/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		1:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"0":"app"}[chunkId]||chunkId) + ".bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2);
	
	__webpack_require__(328);
	
	__webpack_require__(329);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(3);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(57);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(72);
	__webpack_require__(74);
	__webpack_require__(76);
	__webpack_require__(79);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(85);
	__webpack_require__(87);
	__webpack_require__(89);
	__webpack_require__(92);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(97);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(105);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(109);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(113);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(168);
	__webpack_require__(169);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(186);
	__webpack_require__(189);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);
	__webpack_require__(199);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(207);
	__webpack_require__(208);
	__webpack_require__(209);
	__webpack_require__(211);
	__webpack_require__(221);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(260);
	__webpack_require__(262);
	__webpack_require__(263);
	__webpack_require__(264);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(268);
	__webpack_require__(269);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(278);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(295);
	__webpack_require__(296);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(299);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(319);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(325);
	__webpack_require__(326);
	__webpack_require__(327);
	module.exports = __webpack_require__(9);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var DESCRIPTORS = __webpack_require__(6);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var META = __webpack_require__(25).KEY;
	var $fails = __webpack_require__(7);
	var shared = __webpack_require__(21);
	var setToStringTag = __webpack_require__(26);
	var uid = __webpack_require__(19);
	var wks = __webpack_require__(27);
	var wksExt = __webpack_require__(28);
	var wksDefine = __webpack_require__(29);
	var enumKeys = __webpack_require__(30);
	var isArray = __webpack_require__(45);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(16);
	var createDesc = __webpack_require__(17);
	var _create = __webpack_require__(46);
	var gOPNExt = __webpack_require__(49);
	var $GOPD = __webpack_require__(51);
	var $DP = __webpack_require__(11);
	var $keys = __webpack_require__(31);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(50).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(44).f = $propertyIsEnumerable;
	  __webpack_require__(43).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(22)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(10)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(7)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var hide = __webpack_require__(10);
	var redefine = __webpack_require__(18);
	var ctx = __webpack_require__(23);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	module.exports = __webpack_require__(6) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var toPrimitive = __webpack_require__(16);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(6) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(6) && !__webpack_require__(7)(function () {
	  return Object.defineProperty(__webpack_require__(15)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var document = __webpack_require__(4).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(13);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var has = __webpack_require__(5);
	var SRC = __webpack_require__(19)('src');
	var $toString = __webpack_require__(20);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(9).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(21)('native-function-to-string', Function.toString);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(22) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(24);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(19)('meta');
	var isObject = __webpack_require__(13);
	var has = __webpack_require__(5);
	var setDesc = __webpack_require__(11).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(7)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(5);
	var TAG = __webpack_require__(27)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(21)('wks');
	var uid = __webpack_require__(19);
	var Symbol = __webpack_require__(4).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(27);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var LIBRARY = __webpack_require__(22);
	var wksExt = __webpack_require__(28);
	var defineProperty = __webpack_require__(11).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(32);
	var enumBugKeys = __webpack_require__(42);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(5);
	var toIObject = __webpack_require__(33);
	var arrayIndexOf = __webpack_require__(37)(false);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(34);
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(33);
	var toLength = __webpack_require__(38);
	var toAbsoluteIndex = __webpack_require__(40);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(21)('keys');
	var uid = __webpack_require__(19);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(12);
	var dPs = __webpack_require__(47);
	var enumBugKeys = __webpack_require__(42);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(15)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(48).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(12);
	var getKeys = __webpack_require__(31);
	
	module.exports = __webpack_require__(6) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(4).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(33);
	var gOPN = __webpack_require__(50).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(32);
	var hiddenKeys = __webpack_require__(42).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(44);
	var createDesc = __webpack_require__(17);
	var toIObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(16);
	var has = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(14);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(6) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(46) });


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(6), 'Object', { defineProperties: __webpack_require__(47) });


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(33);
	var $getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	__webpack_require__(56)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var fails = __webpack_require__(7);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(58);
	var $getPrototypeOf = __webpack_require__(59);
	
	__webpack_require__(56)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(36);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(5);
	var toObject = __webpack_require__(58);
	var IE_PROTO = __webpack_require__(41)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58);
	var $keys = __webpack_require__(31);
	
	__webpack_require__(56)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(56)('getOwnPropertyNames', function () {
	  return __webpack_require__(49).f;
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(56)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(56)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(13);
	var meta = __webpack_require__(25).onFreeze;
	
	__webpack_require__(56)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(13);
	
	__webpack_require__(56)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(8);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(69) });


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(31);
	var gOPS = __webpack_require__(43);
	var pIE = __webpack_require__(44);
	var toObject = __webpack_require__(58);
	var IObject = __webpack_require__(34);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(7)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { is: __webpack_require__(71) });


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(8);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(73).set });


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(23)(Function.call, __webpack_require__(51).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(75);
	var test = {};
	test[__webpack_require__(27)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(18)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(27)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Function', { bind: __webpack_require__(77) });


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(24);
	var isObject = __webpack_require__(13);
	var invoke = __webpack_require__(78);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(6) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(13);
	var getPrototypeOf = __webpack_require__(59);
	var HAS_INSTANCE = __webpack_require__(27)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(4).parseInt;
	var $trim = __webpack_require__(83).trim;
	var ws = __webpack_require__(84);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var defined = __webpack_require__(36);
	var fails = __webpack_require__(7);
	var spaces = __webpack_require__(84);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(4).parseFloat;
	var $trim = __webpack_require__(83).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(84) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var has = __webpack_require__(5);
	var cof = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(88);
	var toPrimitive = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var gOPN = __webpack_require__(50).f;
	var gOPD = __webpack_require__(51).f;
	var dP = __webpack_require__(11).f;
	var $trim = __webpack_require__(83).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(46)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(6) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(18)(global, NUMBER, $Number);
	}


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var setPrototypeOf = __webpack_require__(73).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toInteger = __webpack_require__(39);
	var aNumberValue = __webpack_require__(90);
	var repeat = __webpack_require__(91);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(7)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(36);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $fails = __webpack_require__(7);
	var aNumberValue = __webpack_require__(90);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(8);
	var _isFinite = __webpack_require__(4).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(96) });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(13);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(8);
	var isInteger = __webpack_require__(96);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseFloat = __webpack_require__(86);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $parseInt = __webpack_require__(82);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(8);
	var log1p = __webpack_require__(104);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(8);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(8);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(8);
	var sign = __webpack_require__(108);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(8);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(8);
	var $expm1 = __webpack_require__(112);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { fround: __webpack_require__(114) });


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(108);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(8);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(8);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(104) });


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { sign: __webpack_require__(108) });


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(8);
	var expm1 = __webpack_require__(112);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(40);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var toLength = __webpack_require__(38);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(83)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(128)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(129)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(36);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(130);
	var $iterCreate = __webpack_require__(131);
	var setToStringTag = __webpack_require__(26);
	var getPrototypeOf = __webpack_require__(59);
	var ITERATOR = __webpack_require__(27)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(46);
	var descriptor = __webpack_require__(17);
	var setToStringTag = __webpack_require__(26);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(10)(IteratorPrototype, __webpack_require__(27)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(38);
	var context = __webpack_require__(134);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135);
	var defined = __webpack_require__(36);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(13);
	var cof = __webpack_require__(35);
	var MATCH = __webpack_require__(27)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(27)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(8);
	var context = __webpack_require__(134);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(91)
	});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(8);
	var toLength = __webpack_require__(38);
	var context = __webpack_require__(134);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(36);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(8);
	var toISOString = __webpack_require__(157);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(7);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(18)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(27)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(10)(proto, TO_PRIMITIVE, __webpack_require__(160));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(45) });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(23);
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var toLength = __webpack_require__(38);
	var createProperty = __webpack_require__(165);
	var getIterFn = __webpack_require__(166);
	
	$export($export.S + $export.F * !__webpack_require__(167)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(12);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(130);
	var ITERATOR = __webpack_require__(27)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(17);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(75);
	var ITERATOR = __webpack_require__(27)('iterator');
	var Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(9).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(27)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var createProperty = __webpack_require__(165);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(34) != Object || !__webpack_require__(170)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var html = __webpack_require__(48);
	var cof = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(7)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var toObject = __webpack_require__(58);
	var fails = __webpack_require__(7);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(170)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $forEach = __webpack_require__(174)(0);
	var STRICT = __webpack_require__(170)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(23);
	var IObject = __webpack_require__(34);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(38);
	var asc = __webpack_require__(175);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(176);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	var isArray = __webpack_require__(45);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $map = __webpack_require__(174)(1);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $filter = __webpack_require__(174)(2);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $some = __webpack_require__(174)(3);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $every = __webpack_require__(174)(4);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(24);
	var toObject = __webpack_require__(58);
	var IObject = __webpack_require__(34);
	var toLength = __webpack_require__(38);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $reduce = __webpack_require__(182);
	
	$export($export.P + $export.F * !__webpack_require__(170)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $indexOf = __webpack_require__(37)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toIObject = __webpack_require__(33);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(170)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(187) });
	
	__webpack_require__(188)('copyWithin');


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(27)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(10)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(8);
	
	$export($export.P, 'Array', { fill: __webpack_require__(190) });
	
	__webpack_require__(188)('fill');


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(58);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(8);
	var $find = __webpack_require__(174)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(188)(KEY);


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(194)('Array');


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var dP = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(6);
	var SPECIES = __webpack_require__(27)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(188);
	var step = __webpack_require__(196);
	var Iterators = __webpack_require__(130);
	var toIObject = __webpack_require__(33);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(129)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 196 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var inheritIfRequired = __webpack_require__(88);
	var dP = __webpack_require__(11).f;
	var gOPN = __webpack_require__(50).f;
	var isRegExp = __webpack_require__(135);
	var $flags = __webpack_require__(198);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(6) && (!CORRECT_NEW || __webpack_require__(7)(function () {
	  re2[__webpack_require__(27)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(18)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(194)('RegExp');


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(12);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(200);
	__webpack_require__(8)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(198);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(202);
	var anObject = __webpack_require__(12);
	var $flags = __webpack_require__(198);
	var DESCRIPTORS = __webpack_require__(6);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(18)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(6) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(198)
	});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(38);
	var advanceStringIndex = __webpack_require__(204);
	var regExpExec = __webpack_require__(205);
	
	// @@match logic
	__webpack_require__(206)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(128)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(75);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(199);
	var redefine = __webpack_require__(18);
	var hide = __webpack_require__(10);
	var fails = __webpack_require__(7);
	var defined = __webpack_require__(36);
	var wks = __webpack_require__(27);
	var regexpExec = __webpack_require__(200);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(38);
	var toInteger = __webpack_require__(39);
	var advanceStringIndex = __webpack_require__(204);
	var regExpExec = __webpack_require__(205);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(206)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(12);
	var sameValue = __webpack_require__(71);
	var regExpExec = __webpack_require__(205);
	
	// @@search logic
	__webpack_require__(206)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(135);
	var anObject = __webpack_require__(12);
	var speciesConstructor = __webpack_require__(210);
	var advanceStringIndex = __webpack_require__(204);
	var toLength = __webpack_require__(38);
	var callRegExpExec = __webpack_require__(205);
	var regexpExec = __webpack_require__(200);
	var fails = __webpack_require__(7);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(206)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(24);
	var SPECIES = __webpack_require__(27)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(22);
	var global = __webpack_require__(4);
	var ctx = __webpack_require__(23);
	var classof = __webpack_require__(75);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var aFunction = __webpack_require__(24);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var speciesConstructor = __webpack_require__(210);
	var task = __webpack_require__(214).set;
	var microtask = __webpack_require__(215)();
	var newPromiseCapabilityModule = __webpack_require__(216);
	var perform = __webpack_require__(217);
	var userAgent = __webpack_require__(218);
	var promiseResolve = __webpack_require__(219);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(27)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(220)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(26)($Promise, PROMISE);
	__webpack_require__(194)(PROMISE);
	Wrapper = __webpack_require__(9)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(167)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 212 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(23);
	var call = __webpack_require__(163);
	var isArrayIter = __webpack_require__(164);
	var anObject = __webpack_require__(12);
	var toLength = __webpack_require__(38);
	var getIterFn = __webpack_require__(166);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(23);
	var invoke = __webpack_require__(78);
	var html = __webpack_require__(48);
	var cel = __webpack_require__(15);
	var global = __webpack_require__(4);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var macrotask = __webpack_require__(214).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(24);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var newPromiseCapability = __webpack_require__(216);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(18);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(222);
	var validate = __webpack_require__(223);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(224)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(11).f;
	var create = __webpack_require__(46);
	var redefineAll = __webpack_require__(220);
	var ctx = __webpack_require__(23);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var $iterDefine = __webpack_require__(129);
	var step = __webpack_require__(196);
	var setSpecies = __webpack_require__(194);
	var DESCRIPTORS = __webpack_require__(6);
	var fastKey = __webpack_require__(25).fastKey;
	var validate = __webpack_require__(223);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(13);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var redefine = __webpack_require__(18);
	var redefineAll = __webpack_require__(220);
	var meta = __webpack_require__(25);
	var forOf = __webpack_require__(213);
	var anInstance = __webpack_require__(212);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var $iterDetect = __webpack_require__(167);
	var setToStringTag = __webpack_require__(26);
	var inheritIfRequired = __webpack_require__(88);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(222);
	var validate = __webpack_require__(223);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(224)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var each = __webpack_require__(174)(0);
	var redefine = __webpack_require__(18);
	var meta = __webpack_require__(25);
	var assign = __webpack_require__(69);
	var weak = __webpack_require__(227);
	var isObject = __webpack_require__(13);
	var validate = __webpack_require__(223);
	var NATIVE_WEAK_MAP = __webpack_require__(223);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(224)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(220);
	var getWeak = __webpack_require__(25).getWeak;
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var anInstance = __webpack_require__(212);
	var forOf = __webpack_require__(213);
	var createArrayMethod = __webpack_require__(174);
	var $has = __webpack_require__(5);
	var validate = __webpack_require__(223);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(227);
	var validate = __webpack_require__(223);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(224)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var $typed = __webpack_require__(230);
	var buffer = __webpack_require__(231);
	var anObject = __webpack_require__(12);
	var toAbsoluteIndex = __webpack_require__(40);
	var toLength = __webpack_require__(38);
	var isObject = __webpack_require__(13);
	var ArrayBuffer = __webpack_require__(4).ArrayBuffer;
	var speciesConstructor = __webpack_require__(210);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(194)(ARRAY_BUFFER);


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var uid = __webpack_require__(19);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(6);
	var LIBRARY = __webpack_require__(22);
	var $typed = __webpack_require__(230);
	var hide = __webpack_require__(10);
	var redefineAll = __webpack_require__(220);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(212);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	var toIndex = __webpack_require__(232);
	var gOPN = __webpack_require__(50).f;
	var dP = __webpack_require__(11).f;
	var arrayFill = __webpack_require__(190);
	var setToStringTag = __webpack_require__(26);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(38);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	$export($export.G + $export.W + $export.F * !__webpack_require__(230).ABV, {
	  DataView: __webpack_require__(231).DataView
	});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(6)) {
	  var LIBRARY = __webpack_require__(22);
	  var global = __webpack_require__(4);
	  var fails = __webpack_require__(7);
	  var $export = __webpack_require__(8);
	  var $typed = __webpack_require__(230);
	  var $buffer = __webpack_require__(231);
	  var ctx = __webpack_require__(23);
	  var anInstance = __webpack_require__(212);
	  var propertyDesc = __webpack_require__(17);
	  var hide = __webpack_require__(10);
	  var redefineAll = __webpack_require__(220);
	  var toInteger = __webpack_require__(39);
	  var toLength = __webpack_require__(38);
	  var toIndex = __webpack_require__(232);
	  var toAbsoluteIndex = __webpack_require__(40);
	  var toPrimitive = __webpack_require__(16);
	  var has = __webpack_require__(5);
	  var classof = __webpack_require__(75);
	  var isObject = __webpack_require__(13);
	  var toObject = __webpack_require__(58);
	  var isArrayIter = __webpack_require__(164);
	  var create = __webpack_require__(46);
	  var getPrototypeOf = __webpack_require__(59);
	  var gOPN = __webpack_require__(50).f;
	  var getIterFn = __webpack_require__(166);
	  var uid = __webpack_require__(19);
	  var wks = __webpack_require__(27);
	  var createArrayMethod = __webpack_require__(174);
	  var createArrayIncludes = __webpack_require__(37);
	  var speciesConstructor = __webpack_require__(210);
	  var ArrayIterators = __webpack_require__(195);
	  var Iterators = __webpack_require__(130);
	  var $iterDetect = __webpack_require__(167);
	  var setSpecies = __webpack_require__(194);
	  var arrayFill = __webpack_require__(190);
	  var arrayCopyWithin = __webpack_require__(187);
	  var $DP = __webpack_require__(11);
	  var $GOPD = __webpack_require__(51);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var rApply = (__webpack_require__(4).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(7)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(8);
	var create = __webpack_require__(46);
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	var fails = __webpack_require__(7);
	var bind = __webpack_require__(77);
	var rConstruct = (__webpack_require__(4).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(11);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var toPrimitive = __webpack_require__(16);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(7)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(8);
	var gOPD = __webpack_require__(51).f;
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var isObject = __webpack_require__(13);
	var anObject = __webpack_require__(12);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(51);
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(8);
	var getProto = __webpack_require__(59);
	var anObject = __webpack_require__(12);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(255) });


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(50);
	var gOPS = __webpack_require__(43);
	var anObject = __webpack_require__(12);
	var Reflect = __webpack_require__(4).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(8);
	var anObject = __webpack_require__(12);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(11);
	var gOPD = __webpack_require__(51);
	var getPrototypeOf = __webpack_require__(59);
	var has = __webpack_require__(5);
	var $export = __webpack_require__(8);
	var createDesc = __webpack_require__(17);
	var anObject = __webpack_require__(12);
	var isObject = __webpack_require__(13);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(8);
	var setProto = __webpack_require__(73);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(8);
	var $includes = __webpack_require__(37)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(188)('includes');


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(261);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(38);
	var aFunction = __webpack_require__(24);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatMap');


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(45);
	var isObject = __webpack_require__(13);
	var toLength = __webpack_require__(38);
	var ctx = __webpack_require__(23);
	var IS_CONCAT_SPREADABLE = __webpack_require__(27)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(8);
	var flattenIntoArray = __webpack_require__(261);
	var toObject = __webpack_require__(58);
	var toLength = __webpack_require__(38);
	var toInteger = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(175);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(188)('flatten');


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(8);
	var $at = __webpack_require__(128)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(265);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(38);
	var repeat = __webpack_require__(91);
	var defined = __webpack_require__(36);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(8);
	var $pad = __webpack_require__(265);
	var userAgent = __webpack_require__(218);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(83)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(8);
	var defined = __webpack_require__(36);
	var toLength = __webpack_require__(38);
	var isRegExp = __webpack_require__(135);
	var getFlags = __webpack_require__(198);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(29)('asyncIterator');


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(29)('observable');


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(8);
	var ownKeys = __webpack_require__(255);
	var toIObject = __webpack_require__(33);
	var gOPD = __webpack_require__(51);
	var createProperty = __webpack_require__(165);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $values = __webpack_require__(274)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(31);
	var toIObject = __webpack_require__(33);
	var isEnum = __webpack_require__(44).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(8);
	var $entries = __webpack_require__(274)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var aFunction = __webpack_require__(24);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(22) || !__webpack_require__(7)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(4)[K];
	});


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var aFunction = __webpack_require__(24);
	var $defineProperty = __webpack_require__(11);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(8);
	var toObject = __webpack_require__(58);
	var toPrimitive = __webpack_require__(16);
	var getPrototypeOf = __webpack_require__(59);
	var getOwnPropertyDescriptor = __webpack_require__(51).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(6) && $export($export.P + __webpack_require__(277), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(282)('Map') });


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(75);
	var from = __webpack_require__(283);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(213);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(8);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(282)('Set') });


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(286)('Map');


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(286)('Set');


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(286)('WeakMap');


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(286)('WeakSet');


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(291)('Map');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(8);
	var aFunction = __webpack_require__(24);
	var ctx = __webpack_require__(23);
	var forOf = __webpack_require__(213);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(291)('Set');


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(291)('WeakMap');


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(291)('WeakSet');


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.G, { global: __webpack_require__(4) });


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(8);
	
	$export($export.S, 'System', { global: __webpack_require__(4) });


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(8);
	var cof = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var scale = __webpack_require__(302);
	var fround = __webpack_require__(114);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { scale: __webpack_require__(302) });


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(8);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(8);
	var core = __webpack_require__(9);
	var global = __webpack_require__(4);
	var speciesConstructor = __webpack_require__(210);
	var promiseResolve = __webpack_require__(219);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(8);
	var newPromiseCapability = __webpack_require__(216);
	var perform = __webpack_require__(217);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(221);
	var $export = __webpack_require__(8);
	var shared = __webpack_require__(21)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(226))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(225);
	var from = __webpack_require__(283);
	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var getPrototypeOf = __webpack_require__(59);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(314);
	var anObject = __webpack_require__(12);
	var aFunction = __webpack_require__(24);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(8);
	var microtask = __webpack_require__(215)();
	var process = __webpack_require__(4).process;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(8);
	var global = __webpack_require__(4);
	var core = __webpack_require__(9);
	var microtask = __webpack_require__(215)();
	var OBSERVABLE = __webpack_require__(27)('observable');
	var aFunction = __webpack_require__(24);
	var anObject = __webpack_require__(12);
	var anInstance = __webpack_require__(212);
	var redefineAll = __webpack_require__(220);
	var hide = __webpack_require__(10);
	var forOf = __webpack_require__(213);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(194)('Observable');


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(4);
	var $export = __webpack_require__(8);
	var userAgent = __webpack_require__(218);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(8);
	var $task = __webpack_require__(214);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(195);
	var getKeys = __webpack_require__(31);
	var redefine = __webpack_require__(18);
	var global = __webpack_require__(4);
	var hide = __webpack_require__(10);
	var Iterators = __webpack_require__(130);
	var wks = __webpack_require__(27);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 328 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(330);
	module.exports = __webpack_require__(9).RegExp.escape;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(8);
	var $re = __webpack_require__(331)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 332 */,
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(334), __esModule: true };

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(335);
	module.exports = __webpack_require__(350).Object.keys;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(336);
	var $keys = __webpack_require__(338);
	
	__webpack_require__(355)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(337);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 337 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(339);
	var enumBugKeys = __webpack_require__(354);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(340);
	var toIObject = __webpack_require__(341);
	var arrayIndexOf = __webpack_require__(344)(false);
	var IE_PROTO = __webpack_require__(348)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 340 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(342);
	var defined = __webpack_require__(337);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(343);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 343 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(341);
	var toLength = __webpack_require__(345);
	var toAbsoluteIndex = __webpack_require__(347);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(346);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 346 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(346);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(349)('keys');
	var uid = __webpack_require__(353);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(350);
	var global = __webpack_require__(351);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(352) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 351 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 354 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(356);
	var core = __webpack_require__(350);
	var fails = __webpack_require__(365);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(351);
	var core = __webpack_require__(350);
	var ctx = __webpack_require__(357);
	var hide = __webpack_require__(359);
	var has = __webpack_require__(340);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(358);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(360);
	var createDesc = __webpack_require__(368);
	module.exports = __webpack_require__(364) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(361);
	var IE8_DOM_DEFINE = __webpack_require__(363);
	var toPrimitive = __webpack_require__(367);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(364) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(362);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(364) && !__webpack_require__(365)(function () {
	  return Object.defineProperty(__webpack_require__(366)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(365)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(362);
	var document = __webpack_require__(351).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(362);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(370);
	module.exports = angular;


/***/ }),
/* 370 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.7.8
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/* exported
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth
	*/
	
	var minErrConfig = {
	  objectMaxDepth: 5,
	  urlErrorParamsEnabled: true
	};
	
	/**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 *
	 * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies wether the generated error url will
	 *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
	 *   generated error url is very long.
	 *
	 *   Default: true. When used without argument, it returns the current value.
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	    if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
	      minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * AngularJS. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	
	  var url = 'https://errors.angularjs.org/1.7.8/';
	  var regex = url.replace('.', '\\.') + '[\\s\\S]*';
	  var errRegExp = new RegExp(regex, 'g');
	
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    // A minErr message has two parts: the message itself and the url that contains the
	    // encoded message.
	    // The message's parameters can contain other error messages which also include error urls.
	    // To prevent the messages from getting too long, we strip the error urls from the parameters.
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index].replace(errRegExp, '');
	      }
	
	      return match;
	    });
	
	    message += '\n' + url + (module ? module + '/' : '') + code;
	
	    if (minErrConfig.urlErrorParamsEnabled) {
	      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	      }
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isError,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  addDateMinutes,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @private
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) && (length >= 0 && (length - 1) in obj || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @deprecated
	* sinceVersion="1.6.5"
	* This function is deprecated, but will not be removed in the 1.x lifecycle.
	* There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
	* supported by this function. We suggest using another, similar library for all-purpose merging,
	* such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
	*
	* @knownIssue
	* This is a list of (known) object types that are not handled correctly by this function:
	* - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
	* - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	* - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
	* - AngularJS {@link $rootScope.Scope scopes};
	*
	* `angular.merge` also does not support merging objects with circular references.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	function isArray(arr) {
	  return Array.isArray(arr) || arr instanceof Array;
	}
	
	/**
	 * @description
	 * Determines if a reference is an `Error`.
	 * Loosely based on https://www.npmjs.com/package/iserror
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Error`.
	 */
	function isError(value) {
	  var tag = toString.call(value);
	  switch (tag) {
	    case '[object Error]': return true;
	    case '[object Exception]': return true;
	    case '[object DOMException]': return true;
	    default: return value instanceof Error;
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array. This functions is used
	 * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
	 * function, and has several limitations (see below).
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 *
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 *   `angular.copy` does not check if destination and source are of the same type. It's the
	 *   developer's responsibility to make sure they are compatible.
	 * </div>
	 *
	 * @knownIssue
	 * This is a non-exhaustive list of object types / features that are not handled correctly by
	 * `angular.copy`. Note that since this functions is used by the change detection code, this
	 * means binding or watching objects of these types (or that include these types) might not work
	 * correctly.
	 * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
	 * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
	 * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
	 * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
	 * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
	 * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
	 * - ['getter'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
	 *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)`
	 *
	 * @param {*} source The source that will be used to make a copy. Can be any type, including
	 *     primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
	 *     must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>leader = {{leader | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.leader = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.leader);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.leader);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since AngularJS uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-15+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone().empty();
	  var elemHtml = jqLite('<div></div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // Support: IE 9-11 only
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * @example
	 *
	 * ### Simple Usage
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * @example
	 *
	 * ### With `ngStrictDi`
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up AngularJS application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * AngularJS will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of AngularJS try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of AngularJS on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of AngularJS application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	  } else {
	    jqLite = JQLite;
	  }
	
	  // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
	  // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
	  // the $destroy event on all removed nodes.
	  originalCleanData = jqLite.cleanData;
	  jqLite.cleanData = function(elems) {
	    var events;
	    for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	      events = (jqLite._data(elem) || {}).events;
	      if (events && events.$destroy) {
	        jqLite(elem).triggerHandler('$destroy');
	      }
	    }
	    originalCleanData(elems);
	  };
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring AngularJS {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving AngularJS
	     * modules.
	     * All modules (AngularJS core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid AngularJS expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	           *    or an object map of components where the keys are the names and the values are the component definition objects.
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to configure services by injecting their
	           * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
	           * {@link ngRoute.$routeProvider $routeProvider}.
	           *
	           * Note that you can only inject {@link angular.Module#provider `providers`} and
	           * {@link angular.Module#constant `constants`} into this function.
	           *
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* exported toDebugString */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    // This file is also included in `angular-loader`, so `copy()` might not always be available in
	    // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
	    obj = angular.copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  hiddenInputBrowserCacheDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRefDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $$IntervalFactoryProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $$TaskTrackerFactoryProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.7.8',
	  major: 1,
	  minor: 7,
	  dot: 8,
	  codeName: 'enthusiastic-oblation'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$lowercase': lowercase,
	    '$$stringify': stringify,
	    '$$uppercase': uppercase
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRef: ngRefDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective,
	          input: hiddenInputBrowserCacheDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $$intervalFactory: $$IntervalFactoryProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.7.8' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## AngularJS's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
	 *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function isEmptyObject(obj) {
	  var name;
	
	  for (name in obj) {
	    return false;
	  }
	  return true;
	}
	
	function removeIfEmptyData(element) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  var events = expandoStore && expandoStore.events;
	  var data = expandoStore && expandoStore.data;
	
	  if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	
	  removeIfEmptyData(element);
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	    } else {
	      expandoStore.data = {};
	    }
	
	    removeIfEmptyData(element);
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	    var newClasses = existingClasses;
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        newClasses += cssClass + ' ';
	      }
	    });
	
	    if (newClasses !== existingClasses) {
	      element.setAttribute('class', trim(newClasses));
	    }
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	      jqLiteOff(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key !== this._lastKey) {
	      this._lastKey = key;
	      this._lastIndex = this._keys.indexOf(key);
	    }
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  has: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    return idx !== -1;
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running AngularJS app
	 * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * ## Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ### Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ### `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ### Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * #### Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * #### The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * #### The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	/**
	 * @ngdoc method
	 * @name $injector#loadNewModules
	 *
	 * @description
	 *
	 * **This is a dangerous API, which you use at your own risk!**
	 *
	 * Add the specified modules to the current injector.
	 *
	 * This method will add each of the injectables to the injector and execute all of the config and run
	 * blocks for each module passed to the method.
	 *
	 * If a module has already been loaded into the injector then it will not be loaded again.
	 *
	 * * The application developer is responsible for loading the code containing the modules; and for
	 * ensuring that lazy scripts are not downloaded and executed more often that desired.
	 * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
	 * * Modules cannot be unloaded.
	 *
	 * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
	 * into the injector, which may indicate whether the script has been executed already.
	 *
	 * @example
	 * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
	 *
	 * ```javascript
	 * app.factory('loadModule', function($injector) {
	 *   return function loadModule(moduleName, bundleUrl) {
	 *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
	 *   };
	 * })
	 * ```
	 *
	 * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * It is possible to inject other providers into the provider function,
	 * but the injected provider must have been defined before the one that requires it.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  instanceInjector.loadNewModules = function(mods) {
	    forEach(loadModules(mods), function(fn) { if (fn) instanceInjector.invoke(fn); });
	  };
	
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	  var customFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#customFilter
	   *
	   * @description
	   * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
	   * determine if an animation is allowed or not. When no filter is specified (the default), no
	   * animation will be blocked. Setting the `customFilter` value will only allow animations for
	   * which the filter function's return value is truthy.
	   *
	   * This allows to easily create arbitrarily complex rules for filtering animations, such as
	   * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
	   * Filtering animations can also boost performance for low-powered devices, as well as
	   * applications containing a lot of structural operations.
	   *
	   * <div class="alert alert-success">
	   *   **Best Practice:**
	   *   Keep the filtering function as lean as possible, because it will be called for each DOM
	   *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
	   *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
	   *   directives that support animations.
	   *   Performing computationally expensive or time-consuming operations on each call of the
	   *   filtering function can make your animations sluggish.
	   * </div>
	   *
	   * **Note:** If present, `customFilter` will be checked before
	   * {@link $animateProvider#classNameFilter classNameFilter}.
	   *
	   * @param {Function=} filterFn - The filter function which will be used to filter all animations.
	   *   If a falsy value is returned, no animation will be performed. The function will be called
	   *   with the following arguments:
	   *   - **node** `{DOMElement}` - The DOM element to be animated.
	   *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
	   *     etc).
	   *   - **options** `{Object}` - A collection of options/styles used for the animation.
	   * @return {Function} The current filter function or `null` if there is none set.
	   */
	  this.customFilter = function(filterFn) {
	    if (arguments.length === 1) {
	      customFilter = isFunction(filterFn) ? filterFn : null;
	    }
	
	    return customFilter;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   *
	   * **Note:** If present, `classNameFilter` will be checked after
	   * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
	   * false, `classNameFilter` will not be checked.
	   *
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * <div class="alert alert-warning">
	       * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
	       * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
	       * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
	       * However, there are two exceptions:
	       *
	       * <ul>
	       *   <li>if both an {@link ng.$animate#addClass addClass()} and a
	       *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
	       *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
	       *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
	       *   the `setClass` event, but if it either removes or adds classes,
	       *   it will fire `animate` instead.</li>
	       * </ul>
	       *
	       * </div>
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered.
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       * * `data` - an object with these properties:
	       *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
	       *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
	       *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
	       *     * to - `{Object|null}` - CSS properties & values at the end of the animation
	       *
	       * Note that the callback does not trigger a scope digest. Wrap your call into a
	       * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation and applies the end state of the animation.
	       * Note that this does not cancel the underlying operation, e.g. the setting of classes or
	       * adding the element to the DOM.
	       *
	       * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
	       *
	       * @example
	        <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
	          <file name="app.js">
	            angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
	              templateUrl: 'template.html',
	              controller: function($element, $animate) {
	                this.runner = null;
	
	                this.addClass = function() {
	                  this.runner = $animate.addClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.removeClass = function() {
	                  this.runner = $animate.removeClass($element.find('div'), 'red');
	                  var ctrl = this;
	                  this.runner.finally(function() {
	                    ctrl.runner = null;
	                  });
	                };
	
	                this.cancel = function() {
	                  $animate.cancel(this.runner);
	                };
	              }
	            });
	          </file>
	          <file name="template.html">
	            <p>
	              <button id="add" ng-click="$ctrl.addClass()">Add</button>
	              <button ng-click="$ctrl.removeClass()">Remove</button>
	              <br>
	              <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
	              <br>
	              <div id="target">CSS-Animated Text</div>
	            </p>
	          </file>
	          <file name="index.html">
	            <cancel-example></cancel-example>
	          </file>
	          <file name="style.css">
	            .red-add, .red-remove {
	              transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
	            }
	
	            .red,
	            .red-add.red-add-active {
	              color: #FF0000;
	              font-size: 40px;
	            }
	
	            .red-remove.red-remove-active {
	              font-size: 10px;
	              color: black;
	            }
	
	          </file>
	        </example>
	       */
	      cancel: function(runner) {
	        if (runner.cancel) {
	          runner.cancel();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} animationRunner the animation runner
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Runner} the animation runner
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global getHash: true, stripHash: false */
	
	function getHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? '' : url.substr(index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/#$/, '');
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {},
	      taskTracker = $$taskTrackerFactory($log);
	
	  self.isMock = false;
	
	  //////////////////////////////////////////////////////////////
	  // Task-tracking API
	  //////////////////////////////////////////////////////////////
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = taskTracker.completeTask;
	  self.$$incOutstandingRequestCount = taskTracker.incTaskCount;
	
	  // TODO(vojta): prefix this method with $$ ?
	  self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of `location.href` (with a
	   * trailing `#` stripped of if the hash is empty).
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
	   * `location.href`/`location.replace` is used.
	   * Returns its own instance to allow chaining.
	   *
	   * NOTE: this api is intended for use only by the `$location` service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state State object to use with `pushState`/`replaceState`
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Normalize the inputted URL
	      url = urlResolve(url).href;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      return trimEmptyHash(pendingLocation || location.href);
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of AngularJS:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of AngularJS.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay, taskType) {
	    var timeoutId;
	
	    delay = delay || 0;
	    taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
	
	    taskTracker.incTaskCount(taskType);
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      taskTracker.completeTask(fn, taskType);
	    }, delay);
	    pendingDeferIds[timeoutId] = taskType;
	
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds.hasOwnProperty(deferId)) {
	      var taskType = pendingDeferIds[deferId];
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      taskTracker.completeTask(noop, taskType);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory',
	       function($window,   $log,   $sniffer,   $document,   $$taskTrackerFactory) {
	    return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
	       * directive to cache templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
	 * {@link ng.$cacheFactory $cacheFactory}.
	 *
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
	 * or by consuming the `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
	 * element with {@link ngApp} attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with life-cycle hooks in the new Angular
	 * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
	 *
	 * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
	 *   `ngDoCheck` in Angular.
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
	 *   isn't  optional and doesn't exist, an exception
	 *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
	 *   to the local value, since it will be impossible to sync them back to the parent scope.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr`
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   It's also possible to watch the evaluated value shallowly with
	 *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
	 * The marker must come after the mode and before the attribute name.
	 * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
	 * This is useful to refine the interface directives provide.
	 * One subtle difference between optional and non-optional happens **when the binding attribute is not
	 * set**:
	 * - the binding is optional: the property will not be defined
	 * - the binding is not optional: the property is defined
	 *
	 * ```js
	 *app.directive('testDir', function() {
	    return {
	      scope: {
	        notoptional: '=',
	        optional: '=?',
	      },
	      bindToController: true,
	      controller: function() {
	        this.$onInit = function() {
	          console.log(this.hasOwnProperty('notoptional')) // true
	          console.log(this.hasOwnProperty('optional')) // false
	        }
	      }
	    }
	  })
	 *```
	 *
	 *
	 * ##### Combining directives with different scope defintions
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace`
	 * <div class="alert alert-danger">
	 * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
	 * </div>
	 *
	 * Specifies what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'AngularJS';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello AngularJS'.
	       expect(output.getText()).toBe('Hello AngularJS');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('AngularJS!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * AngularJS automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	
	 * @knownIssue
	
	   ### Issues with `replace: true`
	 *
	 * <div class="alert alert-danger">
	 *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
	 *   mainly due to the issues listed here. It has been completely removed in the new Angular.
	 * </div>
	 *
	 * #### Attribute values are not merged
	 *
	 * When a `replace` directive encounters the same attribute on the original and the replace node,
	 * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
	 * the `style` attribute.
	 * ```html
	 * Original Node: <span class="original" style="color: red;"></span>
	 * Replace Template: <span class="replaced" style="background: blue;"></span>
	 * Result: <span class="original replaced" style="color: red; background: blue;"></span>
	 * ```
	 *
	 * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
	 * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
	 *
	 * ```html
	 * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
	 * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
	 * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
	 * ```
	 *
	 * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
	 *
	 * #### Directives are not deduplicated before compilation
	 *
	 * When the original node and the replace template declare the same directive(s), they will be
	 * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
	 * does not deduplicate them. In many cases, this is not noticable, but e.g. {@link ngModel} will
	 * attach `$formatters` and `$parsers` twice.
	 *
	 * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
	 *
	 * #### `transclude: element` in the replace template root can have unexpected effects
	 *
	 * When the replace template has a directive at the root node that uses
	 * {@link $compile#-transclude- `transclude: element`}, e.g.
	 * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
	 * See the following issues:
	 *
	 * - Incorrect scope on replaced element:
	 * [#9837](https://github.com/angular/angular.js/issues/9837)
	 * - Different DOM between `template` and `templateUrl`:
	 * [#10612](https://github.com/angular/angular.js/issues/14326)
	 *
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngProp
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-prop-propname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "propName"):
	 *
	 *
	 * ```html
	 * <ANY ng-prop-prop_name="expression">
	 * </ANY>
	 * ```
	 *
	 *
	 * @description
	 * The `ngProp` directive binds an expression to a DOM element property.
	 * `ngProp` allows writing to arbitrary properties by including
	 * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
	 * the `value` property.
	 *
	 * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
	 * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
	 *
	 * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
	 * often use custom properties to hold data, and `ngProp` can be used to provide input to these
	 * custom elements.
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
	 * example, and for binding HTML {@link ngBindHtml} should be used.
	 *
	 * ## Security
	 *
	 * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
	 * can insert potentially dangerous HTML into the application, e.g. script tags that execute
	 * malicious code.
	 * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
	 * This means vulnerable properties require their content to be "trusted", based on the
	 * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
	 * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
	 * this property are trusted as a `RESOURCE_URL`.
	 *
	 * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
	 * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
	 * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
	 *
	 * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
	 *
	 * Based on the context, other options may exist to mark a value as trusted / configure the behavior
	 * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
	 * the {@link $sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist()}
	 * and {@link $sceDelegateProvider#resourceUrlBlacklist resourceUrlBlacklist()}.
	 *
	 * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
	 *
	 * ### HTML Sanitization
	 *
	 * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
	 * content.
	 * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
	 * potentially dangerous HTML, e.g. strip non-whitelisted tags and attributes when binding to
	 * `innerHTML`.
	 *
	 * @example
	 * ### Binding to different contexts
	 *
	 * <example name="ngProp" module="exampleNgProp">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         Binding to a property without security context:
	 *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerText</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... so that actually dangerous content cannot be executed:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Binding to innerHTML with ngSanitize
	 *
	 * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
	 *   <file name="app.js">
	 *     angular.module('exampleNgProp', ['ngSanitize'])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function($sce) {
	 *           this.safeContent = '<strong>Safe content</strong>';
	 *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
	 *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       <div class="prop-unit">
	 *         "Safe" content will be sanitized ...
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (safeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... as will dangerous content:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (unsafeContent)
	 *       </div>
	 *
	 *       <div class="prop-unit">
	 *         ... and content that has been trusted explicitly works the same as without ngSanitize:
	 *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
	 *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 *   <file name="styles.css">
	 *     .prop-unit {
	 *       margin-bottom: 10px;
	 *     }
	 *
	 *     .prop-binding {
	 *       min-height: 30px;
	 *       border: 1px solid blue;
	 *     }
	 *
	 *     .prop-note {
	 *       font-family: Monospace;
	 *     }
	 *   </file>
	 * </example>
	 *
	 */
	
	/** @ngdoc directive
	 * @name ngOn
	 * @restrict A
	 * @element ANY
	 *
	 * @usage
	 *
	 * ```html
	 * <ANY ng-on-eventname="expression">
	 * </ANY>
	 * ```
	 *
	 * or with uppercase letters in property (e.g. "eventName"):
	 *
	 *
	 * ```html
	 * <ANY ng-on-event_name="expression">
	 * </ANY>
	 * ```
	 *
	 * @description
	 * The `ngOn` directive adds an event listener to a DOM element via
	 * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
	 * fired.
	 * `ngOn` allows adding listeners for arbitrary events by including
	 * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
	 * when the `drop` event is fired.
	 *
	 * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
	 * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
	 * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
	 * standards.
	 *
	 * Another use-case for `ngOn` is listening to
	 * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
	 * fired by
	 * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
	 *
	 * ## Binding to camelCase properties
	 *
	 * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
	 * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
	 * `myEvent` must be written as `ng-on-my_event="expression"`.
	 *
	 * @example
	 * ### Bind to built-in DOM events
	 *
	 * <example name="ngOn" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.clickCount = 0;
	 *           this.mouseoverCount = 0;
	 *
	 *           this.loadingState = 0;
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <div>
	 *       This is equivalent to `ngClick` and `ngMouseover`:<br>
	 *       <button
	 *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
	 *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
	 *       clickCount: {{$ctrl.clickCount}}<br>
	 *       mouseover: {{$ctrl.mouseoverCount}}
	 *
	 *       <hr>
	 *
	 *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
	 *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
	 *       <div ng-switch="$ctrl.loadingState">
	 *         <span ng-switch-when="0">Image is loading</span>
	 *         <span ng-switch-when="-1">Image load error</span>
	 *         <span ng-switch-when="1">Image loaded successfully</span>
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 *
	 *
	 * @example
	 * ### Bind to custom DOM events
	 *
	 * <example name="ngOnCustom" module="exampleNgOn">
	 *   <file name="app.js">
	 *     angular.module('exampleNgOn', [])
	 *       .component('main', {
	 *         templateUrl: 'main.html',
	 *         controller: function() {
	 *           this.eventLog = '';
	 *
	 *           this.listener = function($event) {
	 *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
	 *           };
	 *         }
	 *       })
	 *       .component('childComponent', {
	 *         templateUrl: 'child.html',
	 *         controller: function($element) {
	 *           this.fireEvent = function() {
	 *             var event = new CustomEvent('customtype', { detail: new Date()});
	 *
	 *             $element[0].dispatchEvent(event);
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="main.html">
	 *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
	 *     <span>Event log: {{$ctrl.eventLog}}</span>
	 *   </file>
	 *   <file name="child.html">
	      <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
	 *   </file>
	 *   <file name="index.html">
	 *     <main></main>
	 *   </file>
	 * </example>
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      definition = definition.trim();
	
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
	   *    or an object map of components where the keys are the names and the values are the component definition objects.
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    if (!isString(name)) {
	      forEach(name, reverseParams(bind(this, registerComponent)));
	      return this;
	    }
	
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in AngularJS looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `ng-scope` and `ng-isolated-scope` CSS classes
	   * * `$binding` data property containing an array of the binding expressions
	   * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
	   *   the element's scope.
	   * * Placeholder comments will contain information about what directive and binding caused the placeholder.
	   *   E.g. `<!-- ngIf: shouldShow() -->`.
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#strictComponentBindingsEnabled
	   *
	   * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
	   * otherwise return the current strictComponentBindingsEnabled state.
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable / disable the strict component bindings check. If enabled, the
	   * compiler will enforce that all scope / controller bindings of a
	   * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
	   * that are not set as optional with `?`, must be provided when the directive is instantiated.
	   * If not provided, the compiler will throw the
	   * {@link error/$compile/missingattr $compile:missingattr error}.
	   *
	   * The default value is false.
	   */
	  var strictComponentBindingsEnabled = false;
	  this.strictComponentBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      strictComponentBindingsEnabled = enabled;
	      return this;
	    }
	    return strictComponentBindingsEnabled;
	  };
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	
	  /**
	   * The security context of DOM Properties.
	   * @private
	   */
	  var PROP_CONTEXTS = createMap();
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#addPropertySecurityContext
	   * @description
	   *
	   * Defines the security context for DOM properties bound by ng-prop-*.
	   *
	   * @param {string} elementName The element name or '*' to match any element.
	   * @param {string} propertyName The DOM property name.
	   * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
	   * @returns {object} `this` for chaining
	   */
	  this.addPropertySecurityContext = function(elementName, propertyName, ctx) {
	    var key = (elementName.toLowerCase() + '|' + propertyName.toLowerCase());
	
	    if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
	      throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
	    }
	
	    PROP_CONTEXTS[key] = ctx;
	    return this;
	  };
	
	  /* Default property contexts.
	   *
	   * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
	   * Changing:
	   * - SecurityContext.* => SCE_CONTEXTS/$sce.*
	   * - STYLE => CSS
	   * - various URL => MEDIA_URL
	   * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
	   */
	  (function registerNativePropertyContexts() {
	    function registerContext(ctx, values) {
	      forEach(values, function(v) { PROP_CONTEXTS[v.toLowerCase()] = ctx; });
	    }
	
	    registerContext(SCE_CONTEXTS.HTML, [
	      'iframe|srcdoc',
	      '*|innerHTML',
	      '*|outerHTML'
	    ]);
	    registerContext(SCE_CONTEXTS.CSS, ['*|style']);
	    registerContext(SCE_CONTEXTS.URL, [
	      'area|href',       'area|ping',
	      'a|href',          'a|ping',
	      'blockquote|cite',
	      'body|background',
	      'del|cite',
	      'input|src',
	      'ins|cite',
	      'q|cite'
	    ]);
	    registerContext(SCE_CONTEXTS.MEDIA_URL, [
	      'audio|src',
	      'img|src',    'img|srcset',
	      'source|src', 'source|srcset',
	      'track|src',
	      'video|src',  'video|poster'
	    ]);
	    registerContext(SCE_CONTEXTS.RESOURCE_URL, [
	      '*|formAction',
	      'applet|code',      'applet|codebase',
	      'base|href',
	      'embed|src',
	      'frame|src',
	      'form|action',
	      'head|profile',
	      'html|manifest',
	      'iframe|src',
	      'link|href',
	      'media|src',
	      'object|codebase',  'object|data',
	      'script|src'
	    ]);
	  })();
	
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function sanitizeSrcset(value, invokeType) {
	      if (!value) {
	        return value;
	      }
	      if (!isString(value)) {
	        throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
	      }
	
	      // Such values are a bit too complex to handle automatically inside $sce.
	      // Instead, we sanitize each of the URIs individually, which works, even dynamically.
	
	      // It's not possible to work around this using `$sce.trustAsMediaUrl`.
	      // If you want to programmatically set explicitly trusted unsafe URLs, you should use
	      // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
	      // `ng-bind-html` directive.
	
	      var result = '';
	
	      // first check if there are spaces because it's not the same pattern
	      var trimmedSrcset = trim(value);
	      //                (   999x   ,|   999w   ,|   ,|,   )
	      var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	      var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	      // split srcset into tuple of uri and descriptor except for the last item
	      var rawUris = trimmedSrcset.split(pattern);
	
	      // for each tuples
	      var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	      for (var i = 0; i < nbrUrisWith2parts; i++) {
	        var innerIdx = i * 2;
	        // sanitize the uri
	        result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
	        // add the descriptor
	        result += ' ' + trim(rawUris[innerIdx + 1]);
	      }
	
	      // split the last item into uri and descriptor
	      var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	      // sanitize the last uri
	      result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));
	
	      // and add the last descriptor if any
	      if (lastTuple.length === 2) {
	        result += (' ' + trim(lastTuple[1]));
	      }
	      return result;
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        // is set through this function since it may cause $updateClass to
	        // become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        // Sanitize img[srcset] values.
	        if (nodeName === 'img' && key === 'srcset') {
	          this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              // jQuery skips special boolean attrs treatment in XML nodes for
	              // historical reasons and hence AngularJS cannot freely call
	              // `.attr(attrName, false) with such attributes. To avoid issues
	              // in XHTML, call `removeAttr` in such cases instead.
	              // See https://github.com/jquery/jquery/issues/4249
	              if (booleanKey && value === false) {
	                this.$$element.removeAttr(attrName);
	              } else {
	                this.$$element.attr(attrName, value);
	              }
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            var isNgAttr = false, isNgProp = false, isNgEvent = false;
	            var multiElementMatch;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            nName = directiveNormalize(name.toLowerCase());
	
	            // Support ng-attr-*, ng-prop-* and ng-on-*
	            if ((ngPrefixMatch = nName.match(NG_PREFIX_BINDING))) {
	              isNgAttr = ngPrefixMatch[1] === 'Attr';
	              isNgProp = ngPrefixMatch[1] === 'Prop';
	              isNgEvent = ngPrefixMatch[1] === 'On';
	
	              // Normalize the non-prefixed name
	              name = name.replace(PREFIX_REGEXP, '')
	                .toLowerCase()
	                .substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	
	            // Support *-start / *-end multi element directives
	            } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            if (isNgProp || isNgEvent) {
	              attrs[nName] = value;
	              attrsMap[nName] = attr.name;
	
	              if (isNgProp) {
	                addPropertyDirective(node, directives, nName, name);
	              } else {
	                addEventDirective(directives, nName, name);
	              }
	            } else {
	              // Update nName for cases where a prefix was removed
	              // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
	              nName = directiveNormalize(name.toLowerCase());
	              attrsMap[nName] = name;
	
	              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	              }
	
	              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                            attrEndName);
	            }
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = window.document.createDocumentFragment();
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
	                  slots[slotName].appendChild(node);
	                } else {
	                  $template.appendChild(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  var slotCompileNodes = jqLite(slots[slotName].childNodes);
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
	                }
	              }
	
	              $template = jqLite($template.childNodes);
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          controller.instance = controller();
	          $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	          controller.bindingInfo =
	            initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	
	          if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
	            // inheritedData() uses the documentElement when it finds the document, so we would
	            // require from the element itself.
	            value = null;
	          } else {
	            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	          }
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (isError(error)) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedAttrContext(nodeName, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      // All nodes with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media nodes, which require the MEDIA_URL context.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	        return $sce.MEDIA_URL;
	      } else if (attrNormalizedName === 'xlinkHref') {
	        // Some xlink:href are okay, most aren't
	        if (nodeName === 'image') return $sce.MEDIA_URL;
	        if (nodeName === 'a') return $sce.URL;
	        return $sce.RESOURCE_URL;
	      } else if (
	          // Formaction
	          (nodeName === 'form' && attrNormalizedName === 'action') ||
	          // If relative URLs can go where they are not expected to, then
	          // all sorts of trust issues can arise.
	          (nodeName === 'base' && attrNormalizedName === 'href') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (nodeName === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      } else if (nodeName === 'a' && (attrNormalizedName === 'href' ||
	                                 attrNormalizedName === 'ngHref')) {
	        return $sce.URL;
	      }
	    }
	
	    function getTrustedPropContext(nodeName, propNormalizedName) {
	      var prop = propNormalizedName.toLowerCase();
	      return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
	    }
	
	    function sanitizeSrcsetPropertyValue(value) {
	      return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
	    }
	    function addPropertyDirective(node, directives, attrName, propName) {
	      if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
	        throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
	      }
	
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedPropContext(nodeName, propName);
	
	      var sanitizer = identity;
	      // Sanitize img[srcset] + source[srcset] values.
	      if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
	        sanitizer = sanitizeSrcsetPropertyValue;
	      } else if (trustedContext) {
	        sanitizer = $sce.getTrusted.bind($sce, trustedContext);
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function ngPropCompileFn(_, attr) {
	          var ngPropGetter = $parse(attr[attrName]);
	          var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
	            // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	            return $sce.valueOf(val);
	          });
	
	          return {
	            pre: function ngPropPreLinkFn(scope, $element) {
	              function applyPropValue() {
	                var propValue = ngPropGetter(scope);
	                $element[0][propName] = sanitizer(propValue);
	              }
	
	              applyPropValue();
	              scope.$watch(ngPropWatch, applyPropValue);
	            }
	          };
	        }
	      });
	    }
	
	    function addEventDirective(directives, attrName, eventName) {
	      directives.push(
	        createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false)
	      );
	    }
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var nodeName = nodeName_(node);
	      var trustedContext = getTrustedAttrContext(nodeName, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	    function strictBindingsCheck(attrName, directiveName) {
	      if (strictComponentBindingsEnabled) {
	        throw $compileMinErr('missingattr',
	          'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!',
	          attrName, directiveName);
	      }
	    }
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	              destination[scopeName] = attrs[attrName] = undefined;
	
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              strictBindingsCheck(attrName, directive.name);
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var isLiteral = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (isLiteral && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            });
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              strictBindingsCheck(attrName, directive.name);
	            }
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, function(_, letter, offset) {
	      return offset ? letter.toUpperCase() : letter;
	    });
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in AngularJS:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by AngularJS to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {};
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in AngularJS expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value) || isFunction(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          if (isFunction(toSerialize)) {
	            toSerialize = toSerialize();
	          }
	          parts.push(encodeUriQuery(prefix) + '=' +
	              (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      var hasJsonContentType = contentType && (contentType.indexOf(APPLICATION_JSON) === 0);
	
	      if (hasJsonContentType || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          if (!hasJsonContentType) {
	            return data;
	          }
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.transformRequest`** -
	   * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
	   * An array of functions (or a single function) which are applied to the request data.
	   * By default, this is an array with one request transformation function:
	   *
	   *   - If the `data` property of the request configuration object contains an object, serialize it
	   *     into JSON format.
	   *
	   * - **`defaults.transformResponse`** -
	   * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
	   * An array of functions (or a single function) which are applied to the response data. By default,
	   * this is an array which applies one response transformation function that does two things:
	   *
	   *  - If XSRF prefix is detected, strip it
	   *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
	   *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *    deserialize it using a JSON parser.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   */
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   */
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   */
	  var interceptorFactories = this.interceptors = [];
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#xsrfWhitelistedOrigins
	   * @description
	   *
	   * Array containing URLs whose origins are trusted to receive the XSRF token. See the
	   * {@link ng.$http#security-considerations Security Considerations} sections for more details on
	   * XSRF.
	   *
	   * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
	   * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
	   * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
	   * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
	   * Examples: `http://example.com`, `https://api.example.com:9876`
	   *
	   * <div class="alert alert-warning">
	   *   It is not possible to whitelist specific URLs/paths. The `path`, `query` and `fragment` parts
	   *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
	   *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
	   *   `https://foo.com/` will include the XSRF token.
	   * </div>
	   *
	   * @example
	   *
	   * ```js
	   * // App served from `https://example.com/`.
	   * angular.
	   *   module('xsrfWhitelistedOriginsExample', []).
	   *   config(['$httpProvider', function($httpProvider) {
	   *     $httpProvider.xsrfWhitelistedOrigins.push('https://api.example.com');
	   *   }]).
	   *   run(['$http', function($http) {
	   *     // The XSRF token will be sent.
	   *     $http.get('https://api.example.com/preferences').then(...);
	   *
	   *     // The XSRF token will NOT be sent.
	   *     $http.get('https://stats.example.com/activity').then(...);
	   *   }]);
	   * ```
	   */
	  var xsrfWhitelistedOrigins = this.xsrfWhitelistedOrigins = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * A function to check request URLs against a list of allowed origins.
	     */
	    var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfWhitelistedOrigins);
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core AngularJS service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
	     * resolved (request success) or rejected (request failure) with a
	     * {@link ng.$http#$http-returns response} object.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * AngularJS provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
	     * an array with one function that does the following:
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
	     * an array with one function that does the following:
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
	   *      deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * AngularJS will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * AngularJS will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
	     * the cookie, your server can be assured that the XHR came from JavaScript running on your
	     * domain.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
	     * sure that only JavaScript running on your domain could have sent the request. The token must
	     * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
	     * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
	     * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
	     * want to, you can whitelist additional origins to also receive the XSRF token, by adding them
	     * to {@link ng.$httpProvider#xsrfWhitelistedOrigins xsrfWhitelistedOrigins}. This might be
	     * useful, for example, if your application, served from `example.com`, needs to access your API
	     * at `api.example.com`.
	     * See {@link ng.$httpProvider#xsrfWhitelistedOrigins $httpProvider.xsrfWhitelistedOrigins} for
	     * more details.
	     *
	     * <div class="alert alert-danger">
	     *   **Warning**<br />
	     *   Only whitelist origins that you have control over and make sure you understand the
	     *   implications of doing so.
	     * </div>
	     *
	     * The name of the cookie and the header can be specified using the `xsrfCookieName` and
	     * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
	     * `$http.defaults` at run-time, or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple AngularJS apps share the
	     * same domain or subdomain, we recommend that each application uses a unique cookie name.
	     *
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *
	     *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
	     *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
	     *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
	     *
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
	     *   or rejected (request failure) with a response object.
	     *
	     *   The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with
	     *     the transform functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used
	     *     to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
	     *     (`complete`, `error`, `timeout` or `abort`).
	     *
	     *
	     *   A response status code between 200 and 299 is considered a success status
	     *   and will result in the success callback being called. Any response status
	     *   code outside of that range is considered an error status and will result
	     *   in the error callback being called.
	     *   Also, status codes less than -1 are normalized to zero. -1 usually means
	     *   the request was aborted, e.g. using a `config.timeout`. More information
	     *   about the status might be available in the `xhrStatus` property.
	     *
	     *   Note that if the response is a redirect, XMLHttpRequest will transparently
	     *   follow it, meaning that the outcome (success or error) will be determined
	     *   by the final response status code.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount('$http');
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop, '$http');
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * You should avoid generating the URL for the JSONP request from user provided data.
	     * Provide additional query parameters via `params` property of the `config` parameter, rather than
	     * modifying the URL itself.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	     * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	     * See {@link ng.$http#$http-returns `$http()` return value}.
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
	      * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
	      * See {@link ng.$http#$http-returns `$http()` return value}.
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsAllowedOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText, xhrStatus) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText, xhrStatus);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText, xhrStatus) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText,
	          xhrStatus: xhrStatus
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, cbKey) {
	      var parts = url.split('?');
	      if (parts.length > 2) {
	        // Throw if the url contains more than one `?` query indicator
	        throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
	      }
	      var params = parseKeyValue(parts[1]);
	      forEach(params, function(value, key) {
	        if (value === 'JSON_CALLBACK') {
	          // Throw if the url already contains a reference to JSON_CALLBACK
	          throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	        }
	        if (key === cbKey) {
	          // Throw if the callback param was already provided
	          throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
	        }
	      });
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + cbKey + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text, 'complete');
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	      var abortedByTimeout = false;
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText,
	            'complete');
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'error');
	      };
	
	      var requestAborted = function() {
	        completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
	      };
	
	      var requestTimeout = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '', 'timeout');
	      };
	
	      xhr.onerror = requestError;
	      xhr.ontimeout = requestTimeout;
	      xhr.onabort = requestAborted;
	
	      forEach(eventHandlers, function(value, key) {
	        xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    // Since we are using xhr.abort() when a request times out, we have to set a flag that
	    // indicates to requestAborted if the request timed out or was aborted.
	    //
	    // http.timeout = numerical timeout   timeout
	    // http.timeout = $timeout            timeout
	    // http.timeout = promise             abort
	    // xhr.abort()                        abort (The xhr object is normally inaccessible, but
	    //                                    can be exposed with the xhrFactory)
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(function() {
	        timeoutRequest('timeout');
	      }, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(function() {
	        timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
	      });
	    }
	
	    function timeoutRequest(reason) {
	      abortedByTimeout = reason === 'timeout';
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText, xhrStatus);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    }
	    return startSymbol;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    }
	    return endSymbol;
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'AngularJS';
	     *   expect(exp(context)).toEqual('Hello AngularJS!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;
	
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        if (mustHaveExpression) return;
	
	        var unescapedText = unescapeText(text);
	        if (contextAllowsConcatenation) {
	          unescapedText = $sce.getTrusted(trustedContext, unescapedText);
	        }
	        var constantInterp = valueFn(unescapedText);
	        constantInterp.exp = text;
	        constantInterp.expressions = [];
	        constantInterp.$$watchDelegate = constantWatchDelegate;
	
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns,
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [],
	          singleExpression;
	
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push(''); // Placeholder that will get replaced with the evaluated expression.
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      singleExpression = concat.length === 1 && expressionPositions.length === 1;
	      // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
	      // objects rather than simple strings
	      // (we don't modify the expression if the input consists of only a single trusted input)
	      var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
	      parseFns = expressions.map(function(exp) { return $parse(exp, interceptor); });
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
	      // we ensure that the value that's used is assigned or constructed by some JS code somewhere
	      // that is more testable or make it obvious that you bound the value to some user controlled
	      // value.  This helps reduce the load when auditing for XSS issues.
	
	      // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
	      // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
	      // or on the overall concatenated string (losing trusted types used in the mix, by design).
	      // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
	      // only used in srcdoc attributes, this would not be very useful.
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	
	          if (contextAllowsConcatenation) {
	            // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
	            return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
	          } else if (trustedContext && concat.length > 1) {
	            // This context does not allow more than one part, e.g. expr + string or exp + exp.
	            $interpolateMinErr.throwNoconcat(text);
	          }
	          // In an unprivileged context or only one part: just concatenate and return.
	          return concat.join('');
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
	          // parts of a full URL. We don't care about losing the trustedness here.
	          // In non-concatenable contexts, where there is only one expression, this interceptor is
	          // not applied to the expression.
	          value = (trustedContext && !contextAllowsConcatenation) ?
	                    $sce.getTrusted(trustedContext, value) :
	                    $sce.valueOf(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	var $intervalMinErr = minErr('$interval');
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$$intervalFactory', '$window',
	       function($$intervalFactory,   $window) {
	    var intervals = {};
	    var setIntervalFn = function(tick, delay, deferred) {
	      var id = $window.setInterval(tick, delay);
	      intervals[id] = deferred;
	      return id;
	    };
	    var clearIntervalFn = function(id) {
	      $window.clearInterval(id);
	      delete intervals[id];
	    };
	
	    /**
	     * @ngdoc service
	     * @name $interval
	     *
	     * @description
	     * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	     * milliseconds.
	     *
	     * The return value of registering an interval function is a promise. This promise will be
	     * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	     * run indefinitely if `count` is not defined. The value of the notification will be the
	     * number of iterations that have run.
	     * To cancel an interval, call `$interval.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	     * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	     * time.
	     *
	     * <div class="alert alert-warning">
	     * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	     * with them.  In particular they are not automatically destroyed when a controller's scope or a
	     * directive's element are destroyed.
	     * You should take this into consideration and make sure to always cancel the interval at the
	     * appropriate moment.  See the example below for more details on how and when to do this.
	     * </div>
	     *
	     * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	     *   are passed (see below), the function is called with the current iteration count.
	     * @param {number} delay Number of milliseconds between each function call.
	     * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	     *   indefinitely.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	     *
	     * @example
	     * <example module="intervalExample" name="interval-service">
	     * <file name="index.html">
	     *   <script>
	     *     angular.module('intervalExample', [])
	     *       .controller('ExampleController', ['$scope', '$interval',
	     *         function($scope, $interval) {
	     *           $scope.format = 'M/d/yy h:mm:ss a';
	     *           $scope.blood_1 = 100;
	     *           $scope.blood_2 = 120;
	     *
	     *           var stop;
	     *           $scope.fight = function() {
	     *             // Don't start a new fight if we are already fighting
	     *             if ( angular.isDefined(stop) ) return;
	     *
	     *             stop = $interval(function() {
	     *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	     *                 $scope.blood_1 = $scope.blood_1 - 3;
	     *                 $scope.blood_2 = $scope.blood_2 - 4;
	     *               } else {
	     *                 $scope.stopFight();
	     *               }
	     *             }, 100);
	     *           };
	     *
	     *           $scope.stopFight = function() {
	     *             if (angular.isDefined(stop)) {
	     *               $interval.cancel(stop);
	     *               stop = undefined;
	     *             }
	     *           };
	     *
	     *           $scope.resetFight = function() {
	     *             $scope.blood_1 = 100;
	     *             $scope.blood_2 = 120;
	     *           };
	     *
	     *           $scope.$on('$destroy', function() {
	     *             // Make sure that the interval is destroyed too
	     *             $scope.stopFight();
	     *           });
	     *         }])
	     *       // Register the 'myCurrentTime' directive factory method.
	     *       // We inject $interval and dateFilter service since the factory method is DI.
	     *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	     *         function($interval, dateFilter) {
	     *           // return the directive link function. (compile function not needed)
	     *           return function(scope, element, attrs) {
	     *             var format,  // date format
	     *                 stopTime; // so that we can cancel the time updates
	     *
	     *             // used to update the UI
	     *             function updateTime() {
	     *               element.text(dateFilter(new Date(), format));
	     *             }
	     *
	     *             // watch the expression, and update the UI on change.
	     *             scope.$watch(attrs.myCurrentTime, function(value) {
	     *               format = value;
	     *               updateTime();
	     *             });
	     *
	     *             stopTime = $interval(updateTime, 1000);
	     *
	     *             // listen on DOM destroy (removal) event, and cancel the next UI update
	     *             // to prevent updating time after the DOM element was removed.
	     *             element.on('$destroy', function() {
	     *               $interval.cancel(stopTime);
	     *             });
	     *           }
	     *         }]);
	     *   </script>
	     *
	     *   <div>
	     *     <div ng-controller="ExampleController">
	     *       <label>Date format: <input ng-model="format"></label> <hr/>
	     *       Current time is: <span my-current-time="format"></span>
	     *       <hr/>
	     *       Blood 1 : <font color='red'>{{blood_1}}</font>
	     *       Blood 2 : <font color='red'>{{blood_2}}</font>
	     *       <button type="button" data-ng-click="fight()">Fight</button>
	     *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	     *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	     *     </div>
	     *   </div>
	     *
	     * </file>
	     * </example>
	     */
	    var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);
	
	    /**
	     * @ngdoc method
	     * @name $interval#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`.
	     *
	     * @param {Promise=} promise returned by the `$interval` function.
	     * @returns {boolean} Returns `true` if the task was successfully canceled.
	     */
	    interval.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$intervalId')) {
	        throw $intervalMinErr('badprom',
	            '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
	      }
	
	      if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
	
	      var id = promise.$$intervalId;
	      var deferred = intervals[id];
	
	      // Interval cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      clearIntervalFn(id);
	
	      return true;
	    };
	
	    return interval;
	  }];
	}
	
	/** @this */
	function $$IntervalFactoryProvider() {
	  this.$get = ['$browser', '$q', '$$q', '$rootScope',
	       function($browser,   $q,   $$q,   $rootScope) {
	    return function intervalFactory(setIntervalFn, clearIntervalFn) {
	      return function intervalFn(fn, delay, count, invokeApply) {
	        var hasParams = arguments.length > 4,
	            args = hasParams ? sliceArgs(arguments, 4) : [],
	            iteration = 0,
	            skipApply = isDefined(invokeApply) && !invokeApply,
	            deferred = (skipApply ? $$q : $q).defer(),
	            promise = deferred.promise;
	
	        count = isDefined(count) ? count : 0;
	
	        function callback() {
	          if (!hasParams) {
	            fn(iteration);
	          } else {
	            fn.apply(null, args);
	          }
	        }
	
	        function tick() {
	          if (skipApply) {
	            $browser.defer(callback);
	          } else {
	            $rootScope.$evalAsync(callback);
	          }
	          deferred.notify(iteration++);
	
	          if (count > 0 && iteration >= count) {
	            deferred.resolve(iteration);
	            clearIntervalFn(promise.$$intervalId);
	          }
	
	          if (!skipApply) $rootScope.$apply();
	        }
	
	        promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
	
	        return promise;
	      };
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various AngularJS components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	/* global stripHash: true */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    // decode forward slashes to prevent them from being double encoded
	    segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
	  }
	
	  return segments.join('/');
	}
	
	function decodePath(path, html5Mode) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = decodeURIComponent(segments[i]);
	    if (html5Mode) {
	      // encode forward slashes to prevent them from being mistaken for path separators
	      segments[i] = segments[i].replace(/\//g, '%2F');
	    }
	  }
	
	  return segments.join('/');
	}
	
	function normalizePath(pathValue, searchValue, hashValue) {
	  var search = toKeyValue(searchValue),
	    hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
	    path = encodePath(pathValue);
	
	  return path + (search ? '?' + search : '') + hash;
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj, html5Mode) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
	  locationObj.$$path = decodePath(path, html5Mode);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this, true);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBaseNoFile + url.substr(1); // first char is always '/'
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this, false);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of AngularJS, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  this.$$normalizeUrl = function(url) {
	    return appBase + (url ? hashPrefix + url : '');
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$normalizeUrl = function(url) {
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    return appBase + hashPrefix + url;
	  };
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * Compose url and update `url` and `absUrl` property
	   * @private
	   */
	  $$compose: function() {
	    this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
	    this.$$absUrl = this.$$normalizeUrl(this.$$url);
	    this.$$urlUpdatedByLocation = true;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    // Determine if two URLs are equal despite potentially having different encoding/normalizing
	    //  such as $location.absUrl() vs $browser.url()
	    // See https://github.com/angular/angular.js/issues/16592
	    function urlsEqual(a, b) {
	      return a === b || urlResolve(a).href === urlResolve(b).href;
	    }
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the AngularJS application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if ($location.absUrl() !== initialUrl) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = $browser.url();
	        var newUrl = $location.absUrl();
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * To reveal the location of the calls to `$log` in the JavaScript console,
	 * you can "blackbox" the AngularJS source in your browser:
	 *
	 * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
	 * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
	 *
	 * Note: Not all browsers support blackboxing.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (isError(arg)) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop;
	
	      return function() {
	        var args = [];
	        forEach(arguments, function(arg) {
	          args.push(formatError(arg));
	        });
	        // Support: IE 9 only
	        // console methods don't inherit from Function.prototype in IE 9 so we can't
	        // call `logFn.apply(console, args)` directly.
	        return Function.prototype.apply.call(logFn, console, args);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing AngularJS Expressions
	// ------------------------------
	// AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following AngularJS expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	var PURITY_ABSOLUTE = 1;
	var PURITY_RELATIVE = 2;
	
	// Detect nodes which could depend on non-shallow state of objects
	function isPure(node, parentIsPure) {
	  switch (node.type) {
	    // Computed members might invoke a stateful toString()
	    case AST.MemberExpression:
	      if (node.computed) {
	        return false;
	      }
	      break;
	
	    // Unary always convert to primative
	    case AST.UnaryExpression:
	      return PURITY_ABSOLUTE;
	
	    // The binary + operator can invoke a stateful toString().
	    case AST.BinaryExpression:
	      return node.operator !== '+' ? PURITY_ABSOLUTE : false;
	
	    // Functions / filters probably read state from within objects
	    case AST.CallExpression:
	      return false;
	  }
	
	  return (undefined === parentIsPure) ? PURITY_RELATIVE : parentIsPure;
	}
	
	function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	
	  var astIsPure = ast.isPure = isPure(ast, parentIsPure);
	
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
	    findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter, astIsPure);
	      allConstants = allConstants && expr.constant;
	      argsToWatch.push.apply(argsToWatch, expr.toWatch);
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter, astIsPure);
	      allConstants = allConstants && property.value.constant;
	      argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      if (property.computed) {
	        //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
	        findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
	        allConstants = allConstants && property.key.constant;
	        argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push({name: fnKey, isPure: watch.isPure});
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var inputs = this.state.inputs;
	    var self = this;
	    forEach(inputs, function(input) {
	      result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
	      if (input.isPure) {
	        result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
	      }
	    });
	    if (inputs.length) {
	      result.push('fn.inputs=[' + inputs.map(function(i) { return i.name; }).join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        input.isPure = watch.isPure;
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.getAst(text);
	    var fn = this.astCompiler.compile(ast.ast);
	    fn.literal = isLiteral(ast.ast);
	    fn.constant = isConstant(ast.ast);
	    fn.oneTime = ast.oneTime;
	    return fn;
	  },
	
	  getAst: function(exp) {
	    var oneTime = false;
	    exp = exp.trim();
	
	    if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	      oneTime = true;
	      exp = exp.substring(2);
	    }
	    return {
	      ast: this.ast.ast(exp),
	      oneTime: oneTime
	    };
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts AngularJS {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'AngularJS'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('AngularJS');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in AngularJS expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    $parse.$$getAst = $$getAst;
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	
	            cache[cacheKey] = addWatchDelegate(parsedExpression);
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function $$getAst(exp) {
	      var lexer = new Lexer($parseOptions);
	      var parser = new Parser(lexer, $filter, $parseOptions);
	      return parser.getAst(exp).ast;
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	
	      var exp = parsedExpression.$$intercepted || parsedExpression;
	      var post = parsedExpression.$$interceptor || identity;
	
	      var useInputs = parsedExpression.inputs && !exp.inputs;
	
	      // Propogate the literal/inputs/constant attributes
	      // ... but not oneTime since we are handling it
	      oneTimeWatch.literal = parsedExpression.literal;
	      oneTimeWatch.constant = parsedExpression.constant;
	      oneTimeWatch.inputs = parsedExpression.inputs;
	
	      // Allow other delegates to run on this wrapped expression
	      addWatchDelegate(oneTimeWatch);
	
	      unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
	
	      return unwatch;
	
	      function unwatchIfDone() {
	        if (isDone(lastValue)) {
	          unwatch();
	        }
	      }
	
	      function oneTimeWatch(scope, locals, assign, inputs) {
	        lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
	        if (isDone(lastValue)) {
	          scope.$$postDigest(unwatchIfDone);
	        }
	        return post(lastValue);
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addWatchDelegate(parsedExpression) {
	      if (parsedExpression.constant) {
	        parsedExpression.$$watchDelegate = constantWatchDelegate;
	      } else if (parsedExpression.oneTime) {
	        parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	      } else if (parsedExpression.inputs) {
	        parsedExpression.$$watchDelegate = inputsWatchDelegate;
	      }
	
	      return parsedExpression;
	    }
	
	    function chainInterceptors(first, second) {
	      function chainedInterceptor(value) {
	        return second(first(value));
	      }
	      chainedInterceptor.$stateful = first.$stateful || second.$stateful;
	      chainedInterceptor.$$pure = first.$$pure && second.$$pure;
	
	      return chainedInterceptor;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	
	      // Extract any existing interceptors out of the parsedExpression
	      // to ensure the original parsedExpression is always the $$intercepted
	      if (parsedExpression.$$interceptor) {
	        interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
	        parsedExpression = parsedExpression.$$intercepted;
	      }
	
	      var useInputs = false;
	
	      var fn = function interceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value);
	      };
	
	      // Maintain references to the interceptor/intercepted
	      fn.$$intercepted = parsedExpression;
	      fn.$$interceptor = interceptorFn;
	
	      // Propogate the literal/oneTime/constant attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	      fn.constant = parsedExpression.constant;
	
	      // Treat the interceptor like filters.
	      // If it is not $stateful then only watch its inputs.
	      // If the expression itself has no inputs then use the full expression as an input.
	      if (!interceptorFn.$stateful) {
	        useInputs = !parsedExpression.inputs;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	
	        if (!interceptorFn.$$pure) {
	          fn.inputs = fn.inputs.map(function(e) {
	              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
	              // non-pure interceptor function.
	              if (e.isPure === PURITY_RELATIVE) {
	                return function depurifier(s) { return e(s); };
	              }
	              return e;
	            });
	        }
	      }
	
	      return addWatchDelegate(fn);
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * ## $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * ## The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * ## The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * ## Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * ## Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * ## Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        markQStateExceptionHandled(state);
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	          // This error is explicitly marked for being passed to the $exceptionHandler
	          if (e && e.$$passToExceptionHandler === true) {
	            exceptionHandler(e);
	          }
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!isStateExceptionHandled(toCheck)) {
	        markQStateExceptionHandled(toCheck);
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (isError(toCheck.value)) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	function isStateExceptionHandled(state) {
	  return !!state.pur;
	}
	function markQStateExceptionHandled(state) {
	  state.pur = true;
	}
	function markQExceptionHandled(q) {
	  // Built-in `$q` promises will always have a `$$state` property. This check is to allow
	  // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
	  // (Currently, this is the only method that might be called with a promise, even if it is not
	  // created by the built-in `$q`.)
	  if (q.$$state) {
	    markQStateExceptionHandled(q.$$state);
	  }
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	      this.$$suspended = false;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * ## Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$suspended = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are (or contain)
	       *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * @example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	        var fn = isFunction(listener) ? listener : noop;
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: fn,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
	            newValues[i] = value;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          try {
	            if (firstRun) {
	              firstRun = false;
	              listener(newValues, newValues, self);
	            } else {
	              listener(newValues, oldValues, self);
	            }
	          } finally {
	            for (var i = 0; i < watchExpressions.length; i++) {
	              oldValues[i] = newValues[i];
	            }
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * @example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        // Mark the interceptor as
	        // ... $$pure when literal since the instance will change when any input changes
	        $watchCollectionInterceptor.$$pure = $parse(obj).literal;
	        // ... $stateful when non-literal since we must read the state of the collection
	        $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * @example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = asyncQueue.length ? $rootScope : this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = !current.$$suspended && current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            // (though it differs due to having the extra check for $$suspended and does not
	            // check $$listenerCount)
	            if (!(next = ((!current.$$suspended && current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$suspend
	       * @kind function
	       *
	       * @description
	       * Suspend watchers of this scope subtree so that they will not be invoked during digest.
	       *
	       * This can be used to optimize your application when you know that running those watchers
	       * is redundant.
	       *
	       * **Warning**
	       *
	       * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
	       * Only use this approach if you are confident that you know what you are doing and have
	       * ample tests to ensure that bindings get updated as you expect.
	       *
	       * Some of the things to consider are:
	       *
	       * * Any external event on a directive/component will not trigger a digest while the hosting
	       *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
	       * * Transcluded content exists on a scope that inherits from outside a directive but exists
	       *   as a child of the directive's containing scope. If the containing scope is suspended the
	       *   transcluded scope will also be suspended, even if the scope from which the transcluded
	       *   scope inherits is not suspended.
	       * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
	       *    * A call to `$suspend()` on an already suspended scope is a no-op.
	       *    * A call to `$resume()` on a non-suspended scope is a no-op.
	       *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
	       *      longer be suspended. This could result in the other directive believing a scope to be
	       *      suspended when it is not.
	       * * If a parent scope is suspended then all its descendants will be also excluded from future
	       *   digests whether or not they have been suspended themselves. Note that this also applies to
	       *   isolate child scopes.
	       * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
	       *   for that scope and its descendants. When digesting we only check whether the current scope is
	       *   locally suspended, rather than checking whether it has a suspended ancestor.
	       * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
	       *   included in future digests until all its ancestors have been resumed.
	       * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
	       *   against the `$rootScope` and so will still trigger a global digest even if the promise was
	       *   initiated by a component that lives on a suspended scope.
	       */
	      $suspend: function() {
	        this.$$suspended = true;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$isSuspended
	       * @kind function
	       *
	       * @description
	       * Call this method to determine if this scope has been explicitly suspended. It will not
	       * tell you whether an ancestor has been suspended.
	       * To determine if this scope will be excluded from a digest triggered at the $rootScope,
	       * for example, you must check all its ancestors:
	       *
	       * ```
	       * function isExcludedFromDigest(scope) {
	       *   while(scope) {
	       *     if (scope.$isSuspended()) return true;
	       *     scope = scope.$parent;
	       *   }
	       *   return false;
	       * ```
	       *
	       * Be aware that a scope may not be included in digests if it has a suspended ancestor,
	       * even if `$isSuspended()` returns false.
	       *
	       * @returns true if the current scope has been suspended.
	       */
	      $isSuspended: function() {
	        return this.$$suspended;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$resume
	       * @kind function
	       *
	       * @description
	       * Resume watchers of this scope subtree in case it was suspended.
	       *
	       * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
	       */
	      $resume: function() {
	        this.$$suspended = false;
	      },
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating AngularJS
	       * expressions.
	       *
	       * @example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          }, null, '$evalAsync');
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the AngularJS framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * **Life cycle: Pseudo-Code of `$apply()`**
	       *
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An AngularJS expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            // Use delete in the hope of the browser deallocating the memory for the array entry,
	            // while not shifting the array indexes of other listeners.
	            // See issue https://github.com/angular/angular.js/issues/16135
	            delete namedListeners[indexOfListener];
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            break;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount and
	          // does not check $$suspended)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        }, null, '$applyAsync');
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of AngularJS application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	
	  var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
	   *
	   * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
	   * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
	   * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
	   *
	   * If the URL matches the `aHrefSanitizationWhitelist` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
	   *
	   * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
	   * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
	   * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
	   * the potentially malicious URL.
	   *
	   * If the URL matches the `aImgSanitizationWhitelist` regular expression, it is returned unchanged.
	   *
	   * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
	   * to the DOM it is inactive and potentially malicious code will not be executed.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isMediaUrl) {
	      // if (!uri) return uri;
	      var regex = isMediaUrl ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal = urlResolve(uri && uri.trim()).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it refers to the source of media, which are not expected to be run
	  // as scripts, such as an image, audio, video, etc.
	  MEDIA_URL: 'mediaUrl',
	
	  // An URL used in a context where it does not refer to a resource that loads code.
	  // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', '$$sanitizeUri', function($injector, $$sanitizeUri) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Given an object and a security context in which to assign it, returns a value that's safe to
	     * use in this context, which was represented by the parameter. To do so, this function either
	     * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
	     * the context and sanitizer availablility.
	     *
	     * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
	     * by default, and the third one relies on the `$sanitize` service (which may be loaded through
	     * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
	     * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	     * `$sceDelegateProvider.resourceUrlWhitelist`} and {@link ng.$sceDelegateProvider#resourceUrlBlacklist
	     * `$sceDelegateProvider.resourceUrlBlacklist`} accepts that resource.
	     *
	     * This function will throw if the safe type isn't appropriate for this context, or if the
	     * value given cannot be accepted in the context (which might be caused by sanitization not
	     * being available, or the value not being recognized as safe).
	     *
	     * <div class="alert alert-danger">
	     * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
	     * (XSS) vulnerability in your application.
	     * </div>
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If maybeTrusted is a trusted class instance but not of the correct trusted type
	      // then unwrap it and allow it to pass through to the rest of the checks
	      if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
	        maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
	      }
	
	      // If we get here, then we will either sanitize the value or throw an exception.
	      if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
	        // we attempt to sanitize non-resource URLs
	        return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
	      } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * ## Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ### Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ### In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ### How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ### Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, AngularJS only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ### This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
	 * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
	 * when binding untrusted values to `$sce.HTML` context.
	 * AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ### What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
	 * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider#resourceUrlWhitelist()} and {@link $sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider#resourceUrlBlacklist()} can be used to restrict trusted origins for `RESOURCE_URL` |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
	 *
	 *
	 * <div class="alert alert-warning">
	 * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
	 * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
	 *
	 * **As of 1.7.0, this is no longer the case.**
	 *
	 * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
	 * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
	 * service evaluates the expressions.
	 * </div>
	 *
	 * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
	 * functions aren't useful yet. This might evolve.
	 *
	 * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ### Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $$taskTrackerFactory
	 * @description
	 * A function to create `TaskTracker` instances.
	 *
	 * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
	 * parties when all pending tasks (or tasks of a specific type) have been completed.
	 *
	 * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
	 *     execution.
	 *
	 * @this
	 */
	function $$TaskTrackerFactoryProvider() {
	  this.$get = valueFn(function(log) { return new TaskTracker(log); });
	}
	
	function TaskTracker(log) {
	  var self = this;
	  var taskCounts = {};
	  var taskCallbacks = [];
	
	  var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
	  var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';
	
	  /**
	   * Execute the specified function and decrement the appropriate `taskCounts` counter.
	   * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
	   *
	   * @param {Function} fn - The function to execute.
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
	   */
	  self.completeTask = completeTask;
	
	  /**
	   * Increase the task count for the specified task type (or the default task type if non is
	   * specified).
	   *
	   * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
	   */
	  self.incTaskCount = incTaskCount;
	
	  /**
	   * Execute the specified callback when all pending tasks have been completed.
	   *
	   * If there are no pending tasks, the callback is executed immediately. You can optionally limit
	   * the tasks that will be waited for to a specific type, by passing a `taskType`.
	   *
	   * @param {function} callback - The function to call when there are no pending tasks.
	   * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
	   */
	  self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
	
	  function completeTask(fn, taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	
	    try {
	      fn();
	    } finally {
	      decTaskCount(taskType);
	
	      var countForType = taskCounts[taskType];
	      var countForAll = taskCounts[ALL_TASKS_TYPE];
	
	      // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
	      if (!countForAll || !countForType) {
	        var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
	        var nextCb;
	
	        while ((nextCb = getNextCallback(taskType))) {
	          try {
	            nextCb();
	          } catch (e) {
	            log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function decTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    if (taskCounts[taskType]) {
	      taskCounts[taskType]--;
	      taskCounts[ALL_TASKS_TYPE]--;
	    }
	  }
	
	  function getLastCallback() {
	    var cbInfo = taskCallbacks.pop();
	    return cbInfo && cbInfo.cb;
	  }
	
	  function getLastCallbackForType(taskType) {
	    for (var i = taskCallbacks.length - 1; i >= 0; --i) {
	      var cbInfo = taskCallbacks[i];
	      if (cbInfo.type === taskType) {
	        taskCallbacks.splice(i, 1);
	        return cbInfo.cb;
	      }
	    }
	  }
	
	  function incTaskCount(taskType) {
	    taskType = taskType || DEFAULT_TASK_TYPE;
	    taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
	    taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
	  }
	
	  function notifyWhenNoPendingTasks(callback, taskType) {
	    taskType = taskType || ALL_TASKS_TYPE;
	    if (!taskCounts[taskType]) {
	      callback();
	    } else {
	      taskCallbacks.push({type: taskType, cb: callback});
	    }
	  }
	}
	
	var $templateRequestMinErr = minErr('$templateRequest');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
	   * as {@link ngInclude} to download and cache templates.
	   *
	   * 3rd party modules should use `$templateRequest` if their services or directives are loading
	   * templates.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes AngularJS accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            return $templateCache.put(tpl, response.data);
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when all pending tasks are completed.
	     *
	     * Types of tasks waited for include:
	     * - Pending timeouts (via {@link $timeout}).
	     * - Pending HTTP requests (via {@link $http}).
	     * - In-progress route transitions (via {@link $route}).
	     * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
	     * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
	     *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	var $timeoutMinErr = minErr('$timeout');
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	    /**
	     * @ngdoc service
	     * @name $timeout
	     *
	     * @description
	     * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	     * block and delegates any exceptions to
	     * {@link ng.$exceptionHandler $exceptionHandler} service.
	     *
	     * The return value of calling `$timeout` is a promise, which will be resolved when
	     * the delay has passed and the timeout function, if provided, is executed.
	     *
	     * To cancel a timeout request, call `$timeout.cancel(promise)`.
	     *
	     * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	     * synchronously flush the queue of deferred functions.
	     *
	     * If you only want a promise that will be resolved after some specified delay
	     * then you can call `$timeout` without the `fn` function.
	     *
	     * @param {function()=} fn A function, whose execution should be delayed.
	     * @param {number=} [delay=0] Delay in milliseconds.
	     * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	     *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	     * @param {...*=} Pass additional parameters to the executed function.
	     * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	     *   will be resolved with the return value of the `fn` function.
	     *
	     */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay, '$timeout');
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $timeout#cancel
	     *
	     * @description
	     * Cancels a task associated with the `promise`. As a result of this, the promise will be
	     * resolved with a rejection.
	     *
	     * @param {Promise=} promise Promise returned by the `$timeout` function.
	     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	     *   canceled.
	     */
	    timeout.cancel = function(promise) {
	      if (!promise) return false;
	
	      if (!promise.hasOwnProperty('$$timeoutId')) {
	        throw $timeoutMinErr('badprom',
	            '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
	      }
	
	      if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
	
	      var id = promise.$$timeoutId;
	      var deferred = deferreds[id];
	
	      // Timeout cancels should not report an unhandled promise.
	      markQExceptionHandled(deferred.promise);
	      deferred.reject('canceled');
	      delete deferreds[id];
	
	      return $browser.defer.cancel(id);
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	var baseUrlParsingNode;
	
	urlParsingNode.href = 'http://[::1]';
	
	// Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
	// IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
	// when parsed out of an anchor element.
	var ipv6InBrackets = urlParsingNode.hostname === '[::1]';
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
	 *     unchanged.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description                                                            |
	 *   |---------------|------------------------------------------------------------------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol without the trailing colon                                |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol                                 |
	 *   | hostname      | The hostname                                                           |
	 *   | port          | The port, without ":"                                                  |
	 *   | pathname      | The pathname, beginning with "/"                                       |
	 *
	 */
	function urlResolve(url) {
	  if (!isString(url)) return url;
	
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  var hostname = urlParsingNode.hostname;
	
	  if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
	    hostname = '[' + hostname + ']';
	  }
	
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application
	 * document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, originUrl);
	}
	
	/**
	 * Parse a request URL and determine whether it is same-origin as the current document base URL.
	 *
	 * Note: The base URL is usually the same as the document location (`location.href`) but can
	 * be overriden by using the `<base>` tag.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the URL is same-origin as the document base URL.
	 */
	function urlIsSameOriginAsBaseUrl(requestUrl) {
	  return urlsAreSameOrigin(requestUrl, getBaseUrl());
	}
	
	/**
	 * Create a function that can check a URL's origin against a list of allowed/whitelisted origins.
	 * The current location's origin is implicitly trusted.
	 *
	 * @param {string[]} whitelistedOriginUrls - A list of URLs (strings), whose origins are trusted.
	 *
	 * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
	 *     whether it is of an allowed origin.
	 */
	function urlIsAllowedOriginFactory(whitelistedOriginUrls) {
	  var parsedAllowedOriginUrls = [originUrl].concat(whitelistedOriginUrls.map(urlResolve));
	
	  /**
	   * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
	   * based on a list of whitelisted-origin URLs. The current location's origin is implicitly
	   * trusted.
	   *
	   * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
	   *     resolved or a parsed URL object).
	   *
	   * @returns {boolean} - Whether the specified URL is of an allowed origin.
	   */
	  return function urlIsAllowedOrigin(requestUrl) {
	    var parsedUrl = urlResolve(requestUrl);
	    return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
	  };
	}
	
	/**
	 * Determine if two URLs share the same origin.
	 *
	 * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
	 *     a dictionary object returned by `urlResolve()`.
	 * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
	 *     of a dictionary object returned by `urlResolve()`.
	 *
	 * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
	 */
	function urlsAreSameOrigin(url1, url2) {
	  url1 = urlResolve(url1);
	  url2 = urlResolve(url2);
	
	  return (url1.protocol === url2.protocol &&
	          url1.host === url2.host);
	}
	
	/**
	 * Returns the current document base URL.
	 * @returns {string}
	 */
	function getBaseUrl() {
	  if (window.document.baseURI) {
	    return window.document.baseURI;
	  }
	
	  // `document.baseURI` is available everywhere except IE
	  if (!baseUrlParsingNode) {
	    baseUrlParsingNode = window.document.createElement('a');
	    baseUrlParsingNode.href = '.';
	
	    // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
	    // suitable here because we need to track changes to the base URL.
	    baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
	  }
	  return baseUrlParsingNode.href;
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In AngularJS we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how AngularJS filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the AngularJS Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services. AngularJS comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // If the currency symbol is empty, trim whitespace around the symbol
	    var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(currencySymbolRe, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 *
	 * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
	 *
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @example
	   <example module="uppercaseFilterExample" name="filter-uppercase">
	     <file name="index.html">
	       <script>
	         angular.module('uppercaseFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.title = 'This is a title';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <!-- This title should be formatted normally -->
	         <h1>{{title}}</h1>
	         <!-- This title should be capitalized -->
	         <h1>{{title | uppercase}}</h1>
	       </div>
	     </file>
	   </example>
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 *    **Note:** `null` values use `'null'` as their type.
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * If a custom comparator still can't distinguish between two items, then they will be sorted based
	 * on their index using the built-in comparator.
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, sorts values of different types by type and puts
	 * `undefined` and `null` values at the end of the sorted list.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types:
	 *    - If one of the values is undefined, consider it "greater than" the other.
	 *    - Else if one of the values is null, consider it "greater than" the other.
	 *    - Else compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
	 *           any other value (with undefined "greater than" null). This effectively means that `null`
	 *           and `undefined` values end up at the end of a list sorted in ascending order.
	 * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = (type1 === 'undefined') ? 1 :
	        (type2 === 'undefined') ? -1 :
	        (type1 === 'null') ? 1 :
	        (type2 === 'null') ? -1 :
	        (type1 < type2) ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * AngularJS has a chance to replace the `{{hash}}` markup with its
	 * value. Until AngularJS replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an AngularJS page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until AngularJS replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
	        <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
	          element(by.model('leader')).click();
	          expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Internet Explorer and Edge do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>List</summary>
	            <ul>
	              <li>Apple</li>
	              <li>Orange</li>
	              <li>Durian</li>
	            </ul>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = ['$sce', function($sce) {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        // We need to sanitize the url at least once, in case it is a constant
	        // non-interpolated attribute.
	        attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set might have sanitized the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  }];
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $getControls: valueFn([]),
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop,
	  $$setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $pending An object hash, containing references to controls or forms with
	 *  pending validators, where:
	 *
	 *  - keys are validations tokens (error names).
	 *  - values are arrays of controls or forms that have a pending validator for the given error name.
	 *
	 * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
	 *
	 * @property {Object} $error An object hash, containing references to controls or forms with failing
	 *  validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for the given error name.
	 *
	 *  Built-in validation tokens:
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$getControls
	   * @returns {Array} the controls that are currently part of this form
	   *
	   * @description
	   * This method returns a **shallow copy** of the controls that are currently part of this form.
	   * The controls can be instances of {@link form.FormController `FormController`}
	   * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
	   * If you need access to the controls of child-forms, you have to call `$getControls()`
	   * recursively on them.
	   * This can be used for example to iterate over all controls to validate them.
	   *
	   * The controls can be accessed normally, but adding to, or removing controls from the array has
	   * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
	   * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
	   * Likewise, adding a control to, or removing a control from the form is not reflected
	   * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
	   * you need access to the controls.
	   */
	  $getControls: function() {
	    return shallowCopy(this.$$controls);
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
	   * parent forms of the form.
	   */
	  $setSubmitted: function() {
	    var rootForm = this;
	    while (rootForm.$$parentForm && (rootForm.$$parentForm !== nullFormCtrl)) {
	      rootForm = rootForm.$$parentForm;
	    }
	    rootForm.$$setSubmitted();
	  },
	
	  $$setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    forEach(this.$$controls, function(control) {
	      if (control.$$setSubmitted) {
	        control.$$setSubmitted();
	      }
	    });
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Change the validity state of the form, and notify the parent form (if any).
	 *
	 * Application developers will rarely need to call this method directly. It is used internally, by
	 * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
	 * control's validity state to the parent `FormController`.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
	 *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
	 *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
	 *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
	 *        class name. Example: `myError` will result in `ng-valid-my-error` and
	 *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
	 *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *        Skipped is used by AngularJS when validators do not run because of parse errors and when
	 *        `$asyncValidators` do not run because any of the `$validators` failed.
	 * @param {NgModelController | FormController} controller - The controller whose validity state is
	 *        triggering the change.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Helper directive that makes it possible to create control groups inside a
	 * {@link ng.directive:form `form`} directive.
	 * These "child forms" can be used, for example, to determine the validity of a sub-group of
	 * controls.
	 *
	 * <div class="alert alert-danger">
	 * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
	 * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
	 * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
	 * you cannot send data to the server with `ngForm`, or integrate it with
	 * {@link ng.directive:ngSubmit `ngSubmit`}.
	 * </div>
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will
	 *                              be published into the related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * ## Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * ## CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * ## Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side AngularJS applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, AngularJS prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * @animations
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise AngularJS will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * The format of the displayed time can be adjusted with the
	    * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	    * and `timeStripZeroSeconds`.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
	   * this is the timezone of the browser.
	   *
	   * The format of the displayed time can be adjusted with the
	   * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
	   * and `timeStripZeroSeconds`.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise AngularJS will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
	    * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
	    * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise AngularJS will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise AngularJS will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   *
	   *
	   * @knownIssue
	   *
	   * ### HTML5 constraint validation and `allowInvalid`
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   * @knownIssue
	   *
	   * ### Large numbers and `step` validation
	   *
	   * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
	   * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
	   * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
	   * {@link guide/forms#modifying-built-in-validators overwriting the validators}
	   * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
	   * to an `input[text]` element. The source for `input[number]` type can be used as a starting
	   * point for both implementations.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium, which may not fulfill your app's requirements.
	   * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
	   * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
	   * modify the built-in validators (see the {@link guide/forms Forms guide}).
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * **Note:**<br>
	   * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
	   * value of their `name` attribute to determine the property under which their
	   * {@link ngModel.NgModelController NgModelController} will be published on the parent
	   * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
	   * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
	   * published on the parent `FormController` under that name. The rest of the controllers will
	   * continue to work as expected, but you won't be able to access them as properties on the parent
	   * `FormController`.
	   *
	   * <div class="alert alert-info">
	   *   <p>
	   *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
	   *     that the browser can manage their state (checked/unchecked) based on the state of other
	   *     inputs in the same group.
	   *   </p>
	   *   <p>
	   *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
	   *     value of the underlying model data.
	   *   </p>
	   * </div>
	   *
	   * <div class="alert alert-success">
	   *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
	   *   unique name.
	   * </div>
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for AngularJS:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, AngularJS will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
	   *                      to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    // Support: IE9+
	    element.on('compositionupdate', function(ev) {
	      // End composition when ev.data is empty string on 'compositionupdate' event.
	      // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
	      // instead of 'compositionend'.
	      if (isUndefined(ev.data) || ev.data === '') {
	        composing = false;
	      }
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut drop', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, previousDate) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (previousDate) {
	          map = {
	            yyyy: previousDate.getFullYear(),
	            MM: previousDate.getMonth() + 1,
	            dd: previousDate.getDate(),
	            HH: previousDate.getHours(),
	            mm: previousDate.getMinutes(),
	            ss: previousDate.getSeconds(),
	            sss: previousDate.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	
	        var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	        if (map.yyyy < 100) {
	          // In the constructor, 2-digit years map to 1900-1999.
	          // Use `setFullYear()` to set the correct year.
	          date.setFullYear(map.yyyy);
	        }
	
	        return date;
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	    badInputChecker(scope, element, attr, ctrl, type);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	    var isTimeType = type === 'time' || type === 'datetimelocal';
	    var previousDate;
	    var previousTimezone;
	
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        return parseDateAndConvertTimeZoneToLocal(value, previousDate);
	      }
	      ctrl.$$parserName = type;
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        var timezone = ctrl.$options.getOption('timezone');
	
	        if (timezone) {
	          previousTimezone = timezone;
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	
	        return formatter(value, timezone);
	      } else {
	        previousDate = null;
	        previousTimezone = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal = attr.min || $parse(attr.ngMin)(scope);
	      var parsedMinVal = parseObservedDateValue(minVal);
	
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
	      };
	      attr.$observe('min', function(val) {
	        if (val !== minVal) {
	          parsedMinVal = parseObservedDateValue(val);
	          minVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal = attr.max || $parse(attr.ngMax)(scope);
	      var parsedMaxVal = parseObservedDateValue(maxVal);
	
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
	      };
	      attr.$observe('max', function(val) {
	        if (val !== maxVal) {
	          parsedMaxVal = parseObservedDateValue(val);
	          maxVal = val;
	          ctrl.$validate();
	        }
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
	    }
	
	    function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
	      var timezone = ctrl.$options.getOption('timezone');
	
	      if (previousTimezone && previousTimezone !== timezone) {
	        // If the timezone has changed, adjust the previousDate to the default timezone
	        // so that the new date is converted with the correct timezone offset
	        previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
	      }
	
	      var parsedDate = parseDate(value, previousDate);
	
	      if (!isNaN(parsedDate) && timezone) {
	        parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	      }
	      return parsedDate;
	    }
	
	    function formatter(value, timezone) {
	      var targetFormat = format;
	
	      if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
	        targetFormat = format
	          .replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat'))
	          .replace(/:$/, '');
	      }
	
	      var formatted =  $filter('date')(value, targetFormat, timezone);
	
	      if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
	        formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
	      }
	
	      return formatted;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl, parserName) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      if (validity.badInput || validity.typeMismatch) {
	        ctrl.$$parserName = parserName;
	        return undefined;
	      }
	
	      return value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	
	    ctrl.$$parserName = 'number';
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  badInputChecker(scope, element, attr, ctrl, 'number');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var parsedMinVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    var minVal = attr.min || $parse(attr.ngMin)(scope);
	    parsedMinVal = parseNumberAttrVal(minVal);
	
	    ctrl.$validators.min = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
	    };
	
	    attr.$observe('min', function(val) {
	      if (val !== minVal) {
	        parsedMinVal = parseNumberAttrVal(val);
	        minVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    var maxVal = attr.max || $parse(attr.ngMax)(scope);
	    var parsedMaxVal = parseNumberAttrVal(maxVal);
	
	    ctrl.$validators.max = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      if (val !== maxVal) {
	        parsedMaxVal = parseNumberAttrVal(val);
	        maxVal = val;
	        // TODO(matsko): implement validateLater to reduce number of validations
	        ctrl.$validate();
	      }
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal = attr.step || $parse(attr.ngStep)(scope);
	    var parsedStepVal = parseNumberAttrVal(stepVal);
	
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) ||
	        isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      if (val !== stepVal) {
	        parsedStepVal = parseNumberAttrVal(val);
	        stepVal = val;
	        ctrl.$validate();
	      }
	
	    });
	
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl, 'range');
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    minVal = parseNumberAttrVal(attr.min);
	
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    maxVal = parseNumberAttrVal(attr.max);
	
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    stepVal = parseNumberAttrVal(attr.step);
	
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    var oldVal = attr[htmlAttrName];
	    attr.$observe(htmlAttrName, function wrappedObserver(val) {
	      if (val !== oldVal) {
	        oldVal = val;
	        changeFn(val);
	      }
	    });
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (!supportsRange) {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    } else if (ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('change', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with AngularJS data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	var hiddenInputBrowserCacheDirective = function() {
	  var valueProperty = {
	    configurable: true,
	    enumerable: false,
	    get: function() {
	      return this.getAttribute('value') || '';
	    },
	    set: function(val) {
	      this.setAttribute('value', val);
	    }
	  };
	
	  return {
	    restrict: 'E',
	    priority: 200,
	    compile: function(_, attr) {
	      if (lowercase(attr.type) !== 'hidden') {
	        return;
	      }
	
	      return {
	        pre: function(scope, element, attr, ctrls) {
	          var node = element[0];
	
	          // Support: Edge
	          // Moving the DOM around prevents autofillling
	          if (node.parentNode) {
	            node.parentNode.insertBefore(node, node.nextSibling);
	          }
	
	          // Support: FF, IE
	          // Avoiding direct assignment to .value prevents autofillling
	          if (Object.defineProperty) {
	            Object.defineProperty(node, 'value', valueProperty);
	          }
	        }
	      };
	    }
	  };
	};
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element ANY
	 * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 * @restrict A
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element ANY
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    if (!classValue) return classValue;
	
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    } else if (!isString(classValue)) {
	      classString = classValue + '';
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 * @element ANY
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
	 *
	 * ### ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 *
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example
	 * ### Basic
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   @example
	   ### Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassOdd`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-odd="'odd'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .odd {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .odd-add, .odd-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add odd class to odd entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
	         expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 *
	 * <hr />
	 * @example
	 * An example on how to implement animations using `ngClassEven`:
	 *
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
	     <file name="index.html">
	       <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
	         <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
	         <hr />
	         <table>
	           <tr ng-repeat="item in items" ng-class-even="'even'">
	             <td>{{ item }}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="style.css">
	       .even {
	         background: rgba(255, 255, 0, 0.25);
	       }
	
	       .even-add, .even-remove {
	         transition: 1.5s;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should add new entries to the beginning of the list', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.count()).toBe(4);
	         expect(rows.get(0).getText()).toBe('Item 3');
	         expect(rows.get(1).getText()).toBe('Item 2');
	
	         button.click();
	
	         expect(rows.count()).toBe(5);
	         expect(rows.get(0).getText()).toBe('Item 4');
	         expect(rows.get(1).getText()).toBe('Item 3');
	       });
	
	       it('should add even class to even entries', function() {
	         var button = element(by.buttonText('Add item'));
	         var rows = element.all(by.repeater('item in items'));
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	
	         button.click();
	
	         expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
	         expect(rows.get(1).getAttribute('class')).toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the AngularJS community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * AngularJS has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect AngularJS:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related AngularJS features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of AngularJS.
	 *
	 * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 *
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	
	  <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	  <example name="example.csp" module="cspExample" ng-csp="true">
	    <file name="index.html">
	      <div ng-controller="MainController as ctrl">
	        <div>
	          <button ng-click="ctrl.inc()" id="inc">Increment</button>
	          <span id="counter">
	            {{ctrl.counter}}
	          </span>
	        </div>
	
	        <div>
	          <button ng-click="ctrl.evil()" id="evil">Evil</button>
	          <span id="evilError">
	            {{ctrl.evilError}}
	          </span>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	       angular.module('cspExample', [])
	         .controller('MainController', function MainController() {
	            this.counter = 0;
	            this.inc = function() {
	              this.counter++;
	            };
	            this.evil = function() {
	              try {
	                eval('1+2'); // eslint-disable-line no-eval
	              } catch (e) {
	                this.evilError = e.message;
	              }
	            };
	          });
	    </file>
	    <file name="protractor.js" type="protractor">
	      var util, webdriver;
	
	      var incBtn = element(by.id('inc'));
	      var counter = element(by.id('counter'));
	      var evilBtn = element(by.id('evil'));
	      var evilError = element(by.id('evilError'));
	
	      function getAndClearSevereErrors() {
	        return browser.manage().logs().get('browser').then(function(browserLog) {
	          return browserLog.filter(function(logEntry) {
	            return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	          });
	        });
	      }
	
	      function clearErrors() {
	        getAndClearSevereErrors();
	      }
	
	      function expectNoErrors() {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          expect(filteredLog.length).toEqual(0);
	          if (filteredLog.length) {
	            console.log('browser console errors: ' + util.inspect(filteredLog));
	          }
	        });
	      }
	
	      function expectError(regex) {
	        getAndClearSevereErrors().then(function(filteredLog) {
	          var found = false;
	          filteredLog.forEach(function(log) {
	            if (log.message.match(regex)) {
	              found = true;
	            }
	          });
	          if (!found) {
	            throw new Error('expected an error that matches ' + regex);
	          }
	        });
	      }
	
	      beforeEach(function() {
	        util = require('util');
	        webdriver = require('selenium-webdriver');
	      });
	
	      // For now, we only test on Chrome,
	      // as Safari does not load the page with Protractor's injected scripts,
	      // and Firefox webdriver always disables content security policy (#6358)
	      if (browser.params.browser !== 'chrome') {
	        return;
	      }
	
	      it('should not report errors when the page is loaded', function() {
	        // clear errors so we are not dependent on previous tests
	        clearErrors();
	        // Need to reload the page as the page is already loaded when
	        // we come here
	        browser.driver.getCurrentUrl().then(function(url) {
	          browser.get(url);
	        });
	        expectNoErrors();
	      });
	
	      it('should evaluate expressions', function() {
	        expect(counter.getText()).toEqual('0');
	        incBtn.click();
	        expect(counter.getText()).toEqual('1');
	        expectNoErrors();
	      });
	
	      it('should throw and report an error when using "eval"', function() {
	        evilBtn.click();
	        expect(evilError.getText()).toMatch(/Content Security Policy/);
	        expectError(/Content Security Policy/);
	      });
	    </file>
	  </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * AngularJS expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function($parse, $rootScope, $exceptionHandler) {
	      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
	    }];
	  }
	);
	
	function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
	  return {
	    restrict: 'A',
	    compile: function($element, attr) {
	      // NOTE:
	      // We expose the powerful `$event` object on the scope that provides access to the Window,
	      // etc. This is OK, because expressions are not sandboxed any more (and the expression
	      // sandbox was never meant to be a security feature anyway).
	      var fn = $parse(attr[directiveName]);
	      return function ngEventHandler(scope, element) {
	        element.on(eventName, function(event) {
	          var callback = function() {
	            fn(scope, {$event: event});
	          };
	
	          if (!$rootScope.$$phase) {
	            scope.$apply(callback);
	          } else if (forceAsync) {
	            scope.$evalAsync(callback);
	          } else {
	            try {
	              callback();
	            } catch (error) {
	              $exceptionHandler(error);
	            }
	          }
	        });
	      };
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 * @restrict A
	 * @element ANY
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 * @restrict A
	 * @element ANY
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 * @restrict A
	 * @element form
	 * @priority 0
	 *
	 * @description
	 * Enables binding AngularJS expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 * @restrict A
	 * @element window, input, select, textarea, a
	 * @priority 0
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 * @scope
	 * @priority -400
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 * @priority 450
	 * @element ANY
	 *
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`:
	 * <ul>
	 *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
	 *     as seen in the demo below.</li>
	 *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
	 *   <li>injecting data via server side scripting.</li>
	 * </ul>
	 *
	 * Besides these few cases, you should use {@link guide/component Components} or
	 * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 * @restrict A
	 * @priority 100
	 *
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * @example
	 * ### Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Splitting on newline
	 *
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
	 *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
	 *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
	 *     It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * AngularJS provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	  this.$$updateEvents = '';
	  // Attach the correct context to the event handler function for updateOn
	  this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	  this.$$parserName = 'parse';
	
	  this.$$currentValidationRunId = 0;
	
	  this.$$scope = $scope;
	  this.$$rootScope = $scope.$root;
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * @example
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName;
	
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    // Reset any previous parse error
	    this.$setValidity(this.$$parserName, null);
	    this.$$parserName = 'parse';
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default']) &&
	      this.$options.getOption('updateOn').indexOf(trigger) === -1
	    ) {
	      debounceDelay = debounceDelay['default'];
	    } else if (isNumber(debounceDelay['*'])) {
	      debounceDelay = debounceDelay['*'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$rootScope.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** this function only affects the options set on the `ngModelController`,
	   * and not the options on the {@link ngModelOptions} directive from which they might have been
	   * obtained initially.
	   * </div>
	   *
	   * <div class="alert alert-danger">
	   * **Note:** it is not possible to override the `getterSetter` option.
	   * </div>
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	    this.$$setUpdateOnEvents();
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name  ngModel.NgModelController#$processModelValue
	
	   * @description
	   *
	   * Runs the model -> view pipeline on the current
	   * {@link ngModel.NgModelController#$modelValue $modelValue}.
	   *
	   * The following actions are performed by this method:
	   *
	   * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
	   * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
	   * - the `ng-empty` or `ng-not-empty` class is set on the element
	   * - if the `$viewValue` has changed:
	   *   - {@link ngModel.NgModelController#$render $render} is called on the control
	   *   - the {@link ngModel.NgModelController#$validators $validators} are run and
	   *   the validation status is set.
	   *
	   * This method is called by ngModel internally when the bound scope value changes.
	   * Application developers usually do not have to call this function themselves.
	   *
	   * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
	   * formatted and the `$modelValue` must be run through the `$formatters` again.
	   *
	   * @example
	   * Consider a text input with an autocomplete list (for fruit), where the items are
	   * objects with a name and an id.
	   * A user enters `ap` and then selects `Apricot` from the list.
	   * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
	   * but the rendered value will still be `ap`.
	   * The widget can then call `ctrl.$processModelValue()` to run the model -> view
	   * pipeline again, which formats the object to the string `Apricot`,
	   * then updates the `$viewValue`, and finally renders it in the DOM.
	   *
	   * <example module="inputExample" name="ng-model-process">
	     <file name="index.html">
	      <div ng-controller="inputController" style="display: flex;">
	        <div style="margin-right: 30px;">
	          Search Fruit:
	          <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
	        </div>
	        <div>
	          Model:<br>
	          <pre>{{selectedFruit | json}}</pre>
	        </div>
	      </div>
	     </file>
	     <file name="app.js">
	      angular.module('inputExample', [])
	        .controller('inputController', function($scope) {
	          $scope.items = [
	            {name: 'Apricot', id: 443},
	            {name: 'Clementine', id: 972},
	            {name: 'Durian', id: 169},
	            {name: 'Jackfruit', id: 982},
	            {name: 'Strawberry', id: 863}
	          ];
	        })
	        .component('basicAutocomplete', {
	          bindings: {
	            items: '<',
	            onSelect: '&'
	          },
	          templateUrl: 'autocomplete.html',
	          controller: function($element, $scope) {
	            var that = this;
	            var ngModel;
	
	            that.$postLink = function() {
	              ngModel = $element.find('input').controller('ngModel');
	
	              ngModel.$formatters.push(function(value) {
	                return (value && value.name) || value;
	              });
	
	              ngModel.$parsers.push(function(value) {
	                var match = value;
	                for (var i = 0; i < that.items.length; i++) {
	                  if (that.items[i].name === value) {
	                    match = that.items[i];
	                    break;
	                  }
	                }
	
	                return match;
	              });
	            };
	
	            that.selectItem = function(item) {
	              ngModel.$setViewValue(item);
	              ngModel.$processModelValue();
	              that.onSelect({item: item});
	            };
	          }
	        });
	     </file>
	     <file name="autocomplete.html">
	       <div>
	         <input type="search" ng-model="$ctrl.searchTerm" />
	         <ul>
	           <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
	             <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
	           </li>
	         </ul>
	       </div>
	     </file>
	   * </example>
	   *
	   */
	  $processModelValue: function() {
	    var viewValue = this.$$format();
	
	    if (this.$viewValue !== viewValue) {
	      this.$$updateEmptyClasses(viewValue);
	      this.$viewValue = this.$$lastCommittedViewValue = viewValue;
	      this.$render();
	      // It is possible that model and view value have been updated during render
	      this.$$runValidators(this.$modelValue, this.$viewValue, noop);
	    }
	  },
	
	  /**
	   * This method is called internally to run the $formatters on the $modelValue
	   */
	  $$format: function() {
	    var formatters = this.$formatters,
	        idx = formatters.length;
	
	    var viewValue = this.$modelValue;
	    while (idx--) {
	      viewValue = formatters[idx](viewValue);
	    }
	
	    return viewValue;
	  },
	
	  /**
	   * This method is called internally when the bound scope value changes.
	   */
	  $$setModelValue: function(modelValue) {
	    this.$modelValue = this.$$rawModelValue = modelValue;
	    this.$$parserValid = undefined;
	    this.$processModelValue();
	  },
	
	  $$setUpdateOnEvents: function() {
	    if (this.$$updateEvents) {
	      this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
	    }
	
	    this.$$updateEvents = this.$options.getOption('updateOn');
	    if (this.$$updateEvents) {
	      this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
	    }
	  },
	
	  $$updateEventHandler: function(ev) {
	    this.$$debounceViewValueCommit(ev && ev.type);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // This cannot be moved to the action function, because it would not catch the
	    // case where the model is changed in the ngChange function or the model setter
	    if (modelValue !== ctrl.$modelValue &&
	      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	      // eslint-disable-next-line no-self-compare
	      (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$$setModelValue(modelValue);
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by AngularJS when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 * @restrict A
	 * @priority 1
	 * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * ## CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * @animations
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * ### Basic Usage
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * @example
	 * ### Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          modelCtrl.$$setUpdateOnEvents();
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /** @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 * @restrict A
	 * @priority 10
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an AngularJS expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ### Overriding immediate updates
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Debouncing updates
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ### Default events, extra triggers, and catch-all debounce values
	 *
	 * This example shows the relationship between "default" update events and
	 * additional `updateOn` triggers.
	 *
	 * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
	 * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
	 * in `updateOn` is considered a "default" event, since different control types have different
	 * default events.
	 *
	 * The control in this example updates by "default", "click", and "blur", with different `debounce`
	 * values. You can see that "click" doesn't have an individual `debounce` value -
	 * therefore it uses the `*` debounce value.
	 *
	 * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
	 * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
	 * it is considered a "default" event and will update the
	 * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
	 * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
	 *
	 * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
	 * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
	 *
	  <example name="ngModelOptions-advanced" module="optionsExample">
	    <file name="index.html">
	       <model-update-demo></model-update-demo>
	    </file>
	    <file name="app.js">
	      angular.module('optionsExample', [])
	        .component('modelUpdateDemo', {
	          templateUrl: 'template.html',
	          controller: function() {
	            this.name = 'Chinua';
	
	            this.options = {
	              updateOn: 'default blur click',
	              debounce: {
	                default: 2000,
	                blur: 0,
	                '*': 1000
	              }
	            };
	
	            this.updateEvents = function() {
	              var eventList = this.options.updateOn.split(' ');
	              eventList.push('*');
	              var events = {};
	
	              for (var i = 0; i < eventList.length; i++) {
	                events[eventList[i]] = this.options.debounce[eventList[i]];
	              }
	
	              this.events = events;
	            };
	
	            this.updateOptions = function() {
	              var options = angular.extend(this.options, {
	                updateOn: Object.keys(this.events).join(' ').replace('*', ''),
	                debounce: this.events
	              });
	
	              this.form.input.$overrideModelOptions(options);
	            };
	
	            // Initialize the event form
	            this.updateEvents();
	          }
	        });
	    </file>
	    <file name="template.html">
	      <form name="$ctrl.form">
	        Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
	      </form>
	      Model: <tt>{{$ctrl.name}}</tt>
	      <hr>
	      <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
	
	      <hr>
	      <form ng-submit="$ctrl.updateOptions()">
	        <b>updateOn</b><br>
	        <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
	
	        <table>
	          <tr>
	            <th>Option</th>
	            <th>Debounce value</th>
	          </tr>
	          <tr ng-repeat="(key, value) in $ctrl.events">
	            <td>{{key}}</td>
	            <td><input type="number" ng-model="$ctrl.events[key]" /></td>
	          </tr>
	        </table>
	
	        <br>
	        <input type="submit" value="Update options">
	      </form>
	    </file>
	  </example>
	 *
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Programmatically changing options
	 *
	 * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
	 * watched for changes. However, it is possible to override the options on a single
	 * {@link ngModel.NgModelController} instance with
	 * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
	 * See also the example for
	 * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
	 * Default events, extra triggers, and catch-all debounce values}.
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 *
	 * ## Formatting the value of `time` and `datetime-local`
	 *
	 * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
	 * that is displayed in the control. Note that browsers may apply their own formatting
	 * in the user interface.
	 *
	   <example name="ngModelOptions-time-format" module="timeExample">
	     <file name="index.html">
	       <time-example></time-example>
	     </file>
	     <file name="script.js">
	        angular.module('timeExample', [])
	          .component('timeExample', {
	            templateUrl: 'timeExample.html',
	            controller: function() {
	              this.time = new Date(1970, 0, 1, 14, 57, 0);
	
	              this.options = {
	                timeSecondsFormat: 'ss',
	                timeStripZeroSeconds: true
	              };
	
	              this.optionChange = function() {
	                this.timeForm.timeFormatted.$overrideModelOptions(this.options);
	                this.time = new Date(this.time);
	              };
	            }
	          });
	     </file>
	     <file name="timeExample.html">
	       <form name="$ctrl.timeForm">
	         <strong>Default</strong>:
	         <input type="time" ng-model="$ctrl.time" step="any" /><br>
	         <strong>With options</strong>:
	         <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
	         <br>
	
	         Options:<br>
	         <code>timeSecondsFormat</code>:
	         <input
	           type="text"
	           ng-model="$ctrl.options.timeSecondsFormat"
	           ng-change="$ctrl.optionChange()">
	         <br>
	         <code>timeStripZeroSeconds</code>:
	         <input
	           type="checkbox"
	           ng-model="$ctrl.options.timeStripZeroSeconds"
	           ng-change="$ctrl.optionChange()">
	        </form>
	      </file>
	 *  </example>
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents.
	 *
	 * **General options**:
	 *
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control. These are the events that are bound to
	 *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
	 *
	 *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
	 *     since different control types use different default events.
	 *
	 *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
	 *     Triggering and debouncing model updates}.
	 *
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *     You can use the `*` key to specify a debounce value that applies to all events that are not
	 *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur mouseup',
	 *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *
	 *
	 *  **Input-type specific options**:
	 *
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *     Note that changing the timezone will have no effect on the current date, and is only applied after
	 *     the next input / model change.
	 *
	 *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
	 *     milliseconds. The option follows the format string of {@link date date filter}.
	 *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
	 *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
	 *     seconds and milliseconds.
	 *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
	 *     part of the time string, and may show the value differently in the user interface.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
	 *     seconds and milliseconds from the formatted value if they are zero. This option is applied
	 *     after `timeSecondsFormat`.
	 *     This option can be used to make the formatting consistent over different browsers, as some
	 *     browsers with support for `time` will natively hide the milliseconds and
	 *     seconds if they are zero, but others won't, and browsers that don't implement these input
	 *     types will always show the full string.
	 *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 * @element ANY
	 *
	 * @description
	 * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
	 * DOM element, including directives on the element itself that have a lower priority than
	 * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
	 * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
	 * that displays snippets of code, for instance.
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	  <example name="ng-non-bindable">
	    <file name="index.html">
	      <div>Normal: {{1 + 2}}</div>
	      <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	    </file>
	    <file name="protractor.js" type="protractor">
	     it('should check ng-non-bindable', function() {
	       expect(element(by.binding('1 + 2')).getText()).toContain('3');
	       expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	     });
	    </file>
	  </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      // The empty option will be compiled and rendered before we first generate the options
	      selectElement.empty();
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	            selectCtrl.selectUnknownOrEmptyOption(value);
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // The options might not be defined yet when ngModel tries to render
	          if (!options) return;
	
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        selectElement.prepend(selectCtrl.emptyOption);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                var needsRerender = selectCtrl.$isEmptyOptionSelected();
	
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	
	                if (needsRerender) ngModelCtrl.$render();
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // Support: IE 11 only, Edge 12-13 only
	        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * ## Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in AngularJS's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * ## Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * AngularJS expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, AngularJS will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * ## Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRef
	 * @restrict A
	 *
	 * @description
	 * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
	 * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
	 * element to the scope.
	 *
	 * If the element with `ngRef` is destroyed `null` is assigned to the property.
	 *
	 * Note that if you want to assign from a child into the parent scope, you must initialize the
	 * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
	 * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
	 * {@link ngRepeat}. See the second example below.
	 *
	 *
	 * @element ANY
	 * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
	 *                       controller or jqlite-wrapped DOM element will be bound.
	 * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
	 *                            or the special string `$element`. If a name is provided, `ngRef` will
	 *                            assign the matching controller. If `$element` is provided, the element
	 *                            itself is assigned (even if a controller is available).
	 *
	 *
	 * @example
	 * ### Simple toggle
	 * This example shows how the controller of the component toggle
	 * is reused in the template through the scope to use its logic.
	 * <example name="ng-ref-component" module="myApp">
	 *   <file name="index.html">
	 *     <my-toggle ng-ref="myToggle"></my-toggle>
	 *     <button ng-click="myToggle.toggle()">Toggle</button>
	 *     <div ng-show="myToggle.isOpen()">
	 *       You are using a component in the same template to show it.
	 *     </div>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myToggle', {
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should publish the toggle into the scope', function() {
	 *        var toggle = element(by.buttonText('Toggle'));
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
	 *        toggle.click();
	 *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### ngRef inside scopes
	 * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
	 * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
	 * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
	 * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
	 * because the target property has not been initialized on the `myRoot` component controller.
	 *
	 * <example name="ng-ref-scopes" module="myApp">
	 *   <file name="index.html">
	 *     <my-root></my-root>
	 *   </file>
	 *   <file name="index.js">
	 *     angular.module('myApp', [])
	 *     .component('myRoot', {
	 *       templateUrl: 'root.html',
	 *       controller: function() {
	 *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
	 *       }
	 *     })
	 *     .component('myToggle', {
	 *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
	 *       transclude: true,
	 *       controller: function ToggleController() {
	 *         var opened = false;
	 *         this.isOpen = function() { return opened; };
	 *         this.toggle = function() { opened = !opened; };
	 *       }
	 *     })
	 *     .component('myWrapper', {
	 *       transclude: true,
	 *       template: '<strong>myWrapper</strong>' +
	 *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
	 *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
	 *     });
	 *   </file>
	 *   <file name="root.html">
	 *     <strong>myRoot</strong>
	 *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
	 *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     <div><em>wrappers assigned to root</em><br>
	 *     <div ng-repeat="wrapper in $ctrl.wrappers">
	 *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
	 *     </div>
	 *
	 *     <ul>
	 *       <li ng-repeat="(index, value) in [1,2,3]">
	 *         <strong>ngRepeat</strong>
	 *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
	 *       </li>
	 *     </ul>
	 *
	 *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
	 *       assigned to the child scope created by ngIf.
	 *     </div>
	 *     <div ng-if="true">
	          <strong>ngIf</strong>
	 *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
	 *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
	 *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
	 *     </div>
	 *   </file>
	 *   <file name="styles.css">
	 *     ul {
	 *       list-style: none;
	 *       padding-left: 0;
	 *     }
	 *
	 *     li[ng-repeat] {
	 *       background: lightgreen;
	 *       padding: 8px;
	 *       margin: 8px;
	 *     }
	 *
	 *     [ng-if] {
	 *       background: lightgrey;
	 *       padding: 8px;
	 *     }
	 *
	 *     my-root {
	 *       background: lightgoldenrodyellow;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-wrapper {
	 *       background: lightsalmon;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *
	 *     my-toggle {
	 *       background: lightblue;
	 *       padding: 8px;
	 *       display: block;
	 *     }
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      var OuterToggle = function() {
	 *        this.toggle = function() {
	 *          element(by.buttonText('Outer Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
	 *        };
	 *      };
	 *      var NgRepeatToggle = function(i) {
	 *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *      var NgRepeatToggles = function() {
	 *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
	 *        this.forEach = function(fn) {
	 *          toggles.forEach(fn);
	 *        };
	 *        this.isOuterOpen = function(i) {
	 *          return toggles[i - 1].isOuterOpen();
	 *        };
	 *      };
	 *      var NgIfToggle = function() {
	 *        var parent = element(by.css('[ng-if]'));
	 *        this.toggle = function() {
	 *          element(by.buttonText('ngIf Toggle')).click();
	 *        };
	 *        this.isOpen = function() {
	 *          return by.binding('ngIfToggle.isOpen() | json').getText();
	 *        };
	 *        this.isOuterOpen = function() {
	 *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
	 *        };
	 *      };
	 *
	 *      it('should toggle the outer toggle', function() {
	 *        var outerToggle = new OuterToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle all outer toggles', function() {
	 *        var outerToggle = new OuterToggle();
	 *        var repeatToggles = new NgRepeatToggles();
	 *        var ifToggle = new NgIfToggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        outerToggle.toggle();
	 *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
	 *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
	 *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
	 *      });
	 *
	 *      it('should toggle each repeat iteration separately', function() {
	 *        var repeatToggles = new NgRepeatToggles();
	 *
	 *        repeatToggles.forEach(function(repeatToggle) {
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *          repeatToggle.toggle();
	 *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
	 *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
	 *        });
	 *      });
	 *   </file>
	 * </example>
	 *
	 */
	
	var ngRefMinErr = minErr('ngRef');
	
	var ngRefDirective = ['$parse', function($parse) {
	  return {
	    priority: -1, // Needed for compatibility with element transclusion on the same element
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      // Get the expected controller name, converts <data-some-thing> into "someThing"
	      var controllerName = directiveNormalize(nodeName_(tElement));
	
	      // Get the expression for value binding
	      var getter = $parse(tAttrs.ngRef);
	      var setter = getter.assign || function() {
	        throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
	      };
	
	      return function(scope, element, attrs) {
	        var refValue;
	
	        if (attrs.hasOwnProperty('ngRefRead')) {
	          if (attrs.ngRefRead === '$element') {
	            refValue = element;
	          } else {
	            refValue = element.data('$' + attrs.ngRefRead + 'Controller');
	
	            if (!refValue) {
	              throw ngRefMinErr(
	                'noctrl',
	                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
	                attrs.ngRefRead,
	                tAttrs.ngRef
	              );
	            }
	          }
	        } else {
	          refValue = element.data('$' + controllerName + 'Controller');
	        }
	
	        refValue = refValue || element;
	
	        setter(scope, refValue);
	
	        // when the element is removed, remove it (nullify it)
	        element.on('$destroy', function() {
	          // only remove it if value has not changed,
	          // because animations (and other procedures) may duplicate elements
	          if (getter(scope) === refValue) {
	            setter(scope, null);
	          }
	        });
	      };
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * ## Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so AngularJS relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * ## Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * All different types of tracking functions, their syntax, and their support for duplicate
	 * items in collections can be found in the
	 * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** If you are working with objects that have a unique identifier property, you
	 * should track by this identifier instead of the object instance,
	 * e.g. `item in items track by item.id`.
	 * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
	 * it has already rendered, even if the JavaScript objects in the collection have been substituted
	 * for new ones. For large collections, this significantly improves rendering performance.
	 * </div>
	 *
	 * ### Effects of DOM Element re-use
	 *
	 * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
	 * automatically update any active bindings on the template. However, other
	 * functionality will not be updated, because the element is not re-created:
	 *
	 * - Directives are not re-compiled
	 * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
	 * updated if they have stabilized.
	 *
	 * The above affects all kinds of element re-use due to tracking, but may be especially visible
	 * when tracking by `$index` due to the way ngRepeat re-uses elements.
	 *
	 * The following example shows the effects of different actions with tracking:
	
	  <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        var friends = [
	          {name:'John', age:25},
	          {name:'Mary', age:40},
	          {name:'Peter', age:85}
	        ];
	
	        $scope.removeFirst = function() {
	          $scope.friends.shift();
	        };
	
	        $scope.updateAge = function() {
	          $scope.friends.forEach(function(el) {
	            el.age = el.age + 5;
	          });
	        };
	
	        $scope.copy = function() {
	          $scope.friends = angular.copy($scope.friends);
	        };
	
	        $scope.reset = function() {
	          $scope.friends = angular.copy(friends);
	        };
	
	        $scope.reset();
	      });
	    </file>
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        <ol>
	          <li>When you click "Update Age", only the first list updates the age, because all others have
	          a one-time binding on the age property. If you then click "Copy", the current friend list
	          is copied, and now the second list updates the age, because the identity of the collection items
	          has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
	          items are already known according to their tracking functions.
	          </li>
	          <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
	          due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
	          DOM element for the new first collection item, and so on. Since the age property is one-time
	          bound, the value remains from the collection item which was previously at this index.
	          </li>
	        </ol>
	
	        <button ng-click="removeFirst()">Remove First</button>
	        <button ng-click="updateAge()">Update Age</button>
	        <button ng-click="copy()">Copy</button>
	        <br><button ng-click="reset()">Reset List</button>
	        <br>
	        <code>track by $id(friend)</code> (default):
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $id(friend)</code> (default), with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by friend.name</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
	            {{friend.name}}  is {{::friend.age}} years old.
	          </li>
	        </ul>
	        <code>track by $index</code>, with age one-time binding:
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends track by $index">
	            {{friend.name}} is {{::friend.age}} years old.
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	  </example>
	
	 *
	 * ## Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
	 *     This implies that the DOM elements will be associated by item identity in the collection.
	 *
	 *     The built-in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the collection by identity. Moving the same object would move
	 *     the DOM element in the same way in the DOM.
	 *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
	 *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
	 *
	 *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
	 *     id, for example with a function, or using a property on the collection items.
	 *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
	 *     e.g. database id. In this case the object identity does not matter. Two objects are considered
	 *     equivalent as long as their `id` property is same.
	 *     Tracking by unique identifier is the most performant way and should be used whenever possible.
	 *
	 *     *$index*: This special property tracks the collection items by their index, and
	 *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
	 *     be used for a performance improvement if no unique identfier is available and the identity of
	 *     the collection items cannot be easily computed. It also allows duplicates.
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
	 *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
	 *       more info.
	 *     </div>
	 *
	 *     <div class="alert alert-warning">
	 *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
	 *       `item in items | filter:searchText as results  track by item.id`
	 *     </div>
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
	 *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	  var trackByIdArrayFn = function($scope, key, value) {
	    return hashKey(value);
	  };
	
	  var trackByIdObjFn = function($scope, key) {
	    return key;
	  };
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByIdExpFn;
	
	      if (trackByExp) {
	        var hashFnLocals = {$id: hashKey};
	        var trackByExpGetter = $parse(trackByExp);
	
	        trackByIdExpFn = function($scope, key, value, index) {
	          // assign key, value, and $index to the locals so that they can be used in hash functions
	          if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	          hashFnLocals[valueIdentifier] = value;
	          hashFnLocals.$index = index;
	          return trackByExpGetter($scope, hashFnLocals);
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - clone: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn($scope, key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // Clear the value property from the hashFnLocals object to prevent a reference to the last value
	          // being leaked into the ngRepeatCompile function scope
	          if (hashFnLocals) {
	            hashFnLocals[valueIdentifier] = undefined;
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngShow to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * @knownIssue
	 *
	 * ### Flickering when using ngHide to toggle between elements
	 *
	 * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
	 * happen that both the element to show and the element to hide are visible for a very short time.
	 *
	 * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
	 * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
	 * other browsers.
	 *
	 * There are several way to mitigate this problem:
	 *
	 * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
	 * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
	 * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
	 * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
	 * - Define an animation on the affected elements.
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      if (!newStyles) {
	        newStyles = {};
	      }
	      forEach(oldStyles, function(val, style) {
	        if (newStyles[style] == null) {
	          newStyles[style] = '';
	        }
	      });
	    }
	    if (newStyles) element.css(newStyles);
	  });
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value);
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 *
	 * @description
	 * The controller for the {@link ng.select select} directive. The controller exposes
	 * a few utility methods that can be used to augment the behavior of a regular or an
	 * {@link ng.ngOptions ngOptions} select element.
	 *
	 * @example
	 * ### Set a custom error when the unknown option is selected
	 *
	 * This example sets a custom error "unknownValue" on the ngModelController
	 * when the select element's unknown option is selected, i.e. when the model is set to a value
	 * that is not matched by any option.
	 *
	 * <example name="select-unknown-value-error" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Single select: </label><br>
	 *     <select name="testSelect" ng-model="selected" unknown-value-error>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
	 *       Error: The current model doesn't match any option</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueError', function() {
	 *     return {
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
	 *           if (selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return true;
	 *         };
	 *       }
	 *
	 *     };
	 *   });
	 * </file>
	 *</example>
	 *
	 *
	 * @example
	 * ### Set the "required" error when the unknown option is selected.
	 *
	 * By default, the "required" error on the ngModelController is only set on a required select
	 * when the empty option is selected. This example adds a custom directive that also sets the
	 * error when the unknown option is selected.
	 *
	 * <example name="select-unknown-value-required" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="testSelect"> Select: </label><br>
	 *     <select name="testSelect" ng-model="selected" required unknown-value-required>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
	 *
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.selected = null;
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.selected = 'nonsense';
	 *      };
	 *   }])
	 *   .directive('unknownValueRequired', function() {
	 *     return {
	 *       priority: 1, // This directive must run after the required directive has added its validator
	 *       require: ['ngModel', 'select'],
	 *       link: function(scope, element, attrs, ctrls) {
	 *         var ngModelCtrl = ctrls[0];
	 *         var selectCtrl = ctrls[1];
	 *
	 *         var originalRequiredValidator = ngModelCtrl.$validators.required;
	 *
	 *         ngModelCtrl.$validators.required = function() {
	 *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
	 *             return false;
	 *           }
	 *
	 *           return originalRequiredValidator.apply(this, arguments);
	 *         };
	 *       }
	 *     };
	 *   });
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 *  it('should show the error message when the unknown option is selected', function() {
	
	      var error = element(by.className('error'));
	
	      expect(error.getText()).toBe('Error: Please select a value');
	
	      element(by.cssContainingText('option', 'Option 1')).click();
	
	      expect(error.isPresent()).toBe(false);
	
	      element(by.tagName('button')).click();
	
	      expect(error.getText()).toBe('Error: Please select a value');
	    });
	 * </file>
	 *</example>
	 *
	 *
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // Support: IE 9 only
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that the application developer can
	  // provide inside the select. It is always selectable and indicates that a "null" selection has
	  // been made by the user.
	  // If the select has an empty option, and the model of the select is set to "undefined" or "null",
	  // the empty option is selected.
	  // If the model is set to a different unmatched value, the unknown option is rendered and
	  // selected, i.e both are present, because a "null" selection and an unknown value are different.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      setOptionSelectedStatus(self.emptyOption, false);
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      self.selectUnknownOrEmptyOption(value);
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$hasEmptyOption
	   *
	   * @description
	   *
	   * Returns `true` if the select element currently has an empty option
	   * element, i.e. an option that signifies that the select is empty / the selection is null.
	   *
	   */
	  self.$hasEmptyOption = function() {
	    return self.hasEmptyOption;
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isUnknownOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element's unknown option is selected. The unknown option is added
	   * and automatically selected whenever the select model doesn't match any option.
	   *
	   */
	  self.$isUnknownOptionSelected = function() {
	    // Presence of the unknown option means it is selected
	    return $element[0].options[0] === self.unknownOption[0];
	  };
	
	  /**
	   * @ngdoc method
	   * @name select.SelectController#$isEmptyOptionSelected
	   *
	   * @description
	   *
	   * Returns `true` if the select element has an empty option and this empty option is currently
	   * selected. Returns `false` if the select element has no empty option or it is not selected.
	   *
	   */
	  self.$isEmptyOptionSelected = function() {
	    return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
	  };
	
	  self.selectUnknownOrEmptyOption = function(value) {
	    if (value == null && self.emptyOption) {
	      self.removeUnknownOption();
	      self.selectEmptyOption();
	    } else if (self.unknownOption.parent().length) {
	      self.updateUnknownOption(value);
	    } else {
	      self.renderUnknownOption(value);
	    }
	  };
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with AngularJS data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * The {@link select.SelectController select controller} exposes utility functions that can be used
	 * to manipulate the select's behavior.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * @example
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // Support: IE 9-11 only, Edge 12-15+
	            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if necessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
	 *                                `required` attribute to the element and adds the `required`
	 *                                {@link ngModel.NgModelController#$validators `validator`}.
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the AngularJS expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      // For boolean attributes like required, presence means true
	      var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
	
	      if (!attr.ngRequired) {
	        // force truthy in case we are on non input element
	        // (input elements do this automatically for boolean attributes like required)
	        attr.required = true;
	      }
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !value || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function(newVal) {
	
	        if (value !== newVal) {
	          value = newVal;
	          ctrl.$validate();
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 * @restrict A
	 *
	 * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
	 *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
	 *                                      more details.
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained from the `ngPattern` attribute value:
	 * - the value is an AngularJS expression:
	 *   - If the expression evaluates to a RegExp object, then this is used directly.
	 *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    compile: function(tElm, tAttr) {
	      var patternExp;
	      var parseFn;
	
	      if (tAttr.ngPattern) {
	        patternExp = tAttr.ngPattern;
	
	        // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
	        // We get value of the attribute here, so we can compare the old and the new value
	        // in the observer to avoid unnecessary validations
	        if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
	          parseFn = function() { return tAttr.ngPattern; };
	        } else {
	          parseFn = $parse(tAttr.ngPattern);
	        }
	      }
	
	      return function(scope, elm, attr, ctrl) {
	        if (!ctrl) return;
	
	        var attrVal = attr.pattern;
	
	        if (attr.ngPattern) {
	          attrVal = parseFn(scope);
	        } else {
	          patternExp = attr.pattern;
	        }
	
	        var regexp = parsePatternAttr(attrVal, patternExp, elm);
	
	        attr.$observe('pattern', function(newVal) {
	          var oldRegexp = regexp;
	
	          regexp = parsePatternAttr(newVal, patternExp, elm);
	
	          if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
	            ctrl.$validate();
	          }
	        });
	
	        ctrl.$validators.pattern = function(modelValue, viewValue) {
	          // HTML5 pattern constraint validates the input value, so we validate the viewValue
	          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	        };
	      };
	    }
	
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 * @restrict A
	 *
	 * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `maxlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
	      var maxlengthParsed = parseLength(maxlength);
	
	      attr.$observe('maxlength', function(value) {
	        if (maxlength !== value) {
	          maxlengthParsed = parseLength(value);
	          maxlength = value;
	          ctrl.$validate();
	        }
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlengthParsed < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlengthParsed);
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 * @restrict A
	 *
	 * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
	 *                                 parsable into a `Number`. Used as value for the `minlength`
	 *                                 {@link ngModel.NgModelController#$validators validator}.
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the AngularJS expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = ['$parse', function($parse) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
	      var minlengthParsed = parseLength(minlength) || -1;
	
	      attr.$observe('minlength', function(value) {
	        if (minlength !== value) {
	          minlengthParsed = parseLength(value) || -1;
	          minlength = value;
	          ctrl.$validate();
	        }
	
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
	      };
	    }
	  };
	}];
	
	
	function parsePatternAttr(regex, patternExp, elm) {
	  if (!regex) return undefined;
	
	  if (isString(regex)) {
	    regex = new RegExp('^' + regex + '$');
	  }
	
	  if (!regex.test) {
	    throw minErr('ngPattern')('noregexp',
	      'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	      regex, startingTag(elm));
	  }
	
	  return regex;
	}
	
	function parseLength(val) {
	  var intVal = toInt(val);
	  return isNumberNaN(intVal) ? -1 : intVal;
	}
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load AngularJS more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(372);
	module.exports = 'ngAnimate';


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.7.8
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	var ELEMENT_NODE = 1;
	var COMMENT_NODE = 8;
	
	var ADD_CLASS_SUFFIX = '-add';
	var REMOVE_CLASS_SUFFIX = '-remove';
	var EVENT_CLASS_PREFIX = 'ng-';
	var ACTIVE_CLASS_SUFFIX = '-active';
	var PREPARE_CLASS_SUFFIX = '-prepare';
	
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';
	
	// Detect proper transitionend/animationend event names.
	var CSS_PREFIX = '', TRANSITION_PROP, TRANSITIONEND_EVENT, ANIMATION_PROP, ANIMATIONEND_EVENT;
	
	// If unprefixed events are not supported but webkit-prefixed are, use the latter.
	// Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
	// Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
	// but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
	// Register both events in case `window.onanimationend` is not supported because of that,
	// do the same for `transitionend` as Safari is likely to exhibit similar behavior.
	// Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
	// therefore there is no reason to test anymore for other vendor prefixes:
	// http://caniuse.com/#search=transition
	if ((window.ontransitionend === undefined) && (window.onwebkittransitionend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  TRANSITION_PROP = 'WebkitTransition';
	  TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
	} else {
	  TRANSITION_PROP = 'transition';
	  TRANSITIONEND_EVENT = 'transitionend';
	}
	
	if ((window.onanimationend === undefined) && (window.onwebkitanimationend !== undefined)) {
	  CSS_PREFIX = '-webkit-';
	  ANIMATION_PROP = 'WebkitAnimation';
	  ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
	} else {
	  ANIMATION_PROP = 'animation';
	  ANIMATIONEND_EVENT = 'animationend';
	}
	
	var DURATION_KEY = 'Duration';
	var PROPERTY_KEY = 'Property';
	var DELAY_KEY = 'Delay';
	var TIMING_KEY = 'TimingFunction';
	var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
	var ANIMATION_PLAYSTATE_KEY = 'PlayState';
	var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
	
	var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
	var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
	var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
	var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
	
	var ngMinErr = angular.$$minErr('ng');
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function packageStyles(options) {
	  var styles = {};
	  if (options && (options.to || options.from)) {
	    styles.to = options.to;
	    styles.from = options.from;
	  }
	  return styles;
	}
	
	function pendClasses(classes, fix, isPrefix) {
	  var className = '';
	  classes = isArray(classes)
	      ? classes
	      : classes && isString(classes) && classes.length
	          ? classes.split(/\s+/)
	          : [];
	  forEach(classes, function(klass, i) {
	    if (klass && klass.length > 0) {
	      className += (i > 0) ? ' ' : '';
	      className += isPrefix ? fix + klass
	                            : klass + fix;
	    }
	  });
	  return className;
	}
	
	function removeFromArray(arr, val) {
	  var index = arr.indexOf(val);
	  if (val >= 0) {
	    arr.splice(index, 1);
	  }
	}
	
	function stripCommentsFromElement(element) {
	  if (element instanceof jqLite) {
	    switch (element.length) {
	      case 0:
	        return element;
	
	      case 1:
	        // there is no point of stripping anything if the element
	        // is the only element within the jqLite wrapper.
	        // (it's important that we retain the element instance.)
	        if (element[0].nodeType === ELEMENT_NODE) {
	          return element;
	        }
	        break;
	
	      default:
	        return jqLite(extractElementNode(element));
	    }
	  }
	
	  if (element.nodeType === ELEMENT_NODE) {
	    return jqLite(element);
	  }
	}
	
	function extractElementNode(element) {
	  if (!element[0]) return element;
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function $$addClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.addClass(elm, className);
	  });
	}
	
	function $$removeClass($$jqLite, element, className) {
	  forEach(element, function(elm) {
	    $$jqLite.removeClass(elm, className);
	  });
	}
	
	function applyAnimationClassesFactory($$jqLite) {
	  return function(element, options) {
	    if (options.addClass) {
	      $$addClass($$jqLite, element, options.addClass);
	      options.addClass = null;
	    }
	    if (options.removeClass) {
	      $$removeClass($$jqLite, element, options.removeClass);
	      options.removeClass = null;
	    }
	  };
	}
	
	function prepareAnimationOptions(options) {
	  options = options || {};
	  if (!options.$$prepared) {
	    var domOperation = options.domOperation || noop;
	    options.domOperation = function() {
	      options.$$domOperationFired = true;
	      domOperation();
	      domOperation = noop;
	    };
	    options.$$prepared = true;
	  }
	  return options;
	}
	
	function applyAnimationStyles(element, options) {
	  applyAnimationFromStyles(element, options);
	  applyAnimationToStyles(element, options);
	}
	
	function applyAnimationFromStyles(element, options) {
	  if (options.from) {
	    element.css(options.from);
	    options.from = null;
	  }
	}
	
	function applyAnimationToStyles(element, options) {
	  if (options.to) {
	    element.css(options.to);
	    options.to = null;
	  }
	}
	
	function mergeAnimationDetails(element, oldAnimation, newAnimation) {
	  var target = oldAnimation.options || {};
	  var newOptions = newAnimation.options || {};
	
	  var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
	  var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
	  var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
	
	  if (newOptions.preparationClasses) {
	    target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
	    delete newOptions.preparationClasses;
	  }
	
	  // noop is basically when there is no callback; otherwise something has been set
	  var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
	
	  extend(target, newOptions);
	
	  // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
	  if (realDomOperation) {
	    target.domOperation = realDomOperation;
	  }
	
	  if (classes.addClass) {
	    target.addClass = classes.addClass;
	  } else {
	    target.addClass = null;
	  }
	
	  if (classes.removeClass) {
	    target.removeClass = classes.removeClass;
	  } else {
	    target.removeClass = null;
	  }
	
	  oldAnimation.addClass = target.addClass;
	  oldAnimation.removeClass = target.removeClass;
	
	  return target;
	}
	
	function resolveElementClasses(existing, toAdd, toRemove) {
	  var ADD_CLASS = 1;
	  var REMOVE_CLASS = -1;
	
	  var flags = {};
	  existing = splitClassesToLookup(existing);
	
	  toAdd = splitClassesToLookup(toAdd);
	  forEach(toAdd, function(value, key) {
	    flags[key] = ADD_CLASS;
	  });
	
	  toRemove = splitClassesToLookup(toRemove);
	  forEach(toRemove, function(value, key) {
	    flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
	  });
	
	  var classes = {
	    addClass: '',
	    removeClass: ''
	  };
	
	  forEach(flags, function(val, klass) {
	    var prop, allow;
	    if (val === ADD_CLASS) {
	      prop = 'addClass';
	      allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
	    } else if (val === REMOVE_CLASS) {
	      prop = 'removeClass';
	      allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
	    }
	    if (allow) {
	      if (classes[prop].length) {
	        classes[prop] += ' ';
	      }
	      classes[prop] += klass;
	    }
	  });
	
	  function splitClassesToLookup(classes) {
	    if (isString(classes)) {
	      classes = classes.split(' ');
	    }
	
	    var obj = {};
	    forEach(classes, function(klass) {
	      // sometimes the split leaves empty string values
	      // incase extra spaces were applied to the options
	      if (klass.length) {
	        obj[klass] = true;
	      }
	    });
	    return obj;
	  }
	
	  return classes;
	}
	
	function getDomNode(element) {
	  return (element instanceof jqLite) ? element[0] : element;
	}
	
	function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
	  var classes = '';
	  if (event) {
	    classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
	  }
	  if (options.addClass) {
	    classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
	  }
	  if (options.removeClass) {
	    classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
	  }
	  if (classes.length) {
	    options.preparationClasses = classes;
	    element.addClass(classes);
	  }
	}
	
	function clearGeneratedClasses(element, options) {
	  if (options.preparationClasses) {
	    element.removeClass(options.preparationClasses);
	    options.preparationClasses = null;
	  }
	  if (options.activeClasses) {
	    element.removeClass(options.activeClasses);
	    options.activeClasses = null;
	  }
	}
	
	function blockKeyframeAnimations(node, applyBlock) {
	  var value = applyBlock ? 'paused' : '';
	  var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
	  applyInlineStyle(node, [key, value]);
	  return [key, value];
	}
	
	function applyInlineStyle(node, styleTuple) {
	  var prop = styleTuple[0];
	  var value = styleTuple[1];
	  node.style[prop] = value;
	}
	
	function concatWithSpace(a,b) {
	  if (!a) return b;
	  if (!b) return a;
	  return a + ' ' + b;
	}
	
	var helpers = {
	  blockTransitions: function(node, duration) {
	    // we use a negative delay value since it performs blocking
	    // yet it doesn't kill any existing transitions running on the
	    // same element which makes this safe for class-based animations
	    var value = duration ? '-' + duration + 's' : '';
	    applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
	    return [TRANSITION_DELAY_PROP, value];
	  }
	};
	
	var $$rAFSchedulerFactory = ['$$rAF', function($$rAF) {
	  var queue, cancelFn;
	
	  function scheduler(tasks) {
	    // we make a copy since RAFScheduler mutates the state
	    // of the passed in array variable and this would be difficult
	    // to track down on the outside code
	    queue = queue.concat(tasks);
	    nextTick();
	  }
	
	  queue = scheduler.queue = [];
	
	  /* waitUntilQuiet does two things:
	   * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
	   * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
	   *
	   * The motivation here is that animation code can request more time from the scheduler
	   * before the next wave runs. This allows for certain DOM properties such as classes to
	   * be resolved in time for the next animation to run.
	   */
	  scheduler.waitUntilQuiet = function(fn) {
	    if (cancelFn) cancelFn();
	
	    cancelFn = $$rAF(function() {
	      cancelFn = null;
	      fn();
	      nextTick();
	    });
	  };
	
	  return scheduler;
	
	  function nextTick() {
	    if (!queue.length) return;
	
	    var items = queue.shift();
	    for (var i = 0; i < items.length; i++) {
	      items[i]();
	    }
	
	    if (!cancelFn) {
	      $$rAF(function() {
	        if (!cancelFn) nextTick();
	      });
	    }
	  }
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateChildren
	 * @restrict AE
	 * @element ANY
	 *
	 * @description
	 *
	 * ngAnimateChildren allows you to specify that children of this element should animate even if any
	 * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
	 * (structural) animation, child elements that also have an active structural animation are not animated.
	 *
	 * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
	 *
	 *
	 * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
	 *     then child animations are allowed. If the value is `false`, child animations are not allowed.
	 *
	 * @example
	 * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
	     <file name="index.html">
	       <div ng-controller="MainController as main">
	         <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
	         <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
	         <hr>
	         <div ng-animate-children="{{main.animateChildren}}">
	           <div ng-if="main.enterElement" class="container">
	             List of items:
	             <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
	           </div>
	         </div>
	       </div>
	     </file>
	     <file name="animations.css">
	
	      .container.ng-enter,
	      .container.ng-leave {
	        transition: all ease 1.5s;
	      }
	
	      .container.ng-enter,
	      .container.ng-leave-active {
	        opacity: 0;
	      }
	
	      .container.ng-leave,
	      .container.ng-enter-active {
	        opacity: 1;
	      }
	
	      .item {
	        background: firebrick;
	        color: #FFF;
	        margin-bottom: 10px;
	      }
	
	      .item.ng-enter,
	      .item.ng-leave {
	        transition: transform 1.5s ease;
	      }
	
	      .item.ng-enter {
	        transform: translateX(50px);
	      }
	
	      .item.ng-enter-active {
	        transform: translateX(0);
	      }
	    </file>
	    <file name="script.js">
	      angular.module('ngAnimateChildren', ['ngAnimate'])
	        .controller('MainController', function MainController() {
	          this.animateChildren = false;
	          this.enterElement = false;
	        });
	    </file>
	  </example>
	 */
	var $$AnimateChildrenDirective = ['$interpolate', function($interpolate) {
	  return {
	    link: function(scope, element, attrs) {
	      var val = attrs.ngAnimateChildren;
	      if (isString(val) && val.length === 0) { //empty attribute
	        element.data(NG_ANIMATE_CHILDREN_DATA, true);
	      } else {
	        // Interpolate and set the value, so that it is available to
	        // animations that run right after compilation
	        setData($interpolate(val)(scope));
	        attrs.$observe('ngAnimateChildren', setData);
	      }
	
	      function setData(value) {
	        value = value === 'on' || value === 'true';
	        element.data(NG_ANIMATE_CHILDREN_DATA, value);
	      }
	    }
	  };
	}];
	
	/* exported $AnimateCssProvider */
	
	var ANIMATE_TIMER_KEY = '$$animateCss';
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 *
	 * @description
	 * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
	 * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
	 * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
	 * directives to create more complex animations that can be purely driven using CSS code.
	 *
	 * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
	 * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
	 *
	 * ## General Use
	 * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
	 * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
	 * any automatic control over cancelling animations and/or preventing animations from being run on
	 * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
	 * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
	 * the CSS animation.
	 *
	 * The example below shows how we can create a folding animation on an element using `ng-if`:
	 *
	 * ```html
	 * <!-- notice the `fold-animation` CSS class -->
	 * <div ng-if="onOff" class="fold-animation">
	 *   This element will go BOOM
	 * </div>
	 * <button ng-click="onOff=true">Fold In</button>
	 * ```
	 *
	 * Now we create the **JavaScript animation** that will trigger the CSS transition:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## More Advanced Uses
	 *
	 * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
	 * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
	 *
	 * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
	 * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
	 * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
	 * to provide a working animation that will run in CSS.
	 *
	 * The example below showcases a more advanced version of the `.fold-animation` from the example above:
	 *
	 * ```js
	 * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       var height = element[0].offsetHeight;
	 *       return $animateCss(element, {
	 *         addClass: 'red large-text pulse-twice',
	 *         easing: 'ease-out',
	 *         from: { height:'0px' },
	 *         to: { height:height + 'px' },
	 *         duration: 1 // one second
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
	 *
	 * ```css
	 * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
	 * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
	 * .red { background:red; }
	 * .large-text { font-size:20px; }
	 *
	 * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
	 * .pulse-twice {
	 *   animation: 0.5s pulse linear 2;
	 *   -webkit-animation: 0.5s pulse linear 2;
	 * }
	 *
	 * @keyframes pulse {
	 *   from { transform: scale(0.5); }
	 *   to { transform: scale(1.5); }
	 * }
	 *
	 * @-webkit-keyframes pulse {
	 *   from { -webkit-transform: scale(0.5); }
	 *   to { -webkit-transform: scale(1.5); }
	 * }
	 * ```
	 *
	 * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
	 *
	 * ## How the Options are handled
	 *
	 * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
	 * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
	 * styles using the `from` and `to` properties.
	 *
	 * ```js
	 * var animator = $animateCss(element, {
	 *   from: { background:'red' },
	 *   to: { background:'blue' }
	 * });
	 * animator.start();
	 * ```
	 *
	 * ```css
	 * .rotating-animation {
	 *   animation:0.5s rotate linear;
	 *   -webkit-animation:0.5s rotate linear;
	 * }
	 *
	 * @keyframes rotate {
	 *   from { transform: rotate(0deg); }
	 *   to { transform: rotate(360deg); }
	 * }
	 *
	 * @-webkit-keyframes rotate {
	 *   from { -webkit-transform: rotate(0deg); }
	 *   to { -webkit-transform: rotate(360deg); }
	 * }
	 * ```
	 *
	 * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
	 * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
	 * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
	 * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
	 * and spread across the transition and keyframe animation.
	 *
	 * ## What is returned
	 *
	 * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
	 * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
	 * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
	 *
	 * ```js
	 * var animator = $animateCss(element, { ... });
	 * ```
	 *
	 * Now what do the contents of our `animator` variable look like:
	 *
	 * ```js
	 * {
	 *   // starts the animation
	 *   start: Function,
	 *
	 *   // ends (aborts) the animation
	 *   end: Function
	 * }
	 * ```
	 *
	 * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
	 * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
	 * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
	 * and that changing them will not reconfigure the parameters of the animation.
	 *
	 * ### runner.done() vs runner.then()
	 * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
	 * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
	 * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
	 * unless you really need a digest to kick off afterwards.
	 *
	 * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
	 * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
	 * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
	 *
	 * @param {DOMElement} element the element that will be animated
	 * @param {object} options the animation-related options that will be applied during the animation
	 *
	 * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
	 * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
	 * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
	 * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
	 * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
	 * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
	 * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
	 * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
	 * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
	 * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
	 * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
	 * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
	 * is provided then the animation will be skipped entirely.
	 * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
	 * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
	 * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
	 * CSS delay value.
	 * * `stagger` - A numeric time value representing the delay between successively animated elements
	 * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
	 * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
	 *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
	 * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
	 * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
	 *    the animation is closed. This is useful for when the styles are used purely for the sake of
	 *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
	 *    By default this value is set to `false`.
	 *
	 * @return {object} an object with start and end methods and details about the animation.
	 *
	 * * `start` - The method to start the animation. This will return a `Promise` when called.
	 * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
	 */
	var ONE_SECOND = 1000;
	
	var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
	var CLOSING_TIME_BUFFER = 1.5;
	
	var DETECT_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  transitionProperty:      TRANSITION_PROP + PROPERTY_KEY,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP,
	  animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
	};
	
	var DETECT_STAGGER_CSS_PROPERTIES = {
	  transitionDuration:      TRANSITION_DURATION_PROP,
	  transitionDelay:         TRANSITION_DELAY_PROP,
	  animationDuration:       ANIMATION_DURATION_PROP,
	  animationDelay:          ANIMATION_DELAY_PROP
	};
	
	function getCssKeyframeDurationStyle(duration) {
	  return [ANIMATION_DURATION_PROP, duration + 's'];
	}
	
	function getCssDelayStyle(delay, isKeyframeAnimation) {
	  var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
	  return [prop, delay + 's'];
	}
	
	function computeCssStyles($window, element, properties) {
	  var styles = Object.create(null);
	  var detectedStyles = $window.getComputedStyle(element) || {};
	  forEach(properties, function(formalStyleName, actualStyleName) {
	    var val = detectedStyles[formalStyleName];
	    if (val) {
	      var c = val.charAt(0);
	
	      // only numerical-based values have a negative sign or digit as the first value
	      if (c === '-' || c === '+' || c >= 0) {
	        val = parseMaxTime(val);
	      }
	
	      // by setting this to null in the event that the delay is not set or is set directly as 0
	      // then we can still allow for negative values to be used later on and not mistake this
	      // value for being greater than any other negative value.
	      if (val === 0) {
	        val = null;
	      }
	      styles[actualStyleName] = val;
	    }
	  });
	
	  return styles;
	}
	
	function parseMaxTime(str) {
	  var maxValue = 0;
	  var values = str.split(/\s*,\s*/);
	  forEach(values, function(value) {
	    // it's always safe to consider only second values and omit `ms` values since
	    // getComputedStyle will always handle the conversion for us
	    if (value.charAt(value.length - 1) === 's') {
	      value = value.substring(0, value.length - 1);
	    }
	    value = parseFloat(value) || 0;
	    maxValue = maxValue ? Math.max(value, maxValue) : value;
	  });
	  return maxValue;
	}
	
	function truthyTimingValue(val) {
	  return val === 0 || val != null;
	}
	
	function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
	  var style = TRANSITION_PROP;
	  var value = duration + 's';
	  if (applyOnlyDuration) {
	    style += DURATION_KEY;
	  } else {
	    value += ' linear all';
	  }
	  return [style, value];
	}
	
	// we do not reassign an already present style value since
	// if we detect the style property value again we may be
	// detecting styles that were added via the `from` styles.
	// We make use of `isDefined` here since an empty string
	// or null value (which is what getPropertyValue will return
	// for a non-existing style) will still be marked as a valid
	// value for the style (a falsy value implies that the style
	// is to be removed at the end of the animation). If we had a simple
	// "OR" statement then it would not be enough to catch that.
	function registerRestorableStyles(backup, node, properties) {
	  forEach(properties, function(prop) {
	    backup[prop] = isDefined(backup[prop])
	        ? backup[prop]
	        : node.style.getPropertyValue(prop);
	  });
	}
	
	var $AnimateCssProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	
	  this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache',
	               '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue',
	       function($window,   $$jqLite,   $$AnimateRunner,   $timeout,   $$animateCache,
	                $$forceReflow,   $sniffer,   $$rAFScheduler, $$animateQueue) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
	      var timings = $$animateCache.get(cacheKey);
	
	      if (!timings) {
	        timings = computeCssStyles($window, node, properties);
	        if (timings.animationIterationCount === 'infinite') {
	          timings.animationIterationCount = 1;
	        }
	      }
	
	      // if a css animation has no duration we
	      // should mark that so that repeated addClass/removeClass calls are skipped
	      var hasDuration = allowNoDuration || (timings.transitionDuration > 0 || timings.animationDuration > 0);
	
	      // we keep putting this in multiple times even though the value and the cacheKey are the same
	      // because we're keeping an internal tally of how many duplicate animations are detected.
	      $$animateCache.put(cacheKey, timings, hasDuration);
	
	      return timings;
	    }
	
	    function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
	      var stagger;
	      var staggerCacheKey = 'stagger-' + cacheKey;
	
	      // if we have one or more existing matches of matching elements
	      // containing the same parent + CSS styles (which is how cacheKey works)
	      // then staggering is possible
	      if ($$animateCache.count(cacheKey) > 0) {
	        stagger = $$animateCache.get(staggerCacheKey);
	
	        if (!stagger) {
	          var staggerClassName = pendClasses(className, '-stagger');
	
	          $$jqLite.addClass(node, staggerClassName);
	
	          stagger = computeCssStyles($window, node, properties);
	
	          // force the conversion of a null value to zero incase not set
	          stagger.animationDuration = Math.max(stagger.animationDuration, 0);
	          stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
	
	          $$jqLite.removeClass(node, staggerClassName);
	
	          $$animateCache.put(staggerCacheKey, stagger, true);
	        }
	      }
	
	      return stagger || {};
	    }
	
	    var rafWaitQueue = [];
	    function waitUntilQuiet(callback) {
	      rafWaitQueue.push(callback);
	      $$rAFScheduler.waitUntilQuiet(function() {
	        $$animateCache.flush();
	
	        // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
	        // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
	        var pageWidth = $$forceReflow();
	
	        // we use a for loop to ensure that if the queue is changed
	        // during this looping then it will consider new requests
	        for (var i = 0; i < rafWaitQueue.length; i++) {
	          rafWaitQueue[i](pageWidth);
	        }
	        rafWaitQueue.length = 0;
	      });
	    }
	
	    function computeTimings(node, className, cacheKey, allowNoDuration) {
	      var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
	      var aD = timings.animationDelay;
	      var tD = timings.transitionDelay;
	      timings.maxDelay = aD && tD
	          ? Math.max(aD, tD)
	          : (aD || tD);
	      timings.maxDuration = Math.max(
	          timings.animationDuration * timings.animationIterationCount,
	          timings.transitionDuration);
	
	      return timings;
	    }
	
	    return function init(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = prepareAnimationOptions(copy(options));
	      }
	
	      var restoreStyles = {};
	      var node = getDomNode(element);
	      if (!node
	          || !node.parentNode
	          || !$$animateQueue.enabled()) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var temporaryStyles = [];
	      var classes = element.attr('class');
	      var styles = packageStyles(options);
	      var animationClosed;
	      var animationPaused;
	      var animationCompleted;
	      var runner;
	      var runnerHost;
	      var maxDelay;
	      var maxDelayTime;
	      var maxDuration;
	      var maxDurationTime;
	      var startTime;
	      var events = [];
	
	      if (options.duration === 0 || (!$sniffer.animations && !$sniffer.transitions)) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var method = options.event && isArray(options.event)
	            ? options.event.join(' ')
	            : options.event;
	
	      var isStructural = method && options.structural;
	      var structuralClassName = '';
	      var addRemoveClassName = '';
	
	      if (isStructural) {
	        structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
	      } else if (method) {
	        structuralClassName = method;
	      }
	
	      if (options.addClass) {
	        addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
	      }
	
	      if (options.removeClass) {
	        if (addRemoveClassName.length) {
	          addRemoveClassName += ' ';
	        }
	        addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
	      }
	
	      // there may be a situation where a structural animation is combined together
	      // with CSS classes that need to resolve before the animation is computed.
	      // However this means that there is no explicit CSS code to block the animation
	      // from happening (by setting 0s none in the class name). If this is the case
	      // we need to apply the classes before the first rAF so we know to continue if
	      // there actually is a detected transition or keyframe animation
	      if (options.applyClassesEarly && addRemoveClassName.length) {
	        applyAnimationClasses(element, options);
	      }
	
	      var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
	      var fullClassName = classes + ' ' + preparationClasses;
	      var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
	      var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;
	
	      // there is no way we can trigger an animation if no styles and
	      // no classes are being applied which would then trigger a transition,
	      // unless there a is raw keyframe value that is applied to the element.
	      if (!containsKeyframeAnimation
	           && !hasToStyles
	           && !preparationClasses) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var stagger, cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
	      if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
	        preparationClasses = null;
	        return closeAndReturnNoopAnimator();
	      }
	
	      if (options.stagger > 0) {
	        var staggerVal = parseFloat(options.stagger);
	        stagger = {
	          transitionDelay: staggerVal,
	          animationDelay: staggerVal,
	          transitionDuration: 0,
	          animationDuration: 0
	        };
	      } else {
	        stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
	      }
	
	      if (!options.$$skipPreparationClasses) {
	        $$jqLite.addClass(element, preparationClasses);
	      }
	
	      var applyOnlyDuration;
	
	      if (options.transitionStyle) {
	        var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
	        applyInlineStyle(node, transitionStyle);
	        temporaryStyles.push(transitionStyle);
	      }
	
	      if (options.duration >= 0) {
	        applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
	        var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);
	
	        // we set the duration so that it will be picked up by getComputedStyle later
	        applyInlineStyle(node, durationStyle);
	        temporaryStyles.push(durationStyle);
	      }
	
	      if (options.keyframeStyle) {
	        var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
	        applyInlineStyle(node, keyframeStyle);
	        temporaryStyles.push(keyframeStyle);
	      }
	
	      var itemIndex = stagger
	          ? options.staggerIndex >= 0
	              ? options.staggerIndex
	              : $$animateCache.count(cacheKey)
	          : 0;
	
	      var isFirst = itemIndex === 0;
	
	      // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
	      // without causing any combination of transitions to kick in. By adding a negative delay value
	      // it forces the setup class' transition to end immediately. We later then remove the negative
	      // transition delay to allow for the transition to naturally do it's thing. The beauty here is
	      // that if there is no transition defined then nothing will happen and this will also allow
	      // other transitions to be stacked on top of each other without any chopping them out.
	      if (isFirst && !options.skipBlocking) {
	        helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
	      }
	
	      var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
	      var relativeDelay = timings.maxDelay;
	      maxDelay = Math.max(relativeDelay, 0);
	      maxDuration = timings.maxDuration;
	
	      var flags = {};
	      flags.hasTransitions          = timings.transitionDuration > 0;
	      flags.hasAnimations           = timings.animationDuration > 0;
	      flags.hasTransitionAll        = flags.hasTransitions && timings.transitionProperty === 'all';
	      flags.applyTransitionDuration = hasToStyles && (
	                                        (flags.hasTransitions && !flags.hasTransitionAll)
	                                         || (flags.hasAnimations && !flags.hasTransitions));
	      flags.applyAnimationDuration  = options.duration && flags.hasAnimations;
	      flags.applyTransitionDelay    = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
	      flags.applyAnimationDelay     = truthyTimingValue(options.delay) && flags.hasAnimations;
	      flags.recalculateTimingStyles = addRemoveClassName.length > 0;
	
	      if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
	        maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
	
	        if (flags.applyTransitionDuration) {
	          flags.hasTransitions = true;
	          timings.transitionDuration = maxDuration;
	          applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
	          temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
	        }
	
	        if (flags.applyAnimationDuration) {
	          flags.hasAnimations = true;
	          timings.animationDuration = maxDuration;
	          temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
	        }
	      }
	
	      if (maxDuration === 0 && !flags.recalculateTimingStyles) {
	        return closeAndReturnNoopAnimator();
	      }
	
	      var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
	
	      if (options.delay != null) {
	        var delayStyle;
	        if (typeof options.delay !== 'boolean') {
	          delayStyle = parseFloat(options.delay);
	          // number in options.delay means we have to recalculate the delay for the closing timeout
	          maxDelay = Math.max(delayStyle, 0);
	        }
	
	        if (flags.applyTransitionDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle));
	        }
	
	        if (flags.applyAnimationDelay) {
	          temporaryStyles.push(getCssDelayStyle(delayStyle, true));
	        }
	      }
	
	      // we need to recalculate the delay value since we used a pre-emptive negative
	      // delay value and the delay value is required for the final event checking. This
	      // property will ensure that this will happen after the RAF phase has passed.
	      if (options.duration == null && timings.transitionDuration > 0) {
	        flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
	      }
	
	      maxDelayTime = maxDelay * ONE_SECOND;
	      maxDurationTime = maxDuration * ONE_SECOND;
	      if (!options.skipBlocking) {
	        flags.blockTransition = timings.transitionDuration > 0;
	        flags.blockKeyframeAnimation = timings.animationDuration > 0 &&
	                                       stagger.animationDelay > 0 &&
	                                       stagger.animationDuration === 0;
	      }
	
	      if (options.from) {
	        if (options.cleanupStyles) {
	          registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
	        }
	        applyAnimationFromStyles(element, options);
	      }
	
	      if (flags.blockTransition || flags.blockKeyframeAnimation) {
	        applyBlocking(maxDuration);
	      } else if (!options.skipBlocking) {
	        helpers.blockTransitions(node, false);
	      }
	
	      // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
	      return {
	        $$willAnimate: true,
	        end: endFn,
	        start: function() {
	          if (animationClosed) return;
	
	          runnerHost = {
	            end: endFn,
	            cancel: cancelFn,
	            resume: null, //this will be set during the start() phase
	            pause: null
	          };
	
	          runner = new $$AnimateRunner(runnerHost);
	
	          waitUntilQuiet(start);
	
	          // we don't have access to pause/resume the animation
	          // since it hasn't run yet. AnimateRunner will therefore
	          // set noop functions for resume and pause and they will
	          // later be overridden once the animation is triggered
	          return runner;
	        }
	      };
	
	      function endFn() {
	        close();
	      }
	
	      function cancelFn() {
	        close(true);
	      }
	
	      function close(rejected) {
	        // if the promise has been called already then we shouldn't close
	        // the animation again
	        if (animationClosed || (animationCompleted && animationPaused)) return;
	        animationClosed = true;
	        animationPaused = false;
	
	        if (preparationClasses && !options.$$skipPreparationClasses) {
	          $$jqLite.removeClass(element, preparationClasses);
	        }
	
	        if (activeClasses) {
	          $$jqLite.removeClass(element, activeClasses);
	        }
	
	        blockKeyframeAnimations(node, false);
	        helpers.blockTransitions(node, false);
	
	        forEach(temporaryStyles, function(entry) {
	          // There is only one way to remove inline style properties entirely from elements.
	          // By using `removeProperty` this works, but we need to convert camel-cased CSS
	          // styles down to hyphenated values.
	          node.style[entry[0]] = '';
	        });
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	
	        if (Object.keys(restoreStyles).length) {
	          forEach(restoreStyles, function(value, prop) {
	            if (value) {
	              node.style.setProperty(prop, value);
	            } else {
	              node.style.removeProperty(prop);
	            }
	          });
	        }
	
	        // the reason why we have this option is to allow a synchronous closing callback
	        // that is fired as SOON as the animation ends (when the CSS is removed) or if
	        // the animation never takes off at all. A good example is a leave animation since
	        // the element must be removed just after the animation is over or else the element
	        // will appear on screen for one animation frame causing an overbearing flicker.
	        if (options.onDone) {
	          options.onDone();
	        }
	
	        if (events && events.length) {
	          // Remove the transitionend / animationend listener(s)
	          element.off(events.join(' '), onAnimationProgress);
	        }
	
	        //Cancel the fallback closing timeout and remove the timer data
	        var animationTimerData = element.data(ANIMATE_TIMER_KEY);
	        if (animationTimerData) {
	          $timeout.cancel(animationTimerData[0].timer);
	          element.removeData(ANIMATE_TIMER_KEY);
	        }
	
	        // if the preparation function fails then the promise is not setup
	        if (runner) {
	          runner.complete(!rejected);
	        }
	      }
	
	      function applyBlocking(duration) {
	        if (flags.blockTransition) {
	          helpers.blockTransitions(node, duration);
	        }
	
	        if (flags.blockKeyframeAnimation) {
	          blockKeyframeAnimations(node, !!duration);
	        }
	      }
	
	      function closeAndReturnNoopAnimator() {
	        runner = new $$AnimateRunner({
	          end: endFn,
	          cancel: cancelFn
	        });
	
	        // should flush the cache animation
	        waitUntilQuiet(noop);
	        close();
	
	        return {
	          $$willAnimate: false,
	          start: function() {
	            return runner;
	          },
	          end: endFn
	        };
	      }
	
	      function onAnimationProgress(event) {
	        event.stopPropagation();
	        var ev = event.originalEvent || event;
	
	        if (ev.target !== node) {
	          // Since TransitionEvent / AnimationEvent bubble up,
	          // we have to ignore events by finished child animations
	          return;
	        }
	
	        // we now always use `Date.now()` due to the recent changes with
	        // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
	        var timeStamp = ev.$manualTimeStamp || Date.now();
	
	        /* Firefox (or possibly just Gecko) likes to not round values up
	         * when a ms measurement is used for the animation */
	        var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));
	
	        /* $manualTimeStamp is a mocked timeStamp value which is set
	         * within browserTrigger(). This is only here so that tests can
	         * mock animations properly. Real events fallback to event.timeStamp,
	         * or, if they don't, then a timeStamp is automatically created for them.
	         * We're checking to see if the timeStamp surpasses the expected delay,
	         * but we're using elapsedTime instead of the timeStamp on the 2nd
	         * pre-condition since animationPauseds sometimes close off early */
	        if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
	          // we set this flag to ensure that if the transition is paused then, when resumed,
	          // the animation will automatically close itself since transitions cannot be paused.
	          animationCompleted = true;
	          close();
	        }
	      }
	
	      function start() {
	        if (animationClosed) return;
	        if (!node.parentNode) {
	          close();
	          return;
	        }
	
	        // even though we only pause keyframe animations here the pause flag
	        // will still happen when transitions are used. Only the transition will
	        // not be paused since that is not possible. If the animation ends when
	        // paused then it will not complete until unpaused or cancelled.
	        var playPause = function(playAnimation) {
	          if (!animationCompleted) {
	            animationPaused = !playAnimation;
	            if (timings.animationDuration) {
	              var value = blockKeyframeAnimations(node, animationPaused);
	              if (animationPaused) {
	                temporaryStyles.push(value);
	              } else {
	                removeFromArray(temporaryStyles, value);
	              }
	            }
	          } else if (animationPaused && playAnimation) {
	            animationPaused = false;
	            close();
	          }
	        };
	
	        // checking the stagger duration prevents an accidentally cascade of the CSS delay style
	        // being inherited from the parent. If the transition duration is zero then we can safely
	        // rely that the delay value is an intentional stagger delay style.
	        var maxStagger = itemIndex > 0
	                         && ((timings.transitionDuration && stagger.transitionDuration === 0) ||
	                            (timings.animationDuration && stagger.animationDuration === 0))
	                         && Math.max(stagger.animationDelay, stagger.transitionDelay);
	        if (maxStagger) {
	          $timeout(triggerAnimationStart,
	                   Math.floor(maxStagger * itemIndex * ONE_SECOND),
	                   false);
	        } else {
	          triggerAnimationStart();
	        }
	
	        // this will decorate the existing promise runner with pause/resume methods
	        runnerHost.resume = function() {
	          playPause(true);
	        };
	
	        runnerHost.pause = function() {
	          playPause(false);
	        };
	
	        function triggerAnimationStart() {
	          // just incase a stagger animation kicks in when the animation
	          // itself was cancelled entirely
	          if (animationClosed) return;
	
	          applyBlocking(false);
	
	          forEach(temporaryStyles, function(entry) {
	            var key = entry[0];
	            var value = entry[1];
	            node.style[key] = value;
	          });
	
	          applyAnimationClasses(element, options);
	          $$jqLite.addClass(element, activeClasses);
	
	          if (flags.recalculateTimingStyles) {
	            fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
	            cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
	
	            timings = computeTimings(node, fullClassName, cacheKey, false);
	            relativeDelay = timings.maxDelay;
	            maxDelay = Math.max(relativeDelay, 0);
	            maxDuration = timings.maxDuration;
	
	            if (maxDuration === 0) {
	              close();
	              return;
	            }
	
	            flags.hasTransitions = timings.transitionDuration > 0;
	            flags.hasAnimations = timings.animationDuration > 0;
	          }
	
	          if (flags.applyAnimationDelay) {
	            relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay)
	                  ? parseFloat(options.delay)
	                  : relativeDelay;
	
	            maxDelay = Math.max(relativeDelay, 0);
	            timings.animationDelay = relativeDelay;
	            delayStyle = getCssDelayStyle(relativeDelay, true);
	            temporaryStyles.push(delayStyle);
	            node.style[delayStyle[0]] = delayStyle[1];
	          }
	
	          maxDelayTime = maxDelay * ONE_SECOND;
	          maxDurationTime = maxDuration * ONE_SECOND;
	
	          if (options.easing) {
	            var easeProp, easeVal = options.easing;
	            if (flags.hasTransitions) {
	              easeProp = TRANSITION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	            if (flags.hasAnimations) {
	              easeProp = ANIMATION_PROP + TIMING_KEY;
	              temporaryStyles.push([easeProp, easeVal]);
	              node.style[easeProp] = easeVal;
	            }
	          }
	
	          if (timings.transitionDuration) {
	            events.push(TRANSITIONEND_EVENT);
	          }
	
	          if (timings.animationDuration) {
	            events.push(ANIMATIONEND_EVENT);
	          }
	
	          startTime = Date.now();
	          var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
	          var endTime = startTime + timerTime;
	
	          var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
	          var setupFallbackTimer = true;
	          if (animationsData.length) {
	            var currentTimerData = animationsData[0];
	            setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
	            if (setupFallbackTimer) {
	              $timeout.cancel(currentTimerData.timer);
	            } else {
	              animationsData.push(close);
	            }
	          }
	
	          if (setupFallbackTimer) {
	            var timer = $timeout(onAnimationExpired, timerTime, false);
	            animationsData[0] = {
	              timer: timer,
	              expectedEndTime: endTime
	            };
	            animationsData.push(close);
	            element.data(ANIMATE_TIMER_KEY, animationsData);
	          }
	
	          if (events.length) {
	            element.on(events.join(' '), onAnimationProgress);
	          }
	
	          if (options.to) {
	            if (options.cleanupStyles) {
	              registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
	            }
	            applyAnimationToStyles(element, options);
	          }
	        }
	
	        function onAnimationExpired() {
	          var animationsData = element.data(ANIMATE_TIMER_KEY);
	
	          // this will be false in the event that the element was
	          // removed from the DOM (via a leave animation or something
	          // similar)
	          if (animationsData) {
	            for (var i = 1; i < animationsData.length; i++) {
	              animationsData[i]();
	            }
	            element.removeData(ANIMATE_TIMER_KEY);
	          }
	        }
	      }
	    };
	  }];
	}];
	
	var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateCssDriver');
	
	  var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
	  var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
	
	  var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
	  var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
	
	  function isDocumentFragment(node) {
	    return node.parentNode && node.parentNode.nodeType === 11;
	  }
	
	  this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document',
	       function($animateCss,   $rootScope,   $$AnimateRunner,   $rootElement,   $sniffer,   $$jqLite,   $document) {
	
	    // only browsers that support these properties can render animations
	    if (!$sniffer.animations && !$sniffer.transitions) return noop;
	
	    var bodyNode = $document[0].body;
	    var rootNode = getDomNode($rootElement);
	
	    var rootBodyElement = jqLite(
	      // this is to avoid using something that exists outside of the body
	      // we also special case the doc fragment case because our unit test code
	      // appends the $rootElement to the body after the app has been bootstrapped
	      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode
	    );
	
	    return function initDriverFn(animationDetails) {
	      return animationDetails.from && animationDetails.to
	          ? prepareFromToAnchorAnimation(animationDetails.from,
	                                         animationDetails.to,
	                                         animationDetails.classes,
	                                         animationDetails.anchors)
	          : prepareRegularAnimation(animationDetails);
	    };
	
	    function filterCssClasses(classes) {
	      //remove all the `ng-` stuff
	      return classes.replace(/\bng-\S+\b/g, '');
	    }
	
	    function getUniqueValues(a, b) {
	      if (isString(a)) a = a.split(' ');
	      if (isString(b)) b = b.split(' ');
	      return a.filter(function(val) {
	        return b.indexOf(val) === -1;
	      }).join(' ');
	    }
	
	    function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
	      var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
	      var startingClasses = filterCssClasses(getClassVal(clone));
	
	      outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
	
	      clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
	
	      rootBodyElement.append(clone);
	
	      var animatorIn, animatorOut = prepareOutAnimation();
	
	      // the user may not end up using the `out` animation and
	      // only making use of the `in` animation or vice-versa.
	      // In either case we should allow this and not assume the
	      // animation is over unless both animations are not used.
	      if (!animatorOut) {
	        animatorIn = prepareInAnimation();
	        if (!animatorIn) {
	          return end();
	        }
	      }
	
	      var startingAnimator = animatorOut || animatorIn;
	
	      return {
	        start: function() {
	          var runner;
	
	          var currentAnimation = startingAnimator.start();
	          currentAnimation.done(function() {
	            currentAnimation = null;
	            if (!animatorIn) {
	              animatorIn = prepareInAnimation();
	              if (animatorIn) {
	                currentAnimation = animatorIn.start();
	                currentAnimation.done(function() {
	                  currentAnimation = null;
	                  end();
	                  runner.complete();
	                });
	                return currentAnimation;
	              }
	            }
	            // in the event that there is no `in` animation
	            end();
	            runner.complete();
	          });
	
	          runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn
	          });
	
	          return runner;
	
	          function endFn() {
	            if (currentAnimation) {
	              currentAnimation.end();
	            }
	          }
	        }
	      };
	
	      function calculateAnchorStyles(anchor) {
	        var styles = {};
	
	        var coords = getDomNode(anchor).getBoundingClientRect();
	
	        // we iterate directly since safari messes up and doesn't return
	        // all the keys for the coords object when iterated
	        forEach(['width','height','top','left'], function(key) {
	          var value = coords[key];
	          switch (key) {
	            case 'top':
	              value += bodyNode.scrollTop;
	              break;
	            case 'left':
	              value += bodyNode.scrollLeft;
	              break;
	          }
	          styles[key] = Math.floor(value) + 'px';
	        });
	        return styles;
	      }
	
	      function prepareOutAnimation() {
	        var animator = $animateCss(clone, {
	          addClass: NG_OUT_ANCHOR_CLASS_NAME,
	          delay: true,
	          from: calculateAnchorStyles(outAnchor)
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function getClassVal(element) {
	        return element.attr('class') || '';
	      }
	
	      function prepareInAnimation() {
	        var endingClasses = filterCssClasses(getClassVal(inAnchor));
	        var toAdd = getUniqueValues(endingClasses, startingClasses);
	        var toRemove = getUniqueValues(startingClasses, endingClasses);
	
	        var animator = $animateCss(clone, {
	          to: calculateAnchorStyles(inAnchor),
	          addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
	          removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
	          delay: true
	        });
	
	        // read the comment within `prepareRegularAnimation` to understand
	        // why this check is necessary
	        return animator.$$willAnimate ? animator : null;
	      }
	
	      function end() {
	        clone.remove();
	        outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	        inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
	      }
	    }
	
	    function prepareFromToAnchorAnimation(from, to, classes, anchors) {
	      var fromAnimation = prepareRegularAnimation(from, noop);
	      var toAnimation = prepareRegularAnimation(to, noop);
	
	      var anchorAnimations = [];
	      forEach(anchors, function(anchor) {
	        var outElement = anchor['out'];
	        var inElement = anchor['in'];
	        var animator = prepareAnchoredAnimation(classes, outElement, inElement);
	        if (animator) {
	          anchorAnimations.push(animator);
	        }
	      });
	
	      // no point in doing anything when there are no elements to animate
	      if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
	
	      return {
	        start: function() {
	          var animationRunners = [];
	
	          if (fromAnimation) {
	            animationRunners.push(fromAnimation.start());
	          }
	
	          if (toAnimation) {
	            animationRunners.push(toAnimation.start());
	          }
	
	          forEach(anchorAnimations, function(animation) {
	            animationRunners.push(animation.start());
	          });
	
	          var runner = new $$AnimateRunner({
	            end: endFn,
	            cancel: endFn // CSS-driven animations cannot be cancelled, only ended
	          });
	
	          $$AnimateRunner.all(animationRunners, function(status) {
	            runner.complete(status);
	          });
	
	          return runner;
	
	          function endFn() {
	            forEach(animationRunners, function(runner) {
	              runner.end();
	            });
	          }
	        }
	      };
	    }
	
	    function prepareRegularAnimation(animationDetails) {
	      var element = animationDetails.element;
	      var options = animationDetails.options || {};
	
	      if (animationDetails.structural) {
	        options.event = animationDetails.event;
	        options.structural = true;
	        options.applyClassesEarly = true;
	
	        // we special case the leave animation since we want to ensure that
	        // the element is removed as soon as the animation is over. Otherwise
	        // a flicker might appear or the element may not be removed at all
	        if (animationDetails.event === 'leave') {
	          options.onDone = options.domOperation;
	        }
	      }
	
	      // We assign the preparationClasses as the actual animation event since
	      // the internals of $animateCss will just suffix the event token values
	      // with `-active` to trigger the animation.
	      if (options.preparationClasses) {
	        options.event = concatWithSpace(options.event, options.preparationClasses);
	      }
	
	      var animator = $animateCss(element, options);
	
	      // the driver lookup code inside of $$animation attempts to spawn a
	      // driver one by one until a driver returns a.$$willAnimate animator object.
	      // $animateCss will always return an object, however, it will pass in
	      // a flag as a hint as to whether an animation was detected or not
	      return animator.$$willAnimate ? animator : null;
	    }
	  }];
	}];
	
	// TODO(matsko): use caching here to speed things up for detection
	// TODO(matsko): add documentation
	//  by the time...
	
	var $$AnimateJsProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  this.$get = ['$injector', '$$AnimateRunner', '$$jqLite',
	       function($injector,   $$AnimateRunner,   $$jqLite) {
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	         // $animateJs(element, 'enter');
	    return function(element, event, classes, options) {
	      var animationClosed = false;
	
	      // the `classes` argument is optional and if it is not used
	      // then the classes will be resolved from the element's className
	      // property as well as options.addClass/options.removeClass.
	      if (arguments.length === 3 && isObject(classes)) {
	        options = classes;
	        classes = null;
	      }
	
	      options = prepareAnimationOptions(options);
	      if (!classes) {
	        classes = element.attr('class') || '';
	        if (options.addClass) {
	          classes += ' ' + options.addClass;
	        }
	        if (options.removeClass) {
	          classes += ' ' + options.removeClass;
	        }
	      }
	
	      var classesToAdd = options.addClass;
	      var classesToRemove = options.removeClass;
	
	      // the lookupAnimations function returns a series of animation objects that are
	      // matched up with one or more of the CSS classes. These animation objects are
	      // defined via the module.animation factory function. If nothing is detected then
	      // we don't return anything which then makes $animation query the next driver.
	      var animations = lookupAnimations(classes);
	      var before, after;
	      if (animations.length) {
	        var afterFn, beforeFn;
	        if (event === 'leave') {
	          beforeFn = 'leave';
	          afterFn = 'afterLeave'; // TODO(matsko): get rid of this
	        } else {
	          beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
	          afterFn = event;
	        }
	
	        if (event !== 'enter' && event !== 'move') {
	          before = packageAnimations(element, event, options, animations, beforeFn);
	        }
	        after  = packageAnimations(element, event, options, animations, afterFn);
	      }
	
	      // no matching animations
	      if (!before && !after) return;
	
	      function applyOptions() {
	        options.domOperation();
	        applyAnimationClasses(element, options);
	      }
	
	      function close() {
	        animationClosed = true;
	        applyOptions();
	        applyAnimationStyles(element, options);
	      }
	
	      var runner;
	
	      return {
	        $$willAnimate: true,
	        end: function() {
	          if (runner) {
	            runner.end();
	          } else {
	            close();
	            runner = new $$AnimateRunner();
	            runner.complete(true);
	          }
	          return runner;
	        },
	        start: function() {
	          if (runner) {
	            return runner;
	          }
	
	          runner = new $$AnimateRunner();
	          var closeActiveAnimations;
	          var chain = [];
	
	          if (before) {
	            chain.push(function(fn) {
	              closeActiveAnimations = before(fn);
	            });
	          }
	
	          if (chain.length) {
	            chain.push(function(fn) {
	              applyOptions();
	              fn(true);
	            });
	          } else {
	            applyOptions();
	          }
	
	          if (after) {
	            chain.push(function(fn) {
	              closeActiveAnimations = after(fn);
	            });
	          }
	
	          runner.setHost({
	            end: function() {
	              endAnimations();
	            },
	            cancel: function() {
	              endAnimations(true);
	            }
	          });
	
	          $$AnimateRunner.chain(chain, onComplete);
	          return runner;
	
	          function onComplete(success) {
	            close(success);
	            runner.complete(success);
	          }
	
	          function endAnimations(cancelled) {
	            if (!animationClosed) {
	              (closeActiveAnimations || noop)(cancelled);
	              onComplete(cancelled);
	            }
	          }
	        }
	      };
	
	      function executeAnimationFn(fn, element, event, options, onDone) {
	        var args;
	        switch (event) {
	          case 'animate':
	            args = [element, options.from, options.to, onDone];
	            break;
	
	          case 'setClass':
	            args = [element, classesToAdd, classesToRemove, onDone];
	            break;
	
	          case 'addClass':
	            args = [element, classesToAdd, onDone];
	            break;
	
	          case 'removeClass':
	            args = [element, classesToRemove, onDone];
	            break;
	
	          default:
	            args = [element, onDone];
	            break;
	        }
	
	        args.push(options);
	
	        var value = fn.apply(fn, args);
	        if (value) {
	          if (isFunction(value.start)) {
	            value = value.start();
	          }
	
	          if (value instanceof $$AnimateRunner) {
	            value.done(onDone);
	          } else if (isFunction(value)) {
	            // optional onEnd / onCancel callback
	            return value;
	          }
	        }
	
	        return noop;
	      }
	
	      function groupEventedAnimations(element, event, options, animations, fnName) {
	        var operations = [];
	        forEach(animations, function(ani) {
	          var animation = ani[fnName];
	          if (!animation) return;
	
	          // note that all of these animations will run in parallel
	          operations.push(function() {
	            var runner;
	            var endProgressCb;
	
	            var resolved = false;
	            var onAnimationComplete = function(rejected) {
	              if (!resolved) {
	                resolved = true;
	                (endProgressCb || noop)(rejected);
	                runner.complete(!rejected);
	              }
	            };
	
	            runner = new $$AnimateRunner({
	              end: function() {
	                onAnimationComplete();
	              },
	              cancel: function() {
	                onAnimationComplete(true);
	              }
	            });
	
	            endProgressCb = executeAnimationFn(animation, element, event, options, function(result) {
	              var cancelled = result === false;
	              onAnimationComplete(cancelled);
	            });
	
	            return runner;
	          });
	        });
	
	        return operations;
	      }
	
	      function packageAnimations(element, event, options, animations, fnName) {
	        var operations = groupEventedAnimations(element, event, options, animations, fnName);
	        if (operations.length === 0) {
	          var a, b;
	          if (fnName === 'beforeSetClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
	          } else if (fnName === 'setClass') {
	            a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
	            b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
	          }
	
	          if (a) {
	            operations = operations.concat(a);
	          }
	          if (b) {
	            operations = operations.concat(b);
	          }
	        }
	
	        if (operations.length === 0) return;
	
	        // TODO(matsko): add documentation
	        return function startAnimation(callback) {
	          var runners = [];
	          if (operations.length) {
	            forEach(operations, function(animateFn) {
	              runners.push(animateFn());
	            });
	          }
	
	          if (runners.length) {
	            $$AnimateRunner.all(runners, callback);
	          }  else {
	            callback();
	          }
	
	          return function endFn(reject) {
	            forEach(runners, function(runner) {
	              if (reject) {
	                runner.cancel();
	              } else {
	                runner.end();
	              }
	            });
	          };
	        };
	      }
	    };
	
	    function lookupAnimations(classes) {
	      classes = isArray(classes) ? classes : classes.split(' ');
	      var matches = [], flagMap = {};
	      for (var i = 0; i < classes.length; i++) {
	        var klass = classes[i],
	            animationFactory = $animateProvider.$$registeredAnimations[klass];
	        if (animationFactory && !flagMap[klass]) {
	          matches.push($injector.get(animationFactory));
	          flagMap[klass] = true;
	        }
	      }
	      return matches;
	    }
	  }];
	}];
	
	var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */ function($$animationProvider) {
	  $$animationProvider.drivers.push('$$animateJsDriver');
	  this.$get = ['$$animateJs', '$$AnimateRunner', function($$animateJs, $$AnimateRunner) {
	    return function initDriverFn(animationDetails) {
	      if (animationDetails.from && animationDetails.to) {
	        var fromAnimation = prepareAnimation(animationDetails.from);
	        var toAnimation = prepareAnimation(animationDetails.to);
	        if (!fromAnimation && !toAnimation) return;
	
	        return {
	          start: function() {
	            var animationRunners = [];
	
	            if (fromAnimation) {
	              animationRunners.push(fromAnimation.start());
	            }
	
	            if (toAnimation) {
	              animationRunners.push(toAnimation.start());
	            }
	
	            $$AnimateRunner.all(animationRunners, done);
	
	            var runner = new $$AnimateRunner({
	              end: endFnFactory(),
	              cancel: endFnFactory()
	            });
	
	            return runner;
	
	            function endFnFactory() {
	              return function() {
	                forEach(animationRunners, function(runner) {
	                  // at this point we cannot cancel animations for groups just yet. 1.5+
	                  runner.end();
	                });
	              };
	            }
	
	            function done(status) {
	              runner.complete(status);
	            }
	          }
	        };
	      } else {
	        return prepareAnimation(animationDetails);
	      }
	    };
	
	    function prepareAnimation(animationDetails) {
	      // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
	      var element = animationDetails.element;
	      var event = animationDetails.event;
	      var options = animationDetails.options;
	      var classes = animationDetails.classes;
	      return $$animateJs(element, event, classes, options);
	    }
	  }];
	}];
	
	var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
	var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
	var $$AnimateQueueProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var PRE_DIGEST_STATE = 1;
	  var RUNNING_STATE = 2;
	  var ONE_SPACE = ' ';
	
	  var rules = this.rules = {
	    skip: [],
	    cancel: [],
	    join: []
	  };
	
	  function getEventData(options) {
	    return {
	      addClass: options.addClass,
	      removeClass: options.removeClass,
	      from: options.from,
	      to: options.to
	    };
	  }
	
	  function makeTruthyCssClassMap(classString) {
	    if (!classString) {
	      return null;
	    }
	
	    var keys = classString.split(ONE_SPACE);
	    var map = Object.create(null);
	
	    forEach(keys, function(key) {
	      map[key] = true;
	    });
	    return map;
	  }
	
	  function hasMatchingClasses(newClassString, currentClassString) {
	    if (newClassString && currentClassString) {
	      var currentClassMap = makeTruthyCssClassMap(currentClassString);
	      return newClassString.split(ONE_SPACE).some(function(className) {
	        return currentClassMap[className];
	      });
	    }
	  }
	
	  function isAllowed(ruleType, currentAnimation, previousAnimation) {
	    return rules[ruleType].some(function(fn) {
	      return fn(currentAnimation, previousAnimation);
	    });
	  }
	
	  function hasAnimationClasses(animation, and) {
	    var a = (animation.addClass || '').length > 0;
	    var b = (animation.removeClass || '').length > 0;
	    return and ? a && b : a || b;
	  }
	
	  rules.join.push(function(newAnimation, currentAnimation) {
	    // if the new animation is class-based then we can just tack that on
	    return !newAnimation.structural && hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // there is no need to animate anything if no classes are being added and
	    // there is no structural animation that will be triggered
	    return !newAnimation.structural && !hasAnimationClasses(newAnimation);
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // why should we trigger a new structural animation if the element will
	    // be removed from the DOM anyway?
	    return currentAnimation.event === 'leave' && newAnimation.structural;
	  });
	
	  rules.skip.push(function(newAnimation, currentAnimation) {
	    // if there is an ongoing current animation then don't even bother running the class-based animation
	    return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // there can never be two structural animations running at the same time
	    return currentAnimation.structural && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // if the previous animation is already running, but the new animation will
	    // be triggered, but the new animation is structural
	    return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
	  });
	
	  rules.cancel.push(function(newAnimation, currentAnimation) {
	    // cancel the animation if classes added / removed in both animation cancel each other out,
	    // but only if the current animation isn't structural
	
	    if (currentAnimation.structural) return false;
	
	    var nA = newAnimation.addClass;
	    var nR = newAnimation.removeClass;
	    var cA = currentAnimation.addClass;
	    var cR = currentAnimation.removeClass;
	
	    // early detection to save the global CPU shortage :)
	    if ((isUndefined(nA) && isUndefined(nR)) || (isUndefined(cA) && isUndefined(cR))) {
	      return false;
	    }
	
	    return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
	  });
	
	  this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map',
	               '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow',
	               '$$isDocumentHidden',
	       function($$rAF,   $rootScope,   $rootElement,   $document,   $$Map,
	                $$animation,   $$AnimateRunner,   $templateRequest,   $$jqLite,   $$forceReflow,
	                $$isDocumentHidden) {
	
	    var activeAnimationsLookup = new $$Map();
	    var disabledElementsLookup = new $$Map();
	    var animationsEnabled = null;
	
	    function removeFromDisabledElementsLookup(evt) {
	      disabledElementsLookup.delete(evt.target);
	    }
	
	    function postDigestTaskFactory() {
	      var postDigestCalled = false;
	      return function(fn) {
	        // we only issue a call to postDigest before
	        // it has first passed. This prevents any callbacks
	        // from not firing once the animation has completed
	        // since it will be out of the digest cycle.
	        if (postDigestCalled) {
	          fn();
	        } else {
	          $rootScope.$$postDigest(function() {
	            postDigestCalled = true;
	            fn();
	          });
	        }
	      };
	    }
	
	    // Wait until all directive and route-related templates are downloaded and
	    // compiled. The $templateRequest.totalPendingRequests variable keeps track of
	    // all of the remote templates being currently downloaded. If there are no
	    // templates currently downloading then the watcher will still fire anyway.
	    var deregisterWatch = $rootScope.$watch(
	      function() { return $templateRequest.totalPendingRequests === 0; },
	      function(isEmpty) {
	        if (!isEmpty) return;
	        deregisterWatch();
	
	        // Now that all templates have been downloaded, $animate will wait until
	        // the post digest queue is empty before enabling animations. By having two
	        // calls to $postDigest calls we can ensure that the flag is enabled at the
	        // very end of the post digest queue. Since all of the animations in $animate
	        // use $postDigest, it's important that the code below executes at the end.
	        // This basically means that the page is fully downloaded and compiled before
	        // any animations are triggered.
	        $rootScope.$$postDigest(function() {
	          $rootScope.$$postDigest(function() {
	            // we check for null directly in the event that the application already called
	            // .enabled() with whatever arguments that it provided it with
	            if (animationsEnabled === null) {
	              animationsEnabled = true;
	            }
	          });
	        });
	      }
	    );
	
	    var callbackRegistry = Object.create(null);
	
	    // remember that the `customFilter`/`classNameFilter` are set during the
	    // provider/config stage therefore we can optimize here and setup helper functions
	    var customFilter = $animateProvider.customFilter();
	    var classNameFilter = $animateProvider.classNameFilter();
	    var returnTrue = function() { return true; };
	
	    var isAnimatableByFilter = customFilter || returnTrue;
	    var isAnimatableClassName = !classNameFilter ? returnTrue : function(node, options) {
	      var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
	      return classNameFilter.test(className);
	    };
	
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function normalizeAnimationDetails(element, animation) {
	      return mergeAnimationDetails(element, animation, {});
	    }
	
	    // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	    var contains = window.Node.prototype.contains || /** @this */ function(arg) {
	      // eslint-disable-next-line no-bitwise
	      return this === arg || !!(this.compareDocumentPosition(arg) & 16);
	    };
	
	    function findCallbacks(targetParentNode, targetNode, event) {
	      var matches = [];
	      var entries = callbackRegistry[event];
	      if (entries) {
	        forEach(entries, function(entry) {
	          if (contains.call(entry.node, targetNode)) {
	            matches.push(entry.callback);
	          } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
	            matches.push(entry.callback);
	          }
	        });
	      }
	
	      return matches;
	    }
	
	    function filterFromRegistry(list, matchContainer, matchCallback) {
	      var containerNode = extractElementNode(matchContainer);
	      return list.filter(function(entry) {
	        var isMatch = entry.node === containerNode &&
	                        (!matchCallback || entry.callback === matchCallback);
	        return !isMatch;
	      });
	    }
	
	    function cleanupEventListeners(phase, node) {
	      if (phase === 'close' && !node.parentNode) {
	        // If the element is not attached to a parentNode, it has been removed by
	        // the domOperation, and we can safely remove the event callbacks
	        $animate.off(node);
	      }
	    }
	
	    var $animate = {
	      on: function(event, container, callback) {
	        var node = extractElementNode(container);
	        callbackRegistry[event] = callbackRegistry[event] || [];
	        callbackRegistry[event].push({
	          node: node,
	          callback: callback
	        });
	
	        // Remove the callback when the element is removed from the DOM
	        jqLite(container).on('$destroy', function() {
	          var animationDetails = activeAnimationsLookup.get(node);
	
	          if (!animationDetails) {
	            // If there's an animation ongoing, the callback calling code will remove
	            // the event listeners. If we'd remove here, the callbacks would be removed
	            // before the animation ends
	            $animate.off(event, container, callback);
	          }
	        });
	      },
	
	      off: function(event, container, callback) {
	        if (arguments.length === 1 && !isString(arguments[0])) {
	          container = arguments[0];
	          for (var eventType in callbackRegistry) {
	            callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
	          }
	
	          return;
	        }
	
	        var entries = callbackRegistry[event];
	        if (!entries) return;
	
	        callbackRegistry[event] = arguments.length === 1
	            ? null
	            : filterFromRegistry(entries, container, callback);
	      },
	
	      pin: function(element, parentElement) {
	        assertArg(isElement(element), 'element', 'not an element');
	        assertArg(isElement(parentElement), 'parentElement', 'not an element');
	        element.data(NG_ANIMATE_PIN_DATA, parentElement);
	      },
	
	      push: function(element, event, options, domOperation) {
	        options = options || {};
	        options.domOperation = domOperation;
	        return queueAnimation(element, event, options);
	      },
	
	      // this method has four signatures:
	      //  () - global getter
	      //  (bool) - global setter
	      //  (element) - element getter
	      //  (element, bool) - element setter<F37>
	      enabled: function(element, bool) {
	        var argCount = arguments.length;
	
	        if (argCount === 0) {
	          // () - Global getter
	          bool = !!animationsEnabled;
	        } else {
	          var hasElement = isElement(element);
	
	          if (!hasElement) {
	            // (bool) - Global setter
	            bool = animationsEnabled = !!element;
	          } else {
	            var node = getDomNode(element);
	
	            if (argCount === 1) {
	              // (element) - Element getter
	              bool = !disabledElementsLookup.get(node);
	            } else {
	              // (element, bool) - Element setter
	              if (!disabledElementsLookup.has(node)) {
	                // The element is added to the map for the first time.
	                // Create a listener to remove it on `$destroy` (to avoid memory leak).
	                jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
	              }
	              disabledElementsLookup.set(node, !bool);
	            }
	          }
	        }
	
	        return bool;
	      }
	    };
	
	    return $animate;
	
	    function queueAnimation(originalElement, event, initialOptions) {
	      // we always make a copy of the options since
	      // there should never be any side effects on
	      // the input data when running `$animateCss`.
	      var options = copy(initialOptions);
	
	      var element = stripCommentsFromElement(originalElement);
	      var node = getDomNode(element);
	      var parentNode = node && node.parentNode;
	
	      options = prepareAnimationOptions(options);
	
	      // we create a fake runner with a working promise.
	      // These methods will become available after the digest has passed
	      var runner = new $$AnimateRunner();
	
	      // this is used to trigger callbacks in postDigest mode
	      var runInNextPostDigestOrNow = postDigestTaskFactory();
	
	      if (isArray(options.addClass)) {
	        options.addClass = options.addClass.join(' ');
	      }
	
	      if (options.addClass && !isString(options.addClass)) {
	        options.addClass = null;
	      }
	
	      if (isArray(options.removeClass)) {
	        options.removeClass = options.removeClass.join(' ');
	      }
	
	      if (options.removeClass && !isString(options.removeClass)) {
	        options.removeClass = null;
	      }
	
	      if (options.from && !isObject(options.from)) {
	        options.from = null;
	      }
	
	      if (options.to && !isObject(options.to)) {
	        options.to = null;
	      }
	
	      // If animations are hard-disabled for the whole application there is no need to continue.
	      // There are also situations where a directive issues an animation for a jqLite wrapper that
	      // contains only comment nodes. In this case, there is no way we can perform an animation.
	      if (!animationsEnabled ||
	          !node ||
	          !isAnimatableByFilter(node, event, initialOptions) ||
	          !isAnimatableClassName(node, options)) {
	        close();
	        return runner;
	      }
	
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      var documentHidden = $$isDocumentHidden();
	
	      // This is a hard disable of all animations the element itself, therefore  there is no need to
	      // continue further past this point if not enabled
	      // Animations are also disabled if the document is currently hidden (page is not visible
	      // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
	      var skipAnimations = documentHidden || disabledElementsLookup.get(node);
	      var existingAnimation = (!skipAnimations && activeAnimationsLookup.get(node)) || {};
	      var hasExistingAnimation = !!existingAnimation.state;
	
	      // there is no point in traversing the same collection of parent ancestors if a followup
	      // animation will be run on the same element that already did all that checking work
	      if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
	        skipAnimations = !areAnimationsAllowed(node, parentNode, event);
	      }
	
	      if (skipAnimations) {
	        // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
	        if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
	        close();
	        if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
	        return runner;
	      }
	
	      if (isStructural) {
	        closeChildAnimations(node);
	      }
	
	      var newAnimation = {
	        structural: isStructural,
	        element: element,
	        event: event,
	        addClass: options.addClass,
	        removeClass: options.removeClass,
	        close: close,
	        options: options,
	        runner: runner
	      };
	
	      if (hasExistingAnimation) {
	        var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
	        if (skipAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            close();
	            return runner;
	          } else {
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	            return existingAnimation.runner;
	          }
	        }
	        var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
	        if (cancelAnimationFlag) {
	          if (existingAnimation.state === RUNNING_STATE) {
	            // this will end the animation right away and it is safe
	            // to do so since the animation is already running and the
	            // runner callback code will run in async
	            existingAnimation.runner.end();
	          } else if (existingAnimation.structural) {
	            // this means that the animation is queued into a digest, but
	            // hasn't started yet. Therefore it is safe to run the close
	            // method which will call the runner methods in async.
	            existingAnimation.close();
	          } else {
	            // this will merge the new animation options into existing animation options
	            mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	            return existingAnimation.runner;
	          }
	        } else {
	          // a joined animation means that this animation will take over the existing one
	          // so an example would involve a leave animation taking over an enter. Then when
	          // the postDigest kicks in the enter will be ignored.
	          var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
	          if (joinAnimationFlag) {
	            if (existingAnimation.state === RUNNING_STATE) {
	              normalizeAnimationDetails(element, newAnimation);
	            } else {
	              applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);
	
	              event = newAnimation.event = existingAnimation.event;
	              options = mergeAnimationDetails(element, existingAnimation, newAnimation);
	
	              //we return the same runner since only the option values of this animation will
	              //be fed into the `existingAnimation`.
	              return existingAnimation.runner;
	            }
	          }
	        }
	      } else {
	        // normalization in this case means that it removes redundant CSS classes that
	        // already exist (addClass) or do not exist (removeClass) on the element
	        normalizeAnimationDetails(element, newAnimation);
	      }
	
	      // when the options are merged and cleaned up we may end up not having to do
	      // an animation at all, therefore we should check this before issuing a post
	      // digest callback. Structural animations will always run no matter what.
	      var isValidAnimation = newAnimation.structural;
	      if (!isValidAnimation) {
	        // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
	        isValidAnimation = (newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0)
	                            || hasAnimationClasses(newAnimation);
	      }
	
	      if (!isValidAnimation) {
	        close();
	        clearElementAnimationState(node);
	        return runner;
	      }
	
	      // the counter keeps track of cancelled animations
	      var counter = (existingAnimation.counter || 0) + 1;
	      newAnimation.counter = counter;
	
	      markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
	
	      $rootScope.$$postDigest(function() {
	        // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
	        // happen if the animated element is a transcluded clone and also has a `templateUrl`
	        // directive on it. Therefore, we must recreate `element` in order to interact with the
	        // actual DOM nodes.
	        // Note: We still need to use the old `node` for certain things, such as looking up in
	        //       HashMaps where it was used as the key.
	
	        element = stripCommentsFromElement(originalElement);
	
	        var animationDetails = activeAnimationsLookup.get(node);
	        var animationCancelled = !animationDetails;
	        animationDetails = animationDetails || {};
	
	        // if addClass/removeClass is called before something like enter then the
	        // registered parent element may not be present. The code below will ensure
	        // that a final value for parent element is obtained
	        var parentElement = element.parent() || [];
	
	        // animate/structural/class-based animations all have requirements. Otherwise there
	        // is no point in performing an animation. The parent node must also be set.
	        var isValidAnimation = parentElement.length > 0
	                                && (animationDetails.event === 'animate'
	                                    || animationDetails.structural
	                                    || hasAnimationClasses(animationDetails));
	
	        // this means that the previous animation was cancelled
	        // even if the follow-up animation is the same event
	        if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
	          // if another animation did not take over then we need
	          // to make sure that the domOperation and options are
	          // handled accordingly
	          if (animationCancelled) {
	            applyAnimationClasses(element, options);
	            applyAnimationStyles(element, options);
	          }
	
	          // if the event changed from something like enter to leave then we do
	          // it, otherwise if it's the same then the end result will be the same too
	          if (animationCancelled || (isStructural && animationDetails.event !== event)) {
	            options.domOperation();
	            runner.end();
	          }
	
	          // in the event that the element animation was not cancelled or a follow-up animation
	          // isn't allowed to animate from here then we need to clear the state of the element
	          // so that any future animations won't read the expired animation data.
	          if (!isValidAnimation) {
	            clearElementAnimationState(node);
	          }
	
	          return;
	        }
	
	        // this combined multiple class to addClass / removeClass into a setClass event
	        // so long as a structural event did not take over the animation
	        event = !animationDetails.structural && hasAnimationClasses(animationDetails, true)
	            ? 'setClass'
	            : animationDetails.event;
	
	        markElementAnimationState(node, RUNNING_STATE);
	        var realRunner = $$animation(element, event, animationDetails.options);
	
	        // this will update the runner's flow-control events based on
	        // the `realRunner` object.
	        runner.setHost(realRunner);
	        notifyProgress(runner, event, 'start', getEventData(options));
	
	        realRunner.done(function(status) {
	          close(!status);
	          var animationDetails = activeAnimationsLookup.get(node);
	          if (animationDetails && animationDetails.counter === counter) {
	            clearElementAnimationState(node);
	          }
	          notifyProgress(runner, event, 'close', getEventData(options));
	        });
	      });
	
	      return runner;
	
	      function notifyProgress(runner, event, phase, data) {
	        runInNextPostDigestOrNow(function() {
	          var callbacks = findCallbacks(parentNode, node, event);
	          if (callbacks.length) {
	            // do not optimize this call here to RAF because
	            // we don't know how heavy the callback code here will
	            // be and if this code is buffered then this can
	            // lead to a performance regression.
	            $$rAF(function() {
	              forEach(callbacks, function(callback) {
	                callback(element, phase, data);
	              });
	              cleanupEventListeners(phase, node);
	            });
	          } else {
	            cleanupEventListeners(phase, node);
	          }
	        });
	        runner.progress(event, phase, data);
	      }
	
	      function close(reject) {
	        clearGeneratedClasses(element, options);
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	        runner.complete(!reject);
	      }
	    }
	
	    function closeChildAnimations(node) {
	      var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
	      forEach(children, function(child) {
	        var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
	        var animationDetails = activeAnimationsLookup.get(child);
	        if (animationDetails) {
	          switch (state) {
	            case RUNNING_STATE:
	              animationDetails.runner.end();
	              /* falls through */
	            case PRE_DIGEST_STATE:
	              activeAnimationsLookup.delete(child);
	              break;
	          }
	        }
	      });
	    }
	
	    function clearElementAnimationState(node) {
	      node.removeAttribute(NG_ANIMATE_ATTR_NAME);
	      activeAnimationsLookup.delete(node);
	    }
	
	    /**
	     * This fn returns false if any of the following is true:
	     * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
	     * b) a parent element has an ongoing structural animation, and animateChildren is false
	     * c) the element is not a child of the body
	     * d) the element is not a child of the $rootElement
	     */
	    function areAnimationsAllowed(node, parentNode, event) {
	      var bodyNode = $document[0].body;
	      var rootNode = getDomNode($rootElement);
	
	      var bodyNodeDetected = (node === bodyNode) || node.nodeName === 'HTML';
	      var rootNodeDetected = (node === rootNode);
	      var parentAnimationDetected = false;
	      var elementDisabled = disabledElementsLookup.get(node);
	      var animateChildren;
	
	      var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
	      if (parentHost) {
	        parentNode = getDomNode(parentHost);
	      }
	
	      while (parentNode) {
	        if (!rootNodeDetected) {
	          // AngularJS doesn't want to attempt to animate elements outside of the application
	          // therefore we need to ensure that the rootElement is an ancestor of the current element
	          rootNodeDetected = (parentNode === rootNode);
	        }
	
	        if (parentNode.nodeType !== ELEMENT_NODE) {
	          // no point in inspecting the #document element
	          break;
	        }
	
	        var details = activeAnimationsLookup.get(parentNode) || {};
	        // either an enter, leave or move animation will commence
	        // therefore we can't allow any animations to take place
	        // but if a parent animation is class-based then that's ok
	        if (!parentAnimationDetected) {
	          var parentNodeDisabled = disabledElementsLookup.get(parentNode);
	
	          if (parentNodeDisabled === true && elementDisabled !== false) {
	            // disable animations if the user hasn't explicitly enabled animations on the
	            // current element
	            elementDisabled = true;
	            // element is disabled via parent element, no need to check anything else
	            break;
	          } else if (parentNodeDisabled === false) {
	            elementDisabled = false;
	          }
	          parentAnimationDetected = details.structural;
	        }
	
	        if (isUndefined(animateChildren) || animateChildren === true) {
	          var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
	          if (isDefined(value)) {
	            animateChildren = value;
	          }
	        }
	
	        // there is no need to continue traversing at this point
	        if (parentAnimationDetected && animateChildren === false) break;
	
	        if (!bodyNodeDetected) {
	          // we also need to ensure that the element is or will be a part of the body element
	          // otherwise it is pointless to even issue an animation to be rendered
	          bodyNodeDetected = (parentNode === bodyNode);
	        }
	
	        if (bodyNodeDetected && rootNodeDetected) {
	          // If both body and root have been found, any other checks are pointless,
	          // as no animation data should live outside the application
	          break;
	        }
	
	        if (!rootNodeDetected) {
	          // If `rootNode` is not detected, check if `parentNode` is pinned to another element
	          parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
	          if (parentHost) {
	            // The pin target element becomes the next parent element
	            parentNode = getDomNode(parentHost);
	            continue;
	          }
	        }
	
	        parentNode = parentNode.parentNode;
	      }
	
	      var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
	      return allowAnimation && rootNodeDetected && bodyNodeDetected;
	    }
	
	    function markElementAnimationState(node, state, details) {
	      details = details || {};
	      details.state = state;
	
	      node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
	
	      var oldValue = activeAnimationsLookup.get(node);
	      var newValue = oldValue
	          ? extend(oldValue, details)
	          : details;
	      activeAnimationsLookup.set(node, newValue);
	    }
	  }];
	}];
	
	/** @this */
	var $$AnimateCacheProvider = function() {
	
	  var KEY = '$$ngAnimateParentKey';
	  var parentCounter = 0;
	  var cache = Object.create(null);
	
	  this.$get = [function() {
	    return {
	      cacheKey: function(node, method, addClass, removeClass) {
	        var parentNode = node.parentNode;
	        var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
	        var parts = [parentID, method, node.getAttribute('class')];
	        if (addClass) {
	          parts.push(addClass);
	        }
	        if (removeClass) {
	          parts.push(removeClass);
	        }
	        return parts.join(' ');
	      },
	
	      containsCachedAnimationWithoutDuration: function(key) {
	        var entry = cache[key];
	
	        // nothing cached, so go ahead and animate
	        // otherwise it should be a valid animation
	        return (entry && !entry.isValid) || false;
	      },
	
	      flush: function() {
	        cache = Object.create(null);
	      },
	
	      count: function(key) {
	        var entry = cache[key];
	        return entry ? entry.total : 0;
	      },
	
	      get: function(key) {
	        var entry = cache[key];
	        return entry && entry.value;
	      },
	
	      put: function(key, value, isValid) {
	        if (!cache[key]) {
	          cache[key] = { total: 1, value: value, isValid: isValid };
	        } else {
	          cache[key].total++;
	          cache[key].value = value;
	        }
	      }
	    };
	  }];
	};
	
	/* exported $$AnimationProvider */
	
	var $$AnimationProvider = ['$animateProvider', /** @this */ function($animateProvider) {
	  var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
	
	  var drivers = this.drivers = [];
	
	  var RUNNER_STORAGE_KEY = '$$animationRunner';
	  var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';
	
	  function setRunner(element, runner) {
	    element.data(RUNNER_STORAGE_KEY, runner);
	  }
	
	  function removeRunner(element) {
	    element.removeData(RUNNER_STORAGE_KEY);
	  }
	
	  function getRunner(element) {
	    return element.data(RUNNER_STORAGE_KEY);
	  }
	
	  this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache',
	       function($$jqLite,   $rootScope,   $injector,   $$AnimateRunner,   $$Map,   $$rAFScheduler, $$animateCache) {
	
	    var animationQueue = [];
	    var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
	
	    function sortAnimations(animations) {
	      var tree = { children: [] };
	      var i, lookup = new $$Map();
	
	      // this is done first beforehand so that the map
	      // is filled with a list of the elements that will be animated
	      for (i = 0; i < animations.length; i++) {
	        var animation = animations[i];
	        lookup.set(animation.domNode, animations[i] = {
	          domNode: animation.domNode,
	          element: animation.element,
	          fn: animation.fn,
	          children: []
	        });
	      }
	
	      for (i = 0; i < animations.length; i++) {
	        processNode(animations[i]);
	      }
	
	      return flatten(tree);
	
	      function processNode(entry) {
	        if (entry.processed) return entry;
	        entry.processed = true;
	
	        var elementNode = entry.domNode;
	        var parentNode = elementNode.parentNode;
	        lookup.set(elementNode, entry);
	
	        var parentEntry;
	        while (parentNode) {
	          parentEntry = lookup.get(parentNode);
	          if (parentEntry) {
	            if (!parentEntry.processed) {
	              parentEntry = processNode(parentEntry);
	            }
	            break;
	          }
	          parentNode = parentNode.parentNode;
	        }
	
	        (parentEntry || tree).children.push(entry);
	        return entry;
	      }
	
	      function flatten(tree) {
	        var result = [];
	        var queue = [];
	        var i;
	
	        for (i = 0; i < tree.children.length; i++) {
	          queue.push(tree.children[i]);
	        }
	
	        var remainingLevelEntries = queue.length;
	        var nextLevelEntries = 0;
	        var row = [];
	
	        for (i = 0; i < queue.length; i++) {
	          var entry = queue[i];
	          if (remainingLevelEntries <= 0) {
	            remainingLevelEntries = nextLevelEntries;
	            nextLevelEntries = 0;
	            result.push(row);
	            row = [];
	          }
	          row.push(entry);
	          entry.children.forEach(function(childEntry) {
	            nextLevelEntries++;
	            queue.push(childEntry);
	          });
	          remainingLevelEntries--;
	        }
	
	        if (row.length) {
	          result.push(row);
	        }
	
	        return result;
	      }
	    }
	
	    // TODO(matsko): document the signature in a better way
	    return function(element, event, options) {
	      options = prepareAnimationOptions(options);
	      var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
	
	      // there is no animation at the current moment, however
	      // these runner methods will get later updated with the
	      // methods leading into the driver's end/cancel methods
	      // for now they just stop the animation from starting
	      var runner = new $$AnimateRunner({
	        end: function() { close(); },
	        cancel: function() { close(true); }
	      });
	
	      if (!drivers.length) {
	        close();
	        return runner;
	      }
	
	      var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
	      var tempClasses = options.tempClasses;
	      if (tempClasses) {
	        classes += ' ' + tempClasses;
	        options.tempClasses = null;
	      }
	
	      if (isStructural) {
	        element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
	      }
	
	      setRunner(element, runner);
	
	      animationQueue.push({
	        // this data is used by the postDigest code and passed into
	        // the driver step function
	        element: element,
	        classes: classes,
	        event: event,
	        structural: isStructural,
	        options: options,
	        beforeStart: beforeStart,
	        close: close
	      });
	
	      element.on('$destroy', handleDestroyedElement);
	
	      // we only want there to be one function called within the post digest
	      // block. This way we can group animations for all the animations that
	      // were apart of the same postDigest flush call.
	      if (animationQueue.length > 1) return runner;
	
	      $rootScope.$$postDigest(function() {
	        var animations = [];
	        forEach(animationQueue, function(entry) {
	          // the element was destroyed early on which removed the runner
	          // form its storage. This means we can't animate this element
	          // at all and it already has been closed due to destruction.
	          if (getRunner(entry.element)) {
	            animations.push(entry);
	          } else {
	            entry.close();
	          }
	        });
	
	        // now any future animations will be in another postDigest
	        animationQueue.length = 0;
	
	        var groupedAnimations = groupAnimations(animations);
	        var toBeSortedAnimations = [];
	
	        forEach(groupedAnimations, function(animationEntry) {
	          var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
	          var extraClasses = options.addClass;
	
	          extraClasses = (extraClasses ? (extraClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
	          var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);
	
	          toBeSortedAnimations.push({
	            element: element,
	            domNode: getDomNode(element),
	            fn: function triggerAnimationStart() {
	              var startAnimationFn, closeFn = animationEntry.close;
	
	              // in the event that we've cached the animation status for this element
	              // and it's in fact an invalid animation (something that has duration = 0)
	              // then we should skip all the heavy work from here on
	              if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
	                closeFn();
	                return;
	              }
	
	              // it's important that we apply the `ng-animate` CSS class and the
	              // temporary classes before we do any driver invoking since these
	              // CSS classes may be required for proper CSS detection.
	              animationEntry.beforeStart();
	
	              // in the event that the element was removed before the digest runs or
	              // during the RAF sequencing then we should not trigger the animation.
	              var targetElement = animationEntry.anchors
	                  ? (animationEntry.from.element || animationEntry.to.element)
	                  : animationEntry.element;
	
	              if (getRunner(targetElement)) {
	                var operation = invokeFirstDriver(animationEntry);
	                if (operation) {
	                  startAnimationFn = operation.start;
	                }
	              }
	
	              if (!startAnimationFn) {
	                closeFn();
	              } else {
	                var animationRunner = startAnimationFn();
	                animationRunner.done(function(status) {
	                  closeFn(!status);
	                });
	                updateAnimationRunners(animationEntry, animationRunner);
	              }
	            }
	          });
	        });
	
	        // we need to sort each of the animations in order of parent to child
	        // relationships. This ensures that the child classes are applied at the
	        // right time.
	        var finalAnimations = sortAnimations(toBeSortedAnimations);
	        for (var i = 0; i < finalAnimations.length; i++) {
	          var innerArray = finalAnimations[i];
	          for (var j = 0; j < innerArray.length; j++) {
	            var entry = innerArray[j];
	            var element = entry.element;
	
	            // the RAFScheduler code only uses functions
	            finalAnimations[i][j] = entry.fn;
	
	            // the first row of elements shouldn't have a prepare-class added to them
	            // since the elements are at the top of the animation hierarchy and they
	            // will be applied without a RAF having to pass...
	            if (i === 0) {
	              element.removeData(PREPARE_CLASSES_KEY);
	              continue;
	            }
	
	            var prepareClassName = element.data(PREPARE_CLASSES_KEY);
	            if (prepareClassName) {
	              $$jqLite.addClass(element, prepareClassName);
	            }
	          }
	        }
	
	        $$rAFScheduler(finalAnimations);
	      });
	
	      return runner;
	
	      // TODO(matsko): change to reference nodes
	      function getAnchorNodes(node) {
	        var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
	        var items = node.hasAttribute(NG_ANIMATE_REF_ATTR)
	              ? [node]
	              : node.querySelectorAll(SELECTOR);
	        var anchors = [];
	        forEach(items, function(node) {
	          var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
	          if (attr && attr.length) {
	            anchors.push(node);
	          }
	        });
	        return anchors;
	      }
	
	      function groupAnimations(animations) {
	        var preparedAnimations = [];
	        var refLookup = {};
	        forEach(animations, function(animation, index) {
	          var element = animation.element;
	          var node = getDomNode(element);
	          var event = animation.event;
	          var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
	          var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
	
	          if (anchorNodes.length) {
	            var direction = enterOrMove ? 'to' : 'from';
	
	            forEach(anchorNodes, function(anchor) {
	              var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
	              refLookup[key] = refLookup[key] || {};
	              refLookup[key][direction] = {
	                animationID: index,
	                element: jqLite(anchor)
	              };
	            });
	          } else {
	            preparedAnimations.push(animation);
	          }
	        });
	
	        var usedIndicesLookup = {};
	        var anchorGroups = {};
	        forEach(refLookup, function(operations, key) {
	          var from = operations.from;
	          var to = operations.to;
	
	          if (!from || !to) {
	            // only one of these is set therefore we can't have an
	            // anchor animation since all three pieces are required
	            var index = from ? from.animationID : to.animationID;
	            var indexKey = index.toString();
	            if (!usedIndicesLookup[indexKey]) {
	              usedIndicesLookup[indexKey] = true;
	              preparedAnimations.push(animations[index]);
	            }
	            return;
	          }
	
	          var fromAnimation = animations[from.animationID];
	          var toAnimation = animations[to.animationID];
	          var lookupKey = from.animationID.toString();
	          if (!anchorGroups[lookupKey]) {
	            var group = anchorGroups[lookupKey] = {
	              structural: true,
	              beforeStart: function() {
	                fromAnimation.beforeStart();
	                toAnimation.beforeStart();
	              },
	              close: function() {
	                fromAnimation.close();
	                toAnimation.close();
	              },
	              classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
	              from: fromAnimation,
	              to: toAnimation,
	              anchors: [] // TODO(matsko): change to reference nodes
	            };
	
	            // the anchor animations require that the from and to elements both have at least
	            // one shared CSS class which effectively marries the two elements together to use
	            // the same animation driver and to properly sequence the anchor animation.
	            if (group.classes.length) {
	              preparedAnimations.push(group);
	            } else {
	              preparedAnimations.push(fromAnimation);
	              preparedAnimations.push(toAnimation);
	            }
	          }
	
	          anchorGroups[lookupKey].anchors.push({
	            'out': from.element, 'in': to.element
	          });
	        });
	
	        return preparedAnimations;
	      }
	
	      function cssClassesIntersection(a,b) {
	        a = a.split(' ');
	        b = b.split(' ');
	        var matches = [];
	
	        for (var i = 0; i < a.length; i++) {
	          var aa = a[i];
	          if (aa.substring(0,3) === 'ng-') continue;
	
	          for (var j = 0; j < b.length; j++) {
	            if (aa === b[j]) {
	              matches.push(aa);
	              break;
	            }
	          }
	        }
	
	        return matches.join(' ');
	      }
	
	      function invokeFirstDriver(animationDetails) {
	        // we loop in reverse order since the more general drivers (like CSS and JS)
	        // may attempt more elements, but custom drivers are more particular
	        for (var i = drivers.length - 1; i >= 0; i--) {
	          var driverName = drivers[i];
	          var factory = $injector.get(driverName);
	          var driver = factory(animationDetails);
	          if (driver) {
	            return driver;
	          }
	        }
	      }
	
	      function beforeStart() {
	        tempClasses = (tempClasses ? (tempClasses + ' ') : '') + NG_ANIMATE_CLASSNAME;
	        $$jqLite.addClass(element, tempClasses);
	
	        var prepareClassName = element.data(PREPARE_CLASSES_KEY);
	        if (prepareClassName) {
	          $$jqLite.removeClass(element, prepareClassName);
	          prepareClassName = null;
	        }
	      }
	
	      function updateAnimationRunners(animation, newRunner) {
	        if (animation.from && animation.to) {
	          update(animation.from.element);
	          update(animation.to.element);
	        } else {
	          update(animation.element);
	        }
	
	        function update(element) {
	          var runner = getRunner(element);
	          if (runner) runner.setHost(newRunner);
	        }
	      }
	
	      function handleDestroyedElement() {
	        var runner = getRunner(element);
	        if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
	          runner.end();
	        }
	      }
	
	      function close(rejected) {
	        element.off('$destroy', handleDestroyedElement);
	        removeRunner(element);
	
	        applyAnimationClasses(element, options);
	        applyAnimationStyles(element, options);
	        options.domOperation();
	
	        if (tempClasses) {
	          $$jqLite.removeClass(element, tempClasses);
	        }
	
	        runner.complete(!rejected);
	      }
	    };
	  }];
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngAnimateSwap
	 * @restrict A
	 * @scope
	 *
	 * @description
	 *
	 * ngAnimateSwap is a animation-oriented directive that allows for the container to
	 * be removed and entered in whenever the associated expression changes. A
	 * common usecase for this directive is a rotating banner or slider component which
	 * contains one image being present at a time. When the active image changes
	 * then the old image will perform a `leave` animation and the new element
	 * will be inserted via an `enter` animation.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|--------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
	 * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
	 *
	 * @example
	 * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
	 *          deps="angular-animate.js"
	 *          animations="true" fixBase="true">
	 *   <file name="index.html">
	 *     <div class="container" ng-controller="AppCtrl">
	 *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
	 *         {{ number }}
	 *       </div>
	 *     </div>
	 *   </file>
	 *   <file name="script.js">
	 *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
	 *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
	 *         $scope.number = 0;
	 *         $interval(function() {
	 *           $scope.number++;
	 *         }, 1000);
	 *
	 *         var colors = ['red','blue','green','yellow','orange'];
	 *         $scope.colorClass = function(number) {
	 *           return colors[number % colors.length];
	 *         };
	 *       }]);
	 *   </file>
	 *  <file name="animations.css">
	 *  .container {
	 *    height:250px;
	 *    width:250px;
	 *    position:relative;
	 *    overflow:hidden;
	 *    border:2px solid black;
	 *  }
	 *  .container .cell {
	 *    font-size:150px;
	 *    text-align:center;
	 *    line-height:250px;
	 *    position:absolute;
	 *    top:0;
	 *    left:0;
	 *    right:0;
	 *    border-bottom:2px solid black;
	 *  }
	 *  .swap-animation.ng-enter, .swap-animation.ng-leave {
	 *    transition:0.5s linear all;
	 *  }
	 *  .swap-animation.ng-enter {
	 *    top:-250px;
	 *  }
	 *  .swap-animation.ng-enter-active {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave {
	 *    top:0px;
	 *  }
	 *  .swap-animation.ng-leave-active {
	 *    top:250px;
	 *  }
	 *  .red { background:red; }
	 *  .green { background:green; }
	 *  .blue { background:blue; }
	 *  .yellow { background:yellow; }
	 *  .orange { background:orange; }
	 *  </file>
	 * </example>
	 */
	var ngAnimateSwapDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    transclude: 'element',
	    terminal: true,
	    priority: 550, // We use 550 here to ensure that the directive is caught before others,
	                   // but after `ngIf` (at priority 600).
	    link: function(scope, $element, attrs, ctrl, $transclude) {
	      var previousElement, previousScope;
	      scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function(value) {
	        if (previousElement) {
	          $animate.leave(previousElement);
	        }
	        if (previousScope) {
	          previousScope.$destroy();
	          previousScope = null;
	        }
	        if (value || value === 0) {
	          $transclude(function(clone, childScope) {
	            previousElement = clone;
	            previousScope = childScope;
	            $animate.enter(clone, null, $element);
	          });
	        }
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc module
	 * @name ngAnimate
	 * @description
	 *
	 * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
	 * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
	 *
	 * ## Usage
	 * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
	 * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
	 * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
	 * the HTML element that the animation will be triggered on.
	 *
	 * ## Directive Support
	 * The following directives are "animation aware":
	 *
	 * | Directive                                                                     | Supported Animations                                                      |
	 * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
	 * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
	 * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
	 * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
	 * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
	 * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
	 * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
	 * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
	 * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
	 * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
	 * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
	 * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
	 * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
	 * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
	 * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
	 * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
	 *
	 * (More information can be found by visiting the documentation associated with each directive.)
	 *
	 * For a full breakdown of the steps involved during each animation event, refer to the
	 * {@link ng.$animate `$animate` API docs}.
	 *
	 * ## CSS-based Animations
	 *
	 * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
	 * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
	 *
	 * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
	 *
	 * ```html
	 * <div ng-if="bool" class="fade">
	 *    Fade me in out
	 * </div>
	 * <button ng-click="bool=true">Fade In!</button>
	 * <button ng-click="bool=false">Fade Out!</button>
	 * ```
	 *
	 * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
	 *
	 * ```css
	 * /&#42; The starting CSS styles for the enter animation &#42;/
	 * .fade.ng-enter {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 *
	 * /&#42; The finishing CSS styles for the enter animation &#42;/
	 * .fade.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
	 * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
	 * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
	 *
	 * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
	 *
	 * ```css
	 * /&#42; now the element will fade out before it is removed from the DOM &#42;/
	 * .fade.ng-leave {
	 *   transition:0.5s linear all;
	 *   opacity:1;
	 * }
	 * .fade.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
	 *
	 * ```css
	 * /&#42; there is no need to define anything inside of the destination
	 * CSS class since the keyframe will take charge of the animation &#42;/
	 * .fade.ng-leave {
	 *   animation: my_fade_animation 0.5s linear;
	 *   -webkit-animation: my_fade_animation 0.5s linear;
	 * }
	 *
	 * @keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 *
	 * @-webkit-keyframes my_fade_animation {
	 *   from { opacity:1; }
	 *   to { opacity:0; }
	 * }
	 * ```
	 *
	 * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
	 *
	 * ### CSS Class-based Animations
	 *
	 * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
	 * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
	 * and removed.
	 *
	 * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
	 *
	 * ```html
	 * <div ng-show="bool" class="fade">
	 *   Show and hide me
	 * </div>
	 * <button ng-click="bool=!bool">Toggle</button>
	 *
	 * <style>
	 * .fade.ng-hide {
	 *   transition:0.5s linear all;
	 *   opacity:0;
	 * }
	 * </style>
	 * ```
	 *
	 * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
	 * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
	 *
	 * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
	 * with CSS styles.
	 *
	 * ```html
	 * <div ng-class="{on:onOff}" class="highlight">
	 *   Highlight this box
	 * </div>
	 * <button ng-click="onOff=!onOff">Toggle</button>
	 *
	 * <style>
	 * .highlight {
	 *   transition:0.5s linear all;
	 * }
	 * .highlight.on-add {
	 *   background:white;
	 * }
	 * .highlight.on {
	 *   background:yellow;
	 * }
	 * .highlight.on-remove {
	 *   background:black;
	 * }
	 * </style>
	 * ```
	 *
	 * We can also make use of CSS keyframes by placing them within the CSS classes.
	 *
	 *
	 * ### CSS Staggering Animations
	 * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
	 * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
	 * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
	 * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
	 * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
	 *
	 * ```css
	 * .my-animation.ng-enter {
	 *   /&#42; standard transition code &#42;/
	 *   transition: 1s linear all;
	 *   opacity:0;
	 * }
	 * .my-animation.ng-enter-stagger {
	 *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
	 *   transition-delay: 0.1s;
	 *
	 *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
	 *     to not accidentally inherit a delay property from another CSS class &#42;/
	 *   transition-duration: 0s;
	 *
	 *   /&#42; if you are using animations instead of transitions you should configure as follows:
	 *     animation-delay: 0.1s;
	 *     animation-duration: 0s; &#42;/
	 * }
	 * .my-animation.ng-enter.ng-enter-active {
	 *   /&#42; standard transition styles &#42;/
	 *   opacity:1;
	 * }
	 * ```
	 *
	 * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
	 * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
	 * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
	 * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
	 *
	 * The following code will issue the **ng-leave-stagger** event on the element provided:
	 *
	 * ```js
	 * var kids = parent.children();
	 *
	 * $animate.leave(kids[0]); //stagger index=0
	 * $animate.leave(kids[1]); //stagger index=1
	 * $animate.leave(kids[2]); //stagger index=2
	 * $animate.leave(kids[3]); //stagger index=3
	 * $animate.leave(kids[4]); //stagger index=4
	 *
	 * window.requestAnimationFrame(function() {
	 *   //stagger has reset itself
	 *   $animate.leave(kids[5]); //stagger index=0
	 *   $animate.leave(kids[6]); //stagger index=1
	 *
	 *   $scope.$digest();
	 * });
	 * ```
	 *
	 * Stagger animations are currently only supported within CSS-defined animations.
	 *
	 * ### The `ng-animate` CSS class
	 *
	 * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
	 * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
	 *
	 * Therefore, animations can be applied to an element using this temporary class directly via CSS.
	 *
	 * ```css
	 * .zipper.ng-animate {
	 *   transition:0.5s linear all;
	 * }
	 * .zipper.ng-enter {
	 *   opacity:0;
	 * }
	 * .zipper.ng-enter.ng-enter-active {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave {
	 *   opacity:1;
	 * }
	 * .zipper.ng-leave.ng-leave-active {
	 *   opacity:0;
	 * }
	 * ```
	 *
	 * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
	 * the CSS class once an animation has completed.)
	 *
	 *
	 * ### The `ng-[event]-prepare` class
	 *
	 * This is a special class that can be used to prevent unwanted flickering / flash of content before
	 * the actual animation starts. The class is added as soon as an animation is initialized, but removed
	 * before the actual animation starts (after waiting for a $digest).
	 * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
	 *
	 * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
	 * into elements that have class-based animations such as `ngClass`.
	 *
	 * ```html
	 * <div ng-class="{red: myProp}">
	 *   <div ng-class="{blue: myProp}">
	 *     <div class="message" ng-if="myProp"></div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
	 * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
	 *
	 * ```css
	 * .message.ng-enter-prepare {
	 *   opacity: 0;
	 * }
	 * ```
	 *
	 * ### Animating between value changes
	 *
	 * Sometimes you need to animate between different expression states, whose values
	 * don't necessary need to be known or referenced in CSS styles.
	 * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
	 * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
	 * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
	 *
	 * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
	 * creates a new instance of the element (including any other/child directives it may have) and
	 * links it to a new scope every time *swap* happens. In some cases this might not be desirable
	 * (e.g. for performance reasons, or when you wish to retain internal state on the original
	 * element instance).
	 *
	 * ## JavaScript-based Animations
	 *
	 * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
	 * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
	 * `module.animation()` module function we can register the animation.
	 *
	 * Let's see an example of a enter/leave animation using `ngRepeat`:
	 *
	 * ```html
	 * <div ng-repeat="item in items" class="slide">
	 *   {{ item }}
	 * </div>
	 * ```
	 *
	 * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     // make note that other events (like addClass/removeClass)
	 *     // have different function input parameters
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *
	 *       // remember to call doneFn so that AngularJS
	 *       // knows that the animation has concluded
	 *     },
	 *
	 *     move: function(element, doneFn) {
	 *       jQuery(element).fadeIn(1000, doneFn);
	 *     },
	 *
	 *     leave: function(element, doneFn) {
	 *       jQuery(element).fadeOut(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
	 * greensock.js and velocity.js.
	 *
	 * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
	 * our animations inside of the same registered animation, however, the function input arguments are a bit different:
	 *
	 * ```html
	 * <div ng-class="color" class="colorful">
	 *   this box is moody
	 * </div>
	 * <button ng-click="color='red'">Change to red</button>
	 * <button ng-click="color='blue'">Change to blue</button>
	 * <button ng-click="color='green'">Change to green</button>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.colorful', [function() {
	 *   return {
	 *     addClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     removeClass: function(element, className, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     },
	 *     setClass: function(element, addedClass, removedClass, doneFn) {
	 *       // do some cool animation and call the doneFn
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ## CSS + JS Animations Together
	 *
	 * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
	 * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
	 * charge of the animation**:
	 *
	 * ```html
	 * <div ng-if="bool" class="slide">
	 *   Slide in and out
	 * </div>
	 * ```
	 *
	 * ```js
	 * myModule.animation('.slide', [function() {
	 *   return {
	 *     enter: function(element, doneFn) {
	 *       jQuery(element).slideIn(1000, doneFn);
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * ```css
	 * .slide.ng-enter {
	 *   transition:0.5s linear all;
	 *   transform:translateY(-100px);
	 * }
	 * .slide.ng-enter.ng-enter-active {
	 *   transform:translateY(0);
	 * }
	 * ```
	 *
	 * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
	 * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
	 * our own JS-based animation code:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	*        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
	 *
	 * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
	 * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
	 * data into `$animateCss` directly:
	 *
	 * ```js
	 * myModule.animation('.slide', ['$animateCss', function($animateCss) {
	 *   return {
	 *     enter: function(element) {
	 *       return $animateCss(element, {
	 *         event: 'enter',
	 *         structural: true,
	 *         addClass: 'maroon-setting',
	 *         from: { height:0 },
	 *         to: { height: 200 }
	 *       });
	 *     }
	 *   }
	 * }]);
	 * ```
	 *
	 * Now we can fill in the rest via our transition CSS code:
	 *
	 * ```css
	 * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
	 * .slide.ng-enter { transition:0.5s linear all; }
	 *
	 * /&#42; this extra CSS class will be absorbed into the transition
	 * since the $animateCss code is adding the class &#42;/
	 * .maroon-setting { background:red; }
	 * ```
	 *
	 * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
	 *
	 * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
	 *
	 * ## Animation Anchoring (via `ng-animate-ref`)
	 *
	 * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
	 * structural areas of an application (like views) by pairing up elements using an attribute
	 * called `ng-animate-ref`.
	 *
	 * Let's say for example we have two views that are managed by `ng-view` and we want to show
	 * that there is a relationship between two components situated in within these views. By using the
	 * `ng-animate-ref` attribute we can identify that the two components are paired together and we
	 * can then attach an animation, which is triggered when the view changes.
	 *
	 * Say for example we have the following template code:
	 *
	 * ```html
	 * <!-- index.html -->
	 * <div ng-view class="view-animation">
	 * </div>
	 *
	 * <!-- home.html -->
	 * <a href="#/banner-page">
	 *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * </a>
	 *
	 * <!-- banner-page.html -->
	 * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
	 * ```
	 *
	 * Now, when the view changes (once the link is clicked), ngAnimate will examine the
	 * HTML contents to see if there is a match reference between any components in the view
	 * that is leaving and the view that is entering. It will scan both the view which is being
	 * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
	 * contain a matching ref value.
	 *
	 * The two images match since they share the same ref value. ngAnimate will now create a
	 * transport element (which is a clone of the first image element) and it will then attempt
	 * to animate to the position of the second image element in the next view. For the animation to
	 * work a special CSS class called `ng-anchor` will be added to the transported element.
	 *
	 * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
	 * ngAnimate will handle the entire transition for us as well as the addition and removal of
	 * any changes of CSS classes between the elements:
	 *
	 * ```css
	 * .banner.ng-anchor {
	 *   /&#42; this animation will last for 1 second since there are
	 *          two phases to the animation (an `in` and an `out` phase) &#42;/
	 *   transition:0.5s linear all;
	 * }
	 * ```
	 *
	 * We also **must** include animations for the views that are being entered and removed
	 * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
	 *
	 * ```css
	 * .view-animation.ng-enter, .view-animation.ng-leave {
	 *   transition:0.5s linear all;
	 *   position:fixed;
	 *   left:0;
	 *   top:0;
	 *   width:100%;
	 * }
	 * .view-animation.ng-enter {
	 *   transform:translateX(100%);
	 * }
	 * .view-animation.ng-leave,
	 * .view-animation.ng-enter.ng-enter-active {
	 *   transform:translateX(0%);
	 * }
	 * .view-animation.ng-leave.ng-leave-active {
	 *   transform:translateX(-100%);
	 * }
	 * ```
	 *
	 * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
	 * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
	 * from its origin. Once that animation is over then the `in` stage occurs which animates the
	 * element to its destination. The reason why there are two animations is to give enough time
	 * for the enter animation on the new element to be ready.
	 *
	 * The example above sets up a transition for both the in and out phases, but we can also target the out or
	 * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
	 *
	 * ```css
	 * .banner.ng-anchor-out {
	 *   transition: 0.5s linear all;
	 *
	 *   /&#42; the scale will be applied during the out animation,
	 *          but will be animated away when the in animation runs &#42;/
	 *   transform: scale(1.2);
	 * }
	 *
	 * .banner.ng-anchor-in {
	 *   transition: 1s linear all;
	 * }
	 * ```
	 *
	 *
	 *
	 *
	 * ### Anchoring Demo
	 *
	  <example module="anchoringExample"
	           name="anchoringExample"
	           id="anchoringExample"
	           deps="angular-animate.js;angular-route.js"
	           animations="true">
	    <file name="index.html">
	      <a href="#!/">Home</a>
	      <hr />
	      <div class="view-container">
	        <div ng-view class="view"></div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
	        .config(['$routeProvider', function($routeProvider) {
	          $routeProvider.when('/', {
	            templateUrl: 'home.html',
	            controller: 'HomeController as home'
	          });
	          $routeProvider.when('/profile/:id', {
	            templateUrl: 'profile.html',
	            controller: 'ProfileController as profile'
	          });
	        }])
	        .run(['$rootScope', function($rootScope) {
	          $rootScope.records = [
	            { id: 1, title: 'Miss Beulah Roob' },
	            { id: 2, title: 'Trent Morissette' },
	            { id: 3, title: 'Miss Ava Pouros' },
	            { id: 4, title: 'Rod Pouros' },
	            { id: 5, title: 'Abdul Rice' },
	            { id: 6, title: 'Laurie Rutherford Sr.' },
	            { id: 7, title: 'Nakia McLaughlin' },
	            { id: 8, title: 'Jordon Blanda DVM' },
	            { id: 9, title: 'Rhoda Hand' },
	            { id: 10, title: 'Alexandrea Sauer' }
	          ];
	        }])
	        .controller('HomeController', [function() {
	          //empty
	        }])
	        .controller('ProfileController', ['$rootScope', '$routeParams',
	            function ProfileController($rootScope, $routeParams) {
	          var index = parseInt($routeParams.id, 10);
	          var record = $rootScope.records[index - 1];
	
	          this.title = record.title;
	          this.id = record.id;
	        }]);
	    </file>
	    <file name="home.html">
	      <h2>Welcome to the home page</h1>
	      <p>Please click on an element</p>
	      <a class="record"
	         ng-href="#!/profile/{{ record.id }}"
	         ng-animate-ref="{{ record.id }}"
	         ng-repeat="record in records">
	        {{ record.title }}
	      </a>
	    </file>
	    <file name="profile.html">
	      <div class="profile record" ng-animate-ref="{{ profile.id }}">
	        {{ profile.title }}
	      </div>
	    </file>
	    <file name="animations.css">
	      .record {
	        display:block;
	        font-size:20px;
	      }
	      .profile {
	        background:black;
	        color:white;
	        font-size:100px;
	      }
	      .view-container {
	        position:relative;
	      }
	      .view-container > .view.ng-animate {
	        position:absolute;
	        top:0;
	        left:0;
	        width:100%;
	        min-height:500px;
	      }
	      .view.ng-enter, .view.ng-leave,
	      .record.ng-anchor {
	        transition:0.5s linear all;
	      }
	      .view.ng-enter {
	        transform:translateX(100%);
	      }
	      .view.ng-enter.ng-enter-active, .view.ng-leave {
	        transform:translateX(0%);
	      }
	      .view.ng-leave.ng-leave-active {
	        transform:translateX(-100%);
	      }
	      .record.ng-anchor-out {
	        background:red;
	      }
	    </file>
	  </example>
	 *
	 * ### How is the element transported?
	 *
	 * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
	 * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
	 * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
	 * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
	 * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
	 * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
	 * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
	 * will become visible since the shim class will be removed.
	 *
	 * ### How is the morphing handled?
	 *
	 * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
	 * what CSS classes differ between the starting element and the destination element. These different CSS classes
	 * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
	 * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
	 * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
	 * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
	 * the cloned element is placed inside of root element which is likely close to the body element).
	 *
	 * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
	 *
	 *
	 * ## Using $animate in your directive code
	 *
	 * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
	 * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
	 * imagine we have a greeting box that shows and hides itself when the data changes
	 *
	 * ```html
	 * <greeting-box active="onOrOff">Hi there</greeting-box>
	 * ```
	 *
	 * ```js
	 * ngModule.directive('greetingBox', ['$animate', function($animate) {
	 *   return function(scope, element, attrs) {
	 *     attrs.$observe('active', function(value) {
	 *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
	 *     });
	 *   });
	 * }]);
	 * ```
	 *
	 * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
	 * in our HTML code then we can trigger a CSS or JS animation to happen.
	 *
	 * ```css
	 * /&#42; normally we would create a CSS class to reference on the element &#42;/
	 * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
	 * ```
	 *
	 * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
	 * possible be sure to visit the {@link ng.$animate $animate service API page}.
	 *
	 *
	 * ## Callbacks and Promises
	 *
	 * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
	 * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
	 * ended by chaining onto the returned promise that animation method returns.
	 *
	 * ```js
	 * // somewhere within the depths of the directive
	 * $animate.enter(element, parent).then(function() {
	 *   //the animation has completed
	 * });
	 * ```
	 *
	 * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
	 * anymore.)
	 *
	 * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
	 * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
	 * routing controller to hook into that:
	 *
	 * ```js
	 * ngModule.controller('HomePageController', ['$animate', function($animate) {
	 *   $animate.on('enter', ngViewElement, function(element) {
	 *     // the animation for this route has completed
	 *   }]);
	 * }])
	 * ```
	 *
	 * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
	 */
	
	var copy;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var isElement;
	var isFunction;
	var isObject;
	var isString;
	var isUndefined;
	var jqLite;
	var noop;
	
	/**
	 * @ngdoc service
	 * @name $animate
	 * @kind object
	 *
	 * @description
	 * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
	 *
	 * Click here {@link ng.$animate to learn more about animations with `$animate`}.
	 */
	angular.module('ngAnimate', [], function initAngularHelpers() {
	  // Access helpers from AngularJS core.
	  // Do it inside a `config` block to ensure `window.angular` is available.
	  noop        = angular.noop;
	  copy        = angular.copy;
	  extend      = angular.extend;
	  jqLite      = angular.element;
	  forEach     = angular.forEach;
	  isArray     = angular.isArray;
	  isString    = angular.isString;
	  isObject    = angular.isObject;
	  isUndefined = angular.isUndefined;
	  isDefined   = angular.isDefined;
	  isFunction  = angular.isFunction;
	  isElement   = angular.isElement;
	})
	  .info({ angularVersion: '1.7.8' })
	  .directive('ngAnimateSwap', ngAnimateSwapDirective)
	
	  .directive('ngAnimateChildren', $$AnimateChildrenDirective)
	  .factory('$$rAFScheduler', $$rAFSchedulerFactory)
	
	  .provider('$$animateQueue', $$AnimateQueueProvider)
	  .provider('$$animateCache', $$AnimateCacheProvider)
	  .provider('$$animation', $$AnimationProvider)
	
	  .provider('$animateCss', $AnimateCssProvider)
	  .provider('$$animateCssDriver', $$AnimateCssDriverProvider)
	
	  .provider('$$animateJs', $$AnimateJsProvider)
	  .provider('$$animateJsDriver', $$AnimateJsDriverProvider);
	
	
	})(window, window.angular);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.22
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(369), __webpack_require__(374)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component)
	                .map(attributeTpl)
	                .join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject, parentFn) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /**
	     * # Angular 1 types
	     *
	     * UI-Router core provides various Typescript types which you can use for code completion and validating parameter values, etc.
	     * The customizations to the core types for Angular UI-Router are documented here.
	     *
	     * The optional [[$resolve]] service is also documented here.
	     *
	     * @preferred @publicapi @module ng1
	     */ /** */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']); // tslint:disable-line
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!$injector.hasOwnProperty('strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /**
	     * The current (or pending) State Parameters
	     *
	     * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
	     *
	     * The values are not updated until *after* a `Transition` successfully completes.
	     *
	     * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
	     *
	     * ### Deprecation warning:
	     *
	     * The value injected for `$stateParams` is different depending on where it is injected.
	     *
	     * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
	     * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
	     *
	     * Because of these confusing details, this service is deprecated.
	     *
	     * ### Instead of using the global `$stateParams` service object,
	     * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
	     *
	     * ```js
	     * MyService.$inject = ['$uiRouterGlobals'];
	     * function MyService($uiRouterGlobals) {
	     *   return {
	     *     paramValues: function () {
	     *       return $uiRouterGlobals.params;
	     *     }
	     *   }
	     * }
	     * ```
	     *
	     * ### Instead of using the per-transition `$stateParams` object,
	     * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
	     *
	     * ```js
	     * MyController.$inject = ['$transition$'];
	     * function MyController($transition$) {
	     *   var username = $transition$.params().username;
	     *   // .. do something with username
	     * }
	     * ```
	     *
	     * ---
	     *
	     * This object can be injected into other services.
	     *
	     * #### Deprecated Example:
	     * ```js
	     * SomeService.$inject = ['$http', '$stateParams'];
	     * function SomeService($http, $stateParams) {
	     *   return {
	     *     getUser: function() {
	     *       return $http.get('/api/users/' + $stateParams.username);
	     *     }
	     *   }
	     * };
	     * angular.service('SomeService', SomeService);
	     * ```
	     * @deprecated
	     */
	
	    /**
	     * # Angular 1 Directives
	     *
	     * These are the directives included in UI-Router for Angular 1.
	     * These directives are used in templates to create viewports and link/navigate to states.
	     *
	     * @preferred @publicapi @module directives
	     */ /** */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var parsed;
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states)
	                                .concat(splitClasses(activeEqClass))
	                                .reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng
	        .module('ui.router.state')
	        .filter('isState', $IsStateFilter)
	        .filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer(attrs, scope) {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig, unregister;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q', '$timeout'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q, $timeout) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$
	                    .treeChanges('to')
	                    .map(getNodeSchema)
	                    .reduce(core.unnestR, []);
	                var fromSchema = $transition$
	                    .treeChanges('from')
	                    .map(getNodeSchema)
	                    .reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (key) { exports[key] = core[key]; });
	    exports.core = core;
	    exports.default = index;
	    exports.watchDigests = watchDigests;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/** @publicapi @module common */ /** */
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(375));
	__export(__webpack_require__(385));
	__export(__webpack_require__(390));
	__export(__webpack_require__(394));
	__export(__webpack_require__(398));
	__export(__webpack_require__(432));
	__export(__webpack_require__(433));
	__export(__webpack_require__(434));
	__export(__webpack_require__(418));
	__export(__webpack_require__(412));
	__export(__webpack_require__(435));
	__export(__webpack_require__(447));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module common */ /** */
	__export(__webpack_require__(376));
	__export(__webpack_require__(379));
	__export(__webpack_require__(380));
	__export(__webpack_require__(378));
	__export(__webpack_require__(377));
	__export(__webpack_require__(381));
	__export(__webpack_require__(382));
	__export(__webpack_require__(384));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Random utility functions used in the UI-Router code
	 *
	 * These functions are exported, but are subject to change without notice.
	 *
	 * @preferred @publicapi @module common
	 */ /** */
	var predicates_1 = __webpack_require__(377);
	var hof_1 = __webpack_require__(378);
	var coreservices_1 = __webpack_require__(379);
	exports.root = (typeof self === 'object' && self.self === self && self) ||
	    (typeof global === 'object' && global.global === global && global) ||
	    this;
	var angular = exports.root.angular || {};
	exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
	exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
	exports.forEach = angular.forEach || _forEach;
	exports.extend = Object.assign || _extend;
	exports.equals = angular.equals || _equals;
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	function noop() { }
	exports.noop = noop;
	/**
	 * Builds proxy functions on the `to` object which pass through to the `from` object.
	 *
	 * For each key in `fnNames`, creates a proxy function on the `to` object.
	 * The proxy function calls the real function on the `from` object.
	 *
	 *
	 * #### Example:
	 * This example creates an new class instance whose functions are prebound to the new'd object.
	 * ```js
	 * class Foo {
	 *   constructor(data) {
	 *     // Binds all functions from Foo.prototype to 'this',
	 *     // then copies them to 'this'
	 *     bindFunctions(Foo.prototype, this, this);
	 *     this.data = data;
	 *   }
	 *
	 *   log() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * let myFoo = new Foo([1,2,3]);
	 * var logit = myFoo.log;
	 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
	 * ```
	 *
	 * #### Example:
	 * This example creates a bound version of a service function, and copies it to another object
	 * ```
	 *
	 * var SomeService = {
	 *   this.data = [3, 4, 5];
	 *   this.log = function() {
	 *     console.log(this.data);
	 *   }
	 * }
	 *
	 * // Constructor fn
	 * function OtherThing() {
	 *   // Binds all functions from SomeService to SomeService,
	 *   // then copies them to 'this'
	 *   bindFunctions(SomeService, this, SomeService);
	 * }
	 *
	 * let myOtherThing = new OtherThing();
	 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
	 * ```
	 *
	 * @param source A function that returns the source object which contains the original functions to be bound
	 * @param target A function that returns the target object which will receive the bound functions
	 * @param bind A function that returns the object which the functions will be bound to
	 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
	 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
	 */
	function createProxyFunctions(source, target, bind, fnNames, latebind) {
	    if (latebind === void 0) { latebind = false; }
	    var bindFunction = function (fnName) { return source()[fnName].bind(bind()); };
	    var makeLateRebindFn = function (fnName) {
	        return function lateRebindFunction() {
	            target[fnName] = bindFunction(fnName);
	            return target[fnName].apply(null, arguments);
	        };
	    };
	    fnNames = fnNames || Object.keys(source());
	    return fnNames.reduce(function (acc, name) {
	        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
	        return acc;
	    }, target);
	}
	exports.createProxyFunctions = createProxyFunctions;
	/**
	 * prototypal inheritance helper.
	 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
	 */
	exports.inherit = function (parent, extra) { return exports.extend(Object.create(parent), extra); };
	/** Given an array, returns true if the object is found in the array, (using indexOf) */
	exports.inArray = hof_1.curry(_inArray);
	function _inArray(array, obj) {
	    return array.indexOf(obj) !== -1;
	}
	exports._inArray = _inArray;
	/**
	 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
	 * The same array is returned
	 */
	exports.removeFrom = hof_1.curry(_removeFrom);
	function _removeFrom(array, obj) {
	    var idx = array.indexOf(obj);
	    if (idx >= 0)
	        array.splice(idx, 1);
	    return array;
	}
	exports._removeFrom = _removeFrom;
	/** pushes a values to an array and returns the value */
	exports.pushTo = hof_1.curry(_pushTo);
	function _pushTo(arr, val) {
	    return arr.push(val), val;
	}
	exports._pushTo = _pushTo;
	/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
	exports.deregAll = function (functions) {
	    return functions.slice().forEach(function (fn) {
	        typeof fn === 'function' && fn();
	        exports.removeFrom(functions, fn);
	    });
	};
	/**
	 * Applies a set of defaults to an options object.  The options object is filtered
	 * to only those properties of the objects in the defaultsList.
	 * Earlier objects in the defaultsList take precedence when applying defaults.
	 */
	function defaults(opts) {
	    var defaultsList = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        defaultsList[_i - 1] = arguments[_i];
	    }
	    var defaultVals = exports.extend.apply(void 0, [{}].concat(defaultsList.reverse()));
	    return exports.extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
	}
	exports.defaults = defaults;
	/** Reduce function that merges each element of the list into a single object, using extend */
	exports.mergeR = function (memo, item) { return exports.extend(memo, item); };
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	    var path = [];
	    // tslint:disable-next-line:forin
	    for (var n in first.path) {
	        if (first.path[n] !== second.path[n])
	            break;
	        path.push(first.path[n]);
	    }
	    return path;
	}
	exports.ancestors = ancestors;
	/**
	 * Return a copy of the object only containing the whitelisted properties.
	 *
	 * #### Example:
	 * ```
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the whitelisted property names
	 */
	function pick(obj, propNames) {
	    var objCopy = {};
	    for (var _prop in obj) {
	        if (propNames.indexOf(_prop) !== -1) {
	            objCopy[_prop] = obj[_prop];
	        }
	    }
	    return objCopy;
	}
	exports.pick = pick;
	/**
	 * Return a copy of the object omitting the blacklisted properties.
	 *
	 * @example
	 * ```
	 *
	 * var foo = { a: 1, b: 2, c: 3 };
	 * var ab = omit(foo, ['a', 'b']); // { c: 3 }
	 * ```
	 * @param obj the source object
	 * @param propNames an Array of strings, which are the blacklisted property names
	 */
	function omit(obj, propNames) {
	    return Object.keys(obj)
	        .filter(hof_1.not(exports.inArray(propNames)))
	        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
	}
	exports.omit = omit;
	/**
	 * Maps an array, or object to a property (by name)
	 */
	function pluck(collection, propName) {
	    return map(collection, hof_1.prop(propName));
	}
	exports.pluck = pluck;
	/** Filters an Array or an Object's properties based on a predicate */
	function filter(collection, callback) {
	    var arr = predicates_1.isArray(collection), result = arr ? [] : {};
	    var accept = arr ? function (x) { return result.push(x); } : function (x, key) { return (result[key] = x); };
	    exports.forEach(collection, function (item, i) {
	        if (callback(item, i))
	            accept(item, i);
	    });
	    return result;
	}
	exports.filter = filter;
	/** Finds an object from an array, or a property of an object, that matches a predicate */
	function find(collection, callback) {
	    var result;
	    exports.forEach(collection, function (item, i) {
	        if (result)
	            return;
	        if (callback(item, i))
	            result = item;
	    });
	    return result;
	}
	exports.find = find;
	/** Given an object, returns a new object, where each property is transformed by the callback function */
	exports.mapObj = map;
	/** Maps an array or object properties using a callback function */
	function map(collection, callback, target) {
	    target = target || (predicates_1.isArray(collection) ? [] : {});
	    exports.forEach(collection, function (item, i) { return (target[i] = callback(item, i)); });
	    return target;
	}
	exports.map = map;
	/**
	 * Given an object, return its enumerable property values
	 *
	 * @example
	 * ```
	 *
	 * let foo = { a: 1, b: 2, c: 3 }
	 * let vals = values(foo); // [ 1, 2, 3 ]
	 * ```
	 */
	exports.values = function (obj) { return Object.keys(obj).map(function (key) { return obj[key]; }); };
	/**
	 * Reduce function that returns true if all of the values are truthy.
	 *
	 * @example
	 * ```
	 *
	 * let vals = [ 1, true, {}, "hello world"];
	 * vals.reduce(allTrueR, true); // true
	 *
	 * vals.push(0);
	 * vals.reduce(allTrueR, true); // false
	 * ```
	 */
	exports.allTrueR = function (memo, elem) { return memo && elem; };
	/**
	 * Reduce function that returns true if any of the values are truthy.
	 *
	 *  * @example
	 * ```
	 *
	 * let vals = [ 0, null, undefined ];
	 * vals.reduce(anyTrueR, true); // false
	 *
	 * vals.push("hello world");
	 * vals.reduce(anyTrueR, true); // true
	 * ```
	 */
	exports.anyTrueR = function (memo, elem) { return memo || elem; };
	/**
	 * Reduce function which un-nests a single level of arrays
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnestR = function (memo, elem) { return memo.concat(elem); };
	/**
	 * Reduce function which recursively un-nests all arrays
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flattenR = function (memo, elem) {
	    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
	};
	/**
	 * Reduce function that pushes an object to an array, then returns the array.
	 * Mostly just for [[flattenR]] and [[uniqR]]
	 */
	function pushR(arr, obj) {
	    arr.push(obj);
	    return arr;
	}
	exports.pushR = pushR;
	/** Reduce function that filters out duplicates */
	exports.uniqR = function (acc, token) { return (exports.inArray(acc, token) ? acc : pushR(acc, token)); };
	/**
	 * Return a new array with a single level of arrays unnested.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
	 * ```
	 */
	exports.unnest = function (arr) { return arr.reduce(exports.unnestR, []); };
	/**
	 * Return a completely flattened version of an array.
	 *
	 * @example
	 * ```
	 *
	 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
	 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
	 * ```
	 */
	exports.flatten = function (arr) { return arr.reduce(exports.flattenR, []); };
	/**
	 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
	 * @example
	 * ```
	 *
	 * let isNumber = (obj) => typeof(obj) === 'number';
	 * let allNumbers = [ 1, 2, 3, 4, 5 ];
	 * allNumbers.filter(assertPredicate(isNumber)); //OK
	 *
	 * let oneString = [ 1, 2, 3, 4, "5" ];
	 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
	 * ```
	 */
	exports.assertPredicate = assertFn;
	/**
	 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
	 * @example
	 * ```
	 *
	 * var data = { foo: 1, bar: 2 };
	 *
	 * let keys = [ 'foo', 'bar' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // values is [1, 2]
	 *
	 * let keys = [ 'foo', 'bar', 'baz' ]
	 * let values = keys.map(assertMap(key => data[key], "Key not found"));
	 * // throws Error("Key not found")
	 * ```
	 */
	exports.assertMap = assertFn;
	function assertFn(predicateOrMap, errMsg) {
	    if (errMsg === void 0) { errMsg = 'assert failure'; }
	    return function (obj) {
	        var result = predicateOrMap(obj);
	        if (!result) {
	            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
	        }
	        return result;
	    };
	}
	exports.assertFn = assertFn;
	/**
	 * Like _.pairs: Given an object, returns an array of key/value pairs
	 *
	 * @example
	 * ```
	 *
	 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
	 * ```
	 */
	exports.pairs = function (obj) { return Object.keys(obj).map(function (key) { return [key, obj[key]]; }); };
	/**
	 * Given two or more parallel arrays, returns an array of tuples where
	 * each tuple is composed of [ a[i], b[i], ... z[i] ]
	 *
	 * @example
	 * ```
	 *
	 * let foo = [ 0, 2, 4, 6 ];
	 * let bar = [ 1, 3, 5, 7 ];
	 * let baz = [ 10, 30, 50, 70 ];
	 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
	 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
	 * ```
	 */
	function arrayTuples() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    if (args.length === 0)
	        return [];
	    var maxArrayLen = args.reduce(function (min, arr) { return Math.min(arr.length, min); }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
	    var result = [];
	    var _loop_1 = function (i) {
	        // This is a hot function
	        // Unroll when there are 1-4 arguments
	        switch (args.length) {
	            case 1:
	                result.push([args[0][i]]);
	                break;
	            case 2:
	                result.push([args[0][i], args[1][i]]);
	                break;
	            case 3:
	                result.push([args[0][i], args[1][i], args[2][i]]);
	                break;
	            case 4:
	                result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
	                break;
	            default:
	                result.push(args.map(function (array) { return array[i]; }));
	                break;
	        }
	    };
	    for (var i = 0; i < maxArrayLen; i++) {
	        _loop_1(i);
	    }
	    return result;
	}
	exports.arrayTuples = arrayTuples;
	/**
	 * Reduce function which builds an object from an array of [key, value] pairs.
	 *
	 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
	 *
	 * Each keyValueTuple should be an array with values [ key: string, value: any ]
	 *
	 * @example
	 * ```
	 *
	 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
	 *
	 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 *
	 * // Or, more simply:
	 * var pairsToObj = pairs.reduce(applyPairs, {})
	 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
	 * ```
	 */
	function applyPairs(memo, keyValTuple) {
	    var key, value;
	    if (predicates_1.isArray(keyValTuple))
	        key = keyValTuple[0], value = keyValTuple[1];
	    if (!predicates_1.isString(key))
	        throw new Error('invalid parameters to applyPairs');
	    memo[key] = value;
	    return memo;
	}
	exports.applyPairs = applyPairs;
	/** Get the last element of an array */
	function tail(arr) {
	    return (arr.length && arr[arr.length - 1]) || undefined;
	}
	exports.tail = tail;
	/**
	 * shallow copy from src to dest
	 */
	function copy(src, dest) {
	    if (dest)
	        Object.keys(dest).forEach(function (key) { return delete dest[key]; });
	    if (!dest)
	        dest = {};
	    return exports.extend(dest, src);
	}
	exports.copy = copy;
	/** Naive forEach implementation works with Objects or Arrays */
	function _forEach(obj, cb, _this) {
	    if (predicates_1.isArray(obj))
	        return obj.forEach(cb, _this);
	    Object.keys(obj).forEach(function (key) { return cb(obj[key], key); });
	}
	function _extend(toObj) {
	    for (var i = 1; i < arguments.length; i++) {
	        var obj = arguments[i];
	        if (!obj)
	            continue;
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; j++) {
	            toObj[keys[j]] = obj[keys[j]];
	        }
	    }
	    return toObj;
	}
	exports._extend = _extend;
	function _equals(o1, o2) {
	    if (o1 === o2)
	        return true;
	    if (o1 === null || o2 === null)
	        return false;
	    if (o1 !== o1 && o2 !== o2)
	        return true; // NaN === NaN
	    var t1 = typeof o1, t2 = typeof o2;
	    if (t1 !== t2 || t1 !== 'object')
	        return false;
	    var tup = [o1, o2];
	    if (hof_1.all(predicates_1.isArray)(tup))
	        return _arraysEq(o1, o2);
	    if (hof_1.all(predicates_1.isDate)(tup))
	        return o1.getTime() === o2.getTime();
	    if (hof_1.all(predicates_1.isRegExp)(tup))
	        return o1.toString() === o2.toString();
	    if (hof_1.all(predicates_1.isFunction)(tup))
	        return true; // meh
	    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
	    if (predicates.map(hof_1.any).reduce(function (b, fn) { return b || !!fn(tup); }, false))
	        return false;
	    var keys = {};
	    // tslint:disable-next-line:forin
	    for (var key in o1) {
	        if (!_equals(o1[key], o2[key]))
	            return false;
	        keys[key] = true;
	    }
	    for (var key in o2) {
	        if (!keys[key])
	            return false;
	    }
	    return true;
	}
	function _arraysEq(a1, a2) {
	    if (a1.length !== a2.length)
	        return false;
	    return arrayTuples(a1, a2).reduce(function (b, t) { return b && _equals(t[0], t[1]); }, true);
	}
	// issue #2676
	exports.silenceUncaughtInPromise = function (promise) { return promise.catch(function (e) { return 0; }) && promise; };
	exports.silentRejection = function (error) { return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error)); };
	//# sourceMappingURL=common.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** Predicates
	 *
	 * These predicates return true/false based on the input.
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @module common_predicates
	 */ /** */
	var hof_1 = __webpack_require__(378);
	var toStr = Object.prototype.toString;
	var tis = function (t) { return function (x) { return typeof x === t; }; };
	exports.isUndefined = tis('undefined');
	exports.isDefined = hof_1.not(exports.isUndefined);
	exports.isNull = function (o) { return o === null; };
	exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
	exports.isFunction = tis('function');
	exports.isNumber = tis('number');
	exports.isString = tis('string');
	exports.isObject = function (x) { return x !== null && typeof x === 'object'; };
	exports.isArray = Array.isArray;
	exports.isDate = (function (x) { return toStr.call(x) === '[object Date]'; });
	exports.isRegExp = (function (x) { return toStr.call(x) === '[object RegExp]'; });
	/**
	 * Predicate which checks if a value is injectable
	 *
	 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
	 * where all the elements in the array are Strings, except the last one, which is a Function
	 */
	function isInjectable(val) {
	    if (exports.isArray(val) && val.length) {
	        var head = val.slice(0, -1), tail = val.slice(-1);
	        return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
	    }
	    return exports.isFunction(val);
	}
	exports.isInjectable = isInjectable;
	/**
	 * Predicate which checks if a value looks like a Promise
	 *
	 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
	 */
	exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
	//# sourceMappingURL=predicates.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * Higher order functions
	 *
	 * These utility functions are exported, but are subject to change without notice.
	 *
	 * @module common_hof
	 */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
	 *
	 * Given a function with N parameters, returns a new function that supports partial application.
	 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
	 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
	 * accept more parameters until all N parameters have been supplied.
	 *
	 *
	 * This contrived example uses a partially applied function as an predicate, which returns true
	 * if an object is found in both arrays.
	 * @example
	 * ```
	 * // returns true if an object is in both of the two arrays
	 * function inBoth(array1, array2, object) {
	 *   return array1.indexOf(object) !== -1 &&
	 *          array2.indexOf(object) !== 1;
	 * }
	 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
	 * let foos = [obj1, obj3]
	 * let bars = [obj3, obj4, obj5]
	 *
	 * // A curried "copy" of inBoth
	 * let curriedInBoth = curry(inBoth);
	 * // Partially apply both the array1 and array2
	 * let inFoosAndBars = curriedInBoth(foos, bars);
	 *
	 * // Supply the final argument; since all arguments are
	 * // supplied, the original inBoth function is then called.
	 * let obj1InBoth = inFoosAndBars(obj1); // false
	 *
	 * // Use the inFoosAndBars as a predicate.
	 * // Filter, on each iteration, supplies the final argument
	 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
	 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
	 *
	 * ```
	 *
	 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
	 *
	 * @param fn
	 * @returns {*|function(): (*|any)}
	 */
	function curry(fn) {
	    var initial_args = [].slice.apply(arguments, [1]);
	    var func_args_length = fn.length;
	    function curried(args) {
	        if (args.length >= func_args_length)
	            return fn.apply(null, args);
	        return function () {
	            return curried(args.concat([].slice.apply(arguments)));
	        };
	    }
	    return curried(initial_args);
	}
	exports.curry = curry;
	/**
	 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
	 * given: f(x), g(x), h(x)
	 * let composed = compose(f,g,h)
	 * then, composed is: f(g(h(x)))
	 */
	function compose() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start, result = args[start].apply(this, arguments);
	        while (i--)
	            result = args[i].call(this, result);
	        return result;
	    };
	}
	exports.compose = compose;
	/**
	 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
	 * given: f(x), g(x), h(x)
	 * let piped = pipe(f,g,h);
	 * then, piped is: h(g(f(x)))
	 */
	function pipe() {
	    var funcs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        funcs[_i] = arguments[_i];
	    }
	    return compose.apply(null, [].slice.call(arguments).reverse());
	}
	exports.pipe = pipe;
	/**
	 * Given a property name, returns a function that returns that property from an object
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = prop("name");
	 * getName(obj) === "blarg"
	 */
	exports.prop = function (name) { return function (obj) { return obj && obj[name]; }; };
	/**
	 * Given a property name and a value, returns a function that returns a boolean based on whether
	 * the passed object has a property that matches the value
	 * let obj = { foo: 1, name: "blarg" };
	 * let getName = propEq("name", "blarg");
	 * getName(obj) === true
	 */
	exports.propEq = curry(function (name, _val, obj) { return obj && obj[name] === _val; });
	/**
	 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
	 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
	 * let getName = prop("nestedObj.name");
	 * getName(obj) === "blarg"
	 * let propNotFound = prop("this.property.doesnt.exist");
	 * propNotFound(obj) === undefined
	 */
	exports.parse = function (name) { return pipe.apply(null, name.split('.').map(exports.prop)); };
	/**
	 * Given a function that returns a truthy or falsey value, returns a
	 * function that returns the opposite (falsey or truthy) value given the same inputs
	 */
	exports.not = function (fn) { return function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return !fn.apply(null, args);
	}; };
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if both functions return truthy for the given arguments
	 */
	function and(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) && fn2.apply(null, args);
	    };
	}
	exports.and = and;
	/**
	 * Given two functions that return truthy or falsey values, returns a function that returns truthy
	 * if at least one of the functions returns truthy for the given arguments
	 */
	function or(fn1, fn2) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return fn1.apply(null, args) || fn2.apply(null, args);
	    };
	}
	exports.or = or;
	/**
	 * Check if all the elements of an array match a predicate function
	 *
	 * @param fn1 a predicate function `fn1`
	 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
	 */
	exports.all = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b && !!fn1(x); }, true); }; };
	// tslint:disable-next-line:variable-name
	exports.any = function (fn1) { return function (arr) { return arr.reduce(function (b, x) { return b || !!fn1(x); }, false); }; };
	/** Given a class, returns a Predicate function that returns true if the object is of that class */
	exports.is = function (ctor) { return function (obj) {
	    return (obj != null && obj.constructor === ctor) || obj instanceof ctor;
	}; };
	/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
	exports.eq = function (value) { return function (other) { return value === other; }; };
	/** Given a value, returns a function which returns the value */
	exports.val = function (v) { return function () { return v; }; };
	function invoke(fnName, args) {
	    return function (obj) { return obj[fnName].apply(obj, args); };
	}
	exports.invoke = invoke;
	/**
	 * Sorta like Pattern Matching (a functional programming conditional construct)
	 *
	 * See http://c2.com/cgi/wiki?PatternMatching
	 *
	 * This is a conditional construct which allows a series of predicates and output functions
	 * to be checked and then applied.  Each predicate receives the input.  If the predicate
	 * returns truthy, then its matching output function (mapping function) is provided with
	 * the input and, then the result is returned.
	 *
	 * Each combination (2-tuple) of predicate + output function should be placed in an array
	 * of size 2: [ predicate, mapFn ]
	 *
	 * These 2-tuples should be put in an outer array.
	 *
	 * @example
	 * ```
	 *
	 * // Here's a 2-tuple where the first element is the isString predicate
	 * // and the second element is a function that returns a description of the input
	 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
	 *
	 * // Second tuple: predicate "isNumber", mapfn returns a description
	 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
	 *
	 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
	 *
	 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
	 *
	 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
	 *
	 * console.log(descriptionOf(undefined)); // 'notdefined'
	 * console.log(descriptionOf(55)); // '(55) That's a number!'
	 * console.log(descriptionOf("foo")); // 'Here's your string foo'
	 * ```
	 *
	 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
	 * with a Predicate and a mapping/output function
	 * @returns {function(any): *}
	 */
	function pattern(struct) {
	    return function (x) {
	        for (var i = 0; i < struct.length; i++) {
	            if (struct[i][0](x))
	                return struct[i][1](x);
	        }
	    };
	}
	exports.pattern = pattern;
	//# sourceMappingURL=hof.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var noImpl = function (fnname) { return function () {
	    throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
	}; };
	exports.makeStub = function (service, methods) {
	    return methods.reduce(function (acc, key) { return ((acc[key] = noImpl(service + "." + key + "()")), acc); }, {});
	};
	var services = {
	    $q: undefined,
	    $injector: undefined,
	};
	exports.services = services;
	//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module core */
	/**
	 * Matches state names using glob-like pattern strings.
	 *
	 * Globs can be used in specific APIs including:
	 *
	 * - [[StateService.is]]
	 * - [[StateService.includes]]
	 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
	 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
	 *
	 * A `Glob` string is a pattern which matches state names.
	 * Nested state names are split into segments (separated by a dot) when processing.
	 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
	 *
	 * Globs work according to the following rules:
	 *
	 * ### Exact match:
	 *
	 * The glob `'A.B'` matches the state named exactly `'A.B'`.
	 *
	 * | Glob        |Matches states named|Does not match state named|
	 * |:------------|:--------------------|:---------------------|
	 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
	 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
	 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
	 *
	 * ### Single star (`*`)
	 *
	 * A single star (`*`) is a wildcard that matches exactly one segment.
	 *
	 * | Glob        |Matches states named  |Does not match state named |
	 * |:------------|:---------------------|:--------------------------|
	 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
	 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
	 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
	 *
	 * ### Double star (`**`)
	 *
	 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
	 *
	 * | Glob        |Matches states named                           |Does not match state named         |
	 * |:------------|:----------------------------------------------|:----------------------------------|
	 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
	 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
	 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
	 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
	 *
	 */
	var Glob = /** @class */ (function () {
	    function Glob(text) {
	        this.text = text;
	        this.glob = text.split('.');
	        var regexpString = this.text
	            .split('.')
	            .map(function (seg) {
	            if (seg === '**')
	                return '(?:|(?:\\.[^.]*)*)';
	            if (seg === '*')
	                return '\\.[^.]*';
	            return '\\.' + seg;
	        })
	            .join('');
	        this.regexp = new RegExp('^' + regexpString + '$');
	    }
	    /** Returns true if the string has glob-like characters in it */
	    Glob.is = function (text) {
	        return !!/[!,*]+/.exec(text);
	    };
	    /** Returns a glob from the string, or null if the string isn't Glob-like */
	    Glob.fromString = function (text) {
	        return Glob.is(text) ? new Glob(text) : null;
	    };
	    Glob.prototype.matches = function (name) {
	        return this.regexp.test('.' + name);
	    };
	    return Glob;
	}());
	exports.Glob = Glob;
	//# sourceMappingURL=glob.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module common */ /** */
	var common_1 = __webpack_require__(376);
	var Queue = /** @class */ (function () {
	    function Queue(_items, _limit) {
	        if (_items === void 0) { _items = []; }
	        if (_limit === void 0) { _limit = null; }
	        this._items = _items;
	        this._limit = _limit;
	        this._evictListeners = [];
	        this.onEvict = common_1.pushTo(this._evictListeners);
	    }
	    Queue.prototype.enqueue = function (item) {
	        var items = this._items;
	        items.push(item);
	        if (this._limit && items.length > this._limit)
	            this.evict();
	        return item;
	    };
	    Queue.prototype.evict = function () {
	        var item = this._items.shift();
	        this._evictListeners.forEach(function (fn) { return fn(item); });
	        return item;
	    };
	    Queue.prototype.dequeue = function () {
	        if (this.size())
	            return this._items.splice(0, 1)[0];
	    };
	    Queue.prototype.clear = function () {
	        var current = this._items;
	        this._items = [];
	        return current;
	    };
	    Queue.prototype.size = function () {
	        return this._items.length;
	    };
	    Queue.prototype.remove = function (item) {
	        var idx = this._items.indexOf(item);
	        return idx > -1 && this._items.splice(idx, 1)[0];
	    };
	    Queue.prototype.peekTail = function () {
	        return this._items[this._items.length - 1];
	    };
	    Queue.prototype.peekHead = function () {
	        if (this.size())
	            return this._items[0];
	    };
	    return Queue;
	}());
	exports.Queue = Queue;
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Functions that manipulate strings
	 *
	 * Although these functions are exported, they are subject to change without notice.
	 *
	 * @module common_strings
	 */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	var predicates_1 = __webpack_require__(377);
	var rejectFactory_1 = __webpack_require__(383);
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	/**
	 * Returns a string shortened to a maximum length
	 *
	 * If the string is already less than the `max` length, return the string.
	 * Else return the string, shortened to `max - 3` and append three dots ("...").
	 *
	 * @param max the maximum length of the string to return
	 * @param str the input string
	 */
	function maxLength(max, str) {
	    if (str.length <= max)
	        return str;
	    return str.substr(0, max - 3) + '...';
	}
	exports.maxLength = maxLength;
	/**
	 * Returns a string, with spaces added to the end, up to a desired str length
	 *
	 * If the string is already longer than the desired length, return the string.
	 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
	 *
	 * @param length the desired length of the string to return
	 * @param str the input string
	 */
	function padString(length, str) {
	    while (str.length < length)
	        str += ' ';
	    return str;
	}
	exports.padString = padString;
	function kebobString(camelCase) {
	    return camelCase
	        .replace(/^([A-Z])/, function ($1) { return $1.toLowerCase(); }) // replace first char
	        .replace(/([A-Z])/g, function ($1) { return '-' + $1.toLowerCase(); }); // replace rest
	}
	exports.kebobString = kebobString;
	function functionToString(fn) {
	    var fnStr = fnToString(fn);
	    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
	    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
	    var fnName = fn['name'] || '';
	    if (fnName && toStr.match(/function \(/)) {
	        return 'function ' + fnName + toStr.substr(9);
	    }
	    return toStr;
	}
	exports.functionToString = functionToString;
	function fnToString(fn) {
	    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
	    return (_fn && _fn.toString()) || 'undefined';
	}
	exports.fnToString = fnToString;
	var isRejection = rejectFactory_1.Rejection.isRejectionPromise;
	var hasToString = function (obj) {
	    return predicates_1.isObject(obj) && !predicates_1.isArray(obj) && obj.constructor !== Object && predicates_1.isFunction(obj.toString);
	};
	var stringifyPattern = hof_1.pattern([
	    [predicates_1.isUndefined, hof_1.val('undefined')],
	    [predicates_1.isNull, hof_1.val('null')],
	    [predicates_1.isPromise, hof_1.val('[Promise]')],
	    [isRejection, function (x) { return x._transitionRejection.toString(); }],
	    [hasToString, function (x) { return x.toString(); }],
	    [predicates_1.isInjectable, functionToString],
	    [hof_1.val(true), common_1.identity],
	]);
	function stringify(o) {
	    var seen = [];
	    function format(value) {
	        if (predicates_1.isObject(value)) {
	            if (seen.indexOf(value) !== -1)
	                return '[circular ref]';
	            seen.push(value);
	        }
	        return stringifyPattern(value);
	    }
	    if (predicates_1.isUndefined(o)) {
	        // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
	        // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
	        // manually stringifying it.
	        return format(o);
	    }
	    return JSON.stringify(o, function (key, value) { return format(value); }).replace(/\\"/g, '"');
	}
	exports.stringify = stringify;
	/** Returns a function that splits a string on a character or substring */
	exports.beforeAfterSubstr = function (char) { return function (str) {
	    if (!str)
	        return ['', ''];
	    var idx = str.indexOf(char);
	    if (idx === -1)
	        return [str, ''];
	    return [str.substr(0, idx), str.substr(idx + 1)];
	}; };
	exports.hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
	exports.stripLastPathElement = function (str) { return str.replace(/\/[^/]*$/, ''); };
	exports.splitHash = exports.beforeAfterSubstr('#');
	exports.splitQuery = exports.beforeAfterSubstr('?');
	exports.splitEqual = exports.beforeAfterSubstr('=');
	exports.trimHashVal = function (str) { return (str ? str.replace(/^#/, '') : ''); };
	/**
	 * Splits on a delimiter, but returns the delimiters in the array
	 *
	 * #### Example:
	 * ```js
	 * var splitOnSlashes = splitOnDelim('/');
	 * splitOnSlashes("/foo"); // ["/", "foo"]
	 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
	 * ```
	 */
	function splitOnDelim(delim) {
	    var re = new RegExp('(' + delim + ')', 'g');
	    return function (str) { return str.split(re).filter(common_1.identity); };
	}
	exports.splitOnDelim = splitOnDelim;
	/**
	 * Reduce fn that joins neighboring strings
	 *
	 * Given an array of strings, returns a new array
	 * where all neighboring strings have been joined.
	 *
	 * #### Example:
	 * ```js
	 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
	 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
	 * ```
	 */
	function joinNeighborsR(acc, x) {
	    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x))
	        return acc.slice(0, -1).concat(common_1.tail(acc) + x);
	    return common_1.pushR(acc, x);
	}
	exports.joinNeighborsR = joinNeighborsR;
	//# sourceMappingURL=strings.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/** @publicapi @module transition */ /** */
	'use strict';
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(376);
	var strings_1 = __webpack_require__(382);
	var hof_1 = __webpack_require__(378);
	var RejectType;
	(function (RejectType) {
	    /**
	     * A new transition superseded this one.
	     *
	     * While this transition was running, a new transition started.
	     * This transition is cancelled because it was superseded by new transition.
	     */
	    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
	    /**
	     * The transition was aborted
	     *
	     * The transition was aborted by a hook which returned `false`
	     */
	    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
	    /**
	     * The transition was invalid
	     *
	     * The transition was never started because it was invalid
	     */
	    RejectType[RejectType["INVALID"] = 4] = "INVALID";
	    /**
	     * The transition was ignored
	     *
	     * The transition was ignored because it would have no effect.
	     *
	     * Either:
	     *
	     * - The transition is targeting the current state and parameter values
	     * - The transition is targeting the same state and parameter values as the currently running transition.
	     */
	    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
	    /**
	     * The transition errored.
	     *
	     * This generally means a hook threw an error or returned a rejected promise
	     */
	    RejectType[RejectType["ERROR"] = 6] = "ERROR";
	})(RejectType || (RejectType = {}));
	exports.RejectType = RejectType;
	/** @hidden */
	var id = 0;
	var Rejection = /** @class */ (function () {
	    function Rejection(type, message, detail) {
	        /** @hidden */
	        this.$id = id++;
	        this.type = type;
	        this.message = message;
	        this.detail = detail;
	    }
	    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
	    Rejection.isRejectionPromise = function (obj) {
	        return obj && typeof obj.then === 'function' && hof_1.is(Rejection)(obj._transitionRejection);
	    };
	    /** Returns a Rejection due to transition superseded */
	    Rejection.superseded = function (detail, options) {
	        var message = 'The transition has been superseded by a different transition';
	        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
	        if (options && options.redirected) {
	            rejection.redirected = true;
	        }
	        return rejection;
	    };
	    /** Returns a Rejection due to redirected transition */
	    Rejection.redirected = function (detail) {
	        return Rejection.superseded(detail, { redirected: true });
	    };
	    /** Returns a Rejection due to invalid transition */
	    Rejection.invalid = function (detail) {
	        var message = 'This transition is invalid';
	        return new Rejection(RejectType.INVALID, message, detail);
	    };
	    /** Returns a Rejection due to ignored transition */
	    Rejection.ignored = function (detail) {
	        var message = 'The transition was ignored';
	        return new Rejection(RejectType.IGNORED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.aborted = function (detail) {
	        var message = 'The transition has been aborted';
	        return new Rejection(RejectType.ABORTED, message, detail);
	    };
	    /** Returns a Rejection due to aborted transition */
	    Rejection.errored = function (detail) {
	        var message = 'The transition errored';
	        return new Rejection(RejectType.ERROR, message, detail);
	    };
	    /**
	     * Returns a Rejection
	     *
	     * Normalizes a value as a Rejection.
	     * If the value is already a Rejection, returns it.
	     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
	     *
	     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
	     */
	    Rejection.normalize = function (detail) {
	        return hof_1.is(Rejection)(detail) ? detail : Rejection.errored(detail);
	    };
	    Rejection.prototype.toString = function () {
	        var detailString = function (d) { return (d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d)); };
	        var detail = detailString(this.detail);
	        var _a = this, $id = _a.$id, type = _a.type, message = _a.message;
	        return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
	    };
	    Rejection.prototype.toPromise = function () {
	        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
	    };
	    return Rejection;
	}());
	exports.Rejection = Rejection;
	//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition tracing (debug)
	 *
	 * Enable transition tracing to print transition information to the console,
	 * in order to help debug your application.
	 * Tracing logs detailed information about each Transition to your console.
	 *
	 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
	 *
	 * ### ES6
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
	 * ```
	 *
	 * ### CJS
	 * ```js
	 * let trace = require("@uirouter/core").trace;
	 * trace.enable("TRANSITION", "VIEWCONFIG");
	 * ```
	 *
	 * ### Globals
	 * ```js
	 * let trace = window["@uirouter/core"].trace;
	 * trace.enable(); // Trace everything (very verbose)
	 * ```
	 *
	 * ### Angular 1:
	 * ```js
	 * app.run($trace => $trace.enable());
	 * ```
	 *
	 * @publicapi @module trace
	 */
	/* tslint:disable:no-console */
	var hof_1 = __webpack_require__(378);
	var predicates_1 = __webpack_require__(377);
	var strings_1 = __webpack_require__(382);
	/** @hidden */
	function uiViewString(uiview) {
	    if (!uiview)
	        return 'ui-view (defunct)';
	    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
	    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
	}
	/** @hidden */
	var viewConfigString = function (viewConfig) {
	    var view = viewConfig.viewDecl;
	    var state = view.$context.name || '(root)';
	    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
	};
	/** @hidden */
	function normalizedCat(input) {
	    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
	}
	/** @hidden */
	var consoleLog = Function.prototype.bind.call(console.log, console);
	/** @hidden */
	var consoletable = predicates_1.isFunction(console.table) ? console.table.bind(console) : consoleLog.bind(console);
	/**
	 * Trace categories Enum
	 *
	 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
	 *
	 * `trace.enable(Category.TRANSITION)`
	 *
	 * These can also be provided using a matching string, or position ordinal
	 *
	 * `trace.enable("TRANSITION")`
	 *
	 * `trace.enable(1)`
	 */
	var Category;
	(function (Category) {
	    Category[Category["RESOLVE"] = 0] = "RESOLVE";
	    Category[Category["TRANSITION"] = 1] = "TRANSITION";
	    Category[Category["HOOK"] = 2] = "HOOK";
	    Category[Category["UIVIEW"] = 3] = "UIVIEW";
	    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
	})(Category || (Category = {}));
	exports.Category = Category;
	/** @hidden */
	var _tid = hof_1.parse('$id');
	/** @hidden */
	var _rid = hof_1.parse('router.$id');
	/** @hidden */
	var transLbl = function (trans) { return "Transition #" + _tid(trans) + "-" + _rid(trans); };
	/**
	 * Prints UI-Router Transition trace information to the console.
	 */
	var Trace = /** @class */ (function () {
	    /** @hidden */
	    function Trace() {
	        /** @hidden */
	        this._enabled = {};
	        this.approximateDigests = 0;
	    }
	    /** @hidden */
	    Trace.prototype._set = function (enabled, categories) {
	        var _this = this;
	        if (!categories.length) {
	            categories = Object.keys(Category)
	                .map(function (k) { return parseInt(k, 10); })
	                .filter(function (k) { return !isNaN(k); })
	                .map(function (key) { return Category[key]; });
	        }
	        categories.map(normalizedCat).forEach(function (category) { return (_this._enabled[category] = enabled); });
	    };
	    Trace.prototype.enable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(true, categories);
	    };
	    Trace.prototype.disable = function () {
	        var categories = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            categories[_i] = arguments[_i];
	        }
	        this._set(false, categories);
	    };
	    /**
	     * Retrieves the enabled stateus of a [[Category]]
	     *
	     * ```js
	     * trace.enabled("VIEWCONFIG"); // true or false
	     * ```
	     *
	     * @returns boolean true if the category is enabled
	     */
	    Trace.prototype.enabled = function (category) {
	        return !!this._enabled[normalizedCat(category)];
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceTransitionStart = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        console.log(transLbl(trans) + ": Started  -> " + strings_1.stringify(trans));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceTransitionIgnored = function (trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        console.log(transLbl(trans) + ": Ignored  <> " + strings_1.stringify(trans));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceHookInvocation = function (step, trans, options) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.functionToString(step.registeredHook.callback);
	        console.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
	        if (!this.enabled(Category.HOOK))
	            return;
	        console.log(transLbl(trans) + ":   <- Hook returned: " + strings_1.maxLength(200, strings_1.stringify(hookResult)));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceResolvePath = function (path, when, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        console.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
	        if (!this.enabled(Category.RESOLVE))
	            return;
	        console.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + strings_1.maxLength(200, strings_1.stringify(resolvable.data)));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceError = function (reason, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        console.log(transLbl(trans) + ": <- Rejected " + strings_1.stringify(trans) + ", reason: " + reason);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceSuccess = function (finalState, trans) {
	        if (!this.enabled(Category.TRANSITION))
	            return;
	        console.log(transLbl(trans) + ": <- Success  " + strings_1.stringify(trans) + ", final state: " + finalState.name);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
	        if (extra === void 0) { extra = ''; }
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceUIViewFill = function (viewData, html) {
	        if (!this.enabled(Category.UIVIEW))
	            return;
	        this.traceUIViewEvent('Fill', viewData, " with: " + strings_1.maxLength(200, html));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceViewSync = function (pairs) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        var uivheader = 'uiview component fqn';
	        var cfgheader = 'view config state (view name)';
	        var mapping = pairs
	            .map(function (_a) {
	            var uiView = _a.uiView, viewConfig = _a.viewConfig;
	            var _b;
	            var uiv = uiView && uiView.fqn;
	            var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
	            return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
	        })
	            .sort(function (a, b) { return (a[uivheader] || '').localeCompare(b[uivheader] || ''); });
	        consoletable(mapping);
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
	    };
	    /** @internalapi called by ui-router code */
	    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
	        if (!this.enabled(Category.VIEWCONFIG))
	            return;
	        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
	    };
	    return Trace;
	}());
	exports.Trace = Trace;
	/**
	 * The [[Trace]] singleton
	 *
	 * #### Example:
	 * ```js
	 * import {trace} from "@uirouter/core";
	 * trace.enable(1, 5);
	 * ```
	 */
	var trace = new Trace();
	exports.trace = trace;
	//# sourceMappingURL=trace.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(386));
	__export(__webpack_require__(388));
	__export(__webpack_require__(389));
	__export(__webpack_require__(387));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module params */ /** */
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var predicates_1 = __webpack_require__(377);
	var coreservices_1 = __webpack_require__(379);
	var paramType_1 = __webpack_require__(387);
	/** @hidden */
	var hasOwn = Object.prototype.hasOwnProperty;
	/** @hidden */
	var isShorthand = function (cfg) {
	    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
	};
	/** @internalapi */
	var DefType;
	(function (DefType) {
	    DefType[DefType["PATH"] = 0] = "PATH";
	    DefType[DefType["SEARCH"] = 1] = "SEARCH";
	    DefType[DefType["CONFIG"] = 2] = "CONFIG";
	})(DefType || (DefType = {}));
	exports.DefType = DefType;
	/** @internalapi */
	function getParamDeclaration(paramName, location, state) {
	    var noReloadOnSearch = (state.reloadOnSearch === false && location === DefType.SEARCH) || undefined;
	    var dynamic = common_1.find([state.dynamic, noReloadOnSearch], predicates_1.isDefined);
	    var defaultConfig = predicates_1.isDefined(dynamic) ? { dynamic: dynamic } : {};
	    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
	    return common_1.extend(defaultConfig, paramConfig);
	}
	/** @hidden */
	function unwrapShorthand(cfg) {
	    cfg = isShorthand(cfg) ? { value: cfg } : cfg;
	    getStaticDefaultValue['__cacheable'] = true;
	    function getStaticDefaultValue() {
	        return cfg.value;
	    }
	    var $$fn = predicates_1.isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
	    return common_1.extend(cfg, { $$fn: $$fn });
	}
	/** @hidden */
	function getType(cfg, urlType, location, id, paramTypes) {
	    if (cfg.type && urlType && urlType.name !== 'string')
	        throw new Error("Param '" + id + "' has two type configurations.");
	    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type))
	        return paramTypes.type(cfg.type);
	    if (urlType)
	        return urlType;
	    if (!cfg.type) {
	        var type = location === DefType.CONFIG
	            ? 'any'
	            : location === DefType.PATH
	                ? 'path'
	                : location === DefType.SEARCH
	                    ? 'query'
	                    : 'string';
	        return paramTypes.type(type);
	    }
	    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
	}
	/**
	 * @internalapi
	 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	 */
	function getSquashPolicy(config, isOptional, defaultPolicy) {
	    var squash = config.squash;
	    if (!isOptional || squash === false)
	        return false;
	    if (!predicates_1.isDefined(squash) || squash == null)
	        return defaultPolicy;
	    if (squash === true || predicates_1.isString(squash))
	        return squash;
	    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	}
	/** @internalapi */
	function getReplace(config, arrayMode, isOptional, squash) {
	    var defaultPolicy = [
	        { from: '', to: isOptional || arrayMode ? undefined : '' },
	        { from: null, to: isOptional || arrayMode ? undefined : '' },
	    ];
	    var replace = predicates_1.isArray(config.replace) ? config.replace : [];
	    if (predicates_1.isString(squash))
	        replace.push({ from: squash, to: undefined });
	    var configuredKeys = common_1.map(replace, hof_1.prop('from'));
	    return common_1.filter(defaultPolicy, function (item) { return configuredKeys.indexOf(item.from) === -1; }).concat(replace);
	}
	/** @internalapi */
	var Param = /** @class */ (function () {
	    function Param(id, type, location, urlConfig, state) {
	        var config = getParamDeclaration(id, location, state);
	        type = getType(config, type, location, id, urlConfig.paramTypes);
	        var arrayMode = getArrayMode();
	        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
	        var isOptional = config.value !== undefined || location === DefType.SEARCH;
	        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
	        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
	        var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
	        var replace = getReplace(config, arrayMode, isOptional, squash);
	        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
	        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	        function getArrayMode() {
	            var arrayDefaults = { array: location === DefType.SEARCH ? 'auto' : false };
	            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
	        }
	        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
	    }
	    Param.values = function (params, values) {
	        if (values === void 0) { values = {}; }
	        var paramValues = {};
	        for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
	            var param = params_1[_i];
	            paramValues[param.id] = param.value(values[param.id]);
	        }
	        return paramValues;
	    };
	    /**
	     * Finds [[Param]] objects which have different param values
	     *
	     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
	     *
	     * @param params: The list of Param objects to filter
	     * @param values1: The first set of parameter values
	     * @param values2: the second set of parameter values
	     *
	     * @returns any Param objects whose values were different between values1 and values2
	     */
	    Param.changed = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return params.filter(function (param) { return !param.type.equals(values1[param.id], values2[param.id]); });
	    };
	    /**
	     * Checks if two param value objects are equal (for a set of [[Param]] objects)
	     *
	     * @param params The list of [[Param]] objects to check
	     * @param values1 The first set of param values
	     * @param values2 The second set of param values
	     *
	     * @returns true if the param values in values1 and values2 are equal
	     */
	    Param.equals = function (params, values1, values2) {
	        if (values1 === void 0) { values1 = {}; }
	        if (values2 === void 0) { values2 = {}; }
	        return Param.changed(params, values1, values2).length === 0;
	    };
	    /** Returns true if a the parameter values are valid, according to the Param definitions */
	    Param.validates = function (params, values) {
	        if (values === void 0) { values = {}; }
	        return params.map(function (param) { return param.validates(values[param.id]); }).reduce(common_1.allTrueR, true);
	    };
	    Param.prototype.isDefaultValue = function (value) {
	        return this.isOptional && this.type.equals(this.value(), value);
	    };
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    Param.prototype.value = function (value) {
	        var _this = this;
	        /**
	         * [Internal] Get the default value of a parameter, which may be an injectable function.
	         */
	        var getDefaultValue = function () {
	            if (_this._defaultValueCache)
	                return _this._defaultValueCache.defaultValue;
	            if (!coreservices_1.services.$injector)
	                throw new Error('Injectable functions cannot be called at configuration time');
	            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
	            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue))
	                throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
	            if (_this.config.$$fn['__cacheable']) {
	                _this._defaultValueCache = { defaultValue: defaultValue };
	            }
	            return defaultValue;
	        };
	        var replaceSpecialValues = function (val) {
	            for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
	                var tuple = _a[_i];
	                if (tuple.from === val)
	                    return tuple.to;
	            }
	            return val;
	        };
	        value = replaceSpecialValues(value);
	        return predicates_1.isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
	    };
	    Param.prototype.isSearch = function () {
	        return this.location === DefType.SEARCH;
	    };
	    Param.prototype.validates = function (value) {
	        // There was no parameter value, but the param is optional
	        if ((predicates_1.isUndefined(value) || value === null) && this.isOptional)
	            return true;
	        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
	        var normalized = this.type.$normalize(value);
	        if (!this.type.is(normalized))
	            return false;
	        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
	        var encoded = this.type.encode(normalized);
	        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
	    };
	    Param.prototype.toString = function () {
	        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
	    };
	    return Param;
	}());
	exports.Param = Param;
	//# sourceMappingURL=param.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module params */ /** */
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	/**
	 * An internal class which implements [[ParamTypeDefinition]].
	 *
	 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
	 * When a param type definition is registered, an instance of this class is created internally.
	 *
	 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
	 *
	 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
	 *
	 * #### Example:
	 * ```js
	 * var paramTypeDef = {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 *
	 * var paramType = new ParamType(paramTypeDef);
	 * ```
	 * @internalapi
	 */
	var ParamType = /** @class */ (function () {
	    /**
	     * @param def  A configuration object which contains the custom type definition.  The object's
	     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
	     * @returns a new ParamType object
	     */
	    function ParamType(def) {
	        /** @inheritdoc */
	        this.pattern = /.*/;
	        /** @inheritdoc */
	        this.inherit = true;
	        common_1.extend(this, def);
	    }
	    // consider these four methods to be "abstract methods" that should be overridden
	    /** @inheritdoc */
	    ParamType.prototype.is = function (val, key) {
	        return true;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.encode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.decode = function (val, key) {
	        return val;
	    };
	    /** @inheritdoc */
	    ParamType.prototype.equals = function (a, b) {
	        // tslint:disable-next-line:triple-equals
	        return a == b;
	    };
	    ParamType.prototype.$subPattern = function () {
	        var sub = this.pattern.toString();
	        return sub.substr(1, sub.length - 2);
	    };
	    ParamType.prototype.toString = function () {
	        return "{ParamType:" + this.name + "}";
	    };
	    /** Given an encoded string, or a decoded object, returns a decoded object */
	    ParamType.prototype.$normalize = function (val) {
	        return this.is(val) ? val : this.decode(val);
	    };
	    /**
	     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
	     * e.g.:
	     * - urlmatcher pattern "/path?{queryParam[]:int}"
	     * - url: "/path?queryParam=1&queryParam=2
	     * - $stateParams.queryParam will be [1, 2]
	     * if `mode` is "auto", then
	     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	     */
	    ParamType.prototype.$asArray = function (mode, isSearch) {
	        if (!mode)
	            return this;
	        if (mode === 'auto' && !isSearch)
	            throw new Error("'auto' array mode is for query parameters only");
	        return new ArrayType(this, mode);
	    };
	    return ParamType;
	}());
	exports.ParamType = ParamType;
	/**
	 * Wraps up a `ParamType` object to handle array values.
	 * @internalapi
	 */
	function ArrayType(type, mode) {
	    var _this = this;
	    // Wrap non-array value as array
	    function arrayWrap(val) {
	        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
	    }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	        switch (val.length) {
	            case 0:
	                return undefined;
	            case 1:
	                return mode === 'auto' ? val[0] : val;
	            default:
	                return val;
	        }
	    }
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	        return function handleArray(val) {
	            if (predicates_1.isArray(val) && val.length === 0)
	                return val;
	            var arr = arrayWrap(val);
	            var result = common_1.map(arr, callback);
	            return allTruthyMode === true ? common_1.filter(result, function (x) { return !x; }).length === 0 : arrayUnwrap(result);
	        };
	    }
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	        return function handleArray(val1, val2) {
	            var left = arrayWrap(val1), right = arrayWrap(val2);
	            if (left.length !== right.length)
	                return false;
	            for (var i = 0; i < left.length; i++) {
	                if (!callback(left[i], right[i]))
	                    return false;
	            }
	            return true;
	        };
	    }
	    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
	        var paramTypeFn = type[name].bind(type);
	        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
	        _this[name] = wrapperFn(paramTypeFn);
	    });
	    common_1.extend(this, {
	        dynamic: type.dynamic,
	        name: type.name,
	        pattern: type.pattern,
	        inherit: type.inherit,
	        raw: type.raw,
	        is: arrayHandler(type.is.bind(type), true),
	        $arrayMode: mode,
	    });
	}
	//# sourceMappingURL=paramType.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module params */ /** */
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var hof_1 = __webpack_require__(378);
	var coreservices_1 = __webpack_require__(379);
	var paramType_1 = __webpack_require__(387);
	/**
	 * A registry for parameter types.
	 *
	 * This registry manages the built-in (and custom) parameter types.
	 *
	 * The built-in parameter types are:
	 *
	 * - [[string]]
	 * - [[path]]
	 * - [[query]]
	 * - [[hash]]
	 * - [[int]]
	 * - [[bool]]
	 * - [[date]]
	 * - [[json]]
	 * - [[any]]
	 *
	 * To register custom parameter types, use [[UrlConfig.type]], i.e.,
	 *
	 * ```js
	 * router.urlService.config.type(customType)
	 * ```
	 */
	var ParamTypes = /** @class */ (function () {
	    /** @internalapi */
	    function ParamTypes() {
	        /** @hidden */
	        this.enqueue = true;
	        /** @hidden */
	        this.typeQueue = [];
	        /** @internalapi */
	        this.defaultTypes = common_1.pick(ParamTypes.prototype, [
	            'hash',
	            'string',
	            'query',
	            'path',
	            'int',
	            'bool',
	            'date',
	            'json',
	            'any',
	        ]);
	        // Register default types. Store them in the prototype of this.types.
	        var makeType = function (definition, name) { return new paramType_1.ParamType(common_1.extend({ name: name }, definition)); };
	        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
	    }
	    /** @internalapi */
	    ParamTypes.prototype.dispose = function () {
	        this.types = {};
	    };
	    /**
	     * Registers a parameter type
	     *
	     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
	     */
	    ParamTypes.prototype.type = function (name, definition, definitionFn) {
	        if (!predicates_1.isDefined(definition))
	            return this.types[name];
	        if (this.types.hasOwnProperty(name))
	            throw new Error("A type named '" + name + "' has already been defined.");
	        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
	        if (definitionFn) {
	            this.typeQueue.push({ name: name, def: definitionFn });
	            if (!this.enqueue)
	                this._flushTypeQueue();
	        }
	        return this;
	    };
	    /** @internalapi */
	    ParamTypes.prototype._flushTypeQueue = function () {
	        while (this.typeQueue.length) {
	            var type = this.typeQueue.shift();
	            if (type.pattern)
	                throw new Error("You cannot override a type's .pattern at runtime.");
	            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
	        }
	    };
	    return ParamTypes;
	}());
	exports.ParamTypes = ParamTypes;
	/** @hidden */
	function initDefaultTypes() {
	    var makeDefaultType = function (def) {
	        var valToString = function (val) { return (val != null ? val.toString() : val); };
	        var defaultTypeBase = {
	            encode: valToString,
	            decode: valToString,
	            is: hof_1.is(String),
	            pattern: /.*/,
	            // tslint:disable-next-line:triple-equals
	            equals: function (a, b) { return a == b; },
	        };
	        return common_1.extend({}, defaultTypeBase, def);
	    };
	    // Default Parameter Type Definitions
	    common_1.extend(ParamTypes.prototype, {
	        string: makeDefaultType({}),
	        path: makeDefaultType({
	            pattern: /[^/]*/,
	        }),
	        query: makeDefaultType({}),
	        hash: makeDefaultType({
	            inherit: false,
	        }),
	        int: makeDefaultType({
	            decode: function (val) { return parseInt(val, 10); },
	            is: function (val) {
	                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
	            },
	            pattern: /-?\d+/,
	        }),
	        bool: makeDefaultType({
	            encode: function (val) { return (val && 1) || 0; },
	            decode: function (val) { return parseInt(val, 10) !== 0; },
	            is: hof_1.is(Boolean),
	            pattern: /0|1/,
	        }),
	        date: makeDefaultType({
	            encode: function (val) {
	                return !this.is(val)
	                    ? undefined
	                    : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
	            },
	            decode: function (val) {
	                if (this.is(val))
	                    return val;
	                var match = this.capture.exec(val);
	                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	            },
	            is: function (val) { return val instanceof Date && !isNaN(val.valueOf()); },
	            equals: function (l, r) {
	                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) { return acc && l[fn]() === r[fn](); }, true);
	            },
	            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/,
	        }),
	        json: makeDefaultType({
	            encode: common_1.toJson,
	            decode: common_1.fromJson,
	            is: hof_1.is(Object),
	            equals: common_1.equals,
	            pattern: /[^/]*/,
	        }),
	        // does not encode/decode
	        any: makeDefaultType({
	            encode: common_1.identity,
	            decode: common_1.identity,
	            is: function () { return true; },
	            equals: common_1.equals,
	        }),
	    });
	}
	initDefaultTypes();
	//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module params */ /** */
	var common_1 = __webpack_require__(376);
	/** @internalapi */
	var StateParams = /** @class */ (function () {
	    function StateParams(params) {
	        if (params === void 0) { params = {}; }
	        common_1.extend(this, params);
	    }
	    /**
	     * Merges a set of parameters with all parameters inherited between the common parents of the
	     * current state and a given destination state.
	     *
	     * @param {Object} newParams The set of parameters which will be composited with inherited params.
	     * @param {Object} $current Internal definition of object representing the current state.
	     * @param {Object} $to Internal definition of object representing state to transition to.
	     */
	    StateParams.prototype.$inherit = function (newParams, $current, $to) {
	        var parentParams;
	        var parents = common_1.ancestors($current, $to), inherited = {}, inheritList = [];
	        for (var i in parents) {
	            if (!parents[i] || !parents[i].params)
	                continue;
	            parentParams = Object.keys(parents[i].params);
	            if (!parentParams.length)
	                continue;
	            for (var j in parentParams) {
	                if (inheritList.indexOf(parentParams[j]) >= 0)
	                    continue;
	                inheritList.push(parentParams[j]);
	                inherited[parentParams[j]] = this[parentParams[j]];
	            }
	        }
	        return common_1.extend({}, inherited, newParams);
	    };
	    return StateParams;
	}());
	exports.StateParams = StateParams;
	//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module path */ /** */
	__export(__webpack_require__(391));
	__export(__webpack_require__(392));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module path */ /** */
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var param_1 = __webpack_require__(386);
	/**
	 * A node in a [[TreeChanges]] path
	 *
	 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
	 * Each PathNode corresponds to a state being entered, exited, or retained.
	 * The stateful information includes parameter values and resolve data.
	 */
	var PathNode = /** @class */ (function () {
	    function PathNode(stateOrNode) {
	        if (stateOrNode instanceof PathNode) {
	            var node = stateOrNode;
	            this.state = node.state;
	            this.paramSchema = node.paramSchema.slice();
	            this.paramValues = common_1.extend({}, node.paramValues);
	            this.resolvables = node.resolvables.slice();
	            this.views = node.views && node.views.slice();
	        }
	        else {
	            var state = stateOrNode;
	            this.state = state;
	            this.paramSchema = state.parameters({ inherit: false });
	            this.paramValues = {};
	            this.resolvables = state.resolvables.map(function (res) { return res.clone(); });
	        }
	    }
	    PathNode.prototype.clone = function () {
	        return new PathNode(this);
	    };
	    /** Sets [[paramValues]] for the node, from the values of an object hash */
	    PathNode.prototype.applyRawParams = function (params) {
	        var getParamVal = function (paramDef) { return [paramDef.id, paramDef.value(params[paramDef.id])]; };
	        this.paramValues = this.paramSchema.reduce(function (memo, pDef) { return common_1.applyPairs(memo, getParamVal(pDef)); }, {});
	        return this;
	    };
	    /** Gets a specific [[Param]] metadata that belongs to the node */
	    PathNode.prototype.parameter = function (name) {
	        return common_1.find(this.paramSchema, hof_1.propEq('id', name));
	    };
	    /**
	     * @returns true if the state and parameter values for another PathNode are
	     * equal to the state and param values for this PathNode
	     */
	    PathNode.prototype.equals = function (node, paramsFn) {
	        var diff = this.diff(node, paramsFn);
	        return diff && diff.length === 0;
	    };
	    /**
	     * Finds Params with different parameter values on another PathNode.
	     *
	     * Given another node (of the same state), finds the parameter values which differ.
	     * Returns the [[Param]] (schema objects) whose parameter values differ.
	     *
	     * Given another node for a different state, returns `false`
	     *
	     * @param node The node to compare to
	     * @param paramsFn A function that returns which parameters should be compared.
	     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
	     */
	    PathNode.prototype.diff = function (node, paramsFn) {
	        if (this.state !== node.state)
	            return false;
	        var params = paramsFn ? paramsFn(this) : this.paramSchema;
	        return param_1.Param.changed(params, this.paramValues, node.paramValues);
	    };
	    /**
	     * Returns a clone of the PathNode
	     * @deprecated use instance method `node.clone()`
	     */
	    PathNode.clone = function (node) { return node.clone(); };
	    return PathNode;
	}());
	exports.PathNode = PathNode;
	//# sourceMappingURL=pathNode.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/** @internalapi @module path */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var targetState_1 = __webpack_require__(393);
	var pathNode_1 = __webpack_require__(391);
	/**
	 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
	 */
	var PathUtils = /** @class */ (function () {
	    function PathUtils() {
	    }
	    /** Given a PathNode[], create an TargetState */
	    PathUtils.makeTargetState = function (registry, path) {
	        var state = common_1.tail(path).state;
	        return new targetState_1.TargetState(registry, state, path.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}), {});
	    };
	    PathUtils.buildPath = function (targetState) {
	        var toParams = targetState.params();
	        return targetState.$state().path.map(function (state) { return new pathNode_1.PathNode(state).applyRawParams(toParams); });
	    };
	    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
	    PathUtils.buildToPath = function (fromPath, targetState) {
	        var toPath = PathUtils.buildPath(targetState);
	        if (targetState.options().inherit) {
	            return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
	        }
	        return toPath;
	    };
	    /**
	     * Creates ViewConfig objects and adds to nodes.
	     *
	     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
	     */
	    PathUtils.applyViewConfigs = function ($view, path, states) {
	        // Only apply the viewConfigs to the nodes for the given states
	        path
	            .filter(function (node) { return common_1.inArray(states, node.state); })
	            .forEach(function (node) {
	            var viewDecls = common_1.values(node.state.views || {});
	            var subPath = PathUtils.subPath(path, function (n) { return n === node; });
	            var viewConfigs = viewDecls.map(function (view) { return $view.createViewConfig(subPath, view); });
	            node.views = viewConfigs.reduce(common_1.unnestR, []);
	        });
	    };
	    /**
	     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
	     *
	     * For a parameter in a node to be inherited from the from path:
	     * - The toPath's node must have a matching node in the fromPath (by state).
	     * - The parameter name must not be found in the toKeys parameter array.
	     *
	     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
	     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
	     * it is not inherited from the fromPath.
	     */
	    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
	        if (toKeys === void 0) { toKeys = []; }
	        function nodeParamVals(path, state) {
	            var node = common_1.find(path, hof_1.propEq('state', state));
	            return common_1.extend({}, node && node.paramValues);
	        }
	        var noInherit = fromPath
	            .map(function (node) { return node.paramSchema; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (param) { return !param.inherit; })
	            .map(hof_1.prop('id'));
	        /**
	         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
	         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
	         */
	        function makeInheritedParamsNode(toNode) {
	            // All param values for the node (may include default key/vals, when key was not found in toParams)
	            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
	            // limited to only those keys found in toParams
	            var incomingParamVals = common_1.pick(toParamVals, toKeys);
	            toParamVals = common_1.omit(toParamVals, toKeys);
	            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
	            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
	            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
	            return new pathNode_1.PathNode(toNode.state).applyRawParams(ownParamVals);
	        }
	        // The param keys specified by the incoming toParams
	        return toPath.map(makeInheritedParamsNode);
	    };
	    /**
	     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
	     */
	    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
	        var max = Math.min(fromPath.length, toPath.length);
	        var keep = 0;
	        var nodesMatch = function (node1, node2) { return node1.equals(node2, PathUtils.nonDynamicParams); };
	        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
	            keep++;
	        }
	        /** Given a retained node, return a new node which uses the to node's param values */
	        function applyToParams(retainedNode, idx) {
	            var cloned = retainedNode.clone();
	            cloned.paramValues = toPath[idx].paramValues;
	            return cloned;
	        }
	        var from, retained, exiting, entering, to;
	        from = fromPath;
	        retained = from.slice(0, keep);
	        exiting = from.slice(keep);
	        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
	        var retainedWithToParams = retained.map(applyToParams);
	        entering = toPath.slice(keep);
	        to = retainedWithToParams.concat(entering);
	        return { from: from, to: to, retained: retained, retainedWithToParams: retainedWithToParams, exiting: exiting, entering: entering };
	    };
	    /**
	     * Returns a new path which is: the subpath of the first path which matches the second path.
	     *
	     * The new path starts from root and contains any nodes that match the nodes in the second path.
	     * It stops before the first non-matching node.
	     *
	     * Nodes are compared using their state property and their parameter values.
	     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
	     *
	     * @param pathA the first path
	     * @param pathB the second path
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     *
	     * @returns an array of PathNodes from the first path which match the nodes in the second path
	     */
	    PathUtils.matching = function (pathA, pathB, paramsFn) {
	        var done = false;
	        var tuples = common_1.arrayTuples(pathA, pathB);
	        return tuples.reduce(function (matching, _a) {
	            var nodeA = _a[0], nodeB = _a[1];
	            done = done || !nodeA.equals(nodeB, paramsFn);
	            return done ? matching : matching.concat(nodeA);
	        }, []);
	    };
	    /**
	     * Returns true if two paths are identical.
	     *
	     * @param pathA
	     * @param pathB
	     * @param paramsFn a function which returns the parameters to consider when comparing
	     * @returns true if the the states and parameter values for both paths are identical
	     */
	    PathUtils.equals = function (pathA, pathB, paramsFn) {
	        return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
	    };
	    /**
	     * Return a subpath of a path, which stops at the first matching node
	     *
	     * Given an array of nodes, returns a subset of the array starting from the first node,
	     * stopping when the first node matches the predicate.
	     *
	     * @param path a path of [[PathNode]]s
	     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
	     * @returns a subpath up to the matching node, or undefined if no match is found
	     */
	    PathUtils.subPath = function (path, predicate) {
	        var node = common_1.find(path, predicate);
	        var elementIdx = path.indexOf(node);
	        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
	    };
	    PathUtils.nonDynamicParams = function (node) {
	        return node.state.parameters({ inherit: false }).filter(function (param) { return !param.dynamic; });
	    };
	    /** Gets the raw parameter values from a path */
	    PathUtils.paramValues = function (path) { return path.reduce(function (acc, node) { return common_1.extend(acc, node.paramValues); }, {}); };
	    return PathUtils;
	}());
	exports.PathUtils = PathUtils;
	//# sourceMappingURL=pathUtils.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/** @publicapi @module state */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	var predicates_1 = __webpack_require__(377);
	var strings_1 = __webpack_require__(382);
	var common_1 = __webpack_require__(375);
	/**
	 * Encapsulate the target (destination) state/params/options of a [[Transition]].
	 *
	 * This class is frequently used to redirect a transition to a new destination.
	 *
	 * See:
	 *
	 * - [[HookResult]]
	 * - [[TransitionHookFn]]
	 * - [[TransitionService.onStart]]
	 *
	 * To create a `TargetState`, use [[StateService.target]].
	 *
	 * ---
	 *
	 * This class wraps:
	 *
	 * 1) an identifier for a state
	 * 2) a set of parameters
	 * 3) and transition options
	 * 4) the registered state object (the [[StateDeclaration]])
	 *
	 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
	 * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
	 * The `TargetState` class normalizes those options.
	 *
	 * A `TargetState` may be valid (the state being targeted exists in the registry)
	 * or invalid (the state being targeted is not registered).
	 */
	var TargetState = /** @class */ (function () {
	    /**
	     * The TargetState constructor
	     *
	     * Note: Do not construct a `TargetState` manually.
	     * To create a `TargetState`, use the [[StateService.target]] factory method.
	     *
	     * @param _stateRegistry The StateRegistry to use to look up the _definition
	     * @param _identifier An identifier for a state.
	     *    Either a fully-qualified state name, or the object used to define the state.
	     * @param _params Parameters for the target state
	     * @param _options Transition options.
	     *
	     * @internalapi
	     */
	    function TargetState(_stateRegistry, _identifier, _params, _options) {
	        this._stateRegistry = _stateRegistry;
	        this._identifier = _identifier;
	        this._identifier = _identifier;
	        this._params = common_1.extend({}, _params || {});
	        this._options = common_1.extend({}, _options || {});
	        this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
	    }
	    /** The name of the state this object targets */
	    TargetState.prototype.name = function () {
	        return (this._definition && this._definition.name) || this._identifier;
	    };
	    /** The identifier used when creating this TargetState */
	    TargetState.prototype.identifier = function () {
	        return this._identifier;
	    };
	    /** The target parameter values */
	    TargetState.prototype.params = function () {
	        return this._params;
	    };
	    /** The internal state object (if it was found) */
	    TargetState.prototype.$state = function () {
	        return this._definition;
	    };
	    /** The internal state declaration (if it was found) */
	    TargetState.prototype.state = function () {
	        return this._definition && this._definition.self;
	    };
	    /** The target options */
	    TargetState.prototype.options = function () {
	        return this._options;
	    };
	    /** True if the target state was found */
	    TargetState.prototype.exists = function () {
	        return !!(this._definition && this._definition.self);
	    };
	    /** True if the object is valid */
	    TargetState.prototype.valid = function () {
	        return !this.error();
	    };
	    /** If the object is invalid, returns the reason why */
	    TargetState.prototype.error = function () {
	        var base = this.options().relative;
	        if (!this._definition && !!base) {
	            var stateName = base.name ? base.name : base;
	            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
	        }
	        if (!this._definition)
	            return "No such state '" + this.name() + "'";
	        if (!this._definition.self)
	            return "State '" + this.name() + "' has an invalid definition";
	    };
	    TargetState.prototype.toString = function () {
	        return "'" + this.name() + "'" + strings_1.stringify(this.params());
	    };
	    /**
	     * Returns a copy of this TargetState which targets a different state.
	     * The new TargetState has the same parameter values and transition options.
	     *
	     * @param state The new state that should be targeted
	     */
	    TargetState.prototype.withState = function (state) {
	        return new TargetState(this._stateRegistry, state, this._params, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified parameter values.
	     *
	     * @param params the new parameter values to use
	     * @param replace When false (default) the new parameter values will be merged with the current values.
	     *                When true the parameter values will be used instead of the current values.
	     */
	    TargetState.prototype.withParams = function (params, replace) {
	        if (replace === void 0) { replace = false; }
	        var newParams = replace ? params : common_1.extend({}, this._params, params);
	        return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
	    };
	    /**
	     * Returns a copy of this TargetState, using the specified Transition Options.
	     *
	     * @param options the new options to use
	     * @param replace When false (default) the new options will be merged with the current options.
	     *                When true the options will be used instead of the current options.
	     */
	    TargetState.prototype.withOptions = function (options, replace) {
	        if (replace === void 0) { replace = false; }
	        var newOpts = replace ? options : common_1.extend({}, this._options, options);
	        return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
	    };
	    /** Returns true if the object has a state property that might be a state or state name */
	    TargetState.isDef = function (obj) { return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name)); };
	    return TargetState;
	}());
	exports.TargetState = TargetState;
	//# sourceMappingURL=targetState.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module resolve */ /** */
	__export(__webpack_require__(395));
	__export(__webpack_require__(396));
	__export(__webpack_require__(397));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi */
	exports.resolvePolicies = {
	    when: {
	        LAZY: 'LAZY',
	        EAGER: 'EAGER',
	    },
	    async: {
	        WAIT: 'WAIT',
	        NOWAIT: 'NOWAIT',
	        RXWAIT: 'RXWAIT',
	    },
	};
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module resolve */ /** */
	var common_1 = __webpack_require__(376);
	var coreservices_1 = __webpack_require__(379);
	var trace_1 = __webpack_require__(384);
	var strings_1 = __webpack_require__(382);
	var predicates_1 = __webpack_require__(377);
	var predicates_2 = __webpack_require__(377);
	// TODO: explicitly make this user configurable
	exports.defaultResolvePolicy = {
	    when: 'LAZY',
	    async: 'WAIT',
	};
	/**
	 * The basic building block for the resolve system.
	 *
	 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
	 * and the unwrapped-when-complete (.data) result of the resolveFn.
	 *
	 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
	 * resolveFn) and returns the resulting promise.
	 *
	 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
	 * parameter to those fns.
	 */
	var Resolvable = /** @class */ (function () {
	    function Resolvable(arg1, resolveFn, deps, policy, data) {
	        this.resolved = false;
	        this.promise = undefined;
	        if (arg1 instanceof Resolvable) {
	            common_1.extend(this, arg1);
	        }
	        else if (predicates_1.isFunction(resolveFn)) {
	            if (predicates_2.isNullOrUndefined(arg1))
	                throw new Error('new Resolvable(): token argument is required');
	            if (!predicates_1.isFunction(resolveFn))
	                throw new Error('new Resolvable(): resolveFn argument must be a function');
	            this.token = arg1;
	            this.policy = policy;
	            this.resolveFn = resolveFn;
	            this.deps = deps || [];
	            this.data = data;
	            this.resolved = data !== undefined;
	            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
	        }
	        else if (predicates_1.isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
	            var literal = arg1;
	            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
	        }
	    }
	    Resolvable.prototype.getPolicy = function (state) {
	        var thisPolicy = this.policy || {};
	        var statePolicy = (state && state.resolvePolicy) || {};
	        return {
	            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
	            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async,
	        };
	    };
	    /**
	     * Asynchronously resolve this Resolvable's data
	     *
	     * Given a ResolveContext that this Resolvable is found in:
	     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
	     * and update the Resolvable's state
	     */
	    Resolvable.prototype.resolve = function (resolveContext, trans) {
	        var _this = this;
	        var $q = coreservices_1.services.$q;
	        // Gets all dependencies from ResolveContext and wait for them to be resolved
	        var getResolvableDependencies = function () {
	            return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) { return resolvable.get(resolveContext, trans); }));
	        };
	        // Invokes the resolve function passing the resolved dependencies as arguments
	        var invokeResolveFn = function (resolvedDeps) { return _this.resolveFn.apply(null, resolvedDeps); };
	        /**
	         * For RXWAIT policy:
	         *
	         * Given an observable returned from a resolve function:
	         * - enables .cache() mode (this allows multicast subscribers)
	         * - then calls toPromise() (this triggers subscribe() and thus fetches)
	         * - Waits for the promise, then return the cached observable (not the first emitted value).
	         */
	        var waitForRx = function (observable$) {
	            var cached = observable$.cache(1);
	            return cached
	                .take(1)
	                .toPromise()
	                .then(function () { return cached; });
	        };
	        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
	        var node = resolveContext.findNode(this);
	        var state = node && node.state;
	        var maybeWaitForRx = this.getPolicy(state).async === 'RXWAIT' ? waitForRx : common_1.identity;
	        // After the final value has been resolved, update the state of the Resolvable
	        var applyResolvedValue = function (resolvedValue) {
	            _this.data = resolvedValue;
	            _this.resolved = true;
	            _this.resolveFn = null;
	            trace_1.trace.traceResolvableResolved(_this, trans);
	            return _this.data;
	        };
	        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
	        return (this.promise = $q
	            .when()
	            .then(getResolvableDependencies)
	            .then(invokeResolveFn)
	            .then(maybeWaitForRx)
	            .then(applyResolvedValue));
	    };
	    /**
	     * Gets a promise for this Resolvable's data.
	     *
	     * Fetches the data and returns a promise.
	     * Returns the existing promise if it has already been fetched once.
	     */
	    Resolvable.prototype.get = function (resolveContext, trans) {
	        return this.promise || this.resolve(resolveContext, trans);
	    };
	    Resolvable.prototype.toString = function () {
	        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
	    };
	    Resolvable.prototype.clone = function () {
	        return new Resolvable(this);
	    };
	    Resolvable.fromData = function (token, data) { return new Resolvable(token, function () { return data; }, null, null, data); };
	    return Resolvable;
	}());
	exports.Resolvable = Resolvable;
	//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module resolve */ /** */
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var trace_1 = __webpack_require__(384);
	var coreservices_1 = __webpack_require__(379);
	var interface_1 = __webpack_require__(395);
	var resolvable_1 = __webpack_require__(396);
	var pathUtils_1 = __webpack_require__(392);
	var strings_1 = __webpack_require__(382);
	var common_2 = __webpack_require__(375);
	var whens = interface_1.resolvePolicies.when;
	var ALL_WHENS = [whens.EAGER, whens.LAZY];
	var EAGER_WHENS = [whens.EAGER];
	// tslint:disable-next-line:no-inferrable-types
	exports.NATIVE_INJECTOR_TOKEN = 'Native Injector';
	/**
	 * Encapsulates Dependency Injection for a path of nodes
	 *
	 * UI-Router states are organized as a tree.
	 * A nested state has a path of ancestors to the root of the tree.
	 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
	 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
	 *
	 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
	 */
	var ResolveContext = /** @class */ (function () {
	    function ResolveContext(_path) {
	        this._path = _path;
	    }
	    /** Gets all the tokens found in the resolve context, de-duplicated */
	    ResolveContext.prototype.getTokens = function () {
	        return this._path.reduce(function (acc, node) { return acc.concat(node.resolvables.map(function (r) { return r.token; })); }, []).reduce(common_1.uniqR, []);
	    };
	    /**
	     * Gets the Resolvable that matches the token
	     *
	     * Gets the last Resolvable that matches the token in this context, or undefined.
	     * Throws an error if it doesn't exist in the ResolveContext
	     */
	    ResolveContext.prototype.getResolvable = function (token) {
	        var matching = this._path
	            .map(function (node) { return node.resolvables; })
	            .reduce(common_1.unnestR, [])
	            .filter(function (r) { return r.token === token; });
	        return common_1.tail(matching);
	    };
	    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
	    ResolveContext.prototype.getPolicy = function (resolvable) {
	        var node = this.findNode(resolvable);
	        return resolvable.getPolicy(node.state);
	    };
	    /**
	     * Returns a ResolveContext that includes a portion of this one
	     *
	     * Given a state, this method creates a new ResolveContext from this one.
	     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
	     *
	     * #### Why
	     *
	     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
	     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
	     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
	     * This method is used to create a narrower context when injecting ancestor nodes.
	     *
	     * @example
	     * `let ABCD = new ResolveContext([A, B, C, D]);`
	     *
	     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
	     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
	     * However, `B` should only be able to access resolvables from `A`, `B`.
	     *
	     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
	     * `let AB = ABCD.subcontext(a)`
	     */
	    ResolveContext.prototype.subContext = function (state) {
	        return new ResolveContext(pathUtils_1.PathUtils.subPath(this._path, function (node) { return node.state === state; }));
	    };
	    /**
	     * Adds Resolvables to the node that matches the state
	     *
	     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
	     * The resolvable is added to the node matching the `state` parameter.
	     *
	     * These new resolvables are not automatically fetched.
	     * The calling code should either fetch them, fetch something that depends on them,
	     * or rely on [[resolvePath]] being called when some state is being entered.
	     *
	     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
	     *
	     * @param newResolvables the new Resolvables
	     * @param state Used to find the node to put the resolvable on
	     */
	    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
	        var node = common_1.find(this._path, hof_1.propEq('state', state));
	        var keys = newResolvables.map(function (r) { return r.token; });
	        node.resolvables = node.resolvables.filter(function (r) { return keys.indexOf(r.token) === -1; }).concat(newResolvables);
	    };
	    /**
	     * Returns a promise for an array of resolved path Element promises
	     *
	     * @param when
	     * @param trans
	     * @returns {Promise<any>|any}
	     */
	    ResolveContext.prototype.resolvePath = function (when, trans) {
	        var _this = this;
	        if (when === void 0) { when = 'LAZY'; }
	        // This option determines which 'when' policy Resolvables we are about to fetch.
	        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : 'LAZY';
	        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
	        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
	        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
	        // get the subpath to the state argument, if provided
	        trace_1.trace.traceResolvePath(this._path, when, trans);
	        var matchesPolicy = function (acceptedVals, whenOrAsync) { return function (resolvable) {
	            return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
	        }; };
	        // Trigger all the (matching) Resolvables in the path
	        // Reduce all the "WAIT" Resolvables into an array
	        var promises = this._path.reduce(function (acc, node) {
	            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
	            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
	            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
	            // For the matching Resolvables, start their async fetch process.
	            var subContext = _this.subContext(node.state);
	            var getResult = function (r) {
	                return r
	                    .get(subContext, trans)
	                    // Return a tuple that includes the Resolvable's token
	                    .then(function (value) { return ({ token: r.token, value: value }); });
	            };
	            nowait.forEach(getResult);
	            return acc.concat(wait.map(getResult));
	        }, []);
	        // Wait for all the "WAIT" resolvables
	        return coreservices_1.services.$q.all(promises);
	    };
	    ResolveContext.prototype.injector = function () {
	        return this._injector || (this._injector = new UIInjectorImpl(this));
	    };
	    ResolveContext.prototype.findNode = function (resolvable) {
	        return common_1.find(this._path, function (node) { return common_1.inArray(node.resolvables, resolvable); });
	    };
	    /**
	     * Gets the async dependencies of a Resolvable
	     *
	     * Given a Resolvable, returns its dependencies as a Resolvable[]
	     */
	    ResolveContext.prototype.getDependencies = function (resolvable) {
	        var _this = this;
	        var node = this.findNode(resolvable);
	        // Find which other resolvables are "visible" to the `resolvable` argument
	        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
	        var subPath = pathUtils_1.PathUtils.subPath(this._path, function (x) { return x === node; }) || this._path;
	        var availableResolvables = subPath
	            .reduce(function (acc, _node) { return acc.concat(_node.resolvables); }, []) // all of subpath's resolvables
	            .filter(function (res) { return res !== resolvable; }); // filter out the `resolvable` argument
	        var getDependency = function (token) {
	            var matching = availableResolvables.filter(function (r) { return r.token === token; });
	            if (matching.length)
	                return common_1.tail(matching);
	            var fromInjector = _this.injector().getNative(token);
	            if (common_2.isUndefined(fromInjector)) {
	                throw new Error('Could not find Dependency Injection token: ' + strings_1.stringify(token));
	            }
	            return new resolvable_1.Resolvable(token, function () { return fromInjector; }, [], fromInjector);
	        };
	        return resolvable.deps.map(getDependency);
	    };
	    return ResolveContext;
	}());
	exports.ResolveContext = ResolveContext;
	/** @internalapi */
	var UIInjectorImpl = /** @class */ (function () {
	    function UIInjectorImpl(context) {
	        this.context = context;
	        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
	    }
	    UIInjectorImpl.prototype.get = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable) {
	            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
	                return resolvable.get(this.context);
	            }
	            if (!resolvable.resolved) {
	                throw new Error('Resolvable async .get() not complete:' + strings_1.stringify(resolvable.token));
	            }
	            return resolvable.data;
	        }
	        return this.getNative(token);
	    };
	    UIInjectorImpl.prototype.getAsync = function (token) {
	        var resolvable = this.context.getResolvable(token);
	        if (resolvable)
	            return resolvable.get(this.context);
	        return coreservices_1.services.$q.when(this.native.get(token));
	    };
	    UIInjectorImpl.prototype.getNative = function (token) {
	        return this.native && this.native.get(token);
	    };
	    return UIInjectorImpl;
	}());
	//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(399));
	__export(__webpack_require__(400));
	__export(__webpack_require__(401));
	__export(__webpack_require__(402));
	__export(__webpack_require__(403));
	__export(__webpack_require__(404));
	__export(__webpack_require__(393));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module state */ /** */
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var strings_1 = __webpack_require__(382);
	var hof_1 = __webpack_require__(378);
	var resolvable_1 = __webpack_require__(396);
	var coreservices_1 = __webpack_require__(379);
	var parseUrl = function (url) {
	    if (!predicates_1.isString(url))
	        return false;
	    var root = url.charAt(0) === '^';
	    return { val: root ? url.substring(1) : url, root: root };
	};
	function nameBuilder(state) {
	    return state.name;
	}
	function selfBuilder(state) {
	    state.self.$$state = function () { return state; };
	    return state.self;
	}
	function dataBuilder(state) {
	    if (state.parent && state.parent.data) {
	        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
	    }
	    return state.data;
	}
	var getUrlBuilder = function ($urlMatcherFactoryProvider, root) {
	    return function urlBuilder(stateObject) {
	        var stateDec = stateObject.self;
	        // For future states, i.e., states whose name ends with `.**`,
	        // match anything that starts with the url prefix
	        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
	            var newStateDec = {};
	            common_1.copy(stateDec, newStateDec);
	            newStateDec.url += '{remainder:any}'; // match any path (.*)
	            stateDec = newStateDec;
	        }
	        var parent = stateObject.parent;
	        var parsed = parseUrl(stateDec.url);
	        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, { state: stateDec });
	        if (!url)
	            return null;
	        if (!$urlMatcherFactoryProvider.isMatcher(url))
	            throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
	        return parsed && parsed.root ? url : ((parent && parent.navigable) || root()).url.append(url);
	    };
	};
	var getNavigableBuilder = function (isRoot) {
	    return function navigableBuilder(state) {
	        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
	    };
	};
	var getParamsBuilder = function (paramFactory) {
	    return function paramsBuilder(state) {
	        var makeConfigParam = function (config, id) { return paramFactory.fromConfig(id, null, state.self); };
	        var urlParams = (state.url && state.url.parameters({ inherit: false })) || [];
	        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
	        return urlParams
	            .concat(nonUrlParams)
	            .map(function (p) { return [p.id, p]; })
	            .reduce(common_1.applyPairs, {});
	    };
	};
	function pathBuilder(state) {
	    return state.parent ? state.parent.path.concat(state) : /*root*/ [state];
	}
	function includesBuilder(state) {
	    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
	    includes[state.name] = true;
	    return includes;
	}
	/**
	 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
	 *
	 * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	 * validates the `resolve` property and converts it to a [[Resolvable]] array.
	 *
	 * resolve: input value can be:
	 *
	 * {
	 *   // analyzed but not injected
	 *   myFooResolve: function() { return "myFooData"; },
	 *
	 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
	 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
	 *
	 *   // Array split; "DependencyName" dep as string
	 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
	 *
	 *   // Array split; DependencyType dep as token (compared using ===)
	 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
	 *
	 *   // val.$inject used as deps
	 *   // where:
	 *   //     corgeResolve.$inject = ["DependencyName"];
	 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
	 *   // then "DependencyName" dep as string
	 *   myCorgeResolve: corgeResolve,
	 *
	 *  // inject service by name
	 *  // When a string is found, desugar creating a resolve that injects the named service
	 *   myGraultResolve: "SomeService"
	 * }
	 *
	 * or:
	 *
	 * [
	 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
	 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
	 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
	 * ]
	 */
	function resolvablesBuilder(state) {
	    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
	    var objects2Tuples = function (resolveObj, resolvePolicies) {
	        return Object.keys(resolveObj || {}).map(function (token) { return ({
	            token: token,
	            val: resolveObj[token],
	            deps: undefined,
	            policy: resolvePolicies[token],
	        }); });
	    };
	    /** fetch DI annotations from a function or ng1-style array */
	    var annotate = function (fn) {
	        var $injector = coreservices_1.services.$injector;
	        // ng1 doesn't have an $injector until runtime.
	        // If the $injector doesn't exist, use "deferred" literal as a
	        // marker indicating they should be annotated when runtime starts
	        return fn['$inject'] || ($injector && $injector.annotate(fn, $injector.strictDi)) || 'deferred';
	    };
	    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
	    var isResolveLiteral = function (obj) { return !!(obj.token && obj.resolveFn); };
	    /** true if the object looks like a provide literal, or a ng2 Provider */
	    var isLikeNg2Provider = function (obj) {
	        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
	    };
	    /** true if the object looks like a tuple from obj2Tuples */
	    var isTupleFromObj = function (obj) {
	        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
	    };
	    /** extracts the token from a Provider or provide literal */
	    var getToken = function (p) { return p.provide || p.token; };
	    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
	    var literal2Resolvable = hof_1.pattern([
	        [hof_1.prop('resolveFn'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.resolveFn, p.deps, p.policy); }],
	        [hof_1.prop('useFactory'), function (p) { return new resolvable_1.Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy); }],
	        [hof_1.prop('useClass'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return new p.useClass(); }, [], p.policy); }],
	        [hof_1.prop('useValue'), function (p) { return new resolvable_1.Resolvable(getToken(p), function () { return p.useValue; }, [], p.policy, p.useValue); }],
	        [hof_1.prop('useExisting'), function (p) { return new resolvable_1.Resolvable(getToken(p), common_1.identity, [p.useExisting], p.policy); }],
	    ]);
	    // prettier-ignore
	    var tuple2Resolvable = hof_1.pattern([
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isString), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isArray), function (tuple) { return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy); }],
	        [hof_1.pipe(hof_1.prop('val'), predicates_1.isFunction), function (tuple) { return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy); }],
	    ]);
	    // prettier-ignore
	    var item2Resolvable = hof_1.pattern([
	        [hof_1.is(resolvable_1.Resolvable), function (r) { return r; }],
	        [isResolveLiteral, literal2Resolvable],
	        [isLikeNg2Provider, literal2Resolvable],
	        [isTupleFromObj, tuple2Resolvable],
	        [hof_1.val(true), function (obj) { throw new Error('Invalid resolve value: ' + strings_1.stringify(obj)); },],
	    ]);
	    // If resolveBlock is already an array, use it as-is.
	    // Otherwise, assume it's an object and convert to an Array of tuples
	    var decl = state.resolve;
	    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
	    return items.map(item2Resolvable);
	}
	exports.resolvablesBuilder = resolvablesBuilder;
	/**
	 * @internalapi A internal global service
	 *
	 * StateBuilder is a factory for the internal [[StateObject]] objects.
	 *
	 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
	 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
	 * [[StateObject]] object, which has an API and is used internally.
	 *
	 * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
	 * using the [[builder]] method.
	 */
	var StateBuilder = /** @class */ (function () {
	    function StateBuilder(matcher, urlMatcherFactory) {
	        this.matcher = matcher;
	        var self = this;
	        var root = function () { return matcher.find(''); };
	        var isRoot = function (state) { return state.name === ''; };
	        function parentBuilder(state) {
	            if (isRoot(state))
	                return null;
	            return matcher.find(self.parentName(state)) || root();
	        }
	        this.builders = {
	            name: [nameBuilder],
	            self: [selfBuilder],
	            parent: [parentBuilder],
	            data: [dataBuilder],
	            // Build a URLMatcher if necessary, either via a relative or absolute URL
	            url: [getUrlBuilder(urlMatcherFactory, root)],
	            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	            navigable: [getNavigableBuilder(isRoot)],
	            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
	            // Each framework-specific ui-router implementation should define its own `views` builder
	            // e.g., src/ng1/statebuilders/views.ts
	            views: [],
	            // Keep a full path from the root down to this state as this is needed for state activation.
	            path: [pathBuilder],
	            // Speed up $state.includes() as it's used a lot
	            includes: [includesBuilder],
	            resolvables: [resolvablesBuilder],
	        };
	    }
	    /**
	     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
	     * More than one BuilderFunction can be registered for a given property.
	     *
	     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
	     *
	     * @param name The name of the State property being registered for.
	     * @param fn The BuilderFunction which will be used to build the State property
	     * @returns a function which deregisters the BuilderFunction
	     */
	    StateBuilder.prototype.builder = function (name, fn) {
	        var builders = this.builders;
	        var array = builders[name] || [];
	        // Backwards compat: if only one builder exists, return it, else return whole arary.
	        if (predicates_1.isString(name) && !predicates_1.isDefined(fn))
	            return array.length > 1 ? array : array[0];
	        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn))
	            return;
	        builders[name] = array;
	        builders[name].push(fn);
	        return function () { return builders[name].splice(builders[name].indexOf(fn, 1)) && null; };
	    };
	    /**
	     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
	     * properties and API built.
	     *
	     * @param state an uninitialized State object
	     * @returns the built State object
	     */
	    StateBuilder.prototype.build = function (state) {
	        var _a = this, matcher = _a.matcher, builders = _a.builders;
	        var parent = this.parentName(state);
	        if (parent && !matcher.find(parent, undefined, false)) {
	            return null;
	        }
	        for (var key in builders) {
	            if (!builders.hasOwnProperty(key))
	                continue;
	            var chain = builders[key].reduce(function (parentFn, step) { return function (_state) { return step(_state, parentFn); }; }, common_1.noop);
	            state[key] = chain(state);
	        }
	        return state;
	    };
	    StateBuilder.prototype.parentName = function (state) {
	        // name = 'foo.bar.baz.**'
	        var name = state.name || '';
	        // segments = ['foo', 'bar', 'baz', '.**']
	        var segments = name.split('.');
	        // segments = ['foo', 'bar', 'baz']
	        var lastSegment = segments.pop();
	        // segments = ['foo', 'bar'] (ignore .** segment for future states)
	        if (lastSegment === '**')
	            segments.pop();
	        if (segments.length) {
	            if (state.parent) {
	                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
	            }
	            // 'foo.bar'
	            return segments.join('.');
	        }
	        if (!state.parent)
	            return '';
	        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	    };
	    StateBuilder.prototype.name = function (state) {
	        var name = state.name;
	        if (name.indexOf('.') !== -1 || !state.parent)
	            return name;
	        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
	        return parentName ? parentName + '.' + name : name;
	    };
	    return StateBuilder;
	}());
	exports.StateBuilder = StateBuilder;
	//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var glob_1 = __webpack_require__(380);
	var predicates_1 = __webpack_require__(377);
	/**
	 * Internal representation of a UI-Router state.
	 *
	 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
	 *
	 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
	 *
	 * This class prototypally inherits from the corresponding [[StateDeclaration]].
	 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
	 */
	var StateObject = /** @class */ (function () {
	    /** @deprecated use State.create() */
	    function StateObject(config) {
	        return StateObject.create(config || {});
	    }
	    /**
	     * Create a state object to put the private/internal implementation details onto.
	     * The object's prototype chain looks like:
	     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
	     *
	     * @param stateDecl the user-supplied State Declaration
	     * @returns {StateObject} an internal State object
	     */
	    StateObject.create = function (stateDecl) {
	        stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
	        var state = common_1.inherit(common_1.inherit(stateDecl, StateObject.prototype));
	        stateDecl.$$state = function () { return state; };
	        state.self = stateDecl;
	        state.__stateObjectCache = {
	            nameGlob: glob_1.Glob.fromString(state.name),
	        };
	        return state;
	    };
	    /**
	     * Returns true if the provided parameter is the same state.
	     *
	     * Compares the identity of the state against the passed value, which is either an object
	     * reference to the actual `State` instance, the original definition object passed to
	     * `$stateProvider.state()`, or the fully-qualified name.
	     *
	     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
	     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
	     * @returns Returns `true` if `ref` matches the current `State` instance.
	     */
	    StateObject.prototype.is = function (ref) {
	        return this === ref || this.self === ref || this.fqn() === ref;
	    };
	    /**
	     * @deprecated this does not properly handle dot notation
	     * @returns Returns a dot-separated name of the state.
	     */
	    StateObject.prototype.fqn = function () {
	        if (!this.parent || !(this.parent instanceof this.constructor))
	            return this.name;
	        var name = this.parent.fqn();
	        return name ? name + '.' + this.name : this.name;
	    };
	    /**
	     * Returns the root node of this state's tree.
	     *
	     * @returns The root of this state's tree.
	     */
	    StateObject.prototype.root = function () {
	        return (this.parent && this.parent.root()) || this;
	    };
	    /**
	     * Gets the state's `Param` objects
	     *
	     * Gets the list of [[Param]] objects owned by the state.
	     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
	     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
	     *
	     * @param opts options
	     */
	    StateObject.prototype.parameters = function (opts) {
	        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
	        var inherited = (opts.inherit && this.parent && this.parent.parameters()) || [];
	        return inherited
	            .concat(common_1.values(this.params))
	            .filter(function (param) { return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id); });
	    };
	    /**
	     * Returns a single [[Param]] that is owned by the state
	     *
	     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
	     * @param id the name of the [[Param]] to return
	     * @param opts options
	     */
	    StateObject.prototype.parameter = function (id, opts) {
	        if (opts === void 0) { opts = {}; }
	        return ((this.url && this.url.parameter(id, opts)) ||
	            common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) ||
	            (opts.inherit && this.parent && this.parent.parameter(id)));
	    };
	    StateObject.prototype.toString = function () {
	        return this.fqn();
	    };
	    /** Predicate which returns true if the object is an class with @State() decorator */
	    StateObject.isStateClass = function (stateDecl) {
	        return predicates_1.isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
	    };
	    /** Predicate which returns true if the object is an internal [[StateObject]] object */
	    StateObject.isState = function (obj) { return predicates_1.isObject(obj['__stateObjectCache']); };
	    return StateObject;
	}());
	exports.StateObject = StateObject;
	//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module state */ /** */
	var predicates_1 = __webpack_require__(377);
	var common_1 = __webpack_require__(376);
	var StateMatcher = /** @class */ (function () {
	    function StateMatcher(_states) {
	        this._states = _states;
	    }
	    StateMatcher.prototype.isRelative = function (stateName) {
	        stateName = stateName || '';
	        return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
	    };
	    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
	        if (matchGlob === void 0) { matchGlob = true; }
	        if (!stateOrName && stateOrName !== '')
	            return undefined;
	        var isStr = predicates_1.isString(stateOrName);
	        var name = isStr ? stateOrName : stateOrName.name;
	        if (this.isRelative(name))
	            name = this.resolvePath(name, base);
	        var state = this._states[name];
	        if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	            return state;
	        }
	        else if (isStr && matchGlob) {
	            var _states = common_1.values(this._states);
	            var matches = _states.filter(function (_state) { return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name); });
	            if (matches.length > 1) {
	                // tslint:disable-next-line:no-console
	                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) { return match.name; }));
	            }
	            return matches[0];
	        }
	        return undefined;
	    };
	    StateMatcher.prototype.resolvePath = function (name, base) {
	        if (!base)
	            throw new Error("No reference point given for path '" + name + "'");
	        var baseState = this.find(base);
	        var splitName = name.split('.');
	        var pathLength = splitName.length;
	        var i = 0, current = baseState;
	        for (; i < pathLength; i++) {
	            if (splitName[i] === '' && i === 0) {
	                current = baseState;
	                continue;
	            }
	            if (splitName[i] === '^') {
	                if (!current.parent)
	                    throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
	                current = current.parent;
	                continue;
	            }
	            break;
	        }
	        var relName = splitName.slice(i).join('.');
	        return current.name + (current.name && relName ? '.' : '') + relName;
	    };
	    return StateMatcher;
	}());
	exports.StateMatcher = StateMatcher;
	//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module state */ /** */
	var common_1 = __webpack_require__(375);
	var stateObject_1 = __webpack_require__(400);
	/** @internalapi */
	var StateQueueManager = /** @class */ (function () {
	    function StateQueueManager(router, states, builder, listeners) {
	        this.router = router;
	        this.states = states;
	        this.builder = builder;
	        this.listeners = listeners;
	        this.queue = [];
	    }
	    /** @internalapi */
	    StateQueueManager.prototype.dispose = function () {
	        this.queue = [];
	    };
	    StateQueueManager.prototype.register = function (stateDecl) {
	        var queue = this.queue;
	        var state = stateObject_1.StateObject.create(stateDecl);
	        var name = state.name;
	        if (!common_1.isString(name))
	            throw new Error('State must have a valid name');
	        if (this.states.hasOwnProperty(name) || common_1.inArray(queue.map(common_1.prop('name')), name))
	            throw new Error("State '" + name + "' is already defined");
	        queue.push(state);
	        this.flush();
	        return state;
	    };
	    StateQueueManager.prototype.flush = function () {
	        var _this = this;
	        var _a = this, queue = _a.queue, states = _a.states, builder = _a.builder;
	        var registered = [], // states that got registered
	        orphans = [], // states that don't yet have a parent registered
	        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
	        var getState = function (name) { return _this.states.hasOwnProperty(name) && _this.states[name]; };
	        var notifyListeners = function () {
	            if (registered.length) {
	                _this.listeners.forEach(function (listener) { return listener('registered', registered.map(function (s) { return s.self; })); });
	            }
	        };
	        while (queue.length > 0) {
	            var state = queue.shift();
	            var name_1 = state.name;
	            var result = builder.build(state);
	            var orphanIdx = orphans.indexOf(state);
	            if (result) {
	                var existingState = getState(name_1);
	                if (existingState && existingState.name === name_1) {
	                    throw new Error("State '" + name_1 + "' is already defined");
	                }
	                var existingFutureState = getState(name_1 + '.**');
	                if (existingFutureState) {
	                    // Remove future state of the same name
	                    this.router.stateRegistry.deregister(existingFutureState);
	                }
	                states[name_1] = state;
	                this.attachRoute(state);
	                if (orphanIdx >= 0)
	                    orphans.splice(orphanIdx, 1);
	                registered.push(state);
	                continue;
	            }
	            var prev = previousQueueLength[name_1];
	            previousQueueLength[name_1] = queue.length;
	            if (orphanIdx >= 0 && prev === queue.length) {
	                // Wait until two consecutive iterations where no additional states were dequeued successfully.
	                // throw new Error(`Cannot register orphaned state '${name}'`);
	                queue.push(state);
	                notifyListeners();
	                return states;
	            }
	            else if (orphanIdx < 0) {
	                orphans.push(state);
	            }
	            queue.push(state);
	        }
	        notifyListeners();
	        return states;
	    };
	    StateQueueManager.prototype.attachRoute = function (state) {
	        if (state.abstract || !state.url)
	            return;
	        var rulesApi = this.router.urlService.rules;
	        rulesApi.rule(rulesApi.urlRuleFactory.create(state));
	    };
	    return StateQueueManager;
	}());
	exports.StateQueueManager = StateQueueManager;
	//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/** @publicapi @module state */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	var stateMatcher_1 = __webpack_require__(401);
	var stateBuilder_1 = __webpack_require__(399);
	var stateQueueManager_1 = __webpack_require__(402);
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var StateRegistry = /** @class */ (function () {
	    /** @internalapi */
	    function StateRegistry(router) {
	        this.router = router;
	        this.states = {};
	        this.listeners = [];
	        this.matcher = new stateMatcher_1.StateMatcher(this.states);
	        this.builder = new stateBuilder_1.StateBuilder(this.matcher, router.urlMatcherFactory);
	        this.stateQueue = new stateQueueManager_1.StateQueueManager(router, this.states, this.builder, this.listeners);
	        this._registerRoot();
	    }
	    /** @internalapi */
	    StateRegistry.prototype._registerRoot = function () {
	        var rootStateDef = {
	            name: '',
	            url: '^',
	            views: null,
	            params: {
	                '#': { value: null, type: 'hash', dynamic: true },
	            },
	            abstract: true,
	        };
	        var _root = (this._root = this.stateQueue.register(rootStateDef));
	        _root.navigable = null;
	    };
	    /** @internalapi */
	    StateRegistry.prototype.dispose = function () {
	        var _this = this;
	        this.stateQueue.dispose();
	        this.listeners = [];
	        this.get().forEach(function (state) { return _this.get(state) && _this.deregister(state); });
	    };
	    /**
	     * Listen for a State Registry events
	     *
	     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
	     *
	     * #### Example:
	     * ```js
	     * let allStates = registry.get();
	     *
	     * // Later, invoke deregisterFn() to remove the listener
	     * let deregisterFn = registry.onStatesChanged((event, states) => {
	     *   switch(event) {
	     *     case: 'registered':
	     *       states.forEach(state => allStates.push(state));
	     *       break;
	     *     case: 'deregistered':
	     *       states.forEach(state => {
	     *         let idx = allStates.indexOf(state);
	     *         if (idx !== -1) allStates.splice(idx, 1);
	     *       });
	     *       break;
	     *   }
	     * });
	     * ```
	     *
	     * @param listener a callback function invoked when the registered states changes.
	     *        The function receives two parameters, `event` and `state`.
	     *        See [[StateRegistryListener]]
	     * @return a function that deregisters the listener
	     */
	    StateRegistry.prototype.onStatesChanged = function (listener) {
	        this.listeners.push(listener);
	        return function deregisterListener() {
	            common_1.removeFrom(this.listeners)(listener);
	        }.bind(this);
	    };
	    /**
	     * Gets the implicit root state
	     *
	     * Gets the root of the state tree.
	     * The root state is implicitly created by UI-Router.
	     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
	     *
	     * @return the root [[StateObject]]
	     */
	    StateRegistry.prototype.root = function () {
	        return this._root;
	    };
	    /**
	     * Adds a state to the registry
	     *
	     * Registers a [[StateDeclaration]] or queues it for registration.
	     *
	     * Note: a state will be queued if the state's parent isn't yet registered.
	     *
	     * @param stateDefinition the definition of the state to register.
	     * @returns the internal [[StateObject]] object.
	     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
	     *          If the state was only queued, then the object is not fully built.
	     */
	    StateRegistry.prototype.register = function (stateDefinition) {
	        return this.stateQueue.register(stateDefinition);
	    };
	    /** @hidden */
	    StateRegistry.prototype._deregisterTree = function (state) {
	        var _this = this;
	        var all = this.get().map(function (s) { return s.$$state(); });
	        var getChildren = function (states) {
	            var _children = all.filter(function (s) { return states.indexOf(s.parent) !== -1; });
	            return _children.length === 0 ? _children : _children.concat(getChildren(_children));
	        };
	        var children = getChildren([state]);
	        var deregistered = [state].concat(children).reverse();
	        deregistered.forEach(function (_state) {
	            var rulesApi = _this.router.urlService.rules;
	            // Remove URL rule
	            rulesApi
	                .rules()
	                .filter(hof_1.propEq('state', _state))
	                .forEach(function (rule) { return rulesApi.removeRule(rule); });
	            // Remove state from registry
	            delete _this.states[_state.name];
	        });
	        return deregistered;
	    };
	    /**
	     * Removes a state from the registry
	     *
	     * This removes a state from the registry.
	     * If the state has children, they are are also removed from the registry.
	     *
	     * @param stateOrName the state's name or object representation
	     * @returns {StateObject[]} a list of removed states
	     */
	    StateRegistry.prototype.deregister = function (stateOrName) {
	        var _state = this.get(stateOrName);
	        if (!_state)
	            throw new Error("Can't deregister state; not found: " + stateOrName);
	        var deregisteredStates = this._deregisterTree(_state.$$state());
	        this.listeners.forEach(function (listener) { return listener('deregistered', deregisteredStates.map(function (s) { return s.self; })); });
	        return deregisteredStates;
	    };
	    StateRegistry.prototype.get = function (stateOrName, base) {
	        var _this = this;
	        if (arguments.length === 0)
	            return Object.keys(this.states).map(function (name) { return _this.states[name].self; });
	        var found = this.matcher.find(stateOrName, base);
	        return (found && found.self) || null;
	    };
	    StateRegistry.prototype.decorator = function (name, func) {
	        return this.builder.builder(name, func);
	    };
	    return StateRegistry;
	}());
	exports.StateRegistry = StateRegistry;
	//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module state */ /** */
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var queue_1 = __webpack_require__(381);
	var coreservices_1 = __webpack_require__(379);
	var pathUtils_1 = __webpack_require__(392);
	var pathNode_1 = __webpack_require__(391);
	var transitionService_1 = __webpack_require__(405);
	var rejectFactory_1 = __webpack_require__(383);
	var targetState_1 = __webpack_require__(393);
	var param_1 = __webpack_require__(386);
	var glob_1 = __webpack_require__(380);
	var resolveContext_1 = __webpack_require__(397);
	var lazyLoad_1 = __webpack_require__(428);
	var hof_1 = __webpack_require__(378);
	/**
	 * Provides state related service functions
	 *
	 * This class provides services related to ui-router states.
	 * An instance of this class is located on the global [[UIRouter]] object.
	 */
	var StateService = /** @class */ (function () {
	    /** @internalapi */
	    function StateService(/** @hidden */ router) {
	        this.router = router;
	        /** @internalapi */
	        this.invalidCallbacks = [];
	        /** @hidden */
	        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
	            if ($error$ instanceof Error && $error$.stack) {
	                console.error($error$);
	                console.error($error$.stack);
	            }
	            else if ($error$ instanceof rejectFactory_1.Rejection) {
	                console.error($error$.toString());
	                if ($error$.detail && $error$.detail.stack)
	                    console.error($error$.detail.stack);
	            }
	            else {
	                console.error($error$);
	            }
	        };
	        var getters = ['current', '$current', 'params', 'transition'];
	        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
	        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
	    }
	    Object.defineProperty(StateService.prototype, "transition", {
	        /**
	         * The [[Transition]] currently in progress (or null)
	         *
	         * This is a passthrough through to [[UIRouterGlobals.transition]]
	         */
	        get: function () {
	            return this.router.globals.transition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "params", {
	        /**
	         * The latest successful state parameters
	         *
	         * This is a passthrough through to [[UIRouterGlobals.params]]
	         */
	        get: function () {
	            return this.router.globals.params;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "current", {
	        /**
	         * The current [[StateDeclaration]]
	         *
	         * This is a passthrough through to [[UIRouterGlobals.current]]
	         */
	        get: function () {
	            return this.router.globals.current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(StateService.prototype, "$current", {
	        /**
	         * The current [[StateObject]]
	         *
	         * This is a passthrough through to [[UIRouterGlobals.$current]]
	         */
	        get: function () {
	            return this.router.globals.$current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @internalapi */
	    StateService.prototype.dispose = function () {
	        this.defaultErrorHandler(common_1.noop);
	        this.invalidCallbacks = [];
	    };
	    /**
	     * Handler for when [[transitionTo]] is called with an invalid state.
	     *
	     * Invokes the [[onInvalid]] callbacks, in natural order.
	     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
	     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
	     *
	     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
	     *
	     * @internalapi
	     */
	    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
	        var _this = this;
	        var fromState = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
	        var globals = this.router.globals;
	        var latestThing = function () { return globals.transitionHistory.peekTail(); };
	        var latest = latestThing();
	        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
	        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
	        var checkForRedirect = function (result) {
	            if (!(result instanceof targetState_1.TargetState)) {
	                return;
	            }
	            var target = result;
	            // Recreate the TargetState, in case the state is now defined.
	            target = _this.target(target.identifier(), target.params(), target.options());
	            if (!target.valid()) {
	                return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
	            }
	            if (latestThing() !== latest) {
	                return rejectFactory_1.Rejection.superseded().toPromise();
	            }
	            return _this.transitionTo(target.identifier(), target.params(), target.options());
	        };
	        function invokeNextCallback() {
	            var nextCallback = callbackQueue.dequeue();
	            if (nextCallback === undefined)
	                return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
	            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
	            return callbackResult.then(checkForRedirect).then(function (result) { return result || invokeNextCallback(); });
	        }
	        return invokeNextCallback();
	    };
	    /**
	     * Registers an Invalid State handler
	     *
	     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
	     * has been called with an invalid state reference parameter
	     *
	     * Example:
	     * ```js
	     * stateService.onInvalid(function(to, from, injector) {
	     *   if (to.name() === 'foo') {
	     *     let lazyLoader = injector.get('LazyLoadService');
	     *     return lazyLoader.load('foo')
	     *         .then(() => stateService.target('foo'));
	     *   }
	     * });
	     * ```
	     *
	     * @param {function} callback invoked when the toState is invalid
	     *   This function receives the (invalid) toState, the fromState, and an injector.
	     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
	     *   If one is returned, it is treated as a redirect.
	     *
	     * @returns a function which deregisters the callback
	     */
	    StateService.prototype.onInvalid = function (callback) {
	        this.invalidCallbacks.push(callback);
	        return function deregisterListener() {
	            common_1.removeFrom(this.invalidCallbacks)(callback);
	        }.bind(this);
	    };
	    /**
	     * Reloads the current state
	     *
	     * A method that force reloads the current state, or a partial state hierarchy.
	     * All resolves are re-resolved, and components reinstantiated.
	     *
	     * #### Example:
	     * ```js
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * ```
	     *
	     * Note: `reload()` is just an alias for:
	     *
	     * ```js
	     * $state.transitionTo($state.current, $state.params, {
	     *   reload: true, inherit: false
	     * });
	     * ```
	     *
	     * @param reloadState A state name or a state object.
	     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
	     *
	     * #### Example:
	     * ```js
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
	     * //and current state is 'contacts.detail.item'
	     * let app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * ```
	     *
	     * @returns A promise representing the state of the new transition. See [[StateService.go]]
	     */
	    StateService.prototype.reload = function (reloadState) {
	        return this.transitionTo(this.current, this.params, {
	            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
	            inherit: false,
	            notify: false,
	        });
	    };
	    /**
	     * Transition to a different state and/or parameters
	     *
	     * Convenience method for transitioning to a new state.
	     *
	     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
	     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
	     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
	     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
	     * inherit from the current parameter values (because of `inherit: true`).
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to Absolute state name, state object, or relative state path (relative to current state).
	     *
	     * Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to the parent state
	     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
	     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
	     *
	     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
	     *
	     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
	     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
	     *
	     * @param options Transition options
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     */
	    StateService.prototype.go = function (to, params, options) {
	        var defautGoOpts = { relative: this.$current, inherit: true };
	        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
	        return this.transitionTo(to, params, transOpts);
	    };
	    /**
	     * Creates a [[TargetState]]
	     *
	     * This is a factory method for creating a TargetState
	     *
	     * This may be returned from a Transition Hook to redirect a transition, for example.
	     */
	    StateService.prototype.target = function (identifier, params, options) {
	        if (options === void 0) { options = {}; }
	        // If we're reloading, find the state object to reload from
	        if (predicates_1.isObject(options.reload) && !options.reload.name)
	            throw new Error('Invalid reload state object');
	        var reg = this.router.stateRegistry;
	        options.reloadState =
	            options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
	        if (options.reload && !options.reloadState)
	            throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
	        return new targetState_1.TargetState(this.router.stateRegistry, identifier, params, options);
	    };
	    StateService.prototype.getCurrentPath = function () {
	        var _this = this;
	        var globals = this.router.globals;
	        var latestSuccess = globals.successfulTransitions.peekTail();
	        var rootPath = function () { return [new pathNode_1.PathNode(_this.router.stateRegistry.root())]; };
	        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
	    };
	    /**
	     * Low-level method for transitioning to a new state.
	     *
	     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
	     *
	     * #### Example:
	     * ```js
	     * let app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * ```
	     *
	     * @param to State name or state object.
	     * @param toParams A map of the parameters that will be sent to the state,
	     *      will populate $stateParams.
	     * @param options Transition options
	     *
	     * @returns A promise representing the state of the new transition. See [[go]]
	     */
	    StateService.prototype.transitionTo = function (to, toParams, options) {
	        var _this = this;
	        if (toParams === void 0) { toParams = {}; }
	        if (options === void 0) { options = {}; }
	        var router = this.router;
	        var globals = router.globals;
	        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
	        var getCurrent = function () { return globals.transition; };
	        options = common_1.extend(options, { current: getCurrent });
	        var ref = this.target(to, toParams, options);
	        var currentPath = this.getCurrentPath();
	        if (!ref.exists())
	            return this._handleInvalidTargetState(currentPath, ref);
	        if (!ref.valid())
	            return common_1.silentRejection(ref.error());
	        /**
	         * Special handling for Ignored, Aborted, and Redirected transitions
	         *
	         * The semantics for the transition.run() promise and the StateService.transitionTo()
	         * promise differ. For instance, the run() promise may be rejected because it was
	         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
	         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
	         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
	         */
	        var rejectedTransitionHandler = function (trans) { return function (error) {
	            if (error instanceof rejectFactory_1.Rejection) {
	                var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
	                if (error.type === rejectFactory_1.RejectType.IGNORED) {
	                    isLatest && router.urlRouter.update();
	                    // Consider ignored `Transition.run()` as a successful `transitionTo`
	                    return coreservices_1.services.$q.when(globals.current);
	                }
	                var detail = error.detail;
	                if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
	                    // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
	                    // by returning the promise for the new (redirect) `Transition.run()`.
	                    var redirect = trans.redirect(detail);
	                    return redirect.run().catch(rejectedTransitionHandler(redirect));
	                }
	                if (error.type === rejectFactory_1.RejectType.ABORTED) {
	                    isLatest && router.urlRouter.update();
	                    return coreservices_1.services.$q.reject(error);
	                }
	            }
	            var errorHandler = _this.defaultErrorHandler();
	            errorHandler(error);
	            return coreservices_1.services.$q.reject(error);
	        }; };
	        var transition = this.router.transitionService.create(currentPath, ref);
	        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
	        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
	        // Return a promise for the transition, which also has the transition object on it.
	        return common_1.extend(transitionToPromise, { transition: transition });
	    };
	    /**
	     * Checks if the current state *is* the provided state
	     *
	     * Similar to [[includes]] but only checks for the full state name.
	     * If params is supplied then it will be tested for strict equality against the current
	     * active params object, so all params must match with none missing and no extras.
	     *
	     * #### Example:
	     * ```js
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     * ```
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * ```html
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * ```
	     *
	     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns Returns true if it is the state.
	     */
	    StateService.prototype.is = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (this.$current !== state)
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Checks if the current state *includes* the provided state
	     *
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * #### Example when `$state.$current.name === 'contacts.details.item'`
	     * ```js
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     * ```
	     *
	     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
	     * ```js
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * ```
	     *
	     * @param stateOrName A partial name, relative name, glob pattern,
	     *   or state object to be searched for within the current state name.
	     * @param params A param object, e.g. `{sectionId: section.id}`,
	     *   that you'd like to test against the current active state.
	     * @param options An options object. The options are:
	     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     *     test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    StateService.prototype.includes = function (stateOrName, params, options) {
	        options = common_1.defaults(options, { relative: this.$current });
	        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
	        if (glob) {
	            if (!glob.matches(this.$current.name))
	                return false;
	            stateOrName = this.$current.name;
	        }
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative), include = this.$current.includes;
	        if (!predicates_1.isDefined(state))
	            return undefined;
	        if (!predicates_1.isDefined(include[state.name]))
	            return false;
	        if (!params)
	            return true;
	        var schema = state.parameters({ inherit: true, matchingKeys: params });
	        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
	    };
	    /**
	     * Generates a URL for a state and parameters
	     *
	     * Returns the url for the given state populated with the given params.
	     *
	     * #### Example:
	     * ```js
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * ```
	     *
	     * @param stateOrName The state name or state object you'd like to generate a url from.
	     * @param params An object of parameter values to fill the state's required parameters.
	     * @param options Options object. The options are:
	     *
	     * @returns {string} compiled state url
	     */
	    StateService.prototype.href = function (stateOrName, params, options) {
	        var defaultHrefOpts = {
	            lossy: true,
	            inherit: true,
	            absolute: false,
	            relative: this.$current,
	        };
	        options = common_1.defaults(options, defaultHrefOpts);
	        params = params || {};
	        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
	        if (!predicates_1.isDefined(state))
	            return null;
	        if (options.inherit)
	            params = this.params.$inherit(params, this.$current, state);
	        var nav = state && options.lossy ? state.navigable : state;
	        if (!nav || nav.url === undefined || nav.url === null) {
	            return null;
	        }
	        return this.router.urlRouter.href(nav.url, params, { absolute: options.absolute });
	    };
	    /**
	     * Sets or gets the default [[transitionTo]] error handler.
	     *
	     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
	     * This includes errors caused by resolves and transition hooks.
	     *
	     * Note:
	     * This handler does not receive certain Transition rejections.
	     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
	     *
	     * The built-in default error handler logs the error to the console.
	     *
	     * You can provide your own custom handler.
	     *
	     * #### Example:
	     * ```js
	     * stateService.defaultErrorHandler(function() {
	     *   // Do not log transitionTo errors
	     * });
	     * ```
	     *
	     * @param handler a global error handler function
	     * @returns the current global error handler
	     */
	    StateService.prototype.defaultErrorHandler = function (handler) {
	        return (this._defaultErrorHandler = handler || this._defaultErrorHandler);
	    };
	    StateService.prototype.get = function (stateOrName, base) {
	        var reg = this.router.stateRegistry;
	        if (arguments.length === 0)
	            return reg.get();
	        return reg.get(stateOrName, base || this.$current);
	    };
	    /**
	     * Lazy loads a state
	     *
	     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
	     *
	     * @param stateOrName the state that should be lazy loaded
	     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
	     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
	     * This noop transition is not actually run.
	     *
	     * @returns a promise to lazy load
	     */
	    StateService.prototype.lazyLoad = function (stateOrName, transition) {
	        var state = this.get(stateOrName);
	        if (!state || !state.lazyLoad)
	            throw new Error('Can not lazy load ' + stateOrName);
	        var currentPath = this.getCurrentPath();
	        var target = pathUtils_1.PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
	        transition = transition || this.router.transitionService.create(currentPath, target);
	        return lazyLoad_1.lazyLoadState(transition, state);
	    };
	    return StateService;
	}());
	exports.StateService = StateService;
	//# sourceMappingURL=stateService.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module transition */ /** */
	var interface_1 = __webpack_require__(406);
	var transition_1 = __webpack_require__(407);
	var hookRegistry_1 = __webpack_require__(409);
	var coreResolvables_1 = __webpack_require__(411);
	var redirectTo_1 = __webpack_require__(422);
	var onEnterExitRetain_1 = __webpack_require__(423);
	var resolve_1 = __webpack_require__(424);
	var views_1 = __webpack_require__(425);
	var updateGlobals_1 = __webpack_require__(426);
	var url_1 = __webpack_require__(427);
	var lazyLoad_1 = __webpack_require__(428);
	var transitionEventType_1 = __webpack_require__(429);
	var transitionHook_1 = __webpack_require__(408);
	var predicates_1 = __webpack_require__(377);
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var ignoredTransition_1 = __webpack_require__(430);
	var invalidTransition_1 = __webpack_require__(431);
	/**
	 * The default [[Transition]] options.
	 *
	 * Include this object when applying custom defaults:
	 * let reloadOpts = { reload: true, notify: true }
	 * let options = defaults(theirOpts, customDefaults, defaultOptions);
	 */
	exports.defaultTransOpts = {
	    location: true,
	    relative: null,
	    inherit: false,
	    notify: true,
	    reload: false,
	    custom: {},
	    current: function () { return null; },
	    source: 'unknown',
	};
	/**
	 * This class provides services related to Transitions.
	 *
	 * - Most importantly, it allows global Transition Hooks to be registered.
	 * - It allows the default transition error handler to be set.
	 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
	 *
	 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
	 */
	var TransitionService = /** @class */ (function () {
	    /** @hidden */
	    function TransitionService(_router) {
	        /** @hidden */
	        this._transitionCount = 0;
	        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
	        this._eventTypes = [];
	        /** @hidden The registered transition hooks */
	        this._registeredHooks = {};
	        /** @hidden The  paths on a criteria object */
	        this._criteriaPaths = {};
	        this._router = _router;
	        this.$view = _router.viewService;
	        this._deregisterHookFns = {};
	        this._pluginapi = (common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), [
	            '_definePathType',
	            '_defineEvent',
	            '_getPathTypes',
	            '_getEvents',
	            'getHooks',
	        ]));
	        this._defineCorePaths();
	        this._defineCoreEvents();
	        this._registerCoreTransitionHooks();
	        _router.globals.successfulTransitions.onEvict(coreResolvables_1.treeChangesCleanup);
	    }
	    /**
	     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
	     *
	     * Registers a transition lifecycle hook, which is invoked during transition construction.
	     *
	     * This low level hook should only be used by plugins.
	     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
	     * The Sticky States plugin uses this hook to modify the treechanges.
	     *
	     * ### Lifecycle
	     *
	     * `onCreate` hooks are invoked *while a transition is being constructed*.
	     *
	     * ### Return value
	     *
	     * The hook's return value is ignored
	     *
	     * @internalapi
	     * @param criteria defines which Transitions the Hook should be invoked for.
	     * @param callback the hook function which will be invoked.
	     * @param options the registration options
	     * @returns a function which deregisters the hook.
	     */
	    TransitionService.prototype.onCreate = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    TransitionService.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /**
	     * dispose
	     * @internalapi
	     */
	    TransitionService.prototype.dispose = function (router) {
	        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
	            return hooksArray.forEach(function (hook) {
	                hook._deregistered = true;
	                common_1.removeFrom(hooksArray, hook);
	            });
	        });
	    };
	    /**
	     * Creates a new [[Transition]] object
	     *
	     * This is a factory function for creating new Transition objects.
	     * It is used internally by the [[StateService]] and should generally not be called by application code.
	     *
	     * @param fromPath the path to the current state (the from state)
	     * @param targetState the target state (destination)
	     * @returns a Transition
	     */
	    TransitionService.prototype.create = function (fromPath, targetState) {
	        return new transition_1.Transition(fromPath, targetState, this._router);
	    };
	    /** @hidden */
	    TransitionService.prototype._defineCoreEvents = function () {
	        var Phase = interface_1.TransitionHookPhase;
	        var TH = transitionHook_1.TransitionHook;
	        var paths = this._criteriaPaths;
	        var NORMAL_SORT = false, REVERSE_SORT = true;
	        var SYNCHRONOUS = true;
	        this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
	        this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
	        this._defineEvent('onStart', Phase.RUN, 0, paths.to);
	        this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
	        this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
	        this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
	        this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
	        this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	        this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
	    };
	    /** @hidden */
	    TransitionService.prototype._defineCorePaths = function () {
	        var STATE = interface_1.TransitionHookScope.STATE, TRANSITION = interface_1.TransitionHookScope.TRANSITION;
	        this._definePathType('to', TRANSITION);
	        this._definePathType('from', TRANSITION);
	        this._definePathType('exiting', STATE);
	        this._definePathType('retained', STATE);
	        this._definePathType('entering', STATE);
	    };
	    /** @hidden */
	    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
	        this._eventTypes.push(eventType);
	        hookRegistry_1.makeEvent(this, this, eventType);
	    };
	    /** @hidden */
	    // tslint:disable-next-line
	    TransitionService.prototype._getEvents = function (phase) {
	        var transitionHookTypes = predicates_1.isDefined(phase)
	            ? this._eventTypes.filter(function (type) { return type.hookPhase === phase; })
	            : this._eventTypes.slice();
	        return transitionHookTypes.sort(function (l, r) {
	            var cmpByPhase = l.hookPhase - r.hookPhase;
	            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
	        });
	    };
	    /**
	     * Adds a Path to be used as a criterion against a TreeChanges path
	     *
	     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
	     * Each state in the exiting path is checked against the criteria and returned as part of the match.
	     *
	     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
	     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
	     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
	     *
	     * @hidden
	     */
	    TransitionService.prototype._definePathType = function (name, hookScope) {
	        this._criteriaPaths[name] = { name: name, scope: hookScope };
	    };
	    /** * @hidden */
	    // tslint:disable-next-line
	    TransitionService.prototype._getPathTypes = function () {
	        return this._criteriaPaths;
	    };
	    /** @hidden */
	    TransitionService.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    /** @hidden */
	    TransitionService.prototype._registerCoreTransitionHooks = function () {
	        var fns = this._deregisterHookFns;
	        fns.addCoreResolves = coreResolvables_1.registerAddCoreResolvables(this);
	        fns.ignored = ignoredTransition_1.registerIgnoredTransitionHook(this);
	        fns.invalid = invalidTransition_1.registerInvalidTransitionHook(this);
	        // Wire up redirectTo hook
	        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
	        // Wire up onExit/Retain/Enter state hooks
	        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
	        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
	        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
	        // Wire up Resolve hooks
	        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
	        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
	        fns.resolveAll = resolve_1.registerResolveRemaining(this);
	        // Wire up the View management hooks
	        fns.loadViews = views_1.registerLoadEnteringViews(this);
	        fns.activateViews = views_1.registerActivateViews(this);
	        // Updates global state after a transition
	        fns.updateGlobals = updateGlobals_1.registerUpdateGlobalState(this);
	        // After globals.current is updated at priority: 10000
	        fns.updateUrl = url_1.registerUpdateUrl(this);
	        // Lazy load state trees
	        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
	    };
	    return TransitionService;
	}());
	exports.TransitionService = TransitionService;
	//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var TransitionHookPhase;
	(function (TransitionHookPhase) {
	    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
	    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
	    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
	    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
	    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
	})(TransitionHookPhase || (TransitionHookPhase = {}));
	exports.TransitionHookPhase = TransitionHookPhase;
	var TransitionHookScope;
	(function (TransitionHookScope) {
	    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
	    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
	})(TransitionHookScope || (TransitionHookScope = {}));
	exports.TransitionHookScope = TransitionHookScope;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module transition */ /** */
	var trace_1 = __webpack_require__(384);
	var coreservices_1 = __webpack_require__(379);
	var strings_1 = __webpack_require__(382);
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var hof_1 = __webpack_require__(378);
	var interface_1 = __webpack_require__(406); // has or is using
	var transitionHook_1 = __webpack_require__(408);
	var hookRegistry_1 = __webpack_require__(409);
	var hookBuilder_1 = __webpack_require__(410);
	var pathUtils_1 = __webpack_require__(392);
	var param_1 = __webpack_require__(386);
	var resolvable_1 = __webpack_require__(396);
	var resolveContext_1 = __webpack_require__(397);
	var rejectFactory_1 = __webpack_require__(383);
	var common_2 = __webpack_require__(375);
	/** @hidden */
	var stateSelf = hof_1.prop('self');
	/**
	 * Represents a transition between two states.
	 *
	 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
	 *
	 * This object contains all contextual information about the to/from states, parameters, resolves.
	 * It has information about all states being entered and exited as a result of the transition.
	 */
	var Transition = /** @class */ (function () {
	    /**
	     * Creates a new Transition object.
	     *
	     * If the target state is not valid, an error is thrown.
	     *
	     * @internalapi
	     *
	     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
	     *        encapsulates the "from state".
	     * @param targetState The target state and parameters being transitioned to (also, the transition options)
	     * @param router The [[UIRouter]] instance
	     */
	    function Transition(fromPath, targetState, router) {
	        var _this = this;
	        /** @hidden */
	        this._deferred = coreservices_1.services.$q.defer();
	        /**
	         * This promise is resolved or rejected based on the outcome of the Transition.
	         *
	         * When the transition is successful, the promise is resolved
	         * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
	         */
	        this.promise = this._deferred.promise;
	        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
	        this._registeredHooks = {};
	        /** @hidden */
	        this._hookBuilder = new hookBuilder_1.HookBuilder(this);
	        /** Checks if this transition is currently active/running. */
	        this.isActive = function () { return _this.router.globals.transition === _this; };
	        this.router = router;
	        this._targetState = targetState;
	        if (!targetState.valid()) {
	            throw new Error(targetState.error());
	        }
	        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
	        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
	        this.$id = router.transitionService._transitionCount++;
	        var toPath = pathUtils_1.PathUtils.buildToPath(fromPath, targetState);
	        this._treeChanges = pathUtils_1.PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
	        this.createTransitionHookRegFns();
	        var onCreateHooks = this._hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
	        transitionHook_1.TransitionHook.invokeHooks(onCreateHooks, function () { return null; });
	        this.applyViewConfigs(router);
	    }
	    /** @hidden */
	    Transition.prototype.onBefore = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onStart = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onExit = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onRetain = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onEnter = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onFinish = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onSuccess = function (criteria, callback, options) {
	        return;
	    };
	    /** @inheritdoc */
	    Transition.prototype.onError = function (criteria, callback, options) {
	        return;
	    };
	    /** @hidden
	     * Creates the transition-level hook registration functions
	     * (which can then be used to register hooks)
	     */
	    Transition.prototype.createTransitionHookRegFns = function () {
	        var _this = this;
	        this.router.transitionService._pluginapi
	            ._getEvents()
	            .filter(function (type) { return type.hookPhase !== interface_1.TransitionHookPhase.CREATE; })
	            .forEach(function (type) { return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type); });
	    };
	    /** @internalapi */
	    Transition.prototype.getHooks = function (hookName) {
	        return this._registeredHooks[hookName];
	    };
	    Transition.prototype.applyViewConfigs = function (router) {
	        var enteringStates = this._treeChanges.entering.map(function (node) { return node.state; });
	        pathUtils_1.PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
	    };
	    /**
	     * @internalapi
	     *
	     * @returns the internal from [State] object
	     */
	    Transition.prototype.$from = function () {
	        return common_1.tail(this._treeChanges.from).state;
	    };
	    /**
	     * @internalapi
	     *
	     * @returns the internal to [State] object
	     */
	    Transition.prototype.$to = function () {
	        return common_1.tail(this._treeChanges.to).state;
	    };
	    /**
	     * Returns the "from state"
	     *
	     * Returns the state that the transition is coming *from*.
	     *
	     * @returns The state declaration object for the Transition's ("from state").
	     */
	    Transition.prototype.from = function () {
	        return this.$from().self;
	    };
	    /**
	     * Returns the "to state"
	     *
	     * Returns the state that the transition is going *to*.
	     *
	     * @returns The state declaration object for the Transition's target state ("to state").
	     */
	    Transition.prototype.to = function () {
	        return this.$to().self;
	    };
	    /**
	     * Gets the Target State
	     *
	     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
	     *
	     * @returns the [[TargetState]] of this Transition
	     */
	    Transition.prototype.targetState = function () {
	        return this._targetState;
	    };
	    /**
	     * Determines whether two transitions are equivalent.
	     * @deprecated
	     */
	    Transition.prototype.is = function (compare) {
	        if (compare instanceof Transition) {
	            // TODO: Also compare parameters
	            return this.is({ to: compare.$to().name, from: compare.$from().name });
	        }
	        return !((compare.to && !hookRegistry_1.matchState(this.$to(), compare.to, this)) ||
	            (compare.from && !hookRegistry_1.matchState(this.$from(), compare.from, this)));
	    };
	    Transition.prototype.params = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}));
	    };
	    Transition.prototype.paramsChanged = function () {
	        var fromParams = this.params('from');
	        var toParams = this.params('to');
	        // All the parameters declared on both the "to" and "from" paths
	        var allParamDescriptors = []
	            .concat(this._treeChanges.to)
	            .concat(this._treeChanges.from)
	            .map(function (pathNode) { return pathNode.paramSchema; })
	            .reduce(common_2.flattenR, [])
	            .reduce(common_2.uniqR, []);
	        var changedParamDescriptors = param_1.Param.changed(allParamDescriptors, fromParams, toParams);
	        return changedParamDescriptors.reduce(function (changedValues, descriptor) {
	            changedValues[descriptor.id] = toParams[descriptor.id];
	            return changedValues;
	        }, {});
	    };
	    /**
	     * Creates a [[UIInjector]] Dependency Injector
	     *
	     * Returns a Dependency Injector for the Transition's target state (to state).
	     * The injector provides resolve values which the target state has access to.
	     *
	     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
	     *
	     * #### Example:
	     * ```js
	     * .onEnter({ entering: 'myState' }, trans => {
	     *   var myResolveValue = trans.injector().get('myResolve');
	     *   // Inject a global service from the global/native injector (if it exists)
	     *   var MyService = trans.injector().get('MyService');
	     * })
	     * ```
	     *
	     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
	     * You can use [[UIInjector.getAsync]] to get a promise for the data.
	     * #### Example:
	     * ```js
	     * .onBefore({}, trans => {
	     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
	     *     return myResolveValue !== 'ABORT';
	     *   });
	     * });
	     * ```
	     *
	     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
	     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
	     * #### Example:
	     * ```js
	     * .onEnter({ to: 'foo.bar' }, trans => {
	     *   // returns result of `foo` state's `myResolve` resolve
	     *   // even though `foo.bar` also has a `myResolve` resolve
	     *   var fooData = trans.injector('foo').get('myResolve');
	     * });
	     * ```
	     *
	     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
	     * The resolve data from the `from` path will be returned.
	     * #### Example:
	     * ```js
	     * .onExit({ exiting: 'foo.bar' }, trans => {
	     *   // Gets the resolve value of `myResolve` from the state being exited
	     *   var fooData = trans.injector(null, 'from').get('myResolve');
	     * });
	     * ```
	     *
	     *
	     * @param state Limits the resolves provided to only the resolves the provided state has access to.
	     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
	     *
	     * @returns a [[UIInjector]]
	     */
	    Transition.prototype.injector = function (state, pathName) {
	        if (pathName === void 0) { pathName = 'to'; }
	        var path = this._treeChanges[pathName];
	        if (state)
	            path = pathUtils_1.PathUtils.subPath(path, function (node) { return node.state === state || node.state.name === state; });
	        return new resolveContext_1.ResolveContext(path).injector();
	    };
	    /**
	     * Gets all available resolve tokens (keys)
	     *
	     * This method can be used in conjunction with [[injector]] to inspect the resolve values
	     * available to the Transition.
	     *
	     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
	     * in the Transition's [[TreeChanges.to]] path.
	     *
	     * #### Example:
	     * This example logs all resolve values
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
	     * ```
	     *
	     * #### Example:
	     * This example creates promises for each resolve value.
	     * This triggers fetches of resolves (if any have not yet been fetched).
	     * When all promises have all settled, it logs the resolve values.
	     * ```js
	     * let tokens = trans.getResolveTokens();
	     * let promise = tokens.map(token => trans.injector().getAsync(token));
	     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
	     * ```
	     *
	     * Note: Angular 1 users whould use `$q.all()`
	     *
	     * @param pathname resolve context's path name (e.g., `to` or `from`)
	     *
	     * @returns an array of resolve tokens (keys)
	     */
	    Transition.prototype.getResolveTokens = function (pathname) {
	        if (pathname === void 0) { pathname = 'to'; }
	        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
	    };
	    /**
	     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
	     *
	     * Allows a transition hook to dynamically add a Resolvable to this Transition.
	     *
	     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
	     *
	     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
	     * If no `state` is provided then the root state is used.
	     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
	     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
	     *
	     * The `state` argument also scopes the resolved data.
	     * The resolved data is available from the injector for that `state` and any children states.
	     *
	     * #### Example:
	     * ```js
	     * transitionService.onBefore({}, transition => {
	     *   transition.addResolvable({
	     *     token: 'myResolve',
	     *     deps: ['MyService'],
	     *     resolveFn: myService => myService.getData()
	     *   });
	     * });
	     * ```
	     *
	     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
	     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
	     */
	    Transition.prototype.addResolvable = function (resolvable, state) {
	        if (state === void 0) { state = ''; }
	        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
	        var stateName = typeof state === 'string' ? state : state.name;
	        var topath = this._treeChanges.to;
	        var targetNode = common_1.find(topath, function (node) { return node.state.name === stateName; });
	        var resolveContext = new resolveContext_1.ResolveContext(topath);
	        resolveContext.addResolvables([resolvable], targetNode.state);
	    };
	    /**
	     * Gets the transition from which this transition was redirected.
	     *
	     * If the current transition is a redirect, this method returns the transition that was redirected.
	     *
	     * #### Example:
	     * ```js
	     * let transitionA = $state.go('A').transition
	     * transitionA.onStart({}, () => $state.target('B'));
	     * $transitions.onSuccess({ to: 'B' }, (trans) => {
	     *   trans.to().name === 'B'; // true
	     *   trans.redirectedFrom() === transitionA; // true
	     * });
	     * ```
	     *
	     * @returns The previous Transition, or null if this Transition is not the result of a redirection
	     */
	    Transition.prototype.redirectedFrom = function () {
	        return this._options.redirectedFrom || null;
	    };
	    /**
	     * Gets the original transition in a redirect chain
	     *
	     * A transition might belong to a long chain of multiple redirects.
	     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
	     *
	     * #### Example:
	     * ```js
	     * // states
	     * registry.register({ name: 'A', redirectTo: 'B' });
	     * registry.register({ name: 'B', redirectTo: 'C' });
	     * registry.register({ name: 'C', redirectTo: 'D' });
	     * registry.register({ name: 'D' });
	     *
	     * let transitionA = $state.go('A').transition
	     *
	     * $transitions.onSuccess({ to: 'D' }, (trans) => {
	     *   trans.to().name === 'D'; // true
	     *   trans.redirectedFrom().to().name === 'C'; // true
	     *   trans.originalTransition() === transitionA; // true
	     *   trans.originalTransition().to().name === 'A'; // true
	     * });
	     * ```
	     *
	     * @returns The original Transition that started a redirect chain
	     */
	    Transition.prototype.originalTransition = function () {
	        var rf = this.redirectedFrom();
	        return (rf && rf.originalTransition()) || this;
	    };
	    /**
	     * Get the transition options
	     *
	     * @returns the options for this Transition.
	     */
	    Transition.prototype.options = function () {
	        return this._options;
	    };
	    /**
	     * Gets the states being entered.
	     *
	     * @returns an array of states that will be entered during this transition.
	     */
	    Transition.prototype.entering = function () {
	        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Gets the states being exited.
	     *
	     * @returns an array of states that will be exited during this transition.
	     */
	    Transition.prototype.exiting = function () {
	        return common_1.map(this._treeChanges.exiting, hof_1.prop('state'))
	            .map(stateSelf)
	            .reverse();
	    };
	    /**
	     * Gets the states being retained.
	     *
	     * @returns an array of states that are already entered from a previous Transition, that will not be
	     *    exited during this Transition
	     */
	    Transition.prototype.retained = function () {
	        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
	    };
	    /**
	     * Get the [[ViewConfig]]s associated with this Transition
	     *
	     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
	     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
	     *
	     * @param pathname the name of the path to fetch views for:
	     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
	     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
	     *
	     * @returns a list of ViewConfig objects for the given path.
	     */
	    Transition.prototype.views = function (pathname, state) {
	        if (pathname === void 0) { pathname = 'entering'; }
	        var path = this._treeChanges[pathname];
	        path = !state ? path : path.filter(hof_1.propEq('state', state));
	        return path
	            .map(hof_1.prop('views'))
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, []);
	    };
	    Transition.prototype.treeChanges = function (pathname) {
	        return pathname ? this._treeChanges[pathname] : this._treeChanges;
	    };
	    /**
	     * Creates a new transition that is a redirection of the current one.
	     *
	     * This transition can be returned from a [[TransitionService]] hook to
	     * redirect a transition to a new state and/or set of parameters.
	     *
	     * @internalapi
	     *
	     * @returns Returns a new [[Transition]] instance.
	     */
	    Transition.prototype.redirect = function (targetState) {
	        var redirects = 1, trans = this;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((trans = trans.redirectedFrom()) != null) {
	            if (++redirects > 20)
	                throw new Error("Too many consecutive Transition redirects (20+)");
	        }
	        var redirectOpts = { redirectedFrom: this, source: 'redirect' };
	        // If the original transition was caused by URL sync, then use { location: 'replace' }
	        // on the new transition (unless the target state explicitly specifies location: false).
	        // This causes the original url to be replaced with the url for the redirect target
	        // so the original url disappears from the browser history.
	        if (this.options().source === 'url' && targetState.options().location !== false) {
	            redirectOpts.location = 'replace';
	        }
	        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
	        targetState = targetState.withOptions(newOptions, true);
	        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
	        var originalEnteringNodes = this._treeChanges.entering;
	        var redirectEnteringNodes = newTransition._treeChanges.entering;
	        // --- Re-use resolve data from original transition ---
	        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
	        // (because of the redirect), the resolves fetched by the original transition are still valid in the
	        // redirected transition.
	        //
	        // This allows you to define a redirect on a parent state which depends on an async resolve value.
	        // You can wait for the resolve, then redirect to a child state based on the result.
	        // The redirected transition does not have to re-fetch the resolve.
	        // ---------------------------------------------------------
	        var nodeIsReloading = function (reloadState) { return function (node) {
	            return reloadState && node.state.includes[reloadState.name];
	        }; };
	        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
	        var matchingEnteringNodes = pathUtils_1.PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, pathUtils_1.PathUtils.nonDynamicParams).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
	        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
	        matchingEnteringNodes.forEach(function (node, idx) {
	            node.resolvables = originalEnteringNodes[idx].resolvables;
	        });
	        return newTransition;
	    };
	    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
	    Transition.prototype._changedParams = function () {
	        var tc = this._treeChanges;
	        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
	        // If user explicitly wants a reload
	        if (this._options.reload)
	            return undefined;
	        // If any states are exiting or entering
	        if (tc.exiting.length || tc.entering.length)
	            return undefined;
	        // If to/from path lengths differ
	        if (tc.to.length !== tc.from.length)
	            return undefined;
	        // If the to/from paths are different
	        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from)
	            .map(function (tuple) { return tuple[0].state !== tuple[1].state; })
	            .reduce(common_1.anyTrueR, false);
	        if (pathsDiffer)
	            return undefined;
	        // Find any parameter values that differ
	        var nodeSchemas = tc.to.map(function (node) { return node.paramSchema; });
	        var _a = [tc.to, tc.from].map(function (path) { return path.map(function (x) { return x.paramValues; }); }), toValues = _a[0], fromValues = _a[1];
	        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
	        return tuples.map(function (_a) {
	            var schema = _a[0], toVals = _a[1], fromVals = _a[2];
	            return param_1.Param.changed(schema, toVals, fromVals);
	        }).reduce(common_1.unnestR, []);
	    };
	    /**
	     * Returns true if the transition is dynamic.
	     *
	     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
	     *
	     * @returns true if the Transition is dynamic
	     */
	    Transition.prototype.dynamic = function () {
	        var changes = this._changedParams();
	        return !changes ? false : changes.map(function (x) { return x.dynamic; }).reduce(common_1.anyTrueR, false);
	    };
	    /**
	     * Returns true if the transition is ignored.
	     *
	     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
	     *
	     * @returns true if the Transition is ignored.
	     */
	    Transition.prototype.ignored = function () {
	        return !!this._ignoredReason();
	    };
	    /** @hidden */
	    Transition.prototype._ignoredReason = function () {
	        var pending = this.router.globals.transition;
	        var reloadState = this._options.reloadState;
	        var same = function (pathA, pathB) {
	            if (pathA.length !== pathB.length)
	                return false;
	            var matching = pathUtils_1.PathUtils.matching(pathA, pathB);
	            return pathA.length === matching.filter(function (node) { return !reloadState || !node.state.includes[reloadState.name]; }).length;
	        };
	        var newTC = this.treeChanges();
	        var pendTC = pending && pending.treeChanges();
	        if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting))
	            return 'SameAsPending';
	        if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to))
	            return 'SameAsCurrent';
	    };
	    /**
	     * Runs the transition
	     *
	     * This method is generally called from the [[StateService.transitionTo]]
	     *
	     * @internalapi
	     *
	     * @returns a promise for a successful transition.
	     */
	    Transition.prototype.run = function () {
	        var _this = this;
	        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
	        // Gets transition hooks array for the given phase
	        var getHooksFor = function (phase) { return _this._hookBuilder.buildHooksForPhase(phase); };
	        // When the chain is complete, then resolve or reject the deferred
	        var transitionSuccess = function () {
	            trace_1.trace.traceSuccess(_this.$to(), _this);
	            _this.success = true;
	            _this._deferred.resolve(_this.to());
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.SUCCESS));
	        };
	        var transitionError = function (reason) {
	            trace_1.trace.traceError(reason, _this);
	            _this.success = false;
	            _this._deferred.reject(reason);
	            _this._error = reason;
	            runAllHooks(getHooksFor(interface_1.TransitionHookPhase.ERROR));
	        };
	        var runTransition = function () {
	            // Wait to build the RUN hook chain until the BEFORE hooks are done
	            // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
	            var allRunHooks = getHooksFor(interface_1.TransitionHookPhase.RUN);
	            var done = function () { return coreservices_1.services.$q.when(undefined); };
	            return transitionHook_1.TransitionHook.invokeHooks(allRunHooks, done);
	        };
	        var startTransition = function () {
	            var globals = _this.router.globals;
	            globals.lastStartedTransitionId = _this.$id;
	            globals.transition = _this;
	            globals.transitionHistory.enqueue(_this);
	            trace_1.trace.traceTransitionStart(_this);
	            return coreservices_1.services.$q.when(undefined);
	        };
	        var allBeforeHooks = getHooksFor(interface_1.TransitionHookPhase.BEFORE);
	        transitionHook_1.TransitionHook.invokeHooks(allBeforeHooks, startTransition)
	            .then(runTransition)
	            .then(transitionSuccess, transitionError);
	        return this.promise;
	    };
	    /**
	     * Checks if the Transition is valid
	     *
	     * @returns true if the Transition is valid
	     */
	    Transition.prototype.valid = function () {
	        return !this.error() || this.success !== undefined;
	    };
	    /**
	     * Aborts this transition
	     *
	     * Imperative API to abort a Transition.
	     * This only applies to Transitions that are not yet complete.
	     */
	    Transition.prototype.abort = function () {
	        // Do not set flag if the transition is already complete
	        if (predicates_1.isUndefined(this.success)) {
	            this._aborted = true;
	        }
	    };
	    /**
	     * The Transition error reason.
	     *
	     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
	     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
	     *
	     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
	     */
	    Transition.prototype.error = function () {
	        var state = this.$to();
	        if (state.self.abstract) {
	            return rejectFactory_1.Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
	        }
	        var paramDefs = state.parameters();
	        var values = this.params();
	        var invalidParams = paramDefs.filter(function (param) { return !param.validates(values[param.id]); });
	        if (invalidParams.length) {
	            var invalidValues = invalidParams.map(function (param) { return "[" + param.id + ":" + strings_1.stringify(values[param.id]) + "]"; }).join(', ');
	            var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
	            return rejectFactory_1.Rejection.invalid(detail);
	        }
	        if (this.success === false)
	            return this._error;
	    };
	    /**
	     * A string representation of the Transition
	     *
	     * @returns A string representation of the Transition
	     */
	    Transition.prototype.toString = function () {
	        var fromStateOrName = this.from();
	        var toStateOrName = this.to();
	        var avoidEmptyHash = function (params) {
	            return params['#'] !== null && params['#'] !== undefined ? params : common_1.omit(params, ['#']);
	        };
	        // (X) means the to state is invalid.
	        var id = this.$id, from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName, fromParams = strings_1.stringify(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))), toValid = this.valid() ? '' : '(X) ', to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName, toParams = strings_1.stringify(avoidEmptyHash(this.params()));
	        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
	    };
	    /** @hidden */
	    Transition.diToken = Transition;
	    return Transition;
	}());
	exports.Transition = Transition;
	//# sourceMappingURL=transition.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module transition */ /** */
	var interface_1 = __webpack_require__(406);
	var common_1 = __webpack_require__(376);
	var strings_1 = __webpack_require__(382);
	var predicates_1 = __webpack_require__(377);
	var hof_1 = __webpack_require__(378);
	var trace_1 = __webpack_require__(384);
	var coreservices_1 = __webpack_require__(379);
	var rejectFactory_1 = __webpack_require__(383);
	var targetState_1 = __webpack_require__(393);
	var defaultOptions = {
	    current: common_1.noop,
	    transition: null,
	    traceData: {},
	    bind: null,
	};
	/** @hidden */
	var TransitionHook = /** @class */ (function () {
	    function TransitionHook(transition, stateContext, registeredHook, options) {
	        var _this = this;
	        this.transition = transition;
	        this.stateContext = stateContext;
	        this.registeredHook = registeredHook;
	        this.options = options;
	        this.isSuperseded = function () { return _this.type.hookPhase === interface_1.TransitionHookPhase.RUN && !_this.options.transition.isActive(); };
	        this.options = common_1.defaults(options, defaultOptions);
	        this.type = registeredHook.eventType;
	    }
	    /**
	     * Chains together an array of TransitionHooks.
	     *
	     * Given a list of [[TransitionHook]] objects, chains them together.
	     * Each hook is invoked after the previous one completes.
	     *
	     * #### Example:
	     * ```js
	     * var hooks: TransitionHook[] = getHooks();
	     * let promise: Promise<any> = TransitionHook.chain(hooks);
	     *
	     * promise.then(handleSuccess, handleError);
	     * ```
	     *
	     * @param hooks the list of hooks to chain together
	     * @param waitFor if provided, the chain is `.then()`'ed off this promise
	     * @returns a `Promise` for sequentially invoking the hooks (in order)
	     */
	    TransitionHook.chain = function (hooks, waitFor) {
	        // Chain the next hook off the previous
	        var createHookChainR = function (prev, nextHook) { return prev.then(function () { return nextHook.invokeHook(); }); };
	        return hooks.reduce(createHookChainR, waitFor || coreservices_1.services.$q.when());
	    };
	    /**
	     * Invokes all the provided TransitionHooks, in order.
	     * Each hook's return value is checked.
	     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
	     * If no hook returns a promise, then all hooks are processed synchronously.
	     *
	     * @param hooks the list of TransitionHooks to invoke
	     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
	     *
	     * @returns a promise for the async result, or the result of the callback
	     */
	    TransitionHook.invokeHooks = function (hooks, doneCallback) {
	        for (var idx = 0; idx < hooks.length; idx++) {
	            var hookResult = hooks[idx].invokeHook();
	            if (predicates_1.isPromise(hookResult)) {
	                var remainingHooks = hooks.slice(idx + 1);
	                return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
	            }
	        }
	        return doneCallback();
	    };
	    /**
	     * Run all TransitionHooks, ignoring their return value.
	     */
	    TransitionHook.runAllHooks = function (hooks) {
	        hooks.forEach(function (hook) { return hook.invokeHook(); });
	    };
	    TransitionHook.prototype.logError = function (err) {
	        this.transition.router.stateService.defaultErrorHandler()(err);
	    };
	    TransitionHook.prototype.invokeHook = function () {
	        var _this = this;
	        var hook = this.registeredHook;
	        if (hook._deregistered)
	            return;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        var options = this.options;
	        trace_1.trace.traceHookInvocation(this, this.transition, options);
	        var invokeCallback = function () { return hook.callback.call(options.bind, _this.transition, _this.stateContext); };
	        var normalizeErr = function (err) { return rejectFactory_1.Rejection.normalize(err).toPromise(); };
	        var handleError = function (err) { return hook.eventType.getErrorHandler(_this)(err); };
	        var handleResult = function (result) { return hook.eventType.getResultHandler(_this)(result); };
	        try {
	            var result = invokeCallback();
	            if (!this.type.synchronous && predicates_1.isPromise(result)) {
	                return result.catch(normalizeErr).then(handleResult, handleError);
	            }
	            else {
	                return handleResult(result);
	            }
	        }
	        catch (err) {
	            // If callback throws (synchronously)
	            return handleError(rejectFactory_1.Rejection.normalize(err));
	        }
	        finally {
	            if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
	                hook.deregister();
	            }
	        }
	    };
	    /**
	     * This method handles the return value of a Transition Hook.
	     *
	     * A hook can return false (cancel), a TargetState (redirect),
	     * or a promise (which may later resolve to false or a redirect)
	     *
	     * This also handles "transition superseded" -- when a new transition
	     * was started while the hook was still running
	     */
	    TransitionHook.prototype.handleHookResult = function (result) {
	        var _this = this;
	        var notCurrent = this.getNotCurrentRejection();
	        if (notCurrent)
	            return notCurrent;
	        // Hook returned a promise
	        if (predicates_1.isPromise(result)) {
	            // Wait for the promise, then reprocess with the resulting value
	            return result.then(function (val) { return _this.handleHookResult(val); });
	        }
	        trace_1.trace.traceHookResult(result, this.transition, this.options);
	        // Hook returned false
	        if (result === false) {
	            // Abort this Transition
	            return rejectFactory_1.Rejection.aborted('Hook aborted transition').toPromise();
	        }
	        var isTargetState = hof_1.is(targetState_1.TargetState);
	        // hook returned a TargetState
	        if (isTargetState(result)) {
	            // Halt the current Transition and redirect (a new Transition) to the TargetState.
	            return rejectFactory_1.Rejection.redirected(result).toPromise();
	        }
	    };
	    /**
	     * Return a Rejection promise if the transition is no longer current due
	     * to a stopped router (disposed), or a new transition has started and superseded this one.
	     */
	    TransitionHook.prototype.getNotCurrentRejection = function () {
	        var router = this.transition.router;
	        // The router is stopped
	        if (router._disposed) {
	            return rejectFactory_1.Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
	        }
	        if (this.transition._aborted) {
	            return rejectFactory_1.Rejection.aborted().toPromise();
	        }
	        // This transition is no longer current.
	        // Another transition started while this hook was still running.
	        if (this.isSuperseded()) {
	            // Abort this transition
	            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
	        }
	    };
	    TransitionHook.prototype.toString = function () {
	        var _a = this, options = _a.options, registeredHook = _a.registeredHook;
	        var event = hof_1.parse('traceData.hookType')(options) || 'internal', context = hof_1.parse('traceData.context.state.name')(options) || hof_1.parse('traceData.context')(options) || 'unknown', name = strings_1.fnToString(registeredHook.callback);
	        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
	    };
	    /**
	     * These GetResultHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.HANDLE_RESULT = function (hook) { return function (result) {
	        return hook.handleHookResult(result);
	    }; };
	    /**
	     * If the result is a promise rejection, log it.
	     * Otherwise, ignore the result.
	     */
	    TransitionHook.LOG_REJECTED_RESULT = function (hook) { return function (result) {
	        predicates_1.isPromise(result) && result.catch(function (err) { return hook.logError(rejectFactory_1.Rejection.normalize(err)); });
	        return undefined;
	    }; };
	    /**
	     * These GetErrorHandler(s) are used by [[invokeHook]] below
	     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
	     */
	    TransitionHook.LOG_ERROR = function (hook) { return function (error) { return hook.logError(error); }; };
	    TransitionHook.REJECT_ERROR = function (hook) { return function (error) { return common_1.silentRejection(error); }; };
	    TransitionHook.THROW_ERROR = function (hook) { return function (error) {
	        throw error;
	    }; };
	    return TransitionHook;
	}());
	exports.TransitionHook = TransitionHook;
	//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module transition */ /** */
	var common_1 = __webpack_require__(375);
	var interface_1 = __webpack_require__(406);
	/**
	 * Determines if the given state matches the matchCriteria
	 *
	 * @hidden
	 *
	 * @param state a State Object to test against
	 * @param criterion
	 * - If a string, matchState uses the string as a glob-matcher against the state name
	 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
	 *   and returns a positive match if any of the globs match.
	 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
	 * @returns {boolean}
	 */
	function matchState(state, criterion, transition) {
	    var toMatch = common_1.isString(criterion) ? [criterion] : criterion;
	    function matchGlobs(_state) {
	        var globStrings = toMatch;
	        for (var i = 0; i < globStrings.length; i++) {
	            var glob = new common_1.Glob(globStrings[i]);
	            if ((glob && glob.matches(_state.name)) || (!glob && globStrings[i] === _state.name)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var matchFn = (common_1.isFunction(toMatch) ? toMatch : matchGlobs);
	    return !!matchFn(state, transition);
	}
	exports.matchState = matchState;
	/**
	 * @internalapi
	 * The registration data for a registered transition hook
	 */
	var RegisteredHook = /** @class */ (function () {
	    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
	        if (options === void 0) { options = {}; }
	        this.tranSvc = tranSvc;
	        this.eventType = eventType;
	        this.callback = callback;
	        this.matchCriteria = matchCriteria;
	        this.removeHookFromRegistry = removeHookFromRegistry;
	        this.invokeCount = 0;
	        this._deregistered = false;
	        this.priority = options.priority || 0;
	        this.bind = options.bind || null;
	        this.invokeLimit = options.invokeLimit;
	    }
	    /**
	     * Gets the matching [[PathNode]]s
	     *
	     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
	     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
	     *
	     * Returning `null` is significant to distinguish between the default
	     * "match-all criterion value" of `true` compared to a `() => true` function,
	     * when the nodes is an empty array.
	     *
	     * This is useful to allow a transition match criteria of `entering: true`
	     * to still match a transition, even when `entering === []`.  Contrast that
	     * with `entering: (state) => true` which only matches when a state is actually
	     * being entered.
	     */
	    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
	        if (criterion === true)
	            return nodes;
	        var matching = nodes.filter(function (node) { return matchState(node.state, criterion, transition); });
	        return matching.length ? matching : null;
	    };
	    /**
	     * Gets the default match criteria (all `true`)
	     *
	     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
	     *
	     * ```js
	     * {
	     *   to: true,
	     *   from: true,
	     *   entering: true,
	     *   exiting: true,
	     *   retained: true,
	     * }
	     */
	    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
	        return common_1.mapObj(this.tranSvc._pluginapi._getPathTypes(), function () { return true; });
	    };
	    /**
	     * Gets matching nodes as [[IMatchingNodes]]
	     *
	     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
	     *
	     * ```js
	     * let matches: IMatchingNodes = {
	     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
	     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
	     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
	     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
	     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
	     * };
	     * ```
	     */
	    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
	        var _this = this;
	        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
	        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
	        return paths.reduce(function (mn, pathtype) {
	            // STATE scope criteria matches against every node in the path.
	            // TRANSITION scope criteria matches against only the last node in the path
	            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
	            var path = treeChanges[pathtype.name] || [];
	            var nodes = isStateHook ? path : [common_1.tail(path)];
	            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
	            return mn;
	        }, {});
	    };
	    /**
	     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
	     *
	     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
	     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
	     */
	    RegisteredHook.prototype.matches = function (treeChanges, transition) {
	        var matches = this._getMatchingNodes(treeChanges, transition);
	        // Check if all the criteria matched the TreeChanges object
	        var allMatched = common_1.values(matches).every(common_1.identity);
	        return allMatched ? matches : null;
	    };
	    RegisteredHook.prototype.deregister = function () {
	        this.removeHookFromRegistry(this);
	        this._deregistered = true;
	    };
	    return RegisteredHook;
	}());
	exports.RegisteredHook = RegisteredHook;
	/** @hidden Return a registration function of the requested type. */
	function makeEvent(registry, transitionService, eventType) {
	    // Create the object which holds the registered transition hooks.
	    var _registeredHooks = (registry._registeredHooks = registry._registeredHooks || {});
	    var hooks = (_registeredHooks[eventType.name] = []);
	    var removeHookFn = common_1.removeFrom(hooks);
	    // Create hook registration function on the IHookRegistry for the event
	    registry[eventType.name] = hookRegistrationFn;
	    function hookRegistrationFn(matchObject, callback, options) {
	        if (options === void 0) { options = {}; }
	        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
	        hooks.push(registeredHook);
	        return registeredHook.deregister.bind(registeredHook);
	    }
	    return hookRegistrationFn;
	}
	exports.makeEvent = makeEvent;
	//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module transition */ /** */
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var interface_1 = __webpack_require__(406);
	var transitionHook_1 = __webpack_require__(408);
	/**
	 * This class returns applicable TransitionHooks for a specific Transition instance.
	 *
	 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
	 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
	 * determined by the type of hook)
	 *
	 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
	 *
	 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
	 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
	 * in the Transition class, so we must also provide the Transition's _treeChanges)
	 *
	 */
	var HookBuilder = /** @class */ (function () {
	    function HookBuilder(transition) {
	        this.transition = transition;
	    }
	    HookBuilder.prototype.buildHooksForPhase = function (phase) {
	        var _this = this;
	        var $transitions = this.transition.router.transitionService;
	        return $transitions._pluginapi
	            ._getEvents(phase)
	            .map(function (type) { return _this.buildHooks(type); })
	            .reduce(common_1.unnestR, [])
	            .filter(common_1.identity);
	    };
	    /**
	     * Returns an array of newly built TransitionHook objects.
	     *
	     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
	     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
	     * - For each of the [[PathNode]]s, creates a TransitionHook
	     *
	     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
	     */
	    HookBuilder.prototype.buildHooks = function (hookType) {
	        var transition = this.transition;
	        var treeChanges = transition.treeChanges();
	        // Find all the matching registered hooks for a given hook type
	        var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
	        if (!matchingHooks)
	            return [];
	        var baseHookOptions = {
	            transition: transition,
	            current: transition.options().current,
	        };
	        var makeTransitionHooks = function (hook) {
	            // Fetch the Nodes that caused this hook to match.
	            var matches = hook.matches(treeChanges, transition);
	            // Select the PathNode[] that will be used as TransitionHook context objects
	            var matchingNodes = matches[hookType.criteriaMatchPath.name];
	            // Return an array of HookTuples
	            return matchingNodes.map(function (node) {
	                var _options = common_1.extend({
	                    bind: hook.bind,
	                    traceData: { hookType: hookType.name, context: node },
	                }, baseHookOptions);
	                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state.self : null;
	                var transitionHook = new transitionHook_1.TransitionHook(transition, state, hook, _options);
	                return { hook: hook, node: node, transitionHook: transitionHook };
	            });
	        };
	        return matchingHooks
	            .map(makeTransitionHooks)
	            .reduce(common_1.unnestR, [])
	            .sort(tupleSort(hookType.reverseSort))
	            .map(function (tuple) { return tuple.transitionHook; });
	    };
	    /**
	     * Finds all RegisteredHooks from:
	     * - The Transition object instance hook registry
	     * - The TransitionService ($transitions) global hook registry
	     *
	     * which matched:
	     * - the eventType
	     * - the matchCriteria (to, from, exiting, retained, entering)
	     *
	     * @returns an array of matched [[RegisteredHook]]s
	     */
	    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
	        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
	        // Instance and Global hook registries
	        var $transitions = this.transition.router.transitionService;
	        var registries = isCreate ? [$transitions] : [this.transition, $transitions];
	        return registries
	            .map(function (reg) { return reg.getHooks(hookType.name); }) // Get named hooks from registries
	            .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
	            .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
	            .filter(function (hook) { return hook.matches(treeChanges, transition); }); // Only those satisfying matchCriteria
	    };
	    return HookBuilder;
	}());
	exports.HookBuilder = HookBuilder;
	/**
	 * A factory for a sort function for HookTuples.
	 *
	 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
	 * the EventHook priority.
	 *
	 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
	 * @returns a tuple sort function
	 */
	function tupleSort(reverseDepthSort) {
	    if (reverseDepthSort === void 0) { reverseDepthSort = false; }
	    return function nodeDepthThenPriority(l, r) {
	        var factor = reverseDepthSort ? -1 : 1;
	        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
	        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
	    };
	}
	//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module hooks */ /** */
	var transition_1 = __webpack_require__(407);
	var router_1 = __webpack_require__(412);
	var resolve_1 = __webpack_require__(394);
	var common_1 = __webpack_require__(375);
	function addCoreResolvables(trans) {
	    trans.addResolvable(resolve_1.Resolvable.fromData(router_1.UIRouter, trans.router), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData(transition_1.Transition, trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$transition$', trans), '');
	    trans.addResolvable(resolve_1.Resolvable.fromData('$stateParams', trans.params()), '');
	    trans.entering().forEach(function (state) {
	        trans.addResolvable(resolve_1.Resolvable.fromData('$state$', state), state);
	    });
	}
	exports.registerAddCoreResolvables = function (transitionService) {
	    return transitionService.onCreate({}, addCoreResolvables);
	};
	var TRANSITION_TOKENS = ['$transition$', transition_1.Transition];
	var isTransition = common_1.inArray(TRANSITION_TOKENS);
	// References to Transition in the treeChanges pathnodes makes all
	// previous Transitions reachable in memory, causing a memory leak
	// This function removes resolves for '$transition$' and `Transition` from the treeChanges.
	// Do not use this on current transitions, only on old ones.
	exports.treeChangesCleanup = function (trans) {
	    var nodes = common_1.values(trans.treeChanges())
	        .reduce(common_1.unnestR, [])
	        .reduce(common_1.uniqR, []);
	    // If the resolvable is a Transition, return a new resolvable with null data
	    var replaceTransitionWithNull = function (r) {
	        return isTransition(r.token) ? resolve_1.Resolvable.fromData(r.token, null) : r;
	    };
	    nodes.forEach(function (node) {
	        node.resolvables = node.resolvables.map(replaceTransitionWithNull);
	    });
	};
	//# sourceMappingURL=coreResolvables.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module core */ /** */
	var urlMatcherFactory_1 = __webpack_require__(413);
	var urlRouter_1 = __webpack_require__(415);
	var transitionService_1 = __webpack_require__(405);
	var view_1 = __webpack_require__(417);
	var stateRegistry_1 = __webpack_require__(403);
	var stateService_1 = __webpack_require__(404);
	var globals_1 = __webpack_require__(418);
	var common_1 = __webpack_require__(376);
	var predicates_1 = __webpack_require__(377);
	var urlService_1 = __webpack_require__(419);
	var trace_1 = __webpack_require__(384);
	var common_2 = __webpack_require__(375);
	/** @hidden */
	var _routerInstance = 0;
	/** @hidden */
	var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
	/** @hidden */
	var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
	/** @hidden */
	var locationServiceStub = common_2.makeStub('LocationServices', locSvcFns);
	/** @hidden */
	var locationConfigStub = common_2.makeStub('LocationConfig', locCfgFns);
	/**
	 * The master class used to instantiate an instance of UI-Router.
	 *
	 * UI-Router (for each specific framework) will create an instance of this class during bootstrap.
	 * This class instantiates and wires the UI-Router services together.
	 *
	 * After a new instance of the UIRouter class is created, it should be configured for your app.
	 * For instance, app states should be registered with the [[UIRouter.stateRegistry]].
	 *
	 * ---
	 *
	 * Normally the framework code will bootstrap UI-Router.
	 * If you are bootstrapping UIRouter manually, tell it to monitor the URL by calling
	 * [[UrlService.listen]] then [[UrlService.sync]].
	 */
	var UIRouter = /** @class */ (function () {
	    /**
	     * Creates a new `UIRouter` object
	     *
	     * @param locationService a [[LocationServices]] implementation
	     * @param locationConfig a [[LocationConfig]] implementation
	     * @internalapi
	     */
	    function UIRouter(locationService, locationConfig) {
	        if (locationService === void 0) { locationService = locationServiceStub; }
	        if (locationConfig === void 0) { locationConfig = locationConfigStub; }
	        this.locationService = locationService;
	        this.locationConfig = locationConfig;
	        /** @hidden */ this.$id = _routerInstance++;
	        /** @hidden */ this._disposed = false;
	        /** @hidden */ this._disposables = [];
	        /** Provides trace information to the console */
	        this.trace = trace_1.trace;
	        /** Provides services related to ui-view synchronization */
	        this.viewService = new view_1.ViewService(this);
	        /** Global router state */
	        this.globals = new globals_1.UIRouterGlobals();
	        /** Provides services related to Transitions */
	        this.transitionService = new transitionService_1.TransitionService(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory(this);
	        /**
	         * Deprecated for public use. Use [[urlService]] instead.
	         * @deprecated Use [[urlService]] instead
	         */
	        this.urlRouter = new urlRouter_1.UrlRouter(this);
	        /** Provides services related to the URL */
	        this.urlService = new urlService_1.UrlService(this);
	        /** Provides a registry for states, and related registration services */
	        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
	        /** Provides services related to states */
	        this.stateService = new stateService_1.StateService(this);
	        /** @hidden plugin instances are registered here */
	        this._plugins = {};
	        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
	        this.globals.$current = this.stateRegistry.root();
	        this.globals.current = this.globals.$current.self;
	        this.disposable(this.globals);
	        this.disposable(this.stateService);
	        this.disposable(this.stateRegistry);
	        this.disposable(this.transitionService);
	        this.disposable(this.urlService);
	        this.disposable(locationService);
	        this.disposable(locationConfig);
	    }
	    /** Registers an object to be notified when the router is disposed */
	    UIRouter.prototype.disposable = function (disposable) {
	        this._disposables.push(disposable);
	    };
	    /**
	     * Disposes this router instance
	     *
	     * When called, clears resources retained by the router by calling `dispose(this)` on all
	     * registered [[disposable]] objects.
	     *
	     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
	     *
	     * @param disposable (optional) the disposable to dispose
	     */
	    UIRouter.prototype.dispose = function (disposable) {
	        var _this = this;
	        if (disposable && predicates_1.isFunction(disposable.dispose)) {
	            disposable.dispose(this);
	            return undefined;
	        }
	        this._disposed = true;
	        this._disposables.slice().forEach(function (d) {
	            try {
	                typeof d.dispose === 'function' && d.dispose(_this);
	                common_1.removeFrom(_this._disposables, d);
	            }
	            catch (ignored) { }
	        });
	    };
	    /**
	     * Adds a plugin to UI-Router
	     *
	     * This method adds a UI-Router Plugin.
	     * A plugin can enhance or change UI-Router behavior using any public API.
	     *
	     * #### Example:
	     * ```js
	     * import { MyCoolPlugin } from "ui-router-cool-plugin";
	     *
	     * var plugin = router.addPlugin(MyCoolPlugin);
	     * ```
	     *
	     * ### Plugin authoring
	     *
	     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
	     *
	     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
	     * For example, it may configure router options or add a Transition Hook.
	     *
	     * The plugin can then be published as a separate module.
	     *
	     * #### Example:
	     * ```js
	     * export class MyAuthPlugin implements UIRouterPlugin {
	     *   constructor(router: UIRouter, options: any) {
	     *     this.name = "MyAuthPlugin";
	     *     let $transitions = router.transitionService;
	     *     let $state = router.stateService;
	     *
	     *     let authCriteria = {
	     *       to: (state) => state.data && state.data.requiresAuth
	     *     };
	     *
	     *     function authHook(transition: Transition) {
	     *       let authService = transition.injector().get('AuthService');
	     *       if (!authService.isAuthenticated()) {
	     *         return $state.target('login');
	     *       }
	     *     }
	     *
	     *     $transitions.onStart(authCriteria, authHook);
	     *   }
	     * }
	     * ```
	     *
	     * @param plugin one of:
	     *        - a plugin class which implements [[UIRouterPlugin]]
	     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
	     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
	     * @param options options to pass to the plugin class/factory
	     * @returns the registered plugin instance
	     */
	    UIRouter.prototype.plugin = function (plugin, options) {
	        if (options === void 0) { options = {}; }
	        var pluginInstance = new plugin(this, options);
	        if (!pluginInstance.name)
	            throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
	        this._disposables.push(pluginInstance);
	        return (this._plugins[pluginInstance.name] = pluginInstance);
	    };
	    UIRouter.prototype.getPlugin = function (pluginName) {
	        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
	    };
	    return UIRouter;
	}());
	exports.UIRouter = UIRouter;
	//# sourceMappingURL=router.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module url */ /** */
	var common_1 = __webpack_require__(375);
	var urlMatcher_1 = __webpack_require__(414);
	var params_1 = __webpack_require__(385);
	/** @internalapi */
	var ParamFactory = /** @class */ (function () {
	    function ParamFactory(router) {
	        this.router = router;
	    }
	    ParamFactory.prototype.fromConfig = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.CONFIG, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromPath = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.PATH, this.router.urlService.config, state);
	    };
	    ParamFactory.prototype.fromSearch = function (id, type, state) {
	        return new params_1.Param(id, type, params_1.DefType.SEARCH, this.router.urlService.config, state);
	    };
	    return ParamFactory;
	}());
	exports.ParamFactory = ParamFactory;
	/**
	 * Factory for [[UrlMatcher]] instances.
	 *
	 * The factory is available to ng1 services as
	 * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
	 *
	 * @internalapi
	 */
	var UrlMatcherFactory = /** @class */ (function () {
	    // TODO: move implementations to UrlConfig (urlService.config)
	    function UrlMatcherFactory(/** @hidden */ router) {
	        var _this = this;
	        this.router = router;
	        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
	        this.paramFactory = new ParamFactory(this.router);
	        /** @deprecated use [[UrlConfig.caseInsensitive]] */
	        this.caseInsensitive = function (value) { return _this.router.urlService.config.caseInsensitive(value); };
	        /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
	        this.defaultSquashPolicy = function (value) { return _this.router.urlService.config.defaultSquashPolicy(value); };
	        /** @deprecated use [[UrlConfig.strictMode]] */
	        this.strictMode = function (value) { return _this.router.urlService.config.strictMode(value); };
	        /** @deprecated use [[UrlConfig.type]] */
	        this.type = function (name, definition, definitionFn) {
	            return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
	        };
	        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: params_1.Param });
	    }
	    /**
	     * Creates a [[UrlMatcher]] for the specified pattern.
	     *
	     * @param pattern  The URL pattern.
	     * @param config  The config object hash.
	     * @returns The UrlMatcher.
	     */
	    UrlMatcherFactory.prototype.compile = function (pattern, config) {
	        var urlConfig = this.router.urlService.config;
	        // backward-compatible support for config.params -> config.state.params
	        var params = config && !config.state && config.params;
	        config = params ? __assign({ state: { params: params } }, config) : config;
	        var globalConfig = { strict: urlConfig._isStrictMode, caseInsensitive: urlConfig._isCaseInsensitive };
	        return new urlMatcher_1.UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, common_1.extend(globalConfig, config));
	    };
	    /**
	     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
	     *
	     * @param object  The object to perform the type check against.
	     * @returns `true` if the object matches the `UrlMatcher` interface, by
	     *          implementing all the same methods.
	     */
	    UrlMatcherFactory.prototype.isMatcher = function (object) {
	        // TODO: typeof?
	        if (!common_1.isObject(object))
	            return false;
	        var result = true;
	        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
	            if (common_1.isFunction(val))
	                result = result && (common_1.isDefined(object[name]) && common_1.isFunction(object[name]));
	        });
	        return result;
	    };
	    /** @hidden */
	    UrlMatcherFactory.prototype.$get = function () {
	        var urlConfig = this.router.urlService.config;
	        urlConfig.paramTypes.enqueue = false;
	        urlConfig.paramTypes._flushTypeQueue();
	        return this;
	    };
	    return UrlMatcherFactory;
	}());
	exports.UrlMatcherFactory = UrlMatcherFactory;
	//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module url */ /** */
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var predicates_1 = __webpack_require__(377);
	var param_1 = __webpack_require__(386);
	var strings_1 = __webpack_require__(382);
	var common_2 = __webpack_require__(375);
	/** @hidden */
	function quoteRegExp(str, param) {
	    var surroundPattern = ['', ''], result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
	    if (!param)
	        return result;
	    switch (param.squash) {
	        case false:
	            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
	            break;
	        case true:
	            result = result.replace(/\/$/, '');
	            surroundPattern = ['(?:/(', ')|/)?'];
	            break;
	        default:
	            surroundPattern = ["(" + param.squash + "|", ')?'];
	            break;
	    }
	    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
	}
	/** @hidden */
	var memoizeTo = function (obj, _prop, fn) { return (obj[_prop] = obj[_prop] || fn()); };
	/** @hidden */
	var splitOnSlash = strings_1.splitOnDelim('/');
	/** @hidden */
	var defaultConfig = {
	    state: { params: {} },
	    strict: true,
	    caseInsensitive: true,
	};
	/**
	 * Matches URLs against patterns.
	 *
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL.
	 *
	 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
	 * parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by [[UrlMatcher.exec]].
	 *
	 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
	 * or colon placeholders (`/somePath/:param`).
	 *
	 * - *A parameter RegExp* may be defined for a param after a colon
	 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
	 * The regexp must match for the url to be matched.
	 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
	 *
	 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
	 *   See [[UrlMatcherFactory.type]] for more information.
	 *
	 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
	 *   A catch-all * parameter value will contain the remainder of the URL.
	 *
	 * ---
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters).
	 * A path parameter matches any number of characters other than '/'. For catch-all
	 * placeholders the path parameter matches any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 */
	var UrlMatcher = /** @class */ (function () {
	    /**
	     * @param pattern The pattern to compile into a matcher.
	     * @param paramTypes The [[ParamTypes]] registry
	     * @param paramFactory A [[ParamFactory]] object
	     * @param config  A [[UrlMatcherCompileConfig]] configuration object
	     */
	    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
	        var _this = this;
	        /** @hidden */
	        this._cache = { path: [this] };
	        /** @hidden */
	        this._children = [];
	        /** @hidden */
	        this._params = [];
	        /** @hidden */
	        this._segments = [];
	        /** @hidden */
	        this._compiled = [];
	        this.config = config = common_2.defaults(config, defaultConfig);
	        this.pattern = pattern;
	        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	        //   '*' name
	        //   ':' name
	        //   '{' name '}'
	        //   '{' name ':' regexp '}'
	        // The regular expression is somewhat complicated due to the need to allow curly braces
	        // inside the regular expression. The placeholder regexp breaks down as follows:
	        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	        //    [^{}\\]+                       - anything other than curly braces or backslash
	        //    \\.                            - a backslash escape
	        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
	        var patterns = [];
	        var last = 0;
	        var matchArray;
	        var checkParamErrors = function (id) {
	            if (!UrlMatcher.nameValidator.test(id))
	                throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	            if (common_1.find(_this._params, hof_1.propEq('id', id)))
	                throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	        };
	        // Split into static segments separated by path parameter placeholders.
	        // The number of segments is always 1 more than the number of parameters.
	        var matchDetails = function (m, isSearch) {
	            // IE[78] returns '' for unmatched groups instead of null
	            var id = m[2] || m[3];
	            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
	            var makeRegexpType = function (str) {
	                return common_1.inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
	                    pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined),
	                });
	            };
	            return {
	                id: id,
	                regexp: regexp,
	                segment: pattern.substring(last, m.index),
	                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp),
	            };
	        };
	        var details;
	        var segment;
	        // tslint:disable-next-line:no-conditional-assignment
	        while ((matchArray = placeholder.exec(pattern))) {
	            details = matchDetails(matchArray, false);
	            if (details.segment.indexOf('?') >= 0)
	                break; // we're into the search part
	            checkParamErrors(details.id);
	            this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
	            this._segments.push(details.segment);
	            patterns.push([details.segment, common_1.tail(this._params)]);
	            last = placeholder.lastIndex;
	        }
	        segment = pattern.substring(last);
	        // Find any search parameter names and remove them from the last segment
	        var i = segment.indexOf('?');
	        if (i >= 0) {
	            var search = segment.substring(i);
	            segment = segment.substring(0, i);
	            if (search.length > 0) {
	                last = 0;
	                // tslint:disable-next-line:no-conditional-assignment
	                while ((matchArray = searchPlaceholder.exec(search))) {
	                    details = matchDetails(matchArray, true);
	                    checkParamErrors(details.id);
	                    this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
	                    last = placeholder.lastIndex;
	                    // check if ?&
	                }
	            }
	        }
	        this._segments.push(segment);
	        this._compiled = patterns.map(function (_pattern) { return quoteRegExp.apply(null, _pattern); }).concat(quoteRegExp(segment));
	    }
	    /** @hidden */
	    UrlMatcher.encodeDashes = function (str) {
	        // Replace dashes with encoded "\-"
	        return encodeURIComponent(str).replace(/-/g, function (c) {
	            return "%5C%" + c
	                .charCodeAt(0)
	                .toString(16)
	                .toUpperCase();
	        });
	    };
	    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
	    UrlMatcher.pathSegmentsAndParams = function (matcher) {
	        var staticSegments = matcher._segments;
	        var pathParams = matcher._params.filter(function (p) { return p.location === param_1.DefType.PATH; });
	        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined))
	            .reduce(common_1.unnestR, [])
	            .filter(function (x) { return x !== '' && predicates_1.isDefined(x); });
	    };
	    /** @hidden Given a matcher, return an array with the matcher's query params */
	    UrlMatcher.queryParams = function (matcher) {
	        return matcher._params.filter(function (p) { return p.location === param_1.DefType.SEARCH; });
	    };
	    /**
	     * Compare two UrlMatchers
	     *
	     * This comparison function converts a UrlMatcher into static and dynamic path segments.
	     * Each static path segment is a static string between a path separator (slash character).
	     * Each dynamic segment is a path parameter.
	     *
	     * The comparison function sorts static segments before dynamic ones.
	     */
	    UrlMatcher.compare = function (a, b) {
	        /**
	         * Turn a UrlMatcher and all its parent matchers into an array
	         * of slash literals '/', string literals, and Param objects
	         *
	         * This example matcher matches strings like "/foo/:param/tail":
	         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
	         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
	         *
	         * Caches the result as `matcher._cache.segments`
	         */
	        var segments = function (matcher) {
	            return (matcher._cache.segments =
	                matcher._cache.segments ||
	                    matcher._cache.path
	                        .map(UrlMatcher.pathSegmentsAndParams)
	                        .reduce(common_1.unnestR, [])
	                        .reduce(strings_1.joinNeighborsR, [])
	                        .map(function (x) { return (predicates_1.isString(x) ? splitOnSlash(x) : x); })
	                        .reduce(common_1.unnestR, []));
	        };
	        /**
	         * Gets the sort weight for each segment of a UrlMatcher
	         *
	         * Caches the result as `matcher._cache.weights`
	         */
	        var weights = function (matcher) {
	            return (matcher._cache.weights =
	                matcher._cache.weights ||
	                    segments(matcher).map(function (segment) {
	                        // Sort slashes first, then static strings, the Params
	                        if (segment === '/')
	                            return 1;
	                        if (predicates_1.isString(segment))
	                            return 2;
	                        if (segment instanceof param_1.Param)
	                            return 3;
	                    }));
	        };
	        /**
	         * Pads shorter array in-place (mutates)
	         */
	        var padArrays = function (l, r, padVal) {
	            var len = Math.max(l.length, r.length);
	            while (l.length < len)
	                l.push(padVal);
	            while (r.length < len)
	                r.push(padVal);
	        };
	        var weightsA = weights(a), weightsB = weights(b);
	        padArrays(weightsA, weightsB, 0);
	        var _pairs = common_1.arrayTuples(weightsA, weightsB);
	        var cmp, i;
	        for (i = 0; i < _pairs.length; i++) {
	            cmp = _pairs[i][0] - _pairs[i][1];
	            if (cmp !== 0)
	                return cmp;
	        }
	        return 0;
	    };
	    /**
	     * Creates a new concatenated UrlMatcher
	     *
	     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
	     *
	     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
	     */
	    UrlMatcher.prototype.append = function (url) {
	        this._children.push(url);
	        url._cache = {
	            path: this._cache.path.concat(url),
	            parent: this,
	            pattern: null,
	        };
	        return url;
	    };
	    /** @hidden */
	    UrlMatcher.prototype.isRoot = function () {
	        return this._cache.path[0] === this;
	    };
	    /** Returns the input pattern string */
	    UrlMatcher.prototype.toString = function () {
	        return this.pattern;
	    };
	    /**
	     * Tests the specified url/path against this matcher.
	     *
	     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
	     * parameter values.  Returns null if the path does not match.
	     *
	     * The returned object contains the values
	     * of any search parameters that are mentioned in the pattern, but their value may be null if
	     * they are not present in `search`. This means that search parameters are always treated
	     * as optional.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	     *   x: '1', q: 'hello'
	     * });
	     * // returns { id: 'bob', q: 'hello', r: null }
	     * ```
	     *
	     * @param path    The URL path to match, e.g. `$location.path()`.
	     * @param search  URL search parameters, e.g. `$location.search()`.
	     * @param hash    URL hash e.g. `$location.hash()`.
	     * @param options
	     *
	     * @returns The captured parameter values.
	     */
	    UrlMatcher.prototype.exec = function (path, search, hash, options) {
	        var _this = this;
	        if (search === void 0) { search = {}; }
	        if (options === void 0) { options = {}; }
	        var match = memoizeTo(this._cache, 'pattern', function () {
	            return new RegExp([
	                '^',
	                common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''),
	                _this.config.strict === false ? '/?' : '',
	                '$',
	            ].join(''), _this.config.caseInsensitive ? 'i' : undefined);
	        }).exec(path);
	        if (!match)
	            return null;
	        // options = defaults(options, { isolate: false });
	        var allParams = this.parameters(), pathParams = allParams.filter(function (param) { return !param.isSearch(); }), searchParams = allParams.filter(function (param) { return param.isSearch(); }), nPathSegments = this._cache.path.map(function (urlm) { return urlm._segments.length - 1; }).reduce(function (a, x) { return a + x; }), values = {};
	        if (nPathSegments !== match.length - 1)
	            throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
	        function decodePathArray(paramVal) {
	            var reverseString = function (str) {
	                return str
	                    .split('')
	                    .reverse()
	                    .join('');
	            };
	            var unquoteDashes = function (str) { return str.replace(/\\-/g, '-'); };
	            var split = reverseString(paramVal).split(/-(?!\\)/);
	            var allReversed = common_1.map(split, reverseString);
	            return common_1.map(allReversed, unquoteDashes).reverse();
	        }
	        for (var i = 0; i < nPathSegments; i++) {
	            var param = pathParams[i];
	            var value = match[i + 1];
	            // if the param value matches a pre-replace pair, replace the value before decoding.
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (value && param.array === true)
	                value = decodePathArray(value);
	            if (predicates_1.isDefined(value))
	                value = param.type.decode(value);
	            values[param.id] = param.value(value);
	        }
	        searchParams.forEach(function (param) {
	            var value = search[param.id];
	            for (var j = 0; j < param.replace.length; j++) {
	                if (param.replace[j].from === value)
	                    value = param.replace[j].to;
	            }
	            if (predicates_1.isDefined(value))
	                value = param.type.decode(value);
	            values[param.id] = param.value(value);
	        });
	        if (hash)
	            values['#'] = hash;
	        return values;
	    };
	    /**
	     * @hidden
	     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
	     *
	     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
	     *    pattern has no parameters, an empty array is returned.
	     */
	    UrlMatcher.prototype.parameters = function (opts) {
	        if (opts === void 0) { opts = {}; }
	        if (opts.inherit === false)
	            return this._params;
	        return common_1.unnest(this._cache.path.map(function (matcher) { return matcher._params; }));
	    };
	    /**
	     * @hidden
	     * Returns a single parameter from this UrlMatcher by id
	     *
	     * @param id
	     * @param opts
	     * @returns {T|Param|any|boolean|UrlMatcher|null}
	     */
	    UrlMatcher.prototype.parameter = function (id, opts) {
	        var _this = this;
	        if (opts === void 0) { opts = {}; }
	        var findParam = function () {
	            for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
	                var param = _a[_i];
	                if (param.id === id)
	                    return param;
	            }
	        };
	        var parent = this._cache.parent;
	        return findParam() || (opts.inherit !== false && parent && parent.parameter(id, opts)) || null;
	    };
	    /**
	     * Validates the input parameter values against this UrlMatcher
	     *
	     * Checks an object hash of parameters to validate their correctness according to the parameter
	     * types of this `UrlMatcher`.
	     *
	     * @param params The object hash of parameters to validate.
	     * @returns Returns `true` if `params` validates, otherwise `false`.
	     */
	    UrlMatcher.prototype.validates = function (params) {
	        var validParamVal = function (param, val) { return !param || param.validates(val); };
	        params = params || {};
	        // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
	        var paramSchema = this.parameters().filter(function (paramDef) { return params.hasOwnProperty(paramDef.id); });
	        return paramSchema.map(function (paramDef) { return validParamVal(paramDef, params[paramDef.id]); }).reduce(common_1.allTrueR, true);
	    };
	    /**
	     * Given a set of parameter values, creates a URL from this UrlMatcher.
	     *
	     * Creates a URL that matches this pattern by substituting the specified values
	     * for the path and search parameters.
	     *
	     * #### Example:
	     * ```js
	     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	     * // returns '/user/bob?q=yes'
	     * ```
	     *
	     * @param values  the values to substitute for the parameters in this pattern.
	     * @returns the formatted URL (path and optionally search part).
	     */
	    UrlMatcher.prototype.format = function (values) {
	        if (values === void 0) { values = {}; }
	        // Build the full path of UrlMatchers (including all parent UrlMatchers)
	        var urlMatchers = this._cache.path;
	        // Extract all the static segments and Params (processed as ParamDetails)
	        // into an ordered array
	        var pathSegmentsAndParams = urlMatchers
	            .map(UrlMatcher.pathSegmentsAndParams)
	            .reduce(common_1.unnestR, [])
	            .map(function (x) { return (predicates_1.isString(x) ? x : getDetails(x)); });
	        // Extract the query params into a separate array
	        var queryParams = urlMatchers
	            .map(UrlMatcher.queryParams)
	            .reduce(common_1.unnestR, [])
	            .map(getDetails);
	        var isInvalid = function (param) { return param.isValid === false; };
	        if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
	            return null;
	        }
	        /**
	         * Given a Param, applies the parameter value, then returns detailed information about it
	         */
	        function getDetails(param) {
	            // Normalize to typed value
	            var value = param.value(values[param.id]);
	            var isValid = param.validates(value);
	            var isDefaultValue = param.isDefaultValue(value);
	            // Check if we're in squash mode for the parameter
	            var squash = isDefaultValue ? param.squash : false;
	            // Allow the Parameter's Type to encode the value
	            var encoded = param.type.encode(value);
	            return { param: param, value: value, isValid: isValid, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
	        }
	        // Build up the path-portion from the list of static segments and parameters
	        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
	            // The element is a static segment (a raw string); just append it
	            if (predicates_1.isString(x))
	                return acc + x;
	            // Otherwise, it's a ParamDetails.
	            var squash = x.squash, encoded = x.encoded, param = x.param;
	            // If squash is === true, try to remove a slash from the path
	            if (squash === true)
	                return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
	            // If squash is a string, use the string for the param value
	            if (predicates_1.isString(squash))
	                return acc + squash;
	            if (squash !== false)
	                return acc; // ?
	            if (encoded == null)
	                return acc;
	            // If this parameter value is an array, encode the value using encodeDashes
	            if (predicates_1.isArray(encoded))
	                return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join('-');
	            // If the parameter type is "raw", then do not encodeURIComponent
	            if (param.raw)
	                return acc + encoded;
	            // Encode the value
	            return acc + encodeURIComponent(encoded);
	        }, '');
	        // Build the query string by applying parameter values (array or regular)
	        // then mapping to key=value, then flattening and joining using "&"
	        var queryString = queryParams
	            .map(function (paramDetails) {
	            var param = paramDetails.param, squash = paramDetails.squash, encoded = paramDetails.encoded, isDefaultValue = paramDetails.isDefaultValue;
	            if (encoded == null || (isDefaultValue && squash !== false))
	                return;
	            if (!predicates_1.isArray(encoded))
	                encoded = [encoded];
	            if (encoded.length === 0)
	                return;
	            if (!param.raw)
	                encoded = common_1.map(encoded, encodeURIComponent);
	            return encoded.map(function (val) { return param.id + "=" + val; });
	        })
	            .filter(common_1.identity)
	            .reduce(common_1.unnestR, [])
	            .join('&');
	        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
	        return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
	    };
	    /** @hidden */
	    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
	    return UrlMatcher;
	}());
	exports.UrlMatcher = UrlMatcher;
	//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module url */ /** */
	var common_1 = __webpack_require__(375);
	var urlRule_1 = __webpack_require__(416);
	/** @hidden */
	function appendBasePath(url, isHtml5, absolute, baseHref) {
	    if (baseHref === '/')
	        return url;
	    if (isHtml5)
	        return common_1.stripLastPathElement(baseHref) + url;
	    if (absolute)
	        return baseHref.slice(1) + url;
	    return url;
	}
	/**
	 * Updates URL and responds to URL changes
	 *
	 * ### Deprecation warning:
	 * This class is now considered to be an internal API
	 * Use the [[UrlService]] instead.
	 * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
	 *
	 * @internalapi
	 */
	var UrlRouter = /** @class */ (function () {
	    /** @hidden */
	    function UrlRouter(/** @hidden */ router) {
	        var _this = this;
	        this.router = router;
	        // Delegate these calls to [[UrlService]]
	        /** @deprecated use [[UrlService.sync]]*/
	        this.sync = function (evt) { return _this.router.urlService.sync(evt); };
	        /** @deprecated use [[UrlService.listen]]*/
	        this.listen = function (enabled) { return _this.router.urlService.listen(enabled); };
	        /** @deprecated use [[UrlService.deferIntercept]]*/
	        this.deferIntercept = function (defer) { return _this.router.urlService.deferIntercept(defer); };
	        /** @deprecated use [[UrlService.match]]*/
	        this.match = function (urlParts) { return _this.router.urlService.match(urlParts); };
	        // Delegate these calls to [[UrlRules]]
	        /** @deprecated use [[UrlRules.initial]]*/
	        this.initial = function (handler) {
	            return _this.router.urlService.rules.initial(handler);
	        };
	        /** @deprecated use [[UrlRules.otherwise]]*/
	        this.otherwise = function (handler) {
	            return _this.router.urlService.rules.otherwise(handler);
	        };
	        /** @deprecated use [[UrlRules.removeRule]]*/
	        this.removeRule = function (rule) { return _this.router.urlService.rules.removeRule(rule); };
	        /** @deprecated use [[UrlRules.rule]]*/
	        this.rule = function (rule) { return _this.router.urlService.rules.rule(rule); };
	        /** @deprecated use [[UrlRules.rules]]*/
	        this.rules = function () { return _this.router.urlService.rules.rules(); };
	        /** @deprecated use [[UrlRules.sort]]*/
	        this.sort = function (compareFn) { return _this.router.urlService.rules.sort(compareFn); };
	        /** @deprecated use [[UrlRules.when]]*/
	        this.when = function (matcher, handler, options) { return _this.router.urlService.rules.when(matcher, handler, options); };
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /**
	     * Internal API.
	     * @internalapi
	     */
	    UrlRouter.prototype.update = function (read) {
	        var $url = this.router.locationService;
	        if (read) {
	            this.location = $url.url();
	            return;
	        }
	        if ($url.url() === this.location)
	            return;
	        $url.url(this.location, true);
	    };
	    /**
	     * Internal API.
	     *
	     * Pushes a new location to the browser history.
	     *
	     * @internalapi
	     * @param urlMatcher
	     * @param params
	     * @param options
	     */
	    UrlRouter.prototype.push = function (urlMatcher, params, options) {
	        var replace = options && !!options.replace;
	        this.router.urlService.url(urlMatcher.format(params || {}), replace);
	    };
	    /**
	     * Builds and returns a URL with interpolated parameters
	     *
	     * #### Example:
	     * ```js
	     * matcher = $umf.compile("/about/:person");
	     * params = { person: "bob" };
	     * $bob = $urlRouter.href(matcher, params);
	     * // $bob == "/about/bob";
	     * ```
	     *
	     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
	     * @param params An object of parameter values to fill the matcher's required parameters.
	     * @param options Options object. The options are:
	     *
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     *
	     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	     */
	    UrlRouter.prototype.href = function (urlMatcher, params, options) {
	        var url = urlMatcher.format(params);
	        if (url == null)
	            return null;
	        options = options || { absolute: false };
	        var cfg = this.router.urlService.config;
	        var isHtml5 = cfg.html5Mode();
	        if (!isHtml5 && url !== null) {
	            url = '#' + cfg.hashPrefix() + url;
	        }
	        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
	        if (!options.absolute || !url) {
	            return url;
	        }
	        var slash = !isHtml5 && url ? '/' : '';
	        var cfgPort = cfg.port();
	        var port = (cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort);
	        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
	    };
	    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
	        /** @deprecated use [[UrlService.interceptDeferred]]*/
	        get: function () {
	            return this.router.urlService.interceptDeferred;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return UrlRouter;
	}());
	exports.UrlRouter = UrlRouter;
	//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module url */ /** */
	var urlMatcher_1 = __webpack_require__(414);
	var predicates_1 = __webpack_require__(377);
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var stateObject_1 = __webpack_require__(400);
	/**
	 * Creates a [[UrlRule]]
	 *
	 * Creates a [[UrlRule]] from a:
	 *
	 * - `string`
	 * - [[UrlMatcher]]
	 * - `RegExp`
	 * - [[StateObject]]
	 * @internalapi
	 */
	var UrlRuleFactory = /** @class */ (function () {
	    function UrlRuleFactory(router) {
	        this.router = router;
	    }
	    UrlRuleFactory.prototype.compile = function (str) {
	        return this.router.urlMatcherFactory.compile(str);
	    };
	    UrlRuleFactory.prototype.create = function (what, handler) {
	        var _this = this;
	        var isState = stateObject_1.StateObject.isState;
	        var makeRule = hof_1.pattern([
	            [predicates_1.isString, function (_what) { return makeRule(_this.compile(_what)); }],
	            [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) { return _this.fromUrlMatcher(_what, handler); }],
	            [isState, function (_what) { return _this.fromState(_what, _this.router); }],
	            [hof_1.is(RegExp), function (_what) { return _this.fromRegExp(_what, handler); }],
	            [predicates_1.isFunction, function (_what) { return new BaseUrlRule(_what, handler); }],
	        ]);
	        var rule = makeRule(what);
	        if (!rule)
	            throw new Error("invalid 'what' in when()");
	        return rule;
	    };
	    /**
	     * A UrlRule which matches based on a UrlMatcher
	     *
	     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     *
	     * ## Handler as UrlMatcher
	     *
	     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
	     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
	     * The url is replaced with the result.
	     *
	     * #### Example:
	     * ```js
	     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
	     * var handler = $umf.compile("/home/:fooId/:barId");
	     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match); // '/home/123/456'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
	        var _handler = handler;
	        if (predicates_1.isString(handler))
	            handler = this.router.urlMatcherFactory.compile(handler);
	        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler))
	            _handler = function (match) { return handler.format(match); };
	        function matchUrlParamters(url) {
	            var params = urlMatcher.exec(url.path, url.search, url.hash);
	            return urlMatcher.validates(params) && params;
	        }
	        // Prioritize URLs, lowest to highest:
	        // - Some optional URL parameters, but none matched
	        // - No optional parameters in URL
	        // - Some optional parameters, some matched
	        // - Some optional parameters, all matched
	        function matchPriority(params) {
	            var optional = urlMatcher.parameters().filter(function (param) { return param.isOptional; });
	            if (!optional.length)
	                return 0.000001;
	            var matched = optional.filter(function (param) { return params[param.id]; });
	            return matched.length / optional.length;
	        }
	        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: 'URLMATCHER' };
	        return common_1.extend(new BaseUrlRule(matchUrlParamters, _handler), details);
	    };
	    /**
	     * A UrlRule which matches a state by its url
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromState($state.get('foo'), router);
	     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
	     * var result = rule.handler(match);
	     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
	     * ```
	     */
	    UrlRuleFactory.prototype.fromState = function (state, router) {
	        /**
	         * Handles match by transitioning to matched state
	         *
	         * First checks if the router should start a new transition.
	         * A new transition is not required if the current state's URL
	         * and the new URL are already identical
	         */
	        var handler = function (match) {
	            var $state = router.stateService;
	            var globals = router.globals;
	            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
	                $state.transitionTo(state, match, { inherit: true, source: 'url' });
	            }
	        };
	        var details = { state: state, type: 'STATE' };
	        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
	    };
	    /**
	     * A UrlRule which matches based on a regular expression
	     *
	     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
	     *
	     * ## Handler as a function
	     *
	     * If `handler` is a function, the function is invoked with:
	     *
	     * - regexp match array (from `regexp`)
	     * - url: the current Url ([[UrlParts]])
	     * - router: the router object ([[UIRouter]])
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     *
	     * ## Handler as string
	     *
	     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
	     * The string is first interpolated using `string.replace()` style pattern.
	     *
	     * #### Example:
	     * ```js
	     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
	     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
	     * var result = rule.handler(match); // '/home/bar'
	     * ```
	     */
	    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
	        if (regexp.global || regexp.sticky)
	            throw new Error('Rule RegExp must not be global or sticky');
	        /**
	         * If handler is a string, the url will be replaced by the string.
	         * If the string has any String.replace() style variables in it (like `$2`),
	         * they will be replaced by the captures from [[match]]
	         */
	        var redirectUrlTo = function (match) {
	            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
	            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) { return match[what === '$' ? 0 : Number(what)]; });
	        };
	        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
	        var matchParamsFromRegexp = function (url) { return regexp.exec(url.path); };
	        var details = { regexp: regexp, type: 'REGEXP' };
	        return common_1.extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
	    };
	    UrlRuleFactory.isUrlRule = function (obj) { return obj && ['type', 'match', 'handler'].every(function (key) { return predicates_1.isDefined(obj[key]); }); };
	    return UrlRuleFactory;
	}());
	exports.UrlRuleFactory = UrlRuleFactory;
	/**
	 * A base rule which calls `match`
	 *
	 * The value from the `match` function is passed through to the `handler`.
	 * @internalapi
	 */
	var BaseUrlRule = /** @class */ (function () {
	    function BaseUrlRule(match, handler) {
	        var _this = this;
	        this.match = match;
	        this.type = 'RAW';
	        this.matchPriority = function (match) { return 0 - _this.$id; };
	        this.handler = handler || common_1.identity;
	    }
	    return BaseUrlRule;
	}());
	exports.BaseUrlRule = BaseUrlRule;
	//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module view */ /** */
	var common_1 = __webpack_require__(376);
	var hof_1 = __webpack_require__(378);
	var predicates_1 = __webpack_require__(377);
	var trace_1 = __webpack_require__(384);
	/**
	 * The View service
	 *
	 * This service pairs existing `ui-view` components (which live in the DOM)
	 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
	 *
	 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
	 *   The views from exited states are deactivated via [[deactivateViewConfig]].
	 *   (See: the [[registerActivateViews]] Transition Hook)
	 *
	 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
	 *
	 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
	 * are configured with the matching [[ViewConfig]](s)
	 *
	 */
	var ViewService = /** @class */ (function () {
	    /** @hidden */
	    function ViewService(/** @hidden */ router) {
	        var _this = this;
	        this.router = router;
	        /** @hidden */ this._uiViews = [];
	        /** @hidden */ this._viewConfigs = [];
	        /** @hidden */ this._viewConfigFactories = {};
	        /** @hidden */ this._listeners = [];
	        /** @internalapi */
	        this._pluginapi = {
	            _rootViewContext: this._rootViewContext.bind(this),
	            _viewConfigFactory: this._viewConfigFactory.bind(this),
	            _registeredUIView: function (id) { return common_1.find(_this._uiViews, function (view) { return _this.router.$id + "." + view.id === id; }); },
	            _registeredUIViews: function () { return _this._uiViews; },
	            _activeViewConfigs: function () { return _this._viewConfigs; },
	            _onSync: function (listener) {
	                _this._listeners.push(listener);
	                return function () { return common_1.removeFrom(_this._listeners, listener); };
	            },
	        };
	    }
	    /**
	     * Normalizes a view's name from a state.views configuration block.
	     *
	     * This should be used by a framework implementation to calculate the values for
	     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
	     *
	     * @param context the context object (state declaration) that the view belongs to
	     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
	     *
	     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
	     */
	    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
	        if (rawViewName === void 0) { rawViewName = ''; }
	        // TODO: Validate incoming view name with a regexp to allow:
	        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
	        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
	        var viewAtContext = rawViewName.split('@');
	        var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
	        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
	        // Handle relative view-name sugar syntax.
	        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
	        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
	        if (relativeViewNameSugar) {
	            // Clobbers existing contextAnchor (rawViewName validation will fix this)
	            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
	            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
	        }
	        if (uiViewName.charAt(0) === '!') {
	            uiViewName = uiViewName.substr(1);
	            uiViewContextAnchor = ''; // target absolutely from root
	        }
	        // handle parent relative targeting "^.^.^"
	        var relativeMatch = /^(\^(?:\.\^)*)$/;
	        if (relativeMatch.exec(uiViewContextAnchor)) {
	            var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) { return anchor.parent; }, context);
	            uiViewContextAnchor = anchorState.name;
	        }
	        else if (uiViewContextAnchor === '.') {
	            uiViewContextAnchor = context.name;
	        }
	        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
	    };
	    /** @hidden */
	    ViewService.prototype._rootViewContext = function (context) {
	        return (this._rootContext = context || this._rootContext);
	    };
	    /** @hidden */
	    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
	        this._viewConfigFactories[viewType] = factory;
	    };
	    ViewService.prototype.createViewConfig = function (path, decl) {
	        var cfgFactory = this._viewConfigFactories[decl.$type];
	        if (!cfgFactory)
	            throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
	        var cfgs = cfgFactory(path, decl);
	        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
	    };
	    /**
	     * Deactivates a ViewConfig.
	     *
	     * This function deactivates a `ViewConfig`.
	     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
	     *
	     * @param viewConfig The ViewConfig view to deregister.
	     */
	    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('<- Removing', viewConfig);
	        common_1.removeFrom(this._viewConfigs, viewConfig);
	    };
	    ViewService.prototype.activateViewConfig = function (viewConfig) {
	        trace_1.trace.traceViewServiceEvent('-> Registering', viewConfig);
	        this._viewConfigs.push(viewConfig);
	    };
	    ViewService.prototype.sync = function () {
	        var _this = this;
	        var uiViewsByFqn = this._uiViews.map(function (uiv) { return [uiv.fqn, uiv]; }).reduce(common_1.applyPairs, {});
	        // Return a weighted depth value for a uiView.
	        // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
	        // plus the depth of the state that is populating the uiView
	        function uiViewDepth(uiView) {
	            var stateDepth = function (context) { return (context && context.parent ? stateDepth(context.parent) + 1 : 1); };
	            return uiView.fqn.split('.').length * 10000 + stateDepth(uiView.creationContext);
	        }
	        // Return the ViewConfig's context's depth in the context tree.
	        function viewConfigDepth(config) {
	            var context = config.viewDecl.$context, count = 0;
	            while (++count && context.parent)
	                context = context.parent;
	            return count;
	        }
	        // Given a depth function, returns a compare function which can return either ascending or descending order
	        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) { return posNeg * (depthFn(left) - depthFn(right)); });
	        var matchingConfigPair = function (uiView) {
	            var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
	            if (matchingConfigs.length > 1) {
	                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
	                // Sort by depth and return the match from the deepest child
	                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
	                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
	            }
	            return { uiView: uiView, viewConfig: matchingConfigs[0] };
	        };
	        var configureUIView = function (tuple) {
	            // If a parent ui-view is reconfigured, it could destroy child ui-views.
	            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
	            if (_this._uiViews.indexOf(tuple.uiView) !== -1)
	                tuple.uiView.configUpdated(tuple.viewConfig);
	        };
	        // Sort views by FQN and state depth. Process uiviews nearest the root first.
	        var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
	        var matchedViewConfigs = uiViewTuples.map(function (tuple) { return tuple.viewConfig; });
	        var unmatchedConfigTuples = this._viewConfigs
	            .filter(function (config) { return !common_1.inArray(matchedViewConfigs, config); })
	            .map(function (viewConfig) { return ({ uiView: undefined, viewConfig: viewConfig }); });
	        uiViewTuples.forEach(configureUIView);
	        var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
	        this._listeners.forEach(function (cb) { return cb(allTuples); });
	        trace_1.trace.traceViewSync(allTuples);
	    };
	    /**
	     * Registers a `ui-view` component
	     *
	     * When a `ui-view` component is created, it uses this method to register itself.
	     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
	     *
	     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
	     * and what the view's state context is.
	     *
	     * Note: There is no corresponding `deregisterUIView`.
	     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
	     *
	     * @param uiView The metadata for a UIView
	     * @return a de-registration function used when the view is destroyed.
	     */
	    ViewService.prototype.registerUIView = function (uiView) {
	        trace_1.trace.traceViewServiceUIViewEvent('-> Registering', uiView);
	        var uiViews = this._uiViews;
	        var fqnAndTypeMatches = function (uiv) { return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type; };
	        if (uiViews.filter(fqnAndTypeMatches).length)
	            trace_1.trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
	        uiViews.push(uiView);
	        this.sync();
	        return function () {
	            var idx = uiViews.indexOf(uiView);
	            if (idx === -1) {
	                trace_1.trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
	                return;
	            }
	            trace_1.trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
	            common_1.removeFrom(uiViews)(uiView);
	        };
	    };
	    /**
	     * Returns the list of views currently available on the page, by fully-qualified name.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.available = function () {
	        return this._uiViews.map(hof_1.prop('fqn'));
	    };
	    /**
	     * Returns the list of views on the page containing loaded content.
	     *
	     * @return {Array} Returns an array of fully-qualified view names.
	     */
	    ViewService.prototype.active = function () {
	        return this._uiViews.filter(hof_1.prop('$config')).map(hof_1.prop('name'));
	    };
	    /**
	     * Given a ui-view and a ViewConfig, determines if they "match".
	     *
	     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
	     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
	     *
	     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
	     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
	     *
	     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
	     *
	     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
	     * - the ui-view's name matches the ViewConfig's target name
	     * - the ui-view's context matches the ViewConfig's anchor
	     *
	     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
	     * - There exists a parent ui-view where:
	     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
	     *    - the parent ui-view's context matches the ViewConfig's anchor
	     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
	     *
	     * Example:
	     *
	     * DOM:
	     * <ui-view>                        <!-- created in the root context (name: "") -->
	     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
	     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
	     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
	     *       </ui-view>
	     *     </ui-view>
	     *   </ui-view>
	     * </ui-view>
	     *
	     * uiViews: [
	     *  { fqn: "$default",                  creationContext: { name: "" } },
	     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
	     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
	     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
	     * ]
	     *
	     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
	     *
	     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
	     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
	     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
	     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
	     *
	     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
	     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
	     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
	     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
	     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
	     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
	     *   the tail of the ui-view's fqn "default.bar"
	     *
	     * @internalapi
	     */
	    ViewService.matches = function (uiViewsByFqn, uiView) { return function (viewConfig) {
	        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
	        if (uiView.$type !== viewConfig.viewDecl.$type)
	            return false;
	        // Split names apart from both viewConfig and uiView into segments
	        var vc = viewConfig.viewDecl;
	        var vcSegments = vc.$uiViewName.split('.');
	        var uivSegments = uiView.fqn.split('.');
	        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
	        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
	        if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length)))
	            return false;
	        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
	        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
	        var negOffset = 1 - vcSegments.length || undefined;
	        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
	        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
	        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
	    }; };
	    return ViewService;
	}());
	exports.ViewService = ViewService;
	//# sourceMappingURL=view.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @publicapi @module core */ /** */
	var stateParams_1 = __webpack_require__(389);
	var queue_1 = __webpack_require__(381);
	/**
	 * Global router state
	 *
	 * This is where we hold the global mutable state such as current state, current
	 * params, current transition, etc.
	 */
	var UIRouterGlobals = /** @class */ (function () {
	    function UIRouterGlobals() {
	        /**
	         * Current parameter values
	         *
	         * The parameter values from the latest successful transition
	         */
	        this.params = new stateParams_1.StateParams();
	        /** @internalapi */
	        this.lastStartedTransitionId = -1;
	        /** @internalapi */
	        this.transitionHistory = new queue_1.Queue([], 1);
	        /** @internalapi */
	        this.successfulTransitions = new queue_1.Queue([], 1);
	    }
	    UIRouterGlobals.prototype.dispose = function () {
	        this.transitionHistory.clear();
	        this.successfulTransitions.clear();
	        this.transition = null;
	    };
	    return UIRouterGlobals;
	}());
	exports.UIRouterGlobals = UIRouterGlobals;
	//# sourceMappingURL=globals.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(375);
	var urlRules_1 = __webpack_require__(420);
	var urlConfig_1 = __webpack_require__(421);
	var state_1 = __webpack_require__(398);
	/** API for URL management */
	var UrlService = /** @class */ (function () {
	    /** @hidden */
	    function UrlService(/** @hidden */ router) {
	        var _this = this;
	        this.router = router;
	        /** @hidden */ this.interceptDeferred = false;
	        /**
	         * The nested [[UrlRules]] API for managing URL rules and rewrites
	         *
	         * See: [[UrlRules]] for details
	         */
	        this.rules = new urlRules_1.UrlRules(this.router);
	        /**
	         * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
	         *
	         * See: [[UrlConfig]] for details
	         */
	        this.config = new urlConfig_1.UrlConfig(this.router);
	        // Delegate these calls to the current LocationServices implementation
	        /**
	         * Gets the current url, or updates the url
	         *
	         * ### Getting the current URL
	         *
	         * When no arguments are passed, returns the current URL.
	         * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
	         *
	         * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
	         * have a base HREF prepended ([[PushStateLocationServices]]).
	         *
	         * The raw URL in the browser might be:
	         *
	         * ```
	         * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * or
	         *
	         * ```
	         * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
	         * ```
	         *
	         * then this method returns:
	         *
	         * ```
	         * /internal/path/123?param1=foo#anchor
	         * ```
	         *
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url(); // "/some/path?query=value#anchor"
	         * ```
	         *
	         * ### Updating the URL
	         *
	         * When `newurl` arguments is provided, changes the URL to reflect `newurl`
	         *
	         * #### Example:
	         * ```js
	         * locationServices.url("/some/path?query=value#anchor", true);
	         * ```
	         *
	         * @param newurl The new value for the URL.
	         *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
	         *               It should not include the protocol, site, port, or base path of an absolute HREF.
	         * @param replace When true, replaces the current history entry (instead of appending it) with this new url
	         * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
	         *
	         * @return the url (after potentially being processed)
	         */
	        this.url = function (newurl, replace, state) {
	            return _this.router.locationService.url(newurl, replace, state);
	        };
	        /**
	         * Gets the path part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
	         *
	         * @return the path portion of the url
	         */
	        this.path = function () { return _this.router.locationService.path(); };
	        /**
	         * Gets the search part of the current url as an object
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
	         *
	         * @return the search (query) portion of the url, as an object
	         */
	        this.search = function () { return _this.router.locationService.search(); };
	        /**
	         * Gets the hash part of the current url
	         *
	         * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
	         *
	         * @return the hash (anchor) portion of the url
	         */
	        this.hash = function () { return _this.router.locationService.hash(); };
	        /**
	         * @internalapi
	         *
	         * Registers a low level url change handler
	         *
	         * Note: Because this is a low level handler, it's not recommended for general use.
	         *
	         * #### Example:
	         * ```js
	         * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
	         * ```
	         *
	         * @param callback a function that will be called when the url is changing
	         * @return a function that de-registers the callback
	         */
	        this.onChange = function (callback) { return _this.router.locationService.onChange(callback); };
	    }
	    /** @hidden */
	    UrlService.prototype.dispose = function () {
	        this.listen(false);
	        this.rules.dispose();
	    };
	    /**
	     * Gets the current URL parts
	     *
	     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
	     */
	    UrlService.prototype.parts = function () {
	        return { path: this.path(), search: this.search(), hash: this.hash() };
	    };
	    /**
	     * Activates the best rule for the current URL
	     *
	     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
	     * This method is called internally any time the URL has changed.
	     *
	     * This effectively activates the state (or redirect, etc) which matches the current URL.
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   // Find the matching URL and invoke the handler.
	     *   urlService.sync();
	     * });
	     * ```
	     */
	    UrlService.prototype.sync = function (evt) {
	        if (evt && evt.defaultPrevented)
	            return;
	        var _a = this.router, urlService = _a.urlService, stateService = _a.stateService;
	        var url = { path: urlService.path(), search: urlService.search(), hash: urlService.hash() };
	        var best = this.match(url);
	        var applyResult = common_1.pattern([
	            [common_1.isString, function (newurl) { return urlService.url(newurl, true); }],
	            [state_1.TargetState.isDef, function (def) { return stateService.go(def.state, def.params, def.options); }],
	            [common_1.is(state_1.TargetState), function (target) { return stateService.go(target.state(), target.params(), target.options()); }],
	        ]);
	        applyResult(best && best.rule.handler(best.match, url, this.router));
	    };
	    /**
	     * Starts or stops listening for URL changes
	     *
	     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
	     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
	     *
	     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
	     *
	     * #### Example:
	     * ```js
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   // Start responding to URL changes
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param enabled `true` or `false` to start or stop listening to URL changes
	     */
	    UrlService.prototype.listen = function (enabled) {
	        var _this = this;
	        if (enabled === false) {
	            this._stopListeningFn && this._stopListeningFn();
	            delete this._stopListeningFn;
	        }
	        else {
	            return (this._stopListeningFn = this._stopListeningFn || this.router.urlService.onChange(function (evt) { return _this.sync(evt); }));
	        }
	    };
	    /**
	     * Disables monitoring of the URL.
	     *
	     * Call this method before UI-Router has bootstrapped.
	     * It will stop UI-Router from performing the initial url sync.
	     *
	     * This can be useful to perform some asynchronous initialization before the router starts.
	     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	     *
	     * #### Example:
	     * ```js
	     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
	     * urlService.deferIntercept();
	     *
	     * fetch('/states.json').then(resp => resp.json()).then(data => {
	     *   data.forEach(state => $stateRegistry.register(state));
	     *   urlService.listen();
	     *   urlService.sync();
	     * });
	     * ```
	     *
	     * @param defer Indicates whether to defer location change interception.
	     *        Passing no parameter is equivalent to `true`.
	     */
	    UrlService.prototype.deferIntercept = function (defer) {
	        if (defer === undefined)
	            defer = true;
	        this.interceptDeferred = defer;
	    };
	    /**
	     * Matches a URL
	     *
	     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
	     * Return the result as a [[MatchResult]].
	     */
	    UrlService.prototype.match = function (url) {
	        var _this = this;
	        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
	        var rules = this.rules.rules();
	        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
	        var checkRule = function (rule) {
	            var match = rule.match(url, _this.router);
	            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
	        };
	        // The rules are pre-sorted.
	        // - Find the first matching rule.
	        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
	        // - Choose the rule with the highest match weight.
	        var best;
	        for (var i = 0; i < rules.length; i++) {
	            // Stop when there is a 'best' rule and the next rule sorts differently than it.
	            if (best && best.rule._group !== rules[i]._group)
	                break;
	            var current = checkRule(rules[i]);
	            // Pick the best MatchResult
	            best = !best || (current && current.weight > best.weight) ? current : best;
	        }
	        return best;
	    };
	    return UrlService;
	}());
	exports.UrlService = UrlService;
	//# sourceMappingURL=urlService.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var state_1 = __webpack_require__(398);
	var urlMatcher_1 = __webpack_require__(414);
	var common_1 = __webpack_require__(375);
	var urlRule_1 = __webpack_require__(416);
	/** @hidden */
	var prioritySort = function (a, b) { return (b.priority || 0) - (a.priority || 0); };
	/** @hidden */
	var typeSort = function (a, b) {
	    var weights = { STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1 };
	    return (weights[a.type] || 0) - (weights[b.type] || 0);
	};
	/** @hidden */
	var urlMatcherSort = function (a, b) {
	    return !a.urlMatcher || !b.urlMatcher ? 0 : urlMatcher_1.UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
	};
	/** @hidden */
	var idSort = function (a, b) {
	    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
	    var useMatchPriority = { STATE: true, URLMATCHER: true };
	    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
	    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
	};
	/**
	 * Default rule priority sorting function.
	 *
	 * Sorts rules by:
	 *
	 * - Explicit priority (set rule priority using [[UrlRules.when]])
	 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
	 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
	 * - Rule registration order (for rule types other than STATE and URLMATCHER)
	 *   - Equally sorted State and UrlMatcher rules will each match the URL.
	 *     Then, the *best* match is chosen based on how many parameter values were matched.
	 *
	 * @publicapi
	 */
	var defaultRuleSortFn;
	defaultRuleSortFn = function (a, b) {
	    var cmp = prioritySort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = typeSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    cmp = urlMatcherSort(a, b);
	    if (cmp !== 0)
	        return cmp;
	    return idSort(a, b);
	};
	/** @hidden */
	function getHandlerFn(handler) {
	    if (!common_1.isFunction(handler) && !common_1.isString(handler) && !common_1.is(state_1.TargetState)(handler) && !state_1.TargetState.isDef(handler)) {
	        throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
	    }
	    return common_1.isFunction(handler) ? handler : common_1.val(handler);
	}
	/**
	 * API for managing URL rules
	 *
	 * This API is used to create and manage URL rules.
	 * URL rules are a mechanism to respond to specific URL patterns.
	 *
	 * The most commonly used methods are [[otherwise]] and [[when]].
	 *
	 * This API is a property of [[UrlService]] as [[UrlService.rules]]
	 *
	 * @publicapi
	 */
	var UrlRules = /** @class */ (function () {
	    /** @hidden */
	    function UrlRules(/** @hidden */ router) {
	        this.router = router;
	        /** @hidden */ this._sortFn = defaultRuleSortFn;
	        /** @hidden */ this._rules = [];
	        /** @hidden */ this._id = 0;
	        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
	    }
	    /** @hidden */
	    UrlRules.prototype.dispose = function (router) {
	        this._rules = [];
	        delete this._otherwiseFn;
	    };
	    /**
	     * Defines the initial state, path, or behavior to use when the app starts.
	     *
	     * This rule defines the initial/starting state for the application.
	     *
	     * This rule is triggered the first time the URL is checked (when the app initially loads).
	     * The rule is triggered only when the url matches either `""` or `"/"`.
	     *
	     * Note: The rule is intended to be used when the root of the application is directly linked to.
	     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
	     * This allows 404-like behavior when an unknown URL is deep-linked.
	     *
	     * #### Example:
	     * Start app at `home` state.
	     * ```js
	     * .initial({ state: 'home' });
	     * ```
	     *
	     * #### Example:
	     * Start app at `/home` (by url)
	     * ```js
	     * .initial('/home');
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .initial((matchValue, url, router) => {
	     *   console.log('initial state');
	     *   return { state: 'home' };
	     * })
	     * ```
	     *
	     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
	     */
	    UrlRules.prototype.initial = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        var matchFn = function (urlParts, router) {
	            return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
	        };
	        this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
	    };
	    /**
	     * Defines the state, url, or behavior to use when no other rule matches the URL.
	     *
	     * This rule is matched when *no other rule* matches.
	     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
	     *
	     * - If `handler` a string, it is treated as a url redirect
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `/index`
	     * ```js
	     * .otherwise('/index');
	     * ```
	     *
	     * - If `handler` is an object with a `state` property, the state is activated.
	     *
	     * #### Example:
	     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
	     * ```js
	     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
	     * ```
	     *
	     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
	     *   The function can perform actions, and/or return a value.
	     *
	     * #### Example:
	     * When no other url rule matches, manually trigger a transition to the `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   router.stateService.go('home');
	     * });
	     * ```
	     *
	     * #### Example:
	     * When no other url rule matches, go to `home` state
	     * ```js
	     * .otherwise((matchValue, urlParts, router) => {
	     *   return { state: 'home' };
	     * });
	     * ```
	     *
	     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
	     */
	    UrlRules.prototype.otherwise = function (handler) {
	        var handlerFn = getHandlerFn(handler);
	        this._otherwiseFn = this.urlRuleFactory.create(common_1.val(true), handlerFn);
	        this._sorted = false;
	    };
	    /**
	     * Remove a rule previously registered
	     *
	     * @param rule the matcher rule that was previously registered using [[rule]]
	     */
	    UrlRules.prototype.removeRule = function (rule) {
	        common_1.removeFrom(this._rules, rule);
	    };
	    /**
	     * Manually adds a URL Rule.
	     *
	     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
	     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
	     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
	     *
	     * A rule should have a `match` function which returns truthy if the rule matched.
	     * It should also have a `handler` function which is invoked if the rule is the best match.
	     *
	     * @return a function that deregisters the rule
	     */
	    UrlRules.prototype.rule = function (rule) {
	        var _this = this;
	        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule))
	            throw new Error('invalid rule');
	        rule.$id = this._id++;
	        rule.priority = rule.priority || 0;
	        this._rules.push(rule);
	        this._sorted = false;
	        return function () { return _this.removeRule(rule); };
	    };
	    /**
	     * Gets all registered rules
	     *
	     * @returns an array of all the registered rules
	     */
	    UrlRules.prototype.rules = function () {
	        this.ensureSorted();
	        return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
	    };
	    /**
	     * Defines URL Rule priorities
	     *
	     * More than one rule ([[UrlRule]]) might match a given URL.
	     * This `compareFn` is used to sort the rules by priority.
	     * Higher priority rules should sort earlier.
	     *
	     * The [[defaultRuleSortFn]] is used by default.
	     *
	     * You only need to call this function once.
	     * The `compareFn` will be used to sort the rules as each is registered.
	     *
	     * If called without any parameter, it will re-sort the rules.
	     *
	     * ---
	     *
	     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
	     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
	     * The `$id` is is the order in which the rule was registered.
	     *
	     * The sort function should use these data, or data found on a specific type
	     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
	     *
	     * #### Example:
	     * This compare function prioritizes rules by the order in which the rules were registered.
	     * A rule registered earlier has higher priority.
	     *
	     * ```js
	     * function compareFn(a, b) {
	     *   return a.$id - b.$id;
	     * }
	     * ```
	     *
	     * @param compareFn a function that compares to [[UrlRule]] objects.
	     *    The `compareFn` should abide by the `Array.sort` compare function rules.
	     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
	     *    Return a positive number if `b` should be higher priority.
	     *    Return `0` if the rules are identical.
	     *
	     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
	     *    for details.
	     */
	    UrlRules.prototype.sort = function (compareFn) {
	        var sorted = this.stableSort(this._rules, (this._sortFn = compareFn || this._sortFn));
	        // precompute _sortGroup values and apply to each rule
	        var group = 0;
	        for (var i = 0; i < sorted.length; i++) {
	            sorted[i]._group = group;
	            if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
	                group++;
	            }
	        }
	        this._rules = sorted;
	        this._sorted = true;
	    };
	    /** @hidden */
	    UrlRules.prototype.ensureSorted = function () {
	        this._sorted || this.sort();
	    };
	    /** @hidden */
	    UrlRules.prototype.stableSort = function (arr, compareFn) {
	        var arrOfWrapper = arr.map(function (elem, idx) { return ({ elem: elem, idx: idx }); });
	        arrOfWrapper.sort(function (wrapperA, wrapperB) {
	            var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
	            return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
	        });
	        return arrOfWrapper.map(function (wrapper) { return wrapper.elem; });
	    };
	    /**
	     * Registers a `matcher` and `handler` for custom URLs handling.
	     *
	     * The `matcher` can be:
	     *
	     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
	     * - a `string`: The string is compiled to a [[UrlMatcher]]
	     * - a `RegExp`: The regexp is used to match the url.
	     *
	     * The `handler` can be:
	     *
	     * - a string: The url is redirected to the value of the string.
	     * - a function: The url is redirected to the return value of the function.
	     *
	     * ---
	     *
	     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
	     * string is interpolated with parameter values.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when("/foo/:param1", "/bar/:param1")
	     * ```
	     *
	     * ---
	     *
	     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
	     * interpolated with capture groups from the RegExp.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
	     * ```
	     *
	     * ---
	     *
	     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
	     * The "matched value" differs based on the `matcher`.
	     * For [[UrlMatcher]]s, it will be the matched state params.
	     * For `RegExp`, it will be the match array from `regexp.exec()`.
	     *
	     * If the handler returns a string, the URL is redirected to the string.
	     *
	     * #### Example:
	     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
	     * ```js
	     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
	     * ```
	     *
	     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
	     *
	     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
	     * @param handler The path to redirect to, or a function that returns the path.
	     * @param options `{ priority: number }`
	     *
	     * @return the registered [[UrlRule]]
	     */
	    UrlRules.prototype.when = function (matcher, handler, options) {
	        var rule = this.urlRuleFactory.create(matcher, handler);
	        if (common_1.isDefined(options && options.priority))
	            rule.priority = options.priority;
	        this.rule(rule);
	        return rule;
	    };
	    return UrlRules;
	}());
	exports.UrlRules = UrlRules;
	//# sourceMappingURL=urlRules.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var params_1 = __webpack_require__(385);
	var common_1 = __webpack_require__(375);
	/**
	 * An API to customize the URL behavior and retrieve URL configuration
	 *
	 * This API is used to customize the behavior of the URL.
	 * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
	 * and custom parameter encoding (custom [[type]]).
	 *
	 * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
	 * This information can be used to build absolute URLs, such as
	 * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
	 *
	 * This API is a property of [[UrlService]] as [[UrlService.config]].
	 */
	var UrlConfig = /** @class */ (function () {
	    /** @hidden */ function UrlConfig(/** @hidden */ router) {
	        var _this = this;
	        this.router = router;
	        /** @hidden */ this.paramTypes = new params_1.ParamTypes();
	        /** @hidden */ this._isCaseInsensitive = false;
	        /** @hidden */ this._isStrictMode = true;
	        /** @hidden */ this._defaultSquashPolicy = false;
	        /** @internalapi */ this.dispose = function () { return _this.paramTypes.dispose(); };
	        // Delegate these calls to the current LocationConfig implementation
	        /**
	         * Gets the base Href, e.g., `http://localhost/approot/`
	         *
	         * @return the application's base href
	         */
	        this.baseHref = function () { return _this.router.locationConfig.baseHref(); };
	        /**
	         * Gets or sets the hashPrefix
	         *
	         * This only applies when not running in [[html5Mode]] (pushstate mode)
	         *
	         * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
	         *
	         * @return the hash prefix
	         */
	        this.hashPrefix = function (newprefix) { return _this.router.locationConfig.hashPrefix(newprefix); };
	        /**
	         * Gets the host, e.g., `localhost`
	         *
	         * @return the protocol
	         */
	        this.host = function () { return _this.router.locationConfig.host(); };
	        /**
	         * Returns true when running in pushstate mode
	         *
	         * @return true when running in html5 mode (pushstate mode).
	         */
	        this.html5Mode = function () { return _this.router.locationConfig.html5Mode(); };
	        /**
	         * Gets the port, e.g., `80`
	         *
	         * @return the port number
	         */
	        this.port = function () { return _this.router.locationConfig.port(); };
	        /**
	         * Gets the protocol, e.g., `http`
	         *
	         * @return the protocol
	         */
	        this.protocol = function () { return _this.router.locationConfig.protocol(); };
	    }
	    /**
	     * Defines whether URL matching should be case sensitive (the default behavior), or not.
	     *
	     * #### Example:
	     * ```js
	     * // Allow case insensitive url matches
	     * urlService.config.caseInsensitive(true);
	     * ```
	     *
	     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
	     * @returns the current value of caseInsensitive
	     */
	    UrlConfig.prototype.caseInsensitive = function (value) {
	        return (this._isCaseInsensitive = common_1.isDefined(value) ? value : this._isCaseInsensitive);
	    };
	    /**
	     * Sets the default behavior when generating or matching URLs with default parameter values.
	     *
	     * #### Example:
	     * ```js
	     * // Remove default parameter values from the url
	     * urlService.config.defaultSquashPolicy(true);
	     * ```
	     *
	     * @param value A string that defines the default parameter URL squashing behavior.
	     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
	     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	     *      the parameter value from the URL and replace it with this string.
	     * @returns the current value of defaultSquashPolicy
	     */
	    UrlConfig.prototype.defaultSquashPolicy = function (value) {
	        if (common_1.isDefined(value) && value !== true && value !== false && !common_1.isString(value))
	            throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	        return (this._defaultSquashPolicy = common_1.isDefined(value) ? value : this._defaultSquashPolicy);
	    };
	    /**
	     * Defines whether URLs should match trailing slashes, or not (the default behavior).
	     *
	     * #### Example:
	     * ```js
	     * // Allow optional trailing slashes
	     * urlService.config.strictMode(false);
	     * ```
	     *
	     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
	     * @returns the current value of strictMode
	     */
	    UrlConfig.prototype.strictMode = function (value) {
	        return (this._isStrictMode = common_1.isDefined(value) ? value : this._isStrictMode);
	    };
	    /**
	     * Creates and registers a custom [[ParamType]] object
	     *
	     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
	     *
	     * #### Note: Register custom types *before using them* in a state definition.
	     *
	     * #### Example:
	     * ```js
	     * // Encode object parameter as JSON string
	     * urlService.config.type('myjson', {
	     *   encode: (obj) => JSON.stringify(obj),
	     *   decode: (str) => JSON.parse(str),
	     *   is: (val) => typeof(val) === 'object',
	     *   pattern: /[^/]+/,
	     *   equals: (a, b) => _.isEqual(a, b),
	     * });
	     * ```
	     *
	     * See [[ParamTypeDefinition]] for more examples
	     *
	     * @param name The type name.
	     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
	     * @param definitionFn A function that is injected before the app runtime starts.
	     *        The result of this function should be a [[ParamTypeDefinition]].
	     *        The result is merged into the existing `definition`.
	     *        See [[ParamType]] for information on the values accepted.
	     *
	     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
	     */
	    UrlConfig.prototype.type = function (name, definition, definitionFn) {
	        var type = this.paramTypes.type(name, definition, definitionFn);
	        return !common_1.isDefined(definition) ? type : this;
	    };
	    return UrlConfig;
	}());
	exports.UrlConfig = UrlConfig;
	//# sourceMappingURL=urlConfig.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module hooks */ /** */
	var predicates_1 = __webpack_require__(377);
	var coreservices_1 = __webpack_require__(379);
	var targetState_1 = __webpack_require__(393);
	/**
	 * A [[TransitionHookFn]] that redirects to a different state or params
	 *
	 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
	 *
	 * See [[StateDeclaration.redirectTo]]
	 */
	var redirectToHook = function (trans) {
	    var redirect = trans.to().redirectTo;
	    if (!redirect)
	        return;
	    var $state = trans.router.stateService;
	    function handleResult(result) {
	        if (!result)
	            return;
	        if (result instanceof targetState_1.TargetState)
	            return result;
	        if (predicates_1.isString(result))
	            return $state.target(result, trans.params(), trans.options());
	        if (result['state'] || result['params'])
	            return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
	    }
	    if (predicates_1.isFunction(redirect)) {
	        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
	    }
	    return handleResult(redirect);
	};
	exports.registerRedirectToHook = function (transitionService) {
	    return transitionService.onStart({ to: function (state) { return !!state.redirectTo; } }, redirectToHook);
	};
	//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A factory which creates an onEnter, onExit or onRetain transition hook function
	 *
	 * The returned function invokes the (for instance) state.onEnter hook when the
	 * state is being entered.
	 *
	 * @hidden
	 */
	function makeEnterExitRetainHook(hookName) {
	    return function (transition, state) {
	        var _state = state.$$state();
	        var hookFn = _state[hookName];
	        return hookFn(transition, state);
	    };
	}
	/**
	 * The [[TransitionStateHookFn]] for onExit
	 *
	 * When the state is being exited, the state's .onExit function is invoked.
	 *
	 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
	 *
	 * See: [[IHookRegistry.onExit]]
	 */
	var onExitHook = makeEnterExitRetainHook('onExit');
	exports.registerOnExitHook = function (transitionService) {
	    return transitionService.onExit({ exiting: function (state) { return !!state.onExit; } }, onExitHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onRetain
	 *
	 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
	 *
	 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
	 *
	 * See: [[IHookRegistry.onRetain]]
	 */
	var onRetainHook = makeEnterExitRetainHook('onRetain');
	exports.registerOnRetainHook = function (transitionService) {
	    return transitionService.onRetain({ retained: function (state) { return !!state.onRetain; } }, onRetainHook);
	};
	/**
	 * The [[TransitionStateHookFn]] for onEnter
	 *
	 * When the state is being entered, the state's .onEnter function is invoked.
	 *
	 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
	 *
	 * See: [[IHookRegistry.onEnter]]
	 */
	var onEnterHook = makeEnterExitRetainHook('onEnter');
	exports.registerOnEnterHook = function (transitionService) {
	    return transitionService.onEnter({ entering: function (state) { return !!state.onEnter; } }, onEnterHook);
	};
	//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module hooks */ /** */
	var common_1 = __webpack_require__(376);
	var resolveContext_1 = __webpack_require__(397);
	var hof_1 = __webpack_require__(378);
	exports.RESOLVE_HOOK_PRIORITY = 1000;
	/**
	 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
	 *
	 * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var eagerResolvePath = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(common_1.noop);
	};
	exports.registerEagerResolvePath = function (transitionService) {
	    return transitionService.onStart({}, eagerResolvePath, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
	 *
	 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
	 *
	 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var lazyResolveState = function (trans, state) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to)
	        .subContext(state.$$state())
	        .resolvePath('LAZY', trans)
	        .then(common_1.noop);
	};
	exports.registerLazyResolveState = function (transitionService) {
	    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	/**
	 * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
	 *
	 * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
	 *
	 * After all entering states have been entered, this hook resolves any remaining Resolvables.
	 * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
	 *
	 * See [[StateDeclaration.resolve]]
	 */
	var resolveRemaining = function (trans) {
	    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(common_1.noop);
	};
	exports.registerResolveRemaining = function (transitionService) {
	    return transitionService.onFinish({}, resolveRemaining, { priority: exports.RESOLVE_HOOK_PRIORITY });
	};
	//# sourceMappingURL=resolve.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module hooks */ /** */
	var common_1 = __webpack_require__(376);
	var coreservices_1 = __webpack_require__(379);
	/**
	 * A [[TransitionHookFn]] which waits for the views to load
	 *
	 * Registered using `transitionService.onStart({}, loadEnteringViews);`
	 *
	 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
	 * In angular 1, this includes loading the templates.
	 */
	var loadEnteringViews = function (transition) {
	    var $q = coreservices_1.services.$q;
	    var enteringViews = transition.views('entering');
	    if (!enteringViews.length)
	        return;
	    return $q.all(enteringViews.map(function (view) { return $q.when(view.load()); })).then(common_1.noop);
	};
	exports.registerLoadEnteringViews = function (transitionService) {
	    return transitionService.onFinish({}, loadEnteringViews);
	};
	/**
	 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
	 *
	 * Registered using `transitionService.onSuccess({}, activateViews);`
	 *
	 * After a transition is complete, this hook deactivates the old views from the previous state,
	 * and activates the new views from the destination state.
	 *
	 * See [[ViewService]]
	 */
	var activateViews = function (transition) {
	    var enteringViews = transition.views('entering');
	    var exitingViews = transition.views('exiting');
	    if (!enteringViews.length && !exitingViews.length)
	        return;
	    var $view = transition.router.viewService;
	    exitingViews.forEach(function (vc) { return $view.deactivateViewConfig(vc); });
	    enteringViews.forEach(function (vc) { return $view.activateViewConfig(vc); });
	    $view.sync();
	};
	exports.registerActivateViews = function (transitionService) {
	    return transitionService.onSuccess({}, activateViews);
	};
	//# sourceMappingURL=views.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var common_1 = __webpack_require__(376);
	/**
	 * A [[TransitionHookFn]] which updates global UI-Router state
	 *
	 * Registered using `transitionService.onBefore({}, updateGlobalState);`
	 *
	 * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
	 * After a successful [[Transition]], updates the global values of "the current state"
	 * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
	 *
	 * See also the deprecated properties:
	 * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
	 */
	var updateGlobalState = function (trans) {
	    var globals = trans.router.globals;
	    var transitionSuccessful = function () {
	        globals.successfulTransitions.enqueue(trans);
	        globals.$current = trans.$to();
	        globals.current = globals.$current.self;
	        common_1.copy(trans.params(), globals.params);
	    };
	    var clearCurrentTransition = function () {
	        // Do not clear globals.transition if a different transition has started in the meantime
	        if (globals.transition === trans)
	            globals.transition = null;
	    };
	    trans.onSuccess({}, transitionSuccessful, { priority: 10000 });
	    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
	};
	exports.registerUpdateGlobalState = function (transitionService) {
	    return transitionService.onCreate({}, updateGlobalState);
	};
	//# sourceMappingURL=updateGlobals.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A [[TransitionHookFn]] which updates the URL after a successful transition
	 *
	 * Registered using `transitionService.onSuccess({}, updateUrl);`
	 */
	var updateUrl = function (transition) {
	    var options = transition.options();
	    var $state = transition.router.stateService;
	    var $urlRouter = transition.router.urlRouter;
	    // Dont update the url in these situations:
	    // The transition was triggered by a URL sync (options.source === 'url')
	    // The user doesn't want the url to update (options.location === false)
	    // The destination state, and all parents have no navigable url
	    if (options.source !== 'url' && options.location && $state.$current.navigable) {
	        var urlOptions = { replace: options.location === 'replace' };
	        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
	    }
	    $urlRouter.update(true);
	};
	exports.registerUpdateUrl = function (transitionService) {
	    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
	};
	//# sourceMappingURL=url.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var coreservices_1 = __webpack_require__(379);
	/**
	 * A [[TransitionHookFn]] that performs lazy loading
	 *
	 * When entering a state "abc" which has a `lazyLoad` function defined:
	 * - Invoke the `lazyLoad` function (unless it is already in process)
	 *   - Flag the hook function as "in process"
	 *   - The function should return a promise (that resolves when lazy loading is complete)
	 * - Wait for the promise to settle
	 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
	 *   - Flag the hook function as "not in process"
	 * - If the hook was successful
	 *   - Remove the `lazyLoad` function from the state declaration
	 * - If all the hooks were successful
	 *   - Retry the transition (by returning a TargetState)
	 *
	 * ```
	 * .state('abc', {
	 *   component: 'fooComponent',
	 *   lazyLoad: () => System.import('./fooComponent')
	 *   });
	 * ```
	 *
	 * See [[StateDeclaration.lazyLoad]]
	 */
	var lazyLoadHook = function (transition) {
	    var router = transition.router;
	    function retryTransition() {
	        if (transition.originalTransition().options().source !== 'url') {
	            // The original transition was not triggered via url sync
	            // The lazy state should be loaded now, so re-try the original transition
	            var orig = transition.targetState();
	            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
	        }
	        // The original transition was triggered via url sync
	        // Run the URL rules and find the best match
	        var $url = router.urlService;
	        var result = $url.match($url.parts());
	        var rule = result && result.rule;
	        // If the best match is a state, redirect the transition (instead
	        // of calling sync() which supersedes the current transition)
	        if (rule && rule.type === 'STATE') {
	            var state = rule.state;
	            var params = result.match;
	            return router.stateService.target(state, params, transition.options());
	        }
	        // No matching state found, so let .sync() choose the best non-state match/otherwise
	        router.urlService.sync();
	    }
	    var promises = transition
	        .entering()
	        .filter(function (state) { return !!state.$$state().lazyLoad; })
	        .map(function (state) { return lazyLoadState(transition, state); });
	    return coreservices_1.services.$q.all(promises).then(retryTransition);
	};
	exports.registerLazyLoadHook = function (transitionService) {
	    return transitionService.onBefore({ entering: function (state) { return !!state.lazyLoad; } }, lazyLoadHook);
	};
	/**
	 * Invokes a state's lazy load function
	 *
	 * @param transition a Transition context
	 * @param state the state to lazy load
	 * @returns A promise for the lazy load result
	 */
	function lazyLoadState(transition, state) {
	    var lazyLoadFn = state.$$state().lazyLoad;
	    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
	    var promise = lazyLoadFn['_promise'];
	    if (!promise) {
	        var success = function (result) {
	            delete state.lazyLoad;
	            delete state.$$state().lazyLoad;
	            delete lazyLoadFn['_promise'];
	            return result;
	        };
	        var error = function (err) {
	            delete lazyLoadFn['_promise'];
	            return coreservices_1.services.$q.reject(err);
	        };
	        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q
	            .when(lazyLoadFn(transition, state))
	            .then(updateStateRegistry)
	            .then(success, error);
	    }
	    /** Register any lazy loaded state definitions */
	    function updateStateRegistry(result) {
	        if (result && Array.isArray(result.states)) {
	            result.states.forEach(function (_state) { return transition.router.stateRegistry.register(_state); });
	        }
	        return result;
	    }
	    return promise;
	}
	exports.lazyLoadState = lazyLoadState;
	//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var transitionHook_1 = __webpack_require__(408);
	/**
	 * This class defines a type of hook, such as `onBefore` or `onEnter`.
	 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
	 *
	 * @interalapi
	 */
	var TransitionEventType = /** @class */ (function () {
	    /* tslint:disable:no-inferrable-types */
	    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
	        if (reverseSort === void 0) { reverseSort = false; }
	        if (getResultHandler === void 0) { getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT; }
	        if (getErrorHandler === void 0) { getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR; }
	        if (synchronous === void 0) { synchronous = false; }
	        this.name = name;
	        this.hookPhase = hookPhase;
	        this.hookOrder = hookOrder;
	        this.criteriaMatchPath = criteriaMatchPath;
	        this.reverseSort = reverseSort;
	        this.getResultHandler = getResultHandler;
	        this.getErrorHandler = getErrorHandler;
	        this.synchronous = synchronous;
	    }
	    return TransitionEventType;
	}());
	exports.TransitionEventType = TransitionEventType;
	//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/** @internalapi @module hooks */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	var trace_1 = __webpack_require__(384);
	var rejectFactory_1 = __webpack_require__(383);
	/**
	 * A [[TransitionHookFn]] that skips a transition if it should be ignored
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 *
	 * If the transition should be ignored (because no parameter or states changed)
	 * then the transition is ignored and not processed.
	 */
	function ignoredHook(trans) {
	    var ignoredReason = trans._ignoredReason();
	    if (!ignoredReason)
	        return;
	    trace_1.trace.traceTransitionIgnored(trans);
	    var pending = trans.router.globals.transition;
	    // The user clicked a link going back to the *current state* ('A')
	    // However, there is also a pending transition in flight (to 'B')
	    // Abort the transition to 'B' because the user now wants to be back at 'A'.
	    if (ignoredReason === 'SameAsCurrent' && pending) {
	        pending.abort();
	    }
	    return rejectFactory_1.Rejection.ignored().toPromise();
	}
	exports.registerIgnoredTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, ignoredHook, { priority: -9999 });
	};
	//# sourceMappingURL=ignoredTransition.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	"use strict";
	/** @internalapi @module hooks */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * A [[TransitionHookFn]] that rejects the Transition if it is invalid
	 *
	 * This hook is invoked at the end of the onBefore phase.
	 * If the transition is invalid (for example, param values do not validate)
	 * then the transition is rejected.
	 */
	function invalidTransitionHook(trans) {
	    if (!trans.valid()) {
	        throw new Error(trans.error().toString());
	    }
	}
	exports.registerInvalidTransitionHook = function (transitionService) {
	    return transitionService.onBefore({}, invalidTransitionHook, { priority: -10000 });
	};
	//# sourceMappingURL=invalidTransition.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * # Transition subsystem
	 *
	 * This module contains APIs related to a Transition.
	 *
	 * See:
	 * - [[TransitionService]]
	 * - [[Transition]]
	 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
	 *
	 * @preferred @publicapi @module transition
	 */ /** */
	__export(__webpack_require__(406));
	__export(__webpack_require__(410));
	__export(__webpack_require__(409));
	__export(__webpack_require__(383));
	__export(__webpack_require__(407));
	__export(__webpack_require__(408));
	__export(__webpack_require__(429));
	__export(__webpack_require__(405));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(414));
	__export(__webpack_require__(413));
	__export(__webpack_require__(415));
	__export(__webpack_require__(416));
	__export(__webpack_require__(419));
	var urlRules_1 = __webpack_require__(420);
	exports.UrlRules = urlRules_1.UrlRules;
	var urlConfig_1 = __webpack_require__(421);
	exports.UrlConfig = urlConfig_1.UrlConfig;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(417));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	__export(__webpack_require__(436));
	//# sourceMappingURL=vanilla.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(437));
	__export(__webpack_require__(438));
	__export(__webpack_require__(439));
	__export(__webpack_require__(441));
	__export(__webpack_require__(442));
	__export(__webpack_require__(443));
	__export(__webpack_require__(444));
	__export(__webpack_require__(445));
	__export(__webpack_require__(440));
	__export(__webpack_require__(446));
	//# sourceMappingURL=index.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var index_1 = __webpack_require__(375);
	/**
	 * An angular1-like promise api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This API provides native ES6 promise support wrapped as a $q-like API.
	 * Internally, UI-Router uses this $q object to perform promise operations.
	 * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
	 *
	 * $q-like promise api
	 */
	exports.$q = {
	    /** Normalizes a value as a promise */
	    when: function (val) { return new Promise(function (resolve, reject) { return resolve(val); }); },
	    /** Normalizes a value as a promise rejection */
	    reject: function (val) {
	        return new Promise(function (resolve, reject) {
	            reject(val);
	        });
	    },
	    /** @returns a deferred object, which has `resolve` and `reject` functions */
	    defer: function () {
	        var deferred = {};
	        deferred.promise = new Promise(function (resolve, reject) {
	            deferred.resolve = resolve;
	            deferred.reject = reject;
	        });
	        return deferred;
	    },
	    /** Like Promise.all(), but also supports object key/promise notation like $q */
	    all: function (promises) {
	        if (index_1.isArray(promises)) {
	            return Promise.all(promises);
	        }
	        if (index_1.isObject(promises)) {
	            // Convert promises map to promises array.
	            // When each promise resolves, map it to a tuple { key: key, val: val }
	            var chain = Object.keys(promises).map(function (key) { return promises[key].then(function (val) { return ({ key: key, val: val }); }); });
	            // Then wait for all promises to resolve, and convert them back to an object
	            return exports.$q.all(chain).then(function (values) {
	                return values.reduce(function (acc, tuple) {
	                    acc[tuple.key] = tuple.val;
	                    return acc;
	                }, {});
	            });
	        }
	    },
	};
	//# sourceMappingURL=q.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var index_1 = __webpack_require__(375);
	// globally available injectables
	var globals = {};
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
	var ARGUMENT_NAMES = /([^\s,]+)/g;
	/**
	 * A basic angular1-like injector api
	 *
	 * This object implements four methods similar to the
	 * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
	 *
	 * UI-Router evolved from an angular 1 library to a framework agnostic library.
	 * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
	 *
	 * This object provides a naive implementation of a globally scoped dependency injection system.
	 * It supports the following DI approaches:
	 *
	 * ### Function parameter names
	 *
	 * A function's `.toString()` is called, and the parameter names are parsed.
	 * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
	 *
	 * ```js
	 * function injectedFunction(FooService, BarService) {
	 *   // FooService and BarService are injected
	 * }
	 * ```
	 *
	 * ### Function annotation
	 *
	 * A function may be annotated with an array of dependency names as the `$inject` property.
	 *
	 * ```js
	 * injectedFunction.$inject = [ 'FooService', 'BarService' ];
	 * function injectedFunction(fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }
	 * ```
	 *
	 * ### Array notation
	 *
	 * An array provides the names of the dependencies to inject (as strings).
	 * The function is the last element of the array.
	 *
	 * ```js
	 * [ 'FooService', 'BarService', function (fs, bs) {
	 *   // FooService and BarService are injected as fs and bs parameters
	 * }]
	 * ```
	 *
	 * @type {$InjectorLike}
	 */
	exports.$injector = {
	    /** Gets an object from DI based on a string token */
	    get: function (name) { return globals[name]; },
	    /** Returns true if an object named `name` exists in global DI */
	    has: function (name) { return exports.$injector.get(name) != null; },
	    /**
	     * Injects a function
	     *
	     * @param fn the function to inject
	     * @param context the function's `this` binding
	     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
	     */
	    invoke: function (fn, context, locals) {
	        var all = index_1.extend({}, globals, locals || {});
	        var params = exports.$injector.annotate(fn);
	        var ensureExist = index_1.assertPredicate(function (key) { return all.hasOwnProperty(key); }, function (key) { return "DI can't find injectable: '" + key + "'"; });
	        var args = params.filter(ensureExist).map(function (x) { return all[x]; });
	        if (index_1.isFunction(fn))
	            return fn.apply(context, args);
	        else
	            return fn.slice(-1)[0].apply(context, args);
	    },
	    /**
	     * Returns a function's dependencies
	     *
	     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
	     * @return an array of `string`s
	     */
	    annotate: function (fn) {
	        if (!index_1.isInjectable(fn))
	            throw new Error("Not an injectable function: " + fn);
	        if (fn && fn.$inject)
	            return fn.$inject;
	        if (index_1.isArray(fn))
	            return fn.slice(0, -1);
	        var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
	        var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
	        return result || [];
	    },
	};
	//# sourceMappingURL=injector.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var common_1 = __webpack_require__(375);
	var utils_1 = __webpack_require__(440);
	/** A base `LocationServices` */
	var BaseLocationServices = /** @class */ (function () {
	    function BaseLocationServices(router, fireAfterUpdate) {
	        var _this = this;
	        this.fireAfterUpdate = fireAfterUpdate;
	        this._listeners = [];
	        this._listener = function (evt) { return _this._listeners.forEach(function (cb) { return cb(evt); }); };
	        this.hash = function () { return utils_1.parseUrl(_this._get()).hash; };
	        this.path = function () { return utils_1.parseUrl(_this._get()).path; };
	        this.search = function () { return utils_1.getParams(utils_1.parseUrl(_this._get()).search); };
	        this._location = common_1.root.location;
	        this._history = common_1.root.history;
	    }
	    BaseLocationServices.prototype.url = function (url, replace) {
	        if (replace === void 0) { replace = true; }
	        if (common_1.isDefined(url) && url !== this._get()) {
	            this._set(null, null, url, replace);
	            if (this.fireAfterUpdate) {
	                this._listeners.forEach(function (cb) { return cb({ url: url }); });
	            }
	        }
	        return utils_1.buildUrl(this);
	    };
	    BaseLocationServices.prototype.onChange = function (cb) {
	        var _this = this;
	        this._listeners.push(cb);
	        return function () { return common_1.removeFrom(_this._listeners, cb); };
	    };
	    BaseLocationServices.prototype.dispose = function (router) {
	        common_1.deregAll(this._listeners);
	    };
	    return BaseLocationServices;
	}());
	exports.BaseLocationServices = BaseLocationServices;
	//# sourceMappingURL=baseLocationService.js.map

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var common_1 = __webpack_require__(375);
	exports.keyValsToObjectR = function (accum, _a) {
	    var key = _a[0], val = _a[1];
	    if (!accum.hasOwnProperty(key)) {
	        accum[key] = val;
	    }
	    else if (common_1.isArray(accum[key])) {
	        accum[key].push(val);
	    }
	    else {
	        accum[key] = [accum[key], val];
	    }
	    return accum;
	};
	exports.getParams = function (queryString) {
	    return queryString
	        .split('&')
	        .filter(common_1.identity)
	        .map(common_1.splitEqual)
	        .reduce(exports.keyValsToObjectR, {});
	};
	function parseUrl(url) {
	    var orEmptyString = function (x) { return x || ''; };
	    var _a = common_1.splitHash(url).map(orEmptyString), beforehash = _a[0], hash = _a[1];
	    var _b = common_1.splitQuery(beforehash).map(orEmptyString), path = _b[0], search = _b[1];
	    return { path: path, search: search, hash: hash, url: url };
	}
	exports.parseUrl = parseUrl;
	exports.buildUrl = function (loc) {
	    var path = loc.path();
	    var searchObject = loc.search();
	    var hash = loc.hash();
	    var search = Object.keys(searchObject)
	        .map(function (key) {
	        var param = searchObject[key];
	        var vals = common_1.isArray(param) ? param : [param];
	        return vals.map(function (val) { return key + '=' + val; });
	    })
	        .reduce(common_1.unnestR, [])
	        .join('&');
	    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	};
	function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
	    return function (uiRouter) {
	        var service = (uiRouter.locationService = new serviceClass(uiRouter));
	        var configuration = (uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5));
	        function dispose(router) {
	            router.dispose(service);
	            router.dispose(configuration);
	        }
	        return { name: name, service: service, configuration: configuration, dispose: dispose };
	    };
	}
	exports.locationPluginFactory = locationPluginFactory;
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var common_1 = __webpack_require__(375);
	var baseLocationService_1 = __webpack_require__(439);
	/** A `LocationServices` that uses the browser hash "#" to get/set the current location */
	var HashLocationService = /** @class */ (function (_super) {
	    __extends(HashLocationService, _super);
	    function HashLocationService(router) {
	        var _this = _super.call(this, router, false) || this;
	        common_1.root.addEventListener('hashchange', _this._listener, false);
	        return _this;
	    }
	    HashLocationService.prototype._get = function () {
	        return common_1.trimHashVal(this._location.hash);
	    };
	    HashLocationService.prototype._set = function (state, title, url, replace) {
	        this._location.hash = url;
	    };
	    HashLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('hashchange', this._listener);
	    };
	    return HashLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.HashLocationService = HashLocationService;
	//# sourceMappingURL=hashLocationService.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var baseLocationService_1 = __webpack_require__(439);
	/** A `LocationServices` that gets/sets the current location from an in-memory object */
	var MemoryLocationService = /** @class */ (function (_super) {
	    __extends(MemoryLocationService, _super);
	    function MemoryLocationService(router) {
	        return _super.call(this, router, true) || this;
	    }
	    MemoryLocationService.prototype._get = function () {
	        return this._url;
	    };
	    MemoryLocationService.prototype._set = function (state, title, url, replace) {
	        this._url = url;
	    };
	    return MemoryLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.MemoryLocationService = MemoryLocationService;
	//# sourceMappingURL=memoryLocationService.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var baseLocationService_1 = __webpack_require__(439);
	var common_1 = __webpack_require__(375);
	/**
	 * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
	 *
	 * Uses `history.pushState` and `history.replaceState`
	 */
	var PushStateLocationService = /** @class */ (function (_super) {
	    __extends(PushStateLocationService, _super);
	    function PushStateLocationService(router) {
	        var _this = _super.call(this, router, true) || this;
	        _this._config = router.urlService.config;
	        common_1.root.addEventListener('popstate', _this._listener, false);
	        return _this;
	    }
	    /**
	     * Gets the base prefix without:
	     * - trailing slash
	     * - trailing filename
	     * - protocol and hostname
	     *
	     * If <base href='/base/'>, this returns '/base'.
	     * If <base href='/foo/base/'>, this returns '/foo/base'.
	     * If <base href='/base/index.html'>, this returns '/base'.
	     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
	     * If <base href='/base'>, this returns ''.
	     * If <base href='http://localhost:8080'>, this returns ''.
	     * If <base href='http://localhost:8080/'>, this returns ''.
	     *
	     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
	     */
	    PushStateLocationService.prototype._getBasePrefix = function () {
	        return common_1.stripLastPathElement(this._config.baseHref());
	    };
	    PushStateLocationService.prototype._get = function () {
	        var _a = this._location, pathname = _a.pathname, hash = _a.hash, search = _a.search;
	        search = common_1.splitQuery(search)[1]; // strip ? if found
	        hash = common_1.splitHash(hash)[1]; // strip # if found
	        var basePrefix = this._getBasePrefix();
	        var exactBaseHrefMatch = pathname === this._config.baseHref();
	        var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
	        pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
	        return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
	    };
	    PushStateLocationService.prototype._set = function (state, title, url, replace) {
	        var basePrefix = this._getBasePrefix();
	        var slash = url && url[0] !== '/' ? '/' : '';
	        var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
	        if (replace) {
	            this._history.replaceState(state, title, fullUrl);
	        }
	        else {
	            this._history.pushState(state, title, fullUrl);
	        }
	    };
	    PushStateLocationService.prototype.dispose = function (router) {
	        _super.prototype.dispose.call(this, router);
	        common_1.root.removeEventListener('popstate', this._listener);
	    };
	    return PushStateLocationService;
	}(baseLocationService_1.BaseLocationServices));
	exports.PushStateLocationService = PushStateLocationService;
	//# sourceMappingURL=pushStateLocationService.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var predicates_1 = __webpack_require__(377);
	var common_1 = __webpack_require__(376);
	/** A `LocationConfig` mock that gets/sets all config from an in-memory object */
	var MemoryLocationConfig = /** @class */ (function () {
	    function MemoryLocationConfig() {
	        var _this = this;
	        this.dispose = common_1.noop;
	        this._baseHref = '';
	        this._port = 80;
	        this._protocol = 'http';
	        this._host = 'localhost';
	        this._hashPrefix = '';
	        this.port = function () { return _this._port; };
	        this.protocol = function () { return _this._protocol; };
	        this.host = function () { return _this._host; };
	        this.baseHref = function () { return _this._baseHref; };
	        this.html5Mode = function () { return false; };
	        this.hashPrefix = function (newval) { return (predicates_1.isDefined(newval) ? (_this._hashPrefix = newval) : _this._hashPrefix); };
	    }
	    return MemoryLocationConfig;
	}());
	exports.MemoryLocationConfig = MemoryLocationConfig;
	//# sourceMappingURL=memoryLocationConfig.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */
	/** */
	var predicates_1 = __webpack_require__(377);
	/** A `LocationConfig` that delegates to the browser's `location` object */
	var BrowserLocationConfig = /** @class */ (function () {
	    function BrowserLocationConfig(router, _isHtml5) {
	        if (_isHtml5 === void 0) { _isHtml5 = false; }
	        this._isHtml5 = _isHtml5;
	        this._baseHref = undefined;
	        this._hashPrefix = '';
	    }
	    BrowserLocationConfig.prototype.port = function () {
	        if (location.port) {
	            return Number(location.port);
	        }
	        return this.protocol() === 'https' ? 443 : 80;
	    };
	    BrowserLocationConfig.prototype.protocol = function () {
	        return location.protocol.replace(/:/g, '');
	    };
	    BrowserLocationConfig.prototype.host = function () {
	        return location.hostname;
	    };
	    BrowserLocationConfig.prototype.html5Mode = function () {
	        return this._isHtml5;
	    };
	    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
	        return predicates_1.isDefined(newprefix) ? (this._hashPrefix = newprefix) : this._hashPrefix;
	    };
	    BrowserLocationConfig.prototype.baseHref = function (href) {
	        if (predicates_1.isDefined(href))
	            this._baseHref = href;
	        if (predicates_1.isUndefined(this._baseHref))
	            this._baseHref = this.getBaseHref();
	        return this._baseHref;
	    };
	    BrowserLocationConfig.prototype.getBaseHref = function () {
	        var baseTag = document.getElementsByTagName('base')[0];
	        if (baseTag && baseTag.href) {
	            return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
	        }
	        return this._isHtml5 ? '/' : location.pathname || '/';
	    };
	    BrowserLocationConfig.prototype.dispose = function () { };
	    return BrowserLocationConfig;
	}());
	exports.BrowserLocationConfig = BrowserLocationConfig;
	//# sourceMappingURL=browserLocationConfig.js.map

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi @module vanilla */ /** */
	var browserLocationConfig_1 = __webpack_require__(445);
	var hashLocationService_1 = __webpack_require__(441);
	var utils_1 = __webpack_require__(440);
	var pushStateLocationService_1 = __webpack_require__(443);
	var memoryLocationService_1 = __webpack_require__(442);
	var memoryLocationConfig_1 = __webpack_require__(444);
	var injector_1 = __webpack_require__(438);
	var q_1 = __webpack_require__(437);
	var coreservices_1 = __webpack_require__(379);
	function servicesPlugin(router) {
	    coreservices_1.services.$injector = injector_1.$injector;
	    coreservices_1.services.$q = q_1.$q;
	    return { name: 'vanilla.services', $q: q_1.$q, $injector: injector_1.$injector, dispose: function () { return null; } };
	}
	exports.servicesPlugin = servicesPlugin;
	/** A `UIRouterPlugin` uses the browser hash to get/set the current location */
	exports.hashLocationPlugin = utils_1.locationPluginFactory('vanilla.hashBangLocation', false, hashLocationService_1.HashLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
	exports.pushStateLocationPlugin = utils_1.locationPluginFactory('vanilla.pushStateLocation', true, pushStateLocationService_1.PushStateLocationService, browserLocationConfig_1.BrowserLocationConfig);
	/** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
	exports.memoryLocationPlugin = utils_1.locationPluginFactory('vanilla.memoryLocation', false, memoryLocationService_1.MemoryLocationService, memoryLocationConfig_1.MemoryLocationConfig);
	//# sourceMappingURL=plugins.js.map

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * # Core classes and interfaces
	 *
	 * The classes and interfaces that are core to ui-router and do not belong
	 * to a more specific subsystem (such as resolve).
	 *
	 * @preferred @publicapi @module core
	 */ /** */
	Object.defineProperty(exports, "__esModule", { value: true });
	/** @internalapi */
	var UIRouterPluginBase = /** @class */ (function () {
	    function UIRouterPluginBase() {
	    }
	    UIRouterPluginBase.prototype.dispose = function (router) { };
	    return UIRouterPluginBase;
	}());
	exports.UIRouterPluginBase = UIRouterPluginBase;
	//# sourceMappingURL=interface.js.map

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(449);
	
	module.exports = 'ui.bootstrap';


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/*
	 * angular-ui-bootstrap
	 * http://angular-ui.github.io/bootstrap/
	
	 * Version: 2.5.6 - 2017-10-14
	 * License: MIT
	 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
	angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
	angular.module('ui.bootstrap.collapse', [])
	
	  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
	    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
	    return {
	      link: function(scope, element, attrs) {
	        var expandingExpr = $parse(attrs.expanding),
	          expandedExpr = $parse(attrs.expanded),
	          collapsingExpr = $parse(attrs.collapsing),
	          collapsedExpr = $parse(attrs.collapsed),
	          horizontal = false,
	          css = {},
	          cssTo = {};
	
	        init();
	
	        function init() {
	          horizontal = !!('horizontal' in attrs);
	          if (horizontal) {
	            css = {
	              width: ''
	            };
	            cssTo = {width: '0'};
	          } else {
	            css = {
	              height: ''
	            };
	            cssTo = {height: '0'};
	          }
	          if (!scope.$eval(attrs.uibCollapse)) {
	            element.addClass('in')
	              .addClass('collapse')
	              .attr('aria-expanded', true)
	              .attr('aria-hidden', false)
	              .css(css);
	          }
	        }
	
	        function getScrollFromElement(element) {
	          if (horizontal) {
	            return {width: element.scrollWidth + 'px'};
	          }
	          return {height: element.scrollHeight + 'px'};
	        }
	
	        function expand() {
	          if (element.hasClass('collapse') && element.hasClass('in')) {
	            return;
	          }
	
	          $q.resolve(expandingExpr(scope))
	            .then(function() {
	              element.removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', true)
	                .attr('aria-hidden', false);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  addClass: 'in',
	                  easing: 'ease',
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).start()['finally'](expandDone);
	              } else {
	                $animate.addClass(element, 'in', {
	                  css: {
	                    overflow: 'hidden'
	                  },
	                  to: getScrollFromElement(element[0])
	                }).then(expandDone);
	              }
	            }, angular.noop);
	        }
	
	        function expandDone() {
	          element.removeClass('collapsing')
	            .addClass('collapse')
	            .css(css);
	          expandedExpr(scope);
	        }
	
	        function collapse() {
	          if (!element.hasClass('collapse') && !element.hasClass('in')) {
	            return collapseDone();
	          }
	
	          $q.resolve(collapsingExpr(scope))
	            .then(function() {
	              element
	              // IMPORTANT: The width must be set before adding "collapsing" class.
	              // Otherwise, the browser attempts to animate from width 0 (in
	              // collapsing class) to the given width here.
	                .css(getScrollFromElement(element[0]))
	                // initially all panel collapse have the collapse class, this removal
	                // prevents the animation from jumping to collapsed state
	                .removeClass('collapse')
	                .addClass('collapsing')
	                .attr('aria-expanded', false)
	                .attr('aria-hidden', true);
	
	              if ($animateCss) {
	                $animateCss(element, {
	                  removeClass: 'in',
	                  to: cssTo
	                }).start()['finally'](collapseDone);
	              } else {
	                $animate.removeClass(element, 'in', {
	                  to: cssTo
	                }).then(collapseDone);
	              }
	            }, angular.noop);
	        }
	
	        function collapseDone() {
	          element.css(cssTo); // Required so that collapse works when animation is disabled
	          element.removeClass('collapsing')
	            .addClass('collapse');
	          collapsedExpr(scope);
	        }
	
	        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
	          if (shouldCollapse) {
	            collapse();
	          } else {
	            expand();
	          }
	        });
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.tabindex', [])
	
	.directive('uibTabindexToggle', function() {
	  return {
	    restrict: 'A',
	    link: function(scope, elem, attrs) {
	      attrs.$observe('disabled', function(disabled) {
	        attrs.$set('tabindex', disabled ? -1 : null);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])
	
	.constant('uibAccordionConfig', {
	  closeOthers: true
	})
	
	.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
	  // This array keeps track of the accordion groups
	  this.groups = [];
	
	  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
	  this.closeOthers = function(openGroup) {
	    var closeOthers = angular.isDefined($attrs.closeOthers) ?
	      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
	    if (closeOthers) {
	      angular.forEach(this.groups, function(group) {
	        if (group !== openGroup) {
	          group.isOpen = false;
	        }
	      });
	    }
	  };
	
	  // This is called from the accordion-group directive to add itself to the accordion
	  this.addGroup = function(groupScope) {
	    var that = this;
	    this.groups.push(groupScope);
	
	    groupScope.$on('$destroy', function(event) {
	      that.removeGroup(groupScope);
	    });
	  };
	
	  // This is called from the accordion-group directive when to remove itself
	  this.removeGroup = function(group) {
	    var index = this.groups.indexOf(group);
	    if (index !== -1) {
	      this.groups.splice(index, 1);
	    }
	  };
	}])
	
	// The accordion directive simply sets up the directive controller
	// and adds an accordion CSS class to itself element.
	.directive('uibAccordion', function() {
	  return {
	    controller: 'UibAccordionController',
	    controllerAs: 'accordion',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
	    }
	  };
	})
	
	// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
	.directive('uibAccordionGroup', function() {
	  return {
	    require: '^uibAccordion',         // We need this directive to be inside an accordion
	    transclude: true,              // It transcludes the contents of the directive into the template
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
	    },
	    scope: {
	      heading: '@',               // Interpolate the heading attribute onto this scope
	      panelClass: '@?',           // Ditto with panelClass
	      isOpen: '=?',
	      isDisabled: '=?'
	    },
	    controller: function() {
	      this.setHeading = function(element) {
	        this.heading = element;
	      };
	    },
	    link: function(scope, element, attrs, accordionCtrl) {
	      element.addClass('panel');
	      accordionCtrl.addGroup(scope);
	
	      scope.openClass = attrs.openClass || 'panel-open';
	      scope.panelClass = attrs.panelClass || 'panel-default';
	      scope.$watch('isOpen', function(value) {
	        element.toggleClass(scope.openClass, !!value);
	        if (value) {
	          accordionCtrl.closeOthers(scope);
	        }
	      });
	
	      scope.toggleOpen = function($event) {
	        if (!scope.isDisabled) {
	          if (!$event || $event.which === 32) {
	            scope.isOpen = !scope.isOpen;
	          }
	        }
	      };
	
	      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	      scope.headingId = id + '-tab';
	      scope.panelId = id + '-panel';
	    }
	  };
	})
	
	// Use accordion-heading below an accordion-group to provide a heading containing HTML
	.directive('uibAccordionHeading', function() {
	  return {
	    transclude: true,   // Grab the contents to be used as the heading
	    template: '',       // In effect remove this element!
	    replace: true,
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
	      // Pass the heading to the accordion-group controller
	      // so that it can be transcluded into the right place in the template
	      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
	      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
	    }
	  };
	})
	
	// Use in the accordion-group template to indicate where you want the heading to be transcluded
	// You must provide the property on the accordion-group controller that will hold the transcluded element
	.directive('uibAccordionTransclude', function() {
	  return {
	    require: '^uibAccordionGroup',
	    link: function(scope, element, attrs, controller) {
	      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
	        if (heading) {
	          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
	          elem.html('');
	          elem.append(heading);
	        }
	      });
	    }
	  };
	
	  function getHeaderSelectors() {
	      return 'uib-accordion-header,' +
	          'data-uib-accordion-header,' +
	          'x-uib-accordion-header,' +
	          'uib\\:accordion-header,' +
	          '[uib-accordion-header],' +
	          '[data-uib-accordion-header],' +
	          '[x-uib-accordion-header]';
	  }
	});
	
	angular.module('ui.bootstrap.alert', [])
	
	.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
	  $scope.closeable = !!$attrs.close;
	  $element.addClass('alert');
	  $attrs.$set('role', 'alert');
	  if ($scope.closeable) {
	    $element.addClass('alert-dismissible');
	  }
	
	  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
	    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
	
	  if (dismissOnTimeout) {
	    $timeout(function() {
	      $scope.close();
	    }, parseInt(dismissOnTimeout, 10));
	  }
	}])
	
	.directive('uibAlert', function() {
	  return {
	    controller: 'UibAlertController',
	    controllerAs: 'alert',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/alert/alert.html';
	    },
	    transclude: true,
	    scope: {
	      close: '&'
	    }
	  };
	});
	
	angular.module('ui.bootstrap.buttons', [])
	
	.constant('uibButtonConfig', {
	  activeClass: 'active',
	  toggleEvent: 'click'
	})
	
	.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
	  this.activeClass = buttonConfig.activeClass || 'active';
	  this.toggleEvent = buttonConfig.toggleEvent || 'click';
	}])
	
	.directive('uibBtnRadio', ['$parse', function($parse) {
	  return {
	    require: ['uibBtnRadio', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'buttons',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      var uncheckableExpr = $parse(attrs.uibUncheckable);
	
	      element.find('input').css({display: 'none'});
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        var isActive = element.hasClass(buttonsCtrl.activeClass);
	
	        if (!isActive || angular.isDefined(attrs.uncheckable)) {
	          scope.$apply(function() {
	            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
	            ngModelCtrl.$render();
	          });
	        }
	      });
	
	      if (attrs.uibUncheckable) {
	        scope.$watch(uncheckableExpr, function(uncheckable) {
	          attrs.$set('uncheckable', uncheckable ? '' : undefined);
	        });
	      }
	    }
	  };
	}])
	
	.directive('uibBtnCheckbox', function() {
	  return {
	    require: ['uibBtnCheckbox', 'ngModel'],
	    controller: 'UibButtonsController',
	    controllerAs: 'button',
	    link: function(scope, element, attrs, ctrls) {
	      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      element.find('input').css({display: 'none'});
	
	      function getTrueValue() {
	        return getCheckboxValue(attrs.btnCheckboxTrue, true);
	      }
	
	      function getFalseValue() {
	        return getCheckboxValue(attrs.btnCheckboxFalse, false);
	      }
	
	      function getCheckboxValue(attribute, defaultValue) {
	        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
	      }
	
	      //model -> UI
	      ngModelCtrl.$render = function() {
	        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
	      };
	
	      //ui->model
	      element.on(buttonsCtrl.toggleEvent, function() {
	        if (attrs.disabled) {
	          return;
	        }
	
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
	          ngModelCtrl.$render();
	        });
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.carousel', [])
	
	.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
	  var self = this,
	    slides = self.slides = $scope.slides = [],
	    SLIDE_DIRECTION = 'uib-slideDirection',
	    currentIndex = $scope.active,
	    currentInterval, isPlaying;
	
	  var destroyed = false;
	  $element.addClass('carousel');
	
	  self.addSlide = function(slide, element) {
	    slides.push({
	      slide: slide,
	      element: element
	    });
	    slides.sort(function(a, b) {
	      return +a.slide.index - +b.slide.index;
	    });
	    //if this is the first slide or the slide is set to active, select it
	    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
	      if ($scope.$currentTransition) {
	        $scope.$currentTransition = null;
	      }
	
	      currentIndex = slide.index;
	      $scope.active = slide.index;
	      setActive(currentIndex);
	      self.select(slides[findSlideIndex(slide)]);
	      if (slides.length === 1) {
	        $scope.play();
	      }
	    }
	  };
	
	  self.getCurrentIndex = function() {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide.index === currentIndex) {
	        return i;
	      }
	    }
	  };
	
	  self.next = $scope.next = function() {
	    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
	
	    if (newIndex === 0 && $scope.noWrap()) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'next');
	  };
	
	  self.prev = $scope.prev = function() {
	    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
	
	    if ($scope.noWrap() && newIndex === slides.length - 1) {
	      $scope.pause();
	      return;
	    }
	
	    return self.select(slides[newIndex], 'prev');
	  };
	
	  self.removeSlide = function(slide) {
	    var index = findSlideIndex(slide);
	
	    //get the index of the slide inside the carousel
	    slides.splice(index, 1);
	    if (slides.length > 0 && currentIndex === index) {
	      if (index >= slides.length) {
	        currentIndex = slides.length - 1;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[slides.length - 1]);
	      } else {
	        currentIndex = index;
	        $scope.active = currentIndex;
	        setActive(currentIndex);
	        self.select(slides[index]);
	      }
	    } else if (currentIndex > index) {
	      currentIndex--;
	      $scope.active = currentIndex;
	    }
	
	    //clean the active value when no more slide
	    if (slides.length === 0) {
	      currentIndex = null;
	      $scope.active = null;
	    }
	  };
	
	  /* direction: "prev" or "next" */
	  self.select = $scope.select = function(nextSlide, direction) {
	    var nextIndex = findSlideIndex(nextSlide.slide);
	    //Decide direction if it's not given
	    if (direction === undefined) {
	      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
	    }
	    //Prevent this user-triggered transition from occurring if there is already one in progress
	    if (nextSlide.slide.index !== currentIndex &&
	      !$scope.$currentTransition) {
	      goNext(nextSlide.slide, nextIndex, direction);
	    }
	  };
	
	  /* Allow outside people to call indexOf on slides array */
	  $scope.indexOfSlide = function(slide) {
	    return +slide.slide.index;
	  };
	
	  $scope.isActive = function(slide) {
	    return $scope.active === slide.slide.index;
	  };
	
	  $scope.isPrevDisabled = function() {
	    return $scope.active === 0 && $scope.noWrap();
	  };
	
	  $scope.isNextDisabled = function() {
	    return $scope.active === slides.length - 1 && $scope.noWrap();
	  };
	
	  $scope.pause = function() {
	    if (!$scope.noPause) {
	      isPlaying = false;
	      resetTimer();
	    }
	  };
	
	  $scope.play = function() {
	    if (!isPlaying) {
	      isPlaying = true;
	      restartTimer();
	    }
	  };
	
	  $element.on('mouseenter', $scope.pause);
	  $element.on('mouseleave', $scope.play);
	
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	    resetTimer();
	  });
	
	  $scope.$watch('noTransition', function(noTransition) {
	    $animate.enabled($element, !noTransition);
	  });
	
	  $scope.$watch('interval', restartTimer);
	
	  $scope.$watchCollection('slides', resetTransition);
	
	  $scope.$watch('active', function(index) {
	    if (angular.isNumber(index) && currentIndex !== index) {
	      for (var i = 0; i < slides.length; i++) {
	        if (slides[i].slide.index === index) {
	          index = i;
	          break;
	        }
	      }
	
	      var slide = slides[index];
	      if (slide) {
	        setActive(index);
	        self.select(slides[index]);
	        currentIndex = index;
	      }
	    }
	  });
	
	  function getSlideByIndex(index) {
	    for (var i = 0, l = slides.length; i < l; ++i) {
	      if (slides[i].index === index) {
	        return slides[i];
	      }
	    }
	  }
	
	  function setActive(index) {
	    for (var i = 0; i < slides.length; i++) {
	      slides[i].slide.active = i === index;
	    }
	  }
	
	  function goNext(slide, index, direction) {
	    if (destroyed) {
	      return;
	    }
	
	    angular.extend(slide, {direction: direction});
	    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
	    if ($animate.enabled($element) && !$scope.$currentTransition &&
	      slides[index].element && self.slides.length > 1) {
	      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
	      var currentIdx = self.getCurrentIndex();
	
	      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
	        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
	      }
	
	      $scope.$currentTransition = true;
	      $animate.on('addClass', slides[index].element, function(element, phase) {
	        if (phase === 'close') {
	          $scope.$currentTransition = null;
	          $animate.off('addClass', element);
	        }
	      });
	    }
	
	    $scope.active = slide.index;
	    currentIndex = slide.index;
	    setActive(index);
	
	    //every time you change slides, reset the timer
	    restartTimer();
	  }
	
	  function findSlideIndex(slide) {
	    for (var i = 0; i < slides.length; i++) {
	      if (slides[i].slide === slide) {
	        return i;
	      }
	    }
	  }
	
	  function resetTimer() {
	    if (currentInterval) {
	      $interval.cancel(currentInterval);
	      currentInterval = null;
	    }
	  }
	
	  function resetTransition(slides) {
	    if (!slides.length) {
	      $scope.$currentTransition = null;
	    }
	  }
	
	  function restartTimer() {
	    resetTimer();
	    var interval = +$scope.interval;
	    if (!isNaN(interval) && interval > 0) {
	      currentInterval = $interval(timerFn, interval);
	    }
	  }
	
	  function timerFn() {
	    var interval = +$scope.interval;
	    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
	      $scope.next();
	    } else {
	      $scope.pause();
	    }
	  }
	}])
	
	.directive('uibCarousel', function() {
	  return {
	    transclude: true,
	    controller: 'UibCarouselController',
	    controllerAs: 'carousel',
	    restrict: 'A',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
	    },
	    scope: {
	      active: '=',
	      interval: '=',
	      noTransition: '=',
	      noPause: '=',
	      noWrap: '&'
	    }
	  };
	})
	
	.directive('uibSlide', ['$animate', function($animate) {
	  return {
	    require: '^uibCarousel',
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/carousel/slide.html';
	    },
	    scope: {
	      actual: '=?',
	      index: '=?'
	    },
	    link: function (scope, element, attrs, carouselCtrl) {
	      element.addClass('item');
	      carouselCtrl.addSlide(scope, element);
	      //when the scope is destroyed then remove the slide from the current slides array
	      scope.$on('$destroy', function() {
	        carouselCtrl.removeSlide(scope);
	      });
	
	      scope.$watch('active', function(active) {
	        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
	      });
	    }
	  };
	}])
	
	.animation('.item', ['$animateCss',
	function($animateCss) {
	  var SLIDE_DIRECTION = 'uib-slideDirection';
	
	  function removeClass(element, className, callback) {
	    element.removeClass(className);
	    if (callback) {
	      callback();
	    }
	  }
	
	  return {
	    beforeAddClass: function(element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element,
	          directionClass + ' ' + direction, done);
	        element.addClass(direction);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    },
	    beforeRemoveClass: function (element, className, done) {
	      if (className === 'active') {
	        var stopped = false;
	        var direction = element.data(SLIDE_DIRECTION);
	        var directionClass = direction === 'next' ? 'left' : 'right';
	        var removeClassFn = removeClass.bind(this, element, directionClass, done);
	
	        $animateCss(element, {addClass: directionClass})
	          .start()
	          .done(removeClassFn);
	
	        return function() {
	          stopped = true;
	        };
	      }
	      done();
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.dateparser', [])
	
	.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
	  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
	  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	
	  var localeId;
	  var formatCodeToRegex;
	
	  this.init = function() {
	    localeId = $locale.id;
	
	    this.parsers = {};
	    this.formatters = {};
	
	    formatCodeToRegex = [
	      {
	        key: 'yyyy',
	        regex: '\\d{4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yyyy');
	        }
	      },
	      {
	        key: 'yy',
	        regex: '\\d{2}',
	        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'yy');
	        }
	      },
	      {
	        key: 'y',
	        regex: '\\d{1,4}',
	        apply: function(value) { this.year = +value; },
	        formatter: function(date) {
	          var _date = new Date();
	          _date.setFullYear(Math.abs(date.getFullYear()));
	          return dateFilter(_date, 'y');
	        }
	      },
	      {
	        key: 'M!',
	        regex: '0?[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) {
	          var value = date.getMonth();
	          if (/^[0-9]$/.test(value)) {
	            return dateFilter(date, 'MM');
	          }
	
	          return dateFilter(date, 'M');
	        }
	      },
	      {
	        key: 'MMMM',
	        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMMM'); }
	      },
	      {
	        key: 'MMM',
	        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'MMM'); }
	      },
	      {
	        key: 'MM',
	        regex: '0[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'MM'); }
	      },
	      {
	        key: 'M',
	        regex: '[1-9]|1[0-2]',
	        apply: function(value) { this.month = value - 1; },
	        formatter: function(date) { return dateFilter(date, 'M'); }
	      },
	      {
	        key: 'd!',
	        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) {
	          var value = date.getDate();
	          if (/^[1-9]$/.test(value)) {
	            return dateFilter(date, 'dd');
	          }
	
	          return dateFilter(date, 'd');
	        }
	      },
	      {
	        key: 'dd',
	        regex: '[0-2][0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'dd'); }
	      },
	      {
	        key: 'd',
	        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
	        apply: function(value) { this.date = +value; },
	        formatter: function(date) { return dateFilter(date, 'd'); }
	      },
	      {
	        key: 'EEEE',
	        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEEE'); }
	      },
	      {
	        key: 'EEE',
	        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
	        formatter: function(date) { return dateFilter(date, 'EEE'); }
	      },
	      {
	        key: 'HH',
	        regex: '(?:0|1)[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'HH'); }
	      },
	      {
	        key: 'hh',
	        regex: '0[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'hh'); }
	      },
	      {
	        key: 'H',
	        regex: '1?[0-9]|2[0-3]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'H'); }
	      },
	      {
	        key: 'h',
	        regex: '[0-9]|1[0-2]',
	        apply: function(value) { this.hours = +value; },
	        formatter: function(date) { return dateFilter(date, 'h'); }
	      },
	      {
	        key: 'mm',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'mm'); }
	      },
	      {
	        key: 'm',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.minutes = +value; },
	        formatter: function(date) { return dateFilter(date, 'm'); }
	      },
	      {
	        key: 'sss',
	        regex: '[0-9][0-9][0-9]',
	        apply: function(value) { this.milliseconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'sss'); }
	      },
	      {
	        key: 'ss',
	        regex: '[0-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 'ss'); }
	      },
	      {
	        key: 's',
	        regex: '[0-9]|[1-5][0-9]',
	        apply: function(value) { this.seconds = +value; },
	        formatter: function(date) { return dateFilter(date, 's'); }
	      },
	      {
	        key: 'a',
	        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
	        apply: function(value) {
	          if (this.hours === 12) {
	            this.hours = 0;
	          }
	
	          if (value === 'PM') {
	            this.hours += 12;
	          }
	        },
	        formatter: function(date) { return dateFilter(date, 'a'); }
	      },
	      {
	        key: 'Z',
	        regex: '[+-]\\d{4}',
	        apply: function(value) {
	          var matches = value.match(/([+-])(\d{2})(\d{2})/),
	            sign = matches[1],
	            hours = matches[2],
	            minutes = matches[3];
	          this.hours += toInt(sign + hours);
	          this.minutes += toInt(sign + minutes);
	        },
	        formatter: function(date) {
	          return dateFilter(date, 'Z');
	        }
	      },
	      {
	        key: 'ww',
	        regex: '[0-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'ww'); }
	      },
	      {
	        key: 'w',
	        regex: '[0-9]|[1-4][0-9]|5[0-3]',
	        formatter: function(date) { return dateFilter(date, 'w'); }
	      },
	      {
	        key: 'GGGG',
	        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
	        formatter: function(date) { return dateFilter(date, 'GGGG'); }
	      },
	      {
	        key: 'GGG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GGG'); }
	      },
	      {
	        key: 'GG',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'GG'); }
	      },
	      {
	        key: 'G',
	        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
	        formatter: function(date) { return dateFilter(date, 'G'); }
	      }
	    ];
	
	    if (angular.version.major >= 1 && angular.version.minor > 4) {
	      formatCodeToRegex.push({
	        key: 'LLLL',
	        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
	        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
	        formatter: function(date) { return dateFilter(date, 'LLLL'); }
	      });
	    }
	  };
	
	  this.init();
	
	  function getFormatCodeToRegex(key) {
	    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
	  }
	
	  this.getParser = function (key) {
	    var f = getFormatCodeToRegex(key);
	    return f && f.apply || null;
	  };
	
	  this.overrideParser = function (key, parser) {
	    var f = getFormatCodeToRegex(key);
	    if (f && angular.isFunction(parser)) {
	      this.parsers = {};
	      f.apply = parser;
	    }
	  }.bind(this);
	
	  function createParser(format) {
	    var map = [], regex = format.split('');
	
	    // check for literal values
	    var quoteIndex = format.indexOf('\'');
	    if (quoteIndex > -1) {
	      var inLiteral = false;
	      format = format.split('');
	      for (var i = quoteIndex; i < format.length; i++) {
	        if (inLiteral) {
	          if (format[i] === '\'') {
	            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
	              format[i+1] = '$';
	              regex[i+1] = '';
	            } else { // end of literal
	              regex[i] = '';
	              inLiteral = false;
	            }
	          }
	          format[i] = '$';
	        } else {
	          if (format[i] === '\'') { // start of literal
	            format[i] = '$';
	            regex[i] = '';
	            inLiteral = true;
	          }
	        }
	      }
	
	      format = format.join('');
	    }
	
	    angular.forEach(formatCodeToRegex, function(data) {
	      var index = format.indexOf(data.key);
	
	      if (index > -1) {
	        format = format.split('');
	
	        regex[index] = '(' + data.regex + ')';
	        format[index] = '$'; // Custom symbol to define consumed part of format
	        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
	          regex[i] = '';
	          format[i] = '$';
	        }
	        format = format.join('');
	
	        map.push({
	          index: index,
	          key: data.key,
	          apply: data.apply,
	          matcher: data.regex
	        });
	      }
	    });
	
	    return {
	      regex: new RegExp('^' + regex.join('') + '$'),
	      map: orderByFilter(map, 'index')
	    };
	  }
	
	  function createFormatter(format) {
	    var formatters = [];
	    var i = 0;
	    var formatter, literalIdx;
	    while (i < format.length) {
	      if (angular.isNumber(literalIdx)) {
	        if (format.charAt(i) === '\'') {
	          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
	            formatters.push(constructLiteralFormatter(format, literalIdx, i));
	            literalIdx = null;
	          }
	        } else if (i === format.length) {
	          while (literalIdx < format.length) {
	            formatter = constructFormatterFromIdx(format, literalIdx);
	            formatters.push(formatter);
	            literalIdx = formatter.endIdx;
	          }
	        }
	
	        i++;
	        continue;
	      }
	
	      if (format.charAt(i) === '\'') {
	        literalIdx = i;
	        i++;
	        continue;
	      }
	
	      formatter = constructFormatterFromIdx(format, i);
	
	      formatters.push(formatter.parser);
	      i = formatter.endIdx;
	    }
	
	    return formatters;
	  }
	
	  function constructLiteralFormatter(format, literalIdx, endIdx) {
	    return function() {
	      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
	    };
	  }
	
	  function constructFormatterFromIdx(format, i) {
	    var currentPosStr = format.substr(i);
	    for (var j = 0; j < formatCodeToRegex.length; j++) {
	      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
	        var data = formatCodeToRegex[j];
	        return {
	          endIdx: i + data.key.length,
	          parser: data.formatter
	        };
	      }
	    }
	
	    return {
	      endIdx: i + 1,
	      parser: function() {
	        return currentPosStr.charAt(0);
	      }
	    };
	  }
	
	  this.filter = function(date, format) {
	    if (!angular.isDate(date) || isNaN(date) || !format) {
	      return '';
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.formatters[format]) {
	      this.formatters[format] = createFormatter(format);
	    }
	
	    var formatters = this.formatters[format];
	
	    return formatters.reduce(function(str, formatter) {
	      return str + formatter(date);
	    }, '');
	  };
	
	  this.parse = function(input, format, baseDate) {
	    if (!angular.isString(input) || !format) {
	      return input;
	    }
	
	    format = $locale.DATETIME_FORMATS[format] || format;
	    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
	
	    if ($locale.id !== localeId) {
	      this.init();
	    }
	
	    if (!this.parsers[format]) {
	      this.parsers[format] = createParser(format, 'apply');
	    }
	
	    var parser = this.parsers[format],
	        regex = parser.regex,
	        map = parser.map,
	        results = input.match(regex),
	        tzOffset = false;
	    if (results && results.length) {
	      var fields, dt;
	      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
	        fields = {
	          year: baseDate.getFullYear(),
	          month: baseDate.getMonth(),
	          date: baseDate.getDate(),
	          hours: baseDate.getHours(),
	          minutes: baseDate.getMinutes(),
	          seconds: baseDate.getSeconds(),
	          milliseconds: baseDate.getMilliseconds()
	        };
	      } else {
	        if (baseDate) {
	          $log.warn('dateparser:', 'baseDate is not a valid date');
	        }
	        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
	      }
	
	      for (var i = 1, n = results.length; i < n; i++) {
	        var mapper = map[i - 1];
	        if (mapper.matcher === 'Z') {
	          tzOffset = true;
	        }
	
	        if (mapper.apply) {
	          mapper.apply.call(fields, results[i]);
	        }
	      }
	
	      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
	        Date.prototype.setFullYear;
	      var timesetter = tzOffset ? Date.prototype.setUTCHours :
	        Date.prototype.setHours;
	
	      if (isValid(fields.year, fields.month, fields.date)) {
	        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
	          dt = new Date(baseDate);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours, fields.minutes,
	            fields.seconds, fields.milliseconds);
	        } else {
	          dt = new Date(0);
	          datesetter.call(dt, fields.year, fields.month, fields.date);
	          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
	            fields.seconds || 0, fields.milliseconds || 0);
	        }
	      }
	
	      return dt;
	    }
	  };
	
	  // Check if date is valid for specific month (and year for February).
	  // Month: 0 = Jan, 1 = Feb, etc
	  function isValid(year, month, date) {
	    if (date < 1) {
	      return false;
	    }
	
	    if (month === 1 && date > 28) {
	      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
	    }
	
	    if (month === 3 || month === 5 || month === 8 || month === 10) {
	      return date < 31;
	    }
	
	    return true;
	  }
	
	  function toInt(str) {
	    return parseInt(str, 10);
	  }
	
	  this.toTimezone = toTimezone;
	  this.fromTimezone = fromTimezone;
	  this.timezoneToOffset = timezoneToOffset;
	  this.addDateMinutes = addDateMinutes;
	  this.convertTimezoneToLocal = convertTimezoneToLocal;
	
	  function toTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
	  }
	
	  function fromTimezone(date, timezone) {
	    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
	  }
	
	  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
	  function timezoneToOffset(timezone, fallback) {
	    timezone = timezone.replace(/:/g, '');
	    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	  }
	
	  function addDateMinutes(date, minutes) {
	    date = new Date(date.getTime());
	    date.setMinutes(date.getMinutes() + minutes);
	    return date;
	  }
	
	  function convertTimezoneToLocal(date, timezone, reverse) {
	    reverse = reverse ? -1 : 1;
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	  }
	}]);
	
	// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
	// at most one element.
	angular.module('ui.bootstrap.isClass', [])
	.directive('uibIsClass', [
	         '$animate',
	function ($animate) {
	  //                    11111111          22222222
	  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
	  //                    11111111           22222222
	  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
	
	  var dataPerTracked = {};
	
	  return {
	    restrict: 'A',
	    compile: function(tElement, tAttrs) {
	      var linkedScopes = [];
	      var instances = [];
	      var expToData = {};
	      var lastActivated = null;
	      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
	      var onExp = onExpMatches[2];
	      var expsStr = onExpMatches[1];
	      var exps = expsStr.split(',');
	
	      return linkFn;
	
	      function linkFn(scope, element, attrs) {
	        linkedScopes.push(scope);
	        instances.push({
	          scope: scope,
	          element: element
	        });
	
	        exps.forEach(function(exp, k) {
	          addForExp(exp, scope);
	        });
	
	        scope.$on('$destroy', removeScope);
	      }
	
	      function addForExp(exp, scope) {
	        var matches = exp.match(IS_REGEXP);
	        var clazz = scope.$eval(matches[1]);
	        var compareWithExp = matches[2];
	        var data = expToData[exp];
	        if (!data) {
	          var watchFn = function(compareWithVal) {
	            var newActivated = null;
	            instances.some(function(instance) {
	              var thisVal = instance.scope.$eval(onExp);
	              if (thisVal === compareWithVal) {
	                newActivated = instance;
	                return true;
	              }
	            });
	            if (data.lastActivated !== newActivated) {
	              if (data.lastActivated) {
	                $animate.removeClass(data.lastActivated.element, clazz);
	              }
	              if (newActivated) {
	                $animate.addClass(newActivated.element, clazz);
	              }
	              data.lastActivated = newActivated;
	            }
	          };
	          expToData[exp] = data = {
	            lastActivated: null,
	            scope: scope,
	            watchFn: watchFn,
	            compareWithExp: compareWithExp,
	            watcher: scope.$watch(compareWithExp, watchFn)
	          };
	        }
	        data.watchFn(scope.$eval(compareWithExp));
	      }
	
	      function removeScope(e) {
	        var removedScope = e.targetScope;
	        var index = linkedScopes.indexOf(removedScope);
	        linkedScopes.splice(index, 1);
	        instances.splice(index, 1);
	        if (linkedScopes.length) {
	          var newWatchScope = linkedScopes[0];
	          angular.forEach(expToData, function(data) {
	            if (data.scope === removedScope) {
	              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
	              data.scope = newWatchScope;
	            }
	          });
	        } else {
	          expToData = {};
	        }
	      }
	    }
	  };
	}]);
	angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])
	
	.value('$datepickerSuppressError', false)
	
	.value('$datepickerLiteralWarning', true)
	
	.constant('uibDatepickerConfig', {
	  datepickerMode: 'day',
	  formatDay: 'dd',
	  formatMonth: 'MMMM',
	  formatYear: 'yyyy',
	  formatDayHeader: 'EEE',
	  formatDayTitle: 'MMMM yyyy',
	  formatMonthTitle: 'yyyy',
	  maxDate: null,
	  maxMode: 'year',
	  minDate: null,
	  minMode: 'day',
	  monthColumns: 3,
	  ngModelOptions: {},
	  shortcutPropagation: false,
	  showWeeks: true,
	  yearColumns: 5,
	  yearRows: 4
	})
	
	.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
	  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
	  var self = this,
	      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
	      ngModelOptions = {},
	      watchListeners = [];
	
	  $element.addClass('uib-datepicker');
	  $attrs.$set('role', 'application');
	
	  if (!$scope.datepickerOptions) {
	    $scope.datepickerOptions = {};
	  }
	
	  // Modes chain
	  this.modes = ['day', 'month', 'year'];
	
	  [
	    'customClass',
	    'dateDisabled',
	    'datepickerMode',
	    'formatDay',
	    'formatDayHeader',
	    'formatDayTitle',
	    'formatMonth',
	    'formatMonthTitle',
	    'formatYear',
	    'maxDate',
	    'maxMode',
	    'minDate',
	    'minMode',
	    'monthColumns',
	    'showWeeks',
	    'shortcutPropagation',
	    'startingDay',
	    'yearColumns',
	    'yearRows'
	  ].forEach(function(key) {
	    switch (key) {
	      case 'customClass':
	      case 'dateDisabled':
	        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
	        break;
	      case 'datepickerMode':
	        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
	          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
	        break;
	      case 'formatDay':
	      case 'formatDayHeader':
	      case 'formatDayTitle':
	      case 'formatMonth':
	      case 'formatMonthTitle':
	      case 'formatYear':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
	          datepickerConfig[key];
	        break;
	      case 'monthColumns':
	      case 'showWeeks':
	      case 'shortcutPropagation':
	      case 'yearColumns':
	      case 'yearRows':
	        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
	          $scope.datepickerOptions[key] : datepickerConfig[key];
	        break;
	      case 'startingDay':
	        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
	          self.startingDay = $scope.datepickerOptions.startingDay;
	        } else if (angular.isNumber(datepickerConfig.startingDay)) {
	          self.startingDay = datepickerConfig.startingDay;
	        } else {
	          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
	        }
	
	        break;
	      case 'maxDate':
	      case 'minDate':
	        $scope.$watch('datepickerOptions.' + key, function(value) {
	          if (value) {
	            if (angular.isDate(value)) {
	              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
	            } else {
	              if ($datepickerLiteralWarning) {
	                $log.warn('Literal date support has been deprecated, please switch to date object usage');
	              }
	
	              self[key] = new Date(dateFilter(value, 'medium'));
	            }
	          } else {
	            self[key] = datepickerConfig[key] ?
	              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
	              null;
	          }
	
	          self.refreshView();
	        });
	
	        break;
	      case 'maxMode':
	      case 'minMode':
	        if ($scope.datepickerOptions[key]) {
	          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
	            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
	            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
	              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
	              $scope.datepickerMode = self[key];
	              $scope.datepickerOptions.datepickerMode = self[key];
	            }
	          });
	        } else {
	          self[key] = $scope[key] = datepickerConfig[key] || null;
	        }
	
	        break;
	    }
	  });
	
	  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if (angular.isDefined($attrs.ngDisabled)) {
	    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
	      $scope.disabled = disabled;
	      self.refreshView();
	    }));
	  }
	
	  $scope.isActive = function(dateObject) {
	    if (self.compare(dateObject.date, self.activeDate) === 0) {
	      $scope.activeDateId = dateObject.uid;
	      return true;
	    }
	    return false;
	  };
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelOptions = extractOptions(ngModelCtrl);
	
	    if ($scope.datepickerOptions.initDate) {
	      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
	      $scope.$watch('datepickerOptions.initDate', function(initDate) {
	        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
	          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
	          self.refreshView();
	        }
	      });
	    } else {
	      self.activeDate = new Date();
	    }
	
	    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
	    this.activeDate = !isNaN(date) ?
	      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
	      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	
	    ngModelCtrl.$render = function() {
	      self.render();
	    };
	  };
	
	  this.render = function() {
	    if (ngModelCtrl.$viewValue) {
	      var date = new Date(ngModelCtrl.$viewValue),
	          isValid = !isNaN(date);
	
	      if (isValid) {
	        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      } else if (!$datepickerSuppressError) {
	        $log.error('Datepicker directive: "ng-model" value must be a Date object');
	      }
	    }
	    this.refreshView();
	  };
	
	  this.refreshView = function() {
	    if (this.element) {
	      $scope.selectedDt = null;
	      this._refreshView();
	      if ($scope.activeDt) {
	        $scope.activeDateId = $scope.activeDt.uid;
	      }
	
	      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setValidity('dateDisabled', !date ||
	        this.element && !this.isDisabled(date));
	    }
	  };
	
	  this.createDateObject = function(date, format) {
	    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
	    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
	    var today = new Date();
	    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	    var time = this.compare(date, today);
	    var dt = {
	      date: date,
	      label: dateParser.filter(date, format),
	      selected: model && this.compare(date, model) === 0,
	      disabled: this.isDisabled(date),
	      past: time < 0,
	      current: time === 0,
	      future: time > 0,
	      customClass: this.customClass(date) || null
	    };
	
	    if (model && this.compare(date, model) === 0) {
	      $scope.selectedDt = dt;
	    }
	
	    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
	      $scope.activeDt = dt;
	    }
	
	    return dt;
	  };
	
	  this.isDisabled = function(date) {
	    return $scope.disabled ||
	      this.minDate && this.compare(date, this.minDate) < 0 ||
	      this.maxDate && this.compare(date, this.maxDate) > 0 ||
	      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
	  };
	
	  this.customClass = function(date) {
	    return $scope.customClass({date: date, mode: $scope.datepickerMode});
	  };
	
	  // Split array into smaller arrays
	  this.split = function(arr, size) {
	    var arrays = [];
	    while (arr.length > 0) {
	      arrays.push(arr.splice(0, size));
	    }
	    return arrays;
	  };
	
	  $scope.select = function(date) {
	    if ($scope.datepickerMode === self.minMode) {
	      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
	      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
	      ngModelCtrl.$setViewValue(dt);
	      ngModelCtrl.$render();
	    } else {
	      self.activeDate = date;
	      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);
	
	      $scope.$emit('uib:datepicker.mode');
	    }
	
	    $scope.$broadcast('uib:datepicker.focus');
	  };
	
	  $scope.move = function(direction) {
	    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
	        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
	    self.activeDate.setFullYear(year, month, 1);
	    self.refreshView();
	  };
	
	  $scope.toggleMode = function(direction) {
	    direction = direction || 1;
	
	    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
	      $scope.datepickerMode === self.minMode && direction === -1) {
	      return;
	    }
	
	    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);
	
	    $scope.$emit('uib:datepicker.mode');
	  };
	
	  // Key event mapper
	  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };
	
	  var focusElement = function() {
	    self.element[0].focus();
	  };
	
	  // Listen for focus requests from popup directive
	  $scope.$on('uib:datepicker.focus', focusElement);
	
	  $scope.keydown = function(evt) {
	    var key = $scope.keys[evt.which];
	
	    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
	      return;
	    }
	
	    evt.preventDefault();
	    if (!self.shortcutPropagation) {
	      evt.stopPropagation();
	    }
	
	    if (key === 'enter' || key === 'space') {
	      if (self.isDisabled(self.activeDate)) {
	        return; // do nothing
	      }
	      $scope.select(self.activeDate);
	    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
	      $scope.toggleMode(key === 'up' ? 1 : -1);
	    } else {
	      self.handleKeyDown(key, evt);
	      self.refreshView();
	    }
	  };
	
	  $element.on('keydown', function(evt) {
	    $scope.$apply(function() {
	      $scope.keydown(evt);
	    });
	  });
	
	  $scope.$on('$destroy', function() {
	    //Clear all watch listeners on destroy
	    while (watchListeners.length) {
	      watchListeners.shift()();
	    }
	  });
	
	  function setMode(mode) {
	    $scope.datepickerMode = mode;
	    $scope.datepickerOptions.datepickerMode = mode;
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = ngModelCtrl.$options ||
	        $scope.datepickerOptions.ngModelOptions ||
	        datepickerConfig.ngModelOptions ||
	        {};
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
	      var timezone = ngModelCtrl.$options.getOption('timezone') ||
	        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
	        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);
	
	      // values passed to createChild override existing values
	      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
	        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
	        .createChild($scope.datepickerOptions.ngModelOptions)
	        .createChild(ngModelCtrl.$options) // highest precedence
	        .createChild({timezone: timezone}); // to keep from squashing a non-null value
	    }
	
	    return ngModelOptions;
	  }
	}])
	
	.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	  this.step = { months: 1 };
	  this.element = $element;
	  function getDaysInMonth(year, month) {
	    return month === 1 && year % 4 === 0 &&
	      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
	  }
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    scope.showWeeks = ctrl.showWeeks;
	    ctrl.refreshView();
	  };
	
	  this.getDates = function(startDate, n) {
	    var dates = new Array(n), current = new Date(startDate), i = 0, date;
	    while (i < n) {
	      date = new Date(current);
	      dates[i++] = date;
	      current.setDate(current.getDate() + 1);
	    }
	    return dates;
	  };
	
	  this._refreshView = function() {
	    var year = this.activeDate.getFullYear(),
	      month = this.activeDate.getMonth(),
	      firstDayOfMonth = new Date(this.activeDate);
	
	    firstDayOfMonth.setFullYear(year, month, 1);
	
	    var difference = this.startingDay - firstDayOfMonth.getDay(),
	      numDisplayedFromPreviousMonth = difference > 0 ?
	        7 - difference : - difference,
	      firstDate = new Date(firstDayOfMonth);
	
	    if (numDisplayedFromPreviousMonth > 0) {
	      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	    }
	
	    // 42 is the number of days on a six-week calendar
	    var days = this.getDates(firstDate, 42);
	    for (var i = 0; i < 42; i ++) {
	      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
	        secondary: days[i].getMonth() !== month,
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.labels = new Array(7);
	    for (var j = 0; j < 7; j++) {
	      scope.labels[j] = {
	        abbr: dateFilter(days[j].date, this.formatDayHeader),
	        full: dateFilter(days[j].date, 'EEEE')
	      };
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
	    scope.rows = this.split(days, 7);
	
	    if (scope.showWeeks) {
	      scope.weekNumbers = [];
	      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
	          numWeeks = scope.rows.length;
	      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	        scope.weekNumbers.push(
	          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
	      }
	    }
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  function getISO8601WeekNumber(date) {
	    var checkDate = new Date(date);
	    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
	    var time = checkDate.getTime();
	    checkDate.setMonth(0); // Compare with Jan 1
	    checkDate.setDate(1);
	    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
	  }
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getDate();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - 7;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + 7;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setMonth(month, 1);
	      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
	    } else if (key === 'home') {
	      date = 1;
	    } else if (key === 'end') {
	      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
	    }
	    this.activeDate.setDate(date);
	  };
	}])
	
	.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  this.step = { years: 1 };
	  this.element = $element;
	
	  this.init = function(ctrl) {
	    angular.extend(ctrl, this);
	    ctrl.refreshView();
	  };
	
	  this._refreshView = function() {
	    var months = new Array(12),
	        year = this.activeDate.getFullYear(),
	        date;
	
	    for (var i = 0; i < 12; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(year, i, 1);
	      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
	    scope.rows = this.split(months, this.monthColumns);
	    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
	  };
	
	  this.compare = function(date1, date2) {
	    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
	    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
	    _date1.setFullYear(date1.getFullYear());
	    _date2.setFullYear(date2.getFullYear());
	    return _date1 - _date2;
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getMonth();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - this.monthColumns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + this.monthColumns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
	      this.activeDate.setFullYear(year);
	    } else if (key === 'home') {
	      date = 0;
	    } else if (key === 'end') {
	      date = 11;
	    }
	    this.activeDate.setMonth(date);
	  };
	}])
	
	.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
	  var columns, range;
	  this.element = $element;
	
	  function getStartingYear(year) {
	    return parseInt((year - 1) / range, 10) * range + 1;
	  }
	
	  this.yearpickerInit = function() {
	    columns = this.yearColumns;
	    range = this.yearRows * columns;
	    this.step = { years: range };
	  };
	
	  this._refreshView = function() {
	    var years = new Array(range), date;
	
	    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
	      date = new Date(this.activeDate);
	      date.setFullYear(start + i, 0, 1);
	      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
	        uid: scope.uniqueId + '-' + i
	      });
	    }
	
	    scope.title = [years[0].label, years[range - 1].label].join(' - ');
	    scope.rows = this.split(years, columns);
	    scope.columns = columns;
	  };
	
	  this.compare = function(date1, date2) {
	    return date1.getFullYear() - date2.getFullYear();
	  };
	
	  this.handleKeyDown = function(key, evt) {
	    var date = this.activeDate.getFullYear();
	
	    if (key === 'left') {
	      date = date - 1;
	    } else if (key === 'up') {
	      date = date - columns;
	    } else if (key === 'right') {
	      date = date + 1;
	    } else if (key === 'down') {
	      date = date + columns;
	    } else if (key === 'pageup' || key === 'pagedown') {
	      date += (key === 'pageup' ? - 1 : 1) * range;
	    } else if (key === 'home') {
	      date = getStartingYear(this.activeDate.getFullYear());
	    } else if (key === 'end') {
	      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
	    }
	    this.activeDate.setFullYear(date);
	  };
	}])
	
	.directive('uibDatepicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
	    },
	    scope: {
	      datepickerOptions: '=?'
	    },
	    require: ['uibDatepicker', '^ngModel'],
	    restrict: 'A',
	    controller: 'UibDatepickerController',
	    controllerAs: 'datepicker',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      datepickerCtrl.init(ngModelCtrl);
	    }
	  };
	})
	
	.directive('uibDaypicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/day.html';
	    },
	    require: ['^uibDatepicker', 'uibDaypicker'],
	    restrict: 'A',
	    controller: 'UibDaypickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        daypickerCtrl = ctrls[1];
	
	      daypickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibMonthpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/month.html';
	    },
	    require: ['^uibDatepicker', 'uibMonthpicker'],
	    restrict: 'A',
	    controller: 'UibMonthpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var datepickerCtrl = ctrls[0],
	        monthpickerCtrl = ctrls[1];
	
	      monthpickerCtrl.init(datepickerCtrl);
	    }
	  };
	})
	
	.directive('uibYearpicker', function() {
	  return {
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepicker/year.html';
	    },
	    require: ['^uibDatepicker', 'uibYearpicker'],
	    restrict: 'A',
	    controller: 'UibYearpickerController',
	    link: function(scope, element, attrs, ctrls) {
	      var ctrl = ctrls[0];
	      angular.extend(ctrl, ctrls[1]);
	      ctrl.yearpickerInit();
	
	      ctrl.refreshView();
	    }
	  };
	});
	
	angular.module('ui.bootstrap.position', [])
	
	/**
	 * A set of utility methods for working with the DOM.
	 * It is meant to be used where we need to absolute-position elements in
	 * relation to another element (this is the case for tooltips, popovers,
	 * typeahead suggestions etc.).
	 */
	  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
	    /**
	     * Used by scrollbarWidth() function to cache scrollbar's width.
	     * Do not access this variable directly, use scrollbarWidth() instead.
	     */
	    var SCROLLBAR_WIDTH;
	    /**
	     * scrollbar on body and html element in IE and Edge overlay
	     * content and should be considered 0 width.
	     */
	    var BODY_SCROLLBAR_WIDTH;
	    var OVERFLOW_REGEX = {
	      normal: /(auto|scroll)/,
	      hidden: /(auto|scroll|hidden)/
	    };
	    var PLACEMENT_REGEX = {
	      auto: /\s?auto?\s?/i,
	      primary: /^(top|bottom|left|right)$/,
	      secondary: /^(top|bottom|left|right|center)$/,
	      vertical: /^(top|bottom)$/
	    };
	    var BODY_REGEX = /(HTML|BODY)/;
	
	    return {
	
	      /**
	       * Provides a raw DOM element from a jQuery/jQLite element.
	       *
	       * @param {element} elem - The element to convert.
	       *
	       * @returns {element} A HTML element.
	       */
	      getRawNode: function(elem) {
	        return elem.nodeName ? elem : elem[0] || elem;
	      },
	
	      /**
	       * Provides a parsed number for a style property.  Strips
	       * units and casts invalid numbers to 0.
	       *
	       * @param {string} value - The style value to parse.
	       *
	       * @returns {number} A valid number.
	       */
	      parseStyle: function(value) {
	        value = parseFloat(value);
	        return isFinite(value) ? value : 0;
	      },
	
	      /**
	       * Provides the closest positioned ancestor.
	       *
	       * @param {element} element - The element to get the offest parent for.
	       *
	       * @returns {element} The closest positioned ancestor.
	       */
	      offsetParent: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var offsetParent = elem.offsetParent || $document[0].documentElement;
	
	        function isStaticPositioned(el) {
	          return ($window.getComputedStyle(el).position || 'static') === 'static';
	        }
	
	        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        return offsetParent || $document[0].documentElement;
	      },
	
	      /**
	       * Provides the scrollbar width, concept from TWBS measureScrollbar()
	       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
	       * In IE and Edge, scollbar on body and html element overlay and should
	       * return a width of 0.
	       *
	       * @returns {number} The width of the browser scollbar.
	       */
	      scrollbarWidth: function(isBody) {
	        if (isBody) {
	          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
	            var bodyElem = $document.find('body');
	            bodyElem.addClass('uib-position-body-scrollbar-measure');
	            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
	            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
	            bodyElem.removeClass('uib-position-body-scrollbar-measure');
	          }
	          return BODY_SCROLLBAR_WIDTH;
	        }
	
	        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
	          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
	          $document.find('body').append(scrollElem);
	          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
	          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
	          scrollElem.remove();
	        }
	
	        return SCROLLBAR_WIDTH;
	      },
	
	      /**
	       * Provides the padding required on an element to replace the scrollbar.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
	       *     <li>**widthOverflow**: whether the the width is overflowing</li>
	       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
	       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
	       *     <li>**heightOverflow**: whether the the height is overflowing</li>
	       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
	       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
	       *   </ul>
	       */
	      scrollbarPadding: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemStyle = $window.getComputedStyle(elem);
	        var paddingRight = this.parseStyle(elemStyle.paddingRight);
	        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
	        var scrollParent = this.scrollParent(elem, false, true);
	        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));
	
	        return {
	          scrollbarWidth: scrollbarWidth,
	          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
	          right: paddingRight + scrollbarWidth,
	          originalRight: paddingRight,
	          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
	          bottom: paddingBottom + scrollbarWidth,
	          originalBottom: paddingBottom
	         };
	      },
	
	      /**
	       * Checks to see if the element is scrollable.
	       *
	       * @param {element} elem - The element to check.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       *
	       * @returns {boolean} Whether the element is scrollable.
	       */
	      isScrollable: function(elem, includeHidden) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var elemStyle = $window.getComputedStyle(elem);
	        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
	      },
	
	      /**
	       * Provides the closest scrollable ancestor.
	       * A port of the jQuery UI scrollParent method:
	       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
	       *
	       * @param {element} elem - The element to find the scroll parent of.
	       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
	       *   default is false.
	       * @param {boolean=} [includeSelf=false] - Should the element being passed be
	       * included in the scrollable llokup.
	       *
	       * @returns {element} A HTML element.
	       */
	      scrollParent: function(elem, includeHidden, includeSelf) {
	        elem = this.getRawNode(elem);
	
	        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
	        var documentEl = $document[0].documentElement;
	        var elemStyle = $window.getComputedStyle(elem);
	        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
	          return elem;
	        }
	        var excludeStatic = elemStyle.position === 'absolute';
	        var scrollParent = elem.parentElement || documentEl;
	
	        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
	          return documentEl;
	        }
	
	        while (scrollParent.parentElement && scrollParent !== documentEl) {
	          var spStyle = $window.getComputedStyle(scrollParent);
	          if (excludeStatic && spStyle.position !== 'static') {
	            excludeStatic = false;
	          }
	
	          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
	            break;
	          }
	          scrollParent = scrollParent.parentElement;
	        }
	
	        return scrollParent;
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's position function:
	       * http://api.jquery.com/position/ - distance to closest positioned
	       * ancestor.  Does not account for margins by default like jQuery position.
	       *
	       * @param {element} elem - The element to caclulate the position on.
	       * @param {boolean=} [includeMargins=false] - Should margins be accounted
	       * for, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of offset parent</li>
	       *     <li>**left**: distance to left edge of offset parent</li>
	       *   </ul>
	       */
	      position: function(elem, includeMagins) {
	        elem = this.getRawNode(elem);
	
	        var elemOffset = this.offset(elem);
	        if (includeMagins) {
	          var elemStyle = $window.getComputedStyle(elem);
	          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
	          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
	        }
	        var parent = this.offsetParent(elem);
	        var parentOffset = {top: 0, left: 0};
	
	        if (parent !== $document[0].documentElement) {
	          parentOffset = this.offset(parent);
	          parentOffset.top += parent.clientTop - parent.scrollTop;
	          parentOffset.left += parent.clientLeft - parent.scrollLeft;
	        }
	
	        return {
	          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
	          top: Math.round(elemOffset.top - parentOffset.top),
	          left: Math.round(elemOffset.left - parentOffset.left)
	        };
	      },
	
	      /**
	       * Provides read-only equivalent of jQuery's offset function:
	       * http://api.jquery.com/offset/ - distance to viewport.  Does
	       * not account for borders, margins, or padding on the body
	       * element.
	       *
	       * @param {element} elem - The element to calculate the offset on.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**width**: the width of the element</li>
	       *     <li>**height**: the height of the element</li>
	       *     <li>**top**: distance to top edge of viewport</li>
	       *     <li>**right**: distance to bottom edge of viewport</li>
	       *   </ul>
	       */
	      offset: function(elem) {
	        elem = this.getRawNode(elem);
	
	        var elemBCR = elem.getBoundingClientRect();
	        return {
	          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
	          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
	          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
	          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
	        };
	      },
	
	      /**
	       * Provides offset distance to the closest scrollable ancestor
	       * or viewport.  Accounts for border and scrollbar width.
	       *
	       * Right and bottom dimensions represent the distance to the
	       * respective edge of the viewport element.  If the element
	       * edge extends beyond the viewport, a negative value will be
	       * reported.
	       *
	       * @param {element} elem - The element to get the viewport offset for.
	       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
	       * of the first scrollable element, default is false.
	       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
	       * be accounted for, default is true.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: distance to the top content edge of viewport element</li>
	       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
	       *     <li>**left**: distance to the left content edge of viewport element</li>
	       *     <li>**right**: distance to the right content edge of viewport element</li>
	       *   </ul>
	       */
	      viewportOffset: function(elem, useDocument, includePadding) {
	        elem = this.getRawNode(elem);
	        includePadding = includePadding !== false ? true : false;
	
	        var elemBCR = elem.getBoundingClientRect();
	        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};
	
	        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
	        var offsetParentBCR = offsetParent.getBoundingClientRect();
	
	        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
	        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
	        if (offsetParent === $document[0].documentElement) {
	          offsetBCR.top += $window.pageYOffset;
	          offsetBCR.left += $window.pageXOffset;
	        }
	        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
	        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
	
	        if (includePadding) {
	          var offsetParentStyle = $window.getComputedStyle(offsetParent);
	          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
	          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
	          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
	          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
	        }
	
	        return {
	          top: Math.round(elemBCR.top - offsetBCR.top),
	          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
	          left: Math.round(elemBCR.left - offsetBCR.left),
	          right: Math.round(offsetBCR.right - elemBCR.right)
	        };
	      },
	
	      /**
	       * Provides an array of placement values parsed from a placement string.
	       * Along with the 'auto' indicator, supported placement strings are:
	       *   <ul>
	       *     <li>top: element on top, horizontally centered on host element.</li>
	       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
	       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
	       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
	       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
	       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
	       *     <li>left: element on left, vertically centered on host element.</li>
	       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
	       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
	       *     <li>right: element on right, vertically centered on host element.</li>
	       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
	       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
	       *   </ul>
	       * A placement string with an 'auto' indicator is expected to be
	       * space separated from the placement, i.e: 'auto bottom-left'  If
	       * the primary and secondary placement values do not match 'top,
	       * bottom, left, right' then 'top' will be the primary placement and
	       * 'center' will be the secondary placement.  If 'auto' is passed, true
	       * will be returned as the 3rd value of the array.
	       *
	       * @param {string} placement - The placement string to parse.
	       *
	       * @returns {array} An array with the following values
	       * <ul>
	       *   <li>**[0]**: The primary placement.</li>
	       *   <li>**[1]**: The secondary placement.</li>
	       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
	       * </ul>
	       */
	      parsePlacement: function(placement) {
	        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
	        if (autoPlace) {
	          placement = placement.replace(PLACEMENT_REGEX.auto, '');
	        }
	
	        placement = placement.split('-');
	
	        placement[0] = placement[0] || 'top';
	        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
	          placement[0] = 'top';
	        }
	
	        placement[1] = placement[1] || 'center';
	        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
	          placement[1] = 'center';
	        }
	
	        if (autoPlace) {
	          placement[2] = true;
	        } else {
	          placement[2] = false;
	        }
	
	        return placement;
	      },
	
	      /**
	       * Provides coordinates for an element to be positioned relative to
	       * another element.  Passing 'auto' as part of the placement parameter
	       * will enable smart placement - where the element fits. i.e:
	       * 'auto left-top' will check to see if there is enough space to the left
	       * of the hostElem to fit the targetElem, if not place right (same for secondary
	       * top placement).  Available space is calculated using the viewportOffset
	       * function.
	       *
	       * @param {element} hostElem - The element to position against.
	       * @param {element} targetElem - The element to position.
	       * @param {string=} [placement=top] - The placement for the targetElem,
	       *   default is 'top'. 'center' is assumed as secondary placement for
	       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
	       *   <ul>
	       *     <li>top</li>
	       *     <li>top-right</li>
	       *     <li>top-left</li>
	       *     <li>bottom</li>
	       *     <li>bottom-left</li>
	       *     <li>bottom-right</li>
	       *     <li>left</li>
	       *     <li>left-top</li>
	       *     <li>left-bottom</li>
	       *     <li>right</li>
	       *     <li>right-top</li>
	       *     <li>right-bottom</li>
	       *   </ul>
	       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
	       *   be calculated from the body element, default is false.
	       *
	       * @returns {object} An object with the following properties:
	       *   <ul>
	       *     <li>**top**: Value for targetElem top.</li>
	       *     <li>**left**: Value for targetElem left.</li>
	       *     <li>**placement**: The resolved placement.</li>
	       *   </ul>
	       */
	      positionElements: function(hostElem, targetElem, placement, appendToBody) {
	        hostElem = this.getRawNode(hostElem);
	        targetElem = this.getRawNode(targetElem);
	
	        // need to read from prop to support tests.
	        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
	        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
	
	        placement = this.parsePlacement(placement);
	
	        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
	        var targetElemPos = {top: 0, left: 0, placement: ''};
	
	        if (placement[2]) {
	          var viewportOffset = this.viewportOffset(hostElem, appendToBody);
	
	          var targetElemStyle = $window.getComputedStyle(targetElem);
	          var adjustedSize = {
	            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
	            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
	          };
	
	          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
	                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
	                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
	                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
	                         placement[0];
	
	          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
	                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
	                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
	                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
	                         placement[1];
	
	          if (placement[1] === 'center') {
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
	              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
	                placement[1] = 'left';
	              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
	                placement[1] = 'right';
	              }
	            } else {
	              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
	              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
	                placement[1] = 'top';
	              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
	                placement[1] = 'bottom';
	              }
	            }
	          }
	        }
	
	        switch (placement[0]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top - targetHeight;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left - targetWidth;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width;
	            break;
	        }
	
	        switch (placement[1]) {
	          case 'top':
	            targetElemPos.top = hostElemPos.top;
	            break;
	          case 'bottom':
	            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
	            break;
	          case 'left':
	            targetElemPos.left = hostElemPos.left;
	            break;
	          case 'right':
	            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
	            break;
	          case 'center':
	            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
	            } else {
	              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
	            }
	            break;
	        }
	
	        targetElemPos.top = Math.round(targetElemPos.top);
	        targetElemPos.left = Math.round(targetElemPos.left);
	        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
	
	        return targetElemPos;
	      },
	
	      /**
	       * Provides a way to adjust the top positioning after first
	       * render to correctly align element to top after content
	       * rendering causes resized element height
	       *
	       * @param {array} placementClasses - The array of strings of classes
	       * element should have.
	       * @param {object} containerPosition - The object with container
	       * position information
	       * @param {number} initialHeight - The initial height for the elem.
	       * @param {number} currentHeight - The current height for the elem.
	       */
	      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
	        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
	          return {
	            top: containerPosition.top - currentHeight + 'px'
	          };
	        }
	      },
	
	      /**
	       * Provides a way for positioning tooltip & dropdown
	       * arrows when using placement options beyond the standard
	       * left, right, top, or bottom.
	       *
	       * @param {element} elem - The tooltip/dropdown element.
	       * @param {string} placement - The placement for the elem.
	       */
	      positionArrow: function(elem, placement) {
	        elem = this.getRawNode(elem);
	
	        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
	        if (!innerElem) {
	          return;
	        }
	
	        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
	
	        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
	        if (!arrowElem) {
	          return;
	        }
	
	        var arrowCss = {
	          top: '',
	          bottom: '',
	          left: '',
	          right: ''
	        };
	
	        placement = this.parsePlacement(placement);
	        if (placement[1] === 'center') {
	          // no adjustment necessary - just reset styles
	          angular.element(arrowElem).css(arrowCss);
	          return;
	        }
	
	        var borderProp = 'border-' + placement[0] + '-width';
	        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
	
	        var borderRadiusProp = 'border-';
	        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
	          borderRadiusProp += placement[0] + '-' + placement[1];
	        } else {
	          borderRadiusProp += placement[1] + '-' + placement[0];
	        }
	        borderRadiusProp += '-radius';
	        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
	
	        switch (placement[0]) {
	          case 'top':
	            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'bottom':
	            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'left':
	            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
	            break;
	          case 'right':
	            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
	            break;
	        }
	
	        arrowCss[placement[1]] = borderRadius;
	
	        angular.element(arrowElem).css(arrowCss);
	      }
	    };
	  }]);
	
	angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])
	
	.value('$datepickerPopupLiteralWarning', true)
	
	.constant('uibDatepickerPopupConfig', {
	  altInputFormats: [],
	  appendToBody: false,
	  clearText: 'Clear',
	  closeOnDateSelection: true,
	  closeText: 'Done',
	  currentText: 'Today',
	  datepickerPopup: 'yyyy-MM-dd',
	  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
	  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
	  html5Types: {
	    date: 'yyyy-MM-dd',
	    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
	    'month': 'yyyy-MM'
	  },
	  onOpenFocus: true,
	  showButtonBar: true,
	  placement: 'auto bottom-left'
	})
	
	.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
	function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
	  var cache = {},
	    isHtml5DateInput = false;
	  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
	    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
	    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];
	
	  this.init = function(_ngModel_) {
	    ngModel = _ngModel_;
	    ngModelOptions = extractOptions(ngModel);
	    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
	      $scope.$parent.$eval($attrs.closeOnDateSelection) :
	      datepickerPopupConfig.closeOnDateSelection;
	    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
	      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
	      datepickerPopupConfig.appendToBody;
	    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
	      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
	    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
	      $attrs.datepickerPopupTemplateUrl :
	      datepickerPopupConfig.datepickerPopupTemplateUrl;
	    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
	      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
	    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
	      $scope.$parent.$eval($attrs.altInputFormats) :
	      datepickerPopupConfig.altInputFormats;
	
	    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
	      $scope.$parent.$eval($attrs.showButtonBar) :
	      datepickerPopupConfig.showButtonBar;
	
	    if (datepickerPopupConfig.html5Types[$attrs.type]) {
	      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
	      isHtml5DateInput = true;
	    } else {
	      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
	      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
	        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
	        // Invalidate the $modelValue to ensure that formatters re-run
	        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
	        if (newDateFormat !== dateFormat) {
	          dateFormat = newDateFormat;
	          ngModel.$modelValue = null;
	
	          if (!dateFormat) {
	            throw new Error('uibDatepickerPopup must have a date format specified.');
	          }
	        }
	      });
	    }
	
	    if (!dateFormat) {
	      throw new Error('uibDatepickerPopup must have a date format specified.');
	    }
	
	    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
	      throw new Error('HTML5 date input types do not support custom formats.');
	    }
	
	    // popup element used to display calendar
	    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
	
	    popupEl.attr({
	      'ng-model': 'date',
	      'ng-change': 'dateSelection(date)',
	      'template-url': datepickerPopupTemplateUrl
	    });
	
	    // datepicker element
	    datepickerEl = angular.element(popupEl.children()[0]);
	    datepickerEl.attr('template-url', datepickerTemplateUrl);
	
	    if (!$scope.datepickerOptions) {
	      $scope.datepickerOptions = {};
	    }
	
	    if (isHtml5DateInput) {
	      if ($attrs.type === 'month') {
	        $scope.datepickerOptions.datepickerMode = 'month';
	        $scope.datepickerOptions.minMode = 'month';
	      }
	    }
	
	    datepickerEl.attr('datepicker-options', 'datepickerOptions');
	
	    if (!isHtml5DateInput) {
	      // Internal API to maintain the correct ng-invalid-[key] class
	      ngModel.$$parserName = 'date';
	      ngModel.$validators.date = validator;
	      ngModel.$parsers.unshift(parseDate);
	      ngModel.$formatters.push(function(value) {
	        if (ngModel.$isEmpty(value)) {
	          $scope.date = value;
	          return value;
	        }
	
	        if (angular.isNumber(value)) {
	          value = new Date(value);
	        }
	
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	
	        return dateParser.filter($scope.date, dateFormat);
	      });
	    } else {
	      ngModel.$formatters.push(function(value) {
	        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
	        return value;
	      });
	    }
	
	    // Detect changes in the view from the text box
	    ngModel.$viewChangeListeners.push(function() {
	      $scope.date = parseDateString(ngModel.$viewValue);
	    });
	
	    $element.on('keydown', inputKeydownBind);
	
	    $popup = $compile(popupEl)($scope);
	    // Prevent jQuery cache memory leak (template is now redundant after linking)
	    popupEl.remove();
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else {
	      $element.after($popup);
	    }
	
	    $scope.$on('$destroy', function() {
	      if ($scope.isOpen === true) {
	        if (!$rootScope.$$phase) {
	          $scope.$apply(function() {
	            $scope.isOpen = false;
	          });
	        }
	      }
	
	      $popup.remove();
	      $element.off('keydown', inputKeydownBind);
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	
	      //Clear all watch listeners on destroy
	      while (watchListeners.length) {
	        watchListeners.shift()();
	      }
	    });
	  };
	
	  $scope.getText = function(key) {
	    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
	  };
	
	  $scope.isDisabled = function(date) {
	    if (date === 'today') {
	      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
	    }
	
	    var dates = {};
	    angular.forEach(['minDate', 'maxDate'], function(key) {
	      if (!$scope.datepickerOptions[key]) {
	        dates[key] = null;
	      } else if (angular.isDate($scope.datepickerOptions[key])) {
	        dates[key] = new Date($scope.datepickerOptions[key]);
	      } else {
	        if ($datepickerPopupLiteralWarning) {
	          $log.warn('Literal date support has been deprecated, please switch to date object usage');
	        }
	
	        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
	      }
	    });
	
	    return $scope.datepickerOptions &&
	      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
	      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
	  };
	
	  $scope.compare = function(date1, date2) {
	    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	  };
	
	  // Inner change
	  $scope.dateSelection = function(dt) {
	    $scope.date = dt;
	    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
	    $element.val(date);
	    ngModel.$setViewValue(date);
	
	    if (closeOnDateSelection) {
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.keydown = function(evt) {
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      $scope.isOpen = false;
	      $element[0].focus();
	    }
	  };
	
	  $scope.select = function(date, evt) {
	    evt.stopPropagation();
	
	    if (date === 'today') {
	      var today = new Date();
	      if (angular.isDate($scope.date)) {
	        date = new Date($scope.date);
	        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
	      } else {
	        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
	        date.setHours(0, 0, 0, 0);
	      }
	    }
	    $scope.dateSelection(date);
	  };
	
	  $scope.close = function(evt) {
	    evt.stopPropagation();
	
	    $scope.isOpen = false;
	    $element[0].focus();
	  };
	
	  $scope.disabled = angular.isDefined($attrs.disabled) || false;
	  if ($attrs.ngDisabled) {
	    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
	      $scope.disabled = disabled;
	    }));
	  }
	
	  $scope.$watch('isOpen', function(value) {
	    if (value) {
	      if (!$scope.disabled) {
	        $timeout(function() {
	          positionPopup();
	
	          if (onOpenFocus) {
	            $scope.$broadcast('uib:datepicker.focus');
	          }
	
	          $document.on('click', documentClickBind);
	
	          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	          if (appendToBody || $position.parsePlacement(placement)[2]) {
	            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
	            if (scrollParentEl) {
	              scrollParentEl.on('scroll', positionPopup);
	            }
	          } else {
	            scrollParentEl = null;
	          }
	
	          angular.element($window).on('resize', positionPopup);
	        }, 0, false);
	      } else {
	        $scope.isOpen = false;
	      }
	    } else {
	      $document.off('click', documentClickBind);
	      if (scrollParentEl) {
	        scrollParentEl.off('scroll', positionPopup);
	      }
	      angular.element($window).off('resize', positionPopup);
	    }
	  });
	
	  function cameltoDash(string) {
	    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
	  }
	
	  function parseDateString(viewValue) {
	    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
	    if (isNaN(date)) {
	      for (var i = 0; i < altInputFormats.length; i++) {
	        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
	        if (!isNaN(date)) {
	          return date;
	        }
	      }
	    }
	    return date;
	  }
	
	  function parseDate(viewValue) {
	    if (angular.isNumber(viewValue)) {
	      // presumably timestamp to date object
	      viewValue = new Date(viewValue);
	    }
	
	    if (!viewValue) {
	      return null;
	    }
	
	    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
	      return viewValue;
	    }
	
	    if (angular.isString(viewValue)) {
	      var date = parseDateString(viewValue);
	      if (!isNaN(date)) {
	        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
	      }
	    }
	
	    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
	  }
	
	  function validator(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	
	    if (!$attrs.ngRequired && !value) {
	      return true;
	    }
	
	    if (angular.isNumber(value)) {
	      value = new Date(value);
	    }
	
	    if (!value) {
	      return true;
	    }
	
	    if (angular.isDate(value) && !isNaN(value)) {
	      return true;
	    }
	
	    if (angular.isString(value)) {
	      return !isNaN(parseDateString(value));
	    }
	
	    return false;
	  }
	
	  function documentClickBind(event) {
	    if (!$scope.isOpen && $scope.disabled) {
	      return;
	    }
	
	    var popup = $popup[0];
	    var dpContainsTarget = $element[0].contains(event.target);
	    // The popup node may not be an element node
	    // In some browsers (IE) only element nodes have the 'contains' function
	    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
	    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	    }
	  }
	
	  function inputKeydownBind(evt) {
	    if (evt.which === 27 && $scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = false;
	      });
	      $element[0].focus();
	    } else if (evt.which === 40 && !$scope.isOpen) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.$apply(function() {
	        $scope.isOpen = true;
	      });
	    }
	  }
	
	  function positionPopup() {
	    if ($scope.isOpen) {
	      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
	      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
	      var position = $position.positionElements($element, dpElement, placement, appendToBody);
	      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
	      if (dpElement.hasClass('uib-position-measure')) {
	        dpElement.removeClass('uib-position-measure');
	      }
	    }
	  }
	
	  function extractOptions(ngModelCtrl) {
	    var ngModelOptions;
	
	    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	      // guarantee a value
	      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
	        ngModelCtrl.$options :
	        {
	          timezone: null
	        };
	
	      // mimic 1.6+ api
	      ngModelOptions.getOption = function (key) {
	        return ngModelOptions[key];
	      };
	    } else { // in angular >=1.6 $options is always present
	      ngModelOptions = ngModelCtrl.$options;
	    }
	
	    return ngModelOptions;
	  }
	
	  $scope.$on('uib:datepicker.mode', function() {
	    $timeout(positionPopup, 0, false);
	  });
	}])
	
	.directive('uibDatepickerPopup', function() {
	  return {
	    require: ['ngModel', 'uibDatepickerPopup'],
	    controller: 'UibDatepickerPopupController',
	    scope: {
	      datepickerOptions: '=?',
	      isOpen: '=?',
	      currentText: '@',
	      clearText: '@',
	      closeText: '@'
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var ngModel = ctrls[0],
	        ctrl = ctrls[1];
	
	      ctrl.init(ngModel);
	    }
	  };
	})
	
	.directive('uibDatepickerPopupWrap', function() {
	  return {
	    restrict: 'A',
	    transclude: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
	    }
	  };
	});
	
	angular.module('ui.bootstrap.debounce', [])
	/**
	 * A helper, internal service that debounces a function
	 */
	  .factory('$$debounce', ['$timeout', function($timeout) {
	    return function(callback, debounceTime) {
	      var timeoutPromise;
	
	      return function() {
	        var self = this;
	        var args = Array.prototype.slice.call(arguments);
	        if (timeoutPromise) {
	          $timeout.cancel(timeoutPromise);
	        }
	
	        timeoutPromise = $timeout(function() {
	          callback.apply(self, args);
	        }, debounceTime);
	      };
	    };
	  }]);
	
	angular.module('ui.bootstrap.multiMap', [])
	/**
	 * A helper, internal data structure that stores all references attached to key
	 */
	  .factory('$$multiMap', function() {
	    return {
	      createNew: function() {
	        var map = {};
	
	        return {
	          entries: function() {
	            return Object.keys(map).map(function(key) {
	              return {
	                key: key,
	                value: map[key]
	              };
	            });
	          },
	          get: function(key) {
	            return map[key];
	          },
	          hasKey: function(key) {
	            return !!map[key];
	          },
	          keys: function() {
	            return Object.keys(map);
	          },
	          put: function(key, value) {
	            if (!map[key]) {
	              map[key] = [];
	            }
	
	            map[key].push(value);
	          },
	          remove: function(key, value) {
	            var values = map[key];
	
	            if (!values) {
	              return;
	            }
	
	            var idx = values.indexOf(value);
	
	            if (idx !== -1) {
	              values.splice(idx, 1);
	            }
	
	            if (!values.length) {
	              delete map[key];
	            }
	          }
	        };
	      }
	    };
	  });
	
	angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])
	
	.constant('uibDropdownConfig', {
	  appendToOpenClass: 'uib-dropdown-open',
	  openClass: 'open'
	})
	
	.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
	  var openScope = null;
	  var openedContainers = $$multiMap.createNew();
	
	  this.isOnlyOpen = function(dropdownScope, appendTo) {
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (openDropdown) {
	        return openedDropdowns.length === 1;
	      }
	    }
	
	    return false;
	  };
	
	  this.open = function(dropdownScope, element, appendTo) {
	    if (!openScope) {
	      $document.on('click', closeDropdown);
	    }
	
	    if (openScope && openScope !== dropdownScope) {
	      openScope.isOpen = false;
	    }
	
	    openScope = dropdownScope;
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var openedScopes = openedDropdowns.map(function(dropdown) {
	        return dropdown.scope;
	      });
	      if (openedScopes.indexOf(dropdownScope) === -1) {
	        openedContainers.put(appendTo, {
	          scope: dropdownScope
	        });
	      }
	    } else {
	      openedContainers.put(appendTo, {
	        scope: dropdownScope
	      });
	    }
	  };
	
	  this.close = function(dropdownScope, element, appendTo) {
	    if (openScope === dropdownScope) {
	      $document.off('click', closeDropdown);
	      $document.off('keydown', this.keybindFilter);
	      openScope = null;
	    }
	
	    if (!appendTo) {
	      return;
	    }
	
	    var openedDropdowns = openedContainers.get(appendTo);
	    if (openedDropdowns) {
	      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
	        if (dropdown.scope === dropdownScope) {
	          return dropdown;
	        }
	
	        return toClose;
	      }, {});
	      if (dropdownToClose) {
	        openedContainers.remove(appendTo, dropdownToClose);
	      }
	    }
	  };
	
	  var closeDropdown = function(evt) {
	    // This method may still be called during the same mouse event that
	    // unbound this event handler. So check openScope before proceeding.
	    if (!openScope || !openScope.isOpen) { return; }
	
	    if (evt && openScope.getAutoClose() === 'disabled') { return; }
	
	    if (evt && evt.which === 3) { return; }
	
	    var toggleElement = openScope.getToggleElement();
	    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    if (evt && openScope.getAutoClose() === 'outsideClick' &&
	      dropdownElement && dropdownElement[0].contains(evt.target)) {
	      return;
	    }
	
	    openScope.focusToggleElement();
	    openScope.isOpen = false;
	
	    if (!$rootScope.$$phase) {
	      openScope.$apply();
	    }
	  };
	
	  this.keybindFilter = function(evt) {
	    if (!openScope) {
	      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
	      return;
	    }
	
	    var dropdownElement = openScope.getDropdownElement();
	    var toggleElement = openScope.getToggleElement();
	    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
	    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
	    if (evt.which === 27) {
	      evt.stopPropagation();
	      openScope.focusToggleElement();
	      closeDropdown();
	    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      openScope.focusDropdownEntry(evt.which);
	    }
	  };
	}])
	
	.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
	  var self = this,
	    scope = $scope.$new(), // create a child scope so we are not polluting original one
	    templateScope,
	    appendToOpenClass = dropdownConfig.appendToOpenClass,
	    openClass = dropdownConfig.openClass,
	    getIsOpen,
	    setIsOpen = angular.noop,
	    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
	    keynavEnabled = false,
	    selectedOption = null,
	    body = $document.find('body');
	
	  $element.addClass('dropdown');
	
	  this.init = function() {
	    if ($attrs.isOpen) {
	      getIsOpen = $parse($attrs.isOpen);
	      setIsOpen = getIsOpen.assign;
	
	      $scope.$watch(getIsOpen, function(value) {
	        scope.isOpen = !!value;
	      });
	    }
	
	    keynavEnabled = angular.isDefined($attrs.keyboardNav);
	  };
	
	  this.toggle = function(open) {
	    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen(scope, scope.isOpen);
	    }
	
	    return scope.isOpen;
	  };
	
	  // Allow other directives to watch status
	  this.isOpen = function() {
	    return scope.isOpen;
	  };
	
	  scope.getToggleElement = function() {
	    return self.toggleElement;
	  };
	
	  scope.getAutoClose = function() {
	    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
	  };
	
	  scope.getElement = function() {
	    return $element;
	  };
	
	  scope.isKeynavEnabled = function() {
	    return keynavEnabled;
	  };
	
	  scope.focusDropdownEntry = function(keyCode) {
	    var elems = self.dropdownMenu ? //If append to body is used.
	      angular.element(self.dropdownMenu).find('a') :
	      $element.find('ul').eq(0).find('a');
	
	    switch (keyCode) {
	      case 40: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = 0;
	        } else {
	          self.selectedOption = self.selectedOption === elems.length - 1 ?
	            self.selectedOption :
	            self.selectedOption + 1;
	        }
	        break;
	      }
	      case 38: {
	        if (!angular.isNumber(self.selectedOption)) {
	          self.selectedOption = elems.length - 1;
	        } else {
	          self.selectedOption = self.selectedOption === 0 ?
	            0 : self.selectedOption - 1;
	        }
	        break;
	      }
	    }
	    elems[self.selectedOption].focus();
	  };
	
	  scope.getDropdownElement = function() {
	    return self.dropdownMenu;
	  };
	
	  scope.focusToggleElement = function() {
	    if (self.toggleElement) {
	      self.toggleElement[0].focus();
	    }
	  };
	
	  function removeDropdownMenu() {
	    $element.append(self.dropdownMenu);
	  }
	
	  scope.$watch('isOpen', function(isOpen, wasOpen) {
	    var appendTo = null,
	      appendToBody = false;
	
	    if (angular.isDefined($attrs.dropdownAppendTo)) {
	      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
	      if (appendToEl) {
	        appendTo = angular.element(appendToEl);
	      }
	    }
	
	    if (angular.isDefined($attrs.dropdownAppendToBody)) {
	      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
	      if (appendToBodyValue !== false) {
	        appendToBody = true;
	      }
	    }
	
	    if (appendToBody && !appendTo) {
	      appendTo = body;
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      if (isOpen) {
	        appendTo.append(self.dropdownMenu);
	        $element.on('$destroy', removeDropdownMenu);
	      } else {
	        $element.off('$destroy', removeDropdownMenu);
	        removeDropdownMenu();
	      }
	    }
	
	    if (appendTo && self.dropdownMenu) {
	      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
	        css,
	        rightalign,
	        scrollbarPadding,
	        scrollbarWidth = 0;
	
	      css = {
	        top: pos.top + 'px',
	        display: isOpen ? 'block' : 'none'
	      };
	
	      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
	      if (!rightalign) {
	        css.left = pos.left + 'px';
	        css.right = 'auto';
	      } else {
	        css.left = 'auto';
	        scrollbarPadding = $position.scrollbarPadding(appendTo);
	
	        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	          scrollbarWidth = scrollbarPadding.scrollbarWidth;
	        }
	
	        css.right = window.innerWidth - scrollbarWidth -
	          (pos.left + $element.prop('offsetWidth')) + 'px';
	      }
	
	      // Need to adjust our positioning to be relative to the appendTo container
	      // if it's not the body element
	      if (!appendToBody) {
	        var appendOffset = $position.offset(appendTo);
	
	        css.top = pos.top - appendOffset.top + 'px';
	
	        if (!rightalign) {
	          css.left = pos.left - appendOffset.left + 'px';
	        } else {
	          css.right = window.innerWidth -
	            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
	        }
	      }
	
	      self.dropdownMenu.css(css);
	    }
	
	    var openContainer = appendTo ? appendTo : $element;
	    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
	    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
	    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);
	
	    if (hasOpenClass === !isOpen) {
	      var toggleClass;
	      if (appendTo) {
	        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
	      } else {
	        toggleClass = isOpen ? 'addClass' : 'removeClass';
	      }
	      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
	        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
	          toggleInvoker($scope, { open: !!isOpen });
	        }
	      });
	    }
	
	    if (isOpen) {
	      if (self.dropdownMenuTemplateUrl) {
	        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
	          templateScope = scope.$new();
	          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
	            var newEl = dropdownElement;
	            self.dropdownMenu.replaceWith(newEl);
	            self.dropdownMenu = newEl;
	            $document.on('keydown', uibDropdownService.keybindFilter);
	          });
	        });
	      } else {
	        $document.on('keydown', uibDropdownService.keybindFilter);
	      }
	
	      scope.focusToggleElement();
	      uibDropdownService.open(scope, $element, appendTo);
	    } else {
	      uibDropdownService.close(scope, $element, appendTo);
	      if (self.dropdownMenuTemplateUrl) {
	        if (templateScope) {
	          templateScope.$destroy();
	        }
	        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
	        self.dropdownMenu.replaceWith(newEl);
	        self.dropdownMenu = newEl;
	      }
	
	      self.selectedOption = null;
	    }
	
	    if (angular.isFunction(setIsOpen)) {
	      setIsOpen($scope, isOpen);
	    }
	  });
	}])
	
	.directive('uibDropdown', function() {
	  return {
	    controller: 'UibDropdownController',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      dropdownCtrl.init();
	    }
	  };
	})
	
	.directive('uibDropdownMenu', function() {
	  return {
	    restrict: 'A',
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
	        return;
	      }
	
	      element.addClass('dropdown-menu');
	
	      var tplUrl = attrs.templateUrl;
	      if (tplUrl) {
	        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
	      }
	
	      if (!dropdownCtrl.dropdownMenu) {
	        dropdownCtrl.dropdownMenu = element;
	      }
	    }
	  };
	})
	
	.directive('uibDropdownToggle', function() {
	  return {
	    require: '?^uibDropdown',
	    link: function(scope, element, attrs, dropdownCtrl) {
	      if (!dropdownCtrl) {
	        return;
	      }
	
	      element.addClass('dropdown-toggle');
	
	      dropdownCtrl.toggleElement = element;
	
	      var toggleDropdown = function(event) {
	        event.preventDefault();
	
	        if (!element.hasClass('disabled') && !attrs.disabled) {
	          scope.$apply(function() {
	            dropdownCtrl.toggle();
	          });
	        }
	      };
	
	      element.on('click', toggleDropdown);
	
	      // WAI-ARIA
	      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
	      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
	        element.attr('aria-expanded', !!isOpen);
	      });
	
	      scope.$on('$destroy', function() {
	        element.off('click', toggleDropdown);
	      });
	    }
	  };
	});
	
	angular.module('ui.bootstrap.stackedMap', [])
	/**
	 * A helper, internal data structure that acts as a map but also allows getting / removing
	 * elements in the LIFO order
	 */
	  .factory('$$stackedMap', function() {
	    return {
	      createNew: function() {
	        var stack = [];
	
	        return {
	          add: function(key, value) {
	            stack.push({
	              key: key,
	              value: value
	            });
	          },
	          get: function(key) {
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                return stack[i];
	              }
	            }
	          },
	          keys: function() {
	            var keys = [];
	            for (var i = 0; i < stack.length; i++) {
	              keys.push(stack[i].key);
	            }
	            return keys;
	          },
	          top: function() {
	            return stack[stack.length - 1];
	          },
	          remove: function(key) {
	            var idx = -1;
	            for (var i = 0; i < stack.length; i++) {
	              if (key === stack[i].key) {
	                idx = i;
	                break;
	              }
	            }
	            return stack.splice(idx, 1)[0];
	          },
	          removeTop: function() {
	            return stack.pop();
	          },
	          length: function() {
	            return stack.length;
	          }
	        };
	      }
	    };
	  });
	angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
	/**
	 * Pluggable resolve mechanism for the modal resolve resolution
	 * Supports UI Router's $resolve service
	 */
	  .provider('$uibResolve', function() {
	    var resolve = this;
	    this.resolver = null;
	
	    this.setResolver = function(resolver) {
	      this.resolver = resolver;
	    };
	
	    this.$get = ['$injector', '$q', function($injector, $q) {
	      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
	      return {
	        resolve: function(invocables, locals, parent, self) {
	          if (resolver) {
	            return resolver.resolve(invocables, locals, parent, self);
	          }
	
	          var promises = [];
	
	          angular.forEach(invocables, function(value) {
	            if (angular.isFunction(value) || angular.isArray(value)) {
	              promises.push($q.resolve($injector.invoke(value)));
	            } else if (angular.isString(value)) {
	              promises.push($q.resolve($injector.get(value)));
	            } else {
	              promises.push($q.resolve(value));
	            }
	          });
	
	          return $q.all(promises).then(function(resolves) {
	            var resolveObj = {};
	            var resolveIter = 0;
	            angular.forEach(invocables, function(value, key) {
	              resolveObj[key] = resolves[resolveIter++];
	            });
	
	            return resolveObj;
	          });
	        }
	      };
	    }];
	  })
	
	/**
	 * A helper directive for the $modal service. It creates a backdrop element.
	 */
	  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
	  function($animate, $injector, $modalStack) {
	    return {
	      restrict: 'A',
	      compile: function(tElement, tAttrs) {
	        tElement.addClass(tAttrs.backdropClass);
	        return linkFn;
	      }
	    };
	
	    function linkFn(scope, element, attrs) {
	      if (attrs.modalInClass) {
	        $animate.addClass(element, attrs.modalInClass);
	
	        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	          var done = setIsAsync();
	          if (scope.modalOptions.animation) {
	            $animate.removeClass(element, attrs.modalInClass).then(done);
	          } else {
	            done();
	          }
	        });
	      }
	    }
	  }])
	
	  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
	  function($modalStack, $q, $animateCss, $document) {
	    return {
	      scope: {
	        index: '@'
	      },
	      restrict: 'A',
	      transclude: true,
	      templateUrl: function(tElement, tAttrs) {
	        return tAttrs.templateUrl || 'uib/template/modal/window.html';
	      },
	      link: function(scope, element, attrs) {
	        element.addClass(attrs.windowTopClass || '');
	        scope.size = attrs.size;
	
	        scope.close = function(evt) {
	          var modal = $modalStack.getTop();
	          if (modal && modal.value.backdrop &&
	            modal.value.backdrop !== 'static' &&
	            evt.target === evt.currentTarget) {
	            evt.preventDefault();
	            evt.stopPropagation();
	            $modalStack.dismiss(modal.key, 'backdrop click');
	          }
	        };
	
	        // moved from template to fix issue #2280
	        element.on('click', scope.close);
	
	        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
	        // We can detect that by using this property in the template associated with this directive and then use
	        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
	        scope.$isRendered = true;
	
	        // Deferred object that will be resolved when this modal is rendered.
	        var modalRenderDeferObj = $q.defer();
	        // Resolve render promise post-digest
	        scope.$$postDigest(function() {
	          modalRenderDeferObj.resolve();
	        });
	
	        modalRenderDeferObj.promise.then(function() {
	          var animationPromise = null;
	
	          if (attrs.modalInClass) {
	            animationPromise = $animateCss(element, {
	              addClass: attrs.modalInClass
	            }).start();
	
	            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
	              var done = setIsAsync();
	              $animateCss(element, {
	                removeClass: attrs.modalInClass
	              }).start().then(done);
	            });
	          }
	
	
	          $q.when(animationPromise).then(function() {
	            // Notify {@link $modalStack} that modal is rendered.
	            var modal = $modalStack.getTop();
	            if (modal) {
	              $modalStack.modalRendered(modal.key);
	            }
	
	            /**
	             * If something within the freshly-opened modal already has focus (perhaps via a
	             * directive that causes focus) then there's no need to try to focus anything.
	             */
	            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
	              var inputWithAutofocus = element[0].querySelector('[autofocus]');
	              /**
	               * Auto-focusing of a freshly-opened modal element causes any child elements
	               * with the autofocus attribute to lose focus. This is an issue on touch
	               * based devices which will show and then hide the onscreen keyboard.
	               * Attempts to refocus the autofocus element via JavaScript will not reopen
	               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
	               * the modal element if the modal does not contain an autofocus element.
	               */
	              if (inputWithAutofocus) {
	                inputWithAutofocus.focus();
	              } else {
	                element[0].focus();
	              }
	            }
	          });
	        });
	      }
	    };
	  }])
	
	  .directive('uibModalAnimationClass', function() {
	    return {
	      compile: function(tElement, tAttrs) {
	        if (tAttrs.modalAnimation) {
	          tElement.addClass(tAttrs.uibModalAnimationClass);
	        }
	      }
	    };
	  })
	
	  .directive('uibModalTransclude', ['$animate', function($animate) {
	    return {
	      link: function(scope, element, attrs, controller, transclude) {
	        transclude(scope.$parent, function(clone) {
	          element.empty();
	          $animate.enter(clone, element);
	        });
	      }
	    };
	  }])
	
	  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
	    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
	    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
	      var OPENED_MODAL_CLASS = 'modal-open';
	
	      var backdropDomEl, backdropScope;
	      var openedWindows = $$stackedMap.createNew();
	      var openedClasses = $$multiMap.createNew();
	      var $modalStack = {
	        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
	      };
	      var topModalIndex = 0;
	      var previousTopOpenedModal = null;
	      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';
	
	      //Modal focus behavior
	      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
	        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
	        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
	      var scrollbarPadding;
	      var SNAKE_CASE_REGEXP = /[A-Z]/g;
	
	      // TODO: extract into common dependency with tooltip
	      function snake_case(name) {
	        var separator = '-';
	        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	          return (pos ? separator : '') + letter.toLowerCase();
	        });
	      }
	
	      function isVisible(element) {
	        return !!(element.offsetWidth ||
	          element.offsetHeight ||
	          element.getClientRects().length);
	      }
	
	      function backdropIndex() {
	        var topBackdropIndex = -1;
	        var opened = openedWindows.keys();
	        for (var i = 0; i < opened.length; i++) {
	          if (openedWindows.get(opened[i]).value.backdrop) {
	            topBackdropIndex = i;
	          }
	        }
	
	        // If any backdrop exist, ensure that it's index is always
	        // right below the top modal
	        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
	          topBackdropIndex = topModalIndex;
	        }
	        return topBackdropIndex;
	      }
	
	      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
	        if (backdropScope) {
	          backdropScope.index = newBackdropIndex;
	        }
	      });
	
	      function removeModalWindow(modalInstance, elementToReceiveFocus) {
	        var modalWindow = openedWindows.get(modalInstance).value;
	        var appendToElement = modalWindow.appendTo;
	
	        //clean up the stack
	        openedWindows.remove(modalInstance);
	        previousTopOpenedModal = openedWindows.top();
	        if (previousTopOpenedModal) {
	          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
	        }
	
	        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
	          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
	          openedClasses.remove(modalBodyClass, modalInstance);
	          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
	          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
	          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	            if (scrollbarPadding.originalRight) {
	              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
	            } else {
	              appendToElement.css({paddingRight: ''});
	            }
	            scrollbarPadding = null;
	          }
	          toggleTopWindowClass(true);
	        }, modalWindow.closedDeferred);
	        checkRemoveBackdrop();
	
	        //move focus to specified element if available, or else to body
	        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
	          elementToReceiveFocus.focus();
	        } else if (appendToElement.focus) {
	          appendToElement.focus();
	        }
	      }
	
	      // Add or remove "windowTopClass" from the top window in the stack
	      function toggleTopWindowClass(toggleSwitch) {
	        var modalWindow;
	
	        if (openedWindows.length() > 0) {
	          modalWindow = openedWindows.top().value;
	          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
	        }
	      }
	
	      function checkRemoveBackdrop() {
	        //remove backdrop if no longer needed
	        if (backdropDomEl && backdropIndex() === -1) {
	          var backdropScopeRef = backdropScope;
	          removeAfterAnimate(backdropDomEl, backdropScope, function() {
	            backdropScopeRef = null;
	          });
	          backdropDomEl = undefined;
	          backdropScope = undefined;
	        }
	      }
	
	      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
	        var asyncDeferred;
	        var asyncPromise = null;
	        var setIsAsync = function() {
	          if (!asyncDeferred) {
	            asyncDeferred = $q.defer();
	            asyncPromise = asyncDeferred.promise;
	          }
	
	          return function asyncDone() {
	            asyncDeferred.resolve();
	          };
	        };
	        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);
	
	        // Note that it's intentional that asyncPromise might be null.
	        // That's when setIsAsync has not been called during the
	        // NOW_CLOSING_EVENT broadcast.
	        return $q.when(asyncPromise).then(afterAnimating);
	
	        function afterAnimating() {
	          if (afterAnimating.done) {
	            return;
	          }
	          afterAnimating.done = true;
	
	          $animate.leave(domEl).then(function() {
	            if (done) {
	              done();
	            }
	
	            domEl.remove();
	            if (closedDeferred) {
	              closedDeferred.resolve();
	            }
	          });
	
	          scope.$destroy();
	        }
	      }
	
	      $document.on('keydown', keydownListener);
	
	      $rootScope.$on('$destroy', function() {
	        $document.off('keydown', keydownListener);
	      });
	
	      function keydownListener(evt) {
	        if (evt.isDefaultPrevented()) {
	          return evt;
	        }
	
	        var modal = openedWindows.top();
	        if (modal) {
	          switch (evt.which) {
	            case 27: {
	              if (modal.value.keyboard) {
	                evt.preventDefault();
	                $rootScope.$apply(function() {
	                  $modalStack.dismiss(modal.key, 'escape key press');
	                });
	              }
	              break;
	            }
	            case 9: {
	              var list = $modalStack.loadFocusElementList(modal);
	              var focusChanged = false;
	              if (evt.shiftKey) {
	                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
	                  focusChanged = $modalStack.focusLastFocusableElement(list);
	                }
	              } else {
	                if ($modalStack.isFocusInLastItem(evt, list)) {
	                  focusChanged = $modalStack.focusFirstFocusableElement(list);
	                }
	              }
	
	              if (focusChanged) {
	                evt.preventDefault();
	                evt.stopPropagation();
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      $modalStack.open = function(modalInstance, modal) {
	        var modalOpener = $document[0].activeElement,
	          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
	
	        toggleTopWindowClass(false);
	
	        // Store the current top first, to determine what index we ought to use
	        // for the current top modal
	        previousTopOpenedModal = openedWindows.top();
	
	        openedWindows.add(modalInstance, {
	          deferred: modal.deferred,
	          renderDeferred: modal.renderDeferred,
	          closedDeferred: modal.closedDeferred,
	          modalScope: modal.scope,
	          backdrop: modal.backdrop,
	          keyboard: modal.keyboard,
	          openedClass: modal.openedClass,
	          windowTopClass: modal.windowTopClass,
	          animation: modal.animation,
	          appendTo: modal.appendTo
	        });
	
	        openedClasses.put(modalBodyClass, modalInstance);
	
	        var appendToElement = modal.appendTo,
	            currBackdropIndex = backdropIndex();
	
	        if (currBackdropIndex >= 0 && !backdropDomEl) {
	          backdropScope = $rootScope.$new(true);
	          backdropScope.modalOptions = modal;
	          backdropScope.index = currBackdropIndex;
	          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
	          backdropDomEl.attr({
	            'class': 'modal-backdrop',
	            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
	            'uib-modal-animation-class': 'fade',
	            'modal-in-class': 'in'
	          });
	          if (modal.backdropClass) {
	            backdropDomEl.addClass(modal.backdropClass);
	          }
	
	          if (modal.animation) {
	            backdropDomEl.attr('modal-animation', 'true');
	          }
	          $compile(backdropDomEl)(backdropScope);
	          $animate.enter(backdropDomEl, appendToElement);
	          if ($uibPosition.isScrollable(appendToElement)) {
	            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
	            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
	              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
	            }
	          }
	        }
	
	        var content;
	        if (modal.component) {
	          content = document.createElement(snake_case(modal.component.name));
	          content = angular.element(content);
	          content.attr({
	            resolve: '$resolve',
	            'modal-instance': '$uibModalInstance',
	            close: '$close($value)',
	            dismiss: '$dismiss($value)'
	          });
	        } else {
	          content = modal.content;
	        }
	
	        // Set the top modal index based on the index of the previous top modal
	        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
	        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
	        angularDomEl.attr({
	          'class': 'modal',
	          'template-url': modal.windowTemplateUrl,
	          'window-top-class': modal.windowTopClass,
	          'role': 'dialog',
	          'aria-labelledby': modal.ariaLabelledBy,
	          'aria-describedby': modal.ariaDescribedBy,
	          'size': modal.size,
	          'index': topModalIndex,
	          'animate': 'animate',
	          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
	          'tabindex': -1,
	          'uib-modal-animation-class': 'fade',
	          'modal-in-class': 'in'
	        }).append(content);
	        if (modal.windowClass) {
	          angularDomEl.addClass(modal.windowClass);
	        }
	
	        if (modal.animation) {
	          angularDomEl.attr('modal-animation', 'true');
	        }
	
	        appendToElement.addClass(modalBodyClass);
	        if (modal.scope) {
	          // we need to explicitly add the modal index to the modal scope
	          // because it is needed by ngStyle to compute the zIndex property.
	          modal.scope.$$topModalIndex = topModalIndex;
	        }
	        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);
	
	        openedWindows.top().value.modalDomEl = angularDomEl;
	        openedWindows.top().value.modalOpener = modalOpener;
	
	        applyAriaHidden(angularDomEl);
	
	        function applyAriaHidden(el) {
	          if (!el || el[0].tagName === 'BODY') {
	            return;
	          }
	
	          getSiblings(el).forEach(function(sibling) {
	            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
	              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);
	
	            if (!ariaHiddenCount) {
	              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
	            }
	
	            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
	            sibling.setAttribute('aria-hidden', 'true');
	          });
	
	          return applyAriaHidden(el.parent());
	
	          function getSiblings(el) {
	            var children = el.parent() ? el.parent().children() : [];
	
	            return Array.prototype.filter.call(children, function(child) {
	              return child !== el[0];
	            });
	          }
	        }
	      };
	
	      function broadcastClosing(modalWindow, resultOrReason, closing) {
	        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
	      }
	
	      function unhideBackgroundElements() {
	        Array.prototype.forEach.call(
	          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
	          function(hiddenEl) {
	            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
	              newHiddenCount = ariaHiddenCount - 1;
	            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);
	
	            if (!newHiddenCount) {
	              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
	              hiddenEl.removeAttribute('aria-hidden');
	            }
	          }
	        );
	      }
	
	      $modalStack.close = function(modalInstance, result) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.resolve(result);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	
	        return !modalWindow;
	      };
	
	      $modalStack.dismiss = function(modalInstance, reason) {
	        var modalWindow = openedWindows.get(modalInstance);
	        unhideBackgroundElements();
	        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
	          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
	          modalWindow.value.deferred.reject(reason);
	          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
	          return true;
	        }
	        return !modalWindow;
	      };
	
	      $modalStack.dismissAll = function(reason) {
	        var topModal = this.getTop();
	        while (topModal && this.dismiss(topModal.key, reason)) {
	          topModal = this.getTop();
	        }
	      };
	
	      $modalStack.getTop = function() {
	        return openedWindows.top();
	      };
	
	      $modalStack.modalRendered = function(modalInstance) {
	        var modalWindow = openedWindows.get(modalInstance);
	        if (modalWindow) {
	          modalWindow.value.renderDeferred.resolve();
	        }
	      };
	
	      $modalStack.focusFirstFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[0].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.focusLastFocusableElement = function(list) {
	        if (list.length > 0) {
	          list[list.length - 1].focus();
	          return true;
	        }
	        return false;
	      };
	
	      $modalStack.isModalFocused = function(evt, modalWindow) {
	        if (evt && modalWindow) {
	          var modalDomEl = modalWindow.value.modalDomEl;
	          if (modalDomEl && modalDomEl.length) {
	            return (evt.target || evt.srcElement) === modalDomEl[0];
	          }
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInFirstItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[0];
	        }
	        return false;
	      };
	
	      $modalStack.isFocusInLastItem = function(evt, list) {
	        if (list.length > 0) {
	          return (evt.target || evt.srcElement) === list[list.length - 1];
	        }
	        return false;
	      };
	
	      $modalStack.loadFocusElementList = function(modalWindow) {
	        if (modalWindow) {
	          var modalDomE1 = modalWindow.value.modalDomEl;
	          if (modalDomE1 && modalDomE1.length) {
	            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
	            return elements ?
	              Array.prototype.filter.call(elements, function(element) {
	                return isVisible(element);
	              }) : elements;
	          }
	        }
	      };
	
	      return $modalStack;
	    }])
	
	  .provider('$uibModal', function() {
	    var $modalProvider = {
	      options: {
	        animation: true,
	        backdrop: true, //can also be false or 'static'
	        keyboard: true
	      },
	      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
	        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
	          var $modal = {};
	
	          function getTemplatePromise(options) {
	            return options.template ? $q.when(options.template) :
	              $templateRequest(angular.isFunction(options.templateUrl) ?
	                options.templateUrl() : options.templateUrl);
	          }
	
	          var promiseChain = null;
	          $modal.getPromiseChain = function() {
	            return promiseChain;
	          };
	
	          $modal.open = function(modalOptions) {
	            var modalResultDeferred = $q.defer();
	            var modalOpenedDeferred = $q.defer();
	            var modalClosedDeferred = $q.defer();
	            var modalRenderDeferred = $q.defer();
	
	            //prepare an instance of a modal to be injected into controllers and returned to a caller
	            var modalInstance = {
	              result: modalResultDeferred.promise,
	              opened: modalOpenedDeferred.promise,
	              closed: modalClosedDeferred.promise,
	              rendered: modalRenderDeferred.promise,
	              close: function (result) {
	                return $modalStack.close(modalInstance, result);
	              },
	              dismiss: function (reason) {
	                return $modalStack.dismiss(modalInstance, reason);
	              }
	            };
	
	            //merge and clean up options
	            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
	            modalOptions.resolve = modalOptions.resolve || {};
	            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);
	
	            if (!modalOptions.appendTo.length) {
	              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
	            }
	
	            //verify options
	            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
	              throw new Error('One of component or template or templateUrl options is required.');
	            }
	
	            var templateAndResolvePromise;
	            if (modalOptions.component) {
	              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
	            } else {
	              templateAndResolvePromise =
	                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
	            }
	
	            function resolveWithTemplate() {
	              return templateAndResolvePromise;
	            }
	
	            // Wait for the resolution of the existing promise chain.
	            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
	            // Then add to $modalStack and resolve opened.
	            // Finally clean up the chain variable if no subsequent modal has overwritten it.
	            var samePromise;
	            samePromise = promiseChain = $q.all([promiseChain])
	              .then(resolveWithTemplate, resolveWithTemplate)
	              .then(function resolveSuccess(tplAndVars) {
	                var providedScope = modalOptions.scope || $rootScope;
	
	                var modalScope = providedScope.$new();
	                modalScope.$close = modalInstance.close;
	                modalScope.$dismiss = modalInstance.dismiss;
	
	                modalScope.$on('$destroy', function() {
	                  if (!modalScope.$$uibDestructionScheduled) {
	                    modalScope.$dismiss('$uibUnscheduledDestruction');
	                  }
	                });
	
	                var modal = {
	                  scope: modalScope,
	                  deferred: modalResultDeferred,
	                  renderDeferred: modalRenderDeferred,
	                  closedDeferred: modalClosedDeferred,
	                  animation: modalOptions.animation,
	                  backdrop: modalOptions.backdrop,
	                  keyboard: modalOptions.keyboard,
	                  backdropClass: modalOptions.backdropClass,
	                  windowTopClass: modalOptions.windowTopClass,
	                  windowClass: modalOptions.windowClass,
	                  windowTemplateUrl: modalOptions.windowTemplateUrl,
	                  ariaLabelledBy: modalOptions.ariaLabelledBy,
	                  ariaDescribedBy: modalOptions.ariaDescribedBy,
	                  size: modalOptions.size,
	                  openedClass: modalOptions.openedClass,
	                  appendTo: modalOptions.appendTo
	                };
	
	                var component = {};
	                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};
	
	                if (modalOptions.component) {
	                  constructLocals(component, false, true, false);
	                  component.name = modalOptions.component;
	                  modal.component = component;
	                } else if (modalOptions.controller) {
	                  constructLocals(ctrlLocals, true, false, true);
	
	                  // the third param will make the controller instantiate later,private api
	                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
	                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
	                  if (modalOptions.controllerAs && modalOptions.bindToController) {
	                    ctrlInstance = ctrlInstantiate.instance;
	                    ctrlInstance.$close = modalScope.$close;
	                    ctrlInstance.$dismiss = modalScope.$dismiss;
	                    angular.extend(ctrlInstance, {
	                      $resolve: ctrlLocals.$scope.$resolve
	                    }, providedScope);
	                  }
	
	                  ctrlInstance = ctrlInstantiate();
	
	                  if (angular.isFunction(ctrlInstance.$onInit)) {
	                    ctrlInstance.$onInit();
	                  }
	                }
	
	                if (!modalOptions.component) {
	                  modal.content = tplAndVars[0];
	                }
	
	                $modalStack.open(modalInstance, modal);
	                modalOpenedDeferred.resolve(true);
	
	                function constructLocals(obj, template, instanceOnScope, injectable) {
	                  obj.$scope = modalScope;
	                  obj.$scope.$resolve = {};
	                  if (instanceOnScope) {
	                    obj.$scope.$uibModalInstance = modalInstance;
	                  } else {
	                    obj.$uibModalInstance = modalInstance;
	                  }
	
	                  var resolves = template ? tplAndVars[1] : tplAndVars;
	                  angular.forEach(resolves, function(value, key) {
	                    if (injectable) {
	                      obj[key] = value;
	                    }
	
	                    obj.$scope.$resolve[key] = value;
	                  });
	                }
	            }, function resolveError(reason) {
	              modalOpenedDeferred.reject(reason);
	              modalResultDeferred.reject(reason);
	            })['finally'](function() {
	              if (promiseChain === samePromise) {
	                promiseChain = null;
	              }
	            });
	
	            return modalInstance;
	          };
	
	          return $modal;
	        }
	      ]
	    };
	
	    return $modalProvider;
	  });
	
	angular.module('ui.bootstrap.paging', [])
	/**
	 * Helper internal service for generating common controller code between the
	 * pager and pagination components
	 */
	.factory('uibPaging', ['$parse', function($parse) {
	  return {
	    create: function(ctrl, $scope, $attrs) {
	      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
	      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
	      ctrl._watchers = [];
	
	      ctrl.init = function(ngModelCtrl, config) {
	        ctrl.ngModelCtrl = ngModelCtrl;
	        ctrl.config = config;
	
	        ngModelCtrl.$render = function() {
	          ctrl.render();
	        };
	
	        if ($attrs.itemsPerPage) {
	          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
	            ctrl.itemsPerPage = parseInt(value, 10);
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }));
	        } else {
	          ctrl.itemsPerPage = config.itemsPerPage;
	        }
	
	        $scope.$watch('totalItems', function(newTotal, oldTotal) {
	          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
	            $scope.totalPages = ctrl.calculateTotalPages();
	            ctrl.updatePage();
	          }
	        });
	      };
	
	      ctrl.calculateTotalPages = function() {
	        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	      };
	
	      ctrl.render = function() {
	        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
	      };
	
	      $scope.selectPage = function(page, evt) {
	        if (evt) {
	          evt.preventDefault();
	        }
	
	        var clickAllowed = !$scope.ngDisabled || !evt;
	        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
	          if (evt && evt.target) {
	            evt.target.blur();
	          }
	          ctrl.ngModelCtrl.$setViewValue(page);
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.getText = function(key) {
	        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
	      };
	
	      $scope.noPrevious = function() {
	        return $scope.page === 1;
	      };
	
	      $scope.noNext = function() {
	        return $scope.page === $scope.totalPages;
	      };
	
	      ctrl.updatePage = function() {
	        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable
	
	        if ($scope.page > $scope.totalPages) {
	          $scope.selectPage($scope.totalPages);
	        } else {
	          ctrl.ngModelCtrl.$render();
	        }
	      };
	
	      $scope.$on('$destroy', function() {
	        while (ctrl._watchers.length) {
	          ctrl._watchers.shift()();
	        }
	      });
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	
	.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
	  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
	
	  uibPaging.create(this, $scope, $attrs);
	}])
	
	.constant('uibPagerConfig', {
	  itemsPerPage: 10,
	  previousText: '« Previous',
	  nextText: 'Next »',
	  align: true
	})
	
	.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      previousText: '@',
	      nextText: '@',
	      ngDisabled: '='
	    },
	    require: ['uibPager', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPagerController',
	    controllerAs: 'pager',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pager/pager.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pager');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	        return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
	.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
	  var ctrl = this;
	  // Setup configuration parameters
	  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
	    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
	    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
	    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
	    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
	  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
	  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
	  $attrs.$set('role', 'menu');
	
	  uibPaging.create(this, $scope, $attrs);
	
	  if ($attrs.maxSize) {
	    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
	      maxSize = parseInt(value, 10);
	      ctrl.render();
	    }));
	  }
	
	  // Create page object used in template
	  function makePage(number, text, isActive) {
	    return {
	      number: number,
	      text: text,
	      active: isActive
	    };
	  }
	
	  function getPages(currentPage, totalPages) {
	    var pages = [];
	
	    // Default page limits
	    var startPage = 1, endPage = totalPages;
	    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;
	
	    // recompute if maxSize
	    if (isMaxSized) {
	      if (rotate) {
	        // Current page is displayed in the middle of the visible ones
	        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
	        endPage = startPage + maxSize - 1;
	
	        // Adjust if limit is exceeded
	        if (endPage > totalPages) {
	          endPage = totalPages;
	          startPage = endPage - maxSize + 1;
	        }
	      } else {
	        // Visible pages are paginated with maxSize
	        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;
	
	        // Adjust last page if limit is exceeded
	        endPage = Math.min(startPage + maxSize - 1, totalPages);
	      }
	    }
	
	    // Add page number links
	    for (var number = startPage; number <= endPage; number++) {
	      var page = makePage(number, pageLabel(number), number === currentPage);
	      pages.push(page);
	    }
	
	    // Add links to move between page sets
	    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
	      if (startPage > 1) {
	        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
	        var previousPageSet = makePage(startPage - 1, '...', false);
	        pages.unshift(previousPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
	            var secondPageLink = makePage(2, '2', false);
	            pages.unshift(secondPageLink);
	          }
	          //add the first page
	          var firstPageLink = makePage(1, '1', false);
	          pages.unshift(firstPageLink);
	        }
	      }
	
	      if (endPage < totalPages) {
	        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
	        var nextPageSet = makePage(endPage + 1, '...', false);
	        pages.push(nextPageSet);
	      }
	        if (boundaryLinkNumbers) {
	          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
	            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
	            pages.push(secondToLastPageLink);
	          }
	          //add the last page
	          var lastPageLink = makePage(totalPages, totalPages, false);
	          pages.push(lastPageLink);
	        }
	      }
	    }
	    return pages;
	  }
	
	  var originalRender = this.render;
	  this.render = function() {
	    originalRender();
	    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
	      $scope.pages = getPages($scope.page, $scope.totalPages);
	    }
	  };
	}])
	
	.constant('uibPaginationConfig', {
	  itemsPerPage: 10,
	  boundaryLinks: false,
	  boundaryLinkNumbers: false,
	  directionLinks: true,
	  firstText: 'First',
	  previousText: 'Previous',
	  nextText: 'Next',
	  lastText: 'Last',
	  rotate: true,
	  forceEllipses: false
	})
	
	.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
	  return {
	    scope: {
	      totalItems: '=',
	      firstText: '@',
	      previousText: '@',
	      nextText: '@',
	      lastText: '@',
	      ngDisabled:'='
	    },
	    require: ['uibPagination', '?ngModel'],
	    restrict: 'A',
	    controller: 'UibPaginationController',
	    controllerAs: 'pagination',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
	    },
	    link: function(scope, element, attrs, ctrls) {
	      element.addClass('pagination');
	      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (!ngModelCtrl) {
	         return; // do nothing if no ng-model
	      }
	
	      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
	    }
	  };
	}]);
	
	/**
	 * The following features are still outstanding: animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, html tooltips, and selector delegation.
	 */
	angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])
	
	/**
	 * The $tooltip service creates tooltip- and popover-like directives as well as
	 * houses global options for them.
	 */
	.provider('$uibTooltip', function() {
	  // The default options tooltip and popover.
	  var defaultOptions = {
	    placement: 'top',
	    placementClassPrefix: '',
	    animation: true,
	    popupDelay: 0,
	    popupCloseDelay: 0,
	    useContentExp: false
	  };
	
	  // Default hide triggers for each show trigger
	  var triggerMap = {
	    'mouseenter': 'mouseleave',
	    'click': 'click',
	    'outsideClick': 'outsideClick',
	    'focus': 'blur',
	    'none': ''
	  };
	
	  // The options specified to the provider globally.
	  var globalOptions = {};
	
	  /**
	   * `options({})` allows global configuration of all tooltips in the
	   * application.
	   *
	   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
	   *     // place tooltips left instead of top by default
	   *     $tooltipProvider.options( { placement: 'left' } );
	   *   });
	   */
		this.options = function(value) {
			angular.extend(globalOptions, value);
		};
	
	  /**
	   * This allows you to extend the set of trigger mappings available. E.g.:
	   *
	   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
	   */
	  this.setTriggers = function setTriggers(triggers) {
	    angular.extend(triggerMap, triggers);
	  };
	
	  /**
	   * This is a helper function for translating camel-case to snake_case.
	   */
	  function snake_case(name) {
	    var regexp = /[A-Z]/g;
	    var separator = '-';
	    return name.replace(regexp, function(letter, pos) {
	      return (pos ? separator : '') + letter.toLowerCase();
	    });
	  }
	
	  /**
	   * Returns the actual instance of the $tooltip service.
	   * TODO support multiple triggers
	   */
	  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
	    var openedTooltips = $$stackedMap.createNew();
	    $document.on('keyup', keypressListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('keyup', keypressListener);
	    });
	
	    function keypressListener(e) {
	      if (e.which === 27) {
	        var last = openedTooltips.top();
	        if (last) {
	          last.value.close();
	          last = null;
	        }
	      }
	    }
	
	    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
	      options = angular.extend({}, defaultOptions, globalOptions, options);
	
	      /**
	       * Returns an object of show and hide triggers.
	       *
	       * If a trigger is supplied,
	       * it is used to show the tooltip; otherwise, it will use the `trigger`
	       * option passed to the `$tooltipProvider.options` method; else it will
	       * default to the trigger supplied to this directive factory.
	       *
	       * The hide trigger is based on the show trigger. If the `trigger` option
	       * was passed to the `$tooltipProvider.options` method, it will use the
	       * mapped trigger from `triggerMap` or the passed trigger if the map is
	       * undefined; otherwise, it uses the `triggerMap` value of the show
	       * trigger; else it will just use the show trigger.
	       */
	      function getTriggers(trigger) {
	        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
	        var hide = show.map(function(trigger) {
	          return triggerMap[trigger] || trigger;
	        });
	        return {
	          show: show,
	          hide: hide
	        };
	      }
	
	      var directiveName = snake_case(ttType);
	
	      var startSym = $interpolate.startSymbol();
	      var endSym = $interpolate.endSymbol();
	      var template =
	        '<div '+ directiveName + '-popup ' +
	          'uib-title="' + startSym + 'title' + endSym + '" ' +
	          (options.useContentExp ?
	            'content-exp="contentExp()" ' :
	            'content="' + startSym + 'content' + endSym + '" ') +
	          'origin-scope="origScope" ' +
	          'class="uib-position-measure ' + prefix + '" ' +
	          'tooltip-animation-class="fade"' +
	          'uib-tooltip-classes ' +
	          'ng-class="{ in: isOpen }" ' +
	          '>' +
	        '</div>';
	
	      return {
	        compile: function(tElem, tAttrs) {
	          var tooltipLinker = $compile(template);
	
	          return function link(scope, element, attrs, tooltipCtrl) {
	            var tooltip;
	            var tooltipLinkedScope;
	            var transitionTimeout;
	            var showTimeout;
	            var hideTimeout;
	            var positionTimeout;
	            var adjustmentTimeout;
	            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
	            var triggers = getTriggers(undefined);
	            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
	            var ttScope = scope.$new(true);
	            var repositionScheduled = false;
	            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
	            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
	            var observers = [];
	            var lastPlacement;
	
	            var positionTooltip = function() {
	              // check if tooltip exists and is not empty
	              if (!tooltip || !tooltip.html()) { return; }
	
	              if (!positionTimeout) {
	                positionTimeout = $timeout(function() {
	                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
	                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
	                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
	                  var placementClasses = ttPosition.placement.split('-');
	
	                  if (!tooltip.hasClass(placementClasses[0])) {
	                    tooltip.removeClass(lastPlacement.split('-')[0]);
	                    tooltip.addClass(placementClasses[0]);
	                  }
	
	                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
	                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
	                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
	                  }
	
	                  adjustmentTimeout = $timeout(function() {
	                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
	                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
	                    if (adjustment) {
	                      tooltip.css(adjustment);
	                    }
	                    adjustmentTimeout = null;
	                  }, 0, false);
	
	                  // first time through tt element will have the
	                  // uib-position-measure class or if the placement
	                  // has changed we need to position the arrow.
	                  if (tooltip.hasClass('uib-position-measure')) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                    tooltip.removeClass('uib-position-measure');
	                  } else if (lastPlacement !== ttPosition.placement) {
	                    $position.positionArrow(tooltip, ttPosition.placement);
	                  }
	                  lastPlacement = ttPosition.placement;
	
	                  positionTimeout = null;
	                }, 0, false);
	              }
	            };
	
	            // Set up the correct scope to allow transclusion later
	            ttScope.origScope = scope;
	
	            // By default, the tooltip is not open.
	            // TODO add ability to start tooltip opened
	            ttScope.isOpen = false;
	
	            function toggleTooltipBind() {
	              if (!ttScope.isOpen) {
	                showTooltipBind();
	              } else {
	                hideTooltipBind();
	              }
	            }
	
	            // Show the tooltip with delay if specified, otherwise show it immediately
	            function showTooltipBind() {
	              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
	                return;
	              }
	
	              cancelHide();
	              prepareTooltip();
	
	              if (ttScope.popupDelay) {
	                // Do nothing if the tooltip was already scheduled to pop-up.
	                // This happens if show is triggered multiple times before any hide is triggered.
	                if (!showTimeout) {
	                  showTimeout = $timeout(show, ttScope.popupDelay, false);
	                }
	              } else {
	                show();
	              }
	            }
	
	            function hideTooltipBind() {
	              cancelShow();
	
	              if (ttScope.popupCloseDelay) {
	                if (!hideTimeout) {
	                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
	                }
	              } else {
	                hide();
	              }
	            }
	
	            // Show the tooltip popup element.
	            function show() {
	              cancelShow();
	              cancelHide();
	
	              // Don't show empty tooltips.
	              if (!ttScope.content) {
	                return angular.noop;
	              }
	
	              createTooltip();
	
	              // And show the tooltip.
	              ttScope.$evalAsync(function() {
	                ttScope.isOpen = true;
	                assignIsOpen(true);
	                positionTooltip();
	              });
	            }
	
	            function cancelShow() {
	              if (showTimeout) {
	                $timeout.cancel(showTimeout);
	                showTimeout = null;
	              }
	
	              if (positionTimeout) {
	                $timeout.cancel(positionTimeout);
	                positionTimeout = null;
	              }
	            }
	
	            // Hide the tooltip popup element.
	            function hide() {
	              if (!ttScope) {
	                return;
	              }
	
	              // First things first: we don't show it anymore.
	              ttScope.$evalAsync(function() {
	                if (ttScope) {
	                  ttScope.isOpen = false;
	                  assignIsOpen(false);
	                  // And now we remove it from the DOM. However, if we have animation, we
	                  // need to wait for it to expire beforehand.
	                  // FIXME: this is a placeholder for a port of the transitions library.
	                  // The fade transition in TWBS is 150ms.
	                  if (ttScope.animation) {
	                    if (!transitionTimeout) {
	                      transitionTimeout = $timeout(removeTooltip, 150, false);
	                    }
	                  } else {
	                    removeTooltip();
	                  }
	                }
	              });
	            }
	
	            function cancelHide() {
	              if (hideTimeout) {
	                $timeout.cancel(hideTimeout);
	                hideTimeout = null;
	              }
	
	              if (transitionTimeout) {
	                $timeout.cancel(transitionTimeout);
	                transitionTimeout = null;
	              }
	            }
	
	            function createTooltip() {
	              // There can only be one tooltip element per directive shown at once.
	              if (tooltip) {
	                return;
	              }
	
	              tooltipLinkedScope = ttScope.$new();
	              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
	                if (appendToBody) {
	                  $document.find('body').append(tooltip);
	                } else {
	                  element.after(tooltip);
	                }
	              });
	
	              openedTooltips.add(ttScope, {
	                close: hide
	              });
	
	              prepObservers();
	            }
	
	            function removeTooltip() {
	              cancelShow();
	              cancelHide();
	              unregisterObservers();
	
	              if (tooltip) {
	                tooltip.remove();
	                
	                tooltip = null;
	                if (adjustmentTimeout) {
	                  $timeout.cancel(adjustmentTimeout);
	                }
	              }
	
	              openedTooltips.remove(ttScope);
	              
	              if (tooltipLinkedScope) {
	                tooltipLinkedScope.$destroy();
	                tooltipLinkedScope = null;
	              }
	            }
	
	            /**
	             * Set the initial scope values. Once
	             * the tooltip is created, the observers
	             * will be added to keep things in sync.
	             */
	            function prepareTooltip() {
	              ttScope.title = attrs[prefix + 'Title'];
	              if (contentParse) {
	                ttScope.content = contentParse(scope);
	              } else {
	                ttScope.content = attrs[ttType];
	              }
	
	              ttScope.popupClass = attrs[prefix + 'Class'];
	              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
	              var placement = $position.parsePlacement(ttScope.placement);
	              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];
	
	              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
	              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
	              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
	              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
	            }
	
	            function assignIsOpen(isOpen) {
	              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
	                isOpenParse.assign(scope, isOpen);
	              }
	            }
	
	            ttScope.contentExp = function() {
	              return ttScope.content;
	            };
	
	            /**
	             * Observe the relevant attributes.
	             */
	            attrs.$observe('disabled', function(val) {
	              if (val) {
	                cancelShow();
	              }
	
	              if (val && ttScope.isOpen) {
	                hide();
	              }
	            });
	
	            if (isOpenParse) {
	              scope.$watch(isOpenParse, function(val) {
	                if (ttScope && !val === ttScope.isOpen) {
	                  toggleTooltipBind();
	                }
	              });
	            }
	
	            function prepObservers() {
	              observers.length = 0;
	
	              if (contentParse) {
	                observers.push(
	                  scope.$watch(contentParse, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    }
	                  })
	                );
	
	                observers.push(
	                  tooltipLinkedScope.$watch(function() {
	                    if (!repositionScheduled) {
	                      repositionScheduled = true;
	                      tooltipLinkedScope.$$postDigest(function() {
	                        repositionScheduled = false;
	                        if (ttScope && ttScope.isOpen) {
	                          positionTooltip();
	                        }
	                      });
	                    }
	                  })
	                );
	              } else {
	                observers.push(
	                  attrs.$observe(ttType, function(val) {
	                    ttScope.content = val;
	                    if (!val && ttScope.isOpen) {
	                      hide();
	                    } else {
	                      positionTooltip();
	                    }
	                  })
	                );
	              }
	
	              observers.push(
	                attrs.$observe(prefix + 'Title', function(val) {
	                  ttScope.title = val;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	
	              observers.push(
	                attrs.$observe(prefix + 'Placement', function(val) {
	                  ttScope.placement = val ? val : options.placement;
	                  if (ttScope.isOpen) {
	                    positionTooltip();
	                  }
	                })
	              );
	            }
	
	            function unregisterObservers() {
	              if (observers.length) {
	                angular.forEach(observers, function(observer) {
	                  observer();
	                });
	                observers.length = 0;
	              }
	            }
	
	            // hide tooltips/popovers for outsideClick trigger
	            function bodyHideTooltipBind(e) {
	              if (!ttScope || !ttScope.isOpen || !tooltip) {
	                return;
	              }
	              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
	              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
	                hideTooltipBind();
	              }
	            }
	
	            // KeyboardEvent handler to hide the tooltip on Escape key press
	            function hideOnEscapeKey(e) {
	              if (e.which === 27) {
	                hideTooltipBind();
	              }
	            }
	
	            var unregisterTriggers = function() {
	              triggers.show.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  element.off('click', toggleTooltipBind);
	                } else {
	                  element.off(trigger, showTooltipBind);
	                  element.off(trigger, toggleTooltipBind);
	                }
	                element.off('keypress', hideOnEscapeKey);
	              });
	              triggers.hide.forEach(function(trigger) {
	                if (trigger === 'outsideClick') {
	                  $document.off('click', bodyHideTooltipBind);
	                } else {
	                  element.off(trigger, hideTooltipBind);
	                }
	              });
	            };
	
	            function prepTriggers() {
	              var showTriggers = [], hideTriggers = [];
	              var val = scope.$eval(attrs[prefix + 'Trigger']);
	              unregisterTriggers();
	
	              if (angular.isObject(val)) {
	                Object.keys(val).forEach(function(key) {
	                  showTriggers.push(key);
	                  hideTriggers.push(val[key]);
	                });
	                triggers = {
	                  show: showTriggers,
	                  hide: hideTriggers
	                };
	              } else {
	                triggers = getTriggers(val);
	              }
	
	              if (triggers.show !== 'none') {
	                triggers.show.forEach(function(trigger, idx) {
	                  if (trigger === 'outsideClick') {
	                    element.on('click', toggleTooltipBind);
	                    $document.on('click', bodyHideTooltipBind);
	                  } else if (trigger === triggers.hide[idx]) {
	                    element.on(trigger, toggleTooltipBind);
	                  } else if (trigger) {
	                    element.on(trigger, showTooltipBind);
	                    element.on(triggers.hide[idx], hideTooltipBind);
	                  }
	                  element.on('keypress', hideOnEscapeKey);
	                });
	              }
	            }
	
	            prepTriggers();
	
	            var animation = scope.$eval(attrs[prefix + 'Animation']);
	            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
	
	            var appendToBodyVal;
	            var appendKey = prefix + 'AppendToBody';
	            if (appendKey in attrs && attrs[appendKey] === undefined) {
	              appendToBodyVal = true;
	            } else {
	              appendToBodyVal = scope.$eval(attrs[appendKey]);
	            }
	
	            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;
	
	            // Make sure tooltip is destroyed and removed.
	            scope.$on('$destroy', function onDestroyTooltip() {
	              unregisterTriggers();
	              removeTooltip();
	              ttScope = null;
	            });
	          };
	        }
	      };
	    };
	  }];
	})
	
	// This is mostly ngInclude code but with a custom scope
	.directive('uibTooltipTemplateTransclude', [
	         '$animate', '$sce', '$compile', '$templateRequest',
	function ($animate, $sce, $compile, $templateRequest) {
	  return {
	    link: function(scope, elem, attrs) {
	      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
	
	      var changeCounter = 0,
	        currentScope,
	        previousElement,
	        currentElement;
	
	      var cleanupLastIncludeContent = function() {
	        if (previousElement) {
	          previousElement.remove();
	          previousElement = null;
	        }
	
	        if (currentScope) {
	          currentScope.$destroy();
	          currentScope = null;
	        }
	
	        if (currentElement) {
	          $animate.leave(currentElement).then(function() {
	            previousElement = null;
	          });
	          previousElement = currentElement;
	          currentElement = null;
	        }
	      };
	
	      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
	        var thisChangeId = ++changeCounter;
	
	        if (src) {
	          //set the 2nd param to true to ignore the template request error so that the inner
	          //contents and scope can be cleaned up.
	          $templateRequest(src, true).then(function(response) {
	            if (thisChangeId !== changeCounter) { return; }
	            var newScope = origScope.$new();
	            var template = response;
	
	            var clone = $compile(template)(newScope, function(clone) {
	              cleanupLastIncludeContent();
	              $animate.enter(clone, elem);
	            });
	
	            currentScope = newScope;
	            currentElement = clone;
	
	            currentScope.$emit('$includeContentLoaded', src);
	          }, function() {
	            if (thisChangeId === changeCounter) {
	              cleanupLastIncludeContent();
	              scope.$emit('$includeContentError', src);
	            }
	          });
	          scope.$emit('$includeContentRequested', src);
	        } else {
	          cleanupLastIncludeContent();
	        }
	      });
	
	      scope.$on('$destroy', cleanupLastIncludeContent);
	    }
	  };
	}])
	
	/**
	 * Note that it's intentional that these classes are *not* applied through $animate.
	 * They must not be animated as they're expected to be present on the tooltip on
	 * initialization.
	 */
	.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
	  return {
	    restrict: 'A',
	    link: function(scope, element, attrs) {
	      // need to set the primary position so the
	      // arrow has space during position measure.
	      // tooltip.positionTooltip()
	      if (scope.placement) {
	        // // There are no top-left etc... classes
	        // // in TWBS, so we need the primary position.
	        var position = $uibPosition.parsePlacement(scope.placement);
	        element.addClass(position[0]);
	      }
	
	      if (scope.popupClass) {
	        element.addClass(scope.popupClass);
	      }
	
	      if (scope.animation) {
	        element.addClass(attrs.tooltipAnimationClass);
	      }
	    }
	  };
	}])
	
	.directive('uibTooltipPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { content: '@' },
	    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
	  };
	})
	
	.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
	}])
	
	.directive('uibTooltipTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
	  };
	})
	
	.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibTooltipHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&' },
	    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
	  };
	})
	
	.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
	    useContentExp: true
	  });
	}]);
	
	/**
	 * The following features are still outstanding: popup delay, animation as a
	 * function, placement as a function, inside, support for more triggers than
	 * just mouse enter/leave, and selector delegatation.
	 */
	angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])
	
	.directive('uibPopoverTemplatePopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
	    templateUrl: 'uib/template/popover/popover-template.html'
	  };
	})
	
	.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverHtmlPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { contentExp: '&', uibTitle: '@' },
	    templateUrl: 'uib/template/popover/popover-html.html'
	  };
	})
	
	.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
	    useContentExp: true
	  });
	}])
	
	.directive('uibPopoverPopup', function() {
	  return {
	    restrict: 'A',
	    scope: { uibTitle: '@', content: '@' },
	    templateUrl: 'uib/template/popover/popover.html'
	  };
	})
	
	.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
	  return $uibTooltip('uibPopover', 'popover', 'click');
	}]);
	
	angular.module('ui.bootstrap.progressbar', [])
	
	.constant('uibProgressConfig', {
	  animate: true,
	  max: 100
	})
	
	.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
	  var self = this,
	      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
	
	  this.bars = [];
	  $scope.max = getMaxOrDefault();
	
	  this.addBar = function(bar, element, attrs) {
	    if (!animate) {
	      element.css({'transition': 'none'});
	    }
	
	    this.bars.push(bar);
	
	    bar.max = getMaxOrDefault();
	    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
	
	    bar.$watch('value', function(value) {
	      bar.recalculatePercentage();
	    });
	
	    bar.recalculatePercentage = function() {
	      var totalPercentage = self.bars.reduce(function(total, bar) {
	        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
	        return total + bar.percent;
	      }, 0);
	
	      if (totalPercentage > 100) {
	        bar.percent -= totalPercentage - 100;
	      }
	    };
	
	    bar.$on('$destroy', function() {
	      element = null;
	      self.removeBar(bar);
	    });
	  };
	
	  this.removeBar = function(bar) {
	    this.bars.splice(this.bars.indexOf(bar), 1);
	    this.bars.forEach(function (bar) {
	      bar.recalculatePercentage();
	    });
	  };
	
	  //$attrs.$observe('maxParam', function(maxParam) {
	  $scope.$watch('maxParam', function(maxParam) {
	    self.bars.forEach(function(bar) {
	      bar.max = getMaxOrDefault();
	      bar.recalculatePercentage();
	    });
	  });
	
	  function getMaxOrDefault () {
	    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
	  }
	}])
	
	.directive('uibProgress', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    require: 'uibProgress',
	    scope: {
	      maxParam: '=?max'
	    },
	    templateUrl: 'uib/template/progressbar/progress.html'
	  };
	})
	
	.directive('uibBar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    require: '^uibProgress',
	    scope: {
	      value: '=',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/bar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, element, attrs);
	    }
	  };
	})
	
	.directive('uibProgressbar', function() {
	  return {
	    replace: true,
	    transclude: true,
	    controller: 'UibProgressController',
	    scope: {
	      value: '=',
	      maxParam: '=?max',
	      type: '@'
	    },
	    templateUrl: 'uib/template/progressbar/progressbar.html',
	    link: function(scope, element, attrs, progressCtrl) {
	      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
	    }
	  };
	});
	
	angular.module('ui.bootstrap.rating', [])
	
	.constant('uibRatingConfig', {
	  max: 5,
	  stateOn: null,
	  stateOff: null,
	  enableReset: true,
	  titles: ['one', 'two', 'three', 'four', 'five']
	})
	
	.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
	  var ngModelCtrl = { $setViewValue: angular.noop },
	    self = this;
	
	  this.init = function(ngModelCtrl_) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.push(function(value) {
	      if (angular.isNumber(value) && value << 0 !== value) {
	        value = Math.round(value);
	      }
	
	      return value;
	    });
	
	    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
	    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
	    this.enableReset = angular.isDefined($attrs.enableReset) ?
	      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
	    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
	    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
	      tmpTitles : ratingConfig.titles;
	
	    var ratingStates = angular.isDefined($attrs.ratingStates) ?
	      $scope.$parent.$eval($attrs.ratingStates) :
	      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
	    $scope.range = this.buildTemplateObjects(ratingStates);
	  };
	
	  this.buildTemplateObjects = function(states) {
	    for (var i = 0, n = states.length; i < n; i++) {
	      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
	    }
	    return states;
	  };
	
	  this.getTitle = function(index) {
	    if (index >= this.titles.length) {
	      return index + 1;
	    }
	
	    return this.titles[index];
	  };
	
	  $scope.rate = function(value) {
	    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
	      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
	      ngModelCtrl.$setViewValue(newViewValue);
	      ngModelCtrl.$render();
	    }
	  };
	
	  $scope.enter = function(value) {
	    if (!$scope.readonly) {
	      $scope.value = value;
	    }
	    $scope.onHover({value: value});
	  };
	
	  $scope.reset = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.onLeave();
	  };
	
	  $scope.onKeydown = function(evt) {
	    if (/(37|38|39|40)/.test(evt.which)) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
	    }
	  };
	
	  this.render = function() {
	    $scope.value = ngModelCtrl.$viewValue;
	    $scope.title = self.getTitle($scope.value - 1);
	  };
	}])
	
	.directive('uibRating', function() {
	  return {
	    require: ['uibRating', 'ngModel'],
	    restrict: 'A',
	    scope: {
	      readonly: '=?readOnly',
	      onHover: '&',
	      onLeave: '&'
	    },
	    controller: 'UibRatingController',
	    templateUrl: 'uib/template/rating/rating.html',
	    link: function(scope, element, attrs, ctrls) {
	      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	      ratingCtrl.init(ngModelCtrl);
	    }
	  };
	});
	
	angular.module('ui.bootstrap.tabs', [])
	
	.controller('UibTabsetController', ['$scope', function ($scope) {
	  var ctrl = this,
	    oldIndex;
	  ctrl.tabs = [];
	
	  ctrl.select = function(index, evt) {
	    if (!destroyed) {
	      var previousIndex = findTabIndex(oldIndex);
	      var previousSelected = ctrl.tabs[previousIndex];
	      if (previousSelected) {
	        previousSelected.tab.onDeselect({
	          $event: evt,
	          $selectedIndex: index
	        });
	        if (evt && evt.isDefaultPrevented()) {
	          return;
	        }
	        previousSelected.tab.active = false;
	      }
	
	      var selected = ctrl.tabs[index];
	      if (selected) {
	        selected.tab.onSelect({
	          $event: evt
	        });
	        selected.tab.active = true;
	        ctrl.active = selected.index;
	        oldIndex = selected.index;
	      } else if (!selected && angular.isDefined(oldIndex)) {
	        ctrl.active = null;
	        oldIndex = null;
	      }
	    }
	  };
	
	  ctrl.addTab = function addTab(tab) {
	    ctrl.tabs.push({
	      tab: tab,
	      index: tab.index
	    });
	    ctrl.tabs.sort(function(t1, t2) {
	      if (t1.index > t2.index) {
	        return 1;
	      }
	
	      if (t1.index < t2.index) {
	        return -1;
	      }
	
	      return 0;
	    });
	
	    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
	      var newActiveIndex = findTabIndex(tab.index);
	      ctrl.select(newActiveIndex);
	    }
	  };
	
	  ctrl.removeTab = function removeTab(tab) {
	    var index;
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].tab === tab) {
	        index = i;
	        break;
	      }
	    }
	
	    if (ctrl.tabs[index].index === ctrl.active) {
	      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
	        index - 1 : index + 1 % ctrl.tabs.length;
	      ctrl.select(newActiveTabIndex);
	    }
	
	    ctrl.tabs.splice(index, 1);
	  };
	
	  $scope.$watch('tabset.active', function(val) {
	    if (angular.isDefined(val) && val !== oldIndex) {
	      ctrl.select(findTabIndex(val));
	    }
	  });
	
	  var destroyed;
	  $scope.$on('$destroy', function() {
	    destroyed = true;
	  });
	
	  function findTabIndex(index) {
	    for (var i = 0; i < ctrl.tabs.length; i++) {
	      if (ctrl.tabs[i].index === index) {
	        return i;
	      }
	    }
	  }
	}])
	
	.directive('uibTabset', function() {
	  return {
	    transclude: true,
	    replace: true,
	    scope: {},
	    bindToController: {
	      active: '=?',
	      type: '@'
	    },
	    controller: 'UibTabsetController',
	    controllerAs: 'tabset',
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
	    },
	    link: function(scope, element, attrs) {
	      scope.vertical = angular.isDefined(attrs.vertical) ?
	        scope.$parent.$eval(attrs.vertical) : false;
	      scope.justified = angular.isDefined(attrs.justified) ?
	        scope.$parent.$eval(attrs.justified) : false;
	    }
	  };
	})
	
	.directive('uibTab', ['$parse', function($parse) {
	  return {
	    require: '^uibTabset',
	    replace: true,
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || 'uib/template/tabs/tab.html';
	    },
	    transclude: true,
	    scope: {
	      heading: '@',
	      index: '=?',
	      classes: '@?',
	      onSelect: '&select', //This callback is called in contentHeadingTransclude
	                          //once it inserts the tab's content into the dom
	      onDeselect: '&deselect'
	    },
	    controller: function() {
	      //Empty controller so other directives can require being 'under' a tab
	    },
	    controllerAs: 'tab',
	    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
	      scope.disabled = false;
	      if (attrs.disable) {
	        scope.$parent.$watch($parse(attrs.disable), function(value) {
	          scope.disabled = !! value;
	        });
	      }
	
	      if (angular.isUndefined(attrs.index)) {
	        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
	          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
	        } else {
	          scope.index = 0;
	        }
	      }
	
	      if (angular.isUndefined(attrs.classes)) {
	        scope.classes = '';
	      }
	
	      scope.select = function(evt) {
	        if (!scope.disabled) {
	          var index;
	          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
	            if (tabsetCtrl.tabs[i].tab === scope) {
	              index = i;
	              break;
	            }
	          }
	
	          tabsetCtrl.select(index, evt);
	        }
	      };
	
	      tabsetCtrl.addTab(scope);
	      scope.$on('$destroy', function() {
	        tabsetCtrl.removeTab(scope);
	      });
	
	      //We need to transclude later, once the content container is ready.
	      //when this link happens, we're inside a tab heading.
	      scope.$transcludeFn = transclude;
	    }
	  };
	}])
	
	.directive('uibTabHeadingTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTab',
	    link: function(scope, elm) {
	      scope.$watch('headingElement', function updateHeadingElement(heading) {
	        if (heading) {
	          elm.html('');
	          elm.append(heading);
	        }
	      });
	    }
	  };
	})
	
	.directive('uibTabContentTransclude', function() {
	  return {
	    restrict: 'A',
	    require: '^uibTabset',
	    link: function(scope, elm, attrs) {
	      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;
	
	      //Now our tab is ready to be transcluded: both the tab heading area
	      //and the tab content area are loaded.  Transclude 'em both.
	      tab.$transcludeFn(tab.$parent, function(contents) {
	        angular.forEach(contents, function(node) {
	          if (isTabHeading(node)) {
	            //Let tabHeadingTransclude know.
	            tab.headingElement = node;
	          } else {
	            elm.append(node);
	          }
	        });
	      });
	    }
	  };
	
	  function isTabHeading(node) {
	    return node.tagName && (
	      node.hasAttribute('uib-tab-heading') ||
	      node.hasAttribute('data-uib-tab-heading') ||
	      node.hasAttribute('x-uib-tab-heading') ||
	      node.tagName.toLowerCase() === 'uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
	      node.tagName.toLowerCase() === 'uib:tab-heading'
	    );
	  }
	});
	
	angular.module('ui.bootstrap.timepicker', [])
	
	.constant('uibTimepickerConfig', {
	  hourStep: 1,
	  minuteStep: 1,
	  secondStep: 1,
	  showMeridian: true,
	  showSeconds: false,
	  meridians: null,
	  readonlyInput: false,
	  mousewheel: true,
	  arrowkeys: true,
	  showSpinners: true,
	  templateUrl: 'uib/template/timepicker/timepicker.html'
	})
	
	.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
	  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
	  var selected = new Date(),
	    watchers = [],
	    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
	    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
	    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;
	
	  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
	  $element.removeAttr('tabindex');
	
	  this.init = function(ngModelCtrl_, inputs) {
	    ngModelCtrl = ngModelCtrl_;
	    ngModelCtrl.$render = this.render;
	
	    ngModelCtrl.$formatters.unshift(function(modelValue) {
	      return modelValue ? new Date(modelValue) : null;
	    });
	
	    var hoursInputEl = inputs.eq(0),
	        minutesInputEl = inputs.eq(1),
	        secondsInputEl = inputs.eq(2);
	
	    hoursModelCtrl = hoursInputEl.controller('ngModel');
	    minutesModelCtrl = minutesInputEl.controller('ngModel');
	    secondsModelCtrl = secondsInputEl.controller('ngModel');
	
	    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
	
	    if (mousewheel) {
	      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
	    if (arrowkeys) {
	      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	    }
	
	    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
	    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
	  };
	
	  var hourStep = timepickerConfig.hourStep;
	  if ($attrs.hourStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
	      hourStep = +value;
	    }));
	  }
	
	  var minuteStep = timepickerConfig.minuteStep;
	  if ($attrs.minuteStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
	      minuteStep = +value;
	    }));
	  }
	
	  var min;
	  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
	    var dt = new Date(value);
	    min = isNaN(dt) ? undefined : dt;
	  }));
	
	  var max;
	  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
	    var dt = new Date(value);
	    max = isNaN(dt) ? undefined : dt;
	  }));
	
	  var disabled = false;
	  if ($attrs.ngDisabled) {
	    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
	      disabled = value;
	    }));
	  }
	
	  $scope.noIncrementHours = function() {
	    var incrementedSelected = addMinutes(selected, hourStep * 60);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementHours = function() {
	    var decrementedSelected = addMinutes(selected, -hourStep * 60);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementMinutes = function() {
	    var incrementedSelected = addMinutes(selected, minuteStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementMinutes = function() {
	    var decrementedSelected = addMinutes(selected, -minuteStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noIncrementSeconds = function() {
	    var incrementedSelected = addSeconds(selected, secondStep);
	    return disabled || incrementedSelected > max ||
	      incrementedSelected < selected && incrementedSelected < min;
	  };
	
	  $scope.noDecrementSeconds = function() {
	    var decrementedSelected = addSeconds(selected, -secondStep);
	    return disabled || decrementedSelected < min ||
	      decrementedSelected > selected && decrementedSelected > max;
	  };
	
	  $scope.noToggleMeridian = function() {
	    if (selected.getHours() < 12) {
	      return disabled || addMinutes(selected, 12 * 60) > max;
	    }
	
	    return disabled || addMinutes(selected, -12 * 60) < min;
	  };
	
	  var secondStep = timepickerConfig.secondStep;
	  if ($attrs.secondStep) {
	    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
	      secondStep = +value;
	    }));
	  }
	
	  $scope.showSeconds = timepickerConfig.showSeconds;
	  if ($attrs.showSeconds) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
	      $scope.showSeconds = !!value;
	    }));
	  }
	
	  // 12H / 24H mode
	  $scope.showMeridian = timepickerConfig.showMeridian;
	  if ($attrs.showMeridian) {
	    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
	      $scope.showMeridian = !!value;
	
	      if (ngModelCtrl.$error.time) {
	        // Evaluate from template
	        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
	        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	          selected.setHours(hours);
	          refresh();
	        }
	      } else {
	        updateTemplate();
	      }
	    }));
	  }
	
	  // Get $scope.hours in 24H mode if valid
	  function getHoursFromTemplate() {
	    var hours = +$scope.hours;
	    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
	      hours >= 0 && hours < 24;
	    if (!valid || $scope.hours === '') {
	      return undefined;
	    }
	
	    if ($scope.showMeridian) {
	      if (hours === 12) {
	        hours = 0;
	      }
	      if ($scope.meridian === meridians[1]) {
	        hours = hours + 12;
	      }
	    }
	    return hours;
	  }
	
	  function getMinutesFromTemplate() {
	    var minutes = +$scope.minutes;
	    var valid = minutes >= 0 && minutes < 60;
	    if (!valid || $scope.minutes === '') {
	      return undefined;
	    }
	    return minutes;
	  }
	
	  function getSecondsFromTemplate() {
	    var seconds = +$scope.seconds;
	    return seconds >= 0 && seconds < 60 ? seconds : undefined;
	  }
	
	  function pad(value, noPad) {
	    if (value === null) {
	      return '';
	    }
	
	    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
	      '0' + value : value.toString();
	  }
	
	  // Respond on mousewheel spin
	  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    var isScrollingUp = function(e) {
	      if (e.originalEvent) {
	        e = e.originalEvent;
	      }
	      //pick correct delta variable depending on event
	      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
	      return e.detail || delta > 0;
	    };
	
	    hoursInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
	      }
	      e.preventDefault();
	    });
	
	    minutesInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
	      }
	      e.preventDefault();
	    });
	
	     secondsInputEl.on('mousewheel wheel', function(e) {
	      if (!disabled) {
	        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
	      }
	      e.preventDefault();
	    });
	  };
	
	  // Respond on up/down arrowkeys
	  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    hoursInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementHours();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementHours();
	          $scope.$apply();
	        }
	      }
	    });
	
	    minutesInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementMinutes();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementMinutes();
	          $scope.$apply();
	        }
	      }
	    });
	
	    secondsInputEl.on('keydown', function(e) {
	      if (!disabled) {
	        if (e.which === 38) { // up
	          e.preventDefault();
	          $scope.incrementSeconds();
	          $scope.$apply();
	        } else if (e.which === 40) { // down
	          e.preventDefault();
	          $scope.decrementSeconds();
	          $scope.$apply();
	        }
	      }
	    });
	  };
	
	  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
	    if ($scope.readonlyInput) {
	      $scope.updateHours = angular.noop;
	      $scope.updateMinutes = angular.noop;
	      $scope.updateSeconds = angular.noop;
	      return;
	    }
	
	    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
	      ngModelCtrl.$setViewValue(null);
	      ngModelCtrl.$setValidity('time', false);
	      if (angular.isDefined(invalidHours)) {
	        $scope.invalidHours = invalidHours;
	        if (hoursModelCtrl) {
	          hoursModelCtrl.$setValidity('hours', false);
	        }
	      }
	
	      if (angular.isDefined(invalidMinutes)) {
	        $scope.invalidMinutes = invalidMinutes;
	        if (minutesModelCtrl) {
	          minutesModelCtrl.$setValidity('minutes', false);
	        }
	      }
	
	      if (angular.isDefined(invalidSeconds)) {
	        $scope.invalidSeconds = invalidSeconds;
	        if (secondsModelCtrl) {
	          secondsModelCtrl.$setValidity('seconds', false);
	        }
	      }
	    };
	
	    $scope.updateHours = function() {
	      var hours = getHoursFromTemplate(),
	        minutes = getMinutesFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(true);
	        } else {
	          refresh('h');
	        }
	      } else {
	        invalidate(true);
	      }
	    };
	
	    hoursInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.hours === null || $scope.hours === '') {
	        invalidate(true);
	      } else if (!$scope.invalidHours && $scope.hours < 10) {
	        $scope.$apply(function() {
	          $scope.hours = pad($scope.hours, !padHours);
	        });
	      }
	    });
	
	    $scope.updateMinutes = function() {
	      var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        selected.setHours(hours);
	        selected.setMinutes(minutes);
	        if (selected < min || selected > max) {
	          invalidate(undefined, true);
	        } else {
	          refresh('m');
	        }
	      } else {
	        invalidate(undefined, true);
	      }
	    };
	
	    minutesInputEl.on('blur', function(e) {
	      ngModelCtrl.$setTouched();
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if ($scope.minutes === null) {
	        invalidate(undefined, true);
	      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
	        $scope.$apply(function() {
	          $scope.minutes = pad($scope.minutes);
	        });
	      }
	    });
	
	    $scope.updateSeconds = function() {
	      var seconds = getSecondsFromTemplate();
	
	      ngModelCtrl.$setDirty();
	
	      if (angular.isDefined(seconds)) {
	        selected.setSeconds(seconds);
	        refresh('s');
	      } else {
	        invalidate(undefined, undefined, true);
	      }
	    };
	
	    secondsInputEl.on('blur', function(e) {
	      if (modelIsEmpty()) {
	        makeValid();
	      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
	        $scope.$apply( function() {
	          $scope.seconds = pad($scope.seconds);
	        });
	      }
	    });
	
	  };
	
	  this.render = function() {
	    var date = ngModelCtrl.$viewValue;
	
	    if (isNaN(date)) {
	      ngModelCtrl.$setValidity('time', false);
	      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
	    } else {
	      if (date) {
	        selected = date;
	      }
	
	      if (selected < min || selected > max) {
	        ngModelCtrl.$setValidity('time', false);
	        $scope.invalidHours = true;
	        $scope.invalidMinutes = true;
	      } else {
	        makeValid();
	      }
	      updateTemplate();
	    }
	  };
	
	  // Call internally when we know that model is valid.
	  function refresh(keyboardChange) {
	    makeValid();
	    ngModelCtrl.$setViewValue(new Date(selected));
	    updateTemplate(keyboardChange);
	  }
	
	  function makeValid() {
	    if (hoursModelCtrl) {
	      hoursModelCtrl.$setValidity('hours', true);
	    }
	
	    if (minutesModelCtrl) {
	      minutesModelCtrl.$setValidity('minutes', true);
	    }
	
	    if (secondsModelCtrl) {
	      secondsModelCtrl.$setValidity('seconds', true);
	    }
	
	    ngModelCtrl.$setValidity('time', true);
	    $scope.invalidHours = false;
	    $scope.invalidMinutes = false;
	    $scope.invalidSeconds = false;
	  }
	
	  function updateTemplate(keyboardChange) {
	    if (!ngModelCtrl.$modelValue) {
	      $scope.hours = null;
	      $scope.minutes = null;
	      $scope.seconds = null;
	      $scope.meridian = meridians[0];
	    } else {
	      var hours = selected.getHours(),
	        minutes = selected.getMinutes(),
	        seconds = selected.getSeconds();
	
	      if ($scope.showMeridian) {
	        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
	      }
	
	      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
	      if (keyboardChange !== 'm') {
	        $scope.minutes = pad(minutes);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	
	      if (keyboardChange !== 's') {
	        $scope.seconds = pad(seconds);
	      }
	      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
	    }
	  }
	
	  function addSecondsToSelected(seconds) {
	    selected = addSeconds(selected, seconds);
	    refresh();
	  }
	
	  function addMinutes(selected, minutes) {
	    return addSeconds(selected, minutes*60);
	  }
	
	  function addSeconds(date, seconds) {
	    var dt = new Date(date.getTime() + seconds * 1000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
	    return newDate;
	  }
	
	  function modelIsEmpty() {
	    return ($scope.hours === null || $scope.hours === '') &&
	      ($scope.minutes === null || $scope.minutes === '') &&
	      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
	  }
	
	  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
	    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
	
	  $scope.incrementHours = function() {
	    if (!$scope.noIncrementHours()) {
	      addSecondsToSelected(hourStep * 60 * 60);
	    }
	  };
	
	  $scope.decrementHours = function() {
	    if (!$scope.noDecrementHours()) {
	      addSecondsToSelected(-hourStep * 60 * 60);
	    }
	  };
	
	  $scope.incrementMinutes = function() {
	    if (!$scope.noIncrementMinutes()) {
	      addSecondsToSelected(minuteStep * 60);
	    }
	  };
	
	  $scope.decrementMinutes = function() {
	    if (!$scope.noDecrementMinutes()) {
	      addSecondsToSelected(-minuteStep * 60);
	    }
	  };
	
	  $scope.incrementSeconds = function() {
	    if (!$scope.noIncrementSeconds()) {
	      addSecondsToSelected(secondStep);
	    }
	  };
	
	  $scope.decrementSeconds = function() {
	    if (!$scope.noDecrementSeconds()) {
	      addSecondsToSelected(-secondStep);
	    }
	  };
	
	  $scope.toggleMeridian = function() {
	    var minutes = getMinutesFromTemplate(),
	        hours = getHoursFromTemplate();
	
	    if (!$scope.noToggleMeridian()) {
	      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
	        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
	      } else {
	        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
	      }
	    }
	  };
	
	  $scope.blur = function() {
	    ngModelCtrl.$setTouched();
	  };
	
	  $scope.$on('$destroy', function() {
	    while (watchers.length) {
	      watchers.shift()();
	    }
	  });
	}])
	
	.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
	  return {
	    require: ['uibTimepicker', '?^ngModel'],
	    restrict: 'A',
	    controller: 'UibTimepickerController',
	    controllerAs: 'timepicker',
	    scope: {},
	    templateUrl: function(element, attrs) {
	      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
	    },
	    link: function(scope, element, attrs, ctrls) {
	      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
	
	      if (ngModelCtrl) {
	        timepickerCtrl.init(ngModelCtrl, element.find('input'));
	      }
	    }
	  };
	}]);
	
	angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])
	
	/**
	 * A helper service that can parse typeahead's syntax (string provided by users)
	 * Extracted to a separate service for ease of unit testing
	 */
	  .factory('uibTypeaheadParser', ['$parse', function($parse) {
	    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
	    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
	    return {
	      parse: function(input) {
	        var match = input.match(TYPEAHEAD_REGEXP);
	        if (!match) {
	          throw new Error(
	            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
	              ' but got "' + input + '".');
	        }
	
	        return {
	          itemName: match[3],
	          source: $parse(match[4]),
	          viewMapper: $parse(match[2] || match[1]),
	          modelMapper: $parse(match[1])
	        };
	      }
	    };
	  }])
	
	  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
	    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
	    var HOT_KEYS = [9, 13, 27, 38, 40];
	    var eventDebounceTime = 200;
	    var modelCtrl, ngModelOptions;
	    //SUPPORTED ATTRIBUTES (OPTIONS)
	
	    //minimal no of characters that needs to be entered before typeahead kicks-in
	    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
	    if (!minLength && minLength !== 0) {
	      minLength = 1;
	    }
	
	    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
	        minLength = !newVal && newVal !== 0 ? 1 : newVal;
	    });
	
	    //minimal wait time after last character typed before typeahead kicks-in
	    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;
	
	    //should it restrict model values to the ones selected from the popup only?
	    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
	    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
	      isEditable = newVal !== false;
	    });
	
	    //binding to a variable that indicates if matches are being retrieved asynchronously
	    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;
	
	    //a function to determine if an event should cause selection
	    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
	      var evt = vals.$event;
	      return evt.which === 13 || evt.which === 9;
	    };
	
	    //a callback executed when a match is selected
	    var onSelectCallback = $parse(attrs.typeaheadOnSelect);
	
	    //should it select highlighted popup value when losing focus?
	    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;
	
	    //binding to a variable that indicates if there were no results after the query is completed
	    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
	
	    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
	
	    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
	
	    var appendTo = attrs.typeaheadAppendTo ?
	      originalScope.$eval(attrs.typeaheadAppendTo) : null;
	
	    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;
	
	    //If input matches an item of the list exactly, select it automatically
	    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;
	
	    //binding to a variable that indicates if dropdown is open
	    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
	
	    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;
	
	    //INTERNAL VARIABLES
	
	    //model setter executed upon match selection
	    var parsedModel = $parse(attrs.ngModel);
	    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
	    var $setModelValue = function(scope, newValue) {
	      if (angular.isFunction(parsedModel(originalScope)) &&
	        ngModelOptions.getOption('getterSetter')) {
	        return invokeModelSetter(scope, {$$$p: newValue});
	      }
	
	      return parsedModel.assign(scope, newValue);
	    };
	
	    //expressions used by typeahead
	    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
	
	    var hasFocus;
	
	    //Used to avoid bug in iOS webview where iOS keyboard does not fire
	    //mousedown & mouseup events
	    //Issue #3699
	    var selected;
	
	    //create a child scope for the typeahead directive so we are not polluting original scope
	    //with typeahead-specific data (matches, query etc.)
	    var scope = originalScope.$new();
	    var offDestroy = originalScope.$on('$destroy', function() {
	      scope.$destroy();
	    });
	    scope.$on('$destroy', offDestroy);
	
	    // WAI-ARIA
	    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
	    element.attr({
	      'aria-autocomplete': 'list',
	      'aria-expanded': false,
	      'aria-owns': popupId
	    });
	
	    var inputsContainer, hintInputElem;
	    //add read-only input to show hint
	    if (showHint) {
	      inputsContainer = angular.element('<div></div>');
	      inputsContainer.css('position', 'relative');
	      element.after(inputsContainer);
	      hintInputElem = element.clone();
	      hintInputElem.attr('placeholder', '');
	      hintInputElem.attr('tabindex', '-1');
	      hintInputElem.val('');
	      hintInputElem.css({
	        'position': 'absolute',
	        'top': '0px',
	        'left': '0px',
	        'border-color': 'transparent',
	        'box-shadow': 'none',
	        'opacity': 1,
	        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
	        'color': '#999'
	      });
	      element.css({
	        'position': 'relative',
	        'vertical-align': 'top',
	        'background-color': 'transparent'
	      });
	
	      if (hintInputElem.attr('id')) {
	        hintInputElem.removeAttr('id'); // remove duplicate id if present.
	      }
	      inputsContainer.append(hintInputElem);
	      hintInputElem.after(element);
	    }
	
	    //pop-up element used to display matches
	    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
	    popUpEl.attr({
	      id: popupId,
	      matches: 'matches',
	      active: 'activeIdx',
	      select: 'select(activeIdx, evt)',
	      'move-in-progress': 'moveInProgress',
	      query: 'query',
	      position: 'position',
	      'assign-is-open': 'assignIsOpen(isOpen)',
	      debounce: 'debounceUpdate'
	    });
	    //custom item template
	    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
	      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
	    }
	
	    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
	      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
	    }
	
	    var resetHint = function() {
	      if (showHint) {
	        hintInputElem.val('');
	      }
	    };
	
	    var resetMatches = function() {
	      scope.matches = [];
	      scope.activeIdx = -1;
	      element.attr('aria-expanded', false);
	      resetHint();
	    };
	
	    var getMatchId = function(index) {
	      return popupId + '-option-' + index;
	    };
	
	    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
	    // This attribute is added or removed automatically when the `activeIdx` changes.
	    scope.$watch('activeIdx', function(index) {
	      if (index < 0) {
	        element.removeAttr('aria-activedescendant');
	      } else {
	        element.attr('aria-activedescendant', getMatchId(index));
	      }
	    });
	
	    var inputIsExactMatch = function(inputValue, index) {
	      if (scope.matches.length > index && inputValue) {
	        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
	      }
	
	      return false;
	    };
	
	    var getMatchesAsync = function(inputValue, evt) {
	      var locals = {$viewValue: inputValue};
	      isLoadingSetter(originalScope, true);
	      isNoResultsSetter(originalScope, false);
	      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
	        //it might happen that several async queries were in progress if a user were typing fast
	        //but we are interested only in responses that correspond to the current view value
	        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
	        if (onCurrentRequest && hasFocus) {
	          if (matches && matches.length > 0) {
	            scope.activeIdx = focusFirst ? 0 : -1;
	            isNoResultsSetter(originalScope, false);
	            scope.matches.length = 0;
	
	            //transform labels
	            for (var i = 0; i < matches.length; i++) {
	              locals[parserResult.itemName] = matches[i];
	              scope.matches.push({
	                id: getMatchId(i),
	                label: parserResult.viewMapper(scope, locals),
	                model: matches[i]
	              });
	            }
	
	            scope.query = inputValue;
	            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
	            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
	            //due to other elements being rendered
	            recalculatePosition();
	
	            element.attr('aria-expanded', true);
	
	            //Select the single remaining option if user input matches
	            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(0, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(0, evt);
	              }
	            }
	
	            if (showHint) {
	              var firstLabel = scope.matches[0].label;
	              if (angular.isString(inputValue) &&
	                inputValue.length > 0 &&
	                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
	                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
	              } else {
	                hintInputElem.val('');
	              }
	            }
	          } else {
	            resetMatches();
	            isNoResultsSetter(originalScope, true);
	          }
	        }
	        if (onCurrentRequest) {
	          isLoadingSetter(originalScope, false);
	        }
	      }, function() {
	        resetMatches();
	        isLoadingSetter(originalScope, false);
	        isNoResultsSetter(originalScope, true);
	      });
	    };
	
	    // bind events only if appendToBody params exist - performance feature
	    if (appendToBody) {
	      angular.element($window).on('resize', fireRecalculating);
	      $document.find('body').on('scroll', fireRecalculating);
	    }
	
	    // Declare the debounced function outside recalculating for
	    // proper debouncing
	    var debouncedRecalculate = $$debounce(function() {
	      // if popup is visible
	      if (scope.matches.length) {
	        recalculatePosition();
	      }
	
	      scope.moveInProgress = false;
	    }, eventDebounceTime);
	
	    // Default progress type
	    scope.moveInProgress = false;
	
	    function fireRecalculating() {
	      if (!scope.moveInProgress) {
	        scope.moveInProgress = true;
	        scope.$digest();
	      }
	
	      debouncedRecalculate();
	    }
	
	    // recalculate actual position and set new values to scope
	    // after digest loop is popup in right position
	    function recalculatePosition() {
	      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
	      scope.position.top += element.prop('offsetHeight');
	    }
	
	    //we need to propagate user's query so we can higlight matches
	    scope.query = undefined;
	
	    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
	    var timeoutPromise;
	
	    var scheduleSearchWithTimeout = function(inputValue) {
	      timeoutPromise = $timeout(function() {
	        getMatchesAsync(inputValue);
	      }, waitTime);
	    };
	
	    var cancelPreviousTimeout = function() {
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	    };
	
	    resetMatches();
	
	    scope.assignIsOpen = function (isOpen) {
	      isOpenSetter(originalScope, isOpen);
	    };
	
	    scope.select = function(activeIdx, evt) {
	      //called from within the $digest() cycle
	      var locals = {};
	      var model, item;
	
	      selected = true;
	      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
	      model = parserResult.modelMapper(originalScope, locals);
	      $setModelValue(originalScope, model);
	      modelCtrl.$setValidity('editable', true);
	      modelCtrl.$setValidity('parse', true);
	
	      onSelectCallback(originalScope, {
	        $item: item,
	        $model: model,
	        $label: parserResult.viewMapper(originalScope, locals),
	        $event: evt
	      });
	
	      resetMatches();
	
	      //return focus to the input element if a match was selected via a mouse click event
	      // use timeout to avoid $rootScope:inprog error
	      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
	        $timeout(function() { element[0].focus(); }, 0, false);
	      }
	    };
	
	    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
	    element.on('keydown', function(evt) {
	      //typeahead is open and an "interesting" key was pressed
	      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
	        return;
	      }
	
	      var shouldSelect = isSelectEvent(originalScope, {$event: evt});
	
	      /**
	       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
	       * or
	       * shift + tab is pressed to bring focus to the previous element
	       * then clear the results
	       */
	      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
	        resetMatches();
	        scope.$digest();
	        return;
	      }
	
	      evt.preventDefault();
	      var target;
	      switch (evt.which) {
	        case 27: // escape
	          evt.stopPropagation();
	
	          resetMatches();
	          originalScope.$digest();
	          break;
	        case 38: // up arrow
	          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        case 40: // down arrow
	          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
	          scope.$digest();
	          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
	          target.parentNode.scrollTop = target.offsetTop;
	          break;
	        default:
	          if (shouldSelect) {
	            scope.$apply(function() {
	              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
	                $$debounce(function() {
	                  scope.select(scope.activeIdx, evt);
	                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
	              } else {
	                scope.select(scope.activeIdx, evt);
	              }
	            });
	          }
	      }
	    });
	
	    element.on('focus', function (evt) {
	      hasFocus = true;
	      if (minLength === 0 && !modelCtrl.$viewValue) {
	        $timeout(function() {
	          getMatchesAsync(modelCtrl.$viewValue, evt);
	        }, 0);
	      }
	    });
	
	    element.on('blur', function(evt) {
	      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
	        selected = true;
	        scope.$apply(function() {
	          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
	            $$debounce(function() {
	              scope.select(scope.activeIdx, evt);
	            }, scope.debounceUpdate.blur);
	          } else {
	            scope.select(scope.activeIdx, evt);
	          }
	        });
	      }
	      if (!isEditable && modelCtrl.$error.editable) {
	        modelCtrl.$setViewValue();
	        scope.$apply(function() {
	          // Reset validity as we are clearing
	          modelCtrl.$setValidity('editable', true);
	          modelCtrl.$setValidity('parse', true);
	        });
	        element.val('');
	      }
	      hasFocus = false;
	      selected = false;
	    });
	
	    // Keep reference to click handler to unbind it.
	    var dismissClickHandler = function(evt) {
	      // Issue #3973
	      // Firefox treats right click as a click on document
	      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
	        resetMatches();
	        if (!$rootScope.$$phase) {
	          originalScope.$digest();
	        }
	      }
	    };
	
	    $document.on('click', dismissClickHandler);
	
	    originalScope.$on('$destroy', function() {
	      $document.off('click', dismissClickHandler);
	      if (appendToBody || appendTo) {
	        $popup.remove();
	      }
	
	      if (appendToBody) {
	        angular.element($window).off('resize', fireRecalculating);
	        $document.find('body').off('scroll', fireRecalculating);
	      }
	      // Prevent jQuery cache memory leak
	      popUpEl.remove();
	
	      if (showHint) {
	          inputsContainer.remove();
	      }
	    });
	
	    var $popup = $compile(popUpEl)(scope);
	
	    if (appendToBody) {
	      $document.find('body').append($popup);
	    } else if (appendTo) {
	      angular.element(appendTo).eq(0).append($popup);
	    } else {
	      element.after($popup);
	    }
	
	    this.init = function(_modelCtrl) {
	      modelCtrl = _modelCtrl;
	      ngModelOptions = extractOptions(modelCtrl);
	
	      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);
	
	      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
	      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
	      modelCtrl.$parsers.unshift(function(inputValue) {
	        hasFocus = true;
	
	        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
	          if (waitTime > 0) {
	            cancelPreviousTimeout();
	            scheduleSearchWithTimeout(inputValue);
	          } else {
	            getMatchesAsync(inputValue);
	          }
	        } else {
	          isLoadingSetter(originalScope, false);
	          cancelPreviousTimeout();
	          resetMatches();
	        }
	
	        if (isEditable) {
	          return inputValue;
	        }
	
	        if (!inputValue) {
	          // Reset in case user had typed something previously.
	          modelCtrl.$setValidity('editable', true);
	          return null;
	        }
	
	        modelCtrl.$setValidity('editable', false);
	        return undefined;
	      });
	
	      modelCtrl.$formatters.push(function(modelValue) {
	        var candidateViewValue, emptyViewValue;
	        var locals = {};
	
	        // The validity may be set to false via $parsers (see above) if
	        // the model is restricted to selected values. If the model
	        // is set manually it is considered to be valid.
	        if (!isEditable) {
	          modelCtrl.$setValidity('editable', true);
	        }
	
	        if (inputFormatter) {
	          locals.$model = modelValue;
	          return inputFormatter(originalScope, locals);
	        }
	
	        //it might happen that we don't have enough info to properly render input value
	        //we need to check for this situation and simply return model value if we can't apply custom formatting
	        locals[parserResult.itemName] = modelValue;
	        candidateViewValue = parserResult.viewMapper(originalScope, locals);
	        locals[parserResult.itemName] = undefined;
	        emptyViewValue = parserResult.viewMapper(originalScope, locals);
	
	        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
	      });
	    };
	
	    function extractOptions(ngModelCtrl) {
	      var ngModelOptions;
	
	      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
	        // guarantee a value
	        ngModelOptions = ngModelCtrl.$options || {};
	
	        // mimic 1.6+ api
	        ngModelOptions.getOption = function (key) {
	          return ngModelOptions[key];
	        };
	      } else { // in angular >=1.6 $options is always present
	        ngModelOptions = ngModelCtrl.$options;
	      }
	
	      return ngModelOptions;
	    }
	  }])
	
	  .directive('uibTypeahead', function() {
	    return {
	      controller: 'UibTypeaheadController',
	      require: ['ngModel', 'uibTypeahead'],
	      link: function(originalScope, element, attrs, ctrls) {
	        ctrls[1].init(ctrls[0]);
	      }
	    };
	  })
	
	  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
	    return {
	      scope: {
	        matches: '=',
	        query: '=',
	        active: '=',
	        position: '&',
	        moveInProgress: '=',
	        select: '&',
	        assignIsOpen: '&',
	        debounce: '&'
	      },
	      replace: true,
	      templateUrl: function(element, attrs) {
	        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
	      },
	      link: function(scope, element, attrs) {
	        scope.templateUrl = attrs.templateUrl;
	
	        scope.isOpen = function() {
	          var isDropdownOpen = scope.matches.length > 0;
	          scope.assignIsOpen({ isOpen: isDropdownOpen });
	          return isDropdownOpen;
	        };
	
	        scope.isActive = function(matchIdx) {
	          return scope.active === matchIdx;
	        };
	
	        scope.selectActive = function(matchIdx) {
	          scope.active = matchIdx;
	        };
	
	        scope.selectMatch = function(activeIdx, evt) {
	          var debounce = scope.debounce();
	          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
	            $$debounce(function() {
	              scope.select({activeIdx: activeIdx, evt: evt});
	            }, angular.isNumber(debounce) ? debounce : debounce['default']);
	          } else {
	            scope.select({activeIdx: activeIdx, evt: evt});
	          }
	        };
	      }
	    };
	  }])
	
	  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
	    return {
	      scope: {
	        index: '=',
	        match: '=',
	        query: '='
	      },
	      link: function(scope, element, attrs) {
	        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
	        $templateRequest(tplUrl).then(function(tplContent) {
	          var tplEl = angular.element(tplContent.trim());
	          element.replaceWith(tplEl);
	          $compile(tplEl)(scope);
	        });
	      }
	    };
	  }])
	
	  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
	    var isSanitizePresent;
	    isSanitizePresent = $injector.has('$sanitize');
	
	    function escapeRegexp(queryToEscape) {
	      // Regex: capture the whole query string and replace it with the string that will be used to match
	      // the results, for example if the capture is "a" the result will be \a
	      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    }
	
	    function containsHtml(matchItem) {
	      return /<.*>/g.test(matchItem);
	    }
	
	    return function(matchItem, query) {
	      if (!isSanitizePresent && containsHtml(matchItem)) {
	        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
	      }
	      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
	      if (!isSanitizePresent) {
	        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
	      }
	      return matchItem;
	    };
	  }]);
	
	angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion-group.html",
	    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
	    "  <h4 class=\"panel-title\">\n" +
	    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
	    "  </h4>\n" +
	    "</div>\n" +
	    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
	    "  <div class=\"panel-body\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/accordion/accordion.html",
	    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
	}]);
	
	angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/alert/alert.html",
	    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
	    "  <span aria-hidden=\"true\">&times;</span>\n" +
	    "  <span class=\"sr-only\">Close</span>\n" +
	    "</button>\n" +
	    "<div ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/carousel.html",
	    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
	    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
	    "  <span class=\"sr-only\">previous</span>\n" +
	    "</a>\n" +
	    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
	    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
	    "  <span class=\"sr-only\">next</span>\n" +
	    "</a>\n" +
	    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
	    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
	    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
	    "  </li>\n" +
	    "</ol>\n" +
	    "");
	}]);
	
	angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/carousel/slide.html",
	    "<div class=\"text-center\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/datepicker.html",
	    "<div ng-switch=\"datepickerMode\">\n" +
	    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
	    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
	    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/day.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
	    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/month.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/datepicker/popup.html",
	    "<div>\n" +
	    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "    <li ng-transclude></li>\n" +
	    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "      <span class=\"btn-group pull-left\">\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "      </span>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "    </li>\n" +
	    "  </ul>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepicker/year.html",
	    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
	    "  <thead>\n" +
	    "    <tr>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
	    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
	    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
	    "    </tr>\n" +
	    "  </thead>\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
	    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
	    "        id=\"{{::dt.uid}}\"\n" +
	    "        ng-class=\"::dt.customClass\">\n" +
	    "        <button type=\"button\" class=\"btn btn-default\"\n" +
	    "          uib-is-class=\"\n" +
	    "            'btn-info' for selectedDt,\n" +
	    "            'active' for activeDt\n" +
	    "            on dt\"\n" +
	    "          ng-click=\"select(dt.date)\"\n" +
	    "          ng-disabled=\"::dt.disabled\"\n" +
	    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
	    "      </td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/datepickerPopup/popup.html",
	    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
	    "  <li ng-transclude></li>\n" +
	    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
	    "    <span class=\"btn-group pull-left\">\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
	    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
	    "    </span>\n" +
	    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
	    "  </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
	  $templateCache.put("uib/template/modal/backdrop.html",
	    "<div class=\"modal-backdrop\"\n" +
	    "     uib-modal-animation-class=\"fade\"\n" +
	    "     modal-in-class=\"in\"\n" +
	    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
	    "></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/modal/window.html",
	    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pager/pager.html",
	    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/pagination/pagination.html",
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
	    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
	    "<div class=\"tooltip-arrow\"></div>\n" +
	    "<div class=\"tooltip-inner\"\n" +
	    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-html.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover-template.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\"\n" +
	    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
	    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/popover/popover.html",
	    "<div class=\"arrow\"></div>\n" +
	    "\n" +
	    "<div class=\"popover-inner\">\n" +
	    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
	    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/bar.html",
	    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progress.html",
	    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
	}]);
	
	angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/progressbar/progressbar.html",
	    "<div class=\"progress\">\n" +
	    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/rating/rating.html",
	    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
	    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
	    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
	    "</span>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tab.html",
	    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
	    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
	    "</li>\n" +
	    "");
	}]);
	
	angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/tabs/tabset.html",
	    "<div>\n" +
	    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
	    "  <div class=\"tab-content\">\n" +
	    "    <div class=\"tab-pane\"\n" +
	    "         ng-repeat=\"tab in tabset.tabs\"\n" +
	    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
	    "         uib-tab-content-transclude=\"tab\">\n" +
	    "    </div>\n" +
	    "  </div>\n" +
	    "</div>\n" +
	    "");
	}]);
	
	angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/timepicker/timepicker.html",
	    "<table class=\"uib-timepicker\">\n" +
	    "  <tbody>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "    <tr>\n" +
	    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
	    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
	    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
	    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
	    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
	    "      </td>\n" +
	    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
	    "    </tr>\n" +
	    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
	    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td>&nbsp;</td>\n" +
	    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
	    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
	    "      <td ng-show=\"showMeridian\"></td>\n" +
	    "    </tr>\n" +
	    "  </tbody>\n" +
	    "</table>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-match.html",
	    "<a href\n" +
	    "   tabindex=\"-1\"\n" +
	    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
	    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
	    "");
	}]);
	
	angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
	  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
	    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
	    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
	    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
	    "    </li>\n" +
	    "</ul>\n" +
	    "");
	}]);
	angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
	angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
	angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
	angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
	angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
	angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
	angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(451);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./bootstrap.min.css", function() {
				var newContent = require("!!../../css-loader/index.js!./bootstrap.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(453) + ");src:url(" + __webpack_require__(453) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(454) + ") format(\"woff2\"),url(" + __webpack_require__(455) + ") format(\"woff\"),url(" + __webpack_require__(456) + ") format(\"truetype\"),url(" + __webpack_require__(457) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0;margin:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@-o-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);-webkit-background-size:40px 40px;background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);-o-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);-o-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 452 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f4769f9bdb7466be65088239c12046d1.eot";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "448c34a56d699c29117adc64c43affeb.woff2";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa2772327f55d8198301fdb8bcfc8158.woff";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "89889688147bd7575d6327160d64e760.svg";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 459 */,
/* 460 */,
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * State-based routing for AngularJS 1.x
	 * This bundle requires the ui-router-core.js bundle from the @uirouter/core package.
	 * @version v1.0.22
	 * @link https://ui-router.github.io
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(369), __webpack_require__(374)) :
	    typeof define === 'function' && define.amd ? define(['exports', 'angular', '@uirouter/core'], factory) :
	    (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular, global['@uirouter/core']));
	}(this, function (exports, ng_from_import, core) { 'use strict';
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */ var ng_from_global = angular;
	    /** @hidden */ var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
	
	    /** @internalapi */
	    function getNg1ViewConfigFactory() {
	        var templateFactory = null;
	        return function (path, view) {
	            templateFactory = templateFactory || core.services.$injector.get('$templateFactory');
	            return [new Ng1ViewConfig(path, view, templateFactory)];
	        };
	    }
	    /** @internalapi */
	    var hasAnyKey = function (keys, obj) { return keys.reduce(function (acc, key) { return acc || core.isDefined(obj[key]); }, false); };
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `views`.
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
	     *
	     * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
	     * and applies the state-level configuration to a view named `$default`.
	     *
	     * @internalapi
	     */
	    function ng1ViewsBuilder(state) {
	        // Do not process root state
	        if (!state.parent)
	            return {};
	        var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'], ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'], compKeys = ['component', 'bindings', 'componentProvider'], nonCompKeys = tplKeys.concat(ctrlKeys), allViewKeys = compKeys.concat(nonCompKeys);
	        // Do not allow a state to have both state-level props and also a `views: {}` property.
	        // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
	        // However, the `$default` approach should not be mixed with a separate `views: ` block.
	        if (core.isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
	            throw new Error("State '" + state.name + "' has a 'views' object. " +
	                "It cannot also have \"view properties\" at the state level.  " +
	                "Move the following properties into a view (in the 'views' object): " +
	                (" " + allViewKeys.filter(function (key) { return core.isDefined(state[key]); }).join(', ')));
	        }
	        var views = {}, viewsObject = state.views || { $default: core.pick(state, allViewKeys) };
	        core.forEach(viewsObject, function (config, name) {
	            // Account for views: { "": { template... } }
	            name = name || '$default';
	            // Account for views: { header: "headerComponent" }
	            if (core.isString(config))
	                config = { component: config };
	            // Make a shallow copy of the config object
	            config = core.extend({}, config);
	            // Do not allow a view to mix props for component-style view with props for template/controller-style view
	            if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
	                throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
	            }
	            config.resolveAs = config.resolveAs || '$resolve';
	            config.$type = 'ng1';
	            config.$context = state;
	            config.$name = name;
	            var normalized = core.ViewService.normalizeUIViewTarget(config.$context, config.$name);
	            config.$uiViewName = normalized.uiViewName;
	            config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
	            views[name] = config;
	        });
	        return views;
	    }
	    /** @hidden */
	    var id = 0;
	    /** @internalapi */
	    var Ng1ViewConfig = /** @class */ (function () {
	        function Ng1ViewConfig(path, viewDecl, factory) {
	            var _this = this;
	            this.path = path;
	            this.viewDecl = viewDecl;
	            this.factory = factory;
	            this.$id = id++;
	            this.loaded = false;
	            this.getTemplate = function (uiView, context) {
	                return _this.component
	                    ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings)
	                    : _this.template;
	            };
	        }
	        Ng1ViewConfig.prototype.load = function () {
	            var _this = this;
	            var $q = core.services.$q;
	            var context = new core.ResolveContext(this.path);
	            var params = this.path.reduce(function (acc, node) { return core.extend(acc, node.paramValues); }, {});
	            var promises = {
	                template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
	                controller: $q.when(this.getController(context)),
	            };
	            return $q.all(promises).then(function (results) {
	                core.trace.traceViewServiceEvent('Loaded', _this);
	                _this.controller = results.controller;
	                core.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
	                return _this;
	            });
	        };
	        /**
	         * Gets the controller for a view configuration.
	         *
	         * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
	         */
	        Ng1ViewConfig.prototype.getController = function (context) {
	            var provider = this.viewDecl.controllerProvider;
	            if (!core.isInjectable(provider))
	                return this.viewDecl.controller;
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        return Ng1ViewConfig;
	    }());
	
	    /** @publicapi @module view */ /** */
	    /**
	     * Service which manages loading of templates from a ViewConfig.
	     */
	    var TemplateFactory = /** @class */ (function () {
	        function TemplateFactory() {
	            var _this = this;
	            /** @hidden */ this._useHttp = ng.version.minor < 3;
	            /** @hidden */ this.$get = [
	                '$http',
	                '$templateCache',
	                '$injector',
	                function ($http, $templateCache, $injector) {
	                    _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
	                    _this.$http = $http;
	                    _this.$templateCache = $templateCache;
	                    return _this;
	                },
	            ];
	        }
	        /** @hidden */
	        TemplateFactory.prototype.useHttpService = function (value) {
	            this._useHttp = value;
	        };
	        /**
	         * Creates a template from a configuration object.
	         *
	         * @param config Configuration object for which to load a template.
	         * The following properties are search in the specified order, and the first one
	         * that is defined is used to create the template:
	         *
	         * @param params  Parameters to pass to the template function.
	         * @param context The resolve context associated with the template's view
	         *
	         * @return {string|object}  The template html as a string, or a promise for
	         * that string,or `null` if no template is configured.
	         */
	        TemplateFactory.prototype.fromConfig = function (config, params, context) {
	            var defaultTemplate = '<ui-view></ui-view>';
	            var asTemplate = function (result) { return core.services.$q.when(result).then(function (str) { return ({ template: str }); }); };
	            var asComponent = function (result) { return core.services.$q.when(result).then(function (str) { return ({ component: str }); }); };
	            return core.isDefined(config.template)
	                ? asTemplate(this.fromString(config.template, params))
	                : core.isDefined(config.templateUrl)
	                    ? asTemplate(this.fromUrl(config.templateUrl, params))
	                    : core.isDefined(config.templateProvider)
	                        ? asTemplate(this.fromProvider(config.templateProvider, params, context))
	                        : core.isDefined(config.component)
	                            ? asComponent(config.component)
	                            : core.isDefined(config.componentProvider)
	                                ? asComponent(this.fromComponentProvider(config.componentProvider, params, context))
	                                : asTemplate(defaultTemplate);
	        };
	        /**
	         * Creates a template from a string or a function returning a string.
	         *
	         * @param template html template as a string or function that returns an html template as a string.
	         * @param params Parameters to pass to the template function.
	         *
	         * @return {string|object} The template html as a string, or a promise for that
	         * string.
	         */
	        TemplateFactory.prototype.fromString = function (template, params) {
	            return core.isFunction(template) ? template(params) : template;
	        };
	        /**
	         * Loads a template from the a URL via `$http` and `$templateCache`.
	         *
	         * @param {string|Function} url url of the template to load, or a function
	         * that returns a url.
	         * @param {Object} params Parameters to pass to the url function.
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromUrl = function (url, params) {
	            if (core.isFunction(url))
	                url = url(params);
	            if (url == null)
	                return null;
	            if (this._useHttp) {
	                return this.$http
	                    .get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } })
	                    .then(function (response) {
	                    return response.data;
	                });
	            }
	            return this.$templateRequest(url);
	        };
	        /**
	         * Creates a template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string|Promise.<string>} The template html as a string, or a promise
	         * for that string.
	         */
	        TemplateFactory.prototype.fromProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a component's template by invoking an injectable provider function.
	         *
	         * @param provider Function to invoke via `locals`
	         * @param {Function} injectFn a function used to invoke the template provider
	         * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
	            var deps = core.services.$injector.annotate(provider);
	            var providerFn = core.isArray(provider) ? core.tail(provider) : provider;
	            var resolvable = new core.Resolvable('', providerFn, deps);
	            return resolvable.get(context);
	        };
	        /**
	         * Creates a template from a component's name
	         *
	         * This implements route-to-component.
	         * It works by retrieving the component (directive) metadata from the injector.
	         * It analyses the component's bindings, then constructs a template that instantiates the component.
	         * The template wires input and output bindings to resolves or from the parent component.
	         *
	         * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
	         * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
	         * @param component {string} Component's name in camel case.
	         * @param bindings An object defining the component's bindings: {foo: '<'}
	         * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
	         */
	        TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
	            bindings = bindings || {};
	            // Bind once prefix
	            var prefix = ng.version.minor >= 3 ? '::' : '';
	            // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
	            var kebob = function (camelCase) {
	                var kebobed = core.kebobString(camelCase);
	                return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
	            };
	            var attributeTpl = function (input) {
	                var name = input.name, type = input.type;
	                var attrName = kebob(name);
	                // If the ui-view has an attribute which matches a binding on the routed component
	                // then pass that attribute through to the routed component template.
	                // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
	                if (uiView.attr(attrName) && !bindings[name])
	                    return attrName + "='" + uiView.attr(attrName) + "'";
	                var resolveName = bindings[name] || name;
	                // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
	                // some-attr="{{ ::$resolve.someResolveName }}"
	                if (type === '@')
	                    return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
	                // Wire "&" callbacks to resolves that return a callback function
	                // Get the result of the resolve (should be a function) and annotate it to get its arguments.
	                // some-attr="$resolve.someResolveResultName(foo, bar)"
	                if (type === '&') {
	                    var res = context.getResolvable(resolveName);
	                    var fn = res && res.data;
	                    var args = (fn && core.services.$injector.annotate(fn)) || [];
	                    // account for array style injection, i.e., ['foo', function(foo) {}]
	                    var arrayIdxStr = core.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
	                    return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
	                }
	                // some-attr="::$resolve.someResolveName"
	                return attrName + "='" + prefix + "$resolve." + resolveName + "'";
	            };
	            var attrs = getComponentBindings(component)
	                .map(attributeTpl)
	                .join(' ');
	            var kebobName = kebob(component);
	            return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
	        };
	        return TemplateFactory;
	    }());
	    // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
	    function getComponentBindings(name) {
	        var cmpDefs = core.services.$injector.get(name + 'Directive'); // could be multiple
	        if (!cmpDefs || !cmpDefs.length)
	            throw new Error("Unable to find component named '" + name + "'");
	        return cmpDefs.map(getBindings).reduce(core.unnestR, []);
	    }
	    // Given a directive definition, find its object input attributes
	    // Use different properties, depending on the type of directive (component, bindToController, normal)
	    var getBindings = function (def) {
	        if (core.isObject(def.bindToController))
	            return scopeBindings(def.bindToController);
	        return scopeBindings(def.scope);
	    };
	    // for ng 1.2 style, process the scope: { input: "=foo" }
	    // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
	    var scopeBindings = function (bindingsObj) {
	        return Object.keys(bindingsObj || {})
	            // [ 'input', [ '=foo', '=', 'foo' ] ]
	            .map(function (key) { return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])]; })
	            // skip malformed values
	            .filter(function (tuple) { return core.isDefined(tuple) && core.isArray(tuple[1]); })
	            // { name: ('foo' || 'input'), type: '=' }
	            .map(function (tuple) { return ({ name: tuple[1][2] || tuple[0], type: tuple[1][1] }); });
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * The Angular 1 `StateProvider`
	     *
	     * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	     * on state.
	     *
	     * A state corresponds to a "place" in the application in terms of the overall UI and
	     * navigation. A state describes (via the controller / template / view properties) what
	     * the UI looks like and does at that place.
	     *
	     * States often have things in common, and the primary way of factoring out these
	     * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	     * nested states.
	     *
	     * The `$stateProvider` provides interfaces to declare these states for your app.
	     */
	    var StateProvider = /** @class */ (function () {
	        function StateProvider(stateRegistry, stateService) {
	            this.stateRegistry = stateRegistry;
	            this.stateService = stateService;
	            core.createProxyFunctions(core.val(StateProvider.prototype), this, core.val(this));
	        }
	        /**
	         * Decorates states when they are registered
	         *
	         * Allows you to extend (carefully) or override (at your own peril) the
	         * `stateBuilder` object used internally by [[StateRegistry]].
	         * This can be used to add custom functionality to ui-router,
	         * for example inferring templateUrl based on the state name.
	         *
	         * When passing only a name, it returns the current (original or decorated) builder
	         * function that matches `name`.
	         *
	         * The builder functions that can be decorated are listed below. Though not all
	         * necessarily have a good use case for decoration, that is up to you to decide.
	         *
	         * In addition, users can attach custom decorators, which will generate new
	         * properties within the state's internal definition. There is currently no clear
	         * use-case for this beyond accessing internal states (i.e. $state.$current),
	         * however, expect this to become increasingly relevant as we introduce additional
	         * meta-programming features.
	         *
	         * **Warning**: Decorators should not be interdependent because the order of
	         * execution of the builder functions in non-deterministic. Builder functions
	         * should only be dependent on the state definition object and super function.
	         *
	         *
	         * Existing builder functions and current return values:
	         *
	         * - **parent** `{object}` - returns the parent state object.
	         * - **data** `{object}` - returns state data, including any inherited data that is not
	         *   overridden by own values (if any).
	         * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	         *   or `null`.
	         * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
	         *   navigable).
	         * - **params** `{object}` - returns an array of state params that are ensured to
	         *   be a super-set of parent's params.
	         * - **views** `{object}` - returns a views object where each key is an absolute view
	         *   name (i.e. "viewName@stateName") and each value is the config object
	         *   (template, controller) for the view. Even when you don't use the views object
	         *   explicitly on a state config, one is still created for you internally.
	         *   So by decorating this builder function you have access to decorating template
	         *   and controller properties.
	         * - **ownParams** `{object}` - returns an array of params that belong to the state,
	         *   not including any params defined by ancestor states.
	         * - **path** `{string}` - returns the full path from the root down to this state.
	         *   Needed for state activation.
	         * - **includes** `{object}` - returns an object that includes every state that
	         *   would pass a `$state.includes()` test.
	         *
	         * #### Example:
	         * Override the internal 'views' builder with a function that takes the state
	         * definition, and a reference to the internal function being overridden:
	         * ```js
	         * $stateProvider.decorator('views', function (state, parent) {
	         *   let result = {},
	         *       views = parent(state);
	         *
	         *   angular.forEach(views, function (config, name) {
	         *     let autoName = (state.name + '.' + name).replace('.', '/');
	         *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	         *     result[name] = config;
	         *   });
	         *   return result;
	         * });
	         *
	         * $stateProvider.state('home', {
	         *   views: {
	         *     'contact.list': { controller: 'ListController' },
	         *     'contact.item': { controller: 'ItemController' }
	         *   }
	         * });
	         * ```
	         *
	         *
	         * ```js
	         * // Auto-populates list and item views with /partials/home/contact/list.html,
	         * // and /partials/home/contact/item.html, respectively.
	         * $state.go('home');
	         * ```
	         *
	         * @param {string} name The name of the builder function to decorate.
	         * @param {object} func A function that is responsible for decorating the original
	         * builder function. The function receives two parameters:
	         *
	         *   - `{object}` - state - The state config object.
	         *   - `{object}` - super - The original builder function.
	         *
	         * @return {object} $stateProvider - $stateProvider instance
	         */
	        StateProvider.prototype.decorator = function (name, func) {
	            return this.stateRegistry.decorator(name, func) || this;
	        };
	        StateProvider.prototype.state = function (name, definition) {
	            if (core.isObject(name)) {
	                definition = name;
	            }
	            else {
	                definition.name = name;
	            }
	            this.stateRegistry.register(definition);
	            return this;
	        };
	        /**
	         * Registers an invalid state handler
	         *
	         * This is a passthrough to [[StateService.onInvalid]] for ng1.
	         */
	        StateProvider.prototype.onInvalid = function (callback) {
	            return this.stateService.onInvalid(callback);
	        };
	        return StateProvider;
	    }());
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
	     * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
	     *
	     * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
	     * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
	     *
	     * @internalapi
	     */
	    var getStateHookBuilder = function (hookName) {
	        return function stateHookBuilder(stateObject, parentFn) {
	            var hook = stateObject[hookName];
	            var pathname = hookName === 'onExit' ? 'from' : 'to';
	            function decoratedNg1Hook(trans, state) {
	                var resolveContext = new core.ResolveContext(trans.treeChanges(pathname));
	                var subContext = resolveContext.subContext(state.$$state());
	                var locals = core.extend(getLocals(subContext), { $state$: state, $transition$: trans });
	                return core.services.$injector.invoke(hook, this, locals);
	            }
	            return hook ? decoratedNg1Hook : undefined;
	        };
	    };
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
	     * @internalapi
	     */
	    var Ng1LocationServices = /** @class */ (function () {
	        function Ng1LocationServices($locationProvider) {
	            // .onChange() registry
	            this._urlListeners = [];
	            this.$locationProvider = $locationProvider;
	            var _lp = core.val($locationProvider);
	            core.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
	        }
	        /**
	         * Applys ng1-specific path parameter encoding
	         *
	         * The Angular 1 `$location` service is a bit weird.
	         * It doesn't allow slashes to be encoded/decoded bi-directionally.
	         *
	         * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
	         *
	         * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
	         *
	         * @param router
	         */
	        Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
	            var pathType = router.urlMatcherFactory.type('path');
	            pathType.encode = function (x) {
	                return x != null ? x.toString().replace(/(~|\/)/g, function (m) { return ({ '~': '~~', '/': '~2F' }[m]); }) : x;
	            };
	            pathType.decode = function (x) {
	                return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) { return ({ '~~': '~', '~2F': '/' }[m]); }) : x;
	            };
	        };
	        Ng1LocationServices.prototype.dispose = function () { };
	        Ng1LocationServices.prototype.onChange = function (callback) {
	            var _this = this;
	            this._urlListeners.push(callback);
	            return function () { return core.removeFrom(_this._urlListeners)(callback); };
	        };
	        Ng1LocationServices.prototype.html5Mode = function () {
	            var html5Mode = this.$locationProvider.html5Mode();
	            html5Mode = core.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
	            return html5Mode && this.$sniffer.history;
	        };
	        Ng1LocationServices.prototype.baseHref = function () {
	            return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
	        };
	        Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
	            if (replace === void 0) { replace = false; }
	            if (core.isDefined(newUrl))
	                this.$location.url(newUrl);
	            if (replace)
	                this.$location.replace();
	            if (state)
	                this.$location.state(state);
	            return this.$location.url();
	        };
	        Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
	            var _this = this;
	            this.$location = $location;
	            this.$sniffer = $sniffer;
	            this.$browser = $browser;
	            this.$window = $window;
	            // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
	            $rootScope.$on('$locationChangeSuccess', function (evt) { return _this._urlListeners.forEach(function (fn) { return fn(evt); }); });
	            var _loc = core.val($location);
	            // Bind these LocationService functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
	            // Bind these LocationConfig functions to $location
	            core.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
	        };
	        return Ng1LocationServices;
	    }());
	
	    /** @publicapi @module url */ /** */
	    /**
	     * Manages rules for client-side URL
	     *
	     * ### Deprecation warning:
	     * This class is now considered to be an internal API
	     * Use the [[UrlService]] instead.
	     * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
	     *
	     * This class manages the router rules for what to do when the URL changes.
	     *
	     * This provider remains for backwards compatibility.
	     *
	     * @internalapi
	     * @deprecated
	     */
	    var UrlRouterProvider = /** @class */ (function () {
	        /** @hidden */
	        function UrlRouterProvider(/** @hidden */ router) {
	            this.router = router;
	        }
	        UrlRouterProvider.injectableHandler = function (router, handler) {
	            return function (match) { return core.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params }); };
	        };
	        /** @hidden */
	        UrlRouterProvider.prototype.$get = function () {
	            var urlService = this.router.urlService;
	            this.router.urlRouter.update(true);
	            if (!urlService.interceptDeferred)
	                urlService.listen();
	            return this.router.urlRouter;
	        };
	        /**
	         * Registers a url handler function.
	         *
	         * Registers a low level url handler (a `rule`).
	         * A rule detects specific URL patterns and returns a redirect, or performs some action.
	         *
	         * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Here's an example of how you might allow case insensitive urls
	         *   $urlRouterProvider.rule(function ($injector, $location) {
	         *     var path = $location.path(),
	         *         normalized = path.toLowerCase();
	         *
	         *     if (path !== normalized) {
	         *       return normalized;
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param ruleFn
	         * Handler function that takes `$injector` and `$location` services as arguments.
	         * You can use them to detect a url and return a different url as a string.
	         *
	         * @return [[UrlRouterProvider]] (`this`)
	         */
	        UrlRouterProvider.prototype.rule = function (ruleFn) {
	            var _this = this;
	            if (!core.isFunction(ruleFn))
	                throw new Error("'rule' must be a function");
	            var match = function () { return ruleFn(core.services.$injector, _this.router.locationService); };
	            var rule = new core.BaseUrlRule(match, core.identity);
	            this.router.urlService.rules.rule(rule);
	            return this;
	        };
	        /**
	         * Defines the path or behavior to use when no url can be matched.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // if the path doesn't match any of the urls you configured
	         *   // otherwise will take care of routing the user to the
	         *   // specified url
	         *   $urlRouterProvider.otherwise('/index');
	         *
	         *   // Example of using function rule as param
	         *   $urlRouterProvider.otherwise(function ($injector, $location) {
	         *     return '/a/valid/url';
	         *   });
	         * });
	         * ```
	         *
	         * @param rule
	         * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
	         * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
	         *
	         * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	         */
	        UrlRouterProvider.prototype.otherwise = function (rule) {
	            var _this = this;
	            var urlRules = this.router.urlService.rules;
	            if (core.isString(rule)) {
	                urlRules.otherwise(rule);
	            }
	            else if (core.isFunction(rule)) {
	                urlRules.otherwise(function () { return rule(core.services.$injector, _this.router.locationService); });
	            }
	            else {
	                throw new Error("'rule' must be a string or function");
	            }
	            return this;
	        };
	        /**
	         * Registers a handler for a given url matching.
	         *
	         * If the handler is a string, it is
	         * treated as a redirect, and is interpolated according to the syntax of match
	         * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	         *
	         * If the handler is a function, it is injectable.
	         * It gets invoked if `$location` matches.
	         * You have the option of inject the match object as `$match`.
	         *
	         * The handler can return
	         *
	         * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	         *   will continue trying to find another one that matches.
	         * - **string** which is treated as a redirect and passed to `$location.url()`
	         * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	         *     if ($state.$current.navigable !== state ||
	         *         !equalForKeys($match, $stateParams) {
	         *      $state.transitionTo(state, $match, false);
	         *     }
	         *   });
	         * });
	         * ```
	         *
	         * @param what A pattern string to match, compiled as a [[UrlMatcher]].
	         * @param handler The path (or function that returns a path) that you want to redirect your user to.
	         * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
	         *
	         * Note: the handler may also invoke arbitrary code, such as `$state.go()`
	         */
	        UrlRouterProvider.prototype.when = function (what, handler) {
	            if (core.isArray(handler) || core.isFunction(handler)) {
	                handler = UrlRouterProvider.injectableHandler(this.router, handler);
	            }
	            this.router.urlService.rules.when(what, handler);
	            return this;
	        };
	        /**
	         * Disables monitoring of the URL.
	         *
	         * Call this method before UI-Router has bootstrapped.
	         * It will stop UI-Router from performing the initial url sync.
	         *
	         * This can be useful to perform some asynchronous initialization before the router starts.
	         * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
	         *
	         * #### Example:
	         * ```js
	         * var app = angular.module('app', ['ui.router']);
	         *
	         * app.config(function ($urlRouterProvider) {
	         *   // Prevent $urlRouter from automatically intercepting URL changes;
	         *   $urlRouterProvider.deferIntercept();
	         * })
	         *
	         * app.run(function (MyService, $urlRouter, $http) {
	         *   $http.get("/stuff").then(function(resp) {
	         *     MyService.doStuff(resp.data);
	         *     $urlRouter.listen();
	         *     $urlRouter.sync();
	         *   });
	         * });
	         * ```
	         *
	         * @param defer Indicates whether to defer location change interception.
	         *        Passing no parameter is equivalent to `true`.
	         */
	        UrlRouterProvider.prototype.deferIntercept = function (defer) {
	            this.router.urlService.deferIntercept(defer);
	        };
	        return UrlRouterProvider;
	    }());
	
	    /**
	     * # Angular 1 types
	     *
	     * UI-Router core provides various Typescript types which you can use for code completion and validating parameter values, etc.
	     * The customizations to the core types for Angular UI-Router are documented here.
	     *
	     * The optional [[$resolve]] service is also documented here.
	     *
	     * @preferred @publicapi @module ng1
	     */ /** */
	    ng.module('ui.router.angular1', []);
	    var mod_init = ng.module('ui.router.init', ['ng']);
	    var mod_util = ng.module('ui.router.util', ['ui.router.init']);
	    var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
	    var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
	    var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
	    var mod_cmpt = ng.module('ui.router.compat', ['ui.router']); // tslint:disable-line
	    var router = null;
	    $uiRouterProvider.$inject = ['$locationProvider'];
	    /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
	    function $uiRouterProvider($locationProvider) {
	        // Create a new instance of the Router when the $uiRouterProvider is initialized
	        router = this.router = new core.UIRouter();
	        router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
	        // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
	        router.stateRegistry.decorator('views', ng1ViewsBuilder);
	        router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
	        router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
	        router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
	        router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
	        var ng1LocationService = (router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider));
	        Ng1LocationServices.monkeyPatchPathParameterType(router);
	        // backwards compat: also expose router instance as $uiRouterProvider.router
	        router['router'] = router;
	        router['$get'] = $get;
	        $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
	        function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
	            ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
	            delete router['router'];
	            delete router['$get'];
	            return router;
	        }
	        return router;
	    }
	    var getProviderFor = function (serviceName) { return [
	        '$uiRouterProvider',
	        function ($urp) {
	            var service = $urp.router[serviceName];
	            service['$get'] = function () { return service; };
	            return service;
	        },
	    ]; };
	    // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
	    runBlock.$inject = ['$injector', '$q', '$uiRouter'];
	    function runBlock($injector, $q, $uiRouter) {
	        core.services.$injector = $injector;
	        core.services.$q = $q;
	        // https://github.com/angular-ui/ui-router/issues/3678
	        if (!$injector.hasOwnProperty('strictDi')) {
	            try {
	                $injector.invoke(function (checkStrictDi) { });
	            }
	            catch (error) {
	                $injector.strictDi = !!/strict mode/.exec(error && error.toString());
	            }
	        }
	        // The $injector is now available.
	        // Find any resolvables that had dependency annotation deferred
	        $uiRouter.stateRegistry
	            .get()
	            .map(function (x) { return x.$$state().resolvables; })
	            .reduce(core.unnestR, [])
	            .filter(function (x) { return x.deps === 'deferred'; })
	            .forEach(function (resolvable) { return (resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi)); });
	    }
	    // $urlRouter service and $urlRouterProvider
	    var getUrlRouterProvider = function (uiRouter) { return (uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter)); };
	    // $state service and $stateProvider
	    // $urlRouter service and $urlRouterProvider
	    var getStateProvider = function () { return core.extend(router.stateProvider, { $get: function () { return router.stateService; } }); };
	    watchDigests.$inject = ['$rootScope'];
	    function watchDigests($rootScope) {
	        $rootScope.$watch(function () {
	            core.trace.approximateDigests++;
	        });
	    }
	    mod_init.provider('$uiRouter', $uiRouterProvider);
	    mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
	    mod_util.provider('$urlService', getProviderFor('urlService'));
	    mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () { return router.urlMatcherFactory; }]);
	    mod_util.provider('$templateFactory', function () { return new TemplateFactory(); });
	    mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
	    mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
	    mod_state.provider('$transitions', getProviderFor('transitionService'));
	    mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
	    mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) { return $uiRouter.globals.params; }]);
	    mod_main.factory('$view', function () { return router.viewService; });
	    mod_main.service('$trace', function () { return core.trace; });
	    mod_main.run(watchDigests);
	    mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) { }]);
	    mod_state.run(['$state', function ($state) { }]);
	    mod_rtr.run(['$urlRouter', function ($urlRouter) { }]);
	    mod_init.run(runBlock);
	    /** @hidden TODO: find a place to move this */
	    var getLocals = function (ctx) {
	        var tokens = ctx.getTokens().filter(core.isString);
	        var tuples = tokens.map(function (key) {
	            var resolvable = ctx.getResolvable(key);
	            var waitPolicy = ctx.getPolicy(resolvable).async;
	            return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
	        });
	        return tuples.reduce(core.applyPairs, {});
	    };
	
	    /**
	     * The current (or pending) State Parameters
	     *
	     * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
	     *
	     * The values are not updated until *after* a `Transition` successfully completes.
	     *
	     * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
	     *
	     * ### Deprecation warning:
	     *
	     * The value injected for `$stateParams` is different depending on where it is injected.
	     *
	     * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
	     * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
	     *
	     * Because of these confusing details, this service is deprecated.
	     *
	     * ### Instead of using the global `$stateParams` service object,
	     * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
	     *
	     * ```js
	     * MyService.$inject = ['$uiRouterGlobals'];
	     * function MyService($uiRouterGlobals) {
	     *   return {
	     *     paramValues: function () {
	     *       return $uiRouterGlobals.params;
	     *     }
	     *   }
	     * }
	     * ```
	     *
	     * ### Instead of using the per-transition `$stateParams` object,
	     * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
	     *
	     * ```js
	     * MyController.$inject = ['$transition$'];
	     * function MyController($transition$) {
	     *   var username = $transition$.params().username;
	     *   // .. do something with username
	     * }
	     * ```
	     *
	     * ---
	     *
	     * This object can be injected into other services.
	     *
	     * #### Deprecated Example:
	     * ```js
	     * SomeService.$inject = ['$http', '$stateParams'];
	     * function SomeService($http, $stateParams) {
	     *   return {
	     *     getUser: function() {
	     *       return $http.get('/api/users/' + $stateParams.username);
	     *     }
	     *   }
	     * };
	     * angular.service('SomeService', SomeService);
	     * ```
	     * @deprecated
	     */
	
	    /**
	     * # Angular 1 Directives
	     *
	     * These are the directives included in UI-Router for Angular 1.
	     * These directives are used in templates to create viewports and link/navigate to states.
	     *
	     * @preferred @publicapi @module directives
	     */ /** */
	    /** @hidden */
	    function parseStateRef(ref) {
	        var parsed;
	        var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
	        if (paramsOnly)
	            ref = '(' + paramsOnly[1] + ')';
	        parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
	        if (!parsed || parsed.length !== 4)
	            throw new Error("Invalid state ref '" + ref + "'");
	        return { state: parsed[1] || null, paramExpr: parsed[3] || null };
	    }
	    /** @hidden */
	    function stateContext(el) {
	        var $uiView = el.parent().inheritedData('$uiView');
	        var path = core.parse('$cfg.path')($uiView);
	        return path ? core.tail(path).state.name : undefined;
	    }
	    /** @hidden */
	    function processedDef($state, $element, def) {
	        var uiState = def.uiState || $state.current.name;
	        var uiStateOpts = core.extend(defaultOpts($element, $state), def.uiStateOpts || {});
	        var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
	        return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
	    }
	    /** @hidden */
	    function getTypeInfo(el) {
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	        var isForm = el[0].nodeName === 'FORM';
	        return {
	            attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
	            isAnchor: el.prop('tagName').toUpperCase() === 'A',
	            clickable: !isForm,
	        };
	    }
	    /** @hidden */
	    function clickHook(el, $state, $timeout, type, getDef) {
	        return function (e) {
	            var button = e.which || e.button, target = getDef();
	            if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	                // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	                var transition_1 = $timeout(function () {
	                    if (!el.attr('disabled')) {
	                        $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
	                    }
	                });
	                e.preventDefault();
	                // if the state has no URL, ignore one preventDefault from the <a> directive.
	                var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
	                e.preventDefault = function () {
	                    if (ignorePreventDefaultCount_1-- <= 0)
	                        $timeout.cancel(transition_1);
	                };
	            }
	        };
	    }
	    /** @hidden */
	    function defaultOpts(el, $state) {
	        return {
	            relative: stateContext(el) || $state.$current,
	            inherit: true,
	            source: 'sref',
	        };
	    }
	    /** @hidden */
	    function bindEvents(element, scope, hookFn, uiStateOpts) {
	        var events;
	        if (uiStateOpts) {
	            events = uiStateOpts.events;
	        }
	        if (!core.isArray(events)) {
	            events = ['click'];
	        }
	        var on = element.on ? 'on' : 'bind';
	        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
	            var event_1 = events_1[_i];
	            element[on](event_1, hookFn);
	        }
	        scope.$on('$destroy', function () {
	            var off = element.off ? 'off' : 'unbind';
	            for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
	                var event_2 = events_2[_i];
	                element[off](event_2, hookFn);
	            }
	        });
	    }
	    /**
	     * `ui-sref`: A directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of the `ui-sref` is the name of the state to link to.
	     *
	     * #### Example:
	     * This will activate the `home` state when the link is clicked.
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * ```
	     *
	     * ### Relative Links
	     * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create a relative `ui-sref` which always targets the same destination.
	     *
	     * #### Example:
	     * Both these links are relative to the parent state, even when a child state is currently active.
	     * ```html
	     * <a ui-sref=".child1">child 1 state</a>
	     * <a ui-sref=".child2">child 2 state</a>
	     * ```
	     *
	     * This link activates the parent state.
	     * ```html
	     * <a ui-sref="^">Return</a>
	     * ```
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * #### Example:
	     * Assuming the `users` state has a url of `/users/`
	     * ```html
	     * <a ui-sref="users" href="/users/">Users</a>
	     * ```
	     *
	     * ### Parameter Values
	     * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
	     * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
	     * The content inside the parentheses is an expression, evaluated to the parameter values.
	     *
	     * #### Example:
	     * This example renders a list of links to users.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="user in users">
	     *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * Note:
	     * The parameter values expression is `$watch`ed for updates.
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-sref-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Examples
	     * If you have the following template:
	     *
	     * ```html
	     * <a ui-sref="home">Home</a>
	     * <a ui-sref="about">About</a>
	     * <a ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	     *     </li>
	     * </ul>
	     * ```
	     *
	     * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
	     *
	     * ```html
	     * <a href="#/home" ui-sref="home">Home</a>
	     * <a href="#/about" ui-sref="about">About</a>
	     * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	     *
	     * <ul>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	     *     </li>
	     *     <li ng-repeat="contact in contacts">
	     *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	     *     </li>
	     * </ul>
	     *
	     * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	     * ```
	     *
	     * ### Notes
	     *
	     * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-sref="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     *
	     * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
	     * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
	     */
	    var uiSrefDirective;
	    uiSrefDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var ref = parseStateRef(attrs.uiSref);
	                    rawDef.uiState = ref.state;
	                    rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    if (ref.paramExpr) {
	                        scope.$watch(ref.paramExpr, function (val) {
	                            rawDef.uiStateParams = core.extend({}, val);
	                            update();
	                        }, true);
	                        rawDef.uiStateParams = core.extend({}, scope.$eval(ref.paramExpr));
	                    }
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-state`: A fully dynamic directive for linking to a state
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
	     *
	     * A directive which links to a state (and optionally, parameters).
	     * When clicked, this directive activates the linked state with the supplied parameter values.
	     *
	     * ### Linked State
	     * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
	     * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
	     *
	     * #### Example:
	     * Create a list of links.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Relative Links
	     * If the expression evaluates to a relative path, it is processed like [[uiSref]].
	     * You just need to be aware that the path is relative to the state that *created* the link.
	     * This allows a state to create relative `ui-state` which always targets the same destination.
	     *
	     * ### hrefs
	     * If the linked state has a URL, the directive will automatically generate and
	     * update the `href` attribute (using the [[StateService.href]]  method).
	     *
	     * ### Parameter Values
	     * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
	     * Param values should be provided using the `ui-state-params` attribute.
	     * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * This example renders a list of links with param values.
	     * The state's `userId` parameter value comes from each user's `user.id` property.
	     * ```html
	     * <li ng-repeat="link in navlinks">
	     *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Transition Options
	     * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
	     * Options are restricted to `location`, `inherit`, and `reload`.
	     * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
	     *
	     * #### Example:
	     * ```html
	     * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
	     * ```
	     *
	     * ### Other DOM Events
	     *
	     * You can also customize which DOM events to respond to (instead of `click`) by
	     * providing an `events` array in the `ui-state-opts` attribute.
	     *
	     * #### Example:
	     * ```html
	     * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
	     * ```
	     *
	     * ### Highlighting the active link
	     * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
	     *
	     * ### Notes
	     *
	     * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
	     *   However, it might be simpler to use [[uiSref]] parameter-only links.
	     *
	     * #### Example:
	     * Sets the `lang` parameter to `en` and remains on the same state.
	     *
	     * ```html
	     * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
	     * ```
	     *
	     * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
	     * ```
	     */
	    var uiStateDirective;
	    uiStateDirective = [
	        '$uiRouter',
	        '$timeout',
	        function $StateRefDynamicDirective($uiRouter, $timeout) {
	            var $state = $uiRouter.stateService;
	            return {
	                restrict: 'A',
	                require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	                link: function (scope, element, attrs, uiSrefActive) {
	                    var type = getTypeInfo(element);
	                    var active = uiSrefActive[1] || uiSrefActive[0];
	                    var unlinkInfoFn = null;
	                    var hookFn;
	                    var rawDef = {};
	                    var getDef = function () { return processedDef($state, element, rawDef); };
	                    var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
	                    var watchDeregFns = inputAttrs.reduce(function (acc, attr) { return ((acc[attr] = core.noop), acc); }, {});
	                    function update() {
	                        var def = getDef();
	                        if (unlinkInfoFn)
	                            unlinkInfoFn();
	                        if (active)
	                            unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
	                        if (def.href != null)
	                            attrs.$set(type.attr, def.href);
	                    }
	                    inputAttrs.forEach(function (field) {
	                        rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
	                        attrs.$observe(field, function (expr) {
	                            watchDeregFns[field]();
	                            watchDeregFns[field] = scope.$watch(expr, function (newval) {
	                                rawDef[field] = newval;
	                                update();
	                            }, true);
	                        });
	                    });
	                    update();
	                    scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
	                    scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
	                    if (!type.clickable)
	                        return;
	                    hookFn = clickHook(element, $state, $timeout, type, getDef);
	                    bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
	                },
	            };
	        },
	    ];
	    /**
	     * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
	     *
	     * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
	     * related directive's state is active (and remove them when it is inactive).
	     *
	     * The primary use-case is to highlight the active link in navigation menus,
	     * distinguishing it from the inactive menu items.
	     *
	     * ### Linking to a `ui-sref` or `ui-state`
	     * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
	     * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
	     *
	     * ### Matching
	     *
	     * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
	     * This is a "fuzzy match" which uses [[StateService.includes]].
	     *
	     * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
	     * This is an "exact match" which uses [[StateService.is]].
	     *
	     * ### Parameter values
	     * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
	     * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
	     *
	     * #### Example:
	     * ```html
	     * <li ng-repeat="user in users" ui-sref-active="active">
	     *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
	     * </li>
	     * ```
	     *
	     * ### Examples
	     *
	     * Given the following template:
	     * #### Example:
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item">
	     *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * When the app state is `app.user` (or any child state),
	     * and contains the state parameter "user" with value "bilbobaggins",
	     * the resulting HTML will appear as (note the 'active' class):
	     *
	     * ```html
	     * <ul>
	     *   <li ui-sref-active="active" class="item active">
	     *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	     *   </li>
	     * </ul>
	     * ```
	     *
	     * ### Glob mode
	     *
	     * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
	     * The objects keys represent active class names and values represent the respective state names/globs.
	     * `ui-sref-active` will match if the current active state **includes** any of
	     * the specified state names/globs, even the abstract ones.
	     *
	     * #### Example:
	     * Given the following template, with "admin" being an abstract state:
	     * ```html
	     * <div ui-sref-active="{'active': 'admin.**'}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * Arrays are also supported as values in the `ngClass`-like interface.
	     * This allows multiple states to add `active` class.
	     *
	     * #### Example:
	     * Given the following template, with "admin.roles" being the current state, the class will be added too:
	     * ```html
	     * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
	     *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	     * </div>
	     * ```
	     *
	     * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
	     * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
	     *
	     * ### Notes:
	     *
	     * - The class name is interpolated **once** during the directives link time (any further changes to the
	     * interpolated value are ignored).
	     *
	     * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
	     */
	    var uiSrefActiveDirective;
	    uiSrefActiveDirective = [
	        '$state',
	        '$stateParams',
	        '$interpolate',
	        '$uiRouter',
	        function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
	            return {
	                restrict: 'A',
	                controller: [
	                    '$scope',
	                    '$element',
	                    '$attrs',
	                    function ($scope, $element, $attrs) {
	                        var states = [];
	                        var activeEqClass;
	                        var uiSrefActive;
	                        // There probably isn't much point in $observing this
	                        // uiSrefActive and uiSrefActiveEq share the same directive object with some
	                        // slight difference in logic routing
	                        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	                        try {
	                            uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	                        }
	                        catch (e) {
	                            // Do nothing. uiSrefActive is not a valid expression.
	                            // Fall back to using $interpolate below
	                        }
	                        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	                        setStatesFromDefinitionObject(uiSrefActive);
	                        // Allow uiSref to communicate with uiSrefActive[Equals]
	                        this.$$addStateInfo = function (newState, newParams) {
	                            // we already got an explicit state provided by ui-sref-active, so we
	                            // shadow the one that comes from ui-sref
	                            if (core.isObject(uiSrefActive) && states.length > 0) {
	                                return;
	                            }
	                            var deregister = addState(newState, newParams, uiSrefActive);
	                            update();
	                            return deregister;
	                        };
	                        function updateAfterTransition(trans) {
	                            trans.promise.then(update, core.noop);
	                        }
	                        $scope.$on('$destroy', setupEventListeners());
	                        if ($uiRouter.globals.transition) {
	                            updateAfterTransition($uiRouter.globals.transition);
	                        }
	                        function setupEventListeners() {
	                            var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
	                            var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
	                            var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
	                            return function cleanUp() {
	                                deregisterStatesChangedListener();
	                                deregisterOnStartListener();
	                                deregisterStateChangeSuccessListener();
	                            };
	                        }
	                        function handleStatesChanged() {
	                            setStatesFromDefinitionObject(uiSrefActive);
	                        }
	                        function setStatesFromDefinitionObject(statesDefinition) {
	                            if (core.isObject(statesDefinition)) {
	                                states = [];
	                                core.forEach(statesDefinition, function (stateOrName, activeClass) {
	                                    // Helper function to abstract adding state.
	                                    var addStateForClass = function (stateOrName, activeClass) {
	                                        var ref = parseStateRef(stateOrName);
	                                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	                                    };
	                                    if (core.isString(stateOrName)) {
	                                        // If state is string, just add it.
	                                        addStateForClass(stateOrName, activeClass);
	                                    }
	                                    else if (core.isArray(stateOrName)) {
	                                        // If state is an array, iterate over it and add each array item individually.
	                                        core.forEach(stateOrName, function (stateOrName) {
	                                            addStateForClass(stateOrName, activeClass);
	                                        });
	                                    }
	                                });
	                            }
	                        }
	                        function addState(stateName, stateParams, activeClass) {
	                            var state = $state.get(stateName, stateContext($element));
	                            var stateInfo = {
	                                state: state || { name: stateName },
	                                params: stateParams,
	                                activeClass: activeClass,
	                            };
	                            states.push(stateInfo);
	                            return function removeState() {
	                                core.removeFrom(states)(stateInfo);
	                            };
	                        }
	                        // Update route state
	                        function update() {
	                            var splitClasses = function (str) { return str.split(/\s/).filter(core.identity); };
	                            var getClasses = function (stateList) {
	                                return stateList
	                                    .map(function (x) { return x.activeClass; })
	                                    .map(splitClasses)
	                                    .reduce(core.unnestR, []);
	                            };
	                            var allClasses = getClasses(states)
	                                .concat(splitClasses(activeEqClass))
	                                .reduce(core.uniqR, []);
	                            var fuzzyClasses = getClasses(states.filter(function (x) { return $state.includes(x.state.name, x.params); }));
	                            var exactlyMatchesAny = !!states.filter(function (x) { return $state.is(x.state.name, x.params); }).length;
	                            var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
	                            var addClasses = fuzzyClasses.concat(exactClasses).reduce(core.uniqR, []);
	                            var removeClasses = allClasses.filter(function (cls) { return !core.inArray(addClasses, cls); });
	                            $scope.$evalAsync(function () {
	                                addClasses.forEach(function (className) { return $element.addClass(className); });
	                                removeClasses.forEach(function (className) { return $element.removeClass(className); });
	                            });
	                        }
	                        update();
	                    },
	                ],
	            };
	        },
	    ];
	    ng
	        .module('ui.router.state')
	        .directive('uiSref', uiSrefDirective)
	        .directive('uiSrefActive', uiSrefActiveDirective)
	        .directive('uiSrefActiveEq', uiSrefActiveDirective)
	        .directive('uiState', uiStateDirective);
	
	    /** @publicapi @module ng1 */ /** */
	    /**
	     * `isState` Filter: truthy if the current state is the parameter
	     *
	     * Translates to [[StateService.is]] `$state.is("stateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
	     * ```
	     */
	    $IsStateFilter.$inject = ['$state'];
	    function $IsStateFilter($state) {
	        var isFilter = function (state, params, options) {
	            return $state.is(state, params, options);
	        };
	        isFilter.$stateful = true;
	        return isFilter;
	    }
	    /**
	     * `includedByState` Filter: truthy if the current state includes the parameter
	     *
	     * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
	     *
	     * #### Example:
	     * ```html
	     * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
	     * ```
	     */
	    $IncludedByStateFilter.$inject = ['$state'];
	    function $IncludedByStateFilter($state) {
	        var includesFilter = function (state, params, options) {
	            return $state.includes(state, params, options);
	        };
	        includesFilter.$stateful = true;
	        return includesFilter;
	    }
	    ng
	        .module('ui.router.state')
	        .filter('isState', $IsStateFilter)
	        .filter('includedByState', $IncludedByStateFilter);
	
	    /** @publicapi @module directives */ /** */
	    /**
	     * `ui-view`: A viewport directive which is filled in by a view from the active state.
	     *
	     * ### Attributes
	     *
	     * - `name`: (Optional) A view name.
	     *   The name should be unique amongst the other views in the same state.
	     *   You can have views of the same name that live in different states.
	     *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
	     *
	     * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
	     *   Uses [[$uiViewScroll]] to do the scrolling.
	     *
	     * - `onload`: Expression to evaluate whenever the view updates.
	     *
	     * #### Example:
	     * A view can be unnamed or named.
	     * ```html
	     * <!-- Unnamed -->
	     * <div ui-view></div>
	     *
	     * <!-- Named -->
	     * <div ui-view="viewName"></div>
	     *
	     * <!-- Named (different style) -->
	     * <ui-view name="viewName"></ui-view>
	     * ```
	     *
	     * You can only have one unnamed view within any template (or root html). If you are only using a
	     * single view and it is unnamed then you can populate it like so:
	     *
	     * ```html
	     * <div ui-view></div>
	     * $stateProvider.state("home", {
	     *   template: "<h1>HELLO!</h1>"
	     * })
	     * ```
	     *
	     * The above is a convenient shortcut equivalent to specifying your view explicitly with the
	     * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * But typically you'll only use the views property if you name your view or have more than one view
	     * in the same template. There's not really a compelling reason to name a view if its the only one,
	     * but you could if you wanted, like so:
	     *
	     * ```html
	     * <div ui-view="main"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "main": {
	     *       template: "<h1>HELLO!</h1>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * Really though, you'll use views to set up multiple views:
	     *
	     * ```html
	     * <div ui-view></div>
	     * <div ui-view="chart"></div>
	     * <div ui-view="data"></div>
	     * ```
	     *
	     * ```js
	     * $stateProvider.state("home", {
	     *   views: {
	     *     "": {
	     *       template: "<h1>HELLO!</h1>"
	     *     },
	     *     "chart": {
	     *       template: "<chart_thing/>"
	     *     },
	     *     "data": {
	     *       template: "<data_thing/>"
	     *     }
	     *   }
	     * })
	     * ```
	     *
	     * #### Examples for `autoscroll`:
	     * ```html
	     * <!-- If autoscroll present with no expression,
	     *      then scroll ui-view into view -->
	     * <ui-view autoscroll/>
	     *
	     * <!-- If autoscroll present with valid expression,
	     *      then scroll ui-view into view if expression evaluates to true -->
	     * <ui-view autoscroll='true'/>
	     * <ui-view autoscroll='false'/>
	     * <ui-view autoscroll='scopeVariable'/>
	     * ```
	     *
	     * Resolve data:
	     *
	     * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	     * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	     *
	     * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	     * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	     * depends on `$resolve` data.
	     *
	     * #### Example:
	     * ```js
	     * $stateProvider.state('home', {
	     *   template: '<my-component user="$resolve.user"></my-component>',
	     *   resolve: {
	     *     user: function(UserService) { return UserService.fetchUser(); }
	     *   }
	     * });
	     * ```
	     */
	    var uiView;
	    uiView = [
	        '$view',
	        '$animate',
	        '$uiViewScroll',
	        '$interpolate',
	        '$q',
	        function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
	            function getRenderer(attrs, scope) {
	                return {
	                    enter: function (element, target, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.enter(element, null, target).then(cb);
	                        }
	                        else {
	                            $animate.enter(element, null, target, cb);
	                        }
	                    },
	                    leave: function (element, cb) {
	                        if (ng.version.minor > 2) {
	                            $animate.leave(element).then(cb);
	                        }
	                        else {
	                            $animate.leave(element, cb);
	                        }
	                    },
	                };
	            }
	            function configsEqual(config1, config2) {
	                return config1 === config2;
	            }
	            var rootData = {
	                $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
	                $uiView: {},
	            };
	            var directive = {
	                count: 0,
	                restrict: 'ECA',
	                terminal: true,
	                priority: 400,
	                transclude: 'element',
	                compile: function (tElement, tAttrs, $transclude) {
	                    return function (scope, $element, attrs) {
	                        var onloadExp = attrs['onload'] || '', autoScrollExp = attrs['autoscroll'], renderer = getRenderer(attrs, scope), inherited = $element.inheritedData('$uiView') || rootData, name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
	                        var previousEl, currentEl, currentScope, viewConfig, unregister;
	                        var activeUIView = {
	                            $type: 'ng1',
	                            id: directive.count++,
	                            name: name,
	                            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
	                            config: null,
	                            configUpdated: configUpdatedCallback,
	                            get creationContext() {
	                                // The context in which this ui-view "tag" was created
	                                var fromParentTagConfig = core.parse('$cfg.viewDecl.$context')(inherited);
	                                // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
	                                // See https://github.com/angular-ui/ui-router/issues/3355
	                                var fromParentTag = core.parse('$uiView.creationContext')(inherited);
	                                return fromParentTagConfig || fromParentTag;
	                            },
	                        };
	                        core.trace.traceUIViewEvent('Linking', activeUIView);
	                        function configUpdatedCallback(config) {
	                            if (config && !(config instanceof Ng1ViewConfig))
	                                return;
	                            if (configsEqual(viewConfig, config))
	                                return;
	                            core.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
	                            viewConfig = config;
	                            updateView(config);
	                        }
	                        $element.data('$uiView', { $uiView: activeUIView });
	                        updateView();
	                        unregister = $view.registerUIView(activeUIView);
	                        scope.$on('$destroy', function () {
	                            core.trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
	                            unregister();
	                        });
	                        function cleanupLastView() {
	                            if (previousEl) {
	                                core.trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
	                                previousEl.remove();
	                                previousEl = null;
	                            }
	                            if (currentScope) {
	                                core.trace.traceUIViewEvent('Destroying scope', activeUIView);
	                                currentScope.$destroy();
	                                currentScope = null;
	                            }
	                            if (currentEl) {
	                                var _viewData_1 = currentEl.data('$uiViewAnim');
	                                core.trace.traceUIViewEvent('Animate out', _viewData_1);
	                                renderer.leave(currentEl, function () {
	                                    _viewData_1.$$animLeave.resolve();
	                                    previousEl = null;
	                                });
	                                previousEl = currentEl;
	                                currentEl = null;
	                            }
	                        }
	                        function updateView(config) {
	                            var newScope = scope.$new();
	                            var animEnter = $q.defer(), animLeave = $q.defer();
	                            var $uiViewData = {
	                                $cfg: config,
	                                $uiView: activeUIView,
	                            };
	                            var $uiViewAnim = {
	                                $animEnter: animEnter.promise,
	                                $animLeave: animLeave.promise,
	                                $$animLeave: animLeave,
	                            };
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoading
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description
	                             *
	                             * Fired once the view **begins loading**, *before* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             * @param {string} viewName Name of the view.
	                             */
	                            newScope.$emit('$viewContentLoading', name);
	                            var cloned = $transclude(newScope, function (clone) {
	                                clone.data('$uiViewAnim', $uiViewAnim);
	                                clone.data('$uiView', $uiViewData);
	                                renderer.enter(clone, $element, function onUIViewEnter() {
	                                    animEnter.resolve();
	                                    if (currentScope)
	                                        currentScope.$emit('$viewContentAnimationEnded');
	                                    if ((core.isDefined(autoScrollExp) && !autoScrollExp) || scope.$eval(autoScrollExp)) {
	                                        $uiViewScroll(clone);
	                                    }
	                                });
	                                cleanupLastView();
	                            });
	                            currentEl = cloned;
	                            currentScope = newScope;
	                            /**
	                             * @ngdoc event
	                             * @name ui.router.state.directive:ui-view#$viewContentLoaded
	                             * @eventOf ui.router.state.directive:ui-view
	                             * @eventType emits on ui-view directive scope
	                             * @description           *
	                             * Fired once the view is **loaded**, *after* the DOM is rendered.
	                             *
	                             * @param {Object} event Event object.
	                             */
	                            currentScope.$emit('$viewContentLoaded', config || viewConfig);
	                            currentScope.$eval(onloadExp);
	                        }
	                    };
	                },
	            };
	            return directive;
	        },
	    ];
	    $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q', '$timeout'];
	    /** @hidden */
	    function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q, $timeout) {
	        var getControllerAs = core.parse('viewDecl.controllerAs');
	        var getResolveAs = core.parse('viewDecl.resolveAs');
	        return {
	            restrict: 'ECA',
	            priority: -400,
	            compile: function (tElement) {
	                var initial = tElement.html();
	                tElement.empty();
	                return function (scope, $element) {
	                    var data = $element.data('$uiView');
	                    if (!data) {
	                        $element.html(initial);
	                        $compile($element.contents())(scope);
	                        return;
	                    }
	                    var cfg = data.$cfg || { viewDecl: {}, getTemplate: core.noop };
	                    var resolveCtx = cfg.path && new core.ResolveContext(cfg.path);
	                    $element.html(cfg.getTemplate($element, resolveCtx) || initial);
	                    core.trace.traceUIViewFill(data.$uiView, $element.html());
	                    var link = $compile($element.contents());
	                    var controller = cfg.controller;
	                    var controllerAs = getControllerAs(cfg);
	                    var resolveAs = getResolveAs(cfg);
	                    var locals = resolveCtx && getLocals(resolveCtx);
	                    scope[resolveAs] = locals;
	                    if (controller) {
	                        var controllerInstance = ($controller(controller, core.extend({}, locals, { $scope: scope, $element: $element })));
	                        if (controllerAs) {
	                            scope[controllerAs] = controllerInstance;
	                            scope[controllerAs][resolveAs] = locals;
	                        }
	                        // TODO: Use $view service as a central point for registering component-level hooks
	                        // Then, when a component is created, tell the $view service, so it can invoke hooks
	                        // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
	                        // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
	                        $element.data('$ngControllerController', controllerInstance);
	                        $element.children().data('$ngControllerController', controllerInstance);
	                        registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
	                    }
	                    // Wait for the component to appear in the DOM
	                    if (core.isString(cfg.component)) {
	                        var kebobName = core.kebobString(cfg.component);
	                        var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
	                        var getComponentController = function () {
	                            var directiveEl = [].slice
	                                .call($element[0].children)
	                                .filter(function (el) { return el && el.tagName && tagRegexp_1.exec(el.tagName); });
	                            return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
	                        };
	                        var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
	                            if (!ctrlInstance)
	                                return;
	                            registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
	                            deregisterWatch_1();
	                        });
	                    }
	                    link(scope);
	                };
	            },
	        };
	    }
	    /** @hidden */
	    var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
	    /** @hidden incrementing id */
	    var _uiCanExitId = 0;
	    /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
	    function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
	        // Call $onInit() ASAP
	        if (core.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) {
	            controllerInstance.$onInit();
	        }
	        var viewState = core.tail(cfg.path).state.self;
	        var hookOptions = { bind: controllerInstance };
	        // Add component-level hook for onUiParamsChanged
	        if (core.isFunction(controllerInstance.uiOnParamsChanged)) {
	            var resolveContext = new core.ResolveContext(cfg.path);
	            var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
	            // Fire callback on any successful transition
	            var paramsUpdated = function ($transition$) {
	                // Exit early if the $transition$ is the same as the view was created within.
	                // Exit early if the $transition$ will exit the state the view is for.
	                if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1)
	                    return;
	                var toParams = $transition$.params('to');
	                var fromParams = $transition$.params('from');
	                var getNodeSchema = function (node) { return node.paramSchema; };
	                var toSchema = $transition$
	                    .treeChanges('to')
	                    .map(getNodeSchema)
	                    .reduce(core.unnestR, []);
	                var fromSchema = $transition$
	                    .treeChanges('from')
	                    .map(getNodeSchema)
	                    .reduce(core.unnestR, []);
	                // Find the to params that have different values than the from params
	                var changedToParams = toSchema.filter(function (param) {
	                    var idx = fromSchema.indexOf(param);
	                    return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
	                });
	                // Only trigger callback if a to param has changed or is new
	                if (changedToParams.length) {
	                    var changedKeys_1 = changedToParams.map(function (x) { return x.id; });
	                    // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
	                    var newValues = core.filter(toParams, function (val, key) { return changedKeys_1.indexOf(key) !== -1; });
	                    controllerInstance.uiOnParamsChanged(newValues, $transition$);
	                }
	            };
	            $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
	        }
	        // Add component-level hook for uiCanExit
	        if (core.isFunction(controllerInstance.uiCanExit)) {
	            var id_1 = _uiCanExitId++;
	            var cacheProp_1 = '_uiCanExitIds';
	            // Returns true if a redirect transition already answered truthy
	            var prevTruthyAnswer_1 = function (trans) {
	                return !!trans && ((trans[cacheProp_1] && trans[cacheProp_1][id_1] === true) || prevTruthyAnswer_1(trans.redirectedFrom()));
	            };
	            // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
	            var wrappedHook = function (trans) {
	                var promise;
	                var ids = (trans[cacheProp_1] = trans[cacheProp_1] || {});
	                if (!prevTruthyAnswer_1(trans)) {
	                    promise = $q.when(controllerInstance.uiCanExit(trans));
	                    promise.then(function (val) { return (ids[id_1] = val !== false); });
	                }
	                return promise;
	            };
	            var criteria = { exiting: viewState.name };
	            $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
	        }
	    }
	    ng.module('ui.router.state').directive('uiView', uiView);
	    ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	    /** @publicapi @module ng1 */ /** */
	    /** @hidden */
	    function $ViewScrollProvider() {
	        var useAnchorScroll = false;
	        this.useAnchorScroll = function () {
	            useAnchorScroll = true;
	        };
	        this.$get = [
	            '$anchorScroll',
	            '$timeout',
	            function ($anchorScroll, $timeout) {
	                if (useAnchorScroll) {
	                    return $anchorScroll;
	                }
	                return function ($element) {
	                    return $timeout(function () {
	                        $element[0].scrollIntoView();
	                    }, 0, false);
	                };
	            },
	        ];
	    }
	    ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	    var index = 'ui.router';
	
	    Object.keys(core).forEach(function (key) { exports[key] = core[key]; });
	    exports.core = core;
	    exports.default = index;
	    exports.watchDigests = watchDigests;
	    exports.getLocals = getLocals;
	    exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
	    exports.ng1ViewsBuilder = ng1ViewsBuilder;
	    exports.Ng1ViewConfig = Ng1ViewConfig;
	    exports.StateProvider = StateProvider;
	    exports.UrlRouterProvider = UrlRouterProvider;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=ui-router-angularjs.js.map


/***/ }),
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(467);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(468), __esModule: true };

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(469);
	var $Object = __webpack_require__(350).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(356);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(364), 'Object', { defineProperty: __webpack_require__(360).f });


/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* tslint:disable:no-unused-variable */
	// Subject imported before Observable to bypass circular dependency issue since
	// Subject extends Observable and Observable references Subject in it's
	// definition
	var Subject_1 = __webpack_require__(498);
	exports.Subject = Subject_1.Subject;
	exports.AnonymousSubject = Subject_1.AnonymousSubject;
	/* tslint:enable:no-unused-variable */
	var Observable_1 = __webpack_require__(499);
	exports.Observable = Observable_1.Observable;
	// statics
	/* tslint:disable:no-use-before-declare */
	__webpack_require__(517);
	__webpack_require__(521);
	__webpack_require__(524);
	__webpack_require__(537);
	__webpack_require__(551);
	__webpack_require__(554);
	__webpack_require__(556);
	__webpack_require__(559);
	__webpack_require__(560);
	__webpack_require__(563);
	__webpack_require__(566);
	__webpack_require__(568);
	__webpack_require__(571);
	__webpack_require__(574);
	__webpack_require__(583);
	__webpack_require__(585);
	__webpack_require__(587);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(594);
	__webpack_require__(597);
	__webpack_require__(600);
	__webpack_require__(603);
	__webpack_require__(606);
	__webpack_require__(610);
	//dom
	__webpack_require__(613);
	__webpack_require__(617);
	//operators
	__webpack_require__(625);
	__webpack_require__(628);
	__webpack_require__(631);
	__webpack_require__(634);
	__webpack_require__(637);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(646);
	__webpack_require__(648);
	__webpack_require__(651);
	__webpack_require__(653);
	__webpack_require__(656);
	__webpack_require__(659);
	__webpack_require__(662);
	__webpack_require__(665);
	__webpack_require__(668);
	__webpack_require__(671);
	__webpack_require__(674);
	__webpack_require__(677);
	__webpack_require__(680);
	__webpack_require__(684);
	__webpack_require__(687);
	__webpack_require__(690);
	__webpack_require__(693);
	__webpack_require__(696);
	__webpack_require__(699);
	__webpack_require__(702);
	__webpack_require__(706);
	__webpack_require__(709);
	__webpack_require__(712);
	__webpack_require__(715);
	__webpack_require__(718);
	__webpack_require__(722);
	__webpack_require__(728);
	__webpack_require__(731);
	__webpack_require__(734);
	__webpack_require__(737);
	__webpack_require__(740);
	__webpack_require__(743);
	__webpack_require__(745);
	__webpack_require__(748);
	__webpack_require__(750);
	__webpack_require__(753);
	__webpack_require__(756);
	__webpack_require__(762);
	__webpack_require__(765);
	__webpack_require__(767);
	__webpack_require__(769);
	__webpack_require__(772);
	__webpack_require__(775);
	__webpack_require__(778);
	__webpack_require__(783);
	__webpack_require__(785);
	__webpack_require__(787);
	__webpack_require__(790);
	__webpack_require__(794);
	__webpack_require__(797);
	__webpack_require__(800);
	__webpack_require__(804);
	__webpack_require__(807);
	__webpack_require__(810);
	__webpack_require__(813);
	__webpack_require__(815);
	__webpack_require__(818);
	__webpack_require__(821);
	__webpack_require__(824);
	__webpack_require__(827);
	__webpack_require__(830);
	__webpack_require__(833);
	__webpack_require__(835);
	__webpack_require__(838);
	__webpack_require__(841);
	__webpack_require__(844);
	__webpack_require__(847);
	__webpack_require__(850);
	__webpack_require__(853);
	__webpack_require__(856);
	__webpack_require__(859);
	__webpack_require__(862);
	__webpack_require__(873);
	__webpack_require__(877);
	__webpack_require__(879);
	__webpack_require__(882);
	__webpack_require__(885);
	__webpack_require__(887);
	__webpack_require__(890);
	__webpack_require__(893);
	__webpack_require__(896);
	__webpack_require__(899);
	__webpack_require__(902);
	__webpack_require__(906);
	__webpack_require__(909);
	__webpack_require__(912);
	__webpack_require__(915);
	__webpack_require__(916);
	__webpack_require__(919);
	__webpack_require__(922);
	__webpack_require__(925);
	__webpack_require__(928);
	__webpack_require__(931);
	__webpack_require__(934);
	__webpack_require__(936);
	/* tslint:disable:no-unused-variable */
	var Subscription_1 = __webpack_require__(504);
	exports.Subscription = Subscription_1.Subscription;
	var Subscriber_1 = __webpack_require__(502);
	exports.Subscriber = Subscriber_1.Subscriber;
	var AsyncSubject_1 = __webpack_require__(520);
	exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
	var ReplaySubject_1 = __webpack_require__(620);
	exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
	var BehaviorSubject_1 = __webpack_require__(803);
	exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
	var ConnectableObservable_1 = __webpack_require__(781);
	exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
	var Notification_1 = __webpack_require__(546);
	exports.Notification = Notification_1.Notification;
	var EmptyError_1 = __webpack_require__(721);
	exports.EmptyError = EmptyError_1.EmptyError;
	var ArgumentOutOfRangeError_1 = __webpack_require__(705);
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	var ObjectUnsubscribedError_1 = __webpack_require__(515);
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
	var TimeoutError_1 = __webpack_require__(905);
	exports.TimeoutError = TimeoutError_1.TimeoutError;
	var UnsubscriptionError_1 = __webpack_require__(509);
	exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
	var timeInterval_1 = __webpack_require__(900);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	var timestamp_1 = __webpack_require__(911);
	exports.Timestamp = timestamp_1.Timestamp;
	var TestScheduler_1 = __webpack_require__(939);
	exports.TestScheduler = TestScheduler_1.TestScheduler;
	var VirtualTimeScheduler_1 = __webpack_require__(945);
	exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
	var AjaxObservable_1 = __webpack_require__(615);
	exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
	exports.AjaxError = AjaxObservable_1.AjaxError;
	exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
	var pipe_1 = __webpack_require__(513);
	exports.pipe = pipe_1.pipe;
	var asap_1 = __webpack_require__(866);
	var async_1 = __webpack_require__(578);
	var queue_1 = __webpack_require__(621);
	var animationFrame_1 = __webpack_require__(946);
	var rxSubscriber_1 = __webpack_require__(511);
	var iterator_1 = __webpack_require__(535);
	var observable_1 = __webpack_require__(512);
	var _operators = __webpack_require__(950);
	exports.operators = _operators;
	/* tslint:enable:no-unused-variable */
	/**
	 * @typedef {Object} Rx.Scheduler
	 * @property {Scheduler} queue Schedules on a queue in the current event frame
	 * (trampoline scheduler). Use this for iteration operations.
	 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
	 * fastest transport mechanism available, either Node.js' `process.nextTick()`
	 * or Web Worker MessageChannel or setTimeout or others. Use this for
	 * asynchronous conversions.
	 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
	 * time-based operations.
	 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
	 * Use this for synchronizing with the platform's painting
	 */
	var Scheduler = {
	    asap: asap_1.asap,
	    queue: queue_1.queue,
	    animationFrame: animationFrame_1.animationFrame,
	    async: async_1.async
	};
	exports.Scheduler = Scheduler;
	/**
	 * @typedef {Object} Rx.Symbol
	 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
	 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
	 * an object that has all of the traits of an Rx Subscriber, including the
	 * ability to add and remove subscriptions to the subscription chain and
	 * guarantees involving event triggering (can't "next" after unsubscription,
	 * etc).
	 * @property {Symbol|string} observable A symbol to use as a property name to
	 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
	 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
	 * to retrieve an iterator from an object.
	 */
	var Symbol = {
	    rxSubscriber: rxSubscriber_1.rxSubscriber,
	    observable: observable_1.observable,
	    iterator: iterator_1.iterator
	};
	exports.Symbol = Symbol;
	//# sourceMappingURL=Rx.js.map

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var Subscriber_1 = __webpack_require__(502);
	var Subscription_1 = __webpack_require__(504);
	var ObjectUnsubscribedError_1 = __webpack_require__(515);
	var SubjectSubscription_1 = __webpack_require__(516);
	var rxSubscriber_1 = __webpack_require__(511);
	/**
	 * @class SubjectSubscriber<T>
	 */
	var SubjectSubscriber = (function (_super) {
	    __extends(SubjectSubscriber, _super);
	    function SubjectSubscriber(destination) {
	        _super.call(this, destination);
	        this.destination = destination;
	    }
	    return SubjectSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SubjectSubscriber = SubjectSubscriber;
	/**
	 * @class Subject<T>
	 */
	var Subject = (function (_super) {
	    __extends(Subject, _super);
	    function Subject() {
	        _super.call(this);
	        this.observers = [];
	        this.closed = false;
	        this.isStopped = false;
	        this.hasError = false;
	        this.thrownError = null;
	    }
	    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
	        return new SubjectSubscriber(this);
	    };
	    Subject.prototype.lift = function (operator) {
	        var subject = new AnonymousSubject(this, this);
	        subject.operator = operator;
	        return subject;
	    };
	    Subject.prototype.next = function (value) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        if (!this.isStopped) {
	            var observers = this.observers;
	            var len = observers.length;
	            var copy = observers.slice();
	            for (var i = 0; i < len; i++) {
	                copy[i].next(value);
	            }
	        }
	    };
	    Subject.prototype.error = function (err) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.hasError = true;
	        this.thrownError = err;
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].error(err);
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.complete = function () {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        this.isStopped = true;
	        var observers = this.observers;
	        var len = observers.length;
	        var copy = observers.slice();
	        for (var i = 0; i < len; i++) {
	            copy[i].complete();
	        }
	        this.observers.length = 0;
	    };
	    Subject.prototype.unsubscribe = function () {
	        this.isStopped = true;
	        this.closed = true;
	        this.observers = null;
	    };
	    Subject.prototype._trySubscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return _super.prototype._trySubscribe.call(this, subscriber);
	        }
	    };
	    /** @deprecated internal use only */ Subject.prototype._subscribe = function (subscriber) {
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	    };
	    Subject.prototype.asObservable = function () {
	        var observable = new Observable_1.Observable();
	        observable.source = this;
	        return observable;
	    };
	    Subject.create = function (destination, source) {
	        return new AnonymousSubject(destination, source);
	    };
	    return Subject;
	}(Observable_1.Observable));
	exports.Subject = Subject;
	/**
	 * @class AnonymousSubject<T>
	 */
	var AnonymousSubject = (function (_super) {
	    __extends(AnonymousSubject, _super);
	    function AnonymousSubject(destination, source) {
	        _super.call(this);
	        this.destination = destination;
	        this.source = source;
	    }
	    AnonymousSubject.prototype.next = function (value) {
	        var destination = this.destination;
	        if (destination && destination.next) {
	            destination.next(value);
	        }
	    };
	    AnonymousSubject.prototype.error = function (err) {
	        var destination = this.destination;
	        if (destination && destination.error) {
	            this.destination.error(err);
	        }
	    };
	    AnonymousSubject.prototype.complete = function () {
	        var destination = this.destination;
	        if (destination && destination.complete) {
	            this.destination.complete();
	        }
	    };
	    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function (subscriber) {
	        var source = this.source;
	        if (source) {
	            return this.source.subscribe(subscriber);
	        }
	        else {
	            return Subscription_1.Subscription.EMPTY;
	        }
	    };
	    return AnonymousSubject;
	}(Subject));
	exports.AnonymousSubject = AnonymousSubject;
	//# sourceMappingURL=Subject.js.map

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	var toSubscriber_1 = __webpack_require__(501);
	var observable_1 = __webpack_require__(512);
	var pipe_1 = __webpack_require__(513);
	/**
	 * A representation of any set of values over any amount of time. This is the most basic building block
	 * of RxJS.
	 *
	 * @class Observable<T>
	 */
	var Observable = (function () {
	    /**
	     * @constructor
	     * @param {Function} subscribe the function that is called when the Observable is
	     * initially subscribed to. This function is given a Subscriber, to which new values
	     * can be `next`ed, or an `error` method can be called to raise an error, or
	     * `complete` can be called to notify of a successful completion.
	     */
	    function Observable(subscribe) {
	        this._isScalar = false;
	        if (subscribe) {
	            this._subscribe = subscribe;
	        }
	    }
	    /**
	     * Creates a new Observable, with this Observable as the source, and the passed
	     * operator defined as the new observable's operator.
	     * @method lift
	     * @param {Operator} operator the operator defining the operation to take on the observable
	     * @return {Observable} a new observable with the Operator applied
	     */
	    Observable.prototype.lift = function (operator) {
	        var observable = new Observable();
	        observable.source = this;
	        observable.operator = operator;
	        return observable;
	    };
	    /**
	     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
	     *
	     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
	     *
	     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
	     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
	     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
	     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
	     * thought.
	     *
	     * Apart from starting the execution of an Observable, this method allows you to listen for values
	     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
	     * following ways.
	     *
	     * The first way is creating an object that implements {@link Observer} interface. It should have methods
	     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
	     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
	     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
	     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
	     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
	     * be left uncaught.
	     *
	     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
	     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
	     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
	     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
	     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
	     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
	     *
	     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
	     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
	     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
	     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
	     *
	     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
	     * It is an Observable itself that decides when these functions will be called. For example {@link of}
	     * by default emits all its values synchronously. Always check documentation for how given Observable
	     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
	     *
	     * @example <caption>Subscribe with an Observer</caption>
	     * const sumObserver = {
	     *   sum: 0,
	     *   next(value) {
	     *     console.log('Adding: ' + value);
	     *     this.sum = this.sum + value;
	     *   },
	     *   error() { // We actually could just remove this method,
	     *   },        // since we do not really care about errors right now.
	     *   complete() {
	     *     console.log('Sum equals: ' + this.sum);
	     *   }
	     * };
	     *
	     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
	     * .subscribe(sumObserver);
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Subscribe with functions</caption>
	     * let sum = 0;
	     *
	     * Rx.Observable.of(1, 2, 3)
	     * .subscribe(
	     *   function(value) {
	     *     console.log('Adding: ' + value);
	     *     sum = sum + value;
	     *   },
	     *   undefined,
	     *   function() {
	     *     console.log('Sum equals: ' + sum);
	     *   }
	     * );
	     *
	     * // Logs:
	     * // "Adding: 1"
	     * // "Adding: 2"
	     * // "Adding: 3"
	     * // "Sum equals: 6"
	     *
	     *
	     * @example <caption>Cancel a subscription</caption>
	     * const subscription = Rx.Observable.interval(1000).subscribe(
	     *   num => console.log(num),
	     *   undefined,
	     *   () => console.log('completed!') // Will not be called, even
	     * );                                // when cancelling subscription
	     *
	     *
	     * setTimeout(() => {
	     *   subscription.unsubscribe();
	     *   console.log('unsubscribed!');
	     * }, 2500);
	     *
	     * // Logs:
	     * // 0 after 1s
	     * // 1 after 2s
	     * // "unsubscribed!" after 2.5s
	     *
	     *
	     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
	     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
	     *  Observable.
	     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
	     *  the error will be thrown as unhandled.
	     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
	     * @return {ISubscription} a subscription reference to the registered handlers
	     * @method subscribe
	     */
	    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
	        var operator = this.operator;
	        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
	        if (operator) {
	            operator.call(sink, this.source);
	        }
	        else {
	            sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
	        }
	        if (sink.syncErrorThrowable) {
	            sink.syncErrorThrowable = false;
	            if (sink.syncErrorThrown) {
	                throw sink.syncErrorValue;
	            }
	        }
	        return sink;
	    };
	    Observable.prototype._trySubscribe = function (sink) {
	        try {
	            return this._subscribe(sink);
	        }
	        catch (err) {
	            sink.syncErrorThrown = true;
	            sink.syncErrorValue = err;
	            sink.error(err);
	        }
	    };
	    /**
	     * @method forEach
	     * @param {Function} next a handler for each value emitted by the observable
	     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
	     * @return {Promise} a promise that either resolves on observable completion or
	     *  rejects with the handled error
	     */
	    Observable.prototype.forEach = function (next, PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            // Must be declared in a separate statement to avoid a RefernceError when
	            // accessing subscription below in the closure due to Temporal Dead Zone.
	            var subscription;
	            subscription = _this.subscribe(function (value) {
	                if (subscription) {
	                    // if there is a subscription, then we can surmise
	                    // the next handling is asynchronous. Any errors thrown
	                    // need to be rejected explicitly and unsubscribe must be
	                    // called manually
	                    try {
	                        next(value);
	                    }
	                    catch (err) {
	                        reject(err);
	                        subscription.unsubscribe();
	                    }
	                }
	                else {
	                    // if there is NO subscription, then we're getting a nexted
	                    // value synchronously during subscription. We can just call it.
	                    // If it errors, Observable's `subscribe` will ensure the
	                    // unsubscription logic is called, then synchronously rethrow the error.
	                    // After that, Promise will trap the error and send it
	                    // down the rejection path.
	                    next(value);
	                }
	            }, reject, resolve);
	        });
	    };
	    /** @deprecated internal use only */ Observable.prototype._subscribe = function (subscriber) {
	        return this.source.subscribe(subscriber);
	    };
	    /**
	     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
	     * @method Symbol.observable
	     * @return {Observable} this instance of the observable
	     */
	    Observable.prototype[observable_1.observable] = function () {
	        return this;
	    };
	    /* tslint:enable:max-line-length */
	    /**
	     * Used to stitch together functional operators into a chain.
	     * @method pipe
	     * @return {Observable} the Observable result of all of the operators having
	     * been called in the order they were passed in.
	     *
	     * @example
	     *
	     * import { map, filter, scan } from 'rxjs/operators';
	     *
	     * Rx.Observable.interval(1000)
	     *   .pipe(
	     *     filter(x => x % 2 === 0),
	     *     map(x => x + x),
	     *     scan((acc, x) => acc + x)
	     *   )
	     *   .subscribe(x => console.log(x))
	     */
	    Observable.prototype.pipe = function () {
	        var operations = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            operations[_i - 0] = arguments[_i];
	        }
	        if (operations.length === 0) {
	            return this;
	        }
	        return pipe_1.pipeFromArray(operations)(this);
	    };
	    /* tslint:enable:max-line-length */
	    Observable.prototype.toPromise = function (PromiseCtor) {
	        var _this = this;
	        if (!PromiseCtor) {
	            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
	                PromiseCtor = root_1.root.Rx.config.Promise;
	            }
	            else if (root_1.root.Promise) {
	                PromiseCtor = root_1.root.Promise;
	            }
	        }
	        if (!PromiseCtor) {
	            throw new Error('no Promise impl found');
	        }
	        return new PromiseCtor(function (resolve, reject) {
	            var value;
	            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
	        });
	    };
	    // HACK: Since TypeScript inherits static properties too, we have to
	    // fight against TypeScript here so Subject can have a different static create signature
	    /**
	     * Creates a new cold Observable by calling the Observable constructor
	     * @static true
	     * @owner Observable
	     * @method create
	     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
	     * @return {Observable} a new cold observable
	     */
	    Observable.create = function (subscribe) {
	        return new Observable(subscribe);
	    };
	    return Observable;
	}());
	exports.Observable = Observable;
	//# sourceMappingURL=Observable.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	// CommonJS / Node have global context exposed as "global" variable.
	// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
	// the global "global" var for now.
	var __window = typeof window !== 'undefined' && window;
	var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
	    self instanceof WorkerGlobalScope && self;
	var __global = typeof global !== 'undefined' && global;
	var _root = __window || __global || __self;
	exports.root = _root;
	// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
	// This is needed when used with angular/tsickle which inserts a goog.module statement.
	// Wrap in IIFE
	(function () {
	    if (!_root) {
	        throw new Error('RxJS could not find any global context (window, self, global)');
	    }
	})();
	//# sourceMappingURL=root.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subscriber_1 = __webpack_require__(502);
	var rxSubscriber_1 = __webpack_require__(511);
	var Observer_1 = __webpack_require__(510);
	function toSubscriber(nextOrObserver, error, complete) {
	    if (nextOrObserver) {
	        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
	            return nextOrObserver;
	        }
	        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
	            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
	        }
	    }
	    if (!nextOrObserver && !error && !complete) {
	        return new Subscriber_1.Subscriber(Observer_1.empty);
	    }
	    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	}
	exports.toSubscriber = toSubscriber;
	//# sourceMappingURL=toSubscriber.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(503);
	var Subscription_1 = __webpack_require__(504);
	var Observer_1 = __webpack_require__(510);
	var rxSubscriber_1 = __webpack_require__(511);
	/**
	 * Implements the {@link Observer} interface and extends the
	 * {@link Subscription} class. While the {@link Observer} is the public API for
	 * consuming the values of an {@link Observable}, all Observers get converted to
	 * a Subscriber, in order to provide Subscription-like capabilities such as
	 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
	 * implementing operators, but it is rarely used as a public API.
	 *
	 * @class Subscriber<T>
	 */
	var Subscriber = (function (_super) {
	    __extends(Subscriber, _super);
	    /**
	     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
	     * defined Observer or a `next` callback function.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     */
	    function Subscriber(destinationOrNext, error, complete) {
	        _super.call(this);
	        this.syncErrorValue = null;
	        this.syncErrorThrown = false;
	        this.syncErrorThrowable = false;
	        this.isStopped = false;
	        switch (arguments.length) {
	            case 0:
	                this.destination = Observer_1.empty;
	                break;
	            case 1:
	                if (!destinationOrNext) {
	                    this.destination = Observer_1.empty;
	                    break;
	                }
	                if (typeof destinationOrNext === 'object') {
	                    // HACK(benlesh): To resolve an issue where Node users may have multiple
	                    // copies of rxjs in their node_modules directory.
	                    if (isTrustedSubscriber(destinationOrNext)) {
	                        var trustedSubscriber = destinationOrNext[rxSubscriber_1.rxSubscriber]();
	                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
	                        this.destination = trustedSubscriber;
	                        trustedSubscriber.add(this);
	                    }
	                    else {
	                        this.syncErrorThrowable = true;
	                        this.destination = new SafeSubscriber(this, destinationOrNext);
	                    }
	                    break;
	                }
	            default:
	                this.syncErrorThrowable = true;
	                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
	                break;
	        }
	    }
	    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
	    /**
	     * A static factory for a Subscriber, given a (potentially partial) definition
	     * of an Observer.
	     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
	     * @param {function(e: ?any): void} [error] The `error` callback of an
	     * Observer.
	     * @param {function(): void} [complete] The `complete` callback of an
	     * Observer.
	     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
	     * Observer represented by the given arguments.
	     */
	    Subscriber.create = function (next, error, complete) {
	        var subscriber = new Subscriber(next, error, complete);
	        subscriber.syncErrorThrowable = false;
	        return subscriber;
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `next` from
	     * the Observable, with a value. The Observable may call this method 0 or more
	     * times.
	     * @param {T} [value] The `next` value.
	     * @return {void}
	     */
	    Subscriber.prototype.next = function (value) {
	        if (!this.isStopped) {
	            this._next(value);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive notifications of type `error` from
	     * the Observable, with an attached {@link Error}. Notifies the Observer that
	     * the Observable has experienced an error condition.
	     * @param {any} [err] The `error` exception.
	     * @return {void}
	     */
	    Subscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._error(err);
	        }
	    };
	    /**
	     * The {@link Observer} callback to receive a valueless notification of type
	     * `complete` from the Observable. Notifies the Observer that the Observable
	     * has finished sending push-based notifications.
	     * @return {void}
	     */
	    Subscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            this.isStopped = true;
	            this._complete();
	        }
	    };
	    Subscriber.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.isStopped = true;
	        _super.prototype.unsubscribe.call(this);
	    };
	    Subscriber.prototype._next = function (value) {
	        this.destination.next(value);
	    };
	    Subscriber.prototype._error = function (err) {
	        this.destination.error(err);
	        this.unsubscribe();
	    };
	    Subscriber.prototype._complete = function () {
	        this.destination.complete();
	        this.unsubscribe();
	    };
	    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        this._parent = null;
	        this._parents = null;
	        this.unsubscribe();
	        this.closed = false;
	        this.isStopped = false;
	        this._parent = _parent;
	        this._parents = _parents;
	        return this;
	    };
	    return Subscriber;
	}(Subscription_1.Subscription));
	exports.Subscriber = Subscriber;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SafeSubscriber = (function (_super) {
	    __extends(SafeSubscriber, _super);
	    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
	        _super.call(this);
	        this._parentSubscriber = _parentSubscriber;
	        var next;
	        var context = this;
	        if (isFunction_1.isFunction(observerOrNext)) {
	            next = observerOrNext;
	        }
	        else if (observerOrNext) {
	            next = observerOrNext.next;
	            error = observerOrNext.error;
	            complete = observerOrNext.complete;
	            if (observerOrNext !== Observer_1.empty) {
	                context = Object.create(observerOrNext);
	                if (isFunction_1.isFunction(context.unsubscribe)) {
	                    this.add(context.unsubscribe.bind(context));
	                }
	                context.unsubscribe = this.unsubscribe.bind(this);
	            }
	        }
	        this._context = context;
	        this._next = next;
	        this._error = error;
	        this._complete = complete;
	    }
	    SafeSubscriber.prototype.next = function (value) {
	        if (!this.isStopped && this._next) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (!_parentSubscriber.syncErrorThrowable) {
	                this.__tryOrUnsub(this._next, value);
	            }
	            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._error) {
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(this._error, err);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, this._error, err);
	                    this.unsubscribe();
	                }
	            }
	            else if (!_parentSubscriber.syncErrorThrowable) {
	                this.unsubscribe();
	                throw err;
	            }
	            else {
	                _parentSubscriber.syncErrorValue = err;
	                _parentSubscriber.syncErrorThrown = true;
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.complete = function () {
	        var _this = this;
	        if (!this.isStopped) {
	            var _parentSubscriber = this._parentSubscriber;
	            if (this._complete) {
	                var wrappedComplete = function () { return _this._complete.call(_this._context); };
	                if (!_parentSubscriber.syncErrorThrowable) {
	                    this.__tryOrUnsub(wrappedComplete);
	                    this.unsubscribe();
	                }
	                else {
	                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
	                    this.unsubscribe();
	                }
	            }
	            else {
	                this.unsubscribe();
	            }
	        }
	    };
	    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            this.unsubscribe();
	            throw err;
	        }
	    };
	    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
	        try {
	            fn.call(this._context, value);
	        }
	        catch (err) {
	            parent.syncErrorValue = err;
	            parent.syncErrorThrown = true;
	            return true;
	        }
	        return false;
	    };
	    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function () {
	        var _parentSubscriber = this._parentSubscriber;
	        this._context = null;
	        this._parentSubscriber = null;
	        _parentSubscriber.unsubscribe();
	    };
	    return SafeSubscriber;
	}(Subscriber));
	function isTrustedSubscriber(obj) {
	    return obj instanceof Subscriber || ('syncErrorThrowable' in obj && obj[rxSubscriber_1.rxSubscriber]);
	}
	//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	"use strict";
	function isFunction(x) {
	    return typeof x === 'function';
	}
	exports.isFunction = isFunction;
	//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(505);
	var isObject_1 = __webpack_require__(506);
	var isFunction_1 = __webpack_require__(503);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var UnsubscriptionError_1 = __webpack_require__(509);
	/**
	 * Represents a disposable resource, such as the execution of an Observable. A
	 * Subscription has one important method, `unsubscribe`, that takes no argument
	 * and just disposes the resource held by the subscription.
	 *
	 * Additionally, subscriptions may be grouped together through the `add()`
	 * method, which will attach a child Subscription to the current Subscription.
	 * When a Subscription is unsubscribed, all its children (and its grandchildren)
	 * will be unsubscribed as well.
	 *
	 * @class Subscription
	 */
	var Subscription = (function () {
	    /**
	     * @param {function(): void} [unsubscribe] A function describing how to
	     * perform the disposal of resources when the `unsubscribe` method is called.
	     */
	    function Subscription(unsubscribe) {
	        /**
	         * A flag to indicate whether this Subscription has already been unsubscribed.
	         * @type {boolean}
	         */
	        this.closed = false;
	        this._parent = null;
	        this._parents = null;
	        this._subscriptions = null;
	        if (unsubscribe) {
	            this._unsubscribe = unsubscribe;
	        }
	    }
	    /**
	     * Disposes the resources held by the subscription. May, for instance, cancel
	     * an ongoing Observable execution or cancel any other type of work that
	     * started when the Subscription was created.
	     * @return {void}
	     */
	    Subscription.prototype.unsubscribe = function () {
	        var hasErrors = false;
	        var errors;
	        if (this.closed) {
	            return;
	        }
	        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
	        this.closed = true;
	        this._parent = null;
	        this._parents = null;
	        // null out _subscriptions first so any child subscriptions that attempt
	        // to remove themselves from this subscription will noop
	        this._subscriptions = null;
	        var index = -1;
	        var len = _parents ? _parents.length : 0;
	        // if this._parent is null, then so is this._parents, and we
	        // don't have to remove ourselves from any parent subscriptions.
	        while (_parent) {
	            _parent.remove(this);
	            // if this._parents is null or index >= len,
	            // then _parent is set to null, and the loop exits
	            _parent = ++index < len && _parents[index] || null;
	        }
	        if (isFunction_1.isFunction(_unsubscribe)) {
	            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
	            if (trial === errorObject_1.errorObject) {
	                hasErrors = true;
	                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
	                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
	            }
	        }
	        if (isArray_1.isArray(_subscriptions)) {
	            index = -1;
	            len = _subscriptions.length;
	            while (++index < len) {
	                var sub = _subscriptions[index];
	                if (isObject_1.isObject(sub)) {
	                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
	                    if (trial === errorObject_1.errorObject) {
	                        hasErrors = true;
	                        errors = errors || [];
	                        var err = errorObject_1.errorObject.e;
	                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
	                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
	                        }
	                        else {
	                            errors.push(err);
	                        }
	                    }
	                }
	            }
	        }
	        if (hasErrors) {
	            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
	        }
	    };
	    /**
	     * Adds a tear down to be called during the unsubscribe() of this
	     * Subscription.
	     *
	     * If the tear down being added is a subscription that is already
	     * unsubscribed, is the same reference `add` is being called on, or is
	     * `Subscription.EMPTY`, it will not be added.
	     *
	     * If this subscription is already in an `closed` state, the passed
	     * tear down logic will be executed immediately.
	     *
	     * @param {TeardownLogic} teardown The additional logic to execute on
	     * teardown.
	     * @return {Subscription} Returns the Subscription used or created to be
	     * added to the inner subscriptions list. This Subscription can be used with
	     * `remove()` to remove the passed teardown logic from the inner subscriptions
	     * list.
	     */
	    Subscription.prototype.add = function (teardown) {
	        if (!teardown || (teardown === Subscription.EMPTY)) {
	            return Subscription.EMPTY;
	        }
	        if (teardown === this) {
	            return this;
	        }
	        var subscription = teardown;
	        switch (typeof teardown) {
	            case 'function':
	                subscription = new Subscription(teardown);
	            case 'object':
	                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
	                    return subscription;
	                }
	                else if (this.closed) {
	                    subscription.unsubscribe();
	                    return subscription;
	                }
	                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
	                    var tmp = subscription;
	                    subscription = new Subscription();
	                    subscription._subscriptions = [tmp];
	                }
	                break;
	            default:
	                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
	        }
	        var subscriptions = this._subscriptions || (this._subscriptions = []);
	        subscriptions.push(subscription);
	        subscription._addParent(this);
	        return subscription;
	    };
	    /**
	     * Removes a Subscription from the internal list of subscriptions that will
	     * unsubscribe during the unsubscribe process of this Subscription.
	     * @param {Subscription} subscription The subscription to remove.
	     * @return {void}
	     */
	    Subscription.prototype.remove = function (subscription) {
	        var subscriptions = this._subscriptions;
	        if (subscriptions) {
	            var subscriptionIndex = subscriptions.indexOf(subscription);
	            if (subscriptionIndex !== -1) {
	                subscriptions.splice(subscriptionIndex, 1);
	            }
	        }
	    };
	    Subscription.prototype._addParent = function (parent) {
	        var _a = this, _parent = _a._parent, _parents = _a._parents;
	        if (!_parent || _parent === parent) {
	            // If we don't have a parent, or the new parent is the same as the
	            // current parent, then set this._parent to the new parent.
	            this._parent = parent;
	        }
	        else if (!_parents) {
	            // If there's already one parent, but not multiple, allocate an Array to
	            // store the rest of the parent Subscriptions.
	            this._parents = [parent];
	        }
	        else if (_parents.indexOf(parent) === -1) {
	            // Only add the new parent to the _parents list if it's not already there.
	            _parents.push(parent);
	        }
	    };
	    Subscription.EMPTY = (function (empty) {
	        empty.closed = true;
	        return empty;
	    }(new Subscription()));
	    return Subscription;
	}());
	exports.Subscription = Subscription;
	function flattenUnsubscriptionErrors(errors) {
	    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
	}
	//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArray.js.map

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	"use strict";
	function isObject(x) {
	    return x != null && typeof x === 'object';
	}
	exports.isObject = isObject;
	//# sourceMappingURL=isObject.js.map

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var errorObject_1 = __webpack_require__(508);
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        return tryCatchTarget.apply(this, arguments);
	    }
	    catch (e) {
	        errorObject_1.errorObject.e = e;
	        return errorObject_1.errorObject;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	exports.tryCatch = tryCatch;
	;
	//# sourceMappingURL=tryCatch.js.map

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	"use strict";
	// typeof any so that it we don't have to cast when comparing a result to the error object
	exports.errorObject = { e: {} };
	//# sourceMappingURL=errorObject.js.map

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when one or more errors have occurred during the
	 * `unsubscribe` of a {@link Subscription}.
	 */
	var UnsubscriptionError = (function (_super) {
	    __extends(UnsubscriptionError, _super);
	    function UnsubscriptionError(errors) {
	        _super.call(this);
	        this.errors = errors;
	        var err = Error.call(this, errors ?
	            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
	        this.name = err.name = 'UnsubscriptionError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return UnsubscriptionError;
	}(Error));
	exports.UnsubscriptionError = UnsubscriptionError;
	//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	"use strict";
	exports.empty = {
	    closed: true,
	    next: function (value) { },
	    error: function (err) { throw err; },
	    complete: function () { }
	};
	//# sourceMappingURL=Observer.js.map

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	var Symbol = root_1.root.Symbol;
	exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
	    Symbol.for('rxSubscriber') : '@@rxSubscriber';
	/**
	 * @deprecated use rxSubscriber instead
	 */
	exports.$$rxSubscriber = exports.rxSubscriber;
	//# sourceMappingURL=rxSubscriber.js.map

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	function getSymbolObservable(context) {
	    var $$observable;
	    var Symbol = context.Symbol;
	    if (typeof Symbol === 'function') {
	        if (Symbol.observable) {
	            $$observable = Symbol.observable;
	        }
	        else {
	            $$observable = Symbol('observable');
	            Symbol.observable = $$observable;
	        }
	    }
	    else {
	        $$observable = '@@observable';
	    }
	    return $$observable;
	}
	exports.getSymbolObservable = getSymbolObservable;
	exports.observable = getSymbolObservable(root_1.root);
	/**
	 * @deprecated use observable instead
	 */
	exports.$$observable = exports.observable;
	//# sourceMappingURL=observable.js.map

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var noop_1 = __webpack_require__(514);
	/* tslint:enable:max-line-length */
	function pipe() {
	    var fns = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        fns[_i - 0] = arguments[_i];
	    }
	    return pipeFromArray(fns);
	}
	exports.pipe = pipe;
	/* @internal */
	function pipeFromArray(fns) {
	    if (!fns) {
	        return noop_1.noop;
	    }
	    if (fns.length === 1) {
	        return fns[0];
	    }
	    return function piped(input) {
	        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
	    };
	}
	exports.pipeFromArray = pipeFromArray;
	//# sourceMappingURL=pipe.js.map

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	/* tslint:disable:no-empty */
	function noop() { }
	exports.noop = noop;
	//# sourceMappingURL=noop.js.map

/***/ }),
/* 515 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an action is invalid because the object has been
	 * unsubscribed.
	 *
	 * @see {@link Subject}
	 * @see {@link BehaviorSubject}
	 *
	 * @class ObjectUnsubscribedError
	 */
	var ObjectUnsubscribedError = (function (_super) {
	    __extends(ObjectUnsubscribedError, _super);
	    function ObjectUnsubscribedError() {
	        var err = _super.call(this, 'object unsubscribed');
	        this.name = err.name = 'ObjectUnsubscribedError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ObjectUnsubscribedError;
	}(Error));
	exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
	//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(504);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubjectSubscription = (function (_super) {
	    __extends(SubjectSubscription, _super);
	    function SubjectSubscription(subject, subscriber) {
	        _super.call(this);
	        this.subject = subject;
	        this.subscriber = subscriber;
	        this.closed = false;
	    }
	    SubjectSubscription.prototype.unsubscribe = function () {
	        if (this.closed) {
	            return;
	        }
	        this.closed = true;
	        var subject = this.subject;
	        var observers = subject.observers;
	        this.subject = null;
	        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
	            return;
	        }
	        var subscriberIndex = observers.indexOf(this.subscriber);
	        if (subscriberIndex !== -1) {
	            observers.splice(subscriberIndex, 1);
	        }
	    };
	    return SubjectSubscription;
	}(Subscription_1.Subscription));
	exports.SubjectSubscription = SubjectSubscription;
	//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bindCallback_1 = __webpack_require__(518);
	Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundCallbackObservable_1 = __webpack_require__(519);
	exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
	//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var AsyncSubject_1 = __webpack_require__(520);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundCallbackObservable = (function (_super) {
	    __extends(BoundCallbackObservable, _super);
	    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a callback API to a function that returns an Observable.
	     *
	     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
	     * it will return a function `g` that when called as `g(x)` will output an
	     * Observable.</span>
	     *
	     * `bindCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, the
	     * last parameter must be a callback function that `func` calls when it is
	     * done.
	     *
	     * The output of `bindCallback` is a function that takes the same parameters
	     * as `func`, except the last one (the callback). When the output function
	     * is called with arguments it will return an Observable. If function `func`
	     * calls its callback with one argument the Observable will emit that value.
	     * If on the other hand the callback is called with multiple values the resulting
	     * Observable will emit an array with said values as arguments.
	     *
	     * It is very important to remember that input function `func` is not called
	     * when the output function is, but rather when the Observable returned by the output
	     * function is subscribed. This means if `func` makes an AJAX request, that request
	     * will be made every time someone subscribes to the resulting Observable, but not before.
	     *
	     * Optionally, a selector function can be passed to `bindObservable`. The selector function
	     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
	     * Even though by default multiple arguments passed to callback appear in the stream as an array
	     * the selector function will be called with arguments directly, just as the callback would.
	     * This means you can imagine the default selector (when one is not provided explicitly)
	     * as a function that aggregates all its arguments into an array, or simply returns first argument
	     * if there is only one.
	     *
	     * The last optional parameter - {@link Scheduler} - can be used to control when the call
	     * to `func` happens after someone subscribes to Observable, as well as when results
	     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
	     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
	     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
	     * and call `subscribe` on the output Observable all function calls that are currently executing
	     * will end before `func` is invoked.
	     *
	     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
	     * In particular, if the callback is called synchronously the subscription of the resulting Observable
	     * will call the `next` function synchronously as well.  If you want to defer that call,
	     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
	     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
	     *
	     * Note that the Observable created by the output function will always emit a single value
	     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
	     * calls will not appear in the stream. If you need to listen for multiple calls,
	     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
	     *
	     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
	     * will be the context that the output function has at call time. In particular, if `func`
	     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
	     * it is recommended that the context of the output function is set to that object as well.
	     *
	     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
	     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
	     * provides convenient error handling and probably is a better choice.
	     * `bindCallback` will treat such functions the same as any other and error parameters
	     * (whether passed or not) will always be interpreted as regular callback argument.
	     *
	     *
	     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
	     * // Suppose we have jQuery.getJSON('/my/url', callback)
	     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
	     * var result = getJSONAsObservable('/my/url');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Receive an array of arguments passed to a callback</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 5
	     *   console.log(b); // 'some string'
	     *   console.log(c); // {someProperty: 'someValue'}
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
	     * boundSomeFunction().subscribe(values => {
	     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
	     * });
	     *
	     *
	     * @example <caption>Use bindCallback with a selector function</caption>
	     * someFunction((a, b, c) => {
	     *   console.log(a); // 'a'
	     *   console.log(b); // 'b'
	     *   console.log(c); // 'c'
	     * });
	     *
	     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
	     * boundSomeFunction().subscribe(value => {
	     *   console.log(value) // 'abc'
	     * });
	     *
	     *
	     * @example <caption>Compare behaviour with and without async Scheduler</caption>
	     * function iCallMyCallbackSynchronously(cb) {
	     *   cb();
	     * }
	     *
	     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
	     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
	     *
	     * boundSyncFn().subscribe(() => console.log('I was sync!'));
	     * boundAsyncFn().subscribe(() => console.log('I was async!'));
	     * console.log('This happened...');
	     *
	     * // Logs:
	     * // I was sync!
	     * // This happened...
	     * // I was async!
	     *
	     *
	     * @example <caption>Use bindCallback on an object method</caption>
	     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
	     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
	     * .subscribe(subscriber);
	     *
	     *
	     * @see {@link bindNodeCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func A function with a callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps them to a value that is emitted on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the callback would deliver.
	     * @static true
	     * @name bindCallback
	     * @owner Observable
	     */
	    BoundCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    BoundCallbackObservable.dispatch = function (state) {
	        var self = this;
	        var source = state.source, subscriber = state.subscriber, context = state.context;
	        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
	        var subject = source.subject;
	        if (!subject) {
	            subject = source.subject = new AsyncSubject_1.AsyncSubject();
	            var handler = function handlerFn() {
	                var innerArgs = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    innerArgs[_i - 0] = arguments[_i];
	                }
	                var source = handlerFn.source;
	                var selector = source.selector, subject = source.subject;
	                if (selector) {
	                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                    if (result_2 === errorObject_1.errorObject) {
	                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                    }
	                    else {
	                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                    }
	                }
	                else {
	                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	                }
	            };
	            // use named function to pass values in without closure
	            handler.source = source;
	            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	            if (result === errorObject_1.errorObject) {
	                subject.error(errorObject_1.errorObject.e);
	            }
	        }
	        self.add(subject.subscribe(subscriber));
	    };
	    return BoundCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundCallbackObservable = BoundCallbackObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var Subscription_1 = __webpack_require__(504);
	/**
	 * @class AsyncSubject<T>
	 */
	var AsyncSubject = (function (_super) {
	    __extends(AsyncSubject, _super);
	    function AsyncSubject() {
	        _super.apply(this, arguments);
	        this.value = null;
	        this.hasNext = false;
	        this.hasCompleted = false;
	    }
	    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function (subscriber) {
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	            return Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.hasCompleted && this.hasNext) {
	            subscriber.next(this.value);
	            subscriber.complete();
	            return Subscription_1.Subscription.EMPTY;
	        }
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    AsyncSubject.prototype.next = function (value) {
	        if (!this.hasCompleted) {
	            this.value = value;
	            this.hasNext = true;
	        }
	    };
	    AsyncSubject.prototype.error = function (error) {
	        if (!this.hasCompleted) {
	            _super.prototype.error.call(this, error);
	        }
	    };
	    AsyncSubject.prototype.complete = function () {
	        this.hasCompleted = true;
	        if (this.hasNext) {
	            _super.prototype.next.call(this, this.value);
	        }
	        _super.prototype.complete.call(this);
	    };
	    return AsyncSubject;
	}(Subject_1.Subject));
	exports.AsyncSubject = AsyncSubject;
	//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bindNodeCallback_1 = __webpack_require__(522);
	Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BoundNodeCallbackObservable_1 = __webpack_require__(523);
	exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
	//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var AsyncSubject_1 = __webpack_require__(520);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var BoundNodeCallbackObservable = (function (_super) {
	    __extends(BoundNodeCallbackObservable, _super);
	    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
	        _super.call(this);
	        this.callbackFunc = callbackFunc;
	        this.selector = selector;
	        this.args = args;
	        this.context = context;
	        this.scheduler = scheduler;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Converts a Node.js-style callback API to a function that returns an
	     * Observable.
	     *
	     * <span class="informal">It's just like {@link bindCallback}, but the
	     * callback is expected to be of type `callback(error, result)`.</span>
	     *
	     * `bindNodeCallback` is not an operator because its input and output are not
	     * Observables. The input is a function `func` with some parameters, but the
	     * last parameter must be a callback function that `func` calls when it is
	     * done. The callback function is expected to follow Node.js conventions,
	     * where the first argument to the callback is an error object, signaling
	     * whether call was successful. If that object is passed to callback, it means
	     * something went wrong.
	     *
	     * The output of `bindNodeCallback` is a function that takes the same
	     * parameters as `func`, except the last one (the callback). When the output
	     * function is called with arguments, it will return an Observable.
	     * If `func` calls its callback with error parameter present, Observable will
	     * error with that value as well. If error parameter is not passed, Observable will emit
	     * second parameter. If there are more parameters (third and so on),
	     * Observable will emit an array with all arguments, except first error argument.
	     *
	     * Optionally `bindNodeCallback` accepts selector function, which allows you to
	     * make resulting Observable emit value computed by selector, instead of regular
	     * callback arguments. It works similarly to {@link bindCallback} selector, but
	     * Node.js-style error argument will never be passed to that function.
	     *
	     * Note that `func` will not be called at the same time output function is,
	     * but rather whenever resulting Observable is subscribed. By default call to
	     * `func` will happen synchronously after subscription, but that can be changed
	     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
	     * can also control when values from callback will be emitted by Observable.
	     * To find out more, check out documentation for {@link bindCallback}, where
	     * Scheduler works exactly the same.
	     *
	     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
	     * of returned function, when it is called.
	     *
	     * After Observable emits value, it will complete immediately. This means
	     * even if `func` calls callback again, values from second and consecutive
	     * calls will never appear on the stream. If you need to handle functions
	     * that call callbacks multiple times, check out {@link fromEvent} or
	     * {@link fromEventPattern} instead.
	     *
	     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
	     * "Node.js-style" callbacks are just a convention, so if you write for
	     * browsers or any other environment and API you use implements that callback style,
	     * `bindNodeCallback` can be safely used on that API functions as well.
	     *
	     * Remember that Error object passed to callback does not have to be an instance
	     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
	     * Error parameter of callback function is interpreted as "present", when value
	     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
	     * string or boolean `true`. In all of these cases resulting Observable would error
	     * with that value. This means usually regular style callbacks will fail very often when
	     * `bindNodeCallback` is used. If your Observable errors much more often then you
	     * would expect, check if callback really is called in Node.js-style and, if not,
	     * switch to {@link bindCallback} instead.
	     *
	     * Note that even if error parameter is technically present in callback, but its value
	     * is falsy, it still won't appear in array emitted by Observable or in selector function.
	     *
	     *
	     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
	     * import * as fs from 'fs';
	     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
	     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     *
	     * @example <caption>Use on function calling callback with multiple arguments</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // null
	     *   console.log(a); // 5
	     *   console.log(b); // "some string"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // [5, "some string"]
	     * });
	     *
	     *
	     * @example <caption>Use with selector function</caption>
	     * someFunction((err, a, b) => {
	     *   console.log(err); // undefined
	     *   console.log(a); // "abc"
	     *   console.log(b); // "DEF"
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
	     * boundSomeFunction()
	     * .subscribe(value => {
	     *   console.log(value); // "abcDEF"
	     * });
	     *
	     *
	     * @example <caption>Use on function calling callback in regular style</caption>
	     * someFunction(a => {
	     *   console.log(a); // 5
	     * });
	     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
	     * boundSomeFunction()
	     * .subscribe(
	     *   value => {}             // never gets called
	     *   err => console.log(err) // 5
	     *);
	     *
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     * @see {@link fromPromise}
	     *
	     * @param {function} func Function with a Node.js-style callback as the last parameter.
	     * @param {function} [selector] A function which takes the arguments from the
	     * callback and maps those to a value to emit on the output Observable.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * callbacks.
	     * @return {function(...params: *): Observable} A function which returns the
	     * Observable that delivers the same values the Node.js callback would
	     * deliver.
	     * @static true
	     * @name bindNodeCallback
	     * @owner Observable
	     */
	    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
	        if (selector === void 0) { selector = undefined; }
	        return function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
	        };
	    };
	    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
	        var callbackFunc = this.callbackFunc;
	        var args = this.args;
	        var scheduler = this.scheduler;
	        var subject = this.subject;
	        if (!scheduler) {
	            if (!subject) {
	                subject = this.subject = new AsyncSubject_1.AsyncSubject();
	                var handler = function handlerFn() {
	                    var innerArgs = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        innerArgs[_i - 0] = arguments[_i];
	                    }
	                    var source = handlerFn.source;
	                    var selector = source.selector, subject = source.subject;
	                    var err = innerArgs.shift();
	                    if (err) {
	                        subject.error(err);
	                    }
	                    else if (selector) {
	                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                        if (result_1 === errorObject_1.errorObject) {
	                            subject.error(errorObject_1.errorObject.e);
	                        }
	                        else {
	                            subject.next(result_1);
	                            subject.complete();
	                        }
	                    }
	                    else {
	                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
	                        subject.complete();
	                    }
	                };
	                // use named function instance to avoid closure.
	                handler.source = this;
	                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
	                if (result === errorObject_1.errorObject) {
	                    subject.error(errorObject_1.errorObject.e);
	                }
	            }
	            return subject.subscribe(subscriber);
	        }
	        else {
	            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
	        }
	    };
	    return BoundNodeCallbackObservable;
	}(Observable_1.Observable));
	exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
	function dispatch(state) {
	    var self = this;
	    var source = state.source, subscriber = state.subscriber, context = state.context;
	    // XXX: cast to `any` to access to the private field in `source`.
	    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
	    var subject = source.subject;
	    if (!subject) {
	        subject = source.subject = new AsyncSubject_1.AsyncSubject();
	        var handler = function handlerFn() {
	            var innerArgs = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                innerArgs[_i - 0] = arguments[_i];
	            }
	            var source = handlerFn.source;
	            var selector = source.selector, subject = source.subject;
	            var err = innerArgs.shift();
	            if (err) {
	                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
	            }
	            else if (selector) {
	                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
	                if (result_2 === errorObject_1.errorObject) {
	                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	                }
	                else {
	                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
	                }
	            }
	            else {
	                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
	                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
	            }
	        };
	        // use named function to pass values in without closure
	        handler.source = source;
	        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
	        if (result === errorObject_1.errorObject) {
	            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
	        }
	    }
	    self.add(subject.subscribe(subscriber));
	}
	function dispatchNext(arg) {
	    var value = arg.value, subject = arg.subject;
	    subject.next(value);
	    subject.complete();
	}
	function dispatchError(arg) {
	    var err = arg.err, subject = arg.subject;
	    subject.error(err);
	}
	//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var combineLatest_1 = __webpack_require__(525);
	Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(526);
	var isArray_1 = __webpack_require__(505);
	var ArrayObservable_1 = __webpack_require__(527);
	var combineLatest_1 = __webpack_require__(530);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from all the Observables passed as
	 * arguments. This is done by subscribing to each Observable in order and,
	 * whenever any Observable emits, collecting an array of the most recent
	 * values from each Observable. So if you pass `n` Observables to operator,
	 * returned Observable will always emit an array of `n` values, in order
	 * corresponding to order of passed Observables (value from the first Observable
	 * on the first place and so on).
	 *
	 * Static version of `combineLatest` accepts either an array of Observables
	 * or each Observable can be put directly as an argument. Note that array of
	 * Observables is good choice, if you don't know beforehand how many Observables
	 * you will combine. Passing empty array will result in Observable that
	 * completes immediately.
	 *
	 * To ensure output array has always the same length, `combineLatest` will
	 * actually wait for all input Observables to emit at least once,
	 * before it starts emitting results. This means if some Observable emits
	 * values before other Observables started emitting, all that values but last
	 * will be lost. On the other hand, is some Observable does not emit value but
	 * completes, resulting Observable will complete at the same moment without
	 * emitting anything, since it will be now impossible to include value from
	 * completed Observable in resulting array. Also, if some input Observable does
	 * not emit any value and never completes, `combineLatest` will also never emit
	 * and never complete, since, again, it will wait for all streams to emit some
	 * value.
	 *
	 * If at least one Observable was passed to `combineLatest` and all passed Observables
	 * emitted something, resulting Observable will complete when all combined
	 * streams complete. So even if some Observable completes, result of
	 * `combineLatest` will still emit values when other Observables do. In case
	 * of completed Observable, its value from now on will always be the last
	 * emitted value. On the other hand, if any Observable errors, `combineLatest`
	 * will error immediately as well, and all other Observables will be unsubscribed.
	 *
	 * `combineLatest` accepts as optional parameter `project` function, which takes
	 * as arguments all values that would normally be emitted by resulting Observable.
	 * `project` can return any kind of value, which will be then emitted by Observable
	 * instead of default array. Note that `project` does not take as argument that array
	 * of values, but values themselves. That means default `project` can be imagined
	 * as function that takes all its arguments and puts them into an array.
	 *
	 *
	 * @example <caption>Combine two timer Observables</caption>
	 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
	 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
	 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
	 * combinedTimers.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0] after 0.5s
	 * // [1, 0] after 1s
	 * // [1, 1] after 1.5s
	 * // [2, 1] after 2s
	 *
	 *
	 * @example <caption>Combine an array of Observables</caption>
	 * const observables = [1, 5, 10].map(
	 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
	 * );
	 * const combined = Rx.Observable.combineLatest(observables);
	 * combined.subscribe(value => console.log(value));
	 * // Logs
	 * // [0, 0, 0] immediately
	 * // [1, 0, 0] after 1s
	 * // [1, 5, 0] after 5s
	 * // [1, 5, 10] after 10s
	 *
	 *
	 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
	 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
	 * More than one input Observables may be given as arguments
	 * or an array of Observables may be given as the first argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each input Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @static true
	 * @name combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    var scheduler = null;
	    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
	        scheduler = observables.pop();
	    }
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0];
	    }
	    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 526 */
/***/ (function(module, exports) {

	"use strict";
	function isScheduler(value) {
	    return value && typeof value.schedule === 'function';
	}
	exports.isScheduler = isScheduler;
	//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var ScalarObservable_1 = __webpack_require__(528);
	var EmptyObservable_1 = __webpack_require__(529);
	var isScheduler_1 = __webpack_require__(526);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayObservable = (function (_super) {
	    __extends(ArrayObservable, _super);
	    function ArrayObservable(array, scheduler) {
	        _super.call(this);
	        this.array = array;
	        this.scheduler = scheduler;
	        if (!scheduler && array.length === 1) {
	            this._isScalar = true;
	            this.value = array[0];
	        }
	    }
	    ArrayObservable.create = function (array, scheduler) {
	        return new ArrayObservable(array, scheduler);
	    };
	    /**
	     * Creates an Observable that emits some values you specify as arguments,
	     * immediately one after the other, and then emits a complete notification.
	     *
	     * <span class="informal">Emits the arguments you provide, then completes.
	     * </span>
	     *
	     * <img src="./img/of.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the arguments given, and the complete notification thereafter. It can
	     * be used for composing with other Observables, such as with {@link concat}.
	     * By default, it uses a `null` IScheduler, which means the `next`
	     * notifications are sent synchronously, although with a different IScheduler
	     * it is possible to determine when those notifications will be delivered.
	     *
	     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
	     * var numbers = Rx.Observable.of(10, 20, 30);
	     * var letters = Rx.Observable.of('a', 'b', 'c');
	     * var interval = Rx.Observable.interval(1000);
	     * var result = numbers.concat(letters).concat(interval);
	     * result.subscribe(x => console.log(x));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link throw}
	     *
	     * @param {...T} values Arguments that represent `next` values to be emitted.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the `next` notifications.
	     * @return {Observable<T>} An Observable that emits each given input value.
	     * @static true
	     * @name of
	     * @owner Observable
	     */
	    ArrayObservable.of = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i - 0] = arguments[_i];
	        }
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len > 1) {
	            return new ArrayObservable(array, scheduler);
	        }
	        else if (len === 1) {
	            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
	        }
	        else {
	            return new EmptyObservable_1.EmptyObservable(scheduler);
	        }
	    };
	    ArrayObservable.dispatch = function (state) {
	        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(array[index]);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var array = this.array;
	        var count = array.length;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ArrayObservable.dispatch, 0, {
	                array: array, index: index, count: count, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < count && !subscriber.closed; i++) {
	                subscriber.next(array[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayObservable;
	}(Observable_1.Observable));
	exports.ArrayObservable = ArrayObservable;
	//# sourceMappingURL=ArrayObservable.js.map

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ScalarObservable = (function (_super) {
	    __extends(ScalarObservable, _super);
	    function ScalarObservable(value, scheduler) {
	        _super.call(this);
	        this.value = value;
	        this.scheduler = scheduler;
	        this._isScalar = true;
	        if (scheduler) {
	            this._isScalar = false;
	        }
	    }
	    ScalarObservable.create = function (value, scheduler) {
	        return new ScalarObservable(value, scheduler);
	    };
	    ScalarObservable.dispatch = function (state) {
	        var done = state.done, value = state.value, subscriber = state.subscriber;
	        if (done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        state.done = true;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function (subscriber) {
	        var value = this.value;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(ScalarObservable.dispatch, 0, {
	                done: false, value: value, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.next(value);
	            if (!subscriber.closed) {
	                subscriber.complete();
	            }
	        }
	    };
	    return ScalarObservable;
	}(Observable_1.Observable));
	exports.ScalarObservable = ScalarObservable;
	//# sourceMappingURL=ScalarObservable.js.map

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var EmptyObservable = (function (_super) {
	    __extends(EmptyObservable, _super);
	    function EmptyObservable(scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits a complete notification.
	     *
	     * <span class="informal">Just emits 'complete', and nothing else.
	     * </span>
	     *
	     * <img src="./img/empty.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the complete notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then complete.</caption>
	     * var result = Rx.Observable.empty().startWith(7);
	     * result.subscribe(x => console.log(x));
	     *
	     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
	     * );
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following to the console:
	     * // x is equal to the count on the interval eg(0,1,2,3,...)
	     * // x will occur every 1000ms
	     * // if x % 2 is equal to 1 print abc
	     * // if x % 2 is not equal to 1 nothing will be output
	     *
	     * @see {@link create}
	     * @see {@link never}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the complete notification.
	     * @return {Observable} An "empty" Observable: emits only the complete
	     * notification.
	     * @static true
	     * @name empty
	     * @owner Observable
	     */
	    EmptyObservable.create = function (scheduler) {
	        return new EmptyObservable(scheduler);
	    };
	    EmptyObservable.dispatch = function (arg) {
	        var subscriber = arg.subscriber;
	        subscriber.complete();
	    };
	    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function (subscriber) {
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
	        }
	        else {
	            subscriber.complete();
	        }
	    };
	    return EmptyObservable;
	}(Observable_1.Observable));
	exports.EmptyObservable = EmptyObservable;
	//# sourceMappingURL=EmptyObservable.js.map

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(527);
	var isArray_1 = __webpack_require__(505);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	var none = {};
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = null;
	    if (typeof observables[observables.length - 1] === 'function') {
	        project = observables.pop();
	    }
	    // if the first and only other argument besides the resultSelector is an array
	    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
	    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	        observables = observables[0].slice();
	    }
	    return function (source) { return source.lift.call(new ArrayObservable_1.ArrayObservable([source].concat(observables)), new CombineLatestOperator(project)); };
	}
	exports.combineLatest = combineLatest;
	var CombineLatestOperator = (function () {
	    function CombineLatestOperator(project) {
	        this.project = project;
	    }
	    CombineLatestOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
	    };
	    return CombineLatestOperator;
	}());
	exports.CombineLatestOperator = CombineLatestOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CombineLatestSubscriber = (function (_super) {
	    __extends(CombineLatestSubscriber, _super);
	    function CombineLatestSubscriber(destination, project) {
	        _super.call(this, destination);
	        this.project = project;
	        this.active = 0;
	        this.values = [];
	        this.observables = [];
	    }
	    CombineLatestSubscriber.prototype._next = function (observable) {
	        this.values.push(none);
	        this.observables.push(observable);
	    };
	    CombineLatestSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            this.active = len;
	            this.toRespond = len;
	            for (var i = 0; i < len; i++) {
	                var observable = observables[i];
	                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
	        if ((this.active -= 1) === 0) {
	            this.destination.complete();
	        }
	    };
	    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var values = this.values;
	        var oldVal = values[outerIndex];
	        var toRespond = !this.toRespond
	            ? 0
	            : oldVal === none ? --this.toRespond : this.toRespond;
	        values[outerIndex] = innerValue;
	        if (toRespond === 0) {
	            if (this.project) {
	                this._tryProject(values);
	            }
	            else {
	                this.destination.next(values.slice());
	            }
	        }
	    };
	    CombineLatestSubscriber.prototype._tryProject = function (values) {
	        var result;
	        try {
	            result = this.project.apply(this, values);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return CombineLatestSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.CombineLatestSubscriber = CombineLatestSubscriber;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var OuterSubscriber = (function (_super) {
	    __extends(OuterSubscriber, _super);
	    function OuterSubscriber() {
	        _super.apply(this, arguments);
	    }
	    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(innerValue);
	    };
	    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.destination.error(error);
	    };
	    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.destination.complete();
	    };
	    return OuterSubscriber;
	}(Subscriber_1.Subscriber));
	exports.OuterSubscriber = OuterSubscriber;
	//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	var isArrayLike_1 = __webpack_require__(533);
	var isPromise_1 = __webpack_require__(534);
	var isObject_1 = __webpack_require__(506);
	var Observable_1 = __webpack_require__(499);
	var iterator_1 = __webpack_require__(535);
	var InnerSubscriber_1 = __webpack_require__(536);
	var observable_1 = __webpack_require__(512);
	function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
	    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
	    if (destination.closed) {
	        return null;
	    }
	    if (result instanceof Observable_1.Observable) {
	        if (result._isScalar) {
	            destination.next(result.value);
	            destination.complete();
	            return null;
	        }
	        else {
	            destination.syncErrorThrowable = true;
	            return result.subscribe(destination);
	        }
	    }
	    else if (isArrayLike_1.isArrayLike(result)) {
	        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
	            destination.next(result[i]);
	        }
	        if (!destination.closed) {
	            destination.complete();
	        }
	    }
	    else if (isPromise_1.isPromise(result)) {
	        result.then(function (value) {
	            if (!destination.closed) {
	                destination.next(value);
	                destination.complete();
	            }
	        }, function (err) { return destination.error(err); })
	            .then(null, function (err) {
	            // Escaping the Promise trap: globally throw unhandled errors
	            root_1.root.setTimeout(function () { throw err; });
	        });
	        return destination;
	    }
	    else if (result && typeof result[iterator_1.iterator] === 'function') {
	        var iterator = result[iterator_1.iterator]();
	        do {
	            var item = iterator.next();
	            if (item.done) {
	                destination.complete();
	                break;
	            }
	            destination.next(item.value);
	            if (destination.closed) {
	                break;
	            }
	        } while (true);
	    }
	    else if (result && typeof result[observable_1.observable] === 'function') {
	        var obs = result[observable_1.observable]();
	        if (typeof obs.subscribe !== 'function') {
	            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
	        }
	        else {
	            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
	        }
	    }
	    else {
	        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
	        var msg = ("You provided " + value + " where a stream was expected.")
	            + ' You can provide an Observable, Promise, Array, or Iterable.';
	        destination.error(new TypeError(msg));
	    }
	    return null;
	}
	exports.subscribeToResult = subscribeToResult;
	//# sourceMappingURL=subscribeToResult.js.map

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	"use strict";
	exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
	//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	"use strict";
	function isPromise(value) {
	    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
	}
	exports.isPromise = isPromise;
	//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	function symbolIteratorPonyfill(root) {
	    var Symbol = root.Symbol;
	    if (typeof Symbol === 'function') {
	        if (!Symbol.iterator) {
	            Symbol.iterator = Symbol('iterator polyfill');
	        }
	        return Symbol.iterator;
	    }
	    else {
	        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
	        var Set_1 = root.Set;
	        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
	            return '@@iterator';
	        }
	        var Map_1 = root.Map;
	        // required for compatability with es6-shim
	        if (Map_1) {
	            var keys = Object.getOwnPropertyNames(Map_1.prototype);
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
	                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
	                    return key;
	                }
	            }
	        }
	        return '@@iterator';
	    }
	}
	exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
	exports.iterator = symbolIteratorPonyfill(root_1.root);
	/**
	 * @deprecated use iterator instead
	 */
	exports.$$iterator = exports.iterator;
	//# sourceMappingURL=iterator.js.map

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerSubscriber = (function (_super) {
	    __extends(InnerSubscriber, _super);
	    function InnerSubscriber(parent, outerValue, outerIndex) {
	        _super.call(this);
	        this.parent = parent;
	        this.outerValue = outerValue;
	        this.outerIndex = outerIndex;
	        this.index = 0;
	    }
	    InnerSubscriber.prototype._next = function (value) {
	        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
	    };
	    InnerSubscriber.prototype._error = function (error) {
	        this.parent.notifyError(error, this);
	        this.unsubscribe();
	    };
	    InnerSubscriber.prototype._complete = function () {
	        this.parent.notifyComplete(this);
	        this.unsubscribe();
	    };
	    return InnerSubscriber;
	}(Subscriber_1.Subscriber));
	exports.InnerSubscriber = InnerSubscriber;
	//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var concat_1 = __webpack_require__(538);
	Observable_1.Observable.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isScheduler_1 = __webpack_require__(526);
	var of_1 = __webpack_require__(539);
	var from_1 = __webpack_require__(540);
	var concatAll_1 = __webpack_require__(547);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from given
	 * Observable and then moves on to the next.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * `concat` joins multiple Observables together, by subscribing to them one at a time and
	 * merging their results into the output Observable. You can pass either an array of
	 * Observables, or put them directly as arguments. Passing an empty array will result
	 * in Observable that completes immediately.
	 *
	 * `concat` will subscribe to first input Observable and emit all its values, without
	 * changing or affecting them in any way. When that Observable completes, it will
	 * subscribe to then next Observable passed and, again, emit its values. This will be
	 * repeated, until the operator runs out of Observables. When last input Observable completes,
	 * `concat` will complete as well. At any given moment only one Observable passed to operator
	 * emits values. If you would like to emit values from passed Observables concurrently, check out
	 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
	 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
	 *
	 * Note that if some input Observable never completes, `concat` will also never complete
	 * and Observables following the one that did not complete will never be subscribed. On the other
	 * hand, if some Observable simply completes immediately after it is subscribed, it will be
	 * invisible for `concat`, which will just move on to the next Observable.
	 *
	 * If any Observable in chain errors, instead of passing control to the next Observable,
	 * `concat` will error immediately as well. Observables that would be subscribed after
	 * the one that emitted error, never will.
	 *
	 * If you pass to `concat` the same Observable many times, its stream of values
	 * will be "replayed" on every subscription, which means you can repeat given Observable
	 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
	 * you can always use {@link repeat}.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = Rx.Observable.concat(timer, sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 *
	 * @example <caption>Concatenate an array of 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 *
	 * @example <caption>Concatenate the same Observable to repeat it</caption>
	 * const timer = Rx.Observable.interval(1000).take(2);
	 *
	 * Rx.Observable.concat(timer, timer) // concating the same Observable!
	 * .subscribe(
	 *   value => console.log(value),
	 *   err => {},
	 *   () => console.log('...and it is done!')
	 * );
	 *
	 * // Logs:
	 * // 0 after 1s
	 * // 1 after 2s
	 * // 0 after 3s
	 * // 1 after 4s
	 * // "...and it is done!" also after 4s
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} input1 An input Observable to concatenate with others.
	 * @param {ObservableInput} input2 An input Observable to concatenate with others.
	 * More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @static true
	 * @name concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    if (observables.length === 1 || (observables.length === 2 && isScheduler_1.isScheduler(observables[1]))) {
	        return from_1.from(observables[0]);
	    }
	    return concatAll_1.concatAll()(of_1.of.apply(void 0, observables));
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(527);
	exports.of = ArrayObservable_1.ArrayObservable.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromObservable_1 = __webpack_require__(541);
	exports.from = FromObservable_1.FromObservable.create;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(505);
	var isArrayLike_1 = __webpack_require__(533);
	var isPromise_1 = __webpack_require__(534);
	var PromiseObservable_1 = __webpack_require__(542);
	var IteratorObservable_1 = __webpack_require__(543);
	var ArrayObservable_1 = __webpack_require__(527);
	var ArrayLikeObservable_1 = __webpack_require__(544);
	var iterator_1 = __webpack_require__(535);
	var Observable_1 = __webpack_require__(499);
	var observeOn_1 = __webpack_require__(545);
	var observable_1 = __webpack_require__(512);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromObservable = (function (_super) {
	    __extends(FromObservable, _super);
	    function FromObservable(ish, scheduler) {
	        _super.call(this, null);
	        this.ish = ish;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable from an Array, an array-like object, a Promise, an
	     * iterable object, or an Observable-like object.
	     *
	     * <span class="informal">Converts almost anything to an Observable.</span>
	     *
	     * <img src="./img/from.png" width="100%">
	     *
	     * Convert various other objects and data types into Observables. `from`
	     * converts a Promise or an array-like or an
	     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
	     * object into an Observable that emits the items in that promise or array or
	     * iterable. A String, in this context, is treated as an array of characters.
	     * Observable-like objects (contains a function named with the ES2015 Symbol
	     * for Observable) can also be converted through this operator.
	     *
	     * @example <caption>Converts an array to an Observable</caption>
	     * var array = [10, 20, 30];
	     * var result = Rx.Observable.from(array);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 10 20 30
	     *
	     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
	     * function* generateDoubles(seed) {
	     *   var i = seed;
	     *   while (true) {
	     *     yield i;
	     *     i = 2 * i; // double it
	     *   }
	     * }
	     *
	     * var iterator = generateDoubles(3);
	     * var result = Rx.Observable.from(iterator).take(10);
	     * result.subscribe(x => console.log(x));
	     *
	     * // Results in the following:
	     * // 3 6 12 24 48 96 192 384 768 1536
	     *
	     * @see {@link create}
	     * @see {@link fromEvent}
	     * @see {@link fromEventPattern}
	     * @see {@link fromPromise}
	     *
	     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
	     * Observable-like, an Array, an iterable or an array-like object to be
	     * converted.
	     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
	     * emissions of values.
	     * @return {Observable<T>} The Observable whose values are originally from the
	     * input object that was converted.
	     * @static true
	     * @name from
	     * @owner Observable
	     */
	    FromObservable.create = function (ish, scheduler) {
	        if (ish != null) {
	            if (typeof ish[observable_1.observable] === 'function') {
	                if (ish instanceof Observable_1.Observable && !scheduler) {
	                    return ish;
	                }
	                return new FromObservable(ish, scheduler);
	            }
	            else if (isArray_1.isArray(ish)) {
	                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
	            }
	            else if (isPromise_1.isPromise(ish)) {
	                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
	            }
	            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
	                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
	            }
	            else if (isArrayLike_1.isArrayLike(ish)) {
	                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
	            }
	        }
	        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
	    };
	    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function (subscriber) {
	        var ish = this.ish;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            return ish[observable_1.observable]().subscribe(subscriber);
	        }
	        else {
	            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
	        }
	    };
	    return FromObservable;
	}(Observable_1.Observable));
	exports.FromObservable = FromObservable;
	//# sourceMappingURL=FromObservable.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(500);
	var Observable_1 = __webpack_require__(499);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PromiseObservable = (function (_super) {
	    __extends(PromiseObservable, _super);
	    function PromiseObservable(promise, scheduler) {
	        _super.call(this);
	        this.promise = promise;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Converts a Promise to an Observable.
	     *
	     * <span class="informal">Returns an Observable that just emits the Promise's
	     * resolved value, then completes.</span>
	     *
	     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
	     * Observable. If the Promise resolves with a value, the output Observable
	     * emits that resolved value as a `next`, and then completes. If the Promise
	     * is rejected, then the output Observable emits the corresponding Error.
	     *
	     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
	     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link bindCallback}
	     * @see {@link from}
	     *
	     * @param {PromiseLike<T>} promise The promise to be converted.
	     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
	     * the delivery of the resolved value (or the rejection).
	     * @return {Observable<T>} An Observable which wraps the Promise.
	     * @static true
	     * @name fromPromise
	     * @owner Observable
	     */
	    PromiseObservable.create = function (promise, scheduler) {
	        return new PromiseObservable(promise, scheduler);
	    };
	    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var promise = this.promise;
	        var scheduler = this.scheduler;
	        if (scheduler == null) {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    subscriber.next(this.value);
	                    subscriber.complete();
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.next(value);
	                        subscriber.complete();
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.error(err);
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	        else {
	            if (this._isScalar) {
	                if (!subscriber.closed) {
	                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
	                }
	            }
	            else {
	                promise.then(function (value) {
	                    _this.value = value;
	                    _this._isScalar = true;
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
	                    }
	                }, function (err) {
	                    if (!subscriber.closed) {
	                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
	                    }
	                })
	                    .then(null, function (err) {
	                    // escape the promise trap, throw unhandled errors
	                    root_1.root.setTimeout(function () { throw err; });
	                });
	            }
	        }
	    };
	    return PromiseObservable;
	}(Observable_1.Observable));
	exports.PromiseObservable = PromiseObservable;
	function dispatchNext(arg) {
	    var value = arg.value, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.next(value);
	        subscriber.complete();
	    }
	}
	function dispatchError(arg) {
	    var err = arg.err, subscriber = arg.subscriber;
	    if (!subscriber.closed) {
	        subscriber.error(err);
	    }
	}
	//# sourceMappingURL=PromiseObservable.js.map

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(500);
	var Observable_1 = __webpack_require__(499);
	var iterator_1 = __webpack_require__(535);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IteratorObservable = (function (_super) {
	    __extends(IteratorObservable, _super);
	    function IteratorObservable(iterator, scheduler) {
	        _super.call(this);
	        this.scheduler = scheduler;
	        if (iterator == null) {
	            throw new Error('iterator cannot be null.');
	        }
	        this.iterator = getIterator(iterator);
	    }
	    IteratorObservable.create = function (iterator, scheduler) {
	        return new IteratorObservable(iterator, scheduler);
	    };
	    IteratorObservable.dispatch = function (state) {
	        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
	        if (hasError) {
	            subscriber.error(state.error);
	            return;
	        }
	        var result = iterator.next();
	        if (result.done) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(result.value);
	        state.index = index + 1;
	        if (subscriber.closed) {
	            if (typeof iterator.return === 'function') {
	                iterator.return();
	            }
	            return;
	        }
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(IteratorObservable.dispatch, 0, {
	                index: index, iterator: iterator, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                var result = iterator.next();
	                if (result.done) {
	                    subscriber.complete();
	                    break;
	                }
	                else {
	                    subscriber.next(result.value);
	                }
	                if (subscriber.closed) {
	                    if (typeof iterator.return === 'function') {
	                        iterator.return();
	                    }
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return IteratorObservable;
	}(Observable_1.Observable));
	exports.IteratorObservable = IteratorObservable;
	var StringIterator = (function () {
	    function StringIterator(str, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = str.length; }
	        this.str = str;
	        this.idx = idx;
	        this.len = len;
	    }
	    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
	    StringIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.str.charAt(this.idx++)
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return StringIterator;
	}());
	var ArrayIterator = (function () {
	    function ArrayIterator(arr, idx, len) {
	        if (idx === void 0) { idx = 0; }
	        if (len === void 0) { len = toLength(arr); }
	        this.arr = arr;
	        this.idx = idx;
	        this.len = len;
	    }
	    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
	    ArrayIterator.prototype.next = function () {
	        return this.idx < this.len ? {
	            done: false,
	            value: this.arr[this.idx++]
	        } : {
	            done: true,
	            value: undefined
	        };
	    };
	    return ArrayIterator;
	}());
	function getIterator(obj) {
	    var i = obj[iterator_1.iterator];
	    if (!i && typeof obj === 'string') {
	        return new StringIterator(obj);
	    }
	    if (!i && obj.length !== undefined) {
	        return new ArrayIterator(obj);
	    }
	    if (!i) {
	        throw new TypeError('object is not iterable');
	    }
	    return obj[iterator_1.iterator]();
	}
	var maxSafeInteger = Math.pow(2, 53) - 1;
	function toLength(o) {
	    var len = +o.length;
	    if (isNaN(len)) {
	        return 0;
	    }
	    if (len === 0 || !numberIsFinite(len)) {
	        return len;
	    }
	    len = sign(len) * Math.floor(Math.abs(len));
	    if (len <= 0) {
	        return 0;
	    }
	    if (len > maxSafeInteger) {
	        return maxSafeInteger;
	    }
	    return len;
	}
	function numberIsFinite(value) {
	    return typeof value === 'number' && root_1.root.isFinite(value);
	}
	function sign(value) {
	    var valueAsNumber = +value;
	    if (valueAsNumber === 0) {
	        return valueAsNumber;
	    }
	    if (isNaN(valueAsNumber)) {
	        return valueAsNumber;
	    }
	    return valueAsNumber < 0 ? -1 : 1;
	}
	//# sourceMappingURL=IteratorObservable.js.map

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var ScalarObservable_1 = __webpack_require__(528);
	var EmptyObservable_1 = __webpack_require__(529);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ArrayLikeObservable = (function (_super) {
	    __extends(ArrayLikeObservable, _super);
	    function ArrayLikeObservable(arrayLike, scheduler) {
	        _super.call(this);
	        this.arrayLike = arrayLike;
	        this.scheduler = scheduler;
	        if (!scheduler && arrayLike.length === 1) {
	            this._isScalar = true;
	            this.value = arrayLike[0];
	        }
	    }
	    ArrayLikeObservable.create = function (arrayLike, scheduler) {
	        var length = arrayLike.length;
	        if (length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (length === 1) {
	            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
	        }
	        else {
	            return new ArrayLikeObservable(arrayLike, scheduler);
	        }
	    };
	    ArrayLikeObservable.dispatch = function (state) {
	        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
	        if (subscriber.closed) {
	            return;
	        }
	        if (index >= length) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(arrayLike[index]);
	        state.index = index + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
	        var length = arrayLike.length;
	        if (scheduler) {
	            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
	                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
	            });
	        }
	        else {
	            for (var i = 0; i < length && !subscriber.closed; i++) {
	                subscriber.next(arrayLike[i]);
	            }
	            subscriber.complete();
	        }
	    };
	    return ArrayLikeObservable;
	}(Observable_1.Observable));
	exports.ArrayLikeObservable = ArrayLikeObservable;
	//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Notification_1 = __webpack_require__(546);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function observeOnOperatorFunction(source) {
	        return source.lift(new ObserveOnOperator(scheduler, delay));
	    };
	}
	exports.observeOn = observeOn;
	var ObserveOnOperator = (function () {
	    function ObserveOnOperator(scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
	    };
	    return ObserveOnOperator;
	}());
	exports.ObserveOnOperator = ObserveOnOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ObserveOnSubscriber = (function (_super) {
	    __extends(ObserveOnSubscriber, _super);
	    function ObserveOnSubscriber(destination, scheduler, delay) {
	        if (delay === void 0) { delay = 0; }
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    ObserveOnSubscriber.dispatch = function (arg) {
	        var notification = arg.notification, destination = arg.destination;
	        notification.observe(destination);
	        this.unsubscribe();
	    };
	    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
	        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
	    };
	    ObserveOnSubscriber.prototype._next = function (value) {
	        this.scheduleMessage(Notification_1.Notification.createNext(value));
	    };
	    ObserveOnSubscriber.prototype._error = function (err) {
	        this.scheduleMessage(Notification_1.Notification.createError(err));
	    };
	    ObserveOnSubscriber.prototype._complete = function () {
	        this.scheduleMessage(Notification_1.Notification.createComplete());
	    };
	    return ObserveOnSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ObserveOnSubscriber = ObserveOnSubscriber;
	var ObserveOnMessage = (function () {
	    function ObserveOnMessage(notification, destination) {
	        this.notification = notification;
	        this.destination = destination;
	    }
	    return ObserveOnMessage;
	}());
	exports.ObserveOnMessage = ObserveOnMessage;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	/**
	 * Represents a push-based event or value that an {@link Observable} can emit.
	 * This class is particularly useful for operators that manage notifications,
	 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
	 * others. Besides wrapping the actual delivered value, it also annotates it
	 * with metadata of, for instance, what type of push message it is (`next`,
	 * `error`, or `complete`).
	 *
	 * @see {@link materialize}
	 * @see {@link dematerialize}
	 * @see {@link observeOn}
	 *
	 * @class Notification<T>
	 */
	var Notification = (function () {
	    function Notification(kind, value, error) {
	        this.kind = kind;
	        this.value = value;
	        this.error = error;
	        this.hasValue = kind === 'N';
	    }
	    /**
	     * Delivers to the given `observer` the value wrapped by this Notification.
	     * @param {Observer} observer
	     * @return
	     */
	    Notification.prototype.observe = function (observer) {
	        switch (this.kind) {
	            case 'N':
	                return observer.next && observer.next(this.value);
	            case 'E':
	                return observer.error && observer.error(this.error);
	            case 'C':
	                return observer.complete && observer.complete();
	        }
	    };
	    /**
	     * Given some {@link Observer} callbacks, deliver the value represented by the
	     * current Notification to the correctly corresponding callback.
	     * @param {function(value: T): void} next An Observer `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.do = function (next, error, complete) {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return next && next(this.value);
	            case 'E':
	                return error && error(this.error);
	            case 'C':
	                return complete && complete();
	        }
	    };
	    /**
	     * Takes an Observer or its individual callback functions, and calls `observe`
	     * or `do` methods accordingly.
	     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
	     * the `next` callback.
	     * @param {function(err: any): void} [error] An Observer `error` callback.
	     * @param {function(): void} [complete] An Observer `complete` callback.
	     * @return {any}
	     */
	    Notification.prototype.accept = function (nextOrObserver, error, complete) {
	        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
	            return this.observe(nextOrObserver);
	        }
	        else {
	            return this.do(nextOrObserver, error, complete);
	        }
	    };
	    /**
	     * Returns a simple Observable that just delivers the notification represented
	     * by this Notification instance.
	     * @return {any}
	     */
	    Notification.prototype.toObservable = function () {
	        var kind = this.kind;
	        switch (kind) {
	            case 'N':
	                return Observable_1.Observable.of(this.value);
	            case 'E':
	                return Observable_1.Observable.throw(this.error);
	            case 'C':
	                return Observable_1.Observable.empty();
	        }
	        throw new Error('unexpected notification kind value');
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `next` from a
	     * given value.
	     * @param {T} value The `next` value.
	     * @return {Notification<T>} The "next" Notification representing the
	     * argument.
	     */
	    Notification.createNext = function (value) {
	        if (typeof value !== 'undefined') {
	            return new Notification('N', value);
	        }
	        return Notification.undefinedValueNotification;
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `error` from a
	     * given error.
	     * @param {any} [err] The `error` error.
	     * @return {Notification<T>} The "error" Notification representing the
	     * argument.
	     */
	    Notification.createError = function (err) {
	        return new Notification('E', undefined, err);
	    };
	    /**
	     * A shortcut to create a Notification instance of the type `complete`.
	     * @return {Notification<any>} The valueless "complete" Notification.
	     */
	    Notification.createComplete = function () {
	        return Notification.completeNotification;
	    };
	    Notification.completeNotification = new Notification('C');
	    Notification.undefinedValueNotification = new Notification('N', undefined);
	    return Notification;
	}());
	exports.Notification = Notification;
	//# sourceMappingURL=Notification.js.map

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(548);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return mergeAll_1.mergeAll(1);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(549);
	var identity_1 = __webpack_require__(550);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(identity_1.identity, null, concurrent);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function mergeMapOperatorFunction(source) {
	        if (typeof resultSelector === 'number') {
	            concurrent = resultSelector;
	            resultSelector = null;
	        }
	        return source.lift(new MergeMapOperator(project, resultSelector, concurrent));
	    };
	}
	exports.mergeMap = mergeMap;
	var MergeMapOperator = (function () {
	    function MergeMapOperator(project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
	    };
	    return MergeMapOperator;
	}());
	exports.MergeMapOperator = MergeMapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapSubscriber = (function (_super) {
	    __extends(MergeMapSubscriber, _super);
	    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            this._tryNext(value);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapSubscriber.prototype._tryNext = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.active++;
	        this._innerSub(result, value, index);
	    };
	    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapSubscriber = MergeMapSubscriber;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 550 */
/***/ (function(module, exports) {

	"use strict";
	function identity(x) {
	    return x;
	}
	exports.identity = identity;
	//# sourceMappingURL=identity.js.map

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var defer_1 = __webpack_require__(552);
	Observable_1.Observable.defer = defer_1.defer;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var DeferObservable_1 = __webpack_require__(553);
	exports.defer = DeferObservable_1.DeferObservable.create;
	//# sourceMappingURL=defer.js.map

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var DeferObservable = (function (_super) {
	    __extends(DeferObservable, _super);
	    function DeferObservable(observableFactory) {
	        _super.call(this);
	        this.observableFactory = observableFactory;
	    }
	    /**
	     * Creates an Observable that, on subscribe, calls an Observable factory to
	     * make an Observable for each new Observer.
	     *
	     * <span class="informal">Creates the Observable lazily, that is, only when it
	     * is subscribed.
	     * </span>
	     *
	     * <img src="./img/defer.png" width="100%">
	     *
	     * `defer` allows you to create the Observable only when the Observer
	     * subscribes, and create a fresh Observable for each Observer. It waits until
	     * an Observer subscribes to it, and then it generates an Observable,
	     * typically with an Observable factory function. It does this afresh for each
	     * subscriber, so although each subscriber may think it is subscribing to the
	     * same Observable, in fact each subscriber gets its own individual
	     * Observable.
	     *
	     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
	     * var clicksOrInterval = Rx.Observable.defer(function () {
	     *   if (Math.random() > 0.5) {
	     *     return Rx.Observable.fromEvent(document, 'click');
	     *   } else {
	     *     return Rx.Observable.interval(1000);
	     *   }
	     * });
	     * clicksOrInterval.subscribe(x => console.log(x));
	     *
	     * // Results in the following behavior:
	     * // If the result of Math.random() is greater than 0.5 it will listen
	     * // for clicks anywhere on the "document"; when document is clicked it
	     * // will log a MouseEvent object to the console. If the result is less
	     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
	     *
	     * @see {@link create}
	     *
	     * @param {function(): SubscribableOrPromise} observableFactory The Observable
	     * factory function to invoke for each Observer that subscribes to the output
	     * Observable. May also return a Promise, which will be converted on the fly
	     * to an Observable.
	     * @return {Observable} An Observable whose Observers' subscriptions trigger
	     * an invocation of the given Observable factory function.
	     * @static true
	     * @name defer
	     * @owner Observable
	     */
	    DeferObservable.create = function (observableFactory) {
	        return new DeferObservable(observableFactory);
	    };
	    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function (subscriber) {
	        return new DeferSubscriber(subscriber, this.observableFactory);
	    };
	    return DeferObservable;
	}(Observable_1.Observable));
	exports.DeferObservable = DeferObservable;
	var DeferSubscriber = (function (_super) {
	    __extends(DeferSubscriber, _super);
	    function DeferSubscriber(destination, factory) {
	        _super.call(this, destination);
	        this.factory = factory;
	        this.tryDefer();
	    }
	    DeferSubscriber.prototype.tryDefer = function () {
	        try {
	            this._callFactory();
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    DeferSubscriber.prototype._callFactory = function () {
	        var result = this.factory();
	        if (result) {
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return DeferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=DeferObservable.js.map

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var empty_1 = __webpack_require__(555);
	Observable_1.Observable.empty = empty_1.empty;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var EmptyObservable_1 = __webpack_require__(529);
	exports.empty = EmptyObservable_1.EmptyObservable.create;
	//# sourceMappingURL=empty.js.map

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var forkJoin_1 = __webpack_require__(557);
	Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ForkJoinObservable_1 = __webpack_require__(558);
	exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
	//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var EmptyObservable_1 = __webpack_require__(529);
	var isArray_1 = __webpack_require__(505);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ForkJoinObservable = (function (_super) {
	    __extends(ForkJoinObservable, _super);
	    function ForkJoinObservable(sources, resultSelector) {
	        _super.call(this);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Joins last values emitted by passed Observables.
	     *
	     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
	     *
	     * <img src="./img/forkJoin.png" width="100%">
	     *
	     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
	     * or directly as arguments. If no input Observables are provided, resulting stream will complete
	     * immediately.
	     *
	     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
	     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
	     * array will have `n` values, where first value is the last thing emitted by the first Observable,
	     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
	     * not emit more than once and it will complete after that. If you need to emit combined values not only
	     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
	     * or {@link zip} instead.
	     *
	     * In order for resulting array to have the same length as the number of input Observables, whenever any of
	     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
	     * and it will not emit anything either, even if it already has some last values from other Observables.
	     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
	     * unless at any point some other Observable completes without emitting value, which brings us back to
	     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
	     * have to emit something at least once and complete.
	     *
	     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
	     * will be immediately unsubscribed.
	     *
	     * Optionally `forkJoin` accepts project function, that will be called with values which normally
	     * would land in emitted array. Whatever is returned by project function, will appear in output
	     * Observable instead. This means that default project can be thought of as a function that takes
	     * all its arguments and puts them into an array. Note that project function will be called only
	     * when output Observable is supposed to emit a result.
	     *
	     * @example <caption>Use forkJoin with operator emitting immediately</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.of(1, 2, 3, 4),
	     *   Rx.Observable.of(5, 6, 7, 8)
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [4, 8]
	     * // "This is how it ends!"
	     *
	     *
	     * @example <caption>Use forkJoin with operator emitting after some time</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // [2, 3] after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     *
	     * @example <caption>Use forkJoin with project function</caption>
	     * const observable = Rx.Observable.forkJoin(
	     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
	     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
	     *   (n, m) => n + m
	     * );
	     * observable.subscribe(
	     *   value => console.log(value),
	     *   err => {},
	     *   () => console.log('This is how it ends!')
	     * );
	     *
	     * // Logs:
	     * // 5 after 3 seconds
	     * // "This is how it ends!" immediately after
	     *
	     * @see {@link combineLatest}
	     * @see {@link zip}
	     *
	     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
	     * passed directly to the operator.
	     * @param {function} [project] Function that takes values emitted by input Observables and returns value
	     * that will appear in resulting Observable instead of default array.
	     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
	     * or value from project function.
	     * @static true
	     * @name forkJoin
	     * @owner Observable
	     */
	    ForkJoinObservable.create = function () {
	        var sources = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            sources[_i - 0] = arguments[_i];
	        }
	        if (sources === null || arguments.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        var resultSelector = null;
	        if (typeof sources[sources.length - 1] === 'function') {
	            resultSelector = sources.pop();
	        }
	        // if the first and only other argument besides the resultSelector is an array
	        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
	        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
	            sources = sources[0];
	        }
	        if (sources.length === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        return new ForkJoinObservable(sources, resultSelector);
	    };
	    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function (subscriber) {
	        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
	    };
	    return ForkJoinObservable;
	}(Observable_1.Observable));
	exports.ForkJoinObservable = ForkJoinObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ForkJoinSubscriber = (function (_super) {
	    __extends(ForkJoinSubscriber, _super);
	    function ForkJoinSubscriber(destination, sources, resultSelector) {
	        _super.call(this, destination);
	        this.sources = sources;
	        this.resultSelector = resultSelector;
	        this.completed = 0;
	        this.haveValues = 0;
	        var len = sources.length;
	        this.total = len;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            var source = sources[i];
	            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
	            if (innerSubscription) {
	                innerSubscription.outerIndex = i;
	                this.add(innerSubscription);
	            }
	        }
	    }
	    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        if (!innerSub._hasValue) {
	            innerSub._hasValue = true;
	            this.haveValues++;
	        }
	    };
	    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
	        var destination = this.destination;
	        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
	        var len = values.length;
	        if (!innerSub._hasValue) {
	            destination.complete();
	            return;
	        }
	        this.completed++;
	        if (this.completed !== len) {
	            return;
	        }
	        if (haveValues === len) {
	            var value = resultSelector ? resultSelector.apply(this, values) : values;
	            destination.next(value);
	        }
	        destination.complete();
	    };
	    return ForkJoinSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var from_1 = __webpack_require__(540);
	Observable_1.Observable.from = from_1.from;
	//# sourceMappingURL=from.js.map

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var fromEvent_1 = __webpack_require__(561);
	Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventObservable_1 = __webpack_require__(562);
	exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
	//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var tryCatch_1 = __webpack_require__(507);
	var isFunction_1 = __webpack_require__(503);
	var errorObject_1 = __webpack_require__(508);
	var Subscription_1 = __webpack_require__(504);
	var toString = Object.prototype.toString;
	function isNodeStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
	}
	function isJQueryStyleEventEmitter(sourceObj) {
	    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
	}
	function isNodeList(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
	}
	function isHTMLCollection(sourceObj) {
	    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
	}
	function isEventTarget(sourceObj) {
	    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventObservable = (function (_super) {
	    __extends(FromEventObservable, _super);
	    function FromEventObservable(sourceObj, eventName, selector, options) {
	        _super.call(this);
	        this.sourceObj = sourceObj;
	        this.eventName = eventName;
	        this.selector = selector;
	        this.options = options;
	    }
	    /* tslint:enable:max-line-length */
	    /**
	     * Creates an Observable that emits events of a specific type coming from the
	     * given event target.
	     *
	     * <span class="informal">Creates an Observable from DOM events, or Node.js
	     * EventEmitter events or others.</span>
	     *
	     * <img src="./img/fromEvent.png" width="100%">
	     *
	     * `fromEvent` accepts as a first argument event target, which is an object with methods
	     * for registering event handler functions. As a second argument it takes string that indicates
	     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
	     * which are described in detail below. If your event target does not match any of the ones listed,
	     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
	     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
	     * handler functions have different names, but they all accept a string describing event type
	     * and function itself, which will be called whenever said event happens.
	     *
	     * Every time resulting Observable is subscribed, event handler function will be registered
	     * to event target on given event type. When that event fires, value
	     * passed as a first argument to registered function will be emitted by output Observable.
	     * When Observable is unsubscribed, function will be unregistered from event target.
	     *
	     * Note that if event target calls registered function with more than one argument, second
	     * and following arguments will not appear in resulting stream. In order to get access to them,
	     * you can pass to `fromEvent` optional project function, which will be called with all arguments
	     * passed to event handler. Output Observable will then emit value returned by project function,
	     * instead of the usual value.
	     *
	     * Remember that event targets listed below are checked via duck typing. It means that
	     * no matter what kind of object you have and no matter what environment you work in,
	     * you can safely use `fromEvent` on that object if it exposes described methods (provided
	     * of course they behave as was described above). So for example if Node.js library exposes
	     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
	     * a good choice.
	     *
	     * If the API you use is more callback then event handler oriented (subscribed
	     * callback function fires only once and thus there is no need to manually
	     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
	     * instead.
	     *
	     * `fromEvent` supports following types of event targets:
	     *
	     * **DOM EventTarget**
	     *
	     * This is an object with `addEventListener` and `removeEventListener` methods.
	     *
	     * In the browser, `addEventListener` accepts - apart from event type string and event
	     * handler function arguments - optional third parameter, which is either an object or boolean,
	     * both used for additional configuration how and when passed function will be called. When
	     * `fromEvent` is used with event target of that type, you can provide this values
	     * as third parameter as well.
	     *
	     * **Node.js EventEmitter**
	     *
	     * An object with `addListener` and `removeListener` methods.
	     *
	     * **JQuery-style event target**
	     *
	     * An object with `on` and `off` methods
	     *
	     * **DOM NodeList**
	     *
	     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
	     *
	     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
	     * it contains and install event handler function in every of them. When returned Observable
	     * is unsubscribed, function will be removed from all Nodes.
	     *
	     * **DOM HtmlCollection**
	     *
	     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
	     * installed and removed in each of elements.
	     *
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * var clicks = Rx.Observable.fromEvent(document, 'click');
	     * clicks.subscribe(x => console.log(x));
	     *
	     * // Results in:
	     * // MouseEvent object logged to console every time a click
	     * // occurs on the document.
	     *
	     *
	     * @example <caption>Use addEventListener with capture option</caption>
	     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
	     *                                                                          // which will be passed to addEventListener
	     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
	     *
	     * clicksInDocument.subscribe(() => console.log('document'));
	     * clicksInDiv.subscribe(() => console.log('div'));
	     *
	     * // By default events bubble UP in DOM tree, so normally
	     * // when we would click on div in document
	     * // "div" would be logged first and then "document".
	     * // Since we specified optional `capture` option, document
	     * // will catch event when it goes DOWN DOM tree, so console
	     * // will log "document" and then "div".
	     *
	     * @see {@link bindCallback}
	     * @see {@link bindNodeCallback}
	     * @see {@link fromEventPattern}
	     *
	     * @param {EventTargetLike} target The DOM EventTarget, Node.js
	     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
	     * @param {string} eventName The event name of interest, being emitted by the
	     * `target`.
	     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
	     * @param {SelectorMethodSignature<T>} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEvent
	     * @owner Observable
	     */
	    FromEventObservable.create = function (target, eventName, options, selector) {
	        if (isFunction_1.isFunction(options)) {
	            selector = options;
	            options = undefined;
	        }
	        return new FromEventObservable(target, eventName, selector, options);
	    };
	    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
	        var unsubscribe;
	        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
	            for (var i = 0, len = sourceObj.length; i < len; i++) {
	                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
	            }
	        }
	        else if (isEventTarget(sourceObj)) {
	            var source_1 = sourceObj;
	            sourceObj.addEventListener(eventName, handler, options);
	            unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
	        }
	        else if (isJQueryStyleEventEmitter(sourceObj)) {
	            var source_2 = sourceObj;
	            sourceObj.on(eventName, handler);
	            unsubscribe = function () { return source_2.off(eventName, handler); };
	        }
	        else if (isNodeStyleEventEmitter(sourceObj)) {
	            var source_3 = sourceObj;
	            sourceObj.addListener(eventName, handler);
	            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
	        }
	        else {
	            throw new TypeError('Invalid event target');
	        }
	        subscriber.add(new Subscription_1.Subscription(unsubscribe));
	    };
	    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function (subscriber) {
	        var sourceObj = this.sourceObj;
	        var eventName = this.eventName;
	        var options = this.options;
	        var selector = this.selector;
	        var handler = selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
	            if (result === errorObject_1.errorObject) {
	                subscriber.error(errorObject_1.errorObject.e);
	            }
	            else {
	                subscriber.next(result);
	            }
	        } : function (e) { return subscriber.next(e); };
	        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
	    };
	    return FromEventObservable;
	}(Observable_1.Observable));
	exports.FromEventObservable = FromEventObservable;
	//# sourceMappingURL=FromEventObservable.js.map

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var fromEventPattern_1 = __webpack_require__(564);
	Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var FromEventPatternObservable_1 = __webpack_require__(565);
	exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
	//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isFunction_1 = __webpack_require__(503);
	var Observable_1 = __webpack_require__(499);
	var Subscription_1 = __webpack_require__(504);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var FromEventPatternObservable = (function (_super) {
	    __extends(FromEventPatternObservable, _super);
	    function FromEventPatternObservable(addHandler, removeHandler, selector) {
	        _super.call(this);
	        this.addHandler = addHandler;
	        this.removeHandler = removeHandler;
	        this.selector = selector;
	    }
	    /**
	     * Creates an Observable from an API based on addHandler/removeHandler
	     * functions.
	     *
	     * <span class="informal">Converts any addHandler/removeHandler API to an
	     * Observable.</span>
	     *
	     * <img src="./img/fromEventPattern.png" width="100%">
	     *
	     * Creates an Observable by using the `addHandler` and `removeHandler`
	     * functions to add and remove the handlers, with an optional selector
	     * function to project the event arguments to a result. The `addHandler` is
	     * called when the output Observable is subscribed, and `removeHandler` is
	     * called when the Subscription is unsubscribed.
	     *
	     * @example <caption>Emits clicks happening on the DOM document</caption>
	     * function addClickHandler(handler) {
	     *   document.addEventListener('click', handler);
	     * }
	     *
	     * function removeClickHandler(handler) {
	     *   document.removeEventListener('click', handler);
	     * }
	     *
	     * var clicks = Rx.Observable.fromEventPattern(
	     *   addClickHandler,
	     *   removeClickHandler
	     * );
	     * clicks.subscribe(x => console.log(x));
	     *
	     * @see {@link from}
	     * @see {@link fromEvent}
	     *
	     * @param {function(handler: Function): any} addHandler A function that takes
	     * a `handler` function as argument and attaches it somehow to the actual
	     * source of events.
	     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
	     * takes a `handler` function as argument and removes it in case it was
	     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
	     * removeHandler function will forward it.
	     * @param {function(...args: any): T} [selector] An optional function to
	     * post-process results. It takes the arguments from the event handler and
	     * should return a single value.
	     * @return {Observable<T>}
	     * @static true
	     * @name fromEventPattern
	     * @owner Observable
	     */
	    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
	        return new FromEventPatternObservable(addHandler, removeHandler, selector);
	    };
	    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var removeHandler = this.removeHandler;
	        var handler = !!this.selector ? function () {
	            var args = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                args[_i - 0] = arguments[_i];
	            }
	            _this._callSelector(subscriber, args);
	        } : function (e) { subscriber.next(e); };
	        var retValue = this._callAddHandler(handler, subscriber);
	        if (!isFunction_1.isFunction(removeHandler)) {
	            return;
	        }
	        subscriber.add(new Subscription_1.Subscription(function () {
	            //TODO: determine whether or not to forward to error handler
	            removeHandler(handler, retValue);
	        }));
	    };
	    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
	        try {
	            var result = this.selector.apply(this, args);
	            subscriber.next(result);
	        }
	        catch (e) {
	            subscriber.error(e);
	        }
	    };
	    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
	        try {
	            return this.addHandler(handler) || null;
	        }
	        catch (e) {
	            errorSubscriber.error(e);
	        }
	    };
	    return FromEventPatternObservable;
	}(Observable_1.Observable));
	exports.FromEventPatternObservable = FromEventPatternObservable;
	//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var fromPromise_1 = __webpack_require__(567);
	Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PromiseObservable_1 = __webpack_require__(542);
	exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
	//# sourceMappingURL=fromPromise.js.map

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var generate_1 = __webpack_require__(569);
	Observable_1.Observable.generate = generate_1.generate;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var GenerateObservable_1 = __webpack_require__(570);
	exports.generate = GenerateObservable_1.GenerateObservable.create;
	//# sourceMappingURL=generate.js.map

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var isScheduler_1 = __webpack_require__(526);
	var selfSelector = function (value) { return value; };
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var GenerateObservable = (function (_super) {
	    __extends(GenerateObservable, _super);
	    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
	        _super.call(this);
	        this.initialState = initialState;
	        this.condition = condition;
	        this.iterate = iterate;
	        this.resultSelector = resultSelector;
	        this.scheduler = scheduler;
	    }
	    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
	        if (arguments.length == 1) {
	            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
	        }
	        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
	            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
	        }
	        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
	    };
	    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function (subscriber) {
	        var state = this.initialState;
	        if (this.scheduler) {
	            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
	                subscriber: subscriber,
	                iterate: this.iterate,
	                condition: this.condition,
	                resultSelector: this.resultSelector,
	                state: state });
	        }
	        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
	        do {
	            if (condition) {
	                var conditionResult = void 0;
	                try {
	                    conditionResult = condition(state);
	                }
	                catch (err) {
	                    subscriber.error(err);
	                    return;
	                }
	                if (!conditionResult) {
	                    subscriber.complete();
	                    break;
	                }
	            }
	            var value = void 0;
	            try {
	                value = resultSelector(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            subscriber.next(value);
	            if (subscriber.closed) {
	                break;
	            }
	            try {
	                state = iterate(state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        } while (true);
	    };
	    GenerateObservable.dispatch = function (state) {
	        var subscriber = state.subscriber, condition = state.condition;
	        if (subscriber.closed) {
	            return;
	        }
	        if (state.needIterate) {
	            try {
	                state.state = state.iterate(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	        }
	        else {
	            state.needIterate = true;
	        }
	        if (condition) {
	            var conditionResult = void 0;
	            try {
	                conditionResult = condition(state.state);
	            }
	            catch (err) {
	                subscriber.error(err);
	                return;
	            }
	            if (!conditionResult) {
	                subscriber.complete();
	                return;
	            }
	            if (subscriber.closed) {
	                return;
	            }
	        }
	        var value;
	        try {
	            value = state.resultSelector(state.state);
	        }
	        catch (err) {
	            subscriber.error(err);
	            return;
	        }
	        if (subscriber.closed) {
	            return;
	        }
	        subscriber.next(value);
	        if (subscriber.closed) {
	            return;
	        }
	        return this.schedule(state);
	    };
	    return GenerateObservable;
	}(Observable_1.Observable));
	exports.GenerateObservable = GenerateObservable;
	//# sourceMappingURL=GenerateObservable.js.map

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var if_1 = __webpack_require__(572);
	Observable_1.Observable.if = if_1._if;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IfObservable_1 = __webpack_require__(573);
	exports._if = IfObservable_1.IfObservable.create;
	//# sourceMappingURL=if.js.map

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IfObservable = (function (_super) {
	    __extends(IfObservable, _super);
	    function IfObservable(condition, thenSource, elseSource) {
	        _super.call(this);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	    }
	    IfObservable.create = function (condition, thenSource, elseSource) {
	        return new IfObservable(condition, thenSource, elseSource);
	    };
	    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
	    };
	    return IfObservable;
	}(Observable_1.Observable));
	exports.IfObservable = IfObservable;
	var IfSubscriber = (function (_super) {
	    __extends(IfSubscriber, _super);
	    function IfSubscriber(destination, condition, thenSource, elseSource) {
	        _super.call(this, destination);
	        this.condition = condition;
	        this.thenSource = thenSource;
	        this.elseSource = elseSource;
	        this.tryIf();
	    }
	    IfSubscriber.prototype.tryIf = function () {
	        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
	        var result;
	        try {
	            result = condition();
	            var source = result ? thenSource : elseSource;
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	            else {
	                this._complete();
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return IfSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=IfObservable.js.map

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var interval_1 = __webpack_require__(575);
	Observable_1.Observable.interval = interval_1.interval;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var IntervalObservable_1 = __webpack_require__(576);
	exports.interval = IntervalObservable_1.IntervalObservable.create;
	//# sourceMappingURL=interval.js.map

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(577);
	var Observable_1 = __webpack_require__(499);
	var async_1 = __webpack_require__(578);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var IntervalObservable = (function (_super) {
	    __extends(IntervalObservable, _super);
	    function IntervalObservable(period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        _super.call(this);
	        this.period = period;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(period) || period < 0) {
	            this.period = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = async_1.async;
	        }
	    }
	    /**
	     * Creates an Observable that emits sequential numbers every specified
	     * interval of time, on a specified IScheduler.
	     *
	     * <span class="informal">Emits incremental numbers periodically in time.
	     * </span>
	     *
	     * <img src="./img/interval.png" width="100%">
	     *
	     * `interval` returns an Observable that emits an infinite sequence of
	     * ascending integers, with a constant interval of time of your choosing
	     * between those emissions. The first emission is not sent immediately, but
	     * only after the first period has passed. By default, this operator uses the
	     * `async` IScheduler to provide a notion of time, but you may pass any
	     * IScheduler to it.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
	     * var numbers = Rx.Observable.interval(1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link delay}
	     *
	     * @param {number} [period=0] The interval size in milliseconds (by default)
	     * or the time unit determined by the scheduler's clock.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a sequential number each time
	     * interval.
	     * @static true
	     * @name interval
	     * @owner Observable
	     */
	    IntervalObservable.create = function (period, scheduler) {
	        if (period === void 0) { period = 0; }
	        if (scheduler === void 0) { scheduler = async_1.async; }
	        return new IntervalObservable(period, scheduler);
	    };
	    IntervalObservable.dispatch = function (state) {
	        var index = state.index, subscriber = state.subscriber, period = state.period;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index += 1;
	        this.schedule(state, period);
	    };
	    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var period = this.period;
	        var scheduler = this.scheduler;
	        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
	            index: index, subscriber: subscriber, period: period
	        }));
	    };
	    return IntervalObservable;
	}(Observable_1.Observable));
	exports.IntervalObservable = IntervalObservable;
	//# sourceMappingURL=IntervalObservable.js.map

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(505);
	function isNumeric(val) {
	    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
	    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	    // subtraction forces infinities to NaN
	    // adding 1 corrects loss of precision from parseFloat (#15100)
	    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
	}
	exports.isNumeric = isNumeric;
	;
	//# sourceMappingURL=isNumeric.js.map

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncAction_1 = __webpack_require__(579);
	var AsyncScheduler_1 = __webpack_require__(581);
	/**
	 *
	 * Async Scheduler
	 *
	 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
	 *
	 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
	 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
	 * in intervals.
	 *
	 * If you just want to "defer" task, that is to perform it right after currently
	 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
	 * better choice will be the {@link asap} scheduler.
	 *
	 * @example <caption>Use async scheduler to delay task</caption>
	 * const task = () => console.log('it works!');
	 *
	 * Rx.Scheduler.async.schedule(task, 2000);
	 *
	 * // After 2 seconds logs:
	 * // "it works!"
	 *
	 *
	 * @example <caption>Use async scheduler to repeat task in intervals</caption>
	 * function task(state) {
	 *   console.log(state);
	 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
	 *                                   // which we reschedule with new state and delay
	 * }
	 *
	 * Rx.Scheduler.async.schedule(task, 3000, 0);
	 *
	 * // Logs:
	 * // 0 after 3s
	 * // 1 after 4s
	 * // 2 after 5s
	 * // 3 after 6s
	 *
	 * @static true
	 * @name async
	 * @owner Scheduler
	 */
	exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
	//# sourceMappingURL=async.js.map

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(500);
	var Action_1 = __webpack_require__(580);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsyncAction = (function (_super) {
	    __extends(AsyncAction, _super);
	    function AsyncAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.pending = false;
	        this.work = work;
	    }
	    AsyncAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (this.closed) {
	            return this;
	        }
	        // Always replace the current state with the new state.
	        this.state = state;
	        // Set the pending flag indicating that this action has been scheduled, or
	        // has recursively rescheduled itself.
	        this.pending = true;
	        var id = this.id;
	        var scheduler = this.scheduler;
	        //
	        // Important implementation note:
	        //
	        // Actions only execute once by default, unless rescheduled from within the
	        // scheduled callback. This allows us to implement single and repeat
	        // actions via the same code path, without adding API surface area, as well
	        // as mimic traditional recursion but across asynchronous boundaries.
	        //
	        // However, JS runtimes and timers distinguish between intervals achieved by
	        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
	        // serial `setTimeout` calls can be individually delayed, which delays
	        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
	        // guarantee the interval callback will be invoked more precisely to the
	        // interval period, regardless of load.
	        //
	        // Therefore, we use `setInterval` to schedule single and repeat actions.
	        // If the action reschedules itself with the same delay, the interval is not
	        // canceled. If the action doesn't reschedule, or reschedules with a
	        // different delay, the interval will be canceled after scheduled callback
	        // execution.
	        //
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, delay);
	        }
	        this.delay = delay;
	        // If this action has already an async Id, don't request a new one.
	        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
	        return this;
	    };
	    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
	    };
	    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If this action is rescheduled with the same delay time, don't clear the interval id.
	        if (delay !== null && this.delay === delay && this.pending === false) {
	            return id;
	        }
	        // Otherwise, if the action's delay time is different from the current delay,
	        // or the action has been rescheduled before it's executed, clear the interval id
	        return root_1.root.clearInterval(id) && undefined || undefined;
	    };
	    /**
	     * Immediately executes this action and the `work` it contains.
	     * @return {any}
	     */
	    AsyncAction.prototype.execute = function (state, delay) {
	        if (this.closed) {
	            return new Error('executing a cancelled action');
	        }
	        this.pending = false;
	        var error = this._execute(state, delay);
	        if (error) {
	            return error;
	        }
	        else if (this.pending === false && this.id != null) {
	            // Dequeue if the action didn't reschedule itself. Don't call
	            // unsubscribe(), because the action could reschedule later.
	            // For example:
	            // ```
	            // scheduler.schedule(function doWork(counter) {
	            //   /* ... I'm a busy worker bee ... */
	            //   var originalAction = this;
	            //   /* wait 100ms before rescheduling the action */
	            //   setTimeout(function () {
	            //     originalAction.schedule(counter + 1);
	            //   }, 100);
	            // }, 1000);
	            // ```
	            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
	        }
	    };
	    AsyncAction.prototype._execute = function (state, delay) {
	        var errored = false;
	        var errorValue = undefined;
	        try {
	            this.work(state);
	        }
	        catch (e) {
	            errored = true;
	            errorValue = !!e && e || new Error(e);
	        }
	        if (errored) {
	            this.unsubscribe();
	            return errorValue;
	        }
	    };
	    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function () {
	        var id = this.id;
	        var scheduler = this.scheduler;
	        var actions = scheduler.actions;
	        var index = actions.indexOf(this);
	        this.work = null;
	        this.state = null;
	        this.pending = false;
	        this.scheduler = null;
	        if (index !== -1) {
	            actions.splice(index, 1);
	        }
	        if (id != null) {
	            this.id = this.recycleAsyncId(scheduler, id, null);
	        }
	        this.delay = null;
	    };
	    return AsyncAction;
	}(Action_1.Action));
	exports.AsyncAction = AsyncAction;
	//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(504);
	/**
	 * A unit of work to be executed in a {@link Scheduler}. An action is typically
	 * created from within a Scheduler and an RxJS user does not need to concern
	 * themselves about creating and manipulating an Action.
	 *
	 * ```ts
	 * class Action<T> extends Subscription {
	 *   new (scheduler: Scheduler, work: (state?: T) => void);
	 *   schedule(state?: T, delay: number = 0): Subscription;
	 * }
	 * ```
	 *
	 * @class Action<T>
	 */
	var Action = (function (_super) {
	    __extends(Action, _super);
	    function Action(scheduler, work) {
	        _super.call(this);
	    }
	    /**
	     * Schedules this action on its parent Scheduler for execution. May be passed
	     * some context object, `state`. May happen at some point in the future,
	     * according to the `delay` parameter, if specified.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler.
	     * @return {void}
	     */
	    Action.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        return this;
	    };
	    return Action;
	}(Subscription_1.Subscription));
	exports.Action = Action;
	//# sourceMappingURL=Action.js.map

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Scheduler_1 = __webpack_require__(582);
	var AsyncScheduler = (function (_super) {
	    __extends(AsyncScheduler, _super);
	    function AsyncScheduler() {
	        _super.apply(this, arguments);
	        this.actions = [];
	        /**
	         * A flag to indicate whether the Scheduler is currently executing a batch of
	         * queued actions.
	         * @type {boolean}
	         */
	        this.active = false;
	        /**
	         * An internal ID used to track the latest asynchronous task such as those
	         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
	         * others.
	         * @type {any}
	         */
	        this.scheduled = undefined;
	    }
	    AsyncScheduler.prototype.flush = function (action) {
	        var actions = this.actions;
	        if (this.active) {
	            actions.push(action);
	            return;
	        }
	        var error;
	        this.active = true;
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (action = actions.shift()); // exhaust the scheduler queue
	        this.active = false;
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsyncScheduler;
	}(Scheduler_1.Scheduler));
	exports.AsyncScheduler = AsyncScheduler;
	//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * An execution context and a data structure to order tasks and schedule their
	 * execution. Provides a notion of (potentially virtual) time, through the
	 * `now()` getter method.
	 *
	 * Each unit of work in a Scheduler is called an {@link Action}.
	 *
	 * ```ts
	 * class Scheduler {
	 *   now(): number;
	 *   schedule(work, delay?, state?): Subscription;
	 * }
	 * ```
	 *
	 * @class Scheduler
	 */
	var Scheduler = (function () {
	    function Scheduler(SchedulerAction, now) {
	        if (now === void 0) { now = Scheduler.now; }
	        this.SchedulerAction = SchedulerAction;
	        this.now = now;
	    }
	    /**
	     * Schedules a function, `work`, for execution. May happen at some point in
	     * the future, according to the `delay` parameter, if specified. May be passed
	     * some context object, `state`, which will be passed to the `work` function.
	     *
	     * The given arguments will be processed an stored as an Action object in a
	     * queue of actions.
	     *
	     * @param {function(state: ?T): ?Subscription} work A function representing a
	     * task, or some unit of work to be executed by the Scheduler.
	     * @param {number} [delay] Time to wait before executing the work, where the
	     * time unit is implicit and defined by the Scheduler itself.
	     * @param {T} [state] Some contextual data that the `work` function uses when
	     * called by the Scheduler.
	     * @return {Subscription} A subscription in order to be able to unsubscribe
	     * the scheduled work.
	     */
	    Scheduler.prototype.schedule = function (work, delay, state) {
	        if (delay === void 0) { delay = 0; }
	        return new this.SchedulerAction(this, work).schedule(state, delay);
	    };
	    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
	    return Scheduler;
	}());
	exports.Scheduler = Scheduler;
	//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var merge_1 = __webpack_require__(584);
	Observable_1.Observable.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var ArrayObservable_1 = __webpack_require__(527);
	var isScheduler_1 = __webpack_require__(526);
	var mergeAll_1 = __webpack_require__(548);
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (as arguments), and simply
	 * forwards (without doing any transformation) all the values from all the input
	 * Observables to the output Observable. The output Observable only completes
	 * once all input Observables have completed. Any error delivered by an input
	 * Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // timer will emit ascending values, one every second(1000ms) to console
	 * // clicks logs MouseEvents to console everytime the "document" is clicked
	 * // Since the two streams are merged you see these happening
	 * // as they occur.
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - First timer1 and timer2 will run concurrently
	 * // - timer1 will emit a value every 1000ms for 10 iterations
	 * // - timer2 will emit a value every 2000ms for 6 iterations
	 * // - after timer1 hits it's max iteration, timer2 will
	 * //   continue, and timer3 will start to run concurrently with timer2
	 * // - when timer2 hits it's max iteration it terminates, and
	 * //   timer3 will continue to emit a value every 500ms until it is complete
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {...ObservableInput} observables Input Observables to merge together.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} an Observable that emits items that are the result of
	 * every input Observable.
	 * @static true
	 * @name merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var concurrent = Number.POSITIVE_INFINITY;
	    var scheduler = null;
	    var last = observables[observables.length - 1];
	    if (isScheduler_1.isScheduler(last)) {
	        scheduler = observables.pop();
	        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
	            concurrent = observables.pop();
	        }
	    }
	    else if (typeof last === 'number') {
	        concurrent = observables.pop();
	    }
	    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
	        return observables[0];
	    }
	    return mergeAll_1.mergeAll(concurrent)(new ArrayObservable_1.ArrayObservable(observables, scheduler));
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var race_1 = __webpack_require__(586);
	Observable_1.Observable.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isArray_1 = __webpack_require__(505);
	var ArrayObservable_1 = __webpack_require__(527);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    // if the only argument is an array, it was most likely called with
	    // `race([obs1, obs2, ...])`
	    if (observables.length === 1) {
	        if (isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        else {
	            return observables[0];
	        }
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
	}
	exports.race = race;
	var RaceOperator = (function () {
	    function RaceOperator() {
	    }
	    RaceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RaceSubscriber(subscriber));
	    };
	    return RaceOperator;
	}());
	exports.RaceOperator = RaceOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RaceSubscriber = (function (_super) {
	    __extends(RaceSubscriber, _super);
	    function RaceSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasFirst = false;
	        this.observables = [];
	        this.subscriptions = [];
	    }
	    RaceSubscriber.prototype._next = function (observable) {
	        this.observables.push(observable);
	    };
	    RaceSubscriber.prototype._complete = function () {
	        var observables = this.observables;
	        var len = observables.length;
	        if (len === 0) {
	            this.destination.complete();
	        }
	        else {
	            for (var i = 0; i < len && !this.hasFirst; i++) {
	                var observable = observables[i];
	                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
	                if (this.subscriptions) {
	                    this.subscriptions.push(subscription);
	                }
	                this.add(subscription);
	            }
	            this.observables = null;
	        }
	    };
	    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (!this.hasFirst) {
	            this.hasFirst = true;
	            for (var i = 0; i < this.subscriptions.length; i++) {
	                if (i !== outerIndex) {
	                    var subscription = this.subscriptions[i];
	                    subscription.unsubscribe();
	                    this.remove(subscription);
	                }
	            }
	            this.subscriptions = null;
	        }
	        this.destination.next(innerValue);
	    };
	    return RaceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.RaceSubscriber = RaceSubscriber;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var never_1 = __webpack_require__(588);
	Observable_1.Observable.never = never_1.never;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var NeverObservable_1 = __webpack_require__(589);
	exports.never = NeverObservable_1.NeverObservable.create;
	//# sourceMappingURL=never.js.map

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var noop_1 = __webpack_require__(514);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var NeverObservable = (function (_super) {
	    __extends(NeverObservable, _super);
	    function NeverObservable() {
	        _super.call(this);
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer.
	     *
	     * <span class="informal">An Observable that never emits anything.</span>
	     *
	     * <img src="./img/never.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that emits
	     * neither values nor errors nor the completion notification. It can be used
	     * for testing purposes or for composing with other Observables. Please note
	     * that by never emitting a complete notification, this Observable keeps the
	     * subscription from being disposed automatically. Subscriptions need to be
	     * manually disposed.
	     *
	     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
	     * function info() {
	     *   console.log('Will not be called');
	     * }
	     * var result = Rx.Observable.never().startWith(7);
	     * result.subscribe(x => console.log(x), info, info);
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link of}
	     * @see {@link throw}
	     *
	     * @return {Observable} A "never" Observable: never emits anything.
	     * @static true
	     * @name never
	     * @owner Observable
	     */
	    NeverObservable.create = function () {
	        return new NeverObservable();
	    };
	    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function (subscriber) {
	        noop_1.noop();
	    };
	    return NeverObservable;
	}(Observable_1.Observable));
	exports.NeverObservable = NeverObservable;
	//# sourceMappingURL=NeverObservable.js.map

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var of_1 = __webpack_require__(539);
	Observable_1.Observable.of = of_1.of;
	//# sourceMappingURL=of.js.map

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var onErrorResumeNext_1 = __webpack_require__(592);
	Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(593);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var FromObservable_1 = __webpack_require__(541);
	var isArray_1 = __webpack_require__(505);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    return function (source) { return source.lift(new OnErrorResumeNextOperator(nextSources)); };
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	/* tslint:enable:max-line-length */
	function onErrorResumeNextStatic() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    var source = null;
	    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
	        nextSources = nextSources[0];
	    }
	    source = nextSources.shift();
	    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
	}
	exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
	var OnErrorResumeNextOperator = (function () {
	    function OnErrorResumeNextOperator(nextSources) {
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
	    };
	    return OnErrorResumeNextOperator;
	}());
	var OnErrorResumeNextSubscriber = (function (_super) {
	    __extends(OnErrorResumeNextSubscriber, _super);
	    function OnErrorResumeNextSubscriber(destination, nextSources) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.nextSources = nextSources;
	    }
	    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._error = function (err) {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype._complete = function () {
	        this.subscribeToNextSource();
	    };
	    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
	        var next = this.nextSources.shift();
	        if (next) {
	            this.add(subscribeToResult_1.subscribeToResult(this, next));
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return OnErrorResumeNextSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var pairs_1 = __webpack_require__(595);
	Observable_1.Observable.pairs = pairs_1.pairs;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var PairsObservable_1 = __webpack_require__(596);
	exports.pairs = PairsObservable_1.PairsObservable.create;
	//# sourceMappingURL=pairs.js.map

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	function dispatch(state) {
	    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
	    if (index === length) {
	        subscriber.complete();
	        return;
	    }
	    var key = keys[index];
	    subscriber.next([key, obj[key]]);
	    state.index = index + 1;
	    this.schedule(state);
	}
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var PairsObservable = (function (_super) {
	    __extends(PairsObservable, _super);
	    function PairsObservable(obj, scheduler) {
	        _super.call(this);
	        this.obj = obj;
	        this.scheduler = scheduler;
	        this.keys = Object.keys(obj);
	    }
	    /**
	     * Convert an object into an observable sequence of [key, value] pairs
	     * using an optional IScheduler to enumerate the object.
	     *
	     * @example <caption>Converts a javascript object to an Observable</caption>
	     * var obj = {
	     *   foo: 42,
	     *   bar: 56,
	     *   baz: 78
	     * };
	     *
	     * var source = Rx.Observable.pairs(obj);
	     *
	     * var subscription = source.subscribe(
	     *   function (x) {
	     *     console.log('Next: %s', x);
	     *   },
	     *   function (err) {
	     *     console.log('Error: %s', err);
	     *   },
	     *   function () {
	     *     console.log('Completed');
	     *   });
	     *
	     * @param {Object} obj The object to inspect and turn into an
	     * Observable sequence.
	     * @param {Scheduler} [scheduler] An optional IScheduler to run the
	     * enumeration of the input sequence on.
	     * @returns {(Observable<Array<string | T>>)} An observable sequence of
	     * [key, value] pairs from the object.
	     */
	    PairsObservable.create = function (obj, scheduler) {
	        return new PairsObservable(obj, scheduler);
	    };
	    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
	        var length = keys.length;
	        if (scheduler) {
	            return scheduler.schedule(dispatch, 0, {
	                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
	            });
	        }
	        else {
	            for (var idx = 0; idx < length; idx++) {
	                var key = keys[idx];
	                subscriber.next([key, this.obj[key]]);
	            }
	            subscriber.complete();
	        }
	    };
	    return PairsObservable;
	}(Observable_1.Observable));
	exports.PairsObservable = PairsObservable;
	//# sourceMappingURL=PairsObservable.js.map

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var range_1 = __webpack_require__(598);
	Observable_1.Observable.range = range_1.range;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var RangeObservable_1 = __webpack_require__(599);
	exports.range = RangeObservable_1.RangeObservable.create;
	//# sourceMappingURL=range.js.map

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var RangeObservable = (function (_super) {
	    __extends(RangeObservable, _super);
	    function RangeObservable(start, count, scheduler) {
	        _super.call(this);
	        this.start = start;
	        this._count = count;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits a sequence of numbers within a specified
	     * range.
	     *
	     * <span class="informal">Emits a sequence of numbers in a range.</span>
	     *
	     * <img src="./img/range.png" width="100%">
	     *
	     * `range` operator emits a range of sequential integers, in order, where you
	     * select the `start` of the range and its `length`. By default, uses no
	     * IScheduler and just delivers the notifications synchronously, but may use
	     * an optional IScheduler to regulate those deliveries.
	     *
	     * @example <caption>Emits the numbers 1 to 10</caption>
	     * var numbers = Rx.Observable.range(1, 10);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link timer}
	     * @see {@link interval}
	     *
	     * @param {number} [start=0] The value of the first integer in the sequence.
	     * @param {number} [count=0] The number of sequential integers to generate.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emissions of the notifications.
	     * @return {Observable} An Observable of numbers that emits a finite range of
	     * sequential integers.
	     * @static true
	     * @name range
	     * @owner Observable
	     */
	    RangeObservable.create = function (start, count, scheduler) {
	        if (start === void 0) { start = 0; }
	        if (count === void 0) { count = 0; }
	        return new RangeObservable(start, count, scheduler);
	    };
	    RangeObservable.dispatch = function (state) {
	        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
	        if (index >= count) {
	            subscriber.complete();
	            return;
	        }
	        subscriber.next(start);
	        if (subscriber.closed) {
	            return;
	        }
	        state.index = index + 1;
	        state.start = start + 1;
	        this.schedule(state);
	    };
	    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var start = this.start;
	        var count = this._count;
	        var scheduler = this.scheduler;
	        if (scheduler) {
	            return scheduler.schedule(RangeObservable.dispatch, 0, {
	                index: index, count: count, start: start, subscriber: subscriber
	            });
	        }
	        else {
	            do {
	                if (index++ >= count) {
	                    subscriber.complete();
	                    break;
	                }
	                subscriber.next(start++);
	                if (subscriber.closed) {
	                    break;
	                }
	            } while (true);
	        }
	    };
	    return RangeObservable;
	}(Observable_1.Observable));
	exports.RangeObservable = RangeObservable;
	//# sourceMappingURL=RangeObservable.js.map

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var using_1 = __webpack_require__(601);
	Observable_1.Observable.using = using_1.using;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var UsingObservable_1 = __webpack_require__(602);
	exports.using = UsingObservable_1.UsingObservable.create;
	//# sourceMappingURL=using.js.map

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var UsingObservable = (function (_super) {
	    __extends(UsingObservable, _super);
	    function UsingObservable(resourceFactory, observableFactory) {
	        _super.call(this);
	        this.resourceFactory = resourceFactory;
	        this.observableFactory = observableFactory;
	    }
	    UsingObservable.create = function (resourceFactory, observableFactory) {
	        return new UsingObservable(resourceFactory, observableFactory);
	    };
	    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function (subscriber) {
	        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
	        var resource;
	        try {
	            resource = resourceFactory();
	            return new UsingSubscriber(subscriber, resource, observableFactory);
	        }
	        catch (err) {
	            subscriber.error(err);
	        }
	    };
	    return UsingObservable;
	}(Observable_1.Observable));
	exports.UsingObservable = UsingObservable;
	var UsingSubscriber = (function (_super) {
	    __extends(UsingSubscriber, _super);
	    function UsingSubscriber(destination, resource, observableFactory) {
	        _super.call(this, destination);
	        this.resource = resource;
	        this.observableFactory = observableFactory;
	        destination.add(resource);
	        this.tryUse();
	    }
	    UsingSubscriber.prototype.tryUse = function () {
	        try {
	            var source = this.observableFactory.call(this, this.resource);
	            if (source) {
	                this.add(subscribeToResult_1.subscribeToResult(this, source));
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    return UsingSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=UsingObservable.js.map

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var throw_1 = __webpack_require__(604);
	Observable_1.Observable.throw = throw_1._throw;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ErrorObservable_1 = __webpack_require__(605);
	exports._throw = ErrorObservable_1.ErrorObservable.create;
	//# sourceMappingURL=throw.js.map

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var ErrorObservable = (function (_super) {
	    __extends(ErrorObservable, _super);
	    function ErrorObservable(error, scheduler) {
	        _super.call(this);
	        this.error = error;
	        this.scheduler = scheduler;
	    }
	    /**
	     * Creates an Observable that emits no items to the Observer and immediately
	     * emits an error notification.
	     *
	     * <span class="informal">Just emits 'error', and nothing else.
	     * </span>
	     *
	     * <img src="./img/throw.png" width="100%">
	     *
	     * This static operator is useful for creating a simple Observable that only
	     * emits the error notification. It can be used for composing with other
	     * Observables, such as in a {@link mergeMap}.
	     *
	     * @example <caption>Emit the number 7, then emit an error.</caption>
	     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
	     * var interval = Rx.Observable.interval(1000);
	     * var result = interval.mergeMap(x =>
	     *   x === 13 ?
	     *     Rx.Observable.throw('Thirteens are bad') :
	     *     Rx.Observable.of('a', 'b', 'c')
	     * );
	     * result.subscribe(x => console.log(x), e => console.error(e));
	     *
	     * @see {@link create}
	     * @see {@link empty}
	     * @see {@link never}
	     * @see {@link of}
	     *
	     * @param {any} error The particular Error to pass to the error notification.
	     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
	     * the emission of the error notification.
	     * @return {Observable} An error Observable: emits only the error notification
	     * using the given error argument.
	     * @static true
	     * @name throw
	     * @owner Observable
	     */
	    ErrorObservable.create = function (error, scheduler) {
	        return new ErrorObservable(error, scheduler);
	    };
	    ErrorObservable.dispatch = function (arg) {
	        var error = arg.error, subscriber = arg.subscriber;
	        subscriber.error(error);
	    };
	    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function (subscriber) {
	        var error = this.error;
	        var scheduler = this.scheduler;
	        subscriber.syncErrorThrowable = true;
	        if (scheduler) {
	            return scheduler.schedule(ErrorObservable.dispatch, 0, {
	                error: error, subscriber: subscriber
	            });
	        }
	        else {
	            subscriber.error(error);
	        }
	    };
	    return ErrorObservable;
	}(Observable_1.Observable));
	exports.ErrorObservable = ErrorObservable;
	//# sourceMappingURL=ErrorObservable.js.map

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var timer_1 = __webpack_require__(607);
	Observable_1.Observable.timer = timer_1.timer;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var TimerObservable_1 = __webpack_require__(608);
	exports.timer = TimerObservable_1.TimerObservable.create;
	//# sourceMappingURL=timer.js.map

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var isNumeric_1 = __webpack_require__(577);
	var Observable_1 = __webpack_require__(499);
	var async_1 = __webpack_require__(578);
	var isScheduler_1 = __webpack_require__(526);
	var isDate_1 = __webpack_require__(609);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var TimerObservable = (function (_super) {
	    __extends(TimerObservable, _super);
	    function TimerObservable(dueTime, period, scheduler) {
	        if (dueTime === void 0) { dueTime = 0; }
	        _super.call(this);
	        this.period = -1;
	        this.dueTime = 0;
	        if (isNumeric_1.isNumeric(period)) {
	            this.period = Number(period) < 1 && 1 || Number(period);
	        }
	        else if (isScheduler_1.isScheduler(period)) {
	            scheduler = period;
	        }
	        if (!isScheduler_1.isScheduler(scheduler)) {
	            scheduler = async_1.async;
	        }
	        this.scheduler = scheduler;
	        this.dueTime = isDate_1.isDate(dueTime) ?
	            (+dueTime - this.scheduler.now()) :
	            dueTime;
	    }
	    /**
	     * Creates an Observable that starts emitting after an `initialDelay` and
	     * emits ever increasing numbers after each `period` of time thereafter.
	     *
	     * <span class="informal">Its like {@link interval}, but you can specify when
	     * should the emissions start.</span>
	     *
	     * <img src="./img/timer.png" width="100%">
	     *
	     * `timer` returns an Observable that emits an infinite sequence of ascending
	     * integers, with a constant interval of time, `period` of your choosing
	     * between those emissions. The first emission happens after the specified
	     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
	     * operator uses the `async` IScheduler to provide a notion of time, but you
	     * may pass any IScheduler to it. If `period` is not specified, the output
	     * Observable emits only one value, `0`. Otherwise, it emits an infinite
	     * sequence.
	     *
	     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
	     * var numbers = Rx.Observable.timer(3000, 1000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @example <caption>Emits one number after five seconds</caption>
	     * var numbers = Rx.Observable.timer(5000);
	     * numbers.subscribe(x => console.log(x));
	     *
	     * @see {@link interval}
	     * @see {@link delay}
	     *
	     * @param {number|Date} initialDelay The initial delay time to wait before
	     * emitting the first value of `0`.
	     * @param {number} [period] The period of time between emissions of the
	     * subsequent numbers.
	     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
	     * the emission of values, and providing a notion of "time".
	     * @return {Observable} An Observable that emits a `0` after the
	     * `initialDelay` and ever increasing numbers after each `period` of time
	     * thereafter.
	     * @static true
	     * @name timer
	     * @owner Observable
	     */
	    TimerObservable.create = function (initialDelay, period, scheduler) {
	        if (initialDelay === void 0) { initialDelay = 0; }
	        return new TimerObservable(initialDelay, period, scheduler);
	    };
	    TimerObservable.dispatch = function (state) {
	        var index = state.index, period = state.period, subscriber = state.subscriber;
	        var action = this;
	        subscriber.next(index);
	        if (subscriber.closed) {
	            return;
	        }
	        else if (period === -1) {
	            return subscriber.complete();
	        }
	        state.index = index + 1;
	        action.schedule(state, period);
	    };
	    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function (subscriber) {
	        var index = 0;
	        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
	        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
	            index: index, period: period, subscriber: subscriber
	        });
	    };
	    return TimerObservable;
	}(Observable_1.Observable));
	exports.TimerObservable = TimerObservable;
	//# sourceMappingURL=TimerObservable.js.map

/***/ }),
/* 609 */
/***/ (function(module, exports) {

	"use strict";
	function isDate(value) {
	    return value instanceof Date && !isNaN(+value);
	}
	exports.isDate = isDate;
	//# sourceMappingURL=isDate.js.map

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var zip_1 = __webpack_require__(611);
	Observable_1.Observable.zip = zip_1.zip;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(612);
	exports.zip = zip_1.zipStatic;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ArrayObservable_1 = __webpack_require__(527);
	var isArray_1 = __webpack_require__(505);
	var Subscriber_1 = __webpack_require__(502);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	var iterator_1 = __webpack_require__(535);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zip() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function zipOperatorFunction(source) {
	        return source.lift.call(zipStatic.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.zip = zip;
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
	 * of its input Observables.
	 *
	 * If the latest parameter is a function, this function is used to compute the created value from the input values.
	 * Otherwise, an array of the input values is returned.
	 *
	 * @example <caption>Combine age and name from different sources</caption>
	 *
	 * let age$ = Observable.of<number>(27, 25, 29);
	 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
	 * let isDev$ = Observable.of<boolean>(true, true, false);
	 *
	 * Observable
	 *     .zip(age$,
	 *          name$,
	 *          isDev$,
	 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
	 *     .subscribe(x => console.log(x));
	 *
	 * // outputs
	 * // { age: 27, name: 'Foo', isDev: true }
	 * // { age: 25, name: 'Bar', isDev: true }
	 * // { age: 29, name: 'Beer', isDev: false }
	 *
	 * @param observables
	 * @return {Observable<R>}
	 * @static true
	 * @name zip
	 * @owner Observable
	 */
	function zipStatic() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    var project = observables[observables.length - 1];
	    if (typeof project === 'function') {
	        observables.pop();
	    }
	    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
	}
	exports.zipStatic = zipStatic;
	var ZipOperator = (function () {
	    function ZipOperator(project) {
	        this.project = project;
	    }
	    ZipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ZipSubscriber(subscriber, this.project));
	    };
	    return ZipOperator;
	}());
	exports.ZipOperator = ZipOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipSubscriber = (function (_super) {
	    __extends(ZipSubscriber, _super);
	    function ZipSubscriber(destination, project, values) {
	        if (values === void 0) { values = Object.create(null); }
	        _super.call(this, destination);
	        this.iterators = [];
	        this.active = 0;
	        this.project = (typeof project === 'function') ? project : null;
	        this.values = values;
	    }
	    ZipSubscriber.prototype._next = function (value) {
	        var iterators = this.iterators;
	        if (isArray_1.isArray(value)) {
	            iterators.push(new StaticArrayIterator(value));
	        }
	        else if (typeof value[iterator_1.iterator] === 'function') {
	            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
	        }
	        else {
	            iterators.push(new ZipBufferIterator(this.destination, this, value));
	        }
	    };
	    ZipSubscriber.prototype._complete = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        if (len === 0) {
	            this.destination.complete();
	            return;
	        }
	        this.active = len;
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (iterator.stillUnsubscribed) {
	                this.add(iterator.subscribe(iterator, i));
	            }
	            else {
	                this.active--; // not an observable
	            }
	        }
	    };
	    ZipSubscriber.prototype.notifyInactive = function () {
	        this.active--;
	        if (this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ZipSubscriber.prototype.checkIterators = function () {
	        var iterators = this.iterators;
	        var len = iterators.length;
	        var destination = this.destination;
	        // abort if not all of them have values
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
	                return;
	            }
	        }
	        var shouldComplete = false;
	        var args = [];
	        for (var i = 0; i < len; i++) {
	            var iterator = iterators[i];
	            var result = iterator.next();
	            // check to see if it's completed now that you've gotten
	            // the next value.
	            if (iterator.hasCompleted()) {
	                shouldComplete = true;
	            }
	            if (result.done) {
	                destination.complete();
	                return;
	            }
	            args.push(result.value);
	        }
	        if (this.project) {
	            this._tryProject(args);
	        }
	        else {
	            destination.next(args);
	        }
	        if (shouldComplete) {
	            destination.complete();
	        }
	    };
	    ZipSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return ZipSubscriber;
	}(Subscriber_1.Subscriber));
	exports.ZipSubscriber = ZipSubscriber;
	var StaticIterator = (function () {
	    function StaticIterator(iterator) {
	        this.iterator = iterator;
	        this.nextResult = iterator.next();
	    }
	    StaticIterator.prototype.hasValue = function () {
	        return true;
	    };
	    StaticIterator.prototype.next = function () {
	        var result = this.nextResult;
	        this.nextResult = this.iterator.next();
	        return result;
	    };
	    StaticIterator.prototype.hasCompleted = function () {
	        var nextResult = this.nextResult;
	        return nextResult && nextResult.done;
	    };
	    return StaticIterator;
	}());
	var StaticArrayIterator = (function () {
	    function StaticArrayIterator(array) {
	        this.array = array;
	        this.index = 0;
	        this.length = 0;
	        this.length = array.length;
	    }
	    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    StaticArrayIterator.prototype.next = function (value) {
	        var i = this.index++;
	        var array = this.array;
	        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
	    };
	    StaticArrayIterator.prototype.hasValue = function () {
	        return this.array.length > this.index;
	    };
	    StaticArrayIterator.prototype.hasCompleted = function () {
	        return this.array.length === this.index;
	    };
	    return StaticArrayIterator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ZipBufferIterator = (function (_super) {
	    __extends(ZipBufferIterator, _super);
	    function ZipBufferIterator(destination, parent, observable) {
	        _super.call(this, destination);
	        this.parent = parent;
	        this.observable = observable;
	        this.stillUnsubscribed = true;
	        this.buffer = [];
	        this.isComplete = false;
	    }
	    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
	        return this;
	    };
	    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
	    //    this is legit because `next()` will never be called by a subscription in this case.
	    ZipBufferIterator.prototype.next = function () {
	        var buffer = this.buffer;
	        if (buffer.length === 0 && this.isComplete) {
	            return { value: null, done: true };
	        }
	        else {
	            return { value: buffer.shift(), done: false };
	        }
	    };
	    ZipBufferIterator.prototype.hasValue = function () {
	        return this.buffer.length > 0;
	    };
	    ZipBufferIterator.prototype.hasCompleted = function () {
	        return this.buffer.length === 0 && this.isComplete;
	    };
	    ZipBufferIterator.prototype.notifyComplete = function () {
	        if (this.buffer.length > 0) {
	            this.isComplete = true;
	            this.parent.notifyInactive();
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.buffer.push(innerValue);
	        this.parent.checkIterators();
	    };
	    ZipBufferIterator.prototype.subscribe = function (value, index) {
	        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
	    };
	    return ZipBufferIterator;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var ajax_1 = __webpack_require__(614);
	Observable_1.Observable.ajax = ajax_1.ajax;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AjaxObservable_1 = __webpack_require__(615);
	exports.ajax = AjaxObservable_1.AjaxObservable.create;
	//# sourceMappingURL=ajax.js.map

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var root_1 = __webpack_require__(500);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var Observable_1 = __webpack_require__(499);
	var Subscriber_1 = __webpack_require__(502);
	var map_1 = __webpack_require__(616);
	function getCORSRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else if (!!root_1.root.XDomainRequest) {
	        return new root_1.root.XDomainRequest();
	    }
	    else {
	        throw new Error('CORS is not supported by your browser');
	    }
	}
	function getXMLHttpRequest() {
	    if (root_1.root.XMLHttpRequest) {
	        return new root_1.root.XMLHttpRequest();
	    }
	    else {
	        var progId = void 0;
	        try {
	            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
	            for (var i = 0; i < 3; i++) {
	                try {
	                    progId = progIds[i];
	                    if (new root_1.root.ActiveXObject(progId)) {
	                        break;
	                    }
	                }
	                catch (e) {
	                }
	            }
	            return new root_1.root.ActiveXObject(progId);
	        }
	        catch (e) {
	            throw new Error('XMLHttpRequest is not supported by your browser');
	        }
	    }
	}
	function ajaxGet(url, headers) {
	    if (headers === void 0) { headers = null; }
	    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
	}
	exports.ajaxGet = ajaxGet;
	;
	function ajaxPost(url, body, headers) {
	    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
	}
	exports.ajaxPost = ajaxPost;
	;
	function ajaxDelete(url, headers) {
	    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
	}
	exports.ajaxDelete = ajaxDelete;
	;
	function ajaxPut(url, body, headers) {
	    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
	}
	exports.ajaxPut = ajaxPut;
	;
	function ajaxPatch(url, body, headers) {
	    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
	}
	exports.ajaxPatch = ajaxPatch;
	;
	var mapResponse = map_1.map(function (x, index) { return x.response; });
	function ajaxGetJSON(url, headers) {
	    return mapResponse(new AjaxObservable({
	        method: 'GET',
	        url: url,
	        responseType: 'json',
	        headers: headers
	    }));
	}
	exports.ajaxGetJSON = ajaxGetJSON;
	;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var AjaxObservable = (function (_super) {
	    __extends(AjaxObservable, _super);
	    function AjaxObservable(urlOrRequest) {
	        _super.call(this);
	        var request = {
	            async: true,
	            createXHR: function () {
	                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
	            },
	            crossDomain: false,
	            withCredentials: false,
	            headers: {},
	            method: 'GET',
	            responseType: 'json',
	            timeout: 0
	        };
	        if (typeof urlOrRequest === 'string') {
	            request.url = urlOrRequest;
	        }
	        else {
	            for (var prop in urlOrRequest) {
	                if (urlOrRequest.hasOwnProperty(prop)) {
	                    request[prop] = urlOrRequest[prop];
	                }
	            }
	        }
	        this.request = request;
	    }
	    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function (subscriber) {
	        return new AjaxSubscriber(subscriber, this.request);
	    };
	    /**
	     * Creates an observable for an Ajax request with either a request object with
	     * url, headers, etc or a string for a URL.
	     *
	     * @example
	     * source = Rx.Observable.ajax('/products');
	     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
	     *
	     * @param {string|Object} request Can be one of the following:
	     *   A string of the URL to make the Ajax call.
	     *   An object with the following properties
	     *   - url: URL of the request
	     *   - body: The body of the request
	     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
	     *   - async: Whether the request is async
	     *   - headers: Optional headers
	     *   - crossDomain: true if a cross domain request, else false
	     *   - createXHR: a function to override if you need to use an alternate
	     *   XMLHttpRequest implementation.
	     *   - resultSelector: a function to use to alter the output value type of
	     *   the Observable. Gets {@link AjaxResponse} as an argument.
	     * @return {Observable} An observable sequence containing the XMLHttpRequest.
	     * @static true
	     * @name ajax
	     * @owner Observable
	    */
	    AjaxObservable.create = (function () {
	        var create = function (urlOrRequest) {
	            return new AjaxObservable(urlOrRequest);
	        };
	        create.get = ajaxGet;
	        create.post = ajaxPost;
	        create.delete = ajaxDelete;
	        create.put = ajaxPut;
	        create.patch = ajaxPatch;
	        create.getJSON = ajaxGetJSON;
	        return create;
	    })();
	    return AjaxObservable;
	}(Observable_1.Observable));
	exports.AjaxObservable = AjaxObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AjaxSubscriber = (function (_super) {
	    __extends(AjaxSubscriber, _super);
	    function AjaxSubscriber(destination, request) {
	        _super.call(this, destination);
	        this.request = request;
	        this.done = false;
	        var headers = request.headers = request.headers || {};
	        // force CORS if requested
	        if (!request.crossDomain && !headers['X-Requested-With']) {
	            headers['X-Requested-With'] = 'XMLHttpRequest';
	        }
	        // ensure content type is set
	        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
	            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
	        }
	        // properly serialize body
	        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
	        this.send();
	    }
	    AjaxSubscriber.prototype.next = function (e) {
	        this.done = true;
	        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
	        var response = new AjaxResponse(e, xhr, request);
	        destination.next(response);
	    };
	    AjaxSubscriber.prototype.send = function () {
	        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
	        var createXHR = request.createXHR;
	        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
	        if (xhr === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            this.xhr = xhr;
	            // set up the events before open XHR
	            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
	            // You need to add the event listeners before calling open() on the request.
	            // Otherwise the progress events will not fire.
	            this.setupEvents(xhr, request);
	            // open XHR
	            var result = void 0;
	            if (user) {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
	            }
	            else {
	                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
	            }
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	            // timeout, responseType and withCredentials can be set once the XHR is open
	            if (async) {
	                xhr.timeout = request.timeout;
	                xhr.responseType = request.responseType;
	            }
	            if ('withCredentials' in xhr) {
	                xhr.withCredentials = !!request.withCredentials;
	            }
	            // set headers
	            this.setHeaders(xhr, headers);
	            // finally send the request
	            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
	            if (result === errorObject_1.errorObject) {
	                this.error(errorObject_1.errorObject.e);
	                return null;
	            }
	        }
	        return xhr;
	    };
	    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
	        if (!body || typeof body === 'string') {
	            return body;
	        }
	        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
	            return body;
	        }
	        if (contentType) {
	            var splitIndex = contentType.indexOf(';');
	            if (splitIndex !== -1) {
	                contentType = contentType.substring(0, splitIndex);
	            }
	        }
	        switch (contentType) {
	            case 'application/x-www-form-urlencoded':
	                return Object.keys(body).map(function (key) { return (encodeURIComponent(key) + "=" + encodeURIComponent(body[key])); }).join('&');
	            case 'application/json':
	                return JSON.stringify(body);
	            default:
	                return body;
	        }
	    };
	    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
	        for (var key in headers) {
	            if (headers.hasOwnProperty(key)) {
	                xhr.setRequestHeader(key, headers[key]);
	            }
	        }
	    };
	    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
	        var progressSubscriber = request.progressSubscriber;
	        function xhrTimeout(e) {
	            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (progressSubscriber) {
	                progressSubscriber.error(e);
	            }
	            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
	        }
	        ;
	        xhr.ontimeout = xhrTimeout;
	        xhrTimeout.request = request;
	        xhrTimeout.subscriber = this;
	        xhrTimeout.progressSubscriber = progressSubscriber;
	        if (xhr.upload && 'withCredentials' in xhr) {
	            if (progressSubscriber) {
	                var xhrProgress_1;
	                xhrProgress_1 = function (e) {
	                    var progressSubscriber = xhrProgress_1.progressSubscriber;
	                    progressSubscriber.next(e);
	                };
	                if (root_1.root.XDomainRequest) {
	                    xhr.onprogress = xhrProgress_1;
	                }
	                else {
	                    xhr.upload.onprogress = xhrProgress_1;
	                }
	                xhrProgress_1.progressSubscriber = progressSubscriber;
	            }
	            var xhrError_1;
	            xhrError_1 = function (e) {
	                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
	                if (progressSubscriber) {
	                    progressSubscriber.error(e);
	                }
	                subscriber.error(new AjaxError('ajax error', this, request));
	            };
	            xhr.onerror = xhrError_1;
	            xhrError_1.request = request;
	            xhrError_1.subscriber = this;
	            xhrError_1.progressSubscriber = progressSubscriber;
	        }
	        function xhrReadyStateChange(e) {
	            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
	            if (this.readyState === 4) {
	                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	                var status_1 = this.status === 1223 ? 204 : this.status;
	                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
	                // fix status code when it is 0 (0 status is undocumented).
	                // Occurs when accessing file resources or on Android 4.1 stock browser
	                // while retrieving files from application cache.
	                if (status_1 === 0) {
	                    status_1 = response ? 200 : 0;
	                }
	                if (200 <= status_1 && status_1 < 300) {
	                    if (progressSubscriber) {
	                        progressSubscriber.complete();
	                    }
	                    subscriber.next(e);
	                    subscriber.complete();
	                }
	                else {
	                    if (progressSubscriber) {
	                        progressSubscriber.error(e);
	                    }
	                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
	                }
	            }
	        }
	        ;
	        xhr.onreadystatechange = xhrReadyStateChange;
	        xhrReadyStateChange.subscriber = this;
	        xhrReadyStateChange.progressSubscriber = progressSubscriber;
	        xhrReadyStateChange.request = request;
	    };
	    AjaxSubscriber.prototype.unsubscribe = function () {
	        var _a = this, done = _a.done, xhr = _a.xhr;
	        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
	            xhr.abort();
	        }
	        _super.prototype.unsubscribe.call(this);
	    };
	    return AjaxSubscriber;
	}(Subscriber_1.Subscriber));
	exports.AjaxSubscriber = AjaxSubscriber;
	/**
	 * A normalized AJAX response.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxResponse
	 */
	var AjaxResponse = (function () {
	    function AjaxResponse(originalEvent, xhr, request) {
	        this.originalEvent = originalEvent;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxResponse;
	}());
	exports.AjaxResponse = AjaxResponse;
	/**
	 * A normalized AJAX error.
	 *
	 * @see {@link ajax}
	 *
	 * @class AjaxError
	 */
	var AjaxError = (function (_super) {
	    __extends(AjaxError, _super);
	    function AjaxError(message, xhr, request) {
	        _super.call(this, message);
	        this.message = message;
	        this.xhr = xhr;
	        this.request = request;
	        this.status = xhr.status;
	        this.responseType = xhr.responseType || request.responseType;
	        this.response = parseXhrResponse(this.responseType, xhr);
	    }
	    return AjaxError;
	}(Error));
	exports.AjaxError = AjaxError;
	function parseXhrResponse(responseType, xhr) {
	    switch (responseType) {
	        case 'json':
	            if ('response' in xhr) {
	                //IE does not support json as responseType, parse it internally
	                return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
	            }
	            else {
	                // HACK(benlesh): TypeScript shennanigans
	                // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	                return JSON.parse(xhr.responseText || 'null');
	            }
	        case 'xml':
	            return xhr.responseXML;
	        case 'text':
	        default:
	            // HACK(benlesh): TypeScript shennanigans
	            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
	            return ('response' in xhr) ? xhr.response : xhr.responseText;
	    }
	}
	/**
	 * @see {@link ajax}
	 *
	 * @class AjaxTimeoutError
	 */
	var AjaxTimeoutError = (function (_super) {
	    __extends(AjaxTimeoutError, _super);
	    function AjaxTimeoutError(xhr, request) {
	        _super.call(this, 'ajax timeout', xhr, request);
	    }
	    return AjaxTimeoutError;
	}(AjaxError));
	exports.AjaxTimeoutError = AjaxTimeoutError;
	//# sourceMappingURL=AjaxObservable.js.map

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return function mapOperation(source) {
	        if (typeof project !== 'function') {
	            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
	        }
	        return source.lift(new MapOperator(project, thisArg));
	    };
	}
	exports.map = map;
	var MapOperator = (function () {
	    function MapOperator(project, thisArg) {
	        this.project = project;
	        this.thisArg = thisArg;
	    }
	    MapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
	    };
	    return MapOperator;
	}());
	exports.MapOperator = MapOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapSubscriber = (function (_super) {
	    __extends(MapSubscriber, _super);
	    function MapSubscriber(destination, project, thisArg) {
	        _super.call(this, destination);
	        this.project = project;
	        this.count = 0;
	        this.thisArg = thisArg || this;
	    }
	    // NOTE: This looks unoptimized, but it's actually purposefully NOT
	    // using try/catch optimizations.
	    MapSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.project.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return MapSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=map.js.map

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var webSocket_1 = __webpack_require__(618);
	Observable_1.Observable.webSocket = webSocket_1.webSocket;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var WebSocketSubject_1 = __webpack_require__(619);
	exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
	//# sourceMappingURL=webSocket.js.map

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var Subscriber_1 = __webpack_require__(502);
	var Observable_1 = __webpack_require__(499);
	var Subscription_1 = __webpack_require__(504);
	var root_1 = __webpack_require__(500);
	var ReplaySubject_1 = __webpack_require__(620);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var assign_1 = __webpack_require__(624);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var WebSocketSubject = (function (_super) {
	    __extends(WebSocketSubject, _super);
	    function WebSocketSubject(urlConfigOrSource, destination) {
	        if (urlConfigOrSource instanceof Observable_1.Observable) {
	            _super.call(this, destination, urlConfigOrSource);
	        }
	        else {
	            _super.call(this);
	            this.WebSocketCtor = root_1.root.WebSocket;
	            this._output = new Subject_1.Subject();
	            if (typeof urlConfigOrSource === 'string') {
	                this.url = urlConfigOrSource;
	            }
	            else {
	                // WARNING: config object could override important members here.
	                assign_1.assign(this, urlConfigOrSource);
	            }
	            if (!this.WebSocketCtor) {
	                throw new Error('no WebSocket constructor can be found');
	            }
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    }
	    WebSocketSubject.prototype.resultSelector = function (e) {
	        return JSON.parse(e.data);
	    };
	    /**
	     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
	     *
	     * @example <caption>Wraps browser WebSocket</caption>
	     *
	     * let socket$ = Observable.webSocket('ws://localhost:8081');
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
	     *
	     * import { w3cwebsocket } from 'websocket';
	     *
	     * let socket$ = Observable.webSocket({
	     *   url: 'ws://localhost:8081',
	     *   WebSocketCtor: w3cwebsocket
	     * });
	     *
	     * socket$.subscribe(
	     *    (msg) => console.log('message received: ' + msg),
	     *    (err) => console.log(err),
	     *    () => console.log('complete')
	     *  );
	     *
	     * socket$.next(JSON.stringify({ op: 'hello' }));
	     *
	     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
	     * @return {WebSocketSubject}
	     * @static true
	     * @name webSocket
	     * @owner Observable
	     */
	    WebSocketSubject.create = function (urlConfigOrSource) {
	        return new WebSocketSubject(urlConfigOrSource);
	    };
	    WebSocketSubject.prototype.lift = function (operator) {
	        var sock = new WebSocketSubject(this, this.destination);
	        sock.operator = operator;
	        return sock;
	    };
	    WebSocketSubject.prototype._resetState = function () {
	        this.socket = null;
	        if (!this.source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	        this._output = new Subject_1.Subject();
	    };
	    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
	    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
	        var self = this;
	        return new Observable_1.Observable(function (observer) {
	            var result = tryCatch_1.tryCatch(subMsg)();
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                self.next(result);
	            }
	            var subscription = self.subscribe(function (x) {
	                var result = tryCatch_1.tryCatch(messageFilter)(x);
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else if (result) {
	                    observer.next(x);
	                }
	            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
	            return function () {
	                var result = tryCatch_1.tryCatch(unsubMsg)();
	                if (result === errorObject_1.errorObject) {
	                    observer.error(errorObject_1.errorObject.e);
	                }
	                else {
	                    self.next(result);
	                }
	                subscription.unsubscribe();
	            };
	        });
	    };
	    WebSocketSubject.prototype._connectSocket = function () {
	        var _this = this;
	        var WebSocketCtor = this.WebSocketCtor;
	        var observer = this._output;
	        var socket = null;
	        try {
	            socket = this.protocol ?
	                new WebSocketCtor(this.url, this.protocol) :
	                new WebSocketCtor(this.url);
	            this.socket = socket;
	            if (this.binaryType) {
	                this.socket.binaryType = this.binaryType;
	            }
	        }
	        catch (e) {
	            observer.error(e);
	            return;
	        }
	        var subscription = new Subscription_1.Subscription(function () {
	            _this.socket = null;
	            if (socket && socket.readyState === 1) {
	                socket.close();
	            }
	        });
	        socket.onopen = function (e) {
	            var openObserver = _this.openObserver;
	            if (openObserver) {
	                openObserver.next(e);
	            }
	            var queue = _this.destination;
	            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                if (e && e.code) {
	                    socket.close(e.code, e.reason);
	                }
	                else {
	                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
	                        'and an optional reason: { code: number, reason: string }'));
	                }
	                _this._resetState();
	            }, function () {
	                var closingObserver = _this.closingObserver;
	                if (closingObserver) {
	                    closingObserver.next(undefined);
	                }
	                socket.close();
	                _this._resetState();
	            });
	            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
	                subscription.add(queue.subscribe(_this.destination));
	            }
	        };
	        socket.onerror = function (e) {
	            _this._resetState();
	            observer.error(e);
	        };
	        socket.onclose = function (e) {
	            _this._resetState();
	            var closeObserver = _this.closeObserver;
	            if (closeObserver) {
	                closeObserver.next(e);
	            }
	            if (e.wasClean) {
	                observer.complete();
	            }
	            else {
	                observer.error(e);
	            }
	        };
	        socket.onmessage = function (e) {
	            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
	            if (result === errorObject_1.errorObject) {
	                observer.error(errorObject_1.errorObject.e);
	            }
	            else {
	                observer.next(result);
	            }
	        };
	    };
	    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function (subscriber) {
	        var _this = this;
	        var source = this.source;
	        if (source) {
	            return source.subscribe(subscriber);
	        }
	        if (!this.socket) {
	            this._connectSocket();
	        }
	        var subscription = new Subscription_1.Subscription();
	        subscription.add(this._output.subscribe(subscriber));
	        subscription.add(function () {
	            var socket = _this.socket;
	            if (_this._output.observers.length === 0) {
	                if (socket && socket.readyState === 1) {
	                    socket.close();
	                }
	                _this._resetState();
	            }
	        });
	        return subscription;
	    };
	    WebSocketSubject.prototype.unsubscribe = function () {
	        var _a = this, source = _a.source, socket = _a.socket;
	        if (socket && socket.readyState === 1) {
	            socket.close();
	            this._resetState();
	        }
	        _super.prototype.unsubscribe.call(this);
	        if (!source) {
	            this.destination = new ReplaySubject_1.ReplaySubject();
	        }
	    };
	    return WebSocketSubject;
	}(Subject_1.AnonymousSubject));
	exports.WebSocketSubject = WebSocketSubject;
	//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var queue_1 = __webpack_require__(621);
	var Subscription_1 = __webpack_require__(504);
	var observeOn_1 = __webpack_require__(545);
	var ObjectUnsubscribedError_1 = __webpack_require__(515);
	var SubjectSubscription_1 = __webpack_require__(516);
	/**
	 * @class ReplaySubject<T>
	 */
	var ReplaySubject = (function (_super) {
	    __extends(ReplaySubject, _super);
	    function ReplaySubject(bufferSize, windowTime, scheduler) {
	        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
	        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
	        _super.call(this);
	        this.scheduler = scheduler;
	        this._events = [];
	        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
	        this._windowTime = windowTime < 1 ? 1 : windowTime;
	    }
	    ReplaySubject.prototype.next = function (value) {
	        var now = this._getNow();
	        this._events.push(new ReplayEvent(now, value));
	        this._trimBufferThenGetEvents();
	        _super.prototype.next.call(this, value);
	    };
	    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function (subscriber) {
	        var _events = this._trimBufferThenGetEvents();
	        var scheduler = this.scheduler;
	        var subscription;
	        if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else if (this.hasError) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else if (this.isStopped) {
	            subscription = Subscription_1.Subscription.EMPTY;
	        }
	        else {
	            this.observers.push(subscriber);
	            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
	        }
	        if (scheduler) {
	            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
	        }
	        var len = _events.length;
	        for (var i = 0; i < len && !subscriber.closed; i++) {
	            subscriber.next(_events[i].value);
	        }
	        if (this.hasError) {
	            subscriber.error(this.thrownError);
	        }
	        else if (this.isStopped) {
	            subscriber.complete();
	        }
	        return subscription;
	    };
	    ReplaySubject.prototype._getNow = function () {
	        return (this.scheduler || queue_1.queue).now();
	    };
	    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
	        var now = this._getNow();
	        var _bufferSize = this._bufferSize;
	        var _windowTime = this._windowTime;
	        var _events = this._events;
	        var eventsCount = _events.length;
	        var spliceCount = 0;
	        // Trim events that fall out of the time window.
	        // Start at the front of the list. Break early once
	        // we encounter an event that falls within the window.
	        while (spliceCount < eventsCount) {
	            if ((now - _events[spliceCount].time) < _windowTime) {
	                break;
	            }
	            spliceCount++;
	        }
	        if (eventsCount > _bufferSize) {
	            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
	        }
	        if (spliceCount > 0) {
	            _events.splice(0, spliceCount);
	        }
	        return _events;
	    };
	    return ReplaySubject;
	}(Subject_1.Subject));
	exports.ReplaySubject = ReplaySubject;
	var ReplayEvent = (function () {
	    function ReplayEvent(time, value) {
	        this.time = time;
	        this.value = value;
	    }
	    return ReplayEvent;
	}());
	//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var QueueAction_1 = __webpack_require__(622);
	var QueueScheduler_1 = __webpack_require__(623);
	/**
	 *
	 * Queue Scheduler
	 *
	 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
	 *
	 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
	 *
	 * When used without delay, it schedules given task synchronously - executes it right when
	 * it is scheduled. However when called recursively, that is when inside the scheduled task,
	 * another task is scheduled with queue scheduler, instead of executing immediately as well,
	 * that task will be put on a queue and wait for current one to finish.
	 *
	 * This means that when you execute task with `queue` scheduler, you are sure it will end
	 * before any other task scheduled with that scheduler will start.
	 *
	 * @examples <caption>Schedule recursively first, then do something</caption>
	 *
	 * Rx.Scheduler.queue.schedule(() => {
	 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
	 *
	 *   console.log('first');
	 * });
	 *
	 * // Logs:
	 * // "first"
	 * // "second"
	 *
	 *
	 * @example <caption>Reschedule itself recursively</caption>
	 *
	 * Rx.Scheduler.queue.schedule(function(state) {
	 *   if (state !== 0) {
	 *     console.log('before', state);
	 *     this.schedule(state - 1); // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 *     console.log('after', state);
	 *   }
	 * }, 0, 3);
	 *
	 * // In scheduler that runs recursively, you would expect:
	 * // "before", 3
	 * // "before", 2
	 * // "before", 1
	 * // "after", 1
	 * // "after", 2
	 * // "after", 3
	 *
	 * // But with queue it logs:
	 * // "before", 3
	 * // "after", 3
	 * // "before", 2
	 * // "after", 2
	 * // "before", 1
	 * // "after", 1
	 *
	 *
	 * @static true
	 * @name queue
	 * @owner Scheduler
	 */
	exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
	//# sourceMappingURL=queue.js.map

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(579);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var QueueAction = (function (_super) {
	    __extends(QueueAction, _super);
	    function QueueAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    QueueAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (delay > 0) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.delay = delay;
	        this.state = state;
	        this.scheduler.flush(this);
	        return this;
	    };
	    QueueAction.prototype.execute = function (state, delay) {
	        return (delay > 0 || this.closed) ?
	            _super.prototype.execute.call(this, state, delay) :
	            this._execute(state, delay);
	    };
	    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Otherwise flush the scheduler starting with this action.
	        return scheduler.flush(this);
	    };
	    return QueueAction;
	}(AsyncAction_1.AsyncAction));
	exports.QueueAction = QueueAction;
	//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(581);
	var QueueScheduler = (function (_super) {
	    __extends(QueueScheduler, _super);
	    function QueueScheduler() {
	        _super.apply(this, arguments);
	    }
	    return QueueScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.QueueScheduler = QueueScheduler;
	//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	function assignImpl(target) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var len = sources.length;
	    for (var i = 0; i < len; i++) {
	        var source = sources[i];
	        for (var k in source) {
	            if (source.hasOwnProperty(k)) {
	                target[k] = source[k];
	            }
	        }
	    }
	    return target;
	}
	exports.assignImpl = assignImpl;
	;
	function getAssign(root) {
	    return root.Object.assign || assignImpl;
	}
	exports.getAssign = getAssign;
	exports.assign = getAssign(root_1.root);
	//# sourceMappingURL=assign.js.map

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var buffer_1 = __webpack_require__(626);
	Observable_1.Observable.prototype.buffer = buffer_1.buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var buffer_1 = __webpack_require__(627);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return buffer_1.buffer(closingNotifier)(this);
	}
	exports.buffer = buffer;
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Buffers the source Observable values until `closingNotifier` emits.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when another Observable emits.</span>
	 *
	 * <img src="./img/buffer.png" width="100%">
	 *
	 * Buffers the incoming Observable values until the given `closingNotifier`
	 * Observable emits a value, at which point it emits the buffer on the output
	 * Observable and starts a new buffer internally, awaiting the next time
	 * `closingNotifier` emits.
	 *
	 * @example <caption>On every click, emit array of most recent interval events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var buffered = interval.buffer(clicks);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link window}
	 *
	 * @param {Observable<any>} closingNotifier An Observable that signals the
	 * buffer to be emitted on the output Observable.
	 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
	 * values.
	 * @method buffer
	 * @owner Observable
	 */
	function buffer(closingNotifier) {
	    return function bufferOperatorFunction(source) {
	        return source.lift(new BufferOperator(closingNotifier));
	    };
	}
	exports.buffer = buffer;
	var BufferOperator = (function () {
	    function BufferOperator(closingNotifier) {
	        this.closingNotifier = closingNotifier;
	    }
	    BufferOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
	    };
	    return BufferOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSubscriber = (function (_super) {
	    __extends(BufferSubscriber, _super);
	    function BufferSubscriber(destination, closingNotifier) {
	        _super.call(this, destination);
	        this.buffer = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	    }
	    BufferSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var buffer = this.buffer;
	        this.buffer = [];
	        this.destination.next(buffer);
	    };
	    return BufferSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=buffer.js.map

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bufferCount_1 = __webpack_require__(629);
	Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferCount_1 = __webpack_require__(630);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return bufferCount_1.bufferCount(bufferSize, startBufferEvery)(this);
	}
	exports.bufferCount = bufferCount;
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Buffers the source Observable values until the size hits the maximum
	 * `bufferSize` given.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * that array only when its size reaches `bufferSize`.</span>
	 *
	 * <img src="./img/bufferCount.png" width="100%">
	 *
	 * Buffers a number of values from the source Observable by `bufferSize` then
	 * emits the buffer and clears it, and starts a new buffer each
	 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
	 * `null`, then new buffers are started immediately at the start of the source
	 * and when each buffer closes and is emitted.
	 *
	 * @example <caption>Emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>On every click, emit the last two click events as an array</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferCount(2, 1);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link pairwise}
	 * @see {@link windowCount}
	 *
	 * @param {number} bufferSize The maximum size of the buffer emitted.
	 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
	 * For example if `startBufferEvery` is `2`, then a new buffer will be started
	 * on every other value from the source. A new buffer is started at the
	 * beginning of the source by default.
	 * @return {Observable<T[]>} An Observable of arrays of buffered values.
	 * @method bufferCount
	 * @owner Observable
	 */
	function bufferCount(bufferSize, startBufferEvery) {
	    if (startBufferEvery === void 0) { startBufferEvery = null; }
	    return function bufferCountOperatorFunction(source) {
	        return source.lift(new BufferCountOperator(bufferSize, startBufferEvery));
	    };
	}
	exports.bufferCount = bufferCount;
	var BufferCountOperator = (function () {
	    function BufferCountOperator(bufferSize, startBufferEvery) {
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        if (!startBufferEvery || bufferSize === startBufferEvery) {
	            this.subscriberClass = BufferCountSubscriber;
	        }
	        else {
	            this.subscriberClass = BufferSkipCountSubscriber;
	        }
	    }
	    BufferCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
	    };
	    return BufferCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferCountSubscriber = (function (_super) {
	    __extends(BufferCountSubscriber, _super);
	    function BufferCountSubscriber(destination, bufferSize) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.buffer = [];
	    }
	    BufferCountSubscriber.prototype._next = function (value) {
	        var buffer = this.buffer;
	        buffer.push(value);
	        if (buffer.length == this.bufferSize) {
	            this.destination.next(buffer);
	            this.buffer = [];
	        }
	    };
	    BufferCountSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer.length > 0) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferCountSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferSkipCountSubscriber = (function (_super) {
	    __extends(BufferSkipCountSubscriber, _super);
	    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
	        _super.call(this, destination);
	        this.bufferSize = bufferSize;
	        this.startBufferEvery = startBufferEvery;
	        this.buffers = [];
	        this.count = 0;
	    }
	    BufferSkipCountSubscriber.prototype._next = function (value) {
	        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
	        this.count++;
	        if (count % startBufferEvery === 0) {
	            buffers.push([]);
	        }
	        for (var i = buffers.length; i--;) {
	            var buffer = buffers[i];
	            buffer.push(value);
	            if (buffer.length === bufferSize) {
	                buffers.splice(i, 1);
	                this.destination.next(buffer);
	            }
	        }
	    };
	    BufferSkipCountSubscriber.prototype._complete = function () {
	        var _a = this, buffers = _a.buffers, destination = _a.destination;
	        while (buffers.length > 0) {
	            var buffer = buffers.shift();
	            if (buffer.length > 0) {
	                destination.next(buffer);
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    return BufferSkipCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=bufferCount.js.map

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bufferTime_1 = __webpack_require__(632);
	Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var isScheduler_1 = __webpack_require__(526);
	var bufferTime_1 = __webpack_require__(633);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return bufferTime_1.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
	}
	exports.bufferTime = bufferTime;
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(578);
	var Subscriber_1 = __webpack_require__(502);
	var isScheduler_1 = __webpack_require__(526);
	/* tslint:enable:max-line-length */
	/**
	 * Buffers the source Observable values for a specific time period.
	 *
	 * <span class="informal">Collects values from the past as an array, and emits
	 * those arrays periodically in time.</span>
	 *
	 * <img src="./img/bufferTime.png" width="100%">
	 *
	 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
	 * Unless the optional argument `bufferCreationInterval` is given, it emits and
	 * resets the buffer every `bufferTimeSpan` milliseconds. If
	 * `bufferCreationInterval` is given, this operator opens the buffer every
	 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
	 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
	 * `maxBufferSize` is specified, the buffer will be closed either after
	 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
	 *
	 * @example <caption>Every second, emit an array of the recent click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(1000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferTime(2000, 5000);
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferToggle}
	 * @see {@link bufferWhen}
	 * @see {@link windowTime}
	 *
	 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
	 * @param {number} [bufferCreationInterval] The interval at which to start new
	 * buffers.
	 * @param {number} [maxBufferSize] The maximum buffer size.
	 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
	 * intervals that determine buffer boundaries.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferTime
	 * @owner Observable
	 */
	function bufferTime(bufferTimeSpan) {
	    var length = arguments.length;
	    var scheduler = async_1.async;
	    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
	        scheduler = arguments[arguments.length - 1];
	        length--;
	    }
	    var bufferCreationInterval = null;
	    if (length >= 2) {
	        bufferCreationInterval = arguments[1];
	    }
	    var maxBufferSize = Number.POSITIVE_INFINITY;
	    if (length >= 3) {
	        maxBufferSize = arguments[2];
	    }
	    return function bufferTimeOperatorFunction(source) {
	        return source.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
	    };
	}
	exports.bufferTime = bufferTime;
	var BufferTimeOperator = (function () {
	    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	    }
	    BufferTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
	    };
	    return BufferTimeOperator;
	}());
	var Context = (function () {
	    function Context() {
	        this.buffer = [];
	    }
	    return Context;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferTimeSubscriber = (function (_super) {
	    __extends(BufferTimeSubscriber, _super);
	    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
	        _super.call(this, destination);
	        this.bufferTimeSpan = bufferTimeSpan;
	        this.bufferCreationInterval = bufferCreationInterval;
	        this.maxBufferSize = maxBufferSize;
	        this.scheduler = scheduler;
	        this.contexts = [];
	        var context = this.openContext();
	        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
	        if (this.timespanOnly) {
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	        else {
	            var closeState = { subscriber: this, context: context };
	            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
	        }
	    }
	    BufferTimeSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        var filledBufferContext;
	        for (var i = 0; i < len; i++) {
	            var context = contexts[i];
	            var buffer = context.buffer;
	            buffer.push(value);
	            if (buffer.length == this.maxBufferSize) {
	                filledBufferContext = context;
	            }
	        }
	        if (filledBufferContext) {
	            this.onBufferFull(filledBufferContext);
	        }
	    };
	    BufferTimeSubscriber.prototype._error = function (err) {
	        this.contexts.length = 0;
	        _super.prototype._error.call(this, err);
	    };
	    BufferTimeSubscriber.prototype._complete = function () {
	        var _a = this, contexts = _a.contexts, destination = _a.destination;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            destination.next(context.buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function () {
	        this.contexts = null;
	    };
	    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
	        this.closeContext(context);
	        var closeAction = context.closeAction;
	        closeAction.unsubscribe();
	        this.remove(closeAction);
	        if (!this.closed && this.timespanOnly) {
	            context = this.openContext();
	            var bufferTimeSpan = this.bufferTimeSpan;
	            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
	            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
	        }
	    };
	    BufferTimeSubscriber.prototype.openContext = function () {
	        var context = new Context();
	        this.contexts.push(context);
	        return context;
	    };
	    BufferTimeSubscriber.prototype.closeContext = function (context) {
	        this.destination.next(context.buffer);
	        var contexts = this.contexts;
	        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
	        if (spliceIndex >= 0) {
	            contexts.splice(contexts.indexOf(context), 1);
	        }
	    };
	    return BufferTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchBufferTimeSpanOnly(state) {
	    var subscriber = state.subscriber;
	    var prevContext = state.context;
	    if (prevContext) {
	        subscriber.closeContext(prevContext);
	    }
	    if (!subscriber.closed) {
	        state.context = subscriber.openContext();
	        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
	    }
	}
	function dispatchBufferCreation(state) {
	    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
	    var context = subscriber.openContext();
	    var action = this;
	    if (!subscriber.closed) {
	        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
	        action.schedule(state, bufferCreationInterval);
	    }
	}
	function dispatchBufferClose(arg) {
	    var subscriber = arg.subscriber, context = arg.context;
	    subscriber.closeContext(context);
	}
	//# sourceMappingURL=bufferTime.js.map

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bufferToggle_1 = __webpack_require__(635);
	Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferToggle_1 = __webpack_require__(636);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return bufferToggle_1.bufferToggle(openings, closingSelector)(this);
	}
	exports.bufferToggle = bufferToggle;
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(504);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * Buffers the source Observable values starting from an emission from
	 * `openings` and ending when the output of `closingSelector` emits.
	 *
	 * <span class="informal">Collects values from the past as an array. Starts
	 * collecting only when `opening` emits, and calls the `closingSelector`
	 * function to get an Observable that tells when to close the buffer.</span>
	 *
	 * <img src="./img/bufferToggle.png" width="100%">
	 *
	 * Buffers values from the source by opening the buffer via signals from an
	 * Observable provided to `openings`, and closing and sending the buffers when
	 * a Subscribable or Promise returned by the `closingSelector` function emits.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var buffered = clicks.bufferToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferWhen}
	 * @see {@link windowToggle}
	 *
	 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
	 * buffers.
	 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
	 * which, when it emits, signals that the associated buffer should be emitted
	 * and cleared.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferToggle
	 * @owner Observable
	 */
	function bufferToggle(openings, closingSelector) {
	    return function bufferToggleOperatorFunction(source) {
	        return source.lift(new BufferToggleOperator(openings, closingSelector));
	    };
	}
	exports.bufferToggle = bufferToggle;
	var BufferToggleOperator = (function () {
	    function BufferToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    BufferToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return BufferToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferToggleSubscriber = (function (_super) {
	    __extends(BufferToggleSubscriber, _super);
	    function BufferToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(subscribeToResult_1.subscribeToResult(this, openings));
	    }
	    BufferToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        var len = contexts.length;
	        for (var i = 0; i < len; i++) {
	            contexts[i].buffer.push(value);
	        }
	    };
	    BufferToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._error.call(this, err);
	    };
	    BufferToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        while (contexts.length > 0) {
	            var context = contexts.shift();
	            this.destination.next(context.buffer);
	            context.subscription.unsubscribe();
	            context.buffer = null;
	            context.subscription = null;
	        }
	        this.contexts = null;
	        _super.prototype._complete.call(this);
	    };
	    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
	    };
	    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.closeBuffer(innerSub.context);
	    };
	    BufferToggleSubscriber.prototype.openBuffer = function (value) {
	        try {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = closingSelector.call(this, value);
	            if (closingNotifier) {
	                this.trySubscribe(closingNotifier);
	            }
	        }
	        catch (err) {
	            this._error(err);
	        }
	    };
	    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
	        var contexts = this.contexts;
	        if (contexts && context) {
	            var buffer = context.buffer, subscription = context.subscription;
	            this.destination.next(buffer);
	            contexts.splice(contexts.indexOf(context), 1);
	            this.remove(subscription);
	            subscription.unsubscribe();
	        }
	    };
	    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
	        var contexts = this.contexts;
	        var buffer = [];
	        var subscription = new Subscription_1.Subscription();
	        var context = { buffer: buffer, subscription: subscription };
	        contexts.push(context);
	        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	        if (!innerSubscription || innerSubscription.closed) {
	            this.closeBuffer(context);
	        }
	        else {
	            innerSubscription.context = context;
	            this.add(innerSubscription);
	            subscription.add(innerSubscription);
	        }
	    };
	    return BufferToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferToggle.js.map

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var bufferWhen_1 = __webpack_require__(638);
	Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var bufferWhen_1 = __webpack_require__(639);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return bufferWhen_1.bufferWhen(closingSelector)(this);
	}
	exports.bufferWhen = bufferWhen;
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscription_1 = __webpack_require__(504);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Buffers the source Observable values, using a factory function of closing
	 * Observables to determine when to close, emit, and reset the buffer.
	 *
	 * <span class="informal">Collects values from the past as an array. When it
	 * starts collecting values, it calls a function that returns an Observable that
	 * tells when to close the buffer and restart collecting.</span>
	 *
	 * <img src="./img/bufferWhen.png" width="100%">
	 *
	 * Opens a buffer immediately, then closes the buffer when the observable
	 * returned by calling `closingSelector` function emits a value. When it closes
	 * the buffer, it immediately opens a new buffer and repeats the process.
	 *
	 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var buffered = clicks.bufferWhen(() =>
	 *   Rx.Observable.interval(1000 + Math.random() * 4000)
	 * );
	 * buffered.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 * @see {@link bufferTime}
	 * @see {@link bufferToggle}
	 * @see {@link windowWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals buffer closure.
	 * @return {Observable<T[]>} An observable of arrays of buffered values.
	 * @method bufferWhen
	 * @owner Observable
	 */
	function bufferWhen(closingSelector) {
	    return function (source) {
	        return source.lift(new BufferWhenOperator(closingSelector));
	    };
	}
	exports.bufferWhen = bufferWhen;
	var BufferWhenOperator = (function () {
	    function BufferWhenOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    BufferWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
	    };
	    return BufferWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var BufferWhenSubscriber = (function (_super) {
	    __extends(BufferWhenSubscriber, _super);
	    function BufferWhenSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.closingSelector = closingSelector;
	        this.subscribing = false;
	        this.openBuffer();
	    }
	    BufferWhenSubscriber.prototype._next = function (value) {
	        this.buffer.push(value);
	    };
	    BufferWhenSubscriber.prototype._complete = function () {
	        var buffer = this.buffer;
	        if (buffer) {
	            this.destination.next(buffer);
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function () {
	        this.buffer = null;
	        this.subscribing = false;
	    };
	    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openBuffer();
	    };
	    BufferWhenSubscriber.prototype.notifyComplete = function () {
	        if (this.subscribing) {
	            this.complete();
	        }
	        else {
	            this.openBuffer();
	        }
	    };
	    BufferWhenSubscriber.prototype.openBuffer = function () {
	        var closingSubscription = this.closingSubscription;
	        if (closingSubscription) {
	            this.remove(closingSubscription);
	            closingSubscription.unsubscribe();
	        }
	        var buffer = this.buffer;
	        if (this.buffer) {
	            this.destination.next(buffer);
	        }
	        this.buffer = [];
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            this.error(errorObject_1.errorObject.e);
	        }
	        else {
	            closingSubscription = new Subscription_1.Subscription();
	            this.closingSubscription = closingSubscription;
	            this.add(closingSubscription);
	            this.subscribing = true;
	            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
	            this.subscribing = false;
	        }
	    };
	    return BufferWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=bufferWhen.js.map

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var catch_1 = __webpack_require__(641);
	Observable_1.Observable.prototype.catch = catch_1._catch;
	Observable_1.Observable.prototype._catch = catch_1._catch;
	//# sourceMappingURL=catch.js.map

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var catchError_1 = __webpack_require__(642);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @method catch
	 * @name catch
	 * @owner Observable
	 */
	function _catch(selector) {
	    return catchError_1.catchError(selector)(this);
	}
	exports._catch = _catch;
	//# sourceMappingURL=catch.js.map

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
	 *
	 * <img src="./img/catch.png" width="100%">
	 *
	 * @example <caption>Continues with a different Observable when there's an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n == 4) {
	 * 	     throw 'four!';
	 *     }
	 *	   return n;
	 *   })
	 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, I, II, III, IV, V
	 *
	 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 * 	   if (n === 4) {
	 * 	     throw 'four!';
	 *     }
	 * 	   return n;
	 *   })
	 *   .catch((err, caught) => caught)
	 *   .take(30)
	 *   .subscribe(x => console.log(x));
	 *   // 1, 2, 3, 1, 2, 3, ...
	 *
	 * @example <caption>Throws a new error when the source Observable throws an error</caption>
	 *
	 * Observable.of(1, 2, 3, 4, 5)
	 *   .map(n => {
	 *     if (n == 4) {
	 *       throw 'four!';
	 *     }
	 *     return n;
	 *   })
	 *   .catch(err => {
	 *     throw 'error in source. Details: ' + err;
	 *   })
	 *   .subscribe(
	 *     x => console.log(x),
	 *     err => console.log(err)
	 *   );
	 *   // 1, 2, 3, error in source. Details: four!
	 *
	 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
	 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
	 *  is returned by the `selector` will be used to continue the observable chain.
	 * @return {Observable} An observable that originates from either the source or the observable returned by the
	 *  catch `selector` function.
	 * @name catchError
	 */
	function catchError(selector) {
	    return function catchErrorOperatorFunction(source) {
	        var operator = new CatchOperator(selector);
	        var caught = source.lift(operator);
	        return (operator.caught = caught);
	    };
	}
	exports.catchError = catchError;
	var CatchOperator = (function () {
	    function CatchOperator(selector) {
	        this.selector = selector;
	    }
	    CatchOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
	    };
	    return CatchOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CatchSubscriber = (function (_super) {
	    __extends(CatchSubscriber, _super);
	    function CatchSubscriber(destination, selector, caught) {
	        _super.call(this, destination);
	        this.selector = selector;
	        this.caught = caught;
	    }
	    // NOTE: overriding `error` instead of `_error` because we don't want
	    // to have this flag this subscriber as `isStopped`. We can mimic the
	    // behavior of the RetrySubscriber (from the `retry` operator), where
	    // we unsubscribe from our source chain, reset our Subscriber flags,
	    // then subscribe to the selector result.
	    CatchSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var result = void 0;
	            try {
	                result = this.selector(err, this.caught);
	            }
	            catch (err2) {
	                _super.prototype.error.call(this, err2);
	                return;
	            }
	            this._unsubscribeAndRecycle();
	            this.add(subscribeToResult_1.subscribeToResult(this, result));
	        }
	    };
	    return CatchSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=catchError.js.map

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var combineAll_1 = __webpack_require__(644);
	Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineAll_1 = __webpack_require__(645);
	/**
	 * Converts a higher-order Observable into a first-order Observable by waiting
	 * for the outer Observable to complete, then applying {@link combineLatest}.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by applying
	 * {@link combineLatest} when the Observable-of-Observables completes.</span>
	 *
	 * <img src="./img/combineAll.png" width="100%">
	 *
	 * Takes an Observable of Observables, and collects all Observables from it.
	 * Once the outer Observable completes, it subscribes to all collected
	 * Observables and combines their values using the {@link combineLatest}
	 * strategy, such that:
	 * - Every time an inner Observable emits, the output Observable emits.
	 * - When the returned observable emits, it emits all of the latest values by:
	 *   - If a `project` function is provided, it is called with each recent value
	 *     from each inner Observable in whatever order they arrived, and the result
	 *     of the `project` function is what is emitted by the output Observable.
	 *   - If there is no `project` function, an array of all of the most recent
	 *     values is emitted by the output Observable.
	 *
	 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev =>
	 *   Rx.Observable.interval(Math.random()*2000).take(3)
	 * ).take(2);
	 * var result = higherOrder.combineAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 * @see {@link mergeAll}
	 *
	 * @param {function} [project] An optional function to map the most recent
	 * values from each inner Observable into a new result. Takes each of the most
	 * recent values from each collected inner Observable as arguments, in order.
	 * @return {Observable} An Observable of projected results or arrays of recent
	 * values.
	 * @method combineAll
	 * @owner Observable
	 */
	function combineAll(project) {
	    return combineAll_1.combineAll(project)(this);
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(530);
	function combineAll(project) {
	    return function (source) { return source.lift(new combineLatest_1.CombineLatestOperator(project)); };
	}
	exports.combineAll = combineAll;
	//# sourceMappingURL=combineAll.js.map

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var combineLatest_1 = __webpack_require__(647);
	Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var combineLatest_1 = __webpack_require__(530);
	/* tslint:enable:max-line-length */
	/**
	 * Combines multiple Observables to create an Observable whose values are
	 * calculated from the latest values of each of its input Observables.
	 *
	 * <span class="informal">Whenever any input Observable emits a value, it
	 * computes a formula using the latest values from all the inputs, then emits
	 * the output of that formula.</span>
	 *
	 * <img src="./img/combineLatest.png" width="100%">
	 *
	 * `combineLatest` combines the values from this Observable with values from
	 * Observables passed as arguments. This is done by subscribing to each
	 * Observable, in order, and collecting an array of each of the most recent
	 * values any time any of the input Observables emits, then either taking that
	 * array and passing it as arguments to an optional `project` function and
	 * emitting the return value of that, or just emitting the array of recent
	 * values directly if there is no `project` function.
	 *
	 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
	 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
	 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
	 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
	 * bmi.subscribe(x => console.log('BMI is ' + x));
	 *
	 * // With output to console:
	 * // BMI is 24.212293388429753
	 * // BMI is 23.93948099205209
	 * // BMI is 23.671253629592222
	 *
	 * @see {@link combineAll}
	 * @see {@link merge}
	 * @see {@link withLatestFrom}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {function} [project] An optional function to project the values from
	 * the combined latest values into a new value on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method combineLatest
	 * @owner Observable
	 */
	function combineLatest() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return combineLatest_1.combineLatest.apply(void 0, observables)(this);
	}
	exports.combineLatest = combineLatest;
	//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var concat_1 = __webpack_require__(649);
	Observable_1.Observable.prototype.concat = concat_1.concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(650);
	var concat_2 = __webpack_require__(538);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return concat_1.concat.apply(void 0, observables)(this);
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concat_1 = __webpack_require__(538);
	var concat_2 = __webpack_require__(538);
	exports.concatStatic = concat_2.concat;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which sequentially emits all values from every
	 * given input Observable after the current Observable.
	 *
	 * <span class="informal">Concatenates multiple Observables together by
	 * sequentially emitting their values, one Observable after the other.</span>
	 *
	 * <img src="./img/concat.png" width="100%">
	 *
	 * Joins this Observable with multiple other Observables by subscribing to them
	 * one at a time, starting with the source, and merging their results into the
	 * output Observable. Will wait for each Observable to complete before moving
	 * on to the next.
	 *
	 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
	 * var timer = Rx.Observable.interval(1000).take(4);
	 * var sequence = Rx.Observable.range(1, 10);
	 * var result = timer.concat(sequence);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in:
	 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
	 *
	 * @example <caption>Concatenate 3 Observables</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var result = timer1.concat(timer2, timer3);
	 * result.subscribe(x => console.log(x));
	 *
	 * // results in the following:
	 * // (Prints to console sequentially)
	 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
	 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
	 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
	 *
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 *
	 * @param {ObservableInput} other An input Observable to concatenate after the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
	 * Observable subscription on.
	 * @return {Observable} All values of each passed Observable merged into a
	 * single Observable, in order, in serial fashion.
	 * @method concat
	 * @owner Observable
	 */
	function concat() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(concat_1.concat.apply(void 0, [source].concat(observables))); };
	}
	exports.concat = concat;
	//# sourceMappingURL=concat.js.map

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var concatAll_1 = __webpack_require__(652);
	Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatAll_1 = __webpack_require__(547);
	/* tslint:enable:max-line-length */
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * concatenating the inner Observables in order.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by putting one
	 * inner Observable after the other.</span>
	 *
	 * <img src="./img/concatAll.png" width="100%">
	 *
	 * Joins every Observable emitted by the source (a higher-order Observable), in
	 * a serial fashion. It subscribes to each inner Observable only after the
	 * previous inner Observable has completed, and merges all of their values into
	 * the returned observable.
	 *
	 * __Warning:__ If the source Observable emits Observables quickly and
	 * endlessly, and the inner Observables it emits generally complete slower than
	 * the source emits, you can run into memory issues as the incoming Observables
	 * collect in an unbounded buffer.
	 *
	 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
	 * var firstOrder = higherOrder.concatAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link combineAll}
	 * @see {@link concat}
	 * @see {@link concatMap}
	 * @see {@link concatMapTo}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable emitting values from all the inner
	 * Observables concatenated.
	 * @method concatAll
	 * @owner Observable
	 */
	function concatAll() {
	    return concatAll_1.concatAll()(this);
	}
	exports.concatAll = concatAll;
	//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var concatMap_1 = __webpack_require__(654);
	Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(655);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return concatMap_1.concatMap(project, resultSelector)(this);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(549);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, in a serialized fashion waiting for each one to complete before
	 * merging the next.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link concatAll}.</span>
	 *
	 * <img src="./img/concatMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each new inner Observable is
	 * concatenated with the previous inner Observable.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
	 * to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMapTo}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking values from each projected inner
	 * Observable sequentially.
	 * @method concatMap
	 * @owner Observable
	 */
	function concatMap(project, resultSelector) {
	    return mergeMap_1.mergeMap(project, resultSelector, 1);
	}
	exports.concatMap = concatMap;
	//# sourceMappingURL=concatMap.js.map

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var concatMapTo_1 = __webpack_require__(657);
	Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMapTo_1 = __webpack_require__(658);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMapTo_1.concatMapTo(innerObservable, resultSelector)(this);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var concatMap_1 = __webpack_require__(655);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in a serialized fashion on the output Observable.
	 *
	 * <span class="informal">It's like {@link concatMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/concatMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. Each new `innerObservable`
	 * instance emitted on the output Observable is concatenated with the previous
	 * `innerObservable` instance.
	 *
	 * __Warning:__ if source values arrive endlessly and faster than their
	 * corresponding inner Observables can complete, it will result in memory issues
	 * as inner Observables amass in an unbounded buffer waiting for their turn to
	 * be subscribed to.
	 *
	 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
	 * set to `1`.
	 *
	 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // (results are not concurrent)
	 * // For every click on the "document" it will emit values 0 to 3 spaced
	 * // on a 1000ms interval
	 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
	 *
	 * @see {@link concat}
	 * @see {@link concatAll}
	 * @see {@link concatMap}
	 * @see {@link mergeMapTo}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An observable of values merged together by joining the
	 * passed observable with itself, one after the other, for each value emitted
	 * from the source.
	 * @method concatMapTo
	 * @owner Observable
	 */
	function concatMapTo(innerObservable, resultSelector) {
	    return concatMap_1.concatMap(function () { return innerObservable; }, resultSelector);
	}
	exports.concatMapTo = concatMapTo;
	//# sourceMappingURL=concatMapTo.js.map

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var count_1 = __webpack_require__(660);
	Observable_1.Observable.prototype.count = count_1.count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var count_1 = __webpack_require__(661);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return count_1.count(predicate)(this);
	}
	exports.count = count;
	//# sourceMappingURL=count.js.map

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Counts the number of emissions on the source and emits that number when the
	 * source completes.
	 *
	 * <span class="informal">Tells how many values were emitted, when the source
	 * completes.</span>
	 *
	 * <img src="./img/count.png" width="100%">
	 *
	 * `count` transforms an Observable that emits values into an Observable that
	 * emits a single value that represents the number of values emitted by the
	 * source Observable. If the source Observable terminates with an error, `count`
	 * will pass this error notification along without emitting a value first. If
	 * the source Observable does not terminate at all, `count` will neither emit
	 * a value nor terminate. This operator takes an optional `predicate` function
	 * as argument, in which case the output emission will represent the number of
	 * source values that matched `true` with the `predicate`.
	 *
	 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var secondsBeforeClick = seconds.takeUntil(clicks);
	 * var result = secondsBeforeClick.count();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
	 * var numbers = Rx.Observable.range(1, 7);
	 * var result = numbers.count(i => i % 2 === 1);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 4
	 *
	 * @see {@link max}
	 * @see {@link min}
	 * @see {@link reduce}
	 *
	 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
	 * boolean function to select what values are to be counted. It is provided with
	 * arguments of:
	 * - `value`: the value from the source Observable.
	 * - `index`: the (zero-based) "index" of the value from the source Observable.
	 * - `source`: the source Observable instance itself.
	 * @return {Observable} An Observable of one number that represents the count as
	 * described above.
	 * @method count
	 * @owner Observable
	 */
	function count(predicate) {
	    return function (source) { return source.lift(new CountOperator(predicate, source)); };
	}
	exports.count = count;
	var CountOperator = (function () {
	    function CountOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    CountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
	    };
	    return CountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var CountSubscriber = (function (_super) {
	    __extends(CountSubscriber, _super);
	    function CountSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.count = 0;
	        this.index = 0;
	    }
	    CountSubscriber.prototype._next = function (value) {
	        if (this.predicate) {
	            this._tryPredicate(value);
	        }
	        else {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._tryPredicate = function (value) {
	        var result;
	        try {
	            result = this.predicate(value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.count++;
	        }
	    };
	    CountSubscriber.prototype._complete = function () {
	        this.destination.next(this.count);
	        this.destination.complete();
	    };
	    return CountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=count.js.map

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var dematerialize_1 = __webpack_require__(663);
	Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var dematerialize_1 = __webpack_require__(664);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return dematerialize_1.dematerialize()(this);
	}
	exports.dematerialize = dematerialize;
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Converts an Observable of {@link Notification} objects into the emissions
	 * that they represent.
	 *
	 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
	 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
	 *
	 * <img src="./img/dematerialize.png" width="100%">
	 *
	 * `dematerialize` is assumed to operate an Observable that only emits
	 * {@link Notification} objects as `next` emissions, and does not emit any
	 * `error`. Such Observable is the output of a `materialize` operation. Those
	 * notifications are then unwrapped using the metadata they contain, and emitted
	 * as `next`, `error`, and `complete` on the output Observable.
	 *
	 * Use this operator in conjunction with {@link materialize}.
	 *
	 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
	 * var notifA = new Rx.Notification('N', 'A');
	 * var notifB = new Rx.Notification('N', 'B');
	 * var notifE = new Rx.Notification('E', void 0,
	 *   new TypeError('x.toUpperCase is not a function')
	 * );
	 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
	 * var upperCase = materialized.dematerialize();
	 * upperCase.subscribe(x => console.log(x), e => console.error(e));
	 *
	 * // Results in:
	 * // A
	 * // B
	 * // TypeError: x.toUpperCase is not a function
	 *
	 * @see {@link Notification}
	 * @see {@link materialize}
	 *
	 * @return {Observable} An Observable that emits items and notifications
	 * embedded in Notification objects emitted by the source Observable.
	 * @method dematerialize
	 * @owner Observable
	 */
	function dematerialize() {
	    return function dematerializeOperatorFunction(source) {
	        return source.lift(new DeMaterializeOperator());
	    };
	}
	exports.dematerialize = dematerialize;
	var DeMaterializeOperator = (function () {
	    function DeMaterializeOperator() {
	    }
	    DeMaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DeMaterializeSubscriber(subscriber));
	    };
	    return DeMaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DeMaterializeSubscriber = (function (_super) {
	    __extends(DeMaterializeSubscriber, _super);
	    function DeMaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    DeMaterializeSubscriber.prototype._next = function (value) {
	        value.observe(this.destination);
	    };
	    return DeMaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=dematerialize.js.map

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var debounce_1 = __webpack_require__(666);
	Observable_1.Observable.prototype.debounce = debounce_1.debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var debounce_1 = __webpack_require__(667);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return debounce_1.debounce(durationSelector)(this);
	}
	exports.debounce = debounce;
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * determined by another Observable has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link debounceTime}, but the time span of
	 * emission silence is determined by a second Observable.</span>
	 *
	 * <img src="./img/debounce.png" width="100%">
	 *
	 * `debounce` delays values emitted by the source Observable, but drops previous
	 * pending delayed emissions if a new value arrives on the source Observable.
	 * This operator keeps track of the most recent value from the source
	 * Observable, and spawns a duration Observable by calling the
	 * `durationSelector` function. The value is emitted only when the duration
	 * Observable emits a value or completes, and if no other value was emitted on
	 * the source Observable since the duration Observable was spawned. If a new
	 * value appears before the duration Observable emits, the previous value will
	 * be dropped and will not be emitted on the output Observable.
	 *
	 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
	 * delay-like operator since output emissions do not necessarily occur at the
	 * same time as they did on the source Observable.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the timeout
	 * duration for each source value, returned as an Observable or a Promise.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified duration Observable returned by
	 * `durationSelector`, and may drop some values if they occur too frequently.
	 * @method debounce
	 * @owner Observable
	 */
	function debounce(durationSelector) {
	    return function (source) { return source.lift(new DebounceOperator(durationSelector)); };
	}
	exports.debounce = debounce;
	var DebounceOperator = (function () {
	    function DebounceOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    DebounceOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
	    };
	    return DebounceOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceSubscriber = (function (_super) {
	    __extends(DebounceSubscriber, _super);
	    function DebounceSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	        this.durationSubscription = null;
	    }
	    DebounceSubscriber.prototype._next = function (value) {
	        try {
	            var result = this.durationSelector.call(this, value);
	            if (result) {
	                this._tryNext(value, result);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DebounceSubscriber.prototype._complete = function () {
	        this.emitValue();
	        this.destination.complete();
	    };
	    DebounceSubscriber.prototype._tryNext = function (value, duration) {
	        var subscription = this.durationSubscription;
	        this.value = value;
	        this.hasValue = true;
	        if (subscription) {
	            subscription.unsubscribe();
	            this.remove(subscription);
	        }
	        subscription = subscribeToResult_1.subscribeToResult(this, duration);
	        if (!subscription.closed) {
	            this.add(this.durationSubscription = subscription);
	        }
	    };
	    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    DebounceSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            var value = this.value;
	            var subscription = this.durationSubscription;
	            if (subscription) {
	                this.durationSubscription = null;
	                subscription.unsubscribe();
	                this.remove(subscription);
	            }
	            this.value = null;
	            this.hasValue = false;
	            _super.prototype._next.call(this, value);
	        }
	    };
	    return DebounceSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=debounce.js.map

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var debounceTime_1 = __webpack_require__(669);
	Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var debounceTime_1 = __webpack_require__(670);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return debounceTime_1.debounceTime(dueTime, scheduler)(this);
	}
	exports.debounceTime = debounceTime;
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var async_1 = __webpack_require__(578);
	/**
	 * Emits a value from the source Observable only after a particular time span
	 * has passed without another source emission.
	 *
	 * <span class="informal">It's like {@link delay}, but passes only the most
	 * recent value from each burst of emissions.</span>
	 *
	 * <img src="./img/debounceTime.png" width="100%">
	 *
	 * `debounceTime` delays values emitted by the source Observable, but drops
	 * previous pending delayed emissions if a new value arrives on the source
	 * Observable. This operator keeps track of the most recent value from the
	 * source Observable, and emits that only when `dueTime` enough time has passed
	 * without any other value appearing on the source Observable. If a new value
	 * appears before `dueTime` silence occurs, the previous value will be dropped
	 * and will not be emitted on the output Observable.
	 *
	 * This is a rate-limiting operator, because it is impossible for more than one
	 * value to be emitted in any time window of duration `dueTime`, but it is also
	 * a delay-like operator since output emissions do not occur at the same time as
	 * they did on the source Observable. Optionally takes a {@link IScheduler} for
	 * managing timers.
	 *
	 * @example <caption>Emit the most recent click after a burst of clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.debounceTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} dueTime The timeout duration in milliseconds (or the time
	 * unit determined internally by the optional `scheduler`) for the window of
	 * time required to wait for emission silence before emitting the most recent
	 * source value.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the timeout for each value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified `dueTime`, and may drop some values if they occur
	 * too frequently.
	 * @method debounceTime
	 * @owner Observable
	 */
	function debounceTime(dueTime, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new DebounceTimeOperator(dueTime, scheduler)); };
	}
	exports.debounceTime = debounceTime;
	var DebounceTimeOperator = (function () {
	    function DebounceTimeOperator(dueTime, scheduler) {
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	    }
	    DebounceTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
	    };
	    return DebounceTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DebounceTimeSubscriber = (function (_super) {
	    __extends(DebounceTimeSubscriber, _super);
	    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
	        _super.call(this, destination);
	        this.dueTime = dueTime;
	        this.scheduler = scheduler;
	        this.debouncedSubscription = null;
	        this.lastValue = null;
	        this.hasValue = false;
	    }
	    DebounceTimeSubscriber.prototype._next = function (value) {
	        this.clearDebounce();
	        this.lastValue = value;
	        this.hasValue = true;
	        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
	    };
	    DebounceTimeSubscriber.prototype._complete = function () {
	        this.debouncedNext();
	        this.destination.complete();
	    };
	    DebounceTimeSubscriber.prototype.debouncedNext = function () {
	        this.clearDebounce();
	        if (this.hasValue) {
	            this.destination.next(this.lastValue);
	            this.lastValue = null;
	            this.hasValue = false;
	        }
	    };
	    DebounceTimeSubscriber.prototype.clearDebounce = function () {
	        var debouncedSubscription = this.debouncedSubscription;
	        if (debouncedSubscription !== null) {
	            this.remove(debouncedSubscription);
	            debouncedSubscription.unsubscribe();
	            this.debouncedSubscription = null;
	        }
	    };
	    return DebounceTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(subscriber) {
	    subscriber.debouncedNext();
	}
	//# sourceMappingURL=debounceTime.js.map

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var defaultIfEmpty_1 = __webpack_require__(672);
	Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var defaultIfEmpty_1 = __webpack_require__(673);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return defaultIfEmpty_1.defaultIfEmpty(defaultValue)(this);
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/* tslint:enable:max-line-length */
	/**
	 * Emits a given value if the source Observable completes without emitting any
	 * `next` value, otherwise mirrors the source Observable.
	 *
	 * <span class="informal">If the source Observable turns out to be empty, then
	 * this operator will emit a default value.</span>
	 *
	 * <img src="./img/defaultIfEmpty.png" width="100%">
	 *
	 * `defaultIfEmpty` emits the values emitted by the source Observable or a
	 * specified default value if the source Observable is empty (completes without
	 * having emitted any `next` value).
	 *
	 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
	 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link empty}
	 * @see {@link last}
	 *
	 * @param {any} [defaultValue=null] The default value used if the source
	 * Observable is empty.
	 * @return {Observable} An Observable that emits either the specified
	 * `defaultValue` if the source Observable emits no items, or the values emitted
	 * by the source Observable.
	 * @method defaultIfEmpty
	 * @owner Observable
	 */
	function defaultIfEmpty(defaultValue) {
	    if (defaultValue === void 0) { defaultValue = null; }
	    return function (source) { return source.lift(new DefaultIfEmptyOperator(defaultValue)); };
	}
	exports.defaultIfEmpty = defaultIfEmpty;
	var DefaultIfEmptyOperator = (function () {
	    function DefaultIfEmptyOperator(defaultValue) {
	        this.defaultValue = defaultValue;
	    }
	    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
	    };
	    return DefaultIfEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DefaultIfEmptySubscriber = (function (_super) {
	    __extends(DefaultIfEmptySubscriber, _super);
	    function DefaultIfEmptySubscriber(destination, defaultValue) {
	        _super.call(this, destination);
	        this.defaultValue = defaultValue;
	        this.isEmpty = true;
	    }
	    DefaultIfEmptySubscriber.prototype._next = function (value) {
	        this.isEmpty = false;
	        this.destination.next(value);
	    };
	    DefaultIfEmptySubscriber.prototype._complete = function () {
	        if (this.isEmpty) {
	            this.destination.next(this.defaultValue);
	        }
	        this.destination.complete();
	    };
	    return DefaultIfEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var delay_1 = __webpack_require__(675);
	Observable_1.Observable.prototype.delay = delay_1.delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var delay_1 = __webpack_require__(676);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return delay_1.delay(delay, scheduler)(this);
	}
	exports.delay = delay;
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(578);
	var isDate_1 = __webpack_require__(609);
	var Subscriber_1 = __webpack_require__(502);
	var Notification_1 = __webpack_require__(546);
	/**
	 * Delays the emission of items from the source Observable by a given timeout or
	 * until a given Date.
	 *
	 * <span class="informal">Time shifts each item by some specified amount of
	 * milliseconds.</span>
	 *
	 * <img src="./img/delay.png" width="100%">
	 *
	 * If the delay argument is a Number, this operator time shifts the source
	 * Observable by that amount of time expressed in milliseconds. The relative
	 * time intervals between the values are preserved.
	 *
	 * If the delay argument is a Date, this operator time shifts the start of the
	 * Observable execution until the given date occurs.
	 *
	 * @example <caption>Delay each click by one second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @example <caption>Delay all clicks until a future date happens</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var date = new Date('March 15, 2050 12:00:00'); // in the future
	 * var delayedClicks = clicks.delay(date); // click emitted only after that date
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounceTime}
	 * @see {@link delayWhen}
	 *
	 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
	 * a `Date` until which the emission of the source items is delayed.
	 * @param {Scheduler} [scheduler=async] The IScheduler to use for
	 * managing the timers that handle the time-shift for each item.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by the specified timeout or Date.
	 * @method delay
	 * @owner Observable
	 */
	function delay(delay, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteDelay = isDate_1.isDate(delay);
	    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
	    return function (source) { return source.lift(new DelayOperator(delayFor, scheduler)); };
	}
	exports.delay = delay;
	var DelayOperator = (function () {
	    function DelayOperator(delay, scheduler) {
	        this.delay = delay;
	        this.scheduler = scheduler;
	    }
	    DelayOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
	    };
	    return DelayOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelaySubscriber = (function (_super) {
	    __extends(DelaySubscriber, _super);
	    function DelaySubscriber(destination, delay, scheduler) {
	        _super.call(this, destination);
	        this.delay = delay;
	        this.scheduler = scheduler;
	        this.queue = [];
	        this.active = false;
	        this.errored = false;
	    }
	    DelaySubscriber.dispatch = function (state) {
	        var source = state.source;
	        var queue = source.queue;
	        var scheduler = state.scheduler;
	        var destination = state.destination;
	        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
	            queue.shift().notification.observe(destination);
	        }
	        if (queue.length > 0) {
	            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
	            this.schedule(state, delay_1);
	        }
	        else {
	            this.unsubscribe();
	            source.active = false;
	        }
	    };
	    DelaySubscriber.prototype._schedule = function (scheduler) {
	        this.active = true;
	        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
	            source: this, destination: this.destination, scheduler: scheduler
	        }));
	    };
	    DelaySubscriber.prototype.scheduleNotification = function (notification) {
	        if (this.errored === true) {
	            return;
	        }
	        var scheduler = this.scheduler;
	        var message = new DelayMessage(scheduler.now() + this.delay, notification);
	        this.queue.push(message);
	        if (this.active === false) {
	            this._schedule(scheduler);
	        }
	    };
	    DelaySubscriber.prototype._next = function (value) {
	        this.scheduleNotification(Notification_1.Notification.createNext(value));
	    };
	    DelaySubscriber.prototype._error = function (err) {
	        this.errored = true;
	        this.queue = [];
	        this.destination.error(err);
	    };
	    DelaySubscriber.prototype._complete = function () {
	        this.scheduleNotification(Notification_1.Notification.createComplete());
	    };
	    return DelaySubscriber;
	}(Subscriber_1.Subscriber));
	var DelayMessage = (function () {
	    function DelayMessage(time, notification) {
	        this.time = time;
	        this.notification = notification;
	    }
	    return DelayMessage;
	}());
	//# sourceMappingURL=delay.js.map

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var delayWhen_1 = __webpack_require__(678);
	Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var delayWhen_1 = __webpack_require__(679);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    return delayWhen_1.delayWhen(delayDurationSelector, subscriptionDelay)(this);
	}
	exports.delayWhen = delayWhen;
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Observable_1 = __webpack_require__(499);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Delays the emission of items from the source Observable by a given time span
	 * determined by the emissions of another Observable.
	 *
	 * <span class="informal">It's like {@link delay}, but the time span of the
	 * delay duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/delayWhen.png" width="100%">
	 *
	 * `delayWhen` time shifts each emitted value from the source Observable by a
	 * time span determined by another Observable. When the source emits a value,
	 * the `delayDurationSelector` function is called with the source value as
	 * argument, and should return an Observable, called the "duration" Observable.
	 * The source value is emitted on the output Observable only when the duration
	 * Observable emits a value or completes.
	 *
	 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
	 * is an Observable. When `subscriptionDelay` emits its first value or
	 * completes, the source Observable is subscribed to and starts behaving like
	 * described in the previous paragraph. If `subscriptionDelay` is not provided,
	 * `delayWhen` will subscribe to the source Observable as soon as the output
	 * Observable is subscribed.
	 *
	 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var delayedClicks = clicks.delayWhen(event =>
	 *   Rx.Observable.interval(Math.random() * 5000)
	 * );
	 * delayedClicks.subscribe(x => console.log(x));
	 *
	 * @see {@link debounce}
	 * @see {@link delay}
	 *
	 * @param {function(value: T): Observable} delayDurationSelector A function that
	 * returns an Observable for each value emitted by the source Observable, which
	 * is then used to delay the emission of that item on the output Observable
	 * until the Observable returned from this function emits a value.
	 * @param {Observable} subscriptionDelay An Observable that triggers the
	 * subscription to the source Observable once it emits any value.
	 * @return {Observable} An Observable that delays the emissions of the source
	 * Observable by an amount of time specified by the Observable returned by
	 * `delayDurationSelector`.
	 * @method delayWhen
	 * @owner Observable
	 */
	function delayWhen(delayDurationSelector, subscriptionDelay) {
	    if (subscriptionDelay) {
	        return function (source) {
	            return new SubscriptionDelayObservable(source, subscriptionDelay)
	                .lift(new DelayWhenOperator(delayDurationSelector));
	        };
	    }
	    return function (source) { return source.lift(new DelayWhenOperator(delayDurationSelector)); };
	}
	exports.delayWhen = delayWhen;
	var DelayWhenOperator = (function () {
	    function DelayWhenOperator(delayDurationSelector) {
	        this.delayDurationSelector = delayDurationSelector;
	    }
	    DelayWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
	    };
	    return DelayWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DelayWhenSubscriber = (function (_super) {
	    __extends(DelayWhenSubscriber, _super);
	    function DelayWhenSubscriber(destination, delayDurationSelector) {
	        _super.call(this, destination);
	        this.delayDurationSelector = delayDurationSelector;
	        this.completed = false;
	        this.delayNotifierSubscriptions = [];
	        this.values = [];
	    }
	    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.destination.next(outerValue);
	        this.removeSubscription(innerSub);
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        var value = this.removeSubscription(innerSub);
	        if (value) {
	            this.destination.next(value);
	        }
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype._next = function (value) {
	        try {
	            var delayNotifier = this.delayDurationSelector(value);
	            if (delayNotifier) {
	                this.tryDelay(delayNotifier, value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    DelayWhenSubscriber.prototype._complete = function () {
	        this.completed = true;
	        this.tryComplete();
	    };
	    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
	        subscription.unsubscribe();
	        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
	        var value = null;
	        if (subscriptionIdx !== -1) {
	            value = this.values[subscriptionIdx];
	            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
	            this.values.splice(subscriptionIdx, 1);
	        }
	        return value;
	    };
	    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
	        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
	        if (notifierSubscription && !notifierSubscription.closed) {
	            this.add(notifierSubscription);
	            this.delayNotifierSubscriptions.push(notifierSubscription);
	        }
	        this.values.push(value);
	    };
	    DelayWhenSubscriber.prototype.tryComplete = function () {
	        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
	            this.destination.complete();
	        }
	    };
	    return DelayWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelayObservable = (function (_super) {
	    __extends(SubscriptionDelayObservable, _super);
	    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
	        _super.call(this);
	        this.source = source;
	        this.subscriptionDelay = subscriptionDelay;
	    }
	    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
	        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
	    };
	    return SubscriptionDelayObservable;
	}(Observable_1.Observable));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SubscriptionDelaySubscriber = (function (_super) {
	    __extends(SubscriptionDelaySubscriber, _super);
	    function SubscriptionDelaySubscriber(parent, source) {
	        _super.call(this);
	        this.parent = parent;
	        this.source = source;
	        this.sourceSubscribed = false;
	    }
	    SubscriptionDelaySubscriber.prototype._next = function (unused) {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype._error = function (err) {
	        this.unsubscribe();
	        this.parent.error(err);
	    };
	    SubscriptionDelaySubscriber.prototype._complete = function () {
	        this.subscribeToSource();
	    };
	    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
	        if (!this.sourceSubscribed) {
	            this.sourceSubscribed = true;
	            this.unsubscribe();
	            this.source.subscribe(this.parent);
	        }
	    };
	    return SubscriptionDelaySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=delayWhen.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var distinct_1 = __webpack_require__(681);
	Observable_1.Observable.prototype.distinct = distinct_1.distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinct_1 = __webpack_require__(682);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return distinct_1.distinct(keySelector, flushes)(this);
	}
	exports.distinct = distinct;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	var Set_1 = __webpack_require__(683);
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
	 *
	 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
	 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
	 * source observable directly with an equality check against previous values.
	 *
	 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
	 *
	 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
	 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
	 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
	 * that the internal `Set` can be "flushed", basically clearing it of values.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
	 *   .distinct()
	 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
	 *
	 * @example <caption>An example using a keySelector function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     .distinct((p: Person) => p.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 *
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
	 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinct
	 * @owner Observable
	 */
	function distinct(keySelector, flushes) {
	    return function (source) { return source.lift(new DistinctOperator(keySelector, flushes)); };
	}
	exports.distinct = distinct;
	var DistinctOperator = (function () {
	    function DistinctOperator(keySelector, flushes) {
	        this.keySelector = keySelector;
	        this.flushes = flushes;
	    }
	    DistinctOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
	    };
	    return DistinctOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctSubscriber = (function (_super) {
	    __extends(DistinctSubscriber, _super);
	    function DistinctSubscriber(destination, keySelector, flushes) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.values = new Set_1.Set();
	        if (flushes) {
	            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
	        }
	    }
	    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values.clear();
	    };
	    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    DistinctSubscriber.prototype._next = function (value) {
	        if (this.keySelector) {
	            this._useKeySelector(value);
	        }
	        else {
	            this._finalizeNext(value, value);
	        }
	    };
	    DistinctSubscriber.prototype._useKeySelector = function (value) {
	        var key;
	        var destination = this.destination;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this._finalizeNext(key, value);
	    };
	    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
	        var values = this.values;
	        if (!values.has(key)) {
	            values.add(key);
	            this.destination.next(value);
	        }
	    };
	    return DistinctSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.DistinctSubscriber = DistinctSubscriber;
	//# sourceMappingURL=distinct.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	function minimalSetImpl() {
	    // THIS IS NOT a full impl of Set, this is just the minimum
	    // bits of functionality we need for this library.
	    return (function () {
	        function MinimalSet() {
	            this._values = [];
	        }
	        MinimalSet.prototype.add = function (value) {
	            if (!this.has(value)) {
	                this._values.push(value);
	            }
	        };
	        MinimalSet.prototype.has = function (value) {
	            return this._values.indexOf(value) !== -1;
	        };
	        Object.defineProperty(MinimalSet.prototype, "size", {
	            get: function () {
	                return this._values.length;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        MinimalSet.prototype.clear = function () {
	            this._values.length = 0;
	        };
	        return MinimalSet;
	    }());
	}
	exports.minimalSetImpl = minimalSetImpl;
	exports.Set = root_1.root.Set || minimalSetImpl();
	//# sourceMappingURL=Set.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var distinctUntilChanged_1 = __webpack_require__(685);
	Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(686);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return distinctUntilChanged_1.distinctUntilChanged(compare, keySelector)(this);
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>A simple example with numbers</caption>
	 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
	 *   .distinctUntilChanged()
	 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
	 *
	 * @example <caption>An example using a compare function</caption>
	 * interface Person {
	 *    age: number,
	 *    name: string
	 * }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'})
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilKeyChanged}
	 *
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
	 * @method distinctUntilChanged
	 * @owner Observable
	 */
	function distinctUntilChanged(compare, keySelector) {
	    return function (source) { return source.lift(new DistinctUntilChangedOperator(compare, keySelector)); };
	}
	exports.distinctUntilChanged = distinctUntilChanged;
	var DistinctUntilChangedOperator = (function () {
	    function DistinctUntilChangedOperator(compare, keySelector) {
	        this.compare = compare;
	        this.keySelector = keySelector;
	    }
	    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
	    };
	    return DistinctUntilChangedOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DistinctUntilChangedSubscriber = (function (_super) {
	    __extends(DistinctUntilChangedSubscriber, _super);
	    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.hasKey = false;
	        if (typeof compare === 'function') {
	            this.compare = compare;
	        }
	    }
	    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
	        return x === y;
	    };
	    DistinctUntilChangedSubscriber.prototype._next = function (value) {
	        var keySelector = this.keySelector;
	        var key = value;
	        if (keySelector) {
	            key = tryCatch_1.tryCatch(this.keySelector)(value);
	            if (key === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        var result = false;
	        if (this.hasKey) {
	            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
	            if (result === errorObject_1.errorObject) {
	                return this.destination.error(errorObject_1.errorObject.e);
	            }
	        }
	        else {
	            this.hasKey = true;
	        }
	        if (Boolean(result) === false) {
	            this.key = key;
	            this.destination.next(value);
	        }
	    };
	    return DistinctUntilChangedSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var distinctUntilKeyChanged_1 = __webpack_require__(688);
	Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilKeyChanged_1 = __webpack_require__(689);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilKeyChanged_1.distinctUntilKeyChanged(key, compare)(this);
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var distinctUntilChanged_1 = __webpack_require__(686);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
	 * using a property accessed by using the key provided to check if the two items are distinct.
	 *
	 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
	 *
	 * If a comparator function is not provided, an equality check is used by default.
	 *
	 * @example <caption>An example comparing the name of persons</caption>
	 *
	 *  interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo'},
	 *     { age: 6, name: 'Foo'})
	 *     .distinctUntilKeyChanged('name')
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo' }
	 *
	 * @example <caption>An example comparing the first letters of the name</caption>
	 *
	 * interface Person {
	 *     age: number,
	 *     name: string
	 *  }
	 *
	 * Observable.of<Person>(
	 *     { age: 4, name: 'Foo1'},
	 *     { age: 7, name: 'Bar'},
	 *     { age: 5, name: 'Foo2'},
	 *     { age: 6, name: 'Foo3'})
	 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
	 *     .subscribe(x => console.log(x));
	 *
	 * // displays:
	 * // { age: 4, name: 'Foo1' }
	 * // { age: 7, name: 'Bar' }
	 * // { age: 5, name: 'Foo2' }
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 *
	 * @param {string} key String key for object property lookup on each item.
	 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
	 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
	 * @method distinctUntilKeyChanged
	 * @owner Observable
	 */
	function distinctUntilKeyChanged(key, compare) {
	    return distinctUntilChanged_1.distinctUntilChanged(function (x, y) { return compare ? compare(x[key], y[key]) : x[key] === y[key]; });
	}
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
	//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var do_1 = __webpack_require__(691);
	Observable_1.Observable.prototype.do = do_1._do;
	Observable_1.Observable.prototype._do = do_1._do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var tap_1 = __webpack_require__(692);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @method do
	 * @name do
	 * @owner Observable
	 */
	function _do(nextOrObserver, error, complete) {
	    return tap_1.tap(nextOrObserver, error, complete)(this);
	}
	exports._do = _do;
	//# sourceMappingURL=do.js.map

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/* tslint:enable:max-line-length */
	/**
	 * Perform a side effect for every emission on the source Observable, but return
	 * an Observable that is identical to the source.
	 *
	 * <span class="informal">Intercepts each emission on the source and runs a
	 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
	 *
	 * <img src="./img/do.png" width="100%">
	 *
	 * Returns a mirrored Observable of the source Observable, but modified so that
	 * the provided Observer is called to perform a side effect for every value,
	 * error, and completion emitted by the source. Any errors that are thrown in
	 * the aforementioned Observer or handlers are safely sent down the error path
	 * of the output Observable.
	 *
	 * This operator is useful for debugging your Observables for the correct values
	 * or performing other side effects.
	 *
	 * Note: this is different to a `subscribe` on the Observable. If the Observable
	 * returned by `do` is not subscribed, the side effects specified by the
	 * Observer will never happen. `do` therefore simply spies on existing
	 * execution, it does not trigger an execution to happen like `subscribe` does.
	 *
	 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks
	 *   .do(ev => console.log(ev))
	 *   .map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 * @see {@link subscribe}
	 *
	 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
	 * callback for `next`.
	 * @param {function} [error] Callback for errors in the source.
	 * @param {function} [complete] Callback for the completion of the source.
	 * @return {Observable} An Observable identical to the source, but runs the
	 * specified Observer or callback(s) for each item.
	 * @name tap
	 */
	function tap(nextOrObserver, error, complete) {
	    return function tapOperatorFunction(source) {
	        return source.lift(new DoOperator(nextOrObserver, error, complete));
	    };
	}
	exports.tap = tap;
	var DoOperator = (function () {
	    function DoOperator(nextOrObserver, error, complete) {
	        this.nextOrObserver = nextOrObserver;
	        this.error = error;
	        this.complete = complete;
	    }
	    DoOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
	    };
	    return DoOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var DoSubscriber = (function (_super) {
	    __extends(DoSubscriber, _super);
	    function DoSubscriber(destination, nextOrObserver, error, complete) {
	        _super.call(this, destination);
	        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
	        safeSubscriber.syncErrorThrowable = true;
	        this.add(safeSubscriber);
	        this.safeSubscriber = safeSubscriber;
	    }
	    DoSubscriber.prototype._next = function (value) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.next(value);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.next(value);
	        }
	    };
	    DoSubscriber.prototype._error = function (err) {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.error(err);
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.error(err);
	        }
	    };
	    DoSubscriber.prototype._complete = function () {
	        var safeSubscriber = this.safeSubscriber;
	        safeSubscriber.complete();
	        if (safeSubscriber.syncErrorThrown) {
	            this.destination.error(safeSubscriber.syncErrorValue);
	        }
	        else {
	            this.destination.complete();
	        }
	    };
	    return DoSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=tap.js.map

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var exhaust_1 = __webpack_require__(694);
	Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaust_1 = __webpack_require__(695);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return exhaust_1.exhaust()(this);
	}
	exports.exhaust = exhaust;
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Converts a higher-order Observable into a first-order Observable by dropping
	 * inner Observables while the previous inner Observable has not yet completed.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * next inner Observables while the current inner is still executing.</span>
	 *
	 * <img src="./img/exhaust.png" width="100%">
	 *
	 * `exhaust` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable begins emitting the items emitted by that
	 * inner Observable. So far, it behaves like {@link mergeAll}. However,
	 * `exhaust` ignores every new inner Observable if the previous Observable has
	 * not yet completed. Once that one completes, it will accept and flatten the
	 * next inner Observable and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
	 * var result = higherOrder.exhaust();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link switch}
	 * @see {@link mergeAll}
	 * @see {@link exhaustMap}
	 * @see {@link zipAll}
	 *
	 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
	 * exclusively until it completes before subscribing to the next.
	 * @method exhaust
	 * @owner Observable
	 */
	function exhaust() {
	    return function (source) { return source.lift(new SwitchFirstOperator()); };
	}
	exports.exhaust = exhaust;
	var SwitchFirstOperator = (function () {
	    function SwitchFirstOperator() {
	    }
	    SwitchFirstOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstSubscriber(subscriber));
	    };
	    return SwitchFirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstSubscriber = (function (_super) {
	    __extends(SwitchFirstSubscriber, _super);
	    function SwitchFirstSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasCompleted = false;
	        this.hasSubscription = false;
	    }
	    SwitchFirstSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, value));
	        }
	    };
	    SwitchFirstSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaust.js.map

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var exhaustMap_1 = __webpack_require__(697);
	Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var exhaustMap_1 = __webpack_require__(698);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return exhaustMap_1.exhaustMap(project, resultSelector)(this);
	}
	exports.exhaustMap = exhaustMap;
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable only if the previous projected Observable has completed.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link exhaust}.</span>
	 *
	 * <img src="./img/exhaustMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. When it projects a source value to
	 * an Observable, the output Observable begins emitting the items emitted by
	 * that projected Observable. However, `exhaustMap` ignores every new projected
	 * Observable if the previous projected Observable has not yet completed. Once
	 * that one completes, it will accept and flatten the next projected Observable
	 * and repeat this process.
	 *
	 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaust}
	 * @see {@link mergeMap}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable containing projected Observables
	 * of each item of the source, ignoring projected Observables that start before
	 * their preceding Observable has completed.
	 * @method exhaustMap
	 * @owner Observable
	 */
	function exhaustMap(project, resultSelector) {
	    return function (source) { return source.lift(new SwitchFirstMapOperator(project, resultSelector)); };
	}
	exports.exhaustMap = exhaustMap;
	var SwitchFirstMapOperator = (function () {
	    function SwitchFirstMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchFirstMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchFirstMapSubscriber = (function (_super) {
	    __extends(SwitchFirstMapSubscriber, _super);
	    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.hasSubscription = false;
	        this.hasCompleted = false;
	        this.index = 0;
	    }
	    SwitchFirstMapSubscriber.prototype._next = function (value) {
	        if (!this.hasSubscription) {
	            this.tryNext(value);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
	        var index = this.index++;
	        var destination = this.destination;
	        try {
	            var result = this.project(value, index);
	            this.hasSubscription = true;
	            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (!this.hasSubscription) {
	            this.destination.complete();
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        try {
	            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	            destination.next(result);
	        }
	        catch (err) {
	            destination.error(err);
	        }
	    };
	    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.hasSubscription = false;
	        if (this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return SwitchFirstMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=exhaustMap.js.map

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var expand_1 = __webpack_require__(700);
	Observable_1.Observable.prototype.expand = expand_1.expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var expand_1 = __webpack_require__(701);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return expand_1.expand(project, concurrent, scheduler)(this);
	}
	exports.expand = expand;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Recursively projects each source value to an Observable which is merged in
	 * the output Observable.
	 *
	 * <span class="informal">It's similar to {@link mergeMap}, but applies the
	 * projection function to every source value as well as every output value.
	 * It's recursive.</span>
	 *
	 * <img src="./img/expand.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger. *Expand* will re-emit on the output
	 * Observable every source value. Then, each output value is given to the
	 * `project` function which returns an inner Observable to be merged on the
	 * output Observable. Those output values resulting from the projection are also
	 * given to the `project` function to produce new output values. This is how
	 * *expand* behaves recursively.
	 *
	 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var powersOfTwo = clicks
	 *   .mapTo(1)
	 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
	 *   .take(10);
	 * powersOfTwo.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 *
	 * @param {function(value: T, index: number) => Observable} project A function
	 * that, when applied to an item emitted by the source or the output Observable,
	 * returns an Observable.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
	 * each projected inner Observable.
	 * @return {Observable} An Observable that emits the source values and also
	 * result of applying the projection function to each value emitted on the
	 * output Observable and and merging the results of the Observables obtained
	 * from this transformation.
	 * @method expand
	 * @owner Observable
	 */
	function expand(project, concurrent, scheduler) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (scheduler === void 0) { scheduler = undefined; }
	    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
	    return function (source) { return source.lift(new ExpandOperator(project, concurrent, scheduler)); };
	}
	exports.expand = expand;
	var ExpandOperator = (function () {
	    function ExpandOperator(project, concurrent, scheduler) {
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	    }
	    ExpandOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
	    };
	    return ExpandOperator;
	}());
	exports.ExpandOperator = ExpandOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ExpandSubscriber = (function (_super) {
	    __extends(ExpandSubscriber, _super);
	    function ExpandSubscriber(destination, project, concurrent, scheduler) {
	        _super.call(this, destination);
	        this.project = project;
	        this.concurrent = concurrent;
	        this.scheduler = scheduler;
	        this.index = 0;
	        this.active = 0;
	        this.hasCompleted = false;
	        if (concurrent < Number.POSITIVE_INFINITY) {
	            this.buffer = [];
	        }
	    }
	    ExpandSubscriber.dispatch = function (arg) {
	        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
	        subscriber.subscribeToProjection(result, value, index);
	    };
	    ExpandSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (destination.closed) {
	            this._complete();
	            return;
	        }
	        var index = this.index++;
	        if (this.active < this.concurrent) {
	            destination.next(value);
	            var result = tryCatch_1.tryCatch(this.project)(value, index);
	            if (result === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else if (!this.scheduler) {
	                this.subscribeToProjection(result, value, index);
	            }
	            else {
	                var state = { subscriber: this, result: result, value: value, index: index };
	                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
	        this.active++;
	        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    ExpandSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._next(innerValue);
	    };
	    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer && buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        if (this.hasCompleted && this.active === 0) {
	            this.destination.complete();
	        }
	    };
	    return ExpandSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.ExpandSubscriber = ExpandSubscriber;
	//# sourceMappingURL=expand.js.map

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var elementAt_1 = __webpack_require__(703);
	Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var elementAt_1 = __webpack_require__(704);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return elementAt_1.elementAt(index, defaultValue)(this);
	}
	exports.elementAt = elementAt;
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var ArgumentOutOfRangeError_1 = __webpack_require__(705);
	/**
	 * Emits the single value at the specified `index` in a sequence of emissions
	 * from the source Observable.
	 *
	 * <span class="informal">Emits only the i-th value, then completes.</span>
	 *
	 * <img src="./img/elementAt.png" width="100%">
	 *
	 * `elementAt` returns an Observable that emits the item at the specified
	 * `index` in the source Observable, or a default value if that `index` is out
	 * of range and the `default` argument is provided. If the `default` argument is
	 * not given and the `index` is out of range, the output Observable will emit an
	 * `ArgumentOutOfRangeError` error.
	 *
	 * @example <caption>Emit only the third click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.elementAt(2);
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // click 1 = nothing
	 * // click 2 = nothing
	 * // click 3 = MouseEvent object logged to console
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link skip}
	 * @see {@link single}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
	 * Observable has completed before emitting the i-th `next` notification.
	 *
	 * @param {number} index Is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {T} [defaultValue] The default value returned for missing indices.
	 * @return {Observable} An Observable that emits a single item, if it is found.
	 * Otherwise, will emit the default value if given. If not, then emits an error.
	 * @method elementAt
	 * @owner Observable
	 */
	function elementAt(index, defaultValue) {
	    return function (source) { return source.lift(new ElementAtOperator(index, defaultValue)); };
	}
	exports.elementAt = elementAt;
	var ElementAtOperator = (function () {
	    function ElementAtOperator(index, defaultValue) {
	        this.index = index;
	        this.defaultValue = defaultValue;
	        if (index < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    ElementAtOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
	    };
	    return ElementAtOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ElementAtSubscriber = (function (_super) {
	    __extends(ElementAtSubscriber, _super);
	    function ElementAtSubscriber(destination, index, defaultValue) {
	        _super.call(this, destination);
	        this.index = index;
	        this.defaultValue = defaultValue;
	    }
	    ElementAtSubscriber.prototype._next = function (x) {
	        if (this.index-- === 0) {
	            this.destination.next(x);
	            this.destination.complete();
	        }
	    };
	    ElementAtSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index >= 0) {
	            if (typeof this.defaultValue !== 'undefined') {
	                destination.next(this.defaultValue);
	            }
	            else {
	                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
	            }
	        }
	        destination.complete();
	    };
	    return ElementAtSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=elementAt.js.map

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an element was queried at a certain index of an
	 * Observable, but no such index or position exists in that sequence.
	 *
	 * @see {@link elementAt}
	 * @see {@link take}
	 * @see {@link takeLast}
	 *
	 * @class ArgumentOutOfRangeError
	 */
	var ArgumentOutOfRangeError = (function (_super) {
	    __extends(ArgumentOutOfRangeError, _super);
	    function ArgumentOutOfRangeError() {
	        var err = _super.call(this, 'argument out of range');
	        this.name = err.name = 'ArgumentOutOfRangeError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return ArgumentOutOfRangeError;
	}(Error));
	exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
	//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var filter_1 = __webpack_require__(707);
	Observable_1.Observable.prototype.filter = filter_1.filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var filter_1 = __webpack_require__(708);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return filter_1.filter(predicate, thisArg)(this);
	}
	exports.filter = filter;
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/* tslint:enable:max-line-length */
	/**
	 * Filter items emitted by the source Observable by only emitting those that
	 * satisfy a specified predicate.
	 *
	 * <span class="informal">Like
	 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
	 * it only emits a value from the source if it passes a criterion function.</span>
	 *
	 * <img src="./img/filter.png" width="100%">
	 *
	 * Similar to the well-known `Array.prototype.filter` method, this operator
	 * takes values from the source Observable, passes them through a `predicate`
	 * function and only emits those values that yielded `true`.
	 *
	 * @example <caption>Emit only click events whose target was a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
	 * clicksOnDivs.subscribe(x => console.log(x));
	 *
	 * @see {@link distinct}
	 * @see {@link distinctUntilChanged}
	 * @see {@link distinctUntilKeyChanged}
	 * @see {@link ignoreElements}
	 * @see {@link partition}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted, if `false` the value is not passed to the output
	 * Observable. The `index` parameter is the number `i` for the i-th source
	 * emission that has happened since the subscription, starting from the number
	 * `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of values from the source that were
	 * allowed by the `predicate` function.
	 * @method filter
	 * @owner Observable
	 */
	function filter(predicate, thisArg) {
	    return function filterOperatorFunction(source) {
	        return source.lift(new FilterOperator(predicate, thisArg));
	    };
	}
	exports.filter = filter;
	var FilterOperator = (function () {
	    function FilterOperator(predicate, thisArg) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	    }
	    FilterOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
	    };
	    return FilterOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FilterSubscriber = (function (_super) {
	    __extends(FilterSubscriber, _super);
	    function FilterSubscriber(destination, predicate, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.count = 0;
	    }
	    // the try catch block below is left specifically for
	    // optimization and perf reasons. a tryCatcher is not necessary here.
	    FilterSubscriber.prototype._next = function (value) {
	        var result;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.count++);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this.destination.next(value);
	        }
	    };
	    return FilterSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=filter.js.map

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var finally_1 = __webpack_require__(710);
	Observable_1.Observable.prototype.finally = finally_1._finally;
	Observable_1.Observable.prototype._finally = finally_1._finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var finalize_1 = __webpack_require__(711);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function _finally(callback) {
	    return finalize_1.finalize(callback)(this);
	}
	exports._finally = _finally;
	//# sourceMappingURL=finally.js.map

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Subscription_1 = __webpack_require__(504);
	/**
	 * Returns an Observable that mirrors the source Observable, but will call a specified function when
	 * the source terminates on complete or error.
	 * @param {function} callback Function to be called when source terminates.
	 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
	 * @method finally
	 * @owner Observable
	 */
	function finalize(callback) {
	    return function (source) { return source.lift(new FinallyOperator(callback)); };
	}
	exports.finalize = finalize;
	var FinallyOperator = (function () {
	    function FinallyOperator(callback) {
	        this.callback = callback;
	    }
	    FinallyOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
	    };
	    return FinallyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FinallySubscriber = (function (_super) {
	    __extends(FinallySubscriber, _super);
	    function FinallySubscriber(destination, callback) {
	        _super.call(this, destination);
	        this.add(new Subscription_1.Subscription(callback));
	    }
	    return FinallySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=finalize.js.map

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var find_1 = __webpack_require__(713);
	Observable_1.Observable.prototype.find = find_1.find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(714);
	/* tslint:enable:max-line-length */
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    return find_1.find(predicate, thisArg)(this);
	}
	exports.find = find;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Emits only the first value emitted by the source Observable that meets some
	 * condition.
	 *
	 * <span class="informal">Finds the first value that passes some test and emits
	 * that.</span>
	 *
	 * <img src="./img/find.png" width="100%">
	 *
	 * `find` searches for the first item in the source Observable that matches the
	 * specified condition embodied by the `predicate`, and returns the first
	 * occurrence in the source. Unlike {@link first}, the `predicate` is required
	 * in `find`, and does not emit an error if a valid value is not found.
	 *
	 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link first}
	 * @see {@link findIndex}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable<T>} An Observable of the first item that matches the
	 * condition.
	 * @method find
	 * @owner Observable
	 */
	function find(predicate, thisArg) {
	    if (typeof predicate !== 'function') {
	        throw new TypeError('predicate is not a function');
	    }
	    return function (source) { return source.lift(new FindValueOperator(predicate, source, false, thisArg)); };
	}
	exports.find = find;
	var FindValueOperator = (function () {
	    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	    }
	    FindValueOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
	    };
	    return FindValueOperator;
	}());
	exports.FindValueOperator = FindValueOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FindValueSubscriber = (function (_super) {
	    __extends(FindValueSubscriber, _super);
	    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.yieldIndex = yieldIndex;
	        this.thisArg = thisArg;
	        this.index = 0;
	    }
	    FindValueSubscriber.prototype.notifyComplete = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    FindValueSubscriber.prototype._next = function (value) {
	        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
	        var index = this.index++;
	        try {
	            var result = predicate.call(thisArg || this, value, index, this.source);
	            if (result) {
	                this.notifyComplete(this.yieldIndex ? index : value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    FindValueSubscriber.prototype._complete = function () {
	        this.notifyComplete(this.yieldIndex ? -1 : undefined);
	    };
	    return FindValueSubscriber;
	}(Subscriber_1.Subscriber));
	exports.FindValueSubscriber = FindValueSubscriber;
	//# sourceMappingURL=find.js.map

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var findIndex_1 = __webpack_require__(716);
	Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var findIndex_1 = __webpack_require__(717);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return findIndex_1.findIndex(predicate, thisArg)(this);
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var find_1 = __webpack_require__(714);
	/**
	 * Emits only the index of the first value emitted by the source Observable that
	 * meets some condition.
	 *
	 * <span class="informal">It's like {@link find}, but emits the index of the
	 * found value, not the value itself.</span>
	 *
	 * <img src="./img/findIndex.png" width="100%">
	 *
	 * `findIndex` searches for the first item in the source Observable that matches
	 * the specified condition embodied by the `predicate`, and returns the
	 * (zero-based) index of the first occurrence in the source. Unlike
	 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
	 * an error if a valid value is not found.
	 *
	 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link first}
	 * @see {@link take}
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
	 * A function called with each item to test for condition matching.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {Observable} An Observable of the index of the first item that
	 * matches the condition.
	 * @method find
	 * @owner Observable
	 */
	function findIndex(predicate, thisArg) {
	    return function (source) { return source.lift(new find_1.FindValueOperator(predicate, source, true, thisArg)); };
	}
	exports.findIndex = findIndex;
	//# sourceMappingURL=findIndex.js.map

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var first_1 = __webpack_require__(719);
	Observable_1.Observable.prototype.first = first_1.first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var first_1 = __webpack_require__(720);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return first_1.first(predicate, resultSelector, defaultValue)(this);
	}
	exports.first = first;
	//# sourceMappingURL=first.js.map

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var EmptyError_1 = __webpack_require__(721);
	/**
	 * Emits only the first value (or the first value that meets some condition)
	 * emitted by the source Observable.
	 *
	 * <span class="informal">Emits only the first value. Or emits only the first
	 * value that passes some test.</span>
	 *
	 * <img src="./img/first.png" width="100%">
	 *
	 * If called with no arguments, `first` emits the first value of the source
	 * Observable, then completes. If called with a `predicate` function, `first`
	 * emits the first value of the source that matches the specified condition. It
	 * may also take a `resultSelector` function to produce the output value from
	 * the input value, and a `defaultValue` to emit in case the source completes
	 * before it is able to emit a valid value. Throws an error if `defaultValue`
	 * was not provided and a matching element is not found.
	 *
	 * @example <caption>Emit only the first click that happens on the DOM</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first();
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Emits the first click that happens on a DIV</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link filter}
	 * @see {@link find}
	 * @see {@link take}
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 *
	 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
	 * An optional function called with each item to test for condition matching.
	 * @param {function(value: T, index: number): R} [resultSelector] A function to
	 * produce the value on the output Observable based on the values
	 * and the indices of the source Observable. The arguments passed to this
	 * function are:
	 * - `value`: the value that was emitted on the source.
	 * - `index`: the "index" of the value from the source.
	 * @param {R} [defaultValue] The default value emitted in case no valid value
	 * was found on the source.
	 * @return {Observable<T|R>} An Observable of the first item that matches the
	 * condition.
	 * @method first
	 * @owner Observable
	 */
	function first(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new FirstOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.first = first;
	var FirstOperator = (function () {
	    function FirstOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    FirstOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return FirstOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var FirstSubscriber = (function (_super) {
	    __extends(FirstSubscriber, _super);
	    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.index = 0;
	        this.hasCompleted = false;
	        this._emitted = false;
	    }
	    FirstSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            this._emit(value, index);
	        }
	    };
	    FirstSubscriber.prototype._emit = function (value, index) {
	        if (this.resultSelector) {
	            this._tryResultSelector(value, index);
	            return;
	        }
	        this._emitFinal(value);
	    };
	    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this._emitFinal(result);
	    };
	    FirstSubscriber.prototype._emitFinal = function (value) {
	        var destination = this.destination;
	        if (!this._emitted) {
	            this._emitted = true;
	            destination.next(value);
	            destination.complete();
	            this.hasCompleted = true;
	        }
	    };
	    FirstSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
	            destination.next(this.defaultValue);
	            destination.complete();
	        }
	        else if (!this.hasCompleted) {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return FirstSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=first.js.map

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when an Observable or a sequence was queried but has no
	 * elements.
	 *
	 * @see {@link first}
	 * @see {@link last}
	 * @see {@link single}
	 *
	 * @class EmptyError
	 */
	var EmptyError = (function (_super) {
	    __extends(EmptyError, _super);
	    function EmptyError() {
	        var err = _super.call(this, 'no elements in sequence');
	        this.name = err.name = 'EmptyError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return EmptyError;
	}(Error));
	exports.EmptyError = EmptyError;
	//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var groupBy_1 = __webpack_require__(723);
	Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var groupBy_1 = __webpack_require__(724);
	exports.GroupedObservable = groupBy_1.GroupedObservable;
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return groupBy_1.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
	}
	exports.groupBy = groupBy;
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Subscription_1 = __webpack_require__(504);
	var Observable_1 = __webpack_require__(499);
	var Subject_1 = __webpack_require__(498);
	var Map_1 = __webpack_require__(725);
	var FastMap_1 = __webpack_require__(727);
	/* tslint:enable:max-line-length */
	/**
	 * Groups the items emitted by an Observable according to a specified criterion,
	 * and emits these grouped items as `GroupedObservables`, one
	 * {@link GroupedObservable} per group.
	 *
	 * <img src="./img/groupBy.png" width="100%">
	 *
	 * @example <caption>Group objects by id and return as array</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs3'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *     )
	 *     .groupBy(p => p.id)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // [ { id: 1, name: 'aze1' },
	 * //   { id: 1, name: 'erg1' },
	 * //   { id: 1, name: 'df1' } ]
	 * //
	 * // [ { id: 2, name: 'sf2' },
	 * //   { id: 2, name: 'dg2' },
	 * //   { id: 2, name: 'sfqfb2' },
	 * //   { id: 2, name: 'qsgqsfg2' } ]
	 * //
	 * // [ { id: 3, name: 'qfs3' } ]
	 *
	 * @example <caption>Pivot data on the id field</caption>
	 * Observable.of<Obj>({id: 1, name: 'aze1'},
	 *                    {id: 2, name: 'sf2'},
	 *                    {id: 2, name: 'dg2'},
	 *                    {id: 1, name: 'erg1'},
	 *                    {id: 1, name: 'df1'},
	 *                    {id: 2, name: 'sfqfb2'},
	 *                    {id: 3, name: 'qfs1'},
	 *                    {id: 2, name: 'qsgqsfg2'}
	 *                   )
	 *     .groupBy(p => p.id, p => p.name)
	 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
	 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
	 *     .subscribe(p => console.log(p));
	 *
	 * // displays:
	 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
	 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
	 * // { id: 3, values: [ 'qfs1' ] }
	 *
	 * @param {function(value: T): K} keySelector A function that extracts the key
	 * for each item.
	 * @param {function(value: T): R} [elementSelector] A function that extracts the
	 * return element for each item.
	 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
	 * A function that returns an Observable to determine how long each group should
	 * exist.
	 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
	 * GroupedObservables, each of which corresponds to a unique key value and each
	 * of which emits those items from the source Observable that share that key
	 * value.
	 * @method groupBy
	 * @owner Observable
	 */
	function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
	    return function (source) {
	        return source.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
	    };
	}
	exports.groupBy = groupBy;
	var GroupByOperator = (function () {
	    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	    }
	    GroupByOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
	    };
	    return GroupByOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupBySubscriber = (function (_super) {
	    __extends(GroupBySubscriber, _super);
	    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
	        _super.call(this, destination);
	        this.keySelector = keySelector;
	        this.elementSelector = elementSelector;
	        this.durationSelector = durationSelector;
	        this.subjectSelector = subjectSelector;
	        this.groups = null;
	        this.attemptedToUnsubscribe = false;
	        this.count = 0;
	    }
	    GroupBySubscriber.prototype._next = function (value) {
	        var key;
	        try {
	            key = this.keySelector(value);
	        }
	        catch (err) {
	            this.error(err);
	            return;
	        }
	        this._group(value, key);
	    };
	    GroupBySubscriber.prototype._group = function (value, key) {
	        var groups = this.groups;
	        if (!groups) {
	            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
	        }
	        var group = groups.get(key);
	        var element;
	        if (this.elementSelector) {
	            try {
	                element = this.elementSelector(value);
	            }
	            catch (err) {
	                this.error(err);
	            }
	        }
	        else {
	            element = value;
	        }
	        if (!group) {
	            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
	            groups.set(key, group);
	            var groupedObservable = new GroupedObservable(key, group, this);
	            this.destination.next(groupedObservable);
	            if (this.durationSelector) {
	                var duration = void 0;
	                try {
	                    duration = this.durationSelector(new GroupedObservable(key, group));
	                }
	                catch (err) {
	                    this.error(err);
	                    return;
	                }
	                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
	            }
	        }
	        if (!group.closed) {
	            group.next(element);
	        }
	    };
	    GroupBySubscriber.prototype._error = function (err) {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.error(err);
	            });
	            groups.clear();
	        }
	        this.destination.error(err);
	    };
	    GroupBySubscriber.prototype._complete = function () {
	        var groups = this.groups;
	        if (groups) {
	            groups.forEach(function (group, key) {
	                group.complete();
	            });
	            groups.clear();
	        }
	        this.destination.complete();
	    };
	    GroupBySubscriber.prototype.removeGroup = function (key) {
	        this.groups.delete(key);
	    };
	    GroupBySubscriber.prototype.unsubscribe = function () {
	        if (!this.closed) {
	            this.attemptedToUnsubscribe = true;
	            if (this.count === 0) {
	                _super.prototype.unsubscribe.call(this);
	            }
	        }
	    };
	    return GroupBySubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var GroupDurationSubscriber = (function (_super) {
	    __extends(GroupDurationSubscriber, _super);
	    function GroupDurationSubscriber(key, group, parent) {
	        _super.call(this, group);
	        this.key = key;
	        this.group = group;
	        this.parent = parent;
	    }
	    GroupDurationSubscriber.prototype._next = function (value) {
	        this.complete();
	    };
	    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function () {
	        var _a = this, parent = _a.parent, key = _a.key;
	        this.key = this.parent = null;
	        if (parent) {
	            parent.removeGroup(key);
	        }
	    };
	    return GroupDurationSubscriber;
	}(Subscriber_1.Subscriber));
	/**
	 * An Observable representing values belonging to the same group represented by
	 * a common key. The values emitted by a GroupedObservable come from the source
	 * Observable. The common key is available as the field `key` on a
	 * GroupedObservable instance.
	 *
	 * @class GroupedObservable<K, T>
	 */
	var GroupedObservable = (function (_super) {
	    __extends(GroupedObservable, _super);
	    function GroupedObservable(key, groupSubject, refCountSubscription) {
	        _super.call(this);
	        this.key = key;
	        this.groupSubject = groupSubject;
	        this.refCountSubscription = refCountSubscription;
	    }
	    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function (subscriber) {
	        var subscription = new Subscription_1.Subscription();
	        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
	        if (refCountSubscription && !refCountSubscription.closed) {
	            subscription.add(new InnerRefCountSubscription(refCountSubscription));
	        }
	        subscription.add(groupSubject.subscribe(subscriber));
	        return subscription;
	    };
	    return GroupedObservable;
	}(Observable_1.Observable));
	exports.GroupedObservable = GroupedObservable;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var InnerRefCountSubscription = (function (_super) {
	    __extends(InnerRefCountSubscription, _super);
	    function InnerRefCountSubscription(parent) {
	        _super.call(this);
	        this.parent = parent;
	        parent.count++;
	    }
	    InnerRefCountSubscription.prototype.unsubscribe = function () {
	        var parent = this.parent;
	        if (!parent.closed && !this.closed) {
	            _super.prototype.unsubscribe.call(this);
	            parent.count -= 1;
	            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
	                parent.unsubscribe();
	            }
	        }
	    };
	    return InnerRefCountSubscription;
	}(Subscription_1.Subscription));
	//# sourceMappingURL=groupBy.js.map

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	var MapPolyfill_1 = __webpack_require__(726);
	exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
	//# sourceMappingURL=Map.js.map

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	"use strict";
	var MapPolyfill = (function () {
	    function MapPolyfill() {
	        this.size = 0;
	        this._values = [];
	        this._keys = [];
	    }
	    MapPolyfill.prototype.get = function (key) {
	        var i = this._keys.indexOf(key);
	        return i === -1 ? undefined : this._values[i];
	    };
	    MapPolyfill.prototype.set = function (key, value) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            this._keys.push(key);
	            this._values.push(value);
	            this.size++;
	        }
	        else {
	            this._values[i] = value;
	        }
	        return this;
	    };
	    MapPolyfill.prototype.delete = function (key) {
	        var i = this._keys.indexOf(key);
	        if (i === -1) {
	            return false;
	        }
	        this._values.splice(i, 1);
	        this._keys.splice(i, 1);
	        this.size--;
	        return true;
	    };
	    MapPolyfill.prototype.clear = function () {
	        this._keys.length = 0;
	        this._values.length = 0;
	        this.size = 0;
	    };
	    MapPolyfill.prototype.forEach = function (cb, thisArg) {
	        for (var i = 0; i < this.size; i++) {
	            cb.call(thisArg, this._values[i], this._keys[i]);
	        }
	    };
	    return MapPolyfill;
	}());
	exports.MapPolyfill = MapPolyfill;
	//# sourceMappingURL=MapPolyfill.js.map

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	"use strict";
	var FastMap = (function () {
	    function FastMap() {
	        this.values = {};
	    }
	    FastMap.prototype.delete = function (key) {
	        this.values[key] = null;
	        return true;
	    };
	    FastMap.prototype.set = function (key, value) {
	        this.values[key] = value;
	        return this;
	    };
	    FastMap.prototype.get = function (key) {
	        return this.values[key];
	    };
	    FastMap.prototype.forEach = function (cb, thisArg) {
	        var values = this.values;
	        for (var key in values) {
	            if (values.hasOwnProperty(key) && values[key] !== null) {
	                cb.call(thisArg, values[key], key);
	            }
	        }
	    };
	    FastMap.prototype.clear = function () {
	        this.values = {};
	    };
	    return FastMap;
	}());
	exports.FastMap = FastMap;
	//# sourceMappingURL=FastMap.js.map

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var ignoreElements_1 = __webpack_require__(729);
	Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ignoreElements_1 = __webpack_require__(730);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return ignoreElements_1.ignoreElements()(this);
	}
	exports.ignoreElements = ignoreElements;
	;
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var noop_1 = __webpack_require__(514);
	/**
	 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
	 *
	 * <img src="./img/ignoreElements.png" width="100%">
	 *
	 * @return {Observable} An empty Observable that only calls `complete`
	 * or `error`, based on which one is called by the source Observable.
	 * @method ignoreElements
	 * @owner Observable
	 */
	function ignoreElements() {
	    return function ignoreElementsOperatorFunction(source) {
	        return source.lift(new IgnoreElementsOperator());
	    };
	}
	exports.ignoreElements = ignoreElements;
	var IgnoreElementsOperator = (function () {
	    function IgnoreElementsOperator() {
	    }
	    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
	    };
	    return IgnoreElementsOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IgnoreElementsSubscriber = (function (_super) {
	    __extends(IgnoreElementsSubscriber, _super);
	    function IgnoreElementsSubscriber() {
	        _super.apply(this, arguments);
	    }
	    IgnoreElementsSubscriber.prototype._next = function (unused) {
	        noop_1.noop();
	    };
	    return IgnoreElementsSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ignoreElements.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var isEmpty_1 = __webpack_require__(732);
	Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isEmpty_1 = __webpack_require__(733);
	/**
	 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
	 *
	 * <img src="./img/isEmpty.png" width="100%">
	 *
	 * @return {Observable} An Observable that emits a Boolean.
	 * @method isEmpty
	 * @owner Observable
	 */
	function isEmpty() {
	    return isEmpty_1.isEmpty()(this);
	}
	exports.isEmpty = isEmpty;
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	function isEmpty() {
	    return function (source) { return source.lift(new IsEmptyOperator()); };
	}
	exports.isEmpty = isEmpty;
	var IsEmptyOperator = (function () {
	    function IsEmptyOperator() {
	    }
	    IsEmptyOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new IsEmptySubscriber(observer));
	    };
	    return IsEmptyOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var IsEmptySubscriber = (function (_super) {
	    __extends(IsEmptySubscriber, _super);
	    function IsEmptySubscriber(destination) {
	        _super.call(this, destination);
	    }
	    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
	        var destination = this.destination;
	        destination.next(isEmpty);
	        destination.complete();
	    };
	    IsEmptySubscriber.prototype._next = function (value) {
	        this.notifyComplete(false);
	    };
	    IsEmptySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return IsEmptySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=isEmpty.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var audit_1 = __webpack_require__(735);
	Observable_1.Observable.prototype.audit = audit_1.audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(736);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return audit_1.audit(durationSelector)(this);
	}
	exports.audit = audit;
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Ignores source values for a duration determined by another Observable, then
	 * emits the most recent value from the source Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link auditTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/audit.png" width="100%">
	 *
	 * `audit` is similar to `throttle`, but emits the last value from the silenced
	 * time window, instead of the first value. `audit` emits the most recent value
	 * from the source Observable on the output Observable as soon as its internal
	 * timer becomes disabled, and ignores source values while the timer is enabled.
	 * Initially, the timer is disabled. As soon as the first source value arrives,
	 * the timer is enabled by calling the `durationSelector` function with the
	 * source value, which returns the "duration" Observable. When the duration
	 * Observable emits a value or completes, the timer is disabled, then the most
	 * recent source value is emitted on the output Observable, and this process
	 * repeats for the next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttle}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration, returned as an Observable or a Promise.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method audit
	 * @owner Observable
	 */
	function audit(durationSelector) {
	    return function auditOperatorFunction(source) {
	        return source.lift(new AuditOperator(durationSelector));
	    };
	}
	exports.audit = audit;
	var AuditOperator = (function () {
	    function AuditOperator(durationSelector) {
	        this.durationSelector = durationSelector;
	    }
	    AuditOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
	    };
	    return AuditOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AuditSubscriber = (function (_super) {
	    __extends(AuditSubscriber, _super);
	    function AuditSubscriber(destination, durationSelector) {
	        _super.call(this, destination);
	        this.durationSelector = durationSelector;
	        this.hasValue = false;
	    }
	    AuditSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	        if (!this.throttled) {
	            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
	            if (duration === errorObject_1.errorObject) {
	                this.destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, duration);
	                if (innerSubscription.closed) {
	                    this.clearThrottle();
	                }
	                else {
	                    this.add(this.throttled = innerSubscription);
	                }
	            }
	        }
	    };
	    AuditSubscriber.prototype.clearThrottle = function () {
	        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	        if (hasValue) {
	            this.value = null;
	            this.hasValue = false;
	            this.destination.next(value);
	        }
	    };
	    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        this.clearThrottle();
	    };
	    AuditSubscriber.prototype.notifyComplete = function () {
	        this.clearThrottle();
	    };
	    return AuditSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=audit.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var auditTime_1 = __webpack_require__(738);
	Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var auditTime_1 = __webpack_require__(739);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return auditTime_1.auditTime(duration, scheduler)(this);
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var audit_1 = __webpack_require__(736);
	var timer_1 = __webpack_require__(607);
	/**
	 * Ignores source values for `duration` milliseconds, then emits the most recent
	 * value from the source Observable, then repeats this process.
	 *
	 * <span class="informal">When it sees a source values, it ignores that plus
	 * the next ones for `duration` milliseconds, and then it emits the most recent
	 * value from the source.</span>
	 *
	 * <img src="./img/auditTime.png" width="100%">
	 *
	 * `auditTime` is similar to `throttleTime`, but emits the last value from the
	 * silenced time window, instead of the first value. `auditTime` emits the most
	 * recent value from the source Observable on the output Observable as soon as
	 * its internal timer becomes disabled, and ignores source values while the
	 * timer is enabled. Initially, the timer is disabled. As soon as the first
	 * source value arrives, the timer is enabled. After `duration` milliseconds (or
	 * the time unit determined internally by the optional `scheduler`) has passed,
	 * the timer is disabled, then the most recent source value is emitted on the
	 * output Observable, and this process repeats for the next source value.
	 * Optionally takes a {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.auditTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttleTime}
	 *
	 * @param {number} duration Time to wait before emitting the most recent source
	 * value, measured in milliseconds or the time unit determined internally
	 * by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the rate-limiting behavior.
	 * @return {Observable<T>} An Observable that performs rate-limiting of
	 * emissions from the source Observable.
	 * @method auditTime
	 * @owner Observable
	 */
	function auditTime(duration, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return audit_1.audit(function () { return timer_1.timer(duration, scheduler); });
	}
	exports.auditTime = auditTime;
	//# sourceMappingURL=auditTime.js.map

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var last_1 = __webpack_require__(741);
	Observable_1.Observable.prototype.last = last_1.last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var last_1 = __webpack_require__(742);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return last_1.last(predicate, resultSelector, defaultValue)(this);
	}
	exports.last = last;
	//# sourceMappingURL=last.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var EmptyError_1 = __webpack_require__(721);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits only the last item emitted by the source Observable.
	 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
	 * the last item from the source Observable, the resulting Observable will emit the last item
	 * from the source Observable that satisfies the predicate.
	 *
	 * <img src="./img/last.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {function} predicate - The condition any source emitted item has to satisfy.
	 * @return {Observable} An Observable that emits only the last item satisfying the given condition
	 * from the source, or an NoSuchElementException if no such items are emitted.
	 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
	 * @method last
	 * @owner Observable
	 */
	function last(predicate, resultSelector, defaultValue) {
	    return function (source) { return source.lift(new LastOperator(predicate, resultSelector, defaultValue, source)); };
	}
	exports.last = last;
	var LastOperator = (function () {
	    function LastOperator(predicate, resultSelector, defaultValue, source) {
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	    }
	    LastOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
	    };
	    return LastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var LastSubscriber = (function (_super) {
	    __extends(LastSubscriber, _super);
	    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.resultSelector = resultSelector;
	        this.defaultValue = defaultValue;
	        this.source = source;
	        this.hasValue = false;
	        this.index = 0;
	        if (typeof defaultValue !== 'undefined') {
	            this.lastValue = defaultValue;
	            this.hasValue = true;
	        }
	    }
	    LastSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this._tryPredicate(value, index);
	        }
	        else {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryPredicate = function (value, index) {
	        var result;
	        try {
	            result = this.predicate(value, index, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (result) {
	            if (this.resultSelector) {
	                this._tryResultSelector(value, index);
	                return;
	            }
	            this.lastValue = value;
	            this.hasValue = true;
	        }
	    };
	    LastSubscriber.prototype._tryResultSelector = function (value, index) {
	        var result;
	        try {
	            result = this.resultSelector(value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.lastValue = result;
	        this.hasValue = true;
	    };
	    LastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.hasValue) {
	            destination.next(this.lastValue);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return LastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=last.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var let_1 = __webpack_require__(744);
	Observable_1.Observable.prototype.let = let_1.letProto;
	Observable_1.Observable.prototype.letBind = let_1.letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	"use strict";
	/**
	 * @param func
	 * @return {Observable<R>}
	 * @method let
	 * @owner Observable
	 */
	function letProto(func) {
	    return func(this);
	}
	exports.letProto = letProto;
	//# sourceMappingURL=let.js.map

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var every_1 = __webpack_require__(746);
	Observable_1.Observable.prototype.every = every_1.every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var every_1 = __webpack_require__(747);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return every_1.every(predicate, thisArg)(this);
	}
	exports.every = every;
	//# sourceMappingURL=every.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
	 *
	 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
	 *  Observable.of(1, 2, 3, 4, 5, 6)
	 *     .every(x => x < 5)
	 *     .subscribe(x => console.log(x)); // -> false
	 *
	 * @param {function} predicate A function for determining if an item meets a specified condition.
	 * @param {any} [thisArg] Optional object to use for `this` in the callback.
	 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
	 * @method every
	 * @owner Observable
	 */
	function every(predicate, thisArg) {
	    return function (source) { return source.lift(new EveryOperator(predicate, thisArg, source)); };
	}
	exports.every = every;
	var EveryOperator = (function () {
	    function EveryOperator(predicate, thisArg, source) {
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	    }
	    EveryOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
	    };
	    return EveryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var EverySubscriber = (function (_super) {
	    __extends(EverySubscriber, _super);
	    function EverySubscriber(destination, predicate, thisArg, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.thisArg = thisArg;
	        this.source = source;
	        this.index = 0;
	        this.thisArg = thisArg || this;
	    }
	    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
	        this.destination.next(everyValueMatch);
	        this.destination.complete();
	    };
	    EverySubscriber.prototype._next = function (value) {
	        var result = false;
	        try {
	            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        if (!result) {
	            this.notifyComplete(false);
	        }
	    };
	    EverySubscriber.prototype._complete = function () {
	        this.notifyComplete(true);
	    };
	    return EverySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=every.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var map_1 = __webpack_require__(749);
	Observable_1.Observable.prototype.map = map_1.map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(616);
	/**
	 * Applies a given `project` function to each value emitted by the source
	 * Observable, and emits the resulting values as an Observable.
	 *
	 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
	 * it passes each source value through a transformation function to get
	 * corresponding output values.</span>
	 *
	 * <img src="./img/map.png" width="100%">
	 *
	 * Similar to the well known `Array.prototype.map` function, this operator
	 * applies a projection to each value and emits that projection in the output
	 * Observable.
	 *
	 * @example <caption>Map every click to the clientX position of that click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var positions = clicks.map(ev => ev.clientX);
	 * positions.subscribe(x => console.log(x));
	 *
	 * @see {@link mapTo}
	 * @see {@link pluck}
	 *
	 * @param {function(value: T, index: number): R} project The function to apply
	 * to each `value` emitted by the source Observable. The `index` parameter is
	 * the number `i` for the i-th emission that has happened since the
	 * subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to define what `this` is in the
	 * `project` function.
	 * @return {Observable<R>} An Observable that emits the values from the source
	 * Observable transformed by the given `project` function.
	 * @method map
	 * @owner Observable
	 */
	function map(project, thisArg) {
	    return map_1.map(project, thisArg)(this);
	}
	exports.map = map;
	//# sourceMappingURL=map.js.map

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var mapTo_1 = __webpack_require__(751);
	Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mapTo_1 = __webpack_require__(752);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return mapTo_1.mapTo(value)(this);
	}
	exports.mapTo = mapTo;
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Emits the given constant value on the output Observable every time the source
	 * Observable emits a value.
	 *
	 * <span class="informal">Like {@link map}, but it maps every source value to
	 * the same output value every time.</span>
	 *
	 * <img src="./img/mapTo.png" width="100%">
	 *
	 * Takes a constant `value` as argument, and emits that whenever the source
	 * Observable emits a value. In other words, ignores the actual source value,
	 * and simply uses the emission moment to know when to emit the given `value`.
	 *
	 * @example <caption>Map every click to the string 'Hi'</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var greetings = clicks.mapTo('Hi');
	 * greetings.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {any} value The value to map each source value to.
	 * @return {Observable} An Observable that emits the given `value` every time
	 * the source Observable emits something.
	 * @method mapTo
	 * @owner Observable
	 */
	function mapTo(value) {
	    return function (source) { return source.lift(new MapToOperator(value)); };
	}
	exports.mapTo = mapTo;
	var MapToOperator = (function () {
	    function MapToOperator(value) {
	        this.value = value;
	    }
	    MapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MapToSubscriber(subscriber, this.value));
	    };
	    return MapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MapToSubscriber = (function (_super) {
	    __extends(MapToSubscriber, _super);
	    function MapToSubscriber(destination, value) {
	        _super.call(this, destination);
	        this.value = value;
	    }
	    MapToSubscriber.prototype._next = function (x) {
	        this.destination.next(this.value);
	    };
	    return MapToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=mapTo.js.map

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var materialize_1 = __webpack_require__(754);
	Observable_1.Observable.prototype.materialize = materialize_1.materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var materialize_1 = __webpack_require__(755);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return materialize_1.materialize()(this);
	}
	exports.materialize = materialize;
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Notification_1 = __webpack_require__(546);
	/**
	 * Represents all of the notifications from the source Observable as `next`
	 * emissions marked with their original types within {@link Notification}
	 * objects.
	 *
	 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
	 * {@link Notification} objects, emitted as `next` on the output Observable.
	 * </span>
	 *
	 * <img src="./img/materialize.png" width="100%">
	 *
	 * `materialize` returns an Observable that emits a `next` notification for each
	 * `next`, `error`, or `complete` emission of the source Observable. When the
	 * source Observable emits `complete`, the output Observable will emit `next` as
	 * a Notification of type "complete", and then it will emit `complete` as well.
	 * When the source Observable emits `error`, the output will emit `next` as a
	 * Notification of type "error", and then `complete`.
	 *
	 * This operator is useful for producing metadata of the source Observable, to
	 * be consumed as `next` emissions. Use it in conjunction with
	 * {@link dematerialize}.
	 *
	 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
	 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
	 * var upperCase = letters.map(x => x.toUpperCase());
	 * var materialized = upperCase.materialize();
	 * materialized.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
	 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
	 * // - Notification {kind: "E", value: undefined, error: TypeError:
	 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
	 * //   [as project] (http://1…, hasValue: false}
	 *
	 * @see {@link Notification}
	 * @see {@link dematerialize}
	 *
	 * @return {Observable<Notification<T>>} An Observable that emits
	 * {@link Notification} objects that wrap the original emissions from the source
	 * Observable with metadata.
	 * @method materialize
	 * @owner Observable
	 */
	function materialize() {
	    return function materializeOperatorFunction(source) {
	        return source.lift(new MaterializeOperator());
	    };
	}
	exports.materialize = materialize;
	var MaterializeOperator = (function () {
	    function MaterializeOperator() {
	    }
	    MaterializeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MaterializeSubscriber(subscriber));
	    };
	    return MaterializeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MaterializeSubscriber = (function (_super) {
	    __extends(MaterializeSubscriber, _super);
	    function MaterializeSubscriber(destination) {
	        _super.call(this, destination);
	    }
	    MaterializeSubscriber.prototype._next = function (value) {
	        this.destination.next(Notification_1.Notification.createNext(value));
	    };
	    MaterializeSubscriber.prototype._error = function (err) {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createError(err));
	        destination.complete();
	    };
	    MaterializeSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        destination.next(Notification_1.Notification.createComplete());
	        destination.complete();
	    };
	    return MaterializeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=materialize.js.map

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var max_1 = __webpack_require__(757);
	Observable_1.Observable.prototype.max = max_1.max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var max_1 = __webpack_require__(758);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    return max_1.max(comparer)(this);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(759);
	/**
	 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the largest value.
	 *
	 * <img src="./img/max.png" width="100%">
	 *
	 * @example <caption>Get the maximal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .max()
	 *   .subscribe(x => console.log(x)); // -> 8
	 *
	 * @example <caption>Use a comparer function to get the maximal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
	 * }
	 *
	 * @see {@link min}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable} An Observable that emits item with the largest value.
	 * @method max
	 * @owner Observable
	 */
	function max(comparer) {
	    var max = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
	        : function (x, y) { return x > y ? x : y; };
	    return reduce_1.reduce(max);
	}
	exports.max = max;
	//# sourceMappingURL=max.js.map

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(760);
	var takeLast_1 = __webpack_require__(761);
	var defaultIfEmpty_1 = __webpack_require__(673);
	var pipe_1 = __webpack_require__(513);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return function reduceOperatorFunctionWithSeed(source) {
	            return pipe_1.pipe(scan_1.scan(accumulator, seed), takeLast_1.takeLast(1), defaultIfEmpty_1.defaultIfEmpty(seed))(source);
	        };
	    }
	    return function reduceOperatorFunction(source) {
	        return pipe_1.pipe(scan_1.scan(function (acc, value, index) {
	            return accumulator(acc, value, index + 1);
	        }), takeLast_1.takeLast(1))(source);
	    };
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    var hasSeed = false;
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        hasSeed = true;
	    }
	    return function scanOperatorFunction(source) {
	        return source.lift(new ScanOperator(accumulator, seed, hasSeed));
	    };
	}
	exports.scan = scan;
	var ScanOperator = (function () {
	    function ScanOperator(accumulator, seed, hasSeed) {
	        if (hasSeed === void 0) { hasSeed = false; }
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.hasSeed = hasSeed;
	    }
	    ScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
	    };
	    return ScanOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ScanSubscriber = (function (_super) {
	    __extends(ScanSubscriber, _super);
	    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this._seed = _seed;
	        this.hasSeed = hasSeed;
	        this.index = 0;
	    }
	    Object.defineProperty(ScanSubscriber.prototype, "seed", {
	        get: function () {
	            return this._seed;
	        },
	        set: function (value) {
	            this.hasSeed = true;
	            this._seed = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ScanSubscriber.prototype._next = function (value) {
	        if (!this.hasSeed) {
	            this.seed = value;
	            this.destination.next(value);
	        }
	        else {
	            return this._tryNext(value);
	        }
	    };
	    ScanSubscriber.prototype._tryNext = function (value) {
	        var index = this.index++;
	        var result;
	        try {
	            result = this.accumulator(this.seed, value, index);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	        this.seed = result;
	        this.destination.next(result);
	    };
	    return ScanSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var ArgumentOutOfRangeError_1 = __webpack_require__(705);
	var EmptyObservable_1 = __webpack_require__(529);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return function takeLastOperatorFunction(source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeLastOperator(count));
	        }
	    };
	}
	exports.takeLast = takeLast;
	var TakeLastOperator = (function () {
	    function TakeLastOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeLastOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
	    };
	    return TakeLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeLastSubscriber = (function (_super) {
	    __extends(TakeLastSubscriber, _super);
	    function TakeLastSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.ring = new Array();
	        this.count = 0;
	    }
	    TakeLastSubscriber.prototype._next = function (value) {
	        var ring = this.ring;
	        var total = this.total;
	        var count = this.count++;
	        if (ring.length < total) {
	            ring.push(value);
	        }
	        else {
	            var index = count % total;
	            ring[index] = value;
	        }
	    };
	    TakeLastSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        var count = this.count;
	        if (count > 0) {
	            var total = this.count >= this.total ? this.total : this.count;
	            var ring = this.ring;
	            for (var i = 0; i < total; i++) {
	                var idx = (count++) % total;
	                destination.next(ring[idx]);
	            }
	        }
	        destination.complete();
	    };
	    return TakeLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var merge_1 = __webpack_require__(763);
	Observable_1.Observable.prototype.merge = merge_1.merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(764);
	var merge_2 = __webpack_require__(584);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return merge_1.merge.apply(void 0, observables)(this);
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var merge_1 = __webpack_require__(584);
	var merge_2 = __webpack_require__(584);
	exports.mergeStatic = merge_2.merge;
	/* tslint:enable:max-line-length */
	/**
	 * Creates an output Observable which concurrently emits all values from every
	 * given input Observable.
	 *
	 * <span class="informal">Flattens multiple Observables together by blending
	 * their values into one Observable.</span>
	 *
	 * <img src="./img/merge.png" width="100%">
	 *
	 * `merge` subscribes to each given input Observable (either the source or an
	 * Observable given as argument), and simply forwards (without doing any
	 * transformation) all the values from all the input Observables to the output
	 * Observable. The output Observable only completes once all input Observables
	 * have completed. Any error delivered by an input Observable will be immediately
	 * emitted on the output Observable.
	 *
	 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var clicksOrTimer = clicks.merge(timer);
	 * clicksOrTimer.subscribe(x => console.log(x));
	 *
	 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
	 * var timer1 = Rx.Observable.interval(1000).take(10);
	 * var timer2 = Rx.Observable.interval(2000).take(6);
	 * var timer3 = Rx.Observable.interval(500).take(10);
	 * var concurrent = 2; // the argument
	 * var merged = timer1.merge(timer2, timer3, concurrent);
	 * merged.subscribe(x => console.log(x));
	 *
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 *
	 * @param {ObservableInput} other An input Observable to merge with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
	 * concurrency of input Observables.
	 * @return {Observable} An Observable that emits items that are the result of
	 * every input Observable.
	 * @method merge
	 * @owner Observable
	 */
	function merge() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function (source) { return source.lift.call(merge_1.merge.apply(void 0, [source].concat(observables))); };
	}
	exports.merge = merge;
	//# sourceMappingURL=merge.js.map

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var mergeAll_1 = __webpack_require__(766);
	Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeAll_1 = __webpack_require__(548);
	/**
	 * Converts a higher-order Observable into a first-order Observable which
	 * concurrently delivers all values that are emitted on the inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables.</span>
	 *
	 * <img src="./img/mergeAll.png" width="100%">
	 *
	 * `mergeAll` subscribes to an Observable that emits Observables, also known as
	 * a higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, it subscribes to that and delivers all the values from the
	 * inner Observable on the output Observable. The output Observable only
	 * completes once all inner Observables have completed. Any error delivered by
	 * a inner Observable will be immediately emitted on the output Observable.
	 *
	 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var firstOrder = higherOrder.mergeAll();
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
	 * var firstOrder = higherOrder.mergeAll(2);
	 * firstOrder.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link merge}
	 * @see {@link mergeMap}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switch}
	 * @see {@link zipAll}
	 *
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits values coming from all the
	 * inner Observables emitted by the source Observable.
	 * @method mergeAll
	 * @owner Observable
	 */
	function mergeAll(concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeAll_1.mergeAll(concurrent)(this);
	}
	exports.mergeAll = mergeAll;
	//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var mergeMap_1 = __webpack_require__(768);
	Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
	Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMap_1 = __webpack_require__(549);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link mergeAll}.</span>
	 *
	 * <img src="./img/mergeMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an Observable, and then merging those resulting Observables and
	 * emitting the results of this merger.
	 *
	 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
	 * var letters = Rx.Observable.of('a', 'b', 'c');
	 * var result = letters.mergeMap(x =>
	 *   Rx.Observable.interval(1000).map(i => x+i)
	 * );
	 * result.subscribe(x => console.log(x));
	 *
	 * // Results in the following:
	 * // a0
	 * // b0
	 * // c0
	 * // a1
	 * // b1
	 * // c1
	 * // continues to list a,b,c with respective ascending integers
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMapTo}
	 * @see {@link mergeScan}
	 * @see {@link switchMap}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and merging the results of the Observables obtained
	 * from this transformation.
	 * @method mergeMap
	 * @owner Observable
	 */
	function mergeMap(project, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMap_1.mergeMap(project, resultSelector, concurrent)(this);
	}
	exports.mergeMap = mergeMap;
	//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var mergeMapTo_1 = __webpack_require__(770);
	Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
	Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeMapTo_1 = __webpack_require__(771);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeMapTo_1.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
	}
	exports.mergeMapTo = mergeMapTo;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is merged multiple
	 * times in the output Observable.
	 *
	 * <span class="informal">It's like {@link mergeMap}, but maps each value always
	 * to the same inner Observable.</span>
	 *
	 * <img src="./img/mergeMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then merges those resulting Observables into one
	 * single Observable, which is the output Observable.
	 *
	 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link merge}
	 * @see {@link mergeAll}
	 * @see {@link mergeMap}
	 * @see {@link mergeScan}
	 * @see {@link switchMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
	 * Observables being subscribed to concurrently.
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable.
	 * @method mergeMapTo
	 * @owner Observable
	 */
	function mergeMapTo(innerObservable, resultSelector, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    if (typeof resultSelector === 'number') {
	        concurrent = resultSelector;
	        resultSelector = null;
	    }
	    return function (source) { return source.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent)); };
	}
	exports.mergeMapTo = mergeMapTo;
	// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
	//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
	var MergeMapToOperator = (function () {
	    function MergeMapToOperator(ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	    }
	    MergeMapToOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
	    };
	    return MergeMapToOperator;
	}());
	exports.MergeMapToOperator = MergeMapToOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeMapToSubscriber = (function (_super) {
	    __extends(MergeMapToSubscriber, _super);
	    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
	        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	        _super.call(this, destination);
	        this.ish = ish;
	        this.resultSelector = resultSelector;
	        this.concurrent = concurrent;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeMapToSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var resultSelector = this.resultSelector;
	            var index = this.index++;
	            var ish = this.ish;
	            var destination = this.destination;
	            this.active++;
	            this._innerSub(ish, destination, resultSelector, value, index);
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeMapToSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            this.destination.complete();
	        }
	    };
	    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    MergeMapToSubscriber.prototype.notifyError = function (err) {
	        this.destination.error(err);
	    };
	    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            this.destination.complete();
	        }
	    };
	    return MergeMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeMapToSubscriber = MergeMapToSubscriber;
	//# sourceMappingURL=mergeMapTo.js.map

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var mergeScan_1 = __webpack_require__(773);
	Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var mergeScan_1 = __webpack_require__(774);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return mergeScan_1.mergeScan(accumulator, seed, concurrent)(this);
	}
	exports.mergeScan = mergeScan;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var subscribeToResult_1 = __webpack_require__(532);
	var OuterSubscriber_1 = __webpack_require__(531);
	/**
	 * Applies an accumulator function over the source Observable where the
	 * accumulator function itself returns an Observable, then each intermediate
	 * Observable returned is merged into the output Observable.
	 *
	 * <span class="informal">It's like {@link scan}, but the Observables returned
	 * by the accumulator are merged into the outer Observable.</span>
	 *
	 * @example <caption>Count the number of click events</caption>
	 * const click$ = Rx.Observable.fromEvent(document, 'click');
	 * const one$ = click$.mapTo(1);
	 * const seed = 0;
	 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
	 * count$.subscribe(x => console.log(x));
	 *
	 * // Results:
	 * 1
	 * 2
	 * 3
	 * 4
	 * // ...and so on for each click
	 *
	 * @param {function(acc: R, value: T): Observable<R>} accumulator
	 * The accumulator function called on each source value.
	 * @param seed The initial accumulation value.
	 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
	 * input Observables being subscribed to concurrently.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method mergeScan
	 * @owner Observable
	 */
	function mergeScan(accumulator, seed, concurrent) {
	    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
	    return function (source) { return source.lift(new MergeScanOperator(accumulator, seed, concurrent)); };
	}
	exports.mergeScan = mergeScan;
	var MergeScanOperator = (function () {
	    function MergeScanOperator(accumulator, seed, concurrent) {
	        this.accumulator = accumulator;
	        this.seed = seed;
	        this.concurrent = concurrent;
	    }
	    MergeScanOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
	    };
	    return MergeScanOperator;
	}());
	exports.MergeScanOperator = MergeScanOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var MergeScanSubscriber = (function (_super) {
	    __extends(MergeScanSubscriber, _super);
	    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
	        _super.call(this, destination);
	        this.accumulator = accumulator;
	        this.acc = acc;
	        this.concurrent = concurrent;
	        this.hasValue = false;
	        this.hasCompleted = false;
	        this.buffer = [];
	        this.active = 0;
	        this.index = 0;
	    }
	    MergeScanSubscriber.prototype._next = function (value) {
	        if (this.active < this.concurrent) {
	            var index = this.index++;
	            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
	            var destination = this.destination;
	            if (ish === errorObject_1.errorObject) {
	                destination.error(errorObject_1.errorObject.e);
	            }
	            else {
	                this.active++;
	                this._innerSub(ish, value, index);
	            }
	        }
	        else {
	            this.buffer.push(value);
	        }
	    };
	    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
	        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
	    };
	    MergeScanSubscriber.prototype._complete = function () {
	        this.hasCompleted = true;
	        if (this.active === 0 && this.buffer.length === 0) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var destination = this.destination;
	        this.acc = innerValue;
	        this.hasValue = true;
	        destination.next(innerValue);
	    };
	    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
	        var buffer = this.buffer;
	        this.remove(innerSub);
	        this.active--;
	        if (buffer.length > 0) {
	            this._next(buffer.shift());
	        }
	        else if (this.active === 0 && this.hasCompleted) {
	            if (this.hasValue === false) {
	                this.destination.next(this.acc);
	            }
	            this.destination.complete();
	        }
	    };
	    return MergeScanSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	exports.MergeScanSubscriber = MergeScanSubscriber;
	//# sourceMappingURL=mergeScan.js.map

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var min_1 = __webpack_require__(776);
	Observable_1.Observable.prototype.min = min_1.min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var min_1 = __webpack_require__(777);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    return min_1.min(comparer)(this);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(759);
	/**
	 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
	 * and when source Observable completes it emits a single item: the item with the smallest value.
	 *
	 * <img src="./img/min.png" width="100%">
	 *
	 * @example <caption>Get the minimal value of a series of numbers</caption>
	 * Rx.Observable.of(5, 4, 7, 2, 8)
	 *   .min()
	 *   .subscribe(x => console.log(x)); // -> 2
	 *
	 * @example <caption>Use a comparer function to get the minimal item</caption>
	 * interface Person {
	 *   age: number,
	 *   name: string
	 * }
	 * Observable.of<Person>({age: 7, name: 'Foo'},
	 *                       {age: 5, name: 'Bar'},
	 *                       {age: 9, name: 'Beer'})
	 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
	 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
	 * }
	 *
	 * @see {@link max}
	 *
	 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
	 * value of two items.
	 * @return {Observable<R>} An Observable that emits item with the smallest value.
	 * @method min
	 * @owner Observable
	 */
	function min(comparer) {
	    var min = (typeof comparer === 'function')
	        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
	        : function (x, y) { return x < y ? x : y; };
	    return reduce_1.reduce(min);
	}
	exports.min = min;
	//# sourceMappingURL=min.js.map

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var multicast_1 = __webpack_require__(779);
	Observable_1.Observable.prototype.multicast = multicast_1.multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(780);
	/* tslint:enable:max-line-length */
	/**
	 * Allows source Observable to be subscribed only once with a Subject of choice,
	 * while still sharing its values between multiple subscribers.
	 *
	 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * `multicast` is an operator that works in two modes.
	 *
	 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
	 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
	 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
	 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
	 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
	 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
	 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
	 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
	 *
	 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
	 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
	 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
	 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
	 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
	 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
	 * ConnectableObservable, use `refCount`.
	 *
	 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
	 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
	 * as well, which should be the input stream modified by any operators you want. Note that in this
	 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
	 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
	 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
	 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
	 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
	 * but you want to subscribe to that Observable only once, this is the mode you would use.
	 *
	 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
	 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
	 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
	 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
	 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
	 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
	 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
	 *
	 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
	 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
	 *
	 * @example <caption>Use ConnectableObservable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const connectableSeconds = seconds.multicast(new Subject());
	 *
	 * connectableSeconds.subscribe(value => console.log('first: ' + value));
	 * connectableSeconds.subscribe(value => console.log('second: ' + value));
	 *
	 * // At this point still nothing happens, even though we subscribed twice.
	 *
	 * connectableSeconds.connect();
	 *
	 * // From now on `seconds` are being logged to the console,
	 * // twice per every second. `seconds` Observable was however only subscribed once,
	 * // so under the hood Observable.interval had only one clock started.
	 *
	 * @example <caption>Use selector</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds
	 *     .multicast(
	 *         () => new Subject(),
	 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
	 *                                         // Because we are inside selector, `seconds` is subscribed once,
	 *     )                                   // thus starting only one clock used internally by Observable.interval.
	 *     .subscribe();
	 *
	 * @see {@link publish}
	 * @see {@link publishLast}
	 * @see {@link publishBehavior}
	 * @see {@link publishReplay}
	 * @see {@link share}
	 * @see {@link shareReplay}
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
	 * which the source sequence's elements will be multicast to the selector function input Observable or
	 * ConnectableObservable returned by the operator.
	 * @param {Function} [selector] - Optional selector function that can use the input stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the input source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
	 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
	 *
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return multicast_1.multicast(subjectOrSubjectFactory, selector)(this);
	}
	exports.multicast = multicast;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ConnectableObservable_1 = __webpack_require__(781);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the results of invoking a specified selector on items
	 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
	 *
	 * <img src="./img/multicast.png" width="100%">
	 *
	 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
	 * which the source sequence's elements will be multicast to the selector function
	 * or Subject to push source elements into.
	 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
	 * as many times as needed, without causing multiple subscriptions to the source stream.
	 * Subscribers to the given source will receive all notifications of the source from the
	 * time of the subscription forward.
	 * @return {Observable} An Observable that emits the results of invoking the selector
	 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
	 * the underlying stream.
	 * @method multicast
	 * @owner Observable
	 */
	function multicast(subjectOrSubjectFactory, selector) {
	    return function multicastOperatorFunction(source) {
	        var subjectFactory;
	        if (typeof subjectOrSubjectFactory === 'function') {
	            subjectFactory = subjectOrSubjectFactory;
	        }
	        else {
	            subjectFactory = function subjectFactory() {
	                return subjectOrSubjectFactory;
	            };
	        }
	        if (typeof selector === 'function') {
	            return source.lift(new MulticastOperator(subjectFactory, selector));
	        }
	        var connectable = Object.create(source, ConnectableObservable_1.connectableObservableDescriptor);
	        connectable.source = source;
	        connectable.subjectFactory = subjectFactory;
	        return connectable;
	    };
	}
	exports.multicast = multicast;
	var MulticastOperator = (function () {
	    function MulticastOperator(subjectFactory, selector) {
	        this.subjectFactory = subjectFactory;
	        this.selector = selector;
	    }
	    MulticastOperator.prototype.call = function (subscriber, source) {
	        var selector = this.selector;
	        var subject = this.subjectFactory();
	        var subscription = selector(subject).subscribe(subscriber);
	        subscription.add(source.subscribe(subject));
	        return subscription;
	    };
	    return MulticastOperator;
	}());
	exports.MulticastOperator = MulticastOperator;
	//# sourceMappingURL=multicast.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var Observable_1 = __webpack_require__(499);
	var Subscriber_1 = __webpack_require__(502);
	var Subscription_1 = __webpack_require__(504);
	var refCount_1 = __webpack_require__(782);
	/**
	 * @class ConnectableObservable<T>
	 */
	var ConnectableObservable = (function (_super) {
	    __extends(ConnectableObservable, _super);
	    function ConnectableObservable(/** @deprecated internal use only */ source, 
	        /** @deprecated internal use only */ subjectFactory) {
	        _super.call(this);
	        this.source = source;
	        this.subjectFactory = subjectFactory;
	        /** @deprecated internal use only */ this._refCount = 0;
	        this._isComplete = false;
	    }
	    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function (subscriber) {
	        return this.getSubject().subscribe(subscriber);
	    };
	    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function () {
	        var subject = this._subject;
	        if (!subject || subject.isStopped) {
	            this._subject = this.subjectFactory();
	        }
	        return this._subject;
	    };
	    ConnectableObservable.prototype.connect = function () {
	        var connection = this._connection;
	        if (!connection) {
	            this._isComplete = false;
	            connection = this._connection = new Subscription_1.Subscription();
	            connection.add(this.source
	                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
	            if (connection.closed) {
	                this._connection = null;
	                connection = Subscription_1.Subscription.EMPTY;
	            }
	            else {
	                this._connection = connection;
	            }
	        }
	        return connection;
	    };
	    ConnectableObservable.prototype.refCount = function () {
	        return refCount_1.refCount()(this);
	    };
	    return ConnectableObservable;
	}(Observable_1.Observable));
	exports.ConnectableObservable = ConnectableObservable;
	var connectableProto = ConnectableObservable.prototype;
	exports.connectableObservableDescriptor = {
	    operator: { value: null },
	    _refCount: { value: 0, writable: true },
	    _subject: { value: null, writable: true },
	    _connection: { value: null, writable: true },
	    _subscribe: { value: connectableProto._subscribe },
	    _isComplete: { value: connectableProto._isComplete, writable: true },
	    getSubject: { value: connectableProto.getSubject },
	    connect: { value: connectableProto.connect },
	    refCount: { value: connectableProto.refCount }
	};
	var ConnectableSubscriber = (function (_super) {
	    __extends(ConnectableSubscriber, _super);
	    function ConnectableSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    ConnectableSubscriber.prototype._error = function (err) {
	        this._unsubscribe();
	        _super.prototype._error.call(this, err);
	    };
	    ConnectableSubscriber.prototype._complete = function () {
	        this.connectable._isComplete = true;
	        this._unsubscribe();
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (connectable) {
	            this.connectable = null;
	            var connection = connectable._connection;
	            connectable._refCount = 0;
	            connectable._subject = null;
	            connectable._connection = null;
	            if (connection) {
	                connection.unsubscribe();
	            }
	        }
	    };
	    return ConnectableSubscriber;
	}(Subject_1.SubjectSubscriber));
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	function refCount() {
	    return function refCountOperatorFunction(source) {
	        return source.lift(new RefCountOperator(source));
	    };
	}
	exports.refCount = refCount;
	var RefCountOperator = (function () {
	    function RefCountOperator(connectable) {
	        this.connectable = connectable;
	    }
	    RefCountOperator.prototype.call = function (subscriber, source) {
	        var connectable = this.connectable;
	        connectable._refCount++;
	        var refCounter = new RefCountSubscriber(subscriber, connectable);
	        var subscription = source.subscribe(refCounter);
	        if (!refCounter.closed) {
	            refCounter.connection = connectable.connect();
	        }
	        return subscription;
	    };
	    return RefCountOperator;
	}());
	var RefCountSubscriber = (function (_super) {
	    __extends(RefCountSubscriber, _super);
	    function RefCountSubscriber(destination, connectable) {
	        _super.call(this, destination);
	        this.connectable = connectable;
	    }
	    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function () {
	        var connectable = this.connectable;
	        if (!connectable) {
	            this.connection = null;
	            return;
	        }
	        this.connectable = null;
	        var refCount = connectable._refCount;
	        if (refCount <= 0) {
	            this.connection = null;
	            return;
	        }
	        connectable._refCount = refCount - 1;
	        if (refCount > 1) {
	            this.connection = null;
	            return;
	        }
	        ///
	        // Compare the local RefCountSubscriber's connection Subscription to the
	        // connection Subscription on the shared ConnectableObservable. In cases
	        // where the ConnectableObservable source synchronously emits values, and
	        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
	        // execution continues to here before the RefCountOperator has a chance to
	        // supply the RefCountSubscriber with the shared connection Subscription.
	        // For example:
	        // ```
	        // Observable.range(0, 10)
	        //   .publish()
	        //   .refCount()
	        //   .take(5)
	        //   .subscribe();
	        // ```
	        // In order to account for this case, RefCountSubscriber should only dispose
	        // the ConnectableObservable's shared connection Subscription if the
	        // connection Subscription exists, *and* either:
	        //   a. RefCountSubscriber doesn't have a reference to the shared connection
	        //      Subscription yet, or,
	        //   b. RefCountSubscriber's connection Subscription reference is identical
	        //      to the shared connection Subscription
	        ///
	        var connection = this.connection;
	        var sharedConnection = connectable._connection;
	        this.connection = null;
	        if (sharedConnection && (!connection || sharedConnection === connection)) {
	            sharedConnection.unsubscribe();
	        }
	    };
	    return RefCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=refCount.js.map

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var observeOn_1 = __webpack_require__(784);
	Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var observeOn_1 = __webpack_require__(545);
	/**
	 *
	 * Re-emits all notifications from source Observable with specified scheduler.
	 *
	 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
	 *
	 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
	 * notifications emitted by the source Observable. It might be useful, if you do not have control over
	 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
	 *
	 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
	 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
	 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
	 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
	 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
	 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
	 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
	 * little bit more, to ensure that they are emitted at expected moments.
	 *
	 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
	 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
	 * will delay all notifications - including error notifications - while `delay` will pass through error
	 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
	 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
	 * for notification emissions in general.
	 *
	 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
	 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
	 *                                               // with async scheduler by default...
	 *
	 * intervals
	 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
	 * .subscribe(val => {                           // scheduler to ensure smooth animation.
	 *   someDiv.style.height = val + 'px';
	 * });
	 *
	 * @see {@link delay}
	 *
	 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
	 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
	 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
	 * but with provided scheduler.
	 *
	 * @method observeOn
	 * @owner Observable
	 */
	function observeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return observeOn_1.observeOn(scheduler, delay)(this);
	}
	exports.observeOn = observeOn;
	//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var onErrorResumeNext_1 = __webpack_require__(786);
	Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var onErrorResumeNext_1 = __webpack_require__(593);
	/* tslint:enable:max-line-length */
	/**
	 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
	 * that was passed.
	 *
	 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
	 *
	 * <img src="./img/onErrorResumeNext.png" width="100%">
	 *
	 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
	 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
	 * as the source.
	 *
	 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
	 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
	 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
	 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
	 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
	 * be happening until there is no more Observables left in the series, at which point returned Observable will
	 * complete - even if the last subscribed stream ended with an error.
	 *
	 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
	 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
	 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
	 * an error.
	 *
	 * Note that you do not get any access to errors emitted by the Observables. In particular do not
	 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
	 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
	 *
	 *
	 * @example <caption>Subscribe to the next Observable after map fails</caption>
	 * Rx.Observable.of(1, 2, 3, 0)
	 *   .map(x => {
	 *       if (x === 0) { throw Error(); }
	         return 10 / x;
	 *   })
	 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
	 *   .subscribe(
	 *     val => console.log(val),
	 *     err => console.log(err),          // Will never be called.
	 *     () => console.log('that\'s it!')
	 *   );
	 *
	 * // Logs:
	 * // 10
	 * // 5
	 * // 3.3333333333333335
	 * // 1
	 * // 2
	 * // 3
	 * // "that's it!"
	 *
	 * @see {@link concat}
	 * @see {@link catch}
	 *
	 * @param {...ObservableInput} observables Observables passed either directly or as an array.
	 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
	 * to the next passed Observable and so on, until it completes or runs out of Observables.
	 * @method onErrorResumeNext
	 * @owner Observable
	 */
	function onErrorResumeNext() {
	    var nextSources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        nextSources[_i - 0] = arguments[_i];
	    }
	    return onErrorResumeNext_1.onErrorResumeNext.apply(void 0, nextSources)(this);
	}
	exports.onErrorResumeNext = onErrorResumeNext;
	//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var pairwise_1 = __webpack_require__(788);
	Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pairwise_1 = __webpack_require__(789);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return pairwise_1.pairwise()(this);
	}
	exports.pairwise = pairwise;
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Groups pairs of consecutive emissions together and emits them as an array of
	 * two values.
	 *
	 * <span class="informal">Puts the current value and previous value together as
	 * an array, and emits that.</span>
	 *
	 * <img src="./img/pairwise.png" width="100%">
	 *
	 * The Nth emission from the source Observable will cause the output Observable
	 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
	 * pair. For this reason, `pairwise` emits on the second and subsequent
	 * emissions from the source Observable, but not on the first emission, because
	 * there is no previous value in that case.
	 *
	 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var pairs = clicks.pairwise();
	 * var distance = pairs.map(pair => {
	 *   var x0 = pair[0].clientX;
	 *   var y0 = pair[0].clientY;
	 *   var x1 = pair[1].clientX;
	 *   var y1 = pair[1].clientY;
	 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
	 * });
	 * distance.subscribe(x => console.log(x));
	 *
	 * @see {@link buffer}
	 * @see {@link bufferCount}
	 *
	 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
	 * consecutive values from the source Observable.
	 * @method pairwise
	 * @owner Observable
	 */
	function pairwise() {
	    return function (source) { return source.lift(new PairwiseOperator()); };
	}
	exports.pairwise = pairwise;
	var PairwiseOperator = (function () {
	    function PairwiseOperator() {
	    }
	    PairwiseOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new PairwiseSubscriber(subscriber));
	    };
	    return PairwiseOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var PairwiseSubscriber = (function (_super) {
	    __extends(PairwiseSubscriber, _super);
	    function PairwiseSubscriber(destination) {
	        _super.call(this, destination);
	        this.hasPrev = false;
	    }
	    PairwiseSubscriber.prototype._next = function (value) {
	        if (this.hasPrev) {
	            this.destination.next([this.prev, value]);
	        }
	        else {
	            this.hasPrev = true;
	        }
	        this.prev = value;
	    };
	    return PairwiseSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=pairwise.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var partition_1 = __webpack_require__(791);
	Observable_1.Observable.prototype.partition = partition_1.partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var partition_1 = __webpack_require__(792);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return partition_1.partition(predicate, thisArg)(this);
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var not_1 = __webpack_require__(793);
	var filter_1 = __webpack_require__(708);
	/**
	 * Splits the source Observable into two, one with values that satisfy a
	 * predicate, and another with values that don't satisfy the predicate.
	 *
	 * <span class="informal">It's like {@link filter}, but returns two Observables:
	 * one like the output of {@link filter}, and the other with values that did not
	 * pass the condition.</span>
	 *
	 * <img src="./img/partition.png" width="100%">
	 *
	 * `partition` outputs an array with two Observables that partition the values
	 * from the source Observable through the given `predicate` function. The first
	 * Observable in that array emits source values for which the predicate argument
	 * returns true. The second Observable emits source values for which the
	 * predicate returns false. The first behaves like {@link filter} and the second
	 * behaves like {@link filter} with the predicate negated.
	 *
	 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
	 * var clicksOnDivs = parts[0];
	 * var clicksElsewhere = parts[1];
	 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
	 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
	 *
	 * @see {@link filter}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates each value emitted by the source Observable. If it returns `true`,
	 * the value is emitted on the first Observable in the returned array, if
	 * `false` the value is emitted on the second Observable in the array. The
	 * `index` parameter is the number `i` for the i-th source emission that has
	 * happened since the subscription, starting from the number `0`.
	 * @param {any} [thisArg] An optional argument to determine the value of `this`
	 * in the `predicate` function.
	 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
	 * with values that passed the predicate, and another with values that did not
	 * pass the predicate.
	 * @method partition
	 * @owner Observable
	 */
	function partition(predicate, thisArg) {
	    return function (source) { return [
	        filter_1.filter(predicate, thisArg)(source),
	        filter_1.filter(not_1.not(predicate, thisArg))(source)
	    ]; };
	}
	exports.partition = partition;
	//# sourceMappingURL=partition.js.map

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	"use strict";
	function not(pred, thisArg) {
	    function notPred() {
	        return !(notPred.pred.apply(notPred.thisArg, arguments));
	    }
	    notPred.pred = pred;
	    notPred.thisArg = thisArg;
	    return notPred;
	}
	exports.not = not;
	//# sourceMappingURL=not.js.map

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var pluck_1 = __webpack_require__(795);
	Observable_1.Observable.prototype.pluck = pluck_1.pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var pluck_1 = __webpack_require__(796);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    return pluck_1.pluck.apply(void 0, properties)(this);
	}
	exports.pluck = pluck;
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var map_1 = __webpack_require__(616);
	/**
	 * Maps each source value (an object) to its specified nested property.
	 *
	 * <span class="informal">Like {@link map}, but meant only for picking one of
	 * the nested properties of every emitted object.</span>
	 *
	 * <img src="./img/pluck.png" width="100%">
	 *
	 * Given a list of strings describing a path to an object property, retrieves
	 * the value of a specified nested property from all values in the source
	 * Observable. If a property can't be resolved, it will return `undefined` for
	 * that value.
	 *
	 * @example <caption>Map every click to the tagName of the clicked target element</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var tagNames = clicks.pluck('target', 'tagName');
	 * tagNames.subscribe(x => console.log(x));
	 *
	 * @see {@link map}
	 *
	 * @param {...string} properties The nested properties to pluck from each source
	 * value (an object).
	 * @return {Observable} A new Observable of property values from the source values.
	 * @method pluck
	 * @owner Observable
	 */
	function pluck() {
	    var properties = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        properties[_i - 0] = arguments[_i];
	    }
	    var length = properties.length;
	    if (length === 0) {
	        throw new Error('list of properties cannot be empty.');
	    }
	    return function (source) { return map_1.map(plucker(properties, length))(source); };
	}
	exports.pluck = pluck;
	function plucker(props, length) {
	    var mapper = function (x) {
	        var currentProp = x;
	        for (var i = 0; i < length; i++) {
	            var p = currentProp[props[i]];
	            if (typeof p !== 'undefined') {
	                currentProp = p;
	            }
	            else {
	                return undefined;
	            }
	        }
	        return currentProp;
	    };
	    return mapper;
	}
	//# sourceMappingURL=pluck.js.map

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var publish_1 = __webpack_require__(798);
	Observable_1.Observable.prototype.publish = publish_1.publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publish_1 = __webpack_require__(799);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return publish_1.publish(selector)(this);
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Subject_1 = __webpack_require__(498);
	var multicast_1 = __webpack_require__(780);
	/* tslint:enable:max-line-length */
	/**
	 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
	 * before it begins emitting items to those Observers that have subscribed to it.
	 *
	 * <img src="./img/publish.png" width="100%">
	 *
	 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
	 * as needed, without causing multiple subscriptions to the source sequence.
	 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
	 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
	 * @method publish
	 * @owner Observable
	 */
	function publish(selector) {
	    return selector ?
	        multicast_1.multicast(function () { return new Subject_1.Subject(); }, selector) :
	        multicast_1.multicast(new Subject_1.Subject());
	}
	exports.publish = publish;
	//# sourceMappingURL=publish.js.map

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var publishBehavior_1 = __webpack_require__(801);
	Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishBehavior_1 = __webpack_require__(802);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return publishBehavior_1.publishBehavior(value)(this);
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var BehaviorSubject_1 = __webpack_require__(803);
	var multicast_1 = __webpack_require__(780);
	/**
	 * @param value
	 * @return {ConnectableObservable<T>}
	 * @method publishBehavior
	 * @owner Observable
	 */
	function publishBehavior(value) {
	    return function (source) { return multicast_1.multicast(new BehaviorSubject_1.BehaviorSubject(value))(source); };
	}
	exports.publishBehavior = publishBehavior;
	//# sourceMappingURL=publishBehavior.js.map

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var ObjectUnsubscribedError_1 = __webpack_require__(515);
	/**
	 * @class BehaviorSubject<T>
	 */
	var BehaviorSubject = (function (_super) {
	    __extends(BehaviorSubject, _super);
	    function BehaviorSubject(_value) {
	        _super.call(this);
	        this._value = _value;
	    }
	    Object.defineProperty(BehaviorSubject.prototype, "value", {
	        get: function () {
	            return this.getValue();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function (subscriber) {
	        var subscription = _super.prototype._subscribe.call(this, subscriber);
	        if (subscription && !subscription.closed) {
	            subscriber.next(this._value);
	        }
	        return subscription;
	    };
	    BehaviorSubject.prototype.getValue = function () {
	        if (this.hasError) {
	            throw this.thrownError;
	        }
	        else if (this.closed) {
	            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
	        }
	        else {
	            return this._value;
	        }
	    };
	    BehaviorSubject.prototype.next = function (value) {
	        _super.prototype.next.call(this, this._value = value);
	    };
	    return BehaviorSubject;
	}(Subject_1.Subject));
	exports.BehaviorSubject = BehaviorSubject;
	//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var publishReplay_1 = __webpack_require__(805);
	Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishReplay_1 = __webpack_require__(806);
	/* tslint:enable:max-line-length */
	/**
	 * @param bufferSize
	 * @param windowTime
	 * @param selectorOrScheduler
	 * @param scheduler
	 * @return {Observable<T> | ConnectableObservable<T>}
	 * @method publishReplay
	 * @owner Observable
	 */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    return publishReplay_1.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(620);
	var multicast_1 = __webpack_require__(780);
	/* tslint:enable:max-line-length */
	function publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
	    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') {
	        scheduler = selectorOrScheduler;
	    }
	    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
	    var subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	    return function (source) { return multicast_1.multicast(function () { return subject; }, selector)(source); };
	}
	exports.publishReplay = publishReplay;
	//# sourceMappingURL=publishReplay.js.map

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var publishLast_1 = __webpack_require__(808);
	Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var publishLast_1 = __webpack_require__(809);
	/**
	 * @return {ConnectableObservable<T>}
	 * @method publishLast
	 * @owner Observable
	 */
	function publishLast() {
	    //TODO(benlesh): correct type-flow through here.
	    return publishLast_1.publishLast()(this);
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsyncSubject_1 = __webpack_require__(520);
	var multicast_1 = __webpack_require__(780);
	function publishLast() {
	    return function (source) { return multicast_1.multicast(new AsyncSubject_1.AsyncSubject())(source); };
	}
	exports.publishLast = publishLast;
	//# sourceMappingURL=publishLast.js.map

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var race_1 = __webpack_require__(811);
	Observable_1.Observable.prototype.race = race_1.race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var race_1 = __webpack_require__(812);
	// NOTE: to support backwards compatability with 5.4.* and lower
	var race_2 = __webpack_require__(586);
	exports.raceStatic = race_2.race;
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return race_1.race.apply(void 0, observables)(this);
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var isArray_1 = __webpack_require__(505);
	var race_1 = __webpack_require__(586);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that mirrors the first source Observable to emit an item
	 * from the combination of this Observable and supplied Observables.
	 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
	 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
	 * @method race
	 * @owner Observable
	 */
	function race() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return function raceOperatorFunction(source) {
	        // if the only argument is an array, it was most likely called with
	        // `pair([obs1, obs2, ...])`
	        if (observables.length === 1 && isArray_1.isArray(observables[0])) {
	            observables = observables[0];
	        }
	        return source.lift.call(race_1.race.apply(void 0, [source].concat(observables)));
	    };
	}
	exports.race = race;
	//# sourceMappingURL=race.js.map

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var reduce_1 = __webpack_require__(814);
	Observable_1.Observable.prototype.reduce = reduce_1.reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(759);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns the
	 * accumulated result when the source completes, given an optional seed value.
	 *
	 * <span class="informal">Combines together all values emitted on the source,
	 * using an accumulator function that knows how to join a new source value into
	 * the accumulation from the past.</span>
	 *
	 * <img src="./img/reduce.png" width="100%">
	 *
	 * Like
	 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
	 * `reduce` applies an `accumulator` function against an accumulation and each
	 * value of the source Observable (from the past) to reduce it to a single
	 * value, emitted on the output Observable. Note that `reduce` will only emit
	 * one value, only when the source Observable completes. It is equivalent to
	 * applying operator {@link scan} followed by operator {@link last}.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
	 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
	 *   .takeUntil(Rx.Observable.interval(5000));
	 * var ones = clicksInFiveSeconds.mapTo(1);
	 * var seed = 0;
	 * var count = ones.reduce((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link count}
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link scan}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
	 * called on each source value.
	 * @param {R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An Observable that emits a single value that is the
	 * result of accumulating the values emitted by the source Observable.
	 * @method reduce
	 * @owner Observable
	 */
	function reduce(accumulator, seed) {
	    // providing a seed of `undefined` *should* be valid and trigger
	    // hasSeed! so don't use `seed !== undefined` checks!
	    // For this reason, we have to check it here at the original call site
	    // otherwise inside Operator/Subscriber we won't know if `undefined`
	    // means they didn't provide anything or if they literally provided `undefined`
	    if (arguments.length >= 2) {
	        return reduce_1.reduce(accumulator, seed)(this);
	    }
	    return reduce_1.reduce(accumulator)(this);
	}
	exports.reduce = reduce;
	//# sourceMappingURL=reduce.js.map

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var repeat_1 = __webpack_require__(816);
	Observable_1.Observable.prototype.repeat = repeat_1.repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeat_1 = __webpack_require__(817);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return repeat_1.repeat(count)(this);
	}
	exports.repeat = repeat;
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var EmptyObservable_1 = __webpack_require__(529);
	/**
	 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
	 *
	 * <img src="./img/repeat.png" width="100%">
	 *
	 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
	 * an empty Observable.
	 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
	 * count times.
	 * @method repeat
	 * @owner Observable
	 */
	function repeat(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else if (count < 0) {
	            return source.lift(new RepeatOperator(-1, source));
	        }
	        else {
	            return source.lift(new RepeatOperator(count - 1, source));
	        }
	    };
	}
	exports.repeat = repeat;
	var RepeatOperator = (function () {
	    function RepeatOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RepeatOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
	    };
	    return RepeatOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatSubscriber = (function (_super) {
	    __extends(RepeatSubscriber, _super);
	    function RepeatSubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RepeatSubscriber.prototype.complete = function () {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.complete.call(this);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RepeatSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=repeat.js.map

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var repeatWhen_1 = __webpack_require__(819);
	Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var repeatWhen_1 = __webpack_require__(820);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return repeatWhen_1.repeatWhen(notifier)(this);
	}
	exports.repeatWhen = repeatWhen;
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
	 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
	 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
	 * this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/repeatWhen.png" width="100%">
	 *
	 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
	 * which a user can `complete` or `error`, aborting the repetition.
	 * @return {Observable} The source Observable modified with repeat logic.
	 * @method repeatWhen
	 * @owner Observable
	 */
	function repeatWhen(notifier) {
	    return function (source) { return source.lift(new RepeatWhenOperator(notifier)); };
	}
	exports.repeatWhen = repeatWhen;
	var RepeatWhenOperator = (function () {
	    function RepeatWhenOperator(notifier) {
	        this.notifier = notifier;
	    }
	    RepeatWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
	    };
	    return RepeatWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RepeatWhenSubscriber = (function (_super) {
	    __extends(RepeatWhenSubscriber, _super);
	    function RepeatWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	        this.sourceIsBeingSubscribedTo = true;
	    }
	    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.sourceIsBeingSubscribedTo = true;
	        this.source.subscribe(this);
	    };
	    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
	        if (this.sourceIsBeingSubscribedTo === false) {
	            return _super.prototype.complete.call(this);
	        }
	    };
	    RepeatWhenSubscriber.prototype.complete = function () {
	        this.sourceIsBeingSubscribedTo = false;
	        if (!this.isStopped) {
	            if (!this.retries) {
	                this.subscribeToRetries();
	            }
	            if (!this.retriesSubscription || this.retriesSubscription.closed) {
	                return _super.prototype.complete.call(this);
	            }
	            this._unsubscribeAndRecycle();
	            this.notifications.next();
	        }
	    };
	    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
	        if (notifications) {
	            notifications.unsubscribe();
	            this.notifications = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
	        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.notifications = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        _super.prototype._unsubscribeAndRecycle.call(this);
	        this.notifications = notifications;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        return this;
	    };
	    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
	        this.notifications = new Subject_1.Subject();
	        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
	        if (retries === errorObject_1.errorObject) {
	            return _super.prototype.complete.call(this);
	        }
	        this.retries = retries;
	        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	    };
	    return RepeatWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=repeatWhen.js.map

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var retry_1 = __webpack_require__(822);
	Observable_1.Observable.prototype.retry = retry_1.retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retry_1 = __webpack_require__(823);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return retry_1.retry(count)(this);
	}
	exports.retry = retry;
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
	 * as a number parameter) rather than propagating the `error` call.
	 *
	 * <img src="./img/retry.png" width="100%">
	 *
	 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
	 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
	 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
	 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
	 * @param {number} count - Number of retry attempts before failing.
	 * @return {Observable} The source Observable modified with the retry logic.
	 * @method retry
	 * @owner Observable
	 */
	function retry(count) {
	    if (count === void 0) { count = -1; }
	    return function (source) { return source.lift(new RetryOperator(count, source)); };
	}
	exports.retry = retry;
	var RetryOperator = (function () {
	    function RetryOperator(count, source) {
	        this.count = count;
	        this.source = source;
	    }
	    RetryOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
	    };
	    return RetryOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetrySubscriber = (function (_super) {
	    __extends(RetrySubscriber, _super);
	    function RetrySubscriber(destination, count, source) {
	        _super.call(this, destination);
	        this.count = count;
	        this.source = source;
	    }
	    RetrySubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var _a = this, source = _a.source, count = _a.count;
	            if (count === 0) {
	                return _super.prototype.error.call(this, err);
	            }
	            else if (count > -1) {
	                this.count = count - 1;
	            }
	            source.subscribe(this._unsubscribeAndRecycle());
	        }
	    };
	    return RetrySubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=retry.js.map

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var retryWhen_1 = __webpack_require__(825);
	Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var retryWhen_1 = __webpack_require__(826);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return retryWhen_1.retryWhen(notifier)(this);
	}
	exports.retryWhen = retryWhen;
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
	 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
	 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
	 * subscription. Otherwise this method will resubscribe to the source Observable.
	 *
	 * <img src="./img/retryWhen.png" width="100%">
	 *
	 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
	 * user can `complete` or `error`, aborting the retry.
	 * @return {Observable} The source Observable modified with retry logic.
	 * @method retryWhen
	 * @owner Observable
	 */
	function retryWhen(notifier) {
	    return function (source) { return source.lift(new RetryWhenOperator(notifier, source)); };
	}
	exports.retryWhen = retryWhen;
	var RetryWhenOperator = (function () {
	    function RetryWhenOperator(notifier, source) {
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
	    };
	    return RetryWhenOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var RetryWhenSubscriber = (function (_super) {
	    __extends(RetryWhenSubscriber, _super);
	    function RetryWhenSubscriber(destination, notifier, source) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.source = source;
	    }
	    RetryWhenSubscriber.prototype.error = function (err) {
	        if (!this.isStopped) {
	            var errors = this.errors;
	            var retries = this.retries;
	            var retriesSubscription = this.retriesSubscription;
	            if (!retries) {
	                errors = new Subject_1.Subject();
	                retries = tryCatch_1.tryCatch(this.notifier)(errors);
	                if (retries === errorObject_1.errorObject) {
	                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
	                }
	                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
	            }
	            else {
	                this.errors = null;
	                this.retriesSubscription = null;
	            }
	            this._unsubscribeAndRecycle();
	            this.errors = errors;
	            this.retries = retries;
	            this.retriesSubscription = retriesSubscription;
	            errors.next(err);
	        }
	    };
	    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function () {
	        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
	        if (errors) {
	            errors.unsubscribe();
	            this.errors = null;
	        }
	        if (retriesSubscription) {
	            retriesSubscription.unsubscribe();
	            this.retriesSubscription = null;
	        }
	        this.retries = null;
	    };
	    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
	        this.errors = null;
	        this.retries = null;
	        this.retriesSubscription = null;
	        this._unsubscribeAndRecycle();
	        this.errors = errors;
	        this.retries = retries;
	        this.retriesSubscription = retriesSubscription;
	        this.source.subscribe(this);
	    };
	    return RetryWhenSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=retryWhen.js.map

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var sample_1 = __webpack_require__(828);
	Observable_1.Observable.prototype.sample = sample_1.sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sample_1 = __webpack_require__(829);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return sample_1.sample(notifier)(this);
	}
	exports.sample = sample;
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Emits the most recently emitted value from the source Observable whenever
	 * another Observable, the `notifier`, emits.
	 *
	 * <span class="informal">It's like {@link sampleTime}, but samples whenever
	 * the `notifier` Observable emits something.</span>
	 *
	 * <img src="./img/sample.png" width="100%">
	 *
	 * Whenever the `notifier` Observable emits a value or completes, `sample`
	 * looks at the source Observable and emits whichever value it has most recently
	 * emitted since the previous sampling, unless the source has not emitted
	 * anything since the previous sampling. The `notifier` is subscribed to as soon
	 * as the output Observable is subscribed.
	 *
	 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
	 * var seconds = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = seconds.sample(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {Observable<any>} notifier The Observable to use for sampling the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable whenever the notifier Observable
	 * emits value or completes.
	 * @method sample
	 * @owner Observable
	 */
	function sample(notifier) {
	    return function (source) { return source.lift(new SampleOperator(notifier)); };
	}
	exports.sample = sample;
	var SampleOperator = (function () {
	    function SampleOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SampleOperator.prototype.call = function (subscriber, source) {
	        var sampleSubscriber = new SampleSubscriber(subscriber);
	        var subscription = source.subscribe(sampleSubscriber);
	        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
	        return subscription;
	    };
	    return SampleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleSubscriber = (function (_super) {
	    __extends(SampleSubscriber, _super);
	    function SampleSubscriber() {
	        _super.apply(this, arguments);
	        this.hasValue = false;
	    }
	    SampleSubscriber.prototype._next = function (value) {
	        this.value = value;
	        this.hasValue = true;
	    };
	    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.notifyComplete = function () {
	        this.emitValue();
	    };
	    SampleSubscriber.prototype.emitValue = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.value);
	        }
	    };
	    return SampleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=sample.js.map

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var sampleTime_1 = __webpack_require__(831);
	Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var sampleTime_1 = __webpack_require__(832);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return sampleTime_1.sampleTime(period, scheduler)(this);
	}
	exports.sampleTime = sampleTime;
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var async_1 = __webpack_require__(578);
	/**
	 * Emits the most recently emitted value from the source Observable within
	 * periodic time intervals.
	 *
	 * <span class="informal">Samples the source Observable at periodic time
	 * intervals, emitting what it samples.</span>
	 *
	 * <img src="./img/sampleTime.png" width="100%">
	 *
	 * `sampleTime` periodically looks at the source Observable and emits whichever
	 * value it has most recently emitted since the previous sampling, unless the
	 * source has not emitted anything since the previous sampling. The sampling
	 * happens periodically in time every `period` milliseconds (or the time unit
	 * defined by the optional `scheduler` argument). The sampling starts as soon as
	 * the output Observable is subscribed.
	 *
	 * @example <caption>Every second, emit the most recent click at most once</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.sampleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {number} period The sampling period expressed in milliseconds or the
	 * time unit determined internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the sampling.
	 * @return {Observable<T>} An Observable that emits the results of sampling the
	 * values emitted by the source Observable at the specified time interval.
	 * @method sampleTime
	 * @owner Observable
	 */
	function sampleTime(period, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new SampleTimeOperator(period, scheduler)); };
	}
	exports.sampleTime = sampleTime;
	var SampleTimeOperator = (function () {
	    function SampleTimeOperator(period, scheduler) {
	        this.period = period;
	        this.scheduler = scheduler;
	    }
	    SampleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
	    };
	    return SampleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SampleTimeSubscriber = (function (_super) {
	    __extends(SampleTimeSubscriber, _super);
	    function SampleTimeSubscriber(destination, period, scheduler) {
	        _super.call(this, destination);
	        this.period = period;
	        this.scheduler = scheduler;
	        this.hasValue = false;
	        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
	    }
	    SampleTimeSubscriber.prototype._next = function (value) {
	        this.lastValue = value;
	        this.hasValue = true;
	    };
	    SampleTimeSubscriber.prototype.notifyNext = function () {
	        if (this.hasValue) {
	            this.hasValue = false;
	            this.destination.next(this.lastValue);
	        }
	    };
	    return SampleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNotification(state) {
	    var subscriber = state.subscriber, period = state.period;
	    subscriber.notifyNext();
	    this.schedule(state, period);
	}
	//# sourceMappingURL=sampleTime.js.map

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var scan_1 = __webpack_require__(834);
	Observable_1.Observable.prototype.scan = scan_1.scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var scan_1 = __webpack_require__(760);
	/* tslint:enable:max-line-length */
	/**
	 * Applies an accumulator function over the source Observable, and returns each
	 * intermediate result, with an optional seed value.
	 *
	 * <span class="informal">It's like {@link reduce}, but emits the current
	 * accumulation whenever the source emits a value.</span>
	 *
	 * <img src="./img/scan.png" width="100%">
	 *
	 * Combines together all values emitted on the source, using an accumulator
	 * function that knows how to join a new source value into the accumulation from
	 * the past. Is similar to {@link reduce}, but emits the intermediate
	 * accumulations.
	 *
	 * Returns an Observable that applies a specified `accumulator` function to each
	 * item emitted by the source Observable. If a `seed` value is specified, then
	 * that value will be used as the initial value for the accumulator. If no seed
	 * value is specified, the first item of the source is used as the seed.
	 *
	 * @example <caption>Count the number of click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var ones = clicks.mapTo(1);
	 * var seed = 0;
	 * var count = ones.scan((acc, one) => acc + one, seed);
	 * count.subscribe(x => console.log(x));
	 *
	 * @see {@link expand}
	 * @see {@link mergeScan}
	 * @see {@link reduce}
	 *
	 * @param {function(acc: R, value: T, index: number): R} accumulator
	 * The accumulator function called on each source value.
	 * @param {T|R} [seed] The initial accumulation value.
	 * @return {Observable<R>} An observable of the accumulated values.
	 * @method scan
	 * @owner Observable
	 */
	function scan(accumulator, seed) {
	    if (arguments.length >= 2) {
	        return scan_1.scan(accumulator, seed)(this);
	    }
	    return scan_1.scan(accumulator)(this);
	}
	exports.scan = scan;
	//# sourceMappingURL=scan.js.map

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var sequenceEqual_1 = __webpack_require__(836);
	Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var sequenceEqual_1 = __webpack_require__(837);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return sequenceEqual_1.sequenceEqual(compareTo, comparor)(this);
	}
	exports.sequenceEqual = sequenceEqual;
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	/**
	 * Compares all values of two observables in sequence using an optional comparor function
	 * and returns an observable of a single boolean value representing whether or not the two sequences
	 * are equal.
	 *
	 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
	 *
	 * <img src="./img/sequenceEqual.png" width="100%">
	 *
	 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
	 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
	 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
	 * observables completes, the operator will wait for the other observable to complete; If the other
	 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
	 * completes or emits after the other complets, the returned observable will never complete.
	 *
	 * @example <caption>figure out if the Konami code matches</caption>
	 * var code = Rx.Observable.from([
	 *  "ArrowUp",
	 *  "ArrowUp",
	 *  "ArrowDown",
	 *  "ArrowDown",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "ArrowLeft",
	 *  "ArrowRight",
	 *  "KeyB",
	 *  "KeyA",
	 *  "Enter" // no start key, clearly.
	 * ]);
	 *
	 * var keys = Rx.Observable.fromEvent(document, 'keyup')
	 *  .map(e => e.code);
	 * var matches = keys.bufferCount(11, 1)
	 *  .mergeMap(
	 *    last11 =>
	 *      Rx.Observable.from(last11)
	 *        .sequenceEqual(code)
	 *   );
	 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
	 *
	 * @see {@link combineLatest}
	 * @see {@link zip}
	 * @see {@link withLatestFrom}
	 *
	 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
	 * @param {function} [comparor] An optional function to compare each value pair
	 * @return {Observable} An Observable of a single boolean value representing whether or not
	 * the values emitted by both observables were equal in sequence.
	 * @method sequenceEqual
	 * @owner Observable
	 */
	function sequenceEqual(compareTo, comparor) {
	    return function (source) { return source.lift(new SequenceEqualOperator(compareTo, comparor)); };
	}
	exports.sequenceEqual = sequenceEqual;
	var SequenceEqualOperator = (function () {
	    function SequenceEqualOperator(compareTo, comparor) {
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	    }
	    SequenceEqualOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
	    };
	    return SequenceEqualOperator;
	}());
	exports.SequenceEqualOperator = SequenceEqualOperator;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SequenceEqualSubscriber = (function (_super) {
	    __extends(SequenceEqualSubscriber, _super);
	    function SequenceEqualSubscriber(destination, compareTo, comparor) {
	        _super.call(this, destination);
	        this.compareTo = compareTo;
	        this.comparor = comparor;
	        this._a = [];
	        this._b = [];
	        this._oneComplete = false;
	        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
	    }
	    SequenceEqualSubscriber.prototype._next = function (value) {
	        if (this._oneComplete && this._b.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._a.push(value);
	            this.checkValues();
	        }
	    };
	    SequenceEqualSubscriber.prototype._complete = function () {
	        if (this._oneComplete) {
	            this.emit(this._a.length === 0 && this._b.length === 0);
	        }
	        else {
	            this._oneComplete = true;
	        }
	    };
	    SequenceEqualSubscriber.prototype.checkValues = function () {
	        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
	        while (_a.length > 0 && _b.length > 0) {
	            var a = _a.shift();
	            var b = _b.shift();
	            var areEqual = false;
	            if (comparor) {
	                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
	                if (areEqual === errorObject_1.errorObject) {
	                    this.destination.error(errorObject_1.errorObject.e);
	                }
	            }
	            else {
	                areEqual = a === b;
	            }
	            if (!areEqual) {
	                this.emit(false);
	            }
	        }
	    };
	    SequenceEqualSubscriber.prototype.emit = function (value) {
	        var destination = this.destination;
	        destination.next(value);
	        destination.complete();
	    };
	    SequenceEqualSubscriber.prototype.nextB = function (value) {
	        if (this._oneComplete && this._a.length === 0) {
	            this.emit(false);
	        }
	        else {
	            this._b.push(value);
	            this.checkValues();
	        }
	    };
	    return SequenceEqualSubscriber;
	}(Subscriber_1.Subscriber));
	exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
	var SequenceEqualCompareToSubscriber = (function (_super) {
	    __extends(SequenceEqualCompareToSubscriber, _super);
	    function SequenceEqualCompareToSubscriber(destination, parent) {
	        _super.call(this, destination);
	        this.parent = parent;
	    }
	    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
	        this.parent.nextB(value);
	    };
	    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
	        this.parent.error(err);
	    };
	    SequenceEqualCompareToSubscriber.prototype._complete = function () {
	        this.parent._complete();
	    };
	    return SequenceEqualCompareToSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=sequenceEqual.js.map

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var share_1 = __webpack_require__(839);
	Observable_1.Observable.prototype.share = share_1.share;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var share_1 = __webpack_require__(840);
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 *
	 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
	 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
	 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
	 * re-emit "test" to new subscriptions.
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return share_1.share()(this);
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var multicast_1 = __webpack_require__(780);
	var refCount_1 = __webpack_require__(782);
	var Subject_1 = __webpack_require__(498);
	function shareSubjectFactory() {
	    return new Subject_1.Subject();
	}
	/**
	 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
	 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
	 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
	 * This is an alias for .multicast(() => new Subject()).refCount().
	 *
	 * <img src="./img/share.png" width="100%">
	 *
	 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
	 * @method share
	 * @owner Observable
	 */
	function share() {
	    return function (source) { return refCount_1.refCount()(multicast_1.multicast(shareSubjectFactory)(source)); };
	}
	exports.share = share;
	;
	//# sourceMappingURL=share.js.map

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var shareReplay_1 = __webpack_require__(842);
	Observable_1.Observable.prototype.shareReplay = shareReplay_1.shareReplay;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var shareReplay_1 = __webpack_require__(843);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return shareReplay_1.shareReplay(bufferSize, windowTime, scheduler)(this);
	}
	exports.shareReplay = shareReplay;
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ReplaySubject_1 = __webpack_require__(620);
	/**
	 * @method shareReplay
	 * @owner Observable
	 */
	function shareReplay(bufferSize, windowTime, scheduler) {
	    return function (source) { return source.lift(shareReplayOperator(bufferSize, windowTime, scheduler)); };
	}
	exports.shareReplay = shareReplay;
	function shareReplayOperator(bufferSize, windowTime, scheduler) {
	    var subject;
	    var refCount = 0;
	    var subscription;
	    var hasError = false;
	    var isComplete = false;
	    return function shareReplayOperation(source) {
	        refCount++;
	        if (!subject || hasError) {
	            hasError = false;
	            subject = new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler);
	            subscription = source.subscribe({
	                next: function (value) { subject.next(value); },
	                error: function (err) {
	                    hasError = true;
	                    subject.error(err);
	                },
	                complete: function () {
	                    isComplete = true;
	                    subject.complete();
	                },
	            });
	        }
	        var innerSub = subject.subscribe(this);
	        return function () {
	            refCount--;
	            innerSub.unsubscribe();
	            if (subscription && refCount === 0 && isComplete) {
	                subscription.unsubscribe();
	            }
	        };
	    };
	}
	;
	//# sourceMappingURL=shareReplay.js.map

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var single_1 = __webpack_require__(845);
	Observable_1.Observable.prototype.single = single_1.single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var single_1 = __webpack_require__(846);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return single_1.single(predicate)(this);
	}
	exports.single = single;
	//# sourceMappingURL=single.js.map

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var EmptyError_1 = __webpack_require__(721);
	/**
	 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
	 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
	 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
	 *
	 * <img src="./img/single.png" width="100%">
	 *
	 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
	 * callback if the Observable completes before any `next` notification was sent.
	 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
	 * the predicate.
	 .
	 * @method single
	 * @owner Observable
	 */
	function single(predicate) {
	    return function (source) { return source.lift(new SingleOperator(predicate, source)); };
	}
	exports.single = single;
	var SingleOperator = (function () {
	    function SingleOperator(predicate, source) {
	        this.predicate = predicate;
	        this.source = source;
	    }
	    SingleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
	    };
	    return SingleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SingleSubscriber = (function (_super) {
	    __extends(SingleSubscriber, _super);
	    function SingleSubscriber(destination, predicate, source) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.source = source;
	        this.seenValue = false;
	        this.index = 0;
	    }
	    SingleSubscriber.prototype.applySingleValue = function (value) {
	        if (this.seenValue) {
	            this.destination.error('Sequence contains more than one element');
	        }
	        else {
	            this.seenValue = true;
	            this.singleValue = value;
	        }
	    };
	    SingleSubscriber.prototype._next = function (value) {
	        var index = this.index++;
	        if (this.predicate) {
	            this.tryNext(value, index);
	        }
	        else {
	            this.applySingleValue(value);
	        }
	    };
	    SingleSubscriber.prototype.tryNext = function (value, index) {
	        try {
	            if (this.predicate(value, index, this.source)) {
	                this.applySingleValue(value);
	            }
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    SingleSubscriber.prototype._complete = function () {
	        var destination = this.destination;
	        if (this.index > 0) {
	            destination.next(this.seenValue ? this.singleValue : undefined);
	            destination.complete();
	        }
	        else {
	            destination.error(new EmptyError_1.EmptyError);
	        }
	    };
	    return SingleSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=single.js.map

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var skip_1 = __webpack_require__(848);
	Observable_1.Observable.prototype.skip = skip_1.skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skip_1 = __webpack_require__(849);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return skip_1.skip(count)(this);
	}
	exports.skip = skip;
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Returns an Observable that skips the first `count` items emitted by the source Observable.
	 *
	 * <img src="./img/skip.png" width="100%">
	 *
	 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
	 * @return {Observable} An Observable that skips values emitted by the source Observable.
	 *
	 * @method skip
	 * @owner Observable
	 */
	function skip(count) {
	    return function (source) { return source.lift(new SkipOperator(count)); };
	}
	exports.skip = skip;
	var SkipOperator = (function () {
	    function SkipOperator(total) {
	        this.total = total;
	    }
	    SkipOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipSubscriber(subscriber, this.total));
	    };
	    return SkipOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipSubscriber = (function (_super) {
	    __extends(SkipSubscriber, _super);
	    function SkipSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    SkipSubscriber.prototype._next = function (x) {
	        if (++this.count > this.total) {
	            this.destination.next(x);
	        }
	    };
	    return SkipSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skip.js.map

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var skipLast_1 = __webpack_require__(851);
	Observable_1.Observable.prototype.skipLast = skipLast_1.skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipLast_1 = __webpack_require__(852);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return skipLast_1.skipLast(count)(this);
	}
	exports.skipLast = skipLast;
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var ArgumentOutOfRangeError_1 = __webpack_require__(705);
	/**
	 * Skip the last `count` values emitted by the source Observable.
	 *
	 * <img src="./img/skipLast.png" width="100%">
	 *
	 * `skipLast` returns an Observable that accumulates a queue with a length
	 * enough to store the first `count` values. As more values are received,
	 * values are taken from the front of the queue and produced on the result
	 * sequence. This causes values to be delayed.
	 *
	 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 5);
	 * var skipLastTwo = many.skipLast(2);
	 * skipLastTwo.subscribe(x => console.log(x));
	 *
	 * // Results in:
	 * // 1 2 3
	 *
	 * @see {@link skip}
	 * @see {@link skipUntil}
	 * @see {@link skipWhile}
	 * @see {@link take}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
	 * ArgumentOutOrRangeError if `i < 0`.
	 *
	 * @param {number} count Number of elements to skip from the end of the source Observable.
	 * @returns {Observable<T>} An Observable that skips the last count values
	 * emitted by the source Observable.
	 * @method skipLast
	 * @owner Observable
	 */
	function skipLast(count) {
	    return function (source) { return source.lift(new SkipLastOperator(count)); };
	}
	exports.skipLast = skipLast;
	var SkipLastOperator = (function () {
	    function SkipLastOperator(_skipCount) {
	        this._skipCount = _skipCount;
	        if (this._skipCount < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    SkipLastOperator.prototype.call = function (subscriber, source) {
	        if (this._skipCount === 0) {
	            // If we don't want to skip any values then just subscribe
	            // to Subscriber without any further logic.
	            return source.subscribe(new Subscriber_1.Subscriber(subscriber));
	        }
	        else {
	            return source.subscribe(new SkipLastSubscriber(subscriber, this._skipCount));
	        }
	    };
	    return SkipLastOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipLastSubscriber = (function (_super) {
	    __extends(SkipLastSubscriber, _super);
	    function SkipLastSubscriber(destination, _skipCount) {
	        _super.call(this, destination);
	        this._skipCount = _skipCount;
	        this._count = 0;
	        this._ring = new Array(_skipCount);
	    }
	    SkipLastSubscriber.prototype._next = function (value) {
	        var skipCount = this._skipCount;
	        var count = this._count++;
	        if (count < skipCount) {
	            this._ring[count] = value;
	        }
	        else {
	            var currentIndex = count % skipCount;
	            var ring = this._ring;
	            var oldValue = ring[currentIndex];
	            ring[currentIndex] = value;
	            this.destination.next(oldValue);
	        }
	    };
	    return SkipLastSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipLast.js.map

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var skipUntil_1 = __webpack_require__(854);
	Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipUntil_1 = __webpack_require__(855);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return skipUntil_1.skipUntil(notifier)(this);
	}
	exports.skipUntil = skipUntil;
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
	 *
	 * <img src="./img/skipUntil.png" width="100%">
	 *
	 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
	 * be mirrored by the resulting Observable.
	 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
	 * an item, then emits the remaining items.
	 * @method skipUntil
	 * @owner Observable
	 */
	function skipUntil(notifier) {
	    return function (source) { return source.lift(new SkipUntilOperator(notifier)); };
	}
	exports.skipUntil = skipUntil;
	var SkipUntilOperator = (function () {
	    function SkipUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    SkipUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
	    };
	    return SkipUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipUntilSubscriber = (function (_super) {
	    __extends(SkipUntilSubscriber, _super);
	    function SkipUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.hasValue = false;
	        this.isInnerStopped = false;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    SkipUntilSubscriber.prototype._next = function (value) {
	        if (this.hasValue) {
	            _super.prototype._next.call(this, value);
	        }
	    };
	    SkipUntilSubscriber.prototype._complete = function () {
	        if (this.isInnerStopped) {
	            _super.prototype._complete.call(this);
	        }
	        else {
	            this.unsubscribe();
	        }
	    };
	    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.hasValue = true;
	    };
	    SkipUntilSubscriber.prototype.notifyComplete = function () {
	        this.isInnerStopped = true;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    return SkipUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=skipUntil.js.map

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var skipWhile_1 = __webpack_require__(857);
	Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var skipWhile_1 = __webpack_require__(858);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return skipWhile_1.skipWhile(predicate)(this);
	}
	exports.skipWhile = skipWhile;
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
	 * true, but emits all further source items as soon as the condition becomes false.
	 *
	 * <img src="./img/skipWhile.png" width="100%">
	 *
	 * @param {Function} predicate - A function to test each item emitted from the source Observable.
	 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
	 * specified predicate becomes false.
	 * @method skipWhile
	 * @owner Observable
	 */
	function skipWhile(predicate) {
	    return function (source) { return source.lift(new SkipWhileOperator(predicate)); };
	}
	exports.skipWhile = skipWhile;
	var SkipWhileOperator = (function () {
	    function SkipWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    SkipWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
	    };
	    return SkipWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SkipWhileSubscriber = (function (_super) {
	    __extends(SkipWhileSubscriber, _super);
	    function SkipWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.skipping = true;
	        this.index = 0;
	    }
	    SkipWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        if (this.skipping) {
	            this.tryCallPredicate(value);
	        }
	        if (!this.skipping) {
	            destination.next(value);
	        }
	    };
	    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
	        try {
	            var result = this.predicate(value, this.index++);
	            this.skipping = Boolean(result);
	        }
	        catch (err) {
	            this.destination.error(err);
	        }
	    };
	    return SkipWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=skipWhile.js.map

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var startWith_1 = __webpack_require__(860);
	Observable_1.Observable.prototype.startWith = startWith_1.startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var startWith_1 = __webpack_require__(861);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return startWith_1.startWith.apply(void 0, array)(this);
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var ArrayObservable_1 = __webpack_require__(527);
	var ScalarObservable_1 = __webpack_require__(528);
	var EmptyObservable_1 = __webpack_require__(529);
	var concat_1 = __webpack_require__(538);
	var isScheduler_1 = __webpack_require__(526);
	/* tslint:enable:max-line-length */
	/**
	 * Returns an Observable that emits the items you specify as arguments before it begins to emit
	 * items emitted by the source Observable.
	 *
	 * <img src="./img/startWith.png" width="100%">
	 *
	 * @param {...T} values - Items you want the modified Observable to emit first.
	 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
	 * the emissions of the `next` notifications.
	 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
	 * emitted by the source Observable.
	 * @method startWith
	 * @owner Observable
	 */
	function startWith() {
	    var array = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        array[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var scheduler = array[array.length - 1];
	        if (isScheduler_1.isScheduler(scheduler)) {
	            array.pop();
	        }
	        else {
	            scheduler = null;
	        }
	        var len = array.length;
	        if (len === 1) {
	            return concat_1.concat(new ScalarObservable_1.ScalarObservable(array[0], scheduler), source);
	        }
	        else if (len > 1) {
	            return concat_1.concat(new ArrayObservable_1.ArrayObservable(array, scheduler), source);
	        }
	        else {
	            return concat_1.concat(new EmptyObservable_1.EmptyObservable(scheduler), source);
	        }
	    };
	}
	exports.startWith = startWith;
	//# sourceMappingURL=startWith.js.map

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var subscribeOn_1 = __webpack_require__(863);
	Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var subscribeOn_1 = __webpack_require__(864);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return subscribeOn_1.subscribeOn(scheduler, delay)(this);
	}
	exports.subscribeOn = subscribeOn;
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscribeOnObservable_1 = __webpack_require__(865);
	/**
	 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
	 *
	 * <img src="./img/subscribeOn.png" width="100%">
	 *
	 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
	 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
	 .
	 * @method subscribeOn
	 * @owner Observable
	 */
	function subscribeOn(scheduler, delay) {
	    if (delay === void 0) { delay = 0; }
	    return function subscribeOnOperatorFunction(source) {
	        return source.lift(new SubscribeOnOperator(scheduler, delay));
	    };
	}
	exports.subscribeOn = subscribeOn;
	var SubscribeOnOperator = (function () {
	    function SubscribeOnOperator(scheduler, delay) {
	        this.scheduler = scheduler;
	        this.delay = delay;
	    }
	    SubscribeOnOperator.prototype.call = function (subscriber, source) {
	        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
	    };
	    return SubscribeOnOperator;
	}());
	//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var asap_1 = __webpack_require__(866);
	var isNumeric_1 = __webpack_require__(577);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @extends {Ignored}
	 * @hide true
	 */
	var SubscribeOnObservable = (function (_super) {
	    __extends(SubscribeOnObservable, _super);
	    function SubscribeOnObservable(source, delayTime, scheduler) {
	        if (delayTime === void 0) { delayTime = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        _super.call(this);
	        this.source = source;
	        this.delayTime = delayTime;
	        this.scheduler = scheduler;
	        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
	            this.delayTime = 0;
	        }
	        if (!scheduler || typeof scheduler.schedule !== 'function') {
	            this.scheduler = asap_1.asap;
	        }
	    }
	    SubscribeOnObservable.create = function (source, delay, scheduler) {
	        if (delay === void 0) { delay = 0; }
	        if (scheduler === void 0) { scheduler = asap_1.asap; }
	        return new SubscribeOnObservable(source, delay, scheduler);
	    };
	    SubscribeOnObservable.dispatch = function (arg) {
	        var source = arg.source, subscriber = arg.subscriber;
	        return this.add(source.subscribe(subscriber));
	    };
	    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function (subscriber) {
	        var delay = this.delayTime;
	        var source = this.source;
	        var scheduler = this.scheduler;
	        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
	            source: source, subscriber: subscriber
	        });
	    };
	    return SubscribeOnObservable;
	}(Observable_1.Observable));
	exports.SubscribeOnObservable = SubscribeOnObservable;
	//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AsapAction_1 = __webpack_require__(867);
	var AsapScheduler_1 = __webpack_require__(872);
	/**
	 *
	 * Asap Scheduler
	 *
	 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
	 *
	 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
	 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
	 * code to end and then it will try to execute given task as fast as possible.
	 *
	 * `asap` scheduler will do its best to minimize time between end of currently executing code
	 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
	 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
	 * some (although minimal) unwanted delay.
	 *
	 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
	 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
	 * that task will execute first. That being said, if you need to schedule task asynchronously, but
	 * as soon as possible, `asap` scheduler is your best bet.
	 *
	 * @example <caption>Compare async and asap scheduler</caption>
	 *
	 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
	 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
	 *
	 * // Logs:
	 * // "asap"
	 * // "async"
	 * // ... but 'asap' goes first!
	 *
	 * @static true
	 * @name asap
	 * @owner Scheduler
	 */
	exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
	//# sourceMappingURL=asap.js.map

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Immediate_1 = __webpack_require__(868);
	var AsyncAction_1 = __webpack_require__(579);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AsapAction = (function (_super) {
	    __extends(AsapAction, _super);
	    function AsapAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If a microtask has already been scheduled, don't schedule another
	        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
	        // the current scheduled microtask id.
	        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
	    };
	    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested microtask and
	        // set the scheduled flag to undefined so the next AsapAction will schedule
	        // its own.
	        if (scheduler.actions.length === 0) {
	            Immediate_1.Immediate.clearImmediate(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AsapAction;
	}(AsyncAction_1.AsyncAction));
	exports.AsapAction = AsapAction;
	//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {/**
	Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
	*/
	"use strict";
	var root_1 = __webpack_require__(500);
	var ImmediateDefinition = (function () {
	    function ImmediateDefinition(root) {
	        this.root = root;
	        if (root.setImmediate && typeof root.setImmediate === 'function') {
	            this.setImmediate = root.setImmediate.bind(root);
	            this.clearImmediate = root.clearImmediate.bind(root);
	        }
	        else {
	            this.nextHandle = 1;
	            this.tasksByHandle = {};
	            this.currentlyRunningATask = false;
	            // Don't get fooled by e.g. browserify environments.
	            if (this.canUseProcessNextTick()) {
	                // For Node.js before 0.9
	                this.setImmediate = this.createProcessNextTickSetImmediate();
	            }
	            else if (this.canUsePostMessage()) {
	                // For non-IE10 modern browsers
	                this.setImmediate = this.createPostMessageSetImmediate();
	            }
	            else if (this.canUseMessageChannel()) {
	                // For web workers, where supported
	                this.setImmediate = this.createMessageChannelSetImmediate();
	            }
	            else if (this.canUseReadyStateChange()) {
	                // For IE 6–8
	                this.setImmediate = this.createReadyStateChangeSetImmediate();
	            }
	            else {
	                // For older browsers
	                this.setImmediate = this.createSetTimeoutSetImmediate();
	            }
	            var ci = function clearImmediate(handle) {
	                delete clearImmediate.instance.tasksByHandle[handle];
	            };
	            ci.instance = this;
	            this.clearImmediate = ci;
	        }
	    }
	    ImmediateDefinition.prototype.identify = function (o) {
	        return this.root.Object.prototype.toString.call(o);
	    };
	    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
	        return this.identify(this.root.process) === '[object process]';
	    };
	    ImmediateDefinition.prototype.canUseMessageChannel = function () {
	        return Boolean(this.root.MessageChannel);
	    };
	    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
	        var document = this.root.document;
	        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
	    };
	    ImmediateDefinition.prototype.canUsePostMessage = function () {
	        var root = this.root;
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `root.postMessage` means something completely different and can't be used for this purpose.
	        if (root.postMessage && !root.importScripts) {
	            var postMessageIsAsynchronous_1 = true;
	            var oldOnMessage = root.onmessage;
	            root.onmessage = function () {
	                postMessageIsAsynchronous_1 = false;
	            };
	            root.postMessage('', '*');
	            root.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous_1;
	        }
	        return false;
	    };
	    // This function accepts the same arguments as setImmediate, but
	    // returns a function that requires no arguments.
	    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var fn = function result() {
	            var _a = result, handler = _a.handler, args = _a.args;
	            if (typeof handler === 'function') {
	                handler.apply(undefined, args);
	            }
	            else {
	                (new Function('' + handler))();
	            }
	        };
	        fn.handler = handler;
	        fn.args = args;
	        return fn;
	    };
	    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
	        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
	        return this.nextHandle++;
	    };
	    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	        var root = this.root;
	        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
	        var onGlobalMessage = function globalMessageHandler(event) {
	            var instance = globalMessageHandler.instance;
	            if (event.source === root &&
	                typeof event.data === 'string' &&
	                event.data.indexOf(messagePrefix) === 0) {
	                instance.runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	        onGlobalMessage.instance = this;
	        root.addEventListener('message', onGlobalMessage, false);
	        var fn = function setImmediate() {
	            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.postMessage(messagePrefix + handle, '*');
	            return handle;
	        };
	        fn.instance = this;
	        fn.messagePrefix = messagePrefix;
	        return fn;
	    };
	    ImmediateDefinition.prototype.runIfPresent = function (handle) {
	        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (this.currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // 'too much recursion' error.
	            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
	        }
	        else {
	            var task = this.tasksByHandle[handle];
	            if (task) {
	                this.currentlyRunningATask = true;
	                try {
	                    task();
	                }
	                finally {
	                    this.clearImmediate(handle);
	                    this.currentlyRunningATask = false;
	                }
	            }
	        }
	    };
	    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
	        var _this = this;
	        var channel = new this.root.MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            _this.runIfPresent(handle);
	        };
	        var fn = function setImmediate() {
	            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            channel.port2.postMessage(handle);
	            return handle;
	        };
	        fn.channel = channel;
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var root = instance.root;
	            var doc = root.document;
	            var html = doc.documentElement;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement('script');
	            script.onreadystatechange = function () {
	                instance.runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
	        var fn = function setImmediate() {
	            var instance = setImmediate.instance;
	            var handle = instance.addFromSetImmediateArguments(arguments);
	            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
	            return handle;
	        };
	        fn.instance = this;
	        return fn;
	    };
	    return ImmediateDefinition;
	}());
	exports.ImmediateDefinition = ImmediateDefinition;
	exports.Immediate = new ImmediateDefinition(root_1.root);
	//# sourceMappingURL=Immediate.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(869).clearImmediate, __webpack_require__(869).setImmediate))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(870);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(871)))

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(581);
	var AsapScheduler = (function (_super) {
	    __extends(AsapScheduler, _super);
	    function AsapScheduler() {
	        _super.apply(this, arguments);
	    }
	    AsapScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AsapScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AsapScheduler = AsapScheduler;
	//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var switch_1 = __webpack_require__(874);
	Observable_1.Observable.prototype.switch = switch_1._switch;
	Observable_1.Observable.prototype._switch = switch_1._switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchAll_1 = __webpack_require__(875);
	/**
	 * Converts a higher-order Observable into a first-order Observable by
	 * subscribing to only the most recently emitted of those inner Observables.
	 *
	 * <span class="informal">Flattens an Observable-of-Observables by dropping the
	 * previous inner Observable once a new one appears.</span>
	 *
	 * <img src="./img/switch.png" width="100%">
	 *
	 * `switch` subscribes to an Observable that emits Observables, also known as a
	 * higher-order Observable. Each time it observes one of these emitted inner
	 * Observables, the output Observable subscribes to the inner Observable and
	 * begins emitting the items emitted by that. So far, it behaves
	 * like {@link mergeAll}. However, when a new inner Observable is emitted,
	 * `switch` unsubscribes from the earlier-emitted inner Observable and
	 * subscribes to the new inner Observable and begins emitting items from it. It
	 * continues to behave like this for subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * // Each click event is mapped to an Observable that ticks every second
	 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
	 * var switched = higherOrder.switch();
	 * // The outcome is that `switched` is essentially a timer that restarts
	 * // on every click. The interval Observables from older clicks do not merge
	 * // with the current interval Observable.
	 * switched.subscribe(x => console.log(x));
	 *
	 * @see {@link combineAll}
	 * @see {@link concatAll}
	 * @see {@link exhaust}
	 * @see {@link mergeAll}
	 * @see {@link switchMap}
	 * @see {@link switchMapTo}
	 * @see {@link zipAll}
	 *
	 * @return {Observable<T>} An Observable that emits the items emitted by the
	 * Observable most recently emitted by the source Observable.
	 * @method switch
	 * @name switch
	 * @owner Observable
	 */
	function _switch() {
	    return switchAll_1.switchAll()(this);
	}
	exports._switch = _switch;
	//# sourceMappingURL=switch.js.map

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(876);
	var identity_1 = __webpack_require__(550);
	function switchAll() {
	    return switchMap_1.switchMap(identity_1.identity);
	}
	exports.switchAll = switchAll;
	//# sourceMappingURL=switchAll.js.map

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return function switchMapOperatorFunction(source) {
	        return source.lift(new SwitchMapOperator(project, resultSelector));
	    };
	}
	exports.switchMap = switchMap;
	var SwitchMapOperator = (function () {
	    function SwitchMapOperator(project, resultSelector) {
	        this.project = project;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
	    };
	    return SwitchMapOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapSubscriber = (function (_super) {
	    __extends(SwitchMapSubscriber, _super);
	    function SwitchMapSubscriber(destination, project, resultSelector) {
	        _super.call(this, destination);
	        this.project = project;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapSubscriber.prototype._next = function (value) {
	        var result;
	        var index = this.index++;
	        try {
	            result = this.project(value, index);
	        }
	        catch (error) {
	            this.destination.error(error);
	            return;
	        }
	        this._innerSub(result, value, index);
	    };
	    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
	    };
	    SwitchMapSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (this.resultSelector) {
	            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            this.destination.next(innerValue);
	        }
	    };
	    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var result;
	        try {
	            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return SwitchMapSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var switchMap_1 = __webpack_require__(878);
	Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMap_1 = __webpack_require__(876);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to an Observable which is merged in the output
	 * Observable, emitting values only from the most recently projected Observable.
	 *
	 * <span class="informal">Maps each value to an Observable, then flattens all of
	 * these inner Observables using {@link switch}.</span>
	 *
	 * <img src="./img/switchMap.png" width="100%">
	 *
	 * Returns an Observable that emits items based on applying a function that you
	 * supply to each item emitted by the source Observable, where that function
	 * returns an (so-called "inner") Observable. Each time it observes one of these
	 * inner Observables, the output Observable begins emitting the items emitted by
	 * that inner Observable. When a new inner Observable is emitted, `switchMap`
	 * stops emitting items from the earlier-emitted inner Observable and begins
	 * emitting items from the new one. It continues to behave like this for
	 * subsequent inner Observables.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMap}
	 * @see {@link exhaustMap}
	 * @see {@link mergeMap}
	 * @see {@link switch}
	 * @see {@link switchMapTo}
	 *
	 * @param {function(value: T, ?index: number): ObservableInput} project A function
	 * that, when applied to an item emitted by the source Observable, returns an
	 * Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits the result of applying the
	 * projection function (and the optional `resultSelector`) to each item emitted
	 * by the source Observable and taking only the values from the most recently
	 * projected inner Observable.
	 * @method switchMap
	 * @owner Observable
	 */
	function switchMap(project, resultSelector) {
	    return switchMap_1.switchMap(project, resultSelector)(this);
	}
	exports.switchMap = switchMap;
	//# sourceMappingURL=switchMap.js.map

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var switchMapTo_1 = __webpack_require__(880);
	Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var switchMapTo_1 = __webpack_require__(881);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return switchMapTo_1.switchMapTo(innerObservable, resultSelector)(this);
	}
	exports.switchMapTo = switchMapTo;
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Projects each source value to the same Observable which is flattened multiple
	 * times with {@link switch} in the output Observable.
	 *
	 * <span class="informal">It's like {@link switchMap}, but maps each value
	 * always to the same inner Observable.</span>
	 *
	 * <img src="./img/switchMapTo.png" width="100%">
	 *
	 * Maps each source value to the given Observable `innerObservable` regardless
	 * of the source value, and then flattens those resulting Observables into one
	 * single Observable, which is the output Observable. The output Observables
	 * emits values only from the most recently emitted instance of
	 * `innerObservable`.
	 *
	 * @example <caption>Rerun an interval Observable on every click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link concatMapTo}
	 * @see {@link switch}
	 * @see {@link switchMap}
	 * @see {@link mergeMapTo}
	 *
	 * @param {ObservableInput} innerObservable An Observable to replace each value from
	 * the source Observable.
	 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
	 * A function to produce the value on the output Observable based on the values
	 * and the indices of the source (outer) emission and the inner Observable
	 * emission. The arguments passed to this function are:
	 * - `outerValue`: the value that came from the source
	 * - `innerValue`: the value that came from the projected Observable
	 * - `outerIndex`: the "index" of the value that came from the source
	 * - `innerIndex`: the "index" of the value from the projected Observable
	 * @return {Observable} An Observable that emits items from the given
	 * `innerObservable` (and optionally transformed through `resultSelector`) every
	 * time a value is emitted on the source Observable, and taking only the values
	 * from the most recently projected inner Observable.
	 * @method switchMapTo
	 * @owner Observable
	 */
	function switchMapTo(innerObservable, resultSelector) {
	    return function (source) { return source.lift(new SwitchMapToOperator(innerObservable, resultSelector)); };
	}
	exports.switchMapTo = switchMapTo;
	var SwitchMapToOperator = (function () {
	    function SwitchMapToOperator(observable, resultSelector) {
	        this.observable = observable;
	        this.resultSelector = resultSelector;
	    }
	    SwitchMapToOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
	    };
	    return SwitchMapToOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var SwitchMapToSubscriber = (function (_super) {
	    __extends(SwitchMapToSubscriber, _super);
	    function SwitchMapToSubscriber(destination, inner, resultSelector) {
	        _super.call(this, destination);
	        this.inner = inner;
	        this.resultSelector = resultSelector;
	        this.index = 0;
	    }
	    SwitchMapToSubscriber.prototype._next = function (value) {
	        var innerSubscription = this.innerSubscription;
	        if (innerSubscription) {
	            innerSubscription.unsubscribe();
	        }
	        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
	    };
	    SwitchMapToSubscriber.prototype._complete = function () {
	        var innerSubscription = this.innerSubscription;
	        if (!innerSubscription || innerSubscription.closed) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function () {
	        this.innerSubscription = null;
	    };
	    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.remove(innerSub);
	        this.innerSubscription = null;
	        if (this.isStopped) {
	            _super.prototype._complete.call(this);
	        }
	    };
	    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        if (resultSelector) {
	            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        else {
	            destination.next(innerValue);
	        }
	    };
	    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
	        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
	        var result;
	        try {
	            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        destination.next(result);
	    };
	    return SwitchMapToSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=switchMapTo.js.map

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var take_1 = __webpack_require__(883);
	Observable_1.Observable.prototype.take = take_1.take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var take_1 = __webpack_require__(884);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return take_1.take(count)(this);
	}
	exports.take = take;
	//# sourceMappingURL=take.js.map

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var ArgumentOutOfRangeError_1 = __webpack_require__(705);
	var EmptyObservable_1 = __webpack_require__(529);
	/**
	 * Emits only the first `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Takes the first `count` values from the source, then
	 * completes.</span>
	 *
	 * <img src="./img/take.png" width="100%">
	 *
	 * `take` returns an Observable that emits only the first `count` values emitted
	 * by the source Observable. If the source emits fewer than `count` values then
	 * all of its values are emitted. After that, it completes, regardless if the
	 * source completes.
	 *
	 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var five = interval.take(5);
	 * five.subscribe(x => console.log(x));
	 *
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of `next` values to emit.
	 * @return {Observable<T>} An Observable that emits only the first `count`
	 * values emitted by the source Observable, or all of the values from the source
	 * if the source emits fewer than `count` values.
	 * @method take
	 * @owner Observable
	 */
	function take(count) {
	    return function (source) {
	        if (count === 0) {
	            return new EmptyObservable_1.EmptyObservable();
	        }
	        else {
	            return source.lift(new TakeOperator(count));
	        }
	    };
	}
	exports.take = take;
	var TakeOperator = (function () {
	    function TakeOperator(total) {
	        this.total = total;
	        if (this.total < 0) {
	            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
	        }
	    }
	    TakeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeSubscriber(subscriber, this.total));
	    };
	    return TakeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeSubscriber = (function (_super) {
	    __extends(TakeSubscriber, _super);
	    function TakeSubscriber(destination, total) {
	        _super.call(this, destination);
	        this.total = total;
	        this.count = 0;
	    }
	    TakeSubscriber.prototype._next = function (value) {
	        var total = this.total;
	        var count = ++this.count;
	        if (count <= total) {
	            this.destination.next(value);
	            if (count === total) {
	                this.destination.complete();
	                this.unsubscribe();
	            }
	        }
	    };
	    return TakeSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=take.js.map

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var takeLast_1 = __webpack_require__(886);
	Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeLast_1 = __webpack_require__(761);
	/**
	 * Emits only the last `count` values emitted by the source Observable.
	 *
	 * <span class="informal">Remembers the latest `count` values, then emits those
	 * only when the source completes.</span>
	 *
	 * <img src="./img/takeLast.png" width="100%">
	 *
	 * `takeLast` returns an Observable that emits at most the last `count` values
	 * emitted by the source Observable. If the source emits fewer than `count`
	 * values then all of its values are emitted. This operator must wait until the
	 * `complete` notification emission from the source in order to emit the `next`
	 * values on the output Observable, because otherwise it is impossible to know
	 * whether or not more values will be emitted on the source. For this reason,
	 * all values are emitted synchronously, followed by the complete notification.
	 *
	 * @example <caption>Take the last 3 values of an Observable with many values</caption>
	 * var many = Rx.Observable.range(1, 100);
	 * var lastThree = many.takeLast(3);
	 * lastThree.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeUntil}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
	 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
	 *
	 * @param {number} count The maximum number of values to emit from the end of
	 * the sequence of values emitted by the source Observable.
	 * @return {Observable<T>} An Observable that emits at most the last count
	 * values emitted by the source Observable.
	 * @method takeLast
	 * @owner Observable
	 */
	function takeLast(count) {
	    return takeLast_1.takeLast(count)(this);
	}
	exports.takeLast = takeLast;
	//# sourceMappingURL=takeLast.js.map

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var takeUntil_1 = __webpack_require__(888);
	Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeUntil_1 = __webpack_require__(889);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value, the output Observable stops mirroring the source Observable
	 * and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return takeUntil_1.takeUntil(notifier)(this);
	}
	exports.takeUntil = takeUntil;
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Emits the values emitted by the source Observable until a `notifier`
	 * Observable emits a value.
	 *
	 * <span class="informal">Lets values pass until a second Observable,
	 * `notifier`, emits something. Then, it completes.</span>
	 *
	 * <img src="./img/takeUntil.png" width="100%">
	 *
	 * `takeUntil` subscribes and begins mirroring the source Observable. It also
	 * monitors a second Observable, `notifier` that you provide. If the `notifier`
	 * emits a value or a complete notification, the output Observable stops
	 * mirroring the source Observable and completes.
	 *
	 * @example <caption>Tick every second until the first click happens</caption>
	 * var interval = Rx.Observable.interval(1000);
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = interval.takeUntil(clicks);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeWhile}
	 * @see {@link skip}
	 *
	 * @param {Observable} notifier The Observable whose first emitted value will
	 * cause the output Observable of `takeUntil` to stop emitting values from the
	 * source Observable.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable until such time as `notifier` emits its first value.
	 * @method takeUntil
	 * @owner Observable
	 */
	function takeUntil(notifier) {
	    return function (source) { return source.lift(new TakeUntilOperator(notifier)); };
	}
	exports.takeUntil = takeUntil;
	var TakeUntilOperator = (function () {
	    function TakeUntilOperator(notifier) {
	        this.notifier = notifier;
	    }
	    TakeUntilOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
	    };
	    return TakeUntilOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeUntilSubscriber = (function (_super) {
	    __extends(TakeUntilSubscriber, _super);
	    function TakeUntilSubscriber(destination, notifier) {
	        _super.call(this, destination);
	        this.notifier = notifier;
	        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
	    }
	    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.complete();
	    };
	    TakeUntilSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    return TakeUntilSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=takeUntil.js.map

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var takeWhile_1 = __webpack_require__(891);
	Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var takeWhile_1 = __webpack_require__(892);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return takeWhile_1.takeWhile(predicate)(this);
	}
	exports.takeWhile = takeWhile;
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	/**
	 * Emits values emitted by the source Observable so long as each value satisfies
	 * the given `predicate`, and then completes as soon as this `predicate` is not
	 * satisfied.
	 *
	 * <span class="informal">Takes values from the source only while they pass the
	 * condition given. When the first value does not satisfy, it completes.</span>
	 *
	 * <img src="./img/takeWhile.png" width="100%">
	 *
	 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
	 * emitted on the source is given to the `predicate` function which returns a
	 * boolean, representing a condition to be satisfied by the source values. The
	 * output Observable emits the source values until such time as the `predicate`
	 * returns false, at which point `takeWhile` stops mirroring the source
	 * Observable and completes the output Observable.
	 *
	 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.takeWhile(ev => ev.clientX > 200);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link take}
	 * @see {@link takeLast}
	 * @see {@link takeUntil}
	 * @see {@link skip}
	 *
	 * @param {function(value: T, index: number): boolean} predicate A function that
	 * evaluates a value emitted by the source Observable and returns a boolean.
	 * Also takes the (zero-based) index as the second argument.
	 * @return {Observable<T>} An Observable that emits the values from the source
	 * Observable so long as each value satisfies the condition defined by the
	 * `predicate`, then completes.
	 * @method takeWhile
	 * @owner Observable
	 */
	function takeWhile(predicate) {
	    return function (source) { return source.lift(new TakeWhileOperator(predicate)); };
	}
	exports.takeWhile = takeWhile;
	var TakeWhileOperator = (function () {
	    function TakeWhileOperator(predicate) {
	        this.predicate = predicate;
	    }
	    TakeWhileOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
	    };
	    return TakeWhileOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TakeWhileSubscriber = (function (_super) {
	    __extends(TakeWhileSubscriber, _super);
	    function TakeWhileSubscriber(destination, predicate) {
	        _super.call(this, destination);
	        this.predicate = predicate;
	        this.index = 0;
	    }
	    TakeWhileSubscriber.prototype._next = function (value) {
	        var destination = this.destination;
	        var result;
	        try {
	            result = this.predicate(value, this.index++);
	        }
	        catch (err) {
	            destination.error(err);
	            return;
	        }
	        this.nextOrComplete(value, result);
	    };
	    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
	        var destination = this.destination;
	        if (Boolean(predicateResult)) {
	            destination.next(value);
	        }
	        else {
	            destination.complete();
	        }
	    };
	    return TakeWhileSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=takeWhile.js.map

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var throttle_1 = __webpack_require__(894);
	Observable_1.Observable.prototype.throttle = throttle_1.throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var throttle_1 = __webpack_require__(895);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttle_1.throttle(durationSelector, config)(this);
	}
	exports.throttle = throttle;
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	exports.defaultThrottleConfig = {
	    leading: true,
	    trailing: false
	};
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for a duration determined by another Observable, then repeats this
	 * process.
	 *
	 * <span class="informal">It's like {@link throttleTime}, but the silencing
	 * duration is determined by a second Observable.</span>
	 *
	 * <img src="./img/throttle.png" width="100%">
	 *
	 * `throttle` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled by calling the `durationSelector` function with the source value,
	 * which returns the "duration" Observable. When the duration Observable emits a
	 * value or completes, the timer is disabled, and this process repeats for the
	 * next source value.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link audit}
	 * @see {@link debounce}
	 * @see {@link delayWhen}
	 * @see {@link sample}
	 * @see {@link throttleTime}
	 *
	 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
	 * that receives a value from the source Observable, for computing the silencing
	 * duration for each source value, returned as an Observable or a Promise.
	 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
	 * to `{ leading: true, trailing: false }`.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttle
	 * @owner Observable
	 */
	function throttle(durationSelector, config) {
	    if (config === void 0) { config = exports.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleOperator(durationSelector, config.leading, config.trailing)); };
	}
	exports.throttle = throttle;
	var ThrottleOperator = (function () {
	    function ThrottleOperator(durationSelector, leading, trailing) {
	        this.durationSelector = durationSelector;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
	    };
	    return ThrottleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleSubscriber = (function (_super) {
	    __extends(ThrottleSubscriber, _super);
	    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.durationSelector = durationSelector;
	        this._leading = _leading;
	        this._trailing = _trailing;
	        this._hasTrailingValue = false;
	    }
	    ThrottleSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this._trailing) {
	                this._hasTrailingValue = true;
	                this._trailingValue = value;
	            }
	        }
	        else {
	            var duration = this.tryDurationSelector(value);
	            if (duration) {
	                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
	            }
	            if (this._leading) {
	                this.destination.next(value);
	                if (this._trailing) {
	                    this._hasTrailingValue = true;
	                    this._trailingValue = value;
	                }
	            }
	        }
	    };
	    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
	        try {
	            return this.durationSelector(value);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return null;
	        }
	    };
	    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function () {
	        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
	        this._trailingValue = null;
	        this._hasTrailingValue = false;
	        if (throttled) {
	            this.remove(throttled);
	            this.throttled = null;
	            throttled.unsubscribe();
	        }
	    };
	    ThrottleSubscriber.prototype._sendTrailing = function () {
	        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
	        if (throttled && _trailing && _hasTrailingValue) {
	            destination.next(_trailingValue);
	            this._trailingValue = null;
	            this._hasTrailingValue = false;
	        }
	    };
	    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    ThrottleSubscriber.prototype.notifyComplete = function () {
	        this._sendTrailing();
	        this._unsubscribe();
	    };
	    return ThrottleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=throttle.js.map

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var throttleTime_1 = __webpack_require__(897);
	Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var throttle_1 = __webpack_require__(895);
	var throttleTime_1 = __webpack_require__(898);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return throttleTime_1.throttleTime(duration, scheduler, config)(this);
	}
	exports.throttleTime = throttleTime;
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var async_1 = __webpack_require__(578);
	var throttle_1 = __webpack_require__(895);
	/**
	 * Emits a value from the source Observable, then ignores subsequent source
	 * values for `duration` milliseconds, then repeats this process.
	 *
	 * <span class="informal">Lets a value pass, then ignores source values for the
	 * next `duration` milliseconds.</span>
	 *
	 * <img src="./img/throttleTime.png" width="100%">
	 *
	 * `throttleTime` emits the source Observable values on the output Observable
	 * when its internal timer is disabled, and ignores source values when the timer
	 * is enabled. Initially, the timer is disabled. As soon as the first source
	 * value arrives, it is forwarded to the output Observable, and then the timer
	 * is enabled. After `duration` milliseconds (or the time unit determined
	 * internally by the optional `scheduler`) has passed, the timer is disabled,
	 * and this process repeats for the next source value. Optionally takes a
	 * {@link IScheduler} for managing timers.
	 *
	 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.throttleTime(1000);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link auditTime}
	 * @see {@link debounceTime}
	 * @see {@link delay}
	 * @see {@link sampleTime}
	 * @see {@link throttle}
	 *
	 * @param {number} duration Time to wait before emitting another value after
	 * emitting the last value, measured in milliseconds or the time unit determined
	 * internally by the optional `scheduler`.
	 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
	 * managing the timers that handle the throttling.
	 * @return {Observable<T>} An Observable that performs the throttle operation to
	 * limit the rate of emissions from the source.
	 * @method throttleTime
	 * @owner Observable
	 */
	function throttleTime(duration, scheduler, config) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    if (config === void 0) { config = throttle_1.defaultThrottleConfig; }
	    return function (source) { return source.lift(new ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing)); };
	}
	exports.throttleTime = throttleTime;
	var ThrottleTimeOperator = (function () {
	    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	    }
	    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
	    };
	    return ThrottleTimeOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ThrottleTimeSubscriber = (function (_super) {
	    __extends(ThrottleTimeSubscriber, _super);
	    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
	        _super.call(this, destination);
	        this.duration = duration;
	        this.scheduler = scheduler;
	        this.leading = leading;
	        this.trailing = trailing;
	        this._hasTrailingValue = false;
	        this._trailingValue = null;
	    }
	    ThrottleTimeSubscriber.prototype._next = function (value) {
	        if (this.throttled) {
	            if (this.trailing) {
	                this._trailingValue = value;
	                this._hasTrailingValue = true;
	            }
	        }
	        else {
	            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
	            if (this.leading) {
	                this.destination.next(value);
	            }
	        }
	    };
	    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
	        var throttled = this.throttled;
	        if (throttled) {
	            if (this.trailing && this._hasTrailingValue) {
	                this.destination.next(this._trailingValue);
	                this._trailingValue = null;
	                this._hasTrailingValue = false;
	            }
	            throttled.unsubscribe();
	            this.remove(throttled);
	            this.throttled = null;
	        }
	    };
	    return ThrottleTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchNext(arg) {
	    var subscriber = arg.subscriber;
	    subscriber.clearThrottle();
	}
	//# sourceMappingURL=throttleTime.js.map

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var timeInterval_1 = __webpack_require__(900);
	Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var timeInterval_1 = __webpack_require__(901);
	exports.TimeInterval = timeInterval_1.TimeInterval;
	/**
	 * @param scheduler
	 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timeInterval
	 * @owner Observable
	 */
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeInterval_1.timeInterval(scheduler)(this);
	}
	exports.timeInterval = timeInterval;
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var async_1 = __webpack_require__(578);
	function timeInterval(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) { return source.lift(new TimeIntervalOperator(scheduler)); };
	}
	exports.timeInterval = timeInterval;
	var TimeInterval = (function () {
	    function TimeInterval(value, interval) {
	        this.value = value;
	        this.interval = interval;
	    }
	    return TimeInterval;
	}());
	exports.TimeInterval = TimeInterval;
	;
	var TimeIntervalOperator = (function () {
	    function TimeIntervalOperator(scheduler) {
	        this.scheduler = scheduler;
	    }
	    TimeIntervalOperator.prototype.call = function (observer, source) {
	        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
	    };
	    return TimeIntervalOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeIntervalSubscriber = (function (_super) {
	    __extends(TimeIntervalSubscriber, _super);
	    function TimeIntervalSubscriber(destination, scheduler) {
	        _super.call(this, destination);
	        this.scheduler = scheduler;
	        this.lastTime = 0;
	        this.lastTime = scheduler.now();
	    }
	    TimeIntervalSubscriber.prototype._next = function (value) {
	        var now = this.scheduler.now();
	        var span = now - this.lastTime;
	        this.lastTime = now;
	        this.destination.next(new TimeInterval(value, span));
	    };
	    return TimeIntervalSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeInterval.js.map

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var timeout_1 = __webpack_require__(903);
	Observable_1.Observable.prototype.timeout = timeout_1.timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var timeout_1 = __webpack_require__(904);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeout_1.timeout(due, scheduler)(this);
	}
	exports.timeout = timeout;
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(578);
	var isDate_1 = __webpack_require__(609);
	var Subscriber_1 = __webpack_require__(502);
	var TimeoutError_1 = __webpack_require__(905);
	/**
	 *
	 * Errors if Observable does not emit a value in given time span.
	 *
	 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
	 *
	 * <img src="./img/timeout.png" width="100%">
	 *
	 * `timeout` operator accepts as an argument either a number or a Date.
	 *
	 * If number was provided, it returns an Observable that behaves like a source
	 * Observable, unless there is a period of time where there is no value emitted.
	 * So if you provide `100` as argument and first value comes after 50ms from
	 * the moment of subscription, this value will be simply re-emitted by the resulting
	 * Observable. If however after that 100ms passes without a second value being emitted,
	 * stream will end with an error and source Observable will be unsubscribed.
	 * These checks are performed throughout whole lifecycle of Observable - from the moment
	 * it was subscribed to, until it completes or errors itself. Thus every value must be
	 * emitted within specified period since previous value.
	 *
	 * If provided argument was Date, returned Observable behaves differently. It throws
	 * if Observable did not complete before provided Date. This means that periods between
	 * emission of particular values do not matter in this case. If Observable did not complete
	 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
	 * stream behaves just as source Observable.
	 *
	 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
	 * when returned Observable will check if source stream emitted value or completed.
	 *
	 * @example <caption>Check if ticks are emitted within certain timespan</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
	 *                       // since `interval` might fire a bit later then scheduled.
	 * .subscribe(
	 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
	 *     err => console.log(err) // Will never be called.
	 * );
	 *
	 * seconds.timeout(900).subscribe(
	 *     value => console.log(value), // Will never be called.
	 *     err => console.log(err) // Will emit error before even first value is emitted,
	 *                             // since it did not arrive within 900ms period.
	 * );
	 *
	 * @example <caption>Use Date to check if Observable completed</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 *
	 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
	 * .subscribe(
	 *     value => console.log(value), // Will emit values as regular `interval` would
	 *                                  // until December 17, 2020 at 03:24:00.
	 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
	 *                             // since Observable did not complete by then.
	 * );
	 *
	 * @see {@link timeoutWith}
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
	 * @method timeout
	 * @owner Observable
	 */
	function timeout(due, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    var absoluteTimeout = isDate_1.isDate(due);
	    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	    return function (source) { return source.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError())); };
	}
	exports.timeout = timeout;
	var TimeoutOperator = (function () {
	    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	    }
	    TimeoutOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
	    };
	    return TimeoutOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutSubscriber = (function (_super) {
	    __extends(TimeoutSubscriber, _super);
	    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.scheduler = scheduler;
	        this.errorInstance = errorInstance;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
	        subscriber.error(subscriber.errorInstance);
	    };
	    TimeoutSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.errorInstance = null;
	    };
	    return TimeoutSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=timeout.js.map

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	/**
	 * An error thrown when duetime elapses.
	 *
	 * @see {@link timeout}
	 *
	 * @class TimeoutError
	 */
	var TimeoutError = (function (_super) {
	    __extends(TimeoutError, _super);
	    function TimeoutError() {
	        var err = _super.call(this, 'Timeout has occurred');
	        this.name = err.name = 'TimeoutError';
	        this.stack = err.stack;
	        this.message = err.message;
	    }
	    return TimeoutError;
	}(Error));
	exports.TimeoutError = TimeoutError;
	//# sourceMappingURL=TimeoutError.js.map

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var timeoutWith_1 = __webpack_require__(907);
	Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var timeoutWith_1 = __webpack_require__(908);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timeoutWith_1.timeoutWith(due, withObservable, scheduler)(this);
	}
	exports.timeoutWith = timeoutWith;
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var async_1 = __webpack_require__(578);
	var isDate_1 = __webpack_require__(609);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 *
	 * Errors if Observable does not emit a value in given time span, in case of which
	 * subscribes to the second Observable.
	 *
	 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
	 *
	 * <img src="./img/timeoutWith.png" width="100%">
	 *
	 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
	 * still accepting as a first argument either a number or a Date, which control - respectively -
	 * when values of source Observable should be emitted or when it should complete.
	 *
	 * The only difference is that it accepts a second, required parameter. This parameter
	 * should be an Observable which will be subscribed when source Observable fails any timeout check.
	 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
	 * values from second Observable. Note that this fallback Observable is not checked for timeouts
	 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
	 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
	 * stream completes, it completes as well.
	 *
	 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
	 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
	 * as a consequence - when second Observable will be subscribed, since subscription happens
	 * immediately after failing check.
	 *
	 * @example <caption>Add fallback observable</caption>
	 * const seconds = Rx.Observable.interval(1000);
	 * const minutes = Rx.Observable.interval(60 * 1000);
	 *
	 * seconds.timeoutWith(900, minutes)
	 *     .subscribe(
	 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
	 *                                      // since first value of `seconds` will not arrive fast enough.
	 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
	 *                                 // but here will never be called.
	 *     );
	 *
	 * @param {number|Date} due Number specifying period within which Observable must emit values
	 *                          or Date specifying before when Observable should complete
	 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
	 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
	 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
	 *                          passed as a second parameter.
	 * @method timeoutWith
	 * @owner Observable
	 */
	function timeoutWith(due, withObservable, scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return function (source) {
	        var absoluteTimeout = isDate_1.isDate(due);
	        var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
	        return source.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
	    };
	}
	exports.timeoutWith = timeoutWith;
	var TimeoutWithOperator = (function () {
	    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
	        this.waitFor = waitFor;
	        this.absoluteTimeout = absoluteTimeout;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	    }
	    TimeoutWithOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
	    };
	    return TimeoutWithOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var TimeoutWithSubscriber = (function (_super) {
	    __extends(TimeoutWithSubscriber, _super);
	    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
	        _super.call(this, destination);
	        this.absoluteTimeout = absoluteTimeout;
	        this.waitFor = waitFor;
	        this.withObservable = withObservable;
	        this.scheduler = scheduler;
	        this.action = null;
	        this.scheduleTimeout();
	    }
	    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
	        var withObservable = subscriber.withObservable;
	        subscriber._unsubscribeAndRecycle();
	        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
	    };
	    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
	        var action = this.action;
	        if (action) {
	            // Recycle the action if we've already scheduled one. All the production
	            // Scheduler Actions mutate their state/delay time and return themeselves.
	            // VirtualActions are immutable, so they create and return a clone. In this
	            // case, we need to set the action reference to the most recent VirtualAction,
	            // to ensure that's the one we clone from next time.
	            this.action = action.schedule(this, this.waitFor);
	        }
	        else {
	            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
	        }
	    };
	    TimeoutWithSubscriber.prototype._next = function (value) {
	        if (!this.absoluteTimeout) {
	            this.scheduleTimeout();
	        }
	        _super.prototype._next.call(this, value);
	    };
	    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function () {
	        this.action = null;
	        this.scheduler = null;
	        this.withObservable = null;
	    };
	    return TimeoutWithSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=timeoutWith.js.map

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var timestamp_1 = __webpack_require__(910);
	Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var timestamp_1 = __webpack_require__(911);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return timestamp_1.timestamp(scheduler)(this);
	}
	exports.timestamp = timestamp;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var map_1 = __webpack_require__(616);
	/**
	 * @param scheduler
	 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
	 * @method timestamp
	 * @owner Observable
	 */
	function timestamp(scheduler) {
	    if (scheduler === void 0) { scheduler = async_1.async; }
	    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
	    // return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
	}
	exports.timestamp = timestamp;
	var Timestamp = (function () {
	    function Timestamp(value, timestamp) {
	        this.value = value;
	        this.timestamp = timestamp;
	    }
	    return Timestamp;
	}());
	exports.Timestamp = Timestamp;
	;
	//# sourceMappingURL=timestamp.js.map

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var toArray_1 = __webpack_require__(913);
	Observable_1.Observable.prototype.toArray = toArray_1.toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var toArray_1 = __webpack_require__(914);
	/**
	 * Collects all source emissions and emits them as an array when the source completes.
	 *
	 * <span class="informal">Get all values inside an array when the source completes</span>
	 *
	 * <img src="./img/toArray.png" width="100%">
	 *
	 * `toArray` will wait until the source Observable completes
	 * before emitting the array containing all emissions.
	 * When the source Observable errors no array will be emitted.
	 *
	 * @example <caption>Create array from input</caption>
	 * const input = Rx.Observable.interval(100).take(4);
	 *
	 * input.toArray()
	 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
	 *
	 * @see {@link buffer}
	 *
	 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
	 * @method toArray
	 * @owner Observable
	 */
	function toArray() {
	    return toArray_1.toArray()(this);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var reduce_1 = __webpack_require__(759);
	function toArrayReducer(arr, item, index) {
	    if (index === 0) {
	        return [item];
	    }
	    arr.push(item);
	    return arr;
	}
	function toArray() {
	    return reduce_1.reduce(toArrayReducer, []);
	}
	exports.toArray = toArray;
	//# sourceMappingURL=toArray.js.map

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
	// leaving this module here to prevent breakage.
	//# sourceMappingURL=toPromise.js.map

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var window_1 = __webpack_require__(917);
	Observable_1.Observable.prototype.window = window_1.window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var window_1 = __webpack_require__(918);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return window_1.window(windowBoundaries)(this);
	}
	exports.window = window;
	//# sourceMappingURL=window.js.map

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Branch out the source Observable values as a nested Observable whenever
	 * `windowBoundaries` emits.
	 *
	 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
	 * instead of an array.</span>
	 *
	 * <img src="./img/window.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping
	 * windows. It emits the current window and opens a new one whenever the
	 * Observable `windowBoundaries` emits an item. Because each window is an
	 * Observable, the output is a higher-order Observable.
	 *
	 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var interval = Rx.Observable.interval(1000);
	 * var result = clicks.window(interval)
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link buffer}
	 *
	 * @param {Observable<any>} windowBoundaries An Observable that completes the
	 * previous window and starts a new window.
	 * @return {Observable<Observable<T>>} An Observable of windows, which are
	 * Observables emitting values of the source Observable.
	 * @method window
	 * @owner Observable
	 */
	function window(windowBoundaries) {
	    return function windowOperatorFunction(source) {
	        return source.lift(new WindowOperator(windowBoundaries));
	    };
	}
	exports.window = window;
	var WindowOperator = (function () {
	    function WindowOperator(windowBoundaries) {
	        this.windowBoundaries = windowBoundaries;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        var windowSubscriber = new WindowSubscriber(subscriber);
	        var sourceSubscription = source.subscribe(windowSubscriber);
	        if (!sourceSubscription.closed) {
	            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
	        }
	        return sourceSubscription;
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination) {
	        _super.call(this, destination);
	        this.window = new Subject_1.Subject();
	        destination.next(this.window);
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow();
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this._complete();
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	    };
	    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function () {
	        this.window = null;
	    };
	    WindowSubscriber.prototype.openWindow = function () {
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var destination = this.destination;
	        var newWindow = this.window = new Subject_1.Subject();
	        destination.next(newWindow);
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=window.js.map

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var windowCount_1 = __webpack_require__(920);
	Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowCount_1 = __webpack_require__(921);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return windowCount_1.windowCount(windowSize, startWindowEvery)(this);
	}
	exports.windowCount = windowCount;
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subscriber_1 = __webpack_require__(502);
	var Subject_1 = __webpack_require__(498);
	/**
	 * Branch out the source Observable values as a nested Observable with each
	 * nested Observable emitting at most `windowSize` values.
	 *
	 * <span class="informal">It's like {@link bufferCount}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowCount.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows every `startWindowEvery`
	 * items, each containing no more than `windowSize` items. When the source
	 * Observable completes or encounters an error, the output Observable emits
	 * the current window and propagates the notification from the source
	 * Observable. If `startWindowEvery` is not provided, then new windows are
	 * started immediately at the start of the source and when each window completes
	 * with size `windowSize`.
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(3)
	 *   .map(win => win.skip(1)) // skip first of every 3 clicks
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks.windowCount(2, 3)
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link windowWhen}
	 * @see {@link bufferCount}
	 *
	 * @param {number} windowSize The maximum number of values emitted by each
	 * window.
	 * @param {number} [startWindowEvery] Interval at which to start a new window.
	 * For example if `startWindowEvery` is `2`, then a new window will be started
	 * on every other value from the source. A new window is started at the
	 * beginning of the source by default.
	 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
	 * are Observable of values.
	 * @method windowCount
	 * @owner Observable
	 */
	function windowCount(windowSize, startWindowEvery) {
	    if (startWindowEvery === void 0) { startWindowEvery = 0; }
	    return function windowCountOperatorFunction(source) {
	        return source.lift(new WindowCountOperator(windowSize, startWindowEvery));
	    };
	}
	exports.windowCount = windowCount;
	var WindowCountOperator = (function () {
	    function WindowCountOperator(windowSize, startWindowEvery) {
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	    }
	    WindowCountOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
	    };
	    return WindowCountOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowCountSubscriber = (function (_super) {
	    __extends(WindowCountSubscriber, _super);
	    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowSize = windowSize;
	        this.startWindowEvery = startWindowEvery;
	        this.windows = [new Subject_1.Subject()];
	        this.count = 0;
	        destination.next(this.windows[0]);
	    }
	    WindowCountSubscriber.prototype._next = function (value) {
	        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
	        var destination = this.destination;
	        var windowSize = this.windowSize;
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len && !this.closed; i++) {
	            windows[i].next(value);
	        }
	        var c = this.count - windowSize + 1;
	        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
	            windows.shift().complete();
	        }
	        if (++this.count % startWindowEvery === 0 && !this.closed) {
	            var window_1 = new Subject_1.Subject();
	            windows.push(window_1);
	            destination.next(window_1);
	        }
	    };
	    WindowCountSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().error(err);
	            }
	        }
	        this.destination.error(err);
	    };
	    WindowCountSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        if (windows) {
	            while (windows.length > 0 && !this.closed) {
	                windows.shift().complete();
	            }
	        }
	        this.destination.complete();
	    };
	    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function () {
	        this.count = 0;
	        this.windows = null;
	    };
	    return WindowCountSubscriber;
	}(Subscriber_1.Subscriber));
	//# sourceMappingURL=windowCount.js.map

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var windowTime_1 = __webpack_require__(923);
	Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var async_1 = __webpack_require__(578);
	var isNumeric_1 = __webpack_require__(577);
	var isScheduler_1 = __webpack_require__(526);
	var windowTime_1 = __webpack_require__(924);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return windowTime_1.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
	}
	exports.windowTime = windowTime;
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var async_1 = __webpack_require__(578);
	var Subscriber_1 = __webpack_require__(502);
	var isNumeric_1 = __webpack_require__(577);
	var isScheduler_1 = __webpack_require__(526);
	function windowTime(windowTimeSpan) {
	    var scheduler = async_1.async;
	    var windowCreationInterval = null;
	    var maxWindowSize = Number.POSITIVE_INFINITY;
	    if (isScheduler_1.isScheduler(arguments[3])) {
	        scheduler = arguments[3];
	    }
	    if (isScheduler_1.isScheduler(arguments[2])) {
	        scheduler = arguments[2];
	    }
	    else if (isNumeric_1.isNumeric(arguments[2])) {
	        maxWindowSize = arguments[2];
	    }
	    if (isScheduler_1.isScheduler(arguments[1])) {
	        scheduler = arguments[1];
	    }
	    else if (isNumeric_1.isNumeric(arguments[1])) {
	        windowCreationInterval = arguments[1];
	    }
	    return function windowTimeOperatorFunction(source) {
	        return source.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
	    };
	}
	exports.windowTime = windowTime;
	var WindowTimeOperator = (function () {
	    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	    }
	    WindowTimeOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
	    };
	    return WindowTimeOperator;
	}());
	var CountedSubject = (function (_super) {
	    __extends(CountedSubject, _super);
	    function CountedSubject() {
	        _super.apply(this, arguments);
	        this._numberOfNextedValues = 0;
	    }
	    CountedSubject.prototype.next = function (value) {
	        this._numberOfNextedValues++;
	        _super.prototype.next.call(this, value);
	    };
	    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
	        get: function () {
	            return this._numberOfNextedValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return CountedSubject;
	}(Subject_1.Subject));
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowTimeSubscriber = (function (_super) {
	    __extends(WindowTimeSubscriber, _super);
	    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.windowTimeSpan = windowTimeSpan;
	        this.windowCreationInterval = windowCreationInterval;
	        this.maxWindowSize = maxWindowSize;
	        this.scheduler = scheduler;
	        this.windows = [];
	        var window = this.openWindow();
	        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
	            var closeState = { subscriber: this, window: window, context: null };
	            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
	            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
	            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
	        }
	        else {
	            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
	            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
	        }
	    }
	    WindowTimeSubscriber.prototype._next = function (value) {
	        var windows = this.windows;
	        var len = windows.length;
	        for (var i = 0; i < len; i++) {
	            var window_1 = windows[i];
	            if (!window_1.closed) {
	                window_1.next(value);
	                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
	                    this.closeWindow(window_1);
	                }
	            }
	        }
	    };
	    WindowTimeSubscriber.prototype._error = function (err) {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            windows.shift().error(err);
	        }
	        this.destination.error(err);
	    };
	    WindowTimeSubscriber.prototype._complete = function () {
	        var windows = this.windows;
	        while (windows.length > 0) {
	            var window_2 = windows.shift();
	            if (!window_2.closed) {
	                window_2.complete();
	            }
	        }
	        this.destination.complete();
	    };
	    WindowTimeSubscriber.prototype.openWindow = function () {
	        var window = new CountedSubject();
	        this.windows.push(window);
	        var destination = this.destination;
	        destination.next(window);
	        return window;
	    };
	    WindowTimeSubscriber.prototype.closeWindow = function (window) {
	        window.complete();
	        var windows = this.windows;
	        windows.splice(windows.indexOf(window), 1);
	    };
	    return WindowTimeSubscriber;
	}(Subscriber_1.Subscriber));
	function dispatchWindowTimeSpanOnly(state) {
	    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
	    if (window) {
	        subscriber.closeWindow(window);
	    }
	    state.window = subscriber.openWindow();
	    this.schedule(state, windowTimeSpan);
	}
	function dispatchWindowCreation(state) {
	    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
	    var window = subscriber.openWindow();
	    var action = this;
	    var context = { action: action, subscription: null };
	    var timeSpanState = { subscriber: subscriber, window: window, context: context };
	    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
	    action.add(context.subscription);
	    action.schedule(state, windowCreationInterval);
	}
	function dispatchWindowClose(state) {
	    var subscriber = state.subscriber, window = state.window, context = state.context;
	    if (context && context.action && context.subscription) {
	        context.action.remove(context.subscription);
	    }
	    subscriber.closeWindow(window);
	}
	//# sourceMappingURL=windowTime.js.map

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var windowToggle_1 = __webpack_require__(926);
	Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowToggle_1 = __webpack_require__(927);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return windowToggle_1.windowToggle(openings, closingSelector)(this);
	}
	exports.windowToggle = windowToggle;
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var Subscription_1 = __webpack_require__(504);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Branch out the source Observable values as a nested Observable starting from
	 * an emission from `openings` and ending when the output of `closingSelector`
	 * emits.
	 *
	 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowToggle.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits windows that contain those items
	 * emitted by the source Observable between the time when the `openings`
	 * Observable emits an item and when the Observable returned by
	 * `closingSelector` emits an item.
	 *
	 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var openings = Rx.Observable.interval(1000);
	 * var result = clicks.windowToggle(openings, i =>
	 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
	 * ).mergeAll();
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowWhen}
	 * @see {@link bufferToggle}
	 *
	 * @param {Observable<O>} openings An observable of notifications to start new
	 * windows.
	 * @param {function(value: O): Observable} closingSelector A function that takes
	 * the value emitted by the `openings` observable and returns an Observable,
	 * which, when it emits (either `next` or `complete`), signals that the
	 * associated window should complete.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowToggle
	 * @owner Observable
	 */
	function windowToggle(openings, closingSelector) {
	    return function (source) { return source.lift(new WindowToggleOperator(openings, closingSelector)); };
	}
	exports.windowToggle = windowToggle;
	var WindowToggleOperator = (function () {
	    function WindowToggleOperator(openings, closingSelector) {
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	    }
	    WindowToggleOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
	    };
	    return WindowToggleOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowToggleSubscriber = (function (_super) {
	    __extends(WindowToggleSubscriber, _super);
	    function WindowToggleSubscriber(destination, openings, closingSelector) {
	        _super.call(this, destination);
	        this.openings = openings;
	        this.closingSelector = closingSelector;
	        this.contexts = [];
	        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
	    }
	    WindowToggleSubscriber.prototype._next = function (value) {
	        var contexts = this.contexts;
	        if (contexts) {
	            var len = contexts.length;
	            for (var i = 0; i < len; i++) {
	                contexts[i].window.next(value);
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype._error = function (err) {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.error(err);
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._error.call(this, err);
	    };
	    WindowToggleSubscriber.prototype._complete = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.complete();
	                context.subscription.unsubscribe();
	            }
	        }
	        _super.prototype._complete.call(this);
	    };
	    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function () {
	        var contexts = this.contexts;
	        this.contexts = null;
	        if (contexts) {
	            var len = contexts.length;
	            var index = -1;
	            while (++index < len) {
	                var context = contexts[index];
	                context.window.unsubscribe();
	                context.subscription.unsubscribe();
	            }
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        if (outerValue === this.openings) {
	            var closingSelector = this.closingSelector;
	            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
	            if (closingNotifier === errorObject_1.errorObject) {
	                return this.error(errorObject_1.errorObject.e);
	            }
	            else {
	                var window_1 = new Subject_1.Subject();
	                var subscription = new Subscription_1.Subscription();
	                var context = { window: window_1, subscription: subscription };
	                this.contexts.push(context);
	                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
	                if (innerSubscription.closed) {
	                    this.closeWindow(this.contexts.length - 1);
	                }
	                else {
	                    innerSubscription.context = context;
	                    subscription.add(innerSubscription);
	                }
	                this.destination.next(window_1);
	            }
	        }
	        else {
	            this.closeWindow(this.contexts.indexOf(outerValue));
	        }
	    };
	    WindowToggleSubscriber.prototype.notifyError = function (err) {
	        this.error(err);
	    };
	    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
	        if (inner !== this.openSubscription) {
	            this.closeWindow(this.contexts.indexOf(inner.context));
	        }
	    };
	    WindowToggleSubscriber.prototype.closeWindow = function (index) {
	        if (index === -1) {
	            return;
	        }
	        var contexts = this.contexts;
	        var context = contexts[index];
	        var window = context.window, subscription = context.subscription;
	        contexts.splice(index, 1);
	        window.complete();
	        subscription.unsubscribe();
	    };
	    return WindowToggleSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowToggle.js.map

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var windowWhen_1 = __webpack_require__(929);
	Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var windowWhen_1 = __webpack_require__(930);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return windowWhen_1.windowWhen(closingSelector)(this);
	}
	exports.windowWhen = windowWhen;
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var tryCatch_1 = __webpack_require__(507);
	var errorObject_1 = __webpack_require__(508);
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/**
	 * Branch out the source Observable values as a nested Observable using a
	 * factory function of closing Observables to determine when to start a new
	 * window.
	 *
	 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
	 * Observable instead of an array.</span>
	 *
	 * <img src="./img/windowWhen.png" width="100%">
	 *
	 * Returns an Observable that emits windows of items it collects from the source
	 * Observable. The output Observable emits connected, non-overlapping windows.
	 * It emits the current window and opens a new one whenever the Observable
	 * produced by the specified `closingSelector` function emits an item. The first
	 * window is opened immediately when subscribing to the output Observable.
	 *
	 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var result = clicks
	 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
	 *   .map(win => win.take(2)) // each window has at most 2 emissions
	 *   .mergeAll(); // flatten the Observable-of-Observables
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link window}
	 * @see {@link windowCount}
	 * @see {@link windowTime}
	 * @see {@link windowToggle}
	 * @see {@link bufferWhen}
	 *
	 * @param {function(): Observable} closingSelector A function that takes no
	 * arguments and returns an Observable that signals (on either `next` or
	 * `complete`) when to close the previous window and start a new one.
	 * @return {Observable<Observable<T>>} An observable of windows, which in turn
	 * are Observables.
	 * @method windowWhen
	 * @owner Observable
	 */
	function windowWhen(closingSelector) {
	    return function windowWhenOperatorFunction(source) {
	        return source.lift(new WindowOperator(closingSelector));
	    };
	}
	exports.windowWhen = windowWhen;
	var WindowOperator = (function () {
	    function WindowOperator(closingSelector) {
	        this.closingSelector = closingSelector;
	    }
	    WindowOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
	    };
	    return WindowOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WindowSubscriber = (function (_super) {
	    __extends(WindowSubscriber, _super);
	    function WindowSubscriber(destination, closingSelector) {
	        _super.call(this, destination);
	        this.destination = destination;
	        this.closingSelector = closingSelector;
	        this.openWindow();
	    }
	    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
	        this._error(error);
	    };
	    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
	        this.openWindow(innerSub);
	    };
	    WindowSubscriber.prototype._next = function (value) {
	        this.window.next(value);
	    };
	    WindowSubscriber.prototype._error = function (err) {
	        this.window.error(err);
	        this.destination.error(err);
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype._complete = function () {
	        this.window.complete();
	        this.destination.complete();
	        this.unsubscribeClosingNotification();
	    };
	    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
	        if (this.closingNotification) {
	            this.closingNotification.unsubscribe();
	        }
	    };
	    WindowSubscriber.prototype.openWindow = function (innerSub) {
	        if (innerSub === void 0) { innerSub = null; }
	        if (innerSub) {
	            this.remove(innerSub);
	            innerSub.unsubscribe();
	        }
	        var prevWindow = this.window;
	        if (prevWindow) {
	            prevWindow.complete();
	        }
	        var window = this.window = new Subject_1.Subject();
	        this.destination.next(window);
	        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
	        if (closingNotifier === errorObject_1.errorObject) {
	            var err = errorObject_1.errorObject.e;
	            this.destination.error(err);
	            this.window.error(err);
	        }
	        else {
	            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
	        }
	    };
	    return WindowSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=windowWhen.js.map

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var withLatestFrom_1 = __webpack_require__(932);
	Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var withLatestFrom_1 = __webpack_require__(933);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return withLatestFrom_1.withLatestFrom.apply(void 0, args)(this);
	}
	exports.withLatestFrom = withLatestFrom;
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var OuterSubscriber_1 = __webpack_require__(531);
	var subscribeToResult_1 = __webpack_require__(532);
	/* tslint:enable:max-line-length */
	/**
	 * Combines the source Observable with other Observables to create an Observable
	 * whose values are calculated from the latest values of each, only when the
	 * source emits.
	 *
	 * <span class="informal">Whenever the source Observable emits a value, it
	 * computes a formula using that value plus the latest values from other input
	 * Observables, then emits the output of that formula.</span>
	 *
	 * <img src="./img/withLatestFrom.png" width="100%">
	 *
	 * `withLatestFrom` combines each value from the source Observable (the
	 * instance) with the latest values from the other input Observables only when
	 * the source emits a value, optionally using a `project` function to determine
	 * the value to be emitted on the output Observable. All input Observables must
	 * emit at least one value before the output Observable will emit a value.
	 *
	 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
	 * var clicks = Rx.Observable.fromEvent(document, 'click');
	 * var timer = Rx.Observable.interval(1000);
	 * var result = clicks.withLatestFrom(timer);
	 * result.subscribe(x => console.log(x));
	 *
	 * @see {@link combineLatest}
	 *
	 * @param {ObservableInput} other An input Observable to combine with the source
	 * Observable. More than one input Observables may be given as argument.
	 * @param {Function} [project] Projection function for combining values
	 * together. Receives all values in order of the Observables passed, where the
	 * first parameter is a value from the source Observable. (e.g.
	 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
	 * passed, arrays will be emitted on the output Observable.
	 * @return {Observable} An Observable of projected values from the most recent
	 * values from each input Observable, or an array of the most recent values from
	 * each input Observable.
	 * @method withLatestFrom
	 * @owner Observable
	 */
	function withLatestFrom() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i - 0] = arguments[_i];
	    }
	    return function (source) {
	        var project;
	        if (typeof args[args.length - 1] === 'function') {
	            project = args.pop();
	        }
	        var observables = args;
	        return source.lift(new WithLatestFromOperator(observables, project));
	    };
	}
	exports.withLatestFrom = withLatestFrom;
	var WithLatestFromOperator = (function () {
	    function WithLatestFromOperator(observables, project) {
	        this.observables = observables;
	        this.project = project;
	    }
	    WithLatestFromOperator.prototype.call = function (subscriber, source) {
	        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
	    };
	    return WithLatestFromOperator;
	}());
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var WithLatestFromSubscriber = (function (_super) {
	    __extends(WithLatestFromSubscriber, _super);
	    function WithLatestFromSubscriber(destination, observables, project) {
	        _super.call(this, destination);
	        this.observables = observables;
	        this.project = project;
	        this.toRespond = [];
	        var len = observables.length;
	        this.values = new Array(len);
	        for (var i = 0; i < len; i++) {
	            this.toRespond.push(i);
	        }
	        for (var i = 0; i < len; i++) {
	            var observable = observables[i];
	            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
	        }
	    }
	    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
	        this.values[outerIndex] = innerValue;
	        var toRespond = this.toRespond;
	        if (toRespond.length > 0) {
	            var found = toRespond.indexOf(outerIndex);
	            if (found !== -1) {
	                toRespond.splice(found, 1);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype.notifyComplete = function () {
	        // noop
	    };
	    WithLatestFromSubscriber.prototype._next = function (value) {
	        if (this.toRespond.length === 0) {
	            var args = [value].concat(this.values);
	            if (this.project) {
	                this._tryProject(args);
	            }
	            else {
	                this.destination.next(args);
	            }
	        }
	    };
	    WithLatestFromSubscriber.prototype._tryProject = function (args) {
	        var result;
	        try {
	            result = this.project.apply(this, args);
	        }
	        catch (err) {
	            this.destination.error(err);
	            return;
	        }
	        this.destination.next(result);
	    };
	    return WithLatestFromSubscriber;
	}(OuterSubscriber_1.OuterSubscriber));
	//# sourceMappingURL=withLatestFrom.js.map

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var zip_1 = __webpack_require__(935);
	Observable_1.Observable.prototype.zip = zip_1.zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(612);
	/* tslint:enable:max-line-length */
	/**
	 * @param observables
	 * @return {Observable<R>}
	 * @method zip
	 * @owner Observable
	 */
	function zipProto() {
	    var observables = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        observables[_i - 0] = arguments[_i];
	    }
	    return zip_1.zip.apply(void 0, observables)(this);
	}
	exports.zipProto = zipProto;
	//# sourceMappingURL=zip.js.map

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Observable_1 = __webpack_require__(499);
	var zipAll_1 = __webpack_require__(937);
	Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zipAll_1 = __webpack_require__(938);
	/**
	 * @param project
	 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
	 * @method zipAll
	 * @owner Observable
	 */
	function zipAll(project) {
	    return zipAll_1.zipAll(project)(this);
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var zip_1 = __webpack_require__(612);
	function zipAll(project) {
	    return function (source) { return source.lift(new zip_1.ZipOperator(project)); };
	}
	exports.zipAll = zipAll;
	//# sourceMappingURL=zipAll.js.map

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var Notification_1 = __webpack_require__(546);
	var ColdObservable_1 = __webpack_require__(940);
	var HotObservable_1 = __webpack_require__(944);
	var SubscriptionLog_1 = __webpack_require__(942);
	var VirtualTimeScheduler_1 = __webpack_require__(945);
	var defaultMaxFrame = 750;
	var TestScheduler = (function (_super) {
	    __extends(TestScheduler, _super);
	    function TestScheduler(assertDeepEqual) {
	        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
	        this.assertDeepEqual = assertDeepEqual;
	        this.hotObservables = [];
	        this.coldObservables = [];
	        this.flushTests = [];
	    }
	    TestScheduler.prototype.createTime = function (marbles) {
	        var indexOf = marbles.indexOf('|');
	        if (indexOf === -1) {
	            throw new Error('marble diagram for time should have a completion marker "|"');
	        }
	        return indexOf * TestScheduler.frameTimeFactor;
	    };
	    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
	        if (marbles.indexOf('^') !== -1) {
	            throw new Error('cold observable cannot have subscription offset "^"');
	        }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('cold observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var cold = new ColdObservable_1.ColdObservable(messages, this);
	        this.coldObservables.push(cold);
	        return cold;
	    };
	    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('hot observable cannot have unsubscription marker "!"');
	        }
	        var messages = TestScheduler.parseMarbles(marbles, values, error);
	        var subject = new HotObservable_1.HotObservable(messages, this);
	        this.hotObservables.push(subject);
	        return subject;
	    };
	    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
	        var _this = this;
	        var messages = [];
	        observable.subscribe(function (value) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
	        }, function (err) {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
	        }, function () {
	            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
	        });
	        return messages;
	    };
	    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
	        var _this = this;
	        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
	        var actual = [];
	        var flushTest = { actual: actual, ready: false };
	        var unsubscriptionFrame = TestScheduler
	            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
	        var subscription;
	        this.schedule(function () {
	            subscription = observable.subscribe(function (x) {
	                var value = x;
	                // Support Observable-of-Observables
	                if (x instanceof Observable_1.Observable) {
	                    value = _this.materializeInnerObservable(value, _this.frame);
	                }
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
	            }, function (err) {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
	            }, function () {
	                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
	            });
	        }, 0);
	        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
	        }
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles, values, errorValue) {
	                flushTest.ready = true;
	                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
	            }
	        };
	    };
	    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
	        var flushTest = { actual: actualSubscriptionLogs, ready: false };
	        this.flushTests.push(flushTest);
	        return {
	            toBe: function (marbles) {
	                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
	                flushTest.ready = true;
	                flushTest.expected = marblesArray.map(function (marbles) {
	                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
	                });
	            }
	        };
	    };
	    TestScheduler.prototype.flush = function () {
	        var hotObservables = this.hotObservables;
	        while (hotObservables.length > 0) {
	            hotObservables.shift().setup();
	        }
	        _super.prototype.flush.call(this);
	        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
	        while (readyFlushTests.length > 0) {
	            var test = readyFlushTests.shift();
	            this.assertDeepEqual(test.actual, test.expected);
	        }
	    };
	    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
	        if (typeof marbles !== 'string') {
	            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
	        }
	        var len = marbles.length;
	        var groupStart = -1;
	        var subscriptionFrame = Number.POSITIVE_INFINITY;
	        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '^':
	                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                case '!':
	                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
	                        throw new Error('found a second subscription point \'^\' in a ' +
	                            'subscription marble diagram. There can only be one.');
	                    }
	                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
	                    break;
	                default:
	                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
	                        'subscription marble diagram. Found instead \'' + c + '\'.');
	            }
	        }
	        if (unsubscriptionFrame < 0) {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
	        }
	        else {
	            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
	        }
	    };
	    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
	        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
	        if (marbles.indexOf('!') !== -1) {
	            throw new Error('conventional marble diagrams cannot have the ' +
	                'unsubscription marker "!"');
	        }
	        var len = marbles.length;
	        var testMessages = [];
	        var subIndex = marbles.indexOf('^');
	        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
	        var getValue = typeof values !== 'object' ?
	            function (x) { return x; } :
	            function (x) {
	                // Support Observable-of-Observables
	                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
	                    return values[x].messages;
	                }
	                return values[x];
	            };
	        var groupStart = -1;
	        for (var i = 0; i < len; i++) {
	            var frame = i * this.frameTimeFactor + frameOffset;
	            var notification = void 0;
	            var c = marbles[i];
	            switch (c) {
	                case '-':
	                case ' ':
	                    break;
	                case '(':
	                    groupStart = frame;
	                    break;
	                case ')':
	                    groupStart = -1;
	                    break;
	                case '|':
	                    notification = Notification_1.Notification.createComplete();
	                    break;
	                case '^':
	                    break;
	                case '#':
	                    notification = Notification_1.Notification.createError(errorValue || 'error');
	                    break;
	                default:
	                    notification = Notification_1.Notification.createNext(getValue(c));
	                    break;
	            }
	            if (notification) {
	                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
	            }
	        }
	        return testMessages;
	    };
	    return TestScheduler;
	}(VirtualTimeScheduler_1.VirtualTimeScheduler));
	exports.TestScheduler = TestScheduler;
	//# sourceMappingURL=TestScheduler.js.map

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Observable_1 = __webpack_require__(499);
	var Subscription_1 = __webpack_require__(504);
	var SubscriptionLoggable_1 = __webpack_require__(941);
	var applyMixins_1 = __webpack_require__(943);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var ColdObservable = (function (_super) {
	    __extends(ColdObservable, _super);
	    function ColdObservable(messages, scheduler) {
	        _super.call(this, function (subscriber) {
	            var observable = this;
	            var index = observable.logSubscribedFrame();
	            subscriber.add(new Subscription_1.Subscription(function () {
	                observable.logUnsubscribedFrame(index);
	            }));
	            observable.scheduleMessages(subscriber);
	            return subscriber;
	        });
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    ColdObservable.prototype.scheduleMessages = function (subscriber) {
	        var messagesLength = this.messages.length;
	        for (var i = 0; i < messagesLength; i++) {
	            var message = this.messages[i];
	            subscriber.add(this.scheduler.schedule(function (_a) {
	                var message = _a.message, subscriber = _a.subscriber;
	                message.notification.observe(subscriber);
	            }, message.frame, { message: message, subscriber: subscriber }));
	        }
	    };
	    return ColdObservable;
	}(Observable_1.Observable));
	exports.ColdObservable = ColdObservable;
	applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=ColdObservable.js.map

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var SubscriptionLog_1 = __webpack_require__(942);
	var SubscriptionLoggable = (function () {
	    function SubscriptionLoggable() {
	        this.subscriptions = [];
	    }
	    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
	        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
	        return this.subscriptions.length - 1;
	    };
	    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
	        var subscriptionLogs = this.subscriptions;
	        var oldSubscriptionLog = subscriptionLogs[index];
	        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
	    };
	    return SubscriptionLoggable;
	}());
	exports.SubscriptionLoggable = SubscriptionLoggable;
	//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),
/* 942 */
/***/ (function(module, exports) {

	"use strict";
	var SubscriptionLog = (function () {
	    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
	        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
	        this.subscribedFrame = subscribedFrame;
	        this.unsubscribedFrame = unsubscribedFrame;
	    }
	    return SubscriptionLog;
	}());
	exports.SubscriptionLog = SubscriptionLog;
	//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	"use strict";
	function applyMixins(derivedCtor, baseCtors) {
	    for (var i = 0, len = baseCtors.length; i < len; i++) {
	        var baseCtor = baseCtors[i];
	        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
	        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
	            var name_1 = propertyKeys[j];
	            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
	        }
	    }
	}
	exports.applyMixins = applyMixins;
	//# sourceMappingURL=applyMixins.js.map

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Subject_1 = __webpack_require__(498);
	var Subscription_1 = __webpack_require__(504);
	var SubscriptionLoggable_1 = __webpack_require__(941);
	var applyMixins_1 = __webpack_require__(943);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var HotObservable = (function (_super) {
	    __extends(HotObservable, _super);
	    function HotObservable(messages, scheduler) {
	        _super.call(this);
	        this.messages = messages;
	        this.subscriptions = [];
	        this.scheduler = scheduler;
	    }
	    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function (subscriber) {
	        var subject = this;
	        var index = subject.logSubscribedFrame();
	        subscriber.add(new Subscription_1.Subscription(function () {
	            subject.logUnsubscribedFrame(index);
	        }));
	        return _super.prototype._subscribe.call(this, subscriber);
	    };
	    HotObservable.prototype.setup = function () {
	        var subject = this;
	        var messagesLength = subject.messages.length;
	        /* tslint:disable:no-var-keyword */
	        for (var i = 0; i < messagesLength; i++) {
	            (function () {
	                var message = subject.messages[i];
	                /* tslint:enable */
	                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
	            })();
	        }
	    };
	    return HotObservable;
	}(Subject_1.Subject));
	exports.HotObservable = HotObservable;
	applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
	//# sourceMappingURL=HotObservable.js.map

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(579);
	var AsyncScheduler_1 = __webpack_require__(581);
	var VirtualTimeScheduler = (function (_super) {
	    __extends(VirtualTimeScheduler, _super);
	    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
	        var _this = this;
	        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
	        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
	        _super.call(this, SchedulerAction, function () { return _this.frame; });
	        this.maxFrames = maxFrames;
	        this.frame = 0;
	        this.index = -1;
	    }
	    /**
	     * Prompt the Scheduler to execute all of its queued actions, therefore
	     * clearing its queue.
	     * @return {void}
	     */
	    VirtualTimeScheduler.prototype.flush = function () {
	        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
	        var error, action;
	        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        }
	        if (error) {
	            while (action = actions.shift()) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    VirtualTimeScheduler.frameTimeFactor = 10;
	    return VirtualTimeScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.VirtualTimeScheduler = VirtualTimeScheduler;
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var VirtualAction = (function (_super) {
	    __extends(VirtualAction, _super);
	    function VirtualAction(scheduler, work, index) {
	        if (index === void 0) { index = scheduler.index += 1; }
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	        this.index = index;
	        this.active = true;
	        this.index = scheduler.index = index;
	    }
	    VirtualAction.prototype.schedule = function (state, delay) {
	        if (delay === void 0) { delay = 0; }
	        if (!this.id) {
	            return _super.prototype.schedule.call(this, state, delay);
	        }
	        this.active = false;
	        // If an action is rescheduled, we save allocations by mutating its state,
	        // pushing it to the end of the scheduler queue, and recycling the action.
	        // But since the VirtualTimeScheduler is used for testing, VirtualActions
	        // must be immutable so they can be inspected later.
	        var action = new VirtualAction(this.scheduler, this.work);
	        this.add(action);
	        return action.schedule(state, delay);
	    };
	    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        this.delay = scheduler.frame + delay;
	        var actions = scheduler.actions;
	        actions.push(this);
	        actions.sort(VirtualAction.sortActions);
	        return true;
	    };
	    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        return undefined;
	    };
	    VirtualAction.prototype._execute = function (state, delay) {
	        if (this.active === true) {
	            return _super.prototype._execute.call(this, state, delay);
	        }
	    };
	    VirtualAction.sortActions = function (a, b) {
	        if (a.delay === b.delay) {
	            if (a.index === b.index) {
	                return 0;
	            }
	            else if (a.index > b.index) {
	                return 1;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (a.delay > b.delay) {
	            return 1;
	        }
	        else {
	            return -1;
	        }
	    };
	    return VirtualAction;
	}(AsyncAction_1.AsyncAction));
	exports.VirtualAction = VirtualAction;
	//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var AnimationFrameAction_1 = __webpack_require__(947);
	var AnimationFrameScheduler_1 = __webpack_require__(949);
	/**
	 *
	 * Animation Frame Scheduler
	 *
	 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
	 *
	 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
	 * behaviour.
	 *
	 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
	 * It makes sure scheduled task will happen just before next browser content repaint,
	 * thus performing animations as efficiently as possible.
	 *
	 * @example <caption>Schedule div height animation</caption>
	 * const div = document.querySelector('.some-div');
	 *
	 * Rx.Scheduler.schedule(function(height) {
	 *   div.style.height = height + "px";
	 *
	 *   this.schedule(height + 1);  // `this` references currently executing Action,
	 *                               // which we reschedule with new state
	 * }, 0, 0);
	 *
	 * // You will see .some-div element growing in height
	 *
	 *
	 * @static true
	 * @name animationFrame
	 * @owner Scheduler
	 */
	exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
	//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncAction_1 = __webpack_require__(579);
	var AnimationFrame_1 = __webpack_require__(948);
	/**
	 * We need this JSDoc comment for affecting ESDoc.
	 * @ignore
	 * @extends {Ignored}
	 */
	var AnimationFrameAction = (function (_super) {
	    __extends(AnimationFrameAction, _super);
	    function AnimationFrameAction(scheduler, work) {
	        _super.call(this, scheduler, work);
	        this.scheduler = scheduler;
	        this.work = work;
	    }
	    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay is greater than 0, request as an async action.
	        if (delay !== null && delay > 0) {
	            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
	        }
	        // Push the action to the end of the scheduler queue.
	        scheduler.actions.push(this);
	        // If an animation frame has already been requested, don't request another
	        // one. If an animation frame hasn't been requested yet, request one. Return
	        // the current animation frame request id.
	        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
	    };
	    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
	        if (delay === void 0) { delay = 0; }
	        // If delay exists and is greater than 0, or if the delay is null (the
	        // action wasn't rescheduled) but was originally scheduled as an async
	        // action, then recycle as an async action.
	        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
	            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
	        }
	        // If the scheduler queue is empty, cancel the requested animation frame and
	        // set the scheduled flag to undefined so the next AnimationFrameAction will
	        // request its own.
	        if (scheduler.actions.length === 0) {
	            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
	            scheduler.scheduled = undefined;
	        }
	        // Return undefined so the action knows to request a new async id if it's rescheduled.
	        return undefined;
	    };
	    return AnimationFrameAction;
	}(AsyncAction_1.AsyncAction));
	exports.AnimationFrameAction = AnimationFrameAction;
	//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var root_1 = __webpack_require__(500);
	var RequestAnimationFrameDefinition = (function () {
	    function RequestAnimationFrameDefinition(root) {
	        if (root.requestAnimationFrame) {
	            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
	        }
	        else if (root.mozRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
	        }
	        else if (root.webkitRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
	        }
	        else if (root.msRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
	        }
	        else if (root.oRequestAnimationFrame) {
	            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
	            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
	        }
	        else {
	            this.cancelAnimationFrame = root.clearTimeout.bind(root);
	            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
	        }
	    }
	    return RequestAnimationFrameDefinition;
	}());
	exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
	exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
	//# sourceMappingURL=AnimationFrame.js.map

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var AsyncScheduler_1 = __webpack_require__(581);
	var AnimationFrameScheduler = (function (_super) {
	    __extends(AnimationFrameScheduler, _super);
	    function AnimationFrameScheduler() {
	        _super.apply(this, arguments);
	    }
	    AnimationFrameScheduler.prototype.flush = function (action) {
	        this.active = true;
	        this.scheduled = undefined;
	        var actions = this.actions;
	        var error;
	        var index = -1;
	        var count = actions.length;
	        action = action || actions.shift();
	        do {
	            if (error = action.execute(action.state, action.delay)) {
	                break;
	            }
	        } while (++index < count && (action = actions.shift()));
	        this.active = false;
	        if (error) {
	            while (++index < count && (action = actions.shift())) {
	                action.unsubscribe();
	            }
	            throw error;
	        }
	    };
	    return AnimationFrameScheduler;
	}(AsyncScheduler_1.AsyncScheduler));
	exports.AnimationFrameScheduler = AnimationFrameScheduler;
	//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var audit_1 = __webpack_require__(736);
	exports.audit = audit_1.audit;
	var auditTime_1 = __webpack_require__(739);
	exports.auditTime = auditTime_1.auditTime;
	var buffer_1 = __webpack_require__(627);
	exports.buffer = buffer_1.buffer;
	var bufferCount_1 = __webpack_require__(630);
	exports.bufferCount = bufferCount_1.bufferCount;
	var bufferTime_1 = __webpack_require__(633);
	exports.bufferTime = bufferTime_1.bufferTime;
	var bufferToggle_1 = __webpack_require__(636);
	exports.bufferToggle = bufferToggle_1.bufferToggle;
	var bufferWhen_1 = __webpack_require__(639);
	exports.bufferWhen = bufferWhen_1.bufferWhen;
	var catchError_1 = __webpack_require__(642);
	exports.catchError = catchError_1.catchError;
	var combineAll_1 = __webpack_require__(645);
	exports.combineAll = combineAll_1.combineAll;
	var combineLatest_1 = __webpack_require__(530);
	exports.combineLatest = combineLatest_1.combineLatest;
	var concat_1 = __webpack_require__(650);
	exports.concat = concat_1.concat;
	var concatAll_1 = __webpack_require__(547);
	exports.concatAll = concatAll_1.concatAll;
	var concatMap_1 = __webpack_require__(655);
	exports.concatMap = concatMap_1.concatMap;
	var concatMapTo_1 = __webpack_require__(658);
	exports.concatMapTo = concatMapTo_1.concatMapTo;
	var count_1 = __webpack_require__(661);
	exports.count = count_1.count;
	var debounce_1 = __webpack_require__(667);
	exports.debounce = debounce_1.debounce;
	var debounceTime_1 = __webpack_require__(670);
	exports.debounceTime = debounceTime_1.debounceTime;
	var defaultIfEmpty_1 = __webpack_require__(673);
	exports.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
	var delay_1 = __webpack_require__(676);
	exports.delay = delay_1.delay;
	var delayWhen_1 = __webpack_require__(679);
	exports.delayWhen = delayWhen_1.delayWhen;
	var dematerialize_1 = __webpack_require__(664);
	exports.dematerialize = dematerialize_1.dematerialize;
	var distinct_1 = __webpack_require__(682);
	exports.distinct = distinct_1.distinct;
	var distinctUntilChanged_1 = __webpack_require__(686);
	exports.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
	var distinctUntilKeyChanged_1 = __webpack_require__(689);
	exports.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
	var elementAt_1 = __webpack_require__(704);
	exports.elementAt = elementAt_1.elementAt;
	var every_1 = __webpack_require__(747);
	exports.every = every_1.every;
	var exhaust_1 = __webpack_require__(695);
	exports.exhaust = exhaust_1.exhaust;
	var exhaustMap_1 = __webpack_require__(698);
	exports.exhaustMap = exhaustMap_1.exhaustMap;
	var expand_1 = __webpack_require__(701);
	exports.expand = expand_1.expand;
	var filter_1 = __webpack_require__(708);
	exports.filter = filter_1.filter;
	var finalize_1 = __webpack_require__(711);
	exports.finalize = finalize_1.finalize;
	var find_1 = __webpack_require__(714);
	exports.find = find_1.find;
	var findIndex_1 = __webpack_require__(717);
	exports.findIndex = findIndex_1.findIndex;
	var first_1 = __webpack_require__(720);
	exports.first = first_1.first;
	var groupBy_1 = __webpack_require__(724);
	exports.groupBy = groupBy_1.groupBy;
	var ignoreElements_1 = __webpack_require__(730);
	exports.ignoreElements = ignoreElements_1.ignoreElements;
	var isEmpty_1 = __webpack_require__(733);
	exports.isEmpty = isEmpty_1.isEmpty;
	var last_1 = __webpack_require__(742);
	exports.last = last_1.last;
	var map_1 = __webpack_require__(616);
	exports.map = map_1.map;
	var mapTo_1 = __webpack_require__(752);
	exports.mapTo = mapTo_1.mapTo;
	var materialize_1 = __webpack_require__(755);
	exports.materialize = materialize_1.materialize;
	var max_1 = __webpack_require__(758);
	exports.max = max_1.max;
	var merge_1 = __webpack_require__(764);
	exports.merge = merge_1.merge;
	var mergeAll_1 = __webpack_require__(548);
	exports.mergeAll = mergeAll_1.mergeAll;
	var mergeMap_1 = __webpack_require__(549);
	exports.mergeMap = mergeMap_1.mergeMap;
	var mergeMap_2 = __webpack_require__(549);
	exports.flatMap = mergeMap_2.mergeMap;
	var mergeMapTo_1 = __webpack_require__(771);
	exports.mergeMapTo = mergeMapTo_1.mergeMapTo;
	var mergeScan_1 = __webpack_require__(774);
	exports.mergeScan = mergeScan_1.mergeScan;
	var min_1 = __webpack_require__(777);
	exports.min = min_1.min;
	var multicast_1 = __webpack_require__(780);
	exports.multicast = multicast_1.multicast;
	var observeOn_1 = __webpack_require__(545);
	exports.observeOn = observeOn_1.observeOn;
	var onErrorResumeNext_1 = __webpack_require__(593);
	exports.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
	var pairwise_1 = __webpack_require__(789);
	exports.pairwise = pairwise_1.pairwise;
	var partition_1 = __webpack_require__(792);
	exports.partition = partition_1.partition;
	var pluck_1 = __webpack_require__(796);
	exports.pluck = pluck_1.pluck;
	var publish_1 = __webpack_require__(799);
	exports.publish = publish_1.publish;
	var publishBehavior_1 = __webpack_require__(802);
	exports.publishBehavior = publishBehavior_1.publishBehavior;
	var publishLast_1 = __webpack_require__(809);
	exports.publishLast = publishLast_1.publishLast;
	var publishReplay_1 = __webpack_require__(806);
	exports.publishReplay = publishReplay_1.publishReplay;
	var race_1 = __webpack_require__(812);
	exports.race = race_1.race;
	var reduce_1 = __webpack_require__(759);
	exports.reduce = reduce_1.reduce;
	var repeat_1 = __webpack_require__(817);
	exports.repeat = repeat_1.repeat;
	var repeatWhen_1 = __webpack_require__(820);
	exports.repeatWhen = repeatWhen_1.repeatWhen;
	var retry_1 = __webpack_require__(823);
	exports.retry = retry_1.retry;
	var retryWhen_1 = __webpack_require__(826);
	exports.retryWhen = retryWhen_1.retryWhen;
	var refCount_1 = __webpack_require__(782);
	exports.refCount = refCount_1.refCount;
	var sample_1 = __webpack_require__(829);
	exports.sample = sample_1.sample;
	var sampleTime_1 = __webpack_require__(832);
	exports.sampleTime = sampleTime_1.sampleTime;
	var scan_1 = __webpack_require__(760);
	exports.scan = scan_1.scan;
	var sequenceEqual_1 = __webpack_require__(837);
	exports.sequenceEqual = sequenceEqual_1.sequenceEqual;
	var share_1 = __webpack_require__(840);
	exports.share = share_1.share;
	var shareReplay_1 = __webpack_require__(843);
	exports.shareReplay = shareReplay_1.shareReplay;
	var single_1 = __webpack_require__(846);
	exports.single = single_1.single;
	var skip_1 = __webpack_require__(849);
	exports.skip = skip_1.skip;
	var skipLast_1 = __webpack_require__(852);
	exports.skipLast = skipLast_1.skipLast;
	var skipUntil_1 = __webpack_require__(855);
	exports.skipUntil = skipUntil_1.skipUntil;
	var skipWhile_1 = __webpack_require__(858);
	exports.skipWhile = skipWhile_1.skipWhile;
	var startWith_1 = __webpack_require__(861);
	exports.startWith = startWith_1.startWith;
	/**
	 * TODO(https://github.com/ReactiveX/rxjs/issues/2900): Add back subscribeOn once it can be
	 * treeshaken. Currently if this export is added back, it
	 * forces apps to bring in asap scheduler along with
	 * Immediate, root, and other supporting code.
	 */
	// export { subscribeOn } from './operators/subscribeOn';
	var switchAll_1 = __webpack_require__(875);
	exports.switchAll = switchAll_1.switchAll;
	var switchMap_1 = __webpack_require__(876);
	exports.switchMap = switchMap_1.switchMap;
	var switchMapTo_1 = __webpack_require__(881);
	exports.switchMapTo = switchMapTo_1.switchMapTo;
	var take_1 = __webpack_require__(884);
	exports.take = take_1.take;
	var takeLast_1 = __webpack_require__(761);
	exports.takeLast = takeLast_1.takeLast;
	var takeUntil_1 = __webpack_require__(889);
	exports.takeUntil = takeUntil_1.takeUntil;
	var takeWhile_1 = __webpack_require__(892);
	exports.takeWhile = takeWhile_1.takeWhile;
	var tap_1 = __webpack_require__(692);
	exports.tap = tap_1.tap;
	var throttle_1 = __webpack_require__(895);
	exports.throttle = throttle_1.throttle;
	var throttleTime_1 = __webpack_require__(898);
	exports.throttleTime = throttleTime_1.throttleTime;
	var timeInterval_1 = __webpack_require__(901);
	exports.timeInterval = timeInterval_1.timeInterval;
	var timeout_1 = __webpack_require__(904);
	exports.timeout = timeout_1.timeout;
	var timeoutWith_1 = __webpack_require__(908);
	exports.timeoutWith = timeoutWith_1.timeoutWith;
	var timestamp_1 = __webpack_require__(911);
	exports.timestamp = timestamp_1.timestamp;
	var toArray_1 = __webpack_require__(914);
	exports.toArray = toArray_1.toArray;
	var window_1 = __webpack_require__(918);
	exports.window = window_1.window;
	var windowCount_1 = __webpack_require__(921);
	exports.windowCount = windowCount_1.windowCount;
	var windowTime_1 = __webpack_require__(924);
	exports.windowTime = windowTime_1.windowTime;
	var windowToggle_1 = __webpack_require__(927);
	exports.windowToggle = windowToggle_1.windowToggle;
	var windowWhen_1 = __webpack_require__(930);
	exports.windowWhen = windowWhen_1.windowWhen;
	var withLatestFrom_1 = __webpack_require__(933);
	exports.withLatestFrom = withLatestFrom_1.withLatestFrom;
	var zip_1 = __webpack_require__(612);
	exports.zip = zip_1.zip;
	var zipAll_1 = __webpack_require__(938);
	exports.zipAll = zipAll_1.zipAll;
	//# sourceMappingURL=operators.js.map

/***/ }),
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(963), __esModule: true };

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(964);
	module.exports = __webpack_require__(350).Number.isNaN;


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(356);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(970)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(972)
	
	exports.createHmac = __webpack_require__(984)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(985)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(987)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(967)
	var ieee754 = __webpack_require__(968)
	var isArray = __webpack_require__(969)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 968 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 969 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(971)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(966).Buffer))

/***/ }),
/* 971 */,
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(973)
	
	var md5 = toConstructor(__webpack_require__(981))
	var rmd160 = toConstructor(__webpack_require__(983))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(966).Buffer
	var Hash   = __webpack_require__(974)(Buffer)
	
	exports.sha1 = __webpack_require__(975)(Buffer, Hash)
	exports.sha256 = __webpack_require__(979)(Buffer, Hash)
	exports.sha512 = __webpack_require__(980)(Buffer, Hash)


/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(976).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(977);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(978);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(871)))

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(976).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(976).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(982);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(972)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(986)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(988)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(1023)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(1014);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989);
	var Transform = __webpack_require__(990);
	var inherits = __webpack_require__(978);
	var modes = __webpack_require__(1014);
	var ebtk = __webpack_require__(1015);
	var StreamCipher = __webpack_require__(1016);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(1017),
	  CBC: __webpack_require__(1018),
	  CFB: __webpack_require__(1020),
	  OFB: __webpack_require__(1021),
	  CTR: __webpack_require__(1022)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(991).Transform;
	var inherits = __webpack_require__(978);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(992).EventEmitter;
	var inherits = __webpack_require__(978);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(993);
	Stream.Writable = __webpack_require__(1010);
	Stream.Duplex = __webpack_require__(1011);
	Stream.Transform = __webpack_require__(1012);
	Stream.PassThrough = __webpack_require__(1013);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 992 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var R = typeof Reflect === 'object' ? Reflect : null
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  }
	
	var ReflectOwnKeys
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}
	
	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}
	
	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	}
	
	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});
	
	EventEmitter.init = function() {
	
	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	};
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};
	
	function $getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return $getMaxListeners(this);
	};
	
	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');
	
	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }
	
	  var handler = events[type];
	
	  if (handler === undefined)
	    return false;
	
	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	
	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }
	
	    // Check for listener leak
	    m = $getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  var args = [];
	  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    ReflectApply(this.listener, this.target, args);
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      if (typeof listener !== 'function') {
	        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	      }
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      if (typeof listener !== 'function') {
	        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	      }
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      list = events[type];
	      if (list === undefined)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (events === undefined)
	    return [];
	
	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events !== undefined) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(994);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(1005);
	exports.Duplex = __webpack_require__(1004);
	exports.Transform = __webpack_require__(1008);
	exports.PassThrough = __webpack_require__(1009);


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(995);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(996);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(992).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(997);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(998).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(999);
	util.inherits = __webpack_require__(978);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(1000);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1001);
	var destroyImpl = __webpack_require__(1003);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
	
	  // This is a hack to make sure that our error handler is attached before any
	  // userland ones.  NEVER DO THIS. This is here only because this code needs
	  // to continue to work with older versions of Node.js that do not include
	  // the prependListener() method. The goal is to eventually remove this hack.
	  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(1004);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var readableHwm = options.readableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(1007).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(1004);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(1007).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    pna.nextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        pna.nextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    pna.nextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var _this = this;
	
	  var state = this._readableState;
	  var paused = false;
	
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) _this.push(chunk);
	    }
	
	    _this.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = _this.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  this._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return this;
	};
	
	Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._readableState.highWaterMark;
	  }
	});
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    pna.nextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(871)))

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = { nextTick: nextTick };
	} else {
	  module.exports = process
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(871)))

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(992).EventEmitter;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(966)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1000 */,
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(998).Buffer;
	var util = __webpack_require__(1002);
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();
	
	if (util && util.inspect && util.inspect.custom) {
	  module.exports.prototype[util.inspect.custom] = function () {
	    var obj = util.inspect({ length: this.length });
	    return this.constructor.name + ' ' + obj;
	  };
	}

/***/ }),
/* 1002 */,
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(995);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      pna.nextTick(emitErrorNT, this, err);
	    }
	    return this;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      pna.nextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	
	  return this;
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(995);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(999);
	util.inherits = __webpack_require__(978);
	/*</replacement>*/
	
	var Readable = __webpack_require__(994);
	var Writable = __webpack_require__(1005);
	
	util.inherits(Duplex, Readable);
	
	{
	  // avoid scope creep, the keys array can then be collected
	  var keys = objectKeys(Writable.prototype);
	  for (var v = 0; v < keys.length; v++) {
	    var method = keys[v];
	    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	  }
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  pna.nextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  pna.nextTick(cb, err);
	};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var pna = __webpack_require__(995);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(999);
	util.inherits = __webpack_require__(978);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(1006)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(997);
	/*</replacement>*/
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(998).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(1003);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(1004);
	
	  options = options || {};
	
	  // Duplex streams are both readable and writable, but share
	  // the same options object.
	  // However, some cases require setting options to different
	  // values for the readable and the writable sides of the duplex stream.
	  // These options can be provided separately as readableXXX and writableXXX.
	  var isDuplex = stream instanceof Duplex;
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var writableHwm = options.writableHighWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	
	  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	      if (this !== Writable) return false;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(1004);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  pna.nextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    pna.nextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = !state.objectMode && _isUint8Array(chunk);
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
	  // making it explicit this property is not enumerable
	  // because otherwise some prototype manipulation in
	  // userland will fail
	  enumerable: false,
	  get: function () {
	    return this._writableState.highWaterMark;
	  }
	});
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    pna.nextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    pna.nextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	    state.bufferedRequestCount = 0;
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      state.bufferedRequestCount--;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      pna.nextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(871), __webpack_require__(869).setImmediate, (function() { return this; }())))

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var Buffer = __webpack_require__(998).Buffer;
	/*</replacement>*/
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte. If an invalid byte is detected, -2 is returned.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return byte >> 6 === 0x02 ? -1 : -2;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i || nb === -2) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd';
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd';
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd';
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character is added when ending on a partial
	// character.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd';
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(1004);
	
	/*<replacement>*/
	var util = __webpack_require__(999);
	util.inherits = __webpack_require__(978);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function afterTransform(er, data) {
	  var ts = this._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return this.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    this.push(data);
	
	  cb(er);
	
	  var rs = this._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    this._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = {
	    afterTransform: afterTransform.bind(this),
	    needTransform: false,
	    transforming: false,
	    writecb: null,
	    writechunk: null,
	    writeencoding: null
	  };
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.on('prefinish', prefinish);
	}
	
	function prefinish() {
	  var _this = this;
	
	  if (typeof this._flush === 'function') {
	    this._flush(function (er, data) {
	      done(_this, er, data);
	    });
	  } else {
	    done(this, null, null);
	  }
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this2 = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this2.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data != null) // single equals check for both `null` and `undefined`
	    stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(1008);
	
	/*<replacement>*/
	var util = __webpack_require__(999);
	util.inherits = __webpack_require__(978);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1005);


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1004);


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(993).Transform


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(993).PassThrough


/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989);
	var Transform = __webpack_require__(990);
	var inherits = __webpack_require__(978);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(1019);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(1019);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(1019);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(1019);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(989);
	var Transform = __webpack_require__(990);
	var inherits = __webpack_require__(978);
	var modes = __webpack_require__(1014);
	var StreamCipher = __webpack_require__(1016);
	var ebtk = __webpack_require__(1015);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(1017),
	  CBC: __webpack_require__(1018),
	  CFB: __webpack_require__(1020),
	  OFB: __webpack_require__(1021),
	  CTR: __webpack_require__(1022)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(966).Buffer))

/***/ }),
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1037), __esModule: true };

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1038);
	__webpack_require__(1052);
	module.exports = __webpack_require__(1054);


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1039);
	var global = __webpack_require__(351);
	var hide = __webpack_require__(359);
	var Iterators = __webpack_require__(1042);
	var TO_STRING_TAG = __webpack_require__(1050)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1040);
	var step = __webpack_require__(1041);
	var Iterators = __webpack_require__(1042);
	var toIObject = __webpack_require__(341);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(1043)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(352);
	var $export = __webpack_require__(356);
	var redefine = __webpack_require__(1044);
	var hide = __webpack_require__(359);
	var Iterators = __webpack_require__(1042);
	var $iterCreate = __webpack_require__(1045);
	var setToStringTag = __webpack_require__(1049);
	var getPrototypeOf = __webpack_require__(1051);
	var ITERATOR = __webpack_require__(1050)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(359);


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(1046);
	var descriptor = __webpack_require__(368);
	var setToStringTag = __webpack_require__(1049);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(359)(IteratorPrototype, __webpack_require__(1050)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(361);
	var dPs = __webpack_require__(1047);
	var enumBugKeys = __webpack_require__(354);
	var IE_PROTO = __webpack_require__(348)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(366)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1048).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(360);
	var anObject = __webpack_require__(361);
	var getKeys = __webpack_require__(338);
	
	module.exports = __webpack_require__(364) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(351).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(360).f;
	var has = __webpack_require__(340);
	var TAG = __webpack_require__(1050)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(349)('wks');
	var uid = __webpack_require__(353);
	var Symbol = __webpack_require__(351).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(340);
	var toObject = __webpack_require__(336);
	var IE_PROTO = __webpack_require__(348)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1053)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(1043)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(346);
	var defined = __webpack_require__(337);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(361);
	var get = __webpack_require__(1055);
	module.exports = __webpack_require__(350).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(1056);
	var ITERATOR = __webpack_require__(1050)('iterator');
	var Iterators = __webpack_require__(1042);
	module.exports = __webpack_require__(350).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(343);
	var TAG = __webpack_require__(1050)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1064), __esModule: true };

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1065);
	module.exports = __webpack_require__(350).Number.parseFloat;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(356);
	var $parseFloat = __webpack_require__(1066);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(351).parseFloat;
	var $trim = __webpack_require__(1067).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(1068) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(356);
	var defined = __webpack_require__(337);
	var fails = __webpack_require__(365);
	var spaces = __webpack_require__(1068);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1097), __esModule: true };

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(350);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1202), __esModule: true };

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1203);
	module.exports = __webpack_require__(350).Object.freeze;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(362);
	var meta = __webpack_require__(1204).onFreeze;
	
	__webpack_require__(355)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(353)('meta');
	var isObject = __webpack_require__(362);
	var has = __webpack_require__(340);
	var setDesc = __webpack_require__(360).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(365)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(1206);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1207), __esModule: true };

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1052);
	__webpack_require__(1208);
	module.exports = __webpack_require__(350).Array.from;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(357);
	var $export = __webpack_require__(356);
	var toObject = __webpack_require__(336);
	var call = __webpack_require__(1209);
	var isArrayIter = __webpack_require__(1210);
	var toLength = __webpack_require__(345);
	var createProperty = __webpack_require__(1211);
	var getIterFn = __webpack_require__(1055);
	
	$export($export.S + $export.F * !__webpack_require__(1212)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(361);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(1042);
	var ITERATOR = __webpack_require__(1050)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(360);
	var createDesc = __webpack_require__(368);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(1050)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, __filename, global, __dirname) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved. 
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0  
	 
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE, 
	MERCHANTABLITY OR NON-INFRINGEMENT. 
	 
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	};
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var ts;
	(function (ts) {
	    /* @internal */
	    var Comparison;
	    (function (Comparison) {
	        Comparison[Comparison["LessThan"] = -1] = "LessThan";
	        Comparison[Comparison["EqualTo"] = 0] = "EqualTo";
	        Comparison[Comparison["GreaterThan"] = 1] = "GreaterThan";
	    })(Comparison = ts.Comparison || (ts.Comparison = {}));
	    // token > SyntaxKind.Identifier => token is a keyword
	    // Also, If you add a new SyntaxKind be sure to keep the `Markers` section at the bottom in sync
	    var SyntaxKind;
	    (function (SyntaxKind) {
	        SyntaxKind[SyntaxKind["Unknown"] = 0] = "Unknown";
	        SyntaxKind[SyntaxKind["EndOfFileToken"] = 1] = "EndOfFileToken";
	        SyntaxKind[SyntaxKind["SingleLineCommentTrivia"] = 2] = "SingleLineCommentTrivia";
	        SyntaxKind[SyntaxKind["MultiLineCommentTrivia"] = 3] = "MultiLineCommentTrivia";
	        SyntaxKind[SyntaxKind["NewLineTrivia"] = 4] = "NewLineTrivia";
	        SyntaxKind[SyntaxKind["WhitespaceTrivia"] = 5] = "WhitespaceTrivia";
	        // We detect and preserve #! on the first line
	        SyntaxKind[SyntaxKind["ShebangTrivia"] = 6] = "ShebangTrivia";
	        // We detect and provide better error recovery when we encounter a git merge marker.  This
	        // allows us to edit files with git-conflict markers in them in a much more pleasant manner.
	        SyntaxKind[SyntaxKind["ConflictMarkerTrivia"] = 7] = "ConflictMarkerTrivia";
	        // Literals
	        SyntaxKind[SyntaxKind["NumericLiteral"] = 8] = "NumericLiteral";
	        SyntaxKind[SyntaxKind["StringLiteral"] = 9] = "StringLiteral";
	        SyntaxKind[SyntaxKind["JsxText"] = 10] = "JsxText";
	        SyntaxKind[SyntaxKind["JsxTextAllWhiteSpaces"] = 11] = "JsxTextAllWhiteSpaces";
	        SyntaxKind[SyntaxKind["RegularExpressionLiteral"] = 12] = "RegularExpressionLiteral";
	        SyntaxKind[SyntaxKind["NoSubstitutionTemplateLiteral"] = 13] = "NoSubstitutionTemplateLiteral";
	        // Pseudo-literals
	        SyntaxKind[SyntaxKind["TemplateHead"] = 14] = "TemplateHead";
	        SyntaxKind[SyntaxKind["TemplateMiddle"] = 15] = "TemplateMiddle";
	        SyntaxKind[SyntaxKind["TemplateTail"] = 16] = "TemplateTail";
	        // Punctuation
	        SyntaxKind[SyntaxKind["OpenBraceToken"] = 17] = "OpenBraceToken";
	        SyntaxKind[SyntaxKind["CloseBraceToken"] = 18] = "CloseBraceToken";
	        SyntaxKind[SyntaxKind["OpenParenToken"] = 19] = "OpenParenToken";
	        SyntaxKind[SyntaxKind["CloseParenToken"] = 20] = "CloseParenToken";
	        SyntaxKind[SyntaxKind["OpenBracketToken"] = 21] = "OpenBracketToken";
	        SyntaxKind[SyntaxKind["CloseBracketToken"] = 22] = "CloseBracketToken";
	        SyntaxKind[SyntaxKind["DotToken"] = 23] = "DotToken";
	        SyntaxKind[SyntaxKind["DotDotDotToken"] = 24] = "DotDotDotToken";
	        SyntaxKind[SyntaxKind["SemicolonToken"] = 25] = "SemicolonToken";
	        SyntaxKind[SyntaxKind["CommaToken"] = 26] = "CommaToken";
	        SyntaxKind[SyntaxKind["LessThanToken"] = 27] = "LessThanToken";
	        SyntaxKind[SyntaxKind["LessThanSlashToken"] = 28] = "LessThanSlashToken";
	        SyntaxKind[SyntaxKind["GreaterThanToken"] = 29] = "GreaterThanToken";
	        SyntaxKind[SyntaxKind["LessThanEqualsToken"] = 30] = "LessThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanEqualsToken"] = 31] = "GreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsEqualsToken"] = 32] = "EqualsEqualsToken";
	        SyntaxKind[SyntaxKind["ExclamationEqualsToken"] = 33] = "ExclamationEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsEqualsEqualsToken"] = 34] = "EqualsEqualsEqualsToken";
	        SyntaxKind[SyntaxKind["ExclamationEqualsEqualsToken"] = 35] = "ExclamationEqualsEqualsToken";
	        SyntaxKind[SyntaxKind["EqualsGreaterThanToken"] = 36] = "EqualsGreaterThanToken";
	        SyntaxKind[SyntaxKind["PlusToken"] = 37] = "PlusToken";
	        SyntaxKind[SyntaxKind["MinusToken"] = 38] = "MinusToken";
	        SyntaxKind[SyntaxKind["AsteriskToken"] = 39] = "AsteriskToken";
	        SyntaxKind[SyntaxKind["AsteriskAsteriskToken"] = 40] = "AsteriskAsteriskToken";
	        SyntaxKind[SyntaxKind["SlashToken"] = 41] = "SlashToken";
	        SyntaxKind[SyntaxKind["PercentToken"] = 42] = "PercentToken";
	        SyntaxKind[SyntaxKind["PlusPlusToken"] = 43] = "PlusPlusToken";
	        SyntaxKind[SyntaxKind["MinusMinusToken"] = 44] = "MinusMinusToken";
	        SyntaxKind[SyntaxKind["LessThanLessThanToken"] = 45] = "LessThanLessThanToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanToken"] = 46] = "GreaterThanGreaterThanToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanGreaterThanToken"] = 47] = "GreaterThanGreaterThanGreaterThanToken";
	        SyntaxKind[SyntaxKind["AmpersandToken"] = 48] = "AmpersandToken";
	        SyntaxKind[SyntaxKind["BarToken"] = 49] = "BarToken";
	        SyntaxKind[SyntaxKind["CaretToken"] = 50] = "CaretToken";
	        SyntaxKind[SyntaxKind["ExclamationToken"] = 51] = "ExclamationToken";
	        SyntaxKind[SyntaxKind["TildeToken"] = 52] = "TildeToken";
	        SyntaxKind[SyntaxKind["AmpersandAmpersandToken"] = 53] = "AmpersandAmpersandToken";
	        SyntaxKind[SyntaxKind["BarBarToken"] = 54] = "BarBarToken";
	        SyntaxKind[SyntaxKind["QuestionToken"] = 55] = "QuestionToken";
	        SyntaxKind[SyntaxKind["ColonToken"] = 56] = "ColonToken";
	        SyntaxKind[SyntaxKind["AtToken"] = 57] = "AtToken";
	        // Assignments
	        SyntaxKind[SyntaxKind["EqualsToken"] = 58] = "EqualsToken";
	        SyntaxKind[SyntaxKind["PlusEqualsToken"] = 59] = "PlusEqualsToken";
	        SyntaxKind[SyntaxKind["MinusEqualsToken"] = 60] = "MinusEqualsToken";
	        SyntaxKind[SyntaxKind["AsteriskEqualsToken"] = 61] = "AsteriskEqualsToken";
	        SyntaxKind[SyntaxKind["AsteriskAsteriskEqualsToken"] = 62] = "AsteriskAsteriskEqualsToken";
	        SyntaxKind[SyntaxKind["SlashEqualsToken"] = 63] = "SlashEqualsToken";
	        SyntaxKind[SyntaxKind["PercentEqualsToken"] = 64] = "PercentEqualsToken";
	        SyntaxKind[SyntaxKind["LessThanLessThanEqualsToken"] = 65] = "LessThanLessThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanEqualsToken"] = 66] = "GreaterThanGreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["GreaterThanGreaterThanGreaterThanEqualsToken"] = 67] = "GreaterThanGreaterThanGreaterThanEqualsToken";
	        SyntaxKind[SyntaxKind["AmpersandEqualsToken"] = 68] = "AmpersandEqualsToken";
	        SyntaxKind[SyntaxKind["BarEqualsToken"] = 69] = "BarEqualsToken";
	        SyntaxKind[SyntaxKind["CaretEqualsToken"] = 70] = "CaretEqualsToken";
	        // Identifiers
	        SyntaxKind[SyntaxKind["Identifier"] = 71] = "Identifier";
	        // Reserved words
	        SyntaxKind[SyntaxKind["BreakKeyword"] = 72] = "BreakKeyword";
	        SyntaxKind[SyntaxKind["CaseKeyword"] = 73] = "CaseKeyword";
	        SyntaxKind[SyntaxKind["CatchKeyword"] = 74] = "CatchKeyword";
	        SyntaxKind[SyntaxKind["ClassKeyword"] = 75] = "ClassKeyword";
	        SyntaxKind[SyntaxKind["ConstKeyword"] = 76] = "ConstKeyword";
	        SyntaxKind[SyntaxKind["ContinueKeyword"] = 77] = "ContinueKeyword";
	        SyntaxKind[SyntaxKind["DebuggerKeyword"] = 78] = "DebuggerKeyword";
	        SyntaxKind[SyntaxKind["DefaultKeyword"] = 79] = "DefaultKeyword";
	        SyntaxKind[SyntaxKind["DeleteKeyword"] = 80] = "DeleteKeyword";
	        SyntaxKind[SyntaxKind["DoKeyword"] = 81] = "DoKeyword";
	        SyntaxKind[SyntaxKind["ElseKeyword"] = 82] = "ElseKeyword";
	        SyntaxKind[SyntaxKind["EnumKeyword"] = 83] = "EnumKeyword";
	        SyntaxKind[SyntaxKind["ExportKeyword"] = 84] = "ExportKeyword";
	        SyntaxKind[SyntaxKind["ExtendsKeyword"] = 85] = "ExtendsKeyword";
	        SyntaxKind[SyntaxKind["FalseKeyword"] = 86] = "FalseKeyword";
	        SyntaxKind[SyntaxKind["FinallyKeyword"] = 87] = "FinallyKeyword";
	        SyntaxKind[SyntaxKind["ForKeyword"] = 88] = "ForKeyword";
	        SyntaxKind[SyntaxKind["FunctionKeyword"] = 89] = "FunctionKeyword";
	        SyntaxKind[SyntaxKind["IfKeyword"] = 90] = "IfKeyword";
	        SyntaxKind[SyntaxKind["ImportKeyword"] = 91] = "ImportKeyword";
	        SyntaxKind[SyntaxKind["InKeyword"] = 92] = "InKeyword";
	        SyntaxKind[SyntaxKind["InstanceOfKeyword"] = 93] = "InstanceOfKeyword";
	        SyntaxKind[SyntaxKind["NewKeyword"] = 94] = "NewKeyword";
	        SyntaxKind[SyntaxKind["NullKeyword"] = 95] = "NullKeyword";
	        SyntaxKind[SyntaxKind["ReturnKeyword"] = 96] = "ReturnKeyword";
	        SyntaxKind[SyntaxKind["SuperKeyword"] = 97] = "SuperKeyword";
	        SyntaxKind[SyntaxKind["SwitchKeyword"] = 98] = "SwitchKeyword";
	        SyntaxKind[SyntaxKind["ThisKeyword"] = 99] = "ThisKeyword";
	        SyntaxKind[SyntaxKind["ThrowKeyword"] = 100] = "ThrowKeyword";
	        SyntaxKind[SyntaxKind["TrueKeyword"] = 101] = "TrueKeyword";
	        SyntaxKind[SyntaxKind["TryKeyword"] = 102] = "TryKeyword";
	        SyntaxKind[SyntaxKind["TypeOfKeyword"] = 103] = "TypeOfKeyword";
	        SyntaxKind[SyntaxKind["VarKeyword"] = 104] = "VarKeyword";
	        SyntaxKind[SyntaxKind["VoidKeyword"] = 105] = "VoidKeyword";
	        SyntaxKind[SyntaxKind["WhileKeyword"] = 106] = "WhileKeyword";
	        SyntaxKind[SyntaxKind["WithKeyword"] = 107] = "WithKeyword";
	        // Strict mode reserved words
	        SyntaxKind[SyntaxKind["ImplementsKeyword"] = 108] = "ImplementsKeyword";
	        SyntaxKind[SyntaxKind["InterfaceKeyword"] = 109] = "InterfaceKeyword";
	        SyntaxKind[SyntaxKind["LetKeyword"] = 110] = "LetKeyword";
	        SyntaxKind[SyntaxKind["PackageKeyword"] = 111] = "PackageKeyword";
	        SyntaxKind[SyntaxKind["PrivateKeyword"] = 112] = "PrivateKeyword";
	        SyntaxKind[SyntaxKind["ProtectedKeyword"] = 113] = "ProtectedKeyword";
	        SyntaxKind[SyntaxKind["PublicKeyword"] = 114] = "PublicKeyword";
	        SyntaxKind[SyntaxKind["StaticKeyword"] = 115] = "StaticKeyword";
	        SyntaxKind[SyntaxKind["YieldKeyword"] = 116] = "YieldKeyword";
	        // Contextual keywords
	        SyntaxKind[SyntaxKind["AbstractKeyword"] = 117] = "AbstractKeyword";
	        SyntaxKind[SyntaxKind["AsKeyword"] = 118] = "AsKeyword";
	        SyntaxKind[SyntaxKind["AnyKeyword"] = 119] = "AnyKeyword";
	        SyntaxKind[SyntaxKind["AsyncKeyword"] = 120] = "AsyncKeyword";
	        SyntaxKind[SyntaxKind["AwaitKeyword"] = 121] = "AwaitKeyword";
	        SyntaxKind[SyntaxKind["BooleanKeyword"] = 122] = "BooleanKeyword";
	        SyntaxKind[SyntaxKind["ConstructorKeyword"] = 123] = "ConstructorKeyword";
	        SyntaxKind[SyntaxKind["DeclareKeyword"] = 124] = "DeclareKeyword";
	        SyntaxKind[SyntaxKind["GetKeyword"] = 125] = "GetKeyword";
	        SyntaxKind[SyntaxKind["InferKeyword"] = 126] = "InferKeyword";
	        SyntaxKind[SyntaxKind["IsKeyword"] = 127] = "IsKeyword";
	        SyntaxKind[SyntaxKind["KeyOfKeyword"] = 128] = "KeyOfKeyword";
	        SyntaxKind[SyntaxKind["ModuleKeyword"] = 129] = "ModuleKeyword";
	        SyntaxKind[SyntaxKind["NamespaceKeyword"] = 130] = "NamespaceKeyword";
	        SyntaxKind[SyntaxKind["NeverKeyword"] = 131] = "NeverKeyword";
	        SyntaxKind[SyntaxKind["ReadonlyKeyword"] = 132] = "ReadonlyKeyword";
	        SyntaxKind[SyntaxKind["RequireKeyword"] = 133] = "RequireKeyword";
	        SyntaxKind[SyntaxKind["NumberKeyword"] = 134] = "NumberKeyword";
	        SyntaxKind[SyntaxKind["ObjectKeyword"] = 135] = "ObjectKeyword";
	        SyntaxKind[SyntaxKind["SetKeyword"] = 136] = "SetKeyword";
	        SyntaxKind[SyntaxKind["StringKeyword"] = 137] = "StringKeyword";
	        SyntaxKind[SyntaxKind["SymbolKeyword"] = 138] = "SymbolKeyword";
	        SyntaxKind[SyntaxKind["TypeKeyword"] = 139] = "TypeKeyword";
	        SyntaxKind[SyntaxKind["UndefinedKeyword"] = 140] = "UndefinedKeyword";
	        SyntaxKind[SyntaxKind["UniqueKeyword"] = 141] = "UniqueKeyword";
	        SyntaxKind[SyntaxKind["FromKeyword"] = 142] = "FromKeyword";
	        SyntaxKind[SyntaxKind["GlobalKeyword"] = 143] = "GlobalKeyword";
	        SyntaxKind[SyntaxKind["OfKeyword"] = 144] = "OfKeyword";
	        // Parse tree nodes
	        // Names
	        SyntaxKind[SyntaxKind["QualifiedName"] = 145] = "QualifiedName";
	        SyntaxKind[SyntaxKind["ComputedPropertyName"] = 146] = "ComputedPropertyName";
	        // Signature elements
	        SyntaxKind[SyntaxKind["TypeParameter"] = 147] = "TypeParameter";
	        SyntaxKind[SyntaxKind["Parameter"] = 148] = "Parameter";
	        SyntaxKind[SyntaxKind["Decorator"] = 149] = "Decorator";
	        // TypeMember
	        SyntaxKind[SyntaxKind["PropertySignature"] = 150] = "PropertySignature";
	        SyntaxKind[SyntaxKind["PropertyDeclaration"] = 151] = "PropertyDeclaration";
	        SyntaxKind[SyntaxKind["MethodSignature"] = 152] = "MethodSignature";
	        SyntaxKind[SyntaxKind["MethodDeclaration"] = 153] = "MethodDeclaration";
	        SyntaxKind[SyntaxKind["Constructor"] = 154] = "Constructor";
	        SyntaxKind[SyntaxKind["GetAccessor"] = 155] = "GetAccessor";
	        SyntaxKind[SyntaxKind["SetAccessor"] = 156] = "SetAccessor";
	        SyntaxKind[SyntaxKind["CallSignature"] = 157] = "CallSignature";
	        SyntaxKind[SyntaxKind["ConstructSignature"] = 158] = "ConstructSignature";
	        SyntaxKind[SyntaxKind["IndexSignature"] = 159] = "IndexSignature";
	        // Type
	        SyntaxKind[SyntaxKind["TypePredicate"] = 160] = "TypePredicate";
	        SyntaxKind[SyntaxKind["TypeReference"] = 161] = "TypeReference";
	        SyntaxKind[SyntaxKind["FunctionType"] = 162] = "FunctionType";
	        SyntaxKind[SyntaxKind["ConstructorType"] = 163] = "ConstructorType";
	        SyntaxKind[SyntaxKind["TypeQuery"] = 164] = "TypeQuery";
	        SyntaxKind[SyntaxKind["TypeLiteral"] = 165] = "TypeLiteral";
	        SyntaxKind[SyntaxKind["ArrayType"] = 166] = "ArrayType";
	        SyntaxKind[SyntaxKind["TupleType"] = 167] = "TupleType";
	        SyntaxKind[SyntaxKind["UnionType"] = 168] = "UnionType";
	        SyntaxKind[SyntaxKind["IntersectionType"] = 169] = "IntersectionType";
	        SyntaxKind[SyntaxKind["ConditionalType"] = 170] = "ConditionalType";
	        SyntaxKind[SyntaxKind["InferType"] = 171] = "InferType";
	        SyntaxKind[SyntaxKind["ParenthesizedType"] = 172] = "ParenthesizedType";
	        SyntaxKind[SyntaxKind["ThisType"] = 173] = "ThisType";
	        SyntaxKind[SyntaxKind["TypeOperator"] = 174] = "TypeOperator";
	        SyntaxKind[SyntaxKind["IndexedAccessType"] = 175] = "IndexedAccessType";
	        SyntaxKind[SyntaxKind["MappedType"] = 176] = "MappedType";
	        SyntaxKind[SyntaxKind["LiteralType"] = 177] = "LiteralType";
	        SyntaxKind[SyntaxKind["ImportType"] = 178] = "ImportType";
	        // Binding patterns
	        SyntaxKind[SyntaxKind["ObjectBindingPattern"] = 179] = "ObjectBindingPattern";
	        SyntaxKind[SyntaxKind["ArrayBindingPattern"] = 180] = "ArrayBindingPattern";
	        SyntaxKind[SyntaxKind["BindingElement"] = 181] = "BindingElement";
	        // Expression
	        SyntaxKind[SyntaxKind["ArrayLiteralExpression"] = 182] = "ArrayLiteralExpression";
	        SyntaxKind[SyntaxKind["ObjectLiteralExpression"] = 183] = "ObjectLiteralExpression";
	        SyntaxKind[SyntaxKind["PropertyAccessExpression"] = 184] = "PropertyAccessExpression";
	        SyntaxKind[SyntaxKind["ElementAccessExpression"] = 185] = "ElementAccessExpression";
	        SyntaxKind[SyntaxKind["CallExpression"] = 186] = "CallExpression";
	        SyntaxKind[SyntaxKind["NewExpression"] = 187] = "NewExpression";
	        SyntaxKind[SyntaxKind["TaggedTemplateExpression"] = 188] = "TaggedTemplateExpression";
	        SyntaxKind[SyntaxKind["TypeAssertionExpression"] = 189] = "TypeAssertionExpression";
	        SyntaxKind[SyntaxKind["ParenthesizedExpression"] = 190] = "ParenthesizedExpression";
	        SyntaxKind[SyntaxKind["FunctionExpression"] = 191] = "FunctionExpression";
	        SyntaxKind[SyntaxKind["ArrowFunction"] = 192] = "ArrowFunction";
	        SyntaxKind[SyntaxKind["DeleteExpression"] = 193] = "DeleteExpression";
	        SyntaxKind[SyntaxKind["TypeOfExpression"] = 194] = "TypeOfExpression";
	        SyntaxKind[SyntaxKind["VoidExpression"] = 195] = "VoidExpression";
	        SyntaxKind[SyntaxKind["AwaitExpression"] = 196] = "AwaitExpression";
	        SyntaxKind[SyntaxKind["PrefixUnaryExpression"] = 197] = "PrefixUnaryExpression";
	        SyntaxKind[SyntaxKind["PostfixUnaryExpression"] = 198] = "PostfixUnaryExpression";
	        SyntaxKind[SyntaxKind["BinaryExpression"] = 199] = "BinaryExpression";
	        SyntaxKind[SyntaxKind["ConditionalExpression"] = 200] = "ConditionalExpression";
	        SyntaxKind[SyntaxKind["TemplateExpression"] = 201] = "TemplateExpression";
	        SyntaxKind[SyntaxKind["YieldExpression"] = 202] = "YieldExpression";
	        SyntaxKind[SyntaxKind["SpreadElement"] = 203] = "SpreadElement";
	        SyntaxKind[SyntaxKind["ClassExpression"] = 204] = "ClassExpression";
	        SyntaxKind[SyntaxKind["OmittedExpression"] = 205] = "OmittedExpression";
	        SyntaxKind[SyntaxKind["ExpressionWithTypeArguments"] = 206] = "ExpressionWithTypeArguments";
	        SyntaxKind[SyntaxKind["AsExpression"] = 207] = "AsExpression";
	        SyntaxKind[SyntaxKind["NonNullExpression"] = 208] = "NonNullExpression";
	        SyntaxKind[SyntaxKind["MetaProperty"] = 209] = "MetaProperty";
	        // Misc
	        SyntaxKind[SyntaxKind["TemplateSpan"] = 210] = "TemplateSpan";
	        SyntaxKind[SyntaxKind["SemicolonClassElement"] = 211] = "SemicolonClassElement";
	        // Element
	        SyntaxKind[SyntaxKind["Block"] = 212] = "Block";
	        SyntaxKind[SyntaxKind["VariableStatement"] = 213] = "VariableStatement";
	        SyntaxKind[SyntaxKind["EmptyStatement"] = 214] = "EmptyStatement";
	        SyntaxKind[SyntaxKind["ExpressionStatement"] = 215] = "ExpressionStatement";
	        SyntaxKind[SyntaxKind["IfStatement"] = 216] = "IfStatement";
	        SyntaxKind[SyntaxKind["DoStatement"] = 217] = "DoStatement";
	        SyntaxKind[SyntaxKind["WhileStatement"] = 218] = "WhileStatement";
	        SyntaxKind[SyntaxKind["ForStatement"] = 219] = "ForStatement";
	        SyntaxKind[SyntaxKind["ForInStatement"] = 220] = "ForInStatement";
	        SyntaxKind[SyntaxKind["ForOfStatement"] = 221] = "ForOfStatement";
	        SyntaxKind[SyntaxKind["ContinueStatement"] = 222] = "ContinueStatement";
	        SyntaxKind[SyntaxKind["BreakStatement"] = 223] = "BreakStatement";
	        SyntaxKind[SyntaxKind["ReturnStatement"] = 224] = "ReturnStatement";
	        SyntaxKind[SyntaxKind["WithStatement"] = 225] = "WithStatement";
	        SyntaxKind[SyntaxKind["SwitchStatement"] = 226] = "SwitchStatement";
	        SyntaxKind[SyntaxKind["LabeledStatement"] = 227] = "LabeledStatement";
	        SyntaxKind[SyntaxKind["ThrowStatement"] = 228] = "ThrowStatement";
	        SyntaxKind[SyntaxKind["TryStatement"] = 229] = "TryStatement";
	        SyntaxKind[SyntaxKind["DebuggerStatement"] = 230] = "DebuggerStatement";
	        SyntaxKind[SyntaxKind["VariableDeclaration"] = 231] = "VariableDeclaration";
	        SyntaxKind[SyntaxKind["VariableDeclarationList"] = 232] = "VariableDeclarationList";
	        SyntaxKind[SyntaxKind["FunctionDeclaration"] = 233] = "FunctionDeclaration";
	        SyntaxKind[SyntaxKind["ClassDeclaration"] = 234] = "ClassDeclaration";
	        SyntaxKind[SyntaxKind["InterfaceDeclaration"] = 235] = "InterfaceDeclaration";
	        SyntaxKind[SyntaxKind["TypeAliasDeclaration"] = 236] = "TypeAliasDeclaration";
	        SyntaxKind[SyntaxKind["EnumDeclaration"] = 237] = "EnumDeclaration";
	        SyntaxKind[SyntaxKind["ModuleDeclaration"] = 238] = "ModuleDeclaration";
	        SyntaxKind[SyntaxKind["ModuleBlock"] = 239] = "ModuleBlock";
	        SyntaxKind[SyntaxKind["CaseBlock"] = 240] = "CaseBlock";
	        SyntaxKind[SyntaxKind["NamespaceExportDeclaration"] = 241] = "NamespaceExportDeclaration";
	        SyntaxKind[SyntaxKind["ImportEqualsDeclaration"] = 242] = "ImportEqualsDeclaration";
	        SyntaxKind[SyntaxKind["ImportDeclaration"] = 243] = "ImportDeclaration";
	        SyntaxKind[SyntaxKind["ImportClause"] = 244] = "ImportClause";
	        SyntaxKind[SyntaxKind["NamespaceImport"] = 245] = "NamespaceImport";
	        SyntaxKind[SyntaxKind["NamedImports"] = 246] = "NamedImports";
	        SyntaxKind[SyntaxKind["ImportSpecifier"] = 247] = "ImportSpecifier";
	        SyntaxKind[SyntaxKind["ExportAssignment"] = 248] = "ExportAssignment";
	        SyntaxKind[SyntaxKind["ExportDeclaration"] = 249] = "ExportDeclaration";
	        SyntaxKind[SyntaxKind["NamedExports"] = 250] = "NamedExports";
	        SyntaxKind[SyntaxKind["ExportSpecifier"] = 251] = "ExportSpecifier";
	        SyntaxKind[SyntaxKind["MissingDeclaration"] = 252] = "MissingDeclaration";
	        // Module references
	        SyntaxKind[SyntaxKind["ExternalModuleReference"] = 253] = "ExternalModuleReference";
	        // JSX
	        SyntaxKind[SyntaxKind["JsxElement"] = 254] = "JsxElement";
	        SyntaxKind[SyntaxKind["JsxSelfClosingElement"] = 255] = "JsxSelfClosingElement";
	        SyntaxKind[SyntaxKind["JsxOpeningElement"] = 256] = "JsxOpeningElement";
	        SyntaxKind[SyntaxKind["JsxClosingElement"] = 257] = "JsxClosingElement";
	        SyntaxKind[SyntaxKind["JsxFragment"] = 258] = "JsxFragment";
	        SyntaxKind[SyntaxKind["JsxOpeningFragment"] = 259] = "JsxOpeningFragment";
	        SyntaxKind[SyntaxKind["JsxClosingFragment"] = 260] = "JsxClosingFragment";
	        SyntaxKind[SyntaxKind["JsxAttribute"] = 261] = "JsxAttribute";
	        SyntaxKind[SyntaxKind["JsxAttributes"] = 262] = "JsxAttributes";
	        SyntaxKind[SyntaxKind["JsxSpreadAttribute"] = 263] = "JsxSpreadAttribute";
	        SyntaxKind[SyntaxKind["JsxExpression"] = 264] = "JsxExpression";
	        // Clauses
	        SyntaxKind[SyntaxKind["CaseClause"] = 265] = "CaseClause";
	        SyntaxKind[SyntaxKind["DefaultClause"] = 266] = "DefaultClause";
	        SyntaxKind[SyntaxKind["HeritageClause"] = 267] = "HeritageClause";
	        SyntaxKind[SyntaxKind["CatchClause"] = 268] = "CatchClause";
	        // Property assignments
	        SyntaxKind[SyntaxKind["PropertyAssignment"] = 269] = "PropertyAssignment";
	        SyntaxKind[SyntaxKind["ShorthandPropertyAssignment"] = 270] = "ShorthandPropertyAssignment";
	        SyntaxKind[SyntaxKind["SpreadAssignment"] = 271] = "SpreadAssignment";
	        // Enum
	        SyntaxKind[SyntaxKind["EnumMember"] = 272] = "EnumMember";
	        // Top-level nodes
	        SyntaxKind[SyntaxKind["SourceFile"] = 273] = "SourceFile";
	        SyntaxKind[SyntaxKind["Bundle"] = 274] = "Bundle";
	        SyntaxKind[SyntaxKind["UnparsedSource"] = 275] = "UnparsedSource";
	        SyntaxKind[SyntaxKind["InputFiles"] = 276] = "InputFiles";
	        // JSDoc nodes
	        SyntaxKind[SyntaxKind["JSDocTypeExpression"] = 277] = "JSDocTypeExpression";
	        // The * type
	        SyntaxKind[SyntaxKind["JSDocAllType"] = 278] = "JSDocAllType";
	        // The ? type
	        SyntaxKind[SyntaxKind["JSDocUnknownType"] = 279] = "JSDocUnknownType";
	        SyntaxKind[SyntaxKind["JSDocNullableType"] = 280] = "JSDocNullableType";
	        SyntaxKind[SyntaxKind["JSDocNonNullableType"] = 281] = "JSDocNonNullableType";
	        SyntaxKind[SyntaxKind["JSDocOptionalType"] = 282] = "JSDocOptionalType";
	        SyntaxKind[SyntaxKind["JSDocFunctionType"] = 283] = "JSDocFunctionType";
	        SyntaxKind[SyntaxKind["JSDocVariadicType"] = 284] = "JSDocVariadicType";
	        SyntaxKind[SyntaxKind["JSDocComment"] = 285] = "JSDocComment";
	        SyntaxKind[SyntaxKind["JSDocTypeLiteral"] = 286] = "JSDocTypeLiteral";
	        SyntaxKind[SyntaxKind["JSDocSignature"] = 287] = "JSDocSignature";
	        SyntaxKind[SyntaxKind["JSDocTag"] = 288] = "JSDocTag";
	        SyntaxKind[SyntaxKind["JSDocAugmentsTag"] = 289] = "JSDocAugmentsTag";
	        SyntaxKind[SyntaxKind["JSDocClassTag"] = 290] = "JSDocClassTag";
	        SyntaxKind[SyntaxKind["JSDocCallbackTag"] = 291] = "JSDocCallbackTag";
	        SyntaxKind[SyntaxKind["JSDocParameterTag"] = 292] = "JSDocParameterTag";
	        SyntaxKind[SyntaxKind["JSDocReturnTag"] = 293] = "JSDocReturnTag";
	        SyntaxKind[SyntaxKind["JSDocTypeTag"] = 294] = "JSDocTypeTag";
	        SyntaxKind[SyntaxKind["JSDocTemplateTag"] = 295] = "JSDocTemplateTag";
	        SyntaxKind[SyntaxKind["JSDocTypedefTag"] = 296] = "JSDocTypedefTag";
	        SyntaxKind[SyntaxKind["JSDocPropertyTag"] = 297] = "JSDocPropertyTag";
	        // Synthesized list
	        SyntaxKind[SyntaxKind["SyntaxList"] = 298] = "SyntaxList";
	        // Transformation nodes
	        SyntaxKind[SyntaxKind["NotEmittedStatement"] = 299] = "NotEmittedStatement";
	        SyntaxKind[SyntaxKind["PartiallyEmittedExpression"] = 300] = "PartiallyEmittedExpression";
	        SyntaxKind[SyntaxKind["CommaListExpression"] = 301] = "CommaListExpression";
	        SyntaxKind[SyntaxKind["MergeDeclarationMarker"] = 302] = "MergeDeclarationMarker";
	        SyntaxKind[SyntaxKind["EndOfDeclarationMarker"] = 303] = "EndOfDeclarationMarker";
	        // Enum value count
	        SyntaxKind[SyntaxKind["Count"] = 304] = "Count";
	        // Markers
	        SyntaxKind[SyntaxKind["FirstAssignment"] = 58] = "FirstAssignment";
	        SyntaxKind[SyntaxKind["LastAssignment"] = 70] = "LastAssignment";
	        SyntaxKind[SyntaxKind["FirstCompoundAssignment"] = 59] = "FirstCompoundAssignment";
	        SyntaxKind[SyntaxKind["LastCompoundAssignment"] = 70] = "LastCompoundAssignment";
	        SyntaxKind[SyntaxKind["FirstReservedWord"] = 72] = "FirstReservedWord";
	        SyntaxKind[SyntaxKind["LastReservedWord"] = 107] = "LastReservedWord";
	        SyntaxKind[SyntaxKind["FirstKeyword"] = 72] = "FirstKeyword";
	        SyntaxKind[SyntaxKind["LastKeyword"] = 144] = "LastKeyword";
	        SyntaxKind[SyntaxKind["FirstFutureReservedWord"] = 108] = "FirstFutureReservedWord";
	        SyntaxKind[SyntaxKind["LastFutureReservedWord"] = 116] = "LastFutureReservedWord";
	        SyntaxKind[SyntaxKind["FirstTypeNode"] = 160] = "FirstTypeNode";
	        SyntaxKind[SyntaxKind["LastTypeNode"] = 178] = "LastTypeNode";
	        SyntaxKind[SyntaxKind["FirstPunctuation"] = 17] = "FirstPunctuation";
	        SyntaxKind[SyntaxKind["LastPunctuation"] = 70] = "LastPunctuation";
	        SyntaxKind[SyntaxKind["FirstToken"] = 0] = "FirstToken";
	        SyntaxKind[SyntaxKind["LastToken"] = 144] = "LastToken";
	        SyntaxKind[SyntaxKind["FirstTriviaToken"] = 2] = "FirstTriviaToken";
	        SyntaxKind[SyntaxKind["LastTriviaToken"] = 7] = "LastTriviaToken";
	        SyntaxKind[SyntaxKind["FirstLiteralToken"] = 8] = "FirstLiteralToken";
	        SyntaxKind[SyntaxKind["LastLiteralToken"] = 13] = "LastLiteralToken";
	        SyntaxKind[SyntaxKind["FirstTemplateToken"] = 13] = "FirstTemplateToken";
	        SyntaxKind[SyntaxKind["LastTemplateToken"] = 16] = "LastTemplateToken";
	        SyntaxKind[SyntaxKind["FirstBinaryOperator"] = 27] = "FirstBinaryOperator";
	        SyntaxKind[SyntaxKind["LastBinaryOperator"] = 70] = "LastBinaryOperator";
	        SyntaxKind[SyntaxKind["FirstNode"] = 145] = "FirstNode";
	        SyntaxKind[SyntaxKind["FirstJSDocNode"] = 277] = "FirstJSDocNode";
	        SyntaxKind[SyntaxKind["LastJSDocNode"] = 297] = "LastJSDocNode";
	        SyntaxKind[SyntaxKind["FirstJSDocTagNode"] = 288] = "FirstJSDocTagNode";
	        SyntaxKind[SyntaxKind["LastJSDocTagNode"] = 297] = "LastJSDocTagNode";
	        /* @internal */ SyntaxKind[SyntaxKind["FirstContextualKeyword"] = 117] = "FirstContextualKeyword";
	        /* @internal */ SyntaxKind[SyntaxKind["LastContextualKeyword"] = 144] = "LastContextualKeyword";
	    })(SyntaxKind = ts.SyntaxKind || (ts.SyntaxKind = {}));
	    var NodeFlags;
	    (function (NodeFlags) {
	        NodeFlags[NodeFlags["None"] = 0] = "None";
	        NodeFlags[NodeFlags["Let"] = 1] = "Let";
	        NodeFlags[NodeFlags["Const"] = 2] = "Const";
	        NodeFlags[NodeFlags["NestedNamespace"] = 4] = "NestedNamespace";
	        NodeFlags[NodeFlags["Synthesized"] = 8] = "Synthesized";
	        NodeFlags[NodeFlags["Namespace"] = 16] = "Namespace";
	        NodeFlags[NodeFlags["ExportContext"] = 32] = "ExportContext";
	        NodeFlags[NodeFlags["ContainsThis"] = 64] = "ContainsThis";
	        NodeFlags[NodeFlags["HasImplicitReturn"] = 128] = "HasImplicitReturn";
	        NodeFlags[NodeFlags["HasExplicitReturn"] = 256] = "HasExplicitReturn";
	        NodeFlags[NodeFlags["GlobalAugmentation"] = 512] = "GlobalAugmentation";
	        NodeFlags[NodeFlags["HasAsyncFunctions"] = 1024] = "HasAsyncFunctions";
	        NodeFlags[NodeFlags["DisallowInContext"] = 2048] = "DisallowInContext";
	        NodeFlags[NodeFlags["YieldContext"] = 4096] = "YieldContext";
	        NodeFlags[NodeFlags["DecoratorContext"] = 8192] = "DecoratorContext";
	        NodeFlags[NodeFlags["AwaitContext"] = 16384] = "AwaitContext";
	        NodeFlags[NodeFlags["ThisNodeHasError"] = 32768] = "ThisNodeHasError";
	        NodeFlags[NodeFlags["JavaScriptFile"] = 65536] = "JavaScriptFile";
	        NodeFlags[NodeFlags["ThisNodeOrAnySubNodesHasError"] = 131072] = "ThisNodeOrAnySubNodesHasError";
	        NodeFlags[NodeFlags["HasAggregatedChildData"] = 262144] = "HasAggregatedChildData";
	        // These flags will be set when the parser encounters a dynamic import expression or 'import.meta' to avoid
	        // walking the tree if the flags are not set. However, these flags are just a approximation
	        // (hence why it's named "PossiblyContainsDynamicImport") because once set, the flags never get cleared.
	        // During editing, if a dynamic import is removed, incremental parsing will *NOT* clear this flag.
	        // This means that the tree will always be traversed during module resolution, or when looking for external module indicators.
	        // However, the removal operation should not occur often and in the case of the
	        // removal, it is likely that users will add the import anyway.
	        // The advantage of this approach is its simplicity. For the case of batch compilation,
	        // we guarantee that users won't have to pay the price of walking the tree if a dynamic import isn't used.
	        /* @internal */ NodeFlags[NodeFlags["PossiblyContainsDynamicImport"] = 524288] = "PossiblyContainsDynamicImport";
	        /* @internal */ NodeFlags[NodeFlags["PossiblyContainsImportMeta"] = 1048576] = "PossiblyContainsImportMeta";
	        NodeFlags[NodeFlags["JSDoc"] = 2097152] = "JSDoc";
	        /* @internal */ NodeFlags[NodeFlags["Ambient"] = 4194304] = "Ambient";
	        /* @internal */ NodeFlags[NodeFlags["InWithStatement"] = 8388608] = "InWithStatement";
	        NodeFlags[NodeFlags["JsonFile"] = 16777216] = "JsonFile";
	        NodeFlags[NodeFlags["BlockScoped"] = 3] = "BlockScoped";
	        NodeFlags[NodeFlags["ReachabilityCheckFlags"] = 384] = "ReachabilityCheckFlags";
	        NodeFlags[NodeFlags["ReachabilityAndEmitFlags"] = 1408] = "ReachabilityAndEmitFlags";
	        // Parsing context flags
	        NodeFlags[NodeFlags["ContextFlags"] = 12679168] = "ContextFlags";
	        // Exclude these flags when parsing a Type
	        NodeFlags[NodeFlags["TypeExcludesFlags"] = 20480] = "TypeExcludesFlags";
	        // Represents all flags that are potentially set once and
	        // never cleared on SourceFiles which get re-used in between incremental parses.
	        // See the comment above on `PossiblyContainsDynamicImport` and `PossiblyContainsImportMeta`.
	        /* @internal */ NodeFlags[NodeFlags["PermanentlySetIncrementalFlags"] = 1572864] = "PermanentlySetIncrementalFlags";
	    })(NodeFlags = ts.NodeFlags || (ts.NodeFlags = {}));
	    var ModifierFlags;
	    (function (ModifierFlags) {
	        ModifierFlags[ModifierFlags["None"] = 0] = "None";
	        ModifierFlags[ModifierFlags["Export"] = 1] = "Export";
	        ModifierFlags[ModifierFlags["Ambient"] = 2] = "Ambient";
	        ModifierFlags[ModifierFlags["Public"] = 4] = "Public";
	        ModifierFlags[ModifierFlags["Private"] = 8] = "Private";
	        ModifierFlags[ModifierFlags["Protected"] = 16] = "Protected";
	        ModifierFlags[ModifierFlags["Static"] = 32] = "Static";
	        ModifierFlags[ModifierFlags["Readonly"] = 64] = "Readonly";
	        ModifierFlags[ModifierFlags["Abstract"] = 128] = "Abstract";
	        ModifierFlags[ModifierFlags["Async"] = 256] = "Async";
	        ModifierFlags[ModifierFlags["Default"] = 512] = "Default";
	        ModifierFlags[ModifierFlags["Const"] = 2048] = "Const";
	        ModifierFlags[ModifierFlags["HasComputedFlags"] = 536870912] = "HasComputedFlags";
	        ModifierFlags[ModifierFlags["AccessibilityModifier"] = 28] = "AccessibilityModifier";
	        // Accessibility modifiers and 'readonly' can be attached to a parameter in a constructor to make it a property.
	        ModifierFlags[ModifierFlags["ParameterPropertyModifier"] = 92] = "ParameterPropertyModifier";
	        ModifierFlags[ModifierFlags["NonPublicAccessibilityModifier"] = 24] = "NonPublicAccessibilityModifier";
	        ModifierFlags[ModifierFlags["TypeScriptModifier"] = 2270] = "TypeScriptModifier";
	        ModifierFlags[ModifierFlags["ExportDefault"] = 513] = "ExportDefault";
	        ModifierFlags[ModifierFlags["All"] = 3071] = "All";
	    })(ModifierFlags = ts.ModifierFlags || (ts.ModifierFlags = {}));
	    var JsxFlags;
	    (function (JsxFlags) {
	        JsxFlags[JsxFlags["None"] = 0] = "None";
	        /** An element from a named property of the JSX.IntrinsicElements interface */
	        JsxFlags[JsxFlags["IntrinsicNamedElement"] = 1] = "IntrinsicNamedElement";
	        /** An element inferred from the string index signature of the JSX.IntrinsicElements interface */
	        JsxFlags[JsxFlags["IntrinsicIndexedElement"] = 2] = "IntrinsicIndexedElement";
	        JsxFlags[JsxFlags["IntrinsicElement"] = 3] = "IntrinsicElement";
	    })(JsxFlags = ts.JsxFlags || (ts.JsxFlags = {}));
	    /* @internal */
	    var RelationComparisonResult;
	    (function (RelationComparisonResult) {
	        RelationComparisonResult[RelationComparisonResult["Succeeded"] = 1] = "Succeeded";
	        RelationComparisonResult[RelationComparisonResult["Failed"] = 2] = "Failed";
	        RelationComparisonResult[RelationComparisonResult["FailedAndReported"] = 3] = "FailedAndReported";
	    })(RelationComparisonResult = ts.RelationComparisonResult || (ts.RelationComparisonResult = {}));
	    /*@internal*/
	    var GeneratedIdentifierFlags;
	    (function (GeneratedIdentifierFlags) {
	        // Kinds
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["None"] = 0] = "None";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Auto"] = 1] = "Auto";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Loop"] = 2] = "Loop";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Unique"] = 3] = "Unique";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Node"] = 4] = "Node";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["KindMask"] = 7] = "KindMask";
	        // Flags
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["ReservedInNestedScopes"] = 8] = "ReservedInNestedScopes";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["Optimistic"] = 16] = "Optimistic";
	        GeneratedIdentifierFlags[GeneratedIdentifierFlags["FileLevel"] = 32] = "FileLevel";
	    })(GeneratedIdentifierFlags = ts.GeneratedIdentifierFlags || (ts.GeneratedIdentifierFlags = {}));
	    /* @internal */
	    var TokenFlags;
	    (function (TokenFlags) {
	        TokenFlags[TokenFlags["None"] = 0] = "None";
	        TokenFlags[TokenFlags["PrecedingLineBreak"] = 1] = "PrecedingLineBreak";
	        TokenFlags[TokenFlags["PrecedingJSDocComment"] = 2] = "PrecedingJSDocComment";
	        TokenFlags[TokenFlags["Unterminated"] = 4] = "Unterminated";
	        TokenFlags[TokenFlags["ExtendedUnicodeEscape"] = 8] = "ExtendedUnicodeEscape";
	        TokenFlags[TokenFlags["Scientific"] = 16] = "Scientific";
	        TokenFlags[TokenFlags["Octal"] = 32] = "Octal";
	        TokenFlags[TokenFlags["HexSpecifier"] = 64] = "HexSpecifier";
	        TokenFlags[TokenFlags["BinarySpecifier"] = 128] = "BinarySpecifier";
	        TokenFlags[TokenFlags["OctalSpecifier"] = 256] = "OctalSpecifier";
	        TokenFlags[TokenFlags["ContainsSeparator"] = 512] = "ContainsSeparator";
	        TokenFlags[TokenFlags["BinaryOrOctalSpecifier"] = 384] = "BinaryOrOctalSpecifier";
	        TokenFlags[TokenFlags["NumericLiteralFlags"] = 1008] = "NumericLiteralFlags";
	    })(TokenFlags = ts.TokenFlags || (ts.TokenFlags = {}));
	    var FlowFlags;
	    (function (FlowFlags) {
	        FlowFlags[FlowFlags["Unreachable"] = 1] = "Unreachable";
	        FlowFlags[FlowFlags["Start"] = 2] = "Start";
	        FlowFlags[FlowFlags["BranchLabel"] = 4] = "BranchLabel";
	        FlowFlags[FlowFlags["LoopLabel"] = 8] = "LoopLabel";
	        FlowFlags[FlowFlags["Assignment"] = 16] = "Assignment";
	        FlowFlags[FlowFlags["TrueCondition"] = 32] = "TrueCondition";
	        FlowFlags[FlowFlags["FalseCondition"] = 64] = "FalseCondition";
	        FlowFlags[FlowFlags["SwitchClause"] = 128] = "SwitchClause";
	        FlowFlags[FlowFlags["ArrayMutation"] = 256] = "ArrayMutation";
	        FlowFlags[FlowFlags["Referenced"] = 512] = "Referenced";
	        FlowFlags[FlowFlags["Shared"] = 1024] = "Shared";
	        FlowFlags[FlowFlags["PreFinally"] = 2048] = "PreFinally";
	        FlowFlags[FlowFlags["AfterFinally"] = 4096] = "AfterFinally";
	        FlowFlags[FlowFlags["Label"] = 12] = "Label";
	        FlowFlags[FlowFlags["Condition"] = 96] = "Condition";
	    })(FlowFlags = ts.FlowFlags || (ts.FlowFlags = {}));
	    var OperationCanceledException = /** @class */ (function () {
	        function OperationCanceledException() {
	        }
	        return OperationCanceledException;
	    }());
	    ts.OperationCanceledException = OperationCanceledException;
	    /* @internal */
	    var StructureIsReused;
	    (function (StructureIsReused) {
	        StructureIsReused[StructureIsReused["Not"] = 0] = "Not";
	        StructureIsReused[StructureIsReused["SafeModules"] = 1] = "SafeModules";
	        StructureIsReused[StructureIsReused["Completely"] = 2] = "Completely";
	    })(StructureIsReused = ts.StructureIsReused || (ts.StructureIsReused = {}));
	    /** Return code used by getEmitOutput function to indicate status of the function */
	    var ExitStatus;
	    (function (ExitStatus) {
	        // Compiler ran successfully.  Either this was a simple do-nothing compilation (for example,
	        // when -version or -help was provided, or this was a normal compilation, no diagnostics
	        // were produced, and all outputs were generated successfully.
	        ExitStatus[ExitStatus["Success"] = 0] = "Success";
	        // Diagnostics were produced and because of them no code was generated.
	        ExitStatus[ExitStatus["DiagnosticsPresent_OutputsSkipped"] = 1] = "DiagnosticsPresent_OutputsSkipped";
	        // Diagnostics were produced and outputs were generated in spite of them.
	        ExitStatus[ExitStatus["DiagnosticsPresent_OutputsGenerated"] = 2] = "DiagnosticsPresent_OutputsGenerated";
	    })(ExitStatus = ts.ExitStatus || (ts.ExitStatus = {}));
	    /* @internal */
	    var UnionReduction;
	    (function (UnionReduction) {
	        UnionReduction[UnionReduction["None"] = 0] = "None";
	        UnionReduction[UnionReduction["Literal"] = 1] = "Literal";
	        UnionReduction[UnionReduction["Subtype"] = 2] = "Subtype";
	    })(UnionReduction = ts.UnionReduction || (ts.UnionReduction = {}));
	    var NodeBuilderFlags;
	    (function (NodeBuilderFlags) {
	        NodeBuilderFlags[NodeBuilderFlags["None"] = 0] = "None";
	        // Options
	        NodeBuilderFlags[NodeBuilderFlags["NoTruncation"] = 1] = "NoTruncation";
	        NodeBuilderFlags[NodeBuilderFlags["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
	        NodeBuilderFlags[NodeBuilderFlags["GenerateNamesForShadowedTypeParams"] = 4] = "GenerateNamesForShadowedTypeParams";
	        NodeBuilderFlags[NodeBuilderFlags["UseStructuralFallback"] = 8] = "UseStructuralFallback";
	        NodeBuilderFlags[NodeBuilderFlags["ForbidIndexedAccessSymbolReferences"] = 16] = "ForbidIndexedAccessSymbolReferences";
	        NodeBuilderFlags[NodeBuilderFlags["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
	        NodeBuilderFlags[NodeBuilderFlags["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
	        NodeBuilderFlags[NodeBuilderFlags["UseOnlyExternalAliasing"] = 128] = "UseOnlyExternalAliasing";
	        NodeBuilderFlags[NodeBuilderFlags["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
	        NodeBuilderFlags[NodeBuilderFlags["WriteTypeParametersInQualifiedName"] = 512] = "WriteTypeParametersInQualifiedName";
	        NodeBuilderFlags[NodeBuilderFlags["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
	        NodeBuilderFlags[NodeBuilderFlags["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
	        NodeBuilderFlags[NodeBuilderFlags["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
	        NodeBuilderFlags[NodeBuilderFlags["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
	        // Error handling
	        NodeBuilderFlags[NodeBuilderFlags["AllowThisInObjectLiteral"] = 32768] = "AllowThisInObjectLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["AllowQualifedNameInPlaceOfIdentifier"] = 65536] = "AllowQualifedNameInPlaceOfIdentifier";
	        NodeBuilderFlags[NodeBuilderFlags["AllowAnonymousIdentifier"] = 131072] = "AllowAnonymousIdentifier";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyUnionOrIntersection"] = 262144] = "AllowEmptyUnionOrIntersection";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyTuple"] = 524288] = "AllowEmptyTuple";
	        NodeBuilderFlags[NodeBuilderFlags["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
	        NodeBuilderFlags[NodeBuilderFlags["AllowEmptyIndexInfoType"] = 2097152] = "AllowEmptyIndexInfoType";
	        NodeBuilderFlags[NodeBuilderFlags["IgnoreErrors"] = 3112960] = "IgnoreErrors";
	        // State
	        NodeBuilderFlags[NodeBuilderFlags["InObjectTypeLiteral"] = 4194304] = "InObjectTypeLiteral";
	        NodeBuilderFlags[NodeBuilderFlags["InTypeAlias"] = 8388608] = "InTypeAlias";
	        NodeBuilderFlags[NodeBuilderFlags["InInitialEntityName"] = 16777216] = "InInitialEntityName";
	        NodeBuilderFlags[NodeBuilderFlags["InReverseMappedType"] = 33554432] = "InReverseMappedType";
	    })(NodeBuilderFlags = ts.NodeBuilderFlags || (ts.NodeBuilderFlags = {}));
	    // Ensure the shared flags between this and `NodeBuilderFlags` stay in alignment
	    var TypeFormatFlags;
	    (function (TypeFormatFlags) {
	        TypeFormatFlags[TypeFormatFlags["None"] = 0] = "None";
	        TypeFormatFlags[TypeFormatFlags["NoTruncation"] = 1] = "NoTruncation";
	        TypeFormatFlags[TypeFormatFlags["WriteArrayAsGenericType"] = 2] = "WriteArrayAsGenericType";
	        // hole because there's a hole in node builder flags
	        TypeFormatFlags[TypeFormatFlags["UseStructuralFallback"] = 8] = "UseStructuralFallback";
	        // hole because there's a hole in node builder flags
	        TypeFormatFlags[TypeFormatFlags["WriteTypeArgumentsOfSignature"] = 32] = "WriteTypeArgumentsOfSignature";
	        TypeFormatFlags[TypeFormatFlags["UseFullyQualifiedType"] = 64] = "UseFullyQualifiedType";
	        // hole because `UseOnlyExternalAliasing` is here in node builder flags, but functions which take old flags use `SymbolFormatFlags` instead
	        TypeFormatFlags[TypeFormatFlags["SuppressAnyReturnType"] = 256] = "SuppressAnyReturnType";
	        // hole because `WriteTypeParametersInQualifiedName` is here in node builder flags, but functions which take old flags use `SymbolFormatFlags` for this instead
	        TypeFormatFlags[TypeFormatFlags["MultilineObjectLiterals"] = 1024] = "MultilineObjectLiterals";
	        TypeFormatFlags[TypeFormatFlags["WriteClassExpressionAsTypeLiteral"] = 2048] = "WriteClassExpressionAsTypeLiteral";
	        TypeFormatFlags[TypeFormatFlags["UseTypeOfFunction"] = 4096] = "UseTypeOfFunction";
	        TypeFormatFlags[TypeFormatFlags["OmitParameterModifiers"] = 8192] = "OmitParameterModifiers";
	        TypeFormatFlags[TypeFormatFlags["UseAliasDefinedOutsideCurrentScope"] = 16384] = "UseAliasDefinedOutsideCurrentScope";
	        // even though `T` can't be accessed in the current scope.
	        // Error Handling
	        TypeFormatFlags[TypeFormatFlags["AllowUniqueESSymbolType"] = 1048576] = "AllowUniqueESSymbolType";
	        // TypeFormatFlags exclusive
	        TypeFormatFlags[TypeFormatFlags["AddUndefined"] = 131072] = "AddUndefined";
	        TypeFormatFlags[TypeFormatFlags["WriteArrowStyleSignature"] = 262144] = "WriteArrowStyleSignature";
	        // State
	        TypeFormatFlags[TypeFormatFlags["InArrayType"] = 524288] = "InArrayType";
	        TypeFormatFlags[TypeFormatFlags["InElementType"] = 2097152] = "InElementType";
	        TypeFormatFlags[TypeFormatFlags["InFirstTypeArgument"] = 4194304] = "InFirstTypeArgument";
	        TypeFormatFlags[TypeFormatFlags["InTypeAlias"] = 8388608] = "InTypeAlias";
	        /** @deprecated */ TypeFormatFlags[TypeFormatFlags["WriteOwnNameForAnyLike"] = 0] = "WriteOwnNameForAnyLike";
	        TypeFormatFlags[TypeFormatFlags["NodeBuilderFlagsMask"] = 9469291] = "NodeBuilderFlagsMask";
	    })(TypeFormatFlags = ts.TypeFormatFlags || (ts.TypeFormatFlags = {}));
	    var SymbolFormatFlags;
	    (function (SymbolFormatFlags) {
	        SymbolFormatFlags[SymbolFormatFlags["None"] = 0] = "None";
	        // Write symbols's type argument if it is instantiated symbol
	        // eg. class C<T> { p: T }   <-- Show p as C<T>.p here
	        //     var a: C<number>;
	        //     var p = a.p; <--- Here p is property of C<number> so show it as C<number>.p instead of just C.p
	        SymbolFormatFlags[SymbolFormatFlags["WriteTypeParametersOrArguments"] = 1] = "WriteTypeParametersOrArguments";
	        // Use only external alias information to get the symbol name in the given context
	        // eg.  module m { export class c { } } import x = m.c;
	        // When this flag is specified m.c will be used to refer to the class instead of alias symbol x
	        SymbolFormatFlags[SymbolFormatFlags["UseOnlyExternalAliasing"] = 2] = "UseOnlyExternalAliasing";
	        // Build symbol name using any nodes needed, instead of just components of an entity name
	        SymbolFormatFlags[SymbolFormatFlags["AllowAnyNodeKind"] = 4] = "AllowAnyNodeKind";
	        // Prefer aliases which are not directly visible
	        SymbolFormatFlags[SymbolFormatFlags["UseAliasDefinedOutsideCurrentScope"] = 8] = "UseAliasDefinedOutsideCurrentScope";
	    })(SymbolFormatFlags = ts.SymbolFormatFlags || (ts.SymbolFormatFlags = {}));
	    /* @internal */
	    var SymbolAccessibility;
	    (function (SymbolAccessibility) {
	        SymbolAccessibility[SymbolAccessibility["Accessible"] = 0] = "Accessible";
	        SymbolAccessibility[SymbolAccessibility["NotAccessible"] = 1] = "NotAccessible";
	        SymbolAccessibility[SymbolAccessibility["CannotBeNamed"] = 2] = "CannotBeNamed";
	    })(SymbolAccessibility = ts.SymbolAccessibility || (ts.SymbolAccessibility = {}));
	    /* @internal */
	    var SyntheticSymbolKind;
	    (function (SyntheticSymbolKind) {
	        SyntheticSymbolKind[SyntheticSymbolKind["UnionOrIntersection"] = 0] = "UnionOrIntersection";
	        SyntheticSymbolKind[SyntheticSymbolKind["Spread"] = 1] = "Spread";
	    })(SyntheticSymbolKind = ts.SyntheticSymbolKind || (ts.SyntheticSymbolKind = {}));
	    var TypePredicateKind;
	    (function (TypePredicateKind) {
	        TypePredicateKind[TypePredicateKind["This"] = 0] = "This";
	        TypePredicateKind[TypePredicateKind["Identifier"] = 1] = "Identifier";
	    })(TypePredicateKind = ts.TypePredicateKind || (ts.TypePredicateKind = {}));
	    /** Indicates how to serialize the name for a TypeReferenceNode when emitting decorator metadata */
	    /* @internal */
	    var TypeReferenceSerializationKind;
	    (function (TypeReferenceSerializationKind) {
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["Unknown"] = 0] = "Unknown";
	        // should be emitted using a safe fallback.
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["TypeWithConstructSignatureAndValue"] = 1] = "TypeWithConstructSignatureAndValue";
	        // function that can be reached at runtime (e.g. a `class`
	        // declaration or a `var` declaration for the static side
	        // of a type, such as the global `Promise` type in lib.d.ts).
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["VoidNullableOrNeverType"] = 2] = "VoidNullableOrNeverType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["NumberLikeType"] = 3] = "NumberLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["StringLikeType"] = 4] = "StringLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["BooleanType"] = 5] = "BooleanType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ArrayLikeType"] = 6] = "ArrayLikeType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ESSymbolType"] = 7] = "ESSymbolType";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["Promise"] = 8] = "Promise";
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["TypeWithCallSignature"] = 9] = "TypeWithCallSignature";
	        // with call signatures.
	        TypeReferenceSerializationKind[TypeReferenceSerializationKind["ObjectType"] = 10] = "ObjectType";
	    })(TypeReferenceSerializationKind = ts.TypeReferenceSerializationKind || (ts.TypeReferenceSerializationKind = {}));
	    var SymbolFlags;
	    (function (SymbolFlags) {
	        SymbolFlags[SymbolFlags["None"] = 0] = "None";
	        SymbolFlags[SymbolFlags["FunctionScopedVariable"] = 1] = "FunctionScopedVariable";
	        SymbolFlags[SymbolFlags["BlockScopedVariable"] = 2] = "BlockScopedVariable";
	        SymbolFlags[SymbolFlags["Property"] = 4] = "Property";
	        SymbolFlags[SymbolFlags["EnumMember"] = 8] = "EnumMember";
	        SymbolFlags[SymbolFlags["Function"] = 16] = "Function";
	        SymbolFlags[SymbolFlags["Class"] = 32] = "Class";
	        SymbolFlags[SymbolFlags["Interface"] = 64] = "Interface";
	        SymbolFlags[SymbolFlags["ConstEnum"] = 128] = "ConstEnum";
	        SymbolFlags[SymbolFlags["RegularEnum"] = 256] = "RegularEnum";
	        SymbolFlags[SymbolFlags["ValueModule"] = 512] = "ValueModule";
	        SymbolFlags[SymbolFlags["NamespaceModule"] = 1024] = "NamespaceModule";
	        SymbolFlags[SymbolFlags["TypeLiteral"] = 2048] = "TypeLiteral";
	        SymbolFlags[SymbolFlags["ObjectLiteral"] = 4096] = "ObjectLiteral";
	        SymbolFlags[SymbolFlags["Method"] = 8192] = "Method";
	        SymbolFlags[SymbolFlags["Constructor"] = 16384] = "Constructor";
	        SymbolFlags[SymbolFlags["GetAccessor"] = 32768] = "GetAccessor";
	        SymbolFlags[SymbolFlags["SetAccessor"] = 65536] = "SetAccessor";
	        SymbolFlags[SymbolFlags["Signature"] = 131072] = "Signature";
	        SymbolFlags[SymbolFlags["TypeParameter"] = 262144] = "TypeParameter";
	        SymbolFlags[SymbolFlags["TypeAlias"] = 524288] = "TypeAlias";
	        SymbolFlags[SymbolFlags["ExportValue"] = 1048576] = "ExportValue";
	        SymbolFlags[SymbolFlags["Alias"] = 2097152] = "Alias";
	        SymbolFlags[SymbolFlags["Prototype"] = 4194304] = "Prototype";
	        SymbolFlags[SymbolFlags["ExportStar"] = 8388608] = "ExportStar";
	        SymbolFlags[SymbolFlags["Optional"] = 16777216] = "Optional";
	        SymbolFlags[SymbolFlags["Transient"] = 33554432] = "Transient";
	        SymbolFlags[SymbolFlags["JSContainer"] = 67108864] = "JSContainer";
	        /* @internal */
	        SymbolFlags[SymbolFlags["All"] = 67108863] = "All";
	        SymbolFlags[SymbolFlags["Enum"] = 384] = "Enum";
	        SymbolFlags[SymbolFlags["Variable"] = 3] = "Variable";
	        SymbolFlags[SymbolFlags["Value"] = 67216319] = "Value";
	        SymbolFlags[SymbolFlags["Type"] = 67901928] = "Type";
	        SymbolFlags[SymbolFlags["Namespace"] = 1920] = "Namespace";
	        SymbolFlags[SymbolFlags["Module"] = 1536] = "Module";
	        SymbolFlags[SymbolFlags["Accessor"] = 98304] = "Accessor";
	        // Variables can be redeclared, but can not redeclare a block-scoped declaration with the
	        // same name, or any other value that is not a variable, e.g. ValueModule or Class
	        SymbolFlags[SymbolFlags["FunctionScopedVariableExcludes"] = 67216318] = "FunctionScopedVariableExcludes";
	        // Block-scoped declarations are not allowed to be re-declared
	        // they can not merge with anything in the value space
	        SymbolFlags[SymbolFlags["BlockScopedVariableExcludes"] = 67216319] = "BlockScopedVariableExcludes";
	        SymbolFlags[SymbolFlags["ParameterExcludes"] = 67216319] = "ParameterExcludes";
	        SymbolFlags[SymbolFlags["PropertyExcludes"] = 0] = "PropertyExcludes";
	        SymbolFlags[SymbolFlags["EnumMemberExcludes"] = 68008959] = "EnumMemberExcludes";
	        SymbolFlags[SymbolFlags["FunctionExcludes"] = 67215791] = "FunctionExcludes";
	        SymbolFlags[SymbolFlags["ClassExcludes"] = 68008383] = "ClassExcludes";
	        SymbolFlags[SymbolFlags["InterfaceExcludes"] = 67901832] = "InterfaceExcludes";
	        SymbolFlags[SymbolFlags["RegularEnumExcludes"] = 68008191] = "RegularEnumExcludes";
	        SymbolFlags[SymbolFlags["ConstEnumExcludes"] = 68008831] = "ConstEnumExcludes";
	        SymbolFlags[SymbolFlags["ValueModuleExcludes"] = 67215503] = "ValueModuleExcludes";
	        SymbolFlags[SymbolFlags["NamespaceModuleExcludes"] = 0] = "NamespaceModuleExcludes";
	        SymbolFlags[SymbolFlags["MethodExcludes"] = 67208127] = "MethodExcludes";
	        SymbolFlags[SymbolFlags["GetAccessorExcludes"] = 67150783] = "GetAccessorExcludes";
	        SymbolFlags[SymbolFlags["SetAccessorExcludes"] = 67183551] = "SetAccessorExcludes";
	        SymbolFlags[SymbolFlags["TypeParameterExcludes"] = 67639784] = "TypeParameterExcludes";
	        SymbolFlags[SymbolFlags["TypeAliasExcludes"] = 67901928] = "TypeAliasExcludes";
	        SymbolFlags[SymbolFlags["AliasExcludes"] = 2097152] = "AliasExcludes";
	        SymbolFlags[SymbolFlags["ModuleMember"] = 2623475] = "ModuleMember";
	        SymbolFlags[SymbolFlags["ExportHasLocal"] = 944] = "ExportHasLocal";
	        SymbolFlags[SymbolFlags["HasExports"] = 1952] = "HasExports";
	        SymbolFlags[SymbolFlags["HasMembers"] = 6240] = "HasMembers";
	        SymbolFlags[SymbolFlags["BlockScoped"] = 418] = "BlockScoped";
	        SymbolFlags[SymbolFlags["PropertyOrAccessor"] = 98308] = "PropertyOrAccessor";
	        SymbolFlags[SymbolFlags["ClassMember"] = 106500] = "ClassMember";
	        /* @internal */
	        // The set of things we consider semantically classifiable.  Used to speed up the LS during
	        // classification.
	        SymbolFlags[SymbolFlags["Classifiable"] = 2885600] = "Classifiable";
	        /* @internal */
	        SymbolFlags[SymbolFlags["LateBindingContainer"] = 6240] = "LateBindingContainer";
	    })(SymbolFlags = ts.SymbolFlags || (ts.SymbolFlags = {}));
	    /* @internal */
	    var EnumKind;
	    (function (EnumKind) {
	        EnumKind[EnumKind["Numeric"] = 0] = "Numeric";
	        EnumKind[EnumKind["Literal"] = 1] = "Literal"; // Literal enum (each member has a TypeFlags.EnumLiteral type)
	    })(EnumKind = ts.EnumKind || (ts.EnumKind = {}));
	    /* @internal */
	    var CheckFlags;
	    (function (CheckFlags) {
	        CheckFlags[CheckFlags["Instantiated"] = 1] = "Instantiated";
	        CheckFlags[CheckFlags["SyntheticProperty"] = 2] = "SyntheticProperty";
	        CheckFlags[CheckFlags["SyntheticMethod"] = 4] = "SyntheticMethod";
	        CheckFlags[CheckFlags["Readonly"] = 8] = "Readonly";
	        CheckFlags[CheckFlags["Partial"] = 16] = "Partial";
	        CheckFlags[CheckFlags["HasNonUniformType"] = 32] = "HasNonUniformType";
	        CheckFlags[CheckFlags["ContainsPublic"] = 64] = "ContainsPublic";
	        CheckFlags[CheckFlags["ContainsProtected"] = 128] = "ContainsProtected";
	        CheckFlags[CheckFlags["ContainsPrivate"] = 256] = "ContainsPrivate";
	        CheckFlags[CheckFlags["ContainsStatic"] = 512] = "ContainsStatic";
	        CheckFlags[CheckFlags["Late"] = 1024] = "Late";
	        CheckFlags[CheckFlags["ReverseMapped"] = 2048] = "ReverseMapped";
	        CheckFlags[CheckFlags["Synthetic"] = 6] = "Synthetic";
	    })(CheckFlags = ts.CheckFlags || (ts.CheckFlags = {}));
	    var InternalSymbolName;
	    (function (InternalSymbolName) {
	        InternalSymbolName["Call"] = "__call";
	        InternalSymbolName["Constructor"] = "__constructor";
	        InternalSymbolName["New"] = "__new";
	        InternalSymbolName["Index"] = "__index";
	        InternalSymbolName["ExportStar"] = "__export";
	        InternalSymbolName["Global"] = "__global";
	        InternalSymbolName["Missing"] = "__missing";
	        InternalSymbolName["Type"] = "__type";
	        InternalSymbolName["Object"] = "__object";
	        InternalSymbolName["JSXAttributes"] = "__jsxAttributes";
	        InternalSymbolName["Class"] = "__class";
	        InternalSymbolName["Function"] = "__function";
	        InternalSymbolName["Computed"] = "__computed";
	        InternalSymbolName["Resolving"] = "__resolving__";
	        InternalSymbolName["ExportEquals"] = "export=";
	        InternalSymbolName["Default"] = "default";
	    })(InternalSymbolName = ts.InternalSymbolName || (ts.InternalSymbolName = {}));
	    /* @internal */
	    var NodeCheckFlags;
	    (function (NodeCheckFlags) {
	        NodeCheckFlags[NodeCheckFlags["TypeChecked"] = 1] = "TypeChecked";
	        NodeCheckFlags[NodeCheckFlags["LexicalThis"] = 2] = "LexicalThis";
	        NodeCheckFlags[NodeCheckFlags["CaptureThis"] = 4] = "CaptureThis";
	        NodeCheckFlags[NodeCheckFlags["CaptureNewTarget"] = 8] = "CaptureNewTarget";
	        NodeCheckFlags[NodeCheckFlags["SuperInstance"] = 256] = "SuperInstance";
	        NodeCheckFlags[NodeCheckFlags["SuperStatic"] = 512] = "SuperStatic";
	        NodeCheckFlags[NodeCheckFlags["ContextChecked"] = 1024] = "ContextChecked";
	        NodeCheckFlags[NodeCheckFlags["AsyncMethodWithSuper"] = 2048] = "AsyncMethodWithSuper";
	        NodeCheckFlags[NodeCheckFlags["AsyncMethodWithSuperBinding"] = 4096] = "AsyncMethodWithSuperBinding";
	        NodeCheckFlags[NodeCheckFlags["CaptureArguments"] = 8192] = "CaptureArguments";
	        NodeCheckFlags[NodeCheckFlags["EnumValuesComputed"] = 16384] = "EnumValuesComputed";
	        NodeCheckFlags[NodeCheckFlags["LexicalModuleMergesWithClass"] = 32768] = "LexicalModuleMergesWithClass";
	        NodeCheckFlags[NodeCheckFlags["LoopWithCapturedBlockScopedBinding"] = 65536] = "LoopWithCapturedBlockScopedBinding";
	        NodeCheckFlags[NodeCheckFlags["CapturedBlockScopedBinding"] = 131072] = "CapturedBlockScopedBinding";
	        NodeCheckFlags[NodeCheckFlags["BlockScopedBindingInLoop"] = 262144] = "BlockScopedBindingInLoop";
	        NodeCheckFlags[NodeCheckFlags["ClassWithBodyScopedClassBinding"] = 524288] = "ClassWithBodyScopedClassBinding";
	        NodeCheckFlags[NodeCheckFlags["BodyScopedClassBinding"] = 1048576] = "BodyScopedClassBinding";
	        NodeCheckFlags[NodeCheckFlags["NeedsLoopOutParameter"] = 2097152] = "NeedsLoopOutParameter";
	        NodeCheckFlags[NodeCheckFlags["AssignmentsMarked"] = 4194304] = "AssignmentsMarked";
	        NodeCheckFlags[NodeCheckFlags["ClassWithConstructorReference"] = 8388608] = "ClassWithConstructorReference";
	        NodeCheckFlags[NodeCheckFlags["ConstructorReferenceInClass"] = 16777216] = "ConstructorReferenceInClass";
	    })(NodeCheckFlags = ts.NodeCheckFlags || (ts.NodeCheckFlags = {}));
	    var TypeFlags;
	    (function (TypeFlags) {
	        TypeFlags[TypeFlags["Any"] = 1] = "Any";
	        TypeFlags[TypeFlags["String"] = 2] = "String";
	        TypeFlags[TypeFlags["Number"] = 4] = "Number";
	        TypeFlags[TypeFlags["Boolean"] = 8] = "Boolean";
	        TypeFlags[TypeFlags["Enum"] = 16] = "Enum";
	        TypeFlags[TypeFlags["StringLiteral"] = 32] = "StringLiteral";
	        TypeFlags[TypeFlags["NumberLiteral"] = 64] = "NumberLiteral";
	        TypeFlags[TypeFlags["BooleanLiteral"] = 128] = "BooleanLiteral";
	        TypeFlags[TypeFlags["EnumLiteral"] = 256] = "EnumLiteral";
	        TypeFlags[TypeFlags["ESSymbol"] = 512] = "ESSymbol";
	        TypeFlags[TypeFlags["UniqueESSymbol"] = 1024] = "UniqueESSymbol";
	        TypeFlags[TypeFlags["Void"] = 2048] = "Void";
	        TypeFlags[TypeFlags["Undefined"] = 4096] = "Undefined";
	        TypeFlags[TypeFlags["Null"] = 8192] = "Null";
	        TypeFlags[TypeFlags["Never"] = 16384] = "Never";
	        TypeFlags[TypeFlags["TypeParameter"] = 32768] = "TypeParameter";
	        TypeFlags[TypeFlags["Object"] = 65536] = "Object";
	        TypeFlags[TypeFlags["Union"] = 131072] = "Union";
	        TypeFlags[TypeFlags["Intersection"] = 262144] = "Intersection";
	        TypeFlags[TypeFlags["Index"] = 524288] = "Index";
	        TypeFlags[TypeFlags["IndexedAccess"] = 1048576] = "IndexedAccess";
	        TypeFlags[TypeFlags["Conditional"] = 2097152] = "Conditional";
	        TypeFlags[TypeFlags["Substitution"] = 4194304] = "Substitution";
	        /* @internal */
	        TypeFlags[TypeFlags["FreshLiteral"] = 8388608] = "FreshLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsWideningType"] = 16777216] = "ContainsWideningType";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsObjectLiteral"] = 33554432] = "ContainsObjectLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["ContainsAnyFunctionType"] = 67108864] = "ContainsAnyFunctionType";
	        TypeFlags[TypeFlags["NonPrimitive"] = 134217728] = "NonPrimitive";
	        /* @internal */
	        TypeFlags[TypeFlags["UnionOfUnitTypes"] = 268435456] = "UnionOfUnitTypes";
	        /* @internal */
	        TypeFlags[TypeFlags["GenericMappedType"] = 536870912] = "GenericMappedType";
	        /* @internal */
	        TypeFlags[TypeFlags["Nullable"] = 12288] = "Nullable";
	        TypeFlags[TypeFlags["Literal"] = 224] = "Literal";
	        TypeFlags[TypeFlags["Unit"] = 13536] = "Unit";
	        TypeFlags[TypeFlags["StringOrNumberLiteral"] = 96] = "StringOrNumberLiteral";
	        /* @internal */
	        TypeFlags[TypeFlags["StringOrNumberLiteralOrUnique"] = 1120] = "StringOrNumberLiteralOrUnique";
	        /* @internal */
	        TypeFlags[TypeFlags["DefinitelyFalsy"] = 14560] = "DefinitelyFalsy";
	        TypeFlags[TypeFlags["PossiblyFalsy"] = 14574] = "PossiblyFalsy";
	        /* @internal */
	        TypeFlags[TypeFlags["Intrinsic"] = 134249103] = "Intrinsic";
	        /* @internal */
	        TypeFlags[TypeFlags["Primitive"] = 16382] = "Primitive";
	        TypeFlags[TypeFlags["StringLike"] = 34] = "StringLike";
	        TypeFlags[TypeFlags["NumberLike"] = 84] = "NumberLike";
	        TypeFlags[TypeFlags["BooleanLike"] = 136] = "BooleanLike";
	        TypeFlags[TypeFlags["EnumLike"] = 272] = "EnumLike";
	        TypeFlags[TypeFlags["ESSymbolLike"] = 1536] = "ESSymbolLike";
	        TypeFlags[TypeFlags["VoidLike"] = 6144] = "VoidLike";
	        /* @internal */
	        TypeFlags[TypeFlags["DisjointDomains"] = 134233854] = "DisjointDomains";
	        TypeFlags[TypeFlags["UnionOrIntersection"] = 393216] = "UnionOrIntersection";
	        TypeFlags[TypeFlags["StructuredType"] = 458752] = "StructuredType";
	        TypeFlags[TypeFlags["TypeVariable"] = 1081344] = "TypeVariable";
	        TypeFlags[TypeFlags["InstantiableNonPrimitive"] = 7372800] = "InstantiableNonPrimitive";
	        TypeFlags[TypeFlags["InstantiablePrimitive"] = 524288] = "InstantiablePrimitive";
	        TypeFlags[TypeFlags["Instantiable"] = 7897088] = "Instantiable";
	        TypeFlags[TypeFlags["StructuredOrInstantiable"] = 8355840] = "StructuredOrInstantiable";
	        // 'Narrowable' types are types where narrowing actually narrows.
	        // This *should* be every type other than null, undefined, void, and never
	        TypeFlags[TypeFlags["Narrowable"] = 142575359] = "Narrowable";
	        TypeFlags[TypeFlags["NotUnionOrUnit"] = 134283777] = "NotUnionOrUnit";
	        /* @internal */
	        TypeFlags[TypeFlags["NotUnit"] = 8374815] = "NotUnit";
	        /* @internal */
	        TypeFlags[TypeFlags["RequiresWidening"] = 50331648] = "RequiresWidening";
	        /* @internal */
	        TypeFlags[TypeFlags["PropagatingFlags"] = 117440512] = "PropagatingFlags";
	        // The following flags are used for different purposes during union and intersection type construction
	        /* @internal */
	        TypeFlags[TypeFlags["NonWideningType"] = 16777216] = "NonWideningType";
	        /* @internal */
	        TypeFlags[TypeFlags["Wildcard"] = 33554432] = "Wildcard";
	        /* @internal */
	        TypeFlags[TypeFlags["EmptyObject"] = 67108864] = "EmptyObject";
	        /* @internal */
	        TypeFlags[TypeFlags["ConstructionFlags"] = 117440512] = "ConstructionFlags";
	    })(TypeFlags = ts.TypeFlags || (ts.TypeFlags = {}));
	    var ObjectFlags;
	    (function (ObjectFlags) {
	        ObjectFlags[ObjectFlags["Class"] = 1] = "Class";
	        ObjectFlags[ObjectFlags["Interface"] = 2] = "Interface";
	        ObjectFlags[ObjectFlags["Reference"] = 4] = "Reference";
	        ObjectFlags[ObjectFlags["Tuple"] = 8] = "Tuple";
	        ObjectFlags[ObjectFlags["Anonymous"] = 16] = "Anonymous";
	        ObjectFlags[ObjectFlags["Mapped"] = 32] = "Mapped";
	        ObjectFlags[ObjectFlags["Instantiated"] = 64] = "Instantiated";
	        ObjectFlags[ObjectFlags["ObjectLiteral"] = 128] = "ObjectLiteral";
	        ObjectFlags[ObjectFlags["EvolvingArray"] = 256] = "EvolvingArray";
	        ObjectFlags[ObjectFlags["ObjectLiteralPatternWithComputedProperties"] = 512] = "ObjectLiteralPatternWithComputedProperties";
	        ObjectFlags[ObjectFlags["ContainsSpread"] = 1024] = "ContainsSpread";
	        ObjectFlags[ObjectFlags["ReverseMapped"] = 2048] = "ReverseMapped";
	        ObjectFlags[ObjectFlags["JsxAttributes"] = 4096] = "JsxAttributes";
	        ObjectFlags[ObjectFlags["MarkerType"] = 8192] = "MarkerType";
	        ObjectFlags[ObjectFlags["ClassOrInterface"] = 3] = "ClassOrInterface";
	    })(ObjectFlags = ts.ObjectFlags || (ts.ObjectFlags = {}));
	    /* @internal */
	    var Variance;
	    (function (Variance) {
	        Variance[Variance["Invariant"] = 0] = "Invariant";
	        Variance[Variance["Covariant"] = 1] = "Covariant";
	        Variance[Variance["Contravariant"] = 2] = "Contravariant";
	        Variance[Variance["Bivariant"] = 3] = "Bivariant";
	        Variance[Variance["Independent"] = 4] = "Independent";
	    })(Variance = ts.Variance || (ts.Variance = {}));
	    var SignatureKind;
	    (function (SignatureKind) {
	        SignatureKind[SignatureKind["Call"] = 0] = "Call";
	        SignatureKind[SignatureKind["Construct"] = 1] = "Construct";
	    })(SignatureKind = ts.SignatureKind || (ts.SignatureKind = {}));
	    var IndexKind;
	    (function (IndexKind) {
	        IndexKind[IndexKind["String"] = 0] = "String";
	        IndexKind[IndexKind["Number"] = 1] = "Number";
	    })(IndexKind = ts.IndexKind || (ts.IndexKind = {}));
	    var InferencePriority;
	    (function (InferencePriority) {
	        InferencePriority[InferencePriority["NakedTypeVariable"] = 1] = "NakedTypeVariable";
	        InferencePriority[InferencePriority["HomomorphicMappedType"] = 2] = "HomomorphicMappedType";
	        InferencePriority[InferencePriority["MappedTypeConstraint"] = 4] = "MappedTypeConstraint";
	        InferencePriority[InferencePriority["ReturnType"] = 8] = "ReturnType";
	        InferencePriority[InferencePriority["LiteralKeyof"] = 16] = "LiteralKeyof";
	        InferencePriority[InferencePriority["NoConstraints"] = 32] = "NoConstraints";
	        InferencePriority[InferencePriority["AlwaysStrict"] = 64] = "AlwaysStrict";
	        InferencePriority[InferencePriority["PriorityImpliesCombination"] = 28] = "PriorityImpliesCombination";
	    })(InferencePriority = ts.InferencePriority || (ts.InferencePriority = {}));
	    /* @internal */
	    var InferenceFlags;
	    (function (InferenceFlags) {
	        InferenceFlags[InferenceFlags["None"] = 0] = "None";
	        InferenceFlags[InferenceFlags["InferUnionTypes"] = 1] = "InferUnionTypes";
	        InferenceFlags[InferenceFlags["NoDefault"] = 2] = "NoDefault";
	        InferenceFlags[InferenceFlags["AnyDefault"] = 4] = "AnyDefault";
	    })(InferenceFlags = ts.InferenceFlags || (ts.InferenceFlags = {}));
	    /**
	     * Ternary values are defined such that
	     * x & y is False if either x or y is False.
	     * x & y is Maybe if either x or y is Maybe, but neither x or y is False.
	     * x & y is True if both x and y are True.
	     * x | y is False if both x and y are False.
	     * x | y is Maybe if either x or y is Maybe, but neither x or y is True.
	     * x | y is True if either x or y is True.
	     */
	    /* @internal */
	    var Ternary;
	    (function (Ternary) {
	        Ternary[Ternary["False"] = 0] = "False";
	        Ternary[Ternary["Maybe"] = 1] = "Maybe";
	        Ternary[Ternary["True"] = -1] = "True";
	    })(Ternary = ts.Ternary || (ts.Ternary = {}));
	    /* @internal */
	    var SpecialPropertyAssignmentKind;
	    (function (SpecialPropertyAssignmentKind) {
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["None"] = 0] = "None";
	        /// exports.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ExportsProperty"] = 1] = "ExportsProperty";
	        /// module.exports = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ModuleExports"] = 2] = "ModuleExports";
	        /// className.prototype.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["PrototypeProperty"] = 3] = "PrototypeProperty";
	        /// this.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["ThisProperty"] = 4] = "ThisProperty";
	        // F.name = expr
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["Property"] = 5] = "Property";
	        // F.prototype = { ... }
	        SpecialPropertyAssignmentKind[SpecialPropertyAssignmentKind["Prototype"] = 6] = "Prototype";
	    })(SpecialPropertyAssignmentKind = ts.SpecialPropertyAssignmentKind || (ts.SpecialPropertyAssignmentKind = {}));
	    var DiagnosticCategory;
	    (function (DiagnosticCategory) {
	        DiagnosticCategory[DiagnosticCategory["Warning"] = 0] = "Warning";
	        DiagnosticCategory[DiagnosticCategory["Error"] = 1] = "Error";
	        DiagnosticCategory[DiagnosticCategory["Suggestion"] = 2] = "Suggestion";
	        DiagnosticCategory[DiagnosticCategory["Message"] = 3] = "Message";
	    })(DiagnosticCategory = ts.DiagnosticCategory || (ts.DiagnosticCategory = {}));
	    /* @internal */
	    function diagnosticCategoryName(d, lowerCase) {
	        if (lowerCase === void 0) { lowerCase = true; }
	        var name = DiagnosticCategory[d.category];
	        return lowerCase ? name.toLowerCase() : name;
	    }
	    ts.diagnosticCategoryName = diagnosticCategoryName;
	    var ModuleResolutionKind;
	    (function (ModuleResolutionKind) {
	        ModuleResolutionKind[ModuleResolutionKind["Classic"] = 1] = "Classic";
	        ModuleResolutionKind[ModuleResolutionKind["NodeJs"] = 2] = "NodeJs";
	    })(ModuleResolutionKind = ts.ModuleResolutionKind || (ts.ModuleResolutionKind = {}));
	    var ModuleKind;
	    (function (ModuleKind) {
	        ModuleKind[ModuleKind["None"] = 0] = "None";
	        ModuleKind[ModuleKind["CommonJS"] = 1] = "CommonJS";
	        ModuleKind[ModuleKind["AMD"] = 2] = "AMD";
	        ModuleKind[ModuleKind["UMD"] = 3] = "UMD";
	        ModuleKind[ModuleKind["System"] = 4] = "System";
	        ModuleKind[ModuleKind["ES2015"] = 5] = "ES2015";
	        ModuleKind[ModuleKind["ESNext"] = 6] = "ESNext";
	    })(ModuleKind = ts.ModuleKind || (ts.ModuleKind = {}));
	    var JsxEmit;
	    (function (JsxEmit) {
	        JsxEmit[JsxEmit["None"] = 0] = "None";
	        JsxEmit[JsxEmit["Preserve"] = 1] = "Preserve";
	        JsxEmit[JsxEmit["React"] = 2] = "React";
	        JsxEmit[JsxEmit["ReactNative"] = 3] = "ReactNative";
	    })(JsxEmit = ts.JsxEmit || (ts.JsxEmit = {}));
	    var NewLineKind;
	    (function (NewLineKind) {
	        NewLineKind[NewLineKind["CarriageReturnLineFeed"] = 0] = "CarriageReturnLineFeed";
	        NewLineKind[NewLineKind["LineFeed"] = 1] = "LineFeed";
	    })(NewLineKind = ts.NewLineKind || (ts.NewLineKind = {}));
	    var ScriptKind;
	    (function (ScriptKind) {
	        ScriptKind[ScriptKind["Unknown"] = 0] = "Unknown";
	        ScriptKind[ScriptKind["JS"] = 1] = "JS";
	        ScriptKind[ScriptKind["JSX"] = 2] = "JSX";
	        ScriptKind[ScriptKind["TS"] = 3] = "TS";
	        ScriptKind[ScriptKind["TSX"] = 4] = "TSX";
	        ScriptKind[ScriptKind["External"] = 5] = "External";
	        ScriptKind[ScriptKind["JSON"] = 6] = "JSON";
	        /**
	         * Used on extensions that doesn't define the ScriptKind but the content defines it.
	         * Deferred extensions are going to be included in all project contexts.
	         */
	        ScriptKind[ScriptKind["Deferred"] = 7] = "Deferred";
	    })(ScriptKind = ts.ScriptKind || (ts.ScriptKind = {}));
	    var ScriptTarget;
	    (function (ScriptTarget) {
	        ScriptTarget[ScriptTarget["ES3"] = 0] = "ES3";
	        ScriptTarget[ScriptTarget["ES5"] = 1] = "ES5";
	        ScriptTarget[ScriptTarget["ES2015"] = 2] = "ES2015";
	        ScriptTarget[ScriptTarget["ES2016"] = 3] = "ES2016";
	        ScriptTarget[ScriptTarget["ES2017"] = 4] = "ES2017";
	        ScriptTarget[ScriptTarget["ES2018"] = 5] = "ES2018";
	        ScriptTarget[ScriptTarget["ESNext"] = 6] = "ESNext";
	        ScriptTarget[ScriptTarget["JSON"] = 100] = "JSON";
	        ScriptTarget[ScriptTarget["Latest"] = 6] = "Latest";
	    })(ScriptTarget = ts.ScriptTarget || (ts.ScriptTarget = {}));
	    var LanguageVariant;
	    (function (LanguageVariant) {
	        LanguageVariant[LanguageVariant["Standard"] = 0] = "Standard";
	        LanguageVariant[LanguageVariant["JSX"] = 1] = "JSX";
	    })(LanguageVariant = ts.LanguageVariant || (ts.LanguageVariant = {}));
	    var WatchDirectoryFlags;
	    (function (WatchDirectoryFlags) {
	        WatchDirectoryFlags[WatchDirectoryFlags["None"] = 0] = "None";
	        WatchDirectoryFlags[WatchDirectoryFlags["Recursive"] = 1] = "Recursive";
	    })(WatchDirectoryFlags = ts.WatchDirectoryFlags || (ts.WatchDirectoryFlags = {}));
	    /* @internal */
	    var CharacterCodes;
	    (function (CharacterCodes) {
	        CharacterCodes[CharacterCodes["nullCharacter"] = 0] = "nullCharacter";
	        CharacterCodes[CharacterCodes["maxAsciiCharacter"] = 127] = "maxAsciiCharacter";
	        CharacterCodes[CharacterCodes["lineFeed"] = 10] = "lineFeed";
	        CharacterCodes[CharacterCodes["carriageReturn"] = 13] = "carriageReturn";
	        CharacterCodes[CharacterCodes["lineSeparator"] = 8232] = "lineSeparator";
	        CharacterCodes[CharacterCodes["paragraphSeparator"] = 8233] = "paragraphSeparator";
	        CharacterCodes[CharacterCodes["nextLine"] = 133] = "nextLine";
	        // Unicode 3.0 space characters
	        CharacterCodes[CharacterCodes["space"] = 32] = "space";
	        CharacterCodes[CharacterCodes["nonBreakingSpace"] = 160] = "nonBreakingSpace";
	        CharacterCodes[CharacterCodes["enQuad"] = 8192] = "enQuad";
	        CharacterCodes[CharacterCodes["emQuad"] = 8193] = "emQuad";
	        CharacterCodes[CharacterCodes["enSpace"] = 8194] = "enSpace";
	        CharacterCodes[CharacterCodes["emSpace"] = 8195] = "emSpace";
	        CharacterCodes[CharacterCodes["threePerEmSpace"] = 8196] = "threePerEmSpace";
	        CharacterCodes[CharacterCodes["fourPerEmSpace"] = 8197] = "fourPerEmSpace";
	        CharacterCodes[CharacterCodes["sixPerEmSpace"] = 8198] = "sixPerEmSpace";
	        CharacterCodes[CharacterCodes["figureSpace"] = 8199] = "figureSpace";
	        CharacterCodes[CharacterCodes["punctuationSpace"] = 8200] = "punctuationSpace";
	        CharacterCodes[CharacterCodes["thinSpace"] = 8201] = "thinSpace";
	        CharacterCodes[CharacterCodes["hairSpace"] = 8202] = "hairSpace";
	        CharacterCodes[CharacterCodes["zeroWidthSpace"] = 8203] = "zeroWidthSpace";
	        CharacterCodes[CharacterCodes["narrowNoBreakSpace"] = 8239] = "narrowNoBreakSpace";
	        CharacterCodes[CharacterCodes["ideographicSpace"] = 12288] = "ideographicSpace";
	        CharacterCodes[CharacterCodes["mathematicalSpace"] = 8287] = "mathematicalSpace";
	        CharacterCodes[CharacterCodes["ogham"] = 5760] = "ogham";
	        CharacterCodes[CharacterCodes["_"] = 95] = "_";
	        CharacterCodes[CharacterCodes["$"] = 36] = "$";
	        CharacterCodes[CharacterCodes["_0"] = 48] = "_0";
	        CharacterCodes[CharacterCodes["_1"] = 49] = "_1";
	        CharacterCodes[CharacterCodes["_2"] = 50] = "_2";
	        CharacterCodes[CharacterCodes["_3"] = 51] = "_3";
	        CharacterCodes[CharacterCodes["_4"] = 52] = "_4";
	        CharacterCodes[CharacterCodes["_5"] = 53] = "_5";
	        CharacterCodes[CharacterCodes["_6"] = 54] = "_6";
	        CharacterCodes[CharacterCodes["_7"] = 55] = "_7";
	        CharacterCodes[CharacterCodes["_8"] = 56] = "_8";
	        CharacterCodes[CharacterCodes["_9"] = 57] = "_9";
	        CharacterCodes[CharacterCodes["a"] = 97] = "a";
	        CharacterCodes[CharacterCodes["b"] = 98] = "b";
	        CharacterCodes[CharacterCodes["c"] = 99] = "c";
	        CharacterCodes[CharacterCodes["d"] = 100] = "d";
	        CharacterCodes[CharacterCodes["e"] = 101] = "e";
	        CharacterCodes[CharacterCodes["f"] = 102] = "f";
	        CharacterCodes[CharacterCodes["g"] = 103] = "g";
	        CharacterCodes[CharacterCodes["h"] = 104] = "h";
	        CharacterCodes[CharacterCodes["i"] = 105] = "i";
	        CharacterCodes[CharacterCodes["j"] = 106] = "j";
	        CharacterCodes[CharacterCodes["k"] = 107] = "k";
	        CharacterCodes[CharacterCodes["l"] = 108] = "l";
	        CharacterCodes[CharacterCodes["m"] = 109] = "m";
	        CharacterCodes[CharacterCodes["n"] = 110] = "n";
	        CharacterCodes[CharacterCodes["o"] = 111] = "o";
	        CharacterCodes[CharacterCodes["p"] = 112] = "p";
	        CharacterCodes[CharacterCodes["q"] = 113] = "q";
	        CharacterCodes[CharacterCodes["r"] = 114] = "r";
	        CharacterCodes[CharacterCodes["s"] = 115] = "s";
	        CharacterCodes[CharacterCodes["t"] = 116] = "t";
	        CharacterCodes[CharacterCodes["u"] = 117] = "u";
	        CharacterCodes[CharacterCodes["v"] = 118] = "v";
	        CharacterCodes[CharacterCodes["w"] = 119] = "w";
	        CharacterCodes[CharacterCodes["x"] = 120] = "x";
	        CharacterCodes[CharacterCodes["y"] = 121] = "y";
	        CharacterCodes[CharacterCodes["z"] = 122] = "z";
	        CharacterCodes[CharacterCodes["A"] = 65] = "A";
	        CharacterCodes[CharacterCodes["B"] = 66] = "B";
	        CharacterCodes[CharacterCodes["C"] = 67] = "C";
	        CharacterCodes[CharacterCodes["D"] = 68] = "D";
	        CharacterCodes[CharacterCodes["E"] = 69] = "E";
	        CharacterCodes[CharacterCodes["F"] = 70] = "F";
	        CharacterCodes[CharacterCodes["G"] = 71] = "G";
	        CharacterCodes[CharacterCodes["H"] = 72] = "H";
	        CharacterCodes[CharacterCodes["I"] = 73] = "I";
	        CharacterCodes[CharacterCodes["J"] = 74] = "J";
	        CharacterCodes[CharacterCodes["K"] = 75] = "K";
	        CharacterCodes[CharacterCodes["L"] = 76] = "L";
	        CharacterCodes[CharacterCodes["M"] = 77] = "M";
	        CharacterCodes[CharacterCodes["N"] = 78] = "N";
	        CharacterCodes[CharacterCodes["O"] = 79] = "O";
	        CharacterCodes[CharacterCodes["P"] = 80] = "P";
	        CharacterCodes[CharacterCodes["Q"] = 81] = "Q";
	        CharacterCodes[CharacterCodes["R"] = 82] = "R";
	        CharacterCodes[CharacterCodes["S"] = 83] = "S";
	        CharacterCodes[CharacterCodes["T"] = 84] = "T";
	        CharacterCodes[CharacterCodes["U"] = 85] = "U";
	        CharacterCodes[CharacterCodes["V"] = 86] = "V";
	        CharacterCodes[CharacterCodes["W"] = 87] = "W";
	        CharacterCodes[CharacterCodes["X"] = 88] = "X";
	        CharacterCodes[CharacterCodes["Y"] = 89] = "Y";
	        CharacterCodes[CharacterCodes["Z"] = 90] = "Z";
	        CharacterCodes[CharacterCodes["ampersand"] = 38] = "ampersand";
	        CharacterCodes[CharacterCodes["asterisk"] = 42] = "asterisk";
	        CharacterCodes[CharacterCodes["at"] = 64] = "at";
	        CharacterCodes[CharacterCodes["backslash"] = 92] = "backslash";
	        CharacterCodes[CharacterCodes["backtick"] = 96] = "backtick";
	        CharacterCodes[CharacterCodes["bar"] = 124] = "bar";
	        CharacterCodes[CharacterCodes["caret"] = 94] = "caret";
	        CharacterCodes[CharacterCodes["closeBrace"] = 125] = "closeBrace";
	        CharacterCodes[CharacterCodes["closeBracket"] = 93] = "closeBracket";
	        CharacterCodes[CharacterCodes["closeParen"] = 41] = "closeParen";
	        CharacterCodes[CharacterCodes["colon"] = 58] = "colon";
	        CharacterCodes[CharacterCodes["comma"] = 44] = "comma";
	        CharacterCodes[CharacterCodes["dot"] = 46] = "dot";
	        CharacterCodes[CharacterCodes["doubleQuote"] = 34] = "doubleQuote";
	        CharacterCodes[CharacterCodes["equals"] = 61] = "equals";
	        CharacterCodes[CharacterCodes["exclamation"] = 33] = "exclamation";
	        CharacterCodes[CharacterCodes["greaterThan"] = 62] = "greaterThan";
	        CharacterCodes[CharacterCodes["hash"] = 35] = "hash";
	        CharacterCodes[CharacterCodes["lessThan"] = 60] = "lessThan";
	        CharacterCodes[CharacterCodes["minus"] = 45] = "minus";
	        CharacterCodes[CharacterCodes["openBrace"] = 123] = "openBrace";
	        CharacterCodes[CharacterCodes["openBracket"] = 91] = "openBracket";
	        CharacterCodes[CharacterCodes["openParen"] = 40] = "openParen";
	        CharacterCodes[CharacterCodes["percent"] = 37] = "percent";
	        CharacterCodes[CharacterCodes["plus"] = 43] = "plus";
	        CharacterCodes[CharacterCodes["question"] = 63] = "question";
	        CharacterCodes[CharacterCodes["semicolon"] = 59] = "semicolon";
	        CharacterCodes[CharacterCodes["singleQuote"] = 39] = "singleQuote";
	        CharacterCodes[CharacterCodes["slash"] = 47] = "slash";
	        CharacterCodes[CharacterCodes["tilde"] = 126] = "tilde";
	        CharacterCodes[CharacterCodes["backspace"] = 8] = "backspace";
	        CharacterCodes[CharacterCodes["formFeed"] = 12] = "formFeed";
	        CharacterCodes[CharacterCodes["byteOrderMark"] = 65279] = "byteOrderMark";
	        CharacterCodes[CharacterCodes["tab"] = 9] = "tab";
	        CharacterCodes[CharacterCodes["verticalTab"] = 11] = "verticalTab";
	    })(CharacterCodes = ts.CharacterCodes || (ts.CharacterCodes = {}));
	    var Extension;
	    (function (Extension) {
	        Extension["Ts"] = ".ts";
	        Extension["Tsx"] = ".tsx";
	        Extension["Dts"] = ".d.ts";
	        Extension["Js"] = ".js";
	        Extension["Jsx"] = ".jsx";
	        Extension["Json"] = ".json";
	    })(Extension = ts.Extension || (ts.Extension = {}));
	    /* @internal */
	    var TransformFlags;
	    (function (TransformFlags) {
	        TransformFlags[TransformFlags["None"] = 0] = "None";
	        // Facts
	        // - Flags used to indicate that a node or subtree contains syntax that requires transformation.
	        TransformFlags[TransformFlags["TypeScript"] = 1] = "TypeScript";
	        TransformFlags[TransformFlags["ContainsTypeScript"] = 2] = "ContainsTypeScript";
	        TransformFlags[TransformFlags["ContainsJsx"] = 4] = "ContainsJsx";
	        TransformFlags[TransformFlags["ContainsESNext"] = 8] = "ContainsESNext";
	        TransformFlags[TransformFlags["ContainsES2017"] = 16] = "ContainsES2017";
	        TransformFlags[TransformFlags["ContainsES2016"] = 32] = "ContainsES2016";
	        TransformFlags[TransformFlags["ES2015"] = 64] = "ES2015";
	        TransformFlags[TransformFlags["ContainsES2015"] = 128] = "ContainsES2015";
	        TransformFlags[TransformFlags["Generator"] = 256] = "Generator";
	        TransformFlags[TransformFlags["ContainsGenerator"] = 512] = "ContainsGenerator";
	        TransformFlags[TransformFlags["DestructuringAssignment"] = 1024] = "DestructuringAssignment";
	        TransformFlags[TransformFlags["ContainsDestructuringAssignment"] = 2048] = "ContainsDestructuringAssignment";
	        // Markers
	        // - Flags used to indicate that a subtree contains a specific transformation.
	        TransformFlags[TransformFlags["ContainsDecorators"] = 4096] = "ContainsDecorators";
	        TransformFlags[TransformFlags["ContainsPropertyInitializer"] = 8192] = "ContainsPropertyInitializer";
	        TransformFlags[TransformFlags["ContainsLexicalThis"] = 16384] = "ContainsLexicalThis";
	        TransformFlags[TransformFlags["ContainsCapturedLexicalThis"] = 32768] = "ContainsCapturedLexicalThis";
	        TransformFlags[TransformFlags["ContainsLexicalThisInComputedPropertyName"] = 65536] = "ContainsLexicalThisInComputedPropertyName";
	        TransformFlags[TransformFlags["ContainsDefaultValueAssignments"] = 131072] = "ContainsDefaultValueAssignments";
	        TransformFlags[TransformFlags["ContainsParameterPropertyAssignments"] = 262144] = "ContainsParameterPropertyAssignments";
	        TransformFlags[TransformFlags["ContainsSpread"] = 524288] = "ContainsSpread";
	        TransformFlags[TransformFlags["ContainsObjectSpread"] = 1048576] = "ContainsObjectSpread";
	        TransformFlags[TransformFlags["ContainsRest"] = 524288] = "ContainsRest";
	        TransformFlags[TransformFlags["ContainsObjectRest"] = 1048576] = "ContainsObjectRest";
	        TransformFlags[TransformFlags["ContainsComputedPropertyName"] = 2097152] = "ContainsComputedPropertyName";
	        TransformFlags[TransformFlags["ContainsBlockScopedBinding"] = 4194304] = "ContainsBlockScopedBinding";
	        TransformFlags[TransformFlags["ContainsBindingPattern"] = 8388608] = "ContainsBindingPattern";
	        TransformFlags[TransformFlags["ContainsYield"] = 16777216] = "ContainsYield";
	        TransformFlags[TransformFlags["ContainsHoistedDeclarationOrCompletion"] = 33554432] = "ContainsHoistedDeclarationOrCompletion";
	        TransformFlags[TransformFlags["ContainsDynamicImport"] = 67108864] = "ContainsDynamicImport";
	        TransformFlags[TransformFlags["Super"] = 134217728] = "Super";
	        TransformFlags[TransformFlags["ContainsSuper"] = 268435456] = "ContainsSuper";
	        // Please leave this as 1 << 29.
	        // It is the maximum bit we can set before we outgrow the size of a v8 small integer (SMI) on an x86 system.
	        // It is a good reminder of how much room we have left
	        TransformFlags[TransformFlags["HasComputedFlags"] = 536870912] = "HasComputedFlags";
	        // Assertions
	        // - Bitmasks that are used to assert facts about the syntax of a node and its subtree.
	        TransformFlags[TransformFlags["AssertTypeScript"] = 3] = "AssertTypeScript";
	        TransformFlags[TransformFlags["AssertJsx"] = 4] = "AssertJsx";
	        TransformFlags[TransformFlags["AssertESNext"] = 8] = "AssertESNext";
	        TransformFlags[TransformFlags["AssertES2017"] = 16] = "AssertES2017";
	        TransformFlags[TransformFlags["AssertES2016"] = 32] = "AssertES2016";
	        TransformFlags[TransformFlags["AssertES2015"] = 192] = "AssertES2015";
	        TransformFlags[TransformFlags["AssertGenerator"] = 768] = "AssertGenerator";
	        TransformFlags[TransformFlags["AssertDestructuringAssignment"] = 3072] = "AssertDestructuringAssignment";
	        // Scope Exclusions
	        // - Bitmasks that exclude flags from propagating out of a specific context
	        //   into the subtree flags of their container.
	        TransformFlags[TransformFlags["OuterExpressionExcludes"] = 536872257] = "OuterExpressionExcludes";
	        TransformFlags[TransformFlags["PropertyAccessExcludes"] = 671089985] = "PropertyAccessExcludes";
	        TransformFlags[TransformFlags["NodeExcludes"] = 939525441] = "NodeExcludes";
	        TransformFlags[TransformFlags["ArrowFunctionExcludes"] = 1003902273] = "ArrowFunctionExcludes";
	        TransformFlags[TransformFlags["FunctionExcludes"] = 1003935041] = "FunctionExcludes";
	        TransformFlags[TransformFlags["ConstructorExcludes"] = 1003668801] = "ConstructorExcludes";
	        TransformFlags[TransformFlags["MethodOrAccessorExcludes"] = 1003668801] = "MethodOrAccessorExcludes";
	        TransformFlags[TransformFlags["ClassExcludes"] = 942011713] = "ClassExcludes";
	        TransformFlags[TransformFlags["ModuleExcludes"] = 977327425] = "ModuleExcludes";
	        TransformFlags[TransformFlags["TypeExcludes"] = -3] = "TypeExcludes";
	        TransformFlags[TransformFlags["ObjectLiteralExcludes"] = 942740801] = "ObjectLiteralExcludes";
	        TransformFlags[TransformFlags["ArrayLiteralOrCallOrNewExcludes"] = 940049729] = "ArrayLiteralOrCallOrNewExcludes";
	        TransformFlags[TransformFlags["VariableDeclarationListExcludes"] = 948962625] = "VariableDeclarationListExcludes";
	        TransformFlags[TransformFlags["ParameterExcludes"] = 939525441] = "ParameterExcludes";
	        TransformFlags[TransformFlags["CatchClauseExcludes"] = 940574017] = "CatchClauseExcludes";
	        TransformFlags[TransformFlags["BindingPatternExcludes"] = 940049729] = "BindingPatternExcludes";
	        // Masks
	        // - Additional bitmasks
	        TransformFlags[TransformFlags["TypeScriptClassSyntaxMask"] = 274432] = "TypeScriptClassSyntaxMask";
	        TransformFlags[TransformFlags["ES2015FunctionSyntaxMask"] = 163840] = "ES2015FunctionSyntaxMask";
	    })(TransformFlags = ts.TransformFlags || (ts.TransformFlags = {}));
	    var EmitFlags;
	    (function (EmitFlags) {
	        EmitFlags[EmitFlags["SingleLine"] = 1] = "SingleLine";
	        EmitFlags[EmitFlags["AdviseOnEmitNode"] = 2] = "AdviseOnEmitNode";
	        EmitFlags[EmitFlags["NoSubstitution"] = 4] = "NoSubstitution";
	        EmitFlags[EmitFlags["CapturesThis"] = 8] = "CapturesThis";
	        EmitFlags[EmitFlags["NoLeadingSourceMap"] = 16] = "NoLeadingSourceMap";
	        EmitFlags[EmitFlags["NoTrailingSourceMap"] = 32] = "NoTrailingSourceMap";
	        EmitFlags[EmitFlags["NoSourceMap"] = 48] = "NoSourceMap";
	        EmitFlags[EmitFlags["NoNestedSourceMaps"] = 64] = "NoNestedSourceMaps";
	        EmitFlags[EmitFlags["NoTokenLeadingSourceMaps"] = 128] = "NoTokenLeadingSourceMaps";
	        EmitFlags[EmitFlags["NoTokenTrailingSourceMaps"] = 256] = "NoTokenTrailingSourceMaps";
	        EmitFlags[EmitFlags["NoTokenSourceMaps"] = 384] = "NoTokenSourceMaps";
	        EmitFlags[EmitFlags["NoLeadingComments"] = 512] = "NoLeadingComments";
	        EmitFlags[EmitFlags["NoTrailingComments"] = 1024] = "NoTrailingComments";
	        EmitFlags[EmitFlags["NoComments"] = 1536] = "NoComments";
	        EmitFlags[EmitFlags["NoNestedComments"] = 2048] = "NoNestedComments";
	        EmitFlags[EmitFlags["HelperName"] = 4096] = "HelperName";
	        EmitFlags[EmitFlags["ExportName"] = 8192] = "ExportName";
	        EmitFlags[EmitFlags["LocalName"] = 16384] = "LocalName";
	        EmitFlags[EmitFlags["InternalName"] = 32768] = "InternalName";
	        EmitFlags[EmitFlags["Indented"] = 65536] = "Indented";
	        EmitFlags[EmitFlags["NoIndentation"] = 131072] = "NoIndentation";
	        EmitFlags[EmitFlags["AsyncFunctionBody"] = 262144] = "AsyncFunctionBody";
	        EmitFlags[EmitFlags["ReuseTempVariableScope"] = 524288] = "ReuseTempVariableScope";
	        EmitFlags[EmitFlags["CustomPrologue"] = 1048576] = "CustomPrologue";
	        EmitFlags[EmitFlags["NoHoisting"] = 2097152] = "NoHoisting";
	        EmitFlags[EmitFlags["HasEndOfDeclarationMarker"] = 4194304] = "HasEndOfDeclarationMarker";
	        EmitFlags[EmitFlags["Iterator"] = 8388608] = "Iterator";
	        EmitFlags[EmitFlags["NoAsciiEscaping"] = 16777216] = "NoAsciiEscaping";
	        /*@internal*/ EmitFlags[EmitFlags["TypeScriptClassWrapper"] = 33554432] = "TypeScriptClassWrapper";
	        /*@internal*/ EmitFlags[EmitFlags["NeverApplyImportHelper"] = 67108864] = "NeverApplyImportHelper";
	    })(EmitFlags = ts.EmitFlags || (ts.EmitFlags = {}));
	    /**
	     * Used by the checker, this enum keeps track of external emit helpers that should be type
	     * checked.
	     */
	    /* @internal */
	    var ExternalEmitHelpers;
	    (function (ExternalEmitHelpers) {
	        ExternalEmitHelpers[ExternalEmitHelpers["Extends"] = 1] = "Extends";
	        ExternalEmitHelpers[ExternalEmitHelpers["Assign"] = 2] = "Assign";
	        ExternalEmitHelpers[ExternalEmitHelpers["Rest"] = 4] = "Rest";
	        ExternalEmitHelpers[ExternalEmitHelpers["Decorate"] = 8] = "Decorate";
	        ExternalEmitHelpers[ExternalEmitHelpers["Metadata"] = 16] = "Metadata";
	        ExternalEmitHelpers[ExternalEmitHelpers["Param"] = 32] = "Param";
	        ExternalEmitHelpers[ExternalEmitHelpers["Awaiter"] = 64] = "Awaiter";
	        ExternalEmitHelpers[ExternalEmitHelpers["Generator"] = 128] = "Generator";
	        ExternalEmitHelpers[ExternalEmitHelpers["Values"] = 256] = "Values";
	        ExternalEmitHelpers[ExternalEmitHelpers["Read"] = 512] = "Read";
	        ExternalEmitHelpers[ExternalEmitHelpers["Spread"] = 1024] = "Spread";
	        ExternalEmitHelpers[ExternalEmitHelpers["Await"] = 2048] = "Await";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncGenerator"] = 4096] = "AsyncGenerator";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncDelegator"] = 8192] = "AsyncDelegator";
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncValues"] = 16384] = "AsyncValues";
	        ExternalEmitHelpers[ExternalEmitHelpers["ExportStar"] = 32768] = "ExportStar";
	        ExternalEmitHelpers[ExternalEmitHelpers["MakeTemplateObject"] = 65536] = "MakeTemplateObject";
	        ExternalEmitHelpers[ExternalEmitHelpers["FirstEmitHelper"] = 1] = "FirstEmitHelper";
	        ExternalEmitHelpers[ExternalEmitHelpers["LastEmitHelper"] = 65536] = "LastEmitHelper";
	        // Helpers included by ES2015 for..of
	        ExternalEmitHelpers[ExternalEmitHelpers["ForOfIncludes"] = 256] = "ForOfIncludes";
	        // Helpers included by ES2017 for..await..of
	        ExternalEmitHelpers[ExternalEmitHelpers["ForAwaitOfIncludes"] = 16384] = "ForAwaitOfIncludes";
	        // Helpers included by ES2017 async generators
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncGeneratorIncludes"] = 6144] = "AsyncGeneratorIncludes";
	        // Helpers included by yield* in ES2017 async generators
	        ExternalEmitHelpers[ExternalEmitHelpers["AsyncDelegatorIncludes"] = 26624] = "AsyncDelegatorIncludes";
	        // Helpers included by ES2015 spread
	        ExternalEmitHelpers[ExternalEmitHelpers["SpreadIncludes"] = 1536] = "SpreadIncludes";
	    })(ExternalEmitHelpers = ts.ExternalEmitHelpers || (ts.ExternalEmitHelpers = {}));
	    var EmitHint;
	    (function (EmitHint) {
	        EmitHint[EmitHint["SourceFile"] = 0] = "SourceFile";
	        EmitHint[EmitHint["Expression"] = 1] = "Expression";
	        EmitHint[EmitHint["IdentifierName"] = 2] = "IdentifierName";
	        EmitHint[EmitHint["MappedTypeParameter"] = 3] = "MappedTypeParameter";
	        EmitHint[EmitHint["Unspecified"] = 4] = "Unspecified";
	    })(EmitHint = ts.EmitHint || (ts.EmitHint = {}));
	    var ListFormat;
	    (function (ListFormat) {
	        ListFormat[ListFormat["None"] = 0] = "None";
	        // Line separators
	        ListFormat[ListFormat["SingleLine"] = 0] = "SingleLine";
	        ListFormat[ListFormat["MultiLine"] = 1] = "MultiLine";
	        ListFormat[ListFormat["PreserveLines"] = 2] = "PreserveLines";
	        ListFormat[ListFormat["LinesMask"] = 3] = "LinesMask";
	        // Delimiters
	        ListFormat[ListFormat["NotDelimited"] = 0] = "NotDelimited";
	        ListFormat[ListFormat["BarDelimited"] = 4] = "BarDelimited";
	        ListFormat[ListFormat["AmpersandDelimited"] = 8] = "AmpersandDelimited";
	        ListFormat[ListFormat["CommaDelimited"] = 16] = "CommaDelimited";
	        ListFormat[ListFormat["DelimitersMask"] = 28] = "DelimitersMask";
	        ListFormat[ListFormat["AllowTrailingComma"] = 32] = "AllowTrailingComma";
	        // Whitespace
	        ListFormat[ListFormat["Indented"] = 64] = "Indented";
	        ListFormat[ListFormat["SpaceBetweenBraces"] = 128] = "SpaceBetweenBraces";
	        ListFormat[ListFormat["SpaceBetweenSiblings"] = 256] = "SpaceBetweenSiblings";
	        // Brackets/Braces
	        ListFormat[ListFormat["Braces"] = 512] = "Braces";
	        ListFormat[ListFormat["Parenthesis"] = 1024] = "Parenthesis";
	        ListFormat[ListFormat["AngleBrackets"] = 2048] = "AngleBrackets";
	        ListFormat[ListFormat["SquareBrackets"] = 4096] = "SquareBrackets";
	        ListFormat[ListFormat["BracketsMask"] = 7680] = "BracketsMask";
	        ListFormat[ListFormat["OptionalIfUndefined"] = 8192] = "OptionalIfUndefined";
	        ListFormat[ListFormat["OptionalIfEmpty"] = 16384] = "OptionalIfEmpty";
	        ListFormat[ListFormat["Optional"] = 24576] = "Optional";
	        // Other
	        ListFormat[ListFormat["PreferNewLine"] = 32768] = "PreferNewLine";
	        ListFormat[ListFormat["NoTrailingNewLine"] = 65536] = "NoTrailingNewLine";
	        ListFormat[ListFormat["NoInterveningComments"] = 131072] = "NoInterveningComments";
	        ListFormat[ListFormat["NoSpaceIfEmpty"] = 262144] = "NoSpaceIfEmpty";
	        ListFormat[ListFormat["SingleElement"] = 524288] = "SingleElement";
	        // Precomputed Formats
	        ListFormat[ListFormat["Modifiers"] = 131328] = "Modifiers";
	        ListFormat[ListFormat["HeritageClauses"] = 256] = "HeritageClauses";
	        ListFormat[ListFormat["SingleLineTypeLiteralMembers"] = 384] = "SingleLineTypeLiteralMembers";
	        ListFormat[ListFormat["MultiLineTypeLiteralMembers"] = 16449] = "MultiLineTypeLiteralMembers";
	        ListFormat[ListFormat["TupleTypeElements"] = 272] = "TupleTypeElements";
	        ListFormat[ListFormat["UnionTypeConstituents"] = 260] = "UnionTypeConstituents";
	        ListFormat[ListFormat["IntersectionTypeConstituents"] = 264] = "IntersectionTypeConstituents";
	        ListFormat[ListFormat["ObjectBindingPatternElements"] = 262576] = "ObjectBindingPatternElements";
	        ListFormat[ListFormat["ArrayBindingPatternElements"] = 262448] = "ArrayBindingPatternElements";
	        ListFormat[ListFormat["ObjectLiteralExpressionProperties"] = 263122] = "ObjectLiteralExpressionProperties";
	        ListFormat[ListFormat["ArrayLiteralExpressionElements"] = 4466] = "ArrayLiteralExpressionElements";
	        ListFormat[ListFormat["CommaListElements"] = 272] = "CommaListElements";
	        ListFormat[ListFormat["CallExpressionArguments"] = 1296] = "CallExpressionArguments";
	        ListFormat[ListFormat["NewExpressionArguments"] = 9488] = "NewExpressionArguments";
	        ListFormat[ListFormat["TemplateExpressionSpans"] = 131072] = "TemplateExpressionSpans";
	        ListFormat[ListFormat["SingleLineBlockStatements"] = 384] = "SingleLineBlockStatements";
	        ListFormat[ListFormat["MultiLineBlockStatements"] = 65] = "MultiLineBlockStatements";
	        ListFormat[ListFormat["VariableDeclarationList"] = 272] = "VariableDeclarationList";
	        ListFormat[ListFormat["SingleLineFunctionBodyStatements"] = 384] = "SingleLineFunctionBodyStatements";
	        ListFormat[ListFormat["MultiLineFunctionBodyStatements"] = 1] = "MultiLineFunctionBodyStatements";
	        ListFormat[ListFormat["ClassHeritageClauses"] = 0] = "ClassHeritageClauses";
	        ListFormat[ListFormat["ClassMembers"] = 65] = "ClassMembers";
	        ListFormat[ListFormat["InterfaceMembers"] = 65] = "InterfaceMembers";
	        ListFormat[ListFormat["EnumMembers"] = 81] = "EnumMembers";
	        ListFormat[ListFormat["CaseBlockClauses"] = 65] = "CaseBlockClauses";
	        ListFormat[ListFormat["NamedImportsOrExportsElements"] = 262576] = "NamedImportsOrExportsElements";
	        ListFormat[ListFormat["JsxElementOrFragmentChildren"] = 131072] = "JsxElementOrFragmentChildren";
	        ListFormat[ListFormat["JsxElementAttributes"] = 131328] = "JsxElementAttributes";
	        ListFormat[ListFormat["CaseOrDefaultClauseStatements"] = 81985] = "CaseOrDefaultClauseStatements";
	        ListFormat[ListFormat["HeritageClauseTypes"] = 272] = "HeritageClauseTypes";
	        ListFormat[ListFormat["SourceFileStatements"] = 65537] = "SourceFileStatements";
	        ListFormat[ListFormat["Decorators"] = 24577] = "Decorators";
	        ListFormat[ListFormat["TypeArguments"] = 26896] = "TypeArguments";
	        ListFormat[ListFormat["TypeParameters"] = 26896] = "TypeParameters";
	        ListFormat[ListFormat["Parameters"] = 1296] = "Parameters";
	        ListFormat[ListFormat["IndexSignatureParameters"] = 4432] = "IndexSignatureParameters";
	    })(ListFormat = ts.ListFormat || (ts.ListFormat = {}));
	    /* @internal */
	    var PragmaKindFlags;
	    (function (PragmaKindFlags) {
	        PragmaKindFlags[PragmaKindFlags["None"] = 0] = "None";
	        /**
	         * Triple slash comment of the form
	         * /// <pragma-name argname="value" />
	         */
	        PragmaKindFlags[PragmaKindFlags["TripleSlashXML"] = 1] = "TripleSlashXML";
	        /**
	         * Single line comment of the form
	         * // @pragma-name argval1 argval2
	         * or
	         * /// @pragma-name argval1 argval2
	         */
	        PragmaKindFlags[PragmaKindFlags["SingleLine"] = 2] = "SingleLine";
	        /**
	         * Multiline non-jsdoc pragma of the form
	         * /* @pragma-name argval1 argval2 * /
	         */
	        PragmaKindFlags[PragmaKindFlags["MultiLine"] = 4] = "MultiLine";
	        PragmaKindFlags[PragmaKindFlags["All"] = 7] = "All";
	        PragmaKindFlags[PragmaKindFlags["Default"] = 7] = "Default";
	    })(PragmaKindFlags = ts.PragmaKindFlags || (ts.PragmaKindFlags = {}));
	    /**
	     * This function only exists to cause exact types to be inferred for all the literals within `commentPragmas`
	     */
	    /* @internal */
	    function _contextuallyTypePragmas(args) {
	        return args;
	    }
	    // While not strictly a type, this is here because `PragmaMap` needs to be here to be used with `SourceFile`, and we don't
	    //  fancy effectively defining it twice, once in value-space and once in type-space
	    /* @internal */
	    ts.commentPragmas = _contextuallyTypePragmas({
	        "reference": {
	            args: [
	                { name: "types", optional: true, captureSpan: true },
	                { name: "path", optional: true, captureSpan: true },
	                { name: "no-default-lib", optional: true }
	            ],
	            kind: 1 /* TripleSlashXML */
	        },
	        "amd-dependency": {
	            args: [{ name: "path" }, { name: "name", optional: true }],
	            kind: 1 /* TripleSlashXML */
	        },
	        "amd-module": {
	            args: [{ name: "name" }],
	            kind: 1 /* TripleSlashXML */
	        },
	        "ts-check": {
	            kind: 2 /* SingleLine */
	        },
	        "ts-nocheck": {
	            kind: 2 /* SingleLine */
	        },
	        "jsx": {
	            args: [{ name: "factory" }],
	            kind: 4 /* MultiLine */
	        },
	    });
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    /** Gets a timestamp with (at least) ms resolution */
	    ts.timestamp = typeof performance !== "undefined" && performance.now ? function () { return performance.now(); } : Date.now ? Date.now : function () { return +(new Date()); };
	})(ts || (ts = {}));
	/*@internal*/
	/** Performance measurements for the compiler. */
	(function (ts) {
	    var performance;
	    (function (performance) {
	        // NOTE: cannot use ts.noop as core.ts loads after this
	        var profilerEvent = typeof onProfilerEvent === "function" && onProfilerEvent.profiler === true ? onProfilerEvent : function () { };
	        var enabled = false;
	        var profilerStart = 0;
	        var counts;
	        var marks;
	        var measures;
	        /**
	         * Marks a performance event.
	         *
	         * @param markName The name of the mark.
	         */
	        function mark(markName) {
	            if (enabled) {
	                marks.set(markName, ts.timestamp());
	                counts.set(markName, (counts.get(markName) || 0) + 1);
	                profilerEvent(markName);
	            }
	        }
	        performance.mark = mark;
	        /**
	         * Adds a performance measurement with the specified name.
	         *
	         * @param measureName The name of the performance measurement.
	         * @param startMarkName The name of the starting mark. If not supplied, the point at which the
	         *      profiler was enabled is used.
	         * @param endMarkName The name of the ending mark. If not supplied, the current timestamp is
	         *      used.
	         */
	        function measure(measureName, startMarkName, endMarkName) {
	            if (enabled) {
	                var end = endMarkName && marks.get(endMarkName) || ts.timestamp();
	                var start = startMarkName && marks.get(startMarkName) || profilerStart;
	                measures.set(measureName, (measures.get(measureName) || 0) + (end - start));
	            }
	        }
	        performance.measure = measure;
	        /**
	         * Gets the number of times a marker was encountered.
	         *
	         * @param markName The name of the mark.
	         */
	        function getCount(markName) {
	            return counts && counts.get(markName) || 0;
	        }
	        performance.getCount = getCount;
	        /**
	         * Gets the total duration of all measurements with the supplied name.
	         *
	         * @param measureName The name of the measure whose durations should be accumulated.
	         */
	        function getDuration(measureName) {
	            return measures && measures.get(measureName) || 0;
	        }
	        performance.getDuration = getDuration;
	        /**
	         * Iterate over each measure, performing some action
	         *
	         * @param cb The action to perform for each measure
	         */
	        function forEachMeasure(cb) {
	            measures.forEach(function (measure, key) {
	                cb(key, measure);
	            });
	        }
	        performance.forEachMeasure = forEachMeasure;
	        /** Enables (and resets) performance measurements for the compiler. */
	        function enable() {
	            counts = ts.createMap();
	            marks = ts.createMap();
	            measures = ts.createMap();
	            enabled = true;
	            profilerStart = ts.timestamp();
	        }
	        performance.enable = enable;
	        /** Disables performance measurements for the compiler. */
	        function disable() {
	            enabled = false;
	        }
	        performance.disable = disable;
	    })(performance = ts.performance || (ts.performance = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    // WARNING: The script `configureNightly.ts` uses a regexp to parse out these values.
	    // If changing the text in this section, be sure to test `configureNightly` too.
	    ts.versionMajorMinor = "2.9";
	    /** The version of the TypeScript compiler release */
	    ts.version = ts.versionMajorMinor + ".2";
	})(ts || (ts = {}));
	(function (ts) {
	    function isExternalModuleNameRelative(moduleName) {
	        // TypeScript 1.0 spec (April 2014): 11.2.1
	        // An external module name is "relative" if the first term is "." or "..".
	        // Update: We also consider a path like `C:\foo.ts` "relative" because we do not search for it in `node_modules` or treat it as an ambient module.
	        return ts.pathIsRelative(moduleName) || ts.isRootedDiskPath(moduleName);
	    }
	    ts.isExternalModuleNameRelative = isExternalModuleNameRelative;
	    function sortAndDeduplicateDiagnostics(diagnostics) {
	        return ts.sortAndDeduplicate(diagnostics, ts.compareDiagnostics);
	    }
	    ts.sortAndDeduplicateDiagnostics = sortAndDeduplicateDiagnostics;
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    ts.emptyArray = [];
	    function closeFileWatcher(watcher) {
	        watcher.close();
	    }
	    ts.closeFileWatcher = closeFileWatcher;
	    /** Create a MapLike with good performance. */
	    function createDictionaryObject() {
	        var map = Object.create(/*prototype*/ null); // tslint:disable-line:no-null-keyword
	        // Using 'delete' on an object causes V8 to put the object in dictionary mode.
	        // This disables creation of hidden classes, which are expensive when an object is
	        // constantly changing shape.
	        map.__ = undefined;
	        delete map.__;
	        return map;
	    }
	    /** Create a new map. If a template object is provided, the map will copy entries from it. */
	    function createMap() {
	        return new MapCtr();
	    }
	    ts.createMap = createMap;
	    /** Create a new escaped identifier map. */
	    function createUnderscoreEscapedMap() {
	        return new MapCtr();
	    }
	    ts.createUnderscoreEscapedMap = createUnderscoreEscapedMap;
	    function createSymbolTable(symbols) {
	        var result = createMap();
	        if (symbols) {
	            for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
	                var symbol = symbols_1[_i];
	                result.set(symbol.escapedName, symbol);
	            }
	        }
	        return result;
	    }
	    ts.createSymbolTable = createSymbolTable;
	    function createMapFromTemplate(template) {
	        var map = new MapCtr();
	        // Copies keys/values from template. Note that for..in will not throw if
	        // template is undefined, and instead will just exit the loop.
	        for (var key in template) {
	            if (hasOwnProperty.call(template, key)) {
	                map.set(key, template[key]);
	            }
	        }
	        return map;
	    }
	    ts.createMapFromTemplate = createMapFromTemplate;
	    // Internet Explorer's Map doesn't support iteration, so don't use it.
	    // tslint:disable-next-line no-in-operator variable-name
	    var MapCtr = typeof Map !== "undefined" && "entries" in Map.prototype ? Map : shimMap();
	    // Keep the class inside a function so it doesn't get compiled if it's not used.
	    function shimMap() {
	        var MapIterator = /** @class */ (function () {
	            function MapIterator(data, selector) {
	                this.index = 0;
	                this.data = data;
	                this.selector = selector;
	                this.keys = Object.keys(data);
	            }
	            MapIterator.prototype.next = function () {
	                var index = this.index;
	                if (index < this.keys.length) {
	                    this.index++;
	                    return { value: this.selector(this.data, this.keys[index]), done: false };
	                }
	                return { value: undefined, done: true };
	            };
	            return MapIterator;
	        }());
	        return /** @class */ (function () {
	            function class_1() {
	                this.data = createDictionaryObject();
	                this.size = 0;
	            }
	            class_1.prototype.get = function (key) {
	                return this.data[key];
	            };
	            class_1.prototype.set = function (key, value) {
	                if (!this.has(key)) {
	                    this.size++;
	                }
	                this.data[key] = value;
	                return this;
	            };
	            class_1.prototype.has = function (key) {
	                // tslint:disable-next-line:no-in-operator
	                return key in this.data;
	            };
	            class_1.prototype.delete = function (key) {
	                if (this.has(key)) {
	                    this.size--;
	                    delete this.data[key];
	                    return true;
	                }
	                return false;
	            };
	            class_1.prototype.clear = function () {
	                this.data = createDictionaryObject();
	                this.size = 0;
	            };
	            class_1.prototype.keys = function () {
	                return new MapIterator(this.data, function (_data, key) { return key; });
	            };
	            class_1.prototype.values = function () {
	                return new MapIterator(this.data, function (data, key) { return data[key]; });
	            };
	            class_1.prototype.entries = function () {
	                return new MapIterator(this.data, function (data, key) { return [key, data[key]]; });
	            };
	            class_1.prototype.forEach = function (action) {
	                for (var key in this.data) {
	                    action(this.data[key], key);
	                }
	            };
	            return class_1;
	        }());
	    }
	    function toPath(fileName, basePath, getCanonicalFileName) {
	        var nonCanonicalizedPath = isRootedDiskPath(fileName)
	            ? normalizePath(fileName)
	            : getNormalizedAbsolutePath(fileName, basePath);
	        return getCanonicalFileName(nonCanonicalizedPath);
	    }
	    ts.toPath = toPath;
	    function length(array) {
	        return array ? array.length : 0;
	    }
	    ts.length = length;
	    /**
	     * Iterates through 'array' by index and performs the callback on each element of array until the callback
	     * returns a truthy value, then returns that value.
	     * If no such value is found, the callback is applied to each element of array and undefined is returned.
	     */
	    function forEach(array, callback) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var result = callback(array[i], i);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.forEach = forEach;
	    /** Like `forEach`, but suitable for use with numbers and strings (which may be falsy). */
	    function firstDefined(array, callback) {
	        if (array === undefined) {
	            return undefined;
	        }
	        for (var i = 0; i < array.length; i++) {
	            var result = callback(array[i], i);
	            if (result !== undefined) {
	                return result;
	            }
	        }
	        return undefined;
	    }
	    ts.firstDefined = firstDefined;
	    function firstDefinedIterator(iter, callback) {
	        while (true) {
	            var _a = iter.next(), value = _a.value, done = _a.done;
	            if (done) {
	                return undefined;
	            }
	            var result = callback(value);
	            if (result !== undefined) {
	                return result;
	            }
	        }
	    }
	    ts.firstDefinedIterator = firstDefinedIterator;
	    function findAncestor(node, callback) {
	        while (node) {
	            var result = callback(node);
	            if (result === "quit") {
	                return undefined;
	            }
	            else if (result) {
	                return node;
	            }
	            node = node.parent;
	        }
	        return undefined;
	    }
	    ts.findAncestor = findAncestor;
	    function zipWith(arrayA, arrayB, callback) {
	        var result = [];
	        Debug.assertEqual(arrayA.length, arrayB.length);
	        for (var i = 0; i < arrayA.length; i++) {
	            result.push(callback(arrayA[i], arrayB[i], i));
	        }
	        return result;
	    }
	    ts.zipWith = zipWith;
	    function zipToIterator(arrayA, arrayB) {
	        Debug.assertEqual(arrayA.length, arrayB.length);
	        var i = 0;
	        return {
	            next: function () {
	                if (i === arrayA.length) {
	                    return { value: undefined, done: true };
	                }
	                i++;
	                return { value: [arrayA[i - 1], arrayB[i - 1]], done: false };
	            }
	        };
	    }
	    ts.zipToIterator = zipToIterator;
	    function zipToMap(keys, values) {
	        Debug.assert(keys.length === values.length);
	        var map = createMap();
	        for (var i = 0; i < keys.length; ++i) {
	            map.set(keys[i], values[i]);
	        }
	        return map;
	    }
	    ts.zipToMap = zipToMap;
	    /**
	     * Iterates through `array` by index and performs the callback on each element of array until the callback
	     * returns a falsey value, then returns false.
	     * If no such value is found, the callback is applied to each element of array and `true` is returned.
	     */
	    function every(array, callback) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                if (!callback(array[i], i)) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.every = every;
	    function find(array, predicate) {
	        for (var i = 0; i < array.length; i++) {
	            var value = array[i];
	            if (predicate(value, i)) {
	                return value;
	            }
	        }
	        return undefined;
	    }
	    ts.find = find;
	    function findLast(array, predicate) {
	        for (var i = array.length - 1; i >= 0; i--) {
	            var value = array[i];
	            if (predicate(value, i)) {
	                return value;
	            }
	        }
	        return undefined;
	    }
	    ts.findLast = findLast;
	    /** Works like Array.prototype.findIndex, returning `-1` if no element satisfying the predicate is found. */
	    function findIndex(array, predicate, startIndex) {
	        for (var i = startIndex || 0; i < array.length; i++) {
	            if (predicate(array[i], i)) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    ts.findIndex = findIndex;
	    function findLastIndex(array, predicate, startIndex) {
	        for (var i = startIndex === undefined ? array.length - 1 : startIndex; i >= 0; i--) {
	            if (predicate(array[i], i)) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    ts.findLastIndex = findLastIndex;
	    /**
	     * Returns the first truthy result of `callback`, or else fails.
	     * This is like `forEach`, but never returns undefined.
	     */
	    function findMap(array, callback) {
	        for (var i = 0; i < array.length; i++) {
	            var result = callback(array[i], i);
	            if (result) {
	                return result;
	            }
	        }
	        Debug.fail();
	    }
	    ts.findMap = findMap;
	    function contains(array, value, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (array) {
	            for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
	                var v = array_1[_i];
	                if (equalityComparer(v, value)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    }
	    ts.contains = contains;
	    function arraysEqual(a, b, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        return a.length === b.length && a.every(function (x, i) { return equalityComparer(x, b[i]); });
	    }
	    ts.arraysEqual = arraysEqual;
	    function indexOfAnyCharCode(text, charCodes, start) {
	        for (var i = start || 0; i < text.length; i++) {
	            if (contains(charCodes, text.charCodeAt(i))) {
	                return i;
	            }
	        }
	        return -1;
	    }
	    ts.indexOfAnyCharCode = indexOfAnyCharCode;
	    function countWhere(array, predicate) {
	        var count = 0;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var v = array[i];
	                if (predicate(v, i)) {
	                    count++;
	                }
	            }
	        }
	        return count;
	    }
	    ts.countWhere = countWhere;
	    function filter(array, f) {
	        if (array) {
	            var len = array.length;
	            var i = 0;
	            while (i < len && f(array[i]))
	                i++;
	            if (i < len) {
	                var result = array.slice(0, i);
	                i++;
	                while (i < len) {
	                    var item = array[i];
	                    if (f(item)) {
	                        result.push(item);
	                    }
	                    i++;
	                }
	                return result;
	            }
	        }
	        return array;
	    }
	    ts.filter = filter;
	    function filterMutate(array, f) {
	        var outIndex = 0;
	        for (var i = 0; i < array.length; i++) {
	            if (f(array[i], i, array)) {
	                array[outIndex] = array[i];
	                outIndex++;
	            }
	        }
	        array.length = outIndex;
	    }
	    ts.filterMutate = filterMutate;
	    function clear(array) {
	        array.length = 0;
	    }
	    ts.clear = clear;
	    function map(array, f) {
	        var result;
	        if (array) {
	            result = [];
	            for (var i = 0; i < array.length; i++) {
	                result.push(f(array[i], i));
	            }
	        }
	        return result;
	    }
	    ts.map = map;
	    function mapIterator(iter, mapFn) {
	        return {
	            next: function () {
	                var iterRes = iter.next();
	                return iterRes.done ? iterRes : { value: mapFn(iterRes.value), done: false };
	            }
	        };
	    }
	    ts.mapIterator = mapIterator;
	    function sameMap(array, f) {
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var item = array[i];
	                var mapped = f(item, i);
	                if (item !== mapped) {
	                    var result = array.slice(0, i);
	                    result.push(mapped);
	                    for (i++; i < array.length; i++) {
	                        result.push(f(array[i], i));
	                    }
	                    return result;
	                }
	            }
	        }
	        return array;
	    }
	    ts.sameMap = sameMap;
	    /**
	     * Flattens an array containing a mix of array or non-array elements.
	     *
	     * @param array The array to flatten.
	     */
	    function flatten(array) {
	        var result;
	        if (array) {
	            result = [];
	            for (var _i = 0, array_2 = array; _i < array_2.length; _i++) {
	                var v = array_2[_i];
	                if (v) {
	                    if (isArray(v)) {
	                        addRange(result, v);
	                    }
	                    else {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.flatten = flatten;
	    /**
	     * Maps an array. If the mapped value is an array, it is spread into the result.
	     *
	     * @param array The array to map.
	     * @param mapfn The callback used to map the result into one or more values.
	     */
	    function flatMap(array, mapfn) {
	        var result;
	        if (array) {
	            result = [];
	            for (var i = 0; i < array.length; i++) {
	                var v = mapfn(array[i], i);
	                if (v) {
	                    if (isArray(v)) {
	                        addRange(result, v);
	                    }
	                    else {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.flatMap = flatMap;
	    function flatMapIterator(iter, mapfn) {
	        var first = iter.next();
	        if (first.done) {
	            return ts.emptyIterator;
	        }
	        var currentIter = getIterator(first.value);
	        return {
	            next: function () {
	                while (true) {
	                    var currentRes = currentIter.next();
	                    if (!currentRes.done) {
	                        return currentRes;
	                    }
	                    var iterRes = iter.next();
	                    if (iterRes.done) {
	                        return iterRes;
	                    }
	                    currentIter = getIterator(iterRes.value);
	                }
	            },
	        };
	        function getIterator(x) {
	            var res = mapfn(x);
	            return res === undefined ? ts.emptyIterator : isArray(res) ? arrayIterator(res) : res;
	        }
	    }
	    ts.flatMapIterator = flatMapIterator;
	    function sameFlatMap(array, mapfn) {
	        var result;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var item = array[i];
	                var mapped = mapfn(item, i);
	                if (result || item !== mapped || isArray(mapped)) {
	                    if (!result) {
	                        result = array.slice(0, i);
	                    }
	                    if (isArray(mapped)) {
	                        addRange(result, mapped);
	                    }
	                    else {
	                        result.push(mapped);
	                    }
	                }
	            }
	        }
	        return result || array;
	    }
	    ts.sameFlatMap = sameFlatMap;
	    function mapAllOrFail(array, mapFn) {
	        var result = [];
	        for (var i = 0; i < array.length; i++) {
	            var mapped = mapFn(array[i], i);
	            if (mapped === undefined) {
	                return undefined;
	            }
	            result.push(mapped);
	        }
	        return result;
	    }
	    ts.mapAllOrFail = mapAllOrFail;
	    function mapDefined(array, mapFn) {
	        var result = [];
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var mapped = mapFn(array[i], i);
	                if (mapped !== undefined) {
	                    result.push(mapped);
	                }
	            }
	        }
	        return result;
	    }
	    ts.mapDefined = mapDefined;
	    function mapDefinedIterator(iter, mapFn) {
	        return {
	            next: function () {
	                while (true) {
	                    var res = iter.next();
	                    if (res.done) {
	                        return res;
	                    }
	                    var value = mapFn(res.value);
	                    if (value !== undefined) {
	                        return { value: value, done: false };
	                    }
	                }
	            }
	        };
	    }
	    ts.mapDefinedIterator = mapDefinedIterator;
	    ts.emptyIterator = { next: function () { return ({ value: undefined, done: true }); } };
	    function singleIterator(value) {
	        var done = false;
	        return {
	            next: function () {
	                var wasDone = done;
	                done = true;
	                return wasDone ? { value: undefined, done: true } : { value: value, done: false };
	            }
	        };
	    }
	    ts.singleIterator = singleIterator;
	    /**
	     * Maps contiguous spans of values with the same key.
	     *
	     * @param array The array to map.
	     * @param keyfn A callback used to select the key for an element.
	     * @param mapfn A callback used to map a contiguous chunk of values to a single value.
	     */
	    function spanMap(array, keyfn, mapfn) {
	        var result;
	        if (array) {
	            result = [];
	            var len = array.length;
	            var previousKey = void 0;
	            var key = void 0;
	            var start = 0;
	            var pos = 0;
	            while (start < len) {
	                while (pos < len) {
	                    var value = array[pos];
	                    key = keyfn(value, pos);
	                    if (pos === 0) {
	                        previousKey = key;
	                    }
	                    else if (key !== previousKey) {
	                        break;
	                    }
	                    pos++;
	                }
	                if (start < pos) {
	                    var v = mapfn(array.slice(start, pos), previousKey, start, pos);
	                    if (v) {
	                        result.push(v);
	                    }
	                    start = pos;
	                }
	                previousKey = key;
	                pos++;
	            }
	        }
	        return result;
	    }
	    ts.spanMap = spanMap;
	    function mapEntries(map, f) {
	        if (!map) {
	            return undefined;
	        }
	        var result = createMap();
	        map.forEach(function (value, key) {
	            var _a = f(key, value), newKey = _a[0], newValue = _a[1];
	            result.set(newKey, newValue);
	        });
	        return result;
	    }
	    ts.mapEntries = mapEntries;
	    function some(array, predicate) {
	        if (array) {
	            if (predicate) {
	                for (var _i = 0, array_3 = array; _i < array_3.length; _i++) {
	                    var v = array_3[_i];
	                    if (predicate(v)) {
	                        return true;
	                    }
	                }
	            }
	            else {
	                return array.length > 0;
	            }
	        }
	        return false;
	    }
	    ts.some = some;
	    /** Calls the callback with (start, afterEnd) index pairs for each range where 'pred' is true. */
	    function getRangesWhere(arr, pred, cb) {
	        var start;
	        for (var i = 0; i < arr.length; i++) {
	            if (pred(arr[i])) {
	                start = start === undefined ? i : start;
	            }
	            else {
	                if (start !== undefined) {
	                    cb(start, i);
	                    start = undefined;
	                }
	            }
	        }
	        if (start !== undefined)
	            cb(start, arr.length);
	    }
	    ts.getRangesWhere = getRangesWhere;
	    function concatenate(array1, array2) {
	        if (!some(array2))
	            return array1;
	        if (!some(array1))
	            return array2;
	        return array1.concat(array2);
	    }
	    ts.concatenate = concatenate;
	    function deduplicateRelational(array, equalityComparer, comparer) {
	        // Perform a stable sort of the array. This ensures the first entry in a list of
	        // duplicates remains the first entry in the result.
	        var indices = array.map(function (_, i) { return i; });
	        stableSortIndices(array, indices, comparer);
	        var last = array[indices[0]];
	        var deduplicated = [indices[0]];
	        for (var i = 1; i < indices.length; i++) {
	            var index = indices[i];
	            var item = array[index];
	            if (!equalityComparer(last, item)) {
	                deduplicated.push(index);
	                last = item;
	            }
	        }
	        // restore original order
	        deduplicated.sort();
	        return deduplicated.map(function (i) { return array[i]; });
	    }
	    function deduplicateEquality(array, equalityComparer) {
	        var result = [];
	        for (var _i = 0, array_4 = array; _i < array_4.length; _i++) {
	            var item = array_4[_i];
	            pushIfUnique(result, item, equalityComparer);
	        }
	        return result;
	    }
	    /**
	     * Deduplicates an unsorted array.
	     * @param equalityComparer An optional `EqualityComparer` used to determine if two values are duplicates.
	     * @param comparer An optional `Comparer` used to sort entries before comparison, though the
	     * result will remain in the original order in `array`.
	     */
	    function deduplicate(array, equalityComparer, comparer) {
	        return !array ? undefined :
	            array.length === 0 ? [] :
	                array.length === 1 ? array.slice() :
	                    comparer ? deduplicateRelational(array, equalityComparer, comparer) :
	                        deduplicateEquality(array, equalityComparer);
	    }
	    ts.deduplicate = deduplicate;
	    /**
	     * Deduplicates an array that has already been sorted.
	     */
	    function deduplicateSorted(array, comparer) {
	        if (!array)
	            return undefined;
	        if (array.length === 0)
	            return [];
	        var last = array[0];
	        var deduplicated = [last];
	        for (var i = 1; i < array.length; i++) {
	            var next = array[i];
	            switch (comparer(next, last)) {
	                // equality comparison
	                case true:
	                // relational comparison
	                case 0 /* EqualTo */:
	                    continue;
	                case -1 /* LessThan */:
	                    // If `array` is sorted, `next` should **never** be less than `last`.
	                    return Debug.fail("Array is unsorted.");
	            }
	            deduplicated.push(last = next);
	        }
	        return deduplicated;
	    }
	    function insertSorted(array, insert, compare) {
	        if (array.length === 0) {
	            array.push(insert);
	            return;
	        }
	        var insertIndex = binarySearch(array, insert, identity, compare);
	        if (insertIndex < 0) {
	            array.splice(~insertIndex, 0, insert);
	        }
	    }
	    ts.insertSorted = insertSorted;
	    function sortAndDeduplicate(array, comparer, equalityComparer) {
	        return deduplicateSorted(sort(array, comparer), equalityComparer || comparer);
	    }
	    ts.sortAndDeduplicate = sortAndDeduplicate;
	    function arrayIsEqualTo(array1, array2, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (!array1 || !array2) {
	            return array1 === array2;
	        }
	        if (array1.length !== array2.length) {
	            return false;
	        }
	        for (var i = 0; i < array1.length; i++) {
	            if (!equalityComparer(array1[i], array2[i])) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.arrayIsEqualTo = arrayIsEqualTo;
	    function changesAffectModuleResolution(oldOptions, newOptions) {
	        return !oldOptions ||
	            (oldOptions.module !== newOptions.module) ||
	            (oldOptions.moduleResolution !== newOptions.moduleResolution) ||
	            (oldOptions.noResolve !== newOptions.noResolve) ||
	            (oldOptions.target !== newOptions.target) ||
	            (oldOptions.noLib !== newOptions.noLib) ||
	            (oldOptions.jsx !== newOptions.jsx) ||
	            (oldOptions.allowJs !== newOptions.allowJs) ||
	            (oldOptions.rootDir !== newOptions.rootDir) ||
	            (oldOptions.configFilePath !== newOptions.configFilePath) ||
	            (oldOptions.baseUrl !== newOptions.baseUrl) ||
	            (oldOptions.maxNodeModuleJsDepth !== newOptions.maxNodeModuleJsDepth) ||
	            !arrayIsEqualTo(oldOptions.lib, newOptions.lib) ||
	            !arrayIsEqualTo(oldOptions.typeRoots, newOptions.typeRoots) ||
	            !arrayIsEqualTo(oldOptions.rootDirs, newOptions.rootDirs) ||
	            !equalOwnProperties(oldOptions.paths, newOptions.paths);
	    }
	    ts.changesAffectModuleResolution = changesAffectModuleResolution;
	    function compact(array) {
	        var result;
	        if (array) {
	            for (var i = 0; i < array.length; i++) {
	                var v = array[i];
	                if (result || !v) {
	                    if (!result) {
	                        result = array.slice(0, i);
	                    }
	                    if (v) {
	                        result.push(v);
	                    }
	                }
	            }
	        }
	        return result || array;
	    }
	    ts.compact = compact;
	    /**
	     * Gets the relative complement of `arrayA` with respect to `arrayB`, returning the elements that
	     * are not present in `arrayA` but are present in `arrayB`. Assumes both arrays are sorted
	     * based on the provided comparer.
	     */
	    function relativeComplement(arrayA, arrayB, comparer) {
	        if (!arrayB || !arrayA || arrayB.length === 0 || arrayA.length === 0)
	            return arrayB;
	        var result = [];
	        loopB: for (var offsetA = 0, offsetB = 0; offsetB < arrayB.length; offsetB++) {
	            if (offsetB > 0) {
	                // Ensure `arrayB` is properly sorted.
	                Debug.assertGreaterThanOrEqual(comparer(arrayB[offsetB], arrayB[offsetB - 1]), 0 /* EqualTo */);
	            }
	            loopA: for (var startA = offsetA; offsetA < arrayA.length; offsetA++) {
	                if (offsetA > startA) {
	                    // Ensure `arrayA` is properly sorted. We only need to perform this check if
	                    // `offsetA` has changed since we entered the loop.
	                    Debug.assertGreaterThanOrEqual(comparer(arrayA[offsetA], arrayA[offsetA - 1]), 0 /* EqualTo */);
	                }
	                switch (comparer(arrayB[offsetB], arrayA[offsetA])) {
	                    case -1 /* LessThan */:
	                        // If B is less than A, B does not exist in arrayA. Add B to the result and
	                        // move to the next element in arrayB without changing the current position
	                        // in arrayA.
	                        result.push(arrayB[offsetB]);
	                        continue loopB;
	                    case 0 /* EqualTo */:
	                        // If B is equal to A, B exists in arrayA. Move to the next element in
	                        // arrayB without adding B to the result or changing the current position
	                        // in arrayA.
	                        continue loopB;
	                    case 1 /* GreaterThan */:
	                        // If B is greater than A, we need to keep looking for B in arrayA. Move to
	                        // the next element in arrayA and recheck.
	                        continue loopA;
	                }
	            }
	        }
	        return result;
	    }
	    ts.relativeComplement = relativeComplement;
	    function sum(array, prop) {
	        var result = 0;
	        for (var _i = 0, array_5 = array; _i < array_5.length; _i++) {
	            var v = array_5[_i];
	            result += v[prop];
	        }
	        return result;
	    }
	    ts.sum = sum;
	    /**
	     * Appends a value to an array, returning the array.
	     *
	     * @param to The array to which `value` is to be appended. If `to` is `undefined`, a new array
	     * is created if `value` was appended.
	     * @param value The value to append to the array. If `value` is `undefined`, nothing is
	     * appended.
	     */
	    function append(to, value) {
	        if (value === undefined)
	            return to;
	        if (to === undefined)
	            return [value];
	        to.push(value);
	        return to;
	    }
	    ts.append = append;
	    /**
	     * Gets the actual offset into an array for a relative offset. Negative offsets indicate a
	     * position offset from the end of the array.
	     */
	    function toOffset(array, offset) {
	        return offset < 0 ? array.length + offset : offset;
	    }
	    /**
	     * Appends a range of value to an array, returning the array.
	     *
	     * @param to The array to which `value` is to be appended. If `to` is `undefined`, a new array
	     * is created if `value` was appended.
	     * @param from The values to append to the array. If `from` is `undefined`, nothing is
	     * appended. If an element of `from` is `undefined`, that element is not appended.
	     * @param start The offset in `from` at which to start copying values.
	     * @param end The offset in `from` at which to stop copying values (non-inclusive).
	     */
	    function addRange(to, from, start, end) {
	        if (from === undefined || from.length === 0)
	            return to;
	        if (to === undefined)
	            return from.slice(start, end);
	        start = start === undefined ? 0 : toOffset(from, start);
	        end = end === undefined ? from.length : toOffset(from, end);
	        for (var i = start; i < end && i < from.length; i++) {
	            if (from[i] !== undefined) {
	                to.push(from[i]);
	            }
	        }
	        return to;
	    }
	    ts.addRange = addRange;
	    /**
	     * @return Whether the value was added.
	     */
	    function pushIfUnique(array, toAdd, equalityComparer) {
	        if (contains(array, toAdd, equalityComparer)) {
	            return false;
	        }
	        else {
	            array.push(toAdd);
	            return true;
	        }
	    }
	    ts.pushIfUnique = pushIfUnique;
	    /**
	     * Unlike `pushIfUnique`, this can take `undefined` as an input, and returns a new array.
	     */
	    function appendIfUnique(array, toAdd, equalityComparer) {
	        if (array) {
	            pushIfUnique(array, toAdd, equalityComparer);
	            return array;
	        }
	        else {
	            return [toAdd];
	        }
	    }
	    ts.appendIfUnique = appendIfUnique;
	    function stableSortIndices(array, indices, comparer) {
	        // sort indices by value then position
	        indices.sort(function (x, y) { return comparer(array[x], array[y]) || compareValues(x, y); });
	    }
	    /**
	     * Returns a new sorted array.
	     */
	    function sort(array, comparer) {
	        return array.slice().sort(comparer);
	    }
	    ts.sort = sort;
	    function best(iter, isBetter) {
	        var x = iter.next();
	        if (x.done) {
	            return undefined;
	        }
	        var best = x.value;
	        while (true) {
	            var _a = iter.next(), value = _a.value, done = _a.done;
	            if (done) {
	                return best;
	            }
	            if (isBetter(value, best)) {
	                best = value;
	            }
	        }
	    }
	    ts.best = best;
	    function arrayIterator(array) {
	        var i = 0;
	        return { next: function () {
	                if (i === array.length) {
	                    return { value: undefined, done: true };
	                }
	                else {
	                    i++;
	                    return { value: array[i - 1], done: false };
	                }
	            } };
	    }
	    ts.arrayIterator = arrayIterator;
	    /**
	     * Stable sort of an array. Elements equal to each other maintain their relative position in the array.
	     */
	    function stableSort(array, comparer) {
	        var indices = array.map(function (_, i) { return i; });
	        stableSortIndices(array, indices, comparer);
	        return indices.map(function (i) { return array[i]; });
	    }
	    ts.stableSort = stableSort;
	    function rangeEquals(array1, array2, pos, end) {
	        while (pos < end) {
	            if (array1[pos] !== array2[pos]) {
	                return false;
	            }
	            pos++;
	        }
	        return true;
	    }
	    ts.rangeEquals = rangeEquals;
	    /**
	     * Returns the element at a specific offset in an array if non-empty, `undefined` otherwise.
	     * A negative offset indicates the element should be retrieved from the end of the array.
	     */
	    function elementAt(array, offset) {
	        if (array) {
	            offset = toOffset(array, offset);
	            if (offset < array.length) {
	                return array[offset];
	            }
	        }
	        return undefined;
	    }
	    ts.elementAt = elementAt;
	    /**
	     * Returns the first element of an array if non-empty, `undefined` otherwise.
	     */
	    function firstOrUndefined(array) {
	        return array.length === 0 ? undefined : array[0];
	    }
	    ts.firstOrUndefined = firstOrUndefined;
	    function first(array) {
	        Debug.assert(array.length !== 0);
	        return array[0];
	    }
	    ts.first = first;
	    /**
	     * Returns the last element of an array if non-empty, `undefined` otherwise.
	     */
	    function lastOrUndefined(array) {
	        return array.length === 0 ? undefined : array[array.length - 1];
	    }
	    ts.lastOrUndefined = lastOrUndefined;
	    function last(array) {
	        Debug.assert(array.length !== 0);
	        return array[array.length - 1];
	    }
	    ts.last = last;
	    /**
	     * Returns the only element of an array if it contains only one element, `undefined` otherwise.
	     */
	    function singleOrUndefined(array) {
	        return array && array.length === 1
	            ? array[0]
	            : undefined;
	    }
	    ts.singleOrUndefined = singleOrUndefined;
	    function singleOrMany(array) {
	        return array && array.length === 1
	            ? array[0]
	            : array;
	    }
	    ts.singleOrMany = singleOrMany;
	    function replaceElement(array, index, value) {
	        var result = array.slice(0);
	        result[index] = value;
	        return result;
	    }
	    ts.replaceElement = replaceElement;
	    /**
	     * Performs a binary search, finding the index at which `value` occurs in `array`.
	     * If no such index is found, returns the 2's-complement of first index at which
	     * `array[index]` exceeds `value`.
	     * @param array A sorted array whose first element must be no larger than number
	     * @param value The value to be searched for in the array.
	     * @param keySelector A callback used to select the search key from `value` and each element of
	     * `array`.
	     * @param keyComparer A callback used to compare two keys in a sorted array.
	     * @param offset An offset into `array` at which to start the search.
	     */
	    function binarySearch(array, value, keySelector, keyComparer, offset) {
	        if (!array || array.length === 0) {
	            return -1;
	        }
	        var low = offset || 0;
	        var high = array.length - 1;
	        var key = keySelector(value);
	        while (low <= high) {
	            var middle = low + ((high - low) >> 1);
	            var midKey = keySelector(array[middle]);
	            switch (keyComparer(midKey, key)) {
	                case -1 /* LessThan */:
	                    low = middle + 1;
	                    break;
	                case 0 /* EqualTo */:
	                    return middle;
	                case 1 /* GreaterThan */:
	                    high = middle - 1;
	                    break;
	            }
	        }
	        return ~low;
	    }
	    ts.binarySearch = binarySearch;
	    function reduceLeft(array, f, initial, start, count) {
	        if (array && array.length > 0) {
	            var size = array.length;
	            if (size > 0) {
	                var pos = start === undefined || start < 0 ? 0 : start;
	                var end = count === undefined || pos + count > size - 1 ? size - 1 : pos + count;
	                var result = void 0;
	                if (arguments.length <= 2) {
	                    result = array[pos];
	                    pos++;
	                }
	                else {
	                    result = initial;
	                }
	                while (pos <= end) {
	                    result = f(result, array[pos], pos);
	                    pos++;
	                }
	                return result;
	            }
	        }
	        return initial;
	    }
	    ts.reduceLeft = reduceLeft;
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    /**
	     * Indicates whether a map-like contains an own property with the specified key.
	     *
	     * @param map A map-like.
	     * @param key A property key.
	     */
	    function hasProperty(map, key) {
	        return hasOwnProperty.call(map, key);
	    }
	    ts.hasProperty = hasProperty;
	    /**
	     * Gets the value of an owned property in a map-like.
	     *
	     * @param map A map-like.
	     * @param key A property key.
	     */
	    function getProperty(map, key) {
	        return hasOwnProperty.call(map, key) ? map[key] : undefined;
	    }
	    ts.getProperty = getProperty;
	    /**
	     * Gets the owned, enumerable property keys of a map-like.
	     */
	    function getOwnKeys(map) {
	        var keys = [];
	        for (var key in map) {
	            if (hasOwnProperty.call(map, key)) {
	                keys.push(key);
	            }
	        }
	        return keys;
	    }
	    ts.getOwnKeys = getOwnKeys;
	    function getOwnValues(sparseArray) {
	        var values = [];
	        for (var key in sparseArray) {
	            if (hasOwnProperty.call(sparseArray, key)) {
	                values.push(sparseArray[key]);
	            }
	        }
	        return values;
	    }
	    ts.getOwnValues = getOwnValues;
	    function arrayFrom(iterator, map) {
	        var _a;
	        var result = [];
	        for (var _b = iterator.next(), value = _b.value, done = _b.done; !done; _a = iterator.next(), value = _a.value, done = _a.done, _a) {
	            result.push(map ? map(value) : value);
	        }
	        return result;
	    }
	    ts.arrayFrom = arrayFrom;
	    function forEachEntry(map, callback) {
	        var _a;
	        var iterator = map.entries();
	        for (var _b = iterator.next(), pair = _b.value, done = _b.done; !done; _a = iterator.next(), pair = _a.value, done = _a.done, _a) {
	            var key = pair[0], value = pair[1];
	            var result = callback(value, key);
	            if (result) {
	                return result;
	            }
	        }
	        return undefined;
	    }
	    ts.forEachEntry = forEachEntry;
	    function forEachKey(map, callback) {
	        var _a;
	        var iterator = map.keys();
	        for (var _b = iterator.next(), key = _b.value, done = _b.done; !done; _a = iterator.next(), key = _a.value, done = _a.done, _a) {
	            var result = callback(key);
	            if (result) {
	                return result;
	            }
	        }
	        return undefined;
	    }
	    ts.forEachKey = forEachKey;
	    function copyEntries(source, target) {
	        source.forEach(function (value, key) {
	            target.set(key, value);
	        });
	    }
	    ts.copyEntries = copyEntries;
	    function assign(t) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	            var arg = args_1[_a];
	            for (var p in arg) {
	                if (hasProperty(arg, p)) {
	                    t[p] = arg[p];
	                }
	            }
	        }
	        return t;
	    }
	    ts.assign = assign;
	    /**
	     * Performs a shallow equality comparison of the contents of two map-likes.
	     *
	     * @param left A map-like whose properties should be compared.
	     * @param right A map-like whose properties should be compared.
	     */
	    function equalOwnProperties(left, right, equalityComparer) {
	        if (equalityComparer === void 0) { equalityComparer = equateValues; }
	        if (left === right)
	            return true;
	        if (!left || !right)
	            return false;
	        for (var key in left) {
	            if (hasOwnProperty.call(left, key)) {
	                if (!hasOwnProperty.call(right, key) === undefined)
	                    return false;
	                if (!equalityComparer(left[key], right[key]))
	                    return false;
	            }
	        }
	        for (var key in right) {
	            if (hasOwnProperty.call(right, key)) {
	                if (!hasOwnProperty.call(left, key))
	                    return false;
	            }
	        }
	        return true;
	    }
	    ts.equalOwnProperties = equalOwnProperties;
	    function arrayToMap(array, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = createMap();
	        for (var _i = 0, array_6 = array; _i < array_6.length; _i++) {
	            var value = array_6[_i];
	            var key = makeKey(value);
	            if (key !== undefined)
	                result.set(key, makeValue(value));
	        }
	        return result;
	    }
	    ts.arrayToMap = arrayToMap;
	    function arrayToNumericMap(array, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = [];
	        for (var _i = 0, array_7 = array; _i < array_7.length; _i++) {
	            var value = array_7[_i];
	            result[makeKey(value)] = makeValue(value);
	        }
	        return result;
	    }
	    ts.arrayToNumericMap = arrayToNumericMap;
	    function arrayToSet(array, makeKey) {
	        return arrayToMap(array, makeKey || (function (s) { return s; }), function () { return true; });
	    }
	    ts.arrayToSet = arrayToSet;
	    function arrayToMultiMap(values, makeKey, makeValue) {
	        if (makeValue === void 0) { makeValue = identity; }
	        var result = createMultiMap();
	        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
	            var value = values_1[_i];
	            result.add(makeKey(value), makeValue(value));
	        }
	        return result;
	    }
	    ts.arrayToMultiMap = arrayToMultiMap;
	    function group(values, getGroupId) {
	        return arrayFrom(arrayToMultiMap(values, getGroupId).values());
	    }
	    ts.group = group;
	    function cloneMap(map) {
	        var clone = createMap();
	        copyEntries(map, clone);
	        return clone;
	    }
	    ts.cloneMap = cloneMap;
	    function clone(object) {
	        var result = {};
	        for (var id in object) {
	            if (hasOwnProperty.call(object, id)) {
	                result[id] = object[id];
	            }
	        }
	        return result;
	    }
	    ts.clone = clone;
	    function extend(first, second) {
	        var result = {};
	        for (var id in second) {
	            if (hasOwnProperty.call(second, id)) {
	                result[id] = second[id];
	            }
	        }
	        for (var id in first) {
	            if (hasOwnProperty.call(first, id)) {
	                result[id] = first[id];
	            }
	        }
	        return result;
	    }
	    ts.extend = extend;
	    function createMultiMap() {
	        var map = createMap();
	        map.add = multiMapAdd;
	        map.remove = multiMapRemove;
	        return map;
	    }
	    ts.createMultiMap = createMultiMap;
	    function multiMapAdd(key, value) {
	        var values = this.get(key);
	        if (values) {
	            values.push(value);
	        }
	        else {
	            this.set(key, values = [value]);
	        }
	        return values;
	    }
	    function multiMapRemove(key, value) {
	        var values = this.get(key);
	        if (values) {
	            unorderedRemoveItem(values, value);
	            if (!values.length) {
	                this.delete(key);
	            }
	        }
	    }
	    /**
	     * Tests whether a value is an array.
	     */
	    function isArray(value) {
	        return Array.isArray ? Array.isArray(value) : value instanceof Array;
	    }
	    ts.isArray = isArray;
	    function toArray(value) {
	        return isArray(value) ? value : [value];
	    }
	    ts.toArray = toArray;
	    /**
	     * Tests whether a value is string
	     */
	    function isString(text) {
	        return typeof text === "string";
	    }
	    ts.isString = isString;
	    function tryCast(value, test) {
	        return value !== undefined && test(value) ? value : undefined;
	    }
	    ts.tryCast = tryCast;
	    function cast(value, test) {
	        if (value !== undefined && test(value))
	            return value;
	        if (value && typeof value.kind === "number") {
	            Debug.fail("Invalid cast. The supplied " + Debug.showSyntaxKind(value) + " did not pass the test '" + Debug.getFunctionName(test) + "'.");
	        }
	        else {
	            Debug.fail("Invalid cast. The supplied value did not pass the test '" + Debug.getFunctionName(test) + "'.");
	        }
	    }
	    ts.cast = cast;
	    /** Does nothing. */
	    function noop(_) { } // tslint:disable-line no-empty
	    ts.noop = noop;
	    /** Do nothing and return false */
	    function returnFalse() { return false; }
	    ts.returnFalse = returnFalse;
	    /** Do nothing and return true */
	    function returnTrue() { return true; }
	    ts.returnTrue = returnTrue;
	    /** Returns its argument. */
	    function identity(x) { return x; }
	    ts.identity = identity;
	    /** Returns lower case string */
	    function toLowerCase(x) { return x.toLowerCase(); }
	    ts.toLowerCase = toLowerCase;
	    /** Throws an error because a function is not implemented. */
	    function notImplemented() {
	        throw new Error("Not implemented");
	    }
	    ts.notImplemented = notImplemented;
	    function memoize(callback) {
	        var value;
	        return function () {
	            if (callback) {
	                value = callback();
	                callback = undefined;
	            }
	            return value;
	        };
	    }
	    ts.memoize = memoize;
	    function chain(a, b, c, d, e) {
	        if (e) {
	            var args_2 = [];
	            for (var i = 0; i < arguments.length; i++) {
	                args_2[i] = arguments[i];
	            }
	            return function (t) { return compose.apply(void 0, map(args_2, function (f) { return f(t); })); };
	        }
	        else if (d) {
	            return function (t) { return compose(a(t), b(t), c(t), d(t)); };
	        }
	        else if (c) {
	            return function (t) { return compose(a(t), b(t), c(t)); };
	        }
	        else if (b) {
	            return function (t) { return compose(a(t), b(t)); };
	        }
	        else if (a) {
	            return function (t) { return compose(a(t)); };
	        }
	        else {
	            return function (_) { return function (u) { return u; }; };
	        }
	    }
	    ts.chain = chain;
	    function compose(a, b, c, d, e) {
	        if (e) {
	            var args_3 = [];
	            for (var i = 0; i < arguments.length; i++) {
	                args_3[i] = arguments[i];
	            }
	            return function (t) { return reduceLeft(args_3, function (u, f) { return f(u); }, t); };
	        }
	        else if (d) {
	            return function (t) { return d(c(b(a(t)))); };
	        }
	        else if (c) {
	            return function (t) { return c(b(a(t))); };
	        }
	        else if (b) {
	            return function (t) { return b(a(t)); };
	        }
	        else if (a) {
	            return function (t) { return a(t); };
	        }
	        else {
	            return function (t) { return t; };
	        }
	    }
	    ts.compose = compose;
	    function formatStringFromArgs(text, args, baseIndex) {
	        baseIndex = baseIndex || 0;
	        return text.replace(/{(\d+)}/g, function (_match, index) { return Debug.assertDefined(args[+index + baseIndex]); });
	    }
	    ts.formatStringFromArgs = formatStringFromArgs;
	    function getLocaleSpecificMessage(message) {
	        return ts.localizedDiagnosticMessages && ts.localizedDiagnosticMessages[message.key] || message.message;
	    }
	    ts.getLocaleSpecificMessage = getLocaleSpecificMessage;
	    function createFileDiagnostic(file, start, length, message) {
	        Debug.assertGreaterThanOrEqual(start, 0);
	        Debug.assertGreaterThanOrEqual(length, 0);
	        if (file) {
	            Debug.assertLessThanOrEqual(start, file.text.length);
	            Debug.assertLessThanOrEqual(start + length, file.text.length);
	        }
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 4) {
	            text = formatStringFromArgs(text, arguments, 4);
	        }
	        return {
	            file: file,
	            start: start,
	            length: length,
	            messageText: text,
	            category: message.category,
	            code: message.code,
	            reportsUnnecessary: message.reportsUnnecessary,
	        };
	    }
	    ts.createFileDiagnostic = createFileDiagnostic;
	    /* internal */
	    function formatMessage(_dummy, message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 2) {
	            text = formatStringFromArgs(text, arguments, 2);
	        }
	        return text;
	    }
	    ts.formatMessage = formatMessage;
	    function createCompilerDiagnostic(message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 1) {
	            text = formatStringFromArgs(text, arguments, 1);
	        }
	        return {
	            file: undefined,
	            start: undefined,
	            length: undefined,
	            messageText: text,
	            category: message.category,
	            code: message.code,
	            reportsUnnecessary: message.reportsUnnecessary,
	        };
	    }
	    ts.createCompilerDiagnostic = createCompilerDiagnostic;
	    function createCompilerDiagnosticFromMessageChain(chain) {
	        return {
	            file: undefined,
	            start: undefined,
	            length: undefined,
	            code: chain.code,
	            category: chain.category,
	            messageText: chain.next ? chain : chain.messageText,
	        };
	    }
	    ts.createCompilerDiagnosticFromMessageChain = createCompilerDiagnosticFromMessageChain;
	    function chainDiagnosticMessages(details, message) {
	        var text = getLocaleSpecificMessage(message);
	        if (arguments.length > 2) {
	            text = formatStringFromArgs(text, arguments, 2);
	        }
	        return {
	            messageText: text,
	            category: message.category,
	            code: message.code,
	            next: details
	        };
	    }
	    ts.chainDiagnosticMessages = chainDiagnosticMessages;
	    function concatenateDiagnosticMessageChains(headChain, tailChain) {
	        var lastChain = headChain;
	        while (lastChain.next) {
	            lastChain = lastChain.next;
	        }
	        lastChain.next = tailChain;
	        return headChain;
	    }
	    ts.concatenateDiagnosticMessageChains = concatenateDiagnosticMessageChains;
	    function equateValues(a, b) {
	        return a === b;
	    }
	    ts.equateValues = equateValues;
	    /**
	     * Compare the equality of two strings using a case-sensitive ordinal comparison.
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point after applying `toUpperCase` to each string. We always map both
	     * strings to their upper-case form as some unicode characters do not properly round-trip to
	     * lowercase (such as `ẞ` (German sharp capital s)).
	     */
	    function equateStringsCaseInsensitive(a, b) {
	        return a === b
	            || a !== undefined
	                && b !== undefined
	                && a.toUpperCase() === b.toUpperCase();
	    }
	    ts.equateStringsCaseInsensitive = equateStringsCaseInsensitive;
	    /**
	     * Compare the equality of two strings using a case-sensitive ordinal comparison.
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the
	     * integer value of each code-point.
	     */
	    function equateStringsCaseSensitive(a, b) {
	        return equateValues(a, b);
	    }
	    ts.equateStringsCaseSensitive = equateStringsCaseSensitive;
	    function compareComparableValues(a, b) {
	        return a === b ? 0 /* EqualTo */ :
	            a === undefined ? -1 /* LessThan */ :
	                b === undefined ? 1 /* GreaterThan */ :
	                    a < b ? -1 /* LessThan */ :
	                        1 /* GreaterThan */;
	    }
	    /**
	     * Compare two numeric values for their order relative to each other.
	     * To compare strings, use any of the `compareStrings` functions.
	     */
	    function compareValues(a, b) {
	        return compareComparableValues(a, b);
	    }
	    ts.compareValues = compareValues;
	    function min(a, b, compare) {
	        return compare(a, b) === -1 /* LessThan */ ? a : b;
	    }
	    ts.min = min;
	    /**
	     * Compare two strings using a case-insensitive ordinal comparison.
	     *
	     * Ordinal comparisons are based on the difference between the unicode code points of both
	     * strings. Characters with multiple unicode representations are considered unequal. Ordinal
	     * comparisons provide predictable ordering, but place "a" after "B".
	     *
	     * Case-insensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point after applying `toUpperCase` to each string. We always map both
	     * strings to their upper-case form as some unicode characters do not properly round-trip to
	     * lowercase (such as `ẞ` (German sharp capital s)).
	     */
	    function compareStringsCaseInsensitive(a, b) {
	        if (a === b)
	            return 0 /* EqualTo */;
	        if (a === undefined)
	            return -1 /* LessThan */;
	        if (b === undefined)
	            return 1 /* GreaterThan */;
	        a = a.toUpperCase();
	        b = b.toUpperCase();
	        return a < b ? -1 /* LessThan */ : a > b ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	    }
	    ts.compareStringsCaseInsensitive = compareStringsCaseInsensitive;
	    /**
	     * Compare two strings using a case-sensitive ordinal comparison.
	     *
	     * Ordinal comparisons are based on the difference between the unicode code points of both
	     * strings. Characters with multiple unicode representations are considered unequal. Ordinal
	     * comparisons provide predictable ordering, but place "a" after "B".
	     *
	     * Case-sensitive comparisons compare both strings one code-point at a time using the integer
	     * value of each code-point.
	     */
	    function compareStringsCaseSensitive(a, b) {
	        return compareComparableValues(a, b);
	    }
	    ts.compareStringsCaseSensitive = compareStringsCaseSensitive;
	    function getStringComparer(ignoreCase) {
	        return ignoreCase ? compareStringsCaseInsensitive : compareStringsCaseSensitive;
	    }
	    ts.getStringComparer = getStringComparer;
	    /**
	     * Creates a string comparer for use with string collation in the UI.
	     */
	    var createUIStringComparer = (function () {
	        var defaultComparer;
	        var enUSComparer;
	        var stringComparerFactory = getStringComparerFactory();
	        return createStringComparer;
	        function compareWithCallback(a, b, comparer) {
	            if (a === b)
	                return 0 /* EqualTo */;
	            if (a === undefined)
	                return -1 /* LessThan */;
	            if (b === undefined)
	                return 1 /* GreaterThan */;
	            var value = comparer(a, b);
	            return value < 0 ? -1 /* LessThan */ : value > 0 ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	        }
	        function createIntlCollatorStringComparer(locale) {
	            // Intl.Collator.prototype.compare is bound to the collator. See NOTE in
	            // http://www.ecma-international.org/ecma-402/2.0/#sec-Intl.Collator.prototype.compare
	            var comparer = new Intl.Collator(locale, { usage: "sort", sensitivity: "variant" }).compare;
	            return function (a, b) { return compareWithCallback(a, b, comparer); };
	        }
	        function createLocaleCompareStringComparer(locale) {
	            // if the locale is not the default locale (`undefined`), use the fallback comparer.
	            if (locale !== undefined)
	                return createFallbackStringComparer();
	            return function (a, b) { return compareWithCallback(a, b, compareStrings); };
	            function compareStrings(a, b) {
	                return a.localeCompare(b);
	            }
	        }
	        function createFallbackStringComparer() {
	            // An ordinal comparison puts "A" after "b", but for the UI we want "A" before "b".
	            // We first sort case insensitively.  So "Aaa" will come before "baa".
	            // Then we sort case sensitively, so "aaa" will come before "Aaa".
	            //
	            // For case insensitive comparisons we always map both strings to their
	            // upper-case form as some unicode characters do not properly round-trip to
	            // lowercase (such as `ẞ` (German sharp capital s)).
	            return function (a, b) { return compareWithCallback(a, b, compareDictionaryOrder); };
	            function compareDictionaryOrder(a, b) {
	                return compareStrings(a.toUpperCase(), b.toUpperCase()) || compareStrings(a, b);
	            }
	            function compareStrings(a, b) {
	                return a < b ? -1 /* LessThan */ : a > b ? 1 /* GreaterThan */ : 0 /* EqualTo */;
	            }
	        }
	        function getStringComparerFactory() {
	            // If the host supports Intl, we use it for comparisons using the default locale.
	            if (typeof Intl === "object" && typeof Intl.Collator === "function") {
	                return createIntlCollatorStringComparer;
	            }
	            // If the host does not support Intl, we fall back to localeCompare.
	            // localeCompare in Node v0.10 is just an ordinal comparison, so don't use it.
	            if (typeof String.prototype.localeCompare === "function" &&
	                typeof String.prototype.toLocaleUpperCase === "function" &&
	                "a".localeCompare("B") < 0) {
	                return createLocaleCompareStringComparer;
	            }
	            // Otherwise, fall back to ordinal comparison:
	            return createFallbackStringComparer;
	        }
	        function createStringComparer(locale) {
	            // Hold onto common string comparers. This avoids constantly reallocating comparers during
	            // tests.
	            if (locale === undefined) {
	                return defaultComparer || (defaultComparer = stringComparerFactory(locale));
	            }
	            else if (locale === "en-US") {
	                return enUSComparer || (enUSComparer = stringComparerFactory(locale));
	            }
	            else {
	                return stringComparerFactory(locale);
	            }
	        }
	    })();
	    var uiComparerCaseSensitive;
	    var uiLocale;
	    function getUILocale() {
	        return uiLocale;
	    }
	    ts.getUILocale = getUILocale;
	    function setUILocale(value) {
	        if (uiLocale !== value) {
	            uiLocale = value;
	            uiComparerCaseSensitive = undefined;
	        }
	    }
	    ts.setUILocale = setUILocale;
	    /**
	     * Compare two strings in a using the case-sensitive sort behavior of the UI locale.
	     *
	     * Ordering is not predictable between different host locales, but is best for displaying
	     * ordered data for UI presentation. Characters with multiple unicode representations may
	     * be considered equal.
	     *
	     * Case-sensitive comparisons compare strings that differ in base characters, or
	     * accents/diacritic marks, or case as unequal.
	     */
	    function compareStringsCaseSensitiveUI(a, b) {
	        var comparer = uiComparerCaseSensitive || (uiComparerCaseSensitive = createUIStringComparer(uiLocale));
	        return comparer(a, b);
	    }
	    ts.compareStringsCaseSensitiveUI = compareStringsCaseSensitiveUI;
	    function compareProperties(a, b, key, comparer) {
	        return a === b ? 0 /* EqualTo */ :
	            a === undefined ? -1 /* LessThan */ :
	                b === undefined ? 1 /* GreaterThan */ :
	                    comparer(a[key], b[key]);
	    }
	    ts.compareProperties = compareProperties;
	    function getDiagnosticFilePath(diagnostic) {
	        return diagnostic.file ? diagnostic.file.path : undefined;
	    }
	    function compareDiagnostics(d1, d2) {
	        return compareStringsCaseSensitive(getDiagnosticFilePath(d1), getDiagnosticFilePath(d2)) ||
	            compareValues(d1.start, d2.start) ||
	            compareValues(d1.length, d2.length) ||
	            compareValues(d1.code, d2.code) ||
	            compareMessageText(d1.messageText, d2.messageText) ||
	            0 /* EqualTo */;
	    }
	    ts.compareDiagnostics = compareDiagnostics;
	    /** True is greater than false. */
	    function compareBooleans(a, b) {
	        return compareValues(a ? 1 : 0, b ? 1 : 0);
	    }
	    ts.compareBooleans = compareBooleans;
	    function compareMessageText(text1, text2) {
	        while (text1 && text2) {
	            // We still have both chains.
	            var string1 = isString(text1) ? text1 : text1.messageText;
	            var string2 = isString(text2) ? text2 : text2.messageText;
	            var res = compareStringsCaseSensitive(string1, string2);
	            if (res) {
	                return res;
	            }
	            text1 = isString(text1) ? undefined : text1.next;
	            text2 = isString(text2) ? undefined : text2.next;
	        }
	        if (!text1 && !text2) {
	            // if the chains are done, then these messages are the same.
	            return 0 /* EqualTo */;
	        }
	        // We still have one chain remaining.  The shorter chain should come first.
	        return text1 ? 1 /* GreaterThan */ : -1 /* LessThan */;
	    }
	    function getEmitScriptTarget(compilerOptions) {
	        return compilerOptions.target || 0 /* ES3 */;
	    }
	    ts.getEmitScriptTarget = getEmitScriptTarget;
	    function getEmitModuleKind(compilerOptions) {
	        return typeof compilerOptions.module === "number" ?
	            compilerOptions.module :
	            getEmitScriptTarget(compilerOptions) >= 2 /* ES2015 */ ? ts.ModuleKind.ES2015 : ts.ModuleKind.CommonJS;
	    }
	    ts.getEmitModuleKind = getEmitModuleKind;
	    function getEmitModuleResolutionKind(compilerOptions) {
	        var moduleResolution = compilerOptions.moduleResolution;
	        if (moduleResolution === undefined) {
	            moduleResolution = getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS ? ts.ModuleResolutionKind.NodeJs : ts.ModuleResolutionKind.Classic;
	        }
	        return moduleResolution;
	    }
	    ts.getEmitModuleResolutionKind = getEmitModuleResolutionKind;
	    function unreachableCodeIsError(options) {
	        return options.allowUnreachableCode === false;
	    }
	    ts.unreachableCodeIsError = unreachableCodeIsError;
	    function unusedLabelIsError(options) {
	        return options.allowUnusedLabels === false;
	    }
	    ts.unusedLabelIsError = unusedLabelIsError;
	    function getAreDeclarationMapsEnabled(options) {
	        return !!(options.declaration && options.declarationMap);
	    }
	    ts.getAreDeclarationMapsEnabled = getAreDeclarationMapsEnabled;
	    function getAllowSyntheticDefaultImports(compilerOptions) {
	        var moduleKind = getEmitModuleKind(compilerOptions);
	        return compilerOptions.allowSyntheticDefaultImports !== undefined
	            ? compilerOptions.allowSyntheticDefaultImports
	            : compilerOptions.esModuleInterop
	                ? moduleKind !== ts.ModuleKind.None && moduleKind < ts.ModuleKind.ES2015
	                : moduleKind === ts.ModuleKind.System;
	    }
	    ts.getAllowSyntheticDefaultImports = getAllowSyntheticDefaultImports;
	    function getEmitDeclarations(compilerOptions) {
	        return !!(compilerOptions.declaration || compilerOptions.composite);
	    }
	    ts.getEmitDeclarations = getEmitDeclarations;
	    function getStrictOptionValue(compilerOptions, flag) {
	        return compilerOptions[flag] === undefined ? compilerOptions.strict : compilerOptions[flag];
	    }
	    ts.getStrictOptionValue = getStrictOptionValue;
	    function hasZeroOrOneAsteriskCharacter(str) {
	        var seenAsterisk = false;
	        for (var i = 0; i < str.length; i++) {
	            if (str.charCodeAt(i) === 42 /* asterisk */) {
	                if (!seenAsterisk) {
	                    seenAsterisk = true;
	                }
	                else {
	                    // have already seen asterisk
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.hasZeroOrOneAsteriskCharacter = hasZeroOrOneAsteriskCharacter;
	    //
	    // Paths
	    //
	    /**
	     * Internally, we represent paths as strings with '/' as the directory separator.
	     * When we make system calls (eg: LanguageServiceHost.getDirectory()),
	     * we expect the host to correctly handle paths in our specified format.
	     */
	    ts.directorySeparator = "/";
	    var altDirectorySeparator = "\\";
	    var urlSchemeSeparator = "://";
	    var backslashRegExp = /\\/g;
	    /**
	     * Normalize path separators.
	     */
	    function normalizeSlashes(path) {
	        return path.replace(backslashRegExp, ts.directorySeparator);
	    }
	    ts.normalizeSlashes = normalizeSlashes;
	    function isVolumeCharacter(charCode) {
	        return (charCode >= 97 /* a */ && charCode <= 122 /* z */) ||
	            (charCode >= 65 /* A */ && charCode <= 90 /* Z */);
	    }
	    function getFileUrlVolumeSeparatorEnd(url, start) {
	        var ch0 = url.charCodeAt(start);
	        if (ch0 === 58 /* colon */)
	            return start + 1;
	        if (ch0 === 37 /* percent */ && url.charCodeAt(start + 1) === 51 /* _3 */) {
	            var ch2 = url.charCodeAt(start + 2);
	            if (ch2 === 97 /* a */ || ch2 === 65 /* A */)
	                return start + 3;
	        }
	        return -1;
	    }
	    /**
	     * Returns length of the root part of a path or URL (i.e. length of "/", "x:/", "//server/share/, file:///user/files").
	     * If the root is part of a URL, the twos-complement of the root length is returned.
	     */
	    function getEncodedRootLength(path) {
	        if (!path)
	            return 0;
	        var ch0 = path.charCodeAt(0);
	        // POSIX or UNC
	        if (ch0 === 47 /* slash */ || ch0 === 92 /* backslash */) {
	            if (path.charCodeAt(1) !== ch0)
	                return 1; // POSIX: "/" (or non-normalized "\")
	            var p1 = path.indexOf(ch0 === 47 /* slash */ ? ts.directorySeparator : altDirectorySeparator, 2);
	            if (p1 < 0)
	                return path.length; // UNC: "//server" or "\\server"
	            return p1 + 1; // UNC: "//server/" or "\\server\"
	        }
	        // DOS
	        if (isVolumeCharacter(ch0) && path.charCodeAt(1) === 58 /* colon */) {
	            var ch2 = path.charCodeAt(2);
	            if (ch2 === 47 /* slash */ || ch2 === 92 /* backslash */)
	                return 3; // DOS: "c:/" or "c:\"
	            if (path.length === 2)
	                return 2; // DOS: "c:" (but not "c:d")
	        }
	        // URL
	        var schemeEnd = path.indexOf(urlSchemeSeparator);
	        if (schemeEnd !== -1) {
	            var authorityStart = schemeEnd + urlSchemeSeparator.length;
	            var authorityEnd = path.indexOf(ts.directorySeparator, authorityStart);
	            if (authorityEnd !== -1) { // URL: "file:///", "file://server/", "file://server/path"
	                // For local "file" URLs, include the leading DOS volume (if present).
	                // Per https://www.ietf.org/rfc/rfc1738.txt, a host of "" or "localhost" is a
	                // special case interpreted as "the machine from which the URL is being interpreted".
	                var scheme = path.slice(0, schemeEnd);
	                var authority = path.slice(authorityStart, authorityEnd);
	                if (scheme === "file" && (authority === "" || authority === "localhost") &&
	                    isVolumeCharacter(path.charCodeAt(authorityEnd + 1))) {
	                    var volumeSeparatorEnd = getFileUrlVolumeSeparatorEnd(path, authorityEnd + 2);
	                    if (volumeSeparatorEnd !== -1) {
	                        if (path.charCodeAt(volumeSeparatorEnd) === 47 /* slash */) {
	                            // URL: "file:///c:/", "file://localhost/c:/", "file:///c%3a/", "file://localhost/c%3a/"
	                            return ~(volumeSeparatorEnd + 1);
	                        }
	                        if (volumeSeparatorEnd === path.length) {
	                            // URL: "file:///c:", "file://localhost/c:", "file:///c$3a", "file://localhost/c%3a"
	                            // but not "file:///c:d" or "file:///c%3ad"
	                            return ~volumeSeparatorEnd;
	                        }
	                    }
	                }
	                return ~(authorityEnd + 1); // URL: "file://server/", "http://server/"
	            }
	            return ~path.length; // URL: "file://server", "http://server"
	        }
	        // relative
	        return 0;
	    }
	    /**
	     * Returns length of the root part of a path or URL (i.e. length of "/", "x:/", "//server/share/, file:///user/files").
	     *
	     * For example:
	     * ```ts
	     * getRootLength("a") === 0                   // ""
	     * getRootLength("/") === 1                   // "/"
	     * getRootLength("c:") === 2                  // "c:"
	     * getRootLength("c:d") === 0                 // ""
	     * getRootLength("c:/") === 3                 // "c:/"
	     * getRootLength("c:\\") === 3                // "c:\\"
	     * getRootLength("//server") === 7            // "//server"
	     * getRootLength("//server/share") === 8      // "//server/"
	     * getRootLength("\\\\server") === 7          // "\\\\server"
	     * getRootLength("\\\\server\\share") === 8   // "\\\\server\\"
	     * getRootLength("file:///path") === 8        // "file:///"
	     * getRootLength("file:///c:") === 10         // "file:///c:"
	     * getRootLength("file:///c:d") === 8         // "file:///"
	     * getRootLength("file:///c:/path") === 11    // "file:///c:/"
	     * getRootLength("file://server") === 13      // "file://server"
	     * getRootLength("file://server/path") === 14 // "file://server/"
	     * getRootLength("http://server") === 13      // "http://server"
	     * getRootLength("http://server/path") === 14 // "http://server/"
	     * ```
	     */
	    function getRootLength(path) {
	        var rootLength = getEncodedRootLength(path);
	        return rootLength < 0 ? ~rootLength : rootLength;
	    }
	    ts.getRootLength = getRootLength;
	    // TODO(rbuckton): replace references with `resolvePath`
	    function normalizePath(path) {
	        return resolvePath(path);
	    }
	    ts.normalizePath = normalizePath;
	    function normalizePathAndParts(path) {
	        path = normalizeSlashes(path);
	        var _a = reducePathComponents(getPathComponents(path)), root = _a[0], parts = _a.slice(1);
	        if (parts.length) {
	            var joinedParts = root + parts.join(ts.directorySeparator);
	            return { path: hasTrailingDirectorySeparator(path) ? ensureTrailingDirectorySeparator(joinedParts) : joinedParts, parts: parts };
	        }
	        else {
	            return { path: root, parts: parts };
	        }
	    }
	    ts.normalizePathAndParts = normalizePathAndParts;
	    function getDirectoryPath(path) {
	        path = normalizeSlashes(path);
	        // If the path provided is itself the root, then return it.
	        var rootLength = getRootLength(path);
	        if (rootLength === path.length)
	            return path;
	        // return the leading portion of the path up to the last (non-terminal) directory separator
	        // but not including any trailing directory separator.
	        path = removeTrailingDirectorySeparator(path);
	        return path.slice(0, Math.max(rootLength, path.lastIndexOf(ts.directorySeparator)));
	    }
	    ts.getDirectoryPath = getDirectoryPath;
	    function isUrl(path) {
	        return getEncodedRootLength(path) < 0;
	    }
	    ts.isUrl = isUrl;
	    function pathIsRelative(path) {
	        return /^\.\.?($|[\\/])/.test(path);
	    }
	    ts.pathIsRelative = pathIsRelative;
	    /**
	     * Determines whether a path is an absolute path (e.g. starts with `/`, or a dos path
	     * like `c:`, `c:\` or `c:/`).
	     */
	    function isRootedDiskPath(path) {
	        return getEncodedRootLength(path) > 0;
	    }
	    ts.isRootedDiskPath = isRootedDiskPath;
	    /**
	     * Determines whether a path consists only of a path root.
	     */
	    function isDiskPathRoot(path) {
	        var rootLength = getEncodedRootLength(path);
	        return rootLength > 0 && rootLength === path.length;
	    }
	    ts.isDiskPathRoot = isDiskPathRoot;
	    function convertToRelativePath(absoluteOrRelativePath, basePath, getCanonicalFileName) {
	        return !isRootedDiskPath(absoluteOrRelativePath)
	            ? absoluteOrRelativePath
	            : getRelativePathToDirectoryOrUrl(basePath, absoluteOrRelativePath, basePath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	    }
	    ts.convertToRelativePath = convertToRelativePath;
	    function pathComponents(path, rootLength) {
	        var root = path.substring(0, rootLength);
	        var rest = path.substring(rootLength).split(ts.directorySeparator);
	        if (rest.length && !lastOrUndefined(rest))
	            rest.pop();
	        return [root].concat(rest);
	    }
	    /**
	     * Parse a path into an array containing a root component (at index 0) and zero or more path
	     * components (at indices > 0). The result is not normalized.
	     * If the path is relative, the root component is `""`.
	     * If the path is absolute, the root component includes the first path separator (`/`).
	     */
	    function getPathComponents(path, currentDirectory) {
	        if (currentDirectory === void 0) { currentDirectory = ""; }
	        path = combinePaths(currentDirectory, path);
	        var rootLength = getRootLength(path);
	        return pathComponents(path, rootLength);
	    }
	    ts.getPathComponents = getPathComponents;
	    /**
	     * Reduce an array of path components to a more simplified path by navigating any
	     * `"."` or `".."` entries in the path.
	     */
	    function reducePathComponents(components) {
	        if (!some(components))
	            return [];
	        var reduced = [components[0]];
	        for (var i = 1; i < components.length; i++) {
	            var component = components[i];
	            if (!component)
	                continue;
	            if (component === ".")
	                continue;
	            if (component === "..") {
	                if (reduced.length > 1) {
	                    if (reduced[reduced.length - 1] !== "..") {
	                        reduced.pop();
	                        continue;
	                    }
	                }
	                else if (reduced[0])
	                    continue;
	            }
	            reduced.push(component);
	        }
	        return reduced;
	    }
	    ts.reducePathComponents = reducePathComponents;
	    /**
	     * Parse a path into an array containing a root component (at index 0) and zero or more path
	     * components (at indices > 0). The result is normalized.
	     * If the path is relative, the root component is `""`.
	     * If the path is absolute, the root component includes the first path separator (`/`).
	     */
	    function getNormalizedPathComponents(path, currentDirectory) {
	        return reducePathComponents(getPathComponents(path, currentDirectory));
	    }
	    ts.getNormalizedPathComponents = getNormalizedPathComponents;
	    function getNormalizedAbsolutePath(fileName, currentDirectory) {
	        return getPathFromPathComponents(getNormalizedPathComponents(fileName, currentDirectory));
	    }
	    ts.getNormalizedAbsolutePath = getNormalizedAbsolutePath;
	    /**
	     * Formats a parsed path consisting of a root component (at index 0) and zero or more path
	     * segments (at indices > 0).
	     */
	    function getPathFromPathComponents(pathComponents) {
	        if (pathComponents.length === 0)
	            return "";
	        var root = pathComponents[0] && ensureTrailingDirectorySeparator(pathComponents[0]);
	        if (pathComponents.length === 1)
	            return root;
	        return root + pathComponents.slice(1).join(ts.directorySeparator);
	    }
	    ts.getPathFromPathComponents = getPathFromPathComponents;
	    function getPathComponentsRelativeTo(from, to, stringEqualityComparer, getCanonicalFileName) {
	        var fromComponents = reducePathComponents(getPathComponents(from));
	        var toComponents = reducePathComponents(getPathComponents(to));
	        var start;
	        for (start = 0; start < fromComponents.length && start < toComponents.length; start++) {
	            var fromComponent = getCanonicalFileName(fromComponents[start]);
	            var toComponent = getCanonicalFileName(toComponents[start]);
	            var comparer = start === 0 ? equateStringsCaseInsensitive : stringEqualityComparer;
	            if (!comparer(fromComponent, toComponent))
	                break;
	        }
	        if (start === 0) {
	            return toComponents;
	        }
	        var components = toComponents.slice(start);
	        var relative = [];
	        for (; start < fromComponents.length; start++) {
	            relative.push("..");
	        }
	        return [""].concat(relative, components);
	    }
	    function getRelativePathFromFile(from, to, getCanonicalFileName) {
	        return ensurePathIsNonModuleName(getRelativePathFromDirectory(getDirectoryPath(from), to, getCanonicalFileName));
	    }
	    ts.getRelativePathFromFile = getRelativePathFromFile;
	    function getRelativePathFromDirectory(fromDirectory, to, getCanonicalFileNameOrIgnoreCase) {
	        Debug.assert((getRootLength(fromDirectory) > 0) === (getRootLength(to) > 0), "Paths must either both be absolute or both be relative");
	        var getCanonicalFileName = typeof getCanonicalFileNameOrIgnoreCase === "function" ? getCanonicalFileNameOrIgnoreCase : identity;
	        var ignoreCase = typeof getCanonicalFileNameOrIgnoreCase === "boolean" ? getCanonicalFileNameOrIgnoreCase : false;
	        var pathComponents = getPathComponentsRelativeTo(fromDirectory, to, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive, getCanonicalFileName);
	        return getPathFromPathComponents(pathComponents);
	    }
	    ts.getRelativePathFromDirectory = getRelativePathFromDirectory;
	    function getRelativePathToDirectoryOrUrl(directoryPathOrUrl, relativeOrAbsolutePath, currentDirectory, getCanonicalFileName, isAbsolutePathAnUrl) {
	        var pathComponents = getPathComponentsRelativeTo(resolvePath(currentDirectory, directoryPathOrUrl), resolvePath(currentDirectory, relativeOrAbsolutePath), equateStringsCaseSensitive, getCanonicalFileName);
	        var firstComponent = pathComponents[0];
	        if (isAbsolutePathAnUrl && isRootedDiskPath(firstComponent)) {
	            var prefix = firstComponent.charAt(0) === ts.directorySeparator ? "file://" : "file:///";
	            pathComponents[0] = prefix + firstComponent;
	        }
	        return getPathFromPathComponents(pathComponents);
	    }
	    ts.getRelativePathToDirectoryOrUrl = getRelativePathToDirectoryOrUrl;
	    /**
	     * Ensures a path is either absolute (prefixed with `/` or `c:`) or dot-relative (prefixed
	     * with `./` or `../`) so as not to be confused with an unprefixed module name.
	     */
	    function ensurePathIsNonModuleName(path) {
	        return getRootLength(path) === 0 && !pathIsRelative(path) ? "./" + path : path;
	    }
	    ts.ensurePathIsNonModuleName = ensurePathIsNonModuleName;
	    function getBaseFileName(path, extensions, ignoreCase) {
	        path = normalizeSlashes(path);
	        // if the path provided is itself the root, then it has not file name.
	        var rootLength = getRootLength(path);
	        if (rootLength === path.length)
	            return "";
	        // return the trailing portion of the path starting after the last (non-terminal) directory
	        // separator but not including any trailing directory separator.
	        path = removeTrailingDirectorySeparator(path);
	        var name = path.slice(Math.max(getRootLength(path), path.lastIndexOf(ts.directorySeparator) + 1));
	        var extension = extensions !== undefined && ignoreCase !== undefined ? getAnyExtensionFromPath(name, extensions, ignoreCase) : undefined;
	        return extension ? name.slice(0, name.length - extension.length) : name;
	    }
	    ts.getBaseFileName = getBaseFileName;
	    /**
	     * Combines paths. If a path is absolute, it replaces any previous path.
	     */
	    function combinePaths(path) {
	        var paths = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            paths[_i - 1] = arguments[_i];
	        }
	        if (path)
	            path = normalizeSlashes(path);
	        for (var _a = 0, paths_1 = paths; _a < paths_1.length; _a++) {
	            var relativePath = paths_1[_a];
	            if (!relativePath)
	                continue;
	            relativePath = normalizeSlashes(relativePath);
	            if (!path || getRootLength(relativePath) !== 0) {
	                path = relativePath;
	            }
	            else {
	                path = ensureTrailingDirectorySeparator(path) + relativePath;
	            }
	        }
	        return path;
	    }
	    ts.combinePaths = combinePaths;
	    /**
	     * Combines and resolves paths. If a path is absolute, it replaces any previous path. Any
	     * `.` and `..` path components are resolved.
	     */
	    function resolvePath(path) {
	        var paths = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            paths[_i - 1] = arguments[_i];
	        }
	        var combined = some(paths) ? combinePaths.apply(void 0, [path].concat(paths)) : normalizeSlashes(path);
	        var normalized = getPathFromPathComponents(reducePathComponents(getPathComponents(combined)));
	        return normalized && hasTrailingDirectorySeparator(combined) ? ensureTrailingDirectorySeparator(normalized) : normalized;
	    }
	    ts.resolvePath = resolvePath;
	    /**
	     * Determines whether a path has a trailing separator (`/` or `\\`).
	     */
	    function hasTrailingDirectorySeparator(path) {
	        if (path.length === 0)
	            return false;
	        var ch = path.charCodeAt(path.length - 1);
	        return ch === 47 /* slash */ || ch === 92 /* backslash */;
	    }
	    ts.hasTrailingDirectorySeparator = hasTrailingDirectorySeparator;
	    function removeTrailingDirectorySeparator(path) {
	        if (hasTrailingDirectorySeparator(path)) {
	            return path.substr(0, path.length - 1);
	        }
	        return path;
	    }
	    ts.removeTrailingDirectorySeparator = removeTrailingDirectorySeparator;
	    function ensureTrailingDirectorySeparator(path) {
	        if (!hasTrailingDirectorySeparator(path)) {
	            return path + ts.directorySeparator;
	        }
	        return path;
	    }
	    ts.ensureTrailingDirectorySeparator = ensureTrailingDirectorySeparator;
	    function comparePathsWorker(a, b, componentComparer) {
	        if (a === b)
	            return 0 /* EqualTo */;
	        if (a === undefined)
	            return -1 /* LessThan */;
	        if (b === undefined)
	            return 1 /* GreaterThan */;
	        var aComponents = reducePathComponents(getPathComponents(a));
	        var bComponents = reducePathComponents(getPathComponents(b));
	        var sharedLength = Math.min(aComponents.length, bComponents.length);
	        for (var i = 0; i < sharedLength; i++) {
	            var stringComparer = i === 0 ? compareStringsCaseInsensitive : componentComparer;
	            var result = stringComparer(aComponents[i], bComponents[i]);
	            if (result !== 0 /* EqualTo */) {
	                return result;
	            }
	        }
	        return compareValues(aComponents.length, bComponents.length);
	    }
	    /**
	     * Performs a case-sensitive comparison of two paths.
	     */
	    function comparePathsCaseSensitive(a, b) {
	        return comparePathsWorker(a, b, compareStringsCaseSensitive);
	    }
	    ts.comparePathsCaseSensitive = comparePathsCaseSensitive;
	    /**
	     * Performs a case-insensitive comparison of two paths.
	     */
	    function comparePathsCaseInsensitive(a, b) {
	        return comparePathsWorker(a, b, compareStringsCaseInsensitive);
	    }
	    ts.comparePathsCaseInsensitive = comparePathsCaseInsensitive;
	    function comparePaths(a, b, currentDirectory, ignoreCase) {
	        if (typeof currentDirectory === "string") {
	            a = combinePaths(currentDirectory, a);
	            b = combinePaths(currentDirectory, b);
	        }
	        else if (typeof currentDirectory === "boolean") {
	            ignoreCase = currentDirectory;
	        }
	        return comparePathsWorker(a, b, getStringComparer(ignoreCase));
	    }
	    ts.comparePaths = comparePaths;
	    function containsPath(parent, child, currentDirectory, ignoreCase) {
	        if (typeof currentDirectory === "string") {
	            parent = combinePaths(currentDirectory, parent);
	            child = combinePaths(currentDirectory, child);
	        }
	        else if (typeof currentDirectory === "boolean") {
	            ignoreCase = currentDirectory;
	        }
	        if (parent === undefined || child === undefined)
	            return false;
	        if (parent === child)
	            return true;
	        var parentComponents = reducePathComponents(getPathComponents(parent));
	        var childComponents = reducePathComponents(getPathComponents(child));
	        if (childComponents.length < parentComponents.length) {
	            return false;
	        }
	        var componentEqualityComparer = ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive;
	        for (var i = 0; i < parentComponents.length; i++) {
	            var equalityComparer = i === 0 ? equateStringsCaseInsensitive : componentEqualityComparer;
	            if (!equalityComparer(parentComponents[i], childComponents[i])) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.containsPath = containsPath;
	    function startsWith(str, prefix) {
	        return str.lastIndexOf(prefix, 0) === 0;
	    }
	    ts.startsWith = startsWith;
	    function removePrefix(str, prefix) {
	        return startsWith(str, prefix) ? str.substr(prefix.length) : str;
	    }
	    ts.removePrefix = removePrefix;
	    function tryRemovePrefix(str, prefix) {
	        return startsWith(str, prefix) ? str.substring(prefix.length) : undefined;
	    }
	    ts.tryRemovePrefix = tryRemovePrefix;
	    function tryRemoveDirectoryPrefix(path, dirPath) {
	        var a = tryRemovePrefix(path, dirPath);
	        if (a === undefined)
	            return undefined;
	        switch (a.charCodeAt(0)) {
	            case 47 /* slash */:
	            case 92 /* backslash */:
	                return a.slice(1);
	            default:
	                return undefined;
	        }
	    }
	    ts.tryRemoveDirectoryPrefix = tryRemoveDirectoryPrefix;
	    function endsWith(str, suffix) {
	        var expectedPos = str.length - suffix.length;
	        return expectedPos >= 0 && str.indexOf(suffix, expectedPos) === expectedPos;
	    }
	    ts.endsWith = endsWith;
	    function removeSuffix(str, suffix) {
	        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : str;
	    }
	    ts.removeSuffix = removeSuffix;
	    function tryRemoveSuffix(str, suffix) {
	        return endsWith(str, suffix) ? str.slice(0, str.length - suffix.length) : undefined;
	    }
	    ts.tryRemoveSuffix = tryRemoveSuffix;
	    function stringContains(str, substring) {
	        return str.indexOf(substring) !== -1;
	    }
	    ts.stringContains = stringContains;
	    function hasExtension(fileName) {
	        return stringContains(getBaseFileName(fileName), ".");
	    }
	    ts.hasExtension = hasExtension;
	    function fileExtensionIs(path, extension) {
	        return path.length > extension.length && endsWith(path, extension);
	    }
	    ts.fileExtensionIs = fileExtensionIs;
	    function fileExtensionIsOneOf(path, extensions) {
	        for (var _i = 0, extensions_1 = extensions; _i < extensions_1.length; _i++) {
	            var extension = extensions_1[_i];
	            if (fileExtensionIs(path, extension)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.fileExtensionIsOneOf = fileExtensionIsOneOf;
	    // Reserved characters, forces escaping of any non-word (or digit), non-whitespace character.
	    // It may be inefficient (we could just match (/[-[\]{}()*+?.,\\^$|#\s]/g), but this is future
	    // proof.
	    var reservedCharacterPattern = /[^\w\s\/]/g;
	    var wildcardCharCodes = [42 /* asterisk */, 63 /* question */];
	    ts.commonPackageFolders = ["node_modules", "bower_components", "jspm_packages"];
	    var implicitExcludePathRegexPattern = "(?!(" + ts.commonPackageFolders.join("|") + ")(/|$))";
	    var filesMatcher = {
	        /**
	         * Matches any single directory segment unless it is the last segment and a .min.js file
	         * Breakdown:
	         *  [^./]                   # matches everything up to the first . character (excluding directory seperators)
	         *  (\\.(?!min\\.js$))?     # matches . characters but not if they are part of the .min.js file extension
	         */
	        singleAsteriskRegexFragment: "([^./]|(\\.(?!min\\.js$))?)*",
	        /**
	         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
	         * files or directories, does not match subdirectories that start with a . character
	         */
	        doubleAsteriskRegexFragment: "(/" + implicitExcludePathRegexPattern + "[^/.][^/]*)*?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, filesMatcher.singleAsteriskRegexFragment); }
	    };
	    var directoriesMatcher = {
	        singleAsteriskRegexFragment: "[^/]*",
	        /**
	         * Regex for the ** wildcard. Matches any number of subdirectories. When used for including
	         * files or directories, does not match subdirectories that start with a . character
	         */
	        doubleAsteriskRegexFragment: "(/" + implicitExcludePathRegexPattern + "[^/.][^/]*)*?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, directoriesMatcher.singleAsteriskRegexFragment); }
	    };
	    var excludeMatcher = {
	        singleAsteriskRegexFragment: "[^/]*",
	        doubleAsteriskRegexFragment: "(/.+?)?",
	        replaceWildcardCharacter: function (match) { return replaceWildcardCharacter(match, excludeMatcher.singleAsteriskRegexFragment); }
	    };
	    var wildcardMatchers = {
	        files: filesMatcher,
	        directories: directoriesMatcher,
	        exclude: excludeMatcher
	    };
	    function getRegularExpressionForWildcard(specs, basePath, usage) {
	        var patterns = getRegularExpressionsForWildcards(specs, basePath, usage);
	        if (!patterns || !patterns.length) {
	            return undefined;
	        }
	        var pattern = patterns.map(function (pattern) { return "(" + pattern + ")"; }).join("|");
	        // If excluding, match "foo/bar/baz...", but if including, only allow "foo".
	        var terminator = usage === "exclude" ? "($|/)" : "$";
	        return "^(" + pattern + ")" + terminator;
	    }
	    ts.getRegularExpressionForWildcard = getRegularExpressionForWildcard;
	    function getRegularExpressionsForWildcards(specs, basePath, usage) {
	        if (specs === undefined || specs.length === 0) {
	            return undefined;
	        }
	        return flatMap(specs, function (spec) {
	            return spec && getSubPatternFromSpec(spec, basePath, usage, wildcardMatchers[usage]);
	        });
	    }
	    /**
	     * An "includes" path "foo" is implicitly a glob "foo/** /*" (without the space) if its last component has no extension,
	     * and does not contain any glob characters itself.
	     */
	    function isImplicitGlob(lastPathComponent) {
	        return !/[.*?]/.test(lastPathComponent);
	    }
	    ts.isImplicitGlob = isImplicitGlob;
	    function getSubPatternFromSpec(spec, basePath, usage, _a) {
	        var singleAsteriskRegexFragment = _a.singleAsteriskRegexFragment, doubleAsteriskRegexFragment = _a.doubleAsteriskRegexFragment, replaceWildcardCharacter = _a.replaceWildcardCharacter;
	        var subpattern = "";
	        var hasWrittenComponent = false;
	        var components = getNormalizedPathComponents(spec, basePath);
	        var lastComponent = lastOrUndefined(components);
	        if (usage !== "exclude" && lastComponent === "**") {
	            return undefined;
	        }
	        // getNormalizedPathComponents includes the separator for the root component.
	        // We need to remove to create our regex correctly.
	        components[0] = removeTrailingDirectorySeparator(components[0]);
	        if (isImplicitGlob(lastComponent)) {
	            components.push("**", "*");
	        }
	        var optionalCount = 0;
	        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
	            var component = components_1[_i];
	            if (component === "**") {
	                subpattern += doubleAsteriskRegexFragment;
	            }
	            else {
	                if (usage === "directories") {
	                    subpattern += "(";
	                    optionalCount++;
	                }
	                if (hasWrittenComponent) {
	                    subpattern += ts.directorySeparator;
	                }
	                if (usage !== "exclude") {
	                    var componentPattern = "";
	                    // The * and ? wildcards should not match directories or files that start with . if they
	                    // appear first in a component. Dotted directories and files can be included explicitly
	                    // like so: **/.*/.*
	                    if (component.charCodeAt(0) === 42 /* asterisk */) {
	                        componentPattern += "([^./]" + singleAsteriskRegexFragment + ")?";
	                        component = component.substr(1);
	                    }
	                    else if (component.charCodeAt(0) === 63 /* question */) {
	                        componentPattern += "[^./]";
	                        component = component.substr(1);
	                    }
	                    componentPattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter);
	                    // Patterns should not include subfolders like node_modules unless they are
	                    // explicitly included as part of the path.
	                    //
	                    // As an optimization, if the component pattern is the same as the component,
	                    // then there definitely were no wildcard characters and we do not need to
	                    // add the exclusion pattern.
	                    if (componentPattern !== component) {
	                        subpattern += implicitExcludePathRegexPattern;
	                    }
	                    subpattern += componentPattern;
	                }
	                else {
	                    subpattern += component.replace(reservedCharacterPattern, replaceWildcardCharacter);
	                }
	            }
	            hasWrittenComponent = true;
	        }
	        while (optionalCount > 0) {
	            subpattern += ")?";
	            optionalCount--;
	        }
	        return subpattern;
	    }
	    function replaceWildcardCharacter(match, singleAsteriskRegexFragment) {
	        return match === "*" ? singleAsteriskRegexFragment : match === "?" ? "[^/]" : "\\" + match;
	    }
	    /** @param path directory of the tsconfig.json */
	    function getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory) {
	        path = normalizePath(path);
	        currentDirectory = normalizePath(currentDirectory);
	        var absolutePath = combinePaths(currentDirectory, path);
	        return {
	            includeFilePatterns: map(getRegularExpressionsForWildcards(includes, absolutePath, "files"), function (pattern) { return "^" + pattern + "$"; }),
	            includeFilePattern: getRegularExpressionForWildcard(includes, absolutePath, "files"),
	            includeDirectoryPattern: getRegularExpressionForWildcard(includes, absolutePath, "directories"),
	            excludePattern: getRegularExpressionForWildcard(excludes, absolutePath, "exclude"),
	            basePaths: getBasePaths(path, includes, useCaseSensitiveFileNames)
	        };
	    }
	    ts.getFileMatcherPatterns = getFileMatcherPatterns;
	    function getRegexFromPattern(pattern, useCaseSensitiveFileNames) {
	        return new RegExp(pattern, useCaseSensitiveFileNames ? "" : "i");
	    }
	    ts.getRegexFromPattern = getRegexFromPattern;
	    /** @param path directory of the tsconfig.json */
	    function matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries) {
	        path = normalizePath(path);
	        currentDirectory = normalizePath(currentDirectory);
	        var patterns = getFileMatcherPatterns(path, excludes, includes, useCaseSensitiveFileNames, currentDirectory);
	        var includeFileRegexes = patterns.includeFilePatterns && patterns.includeFilePatterns.map(function (pattern) { return getRegexFromPattern(pattern, useCaseSensitiveFileNames); });
	        var includeDirectoryRegex = patterns.includeDirectoryPattern && getRegexFromPattern(patterns.includeDirectoryPattern, useCaseSensitiveFileNames);
	        var excludeRegex = patterns.excludePattern && getRegexFromPattern(patterns.excludePattern, useCaseSensitiveFileNames);
	        // Associate an array of results with each include regex. This keeps results in order of the "include" order.
	        // If there are no "includes", then just put everything in results[0].
	        var results = includeFileRegexes ? includeFileRegexes.map(function () { return []; }) : [[]];
	        for (var _i = 0, _a = patterns.basePaths; _i < _a.length; _i++) {
	            var basePath = _a[_i];
	            visitDirectory(basePath, combinePaths(currentDirectory, basePath), depth);
	        }
	        return flatten(results);
	        function visitDirectory(path, absolutePath, depth) {
	            var _a = getFileSystemEntries(path), files = _a.files, directories = _a.directories;
	            var _loop_1 = function (current) {
	                var name = combinePaths(path, current);
	                var absoluteName = combinePaths(absolutePath, current);
	                if (extensions && !fileExtensionIsOneOf(name, extensions))
	                    return "continue";
	                if (excludeRegex && excludeRegex.test(absoluteName))
	                    return "continue";
	                if (!includeFileRegexes) {
	                    results[0].push(name);
	                }
	                else {
	                    var includeIndex = findIndex(includeFileRegexes, function (re) { return re.test(absoluteName); });
	                    if (includeIndex !== -1) {
	                        results[includeIndex].push(name);
	                    }
	                }
	            };
	            for (var _i = 0, _b = sort(files, compareStringsCaseSensitive); _i < _b.length; _i++) {
	                var current = _b[_i];
	                _loop_1(current);
	            }
	            if (depth !== undefined) {
	                depth--;
	                if (depth === 0) {
	                    return;
	                }
	            }
	            for (var _c = 0, _d = sort(directories, compareStringsCaseSensitive); _c < _d.length; _c++) {
	                var current = _d[_c];
	                var name = combinePaths(path, current);
	                var absoluteName = combinePaths(absolutePath, current);
	                if ((!includeDirectoryRegex || includeDirectoryRegex.test(absoluteName)) &&
	                    (!excludeRegex || !excludeRegex.test(absoluteName))) {
	                    visitDirectory(name, absoluteName, depth);
	                }
	            }
	        }
	    }
	    ts.matchFiles = matchFiles;
	    /**
	     * Computes the unique non-wildcard base paths amongst the provided include patterns.
	     */
	    function getBasePaths(path, includes, useCaseSensitiveFileNames) {
	        // Storage for our results in the form of literal paths (e.g. the paths as written by the user).
	        var basePaths = [path];
	        if (includes) {
	            // Storage for literal base paths amongst the include patterns.
	            var includeBasePaths = [];
	            for (var _i = 0, includes_1 = includes; _i < includes_1.length; _i++) {
	                var include = includes_1[_i];
	                // We also need to check the relative paths by converting them to absolute and normalizing
	                // in case they escape the base path (e.g "..\somedirectory")
	                var absolute = isRootedDiskPath(include) ? include : normalizePath(combinePaths(path, include));
	                // Append the literal and canonical candidate base paths.
	                includeBasePaths.push(getIncludeBasePath(absolute));
	            }
	            // Sort the offsets array using either the literal or canonical path representations.
	            includeBasePaths.sort(getStringComparer(!useCaseSensitiveFileNames));
	            var _loop_2 = function (includeBasePath) {
	                if (every(basePaths, function (basePath) { return !containsPath(basePath, includeBasePath, path, !useCaseSensitiveFileNames); })) {
	                    basePaths.push(includeBasePath);
	                }
	            };
	            // Iterate over each include base path and include unique base paths that are not a
	            // subpath of an existing base path
	            for (var _a = 0, includeBasePaths_1 = includeBasePaths; _a < includeBasePaths_1.length; _a++) {
	                var includeBasePath = includeBasePaths_1[_a];
	                _loop_2(includeBasePath);
	            }
	        }
	        return basePaths;
	    }
	    function getIncludeBasePath(absolute) {
	        var wildcardOffset = indexOfAnyCharCode(absolute, wildcardCharCodes);
	        if (wildcardOffset < 0) {
	            // No "*" or "?" in the path
	            return !hasExtension(absolute)
	                ? absolute
	                : removeTrailingDirectorySeparator(getDirectoryPath(absolute));
	        }
	        return absolute.substring(0, absolute.lastIndexOf(ts.directorySeparator, wildcardOffset));
	    }
	    function ensureScriptKind(fileName, scriptKind) {
	        // Using scriptKind as a condition handles both:
	        // - 'scriptKind' is unspecified and thus it is `undefined`
	        // - 'scriptKind' is set and it is `Unknown` (0)
	        // If the 'scriptKind' is 'undefined' or 'Unknown' then we attempt
	        // to get the ScriptKind from the file name. If it cannot be resolved
	        // from the file name then the default 'TS' script kind is returned.
	        return scriptKind || getScriptKindFromFileName(fileName) || 3 /* TS */;
	    }
	    ts.ensureScriptKind = ensureScriptKind;
	    function getScriptKindFromFileName(fileName) {
	        var ext = fileName.substr(fileName.lastIndexOf("."));
	        switch (ext.toLowerCase()) {
	            case ".js" /* Js */:
	                return 1 /* JS */;
	            case ".jsx" /* Jsx */:
	                return 2 /* JSX */;
	            case ".ts" /* Ts */:
	                return 3 /* TS */;
	            case ".tsx" /* Tsx */:
	                return 4 /* TSX */;
	            case ".json" /* Json */:
	                return 6 /* JSON */;
	            default:
	                return 0 /* Unknown */;
	        }
	    }
	    ts.getScriptKindFromFileName = getScriptKindFromFileName;
	    /**
	     *  List of supported extensions in order of file resolution precedence.
	     */
	    ts.supportedTypeScriptExtensions = [".ts" /* Ts */, ".tsx" /* Tsx */, ".d.ts" /* Dts */];
	    /** Must have ".d.ts" first because if ".ts" goes first, that will be detected as the extension instead of ".d.ts". */
	    ts.supportedTypescriptExtensionsForExtractExtension = [".d.ts" /* Dts */, ".ts" /* Ts */, ".tsx" /* Tsx */];
	    ts.supportedJavascriptExtensions = [".js" /* Js */, ".jsx" /* Jsx */];
	    var allSupportedExtensions = ts.supportedTypeScriptExtensions.concat(ts.supportedJavascriptExtensions);
	    function getSupportedExtensions(options, extraFileExtensions) {
	        var needJsExtensions = options && options.allowJs;
	        if (!extraFileExtensions || extraFileExtensions.length === 0) {
	            return needJsExtensions ? allSupportedExtensions : ts.supportedTypeScriptExtensions;
	        }
	        var extensions = (needJsExtensions ? allSupportedExtensions : ts.supportedTypeScriptExtensions).concat(mapDefined(extraFileExtensions, function (x) { return x.scriptKind === 7 /* Deferred */ || needJsExtensions && isJavaScriptLike(x.scriptKind) ? x.extension : undefined; }));
	        return deduplicate(extensions, equateStringsCaseSensitive, compareStringsCaseSensitive);
	    }
	    ts.getSupportedExtensions = getSupportedExtensions;
	    function isJavaScriptLike(scriptKind) {
	        return scriptKind === 1 /* JS */ || scriptKind === 2 /* JSX */;
	    }
	    function hasJavaScriptFileExtension(fileName) {
	        return forEach(ts.supportedJavascriptExtensions, function (extension) { return fileExtensionIs(fileName, extension); });
	    }
	    ts.hasJavaScriptFileExtension = hasJavaScriptFileExtension;
	    function hasTypeScriptFileExtension(fileName) {
	        return forEach(ts.supportedTypeScriptExtensions, function (extension) { return fileExtensionIs(fileName, extension); });
	    }
	    ts.hasTypeScriptFileExtension = hasTypeScriptFileExtension;
	    function isSupportedSourceFileName(fileName, compilerOptions, extraFileExtensions) {
	        if (!fileName) {
	            return false;
	        }
	        for (var _i = 0, _a = getSupportedExtensions(compilerOptions, extraFileExtensions); _i < _a.length; _i++) {
	            var extension = _a[_i];
	            if (fileExtensionIs(fileName, extension)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.isSupportedSourceFileName = isSupportedSourceFileName;
	    /**
	     * Extension boundaries by priority. Lower numbers indicate higher priorities, and are
	     * aligned to the offset of the highest priority extension in the
	     * allSupportedExtensions array.
	     */
	    var ExtensionPriority;
	    (function (ExtensionPriority) {
	        ExtensionPriority[ExtensionPriority["TypeScriptFiles"] = 0] = "TypeScriptFiles";
	        ExtensionPriority[ExtensionPriority["DeclarationAndJavaScriptFiles"] = 2] = "DeclarationAndJavaScriptFiles";
	        ExtensionPriority[ExtensionPriority["Highest"] = 0] = "Highest";
	        ExtensionPriority[ExtensionPriority["Lowest"] = 2] = "Lowest";
	    })(ExtensionPriority = ts.ExtensionPriority || (ts.ExtensionPriority = {}));
	    function getExtensionPriority(path, supportedExtensions) {
	        for (var i = supportedExtensions.length - 1; i >= 0; i--) {
	            if (fileExtensionIs(path, supportedExtensions[i])) {
	                return adjustExtensionPriority(i, supportedExtensions);
	            }
	        }
	        // If its not in the list of supported extensions, this is likely a
	        // TypeScript file with a non-ts extension
	        return 0 /* Highest */;
	    }
	    ts.getExtensionPriority = getExtensionPriority;
	    /**
	     * Adjusts an extension priority to be the highest priority within the same range.
	     */
	    function adjustExtensionPriority(extensionPriority, supportedExtensions) {
	        if (extensionPriority < 2 /* DeclarationAndJavaScriptFiles */) {
	            return 0 /* TypeScriptFiles */;
	        }
	        else if (extensionPriority < supportedExtensions.length) {
	            return 2 /* DeclarationAndJavaScriptFiles */;
	        }
	        else {
	            return supportedExtensions.length;
	        }
	    }
	    ts.adjustExtensionPriority = adjustExtensionPriority;
	    /**
	     * Gets the next lowest extension priority for a given priority.
	     */
	    function getNextLowestExtensionPriority(extensionPriority, supportedExtensions) {
	        if (extensionPriority < 2 /* DeclarationAndJavaScriptFiles */) {
	            return 2 /* DeclarationAndJavaScriptFiles */;
	        }
	        else {
	            return supportedExtensions.length;
	        }
	    }
	    ts.getNextLowestExtensionPriority = getNextLowestExtensionPriority;
	    var extensionsToRemove = [".d.ts" /* Dts */, ".ts" /* Ts */, ".js" /* Js */, ".tsx" /* Tsx */, ".jsx" /* Jsx */, ".json" /* Json */];
	    function removeFileExtension(path) {
	        for (var _i = 0, extensionsToRemove_1 = extensionsToRemove; _i < extensionsToRemove_1.length; _i++) {
	            var ext = extensionsToRemove_1[_i];
	            var extensionless = tryRemoveExtension(path, ext);
	            if (extensionless !== undefined) {
	                return extensionless;
	            }
	        }
	        return path;
	    }
	    ts.removeFileExtension = removeFileExtension;
	    function tryRemoveExtension(path, extension) {
	        return fileExtensionIs(path, extension) ? removeExtension(path, extension) : undefined;
	    }
	    ts.tryRemoveExtension = tryRemoveExtension;
	    function removeExtension(path, extension) {
	        return path.substring(0, path.length - extension.length);
	    }
	    ts.removeExtension = removeExtension;
	    function changeExtension(path, newExtension) {
	        return changeAnyExtension(path, newExtension, extensionsToRemove, /*ignoreCase*/ false);
	    }
	    ts.changeExtension = changeExtension;
	    function changeAnyExtension(path, ext, extensions, ignoreCase) {
	        var pathext = extensions !== undefined && ignoreCase !== undefined ? getAnyExtensionFromPath(path, extensions, ignoreCase) : getAnyExtensionFromPath(path);
	        return pathext ? path.slice(0, path.length - pathext.length) + (startsWith(ext, ".") ? ext : "." + ext) : path;
	    }
	    ts.changeAnyExtension = changeAnyExtension;
	    /**
	     * Takes a string like "jquery-min.4.2.3" and returns "jquery"
	     */
	    function removeMinAndVersionNumbers(fileName) {
	        // Match a "." or "-" followed by a version number or 'min' at the end of the name
	        var trailingMinOrVersion = /[.-]((min)|(\d+(\.\d+)*))$/;
	        // The "min" or version may both be present, in either order, so try applying the above twice.
	        return fileName.replace(trailingMinOrVersion, "").replace(trailingMinOrVersion, "");
	    }
	    ts.removeMinAndVersionNumbers = removeMinAndVersionNumbers;
	    function Symbol(flags, name) {
	        this.flags = flags;
	        this.escapedName = name;
	        this.declarations = undefined;
	        this.valueDeclaration = undefined;
	        this.id = undefined;
	        this.mergeId = undefined;
	        this.parent = undefined;
	    }
	    function Type(checker, flags) {
	        this.flags = flags;
	        if (Debug.isDebugging) {
	            this.checker = checker;
	        }
	    }
	    function Signature() { } // tslint:disable-line no-empty
	    function Node(kind, pos, end) {
	        this.pos = pos;
	        this.end = end;
	        this.kind = kind;
	        this.id = 0;
	        this.flags = 0 /* None */;
	        this.modifierFlagsCache = 0 /* None */;
	        this.transformFlags = 0 /* None */;
	        this.parent = undefined;
	        this.original = undefined;
	    }
	    function SourceMapSource(fileName, text, skipTrivia) {
	        this.fileName = fileName;
	        this.text = text;
	        this.skipTrivia = skipTrivia || (function (pos) { return pos; });
	    }
	    ts.objectAllocator = {
	        getNodeConstructor: function () { return Node; },
	        getTokenConstructor: function () { return Node; },
	        getIdentifierConstructor: function () { return Node; },
	        getSourceFileConstructor: function () { return Node; },
	        getSymbolConstructor: function () { return Symbol; },
	        getTypeConstructor: function () { return Type; },
	        getSignatureConstructor: function () { return Signature; },
	        getSourceMapSourceConstructor: function () { return SourceMapSource; },
	    };
	    var AssertionLevel;
	    (function (AssertionLevel) {
	        AssertionLevel[AssertionLevel["None"] = 0] = "None";
	        AssertionLevel[AssertionLevel["Normal"] = 1] = "Normal";
	        AssertionLevel[AssertionLevel["Aggressive"] = 2] = "Aggressive";
	        AssertionLevel[AssertionLevel["VeryAggressive"] = 3] = "VeryAggressive";
	    })(AssertionLevel = ts.AssertionLevel || (ts.AssertionLevel = {}));
	    var Debug;
	    (function (Debug) {
	        Debug.currentAssertionLevel = 0 /* None */;
	        Debug.isDebugging = false;
	        function shouldAssert(level) {
	            return Debug.currentAssertionLevel >= level;
	        }
	        Debug.shouldAssert = shouldAssert;
	        function assert(expression, message, verboseDebugInfo, stackCrawlMark) {
	            if (!expression) {
	                if (verboseDebugInfo) {
	                    message += "\r\nVerbose Debug Information: " + (typeof verboseDebugInfo === "string" ? verboseDebugInfo : verboseDebugInfo());
	                }
	                fail(message ? "False expression: " + message : "False expression.", stackCrawlMark || assert);
	            }
	        }
	        Debug.assert = assert;
	        function assertEqual(a, b, msg, msg2) {
	            if (a !== b) {
	                var message = msg ? msg2 ? msg + " " + msg2 : msg : "";
	                fail("Expected " + a + " === " + b + ". " + message);
	            }
	        }
	        Debug.assertEqual = assertEqual;
	        function assertLessThan(a, b, msg) {
	            if (a >= b) {
	                fail("Expected " + a + " < " + b + ". " + (msg || ""));
	            }
	        }
	        Debug.assertLessThan = assertLessThan;
	        function assertLessThanOrEqual(a, b) {
	            if (a > b) {
	                fail("Expected " + a + " <= " + b);
	            }
	        }
	        Debug.assertLessThanOrEqual = assertLessThanOrEqual;
	        function assertGreaterThanOrEqual(a, b) {
	            if (a < b) {
	                fail("Expected " + a + " >= " + b);
	            }
	        }
	        Debug.assertGreaterThanOrEqual = assertGreaterThanOrEqual;
	        function fail(message, stackCrawlMark) {
	            debugger;
	            var e = new Error(message ? "Debug Failure. " + message : "Debug Failure.");
	            if (Error.captureStackTrace) {
	                Error.captureStackTrace(e, stackCrawlMark || fail);
	            }
	            throw e;
	        }
	        Debug.fail = fail;
	        function assertDefined(value, message) {
	            assert(value !== undefined && value !== null, message);
	            return value;
	        }
	        Debug.assertDefined = assertDefined;
	        function assertEachDefined(value, message) {
	            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
	                var v = value_1[_i];
	                assertDefined(v, message);
	            }
	            return value;
	        }
	        Debug.assertEachDefined = assertEachDefined;
	        function assertNever(member, message, stackCrawlMark) {
	            return fail(message || "Illegal value: " + member, stackCrawlMark || assertNever);
	        }
	        Debug.assertNever = assertNever;
	        function getFunctionName(func) {
	            if (typeof func !== "function") {
	                return "";
	            }
	            else if (func.hasOwnProperty("name")) {
	                return func.name;
	            }
	            else {
	                var text = Function.prototype.toString.call(func);
	                var match = /^function\s+([\w\$]+)\s*\(/.exec(text);
	                return match ? match[1] : "";
	            }
	        }
	        Debug.getFunctionName = getFunctionName;
	        function showSymbol(symbol) {
	            var symbolFlags = ts.SymbolFlags;
	            return "{ flags: " + (symbolFlags ? showFlags(symbol.flags, symbolFlags) : symbol.flags) + "; declarations: " + map(symbol.declarations, showSyntaxKind) + " }";
	        }
	        Debug.showSymbol = showSymbol;
	        function showFlags(flags, flagsEnum) {
	            var out = [];
	            for (var pow = 0; pow <= 30; pow++) {
	                var n = 1 << pow;
	                if (flags & n) {
	                    out.push(flagsEnum[n]);
	                }
	            }
	            return out.join("|");
	        }
	        function showSyntaxKind(node) {
	            var syntaxKind = ts.SyntaxKind;
	            return syntaxKind ? syntaxKind[node.kind] : node.kind.toString();
	        }
	        Debug.showSyntaxKind = showSyntaxKind;
	    })(Debug = ts.Debug || (ts.Debug = {}));
	    /** Remove an item from an array, moving everything to its right one space left. */
	    function orderedRemoveItem(array, item) {
	        for (var i = 0; i < array.length; i++) {
	            if (array[i] === item) {
	                orderedRemoveItemAt(array, i);
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.orderedRemoveItem = orderedRemoveItem;
	    /** Remove an item by index from an array, moving everything to its right one space left. */
	    function orderedRemoveItemAt(array, index) {
	        // This seems to be faster than either `array.splice(i, 1)` or `array.copyWithin(i, i+ 1)`.
	        for (var i = index; i < array.length - 1; i++) {
	            array[i] = array[i + 1];
	        }
	        array.pop();
	    }
	    ts.orderedRemoveItemAt = orderedRemoveItemAt;
	    function unorderedRemoveItemAt(array, index) {
	        // Fill in the "hole" left at `index`.
	        array[index] = array[array.length - 1];
	        array.pop();
	    }
	    ts.unorderedRemoveItemAt = unorderedRemoveItemAt;
	    /** Remove the *first* occurrence of `item` from the array. */
	    function unorderedRemoveItem(array, item) {
	        return unorderedRemoveFirstItemWhere(array, function (element) { return element === item; });
	    }
	    ts.unorderedRemoveItem = unorderedRemoveItem;
	    /** Remove the *first* element satisfying `predicate`. */
	    function unorderedRemoveFirstItemWhere(array, predicate) {
	        for (var i = 0; i < array.length; i++) {
	            if (predicate(array[i])) {
	                unorderedRemoveItemAt(array, i);
	                return true;
	            }
	        }
	        return false;
	    }
	    function createGetCanonicalFileName(useCaseSensitiveFileNames) {
	        return useCaseSensitiveFileNames ? identity : toLowerCase;
	    }
	    ts.createGetCanonicalFileName = createGetCanonicalFileName;
	    /**
	     * patternStrings contains both pattern strings (containing "*") and regular strings.
	     * Return an exact match if possible, or a pattern match, or undefined.
	     * (These are verified by verifyCompilerOptions to have 0 or 1 "*" characters.)
	     */
	    function matchPatternOrExact(patternStrings, candidate) {
	        var patterns = [];
	        for (var _i = 0, patternStrings_1 = patternStrings; _i < patternStrings_1.length; _i++) {
	            var patternString = patternStrings_1[_i];
	            var pattern = tryParsePattern(patternString);
	            if (pattern) {
	                patterns.push(pattern);
	            }
	            else if (patternString === candidate) {
	                // pattern was matched as is - no need to search further
	                return patternString;
	            }
	        }
	        return findBestPatternMatch(patterns, function (_) { return _; }, candidate);
	    }
	    ts.matchPatternOrExact = matchPatternOrExact;
	    function patternText(_a) {
	        var prefix = _a.prefix, suffix = _a.suffix;
	        return prefix + "*" + suffix;
	    }
	    ts.patternText = patternText;
	    /**
	     * Given that candidate matches pattern, returns the text matching the '*'.
	     * E.g.: matchedText(tryParsePattern("foo*baz"), "foobarbaz") === "bar"
	     */
	    function matchedText(pattern, candidate) {
	        Debug.assert(isPatternMatch(pattern, candidate));
	        return candidate.substring(pattern.prefix.length, candidate.length - pattern.suffix.length);
	    }
	    ts.matchedText = matchedText;
	    /** Return the object corresponding to the best pattern to match `candidate`. */
	    function findBestPatternMatch(values, getPattern, candidate) {
	        var matchedValue;
	        // use length of prefix as betterness criteria
	        var longestMatchPrefixLength = -1;
	        for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
	            var v = values_2[_i];
	            var pattern = getPattern(v);
	            if (isPatternMatch(pattern, candidate) && pattern.prefix.length > longestMatchPrefixLength) {
	                longestMatchPrefixLength = pattern.prefix.length;
	                matchedValue = v;
	            }
	        }
	        return matchedValue;
	    }
	    ts.findBestPatternMatch = findBestPatternMatch;
	    function isPatternMatch(_a, candidate) {
	        var prefix = _a.prefix, suffix = _a.suffix;
	        return candidate.length >= prefix.length + suffix.length &&
	            startsWith(candidate, prefix) &&
	            endsWith(candidate, suffix);
	    }
	    function tryParsePattern(pattern) {
	        // This should be verified outside of here and a proper error thrown.
	        Debug.assert(hasZeroOrOneAsteriskCharacter(pattern));
	        var indexOfStar = pattern.indexOf("*");
	        return indexOfStar === -1 ? undefined : {
	            prefix: pattern.substr(0, indexOfStar),
	            suffix: pattern.substr(indexOfStar + 1)
	        };
	    }
	    ts.tryParsePattern = tryParsePattern;
	    function positionIsSynthesized(pos) {
	        // This is a fast way of testing the following conditions:
	        //  pos === undefined || pos === null || isNaN(pos) || pos < 0;
	        return !(pos >= 0);
	    }
	    ts.positionIsSynthesized = positionIsSynthesized;
	    /** True if an extension is one of the supported TypeScript extensions. */
	    function extensionIsTypeScript(ext) {
	        return ext === ".ts" /* Ts */ || ext === ".tsx" /* Tsx */ || ext === ".d.ts" /* Dts */;
	    }
	    ts.extensionIsTypeScript = extensionIsTypeScript;
	    function resolutionExtensionIsTypeScriptOrJson(ext) {
	        return extensionIsTypeScript(ext) || ext === ".json" /* Json */;
	    }
	    ts.resolutionExtensionIsTypeScriptOrJson = resolutionExtensionIsTypeScriptOrJson;
	    /**
	     * Gets the extension from a path.
	     * Path must have a valid extension.
	     */
	    function extensionFromPath(path) {
	        var ext = tryGetExtensionFromPath(path);
	        if (ext !== undefined) {
	            return ext;
	        }
	        Debug.fail("File " + path + " has unknown extension.");
	    }
	    ts.extensionFromPath = extensionFromPath;
	    function isAnySupportedFileExtension(path) {
	        return tryGetExtensionFromPath(path) !== undefined;
	    }
	    ts.isAnySupportedFileExtension = isAnySupportedFileExtension;
	    function tryGetExtensionFromPath(path) {
	        return find(ts.supportedTypescriptExtensionsForExtractExtension, function (e) { return fileExtensionIs(path, e); }) || find(ts.supportedJavascriptExtensions, function (e) { return fileExtensionIs(path, e); });
	    }
	    ts.tryGetExtensionFromPath = tryGetExtensionFromPath;
	    function getAnyExtensionFromPathWorker(path, extensions, stringEqualityComparer) {
	        if (typeof extensions === "string")
	            extensions = [extensions];
	        for (var _i = 0, extensions_2 = extensions; _i < extensions_2.length; _i++) {
	            var extension = extensions_2[_i];
	            if (!startsWith(extension, "."))
	                extension = "." + extension;
	            if (path.length >= extension.length && path.charAt(path.length - extension.length) === ".") {
	                var pathExtension = path.slice(path.length - extension.length);
	                if (stringEqualityComparer(pathExtension, extension)) {
	                    return pathExtension;
	                }
	            }
	        }
	        return "";
	    }
	    function getAnyExtensionFromPath(path, extensions, ignoreCase) {
	        // Retrieves any string from the final "." onwards from a base file name.
	        // Unlike extensionFromPath, which throws an exception on unrecognized extensions.
	        if (extensions) {
	            return getAnyExtensionFromPathWorker(path, extensions, ignoreCase ? equateStringsCaseInsensitive : equateStringsCaseSensitive);
	        }
	        var baseFileName = getBaseFileName(path);
	        var extensionIndex = baseFileName.lastIndexOf(".");
	        if (extensionIndex >= 0) {
	            return baseFileName.substring(extensionIndex);
	        }
	        return "";
	    }
	    ts.getAnyExtensionFromPath = getAnyExtensionFromPath;
	    function isCheckJsEnabledForFile(sourceFile, compilerOptions) {
	        return sourceFile.checkJsDirective ? sourceFile.checkJsDirective.enabled : compilerOptions.checkJs;
	    }
	    ts.isCheckJsEnabledForFile = isCheckJsEnabledForFile;
	    function and(f, g) {
	        return function (arg) { return f(arg) && g(arg); };
	    }
	    ts.and = and;
	    function or(f, g) {
	        return function (arg) { return f(arg) || g(arg); };
	    }
	    ts.or = or;
	    function assertTypeIsNever(_) { } // tslint:disable-line no-empty
	    ts.assertTypeIsNever = assertTypeIsNever;
	    ts.emptyFileSystemEntries = {
	        files: ts.emptyArray,
	        directories: ts.emptyArray
	    };
	    function singleElementArray(t) {
	        return t === undefined ? undefined : [t];
	    }
	    ts.singleElementArray = singleElementArray;
	    function enumerateInsertsAndDeletes(newItems, oldItems, comparer, inserted, deleted, unchanged) {
	        unchanged = unchanged || noop;
	        var newIndex = 0;
	        var oldIndex = 0;
	        var newLen = newItems.length;
	        var oldLen = oldItems.length;
	        while (newIndex < newLen && oldIndex < oldLen) {
	            var newItem = newItems[newIndex];
	            var oldItem = oldItems[oldIndex];
	            var compareResult = comparer(newItem, oldItem);
	            if (compareResult === -1 /* LessThan */) {
	                inserted(newItem);
	                newIndex++;
	            }
	            else if (compareResult === 1 /* GreaterThan */) {
	                deleted(oldItem);
	                oldIndex++;
	            }
	            else {
	                unchanged(oldItem, newItem);
	                newIndex++;
	                oldIndex++;
	            }
	        }
	        while (newIndex < newLen) {
	            inserted(newItems[newIndex++]);
	        }
	        while (oldIndex < oldLen) {
	            deleted(oldItems[oldIndex++]);
	        }
	    }
	    ts.enumerateInsertsAndDeletes = enumerateInsertsAndDeletes;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /**
	     * Set a high stack trace limit to provide more information in case of an error.
	     * Called for command-line and server use cases.
	     * Not called if TypeScript is used as a library.
	     */
	    /* @internal */
	    function setStackTraceLimit() {
	        if (Error.stackTraceLimit < 100) { // Also tests that we won't set the property if it doesn't exist.
	            Error.stackTraceLimit = 100;
	        }
	    }
	    ts.setStackTraceLimit = setStackTraceLimit;
	    var FileWatcherEventKind;
	    (function (FileWatcherEventKind) {
	        FileWatcherEventKind[FileWatcherEventKind["Created"] = 0] = "Created";
	        FileWatcherEventKind[FileWatcherEventKind["Changed"] = 1] = "Changed";
	        FileWatcherEventKind[FileWatcherEventKind["Deleted"] = 2] = "Deleted";
	    })(FileWatcherEventKind = ts.FileWatcherEventKind || (ts.FileWatcherEventKind = {}));
	    /* @internal */
	    var PollingInterval;
	    (function (PollingInterval) {
	        PollingInterval[PollingInterval["High"] = 2000] = "High";
	        PollingInterval[PollingInterval["Medium"] = 500] = "Medium";
	        PollingInterval[PollingInterval["Low"] = 250] = "Low";
	    })(PollingInterval = ts.PollingInterval || (ts.PollingInterval = {}));
	    function getPriorityValues(highPriorityValue) {
	        var mediumPriorityValue = highPriorityValue * 2;
	        var lowPriorityValue = mediumPriorityValue * 4;
	        return [highPriorityValue, mediumPriorityValue, lowPriorityValue];
	    }
	    function pollingInterval(watchPriority) {
	        return pollingIntervalsForPriority[watchPriority];
	    }
	    var pollingIntervalsForPriority = getPriorityValues(250);
	    /* @internal */
	    function watchFileUsingPriorityPollingInterval(host, fileName, callback, watchPriority) {
	        return host.watchFile(fileName, callback, pollingInterval(watchPriority));
	    }
	    ts.watchFileUsingPriorityPollingInterval = watchFileUsingPriorityPollingInterval;
	    /* @internal */
	    ts.missingFileModifiedTime = new Date(0); // Any subsequent modification will occur after this time
	    function createPollingIntervalBasedLevels(levels) {
	        var _a;
	        return _a = {},
	            _a[PollingInterval.Low] = levels.Low,
	            _a[PollingInterval.Medium] = levels.Medium,
	            _a[PollingInterval.High] = levels.High,
	            _a;
	    }
	    var defaultChunkLevels = { Low: 32, Medium: 64, High: 256 };
	    var pollingChunkSize = createPollingIntervalBasedLevels(defaultChunkLevels);
	    /* @internal */
	    ts.unchangedPollThresholds = createPollingIntervalBasedLevels(defaultChunkLevels);
	    /* @internal */
	    function setCustomPollingValues(system) {
	        if (!system.getEnvironmentVariable) {
	            return;
	        }
	        var pollingIntervalChanged = setCustomLevels("TSC_WATCH_POLLINGINTERVAL", PollingInterval);
	        pollingChunkSize = getCustomPollingBasedLevels("TSC_WATCH_POLLINGCHUNKSIZE", defaultChunkLevels) || pollingChunkSize;
	        ts.unchangedPollThresholds = getCustomPollingBasedLevels("TSC_WATCH_UNCHANGEDPOLLTHRESHOLDS", defaultChunkLevels) || ts.unchangedPollThresholds;
	        function getLevel(envVar, level) {
	            return system.getEnvironmentVariable(envVar + "_" + level.toUpperCase());
	        }
	        function getCustomLevels(baseVariable) {
	            var customLevels;
	            setCustomLevel("Low");
	            setCustomLevel("Medium");
	            setCustomLevel("High");
	            return customLevels;
	            function setCustomLevel(level) {
	                var customLevel = getLevel(baseVariable, level);
	                if (customLevel) {
	                    (customLevels || (customLevels = {}))[level] = Number(customLevel);
	                }
	            }
	        }
	        function setCustomLevels(baseVariable, levels) {
	            var customLevels = getCustomLevels(baseVariable);
	            if (customLevels) {
	                setLevel("Low");
	                setLevel("Medium");
	                setLevel("High");
	                return true;
	            }
	            return false;
	            function setLevel(level) {
	                levels[level] = customLevels[level] || levels[level];
	            }
	        }
	        function getCustomPollingBasedLevels(baseVariable, defaultLevels) {
	            var customLevels = getCustomLevels(baseVariable);
	            return (pollingIntervalChanged || customLevels) &&
	                createPollingIntervalBasedLevels(customLevels ? __assign({}, defaultLevels, customLevels) : defaultLevels);
	        }
	    }
	    ts.setCustomPollingValues = setCustomPollingValues;
	    /* @internal */
	    function createDynamicPriorityPollingWatchFile(host) {
	        var watchedFiles = [];
	        var changedFilesInLastPoll = [];
	        var lowPollingIntervalQueue = createPollingIntervalQueue(PollingInterval.Low);
	        var mediumPollingIntervalQueue = createPollingIntervalQueue(PollingInterval.Medium);
	        var highPollingIntervalQueue = createPollingIntervalQueue(PollingInterval.High);
	        return watchFile;
	        function watchFile(fileName, callback, defaultPollingInterval) {
	            var file = {
	                fileName: fileName,
	                callback: callback,
	                unchangedPolls: 0,
	                mtime: getModifiedTime(fileName)
	            };
	            watchedFiles.push(file);
	            addToPollingIntervalQueue(file, defaultPollingInterval);
	            return {
	                close: function () {
	                    file.isClosed = true;
	                    // Remove from watchedFiles
	                    ts.unorderedRemoveItem(watchedFiles, file);
	                    // Do not update polling interval queue since that will happen as part of polling
	                }
	            };
	        }
	        function createPollingIntervalQueue(pollingInterval) {
	            var queue = [];
	            queue.pollingInterval = pollingInterval;
	            queue.pollIndex = 0;
	            queue.pollScheduled = false;
	            return queue;
	        }
	        function pollPollingIntervalQueue(queue) {
	            queue.pollIndex = pollQueue(queue, queue.pollingInterval, queue.pollIndex, pollingChunkSize[queue.pollingInterval]);
	            // Set the next polling index and timeout
	            if (queue.length) {
	                scheduleNextPoll(queue.pollingInterval);
	            }
	            else {
	                ts.Debug.assert(queue.pollIndex === 0);
	                queue.pollScheduled = false;
	            }
	        }
	        function pollLowPollingIntervalQueue(queue) {
	            // Always poll complete list of changedFilesInLastPoll
	            pollQueue(changedFilesInLastPoll, PollingInterval.Low, /*pollIndex*/ 0, changedFilesInLastPoll.length);
	            // Finally do the actual polling of the queue
	            pollPollingIntervalQueue(queue);
	            // Schedule poll if there are files in changedFilesInLastPoll but no files in the actual queue
	            // as pollPollingIntervalQueue wont schedule for next poll
	            if (!queue.pollScheduled && changedFilesInLastPoll.length) {
	                scheduleNextPoll(PollingInterval.Low);
	            }
	        }
	        function pollQueue(queue, pollingInterval, pollIndex, chunkSize) {
	            // Max visit would be all elements of the queue
	            var needsVisit = queue.length;
	            var definedValueCopyToIndex = pollIndex;
	            for (var polled = 0; polled < chunkSize && needsVisit > 0; nextPollIndex(), needsVisit--) {
	                var watchedFile = queue[pollIndex];
	                if (!watchedFile) {
	                    continue;
	                }
	                else if (watchedFile.isClosed) {
	                    queue[pollIndex] = undefined;
	                    continue;
	                }
	                polled++;
	                var fileChanged = onWatchedFileStat(watchedFile, getModifiedTime(watchedFile.fileName));
	                if (watchedFile.isClosed) {
	                    // Closed watcher as part of callback
	                    queue[pollIndex] = undefined;
	                }
	                else if (fileChanged) {
	                    watchedFile.unchangedPolls = 0;
	                    // Changed files go to changedFilesInLastPoll queue
	                    if (queue !== changedFilesInLastPoll) {
	                        queue[pollIndex] = undefined;
	                        addChangedFileToLowPollingIntervalQueue(watchedFile);
	                    }
	                }
	                else if (watchedFile.unchangedPolls !== ts.unchangedPollThresholds[pollingInterval]) {
	                    watchedFile.unchangedPolls++;
	                }
	                else if (queue === changedFilesInLastPoll) {
	                    // Restart unchangedPollCount for unchanged file and move to low polling interval queue
	                    watchedFile.unchangedPolls = 1;
	                    queue[pollIndex] = undefined;
	                    addToPollingIntervalQueue(watchedFile, PollingInterval.Low);
	                }
	                else if (pollingInterval !== PollingInterval.High) {
	                    watchedFile.unchangedPolls++;
	                    queue[pollIndex] = undefined;
	                    addToPollingIntervalQueue(watchedFile, pollingInterval === PollingInterval.Low ? PollingInterval.Medium : PollingInterval.High);
	                }
	                if (queue[pollIndex]) {
	                    // Copy this file to the non hole location
	                    if (definedValueCopyToIndex < pollIndex) {
	                        queue[definedValueCopyToIndex] = watchedFile;
	                        queue[pollIndex] = undefined;
	                    }
	                    definedValueCopyToIndex++;
	                }
	            }
	            // Return next poll index
	            return pollIndex;
	            function nextPollIndex() {
	                pollIndex++;
	                if (pollIndex === queue.length) {
	                    if (definedValueCopyToIndex < pollIndex) {
	                        // There are holes from nextDefinedValueIndex to end of queue, change queue size
	                        queue.length = definedValueCopyToIndex;
	                    }
	                    pollIndex = 0;
	                    definedValueCopyToIndex = 0;
	                }
	            }
	        }
	        function pollingIntervalQueue(pollingInterval) {
	            switch (pollingInterval) {
	                case PollingInterval.Low:
	                    return lowPollingIntervalQueue;
	                case PollingInterval.Medium:
	                    return mediumPollingIntervalQueue;
	                case PollingInterval.High:
	                    return highPollingIntervalQueue;
	            }
	        }
	        function addToPollingIntervalQueue(file, pollingInterval) {
	            pollingIntervalQueue(pollingInterval).push(file);
	            scheduleNextPollIfNotAlreadyScheduled(pollingInterval);
	        }
	        function addChangedFileToLowPollingIntervalQueue(file) {
	            changedFilesInLastPoll.push(file);
	            scheduleNextPollIfNotAlreadyScheduled(PollingInterval.Low);
	        }
	        function scheduleNextPollIfNotAlreadyScheduled(pollingInterval) {
	            if (!pollingIntervalQueue(pollingInterval).pollScheduled) {
	                scheduleNextPoll(pollingInterval);
	            }
	        }
	        function scheduleNextPoll(pollingInterval) {
	            pollingIntervalQueue(pollingInterval).pollScheduled = host.setTimeout(pollingInterval === PollingInterval.Low ? pollLowPollingIntervalQueue : pollPollingIntervalQueue, pollingInterval, pollingIntervalQueue(pollingInterval));
	        }
	        function getModifiedTime(fileName) {
	            return host.getModifiedTime(fileName) || ts.missingFileModifiedTime;
	        }
	    }
	    ts.createDynamicPriorityPollingWatchFile = createDynamicPriorityPollingWatchFile;
	    /**
	     * Returns true if file status changed
	     */
	    /*@internal*/
	    function onWatchedFileStat(watchedFile, modifiedTime) {
	        var oldTime = watchedFile.mtime.getTime();
	        var newTime = modifiedTime.getTime();
	        if (oldTime !== newTime) {
	            watchedFile.mtime = modifiedTime;
	            var eventKind = oldTime === 0
	                ? FileWatcherEventKind.Created
	                : newTime === 0
	                    ? FileWatcherEventKind.Deleted
	                    : FileWatcherEventKind.Changed;
	            watchedFile.callback(watchedFile.fileName, eventKind);
	            return true;
	        }
	        return false;
	    }
	    ts.onWatchedFileStat = onWatchedFileStat;
	    /**
	     * Watch the directory recursively using host provided method to watch child directories
	     * that means if this is recursive watcher, watch the children directories as well
	     * (eg on OS that dont support recursive watch using fs.watch use fs.watchFile)
	     */
	    /*@internal*/
	    function createRecursiveDirectoryWatcher(host) {
	        return createDirectoryWatcher;
	        /**
	         * Create the directory watcher for the dirPath.
	         */
	        function createDirectoryWatcher(dirName, callback) {
	            var watcher = host.watchDirectory(dirName, function (fileName) {
	                // Call the actual callback
	                callback(fileName);
	                // Iterate through existing children and update the watches if needed
	                updateChildWatches(result, callback);
	            });
	            var result = {
	                close: function () {
	                    watcher.close();
	                    result.childWatches.forEach(ts.closeFileWatcher);
	                    result = undefined;
	                },
	                dirName: dirName,
	                childWatches: ts.emptyArray
	            };
	            updateChildWatches(result, callback);
	            return result;
	        }
	        function updateChildWatches(watcher, callback) {
	            // Iterate through existing children and update the watches if needed
	            if (watcher) {
	                watcher.childWatches = watchChildDirectories(watcher.dirName, watcher.childWatches, callback);
	            }
	        }
	        /**
	         * Watch the directories in the parentDir
	         */
	        function watchChildDirectories(parentDir, existingChildWatches, callback) {
	            var newChildWatches;
	            ts.enumerateInsertsAndDeletes(host.directoryExists(parentDir) ? ts.mapDefined(host.getAccessibleSortedChildDirectories(parentDir), function (child) {
	                var childFullName = ts.getNormalizedAbsolutePath(child, parentDir);
	                // Filter our the symbolic link directories since those arent included in recursive watch
	                // which is same behaviour when recursive: true is passed to fs.watch
	                return host.filePathComparer(childFullName, host.realpath(childFullName)) === 0 /* EqualTo */ ? childFullName : undefined;
	            }) : ts.emptyArray, existingChildWatches, function (child, childWatcher) { return host.filePathComparer(child, childWatcher.dirName); }, createAndAddChildDirectoryWatcher, ts.closeFileWatcher, addChildDirectoryWatcher);
	            return newChildWatches || ts.emptyArray;
	            /**
	             * Create new childDirectoryWatcher and add it to the new ChildDirectoryWatcher list
	             */
	            function createAndAddChildDirectoryWatcher(childName) {
	                var result = createDirectoryWatcher(childName, callback);
	                addChildDirectoryWatcher(result);
	            }
	            /**
	             * Add child directory watcher to the new ChildDirectoryWatcher list
	             */
	            function addChildDirectoryWatcher(childWatcher) {
	                (newChildWatches || (newChildWatches = [])).push(childWatcher);
	            }
	        }
	    }
	    ts.createRecursiveDirectoryWatcher = createRecursiveDirectoryWatcher;
	    function getNodeMajorVersion() {
	        if (typeof process === "undefined") {
	            return undefined;
	        }
	        var version = process.version;
	        if (!version) {
	            return undefined;
	        }
	        var dot = version.indexOf(".");
	        if (dot === -1) {
	            return undefined;
	        }
	        return parseInt(version.substring(1, dot));
	    }
	    ts.getNodeMajorVersion = getNodeMajorVersion;
	    ts.sys = (function () {
	        // NodeJS detects "\uFEFF" at the start of the string and *replaces* it with the actual
	        // byte order mark from the specified encoding. Using any other byte order mark does
	        // not actually work.
	        var byteOrderMarkIndicator = "\uFEFF";
	        function getNodeSystem() {
	            var _fs = __webpack_require__(1310);
	            var _path = __webpack_require__(1311);
	            var _os = __webpack_require__(1312);
	            // crypto can be absent on reduced node installations
	            var _crypto;
	            try {
	                _crypto = __webpack_require__(965);
	            }
	            catch (_a) {
	                _crypto = undefined;
	            }
	            var Buffer = __webpack_require__(966).Buffer;
	            var nodeVersion = getNodeMajorVersion();
	            var isNode4OrLater = nodeVersion >= 4;
	            var platform = _os.platform();
	            var useCaseSensitiveFileNames = isFileSystemCaseSensitive();
	            var FileSystemEntryKind;
	            (function (FileSystemEntryKind) {
	                FileSystemEntryKind[FileSystemEntryKind["File"] = 0] = "File";
	                FileSystemEntryKind[FileSystemEntryKind["Directory"] = 1] = "Directory";
	            })(FileSystemEntryKind || (FileSystemEntryKind = {}));
	            var useNonPollingWatchers = process.env.TSC_NONPOLLING_WATCHER;
	            var tscWatchFile = process.env.TSC_WATCHFILE;
	            var tscWatchDirectory = process.env.TSC_WATCHDIRECTORY;
	            var dynamicPollingWatchFile;
	            var nodeSystem = {
	                args: process.argv.slice(2),
	                newLine: _os.EOL,
	                useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	                write: function (s) {
	                    process.stdout.write(s);
	                },
	                writeOutputIsTTY: function () {
	                    return process.stdout.isTTY;
	                },
	                readFile: readFile,
	                writeFile: writeFile,
	                watchFile: getWatchFile(),
	                watchDirectory: getWatchDirectory(),
	                resolvePath: function (path) { return _path.resolve(path); },
	                fileExists: fileExists,
	                directoryExists: directoryExists,
	                createDirectory: function (directoryName) {
	                    if (!nodeSystem.directoryExists(directoryName)) {
	                        _fs.mkdirSync(directoryName);
	                    }
	                },
	                getExecutingFilePath: function () {
	                    return __filename;
	                },
	                getCurrentDirectory: function () {
	                    return process.cwd();
	                },
	                getDirectories: getDirectories,
	                getEnvironmentVariable: function (name) {
	                    return process.env[name] || "";
	                },
	                readDirectory: readDirectory,
	                getModifiedTime: getModifiedTime,
	                createHash: _crypto ? createMD5HashUsingNativeCrypto : generateDjb2Hash,
	                createSHA256Hash: _crypto ? createSHA256Hash : undefined,
	                getMemoryUsage: function () {
	                    if (global.gc) {
	                        global.gc();
	                    }
	                    return process.memoryUsage().heapUsed;
	                },
	                getFileSize: function (path) {
	                    try {
	                        var stat = _fs.statSync(path);
	                        if (stat.isFile()) {
	                            return stat.size;
	                        }
	                    }
	                    catch ( /*ignore*/_a) { /*ignore*/ }
	                    return 0;
	                },
	                exit: function (exitCode) {
	                    process.exit(exitCode);
	                },
	                realpath: realpath,
	                debugMode: ts.some(process.execArgv, function (arg) { return /^--(inspect|debug)(-brk)?(=\d+)?$/i.test(arg); }),
	                tryEnableSourceMapsForHost: function () {
	                    try {
	                        __webpack_require__(1313).install();
	                    }
	                    catch (_a) {
	                        // Could not enable source maps.
	                    }
	                },
	                setTimeout: setTimeout,
	                clearTimeout: clearTimeout,
	                clearScreen: function () {
	                    process.stdout.write("\x1Bc");
	                },
	                setBlocking: function () {
	                    if (process.stdout && process.stdout._handle && process.stdout._handle.setBlocking) {
	                        process.stdout._handle.setBlocking(true);
	                    }
	                },
	                base64decode: Buffer.from ? function (input) {
	                    return Buffer.from(input, "base64").toString("utf8");
	                } : function (input) {
	                    return new Buffer(input, "base64").toString("utf8");
	                },
	                base64encode: Buffer.from ? function (input) {
	                    return Buffer.from(input).toString("base64");
	                } : function (input) {
	                    return new Buffer(input).toString("base64");
	                }
	            };
	            return nodeSystem;
	            function isFileSystemCaseSensitive() {
	                // win32\win64 are case insensitive platforms
	                if (platform === "win32" || platform === "win64") {
	                    return false;
	                }
	                // If this file exists under a different case, we must be case-insensitve.
	                return !fileExists(swapCase(__filename));
	            }
	            /** Convert all lowercase chars to uppercase, and vice-versa */
	            function swapCase(s) {
	                return s.replace(/\w/g, function (ch) {
	                    var up = ch.toUpperCase();
	                    return ch === up ? ch.toLowerCase() : up;
	                });
	            }
	            function getWatchFile() {
	                switch (tscWatchFile) {
	                    case "PriorityPollingInterval":
	                        // Use polling interval based on priority when create watch using host.watchFile
	                        return fsWatchFile;
	                    case "DynamicPriorityPolling":
	                        // Use polling interval but change the interval depending on file changes and their default polling interval
	                        return createDynamicPriorityPollingWatchFile({ getModifiedTime: getModifiedTime, setTimeout: setTimeout });
	                    case "UseFsEvents":
	                        // Use notifications from FS to watch with falling back to fs.watchFile
	                        return watchFileUsingFsWatch;
	                    case "UseFsEventsWithFallbackDynamicPolling":
	                        // Use notifications from FS to watch with falling back to dynamic watch file
	                        dynamicPollingWatchFile = createDynamicPriorityPollingWatchFile({ getModifiedTime: getModifiedTime, setTimeout: setTimeout });
	                        return createWatchFileUsingDynamicWatchFile(dynamicPollingWatchFile);
	                    case "UseFsEventsOnParentDirectory":
	                        // Use notifications from FS to watch with falling back to fs.watchFile
	                        return createNonPollingWatchFile();
	                }
	                return useNonPollingWatchers ?
	                    createNonPollingWatchFile() :
	                    // Default to do not use polling interval as it is before this experiment branch
	                    function (fileName, callback) { return fsWatchFile(fileName, callback); };
	            }
	            function getWatchDirectory() {
	                // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
	                // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
	                var fsSupportsRecursive = isNode4OrLater && (process.platform === "win32" || process.platform === "darwin");
	                if (fsSupportsRecursive) {
	                    return watchDirectoryUsingFsWatch;
	                }
	                var watchDirectory = tscWatchDirectory === "RecursiveDirectoryUsingFsWatchFile" ?
	                    createWatchDirectoryUsing(fsWatchFile) :
	                    tscWatchDirectory === "RecursiveDirectoryUsingDynamicPriorityPolling" ?
	                        createWatchDirectoryUsing(dynamicPollingWatchFile || createDynamicPriorityPollingWatchFile({ getModifiedTime: getModifiedTime, setTimeout: setTimeout })) :
	                        watchDirectoryUsingFsWatch;
	                var watchDirectoryRecursively = createRecursiveDirectoryWatcher({
	                    filePathComparer: ts.getStringComparer(!useCaseSensitiveFileNames),
	                    directoryExists: directoryExists,
	                    getAccessibleSortedChildDirectories: function (path) { return getAccessibleFileSystemEntries(path).directories; },
	                    watchDirectory: watchDirectory,
	                    realpath: realpath
	                });
	                return function (directoryName, callback, recursive) {
	                    if (recursive) {
	                        return watchDirectoryRecursively(directoryName, callback);
	                    }
	                    watchDirectory(directoryName, callback);
	                };
	            }
	            function createNonPollingWatchFile() {
	                // One file can have multiple watchers
	                var fileWatcherCallbacks = ts.createMultiMap();
	                var dirWatchers = ts.createMap();
	                var toCanonicalName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	                return nonPollingWatchFile;
	                function nonPollingWatchFile(fileName, callback) {
	                    var filePath = toCanonicalName(fileName);
	                    fileWatcherCallbacks.add(filePath, callback);
	                    var dirPath = ts.getDirectoryPath(filePath) || ".";
	                    var watcher = dirWatchers.get(dirPath) || createDirectoryWatcher(ts.getDirectoryPath(fileName) || ".", dirPath);
	                    watcher.referenceCount++;
	                    return {
	                        close: function () {
	                            if (watcher.referenceCount === 1) {
	                                watcher.close();
	                                dirWatchers.delete(dirPath);
	                            }
	                            else {
	                                watcher.referenceCount--;
	                            }
	                            fileWatcherCallbacks.remove(filePath, callback);
	                        }
	                    };
	                }
	                function createDirectoryWatcher(dirName, dirPath) {
	                    var watcher = fsWatchDirectory(dirName, function (_eventName, relativeFileName) {
	                        // When files are deleted from disk, the triggered "rename" event would have a relativefileName of "undefined"
	                        var fileName = !ts.isString(relativeFileName)
	                            ? undefined
	                            : ts.getNormalizedAbsolutePath(relativeFileName, dirName);
	                        // Some applications save a working file via rename operations
	                        var callbacks = fileWatcherCallbacks.get(toCanonicalName(fileName));
	                        if (callbacks) {
	                            for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
	                                var fileCallback = callbacks_1[_i];
	                                fileCallback(fileName, FileWatcherEventKind.Changed);
	                            }
	                        }
	                    });
	                    watcher.referenceCount = 0;
	                    dirWatchers.set(dirPath, watcher);
	                    return watcher;
	                }
	            }
	            function fsWatchFile(fileName, callback, pollingInterval) {
	                _fs.watchFile(fileName, { persistent: true, interval: pollingInterval || 250 }, fileChanged);
	                var eventKind;
	                return {
	                    close: function () { return _fs.unwatchFile(fileName, fileChanged); }
	                };
	                function fileChanged(curr, prev) {
	                    // previous event kind check is to ensure we recongnize the file as previously also missing when it is restored or renamed twice (that is it disappears and reappears)
	                    // In such case, prevTime returned is same as prev time of event when file was deleted as per node documentation
	                    var isPreviouslyDeleted = +prev.mtime === 0 || eventKind === FileWatcherEventKind.Deleted;
	                    if (+curr.mtime === 0) {
	                        if (isPreviouslyDeleted) {
	                            // Already deleted file, no need to callback again
	                            return;
	                        }
	                        eventKind = FileWatcherEventKind.Deleted;
	                    }
	                    else if (isPreviouslyDeleted) {
	                        eventKind = FileWatcherEventKind.Created;
	                    }
	                    // If there is no change in modified time, ignore the event
	                    else if (+curr.mtime === +prev.mtime) {
	                        return;
	                    }
	                    else {
	                        // File changed
	                        eventKind = FileWatcherEventKind.Changed;
	                    }
	                    callback(fileName, eventKind);
	                }
	            }
	            function createFileWatcherCallback(callback) {
	                return function (_fileName, eventKind) { return callback(eventKind === FileWatcherEventKind.Changed ? "change" : "rename", ""); };
	            }
	            function createFsWatchCallbackForFileWatcherCallback(fileName, callback) {
	                return function (eventName) {
	                    if (eventName === "rename") {
	                        callback(fileName, fileExists(fileName) ? FileWatcherEventKind.Created : FileWatcherEventKind.Deleted);
	                    }
	                    else {
	                        // Change
	                        callback(fileName, FileWatcherEventKind.Changed);
	                    }
	                };
	            }
	            function createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback) {
	                return function (eventName, relativeFileName) {
	                    // In watchDirectory we only care about adding and removing files (when event name is
	                    // "rename"); changes made within files are handled by corresponding fileWatchers (when
	                    // event name is "change")
	                    if (eventName === "rename") {
	                        // When deleting a file, the passed baseFileName is null
	                        callback(!relativeFileName ? directoryName : ts.normalizePath(ts.combinePaths(directoryName, relativeFileName)));
	                    }
	                };
	            }
	            function fsWatch(fileOrDirectory, entryKind, callback, recursive, fallbackPollingWatchFile, pollingInterval) {
	                var options;
	                /** Watcher for the file system entry depending on whether it is missing or present */
	                var watcher = !fileSystemEntryExists(fileOrDirectory, entryKind) ?
	                    watchMissingFileSystemEntry() :
	                    watchPresentFileSystemEntry();
	                return {
	                    close: function () {
	                        // Close the watcher (either existing file system entry watcher or missing file system entry watcher)
	                        watcher.close();
	                        watcher = undefined;
	                    }
	                };
	                /**
	                 * Invoke the callback with rename and update the watcher if not closed
	                 * @param createWatcher
	                 */
	                function invokeCallbackAndUpdateWatcher(createWatcher) {
	                    // Call the callback for current directory
	                    callback("rename", "");
	                    // If watcher is not closed, update it
	                    if (watcher) {
	                        watcher.close();
	                        watcher = createWatcher();
	                    }
	                }
	                /**
	                 * Watch the file or directory that is currently present
	                 * and when the watched file or directory is deleted, switch to missing file system entry watcher
	                 */
	                function watchPresentFileSystemEntry() {
	                    // Node 4.0 `fs.watch` function supports the "recursive" option on both OSX and Windows
	                    // (ref: https://github.com/nodejs/node/pull/2649 and https://github.com/Microsoft/TypeScript/issues/4643)
	                    if (options === undefined) {
	                        if (isNode4OrLater && (process.platform === "win32" || process.platform === "darwin")) {
	                            options = { persistent: true, recursive: !!recursive };
	                        }
	                        else {
	                            options = { persistent: true };
	                        }
	                    }
	                    try {
	                        var presentWatcher = _fs.watch(fileOrDirectory, options, callback);
	                        // Watch the missing file or directory or error
	                        presentWatcher.on("error", function () { return invokeCallbackAndUpdateWatcher(watchMissingFileSystemEntry); });
	                        return presentWatcher;
	                    }
	                    catch (e) {
	                        // Catch the exception and use polling instead
	                        // Eg. on linux the number of watches are limited and one could easily exhaust watches and the exception ENOSPC is thrown when creating watcher at that point
	                        // so instead of throwing error, use fs.watchFile
	                        return watchPresentFileSystemEntryWithFsWatchFile();
	                    }
	                }
	                /**
	                 * Watch the file or directory using fs.watchFile since fs.watch threw exception
	                 * Eg. on linux the number of watches are limited and one could easily exhaust watches and the exception ENOSPC is thrown when creating watcher at that point
	                 */
	                function watchPresentFileSystemEntryWithFsWatchFile() {
	                    return fallbackPollingWatchFile(fileOrDirectory, createFileWatcherCallback(callback), pollingInterval);
	                }
	                /**
	                 * Watch the file or directory that is missing
	                 * and switch to existing file or directory when the missing filesystem entry is created
	                 */
	                function watchMissingFileSystemEntry() {
	                    return fallbackPollingWatchFile(fileOrDirectory, function (_fileName, eventKind) {
	                        if (eventKind === FileWatcherEventKind.Created && fileSystemEntryExists(fileOrDirectory, entryKind)) {
	                            // Call the callback for current file or directory
	                            // For now it could be callback for the inner directory creation,
	                            // but just return current directory, better than current no-op
	                            invokeCallbackAndUpdateWatcher(watchPresentFileSystemEntry);
	                        }
	                    }, pollingInterval);
	                }
	            }
	            function watchFileUsingFsWatch(fileName, callback, pollingInterval) {
	                return fsWatch(fileName, 0 /* File */, createFsWatchCallbackForFileWatcherCallback(fileName, callback), /*recursive*/ false, fsWatchFile, pollingInterval);
	            }
	            function createWatchFileUsingDynamicWatchFile(watchFile) {
	                return function (fileName, callback, pollingInterval) { return fsWatch(fileName, 0 /* File */, createFsWatchCallbackForFileWatcherCallback(fileName, callback), /*recursive*/ false, watchFile, pollingInterval); };
	            }
	            function fsWatchDirectory(directoryName, callback, recursive) {
	                return fsWatch(directoryName, 1 /* Directory */, callback, !!recursive, fsWatchFile);
	            }
	            function watchDirectoryUsingFsWatch(directoryName, callback, recursive) {
	                return fsWatchDirectory(directoryName, createFsWatchCallbackForDirectoryWatcherCallback(directoryName, callback), recursive);
	            }
	            function createWatchDirectoryUsing(fsWatchFile) {
	                return function (directoryName, callback) { return fsWatchFile(directoryName, function () { return callback(directoryName); }, PollingInterval.Medium); };
	            }
	            function readFile(fileName, _encoding) {
	                if (!fileExists(fileName)) {
	                    return undefined;
	                }
	                var buffer = _fs.readFileSync(fileName);
	                var len = buffer.length;
	                if (len >= 2 && buffer[0] === 0xFE && buffer[1] === 0xFF) {
	                    // Big endian UTF-16 byte order mark detected. Since big endian is not supported by node.js,
	                    // flip all byte pairs and treat as little endian.
	                    len &= ~1; // Round down to a multiple of 2
	                    for (var i = 0; i < len; i += 2) {
	                        var temp = buffer[i];
	                        buffer[i] = buffer[i + 1];
	                        buffer[i + 1] = temp;
	                    }
	                    return buffer.toString("utf16le", 2);
	                }
	                if (len >= 2 && buffer[0] === 0xFF && buffer[1] === 0xFE) {
	                    // Little endian UTF-16 byte order mark detected
	                    return buffer.toString("utf16le", 2);
	                }
	                if (len >= 3 && buffer[0] === 0xEF && buffer[1] === 0xBB && buffer[2] === 0xBF) {
	                    // UTF-8 byte order mark detected
	                    return buffer.toString("utf8", 3);
	                }
	                // Default is UTF-8 with no byte order mark
	                return buffer.toString("utf8");
	            }
	            function writeFile(fileName, data, writeByteOrderMark) {
	                // If a BOM is required, emit one
	                if (writeByteOrderMark) {
	                    data = byteOrderMarkIndicator + data;
	                }
	                var fd;
	                try {
	                    fd = _fs.openSync(fileName, "w");
	                    _fs.writeSync(fd, data, /*position*/ undefined, "utf8");
	                }
	                finally {
	                    if (fd !== undefined) {
	                        _fs.closeSync(fd);
	                    }
	                }
	            }
	            function getAccessibleFileSystemEntries(path) {
	                try {
	                    var entries = _fs.readdirSync(path || ".").sort();
	                    var files = [];
	                    var directories = [];
	                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                        var entry = entries_1[_i];
	                        // This is necessary because on some file system node fails to exclude
	                        // "." and "..". See https://github.com/nodejs/node/issues/4002
	                        if (entry === "." || entry === "..") {
	                            continue;
	                        }
	                        var name = ts.combinePaths(path, entry);
	                        var stat = void 0;
	                        try {
	                            stat = _fs.statSync(name);
	                        }
	                        catch (e) {
	                            continue;
	                        }
	                        if (stat.isFile()) {
	                            files.push(entry);
	                        }
	                        else if (stat.isDirectory()) {
	                            directories.push(entry);
	                        }
	                    }
	                    return { files: files, directories: directories };
	                }
	                catch (e) {
	                    return ts.emptyFileSystemEntries;
	                }
	            }
	            function readDirectory(path, extensions, excludes, includes, depth) {
	                return ts.matchFiles(path, extensions, excludes, includes, useCaseSensitiveFileNames, process.cwd(), depth, getAccessibleFileSystemEntries);
	            }
	            function fileSystemEntryExists(path, entryKind) {
	                try {
	                    var stat = _fs.statSync(path);
	                    switch (entryKind) {
	                        case 0 /* File */: return stat.isFile();
	                        case 1 /* Directory */: return stat.isDirectory();
	                    }
	                }
	                catch (e) {
	                    return false;
	                }
	            }
	            function fileExists(path) {
	                return fileSystemEntryExists(path, 0 /* File */);
	            }
	            function directoryExists(path) {
	                return fileSystemEntryExists(path, 1 /* Directory */);
	            }
	            function getDirectories(path) {
	                return ts.filter(_fs.readdirSync(path), function (dir) { return fileSystemEntryExists(ts.combinePaths(path, dir), 1 /* Directory */); });
	            }
	            function realpath(path) {
	                try {
	                    return _fs.realpathSync(path);
	                }
	                catch (_a) {
	                    return path;
	                }
	            }
	            function getModifiedTime(path) {
	                try {
	                    return _fs.statSync(path).mtime;
	                }
	                catch (e) {
	                    return undefined;
	                }
	            }
	            /**
	             * djb2 hashing algorithm
	             * http://www.cse.yorku.ca/~oz/hash.html
	             */
	            function generateDjb2Hash(data) {
	                var chars = data.split("").map(function (str) { return str.charCodeAt(0); });
	                return "" + chars.reduce(function (prev, curr) { return ((prev << 5) + prev) + curr; }, 5381);
	            }
	            function createMD5HashUsingNativeCrypto(data) {
	                var hash = _crypto.createHash("md5");
	                hash.update(data);
	                return hash.digest("hex");
	            }
	            function createSHA256Hash(data) {
	                var hash = _crypto.createHash("sha256");
	                hash.update(data);
	                return hash.digest("hex");
	            }
	        }
	        function getChakraSystem() {
	            var realpath = ChakraHost.realpath && (function (path) { return ChakraHost.realpath(path); });
	            return {
	                newLine: ChakraHost.newLine || "\r\n",
	                args: ChakraHost.args,
	                useCaseSensitiveFileNames: !!ChakraHost.useCaseSensitiveFileNames,
	                write: ChakraHost.echo,
	                readFile: function (path, _encoding) {
	                    // encoding is automatically handled by the implementation in ChakraHost
	                    return ChakraHost.readFile(path);
	                },
	                writeFile: function (path, data, writeByteOrderMark) {
	                    // If a BOM is required, emit one
	                    if (writeByteOrderMark) {
	                        data = byteOrderMarkIndicator + data;
	                    }
	                    ChakraHost.writeFile(path, data);
	                },
	                resolvePath: ChakraHost.resolvePath,
	                fileExists: ChakraHost.fileExists,
	                directoryExists: ChakraHost.directoryExists,
	                createDirectory: ChakraHost.createDirectory,
	                getExecutingFilePath: function () { return ChakraHost.executingFile; },
	                getCurrentDirectory: function () { return ChakraHost.currentDirectory; },
	                getDirectories: ChakraHost.getDirectories,
	                getEnvironmentVariable: ChakraHost.getEnvironmentVariable || (function () { return ""; }),
	                readDirectory: function (path, extensions, excludes, includes, _depth) {
	                    var pattern = ts.getFileMatcherPatterns(path, excludes, includes, !!ChakraHost.useCaseSensitiveFileNames, ChakraHost.currentDirectory);
	                    return ChakraHost.readDirectory(path, extensions, pattern.basePaths, pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern);
	                },
	                exit: ChakraHost.quit,
	                realpath: realpath
	            };
	        }
	        function recursiveCreateDirectory(directoryPath, sys) {
	            var basePath = ts.getDirectoryPath(directoryPath);
	            var shouldCreateParent = basePath !== "" && directoryPath !== basePath && !sys.directoryExists(basePath);
	            if (shouldCreateParent) {
	                recursiveCreateDirectory(basePath, sys);
	            }
	            if (shouldCreateParent || !sys.directoryExists(directoryPath)) {
	                sys.createDirectory(directoryPath);
	            }
	        }
	        var sys;
	        if (typeof ChakraHost !== "undefined") {
	            sys = getChakraSystem();
	        }
	        else if (typeof process !== "undefined" && process.nextTick && !process.browser && "function" !== "undefined") {
	            // process and process.nextTick checks if current environment is node-like
	            // process.browser check excludes webpack and browserify
	            sys = getNodeSystem();
	        }
	        if (sys) {
	            // patch writefile to create folder before writing the file
	            var originalWriteFile_1 = sys.writeFile;
	            sys.writeFile = function (path, data, writeBom) {
	                var directoryPath = ts.getDirectoryPath(ts.normalizeSlashes(path));
	                if (directoryPath && !sys.directoryExists(directoryPath)) {
	                    recursiveCreateDirectory(directoryPath, sys);
	                }
	                originalWriteFile_1.call(sys, path, data, writeBom);
	            };
	        }
	        return sys;
	    })();
	    if (ts.sys && ts.sys.getEnvironmentVariable) {
	        setCustomPollingValues(ts.sys);
	        ts.Debug.currentAssertionLevel = /^development$/i.test(ts.sys.getEnvironmentVariable("NODE_ENV"))
	            ? 1 /* Normal */
	            : 0 /* None */;
	    }
	    if (ts.sys && ts.sys.debugMode) {
	        ts.Debug.isDebugging = true;
	    }
	})(ts || (ts = {}));
	// <auto-generated />
	// generated from './diagnosticInformationMap.generated.ts' by '../../scripts/processDiagnosticMessages.js'
	/* @internal */
	var ts;
	(function (ts) {
	    function diag(code, category, key, message, reportsUnnecessary) {
	        return { code: code, category: category, key: key, message: message, reportsUnnecessary: reportsUnnecessary };
	    }
	    // tslint:disable-next-line variable-name
	    ts.Diagnostics = {
	        Unterminated_string_literal: diag(1002, ts.DiagnosticCategory.Error, "Unterminated_string_literal_1002", "Unterminated string literal."),
	        Identifier_expected: diag(1003, ts.DiagnosticCategory.Error, "Identifier_expected_1003", "Identifier expected."),
	        _0_expected: diag(1005, ts.DiagnosticCategory.Error, "_0_expected_1005", "'{0}' expected."),
	        A_file_cannot_have_a_reference_to_itself: diag(1006, ts.DiagnosticCategory.Error, "A_file_cannot_have_a_reference_to_itself_1006", "A file cannot have a reference to itself."),
	        Trailing_comma_not_allowed: diag(1009, ts.DiagnosticCategory.Error, "Trailing_comma_not_allowed_1009", "Trailing comma not allowed."),
	        Asterisk_Slash_expected: diag(1010, ts.DiagnosticCategory.Error, "Asterisk_Slash_expected_1010", "'*/' expected."),
	        An_element_access_expression_should_take_an_argument: diag(1011, ts.DiagnosticCategory.Error, "An_element_access_expression_should_take_an_argument_1011", "An element access expression should take an argument."),
	        Unexpected_token: diag(1012, ts.DiagnosticCategory.Error, "Unexpected_token_1012", "Unexpected token."),
	        A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma: diag(1013, ts.DiagnosticCategory.Error, "A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma_1013", "A rest parameter or binding pattern may not have a trailing comma."),
	        A_rest_parameter_must_be_last_in_a_parameter_list: diag(1014, ts.DiagnosticCategory.Error, "A_rest_parameter_must_be_last_in_a_parameter_list_1014", "A rest parameter must be last in a parameter list."),
	        Parameter_cannot_have_question_mark_and_initializer: diag(1015, ts.DiagnosticCategory.Error, "Parameter_cannot_have_question_mark_and_initializer_1015", "Parameter cannot have question mark and initializer."),
	        A_required_parameter_cannot_follow_an_optional_parameter: diag(1016, ts.DiagnosticCategory.Error, "A_required_parameter_cannot_follow_an_optional_parameter_1016", "A required parameter cannot follow an optional parameter."),
	        An_index_signature_cannot_have_a_rest_parameter: diag(1017, ts.DiagnosticCategory.Error, "An_index_signature_cannot_have_a_rest_parameter_1017", "An index signature cannot have a rest parameter."),
	        An_index_signature_parameter_cannot_have_an_accessibility_modifier: diag(1018, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_an_accessibility_modifier_1018", "An index signature parameter cannot have an accessibility modifier."),
	        An_index_signature_parameter_cannot_have_a_question_mark: diag(1019, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_a_question_mark_1019", "An index signature parameter cannot have a question mark."),
	        An_index_signature_parameter_cannot_have_an_initializer: diag(1020, ts.DiagnosticCategory.Error, "An_index_signature_parameter_cannot_have_an_initializer_1020", "An index signature parameter cannot have an initializer."),
	        An_index_signature_must_have_a_type_annotation: diag(1021, ts.DiagnosticCategory.Error, "An_index_signature_must_have_a_type_annotation_1021", "An index signature must have a type annotation."),
	        An_index_signature_parameter_must_have_a_type_annotation: diag(1022, ts.DiagnosticCategory.Error, "An_index_signature_parameter_must_have_a_type_annotation_1022", "An index signature parameter must have a type annotation."),
	        An_index_signature_parameter_type_must_be_string_or_number: diag(1023, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_must_be_string_or_number_1023", "An index signature parameter type must be 'string' or 'number'."),
	        readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature: diag(1024, ts.DiagnosticCategory.Error, "readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature_1024", "'readonly' modifier can only appear on a property declaration or index signature."),
	        Accessibility_modifier_already_seen: diag(1028, ts.DiagnosticCategory.Error, "Accessibility_modifier_already_seen_1028", "Accessibility modifier already seen."),
	        _0_modifier_must_precede_1_modifier: diag(1029, ts.DiagnosticCategory.Error, "_0_modifier_must_precede_1_modifier_1029", "'{0}' modifier must precede '{1}' modifier."),
	        _0_modifier_already_seen: diag(1030, ts.DiagnosticCategory.Error, "_0_modifier_already_seen_1030", "'{0}' modifier already seen."),
	        _0_modifier_cannot_appear_on_a_class_element: diag(1031, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_class_element_1031", "'{0}' modifier cannot appear on a class element."),
	        super_must_be_followed_by_an_argument_list_or_member_access: diag(1034, ts.DiagnosticCategory.Error, "super_must_be_followed_by_an_argument_list_or_member_access_1034", "'super' must be followed by an argument list or member access."),
	        Only_ambient_modules_can_use_quoted_names: diag(1035, ts.DiagnosticCategory.Error, "Only_ambient_modules_can_use_quoted_names_1035", "Only ambient modules can use quoted names."),
	        Statements_are_not_allowed_in_ambient_contexts: diag(1036, ts.DiagnosticCategory.Error, "Statements_are_not_allowed_in_ambient_contexts_1036", "Statements are not allowed in ambient contexts."),
	        A_declare_modifier_cannot_be_used_in_an_already_ambient_context: diag(1038, ts.DiagnosticCategory.Error, "A_declare_modifier_cannot_be_used_in_an_already_ambient_context_1038", "A 'declare' modifier cannot be used in an already ambient context."),
	        Initializers_are_not_allowed_in_ambient_contexts: diag(1039, ts.DiagnosticCategory.Error, "Initializers_are_not_allowed_in_ambient_contexts_1039", "Initializers are not allowed in ambient contexts."),
	        _0_modifier_cannot_be_used_in_an_ambient_context: diag(1040, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_in_an_ambient_context_1040", "'{0}' modifier cannot be used in an ambient context."),
	        _0_modifier_cannot_be_used_with_a_class_declaration: diag(1041, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_with_a_class_declaration_1041", "'{0}' modifier cannot be used with a class declaration."),
	        _0_modifier_cannot_be_used_here: diag(1042, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_here_1042", "'{0}' modifier cannot be used here."),
	        _0_modifier_cannot_appear_on_a_data_property: diag(1043, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_data_property_1043", "'{0}' modifier cannot appear on a data property."),
	        _0_modifier_cannot_appear_on_a_module_or_namespace_element: diag(1044, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_module_or_namespace_element_1044", "'{0}' modifier cannot appear on a module or namespace element."),
	        A_0_modifier_cannot_be_used_with_an_interface_declaration: diag(1045, ts.DiagnosticCategory.Error, "A_0_modifier_cannot_be_used_with_an_interface_declaration_1045", "A '{0}' modifier cannot be used with an interface declaration."),
	        A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file: diag(1046, ts.DiagnosticCategory.Error, "A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file_1046", "A 'declare' modifier is required for a top level declaration in a .d.ts file."),
	        A_rest_parameter_cannot_be_optional: diag(1047, ts.DiagnosticCategory.Error, "A_rest_parameter_cannot_be_optional_1047", "A rest parameter cannot be optional."),
	        A_rest_parameter_cannot_have_an_initializer: diag(1048, ts.DiagnosticCategory.Error, "A_rest_parameter_cannot_have_an_initializer_1048", "A rest parameter cannot have an initializer."),
	        A_set_accessor_must_have_exactly_one_parameter: diag(1049, ts.DiagnosticCategory.Error, "A_set_accessor_must_have_exactly_one_parameter_1049", "A 'set' accessor must have exactly one parameter."),
	        A_set_accessor_cannot_have_an_optional_parameter: diag(1051, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_an_optional_parameter_1051", "A 'set' accessor cannot have an optional parameter."),
	        A_set_accessor_parameter_cannot_have_an_initializer: diag(1052, ts.DiagnosticCategory.Error, "A_set_accessor_parameter_cannot_have_an_initializer_1052", "A 'set' accessor parameter cannot have an initializer."),
	        A_set_accessor_cannot_have_rest_parameter: diag(1053, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_rest_parameter_1053", "A 'set' accessor cannot have rest parameter."),
	        A_get_accessor_cannot_have_parameters: diag(1054, ts.DiagnosticCategory.Error, "A_get_accessor_cannot_have_parameters_1054", "A 'get' accessor cannot have parameters."),
	        Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value: diag(1055, ts.DiagnosticCategory.Error, "Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Prom_1055", "Type '{0}' is not a valid async function return type in ES5/ES3 because it does not refer to a Promise-compatible constructor value."),
	        Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher: diag(1056, ts.DiagnosticCategory.Error, "Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher_1056", "Accessors are only available when targeting ECMAScript 5 and higher."),
	        An_async_function_or_method_must_have_a_valid_awaitable_return_type: diag(1057, ts.DiagnosticCategory.Error, "An_async_function_or_method_must_have_a_valid_awaitable_return_type_1057", "An async function or method must have a valid awaitable return type."),
	        The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1058, ts.DiagnosticCategory.Error, "The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_t_1058", "The return type of an async function must either be a valid promise or must not contain a callable 'then' member."),
	        A_promise_must_have_a_then_method: diag(1059, ts.DiagnosticCategory.Error, "A_promise_must_have_a_then_method_1059", "A promise must have a 'then' method."),
	        The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback: diag(1060, ts.DiagnosticCategory.Error, "The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback_1060", "The first parameter of the 'then' method of a promise must be a callback."),
	        Enum_member_must_have_initializer: diag(1061, ts.DiagnosticCategory.Error, "Enum_member_must_have_initializer_1061", "Enum member must have initializer."),
	        Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method: diag(1062, ts.DiagnosticCategory.Error, "Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method_1062", "Type is referenced directly or indirectly in the fulfillment callback of its own 'then' method."),
	        An_export_assignment_cannot_be_used_in_a_namespace: diag(1063, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_be_used_in_a_namespace_1063", "An export assignment cannot be used in a namespace."),
	        The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type: diag(1064, ts.DiagnosticCategory.Error, "The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type_1064", "The return type of an async function or method must be the global Promise<T> type."),
	        In_ambient_enum_declarations_member_initializer_must_be_constant_expression: diag(1066, ts.DiagnosticCategory.Error, "In_ambient_enum_declarations_member_initializer_must_be_constant_expression_1066", "In ambient enum declarations member initializer must be constant expression."),
	        Unexpected_token_A_constructor_method_accessor_or_property_was_expected: diag(1068, ts.DiagnosticCategory.Error, "Unexpected_token_A_constructor_method_accessor_or_property_was_expected_1068", "Unexpected token. A constructor, method, accessor, or property was expected."),
	        _0_modifier_cannot_appear_on_a_type_member: diag(1070, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_type_member_1070", "'{0}' modifier cannot appear on a type member."),
	        _0_modifier_cannot_appear_on_an_index_signature: diag(1071, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_an_index_signature_1071", "'{0}' modifier cannot appear on an index signature."),
	        A_0_modifier_cannot_be_used_with_an_import_declaration: diag(1079, ts.DiagnosticCategory.Error, "A_0_modifier_cannot_be_used_with_an_import_declaration_1079", "A '{0}' modifier cannot be used with an import declaration."),
	        Invalid_reference_directive_syntax: diag(1084, ts.DiagnosticCategory.Error, "Invalid_reference_directive_syntax_1084", "Invalid 'reference' directive syntax."),
	        Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0: diag(1085, ts.DiagnosticCategory.Error, "Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0_1085", "Octal literals are not available when targeting ECMAScript 5 and higher. Use the syntax '{0}'."),
	        An_accessor_cannot_be_declared_in_an_ambient_context: diag(1086, ts.DiagnosticCategory.Error, "An_accessor_cannot_be_declared_in_an_ambient_context_1086", "An accessor cannot be declared in an ambient context."),
	        _0_modifier_cannot_appear_on_a_constructor_declaration: diag(1089, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_constructor_declaration_1089", "'{0}' modifier cannot appear on a constructor declaration."),
	        _0_modifier_cannot_appear_on_a_parameter: diag(1090, ts.DiagnosticCategory.Error, "_0_modifier_cannot_appear_on_a_parameter_1090", "'{0}' modifier cannot appear on a parameter."),
	        Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement: diag(1091, ts.DiagnosticCategory.Error, "Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement_1091", "Only a single variable declaration is allowed in a 'for...in' statement."),
	        Type_parameters_cannot_appear_on_a_constructor_declaration: diag(1092, ts.DiagnosticCategory.Error, "Type_parameters_cannot_appear_on_a_constructor_declaration_1092", "Type parameters cannot appear on a constructor declaration."),
	        Type_annotation_cannot_appear_on_a_constructor_declaration: diag(1093, ts.DiagnosticCategory.Error, "Type_annotation_cannot_appear_on_a_constructor_declaration_1093", "Type annotation cannot appear on a constructor declaration."),
	        An_accessor_cannot_have_type_parameters: diag(1094, ts.DiagnosticCategory.Error, "An_accessor_cannot_have_type_parameters_1094", "An accessor cannot have type parameters."),
	        A_set_accessor_cannot_have_a_return_type_annotation: diag(1095, ts.DiagnosticCategory.Error, "A_set_accessor_cannot_have_a_return_type_annotation_1095", "A 'set' accessor cannot have a return type annotation."),
	        An_index_signature_must_have_exactly_one_parameter: diag(1096, ts.DiagnosticCategory.Error, "An_index_signature_must_have_exactly_one_parameter_1096", "An index signature must have exactly one parameter."),
	        _0_list_cannot_be_empty: diag(1097, ts.DiagnosticCategory.Error, "_0_list_cannot_be_empty_1097", "'{0}' list cannot be empty."),
	        Type_parameter_list_cannot_be_empty: diag(1098, ts.DiagnosticCategory.Error, "Type_parameter_list_cannot_be_empty_1098", "Type parameter list cannot be empty."),
	        Type_argument_list_cannot_be_empty: diag(1099, ts.DiagnosticCategory.Error, "Type_argument_list_cannot_be_empty_1099", "Type argument list cannot be empty."),
	        Invalid_use_of_0_in_strict_mode: diag(1100, ts.DiagnosticCategory.Error, "Invalid_use_of_0_in_strict_mode_1100", "Invalid use of '{0}' in strict mode."),
	        with_statements_are_not_allowed_in_strict_mode: diag(1101, ts.DiagnosticCategory.Error, "with_statements_are_not_allowed_in_strict_mode_1101", "'with' statements are not allowed in strict mode."),
	        delete_cannot_be_called_on_an_identifier_in_strict_mode: diag(1102, ts.DiagnosticCategory.Error, "delete_cannot_be_called_on_an_identifier_in_strict_mode_1102", "'delete' cannot be called on an identifier in strict mode."),
	        A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator: diag(1103, ts.DiagnosticCategory.Error, "A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator_1103", "A 'for-await-of' statement is only allowed within an async function or async generator."),
	        A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement: diag(1104, ts.DiagnosticCategory.Error, "A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement_1104", "A 'continue' statement can only be used within an enclosing iteration statement."),
	        A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement: diag(1105, ts.DiagnosticCategory.Error, "A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement_1105", "A 'break' statement can only be used within an enclosing iteration or switch statement."),
	        Jump_target_cannot_cross_function_boundary: diag(1107, ts.DiagnosticCategory.Error, "Jump_target_cannot_cross_function_boundary_1107", "Jump target cannot cross function boundary."),
	        A_return_statement_can_only_be_used_within_a_function_body: diag(1108, ts.DiagnosticCategory.Error, "A_return_statement_can_only_be_used_within_a_function_body_1108", "A 'return' statement can only be used within a function body."),
	        Expression_expected: diag(1109, ts.DiagnosticCategory.Error, "Expression_expected_1109", "Expression expected."),
	        Type_expected: diag(1110, ts.DiagnosticCategory.Error, "Type_expected_1110", "Type expected."),
	        A_default_clause_cannot_appear_more_than_once_in_a_switch_statement: diag(1113, ts.DiagnosticCategory.Error, "A_default_clause_cannot_appear_more_than_once_in_a_switch_statement_1113", "A 'default' clause cannot appear more than once in a 'switch' statement."),
	        Duplicate_label_0: diag(1114, ts.DiagnosticCategory.Error, "Duplicate_label_0_1114", "Duplicate label '{0}'."),
	        A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement: diag(1115, ts.DiagnosticCategory.Error, "A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement_1115", "A 'continue' statement can only jump to a label of an enclosing iteration statement."),
	        A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement: diag(1116, ts.DiagnosticCategory.Error, "A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement_1116", "A 'break' statement can only jump to a label of an enclosing statement."),
	        An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode: diag(1117, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode_1117", "An object literal cannot have multiple properties with the same name in strict mode."),
	        An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name: diag(1118, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name_1118", "An object literal cannot have multiple get/set accessors with the same name."),
	        An_object_literal_cannot_have_property_and_accessor_with_the_same_name: diag(1119, ts.DiagnosticCategory.Error, "An_object_literal_cannot_have_property_and_accessor_with_the_same_name_1119", "An object literal cannot have property and accessor with the same name."),
	        An_export_assignment_cannot_have_modifiers: diag(1120, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_have_modifiers_1120", "An export assignment cannot have modifiers."),
	        Octal_literals_are_not_allowed_in_strict_mode: diag(1121, ts.DiagnosticCategory.Error, "Octal_literals_are_not_allowed_in_strict_mode_1121", "Octal literals are not allowed in strict mode."),
	        A_tuple_type_element_list_cannot_be_empty: diag(1122, ts.DiagnosticCategory.Error, "A_tuple_type_element_list_cannot_be_empty_1122", "A tuple type element list cannot be empty."),
	        Variable_declaration_list_cannot_be_empty: diag(1123, ts.DiagnosticCategory.Error, "Variable_declaration_list_cannot_be_empty_1123", "Variable declaration list cannot be empty."),
	        Digit_expected: diag(1124, ts.DiagnosticCategory.Error, "Digit_expected_1124", "Digit expected."),
	        Hexadecimal_digit_expected: diag(1125, ts.DiagnosticCategory.Error, "Hexadecimal_digit_expected_1125", "Hexadecimal digit expected."),
	        Unexpected_end_of_text: diag(1126, ts.DiagnosticCategory.Error, "Unexpected_end_of_text_1126", "Unexpected end of text."),
	        Invalid_character: diag(1127, ts.DiagnosticCategory.Error, "Invalid_character_1127", "Invalid character."),
	        Declaration_or_statement_expected: diag(1128, ts.DiagnosticCategory.Error, "Declaration_or_statement_expected_1128", "Declaration or statement expected."),
	        Statement_expected: diag(1129, ts.DiagnosticCategory.Error, "Statement_expected_1129", "Statement expected."),
	        case_or_default_expected: diag(1130, ts.DiagnosticCategory.Error, "case_or_default_expected_1130", "'case' or 'default' expected."),
	        Property_or_signature_expected: diag(1131, ts.DiagnosticCategory.Error, "Property_or_signature_expected_1131", "Property or signature expected."),
	        Enum_member_expected: diag(1132, ts.DiagnosticCategory.Error, "Enum_member_expected_1132", "Enum member expected."),
	        Variable_declaration_expected: diag(1134, ts.DiagnosticCategory.Error, "Variable_declaration_expected_1134", "Variable declaration expected."),
	        Argument_expression_expected: diag(1135, ts.DiagnosticCategory.Error, "Argument_expression_expected_1135", "Argument expression expected."),
	        Property_assignment_expected: diag(1136, ts.DiagnosticCategory.Error, "Property_assignment_expected_1136", "Property assignment expected."),
	        Expression_or_comma_expected: diag(1137, ts.DiagnosticCategory.Error, "Expression_or_comma_expected_1137", "Expression or comma expected."),
	        Parameter_declaration_expected: diag(1138, ts.DiagnosticCategory.Error, "Parameter_declaration_expected_1138", "Parameter declaration expected."),
	        Type_parameter_declaration_expected: diag(1139, ts.DiagnosticCategory.Error, "Type_parameter_declaration_expected_1139", "Type parameter declaration expected."),
	        Type_argument_expected: diag(1140, ts.DiagnosticCategory.Error, "Type_argument_expected_1140", "Type argument expected."),
	        String_literal_expected: diag(1141, ts.DiagnosticCategory.Error, "String_literal_expected_1141", "String literal expected."),
	        Line_break_not_permitted_here: diag(1142, ts.DiagnosticCategory.Error, "Line_break_not_permitted_here_1142", "Line break not permitted here."),
	        or_expected: diag(1144, ts.DiagnosticCategory.Error, "or_expected_1144", "'{' or ';' expected."),
	        Declaration_expected: diag(1146, ts.DiagnosticCategory.Error, "Declaration_expected_1146", "Declaration expected."),
	        Import_declarations_in_a_namespace_cannot_reference_a_module: diag(1147, ts.DiagnosticCategory.Error, "Import_declarations_in_a_namespace_cannot_reference_a_module_1147", "Import declarations in a namespace cannot reference a module."),
	        Cannot_use_imports_exports_or_module_augmentations_when_module_is_none: diag(1148, ts.DiagnosticCategory.Error, "Cannot_use_imports_exports_or_module_augmentations_when_module_is_none_1148", "Cannot use imports, exports, or module augmentations when '--module' is 'none'."),
	        File_name_0_differs_from_already_included_file_name_1_only_in_casing: diag(1149, ts.DiagnosticCategory.Error, "File_name_0_differs_from_already_included_file_name_1_only_in_casing_1149", "File name '{0}' differs from already included file name '{1}' only in casing."),
	        new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead: diag(1150, ts.DiagnosticCategory.Error, "new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead_1150", "'new T[]' cannot be used to create an array. Use 'new Array<T>()' instead."),
	        const_declarations_must_be_initialized: diag(1155, ts.DiagnosticCategory.Error, "const_declarations_must_be_initialized_1155", "'const' declarations must be initialized."),
	        const_declarations_can_only_be_declared_inside_a_block: diag(1156, ts.DiagnosticCategory.Error, "const_declarations_can_only_be_declared_inside_a_block_1156", "'const' declarations can only be declared inside a block."),
	        let_declarations_can_only_be_declared_inside_a_block: diag(1157, ts.DiagnosticCategory.Error, "let_declarations_can_only_be_declared_inside_a_block_1157", "'let' declarations can only be declared inside a block."),
	        Unterminated_template_literal: diag(1160, ts.DiagnosticCategory.Error, "Unterminated_template_literal_1160", "Unterminated template literal."),
	        Unterminated_regular_expression_literal: diag(1161, ts.DiagnosticCategory.Error, "Unterminated_regular_expression_literal_1161", "Unterminated regular expression literal."),
	        An_object_member_cannot_be_declared_optional: diag(1162, ts.DiagnosticCategory.Error, "An_object_member_cannot_be_declared_optional_1162", "An object member cannot be declared optional."),
	        A_yield_expression_is_only_allowed_in_a_generator_body: diag(1163, ts.DiagnosticCategory.Error, "A_yield_expression_is_only_allowed_in_a_generator_body_1163", "A 'yield' expression is only allowed in a generator body."),
	        Computed_property_names_are_not_allowed_in_enums: diag(1164, ts.DiagnosticCategory.Error, "Computed_property_names_are_not_allowed_in_enums_1164", "Computed property names are not allowed in enums."),
	        A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1165, ts.DiagnosticCategory.Error, "A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_t_1165", "A computed property name in an ambient context must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1166, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_1166", "A computed property name in a class property declaration must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1168, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_ty_1168", "A computed property name in a method overload must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1169, ts.DiagnosticCategory.Error, "A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_1169", "A computed property name in an interface must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type: diag(1170, ts.DiagnosticCategory.Error, "A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type__1170", "A computed property name in a type literal must refer to an expression whose type is a literal type or a 'unique symbol' type."),
	        A_comma_expression_is_not_allowed_in_a_computed_property_name: diag(1171, ts.DiagnosticCategory.Error, "A_comma_expression_is_not_allowed_in_a_computed_property_name_1171", "A comma expression is not allowed in a computed property name."),
	        extends_clause_already_seen: diag(1172, ts.DiagnosticCategory.Error, "extends_clause_already_seen_1172", "'extends' clause already seen."),
	        extends_clause_must_precede_implements_clause: diag(1173, ts.DiagnosticCategory.Error, "extends_clause_must_precede_implements_clause_1173", "'extends' clause must precede 'implements' clause."),
	        Classes_can_only_extend_a_single_class: diag(1174, ts.DiagnosticCategory.Error, "Classes_can_only_extend_a_single_class_1174", "Classes can only extend a single class."),
	        implements_clause_already_seen: diag(1175, ts.DiagnosticCategory.Error, "implements_clause_already_seen_1175", "'implements' clause already seen."),
	        Interface_declaration_cannot_have_implements_clause: diag(1176, ts.DiagnosticCategory.Error, "Interface_declaration_cannot_have_implements_clause_1176", "Interface declaration cannot have 'implements' clause."),
	        Binary_digit_expected: diag(1177, ts.DiagnosticCategory.Error, "Binary_digit_expected_1177", "Binary digit expected."),
	        Octal_digit_expected: diag(1178, ts.DiagnosticCategory.Error, "Octal_digit_expected_1178", "Octal digit expected."),
	        Unexpected_token_expected: diag(1179, ts.DiagnosticCategory.Error, "Unexpected_token_expected_1179", "Unexpected token. '{' expected."),
	        Property_destructuring_pattern_expected: diag(1180, ts.DiagnosticCategory.Error, "Property_destructuring_pattern_expected_1180", "Property destructuring pattern expected."),
	        Array_element_destructuring_pattern_expected: diag(1181, ts.DiagnosticCategory.Error, "Array_element_destructuring_pattern_expected_1181", "Array element destructuring pattern expected."),
	        A_destructuring_declaration_must_have_an_initializer: diag(1182, ts.DiagnosticCategory.Error, "A_destructuring_declaration_must_have_an_initializer_1182", "A destructuring declaration must have an initializer."),
	        An_implementation_cannot_be_declared_in_ambient_contexts: diag(1183, ts.DiagnosticCategory.Error, "An_implementation_cannot_be_declared_in_ambient_contexts_1183", "An implementation cannot be declared in ambient contexts."),
	        Modifiers_cannot_appear_here: diag(1184, ts.DiagnosticCategory.Error, "Modifiers_cannot_appear_here_1184", "Modifiers cannot appear here."),
	        Merge_conflict_marker_encountered: diag(1185, ts.DiagnosticCategory.Error, "Merge_conflict_marker_encountered_1185", "Merge conflict marker encountered."),
	        A_rest_element_cannot_have_an_initializer: diag(1186, ts.DiagnosticCategory.Error, "A_rest_element_cannot_have_an_initializer_1186", "A rest element cannot have an initializer."),
	        A_parameter_property_may_not_be_declared_using_a_binding_pattern: diag(1187, ts.DiagnosticCategory.Error, "A_parameter_property_may_not_be_declared_using_a_binding_pattern_1187", "A parameter property may not be declared using a binding pattern."),
	        Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement: diag(1188, ts.DiagnosticCategory.Error, "Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement_1188", "Only a single variable declaration is allowed in a 'for...of' statement."),
	        The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer: diag(1189, ts.DiagnosticCategory.Error, "The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer_1189", "The variable declaration of a 'for...in' statement cannot have an initializer."),
	        The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer: diag(1190, ts.DiagnosticCategory.Error, "The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer_1190", "The variable declaration of a 'for...of' statement cannot have an initializer."),
	        An_import_declaration_cannot_have_modifiers: diag(1191, ts.DiagnosticCategory.Error, "An_import_declaration_cannot_have_modifiers_1191", "An import declaration cannot have modifiers."),
	        Module_0_has_no_default_export: diag(1192, ts.DiagnosticCategory.Error, "Module_0_has_no_default_export_1192", "Module '{0}' has no default export."),
	        An_export_declaration_cannot_have_modifiers: diag(1193, ts.DiagnosticCategory.Error, "An_export_declaration_cannot_have_modifiers_1193", "An export declaration cannot have modifiers."),
	        Export_declarations_are_not_permitted_in_a_namespace: diag(1194, ts.DiagnosticCategory.Error, "Export_declarations_are_not_permitted_in_a_namespace_1194", "Export declarations are not permitted in a namespace."),
	        Catch_clause_variable_cannot_have_a_type_annotation: diag(1196, ts.DiagnosticCategory.Error, "Catch_clause_variable_cannot_have_a_type_annotation_1196", "Catch clause variable cannot have a type annotation."),
	        Catch_clause_variable_cannot_have_an_initializer: diag(1197, ts.DiagnosticCategory.Error, "Catch_clause_variable_cannot_have_an_initializer_1197", "Catch clause variable cannot have an initializer."),
	        An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive: diag(1198, ts.DiagnosticCategory.Error, "An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive_1198", "An extended Unicode escape value must be between 0x0 and 0x10FFFF inclusive."),
	        Unterminated_Unicode_escape_sequence: diag(1199, ts.DiagnosticCategory.Error, "Unterminated_Unicode_escape_sequence_1199", "Unterminated Unicode escape sequence."),
	        Line_terminator_not_permitted_before_arrow: diag(1200, ts.DiagnosticCategory.Error, "Line_terminator_not_permitted_before_arrow_1200", "Line terminator not permitted before arrow."),
	        Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead: diag(1202, ts.DiagnosticCategory.Error, "Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_1202", "Import assignment cannot be used when targeting ECMAScript modules. Consider using 'import * as ns from \"mod\"', 'import {a} from \"mod\"', 'import d from \"mod\"', or another module format instead."),
	        Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead: diag(1203, ts.DiagnosticCategory.Error, "Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or__1203", "Export assignment cannot be used when targeting ECMAScript modules. Consider using 'export default' or another module format instead."),
	        Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided: diag(1205, ts.DiagnosticCategory.Error, "Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided_1205", "Cannot re-export a type when the '--isolatedModules' flag is provided."),
	        Decorators_are_not_valid_here: diag(1206, ts.DiagnosticCategory.Error, "Decorators_are_not_valid_here_1206", "Decorators are not valid here."),
	        Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name: diag(1207, ts.DiagnosticCategory.Error, "Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name_1207", "Decorators cannot be applied to multiple get/set accessors of the same name."),
	        Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided: diag(1208, ts.DiagnosticCategory.Error, "Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided_1208", "Cannot compile namespaces when the '--isolatedModules' flag is provided."),
	        Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided: diag(1209, ts.DiagnosticCategory.Error, "Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided_1209", "Ambient const enums are not allowed when the '--isolatedModules' flag is provided."),
	        Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode: diag(1210, ts.DiagnosticCategory.Error, "Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode_1210", "Invalid use of '{0}'. Class definitions are automatically in strict mode."),
	        A_class_declaration_without_the_default_modifier_must_have_a_name: diag(1211, ts.DiagnosticCategory.Error, "A_class_declaration_without_the_default_modifier_must_have_a_name_1211", "A class declaration without the 'default' modifier must have a name."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode: diag(1212, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_1212", "Identifier expected. '{0}' is a reserved word in strict mode."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode: diag(1213, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_stric_1213", "Identifier expected. '{0}' is a reserved word in strict mode. Class definitions are automatically in strict mode."),
	        Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode: diag(1214, ts.DiagnosticCategory.Error, "Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode_1214", "Identifier expected. '{0}' is a reserved word in strict mode. Modules are automatically in strict mode."),
	        Invalid_use_of_0_Modules_are_automatically_in_strict_mode: diag(1215, ts.DiagnosticCategory.Error, "Invalid_use_of_0_Modules_are_automatically_in_strict_mode_1215", "Invalid use of '{0}'. Modules are automatically in strict mode."),
	        Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules: diag(1216, ts.DiagnosticCategory.Error, "Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules_1216", "Identifier expected. '__esModule' is reserved as an exported marker when transforming ECMAScript modules."),
	        Export_assignment_is_not_supported_when_module_flag_is_system: diag(1218, ts.DiagnosticCategory.Error, "Export_assignment_is_not_supported_when_module_flag_is_system_1218", "Export assignment is not supported when '--module' flag is 'system'."),
	        Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning: diag(1219, ts.DiagnosticCategory.Error, "Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_t_1219", "Experimental support for decorators is a feature that is subject to change in a future release. Set the 'experimentalDecorators' option to remove this warning."),
	        Generators_are_only_available_when_targeting_ECMAScript_2015_or_higher: diag(1220, ts.DiagnosticCategory.Error, "Generators_are_only_available_when_targeting_ECMAScript_2015_or_higher_1220", "Generators are only available when targeting ECMAScript 2015 or higher."),
	        Generators_are_not_allowed_in_an_ambient_context: diag(1221, ts.DiagnosticCategory.Error, "Generators_are_not_allowed_in_an_ambient_context_1221", "Generators are not allowed in an ambient context."),
	        An_overload_signature_cannot_be_declared_as_a_generator: diag(1222, ts.DiagnosticCategory.Error, "An_overload_signature_cannot_be_declared_as_a_generator_1222", "An overload signature cannot be declared as a generator."),
	        _0_tag_already_specified: diag(1223, ts.DiagnosticCategory.Error, "_0_tag_already_specified_1223", "'{0}' tag already specified."),
	        Signature_0_must_be_a_type_predicate: diag(1224, ts.DiagnosticCategory.Error, "Signature_0_must_be_a_type_predicate_1224", "Signature '{0}' must be a type predicate."),
	        Cannot_find_parameter_0: diag(1225, ts.DiagnosticCategory.Error, "Cannot_find_parameter_0_1225", "Cannot find parameter '{0}'."),
	        Type_predicate_0_is_not_assignable_to_1: diag(1226, ts.DiagnosticCategory.Error, "Type_predicate_0_is_not_assignable_to_1_1226", "Type predicate '{0}' is not assignable to '{1}'."),
	        Parameter_0_is_not_in_the_same_position_as_parameter_1: diag(1227, ts.DiagnosticCategory.Error, "Parameter_0_is_not_in_the_same_position_as_parameter_1_1227", "Parameter '{0}' is not in the same position as parameter '{1}'."),
	        A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods: diag(1228, ts.DiagnosticCategory.Error, "A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods_1228", "A type predicate is only allowed in return type position for functions and methods."),
	        A_type_predicate_cannot_reference_a_rest_parameter: diag(1229, ts.DiagnosticCategory.Error, "A_type_predicate_cannot_reference_a_rest_parameter_1229", "A type predicate cannot reference a rest parameter."),
	        A_type_predicate_cannot_reference_element_0_in_a_binding_pattern: diag(1230, ts.DiagnosticCategory.Error, "A_type_predicate_cannot_reference_element_0_in_a_binding_pattern_1230", "A type predicate cannot reference element '{0}' in a binding pattern."),
	        An_export_assignment_can_only_be_used_in_a_module: diag(1231, ts.DiagnosticCategory.Error, "An_export_assignment_can_only_be_used_in_a_module_1231", "An export assignment can only be used in a module."),
	        An_import_declaration_can_only_be_used_in_a_namespace_or_module: diag(1232, ts.DiagnosticCategory.Error, "An_import_declaration_can_only_be_used_in_a_namespace_or_module_1232", "An import declaration can only be used in a namespace or module."),
	        An_export_declaration_can_only_be_used_in_a_module: diag(1233, ts.DiagnosticCategory.Error, "An_export_declaration_can_only_be_used_in_a_module_1233", "An export declaration can only be used in a module."),
	        An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file: diag(1234, ts.DiagnosticCategory.Error, "An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file_1234", "An ambient module declaration is only allowed at the top level in a file."),
	        A_namespace_declaration_is_only_allowed_in_a_namespace_or_module: diag(1235, ts.DiagnosticCategory.Error, "A_namespace_declaration_is_only_allowed_in_a_namespace_or_module_1235", "A namespace declaration is only allowed in a namespace or module."),
	        The_return_type_of_a_property_decorator_function_must_be_either_void_or_any: diag(1236, ts.DiagnosticCategory.Error, "The_return_type_of_a_property_decorator_function_must_be_either_void_or_any_1236", "The return type of a property decorator function must be either 'void' or 'any'."),
	        The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any: diag(1237, ts.DiagnosticCategory.Error, "The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any_1237", "The return type of a parameter decorator function must be either 'void' or 'any'."),
	        Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression: diag(1238, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression_1238", "Unable to resolve signature of class decorator when called as an expression."),
	        Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression: diag(1239, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression_1239", "Unable to resolve signature of parameter decorator when called as an expression."),
	        Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression: diag(1240, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression_1240", "Unable to resolve signature of property decorator when called as an expression."),
	        Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression: diag(1241, ts.DiagnosticCategory.Error, "Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression_1241", "Unable to resolve signature of method decorator when called as an expression."),
	        abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration: diag(1242, ts.DiagnosticCategory.Error, "abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration_1242", "'abstract' modifier can only appear on a class, method, or property declaration."),
	        _0_modifier_cannot_be_used_with_1_modifier: diag(1243, ts.DiagnosticCategory.Error, "_0_modifier_cannot_be_used_with_1_modifier_1243", "'{0}' modifier cannot be used with '{1}' modifier."),
	        Abstract_methods_can_only_appear_within_an_abstract_class: diag(1244, ts.DiagnosticCategory.Error, "Abstract_methods_can_only_appear_within_an_abstract_class_1244", "Abstract methods can only appear within an abstract class."),
	        Method_0_cannot_have_an_implementation_because_it_is_marked_abstract: diag(1245, ts.DiagnosticCategory.Error, "Method_0_cannot_have_an_implementation_because_it_is_marked_abstract_1245", "Method '{0}' cannot have an implementation because it is marked abstract."),
	        An_interface_property_cannot_have_an_initializer: diag(1246, ts.DiagnosticCategory.Error, "An_interface_property_cannot_have_an_initializer_1246", "An interface property cannot have an initializer."),
	        A_type_literal_property_cannot_have_an_initializer: diag(1247, ts.DiagnosticCategory.Error, "A_type_literal_property_cannot_have_an_initializer_1247", "A type literal property cannot have an initializer."),
	        A_class_member_cannot_have_the_0_keyword: diag(1248, ts.DiagnosticCategory.Error, "A_class_member_cannot_have_the_0_keyword_1248", "A class member cannot have the '{0}' keyword."),
	        A_decorator_can_only_decorate_a_method_implementation_not_an_overload: diag(1249, ts.DiagnosticCategory.Error, "A_decorator_can_only_decorate_a_method_implementation_not_an_overload_1249", "A decorator can only decorate a method implementation, not an overload."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5: diag(1250, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_1250", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode: diag(1251, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_d_1251", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Class definitions are automatically in strict mode."),
	        Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode: diag(1252, ts.DiagnosticCategory.Error, "Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_1252", "Function declarations are not allowed inside blocks in strict mode when targeting 'ES3' or 'ES5'. Modules are automatically in strict mode."),
	        _0_tag_cannot_be_used_independently_as_a_top_level_JSDoc_tag: diag(1253, ts.DiagnosticCategory.Error, "_0_tag_cannot_be_used_independently_as_a_top_level_JSDoc_tag_1253", "'{0}' tag cannot be used independently as a top level JSDoc tag."),
	        A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal: diag(1254, ts.DiagnosticCategory.Error, "A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal_1254", "A 'const' initializer in an ambient context must be a string or numeric literal."),
	        A_definite_assignment_assertion_is_not_permitted_in_this_context: diag(1255, ts.DiagnosticCategory.Error, "A_definite_assignment_assertion_is_not_permitted_in_this_context_1255", "A definite assignment assertion '!' is not permitted in this context."),
	        with_statements_are_not_allowed_in_an_async_function_block: diag(1300, ts.DiagnosticCategory.Error, "with_statements_are_not_allowed_in_an_async_function_block_1300", "'with' statements are not allowed in an async function block."),
	        await_expression_is_only_allowed_within_an_async_function: diag(1308, ts.DiagnosticCategory.Error, "await_expression_is_only_allowed_within_an_async_function_1308", "'await' expression is only allowed within an async function."),
	        can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment: diag(1312, ts.DiagnosticCategory.Error, "can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment_1312", "'=' can only be used in an object literal property inside a destructuring assignment."),
	        The_body_of_an_if_statement_cannot_be_the_empty_statement: diag(1313, ts.DiagnosticCategory.Error, "The_body_of_an_if_statement_cannot_be_the_empty_statement_1313", "The body of an 'if' statement cannot be the empty statement."),
	        Global_module_exports_may_only_appear_in_module_files: diag(1314, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_in_module_files_1314", "Global module exports may only appear in module files."),
	        Global_module_exports_may_only_appear_in_declaration_files: diag(1315, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_in_declaration_files_1315", "Global module exports may only appear in declaration files."),
	        Global_module_exports_may_only_appear_at_top_level: diag(1316, ts.DiagnosticCategory.Error, "Global_module_exports_may_only_appear_at_top_level_1316", "Global module exports may only appear at top level."),
	        A_parameter_property_cannot_be_declared_using_a_rest_parameter: diag(1317, ts.DiagnosticCategory.Error, "A_parameter_property_cannot_be_declared_using_a_rest_parameter_1317", "A parameter property cannot be declared using a rest parameter."),
	        An_abstract_accessor_cannot_have_an_implementation: diag(1318, ts.DiagnosticCategory.Error, "An_abstract_accessor_cannot_have_an_implementation_1318", "An abstract accessor cannot have an implementation."),
	        A_default_export_can_only_be_used_in_an_ECMAScript_style_module: diag(1319, ts.DiagnosticCategory.Error, "A_default_export_can_only_be_used_in_an_ECMAScript_style_module_1319", "A default export can only be used in an ECMAScript-style module."),
	        Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1320, ts.DiagnosticCategory.Error, "Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member_1320", "Type of 'await' operand must either be a valid promise or must not contain a callable 'then' member."),
	        Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1321, ts.DiagnosticCategory.Error, "Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_cal_1321", "Type of 'yield' operand in an async generator must either be a valid promise or must not contain a callable 'then' member."),
	        Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member: diag(1322, ts.DiagnosticCategory.Error, "Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_con_1322", "Type of iterated elements of a 'yield*' operand must either be a valid promise or must not contain a callable 'then' member."),
	        Dynamic_import_is_only_supported_when_module_flag_is_commonjs_or_esNext: diag(1323, ts.DiagnosticCategory.Error, "Dynamic_import_is_only_supported_when_module_flag_is_commonjs_or_esNext_1323", "Dynamic import is only supported when '--module' flag is 'commonjs' or 'esNext'."),
	        Dynamic_import_must_have_one_specifier_as_an_argument: diag(1324, ts.DiagnosticCategory.Error, "Dynamic_import_must_have_one_specifier_as_an_argument_1324", "Dynamic import must have one specifier as an argument."),
	        Specifier_of_dynamic_import_cannot_be_spread_element: diag(1325, ts.DiagnosticCategory.Error, "Specifier_of_dynamic_import_cannot_be_spread_element_1325", "Specifier of dynamic import cannot be spread element."),
	        Dynamic_import_cannot_have_type_arguments: diag(1326, ts.DiagnosticCategory.Error, "Dynamic_import_cannot_have_type_arguments_1326", "Dynamic import cannot have type arguments"),
	        String_literal_with_double_quotes_expected: diag(1327, ts.DiagnosticCategory.Error, "String_literal_with_double_quotes_expected_1327", "String literal with double quotes expected."),
	        Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal: diag(1328, ts.DiagnosticCategory.Error, "Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_li_1328", "Property value can only be string literal, numeric literal, 'true', 'false', 'null', object literal or array literal."),
	        _0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0: diag(1329, ts.DiagnosticCategory.Error, "_0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write__1329", "'{0}' accepts too few arguments to be used as a decorator here. Did you mean to call it first and write '@{0}()'?"),
	        A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly: diag(1330, ts.DiagnosticCategory.Error, "A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly_1330", "A property of an interface or type literal whose type is a 'unique symbol' type must be 'readonly'."),
	        A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly: diag(1331, ts.DiagnosticCategory.Error, "A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly_1331", "A property of a class whose type is a 'unique symbol' type must be both 'static' and 'readonly'."),
	        A_variable_whose_type_is_a_unique_symbol_type_must_be_const: diag(1332, ts.DiagnosticCategory.Error, "A_variable_whose_type_is_a_unique_symbol_type_must_be_const_1332", "A variable whose type is a 'unique symbol' type must be 'const'."),
	        unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name: diag(1333, ts.DiagnosticCategory.Error, "unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name_1333", "'unique symbol' types may not be used on a variable declaration with a binding name."),
	        unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement: diag(1334, ts.DiagnosticCategory.Error, "unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement_1334", "'unique symbol' types are only allowed on variables in a variable statement."),
	        unique_symbol_types_are_not_allowed_here: diag(1335, ts.DiagnosticCategory.Error, "unique_symbol_types_are_not_allowed_here_1335", "'unique symbol' types are not allowed here."),
	        An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead: diag(1336, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead_1336", "An index signature parameter type cannot be a type alias. Consider writing '[{0}: {1}]: {2}' instead."),
	        An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead: diag(1337, ts.DiagnosticCategory.Error, "An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead_1337", "An index signature parameter type cannot be a union type. Consider using a mapped object type instead."),
	        infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type: diag(1338, ts.DiagnosticCategory.Error, "infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type_1338", "'infer' declarations are only permitted in the 'extends' clause of a conditional type."),
	        Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here: diag(1339, ts.DiagnosticCategory.Error, "Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here_1339", "Module '{0}' does not refer to a value, but is used as a value here."),
	        Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here: diag(1340, ts.DiagnosticCategory.Error, "Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here_1340", "Module '{0}' does not refer to a type, but is used as a type here."),
	        Type_arguments_cannot_be_used_here: diag(1342, ts.DiagnosticCategory.Error, "Type_arguments_cannot_be_used_here_1342", "Type arguments cannot be used here."),
	        The_import_meta_meta_property_is_only_allowed_using_ESNext_for_the_target_and_module_compiler_options: diag(1343, ts.DiagnosticCategory.Error, "The_import_meta_meta_property_is_only_allowed_using_ESNext_for_the_target_and_module_compiler_option_1343", "The 'import.meta' meta-property is only allowed using 'ESNext' for the 'target' and 'module' compiler options."),
	        Duplicate_identifier_0: diag(2300, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_2300", "Duplicate identifier '{0}'."),
	        Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor: diag(2301, ts.DiagnosticCategory.Error, "Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor_2301", "Initializer of instance member variable '{0}' cannot reference identifier '{1}' declared in the constructor."),
	        Static_members_cannot_reference_class_type_parameters: diag(2302, ts.DiagnosticCategory.Error, "Static_members_cannot_reference_class_type_parameters_2302", "Static members cannot reference class type parameters."),
	        Circular_definition_of_import_alias_0: diag(2303, ts.DiagnosticCategory.Error, "Circular_definition_of_import_alias_0_2303", "Circular definition of import alias '{0}'."),
	        Cannot_find_name_0: diag(2304, ts.DiagnosticCategory.Error, "Cannot_find_name_0_2304", "Cannot find name '{0}'."),
	        Module_0_has_no_exported_member_1: diag(2305, ts.DiagnosticCategory.Error, "Module_0_has_no_exported_member_1_2305", "Module '{0}' has no exported member '{1}'."),
	        File_0_is_not_a_module: diag(2306, ts.DiagnosticCategory.Error, "File_0_is_not_a_module_2306", "File '{0}' is not a module."),
	        Cannot_find_module_0: diag(2307, ts.DiagnosticCategory.Error, "Cannot_find_module_0_2307", "Cannot find module '{0}'."),
	        Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity: diag(2308, ts.DiagnosticCategory.Error, "Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambig_2308", "Module {0} has already exported a member named '{1}'. Consider explicitly re-exporting to resolve the ambiguity."),
	        An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements: diag(2309, ts.DiagnosticCategory.Error, "An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements_2309", "An export assignment cannot be used in a module with other exported elements."),
	        Type_0_recursively_references_itself_as_a_base_type: diag(2310, ts.DiagnosticCategory.Error, "Type_0_recursively_references_itself_as_a_base_type_2310", "Type '{0}' recursively references itself as a base type."),
	        A_class_may_only_extend_another_class: diag(2311, ts.DiagnosticCategory.Error, "A_class_may_only_extend_another_class_2311", "A class may only extend another class."),
	        An_interface_may_only_extend_a_class_or_another_interface: diag(2312, ts.DiagnosticCategory.Error, "An_interface_may_only_extend_a_class_or_another_interface_2312", "An interface may only extend a class or another interface."),
	        Type_parameter_0_has_a_circular_constraint: diag(2313, ts.DiagnosticCategory.Error, "Type_parameter_0_has_a_circular_constraint_2313", "Type parameter '{0}' has a circular constraint."),
	        Generic_type_0_requires_1_type_argument_s: diag(2314, ts.DiagnosticCategory.Error, "Generic_type_0_requires_1_type_argument_s_2314", "Generic type '{0}' requires {1} type argument(s)."),
	        Type_0_is_not_generic: diag(2315, ts.DiagnosticCategory.Error, "Type_0_is_not_generic_2315", "Type '{0}' is not generic."),
	        Global_type_0_must_be_a_class_or_interface_type: diag(2316, ts.DiagnosticCategory.Error, "Global_type_0_must_be_a_class_or_interface_type_2316", "Global type '{0}' must be a class or interface type."),
	        Global_type_0_must_have_1_type_parameter_s: diag(2317, ts.DiagnosticCategory.Error, "Global_type_0_must_have_1_type_parameter_s_2317", "Global type '{0}' must have {1} type parameter(s)."),
	        Cannot_find_global_type_0: diag(2318, ts.DiagnosticCategory.Error, "Cannot_find_global_type_0_2318", "Cannot find global type '{0}'."),
	        Named_property_0_of_types_1_and_2_are_not_identical: diag(2319, ts.DiagnosticCategory.Error, "Named_property_0_of_types_1_and_2_are_not_identical_2319", "Named property '{0}' of types '{1}' and '{2}' are not identical."),
	        Interface_0_cannot_simultaneously_extend_types_1_and_2: diag(2320, ts.DiagnosticCategory.Error, "Interface_0_cannot_simultaneously_extend_types_1_and_2_2320", "Interface '{0}' cannot simultaneously extend types '{1}' and '{2}'."),
	        Excessive_stack_depth_comparing_types_0_and_1: diag(2321, ts.DiagnosticCategory.Error, "Excessive_stack_depth_comparing_types_0_and_1_2321", "Excessive stack depth comparing types '{0}' and '{1}'."),
	        Type_0_is_not_assignable_to_type_1: diag(2322, ts.DiagnosticCategory.Error, "Type_0_is_not_assignable_to_type_1_2322", "Type '{0}' is not assignable to type '{1}'."),
	        Cannot_redeclare_exported_variable_0: diag(2323, ts.DiagnosticCategory.Error, "Cannot_redeclare_exported_variable_0_2323", "Cannot redeclare exported variable '{0}'."),
	        Property_0_is_missing_in_type_1: diag(2324, ts.DiagnosticCategory.Error, "Property_0_is_missing_in_type_1_2324", "Property '{0}' is missing in type '{1}'."),
	        Property_0_is_private_in_type_1_but_not_in_type_2: diag(2325, ts.DiagnosticCategory.Error, "Property_0_is_private_in_type_1_but_not_in_type_2_2325", "Property '{0}' is private in type '{1}' but not in type '{2}'."),
	        Types_of_property_0_are_incompatible: diag(2326, ts.DiagnosticCategory.Error, "Types_of_property_0_are_incompatible_2326", "Types of property '{0}' are incompatible."),
	        Property_0_is_optional_in_type_1_but_required_in_type_2: diag(2327, ts.DiagnosticCategory.Error, "Property_0_is_optional_in_type_1_but_required_in_type_2_2327", "Property '{0}' is optional in type '{1}' but required in type '{2}'."),
	        Types_of_parameters_0_and_1_are_incompatible: diag(2328, ts.DiagnosticCategory.Error, "Types_of_parameters_0_and_1_are_incompatible_2328", "Types of parameters '{0}' and '{1}' are incompatible."),
	        Index_signature_is_missing_in_type_0: diag(2329, ts.DiagnosticCategory.Error, "Index_signature_is_missing_in_type_0_2329", "Index signature is missing in type '{0}'."),
	        Index_signatures_are_incompatible: diag(2330, ts.DiagnosticCategory.Error, "Index_signatures_are_incompatible_2330", "Index signatures are incompatible."),
	        this_cannot_be_referenced_in_a_module_or_namespace_body: diag(2331, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_module_or_namespace_body_2331", "'this' cannot be referenced in a module or namespace body."),
	        this_cannot_be_referenced_in_current_location: diag(2332, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_current_location_2332", "'this' cannot be referenced in current location."),
	        this_cannot_be_referenced_in_constructor_arguments: diag(2333, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_constructor_arguments_2333", "'this' cannot be referenced in constructor arguments."),
	        this_cannot_be_referenced_in_a_static_property_initializer: diag(2334, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_static_property_initializer_2334", "'this' cannot be referenced in a static property initializer."),
	        super_can_only_be_referenced_in_a_derived_class: diag(2335, ts.DiagnosticCategory.Error, "super_can_only_be_referenced_in_a_derived_class_2335", "'super' can only be referenced in a derived class."),
	        super_cannot_be_referenced_in_constructor_arguments: diag(2336, ts.DiagnosticCategory.Error, "super_cannot_be_referenced_in_constructor_arguments_2336", "'super' cannot be referenced in constructor arguments."),
	        Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors: diag(2337, ts.DiagnosticCategory.Error, "Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors_2337", "Super calls are not permitted outside constructors or in nested functions inside constructors."),
	        super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class: diag(2338, ts.DiagnosticCategory.Error, "super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_der_2338", "'super' property access is permitted only in a constructor, member function, or member accessor of a derived class."),
	        Property_0_does_not_exist_on_type_1: diag(2339, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_type_1_2339", "Property '{0}' does not exist on type '{1}'."),
	        Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword: diag(2340, ts.DiagnosticCategory.Error, "Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword_2340", "Only public and protected methods of the base class are accessible via the 'super' keyword."),
	        Property_0_is_private_and_only_accessible_within_class_1: diag(2341, ts.DiagnosticCategory.Error, "Property_0_is_private_and_only_accessible_within_class_1_2341", "Property '{0}' is private and only accessible within class '{1}'."),
	        An_index_expression_argument_must_be_of_type_string_number_symbol_or_any: diag(2342, ts.DiagnosticCategory.Error, "An_index_expression_argument_must_be_of_type_string_number_symbol_or_any_2342", "An index expression argument must be of type 'string', 'number', 'symbol', or 'any'."),
	        This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1: diag(2343, ts.DiagnosticCategory.Error, "This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1_2343", "This syntax requires an imported helper named '{1}', but module '{0}' has no exported member '{1}'."),
	        Type_0_does_not_satisfy_the_constraint_1: diag(2344, ts.DiagnosticCategory.Error, "Type_0_does_not_satisfy_the_constraint_1_2344", "Type '{0}' does not satisfy the constraint '{1}'."),
	        Argument_of_type_0_is_not_assignable_to_parameter_of_type_1: diag(2345, ts.DiagnosticCategory.Error, "Argument_of_type_0_is_not_assignable_to_parameter_of_type_1_2345", "Argument of type '{0}' is not assignable to parameter of type '{1}'."),
	        Call_target_does_not_contain_any_signatures: diag(2346, ts.DiagnosticCategory.Error, "Call_target_does_not_contain_any_signatures_2346", "Call target does not contain any signatures."),
	        Untyped_function_calls_may_not_accept_type_arguments: diag(2347, ts.DiagnosticCategory.Error, "Untyped_function_calls_may_not_accept_type_arguments_2347", "Untyped function calls may not accept type arguments."),
	        Value_of_type_0_is_not_callable_Did_you_mean_to_include_new: diag(2348, ts.DiagnosticCategory.Error, "Value_of_type_0_is_not_callable_Did_you_mean_to_include_new_2348", "Value of type '{0}' is not callable. Did you mean to include 'new'?"),
	        Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures: diag(2349, ts.DiagnosticCategory.Error, "Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatur_2349", "Cannot invoke an expression whose type lacks a call signature. Type '{0}' has no compatible call signatures."),
	        Only_a_void_function_can_be_called_with_the_new_keyword: diag(2350, ts.DiagnosticCategory.Error, "Only_a_void_function_can_be_called_with_the_new_keyword_2350", "Only a void function can be called with the 'new' keyword."),
	        Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature: diag(2351, ts.DiagnosticCategory.Error, "Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature_2351", "Cannot use 'new' with an expression whose type lacks a call or construct signature."),
	        Type_0_cannot_be_converted_to_type_1: diag(2352, ts.DiagnosticCategory.Error, "Type_0_cannot_be_converted_to_type_1_2352", "Type '{0}' cannot be converted to type '{1}'."),
	        Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1: diag(2353, ts.DiagnosticCategory.Error, "Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1_2353", "Object literal may only specify known properties, and '{0}' does not exist in type '{1}'."),
	        This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found: diag(2354, ts.DiagnosticCategory.Error, "This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found_2354", "This syntax requires an imported helper but module '{0}' cannot be found."),
	        A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value: diag(2355, ts.DiagnosticCategory.Error, "A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value_2355", "A function whose declared type is neither 'void' nor 'any' must return a value."),
	        An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type: diag(2356, ts.DiagnosticCategory.Error, "An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type_2356", "An arithmetic operand must be of type 'any', 'number' or an enum type."),
	        The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access: diag(2357, ts.DiagnosticCategory.Error, "The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access_2357", "The operand of an increment or decrement operator must be a variable or a property access."),
	        The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2358, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_paramete_2358", "The left-hand side of an 'instanceof' expression must be of type 'any', an object type or a type parameter."),
	        The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type: diag(2359, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_F_2359", "The right-hand side of an 'instanceof' expression must be of type 'any' or of a type assignable to the 'Function' interface type."),
	        The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol: diag(2360, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol_2360", "The left-hand side of an 'in' expression must be of type 'any', 'string', 'number', or 'symbol'."),
	        The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter: diag(2361, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter_2361", "The right-hand side of an 'in' expression must be of type 'any', an object type or a type parameter."),
	        The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type: diag(2362, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type_2362", "The left-hand side of an arithmetic operation must be of type 'any', 'number' or an enum type."),
	        The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type: diag(2363, ts.DiagnosticCategory.Error, "The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type_2363", "The right-hand side of an arithmetic operation must be of type 'any', 'number' or an enum type."),
	        The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access: diag(2364, ts.DiagnosticCategory.Error, "The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access_2364", "The left-hand side of an assignment expression must be a variable or a property access."),
	        Operator_0_cannot_be_applied_to_types_1_and_2: diag(2365, ts.DiagnosticCategory.Error, "Operator_0_cannot_be_applied_to_types_1_and_2_2365", "Operator '{0}' cannot be applied to types '{1}' and '{2}'."),
	        Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined: diag(2366, ts.DiagnosticCategory.Error, "Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined_2366", "Function lacks ending return statement and return type does not include 'undefined'."),
	        Type_parameter_name_cannot_be_0: diag(2368, ts.DiagnosticCategory.Error, "Type_parameter_name_cannot_be_0_2368", "Type parameter name cannot be '{0}'."),
	        A_parameter_property_is_only_allowed_in_a_constructor_implementation: diag(2369, ts.DiagnosticCategory.Error, "A_parameter_property_is_only_allowed_in_a_constructor_implementation_2369", "A parameter property is only allowed in a constructor implementation."),
	        A_rest_parameter_must_be_of_an_array_type: diag(2370, ts.DiagnosticCategory.Error, "A_rest_parameter_must_be_of_an_array_type_2370", "A rest parameter must be of an array type."),
	        A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation: diag(2371, ts.DiagnosticCategory.Error, "A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation_2371", "A parameter initializer is only allowed in a function or constructor implementation."),
	        Parameter_0_cannot_be_referenced_in_its_initializer: diag(2372, ts.DiagnosticCategory.Error, "Parameter_0_cannot_be_referenced_in_its_initializer_2372", "Parameter '{0}' cannot be referenced in its initializer."),
	        Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it: diag(2373, ts.DiagnosticCategory.Error, "Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it_2373", "Initializer of parameter '{0}' cannot reference identifier '{1}' declared after it."),
	        Duplicate_string_index_signature: diag(2374, ts.DiagnosticCategory.Error, "Duplicate_string_index_signature_2374", "Duplicate string index signature."),
	        Duplicate_number_index_signature: diag(2375, ts.DiagnosticCategory.Error, "Duplicate_number_index_signature_2375", "Duplicate number index signature."),
	        A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_properties_or_has_parameter_properties: diag(2376, ts.DiagnosticCategory.Error, "A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_proper_2376", "A 'super' call must be the first statement in the constructor when a class contains initialized properties or has parameter properties."),
	        Constructors_for_derived_classes_must_contain_a_super_call: diag(2377, ts.DiagnosticCategory.Error, "Constructors_for_derived_classes_must_contain_a_super_call_2377", "Constructors for derived classes must contain a 'super' call."),
	        A_get_accessor_must_return_a_value: diag(2378, ts.DiagnosticCategory.Error, "A_get_accessor_must_return_a_value_2378", "A 'get' accessor must return a value."),
	        Getter_and_setter_accessors_do_not_agree_in_visibility: diag(2379, ts.DiagnosticCategory.Error, "Getter_and_setter_accessors_do_not_agree_in_visibility_2379", "Getter and setter accessors do not agree in visibility."),
	        get_and_set_accessor_must_have_the_same_type: diag(2380, ts.DiagnosticCategory.Error, "get_and_set_accessor_must_have_the_same_type_2380", "'get' and 'set' accessor must have the same type."),
	        A_signature_with_an_implementation_cannot_use_a_string_literal_type: diag(2381, ts.DiagnosticCategory.Error, "A_signature_with_an_implementation_cannot_use_a_string_literal_type_2381", "A signature with an implementation cannot use a string literal type."),
	        Specialized_overload_signature_is_not_assignable_to_any_non_specialized_signature: diag(2382, ts.DiagnosticCategory.Error, "Specialized_overload_signature_is_not_assignable_to_any_non_specialized_signature_2382", "Specialized overload signature is not assignable to any non-specialized signature."),
	        Overload_signatures_must_all_be_exported_or_non_exported: diag(2383, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_exported_or_non_exported_2383", "Overload signatures must all be exported or non-exported."),
	        Overload_signatures_must_all_be_ambient_or_non_ambient: diag(2384, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_ambient_or_non_ambient_2384", "Overload signatures must all be ambient or non-ambient."),
	        Overload_signatures_must_all_be_public_private_or_protected: diag(2385, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_public_private_or_protected_2385", "Overload signatures must all be public, private or protected."),
	        Overload_signatures_must_all_be_optional_or_required: diag(2386, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_optional_or_required_2386", "Overload signatures must all be optional or required."),
	        Function_overload_must_be_static: diag(2387, ts.DiagnosticCategory.Error, "Function_overload_must_be_static_2387", "Function overload must be static."),
	        Function_overload_must_not_be_static: diag(2388, ts.DiagnosticCategory.Error, "Function_overload_must_not_be_static_2388", "Function overload must not be static."),
	        Function_implementation_name_must_be_0: diag(2389, ts.DiagnosticCategory.Error, "Function_implementation_name_must_be_0_2389", "Function implementation name must be '{0}'."),
	        Constructor_implementation_is_missing: diag(2390, ts.DiagnosticCategory.Error, "Constructor_implementation_is_missing_2390", "Constructor implementation is missing."),
	        Function_implementation_is_missing_or_not_immediately_following_the_declaration: diag(2391, ts.DiagnosticCategory.Error, "Function_implementation_is_missing_or_not_immediately_following_the_declaration_2391", "Function implementation is missing or not immediately following the declaration."),
	        Multiple_constructor_implementations_are_not_allowed: diag(2392, ts.DiagnosticCategory.Error, "Multiple_constructor_implementations_are_not_allowed_2392", "Multiple constructor implementations are not allowed."),
	        Duplicate_function_implementation: diag(2393, ts.DiagnosticCategory.Error, "Duplicate_function_implementation_2393", "Duplicate function implementation."),
	        Overload_signature_is_not_compatible_with_function_implementation: diag(2394, ts.DiagnosticCategory.Error, "Overload_signature_is_not_compatible_with_function_implementation_2394", "Overload signature is not compatible with function implementation."),
	        Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local: diag(2395, ts.DiagnosticCategory.Error, "Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local_2395", "Individual declarations in merged declaration '{0}' must be all exported or all local."),
	        Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters: diag(2396, ts.DiagnosticCategory.Error, "Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters_2396", "Duplicate identifier 'arguments'. Compiler uses 'arguments' to initialize rest parameters."),
	        Declaration_name_conflicts_with_built_in_global_identifier_0: diag(2397, ts.DiagnosticCategory.Error, "Declaration_name_conflicts_with_built_in_global_identifier_0_2397", "Declaration name conflicts with built-in global identifier '{0}'."),
	        Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference: diag(2399, ts.DiagnosticCategory.Error, "Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference_2399", "Duplicate identifier '_this'. Compiler uses variable declaration '_this' to capture 'this' reference."),
	        Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference: diag(2400, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference_2400", "Expression resolves to variable declaration '_this' that compiler uses to capture 'this' reference."),
	        Duplicate_identifier_super_Compiler_uses_super_to_capture_base_class_reference: diag(2401, ts.DiagnosticCategory.Error, "Duplicate_identifier_super_Compiler_uses_super_to_capture_base_class_reference_2401", "Duplicate identifier '_super'. Compiler uses '_super' to capture base class reference."),
	        Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference: diag(2402, ts.DiagnosticCategory.Error, "Expression_resolves_to_super_that_compiler_uses_to_capture_base_class_reference_2402", "Expression resolves to '_super' that compiler uses to capture base class reference."),
	        Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2: diag(2403, ts.DiagnosticCategory.Error, "Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_t_2403", "Subsequent variable declarations must have the same type.  Variable '{0}' must be of type '{1}', but here has type '{2}'."),
	        The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation: diag(2404, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation_2404", "The left-hand side of a 'for...in' statement cannot use a type annotation."),
	        The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any: diag(2405, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any_2405", "The left-hand side of a 'for...in' statement must be of type 'string' or 'any'."),
	        The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access: diag(2406, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access_2406", "The left-hand side of a 'for...in' statement must be a variable or a property access."),
	        The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0: diag(2407, ts.DiagnosticCategory.Error, "The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_2407", "The right-hand side of a 'for...in' statement must be of type 'any', an object type or a type parameter, but here has type '{0}'."),
	        Setters_cannot_return_a_value: diag(2408, ts.DiagnosticCategory.Error, "Setters_cannot_return_a_value_2408", "Setters cannot return a value."),
	        Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class: diag(2409, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class_2409", "Return type of constructor signature must be assignable to the instance type of the class."),
	        The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any: diag(2410, ts.DiagnosticCategory.Error, "The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any_2410", "The 'with' statement is not supported. All symbols in a 'with' block will have type 'any'."),
	        Property_0_of_type_1_is_not_assignable_to_string_index_type_2: diag(2411, ts.DiagnosticCategory.Error, "Property_0_of_type_1_is_not_assignable_to_string_index_type_2_2411", "Property '{0}' of type '{1}' is not assignable to string index type '{2}'."),
	        Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2: diag(2412, ts.DiagnosticCategory.Error, "Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2_2412", "Property '{0}' of type '{1}' is not assignable to numeric index type '{2}'."),
	        Numeric_index_type_0_is_not_assignable_to_string_index_type_1: diag(2413, ts.DiagnosticCategory.Error, "Numeric_index_type_0_is_not_assignable_to_string_index_type_1_2413", "Numeric index type '{0}' is not assignable to string index type '{1}'."),
	        Class_name_cannot_be_0: diag(2414, ts.DiagnosticCategory.Error, "Class_name_cannot_be_0_2414", "Class name cannot be '{0}'."),
	        Class_0_incorrectly_extends_base_class_1: diag(2415, ts.DiagnosticCategory.Error, "Class_0_incorrectly_extends_base_class_1_2415", "Class '{0}' incorrectly extends base class '{1}'."),
	        Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2: diag(2416, ts.DiagnosticCategory.Error, "Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2_2416", "Property '{0}' in type '{1}' is not assignable to the same property in base type '{2}'."),
	        Class_static_side_0_incorrectly_extends_base_class_static_side_1: diag(2417, ts.DiagnosticCategory.Error, "Class_static_side_0_incorrectly_extends_base_class_static_side_1_2417", "Class static side '{0}' incorrectly extends base class static side '{1}'."),
	        Class_0_incorrectly_implements_interface_1: diag(2420, ts.DiagnosticCategory.Error, "Class_0_incorrectly_implements_interface_1_2420", "Class '{0}' incorrectly implements interface '{1}'."),
	        A_class_may_only_implement_another_class_or_interface: diag(2422, ts.DiagnosticCategory.Error, "A_class_may_only_implement_another_class_or_interface_2422", "A class may only implement another class or interface."),
	        Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor: diag(2423, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_access_2423", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member accessor."),
	        Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_property: diag(2424, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_proper_2424", "Class '{0}' defines instance member function '{1}', but extended class '{2}' defines it as instance member property."),
	        Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2425, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_functi_2425", "Class '{0}' defines instance member property '{1}', but extended class '{2}' defines it as instance member function."),
	        Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function: diag(2426, ts.DiagnosticCategory.Error, "Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_functi_2426", "Class '{0}' defines instance member accessor '{1}', but extended class '{2}' defines it as instance member function."),
	        Interface_name_cannot_be_0: diag(2427, ts.DiagnosticCategory.Error, "Interface_name_cannot_be_0_2427", "Interface name cannot be '{0}'."),
	        All_declarations_of_0_must_have_identical_type_parameters: diag(2428, ts.DiagnosticCategory.Error, "All_declarations_of_0_must_have_identical_type_parameters_2428", "All declarations of '{0}' must have identical type parameters."),
	        Interface_0_incorrectly_extends_interface_1: diag(2430, ts.DiagnosticCategory.Error, "Interface_0_incorrectly_extends_interface_1_2430", "Interface '{0}' incorrectly extends interface '{1}'."),
	        Enum_name_cannot_be_0: diag(2431, ts.DiagnosticCategory.Error, "Enum_name_cannot_be_0_2431", "Enum name cannot be '{0}'."),
	        In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element: diag(2432, ts.DiagnosticCategory.Error, "In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enu_2432", "In an enum with multiple declarations, only one declaration can omit an initializer for its first enum element."),
	        A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged: diag(2433, ts.DiagnosticCategory.Error, "A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merg_2433", "A namespace declaration cannot be in a different file from a class or function with which it is merged."),
	        A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged: diag(2434, ts.DiagnosticCategory.Error, "A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged_2434", "A namespace declaration cannot be located prior to a class or function with which it is merged."),
	        Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces: diag(2435, ts.DiagnosticCategory.Error, "Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces_2435", "Ambient modules cannot be nested in other modules or namespaces."),
	        Ambient_module_declaration_cannot_specify_relative_module_name: diag(2436, ts.DiagnosticCategory.Error, "Ambient_module_declaration_cannot_specify_relative_module_name_2436", "Ambient module declaration cannot specify relative module name."),
	        Module_0_is_hidden_by_a_local_declaration_with_the_same_name: diag(2437, ts.DiagnosticCategory.Error, "Module_0_is_hidden_by_a_local_declaration_with_the_same_name_2437", "Module '{0}' is hidden by a local declaration with the same name."),
	        Import_name_cannot_be_0: diag(2438, ts.DiagnosticCategory.Error, "Import_name_cannot_be_0_2438", "Import name cannot be '{0}'."),
	        Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name: diag(2439, ts.DiagnosticCategory.Error, "Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relati_2439", "Import or export declaration in an ambient module declaration cannot reference module through relative module name."),
	        Import_declaration_conflicts_with_local_declaration_of_0: diag(2440, ts.DiagnosticCategory.Error, "Import_declaration_conflicts_with_local_declaration_of_0_2440", "Import declaration conflicts with local declaration of '{0}'."),
	        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module: diag(2441, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_2441", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module."),
	        Types_have_separate_declarations_of_a_private_property_0: diag(2442, ts.DiagnosticCategory.Error, "Types_have_separate_declarations_of_a_private_property_0_2442", "Types have separate declarations of a private property '{0}'."),
	        Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2: diag(2443, ts.DiagnosticCategory.Error, "Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2_2443", "Property '{0}' is protected but type '{1}' is not a class derived from '{2}'."),
	        Property_0_is_protected_in_type_1_but_public_in_type_2: diag(2444, ts.DiagnosticCategory.Error, "Property_0_is_protected_in_type_1_but_public_in_type_2_2444", "Property '{0}' is protected in type '{1}' but public in type '{2}'."),
	        Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses: diag(2445, ts.DiagnosticCategory.Error, "Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses_2445", "Property '{0}' is protected and only accessible within class '{1}' and its subclasses."),
	        Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1: diag(2446, ts.DiagnosticCategory.Error, "Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1_2446", "Property '{0}' is protected and only accessible through an instance of class '{1}'."),
	        The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead: diag(2447, ts.DiagnosticCategory.Error, "The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead_2447", "The '{0}' operator is not allowed for boolean types. Consider using '{1}' instead."),
	        Block_scoped_variable_0_used_before_its_declaration: diag(2448, ts.DiagnosticCategory.Error, "Block_scoped_variable_0_used_before_its_declaration_2448", "Block-scoped variable '{0}' used before its declaration."),
	        Class_0_used_before_its_declaration: diag(2449, ts.DiagnosticCategory.Error, "Class_0_used_before_its_declaration_2449", "Class '{0}' used before its declaration."),
	        Enum_0_used_before_its_declaration: diag(2450, ts.DiagnosticCategory.Error, "Enum_0_used_before_its_declaration_2450", "Enum '{0}' used before its declaration."),
	        Cannot_redeclare_block_scoped_variable_0: diag(2451, ts.DiagnosticCategory.Error, "Cannot_redeclare_block_scoped_variable_0_2451", "Cannot redeclare block-scoped variable '{0}'."),
	        An_enum_member_cannot_have_a_numeric_name: diag(2452, ts.DiagnosticCategory.Error, "An_enum_member_cannot_have_a_numeric_name_2452", "An enum member cannot have a numeric name."),
	        The_type_argument_for_type_parameter_0_cannot_be_inferred_from_the_usage_Consider_specifying_the_type_arguments_explicitly: diag(2453, ts.DiagnosticCategory.Error, "The_type_argument_for_type_parameter_0_cannot_be_inferred_from_the_usage_Consider_specifying_the_typ_2453", "The type argument for type parameter '{0}' cannot be inferred from the usage. Consider specifying the type arguments explicitly."),
	        Variable_0_is_used_before_being_assigned: diag(2454, ts.DiagnosticCategory.Error, "Variable_0_is_used_before_being_assigned_2454", "Variable '{0}' is used before being assigned."),
	        Type_argument_candidate_1_is_not_a_valid_type_argument_because_it_is_not_a_supertype_of_candidate_0: diag(2455, ts.DiagnosticCategory.Error, "Type_argument_candidate_1_is_not_a_valid_type_argument_because_it_is_not_a_supertype_of_candidate_0_2455", "Type argument candidate '{1}' is not a valid type argument because it is not a supertype of candidate '{0}'."),
	        Type_alias_0_circularly_references_itself: diag(2456, ts.DiagnosticCategory.Error, "Type_alias_0_circularly_references_itself_2456", "Type alias '{0}' circularly references itself."),
	        Type_alias_name_cannot_be_0: diag(2457, ts.DiagnosticCategory.Error, "Type_alias_name_cannot_be_0_2457", "Type alias name cannot be '{0}'."),
	        An_AMD_module_cannot_have_multiple_name_assignments: diag(2458, ts.DiagnosticCategory.Error, "An_AMD_module_cannot_have_multiple_name_assignments_2458", "An AMD module cannot have multiple name assignments."),
	        Type_0_has_no_property_1_and_no_string_index_signature: diag(2459, ts.DiagnosticCategory.Error, "Type_0_has_no_property_1_and_no_string_index_signature_2459", "Type '{0}' has no property '{1}' and no string index signature."),
	        Type_0_has_no_property_1: diag(2460, ts.DiagnosticCategory.Error, "Type_0_has_no_property_1_2460", "Type '{0}' has no property '{1}'."),
	        Type_0_is_not_an_array_type: diag(2461, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_2461", "Type '{0}' is not an array type."),
	        A_rest_element_must_be_last_in_a_destructuring_pattern: diag(2462, ts.DiagnosticCategory.Error, "A_rest_element_must_be_last_in_a_destructuring_pattern_2462", "A rest element must be last in a destructuring pattern."),
	        A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature: diag(2463, ts.DiagnosticCategory.Error, "A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature_2463", "A binding pattern parameter cannot be optional in an implementation signature."),
	        A_computed_property_name_must_be_of_type_string_number_symbol_or_any: diag(2464, ts.DiagnosticCategory.Error, "A_computed_property_name_must_be_of_type_string_number_symbol_or_any_2464", "A computed property name must be of type 'string', 'number', 'symbol', or 'any'."),
	        this_cannot_be_referenced_in_a_computed_property_name: diag(2465, ts.DiagnosticCategory.Error, "this_cannot_be_referenced_in_a_computed_property_name_2465", "'this' cannot be referenced in a computed property name."),
	        super_cannot_be_referenced_in_a_computed_property_name: diag(2466, ts.DiagnosticCategory.Error, "super_cannot_be_referenced_in_a_computed_property_name_2466", "'super' cannot be referenced in a computed property name."),
	        A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type: diag(2467, ts.DiagnosticCategory.Error, "A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type_2467", "A computed property name cannot reference a type parameter from its containing type."),
	        Cannot_find_global_value_0: diag(2468, ts.DiagnosticCategory.Error, "Cannot_find_global_value_0_2468", "Cannot find global value '{0}'."),
	        The_0_operator_cannot_be_applied_to_type_symbol: diag(2469, ts.DiagnosticCategory.Error, "The_0_operator_cannot_be_applied_to_type_symbol_2469", "The '{0}' operator cannot be applied to type 'symbol'."),
	        Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object: diag(2470, ts.DiagnosticCategory.Error, "Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object_2470", "'Symbol' reference does not refer to the global Symbol constructor object."),
	        A_computed_property_name_of_the_form_0_must_be_of_type_symbol: diag(2471, ts.DiagnosticCategory.Error, "A_computed_property_name_of_the_form_0_must_be_of_type_symbol_2471", "A computed property name of the form '{0}' must be of type 'symbol'."),
	        Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher: diag(2472, ts.DiagnosticCategory.Error, "Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher_2472", "Spread operator in 'new' expressions is only available when targeting ECMAScript 5 and higher."),
	        Enum_declarations_must_all_be_const_or_non_const: diag(2473, ts.DiagnosticCategory.Error, "Enum_declarations_must_all_be_const_or_non_const_2473", "Enum declarations must all be const or non-const."),
	        In_const_enum_declarations_member_initializer_must_be_constant_expression: diag(2474, ts.DiagnosticCategory.Error, "In_const_enum_declarations_member_initializer_must_be_constant_expression_2474", "In 'const' enum declarations member initializer must be constant expression."),
	        const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query: diag(2475, ts.DiagnosticCategory.Error, "const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_im_2475", "'const' enums can only be used in property or index access expressions or the right hand side of an import declaration or export assignment or type query."),
	        A_const_enum_member_can_only_be_accessed_using_a_string_literal: diag(2476, ts.DiagnosticCategory.Error, "A_const_enum_member_can_only_be_accessed_using_a_string_literal_2476", "A const enum member can only be accessed using a string literal."),
	        const_enum_member_initializer_was_evaluated_to_a_non_finite_value: diag(2477, ts.DiagnosticCategory.Error, "const_enum_member_initializer_was_evaluated_to_a_non_finite_value_2477", "'const' enum member initializer was evaluated to a non-finite value."),
	        const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN: diag(2478, ts.DiagnosticCategory.Error, "const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN_2478", "'const' enum member initializer was evaluated to disallowed value 'NaN'."),
	        Property_0_does_not_exist_on_const_enum_1: diag(2479, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_const_enum_1_2479", "Property '{0}' does not exist on 'const' enum '{1}'."),
	        let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations: diag(2480, ts.DiagnosticCategory.Error, "let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations_2480", "'let' is not allowed to be used as a name in 'let' or 'const' declarations."),
	        Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1: diag(2481, ts.DiagnosticCategory.Error, "Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1_2481", "Cannot initialize outer scoped variable '{0}' in the same scope as block scoped declaration '{1}'."),
	        The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation: diag(2483, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation_2483", "The left-hand side of a 'for...of' statement cannot use a type annotation."),
	        Export_declaration_conflicts_with_exported_declaration_of_0: diag(2484, ts.DiagnosticCategory.Error, "Export_declaration_conflicts_with_exported_declaration_of_0_2484", "Export declaration conflicts with exported declaration of '{0}'."),
	        The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access: diag(2487, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access_2487", "The left-hand side of a 'for...of' statement must be a variable or a property access."),
	        Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2488, ts.DiagnosticCategory.Error, "Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator_2488", "Type '{0}' must have a '[Symbol.iterator]()' method that returns an iterator."),
	        An_iterator_must_have_a_next_method: diag(2489, ts.DiagnosticCategory.Error, "An_iterator_must_have_a_next_method_2489", "An iterator must have a 'next()' method."),
	        The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property: diag(2490, ts.DiagnosticCategory.Error, "The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property_2490", "The type returned by the 'next()' method of an iterator must have a 'value' property."),
	        The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern: diag(2491, ts.DiagnosticCategory.Error, "The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern_2491", "The left-hand side of a 'for...in' statement cannot be a destructuring pattern."),
	        Cannot_redeclare_identifier_0_in_catch_clause: diag(2492, ts.DiagnosticCategory.Error, "Cannot_redeclare_identifier_0_in_catch_clause_2492", "Cannot redeclare identifier '{0}' in catch clause."),
	        Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2: diag(2493, ts.DiagnosticCategory.Error, "Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2_2493", "Tuple type '{0}' with length '{1}' cannot be assigned to tuple with length '{2}'."),
	        Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher: diag(2494, ts.DiagnosticCategory.Error, "Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher_2494", "Using a string in a 'for...of' statement is only supported in ECMAScript 5 and higher."),
	        Type_0_is_not_an_array_type_or_a_string_type: diag(2495, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_a_string_type_2495", "Type '{0}' is not an array type or a string type."),
	        The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression: diag(2496, ts.DiagnosticCategory.Error, "The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_stand_2496", "The 'arguments' object cannot be referenced in an arrow function in ES3 and ES5. Consider using a standard function expression."),
	        Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct: diag(2497, ts.DiagnosticCategory.Error, "Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct_2497", "Module '{0}' resolves to a non-module entity and cannot be imported using this construct."),
	        Module_0_uses_export_and_cannot_be_used_with_export_Asterisk: diag(2498, ts.DiagnosticCategory.Error, "Module_0_uses_export_and_cannot_be_used_with_export_Asterisk_2498", "Module '{0}' uses 'export =' and cannot be used with 'export *'."),
	        An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2499, ts.DiagnosticCategory.Error, "An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments_2499", "An interface can only extend an identifier/qualified-name with optional type arguments."),
	        A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments: diag(2500, ts.DiagnosticCategory.Error, "A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments_2500", "A class can only implement an identifier/qualified-name with optional type arguments."),
	        A_rest_element_cannot_contain_a_binding_pattern: diag(2501, ts.DiagnosticCategory.Error, "A_rest_element_cannot_contain_a_binding_pattern_2501", "A rest element cannot contain a binding pattern."),
	        _0_is_referenced_directly_or_indirectly_in_its_own_type_annotation: diag(2502, ts.DiagnosticCategory.Error, "_0_is_referenced_directly_or_indirectly_in_its_own_type_annotation_2502", "'{0}' is referenced directly or indirectly in its own type annotation."),
	        Cannot_find_namespace_0: diag(2503, ts.DiagnosticCategory.Error, "Cannot_find_namespace_0_2503", "Cannot find namespace '{0}'."),
	        Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator: diag(2504, ts.DiagnosticCategory.Error, "Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator_2504", "Type '{0}' must have a '[Symbol.asyncIterator]()' method that returns an async iterator."),
	        A_generator_cannot_have_a_void_type_annotation: diag(2505, ts.DiagnosticCategory.Error, "A_generator_cannot_have_a_void_type_annotation_2505", "A generator cannot have a 'void' type annotation."),
	        _0_is_referenced_directly_or_indirectly_in_its_own_base_expression: diag(2506, ts.DiagnosticCategory.Error, "_0_is_referenced_directly_or_indirectly_in_its_own_base_expression_2506", "'{0}' is referenced directly or indirectly in its own base expression."),
	        Type_0_is_not_a_constructor_function_type: diag(2507, ts.DiagnosticCategory.Error, "Type_0_is_not_a_constructor_function_type_2507", "Type '{0}' is not a constructor function type."),
	        No_base_constructor_has_the_specified_number_of_type_arguments: diag(2508, ts.DiagnosticCategory.Error, "No_base_constructor_has_the_specified_number_of_type_arguments_2508", "No base constructor has the specified number of type arguments."),
	        Base_constructor_return_type_0_is_not_a_class_or_interface_type: diag(2509, ts.DiagnosticCategory.Error, "Base_constructor_return_type_0_is_not_a_class_or_interface_type_2509", "Base constructor return type '{0}' is not a class or interface type."),
	        Base_constructors_must_all_have_the_same_return_type: diag(2510, ts.DiagnosticCategory.Error, "Base_constructors_must_all_have_the_same_return_type_2510", "Base constructors must all have the same return type."),
	        Cannot_create_an_instance_of_an_abstract_class: diag(2511, ts.DiagnosticCategory.Error, "Cannot_create_an_instance_of_an_abstract_class_2511", "Cannot create an instance of an abstract class."),
	        Overload_signatures_must_all_be_abstract_or_non_abstract: diag(2512, ts.DiagnosticCategory.Error, "Overload_signatures_must_all_be_abstract_or_non_abstract_2512", "Overload signatures must all be abstract or non-abstract."),
	        Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression: diag(2513, ts.DiagnosticCategory.Error, "Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression_2513", "Abstract method '{0}' in class '{1}' cannot be accessed via super expression."),
	        Classes_containing_abstract_methods_must_be_marked_abstract: diag(2514, ts.DiagnosticCategory.Error, "Classes_containing_abstract_methods_must_be_marked_abstract_2514", "Classes containing abstract methods must be marked abstract."),
	        Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2: diag(2515, ts.DiagnosticCategory.Error, "Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2_2515", "Non-abstract class '{0}' does not implement inherited abstract member '{1}' from class '{2}'."),
	        All_declarations_of_an_abstract_method_must_be_consecutive: diag(2516, ts.DiagnosticCategory.Error, "All_declarations_of_an_abstract_method_must_be_consecutive_2516", "All declarations of an abstract method must be consecutive."),
	        Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type: diag(2517, ts.DiagnosticCategory.Error, "Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type_2517", "Cannot assign an abstract constructor type to a non-abstract constructor type."),
	        A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard: diag(2518, ts.DiagnosticCategory.Error, "A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard_2518", "A 'this'-based type guard is not compatible with a parameter-based type guard."),
	        An_async_iterator_must_have_a_next_method: diag(2519, ts.DiagnosticCategory.Error, "An_async_iterator_must_have_a_next_method_2519", "An async iterator must have a 'next()' method."),
	        Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions: diag(2520, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions_2520", "Duplicate identifier '{0}'. Compiler uses declaration '{1}' to support async functions."),
	        Expression_resolves_to_variable_declaration_0_that_compiler_uses_to_support_async_functions: diag(2521, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_0_that_compiler_uses_to_support_async_functions_2521", "Expression resolves to variable declaration '{0}' that compiler uses to support async functions."),
	        The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method: diag(2522, ts.DiagnosticCategory.Error, "The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_usi_2522", "The 'arguments' object cannot be referenced in an async function or method in ES3 and ES5. Consider using a standard function or method."),
	        yield_expressions_cannot_be_used_in_a_parameter_initializer: diag(2523, ts.DiagnosticCategory.Error, "yield_expressions_cannot_be_used_in_a_parameter_initializer_2523", "'yield' expressions cannot be used in a parameter initializer."),
	        await_expressions_cannot_be_used_in_a_parameter_initializer: diag(2524, ts.DiagnosticCategory.Error, "await_expressions_cannot_be_used_in_a_parameter_initializer_2524", "'await' expressions cannot be used in a parameter initializer."),
	        Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value: diag(2525, ts.DiagnosticCategory.Error, "Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value_2525", "Initializer provides no value for this binding element and the binding element has no default value."),
	        A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface: diag(2526, ts.DiagnosticCategory.Error, "A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface_2526", "A 'this' type is available only in a non-static member of a class or interface."),
	        The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary: diag(2527, ts.DiagnosticCategory.Error, "The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary_2527", "The inferred type of '{0}' references an inaccessible '{1}' type. A type annotation is necessary."),
	        A_module_cannot_have_multiple_default_exports: diag(2528, ts.DiagnosticCategory.Error, "A_module_cannot_have_multiple_default_exports_2528", "A module cannot have multiple default exports."),
	        Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions: diag(2529, ts.DiagnosticCategory.Error, "Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_func_2529", "Duplicate identifier '{0}'. Compiler reserves name '{1}' in top level scope of a module containing async functions."),
	        Property_0_is_incompatible_with_index_signature: diag(2530, ts.DiagnosticCategory.Error, "Property_0_is_incompatible_with_index_signature_2530", "Property '{0}' is incompatible with index signature."),
	        Object_is_possibly_null: diag(2531, ts.DiagnosticCategory.Error, "Object_is_possibly_null_2531", "Object is possibly 'null'."),
	        Object_is_possibly_undefined: diag(2532, ts.DiagnosticCategory.Error, "Object_is_possibly_undefined_2532", "Object is possibly 'undefined'."),
	        Object_is_possibly_null_or_undefined: diag(2533, ts.DiagnosticCategory.Error, "Object_is_possibly_null_or_undefined_2533", "Object is possibly 'null' or 'undefined'."),
	        A_function_returning_never_cannot_have_a_reachable_end_point: diag(2534, ts.DiagnosticCategory.Error, "A_function_returning_never_cannot_have_a_reachable_end_point_2534", "A function returning 'never' cannot have a reachable end point."),
	        Enum_type_0_has_members_with_initializers_that_are_not_literals: diag(2535, ts.DiagnosticCategory.Error, "Enum_type_0_has_members_with_initializers_that_are_not_literals_2535", "Enum type '{0}' has members with initializers that are not literals."),
	        Type_0_cannot_be_used_to_index_type_1: diag(2536, ts.DiagnosticCategory.Error, "Type_0_cannot_be_used_to_index_type_1_2536", "Type '{0}' cannot be used to index type '{1}'."),
	        Type_0_has_no_matching_index_signature_for_type_1: diag(2537, ts.DiagnosticCategory.Error, "Type_0_has_no_matching_index_signature_for_type_1_2537", "Type '{0}' has no matching index signature for type '{1}'."),
	        Type_0_cannot_be_used_as_an_index_type: diag(2538, ts.DiagnosticCategory.Error, "Type_0_cannot_be_used_as_an_index_type_2538", "Type '{0}' cannot be used as an index type."),
	        Cannot_assign_to_0_because_it_is_not_a_variable: diag(2539, ts.DiagnosticCategory.Error, "Cannot_assign_to_0_because_it_is_not_a_variable_2539", "Cannot assign to '{0}' because it is not a variable."),
	        Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property: diag(2540, ts.DiagnosticCategory.Error, "Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property_2540", "Cannot assign to '{0}' because it is a constant or a read-only property."),
	        The_target_of_an_assignment_must_be_a_variable_or_a_property_access: diag(2541, ts.DiagnosticCategory.Error, "The_target_of_an_assignment_must_be_a_variable_or_a_property_access_2541", "The target of an assignment must be a variable or a property access."),
	        Index_signature_in_type_0_only_permits_reading: diag(2542, ts.DiagnosticCategory.Error, "Index_signature_in_type_0_only_permits_reading_2542", "Index signature in type '{0}' only permits reading."),
	        Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference: diag(2543, ts.DiagnosticCategory.Error, "Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_me_2543", "Duplicate identifier '_newTarget'. Compiler uses variable declaration '_newTarget' to capture 'new.target' meta-property reference."),
	        Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference: diag(2544, ts.DiagnosticCategory.Error, "Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta__2544", "Expression resolves to variable declaration '_newTarget' that compiler uses to capture 'new.target' meta-property reference."),
	        A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any: diag(2545, ts.DiagnosticCategory.Error, "A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any_2545", "A mixin class must have a constructor with a single rest parameter of type 'any[]'."),
	        Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1: diag(2546, ts.DiagnosticCategory.Error, "Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1_2546", "Property '{0}' has conflicting declarations and is inaccessible in type '{1}'."),
	        The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property: diag(2547, ts.DiagnosticCategory.Error, "The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value__2547", "The type returned by the 'next()' method of an async iterator must be a promise for a type with a 'value' property."),
	        Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2548, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator_2548", "Type '{0}' is not an array type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
	        Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator: diag(2549, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns__2549", "Type '{0}' is not an array type or a string type or does not have a '[Symbol.iterator]()' method that returns an iterator."),
	        Generic_type_instantiation_is_excessively_deep_and_possibly_infinite: diag(2550, ts.DiagnosticCategory.Error, "Generic_type_instantiation_is_excessively_deep_and_possibly_infinite_2550", "Generic type instantiation is excessively deep and possibly infinite."),
	        Property_0_does_not_exist_on_type_1_Did_you_mean_2: diag(2551, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_type_1_Did_you_mean_2_2551", "Property '{0}' does not exist on type '{1}'. Did you mean '{2}'?"),
	        Cannot_find_name_0_Did_you_mean_1: diag(2552, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_1_2552", "Cannot find name '{0}'. Did you mean '{1}'?"),
	        Computed_values_are_not_permitted_in_an_enum_with_string_valued_members: diag(2553, ts.DiagnosticCategory.Error, "Computed_values_are_not_permitted_in_an_enum_with_string_valued_members_2553", "Computed values are not permitted in an enum with string valued members."),
	        Expected_0_arguments_but_got_1: diag(2554, ts.DiagnosticCategory.Error, "Expected_0_arguments_but_got_1_2554", "Expected {0} arguments, but got {1}."),
	        Expected_at_least_0_arguments_but_got_1: diag(2555, ts.DiagnosticCategory.Error, "Expected_at_least_0_arguments_but_got_1_2555", "Expected at least {0} arguments, but got {1}."),
	        Expected_0_arguments_but_got_1_or_more: diag(2556, ts.DiagnosticCategory.Error, "Expected_0_arguments_but_got_1_or_more_2556", "Expected {0} arguments, but got {1} or more."),
	        Expected_at_least_0_arguments_but_got_1_or_more: diag(2557, ts.DiagnosticCategory.Error, "Expected_at_least_0_arguments_but_got_1_or_more_2557", "Expected at least {0} arguments, but got {1} or more."),
	        Expected_0_type_arguments_but_got_1: diag(2558, ts.DiagnosticCategory.Error, "Expected_0_type_arguments_but_got_1_2558", "Expected {0} type arguments, but got {1}."),
	        Type_0_has_no_properties_in_common_with_type_1: diag(2559, ts.DiagnosticCategory.Error, "Type_0_has_no_properties_in_common_with_type_1_2559", "Type '{0}' has no properties in common with type '{1}'."),
	        Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it: diag(2560, ts.DiagnosticCategory.Error, "Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it_2560", "Value of type '{0}' has no properties in common with type '{1}'. Did you mean to call it?"),
	        Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2: diag(2561, ts.DiagnosticCategory.Error, "Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_writ_2561", "Object literal may only specify known properties, but '{0}' does not exist in type '{1}'. Did you mean to write '{2}'?"),
	        Base_class_expressions_cannot_reference_class_type_parameters: diag(2562, ts.DiagnosticCategory.Error, "Base_class_expressions_cannot_reference_class_type_parameters_2562", "Base class expressions cannot reference class type parameters."),
	        The_containing_function_or_module_body_is_too_large_for_control_flow_analysis: diag(2563, ts.DiagnosticCategory.Error, "The_containing_function_or_module_body_is_too_large_for_control_flow_analysis_2563", "The containing function or module body is too large for control flow analysis."),
	        Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor: diag(2564, ts.DiagnosticCategory.Error, "Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor_2564", "Property '{0}' has no initializer and is not definitely assigned in the constructor."),
	        Property_0_is_used_before_being_assigned: diag(2565, ts.DiagnosticCategory.Error, "Property_0_is_used_before_being_assigned_2565", "Property '{0}' is used before being assigned."),
	        A_rest_element_cannot_have_a_property_name: diag(2566, ts.DiagnosticCategory.Error, "A_rest_element_cannot_have_a_property_name_2566", "A rest element cannot have a property name."),
	        Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations: diag(2567, ts.DiagnosticCategory.Error, "Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations_2567", "Enum declarations can only merge with namespace or other enum declarations."),
	        Type_0_is_not_an_array_type_Use_compiler_option_downlevelIteration_to_allow_iterating_of_iterators: diag(2568, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_Use_compiler_option_downlevelIteration_to_allow_iterating_of_iterators_2568", "Type '{0}' is not an array type. Use compiler option '--downlevelIteration' to allow iterating of iterators."),
	        Type_0_is_not_an_array_type_or_a_string_type_Use_compiler_option_downlevelIteration_to_allow_iterating_of_iterators: diag(2569, ts.DiagnosticCategory.Error, "Type_0_is_not_an_array_type_or_a_string_type_Use_compiler_option_downlevelIteration_to_allow_iterati_2569", "Type '{0}' is not an array type or a string type. Use compiler option '--downlevelIteration' to allow iterating of iterators."),
	        Property_0_does_not_exist_on_type_1_Did_you_forget_to_use_await: diag(2570, ts.DiagnosticCategory.Error, "Property_0_does_not_exist_on_type_1_Did_you_forget_to_use_await_2570", "Property '{0}' does not exist on type '{1}'. Did you forget to use 'await'?"),
	        JSX_element_attributes_type_0_may_not_be_a_union_type: diag(2600, ts.DiagnosticCategory.Error, "JSX_element_attributes_type_0_may_not_be_a_union_type_2600", "JSX element attributes type '{0}' may not be a union type."),
	        The_return_type_of_a_JSX_element_constructor_must_return_an_object_type: diag(2601, ts.DiagnosticCategory.Error, "The_return_type_of_a_JSX_element_constructor_must_return_an_object_type_2601", "The return type of a JSX element constructor must return an object type."),
	        JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist: diag(2602, ts.DiagnosticCategory.Error, "JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist_2602", "JSX element implicitly has type 'any' because the global type 'JSX.Element' does not exist."),
	        Property_0_in_type_1_is_not_assignable_to_type_2: diag(2603, ts.DiagnosticCategory.Error, "Property_0_in_type_1_is_not_assignable_to_type_2_2603", "Property '{0}' in type '{1}' is not assignable to type '{2}'."),
	        JSX_element_type_0_does_not_have_any_construct_or_call_signatures: diag(2604, ts.DiagnosticCategory.Error, "JSX_element_type_0_does_not_have_any_construct_or_call_signatures_2604", "JSX element type '{0}' does not have any construct or call signatures."),
	        JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements: diag(2605, ts.DiagnosticCategory.Error, "JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements_2605", "JSX element type '{0}' is not a constructor function for JSX elements."),
	        Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property: diag(2606, ts.DiagnosticCategory.Error, "Property_0_of_JSX_spread_attribute_is_not_assignable_to_target_property_2606", "Property '{0}' of JSX spread attribute is not assignable to target property."),
	        JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property: diag(2607, ts.DiagnosticCategory.Error, "JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property_2607", "JSX element class does not support attributes because it does not have a '{0}' property."),
	        The_global_type_JSX_0_may_not_have_more_than_one_property: diag(2608, ts.DiagnosticCategory.Error, "The_global_type_JSX_0_may_not_have_more_than_one_property_2608", "The global type 'JSX.{0}' may not have more than one property."),
	        JSX_spread_child_must_be_an_array_type: diag(2609, ts.DiagnosticCategory.Error, "JSX_spread_child_must_be_an_array_type_2609", "JSX spread child must be an array type."),
	        Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity: diag(2649, ts.DiagnosticCategory.Error, "Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity_2649", "Cannot augment module '{0}' with value exports because it resolves to a non-module entity."),
	        A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums: diag(2651, ts.DiagnosticCategory.Error, "A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_memb_2651", "A member initializer in a enum declaration cannot reference members declared after it, including members defined in other enums."),
	        Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead: diag(2652, ts.DiagnosticCategory.Error, "Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_d_2652", "Merged declaration '{0}' cannot include a default export declaration. Consider adding a separate 'export default {0}' declaration instead."),
	        Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1: diag(2653, ts.DiagnosticCategory.Error, "Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1_2653", "Non-abstract class expression does not implement inherited abstract member '{0}' from class '{1}'."),
	        Exported_external_package_typings_file_cannot_contain_tripleslash_references_Please_contact_the_package_author_to_update_the_package_definition: diag(2654, ts.DiagnosticCategory.Error, "Exported_external_package_typings_file_cannot_contain_tripleslash_references_Please_contact_the_pack_2654", "Exported external package typings file cannot contain tripleslash references. Please contact the package author to update the package definition."),
	        Exported_external_package_typings_file_0_is_not_a_module_Please_contact_the_package_author_to_update_the_package_definition: diag(2656, ts.DiagnosticCategory.Error, "Exported_external_package_typings_file_0_is_not_a_module_Please_contact_the_package_author_to_update_2656", "Exported external package typings file '{0}' is not a module. Please contact the package author to update the package definition."),
	        JSX_expressions_must_have_one_parent_element: diag(2657, ts.DiagnosticCategory.Error, "JSX_expressions_must_have_one_parent_element_2657", "JSX expressions must have one parent element."),
	        Type_0_provides_no_match_for_the_signature_1: diag(2658, ts.DiagnosticCategory.Error, "Type_0_provides_no_match_for_the_signature_1_2658", "Type '{0}' provides no match for the signature '{1}'."),
	        super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher: diag(2659, ts.DiagnosticCategory.Error, "super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_highe_2659", "'super' is only allowed in members of object literal expressions when option 'target' is 'ES2015' or higher."),
	        super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions: diag(2660, ts.DiagnosticCategory.Error, "super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions_2660", "'super' can only be referenced in members of derived classes or object literal expressions."),
	        Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module: diag(2661, ts.DiagnosticCategory.Error, "Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module_2661", "Cannot export '{0}'. Only local declarations can be exported from a module."),
	        Cannot_find_name_0_Did_you_mean_the_static_member_1_0: diag(2662, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_the_static_member_1_0_2662", "Cannot find name '{0}'. Did you mean the static member '{1}.{0}'?"),
	        Cannot_find_name_0_Did_you_mean_the_instance_member_this_0: diag(2663, ts.DiagnosticCategory.Error, "Cannot_find_name_0_Did_you_mean_the_instance_member_this_0_2663", "Cannot find name '{0}'. Did you mean the instance member 'this.{0}'?"),
	        Invalid_module_name_in_augmentation_module_0_cannot_be_found: diag(2664, ts.DiagnosticCategory.Error, "Invalid_module_name_in_augmentation_module_0_cannot_be_found_2664", "Invalid module name in augmentation, module '{0}' cannot be found."),
	        Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented: diag(2665, ts.DiagnosticCategory.Error, "Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augm_2665", "Invalid module name in augmentation. Module '{0}' resolves to an untyped module at '{1}', which cannot be augmented."),
	        Exports_and_export_assignments_are_not_permitted_in_module_augmentations: diag(2666, ts.DiagnosticCategory.Error, "Exports_and_export_assignments_are_not_permitted_in_module_augmentations_2666", "Exports and export assignments are not permitted in module augmentations."),
	        Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module: diag(2667, ts.DiagnosticCategory.Error, "Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_mod_2667", "Imports are not permitted in module augmentations. Consider moving them to the enclosing external module."),
	        export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible: diag(2668, ts.DiagnosticCategory.Error, "export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always__2668", "'export' modifier cannot be applied to ambient modules and module augmentations since they are always visible."),
	        Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations: diag(2669, ts.DiagnosticCategory.Error, "Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_2669", "Augmentations for the global scope can only be directly nested in external modules or ambient module declarations."),
	        Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context: diag(2670, ts.DiagnosticCategory.Error, "Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambien_2670", "Augmentations for the global scope should have 'declare' modifier unless they appear in already ambient context."),
	        Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity: diag(2671, ts.DiagnosticCategory.Error, "Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity_2671", "Cannot augment module '{0}' because it resolves to a non-module entity."),
	        Cannot_assign_a_0_constructor_type_to_a_1_constructor_type: diag(2672, ts.DiagnosticCategory.Error, "Cannot_assign_a_0_constructor_type_to_a_1_constructor_type_2672", "Cannot assign a '{0}' constructor type to a '{1}' constructor type."),
	        Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration: diag(2673, ts.DiagnosticCategory.Error, "Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration_2673", "Constructor of class '{0}' is private and only accessible within the class declaration."),
	        Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration: diag(2674, ts.DiagnosticCategory.Error, "Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration_2674", "Constructor of class '{0}' is protected and only accessible within the class declaration."),
	        Cannot_extend_a_class_0_Class_constructor_is_marked_as_private: diag(2675, ts.DiagnosticCategory.Error, "Cannot_extend_a_class_0_Class_constructor_is_marked_as_private_2675", "Cannot extend a class '{0}'. Class constructor is marked as private."),
	        Accessors_must_both_be_abstract_or_non_abstract: diag(2676, ts.DiagnosticCategory.Error, "Accessors_must_both_be_abstract_or_non_abstract_2676", "Accessors must both be abstract or non-abstract."),
	        A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type: diag(2677, ts.DiagnosticCategory.Error, "A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type_2677", "A type predicate's type must be assignable to its parameter's type."),
	        Type_0_is_not_comparable_to_type_1: diag(2678, ts.DiagnosticCategory.Error, "Type_0_is_not_comparable_to_type_1_2678", "Type '{0}' is not comparable to type '{1}'."),
	        A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void: diag(2679, ts.DiagnosticCategory.Error, "A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void_2679", "A function that is called with the 'new' keyword cannot have a 'this' type that is 'void'."),
	        A_0_parameter_must_be_the_first_parameter: diag(2680, ts.DiagnosticCategory.Error, "A_0_parameter_must_be_the_first_parameter_2680", "A '{0}' parameter must be the first parameter."),
	        A_constructor_cannot_have_a_this_parameter: diag(2681, ts.DiagnosticCategory.Error, "A_constructor_cannot_have_a_this_parameter_2681", "A constructor cannot have a 'this' parameter."),
	        get_and_set_accessor_must_have_the_same_this_type: diag(2682, ts.DiagnosticCategory.Error, "get_and_set_accessor_must_have_the_same_this_type_2682", "'get' and 'set' accessor must have the same 'this' type."),
	        this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation: diag(2683, ts.DiagnosticCategory.Error, "this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_2683", "'this' implicitly has type 'any' because it does not have a type annotation."),
	        The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1: diag(2684, ts.DiagnosticCategory.Error, "The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1_2684", "The 'this' context of type '{0}' is not assignable to method's 'this' of type '{1}'."),
	        The_this_types_of_each_signature_are_incompatible: diag(2685, ts.DiagnosticCategory.Error, "The_this_types_of_each_signature_are_incompatible_2685", "The 'this' types of each signature are incompatible."),
	        _0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead: diag(2686, ts.DiagnosticCategory.Error, "_0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead_2686", "'{0}' refers to a UMD global, but the current file is a module. Consider adding an import instead."),
	        All_declarations_of_0_must_have_identical_modifiers: diag(2687, ts.DiagnosticCategory.Error, "All_declarations_of_0_must_have_identical_modifiers_2687", "All declarations of '{0}' must have identical modifiers."),
	        Cannot_find_type_definition_file_for_0: diag(2688, ts.DiagnosticCategory.Error, "Cannot_find_type_definition_file_for_0_2688", "Cannot find type definition file for '{0}'."),
	        Cannot_extend_an_interface_0_Did_you_mean_implements: diag(2689, ts.DiagnosticCategory.Error, "Cannot_extend_an_interface_0_Did_you_mean_implements_2689", "Cannot extend an interface '{0}'. Did you mean 'implements'?"),
	        An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead: diag(2691, ts.DiagnosticCategory.Error, "An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead_2691", "An import path cannot end with a '{0}' extension. Consider importing '{1}' instead."),
	        _0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible: diag(2692, ts.DiagnosticCategory.Error, "_0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible_2692", "'{0}' is a primitive, but '{1}' is a wrapper object. Prefer using '{0}' when possible."),
	        _0_only_refers_to_a_type_but_is_being_used_as_a_value_here: diag(2693, ts.DiagnosticCategory.Error, "_0_only_refers_to_a_type_but_is_being_used_as_a_value_here_2693", "'{0}' only refers to a type, but is being used as a value here."),
	        Namespace_0_has_no_exported_member_1: diag(2694, ts.DiagnosticCategory.Error, "Namespace_0_has_no_exported_member_1_2694", "Namespace '{0}' has no exported member '{1}'."),
	        Left_side_of_comma_operator_is_unused_and_has_no_side_effects: diag(2695, ts.DiagnosticCategory.Error, "Left_side_of_comma_operator_is_unused_and_has_no_side_effects_2695", "Left side of comma operator is unused and has no side effects.", /*reportsUnnecessary*/ true),
	        The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead: diag(2696, ts.DiagnosticCategory.Error, "The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead_2696", "The 'Object' type is assignable to very few other types. Did you mean to use the 'any' type instead?"),
	        An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2697, ts.DiagnosticCategory.Error, "An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_in_2697", "An async function or method must return a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your `--lib` option."),
	        Spread_types_may_only_be_created_from_object_types: diag(2698, ts.DiagnosticCategory.Error, "Spread_types_may_only_be_created_from_object_types_2698", "Spread types may only be created from object types."),
	        Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1: diag(2699, ts.DiagnosticCategory.Error, "Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1_2699", "Static property '{0}' conflicts with built-in property 'Function.{0}' of constructor function '{1}'."),
	        Rest_types_may_only_be_created_from_object_types: diag(2700, ts.DiagnosticCategory.Error, "Rest_types_may_only_be_created_from_object_types_2700", "Rest types may only be created from object types."),
	        The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access: diag(2701, ts.DiagnosticCategory.Error, "The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access_2701", "The target of an object rest assignment must be a variable or a property access."),
	        _0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here: diag(2702, ts.DiagnosticCategory.Error, "_0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here_2702", "'{0}' only refers to a type, but is being used as a namespace here."),
	        The_operand_of_a_delete_operator_must_be_a_property_reference: diag(2703, ts.DiagnosticCategory.Error, "The_operand_of_a_delete_operator_must_be_a_property_reference_2703", "The operand of a delete operator must be a property reference."),
	        The_operand_of_a_delete_operator_cannot_be_a_read_only_property: diag(2704, ts.DiagnosticCategory.Error, "The_operand_of_a_delete_operator_cannot_be_a_read_only_property_2704", "The operand of a delete operator cannot be a read-only property."),
	        An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2705, ts.DiagnosticCategory.Error, "An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_de_2705", "An async function or method in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your `--lib` option."),
	        Required_type_parameters_may_not_follow_optional_type_parameters: diag(2706, ts.DiagnosticCategory.Error, "Required_type_parameters_may_not_follow_optional_type_parameters_2706", "Required type parameters may not follow optional type parameters."),
	        Generic_type_0_requires_between_1_and_2_type_arguments: diag(2707, ts.DiagnosticCategory.Error, "Generic_type_0_requires_between_1_and_2_type_arguments_2707", "Generic type '{0}' requires between {1} and {2} type arguments."),
	        Cannot_use_namespace_0_as_a_value: diag(2708, ts.DiagnosticCategory.Error, "Cannot_use_namespace_0_as_a_value_2708", "Cannot use namespace '{0}' as a value."),
	        Cannot_use_namespace_0_as_a_type: diag(2709, ts.DiagnosticCategory.Error, "Cannot_use_namespace_0_as_a_type_2709", "Cannot use namespace '{0}' as a type."),
	        _0_are_specified_twice_The_attribute_named_0_will_be_overwritten: diag(2710, ts.DiagnosticCategory.Error, "_0_are_specified_twice_The_attribute_named_0_will_be_overwritten_2710", "'{0}' are specified twice. The attribute named '{0}' will be overwritten."),
	        A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option: diag(2711, ts.DiagnosticCategory.Error, "A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES20_2711", "A dynamic import call returns a 'Promise'. Make sure you have a declaration for 'Promise' or include 'ES2015' in your `--lib` option."),
	        A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option: diag(2712, ts.DiagnosticCategory.Error, "A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declarat_2712", "A dynamic import call in ES5/ES3 requires the 'Promise' constructor.  Make sure you have a declaration for the 'Promise' constructor or include 'ES2015' in your `--lib` option."),
	        Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1: diag(2713, ts.DiagnosticCategory.Error, "Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_p_2713", "Cannot access '{0}.{1}' because '{0}' is a type, but not a namespace. Did you mean to retrieve the type of the property '{1}' in '{0}' with '{0}[\"{1}\"]'?"),
	        The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context: diag(2714, ts.DiagnosticCategory.Error, "The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context_2714", "The expression of an export assignment must be an identifier or qualified name in an ambient context."),
	        Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor: diag(2715, ts.DiagnosticCategory.Error, "Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor_2715", "Abstract property '{0}' in class '{1}' cannot be accessed in the constructor."),
	        Type_parameter_0_has_a_circular_default: diag(2716, ts.DiagnosticCategory.Error, "Type_parameter_0_has_a_circular_default_2716", "Type parameter '{0}' has a circular default."),
	        Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2: diag(2717, ts.DiagnosticCategory.Error, "Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_t_2717", "Subsequent property declarations must have the same type.  Property '{0}' must be of type '{1}', but here has type '{2}'."),
	        Duplicate_declaration_0: diag(2718, ts.DiagnosticCategory.Error, "Duplicate_declaration_0_2718", "Duplicate declaration '{0}'."),
	        Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated: diag(2719, ts.DiagnosticCategory.Error, "Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated_2719", "Type '{0}' is not assignable to type '{1}'. Two different types with this name exist, but they are unrelated."),
	        Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass: diag(2720, ts.DiagnosticCategory.Error, "Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclas_2720", "Class '{0}' incorrectly implements class '{1}'. Did you mean to extend '{1}' and inherit its members as a subclass?"),
	        Cannot_invoke_an_object_which_is_possibly_null: diag(2721, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_null_2721", "Cannot invoke an object which is possibly 'null'."),
	        Cannot_invoke_an_object_which_is_possibly_undefined: diag(2722, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_undefined_2722", "Cannot invoke an object which is possibly 'undefined'."),
	        Cannot_invoke_an_object_which_is_possibly_null_or_undefined: diag(2723, ts.DiagnosticCategory.Error, "Cannot_invoke_an_object_which_is_possibly_null_or_undefined_2723", "Cannot invoke an object which is possibly 'null' or 'undefined'."),
	        Module_0_has_no_exported_member_1_Did_you_mean_2: diag(2724, ts.DiagnosticCategory.Error, "Module_0_has_no_exported_member_1_Did_you_mean_2_2724", "Module '{0}' has no exported member '{1}'. Did you mean '{2}'?"),
	        Import_declaration_0_is_using_private_name_1: diag(4000, ts.DiagnosticCategory.Error, "Import_declaration_0_is_using_private_name_1_4000", "Import declaration '{0}' is using private name '{1}'."),
	        Type_parameter_0_of_exported_class_has_or_is_using_private_name_1: diag(4002, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_class_has_or_is_using_private_name_1_4002", "Type parameter '{0}' of exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1: diag(4004, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1_4004", "Type parameter '{0}' of exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4006, ts.DiagnosticCategory.Error, "Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4006", "Type parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4008, ts.DiagnosticCategory.Error, "Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4008", "Type parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4010, ts.DiagnosticCategory.Error, "Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4010", "Type parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4012, ts.DiagnosticCategory.Error, "Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4012", "Type parameter '{0}' of public method from exported class has or is using private name '{1}'."),
	        Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4014, ts.DiagnosticCategory.Error, "Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4014", "Type parameter '{0}' of method from exported interface has or is using private name '{1}'."),
	        Type_parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4016, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_function_has_or_is_using_private_name_1_4016", "Type parameter '{0}' of exported function has or is using private name '{1}'."),
	        Implements_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4019, ts.DiagnosticCategory.Error, "Implements_clause_of_exported_class_0_has_or_is_using_private_name_1_4019", "Implements clause of exported class '{0}' has or is using private name '{1}'."),
	        extends_clause_of_exported_class_0_has_or_is_using_private_name_1: diag(4020, ts.DiagnosticCategory.Error, "extends_clause_of_exported_class_0_has_or_is_using_private_name_1_4020", "'extends' clause of exported class '{0}' has or is using private name '{1}'."),
	        extends_clause_of_exported_interface_0_has_or_is_using_private_name_1: diag(4022, ts.DiagnosticCategory.Error, "extends_clause_of_exported_interface_0_has_or_is_using_private_name_1_4022", "'extends' clause of exported interface '{0}' has or is using private name '{1}'."),
	        Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4023, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4023", "Exported variable '{0}' has or is using name '{1}' from external module {2} but cannot be named."),
	        Exported_variable_0_has_or_is_using_name_1_from_private_module_2: diag(4024, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_name_1_from_private_module_2_4024", "Exported variable '{0}' has or is using name '{1}' from private module '{2}'."),
	        Exported_variable_0_has_or_is_using_private_name_1: diag(4025, ts.DiagnosticCategory.Error, "Exported_variable_0_has_or_is_using_private_name_1_4025", "Exported variable '{0}' has or is using private name '{1}'."),
	        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4026, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot__4026", "Public static property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4027, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4027", "Public static property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_static_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4028, ts.DiagnosticCategory.Error, "Public_static_property_0_of_exported_class_has_or_is_using_private_name_1_4028", "Public static property '{0}' of exported class has or is using private name '{1}'."),
	        Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4029, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_name_4029", "Public property '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4030, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4030", "Public property '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_property_0_of_exported_class_has_or_is_using_private_name_1: diag(4031, ts.DiagnosticCategory.Error, "Public_property_0_of_exported_class_has_or_is_using_private_name_1_4031", "Public property '{0}' of exported class has or is using private name '{1}'."),
	        Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4032, ts.DiagnosticCategory.Error, "Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4032", "Property '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
	        Property_0_of_exported_interface_has_or_is_using_private_name_1: diag(4033, ts.DiagnosticCategory.Error, "Property_0_of_exported_interface_has_or_is_using_private_name_1_4033", "Property '{0}' of exported interface has or is using private name '{1}'."),
	        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4034, ts.DiagnosticCategory.Error, "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_mod_4034", "Parameter type of public static setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4035, ts.DiagnosticCategory.Error, "Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1_4035", "Parameter type of public static setter '{0}' from exported class has or is using private name '{1}'."),
	        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4036, ts.DiagnosticCategory.Error, "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4036", "Parameter type of public setter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1: diag(4037, ts.DiagnosticCategory.Error, "Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1_4037", "Parameter type of public setter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4038, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_modul_4038", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4039, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_4039", "Return type of public static getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4040, ts.DiagnosticCategory.Error, "Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1_4040", "Return type of public static getter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4041, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_4041", "Return type of public getter '{0}' from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4042, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2_4042", "Return type of public getter '{0}' from exported class has or is using name '{1}' from private module '{2}'."),
	        Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1: diag(4043, ts.DiagnosticCategory.Error, "Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1_4043", "Return type of public getter '{0}' from exported class has or is using private name '{1}'."),
	        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4044, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_mod_4044", "Return type of constructor signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4045, ts.DiagnosticCategory.Error, "Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0_4045", "Return type of constructor signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4046, ts.DiagnosticCategory.Error, "Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4046", "Return type of call signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4047, ts.DiagnosticCategory.Error, "Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0_4047", "Return type of call signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4048, ts.DiagnosticCategory.Error, "Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4048", "Return type of index signature from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0: diag(4049, ts.DiagnosticCategory.Error, "Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0_4049", "Return type of index signature from exported interface has or is using private name '{0}'."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4050, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module__4050", "Return type of public static method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4051, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4051", "Return type of public static method from exported class has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0: diag(4052, ts.DiagnosticCategory.Error, "Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0_4052", "Return type of public static method from exported class has or is using private name '{0}'."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4053, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_c_4053", "Return type of public method from exported class has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1: diag(4054, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1_4054", "Return type of public method from exported class has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0: diag(4055, ts.DiagnosticCategory.Error, "Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0_4055", "Return type of public method from exported class has or is using private name '{0}'."),
	        Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1: diag(4056, ts.DiagnosticCategory.Error, "Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1_4056", "Return type of method from exported interface has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0: diag(4057, ts.DiagnosticCategory.Error, "Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0_4057", "Return type of method from exported interface has or is using private name '{0}'."),
	        Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named: diag(4058, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named_4058", "Return type of exported function has or is using name '{0}' from external module {1} but cannot be named."),
	        Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1: diag(4059, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1_4059", "Return type of exported function has or is using name '{0}' from private module '{1}'."),
	        Return_type_of_exported_function_has_or_is_using_private_name_0: diag(4060, ts.DiagnosticCategory.Error, "Return_type_of_exported_function_has_or_is_using_private_name_0_4060", "Return type of exported function has or is using private name '{0}'."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4061, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_can_4061", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4062, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2_4062", "Parameter '{0}' of constructor from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1: diag(4063, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1_4063", "Parameter '{0}' of constructor from exported class has or is using private name '{1}'."),
	        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4064, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_mod_4064", "Parameter '{0}' of constructor signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4065, ts.DiagnosticCategory.Error, "Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1_4065", "Parameter '{0}' of constructor signature from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4066, ts.DiagnosticCategory.Error, "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4066", "Parameter '{0}' of call signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4067, ts.DiagnosticCategory.Error, "Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1_4067", "Parameter '{0}' of call signature from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4068, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module__4068", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4069, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4069", "Parameter '{0}' of public static method from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1: diag(4070, ts.DiagnosticCategory.Error, "Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1_4070", "Parameter '{0}' of public static method from exported class has or is using private name '{1}'."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4071, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_c_4071", "Parameter '{0}' of public method from exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4072, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2_4072", "Parameter '{0}' of public method from exported class has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1: diag(4073, ts.DiagnosticCategory.Error, "Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1_4073", "Parameter '{0}' of public method from exported class has or is using private name '{1}'."),
	        Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4074, ts.DiagnosticCategory.Error, "Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4074", "Parameter '{0}' of method from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1: diag(4075, ts.DiagnosticCategory.Error, "Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1_4075", "Parameter '{0}' of method from exported interface has or is using private name '{1}'."),
	        Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4076, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4076", "Parameter '{0}' of exported function has or is using name '{1}' from external module {2} but cannot be named."),
	        Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2: diag(4077, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2_4077", "Parameter '{0}' of exported function has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_exported_function_has_or_is_using_private_name_1: diag(4078, ts.DiagnosticCategory.Error, "Parameter_0_of_exported_function_has_or_is_using_private_name_1_4078", "Parameter '{0}' of exported function has or is using private name '{1}'."),
	        Exported_type_alias_0_has_or_is_using_private_name_1: diag(4081, ts.DiagnosticCategory.Error, "Exported_type_alias_0_has_or_is_using_private_name_1_4081", "Exported type alias '{0}' has or is using private name '{1}'."),
	        Default_export_of_the_module_has_or_is_using_private_name_0: diag(4082, ts.DiagnosticCategory.Error, "Default_export_of_the_module_has_or_is_using_private_name_0_4082", "Default export of the module has or is using private name '{0}'."),
	        Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1: diag(4083, ts.DiagnosticCategory.Error, "Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1_4083", "Type parameter '{0}' of exported type alias has or is using private name '{1}'."),
	        Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict: diag(4090, ts.DiagnosticCategory.Error, "Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_librar_4090", "Conflicting definitions for '{0}' found at '{1}' and '{2}'. Consider installing a specific version of this library to resolve the conflict."),
	        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4091, ts.DiagnosticCategory.Error, "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2_4091", "Parameter '{0}' of index signature from exported interface has or is using name '{1}' from private module '{2}'."),
	        Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1: diag(4092, ts.DiagnosticCategory.Error, "Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1_4092", "Parameter '{0}' of index signature from exported interface has or is using private name '{1}'."),
	        Property_0_of_exported_class_expression_may_not_be_private_or_protected: diag(4094, ts.DiagnosticCategory.Error, "Property_0_of_exported_class_expression_may_not_be_private_or_protected_4094", "Property '{0}' of exported class expression may not be private or protected."),
	        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4095, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_4095", "Public static method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4096, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4096", "Public static method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_static_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4097, ts.DiagnosticCategory.Error, "Public_static_method_0_of_exported_class_has_or_is_using_private_name_1_4097", "Public static method '{0}' of exported class has or is using private name '{1}'."),
	        Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named: diag(4098, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named_4098", "Public method '{0}' of exported class has or is using name '{1}' from external module {2} but cannot be named."),
	        Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2: diag(4099, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2_4099", "Public method '{0}' of exported class has or is using name '{1}' from private module '{2}'."),
	        Public_method_0_of_exported_class_has_or_is_using_private_name_1: diag(4100, ts.DiagnosticCategory.Error, "Public_method_0_of_exported_class_has_or_is_using_private_name_1_4100", "Public method '{0}' of exported class has or is using private name '{1}'."),
	        Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2: diag(4101, ts.DiagnosticCategory.Error, "Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2_4101", "Method '{0}' of exported interface has or is using name '{1}' from private module '{2}'."),
	        Method_0_of_exported_interface_has_or_is_using_private_name_1: diag(4102, ts.DiagnosticCategory.Error, "Method_0_of_exported_interface_has_or_is_using_private_name_1_4102", "Method '{0}' of exported interface has or is using private name '{1}'."),
	        The_current_host_does_not_support_the_0_option: diag(5001, ts.DiagnosticCategory.Error, "The_current_host_does_not_support_the_0_option_5001", "The current host does not support the '{0}' option."),
	        Cannot_find_the_common_subdirectory_path_for_the_input_files: diag(5009, ts.DiagnosticCategory.Error, "Cannot_find_the_common_subdirectory_path_for_the_input_files_5009", "Cannot find the common subdirectory path for the input files."),
	        File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5010, ts.DiagnosticCategory.Error, "File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0_5010", "File specification cannot end in a recursive directory wildcard ('**'): '{0}'."),
	        Cannot_read_file_0_Colon_1: diag(5012, ts.DiagnosticCategory.Error, "Cannot_read_file_0_Colon_1_5012", "Cannot read file '{0}': {1}."),
	        Failed_to_parse_file_0_Colon_1: diag(5014, ts.DiagnosticCategory.Error, "Failed_to_parse_file_0_Colon_1_5014", "Failed to parse file '{0}': {1}."),
	        Unknown_compiler_option_0: diag(5023, ts.DiagnosticCategory.Error, "Unknown_compiler_option_0_5023", "Unknown compiler option '{0}'."),
	        Compiler_option_0_requires_a_value_of_type_1: diag(5024, ts.DiagnosticCategory.Error, "Compiler_option_0_requires_a_value_of_type_1_5024", "Compiler option '{0}' requires a value of type {1}."),
	        Could_not_write_file_0_Colon_1: diag(5033, ts.DiagnosticCategory.Error, "Could_not_write_file_0_Colon_1_5033", "Could not write file '{0}': {1}."),
	        Option_project_cannot_be_mixed_with_source_files_on_a_command_line: diag(5042, ts.DiagnosticCategory.Error, "Option_project_cannot_be_mixed_with_source_files_on_a_command_line_5042", "Option 'project' cannot be mixed with source files on a command line."),
	        Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher: diag(5047, ts.DiagnosticCategory.Error, "Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES_5047", "Option 'isolatedModules' can only be used when either option '--module' is provided or option 'target' is 'ES2015' or higher."),
	        Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided: diag(5051, ts.DiagnosticCategory.Error, "Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided_5051", "Option '{0} can only be used when either option '--inlineSourceMap' or option '--sourceMap' is provided."),
	        Option_0_cannot_be_specified_without_specifying_option_1: diag(5052, ts.DiagnosticCategory.Error, "Option_0_cannot_be_specified_without_specifying_option_1_5052", "Option '{0}' cannot be specified without specifying option '{1}'."),
	        Option_0_cannot_be_specified_with_option_1: diag(5053, ts.DiagnosticCategory.Error, "Option_0_cannot_be_specified_with_option_1_5053", "Option '{0}' cannot be specified with option '{1}'."),
	        A_tsconfig_json_file_is_already_defined_at_Colon_0: diag(5054, ts.DiagnosticCategory.Error, "A_tsconfig_json_file_is_already_defined_at_Colon_0_5054", "A 'tsconfig.json' file is already defined at: '{0}'."),
	        Cannot_write_file_0_because_it_would_overwrite_input_file: diag(5055, ts.DiagnosticCategory.Error, "Cannot_write_file_0_because_it_would_overwrite_input_file_5055", "Cannot write file '{0}' because it would overwrite input file."),
	        Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files: diag(5056, ts.DiagnosticCategory.Error, "Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files_5056", "Cannot write file '{0}' because it would be overwritten by multiple input files."),
	        Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0: diag(5057, ts.DiagnosticCategory.Error, "Cannot_find_a_tsconfig_json_file_at_the_specified_directory_Colon_0_5057", "Cannot find a tsconfig.json file at the specified directory: '{0}'."),
	        The_specified_path_does_not_exist_Colon_0: diag(5058, ts.DiagnosticCategory.Error, "The_specified_path_does_not_exist_Colon_0_5058", "The specified path does not exist: '{0}'."),
	        Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier: diag(5059, ts.DiagnosticCategory.Error, "Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier_5059", "Invalid value for '--reactNamespace'. '{0}' is not a valid identifier."),
	        Option_paths_cannot_be_used_without_specifying_baseUrl_option: diag(5060, ts.DiagnosticCategory.Error, "Option_paths_cannot_be_used_without_specifying_baseUrl_option_5060", "Option 'paths' cannot be used without specifying '--baseUrl' option."),
	        Pattern_0_can_have_at_most_one_Asterisk_character: diag(5061, ts.DiagnosticCategory.Error, "Pattern_0_can_have_at_most_one_Asterisk_character_5061", "Pattern '{0}' can have at most one '*' character."),
	        Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character: diag(5062, ts.DiagnosticCategory.Error, "Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character_5062", "Substitution '{0}' in pattern '{1}' in can have at most one '*' character."),
	        Substitutions_for_pattern_0_should_be_an_array: diag(5063, ts.DiagnosticCategory.Error, "Substitutions_for_pattern_0_should_be_an_array_5063", "Substitutions for pattern '{0}' should be an array."),
	        Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2: diag(5064, ts.DiagnosticCategory.Error, "Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2_5064", "Substitution '{0}' for pattern '{1}' has incorrect type, expected 'string', got '{2}'."),
	        File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0: diag(5065, ts.DiagnosticCategory.Error, "File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildca_5065", "File specification cannot contain a parent directory ('..') that appears after a recursive directory wildcard ('**'): '{0}'."),
	        Substitutions_for_pattern_0_shouldn_t_be_an_empty_array: diag(5066, ts.DiagnosticCategory.Error, "Substitutions_for_pattern_0_shouldn_t_be_an_empty_array_5066", "Substitutions for pattern '{0}' shouldn't be an empty array."),
	        Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name: diag(5067, ts.DiagnosticCategory.Error, "Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name_5067", "Invalid value for 'jsxFactory'. '{0}' is not a valid identifier or qualified-name."),
	        Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig: diag(5068, ts.DiagnosticCategory.Error, "Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript__5068", "Adding a tsconfig.json file will help organize projects that contain both TypeScript and JavaScript files. Learn more at https://aka.ms/tsconfig."),
	        Option_0_cannot_be_specified_without_specifying_option_1_or_option_2: diag(5069, ts.DiagnosticCategory.Error, "Option_0_cannot_be_specified_without_specifying_option_1_or_option_2_5069", "Option '{0}' cannot be specified without specifying option '{1}' or option '{2}'."),
	        Option_resolveJsonModule_cannot_be_specified_without_node_module_resolution_strategy: diag(5070, ts.DiagnosticCategory.Error, "Option_resolveJsonModule_cannot_be_specified_without_node_module_resolution_strategy_5070", "Option '--resolveJsonModule' cannot be specified without 'node' module resolution strategy."),
	        Generates_a_sourcemap_for_each_corresponding_d_ts_file: diag(6000, ts.DiagnosticCategory.Message, "Generates_a_sourcemap_for_each_corresponding_d_ts_file_6000", "Generates a sourcemap for each corresponding '.d.ts' file."),
	        Concatenate_and_emit_output_to_single_file: diag(6001, ts.DiagnosticCategory.Message, "Concatenate_and_emit_output_to_single_file_6001", "Concatenate and emit output to single file."),
	        Generates_corresponding_d_ts_file: diag(6002, ts.DiagnosticCategory.Message, "Generates_corresponding_d_ts_file_6002", "Generates corresponding '.d.ts' file."),
	        Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations: diag(6003, ts.DiagnosticCategory.Message, "Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations_6003", "Specify the location where debugger should locate map files instead of generated locations."),
	        Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations: diag(6004, ts.DiagnosticCategory.Message, "Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations_6004", "Specify the location where debugger should locate TypeScript files instead of source locations."),
	        Watch_input_files: diag(6005, ts.DiagnosticCategory.Message, "Watch_input_files_6005", "Watch input files."),
	        Redirect_output_structure_to_the_directory: diag(6006, ts.DiagnosticCategory.Message, "Redirect_output_structure_to_the_directory_6006", "Redirect output structure to the directory."),
	        Do_not_erase_const_enum_declarations_in_generated_code: diag(6007, ts.DiagnosticCategory.Message, "Do_not_erase_const_enum_declarations_in_generated_code_6007", "Do not erase const enum declarations in generated code."),
	        Do_not_emit_outputs_if_any_errors_were_reported: diag(6008, ts.DiagnosticCategory.Message, "Do_not_emit_outputs_if_any_errors_were_reported_6008", "Do not emit outputs if any errors were reported."),
	        Do_not_emit_comments_to_output: diag(6009, ts.DiagnosticCategory.Message, "Do_not_emit_comments_to_output_6009", "Do not emit comments to output."),
	        Do_not_emit_outputs: diag(6010, ts.DiagnosticCategory.Message, "Do_not_emit_outputs_6010", "Do not emit outputs."),
	        Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking: diag(6011, ts.DiagnosticCategory.Message, "Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typech_6011", "Allow default imports from modules with no default export. This does not affect code emit, just typechecking."),
	        Skip_type_checking_of_declaration_files: diag(6012, ts.DiagnosticCategory.Message, "Skip_type_checking_of_declaration_files_6012", "Skip type checking of declaration files."),
	        Do_not_resolve_the_real_path_of_symlinks: diag(6013, ts.DiagnosticCategory.Message, "Do_not_resolve_the_real_path_of_symlinks_6013", "Do not resolve the real path of symlinks."),
	        Only_emit_d_ts_declaration_files: diag(6014, ts.DiagnosticCategory.Message, "Only_emit_d_ts_declaration_files_6014", "Only emit '.d.ts' declaration files."),
	        Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT: diag(6015, ts.DiagnosticCategory.Message, "Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT_6015", "Specify ECMAScript target version: 'ES3' (default), 'ES5', 'ES2015', 'ES2016', 'ES2017','ES2018' or 'ESNEXT'."),
	        Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext: diag(6016, ts.DiagnosticCategory.Message, "Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext_6016", "Specify module code generation: 'none', 'commonjs', 'amd', 'system', 'umd', 'es2015', or 'ESNext'."),
	        Print_this_message: diag(6017, ts.DiagnosticCategory.Message, "Print_this_message_6017", "Print this message."),
	        Print_the_compiler_s_version: diag(6019, ts.DiagnosticCategory.Message, "Print_the_compiler_s_version_6019", "Print the compiler's version."),
	        Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json: diag(6020, ts.DiagnosticCategory.Message, "Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json_6020", "Compile the project given the path to its configuration file, or to a folder with a 'tsconfig.json'."),
	        Syntax_Colon_0: diag(6023, ts.DiagnosticCategory.Message, "Syntax_Colon_0_6023", "Syntax: {0}"),
	        options: diag(6024, ts.DiagnosticCategory.Message, "options_6024", "options"),
	        file: diag(6025, ts.DiagnosticCategory.Message, "file_6025", "file"),
	        Examples_Colon_0: diag(6026, ts.DiagnosticCategory.Message, "Examples_Colon_0_6026", "Examples: {0}"),
	        Options_Colon: diag(6027, ts.DiagnosticCategory.Message, "Options_Colon_6027", "Options:"),
	        Version_0: diag(6029, ts.DiagnosticCategory.Message, "Version_0_6029", "Version {0}"),
	        Insert_command_line_options_and_files_from_a_file: diag(6030, ts.DiagnosticCategory.Message, "Insert_command_line_options_and_files_from_a_file_6030", "Insert command line options and files from a file."),
	        Starting_compilation_in_watch_mode: diag(6031, ts.DiagnosticCategory.Message, "Starting_compilation_in_watch_mode_6031", "Starting compilation in watch mode..."),
	        File_change_detected_Starting_incremental_compilation: diag(6032, ts.DiagnosticCategory.Message, "File_change_detected_Starting_incremental_compilation_6032", "File change detected. Starting incremental compilation..."),
	        KIND: diag(6034, ts.DiagnosticCategory.Message, "KIND_6034", "KIND"),
	        FILE: diag(6035, ts.DiagnosticCategory.Message, "FILE_6035", "FILE"),
	        VERSION: diag(6036, ts.DiagnosticCategory.Message, "VERSION_6036", "VERSION"),
	        LOCATION: diag(6037, ts.DiagnosticCategory.Message, "LOCATION_6037", "LOCATION"),
	        DIRECTORY: diag(6038, ts.DiagnosticCategory.Message, "DIRECTORY_6038", "DIRECTORY"),
	        STRATEGY: diag(6039, ts.DiagnosticCategory.Message, "STRATEGY_6039", "STRATEGY"),
	        FILE_OR_DIRECTORY: diag(6040, ts.DiagnosticCategory.Message, "FILE_OR_DIRECTORY_6040", "FILE OR DIRECTORY"),
	        Generates_corresponding_map_file: diag(6043, ts.DiagnosticCategory.Message, "Generates_corresponding_map_file_6043", "Generates corresponding '.map' file."),
	        Compiler_option_0_expects_an_argument: diag(6044, ts.DiagnosticCategory.Error, "Compiler_option_0_expects_an_argument_6044", "Compiler option '{0}' expects an argument."),
	        Unterminated_quoted_string_in_response_file_0: diag(6045, ts.DiagnosticCategory.Error, "Unterminated_quoted_string_in_response_file_0_6045", "Unterminated quoted string in response file '{0}'."),
	        Argument_for_0_option_must_be_Colon_1: diag(6046, ts.DiagnosticCategory.Error, "Argument_for_0_option_must_be_Colon_1_6046", "Argument for '{0}' option must be: {1}."),
	        Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1: diag(6048, ts.DiagnosticCategory.Error, "Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1_6048", "Locale must be of the form <language> or <language>-<territory>. For example '{0}' or '{1}'."),
	        Unsupported_locale_0: diag(6049, ts.DiagnosticCategory.Error, "Unsupported_locale_0_6049", "Unsupported locale '{0}'."),
	        Unable_to_open_file_0: diag(6050, ts.DiagnosticCategory.Error, "Unable_to_open_file_0_6050", "Unable to open file '{0}'."),
	        Corrupted_locale_file_0: diag(6051, ts.DiagnosticCategory.Error, "Corrupted_locale_file_0_6051", "Corrupted locale file {0}."),
	        Raise_error_on_expressions_and_declarations_with_an_implied_any_type: diag(6052, ts.DiagnosticCategory.Message, "Raise_error_on_expressions_and_declarations_with_an_implied_any_type_6052", "Raise error on expressions and declarations with an implied 'any' type."),
	        File_0_not_found: diag(6053, ts.DiagnosticCategory.Error, "File_0_not_found_6053", "File '{0}' not found."),
	        File_0_has_unsupported_extension_The_only_supported_extensions_are_1: diag(6054, ts.DiagnosticCategory.Error, "File_0_has_unsupported_extension_The_only_supported_extensions_are_1_6054", "File '{0}' has unsupported extension. The only supported extensions are {1}."),
	        Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures: diag(6055, ts.DiagnosticCategory.Message, "Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures_6055", "Suppress noImplicitAny errors for indexing objects lacking index signatures."),
	        Do_not_emit_declarations_for_code_that_has_an_internal_annotation: diag(6056, ts.DiagnosticCategory.Message, "Do_not_emit_declarations_for_code_that_has_an_internal_annotation_6056", "Do not emit declarations for code that has an '@internal' annotation."),
	        Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir: diag(6058, ts.DiagnosticCategory.Message, "Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir_6058", "Specify the root directory of input files. Use to control the output directory structure with --outDir."),
	        File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files: diag(6059, ts.DiagnosticCategory.Error, "File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files_6059", "File '{0}' is not under 'rootDir' '{1}'. 'rootDir' is expected to contain all source files."),
	        Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix: diag(6060, ts.DiagnosticCategory.Message, "Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix_6060", "Specify the end of line sequence to be used when emitting files: 'CRLF' (dos) or 'LF' (unix)."),
	        NEWLINE: diag(6061, ts.DiagnosticCategory.Message, "NEWLINE_6061", "NEWLINE"),
	        Option_0_can_only_be_specified_in_tsconfig_json_file: diag(6064, ts.DiagnosticCategory.Error, "Option_0_can_only_be_specified_in_tsconfig_json_file_6064", "Option '{0}' can only be specified in 'tsconfig.json' file."),
	        Enables_experimental_support_for_ES7_decorators: diag(6065, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_ES7_decorators_6065", "Enables experimental support for ES7 decorators."),
	        Enables_experimental_support_for_emitting_type_metadata_for_decorators: diag(6066, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_emitting_type_metadata_for_decorators_6066", "Enables experimental support for emitting type metadata for decorators."),
	        Enables_experimental_support_for_ES7_async_functions: diag(6068, ts.DiagnosticCategory.Message, "Enables_experimental_support_for_ES7_async_functions_6068", "Enables experimental support for ES7 async functions."),
	        Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6: diag(6069, ts.DiagnosticCategory.Message, "Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6_6069", "Specify module resolution strategy: 'node' (Node.js) or 'classic' (TypeScript pre-1.6)."),
	        Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file: diag(6070, ts.DiagnosticCategory.Message, "Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file_6070", "Initializes a TypeScript project and creates a tsconfig.json file."),
	        Successfully_created_a_tsconfig_json_file: diag(6071, ts.DiagnosticCategory.Message, "Successfully_created_a_tsconfig_json_file_6071", "Successfully created a tsconfig.json file."),
	        Suppress_excess_property_checks_for_object_literals: diag(6072, ts.DiagnosticCategory.Message, "Suppress_excess_property_checks_for_object_literals_6072", "Suppress excess property checks for object literals."),
	        Stylize_errors_and_messages_using_color_and_context_experimental: diag(6073, ts.DiagnosticCategory.Message, "Stylize_errors_and_messages_using_color_and_context_experimental_6073", "Stylize errors and messages using color and context (experimental)."),
	        Do_not_report_errors_on_unused_labels: diag(6074, ts.DiagnosticCategory.Message, "Do_not_report_errors_on_unused_labels_6074", "Do not report errors on unused labels."),
	        Report_error_when_not_all_code_paths_in_function_return_a_value: diag(6075, ts.DiagnosticCategory.Message, "Report_error_when_not_all_code_paths_in_function_return_a_value_6075", "Report error when not all code paths in function return a value."),
	        Report_errors_for_fallthrough_cases_in_switch_statement: diag(6076, ts.DiagnosticCategory.Message, "Report_errors_for_fallthrough_cases_in_switch_statement_6076", "Report errors for fallthrough cases in switch statement."),
	        Do_not_report_errors_on_unreachable_code: diag(6077, ts.DiagnosticCategory.Message, "Do_not_report_errors_on_unreachable_code_6077", "Do not report errors on unreachable code."),
	        Disallow_inconsistently_cased_references_to_the_same_file: diag(6078, ts.DiagnosticCategory.Message, "Disallow_inconsistently_cased_references_to_the_same_file_6078", "Disallow inconsistently-cased references to the same file."),
	        Specify_library_files_to_be_included_in_the_compilation: diag(6079, ts.DiagnosticCategory.Message, "Specify_library_files_to_be_included_in_the_compilation_6079", "Specify library files to be included in the compilation."),
	        Specify_JSX_code_generation_Colon_preserve_react_native_or_react: diag(6080, ts.DiagnosticCategory.Message, "Specify_JSX_code_generation_Colon_preserve_react_native_or_react_6080", "Specify JSX code generation: 'preserve', 'react-native', or 'react'."),
	        File_0_has_an_unsupported_extension_so_skipping_it: diag(6081, ts.DiagnosticCategory.Message, "File_0_has_an_unsupported_extension_so_skipping_it_6081", "File '{0}' has an unsupported extension, so skipping it."),
	        Only_amd_and_system_modules_are_supported_alongside_0: diag(6082, ts.DiagnosticCategory.Error, "Only_amd_and_system_modules_are_supported_alongside_0_6082", "Only 'amd' and 'system' modules are supported alongside --{0}."),
	        Base_directory_to_resolve_non_absolute_module_names: diag(6083, ts.DiagnosticCategory.Message, "Base_directory_to_resolve_non_absolute_module_names_6083", "Base directory to resolve non-absolute module names."),
	        Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit: diag(6084, ts.DiagnosticCategory.Message, "Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react__6084", "[Deprecated] Use '--jsxFactory' instead. Specify the object invoked for createElement when targeting 'react' JSX emit"),
	        Enable_tracing_of_the_name_resolution_process: diag(6085, ts.DiagnosticCategory.Message, "Enable_tracing_of_the_name_resolution_process_6085", "Enable tracing of the name resolution process."),
	        Resolving_module_0_from_1: diag(6086, ts.DiagnosticCategory.Message, "Resolving_module_0_from_1_6086", "======== Resolving module '{0}' from '{1}'. ========"),
	        Explicitly_specified_module_resolution_kind_Colon_0: diag(6087, ts.DiagnosticCategory.Message, "Explicitly_specified_module_resolution_kind_Colon_0_6087", "Explicitly specified module resolution kind: '{0}'."),
	        Module_resolution_kind_is_not_specified_using_0: diag(6088, ts.DiagnosticCategory.Message, "Module_resolution_kind_is_not_specified_using_0_6088", "Module resolution kind is not specified, using '{0}'."),
	        Module_name_0_was_successfully_resolved_to_1: diag(6089, ts.DiagnosticCategory.Message, "Module_name_0_was_successfully_resolved_to_1_6089", "======== Module name '{0}' was successfully resolved to '{1}'. ========"),
	        Module_name_0_was_not_resolved: diag(6090, ts.DiagnosticCategory.Message, "Module_name_0_was_not_resolved_6090", "======== Module name '{0}' was not resolved. ========"),
	        paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0: diag(6091, ts.DiagnosticCategory.Message, "paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0_6091", "'paths' option is specified, looking for a pattern to match module name '{0}'."),
	        Module_name_0_matched_pattern_1: diag(6092, ts.DiagnosticCategory.Message, "Module_name_0_matched_pattern_1_6092", "Module name '{0}', matched pattern '{1}'."),
	        Trying_substitution_0_candidate_module_location_Colon_1: diag(6093, ts.DiagnosticCategory.Message, "Trying_substitution_0_candidate_module_location_Colon_1_6093", "Trying substitution '{0}', candidate module location: '{1}'."),
	        Resolving_module_name_0_relative_to_base_url_1_2: diag(6094, ts.DiagnosticCategory.Message, "Resolving_module_name_0_relative_to_base_url_1_2_6094", "Resolving module name '{0}' relative to base url '{1}' - '{2}'."),
	        Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1: diag(6095, ts.DiagnosticCategory.Message, "Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1_6095", "Loading module as file / folder, candidate module location '{0}', target file type '{1}'."),
	        File_0_does_not_exist: diag(6096, ts.DiagnosticCategory.Message, "File_0_does_not_exist_6096", "File '{0}' does not exist."),
	        File_0_exist_use_it_as_a_name_resolution_result: diag(6097, ts.DiagnosticCategory.Message, "File_0_exist_use_it_as_a_name_resolution_result_6097", "File '{0}' exist - use it as a name resolution result."),
	        Loading_module_0_from_node_modules_folder_target_file_type_1: diag(6098, ts.DiagnosticCategory.Message, "Loading_module_0_from_node_modules_folder_target_file_type_1_6098", "Loading module '{0}' from 'node_modules' folder, target file type '{1}'."),
	        Found_package_json_at_0: diag(6099, ts.DiagnosticCategory.Message, "Found_package_json_at_0_6099", "Found 'package.json' at '{0}'."),
	        package_json_does_not_have_a_0_field: diag(6100, ts.DiagnosticCategory.Message, "package_json_does_not_have_a_0_field_6100", "'package.json' does not have a '{0}' field."),
	        package_json_has_0_field_1_that_references_2: diag(6101, ts.DiagnosticCategory.Message, "package_json_has_0_field_1_that_references_2_6101", "'package.json' has '{0}' field '{1}' that references '{2}'."),
	        Allow_javascript_files_to_be_compiled: diag(6102, ts.DiagnosticCategory.Message, "Allow_javascript_files_to_be_compiled_6102", "Allow javascript files to be compiled."),
	        Option_0_should_have_array_of_strings_as_a_value: diag(6103, ts.DiagnosticCategory.Error, "Option_0_should_have_array_of_strings_as_a_value_6103", "Option '{0}' should have array of strings as a value."),
	        Checking_if_0_is_the_longest_matching_prefix_for_1_2: diag(6104, ts.DiagnosticCategory.Message, "Checking_if_0_is_the_longest_matching_prefix_for_1_2_6104", "Checking if '{0}' is the longest matching prefix for '{1}' - '{2}'."),
	        Expected_type_of_0_field_in_package_json_to_be_string_got_1: diag(6105, ts.DiagnosticCategory.Message, "Expected_type_of_0_field_in_package_json_to_be_string_got_1_6105", "Expected type of '{0}' field in 'package.json' to be 'string', got '{1}'."),
	        baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1: diag(6106, ts.DiagnosticCategory.Message, "baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1_6106", "'baseUrl' option is set to '{0}', using this value to resolve non-relative module name '{1}'."),
	        rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0: diag(6107, ts.DiagnosticCategory.Message, "rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0_6107", "'rootDirs' option is set, using it to resolve relative module name '{0}'."),
	        Longest_matching_prefix_for_0_is_1: diag(6108, ts.DiagnosticCategory.Message, "Longest_matching_prefix_for_0_is_1_6108", "Longest matching prefix for '{0}' is '{1}'."),
	        Loading_0_from_the_root_dir_1_candidate_location_2: diag(6109, ts.DiagnosticCategory.Message, "Loading_0_from_the_root_dir_1_candidate_location_2_6109", "Loading '{0}' from the root dir '{1}', candidate location '{2}'."),
	        Trying_other_entries_in_rootDirs: diag(6110, ts.DiagnosticCategory.Message, "Trying_other_entries_in_rootDirs_6110", "Trying other entries in 'rootDirs'."),
	        Module_resolution_using_rootDirs_has_failed: diag(6111, ts.DiagnosticCategory.Message, "Module_resolution_using_rootDirs_has_failed_6111", "Module resolution using 'rootDirs' has failed."),
	        Do_not_emit_use_strict_directives_in_module_output: diag(6112, ts.DiagnosticCategory.Message, "Do_not_emit_use_strict_directives_in_module_output_6112", "Do not emit 'use strict' directives in module output."),
	        Enable_strict_null_checks: diag(6113, ts.DiagnosticCategory.Message, "Enable_strict_null_checks_6113", "Enable strict null checks."),
	        Unknown_option_excludes_Did_you_mean_exclude: diag(6114, ts.DiagnosticCategory.Error, "Unknown_option_excludes_Did_you_mean_exclude_6114", "Unknown option 'excludes'. Did you mean 'exclude'?"),
	        Raise_error_on_this_expressions_with_an_implied_any_type: diag(6115, ts.DiagnosticCategory.Message, "Raise_error_on_this_expressions_with_an_implied_any_type_6115", "Raise error on 'this' expressions with an implied 'any' type."),
	        Resolving_type_reference_directive_0_containing_file_1_root_directory_2: diag(6116, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_1_root_directory_2_6116", "======== Resolving type reference directive '{0}', containing file '{1}', root directory '{2}'. ========"),
	        Resolving_using_primary_search_paths: diag(6117, ts.DiagnosticCategory.Message, "Resolving_using_primary_search_paths_6117", "Resolving using primary search paths..."),
	        Resolving_from_node_modules_folder: diag(6118, ts.DiagnosticCategory.Message, "Resolving_from_node_modules_folder_6118", "Resolving from node_modules folder..."),
	        Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2: diag(6119, ts.DiagnosticCategory.Message, "Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2_6119", "======== Type reference directive '{0}' was successfully resolved to '{1}', primary: {2}. ========"),
	        Type_reference_directive_0_was_not_resolved: diag(6120, ts.DiagnosticCategory.Message, "Type_reference_directive_0_was_not_resolved_6120", "======== Type reference directive '{0}' was not resolved. ========"),
	        Resolving_with_primary_search_path_0: diag(6121, ts.DiagnosticCategory.Message, "Resolving_with_primary_search_path_0_6121", "Resolving with primary search path '{0}'."),
	        Root_directory_cannot_be_determined_skipping_primary_search_paths: diag(6122, ts.DiagnosticCategory.Message, "Root_directory_cannot_be_determined_skipping_primary_search_paths_6122", "Root directory cannot be determined, skipping primary search paths."),
	        Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set: diag(6123, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set_6123", "======== Resolving type reference directive '{0}', containing file '{1}', root directory not set. ========"),
	        Type_declaration_files_to_be_included_in_compilation: diag(6124, ts.DiagnosticCategory.Message, "Type_declaration_files_to_be_included_in_compilation_6124", "Type declaration files to be included in compilation."),
	        Looking_up_in_node_modules_folder_initial_location_0: diag(6125, ts.DiagnosticCategory.Message, "Looking_up_in_node_modules_folder_initial_location_0_6125", "Looking up in 'node_modules' folder, initial location '{0}'."),
	        Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder: diag(6126, ts.DiagnosticCategory.Message, "Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_mod_6126", "Containing file is not specified and root directory cannot be determined, skipping lookup in 'node_modules' folder."),
	        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1: diag(6127, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1_6127", "======== Resolving type reference directive '{0}', containing file not set, root directory '{1}'. ========"),
	        Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set: diag(6128, ts.DiagnosticCategory.Message, "Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set_6128", "======== Resolving type reference directive '{0}', containing file not set, root directory not set. ========"),
	        Resolving_real_path_for_0_result_1: diag(6130, ts.DiagnosticCategory.Message, "Resolving_real_path_for_0_result_1_6130", "Resolving real path for '{0}', result '{1}'."),
	        Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system: diag(6131, ts.DiagnosticCategory.Error, "Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system_6131", "Cannot compile modules using option '{0}' unless the '--module' flag is 'amd' or 'system'."),
	        File_name_0_has_a_1_extension_stripping_it: diag(6132, ts.DiagnosticCategory.Message, "File_name_0_has_a_1_extension_stripping_it_6132", "File name '{0}' has a '{1}' extension - stripping it."),
	        _0_is_declared_but_its_value_is_never_read: diag(6133, ts.DiagnosticCategory.Error, "_0_is_declared_but_its_value_is_never_read_6133", "'{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
	        Report_errors_on_unused_locals: diag(6134, ts.DiagnosticCategory.Message, "Report_errors_on_unused_locals_6134", "Report errors on unused locals."),
	        Report_errors_on_unused_parameters: diag(6135, ts.DiagnosticCategory.Message, "Report_errors_on_unused_parameters_6135", "Report errors on unused parameters."),
	        The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files: diag(6136, ts.DiagnosticCategory.Message, "The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files_6136", "The maximum dependency depth to search under node_modules and load JavaScript files."),
	        Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1: diag(6137, ts.DiagnosticCategory.Error, "Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1_6137", "Cannot import type declaration files. Consider importing '{0}' instead of '{1}'."),
	        Property_0_is_declared_but_its_value_is_never_read: diag(6138, ts.DiagnosticCategory.Error, "Property_0_is_declared_but_its_value_is_never_read_6138", "Property '{0}' is declared but its value is never read.", /*reportsUnnecessary*/ true),
	        Import_emit_helpers_from_tslib: diag(6139, ts.DiagnosticCategory.Message, "Import_emit_helpers_from_tslib_6139", "Import emit helpers from 'tslib'."),
	        Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2: diag(6140, ts.DiagnosticCategory.Error, "Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using__6140", "Auto discovery for typings is enabled in project '{0}'. Running extra resolution pass for module '{1}' using cache location '{2}'."),
	        Parse_in_strict_mode_and_emit_use_strict_for_each_source_file: diag(6141, ts.DiagnosticCategory.Message, "Parse_in_strict_mode_and_emit_use_strict_for_each_source_file_6141", "Parse in strict mode and emit \"use strict\" for each source file."),
	        Module_0_was_resolved_to_1_but_jsx_is_not_set: diag(6142, ts.DiagnosticCategory.Error, "Module_0_was_resolved_to_1_but_jsx_is_not_set_6142", "Module '{0}' was resolved to '{1}', but '--jsx' is not set."),
	        Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1: diag(6144, ts.DiagnosticCategory.Message, "Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1_6144", "Module '{0}' was resolved as locally declared ambient module in file '{1}'."),
	        Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified: diag(6145, ts.DiagnosticCategory.Message, "Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified_6145", "Module '{0}' was resolved as ambient module declared in '{1}' since this file was not modified."),
	        Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h: diag(6146, ts.DiagnosticCategory.Message, "Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h_6146", "Specify the JSX factory function to use when targeting 'react' JSX emit, e.g. 'React.createElement' or 'h'."),
	        Resolution_for_module_0_was_found_in_cache_from_location_1: diag(6147, ts.DiagnosticCategory.Message, "Resolution_for_module_0_was_found_in_cache_from_location_1_6147", "Resolution for module '{0}' was found in cache from location '{1}'."),
	        Directory_0_does_not_exist_skipping_all_lookups_in_it: diag(6148, ts.DiagnosticCategory.Message, "Directory_0_does_not_exist_skipping_all_lookups_in_it_6148", "Directory '{0}' does not exist, skipping all lookups in it."),
	        Show_diagnostic_information: diag(6149, ts.DiagnosticCategory.Message, "Show_diagnostic_information_6149", "Show diagnostic information."),
	        Show_verbose_diagnostic_information: diag(6150, ts.DiagnosticCategory.Message, "Show_verbose_diagnostic_information_6150", "Show verbose diagnostic information."),
	        Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file: diag(6151, ts.DiagnosticCategory.Message, "Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file_6151", "Emit a single file with source maps instead of having a separate file."),
	        Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set: diag(6152, ts.DiagnosticCategory.Message, "Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap__6152", "Emit the source alongside the sourcemaps within a single file; requires '--inlineSourceMap' or '--sourceMap' to be set."),
	        Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule: diag(6153, ts.DiagnosticCategory.Message, "Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule_6153", "Transpile each file as a separate module (similar to 'ts.transpileModule')."),
	        Print_names_of_generated_files_part_of_the_compilation: diag(6154, ts.DiagnosticCategory.Message, "Print_names_of_generated_files_part_of_the_compilation_6154", "Print names of generated files part of the compilation."),
	        Print_names_of_files_part_of_the_compilation: diag(6155, ts.DiagnosticCategory.Message, "Print_names_of_files_part_of_the_compilation_6155", "Print names of files part of the compilation."),
	        The_locale_used_when_displaying_messages_to_the_user_e_g_en_us: diag(6156, ts.DiagnosticCategory.Message, "The_locale_used_when_displaying_messages_to_the_user_e_g_en_us_6156", "The locale used when displaying messages to the user (e.g. 'en-us')"),
	        Do_not_generate_custom_helper_functions_like_extends_in_compiled_output: diag(6157, ts.DiagnosticCategory.Message, "Do_not_generate_custom_helper_functions_like_extends_in_compiled_output_6157", "Do not generate custom helper functions like '__extends' in compiled output."),
	        Do_not_include_the_default_library_file_lib_d_ts: diag(6158, ts.DiagnosticCategory.Message, "Do_not_include_the_default_library_file_lib_d_ts_6158", "Do not include the default library file (lib.d.ts)."),
	        Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files: diag(6159, ts.DiagnosticCategory.Message, "Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files_6159", "Do not add triple-slash references or imported modules to the list of compiled files."),
	        Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files: diag(6160, ts.DiagnosticCategory.Message, "Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files_6160", "[Deprecated] Use '--skipLibCheck' instead. Skip type checking of default library declaration files."),
	        List_of_folders_to_include_type_definitions_from: diag(6161, ts.DiagnosticCategory.Message, "List_of_folders_to_include_type_definitions_from_6161", "List of folders to include type definitions from."),
	        Disable_size_limitations_on_JavaScript_projects: diag(6162, ts.DiagnosticCategory.Message, "Disable_size_limitations_on_JavaScript_projects_6162", "Disable size limitations on JavaScript projects."),
	        The_character_set_of_the_input_files: diag(6163, ts.DiagnosticCategory.Message, "The_character_set_of_the_input_files_6163", "The character set of the input files."),
	        Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files: diag(6164, ts.DiagnosticCategory.Message, "Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files_6164", "Emit a UTF-8 Byte Order Mark (BOM) in the beginning of output files."),
	        Do_not_truncate_error_messages: diag(6165, ts.DiagnosticCategory.Message, "Do_not_truncate_error_messages_6165", "Do not truncate error messages."),
	        Output_directory_for_generated_declaration_files: diag(6166, ts.DiagnosticCategory.Message, "Output_directory_for_generated_declaration_files_6166", "Output directory for generated declaration files."),
	        A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl: diag(6167, ts.DiagnosticCategory.Message, "A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl_6167", "A series of entries which re-map imports to lookup locations relative to the 'baseUrl'."),
	        List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime: diag(6168, ts.DiagnosticCategory.Message, "List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime_6168", "List of root folders whose combined content represents the structure of the project at runtime."),
	        Show_all_compiler_options: diag(6169, ts.DiagnosticCategory.Message, "Show_all_compiler_options_6169", "Show all compiler options."),
	        Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file: diag(6170, ts.DiagnosticCategory.Message, "Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file_6170", "[Deprecated] Use '--outFile' instead. Concatenate and emit output to single file"),
	        Command_line_Options: diag(6171, ts.DiagnosticCategory.Message, "Command_line_Options_6171", "Command-line Options"),
	        Basic_Options: diag(6172, ts.DiagnosticCategory.Message, "Basic_Options_6172", "Basic Options"),
	        Strict_Type_Checking_Options: diag(6173, ts.DiagnosticCategory.Message, "Strict_Type_Checking_Options_6173", "Strict Type-Checking Options"),
	        Module_Resolution_Options: diag(6174, ts.DiagnosticCategory.Message, "Module_Resolution_Options_6174", "Module Resolution Options"),
	        Source_Map_Options: diag(6175, ts.DiagnosticCategory.Message, "Source_Map_Options_6175", "Source Map Options"),
	        Additional_Checks: diag(6176, ts.DiagnosticCategory.Message, "Additional_Checks_6176", "Additional Checks"),
	        Experimental_Options: diag(6177, ts.DiagnosticCategory.Message, "Experimental_Options_6177", "Experimental Options"),
	        Advanced_Options: diag(6178, ts.DiagnosticCategory.Message, "Advanced_Options_6178", "Advanced Options"),
	        Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3: diag(6179, ts.DiagnosticCategory.Message, "Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3_6179", "Provide full support for iterables in 'for-of', spread, and destructuring when targeting 'ES5' or 'ES3'."),
	        Enable_all_strict_type_checking_options: diag(6180, ts.DiagnosticCategory.Message, "Enable_all_strict_type_checking_options_6180", "Enable all strict type-checking options."),
	        List_of_language_service_plugins: diag(6181, ts.DiagnosticCategory.Message, "List_of_language_service_plugins_6181", "List of language service plugins."),
	        Scoped_package_detected_looking_in_0: diag(6182, ts.DiagnosticCategory.Message, "Scoped_package_detected_looking_in_0_6182", "Scoped package detected, looking in '{0}'"),
	        Reusing_resolution_of_module_0_to_file_1_from_old_program: diag(6183, ts.DiagnosticCategory.Message, "Reusing_resolution_of_module_0_to_file_1_from_old_program_6183", "Reusing resolution of module '{0}' to file '{1}' from old program."),
	        Reusing_module_resolutions_originating_in_0_since_resolutions_are_unchanged_from_old_program: diag(6184, ts.DiagnosticCategory.Message, "Reusing_module_resolutions_originating_in_0_since_resolutions_are_unchanged_from_old_program_6184", "Reusing module resolutions originating in '{0}' since resolutions are unchanged from old program."),
	        Disable_strict_checking_of_generic_signatures_in_function_types: diag(6185, ts.DiagnosticCategory.Message, "Disable_strict_checking_of_generic_signatures_in_function_types_6185", "Disable strict checking of generic signatures in function types."),
	        Enable_strict_checking_of_function_types: diag(6186, ts.DiagnosticCategory.Message, "Enable_strict_checking_of_function_types_6186", "Enable strict checking of function types."),
	        Enable_strict_checking_of_property_initialization_in_classes: diag(6187, ts.DiagnosticCategory.Message, "Enable_strict_checking_of_property_initialization_in_classes_6187", "Enable strict checking of property initialization in classes."),
	        Numeric_separators_are_not_allowed_here: diag(6188, ts.DiagnosticCategory.Error, "Numeric_separators_are_not_allowed_here_6188", "Numeric separators are not allowed here."),
	        Multiple_consecutive_numeric_separators_are_not_permitted: diag(6189, ts.DiagnosticCategory.Error, "Multiple_consecutive_numeric_separators_are_not_permitted_6189", "Multiple consecutive numeric separators are not permitted."),
	        Found_package_json_at_0_Package_ID_is_1: diag(6190, ts.DiagnosticCategory.Message, "Found_package_json_at_0_Package_ID_is_1_6190", "Found 'package.json' at '{0}'. Package ID is '{1}'."),
	        Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen: diag(6191, ts.DiagnosticCategory.Message, "Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen_6191", "Whether to keep outdated console output in watch mode instead of clearing the screen."),
	        All_imports_in_import_declaration_are_unused: diag(6192, ts.DiagnosticCategory.Error, "All_imports_in_import_declaration_are_unused_6192", "All imports in import declaration are unused.", /*reportsUnnecessary*/ true),
	        Found_1_error_Watching_for_file_changes: diag(6193, ts.DiagnosticCategory.Message, "Found_1_error_Watching_for_file_changes_6193", "Found 1 error. Watching for file changes."),
	        Found_0_errors_Watching_for_file_changes: diag(6194, ts.DiagnosticCategory.Message, "Found_0_errors_Watching_for_file_changes_6194", "Found {0} errors. Watching for file changes."),
	        Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols: diag(6195, ts.DiagnosticCategory.Message, "Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols_6195", "Resolve 'keyof' to string valued property names only (no numbers or symbols)."),
	        _0_is_declared_but_never_used: diag(6196, ts.DiagnosticCategory.Error, "_0_is_declared_but_never_used_6196", "'{0}' is declared but never used.", /*reportsUnnecessary*/ true),
	        Include_modules_imported_with_json_extension: diag(6197, ts.DiagnosticCategory.Message, "Include_modules_imported_with_json_extension_6197", "Include modules imported with '.json' extension"),
	        All_destructured_elements_are_unused: diag(6198, ts.DiagnosticCategory.Error, "All_destructured_elements_are_unused_6198", "All destructured elements are unused.", /*reportsUnnecessary*/ true),
	        All_variables_are_unused: diag(6199, ts.DiagnosticCategory.Error, "All_variables_are_unused_6199", "All variables are unused.", /*reportsUnnecessary*/ true),
	        Projects_to_reference: diag(6300, ts.DiagnosticCategory.Message, "Projects_to_reference_6300", "Projects to reference"),
	        Enable_project_compilation: diag(6302, ts.DiagnosticCategory.Message, "Enable_project_compilation_6302", "Enable project compilation"),
	        Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0: diag(6202, ts.DiagnosticCategory.Error, "Project_references_may_not_form_a_circular_graph_Cycle_detected_Colon_0_6202", "Project references may not form a circular graph. Cycle detected: {0}"),
	        Composite_projects_may_not_disable_declaration_emit: diag(6304, ts.DiagnosticCategory.Error, "Composite_projects_may_not_disable_declaration_emit_6304", "Composite projects may not disable declaration emit."),
	        Output_file_0_has_not_been_built_from_source_file_1: diag(6305, ts.DiagnosticCategory.Error, "Output_file_0_has_not_been_built_from_source_file_1_6305", "Output file '{0}' has not been built from source file '{1}'."),
	        Referenced_project_0_must_have_setting_composite_Colon_true: diag(6306, ts.DiagnosticCategory.Error, "Referenced_project_0_must_have_setting_composite_Colon_true_6306", "Referenced project '{0}' must have setting \"composite\": true."),
	        File_0_is_not_in_project_file_list_Projects_must_list_all_files_or_use_an_include_pattern: diag(6307, ts.DiagnosticCategory.Error, "File_0_is_not_in_project_file_list_Projects_must_list_all_files_or_use_an_include_pattern_6307", "File '{0}' is not in project file list. Projects must list all files or use an 'include' pattern."),
	        Cannot_prepend_project_0_because_it_does_not_have_outFile_set: diag(6308, ts.DiagnosticCategory.Error, "Cannot_prepend_project_0_because_it_does_not_have_outFile_set_6308", "Cannot prepend project '{0}' because it does not have 'outFile' set"),
	        Output_file_0_from_project_1_does_not_exist: diag(6309, ts.DiagnosticCategory.Error, "Output_file_0_from_project_1_does_not_exist_6309", "Output file '{0}' from project '{1}' does not exist"),
	        Variable_0_implicitly_has_an_1_type: diag(7005, ts.DiagnosticCategory.Error, "Variable_0_implicitly_has_an_1_type_7005", "Variable '{0}' implicitly has an '{1}' type."),
	        Parameter_0_implicitly_has_an_1_type: diag(7006, ts.DiagnosticCategory.Error, "Parameter_0_implicitly_has_an_1_type_7006", "Parameter '{0}' implicitly has an '{1}' type."),
	        Member_0_implicitly_has_an_1_type: diag(7008, ts.DiagnosticCategory.Error, "Member_0_implicitly_has_an_1_type_7008", "Member '{0}' implicitly has an '{1}' type."),
	        new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type: diag(7009, ts.DiagnosticCategory.Error, "new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type_7009", "'new' expression, whose target lacks a construct signature, implicitly has an 'any' type."),
	        _0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type: diag(7010, ts.DiagnosticCategory.Error, "_0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type_7010", "'{0}', which lacks return-type annotation, implicitly has an '{1}' return type."),
	        Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type: diag(7011, ts.DiagnosticCategory.Error, "Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type_7011", "Function expression, which lacks return-type annotation, implicitly has an '{0}' return type."),
	        Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7013, ts.DiagnosticCategory.Error, "Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7013", "Construct signature, which lacks return-type annotation, implicitly has an 'any' return type."),
	        Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number: diag(7015, ts.DiagnosticCategory.Error, "Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number_7015", "Element implicitly has an 'any' type because index expression is not of type 'number'."),
	        Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type: diag(7016, ts.DiagnosticCategory.Error, "Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type_7016", "Could not find a declaration file for module '{0}'. '{1}' implicitly has an 'any' type."),
	        Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature: diag(7017, ts.DiagnosticCategory.Error, "Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature_7017", "Element implicitly has an 'any' type because type '{0}' has no index signature."),
	        Object_literal_s_property_0_implicitly_has_an_1_type: diag(7018, ts.DiagnosticCategory.Error, "Object_literal_s_property_0_implicitly_has_an_1_type_7018", "Object literal's property '{0}' implicitly has an '{1}' type."),
	        Rest_parameter_0_implicitly_has_an_any_type: diag(7019, ts.DiagnosticCategory.Error, "Rest_parameter_0_implicitly_has_an_any_type_7019", "Rest parameter '{0}' implicitly has an 'any[]' type."),
	        Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type: diag(7020, ts.DiagnosticCategory.Error, "Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type_7020", "Call signature, which lacks return-type annotation, implicitly has an 'any' return type."),
	        _0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer: diag(7022, ts.DiagnosticCategory.Error, "_0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or__7022", "'{0}' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer."),
	        _0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7023, ts.DiagnosticCategory.Error, "_0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_reference_7023", "'{0}' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
	        Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions: diag(7024, ts.DiagnosticCategory.Error, "Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_ref_7024", "Function implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions."),
	        Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type: diag(7025, ts.DiagnosticCategory.Error, "Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_typ_7025", "Generator implicitly has type '{0}' because it does not yield any values. Consider supplying a return type."),
	        JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists: diag(7026, ts.DiagnosticCategory.Error, "JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists_7026", "JSX element implicitly has type 'any' because no interface 'JSX.{0}' exists."),
	        Unreachable_code_detected: diag(7027, ts.DiagnosticCategory.Error, "Unreachable_code_detected_7027", "Unreachable code detected.", /*reportsUnnecessary*/ true),
	        Unused_label: diag(7028, ts.DiagnosticCategory.Error, "Unused_label_7028", "Unused label.", /*reportsUnnecessary*/ true),
	        Fallthrough_case_in_switch: diag(7029, ts.DiagnosticCategory.Error, "Fallthrough_case_in_switch_7029", "Fallthrough case in switch."),
	        Not_all_code_paths_return_a_value: diag(7030, ts.DiagnosticCategory.Error, "Not_all_code_paths_return_a_value_7030", "Not all code paths return a value."),
	        Binding_element_0_implicitly_has_an_1_type: diag(7031, ts.DiagnosticCategory.Error, "Binding_element_0_implicitly_has_an_1_type_7031", "Binding element '{0}' implicitly has an '{1}' type."),
	        Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation: diag(7032, ts.DiagnosticCategory.Error, "Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation_7032", "Property '{0}' implicitly has type 'any', because its set accessor lacks a parameter type annotation."),
	        Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation: diag(7033, ts.DiagnosticCategory.Error, "Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation_7033", "Property '{0}' implicitly has type 'any', because its get accessor lacks a return type annotation."),
	        Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined: diag(7034, ts.DiagnosticCategory.Error, "Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined_7034", "Variable '{0}' implicitly has type '{1}' in some locations where its type cannot be determined."),
	        Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0: diag(7035, ts.DiagnosticCategory.Error, "Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_mod_7035", "Try `npm install @types/{0}` if it exists or add a new declaration (.d.ts) file containing `declare module '{0}';`"),
	        Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0: diag(7036, ts.DiagnosticCategory.Error, "Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0_7036", "Dynamic import's specifier must be of type 'string', but here has type '{0}'."),
	        Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports: diag(7037, ts.DiagnosticCategory.Message, "Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for__7037", "Enables emit interoperability between CommonJS and ES Modules via creation of namespace objects for all imports. Implies 'allowSyntheticDefaultImports'."),
	        A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime: diag(7038, ts.DiagnosticCategory.Error, "A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime_7038", "A namespace-style import cannot be called or constructed, and will cause a failure at runtime."),
	        Mapped_object_type_implicitly_has_an_any_template_type: diag(7039, ts.DiagnosticCategory.Error, "Mapped_object_type_implicitly_has_an_any_template_type_7039", "Mapped object type implicitly has an 'any' template type."),
	        You_cannot_rename_this_element: diag(8000, ts.DiagnosticCategory.Error, "You_cannot_rename_this_element_8000", "You cannot rename this element."),
	        You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library: diag(8001, ts.DiagnosticCategory.Error, "You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library_8001", "You cannot rename elements that are defined in the standard TypeScript library."),
	        import_can_only_be_used_in_a_ts_file: diag(8002, ts.DiagnosticCategory.Error, "import_can_only_be_used_in_a_ts_file_8002", "'import ... =' can only be used in a .ts file."),
	        export_can_only_be_used_in_a_ts_file: diag(8003, ts.DiagnosticCategory.Error, "export_can_only_be_used_in_a_ts_file_8003", "'export=' can only be used in a .ts file."),
	        type_parameter_declarations_can_only_be_used_in_a_ts_file: diag(8004, ts.DiagnosticCategory.Error, "type_parameter_declarations_can_only_be_used_in_a_ts_file_8004", "'type parameter declarations' can only be used in a .ts file."),
	        implements_clauses_can_only_be_used_in_a_ts_file: diag(8005, ts.DiagnosticCategory.Error, "implements_clauses_can_only_be_used_in_a_ts_file_8005", "'implements clauses' can only be used in a .ts file."),
	        interface_declarations_can_only_be_used_in_a_ts_file: diag(8006, ts.DiagnosticCategory.Error, "interface_declarations_can_only_be_used_in_a_ts_file_8006", "'interface declarations' can only be used in a .ts file."),
	        module_declarations_can_only_be_used_in_a_ts_file: diag(8007, ts.DiagnosticCategory.Error, "module_declarations_can_only_be_used_in_a_ts_file_8007", "'module declarations' can only be used in a .ts file."),
	        type_aliases_can_only_be_used_in_a_ts_file: diag(8008, ts.DiagnosticCategory.Error, "type_aliases_can_only_be_used_in_a_ts_file_8008", "'type aliases' can only be used in a .ts file."),
	        _0_can_only_be_used_in_a_ts_file: diag(8009, ts.DiagnosticCategory.Error, "_0_can_only_be_used_in_a_ts_file_8009", "'{0}' can only be used in a .ts file."),
	        types_can_only_be_used_in_a_ts_file: diag(8010, ts.DiagnosticCategory.Error, "types_can_only_be_used_in_a_ts_file_8010", "'types' can only be used in a .ts file."),
	        type_arguments_can_only_be_used_in_a_ts_file: diag(8011, ts.DiagnosticCategory.Error, "type_arguments_can_only_be_used_in_a_ts_file_8011", "'type arguments' can only be used in a .ts file."),
	        parameter_modifiers_can_only_be_used_in_a_ts_file: diag(8012, ts.DiagnosticCategory.Error, "parameter_modifiers_can_only_be_used_in_a_ts_file_8012", "'parameter modifiers' can only be used in a .ts file."),
	        non_null_assertions_can_only_be_used_in_a_ts_file: diag(8013, ts.DiagnosticCategory.Error, "non_null_assertions_can_only_be_used_in_a_ts_file_8013", "'non-null assertions' can only be used in a .ts file."),
	        enum_declarations_can_only_be_used_in_a_ts_file: diag(8015, ts.DiagnosticCategory.Error, "enum_declarations_can_only_be_used_in_a_ts_file_8015", "'enum declarations' can only be used in a .ts file."),
	        type_assertion_expressions_can_only_be_used_in_a_ts_file: diag(8016, ts.DiagnosticCategory.Error, "type_assertion_expressions_can_only_be_used_in_a_ts_file_8016", "'type assertion expressions' can only be used in a .ts file."),
	        Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0: diag(8017, ts.DiagnosticCategory.Error, "Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0_8017", "Octal literal types must use ES2015 syntax. Use the syntax '{0}'."),
	        Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0: diag(8018, ts.DiagnosticCategory.Error, "Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0_8018", "Octal literals are not allowed in enums members initializer. Use the syntax '{0}'."),
	        Report_errors_in_js_files: diag(8019, ts.DiagnosticCategory.Message, "Report_errors_in_js_files_8019", "Report errors in .js files."),
	        JSDoc_types_can_only_be_used_inside_documentation_comments: diag(8020, ts.DiagnosticCategory.Error, "JSDoc_types_can_only_be_used_inside_documentation_comments_8020", "JSDoc types can only be used inside documentation comments."),
	        JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags: diag(8021, ts.DiagnosticCategory.Error, "JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags_8021", "JSDoc '@typedef' tag should either have a type annotation or be followed by '@property' or '@member' tags."),
	        JSDoc_0_is_not_attached_to_a_class: diag(8022, ts.DiagnosticCategory.Error, "JSDoc_0_is_not_attached_to_a_class_8022", "JSDoc '@{0}' is not attached to a class."),
	        JSDoc_0_1_does_not_match_the_extends_2_clause: diag(8023, ts.DiagnosticCategory.Error, "JSDoc_0_1_does_not_match_the_extends_2_clause_8023", "JSDoc '@{0} {1}' does not match the 'extends {2}' clause."),
	        JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name: diag(8024, ts.DiagnosticCategory.Error, "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_8024", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name."),
	        Class_declarations_cannot_have_more_than_one_augments_or_extends_tag: diag(8025, ts.DiagnosticCategory.Error, "Class_declarations_cannot_have_more_than_one_augments_or_extends_tag_8025", "Class declarations cannot have more than one `@augments` or `@extends` tag."),
	        Expected_0_type_arguments_provide_these_with_an_extends_tag: diag(8026, ts.DiagnosticCategory.Error, "Expected_0_type_arguments_provide_these_with_an_extends_tag_8026", "Expected {0} type arguments; provide these with an '@extends' tag."),
	        Expected_0_1_type_arguments_provide_these_with_an_extends_tag: diag(8027, ts.DiagnosticCategory.Error, "Expected_0_1_type_arguments_provide_these_with_an_extends_tag_8027", "Expected {0}-{1} type arguments; provide these with an '@extends' tag."),
	        JSDoc_may_only_appear_in_the_last_parameter_of_a_signature: diag(8028, ts.DiagnosticCategory.Error, "JSDoc_may_only_appear_in_the_last_parameter_of_a_signature_8028", "JSDoc '...' may only appear in the last parameter of a signature."),
	        JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type: diag(8029, ts.DiagnosticCategory.Error, "JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_h_8029", "JSDoc '@param' tag has name '{0}', but there is no parameter with that name. It would match 'arguments' if it had an array type."),
	        Only_identifiers_Slashqualified_names_with_optional_type_arguments_are_currently_supported_in_a_class_extends_clause: diag(9002, ts.DiagnosticCategory.Error, "Only_identifiers_Slashqualified_names_with_optional_type_arguments_are_currently_supported_in_a_clas_9002", "Only identifiers/qualified-names with optional type arguments are currently supported in a class 'extends' clause."),
	        class_expressions_are_not_currently_supported: diag(9003, ts.DiagnosticCategory.Error, "class_expressions_are_not_currently_supported_9003", "'class' expressions are not currently supported."),
	        Language_service_is_disabled: diag(9004, ts.DiagnosticCategory.Error, "Language_service_is_disabled_9004", "Language service is disabled."),
	        JSX_attributes_must_only_be_assigned_a_non_empty_expression: diag(17000, ts.DiagnosticCategory.Error, "JSX_attributes_must_only_be_assigned_a_non_empty_expression_17000", "JSX attributes must only be assigned a non-empty 'expression'."),
	        JSX_elements_cannot_have_multiple_attributes_with_the_same_name: diag(17001, ts.DiagnosticCategory.Error, "JSX_elements_cannot_have_multiple_attributes_with_the_same_name_17001", "JSX elements cannot have multiple attributes with the same name."),
	        Expected_corresponding_JSX_closing_tag_for_0: diag(17002, ts.DiagnosticCategory.Error, "Expected_corresponding_JSX_closing_tag_for_0_17002", "Expected corresponding JSX closing tag for '{0}'."),
	        JSX_attribute_expected: diag(17003, ts.DiagnosticCategory.Error, "JSX_attribute_expected_17003", "JSX attribute expected."),
	        Cannot_use_JSX_unless_the_jsx_flag_is_provided: diag(17004, ts.DiagnosticCategory.Error, "Cannot_use_JSX_unless_the_jsx_flag_is_provided_17004", "Cannot use JSX unless the '--jsx' flag is provided."),
	        A_constructor_cannot_contain_a_super_call_when_its_class_extends_null: diag(17005, ts.DiagnosticCategory.Error, "A_constructor_cannot_contain_a_super_call_when_its_class_extends_null_17005", "A constructor cannot contain a 'super' call when its class extends 'null'."),
	        An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17006, ts.DiagnosticCategory.Error, "An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_ex_17006", "An unary expression with the '{0}' operator is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
	        A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses: diag(17007, ts.DiagnosticCategory.Error, "A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Con_17007", "A type assertion expression is not allowed in the left-hand side of an exponentiation expression. Consider enclosing the expression in parentheses."),
	        JSX_element_0_has_no_corresponding_closing_tag: diag(17008, ts.DiagnosticCategory.Error, "JSX_element_0_has_no_corresponding_closing_tag_17008", "JSX element '{0}' has no corresponding closing tag."),
	        super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class: diag(17009, ts.DiagnosticCategory.Error, "super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class_17009", "'super' must be called before accessing 'this' in the constructor of a derived class."),
	        Unknown_type_acquisition_option_0: diag(17010, ts.DiagnosticCategory.Error, "Unknown_type_acquisition_option_0_17010", "Unknown type acquisition option '{0}'."),
	        super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class: diag(17011, ts.DiagnosticCategory.Error, "super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class_17011", "'super' must be called before accessing a property of 'super' in the constructor of a derived class."),
	        _0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2: diag(17012, ts.DiagnosticCategory.Error, "_0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2_17012", "'{0}' is not a valid meta-property for keyword '{1}'. Did you mean '{2}'?"),
	        Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor: diag(17013, ts.DiagnosticCategory.Error, "Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constru_17013", "Meta-property '{0}' is only allowed in the body of a function declaration, function expression, or constructor."),
	        JSX_fragment_has_no_corresponding_closing_tag: diag(17014, ts.DiagnosticCategory.Error, "JSX_fragment_has_no_corresponding_closing_tag_17014", "JSX fragment has no corresponding closing tag."),
	        Expected_corresponding_closing_tag_for_JSX_fragment: diag(17015, ts.DiagnosticCategory.Error, "Expected_corresponding_closing_tag_for_JSX_fragment_17015", "Expected corresponding closing tag for JSX fragment."),
	        JSX_fragment_is_not_supported_when_using_jsxFactory: diag(17016, ts.DiagnosticCategory.Error, "JSX_fragment_is_not_supported_when_using_jsxFactory_17016", "JSX fragment is not supported when using --jsxFactory"),
	        JSX_fragment_is_not_supported_when_using_an_inline_JSX_factory_pragma: diag(17017, ts.DiagnosticCategory.Error, "JSX_fragment_is_not_supported_when_using_an_inline_JSX_factory_pragma_17017", "JSX fragment is not supported when using an inline JSX factory pragma"),
	        Circularity_detected_while_resolving_configuration_Colon_0: diag(18000, ts.DiagnosticCategory.Error, "Circularity_detected_while_resolving_configuration_Colon_0_18000", "Circularity detected while resolving configuration: {0}"),
	        A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not: diag(18001, ts.DiagnosticCategory.Error, "A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not_18001", "A path in an 'extends' option must be relative or rooted, but '{0}' is not."),
	        The_files_list_in_config_file_0_is_empty: diag(18002, ts.DiagnosticCategory.Error, "The_files_list_in_config_file_0_is_empty_18002", "The 'files' list in config file '{0}' is empty."),
	        No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2: diag(18003, ts.DiagnosticCategory.Error, "No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2_18003", "No inputs were found in config file '{0}'. Specified 'include' paths were '{1}' and 'exclude' paths were '{2}'."),
	        File_is_a_CommonJS_module_it_may_be_converted_to_an_ES6_module: diag(80001, ts.DiagnosticCategory.Suggestion, "File_is_a_CommonJS_module_it_may_be_converted_to_an_ES6_module_80001", "File is a CommonJS module; it may be converted to an ES6 module."),
	        This_constructor_function_may_be_converted_to_a_class_declaration: diag(80002, ts.DiagnosticCategory.Suggestion, "This_constructor_function_may_be_converted_to_a_class_declaration_80002", "This constructor function may be converted to a class declaration."),
	        Import_may_be_converted_to_a_default_import: diag(80003, ts.DiagnosticCategory.Suggestion, "Import_may_be_converted_to_a_default_import_80003", "Import may be converted to a default import."),
	        JSDoc_types_may_be_moved_to_TypeScript_types: diag(80004, ts.DiagnosticCategory.Suggestion, "JSDoc_types_may_be_moved_to_TypeScript_types_80004", "JSDoc types may be moved to TypeScript types."),
	        require_call_may_be_converted_to_an_import: diag(80005, ts.DiagnosticCategory.Suggestion, "require_call_may_be_converted_to_an_import_80005", "'require' call may be converted to an import."),
	        Add_missing_super_call: diag(90001, ts.DiagnosticCategory.Message, "Add_missing_super_call_90001", "Add missing 'super()' call"),
	        Make_super_call_the_first_statement_in_the_constructor: diag(90002, ts.DiagnosticCategory.Message, "Make_super_call_the_first_statement_in_the_constructor_90002", "Make 'super()' call the first statement in the constructor"),
	        Change_extends_to_implements: diag(90003, ts.DiagnosticCategory.Message, "Change_extends_to_implements_90003", "Change 'extends' to 'implements'"),
	        Remove_declaration_for_Colon_0: diag(90004, ts.DiagnosticCategory.Message, "Remove_declaration_for_Colon_0_90004", "Remove declaration for: '{0}'"),
	        Remove_import_from_0: diag(90005, ts.DiagnosticCategory.Message, "Remove_import_from_0_90005", "Remove import from '{0}'"),
	        Implement_interface_0: diag(90006, ts.DiagnosticCategory.Message, "Implement_interface_0_90006", "Implement interface '{0}'"),
	        Implement_inherited_abstract_class: diag(90007, ts.DiagnosticCategory.Message, "Implement_inherited_abstract_class_90007", "Implement inherited abstract class"),
	        Add_0_to_unresolved_variable: diag(90008, ts.DiagnosticCategory.Message, "Add_0_to_unresolved_variable_90008", "Add '{0}.' to unresolved variable"),
	        Remove_destructuring: diag(90009, ts.DiagnosticCategory.Message, "Remove_destructuring_90009", "Remove destructuring"),
	        Remove_variable_statement: diag(90010, ts.DiagnosticCategory.Message, "Remove_variable_statement_90010", "Remove variable statement"),
	        Import_0_from_module_1: diag(90013, ts.DiagnosticCategory.Message, "Import_0_from_module_1_90013", "Import '{0}' from module \"{1}\""),
	        Change_0_to_1: diag(90014, ts.DiagnosticCategory.Message, "Change_0_to_1_90014", "Change '{0}' to '{1}'"),
	        Add_0_to_existing_import_declaration_from_1: diag(90015, ts.DiagnosticCategory.Message, "Add_0_to_existing_import_declaration_from_1_90015", "Add '{0}' to existing import declaration from \"{1}\""),
	        Declare_property_0: diag(90016, ts.DiagnosticCategory.Message, "Declare_property_0_90016", "Declare property '{0}'"),
	        Add_index_signature_for_property_0: diag(90017, ts.DiagnosticCategory.Message, "Add_index_signature_for_property_0_90017", "Add index signature for property '{0}'"),
	        Disable_checking_for_this_file: diag(90018, ts.DiagnosticCategory.Message, "Disable_checking_for_this_file_90018", "Disable checking for this file"),
	        Ignore_this_error_message: diag(90019, ts.DiagnosticCategory.Message, "Ignore_this_error_message_90019", "Ignore this error message"),
	        Initialize_property_0_in_the_constructor: diag(90020, ts.DiagnosticCategory.Message, "Initialize_property_0_in_the_constructor_90020", "Initialize property '{0}' in the constructor"),
	        Initialize_static_property_0: diag(90021, ts.DiagnosticCategory.Message, "Initialize_static_property_0_90021", "Initialize static property '{0}'"),
	        Change_spelling_to_0: diag(90022, ts.DiagnosticCategory.Message, "Change_spelling_to_0_90022", "Change spelling to '{0}'"),
	        Declare_method_0: diag(90023, ts.DiagnosticCategory.Message, "Declare_method_0_90023", "Declare method '{0}'"),
	        Declare_static_method_0: diag(90024, ts.DiagnosticCategory.Message, "Declare_static_method_0_90024", "Declare static method '{0}'"),
	        Prefix_0_with_an_underscore: diag(90025, ts.DiagnosticCategory.Message, "Prefix_0_with_an_underscore_90025", "Prefix '{0}' with an underscore"),
	        Rewrite_as_the_indexed_access_type_0: diag(90026, ts.DiagnosticCategory.Message, "Rewrite_as_the_indexed_access_type_0_90026", "Rewrite as the indexed access type '{0}'"),
	        Declare_static_property_0: diag(90027, ts.DiagnosticCategory.Message, "Declare_static_property_0_90027", "Declare static property '{0}'"),
	        Call_decorator_expression: diag(90028, ts.DiagnosticCategory.Message, "Call_decorator_expression_90028", "Call decorator expression"),
	        Add_async_modifier_to_containing_function: diag(90029, ts.DiagnosticCategory.Message, "Add_async_modifier_to_containing_function_90029", "Add async modifier to containing function"),
	        Convert_function_to_an_ES2015_class: diag(95001, ts.DiagnosticCategory.Message, "Convert_function_to_an_ES2015_class_95001", "Convert function to an ES2015 class"),
	        Convert_function_0_to_class: diag(95002, ts.DiagnosticCategory.Message, "Convert_function_0_to_class_95002", "Convert function '{0}' to class"),
	        Extract_to_0_in_1: diag(95004, ts.DiagnosticCategory.Message, "Extract_to_0_in_1_95004", "Extract to {0} in {1}"),
	        Extract_function: diag(95005, ts.DiagnosticCategory.Message, "Extract_function_95005", "Extract function"),
	        Extract_constant: diag(95006, ts.DiagnosticCategory.Message, "Extract_constant_95006", "Extract constant"),
	        Extract_to_0_in_enclosing_scope: diag(95007, ts.DiagnosticCategory.Message, "Extract_to_0_in_enclosing_scope_95007", "Extract to {0} in enclosing scope"),
	        Extract_to_0_in_1_scope: diag(95008, ts.DiagnosticCategory.Message, "Extract_to_0_in_1_scope_95008", "Extract to {0} in {1} scope"),
	        Annotate_with_type_from_JSDoc: diag(95009, ts.DiagnosticCategory.Message, "Annotate_with_type_from_JSDoc_95009", "Annotate with type from JSDoc"),
	        Annotate_with_types_from_JSDoc: diag(95010, ts.DiagnosticCategory.Message, "Annotate_with_types_from_JSDoc_95010", "Annotate with types from JSDoc"),
	        Infer_type_of_0_from_usage: diag(95011, ts.DiagnosticCategory.Message, "Infer_type_of_0_from_usage_95011", "Infer type of '{0}' from usage"),
	        Infer_parameter_types_from_usage: diag(95012, ts.DiagnosticCategory.Message, "Infer_parameter_types_from_usage_95012", "Infer parameter types from usage"),
	        Convert_to_default_import: diag(95013, ts.DiagnosticCategory.Message, "Convert_to_default_import_95013", "Convert to default import"),
	        Install_0: diag(95014, ts.DiagnosticCategory.Message, "Install_0_95014", "Install '{0}'"),
	        Replace_import_with_0: diag(95015, ts.DiagnosticCategory.Message, "Replace_import_with_0_95015", "Replace import with '{0}'."),
	        Use_synthetic_default_member: diag(95016, ts.DiagnosticCategory.Message, "Use_synthetic_default_member_95016", "Use synthetic 'default' member."),
	        Convert_to_ES6_module: diag(95017, ts.DiagnosticCategory.Message, "Convert_to_ES6_module_95017", "Convert to ES6 module"),
	        Add_undefined_type_to_property_0: diag(95018, ts.DiagnosticCategory.Message, "Add_undefined_type_to_property_0_95018", "Add 'undefined' type to property '{0}'"),
	        Add_initializer_to_property_0: diag(95019, ts.DiagnosticCategory.Message, "Add_initializer_to_property_0_95019", "Add initializer to property '{0}'"),
	        Add_definite_assignment_assertion_to_property_0: diag(95020, ts.DiagnosticCategory.Message, "Add_definite_assignment_assertion_to_property_0_95020", "Add definite assignment assertion to property '{0}'"),
	        Add_all_missing_members: diag(95022, ts.DiagnosticCategory.Message, "Add_all_missing_members_95022", "Add all missing members"),
	        Infer_all_types_from_usage: diag(95023, ts.DiagnosticCategory.Message, "Infer_all_types_from_usage_95023", "Infer all types from usage"),
	        Delete_all_unused_declarations: diag(95024, ts.DiagnosticCategory.Message, "Delete_all_unused_declarations_95024", "Delete all unused declarations"),
	        Prefix_all_unused_declarations_with_where_possible: diag(95025, ts.DiagnosticCategory.Message, "Prefix_all_unused_declarations_with_where_possible_95025", "Prefix all unused declarations with '_' where possible"),
	        Fix_all_detected_spelling_errors: diag(95026, ts.DiagnosticCategory.Message, "Fix_all_detected_spelling_errors_95026", "Fix all detected spelling errors"),
	        Add_initializers_to_all_uninitialized_properties: diag(95027, ts.DiagnosticCategory.Message, "Add_initializers_to_all_uninitialized_properties_95027", "Add initializers to all uninitialized properties"),
	        Add_definite_assignment_assertions_to_all_uninitialized_properties: diag(95028, ts.DiagnosticCategory.Message, "Add_definite_assignment_assertions_to_all_uninitialized_properties_95028", "Add definite assignment assertions to all uninitialized properties"),
	        Add_undefined_type_to_all_uninitialized_properties: diag(95029, ts.DiagnosticCategory.Message, "Add_undefined_type_to_all_uninitialized_properties_95029", "Add undefined type to all uninitialized properties"),
	        Change_all_jsdoc_style_types_to_TypeScript: diag(95030, ts.DiagnosticCategory.Message, "Change_all_jsdoc_style_types_to_TypeScript_95030", "Change all jsdoc-style types to TypeScript"),
	        Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types: diag(95031, ts.DiagnosticCategory.Message, "Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types_95031", "Change all jsdoc-style types to TypeScript (and add '| undefined' to nullable types)"),
	        Implement_all_unimplemented_interfaces: diag(95032, ts.DiagnosticCategory.Message, "Implement_all_unimplemented_interfaces_95032", "Implement all unimplemented interfaces"),
	        Install_all_missing_types_packages: diag(95033, ts.DiagnosticCategory.Message, "Install_all_missing_types_packages_95033", "Install all missing types packages"),
	        Rewrite_all_as_indexed_access_types: diag(95034, ts.DiagnosticCategory.Message, "Rewrite_all_as_indexed_access_types_95034", "Rewrite all as indexed access types"),
	        Convert_all_to_default_imports: diag(95035, ts.DiagnosticCategory.Message, "Convert_all_to_default_imports_95035", "Convert all to default imports"),
	        Make_all_super_calls_the_first_statement_in_their_constructor: diag(95036, ts.DiagnosticCategory.Message, "Make_all_super_calls_the_first_statement_in_their_constructor_95036", "Make all 'super()' calls the first statement in their constructor"),
	        Add_qualifier_to_all_unresolved_variables_matching_a_member_name: diag(95037, ts.DiagnosticCategory.Message, "Add_qualifier_to_all_unresolved_variables_matching_a_member_name_95037", "Add qualifier to all unresolved variables matching a member name"),
	        Change_all_extended_interfaces_to_implements: diag(95038, ts.DiagnosticCategory.Message, "Change_all_extended_interfaces_to_implements_95038", "Change all extended interfaces to 'implements'"),
	        Add_all_missing_super_calls: diag(95039, ts.DiagnosticCategory.Message, "Add_all_missing_super_calls_95039", "Add all missing super calls"),
	        Implement_all_inherited_abstract_classes: diag(95040, ts.DiagnosticCategory.Message, "Implement_all_inherited_abstract_classes_95040", "Implement all inherited abstract classes"),
	        Add_all_missing_async_modifiers: diag(95041, ts.DiagnosticCategory.Message, "Add_all_missing_async_modifiers_95041", "Add all missing 'async' modifiers"),
	        Add_ts_ignore_to_all_error_messages: diag(95042, ts.DiagnosticCategory.Message, "Add_ts_ignore_to_all_error_messages_95042", "Add '@ts-ignore' to all error messages"),
	        Annotate_everything_with_types_from_JSDoc: diag(95043, ts.DiagnosticCategory.Message, "Annotate_everything_with_types_from_JSDoc_95043", "Annotate everything with types from JSDoc"),
	        Add_to_all_uncalled_decorators: diag(95044, ts.DiagnosticCategory.Message, "Add_to_all_uncalled_decorators_95044", "Add '()' to all uncalled decorators"),
	        Convert_all_constructor_functions_to_classes: diag(95045, ts.DiagnosticCategory.Message, "Convert_all_constructor_functions_to_classes_95045", "Convert all constructor functions to classes"),
	        Generate_get_and_set_accessors: diag(95046, ts.DiagnosticCategory.Message, "Generate_get_and_set_accessors_95046", "Generate 'get' and 'set' accessors"),
	        Convert_require_to_import: diag(95047, ts.DiagnosticCategory.Message, "Convert_require_to_import_95047", "Convert 'require' to 'import'"),
	        Convert_all_require_to_import: diag(95048, ts.DiagnosticCategory.Message, "Convert_all_require_to_import_95048", "Convert all 'require' to 'import'"),
	        Move_to_a_new_file: diag(95049, ts.DiagnosticCategory.Message, "Move_to_a_new_file_95049", "Move to a new file"),
	        Remove_unreachable_code: diag(95050, ts.DiagnosticCategory.Message, "Remove_unreachable_code_95050", "Remove unreachable code"),
	        Remove_all_unreachable_code: diag(95051, ts.DiagnosticCategory.Message, "Remove_all_unreachable_code_95051", "Remove all unreachable code"),
	        Add_missing_typeof: diag(95052, ts.DiagnosticCategory.Message, "Add_missing_typeof_95052", "Add missing 'typeof'"),
	        Remove_unused_label: diag(95053, ts.DiagnosticCategory.Message, "Remove_unused_label_95053", "Remove unused label"),
	        Remove_all_unused_labels: diag(95054, ts.DiagnosticCategory.Message, "Remove_all_unused_labels_95054", "Remove all unused labels"),
	    };
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /* @internal */
	    function tokenIsIdentifierOrKeyword(token) {
	        return token >= 71 /* Identifier */;
	    }
	    ts.tokenIsIdentifierOrKeyword = tokenIsIdentifierOrKeyword;
	    /* @internal */
	    function tokenIsIdentifierOrKeywordOrGreaterThan(token) {
	        return token === 29 /* GreaterThanToken */ || tokenIsIdentifierOrKeyword(token);
	    }
	    ts.tokenIsIdentifierOrKeywordOrGreaterThan = tokenIsIdentifierOrKeywordOrGreaterThan;
	    var textToToken = ts.createMapFromTemplate({
	        "abstract": 117 /* AbstractKeyword */,
	        "any": 119 /* AnyKeyword */,
	        "as": 118 /* AsKeyword */,
	        "boolean": 122 /* BooleanKeyword */,
	        "break": 72 /* BreakKeyword */,
	        "case": 73 /* CaseKeyword */,
	        "catch": 74 /* CatchKeyword */,
	        "class": 75 /* ClassKeyword */,
	        "continue": 77 /* ContinueKeyword */,
	        "const": 76 /* ConstKeyword */,
	        "constructor": 123 /* ConstructorKeyword */,
	        "debugger": 78 /* DebuggerKeyword */,
	        "declare": 124 /* DeclareKeyword */,
	        "default": 79 /* DefaultKeyword */,
	        "delete": 80 /* DeleteKeyword */,
	        "do": 81 /* DoKeyword */,
	        "else": 82 /* ElseKeyword */,
	        "enum": 83 /* EnumKeyword */,
	        "export": 84 /* ExportKeyword */,
	        "extends": 85 /* ExtendsKeyword */,
	        "false": 86 /* FalseKeyword */,
	        "finally": 87 /* FinallyKeyword */,
	        "for": 88 /* ForKeyword */,
	        "from": 142 /* FromKeyword */,
	        "function": 89 /* FunctionKeyword */,
	        "get": 125 /* GetKeyword */,
	        "if": 90 /* IfKeyword */,
	        "implements": 108 /* ImplementsKeyword */,
	        "import": 91 /* ImportKeyword */,
	        "in": 92 /* InKeyword */,
	        "infer": 126 /* InferKeyword */,
	        "instanceof": 93 /* InstanceOfKeyword */,
	        "interface": 109 /* InterfaceKeyword */,
	        "is": 127 /* IsKeyword */,
	        "keyof": 128 /* KeyOfKeyword */,
	        "let": 110 /* LetKeyword */,
	        "module": 129 /* ModuleKeyword */,
	        "namespace": 130 /* NamespaceKeyword */,
	        "never": 131 /* NeverKeyword */,
	        "new": 94 /* NewKeyword */,
	        "null": 95 /* NullKeyword */,
	        "number": 134 /* NumberKeyword */,
	        "object": 135 /* ObjectKeyword */,
	        "package": 111 /* PackageKeyword */,
	        "private": 112 /* PrivateKeyword */,
	        "protected": 113 /* ProtectedKeyword */,
	        "public": 114 /* PublicKeyword */,
	        "readonly": 132 /* ReadonlyKeyword */,
	        "require": 133 /* RequireKeyword */,
	        "global": 143 /* GlobalKeyword */,
	        "return": 96 /* ReturnKeyword */,
	        "set": 136 /* SetKeyword */,
	        "static": 115 /* StaticKeyword */,
	        "string": 137 /* StringKeyword */,
	        "super": 97 /* SuperKeyword */,
	        "switch": 98 /* SwitchKeyword */,
	        "symbol": 138 /* SymbolKeyword */,
	        "this": 99 /* ThisKeyword */,
	        "throw": 100 /* ThrowKeyword */,
	        "true": 101 /* TrueKeyword */,
	        "try": 102 /* TryKeyword */,
	        "type": 139 /* TypeKeyword */,
	        "typeof": 103 /* TypeOfKeyword */,
	        "undefined": 140 /* UndefinedKeyword */,
	        "unique": 141 /* UniqueKeyword */,
	        "var": 104 /* VarKeyword */,
	        "void": 105 /* VoidKeyword */,
	        "while": 106 /* WhileKeyword */,
	        "with": 107 /* WithKeyword */,
	        "yield": 116 /* YieldKeyword */,
	        "async": 120 /* AsyncKeyword */,
	        "await": 121 /* AwaitKeyword */,
	        "of": 144 /* OfKeyword */,
	        "{": 17 /* OpenBraceToken */,
	        "}": 18 /* CloseBraceToken */,
	        "(": 19 /* OpenParenToken */,
	        ")": 20 /* CloseParenToken */,
	        "[": 21 /* OpenBracketToken */,
	        "]": 22 /* CloseBracketToken */,
	        ".": 23 /* DotToken */,
	        "...": 24 /* DotDotDotToken */,
	        ";": 25 /* SemicolonToken */,
	        ",": 26 /* CommaToken */,
	        "<": 27 /* LessThanToken */,
	        ">": 29 /* GreaterThanToken */,
	        "<=": 30 /* LessThanEqualsToken */,
	        ">=": 31 /* GreaterThanEqualsToken */,
	        "==": 32 /* EqualsEqualsToken */,
	        "!=": 33 /* ExclamationEqualsToken */,
	        "===": 34 /* EqualsEqualsEqualsToken */,
	        "!==": 35 /* ExclamationEqualsEqualsToken */,
	        "=>": 36 /* EqualsGreaterThanToken */,
	        "+": 37 /* PlusToken */,
	        "-": 38 /* MinusToken */,
	        "**": 40 /* AsteriskAsteriskToken */,
	        "*": 39 /* AsteriskToken */,
	        "/": 41 /* SlashToken */,
	        "%": 42 /* PercentToken */,
	        "++": 43 /* PlusPlusToken */,
	        "--": 44 /* MinusMinusToken */,
	        "<<": 45 /* LessThanLessThanToken */,
	        "</": 28 /* LessThanSlashToken */,
	        ">>": 46 /* GreaterThanGreaterThanToken */,
	        ">>>": 47 /* GreaterThanGreaterThanGreaterThanToken */,
	        "&": 48 /* AmpersandToken */,
	        "|": 49 /* BarToken */,
	        "^": 50 /* CaretToken */,
	        "!": 51 /* ExclamationToken */,
	        "~": 52 /* TildeToken */,
	        "&&": 53 /* AmpersandAmpersandToken */,
	        "||": 54 /* BarBarToken */,
	        "?": 55 /* QuestionToken */,
	        ":": 56 /* ColonToken */,
	        "=": 58 /* EqualsToken */,
	        "+=": 59 /* PlusEqualsToken */,
	        "-=": 60 /* MinusEqualsToken */,
	        "*=": 61 /* AsteriskEqualsToken */,
	        "**=": 62 /* AsteriskAsteriskEqualsToken */,
	        "/=": 63 /* SlashEqualsToken */,
	        "%=": 64 /* PercentEqualsToken */,
	        "<<=": 65 /* LessThanLessThanEqualsToken */,
	        ">>=": 66 /* GreaterThanGreaterThanEqualsToken */,
	        ">>>=": 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */,
	        "&=": 68 /* AmpersandEqualsToken */,
	        "|=": 69 /* BarEqualsToken */,
	        "^=": 70 /* CaretEqualsToken */,
	        "@": 57 /* AtToken */,
	    });
	    /*
	        As per ECMAScript Language Specification 3th Edition, Section 7.6: Identifiers
	        IdentifierStart ::
	            Can contain Unicode 3.0.0 categories:
	            Uppercase letter (Lu),
	            Lowercase letter (Ll),
	            Titlecase letter (Lt),
	            Modifier letter (Lm),
	            Other letter (Lo), or
	            Letter number (Nl).
	        IdentifierPart :: =
	            Can contain IdentifierStart + Unicode 3.0.0 categories:
	            Non-spacing mark (Mn),
	            Combining spacing mark (Mc),
	            Decimal number (Nd), or
	            Connector punctuation (Pc).
	
	        Codepoint ranges for ES3 Identifiers are extracted from the Unicode 3.0.0 specification at:
	        http://www.unicode.org/Public/3.0-Update/UnicodeData-3.0.0.txt
	    */
	    var unicodeES3IdentifierStart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 543, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 983, 986, 1011, 1024, 1153, 1164, 1220, 1223, 1224, 1227, 1228, 1232, 1269, 1272, 1273, 1329, 1366, 1369, 1369, 1377, 1415, 1488, 1514, 1520, 1522, 1569, 1594, 1600, 1610, 1649, 1747, 1749, 1749, 1765, 1766, 1786, 1788, 1808, 1808, 1810, 1836, 1920, 1957, 2309, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2524, 2525, 2527, 2529, 2544, 2545, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2784, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3168, 3169, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3294, 3294, 3296, 3297, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3424, 3425, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3654, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3804, 3805, 3840, 3840, 3904, 3911, 3913, 3946, 3976, 3979, 4096, 4129, 4131, 4135, 4137, 4138, 4176, 4181, 4256, 4293, 4304, 4342, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 5024, 5108, 5121, 5740, 5743, 5750, 5761, 5786, 5792, 5866, 6016, 6067, 6176, 6263, 6272, 6312, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8319, 8319, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8544, 8579, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12346, 12353, 12436, 12445, 12446, 12449, 12538, 12540, 12542, 12549, 12588, 12593, 12686, 12704, 12727, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 63744, 64045, 64256, 64262, 64275, 64279, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65138, 65140, 65140, 65142, 65276, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    var unicodeES3IdentifierPart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 543, 546, 563, 592, 685, 688, 696, 699, 705, 720, 721, 736, 740, 750, 750, 768, 846, 864, 866, 890, 890, 902, 902, 904, 906, 908, 908, 910, 929, 931, 974, 976, 983, 986, 1011, 1024, 1153, 1155, 1158, 1164, 1220, 1223, 1224, 1227, 1228, 1232, 1269, 1272, 1273, 1329, 1366, 1369, 1369, 1377, 1415, 1425, 1441, 1443, 1465, 1467, 1469, 1471, 1471, 1473, 1474, 1476, 1476, 1488, 1514, 1520, 1522, 1569, 1594, 1600, 1621, 1632, 1641, 1648, 1747, 1749, 1756, 1759, 1768, 1770, 1773, 1776, 1788, 1808, 1836, 1840, 1866, 1920, 1968, 2305, 2307, 2309, 2361, 2364, 2381, 2384, 2388, 2392, 2403, 2406, 2415, 2433, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2492, 2492, 2494, 2500, 2503, 2504, 2507, 2509, 2519, 2519, 2524, 2525, 2527, 2531, 2534, 2545, 2562, 2562, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2620, 2620, 2622, 2626, 2631, 2632, 2635, 2637, 2649, 2652, 2654, 2654, 2662, 2676, 2689, 2691, 2693, 2699, 2701, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2748, 2757, 2759, 2761, 2763, 2765, 2768, 2768, 2784, 2784, 2790, 2799, 2817, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2870, 2873, 2876, 2883, 2887, 2888, 2891, 2893, 2902, 2903, 2908, 2909, 2911, 2913, 2918, 2927, 2946, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 2997, 2999, 3001, 3006, 3010, 3014, 3016, 3018, 3021, 3031, 3031, 3047, 3055, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3134, 3140, 3142, 3144, 3146, 3149, 3157, 3158, 3168, 3169, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3262, 3268, 3270, 3272, 3274, 3277, 3285, 3286, 3294, 3294, 3296, 3297, 3302, 3311, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3368, 3370, 3385, 3390, 3395, 3398, 3400, 3402, 3405, 3415, 3415, 3424, 3425, 3430, 3439, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3530, 3530, 3535, 3540, 3542, 3542, 3544, 3551, 3570, 3571, 3585, 3642, 3648, 3662, 3664, 3673, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3769, 3771, 3773, 3776, 3780, 3782, 3782, 3784, 3789, 3792, 3801, 3804, 3805, 3840, 3840, 3864, 3865, 3872, 3881, 3893, 3893, 3895, 3895, 3897, 3897, 3902, 3911, 3913, 3946, 3953, 3972, 3974, 3979, 3984, 3991, 3993, 4028, 4038, 4038, 4096, 4129, 4131, 4135, 4137, 4138, 4140, 4146, 4150, 4153, 4160, 4169, 4176, 4185, 4256, 4293, 4304, 4342, 4352, 4441, 4447, 4514, 4520, 4601, 4608, 4614, 4616, 4678, 4680, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4742, 4744, 4744, 4746, 4749, 4752, 4782, 4784, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4814, 4816, 4822, 4824, 4846, 4848, 4878, 4880, 4880, 4882, 4885, 4888, 4894, 4896, 4934, 4936, 4954, 4969, 4977, 5024, 5108, 5121, 5740, 5743, 5750, 5761, 5786, 5792, 5866, 6016, 6099, 6112, 6121, 6160, 6169, 6176, 6263, 6272, 6313, 7680, 7835, 7840, 7929, 7936, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8255, 8256, 8319, 8319, 8400, 8412, 8417, 8417, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8497, 8499, 8505, 8544, 8579, 12293, 12295, 12321, 12335, 12337, 12341, 12344, 12346, 12353, 12436, 12441, 12442, 12445, 12446, 12449, 12542, 12549, 12588, 12593, 12686, 12704, 12727, 13312, 19893, 19968, 40869, 40960, 42124, 44032, 55203, 63744, 64045, 64256, 64262, 64275, 64279, 64285, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65056, 65059, 65075, 65076, 65101, 65103, 65136, 65138, 65140, 65140, 65142, 65276, 65296, 65305, 65313, 65338, 65343, 65343, 65345, 65370, 65381, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    /*
	        As per ECMAScript Language Specification 5th Edition, Section 7.6: ISyntaxToken Names and Identifiers
	        IdentifierStart ::
	            Can contain Unicode 6.2 categories:
	            Uppercase letter (Lu),
	            Lowercase letter (Ll),
	            Titlecase letter (Lt),
	            Modifier letter (Lm),
	            Other letter (Lo), or
	            Letter number (Nl).
	        IdentifierPart ::
	            Can contain IdentifierStart + Unicode 6.2 categories:
	            Non-spacing mark (Mn),
	            Combining spacing mark (Mc),
	            Decimal number (Nd),
	            Connector punctuation (Pc),
	            <ZWNJ>, or
	            <ZWJ>.
	
	        Codepoint ranges for ES5 Identifiers are extracted from the Unicode 6.2 specification at:
	        http://www.unicode.org/Public/6.2.0/ucd/UnicodeData.txt
	    */
	    var unicodeES5IdentifierStart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 705, 710, 721, 736, 740, 748, 748, 750, 750, 880, 884, 886, 887, 890, 893, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1162, 1319, 1329, 1366, 1369, 1369, 1377, 1415, 1488, 1514, 1520, 1522, 1568, 1610, 1646, 1647, 1649, 1747, 1749, 1749, 1765, 1766, 1774, 1775, 1786, 1788, 1791, 1791, 1808, 1808, 1810, 1839, 1869, 1957, 1969, 1969, 1994, 2026, 2036, 2037, 2042, 2042, 2048, 2069, 2074, 2074, 2084, 2084, 2088, 2088, 2112, 2136, 2208, 2208, 2210, 2220, 2308, 2361, 2365, 2365, 2384, 2384, 2392, 2401, 2417, 2423, 2425, 2431, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2493, 2493, 2510, 2510, 2524, 2525, 2527, 2529, 2544, 2545, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2649, 2652, 2654, 2654, 2674, 2676, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2749, 2749, 2768, 2768, 2784, 2785, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2877, 2877, 2908, 2909, 2911, 2913, 2929, 2929, 2947, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3024, 3024, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3133, 3133, 3160, 3161, 3168, 3169, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3261, 3261, 3294, 3294, 3296, 3297, 3313, 3314, 3333, 3340, 3342, 3344, 3346, 3386, 3389, 3389, 3406, 3406, 3424, 3425, 3450, 3455, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3585, 3632, 3634, 3635, 3648, 3654, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3760, 3762, 3763, 3773, 3773, 3776, 3780, 3782, 3782, 3804, 3807, 3840, 3840, 3904, 3911, 3913, 3948, 3976, 3980, 4096, 4138, 4159, 4159, 4176, 4181, 4186, 4189, 4193, 4193, 4197, 4198, 4206, 4208, 4213, 4225, 4238, 4238, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4348, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4992, 5007, 5024, 5108, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5870, 5872, 5888, 5900, 5902, 5905, 5920, 5937, 5952, 5969, 5984, 5996, 5998, 6000, 6016, 6067, 6103, 6103, 6108, 6108, 6176, 6263, 6272, 6312, 6314, 6314, 6320, 6389, 6400, 6428, 6480, 6509, 6512, 6516, 6528, 6571, 6593, 6599, 6656, 6678, 6688, 6740, 6823, 6823, 6917, 6963, 6981, 6987, 7043, 7072, 7086, 7087, 7098, 7141, 7168, 7203, 7245, 7247, 7258, 7293, 7401, 7404, 7406, 7409, 7413, 7414, 7424, 7615, 7680, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8305, 8305, 8319, 8319, 8336, 8348, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8544, 8584, 11264, 11310, 11312, 11358, 11360, 11492, 11499, 11502, 11506, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 11568, 11623, 11631, 11631, 11648, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 11823, 11823, 12293, 12295, 12321, 12329, 12337, 12341, 12344, 12348, 12353, 12438, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12589, 12593, 12686, 12704, 12730, 12784, 12799, 13312, 19893, 19968, 40908, 40960, 42124, 42192, 42237, 42240, 42508, 42512, 42527, 42538, 42539, 42560, 42606, 42623, 42647, 42656, 42735, 42775, 42783, 42786, 42888, 42891, 42894, 42896, 42899, 42912, 42922, 43000, 43009, 43011, 43013, 43015, 43018, 43020, 43042, 43072, 43123, 43138, 43187, 43250, 43255, 43259, 43259, 43274, 43301, 43312, 43334, 43360, 43388, 43396, 43442, 43471, 43471, 43520, 43560, 43584, 43586, 43588, 43595, 43616, 43638, 43642, 43642, 43648, 43695, 43697, 43697, 43701, 43702, 43705, 43709, 43712, 43712, 43714, 43714, 43739, 43741, 43744, 43754, 43762, 43764, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43968, 44002, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64256, 64262, 64275, 64279, 64285, 64285, 64287, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65136, 65140, 65142, 65276, 65313, 65338, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    var unicodeES5IdentifierPart = [170, 170, 181, 181, 186, 186, 192, 214, 216, 246, 248, 705, 710, 721, 736, 740, 748, 748, 750, 750, 768, 884, 886, 887, 890, 893, 902, 902, 904, 906, 908, 908, 910, 929, 931, 1013, 1015, 1153, 1155, 1159, 1162, 1319, 1329, 1366, 1369, 1369, 1377, 1415, 1425, 1469, 1471, 1471, 1473, 1474, 1476, 1477, 1479, 1479, 1488, 1514, 1520, 1522, 1552, 1562, 1568, 1641, 1646, 1747, 1749, 1756, 1759, 1768, 1770, 1788, 1791, 1791, 1808, 1866, 1869, 1969, 1984, 2037, 2042, 2042, 2048, 2093, 2112, 2139, 2208, 2208, 2210, 2220, 2276, 2302, 2304, 2403, 2406, 2415, 2417, 2423, 2425, 2431, 2433, 2435, 2437, 2444, 2447, 2448, 2451, 2472, 2474, 2480, 2482, 2482, 2486, 2489, 2492, 2500, 2503, 2504, 2507, 2510, 2519, 2519, 2524, 2525, 2527, 2531, 2534, 2545, 2561, 2563, 2565, 2570, 2575, 2576, 2579, 2600, 2602, 2608, 2610, 2611, 2613, 2614, 2616, 2617, 2620, 2620, 2622, 2626, 2631, 2632, 2635, 2637, 2641, 2641, 2649, 2652, 2654, 2654, 2662, 2677, 2689, 2691, 2693, 2701, 2703, 2705, 2707, 2728, 2730, 2736, 2738, 2739, 2741, 2745, 2748, 2757, 2759, 2761, 2763, 2765, 2768, 2768, 2784, 2787, 2790, 2799, 2817, 2819, 2821, 2828, 2831, 2832, 2835, 2856, 2858, 2864, 2866, 2867, 2869, 2873, 2876, 2884, 2887, 2888, 2891, 2893, 2902, 2903, 2908, 2909, 2911, 2915, 2918, 2927, 2929, 2929, 2946, 2947, 2949, 2954, 2958, 2960, 2962, 2965, 2969, 2970, 2972, 2972, 2974, 2975, 2979, 2980, 2984, 2986, 2990, 3001, 3006, 3010, 3014, 3016, 3018, 3021, 3024, 3024, 3031, 3031, 3046, 3055, 3073, 3075, 3077, 3084, 3086, 3088, 3090, 3112, 3114, 3123, 3125, 3129, 3133, 3140, 3142, 3144, 3146, 3149, 3157, 3158, 3160, 3161, 3168, 3171, 3174, 3183, 3202, 3203, 3205, 3212, 3214, 3216, 3218, 3240, 3242, 3251, 3253, 3257, 3260, 3268, 3270, 3272, 3274, 3277, 3285, 3286, 3294, 3294, 3296, 3299, 3302, 3311, 3313, 3314, 3330, 3331, 3333, 3340, 3342, 3344, 3346, 3386, 3389, 3396, 3398, 3400, 3402, 3406, 3415, 3415, 3424, 3427, 3430, 3439, 3450, 3455, 3458, 3459, 3461, 3478, 3482, 3505, 3507, 3515, 3517, 3517, 3520, 3526, 3530, 3530, 3535, 3540, 3542, 3542, 3544, 3551, 3570, 3571, 3585, 3642, 3648, 3662, 3664, 3673, 3713, 3714, 3716, 3716, 3719, 3720, 3722, 3722, 3725, 3725, 3732, 3735, 3737, 3743, 3745, 3747, 3749, 3749, 3751, 3751, 3754, 3755, 3757, 3769, 3771, 3773, 3776, 3780, 3782, 3782, 3784, 3789, 3792, 3801, 3804, 3807, 3840, 3840, 3864, 3865, 3872, 3881, 3893, 3893, 3895, 3895, 3897, 3897, 3902, 3911, 3913, 3948, 3953, 3972, 3974, 3991, 3993, 4028, 4038, 4038, 4096, 4169, 4176, 4253, 4256, 4293, 4295, 4295, 4301, 4301, 4304, 4346, 4348, 4680, 4682, 4685, 4688, 4694, 4696, 4696, 4698, 4701, 4704, 4744, 4746, 4749, 4752, 4784, 4786, 4789, 4792, 4798, 4800, 4800, 4802, 4805, 4808, 4822, 4824, 4880, 4882, 4885, 4888, 4954, 4957, 4959, 4992, 5007, 5024, 5108, 5121, 5740, 5743, 5759, 5761, 5786, 5792, 5866, 5870, 5872, 5888, 5900, 5902, 5908, 5920, 5940, 5952, 5971, 5984, 5996, 5998, 6000, 6002, 6003, 6016, 6099, 6103, 6103, 6108, 6109, 6112, 6121, 6155, 6157, 6160, 6169, 6176, 6263, 6272, 6314, 6320, 6389, 6400, 6428, 6432, 6443, 6448, 6459, 6470, 6509, 6512, 6516, 6528, 6571, 6576, 6601, 6608, 6617, 6656, 6683, 6688, 6750, 6752, 6780, 6783, 6793, 6800, 6809, 6823, 6823, 6912, 6987, 6992, 7001, 7019, 7027, 7040, 7155, 7168, 7223, 7232, 7241, 7245, 7293, 7376, 7378, 7380, 7414, 7424, 7654, 7676, 7957, 7960, 7965, 7968, 8005, 8008, 8013, 8016, 8023, 8025, 8025, 8027, 8027, 8029, 8029, 8031, 8061, 8064, 8116, 8118, 8124, 8126, 8126, 8130, 8132, 8134, 8140, 8144, 8147, 8150, 8155, 8160, 8172, 8178, 8180, 8182, 8188, 8204, 8205, 8255, 8256, 8276, 8276, 8305, 8305, 8319, 8319, 8336, 8348, 8400, 8412, 8417, 8417, 8421, 8432, 8450, 8450, 8455, 8455, 8458, 8467, 8469, 8469, 8473, 8477, 8484, 8484, 8486, 8486, 8488, 8488, 8490, 8493, 8495, 8505, 8508, 8511, 8517, 8521, 8526, 8526, 8544, 8584, 11264, 11310, 11312, 11358, 11360, 11492, 11499, 11507, 11520, 11557, 11559, 11559, 11565, 11565, 11568, 11623, 11631, 11631, 11647, 11670, 11680, 11686, 11688, 11694, 11696, 11702, 11704, 11710, 11712, 11718, 11720, 11726, 11728, 11734, 11736, 11742, 11744, 11775, 11823, 11823, 12293, 12295, 12321, 12335, 12337, 12341, 12344, 12348, 12353, 12438, 12441, 12442, 12445, 12447, 12449, 12538, 12540, 12543, 12549, 12589, 12593, 12686, 12704, 12730, 12784, 12799, 13312, 19893, 19968, 40908, 40960, 42124, 42192, 42237, 42240, 42508, 42512, 42539, 42560, 42607, 42612, 42621, 42623, 42647, 42655, 42737, 42775, 42783, 42786, 42888, 42891, 42894, 42896, 42899, 42912, 42922, 43000, 43047, 43072, 43123, 43136, 43204, 43216, 43225, 43232, 43255, 43259, 43259, 43264, 43309, 43312, 43347, 43360, 43388, 43392, 43456, 43471, 43481, 43520, 43574, 43584, 43597, 43600, 43609, 43616, 43638, 43642, 43643, 43648, 43714, 43739, 43741, 43744, 43759, 43762, 43766, 43777, 43782, 43785, 43790, 43793, 43798, 43808, 43814, 43816, 43822, 43968, 44010, 44012, 44013, 44016, 44025, 44032, 55203, 55216, 55238, 55243, 55291, 63744, 64109, 64112, 64217, 64256, 64262, 64275, 64279, 64285, 64296, 64298, 64310, 64312, 64316, 64318, 64318, 64320, 64321, 64323, 64324, 64326, 64433, 64467, 64829, 64848, 64911, 64914, 64967, 65008, 65019, 65024, 65039, 65056, 65062, 65075, 65076, 65101, 65103, 65136, 65140, 65142, 65276, 65296, 65305, 65313, 65338, 65343, 65343, 65345, 65370, 65382, 65470, 65474, 65479, 65482, 65487, 65490, 65495, 65498, 65500,];
	    function lookupInUnicodeMap(code, map) {
	        // Bail out quickly if it couldn't possibly be in the map.
	        if (code < map[0]) {
	            return false;
	        }
	        // Perform binary search in one of the Unicode range maps
	        var lo = 0;
	        var hi = map.length;
	        var mid;
	        while (lo + 1 < hi) {
	            mid = lo + (hi - lo) / 2;
	            // mid has to be even to catch a range's beginning
	            mid -= mid % 2;
	            if (map[mid] <= code && code <= map[mid + 1]) {
	                return true;
	            }
	            if (code < map[mid]) {
	                hi = mid;
	            }
	            else {
	                lo = mid + 2;
	            }
	        }
	        return false;
	    }
	    /* @internal */ function isUnicodeIdentifierStart(code, languageVersion) {
	        return languageVersion >= 1 /* ES5 */ ?
	            lookupInUnicodeMap(code, unicodeES5IdentifierStart) :
	            lookupInUnicodeMap(code, unicodeES3IdentifierStart);
	    }
	    ts.isUnicodeIdentifierStart = isUnicodeIdentifierStart;
	    function isUnicodeIdentifierPart(code, languageVersion) {
	        return languageVersion >= 1 /* ES5 */ ?
	            lookupInUnicodeMap(code, unicodeES5IdentifierPart) :
	            lookupInUnicodeMap(code, unicodeES3IdentifierPart);
	    }
	    function makeReverseMap(source) {
	        var result = [];
	        source.forEach(function (value, name) {
	            result[value] = name;
	        });
	        return result;
	    }
	    var tokenStrings = makeReverseMap(textToToken);
	    function tokenToString(t) {
	        return tokenStrings[t];
	    }
	    ts.tokenToString = tokenToString;
	    /* @internal */
	    function stringToToken(s) {
	        return textToToken.get(s);
	    }
	    ts.stringToToken = stringToToken;
	    /* @internal */
	    function computeLineStarts(text) {
	        var result = new Array();
	        var pos = 0;
	        var lineStart = 0;
	        while (pos < text.length) {
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    result.push(lineStart);
	                    lineStart = pos;
	                    break;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && isLineBreak(ch)) {
	                        result.push(lineStart);
	                        lineStart = pos;
	                    }
	                    break;
	            }
	        }
	        result.push(lineStart);
	        return result;
	    }
	    ts.computeLineStarts = computeLineStarts;
	    function getPositionOfLineAndCharacter(sourceFile, line, character) {
	        return computePositionOfLineAndCharacter(getLineStarts(sourceFile), line, character, sourceFile.text);
	    }
	    ts.getPositionOfLineAndCharacter = getPositionOfLineAndCharacter;
	    /* @internal */
	    function computePositionOfLineAndCharacter(lineStarts, line, character, debugText) {
	        if (line < 0 || line >= lineStarts.length) {
	            ts.Debug.fail("Bad line number. Line: " + line + ", lineStarts.length: " + lineStarts.length + " , line map is correct? " + (debugText !== undefined ? ts.arraysEqual(lineStarts, computeLineStarts(debugText)) : "unknown"));
	        }
	        var res = lineStarts[line] + character;
	        if (line < lineStarts.length - 1) {
	            ts.Debug.assert(res < lineStarts[line + 1]);
	        }
	        else if (debugText !== undefined) {
	            ts.Debug.assert(res <= debugText.length); // Allow single character overflow for trailing newline
	        }
	        return res;
	    }
	    ts.computePositionOfLineAndCharacter = computePositionOfLineAndCharacter;
	    /* @internal */
	    function getLineStarts(sourceFile) {
	        return sourceFile.lineMap || (sourceFile.lineMap = computeLineStarts(sourceFile.text));
	    }
	    ts.getLineStarts = getLineStarts;
	    /* @internal */
	    /**
	     * We assume the first line starts at position 0 and 'position' is non-negative.
	     */
	    function computeLineAndCharacterOfPosition(lineStarts, position) {
	        var lineNumber = ts.binarySearch(lineStarts, position, ts.identity, ts.compareValues);
	        if (lineNumber < 0) {
	            // If the actual position was not found,
	            // the binary search returns the 2's-complement of the next line start
	            // e.g. if the line starts at [5, 10, 23, 80] and the position requested was 20
	            // then the search will return -2.
	            //
	            // We want the index of the previous line start, so we subtract 1.
	            // Review 2's-complement if this is confusing.
	            lineNumber = ~lineNumber - 1;
	            ts.Debug.assert(lineNumber !== -1, "position cannot precede the beginning of the file");
	        }
	        return {
	            line: lineNumber,
	            character: position - lineStarts[lineNumber]
	        };
	    }
	    ts.computeLineAndCharacterOfPosition = computeLineAndCharacterOfPosition;
	    function getLineAndCharacterOfPosition(sourceFile, position) {
	        return computeLineAndCharacterOfPosition(getLineStarts(sourceFile), position);
	    }
	    ts.getLineAndCharacterOfPosition = getLineAndCharacterOfPosition;
	    function isWhiteSpaceLike(ch) {
	        return isWhiteSpaceSingleLine(ch) || isLineBreak(ch);
	    }
	    ts.isWhiteSpaceLike = isWhiteSpaceLike;
	    /** Does not include line breaks. For that, see isWhiteSpaceLike. */
	    function isWhiteSpaceSingleLine(ch) {
	        // Note: nextLine is in the Zs space, and should be considered to be a whitespace.
	        // It is explicitly not a line-break as it isn't in the exact set specified by EcmaScript.
	        return ch === 32 /* space */ ||
	            ch === 9 /* tab */ ||
	            ch === 11 /* verticalTab */ ||
	            ch === 12 /* formFeed */ ||
	            ch === 160 /* nonBreakingSpace */ ||
	            ch === 133 /* nextLine */ ||
	            ch === 5760 /* ogham */ ||
	            ch >= 8192 /* enQuad */ && ch <= 8203 /* zeroWidthSpace */ ||
	            ch === 8239 /* narrowNoBreakSpace */ ||
	            ch === 8287 /* mathematicalSpace */ ||
	            ch === 12288 /* ideographicSpace */ ||
	            ch === 65279 /* byteOrderMark */;
	    }
	    ts.isWhiteSpaceSingleLine = isWhiteSpaceSingleLine;
	    function isLineBreak(ch) {
	        // ES5 7.3:
	        // The ECMAScript line terminator characters are listed in Table 3.
	        //     Table 3: Line Terminator Characters
	        //     Code Unit Value     Name                    Formal Name
	        //     \u000A              Line Feed               <LF>
	        //     \u000D              Carriage Return         <CR>
	        //     \u2028              Line separator          <LS>
	        //     \u2029              Paragraph separator     <PS>
	        // Only the characters in Table 3 are treated as line terminators. Other new line or line
	        // breaking characters are treated as white space but not as line terminators.
	        return ch === 10 /* lineFeed */ ||
	            ch === 13 /* carriageReturn */ ||
	            ch === 8232 /* lineSeparator */ ||
	            ch === 8233 /* paragraphSeparator */;
	    }
	    ts.isLineBreak = isLineBreak;
	    function isDigit(ch) {
	        return ch >= 48 /* _0 */ && ch <= 57 /* _9 */;
	    }
	    /* @internal */
	    function isOctalDigit(ch) {
	        return ch >= 48 /* _0 */ && ch <= 55 /* _7 */;
	    }
	    ts.isOctalDigit = isOctalDigit;
	    function couldStartTrivia(text, pos) {
	        // Keep in sync with skipTrivia
	        var ch = text.charCodeAt(pos);
	        switch (ch) {
	            case 13 /* carriageReturn */:
	            case 10 /* lineFeed */:
	            case 9 /* tab */:
	            case 11 /* verticalTab */:
	            case 12 /* formFeed */:
	            case 32 /* space */:
	            case 47 /* slash */:
	            // starts of normal trivia
	            case 60 /* lessThan */:
	            case 124 /* bar */:
	            case 61 /* equals */:
	            case 62 /* greaterThan */:
	                // Starts of conflict marker trivia
	                return true;
	            case 35 /* hash */:
	                // Only if its the beginning can we have #! trivia
	                return pos === 0;
	            default:
	                return ch > 127 /* maxAsciiCharacter */;
	        }
	    }
	    ts.couldStartTrivia = couldStartTrivia;
	    /* @internal */
	    function skipTrivia(text, pos, stopAfterLineBreak, stopAtComments) {
	        if (stopAtComments === void 0) { stopAtComments = false; }
	        if (ts.positionIsSynthesized(pos)) {
	            return pos;
	        }
	        // Keep in sync with couldStartTrivia
	        while (true) {
	            var ch = text.charCodeAt(pos);
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    pos++;
	                    if (stopAfterLineBreak) {
	                        return pos;
	                    }
	                    continue;
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    pos++;
	                    continue;
	                case 47 /* slash */:
	                    if (stopAtComments) {
	                        break;
	                    }
	                    if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                        pos += 2;
	                        while (pos < text.length) {
	                            if (isLineBreak(text.charCodeAt(pos))) {
	                                break;
	                            }
	                            pos++;
	                        }
	                        continue;
	                    }
	                    if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                        pos += 2;
	                        while (pos < text.length) {
	                            if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                pos += 2;
	                                break;
	                            }
	                            pos++;
	                        }
	                        continue;
	                    }
	                    break;
	                case 60 /* lessThan */:
	                case 124 /* bar */:
	                case 61 /* equals */:
	                case 62 /* greaterThan */:
	                    if (isConflictMarkerTrivia(text, pos)) {
	                        pos = scanConflictMarkerTrivia(text, pos);
	                        continue;
	                    }
	                    break;
	                case 35 /* hash */:
	                    if (pos === 0 && isShebangTrivia(text, pos)) {
	                        pos = scanShebangTrivia(text, pos);
	                        continue;
	                    }
	                    break;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && (isWhiteSpaceLike(ch))) {
	                        pos++;
	                        continue;
	                    }
	                    break;
	            }
	            return pos;
	        }
	    }
	    ts.skipTrivia = skipTrivia;
	    // All conflict markers consist of the same character repeated seven times.  If it is
	    // a <<<<<<< or >>>>>>> marker then it is also followed by a space.
	    var mergeConflictMarkerLength = "<<<<<<<".length;
	    function isConflictMarkerTrivia(text, pos) {
	        ts.Debug.assert(pos >= 0);
	        // Conflict markers must be at the start of a line.
	        if (pos === 0 || isLineBreak(text.charCodeAt(pos - 1))) {
	            var ch = text.charCodeAt(pos);
	            if ((pos + mergeConflictMarkerLength) < text.length) {
	                for (var i = 0; i < mergeConflictMarkerLength; i++) {
	                    if (text.charCodeAt(pos + i) !== ch) {
	                        return false;
	                    }
	                }
	                return ch === 61 /* equals */ ||
	                    text.charCodeAt(pos + mergeConflictMarkerLength) === 32 /* space */;
	            }
	        }
	        return false;
	    }
	    function scanConflictMarkerTrivia(text, pos, error) {
	        if (error) {
	            error(ts.Diagnostics.Merge_conflict_marker_encountered, pos, mergeConflictMarkerLength);
	        }
	        var ch = text.charCodeAt(pos);
	        var len = text.length;
	        if (ch === 60 /* lessThan */ || ch === 62 /* greaterThan */) {
	            while (pos < len && !isLineBreak(text.charCodeAt(pos))) {
	                pos++;
	            }
	        }
	        else {
	            ts.Debug.assert(ch === 124 /* bar */ || ch === 61 /* equals */);
	            // Consume everything from the start of a ||||||| or ======= marker to the start
	            // of the next ======= or >>>>>>> marker.
	            while (pos < len) {
	                var currentChar = text.charCodeAt(pos);
	                if ((currentChar === 61 /* equals */ || currentChar === 62 /* greaterThan */) && currentChar !== ch && isConflictMarkerTrivia(text, pos)) {
	                    break;
	                }
	                pos++;
	            }
	        }
	        return pos;
	    }
	    var shebangTriviaRegex = /^#!.*/;
	    function isShebangTrivia(text, pos) {
	        // Shebangs check must only be done at the start of the file
	        ts.Debug.assert(pos === 0);
	        return shebangTriviaRegex.test(text);
	    }
	    function scanShebangTrivia(text, pos) {
	        var shebang = shebangTriviaRegex.exec(text)[0];
	        pos = pos + shebang.length;
	        return pos;
	    }
	    /**
	     * Invokes a callback for each comment range following the provided position.
	     *
	     * Single-line comment ranges include the leading double-slash characters but not the ending
	     * line break. Multi-line comment ranges include the leading slash-asterisk and trailing
	     * asterisk-slash characters.
	     *
	     * @param reduce If true, accumulates the result of calling the callback in a fashion similar
	     *      to reduceLeft. If false, iteration stops when the callback returns a truthy value.
	     * @param text The source text to scan.
	     * @param pos The position at which to start scanning.
	     * @param trailing If false, whitespace is skipped until the first line break and comments
	     *      between that location and the next token are returned. If true, comments occurring
	     *      between the given position and the next line break are returned.
	     * @param cb The callback to execute as each comment range is encountered.
	     * @param state A state value to pass to each iteration of the callback.
	     * @param initial An initial value to pass when accumulating results (when "reduce" is true).
	     * @returns If "reduce" is true, the accumulated value. If "reduce" is false, the first truthy
	     *      return value of the callback.
	     */
	    function iterateCommentRanges(reduce, text, pos, trailing, cb, state, initial) {
	        var pendingPos;
	        var pendingEnd;
	        var pendingKind;
	        var pendingHasTrailingNewLine;
	        var hasPendingCommentRange = false;
	        var collecting = trailing || pos === 0;
	        var accumulator = initial;
	        scan: while (pos >= 0 && pos < text.length) {
	            var ch = text.charCodeAt(pos);
	            switch (ch) {
	                case 13 /* carriageReturn */:
	                    if (text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                    pos++;
	                    if (trailing) {
	                        break scan;
	                    }
	                    collecting = true;
	                    if (hasPendingCommentRange) {
	                        pendingHasTrailingNewLine = true;
	                    }
	                    continue;
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    pos++;
	                    continue;
	                case 47 /* slash */:
	                    var nextChar = text.charCodeAt(pos + 1);
	                    var hasTrailingNewLine = false;
	                    if (nextChar === 47 /* slash */ || nextChar === 42 /* asterisk */) {
	                        var kind = nextChar === 47 /* slash */ ? 2 /* SingleLineCommentTrivia */ : 3 /* MultiLineCommentTrivia */;
	                        var startPos = pos;
	                        pos += 2;
	                        if (nextChar === 47 /* slash */) {
	                            while (pos < text.length) {
	                                if (isLineBreak(text.charCodeAt(pos))) {
	                                    hasTrailingNewLine = true;
	                                    break;
	                                }
	                                pos++;
	                            }
	                        }
	                        else {
	                            while (pos < text.length) {
	                                if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                    pos += 2;
	                                    break;
	                                }
	                                pos++;
	                            }
	                        }
	                        if (collecting) {
	                            if (hasPendingCommentRange) {
	                                accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
	                                if (!reduce && accumulator) {
	                                    // If we are not reducing and we have a truthy result, return it.
	                                    return accumulator;
	                                }
	                            }
	                            pendingPos = startPos;
	                            pendingEnd = pos;
	                            pendingKind = kind;
	                            pendingHasTrailingNewLine = hasTrailingNewLine;
	                            hasPendingCommentRange = true;
	                        }
	                        continue;
	                    }
	                    break scan;
	                default:
	                    if (ch > 127 /* maxAsciiCharacter */ && (isWhiteSpaceLike(ch))) {
	                        if (hasPendingCommentRange && isLineBreak(ch)) {
	                            pendingHasTrailingNewLine = true;
	                        }
	                        pos++;
	                        continue;
	                    }
	                    break scan;
	            }
	        }
	        if (hasPendingCommentRange) {
	            accumulator = cb(pendingPos, pendingEnd, pendingKind, pendingHasTrailingNewLine, state, accumulator);
	        }
	        return accumulator;
	    }
	    function forEachLeadingCommentRange(text, pos, cb, state) {
	        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ false, cb, state);
	    }
	    ts.forEachLeadingCommentRange = forEachLeadingCommentRange;
	    function forEachTrailingCommentRange(text, pos, cb, state) {
	        return iterateCommentRanges(/*reduce*/ false, text, pos, /*trailing*/ true, cb, state);
	    }
	    ts.forEachTrailingCommentRange = forEachTrailingCommentRange;
	    function reduceEachLeadingCommentRange(text, pos, cb, state, initial) {
	        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ false, cb, state, initial);
	    }
	    ts.reduceEachLeadingCommentRange = reduceEachLeadingCommentRange;
	    function reduceEachTrailingCommentRange(text, pos, cb, state, initial) {
	        return iterateCommentRanges(/*reduce*/ true, text, pos, /*trailing*/ true, cb, state, initial);
	    }
	    ts.reduceEachTrailingCommentRange = reduceEachTrailingCommentRange;
	    function appendCommentRange(pos, end, kind, hasTrailingNewLine, _state, comments) {
	        if (!comments) {
	            comments = [];
	        }
	        comments.push({ kind: kind, pos: pos, end: end, hasTrailingNewLine: hasTrailingNewLine });
	        return comments;
	    }
	    function getLeadingCommentRanges(text, pos) {
	        return reduceEachLeadingCommentRange(text, pos, appendCommentRange, /*state*/ undefined, /*initial*/ undefined);
	    }
	    ts.getLeadingCommentRanges = getLeadingCommentRanges;
	    function getTrailingCommentRanges(text, pos) {
	        return reduceEachTrailingCommentRange(text, pos, appendCommentRange, /*state*/ undefined, /*initial*/ undefined);
	    }
	    ts.getTrailingCommentRanges = getTrailingCommentRanges;
	    /** Optionally, get the shebang */
	    function getShebang(text) {
	        var match = shebangTriviaRegex.exec(text);
	        if (match) {
	            return match[0];
	        }
	    }
	    ts.getShebang = getShebang;
	    function isIdentifierStart(ch, languageVersion) {
	        return ch >= 65 /* A */ && ch <= 90 /* Z */ || ch >= 97 /* a */ && ch <= 122 /* z */ ||
	            ch === 36 /* $ */ || ch === 95 /* _ */ ||
	            ch > 127 /* maxAsciiCharacter */ && isUnicodeIdentifierStart(ch, languageVersion);
	    }
	    ts.isIdentifierStart = isIdentifierStart;
	    function isIdentifierPart(ch, languageVersion) {
	        return ch >= 65 /* A */ && ch <= 90 /* Z */ || ch >= 97 /* a */ && ch <= 122 /* z */ ||
	            ch >= 48 /* _0 */ && ch <= 57 /* _9 */ || ch === 36 /* $ */ || ch === 95 /* _ */ ||
	            ch > 127 /* maxAsciiCharacter */ && isUnicodeIdentifierPart(ch, languageVersion);
	    }
	    ts.isIdentifierPart = isIdentifierPart;
	    /* @internal */
	    function isIdentifierText(name, languageVersion) {
	        if (!isIdentifierStart(name.charCodeAt(0), languageVersion)) {
	            return false;
	        }
	        for (var i = 1; i < name.length; i++) {
	            if (!isIdentifierPart(name.charCodeAt(i), languageVersion)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    ts.isIdentifierText = isIdentifierText;
	    // Creates a scanner over a (possibly unspecified) range of a piece of text.
	    function createScanner(languageVersion, skipTrivia, languageVariant, text, onError, start, length) {
	        if (languageVariant === void 0) { languageVariant = 0 /* Standard */; }
	        // Current position (end position of text of current token)
	        var pos;
	        // end of text
	        var end;
	        // Start position of whitespace before current token
	        var startPos;
	        // Start position of text of current token
	        var tokenPos;
	        var token;
	        var tokenValue;
	        var tokenFlags;
	        setText(text, start, length);
	        return {
	            getStartPos: function () { return startPos; },
	            getTextPos: function () { return pos; },
	            getToken: function () { return token; },
	            getTokenPos: function () { return tokenPos; },
	            getTokenText: function () { return text.substring(tokenPos, pos); },
	            getTokenValue: function () { return tokenValue; },
	            hasExtendedUnicodeEscape: function () { return (tokenFlags & 8 /* ExtendedUnicodeEscape */) !== 0; },
	            hasPrecedingLineBreak: function () { return (tokenFlags & 1 /* PrecedingLineBreak */) !== 0; },
	            isIdentifier: function () { return token === 71 /* Identifier */ || token > 107 /* LastReservedWord */; },
	            isReservedWord: function () { return token >= 72 /* FirstReservedWord */ && token <= 107 /* LastReservedWord */; },
	            isUnterminated: function () { return (tokenFlags & 4 /* Unterminated */) !== 0; },
	            getTokenFlags: function () { return tokenFlags; },
	            reScanGreaterToken: reScanGreaterToken,
	            reScanSlashToken: reScanSlashToken,
	            reScanTemplateToken: reScanTemplateToken,
	            scanJsxIdentifier: scanJsxIdentifier,
	            scanJsxAttributeValue: scanJsxAttributeValue,
	            reScanJsxToken: reScanJsxToken,
	            scanJsxToken: scanJsxToken,
	            scanJSDocToken: scanJSDocToken,
	            scan: scan,
	            getText: getText,
	            setText: setText,
	            setScriptTarget: setScriptTarget,
	            setLanguageVariant: setLanguageVariant,
	            setOnError: setOnError,
	            setTextPos: setTextPos,
	            tryScan: tryScan,
	            lookAhead: lookAhead,
	            scanRange: scanRange,
	        };
	        function error(message, errPos, length) {
	            if (errPos === void 0) { errPos = pos; }
	            if (onError) {
	                var oldPos = pos;
	                pos = errPos;
	                onError(message, length || 0);
	                pos = oldPos;
	            }
	        }
	        function scanNumberFragment() {
	            var start = pos;
	            var allowSeparator = false;
	            var isPreviousTokenSeparator = false;
	            var result = "";
	            while (true) {
	                var ch = text.charCodeAt(pos);
	                if (ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (allowSeparator) {
	                        allowSeparator = false;
	                        isPreviousTokenSeparator = true;
	                        result += text.substring(start, pos);
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    start = pos;
	                    continue;
	                }
	                if (isDigit(ch)) {
	                    allowSeparator = true;
	                    isPreviousTokenSeparator = false;
	                    pos++;
	                    continue;
	                }
	                break;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	            }
	            return result + text.substring(start, pos);
	        }
	        function scanNumber() {
	            var start = pos;
	            var mainFragment = scanNumberFragment();
	            var decimalFragment;
	            var scientificFragment;
	            if (text.charCodeAt(pos) === 46 /* dot */) {
	                pos++;
	                decimalFragment = scanNumberFragment();
	            }
	            var end = pos;
	            if (text.charCodeAt(pos) === 69 /* E */ || text.charCodeAt(pos) === 101 /* e */) {
	                pos++;
	                tokenFlags |= 16 /* Scientific */;
	                if (text.charCodeAt(pos) === 43 /* plus */ || text.charCodeAt(pos) === 45 /* minus */)
	                    pos++;
	                var preNumericPart = pos;
	                var finalFragment = scanNumberFragment();
	                if (!finalFragment) {
	                    error(ts.Diagnostics.Digit_expected);
	                }
	                else {
	                    scientificFragment = text.substring(end, preNumericPart) + finalFragment;
	                    end = pos;
	                }
	            }
	            if (tokenFlags & 512 /* ContainsSeparator */) {
	                var result = mainFragment;
	                if (decimalFragment) {
	                    result += "." + decimalFragment;
	                }
	                if (scientificFragment) {
	                    result += scientificFragment;
	                }
	                return "" + +result;
	            }
	            else {
	                return "" + +(text.substring(start, end)); // No need to use all the fragments; no _ removal needed
	            }
	        }
	        function scanOctalDigits() {
	            var start = pos;
	            while (isOctalDigit(text.charCodeAt(pos))) {
	                pos++;
	            }
	            return +(text.substring(start, pos));
	        }
	        /**
	         * Scans the given number of hexadecimal digits in the text,
	         * returning -1 if the given number is unavailable.
	         */
	        function scanExactNumberOfHexDigits(count, canHaveSeparators) {
	            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ false, canHaveSeparators);
	        }
	        /**
	         * Scans as many hexadecimal digits as are available in the text,
	         * returning -1 if the given number of digits was unavailable.
	         */
	        function scanMinimumNumberOfHexDigits(count, canHaveSeparators) {
	            return scanHexDigits(/*minCount*/ count, /*scanAsManyAsPossible*/ true, canHaveSeparators);
	        }
	        function scanHexDigits(minCount, scanAsManyAsPossible, canHaveSeparators) {
	            var digits = 0;
	            var value = 0;
	            var allowSeparator = false;
	            var isPreviousTokenSeparator = false;
	            while (digits < minCount || scanAsManyAsPossible) {
	                var ch = text.charCodeAt(pos);
	                if (canHaveSeparators && ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (allowSeparator) {
	                        allowSeparator = false;
	                        isPreviousTokenSeparator = true;
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    continue;
	                }
	                allowSeparator = canHaveSeparators;
	                if (ch >= 48 /* _0 */ && ch <= 57 /* _9 */) {
	                    value = value * 16 + ch - 48 /* _0 */;
	                }
	                else if (ch >= 65 /* A */ && ch <= 70 /* F */) {
	                    value = value * 16 + ch - 65 /* A */ + 10;
	                }
	                else if (ch >= 97 /* a */ && ch <= 102 /* f */) {
	                    value = value * 16 + ch - 97 /* a */ + 10;
	                }
	                else {
	                    break;
	                }
	                pos++;
	                digits++;
	                isPreviousTokenSeparator = false;
	            }
	            if (digits < minCount) {
	                value = -1;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	            }
	            return value;
	        }
	        function scanString(jsxAttributeString) {
	            if (jsxAttributeString === void 0) { jsxAttributeString = false; }
	            var quote = text.charCodeAt(pos);
	            pos++;
	            var result = "";
	            var start = pos;
	            while (true) {
	                if (pos >= end) {
	                    result += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_string_literal);
	                    break;
	                }
	                var ch = text.charCodeAt(pos);
	                if (ch === quote) {
	                    result += text.substring(start, pos);
	                    pos++;
	                    break;
	                }
	                if (ch === 92 /* backslash */ && !jsxAttributeString) {
	                    result += text.substring(start, pos);
	                    result += scanEscapeSequence();
	                    start = pos;
	                    continue;
	                }
	                if (isLineBreak(ch) && !jsxAttributeString) {
	                    result += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_string_literal);
	                    break;
	                }
	                pos++;
	            }
	            return result;
	        }
	        /**
	         * Sets the current 'tokenValue' and returns a NoSubstitutionTemplateLiteral or
	         * a literal component of a TemplateExpression.
	         */
	        function scanTemplateAndSetTokenValue() {
	            var startedWithBacktick = text.charCodeAt(pos) === 96 /* backtick */;
	            pos++;
	            var start = pos;
	            var contents = "";
	            var resultingToken;
	            while (true) {
	                if (pos >= end) {
	                    contents += text.substring(start, pos);
	                    tokenFlags |= 4 /* Unterminated */;
	                    error(ts.Diagnostics.Unterminated_template_literal);
	                    resultingToken = startedWithBacktick ? 13 /* NoSubstitutionTemplateLiteral */ : 16 /* TemplateTail */;
	                    break;
	                }
	                var currChar = text.charCodeAt(pos);
	                // '`'
	                if (currChar === 96 /* backtick */) {
	                    contents += text.substring(start, pos);
	                    pos++;
	                    resultingToken = startedWithBacktick ? 13 /* NoSubstitutionTemplateLiteral */ : 16 /* TemplateTail */;
	                    break;
	                }
	                // '${'
	                if (currChar === 36 /* $ */ && pos + 1 < end && text.charCodeAt(pos + 1) === 123 /* openBrace */) {
	                    contents += text.substring(start, pos);
	                    pos += 2;
	                    resultingToken = startedWithBacktick ? 14 /* TemplateHead */ : 15 /* TemplateMiddle */;
	                    break;
	                }
	                // Escape character
	                if (currChar === 92 /* backslash */) {
	                    contents += text.substring(start, pos);
	                    contents += scanEscapeSequence();
	                    start = pos;
	                    continue;
	                }
	                // Speculated ECMAScript 6 Spec 11.8.6.1:
	                // <CR><LF> and <CR> LineTerminatorSequences are normalized to <LF> for Template Values
	                if (currChar === 13 /* carriageReturn */) {
	                    contents += text.substring(start, pos);
	                    pos++;
	                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                    contents += "\n";
	                    start = pos;
	                    continue;
	                }
	                pos++;
	            }
	            ts.Debug.assert(resultingToken !== undefined);
	            tokenValue = contents;
	            return resultingToken;
	        }
	        function scanEscapeSequence() {
	            pos++;
	            if (pos >= end) {
	                error(ts.Diagnostics.Unexpected_end_of_text);
	                return "";
	            }
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 48 /* _0 */:
	                    return "\0";
	                case 98 /* b */:
	                    return "\b";
	                case 116 /* t */:
	                    return "\t";
	                case 110 /* n */:
	                    return "\n";
	                case 118 /* v */:
	                    return "\v";
	                case 102 /* f */:
	                    return "\f";
	                case 114 /* r */:
	                    return "\r";
	                case 39 /* singleQuote */:
	                    return "\'";
	                case 34 /* doubleQuote */:
	                    return "\"";
	                case 117 /* u */:
	                    // '\u{DDDDDDDD}'
	                    if (pos < end && text.charCodeAt(pos) === 123 /* openBrace */) {
	                        tokenFlags |= 8 /* ExtendedUnicodeEscape */;
	                        pos++;
	                        return scanExtendedUnicodeEscape();
	                    }
	                    // '\uDDDD'
	                    return scanHexadecimalEscape(/*numDigits*/ 4);
	                case 120 /* x */:
	                    // '\xDD'
	                    return scanHexadecimalEscape(/*numDigits*/ 2);
	                // when encountering a LineContinuation (i.e. a backslash and a line terminator sequence),
	                // the line terminator is interpreted to be "the empty code unit sequence".
	                case 13 /* carriageReturn */:
	                    if (pos < end && text.charCodeAt(pos) === 10 /* lineFeed */) {
	                        pos++;
	                    }
	                // falls through
	                case 10 /* lineFeed */:
	                case 8232 /* lineSeparator */:
	                case 8233 /* paragraphSeparator */:
	                    return "";
	                default:
	                    return String.fromCharCode(ch);
	            }
	        }
	        function scanHexadecimalEscape(numDigits) {
	            var escapedValue = scanExactNumberOfHexDigits(numDigits, /*canHaveSeparators*/ false);
	            if (escapedValue >= 0) {
	                return String.fromCharCode(escapedValue);
	            }
	            else {
	                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                return "";
	            }
	        }
	        function scanExtendedUnicodeEscape() {
	            var escapedValue = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ false);
	            var isInvalidExtendedEscape = false;
	            // Validate the value of the digit
	            if (escapedValue < 0) {
	                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                isInvalidExtendedEscape = true;
	            }
	            else if (escapedValue > 0x10FFFF) {
	                error(ts.Diagnostics.An_extended_Unicode_escape_value_must_be_between_0x0_and_0x10FFFF_inclusive);
	                isInvalidExtendedEscape = true;
	            }
	            if (pos >= end) {
	                error(ts.Diagnostics.Unexpected_end_of_text);
	                isInvalidExtendedEscape = true;
	            }
	            else if (text.charCodeAt(pos) === 125 /* closeBrace */) {
	                // Only swallow the following character up if it's a '}'.
	                pos++;
	            }
	            else {
	                error(ts.Diagnostics.Unterminated_Unicode_escape_sequence);
	                isInvalidExtendedEscape = true;
	            }
	            if (isInvalidExtendedEscape) {
	                return "";
	            }
	            return utf16EncodeAsString(escapedValue);
	        }
	        // Derived from the 10.1.1 UTF16Encoding of the ES6 Spec.
	        function utf16EncodeAsString(codePoint) {
	            ts.Debug.assert(0x0 <= codePoint && codePoint <= 0x10FFFF);
	            if (codePoint <= 65535) {
	                return String.fromCharCode(codePoint);
	            }
	            var codeUnit1 = Math.floor((codePoint - 65536) / 1024) + 0xD800;
	            var codeUnit2 = ((codePoint - 65536) % 1024) + 0xDC00;
	            return String.fromCharCode(codeUnit1, codeUnit2);
	        }
	        // Current character is known to be a backslash. Check for Unicode escape of the form '\uXXXX'
	        // and return code point value if valid Unicode escape is found. Otherwise return -1.
	        function peekUnicodeEscape() {
	            if (pos + 5 < end && text.charCodeAt(pos + 1) === 117 /* u */) {
	                var start_1 = pos;
	                pos += 2;
	                var value = scanExactNumberOfHexDigits(4, /*canHaveSeparators*/ false);
	                pos = start_1;
	                return value;
	            }
	            return -1;
	        }
	        function scanIdentifierParts() {
	            var result = "";
	            var start = pos;
	            while (pos < end) {
	                var ch = text.charCodeAt(pos);
	                if (isIdentifierPart(ch, languageVersion)) {
	                    pos++;
	                }
	                else if (ch === 92 /* backslash */) {
	                    ch = peekUnicodeEscape();
	                    if (!(ch >= 0 && isIdentifierPart(ch, languageVersion))) {
	                        break;
	                    }
	                    result += text.substring(start, pos);
	                    result += String.fromCharCode(ch);
	                    // Valid Unicode escape is always six characters
	                    pos += 6;
	                    start = pos;
	                }
	                else {
	                    break;
	                }
	            }
	            result += text.substring(start, pos);
	            return result;
	        }
	        function getIdentifierToken() {
	            // Reserved words are between 2 and 11 characters long and start with a lowercase letter
	            var len = tokenValue.length;
	            if (len >= 2 && len <= 11) {
	                var ch = tokenValue.charCodeAt(0);
	                if (ch >= 97 /* a */ && ch <= 122 /* z */) {
	                    token = textToToken.get(tokenValue);
	                    if (token !== undefined) {
	                        return token;
	                    }
	                }
	            }
	            return token = 71 /* Identifier */;
	        }
	        function scanBinaryOrOctalDigits(base) {
	            ts.Debug.assert(base === 2 || base === 8, "Expected either base 2 or base 8");
	            var value = 0;
	            // For counting number of digits; Valid binaryIntegerLiteral must have at least one binary digit following B or b.
	            // Similarly valid octalIntegerLiteral must have at least one octal digit following o or O.
	            var numberOfDigits = 0;
	            var separatorAllowed = false;
	            var isPreviousTokenSeparator = false;
	            while (true) {
	                var ch = text.charCodeAt(pos);
	                // Numeric seperators are allowed anywhere within a numeric literal, except not at the beginning, or following another separator
	                if (ch === 95 /* _ */) {
	                    tokenFlags |= 512 /* ContainsSeparator */;
	                    if (separatorAllowed) {
	                        separatorAllowed = false;
	                        isPreviousTokenSeparator = true;
	                    }
	                    else if (isPreviousTokenSeparator) {
	                        error(ts.Diagnostics.Multiple_consecutive_numeric_separators_are_not_permitted, pos, 1);
	                    }
	                    else {
	                        error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos, 1);
	                    }
	                    pos++;
	                    continue;
	                }
	                separatorAllowed = true;
	                var valueOfCh = ch - 48 /* _0 */;
	                if (!isDigit(ch) || valueOfCh >= base) {
	                    break;
	                }
	                value = value * base + valueOfCh;
	                pos++;
	                numberOfDigits++;
	                isPreviousTokenSeparator = false;
	            }
	            // Invalid binaryIntegerLiteral or octalIntegerLiteral
	            if (numberOfDigits === 0) {
	                return -1;
	            }
	            if (text.charCodeAt(pos - 1) === 95 /* _ */) {
	                // Literal ends with underscore - not allowed
	                error(ts.Diagnostics.Numeric_separators_are_not_allowed_here, pos - 1, 1);
	                return value;
	            }
	            return value;
	        }
	        function scan() {
	            startPos = pos;
	            tokenFlags = 0;
	            while (true) {
	                tokenPos = pos;
	                if (pos >= end) {
	                    return token = 1 /* EndOfFileToken */;
	                }
	                var ch = text.charCodeAt(pos);
	                // Special handling for shebang
	                if (ch === 35 /* hash */ && pos === 0 && isShebangTrivia(text, pos)) {
	                    pos = scanShebangTrivia(text, pos);
	                    if (skipTrivia) {
	                        continue;
	                    }
	                    else {
	                        return token = 6 /* ShebangTrivia */;
	                    }
	                }
	                switch (ch) {
	                    case 10 /* lineFeed */:
	                    case 13 /* carriageReturn */:
	                        tokenFlags |= 1 /* PrecedingLineBreak */;
	                        if (skipTrivia) {
	                            pos++;
	                            continue;
	                        }
	                        else {
	                            if (ch === 13 /* carriageReturn */ && pos + 1 < end && text.charCodeAt(pos + 1) === 10 /* lineFeed */) {
	                                // consume both CR and LF
	                                pos += 2;
	                            }
	                            else {
	                                pos++;
	                            }
	                            return token = 4 /* NewLineTrivia */;
	                        }
	                    case 9 /* tab */:
	                    case 11 /* verticalTab */:
	                    case 12 /* formFeed */:
	                    case 32 /* space */:
	                        if (skipTrivia) {
	                            pos++;
	                            continue;
	                        }
	                        else {
	                            while (pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos))) {
	                                pos++;
	                            }
	                            return token = 5 /* WhitespaceTrivia */;
	                        }
	                    case 33 /* exclamation */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 35 /* ExclamationEqualsEqualsToken */;
	                            }
	                            return pos += 2, token = 33 /* ExclamationEqualsToken */;
	                        }
	                        pos++;
	                        return token = 51 /* ExclamationToken */;
	                    case 34 /* doubleQuote */:
	                    case 39 /* singleQuote */:
	                        tokenValue = scanString();
	                        return token = 9 /* StringLiteral */;
	                    case 96 /* backtick */:
	                        return token = scanTemplateAndSetTokenValue();
	                    case 37 /* percent */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 64 /* PercentEqualsToken */;
	                        }
	                        pos++;
	                        return token = 42 /* PercentToken */;
	                    case 38 /* ampersand */:
	                        if (text.charCodeAt(pos + 1) === 38 /* ampersand */) {
	                            return pos += 2, token = 53 /* AmpersandAmpersandToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 68 /* AmpersandEqualsToken */;
	                        }
	                        pos++;
	                        return token = 48 /* AmpersandToken */;
	                    case 40 /* openParen */:
	                        pos++;
	                        return token = 19 /* OpenParenToken */;
	                    case 41 /* closeParen */:
	                        pos++;
	                        return token = 20 /* CloseParenToken */;
	                    case 42 /* asterisk */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 61 /* AsteriskEqualsToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 62 /* AsteriskAsteriskEqualsToken */;
	                            }
	                            return pos += 2, token = 40 /* AsteriskAsteriskToken */;
	                        }
	                        pos++;
	                        return token = 39 /* AsteriskToken */;
	                    case 43 /* plus */:
	                        if (text.charCodeAt(pos + 1) === 43 /* plus */) {
	                            return pos += 2, token = 43 /* PlusPlusToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 59 /* PlusEqualsToken */;
	                        }
	                        pos++;
	                        return token = 37 /* PlusToken */;
	                    case 44 /* comma */:
	                        pos++;
	                        return token = 26 /* CommaToken */;
	                    case 45 /* minus */:
	                        if (text.charCodeAt(pos + 1) === 45 /* minus */) {
	                            return pos += 2, token = 44 /* MinusMinusToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 60 /* MinusEqualsToken */;
	                        }
	                        pos++;
	                        return token = 38 /* MinusToken */;
	                    case 46 /* dot */:
	                        if (isDigit(text.charCodeAt(pos + 1))) {
	                            tokenValue = scanNumber();
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 46 /* dot */ && text.charCodeAt(pos + 2) === 46 /* dot */) {
	                            return pos += 3, token = 24 /* DotDotDotToken */;
	                        }
	                        pos++;
	                        return token = 23 /* DotToken */;
	                    case 47 /* slash */:
	                        // Single-line comment
	                        if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                            pos += 2;
	                            while (pos < end) {
	                                if (isLineBreak(text.charCodeAt(pos))) {
	                                    break;
	                                }
	                                pos++;
	                            }
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 2 /* SingleLineCommentTrivia */;
	                            }
	                        }
	                        // Multi-line comment
	                        if (text.charCodeAt(pos + 1) === 42 /* asterisk */) {
	                            pos += 2;
	                            if (text.charCodeAt(pos) === 42 /* asterisk */ && text.charCodeAt(pos + 1) !== 47 /* slash */) {
	                                tokenFlags |= 2 /* PrecedingJSDocComment */;
	                            }
	                            var commentClosed = false;
	                            while (pos < end) {
	                                var ch_1 = text.charCodeAt(pos);
	                                if (ch_1 === 42 /* asterisk */ && text.charCodeAt(pos + 1) === 47 /* slash */) {
	                                    pos += 2;
	                                    commentClosed = true;
	                                    break;
	                                }
	                                if (isLineBreak(ch_1)) {
	                                    tokenFlags |= 1 /* PrecedingLineBreak */;
	                                }
	                                pos++;
	                            }
	                            if (!commentClosed) {
	                                error(ts.Diagnostics.Asterisk_Slash_expected);
	                            }
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                if (!commentClosed) {
	                                    tokenFlags |= 4 /* Unterminated */;
	                                }
	                                return token = 3 /* MultiLineCommentTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 63 /* SlashEqualsToken */;
	                        }
	                        pos++;
	                        return token = 41 /* SlashToken */;
	                    case 48 /* _0 */:
	                        if (pos + 2 < end && (text.charCodeAt(pos + 1) === 88 /* X */ || text.charCodeAt(pos + 1) === 120 /* x */)) {
	                            pos += 2;
	                            var value = scanMinimumNumberOfHexDigits(1, /*canHaveSeparators*/ true);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Hexadecimal_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 64 /* HexSpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 66 /* B */ || text.charCodeAt(pos + 1) === 98 /* b */)) {
	                            pos += 2;
	                            var value = scanBinaryOrOctalDigits(/* base */ 2);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Binary_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 128 /* BinarySpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        else if (pos + 2 < end && (text.charCodeAt(pos + 1) === 79 /* O */ || text.charCodeAt(pos + 1) === 111 /* o */)) {
	                            pos += 2;
	                            var value = scanBinaryOrOctalDigits(/* base */ 8);
	                            if (value < 0) {
	                                error(ts.Diagnostics.Octal_digit_expected);
	                                value = 0;
	                            }
	                            tokenValue = "" + value;
	                            tokenFlags |= 256 /* OctalSpecifier */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                        // Try to parse as an octal
	                        if (pos + 1 < end && isOctalDigit(text.charCodeAt(pos + 1))) {
	                            tokenValue = "" + scanOctalDigits();
	                            tokenFlags |= 32 /* Octal */;
	                            return token = 8 /* NumericLiteral */;
	                        }
	                    // This fall-through is a deviation from the EcmaScript grammar. The grammar says that a leading zero
	                    // can only be followed by an octal digit, a dot, or the end of the number literal. However, we are being
	                    // permissive and allowing decimal digits of the form 08* and 09* (which many browsers also do).
	                    // falls through
	                    case 49 /* _1 */:
	                    case 50 /* _2 */:
	                    case 51 /* _3 */:
	                    case 52 /* _4 */:
	                    case 53 /* _5 */:
	                    case 54 /* _6 */:
	                    case 55 /* _7 */:
	                    case 56 /* _8 */:
	                    case 57 /* _9 */:
	                        tokenValue = scanNumber();
	                        return token = 8 /* NumericLiteral */;
	                    case 58 /* colon */:
	                        pos++;
	                        return token = 56 /* ColonToken */;
	                    case 59 /* semicolon */:
	                        pos++;
	                        return token = 25 /* SemicolonToken */;
	                    case 60 /* lessThan */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 60 /* lessThan */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 65 /* LessThanLessThanEqualsToken */;
	                            }
	                            return pos += 2, token = 45 /* LessThanLessThanToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 30 /* LessThanEqualsToken */;
	                        }
	                        if (languageVariant === 1 /* JSX */ &&
	                            text.charCodeAt(pos + 1) === 47 /* slash */ &&
	                            text.charCodeAt(pos + 2) !== 42 /* asterisk */) {
	                            return pos += 2, token = 28 /* LessThanSlashToken */;
	                        }
	                        pos++;
	                        return token = 27 /* LessThanToken */;
	                    case 61 /* equals */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                                return pos += 3, token = 34 /* EqualsEqualsEqualsToken */;
	                            }
	                            return pos += 2, token = 32 /* EqualsEqualsToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 62 /* greaterThan */) {
	                            return pos += 2, token = 36 /* EqualsGreaterThanToken */;
	                        }
	                        pos++;
	                        return token = 58 /* EqualsToken */;
	                    case 62 /* greaterThan */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        pos++;
	                        return token = 29 /* GreaterThanToken */;
	                    case 63 /* question */:
	                        pos++;
	                        return token = 55 /* QuestionToken */;
	                    case 91 /* openBracket */:
	                        pos++;
	                        return token = 21 /* OpenBracketToken */;
	                    case 93 /* closeBracket */:
	                        pos++;
	                        return token = 22 /* CloseBracketToken */;
	                    case 94 /* caret */:
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 70 /* CaretEqualsToken */;
	                        }
	                        pos++;
	                        return token = 50 /* CaretToken */;
	                    case 123 /* openBrace */:
	                        pos++;
	                        return token = 17 /* OpenBraceToken */;
	                    case 124 /* bar */:
	                        if (isConflictMarkerTrivia(text, pos)) {
	                            pos = scanConflictMarkerTrivia(text, pos, error);
	                            if (skipTrivia) {
	                                continue;
	                            }
	                            else {
	                                return token = 7 /* ConflictMarkerTrivia */;
	                            }
	                        }
	                        if (text.charCodeAt(pos + 1) === 124 /* bar */) {
	                            return pos += 2, token = 54 /* BarBarToken */;
	                        }
	                        if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                            return pos += 2, token = 69 /* BarEqualsToken */;
	                        }
	                        pos++;
	                        return token = 49 /* BarToken */;
	                    case 125 /* closeBrace */:
	                        pos++;
	                        return token = 18 /* CloseBraceToken */;
	                    case 126 /* tilde */:
	                        pos++;
	                        return token = 52 /* TildeToken */;
	                    case 64 /* at */:
	                        pos++;
	                        return token = 57 /* AtToken */;
	                    case 92 /* backslash */:
	                        var cookedChar = peekUnicodeEscape();
	                        if (cookedChar >= 0 && isIdentifierStart(cookedChar, languageVersion)) {
	                            pos += 6;
	                            tokenValue = String.fromCharCode(cookedChar) + scanIdentifierParts();
	                            return token = getIdentifierToken();
	                        }
	                        error(ts.Diagnostics.Invalid_character);
	                        pos++;
	                        return token = 0 /* Unknown */;
	                    default:
	                        if (isIdentifierStart(ch, languageVersion)) {
	                            pos++;
	                            while (pos < end && isIdentifierPart(ch = text.charCodeAt(pos), languageVersion))
	                                pos++;
	                            tokenValue = text.substring(tokenPos, pos);
	                            if (ch === 92 /* backslash */) {
	                                tokenValue += scanIdentifierParts();
	                            }
	                            return token = getIdentifierToken();
	                        }
	                        else if (isWhiteSpaceSingleLine(ch)) {
	                            pos++;
	                            continue;
	                        }
	                        else if (isLineBreak(ch)) {
	                            tokenFlags |= 1 /* PrecedingLineBreak */;
	                            pos++;
	                            continue;
	                        }
	                        error(ts.Diagnostics.Invalid_character);
	                        pos++;
	                        return token = 0 /* Unknown */;
	                }
	            }
	        }
	        function reScanGreaterToken() {
	            if (token === 29 /* GreaterThanToken */) {
	                if (text.charCodeAt(pos) === 62 /* greaterThan */) {
	                    if (text.charCodeAt(pos + 1) === 62 /* greaterThan */) {
	                        if (text.charCodeAt(pos + 2) === 61 /* equals */) {
	                            return pos += 3, token = 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */;
	                        }
	                        return pos += 2, token = 47 /* GreaterThanGreaterThanGreaterThanToken */;
	                    }
	                    if (text.charCodeAt(pos + 1) === 61 /* equals */) {
	                        return pos += 2, token = 66 /* GreaterThanGreaterThanEqualsToken */;
	                    }
	                    pos++;
	                    return token = 46 /* GreaterThanGreaterThanToken */;
	                }
	                if (text.charCodeAt(pos) === 61 /* equals */) {
	                    pos++;
	                    return token = 31 /* GreaterThanEqualsToken */;
	                }
	            }
	            return token;
	        }
	        function reScanSlashToken() {
	            if (token === 41 /* SlashToken */ || token === 63 /* SlashEqualsToken */) {
	                var p = tokenPos + 1;
	                var inEscape = false;
	                var inCharacterClass = false;
	                while (true) {
	                    // If we reach the end of a file, or hit a newline, then this is an unterminated
	                    // regex.  Report error and return what we have so far.
	                    if (p >= end) {
	                        tokenFlags |= 4 /* Unterminated */;
	                        error(ts.Diagnostics.Unterminated_regular_expression_literal);
	                        break;
	                    }
	                    var ch = text.charCodeAt(p);
	                    if (isLineBreak(ch)) {
	                        tokenFlags |= 4 /* Unterminated */;
	                        error(ts.Diagnostics.Unterminated_regular_expression_literal);
	                        break;
	                    }
	                    if (inEscape) {
	                        // Parsing an escape character;
	                        // reset the flag and just advance to the next char.
	                        inEscape = false;
	                    }
	                    else if (ch === 47 /* slash */ && !inCharacterClass) {
	                        // A slash within a character class is permissible,
	                        // but in general it signals the end of the regexp literal.
	                        p++;
	                        break;
	                    }
	                    else if (ch === 91 /* openBracket */) {
	                        inCharacterClass = true;
	                    }
	                    else if (ch === 92 /* backslash */) {
	                        inEscape = true;
	                    }
	                    else if (ch === 93 /* closeBracket */) {
	                        inCharacterClass = false;
	                    }
	                    p++;
	                }
	                while (p < end && isIdentifierPart(text.charCodeAt(p), languageVersion)) {
	                    p++;
	                }
	                pos = p;
	                tokenValue = text.substring(tokenPos, pos);
	                token = 12 /* RegularExpressionLiteral */;
	            }
	            return token;
	        }
	        /**
	         * Unconditionally back up and scan a template expression portion.
	         */
	        function reScanTemplateToken() {
	            ts.Debug.assert(token === 18 /* CloseBraceToken */, "'reScanTemplateToken' should only be called on a '}'");
	            pos = tokenPos;
	            return token = scanTemplateAndSetTokenValue();
	        }
	        function reScanJsxToken() {
	            pos = tokenPos = startPos;
	            return token = scanJsxToken();
	        }
	        function scanJsxToken() {
	            startPos = tokenPos = pos;
	            if (pos >= end) {
	                return token = 1 /* EndOfFileToken */;
	            }
	            var char = text.charCodeAt(pos);
	            if (char === 60 /* lessThan */) {
	                if (text.charCodeAt(pos + 1) === 47 /* slash */) {
	                    pos += 2;
	                    return token = 28 /* LessThanSlashToken */;
	                }
	                pos++;
	                return token = 27 /* LessThanToken */;
	            }
	            if (char === 123 /* openBrace */) {
	                pos++;
	                return token = 17 /* OpenBraceToken */;
	            }
	            // First non-whitespace character on this line.
	            var firstNonWhitespace = 0;
	            // These initial values are special because the first line is:
	            // firstNonWhitespace = 0 to indicate that we want leading whitspace,
	            while (pos < end) {
	                char = text.charCodeAt(pos);
	                if (char === 123 /* openBrace */) {
	                    break;
	                }
	                if (char === 60 /* lessThan */) {
	                    if (isConflictMarkerTrivia(text, pos)) {
	                        pos = scanConflictMarkerTrivia(text, pos, error);
	                        return token = 7 /* ConflictMarkerTrivia */;
	                    }
	                    break;
	                }
	                // FirstNonWhitespace is 0, then we only see whitespaces so far. If we see a linebreak, we want to ignore that whitespaces.
	                // i.e (- : whitespace)
	                //      <div>----
	                //      </div> becomes <div></div>
	                //
	                //      <div>----</div> becomes <div>----</div>
	                if (isLineBreak(char) && firstNonWhitespace === 0) {
	                    firstNonWhitespace = -1;
	                }
	                else if (!isWhiteSpaceLike(char)) {
	                    firstNonWhitespace = pos;
	                }
	                pos++;
	            }
	            return firstNonWhitespace === -1 ? 11 /* JsxTextAllWhiteSpaces */ : 10 /* JsxText */;
	        }
	        // Scans a JSX identifier; these differ from normal identifiers in that
	        // they allow dashes
	        function scanJsxIdentifier() {
	            if (tokenIsIdentifierOrKeyword(token)) {
	                var firstCharPosition = pos;
	                while (pos < end) {
	                    var ch = text.charCodeAt(pos);
	                    if (ch === 45 /* minus */ || ((firstCharPosition === pos) ? isIdentifierStart(ch, languageVersion) : isIdentifierPart(ch, languageVersion))) {
	                        pos++;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                tokenValue += text.substring(firstCharPosition, pos);
	            }
	            return token;
	        }
	        function scanJsxAttributeValue() {
	            startPos = pos;
	            switch (text.charCodeAt(pos)) {
	                case 34 /* doubleQuote */:
	                case 39 /* singleQuote */:
	                    tokenValue = scanString(/*jsxAttributeString*/ true);
	                    return token = 9 /* StringLiteral */;
	                default:
	                    // If this scans anything other than `{`, it's a parse error.
	                    return scan();
	            }
	        }
	        function scanJSDocToken() {
	            startPos = tokenPos = pos;
	            if (pos >= end) {
	                return token = 1 /* EndOfFileToken */;
	            }
	            var ch = text.charCodeAt(pos);
	            pos++;
	            switch (ch) {
	                case 9 /* tab */:
	                case 11 /* verticalTab */:
	                case 12 /* formFeed */:
	                case 32 /* space */:
	                    while (pos < end && isWhiteSpaceSingleLine(text.charCodeAt(pos))) {
	                        pos++;
	                    }
	                    return token = 5 /* WhitespaceTrivia */;
	                case 64 /* at */:
	                    return token = 57 /* AtToken */;
	                case 10 /* lineFeed */:
	                case 13 /* carriageReturn */:
	                    return token = 4 /* NewLineTrivia */;
	                case 42 /* asterisk */:
	                    return token = 39 /* AsteriskToken */;
	                case 123 /* openBrace */:
	                    return token = 17 /* OpenBraceToken */;
	                case 125 /* closeBrace */:
	                    return token = 18 /* CloseBraceToken */;
	                case 91 /* openBracket */:
	                    return token = 21 /* OpenBracketToken */;
	                case 93 /* closeBracket */:
	                    return token = 22 /* CloseBracketToken */;
	                case 60 /* lessThan */:
	                    return token = 27 /* LessThanToken */;
	                case 61 /* equals */:
	                    return token = 58 /* EqualsToken */;
	                case 44 /* comma */:
	                    return token = 26 /* CommaToken */;
	                case 46 /* dot */:
	                    return token = 23 /* DotToken */;
	                case 96 /* backtick */:
	                    while (pos < end && text.charCodeAt(pos) !== 96 /* backtick */) {
	                        pos++;
	                    }
	                    tokenValue = text.substring(tokenPos + 1, pos);
	                    pos++;
	                    return token = 13 /* NoSubstitutionTemplateLiteral */;
	            }
	            if (isIdentifierStart(ch, 6 /* Latest */)) {
	                while (isIdentifierPart(text.charCodeAt(pos), 6 /* Latest */) && pos < end) {
	                    pos++;
	                }
	                tokenValue = text.substring(tokenPos, pos);
	                return token = 71 /* Identifier */;
	            }
	            else {
	                return token = 0 /* Unknown */;
	            }
	        }
	        function speculationHelper(callback, isLookahead) {
	            var savePos = pos;
	            var saveStartPos = startPos;
	            var saveTokenPos = tokenPos;
	            var saveToken = token;
	            var saveTokenValue = tokenValue;
	            var saveTokenFlags = tokenFlags;
	            var result = callback();
	            // If our callback returned something 'falsy' or we're just looking ahead,
	            // then unconditionally restore us to where we were.
	            if (!result || isLookahead) {
	                pos = savePos;
	                startPos = saveStartPos;
	                tokenPos = saveTokenPos;
	                token = saveToken;
	                tokenValue = saveTokenValue;
	                tokenFlags = saveTokenFlags;
	            }
	            return result;
	        }
	        function scanRange(start, length, callback) {
	            var saveEnd = end;
	            var savePos = pos;
	            var saveStartPos = startPos;
	            var saveTokenPos = tokenPos;
	            var saveToken = token;
	            var saveTokenValue = tokenValue;
	            var saveTokenFlags = tokenFlags;
	            setText(text, start, length);
	            var result = callback();
	            end = saveEnd;
	            pos = savePos;
	            startPos = saveStartPos;
	            tokenPos = saveTokenPos;
	            token = saveToken;
	            tokenValue = saveTokenValue;
	            tokenFlags = saveTokenFlags;
	            return result;
	        }
	        function lookAhead(callback) {
	            return speculationHelper(callback, /*isLookahead*/ true);
	        }
	        function tryScan(callback) {
	            return speculationHelper(callback, /*isLookahead*/ false);
	        }
	        function getText() {
	            return text;
	        }
	        function setText(newText, start, length) {
	            text = newText || "";
	            end = length === undefined ? text.length : start + length;
	            setTextPos(start || 0);
	        }
	        function setOnError(errorCallback) {
	            onError = errorCallback;
	        }
	        function setScriptTarget(scriptTarget) {
	            languageVersion = scriptTarget;
	        }
	        function setLanguageVariant(variant) {
	            languageVariant = variant;
	        }
	        function setTextPos(textPos) {
	            ts.Debug.assert(textPos >= 0);
	            pos = textPos;
	            startPos = textPos;
	            tokenPos = textPos;
	            token = 0 /* Unknown */;
	            tokenValue = undefined;
	            tokenFlags = 0;
	        }
	    }
	    ts.createScanner = createScanner;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    ts.resolvingEmptyArray = [];
	    ts.emptyMap = ts.createMap();
	    ts.emptyUnderscoreEscapedMap = ts.emptyMap;
	    ts.externalHelpersModuleNameText = "tslib";
	    function getDeclarationOfKind(symbol, kind) {
	        var declarations = symbol.declarations;
	        if (declarations) {
	            for (var _i = 0, declarations_1 = declarations; _i < declarations_1.length; _i++) {
	                var declaration = declarations_1[_i];
	                if (declaration.kind === kind) {
	                    return declaration;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.getDeclarationOfKind = getDeclarationOfKind;
	    var stringWriter = createSingleLineStringWriter();
	    function createSingleLineStringWriter() {
	        var str = "";
	        var writeText = function (text) { return str += text; };
	        return {
	            getText: function () { return str; },
	            write: writeText,
	            rawWrite: writeText,
	            writeTextOfNode: writeText,
	            writeKeyword: writeText,
	            writeOperator: writeText,
	            writePunctuation: writeText,
	            writeSpace: writeText,
	            writeStringLiteral: writeText,
	            writeLiteral: writeText,
	            writeParameter: writeText,
	            writeProperty: writeText,
	            writeSymbol: writeText,
	            getTextPos: function () { return str.length; },
	            getLine: function () { return 0; },
	            getColumn: function () { return 0; },
	            getIndent: function () { return 0; },
	            isAtStartOfLine: function () { return false; },
	            // Completely ignore indentation for string writers.  And map newlines to
	            // a single space.
	            writeLine: function () { return str += " "; },
	            increaseIndent: ts.noop,
	            decreaseIndent: ts.noop,
	            clear: function () { return str = ""; },
	            trackSymbol: ts.noop,
	            reportInaccessibleThisError: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	        };
	    }
	    function usingSingleLineStringWriter(action) {
	        var oldString = stringWriter.getText();
	        try {
	            action(stringWriter);
	            return stringWriter.getText();
	        }
	        finally {
	            stringWriter.clear();
	            stringWriter.writeKeyword(oldString);
	        }
	    }
	    ts.usingSingleLineStringWriter = usingSingleLineStringWriter;
	    function getFullWidth(node) {
	        return node.end - node.pos;
	    }
	    ts.getFullWidth = getFullWidth;
	    function getResolvedModule(sourceFile, moduleNameText) {
	        return sourceFile && sourceFile.resolvedModules && sourceFile.resolvedModules.get(moduleNameText);
	    }
	    ts.getResolvedModule = getResolvedModule;
	    function setResolvedModule(sourceFile, moduleNameText, resolvedModule) {
	        if (!sourceFile.resolvedModules) {
	            sourceFile.resolvedModules = ts.createMap();
	        }
	        sourceFile.resolvedModules.set(moduleNameText, resolvedModule);
	    }
	    ts.setResolvedModule = setResolvedModule;
	    function setResolvedTypeReferenceDirective(sourceFile, typeReferenceDirectiveName, resolvedTypeReferenceDirective) {
	        if (!sourceFile.resolvedTypeReferenceDirectiveNames) {
	            sourceFile.resolvedTypeReferenceDirectiveNames = ts.createMap();
	        }
	        sourceFile.resolvedTypeReferenceDirectiveNames.set(typeReferenceDirectiveName, resolvedTypeReferenceDirective);
	    }
	    ts.setResolvedTypeReferenceDirective = setResolvedTypeReferenceDirective;
	    function moduleResolutionIsEqualTo(oldResolution, newResolution) {
	        return oldResolution.isExternalLibraryImport === newResolution.isExternalLibraryImport &&
	            oldResolution.extension === newResolution.extension &&
	            oldResolution.resolvedFileName === newResolution.resolvedFileName &&
	            oldResolution.originalPath === newResolution.originalPath &&
	            packageIdIsEqual(oldResolution.packageId, newResolution.packageId);
	    }
	    ts.moduleResolutionIsEqualTo = moduleResolutionIsEqualTo;
	    function packageIdIsEqual(a, b) {
	        return a === b || a && b && a.name === b.name && a.subModuleName === b.subModuleName && a.version === b.version;
	    }
	    function packageIdToString(_a) {
	        var name = _a.name, subModuleName = _a.subModuleName, version = _a.version;
	        var fullName = subModuleName ? name + "/" + subModuleName : name;
	        return fullName + "@" + version;
	    }
	    ts.packageIdToString = packageIdToString;
	    function typeDirectiveIsEqualTo(oldResolution, newResolution) {
	        return oldResolution.resolvedFileName === newResolution.resolvedFileName && oldResolution.primary === newResolution.primary;
	    }
	    ts.typeDirectiveIsEqualTo = typeDirectiveIsEqualTo;
	    function hasChangesInResolutions(names, newResolutions, oldResolutions, comparer) {
	        ts.Debug.assert(names.length === newResolutions.length);
	        for (var i = 0; i < names.length; i++) {
	            var newResolution = newResolutions[i];
	            var oldResolution = oldResolutions && oldResolutions.get(names[i]);
	            var changed = oldResolution
	                ? !newResolution || !comparer(oldResolution, newResolution)
	                : newResolution;
	            if (changed) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.hasChangesInResolutions = hasChangesInResolutions;
	    // Returns true if this node contains a parse error anywhere underneath it.
	    function containsParseError(node) {
	        aggregateChildData(node);
	        return (node.flags & 131072 /* ThisNodeOrAnySubNodesHasError */) !== 0;
	    }
	    ts.containsParseError = containsParseError;
	    function aggregateChildData(node) {
	        if (!(node.flags & 262144 /* HasAggregatedChildData */)) {
	            // A node is considered to contain a parse error if:
	            //  a) the parser explicitly marked that it had an error
	            //  b) any of it's children reported that it had an error.
	            var thisNodeOrAnySubNodesHasError = ((node.flags & 32768 /* ThisNodeHasError */) !== 0) ||
	                ts.forEachChild(node, containsParseError);
	            // If so, mark ourselves accordingly.
	            if (thisNodeOrAnySubNodesHasError) {
	                node.flags |= 131072 /* ThisNodeOrAnySubNodesHasError */;
	            }
	            // Also mark that we've propagated the child information to this node.  This way we can
	            // always consult the bit directly on this node without needing to check its children
	            // again.
	            node.flags |= 262144 /* HasAggregatedChildData */;
	        }
	    }
	    function getSourceFileOfNode(node) {
	        while (node && node.kind !== 273 /* SourceFile */) {
	            node = node.parent;
	        }
	        return node;
	    }
	    ts.getSourceFileOfNode = getSourceFileOfNode;
	    function isStatementWithLocals(node) {
	        switch (node.kind) {
	            case 212 /* Block */:
	            case 240 /* CaseBlock */:
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	                return true;
	        }
	        return false;
	    }
	    ts.isStatementWithLocals = isStatementWithLocals;
	    function getStartPositionOfLine(line, sourceFile) {
	        ts.Debug.assert(line >= 0);
	        return ts.getLineStarts(sourceFile)[line];
	    }
	    ts.getStartPositionOfLine = getStartPositionOfLine;
	    // This is a useful function for debugging purposes.
	    function nodePosToString(node) {
	        var file = getSourceFileOfNode(node);
	        var loc = ts.getLineAndCharacterOfPosition(file, node.pos);
	        return file.fileName + "(" + (loc.line + 1) + "," + (loc.character + 1) + ")";
	    }
	    ts.nodePosToString = nodePosToString;
	    function getEndLinePosition(line, sourceFile) {
	        ts.Debug.assert(line >= 0);
	        var lineStarts = ts.getLineStarts(sourceFile);
	        var lineIndex = line;
	        var sourceText = sourceFile.text;
	        if (lineIndex + 1 === lineStarts.length) {
	            // last line - return EOF
	            return sourceText.length - 1;
	        }
	        else {
	            // current line start
	            var start = lineStarts[lineIndex];
	            // take the start position of the next line - 1 = it should be some line break
	            var pos = lineStarts[lineIndex + 1] - 1;
	            ts.Debug.assert(ts.isLineBreak(sourceText.charCodeAt(pos)));
	            // walk backwards skipping line breaks, stop the the beginning of current line.
	            // i.e:
	            // <some text>
	            // $ <- end of line for this position should match the start position
	            while (start <= pos && ts.isLineBreak(sourceText.charCodeAt(pos))) {
	                pos--;
	            }
	            return pos;
	        }
	    }
	    ts.getEndLinePosition = getEndLinePosition;
	    /**
	     * Returns a value indicating whether a name is unique globally or within the current file
	     */
	    function isFileLevelUniqueName(currentSourceFile, name, hasGlobalName) {
	        return !(hasGlobalName && hasGlobalName(name))
	            && !currentSourceFile.identifiers.has(name);
	    }
	    ts.isFileLevelUniqueName = isFileLevelUniqueName;
	    // Returns true if this node is missing from the actual source code. A 'missing' node is different
	    // from 'undefined/defined'. When a node is undefined (which can happen for optional nodes
	    // in the tree), it is definitely missing. However, a node may be defined, but still be
	    // missing.  This happens whenever the parser knows it needs to parse something, but can't
	    // get anything in the source code that it expects at that location. For example:
	    //
	    //          let a: ;
	    //
	    // Here, the Type in the Type-Annotation is not-optional (as there is a colon in the source
	    // code). So the parser will attempt to parse out a type, and will create an actual node.
	    // However, this node will be 'missing' in the sense that no actual source-code/tokens are
	    // contained within it.
	    function nodeIsMissing(node) {
	        if (node === undefined) {
	            return true;
	        }
	        return node.pos === node.end && node.pos >= 0 && node.kind !== 1 /* EndOfFileToken */;
	    }
	    ts.nodeIsMissing = nodeIsMissing;
	    function nodeIsPresent(node) {
	        return !nodeIsMissing(node);
	    }
	    ts.nodeIsPresent = nodeIsPresent;
	    /**
	     * Appends a range of value to begin of an array, returning the array.
	     *
	     * @param to The array to which `value` is to be appended. If `to` is `undefined`, a new array
	     * is created if `value` was appended.
	     * @param from The values to append to the array. If `from` is `undefined`, nothing is
	     * appended. If an element of `from` is `undefined`, that element is not appended.
	     */
	    function prependStatements(to, from) {
	        if (from === undefined || from.length === 0)
	            return to;
	        if (to === undefined)
	            return from.slice();
	        var prologue = to.length && isPrologueDirective(to[0]) && to.shift();
	        to.unshift.apply(to, from);
	        if (prologue) {
	            to.unshift(prologue);
	        }
	        return to;
	    }
	    ts.prependStatements = prependStatements;
	    /**
	     * Determine if the given comment is a triple-slash
	     *
	     * @return true if the comment is a triple-slash comment else false
	     */
	    function isRecognizedTripleSlashComment(text, commentPos, commentEnd) {
	        // Verify this is /// comment, but do the regexp match only when we first can find /// in the comment text
	        // so that we don't end up computing comment string and doing match for all // comments
	        if (text.charCodeAt(commentPos + 1) === 47 /* slash */ &&
	            commentPos + 2 < commentEnd &&
	            text.charCodeAt(commentPos + 2) === 47 /* slash */) {
	            var textSubStr = text.substring(commentPos, commentEnd);
	            return textSubStr.match(ts.fullTripleSlashReferencePathRegEx) ||
	                textSubStr.match(ts.fullTripleSlashAMDReferencePathRegEx) ||
	                textSubStr.match(fullTripleSlashReferenceTypeReferenceDirectiveRegEx) ||
	                textSubStr.match(defaultLibReferenceRegEx) ?
	                true : false;
	        }
	        return false;
	    }
	    ts.isRecognizedTripleSlashComment = isRecognizedTripleSlashComment;
	    function isPinnedComment(text, start) {
	        return text.charCodeAt(start + 1) === 42 /* asterisk */ &&
	            text.charCodeAt(start + 2) === 33 /* exclamation */;
	    }
	    ts.isPinnedComment = isPinnedComment;
	    function getTokenPosOfNode(node, sourceFile, includeJsDoc) {
	        // With nodes that have no width (i.e. 'Missing' nodes), we actually *don't*
	        // want to skip trivia because this will launch us forward to the next token.
	        if (nodeIsMissing(node)) {
	            return node.pos;
	        }
	        if (ts.isJSDocNode(node)) {
	            return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	        }
	        if (includeJsDoc && ts.hasJSDocNodes(node)) {
	            return getTokenPosOfNode(node.jsDoc[0]);
	        }
	        // For a syntax list, it is possible that one of its children has JSDocComment nodes, while
	        // the syntax list itself considers them as normal trivia. Therefore if we simply skip
	        // trivia for the list, we may have skipped the JSDocComment as well. So we should process its
	        // first child to determine the actual position of its first token.
	        if (node.kind === 298 /* SyntaxList */ && node._children.length > 0) {
	            return getTokenPosOfNode(node._children[0], sourceFile, includeJsDoc);
	        }
	        return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.pos);
	    }
	    ts.getTokenPosOfNode = getTokenPosOfNode;
	    function getNonDecoratorTokenPosOfNode(node, sourceFile) {
	        if (nodeIsMissing(node) || !node.decorators) {
	            return getTokenPosOfNode(node, sourceFile);
	        }
	        return ts.skipTrivia((sourceFile || getSourceFileOfNode(node)).text, node.decorators.end);
	    }
	    ts.getNonDecoratorTokenPosOfNode = getNonDecoratorTokenPosOfNode;
	    function getSourceTextOfNodeFromSourceFile(sourceFile, node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = false; }
	        return getTextOfNodeFromSourceText(sourceFile.text, node, includeTrivia);
	    }
	    ts.getSourceTextOfNodeFromSourceFile = getSourceTextOfNodeFromSourceFile;
	    function getTextOfNodeFromSourceText(sourceText, node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = false; }
	        if (nodeIsMissing(node)) {
	            return "";
	        }
	        return sourceText.substring(includeTrivia ? node.pos : ts.skipTrivia(sourceText, node.pos), node.end);
	    }
	    ts.getTextOfNodeFromSourceText = getTextOfNodeFromSourceText;
	    function getTextOfNode(node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = false; }
	        return getSourceTextOfNodeFromSourceFile(getSourceFileOfNode(node), node, includeTrivia);
	    }
	    ts.getTextOfNode = getTextOfNode;
	    function getPos(range) {
	        return range.pos;
	    }
	    /**
	     * Note: it is expected that the `nodeArray` and the `node` are within the same file.
	     * For example, searching for a `SourceFile` in a `SourceFile[]` wouldn't work.
	     */
	    function indexOfNode(nodeArray, node) {
	        return ts.binarySearch(nodeArray, node, getPos, ts.compareValues);
	    }
	    ts.indexOfNode = indexOfNode;
	    /**
	     * Gets flags that control emit behavior of a node.
	     */
	    function getEmitFlags(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.flags;
	    }
	    ts.getEmitFlags = getEmitFlags;
	    function getLiteralText(node, sourceFile) {
	        // If we don't need to downlevel and we can reach the original source text using
	        // the node's parent reference, then simply get the text as it was originally written.
	        if (!nodeIsSynthesized(node) && node.parent && !(ts.isNumericLiteral(node) && node.numericLiteralFlags & 512 /* ContainsSeparator */)) {
	            return getSourceTextOfNodeFromSourceFile(sourceFile, node);
	        }
	        var escapeText = getEmitFlags(node) & 16777216 /* NoAsciiEscaping */ ? escapeString : escapeNonAsciiString;
	        // If we can't reach the original source text, use the canonical form if it's a number,
	        // or a (possibly escaped) quoted form of the original text if it's string-like.
	        switch (node.kind) {
	            case 9 /* StringLiteral */:
	                if (node.singleQuote) {
	                    return "'" + escapeText(node.text, 39 /* singleQuote */) + "'";
	                }
	                else {
	                    return '"' + escapeText(node.text, 34 /* doubleQuote */) + '"';
	                }
	            case 13 /* NoSubstitutionTemplateLiteral */:
	                return "`" + escapeText(node.text, 96 /* backtick */) + "`";
	            case 14 /* TemplateHead */:
	                // tslint:disable-next-line no-invalid-template-strings
	                return "`" + escapeText(node.text, 96 /* backtick */) + "${";
	            case 15 /* TemplateMiddle */:
	                // tslint:disable-next-line no-invalid-template-strings
	                return "}" + escapeText(node.text, 96 /* backtick */) + "${";
	            case 16 /* TemplateTail */:
	                return "}" + escapeText(node.text, 96 /* backtick */) + "`";
	            case 8 /* NumericLiteral */:
	            case 12 /* RegularExpressionLiteral */:
	                return node.text;
	        }
	        ts.Debug.fail("Literal kind '" + node.kind + "' not accounted for.");
	    }
	    ts.getLiteralText = getLiteralText;
	    function getTextOfConstantValue(value) {
	        return ts.isString(value) ? '"' + escapeNonAsciiString(value) + '"' : "" + value;
	    }
	    ts.getTextOfConstantValue = getTextOfConstantValue;
	    // Add an extra underscore to identifiers that start with two underscores to avoid issues with magic names like '__proto__'
	    function escapeLeadingUnderscores(identifier) {
	        return (identifier.length >= 2 && identifier.charCodeAt(0) === 95 /* _ */ && identifier.charCodeAt(1) === 95 /* _ */ ? "_" + identifier : identifier);
	    }
	    ts.escapeLeadingUnderscores = escapeLeadingUnderscores;
	    /**
	     * @deprecated Use `id.escapedText` to get the escaped text of an Identifier.
	     * @param identifier The identifier to escape
	     */
	    function escapeIdentifier(identifier) {
	        return identifier;
	    }
	    ts.escapeIdentifier = escapeIdentifier;
	    // Make an identifier from an external module name by extracting the string after the last "/" and replacing
	    // all non-alphanumeric characters with underscores
	    function makeIdentifierFromModuleName(moduleName) {
	        return ts.getBaseFileName(moduleName).replace(/^(\d)/, "_$1").replace(/\W/g, "_");
	    }
	    ts.makeIdentifierFromModuleName = makeIdentifierFromModuleName;
	    function isBlockOrCatchScoped(declaration) {
	        return (ts.getCombinedNodeFlags(declaration) & 3 /* BlockScoped */) !== 0 ||
	            isCatchClauseVariableDeclarationOrBindingElement(declaration);
	    }
	    ts.isBlockOrCatchScoped = isBlockOrCatchScoped;
	    function isCatchClauseVariableDeclarationOrBindingElement(declaration) {
	        var node = getRootDeclaration(declaration);
	        return node.kind === 231 /* VariableDeclaration */ && node.parent.kind === 268 /* CatchClause */;
	    }
	    ts.isCatchClauseVariableDeclarationOrBindingElement = isCatchClauseVariableDeclarationOrBindingElement;
	    function isAmbientModule(node) {
	        return ts.isModuleDeclaration(node) && (node.name.kind === 9 /* StringLiteral */ || isGlobalScopeAugmentation(node));
	    }
	    ts.isAmbientModule = isAmbientModule;
	    function isModuleWithStringLiteralName(node) {
	        return ts.isModuleDeclaration(node) && node.name.kind === 9 /* StringLiteral */;
	    }
	    ts.isModuleWithStringLiteralName = isModuleWithStringLiteralName;
	    function isNonGlobalAmbientModule(node) {
	        return ts.isModuleDeclaration(node) && ts.isStringLiteral(node.name);
	    }
	    ts.isNonGlobalAmbientModule = isNonGlobalAmbientModule;
	    /** Given a symbol for a module, checks that it is a shorthand ambient module. */
	    function isShorthandAmbientModuleSymbol(moduleSymbol) {
	        return isShorthandAmbientModule(moduleSymbol.valueDeclaration);
	    }
	    ts.isShorthandAmbientModuleSymbol = isShorthandAmbientModuleSymbol;
	    function isShorthandAmbientModule(node) {
	        // The only kind of module that can be missing a body is a shorthand ambient module.
	        return node && node.kind === 238 /* ModuleDeclaration */ && (!node.body);
	    }
	    function isBlockScopedContainerTopLevel(node) {
	        return node.kind === 273 /* SourceFile */ ||
	            node.kind === 238 /* ModuleDeclaration */ ||
	            ts.isFunctionLike(node);
	    }
	    ts.isBlockScopedContainerTopLevel = isBlockScopedContainerTopLevel;
	    function isGlobalScopeAugmentation(module) {
	        return !!(module.flags & 512 /* GlobalAugmentation */);
	    }
	    ts.isGlobalScopeAugmentation = isGlobalScopeAugmentation;
	    function isExternalModuleAugmentation(node) {
	        return isAmbientModule(node) && isModuleAugmentationExternal(node);
	    }
	    ts.isExternalModuleAugmentation = isExternalModuleAugmentation;
	    function isModuleAugmentationExternal(node) {
	        // external module augmentation is a ambient module declaration that is either:
	        // - defined in the top level scope and source file is an external module
	        // - defined inside ambient module declaration located in the top level scope and source file not an external module
	        switch (node.parent.kind) {
	            case 273 /* SourceFile */:
	                return ts.isExternalModule(node.parent);
	            case 239 /* ModuleBlock */:
	                return isAmbientModule(node.parent.parent) && ts.isSourceFile(node.parent.parent.parent) && !ts.isExternalModule(node.parent.parent.parent);
	        }
	        return false;
	    }
	    ts.isModuleAugmentationExternal = isModuleAugmentationExternal;
	    function isEffectiveExternalModule(node, compilerOptions) {
	        return ts.isExternalModule(node) || compilerOptions.isolatedModules || ((ts.getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS) && !!node.commonJsModuleIndicator);
	    }
	    ts.isEffectiveExternalModule = isEffectiveExternalModule;
	    function isBlockScope(node, parentNode) {
	        switch (node.kind) {
	            case 273 /* SourceFile */:
	            case 240 /* CaseBlock */:
	            case 268 /* CatchClause */:
	            case 238 /* ModuleDeclaration */:
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	            case 154 /* Constructor */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	                return true;
	            case 212 /* Block */:
	                // function block is not considered block-scope container
	                // see comment in binder.ts: bind(...), case for SyntaxKind.Block
	                return parentNode && !ts.isFunctionLike(parentNode);
	        }
	        return false;
	    }
	    ts.isBlockScope = isBlockScope;
	    function isDeclarationWithTypeParameters(node) {
	        switch (node.kind) {
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 152 /* MethodSignature */:
	            case 159 /* IndexSignature */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 283 /* JSDocFunctionType */:
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	            case 235 /* InterfaceDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 295 /* JSDocTemplateTag */:
	            case 233 /* FunctionDeclaration */:
	            case 153 /* MethodDeclaration */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	            case 291 /* JSDocCallbackTag */:
	            case 296 /* JSDocTypedefTag */:
	            case 287 /* JSDocSignature */:
	                return true;
	            default:
	                ts.assertTypeIsNever(node);
	                return false;
	        }
	    }
	    ts.isDeclarationWithTypeParameters = isDeclarationWithTypeParameters;
	    function isAnyImportSyntax(node) {
	        switch (node.kind) {
	            case 243 /* ImportDeclaration */:
	            case 242 /* ImportEqualsDeclaration */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isAnyImportSyntax = isAnyImportSyntax;
	    function isLateVisibilityPaintedStatement(node) {
	        switch (node.kind) {
	            case 243 /* ImportDeclaration */:
	            case 242 /* ImportEqualsDeclaration */:
	            case 213 /* VariableStatement */:
	            case 234 /* ClassDeclaration */:
	            case 233 /* FunctionDeclaration */:
	            case 238 /* ModuleDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 235 /* InterfaceDeclaration */:
	            case 237 /* EnumDeclaration */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isLateVisibilityPaintedStatement = isLateVisibilityPaintedStatement;
	    function isAnyImportOrReExport(node) {
	        return isAnyImportSyntax(node) || ts.isExportDeclaration(node);
	    }
	    ts.isAnyImportOrReExport = isAnyImportOrReExport;
	    // Gets the nearest enclosing block scope container that has the provided node
	    // as a descendant, that is not the provided node.
	    function getEnclosingBlockScopeContainer(node) {
	        return ts.findAncestor(node.parent, function (current) { return isBlockScope(current, current.parent); });
	    }
	    ts.getEnclosingBlockScopeContainer = getEnclosingBlockScopeContainer;
	    // Return display name of an identifier
	    // Computed property names will just be emitted as "[<expr>]", where <expr> is the source
	    // text of the expression in the computed property.
	    function declarationNameToString(name) {
	        return getFullWidth(name) === 0 ? "(Missing)" : getTextOfNode(name);
	    }
	    ts.declarationNameToString = declarationNameToString;
	    function getNameFromIndexInfo(info) {
	        return info.declaration ? declarationNameToString(info.declaration.parameters[0].name) : undefined;
	    }
	    ts.getNameFromIndexInfo = getNameFromIndexInfo;
	    function getTextOfPropertyName(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	                return name.escapedText;
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                return escapeLeadingUnderscores(name.text);
	            case 146 /* ComputedPropertyName */:
	                return isStringOrNumericLiteral(name.expression) ? escapeLeadingUnderscores(name.expression.text) : undefined;
	            default:
	                ts.Debug.assertNever(name);
	        }
	    }
	    ts.getTextOfPropertyName = getTextOfPropertyName;
	    function entityNameToString(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	                return getFullWidth(name) === 0 ? ts.idText(name) : getTextOfNode(name);
	            case 145 /* QualifiedName */:
	                return entityNameToString(name.left) + "." + entityNameToString(name.right);
	            case 184 /* PropertyAccessExpression */:
	                return entityNameToString(name.expression) + "." + entityNameToString(name.name);
	        }
	    }
	    ts.entityNameToString = entityNameToString;
	    function createDiagnosticForNode(node, message, arg0, arg1, arg2, arg3) {
	        var sourceFile = getSourceFileOfNode(node);
	        return createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNode = createDiagnosticForNode;
	    function createDiagnosticForNodeArray(sourceFile, nodes, message, arg0, arg1, arg2, arg3) {
	        var start = ts.skipTrivia(sourceFile.text, nodes.pos);
	        return ts.createFileDiagnostic(sourceFile, start, nodes.end - start, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNodeArray = createDiagnosticForNodeArray;
	    function createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2, arg3) {
	        var span = getErrorSpanForNode(sourceFile, node);
	        return ts.createFileDiagnostic(sourceFile, span.start, span.length, message, arg0, arg1, arg2, arg3);
	    }
	    ts.createDiagnosticForNodeInSourceFile = createDiagnosticForNodeInSourceFile;
	    function createDiagnosticForNodeFromMessageChain(node, messageChain) {
	        var sourceFile = getSourceFileOfNode(node);
	        var span = getErrorSpanForNode(sourceFile, node);
	        return {
	            file: sourceFile,
	            start: span.start,
	            length: span.length,
	            code: messageChain.code,
	            category: messageChain.category,
	            messageText: messageChain.next ? messageChain : messageChain.messageText
	        };
	    }
	    ts.createDiagnosticForNodeFromMessageChain = createDiagnosticForNodeFromMessageChain;
	    function getSpanOfTokenAtPosition(sourceFile, pos) {
	        var scanner = ts.createScanner(sourceFile.languageVersion, /*skipTrivia*/ true, sourceFile.languageVariant, sourceFile.text, /*onError:*/ undefined, pos);
	        scanner.scan();
	        var start = scanner.getTokenPos();
	        return ts.createTextSpanFromBounds(start, scanner.getTextPos());
	    }
	    ts.getSpanOfTokenAtPosition = getSpanOfTokenAtPosition;
	    function getErrorSpanForArrowFunction(sourceFile, node) {
	        var pos = ts.skipTrivia(sourceFile.text, node.pos);
	        if (node.body && node.body.kind === 212 /* Block */) {
	            var startLine = ts.getLineAndCharacterOfPosition(sourceFile, node.body.pos).line;
	            var endLine = ts.getLineAndCharacterOfPosition(sourceFile, node.body.end).line;
	            if (startLine < endLine) {
	                // The arrow function spans multiple lines,
	                // make the error span be the first line, inclusive.
	                return ts.createTextSpan(pos, getEndLinePosition(startLine, sourceFile) - pos + 1);
	            }
	        }
	        return ts.createTextSpanFromBounds(pos, node.end);
	    }
	    function getErrorSpanForNode(sourceFile, node) {
	        var errorNode = node;
	        switch (node.kind) {
	            case 273 /* SourceFile */:
	                var pos_1 = ts.skipTrivia(sourceFile.text, 0, /*stopAfterLineBreak*/ false);
	                if (pos_1 === sourceFile.text.length) {
	                    // file is empty - return span for the beginning of the file
	                    return ts.createTextSpan(0, 0);
	                }
	                return getSpanOfTokenAtPosition(sourceFile, pos_1);
	            // This list is a work in progress. Add missing node kinds to improve their error
	            // spans.
	            case 231 /* VariableDeclaration */:
	            case 181 /* BindingElement */:
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	            case 235 /* InterfaceDeclaration */:
	            case 238 /* ModuleDeclaration */:
	            case 237 /* EnumDeclaration */:
	            case 272 /* EnumMember */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 236 /* TypeAliasDeclaration */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	                errorNode = node.name;
	                break;
	            case 192 /* ArrowFunction */:
	                return getErrorSpanForArrowFunction(sourceFile, node);
	        }
	        if (errorNode === undefined) {
	            // If we don't have a better node, then just set the error on the first token of
	            // construct.
	            return getSpanOfTokenAtPosition(sourceFile, node.pos);
	        }
	        var isMissing = nodeIsMissing(errorNode);
	        var pos = isMissing
	            ? errorNode.pos
	            : ts.skipTrivia(sourceFile.text, errorNode.pos);
	        // These asserts should all be satisfied for a properly constructed `errorNode`.
	        if (isMissing) {
	            ts.Debug.assert(pos === errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	            ts.Debug.assert(pos === errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	        }
	        else {
	            ts.Debug.assert(pos >= errorNode.pos, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	            ts.Debug.assert(pos <= errorNode.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	        }
	        return ts.createTextSpanFromBounds(pos, errorNode.end);
	    }
	    ts.getErrorSpanForNode = getErrorSpanForNode;
	    function isExternalOrCommonJsModule(file) {
	        return (file.externalModuleIndicator || file.commonJsModuleIndicator) !== undefined;
	    }
	    ts.isExternalOrCommonJsModule = isExternalOrCommonJsModule;
	    function isJsonSourceFile(file) {
	        return file.scriptKind === 6 /* JSON */;
	    }
	    ts.isJsonSourceFile = isJsonSourceFile;
	    function isConstEnumDeclaration(node) {
	        return node.kind === 237 /* EnumDeclaration */ && isConst(node);
	    }
	    ts.isConstEnumDeclaration = isConstEnumDeclaration;
	    function isConst(node) {
	        return !!(ts.getCombinedNodeFlags(node) & 2 /* Const */)
	            || !!(ts.getCombinedModifierFlags(node) & 2048 /* Const */);
	    }
	    ts.isConst = isConst;
	    function isLet(node) {
	        return !!(ts.getCombinedNodeFlags(node) & 1 /* Let */);
	    }
	    ts.isLet = isLet;
	    function isSuperCall(n) {
	        return n.kind === 186 /* CallExpression */ && n.expression.kind === 97 /* SuperKeyword */;
	    }
	    ts.isSuperCall = isSuperCall;
	    function isImportCall(n) {
	        return n.kind === 186 /* CallExpression */ && n.expression.kind === 91 /* ImportKeyword */;
	    }
	    ts.isImportCall = isImportCall;
	    function isLiteralImportTypeNode(n) {
	        return n.kind === 178 /* ImportType */ &&
	            n.argument.kind === 177 /* LiteralType */ &&
	            ts.isStringLiteral(n.argument.literal);
	    }
	    ts.isLiteralImportTypeNode = isLiteralImportTypeNode;
	    function isPrologueDirective(node) {
	        return node.kind === 215 /* ExpressionStatement */
	            && node.expression.kind === 9 /* StringLiteral */;
	    }
	    ts.isPrologueDirective = isPrologueDirective;
	    function getLeadingCommentRangesOfNode(node, sourceFileOfNode) {
	        return node.kind !== 10 /* JsxText */ ? ts.getLeadingCommentRanges(sourceFileOfNode.text, node.pos) : undefined;
	    }
	    ts.getLeadingCommentRangesOfNode = getLeadingCommentRangesOfNode;
	    function getJSDocCommentRanges(node, text) {
	        var commentRanges = (node.kind === 148 /* Parameter */ ||
	            node.kind === 147 /* TypeParameter */ ||
	            node.kind === 191 /* FunctionExpression */ ||
	            node.kind === 192 /* ArrowFunction */ ||
	            node.kind === 190 /* ParenthesizedExpression */) ?
	            ts.concatenate(ts.getTrailingCommentRanges(text, node.pos), ts.getLeadingCommentRanges(text, node.pos)) :
	            ts.getLeadingCommentRanges(text, node.pos);
	        // True if the comment starts with '/**' but not if it is '/**/'
	        return ts.filter(commentRanges, function (comment) {
	            return text.charCodeAt(comment.pos + 1) === 42 /* asterisk */ &&
	                text.charCodeAt(comment.pos + 2) === 42 /* asterisk */ &&
	                text.charCodeAt(comment.pos + 3) !== 47 /* slash */;
	        });
	    }
	    ts.getJSDocCommentRanges = getJSDocCommentRanges;
	    ts.fullTripleSlashReferencePathRegEx = /^(\/\/\/\s*<reference\s+path\s*=\s*)('|")(.+?)\2.*?\/>/;
	    var fullTripleSlashReferenceTypeReferenceDirectiveRegEx = /^(\/\/\/\s*<reference\s+types\s*=\s*)('|")(.+?)\2.*?\/>/;
	    ts.fullTripleSlashAMDReferencePathRegEx = /^(\/\/\/\s*<amd-dependency\s+path\s*=\s*)('|")(.+?)\2.*?\/>/;
	    var defaultLibReferenceRegEx = /^(\/\/\/\s*<reference\s+no-default-lib\s*=\s*)('|")(.+?)\2\s*\/>/;
	    function isPartOfTypeNode(node) {
	        if (160 /* FirstTypeNode */ <= node.kind && node.kind <= 178 /* LastTypeNode */) {
	            return true;
	        }
	        switch (node.kind) {
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 137 /* StringKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 140 /* UndefinedKeyword */:
	            case 131 /* NeverKeyword */:
	                return true;
	            case 105 /* VoidKeyword */:
	                return node.parent.kind !== 195 /* VoidExpression */;
	            case 206 /* ExpressionWithTypeArguments */:
	                return !isExpressionWithTypeArgumentsInClassExtendsClause(node);
	            case 147 /* TypeParameter */:
	                return node.parent.kind === 176 /* MappedType */ || node.parent.kind === 171 /* InferType */;
	            // Identifiers and qualified names may be type nodes, depending on their context. Climb
	            // above them to find the lowest container
	            case 71 /* Identifier */:
	                // If the identifier is the RHS of a qualified name, then it's a type iff its parent is.
	                if (node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node) {
	                    node = node.parent;
	                }
	                else if (node.parent.kind === 184 /* PropertyAccessExpression */ && node.parent.name === node) {
	                    node = node.parent;
	                }
	                // At this point, node is either a qualified name or an identifier
	                ts.Debug.assert(node.kind === 71 /* Identifier */ || node.kind === 145 /* QualifiedName */ || node.kind === 184 /* PropertyAccessExpression */, "'node' was expected to be a qualified name, identifier or property access in 'isPartOfTypeNode'.");
	            // falls through
	            case 145 /* QualifiedName */:
	            case 184 /* PropertyAccessExpression */:
	            case 99 /* ThisKeyword */:
	                var parent = node.parent;
	                if (parent.kind === 164 /* TypeQuery */) {
	                    return false;
	                }
	                if (parent.kind === 178 /* ImportType */) {
	                    return !parent.isTypeOf;
	                }
	                // Do not recursively call isPartOfTypeNode on the parent. In the example:
	                //
	                //     let a: A.B.C;
	                //
	                // Calling isPartOfTypeNode would consider the qualified name A.B a type node.
	                // Only C and A.B.C are type nodes.
	                if (160 /* FirstTypeNode */ <= parent.kind && parent.kind <= 178 /* LastTypeNode */) {
	                    return true;
	                }
	                switch (parent.kind) {
	                    case 206 /* ExpressionWithTypeArguments */:
	                        return !isExpressionWithTypeArgumentsInClassExtendsClause(parent);
	                    case 147 /* TypeParameter */:
	                        return node === parent.constraint;
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 148 /* Parameter */:
	                    case 231 /* VariableDeclaration */:
	                        return node === parent.type;
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                    case 192 /* ArrowFunction */:
	                    case 154 /* Constructor */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return node === parent.type;
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 159 /* IndexSignature */:
	                        return node === parent.type;
	                    case 189 /* TypeAssertionExpression */:
	                        return node === parent.type;
	                    case 186 /* CallExpression */:
	                    case 187 /* NewExpression */:
	                        return ts.contains(parent.typeArguments, node);
	                    case 188 /* TaggedTemplateExpression */:
	                        // TODO (drosen): TaggedTemplateExpressions may eventually support type arguments.
	                        return false;
	                }
	        }
	        return false;
	    }
	    ts.isPartOfTypeNode = isPartOfTypeNode;
	    function isChildOfNodeWithKind(node, kind) {
	        while (node) {
	            if (node.kind === kind) {
	                return true;
	            }
	            node = node.parent;
	        }
	        return false;
	    }
	    ts.isChildOfNodeWithKind = isChildOfNodeWithKind;
	    // Warning: This has the same semantics as the forEach family of functions,
	    //          in that traversal terminates in the event that 'visitor' supplies a truthy value.
	    function forEachReturnStatement(body, visitor) {
	        return traverse(body);
	        function traverse(node) {
	            switch (node.kind) {
	                case 224 /* ReturnStatement */:
	                    return visitor(node);
	                case 240 /* CaseBlock */:
	                case 212 /* Block */:
	                case 216 /* IfStatement */:
	                case 217 /* DoStatement */:
	                case 218 /* WhileStatement */:
	                case 219 /* ForStatement */:
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                case 225 /* WithStatement */:
	                case 226 /* SwitchStatement */:
	                case 265 /* CaseClause */:
	                case 266 /* DefaultClause */:
	                case 227 /* LabeledStatement */:
	                case 229 /* TryStatement */:
	                case 268 /* CatchClause */:
	                    return ts.forEachChild(node, traverse);
	            }
	        }
	    }
	    ts.forEachReturnStatement = forEachReturnStatement;
	    function forEachYieldExpression(body, visitor) {
	        return traverse(body);
	        function traverse(node) {
	            switch (node.kind) {
	                case 202 /* YieldExpression */:
	                    visitor(node);
	                    var operand = node.expression;
	                    if (operand) {
	                        traverse(operand);
	                    }
	                    return;
	                case 237 /* EnumDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                    // These are not allowed inside a generator now, but eventually they may be allowed
	                    // as local types. Regardless, any yield statements contained within them should be
	                    // skipped in this traversal.
	                    return;
	                default:
	                    if (ts.isFunctionLike(node)) {
	                        if (node.name && node.name.kind === 146 /* ComputedPropertyName */) {
	                            // Note that we will not include methods/accessors of a class because they would require
	                            // first descending into the class. This is by design.
	                            traverse(node.name.expression);
	                            return;
	                        }
	                    }
	                    else if (!isPartOfTypeNode(node)) {
	                        // This is the general case, which should include mostly expressions and statements.
	                        // Also includes NodeArrays.
	                        ts.forEachChild(node, traverse);
	                    }
	            }
	        }
	    }
	    ts.forEachYieldExpression = forEachYieldExpression;
	    /**
	     * Gets the most likely element type for a TypeNode. This is not an exhaustive test
	     * as it assumes a rest argument can only be an array type (either T[], or Array<T>).
	     *
	     * @param node The type node.
	     */
	    function getRestParameterElementType(node) {
	        if (node && node.kind === 166 /* ArrayType */) {
	            return node.elementType;
	        }
	        else if (node && node.kind === 161 /* TypeReference */) {
	            return ts.singleOrUndefined(node.typeArguments);
	        }
	        else {
	            return undefined;
	        }
	    }
	    ts.getRestParameterElementType = getRestParameterElementType;
	    function getMembersOfDeclaration(node) {
	        switch (node.kind) {
	            case 235 /* InterfaceDeclaration */:
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	            case 165 /* TypeLiteral */:
	                return node.members;
	            case 183 /* ObjectLiteralExpression */:
	                return node.properties;
	        }
	    }
	    ts.getMembersOfDeclaration = getMembersOfDeclaration;
	    function isVariableLike(node) {
	        if (node) {
	            switch (node.kind) {
	                case 181 /* BindingElement */:
	                case 272 /* EnumMember */:
	                case 148 /* Parameter */:
	                case 269 /* PropertyAssignment */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 270 /* ShorthandPropertyAssignment */:
	                case 231 /* VariableDeclaration */:
	                    return true;
	            }
	        }
	        return false;
	    }
	    ts.isVariableLike = isVariableLike;
	    function isVariableLikeOrAccessor(node) {
	        return isVariableLike(node) || ts.isAccessor(node);
	    }
	    ts.isVariableLikeOrAccessor = isVariableLikeOrAccessor;
	    function isVariableDeclarationInVariableStatement(node) {
	        return node.parent.kind === 232 /* VariableDeclarationList */
	            && node.parent.parent.kind === 213 /* VariableStatement */;
	    }
	    ts.isVariableDeclarationInVariableStatement = isVariableDeclarationInVariableStatement;
	    function isValidESSymbolDeclaration(node) {
	        return ts.isVariableDeclaration(node) ? isConst(node) && ts.isIdentifier(node.name) && isVariableDeclarationInVariableStatement(node) :
	            ts.isPropertyDeclaration(node) ? hasReadonlyModifier(node) && hasStaticModifier(node) :
	                ts.isPropertySignature(node) && hasReadonlyModifier(node);
	    }
	    ts.isValidESSymbolDeclaration = isValidESSymbolDeclaration;
	    function introducesArgumentsExoticObject(node) {
	        switch (node.kind) {
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.introducesArgumentsExoticObject = introducesArgumentsExoticObject;
	    function unwrapInnermostStatementOfLabel(node, beforeUnwrapLabelCallback) {
	        while (true) {
	            if (beforeUnwrapLabelCallback) {
	                beforeUnwrapLabelCallback(node);
	            }
	            if (node.statement.kind !== 227 /* LabeledStatement */) {
	                return node.statement;
	            }
	            node = node.statement;
	        }
	    }
	    ts.unwrapInnermostStatementOfLabel = unwrapInnermostStatementOfLabel;
	    function isFunctionBlock(node) {
	        return node && node.kind === 212 /* Block */ && ts.isFunctionLike(node.parent);
	    }
	    ts.isFunctionBlock = isFunctionBlock;
	    function isObjectLiteralMethod(node) {
	        return node && node.kind === 153 /* MethodDeclaration */ && node.parent.kind === 183 /* ObjectLiteralExpression */;
	    }
	    ts.isObjectLiteralMethod = isObjectLiteralMethod;
	    function isObjectLiteralOrClassExpressionMethod(node) {
	        return node.kind === 153 /* MethodDeclaration */ &&
	            (node.parent.kind === 183 /* ObjectLiteralExpression */ ||
	                node.parent.kind === 204 /* ClassExpression */);
	    }
	    ts.isObjectLiteralOrClassExpressionMethod = isObjectLiteralOrClassExpressionMethod;
	    function isIdentifierTypePredicate(predicate) {
	        return predicate && predicate.kind === 1 /* Identifier */;
	    }
	    ts.isIdentifierTypePredicate = isIdentifierTypePredicate;
	    function isThisTypePredicate(predicate) {
	        return predicate && predicate.kind === 0 /* This */;
	    }
	    ts.isThisTypePredicate = isThisTypePredicate;
	    function getPropertyAssignment(objectLiteral, key, key2) {
	        return objectLiteral.properties.filter(function (property) {
	            if (property.kind === 269 /* PropertyAssignment */) {
	                var propName = getTextOfPropertyName(property.name);
	                return key === propName || (key2 && key2 === propName);
	            }
	        });
	    }
	    ts.getPropertyAssignment = getPropertyAssignment;
	    function getTsConfigObjectLiteralExpression(tsConfigSourceFile) {
	        if (tsConfigSourceFile && tsConfigSourceFile.statements.length) {
	            var expression = tsConfigSourceFile.statements[0].expression;
	            return ts.isObjectLiteralExpression(expression) && expression;
	        }
	    }
	    ts.getTsConfigObjectLiteralExpression = getTsConfigObjectLiteralExpression;
	    function getTsConfigPropArrayElementValue(tsConfigSourceFile, propKey, elementValue) {
	        return ts.firstDefined(getTsConfigPropArray(tsConfigSourceFile, propKey), function (property) {
	            return ts.isArrayLiteralExpression(property.initializer) ?
	                ts.find(property.initializer.elements, function (element) { return ts.isStringLiteral(element) && element.text === elementValue; }) :
	                undefined;
	        });
	    }
	    ts.getTsConfigPropArrayElementValue = getTsConfigPropArrayElementValue;
	    function getTsConfigPropArray(tsConfigSourceFile, propKey) {
	        var jsonObjectLiteral = getTsConfigObjectLiteralExpression(tsConfigSourceFile);
	        return jsonObjectLiteral ? getPropertyAssignment(jsonObjectLiteral, propKey) : ts.emptyArray;
	    }
	    ts.getTsConfigPropArray = getTsConfigPropArray;
	    function getContainingFunction(node) {
	        return ts.findAncestor(node.parent, ts.isFunctionLike);
	    }
	    ts.getContainingFunction = getContainingFunction;
	    function getContainingClass(node) {
	        return ts.findAncestor(node.parent, ts.isClassLike);
	    }
	    ts.getContainingClass = getContainingClass;
	    function getThisContainer(node, includeArrowFunctions) {
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return undefined;
	            }
	            switch (node.kind) {
	                case 146 /* ComputedPropertyName */:
	                    // If the grandparent node is an object literal (as opposed to a class),
	                    // then the computed property is not a 'this' container.
	                    // A computed property name in a class needs to be a this container
	                    // so that we can error on it.
	                    if (ts.isClassLike(node.parent.parent)) {
	                        return node;
	                    }
	                    // If this is a computed property, then the parent should not
	                    // make it a this container. The parent might be a property
	                    // in an object literal, like a method or accessor. But in order for
	                    // such a parent to be a this container, the reference must be in
	                    // the *body* of the container.
	                    node = node.parent;
	                    break;
	                case 149 /* Decorator */:
	                    // Decorators are always applied outside of the body of a class or method.
	                    if (node.parent.kind === 148 /* Parameter */ && ts.isClassElement(node.parent.parent)) {
	                        // If the decorator's parent is a Parameter, we resolve the this container from
	                        // the grandparent class declaration.
	                        node = node.parent.parent;
	                    }
	                    else if (ts.isClassElement(node.parent)) {
	                        // If the decorator's parent is a class element, we resolve the 'this' container
	                        // from the parent class declaration.
	                        node = node.parent;
	                    }
	                    break;
	                case 192 /* ArrowFunction */:
	                    if (!includeArrowFunctions) {
	                        continue;
	                    }
	                // falls through
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 238 /* ModuleDeclaration */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                case 237 /* EnumDeclaration */:
	                case 273 /* SourceFile */:
	                    return node;
	            }
	        }
	    }
	    ts.getThisContainer = getThisContainer;
	    function getNewTargetContainer(node) {
	        var container = getThisContainer(node, /*includeArrowFunctions*/ false);
	        if (container) {
	            switch (container.kind) {
	                case 154 /* Constructor */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                    return container;
	            }
	        }
	        return undefined;
	    }
	    ts.getNewTargetContainer = getNewTargetContainer;
	    /**
	     * Given an super call/property node, returns the closest node where
	     * - a super call/property access is legal in the node and not legal in the parent node the node.
	     *   i.e. super call is legal in constructor but not legal in the class body.
	     * - the container is an arrow function (so caller might need to call getSuperContainer again in case it needs to climb higher)
	     * - a super call/property is definitely illegal in the container (but might be legal in some subnode)
	     *   i.e. super property access is illegal in function declaration but can be legal in the statement list
	     */
	    function getSuperContainer(node, stopOnFunctions) {
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return node;
	            }
	            switch (node.kind) {
	                case 146 /* ComputedPropertyName */:
	                    node = node.parent;
	                    break;
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    if (!stopOnFunctions) {
	                        continue;
	                    }
	                // falls through
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return node;
	                case 149 /* Decorator */:
	                    // Decorators are always applied outside of the body of a class or method.
	                    if (node.parent.kind === 148 /* Parameter */ && ts.isClassElement(node.parent.parent)) {
	                        // If the decorator's parent is a Parameter, we resolve the this container from
	                        // the grandparent class declaration.
	                        node = node.parent.parent;
	                    }
	                    else if (ts.isClassElement(node.parent)) {
	                        // If the decorator's parent is a class element, we resolve the 'this' container
	                        // from the parent class declaration.
	                        node = node.parent;
	                    }
	                    break;
	            }
	        }
	    }
	    ts.getSuperContainer = getSuperContainer;
	    function getImmediatelyInvokedFunctionExpression(func) {
	        if (func.kind === 191 /* FunctionExpression */ || func.kind === 192 /* ArrowFunction */) {
	            var prev = func;
	            var parent = func.parent;
	            while (parent.kind === 190 /* ParenthesizedExpression */) {
	                prev = parent;
	                parent = parent.parent;
	            }
	            if (parent.kind === 186 /* CallExpression */ && parent.expression === prev) {
	                return parent;
	            }
	        }
	    }
	    ts.getImmediatelyInvokedFunctionExpression = getImmediatelyInvokedFunctionExpression;
	    /**
	     * Determines whether a node is a property or element access expression for `super`.
	     */
	    function isSuperProperty(node) {
	        var kind = node.kind;
	        return (kind === 184 /* PropertyAccessExpression */ || kind === 185 /* ElementAccessExpression */)
	            && node.expression.kind === 97 /* SuperKeyword */;
	    }
	    ts.isSuperProperty = isSuperProperty;
	    /**
	     * Determines whether a node is a property or element access expression for `this`.
	     */
	    function isThisProperty(node) {
	        var kind = node.kind;
	        return (kind === 184 /* PropertyAccessExpression */ || kind === 185 /* ElementAccessExpression */)
	            && node.expression.kind === 99 /* ThisKeyword */;
	    }
	    ts.isThisProperty = isThisProperty;
	    function getEntityNameFromTypeNode(node) {
	        switch (node.kind) {
	            case 161 /* TypeReference */:
	                return node.typeName;
	            case 206 /* ExpressionWithTypeArguments */:
	                return isEntityNameExpression(node.expression)
	                    ? node.expression
	                    : undefined;
	            case 71 /* Identifier */:
	            case 145 /* QualifiedName */:
	                return node;
	        }
	        return undefined;
	    }
	    ts.getEntityNameFromTypeNode = getEntityNameFromTypeNode;
	    function getInvokedExpression(node) {
	        switch (node.kind) {
	            case 188 /* TaggedTemplateExpression */:
	                return node.tag;
	            case 256 /* JsxOpeningElement */:
	            case 255 /* JsxSelfClosingElement */:
	                return node.tagName;
	            default:
	                return node.expression;
	        }
	    }
	    ts.getInvokedExpression = getInvokedExpression;
	    function nodeCanBeDecorated(node, parent, grandparent) {
	        switch (node.kind) {
	            case 234 /* ClassDeclaration */:
	                // classes are valid targets
	                return true;
	            case 151 /* PropertyDeclaration */:
	                // property declarations are valid if their parent is a class declaration.
	                return parent.kind === 234 /* ClassDeclaration */;
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 153 /* MethodDeclaration */:
	                // if this method has a body and its parent is a class declaration, this is a valid target.
	                return node.body !== undefined
	                    && parent.kind === 234 /* ClassDeclaration */;
	            case 148 /* Parameter */:
	                // if the parameter's parent has a body and its grandparent is a class declaration, this is a valid target;
	                return parent.body !== undefined
	                    && (parent.kind === 154 /* Constructor */
	                        || parent.kind === 153 /* MethodDeclaration */
	                        || parent.kind === 156 /* SetAccessor */)
	                    && grandparent.kind === 234 /* ClassDeclaration */;
	        }
	        return false;
	    }
	    ts.nodeCanBeDecorated = nodeCanBeDecorated;
	    function nodeIsDecorated(node, parent, grandparent) {
	        return node.decorators !== undefined
	            && nodeCanBeDecorated(node, parent, grandparent);
	    }
	    ts.nodeIsDecorated = nodeIsDecorated;
	    function nodeOrChildIsDecorated(node, parent, grandparent) {
	        return nodeIsDecorated(node, parent, grandparent) || childIsDecorated(node, parent);
	    }
	    ts.nodeOrChildIsDecorated = nodeOrChildIsDecorated;
	    function childIsDecorated(node, parent) {
	        switch (node.kind) {
	            case 234 /* ClassDeclaration */:
	                return ts.forEach(node.members, function (m) { return nodeOrChildIsDecorated(m, node, parent); });
	            case 153 /* MethodDeclaration */:
	            case 156 /* SetAccessor */:
	                return ts.forEach(node.parameters, function (p) { return nodeIsDecorated(p, node, parent); });
	        }
	    }
	    ts.childIsDecorated = childIsDecorated;
	    function isJSXTagName(node) {
	        var parent = node.parent;
	        if (parent.kind === 256 /* JsxOpeningElement */ ||
	            parent.kind === 255 /* JsxSelfClosingElement */ ||
	            parent.kind === 257 /* JsxClosingElement */) {
	            return parent.tagName === node;
	        }
	        return false;
	    }
	    ts.isJSXTagName = isJSXTagName;
	    function isExpressionNode(node) {
	        switch (node.kind) {
	            case 97 /* SuperKeyword */:
	            case 95 /* NullKeyword */:
	            case 101 /* TrueKeyword */:
	            case 86 /* FalseKeyword */:
	            case 12 /* RegularExpressionLiteral */:
	            case 182 /* ArrayLiteralExpression */:
	            case 183 /* ObjectLiteralExpression */:
	            case 184 /* PropertyAccessExpression */:
	            case 185 /* ElementAccessExpression */:
	            case 186 /* CallExpression */:
	            case 187 /* NewExpression */:
	            case 188 /* TaggedTemplateExpression */:
	            case 207 /* AsExpression */:
	            case 189 /* TypeAssertionExpression */:
	            case 208 /* NonNullExpression */:
	            case 190 /* ParenthesizedExpression */:
	            case 191 /* FunctionExpression */:
	            case 204 /* ClassExpression */:
	            case 192 /* ArrowFunction */:
	            case 195 /* VoidExpression */:
	            case 193 /* DeleteExpression */:
	            case 194 /* TypeOfExpression */:
	            case 197 /* PrefixUnaryExpression */:
	            case 198 /* PostfixUnaryExpression */:
	            case 199 /* BinaryExpression */:
	            case 200 /* ConditionalExpression */:
	            case 203 /* SpreadElement */:
	            case 201 /* TemplateExpression */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 205 /* OmittedExpression */:
	            case 254 /* JsxElement */:
	            case 255 /* JsxSelfClosingElement */:
	            case 258 /* JsxFragment */:
	            case 202 /* YieldExpression */:
	            case 196 /* AwaitExpression */:
	            case 209 /* MetaProperty */:
	                return true;
	            case 145 /* QualifiedName */:
	                while (node.parent.kind === 145 /* QualifiedName */) {
	                    node = node.parent;
	                }
	                return node.parent.kind === 164 /* TypeQuery */ || isJSXTagName(node);
	            case 71 /* Identifier */:
	                if (node.parent.kind === 164 /* TypeQuery */ || isJSXTagName(node)) {
	                    return true;
	                }
	            // falls through
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 99 /* ThisKeyword */:
	                return isInExpressionContext(node);
	            default:
	                return false;
	        }
	    }
	    ts.isExpressionNode = isExpressionNode;
	    function isInExpressionContext(node) {
	        var parent = node.parent;
	        switch (parent.kind) {
	            case 231 /* VariableDeclaration */:
	            case 148 /* Parameter */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 272 /* EnumMember */:
	            case 269 /* PropertyAssignment */:
	            case 181 /* BindingElement */:
	                return parent.initializer === node;
	            case 215 /* ExpressionStatement */:
	            case 216 /* IfStatement */:
	            case 217 /* DoStatement */:
	            case 218 /* WhileStatement */:
	            case 224 /* ReturnStatement */:
	            case 225 /* WithStatement */:
	            case 226 /* SwitchStatement */:
	            case 265 /* CaseClause */:
	            case 228 /* ThrowStatement */:
	                return parent.expression === node;
	            case 219 /* ForStatement */:
	                var forStatement = parent;
	                return (forStatement.initializer === node && forStatement.initializer.kind !== 232 /* VariableDeclarationList */) ||
	                    forStatement.condition === node ||
	                    forStatement.incrementor === node;
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	                var forInStatement = parent;
	                return (forInStatement.initializer === node && forInStatement.initializer.kind !== 232 /* VariableDeclarationList */) ||
	                    forInStatement.expression === node;
	            case 189 /* TypeAssertionExpression */:
	            case 207 /* AsExpression */:
	                return node === parent.expression;
	            case 210 /* TemplateSpan */:
	                return node === parent.expression;
	            case 146 /* ComputedPropertyName */:
	                return node === parent.expression;
	            case 149 /* Decorator */:
	            case 264 /* JsxExpression */:
	            case 263 /* JsxSpreadAttribute */:
	            case 271 /* SpreadAssignment */:
	                return true;
	            case 206 /* ExpressionWithTypeArguments */:
	                return parent.expression === node && isExpressionWithTypeArgumentsInClassExtendsClause(parent);
	            default:
	                return isExpressionNode(parent);
	        }
	    }
	    ts.isInExpressionContext = isInExpressionContext;
	    function isExternalModuleImportEqualsDeclaration(node) {
	        return node.kind === 242 /* ImportEqualsDeclaration */ && node.moduleReference.kind === 253 /* ExternalModuleReference */;
	    }
	    ts.isExternalModuleImportEqualsDeclaration = isExternalModuleImportEqualsDeclaration;
	    function getExternalModuleImportEqualsDeclarationExpression(node) {
	        ts.Debug.assert(isExternalModuleImportEqualsDeclaration(node));
	        return node.moduleReference.expression;
	    }
	    ts.getExternalModuleImportEqualsDeclarationExpression = getExternalModuleImportEqualsDeclarationExpression;
	    function isInternalModuleImportEqualsDeclaration(node) {
	        return node.kind === 242 /* ImportEqualsDeclaration */ && node.moduleReference.kind !== 253 /* ExternalModuleReference */;
	    }
	    ts.isInternalModuleImportEqualsDeclaration = isInternalModuleImportEqualsDeclaration;
	    function isSourceFileJavaScript(file) {
	        return isInJavaScriptFile(file);
	    }
	    ts.isSourceFileJavaScript = isSourceFileJavaScript;
	    function isSourceFileNotJavaScript(file) {
	        return !isInJavaScriptFile(file);
	    }
	    ts.isSourceFileNotJavaScript = isSourceFileNotJavaScript;
	    function isInJavaScriptFile(node) {
	        return node && !!(node.flags & 65536 /* JavaScriptFile */);
	    }
	    ts.isInJavaScriptFile = isInJavaScriptFile;
	    function isInJsonFile(node) {
	        return node && !!(node.flags & 16777216 /* JsonFile */);
	    }
	    ts.isInJsonFile = isInJsonFile;
	    function isInJSDoc(node) {
	        return node && !!(node.flags & 2097152 /* JSDoc */);
	    }
	    ts.isInJSDoc = isInJSDoc;
	    function isJSDocIndexSignature(node) {
	        return ts.isTypeReferenceNode(node) &&
	            ts.isIdentifier(node.typeName) &&
	            node.typeName.escapedText === "Object" &&
	            node.typeArguments && node.typeArguments.length === 2 &&
	            (node.typeArguments[0].kind === 137 /* StringKeyword */ || node.typeArguments[0].kind === 134 /* NumberKeyword */);
	    }
	    ts.isJSDocIndexSignature = isJSDocIndexSignature;
	    function isRequireCall(callExpression, checkArgumentIsStringLiteralLike) {
	        if (callExpression.kind !== 186 /* CallExpression */) {
	            return false;
	        }
	        var _a = callExpression, expression = _a.expression, args = _a.arguments;
	        if (expression.kind !== 71 /* Identifier */ || expression.escapedText !== "require") {
	            return false;
	        }
	        if (args.length !== 1) {
	            return false;
	        }
	        var arg = args[0];
	        return !checkArgumentIsStringLiteralLike || ts.isStringLiteralLike(arg);
	    }
	    ts.isRequireCall = isRequireCall;
	    function isSingleOrDoubleQuote(charCode) {
	        return charCode === 39 /* singleQuote */ || charCode === 34 /* doubleQuote */;
	    }
	    ts.isSingleOrDoubleQuote = isSingleOrDoubleQuote;
	    function isStringDoubleQuoted(str, sourceFile) {
	        return getSourceTextOfNodeFromSourceFile(sourceFile, str).charCodeAt(0) === 34 /* doubleQuote */;
	    }
	    ts.isStringDoubleQuoted = isStringDoubleQuoted;
	    /**
	     * Given the symbol of a declaration, find the symbol of its Javascript container-like initializer,
	     * if it has one. Otherwise just return the original symbol.
	     *
	     * Container-like initializer behave like namespaces, so the binder needs to add contained symbols
	     * to their exports. An example is a function with assignments to `this` inside.
	     */
	    function getJSInitializerSymbol(symbol) {
	        if (!symbol || !symbol.valueDeclaration) {
	            return symbol;
	        }
	        var declaration = symbol.valueDeclaration;
	        var e = getDeclaredJavascriptInitializer(declaration) || getAssignedJavascriptInitializer(declaration);
	        return e && e.symbol ? e.symbol : symbol;
	    }
	    ts.getJSInitializerSymbol = getJSInitializerSymbol;
	    /** Get the declaration initializer, when the initializer is container-like (See getJavascriptInitializer) */
	    function getDeclaredJavascriptInitializer(node) {
	        if (node && ts.isVariableDeclaration(node) && node.initializer) {
	            return getJavascriptInitializer(node.initializer, /*isPrototypeAssignment*/ false) ||
	                ts.isIdentifier(node.name) && getDefaultedJavascriptInitializer(node.name, node.initializer, /*isPrototypeAssignment*/ false);
	        }
	    }
	    ts.getDeclaredJavascriptInitializer = getDeclaredJavascriptInitializer;
	    /**
	     * Get the assignment 'initializer' -- the righthand side-- when the initializer is container-like (See getJavascriptInitializer).
	     * We treat the right hand side of assignments with container-like initalizers as declarations.
	     */
	    function getAssignedJavascriptInitializer(node) {
	        if (node && node.parent && ts.isBinaryExpression(node.parent) && node.parent.operatorToken.kind === 58 /* EqualsToken */) {
	            var isPrototypeAssignment = isPrototypeAccess(node.parent.left);
	            return getJavascriptInitializer(node.parent.right, isPrototypeAssignment) ||
	                getDefaultedJavascriptInitializer(node.parent.left, node.parent.right, isPrototypeAssignment);
	        }
	    }
	    ts.getAssignedJavascriptInitializer = getAssignedJavascriptInitializer;
	    /**
	     * Recognized Javascript container-like initializers are:
	     * 1. (function() {})() -- IIFEs
	     * 2. function() { } -- Function expressions
	     * 3. class { } -- Class expressions
	     * 4. {} -- Empty object literals
	     * 5. { ... } -- Non-empty object literals, when used to initialize a prototype, like `C.prototype = { m() { } }`
	     *
	     * This function returns the provided initializer, or undefined if it is not valid.
	     */
	    function getJavascriptInitializer(initializer, isPrototypeAssignment) {
	        if (ts.isCallExpression(initializer)) {
	            var e = skipParentheses(initializer.expression);
	            return e.kind === 191 /* FunctionExpression */ || e.kind === 192 /* ArrowFunction */ ? initializer : undefined;
	        }
	        if (initializer.kind === 191 /* FunctionExpression */ ||
	            initializer.kind === 204 /* ClassExpression */ ||
	            initializer.kind === 192 /* ArrowFunction */) {
	            return initializer;
	        }
	        if (ts.isObjectLiteralExpression(initializer) && (initializer.properties.length === 0 || isPrototypeAssignment)) {
	            return initializer;
	        }
	    }
	    ts.getJavascriptInitializer = getJavascriptInitializer;
	    /**
	     * A defaulted Javascript initializer matches the pattern
	     * `Lhs = Lhs || JavascriptInitializer`
	     * or `var Lhs = Lhs || JavascriptInitializer`
	     *
	     * The second Lhs is required to be the same as the first except that it may be prefixed with
	     * 'window.', 'global.' or 'self.' The second Lhs is otherwise ignored by the binder and checker.
	     */
	    function getDefaultedJavascriptInitializer(name, initializer, isPrototypeAssignment) {
	        var e = ts.isBinaryExpression(initializer) && initializer.operatorToken.kind === 54 /* BarBarToken */ && getJavascriptInitializer(initializer.right, isPrototypeAssignment);
	        if (e && isSameEntityName(name, initializer.left)) {
	            return e;
	        }
	    }
	    /** Given a Javascript initializer, return the outer name. That is, the lhs of the assignment or the declaration name. */
	    function getOuterNameOfJsInitializer(node) {
	        if (ts.isBinaryExpression(node.parent)) {
	            var parent = (node.parent.operatorToken.kind === 54 /* BarBarToken */ && ts.isBinaryExpression(node.parent.parent)) ? node.parent.parent : node.parent;
	            if (parent.operatorToken.kind === 58 /* EqualsToken */ && ts.isIdentifier(parent.left)) {
	                return parent.left;
	            }
	        }
	        else if (ts.isVariableDeclaration(node.parent)) {
	            return node.parent.name;
	        }
	    }
	    ts.getOuterNameOfJsInitializer = getOuterNameOfJsInitializer;
	    /**
	     * Is the 'declared' name the same as the one in the initializer?
	     * @return true for identical entity names, as well as ones where the initializer is prefixed with
	     * 'window', 'self' or 'global'. For example:
	     *
	     * var my = my || {}
	     * var min = window.min || {}
	     * my.app = self.my.app || class { }
	     */
	    function isSameEntityName(name, initializer) {
	        if (ts.isIdentifier(name) && ts.isIdentifier(initializer)) {
	            return name.escapedText === initializer.escapedText;
	        }
	        if (ts.isIdentifier(name) && ts.isPropertyAccessExpression(initializer)) {
	            return (initializer.expression.kind === 99 /* ThisKeyword */ ||
	                ts.isIdentifier(initializer.expression) &&
	                    (initializer.expression.escapedText === "window" ||
	                        initializer.expression.escapedText === "self" ||
	                        initializer.expression.escapedText === "global")) &&
	                isSameEntityName(name, initializer.name);
	        }
	        if (ts.isPropertyAccessExpression(name) && ts.isPropertyAccessExpression(initializer)) {
	            return name.name.escapedText === initializer.name.escapedText && isSameEntityName(name.expression, initializer.expression);
	        }
	        return false;
	    }
	    function getRightMostAssignedExpression(node) {
	        while (isAssignmentExpression(node, /*excludeCompoundAssignements*/ true)) {
	            node = node.right;
	        }
	        return node;
	    }
	    ts.getRightMostAssignedExpression = getRightMostAssignedExpression;
	    function isExportsIdentifier(node) {
	        return ts.isIdentifier(node) && node.escapedText === "exports";
	    }
	    ts.isExportsIdentifier = isExportsIdentifier;
	    function isModuleExportsPropertyAccessExpression(node) {
	        return ts.isPropertyAccessExpression(node) && ts.isIdentifier(node.expression) && node.expression.escapedText === "module" && node.name.escapedText === "exports";
	    }
	    ts.isModuleExportsPropertyAccessExpression = isModuleExportsPropertyAccessExpression;
	    /// Given a BinaryExpression, returns SpecialPropertyAssignmentKind for the various kinds of property
	    /// assignments we treat as special in the binder
	    function getSpecialPropertyAssignmentKind(expr) {
	        if (!isInJavaScriptFile(expr) ||
	            expr.operatorToken.kind !== 58 /* EqualsToken */ ||
	            !ts.isPropertyAccessExpression(expr.left)) {
	            return 0 /* None */;
	        }
	        var lhs = expr.left;
	        if (lhs.expression.kind === 99 /* ThisKeyword */) {
	            return 4 /* ThisProperty */;
	        }
	        else if (ts.isIdentifier(lhs.expression) && lhs.expression.escapedText === "module" && lhs.name.escapedText === "exports") {
	            // module.exports = expr
	            return 2 /* ModuleExports */;
	        }
	        else if (isEntityNameExpression(lhs.expression)) {
	            if (lhs.name.escapedText === "prototype" && ts.isObjectLiteralExpression(getInitializerOfBinaryExpression(expr))) {
	                // F.prototype = { ... }
	                return 6 /* Prototype */;
	            }
	            else if (isPrototypeAccess(lhs.expression)) {
	                // F.G....prototype.x = expr
	                return 3 /* PrototypeProperty */;
	            }
	            var nextToLast = lhs;
	            while (ts.isPropertyAccessExpression(nextToLast.expression)) {
	                nextToLast = nextToLast.expression;
	            }
	            ts.Debug.assert(ts.isIdentifier(nextToLast.expression));
	            var id = nextToLast.expression;
	            if (id.escapedText === "exports" ||
	                id.escapedText === "module" && nextToLast.name.escapedText === "exports") {
	                // exports.name = expr OR module.exports.name = expr
	                return 1 /* ExportsProperty */;
	            }
	            // F.G...x = expr
	            return 5 /* Property */;
	        }
	        return 0 /* None */;
	    }
	    ts.getSpecialPropertyAssignmentKind = getSpecialPropertyAssignmentKind;
	    function getInitializerOfBinaryExpression(expr) {
	        while (ts.isBinaryExpression(expr.right)) {
	            expr = expr.right;
	        }
	        return expr.right;
	    }
	    ts.getInitializerOfBinaryExpression = getInitializerOfBinaryExpression;
	    function isPrototypePropertyAssignment(node) {
	        return ts.isBinaryExpression(node) && getSpecialPropertyAssignmentKind(node) === 3 /* PrototypeProperty */;
	    }
	    ts.isPrototypePropertyAssignment = isPrototypePropertyAssignment;
	    function isSpecialPropertyDeclaration(expr) {
	        return isInJavaScriptFile(expr) &&
	            expr.parent && expr.parent.kind === 215 /* ExpressionStatement */ &&
	            !!ts.getJSDocTypeTag(expr.parent);
	    }
	    ts.isSpecialPropertyDeclaration = isSpecialPropertyDeclaration;
	    function importFromModuleSpecifier(node) {
	        return tryGetImportFromModuleSpecifier(node) || ts.Debug.fail(ts.Debug.showSyntaxKind(node.parent));
	    }
	    ts.importFromModuleSpecifier = importFromModuleSpecifier;
	    function tryGetImportFromModuleSpecifier(node) {
	        switch (node.parent.kind) {
	            case 243 /* ImportDeclaration */:
	            case 249 /* ExportDeclaration */:
	                return node.parent;
	            case 253 /* ExternalModuleReference */:
	                return node.parent.parent;
	            case 186 /* CallExpression */:
	                return node.parent;
	            case 177 /* LiteralType */:
	                ts.Debug.assert(ts.isStringLiteral(node));
	                return ts.tryCast(node.parent.parent, ts.isImportTypeNode);
	            default:
	                return undefined;
	        }
	    }
	    ts.tryGetImportFromModuleSpecifier = tryGetImportFromModuleSpecifier;
	    function getExternalModuleName(node) {
	        switch (node.kind) {
	            case 243 /* ImportDeclaration */:
	            case 249 /* ExportDeclaration */:
	                return node.moduleSpecifier;
	            case 242 /* ImportEqualsDeclaration */:
	                return node.moduleReference.kind === 253 /* ExternalModuleReference */ ? node.moduleReference.expression : undefined;
	            case 178 /* ImportType */:
	                return isLiteralImportTypeNode(node) ? node.argument.literal : undefined;
	            default:
	                return ts.Debug.assertNever(node);
	        }
	    }
	    ts.getExternalModuleName = getExternalModuleName;
	    function getNamespaceDeclarationNode(node) {
	        switch (node.kind) {
	            case 243 /* ImportDeclaration */:
	                return node.importClause && ts.tryCast(node.importClause.namedBindings, ts.isNamespaceImport);
	            case 242 /* ImportEqualsDeclaration */:
	                return node;
	            case 249 /* ExportDeclaration */:
	                return undefined;
	            default:
	                return ts.Debug.assertNever(node);
	        }
	    }
	    ts.getNamespaceDeclarationNode = getNamespaceDeclarationNode;
	    function isDefaultImport(node) {
	        return node.kind === 243 /* ImportDeclaration */ && node.importClause && !!node.importClause.name;
	    }
	    ts.isDefaultImport = isDefaultImport;
	    function hasQuestionToken(node) {
	        if (node) {
	            switch (node.kind) {
	                case 148 /* Parameter */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 270 /* ShorthandPropertyAssignment */:
	                case 269 /* PropertyAssignment */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return node.questionToken !== undefined;
	            }
	        }
	        return false;
	    }
	    ts.hasQuestionToken = hasQuestionToken;
	    function isJSDocConstructSignature(node) {
	        return node.kind === 283 /* JSDocFunctionType */ &&
	            node.parameters.length > 0 &&
	            node.parameters[0].name &&
	            node.parameters[0].name.escapedText === "new";
	    }
	    ts.isJSDocConstructSignature = isJSDocConstructSignature;
	    function isJSDocTypeAlias(node) {
	        return node.kind === 296 /* JSDocTypedefTag */ || node.kind === 291 /* JSDocCallbackTag */;
	    }
	    ts.isJSDocTypeAlias = isJSDocTypeAlias;
	    function isTypeAlias(node) {
	        return isJSDocTypeAlias(node) || ts.isTypeAliasDeclaration(node);
	    }
	    ts.isTypeAlias = isTypeAlias;
	    function getSourceOfAssignment(node) {
	        return ts.isExpressionStatement(node) &&
	            node.expression && ts.isBinaryExpression(node.expression) &&
	            node.expression.operatorToken.kind === 58 /* EqualsToken */ &&
	            node.expression.right;
	    }
	    function getSourceOfDefaultedAssignment(node) {
	        return ts.isExpressionStatement(node) &&
	            ts.isBinaryExpression(node.expression) &&
	            getSpecialPropertyAssignmentKind(node.expression) !== 0 /* None */ &&
	            ts.isBinaryExpression(node.expression.right) &&
	            node.expression.right.operatorToken.kind === 54 /* BarBarToken */ &&
	            node.expression.right.right;
	    }
	    function getSingleInitializerOfVariableStatementOrPropertyDeclaration(node) {
	        switch (node.kind) {
	            case 213 /* VariableStatement */:
	                var v = getSingleVariableOfVariableStatement(node);
	                return v && v.initializer;
	            case 151 /* PropertyDeclaration */:
	                return node.initializer;
	            case 269 /* PropertyAssignment */:
	                return node.initializer;
	        }
	    }
	    function getSingleVariableOfVariableStatement(node) {
	        return ts.isVariableStatement(node) &&
	            node.declarationList.declarations.length > 0 &&
	            node.declarationList.declarations[0];
	    }
	    function getNestedModuleDeclaration(node) {
	        return node.kind === 238 /* ModuleDeclaration */ &&
	            node.body &&
	            node.body.kind === 238 /* ModuleDeclaration */ &&
	            node.body;
	    }
	    function getJSDocCommentsAndTags(hostNode) {
	        var result;
	        getJSDocCommentsAndTagsWorker(hostNode);
	        return result || ts.emptyArray;
	        function getJSDocCommentsAndTagsWorker(node) {
	            var parent = node.parent;
	            if (!parent)
	                return;
	            if (parent.kind === 269 /* PropertyAssignment */ || parent.kind === 151 /* PropertyDeclaration */ || getNestedModuleDeclaration(parent)) {
	                getJSDocCommentsAndTagsWorker(parent);
	            }
	            // Try to recognize this pattern when node is initializer of variable declaration and JSDoc comments are on containing variable statement.
	            // /**
	            //   * @param {number} name
	            //   * @returns {number}
	            //   */
	            // var x = function(name) { return name.length; }
	            if (parent.parent && (getSingleVariableOfVariableStatement(parent.parent) === node)) {
	                getJSDocCommentsAndTagsWorker(parent.parent);
	            }
	            if (parent.parent && parent.parent.parent &&
	                (getSingleVariableOfVariableStatement(parent.parent.parent) ||
	                    getSingleInitializerOfVariableStatementOrPropertyDeclaration(parent.parent.parent) === node ||
	                    getSourceOfDefaultedAssignment(parent.parent.parent))) {
	                getJSDocCommentsAndTagsWorker(parent.parent.parent);
	            }
	            if (ts.isBinaryExpression(node) && node.operatorToken.kind === 58 /* EqualsToken */ ||
	                ts.isBinaryExpression(parent) && parent.operatorToken.kind === 58 /* EqualsToken */ ||
	                node.kind === 184 /* PropertyAccessExpression */ && node.parent && node.parent.kind === 215 /* ExpressionStatement */) {
	                getJSDocCommentsAndTagsWorker(parent);
	            }
	            // Pull parameter comments from declaring function as well
	            if (node.kind === 148 /* Parameter */) {
	                result = ts.addRange(result, ts.getJSDocParameterTags(node));
	            }
	            if (isVariableLike(node) && ts.hasInitializer(node) && node.initializer !== hostNode && ts.hasJSDocNodes(node.initializer)) {
	                result = ts.addRange(result, node.initializer.jsDoc);
	            }
	            if (ts.hasJSDocNodes(node)) {
	                result = ts.addRange(result, node.jsDoc);
	            }
	        }
	    }
	    ts.getJSDocCommentsAndTags = getJSDocCommentsAndTags;
	    /** Does the opposite of `getJSDocParameterTags`: given a JSDoc parameter, finds the parameter corresponding to it. */
	    function getParameterSymbolFromJSDoc(node) {
	        if (node.symbol) {
	            return node.symbol;
	        }
	        if (!ts.isIdentifier(node.name)) {
	            return undefined;
	        }
	        var name = node.name.escapedText;
	        var decl = getHostSignatureFromJSDoc(node);
	        if (!decl) {
	            return undefined;
	        }
	        var parameter = ts.find(decl.parameters, function (p) { return p.name.kind === 71 /* Identifier */ && p.name.escapedText === name; });
	        return parameter && parameter.symbol;
	    }
	    ts.getParameterSymbolFromJSDoc = getParameterSymbolFromJSDoc;
	    function getHostSignatureFromJSDoc(node) {
	        return getHostSignatureFromJSDocHost(getJSDocHost(node));
	    }
	    ts.getHostSignatureFromJSDoc = getHostSignatureFromJSDoc;
	    function getHostSignatureFromJSDocHost(host) {
	        var decl = getSourceOfDefaultedAssignment(host) ||
	            getSourceOfAssignment(host) ||
	            getSingleInitializerOfVariableStatementOrPropertyDeclaration(host) ||
	            getSingleVariableOfVariableStatement(host) ||
	            getNestedModuleDeclaration(host) ||
	            host;
	        return decl && ts.isFunctionLike(decl) ? decl : undefined;
	    }
	    ts.getHostSignatureFromJSDocHost = getHostSignatureFromJSDocHost;
	    function getJSDocHost(node) {
	        return ts.Debug.assertDefined(ts.findAncestor(node.parent, ts.isJSDoc)).parent;
	    }
	    ts.getJSDocHost = getJSDocHost;
	    function getTypeParameterFromJsDoc(node) {
	        var name = node.name.escapedText;
	        var typeParameters = node.parent.parent.parent.typeParameters;
	        return ts.find(typeParameters, function (p) { return p.name.escapedText === name; });
	    }
	    ts.getTypeParameterFromJsDoc = getTypeParameterFromJsDoc;
	    function hasRestParameter(s) {
	        var last = ts.lastOrUndefined(s.parameters);
	        return last && isRestParameter(last);
	    }
	    ts.hasRestParameter = hasRestParameter;
	    function isRestParameter(node) {
	        var type = ts.isJSDocParameterTag(node) ? (node.typeExpression && node.typeExpression.type) : node.type;
	        return node.dotDotDotToken !== undefined || type && type.kind === 284 /* JSDocVariadicType */;
	    }
	    ts.isRestParameter = isRestParameter;
	    var AssignmentKind;
	    (function (AssignmentKind) {
	        AssignmentKind[AssignmentKind["None"] = 0] = "None";
	        AssignmentKind[AssignmentKind["Definite"] = 1] = "Definite";
	        AssignmentKind[AssignmentKind["Compound"] = 2] = "Compound";
	    })(AssignmentKind = ts.AssignmentKind || (ts.AssignmentKind = {}));
	    function getAssignmentTargetKind(node) {
	        var parent = node.parent;
	        while (true) {
	            switch (parent.kind) {
	                case 199 /* BinaryExpression */:
	                    var binaryOperator = parent.operatorToken.kind;
	                    return isAssignmentOperator(binaryOperator) && parent.left === node ?
	                        binaryOperator === 58 /* EqualsToken */ ? 1 /* Definite */ : 2 /* Compound */ :
	                        0 /* None */;
	                case 197 /* PrefixUnaryExpression */:
	                case 198 /* PostfixUnaryExpression */:
	                    var unaryOperator = parent.operator;
	                    return unaryOperator === 43 /* PlusPlusToken */ || unaryOperator === 44 /* MinusMinusToken */ ? 2 /* Compound */ : 0 /* None */;
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                    return parent.initializer === node ? 1 /* Definite */ : 0 /* None */;
	                case 190 /* ParenthesizedExpression */:
	                case 182 /* ArrayLiteralExpression */:
	                case 203 /* SpreadElement */:
	                case 208 /* NonNullExpression */:
	                    node = parent;
	                    break;
	                case 270 /* ShorthandPropertyAssignment */:
	                    if (parent.name !== node) {
	                        return 0 /* None */;
	                    }
	                    node = parent.parent;
	                    break;
	                case 269 /* PropertyAssignment */:
	                    if (parent.name === node) {
	                        return 0 /* None */;
	                    }
	                    node = parent.parent;
	                    break;
	                default:
	                    return 0 /* None */;
	            }
	            parent = node.parent;
	        }
	    }
	    ts.getAssignmentTargetKind = getAssignmentTargetKind;
	    // A node is an assignment target if it is on the left hand side of an '=' token, if it is parented by a property
	    // assignment in an object literal that is an assignment target, or if it is parented by an array literal that is
	    // an assignment target. Examples include 'a = xxx', '{ p: a } = xxx', '[{ a }] = xxx'.
	    // (Note that `p` is not a target in the above examples, only `a`.)
	    function isAssignmentTarget(node) {
	        return getAssignmentTargetKind(node) !== 0 /* None */;
	    }
	    ts.isAssignmentTarget = isAssignmentTarget;
	    /**
	     * Indicates whether a node could contain a `var` VariableDeclarationList that contributes to
	     * the same `var` declaration scope as the node's parent.
	     */
	    function isNodeWithPossibleHoistedDeclaration(node) {
	        switch (node.kind) {
	            case 212 /* Block */:
	            case 213 /* VariableStatement */:
	            case 225 /* WithStatement */:
	            case 216 /* IfStatement */:
	            case 226 /* SwitchStatement */:
	            case 240 /* CaseBlock */:
	            case 265 /* CaseClause */:
	            case 266 /* DefaultClause */:
	            case 227 /* LabeledStatement */:
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	            case 217 /* DoStatement */:
	            case 218 /* WhileStatement */:
	            case 229 /* TryStatement */:
	            case 268 /* CatchClause */:
	                return true;
	        }
	        return false;
	    }
	    ts.isNodeWithPossibleHoistedDeclaration = isNodeWithPossibleHoistedDeclaration;
	    function isValueSignatureDeclaration(node) {
	        return ts.isFunctionExpression(node) || ts.isArrowFunction(node) || ts.isMethodOrAccessor(node) || ts.isFunctionDeclaration(node) || ts.isConstructorDeclaration(node);
	    }
	    ts.isValueSignatureDeclaration = isValueSignatureDeclaration;
	    function walkUp(node, kind) {
	        while (node && node.kind === kind) {
	            node = node.parent;
	        }
	        return node;
	    }
	    function walkUpParenthesizedTypes(node) {
	        return walkUp(node, 172 /* ParenthesizedType */);
	    }
	    ts.walkUpParenthesizedTypes = walkUpParenthesizedTypes;
	    function walkUpParenthesizedExpressions(node) {
	        return walkUp(node, 190 /* ParenthesizedExpression */);
	    }
	    ts.walkUpParenthesizedExpressions = walkUpParenthesizedExpressions;
	    function skipParentheses(node) {
	        while (node.kind === 190 /* ParenthesizedExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipParentheses = skipParentheses;
	    // a node is delete target iff. it is PropertyAccessExpression/ElementAccessExpression with parentheses skipped
	    function isDeleteTarget(node) {
	        if (node.kind !== 184 /* PropertyAccessExpression */ && node.kind !== 185 /* ElementAccessExpression */) {
	            return false;
	        }
	        node = walkUpParenthesizedExpressions(node.parent);
	        return node && node.kind === 193 /* DeleteExpression */;
	    }
	    ts.isDeleteTarget = isDeleteTarget;
	    function isNodeDescendantOf(node, ancestor) {
	        while (node) {
	            if (node === ancestor)
	                return true;
	            node = node.parent;
	        }
	        return false;
	    }
	    ts.isNodeDescendantOf = isNodeDescendantOf;
	    // True if `name` is the name of a declaration node
	    function isDeclarationName(name) {
	        return !ts.isSourceFile(name) && !ts.isBindingPattern(name) && ts.isDeclaration(name.parent) && name.parent.name === name;
	    }
	    ts.isDeclarationName = isDeclarationName;
	    // See GH#16030
	    function isAnyDeclarationName(name) {
	        switch (name.kind) {
	            case 71 /* Identifier */:
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                if (ts.isDeclaration(name.parent)) {
	                    return name.parent.name === name;
	                }
	                else if (ts.isQualifiedName(name.parent)) {
	                    var tag = name.parent.parent;
	                    return ts.isJSDocParameterTag(tag) && tag.name === name.parent;
	                }
	                else {
	                    var binExp = name.parent.parent;
	                    return ts.isBinaryExpression(binExp) && getSpecialPropertyAssignmentKind(binExp) !== 0 /* None */ && ts.getNameOfDeclaration(binExp) === name;
	                }
	            default:
	                return false;
	        }
	    }
	    ts.isAnyDeclarationName = isAnyDeclarationName;
	    function isLiteralComputedPropertyDeclarationName(node) {
	        return (node.kind === 9 /* StringLiteral */ || node.kind === 8 /* NumericLiteral */) &&
	            node.parent.kind === 146 /* ComputedPropertyName */ &&
	            ts.isDeclaration(node.parent.parent);
	    }
	    ts.isLiteralComputedPropertyDeclarationName = isLiteralComputedPropertyDeclarationName;
	    // Return true if the given identifier is classified as an IdentifierName
	    function isIdentifierName(node) {
	        var parent = node.parent;
	        switch (parent.kind) {
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 272 /* EnumMember */:
	            case 269 /* PropertyAssignment */:
	            case 184 /* PropertyAccessExpression */:
	                // Name in member declaration or property name in property access
	                return parent.name === node;
	            case 145 /* QualifiedName */:
	                // Name on right hand side of dot in a type query or type reference
	                if (parent.right === node) {
	                    while (parent.kind === 145 /* QualifiedName */) {
	                        parent = parent.parent;
	                    }
	                    return parent.kind === 164 /* TypeQuery */ || parent.kind === 161 /* TypeReference */;
	                }
	                return false;
	            case 181 /* BindingElement */:
	            case 247 /* ImportSpecifier */:
	                // Property name in binding element or import specifier
	                return parent.propertyName === node;
	            case 251 /* ExportSpecifier */:
	            case 261 /* JsxAttribute */:
	                // Any name in an export specifier or JSX Attribute
	                return true;
	        }
	        return false;
	    }
	    ts.isIdentifierName = isIdentifierName;
	    // An alias symbol is created by one of the following declarations:
	    // import <symbol> = ...
	    // import <symbol> from ...
	    // import * as <symbol> from ...
	    // import { x as <symbol> } from ...
	    // export { x as <symbol> } from ...
	    // export = <EntityNameExpression>
	    // export default <EntityNameExpression>
	    function isAliasSymbolDeclaration(node) {
	        return node.kind === 242 /* ImportEqualsDeclaration */ ||
	            node.kind === 241 /* NamespaceExportDeclaration */ ||
	            node.kind === 244 /* ImportClause */ && !!node.name ||
	            node.kind === 245 /* NamespaceImport */ ||
	            node.kind === 247 /* ImportSpecifier */ ||
	            node.kind === 251 /* ExportSpecifier */ ||
	            node.kind === 248 /* ExportAssignment */ && exportAssignmentIsAlias(node) ||
	            ts.isBinaryExpression(node) && getSpecialPropertyAssignmentKind(node) === 2 /* ModuleExports */;
	    }
	    ts.isAliasSymbolDeclaration = isAliasSymbolDeclaration;
	    function exportAssignmentIsAlias(node) {
	        var e = ts.isExportAssignment(node) ? node.expression : node.right;
	        return isEntityNameExpression(e) || ts.isClassExpression(e);
	    }
	    ts.exportAssignmentIsAlias = exportAssignmentIsAlias;
	    function getClassExtendsHeritageClauseElement(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 85 /* ExtendsKeyword */);
	        return heritageClause && heritageClause.types.length > 0 ? heritageClause.types[0] : undefined;
	    }
	    ts.getClassExtendsHeritageClauseElement = getClassExtendsHeritageClauseElement;
	    function getClassImplementsHeritageClauseElements(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 108 /* ImplementsKeyword */);
	        return heritageClause ? heritageClause.types : undefined;
	    }
	    ts.getClassImplementsHeritageClauseElements = getClassImplementsHeritageClauseElements;
	    /** Returns the node in an `extends` or `implements` clause of a class or interface. */
	    function getAllSuperTypeNodes(node) {
	        return ts.isInterfaceDeclaration(node) ? getInterfaceBaseTypeNodes(node) || ts.emptyArray
	            : ts.isClassLike(node) ? ts.concatenate(ts.singleElementArray(getClassExtendsHeritageClauseElement(node)), getClassImplementsHeritageClauseElements(node)) || ts.emptyArray
	                : ts.emptyArray;
	    }
	    ts.getAllSuperTypeNodes = getAllSuperTypeNodes;
	    function getInterfaceBaseTypeNodes(node) {
	        var heritageClause = getHeritageClause(node.heritageClauses, 85 /* ExtendsKeyword */);
	        return heritageClause ? heritageClause.types : undefined;
	    }
	    ts.getInterfaceBaseTypeNodes = getInterfaceBaseTypeNodes;
	    function getHeritageClause(clauses, kind) {
	        if (clauses) {
	            for (var _i = 0, clauses_1 = clauses; _i < clauses_1.length; _i++) {
	                var clause = clauses_1[_i];
	                if (clause.token === kind) {
	                    return clause;
	                }
	            }
	        }
	        return undefined;
	    }
	    ts.getHeritageClause = getHeritageClause;
	    function tryResolveScriptReference(host, sourceFile, reference) {
	        if (!host.getCompilerOptions().noResolve) {
	            var referenceFileName = ts.isRootedDiskPath(reference.fileName) ? reference.fileName : ts.combinePaths(ts.getDirectoryPath(sourceFile.fileName), reference.fileName);
	            return host.getSourceFile(referenceFileName);
	        }
	    }
	    ts.tryResolveScriptReference = tryResolveScriptReference;
	    function getAncestor(node, kind) {
	        while (node) {
	            if (node.kind === kind) {
	                return node;
	            }
	            node = node.parent;
	        }
	        return undefined;
	    }
	    ts.getAncestor = getAncestor;
	    function isKeyword(token) {
	        return 72 /* FirstKeyword */ <= token && token <= 144 /* LastKeyword */;
	    }
	    ts.isKeyword = isKeyword;
	    function isContextualKeyword(token) {
	        return 117 /* FirstContextualKeyword */ <= token && token <= 144 /* LastContextualKeyword */;
	    }
	    ts.isContextualKeyword = isContextualKeyword;
	    function isNonContextualKeyword(token) {
	        return isKeyword(token) && !isContextualKeyword(token);
	    }
	    ts.isNonContextualKeyword = isNonContextualKeyword;
	    function isStringANonContextualKeyword(name) {
	        var token = ts.stringToToken(name);
	        return token !== undefined && isNonContextualKeyword(token);
	    }
	    ts.isStringANonContextualKeyword = isStringANonContextualKeyword;
	    function isTrivia(token) {
	        return 2 /* FirstTriviaToken */ <= token && token <= 7 /* LastTriviaToken */;
	    }
	    ts.isTrivia = isTrivia;
	    var FunctionFlags;
	    (function (FunctionFlags) {
	        FunctionFlags[FunctionFlags["Normal"] = 0] = "Normal";
	        FunctionFlags[FunctionFlags["Generator"] = 1] = "Generator";
	        FunctionFlags[FunctionFlags["Async"] = 2] = "Async";
	        FunctionFlags[FunctionFlags["Invalid"] = 4] = "Invalid";
	        FunctionFlags[FunctionFlags["AsyncGenerator"] = 3] = "AsyncGenerator";
	    })(FunctionFlags = ts.FunctionFlags || (ts.FunctionFlags = {}));
	    function getFunctionFlags(node) {
	        if (!node) {
	            return 4 /* Invalid */;
	        }
	        var flags = 0 /* Normal */;
	        switch (node.kind) {
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	                if (node.asteriskToken) {
	                    flags |= 1 /* Generator */;
	                }
	            // falls through
	            case 192 /* ArrowFunction */:
	                if (hasModifier(node, 256 /* Async */)) {
	                    flags |= 2 /* Async */;
	                }
	                break;
	        }
	        if (!node.body) {
	            flags |= 4 /* Invalid */;
	        }
	        return flags;
	    }
	    ts.getFunctionFlags = getFunctionFlags;
	    function isAsyncFunction(node) {
	        switch (node.kind) {
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	            case 153 /* MethodDeclaration */:
	                return node.body !== undefined
	                    && node.asteriskToken === undefined
	                    && hasModifier(node, 256 /* Async */);
	        }
	        return false;
	    }
	    ts.isAsyncFunction = isAsyncFunction;
	    function isStringOrNumericLiteral(node) {
	        var kind = node.kind;
	        return kind === 9 /* StringLiteral */
	            || kind === 8 /* NumericLiteral */;
	    }
	    ts.isStringOrNumericLiteral = isStringOrNumericLiteral;
	    /**
	     * A declaration has a dynamic name if both of the following are true:
	     *   1. The declaration has a computed property name
	     *   2. The computed name is *not* expressed as Symbol.<name>, where name
	     *      is a property of the Symbol constructor that denotes a built in
	     *      Symbol.
	     */
	    function hasDynamicName(declaration) {
	        var name = ts.getNameOfDeclaration(declaration);
	        return name && isDynamicName(name);
	    }
	    ts.hasDynamicName = hasDynamicName;
	    function isDynamicName(name) {
	        return name.kind === 146 /* ComputedPropertyName */ &&
	            !isStringOrNumericLiteral(name.expression) &&
	            !isWellKnownSymbolSyntactically(name.expression);
	    }
	    ts.isDynamicName = isDynamicName;
	    /**
	     * Checks if the expression is of the form:
	     *    Symbol.name
	     * where Symbol is literally the word "Symbol", and name is any identifierName
	     */
	    function isWellKnownSymbolSyntactically(node) {
	        return ts.isPropertyAccessExpression(node) && isESSymbolIdentifier(node.expression);
	    }
	    ts.isWellKnownSymbolSyntactically = isWellKnownSymbolSyntactically;
	    function getPropertyNameForPropertyNameNode(name) {
	        if (name.kind === 71 /* Identifier */) {
	            return name.escapedText;
	        }
	        if (name.kind === 9 /* StringLiteral */ || name.kind === 8 /* NumericLiteral */) {
	            return escapeLeadingUnderscores(name.text);
	        }
	        if (name.kind === 146 /* ComputedPropertyName */) {
	            var nameExpression = name.expression;
	            if (isWellKnownSymbolSyntactically(nameExpression)) {
	                return getPropertyNameForKnownSymbolName(ts.idText(nameExpression.name));
	            }
	            else if (nameExpression.kind === 9 /* StringLiteral */ || nameExpression.kind === 8 /* NumericLiteral */) {
	                return escapeLeadingUnderscores(nameExpression.text);
	            }
	        }
	        return undefined;
	    }
	    ts.getPropertyNameForPropertyNameNode = getPropertyNameForPropertyNameNode;
	    function isPropertyNameLiteral(node) {
	        switch (node.kind) {
	            case 71 /* Identifier */:
	            case 9 /* StringLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 8 /* NumericLiteral */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isPropertyNameLiteral = isPropertyNameLiteral;
	    function getTextOfIdentifierOrLiteral(node) {
	        return node.kind === 71 /* Identifier */ ? ts.idText(node) : node.text;
	    }
	    ts.getTextOfIdentifierOrLiteral = getTextOfIdentifierOrLiteral;
	    function getEscapedTextOfIdentifierOrLiteral(node) {
	        return node.kind === 71 /* Identifier */ ? node.escapedText : escapeLeadingUnderscores(node.text);
	    }
	    ts.getEscapedTextOfIdentifierOrLiteral = getEscapedTextOfIdentifierOrLiteral;
	    function getPropertyNameForKnownSymbolName(symbolName) {
	        return "__@" + symbolName;
	    }
	    ts.getPropertyNameForKnownSymbolName = getPropertyNameForKnownSymbolName;
	    function isKnownSymbol(symbol) {
	        return ts.startsWith(symbol.escapedName, "__@");
	    }
	    ts.isKnownSymbol = isKnownSymbol;
	    /**
	     * Includes the word "Symbol" with unicode escapes
	     */
	    function isESSymbolIdentifier(node) {
	        return node.kind === 71 /* Identifier */ && node.escapedText === "Symbol";
	    }
	    ts.isESSymbolIdentifier = isESSymbolIdentifier;
	    function isPushOrUnshiftIdentifier(node) {
	        return node.escapedText === "push" || node.escapedText === "unshift";
	    }
	    ts.isPushOrUnshiftIdentifier = isPushOrUnshiftIdentifier;
	    function isParameterDeclaration(node) {
	        var root = getRootDeclaration(node);
	        return root.kind === 148 /* Parameter */;
	    }
	    ts.isParameterDeclaration = isParameterDeclaration;
	    function getRootDeclaration(node) {
	        while (node.kind === 181 /* BindingElement */) {
	            node = node.parent.parent;
	        }
	        return node;
	    }
	    ts.getRootDeclaration = getRootDeclaration;
	    function nodeStartsNewLexicalEnvironment(node) {
	        var kind = node.kind;
	        return kind === 154 /* Constructor */
	            || kind === 191 /* FunctionExpression */
	            || kind === 233 /* FunctionDeclaration */
	            || kind === 192 /* ArrowFunction */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */
	            || kind === 238 /* ModuleDeclaration */
	            || kind === 273 /* SourceFile */;
	    }
	    ts.nodeStartsNewLexicalEnvironment = nodeStartsNewLexicalEnvironment;
	    function nodeIsSynthesized(range) {
	        return ts.positionIsSynthesized(range.pos)
	            || ts.positionIsSynthesized(range.end);
	    }
	    ts.nodeIsSynthesized = nodeIsSynthesized;
	    function getOriginalSourceFile(sourceFile) {
	        return ts.getParseTreeNode(sourceFile, ts.isSourceFile) || sourceFile;
	    }
	    ts.getOriginalSourceFile = getOriginalSourceFile;
	    var Associativity;
	    (function (Associativity) {
	        Associativity[Associativity["Left"] = 0] = "Left";
	        Associativity[Associativity["Right"] = 1] = "Right";
	    })(Associativity = ts.Associativity || (ts.Associativity = {}));
	    function getExpressionAssociativity(expression) {
	        var operator = getOperator(expression);
	        var hasArguments = expression.kind === 187 /* NewExpression */ && expression.arguments !== undefined;
	        return getOperatorAssociativity(expression.kind, operator, hasArguments);
	    }
	    ts.getExpressionAssociativity = getExpressionAssociativity;
	    function getOperatorAssociativity(kind, operator, hasArguments) {
	        switch (kind) {
	            case 187 /* NewExpression */:
	                return hasArguments ? 0 /* Left */ : 1 /* Right */;
	            case 197 /* PrefixUnaryExpression */:
	            case 194 /* TypeOfExpression */:
	            case 195 /* VoidExpression */:
	            case 193 /* DeleteExpression */:
	            case 196 /* AwaitExpression */:
	            case 200 /* ConditionalExpression */:
	            case 202 /* YieldExpression */:
	                return 1 /* Right */;
	            case 199 /* BinaryExpression */:
	                switch (operator) {
	                    case 40 /* AsteriskAsteriskToken */:
	                    case 58 /* EqualsToken */:
	                    case 59 /* PlusEqualsToken */:
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 1 /* Right */;
	                }
	        }
	        return 0 /* Left */;
	    }
	    ts.getOperatorAssociativity = getOperatorAssociativity;
	    function getExpressionPrecedence(expression) {
	        var operator = getOperator(expression);
	        var hasArguments = expression.kind === 187 /* NewExpression */ && expression.arguments !== undefined;
	        return getOperatorPrecedence(expression.kind, operator, hasArguments);
	    }
	    ts.getExpressionPrecedence = getExpressionPrecedence;
	    function getOperator(expression) {
	        if (expression.kind === 199 /* BinaryExpression */) {
	            return expression.operatorToken.kind;
	        }
	        else if (expression.kind === 197 /* PrefixUnaryExpression */ || expression.kind === 198 /* PostfixUnaryExpression */) {
	            return expression.operator;
	        }
	        else {
	            return expression.kind;
	        }
	    }
	    ts.getOperator = getOperator;
	    function getOperatorPrecedence(nodeKind, operatorKind, hasArguments) {
	        switch (nodeKind) {
	            case 301 /* CommaListExpression */:
	                return 0;
	            case 203 /* SpreadElement */:
	                return 1;
	            case 202 /* YieldExpression */:
	                return 2;
	            case 200 /* ConditionalExpression */:
	                return 4;
	            case 199 /* BinaryExpression */:
	                switch (operatorKind) {
	                    case 26 /* CommaToken */:
	                        return 0;
	                    case 58 /* EqualsToken */:
	                    case 59 /* PlusEqualsToken */:
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 3;
	                    default:
	                        return getBinaryOperatorPrecedence(operatorKind);
	                }
	            case 197 /* PrefixUnaryExpression */:
	            case 194 /* TypeOfExpression */:
	            case 195 /* VoidExpression */:
	            case 193 /* DeleteExpression */:
	            case 196 /* AwaitExpression */:
	                return 16;
	            case 198 /* PostfixUnaryExpression */:
	                return 17;
	            case 186 /* CallExpression */:
	                return 18;
	            case 187 /* NewExpression */:
	                return hasArguments ? 19 : 18;
	            case 188 /* TaggedTemplateExpression */:
	            case 184 /* PropertyAccessExpression */:
	            case 185 /* ElementAccessExpression */:
	                return 19;
	            case 99 /* ThisKeyword */:
	            case 97 /* SuperKeyword */:
	            case 71 /* Identifier */:
	            case 95 /* NullKeyword */:
	            case 101 /* TrueKeyword */:
	            case 86 /* FalseKeyword */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 182 /* ArrayLiteralExpression */:
	            case 183 /* ObjectLiteralExpression */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	            case 204 /* ClassExpression */:
	            case 254 /* JsxElement */:
	            case 255 /* JsxSelfClosingElement */:
	            case 258 /* JsxFragment */:
	            case 12 /* RegularExpressionLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 201 /* TemplateExpression */:
	            case 190 /* ParenthesizedExpression */:
	            case 205 /* OmittedExpression */:
	                return 20;
	            default:
	                return -1;
	        }
	    }
	    ts.getOperatorPrecedence = getOperatorPrecedence;
	    /* @internal */
	    function getBinaryOperatorPrecedence(kind) {
	        switch (kind) {
	            case 54 /* BarBarToken */:
	                return 5;
	            case 53 /* AmpersandAmpersandToken */:
	                return 6;
	            case 49 /* BarToken */:
	                return 7;
	            case 50 /* CaretToken */:
	                return 8;
	            case 48 /* AmpersandToken */:
	                return 9;
	            case 32 /* EqualsEqualsToken */:
	            case 33 /* ExclamationEqualsToken */:
	            case 34 /* EqualsEqualsEqualsToken */:
	            case 35 /* ExclamationEqualsEqualsToken */:
	                return 10;
	            case 27 /* LessThanToken */:
	            case 29 /* GreaterThanToken */:
	            case 30 /* LessThanEqualsToken */:
	            case 31 /* GreaterThanEqualsToken */:
	            case 93 /* InstanceOfKeyword */:
	            case 92 /* InKeyword */:
	            case 118 /* AsKeyword */:
	                return 11;
	            case 45 /* LessThanLessThanToken */:
	            case 46 /* GreaterThanGreaterThanToken */:
	            case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                return 12;
	            case 37 /* PlusToken */:
	            case 38 /* MinusToken */:
	                return 13;
	            case 39 /* AsteriskToken */:
	            case 41 /* SlashToken */:
	            case 42 /* PercentToken */:
	                return 14;
	            case 40 /* AsteriskAsteriskToken */:
	                return 15;
	        }
	        // -1 is lower than all other precedences.  Returning it will cause binary expression
	        // parsing to stop.
	        return -1;
	    }
	    ts.getBinaryOperatorPrecedence = getBinaryOperatorPrecedence;
	    function createDiagnosticCollection() {
	        var nonFileDiagnostics = [];
	        var filesWithDiagnostics = [];
	        var fileDiagnostics = ts.createMap();
	        var hasReadNonFileDiagnostics = false;
	        return {
	            add: add,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getDiagnostics: getDiagnostics,
	            reattachFileDiagnostics: reattachFileDiagnostics
	        };
	        function reattachFileDiagnostics(newFile) {
	            ts.forEach(fileDiagnostics.get(newFile.fileName), function (diagnostic) { return diagnostic.file = newFile; });
	        }
	        function add(diagnostic) {
	            var diagnostics;
	            if (diagnostic.file) {
	                diagnostics = fileDiagnostics.get(diagnostic.file.fileName);
	                if (!diagnostics) {
	                    diagnostics = [];
	                    fileDiagnostics.set(diagnostic.file.fileName, diagnostics);
	                    ts.insertSorted(filesWithDiagnostics, diagnostic.file.fileName, ts.compareStringsCaseSensitive);
	                }
	            }
	            else {
	                // If we've already read the non-file diagnostics, do not modify the existing array.
	                if (hasReadNonFileDiagnostics) {
	                    hasReadNonFileDiagnostics = false;
	                    nonFileDiagnostics = nonFileDiagnostics.slice();
	                }
	                diagnostics = nonFileDiagnostics;
	            }
	            ts.insertSorted(diagnostics, diagnostic, ts.compareDiagnostics);
	        }
	        function getGlobalDiagnostics() {
	            hasReadNonFileDiagnostics = true;
	            return nonFileDiagnostics;
	        }
	        function getDiagnostics(fileName) {
	            if (fileName) {
	                return fileDiagnostics.get(fileName) || [];
	            }
	            var fileDiags = ts.flatMap(filesWithDiagnostics, function (f) { return fileDiagnostics.get(f); });
	            if (!nonFileDiagnostics.length) {
	                return fileDiags;
	            }
	            fileDiags.unshift.apply(fileDiags, nonFileDiagnostics);
	            return fileDiags;
	        }
	    }
	    ts.createDiagnosticCollection = createDiagnosticCollection;
	    // This consists of the first 19 unprintable ASCII characters, canonical escapes, lineSeparator,
	    // paragraphSeparator, and nextLine. The latter three are just desirable to suppress new lines in
	    // the language service. These characters should be escaped when printing, and if any characters are added,
	    // the map below must be updated. Note that this regexp *does not* include the 'delete' character.
	    // There is no reason for this other than that JSON.stringify does not handle it either.
	    var doubleQuoteEscapedCharsRegExp = /[\\\"\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var singleQuoteEscapedCharsRegExp = /[\\\'\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var backtickQuoteEscapedCharsRegExp = /[\\\`\u0000-\u001f\t\v\f\b\r\n\u2028\u2029\u0085]/g;
	    var escapedCharsMap = ts.createMapFromTemplate({
	        "\t": "\\t",
	        "\v": "\\v",
	        "\f": "\\f",
	        "\b": "\\b",
	        "\r": "\\r",
	        "\n": "\\n",
	        "\\": "\\\\",
	        "\"": "\\\"",
	        "\'": "\\\'",
	        "\`": "\\\`",
	        "\u2028": "\\u2028",
	        "\u2029": "\\u2029",
	        "\u0085": "\\u0085" // nextLine
	    });
	    /**
	     * Based heavily on the abstract 'Quote'/'QuoteJSONString' operation from ECMA-262 (24.3.2.2),
	     * but augmented for a few select characters (e.g. lineSeparator, paragraphSeparator, nextLine)
	     * Note that this doesn't actually wrap the input in double quotes.
	     */
	    function escapeString(s, quoteChar) {
	        var escapedCharsRegExp = quoteChar === 96 /* backtick */ ? backtickQuoteEscapedCharsRegExp :
	            quoteChar === 39 /* singleQuote */ ? singleQuoteEscapedCharsRegExp :
	                doubleQuoteEscapedCharsRegExp;
	        return s.replace(escapedCharsRegExp, getReplacement);
	    }
	    ts.escapeString = escapeString;
	    function getReplacement(c, offset, input) {
	        if (c.charCodeAt(0) === 0 /* nullCharacter */) {
	            var lookAhead = input.charCodeAt(offset + c.length);
	            if (lookAhead >= 48 /* _0 */ && lookAhead <= 57 /* _9 */) {
	                // If the null character is followed by digits, print as a hex escape to prevent the result from parsing as an octal (which is forbidden in strict mode)
	                return "\\x00";
	            }
	            // Otherwise, keep printing a literal \0 for the null character
	            return "\\0";
	        }
	        return escapedCharsMap.get(c) || get16BitUnicodeEscapeSequence(c.charCodeAt(0));
	    }
	    function isIntrinsicJsxName(name) {
	        var ch = name.charCodeAt(0);
	        return (ch >= 97 /* a */ && ch <= 122 /* z */) || name.indexOf("-") > -1;
	    }
	    ts.isIntrinsicJsxName = isIntrinsicJsxName;
	    function get16BitUnicodeEscapeSequence(charCode) {
	        var hexCharCode = charCode.toString(16).toUpperCase();
	        var paddedHexCode = ("0000" + hexCharCode).slice(-4);
	        return "\\u" + paddedHexCode;
	    }
	    var nonAsciiCharacters = /[^\u0000-\u007F]/g;
	    function escapeNonAsciiString(s, quoteChar) {
	        s = escapeString(s, quoteChar);
	        // Replace non-ASCII characters with '\uNNNN' escapes if any exist.
	        // Otherwise just return the original string.
	        return nonAsciiCharacters.test(s) ?
	            s.replace(nonAsciiCharacters, function (c) { return get16BitUnicodeEscapeSequence(c.charCodeAt(0)); }) :
	            s;
	    }
	    ts.escapeNonAsciiString = escapeNonAsciiString;
	    var indentStrings = ["", "    "];
	    function getIndentString(level) {
	        if (indentStrings[level] === undefined) {
	            indentStrings[level] = getIndentString(level - 1) + indentStrings[1];
	        }
	        return indentStrings[level];
	    }
	    ts.getIndentString = getIndentString;
	    function getIndentSize() {
	        return indentStrings[1].length;
	    }
	    ts.getIndentSize = getIndentSize;
	    function createTextWriter(newLine) {
	        var output;
	        var indent;
	        var lineStart;
	        var lineCount;
	        var linePos;
	        function write(s) {
	            if (s && s.length) {
	                if (lineStart) {
	                    output += getIndentString(indent);
	                    lineStart = false;
	                }
	                output += s;
	            }
	        }
	        function reset() {
	            output = "";
	            indent = 0;
	            lineStart = true;
	            lineCount = 0;
	            linePos = 0;
	        }
	        function rawWrite(s) {
	            if (s !== undefined) {
	                if (lineStart) {
	                    lineStart = false;
	                }
	                output += s;
	            }
	        }
	        function writeLiteral(s) {
	            if (s && s.length) {
	                write(s);
	                var lineStartsOfS = ts.computeLineStarts(s);
	                if (lineStartsOfS.length > 1) {
	                    lineCount = lineCount + lineStartsOfS.length - 1;
	                    linePos = output.length - s.length + ts.lastOrUndefined(lineStartsOfS);
	                }
	            }
	        }
	        function writeLine() {
	            if (!lineStart) {
	                output += newLine;
	                lineCount++;
	                linePos = output.length;
	                lineStart = true;
	            }
	        }
	        function writeTextOfNode(text, node) {
	            write(getTextOfNodeFromSourceText(text, node));
	        }
	        reset();
	        return {
	            write: write,
	            rawWrite: rawWrite,
	            writeTextOfNode: writeTextOfNode,
	            writeLiteral: writeLiteral,
	            writeLine: writeLine,
	            increaseIndent: function () { indent++; },
	            decreaseIndent: function () { indent--; },
	            getIndent: function () { return indent; },
	            getTextPos: function () { return output.length; },
	            getLine: function () { return lineCount + 1; },
	            getColumn: function () { return lineStart ? indent * getIndentSize() + 1 : output.length - linePos + 1; },
	            getText: function () { return output; },
	            isAtStartOfLine: function () { return lineStart; },
	            clear: reset,
	            reportInaccessibleThisError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            trackSymbol: ts.noop,
	            writeKeyword: write,
	            writeOperator: write,
	            writeParameter: write,
	            writeProperty: write,
	            writePunctuation: write,
	            writeSpace: write,
	            writeStringLiteral: write,
	            writeSymbol: write
	        };
	    }
	    ts.createTextWriter = createTextWriter;
	    function getResolvedExternalModuleName(host, file, referenceFile) {
	        return file.moduleName || getExternalModuleNameFromPath(host, file.fileName, referenceFile && referenceFile.fileName);
	    }
	    ts.getResolvedExternalModuleName = getResolvedExternalModuleName;
	    function getExternalModuleNameFromDeclaration(host, resolver, declaration) {
	        var file = resolver.getExternalModuleFileFromDeclaration(declaration);
	        if (!file || file.isDeclarationFile) {
	            return undefined;
	        }
	        return getResolvedExternalModuleName(host, file);
	    }
	    ts.getExternalModuleNameFromDeclaration = getExternalModuleNameFromDeclaration;
	    /**
	     * Resolves a local path to a path which is absolute to the base of the emit
	     */
	    function getExternalModuleNameFromPath(host, fileName, referencePath) {
	        var getCanonicalFileName = function (f) { return host.getCanonicalFileName(f); };
	        var dir = ts.toPath(referencePath ? ts.getDirectoryPath(referencePath) : host.getCommonSourceDirectory(), host.getCurrentDirectory(), getCanonicalFileName);
	        var filePath = ts.getNormalizedAbsolutePath(fileName, host.getCurrentDirectory());
	        var relativePath = ts.getRelativePathToDirectoryOrUrl(dir, filePath, dir, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	        var extensionless = ts.removeFileExtension(relativePath);
	        return referencePath ? ts.ensurePathIsNonModuleName(extensionless) : extensionless;
	    }
	    ts.getExternalModuleNameFromPath = getExternalModuleNameFromPath;
	    function getOwnEmitOutputFilePath(sourceFile, host, extension) {
	        var compilerOptions = host.getCompilerOptions();
	        var emitOutputFilePathWithoutExtension;
	        if (compilerOptions.outDir) {
	            emitOutputFilePathWithoutExtension = ts.removeFileExtension(getSourceFilePathInNewDir(sourceFile, host, compilerOptions.outDir));
	        }
	        else {
	            emitOutputFilePathWithoutExtension = ts.removeFileExtension(sourceFile.fileName);
	        }
	        return emitOutputFilePathWithoutExtension + extension;
	    }
	    ts.getOwnEmitOutputFilePath = getOwnEmitOutputFilePath;
	    function getDeclarationEmitOutputFilePath(sourceFile, host) {
	        var options = host.getCompilerOptions();
	        var outputDir = options.declarationDir || options.outDir; // Prefer declaration folder if specified
	        var path = outputDir
	            ? getSourceFilePathInNewDir(sourceFile, host, outputDir)
	            : sourceFile.fileName;
	        return ts.removeFileExtension(path) + ".d.ts" /* Dts */;
	    }
	    ts.getDeclarationEmitOutputFilePath = getDeclarationEmitOutputFilePath;
	    /**
	     * Gets the source files that are expected to have an emit output.
	     *
	     * Originally part of `forEachExpectedEmitFile`, this functionality was extracted to support
	     * transformations.
	     *
	     * @param host An EmitHost.
	     * @param targetSourceFile An optional target source file to emit.
	     */
	    function getSourceFilesToEmit(host, targetSourceFile) {
	        var options = host.getCompilerOptions();
	        var isSourceFileFromExternalLibrary = function (file) { return host.isSourceFileFromExternalLibrary(file); };
	        if (options.outFile || options.out) {
	            var moduleKind = ts.getEmitModuleKind(options);
	            var moduleEmitEnabled_1 = moduleKind === ts.ModuleKind.AMD || moduleKind === ts.ModuleKind.System;
	            // Can emit only sources that are not declaration file and are either non module code or module with --module or --target es6 specified
	            return ts.filter(host.getSourceFiles(), function (sourceFile) {
	                return (moduleEmitEnabled_1 || !ts.isExternalModule(sourceFile)) && sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary);
	            });
	        }
	        else {
	            var sourceFiles = targetSourceFile === undefined ? host.getSourceFiles() : [targetSourceFile];
	            return ts.filter(sourceFiles, function (sourceFile) { return sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary); });
	        }
	    }
	    ts.getSourceFilesToEmit = getSourceFilesToEmit;
	    /** Don't call this for `--outFile`, just for `--outDir` or plain emit. `--outFile` needs additional checks. */
	    function sourceFileMayBeEmitted(sourceFile, options, isSourceFileFromExternalLibrary) {
	        return !(options.noEmitForJsFiles && isSourceFileJavaScript(sourceFile)) && !sourceFile.isDeclarationFile && !isSourceFileFromExternalLibrary(sourceFile);
	    }
	    ts.sourceFileMayBeEmitted = sourceFileMayBeEmitted;
	    function getSourceFilePathInNewDir(sourceFile, host, newDirPath) {
	        var sourceFilePath = ts.getNormalizedAbsolutePath(sourceFile.fileName, host.getCurrentDirectory());
	        var commonSourceDirectory = host.getCommonSourceDirectory();
	        var isSourceFileInCommonSourceDirectory = host.getCanonicalFileName(sourceFilePath).indexOf(host.getCanonicalFileName(commonSourceDirectory)) === 0;
	        sourceFilePath = isSourceFileInCommonSourceDirectory ? sourceFilePath.substring(commonSourceDirectory.length) : sourceFilePath;
	        return ts.combinePaths(newDirPath, sourceFilePath);
	    }
	    ts.getSourceFilePathInNewDir = getSourceFilePathInNewDir;
	    function writeFile(host, diagnostics, fileName, data, writeByteOrderMark, sourceFiles) {
	        host.writeFile(fileName, data, writeByteOrderMark, function (hostErrorMessage) {
	            diagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Could_not_write_file_0_Colon_1, fileName, hostErrorMessage));
	        }, sourceFiles);
	    }
	    ts.writeFile = writeFile;
	    function getLineOfLocalPosition(currentSourceFile, pos) {
	        return ts.getLineAndCharacterOfPosition(currentSourceFile, pos).line;
	    }
	    ts.getLineOfLocalPosition = getLineOfLocalPosition;
	    function getLineOfLocalPositionFromLineMap(lineMap, pos) {
	        return ts.computeLineAndCharacterOfPosition(lineMap, pos).line;
	    }
	    ts.getLineOfLocalPositionFromLineMap = getLineOfLocalPositionFromLineMap;
	    function getFirstConstructorWithBody(node) {
	        return ts.find(node.members, function (member) { return ts.isConstructorDeclaration(member) && nodeIsPresent(member.body); });
	    }
	    ts.getFirstConstructorWithBody = getFirstConstructorWithBody;
	    function getSetAccessorValueParameter(accessor) {
	        if (accessor && accessor.parameters.length > 0) {
	            var hasThis = accessor.parameters.length === 2 && parameterIsThisKeyword(accessor.parameters[0]);
	            return accessor.parameters[hasThis ? 1 : 0];
	        }
	    }
	    /** Get the type annotation for the value parameter. */
	    function getSetAccessorTypeAnnotationNode(accessor) {
	        var parameter = getSetAccessorValueParameter(accessor);
	        return parameter && parameter.type;
	    }
	    ts.getSetAccessorTypeAnnotationNode = getSetAccessorTypeAnnotationNode;
	    function getThisParameter(signature) {
	        // callback tags do not currently support this parameters
	        if (signature.parameters.length && !ts.isJSDocSignature(signature)) {
	            var thisParameter = signature.parameters[0];
	            if (parameterIsThisKeyword(thisParameter)) {
	                return thisParameter;
	            }
	        }
	    }
	    ts.getThisParameter = getThisParameter;
	    function parameterIsThisKeyword(parameter) {
	        return isThisIdentifier(parameter.name);
	    }
	    ts.parameterIsThisKeyword = parameterIsThisKeyword;
	    function isThisIdentifier(node) {
	        return node && node.kind === 71 /* Identifier */ && identifierIsThisKeyword(node);
	    }
	    ts.isThisIdentifier = isThisIdentifier;
	    function identifierIsThisKeyword(id) {
	        return id.originalKeywordKind === 99 /* ThisKeyword */;
	    }
	    ts.identifierIsThisKeyword = identifierIsThisKeyword;
	    function getAllAccessorDeclarations(declarations, accessor) {
	        var firstAccessor;
	        var secondAccessor;
	        var getAccessor;
	        var setAccessor;
	        if (hasDynamicName(accessor)) {
	            firstAccessor = accessor;
	            if (accessor.kind === 155 /* GetAccessor */) {
	                getAccessor = accessor;
	            }
	            else if (accessor.kind === 156 /* SetAccessor */) {
	                setAccessor = accessor;
	            }
	            else {
	                ts.Debug.fail("Accessor has wrong kind");
	            }
	        }
	        else {
	            ts.forEach(declarations, function (member) {
	                if ((member.kind === 155 /* GetAccessor */ || member.kind === 156 /* SetAccessor */)
	                    && hasModifier(member, 32 /* Static */) === hasModifier(accessor, 32 /* Static */)) {
	                    var memberName = getPropertyNameForPropertyNameNode(member.name);
	                    var accessorName = getPropertyNameForPropertyNameNode(accessor.name);
	                    if (memberName === accessorName) {
	                        if (!firstAccessor) {
	                            firstAccessor = member;
	                        }
	                        else if (!secondAccessor) {
	                            secondAccessor = member;
	                        }
	                        if (member.kind === 155 /* GetAccessor */ && !getAccessor) {
	                            getAccessor = member;
	                        }
	                        if (member.kind === 156 /* SetAccessor */ && !setAccessor) {
	                            setAccessor = member;
	                        }
	                    }
	                }
	            });
	        }
	        return {
	            firstAccessor: firstAccessor,
	            secondAccessor: secondAccessor,
	            getAccessor: getAccessor,
	            setAccessor: setAccessor
	        };
	    }
	    ts.getAllAccessorDeclarations = getAllAccessorDeclarations;
	    /**
	     * Gets the effective type annotation of a variable, parameter, or property. If the node was
	     * parsed in a JavaScript file, gets the type annotation from JSDoc.
	     */
	    function getEffectiveTypeAnnotationNode(node) {
	        return node.type || (isInJavaScriptFile(node) ? ts.getJSDocType(node) : undefined);
	    }
	    ts.getEffectiveTypeAnnotationNode = getEffectiveTypeAnnotationNode;
	    function getTypeAnnotationNode(node) {
	        return node.type;
	    }
	    ts.getTypeAnnotationNode = getTypeAnnotationNode;
	    /**
	     * Gets the effective return type annotation of a signature. If the node was parsed in a
	     * JavaScript file, gets the return type annotation from JSDoc.
	     */
	    function getEffectiveReturnTypeNode(node) {
	        if (ts.isJSDocSignature(node)) {
	            return node.type && node.type.typeExpression && node.type.typeExpression.type;
	        }
	        return node.type || (isInJavaScriptFile(node) ? ts.getJSDocReturnType(node) : undefined);
	    }
	    ts.getEffectiveReturnTypeNode = getEffectiveReturnTypeNode;
	    /**
	     * Gets the effective type parameters. If the node was parsed in a
	     * JavaScript file, gets the type parameters from the `@template` tag from JSDoc.
	     */
	    function getEffectiveTypeParameterDeclarations(node) {
	        if (ts.isJSDocSignature(node)) {
	            return ts.emptyArray;
	        }
	        if (isJSDocTypeAlias(node)) {
	            ts.Debug.assert(node.parent.kind === 285 /* JSDocComment */);
	            var templateTags = ts.flatMap(ts.filter(node.parent.tags, ts.isJSDocTemplateTag), function (tag) { return tag.typeParameters; });
	            var templateTagNodes = templateTags;
	            templateTagNodes.pos = templateTagNodes.length > 0 ? ts.first(templateTagNodes).pos : node.pos;
	            templateTagNodes.end = templateTagNodes.length > 0 ? ts.last(templateTagNodes).end : node.end;
	            templateTagNodes.hasTrailingComma = false;
	            return templateTagNodes;
	        }
	        return node.typeParameters || (isInJavaScriptFile(node) ? getJSDocTypeParameterDeclarations(node) : ts.emptyArray);
	    }
	    ts.getEffectiveTypeParameterDeclarations = getEffectiveTypeParameterDeclarations;
	    function getJSDocTypeParameterDeclarations(node) {
	        // template tags are only available when a typedef isn't already using them
	        var tag = ts.find(ts.getJSDocTags(node), function (tag) {
	            return ts.isJSDocTemplateTag(tag) && !(tag.parent.kind === 285 /* JSDocComment */ && tag.parent.tags.some(isJSDocTypeAlias));
	        });
	        return (tag && tag.typeParameters) || ts.emptyArray;
	    }
	    ts.getJSDocTypeParameterDeclarations = getJSDocTypeParameterDeclarations;
	    /**
	     * Gets the effective type annotation of the value parameter of a set accessor. If the node
	     * was parsed in a JavaScript file, gets the type annotation from JSDoc.
	     */
	    function getEffectiveSetAccessorTypeAnnotationNode(node) {
	        var parameter = getSetAccessorValueParameter(node);
	        return parameter && getEffectiveTypeAnnotationNode(parameter);
	    }
	    ts.getEffectiveSetAccessorTypeAnnotationNode = getEffectiveSetAccessorTypeAnnotationNode;
	    function emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments) {
	        emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, node.pos, leadingComments);
	    }
	    ts.emitNewLineBeforeLeadingComments = emitNewLineBeforeLeadingComments;
	    function emitNewLineBeforeLeadingCommentsOfPosition(lineMap, writer, pos, leadingComments) {
	        // If the leading comments start on different line than the start of node, write new line
	        if (leadingComments && leadingComments.length && pos !== leadingComments[0].pos &&
	            getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, leadingComments[0].pos)) {
	            writer.writeLine();
	        }
	    }
	    ts.emitNewLineBeforeLeadingCommentsOfPosition = emitNewLineBeforeLeadingCommentsOfPosition;
	    function emitNewLineBeforeLeadingCommentOfPosition(lineMap, writer, pos, commentPos) {
	        // If the leading comments start on different line than the start of node, write new line
	        if (pos !== commentPos &&
	            getLineOfLocalPositionFromLineMap(lineMap, pos) !== getLineOfLocalPositionFromLineMap(lineMap, commentPos)) {
	            writer.writeLine();
	        }
	    }
	    ts.emitNewLineBeforeLeadingCommentOfPosition = emitNewLineBeforeLeadingCommentOfPosition;
	    function emitComments(text, lineMap, writer, comments, leadingSeparator, trailingSeparator, newLine, writeComment) {
	        if (comments && comments.length > 0) {
	            if (leadingSeparator) {
	                writer.write(" ");
	            }
	            var emitInterveningSeparator = false;
	            for (var _i = 0, comments_1 = comments; _i < comments_1.length; _i++) {
	                var comment = comments_1[_i];
	                if (emitInterveningSeparator) {
	                    writer.write(" ");
	                    emitInterveningSeparator = false;
	                }
	                writeComment(text, lineMap, writer, comment.pos, comment.end, newLine);
	                if (comment.hasTrailingNewLine) {
	                    writer.writeLine();
	                }
	                else {
	                    emitInterveningSeparator = true;
	                }
	            }
	            if (emitInterveningSeparator && trailingSeparator) {
	                writer.write(" ");
	            }
	        }
	    }
	    ts.emitComments = emitComments;
	    /**
	     * Detached comment is a comment at the top of file or function body that is separated from
	     * the next statement by space.
	     */
	    function emitDetachedComments(text, lineMap, writer, writeComment, node, newLine, removeComments) {
	        var leadingComments;
	        var currentDetachedCommentInfo;
	        if (removeComments) {
	            // removeComments is true, only reserve pinned comment at the top of file
	            // For example:
	            //      /*! Pinned Comment */
	            //
	            //      var x = 10;
	            if (node.pos === 0) {
	                leadingComments = ts.filter(ts.getLeadingCommentRanges(text, node.pos), isPinnedCommentLocal);
	            }
	        }
	        else {
	            // removeComments is false, just get detached as normal and bypass the process to filter comment
	            leadingComments = ts.getLeadingCommentRanges(text, node.pos);
	        }
	        if (leadingComments) {
	            var detachedComments = [];
	            var lastComment = void 0;
	            for (var _i = 0, leadingComments_1 = leadingComments; _i < leadingComments_1.length; _i++) {
	                var comment = leadingComments_1[_i];
	                if (lastComment) {
	                    var lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, lastComment.end);
	                    var commentLine = getLineOfLocalPositionFromLineMap(lineMap, comment.pos);
	                    if (commentLine >= lastCommentLine + 2) {
	                        // There was a blank line between the last comment and this comment.  This
	                        // comment is not part of the copyright comments.  Return what we have so
	                        // far.
	                        break;
	                    }
	                }
	                detachedComments.push(comment);
	                lastComment = comment;
	            }
	            if (detachedComments.length) {
	                // All comments look like they could have been part of the copyright header.  Make
	                // sure there is at least one blank line between it and the node.  If not, it's not
	                // a copyright header.
	                var lastCommentLine = getLineOfLocalPositionFromLineMap(lineMap, ts.lastOrUndefined(detachedComments).end);
	                var nodeLine = getLineOfLocalPositionFromLineMap(lineMap, ts.skipTrivia(text, node.pos));
	                if (nodeLine >= lastCommentLine + 2) {
	                    // Valid detachedComments
	                    emitNewLineBeforeLeadingComments(lineMap, writer, node, leadingComments);
	                    emitComments(text, lineMap, writer, detachedComments, /*leadingSeparator*/ false, /*trailingSeparator*/ true, newLine, writeComment);
	                    currentDetachedCommentInfo = { nodePos: node.pos, detachedCommentEndPos: ts.lastOrUndefined(detachedComments).end };
	                }
	            }
	        }
	        return currentDetachedCommentInfo;
	        function isPinnedCommentLocal(comment) {
	            return isPinnedComment(text, comment.pos);
	        }
	    }
	    ts.emitDetachedComments = emitDetachedComments;
	    function writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine) {
	        if (text.charCodeAt(commentPos + 1) === 42 /* asterisk */) {
	            var firstCommentLineAndCharacter = ts.computeLineAndCharacterOfPosition(lineMap, commentPos);
	            var lineCount = lineMap.length;
	            var firstCommentLineIndent = void 0;
	            for (var pos = commentPos, currentLine = firstCommentLineAndCharacter.line; pos < commentEnd; currentLine++) {
	                var nextLineStart = (currentLine + 1) === lineCount
	                    ? text.length + 1
	                    : lineMap[currentLine + 1];
	                if (pos !== commentPos) {
	                    // If we are not emitting first line, we need to write the spaces to adjust the alignment
	                    if (firstCommentLineIndent === undefined) {
	                        firstCommentLineIndent = calculateIndent(text, lineMap[firstCommentLineAndCharacter.line], commentPos);
	                    }
	                    // These are number of spaces writer is going to write at current indent
	                    var currentWriterIndentSpacing = writer.getIndent() * getIndentSize();
	                    // Number of spaces we want to be writing
	                    // eg: Assume writer indent
	                    // module m {
	                    //         /* starts at character 9 this is line 1
	                    //    * starts at character pos 4 line                        --1  = 8 - 8 + 3
	                    //   More left indented comment */                            --2  = 8 - 8 + 2
	                    //     class c { }
	                    // }
	                    // module m {
	                    //     /* this is line 1 -- Assume current writer indent 8
	                    //      * line                                                --3 = 8 - 4 + 5
	                    //            More right indented comment */                  --4 = 8 - 4 + 11
	                    //     class c { }
	                    // }
	                    var spacesToEmit = currentWriterIndentSpacing - firstCommentLineIndent + calculateIndent(text, pos, nextLineStart);
	                    if (spacesToEmit > 0) {
	                        var numberOfSingleSpacesToEmit = spacesToEmit % getIndentSize();
	                        var indentSizeSpaceString = getIndentString((spacesToEmit - numberOfSingleSpacesToEmit) / getIndentSize());
	                        // Write indent size string ( in eg 1: = "", 2: "" , 3: string with 8 spaces 4: string with 12 spaces
	                        writer.rawWrite(indentSizeSpaceString);
	                        // Emit the single spaces (in eg: 1: 3 spaces, 2: 2 spaces, 3: 1 space, 4: 3 spaces)
	                        while (numberOfSingleSpacesToEmit) {
	                            writer.rawWrite(" ");
	                            numberOfSingleSpacesToEmit--;
	                        }
	                    }
	                    else {
	                        // No spaces to emit write empty string
	                        writer.rawWrite("");
	                    }
	                }
	                // Write the comment line text
	                writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart);
	                pos = nextLineStart;
	            }
	        }
	        else {
	            // Single line comment of style //....
	            writer.write(text.substring(commentPos, commentEnd));
	        }
	    }
	    ts.writeCommentRange = writeCommentRange;
	    function writeTrimmedCurrentLine(text, commentEnd, writer, newLine, pos, nextLineStart) {
	        var end = Math.min(commentEnd, nextLineStart - 1);
	        var currentLineText = text.substring(pos, end).replace(/^\s+|\s+$/g, "");
	        if (currentLineText) {
	            // trimmed forward and ending spaces text
	            writer.write(currentLineText);
	            if (end !== commentEnd) {
	                writer.writeLine();
	            }
	        }
	        else {
	            // Empty string - make sure we write empty line
	            writer.writeLiteral(newLine);
	        }
	    }
	    function calculateIndent(text, pos, end) {
	        var currentLineIndent = 0;
	        for (; pos < end && ts.isWhiteSpaceSingleLine(text.charCodeAt(pos)); pos++) {
	            if (text.charCodeAt(pos) === 9 /* tab */) {
	                // Tabs = TabSize = indent size and go to next tabStop
	                currentLineIndent += getIndentSize() - (currentLineIndent % getIndentSize());
	            }
	            else {
	                // Single space
	                currentLineIndent++;
	            }
	        }
	        return currentLineIndent;
	    }
	    function hasModifiers(node) {
	        return getModifierFlags(node) !== 0 /* None */;
	    }
	    ts.hasModifiers = hasModifiers;
	    function hasModifier(node, flags) {
	        return !!getSelectedModifierFlags(node, flags);
	    }
	    ts.hasModifier = hasModifier;
	    function hasStaticModifier(node) {
	        return hasModifier(node, 32 /* Static */);
	    }
	    ts.hasStaticModifier = hasStaticModifier;
	    function hasReadonlyModifier(node) {
	        return hasModifier(node, 64 /* Readonly */);
	    }
	    ts.hasReadonlyModifier = hasReadonlyModifier;
	    function getSelectedModifierFlags(node, flags) {
	        return getModifierFlags(node) & flags;
	    }
	    ts.getSelectedModifierFlags = getSelectedModifierFlags;
	    function getModifierFlags(node) {
	        if (node.modifierFlagsCache & 536870912 /* HasComputedFlags */) {
	            return node.modifierFlagsCache & ~536870912 /* HasComputedFlags */;
	        }
	        var flags = getModifierFlagsNoCache(node);
	        node.modifierFlagsCache = flags | 536870912 /* HasComputedFlags */;
	        return flags;
	    }
	    ts.getModifierFlags = getModifierFlags;
	    function getModifierFlagsNoCache(node) {
	        var flags = 0 /* None */;
	        if (node.modifiers) {
	            for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                var modifier = _a[_i];
	                flags |= modifierToFlag(modifier.kind);
	            }
	        }
	        if (node.flags & 4 /* NestedNamespace */ || (node.kind === 71 /* Identifier */ && node.isInJSDocNamespace)) {
	            flags |= 1 /* Export */;
	        }
	        return flags;
	    }
	    ts.getModifierFlagsNoCache = getModifierFlagsNoCache;
	    function modifierToFlag(token) {
	        switch (token) {
	            case 115 /* StaticKeyword */: return 32 /* Static */;
	            case 114 /* PublicKeyword */: return 4 /* Public */;
	            case 113 /* ProtectedKeyword */: return 16 /* Protected */;
	            case 112 /* PrivateKeyword */: return 8 /* Private */;
	            case 117 /* AbstractKeyword */: return 128 /* Abstract */;
	            case 84 /* ExportKeyword */: return 1 /* Export */;
	            case 124 /* DeclareKeyword */: return 2 /* Ambient */;
	            case 76 /* ConstKeyword */: return 2048 /* Const */;
	            case 79 /* DefaultKeyword */: return 512 /* Default */;
	            case 120 /* AsyncKeyword */: return 256 /* Async */;
	            case 132 /* ReadonlyKeyword */: return 64 /* Readonly */;
	        }
	        return 0 /* None */;
	    }
	    ts.modifierToFlag = modifierToFlag;
	    function isLogicalOperator(token) {
	        return token === 54 /* BarBarToken */
	            || token === 53 /* AmpersandAmpersandToken */
	            || token === 51 /* ExclamationToken */;
	    }
	    ts.isLogicalOperator = isLogicalOperator;
	    function isAssignmentOperator(token) {
	        return token >= 58 /* FirstAssignment */ && token <= 70 /* LastAssignment */;
	    }
	    ts.isAssignmentOperator = isAssignmentOperator;
	    /** Get `C` given `N` if `N` is in the position `class C extends N` where `N` is an ExpressionWithTypeArguments. */
	    function tryGetClassExtendingExpressionWithTypeArguments(node) {
	        if (node.kind === 206 /* ExpressionWithTypeArguments */ &&
	            node.parent.token === 85 /* ExtendsKeyword */ &&
	            ts.isClassLike(node.parent.parent)) {
	            return node.parent.parent;
	        }
	    }
	    ts.tryGetClassExtendingExpressionWithTypeArguments = tryGetClassExtendingExpressionWithTypeArguments;
	    function isAssignmentExpression(node, excludeCompoundAssignment) {
	        return ts.isBinaryExpression(node)
	            && (excludeCompoundAssignment
	                ? node.operatorToken.kind === 58 /* EqualsToken */
	                : isAssignmentOperator(node.operatorToken.kind))
	            && ts.isLeftHandSideExpression(node.left);
	    }
	    ts.isAssignmentExpression = isAssignmentExpression;
	    function isDestructuringAssignment(node) {
	        if (isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
	            var kind = node.left.kind;
	            return kind === 183 /* ObjectLiteralExpression */
	                || kind === 182 /* ArrayLiteralExpression */;
	        }
	        return false;
	    }
	    ts.isDestructuringAssignment = isDestructuringAssignment;
	    function isExpressionWithTypeArgumentsInClassExtendsClause(node) {
	        return tryGetClassExtendingExpressionWithTypeArguments(node) !== undefined;
	    }
	    ts.isExpressionWithTypeArgumentsInClassExtendsClause = isExpressionWithTypeArgumentsInClassExtendsClause;
	    function isExpressionWithTypeArgumentsInClassImplementsClause(node) {
	        return node.kind === 206 /* ExpressionWithTypeArguments */
	            && isEntityNameExpression(node.expression)
	            && node.parent
	            && node.parent.token === 108 /* ImplementsKeyword */
	            && node.parent.parent
	            && ts.isClassLike(node.parent.parent);
	    }
	    ts.isExpressionWithTypeArgumentsInClassImplementsClause = isExpressionWithTypeArgumentsInClassImplementsClause;
	    function isEntityNameExpression(node) {
	        return node.kind === 71 /* Identifier */ || isPropertyAccessEntityNameExpression(node);
	    }
	    ts.isEntityNameExpression = isEntityNameExpression;
	    function isPropertyAccessEntityNameExpression(node) {
	        return ts.isPropertyAccessExpression(node) && isEntityNameExpression(node.expression);
	    }
	    ts.isPropertyAccessEntityNameExpression = isPropertyAccessEntityNameExpression;
	    function isPrototypeAccess(node) {
	        return ts.isPropertyAccessExpression(node) && node.name.escapedText === "prototype";
	    }
	    ts.isPrototypeAccess = isPrototypeAccess;
	    function isRightSideOfQualifiedNameOrPropertyAccess(node) {
	        return (node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node) ||
	            (node.parent.kind === 184 /* PropertyAccessExpression */ && node.parent.name === node);
	    }
	    ts.isRightSideOfQualifiedNameOrPropertyAccess = isRightSideOfQualifiedNameOrPropertyAccess;
	    function isEmptyObjectLiteral(expression) {
	        return expression.kind === 183 /* ObjectLiteralExpression */ &&
	            expression.properties.length === 0;
	    }
	    ts.isEmptyObjectLiteral = isEmptyObjectLiteral;
	    function isEmptyArrayLiteral(expression) {
	        return expression.kind === 182 /* ArrayLiteralExpression */ &&
	            expression.elements.length === 0;
	    }
	    ts.isEmptyArrayLiteral = isEmptyArrayLiteral;
	    function getLocalSymbolForExportDefault(symbol) {
	        return isExportDefaultSymbol(symbol) ? symbol.declarations[0].localSymbol : undefined;
	    }
	    ts.getLocalSymbolForExportDefault = getLocalSymbolForExportDefault;
	    function isExportDefaultSymbol(symbol) {
	        return symbol && ts.length(symbol.declarations) > 0 && hasModifier(symbol.declarations[0], 512 /* Default */);
	    }
	    /** Return ".ts", ".d.ts", or ".tsx", if that is the extension. */
	    function tryExtractTypeScriptExtension(fileName) {
	        return ts.find(ts.supportedTypescriptExtensionsForExtractExtension, function (extension) { return ts.fileExtensionIs(fileName, extension); });
	    }
	    ts.tryExtractTypeScriptExtension = tryExtractTypeScriptExtension;
	    /**
	     * Replace each instance of non-ascii characters by one, two, three, or four escape sequences
	     * representing the UTF-8 encoding of the character, and return the expanded char code list.
	     */
	    function getExpandedCharCodes(input) {
	        var output = [];
	        var length = input.length;
	        for (var i = 0; i < length; i++) {
	            var charCode = input.charCodeAt(i);
	            // handle utf8
	            if (charCode < 0x80) {
	                output.push(charCode);
	            }
	            else if (charCode < 0x800) {
	                output.push((charCode >> 6) | 192);
	                output.push((charCode & 63) | 128);
	            }
	            else if (charCode < 0x10000) {
	                output.push((charCode >> 12) | 224);
	                output.push(((charCode >> 6) & 63) | 128);
	                output.push((charCode & 63) | 128);
	            }
	            else if (charCode < 0x20000) {
	                output.push((charCode >> 18) | 240);
	                output.push(((charCode >> 12) & 63) | 128);
	                output.push(((charCode >> 6) & 63) | 128);
	                output.push((charCode & 63) | 128);
	            }
	            else {
	                ts.Debug.assert(false, "Unexpected code point");
	            }
	        }
	        return output;
	    }
	    var base64Digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    /**
	     * Converts a string to a base-64 encoded ASCII string.
	     */
	    function convertToBase64(input) {
	        var result = "";
	        var charCodes = getExpandedCharCodes(input);
	        var i = 0;
	        var length = charCodes.length;
	        var byte1, byte2, byte3, byte4;
	        while (i < length) {
	            // Convert every 6-bits in the input 3 character points
	            // into a base64 digit
	            byte1 = charCodes[i] >> 2;
	            byte2 = (charCodes[i] & 3) << 4 | charCodes[i + 1] >> 4;
	            byte3 = (charCodes[i + 1] & 15) << 2 | charCodes[i + 2] >> 6;
	            byte4 = charCodes[i + 2] & 63;
	            // We are out of characters in the input, set the extra
	            // digits to 64 (padding character).
	            if (i + 1 >= length) {
	                byte3 = byte4 = 64;
	            }
	            else if (i + 2 >= length) {
	                byte4 = 64;
	            }
	            // Write to the output
	            result += base64Digits.charAt(byte1) + base64Digits.charAt(byte2) + base64Digits.charAt(byte3) + base64Digits.charAt(byte4);
	            i += 3;
	        }
	        return result;
	    }
	    ts.convertToBase64 = convertToBase64;
	    function getStringFromExpandedCharCodes(codes) {
	        var output = "";
	        var i = 0;
	        var length = codes.length;
	        while (i < length) {
	            var charCode = codes[i];
	            if (charCode < 0x80) {
	                output += String.fromCharCode(charCode);
	                i++;
	            }
	            else if ((charCode & 192) === 192) {
	                var value = charCode & 63;
	                i++;
	                var nextCode = codes[i];
	                while ((nextCode & 192) === 128) {
	                    value = (value << 6) | (nextCode & 63);
	                    i++;
	                    nextCode = codes[i];
	                }
	                // `value` may be greater than 10FFFF (the maximum unicode codepoint) - JS will just make this into an invalid character for us
	                output += String.fromCharCode(value);
	            }
	            else {
	                // We don't want to kill the process when decoding fails (due to a following char byte not
	                // following a leading char), so we just print the (bad) value
	                output += String.fromCharCode(charCode);
	                i++;
	            }
	        }
	        return output;
	    }
	    function base64encode(host, input) {
	        if (host.base64encode) {
	            return host.base64encode(input);
	        }
	        return convertToBase64(input);
	    }
	    ts.base64encode = base64encode;
	    function base64decode(host, input) {
	        if (host.base64decode) {
	            return host.base64decode(input);
	        }
	        var length = input.length;
	        var expandedCharCodes = [];
	        var i = 0;
	        while (i < length) {
	            // Stop decoding once padding characters are present
	            if (input.charCodeAt(i) === base64Digits.charCodeAt(64)) {
	                break;
	            }
	            // convert 4 input digits into three characters, ignoring padding characters at the end
	            var ch1 = base64Digits.indexOf(input[i]);
	            var ch2 = base64Digits.indexOf(input[i + 1]);
	            var ch3 = base64Digits.indexOf(input[i + 2]);
	            var ch4 = base64Digits.indexOf(input[i + 3]);
	            var code1 = ((ch1 & 63) << 2) | ((ch2 >> 4) & 3);
	            var code2 = ((ch2 & 15) << 4) | ((ch3 >> 2) & 15);
	            var code3 = ((ch3 & 3) << 6) | (ch4 & 63);
	            if (code2 === 0 && ch3 !== 0) { // code2 decoded to zero, but ch3 was padding - elide code2 and code3
	                expandedCharCodes.push(code1);
	            }
	            else if (code3 === 0 && ch4 !== 0) { // code3 decoded to zero, but ch4 was padding, elide code3
	                expandedCharCodes.push(code1, code2);
	            }
	            else {
	                expandedCharCodes.push(code1, code2, code3);
	            }
	            i += 4;
	        }
	        return getStringFromExpandedCharCodes(expandedCharCodes);
	    }
	    ts.base64decode = base64decode;
	    var carriageReturnLineFeed = "\r\n";
	    var lineFeed = "\n";
	    function getNewLineCharacter(options, getNewLine) {
	        switch (options.newLine) {
	            case 0 /* CarriageReturnLineFeed */:
	                return carriageReturnLineFeed;
	            case 1 /* LineFeed */:
	                return lineFeed;
	        }
	        return getNewLine ? getNewLine() : ts.sys ? ts.sys.newLine : carriageReturnLineFeed;
	    }
	    ts.getNewLineCharacter = getNewLineCharacter;
	    /**
	     * Formats an enum value as a string for debugging and debug assertions.
	     */
	    function formatEnum(value, enumObject, isFlags) {
	        if (value === void 0) { value = 0; }
	        var members = getEnumMembers(enumObject);
	        if (value === 0) {
	            return members.length > 0 && members[0][0] === 0 ? members[0][1] : "0";
	        }
	        if (isFlags) {
	            var result = "";
	            var remainingFlags = value;
	            for (var i = members.length - 1; i >= 0 && remainingFlags !== 0; i--) {
	                var _a = members[i], enumValue = _a[0], enumName = _a[1];
	                if (enumValue !== 0 && (remainingFlags & enumValue) === enumValue) {
	                    remainingFlags &= ~enumValue;
	                    result = "" + enumName + (result ? ", " : "") + result;
	                }
	            }
	            if (remainingFlags === 0) {
	                return result;
	            }
	        }
	        else {
	            for (var _i = 0, members_1 = members; _i < members_1.length; _i++) {
	                var _b = members_1[_i], enumValue = _b[0], enumName = _b[1];
	                if (enumValue === value) {
	                    return enumName;
	                }
	            }
	        }
	        return value.toString();
	    }
	    function getEnumMembers(enumObject) {
	        var result = [];
	        for (var name in enumObject) {
	            var value = enumObject[name];
	            if (typeof value === "number") {
	                result.push([value, name]);
	            }
	        }
	        return ts.stableSort(result, function (x, y) { return ts.compareValues(x[0], y[0]); });
	    }
	    function formatSyntaxKind(kind) {
	        return formatEnum(kind, ts.SyntaxKind, /*isFlags*/ false);
	    }
	    ts.formatSyntaxKind = formatSyntaxKind;
	    function formatModifierFlags(flags) {
	        return formatEnum(flags, ts.ModifierFlags, /*isFlags*/ true);
	    }
	    ts.formatModifierFlags = formatModifierFlags;
	    function formatTransformFlags(flags) {
	        return formatEnum(flags, ts.TransformFlags, /*isFlags*/ true);
	    }
	    ts.formatTransformFlags = formatTransformFlags;
	    function formatEmitFlags(flags) {
	        return formatEnum(flags, ts.EmitFlags, /*isFlags*/ true);
	    }
	    ts.formatEmitFlags = formatEmitFlags;
	    function formatSymbolFlags(flags) {
	        return formatEnum(flags, ts.SymbolFlags, /*isFlags*/ true);
	    }
	    ts.formatSymbolFlags = formatSymbolFlags;
	    function formatTypeFlags(flags) {
	        return formatEnum(flags, ts.TypeFlags, /*isFlags*/ true);
	    }
	    ts.formatTypeFlags = formatTypeFlags;
	    function formatObjectFlags(flags) {
	        return formatEnum(flags, ts.ObjectFlags, /*isFlags*/ true);
	    }
	    ts.formatObjectFlags = formatObjectFlags;
	    /**
	     * Creates a new TextRange from the provided pos and end.
	     *
	     * @param pos The start position.
	     * @param end The end position.
	     */
	    function createRange(pos, end) {
	        return { pos: pos, end: end };
	    }
	    ts.createRange = createRange;
	    /**
	     * Creates a new TextRange from a provided range with a new end position.
	     *
	     * @param range A TextRange.
	     * @param end The new end position.
	     */
	    function moveRangeEnd(range, end) {
	        return createRange(range.pos, end);
	    }
	    ts.moveRangeEnd = moveRangeEnd;
	    /**
	     * Creates a new TextRange from a provided range with a new start position.
	     *
	     * @param range A TextRange.
	     * @param pos The new Start position.
	     */
	    function moveRangePos(range, pos) {
	        return createRange(pos, range.end);
	    }
	    ts.moveRangePos = moveRangePos;
	    /**
	     * Moves the start position of a range past any decorators.
	     */
	    function moveRangePastDecorators(node) {
	        return node.decorators && node.decorators.length > 0
	            ? moveRangePos(node, node.decorators.end)
	            : node;
	    }
	    ts.moveRangePastDecorators = moveRangePastDecorators;
	    /**
	     * Moves the start position of a range past any decorators or modifiers.
	     */
	    function moveRangePastModifiers(node) {
	        return node.modifiers && node.modifiers.length > 0
	            ? moveRangePos(node, node.modifiers.end)
	            : moveRangePastDecorators(node);
	    }
	    ts.moveRangePastModifiers = moveRangePastModifiers;
	    /**
	     * Determines whether a TextRange has the same start and end positions.
	     *
	     * @param range A TextRange.
	     */
	    function isCollapsedRange(range) {
	        return range.pos === range.end;
	    }
	    ts.isCollapsedRange = isCollapsedRange;
	    /**
	     * Creates a new TextRange for a token at the provides start position.
	     *
	     * @param pos The start position.
	     * @param token The token.
	     */
	    function createTokenRange(pos, token) {
	        return createRange(pos, pos + ts.tokenToString(token).length);
	    }
	    ts.createTokenRange = createTokenRange;
	    function rangeIsOnSingleLine(range, sourceFile) {
	        return rangeStartIsOnSameLineAsRangeEnd(range, range, sourceFile);
	    }
	    ts.rangeIsOnSingleLine = rangeIsOnSingleLine;
	    function rangeStartPositionsAreOnSameLine(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile), getStartPositionOfRange(range2, sourceFile), sourceFile);
	    }
	    ts.rangeStartPositionsAreOnSameLine = rangeStartPositionsAreOnSameLine;
	    function rangeEndPositionsAreOnSameLine(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(range1.end, range2.end, sourceFile);
	    }
	    ts.rangeEndPositionsAreOnSameLine = rangeEndPositionsAreOnSameLine;
	    function rangeStartIsOnSameLineAsRangeEnd(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(getStartPositionOfRange(range1, sourceFile), range2.end, sourceFile);
	    }
	    ts.rangeStartIsOnSameLineAsRangeEnd = rangeStartIsOnSameLineAsRangeEnd;
	    function rangeEndIsOnSameLineAsRangeStart(range1, range2, sourceFile) {
	        return positionsAreOnSameLine(range1.end, getStartPositionOfRange(range2, sourceFile), sourceFile);
	    }
	    ts.rangeEndIsOnSameLineAsRangeStart = rangeEndIsOnSameLineAsRangeStart;
	    function positionsAreOnSameLine(pos1, pos2, sourceFile) {
	        return pos1 === pos2 ||
	            getLineOfLocalPosition(sourceFile, pos1) === getLineOfLocalPosition(sourceFile, pos2);
	    }
	    ts.positionsAreOnSameLine = positionsAreOnSameLine;
	    function getStartPositionOfRange(range, sourceFile) {
	        return ts.positionIsSynthesized(range.pos) ? -1 : ts.skipTrivia(sourceFile.text, range.pos);
	    }
	    ts.getStartPositionOfRange = getStartPositionOfRange;
	    /**
	     * Determines whether a name was originally the declaration name of an enum or namespace
	     * declaration.
	     */
	    function isDeclarationNameOfEnumOrNamespace(node) {
	        var parseNode = ts.getParseTreeNode(node);
	        if (parseNode) {
	            switch (parseNode.parent.kind) {
	                case 237 /* EnumDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                    return parseNode === parseNode.parent.name;
	            }
	        }
	        return false;
	    }
	    ts.isDeclarationNameOfEnumOrNamespace = isDeclarationNameOfEnumOrNamespace;
	    function getInitializedVariables(node) {
	        return ts.filter(node.declarations, isInitializedVariable);
	    }
	    ts.getInitializedVariables = getInitializedVariables;
	    function isInitializedVariable(node) {
	        return node.initializer !== undefined;
	    }
	    function isWatchSet(options) {
	        // Firefox has Object.prototype.watch
	        return options.watch && options.hasOwnProperty("watch");
	    }
	    ts.isWatchSet = isWatchSet;
	    function getCheckFlags(symbol) {
	        return symbol.flags & 33554432 /* Transient */ ? symbol.checkFlags : 0;
	    }
	    ts.getCheckFlags = getCheckFlags;
	    function getDeclarationModifierFlagsFromSymbol(s) {
	        if (s.valueDeclaration) {
	            var flags = ts.getCombinedModifierFlags(s.valueDeclaration);
	            return s.parent && s.parent.flags & 32 /* Class */ ? flags : flags & ~28 /* AccessibilityModifier */;
	        }
	        if (getCheckFlags(s) & 6 /* Synthetic */) {
	            var checkFlags = s.checkFlags;
	            var accessModifier = checkFlags & 256 /* ContainsPrivate */ ? 8 /* Private */ :
	                checkFlags & 64 /* ContainsPublic */ ? 4 /* Public */ :
	                    16 /* Protected */;
	            var staticModifier = checkFlags & 512 /* ContainsStatic */ ? 32 /* Static */ : 0;
	            return accessModifier | staticModifier;
	        }
	        if (s.flags & 4194304 /* Prototype */) {
	            return 4 /* Public */ | 32 /* Static */;
	        }
	        return 0;
	    }
	    ts.getDeclarationModifierFlagsFromSymbol = getDeclarationModifierFlagsFromSymbol;
	    function skipAlias(symbol, checker) {
	        return symbol.flags & 2097152 /* Alias */ ? checker.getAliasedSymbol(symbol) : symbol;
	    }
	    ts.skipAlias = skipAlias;
	    /** See comment on `declareModuleMember` in `binder.ts`. */
	    function getCombinedLocalAndExportSymbolFlags(symbol) {
	        return symbol.exportSymbol ? symbol.exportSymbol.flags | symbol.flags : symbol.flags;
	    }
	    ts.getCombinedLocalAndExportSymbolFlags = getCombinedLocalAndExportSymbolFlags;
	    function isWriteOnlyAccess(node) {
	        return accessKind(node) === 1 /* Write */;
	    }
	    ts.isWriteOnlyAccess = isWriteOnlyAccess;
	    function isWriteAccess(node) {
	        return accessKind(node) !== 0 /* Read */;
	    }
	    ts.isWriteAccess = isWriteAccess;
	    var AccessKind;
	    (function (AccessKind) {
	        /** Only reads from a variable. */
	        AccessKind[AccessKind["Read"] = 0] = "Read";
	        /** Only writes to a variable without using the result. E.g.: `x++;`. */
	        AccessKind[AccessKind["Write"] = 1] = "Write";
	        /** Writes to a variable and uses the result as an expression. E.g.: `f(x++);`. */
	        AccessKind[AccessKind["ReadWrite"] = 2] = "ReadWrite";
	    })(AccessKind || (AccessKind = {}));
	    function accessKind(node) {
	        var parent = node.parent;
	        if (!parent)
	            return 0 /* Read */;
	        switch (parent.kind) {
	            case 198 /* PostfixUnaryExpression */:
	            case 197 /* PrefixUnaryExpression */:
	                var operator = parent.operator;
	                return operator === 43 /* PlusPlusToken */ || operator === 44 /* MinusMinusToken */ ? writeOrReadWrite() : 0 /* Read */;
	            case 199 /* BinaryExpression */:
	                var _a = parent, left = _a.left, operatorToken = _a.operatorToken;
	                return left === node && isAssignmentOperator(operatorToken.kind) ? writeOrReadWrite() : 0 /* Read */;
	            case 184 /* PropertyAccessExpression */:
	                return parent.name !== node ? 0 /* Read */ : accessKind(parent);
	            default:
	                return 0 /* Read */;
	        }
	        function writeOrReadWrite() {
	            // If grandparent is not an ExpressionStatement, this is used as an expression in addition to having a side effect.
	            return parent.parent && parent.parent.kind === 215 /* ExpressionStatement */ ? 1 /* Write */ : 2 /* ReadWrite */;
	        }
	    }
	    function compareDataObjects(dst, src) {
	        if (!dst || !src || Object.keys(dst).length !== Object.keys(src).length) {
	            return false;
	        }
	        for (var e in dst) {
	            if (typeof dst[e] === "object") {
	                if (!compareDataObjects(dst[e], src[e])) {
	                    return false;
	                }
	            }
	            else if (typeof dst[e] !== "function") {
	                if (dst[e] !== src[e]) {
	                    return false;
	                }
	            }
	        }
	        return true;
	    }
	    ts.compareDataObjects = compareDataObjects;
	    /**
	     * clears already present map by calling onDeleteExistingValue callback before deleting that key/value
	     */
	    function clearMap(map, onDeleteValue) {
	        // Remove all
	        map.forEach(onDeleteValue);
	        map.clear();
	    }
	    ts.clearMap = clearMap;
	    /**
	     * Mutates the map with newMap such that keys in map will be same as newMap.
	     */
	    function mutateMap(map, newMap, options) {
	        var createNewValue = options.createNewValue, onDeleteValue = options.onDeleteValue, onExistingValue = options.onExistingValue;
	        // Needs update
	        map.forEach(function (existingValue, key) {
	            var valueInNewMap = newMap.get(key);
	            // Not present any more in new map, remove it
	            if (valueInNewMap === undefined) {
	                map.delete(key);
	                onDeleteValue(existingValue, key);
	            }
	            // If present notify about existing values
	            else if (onExistingValue) {
	                onExistingValue(existingValue, valueInNewMap, key);
	            }
	        });
	        // Add new values that are not already present
	        newMap.forEach(function (valueInNewMap, key) {
	            if (!map.has(key)) {
	                // New values
	                map.set(key, createNewValue(key, valueInNewMap));
	            }
	        });
	    }
	    ts.mutateMap = mutateMap;
	    /** Calls `callback` on `directory` and every ancestor directory it has, returning the first defined result. */
	    function forEachAncestorDirectory(directory, callback) {
	        while (true) {
	            var result = callback(directory);
	            if (result !== undefined) {
	                return result;
	            }
	            var parentPath = ts.getDirectoryPath(directory);
	            if (parentPath === directory) {
	                return undefined;
	            }
	            directory = parentPath;
	        }
	    }
	    ts.forEachAncestorDirectory = forEachAncestorDirectory;
	    // Return true if the given type is the constructor type for an abstract class
	    function isAbstractConstructorType(type) {
	        return !!(getObjectFlags(type) & 16 /* Anonymous */) && !!type.symbol && isAbstractConstructorSymbol(type.symbol);
	    }
	    ts.isAbstractConstructorType = isAbstractConstructorType;
	    function isAbstractConstructorSymbol(symbol) {
	        if (symbol.flags & 32 /* Class */) {
	            var declaration = getClassLikeDeclarationOfSymbol(symbol);
	            return !!declaration && hasModifier(declaration, 128 /* Abstract */);
	        }
	        return false;
	    }
	    ts.isAbstractConstructorSymbol = isAbstractConstructorSymbol;
	    function getClassLikeDeclarationOfSymbol(symbol) {
	        return ts.find(symbol.declarations, ts.isClassLike);
	    }
	    ts.getClassLikeDeclarationOfSymbol = getClassLikeDeclarationOfSymbol;
	    function getObjectFlags(type) {
	        return type.flags & 65536 /* Object */ ? type.objectFlags : 0;
	    }
	    ts.getObjectFlags = getObjectFlags;
	    function typeHasCallOrConstructSignatures(type, checker) {
	        return checker.getSignaturesOfType(type, 0 /* Call */).length !== 0 || checker.getSignaturesOfType(type, 1 /* Construct */).length !== 0;
	    }
	    ts.typeHasCallOrConstructSignatures = typeHasCallOrConstructSignatures;
	    function forSomeAncestorDirectory(directory, callback) {
	        return !!forEachAncestorDirectory(directory, function (d) { return callback(d) ? true : undefined; });
	    }
	    ts.forSomeAncestorDirectory = forSomeAncestorDirectory;
	    function isUMDExportSymbol(symbol) {
	        return symbol && symbol.declarations && symbol.declarations[0] && ts.isNamespaceExportDeclaration(symbol.declarations[0]);
	    }
	    ts.isUMDExportSymbol = isUMDExportSymbol;
	    function showModuleSpecifier(_a) {
	        var moduleSpecifier = _a.moduleSpecifier;
	        return ts.isStringLiteral(moduleSpecifier) ? moduleSpecifier.text : getTextOfNode(moduleSpecifier);
	    }
	    ts.showModuleSpecifier = showModuleSpecifier;
	    function getLastChild(node) {
	        var lastChild;
	        ts.forEachChild(node, function (child) {
	            if (nodeIsPresent(child))
	                lastChild = child;
	        }, function (children) {
	            // As an optimization, jump straight to the end of the list.
	            for (var i = children.length - 1; i >= 0; i--) {
	                if (nodeIsPresent(children[i])) {
	                    lastChild = children[i];
	                    break;
	                }
	            }
	        });
	        return lastChild;
	    }
	    ts.getLastChild = getLastChild;
	    function addToSeen(seen, key, value) {
	        if (value === void 0) { value = true; }
	        key = String(key);
	        if (seen.has(key)) {
	            return false;
	        }
	        seen.set(key, value);
	        return true;
	    }
	    ts.addToSeen = addToSeen;
	    function isObjectTypeDeclaration(node) {
	        return ts.isClassLike(node) || ts.isInterfaceDeclaration(node) || ts.isTypeLiteralNode(node);
	    }
	    ts.isObjectTypeDeclaration = isObjectTypeDeclaration;
	})(ts || (ts = {}));
	(function (ts) {
	    function getDefaultLibFileName(options) {
	        switch (options.target) {
	            case 6 /* ESNext */:
	                return "lib.esnext.full.d.ts";
	            case 4 /* ES2017 */:
	                return "lib.es2017.full.d.ts";
	            case 3 /* ES2016 */:
	                return "lib.es2016.full.d.ts";
	            case 2 /* ES2015 */:
	                return "lib.es6.d.ts"; // We don't use lib.es2015.full.d.ts due to breaking change.
	            default:
	                return "lib.d.ts";
	        }
	    }
	    ts.getDefaultLibFileName = getDefaultLibFileName;
	    function textSpanEnd(span) {
	        return span.start + span.length;
	    }
	    ts.textSpanEnd = textSpanEnd;
	    function textSpanIsEmpty(span) {
	        return span.length === 0;
	    }
	    ts.textSpanIsEmpty = textSpanIsEmpty;
	    function textSpanContainsPosition(span, position) {
	        return position >= span.start && position < textSpanEnd(span);
	    }
	    ts.textSpanContainsPosition = textSpanContainsPosition;
	    // Returns true if 'span' contains 'other'.
	    function textSpanContainsTextSpan(span, other) {
	        return other.start >= span.start && textSpanEnd(other) <= textSpanEnd(span);
	    }
	    ts.textSpanContainsTextSpan = textSpanContainsTextSpan;
	    function textSpanOverlapsWith(span, other) {
	        return textSpanOverlap(span, other) !== undefined;
	    }
	    ts.textSpanOverlapsWith = textSpanOverlapsWith;
	    function textSpanOverlap(span1, span2) {
	        var overlap = textSpanIntersection(span1, span2);
	        return overlap && overlap.length === 0 ? undefined : overlap;
	    }
	    ts.textSpanOverlap = textSpanOverlap;
	    function textSpanIntersectsWithTextSpan(span, other) {
	        return decodedTextSpanIntersectsWith(span.start, span.length, other.start, other.length);
	    }
	    ts.textSpanIntersectsWithTextSpan = textSpanIntersectsWithTextSpan;
	    function textSpanIntersectsWith(span, start, length) {
	        return decodedTextSpanIntersectsWith(span.start, span.length, start, length);
	    }
	    ts.textSpanIntersectsWith = textSpanIntersectsWith;
	    function decodedTextSpanIntersectsWith(start1, length1, start2, length2) {
	        var end1 = start1 + length1;
	        var end2 = start2 + length2;
	        return start2 <= end1 && end2 >= start1;
	    }
	    ts.decodedTextSpanIntersectsWith = decodedTextSpanIntersectsWith;
	    function textSpanIntersectsWithPosition(span, position) {
	        return position <= textSpanEnd(span) && position >= span.start;
	    }
	    ts.textSpanIntersectsWithPosition = textSpanIntersectsWithPosition;
	    function textSpanIntersection(span1, span2) {
	        var start = Math.max(span1.start, span2.start);
	        var end = Math.min(textSpanEnd(span1), textSpanEnd(span2));
	        return start <= end ? createTextSpanFromBounds(start, end) : undefined;
	    }
	    ts.textSpanIntersection = textSpanIntersection;
	    function createTextSpan(start, length) {
	        if (start < 0) {
	            throw new Error("start < 0");
	        }
	        if (length < 0) {
	            throw new Error("length < 0");
	        }
	        return { start: start, length: length };
	    }
	    ts.createTextSpan = createTextSpan;
	    /* @internal */
	    function createTextRange(pos, end) {
	        if (end === void 0) { end = pos; }
	        ts.Debug.assert(end >= pos);
	        return { pos: pos, end: end };
	    }
	    ts.createTextRange = createTextRange;
	    function createTextSpanFromBounds(start, end) {
	        return createTextSpan(start, end - start);
	    }
	    ts.createTextSpanFromBounds = createTextSpanFromBounds;
	    function textChangeRangeNewSpan(range) {
	        return createTextSpan(range.span.start, range.newLength);
	    }
	    ts.textChangeRangeNewSpan = textChangeRangeNewSpan;
	    function textChangeRangeIsUnchanged(range) {
	        return textSpanIsEmpty(range.span) && range.newLength === 0;
	    }
	    ts.textChangeRangeIsUnchanged = textChangeRangeIsUnchanged;
	    function createTextChangeRange(span, newLength) {
	        if (newLength < 0) {
	            throw new Error("newLength < 0");
	        }
	        return { span: span, newLength: newLength };
	    }
	    ts.createTextChangeRange = createTextChangeRange;
	    ts.unchangedTextChangeRange = createTextChangeRange(createTextSpan(0, 0), 0);
	    /**
	     * Called to merge all the changes that occurred across several versions of a script snapshot
	     * into a single change.  i.e. if a user keeps making successive edits to a script we will
	     * have a text change from V1 to V2, V2 to V3, ..., Vn.
	     *
	     * This function will then merge those changes into a single change range valid between V1 and
	     * Vn.
	     */
	    function collapseTextChangeRangesAcrossMultipleVersions(changes) {
	        if (changes.length === 0) {
	            return ts.unchangedTextChangeRange;
	        }
	        if (changes.length === 1) {
	            return changes[0];
	        }
	        // We change from talking about { { oldStart, oldLength }, newLength } to { oldStart, oldEnd, newEnd }
	        // as it makes things much easier to reason about.
	        var change0 = changes[0];
	        var oldStartN = change0.span.start;
	        var oldEndN = textSpanEnd(change0.span);
	        var newEndN = oldStartN + change0.newLength;
	        for (var i = 1; i < changes.length; i++) {
	            var nextChange = changes[i];
	            // Consider the following case:
	            // i.e. two edits.  The first represents the text change range { { 10, 50 }, 30 }.  i.e. The span starting
	            // at 10, with length 50 is reduced to length 30.  The second represents the text change range { { 30, 30 }, 40 }.
	            // i.e. the span starting at 30 with length 30 is increased to length 40.
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      -------------------------------------------------------------------------------------------------------
	            //                |                                                 /
	            //                |                                            /----
	            //  T1            |                                       /----
	            //                |                                  /----
	            //                |                             /----
	            //      -------------------------------------------------------------------------------------------------------
	            //                                     |                            \
	            //                                     |                               \
	            //   T2                                |                                 \
	            //                                     |                                   \
	            //                                     |                                      \
	            //      -------------------------------------------------------------------------------------------------------
	            //
	            // Merging these turns out to not be too difficult.  First, determining the new start of the change is trivial
	            // it's just the min of the old and new starts.  i.e.:
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      ------------------------------------------------------------*------------------------------------------
	            //                |                                                 /
	            //                |                                            /----
	            //  T1            |                                       /----
	            //                |                                  /----
	            //                |                             /----
	            //      ----------------------------------------$-------------------$------------------------------------------
	            //                .                    |                            \
	            //                .                    |                               \
	            //   T2           .                    |                                 \
	            //                .                    |                                   \
	            //                .                    |                                      \
	            //      ----------------------------------------------------------------------*--------------------------------
	            //
	            // (Note the dots represent the newly inferred start.
	            // Determining the new and old end is also pretty simple.  Basically it boils down to paying attention to the
	            // absolute positions at the asterisks, and the relative change between the dollar signs. Basically, we see
	            // which if the two $'s precedes the other, and we move that one forward until they line up.  in this case that
	            // means:
	            //
	            //      0         10        20        30        40        50        60        70        80        90        100
	            //      --------------------------------------------------------------------------------*----------------------
	            //                |                                                                     /
	            //                |                                                                /----
	            //  T1            |                                                           /----
	            //                |                                                      /----
	            //                |                                                 /----
	            //      ------------------------------------------------------------$------------------------------------------
	            //                .                    |                            \
	            //                .                    |                               \
	            //   T2           .                    |                                 \
	            //                .                    |                                   \
	            //                .                    |                                      \
	            //      ----------------------------------------------------------------------*--------------------------------
	            //
	            // In other words (in this case), we're recognizing that the second edit happened after where the first edit
	            // ended with a delta of 20 characters (60 - 40).  Thus, if we go back in time to where the first edit started
	            // that's the same as if we started at char 80 instead of 60.
	            //
	            // As it so happens, the same logic applies if the second edit precedes the first edit.  In that case rather
	            // than pushing the first edit forward to match the second, we'll push the second edit forward to match the
	            // first.
	            //
	            // In this case that means we have { oldStart: 10, oldEnd: 80, newEnd: 70 } or, in TextChangeRange
	            // semantics: { { start: 10, length: 70 }, newLength: 60 }
	            //
	            // The math then works out as follows.
	            // If we have { oldStart1, oldEnd1, newEnd1 } and { oldStart2, oldEnd2, newEnd2 } then we can compute the
	            // final result like so:
	            //
	            // {
	            //      oldStart3: Min(oldStart1, oldStart2),
	            //      oldEnd3: Max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1)),
	            //      newEnd3: Max(newEnd2, newEnd2 + (newEnd1 - oldEnd2))
	            // }
	            var oldStart1 = oldStartN;
	            var oldEnd1 = oldEndN;
	            var newEnd1 = newEndN;
	            var oldStart2 = nextChange.span.start;
	            var oldEnd2 = textSpanEnd(nextChange.span);
	            var newEnd2 = oldStart2 + nextChange.newLength;
	            oldStartN = Math.min(oldStart1, oldStart2);
	            oldEndN = Math.max(oldEnd1, oldEnd1 + (oldEnd2 - newEnd1));
	            newEndN = Math.max(newEnd2, newEnd2 + (newEnd1 - oldEnd2));
	        }
	        return createTextChangeRange(createTextSpanFromBounds(oldStartN, oldEndN), /*newLength*/ newEndN - oldStartN);
	    }
	    ts.collapseTextChangeRangesAcrossMultipleVersions = collapseTextChangeRangesAcrossMultipleVersions;
	    function getTypeParameterOwner(d) {
	        if (d && d.kind === 147 /* TypeParameter */) {
	            for (var current = d; current; current = current.parent) {
	                if (ts.isFunctionLike(current) || ts.isClassLike(current) || current.kind === 235 /* InterfaceDeclaration */) {
	                    return current;
	                }
	            }
	        }
	    }
	    ts.getTypeParameterOwner = getTypeParameterOwner;
	    function isParameterPropertyDeclaration(node) {
	        return ts.hasModifier(node, 92 /* ParameterPropertyModifier */) && node.parent.kind === 154 /* Constructor */;
	    }
	    ts.isParameterPropertyDeclaration = isParameterPropertyDeclaration;
	    function isEmptyBindingPattern(node) {
	        if (ts.isBindingPattern(node)) {
	            return ts.every(node.elements, isEmptyBindingElement);
	        }
	        return false;
	    }
	    ts.isEmptyBindingPattern = isEmptyBindingPattern;
	    function isEmptyBindingElement(node) {
	        if (ts.isOmittedExpression(node)) {
	            return true;
	        }
	        return isEmptyBindingPattern(node.name);
	    }
	    ts.isEmptyBindingElement = isEmptyBindingElement;
	    function walkUpBindingElementsAndPatterns(node) {
	        while (node && (node.kind === 181 /* BindingElement */ || ts.isBindingPattern(node))) {
	            node = node.parent;
	        }
	        return node;
	    }
	    function getCombinedModifierFlags(node) {
	        node = walkUpBindingElementsAndPatterns(node);
	        var flags = ts.getModifierFlags(node);
	        if (node.kind === 231 /* VariableDeclaration */) {
	            node = node.parent;
	        }
	        if (node && node.kind === 232 /* VariableDeclarationList */) {
	            flags |= ts.getModifierFlags(node);
	            node = node.parent;
	        }
	        if (node && node.kind === 213 /* VariableStatement */) {
	            flags |= ts.getModifierFlags(node);
	        }
	        return flags;
	    }
	    ts.getCombinedModifierFlags = getCombinedModifierFlags;
	    // Returns the node flags for this node and all relevant parent nodes.  This is done so that
	    // nodes like variable declarations and binding elements can returned a view of their flags
	    // that includes the modifiers from their container.  i.e. flags like export/declare aren't
	    // stored on the variable declaration directly, but on the containing variable statement
	    // (if it has one).  Similarly, flags for let/const are store on the variable declaration
	    // list.  By calling this function, all those flags are combined so that the client can treat
	    // the node as if it actually had those flags.
	    function getCombinedNodeFlags(node) {
	        node = walkUpBindingElementsAndPatterns(node);
	        var flags = node.flags;
	        if (node.kind === 231 /* VariableDeclaration */) {
	            node = node.parent;
	        }
	        if (node && node.kind === 232 /* VariableDeclarationList */) {
	            flags |= node.flags;
	            node = node.parent;
	        }
	        if (node && node.kind === 213 /* VariableStatement */) {
	            flags |= node.flags;
	        }
	        return flags;
	    }
	    ts.getCombinedNodeFlags = getCombinedNodeFlags;
	    /**
	     * Checks to see if the locale is in the appropriate format,
	     * and if it is, attempts to set the appropriate language.
	     */
	    function validateLocaleAndSetLanguage(locale, sys, errors) {
	        var matchResult = /^([a-z]+)([_\-]([a-z]+))?$/.exec(locale.toLowerCase());
	        if (!matchResult) {
	            if (errors) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Locale_must_be_of_the_form_language_or_language_territory_For_example_0_or_1, "en", "ja-jp"));
	            }
	            return;
	        }
	        var language = matchResult[1];
	        var territory = matchResult[3];
	        // First try the entire locale, then fall back to just language if that's all we have.
	        // Either ways do not fail, and fallback to the English diagnostic strings.
	        if (!trySetLanguageAndTerritory(language, territory, errors)) {
	            trySetLanguageAndTerritory(language, /*territory*/ undefined, errors);
	        }
	        // Set the UI locale for string collation
	        ts.setUILocale(locale);
	        function trySetLanguageAndTerritory(language, territory, errors) {
	            var compilerFilePath = ts.normalizePath(sys.getExecutingFilePath());
	            var containingDirectoryPath = ts.getDirectoryPath(compilerFilePath);
	            var filePath = ts.combinePaths(containingDirectoryPath, language);
	            if (territory) {
	                filePath = filePath + "-" + territory;
	            }
	            filePath = sys.resolvePath(ts.combinePaths(filePath, "diagnosticMessages.generated.json"));
	            if (!sys.fileExists(filePath)) {
	                return false;
	            }
	            // TODO: Add codePage support for readFile?
	            var fileContents = "";
	            try {
	                fileContents = sys.readFile(filePath);
	            }
	            catch (e) {
	                if (errors) {
	                    errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unable_to_open_file_0, filePath));
	                }
	                return false;
	            }
	            try {
	                // tslint:disable-next-line no-unnecessary-qualifier (making clear this is a global mutation!)
	                ts.localizedDiagnosticMessages = JSON.parse(fileContents);
	            }
	            catch (e) {
	                if (errors) {
	                    errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Corrupted_locale_file_0, filePath));
	                }
	                return false;
	            }
	            return true;
	        }
	    }
	    ts.validateLocaleAndSetLanguage = validateLocaleAndSetLanguage;
	    function getOriginalNode(node, nodeTest) {
	        if (node) {
	            while (node.original !== undefined) {
	                node = node.original;
	            }
	        }
	        return !nodeTest || nodeTest(node) ? node : undefined;
	    }
	    ts.getOriginalNode = getOriginalNode;
	    /**
	     * Gets a value indicating whether a node originated in the parse tree.
	     *
	     * @param node The node to test.
	     */
	    function isParseTreeNode(node) {
	        return (node.flags & 8 /* Synthesized */) === 0;
	    }
	    ts.isParseTreeNode = isParseTreeNode;
	    function getParseTreeNode(node, nodeTest) {
	        if (node === undefined || isParseTreeNode(node)) {
	            return node;
	        }
	        node = getOriginalNode(node);
	        if (isParseTreeNode(node) && (!nodeTest || nodeTest(node))) {
	            return node;
	        }
	        return undefined;
	    }
	    ts.getParseTreeNode = getParseTreeNode;
	    /**
	     * Remove extra underscore from escaped identifier text content.
	     *
	     * @param identifier The escaped identifier text.
	     * @returns The unescaped identifier text.
	     */
	    function unescapeLeadingUnderscores(identifier) {
	        var id = identifier;
	        return id.length >= 3 && id.charCodeAt(0) === 95 /* _ */ && id.charCodeAt(1) === 95 /* _ */ && id.charCodeAt(2) === 95 /* _ */ ? id.substr(1) : id;
	    }
	    ts.unescapeLeadingUnderscores = unescapeLeadingUnderscores;
	    function idText(identifier) {
	        return unescapeLeadingUnderscores(identifier.escapedText);
	    }
	    ts.idText = idText;
	    function symbolName(symbol) {
	        return unescapeLeadingUnderscores(symbol.escapedName);
	    }
	    ts.symbolName = symbolName;
	    /**
	     * Remove extra underscore from escaped identifier text content.
	     * @deprecated Use `id.text` for the unescaped text.
	     * @param identifier The escaped identifier text.
	     * @returns The unescaped identifier text.
	     */
	    function unescapeIdentifier(id) {
	        return id;
	    }
	    ts.unescapeIdentifier = unescapeIdentifier;
	    /**
	     * A JSDocTypedef tag has an _optional_ name field - if a name is not directly present, we should
	     * attempt to draw the name from the node the declaration is on (as that declaration is what its' symbol
	     * will be merged with)
	     */
	    function nameForNamelessJSDocTypedef(declaration) {
	        var hostNode = declaration.parent.parent;
	        if (!hostNode) {
	            return undefined;
	        }
	        // Covers classes, functions - any named declaration host node
	        if (ts.isDeclaration(hostNode)) {
	            return getDeclarationIdentifier(hostNode);
	        }
	        // Covers remaining cases
	        switch (hostNode.kind) {
	            case 213 /* VariableStatement */:
	                if (hostNode.declarationList && hostNode.declarationList.declarations[0]) {
	                    return getDeclarationIdentifier(hostNode.declarationList.declarations[0]);
	                }
	                return undefined;
	            case 215 /* ExpressionStatement */:
	                var expr = hostNode.expression;
	                switch (expr.kind) {
	                    case 184 /* PropertyAccessExpression */:
	                        return expr.name;
	                    case 185 /* ElementAccessExpression */:
	                        var arg = expr.argumentExpression;
	                        if (ts.isIdentifier(arg)) {
	                            return arg;
	                        }
	                }
	                return undefined;
	            case 1 /* EndOfFileToken */:
	                return undefined;
	            case 190 /* ParenthesizedExpression */: {
	                return getDeclarationIdentifier(hostNode.expression);
	            }
	            case 227 /* LabeledStatement */: {
	                if (ts.isDeclaration(hostNode.statement) || ts.isExpression(hostNode.statement)) {
	                    return getDeclarationIdentifier(hostNode.statement);
	                }
	                return undefined;
	            }
	            default:
	                ts.Debug.assertNever(hostNode, "Found typedef tag attached to node which it should not be!");
	        }
	    }
	    function getDeclarationIdentifier(node) {
	        var name = getNameOfDeclaration(node);
	        return ts.isIdentifier(name) ? name : undefined;
	    }
	    function getNameOfJSDocTypedef(declaration) {
	        return declaration.name || nameForNamelessJSDocTypedef(declaration);
	    }
	    ts.getNameOfJSDocTypedef = getNameOfJSDocTypedef;
	    /** @internal */
	    function isNamedDeclaration(node) {
	        return !!node.name; // A 'name' property should always be a DeclarationName.
	    }
	    ts.isNamedDeclaration = isNamedDeclaration;
	    function getNameOfDeclaration(declaration) {
	        if (!declaration) {
	            return undefined;
	        }
	        switch (declaration.kind) {
	            case 204 /* ClassExpression */:
	            case 191 /* FunctionExpression */:
	                if (!declaration.name) {
	                    return getAssignedName(declaration);
	                }
	                break;
	            case 71 /* Identifier */:
	                return declaration;
	            case 297 /* JSDocPropertyTag */:
	            case 292 /* JSDocParameterTag */: {
	                var name = declaration.name;
	                if (name.kind === 145 /* QualifiedName */) {
	                    return name.right;
	                }
	                break;
	            }
	            case 199 /* BinaryExpression */: {
	                var expr = declaration;
	                switch (ts.getSpecialPropertyAssignmentKind(expr)) {
	                    case 1 /* ExportsProperty */:
	                    case 4 /* ThisProperty */:
	                    case 5 /* Property */:
	                    case 3 /* PrototypeProperty */:
	                        return expr.left.name;
	                    default:
	                        return undefined;
	                }
	            }
	            case 291 /* JSDocCallbackTag */:
	                return declaration.name;
	            case 296 /* JSDocTypedefTag */:
	                return getNameOfJSDocTypedef(declaration);
	            case 248 /* ExportAssignment */: {
	                var expression = declaration.expression;
	                return ts.isIdentifier(expression) ? expression : undefined;
	            }
	        }
	        return declaration.name;
	    }
	    ts.getNameOfDeclaration = getNameOfDeclaration;
	    function getAssignedName(node) {
	        if (!node.parent) {
	            return undefined;
	        }
	        else if (ts.isPropertyAssignment(node.parent) || ts.isBindingElement(node.parent)) {
	            return node.parent.name;
	        }
	        else if (ts.isBinaryExpression(node.parent) && node === node.parent.right) {
	            if (ts.isIdentifier(node.parent.left)) {
	                return node.parent.left;
	            }
	            else if (ts.isPropertyAccessExpression(node.parent.left)) {
	                return node.parent.left.name;
	            }
	        }
	    }
	    /**
	     * Gets the JSDoc parameter tags for the node if present.
	     *
	     * @remarks Returns any JSDoc param tag that matches the provided
	     * parameter, whether a param tag on a containing function
	     * expression, or a param tag on a variable declaration whose
	     * initializer is the containing function. The tags closest to the
	     * node are returned first, so in the previous example, the param
	     * tag on the containing function expression would be first.
	     *
	     * Does not return tags for binding patterns, because JSDoc matches
	     * parameters by name and binding patterns do not have a name.
	     */
	    function getJSDocParameterTags(param) {
	        if (param.name) {
	            if (ts.isIdentifier(param.name)) {
	                var name_1 = param.name.escapedText;
	                return getJSDocTags(param.parent).filter(function (tag) { return ts.isJSDocParameterTag(tag) && ts.isIdentifier(tag.name) && tag.name.escapedText === name_1; });
	            }
	            else {
	                var i = param.parent.parameters.indexOf(param);
	                ts.Debug.assert(i > -1, "Parameters should always be in their parents' parameter list");
	                var paramTags = getJSDocTags(param.parent).filter(ts.isJSDocParameterTag);
	                if (i < paramTags.length) {
	                    return [paramTags[i]];
	                }
	            }
	        }
	        // return empty array for: out-of-order binding patterns and JSDoc function syntax, which has un-named parameters
	        return ts.emptyArray;
	    }
	    ts.getJSDocParameterTags = getJSDocParameterTags;
	    /**
	     * Return true if the node has JSDoc parameter tags.
	     *
	     * @remarks Includes parameter tags that are not directly on the node,
	     * for example on a variable declaration whose initializer is a function expression.
	     */
	    function hasJSDocParameterTags(node) {
	        return !!getFirstJSDocTag(node, ts.isJSDocParameterTag);
	    }
	    ts.hasJSDocParameterTags = hasJSDocParameterTags;
	    /** Gets the JSDoc augments tag for the node if present */
	    function getJSDocAugmentsTag(node) {
	        return getFirstJSDocTag(node, ts.isJSDocAugmentsTag);
	    }
	    ts.getJSDocAugmentsTag = getJSDocAugmentsTag;
	    /** Gets the JSDoc class tag for the node if present */
	    function getJSDocClassTag(node) {
	        return getFirstJSDocTag(node, ts.isJSDocClassTag);
	    }
	    ts.getJSDocClassTag = getJSDocClassTag;
	    /** Gets the JSDoc return tag for the node if present */
	    function getJSDocReturnTag(node) {
	        return getFirstJSDocTag(node, ts.isJSDocReturnTag);
	    }
	    ts.getJSDocReturnTag = getJSDocReturnTag;
	    /** Gets the JSDoc template tag for the node if present */
	    function getJSDocTemplateTag(node) {
	        return getFirstJSDocTag(node, ts.isJSDocTemplateTag);
	    }
	    ts.getJSDocTemplateTag = getJSDocTemplateTag;
	    /** Gets the JSDoc type tag for the node if present and valid */
	    function getJSDocTypeTag(node) {
	        // We should have already issued an error if there were multiple type jsdocs, so just use the first one.
	        var tag = getFirstJSDocTag(node, ts.isJSDocTypeTag);
	        if (tag && tag.typeExpression && tag.typeExpression.type) {
	            return tag;
	        }
	        return undefined;
	    }
	    ts.getJSDocTypeTag = getJSDocTypeTag;
	    /**
	     * Gets the type node for the node if provided via JSDoc.
	     *
	     * @remarks The search includes any JSDoc param tag that relates
	     * to the provided parameter, for example a type tag on the
	     * parameter itself, or a param tag on a containing function
	     * expression, or a param tag on a variable declaration whose
	     * initializer is the containing function. The tags closest to the
	     * node are examined first, so in the previous example, the type
	     * tag directly on the node would be returned.
	     */
	    function getJSDocType(node) {
	        var tag = getFirstJSDocTag(node, ts.isJSDocTypeTag);
	        if (!tag && ts.isParameter(node)) {
	            tag = ts.find(getJSDocParameterTags(node), function (tag) { return !!tag.typeExpression; });
	        }
	        return tag && tag.typeExpression && tag.typeExpression.type;
	    }
	    ts.getJSDocType = getJSDocType;
	    /**
	     * Gets the return type node for the node if provided via JSDoc's return tag.
	     *
	     * @remarks `getJSDocReturnTag` just gets the whole JSDoc tag. This function
	     * gets the type from inside the braces.
	     */
	    function getJSDocReturnType(node) {
	        var returnTag = getJSDocReturnTag(node);
	        return returnTag && returnTag.typeExpression && returnTag.typeExpression.type;
	    }
	    ts.getJSDocReturnType = getJSDocReturnType;
	    /** Get all JSDoc tags related to a node, including those on parent nodes. */
	    function getJSDocTags(node) {
	        var tags = node.jsDocCache;
	        // If cache is 'null', that means we did the work of searching for JSDoc tags and came up with nothing.
	        if (tags === undefined) {
	            var comments = ts.getJSDocCommentsAndTags(node);
	            ts.Debug.assert(comments.length < 2 || comments[0] !== comments[1]);
	            node.jsDocCache = tags = ts.flatMap(comments, function (j) { return ts.isJSDoc(j) ? j.tags : j; });
	        }
	        return tags;
	    }
	    ts.getJSDocTags = getJSDocTags;
	    /** Get the first JSDoc tag of a specified kind, or undefined if not present. */
	    function getFirstJSDocTag(node, predicate) {
	        return ts.find(getJSDocTags(node), predicate);
	    }
	    /** Gets all JSDoc tags of a specified kind, or undefined if not present. */
	    function getAllJSDocTagsOfKind(node, kind) {
	        return getJSDocTags(node).filter(function (doc) { return doc.kind === kind; });
	    }
	    ts.getAllJSDocTagsOfKind = getAllJSDocTagsOfKind;
	})(ts || (ts = {}));
	// Simple node tests of the form `node.kind === SyntaxKind.Foo`.
	(function (ts) {
	    // Literals
	    function isNumericLiteral(node) {
	        return node.kind === 8 /* NumericLiteral */;
	    }
	    ts.isNumericLiteral = isNumericLiteral;
	    function isStringLiteral(node) {
	        return node.kind === 9 /* StringLiteral */;
	    }
	    ts.isStringLiteral = isStringLiteral;
	    function isJsxText(node) {
	        return node.kind === 10 /* JsxText */;
	    }
	    ts.isJsxText = isJsxText;
	    function isRegularExpressionLiteral(node) {
	        return node.kind === 12 /* RegularExpressionLiteral */;
	    }
	    ts.isRegularExpressionLiteral = isRegularExpressionLiteral;
	    function isNoSubstitutionTemplateLiteral(node) {
	        return node.kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isNoSubstitutionTemplateLiteral = isNoSubstitutionTemplateLiteral;
	    // Pseudo-literals
	    function isTemplateHead(node) {
	        return node.kind === 14 /* TemplateHead */;
	    }
	    ts.isTemplateHead = isTemplateHead;
	    function isTemplateMiddle(node) {
	        return node.kind === 15 /* TemplateMiddle */;
	    }
	    ts.isTemplateMiddle = isTemplateMiddle;
	    function isTemplateTail(node) {
	        return node.kind === 16 /* TemplateTail */;
	    }
	    ts.isTemplateTail = isTemplateTail;
	    function isIdentifier(node) {
	        return node.kind === 71 /* Identifier */;
	    }
	    ts.isIdentifier = isIdentifier;
	    // Names
	    function isQualifiedName(node) {
	        return node.kind === 145 /* QualifiedName */;
	    }
	    ts.isQualifiedName = isQualifiedName;
	    function isComputedPropertyName(node) {
	        return node.kind === 146 /* ComputedPropertyName */;
	    }
	    ts.isComputedPropertyName = isComputedPropertyName;
	    // Signature elements
	    function isTypeParameterDeclaration(node) {
	        return node.kind === 147 /* TypeParameter */;
	    }
	    ts.isTypeParameterDeclaration = isTypeParameterDeclaration;
	    function isParameter(node) {
	        return node.kind === 148 /* Parameter */;
	    }
	    ts.isParameter = isParameter;
	    function isDecorator(node) {
	        return node.kind === 149 /* Decorator */;
	    }
	    ts.isDecorator = isDecorator;
	    // TypeMember
	    function isPropertySignature(node) {
	        return node.kind === 150 /* PropertySignature */;
	    }
	    ts.isPropertySignature = isPropertySignature;
	    function isPropertyDeclaration(node) {
	        return node.kind === 151 /* PropertyDeclaration */;
	    }
	    ts.isPropertyDeclaration = isPropertyDeclaration;
	    function isMethodSignature(node) {
	        return node.kind === 152 /* MethodSignature */;
	    }
	    ts.isMethodSignature = isMethodSignature;
	    function isMethodDeclaration(node) {
	        return node.kind === 153 /* MethodDeclaration */;
	    }
	    ts.isMethodDeclaration = isMethodDeclaration;
	    function isConstructorDeclaration(node) {
	        return node.kind === 154 /* Constructor */;
	    }
	    ts.isConstructorDeclaration = isConstructorDeclaration;
	    function isGetAccessorDeclaration(node) {
	        return node.kind === 155 /* GetAccessor */;
	    }
	    ts.isGetAccessorDeclaration = isGetAccessorDeclaration;
	    function isSetAccessorDeclaration(node) {
	        return node.kind === 156 /* SetAccessor */;
	    }
	    ts.isSetAccessorDeclaration = isSetAccessorDeclaration;
	    function isCallSignatureDeclaration(node) {
	        return node.kind === 157 /* CallSignature */;
	    }
	    ts.isCallSignatureDeclaration = isCallSignatureDeclaration;
	    function isConstructSignatureDeclaration(node) {
	        return node.kind === 158 /* ConstructSignature */;
	    }
	    ts.isConstructSignatureDeclaration = isConstructSignatureDeclaration;
	    function isIndexSignatureDeclaration(node) {
	        return node.kind === 159 /* IndexSignature */;
	    }
	    ts.isIndexSignatureDeclaration = isIndexSignatureDeclaration;
	    /* @internal */
	    function isGetOrSetAccessorDeclaration(node) {
	        return node.kind === 156 /* SetAccessor */ || node.kind === 155 /* GetAccessor */;
	    }
	    ts.isGetOrSetAccessorDeclaration = isGetOrSetAccessorDeclaration;
	    // Type
	    function isTypePredicateNode(node) {
	        return node.kind === 160 /* TypePredicate */;
	    }
	    ts.isTypePredicateNode = isTypePredicateNode;
	    function isTypeReferenceNode(node) {
	        return node.kind === 161 /* TypeReference */;
	    }
	    ts.isTypeReferenceNode = isTypeReferenceNode;
	    function isFunctionTypeNode(node) {
	        return node.kind === 162 /* FunctionType */;
	    }
	    ts.isFunctionTypeNode = isFunctionTypeNode;
	    function isConstructorTypeNode(node) {
	        return node.kind === 163 /* ConstructorType */;
	    }
	    ts.isConstructorTypeNode = isConstructorTypeNode;
	    function isTypeQueryNode(node) {
	        return node.kind === 164 /* TypeQuery */;
	    }
	    ts.isTypeQueryNode = isTypeQueryNode;
	    function isTypeLiteralNode(node) {
	        return node.kind === 165 /* TypeLiteral */;
	    }
	    ts.isTypeLiteralNode = isTypeLiteralNode;
	    function isArrayTypeNode(node) {
	        return node.kind === 166 /* ArrayType */;
	    }
	    ts.isArrayTypeNode = isArrayTypeNode;
	    function isTupleTypeNode(node) {
	        return node.kind === 167 /* TupleType */;
	    }
	    ts.isTupleTypeNode = isTupleTypeNode;
	    function isUnionTypeNode(node) {
	        return node.kind === 168 /* UnionType */;
	    }
	    ts.isUnionTypeNode = isUnionTypeNode;
	    function isIntersectionTypeNode(node) {
	        return node.kind === 169 /* IntersectionType */;
	    }
	    ts.isIntersectionTypeNode = isIntersectionTypeNode;
	    function isConditionalTypeNode(node) {
	        return node.kind === 170 /* ConditionalType */;
	    }
	    ts.isConditionalTypeNode = isConditionalTypeNode;
	    function isInferTypeNode(node) {
	        return node.kind === 171 /* InferType */;
	    }
	    ts.isInferTypeNode = isInferTypeNode;
	    function isParenthesizedTypeNode(node) {
	        return node.kind === 172 /* ParenthesizedType */;
	    }
	    ts.isParenthesizedTypeNode = isParenthesizedTypeNode;
	    function isThisTypeNode(node) {
	        return node.kind === 173 /* ThisType */;
	    }
	    ts.isThisTypeNode = isThisTypeNode;
	    function isTypeOperatorNode(node) {
	        return node.kind === 174 /* TypeOperator */;
	    }
	    ts.isTypeOperatorNode = isTypeOperatorNode;
	    function isIndexedAccessTypeNode(node) {
	        return node.kind === 175 /* IndexedAccessType */;
	    }
	    ts.isIndexedAccessTypeNode = isIndexedAccessTypeNode;
	    function isMappedTypeNode(node) {
	        return node.kind === 176 /* MappedType */;
	    }
	    ts.isMappedTypeNode = isMappedTypeNode;
	    function isLiteralTypeNode(node) {
	        return node.kind === 177 /* LiteralType */;
	    }
	    ts.isLiteralTypeNode = isLiteralTypeNode;
	    function isImportTypeNode(node) {
	        return node.kind === 178 /* ImportType */;
	    }
	    ts.isImportTypeNode = isImportTypeNode;
	    // Binding patterns
	    function isObjectBindingPattern(node) {
	        return node.kind === 179 /* ObjectBindingPattern */;
	    }
	    ts.isObjectBindingPattern = isObjectBindingPattern;
	    function isArrayBindingPattern(node) {
	        return node.kind === 180 /* ArrayBindingPattern */;
	    }
	    ts.isArrayBindingPattern = isArrayBindingPattern;
	    function isBindingElement(node) {
	        return node.kind === 181 /* BindingElement */;
	    }
	    ts.isBindingElement = isBindingElement;
	    // Expression
	    function isArrayLiteralExpression(node) {
	        return node.kind === 182 /* ArrayLiteralExpression */;
	    }
	    ts.isArrayLiteralExpression = isArrayLiteralExpression;
	    function isObjectLiteralExpression(node) {
	        return node.kind === 183 /* ObjectLiteralExpression */;
	    }
	    ts.isObjectLiteralExpression = isObjectLiteralExpression;
	    function isPropertyAccessExpression(node) {
	        return node.kind === 184 /* PropertyAccessExpression */;
	    }
	    ts.isPropertyAccessExpression = isPropertyAccessExpression;
	    function isElementAccessExpression(node) {
	        return node.kind === 185 /* ElementAccessExpression */;
	    }
	    ts.isElementAccessExpression = isElementAccessExpression;
	    function isCallExpression(node) {
	        return node.kind === 186 /* CallExpression */;
	    }
	    ts.isCallExpression = isCallExpression;
	    function isNewExpression(node) {
	        return node.kind === 187 /* NewExpression */;
	    }
	    ts.isNewExpression = isNewExpression;
	    function isTaggedTemplateExpression(node) {
	        return node.kind === 188 /* TaggedTemplateExpression */;
	    }
	    ts.isTaggedTemplateExpression = isTaggedTemplateExpression;
	    function isTypeAssertion(node) {
	        return node.kind === 189 /* TypeAssertionExpression */;
	    }
	    ts.isTypeAssertion = isTypeAssertion;
	    function isParenthesizedExpression(node) {
	        return node.kind === 190 /* ParenthesizedExpression */;
	    }
	    ts.isParenthesizedExpression = isParenthesizedExpression;
	    function skipPartiallyEmittedExpressions(node) {
	        while (node.kind === 300 /* PartiallyEmittedExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipPartiallyEmittedExpressions = skipPartiallyEmittedExpressions;
	    function isFunctionExpression(node) {
	        return node.kind === 191 /* FunctionExpression */;
	    }
	    ts.isFunctionExpression = isFunctionExpression;
	    function isArrowFunction(node) {
	        return node.kind === 192 /* ArrowFunction */;
	    }
	    ts.isArrowFunction = isArrowFunction;
	    function isDeleteExpression(node) {
	        return node.kind === 193 /* DeleteExpression */;
	    }
	    ts.isDeleteExpression = isDeleteExpression;
	    function isTypeOfExpression(node) {
	        return node.kind === 194 /* TypeOfExpression */;
	    }
	    ts.isTypeOfExpression = isTypeOfExpression;
	    function isVoidExpression(node) {
	        return node.kind === 195 /* VoidExpression */;
	    }
	    ts.isVoidExpression = isVoidExpression;
	    function isAwaitExpression(node) {
	        return node.kind === 196 /* AwaitExpression */;
	    }
	    ts.isAwaitExpression = isAwaitExpression;
	    function isPrefixUnaryExpression(node) {
	        return node.kind === 197 /* PrefixUnaryExpression */;
	    }
	    ts.isPrefixUnaryExpression = isPrefixUnaryExpression;
	    function isPostfixUnaryExpression(node) {
	        return node.kind === 198 /* PostfixUnaryExpression */;
	    }
	    ts.isPostfixUnaryExpression = isPostfixUnaryExpression;
	    function isBinaryExpression(node) {
	        return node.kind === 199 /* BinaryExpression */;
	    }
	    ts.isBinaryExpression = isBinaryExpression;
	    function isConditionalExpression(node) {
	        return node.kind === 200 /* ConditionalExpression */;
	    }
	    ts.isConditionalExpression = isConditionalExpression;
	    function isTemplateExpression(node) {
	        return node.kind === 201 /* TemplateExpression */;
	    }
	    ts.isTemplateExpression = isTemplateExpression;
	    function isYieldExpression(node) {
	        return node.kind === 202 /* YieldExpression */;
	    }
	    ts.isYieldExpression = isYieldExpression;
	    function isSpreadElement(node) {
	        return node.kind === 203 /* SpreadElement */;
	    }
	    ts.isSpreadElement = isSpreadElement;
	    function isClassExpression(node) {
	        return node.kind === 204 /* ClassExpression */;
	    }
	    ts.isClassExpression = isClassExpression;
	    function isOmittedExpression(node) {
	        return node.kind === 205 /* OmittedExpression */;
	    }
	    ts.isOmittedExpression = isOmittedExpression;
	    function isExpressionWithTypeArguments(node) {
	        return node.kind === 206 /* ExpressionWithTypeArguments */;
	    }
	    ts.isExpressionWithTypeArguments = isExpressionWithTypeArguments;
	    function isAsExpression(node) {
	        return node.kind === 207 /* AsExpression */;
	    }
	    ts.isAsExpression = isAsExpression;
	    function isNonNullExpression(node) {
	        return node.kind === 208 /* NonNullExpression */;
	    }
	    ts.isNonNullExpression = isNonNullExpression;
	    function isMetaProperty(node) {
	        return node.kind === 209 /* MetaProperty */;
	    }
	    ts.isMetaProperty = isMetaProperty;
	    // Misc
	    function isTemplateSpan(node) {
	        return node.kind === 210 /* TemplateSpan */;
	    }
	    ts.isTemplateSpan = isTemplateSpan;
	    function isSemicolonClassElement(node) {
	        return node.kind === 211 /* SemicolonClassElement */;
	    }
	    ts.isSemicolonClassElement = isSemicolonClassElement;
	    // Block
	    function isBlock(node) {
	        return node.kind === 212 /* Block */;
	    }
	    ts.isBlock = isBlock;
	    function isVariableStatement(node) {
	        return node.kind === 213 /* VariableStatement */;
	    }
	    ts.isVariableStatement = isVariableStatement;
	    function isEmptyStatement(node) {
	        return node.kind === 214 /* EmptyStatement */;
	    }
	    ts.isEmptyStatement = isEmptyStatement;
	    function isExpressionStatement(node) {
	        return node.kind === 215 /* ExpressionStatement */;
	    }
	    ts.isExpressionStatement = isExpressionStatement;
	    function isIfStatement(node) {
	        return node.kind === 216 /* IfStatement */;
	    }
	    ts.isIfStatement = isIfStatement;
	    function isDoStatement(node) {
	        return node.kind === 217 /* DoStatement */;
	    }
	    ts.isDoStatement = isDoStatement;
	    function isWhileStatement(node) {
	        return node.kind === 218 /* WhileStatement */;
	    }
	    ts.isWhileStatement = isWhileStatement;
	    function isForStatement(node) {
	        return node.kind === 219 /* ForStatement */;
	    }
	    ts.isForStatement = isForStatement;
	    function isForInStatement(node) {
	        return node.kind === 220 /* ForInStatement */;
	    }
	    ts.isForInStatement = isForInStatement;
	    function isForOfStatement(node) {
	        return node.kind === 221 /* ForOfStatement */;
	    }
	    ts.isForOfStatement = isForOfStatement;
	    function isContinueStatement(node) {
	        return node.kind === 222 /* ContinueStatement */;
	    }
	    ts.isContinueStatement = isContinueStatement;
	    function isBreakStatement(node) {
	        return node.kind === 223 /* BreakStatement */;
	    }
	    ts.isBreakStatement = isBreakStatement;
	    function isBreakOrContinueStatement(node) {
	        return node.kind === 223 /* BreakStatement */ || node.kind === 222 /* ContinueStatement */;
	    }
	    ts.isBreakOrContinueStatement = isBreakOrContinueStatement;
	    function isReturnStatement(node) {
	        return node.kind === 224 /* ReturnStatement */;
	    }
	    ts.isReturnStatement = isReturnStatement;
	    function isWithStatement(node) {
	        return node.kind === 225 /* WithStatement */;
	    }
	    ts.isWithStatement = isWithStatement;
	    function isSwitchStatement(node) {
	        return node.kind === 226 /* SwitchStatement */;
	    }
	    ts.isSwitchStatement = isSwitchStatement;
	    function isLabeledStatement(node) {
	        return node.kind === 227 /* LabeledStatement */;
	    }
	    ts.isLabeledStatement = isLabeledStatement;
	    function isThrowStatement(node) {
	        return node.kind === 228 /* ThrowStatement */;
	    }
	    ts.isThrowStatement = isThrowStatement;
	    function isTryStatement(node) {
	        return node.kind === 229 /* TryStatement */;
	    }
	    ts.isTryStatement = isTryStatement;
	    function isDebuggerStatement(node) {
	        return node.kind === 230 /* DebuggerStatement */;
	    }
	    ts.isDebuggerStatement = isDebuggerStatement;
	    function isVariableDeclaration(node) {
	        return node.kind === 231 /* VariableDeclaration */;
	    }
	    ts.isVariableDeclaration = isVariableDeclaration;
	    function isVariableDeclarationList(node) {
	        return node.kind === 232 /* VariableDeclarationList */;
	    }
	    ts.isVariableDeclarationList = isVariableDeclarationList;
	    function isFunctionDeclaration(node) {
	        return node.kind === 233 /* FunctionDeclaration */;
	    }
	    ts.isFunctionDeclaration = isFunctionDeclaration;
	    function isClassDeclaration(node) {
	        return node.kind === 234 /* ClassDeclaration */;
	    }
	    ts.isClassDeclaration = isClassDeclaration;
	    function isInterfaceDeclaration(node) {
	        return node.kind === 235 /* InterfaceDeclaration */;
	    }
	    ts.isInterfaceDeclaration = isInterfaceDeclaration;
	    function isTypeAliasDeclaration(node) {
	        return node.kind === 236 /* TypeAliasDeclaration */;
	    }
	    ts.isTypeAliasDeclaration = isTypeAliasDeclaration;
	    function isEnumDeclaration(node) {
	        return node.kind === 237 /* EnumDeclaration */;
	    }
	    ts.isEnumDeclaration = isEnumDeclaration;
	    function isModuleDeclaration(node) {
	        return node.kind === 238 /* ModuleDeclaration */;
	    }
	    ts.isModuleDeclaration = isModuleDeclaration;
	    function isModuleBlock(node) {
	        return node.kind === 239 /* ModuleBlock */;
	    }
	    ts.isModuleBlock = isModuleBlock;
	    function isCaseBlock(node) {
	        return node.kind === 240 /* CaseBlock */;
	    }
	    ts.isCaseBlock = isCaseBlock;
	    function isNamespaceExportDeclaration(node) {
	        return node.kind === 241 /* NamespaceExportDeclaration */;
	    }
	    ts.isNamespaceExportDeclaration = isNamespaceExportDeclaration;
	    function isImportEqualsDeclaration(node) {
	        return node.kind === 242 /* ImportEqualsDeclaration */;
	    }
	    ts.isImportEqualsDeclaration = isImportEqualsDeclaration;
	    function isImportDeclaration(node) {
	        return node.kind === 243 /* ImportDeclaration */;
	    }
	    ts.isImportDeclaration = isImportDeclaration;
	    function isImportClause(node) {
	        return node.kind === 244 /* ImportClause */;
	    }
	    ts.isImportClause = isImportClause;
	    function isNamespaceImport(node) {
	        return node.kind === 245 /* NamespaceImport */;
	    }
	    ts.isNamespaceImport = isNamespaceImport;
	    function isNamedImports(node) {
	        return node.kind === 246 /* NamedImports */;
	    }
	    ts.isNamedImports = isNamedImports;
	    function isImportSpecifier(node) {
	        return node.kind === 247 /* ImportSpecifier */;
	    }
	    ts.isImportSpecifier = isImportSpecifier;
	    function isExportAssignment(node) {
	        return node.kind === 248 /* ExportAssignment */;
	    }
	    ts.isExportAssignment = isExportAssignment;
	    function isExportDeclaration(node) {
	        return node.kind === 249 /* ExportDeclaration */;
	    }
	    ts.isExportDeclaration = isExportDeclaration;
	    function isNamedExports(node) {
	        return node.kind === 250 /* NamedExports */;
	    }
	    ts.isNamedExports = isNamedExports;
	    function isExportSpecifier(node) {
	        return node.kind === 251 /* ExportSpecifier */;
	    }
	    ts.isExportSpecifier = isExportSpecifier;
	    function isMissingDeclaration(node) {
	        return node.kind === 252 /* MissingDeclaration */;
	    }
	    ts.isMissingDeclaration = isMissingDeclaration;
	    // Module References
	    function isExternalModuleReference(node) {
	        return node.kind === 253 /* ExternalModuleReference */;
	    }
	    ts.isExternalModuleReference = isExternalModuleReference;
	    // JSX
	    function isJsxElement(node) {
	        return node.kind === 254 /* JsxElement */;
	    }
	    ts.isJsxElement = isJsxElement;
	    function isJsxSelfClosingElement(node) {
	        return node.kind === 255 /* JsxSelfClosingElement */;
	    }
	    ts.isJsxSelfClosingElement = isJsxSelfClosingElement;
	    function isJsxOpeningElement(node) {
	        return node.kind === 256 /* JsxOpeningElement */;
	    }
	    ts.isJsxOpeningElement = isJsxOpeningElement;
	    function isJsxClosingElement(node) {
	        return node.kind === 257 /* JsxClosingElement */;
	    }
	    ts.isJsxClosingElement = isJsxClosingElement;
	    function isJsxFragment(node) {
	        return node.kind === 258 /* JsxFragment */;
	    }
	    ts.isJsxFragment = isJsxFragment;
	    function isJsxOpeningFragment(node) {
	        return node.kind === 259 /* JsxOpeningFragment */;
	    }
	    ts.isJsxOpeningFragment = isJsxOpeningFragment;
	    function isJsxClosingFragment(node) {
	        return node.kind === 260 /* JsxClosingFragment */;
	    }
	    ts.isJsxClosingFragment = isJsxClosingFragment;
	    function isJsxAttribute(node) {
	        return node.kind === 261 /* JsxAttribute */;
	    }
	    ts.isJsxAttribute = isJsxAttribute;
	    function isJsxAttributes(node) {
	        return node.kind === 262 /* JsxAttributes */;
	    }
	    ts.isJsxAttributes = isJsxAttributes;
	    function isJsxSpreadAttribute(node) {
	        return node.kind === 263 /* JsxSpreadAttribute */;
	    }
	    ts.isJsxSpreadAttribute = isJsxSpreadAttribute;
	    function isJsxExpression(node) {
	        return node.kind === 264 /* JsxExpression */;
	    }
	    ts.isJsxExpression = isJsxExpression;
	    // Clauses
	    function isCaseClause(node) {
	        return node.kind === 265 /* CaseClause */;
	    }
	    ts.isCaseClause = isCaseClause;
	    function isDefaultClause(node) {
	        return node.kind === 266 /* DefaultClause */;
	    }
	    ts.isDefaultClause = isDefaultClause;
	    function isHeritageClause(node) {
	        return node.kind === 267 /* HeritageClause */;
	    }
	    ts.isHeritageClause = isHeritageClause;
	    function isCatchClause(node) {
	        return node.kind === 268 /* CatchClause */;
	    }
	    ts.isCatchClause = isCatchClause;
	    // Property assignments
	    function isPropertyAssignment(node) {
	        return node.kind === 269 /* PropertyAssignment */;
	    }
	    ts.isPropertyAssignment = isPropertyAssignment;
	    function isShorthandPropertyAssignment(node) {
	        return node.kind === 270 /* ShorthandPropertyAssignment */;
	    }
	    ts.isShorthandPropertyAssignment = isShorthandPropertyAssignment;
	    function isSpreadAssignment(node) {
	        return node.kind === 271 /* SpreadAssignment */;
	    }
	    ts.isSpreadAssignment = isSpreadAssignment;
	    // Enum
	    function isEnumMember(node) {
	        return node.kind === 272 /* EnumMember */;
	    }
	    ts.isEnumMember = isEnumMember;
	    // Top-level nodes
	    function isSourceFile(node) {
	        return node.kind === 273 /* SourceFile */;
	    }
	    ts.isSourceFile = isSourceFile;
	    function isBundle(node) {
	        return node.kind === 274 /* Bundle */;
	    }
	    ts.isBundle = isBundle;
	    // JSDoc
	    function isJSDocTypeExpression(node) {
	        return node.kind === 277 /* JSDocTypeExpression */;
	    }
	    ts.isJSDocTypeExpression = isJSDocTypeExpression;
	    function isJSDocAllType(node) {
	        return node.kind === 278 /* JSDocAllType */;
	    }
	    ts.isJSDocAllType = isJSDocAllType;
	    function isJSDocUnknownType(node) {
	        return node.kind === 279 /* JSDocUnknownType */;
	    }
	    ts.isJSDocUnknownType = isJSDocUnknownType;
	    function isJSDocNullableType(node) {
	        return node.kind === 280 /* JSDocNullableType */;
	    }
	    ts.isJSDocNullableType = isJSDocNullableType;
	    function isJSDocNonNullableType(node) {
	        return node.kind === 281 /* JSDocNonNullableType */;
	    }
	    ts.isJSDocNonNullableType = isJSDocNonNullableType;
	    function isJSDocOptionalType(node) {
	        return node.kind === 282 /* JSDocOptionalType */;
	    }
	    ts.isJSDocOptionalType = isJSDocOptionalType;
	    function isJSDocFunctionType(node) {
	        return node.kind === 283 /* JSDocFunctionType */;
	    }
	    ts.isJSDocFunctionType = isJSDocFunctionType;
	    function isJSDocVariadicType(node) {
	        return node.kind === 284 /* JSDocVariadicType */;
	    }
	    ts.isJSDocVariadicType = isJSDocVariadicType;
	    function isJSDoc(node) {
	        return node.kind === 285 /* JSDocComment */;
	    }
	    ts.isJSDoc = isJSDoc;
	    function isJSDocAugmentsTag(node) {
	        return node.kind === 289 /* JSDocAugmentsTag */;
	    }
	    ts.isJSDocAugmentsTag = isJSDocAugmentsTag;
	    function isJSDocClassTag(node) {
	        return node.kind === 290 /* JSDocClassTag */;
	    }
	    ts.isJSDocClassTag = isJSDocClassTag;
	    function isJSDocParameterTag(node) {
	        return node.kind === 292 /* JSDocParameterTag */;
	    }
	    ts.isJSDocParameterTag = isJSDocParameterTag;
	    function isJSDocReturnTag(node) {
	        return node.kind === 293 /* JSDocReturnTag */;
	    }
	    ts.isJSDocReturnTag = isJSDocReturnTag;
	    function isJSDocTypeTag(node) {
	        return node.kind === 294 /* JSDocTypeTag */;
	    }
	    ts.isJSDocTypeTag = isJSDocTypeTag;
	    function isJSDocTemplateTag(node) {
	        return node.kind === 295 /* JSDocTemplateTag */;
	    }
	    ts.isJSDocTemplateTag = isJSDocTemplateTag;
	    function isJSDocTypedefTag(node) {
	        return node.kind === 296 /* JSDocTypedefTag */;
	    }
	    ts.isJSDocTypedefTag = isJSDocTypedefTag;
	    function isJSDocPropertyTag(node) {
	        return node.kind === 297 /* JSDocPropertyTag */;
	    }
	    ts.isJSDocPropertyTag = isJSDocPropertyTag;
	    function isJSDocPropertyLikeTag(node) {
	        return node.kind === 297 /* JSDocPropertyTag */ || node.kind === 292 /* JSDocParameterTag */;
	    }
	    ts.isJSDocPropertyLikeTag = isJSDocPropertyLikeTag;
	    function isJSDocTypeLiteral(node) {
	        return node.kind === 286 /* JSDocTypeLiteral */;
	    }
	    ts.isJSDocTypeLiteral = isJSDocTypeLiteral;
	    function isJSDocCallbackTag(node) {
	        return node.kind === 291 /* JSDocCallbackTag */;
	    }
	    ts.isJSDocCallbackTag = isJSDocCallbackTag;
	    function isJSDocSignature(node) {
	        return node.kind === 287 /* JSDocSignature */;
	    }
	    ts.isJSDocSignature = isJSDocSignature;
	})(ts || (ts = {}));
	// Node tests
	//
	// All node tests in the following list should *not* reference parent pointers so that
	// they may be used with transformations.
	(function (ts) {
	    /* @internal */
	    function isSyntaxList(n) {
	        return n.kind === 298 /* SyntaxList */;
	    }
	    ts.isSyntaxList = isSyntaxList;
	    /* @internal */
	    function isNode(node) {
	        return isNodeKind(node.kind);
	    }
	    ts.isNode = isNode;
	    /* @internal */
	    function isNodeKind(kind) {
	        return kind >= 145 /* FirstNode */;
	    }
	    ts.isNodeKind = isNodeKind;
	    /**
	     * True if node is of some token syntax kind.
	     * For example, this is true for an IfKeyword but not for an IfStatement.
	     * Literals are considered tokens, except TemplateLiteral, but does include TemplateHead/Middle/Tail.
	     */
	    function isToken(n) {
	        return n.kind >= 0 /* FirstToken */ && n.kind <= 144 /* LastToken */;
	    }
	    ts.isToken = isToken;
	    // Node Arrays
	    /* @internal */
	    function isNodeArray(array) {
	        return array.hasOwnProperty("pos") && array.hasOwnProperty("end");
	    }
	    ts.isNodeArray = isNodeArray;
	    // Literals
	    /* @internal */
	    function isLiteralKind(kind) {
	        return 8 /* FirstLiteralToken */ <= kind && kind <= 13 /* LastLiteralToken */;
	    }
	    ts.isLiteralKind = isLiteralKind;
	    function isLiteralExpression(node) {
	        return isLiteralKind(node.kind);
	    }
	    ts.isLiteralExpression = isLiteralExpression;
	    // Pseudo-literals
	    /* @internal */
	    function isTemplateLiteralKind(kind) {
	        return 13 /* FirstTemplateToken */ <= kind && kind <= 16 /* LastTemplateToken */;
	    }
	    ts.isTemplateLiteralKind = isTemplateLiteralKind;
	    function isTemplateMiddleOrTemplateTail(node) {
	        var kind = node.kind;
	        return kind === 15 /* TemplateMiddle */
	            || kind === 16 /* TemplateTail */;
	    }
	    ts.isTemplateMiddleOrTemplateTail = isTemplateMiddleOrTemplateTail;
	    function isStringTextContainingNode(node) {
	        return node.kind === 9 /* StringLiteral */ || isTemplateLiteralKind(node.kind);
	    }
	    ts.isStringTextContainingNode = isStringTextContainingNode;
	    // Identifiers
	    /* @internal */
	    function isGeneratedIdentifier(node) {
	        // Using `>` here catches both `GeneratedIdentifierKind.None` and `undefined`.
	        return ts.isIdentifier(node) && (node.autoGenerateFlags & 7 /* KindMask */) > 0 /* None */;
	    }
	    ts.isGeneratedIdentifier = isGeneratedIdentifier;
	    // Keywords
	    /* @internal */
	    function isModifierKind(token) {
	        switch (token) {
	            case 117 /* AbstractKeyword */:
	            case 120 /* AsyncKeyword */:
	            case 76 /* ConstKeyword */:
	            case 124 /* DeclareKeyword */:
	            case 79 /* DefaultKeyword */:
	            case 84 /* ExportKeyword */:
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	            case 132 /* ReadonlyKeyword */:
	            case 115 /* StaticKeyword */:
	                return true;
	        }
	        return false;
	    }
	    ts.isModifierKind = isModifierKind;
	    /* @internal */
	    function isParameterPropertyModifier(kind) {
	        return !!(ts.modifierToFlag(kind) & 92 /* ParameterPropertyModifier */);
	    }
	    ts.isParameterPropertyModifier = isParameterPropertyModifier;
	    /* @internal */
	    function isClassMemberModifier(idToken) {
	        return isParameterPropertyModifier(idToken) || idToken === 115 /* StaticKeyword */;
	    }
	    ts.isClassMemberModifier = isClassMemberModifier;
	    function isModifier(node) {
	        return isModifierKind(node.kind);
	    }
	    ts.isModifier = isModifier;
	    function isEntityName(node) {
	        var kind = node.kind;
	        return kind === 145 /* QualifiedName */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isEntityName = isEntityName;
	    function isPropertyName(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 9 /* StringLiteral */
	            || kind === 8 /* NumericLiteral */
	            || kind === 146 /* ComputedPropertyName */;
	    }
	    ts.isPropertyName = isPropertyName;
	    function isBindingName(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 179 /* ObjectBindingPattern */
	            || kind === 180 /* ArrayBindingPattern */;
	    }
	    ts.isBindingName = isBindingName;
	    // Functions
	    function isFunctionLike(node) {
	        return node && isFunctionLikeKind(node.kind);
	    }
	    ts.isFunctionLike = isFunctionLike;
	    /* @internal */
	    function isFunctionLikeDeclaration(node) {
	        return node && isFunctionLikeDeclarationKind(node.kind);
	    }
	    ts.isFunctionLikeDeclaration = isFunctionLikeDeclaration;
	    function isFunctionLikeDeclarationKind(kind) {
	        switch (kind) {
	            case 233 /* FunctionDeclaration */:
	            case 153 /* MethodDeclaration */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    /* @internal */
	    function isFunctionLikeKind(kind) {
	        switch (kind) {
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 287 /* JSDocSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 162 /* FunctionType */:
	            case 283 /* JSDocFunctionType */:
	            case 163 /* ConstructorType */:
	                return true;
	            default:
	                return isFunctionLikeDeclarationKind(kind);
	        }
	    }
	    ts.isFunctionLikeKind = isFunctionLikeKind;
	    /* @internal */
	    function isFunctionOrModuleBlock(node) {
	        return ts.isSourceFile(node) || ts.isModuleBlock(node) || ts.isBlock(node) && isFunctionLike(node.parent);
	    }
	    ts.isFunctionOrModuleBlock = isFunctionOrModuleBlock;
	    // Classes
	    function isClassElement(node) {
	        var kind = node.kind;
	        return kind === 154 /* Constructor */
	            || kind === 151 /* PropertyDeclaration */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */
	            || kind === 159 /* IndexSignature */
	            || kind === 211 /* SemicolonClassElement */;
	    }
	    ts.isClassElement = isClassElement;
	    function isClassLike(node) {
	        return node && (node.kind === 234 /* ClassDeclaration */ || node.kind === 204 /* ClassExpression */);
	    }
	    ts.isClassLike = isClassLike;
	    function isAccessor(node) {
	        return node && (node.kind === 155 /* GetAccessor */ || node.kind === 156 /* SetAccessor */);
	    }
	    ts.isAccessor = isAccessor;
	    /* @internal */
	    function isMethodOrAccessor(node) {
	        switch (node.kind) {
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isMethodOrAccessor = isMethodOrAccessor;
	    // Type members
	    function isTypeElement(node) {
	        var kind = node.kind;
	        return kind === 158 /* ConstructSignature */
	            || kind === 157 /* CallSignature */
	            || kind === 150 /* PropertySignature */
	            || kind === 152 /* MethodSignature */
	            || kind === 159 /* IndexSignature */;
	    }
	    ts.isTypeElement = isTypeElement;
	    function isClassOrTypeElement(node) {
	        return isTypeElement(node) || isClassElement(node);
	    }
	    ts.isClassOrTypeElement = isClassOrTypeElement;
	    function isObjectLiteralElementLike(node) {
	        var kind = node.kind;
	        return kind === 269 /* PropertyAssignment */
	            || kind === 270 /* ShorthandPropertyAssignment */
	            || kind === 271 /* SpreadAssignment */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 155 /* GetAccessor */
	            || kind === 156 /* SetAccessor */;
	    }
	    ts.isObjectLiteralElementLike = isObjectLiteralElementLike;
	    // Type
	    function isTypeNodeKind(kind) {
	        return (kind >= 160 /* FirstTypeNode */ && kind <= 178 /* LastTypeNode */)
	            || kind === 119 /* AnyKeyword */
	            || kind === 134 /* NumberKeyword */
	            || kind === 135 /* ObjectKeyword */
	            || kind === 122 /* BooleanKeyword */
	            || kind === 137 /* StringKeyword */
	            || kind === 138 /* SymbolKeyword */
	            || kind === 99 /* ThisKeyword */
	            || kind === 105 /* VoidKeyword */
	            || kind === 140 /* UndefinedKeyword */
	            || kind === 95 /* NullKeyword */
	            || kind === 131 /* NeverKeyword */
	            || kind === 206 /* ExpressionWithTypeArguments */
	            || kind === 278 /* JSDocAllType */
	            || kind === 279 /* JSDocUnknownType */
	            || kind === 280 /* JSDocNullableType */
	            || kind === 281 /* JSDocNonNullableType */
	            || kind === 282 /* JSDocOptionalType */
	            || kind === 283 /* JSDocFunctionType */
	            || kind === 284 /* JSDocVariadicType */;
	    }
	    /**
	     * Node test that determines whether a node is a valid type node.
	     * This differs from the `isPartOfTypeNode` function which determines whether a node is *part*
	     * of a TypeNode.
	     */
	    function isTypeNode(node) {
	        return isTypeNodeKind(node.kind);
	    }
	    ts.isTypeNode = isTypeNode;
	    function isFunctionOrConstructorTypeNode(node) {
	        switch (node.kind) {
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return true;
	        }
	        return false;
	    }
	    ts.isFunctionOrConstructorTypeNode = isFunctionOrConstructorTypeNode;
	    // Binding patterns
	    /* @internal */
	    function isBindingPattern(node) {
	        if (node) {
	            var kind = node.kind;
	            return kind === 180 /* ArrayBindingPattern */
	                || kind === 179 /* ObjectBindingPattern */;
	        }
	        return false;
	    }
	    ts.isBindingPattern = isBindingPattern;
	    /* @internal */
	    function isAssignmentPattern(node) {
	        var kind = node.kind;
	        return kind === 182 /* ArrayLiteralExpression */
	            || kind === 183 /* ObjectLiteralExpression */;
	    }
	    ts.isAssignmentPattern = isAssignmentPattern;
	    /* @internal */
	    function isArrayBindingElement(node) {
	        var kind = node.kind;
	        return kind === 181 /* BindingElement */
	            || kind === 205 /* OmittedExpression */;
	    }
	    ts.isArrayBindingElement = isArrayBindingElement;
	    /**
	     * Determines whether the BindingOrAssignmentElement is a BindingElement-like declaration
	     */
	    /* @internal */
	    function isDeclarationBindingElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 231 /* VariableDeclaration */:
	            case 148 /* Parameter */:
	            case 181 /* BindingElement */:
	                return true;
	        }
	        return false;
	    }
	    ts.isDeclarationBindingElement = isDeclarationBindingElement;
	    /**
	     * Determines whether a node is a BindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isBindingOrAssignmentPattern(node) {
	        return isObjectBindingOrAssignmentPattern(node)
	            || isArrayBindingOrAssignmentPattern(node);
	    }
	    ts.isBindingOrAssignmentPattern = isBindingOrAssignmentPattern;
	    /**
	     * Determines whether a node is an ObjectBindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isObjectBindingOrAssignmentPattern(node) {
	        switch (node.kind) {
	            case 179 /* ObjectBindingPattern */:
	            case 183 /* ObjectLiteralExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.isObjectBindingOrAssignmentPattern = isObjectBindingOrAssignmentPattern;
	    /**
	     * Determines whether a node is an ArrayBindingOrAssignmentPattern
	     */
	    /* @internal */
	    function isArrayBindingOrAssignmentPattern(node) {
	        switch (node.kind) {
	            case 180 /* ArrayBindingPattern */:
	            case 182 /* ArrayLiteralExpression */:
	                return true;
	        }
	        return false;
	    }
	    ts.isArrayBindingOrAssignmentPattern = isArrayBindingOrAssignmentPattern;
	    /* @internal */
	    function isPropertyAccessOrQualifiedNameOrImportTypeNode(node) {
	        var kind = node.kind;
	        return kind === 184 /* PropertyAccessExpression */
	            || kind === 145 /* QualifiedName */
	            || kind === 178 /* ImportType */;
	    }
	    ts.isPropertyAccessOrQualifiedNameOrImportTypeNode = isPropertyAccessOrQualifiedNameOrImportTypeNode;
	    // Expression
	    function isPropertyAccessOrQualifiedName(node) {
	        var kind = node.kind;
	        return kind === 184 /* PropertyAccessExpression */
	            || kind === 145 /* QualifiedName */;
	    }
	    ts.isPropertyAccessOrQualifiedName = isPropertyAccessOrQualifiedName;
	    function isCallLikeExpression(node) {
	        switch (node.kind) {
	            case 256 /* JsxOpeningElement */:
	            case 255 /* JsxSelfClosingElement */:
	            case 186 /* CallExpression */:
	            case 187 /* NewExpression */:
	            case 188 /* TaggedTemplateExpression */:
	            case 149 /* Decorator */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isCallLikeExpression = isCallLikeExpression;
	    function isCallOrNewExpression(node) {
	        return node.kind === 186 /* CallExpression */ || node.kind === 187 /* NewExpression */;
	    }
	    ts.isCallOrNewExpression = isCallOrNewExpression;
	    function isTemplateLiteral(node) {
	        var kind = node.kind;
	        return kind === 201 /* TemplateExpression */
	            || kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isTemplateLiteral = isTemplateLiteral;
	    /* @internal */
	    function isLeftHandSideExpression(node) {
	        return isLeftHandSideExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isLeftHandSideExpression = isLeftHandSideExpression;
	    function isLeftHandSideExpressionKind(kind) {
	        switch (kind) {
	            case 184 /* PropertyAccessExpression */:
	            case 185 /* ElementAccessExpression */:
	            case 187 /* NewExpression */:
	            case 186 /* CallExpression */:
	            case 254 /* JsxElement */:
	            case 255 /* JsxSelfClosingElement */:
	            case 258 /* JsxFragment */:
	            case 188 /* TaggedTemplateExpression */:
	            case 182 /* ArrayLiteralExpression */:
	            case 190 /* ParenthesizedExpression */:
	            case 183 /* ObjectLiteralExpression */:
	            case 204 /* ClassExpression */:
	            case 191 /* FunctionExpression */:
	            case 71 /* Identifier */:
	            case 12 /* RegularExpressionLiteral */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 201 /* TemplateExpression */:
	            case 86 /* FalseKeyword */:
	            case 95 /* NullKeyword */:
	            case 99 /* ThisKeyword */:
	            case 101 /* TrueKeyword */:
	            case 97 /* SuperKeyword */:
	            case 208 /* NonNullExpression */:
	            case 209 /* MetaProperty */:
	            case 91 /* ImportKeyword */: // technically this is only an Expression if it's in a CallExpression
	                return true;
	            default:
	                return false;
	        }
	    }
	    /* @internal */
	    function isUnaryExpression(node) {
	        return isUnaryExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isUnaryExpression = isUnaryExpression;
	    function isUnaryExpressionKind(kind) {
	        switch (kind) {
	            case 197 /* PrefixUnaryExpression */:
	            case 198 /* PostfixUnaryExpression */:
	            case 193 /* DeleteExpression */:
	            case 194 /* TypeOfExpression */:
	            case 195 /* VoidExpression */:
	            case 196 /* AwaitExpression */:
	            case 189 /* TypeAssertionExpression */:
	                return true;
	            default:
	                return isLeftHandSideExpressionKind(kind);
	        }
	    }
	    /* @internal */
	    function isUnaryExpressionWithWrite(expr) {
	        switch (expr.kind) {
	            case 198 /* PostfixUnaryExpression */:
	                return true;
	            case 197 /* PrefixUnaryExpression */:
	                return expr.operator === 43 /* PlusPlusToken */ ||
	                    expr.operator === 44 /* MinusMinusToken */;
	            default:
	                return false;
	        }
	    }
	    ts.isUnaryExpressionWithWrite = isUnaryExpressionWithWrite;
	    /* @internal */
	    /**
	     * Determines whether a node is an expression based only on its kind.
	     * Use `isExpressionNode` if not in transforms.
	     */
	    function isExpression(node) {
	        return isExpressionKind(ts.skipPartiallyEmittedExpressions(node).kind);
	    }
	    ts.isExpression = isExpression;
	    function isExpressionKind(kind) {
	        switch (kind) {
	            case 200 /* ConditionalExpression */:
	            case 202 /* YieldExpression */:
	            case 192 /* ArrowFunction */:
	            case 199 /* BinaryExpression */:
	            case 203 /* SpreadElement */:
	            case 207 /* AsExpression */:
	            case 205 /* OmittedExpression */:
	            case 301 /* CommaListExpression */:
	            case 300 /* PartiallyEmittedExpression */:
	                return true;
	            default:
	                return isUnaryExpressionKind(kind);
	        }
	    }
	    function isAssertionExpression(node) {
	        var kind = node.kind;
	        return kind === 189 /* TypeAssertionExpression */
	            || kind === 207 /* AsExpression */;
	    }
	    ts.isAssertionExpression = isAssertionExpression;
	    /* @internal */
	    function isPartiallyEmittedExpression(node) {
	        return node.kind === 300 /* PartiallyEmittedExpression */;
	    }
	    ts.isPartiallyEmittedExpression = isPartiallyEmittedExpression;
	    /* @internal */
	    function isNotEmittedStatement(node) {
	        return node.kind === 299 /* NotEmittedStatement */;
	    }
	    ts.isNotEmittedStatement = isNotEmittedStatement;
	    /* @internal */
	    function isNotEmittedOrPartiallyEmittedNode(node) {
	        return isNotEmittedStatement(node)
	            || isPartiallyEmittedExpression(node);
	    }
	    ts.isNotEmittedOrPartiallyEmittedNode = isNotEmittedOrPartiallyEmittedNode;
	    function isIterationStatement(node, lookInLabeledStatements) {
	        switch (node.kind) {
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	            case 217 /* DoStatement */:
	            case 218 /* WhileStatement */:
	                return true;
	            case 227 /* LabeledStatement */:
	                return lookInLabeledStatements && isIterationStatement(node.statement, lookInLabeledStatements);
	        }
	        return false;
	    }
	    ts.isIterationStatement = isIterationStatement;
	    /* @internal */
	    function isForInOrOfStatement(node) {
	        return node.kind === 220 /* ForInStatement */ || node.kind === 221 /* ForOfStatement */;
	    }
	    ts.isForInOrOfStatement = isForInOrOfStatement;
	    // Element
	    /* @internal */
	    function isConciseBody(node) {
	        return ts.isBlock(node)
	            || isExpression(node);
	    }
	    ts.isConciseBody = isConciseBody;
	    /* @internal */
	    function isFunctionBody(node) {
	        return ts.isBlock(node);
	    }
	    ts.isFunctionBody = isFunctionBody;
	    /* @internal */
	    function isForInitializer(node) {
	        return ts.isVariableDeclarationList(node)
	            || isExpression(node);
	    }
	    ts.isForInitializer = isForInitializer;
	    /* @internal */
	    function isModuleBody(node) {
	        var kind = node.kind;
	        return kind === 239 /* ModuleBlock */
	            || kind === 238 /* ModuleDeclaration */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isModuleBody = isModuleBody;
	    /* @internal */
	    function isNamespaceBody(node) {
	        var kind = node.kind;
	        return kind === 239 /* ModuleBlock */
	            || kind === 238 /* ModuleDeclaration */;
	    }
	    ts.isNamespaceBody = isNamespaceBody;
	    /* @internal */
	    function isJSDocNamespaceBody(node) {
	        var kind = node.kind;
	        return kind === 71 /* Identifier */
	            || kind === 238 /* ModuleDeclaration */;
	    }
	    ts.isJSDocNamespaceBody = isJSDocNamespaceBody;
	    /* @internal */
	    function isNamedImportBindings(node) {
	        var kind = node.kind;
	        return kind === 246 /* NamedImports */
	            || kind === 245 /* NamespaceImport */;
	    }
	    ts.isNamedImportBindings = isNamedImportBindings;
	    /* @internal */
	    function isModuleOrEnumDeclaration(node) {
	        return node.kind === 238 /* ModuleDeclaration */ || node.kind === 237 /* EnumDeclaration */;
	    }
	    ts.isModuleOrEnumDeclaration = isModuleOrEnumDeclaration;
	    function isDeclarationKind(kind) {
	        return kind === 192 /* ArrowFunction */
	            || kind === 181 /* BindingElement */
	            || kind === 234 /* ClassDeclaration */
	            || kind === 204 /* ClassExpression */
	            || kind === 154 /* Constructor */
	            || kind === 237 /* EnumDeclaration */
	            || kind === 272 /* EnumMember */
	            || kind === 251 /* ExportSpecifier */
	            || kind === 233 /* FunctionDeclaration */
	            || kind === 191 /* FunctionExpression */
	            || kind === 155 /* GetAccessor */
	            || kind === 244 /* ImportClause */
	            || kind === 242 /* ImportEqualsDeclaration */
	            || kind === 247 /* ImportSpecifier */
	            || kind === 235 /* InterfaceDeclaration */
	            || kind === 261 /* JsxAttribute */
	            || kind === 153 /* MethodDeclaration */
	            || kind === 152 /* MethodSignature */
	            || kind === 238 /* ModuleDeclaration */
	            || kind === 241 /* NamespaceExportDeclaration */
	            || kind === 245 /* NamespaceImport */
	            || kind === 148 /* Parameter */
	            || kind === 269 /* PropertyAssignment */
	            || kind === 151 /* PropertyDeclaration */
	            || kind === 150 /* PropertySignature */
	            || kind === 156 /* SetAccessor */
	            || kind === 270 /* ShorthandPropertyAssignment */
	            || kind === 236 /* TypeAliasDeclaration */
	            || kind === 147 /* TypeParameter */
	            || kind === 231 /* VariableDeclaration */
	            || kind === 296 /* JSDocTypedefTag */
	            || kind === 291 /* JSDocCallbackTag */
	            || kind === 297 /* JSDocPropertyTag */;
	    }
	    function isDeclarationStatementKind(kind) {
	        return kind === 233 /* FunctionDeclaration */
	            || kind === 252 /* MissingDeclaration */
	            || kind === 234 /* ClassDeclaration */
	            || kind === 235 /* InterfaceDeclaration */
	            || kind === 236 /* TypeAliasDeclaration */
	            || kind === 237 /* EnumDeclaration */
	            || kind === 238 /* ModuleDeclaration */
	            || kind === 243 /* ImportDeclaration */
	            || kind === 242 /* ImportEqualsDeclaration */
	            || kind === 249 /* ExportDeclaration */
	            || kind === 248 /* ExportAssignment */
	            || kind === 241 /* NamespaceExportDeclaration */;
	    }
	    function isStatementKindButNotDeclarationKind(kind) {
	        return kind === 223 /* BreakStatement */
	            || kind === 222 /* ContinueStatement */
	            || kind === 230 /* DebuggerStatement */
	            || kind === 217 /* DoStatement */
	            || kind === 215 /* ExpressionStatement */
	            || kind === 214 /* EmptyStatement */
	            || kind === 220 /* ForInStatement */
	            || kind === 221 /* ForOfStatement */
	            || kind === 219 /* ForStatement */
	            || kind === 216 /* IfStatement */
	            || kind === 227 /* LabeledStatement */
	            || kind === 224 /* ReturnStatement */
	            || kind === 226 /* SwitchStatement */
	            || kind === 228 /* ThrowStatement */
	            || kind === 229 /* TryStatement */
	            || kind === 213 /* VariableStatement */
	            || kind === 218 /* WhileStatement */
	            || kind === 225 /* WithStatement */
	            || kind === 299 /* NotEmittedStatement */
	            || kind === 303 /* EndOfDeclarationMarker */
	            || kind === 302 /* MergeDeclarationMarker */;
	    }
	    /* @internal */
	    function isDeclaration(node) {
	        if (node.kind === 147 /* TypeParameter */) {
	            return node.parent.kind !== 295 /* JSDocTemplateTag */ || ts.isInJavaScriptFile(node);
	        }
	        return isDeclarationKind(node.kind);
	    }
	    ts.isDeclaration = isDeclaration;
	    /* @internal */
	    function isDeclarationStatement(node) {
	        return isDeclarationStatementKind(node.kind);
	    }
	    ts.isDeclarationStatement = isDeclarationStatement;
	    /**
	     * Determines whether the node is a statement that is not also a declaration
	     */
	    /* @internal */
	    function isStatementButNotDeclaration(node) {
	        return isStatementKindButNotDeclarationKind(node.kind);
	    }
	    ts.isStatementButNotDeclaration = isStatementButNotDeclaration;
	    /* @internal */
	    function isStatement(node) {
	        var kind = node.kind;
	        return isStatementKindButNotDeclarationKind(kind)
	            || isDeclarationStatementKind(kind)
	            || isBlockStatement(node);
	    }
	    ts.isStatement = isStatement;
	    function isBlockStatement(node) {
	        if (node.kind !== 212 /* Block */)
	            return false;
	        if (node.parent !== undefined) {
	            if (node.parent.kind === 229 /* TryStatement */ || node.parent.kind === 268 /* CatchClause */) {
	                return false;
	            }
	        }
	        return !ts.isFunctionBlock(node);
	    }
	    // Module references
	    /* @internal */
	    function isModuleReference(node) {
	        var kind = node.kind;
	        return kind === 253 /* ExternalModuleReference */
	            || kind === 145 /* QualifiedName */
	            || kind === 71 /* Identifier */;
	    }
	    ts.isModuleReference = isModuleReference;
	    // JSX
	    /* @internal */
	    function isJsxTagNameExpression(node) {
	        var kind = node.kind;
	        return kind === 99 /* ThisKeyword */
	            || kind === 71 /* Identifier */
	            || kind === 184 /* PropertyAccessExpression */;
	    }
	    ts.isJsxTagNameExpression = isJsxTagNameExpression;
	    /* @internal */
	    function isJsxChild(node) {
	        var kind = node.kind;
	        return kind === 254 /* JsxElement */
	            || kind === 264 /* JsxExpression */
	            || kind === 255 /* JsxSelfClosingElement */
	            || kind === 10 /* JsxText */
	            || kind === 258 /* JsxFragment */;
	    }
	    ts.isJsxChild = isJsxChild;
	    /* @internal */
	    function isJsxAttributeLike(node) {
	        var kind = node.kind;
	        return kind === 261 /* JsxAttribute */
	            || kind === 263 /* JsxSpreadAttribute */;
	    }
	    ts.isJsxAttributeLike = isJsxAttributeLike;
	    /* @internal */
	    function isStringLiteralOrJsxExpression(node) {
	        var kind = node.kind;
	        return kind === 9 /* StringLiteral */
	            || kind === 264 /* JsxExpression */;
	    }
	    ts.isStringLiteralOrJsxExpression = isStringLiteralOrJsxExpression;
	    function isJsxOpeningLikeElement(node) {
	        var kind = node.kind;
	        return kind === 256 /* JsxOpeningElement */
	            || kind === 255 /* JsxSelfClosingElement */;
	    }
	    ts.isJsxOpeningLikeElement = isJsxOpeningLikeElement;
	    // Clauses
	    function isCaseOrDefaultClause(node) {
	        var kind = node.kind;
	        return kind === 265 /* CaseClause */
	            || kind === 266 /* DefaultClause */;
	    }
	    ts.isCaseOrDefaultClause = isCaseOrDefaultClause;
	    // JSDoc
	    /** True if node is of some JSDoc syntax kind. */
	    /* @internal */
	    function isJSDocNode(node) {
	        return node.kind >= 277 /* FirstJSDocNode */ && node.kind <= 297 /* LastJSDocNode */;
	    }
	    ts.isJSDocNode = isJSDocNode;
	    /** True if node is of a kind that may contain comment text. */
	    function isJSDocCommentContainingNode(node) {
	        return node.kind === 285 /* JSDocComment */ || isJSDocTag(node) || ts.isJSDocTypeLiteral(node) || ts.isJSDocSignature(node);
	    }
	    ts.isJSDocCommentContainingNode = isJSDocCommentContainingNode;
	    // TODO: determine what this does before making it public.
	    /* @internal */
	    function isJSDocTag(node) {
	        return node.kind >= 288 /* FirstJSDocTagNode */ && node.kind <= 297 /* LastJSDocTagNode */;
	    }
	    ts.isJSDocTag = isJSDocTag;
	    function isSetAccessor(node) {
	        return node.kind === 156 /* SetAccessor */;
	    }
	    ts.isSetAccessor = isSetAccessor;
	    function isGetAccessor(node) {
	        return node.kind === 155 /* GetAccessor */;
	    }
	    ts.isGetAccessor = isGetAccessor;
	    /** True if has jsdoc nodes attached to it. */
	    /* @internal */
	    function hasJSDocNodes(node) {
	        return !!node.jsDoc && node.jsDoc.length > 0;
	    }
	    ts.hasJSDocNodes = hasJSDocNodes;
	    /** True if has type node attached to it. */
	    /* @internal */
	    function hasType(node) {
	        return !!node.type;
	    }
	    ts.hasType = hasType;
	    /* True if the node could have a type node a `.type` */
	    /* @internal */
	    function couldHaveType(node) {
	        switch (node.kind) {
	            case 148 /* Parameter */:
	            case 150 /* PropertySignature */:
	            case 151 /* PropertyDeclaration */:
	            case 152 /* MethodSignature */:
	            case 153 /* MethodDeclaration */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 160 /* TypePredicate */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 172 /* ParenthesizedType */:
	            case 174 /* TypeOperator */:
	            case 176 /* MappedType */:
	            case 189 /* TypeAssertionExpression */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	            case 207 /* AsExpression */:
	            case 231 /* VariableDeclaration */:
	            case 233 /* FunctionDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 277 /* JSDocTypeExpression */:
	            case 280 /* JSDocNullableType */:
	            case 281 /* JSDocNonNullableType */:
	            case 282 /* JSDocOptionalType */:
	            case 283 /* JSDocFunctionType */:
	            case 284 /* JSDocVariadicType */:
	                return true;
	        }
	        return false;
	    }
	    ts.couldHaveType = couldHaveType;
	    /** True if has initializer node attached to it. */
	    /* @internal */
	    function hasInitializer(node) {
	        return !!node.initializer;
	    }
	    ts.hasInitializer = hasInitializer;
	    /** True if has initializer node attached to it. */
	    /* @internal */
	    function hasOnlyExpressionInitializer(node) {
	        return hasInitializer(node) && !ts.isForStatement(node) && !ts.isForInStatement(node) && !ts.isForOfStatement(node) && !ts.isJsxAttribute(node);
	    }
	    ts.hasOnlyExpressionInitializer = hasOnlyExpressionInitializer;
	    function isObjectLiteralElement(node) {
	        switch (node.kind) {
	            case 261 /* JsxAttribute */:
	            case 263 /* JsxSpreadAttribute */:
	            case 269 /* PropertyAssignment */:
	            case 270 /* ShorthandPropertyAssignment */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    ts.isObjectLiteralElement = isObjectLiteralElement;
	    /* @internal */
	    function isTypeReferenceType(node) {
	        return node.kind === 161 /* TypeReference */ || node.kind === 206 /* ExpressionWithTypeArguments */;
	    }
	    ts.isTypeReferenceType = isTypeReferenceType;
	    var MAX_SMI_X86 = 1073741823;
	    /* @internal */
	    function guessIndentation(lines) {
	        var indentation = MAX_SMI_X86;
	        for (var _i = 0, lines_1 = lines; _i < lines_1.length; _i++) {
	            var line = lines_1[_i];
	            if (!line.length) {
	                continue;
	            }
	            var i = 0;
	            for (; i < line.length && i < indentation; i++) {
	                if (!ts.isWhiteSpaceLike(line.charCodeAt(i))) {
	                    break;
	                }
	            }
	            if (i < indentation) {
	                indentation = i;
	            }
	            if (indentation === 0) {
	                return 0;
	            }
	        }
	        return indentation === MAX_SMI_X86 ? undefined : indentation;
	    }
	    ts.guessIndentation = guessIndentation;
	    function isStringLiteralLike(node) {
	        return node.kind === 9 /* StringLiteral */ || node.kind === 13 /* NoSubstitutionTemplateLiteral */;
	    }
	    ts.isStringLiteralLike = isStringLiteralLike;
	    /** @internal */
	    function isNamedImportsOrExports(node) {
	        return node.kind === 246 /* NamedImports */ || node.kind === 250 /* NamedExports */;
	    }
	    ts.isNamedImportsOrExports = isNamedImportsOrExports;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var SignatureFlags;
	    (function (SignatureFlags) {
	        SignatureFlags[SignatureFlags["None"] = 0] = "None";
	        SignatureFlags[SignatureFlags["Yield"] = 1] = "Yield";
	        SignatureFlags[SignatureFlags["Await"] = 2] = "Await";
	        SignatureFlags[SignatureFlags["Type"] = 4] = "Type";
	        SignatureFlags[SignatureFlags["IgnoreMissingOpenBrace"] = 16] = "IgnoreMissingOpenBrace";
	        SignatureFlags[SignatureFlags["JSDoc"] = 32] = "JSDoc";
	    })(SignatureFlags || (SignatureFlags = {}));
	    // tslint:disable variable-name
	    var NodeConstructor;
	    var TokenConstructor;
	    var IdentifierConstructor;
	    var SourceFileConstructor;
	    // tslint:enable variable-name
	    function createNode(kind, pos, end) {
	        if (kind === 273 /* SourceFile */) {
	            return new (SourceFileConstructor || (SourceFileConstructor = ts.objectAllocator.getSourceFileConstructor()))(kind, pos, end);
	        }
	        else if (kind === 71 /* Identifier */) {
	            return new (IdentifierConstructor || (IdentifierConstructor = ts.objectAllocator.getIdentifierConstructor()))(kind, pos, end);
	        }
	        else if (!ts.isNodeKind(kind)) {
	            return new (TokenConstructor || (TokenConstructor = ts.objectAllocator.getTokenConstructor()))(kind, pos, end);
	        }
	        else {
	            return new (NodeConstructor || (NodeConstructor = ts.objectAllocator.getNodeConstructor()))(kind, pos, end);
	        }
	    }
	    ts.createNode = createNode;
	    function visitNode(cbNode, node) {
	        return node && cbNode(node);
	    }
	    function visitNodes(cbNode, cbNodes, nodes) {
	        if (nodes) {
	            if (cbNodes) {
	                return cbNodes(nodes);
	            }
	            for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
	                var node = nodes_1[_i];
	                var result = cbNode(node);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	    }
	    /*@internal*/
	    function isJSDocLikeText(text, start) {
	        return text.charCodeAt(start + 1) === 42 /* asterisk */ &&
	            text.charCodeAt(start + 2) === 42 /* asterisk */ &&
	            text.charCodeAt(start + 3) !== 47 /* slash */;
	    }
	    ts.isJSDocLikeText = isJSDocLikeText;
	    /**
	     * Invokes a callback for each child of the given node. The 'cbNode' callback is invoked for all child nodes
	     * stored in properties. If a 'cbNodes' callback is specified, it is invoked for embedded arrays; otherwise,
	     * embedded arrays are flattened and the 'cbNode' callback is invoked for each element. If a callback returns
	     * a truthy value, iteration stops and that value is returned. Otherwise, undefined is returned.
	     *
	     * @param node a given node to visit its children
	     * @param cbNode a callback to be invoked for all child nodes
	     * @param cbNodes a callback to be invoked for embedded array
	     *
	     * @remarks `forEachChild` must visit the children of a node in the order
	     * that they appear in the source code. The language service depends on this property to locate nodes by position.
	     */
	    function forEachChild(node, cbNode, cbNodes) {
	        if (!node || node.kind <= 144 /* LastToken */) {
	            return;
	        }
	        switch (node.kind) {
	            case 145 /* QualifiedName */:
	                return visitNode(cbNode, node.left) ||
	                    visitNode(cbNode, node.right);
	            case 147 /* TypeParameter */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.constraint) ||
	                    visitNode(cbNode, node.default) ||
	                    visitNode(cbNode, node.expression);
	            case 270 /* ShorthandPropertyAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.equalsToken) ||
	                    visitNode(cbNode, node.objectAssignmentInitializer);
	            case 271 /* SpreadAssignment */:
	                return visitNode(cbNode, node.expression);
	            case 148 /* Parameter */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 151 /* PropertyDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.exclamationToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 150 /* PropertySignature */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 269 /* PropertyAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.initializer);
	            case 231 /* VariableDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.exclamationToken) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.initializer);
	            case 181 /* BindingElement */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.propertyName) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type);
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 191 /* FunctionExpression */:
	            case 233 /* FunctionDeclaration */:
	            case 192 /* ArrowFunction */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.asteriskToken) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.equalsGreaterThanToken) ||
	                    visitNode(cbNode, node.body);
	            case 161 /* TypeReference */:
	                return visitNode(cbNode, node.typeName) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments);
	            case 160 /* TypePredicate */:
	                return visitNode(cbNode, node.parameterName) ||
	                    visitNode(cbNode, node.type);
	            case 164 /* TypeQuery */:
	                return visitNode(cbNode, node.exprName);
	            case 165 /* TypeLiteral */:
	                return visitNodes(cbNode, cbNodes, node.members);
	            case 166 /* ArrayType */:
	                return visitNode(cbNode, node.elementType);
	            case 167 /* TupleType */:
	                return visitNodes(cbNode, cbNodes, node.elementTypes);
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	                return visitNodes(cbNode, cbNodes, node.types);
	            case 170 /* ConditionalType */:
	                return visitNode(cbNode, node.checkType) ||
	                    visitNode(cbNode, node.extendsType) ||
	                    visitNode(cbNode, node.trueType) ||
	                    visitNode(cbNode, node.falseType);
	            case 171 /* InferType */:
	                return visitNode(cbNode, node.typeParameter);
	            case 178 /* ImportType */:
	                return visitNode(cbNode, node.argument) ||
	                    visitNode(cbNode, node.qualifier) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments);
	            case 172 /* ParenthesizedType */:
	            case 174 /* TypeOperator */:
	                return visitNode(cbNode, node.type);
	            case 175 /* IndexedAccessType */:
	                return visitNode(cbNode, node.objectType) ||
	                    visitNode(cbNode, node.indexType);
	            case 176 /* MappedType */:
	                return visitNode(cbNode, node.readonlyToken) ||
	                    visitNode(cbNode, node.typeParameter) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.type);
	            case 177 /* LiteralType */:
	                return visitNode(cbNode, node.literal);
	            case 179 /* ObjectBindingPattern */:
	            case 180 /* ArrayBindingPattern */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 182 /* ArrayLiteralExpression */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 183 /* ObjectLiteralExpression */:
	                return visitNodes(cbNode, cbNodes, node.properties);
	            case 184 /* PropertyAccessExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.name);
	            case 185 /* ElementAccessExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.argumentExpression);
	            case 186 /* CallExpression */:
	            case 187 /* NewExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments) ||
	                    visitNodes(cbNode, cbNodes, node.arguments);
	            case 188 /* TaggedTemplateExpression */:
	                return visitNode(cbNode, node.tag) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments) ||
	                    visitNode(cbNode, node.template);
	            case 189 /* TypeAssertionExpression */:
	                return visitNode(cbNode, node.type) ||
	                    visitNode(cbNode, node.expression);
	            case 190 /* ParenthesizedExpression */:
	                return visitNode(cbNode, node.expression);
	            case 193 /* DeleteExpression */:
	                return visitNode(cbNode, node.expression);
	            case 194 /* TypeOfExpression */:
	                return visitNode(cbNode, node.expression);
	            case 195 /* VoidExpression */:
	                return visitNode(cbNode, node.expression);
	            case 197 /* PrefixUnaryExpression */:
	                return visitNode(cbNode, node.operand);
	            case 202 /* YieldExpression */:
	                return visitNode(cbNode, node.asteriskToken) ||
	                    visitNode(cbNode, node.expression);
	            case 196 /* AwaitExpression */:
	                return visitNode(cbNode, node.expression);
	            case 198 /* PostfixUnaryExpression */:
	                return visitNode(cbNode, node.operand);
	            case 199 /* BinaryExpression */:
	                return visitNode(cbNode, node.left) ||
	                    visitNode(cbNode, node.operatorToken) ||
	                    visitNode(cbNode, node.right);
	            case 207 /* AsExpression */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.type);
	            case 208 /* NonNullExpression */:
	                return visitNode(cbNode, node.expression);
	            case 209 /* MetaProperty */:
	                return visitNode(cbNode, node.name);
	            case 200 /* ConditionalExpression */:
	                return visitNode(cbNode, node.condition) ||
	                    visitNode(cbNode, node.questionToken) ||
	                    visitNode(cbNode, node.whenTrue) ||
	                    visitNode(cbNode, node.colonToken) ||
	                    visitNode(cbNode, node.whenFalse);
	            case 203 /* SpreadElement */:
	                return visitNode(cbNode, node.expression);
	            case 212 /* Block */:
	            case 239 /* ModuleBlock */:
	                return visitNodes(cbNode, cbNodes, node.statements);
	            case 273 /* SourceFile */:
	                return visitNodes(cbNode, cbNodes, node.statements) ||
	                    visitNode(cbNode, node.endOfFileToken);
	            case 213 /* VariableStatement */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.declarationList);
	            case 232 /* VariableDeclarationList */:
	                return visitNodes(cbNode, cbNodes, node.declarations);
	            case 215 /* ExpressionStatement */:
	                return visitNode(cbNode, node.expression);
	            case 216 /* IfStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.thenStatement) ||
	                    visitNode(cbNode, node.elseStatement);
	            case 217 /* DoStatement */:
	                return visitNode(cbNode, node.statement) ||
	                    visitNode(cbNode, node.expression);
	            case 218 /* WhileStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 219 /* ForStatement */:
	                return visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.condition) ||
	                    visitNode(cbNode, node.incrementor) ||
	                    visitNode(cbNode, node.statement);
	            case 220 /* ForInStatement */:
	                return visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 221 /* ForOfStatement */:
	                return visitNode(cbNode, node.awaitModifier) ||
	                    visitNode(cbNode, node.initializer) ||
	                    visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 222 /* ContinueStatement */:
	            case 223 /* BreakStatement */:
	                return visitNode(cbNode, node.label);
	            case 224 /* ReturnStatement */:
	                return visitNode(cbNode, node.expression);
	            case 225 /* WithStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.statement);
	            case 226 /* SwitchStatement */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNode(cbNode, node.caseBlock);
	            case 240 /* CaseBlock */:
	                return visitNodes(cbNode, cbNodes, node.clauses);
	            case 265 /* CaseClause */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.statements);
	            case 266 /* DefaultClause */:
	                return visitNodes(cbNode, cbNodes, node.statements);
	            case 227 /* LabeledStatement */:
	                return visitNode(cbNode, node.label) ||
	                    visitNode(cbNode, node.statement);
	            case 228 /* ThrowStatement */:
	                return visitNode(cbNode, node.expression);
	            case 229 /* TryStatement */:
	                return visitNode(cbNode, node.tryBlock) ||
	                    visitNode(cbNode, node.catchClause) ||
	                    visitNode(cbNode, node.finallyBlock);
	            case 268 /* CatchClause */:
	                return visitNode(cbNode, node.variableDeclaration) ||
	                    visitNode(cbNode, node.block);
	            case 149 /* Decorator */:
	                return visitNode(cbNode, node.expression);
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.heritageClauses) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 235 /* InterfaceDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.heritageClauses) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 236 /* TypeAliasDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNode(cbNode, node.type);
	            case 237 /* EnumDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNodes(cbNode, cbNodes, node.members);
	            case 272 /* EnumMember */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 238 /* ModuleDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.body);
	            case 242 /* ImportEqualsDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.moduleReference);
	            case 243 /* ImportDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.importClause) ||
	                    visitNode(cbNode, node.moduleSpecifier);
	            case 244 /* ImportClause */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.namedBindings);
	            case 241 /* NamespaceExportDeclaration */:
	                return visitNode(cbNode, node.name);
	            case 245 /* NamespaceImport */:
	                return visitNode(cbNode, node.name);
	            case 246 /* NamedImports */:
	            case 250 /* NamedExports */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 249 /* ExportDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.exportClause) ||
	                    visitNode(cbNode, node.moduleSpecifier);
	            case 247 /* ImportSpecifier */:
	            case 251 /* ExportSpecifier */:
	                return visitNode(cbNode, node.propertyName) ||
	                    visitNode(cbNode, node.name);
	            case 248 /* ExportAssignment */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNode(cbNode, node.expression);
	            case 201 /* TemplateExpression */:
	                return visitNode(cbNode, node.head) || visitNodes(cbNode, cbNodes, node.templateSpans);
	            case 210 /* TemplateSpan */:
	                return visitNode(cbNode, node.expression) || visitNode(cbNode, node.literal);
	            case 146 /* ComputedPropertyName */:
	                return visitNode(cbNode, node.expression);
	            case 267 /* HeritageClause */:
	                return visitNodes(cbNode, cbNodes, node.types);
	            case 206 /* ExpressionWithTypeArguments */:
	                return visitNode(cbNode, node.expression) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments);
	            case 253 /* ExternalModuleReference */:
	                return visitNode(cbNode, node.expression);
	            case 252 /* MissingDeclaration */:
	                return visitNodes(cbNode, cbNodes, node.decorators);
	            case 301 /* CommaListExpression */:
	                return visitNodes(cbNode, cbNodes, node.elements);
	            case 254 /* JsxElement */:
	                return visitNode(cbNode, node.openingElement) ||
	                    visitNodes(cbNode, cbNodes, node.children) ||
	                    visitNode(cbNode, node.closingElement);
	            case 258 /* JsxFragment */:
	                return visitNode(cbNode, node.openingFragment) ||
	                    visitNodes(cbNode, cbNodes, node.children) ||
	                    visitNode(cbNode, node.closingFragment);
	            case 255 /* JsxSelfClosingElement */:
	            case 256 /* JsxOpeningElement */:
	                return visitNode(cbNode, node.tagName) ||
	                    visitNodes(cbNode, cbNodes, node.typeArguments) ||
	                    visitNode(cbNode, node.attributes);
	            case 262 /* JsxAttributes */:
	                return visitNodes(cbNode, cbNodes, node.properties);
	            case 261 /* JsxAttribute */:
	                return visitNode(cbNode, node.name) ||
	                    visitNode(cbNode, node.initializer);
	            case 263 /* JsxSpreadAttribute */:
	                return visitNode(cbNode, node.expression);
	            case 264 /* JsxExpression */:
	                return visitNode(cbNode, node.dotDotDotToken) ||
	                    visitNode(cbNode, node.expression);
	            case 257 /* JsxClosingElement */:
	                return visitNode(cbNode, node.tagName);
	            case 277 /* JSDocTypeExpression */:
	                return visitNode(cbNode, node.type);
	            case 281 /* JSDocNonNullableType */:
	                return visitNode(cbNode, node.type);
	            case 280 /* JSDocNullableType */:
	                return visitNode(cbNode, node.type);
	            case 282 /* JSDocOptionalType */:
	                return visitNode(cbNode, node.type);
	            case 283 /* JSDocFunctionType */:
	                return visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type);
	            case 284 /* JSDocVariadicType */:
	                return visitNode(cbNode, node.type);
	            case 285 /* JSDocComment */:
	                return visitNodes(cbNode, cbNodes, node.tags);
	            case 292 /* JSDocParameterTag */:
	            case 297 /* JSDocPropertyTag */:
	                if (node.isNameFirst) {
	                    return visitNode(cbNode, node.name) ||
	                        visitNode(cbNode, node.typeExpression);
	                }
	                else {
	                    return visitNode(cbNode, node.typeExpression) ||
	                        visitNode(cbNode, node.name);
	                }
	            case 293 /* JSDocReturnTag */:
	                return visitNode(cbNode, node.typeExpression);
	            case 294 /* JSDocTypeTag */:
	                return visitNode(cbNode, node.typeExpression);
	            case 289 /* JSDocAugmentsTag */:
	                return visitNode(cbNode, node.class);
	            case 295 /* JSDocTemplateTag */:
	                return visitNodes(cbNode, cbNodes, node.typeParameters);
	            case 296 /* JSDocTypedefTag */:
	                if (node.typeExpression &&
	                    node.typeExpression.kind === 277 /* JSDocTypeExpression */) {
	                    return visitNode(cbNode, node.typeExpression) ||
	                        visitNode(cbNode, node.fullName);
	                }
	                else {
	                    return visitNode(cbNode, node.fullName) ||
	                        visitNode(cbNode, node.typeExpression);
	                }
	            case 291 /* JSDocCallbackTag */:
	                return visitNode(cbNode, node.fullName) ||
	                    visitNode(cbNode, node.typeExpression);
	            case 287 /* JSDocSignature */:
	                return visitNodes(cbNode, cbNodes, node.decorators) ||
	                    visitNodes(cbNode, cbNodes, node.modifiers) ||
	                    visitNodes(cbNode, cbNodes, node.typeParameters) ||
	                    visitNodes(cbNode, cbNodes, node.parameters) ||
	                    visitNode(cbNode, node.type);
	            case 286 /* JSDocTypeLiteral */:
	                if (node.jsDocPropertyTags) {
	                    for (var _i = 0, _a = node.jsDocPropertyTags; _i < _a.length; _i++) {
	                        var tag = _a[_i];
	                        visitNode(cbNode, tag);
	                    }
	                }
	                return;
	            case 300 /* PartiallyEmittedExpression */:
	                return visitNode(cbNode, node.expression);
	        }
	    }
	    ts.forEachChild = forEachChild;
	    function createSourceFile(fileName, sourceText, languageVersion, setParentNodes, scriptKind) {
	        if (setParentNodes === void 0) { setParentNodes = false; }
	        ts.performance.mark("beforeParse");
	        var result;
	        if (languageVersion === 100 /* JSON */) {
	            result = Parser.parseJsonText(fileName, sourceText, languageVersion, /*syntaxCursor*/ undefined, setParentNodes);
	        }
	        else {
	            result = Parser.parseSourceFile(fileName, sourceText, languageVersion, /*syntaxCursor*/ undefined, setParentNodes, scriptKind);
	        }
	        ts.performance.mark("afterParse");
	        ts.performance.measure("Parse", "beforeParse", "afterParse");
	        return result;
	    }
	    ts.createSourceFile = createSourceFile;
	    function parseIsolatedEntityName(text, languageVersion) {
	        return Parser.parseIsolatedEntityName(text, languageVersion);
	    }
	    ts.parseIsolatedEntityName = parseIsolatedEntityName;
	    /**
	     * Parse json text into SyntaxTree and return node and parse errors if any
	     * @param fileName
	     * @param sourceText
	     */
	    function parseJsonText(fileName, sourceText) {
	        return Parser.parseJsonText(fileName, sourceText);
	    }
	    ts.parseJsonText = parseJsonText;
	    // See also `isExternalOrCommonJsModule` in utilities.ts
	    function isExternalModule(file) {
	        return file.externalModuleIndicator !== undefined;
	    }
	    ts.isExternalModule = isExternalModule;
	    // Produces a new SourceFile for the 'newText' provided. The 'textChangeRange' parameter
	    // indicates what changed between the 'text' that this SourceFile has and the 'newText'.
	    // The SourceFile will be created with the compiler attempting to reuse as many nodes from
	    // this file as possible.
	    //
	    // Note: this function mutates nodes from this SourceFile. That means any existing nodes
	    // from this SourceFile that are being held onto may change as a result (including
	    // becoming detached from any SourceFile).  It is recommended that this SourceFile not
	    // be used once 'update' is called on it.
	    function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks) {
	        var newSourceFile = IncrementalParser.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
	        // Because new source file node is created, it may not have the flag PossiblyContainDynamicImport. This is the case if there is no new edit to add dynamic import.
	        // We will manually port the flag to the new source file.
	        newSourceFile.flags |= (sourceFile.flags & 1572864 /* PermanentlySetIncrementalFlags */);
	        return newSourceFile;
	    }
	    ts.updateSourceFile = updateSourceFile;
	    /* @internal */
	    function parseIsolatedJSDocComment(content, start, length) {
	        var result = Parser.JSDocParser.parseIsolatedJSDocComment(content, start, length);
	        if (result && result.jsDoc) {
	            // because the jsDocComment was parsed out of the source file, it might
	            // not be covered by the fixupParentReferences.
	            Parser.fixupParentReferences(result.jsDoc);
	        }
	        return result;
	    }
	    ts.parseIsolatedJSDocComment = parseIsolatedJSDocComment;
	    /* @internal */
	    // Exposed only for testing.
	    function parseJSDocTypeExpressionForTests(content, start, length) {
	        return Parser.JSDocParser.parseJSDocTypeExpressionForTests(content, start, length);
	    }
	    ts.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests;
	    // Implement the parser as a singleton module.  We do this for perf reasons because creating
	    // parser instances can actually be expensive enough to impact us on projects with many source
	    // files.
	    var Parser;
	    (function (Parser) {
	        // Share a single scanner across all calls to parse a source file.  This helps speed things
	        // up by avoiding the cost of creating/compiling scanners over and over again.
	        var scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ true);
	        var disallowInAndDecoratorContext = 2048 /* DisallowInContext */ | 8192 /* DecoratorContext */;
	        // capture constructors in 'initializeState' to avoid null checks
	        // tslint:disable variable-name
	        var NodeConstructor;
	        var TokenConstructor;
	        var IdentifierConstructor;
	        var SourceFileConstructor;
	        // tslint:enable variable-name
	        var sourceFile;
	        var parseDiagnostics;
	        var syntaxCursor;
	        var currentToken;
	        var sourceText;
	        var nodeCount;
	        var identifiers;
	        var identifierCount;
	        var parsingContext;
	        // Flags that dictate what parsing context we're in.  For example:
	        // Whether or not we are in strict parsing mode.  All that changes in strict parsing mode is
	        // that some tokens that would be considered identifiers may be considered keywords.
	        //
	        // When adding more parser context flags, consider which is the more common case that the
	        // flag will be in.  This should be the 'false' state for that flag.  The reason for this is
	        // that we don't store data in our nodes unless the value is in the *non-default* state.  So,
	        // for example, more often than code 'allows-in' (or doesn't 'disallow-in').  We opt for
	        // 'disallow-in' set to 'false'.  Otherwise, if we had 'allowsIn' set to 'true', then almost
	        // all nodes would need extra state on them to store this info.
	        //
	        // Note: 'allowIn' and 'allowYield' track 1:1 with the [in] and [yield] concepts in the ES6
	        // grammar specification.
	        //
	        // An important thing about these context concepts.  By default they are effectively inherited
	        // while parsing through every grammar production.  i.e. if you don't change them, then when
	        // you parse a sub-production, it will have the same context values as the parent production.
	        // This is great most of the time.  After all, consider all the 'expression' grammar productions
	        // and how nearly all of them pass along the 'in' and 'yield' context values:
	        //
	        // EqualityExpression[In, Yield] :
	        //      RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] == RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] != RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] === RelationalExpression[?In, ?Yield]
	        //      EqualityExpression[?In, ?Yield] !== RelationalExpression[?In, ?Yield]
	        //
	        // Where you have to be careful is then understanding what the points are in the grammar
	        // where the values are *not* passed along.  For example:
	        //
	        // SingleNameBinding[Yield,GeneratorParameter]
	        //      [+GeneratorParameter]BindingIdentifier[Yield] Initializer[In]opt
	        //      [~GeneratorParameter]BindingIdentifier[?Yield]Initializer[In, ?Yield]opt
	        //
	        // Here this is saying that if the GeneratorParameter context flag is set, that we should
	        // explicitly set the 'yield' context flag to false before calling into the BindingIdentifier
	        // and we should explicitly unset the 'yield' context flag before calling into the Initializer.
	        // production.  Conversely, if the GeneratorParameter context flag is not set, then we
	        // should leave the 'yield' context flag alone.
	        //
	        // Getting this all correct is tricky and requires careful reading of the grammar to
	        // understand when these values should be changed versus when they should be inherited.
	        //
	        // Note: it should not be necessary to save/restore these flags during speculative/lookahead
	        // parsing.  These context flags are naturally stored and restored through normal recursive
	        // descent parsing and unwinding.
	        var contextFlags;
	        // Whether or not we've had a parse error since creating the last AST node.  If we have
	        // encountered an error, it will be stored on the next AST node we create.  Parse errors
	        // can be broken down into three categories:
	        //
	        // 1) An error that occurred during scanning.  For example, an unterminated literal, or a
	        //    character that was completely not understood.
	        //
	        // 2) A token was expected, but was not present.  This type of error is commonly produced
	        //    by the 'parseExpected' function.
	        //
	        // 3) A token was present that no parsing function was able to consume.  This type of error
	        //    only occurs in the 'abortParsingListOrMoveToNextToken' function when the parser
	        //    decides to skip the token.
	        //
	        // In all of these cases, we want to mark the next node as having had an error before it.
	        // With this mark, we can know in incremental settings if this node can be reused, or if
	        // we have to reparse it.  If we don't keep this information around, we may just reuse the
	        // node.  in that event we would then not produce the same errors as we did before, causing
	        // significant confusion problems.
	        //
	        // Note: it is necessary that this value be saved/restored during speculative/lookahead
	        // parsing.  During lookahead parsing, we will often create a node.  That node will have
	        // this value attached, and then this value will be set back to 'false'.  If we decide to
	        // rewind, we must get back to the same value we had prior to the lookahead.
	        //
	        // Note: any errors at the end of the file that do not precede a regular node, should get
	        // attached to the EOF token.
	        var parseErrorBeforeNextFinishedNode = false;
	        function parseSourceFile(fileName, sourceText, languageVersion, syntaxCursor, setParentNodes, scriptKind) {
	            scriptKind = ts.ensureScriptKind(fileName, scriptKind);
	            if (scriptKind === 6 /* JSON */) {
	                var result_1 = parseJsonText(fileName, sourceText, languageVersion, syntaxCursor, setParentNodes);
	                ts.convertToObjectWorker(result_1, result_1.parseDiagnostics, /*returnValue*/ false, /*knownRootOptions*/ undefined, /*jsonConversionNotifier*/ undefined);
	                result_1.typeReferenceDirectives = ts.emptyArray;
	                result_1.amdDependencies = ts.emptyArray;
	                return result_1;
	            }
	            initializeState(sourceText, languageVersion, syntaxCursor, scriptKind);
	            var result = parseSourceFileWorker(fileName, languageVersion, setParentNodes, scriptKind);
	            clearState();
	            return result;
	        }
	        Parser.parseSourceFile = parseSourceFile;
	        function parseIsolatedEntityName(content, languageVersion) {
	            // Choice of `isDeclarationFile` should be arbitrary
	            initializeState(content, languageVersion, /*syntaxCursor*/ undefined, 1 /* JS */);
	            // Prime the scanner.
	            nextToken();
	            var entityName = parseEntityName(/*allowReservedWords*/ true);
	            var isInvalid = token() === 1 /* EndOfFileToken */ && !parseDiagnostics.length;
	            clearState();
	            return isInvalid ? entityName : undefined;
	        }
	        Parser.parseIsolatedEntityName = parseIsolatedEntityName;
	        function parseJsonText(fileName, sourceText, languageVersion, syntaxCursor, setParentNodes) {
	            if (languageVersion === void 0) { languageVersion = 2 /* ES2015 */; }
	            initializeState(sourceText, languageVersion, syntaxCursor, 6 /* JSON */);
	            // Set source file so that errors will be reported with this file name
	            sourceFile = createSourceFile(fileName, 2 /* ES2015 */, 6 /* JSON */, /*isDeclaration*/ false);
	            sourceFile.flags = contextFlags;
	            // Prime the scanner.
	            nextToken();
	            var pos = getNodePos();
	            if (token() === 1 /* EndOfFileToken */) {
	                sourceFile.statements = createNodeArray([], pos, pos);
	                sourceFile.endOfFileToken = parseTokenNode();
	            }
	            else {
	                var statement = createNode(215 /* ExpressionStatement */);
	                switch (token()) {
	                    case 21 /* OpenBracketToken */:
	                        statement.expression = parseArrayLiteralExpression();
	                        break;
	                    case 101 /* TrueKeyword */:
	                    case 86 /* FalseKeyword */:
	                    case 95 /* NullKeyword */:
	                        statement.expression = parseTokenNode();
	                        break;
	                    case 38 /* MinusToken */:
	                        if (lookAhead(function () { return nextToken() === 8 /* NumericLiteral */ && nextToken() !== 56 /* ColonToken */; })) {
	                            statement.expression = parsePrefixUnaryExpression();
	                        }
	                        else {
	                            statement.expression = parseObjectLiteralExpression();
	                        }
	                        break;
	                    case 8 /* NumericLiteral */:
	                    case 9 /* StringLiteral */:
	                        if (lookAhead(function () { return nextToken() !== 56 /* ColonToken */; })) {
	                            statement.expression = parseLiteralNode();
	                            break;
	                        }
	                    // falls through
	                    default:
	                        statement.expression = parseObjectLiteralExpression();
	                        break;
	                }
	                finishNode(statement);
	                sourceFile.statements = createNodeArray([statement], pos);
	                sourceFile.endOfFileToken = parseExpectedToken(1 /* EndOfFileToken */, ts.Diagnostics.Unexpected_token);
	            }
	            if (setParentNodes) {
	                fixupParentReferences(sourceFile);
	            }
	            sourceFile.parseDiagnostics = parseDiagnostics;
	            var result = sourceFile;
	            clearState();
	            return result;
	        }
	        Parser.parseJsonText = parseJsonText;
	        function getLanguageVariant(scriptKind) {
	            // .tsx and .jsx files are treated as jsx language variant.
	            return scriptKind === 4 /* TSX */ || scriptKind === 2 /* JSX */ || scriptKind === 1 /* JS */ || scriptKind === 6 /* JSON */ ? 1 /* JSX */ : 0 /* Standard */;
	        }
	        function initializeState(_sourceText, languageVersion, _syntaxCursor, scriptKind) {
	            NodeConstructor = ts.objectAllocator.getNodeConstructor();
	            TokenConstructor = ts.objectAllocator.getTokenConstructor();
	            IdentifierConstructor = ts.objectAllocator.getIdentifierConstructor();
	            SourceFileConstructor = ts.objectAllocator.getSourceFileConstructor();
	            sourceText = _sourceText;
	            syntaxCursor = _syntaxCursor;
	            parseDiagnostics = [];
	            parsingContext = 0;
	            identifiers = ts.createMap();
	            identifierCount = 0;
	            nodeCount = 0;
	            switch (scriptKind) {
	                case 1 /* JS */:
	                case 2 /* JSX */:
	                    contextFlags = 65536 /* JavaScriptFile */;
	                    break;
	                case 6 /* JSON */:
	                    contextFlags = 65536 /* JavaScriptFile */ | 16777216 /* JsonFile */;
	                    break;
	                default:
	                    contextFlags = 0 /* None */;
	                    break;
	            }
	            parseErrorBeforeNextFinishedNode = false;
	            // Initialize and prime the scanner before parsing the source elements.
	            scanner.setText(sourceText);
	            scanner.setOnError(scanError);
	            scanner.setScriptTarget(languageVersion);
	            scanner.setLanguageVariant(getLanguageVariant(scriptKind));
	        }
	        function clearState() {
	            // Clear out the text the scanner is pointing at, so it doesn't keep anything alive unnecessarily.
	            scanner.setText("");
	            scanner.setOnError(undefined);
	            // Clear any data.  We don't want to accidentally hold onto it for too long.
	            parseDiagnostics = undefined;
	            sourceFile = undefined;
	            identifiers = undefined;
	            syntaxCursor = undefined;
	            sourceText = undefined;
	        }
	        function parseSourceFileWorker(fileName, languageVersion, setParentNodes, scriptKind) {
	            var isDeclarationFile = isDeclarationFileName(fileName);
	            if (isDeclarationFile) {
	                contextFlags |= 4194304 /* Ambient */;
	            }
	            sourceFile = createSourceFile(fileName, languageVersion, scriptKind, isDeclarationFile);
	            sourceFile.flags = contextFlags;
	            // Prime the scanner.
	            nextToken();
	            // A member of ReadonlyArray<T> isn't assignable to a member of T[] (and prevents a direct cast) - but this is where we set up those members so they can be readonly in the future
	            processCommentPragmas(sourceFile, sourceText);
	            processPragmasIntoFields(sourceFile, reportPragmaDiagnostic);
	            sourceFile.statements = parseList(0 /* SourceElements */, parseStatement);
	            ts.Debug.assert(token() === 1 /* EndOfFileToken */);
	            sourceFile.endOfFileToken = addJSDocComment(parseTokenNode());
	            setExternalModuleIndicator(sourceFile);
	            sourceFile.nodeCount = nodeCount;
	            sourceFile.identifierCount = identifierCount;
	            sourceFile.identifiers = identifiers;
	            sourceFile.parseDiagnostics = parseDiagnostics;
	            if (setParentNodes) {
	                fixupParentReferences(sourceFile);
	            }
	            return sourceFile;
	            function reportPragmaDiagnostic(pos, end, diagnostic) {
	                parseDiagnostics.push(ts.createFileDiagnostic(sourceFile, pos, end, diagnostic));
	            }
	        }
	        function addJSDocComment(node) {
	            var comments = ts.getJSDocCommentRanges(node, sourceFile.text);
	            if (comments) {
	                for (var _i = 0, comments_2 = comments; _i < comments_2.length; _i++) {
	                    var comment = comments_2[_i];
	                    node.jsDoc = ts.append(node.jsDoc, JSDocParser.parseJSDocComment(node, comment.pos, comment.end - comment.pos));
	                }
	            }
	            return node;
	        }
	        function fixupParentReferences(rootNode) {
	            // normally parent references are set during binding. However, for clients that only need
	            // a syntax tree, and no semantic features, then the binding process is an unnecessary
	            // overhead.  This functions allows us to set all the parents, without all the expense of
	            // binding.
	            var parent = rootNode;
	            forEachChild(rootNode, visitNode);
	            return;
	            function visitNode(n) {
	                // walk down setting parents that differ from the parent we think it should be.  This
	                // allows us to quickly bail out of setting parents for subtrees during incremental
	                // parsing
	                if (n.parent !== parent) {
	                    n.parent = parent;
	                    var saveParent = parent;
	                    parent = n;
	                    forEachChild(n, visitNode);
	                    if (ts.hasJSDocNodes(n)) {
	                        for (var _i = 0, _a = n.jsDoc; _i < _a.length; _i++) {
	                            var jsDoc = _a[_i];
	                            jsDoc.parent = n;
	                            parent = jsDoc;
	                            forEachChild(jsDoc, visitNode);
	                        }
	                    }
	                    parent = saveParent;
	                }
	            }
	        }
	        Parser.fixupParentReferences = fixupParentReferences;
	        function createSourceFile(fileName, languageVersion, scriptKind, isDeclarationFile) {
	            // code from createNode is inlined here so createNode won't have to deal with special case of creating source files
	            // this is quite rare comparing to other nodes and createNode should be as fast as possible
	            var sourceFile = new SourceFileConstructor(273 /* SourceFile */, /*pos*/ 0, /* end */ sourceText.length);
	            nodeCount++;
	            sourceFile.text = sourceText;
	            sourceFile.bindDiagnostics = [];
	            sourceFile.bindSuggestionDiagnostics = undefined;
	            sourceFile.languageVersion = languageVersion;
	            sourceFile.fileName = ts.normalizePath(fileName);
	            sourceFile.languageVariant = getLanguageVariant(scriptKind);
	            sourceFile.isDeclarationFile = isDeclarationFile;
	            sourceFile.scriptKind = scriptKind;
	            return sourceFile;
	        }
	        function setContextFlag(val, flag) {
	            if (val) {
	                contextFlags |= flag;
	            }
	            else {
	                contextFlags &= ~flag;
	            }
	        }
	        function setDisallowInContext(val) {
	            setContextFlag(val, 2048 /* DisallowInContext */);
	        }
	        function setYieldContext(val) {
	            setContextFlag(val, 4096 /* YieldContext */);
	        }
	        function setDecoratorContext(val) {
	            setContextFlag(val, 8192 /* DecoratorContext */);
	        }
	        function setAwaitContext(val) {
	            setContextFlag(val, 16384 /* AwaitContext */);
	        }
	        function doOutsideOfContext(context, func) {
	            // contextFlagsToClear will contain only the context flags that are
	            // currently set that we need to temporarily clear
	            // We don't just blindly reset to the previous flags to ensure
	            // that we do not mutate cached flags for the incremental
	            // parser (ThisNodeHasError, ThisNodeOrAnySubNodesHasError, and
	            // HasAggregatedChildData).
	            var contextFlagsToClear = context & contextFlags;
	            if (contextFlagsToClear) {
	                // clear the requested context flags
	                setContextFlag(/*val*/ false, contextFlagsToClear);
	                var result = func();
	                // restore the context flags we just cleared
	                setContextFlag(/*val*/ true, contextFlagsToClear);
	                return result;
	            }
	            // no need to do anything special as we are not in any of the requested contexts
	            return func();
	        }
	        function doInsideOfContext(context, func) {
	            // contextFlagsToSet will contain only the context flags that
	            // are not currently set that we need to temporarily enable.
	            // We don't just blindly reset to the previous flags to ensure
	            // that we do not mutate cached flags for the incremental
	            // parser (ThisNodeHasError, ThisNodeOrAnySubNodesHasError, and
	            // HasAggregatedChildData).
	            var contextFlagsToSet = context & ~contextFlags;
	            if (contextFlagsToSet) {
	                // set the requested context flags
	                setContextFlag(/*val*/ true, contextFlagsToSet);
	                var result = func();
	                // reset the context flags we just set
	                setContextFlag(/*val*/ false, contextFlagsToSet);
	                return result;
	            }
	            // no need to do anything special as we are already in all of the requested contexts
	            return func();
	        }
	        function allowInAnd(func) {
	            return doOutsideOfContext(2048 /* DisallowInContext */, func);
	        }
	        function disallowInAnd(func) {
	            return doInsideOfContext(2048 /* DisallowInContext */, func);
	        }
	        function doInYieldContext(func) {
	            return doInsideOfContext(4096 /* YieldContext */, func);
	        }
	        function doInDecoratorContext(func) {
	            return doInsideOfContext(8192 /* DecoratorContext */, func);
	        }
	        function doInAwaitContext(func) {
	            return doInsideOfContext(16384 /* AwaitContext */, func);
	        }
	        function doOutsideOfAwaitContext(func) {
	            return doOutsideOfContext(16384 /* AwaitContext */, func);
	        }
	        function doInYieldAndAwaitContext(func) {
	            return doInsideOfContext(4096 /* YieldContext */ | 16384 /* AwaitContext */, func);
	        }
	        function inContext(flags) {
	            return (contextFlags & flags) !== 0;
	        }
	        function inYieldContext() {
	            return inContext(4096 /* YieldContext */);
	        }
	        function inDisallowInContext() {
	            return inContext(2048 /* DisallowInContext */);
	        }
	        function inDecoratorContext() {
	            return inContext(8192 /* DecoratorContext */);
	        }
	        function inAwaitContext() {
	            return inContext(16384 /* AwaitContext */);
	        }
	        function parseErrorAtCurrentToken(message, arg0) {
	            parseErrorAt(scanner.getTokenPos(), scanner.getTextPos(), message, arg0);
	        }
	        function parseErrorAtPosition(start, length, message, arg0) {
	            // Don't report another error if it would just be at the same position as the last error.
	            var lastError = ts.lastOrUndefined(parseDiagnostics);
	            if (!lastError || start !== lastError.start) {
	                parseDiagnostics.push(ts.createFileDiagnostic(sourceFile, start, length, message, arg0));
	            }
	            // Mark that we've encountered an error.  We'll set an appropriate bit on the next
	            // node we finish so that it can't be reused incrementally.
	            parseErrorBeforeNextFinishedNode = true;
	        }
	        function parseErrorAt(start, end, message, arg0) {
	            parseErrorAtPosition(start, end - start, message, arg0);
	        }
	        function parseErrorAtRange(range, message, arg0) {
	            parseErrorAt(range.pos, range.end, message, arg0);
	        }
	        function scanError(message, length) {
	            parseErrorAtPosition(scanner.getTextPos(), length, message);
	        }
	        function getNodePos() {
	            return scanner.getStartPos();
	        }
	        // Use this function to access the current token instead of reading the currentToken
	        // variable. Since function results aren't narrowed in control flow analysis, this ensures
	        // that the type checker doesn't make wrong assumptions about the type of the current
	        // token (e.g. a call to nextToken() changes the current token but the checker doesn't
	        // reason about this side effect).  Mainstream VMs inline simple functions like this, so
	        // there is no performance penalty.
	        function token() {
	            return currentToken;
	        }
	        function nextToken() {
	            return currentToken = scanner.scan();
	        }
	        function reScanGreaterToken() {
	            return currentToken = scanner.reScanGreaterToken();
	        }
	        function reScanSlashToken() {
	            return currentToken = scanner.reScanSlashToken();
	        }
	        function reScanTemplateToken() {
	            return currentToken = scanner.reScanTemplateToken();
	        }
	        function scanJsxIdentifier() {
	            return currentToken = scanner.scanJsxIdentifier();
	        }
	        function scanJsxText() {
	            return currentToken = scanner.scanJsxToken();
	        }
	        function scanJsxAttributeValue() {
	            return currentToken = scanner.scanJsxAttributeValue();
	        }
	        function speculationHelper(callback, isLookAhead) {
	            // Keep track of the state we'll need to rollback to if lookahead fails (or if the
	            // caller asked us to always reset our state).
	            var saveToken = currentToken;
	            var saveParseDiagnosticsLength = parseDiagnostics.length;
	            var saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
	            // Note: it is not actually necessary to save/restore the context flags here.  That's
	            // because the saving/restoring of these flags happens naturally through the recursive
	            // descent nature of our parser.  However, we still store this here just so we can
	            // assert that invariant holds.
	            var saveContextFlags = contextFlags;
	            // If we're only looking ahead, then tell the scanner to only lookahead as well.
	            // Otherwise, if we're actually speculatively parsing, then tell the scanner to do the
	            // same.
	            var result = isLookAhead
	                ? scanner.lookAhead(callback)
	                : scanner.tryScan(callback);
	            ts.Debug.assert(saveContextFlags === contextFlags);
	            // If our callback returned something 'falsy' or we're just looking ahead,
	            // then unconditionally restore us to where we were.
	            if (!result || isLookAhead) {
	                currentToken = saveToken;
	                parseDiagnostics.length = saveParseDiagnosticsLength;
	                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
	            }
	            return result;
	        }
	        /** Invokes the provided callback then unconditionally restores the parser to the state it
	         * was in immediately prior to invoking the callback.  The result of invoking the callback
	         * is returned from this function.
	         */
	        function lookAhead(callback) {
	            return speculationHelper(callback, /*isLookAhead*/ true);
	        }
	        /** Invokes the provided callback.  If the callback returns something falsy, then it restores
	         * the parser to the state it was in immediately prior to invoking the callback.  If the
	         * callback returns something truthy, then the parser state is not rolled back.  The result
	         * of invoking the callback is returned from this function.
	         */
	        function tryParse(callback) {
	            return speculationHelper(callback, /*isLookAhead*/ false);
	        }
	        // Ignore strict mode flag because we will report an error in type checker instead.
	        function isIdentifier() {
	            if (token() === 71 /* Identifier */) {
	                return true;
	            }
	            // If we have a 'yield' keyword, and we're in the [yield] context, then 'yield' is
	            // considered a keyword and is not an identifier.
	            if (token() === 116 /* YieldKeyword */ && inYieldContext()) {
	                return false;
	            }
	            // If we have a 'await' keyword, and we're in the [Await] context, then 'await' is
	            // considered a keyword and is not an identifier.
	            if (token() === 121 /* AwaitKeyword */ && inAwaitContext()) {
	                return false;
	            }
	            return token() > 107 /* LastReservedWord */;
	        }
	        function parseExpected(kind, diagnosticMessage, shouldAdvance) {
	            if (shouldAdvance === void 0) { shouldAdvance = true; }
	            if (token() === kind) {
	                if (shouldAdvance) {
	                    nextToken();
	                }
	                return true;
	            }
	            // Report specific message if provided with one.  Otherwise, report generic fallback message.
	            if (diagnosticMessage) {
	                parseErrorAtCurrentToken(diagnosticMessage);
	            }
	            else {
	                parseErrorAtCurrentToken(ts.Diagnostics._0_expected, ts.tokenToString(kind));
	            }
	            return false;
	        }
	        function parseOptional(t) {
	            if (token() === t) {
	                nextToken();
	                return true;
	            }
	            return false;
	        }
	        function parseOptionalToken(t) {
	            if (token() === t) {
	                return parseTokenNode();
	            }
	            return undefined;
	        }
	        function parseExpectedToken(t, diagnosticMessage, arg0) {
	            return parseOptionalToken(t) ||
	                createMissingNode(t, /*reportAtCurrentPosition*/ false, diagnosticMessage || ts.Diagnostics._0_expected, arg0 || ts.tokenToString(t));
	        }
	        function parseTokenNode() {
	            var node = createNode(token());
	            nextToken();
	            return finishNode(node);
	        }
	        function canParseSemicolon() {
	            // If there's a real semicolon, then we can always parse it out.
	            if (token() === 25 /* SemicolonToken */) {
	                return true;
	            }
	            // We can parse out an optional semicolon in ASI cases in the following cases.
	            return token() === 18 /* CloseBraceToken */ || token() === 1 /* EndOfFileToken */ || scanner.hasPrecedingLineBreak();
	        }
	        function parseSemicolon() {
	            if (canParseSemicolon()) {
	                if (token() === 25 /* SemicolonToken */) {
	                    // consume the semicolon if it was explicitly provided.
	                    nextToken();
	                }
	                return true;
	            }
	            else {
	                return parseExpected(25 /* SemicolonToken */);
	            }
	        }
	        function createNode(kind, pos) {
	            nodeCount++;
	            var p = pos >= 0 ? pos : scanner.getStartPos();
	            return ts.isNodeKind(kind) || kind === 0 /* Unknown */ ? new NodeConstructor(kind, p, p) :
	                kind === 71 /* Identifier */ ? new IdentifierConstructor(kind, p, p) :
	                    new TokenConstructor(kind, p, p);
	        }
	        function createNodeWithJSDoc(kind, pos) {
	            var node = createNode(kind, pos);
	            if (scanner.getTokenFlags() & 2 /* PrecedingJSDocComment */) {
	                addJSDocComment(node);
	            }
	            return node;
	        }
	        function createNodeArray(elements, pos, end) {
	            // Since the element list of a node array is typically created by starting with an empty array and
	            // repeatedly calling push(), the list may not have the optimal memory layout. We invoke slice() for
	            // small arrays (1 to 4 elements) to give the VM a chance to allocate an optimal representation.
	            var length = elements.length;
	            var array = (length >= 1 && length <= 4 ? elements.slice() : elements);
	            array.pos = pos;
	            array.end = end === undefined ? scanner.getStartPos() : end;
	            return array;
	        }
	        function finishNode(node, end) {
	            node.end = end === undefined ? scanner.getStartPos() : end;
	            if (contextFlags) {
	                node.flags |= contextFlags;
	            }
	            // Keep track on the node if we encountered an error while parsing it.  If we did, then
	            // we cannot reuse the node incrementally.  Once we've marked this node, clear out the
	            // flag so that we don't mark any subsequent nodes.
	            if (parseErrorBeforeNextFinishedNode) {
	                parseErrorBeforeNextFinishedNode = false;
	                node.flags |= 32768 /* ThisNodeHasError */;
	            }
	            return node;
	        }
	        function createMissingNode(kind, reportAtCurrentPosition, diagnosticMessage, arg0) {
	            if (reportAtCurrentPosition) {
	                parseErrorAtPosition(scanner.getStartPos(), 0, diagnosticMessage, arg0);
	            }
	            else if (diagnosticMessage) {
	                parseErrorAtCurrentToken(diagnosticMessage, arg0);
	            }
	            var result = createNode(kind);
	            if (kind === 71 /* Identifier */) {
	                result.escapedText = "";
	            }
	            else if (ts.isLiteralKind(kind) || ts.isTemplateLiteralKind(kind)) {
	                result.text = "";
	            }
	            return finishNode(result);
	        }
	        function internIdentifier(text) {
	            var identifier = identifiers.get(text);
	            if (identifier === undefined) {
	                identifiers.set(text, identifier = text);
	            }
	            return identifier;
	        }
	        // An identifier that starts with two underscores has an extra underscore character prepended to it to avoid issues
	        // with magic property names like '__proto__'. The 'identifiers' object is used to share a single string instance for
	        // each identifier in order to reduce memory consumption.
	        function createIdentifier(isIdentifier, diagnosticMessage) {
	            identifierCount++;
	            if (isIdentifier) {
	                var node = createNode(71 /* Identifier */);
	                // Store original token kind if it is not just an Identifier so we can report appropriate error later in type checker
	                if (token() !== 71 /* Identifier */) {
	                    node.originalKeywordKind = token();
	                }
	                node.escapedText = ts.escapeLeadingUnderscores(internIdentifier(scanner.getTokenValue()));
	                nextToken();
	                return finishNode(node);
	            }
	            // Only for end of file because the error gets reported incorrectly on embedded script tags.
	            var reportAtCurrentPosition = token() === 1 /* EndOfFileToken */;
	            return createMissingNode(71 /* Identifier */, reportAtCurrentPosition, diagnosticMessage || ts.Diagnostics.Identifier_expected);
	        }
	        function parseIdentifier(diagnosticMessage) {
	            return createIdentifier(isIdentifier(), diagnosticMessage);
	        }
	        function parseIdentifierName(diagnosticMessage) {
	            return createIdentifier(ts.tokenIsIdentifierOrKeyword(token()), diagnosticMessage);
	        }
	        function isLiteralPropertyName() {
	            return ts.tokenIsIdentifierOrKeyword(token()) ||
	                token() === 9 /* StringLiteral */ ||
	                token() === 8 /* NumericLiteral */;
	        }
	        function parsePropertyNameWorker(allowComputedPropertyNames) {
	            if (token() === 9 /* StringLiteral */ || token() === 8 /* NumericLiteral */) {
	                var node = parseLiteralNode();
	                node.text = internIdentifier(node.text);
	                return node;
	            }
	            if (allowComputedPropertyNames && token() === 21 /* OpenBracketToken */) {
	                return parseComputedPropertyName();
	            }
	            return parseIdentifierName();
	        }
	        function parsePropertyName() {
	            return parsePropertyNameWorker(/*allowComputedPropertyNames*/ true);
	        }
	        function parseComputedPropertyName() {
	            // PropertyName [Yield]:
	            //      LiteralPropertyName
	            //      ComputedPropertyName[?Yield]
	            var node = createNode(146 /* ComputedPropertyName */);
	            parseExpected(21 /* OpenBracketToken */);
	            // We parse any expression (including a comma expression). But the grammar
	            // says that only an assignment expression is allowed, so the grammar checker
	            // will error if it sees a comma expression.
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseContextualModifier(t) {
	            return token() === t && tryParse(nextTokenCanFollowModifier);
	        }
	        function nextTokenIsOnSameLineAndCanFollowModifier() {
	            nextToken();
	            if (scanner.hasPrecedingLineBreak()) {
	                return false;
	            }
	            return canFollowModifier();
	        }
	        function nextTokenCanFollowModifier() {
	            switch (token()) {
	                case 76 /* ConstKeyword */:
	                    // 'const' is only a modifier if followed by 'enum'.
	                    return nextToken() === 83 /* EnumKeyword */;
	                case 84 /* ExportKeyword */:
	                    nextToken();
	                    if (token() === 79 /* DefaultKeyword */) {
	                        return lookAhead(nextTokenCanFollowDefaultKeyword);
	                    }
	                    return token() !== 39 /* AsteriskToken */ && token() !== 118 /* AsKeyword */ && token() !== 17 /* OpenBraceToken */ && canFollowModifier();
	                case 79 /* DefaultKeyword */:
	                    return nextTokenCanFollowDefaultKeyword();
	                case 115 /* StaticKeyword */:
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                    nextToken();
	                    return canFollowModifier();
	                default:
	                    return nextTokenIsOnSameLineAndCanFollowModifier();
	            }
	        }
	        function parseAnyContextualModifier() {
	            return ts.isModifierKind(token()) && tryParse(nextTokenCanFollowModifier);
	        }
	        function canFollowModifier() {
	            return token() === 21 /* OpenBracketToken */
	                || token() === 17 /* OpenBraceToken */
	                || token() === 39 /* AsteriskToken */
	                || token() === 24 /* DotDotDotToken */
	                || isLiteralPropertyName();
	        }
	        function nextTokenCanFollowDefaultKeyword() {
	            nextToken();
	            return token() === 75 /* ClassKeyword */ || token() === 89 /* FunctionKeyword */ ||
	                token() === 109 /* InterfaceKeyword */ ||
	                (token() === 117 /* AbstractKeyword */ && lookAhead(nextTokenIsClassKeywordOnSameLine)) ||
	                (token() === 120 /* AsyncKeyword */ && lookAhead(nextTokenIsFunctionKeywordOnSameLine));
	        }
	        // True if positioned at the start of a list element
	        function isListElement(parsingContext, inErrorRecovery) {
	            var node = currentNode(parsingContext);
	            if (node) {
	                return true;
	            }
	            switch (parsingContext) {
	                case 0 /* SourceElements */:
	                case 1 /* BlockStatements */:
	                case 3 /* SwitchClauseStatements */:
	                    // If we're in error recovery, then we don't want to treat ';' as an empty statement.
	                    // The problem is that ';' can show up in far too many contexts, and if we see one
	                    // and assume it's a statement, then we may bail out inappropriately from whatever
	                    // we're parsing.  For example, if we have a semicolon in the middle of a class, then
	                    // we really don't want to assume the class is over and we're on a statement in the
	                    // outer module.  We just want to consume and move on.
	                    return !(token() === 25 /* SemicolonToken */ && inErrorRecovery) && isStartOfStatement();
	                case 2 /* SwitchClauses */:
	                    return token() === 73 /* CaseKeyword */ || token() === 79 /* DefaultKeyword */;
	                case 4 /* TypeMembers */:
	                    return lookAhead(isTypeMemberStart);
	                case 5 /* ClassMembers */:
	                    // We allow semicolons as class elements (as specified by ES6) as long as we're
	                    // not in error recovery.  If we're in error recovery, we don't want an errant
	                    // semicolon to be treated as a class member (since they're almost always used
	                    // for statements.
	                    return lookAhead(isClassMemberStart) || (token() === 25 /* SemicolonToken */ && !inErrorRecovery);
	                case 6 /* EnumMembers */:
	                    // Include open bracket computed properties. This technically also lets in indexers,
	                    // which would be a candidate for improved error reporting.
	                    return token() === 21 /* OpenBracketToken */ || isLiteralPropertyName();
	                case 12 /* ObjectLiteralMembers */:
	                    return token() === 21 /* OpenBracketToken */ || token() === 39 /* AsteriskToken */ || token() === 24 /* DotDotDotToken */ || isLiteralPropertyName();
	                case 17 /* RestProperties */:
	                    return isLiteralPropertyName();
	                case 9 /* ObjectBindingElements */:
	                    return token() === 21 /* OpenBracketToken */ || token() === 24 /* DotDotDotToken */ || isLiteralPropertyName();
	                case 7 /* HeritageClauseElement */:
	                    // If we see `{ ... }` then only consume it as an expression if it is followed by `,` or `{`
	                    // That way we won't consume the body of a class in its heritage clause.
	                    if (token() === 17 /* OpenBraceToken */) {
	                        return lookAhead(isValidHeritageClauseObjectLiteral);
	                    }
	                    if (!inErrorRecovery) {
	                        return isStartOfLeftHandSideExpression() && !isHeritageClauseExtendsOrImplementsKeyword();
	                    }
	                    else {
	                        // If we're in error recovery we tighten up what we're willing to match.
	                        // That way we don't treat something like "this" as a valid heritage clause
	                        // element during recovery.
	                        return isIdentifier() && !isHeritageClauseExtendsOrImplementsKeyword();
	                    }
	                case 8 /* VariableDeclarations */:
	                    return isIdentifierOrPattern();
	                case 10 /* ArrayBindingElements */:
	                    return token() === 26 /* CommaToken */ || token() === 24 /* DotDotDotToken */ || isIdentifierOrPattern();
	                case 18 /* TypeParameters */:
	                    return isIdentifier();
	                case 15 /* ArrayLiteralMembers */:
	                    if (token() === 26 /* CommaToken */) {
	                        return true;
	                    }
	                // falls through
	                case 11 /* ArgumentExpressions */:
	                    return token() === 24 /* DotDotDotToken */ || isStartOfExpression();
	                case 16 /* Parameters */:
	                    return isStartOfParameter();
	                case 19 /* TypeArguments */:
	                case 20 /* TupleElementTypes */:
	                    return token() === 26 /* CommaToken */ || isStartOfType();
	                case 21 /* HeritageClauses */:
	                    return isHeritageClause();
	                case 22 /* ImportOrExportSpecifiers */:
	                    return ts.tokenIsIdentifierOrKeyword(token());
	                case 13 /* JsxAttributes */:
	                    return ts.tokenIsIdentifierOrKeyword(token()) || token() === 17 /* OpenBraceToken */;
	                case 14 /* JsxChildren */:
	                    return true;
	            }
	            ts.Debug.fail("Non-exhaustive case in 'isListElement'.");
	        }
	        function isValidHeritageClauseObjectLiteral() {
	            ts.Debug.assert(token() === 17 /* OpenBraceToken */);
	            if (nextToken() === 18 /* CloseBraceToken */) {
	                // if we see "extends {}" then only treat the {} as what we're extending (and not
	                // the class body) if we have:
	                //
	                //      extends {} {
	                //      extends {},
	                //      extends {} extends
	                //      extends {} implements
	                var next = nextToken();
	                return next === 26 /* CommaToken */ || next === 17 /* OpenBraceToken */ || next === 85 /* ExtendsKeyword */ || next === 108 /* ImplementsKeyword */;
	            }
	            return true;
	        }
	        function nextTokenIsIdentifier() {
	            nextToken();
	            return isIdentifier();
	        }
	        function nextTokenIsIdentifierOrKeyword() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeyword(token());
	        }
	        function nextTokenIsIdentifierOrKeywordOrGreaterThan() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeywordOrGreaterThan(token());
	        }
	        function isHeritageClauseExtendsOrImplementsKeyword() {
	            if (token() === 108 /* ImplementsKeyword */ ||
	                token() === 85 /* ExtendsKeyword */) {
	                return lookAhead(nextTokenIsStartOfExpression);
	            }
	            return false;
	        }
	        function nextTokenIsStartOfExpression() {
	            nextToken();
	            return isStartOfExpression();
	        }
	        function nextTokenIsStartOfType() {
	            nextToken();
	            return isStartOfType();
	        }
	        // True if positioned at a list terminator
	        function isListTerminator(kind) {
	            if (token() === 1 /* EndOfFileToken */) {
	                // Being at the end of the file ends all lists.
	                return true;
	            }
	            switch (kind) {
	                case 1 /* BlockStatements */:
	                case 2 /* SwitchClauses */:
	                case 4 /* TypeMembers */:
	                case 5 /* ClassMembers */:
	                case 6 /* EnumMembers */:
	                case 12 /* ObjectLiteralMembers */:
	                case 9 /* ObjectBindingElements */:
	                case 22 /* ImportOrExportSpecifiers */:
	                    return token() === 18 /* CloseBraceToken */;
	                case 3 /* SwitchClauseStatements */:
	                    return token() === 18 /* CloseBraceToken */ || token() === 73 /* CaseKeyword */ || token() === 79 /* DefaultKeyword */;
	                case 7 /* HeritageClauseElement */:
	                    return token() === 17 /* OpenBraceToken */ || token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	                case 8 /* VariableDeclarations */:
	                    return isVariableDeclaratorListTerminator();
	                case 18 /* TypeParameters */:
	                    // Tokens other than '>' are here for better error recovery
	                    return token() === 29 /* GreaterThanToken */ || token() === 19 /* OpenParenToken */ || token() === 17 /* OpenBraceToken */ || token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	                case 11 /* ArgumentExpressions */:
	                    // Tokens other than ')' are here for better error recovery
	                    return token() === 20 /* CloseParenToken */ || token() === 25 /* SemicolonToken */;
	                case 15 /* ArrayLiteralMembers */:
	                case 20 /* TupleElementTypes */:
	                case 10 /* ArrayBindingElements */:
	                    return token() === 22 /* CloseBracketToken */;
	                case 16 /* Parameters */:
	                case 17 /* RestProperties */:
	                    // Tokens other than ')' and ']' (the latter for index signatures) are here for better error recovery
	                    return token() === 20 /* CloseParenToken */ || token() === 22 /* CloseBracketToken */ /*|| token === SyntaxKind.OpenBraceToken*/;
	                case 19 /* TypeArguments */:
	                    // All other tokens should cause the type-argument to terminate except comma token
	                    return token() !== 26 /* CommaToken */;
	                case 21 /* HeritageClauses */:
	                    return token() === 17 /* OpenBraceToken */ || token() === 18 /* CloseBraceToken */;
	                case 13 /* JsxAttributes */:
	                    return token() === 29 /* GreaterThanToken */ || token() === 41 /* SlashToken */;
	                case 14 /* JsxChildren */:
	                    return token() === 27 /* LessThanToken */ && lookAhead(nextTokenIsSlash);
	            }
	        }
	        function isVariableDeclaratorListTerminator() {
	            // If we can consume a semicolon (either explicitly, or with ASI), then consider us done
	            // with parsing the list of variable declarators.
	            if (canParseSemicolon()) {
	                return true;
	            }
	            // in the case where we're parsing the variable declarator of a 'for-in' statement, we
	            // are done if we see an 'in' keyword in front of us. Same with for-of
	            if (isInOrOfKeyword(token())) {
	                return true;
	            }
	            // ERROR RECOVERY TWEAK:
	            // For better error recovery, if we see an '=>' then we just stop immediately.  We've got an
	            // arrow function here and it's going to be very unlikely that we'll resynchronize and get
	            // another variable declaration.
	            if (token() === 36 /* EqualsGreaterThanToken */) {
	                return true;
	            }
	            // Keep trying to parse out variable declarators.
	            return false;
	        }
	        // True if positioned at element or terminator of the current list or any enclosing list
	        function isInSomeParsingContext() {
	            for (var kind = 0; kind < 23 /* Count */; kind++) {
	                if (parsingContext & (1 << kind)) {
	                    if (isListElement(kind, /*inErrorRecovery*/ true) || isListTerminator(kind)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        // Parses a list of elements
	        function parseList(kind, parseElement) {
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << kind;
	            var list = [];
	            var listPos = getNodePos();
	            while (!isListTerminator(kind)) {
	                if (isListElement(kind, /*inErrorRecovery*/ false)) {
	                    var element = parseListElement(kind, parseElement);
	                    list.push(element);
	                    continue;
	                }
	                if (abortParsingListOrMoveToNextToken(kind)) {
	                    break;
	                }
	            }
	            parsingContext = saveParsingContext;
	            return createNodeArray(list, listPos);
	        }
	        function parseListElement(parsingContext, parseElement) {
	            var node = currentNode(parsingContext);
	            if (node) {
	                return consumeNode(node);
	            }
	            return parseElement();
	        }
	        function currentNode(parsingContext) {
	            // If there is an outstanding parse error that we've encountered, but not attached to
	            // some node, then we cannot get a node from the old source tree.  This is because we
	            // want to mark the next node we encounter as being unusable.
	            //
	            // Note: This may be too conservative.  Perhaps we could reuse the node and set the bit
	            // on it (or its leftmost child) as having the error.  For now though, being conservative
	            // is nice and likely won't ever affect perf.
	            if (parseErrorBeforeNextFinishedNode) {
	                return undefined;
	            }
	            if (!syntaxCursor) {
	                // if we don't have a cursor, we could never return a node from the old tree.
	                return undefined;
	            }
	            var node = syntaxCursor.currentNode(scanner.getStartPos());
	            // Can't reuse a missing node.
	            if (ts.nodeIsMissing(node)) {
	                return undefined;
	            }
	            // Can't reuse a node that intersected the change range.
	            if (node.intersectsChange) {
	                return undefined;
	            }
	            // Can't reuse a node that contains a parse error.  This is necessary so that we
	            // produce the same set of errors again.
	            if (ts.containsParseError(node)) {
	                return undefined;
	            }
	            // We can only reuse a node if it was parsed under the same strict mode that we're
	            // currently in.  i.e. if we originally parsed a node in non-strict mode, but then
	            // the user added 'using strict' at the top of the file, then we can't use that node
	            // again as the presence of strict mode may cause us to parse the tokens in the file
	            // differently.
	            //
	            // Note: we *can* reuse tokens when the strict mode changes.  That's because tokens
	            // are unaffected by strict mode.  It's just the parser will decide what to do with it
	            // differently depending on what mode it is in.
	            //
	            // This also applies to all our other context flags as well.
	            var nodeContextFlags = node.flags & 12679168 /* ContextFlags */;
	            if (nodeContextFlags !== contextFlags) {
	                return undefined;
	            }
	            // Ok, we have a node that looks like it could be reused.  Now verify that it is valid
	            // in the current list parsing context that we're currently at.
	            if (!canReuseNode(node, parsingContext)) {
	                return undefined;
	            }
	            if (node.jsDocCache) {
	                // jsDocCache may include tags from parent nodes, which might have been modified.
	                node.jsDocCache = undefined;
	            }
	            return node;
	        }
	        function consumeNode(node) {
	            // Move the scanner so it is after the node we just consumed.
	            scanner.setTextPos(node.end);
	            nextToken();
	            return node;
	        }
	        function canReuseNode(node, parsingContext) {
	            switch (parsingContext) {
	                case 5 /* ClassMembers */:
	                    return isReusableClassMember(node);
	                case 2 /* SwitchClauses */:
	                    return isReusableSwitchClause(node);
	                case 0 /* SourceElements */:
	                case 1 /* BlockStatements */:
	                case 3 /* SwitchClauseStatements */:
	                    return isReusableStatement(node);
	                case 6 /* EnumMembers */:
	                    return isReusableEnumMember(node);
	                case 4 /* TypeMembers */:
	                    return isReusableTypeMember(node);
	                case 8 /* VariableDeclarations */:
	                    return isReusableVariableDeclaration(node);
	                case 16 /* Parameters */:
	                    return isReusableParameter(node);
	                case 17 /* RestProperties */:
	                    return false;
	                // Any other lists we do not care about reusing nodes in.  But feel free to add if
	                // you can do so safely.  Danger areas involve nodes that may involve speculative
	                // parsing.  If speculative parsing is involved with the node, then the range the
	                // parser reached while looking ahead might be in the edited range (see the example
	                // in canReuseVariableDeclaratorNode for a good case of this).
	                case 21 /* HeritageClauses */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // heritage clauses.
	                case 18 /* TypeParameters */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // type parameters.  Note that that's because type *parameters* only occur in
	                // unambiguous *type* contexts.  While type *arguments* occur in very ambiguous
	                // *expression* contexts.
	                case 20 /* TupleElementTypes */:
	                // This would probably be safe to reuse.  There is no speculative parsing with
	                // tuple types.
	                // Technically, type argument list types are probably safe to reuse.  While
	                // speculative parsing is involved with them (since type argument lists are only
	                // produced from speculative parsing a < as a type argument list), we only have
	                // the types because speculative parsing succeeded.  Thus, the lookahead never
	                // went past the end of the list and rewound.
	                case 19 /* TypeArguments */:
	                // Note: these are almost certainly not safe to ever reuse.  Expressions commonly
	                // need a large amount of lookahead, and we should not reuse them as they may
	                // have actually intersected the edit.
	                case 11 /* ArgumentExpressions */:
	                // This is not safe to reuse for the same reason as the 'AssignmentExpression'
	                // cases.  i.e. a property assignment may end with an expression, and thus might
	                // have lookahead far beyond it's old node.
	                case 12 /* ObjectLiteralMembers */:
	                // This is probably not safe to reuse.  There can be speculative parsing with
	                // type names in a heritage clause.  There can be generic names in the type
	                // name list, and there can be left hand side expressions (which can have type
	                // arguments.)
	                case 7 /* HeritageClauseElement */:
	                // Perhaps safe to reuse, but it's unlikely we'd see more than a dozen attributes
	                // on any given element. Same for children.
	                case 13 /* JsxAttributes */:
	                case 14 /* JsxChildren */:
	            }
	            return false;
	        }
	        function isReusableClassMember(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 154 /* Constructor */:
	                    case 159 /* IndexSignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 151 /* PropertyDeclaration */:
	                    case 211 /* SemicolonClassElement */:
	                        return true;
	                    case 153 /* MethodDeclaration */:
	                        // Method declarations are not necessarily reusable.  An object-literal
	                        // may have a method calls "constructor(...)" and we must reparse that
	                        // into an actual .ConstructorDeclaration.
	                        var methodDeclaration = node;
	                        var nameIsConstructor = methodDeclaration.name.kind === 71 /* Identifier */ &&
	                            methodDeclaration.name.originalKeywordKind === 123 /* ConstructorKeyword */;
	                        return !nameIsConstructor;
	                }
	            }
	            return false;
	        }
	        function isReusableSwitchClause(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 265 /* CaseClause */:
	                    case 266 /* DefaultClause */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableStatement(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 233 /* FunctionDeclaration */:
	                    case 213 /* VariableStatement */:
	                    case 212 /* Block */:
	                    case 216 /* IfStatement */:
	                    case 215 /* ExpressionStatement */:
	                    case 228 /* ThrowStatement */:
	                    case 224 /* ReturnStatement */:
	                    case 226 /* SwitchStatement */:
	                    case 223 /* BreakStatement */:
	                    case 222 /* ContinueStatement */:
	                    case 220 /* ForInStatement */:
	                    case 221 /* ForOfStatement */:
	                    case 219 /* ForStatement */:
	                    case 218 /* WhileStatement */:
	                    case 225 /* WithStatement */:
	                    case 214 /* EmptyStatement */:
	                    case 229 /* TryStatement */:
	                    case 227 /* LabeledStatement */:
	                    case 217 /* DoStatement */:
	                    case 230 /* DebuggerStatement */:
	                    case 243 /* ImportDeclaration */:
	                    case 242 /* ImportEqualsDeclaration */:
	                    case 249 /* ExportDeclaration */:
	                    case 248 /* ExportAssignment */:
	                    case 238 /* ModuleDeclaration */:
	                    case 234 /* ClassDeclaration */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 237 /* EnumDeclaration */:
	                    case 236 /* TypeAliasDeclaration */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableEnumMember(node) {
	            return node.kind === 272 /* EnumMember */;
	        }
	        function isReusableTypeMember(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 158 /* ConstructSignature */:
	                    case 152 /* MethodSignature */:
	                    case 159 /* IndexSignature */:
	                    case 150 /* PropertySignature */:
	                    case 157 /* CallSignature */:
	                        return true;
	                }
	            }
	            return false;
	        }
	        function isReusableVariableDeclaration(node) {
	            if (node.kind !== 231 /* VariableDeclaration */) {
	                return false;
	            }
	            // Very subtle incremental parsing bug.  Consider the following code:
	            //
	            //      let v = new List < A, B
	            //
	            // This is actually legal code.  It's a list of variable declarators "v = new List<A"
	            // on one side and "B" on the other. If you then change that to:
	            //
	            //      let v = new List < A, B >()
	            //
	            // then we have a problem.  "v = new List<A" doesn't intersect the change range, so we
	            // start reparsing at "B" and we completely fail to handle this properly.
	            //
	            // In order to prevent this, we do not allow a variable declarator to be reused if it
	            // has an initializer.
	            var variableDeclarator = node;
	            return variableDeclarator.initializer === undefined;
	        }
	        function isReusableParameter(node) {
	            if (node.kind !== 148 /* Parameter */) {
	                return false;
	            }
	            // See the comment in isReusableVariableDeclaration for why we do this.
	            var parameter = node;
	            return parameter.initializer === undefined;
	        }
	        // Returns true if we should abort parsing.
	        function abortParsingListOrMoveToNextToken(kind) {
	            parseErrorAtCurrentToken(parsingContextErrors(kind));
	            if (isInSomeParsingContext()) {
	                return true;
	            }
	            nextToken();
	            return false;
	        }
	        function parsingContextErrors(context) {
	            switch (context) {
	                case 0 /* SourceElements */: return ts.Diagnostics.Declaration_or_statement_expected;
	                case 1 /* BlockStatements */: return ts.Diagnostics.Declaration_or_statement_expected;
	                case 2 /* SwitchClauses */: return ts.Diagnostics.case_or_default_expected;
	                case 3 /* SwitchClauseStatements */: return ts.Diagnostics.Statement_expected;
	                case 17 /* RestProperties */: // fallthrough
	                case 4 /* TypeMembers */: return ts.Diagnostics.Property_or_signature_expected;
	                case 5 /* ClassMembers */: return ts.Diagnostics.Unexpected_token_A_constructor_method_accessor_or_property_was_expected;
	                case 6 /* EnumMembers */: return ts.Diagnostics.Enum_member_expected;
	                case 7 /* HeritageClauseElement */: return ts.Diagnostics.Expression_expected;
	                case 8 /* VariableDeclarations */: return ts.Diagnostics.Variable_declaration_expected;
	                case 9 /* ObjectBindingElements */: return ts.Diagnostics.Property_destructuring_pattern_expected;
	                case 10 /* ArrayBindingElements */: return ts.Diagnostics.Array_element_destructuring_pattern_expected;
	                case 11 /* ArgumentExpressions */: return ts.Diagnostics.Argument_expression_expected;
	                case 12 /* ObjectLiteralMembers */: return ts.Diagnostics.Property_assignment_expected;
	                case 15 /* ArrayLiteralMembers */: return ts.Diagnostics.Expression_or_comma_expected;
	                case 16 /* Parameters */: return ts.Diagnostics.Parameter_declaration_expected;
	                case 18 /* TypeParameters */: return ts.Diagnostics.Type_parameter_declaration_expected;
	                case 19 /* TypeArguments */: return ts.Diagnostics.Type_argument_expected;
	                case 20 /* TupleElementTypes */: return ts.Diagnostics.Type_expected;
	                case 21 /* HeritageClauses */: return ts.Diagnostics.Unexpected_token_expected;
	                case 22 /* ImportOrExportSpecifiers */: return ts.Diagnostics.Identifier_expected;
	                case 13 /* JsxAttributes */: return ts.Diagnostics.Identifier_expected;
	                case 14 /* JsxChildren */: return ts.Diagnostics.Identifier_expected;
	            }
	        }
	        // Parses a comma-delimited list of elements
	        function parseDelimitedList(kind, parseElement, considerSemicolonAsDelimiter) {
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << kind;
	            var list = [];
	            var listPos = getNodePos();
	            var commaStart = -1; // Meaning the previous token was not a comma
	            while (true) {
	                if (isListElement(kind, /*inErrorRecovery*/ false)) {
	                    var startPos = scanner.getStartPos();
	                    list.push(parseListElement(kind, parseElement));
	                    commaStart = scanner.getTokenPos();
	                    if (parseOptional(26 /* CommaToken */)) {
	                        // No need to check for a zero length node since we know we parsed a comma
	                        continue;
	                    }
	                    commaStart = -1; // Back to the state where the last token was not a comma
	                    if (isListTerminator(kind)) {
	                        break;
	                    }
	                    // We didn't get a comma, and the list wasn't terminated, explicitly parse
	                    // out a comma so we give a good error message.
	                    parseExpected(26 /* CommaToken */);
	                    // If the token was a semicolon, and the caller allows that, then skip it and
	                    // continue.  This ensures we get back on track and don't result in tons of
	                    // parse errors.  For example, this can happen when people do things like use
	                    // a semicolon to delimit object literal members.   Note: we'll have already
	                    // reported an error when we called parseExpected above.
	                    if (considerSemicolonAsDelimiter && token() === 25 /* SemicolonToken */ && !scanner.hasPrecedingLineBreak()) {
	                        nextToken();
	                    }
	                    if (startPos === scanner.getStartPos()) {
	                        // What we're parsing isn't actually remotely recognizable as a element and we've consumed no tokens whatsoever
	                        // Consume a token to advance the parser in some way and avoid an infinite loop
	                        // This can happen when we're speculatively parsing parenthesized expressions which we think may be arrow functions,
	                        // or when a modifier keyword which is disallowed as a parameter name (ie, `static` in strict mode) is supplied
	                        nextToken();
	                    }
	                    continue;
	                }
	                if (isListTerminator(kind)) {
	                    break;
	                }
	                if (abortParsingListOrMoveToNextToken(kind)) {
	                    break;
	                }
	            }
	            parsingContext = saveParsingContext;
	            var result = createNodeArray(list, listPos);
	            // Recording the trailing comma is deliberately done after the previous
	            // loop, and not just if we see a list terminator. This is because the list
	            // may have ended incorrectly, but it is still important to know if there
	            // was a trailing comma.
	            // Check if the last token was a comma.
	            if (commaStart >= 0) {
	                // Always preserve a trailing comma by marking it on the NodeArray
	                result.hasTrailingComma = true;
	            }
	            return result;
	        }
	        function createMissingList() {
	            return createNodeArray([], getNodePos());
	        }
	        function parseBracketedList(kind, parseElement, open, close) {
	            if (parseExpected(open)) {
	                var result = parseDelimitedList(kind, parseElement);
	                parseExpected(close);
	                return result;
	            }
	            return createMissingList();
	        }
	        function parseEntityName(allowReservedWords, diagnosticMessage) {
	            var entity = allowReservedWords ? parseIdentifierName(diagnosticMessage) : parseIdentifier(diagnosticMessage);
	            var dotPos = scanner.getStartPos();
	            while (parseOptional(23 /* DotToken */)) {
	                if (token() === 27 /* LessThanToken */) {
	                    // the entity is part of a JSDoc-style generic, so record the trailing dot for later error reporting
	                    entity.jsdocDotPos = dotPos;
	                    break;
	                }
	                dotPos = scanner.getStartPos();
	                entity = createQualifiedName(entity, parseRightSideOfDot(allowReservedWords));
	            }
	            return entity;
	        }
	        function createQualifiedName(entity, name) {
	            var node = createNode(145 /* QualifiedName */, entity.pos);
	            node.left = entity;
	            node.right = name;
	            return finishNode(node);
	        }
	        function parseRightSideOfDot(allowIdentifierNames) {
	            // Technically a keyword is valid here as all identifiers and keywords are identifier names.
	            // However, often we'll encounter this in error situations when the identifier or keyword
	            // is actually starting another valid construct.
	            //
	            // So, we check for the following specific case:
	            //
	            //      name.
	            //      identifierOrKeyword identifierNameOrKeyword
	            //
	            // Note: the newlines are important here.  For example, if that above code
	            // were rewritten into:
	            //
	            //      name.identifierOrKeyword
	            //      identifierNameOrKeyword
	            //
	            // Then we would consider it valid.  That's because ASI would take effect and
	            // the code would be implicitly: "name.identifierOrKeyword; identifierNameOrKeyword".
	            // In the first case though, ASI will not take effect because there is not a
	            // line terminator after the identifier or keyword.
	            if (scanner.hasPrecedingLineBreak() && ts.tokenIsIdentifierOrKeyword(token())) {
	                var matchesPattern = lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
	                if (matchesPattern) {
	                    // Report that we need an identifier.  However, report it right after the dot,
	                    // and not on the next token.  This is because the next token might actually
	                    // be an identifier and the error would be quite confusing.
	                    return createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Identifier_expected);
	                }
	            }
	            return allowIdentifierNames ? parseIdentifierName() : parseIdentifier();
	        }
	        function parseTemplateExpression() {
	            var template = createNode(201 /* TemplateExpression */);
	            template.head = parseTemplateHead();
	            ts.Debug.assert(template.head.kind === 14 /* TemplateHead */, "Template head has wrong token kind");
	            var list = [];
	            var listPos = getNodePos();
	            do {
	                list.push(parseTemplateSpan());
	            } while (ts.lastOrUndefined(list).literal.kind === 15 /* TemplateMiddle */);
	            template.templateSpans = createNodeArray(list, listPos);
	            return finishNode(template);
	        }
	        function parseTemplateSpan() {
	            var span = createNode(210 /* TemplateSpan */);
	            span.expression = allowInAnd(parseExpression);
	            var literal;
	            if (token() === 18 /* CloseBraceToken */) {
	                reScanTemplateToken();
	                literal = parseTemplateMiddleOrTemplateTail();
	            }
	            else {
	                literal = parseExpectedToken(16 /* TemplateTail */, ts.Diagnostics._0_expected, ts.tokenToString(18 /* CloseBraceToken */));
	            }
	            span.literal = literal;
	            return finishNode(span);
	        }
	        function parseLiteralNode() {
	            return parseLiteralLikeNode(token());
	        }
	        function parseTemplateHead() {
	            var fragment = parseLiteralLikeNode(token());
	            ts.Debug.assert(fragment.kind === 14 /* TemplateHead */, "Template head has wrong token kind");
	            return fragment;
	        }
	        function parseTemplateMiddleOrTemplateTail() {
	            var fragment = parseLiteralLikeNode(token());
	            ts.Debug.assert(fragment.kind === 15 /* TemplateMiddle */ || fragment.kind === 16 /* TemplateTail */, "Template fragment has wrong token kind");
	            return fragment;
	        }
	        function parseLiteralLikeNode(kind) {
	            var node = createNode(kind);
	            var text = scanner.getTokenValue();
	            node.text = text;
	            if (scanner.hasExtendedUnicodeEscape()) {
	                node.hasExtendedUnicodeEscape = true;
	            }
	            if (scanner.isUnterminated()) {
	                node.isUnterminated = true;
	            }
	            // Octal literals are not allowed in strict mode or ES5
	            // Note that theoretically the following condition would hold true literals like 009,
	            // which is not octal.But because of how the scanner separates the tokens, we would
	            // never get a token like this. Instead, we would get 00 and 9 as two separate tokens.
	            // We also do not need to check for negatives because any prefix operator would be part of a
	            // parent unary expression.
	            if (node.kind === 8 /* NumericLiteral */) {
	                node.numericLiteralFlags = scanner.getTokenFlags() & 1008 /* NumericLiteralFlags */;
	            }
	            nextToken();
	            finishNode(node);
	            return node;
	        }
	        // TYPES
	        function parseTypeReference() {
	            var node = createNode(161 /* TypeReference */);
	            node.typeName = parseEntityName(/*allowReservedWords*/ true, ts.Diagnostics.Type_expected);
	            if (!scanner.hasPrecedingLineBreak() && token() === 27 /* LessThanToken */) {
	                node.typeArguments = parseBracketedList(19 /* TypeArguments */, parseType, 27 /* LessThanToken */, 29 /* GreaterThanToken */);
	            }
	            return finishNode(node);
	        }
	        // If true, we should abort parsing an error function.
	        function typeHasArrowFunctionBlockingParseError(node) {
	            switch (node.kind) {
	                case 161 /* TypeReference */:
	                    return ts.nodeIsMissing(node.typeName);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */: {
	                    var _a = node, parameters = _a.parameters, type = _a.type;
	                    // parameters.pos === parameters.end only if we used parseMissingList, else should contain at least `()`
	                    return parameters.pos === parameters.end || typeHasArrowFunctionBlockingParseError(type);
	                }
	                case 172 /* ParenthesizedType */:
	                    return typeHasArrowFunctionBlockingParseError(node.type);
	                default:
	                    return false;
	            }
	        }
	        function parseThisTypePredicate(lhs) {
	            nextToken();
	            var node = createNode(160 /* TypePredicate */, lhs.pos);
	            node.parameterName = lhs;
	            node.type = parseType();
	            return finishNode(node);
	        }
	        function parseThisTypeNode() {
	            var node = createNode(173 /* ThisType */);
	            nextToken();
	            return finishNode(node);
	        }
	        function parseJSDocAllType(postFixEquals) {
	            var result = createNode(278 /* JSDocAllType */);
	            if (postFixEquals) {
	                return createJSDocPostfixType(282 /* JSDocOptionalType */, result);
	            }
	            else {
	                nextToken();
	            }
	            return finishNode(result);
	        }
	        function parseJSDocNonNullableType() {
	            var result = createNode(281 /* JSDocNonNullableType */);
	            nextToken();
	            result.type = parseNonArrayType();
	            return finishNode(result);
	        }
	        function parseJSDocUnknownOrNullableType() {
	            var pos = scanner.getStartPos();
	            // skip the ?
	            nextToken();
	            // Need to lookahead to decide if this is a nullable or unknown type.
	            // Here are cases where we'll pick the unknown type:
	            //
	            //      Foo(?,
	            //      { a: ? }
	            //      Foo(?)
	            //      Foo<?>
	            //      Foo(?=
	            //      (?|
	            if (token() === 26 /* CommaToken */ ||
	                token() === 18 /* CloseBraceToken */ ||
	                token() === 20 /* CloseParenToken */ ||
	                token() === 29 /* GreaterThanToken */ ||
	                token() === 58 /* EqualsToken */ ||
	                token() === 49 /* BarToken */) {
	                var result = createNode(279 /* JSDocUnknownType */, pos);
	                return finishNode(result);
	            }
	            else {
	                var result = createNode(280 /* JSDocNullableType */, pos);
	                result.type = parseType();
	                return finishNode(result);
	            }
	        }
	        function parseJSDocFunctionType() {
	            if (lookAhead(nextTokenIsOpenParen)) {
	                var result = createNodeWithJSDoc(283 /* JSDocFunctionType */);
	                nextToken();
	                fillSignature(56 /* ColonToken */, 4 /* Type */ | 32 /* JSDoc */, result);
	                return finishNode(result);
	            }
	            var node = createNode(161 /* TypeReference */);
	            node.typeName = parseIdentifierName();
	            return finishNode(node);
	        }
	        function parseJSDocParameter() {
	            var parameter = createNode(148 /* Parameter */);
	            if (token() === 99 /* ThisKeyword */ || token() === 94 /* NewKeyword */) {
	                parameter.name = parseIdentifierName();
	                parseExpected(56 /* ColonToken */);
	            }
	            parameter.type = parseJSDocType();
	            return finishNode(parameter);
	        }
	        function parseJSDocType() {
	            var dotdotdot = parseOptionalToken(24 /* DotDotDotToken */);
	            var type = parseType();
	            if (dotdotdot) {
	                var variadic = createNode(284 /* JSDocVariadicType */, dotdotdot.pos);
	                variadic.type = type;
	                type = finishNode(variadic);
	            }
	            if (token() === 58 /* EqualsToken */) {
	                return createJSDocPostfixType(282 /* JSDocOptionalType */, type);
	            }
	            return type;
	        }
	        function parseTypeQuery() {
	            var node = createNode(164 /* TypeQuery */);
	            parseExpected(103 /* TypeOfKeyword */);
	            node.exprName = parseEntityName(/*allowReservedWords*/ true);
	            return finishNode(node);
	        }
	        function parseTypeParameter() {
	            var node = createNode(147 /* TypeParameter */);
	            node.name = parseIdentifier();
	            if (parseOptional(85 /* ExtendsKeyword */)) {
	                // It's not uncommon for people to write improper constraints to a generic.  If the
	                // user writes a constraint that is an expression and not an actual type, then parse
	                // it out as an expression (so we can recover well), but report that a type is needed
	                // instead.
	                if (isStartOfType() || !isStartOfExpression()) {
	                    node.constraint = parseType();
	                }
	                else {
	                    // It was not a type, and it looked like an expression.  Parse out an expression
	                    // here so we recover well.  Note: it is important that we call parseUnaryExpression
	                    // and not parseExpression here.  If the user has:
	                    //
	                    //      <T extends "">
	                    //
	                    // We do *not* want to consume the `>` as we're consuming the expression for "".
	                    node.expression = parseUnaryExpressionOrHigher();
	                }
	            }
	            if (parseOptional(58 /* EqualsToken */)) {
	                node.default = parseType();
	            }
	            return finishNode(node);
	        }
	        function parseTypeParameters() {
	            if (token() === 27 /* LessThanToken */) {
	                return parseBracketedList(18 /* TypeParameters */, parseTypeParameter, 27 /* LessThanToken */, 29 /* GreaterThanToken */);
	            }
	        }
	        function parseParameterType() {
	            if (parseOptional(56 /* ColonToken */)) {
	                return parseType();
	            }
	            return undefined;
	        }
	        function isStartOfParameter() {
	            return token() === 24 /* DotDotDotToken */ ||
	                isIdentifierOrPattern() ||
	                ts.isModifierKind(token()) ||
	                token() === 57 /* AtToken */ ||
	                isStartOfType(/*inStartOfParameter*/ true);
	        }
	        function parseParameter() {
	            var node = createNodeWithJSDoc(148 /* Parameter */);
	            if (token() === 99 /* ThisKeyword */) {
	                node.name = createIdentifier(/*isIdentifier*/ true);
	                node.type = parseParameterType();
	                return finishNode(node);
	            }
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            // FormalParameter [Yield,Await]:
	            //      BindingElement[?Yield,?Await]
	            node.name = parseIdentifierOrPattern();
	            if (ts.getFullWidth(node.name) === 0 && !ts.hasModifiers(node) && ts.isModifierKind(token())) {
	                // in cases like
	                // 'use strict'
	                // function foo(static)
	                // isParameter('static') === true, because of isModifier('static')
	                // however 'static' is not a legal identifier in a strict mode.
	                // so result of this function will be ParameterDeclaration (flags = 0, name = missing, type = undefined, initializer = undefined)
	                // and current token will not change => parsing of the enclosing parameter list will last till the end of time (or OOM)
	                // to avoid this we'll advance cursor to the next token.
	                nextToken();
	            }
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            node.type = parseParameterType();
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        /**
	         * Note: If returnToken is EqualsGreaterThanToken, `signature.type` will always be defined.
	         * @returns If return type parsing succeeds
	         */
	        function fillSignature(returnToken, flags, signature) {
	            if (!(flags & 32 /* JSDoc */)) {
	                signature.typeParameters = parseTypeParameters();
	            }
	            var parametersParsedSuccessfully = parseParameterList(signature, flags);
	            if (shouldParseReturnType(returnToken, !!(flags & 4 /* Type */))) {
	                signature.type = parseTypeOrTypePredicate();
	                if (typeHasArrowFunctionBlockingParseError(signature.type))
	                    return false;
	            }
	            return parametersParsedSuccessfully;
	        }
	        function shouldParseReturnType(returnToken, isType) {
	            if (returnToken === 36 /* EqualsGreaterThanToken */) {
	                parseExpected(returnToken);
	                return true;
	            }
	            else if (parseOptional(56 /* ColonToken */)) {
	                return true;
	            }
	            else if (isType && token() === 36 /* EqualsGreaterThanToken */) {
	                // This is easy to get backward, especially in type contexts, so parse the type anyway
	                parseErrorAtCurrentToken(ts.Diagnostics._0_expected, ts.tokenToString(56 /* ColonToken */));
	                nextToken();
	                return true;
	            }
	            return false;
	        }
	        // Returns true on success.
	        function parseParameterList(signature, flags) {
	            // FormalParameters [Yield,Await]: (modified)
	            //      [empty]
	            //      FormalParameterList[?Yield,Await]
	            //
	            // FormalParameter[Yield,Await]: (modified)
	            //      BindingElement[?Yield,Await]
	            //
	            // BindingElement [Yield,Await]: (modified)
	            //      SingleNameBinding[?Yield,?Await]
	            //      BindingPattern[?Yield,?Await]Initializer [In, ?Yield,?Await] opt
	            //
	            // SingleNameBinding [Yield,Await]:
	            //      BindingIdentifier[?Yield,?Await]Initializer [In, ?Yield,?Await] opt
	            if (!parseExpected(19 /* OpenParenToken */)) {
	                signature.parameters = createMissingList();
	                return false;
	            }
	            var savedYieldContext = inYieldContext();
	            var savedAwaitContext = inAwaitContext();
	            setYieldContext(!!(flags & 1 /* Yield */));
	            setAwaitContext(!!(flags & 2 /* Await */));
	            signature.parameters = parseDelimitedList(16 /* Parameters */, flags & 32 /* JSDoc */ ? parseJSDocParameter : parseParameter);
	            setYieldContext(savedYieldContext);
	            setAwaitContext(savedAwaitContext);
	            return parseExpected(20 /* CloseParenToken */);
	        }
	        function parseTypeMemberSemicolon() {
	            // We allow type members to be separated by commas or (possibly ASI) semicolons.
	            // First check if it was a comma.  If so, we're done with the member.
	            if (parseOptional(26 /* CommaToken */)) {
	                return;
	            }
	            // Didn't have a comma.  We must have a (possible ASI) semicolon.
	            parseSemicolon();
	        }
	        function parseSignatureMember(kind) {
	            var node = createNodeWithJSDoc(kind);
	            if (kind === 158 /* ConstructSignature */) {
	                parseExpected(94 /* NewKeyword */);
	            }
	            fillSignature(56 /* ColonToken */, 4 /* Type */, node);
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function isIndexSignature() {
	            return token() === 21 /* OpenBracketToken */ && lookAhead(isUnambiguouslyIndexSignature);
	        }
	        function isUnambiguouslyIndexSignature() {
	            // The only allowed sequence is:
	            //
	            //   [id:
	            //
	            // However, for error recovery, we also check the following cases:
	            //
	            //   [...
	            //   [id,
	            //   [id?,
	            //   [id?:
	            //   [id?]
	            //   [public id
	            //   [private id
	            //   [protected id
	            //   []
	            //
	            nextToken();
	            if (token() === 24 /* DotDotDotToken */ || token() === 22 /* CloseBracketToken */) {
	                return true;
	            }
	            if (ts.isModifierKind(token())) {
	                nextToken();
	                if (isIdentifier()) {
	                    return true;
	                }
	            }
	            else if (!isIdentifier()) {
	                return false;
	            }
	            else {
	                // Skip the identifier
	                nextToken();
	            }
	            // A colon signifies a well formed indexer
	            // A comma should be a badly formed indexer because comma expressions are not allowed
	            // in computed properties.
	            if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */) {
	                return true;
	            }
	            // Question mark could be an indexer with an optional property,
	            // or it could be a conditional expression in a computed property.
	            if (token() !== 55 /* QuestionToken */) {
	                return false;
	            }
	            // If any of the following tokens are after the question mark, it cannot
	            // be a conditional expression, so treat it as an indexer.
	            nextToken();
	            return token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ || token() === 22 /* CloseBracketToken */;
	        }
	        function parseIndexSignatureDeclaration(node) {
	            node.kind = 159 /* IndexSignature */;
	            node.parameters = parseBracketedList(16 /* Parameters */, parseParameter, 21 /* OpenBracketToken */, 22 /* CloseBracketToken */);
	            node.type = parseTypeAnnotation();
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function parsePropertyOrMethodSignature(node) {
	            node.name = parsePropertyName();
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                node.kind = 152 /* MethodSignature */;
	                // Method signatures don't exist in expression contexts.  So they have neither
	                // [Yield] nor [Await]
	                fillSignature(56 /* ColonToken */, 4 /* Type */, node);
	            }
	            else {
	                node.kind = 150 /* PropertySignature */;
	                node.type = parseTypeAnnotation();
	                if (token() === 58 /* EqualsToken */) {
	                    // Although type literal properties cannot not have initializers, we attempt
	                    // to parse an initializer so we can report in the checker that an interface
	                    // property or type literal property cannot have an initializer.
	                    node.initializer = parseInitializer();
	                }
	            }
	            parseTypeMemberSemicolon();
	            return finishNode(node);
	        }
	        function isTypeMemberStart() {
	            // Return true if we have the start of a signature member
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return true;
	            }
	            var idToken;
	            // Eat up all modifiers, but hold on to the last one in case it is actually an identifier
	            while (ts.isModifierKind(token())) {
	                idToken = true;
	                nextToken();
	            }
	            // Index signatures and computed property names are type members
	            if (token() === 21 /* OpenBracketToken */) {
	                return true;
	            }
	            // Try to get the first property-like token following all modifiers
	            if (isLiteralPropertyName()) {
	                idToken = true;
	                nextToken();
	            }
	            // If we were able to get any potential identifier, check that it is
	            // the start of a member declaration
	            if (idToken) {
	                return token() === 19 /* OpenParenToken */ ||
	                    token() === 27 /* LessThanToken */ ||
	                    token() === 55 /* QuestionToken */ ||
	                    token() === 56 /* ColonToken */ ||
	                    token() === 26 /* CommaToken */ ||
	                    canParseSemicolon();
	            }
	            return false;
	        }
	        function parseTypeMember() {
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseSignatureMember(157 /* CallSignature */);
	            }
	            if (token() === 94 /* NewKeyword */ && lookAhead(nextTokenIsOpenParenOrLessThan)) {
	                return parseSignatureMember(158 /* ConstructSignature */);
	            }
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.modifiers = parseModifiers();
	            if (isIndexSignature()) {
	                return parseIndexSignatureDeclaration(node);
	            }
	            return parsePropertyOrMethodSignature(node);
	        }
	        function nextTokenIsOpenParenOrLessThan() {
	            nextToken();
	            return token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */;
	        }
	        function nextTokenIsDot() {
	            return nextToken() === 23 /* DotToken */;
	        }
	        function nextTokenIsOpenParenOrLessThanOrDot() {
	            switch (nextToken()) {
	                case 19 /* OpenParenToken */:
	                case 27 /* LessThanToken */:
	                case 23 /* DotToken */:
	                    return true;
	            }
	            return false;
	        }
	        function parseTypeLiteral() {
	            var node = createNode(165 /* TypeLiteral */);
	            node.members = parseObjectTypeMembers();
	            return finishNode(node);
	        }
	        function parseObjectTypeMembers() {
	            var members;
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                members = parseList(4 /* TypeMembers */, parseTypeMember);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                members = createMissingList();
	            }
	            return members;
	        }
	        function isStartOfMappedType() {
	            nextToken();
	            if (token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                return nextToken() === 132 /* ReadonlyKeyword */;
	            }
	            if (token() === 132 /* ReadonlyKeyword */) {
	                nextToken();
	            }
	            return token() === 21 /* OpenBracketToken */ && nextTokenIsIdentifier() && nextToken() === 92 /* InKeyword */;
	        }
	        function parseMappedTypeParameter() {
	            var node = createNode(147 /* TypeParameter */);
	            node.name = parseIdentifier();
	            parseExpected(92 /* InKeyword */);
	            node.constraint = parseType();
	            return finishNode(node);
	        }
	        function parseMappedType() {
	            var node = createNode(176 /* MappedType */);
	            parseExpected(17 /* OpenBraceToken */);
	            if (token() === 132 /* ReadonlyKeyword */ || token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                node.readonlyToken = parseTokenNode();
	                if (node.readonlyToken.kind !== 132 /* ReadonlyKeyword */) {
	                    parseExpectedToken(132 /* ReadonlyKeyword */);
	                }
	            }
	            parseExpected(21 /* OpenBracketToken */);
	            node.typeParameter = parseMappedTypeParameter();
	            parseExpected(22 /* CloseBracketToken */);
	            if (token() === 55 /* QuestionToken */ || token() === 37 /* PlusToken */ || token() === 38 /* MinusToken */) {
	                node.questionToken = parseTokenNode();
	                if (node.questionToken.kind !== 55 /* QuestionToken */) {
	                    parseExpectedToken(55 /* QuestionToken */);
	                }
	            }
	            node.type = parseTypeAnnotation();
	            parseSemicolon();
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseTupleType() {
	            var node = createNode(167 /* TupleType */);
	            node.elementTypes = parseBracketedList(20 /* TupleElementTypes */, parseType, 21 /* OpenBracketToken */, 22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseParenthesizedType() {
	            var node = createNode(172 /* ParenthesizedType */);
	            parseExpected(19 /* OpenParenToken */);
	            node.type = parseType();
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseFunctionOrConstructorType() {
	            var pos = getNodePos();
	            var kind = parseOptional(94 /* NewKeyword */) ? 163 /* ConstructorType */ : 162 /* FunctionType */;
	            var node = createNodeWithJSDoc(kind, pos);
	            fillSignature(36 /* EqualsGreaterThanToken */, 4 /* Type */, node);
	            return finishNode(node);
	        }
	        function parseKeywordAndNoDot() {
	            var node = parseTokenNode();
	            return token() === 23 /* DotToken */ ? undefined : node;
	        }
	        function parseLiteralTypeNode(negative) {
	            var node = createNode(177 /* LiteralType */);
	            var unaryMinusExpression;
	            if (negative) {
	                unaryMinusExpression = createNode(197 /* PrefixUnaryExpression */);
	                unaryMinusExpression.operator = 38 /* MinusToken */;
	                nextToken();
	            }
	            var expression = token() === 101 /* TrueKeyword */ || token() === 86 /* FalseKeyword */
	                ? parseTokenNode()
	                : parseLiteralLikeNode(token());
	            if (negative) {
	                unaryMinusExpression.operand = expression;
	                finishNode(unaryMinusExpression);
	                expression = unaryMinusExpression;
	            }
	            node.literal = expression;
	            return finishNode(node);
	        }
	        function isStartOfTypeOfImportType() {
	            nextToken();
	            return token() === 91 /* ImportKeyword */;
	        }
	        function parseImportType() {
	            sourceFile.flags |= 524288 /* PossiblyContainsDynamicImport */;
	            var node = createNode(178 /* ImportType */);
	            if (parseOptional(103 /* TypeOfKeyword */)) {
	                node.isTypeOf = true;
	            }
	            parseExpected(91 /* ImportKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.argument = parseType();
	            parseExpected(20 /* CloseParenToken */);
	            if (parseOptional(23 /* DotToken */)) {
	                node.qualifier = parseEntityName(/*allowReservedWords*/ true, ts.Diagnostics.Type_expected);
	            }
	            node.typeArguments = tryParseTypeArguments();
	            return finishNode(node);
	        }
	        function nextTokenIsNumericLiteral() {
	            return nextToken() === 8 /* NumericLiteral */;
	        }
	        function parseNonArrayType() {
	            switch (token()) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 131 /* NeverKeyword */:
	                case 135 /* ObjectKeyword */:
	                    // If these are followed by a dot, then parse these out as a dotted type reference instead.
	                    return tryParse(parseKeywordAndNoDot) || parseTypeReference();
	                case 39 /* AsteriskToken */:
	                    return parseJSDocAllType(/*postfixEquals*/ false);
	                case 61 /* AsteriskEqualsToken */:
	                    return parseJSDocAllType(/*postfixEquals*/ true);
	                case 55 /* QuestionToken */:
	                    return parseJSDocUnknownOrNullableType();
	                case 89 /* FunctionKeyword */:
	                    return parseJSDocFunctionType();
	                case 51 /* ExclamationToken */:
	                    return parseJSDocNonNullableType();
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                    return parseLiteralTypeNode();
	                case 38 /* MinusToken */:
	                    return lookAhead(nextTokenIsNumericLiteral) ? parseLiteralTypeNode(/*negative*/ true) : parseTypeReference();
	                case 105 /* VoidKeyword */:
	                case 95 /* NullKeyword */:
	                    return parseTokenNode();
	                case 99 /* ThisKeyword */: {
	                    var thisKeyword = parseThisTypeNode();
	                    if (token() === 127 /* IsKeyword */ && !scanner.hasPrecedingLineBreak()) {
	                        return parseThisTypePredicate(thisKeyword);
	                    }
	                    else {
	                        return thisKeyword;
	                    }
	                }
	                case 103 /* TypeOfKeyword */:
	                    return lookAhead(isStartOfTypeOfImportType) ? parseImportType() : parseTypeQuery();
	                case 17 /* OpenBraceToken */:
	                    return lookAhead(isStartOfMappedType) ? parseMappedType() : parseTypeLiteral();
	                case 21 /* OpenBracketToken */:
	                    return parseTupleType();
	                case 19 /* OpenParenToken */:
	                    return parseParenthesizedType();
	                case 91 /* ImportKeyword */:
	                    return parseImportType();
	                default:
	                    return parseTypeReference();
	            }
	        }
	        function isStartOfType(inStartOfParameter) {
	            switch (token()) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 141 /* UniqueKeyword */:
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 99 /* ThisKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 131 /* NeverKeyword */:
	                case 17 /* OpenBraceToken */:
	                case 21 /* OpenBracketToken */:
	                case 27 /* LessThanToken */:
	                case 49 /* BarToken */:
	                case 48 /* AmpersandToken */:
	                case 94 /* NewKeyword */:
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 135 /* ObjectKeyword */:
	                case 39 /* AsteriskToken */:
	                case 55 /* QuestionToken */:
	                case 51 /* ExclamationToken */:
	                case 24 /* DotDotDotToken */:
	                case 126 /* InferKeyword */:
	                case 91 /* ImportKeyword */:
	                    return true;
	                case 38 /* MinusToken */:
	                    return !inStartOfParameter && lookAhead(nextTokenIsNumericLiteral);
	                case 19 /* OpenParenToken */:
	                    // Only consider '(' the start of a type if followed by ')', '...', an identifier, a modifier,
	                    // or something that starts a type. We don't want to consider things like '(1)' a type.
	                    return !inStartOfParameter && lookAhead(isStartOfParenthesizedOrFunctionType);
	                default:
	                    return isIdentifier();
	            }
	        }
	        function isStartOfParenthesizedOrFunctionType() {
	            nextToken();
	            return token() === 20 /* CloseParenToken */ || isStartOfParameter() || isStartOfType();
	        }
	        function parsePostfixTypeOrHigher() {
	            var type = parseNonArrayType();
	            while (!scanner.hasPrecedingLineBreak()) {
	                switch (token()) {
	                    case 51 /* ExclamationToken */:
	                        type = createJSDocPostfixType(281 /* JSDocNonNullableType */, type);
	                        break;
	                    case 55 /* QuestionToken */:
	                        // If not in JSDoc and next token is start of a type we have a conditional type
	                        if (!(contextFlags & 2097152 /* JSDoc */) && lookAhead(nextTokenIsStartOfType)) {
	                            return type;
	                        }
	                        type = createJSDocPostfixType(280 /* JSDocNullableType */, type);
	                        break;
	                    case 21 /* OpenBracketToken */:
	                        parseExpected(21 /* OpenBracketToken */);
	                        if (isStartOfType()) {
	                            var node = createNode(175 /* IndexedAccessType */, type.pos);
	                            node.objectType = type;
	                            node.indexType = parseType();
	                            parseExpected(22 /* CloseBracketToken */);
	                            type = finishNode(node);
	                        }
	                        else {
	                            var node = createNode(166 /* ArrayType */, type.pos);
	                            node.elementType = type;
	                            parseExpected(22 /* CloseBracketToken */);
	                            type = finishNode(node);
	                        }
	                        break;
	                    default:
	                        return type;
	                }
	            }
	            return type;
	        }
	        function createJSDocPostfixType(kind, type) {
	            nextToken();
	            var postfix = createNode(kind, type.pos);
	            postfix.type = type;
	            return finishNode(postfix);
	        }
	        function parseTypeOperator(operator) {
	            var node = createNode(174 /* TypeOperator */);
	            parseExpected(operator);
	            node.operator = operator;
	            node.type = parseTypeOperatorOrHigher();
	            return finishNode(node);
	        }
	        function parseInferType() {
	            var node = createNode(171 /* InferType */);
	            parseExpected(126 /* InferKeyword */);
	            var typeParameter = createNode(147 /* TypeParameter */);
	            typeParameter.name = parseIdentifier();
	            node.typeParameter = finishNode(typeParameter);
	            return finishNode(node);
	        }
	        function parseTypeOperatorOrHigher() {
	            var operator = token();
	            switch (operator) {
	                case 128 /* KeyOfKeyword */:
	                case 141 /* UniqueKeyword */:
	                    return parseTypeOperator(operator);
	                case 126 /* InferKeyword */:
	                    return parseInferType();
	            }
	            return parsePostfixTypeOrHigher();
	        }
	        function parseUnionOrIntersectionType(kind, parseConstituentType, operator) {
	            parseOptional(operator);
	            var type = parseConstituentType();
	            if (token() === operator) {
	                var types = [type];
	                while (parseOptional(operator)) {
	                    types.push(parseConstituentType());
	                }
	                var node = createNode(kind, type.pos);
	                node.types = createNodeArray(types, type.pos);
	                type = finishNode(node);
	            }
	            return type;
	        }
	        function parseIntersectionTypeOrHigher() {
	            return parseUnionOrIntersectionType(169 /* IntersectionType */, parseTypeOperatorOrHigher, 48 /* AmpersandToken */);
	        }
	        function parseUnionTypeOrHigher() {
	            return parseUnionOrIntersectionType(168 /* UnionType */, parseIntersectionTypeOrHigher, 49 /* BarToken */);
	        }
	        function isStartOfFunctionType() {
	            if (token() === 27 /* LessThanToken */) {
	                return true;
	            }
	            return token() === 19 /* OpenParenToken */ && lookAhead(isUnambiguouslyStartOfFunctionType);
	        }
	        function skipParameterStart() {
	            if (ts.isModifierKind(token())) {
	                // Skip modifiers
	                parseModifiers();
	            }
	            if (isIdentifier() || token() === 99 /* ThisKeyword */) {
	                nextToken();
	                return true;
	            }
	            if (token() === 21 /* OpenBracketToken */ || token() === 17 /* OpenBraceToken */) {
	                // Return true if we can parse an array or object binding pattern with no errors
	                var previousErrorCount = parseDiagnostics.length;
	                parseIdentifierOrPattern();
	                return previousErrorCount === parseDiagnostics.length;
	            }
	            return false;
	        }
	        function isUnambiguouslyStartOfFunctionType() {
	            nextToken();
	            if (token() === 20 /* CloseParenToken */ || token() === 24 /* DotDotDotToken */) {
	                // ( )
	                // ( ...
	                return true;
	            }
	            if (skipParameterStart()) {
	                // We successfully skipped modifiers (if any) and an identifier or binding pattern,
	                // now see if we have something that indicates a parameter declaration
	                if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ ||
	                    token() === 55 /* QuestionToken */ || token() === 58 /* EqualsToken */) {
	                    // ( xxx :
	                    // ( xxx ,
	                    // ( xxx ?
	                    // ( xxx =
	                    return true;
	                }
	                if (token() === 20 /* CloseParenToken */) {
	                    nextToken();
	                    if (token() === 36 /* EqualsGreaterThanToken */) {
	                        // ( xxx ) =>
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function parseTypeOrTypePredicate() {
	            var typePredicateVariable = isIdentifier() && tryParse(parseTypePredicatePrefix);
	            var type = parseType();
	            if (typePredicateVariable) {
	                var node = createNode(160 /* TypePredicate */, typePredicateVariable.pos);
	                node.parameterName = typePredicateVariable;
	                node.type = type;
	                return finishNode(node);
	            }
	            else {
	                return type;
	            }
	        }
	        function parseTypePredicatePrefix() {
	            var id = parseIdentifier();
	            if (token() === 127 /* IsKeyword */ && !scanner.hasPrecedingLineBreak()) {
	                nextToken();
	                return id;
	            }
	        }
	        function parseType() {
	            // The rules about 'yield' only apply to actual code/expression contexts.  They don't
	            // apply to 'type' contexts.  So we disable these parameters here before moving on.
	            return doOutsideOfContext(20480 /* TypeExcludesFlags */, parseTypeWorker);
	        }
	        function parseTypeWorker(noConditionalTypes) {
	            if (isStartOfFunctionType() || token() === 94 /* NewKeyword */) {
	                return parseFunctionOrConstructorType();
	            }
	            var type = parseUnionTypeOrHigher();
	            if (!noConditionalTypes && !scanner.hasPrecedingLineBreak() && parseOptional(85 /* ExtendsKeyword */)) {
	                var node = createNode(170 /* ConditionalType */, type.pos);
	                node.checkType = type;
	                // The type following 'extends' is not permitted to be another conditional type
	                node.extendsType = parseTypeWorker(/*noConditionalTypes*/ true);
	                parseExpected(55 /* QuestionToken */);
	                node.trueType = parseTypeWorker();
	                parseExpected(56 /* ColonToken */);
	                node.falseType = parseTypeWorker();
	                return finishNode(node);
	            }
	            return type;
	        }
	        function parseTypeAnnotation() {
	            return parseOptional(56 /* ColonToken */) ? parseType() : undefined;
	        }
	        // EXPRESSIONS
	        function isStartOfLeftHandSideExpression() {
	            switch (token()) {
	                case 99 /* ThisKeyword */:
	                case 97 /* SuperKeyword */:
	                case 95 /* NullKeyword */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 14 /* TemplateHead */:
	                case 19 /* OpenParenToken */:
	                case 21 /* OpenBracketToken */:
	                case 17 /* OpenBraceToken */:
	                case 89 /* FunctionKeyword */:
	                case 75 /* ClassKeyword */:
	                case 94 /* NewKeyword */:
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                case 71 /* Identifier */:
	                    return true;
	                case 91 /* ImportKeyword */:
	                    return lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
	                default:
	                    return isIdentifier();
	            }
	        }
	        function isStartOfExpression() {
	            if (isStartOfLeftHandSideExpression()) {
	                return true;
	            }
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                case 80 /* DeleteKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 105 /* VoidKeyword */:
	                case 43 /* PlusPlusToken */:
	                case 44 /* MinusMinusToken */:
	                case 27 /* LessThanToken */:
	                case 121 /* AwaitKeyword */:
	                case 116 /* YieldKeyword */:
	                    // Yield/await always starts an expression.  Either it is an identifier (in which case
	                    // it is definitely an expression).  Or it's a keyword (either because we're in
	                    // a generator or async function, or in strict mode (or both)) and it started a yield or await expression.
	                    return true;
	                default:
	                    // Error tolerance.  If we see the start of some binary operator, we consider
	                    // that the start of an expression.  That way we'll parse out a missing identifier,
	                    // give a good message about an identifier being missing, and then consume the
	                    // rest of the binary expression.
	                    if (isBinaryOperator()) {
	                        return true;
	                    }
	                    return isIdentifier();
	            }
	        }
	        function isStartOfExpressionStatement() {
	            // As per the grammar, none of '{' or 'function' or 'class' can start an expression statement.
	            return token() !== 17 /* OpenBraceToken */ &&
	                token() !== 89 /* FunctionKeyword */ &&
	                token() !== 75 /* ClassKeyword */ &&
	                token() !== 57 /* AtToken */ &&
	                isStartOfExpression();
	        }
	        function parseExpression() {
	            // Expression[in]:
	            //      AssignmentExpression[in]
	            //      Expression[in] , AssignmentExpression[in]
	            // clear the decorator context when parsing Expression, as it should be unambiguous when parsing a decorator
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var expr = parseAssignmentExpressionOrHigher();
	            var operatorToken;
	            while ((operatorToken = parseOptionalToken(26 /* CommaToken */))) {
	                expr = makeBinaryExpression(expr, operatorToken, parseAssignmentExpressionOrHigher());
	            }
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            return expr;
	        }
	        function parseInitializer() {
	            return parseOptional(58 /* EqualsToken */) ? parseAssignmentExpressionOrHigher() : undefined;
	        }
	        function parseAssignmentExpressionOrHigher() {
	            //  AssignmentExpression[in,yield]:
	            //      1) ConditionalExpression[?in,?yield]
	            //      2) LeftHandSideExpression = AssignmentExpression[?in,?yield]
	            //      3) LeftHandSideExpression AssignmentOperator AssignmentExpression[?in,?yield]
	            //      4) ArrowFunctionExpression[?in,?yield]
	            //      5) AsyncArrowFunctionExpression[in,yield,await]
	            //      6) [+Yield] YieldExpression[?In]
	            //
	            // Note: for ease of implementation we treat productions '2' and '3' as the same thing.
	            // (i.e. they're both BinaryExpressions with an assignment operator in it).
	            // First, do the simple check if we have a YieldExpression (production '6').
	            if (isYieldExpression()) {
	                return parseYieldExpression();
	            }
	            // Then, check if we have an arrow function (production '4' and '5') that starts with a parenthesized
	            // parameter list or is an async arrow function.
	            // AsyncArrowFunctionExpression:
	            //      1) async[no LineTerminator here]AsyncArrowBindingIdentifier[?Yield][no LineTerminator here]=>AsyncConciseBody[?In]
	            //      2) CoverCallExpressionAndAsyncArrowHead[?Yield, ?Await][no LineTerminator here]=>AsyncConciseBody[?In]
	            // Production (1) of AsyncArrowFunctionExpression is parsed in "tryParseAsyncSimpleArrowFunctionExpression".
	            // And production (2) is parsed in "tryParseParenthesizedArrowFunctionExpression".
	            //
	            // If we do successfully parse arrow-function, we must *not* recurse for productions 1, 2 or 3. An ArrowFunction is
	            // not a LeftHandSideExpression, nor does it start a ConditionalExpression.  So we are done
	            // with AssignmentExpression if we see one.
	            var arrowExpression = tryParseParenthesizedArrowFunctionExpression() || tryParseAsyncSimpleArrowFunctionExpression();
	            if (arrowExpression) {
	                return arrowExpression;
	            }
	            // Now try to see if we're in production '1', '2' or '3'.  A conditional expression can
	            // start with a LogicalOrExpression, while the assignment productions can only start with
	            // LeftHandSideExpressions.
	            //
	            // So, first, we try to just parse out a BinaryExpression.  If we get something that is a
	            // LeftHandSide or higher, then we can try to parse out the assignment expression part.
	            // Otherwise, we try to parse out the conditional expression bit.  We want to allow any
	            // binary expression here, so we pass in the 'lowest' precedence here so that it matches
	            // and consumes anything.
	            var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	            // To avoid a look-ahead, we did not handle the case of an arrow function with a single un-parenthesized
	            // parameter ('x => ...') above. We handle it here by checking if the parsed expression was a single
	            // identifier and the current token is an arrow.
	            if (expr.kind === 71 /* Identifier */ && token() === 36 /* EqualsGreaterThanToken */) {
	                return parseSimpleArrowFunctionExpression(expr);
	            }
	            // Now see if we might be in cases '2' or '3'.
	            // If the expression was a LHS expression, and we have an assignment operator, then
	            // we're in '2' or '3'. Consume the assignment and return.
	            //
	            // Note: we call reScanGreaterToken so that we get an appropriately merged token
	            // for cases like `> > =` becoming `>>=`
	            if (ts.isLeftHandSideExpression(expr) && ts.isAssignmentOperator(reScanGreaterToken())) {
	                return makeBinaryExpression(expr, parseTokenNode(), parseAssignmentExpressionOrHigher());
	            }
	            // It wasn't an assignment or a lambda.  This is a conditional expression:
	            return parseConditionalExpressionRest(expr);
	        }
	        function isYieldExpression() {
	            if (token() === 116 /* YieldKeyword */) {
	                // If we have a 'yield' keyword, and this is a context where yield expressions are
	                // allowed, then definitely parse out a yield expression.
	                if (inYieldContext()) {
	                    return true;
	                }
	                // We're in a context where 'yield expr' is not allowed.  However, if we can
	                // definitely tell that the user was trying to parse a 'yield expr' and not
	                // just a normal expr that start with a 'yield' identifier, then parse out
	                // a 'yield expr'.  We can then report an error later that they are only
	                // allowed in generator expressions.
	                //
	                // for example, if we see 'yield(foo)', then we'll have to treat that as an
	                // invocation expression of something called 'yield'.  However, if we have
	                // 'yield foo' then that is not legal as a normal expression, so we can
	                // definitely recognize this as a yield expression.
	                //
	                // for now we just check if the next token is an identifier.  More heuristics
	                // can be added here later as necessary.  We just need to make sure that we
	                // don't accidentally consume something legal.
	                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
	            }
	            return false;
	        }
	        function nextTokenIsIdentifierOnSameLine() {
	            nextToken();
	            return !scanner.hasPrecedingLineBreak() && isIdentifier();
	        }
	        function parseYieldExpression() {
	            var node = createNode(202 /* YieldExpression */);
	            // YieldExpression[In] :
	            //      yield
	            //      yield [no LineTerminator here] [Lexical goal InputElementRegExp]AssignmentExpression[?In, Yield]
	            //      yield [no LineTerminator here] * [Lexical goal InputElementRegExp]AssignmentExpression[?In, Yield]
	            nextToken();
	            if (!scanner.hasPrecedingLineBreak() &&
	                (token() === 39 /* AsteriskToken */ || isStartOfExpression())) {
	                node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	                node.expression = parseAssignmentExpressionOrHigher();
	                return finishNode(node);
	            }
	            else {
	                // if the next token is not on the same line as yield.  or we don't have an '*' or
	                // the start of an expression, then this is just a simple "yield" expression.
	                return finishNode(node);
	            }
	        }
	        function parseSimpleArrowFunctionExpression(identifier, asyncModifier) {
	            ts.Debug.assert(token() === 36 /* EqualsGreaterThanToken */, "parseSimpleArrowFunctionExpression should only have been called if we had a =>");
	            var node;
	            if (asyncModifier) {
	                node = createNode(192 /* ArrowFunction */, asyncModifier.pos);
	                node.modifiers = asyncModifier;
	            }
	            else {
	                node = createNode(192 /* ArrowFunction */, identifier.pos);
	            }
	            var parameter = createNode(148 /* Parameter */, identifier.pos);
	            parameter.name = identifier;
	            finishNode(parameter);
	            node.parameters = createNodeArray([parameter], parameter.pos, parameter.end);
	            node.equalsGreaterThanToken = parseExpectedToken(36 /* EqualsGreaterThanToken */);
	            node.body = parseArrowFunctionExpressionBody(/*isAsync*/ !!asyncModifier);
	            return addJSDocComment(finishNode(node));
	        }
	        function tryParseParenthesizedArrowFunctionExpression() {
	            var triState = isParenthesizedArrowFunctionExpression();
	            if (triState === 0 /* False */) {
	                // It's definitely not a parenthesized arrow function expression.
	                return undefined;
	            }
	            // If we definitely have an arrow function, then we can just parse one, not requiring a
	            // following => or { token. Otherwise, we *might* have an arrow function.  Try to parse
	            // it out, but don't allow any ambiguity, and return 'undefined' if this could be an
	            // expression instead.
	            var arrowFunction = triState === 1 /* True */
	                ? parseParenthesizedArrowFunctionExpressionHead(/*allowAmbiguity*/ true)
	                : tryParse(parsePossibleParenthesizedArrowFunctionExpressionHead);
	            if (!arrowFunction) {
	                // Didn't appear to actually be a parenthesized arrow function.  Just bail out.
	                return undefined;
	            }
	            var isAsync = ts.hasModifier(arrowFunction, 256 /* Async */);
	            // If we have an arrow, then try to parse the body. Even if not, try to parse if we
	            // have an opening brace, just in case we're in an error state.
	            var lastToken = token();
	            arrowFunction.equalsGreaterThanToken = parseExpectedToken(36 /* EqualsGreaterThanToken */);
	            arrowFunction.body = (lastToken === 36 /* EqualsGreaterThanToken */ || lastToken === 17 /* OpenBraceToken */)
	                ? parseArrowFunctionExpressionBody(isAsync)
	                : parseIdentifier();
	            return finishNode(arrowFunction);
	        }
	        //  True        -> We definitely expect a parenthesized arrow function here.
	        //  False       -> There *cannot* be a parenthesized arrow function here.
	        //  Unknown     -> There *might* be a parenthesized arrow function here.
	        //                 Speculatively look ahead to be sure, and rollback if not.
	        function isParenthesizedArrowFunctionExpression() {
	            if (token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */ || token() === 120 /* AsyncKeyword */) {
	                return lookAhead(isParenthesizedArrowFunctionExpressionWorker);
	            }
	            if (token() === 36 /* EqualsGreaterThanToken */) {
	                // ERROR RECOVERY TWEAK:
	                // If we see a standalone => try to parse it as an arrow function expression as that's
	                // likely what the user intended to write.
	                return 1 /* True */;
	            }
	            // Definitely not a parenthesized arrow function.
	            return 0 /* False */;
	        }
	        function isParenthesizedArrowFunctionExpressionWorker() {
	            if (token() === 120 /* AsyncKeyword */) {
	                nextToken();
	                if (scanner.hasPrecedingLineBreak()) {
	                    return 0 /* False */;
	                }
	                if (token() !== 19 /* OpenParenToken */ && token() !== 27 /* LessThanToken */) {
	                    return 0 /* False */;
	                }
	            }
	            var first = token();
	            var second = nextToken();
	            if (first === 19 /* OpenParenToken */) {
	                if (second === 20 /* CloseParenToken */) {
	                    // Simple cases: "() =>", "(): ", and "() {".
	                    // This is an arrow function with no parameters.
	                    // The last one is not actually an arrow function,
	                    // but this is probably what the user intended.
	                    var third = nextToken();
	                    switch (third) {
	                        case 36 /* EqualsGreaterThanToken */:
	                        case 56 /* ColonToken */:
	                        case 17 /* OpenBraceToken */:
	                            return 1 /* True */;
	                        default:
	                            return 0 /* False */;
	                    }
	                }
	                // If encounter "([" or "({", this could be the start of a binding pattern.
	                // Examples:
	                //      ([ x ]) => { }
	                //      ({ x }) => { }
	                //      ([ x ])
	                //      ({ x })
	                if (second === 21 /* OpenBracketToken */ || second === 17 /* OpenBraceToken */) {
	                    return 2 /* Unknown */;
	                }
	                // Simple case: "(..."
	                // This is an arrow function with a rest parameter.
	                if (second === 24 /* DotDotDotToken */) {
	                    return 1 /* True */;
	                }
	                // Check for "(xxx yyy", where xxx is a modifier and yyy is an identifier. This
	                // isn't actually allowed, but we want to treat it as a lambda so we can provide
	                // a good error message.
	                if (ts.isModifierKind(second) && second !== 120 /* AsyncKeyword */ && lookAhead(nextTokenIsIdentifier)) {
	                    return 1 /* True */;
	                }
	                // If we had "(" followed by something that's not an identifier,
	                // then this definitely doesn't look like a lambda.
	                if (!isIdentifier()) {
	                    return 0 /* False */;
	                }
	                switch (nextToken()) {
	                    case 56 /* ColonToken */:
	                        // If we have something like "(a:", then we must have a
	                        // type-annotated parameter in an arrow function expression.
	                        return 1 /* True */;
	                    case 55 /* QuestionToken */:
	                        nextToken();
	                        // If we have "(a?:" or "(a?," or "(a?=" or "(a?)" then it is definitely a lambda.
	                        if (token() === 56 /* ColonToken */ || token() === 26 /* CommaToken */ || token() === 58 /* EqualsToken */ || token() === 20 /* CloseParenToken */) {
	                            return 1 /* True */;
	                        }
	                        // Otherwise it is definitely not a lambda.
	                        return 0 /* False */;
	                    case 26 /* CommaToken */:
	                    case 58 /* EqualsToken */:
	                    case 20 /* CloseParenToken */:
	                        // If we have "(a," or "(a=" or "(a)" this *could* be an arrow function
	                        return 2 /* Unknown */;
	                }
	                // It is definitely not an arrow function
	                return 0 /* False */;
	            }
	            else {
	                ts.Debug.assert(first === 27 /* LessThanToken */);
	                // If we have "<" not followed by an identifier,
	                // then this definitely is not an arrow function.
	                if (!isIdentifier()) {
	                    return 0 /* False */;
	                }
	                // JSX overrides
	                if (sourceFile.languageVariant === 1 /* JSX */) {
	                    var isArrowFunctionInJsx = lookAhead(function () {
	                        var third = nextToken();
	                        if (third === 85 /* ExtendsKeyword */) {
	                            var fourth = nextToken();
	                            switch (fourth) {
	                                case 58 /* EqualsToken */:
	                                case 29 /* GreaterThanToken */:
	                                    return false;
	                                default:
	                                    return true;
	                            }
	                        }
	                        else if (third === 26 /* CommaToken */) {
	                            return true;
	                        }
	                        return false;
	                    });
	                    if (isArrowFunctionInJsx) {
	                        return 1 /* True */;
	                    }
	                    return 0 /* False */;
	                }
	                // This *could* be a parenthesized arrow function.
	                return 2 /* Unknown */;
	            }
	        }
	        function parsePossibleParenthesizedArrowFunctionExpressionHead() {
	            return parseParenthesizedArrowFunctionExpressionHead(/*allowAmbiguity*/ false);
	        }
	        function tryParseAsyncSimpleArrowFunctionExpression() {
	            // We do a check here so that we won't be doing unnecessarily call to "lookAhead"
	            if (token() === 120 /* AsyncKeyword */) {
	                if (lookAhead(isUnParenthesizedAsyncArrowFunctionWorker) === 1 /* True */) {
	                    var asyncModifier = parseModifiersForArrowFunction();
	                    var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	                    return parseSimpleArrowFunctionExpression(expr, asyncModifier);
	                }
	            }
	            return undefined;
	        }
	        function isUnParenthesizedAsyncArrowFunctionWorker() {
	            // AsyncArrowFunctionExpression:
	            //      1) async[no LineTerminator here]AsyncArrowBindingIdentifier[?Yield][no LineTerminator here]=>AsyncConciseBody[?In]
	            //      2) CoverCallExpressionAndAsyncArrowHead[?Yield, ?Await][no LineTerminator here]=>AsyncConciseBody[?In]
	            if (token() === 120 /* AsyncKeyword */) {
	                nextToken();
	                // If the "async" is followed by "=>" token then it is not a beginning of an async arrow-function
	                // but instead a simple arrow-function which will be parsed inside "parseAssignmentExpressionOrHigher"
	                if (scanner.hasPrecedingLineBreak() || token() === 36 /* EqualsGreaterThanToken */) {
	                    return 0 /* False */;
	                }
	                // Check for un-parenthesized AsyncArrowFunction
	                var expr = parseBinaryExpressionOrHigher(/*precedence*/ 0);
	                if (!scanner.hasPrecedingLineBreak() && expr.kind === 71 /* Identifier */ && token() === 36 /* EqualsGreaterThanToken */) {
	                    return 1 /* True */;
	                }
	            }
	            return 0 /* False */;
	        }
	        function parseParenthesizedArrowFunctionExpressionHead(allowAmbiguity) {
	            var node = createNodeWithJSDoc(192 /* ArrowFunction */);
	            node.modifiers = parseModifiersForArrowFunction();
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            // Arrow functions are never generators.
	            //
	            // If we're speculatively parsing a signature for a parenthesized arrow function, then
	            // we have to have a complete parameter list.  Otherwise we might see something like
	            // a => (b => c)
	            // And think that "(b =>" was actually a parenthesized arrow function with a missing
	            // close paren.
	            if (!fillSignature(56 /* ColonToken */, isAsync, node) && !allowAmbiguity) {
	                return undefined;
	            }
	            // Parsing a signature isn't enough.
	            // Parenthesized arrow signatures often look like other valid expressions.
	            // For instance:
	            //  - "(x = 10)" is an assignment expression parsed as a signature with a default parameter value.
	            //  - "(x,y)" is a comma expression parsed as a signature with two parameters.
	            //  - "a ? (b): c" will have "(b):" parsed as a signature with a return type annotation.
	            //
	            // So we need just a bit of lookahead to ensure that it can only be a signature.
	            if (!allowAmbiguity && token() !== 36 /* EqualsGreaterThanToken */ && token() !== 17 /* OpenBraceToken */) {
	                // Returning undefined here will cause our caller to rewind to where we started from.
	                return undefined;
	            }
	            return node;
	        }
	        function parseArrowFunctionExpressionBody(isAsync) {
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseFunctionBlock(isAsync ? 2 /* Await */ : 0 /* None */);
	            }
	            if (token() !== 25 /* SemicolonToken */ &&
	                token() !== 89 /* FunctionKeyword */ &&
	                token() !== 75 /* ClassKeyword */ &&
	                isStartOfStatement() &&
	                !isStartOfExpressionStatement()) {
	                // Check if we got a plain statement (i.e. no expression-statements, no function/class expressions/declarations)
	                //
	                // Here we try to recover from a potential error situation in the case where the
	                // user meant to supply a block. For example, if the user wrote:
	                //
	                //  a =>
	                //      let v = 0;
	                //  }
	                //
	                // they may be missing an open brace.  Check to see if that's the case so we can
	                // try to recover better.  If we don't do this, then the next close curly we see may end
	                // up preemptively closing the containing construct.
	                //
	                // Note: even when 'IgnoreMissingOpenBrace' is passed, parseBody will still error.
	                return parseFunctionBlock(16 /* IgnoreMissingOpenBrace */ | (isAsync ? 2 /* Await */ : 0 /* None */));
	            }
	            return isAsync
	                ? doInAwaitContext(parseAssignmentExpressionOrHigher)
	                : doOutsideOfAwaitContext(parseAssignmentExpressionOrHigher);
	        }
	        function parseConditionalExpressionRest(leftOperand) {
	            // Note: we are passed in an expression which was produced from parseBinaryExpressionOrHigher.
	            var questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (!questionToken) {
	                return leftOperand;
	            }
	            // Note: we explicitly 'allowIn' in the whenTrue part of the condition expression, and
	            // we do not that for the 'whenFalse' part.
	            var node = createNode(200 /* ConditionalExpression */, leftOperand.pos);
	            node.condition = leftOperand;
	            node.questionToken = questionToken;
	            node.whenTrue = doOutsideOfContext(disallowInAndDecoratorContext, parseAssignmentExpressionOrHigher);
	            node.colonToken = parseExpectedToken(56 /* ColonToken */);
	            node.whenFalse = ts.nodeIsPresent(node.colonToken)
	                ? parseAssignmentExpressionOrHigher()
	                : createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ false, ts.Diagnostics._0_expected, ts.tokenToString(56 /* ColonToken */));
	            return finishNode(node);
	        }
	        function parseBinaryExpressionOrHigher(precedence) {
	            var leftOperand = parseUnaryExpressionOrHigher();
	            return parseBinaryExpressionRest(precedence, leftOperand);
	        }
	        function isInOrOfKeyword(t) {
	            return t === 92 /* InKeyword */ || t === 144 /* OfKeyword */;
	        }
	        function parseBinaryExpressionRest(precedence, leftOperand) {
	            while (true) {
	                // We either have a binary operator here, or we're finished.  We call
	                // reScanGreaterToken so that we merge token sequences like > and = into >=
	                reScanGreaterToken();
	                var newPrecedence = ts.getBinaryOperatorPrecedence(token());
	                // Check the precedence to see if we should "take" this operator
	                // - For left associative operator (all operator but **), consume the operator,
	                //   recursively call the function below, and parse binaryExpression as a rightOperand
	                //   of the caller if the new precedence of the operator is greater then or equal to the current precedence.
	                //   For example:
	                //      a - b - c;
	                //            ^token; leftOperand = b. Return b to the caller as a rightOperand
	                //      a * b - c
	                //            ^token; leftOperand = b. Return b to the caller as a rightOperand
	                //      a - b * c;
	                //            ^token; leftOperand = b. Return b * c to the caller as a rightOperand
	                // - For right associative operator (**), consume the operator, recursively call the function
	                //   and parse binaryExpression as a rightOperand of the caller if the new precedence of
	                //   the operator is strictly grater than the current precedence
	                //   For example:
	                //      a ** b ** c;
	                //             ^^token; leftOperand = b. Return b ** c to the caller as a rightOperand
	                //      a - b ** c;
	                //            ^^token; leftOperand = b. Return b ** c to the caller as a rightOperand
	                //      a ** b - c
	                //             ^token; leftOperand = b. Return b to the caller as a rightOperand
	                var consumeCurrentOperator = token() === 40 /* AsteriskAsteriskToken */ ?
	                    newPrecedence >= precedence :
	                    newPrecedence > precedence;
	                if (!consumeCurrentOperator) {
	                    break;
	                }
	                if (token() === 92 /* InKeyword */ && inDisallowInContext()) {
	                    break;
	                }
	                if (token() === 118 /* AsKeyword */) {
	                    // Make sure we *do* perform ASI for constructs like this:
	                    //    var x = foo
	                    //    as (Bar)
	                    // This should be parsed as an initialized variable, followed
	                    // by a function call to 'as' with the argument 'Bar'
	                    if (scanner.hasPrecedingLineBreak()) {
	                        break;
	                    }
	                    else {
	                        nextToken();
	                        leftOperand = makeAsExpression(leftOperand, parseType());
	                    }
	                }
	                else {
	                    leftOperand = makeBinaryExpression(leftOperand, parseTokenNode(), parseBinaryExpressionOrHigher(newPrecedence));
	                }
	            }
	            return leftOperand;
	        }
	        function isBinaryOperator() {
	            if (inDisallowInContext() && token() === 92 /* InKeyword */) {
	                return false;
	            }
	            return ts.getBinaryOperatorPrecedence(token()) > 0;
	        }
	        function makeBinaryExpression(left, operatorToken, right) {
	            var node = createNode(199 /* BinaryExpression */, left.pos);
	            node.left = left;
	            node.operatorToken = operatorToken;
	            node.right = right;
	            return finishNode(node);
	        }
	        function makeAsExpression(left, right) {
	            var node = createNode(207 /* AsExpression */, left.pos);
	            node.expression = left;
	            node.type = right;
	            return finishNode(node);
	        }
	        function parsePrefixUnaryExpression() {
	            var node = createNode(197 /* PrefixUnaryExpression */);
	            node.operator = token();
	            nextToken();
	            node.operand = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseDeleteExpression() {
	            var node = createNode(193 /* DeleteExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseTypeOfExpression() {
	            var node = createNode(194 /* TypeOfExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseVoidExpression() {
	            var node = createNode(195 /* VoidExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function isAwaitExpression() {
	            if (token() === 121 /* AwaitKeyword */) {
	                if (inAwaitContext()) {
	                    return true;
	                }
	                // here we are using similar heuristics as 'isYieldExpression'
	                return lookAhead(nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine);
	            }
	            return false;
	        }
	        function parseAwaitExpression() {
	            var node = createNode(196 /* AwaitExpression */);
	            nextToken();
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        /**
	         * Parse ES7 exponential expression and await expression
	         *
	         * ES7 ExponentiationExpression:
	         *      1) UnaryExpression[?Yield]
	         *      2) UpdateExpression[?Yield] ** ExponentiationExpression[?Yield]
	         *
	         */
	        function parseUnaryExpressionOrHigher() {
	            /**
	             * ES7 UpdateExpression:
	             *      1) LeftHandSideExpression[?Yield]
	             *      2) LeftHandSideExpression[?Yield][no LineTerminator here]++
	             *      3) LeftHandSideExpression[?Yield][no LineTerminator here]--
	             *      4) ++UnaryExpression[?Yield]
	             *      5) --UnaryExpression[?Yield]
	             */
	            if (isUpdateExpression()) {
	                var updateExpression = parseUpdateExpression();
	                return token() === 40 /* AsteriskAsteriskToken */ ?
	                    parseBinaryExpressionRest(ts.getBinaryOperatorPrecedence(token()), updateExpression) :
	                    updateExpression;
	            }
	            /**
	             * ES7 UnaryExpression:
	             *      1) UpdateExpression[?yield]
	             *      2) delete UpdateExpression[?yield]
	             *      3) void UpdateExpression[?yield]
	             *      4) typeof UpdateExpression[?yield]
	             *      5) + UpdateExpression[?yield]
	             *      6) - UpdateExpression[?yield]
	             *      7) ~ UpdateExpression[?yield]
	             *      8) ! UpdateExpression[?yield]
	             */
	            var unaryOperator = token();
	            var simpleUnaryExpression = parseSimpleUnaryExpression();
	            if (token() === 40 /* AsteriskAsteriskToken */) {
	                var pos = ts.skipTrivia(sourceText, simpleUnaryExpression.pos);
	                var end = simpleUnaryExpression.end;
	                if (simpleUnaryExpression.kind === 189 /* TypeAssertionExpression */) {
	                    parseErrorAt(pos, end, ts.Diagnostics.A_type_assertion_expression_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses);
	                }
	                else {
	                    parseErrorAt(pos, end, ts.Diagnostics.An_unary_expression_with_the_0_operator_is_not_allowed_in_the_left_hand_side_of_an_exponentiation_expression_Consider_enclosing_the_expression_in_parentheses, ts.tokenToString(unaryOperator));
	                }
	            }
	            return simpleUnaryExpression;
	        }
	        /**
	         * Parse ES7 simple-unary expression or higher:
	         *
	         * ES7 UnaryExpression:
	         *      1) UpdateExpression[?yield]
	         *      2) delete UnaryExpression[?yield]
	         *      3) void UnaryExpression[?yield]
	         *      4) typeof UnaryExpression[?yield]
	         *      5) + UnaryExpression[?yield]
	         *      6) - UnaryExpression[?yield]
	         *      7) ~ UnaryExpression[?yield]
	         *      8) ! UnaryExpression[?yield]
	         *      9) [+Await] await UnaryExpression[?yield]
	         */
	        function parseSimpleUnaryExpression() {
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                    return parsePrefixUnaryExpression();
	                case 80 /* DeleteKeyword */:
	                    return parseDeleteExpression();
	                case 103 /* TypeOfKeyword */:
	                    return parseTypeOfExpression();
	                case 105 /* VoidKeyword */:
	                    return parseVoidExpression();
	                case 27 /* LessThanToken */:
	                    // This is modified UnaryExpression grammar in TypeScript
	                    //  UnaryExpression (modified):
	                    //      < type > UnaryExpression
	                    return parseTypeAssertion();
	                case 121 /* AwaitKeyword */:
	                    if (isAwaitExpression()) {
	                        return parseAwaitExpression();
	                    }
	                // falls through
	                default:
	                    return parseUpdateExpression();
	            }
	        }
	        /**
	         * Check if the current token can possibly be an ES7 increment expression.
	         *
	         * ES7 UpdateExpression:
	         *      LeftHandSideExpression[?Yield]
	         *      LeftHandSideExpression[?Yield][no LineTerminator here]++
	         *      LeftHandSideExpression[?Yield][no LineTerminator here]--
	         *      ++LeftHandSideExpression[?Yield]
	         *      --LeftHandSideExpression[?Yield]
	         */
	        function isUpdateExpression() {
	            // This function is called inside parseUnaryExpression to decide
	            // whether to call parseSimpleUnaryExpression or call parseUpdateExpression directly
	            switch (token()) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                case 51 /* ExclamationToken */:
	                case 80 /* DeleteKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 105 /* VoidKeyword */:
	                case 121 /* AwaitKeyword */:
	                    return false;
	                case 27 /* LessThanToken */:
	                    // If we are not in JSX context, we are parsing TypeAssertion which is an UnaryExpression
	                    if (sourceFile.languageVariant !== 1 /* JSX */) {
	                        return false;
	                    }
	                // We are in JSX context and the token is part of JSXElement.
	                // falls through
	                default:
	                    return true;
	            }
	        }
	        /**
	         * Parse ES7 UpdateExpression. UpdateExpression is used instead of ES6's PostFixExpression.
	         *
	         * ES7 UpdateExpression[yield]:
	         *      1) LeftHandSideExpression[?yield]
	         *      2) LeftHandSideExpression[?yield] [[no LineTerminator here]]++
	         *      3) LeftHandSideExpression[?yield] [[no LineTerminator here]]--
	         *      4) ++LeftHandSideExpression[?yield]
	         *      5) --LeftHandSideExpression[?yield]
	         * In TypeScript (2), (3) are parsed as PostfixUnaryExpression. (4), (5) are parsed as PrefixUnaryExpression
	         */
	        function parseUpdateExpression() {
	            if (token() === 43 /* PlusPlusToken */ || token() === 44 /* MinusMinusToken */) {
	                var node = createNode(197 /* PrefixUnaryExpression */);
	                node.operator = token();
	                nextToken();
	                node.operand = parseLeftHandSideExpressionOrHigher();
	                return finishNode(node);
	            }
	            else if (sourceFile.languageVariant === 1 /* JSX */ && token() === 27 /* LessThanToken */ && lookAhead(nextTokenIsIdentifierOrKeywordOrGreaterThan)) {
	                // JSXElement is part of primaryExpression
	                return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true);
	            }
	            var expression = parseLeftHandSideExpressionOrHigher();
	            ts.Debug.assert(ts.isLeftHandSideExpression(expression));
	            if ((token() === 43 /* PlusPlusToken */ || token() === 44 /* MinusMinusToken */) && !scanner.hasPrecedingLineBreak()) {
	                var node = createNode(198 /* PostfixUnaryExpression */, expression.pos);
	                node.operand = expression;
	                node.operator = token();
	                nextToken();
	                return finishNode(node);
	            }
	            return expression;
	        }
	        function parseLeftHandSideExpressionOrHigher() {
	            // Original Ecma:
	            // LeftHandSideExpression: See 11.2
	            //      NewExpression
	            //      CallExpression
	            //
	            // Our simplification:
	            //
	            // LeftHandSideExpression: See 11.2
	            //      MemberExpression
	            //      CallExpression
	            //
	            // See comment in parseMemberExpressionOrHigher on how we replaced NewExpression with
	            // MemberExpression to make our lives easier.
	            //
	            // to best understand the below code, it's important to see how CallExpression expands
	            // out into its own productions:
	            //
	            // CallExpression:
	            //      MemberExpression Arguments
	            //      CallExpression Arguments
	            //      CallExpression[Expression]
	            //      CallExpression.IdentifierName
	            //      import (AssignmentExpression)
	            //      super Arguments
	            //      super.IdentifierName
	            //
	            // Because of the recursion in these calls, we need to bottom out first. There are three
	            // bottom out states we can run into: 1) We see 'super' which must start either of
	            // the last two CallExpression productions. 2) We see 'import' which must start import call.
	            // 3)we have a MemberExpression which either completes the LeftHandSideExpression,
	            // or starts the beginning of the first four CallExpression productions.
	            var expression;
	            if (token() === 91 /* ImportKeyword */) {
	                if (lookAhead(nextTokenIsOpenParenOrLessThan)) {
	                    // We don't want to eagerly consume all import keyword as import call expression so we look ahead to find "("
	                    // For example:
	                    //      var foo3 = require("subfolder
	                    //      import * as foo1 from "module-from-node
	                    // We want this import to be a statement rather than import call expression
	                    sourceFile.flags |= 524288 /* PossiblyContainsDynamicImport */;
	                    expression = parseTokenNode();
	                }
	                else if (lookAhead(nextTokenIsDot)) {
	                    // This is an 'import.*' metaproperty (i.e. 'import.meta')
	                    var fullStart = scanner.getStartPos();
	                    nextToken(); // advance past the 'import'
	                    nextToken(); // advance past the dot
	                    var node = createNode(209 /* MetaProperty */, fullStart);
	                    node.keywordToken = 91 /* ImportKeyword */;
	                    node.name = parseIdentifierName();
	                    expression = finishNode(node);
	                    sourceFile.flags |= 1048576 /* PossiblyContainsImportMeta */;
	                }
	                else {
	                    expression = parseMemberExpressionOrHigher();
	                }
	            }
	            else {
	                expression = token() === 97 /* SuperKeyword */ ? parseSuperExpression() : parseMemberExpressionOrHigher();
	            }
	            // Now, we *may* be complete.  However, we might have consumed the start of a
	            // CallExpression.  As such, we need to consume the rest of it here to be complete.
	            return parseCallExpressionRest(expression);
	        }
	        function parseMemberExpressionOrHigher() {
	            // Note: to make our lives simpler, we decompose the NewExpression productions and
	            // place ObjectCreationExpression and FunctionExpression into PrimaryExpression.
	            // like so:
	            //
	            //   PrimaryExpression : See 11.1
	            //      this
	            //      Identifier
	            //      Literal
	            //      ArrayLiteral
	            //      ObjectLiteral
	            //      (Expression)
	            //      FunctionExpression
	            //      new MemberExpression Arguments?
	            //
	            //   MemberExpression : See 11.2
	            //      PrimaryExpression
	            //      MemberExpression[Expression]
	            //      MemberExpression.IdentifierName
	            //
	            //   CallExpression : See 11.2
	            //      MemberExpression
	            //      CallExpression Arguments
	            //      CallExpression[Expression]
	            //      CallExpression.IdentifierName
	            //
	            // Technically this is ambiguous.  i.e. CallExpression defines:
	            //
	            //   CallExpression:
	            //      CallExpression Arguments
	            //
	            // If you see: "new Foo()"
	            //
	            // Then that could be treated as a single ObjectCreationExpression, or it could be
	            // treated as the invocation of "new Foo".  We disambiguate that in code (to match
	            // the original grammar) by making sure that if we see an ObjectCreationExpression
	            // we always consume arguments if they are there. So we treat "new Foo()" as an
	            // object creation only, and not at all as an invocation.  Another way to think
	            // about this is that for every "new" that we see, we will consume an argument list if
	            // it is there as part of the *associated* object creation node.  Any additional
	            // argument lists we see, will become invocation expressions.
	            //
	            // Because there are no other places in the grammar now that refer to FunctionExpression
	            // or ObjectCreationExpression, it is safe to push down into the PrimaryExpression
	            // production.
	            //
	            // Because CallExpression and MemberExpression are left recursive, we need to bottom out
	            // of the recursion immediately.  So we parse out a primary expression to start with.
	            var expression = parsePrimaryExpression();
	            return parseMemberExpressionRest(expression);
	        }
	        function parseSuperExpression() {
	            var expression = parseTokenNode();
	            if (token() === 19 /* OpenParenToken */ || token() === 23 /* DotToken */ || token() === 21 /* OpenBracketToken */) {
	                return expression;
	            }
	            // If we have seen "super" it must be followed by '(' or '.'.
	            // If it wasn't then just try to parse out a '.' and report an error.
	            var node = createNode(184 /* PropertyAccessExpression */, expression.pos);
	            node.expression = expression;
	            parseExpectedToken(23 /* DotToken */, ts.Diagnostics.super_must_be_followed_by_an_argument_list_or_member_access);
	            node.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	            return finishNode(node);
	        }
	        function tagNamesAreEquivalent(lhs, rhs) {
	            if (lhs.kind !== rhs.kind) {
	                return false;
	            }
	            if (lhs.kind === 71 /* Identifier */) {
	                return lhs.escapedText === rhs.escapedText;
	            }
	            if (lhs.kind === 99 /* ThisKeyword */) {
	                return true;
	            }
	            // If we are at this statement then we must have PropertyAccessExpression and because tag name in Jsx element can only
	            // take forms of JsxTagNameExpression which includes an identifier, "this" expression, or another propertyAccessExpression
	            // it is safe to case the expression property as such. See parseJsxElementName for how we parse tag name in Jsx element
	            return lhs.name.escapedText === rhs.name.escapedText &&
	                tagNamesAreEquivalent(lhs.expression, rhs.expression);
	        }
	        function parseJsxElementOrSelfClosingElementOrFragment(inExpressionContext) {
	            var opening = parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext);
	            var result;
	            if (opening.kind === 256 /* JsxOpeningElement */) {
	                var node = createNode(254 /* JsxElement */, opening.pos);
	                node.openingElement = opening;
	                node.children = parseJsxChildren(node.openingElement);
	                node.closingElement = parseJsxClosingElement(inExpressionContext);
	                if (!tagNamesAreEquivalent(node.openingElement.tagName, node.closingElement.tagName)) {
	                    parseErrorAtRange(node.closingElement, ts.Diagnostics.Expected_corresponding_JSX_closing_tag_for_0, ts.getTextOfNodeFromSourceText(sourceText, node.openingElement.tagName));
	                }
	                result = finishNode(node);
	            }
	            else if (opening.kind === 259 /* JsxOpeningFragment */) {
	                var node = createNode(258 /* JsxFragment */, opening.pos);
	                node.openingFragment = opening;
	                node.children = parseJsxChildren(node.openingFragment);
	                node.closingFragment = parseJsxClosingFragment(inExpressionContext);
	                result = finishNode(node);
	            }
	            else {
	                ts.Debug.assert(opening.kind === 255 /* JsxSelfClosingElement */);
	                // Nothing else to do for self-closing elements
	                result = opening;
	            }
	            // If the user writes the invalid code '<div></div><div></div>' in an expression context (i.e. not wrapped in
	            // an enclosing tag), we'll naively try to parse   ^ this as a 'less than' operator and the remainder of the tag
	            // as garbage, which will cause the formatter to badly mangle the JSX. Perform a speculative parse of a JSX
	            // element if we see a < token so that we can wrap it in a synthetic binary expression so the formatter
	            // does less damage and we can report a better error.
	            // Since JSX elements are invalid < operands anyway, this lookahead parse will only occur in error scenarios
	            // of one sort or another.
	            if (inExpressionContext && token() === 27 /* LessThanToken */) {
	                var invalidElement = tryParse(function () { return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ true); });
	                if (invalidElement) {
	                    parseErrorAtCurrentToken(ts.Diagnostics.JSX_expressions_must_have_one_parent_element);
	                    var badNode = createNode(199 /* BinaryExpression */, result.pos);
	                    badNode.end = invalidElement.end;
	                    badNode.left = result;
	                    badNode.right = invalidElement;
	                    badNode.operatorToken = createMissingNode(26 /* CommaToken */, /*reportAtCurrentPosition*/ false, /*diagnosticMessage*/ undefined);
	                    badNode.operatorToken.pos = badNode.operatorToken.end = badNode.right.pos;
	                    return badNode;
	                }
	            }
	            return result;
	        }
	        function parseJsxText() {
	            var node = createNode(10 /* JsxText */);
	            node.containsOnlyWhiteSpaces = currentToken === 11 /* JsxTextAllWhiteSpaces */;
	            currentToken = scanner.scanJsxToken();
	            return finishNode(node);
	        }
	        function parseJsxChild(openingTag, token) {
	            switch (token) {
	                case 1 /* EndOfFileToken */:
	                    // If we hit EOF, issue the error at the tag that lacks the closing element
	                    // rather than at the end of the file (which is useless)
	                    if (ts.isJsxOpeningFragment(openingTag)) {
	                        parseErrorAtRange(openingTag, ts.Diagnostics.JSX_fragment_has_no_corresponding_closing_tag);
	                    }
	                    else {
	                        parseErrorAtRange(openingTag.tagName, ts.Diagnostics.JSX_element_0_has_no_corresponding_closing_tag, ts.getTextOfNodeFromSourceText(sourceText, openingTag.tagName));
	                    }
	                    return undefined;
	                case 28 /* LessThanSlashToken */:
	                case 7 /* ConflictMarkerTrivia */:
	                    return undefined;
	                case 10 /* JsxText */:
	                case 11 /* JsxTextAllWhiteSpaces */:
	                    return parseJsxText();
	                case 17 /* OpenBraceToken */:
	                    return parseJsxExpression(/*inExpressionContext*/ false);
	                case 27 /* LessThanToken */:
	                    return parseJsxElementOrSelfClosingElementOrFragment(/*inExpressionContext*/ false);
	                default:
	                    return ts.Debug.assertNever(token);
	            }
	        }
	        function parseJsxChildren(openingTag) {
	            var list = [];
	            var listPos = getNodePos();
	            var saveParsingContext = parsingContext;
	            parsingContext |= 1 << 14 /* JsxChildren */;
	            while (true) {
	                var child = parseJsxChild(openingTag, currentToken = scanner.reScanJsxToken());
	                if (!child)
	                    break;
	                list.push(child);
	            }
	            parsingContext = saveParsingContext;
	            return createNodeArray(list, listPos);
	        }
	        function parseJsxAttributes() {
	            var jsxAttributes = createNode(262 /* JsxAttributes */);
	            jsxAttributes.properties = parseList(13 /* JsxAttributes */, parseJsxAttribute);
	            return finishNode(jsxAttributes);
	        }
	        function parseJsxOpeningOrSelfClosingElementOrOpeningFragment(inExpressionContext) {
	            var fullStart = scanner.getStartPos();
	            parseExpected(27 /* LessThanToken */);
	            if (token() === 29 /* GreaterThanToken */) {
	                // See below for explanation of scanJsxText
	                var node_1 = createNode(259 /* JsxOpeningFragment */, fullStart);
	                scanJsxText();
	                return finishNode(node_1);
	            }
	            var tagName = parseJsxElementName();
	            var typeArguments = tryParseTypeArguments();
	            var attributes = parseJsxAttributes();
	            var node;
	            if (token() === 29 /* GreaterThanToken */) {
	                // Closing tag, so scan the immediately-following text with the JSX scanning instead
	                // of regular scanning to avoid treating illegal characters (e.g. '#') as immediate
	                // scanning errors
	                node = createNode(256 /* JsxOpeningElement */, fullStart);
	                scanJsxText();
	            }
	            else {
	                parseExpected(41 /* SlashToken */);
	                if (inExpressionContext) {
	                    parseExpected(29 /* GreaterThanToken */);
	                }
	                else {
	                    parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                    scanJsxText();
	                }
	                node = createNode(255 /* JsxSelfClosingElement */, fullStart);
	            }
	            node.tagName = tagName;
	            node.typeArguments = typeArguments;
	            node.attributes = attributes;
	            return finishNode(node);
	        }
	        function parseJsxElementName() {
	            scanJsxIdentifier();
	            // JsxElement can have name in the form of
	            //      propertyAccessExpression
	            //      primaryExpression in the form of an identifier and "this" keyword
	            // We can't just simply use parseLeftHandSideExpressionOrHigher because then we will start consider class,function etc as a keyword
	            // We only want to consider "this" as a primaryExpression
	            var expression = token() === 99 /* ThisKeyword */ ?
	                parseTokenNode() : parseIdentifierName();
	            while (parseOptional(23 /* DotToken */)) {
	                var propertyAccess = createNode(184 /* PropertyAccessExpression */, expression.pos);
	                propertyAccess.expression = expression;
	                propertyAccess.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	                expression = finishNode(propertyAccess);
	            }
	            return expression;
	        }
	        function parseJsxExpression(inExpressionContext) {
	            var node = createNode(264 /* JsxExpression */);
	            if (!parseExpected(17 /* OpenBraceToken */)) {
	                return undefined;
	            }
	            if (token() !== 18 /* CloseBraceToken */) {
	                node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	                node.expression = parseAssignmentExpressionOrHigher();
	            }
	            if (inExpressionContext) {
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                parseExpected(18 /* CloseBraceToken */, /*message*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseJsxAttribute() {
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseJsxSpreadAttribute();
	            }
	            scanJsxIdentifier();
	            var node = createNode(261 /* JsxAttribute */);
	            node.name = parseIdentifierName();
	            if (token() === 58 /* EqualsToken */) {
	                switch (scanJsxAttributeValue()) {
	                    case 9 /* StringLiteral */:
	                        node.initializer = parseLiteralNode();
	                        break;
	                    default:
	                        node.initializer = parseJsxExpression(/*inExpressionContext*/ true);
	                        break;
	                }
	            }
	            return finishNode(node);
	        }
	        function parseJsxSpreadAttribute() {
	            var node = createNode(263 /* JsxSpreadAttribute */);
	            parseExpected(17 /* OpenBraceToken */);
	            parseExpected(24 /* DotDotDotToken */);
	            node.expression = parseExpression();
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseJsxClosingElement(inExpressionContext) {
	            var node = createNode(257 /* JsxClosingElement */);
	            parseExpected(28 /* LessThanSlashToken */);
	            node.tagName = parseJsxElementName();
	            if (inExpressionContext) {
	                parseExpected(29 /* GreaterThanToken */);
	            }
	            else {
	                parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseJsxClosingFragment(inExpressionContext) {
	            var node = createNode(260 /* JsxClosingFragment */);
	            parseExpected(28 /* LessThanSlashToken */);
	            if (ts.tokenIsIdentifierOrKeyword(token())) {
	                parseErrorAtRange(parseJsxElementName(), ts.Diagnostics.Expected_corresponding_closing_tag_for_JSX_fragment);
	            }
	            if (inExpressionContext) {
	                parseExpected(29 /* GreaterThanToken */);
	            }
	            else {
	                parseExpected(29 /* GreaterThanToken */, /*diagnostic*/ undefined, /*shouldAdvance*/ false);
	                scanJsxText();
	            }
	            return finishNode(node);
	        }
	        function parseTypeAssertion() {
	            var node = createNode(189 /* TypeAssertionExpression */);
	            parseExpected(27 /* LessThanToken */);
	            node.type = parseType();
	            parseExpected(29 /* GreaterThanToken */);
	            node.expression = parseSimpleUnaryExpression();
	            return finishNode(node);
	        }
	        function parseMemberExpressionRest(expression) {
	            while (true) {
	                var dotToken = parseOptionalToken(23 /* DotToken */);
	                if (dotToken) {
	                    var propertyAccess = createNode(184 /* PropertyAccessExpression */, expression.pos);
	                    propertyAccess.expression = expression;
	                    propertyAccess.name = parseRightSideOfDot(/*allowIdentifierNames*/ true);
	                    expression = finishNode(propertyAccess);
	                    continue;
	                }
	                if (token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                    nextToken();
	                    var nonNullExpression = createNode(208 /* NonNullExpression */, expression.pos);
	                    nonNullExpression.expression = expression;
	                    expression = finishNode(nonNullExpression);
	                    continue;
	                }
	                // when in the [Decorator] context, we do not parse ElementAccess as it could be part of a ComputedPropertyName
	                if (!inDecoratorContext() && parseOptional(21 /* OpenBracketToken */)) {
	                    var indexedAccess = createNode(185 /* ElementAccessExpression */, expression.pos);
	                    indexedAccess.expression = expression;
	                    if (token() === 22 /* CloseBracketToken */) {
	                        indexedAccess.argumentExpression = createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.An_element_access_expression_should_take_an_argument);
	                    }
	                    else {
	                        var argument = allowInAnd(parseExpression);
	                        if (ts.isStringOrNumericLiteral(argument)) {
	                            argument.text = internIdentifier(argument.text);
	                        }
	                        indexedAccess.argumentExpression = argument;
	                    }
	                    parseExpected(22 /* CloseBracketToken */);
	                    expression = finishNode(indexedAccess);
	                    continue;
	                }
	                if (isTemplateStartOfTaggedTemplate()) {
	                    expression = parseTaggedTemplateRest(expression, /*typeArguments*/ undefined);
	                    continue;
	                }
	                return expression;
	            }
	        }
	        function isTemplateStartOfTaggedTemplate() {
	            return token() === 13 /* NoSubstitutionTemplateLiteral */ || token() === 14 /* TemplateHead */;
	        }
	        function parseTaggedTemplateRest(tag, typeArguments) {
	            var tagExpression = createNode(188 /* TaggedTemplateExpression */, tag.pos);
	            tagExpression.tag = tag;
	            tagExpression.typeArguments = typeArguments;
	            tagExpression.template = token() === 13 /* NoSubstitutionTemplateLiteral */
	                ? parseLiteralNode()
	                : parseTemplateExpression();
	            return finishNode(tagExpression);
	        }
	        function parseCallExpressionRest(expression) {
	            while (true) {
	                expression = parseMemberExpressionRest(expression);
	                if (token() === 27 /* LessThanToken */) {
	                    // See if this is the start of a generic invocation.  If so, consume it and
	                    // keep checking for postfix expressions.  Otherwise, it's just a '<' that's
	                    // part of an arithmetic expression.  Break out so we consume it higher in the
	                    // stack.
	                    var typeArguments = tryParse(parseTypeArgumentsInExpression);
	                    if (!typeArguments) {
	                        return expression;
	                    }
	                    if (isTemplateStartOfTaggedTemplate()) {
	                        expression = parseTaggedTemplateRest(expression, typeArguments);
	                        continue;
	                    }
	                    var callExpr = createNode(186 /* CallExpression */, expression.pos);
	                    callExpr.expression = expression;
	                    callExpr.typeArguments = typeArguments;
	                    callExpr.arguments = parseArgumentList();
	                    expression = finishNode(callExpr);
	                    continue;
	                }
	                else if (token() === 19 /* OpenParenToken */) {
	                    var callExpr = createNode(186 /* CallExpression */, expression.pos);
	                    callExpr.expression = expression;
	                    callExpr.arguments = parseArgumentList();
	                    expression = finishNode(callExpr);
	                    continue;
	                }
	                return expression;
	            }
	        }
	        function parseArgumentList() {
	            parseExpected(19 /* OpenParenToken */);
	            var result = parseDelimitedList(11 /* ArgumentExpressions */, parseArgumentExpression);
	            parseExpected(20 /* CloseParenToken */);
	            return result;
	        }
	        function parseTypeArgumentsInExpression() {
	            if (!parseOptional(27 /* LessThanToken */)) {
	                return undefined;
	            }
	            var typeArguments = parseDelimitedList(19 /* TypeArguments */, parseType);
	            if (!parseExpected(29 /* GreaterThanToken */)) {
	                // If it doesn't have the closing `>` then it's definitely not an type argument list.
	                return undefined;
	            }
	            // If we have a '<', then only parse this as a argument list if the type arguments
	            // are complete and we have an open paren.  if we don't, rewind and return nothing.
	            return typeArguments && canFollowTypeArgumentsInExpression()
	                ? typeArguments
	                : undefined;
	        }
	        function canFollowTypeArgumentsInExpression() {
	            switch (token()) {
	                case 19 /* OpenParenToken */: // foo<x>(
	                case 13 /* NoSubstitutionTemplateLiteral */: // foo<T> `...`
	                case 14 /* TemplateHead */: // foo<T> `...${100}...`
	                // these are the only tokens can legally follow a type argument
	                // list. So we definitely want to treat them as type arg lists.
	                case 23 /* DotToken */: // foo<x>.
	                case 20 /* CloseParenToken */: // foo<x>)
	                case 22 /* CloseBracketToken */: // foo<x>]
	                case 56 /* ColonToken */: // foo<x>:
	                case 25 /* SemicolonToken */: // foo<x>;
	                case 55 /* QuestionToken */: // foo<x>?
	                case 32 /* EqualsEqualsToken */: // foo<x> ==
	                case 34 /* EqualsEqualsEqualsToken */: // foo<x> ===
	                case 33 /* ExclamationEqualsToken */: // foo<x> !=
	                case 35 /* ExclamationEqualsEqualsToken */: // foo<x> !==
	                case 53 /* AmpersandAmpersandToken */: // foo<x> &&
	                case 54 /* BarBarToken */: // foo<x> ||
	                case 50 /* CaretToken */: // foo<x> ^
	                case 48 /* AmpersandToken */: // foo<x> &
	                case 49 /* BarToken */: // foo<x> |
	                case 18 /* CloseBraceToken */: // foo<x> }
	                case 1 /* EndOfFileToken */: // foo<x>
	                    // these cases can't legally follow a type arg list.  However, they're not legal
	                    // expressions either.  The user is probably in the middle of a generic type. So
	                    // treat it as such.
	                    return true;
	                case 26 /* CommaToken */: // foo<x>,
	                case 17 /* OpenBraceToken */: // foo<x> {
	                // We don't want to treat these as type arguments.  Otherwise we'll parse this
	                // as an invocation expression.  Instead, we want to parse out the expression
	                // in isolation from the type arguments.
	                default:
	                    // Anything else treat as an expression.
	                    return false;
	            }
	        }
	        function parsePrimaryExpression() {
	            switch (token()) {
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                    return parseLiteralNode();
	                case 99 /* ThisKeyword */:
	                case 97 /* SuperKeyword */:
	                case 95 /* NullKeyword */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                    return parseTokenNode();
	                case 19 /* OpenParenToken */:
	                    return parseParenthesizedExpression();
	                case 21 /* OpenBracketToken */:
	                    return parseArrayLiteralExpression();
	                case 17 /* OpenBraceToken */:
	                    return parseObjectLiteralExpression();
	                case 120 /* AsyncKeyword */:
	                    // Async arrow functions are parsed earlier in parseAssignmentExpressionOrHigher.
	                    // If we encounter `async [no LineTerminator here] function` then this is an async
	                    // function; otherwise, its an identifier.
	                    if (!lookAhead(nextTokenIsFunctionKeywordOnSameLine)) {
	                        break;
	                    }
	                    return parseFunctionExpression();
	                case 75 /* ClassKeyword */:
	                    return parseClassExpression();
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionExpression();
	                case 94 /* NewKeyword */:
	                    return parseNewExpressionOrNewDotTarget();
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                    if (reScanSlashToken() === 12 /* RegularExpressionLiteral */) {
	                        return parseLiteralNode();
	                    }
	                    break;
	                case 14 /* TemplateHead */:
	                    return parseTemplateExpression();
	            }
	            return parseIdentifier(ts.Diagnostics.Expression_expected);
	        }
	        function parseParenthesizedExpression() {
	            var node = createNodeWithJSDoc(190 /* ParenthesizedExpression */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseSpreadElement() {
	            var node = createNode(203 /* SpreadElement */);
	            parseExpected(24 /* DotDotDotToken */);
	            node.expression = parseAssignmentExpressionOrHigher();
	            return finishNode(node);
	        }
	        function parseArgumentOrArrayLiteralElement() {
	            return token() === 24 /* DotDotDotToken */ ? parseSpreadElement() :
	                token() === 26 /* CommaToken */ ? createNode(205 /* OmittedExpression */) :
	                    parseAssignmentExpressionOrHigher();
	        }
	        function parseArgumentExpression() {
	            return doOutsideOfContext(disallowInAndDecoratorContext, parseArgumentOrArrayLiteralElement);
	        }
	        function parseArrayLiteralExpression() {
	            var node = createNode(182 /* ArrayLiteralExpression */);
	            parseExpected(21 /* OpenBracketToken */);
	            if (scanner.hasPrecedingLineBreak()) {
	                node.multiLine = true;
	            }
	            node.elements = parseDelimitedList(15 /* ArrayLiteralMembers */, parseArgumentOrArrayLiteralElement);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function parseObjectLiteralElement() {
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            if (parseOptionalToken(24 /* DotDotDotToken */)) {
	                node.kind = 271 /* SpreadAssignment */;
	                node.expression = parseAssignmentExpressionOrHigher();
	                return finishNode(node);
	            }
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            if (parseContextualModifier(125 /* GetKeyword */)) {
	                return parseAccessorDeclaration(node, 155 /* GetAccessor */);
	            }
	            if (parseContextualModifier(136 /* SetKeyword */)) {
	                return parseAccessorDeclaration(node, 156 /* SetAccessor */);
	            }
	            var asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            var tokenIsIdentifier = isIdentifier();
	            node.name = parsePropertyName();
	            // Disallowing of optional property assignments happens in the grammar checker.
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (asteriskToken || token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseMethodDeclaration(node, asteriskToken);
	            }
	            // check if it is short-hand property assignment or normal property assignment
	            // NOTE: if token is EqualsToken it is interpreted as CoverInitializedName production
	            // CoverInitializedName[Yield] :
	            //     IdentifierReference[?Yield] Initializer[In, ?Yield]
	            // this is necessary because ObjectLiteral productions are also used to cover grammar for ObjectAssignmentPattern
	            var isShorthandPropertyAssignment = tokenIsIdentifier && (token() === 26 /* CommaToken */ || token() === 18 /* CloseBraceToken */ || token() === 58 /* EqualsToken */);
	            if (isShorthandPropertyAssignment) {
	                node.kind = 270 /* ShorthandPropertyAssignment */;
	                var equalsToken = parseOptionalToken(58 /* EqualsToken */);
	                if (equalsToken) {
	                    node.equalsToken = equalsToken;
	                    node.objectAssignmentInitializer = allowInAnd(parseAssignmentExpressionOrHigher);
	                }
	            }
	            else {
	                node.kind = 269 /* PropertyAssignment */;
	                parseExpected(56 /* ColonToken */);
	                node.initializer = allowInAnd(parseAssignmentExpressionOrHigher);
	            }
	            return finishNode(node);
	        }
	        function parseObjectLiteralExpression() {
	            var node = createNode(183 /* ObjectLiteralExpression */);
	            parseExpected(17 /* OpenBraceToken */);
	            if (scanner.hasPrecedingLineBreak()) {
	                node.multiLine = true;
	            }
	            node.properties = parseDelimitedList(12 /* ObjectLiteralMembers */, parseObjectLiteralElement, /*considerSemicolonAsDelimiter*/ true);
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseFunctionExpression() {
	            // GeneratorExpression:
	            //      function* BindingIdentifier [Yield][opt](FormalParameters[Yield]){ GeneratorBody }
	            //
	            // FunctionExpression:
	            //      function BindingIdentifier[opt](FormalParameters){ FunctionBody }
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var node = createNodeWithJSDoc(191 /* FunctionExpression */);
	            node.modifiers = parseModifiers();
	            parseExpected(89 /* FunctionKeyword */);
	            node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            var isGenerator = node.asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            node.name =
	                isGenerator && isAsync ? doInYieldAndAwaitContext(parseOptionalIdentifier) :
	                    isGenerator ? doInYieldContext(parseOptionalIdentifier) :
	                        isAsync ? doInAwaitContext(parseOptionalIdentifier) :
	                            parseOptionalIdentifier();
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlock(isGenerator | isAsync);
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            return finishNode(node);
	        }
	        function parseOptionalIdentifier() {
	            return isIdentifier() ? parseIdentifier() : undefined;
	        }
	        function parseNewExpressionOrNewDotTarget() {
	            var fullStart = scanner.getStartPos();
	            parseExpected(94 /* NewKeyword */);
	            if (parseOptional(23 /* DotToken */)) {
	                var node_2 = createNode(209 /* MetaProperty */, fullStart);
	                node_2.keywordToken = 94 /* NewKeyword */;
	                node_2.name = parseIdentifierName();
	                return finishNode(node_2);
	            }
	            var expression = parsePrimaryExpression();
	            var typeArguments;
	            while (true) {
	                expression = parseMemberExpressionRest(expression);
	                typeArguments = tryParse(parseTypeArgumentsInExpression);
	                if (isTemplateStartOfTaggedTemplate()) {
	                    ts.Debug.assert(!!typeArguments, "Expected a type argument list; all plain tagged template starts should be consumed in 'parseMemberExpressionRest'");
	                    expression = parseTaggedTemplateRest(expression, typeArguments);
	                    typeArguments = undefined;
	                }
	                break;
	            }
	            var node = createNode(187 /* NewExpression */, fullStart);
	            node.expression = expression;
	            node.typeArguments = typeArguments;
	            if (node.typeArguments || token() === 19 /* OpenParenToken */) {
	                node.arguments = parseArgumentList();
	            }
	            return finishNode(node);
	        }
	        // STATEMENTS
	        function parseBlock(ignoreMissingOpenBrace, diagnosticMessage) {
	            var node = createNode(212 /* Block */);
	            if (parseExpected(17 /* OpenBraceToken */, diagnosticMessage) || ignoreMissingOpenBrace) {
	                if (scanner.hasPrecedingLineBreak()) {
	                    node.multiLine = true;
	                }
	                node.statements = parseList(1 /* BlockStatements */, parseStatement);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.statements = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseFunctionBlock(flags, diagnosticMessage) {
	            var savedYieldContext = inYieldContext();
	            setYieldContext(!!(flags & 1 /* Yield */));
	            var savedAwaitContext = inAwaitContext();
	            setAwaitContext(!!(flags & 2 /* Await */));
	            // We may be in a [Decorator] context when parsing a function expression or
	            // arrow function. The body of the function is not in [Decorator] context.
	            var saveDecoratorContext = inDecoratorContext();
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ false);
	            }
	            var block = parseBlock(!!(flags & 16 /* IgnoreMissingOpenBrace */), diagnosticMessage);
	            if (saveDecoratorContext) {
	                setDecoratorContext(/*val*/ true);
	            }
	            setYieldContext(savedYieldContext);
	            setAwaitContext(savedAwaitContext);
	            return block;
	        }
	        function parseEmptyStatement() {
	            var node = createNode(214 /* EmptyStatement */);
	            parseExpected(25 /* SemicolonToken */);
	            return finishNode(node);
	        }
	        function parseIfStatement() {
	            var node = createNode(216 /* IfStatement */);
	            parseExpected(90 /* IfKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.thenStatement = parseStatement();
	            node.elseStatement = parseOptional(82 /* ElseKeyword */) ? parseStatement() : undefined;
	            return finishNode(node);
	        }
	        function parseDoStatement() {
	            var node = createNode(217 /* DoStatement */);
	            parseExpected(81 /* DoKeyword */);
	            node.statement = parseStatement();
	            parseExpected(106 /* WhileKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            // From: https://mail.mozilla.org/pipermail/es-discuss/2011-August/016188.html
	            // 157 min --- All allen at wirfs-brock.com CONF --- "do{;}while(false)false" prohibited in
	            // spec but allowed in consensus reality. Approved -- this is the de-facto standard whereby
	            //  do;while(0)x will have a semicolon inserted before x.
	            parseOptional(25 /* SemicolonToken */);
	            return finishNode(node);
	        }
	        function parseWhileStatement() {
	            var node = createNode(218 /* WhileStatement */);
	            parseExpected(106 /* WhileKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.statement = parseStatement();
	            return finishNode(node);
	        }
	        function parseForOrForInOrForOfStatement() {
	            var pos = getNodePos();
	            parseExpected(88 /* ForKeyword */);
	            var awaitToken = parseOptionalToken(121 /* AwaitKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            var initializer;
	            if (token() !== 25 /* SemicolonToken */) {
	                if (token() === 104 /* VarKeyword */ || token() === 110 /* LetKeyword */ || token() === 76 /* ConstKeyword */) {
	                    initializer = parseVariableDeclarationList(/*inForStatementInitializer*/ true);
	                }
	                else {
	                    initializer = disallowInAnd(parseExpression);
	                }
	            }
	            var forOrForInOrForOfStatement;
	            if (awaitToken ? parseExpected(144 /* OfKeyword */) : parseOptional(144 /* OfKeyword */)) {
	                var forOfStatement = createNode(221 /* ForOfStatement */, pos);
	                forOfStatement.awaitModifier = awaitToken;
	                forOfStatement.initializer = initializer;
	                forOfStatement.expression = allowInAnd(parseAssignmentExpressionOrHigher);
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forOfStatement;
	            }
	            else if (parseOptional(92 /* InKeyword */)) {
	                var forInStatement = createNode(220 /* ForInStatement */, pos);
	                forInStatement.initializer = initializer;
	                forInStatement.expression = allowInAnd(parseExpression);
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forInStatement;
	            }
	            else {
	                var forStatement = createNode(219 /* ForStatement */, pos);
	                forStatement.initializer = initializer;
	                parseExpected(25 /* SemicolonToken */);
	                if (token() !== 25 /* SemicolonToken */ && token() !== 20 /* CloseParenToken */) {
	                    forStatement.condition = allowInAnd(parseExpression);
	                }
	                parseExpected(25 /* SemicolonToken */);
	                if (token() !== 20 /* CloseParenToken */) {
	                    forStatement.incrementor = allowInAnd(parseExpression);
	                }
	                parseExpected(20 /* CloseParenToken */);
	                forOrForInOrForOfStatement = forStatement;
	            }
	            forOrForInOrForOfStatement.statement = parseStatement();
	            return finishNode(forOrForInOrForOfStatement);
	        }
	        function parseBreakOrContinueStatement(kind) {
	            var node = createNode(kind);
	            parseExpected(kind === 223 /* BreakStatement */ ? 72 /* BreakKeyword */ : 77 /* ContinueKeyword */);
	            if (!canParseSemicolon()) {
	                node.label = parseIdentifier();
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseReturnStatement() {
	            var node = createNode(224 /* ReturnStatement */);
	            parseExpected(96 /* ReturnKeyword */);
	            if (!canParseSemicolon()) {
	                node.expression = allowInAnd(parseExpression);
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseWithStatement() {
	            var node = createNode(225 /* WithStatement */);
	            parseExpected(107 /* WithKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            node.statement = doInsideOfContext(8388608 /* InWithStatement */, parseStatement);
	            return finishNode(node);
	        }
	        function parseCaseClause() {
	            var node = createNode(265 /* CaseClause */);
	            parseExpected(73 /* CaseKeyword */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(56 /* ColonToken */);
	            node.statements = parseList(3 /* SwitchClauseStatements */, parseStatement);
	            return finishNode(node);
	        }
	        function parseDefaultClause() {
	            var node = createNode(266 /* DefaultClause */);
	            parseExpected(79 /* DefaultKeyword */);
	            parseExpected(56 /* ColonToken */);
	            node.statements = parseList(3 /* SwitchClauseStatements */, parseStatement);
	            return finishNode(node);
	        }
	        function parseCaseOrDefaultClause() {
	            return token() === 73 /* CaseKeyword */ ? parseCaseClause() : parseDefaultClause();
	        }
	        function parseSwitchStatement() {
	            var node = createNode(226 /* SwitchStatement */);
	            parseExpected(98 /* SwitchKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = allowInAnd(parseExpression);
	            parseExpected(20 /* CloseParenToken */);
	            var caseBlock = createNode(240 /* CaseBlock */);
	            parseExpected(17 /* OpenBraceToken */);
	            caseBlock.clauses = parseList(2 /* SwitchClauses */, parseCaseOrDefaultClause);
	            parseExpected(18 /* CloseBraceToken */);
	            node.caseBlock = finishNode(caseBlock);
	            return finishNode(node);
	        }
	        function parseThrowStatement() {
	            // ThrowStatement[Yield] :
	            //      throw [no LineTerminator here]Expression[In, ?Yield];
	            // Because of automatic semicolon insertion, we need to report error if this
	            // throw could be terminated with a semicolon.  Note: we can't call 'parseExpression'
	            // directly as that might consume an expression on the following line.
	            // We just return 'undefined' in that case.  The actual error will be reported in the
	            // grammar walker.
	            var node = createNode(228 /* ThrowStatement */);
	            parseExpected(100 /* ThrowKeyword */);
	            node.expression = scanner.hasPrecedingLineBreak() ? undefined : allowInAnd(parseExpression);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        // TODO: Review for error recovery
	        function parseTryStatement() {
	            var node = createNode(229 /* TryStatement */);
	            parseExpected(102 /* TryKeyword */);
	            node.tryBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            node.catchClause = token() === 74 /* CatchKeyword */ ? parseCatchClause() : undefined;
	            // If we don't have a catch clause, then we must have a finally clause.  Try to parse
	            // one out no matter what.
	            if (!node.catchClause || token() === 87 /* FinallyKeyword */) {
	                parseExpected(87 /* FinallyKeyword */);
	                node.finallyBlock = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            }
	            return finishNode(node);
	        }
	        function parseCatchClause() {
	            var result = createNode(268 /* CatchClause */);
	            parseExpected(74 /* CatchKeyword */);
	            if (parseOptional(19 /* OpenParenToken */)) {
	                result.variableDeclaration = parseVariableDeclaration();
	                parseExpected(20 /* CloseParenToken */);
	            }
	            else {
	                // Keep shape of node to avoid degrading performance.
	                result.variableDeclaration = undefined;
	            }
	            result.block = parseBlock(/*ignoreMissingOpenBrace*/ false);
	            return finishNode(result);
	        }
	        function parseDebuggerStatement() {
	            var node = createNode(230 /* DebuggerStatement */);
	            parseExpected(78 /* DebuggerKeyword */);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseExpressionOrLabeledStatement() {
	            // Avoiding having to do the lookahead for a labeled statement by just trying to parse
	            // out an expression, seeing if it is identifier and then seeing if it is followed by
	            // a colon.
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            var expression = allowInAnd(parseExpression);
	            if (expression.kind === 71 /* Identifier */ && parseOptional(56 /* ColonToken */)) {
	                node.kind = 227 /* LabeledStatement */;
	                node.label = expression;
	                node.statement = parseStatement();
	            }
	            else {
	                node.kind = 215 /* ExpressionStatement */;
	                node.expression = expression;
	                parseSemicolon();
	            }
	            return finishNode(node);
	        }
	        function nextTokenIsIdentifierOrKeywordOnSameLine() {
	            nextToken();
	            return ts.tokenIsIdentifierOrKeyword(token()) && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsClassKeywordOnSameLine() {
	            nextToken();
	            return token() === 75 /* ClassKeyword */ && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsFunctionKeywordOnSameLine() {
	            nextToken();
	            return token() === 89 /* FunctionKeyword */ && !scanner.hasPrecedingLineBreak();
	        }
	        function nextTokenIsIdentifierOrKeywordOrLiteralOnSameLine() {
	            nextToken();
	            return (ts.tokenIsIdentifierOrKeyword(token()) || token() === 8 /* NumericLiteral */ || token() === 9 /* StringLiteral */) && !scanner.hasPrecedingLineBreak();
	        }
	        function isDeclaration() {
	            while (true) {
	                switch (token()) {
	                    case 104 /* VarKeyword */:
	                    case 110 /* LetKeyword */:
	                    case 76 /* ConstKeyword */:
	                    case 89 /* FunctionKeyword */:
	                    case 75 /* ClassKeyword */:
	                    case 83 /* EnumKeyword */:
	                        return true;
	                    // 'declare', 'module', 'namespace', 'interface'* and 'type' are all legal JavaScript identifiers;
	                    // however, an identifier cannot be followed by another identifier on the same line. This is what we
	                    // count on to parse out the respective declarations. For instance, we exploit this to say that
	                    //
	                    //    namespace n
	                    //
	                    // can be none other than the beginning of a namespace declaration, but need to respect that JavaScript sees
	                    //
	                    //    namespace
	                    //    n
	                    //
	                    // as the identifier 'namespace' on one line followed by the identifier 'n' on another.
	                    // We need to look one token ahead to see if it permissible to try parsing a declaration.
	                    //
	                    // *Note*: 'interface' is actually a strict mode reserved word. So while
	                    //
	                    //   "use strict"
	                    //   interface
	                    //   I {}
	                    //
	                    // could be legal, it would add complexity for very little gain.
	                    case 109 /* InterfaceKeyword */:
	                    case 139 /* TypeKeyword */:
	                        return nextTokenIsIdentifierOnSameLine();
	                    case 129 /* ModuleKeyword */:
	                    case 130 /* NamespaceKeyword */:
	                        return nextTokenIsIdentifierOrStringLiteralOnSameLine();
	                    case 117 /* AbstractKeyword */:
	                    case 120 /* AsyncKeyword */:
	                    case 124 /* DeclareKeyword */:
	                    case 112 /* PrivateKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                    case 114 /* PublicKeyword */:
	                    case 132 /* ReadonlyKeyword */:
	                        nextToken();
	                        // ASI takes effect for this modifier.
	                        if (scanner.hasPrecedingLineBreak()) {
	                            return false;
	                        }
	                        continue;
	                    case 143 /* GlobalKeyword */:
	                        nextToken();
	                        return token() === 17 /* OpenBraceToken */ || token() === 71 /* Identifier */ || token() === 84 /* ExportKeyword */;
	                    case 91 /* ImportKeyword */:
	                        nextToken();
	                        return token() === 9 /* StringLiteral */ || token() === 39 /* AsteriskToken */ ||
	                            token() === 17 /* OpenBraceToken */ || ts.tokenIsIdentifierOrKeyword(token());
	                    case 84 /* ExportKeyword */:
	                        nextToken();
	                        if (token() === 58 /* EqualsToken */ || token() === 39 /* AsteriskToken */ ||
	                            token() === 17 /* OpenBraceToken */ || token() === 79 /* DefaultKeyword */ ||
	                            token() === 118 /* AsKeyword */) {
	                            return true;
	                        }
	                        continue;
	                    case 115 /* StaticKeyword */:
	                        nextToken();
	                        continue;
	                    default:
	                        return false;
	                }
	            }
	        }
	        function isStartOfDeclaration() {
	            return lookAhead(isDeclaration);
	        }
	        function isStartOfStatement() {
	            switch (token()) {
	                case 57 /* AtToken */:
	                case 25 /* SemicolonToken */:
	                case 17 /* OpenBraceToken */:
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 89 /* FunctionKeyword */:
	                case 75 /* ClassKeyword */:
	                case 83 /* EnumKeyword */:
	                case 90 /* IfKeyword */:
	                case 81 /* DoKeyword */:
	                case 106 /* WhileKeyword */:
	                case 88 /* ForKeyword */:
	                case 77 /* ContinueKeyword */:
	                case 72 /* BreakKeyword */:
	                case 96 /* ReturnKeyword */:
	                case 107 /* WithKeyword */:
	                case 98 /* SwitchKeyword */:
	                case 100 /* ThrowKeyword */:
	                case 102 /* TryKeyword */:
	                case 78 /* DebuggerKeyword */:
	                // 'catch' and 'finally' do not actually indicate that the code is part of a statement,
	                // however, we say they are here so that we may gracefully parse them and error later.
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    return true;
	                case 91 /* ImportKeyword */:
	                    return isStartOfDeclaration() || lookAhead(nextTokenIsOpenParenOrLessThanOrDot);
	                case 76 /* ConstKeyword */:
	                case 84 /* ExportKeyword */:
	                    return isStartOfDeclaration();
	                case 120 /* AsyncKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 109 /* InterfaceKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                case 139 /* TypeKeyword */:
	                case 143 /* GlobalKeyword */:
	                    // When these don't start a declaration, they're an identifier in an expression statement
	                    return true;
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 115 /* StaticKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                    // When these don't start a declaration, they may be the start of a class member if an identifier
	                    // immediately follows. Otherwise they're an identifier in an expression statement.
	                    return isStartOfDeclaration() || !lookAhead(nextTokenIsIdentifierOrKeywordOnSameLine);
	                default:
	                    return isStartOfExpression();
	            }
	        }
	        function nextTokenIsIdentifierOrStartOfDestructuring() {
	            nextToken();
	            return isIdentifier() || token() === 17 /* OpenBraceToken */ || token() === 21 /* OpenBracketToken */;
	        }
	        function isLetDeclaration() {
	            // In ES6 'let' always starts a lexical declaration if followed by an identifier or {
	            // or [.
	            return lookAhead(nextTokenIsIdentifierOrStartOfDestructuring);
	        }
	        function parseStatement() {
	            switch (token()) {
	                case 25 /* SemicolonToken */:
	                    return parseEmptyStatement();
	                case 17 /* OpenBraceToken */:
	                    return parseBlock(/*ignoreMissingOpenBrace*/ false);
	                case 104 /* VarKeyword */:
	                    return parseVariableStatement(createNodeWithJSDoc(231 /* VariableDeclaration */));
	                case 110 /* LetKeyword */:
	                    if (isLetDeclaration()) {
	                        return parseVariableStatement(createNodeWithJSDoc(231 /* VariableDeclaration */));
	                    }
	                    break;
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionDeclaration(createNodeWithJSDoc(233 /* FunctionDeclaration */));
	                case 75 /* ClassKeyword */:
	                    return parseClassDeclaration(createNodeWithJSDoc(234 /* ClassDeclaration */));
	                case 90 /* IfKeyword */:
	                    return parseIfStatement();
	                case 81 /* DoKeyword */:
	                    return parseDoStatement();
	                case 106 /* WhileKeyword */:
	                    return parseWhileStatement();
	                case 88 /* ForKeyword */:
	                    return parseForOrForInOrForOfStatement();
	                case 77 /* ContinueKeyword */:
	                    return parseBreakOrContinueStatement(222 /* ContinueStatement */);
	                case 72 /* BreakKeyword */:
	                    return parseBreakOrContinueStatement(223 /* BreakStatement */);
	                case 96 /* ReturnKeyword */:
	                    return parseReturnStatement();
	                case 107 /* WithKeyword */:
	                    return parseWithStatement();
	                case 98 /* SwitchKeyword */:
	                    return parseSwitchStatement();
	                case 100 /* ThrowKeyword */:
	                    return parseThrowStatement();
	                case 102 /* TryKeyword */:
	                // Include 'catch' and 'finally' for error recovery.
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    return parseTryStatement();
	                case 78 /* DebuggerKeyword */:
	                    return parseDebuggerStatement();
	                case 57 /* AtToken */:
	                    return parseDeclaration();
	                case 120 /* AsyncKeyword */:
	                case 109 /* InterfaceKeyword */:
	                case 139 /* TypeKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 76 /* ConstKeyword */:
	                case 83 /* EnumKeyword */:
	                case 84 /* ExportKeyword */:
	                case 91 /* ImportKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 114 /* PublicKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 115 /* StaticKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                case 143 /* GlobalKeyword */:
	                    if (isStartOfDeclaration()) {
	                        return parseDeclaration();
	                    }
	                    break;
	            }
	            return parseExpressionOrLabeledStatement();
	        }
	        function isDeclareModifier(modifier) {
	            return modifier.kind === 124 /* DeclareKeyword */;
	        }
	        function parseDeclaration() {
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers();
	            if (ts.some(node.modifiers, isDeclareModifier)) {
	                for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                    var m = _a[_i];
	                    m.flags |= 4194304 /* Ambient */;
	                }
	                return doInsideOfContext(4194304 /* Ambient */, function () { return parseDeclarationWorker(node); });
	            }
	            else {
	                return parseDeclarationWorker(node);
	            }
	        }
	        function parseDeclarationWorker(node) {
	            switch (token()) {
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 76 /* ConstKeyword */:
	                    return parseVariableStatement(node);
	                case 89 /* FunctionKeyword */:
	                    return parseFunctionDeclaration(node);
	                case 75 /* ClassKeyword */:
	                    return parseClassDeclaration(node);
	                case 109 /* InterfaceKeyword */:
	                    return parseInterfaceDeclaration(node);
	                case 139 /* TypeKeyword */:
	                    return parseTypeAliasDeclaration(node);
	                case 83 /* EnumKeyword */:
	                    return parseEnumDeclaration(node);
	                case 143 /* GlobalKeyword */:
	                case 129 /* ModuleKeyword */:
	                case 130 /* NamespaceKeyword */:
	                    return parseModuleDeclaration(node);
	                case 91 /* ImportKeyword */:
	                    return parseImportDeclarationOrImportEqualsDeclaration(node);
	                case 84 /* ExportKeyword */:
	                    nextToken();
	                    switch (token()) {
	                        case 79 /* DefaultKeyword */:
	                        case 58 /* EqualsToken */:
	                            return parseExportAssignment(node);
	                        case 118 /* AsKeyword */:
	                            return parseNamespaceExportDeclaration(node);
	                        default:
	                            return parseExportDeclaration(node);
	                    }
	                default:
	                    if (node.decorators || node.modifiers) {
	                        // We reached this point because we encountered decorators and/or modifiers and assumed a declaration
	                        // would follow. For recovery and error reporting purposes, return an incomplete declaration.
	                        var missing = createMissingNode(252 /* MissingDeclaration */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Declaration_expected);
	                        missing.pos = node.pos;
	                        missing.decorators = node.decorators;
	                        missing.modifiers = node.modifiers;
	                        return finishNode(missing);
	                    }
	            }
	        }
	        function nextTokenIsIdentifierOrStringLiteralOnSameLine() {
	            nextToken();
	            return !scanner.hasPrecedingLineBreak() && (isIdentifier() || token() === 9 /* StringLiteral */);
	        }
	        function parseFunctionBlockOrSemicolon(flags, diagnosticMessage) {
	            if (token() !== 17 /* OpenBraceToken */ && canParseSemicolon()) {
	                parseSemicolon();
	                return;
	            }
	            return parseFunctionBlock(flags, diagnosticMessage);
	        }
	        // DECLARATIONS
	        function parseArrayBindingElement() {
	            if (token() === 26 /* CommaToken */) {
	                return createNode(205 /* OmittedExpression */);
	            }
	            var node = createNode(181 /* BindingElement */);
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            node.name = parseIdentifierOrPattern();
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        function parseObjectBindingElement() {
	            var node = createNode(181 /* BindingElement */);
	            node.dotDotDotToken = parseOptionalToken(24 /* DotDotDotToken */);
	            var tokenIsIdentifier = isIdentifier();
	            var propertyName = parsePropertyName();
	            if (tokenIsIdentifier && token() !== 56 /* ColonToken */) {
	                node.name = propertyName;
	            }
	            else {
	                parseExpected(56 /* ColonToken */);
	                node.propertyName = propertyName;
	                node.name = parseIdentifierOrPattern();
	            }
	            node.initializer = parseInitializer();
	            return finishNode(node);
	        }
	        function parseObjectBindingPattern() {
	            var node = createNode(179 /* ObjectBindingPattern */);
	            parseExpected(17 /* OpenBraceToken */);
	            node.elements = parseDelimitedList(9 /* ObjectBindingElements */, parseObjectBindingElement);
	            parseExpected(18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseArrayBindingPattern() {
	            var node = createNode(180 /* ArrayBindingPattern */);
	            parseExpected(21 /* OpenBracketToken */);
	            node.elements = parseDelimitedList(10 /* ArrayBindingElements */, parseArrayBindingElement);
	            parseExpected(22 /* CloseBracketToken */);
	            return finishNode(node);
	        }
	        function isIdentifierOrPattern() {
	            return token() === 17 /* OpenBraceToken */ || token() === 21 /* OpenBracketToken */ || isIdentifier();
	        }
	        function parseIdentifierOrPattern() {
	            if (token() === 21 /* OpenBracketToken */) {
	                return parseArrayBindingPattern();
	            }
	            if (token() === 17 /* OpenBraceToken */) {
	                return parseObjectBindingPattern();
	            }
	            return parseIdentifier();
	        }
	        function parseVariableDeclarationAllowExclamation() {
	            return parseVariableDeclaration(/*allowExclamation*/ true);
	        }
	        function parseVariableDeclaration(allowExclamation) {
	            var node = createNode(231 /* VariableDeclaration */);
	            node.name = parseIdentifierOrPattern();
	            if (allowExclamation && node.name.kind === 71 /* Identifier */ &&
	                token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                node.exclamationToken = parseTokenNode();
	            }
	            node.type = parseTypeAnnotation();
	            if (!isInOrOfKeyword(token())) {
	                node.initializer = parseInitializer();
	            }
	            return finishNode(node);
	        }
	        function parseVariableDeclarationList(inForStatementInitializer) {
	            var node = createNode(232 /* VariableDeclarationList */);
	            switch (token()) {
	                case 104 /* VarKeyword */:
	                    break;
	                case 110 /* LetKeyword */:
	                    node.flags |= 1 /* Let */;
	                    break;
	                case 76 /* ConstKeyword */:
	                    node.flags |= 2 /* Const */;
	                    break;
	                default:
	                    ts.Debug.fail();
	            }
	            nextToken();
	            // The user may have written the following:
	            //
	            //    for (let of X) { }
	            //
	            // In this case, we want to parse an empty declaration list, and then parse 'of'
	            // as a keyword. The reason this is not automatic is that 'of' is a valid identifier.
	            // So we need to look ahead to determine if 'of' should be treated as a keyword in
	            // this context.
	            // The checker will then give an error that there is an empty declaration list.
	            if (token() === 144 /* OfKeyword */ && lookAhead(canFollowContextualOfKeyword)) {
	                node.declarations = createMissingList();
	            }
	            else {
	                var savedDisallowIn = inDisallowInContext();
	                setDisallowInContext(inForStatementInitializer);
	                node.declarations = parseDelimitedList(8 /* VariableDeclarations */, inForStatementInitializer ? parseVariableDeclaration : parseVariableDeclarationAllowExclamation);
	                setDisallowInContext(savedDisallowIn);
	            }
	            return finishNode(node);
	        }
	        function canFollowContextualOfKeyword() {
	            return nextTokenIsIdentifier() && nextToken() === 20 /* CloseParenToken */;
	        }
	        function parseVariableStatement(node) {
	            node.kind = 213 /* VariableStatement */;
	            node.declarationList = parseVariableDeclarationList(/*inForStatementInitializer*/ false);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseFunctionDeclaration(node) {
	            node.kind = 233 /* FunctionDeclaration */;
	            parseExpected(89 /* FunctionKeyword */);
	            node.asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            node.name = ts.hasModifier(node, 512 /* Default */) ? parseOptionalIdentifier() : parseIdentifier();
	            var isGenerator = node.asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, ts.Diagnostics.or_expected);
	            return finishNode(node);
	        }
	        function parseConstructorDeclaration(node) {
	            node.kind = 154 /* Constructor */;
	            parseExpected(123 /* ConstructorKeyword */);
	            fillSignature(56 /* ColonToken */, 0 /* None */, node);
	            node.body = parseFunctionBlockOrSemicolon(0 /* None */, ts.Diagnostics.or_expected);
	            return finishNode(node);
	        }
	        function parseMethodDeclaration(node, asteriskToken, diagnosticMessage) {
	            node.kind = 153 /* MethodDeclaration */;
	            node.asteriskToken = asteriskToken;
	            var isGenerator = asteriskToken ? 1 /* Yield */ : 0 /* None */;
	            var isAsync = ts.hasModifier(node, 256 /* Async */) ? 2 /* Await */ : 0 /* None */;
	            fillSignature(56 /* ColonToken */, isGenerator | isAsync, node);
	            node.body = parseFunctionBlockOrSemicolon(isGenerator | isAsync, diagnosticMessage);
	            return finishNode(node);
	        }
	        function parsePropertyDeclaration(node) {
	            node.kind = 151 /* PropertyDeclaration */;
	            if (!node.questionToken && token() === 51 /* ExclamationToken */ && !scanner.hasPrecedingLineBreak()) {
	                node.exclamationToken = parseTokenNode();
	            }
	            node.type = parseTypeAnnotation();
	            // For instance properties specifically, since they are evaluated inside the constructor,
	            // we do *not * want to parse yield expressions, so we specifically turn the yield context
	            // off. The grammar would look something like this:
	            //
	            //    MemberVariableDeclaration[Yield]:
	            //        AccessibilityModifier_opt PropertyName TypeAnnotation_opt Initializer_opt[In];
	            //        AccessibilityModifier_opt static_opt PropertyName TypeAnnotation_opt Initializer_opt[In, ?Yield];
	            //
	            // The checker may still error in the static case to explicitly disallow the yield expression.
	            node.initializer = ts.hasModifier(node, 32 /* Static */)
	                ? allowInAnd(parseInitializer)
	                : doOutsideOfContext(4096 /* YieldContext */ | 2048 /* DisallowInContext */, parseInitializer);
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parsePropertyOrMethodDeclaration(node) {
	            var asteriskToken = parseOptionalToken(39 /* AsteriskToken */);
	            node.name = parsePropertyName();
	            // Note: this is not legal as per the grammar.  But we allow it in the parser and
	            // report an error in the grammar checker.
	            node.questionToken = parseOptionalToken(55 /* QuestionToken */);
	            if (asteriskToken || token() === 19 /* OpenParenToken */ || token() === 27 /* LessThanToken */) {
	                return parseMethodDeclaration(node, asteriskToken, ts.Diagnostics.or_expected);
	            }
	            return parsePropertyDeclaration(node);
	        }
	        function parseAccessorDeclaration(node, kind) {
	            node.kind = kind;
	            node.name = parsePropertyName();
	            fillSignature(56 /* ColonToken */, 0 /* None */, node);
	            node.body = parseFunctionBlockOrSemicolon(0 /* None */);
	            return finishNode(node);
	        }
	        function isClassMemberStart() {
	            var idToken;
	            if (token() === 57 /* AtToken */) {
	                return true;
	            }
	            // Eat up all modifiers, but hold on to the last one in case it is actually an identifier.
	            while (ts.isModifierKind(token())) {
	                idToken = token();
	                // If the idToken is a class modifier (protected, private, public, and static), it is
	                // certain that we are starting to parse class member. This allows better error recovery
	                // Example:
	                //      public foo() ...     // true
	                //      public @dec blah ... // true; we will then report an error later
	                //      export public ...    // true; we will then report an error later
	                if (ts.isClassMemberModifier(idToken)) {
	                    return true;
	                }
	                nextToken();
	            }
	            if (token() === 39 /* AsteriskToken */) {
	                return true;
	            }
	            // Try to get the first property-like token following all modifiers.
	            // This can either be an identifier or the 'get' or 'set' keywords.
	            if (isLiteralPropertyName()) {
	                idToken = token();
	                nextToken();
	            }
	            // Index signatures and computed properties are class members; we can parse.
	            if (token() === 21 /* OpenBracketToken */) {
	                return true;
	            }
	            // If we were able to get any potential identifier...
	            if (idToken !== undefined) {
	                // If we have a non-keyword identifier, or if we have an accessor, then it's safe to parse.
	                if (!ts.isKeyword(idToken) || idToken === 136 /* SetKeyword */ || idToken === 125 /* GetKeyword */) {
	                    return true;
	                }
	                // If it *is* a keyword, but not an accessor, check a little farther along
	                // to see if it should actually be parsed as a class member.
	                switch (token()) {
	                    case 19 /* OpenParenToken */: // Method declaration
	                    case 27 /* LessThanToken */: // Generic Method declaration
	                    case 51 /* ExclamationToken */: // Non-null assertion on property name
	                    case 56 /* ColonToken */: // Type Annotation for declaration
	                    case 58 /* EqualsToken */: // Initializer for declaration
	                    case 55 /* QuestionToken */: // Not valid, but permitted so that it gets caught later on.
	                        return true;
	                    default:
	                        // Covers
	                        //  - Semicolons     (declaration termination)
	                        //  - Closing braces (end-of-class, must be declaration)
	                        //  - End-of-files   (not valid, but permitted so that it gets caught later on)
	                        //  - Line-breaks    (enabling *automatic semicolon insertion*)
	                        return canParseSemicolon();
	                }
	            }
	            return false;
	        }
	        function parseDecorators() {
	            var list;
	            var listPos = getNodePos();
	            while (true) {
	                var decoratorStart = getNodePos();
	                if (!parseOptional(57 /* AtToken */)) {
	                    break;
	                }
	                var decorator = createNode(149 /* Decorator */, decoratorStart);
	                decorator.expression = doInDecoratorContext(parseLeftHandSideExpressionOrHigher);
	                finishNode(decorator);
	                (list || (list = [])).push(decorator);
	            }
	            return list && createNodeArray(list, listPos);
	        }
	        /*
	         * There are situations in which a modifier like 'const' will appear unexpectedly, such as on a class member.
	         * In those situations, if we are entirely sure that 'const' is not valid on its own (such as when ASI takes effect
	         * and turns it into a standalone declaration), then it is better to parse it and report an error later.
	         *
	         * In such situations, 'permitInvalidConstAsModifier' should be set to true.
	         */
	        function parseModifiers(permitInvalidConstAsModifier) {
	            var list;
	            var listPos = getNodePos();
	            while (true) {
	                var modifierStart = scanner.getStartPos();
	                var modifierKind = token();
	                if (token() === 76 /* ConstKeyword */ && permitInvalidConstAsModifier) {
	                    // We need to ensure that any subsequent modifiers appear on the same line
	                    // so that when 'const' is a standalone declaration, we don't issue an error.
	                    if (!tryParse(nextTokenIsOnSameLineAndCanFollowModifier)) {
	                        break;
	                    }
	                }
	                else {
	                    if (!parseAnyContextualModifier()) {
	                        break;
	                    }
	                }
	                var modifier = finishNode(createNode(modifierKind, modifierStart));
	                (list || (list = [])).push(modifier);
	            }
	            return list && createNodeArray(list, listPos);
	        }
	        function parseModifiersForArrowFunction() {
	            var modifiers;
	            if (token() === 120 /* AsyncKeyword */) {
	                var modifierStart = scanner.getStartPos();
	                var modifierKind = token();
	                nextToken();
	                var modifier = finishNode(createNode(modifierKind, modifierStart));
	                modifiers = createNodeArray([modifier], modifierStart);
	            }
	            return modifiers;
	        }
	        function parseClassElement() {
	            if (token() === 25 /* SemicolonToken */) {
	                var result = createNode(211 /* SemicolonClassElement */);
	                nextToken();
	                return finishNode(result);
	            }
	            var node = createNodeWithJSDoc(0 /* Unknown */);
	            node.decorators = parseDecorators();
	            node.modifiers = parseModifiers(/*permitInvalidConstAsModifier*/ true);
	            if (parseContextualModifier(125 /* GetKeyword */)) {
	                return parseAccessorDeclaration(node, 155 /* GetAccessor */);
	            }
	            if (parseContextualModifier(136 /* SetKeyword */)) {
	                return parseAccessorDeclaration(node, 156 /* SetAccessor */);
	            }
	            if (token() === 123 /* ConstructorKeyword */) {
	                return parseConstructorDeclaration(node);
	            }
	            if (isIndexSignature()) {
	                return parseIndexSignatureDeclaration(node);
	            }
	            // It is very important that we check this *after* checking indexers because
	            // the [ token can start an index signature or a computed property name
	            if (ts.tokenIsIdentifierOrKeyword(token()) ||
	                token() === 9 /* StringLiteral */ ||
	                token() === 8 /* NumericLiteral */ ||
	                token() === 39 /* AsteriskToken */ ||
	                token() === 21 /* OpenBracketToken */) {
	                return parsePropertyOrMethodDeclaration(node);
	            }
	            if (node.decorators || node.modifiers) {
	                // treat this as a property declaration with a missing name.
	                node.name = createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Declaration_expected);
	                return parsePropertyDeclaration(node);
	            }
	            // 'isClassMemberStart' should have hinted not to attempt parsing.
	            ts.Debug.fail("Should not have attempted to parse class member declaration.");
	        }
	        function parseClassExpression() {
	            return parseClassDeclarationOrExpression(createNodeWithJSDoc(0 /* Unknown */), 204 /* ClassExpression */);
	        }
	        function parseClassDeclaration(node) {
	            return parseClassDeclarationOrExpression(node, 234 /* ClassDeclaration */);
	        }
	        function parseClassDeclarationOrExpression(node, kind) {
	            node.kind = kind;
	            parseExpected(75 /* ClassKeyword */);
	            node.name = parseNameOfClassDeclarationOrExpression();
	            node.typeParameters = parseTypeParameters();
	            node.heritageClauses = parseHeritageClauses();
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                // ClassTail[Yield,Await] : (Modified) See 14.5
	                //      ClassHeritage[?Yield,?Await]opt { ClassBody[?Yield,?Await]opt }
	                node.members = parseClassMembers();
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.members = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseNameOfClassDeclarationOrExpression() {
	            // implements is a future reserved word so
	            // 'class implements' might mean either
	            // - class expression with omitted name, 'implements' starts heritage clause
	            // - class with name 'implements'
	            // 'isImplementsClause' helps to disambiguate between these two cases
	            return isIdentifier() && !isImplementsClause()
	                ? parseIdentifier()
	                : undefined;
	        }
	        function isImplementsClause() {
	            return token() === 108 /* ImplementsKeyword */ && lookAhead(nextTokenIsIdentifierOrKeyword);
	        }
	        function parseHeritageClauses() {
	            // ClassTail[Yield,Await] : (Modified) See 14.5
	            //      ClassHeritage[?Yield,?Await]opt { ClassBody[?Yield,?Await]opt }
	            if (isHeritageClause()) {
	                return parseList(21 /* HeritageClauses */, parseHeritageClause);
	            }
	            return undefined;
	        }
	        function parseHeritageClause() {
	            var tok = token();
	            if (tok === 85 /* ExtendsKeyword */ || tok === 108 /* ImplementsKeyword */) {
	                var node = createNode(267 /* HeritageClause */);
	                node.token = tok;
	                nextToken();
	                node.types = parseDelimitedList(7 /* HeritageClauseElement */, parseExpressionWithTypeArguments);
	                return finishNode(node);
	            }
	            return undefined;
	        }
	        function parseExpressionWithTypeArguments() {
	            var node = createNode(206 /* ExpressionWithTypeArguments */);
	            node.expression = parseLeftHandSideExpressionOrHigher();
	            node.typeArguments = tryParseTypeArguments();
	            return finishNode(node);
	        }
	        function tryParseTypeArguments() {
	            return token() === 27 /* LessThanToken */
	                ? parseBracketedList(19 /* TypeArguments */, parseType, 27 /* LessThanToken */, 29 /* GreaterThanToken */)
	                : undefined;
	        }
	        function isHeritageClause() {
	            return token() === 85 /* ExtendsKeyword */ || token() === 108 /* ImplementsKeyword */;
	        }
	        function parseClassMembers() {
	            return parseList(5 /* ClassMembers */, parseClassElement);
	        }
	        function parseInterfaceDeclaration(node) {
	            node.kind = 235 /* InterfaceDeclaration */;
	            parseExpected(109 /* InterfaceKeyword */);
	            node.name = parseIdentifier();
	            node.typeParameters = parseTypeParameters();
	            node.heritageClauses = parseHeritageClauses();
	            node.members = parseObjectTypeMembers();
	            return finishNode(node);
	        }
	        function parseTypeAliasDeclaration(node) {
	            node.kind = 236 /* TypeAliasDeclaration */;
	            parseExpected(139 /* TypeKeyword */);
	            node.name = parseIdentifier();
	            node.typeParameters = parseTypeParameters();
	            parseExpected(58 /* EqualsToken */);
	            node.type = parseType();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        // In an ambient declaration, the grammar only allows integer literals as initializers.
	        // In a non-ambient declaration, the grammar allows uninitialized members only in a
	        // ConstantEnumMemberSection, which starts at the beginning of an enum declaration
	        // or any time an integer literal initializer is encountered.
	        function parseEnumMember() {
	            var node = createNodeWithJSDoc(272 /* EnumMember */);
	            node.name = parsePropertyName();
	            node.initializer = allowInAnd(parseInitializer);
	            return finishNode(node);
	        }
	        function parseEnumDeclaration(node) {
	            node.kind = 237 /* EnumDeclaration */;
	            parseExpected(83 /* EnumKeyword */);
	            node.name = parseIdentifier();
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                node.members = parseDelimitedList(6 /* EnumMembers */, parseEnumMember);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.members = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseModuleBlock() {
	            var node = createNode(239 /* ModuleBlock */);
	            if (parseExpected(17 /* OpenBraceToken */)) {
	                node.statements = parseList(1 /* BlockStatements */, parseStatement);
	                parseExpected(18 /* CloseBraceToken */);
	            }
	            else {
	                node.statements = createMissingList();
	            }
	            return finishNode(node);
	        }
	        function parseModuleOrNamespaceDeclaration(node, flags) {
	            node.kind = 238 /* ModuleDeclaration */;
	            // If we are parsing a dotted namespace name, we want to
	            // propagate the 'Namespace' flag across the names if set.
	            var namespaceFlag = flags & 16 /* Namespace */;
	            node.flags |= flags;
	            node.name = parseIdentifier();
	            node.body = parseOptional(23 /* DotToken */)
	                ? parseModuleOrNamespaceDeclaration(createNode(0 /* Unknown */), 4 /* NestedNamespace */ | namespaceFlag)
	                : parseModuleBlock();
	            return finishNode(node);
	        }
	        function parseAmbientExternalModuleDeclaration(node) {
	            node.kind = 238 /* ModuleDeclaration */;
	            if (token() === 143 /* GlobalKeyword */) {
	                // parse 'global' as name of global scope augmentation
	                node.name = parseIdentifier();
	                node.flags |= 512 /* GlobalAugmentation */;
	            }
	            else {
	                node.name = parseLiteralNode();
	                node.name.text = internIdentifier(node.name.text);
	            }
	            if (token() === 17 /* OpenBraceToken */) {
	                node.body = parseModuleBlock();
	            }
	            else {
	                parseSemicolon();
	            }
	            return finishNode(node);
	        }
	        function parseModuleDeclaration(node) {
	            var flags = 0;
	            if (token() === 143 /* GlobalKeyword */) {
	                // global augmentation
	                return parseAmbientExternalModuleDeclaration(node);
	            }
	            else if (parseOptional(130 /* NamespaceKeyword */)) {
	                flags |= 16 /* Namespace */;
	            }
	            else {
	                parseExpected(129 /* ModuleKeyword */);
	                if (token() === 9 /* StringLiteral */) {
	                    return parseAmbientExternalModuleDeclaration(node);
	                }
	            }
	            return parseModuleOrNamespaceDeclaration(node, flags);
	        }
	        function isExternalModuleReference() {
	            return token() === 133 /* RequireKeyword */ &&
	                lookAhead(nextTokenIsOpenParen);
	        }
	        function nextTokenIsOpenParen() {
	            return nextToken() === 19 /* OpenParenToken */;
	        }
	        function nextTokenIsSlash() {
	            return nextToken() === 41 /* SlashToken */;
	        }
	        function parseNamespaceExportDeclaration(node) {
	            node.kind = 241 /* NamespaceExportDeclaration */;
	            parseExpected(118 /* AsKeyword */);
	            parseExpected(130 /* NamespaceKeyword */);
	            node.name = parseIdentifier();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportDeclarationOrImportEqualsDeclaration(node) {
	            parseExpected(91 /* ImportKeyword */);
	            var afterImportPos = scanner.getStartPos();
	            var identifier;
	            if (isIdentifier()) {
	                identifier = parseIdentifier();
	                if (token() !== 26 /* CommaToken */ && token() !== 142 /* FromKeyword */) {
	                    return parseImportEqualsDeclaration(node, identifier);
	                }
	            }
	            // Import statement
	            node.kind = 243 /* ImportDeclaration */;
	            // ImportDeclaration:
	            //  import ImportClause from ModuleSpecifier ;
	            //  import ModuleSpecifier;
	            if (identifier || // import id
	                token() === 39 /* AsteriskToken */ || // import *
	                token() === 17 /* OpenBraceToken */) { // import {
	                node.importClause = parseImportClause(identifier, afterImportPos);
	                parseExpected(142 /* FromKeyword */);
	            }
	            node.moduleSpecifier = parseModuleSpecifier();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportEqualsDeclaration(node, identifier) {
	            node.kind = 242 /* ImportEqualsDeclaration */;
	            node.name = identifier;
	            parseExpected(58 /* EqualsToken */);
	            node.moduleReference = parseModuleReference();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseImportClause(identifier, fullStart) {
	            // ImportClause:
	            //  ImportedDefaultBinding
	            //  NameSpaceImport
	            //  NamedImports
	            //  ImportedDefaultBinding, NameSpaceImport
	            //  ImportedDefaultBinding, NamedImports
	            var importClause = createNode(244 /* ImportClause */, fullStart);
	            if (identifier) {
	                // ImportedDefaultBinding:
	                //  ImportedBinding
	                importClause.name = identifier;
	            }
	            // If there was no default import or if there is comma token after default import
	            // parse namespace or named imports
	            if (!importClause.name ||
	                parseOptional(26 /* CommaToken */)) {
	                importClause.namedBindings = token() === 39 /* AsteriskToken */ ? parseNamespaceImport() : parseNamedImportsOrExports(246 /* NamedImports */);
	            }
	            return finishNode(importClause);
	        }
	        function parseModuleReference() {
	            return isExternalModuleReference()
	                ? parseExternalModuleReference()
	                : parseEntityName(/*allowReservedWords*/ false);
	        }
	        function parseExternalModuleReference() {
	            var node = createNode(253 /* ExternalModuleReference */);
	            parseExpected(133 /* RequireKeyword */);
	            parseExpected(19 /* OpenParenToken */);
	            node.expression = parseModuleSpecifier();
	            parseExpected(20 /* CloseParenToken */);
	            return finishNode(node);
	        }
	        function parseModuleSpecifier() {
	            if (token() === 9 /* StringLiteral */) {
	                var result = parseLiteralNode();
	                result.text = internIdentifier(result.text);
	                return result;
	            }
	            else {
	                // We allow arbitrary expressions here, even though the grammar only allows string
	                // literals.  We check to ensure that it is only a string literal later in the grammar
	                // check pass.
	                return parseExpression();
	            }
	        }
	        function parseNamespaceImport() {
	            // NameSpaceImport:
	            //  * as ImportedBinding
	            var namespaceImport = createNode(245 /* NamespaceImport */);
	            parseExpected(39 /* AsteriskToken */);
	            parseExpected(118 /* AsKeyword */);
	            namespaceImport.name = parseIdentifier();
	            return finishNode(namespaceImport);
	        }
	        function parseNamedImportsOrExports(kind) {
	            var node = createNode(kind);
	            // NamedImports:
	            //  { }
	            //  { ImportsList }
	            //  { ImportsList, }
	            // ImportsList:
	            //  ImportSpecifier
	            //  ImportsList, ImportSpecifier
	            node.elements = parseBracketedList(22 /* ImportOrExportSpecifiers */, kind === 246 /* NamedImports */ ? parseImportSpecifier : parseExportSpecifier, 17 /* OpenBraceToken */, 18 /* CloseBraceToken */);
	            return finishNode(node);
	        }
	        function parseExportSpecifier() {
	            return parseImportOrExportSpecifier(251 /* ExportSpecifier */);
	        }
	        function parseImportSpecifier() {
	            return parseImportOrExportSpecifier(247 /* ImportSpecifier */);
	        }
	        function parseImportOrExportSpecifier(kind) {
	            var node = createNode(kind);
	            // ImportSpecifier:
	            //   BindingIdentifier
	            //   IdentifierName as BindingIdentifier
	            // ExportSpecifier:
	            //   IdentifierName
	            //   IdentifierName as IdentifierName
	            var checkIdentifierIsKeyword = ts.isKeyword(token()) && !isIdentifier();
	            var checkIdentifierStart = scanner.getTokenPos();
	            var checkIdentifierEnd = scanner.getTextPos();
	            var identifierName = parseIdentifierName();
	            if (token() === 118 /* AsKeyword */) {
	                node.propertyName = identifierName;
	                parseExpected(118 /* AsKeyword */);
	                checkIdentifierIsKeyword = ts.isKeyword(token()) && !isIdentifier();
	                checkIdentifierStart = scanner.getTokenPos();
	                checkIdentifierEnd = scanner.getTextPos();
	                node.name = parseIdentifierName();
	            }
	            else {
	                node.name = identifierName;
	            }
	            if (kind === 247 /* ImportSpecifier */ && checkIdentifierIsKeyword) {
	                parseErrorAt(checkIdentifierStart, checkIdentifierEnd, ts.Diagnostics.Identifier_expected);
	            }
	            return finishNode(node);
	        }
	        function parseExportDeclaration(node) {
	            node.kind = 249 /* ExportDeclaration */;
	            if (parseOptional(39 /* AsteriskToken */)) {
	                parseExpected(142 /* FromKeyword */);
	                node.moduleSpecifier = parseModuleSpecifier();
	            }
	            else {
	                node.exportClause = parseNamedImportsOrExports(250 /* NamedExports */);
	                // It is not uncommon to accidentally omit the 'from' keyword. Additionally, in editing scenarios,
	                // the 'from' keyword can be parsed as a named export when the export clause is unterminated (i.e. `export { from "moduleName";`)
	                // If we don't have a 'from' keyword, see if we have a string literal such that ASI won't take effect.
	                if (token() === 142 /* FromKeyword */ || (token() === 9 /* StringLiteral */ && !scanner.hasPrecedingLineBreak())) {
	                    parseExpected(142 /* FromKeyword */);
	                    node.moduleSpecifier = parseModuleSpecifier();
	                }
	            }
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function parseExportAssignment(node) {
	            node.kind = 248 /* ExportAssignment */;
	            if (parseOptional(58 /* EqualsToken */)) {
	                node.isExportEquals = true;
	            }
	            else {
	                parseExpected(79 /* DefaultKeyword */);
	            }
	            node.expression = parseAssignmentExpressionOrHigher();
	            parseSemicolon();
	            return finishNode(node);
	        }
	        function setExternalModuleIndicator(sourceFile) {
	            // Try to use the first top-level import/export when available, then
	            // fall back to looking for an 'import.meta' somewhere in the tree if necessary.
	            sourceFile.externalModuleIndicator =
	                ts.forEach(sourceFile.statements, isAnExternalModuleIndicatorNode) ||
	                    getImportMetaIfNecessary(sourceFile);
	        }
	        function isAnExternalModuleIndicatorNode(node) {
	            return ts.hasModifier(node, 1 /* Export */)
	                || node.kind === 242 /* ImportEqualsDeclaration */ && node.moduleReference.kind === 253 /* ExternalModuleReference */
	                || node.kind === 243 /* ImportDeclaration */
	                || node.kind === 248 /* ExportAssignment */
	                || node.kind === 249 /* ExportDeclaration */
	                ? node
	                : undefined;
	        }
	        function getImportMetaIfNecessary(sourceFile) {
	            return sourceFile.flags & 1048576 /* PossiblyContainsImportMeta */ ?
	                walkTreeForExternalModuleIndicators(sourceFile) :
	                undefined;
	        }
	        function walkTreeForExternalModuleIndicators(node) {
	            return isImportMeta(node) ? node : forEachChild(node, walkTreeForExternalModuleIndicators);
	        }
	        function isImportMeta(node) {
	            return ts.isMetaProperty(node) && node.keywordToken === 91 /* ImportKeyword */ && node.name.escapedText === "meta";
	        }
	        var ParsingContext;
	        (function (ParsingContext) {
	            ParsingContext[ParsingContext["SourceElements"] = 0] = "SourceElements";
	            ParsingContext[ParsingContext["BlockStatements"] = 1] = "BlockStatements";
	            ParsingContext[ParsingContext["SwitchClauses"] = 2] = "SwitchClauses";
	            ParsingContext[ParsingContext["SwitchClauseStatements"] = 3] = "SwitchClauseStatements";
	            ParsingContext[ParsingContext["TypeMembers"] = 4] = "TypeMembers";
	            ParsingContext[ParsingContext["ClassMembers"] = 5] = "ClassMembers";
	            ParsingContext[ParsingContext["EnumMembers"] = 6] = "EnumMembers";
	            ParsingContext[ParsingContext["HeritageClauseElement"] = 7] = "HeritageClauseElement";
	            ParsingContext[ParsingContext["VariableDeclarations"] = 8] = "VariableDeclarations";
	            ParsingContext[ParsingContext["ObjectBindingElements"] = 9] = "ObjectBindingElements";
	            ParsingContext[ParsingContext["ArrayBindingElements"] = 10] = "ArrayBindingElements";
	            ParsingContext[ParsingContext["ArgumentExpressions"] = 11] = "ArgumentExpressions";
	            ParsingContext[ParsingContext["ObjectLiteralMembers"] = 12] = "ObjectLiteralMembers";
	            ParsingContext[ParsingContext["JsxAttributes"] = 13] = "JsxAttributes";
	            ParsingContext[ParsingContext["JsxChildren"] = 14] = "JsxChildren";
	            ParsingContext[ParsingContext["ArrayLiteralMembers"] = 15] = "ArrayLiteralMembers";
	            ParsingContext[ParsingContext["Parameters"] = 16] = "Parameters";
	            ParsingContext[ParsingContext["RestProperties"] = 17] = "RestProperties";
	            ParsingContext[ParsingContext["TypeParameters"] = 18] = "TypeParameters";
	            ParsingContext[ParsingContext["TypeArguments"] = 19] = "TypeArguments";
	            ParsingContext[ParsingContext["TupleElementTypes"] = 20] = "TupleElementTypes";
	            ParsingContext[ParsingContext["HeritageClauses"] = 21] = "HeritageClauses";
	            ParsingContext[ParsingContext["ImportOrExportSpecifiers"] = 22] = "ImportOrExportSpecifiers";
	            ParsingContext[ParsingContext["Count"] = 23] = "Count"; // Number of parsing contexts
	        })(ParsingContext || (ParsingContext = {}));
	        var Tristate;
	        (function (Tristate) {
	            Tristate[Tristate["False"] = 0] = "False";
	            Tristate[Tristate["True"] = 1] = "True";
	            Tristate[Tristate["Unknown"] = 2] = "Unknown";
	        })(Tristate || (Tristate = {}));
	        var JSDocParser;
	        (function (JSDocParser) {
	            function parseJSDocTypeExpressionForTests(content, start, length) {
	                initializeState(content, 6 /* Latest */, /*_syntaxCursor:*/ undefined, 1 /* JS */);
	                sourceFile = createSourceFile("file.js", 6 /* Latest */, 1 /* JS */, /*isDeclarationFile*/ false);
	                scanner.setText(content, start, length);
	                currentToken = scanner.scan();
	                var jsDocTypeExpression = parseJSDocTypeExpression();
	                var diagnostics = parseDiagnostics;
	                clearState();
	                return jsDocTypeExpression ? { jsDocTypeExpression: jsDocTypeExpression, diagnostics: diagnostics } : undefined;
	            }
	            JSDocParser.parseJSDocTypeExpressionForTests = parseJSDocTypeExpressionForTests;
	            // Parses out a JSDoc type expression.
	            function parseJSDocTypeExpression(mayOmitBraces) {
	                var result = createNode(277 /* JSDocTypeExpression */, scanner.getTokenPos());
	                var hasBrace = (mayOmitBraces ? parseOptional : parseExpected)(17 /* OpenBraceToken */);
	                result.type = doInsideOfContext(2097152 /* JSDoc */, parseJSDocType);
	                if (!mayOmitBraces || hasBrace) {
	                    parseExpected(18 /* CloseBraceToken */);
	                }
	                fixupParentReferences(result);
	                return finishNode(result);
	            }
	            JSDocParser.parseJSDocTypeExpression = parseJSDocTypeExpression;
	            function parseIsolatedJSDocComment(content, start, length) {
	                initializeState(content, 6 /* Latest */, /*_syntaxCursor:*/ undefined, 1 /* JS */);
	                sourceFile = { languageVariant: 0 /* Standard */, text: content }; // tslint:disable-line no-object-literal-type-assertion
	                var jsDoc = parseJSDocCommentWorker(start, length);
	                var diagnostics = parseDiagnostics;
	                clearState();
	                return jsDoc ? { jsDoc: jsDoc, diagnostics: diagnostics } : undefined;
	            }
	            JSDocParser.parseIsolatedJSDocComment = parseIsolatedJSDocComment;
	            function parseJSDocComment(parent, start, length) {
	                var _a;
	                var saveToken = currentToken;
	                var saveParseDiagnosticsLength = parseDiagnostics.length;
	                var saveParseErrorBeforeNextFinishedNode = parseErrorBeforeNextFinishedNode;
	                var comment = parseJSDocCommentWorker(start, length);
	                if (comment) {
	                    comment.parent = parent;
	                }
	                if (contextFlags & 65536 /* JavaScriptFile */) {
	                    if (!sourceFile.jsDocDiagnostics) {
	                        sourceFile.jsDocDiagnostics = [];
	                    }
	                    (_a = sourceFile.jsDocDiagnostics).push.apply(_a, parseDiagnostics);
	                }
	                currentToken = saveToken;
	                parseDiagnostics.length = saveParseDiagnosticsLength;
	                parseErrorBeforeNextFinishedNode = saveParseErrorBeforeNextFinishedNode;
	                return comment;
	            }
	            JSDocParser.parseJSDocComment = parseJSDocComment;
	            var JSDocState;
	            (function (JSDocState) {
	                JSDocState[JSDocState["BeginningOfLine"] = 0] = "BeginningOfLine";
	                JSDocState[JSDocState["SawAsterisk"] = 1] = "SawAsterisk";
	                JSDocState[JSDocState["SavingComments"] = 2] = "SavingComments";
	            })(JSDocState || (JSDocState = {}));
	            var PropertyLikeParse;
	            (function (PropertyLikeParse) {
	                PropertyLikeParse[PropertyLikeParse["Property"] = 1] = "Property";
	                PropertyLikeParse[PropertyLikeParse["Parameter"] = 2] = "Parameter";
	                PropertyLikeParse[PropertyLikeParse["CallbackParameter"] = 4] = "CallbackParameter";
	            })(PropertyLikeParse || (PropertyLikeParse = {}));
	            function parseJSDocCommentWorker(start, length) {
	                var content = sourceText;
	                start = start || 0;
	                var end = length === undefined ? content.length : start + length;
	                length = end - start;
	                ts.Debug.assert(start >= 0);
	                ts.Debug.assert(start <= end);
	                ts.Debug.assert(end <= content.length);
	                var tags;
	                var tagsPos;
	                var tagsEnd;
	                var comments = [];
	                var result;
	                // Check for /** (JSDoc opening part)
	                if (!isJSDocLikeText(content, start)) {
	                    return result;
	                }
	                // + 3 for leading /**, - 5 in total for /** */
	                scanner.scanRange(start + 3, length - 5, function () {
	                    // Initially we can parse out a tag.  We also have seen a starting asterisk.
	                    // This is so that /** * @type */ doesn't parse.
	                    var state = 1 /* SawAsterisk */;
	                    var margin;
	                    // + 4 for leading '/** '
	                    var indent = start - Math.max(content.lastIndexOf("\n", start), 0) + 4;
	                    function pushComment(text) {
	                        if (!margin) {
	                            margin = indent;
	                        }
	                        comments.push(text);
	                        indent += text.length;
	                    }
	                    var t = nextJSDocToken();
	                    while (t === 5 /* WhitespaceTrivia */) {
	                        t = nextJSDocToken();
	                    }
	                    if (t === 4 /* NewLineTrivia */) {
	                        state = 0 /* BeginningOfLine */;
	                        indent = 0;
	                        t = nextJSDocToken();
	                    }
	                    loop: while (true) {
	                        switch (t) {
	                            case 57 /* AtToken */:
	                                if (state === 0 /* BeginningOfLine */ || state === 1 /* SawAsterisk */) {
	                                    removeTrailingNewlines(comments);
	                                    addTag(parseTag(indent));
	                                    // NOTE: According to usejsdoc.org, a tag goes to end of line, except the last tag.
	                                    // Real-world comments may break this rule, so "BeginningOfLine" will not be a real line beginning
	                                    // for malformed examples like `/** @param {string} x @returns {number} the length */`
	                                    state = 0 /* BeginningOfLine */;
	                                    margin = undefined;
	                                    indent++;
	                                }
	                                else {
	                                    pushComment(scanner.getTokenText());
	                                }
	                                break;
	                            case 4 /* NewLineTrivia */:
	                                comments.push(scanner.getTokenText());
	                                state = 0 /* BeginningOfLine */;
	                                indent = 0;
	                                break;
	                            case 39 /* AsteriskToken */:
	                                var asterisk = scanner.getTokenText();
	                                if (state === 1 /* SawAsterisk */ || state === 2 /* SavingComments */) {
	                                    // If we've already seen an asterisk, then we can no longer parse a tag on this line
	                                    state = 2 /* SavingComments */;
	                                    pushComment(asterisk);
	                                }
	                                else {
	                                    // Ignore the first asterisk on a line
	                                    state = 1 /* SawAsterisk */;
	                                    indent += asterisk.length;
	                                }
	                                break;
	                            case 71 /* Identifier */:
	                                // Anything else is doc comment text. We just save it. Because it
	                                // wasn't a tag, we can no longer parse a tag on this line until we hit the next
	                                // line break.
	                                pushComment(scanner.getTokenText());
	                                state = 2 /* SavingComments */;
	                                break;
	                            case 5 /* WhitespaceTrivia */:
	                                // only collect whitespace if we're already saving comments or have just crossed the comment indent margin
	                                var whitespace = scanner.getTokenText();
	                                if (state === 2 /* SavingComments */) {
	                                    comments.push(whitespace);
	                                }
	                                else if (margin !== undefined && indent + whitespace.length > margin) {
	                                    comments.push(whitespace.slice(margin - indent - 1));
	                                }
	                                indent += whitespace.length;
	                                break;
	                            case 1 /* EndOfFileToken */:
	                                break loop;
	                            default:
	                                // anything other than whitespace or asterisk at the beginning of the line starts the comment text
	                                state = 2 /* SavingComments */;
	                                pushComment(scanner.getTokenText());
	                                break;
	                        }
	                        t = nextJSDocToken();
	                    }
	                    removeLeadingNewlines(comments);
	                    removeTrailingNewlines(comments);
	                    result = createJSDocComment();
	                });
	                return result;
	                function removeLeadingNewlines(comments) {
	                    while (comments.length && (comments[0] === "\n" || comments[0] === "\r")) {
	                        comments.shift();
	                    }
	                }
	                function removeTrailingNewlines(comments) {
	                    while (comments.length && (comments[comments.length - 1] === "\n" || comments[comments.length - 1] === "\r")) {
	                        comments.pop();
	                    }
	                }
	                function createJSDocComment() {
	                    var result = createNode(285 /* JSDocComment */, start);
	                    result.tags = tags && createNodeArray(tags, tagsPos, tagsEnd);
	                    result.comment = comments.length ? comments.join("") : undefined;
	                    return finishNode(result, end);
	                }
	                function isNextNonwhitespaceTokenEndOfFile() {
	                    // We must use infinite lookahead, as there could be any number of newlines :(
	                    while (true) {
	                        nextJSDocToken();
	                        if (token() === 1 /* EndOfFileToken */) {
	                            return true;
	                        }
	                        if (!(token() === 5 /* WhitespaceTrivia */ || token() === 4 /* NewLineTrivia */)) {
	                            return false;
	                        }
	                    }
	                }
	                function skipWhitespace() {
	                    if (token() === 5 /* WhitespaceTrivia */ || token() === 4 /* NewLineTrivia */) {
	                        if (lookAhead(isNextNonwhitespaceTokenEndOfFile)) {
	                            return; // Don't skip whitespace prior to EoF (or end of comment) - that shouldn't be included in any node's range
	                        }
	                    }
	                    while (token() === 5 /* WhitespaceTrivia */ || token() === 4 /* NewLineTrivia */) {
	                        nextJSDocToken();
	                    }
	                }
	                function parseTag(indent) {
	                    ts.Debug.assert(token() === 57 /* AtToken */);
	                    var atToken = createNode(57 /* AtToken */, scanner.getTokenPos());
	                    atToken.end = scanner.getTextPos();
	                    nextJSDocToken();
	                    var tagName = parseJSDocIdentifierName();
	                    skipWhitespace();
	                    if (!tagName) {
	                        return;
	                    }
	                    var tag;
	                    if (tagName) {
	                        switch (tagName.escapedText) {
	                            case "augments":
	                            case "extends":
	                                tag = parseAugmentsTag(atToken, tagName);
	                                break;
	                            case "class":
	                            case "constructor":
	                                tag = parseClassTag(atToken, tagName);
	                                break;
	                            case "arg":
	                            case "argument":
	                            case "param":
	                                return parseParameterOrPropertyTag(atToken, tagName, 2 /* Parameter */, indent);
	                            case "return":
	                            case "returns":
	                                tag = parseReturnTag(atToken, tagName);
	                                break;
	                            case "template":
	                                tag = parseTemplateTag(atToken, tagName);
	                                break;
	                            case "type":
	                                tag = parseTypeTag(atToken, tagName);
	                                break;
	                            case "typedef":
	                                tag = parseTypedefTag(atToken, tagName, indent);
	                                break;
	                            case "callback":
	                                tag = parseCallbackTag(atToken, tagName, indent);
	                                break;
	                            default:
	                                tag = parseUnknownTag(atToken, tagName);
	                                break;
	                        }
	                    }
	                    else {
	                        tag = parseUnknownTag(atToken, tagName);
	                    }
	                    if (!tag) {
	                        // a badly malformed tag should not be added to the list of tags
	                        return;
	                    }
	                    if (!tag.comment) {
	                        // some tags, like typedef and callback, have already parsed their comments earlier
	                        tag.comment = parseTagComments(indent + tag.end - tag.pos);
	                    }
	                    return tag;
	                }
	                function parseTagComments(indent) {
	                    var comments = [];
	                    var state = 0 /* BeginningOfLine */;
	                    var margin;
	                    function pushComment(text) {
	                        if (!margin) {
	                            margin = indent;
	                        }
	                        comments.push(text);
	                        indent += text.length;
	                    }
	                    var tok = token();
	                    loop: while (true) {
	                        switch (tok) {
	                            case 4 /* NewLineTrivia */:
	                                if (state >= 1 /* SawAsterisk */) {
	                                    state = 0 /* BeginningOfLine */;
	                                    comments.push(scanner.getTokenText());
	                                }
	                                indent = 0;
	                                break;
	                            case 57 /* AtToken */:
	                                scanner.setTextPos(scanner.getTextPos() - 1);
	                            // falls through
	                            case 1 /* EndOfFileToken */:
	                                // Done
	                                break loop;
	                            case 5 /* WhitespaceTrivia */:
	                                if (state === 2 /* SavingComments */) {
	                                    pushComment(scanner.getTokenText());
	                                }
	                                else {
	                                    var whitespace = scanner.getTokenText();
	                                    // if the whitespace crosses the margin, take only the whitespace that passes the margin
	                                    if (margin !== undefined && indent + whitespace.length > margin) {
	                                        comments.push(whitespace.slice(margin - indent - 1));
	                                    }
	                                    indent += whitespace.length;
	                                }
	                                break;
	                            case 39 /* AsteriskToken */:
	                                if (state === 0 /* BeginningOfLine */) {
	                                    // leading asterisks start recording on the *next* (non-whitespace) token
	                                    state = 1 /* SawAsterisk */;
	                                    indent += 1;
	                                    break;
	                                }
	                            // record the * as a comment
	                            // falls through
	                            default:
	                                state = 2 /* SavingComments */; // leading identifiers start recording as well
	                                pushComment(scanner.getTokenText());
	                                break;
	                        }
	                        tok = nextJSDocToken();
	                    }
	                    removeLeadingNewlines(comments);
	                    removeTrailingNewlines(comments);
	                    return comments.length === 0 ? undefined : comments.join("");
	                }
	                function parseUnknownTag(atToken, tagName) {
	                    var result = createNode(288 /* JSDocTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    return finishNode(result);
	                }
	                function addTag(tag) {
	                    if (!tag) {
	                        return;
	                    }
	                    if (!tags) {
	                        tags = [tag];
	                        tagsPos = tag.pos;
	                    }
	                    else {
	                        tags.push(tag);
	                    }
	                    tagsEnd = tag.end;
	                }
	                function tryParseTypeExpression() {
	                    skipWhitespace();
	                    return token() === 17 /* OpenBraceToken */ ? parseJSDocTypeExpression() : undefined;
	                }
	                function parseBracketNameInPropertyAndParamTag() {
	                    if (token() === 13 /* NoSubstitutionTemplateLiteral */) {
	                        // a markdown-quoted name: `arg` is not legal jsdoc, but occurs in the wild
	                        return { name: createIdentifier(/*isIdentifier*/ true), isBracketed: false };
	                    }
	                    // Looking for something like '[foo]', 'foo', '[foo.bar]' or 'foo.bar'
	                    var isBracketed = parseOptional(21 /* OpenBracketToken */);
	                    var name = parseJSDocEntityName();
	                    if (isBracketed) {
	                        skipWhitespace();
	                        // May have an optional default, e.g. '[foo = 42]'
	                        if (parseOptionalToken(58 /* EqualsToken */)) {
	                            parseExpression();
	                        }
	                        parseExpected(22 /* CloseBracketToken */);
	                    }
	                    return { name: name, isBracketed: isBracketed };
	                }
	                function isObjectOrObjectArrayTypeReference(node) {
	                    switch (node.kind) {
	                        case 135 /* ObjectKeyword */:
	                            return true;
	                        case 166 /* ArrayType */:
	                            return isObjectOrObjectArrayTypeReference(node.elementType);
	                        default:
	                            return ts.isTypeReferenceNode(node) && ts.isIdentifier(node.typeName) && node.typeName.escapedText === "Object";
	                    }
	                }
	                function parseParameterOrPropertyTag(atToken, tagName, target, indent) {
	                    var typeExpression = tryParseTypeExpression();
	                    var isNameFirst = !typeExpression;
	                    skipWhitespace();
	                    var _a = parseBracketNameInPropertyAndParamTag(), name = _a.name, isBracketed = _a.isBracketed;
	                    skipWhitespace();
	                    if (isNameFirst) {
	                        typeExpression = tryParseTypeExpression();
	                    }
	                    var result = target === 1 /* Property */ ?
	                        createNode(297 /* JSDocPropertyTag */, atToken.pos) :
	                        createNode(292 /* JSDocParameterTag */, atToken.pos);
	                    var comment;
	                    if (indent !== undefined)
	                        comment = parseTagComments(indent + scanner.getStartPos() - atToken.pos);
	                    var nestedTypeLiteral = target !== 4 /* CallbackParameter */ && parseNestedTypeLiteral(typeExpression, name, target);
	                    if (nestedTypeLiteral) {
	                        typeExpression = nestedTypeLiteral;
	                        isNameFirst = true;
	                    }
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = typeExpression;
	                    result.name = name;
	                    result.isNameFirst = isNameFirst;
	                    result.isBracketed = isBracketed;
	                    result.comment = comment;
	                    return finishNode(result);
	                }
	                function parseNestedTypeLiteral(typeExpression, name, target) {
	                    if (typeExpression && isObjectOrObjectArrayTypeReference(typeExpression.type)) {
	                        var typeLiteralExpression = createNode(277 /* JSDocTypeExpression */, scanner.getTokenPos());
	                        var child = void 0;
	                        var jsdocTypeLiteral = void 0;
	                        var start_2 = scanner.getStartPos();
	                        var children = void 0;
	                        while (child = tryParse(function () { return parseChildParameterOrPropertyTag(target, name); })) {
	                            if (child.kind === 292 /* JSDocParameterTag */ || child.kind === 297 /* JSDocPropertyTag */) {
	                                children = ts.append(children, child);
	                            }
	                        }
	                        if (children) {
	                            jsdocTypeLiteral = createNode(286 /* JSDocTypeLiteral */, start_2);
	                            jsdocTypeLiteral.jsDocPropertyTags = children;
	                            if (typeExpression.type.kind === 166 /* ArrayType */) {
	                                jsdocTypeLiteral.isArrayType = true;
	                            }
	                            typeLiteralExpression.type = finishNode(jsdocTypeLiteral);
	                            return finishNode(typeLiteralExpression);
	                        }
	                    }
	                }
	                function parseReturnTag(atToken, tagName) {
	                    if (ts.forEach(tags, function (t) { return t.kind === 293 /* JSDocReturnTag */; })) {
	                        parseErrorAt(tagName.pos, scanner.getTokenPos(), ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    var result = createNode(293 /* JSDocReturnTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = tryParseTypeExpression();
	                    return finishNode(result);
	                }
	                function parseTypeTag(atToken, tagName) {
	                    if (ts.forEach(tags, function (t) { return t.kind === 294 /* JSDocTypeTag */; })) {
	                        parseErrorAt(tagName.pos, scanner.getTokenPos(), ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    var result = createNode(294 /* JSDocTypeTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeExpression = parseJSDocTypeExpression(/*mayOmitBraces*/ true);
	                    return finishNode(result);
	                }
	                function parseAugmentsTag(atToken, tagName) {
	                    var result = createNode(289 /* JSDocAugmentsTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.class = parseExpressionWithTypeArgumentsForAugments();
	                    return finishNode(result);
	                }
	                function parseExpressionWithTypeArgumentsForAugments() {
	                    var usedBrace = parseOptional(17 /* OpenBraceToken */);
	                    var node = createNode(206 /* ExpressionWithTypeArguments */);
	                    node.expression = parsePropertyAccessEntityNameExpression();
	                    node.typeArguments = tryParseTypeArguments();
	                    var res = finishNode(node);
	                    if (usedBrace) {
	                        parseExpected(18 /* CloseBraceToken */);
	                    }
	                    return res;
	                }
	                function parsePropertyAccessEntityNameExpression() {
	                    var node = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                    while (parseOptional(23 /* DotToken */)) {
	                        var prop = createNode(184 /* PropertyAccessExpression */, node.pos);
	                        prop.expression = node;
	                        prop.name = parseJSDocIdentifierName();
	                        node = finishNode(prop);
	                    }
	                    return node;
	                }
	                function parseClassTag(atToken, tagName) {
	                    var tag = createNode(290 /* JSDocClassTag */, atToken.pos);
	                    tag.atToken = atToken;
	                    tag.tagName = tagName;
	                    return finishNode(tag);
	                }
	                function parseTypedefTag(atToken, tagName, indent) {
	                    var typeExpression = tryParseTypeExpression();
	                    skipWhitespace();
	                    var typedefTag = createNode(296 /* JSDocTypedefTag */, atToken.pos);
	                    typedefTag.atToken = atToken;
	                    typedefTag.tagName = tagName;
	                    typedefTag.fullName = parseJSDocTypeNameWithNamespace();
	                    typedefTag.name = getJSDocTypeAliasName(typedefTag.fullName);
	                    skipWhitespace();
	                    typedefTag.comment = parseTagComments(indent);
	                    typedefTag.typeExpression = typeExpression;
	                    var end;
	                    if (!typeExpression || isObjectOrObjectArrayTypeReference(typeExpression.type)) {
	                        var child = void 0;
	                        var jsdocTypeLiteral = void 0;
	                        var childTypeTag = void 0;
	                        var start_3 = scanner.getStartPos();
	                        while (child = tryParse(function () { return parseChildPropertyTag(); })) {
	                            if (!jsdocTypeLiteral) {
	                                jsdocTypeLiteral = createNode(286 /* JSDocTypeLiteral */, start_3);
	                            }
	                            if (child.kind === 294 /* JSDocTypeTag */) {
	                                if (childTypeTag) {
	                                    break;
	                                }
	                                else {
	                                    childTypeTag = child;
	                                }
	                            }
	                            else {
	                                jsdocTypeLiteral.jsDocPropertyTags = ts.append(jsdocTypeLiteral.jsDocPropertyTags, child);
	                            }
	                        }
	                        if (jsdocTypeLiteral) {
	                            if (typeExpression && typeExpression.type.kind === 166 /* ArrayType */) {
	                                jsdocTypeLiteral.isArrayType = true;
	                            }
	                            typedefTag.typeExpression = childTypeTag && childTypeTag.typeExpression && !isObjectOrObjectArrayTypeReference(childTypeTag.typeExpression.type) ?
	                                childTypeTag.typeExpression :
	                                finishNode(jsdocTypeLiteral);
	                            end = typedefTag.typeExpression.end;
	                        }
	                    }
	                    // Only include the characters between the name end and the next token if a comment was actually parsed out - otherwise it's just whitespace
	                    return finishNode(typedefTag, end || typedefTag.comment !== undefined ? scanner.getStartPos() : (typedefTag.fullName || typedefTag.typeExpression || typedefTag.tagName).end);
	                }
	                function parseJSDocTypeNameWithNamespace(nested) {
	                    var pos = scanner.getTokenPos();
	                    var typeNameOrNamespaceName = parseJSDocIdentifierName();
	                    if (typeNameOrNamespaceName && parseOptional(23 /* DotToken */)) {
	                        var jsDocNamespaceNode = createNode(238 /* ModuleDeclaration */, pos);
	                        if (nested) {
	                            jsDocNamespaceNode.flags |= 4 /* NestedNamespace */;
	                        }
	                        jsDocNamespaceNode.name = typeNameOrNamespaceName;
	                        jsDocNamespaceNode.body = parseJSDocTypeNameWithNamespace(/*nested*/ true);
	                        return finishNode(jsDocNamespaceNode);
	                    }
	                    if (typeNameOrNamespaceName && nested) {
	                        typeNameOrNamespaceName.isInJSDocNamespace = true;
	                    }
	                    return typeNameOrNamespaceName;
	                }
	                function parseCallbackTag(atToken, tagName, indent) {
	                    var callbackTag = createNode(291 /* JSDocCallbackTag */, atToken.pos);
	                    callbackTag.atToken = atToken;
	                    callbackTag.tagName = tagName;
	                    callbackTag.fullName = parseJSDocTypeNameWithNamespace();
	                    callbackTag.name = getJSDocTypeAliasName(callbackTag.fullName);
	                    skipWhitespace();
	                    callbackTag.comment = parseTagComments(indent);
	                    var child;
	                    var start = scanner.getStartPos();
	                    var jsdocSignature = createNode(287 /* JSDocSignature */, start);
	                    jsdocSignature.parameters = [];
	                    while (child = tryParse(function () { return parseChildParameterOrPropertyTag(4 /* CallbackParameter */); })) {
	                        jsdocSignature.parameters = ts.append(jsdocSignature.parameters, child);
	                    }
	                    var returnTag = tryParse(function () {
	                        if (token() === 57 /* AtToken */) {
	                            nextJSDocToken();
	                            var tag = parseTag(indent);
	                            if (tag && tag.kind === 293 /* JSDocReturnTag */) {
	                                return tag;
	                            }
	                        }
	                    });
	                    if (returnTag) {
	                        jsdocSignature.type = returnTag;
	                    }
	                    callbackTag.typeExpression = finishNode(jsdocSignature);
	                    return finishNode(callbackTag);
	                }
	                function getJSDocTypeAliasName(fullName) {
	                    if (fullName) {
	                        var rightNode = fullName;
	                        while (true) {
	                            if (ts.isIdentifier(rightNode) || !rightNode.body) {
	                                return ts.isIdentifier(rightNode) ? rightNode : rightNode.name;
	                            }
	                            rightNode = rightNode.body;
	                        }
	                    }
	                }
	                function escapedTextsEqual(a, b) {
	                    while (!ts.isIdentifier(a) || !ts.isIdentifier(b)) {
	                        if (!ts.isIdentifier(a) && !ts.isIdentifier(b) && a.right.escapedText === b.right.escapedText) {
	                            a = a.left;
	                            b = b.left;
	                        }
	                        else {
	                            return false;
	                        }
	                    }
	                    return a.escapedText === b.escapedText;
	                }
	                function parseChildPropertyTag() {
	                    return parseChildParameterOrPropertyTag(1 /* Property */);
	                }
	                function parseChildParameterOrPropertyTag(target, name) {
	                    var canParseTag = true;
	                    var seenAsterisk = false;
	                    while (true) {
	                        switch (nextJSDocToken()) {
	                            case 57 /* AtToken */:
	                                if (canParseTag) {
	                                    var child = tryParseChildTag(target);
	                                    if (child && child.kind === 292 /* JSDocParameterTag */ &&
	                                        target !== 4 /* CallbackParameter */ &&
	                                        (ts.isIdentifier(child.name) || !escapedTextsEqual(name, child.name.left))) {
	                                        return false;
	                                    }
	                                    return child;
	                                }
	                                seenAsterisk = false;
	                                break;
	                            case 4 /* NewLineTrivia */:
	                                canParseTag = true;
	                                seenAsterisk = false;
	                                break;
	                            case 39 /* AsteriskToken */:
	                                if (seenAsterisk) {
	                                    canParseTag = false;
	                                }
	                                seenAsterisk = true;
	                                break;
	                            case 71 /* Identifier */:
	                                canParseTag = false;
	                                break;
	                            case 1 /* EndOfFileToken */:
	                                return false;
	                        }
	                    }
	                }
	                function tryParseChildTag(target) {
	                    ts.Debug.assert(token() === 57 /* AtToken */);
	                    var atToken = createNode(57 /* AtToken */);
	                    atToken.end = scanner.getTextPos();
	                    nextJSDocToken();
	                    var tagName = parseJSDocIdentifierName();
	                    skipWhitespace();
	                    if (!tagName) {
	                        return false;
	                    }
	                    var t;
	                    switch (tagName.escapedText) {
	                        case "type":
	                            return target === 1 /* Property */ && parseTypeTag(atToken, tagName);
	                        case "prop":
	                        case "property":
	                            t = 1 /* Property */;
	                            break;
	                        case "arg":
	                        case "argument":
	                        case "param":
	                            t = 2 /* Parameter */ | 4 /* CallbackParameter */;
	                            break;
	                        default:
	                            return false;
	                    }
	                    if (!(target & t)) {
	                        return false;
	                    }
	                    var tag = parseParameterOrPropertyTag(atToken, tagName, target, /*indent*/ undefined);
	                    tag.comment = parseTagComments(tag.end - tag.pos);
	                    return tag;
	                }
	                function parseTemplateTag(atToken, tagName) {
	                    if (ts.some(tags, ts.isJSDocTemplateTag)) {
	                        parseErrorAt(tagName.pos, scanner.getTokenPos(), ts.Diagnostics._0_tag_already_specified, tagName.escapedText);
	                    }
	                    // Type parameter list looks like '@template T,U,V'
	                    var typeParameters = [];
	                    var typeParametersPos = getNodePos();
	                    while (true) {
	                        var typeParameter = createNode(147 /* TypeParameter */);
	                        var name = parseJSDocIdentifierNameWithOptionalBraces();
	                        skipWhitespace();
	                        if (!name) {
	                            parseErrorAtPosition(scanner.getStartPos(), 0, ts.Diagnostics.Identifier_expected);
	                            return undefined;
	                        }
	                        typeParameter.name = name;
	                        finishNode(typeParameter);
	                        typeParameters.push(typeParameter);
	                        if (token() === 26 /* CommaToken */) {
	                            nextJSDocToken();
	                            skipWhitespace();
	                        }
	                        else {
	                            break;
	                        }
	                    }
	                    var result = createNode(295 /* JSDocTemplateTag */, atToken.pos);
	                    result.atToken = atToken;
	                    result.tagName = tagName;
	                    result.typeParameters = createNodeArray(typeParameters, typeParametersPos);
	                    finishNode(result);
	                    return result;
	                }
	                function parseJSDocIdentifierNameWithOptionalBraces() {
	                    var parsedBrace = parseOptional(17 /* OpenBraceToken */);
	                    var res = parseJSDocIdentifierName();
	                    if (parsedBrace) {
	                        parseExpected(18 /* CloseBraceToken */);
	                    }
	                    return res;
	                }
	                function nextJSDocToken() {
	                    return currentToken = scanner.scanJSDocToken();
	                }
	                function parseJSDocEntityName() {
	                    var entity = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                    if (parseOptional(21 /* OpenBracketToken */)) {
	                        parseExpected(22 /* CloseBracketToken */);
	                        // Note that y[] is accepted as an entity name, but the postfix brackets are not saved for checking.
	                        // Technically usejsdoc.org requires them for specifying a property of a type equivalent to Array<{ x: ...}>
	                        // but it's not worth it to enforce that restriction.
	                    }
	                    while (parseOptional(23 /* DotToken */)) {
	                        var name = parseJSDocIdentifierName(/*createIfMissing*/ true);
	                        if (parseOptional(21 /* OpenBracketToken */)) {
	                            parseExpected(22 /* CloseBracketToken */);
	                        }
	                        entity = createQualifiedName(entity, name);
	                    }
	                    return entity;
	                }
	                function parseJSDocIdentifierName(createIfMissing) {
	                    if (createIfMissing === void 0) { createIfMissing = false; }
	                    if (!ts.tokenIsIdentifierOrKeyword(token())) {
	                        if (createIfMissing) {
	                            return createMissingNode(71 /* Identifier */, /*reportAtCurrentPosition*/ true, ts.Diagnostics.Identifier_expected);
	                        }
	                        else {
	                            parseErrorAtCurrentToken(ts.Diagnostics.Identifier_expected);
	                            return undefined;
	                        }
	                    }
	                    var pos = scanner.getTokenPos();
	                    var end = scanner.getTextPos();
	                    var result = createNode(71 /* Identifier */, pos);
	                    result.escapedText = ts.escapeLeadingUnderscores(scanner.getTokenText());
	                    finishNode(result, end);
	                    nextJSDocToken();
	                    return result;
	                }
	            }
	            JSDocParser.parseJSDocCommentWorker = parseJSDocCommentWorker;
	        })(JSDocParser = Parser.JSDocParser || (Parser.JSDocParser = {}));
	    })(Parser || (Parser = {}));
	    var IncrementalParser;
	    (function (IncrementalParser) {
	        function updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks) {
	            aggressiveChecks = aggressiveChecks || ts.Debug.shouldAssert(2 /* Aggressive */);
	            checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks);
	            if (ts.textChangeRangeIsUnchanged(textChangeRange)) {
	                // if the text didn't change, then we can just return our current source file as-is.
	                return sourceFile;
	            }
	            if (sourceFile.statements.length === 0) {
	                // If we don't have any statements in the current source file, then there's no real
	                // way to incrementally parse.  So just do a full parse instead.
	                return Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, /*syntaxCursor*/ undefined, /*setParentNodes*/ true, sourceFile.scriptKind);
	            }
	            // Make sure we're not trying to incrementally update a source file more than once.  Once
	            // we do an update the original source file is considered unusable from that point onwards.
	            //
	            // This is because we do incremental parsing in-place.  i.e. we take nodes from the old
	            // tree and give them new positions and parents.  From that point on, trusting the old
	            // tree at all is not possible as far too much of it may violate invariants.
	            var incrementalSourceFile = sourceFile;
	            ts.Debug.assert(!incrementalSourceFile.hasBeenIncrementallyParsed);
	            incrementalSourceFile.hasBeenIncrementallyParsed = true;
	            var oldText = sourceFile.text;
	            var syntaxCursor = createSyntaxCursor(sourceFile);
	            // Make the actual change larger so that we know to reparse anything whose lookahead
	            // might have intersected the change.
	            var changeRange = extendToAffectedRange(sourceFile, textChangeRange);
	            checkChangeRange(sourceFile, newText, changeRange, aggressiveChecks);
	            // Ensure that extending the affected range only moved the start of the change range
	            // earlier in the file.
	            ts.Debug.assert(changeRange.span.start <= textChangeRange.span.start);
	            ts.Debug.assert(ts.textSpanEnd(changeRange.span) === ts.textSpanEnd(textChangeRange.span));
	            ts.Debug.assert(ts.textSpanEnd(ts.textChangeRangeNewSpan(changeRange)) === ts.textSpanEnd(ts.textChangeRangeNewSpan(textChangeRange)));
	            // The is the amount the nodes after the edit range need to be adjusted.  It can be
	            // positive (if the edit added characters), negative (if the edit deleted characters)
	            // or zero (if this was a pure overwrite with nothing added/removed).
	            var delta = ts.textChangeRangeNewSpan(changeRange).length - changeRange.span.length;
	            // If we added or removed characters during the edit, then we need to go and adjust all
	            // the nodes after the edit.  Those nodes may move forward (if we inserted chars) or they
	            // may move backward (if we deleted chars).
	            //
	            // Doing this helps us out in two ways.  First, it means that any nodes/tokens we want
	            // to reuse are already at the appropriate position in the new text.  That way when we
	            // reuse them, we don't have to figure out if they need to be adjusted.  Second, it makes
	            // it very easy to determine if we can reuse a node.  If the node's position is at where
	            // we are in the text, then we can reuse it.  Otherwise we can't.  If the node's position
	            // is ahead of us, then we'll need to rescan tokens.  If the node's position is behind
	            // us, then we'll need to skip it or crumble it as appropriate
	            //
	            // We will also adjust the positions of nodes that intersect the change range as well.
	            // By doing this, we ensure that all the positions in the old tree are consistent, not
	            // just the positions of nodes entirely before/after the change range.  By being
	            // consistent, we can then easily map from positions to nodes in the old tree easily.
	            //
	            // Also, mark any syntax elements that intersect the changed span.  We know, up front,
	            // that we cannot reuse these elements.
	            updateTokenPositionsAndMarkElements(incrementalSourceFile, changeRange.span.start, ts.textSpanEnd(changeRange.span), ts.textSpanEnd(ts.textChangeRangeNewSpan(changeRange)), delta, oldText, newText, aggressiveChecks);
	            // Now that we've set up our internal incremental state just proceed and parse the
	            // source file in the normal fashion.  When possible the parser will retrieve and
	            // reuse nodes from the old tree.
	            //
	            // Note: passing in 'true' for setNodeParents is very important.  When incrementally
	            // parsing, we will be reusing nodes from the old tree, and placing it into new
	            // parents.  If we don't set the parents now, we'll end up with an observably
	            // inconsistent tree.  Setting the parents on the new tree should be very fast.  We
	            // will immediately bail out of walking any subtrees when we can see that their parents
	            // are already correct.
	            var result = Parser.parseSourceFile(sourceFile.fileName, newText, sourceFile.languageVersion, syntaxCursor, /*setParentNodes*/ true, sourceFile.scriptKind);
	            return result;
	        }
	        IncrementalParser.updateSourceFile = updateSourceFile;
	        function moveElementEntirelyPastChangeRange(element, isArray, delta, oldText, newText, aggressiveChecks) {
	            if (isArray) {
	                visitArray(element);
	            }
	            else {
	                visitNode(element);
	            }
	            return;
	            function visitNode(node) {
	                var text = "";
	                if (aggressiveChecks && shouldCheckNode(node)) {
	                    text = oldText.substring(node.pos, node.end);
	                }
	                // Ditch any existing LS children we may have created.  This way we can avoid
	                // moving them forward.
	                if (node._children) {
	                    node._children = undefined;
	                }
	                node.pos += delta;
	                node.end += delta;
	                if (aggressiveChecks && shouldCheckNode(node)) {
	                    ts.Debug.assert(text === newText.substring(node.pos, node.end));
	                }
	                forEachChild(node, visitNode, visitArray);
	                if (ts.hasJSDocNodes(node)) {
	                    for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                        var jsDocComment = _a[_i];
	                        visitNode(jsDocComment);
	                    }
	                }
	                checkNodePositions(node, aggressiveChecks);
	            }
	            function visitArray(array) {
	                array._children = undefined;
	                array.pos += delta;
	                array.end += delta;
	                for (var _i = 0, array_8 = array; _i < array_8.length; _i++) {
	                    var node = array_8[_i];
	                    visitNode(node);
	                }
	            }
	        }
	        function shouldCheckNode(node) {
	            switch (node.kind) {
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 71 /* Identifier */:
	                    return true;
	            }
	            return false;
	        }
	        function adjustIntersectingElement(element, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta) {
	            ts.Debug.assert(element.end >= changeStart, "Adjusting an element that was entirely before the change range");
	            ts.Debug.assert(element.pos <= changeRangeOldEnd, "Adjusting an element that was entirely after the change range");
	            ts.Debug.assert(element.pos <= element.end);
	            // We have an element that intersects the change range in some way.  It may have its
	            // start, or its end (or both) in the changed range.  We want to adjust any part
	            // that intersects such that the final tree is in a consistent state.  i.e. all
	            // children have spans within the span of their parent, and all siblings are ordered
	            // properly.
	            // We may need to update both the 'pos' and the 'end' of the element.
	            // If the 'pos' is before the start of the change, then we don't need to touch it.
	            // If it isn't, then the 'pos' must be inside the change.  How we update it will
	            // depend if delta is positive or negative. If delta is positive then we have
	            // something like:
	            //
	            //  -------------------AAA-----------------
	            //  -------------------BBBCCCCCCC-----------------
	            //
	            // In this case, we consider any node that started in the change range to still be
	            // starting at the same position.
	            //
	            // however, if the delta is negative, then we instead have something like this:
	            //
	            //  -------------------XXXYYYYYYY-----------------
	            //  -------------------ZZZ-----------------
	            //
	            // In this case, any element that started in the 'X' range will keep its position.
	            // However any element that started after that will have their pos adjusted to be
	            // at the end of the new range.  i.e. any node that started in the 'Y' range will
	            // be adjusted to have their start at the end of the 'Z' range.
	            //
	            // The element will keep its position if possible.  Or Move backward to the new-end
	            // if it's in the 'Y' range.
	            element.pos = Math.min(element.pos, changeRangeNewEnd);
	            // If the 'end' is after the change range, then we always adjust it by the delta
	            // amount.  However, if the end is in the change range, then how we adjust it
	            // will depend on if delta is positive or negative.  If delta is positive then we
	            // have something like:
	            //
	            //  -------------------AAA-----------------
	            //  -------------------BBBCCCCCCC-----------------
	            //
	            // In this case, we consider any node that ended inside the change range to keep its
	            // end position.
	            //
	            // however, if the delta is negative, then we instead have something like this:
	            //
	            //  -------------------XXXYYYYYYY-----------------
	            //  -------------------ZZZ-----------------
	            //
	            // In this case, any element that ended in the 'X' range will keep its position.
	            // However any element that ended after that will have their pos adjusted to be
	            // at the end of the new range.  i.e. any node that ended in the 'Y' range will
	            // be adjusted to have their end at the end of the 'Z' range.
	            if (element.end >= changeRangeOldEnd) {
	                // Element ends after the change range.  Always adjust the end pos.
	                element.end += delta;
	            }
	            else {
	                // Element ends in the change range.  The element will keep its position if
	                // possible. Or Move backward to the new-end if it's in the 'Y' range.
	                element.end = Math.min(element.end, changeRangeNewEnd);
	            }
	            ts.Debug.assert(element.pos <= element.end);
	            if (element.parent) {
	                ts.Debug.assert(element.pos >= element.parent.pos);
	                ts.Debug.assert(element.end <= element.parent.end);
	            }
	        }
	        function checkNodePositions(node, aggressiveChecks) {
	            if (aggressiveChecks) {
	                var pos_2 = node.pos;
	                var visitNode_1 = function (child) {
	                    ts.Debug.assert(child.pos >= pos_2);
	                    pos_2 = child.end;
	                };
	                if (ts.hasJSDocNodes(node)) {
	                    for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                        var jsDocComment = _a[_i];
	                        visitNode_1(jsDocComment);
	                    }
	                }
	                forEachChild(node, visitNode_1);
	                ts.Debug.assert(pos_2 <= node.end);
	            }
	        }
	        function updateTokenPositionsAndMarkElements(sourceFile, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta, oldText, newText, aggressiveChecks) {
	            visitNode(sourceFile);
	            return;
	            function visitNode(child) {
	                ts.Debug.assert(child.pos <= child.end);
	                if (child.pos > changeRangeOldEnd) {
	                    // Node is entirely past the change range.  We need to move both its pos and
	                    // end, forward or backward appropriately.
	                    moveElementEntirelyPastChangeRange(child, /*isArray*/ false, delta, oldText, newText, aggressiveChecks);
	                    return;
	                }
	                // Check if the element intersects the change range.  If it does, then it is not
	                // reusable.  Also, we'll need to recurse to see what constituent portions we may
	                // be able to use.
	                var fullEnd = child.end;
	                if (fullEnd >= changeStart) {
	                    child.intersectsChange = true;
	                    child._children = undefined;
	                    // Adjust the pos or end (or both) of the intersecting element accordingly.
	                    adjustIntersectingElement(child, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
	                    forEachChild(child, visitNode, visitArray);
	                    if (ts.hasJSDocNodes(child)) {
	                        for (var _i = 0, _a = child.jsDoc; _i < _a.length; _i++) {
	                            var jsDocComment = _a[_i];
	                            visitNode(jsDocComment);
	                        }
	                    }
	                    checkNodePositions(child, aggressiveChecks);
	                    return;
	                }
	                // Otherwise, the node is entirely before the change range.  No need to do anything with it.
	                ts.Debug.assert(fullEnd < changeStart);
	            }
	            function visitArray(array) {
	                ts.Debug.assert(array.pos <= array.end);
	                if (array.pos > changeRangeOldEnd) {
	                    // Array is entirely after the change range.  We need to move it, and move any of
	                    // its children.
	                    moveElementEntirelyPastChangeRange(array, /*isArray*/ true, delta, oldText, newText, aggressiveChecks);
	                    return;
	                }
	                // Check if the element intersects the change range.  If it does, then it is not
	                // reusable.  Also, we'll need to recurse to see what constituent portions we may
	                // be able to use.
	                var fullEnd = array.end;
	                if (fullEnd >= changeStart) {
	                    array.intersectsChange = true;
	                    array._children = undefined;
	                    // Adjust the pos or end (or both) of the intersecting array accordingly.
	                    adjustIntersectingElement(array, changeStart, changeRangeOldEnd, changeRangeNewEnd, delta);
	                    for (var _i = 0, array_9 = array; _i < array_9.length; _i++) {
	                        var node = array_9[_i];
	                        visitNode(node);
	                    }
	                    return;
	                }
	                // Otherwise, the array is entirely before the change range.  No need to do anything with it.
	                ts.Debug.assert(fullEnd < changeStart);
	            }
	        }
	        function extendToAffectedRange(sourceFile, changeRange) {
	            // Consider the following code:
	            //      void foo() { /; }
	            //
	            // If the text changes with an insertion of / just before the semicolon then we end up with:
	            //      void foo() { //; }
	            //
	            // If we were to just use the changeRange a is, then we would not rescan the { token
	            // (as it does not intersect the actual original change range).  Because an edit may
	            // change the token touching it, we actually need to look back *at least* one token so
	            // that the prior token sees that change.
	            var maxLookahead = 1;
	            var start = changeRange.span.start;
	            // the first iteration aligns us with the change start. subsequent iteration move us to
	            // the left by maxLookahead tokens.  We only need to do this as long as we're not at the
	            // start of the tree.
	            for (var i = 0; start > 0 && i <= maxLookahead; i++) {
	                var nearestNode = findNearestNodeStartingBeforeOrAtPosition(sourceFile, start);
	                ts.Debug.assert(nearestNode.pos <= start);
	                var position = nearestNode.pos;
	                start = Math.max(0, position - 1);
	            }
	            var finalSpan = ts.createTextSpanFromBounds(start, ts.textSpanEnd(changeRange.span));
	            var finalLength = changeRange.newLength + (changeRange.span.start - start);
	            return ts.createTextChangeRange(finalSpan, finalLength);
	        }
	        function findNearestNodeStartingBeforeOrAtPosition(sourceFile, position) {
	            var bestResult = sourceFile;
	            var lastNodeEntirelyBeforePosition;
	            forEachChild(sourceFile, visit);
	            if (lastNodeEntirelyBeforePosition) {
	                var lastChildOfLastEntireNodeBeforePosition = getLastDescendant(lastNodeEntirelyBeforePosition);
	                if (lastChildOfLastEntireNodeBeforePosition.pos > bestResult.pos) {
	                    bestResult = lastChildOfLastEntireNodeBeforePosition;
	                }
	            }
	            return bestResult;
	            function getLastDescendant(node) {
	                while (true) {
	                    var lastChild = ts.getLastChild(node);
	                    if (lastChild) {
	                        node = lastChild;
	                    }
	                    else {
	                        return node;
	                    }
	                }
	            }
	            function visit(child) {
	                if (ts.nodeIsMissing(child)) {
	                    // Missing nodes are effectively invisible to us.  We never even consider them
	                    // When trying to find the nearest node before us.
	                    return;
	                }
	                // If the child intersects this position, then this node is currently the nearest
	                // node that starts before the position.
	                if (child.pos <= position) {
	                    if (child.pos >= bestResult.pos) {
	                        // This node starts before the position, and is closer to the position than
	                        // the previous best node we found.  It is now the new best node.
	                        bestResult = child;
	                    }
	                    // Now, the node may overlap the position, or it may end entirely before the
	                    // position.  If it overlaps with the position, then either it, or one of its
	                    // children must be the nearest node before the position.  So we can just
	                    // recurse into this child to see if we can find something better.
	                    if (position < child.end) {
	                        // The nearest node is either this child, or one of the children inside
	                        // of it.  We've already marked this child as the best so far.  Recurse
	                        // in case one of the children is better.
	                        forEachChild(child, visit);
	                        // Once we look at the children of this node, then there's no need to
	                        // continue any further.
	                        return true;
	                    }
	                    else {
	                        ts.Debug.assert(child.end <= position);
	                        // The child ends entirely before this position.  Say you have the following
	                        // (where $ is the position)
	                        //
	                        //      <complex expr 1> ? <complex expr 2> $ : <...> <...>
	                        //
	                        // We would want to find the nearest preceding node in "complex expr 2".
	                        // To support that, we keep track of this node, and once we're done searching
	                        // for a best node, we recurse down this node to see if we can find a good
	                        // result in it.
	                        //
	                        // This approach allows us to quickly skip over nodes that are entirely
	                        // before the position, while still allowing us to find any nodes in the
	                        // last one that might be what we want.
	                        lastNodeEntirelyBeforePosition = child;
	                    }
	                }
	                else {
	                    ts.Debug.assert(child.pos > position);
	                    // We're now at a node that is entirely past the position we're searching for.
	                    // This node (and all following nodes) could never contribute to the result,
	                    // so just skip them by returning 'true' here.
	                    return true;
	                }
	            }
	        }
	        function checkChangeRange(sourceFile, newText, textChangeRange, aggressiveChecks) {
	            var oldText = sourceFile.text;
	            if (textChangeRange) {
	                ts.Debug.assert((oldText.length - textChangeRange.span.length + textChangeRange.newLength) === newText.length);
	                if (aggressiveChecks || ts.Debug.shouldAssert(3 /* VeryAggressive */)) {
	                    var oldTextPrefix = oldText.substr(0, textChangeRange.span.start);
	                    var newTextPrefix = newText.substr(0, textChangeRange.span.start);
	                    ts.Debug.assert(oldTextPrefix === newTextPrefix);
	                    var oldTextSuffix = oldText.substring(ts.textSpanEnd(textChangeRange.span), oldText.length);
	                    var newTextSuffix = newText.substring(ts.textSpanEnd(ts.textChangeRangeNewSpan(textChangeRange)), newText.length);
	                    ts.Debug.assert(oldTextSuffix === newTextSuffix);
	                }
	            }
	        }
	        function createSyntaxCursor(sourceFile) {
	            var currentArray = sourceFile.statements;
	            var currentArrayIndex = 0;
	            ts.Debug.assert(currentArrayIndex < currentArray.length);
	            var current = currentArray[currentArrayIndex];
	            var lastQueriedPosition = -1 /* Value */;
	            return {
	                currentNode: function (position) {
	                    // Only compute the current node if the position is different than the last time
	                    // we were asked.  The parser commonly asks for the node at the same position
	                    // twice.  Once to know if can read an appropriate list element at a certain point,
	                    // and then to actually read and consume the node.
	                    if (position !== lastQueriedPosition) {
	                        // Much of the time the parser will need the very next node in the array that
	                        // we just returned a node from.So just simply check for that case and move
	                        // forward in the array instead of searching for the node again.
	                        if (current && current.end === position && currentArrayIndex < (currentArray.length - 1)) {
	                            currentArrayIndex++;
	                            current = currentArray[currentArrayIndex];
	                        }
	                        // If we don't have a node, or the node we have isn't in the right position,
	                        // then try to find a viable node at the position requested.
	                        if (!current || current.pos !== position) {
	                            findHighestListElementThatStartsAtPosition(position);
	                        }
	                    }
	                    // Cache this query so that we don't do any extra work if the parser calls back
	                    // into us.  Note: this is very common as the parser will make pairs of calls like
	                    // 'isListElement -> parseListElement'.  If we were unable to find a node when
	                    // called with 'isListElement', we don't want to redo the work when parseListElement
	                    // is called immediately after.
	                    lastQueriedPosition = position;
	                    // Either we don'd have a node, or we have a node at the position being asked for.
	                    ts.Debug.assert(!current || current.pos === position);
	                    return current;
	                }
	            };
	            // Finds the highest element in the tree we can find that starts at the provided position.
	            // The element must be a direct child of some node list in the tree.  This way after we
	            // return it, we can easily return its next sibling in the list.
	            function findHighestListElementThatStartsAtPosition(position) {
	                // Clear out any cached state about the last node we found.
	                currentArray = undefined;
	                currentArrayIndex = -1 /* Value */;
	                current = undefined;
	                // Recurse into the source file to find the highest node at this position.
	                forEachChild(sourceFile, visitNode, visitArray);
	                return;
	                function visitNode(node) {
	                    if (position >= node.pos && position < node.end) {
	                        // Position was within this node.  Keep searching deeper to find the node.
	                        forEachChild(node, visitNode, visitArray);
	                        // don't proceed any further in the search.
	                        return true;
	                    }
	                    // position wasn't in this node, have to keep searching.
	                    return false;
	                }
	                function visitArray(array) {
	                    if (position >= array.pos && position < array.end) {
	                        // position was in this array.  Search through this array to see if we find a
	                        // viable element.
	                        for (var i = 0; i < array.length; i++) {
	                            var child = array[i];
	                            if (child) {
	                                if (child.pos === position) {
	                                    // Found the right node.  We're done.
	                                    currentArray = array;
	                                    currentArrayIndex = i;
	                                    current = child;
	                                    return true;
	                                }
	                                else {
	                                    if (child.pos < position && position < child.end) {
	                                        // Position in somewhere within this child.  Search in it and
	                                        // stop searching in this array.
	                                        forEachChild(child, visitNode, visitArray);
	                                        return true;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                    // position wasn't in this array, have to keep searching.
	                    return false;
	                }
	            }
	        }
	        var InvalidPosition;
	        (function (InvalidPosition) {
	            InvalidPosition[InvalidPosition["Value"] = -1] = "Value";
	        })(InvalidPosition || (InvalidPosition = {}));
	    })(IncrementalParser || (IncrementalParser = {}));
	    function isDeclarationFileName(fileName) {
	        return ts.fileExtensionIs(fileName, ".d.ts" /* Dts */);
	    }
	    /*@internal*/
	    function processCommentPragmas(context, sourceText) {
	        var triviaScanner = ts.createScanner(context.languageVersion, /*skipTrivia*/ false, 0 /* Standard */, sourceText);
	        var pragmas = [];
	        // Keep scanning all the leading trivia in the file until we get to something that
	        // isn't trivia.  Any single line comment will be analyzed to see if it is a
	        // reference comment.
	        while (true) {
	            var kind = triviaScanner.scan();
	            if (!ts.isTrivia(kind)) {
	                break;
	            }
	            var range = {
	                kind: triviaScanner.getToken(),
	                pos: triviaScanner.getTokenPos(),
	                end: triviaScanner.getTextPos(),
	            };
	            var comment = sourceText.substring(range.pos, range.end);
	            extractPragmas(pragmas, range, comment);
	        }
	        context.pragmas = ts.createMap();
	        for (var _i = 0, pragmas_1 = pragmas; _i < pragmas_1.length; _i++) {
	            var pragma = pragmas_1[_i];
	            if (context.pragmas.has(pragma.name)) {
	                var currentValue = context.pragmas.get(pragma.name);
	                if (currentValue instanceof Array) {
	                    currentValue.push(pragma.args);
	                }
	                else {
	                    context.pragmas.set(pragma.name, [currentValue, pragma.args]);
	                }
	                continue;
	            }
	            context.pragmas.set(pragma.name, pragma.args);
	        }
	    }
	    ts.processCommentPragmas = processCommentPragmas;
	    /*@internal*/
	    function processPragmasIntoFields(context, reportDiagnostic) {
	        context.checkJsDirective = undefined;
	        context.referencedFiles = [];
	        context.typeReferenceDirectives = [];
	        context.amdDependencies = [];
	        context.hasNoDefaultLib = false;
	        context.pragmas.forEach(function (entryOrList, key) {
	            // TODO: The below should be strongly type-guarded and not need casts/explicit annotations, since entryOrList is related to
	            // key and key is constrained to a union; but it's not (see GH#21483 for at least partial fix) :(
	            switch (key) {
	                case "reference": {
	                    var referencedFiles_1 = context.referencedFiles;
	                    var typeReferenceDirectives_1 = context.typeReferenceDirectives;
	                    ts.forEach(ts.toArray(entryOrList), function (arg) {
	                        if (arg.arguments["no-default-lib"]) {
	                            context.hasNoDefaultLib = true;
	                        }
	                        else if (arg.arguments.types) {
	                            typeReferenceDirectives_1.push({ pos: arg.arguments.types.pos, end: arg.arguments.types.end, fileName: arg.arguments.types.value });
	                        }
	                        else if (arg.arguments.path) {
	                            referencedFiles_1.push({ pos: arg.arguments.path.pos, end: arg.arguments.path.end, fileName: arg.arguments.path.value });
	                        }
	                        else {
	                            reportDiagnostic(arg.range.pos, arg.range.end - arg.range.pos, ts.Diagnostics.Invalid_reference_directive_syntax);
	                        }
	                    });
	                    break;
	                }
	                case "amd-dependency": {
	                    context.amdDependencies = ts.map(ts.toArray(entryOrList), function (_a) {
	                        var _b = _a.arguments, name = _b.name, path = _b.path;
	                        return ({ name: name, path: path });
	                    });
	                    break;
	                }
	                case "amd-module": {
	                    if (entryOrList instanceof Array) {
	                        for (var _i = 0, entryOrList_1 = entryOrList; _i < entryOrList_1.length; _i++) {
	                            var entry = entryOrList_1[_i];
	                            if (context.moduleName) {
	                                // TODO: It's probably fine to issue this diagnostic on all instances of the pragma
	                                reportDiagnostic(entry.range.pos, entry.range.end - entry.range.pos, ts.Diagnostics.An_AMD_module_cannot_have_multiple_name_assignments);
	                            }
	                            context.moduleName = entry.arguments.name;
	                        }
	                    }
	                    else {
	                        context.moduleName = entryOrList.arguments.name;
	                    }
	                    break;
	                }
	                case "ts-nocheck":
	                case "ts-check": {
	                    // _last_ of either nocheck or check in a file is the "winner"
	                    ts.forEach(ts.toArray(entryOrList), function (entry) {
	                        if (!context.checkJsDirective || entry.range.pos > context.checkJsDirective.pos) {
	                            context.checkJsDirective = {
	                                enabled: key === "ts-check",
	                                end: entry.range.end,
	                                pos: entry.range.pos
	                            };
	                        }
	                    });
	                    break;
	                }
	                case "jsx": return; // Accessed directly
	                default: ts.Debug.fail("Unhandled pragma kind"); // Can this be made into an assertNever in the future?
	            }
	        });
	    }
	    ts.processPragmasIntoFields = processPragmasIntoFields;
	    var namedArgRegExCache = ts.createMap();
	    function getNamedArgRegEx(name) {
	        if (namedArgRegExCache.has(name)) {
	            return namedArgRegExCache.get(name);
	        }
	        var result = new RegExp("(\\s" + name + "\\s*=\\s*)('|\")(.+?)\\2", "im");
	        namedArgRegExCache.set(name, result);
	        return result;
	    }
	    var tripleSlashXMLCommentStartRegEx = /^\/\/\/\s*<(\S+)\s.*?\/>/im;
	    var singleLinePragmaRegEx = /^\/\/\/?\s*@(\S+)\s*(.*)\s*$/im;
	    function extractPragmas(pragmas, range, text) {
	        var tripleSlash = range.kind === 2 /* SingleLineCommentTrivia */ && tripleSlashXMLCommentStartRegEx.exec(text);
	        if (tripleSlash) {
	            var name = tripleSlash[1].toLowerCase(); // Technically unsafe cast, but we do it so the below check to make it safe typechecks
	            var pragma = ts.commentPragmas[name];
	            if (!pragma || !(pragma.kind & 1 /* TripleSlashXML */)) {
	                return;
	            }
	            if (pragma.args) {
	                var argument = {};
	                for (var _i = 0, _a = pragma.args; _i < _a.length; _i++) {
	                    var arg = _a[_i];
	                    var matcher = getNamedArgRegEx(arg.name);
	                    var matchResult = matcher.exec(text);
	                    if (!matchResult && !arg.optional) {
	                        return; // Missing required argument, don't parse
	                    }
	                    else if (matchResult) {
	                        if (arg.captureSpan) {
	                            var startPos = range.pos + matchResult.index + matchResult[1].length + matchResult[2].length;
	                            argument[arg.name] = {
	                                value: matchResult[3],
	                                pos: startPos,
	                                end: startPos + matchResult[3].length
	                            };
	                        }
	                        else {
	                            argument[arg.name] = matchResult[3];
	                        }
	                    }
	                }
	                pragmas.push({ name: name, args: { arguments: argument, range: range } });
	            }
	            else {
	                pragmas.push({ name: name, args: { arguments: {}, range: range } });
	            }
	            return;
	        }
	        var singleLine = range.kind === 2 /* SingleLineCommentTrivia */ && singleLinePragmaRegEx.exec(text);
	        if (singleLine) {
	            return addPragmaForMatch(pragmas, range, 2 /* SingleLine */, singleLine);
	        }
	        if (range.kind === 3 /* MultiLineCommentTrivia */) {
	            var multiLinePragmaRegEx = /\s*@(\S+)\s*(.*)\s*$/gim; // Defined inline since it uses the "g" flag, which keeps a persistent index (for iterating)
	            var multiLineMatch = void 0;
	            while (multiLineMatch = multiLinePragmaRegEx.exec(text)) {
	                addPragmaForMatch(pragmas, range, 4 /* MultiLine */, multiLineMatch);
	            }
	        }
	    }
	    function addPragmaForMatch(pragmas, range, kind, match) {
	        if (!match)
	            return;
	        var name = match[1].toLowerCase(); // Technically unsafe cast, but we do it so they below check to make it safe typechecks
	        var pragma = ts.commentPragmas[name];
	        if (!pragma || !(pragma.kind & kind)) {
	            return;
	        }
	        var args = match[2]; // Split on spaces and match up positionally with definition
	        var argument = getNamedPragmaArguments(pragma, args);
	        if (argument === "fail")
	            return; // Missing required argument, fail to parse it
	        pragmas.push({ name: name, args: { arguments: argument, range: range } });
	        return;
	    }
	    function getNamedPragmaArguments(pragma, text) {
	        if (!text)
	            return {};
	        if (!pragma.args)
	            return {};
	        var args = text.split(/\s+/);
	        var argMap = {};
	        for (var i = 0; i < pragma.args.length; i++) {
	            var argument = pragma.args[i];
	            if (!args[i] && !argument.optional) {
	                return "fail";
	            }
	            if (argument.captureSpan) {
	                return ts.Debug.fail("Capture spans not yet implemented for non-xml pragmas");
	            }
	            argMap[argument.name] = args[i];
	        }
	        return argMap;
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var ModuleInstanceState;
	    (function (ModuleInstanceState) {
	        ModuleInstanceState[ModuleInstanceState["NonInstantiated"] = 0] = "NonInstantiated";
	        ModuleInstanceState[ModuleInstanceState["Instantiated"] = 1] = "Instantiated";
	        ModuleInstanceState[ModuleInstanceState["ConstEnumOnly"] = 2] = "ConstEnumOnly";
	    })(ModuleInstanceState = ts.ModuleInstanceState || (ts.ModuleInstanceState = {}));
	    function getModuleInstanceState(node) {
	        return node.body ? getModuleInstanceStateWorker(node.body) : 1 /* Instantiated */;
	    }
	    ts.getModuleInstanceState = getModuleInstanceState;
	    function getModuleInstanceStateWorker(node) {
	        // A module is uninstantiated if it contains only
	        switch (node.kind) {
	            // 1. interface declarations, type alias declarations
	            case 235 /* InterfaceDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	                return 0 /* NonInstantiated */;
	            // 2. const enum declarations
	            case 237 /* EnumDeclaration */:
	                if (ts.isConst(node)) {
	                    return 2 /* ConstEnumOnly */;
	                }
	                break;
	            // 3. non-exported import declarations
	            case 243 /* ImportDeclaration */:
	            case 242 /* ImportEqualsDeclaration */:
	                if (!(ts.hasModifier(node, 1 /* Export */))) {
	                    return 0 /* NonInstantiated */;
	                }
	                break;
	            // 4. other uninstantiated module declarations.
	            case 239 /* ModuleBlock */: {
	                var state_1 = 0 /* NonInstantiated */;
	                ts.forEachChild(node, function (n) {
	                    var childState = getModuleInstanceStateWorker(n);
	                    switch (childState) {
	                        case 0 /* NonInstantiated */:
	                            // child is non-instantiated - continue searching
	                            return;
	                        case 2 /* ConstEnumOnly */:
	                            // child is const enum only - record state and continue searching
	                            state_1 = 2 /* ConstEnumOnly */;
	                            return;
	                        case 1 /* Instantiated */:
	                            // child is instantiated - record state and stop
	                            state_1 = 1 /* Instantiated */;
	                            return true;
	                        default:
	                            ts.Debug.assertNever(childState);
	                    }
	                });
	                return state_1;
	            }
	            case 238 /* ModuleDeclaration */:
	                return getModuleInstanceState(node);
	            case 71 /* Identifier */:
	                // Only jsdoc typedef definition can exist in jsdoc namespace, and it should
	                // be considered the same as type alias
	                if (node.isInJSDocNamespace) {
	                    return 0 /* NonInstantiated */;
	                }
	        }
	        return 1 /* Instantiated */;
	    }
	    var ContainerFlags;
	    (function (ContainerFlags) {
	        // The current node is not a container, and no container manipulation should happen before
	        // recursing into it.
	        ContainerFlags[ContainerFlags["None"] = 0] = "None";
	        // The current node is a container.  It should be set as the current container (and block-
	        // container) before recursing into it.  The current node does not have locals.  Examples:
	        //
	        //      Classes, ObjectLiterals, TypeLiterals, Interfaces...
	        ContainerFlags[ContainerFlags["IsContainer"] = 1] = "IsContainer";
	        // The current node is a block-scoped-container.  It should be set as the current block-
	        // container before recursing into it.  Examples:
	        //
	        //      Blocks (when not parented by functions), Catch clauses, For/For-in/For-of statements...
	        ContainerFlags[ContainerFlags["IsBlockScopedContainer"] = 2] = "IsBlockScopedContainer";
	        // The current node is the container of a control flow path. The current control flow should
	        // be saved and restored, and a new control flow initialized within the container.
	        ContainerFlags[ContainerFlags["IsControlFlowContainer"] = 4] = "IsControlFlowContainer";
	        ContainerFlags[ContainerFlags["IsFunctionLike"] = 8] = "IsFunctionLike";
	        ContainerFlags[ContainerFlags["IsFunctionExpression"] = 16] = "IsFunctionExpression";
	        ContainerFlags[ContainerFlags["HasLocals"] = 32] = "HasLocals";
	        ContainerFlags[ContainerFlags["IsInterface"] = 64] = "IsInterface";
	        ContainerFlags[ContainerFlags["IsObjectLiteralOrClassExpressionMethod"] = 128] = "IsObjectLiteralOrClassExpressionMethod";
	    })(ContainerFlags || (ContainerFlags = {}));
	    var binder = createBinder();
	    function bindSourceFile(file, options) {
	        ts.performance.mark("beforeBind");
	        binder(file, options);
	        ts.performance.mark("afterBind");
	        ts.performance.measure("Bind", "beforeBind", "afterBind");
	    }
	    ts.bindSourceFile = bindSourceFile;
	    function createBinder() {
	        var file;
	        var options;
	        var languageVersion;
	        var parent;
	        var container;
	        var thisParentContainer; // Container one level up
	        var blockScopeContainer;
	        var lastContainer;
	        var delayedTypeAliases;
	        var seenThisKeyword;
	        // state used by control flow analysis
	        var currentFlow;
	        var currentBreakTarget;
	        var currentContinueTarget;
	        var currentReturnTarget;
	        var currentTrueTarget;
	        var currentFalseTarget;
	        var preSwitchCaseFlow;
	        var activeLabels;
	        var hasExplicitReturn;
	        // state used for emit helpers
	        var emitFlags;
	        // If this file is an external module, then it is automatically in strict-mode according to
	        // ES6.  If it is not an external module, then we'll determine if it is in strict mode or
	        // not depending on if we see "use strict" in certain places or if we hit a class/namespace
	        // or if compiler options contain alwaysStrict.
	        var inStrictMode;
	        var symbolCount = 0;
	        var Symbol; // tslint:disable-line variable-name
	        var classifiableNames;
	        var unreachableFlow = { flags: 1 /* Unreachable */ };
	        var reportedUnreachableFlow = { flags: 1 /* Unreachable */ };
	        // state used to aggregate transform flags during bind.
	        var subtreeTransformFlags = 0 /* None */;
	        var skipTransformFlagAggregation;
	        /**
	         * Inside the binder, we may create a diagnostic for an as-yet unbound node (with potentially no parent pointers, implying no accessible source file)
	         * If so, the node _must_ be in the current file (as that's the only way anything could have traversed to it to yield it as the error node)
	         * This version of `createDiagnosticForNode` uses the binder's context to account for this, and always yields correct diagnostics even in these situations.
	         */
	        function createDiagnosticForNode(node, message, arg0, arg1, arg2) {
	            return ts.createDiagnosticForNodeInSourceFile(ts.getSourceFileOfNode(node) || file, node, message, arg0, arg1, arg2);
	        }
	        function bindSourceFile(f, opts) {
	            file = f;
	            options = opts;
	            languageVersion = ts.getEmitScriptTarget(options);
	            inStrictMode = bindInStrictMode(file, opts);
	            classifiableNames = ts.createUnderscoreEscapedMap();
	            symbolCount = 0;
	            skipTransformFlagAggregation = file.isDeclarationFile;
	            Symbol = ts.objectAllocator.getSymbolConstructor();
	            if (!file.locals) {
	                bind(file);
	                file.symbolCount = symbolCount;
	                file.classifiableNames = classifiableNames;
	                delayedBindJSDocTypedefTag();
	            }
	            file = undefined;
	            options = undefined;
	            languageVersion = undefined;
	            parent = undefined;
	            container = undefined;
	            thisParentContainer = undefined;
	            blockScopeContainer = undefined;
	            lastContainer = undefined;
	            delayedTypeAliases = undefined;
	            seenThisKeyword = false;
	            currentFlow = undefined;
	            currentBreakTarget = undefined;
	            currentContinueTarget = undefined;
	            currentReturnTarget = undefined;
	            currentTrueTarget = undefined;
	            currentFalseTarget = undefined;
	            activeLabels = undefined;
	            hasExplicitReturn = false;
	            emitFlags = 0 /* None */;
	            subtreeTransformFlags = 0 /* None */;
	        }
	        return bindSourceFile;
	        function bindInStrictMode(file, opts) {
	            if (ts.getStrictOptionValue(opts, "alwaysStrict") && !file.isDeclarationFile) {
	                // bind in strict mode source files with alwaysStrict option
	                return true;
	            }
	            else {
	                return !!file.externalModuleIndicator;
	            }
	        }
	        function createSymbol(flags, name) {
	            symbolCount++;
	            return new Symbol(flags, name);
	        }
	        function addDeclarationToSymbol(symbol, node, symbolFlags) {
	            symbol.flags |= symbolFlags;
	            node.symbol = symbol;
	            symbol.declarations = ts.append(symbol.declarations, node);
	            if (symbolFlags & 1952 /* HasExports */ && !symbol.exports) {
	                symbol.exports = ts.createSymbolTable();
	            }
	            if (symbolFlags & 6240 /* HasMembers */ && !symbol.members) {
	                symbol.members = ts.createSymbolTable();
	            }
	            if (symbolFlags & 67216319 /* Value */) {
	                var valueDeclaration = symbol.valueDeclaration;
	                if (!valueDeclaration ||
	                    (valueDeclaration.kind !== node.kind && valueDeclaration.kind === 238 /* ModuleDeclaration */)) {
	                    // other kinds of value declarations take precedence over modules
	                    symbol.valueDeclaration = node;
	                }
	            }
	        }
	        // Should not be called on a declaration with a computed property name,
	        // unless it is a well known Symbol.
	        function getDeclarationName(node) {
	            if (node.kind === 248 /* ExportAssignment */) {
	                return node.isExportEquals ? "export=" /* ExportEquals */ : "default" /* Default */;
	            }
	            var name = ts.getNameOfDeclaration(node);
	            if (name) {
	                if (ts.isAmbientModule(node)) {
	                    var moduleName = ts.getTextOfIdentifierOrLiteral(name);
	                    return (ts.isGlobalScopeAugmentation(node) ? "__global" : "\"" + moduleName + "\"");
	                }
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    var nameExpression = name.expression;
	                    // treat computed property names where expression is string/numeric literal as just string/numeric literal
	                    if (ts.isStringOrNumericLiteral(nameExpression)) {
	                        return ts.escapeLeadingUnderscores(nameExpression.text);
	                    }
	                    ts.Debug.assert(ts.isWellKnownSymbolSyntactically(nameExpression));
	                    return ts.getPropertyNameForKnownSymbolName(ts.idText(nameExpression.name));
	                }
	                return ts.isPropertyNameLiteral(name) ? ts.getEscapedTextOfIdentifierOrLiteral(name) : undefined;
	            }
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    return "__constructor" /* Constructor */;
	                case 162 /* FunctionType */:
	                case 157 /* CallSignature */:
	                case 287 /* JSDocSignature */:
	                    return "__call" /* Call */;
	                case 163 /* ConstructorType */:
	                case 158 /* ConstructSignature */:
	                    return "__new" /* New */;
	                case 159 /* IndexSignature */:
	                    return "__index" /* Index */;
	                case 249 /* ExportDeclaration */:
	                    return "__export" /* ExportStar */;
	                case 273 /* SourceFile */:
	                    // json file should behave as
	                    // module.exports = ...
	                    return "export=" /* ExportEquals */;
	                case 199 /* BinaryExpression */:
	                    if (ts.getSpecialPropertyAssignmentKind(node) === 2 /* ModuleExports */) {
	                        // module.exports = ...
	                        return "export=" /* ExportEquals */;
	                    }
	                    ts.Debug.fail("Unknown binary declaration kind");
	                    break;
	                case 283 /* JSDocFunctionType */:
	                    return (ts.isJSDocConstructSignature(node) ? "__new" /* New */ : "__call" /* Call */);
	                case 148 /* Parameter */:
	                    // Parameters with names are handled at the top of this function.  Parameters
	                    // without names can only come from JSDocFunctionTypes.
	                    ts.Debug.assert(node.parent.kind === 283 /* JSDocFunctionType */, "Impossible parameter parent kind", function () { return "parent is: " + (ts.SyntaxKind ? ts.SyntaxKind[node.parent.kind] : node.parent.kind) + ", expected JSDocFunctionType"; });
	                    var functionType = node.parent;
	                    var index = functionType.parameters.indexOf(node);
	                    return "arg" + index;
	            }
	        }
	        function getDisplayName(node) {
	            return ts.isNamedDeclaration(node) ? ts.declarationNameToString(node.name) : ts.unescapeLeadingUnderscores(getDeclarationName(node));
	        }
	        /**
	         * Declares a Symbol for the node and adds it to symbols. Reports errors for conflicting identifier names.
	         * @param symbolTable - The symbol table which node will be added to.
	         * @param parent - node's parent declaration.
	         * @param node - The declaration to be added to the symbol table
	         * @param includes - The SymbolFlags that node has in addition to its declaration type (eg: export, ambient, etc.)
	         * @param excludes - The flags which node cannot be declared alongside in a symbol table. Used to report forbidden declarations.
	         */
	        function declareSymbol(symbolTable, parent, node, includes, excludes, isReplaceableByMethod) {
	            ts.Debug.assert(!ts.hasDynamicName(node));
	            var isDefaultExport = ts.hasModifier(node, 512 /* Default */);
	            // The exported symbol for an export default function/class node is always named "default"
	            var name = isDefaultExport && parent ? "default" /* Default */ : getDeclarationName(node);
	            var symbol;
	            if (name === undefined) {
	                symbol = createSymbol(0 /* None */, "__missing" /* Missing */);
	            }
	            else {
	                // Check and see if the symbol table already has a symbol with this name.  If not,
	                // create a new symbol with this name and add it to the table.  Note that we don't
	                // give the new symbol any flags *yet*.  This ensures that it will not conflict
	                // with the 'excludes' flags we pass in.
	                //
	                // If we do get an existing symbol, see if it conflicts with the new symbol we're
	                // creating.  For example, a 'var' symbol and a 'class' symbol will conflict within
	                // the same symbol table.  If we have a conflict, report the issue on each
	                // declaration we have for this symbol, and then create a new symbol for this
	                // declaration.
	                //
	                // Note that when properties declared in Javascript constructors
	                // (marked by isReplaceableByMethod) conflict with another symbol, the property loses.
	                // Always. This allows the common Javascript pattern of overwriting a prototype method
	                // with an bound instance method of the same type: `this.method = this.method.bind(this)`
	                //
	                // If we created a new symbol, either because we didn't have a symbol with this name
	                // in the symbol table, or we conflicted with an existing symbol, then just add this
	                // node as the sole declaration of the new symbol.
	                //
	                // Otherwise, we'll be merging into a compatible existing symbol (for example when
	                // you have multiple 'vars' with the same name in the same container).  In this case
	                // just add this node into the declarations list of the symbol.
	                symbol = symbolTable.get(name);
	                if (includes & 2885600 /* Classifiable */) {
	                    classifiableNames.set(name, true);
	                }
	                if (!symbol) {
	                    symbolTable.set(name, symbol = createSymbol(0 /* None */, name));
	                    if (isReplaceableByMethod)
	                        symbol.isReplaceableByMethod = true;
	                }
	                else if (isReplaceableByMethod && !symbol.isReplaceableByMethod) {
	                    // A symbol already exists, so don't add this as a declaration.
	                    return symbol;
	                }
	                else if (symbol.flags & excludes) {
	                    if (symbol.isReplaceableByMethod) {
	                        // Javascript constructor-declared symbols can be discarded in favor of
	                        // prototype symbols like methods.
	                        symbolTable.set(name, symbol = createSymbol(0 /* None */, name));
	                    }
	                    else {
	                        if (ts.isNamedDeclaration(node)) {
	                            node.name.parent = node;
	                        }
	                        // Report errors every position with duplicate declaration
	                        // Report errors on previous encountered declarations
	                        var message_1 = symbol.flags & 2 /* BlockScopedVariable */
	                            ? ts.Diagnostics.Cannot_redeclare_block_scoped_variable_0
	                            : ts.Diagnostics.Duplicate_identifier_0;
	                        if (symbol.flags & 384 /* Enum */ || includes & 384 /* Enum */) {
	                            message_1 = ts.Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations;
	                        }
	                        if (symbol.declarations && symbol.declarations.length) {
	                            // If the current node is a default export of some sort, then check if
	                            // there are any other default exports that we need to error on.
	                            // We'll know whether we have other default exports depending on if `symbol` already has a declaration list set.
	                            if (isDefaultExport) {
	                                message_1 = ts.Diagnostics.A_module_cannot_have_multiple_default_exports;
	                            }
	                            else {
	                                // This is to properly report an error in the case "export default { }" is after export default of class declaration or function declaration.
	                                // Error on multiple export default in the following case:
	                                // 1. multiple export default of class declaration or function declaration by checking NodeFlags.Default
	                                // 2. multiple export default of export assignment. This one doesn't have NodeFlags.Default on (as export default doesn't considered as modifiers)
	                                if (symbol.declarations && symbol.declarations.length &&
	                                    (node.kind === 248 /* ExportAssignment */ && !node.isExportEquals)) {
	                                    message_1 = ts.Diagnostics.A_module_cannot_have_multiple_default_exports;
	                                }
	                            }
	                        }
	                        ts.forEach(symbol.declarations, function (declaration) {
	                            file.bindDiagnostics.push(createDiagnosticForNode(ts.getNameOfDeclaration(declaration) || declaration, message_1, getDisplayName(declaration)));
	                        });
	                        file.bindDiagnostics.push(createDiagnosticForNode(ts.getNameOfDeclaration(node) || node, message_1, getDisplayName(node)));
	                        symbol = createSymbol(0 /* None */, name);
	                    }
	                }
	            }
	            addDeclarationToSymbol(symbol, node, includes);
	            if (symbol.parent) {
	                ts.Debug.assert(symbol.parent === parent, "Existing symbol parent should match new one");
	            }
	            else {
	                symbol.parent = parent;
	            }
	            return symbol;
	        }
	        function declareModuleMember(node, symbolFlags, symbolExcludes) {
	            var hasExportModifier = ts.getCombinedModifierFlags(node) & 1 /* Export */;
	            if (symbolFlags & 2097152 /* Alias */) {
	                if (node.kind === 251 /* ExportSpecifier */ || (node.kind === 242 /* ImportEqualsDeclaration */ && hasExportModifier)) {
	                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                }
	                else {
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	                }
	            }
	            else {
	                // Exported module members are given 2 symbols: A local symbol that is classified with an ExportValue flag,
	                // and an associated export symbol with all the correct flags set on it. There are 2 main reasons:
	                //
	                //   1. We treat locals and exports of the same name as mutually exclusive within a container.
	                //      That means the binder will issue a Duplicate Identifier error if you mix locals and exports
	                //      with the same name in the same container.
	                //      TODO: Make this a more specific error and decouple it from the exclusion logic.
	                //   2. When we checkIdentifier in the checker, we set its resolved symbol to the local symbol,
	                //      but return the export symbol (by calling getExportSymbolOfValueSymbolIfExported). That way
	                //      when the emitter comes back to it, it knows not to qualify the name if it was found in a containing scope.
	                // NOTE: Nested ambient modules always should go to to 'locals' table to prevent their automatic merge
	                //       during global merging in the checker. Why? The only case when ambient module is permitted inside another module is module augmentation
	                //       and this case is specially handled. Module augmentations should only be merged with original module definition
	                //       and should never be merged directly with other augmentation, and the latter case would be possible if automatic merge is allowed.
	                if (ts.isJSDocTypeAlias(node))
	                    ts.Debug.assert(ts.isInJavaScriptFile(node)); // We shouldn't add symbols for JSDoc nodes if not in a JS file.
	                if ((!ts.isAmbientModule(node) && (hasExportModifier || container.flags & 32 /* ExportContext */)) || ts.isJSDocTypeAlias(node)) {
	                    if (ts.hasModifier(node, 512 /* Default */) && !getDeclarationName(node)) {
	                        return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes); // No local symbol for an unnamed default!
	                    }
	                    var exportKind = symbolFlags & 67216319 /* Value */ ? 1048576 /* ExportValue */ : 0;
	                    var local = declareSymbol(container.locals, /*parent*/ undefined, node, exportKind, symbolExcludes);
	                    local.exportSymbol = declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                    node.localSymbol = local;
	                    return local;
	                }
	                else {
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	                }
	            }
	        }
	        // All container nodes are kept on a linked list in declaration order. This list is used by
	        // the getLocalNameOfContainer function in the type checker to validate that the local name
	        // used for a container is unique.
	        function bindContainer(node, containerFlags) {
	            // Before we recurse into a node's children, we first save the existing parent, container
	            // and block-container.  Then after we pop out of processing the children, we restore
	            // these saved values.
	            var saveContainer = container;
	            var saveThisParentContainer = thisParentContainer;
	            var savedBlockScopeContainer = blockScopeContainer;
	            // Depending on what kind of node this is, we may have to adjust the current container
	            // and block-container.   If the current node is a container, then it is automatically
	            // considered the current block-container as well.  Also, for containers that we know
	            // may contain locals, we eagerly initialize the .locals field. We do this because
	            // it's highly likely that the .locals will be needed to place some child in (for example,
	            // a parameter, or variable declaration).
	            //
	            // However, we do not proactively create the .locals for block-containers because it's
	            // totally normal and common for block-containers to never actually have a block-scoped
	            // variable in them.  We don't want to end up allocating an object for every 'block' we
	            // run into when most of them won't be necessary.
	            //
	            // Finally, if this is a block-container, then we clear out any existing .locals object
	            // it may contain within it.  This happens in incremental scenarios.  Because we can be
	            // reusing a node from a previous compilation, that node may have had 'locals' created
	            // for it.  We must clear this so we don't accidentally move any stale data forward from
	            // a previous compilation.
	            if (containerFlags & 1 /* IsContainer */) {
	                if (node.kind !== 192 /* ArrowFunction */) {
	                    thisParentContainer = container;
	                }
	                container = blockScopeContainer = node;
	                if (containerFlags & 32 /* HasLocals */) {
	                    container.locals = ts.createSymbolTable();
	                }
	                addToContainerChain(container);
	            }
	            else if (containerFlags & 2 /* IsBlockScopedContainer */) {
	                blockScopeContainer = node;
	                blockScopeContainer.locals = undefined;
	            }
	            if (containerFlags & 4 /* IsControlFlowContainer */) {
	                var saveCurrentFlow = currentFlow;
	                var saveBreakTarget = currentBreakTarget;
	                var saveContinueTarget = currentContinueTarget;
	                var saveReturnTarget = currentReturnTarget;
	                var saveActiveLabels = activeLabels;
	                var saveHasExplicitReturn = hasExplicitReturn;
	                var isIIFE = containerFlags & 16 /* IsFunctionExpression */ && !ts.hasModifier(node, 256 /* Async */) &&
	                    !node.asteriskToken && !!ts.getImmediatelyInvokedFunctionExpression(node);
	                // A non-async, non-generator IIFE is considered part of the containing control flow. Return statements behave
	                // similarly to break statements that exit to a label just past the statement body.
	                if (!isIIFE) {
	                    currentFlow = { flags: 2 /* Start */ };
	                    if (containerFlags & (16 /* IsFunctionExpression */ | 128 /* IsObjectLiteralOrClassExpressionMethod */)) {
	                        currentFlow.container = node;
	                    }
	                }
	                // We create a return control flow graph for IIFEs and constructors. For constructors
	                // we use the return control flow graph in strict property intialization checks.
	                currentReturnTarget = isIIFE || node.kind === 154 /* Constructor */ ? createBranchLabel() : undefined;
	                currentBreakTarget = undefined;
	                currentContinueTarget = undefined;
	                activeLabels = undefined;
	                hasExplicitReturn = false;
	                bindChildren(node);
	                // Reset all reachability check related flags on node (for incremental scenarios)
	                node.flags &= ~1408 /* ReachabilityAndEmitFlags */;
	                if (!(currentFlow.flags & 1 /* Unreachable */) && containerFlags & 8 /* IsFunctionLike */ && ts.nodeIsPresent(node.body)) {
	                    node.flags |= 128 /* HasImplicitReturn */;
	                    if (hasExplicitReturn)
	                        node.flags |= 256 /* HasExplicitReturn */;
	                }
	                if (node.kind === 273 /* SourceFile */) {
	                    node.flags |= emitFlags;
	                }
	                if (currentReturnTarget) {
	                    addAntecedent(currentReturnTarget, currentFlow);
	                    currentFlow = finishFlowLabel(currentReturnTarget);
	                    if (node.kind === 154 /* Constructor */) {
	                        node.returnFlowNode = currentFlow;
	                    }
	                }
	                if (!isIIFE) {
	                    currentFlow = saveCurrentFlow;
	                }
	                currentBreakTarget = saveBreakTarget;
	                currentContinueTarget = saveContinueTarget;
	                currentReturnTarget = saveReturnTarget;
	                activeLabels = saveActiveLabels;
	                hasExplicitReturn = saveHasExplicitReturn;
	            }
	            else if (containerFlags & 64 /* IsInterface */) {
	                seenThisKeyword = false;
	                bindChildren(node);
	                node.flags = seenThisKeyword ? node.flags | 64 /* ContainsThis */ : node.flags & ~64 /* ContainsThis */;
	            }
	            else {
	                bindChildren(node);
	            }
	            container = saveContainer;
	            thisParentContainer = saveThisParentContainer;
	            blockScopeContainer = savedBlockScopeContainer;
	        }
	        function bindChildren(node) {
	            if (skipTransformFlagAggregation) {
	                bindChildrenWorker(node);
	            }
	            else if (node.transformFlags & 536870912 /* HasComputedFlags */) {
	                skipTransformFlagAggregation = true;
	                bindChildrenWorker(node);
	                skipTransformFlagAggregation = false;
	                subtreeTransformFlags |= node.transformFlags & ~getTransformFlagsSubtreeExclusions(node.kind);
	            }
	            else {
	                var savedSubtreeTransformFlags = subtreeTransformFlags;
	                subtreeTransformFlags = 0;
	                bindChildrenWorker(node);
	                subtreeTransformFlags = savedSubtreeTransformFlags | computeTransformFlagsForNode(node, subtreeTransformFlags);
	            }
	        }
	        function bindEachFunctionsFirst(nodes) {
	            bindEach(nodes, function (n) { return n.kind === 233 /* FunctionDeclaration */ ? bind(n) : undefined; });
	            bindEach(nodes, function (n) { return n.kind !== 233 /* FunctionDeclaration */ ? bind(n) : undefined; });
	        }
	        function bindEach(nodes, bindFunction) {
	            if (bindFunction === void 0) { bindFunction = bind; }
	            if (nodes === undefined) {
	                return;
	            }
	            if (skipTransformFlagAggregation) {
	                ts.forEach(nodes, bindFunction);
	            }
	            else {
	                var savedSubtreeTransformFlags = subtreeTransformFlags;
	                subtreeTransformFlags = 0 /* None */;
	                var nodeArrayFlags = 0 /* None */;
	                for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
	                    var node = nodes_2[_i];
	                    bindFunction(node);
	                    nodeArrayFlags |= node.transformFlags & ~536870912 /* HasComputedFlags */;
	                }
	                nodes.transformFlags = nodeArrayFlags | 536870912 /* HasComputedFlags */;
	                subtreeTransformFlags |= savedSubtreeTransformFlags;
	            }
	        }
	        function bindEachChild(node) {
	            ts.forEachChild(node, bind, bindEach);
	        }
	        function bindChildrenWorker(node) {
	            if (checkUnreachable(node)) {
	                bindEachChild(node);
	                return;
	            }
	            switch (node.kind) {
	                case 218 /* WhileStatement */:
	                    bindWhileStatement(node);
	                    break;
	                case 217 /* DoStatement */:
	                    bindDoStatement(node);
	                    break;
	                case 219 /* ForStatement */:
	                    bindForStatement(node);
	                    break;
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                    bindForInOrForOfStatement(node);
	                    break;
	                case 216 /* IfStatement */:
	                    bindIfStatement(node);
	                    break;
	                case 224 /* ReturnStatement */:
	                case 228 /* ThrowStatement */:
	                    bindReturnOrThrow(node);
	                    break;
	                case 223 /* BreakStatement */:
	                case 222 /* ContinueStatement */:
	                    bindBreakOrContinueStatement(node);
	                    break;
	                case 229 /* TryStatement */:
	                    bindTryStatement(node);
	                    break;
	                case 226 /* SwitchStatement */:
	                    bindSwitchStatement(node);
	                    break;
	                case 240 /* CaseBlock */:
	                    bindCaseBlock(node);
	                    break;
	                case 265 /* CaseClause */:
	                    bindCaseClause(node);
	                    break;
	                case 227 /* LabeledStatement */:
	                    bindLabeledStatement(node);
	                    break;
	                case 197 /* PrefixUnaryExpression */:
	                    bindPrefixUnaryExpressionFlow(node);
	                    break;
	                case 198 /* PostfixUnaryExpression */:
	                    bindPostfixUnaryExpressionFlow(node);
	                    break;
	                case 199 /* BinaryExpression */:
	                    bindBinaryExpressionFlow(node);
	                    break;
	                case 193 /* DeleteExpression */:
	                    bindDeleteExpressionFlow(node);
	                    break;
	                case 200 /* ConditionalExpression */:
	                    bindConditionalExpressionFlow(node);
	                    break;
	                case 231 /* VariableDeclaration */:
	                    bindVariableDeclarationFlow(node);
	                    break;
	                case 186 /* CallExpression */:
	                    bindCallExpressionFlow(node);
	                    break;
	                case 296 /* JSDocTypedefTag */:
	                case 291 /* JSDocCallbackTag */:
	                    bindJSDocTypeAlias(node);
	                    break;
	                // In source files and blocks, bind functions first to match hoisting that occurs at runtime
	                case 273 /* SourceFile */:
	                    bindEachFunctionsFirst(node.statements);
	                    bind(node.endOfFileToken);
	                    break;
	                case 212 /* Block */:
	                case 239 /* ModuleBlock */:
	                    bindEachFunctionsFirst(node.statements);
	                    break;
	                default:
	                    bindEachChild(node);
	                    break;
	            }
	            bindJSDoc(node);
	        }
	        function isNarrowingExpression(expr) {
	            switch (expr.kind) {
	                case 71 /* Identifier */:
	                case 99 /* ThisKeyword */:
	                case 184 /* PropertyAccessExpression */:
	                    return isNarrowableReference(expr);
	                case 186 /* CallExpression */:
	                    return hasNarrowableArgument(expr);
	                case 190 /* ParenthesizedExpression */:
	                    return isNarrowingExpression(expr.expression);
	                case 199 /* BinaryExpression */:
	                    return isNarrowingBinaryExpression(expr);
	                case 197 /* PrefixUnaryExpression */:
	                    return expr.operator === 51 /* ExclamationToken */ && isNarrowingExpression(expr.operand);
	            }
	            return false;
	        }
	        function isNarrowableReference(expr) {
	            return expr.kind === 71 /* Identifier */ ||
	                expr.kind === 99 /* ThisKeyword */ ||
	                expr.kind === 97 /* SuperKeyword */ ||
	                expr.kind === 184 /* PropertyAccessExpression */ && isNarrowableReference(expr.expression);
	        }
	        function hasNarrowableArgument(expr) {
	            if (expr.arguments) {
	                for (var _i = 0, _a = expr.arguments; _i < _a.length; _i++) {
	                    var argument = _a[_i];
	                    if (isNarrowableReference(argument)) {
	                        return true;
	                    }
	                }
	            }
	            if (expr.expression.kind === 184 /* PropertyAccessExpression */ &&
	                isNarrowableReference(expr.expression.expression)) {
	                return true;
	            }
	            return false;
	        }
	        function isNarrowingTypeofOperands(expr1, expr2) {
	            return ts.isTypeOfExpression(expr1) && isNarrowableOperand(expr1.expression) && ts.isStringLiteralLike(expr2);
	        }
	        function isNarrowableInOperands(left, right) {
	            return ts.isStringLiteralLike(left) && isNarrowingExpression(right);
	        }
	        function isNarrowingBinaryExpression(expr) {
	            switch (expr.operatorToken.kind) {
	                case 58 /* EqualsToken */:
	                    return isNarrowableReference(expr.left);
	                case 32 /* EqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                    return isNarrowableOperand(expr.left) || isNarrowableOperand(expr.right) ||
	                        isNarrowingTypeofOperands(expr.right, expr.left) || isNarrowingTypeofOperands(expr.left, expr.right);
	                case 93 /* InstanceOfKeyword */:
	                    return isNarrowableOperand(expr.left);
	                case 92 /* InKeyword */:
	                    return isNarrowableInOperands(expr.left, expr.right);
	                case 26 /* CommaToken */:
	                    return isNarrowingExpression(expr.right);
	            }
	            return false;
	        }
	        function isNarrowableOperand(expr) {
	            switch (expr.kind) {
	                case 190 /* ParenthesizedExpression */:
	                    return isNarrowableOperand(expr.expression);
	                case 199 /* BinaryExpression */:
	                    switch (expr.operatorToken.kind) {
	                        case 58 /* EqualsToken */:
	                            return isNarrowableOperand(expr.left);
	                        case 26 /* CommaToken */:
	                            return isNarrowableOperand(expr.right);
	                    }
	            }
	            return isNarrowableReference(expr);
	        }
	        function createBranchLabel() {
	            return {
	                flags: 4 /* BranchLabel */,
	                antecedents: undefined
	            };
	        }
	        function createLoopLabel() {
	            return {
	                flags: 8 /* LoopLabel */,
	                antecedents: undefined
	            };
	        }
	        function setFlowNodeReferenced(flow) {
	            // On first reference we set the Referenced flag, thereafter we set the Shared flag
	            flow.flags |= flow.flags & 512 /* Referenced */ ? 1024 /* Shared */ : 512 /* Referenced */;
	        }
	        function addAntecedent(label, antecedent) {
	            if (!(antecedent.flags & 1 /* Unreachable */) && !ts.contains(label.antecedents, antecedent)) {
	                (label.antecedents || (label.antecedents = [])).push(antecedent);
	                setFlowNodeReferenced(antecedent);
	            }
	        }
	        function createFlowCondition(flags, antecedent, expression) {
	            if (antecedent.flags & 1 /* Unreachable */) {
	                return antecedent;
	            }
	            if (!expression) {
	                return flags & 32 /* TrueCondition */ ? antecedent : unreachableFlow;
	            }
	            if (expression.kind === 101 /* TrueKeyword */ && flags & 64 /* FalseCondition */ ||
	                expression.kind === 86 /* FalseKeyword */ && flags & 32 /* TrueCondition */) {
	                return unreachableFlow;
	            }
	            if (!isNarrowingExpression(expression)) {
	                return antecedent;
	            }
	            setFlowNodeReferenced(antecedent);
	            return { flags: flags, expression: expression, antecedent: antecedent };
	        }
	        function createFlowSwitchClause(antecedent, switchStatement, clauseStart, clauseEnd) {
	            if (!isNarrowingExpression(switchStatement.expression)) {
	                return antecedent;
	            }
	            setFlowNodeReferenced(antecedent);
	            return { flags: 128 /* SwitchClause */, switchStatement: switchStatement, clauseStart: clauseStart, clauseEnd: clauseEnd, antecedent: antecedent };
	        }
	        function createFlowAssignment(antecedent, node) {
	            setFlowNodeReferenced(antecedent);
	            return { flags: 16 /* Assignment */, antecedent: antecedent, node: node };
	        }
	        function createFlowArrayMutation(antecedent, node) {
	            setFlowNodeReferenced(antecedent);
	            var res = { flags: 256 /* ArrayMutation */, antecedent: antecedent, node: node };
	            return res;
	        }
	        function finishFlowLabel(flow) {
	            var antecedents = flow.antecedents;
	            if (!antecedents) {
	                return unreachableFlow;
	            }
	            if (antecedents.length === 1) {
	                return antecedents[0];
	            }
	            return flow;
	        }
	        function isStatementCondition(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 216 /* IfStatement */:
	                case 218 /* WhileStatement */:
	                case 217 /* DoStatement */:
	                    return parent.expression === node;
	                case 219 /* ForStatement */:
	                case 200 /* ConditionalExpression */:
	                    return parent.condition === node;
	            }
	            return false;
	        }
	        function isLogicalExpression(node) {
	            while (true) {
	                if (node.kind === 190 /* ParenthesizedExpression */) {
	                    node = node.expression;
	                }
	                else if (node.kind === 197 /* PrefixUnaryExpression */ && node.operator === 51 /* ExclamationToken */) {
	                    node = node.operand;
	                }
	                else {
	                    return node.kind === 199 /* BinaryExpression */ && (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */ ||
	                        node.operatorToken.kind === 54 /* BarBarToken */);
	                }
	            }
	        }
	        function isTopLevelLogicalExpression(node) {
	            while (node.parent.kind === 190 /* ParenthesizedExpression */ ||
	                node.parent.kind === 197 /* PrefixUnaryExpression */ &&
	                    node.parent.operator === 51 /* ExclamationToken */) {
	                node = node.parent;
	            }
	            return !isStatementCondition(node) && !isLogicalExpression(node.parent);
	        }
	        function bindCondition(node, trueTarget, falseTarget) {
	            var saveTrueTarget = currentTrueTarget;
	            var saveFalseTarget = currentFalseTarget;
	            currentTrueTarget = trueTarget;
	            currentFalseTarget = falseTarget;
	            bind(node);
	            currentTrueTarget = saveTrueTarget;
	            currentFalseTarget = saveFalseTarget;
	            if (!node || !isLogicalExpression(node)) {
	                addAntecedent(trueTarget, createFlowCondition(32 /* TrueCondition */, currentFlow, node));
	                addAntecedent(falseTarget, createFlowCondition(64 /* FalseCondition */, currentFlow, node));
	            }
	        }
	        function bindIterativeStatement(node, breakTarget, continueTarget) {
	            var saveBreakTarget = currentBreakTarget;
	            var saveContinueTarget = currentContinueTarget;
	            currentBreakTarget = breakTarget;
	            currentContinueTarget = continueTarget;
	            bind(node);
	            currentBreakTarget = saveBreakTarget;
	            currentContinueTarget = saveContinueTarget;
	        }
	        function bindWhileStatement(node) {
	            var preWhileLabel = createLoopLabel();
	            var preBodyLabel = createBranchLabel();
	            var postWhileLabel = createBranchLabel();
	            addAntecedent(preWhileLabel, currentFlow);
	            currentFlow = preWhileLabel;
	            bindCondition(node.expression, preBodyLabel, postWhileLabel);
	            currentFlow = finishFlowLabel(preBodyLabel);
	            bindIterativeStatement(node.statement, postWhileLabel, preWhileLabel);
	            addAntecedent(preWhileLabel, currentFlow);
	            currentFlow = finishFlowLabel(postWhileLabel);
	        }
	        function bindDoStatement(node) {
	            var preDoLabel = createLoopLabel();
	            var enclosingLabeledStatement = node.parent.kind === 227 /* LabeledStatement */
	                ? ts.lastOrUndefined(activeLabels)
	                : undefined;
	            // if do statement is wrapped in labeled statement then target labels for break/continue with or without
	            // label should be the same
	            var preConditionLabel = enclosingLabeledStatement ? enclosingLabeledStatement.continueTarget : createBranchLabel();
	            var postDoLabel = enclosingLabeledStatement ? enclosingLabeledStatement.breakTarget : createBranchLabel();
	            addAntecedent(preDoLabel, currentFlow);
	            currentFlow = preDoLabel;
	            bindIterativeStatement(node.statement, postDoLabel, preConditionLabel);
	            addAntecedent(preConditionLabel, currentFlow);
	            currentFlow = finishFlowLabel(preConditionLabel);
	            bindCondition(node.expression, preDoLabel, postDoLabel);
	            currentFlow = finishFlowLabel(postDoLabel);
	        }
	        function bindForStatement(node) {
	            var preLoopLabel = createLoopLabel();
	            var preBodyLabel = createBranchLabel();
	            var postLoopLabel = createBranchLabel();
	            bind(node.initializer);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = preLoopLabel;
	            bindCondition(node.condition, preBodyLabel, postLoopLabel);
	            currentFlow = finishFlowLabel(preBodyLabel);
	            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
	            bind(node.incrementor);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = finishFlowLabel(postLoopLabel);
	        }
	        function bindForInOrForOfStatement(node) {
	            var preLoopLabel = createLoopLabel();
	            var postLoopLabel = createBranchLabel();
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = preLoopLabel;
	            if (node.kind === 221 /* ForOfStatement */) {
	                bind(node.awaitModifier);
	            }
	            bind(node.expression);
	            addAntecedent(postLoopLabel, currentFlow);
	            bind(node.initializer);
	            if (node.initializer.kind !== 232 /* VariableDeclarationList */) {
	                bindAssignmentTargetFlow(node.initializer);
	            }
	            bindIterativeStatement(node.statement, postLoopLabel, preLoopLabel);
	            addAntecedent(preLoopLabel, currentFlow);
	            currentFlow = finishFlowLabel(postLoopLabel);
	        }
	        function bindIfStatement(node) {
	            var thenLabel = createBranchLabel();
	            var elseLabel = createBranchLabel();
	            var postIfLabel = createBranchLabel();
	            bindCondition(node.expression, thenLabel, elseLabel);
	            currentFlow = finishFlowLabel(thenLabel);
	            bind(node.thenStatement);
	            addAntecedent(postIfLabel, currentFlow);
	            currentFlow = finishFlowLabel(elseLabel);
	            bind(node.elseStatement);
	            addAntecedent(postIfLabel, currentFlow);
	            currentFlow = finishFlowLabel(postIfLabel);
	        }
	        function bindReturnOrThrow(node) {
	            bind(node.expression);
	            if (node.kind === 224 /* ReturnStatement */) {
	                hasExplicitReturn = true;
	                if (currentReturnTarget) {
	                    addAntecedent(currentReturnTarget, currentFlow);
	                }
	            }
	            currentFlow = unreachableFlow;
	        }
	        function findActiveLabel(name) {
	            if (activeLabels) {
	                for (var _i = 0, activeLabels_1 = activeLabels; _i < activeLabels_1.length; _i++) {
	                    var label = activeLabels_1[_i];
	                    if (label.name === name) {
	                        return label;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function bindBreakOrContinueFlow(node, breakTarget, continueTarget) {
	            var flowLabel = node.kind === 223 /* BreakStatement */ ? breakTarget : continueTarget;
	            if (flowLabel) {
	                addAntecedent(flowLabel, currentFlow);
	                currentFlow = unreachableFlow;
	            }
	        }
	        function bindBreakOrContinueStatement(node) {
	            bind(node.label);
	            if (node.label) {
	                var activeLabel = findActiveLabel(node.label.escapedText);
	                if (activeLabel) {
	                    activeLabel.referenced = true;
	                    bindBreakOrContinueFlow(node, activeLabel.breakTarget, activeLabel.continueTarget);
	                }
	            }
	            else {
	                bindBreakOrContinueFlow(node, currentBreakTarget, currentContinueTarget);
	            }
	        }
	        function bindTryStatement(node) {
	            var preFinallyLabel = createBranchLabel();
	            var preTryFlow = currentFlow;
	            // TODO: Every statement in try block is potentially an exit point!
	            bind(node.tryBlock);
	            addAntecedent(preFinallyLabel, currentFlow);
	            var flowAfterTry = currentFlow;
	            var flowAfterCatch = unreachableFlow;
	            if (node.catchClause) {
	                currentFlow = preTryFlow;
	                bind(node.catchClause);
	                addAntecedent(preFinallyLabel, currentFlow);
	                flowAfterCatch = currentFlow;
	            }
	            if (node.finallyBlock) {
	                // in finally flow is combined from pre-try/flow from try/flow from catch
	                // pre-flow is necessary to make sure that finally is reachable even if finally flows in both try and finally blocks are unreachable
	                // also for finally blocks we inject two extra edges into the flow graph.
	                // first -> edge that connects pre-try flow with the label at the beginning of the finally block, it has lock associated with it
	                // second -> edge that represents post-finally flow.
	                // these edges are used in following scenario:
	                // let a; (1)
	                // try { a = someOperation(); (2)}
	                // finally { (3) console.log(a) } (4)
	                // (5) a
	                // flow graph for this case looks roughly like this (arrows show ):
	                // (1-pre-try-flow) <--.. <-- (2-post-try-flow)
	                //  ^                                ^
	                //  |*****(3-pre-finally-label) -----|
	                //                ^
	                //                |-- ... <-- (4-post-finally-label) <--- (5)
	                // In case when we walk the flow starting from inside the finally block we want to take edge '*****' into account
	                // since it ensures that finally is always reachable. However when we start outside the finally block and go through label (5)
	                // then edge '*****' should be discarded because label 4 is only reachable if post-finally label-4 is reachable
	                // Simply speaking code inside finally block is treated as reachable as pre-try-flow
	                // since we conservatively assume that any line in try block can throw or return in which case we'll enter finally.
	                // However code after finally is reachable only if control flow was not abrupted in try/catch or finally blocks - it should be composed from
	                // final flows of these blocks without taking pre-try flow into account.
	                //
	                // extra edges that we inject allows to control this behavior
	                // if when walking the flow we step on post-finally edge - we can mark matching pre-finally edge as locked so it will be skipped.
	                var preFinallyFlow = { flags: 2048 /* PreFinally */, antecedent: preTryFlow, lock: {} };
	                addAntecedent(preFinallyLabel, preFinallyFlow);
	                currentFlow = finishFlowLabel(preFinallyLabel);
	                bind(node.finallyBlock);
	                // if flow after finally is unreachable - keep it
	                // otherwise check if flows after try and after catch are unreachable
	                // if yes - convert current flow to unreachable
	                // i.e.
	                // try { return "1" } finally { console.log(1); }
	                // console.log(2); // this line should be unreachable even if flow falls out of finally block
	                if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                    if ((flowAfterTry.flags & 1 /* Unreachable */) && (flowAfterCatch.flags & 1 /* Unreachable */)) {
	                        currentFlow = flowAfterTry === reportedUnreachableFlow || flowAfterCatch === reportedUnreachableFlow
	                            ? reportedUnreachableFlow
	                            : unreachableFlow;
	                    }
	                }
	                if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                    var afterFinallyFlow = { flags: 4096 /* AfterFinally */, antecedent: currentFlow };
	                    preFinallyFlow.lock = afterFinallyFlow;
	                    currentFlow = afterFinallyFlow;
	                }
	            }
	            else {
	                currentFlow = finishFlowLabel(preFinallyLabel);
	            }
	        }
	        function bindSwitchStatement(node) {
	            var postSwitchLabel = createBranchLabel();
	            bind(node.expression);
	            var saveBreakTarget = currentBreakTarget;
	            var savePreSwitchCaseFlow = preSwitchCaseFlow;
	            currentBreakTarget = postSwitchLabel;
	            preSwitchCaseFlow = currentFlow;
	            bind(node.caseBlock);
	            addAntecedent(postSwitchLabel, currentFlow);
	            var hasDefault = ts.forEach(node.caseBlock.clauses, function (c) { return c.kind === 266 /* DefaultClause */; });
	            // We mark a switch statement as possibly exhaustive if it has no default clause and if all
	            // case clauses have unreachable end points (e.g. they all return).
	            node.possiblyExhaustive = !hasDefault && !postSwitchLabel.antecedents;
	            if (!hasDefault) {
	                addAntecedent(postSwitchLabel, createFlowSwitchClause(preSwitchCaseFlow, node, 0, 0));
	            }
	            currentBreakTarget = saveBreakTarget;
	            preSwitchCaseFlow = savePreSwitchCaseFlow;
	            currentFlow = finishFlowLabel(postSwitchLabel);
	        }
	        function bindCaseBlock(node) {
	            var savedSubtreeTransformFlags = subtreeTransformFlags;
	            subtreeTransformFlags = 0;
	            var clauses = node.clauses;
	            var fallthroughFlow = unreachableFlow;
	            for (var i = 0; i < clauses.length; i++) {
	                var clauseStart = i;
	                while (!clauses[i].statements.length && i + 1 < clauses.length) {
	                    bind(clauses[i]);
	                    i++;
	                }
	                var preCaseLabel = createBranchLabel();
	                addAntecedent(preCaseLabel, createFlowSwitchClause(preSwitchCaseFlow, node.parent, clauseStart, i + 1));
	                addAntecedent(preCaseLabel, fallthroughFlow);
	                currentFlow = finishFlowLabel(preCaseLabel);
	                var clause = clauses[i];
	                bind(clause);
	                fallthroughFlow = currentFlow;
	                if (!(currentFlow.flags & 1 /* Unreachable */) && i !== clauses.length - 1 && options.noFallthroughCasesInSwitch) {
	                    errorOnFirstToken(clause, ts.Diagnostics.Fallthrough_case_in_switch);
	                }
	            }
	            clauses.transformFlags = subtreeTransformFlags | 536870912 /* HasComputedFlags */;
	            subtreeTransformFlags |= savedSubtreeTransformFlags;
	        }
	        function bindCaseClause(node) {
	            var saveCurrentFlow = currentFlow;
	            currentFlow = preSwitchCaseFlow;
	            bind(node.expression);
	            currentFlow = saveCurrentFlow;
	            bindEach(node.statements);
	        }
	        function pushActiveLabel(name, breakTarget, continueTarget) {
	            var activeLabel = {
	                name: name,
	                breakTarget: breakTarget,
	                continueTarget: continueTarget,
	                referenced: false
	            };
	            (activeLabels || (activeLabels = [])).push(activeLabel);
	            return activeLabel;
	        }
	        function popActiveLabel() {
	            activeLabels.pop();
	        }
	        function bindLabeledStatement(node) {
	            var preStatementLabel = createLoopLabel();
	            var postStatementLabel = createBranchLabel();
	            bind(node.label);
	            addAntecedent(preStatementLabel, currentFlow);
	            var activeLabel = pushActiveLabel(node.label.escapedText, postStatementLabel, preStatementLabel);
	            bind(node.statement);
	            popActiveLabel();
	            if (!activeLabel.referenced && !options.allowUnusedLabels) {
	                errorOrSuggestionOnFirstToken(ts.unusedLabelIsError(options), node, ts.Diagnostics.Unused_label);
	            }
	            if (!node.statement || node.statement.kind !== 217 /* DoStatement */) {
	                // do statement sets current flow inside bindDoStatement
	                addAntecedent(postStatementLabel, currentFlow);
	                currentFlow = finishFlowLabel(postStatementLabel);
	            }
	        }
	        function bindDestructuringTargetFlow(node) {
	            if (node.kind === 199 /* BinaryExpression */ && node.operatorToken.kind === 58 /* EqualsToken */) {
	                bindAssignmentTargetFlow(node.left);
	            }
	            else {
	                bindAssignmentTargetFlow(node);
	            }
	        }
	        function bindAssignmentTargetFlow(node) {
	            if (isNarrowableReference(node)) {
	                currentFlow = createFlowAssignment(currentFlow, node);
	            }
	            else if (node.kind === 182 /* ArrayLiteralExpression */) {
	                for (var _i = 0, _a = node.elements; _i < _a.length; _i++) {
	                    var e = _a[_i];
	                    if (e.kind === 203 /* SpreadElement */) {
	                        bindAssignmentTargetFlow(e.expression);
	                    }
	                    else {
	                        bindDestructuringTargetFlow(e);
	                    }
	                }
	            }
	            else if (node.kind === 183 /* ObjectLiteralExpression */) {
	                for (var _b = 0, _c = node.properties; _b < _c.length; _b++) {
	                    var p = _c[_b];
	                    if (p.kind === 269 /* PropertyAssignment */) {
	                        bindDestructuringTargetFlow(p.initializer);
	                    }
	                    else if (p.kind === 270 /* ShorthandPropertyAssignment */) {
	                        bindAssignmentTargetFlow(p.name);
	                    }
	                    else if (p.kind === 271 /* SpreadAssignment */) {
	                        bindAssignmentTargetFlow(p.expression);
	                    }
	                }
	            }
	        }
	        function bindLogicalExpression(node, trueTarget, falseTarget) {
	            var preRightLabel = createBranchLabel();
	            if (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */) {
	                bindCondition(node.left, preRightLabel, falseTarget);
	            }
	            else {
	                bindCondition(node.left, trueTarget, preRightLabel);
	            }
	            currentFlow = finishFlowLabel(preRightLabel);
	            bind(node.operatorToken);
	            bindCondition(node.right, trueTarget, falseTarget);
	        }
	        function bindPrefixUnaryExpressionFlow(node) {
	            if (node.operator === 51 /* ExclamationToken */) {
	                var saveTrueTarget = currentTrueTarget;
	                currentTrueTarget = currentFalseTarget;
	                currentFalseTarget = saveTrueTarget;
	                bindEachChild(node);
	                currentFalseTarget = currentTrueTarget;
	                currentTrueTarget = saveTrueTarget;
	            }
	            else {
	                bindEachChild(node);
	                if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                    bindAssignmentTargetFlow(node.operand);
	                }
	            }
	        }
	        function bindPostfixUnaryExpressionFlow(node) {
	            bindEachChild(node);
	            if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                bindAssignmentTargetFlow(node.operand);
	            }
	        }
	        function bindBinaryExpressionFlow(node) {
	            var operator = node.operatorToken.kind;
	            if (operator === 53 /* AmpersandAmpersandToken */ || operator === 54 /* BarBarToken */) {
	                if (isTopLevelLogicalExpression(node)) {
	                    var postExpressionLabel = createBranchLabel();
	                    bindLogicalExpression(node, postExpressionLabel, postExpressionLabel);
	                    currentFlow = finishFlowLabel(postExpressionLabel);
	                }
	                else {
	                    bindLogicalExpression(node, currentTrueTarget, currentFalseTarget);
	                }
	            }
	            else {
	                bindEachChild(node);
	                if (ts.isAssignmentOperator(operator) && !ts.isAssignmentTarget(node)) {
	                    bindAssignmentTargetFlow(node.left);
	                    if (operator === 58 /* EqualsToken */ && node.left.kind === 185 /* ElementAccessExpression */) {
	                        var elementAccess = node.left;
	                        if (isNarrowableOperand(elementAccess.expression)) {
	                            currentFlow = createFlowArrayMutation(currentFlow, node);
	                        }
	                    }
	                }
	            }
	        }
	        function bindDeleteExpressionFlow(node) {
	            bindEachChild(node);
	            if (node.expression.kind === 184 /* PropertyAccessExpression */) {
	                bindAssignmentTargetFlow(node.expression);
	            }
	        }
	        function bindConditionalExpressionFlow(node) {
	            var trueLabel = createBranchLabel();
	            var falseLabel = createBranchLabel();
	            var postExpressionLabel = createBranchLabel();
	            bindCondition(node.condition, trueLabel, falseLabel);
	            currentFlow = finishFlowLabel(trueLabel);
	            bind(node.questionToken);
	            bind(node.whenTrue);
	            addAntecedent(postExpressionLabel, currentFlow);
	            currentFlow = finishFlowLabel(falseLabel);
	            bind(node.colonToken);
	            bind(node.whenFalse);
	            addAntecedent(postExpressionLabel, currentFlow);
	            currentFlow = finishFlowLabel(postExpressionLabel);
	        }
	        function bindInitializedVariableFlow(node) {
	            var name = !ts.isOmittedExpression(node) ? node.name : undefined;
	            if (ts.isBindingPattern(name)) {
	                for (var _i = 0, _a = name.elements; _i < _a.length; _i++) {
	                    var child = _a[_i];
	                    bindInitializedVariableFlow(child);
	                }
	            }
	            else {
	                currentFlow = createFlowAssignment(currentFlow, node);
	            }
	        }
	        function bindVariableDeclarationFlow(node) {
	            bindEachChild(node);
	            if (node.initializer || ts.isForInOrOfStatement(node.parent.parent)) {
	                bindInitializedVariableFlow(node);
	            }
	        }
	        function bindJSDocTypeAlias(node) {
	            if (node.fullName) {
	                setParentPointers(node, node.fullName);
	            }
	        }
	        function bindCallExpressionFlow(node) {
	            // If the target of the call expression is a function expression or arrow function we have
	            // an immediately invoked function expression (IIFE). Initialize the flowNode property to
	            // the current control flow (which includes evaluation of the IIFE arguments).
	            var expr = node.expression;
	            while (expr.kind === 190 /* ParenthesizedExpression */) {
	                expr = expr.expression;
	            }
	            if (expr.kind === 191 /* FunctionExpression */ || expr.kind === 192 /* ArrowFunction */) {
	                bindEach(node.typeArguments);
	                bindEach(node.arguments);
	                bind(node.expression);
	            }
	            else {
	                bindEachChild(node);
	            }
	            if (node.expression.kind === 184 /* PropertyAccessExpression */) {
	                var propertyAccess = node.expression;
	                if (isNarrowableOperand(propertyAccess.expression) && ts.isPushOrUnshiftIdentifier(propertyAccess.name)) {
	                    currentFlow = createFlowArrayMutation(currentFlow, node);
	                }
	            }
	        }
	        function getContainerFlags(node) {
	            switch (node.kind) {
	                case 204 /* ClassExpression */:
	                case 234 /* ClassDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 183 /* ObjectLiteralExpression */:
	                case 165 /* TypeLiteral */:
	                case 286 /* JSDocTypeLiteral */:
	                case 262 /* JsxAttributes */:
	                    return 1 /* IsContainer */;
	                case 235 /* InterfaceDeclaration */:
	                    return 1 /* IsContainer */ | 64 /* IsInterface */;
	                case 238 /* ModuleDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 176 /* MappedType */:
	                    return 1 /* IsContainer */ | 32 /* HasLocals */;
	                case 273 /* SourceFile */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */;
	                case 153 /* MethodDeclaration */:
	                    if (ts.isObjectLiteralOrClassExpressionMethod(node)) {
	                        return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */ | 128 /* IsObjectLiteralOrClassExpressionMethod */;
	                    }
	                // falls through
	                case 154 /* Constructor */:
	                case 233 /* FunctionDeclaration */:
	                case 152 /* MethodSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 157 /* CallSignature */:
	                case 287 /* JSDocSignature */:
	                case 283 /* JSDocFunctionType */:
	                case 162 /* FunctionType */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                case 163 /* ConstructorType */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */;
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return 1 /* IsContainer */ | 4 /* IsControlFlowContainer */ | 32 /* HasLocals */ | 8 /* IsFunctionLike */ | 16 /* IsFunctionExpression */;
	                case 239 /* ModuleBlock */:
	                    return 4 /* IsControlFlowContainer */;
	                case 151 /* PropertyDeclaration */:
	                    return node.initializer ? 4 /* IsControlFlowContainer */ : 0;
	                case 268 /* CatchClause */:
	                case 219 /* ForStatement */:
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                case 240 /* CaseBlock */:
	                    return 2 /* IsBlockScopedContainer */;
	                case 212 /* Block */:
	                    // do not treat blocks directly inside a function as a block-scoped-container.
	                    // Locals that reside in this block should go to the function locals. Otherwise 'x'
	                    // would not appear to be a redeclaration of a block scoped local in the following
	                    // example:
	                    //
	                    //      function foo() {
	                    //          var x;
	                    //          let x;
	                    //      }
	                    //
	                    // If we placed 'var x' into the function locals and 'let x' into the locals of
	                    // the block, then there would be no collision.
	                    //
	                    // By not creating a new block-scoped-container here, we ensure that both 'var x'
	                    // and 'let x' go into the Function-container's locals, and we do get a collision
	                    // conflict.
	                    return ts.isFunctionLike(node.parent) ? 0 /* None */ : 2 /* IsBlockScopedContainer */;
	            }
	            return 0 /* None */;
	        }
	        function addToContainerChain(next) {
	            if (lastContainer) {
	                lastContainer.nextContainer = next;
	            }
	            lastContainer = next;
	        }
	        function declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes) {
	            switch (container.kind) {
	                // Modules, source files, and classes need specialized handling for how their
	                // members are declared (for example, a member of a class will go into a specific
	                // symbol table depending on if it is static or not). We defer to specialized
	                // handlers to take care of declaring these child members.
	                case 238 /* ModuleDeclaration */:
	                    return declareModuleMember(node, symbolFlags, symbolExcludes);
	                case 273 /* SourceFile */:
	                    return declareSourceFileMember(node, symbolFlags, symbolExcludes);
	                case 204 /* ClassExpression */:
	                case 234 /* ClassDeclaration */:
	                    return declareClassMember(node, symbolFlags, symbolExcludes);
	                case 237 /* EnumDeclaration */:
	                    return declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes);
	                case 165 /* TypeLiteral */:
	                case 286 /* JSDocTypeLiteral */:
	                case 183 /* ObjectLiteralExpression */:
	                case 235 /* InterfaceDeclaration */:
	                case 262 /* JsxAttributes */:
	                    // Interface/Object-types always have their children added to the 'members' of
	                    // their container. They are only accessible through an instance of their
	                    // container, and are never in scope otherwise (even inside the body of the
	                    // object / type / interface declaring them). An exception is type parameters,
	                    // which are in scope without qualification (similar to 'locals').
	                    return declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 287 /* JSDocSignature */:
	                case 159 /* IndexSignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 154 /* Constructor */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                case 283 /* JSDocFunctionType */:
	                case 296 /* JSDocTypedefTag */:
	                case 291 /* JSDocCallbackTag */:
	                case 236 /* TypeAliasDeclaration */:
	                case 176 /* MappedType */:
	                    // All the children of these container types are never visible through another
	                    // symbol (i.e. through another symbol's 'exports' or 'members').  Instead,
	                    // they're only accessed 'lexically' (i.e. from code that exists underneath
	                    // their container in the tree). To accomplish this, we simply add their declared
	                    // symbol to the 'locals' of the container.  These symbols can then be found as
	                    // the type checker walks up the containers, checking them for matching names.
	                    return declareSymbol(container.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	            }
	        }
	        function declareClassMember(node, symbolFlags, symbolExcludes) {
	            return ts.hasModifier(node, 32 /* Static */)
	                ? declareSymbol(container.symbol.exports, container.symbol, node, symbolFlags, symbolExcludes)
	                : declareSymbol(container.symbol.members, container.symbol, node, symbolFlags, symbolExcludes);
	        }
	        function declareSourceFileMember(node, symbolFlags, symbolExcludes) {
	            return ts.isExternalModule(file)
	                ? declareModuleMember(node, symbolFlags, symbolExcludes)
	                : declareSymbol(file.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	        }
	        function hasExportDeclarations(node) {
	            var body = node.kind === 273 /* SourceFile */ ? node : node.body;
	            if (body && (body.kind === 273 /* SourceFile */ || body.kind === 239 /* ModuleBlock */)) {
	                for (var _i = 0, _a = body.statements; _i < _a.length; _i++) {
	                    var stat = _a[_i];
	                    if (stat.kind === 249 /* ExportDeclaration */ || stat.kind === 248 /* ExportAssignment */) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function setExportContextFlag(node) {
	            // A declaration source file or ambient module declaration that contains no export declarations (but possibly regular
	            // declarations with export modifiers) is an export context in which declarations are implicitly exported.
	            if (node.flags & 4194304 /* Ambient */ && !hasExportDeclarations(node)) {
	                node.flags |= 32 /* ExportContext */;
	            }
	            else {
	                node.flags &= ~32 /* ExportContext */;
	            }
	        }
	        function bindModuleDeclaration(node) {
	            setExportContextFlag(node);
	            if (ts.isAmbientModule(node)) {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    errorOnFirstToken(node, ts.Diagnostics.export_modifier_cannot_be_applied_to_ambient_modules_and_module_augmentations_since_they_are_always_visible);
	                }
	                if (ts.isModuleAugmentationExternal(node)) {
	                    declareModuleSymbol(node);
	                }
	                else {
	                    var pattern = void 0;
	                    if (node.name.kind === 9 /* StringLiteral */) {
	                        var text = node.name.text;
	                        if (ts.hasZeroOrOneAsteriskCharacter(text)) {
	                            pattern = ts.tryParsePattern(text);
	                        }
	                        else {
	                            errorOnFirstToken(node.name, ts.Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, text);
	                        }
	                    }
	                    var symbol = declareSymbolAndAddToSymbolTable(node, 512 /* ValueModule */, 67215503 /* ValueModuleExcludes */);
	                    file.patternAmbientModules = ts.append(file.patternAmbientModules, pattern && { pattern: pattern, symbol: symbol });
	                }
	            }
	            else {
	                var state = declareModuleSymbol(node);
	                if (state !== 0 /* NonInstantiated */) {
	                    var symbol = node.symbol;
	                    // if module was already merged with some function, class or non-const enum, treat it as non-const-enum-only
	                    symbol.constEnumOnlyModule = (!(symbol.flags & (16 /* Function */ | 32 /* Class */ | 256 /* RegularEnum */)))
	                        // Current must be `const enum` only
	                        && state === 2 /* ConstEnumOnly */
	                        // Can't have been set to 'false' in a previous merged symbol. ('undefined' OK)
	                        && symbol.constEnumOnlyModule !== false;
	                }
	            }
	        }
	        function declareModuleSymbol(node) {
	            var state = getModuleInstanceState(node);
	            var instantiated = state !== 0 /* NonInstantiated */;
	            declareSymbolAndAddToSymbolTable(node, instantiated ? 512 /* ValueModule */ : 1024 /* NamespaceModule */, instantiated ? 67215503 /* ValueModuleExcludes */ : 0 /* NamespaceModuleExcludes */);
	            return state;
	        }
	        function bindFunctionOrConstructorType(node) {
	            // For a given function symbol "<...>(...) => T" we want to generate a symbol identical
	            // to the one we would get for: { <...>(...): T }
	            //
	            // We do that by making an anonymous type literal symbol, and then setting the function
	            // symbol as its sole member. To the rest of the system, this symbol will be indistinguishable
	            // from an actual type literal symbol you would have gotten had you used the long form.
	            var symbol = createSymbol(131072 /* Signature */, getDeclarationName(node));
	            addDeclarationToSymbol(symbol, node, 131072 /* Signature */);
	            var typeLiteralSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	            addDeclarationToSymbol(typeLiteralSymbol, node, 2048 /* TypeLiteral */);
	            typeLiteralSymbol.members = ts.createSymbolTable();
	            typeLiteralSymbol.members.set(symbol.escapedName, symbol);
	        }
	        function bindObjectLiteralExpression(node) {
	            var ElementKind;
	            (function (ElementKind) {
	                ElementKind[ElementKind["Property"] = 1] = "Property";
	                ElementKind[ElementKind["Accessor"] = 2] = "Accessor";
	            })(ElementKind || (ElementKind = {}));
	            if (inStrictMode) {
	                var seen = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (prop.kind === 271 /* SpreadAssignment */ || prop.name.kind !== 71 /* Identifier */) {
	                        continue;
	                    }
	                    var identifier = prop.name;
	                    // ECMA-262 11.1.5 Object Initializer
	                    // If previous is not undefined then throw a SyntaxError exception if any of the following conditions are true
	                    // a.This production is contained in strict code and IsDataDescriptor(previous) is true and
	                    // IsDataDescriptor(propId.descriptor) is true.
	                    //    b.IsDataDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true.
	                    //    c.IsAccessorDescriptor(previous) is true and IsDataDescriptor(propId.descriptor) is true.
	                    //    d.IsAccessorDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true
	                    // and either both previous and propId.descriptor have[[Get]] fields or both previous and propId.descriptor have[[Set]] fields
	                    var currentKind = prop.kind === 269 /* PropertyAssignment */ || prop.kind === 270 /* ShorthandPropertyAssignment */ || prop.kind === 153 /* MethodDeclaration */
	                        ? 1 /* Property */
	                        : 2 /* Accessor */;
	                    var existingKind = seen.get(identifier.escapedText);
	                    if (!existingKind) {
	                        seen.set(identifier.escapedText, currentKind);
	                        continue;
	                    }
	                    if (currentKind === 1 /* Property */ && existingKind === 1 /* Property */) {
	                        var span = ts.getErrorSpanForNode(file, identifier);
	                        file.bindDiagnostics.push(ts.createFileDiagnostic(file, span.start, span.length, ts.Diagnostics.An_object_literal_cannot_have_multiple_properties_with_the_same_name_in_strict_mode));
	                    }
	                }
	            }
	            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */, "__object" /* Object */);
	        }
	        function bindJsxAttributes(node) {
	            return bindAnonymousDeclaration(node, 4096 /* ObjectLiteral */, "__jsxAttributes" /* JSXAttributes */);
	        }
	        function bindJsxAttribute(node, symbolFlags, symbolExcludes) {
	            return declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
	        }
	        function bindAnonymousDeclaration(node, symbolFlags, name) {
	            var symbol = createSymbol(symbolFlags, name);
	            if (symbolFlags & (8 /* EnumMember */ | 106500 /* ClassMember */)) {
	                symbol.parent = container.symbol;
	            }
	            addDeclarationToSymbol(symbol, node, symbolFlags);
	        }
	        function bindBlockScopedDeclaration(node, symbolFlags, symbolExcludes) {
	            switch (blockScopeContainer.kind) {
	                case 238 /* ModuleDeclaration */:
	                    declareModuleMember(node, symbolFlags, symbolExcludes);
	                    break;
	                case 273 /* SourceFile */:
	                    if (ts.isExternalOrCommonJsModule(container)) {
	                        declareModuleMember(node, symbolFlags, symbolExcludes);
	                        break;
	                    }
	                // falls through
	                default:
	                    if (!blockScopeContainer.locals) {
	                        blockScopeContainer.locals = ts.createSymbolTable();
	                        addToContainerChain(blockScopeContainer);
	                    }
	                    declareSymbol(blockScopeContainer.locals, /*parent*/ undefined, node, symbolFlags, symbolExcludes);
	            }
	        }
	        function bindBlockScopedVariableDeclaration(node) {
	            bindBlockScopedDeclaration(node, 2 /* BlockScopedVariable */, 67216319 /* BlockScopedVariableExcludes */);
	        }
	        function delayedBindJSDocTypedefTag() {
	            if (!delayedTypeAliases) {
	                return;
	            }
	            var saveContainer = container;
	            var saveLastContainer = lastContainer;
	            var saveBlockScopeContainer = blockScopeContainer;
	            var saveParent = parent;
	            var saveCurrentFlow = currentFlow;
	            for (var _i = 0, delayedTypeAliases_1 = delayedTypeAliases; _i < delayedTypeAliases_1.length; _i++) {
	                var typeAlias = delayedTypeAliases_1[_i];
	                var host = ts.getJSDocHost(typeAlias);
	                container = ts.findAncestor(host.parent, function (n) { return !!(getContainerFlags(n) & 1 /* IsContainer */); }) || file;
	                blockScopeContainer = ts.getEnclosingBlockScopeContainer(host) || file;
	                currentFlow = { flags: 2 /* Start */ };
	                parent = typeAlias;
	                bind(typeAlias.typeExpression);
	                if (!typeAlias.fullName || typeAlias.fullName.kind === 71 /* Identifier */) {
	                    parent = typeAlias.parent;
	                    bindBlockScopedDeclaration(typeAlias, 524288 /* TypeAlias */, 67901928 /* TypeAliasExcludes */);
	                }
	                else {
	                    bind(typeAlias.fullName);
	                }
	            }
	            container = saveContainer;
	            lastContainer = saveLastContainer;
	            blockScopeContainer = saveBlockScopeContainer;
	            parent = saveParent;
	            currentFlow = saveCurrentFlow;
	        }
	        // The binder visits every node in the syntax tree so it is a convenient place to perform a single localized
	        // check for reserved words used as identifiers in strict mode code.
	        function checkStrictModeIdentifier(node) {
	            if (inStrictMode &&
	                node.originalKeywordKind >= 108 /* FirstFutureReservedWord */ &&
	                node.originalKeywordKind <= 116 /* LastFutureReservedWord */ &&
	                !ts.isIdentifierName(node) &&
	                !(node.flags & 4194304 /* Ambient */)) {
	                // Report error only if there are no parse errors in file
	                if (!file.parseDiagnostics.length) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, getStrictModeIdentifierMessage(node), ts.declarationNameToString(node)));
	                }
	            }
	        }
	        function getStrictModeIdentifierMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Identifier_expected_0_is_a_reserved_word_in_strict_mode;
	        }
	        function checkStrictModeBinaryExpression(node) {
	            if (inStrictMode && ts.isLeftHandSideExpression(node.left) && ts.isAssignmentOperator(node.operatorToken.kind)) {
	                // ECMA 262 (Annex C) The identifier eval or arguments may not appear as the LeftHandSideExpression of an
	                // Assignment operator(11.13) or of a PostfixExpression(11.3)
	                checkStrictModeEvalOrArguments(node, node.left);
	            }
	        }
	        function checkStrictModeCatchClause(node) {
	            // It is a SyntaxError if a TryStatement with a Catch occurs within strict code and the Identifier of the
	            // Catch production is eval or arguments
	            if (inStrictMode && node.variableDeclaration) {
	                checkStrictModeEvalOrArguments(node, node.variableDeclaration.name);
	            }
	        }
	        function checkStrictModeDeleteExpression(node) {
	            // Grammar checking
	            if (inStrictMode && node.expression.kind === 71 /* Identifier */) {
	                // When a delete operator occurs within strict mode code, a SyntaxError is thrown if its
	                // UnaryExpression is a direct reference to a variable, function argument, or function name
	                var span = ts.getErrorSpanForNode(file, node.expression);
	                file.bindDiagnostics.push(ts.createFileDiagnostic(file, span.start, span.length, ts.Diagnostics.delete_cannot_be_called_on_an_identifier_in_strict_mode));
	            }
	        }
	        function isEvalOrArgumentsIdentifier(node) {
	            return ts.isIdentifier(node) && (node.escapedText === "eval" || node.escapedText === "arguments");
	        }
	        function checkStrictModeEvalOrArguments(contextNode, name) {
	            if (name && name.kind === 71 /* Identifier */) {
	                var identifier = name;
	                if (isEvalOrArgumentsIdentifier(identifier)) {
	                    // We check first if the name is inside class declaration or class expression; if so give explicit message
	                    // otherwise report generic error message.
	                    var span = ts.getErrorSpanForNode(file, name);
	                    file.bindDiagnostics.push(ts.createFileDiagnostic(file, span.start, span.length, getStrictModeEvalOrArgumentsMessage(contextNode), ts.idText(identifier)));
	                }
	            }
	        }
	        function getStrictModeEvalOrArgumentsMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Invalid_use_of_0_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Invalid_use_of_0_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Invalid_use_of_0_in_strict_mode;
	        }
	        function checkStrictModeFunctionName(node) {
	            if (inStrictMode) {
	                // It is a SyntaxError if the identifier eval or arguments appears within a FormalParameterList of a strict mode FunctionDeclaration or FunctionExpression (13.1))
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	        }
	        function getStrictModeBlockScopeFunctionDeclarationMessage(node) {
	            // Provide specialized messages to help the user understand why we think they're in
	            // strict mode.
	            if (ts.getContainingClass(node)) {
	                return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Class_definitions_are_automatically_in_strict_mode;
	            }
	            if (file.externalModuleIndicator) {
	                return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5_Modules_are_automatically_in_strict_mode;
	            }
	            return ts.Diagnostics.Function_declarations_are_not_allowed_inside_blocks_in_strict_mode_when_targeting_ES3_or_ES5;
	        }
	        function checkStrictModeFunctionDeclaration(node) {
	            if (languageVersion < 2 /* ES2015 */) {
	                // Report error if function is not top level function declaration
	                if (blockScopeContainer.kind !== 273 /* SourceFile */ &&
	                    blockScopeContainer.kind !== 238 /* ModuleDeclaration */ &&
	                    !ts.isFunctionLike(blockScopeContainer)) {
	                    // We check first if the name is inside class declaration or class expression; if so give explicit message
	                    // otherwise report generic error message.
	                    var errorSpan = ts.getErrorSpanForNode(file, node);
	                    file.bindDiagnostics.push(ts.createFileDiagnostic(file, errorSpan.start, errorSpan.length, getStrictModeBlockScopeFunctionDeclarationMessage(node)));
	                }
	            }
	        }
	        function checkStrictModeNumericLiteral(node) {
	            if (inStrictMode && node.numericLiteralFlags & 32 /* Octal */) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Octal_literals_are_not_allowed_in_strict_mode));
	            }
	        }
	        function checkStrictModePostfixUnaryExpression(node) {
	            // Grammar checking
	            // The identifier eval or arguments may not appear as the LeftHandSideExpression of an
	            // Assignment operator(11.13) or of a PostfixExpression(11.3) or as the UnaryExpression
	            // operated upon by a Prefix Increment(11.4.4) or a Prefix Decrement(11.4.5) operator.
	            if (inStrictMode) {
	                checkStrictModeEvalOrArguments(node, node.operand);
	            }
	        }
	        function checkStrictModePrefixUnaryExpression(node) {
	            // Grammar checking
	            if (inStrictMode) {
	                if (node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */) {
	                    checkStrictModeEvalOrArguments(node, node.operand);
	                }
	            }
	        }
	        function checkStrictModeWithStatement(node) {
	            // Grammar checking for withStatement
	            if (inStrictMode) {
	                errorOnFirstToken(node, ts.Diagnostics.with_statements_are_not_allowed_in_strict_mode);
	            }
	        }
	        function errorOnFirstToken(node, message, arg0, arg1, arg2) {
	            var span = ts.getSpanOfTokenAtPosition(file, node.pos);
	            file.bindDiagnostics.push(ts.createFileDiagnostic(file, span.start, span.length, message, arg0, arg1, arg2));
	        }
	        function errorOrSuggestionOnFirstToken(isError, node, message, arg0, arg1, arg2) {
	            var span = ts.getSpanOfTokenAtPosition(file, node.pos);
	            var diag = ts.createFileDiagnostic(file, span.start, span.length, message, arg0, arg1, arg2);
	            if (isError) {
	                file.bindDiagnostics.push(diag);
	            }
	            else {
	                file.bindSuggestionDiagnostics = ts.append(file.bindSuggestionDiagnostics, __assign({}, diag, { category: ts.DiagnosticCategory.Suggestion }));
	            }
	        }
	        function bind(node) {
	            if (!node) {
	                return;
	            }
	            node.parent = parent;
	            var saveInStrictMode = inStrictMode;
	            // Even though in the AST the jsdoc @typedef node belongs to the current node,
	            // its symbol might be in the same scope with the current node's symbol. Consider:
	            //
	            //     /** @typedef {string | number} MyType */
	            //     function foo();
	            //
	            // Here the current node is "foo", which is a container, but the scope of "MyType" should
	            // not be inside "foo". Therefore we always bind @typedef before bind the parent node,
	            // and skip binding this tag later when binding all the other jsdoc tags.
	            // First we bind declaration nodes to a symbol if possible. We'll both create a symbol
	            // and then potentially add the symbol to an appropriate symbol table. Possible
	            // destination symbol tables are:
	            //
	            //  1) The 'exports' table of the current container's symbol.
	            //  2) The 'members' table of the current container's symbol.
	            //  3) The 'locals' table of the current container.
	            //
	            // However, not all symbols will end up in any of these tables. 'Anonymous' symbols
	            // (like TypeLiterals for example) will not be put in any table.
	            bindWorker(node);
	            // Then we recurse into the children of the node to bind them as well. For certain
	            // symbols we do specialized work when we recurse. For example, we'll keep track of
	            // the current 'container' node when it changes. This helps us know which symbol table
	            // a local should go into for example. Since terminal nodes are known not to have
	            // children, as an optimization we don't process those.
	            if (node.kind > 144 /* LastToken */) {
	                var saveParent = parent;
	                parent = node;
	                var containerFlags = getContainerFlags(node);
	                if (containerFlags === 0 /* None */) {
	                    bindChildren(node);
	                }
	                else {
	                    bindContainer(node, containerFlags);
	                }
	                parent = saveParent;
	            }
	            else if (!skipTransformFlagAggregation && (node.transformFlags & 536870912 /* HasComputedFlags */) === 0) {
	                subtreeTransformFlags |= computeTransformFlagsForNode(node, 0);
	                bindJSDoc(node);
	            }
	            inStrictMode = saveInStrictMode;
	        }
	        function bindJSDoc(node) {
	            if (ts.hasJSDocNodes(node)) {
	                if (ts.isInJavaScriptFile(node)) {
	                    for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                        var j = _a[_i];
	                        bind(j);
	                    }
	                }
	                else {
	                    for (var _b = 0, _c = node.jsDoc; _b < _c.length; _b++) {
	                        var j = _c[_b];
	                        setParentPointers(node, j);
	                    }
	                }
	            }
	        }
	        function updateStrictModeStatementList(statements) {
	            if (!inStrictMode) {
	                for (var _i = 0, statements_1 = statements; _i < statements_1.length; _i++) {
	                    var statement = statements_1[_i];
	                    if (!ts.isPrologueDirective(statement)) {
	                        return;
	                    }
	                    if (isUseStrictPrologueDirective(statement)) {
	                        inStrictMode = true;
	                        return;
	                    }
	                }
	            }
	        }
	        /// Should be called only on prologue directives (isPrologueDirective(node) should be true)
	        function isUseStrictPrologueDirective(node) {
	            var nodeText = ts.getSourceTextOfNodeFromSourceFile(file, node.expression);
	            // Note: the node text must be exactly "use strict" or 'use strict'.  It is not ok for the
	            // string to contain unicode escapes (as per ES5).
	            return nodeText === '"use strict"' || nodeText === "'use strict'";
	        }
	        function bindWorker(node) {
	            switch (node.kind) {
	                /* Strict mode checks */
	                case 71 /* Identifier */:
	                    // for typedef type names with namespaces, bind the new jsdoc type symbol here
	                    // because it requires all containing namespaces to be in effect, namely the
	                    // current "blockScopeContainer" needs to be set to its immediate namespace parent.
	                    if (node.isInJSDocNamespace) {
	                        var parentNode = node.parent;
	                        while (parentNode && !ts.isJSDocTypeAlias(parentNode)) {
	                            parentNode = parentNode.parent;
	                        }
	                        bindBlockScopedDeclaration(parentNode, 524288 /* TypeAlias */, 67901928 /* TypeAliasExcludes */);
	                        break;
	                    }
	                // falls through
	                case 99 /* ThisKeyword */:
	                    if (currentFlow && (ts.isExpression(node) || parent.kind === 270 /* ShorthandPropertyAssignment */)) {
	                        node.flowNode = currentFlow;
	                    }
	                    return checkStrictModeIdentifier(node);
	                case 184 /* PropertyAccessExpression */:
	                    if (currentFlow && isNarrowableReference(node)) {
	                        node.flowNode = currentFlow;
	                    }
	                    if (ts.isSpecialPropertyDeclaration(node)) {
	                        bindSpecialPropertyDeclaration(node);
	                    }
	                    break;
	                case 199 /* BinaryExpression */:
	                    var specialKind = ts.getSpecialPropertyAssignmentKind(node);
	                    switch (specialKind) {
	                        case 1 /* ExportsProperty */:
	                            bindExportsPropertyAssignment(node);
	                            break;
	                        case 2 /* ModuleExports */:
	                            bindModuleExportsAssignment(node);
	                            break;
	                        case 3 /* PrototypeProperty */:
	                            bindPrototypePropertyAssignment(node.left, node);
	                            break;
	                        case 6 /* Prototype */:
	                            bindPrototypeAssignment(node);
	                            break;
	                        case 4 /* ThisProperty */:
	                            bindThisPropertyAssignment(node);
	                            break;
	                        case 5 /* Property */:
	                            bindSpecialPropertyAssignment(node);
	                            break;
	                        case 0 /* None */:
	                            // Nothing to do
	                            break;
	                        default:
	                            ts.Debug.fail("Unknown special property assignment kind");
	                    }
	                    return checkStrictModeBinaryExpression(node);
	                case 268 /* CatchClause */:
	                    return checkStrictModeCatchClause(node);
	                case 193 /* DeleteExpression */:
	                    return checkStrictModeDeleteExpression(node);
	                case 8 /* NumericLiteral */:
	                    return checkStrictModeNumericLiteral(node);
	                case 198 /* PostfixUnaryExpression */:
	                    return checkStrictModePostfixUnaryExpression(node);
	                case 197 /* PrefixUnaryExpression */:
	                    return checkStrictModePrefixUnaryExpression(node);
	                case 225 /* WithStatement */:
	                    return checkStrictModeWithStatement(node);
	                case 173 /* ThisType */:
	                    seenThisKeyword = true;
	                    return;
	                case 160 /* TypePredicate */:
	                    break; // Binding the children will handle everything
	                case 147 /* TypeParameter */:
	                    return bindTypeParameter(node);
	                case 148 /* Parameter */:
	                    return bindParameter(node);
	                case 231 /* VariableDeclaration */:
	                    return bindVariableDeclarationOrBindingElement(node);
	                case 181 /* BindingElement */:
	                    node.flowNode = currentFlow;
	                    return bindVariableDeclarationOrBindingElement(node);
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return bindPropertyWorker(node);
	                case 269 /* PropertyAssignment */:
	                case 270 /* ShorthandPropertyAssignment */:
	                    return bindPropertyOrMethodOrAccessor(node, 4 /* Property */, 0 /* PropertyExcludes */);
	                case 272 /* EnumMember */:
	                    return bindPropertyOrMethodOrAccessor(node, 8 /* EnumMember */, 68008959 /* EnumMemberExcludes */);
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                    return declareSymbolAndAddToSymbolTable(node, 131072 /* Signature */, 0 /* None */);
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    // If this is an ObjectLiteralExpression method, then it sits in the same space
	                    // as other properties in the object literal.  So we use SymbolFlags.PropertyExcludes
	                    // so that it will conflict with any other object literal members with the same
	                    // name.
	                    return bindPropertyOrMethodOrAccessor(node, 8192 /* Method */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), ts.isObjectLiteralMethod(node) ? 0 /* PropertyExcludes */ : 67208127 /* MethodExcludes */);
	                case 233 /* FunctionDeclaration */:
	                    return bindFunctionDeclaration(node);
	                case 154 /* Constructor */:
	                    return declareSymbolAndAddToSymbolTable(node, 16384 /* Constructor */, /*symbolExcludes:*/ 0 /* None */);
	                case 155 /* GetAccessor */:
	                    return bindPropertyOrMethodOrAccessor(node, 32768 /* GetAccessor */, 67150783 /* GetAccessorExcludes */);
	                case 156 /* SetAccessor */:
	                    return bindPropertyOrMethodOrAccessor(node, 65536 /* SetAccessor */, 67183551 /* SetAccessorExcludes */);
	                case 162 /* FunctionType */:
	                case 283 /* JSDocFunctionType */:
	                case 287 /* JSDocSignature */:
	                case 163 /* ConstructorType */:
	                    return bindFunctionOrConstructorType(node);
	                case 165 /* TypeLiteral */:
	                case 286 /* JSDocTypeLiteral */:
	                case 176 /* MappedType */:
	                    return bindAnonymousTypeWorker(node);
	                case 183 /* ObjectLiteralExpression */:
	                    return bindObjectLiteralExpression(node);
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return bindFunctionExpression(node);
	                case 186 /* CallExpression */:
	                    if (ts.isInJavaScriptFile(node)) {
	                        bindCallExpression(node);
	                    }
	                    break;
	                // Members of classes, interfaces, and modules
	                case 204 /* ClassExpression */:
	                case 234 /* ClassDeclaration */:
	                    // All classes are automatically in strict mode in ES6.
	                    inStrictMode = true;
	                    return bindClassLikeDeclaration(node);
	                case 235 /* InterfaceDeclaration */:
	                    return bindBlockScopedDeclaration(node, 64 /* Interface */, 67901832 /* InterfaceExcludes */);
	                case 236 /* TypeAliasDeclaration */:
	                    return bindBlockScopedDeclaration(node, 524288 /* TypeAlias */, 67901928 /* TypeAliasExcludes */);
	                case 237 /* EnumDeclaration */:
	                    return bindEnumDeclaration(node);
	                case 238 /* ModuleDeclaration */:
	                    return bindModuleDeclaration(node);
	                // Jsx-attributes
	                case 262 /* JsxAttributes */:
	                    return bindJsxAttributes(node);
	                case 261 /* JsxAttribute */:
	                    return bindJsxAttribute(node, 4 /* Property */, 0 /* PropertyExcludes */);
	                // Imports and exports
	                case 242 /* ImportEqualsDeclaration */:
	                case 245 /* NamespaceImport */:
	                case 247 /* ImportSpecifier */:
	                case 251 /* ExportSpecifier */:
	                    return declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	                case 241 /* NamespaceExportDeclaration */:
	                    return bindNamespaceExportDeclaration(node);
	                case 244 /* ImportClause */:
	                    return bindImportClause(node);
	                case 249 /* ExportDeclaration */:
	                    return bindExportDeclaration(node);
	                case 248 /* ExportAssignment */:
	                    return bindExportAssignment(node);
	                case 273 /* SourceFile */:
	                    updateStrictModeStatementList(node.statements);
	                    return bindSourceFileIfExternalModule();
	                case 212 /* Block */:
	                    if (!ts.isFunctionLike(node.parent)) {
	                        return;
	                    }
	                // falls through
	                case 239 /* ModuleBlock */:
	                    return updateStrictModeStatementList(node.statements);
	                case 292 /* JSDocParameterTag */:
	                    if (node.parent.kind === 287 /* JSDocSignature */) {
	                        return bindParameter(node);
	                    }
	                    if (node.parent.kind !== 286 /* JSDocTypeLiteral */) {
	                        break;
	                    }
	                // falls through
	                case 297 /* JSDocPropertyTag */:
	                    var propTag = node;
	                    var flags = propTag.isBracketed || propTag.typeExpression && propTag.typeExpression.type.kind === 282 /* JSDocOptionalType */ ?
	                        4 /* Property */ | 16777216 /* Optional */ :
	                        4 /* Property */;
	                    return declareSymbolAndAddToSymbolTable(propTag, flags, 0 /* PropertyExcludes */);
	                case 296 /* JSDocTypedefTag */:
	                case 291 /* JSDocCallbackTag */:
	                    return (delayedTypeAliases || (delayedTypeAliases = [])).push(node);
	            }
	        }
	        function bindPropertyWorker(node) {
	            return bindPropertyOrMethodOrAccessor(node, 4 /* Property */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), 0 /* PropertyExcludes */);
	        }
	        function bindAnonymousTypeWorker(node) {
	            return bindAnonymousDeclaration(node, 2048 /* TypeLiteral */, "__type" /* Type */);
	        }
	        function bindSourceFileIfExternalModule() {
	            setExportContextFlag(file);
	            if (ts.isExternalModule(file)) {
	                bindSourceFileAsExternalModule();
	            }
	            else if (ts.isJsonSourceFile(file)) {
	                bindSourceFileAsExternalModule();
	                // Create symbol equivalent for the module.exports = {}
	                var originalSymbol = file.symbol;
	                declareSymbol(file.symbol.exports, file.symbol, file, 4 /* Property */, 67108863 /* All */);
	                file.symbol = originalSymbol;
	            }
	        }
	        function bindSourceFileAsExternalModule() {
	            bindAnonymousDeclaration(file, 512 /* ValueModule */, "\"" + ts.removeFileExtension(file.fileName) + "\"");
	        }
	        function bindExportAssignment(node) {
	            if (!container.symbol || !container.symbol.exports) {
	                // Export assignment in some sort of block construct
	                bindAnonymousDeclaration(node, 2097152 /* Alias */, getDeclarationName(node));
	            }
	            else {
	                var flags = node.kind === 248 /* ExportAssignment */ && ts.exportAssignmentIsAlias(node)
	                    // An export default clause with an EntityNameExpression or a class expression exports all meanings of that identifier or expression;
	                    ? 2097152 /* Alias */
	                    // An export default clause with any other expression exports a value
	                    : 4 /* Property */;
	                // If there is an `export default x;` alias declaration, can't `export default` anything else.
	                // (In contrast, you can still have `export default function f() {}` and `export default interface I {}`.)
	                declareSymbol(container.symbol.exports, container.symbol, node, flags, 67108863 /* All */);
	            }
	        }
	        function bindNamespaceExportDeclaration(node) {
	            if (node.modifiers && node.modifiers.length) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Modifiers_cannot_appear_here));
	            }
	            if (node.parent.kind !== 273 /* SourceFile */) {
	                file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_at_top_level));
	                return;
	            }
	            else {
	                var parent_1 = node.parent;
	                if (!ts.isExternalModule(parent_1)) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_in_module_files));
	                    return;
	                }
	                if (!parent_1.isDeclarationFile) {
	                    file.bindDiagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.Global_module_exports_may_only_appear_in_declaration_files));
	                    return;
	                }
	            }
	            file.symbol.globalExports = file.symbol.globalExports || ts.createSymbolTable();
	            declareSymbol(file.symbol.globalExports, file.symbol, node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	        }
	        function bindExportDeclaration(node) {
	            if (!container.symbol || !container.symbol.exports) {
	                // Export * in some sort of block construct
	                bindAnonymousDeclaration(node, 8388608 /* ExportStar */, getDeclarationName(node));
	            }
	            else if (!node.exportClause) {
	                // All export * declarations are collected in an __export symbol
	                declareSymbol(container.symbol.exports, container.symbol, node, 8388608 /* ExportStar */, 0 /* None */);
	            }
	        }
	        function bindImportClause(node) {
	            if (node.name) {
	                declareSymbolAndAddToSymbolTable(node, 2097152 /* Alias */, 2097152 /* AliasExcludes */);
	            }
	        }
	        function setCommonJsModuleIndicator(node) {
	            if (!file.commonJsModuleIndicator) {
	                file.commonJsModuleIndicator = node;
	                if (!file.externalModuleIndicator) {
	                    bindSourceFileAsExternalModule();
	                }
	            }
	        }
	        function bindExportsPropertyAssignment(node) {
	            // When we create a property via 'exports.foo = bar', the 'exports.foo' property access
	            // expression is the declaration
	            setCommonJsModuleIndicator(node);
	            var lhs = node.left;
	            var symbol = forEachIdentifierInEntityName(lhs.expression, function (id, original) {
	                if (!original) {
	                    return undefined;
	                }
	                var s = ts.getJSInitializerSymbol(original);
	                addDeclarationToSymbol(s, id, 1536 /* Module */ | 67108864 /* JSContainer */);
	                return s;
	            });
	            if (symbol) {
	                var flags = ts.isClassExpression(node.right) ?
	                    4 /* Property */ | 1048576 /* ExportValue */ | 32 /* Class */ :
	                    4 /* Property */ | 1048576 /* ExportValue */;
	                declareSymbol(symbol.exports, symbol, lhs, flags, 0 /* None */);
	            }
	        }
	        function bindModuleExportsAssignment(node) {
	            // A common practice in node modules is to set 'export = module.exports = {}', this ensures that 'exports'
	            // is still pointing to 'module.exports'.
	            // We do not want to consider this as 'export=' since a module can have only one of these.
	            // Similarly we do not want to treat 'module.exports = exports' as an 'export='.
	            var assignedExpression = ts.getRightMostAssignedExpression(node.right);
	            if (ts.isEmptyObjectLiteral(assignedExpression) || container === file && isExportsOrModuleExportsOrAlias(file, assignedExpression)) {
	                // Mark it as a module in case there are no other exports in the file
	                setCommonJsModuleIndicator(node);
	                return;
	            }
	            // 'module.exports = expr' assignment
	            setCommonJsModuleIndicator(node);
	            var flags = ts.exportAssignmentIsAlias(node)
	                ? 2097152 /* Alias */
	                : 4 /* Property */ | 1048576 /* ExportValue */ | 512 /* ValueModule */;
	            declareSymbol(file.symbol.exports, file.symbol, node, flags, 0 /* None */);
	        }
	        function bindThisPropertyAssignment(node) {
	            ts.Debug.assert(ts.isInJavaScriptFile(node));
	            var thisContainer = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	            switch (thisContainer.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                    var constructorSymbol = thisContainer.symbol;
	                    // For `f.prototype.m = function() { this.x = 0; }`, `this.x = 0` should modify `f`'s members, not the function expression.
	                    if (ts.isBinaryExpression(thisContainer.parent) && thisContainer.parent.operatorToken.kind === 58 /* EqualsToken */) {
	                        var l = thisContainer.parent.left;
	                        if (ts.isPropertyAccessEntityNameExpression(l) && ts.isPrototypeAccess(l.expression)) {
	                            constructorSymbol = getJSInitializerSymbolFromName(l.expression.expression, thisParentContainer);
	                        }
	                    }
	                    if (constructorSymbol) {
	                        // Declare a 'member' if the container is an ES5 class or ES6 constructor
	                        constructorSymbol.members = constructorSymbol.members || ts.createSymbolTable();
	                        // It's acceptable for multiple 'this' assignments of the same identifier to occur
	                        declareSymbol(constructorSymbol.members, constructorSymbol, node, 4 /* Property */, 0 /* PropertyExcludes */ & ~4 /* Property */);
	                    }
	                    break;
	                case 154 /* Constructor */:
	                case 151 /* PropertyDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    // this.foo assignment in a JavaScript class
	                    // Bind this property to the containing class
	                    var containingClass = thisContainer.parent;
	                    var symbolTable = ts.hasModifier(thisContainer, 32 /* Static */) ? containingClass.symbol.exports : containingClass.symbol.members;
	                    declareSymbol(symbolTable, containingClass.symbol, node, 4 /* Property */, 0 /* None */, /*isReplaceableByMethod*/ true);
	                    break;
	                case 273 /* SourceFile */:
	                    // this.foo assignment in a source file
	                    // Do not bind. It would be nice to support this someday though.
	                    break;
	                default:
	                    ts.Debug.fail(ts.Debug.showSyntaxKind(thisContainer));
	            }
	        }
	        function bindSpecialPropertyDeclaration(node) {
	            if (node.expression.kind === 99 /* ThisKeyword */) {
	                bindThisPropertyAssignment(node);
	            }
	            else if (ts.isPropertyAccessEntityNameExpression(node) && node.parent.parent.kind === 273 /* SourceFile */) {
	                if (ts.isPrototypeAccess(node.expression)) {
	                    bindPrototypePropertyAssignment(node, node.parent);
	                }
	                else {
	                    bindStaticPropertyAssignment(node);
	                }
	            }
	        }
	        /** For `x.prototype = { p, ... }`, declare members p,... if `x` is function/class/{}, or not declared. */
	        function bindPrototypeAssignment(node) {
	            node.left.parent = node;
	            node.right.parent = node;
	            var lhs = node.left;
	            bindPropertyAssignment(lhs, lhs, /*isPrototypeProperty*/ false);
	        }
	        /**
	         * For `x.prototype.y = z`, declare a member `y` on `x` if `x` is a function or class, or not declared.
	         * Note that jsdoc preceding an ExpressionStatement like `x.prototype.y;` is also treated as a declaration.
	         */
	        function bindPrototypePropertyAssignment(lhs, parent) {
	            // Look up the function in the local scope, since prototype assignments should
	            // follow the function declaration
	            var classPrototype = lhs.expression;
	            var constructorFunction = classPrototype.expression;
	            // Fix up parent pointers since we're going to use these nodes before we bind into them
	            lhs.parent = parent;
	            constructorFunction.parent = classPrototype;
	            classPrototype.parent = lhs;
	            bindPropertyAssignment(constructorFunction, lhs, /*isPrototypeProperty*/ true);
	        }
	        function bindSpecialPropertyAssignment(node) {
	            var lhs = node.left;
	            // Fix up parent pointers since we're going to use these nodes before we bind into them
	            node.left.parent = node;
	            node.right.parent = node;
	            if (ts.isIdentifier(lhs.expression) && container === file && isNameOfExportsOrModuleExportsAliasDeclaration(file, lhs.expression)) {
	                // This can be an alias for the 'exports' or 'module.exports' names, e.g.
	                //    var util = module.exports;
	                //    util.property = function ...
	                bindExportsPropertyAssignment(node);
	            }
	            else {
	                bindStaticPropertyAssignment(lhs);
	            }
	        }
	        /**
	         * For nodes like `x.y = z`, declare a member 'y' on 'x' if x is a function (or IIFE) or class or {}, or not declared.
	         * Also works for expression statements preceded by JSDoc, like / ** @type number * / x.y;
	         */
	        function bindStaticPropertyAssignment(node) {
	            node.expression.parent = node;
	            bindPropertyAssignment(node.expression, node, /*isPrototypeProperty*/ false);
	        }
	        function getJSInitializerSymbolFromName(name, lookupContainer) {
	            return ts.getJSInitializerSymbol(lookupSymbolForPropertyAccess(name, lookupContainer));
	        }
	        function bindPropertyAssignment(name, propertyAccess, isPrototypeProperty) {
	            var symbol = getJSInitializerSymbolFromName(name);
	            var isToplevelNamespaceableInitializer = ts.isBinaryExpression(propertyAccess.parent)
	                ? getParentOfBinaryExpression(propertyAccess.parent).parent.kind === 273 /* SourceFile */ &&
	                    !!ts.getJavascriptInitializer(ts.getInitializerOfBinaryExpression(propertyAccess.parent), ts.isPrototypeAccess(propertyAccess.parent.left))
	                : propertyAccess.parent.parent.kind === 273 /* SourceFile */;
	            if (!isPrototypeProperty && (!symbol || !(symbol.flags & 1920 /* Namespace */)) && isToplevelNamespaceableInitializer) {
	                // make symbols or add declarations for intermediate containers
	                var flags_1 = 1536 /* Module */ | 67108864 /* JSContainer */;
	                var excludeFlags_1 = 67215503 /* ValueModuleExcludes */ & ~67108864 /* JSContainer */;
	                forEachIdentifierInEntityName(propertyAccess.expression, function (id, original) {
	                    if (original) {
	                        // Note: add declaration to original symbol, not the special-syntax's symbol, so that namespaces work for type lookup
	                        addDeclarationToSymbol(original, id, flags_1);
	                        return original;
	                    }
	                    else {
	                        return symbol = declareSymbol(symbol ? symbol.exports : container.locals, symbol, id, flags_1, excludeFlags_1);
	                    }
	                });
	            }
	            if (!symbol || !(symbol.flags & (16 /* Function */ | 32 /* Class */ | 1024 /* NamespaceModule */ | 4096 /* ObjectLiteral */))) {
	                return;
	            }
	            // Set up the members collection if it doesn't exist already
	            var symbolTable = isPrototypeProperty ?
	                (symbol.members || (symbol.members = ts.createSymbolTable())) :
	                (symbol.exports || (symbol.exports = ts.createSymbolTable()));
	            // Declare the method/property
	            var jsContainerFlag = isToplevelNamespaceableInitializer ? 67108864 /* JSContainer */ : 0;
	            var isMethod = ts.isFunctionLikeDeclaration(ts.getAssignedJavascriptInitializer(propertyAccess));
	            var symbolFlags = (isMethod ? 8192 /* Method */ : 4 /* Property */) | jsContainerFlag;
	            var symbolExcludes = (isMethod ? 67208127 /* MethodExcludes */ : 0 /* PropertyExcludes */) & ~jsContainerFlag;
	            declareSymbol(symbolTable, symbol, propertyAccess, symbolFlags, symbolExcludes);
	        }
	        function getParentOfBinaryExpression(expr) {
	            while (ts.isBinaryExpression(expr.parent)) {
	                expr = expr.parent;
	            }
	            return expr.parent;
	        }
	        function lookupSymbolForPropertyAccess(node, lookupContainer) {
	            if (lookupContainer === void 0) { lookupContainer = container; }
	            if (ts.isIdentifier(node)) {
	                return lookupSymbolForNameWorker(lookupContainer, node.escapedText);
	            }
	            else {
	                var symbol = ts.getJSInitializerSymbol(lookupSymbolForPropertyAccess(node.expression));
	                return symbol && symbol.exports && symbol.exports.get(node.name.escapedText);
	            }
	        }
	        function forEachIdentifierInEntityName(e, action) {
	            if (isExportsOrModuleExportsOrAlias(file, e)) {
	                return file.symbol;
	            }
	            else if (ts.isIdentifier(e)) {
	                return action(e, lookupSymbolForPropertyAccess(e));
	            }
	            else {
	                var s = ts.getJSInitializerSymbol(forEachIdentifierInEntityName(e.expression, action));
	                ts.Debug.assert(!!s && !!s.exports);
	                return action(e.name, s.exports.get(e.name.escapedText));
	            }
	        }
	        function bindCallExpression(node) {
	            // We're only inspecting call expressions to detect CommonJS modules, so we can skip
	            // this check if we've already seen the module indicator
	            if (!file.commonJsModuleIndicator && ts.isRequireCall(node, /*checkArgumentIsStringLiteralLike*/ false)) {
	                setCommonJsModuleIndicator(node);
	            }
	        }
	        function bindClassLikeDeclaration(node) {
	            if (node.kind === 234 /* ClassDeclaration */) {
	                bindBlockScopedDeclaration(node, 32 /* Class */, 68008383 /* ClassExcludes */);
	            }
	            else {
	                var bindingName = node.name ? node.name.escapedText : "__class" /* Class */;
	                bindAnonymousDeclaration(node, 32 /* Class */, bindingName);
	                // Add name of class expression into the map for semantic classifier
	                if (node.name) {
	                    classifiableNames.set(node.name.escapedText, true);
	                }
	            }
	            var symbol = node.symbol;
	            // TypeScript 1.0 spec (April 2014): 8.4
	            // Every class automatically contains a static property member named 'prototype', the
	            // type of which is an instantiation of the class type with type Any supplied as a type
	            // argument for each type parameter. It is an error to explicitly declare a static
	            // property member with the name 'prototype'.
	            //
	            // Note: we check for this here because this class may be merging into a module.  The
	            // module might have an exported variable called 'prototype'.  We can't allow that as
	            // that would clash with the built-in 'prototype' for the class.
	            var prototypeSymbol = createSymbol(4 /* Property */ | 4194304 /* Prototype */, "prototype");
	            var symbolExport = symbol.exports.get(prototypeSymbol.escapedName);
	            if (symbolExport) {
	                if (node.name) {
	                    node.name.parent = node;
	                }
	                file.bindDiagnostics.push(createDiagnosticForNode(symbolExport.declarations[0], ts.Diagnostics.Duplicate_identifier_0, ts.symbolName(prototypeSymbol)));
	            }
	            symbol.exports.set(prototypeSymbol.escapedName, prototypeSymbol);
	            prototypeSymbol.parent = symbol;
	        }
	        function bindEnumDeclaration(node) {
	            return ts.isConst(node)
	                ? bindBlockScopedDeclaration(node, 128 /* ConstEnum */, 68008831 /* ConstEnumExcludes */)
	                : bindBlockScopedDeclaration(node, 256 /* RegularEnum */, 68008191 /* RegularEnumExcludes */);
	        }
	        function bindVariableDeclarationOrBindingElement(node) {
	            if (inStrictMode) {
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	            if (!ts.isBindingPattern(node.name)) {
	                if (ts.isBlockOrCatchScoped(node)) {
	                    bindBlockScopedVariableDeclaration(node);
	                }
	                else if (ts.isParameterDeclaration(node)) {
	                    // It is safe to walk up parent chain to find whether the node is a destructing parameter declaration
	                    // because its parent chain has already been set up, since parents are set before descending into children.
	                    //
	                    // If node is a binding element in parameter declaration, we need to use ParameterExcludes.
	                    // Using ParameterExcludes flag allows the compiler to report an error on duplicate identifiers in Parameter Declaration
	                    // For example:
	                    //      function foo([a,a]) {} // Duplicate Identifier error
	                    //      function bar(a,a) {}   // Duplicate Identifier error, parameter declaration in this case is handled in bindParameter
	                    //                             // which correctly set excluded symbols
	                    declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 67216319 /* ParameterExcludes */);
	                }
	                else {
	                    declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 67216318 /* FunctionScopedVariableExcludes */);
	                }
	            }
	        }
	        function bindParameter(node) {
	            if (node.kind === 292 /* JSDocParameterTag */ && container.kind !== 287 /* JSDocSignature */) {
	                return;
	            }
	            if (inStrictMode && !(node.flags & 4194304 /* Ambient */)) {
	                // It is a SyntaxError if the identifier eval or arguments appears within a FormalParameterList of a
	                // strict mode FunctionLikeDeclaration or FunctionExpression(13.1)
	                checkStrictModeEvalOrArguments(node, node.name);
	            }
	            if (ts.isBindingPattern(node.name)) {
	                bindAnonymousDeclaration(node, 1 /* FunctionScopedVariable */, "__" + node.parent.parameters.indexOf(node));
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 1 /* FunctionScopedVariable */, 67216319 /* ParameterExcludes */);
	            }
	            // If this is a property-parameter, then also declare the property symbol into the
	            // containing class.
	            if (ts.isParameterPropertyDeclaration(node)) {
	                var classDeclaration = node.parent.parent;
	                declareSymbol(classDeclaration.symbol.members, classDeclaration.symbol, node, 4 /* Property */ | (node.questionToken ? 16777216 /* Optional */ : 0 /* None */), 0 /* PropertyExcludes */);
	            }
	        }
	        function bindFunctionDeclaration(node) {
	            if (!file.isDeclarationFile && !(node.flags & 4194304 /* Ambient */)) {
	                if (ts.isAsyncFunction(node)) {
	                    emitFlags |= 1024 /* HasAsyncFunctions */;
	                }
	            }
	            checkStrictModeFunctionName(node);
	            if (inStrictMode) {
	                checkStrictModeFunctionDeclaration(node);
	                bindBlockScopedDeclaration(node, 16 /* Function */, 67215791 /* FunctionExcludes */);
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 16 /* Function */, 67215791 /* FunctionExcludes */);
	            }
	        }
	        function bindFunctionExpression(node) {
	            if (!file.isDeclarationFile && !(node.flags & 4194304 /* Ambient */)) {
	                if (ts.isAsyncFunction(node)) {
	                    emitFlags |= 1024 /* HasAsyncFunctions */;
	                }
	            }
	            if (currentFlow) {
	                node.flowNode = currentFlow;
	            }
	            checkStrictModeFunctionName(node);
	            var bindingName = node.name ? node.name.escapedText : "__function" /* Function */;
	            return bindAnonymousDeclaration(node, 16 /* Function */, bindingName);
	        }
	        function bindPropertyOrMethodOrAccessor(node, symbolFlags, symbolExcludes) {
	            if (!file.isDeclarationFile && !(node.flags & 4194304 /* Ambient */) && ts.isAsyncFunction(node)) {
	                emitFlags |= 1024 /* HasAsyncFunctions */;
	            }
	            if (currentFlow && ts.isObjectLiteralOrClassExpressionMethod(node)) {
	                node.flowNode = currentFlow;
	            }
	            return ts.hasDynamicName(node)
	                ? bindAnonymousDeclaration(node, symbolFlags, "__computed" /* Computed */)
	                : declareSymbolAndAddToSymbolTable(node, symbolFlags, symbolExcludes);
	        }
	        function getInferTypeContainer(node) {
	            var extendsType = ts.findAncestor(node, function (n) { return n.parent && ts.isConditionalTypeNode(n.parent) && n.parent.extendsType === n; });
	            return extendsType && extendsType.parent;
	        }
	        function bindTypeParameter(node) {
	            if (ts.isJSDocTemplateTag(node.parent)) {
	                var container_1 = ts.find(node.parent.parent.tags, ts.isJSDocTypeAlias) || ts.getHostSignatureFromJSDoc(node.parent);
	                if (container_1) {
	                    if (!container_1.locals) {
	                        container_1.locals = ts.createSymbolTable();
	                    }
	                    declareSymbol(container_1.locals, /*parent*/ undefined, node, 262144 /* TypeParameter */, 67639784 /* TypeParameterExcludes */);
	                }
	                else {
	                    declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */, 67639784 /* TypeParameterExcludes */);
	                }
	            }
	            else if (node.parent.kind === 171 /* InferType */) {
	                var container_2 = getInferTypeContainer(node.parent);
	                if (container_2) {
	                    if (!container_2.locals) {
	                        container_2.locals = ts.createSymbolTable();
	                    }
	                    declareSymbol(container_2.locals, /*parent*/ undefined, node, 262144 /* TypeParameter */, 67639784 /* TypeParameterExcludes */);
	                }
	                else {
	                    bindAnonymousDeclaration(node, 262144 /* TypeParameter */, getDeclarationName(node));
	                }
	            }
	            else {
	                declareSymbolAndAddToSymbolTable(node, 262144 /* TypeParameter */, 67639784 /* TypeParameterExcludes */);
	            }
	        }
	        // reachability checks
	        function shouldReportErrorOnModuleDeclaration(node) {
	            var instanceState = getModuleInstanceState(node);
	            return instanceState === 1 /* Instantiated */ || (instanceState === 2 /* ConstEnumOnly */ && options.preserveConstEnums);
	        }
	        function checkUnreachable(node) {
	            if (!(currentFlow.flags & 1 /* Unreachable */)) {
	                return false;
	            }
	            if (currentFlow === unreachableFlow) {
	                var reportError = 
	                // report error on all statements except empty ones
	                (ts.isStatementButNotDeclaration(node) && node.kind !== 214 /* EmptyStatement */) ||
	                    // report error on class declarations
	                    node.kind === 234 /* ClassDeclaration */ ||
	                    // report error on instantiated modules or const-enums only modules if preserveConstEnums is set
	                    (node.kind === 238 /* ModuleDeclaration */ && shouldReportErrorOnModuleDeclaration(node)) ||
	                    // report error on regular enums and const enums if preserveConstEnums is set
	                    (node.kind === 237 /* EnumDeclaration */ && (!ts.isConstEnumDeclaration(node) || options.preserveConstEnums));
	                if (reportError) {
	                    currentFlow = reportedUnreachableFlow;
	                    if (!options.allowUnreachableCode) {
	                        // unreachable code is reported if
	                        // - user has explicitly asked about it AND
	                        // - statement is in not ambient context (statements in ambient context is already an error
	                        //   so we should not report extras) AND
	                        //   - node is not variable statement OR
	                        //   - node is block scoped variable statement OR
	                        //   - node is not block scoped variable statement and at least one variable declaration has initializer
	                        //   Rationale: we don't want to report errors on non-initialized var's since they are hoisted
	                        //   On the other side we do want to report errors on non-initialized 'lets' because of TDZ
	                        var isError = ts.unreachableCodeIsError(options) &&
	                            !(node.flags & 4194304 /* Ambient */) &&
	                            (!ts.isVariableStatement(node) ||
	                                !!(ts.getCombinedNodeFlags(node.declarationList) & 3 /* BlockScoped */) ||
	                                node.declarationList.declarations.some(function (d) { return !!d.initializer; }));
	                        errorOrSuggestionOnFirstToken(isError, node, ts.Diagnostics.Unreachable_code_detected);
	                    }
	                }
	            }
	            return true;
	        }
	    }
	    /* @internal */
	    function isExportsOrModuleExportsOrAlias(sourceFile, node) {
	        return ts.isExportsIdentifier(node) ||
	            ts.isModuleExportsPropertyAccessExpression(node) ||
	            ts.isIdentifier(node) && isNameOfExportsOrModuleExportsAliasDeclaration(sourceFile, node);
	    }
	    ts.isExportsOrModuleExportsOrAlias = isExportsOrModuleExportsOrAlias;
	    function isNameOfExportsOrModuleExportsAliasDeclaration(sourceFile, node) {
	        var symbol = lookupSymbolForNameWorker(sourceFile, node.escapedText);
	        return symbol && symbol.valueDeclaration && ts.isVariableDeclaration(symbol.valueDeclaration) &&
	            symbol.valueDeclaration.initializer && isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, symbol.valueDeclaration.initializer);
	    }
	    function isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node) {
	        return isExportsOrModuleExportsOrAlias(sourceFile, node) ||
	            (ts.isAssignmentExpression(node, /*excludeCompoundAssignment*/ true) && (isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node.left) || isExportsOrModuleExportsOrAliasOrAssignment(sourceFile, node.right)));
	    }
	    function lookupSymbolForNameWorker(container, name) {
	        var local = container.locals && container.locals.get(name);
	        if (local) {
	            return local.exportSymbol || local;
	        }
	        return container.symbol && container.symbol.exports && container.symbol.exports.get(name);
	    }
	    /**
	     * Computes the transform flags for a node, given the transform flags of its subtree
	     *
	     * @param node The node to analyze
	     * @param subtreeFlags Transform flags computed for this node's subtree
	     */
	    function computeTransformFlagsForNode(node, subtreeFlags) {
	        var kind = node.kind;
	        switch (kind) {
	            case 186 /* CallExpression */:
	                return computeCallExpression(node, subtreeFlags);
	            case 187 /* NewExpression */:
	                return computeNewExpression(node, subtreeFlags);
	            case 238 /* ModuleDeclaration */:
	                return computeModuleDeclaration(node, subtreeFlags);
	            case 190 /* ParenthesizedExpression */:
	                return computeParenthesizedExpression(node, subtreeFlags);
	            case 199 /* BinaryExpression */:
	                return computeBinaryExpression(node, subtreeFlags);
	            case 215 /* ExpressionStatement */:
	                return computeExpressionStatement(node, subtreeFlags);
	            case 148 /* Parameter */:
	                return computeParameter(node, subtreeFlags);
	            case 192 /* ArrowFunction */:
	                return computeArrowFunction(node, subtreeFlags);
	            case 191 /* FunctionExpression */:
	                return computeFunctionExpression(node, subtreeFlags);
	            case 233 /* FunctionDeclaration */:
	                return computeFunctionDeclaration(node, subtreeFlags);
	            case 231 /* VariableDeclaration */:
	                return computeVariableDeclaration(node, subtreeFlags);
	            case 232 /* VariableDeclarationList */:
	                return computeVariableDeclarationList(node, subtreeFlags);
	            case 213 /* VariableStatement */:
	                return computeVariableStatement(node, subtreeFlags);
	            case 227 /* LabeledStatement */:
	                return computeLabeledStatement(node, subtreeFlags);
	            case 234 /* ClassDeclaration */:
	                return computeClassDeclaration(node, subtreeFlags);
	            case 204 /* ClassExpression */:
	                return computeClassExpression(node, subtreeFlags);
	            case 267 /* HeritageClause */:
	                return computeHeritageClause(node, subtreeFlags);
	            case 268 /* CatchClause */:
	                return computeCatchClause(node, subtreeFlags);
	            case 206 /* ExpressionWithTypeArguments */:
	                return computeExpressionWithTypeArguments(node, subtreeFlags);
	            case 154 /* Constructor */:
	                return computeConstructor(node, subtreeFlags);
	            case 151 /* PropertyDeclaration */:
	                return computePropertyDeclaration(node, subtreeFlags);
	            case 153 /* MethodDeclaration */:
	                return computeMethod(node, subtreeFlags);
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return computeAccessor(node, subtreeFlags);
	            case 242 /* ImportEqualsDeclaration */:
	                return computeImportEquals(node, subtreeFlags);
	            case 184 /* PropertyAccessExpression */:
	                return computePropertyAccess(node, subtreeFlags);
	            case 185 /* ElementAccessExpression */:
	                return computeElementAccess(node, subtreeFlags);
	            default:
	                return computeOther(node, kind, subtreeFlags);
	        }
	    }
	    ts.computeTransformFlagsForNode = computeTransformFlagsForNode;
	    function computeCallExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 524288 /* ContainsSpread */
	            || (expression.transformFlags & (134217728 /* Super */ | 268435456 /* ContainsSuper */))) {
	            // If the this node contains a SpreadExpression, or is a super call, then it is an ES6
	            // node.
	            transformFlags |= 192 /* AssertES2015 */;
	            // super property or element accesses could be inside lambdas, etc, and need a captured `this`,
	            // while super keyword for super calls (indicated by TransformFlags.Super) does not (since it can only be top-level in a constructor)
	            if (expression.transformFlags & 268435456 /* ContainsSuper */) {
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	            }
	        }
	        if (expression.kind === 91 /* ImportKeyword */) {
	            transformFlags |= 67108864 /* ContainsDynamicImport */;
	            // A dynamic 'import()' call that contains a lexical 'this' will
	            // require a captured 'this' when emitting down-level.
	            if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	                transformFlags |= 32768 /* ContainsCapturedLexicalThis */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	    }
	    function computeNewExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 524288 /* ContainsSpread */) {
	            // If the this node contains a SpreadElementExpression then it is an ES6
	            // node.
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	    }
	    function computeBinaryExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var operatorTokenKind = node.operatorToken.kind;
	        var leftKind = node.left.kind;
	        if (operatorTokenKind === 58 /* EqualsToken */ && leftKind === 183 /* ObjectLiteralExpression */) {
	            // Destructuring object assignments with are ES2015 syntax
	            // and possibly ESNext if they contain rest
	            transformFlags |= 8 /* AssertESNext */ | 192 /* AssertES2015 */ | 3072 /* AssertDestructuringAssignment */;
	        }
	        else if (operatorTokenKind === 58 /* EqualsToken */ && leftKind === 182 /* ArrayLiteralExpression */) {
	            // Destructuring assignments are ES2015 syntax.
	            transformFlags |= 192 /* AssertES2015 */ | 3072 /* AssertDestructuringAssignment */;
	        }
	        else if (operatorTokenKind === 40 /* AsteriskAsteriskToken */
	            || operatorTokenKind === 62 /* AsteriskAsteriskEqualsToken */) {
	            // Exponentiation is ES2016 syntax.
	            transformFlags |= 32 /* AssertES2016 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeParameter(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var name = node.name;
	        var initializer = node.initializer;
	        var dotDotDotToken = node.dotDotDotToken;
	        // The '?' token, type annotations, decorators, and 'this' parameters are TypeSCript
	        // syntax.
	        if (node.questionToken
	            || node.type
	            || subtreeFlags & 4096 /* ContainsDecorators */
	            || ts.isThisIdentifier(name)) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // If a parameter has an accessibility modifier, then it is TypeScript syntax.
	        if (ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	            transformFlags |= 3 /* AssertTypeScript */ | 262144 /* ContainsParameterPropertyAssignments */;
	        }
	        // parameters with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If a parameter has an initializer, a binding pattern or a dotDotDot token, then
	        // it is ES6 syntax and its container must emit default value assignments or parameter destructuring downlevel.
	        if (subtreeFlags & 8388608 /* ContainsBindingPattern */ || initializer || dotDotDotToken) {
	            transformFlags |= 192 /* AssertES2015 */ | 131072 /* ContainsDefaultValueAssignments */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* ParameterExcludes */;
	    }
	    function computeParenthesizedExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        var expressionKind = expression.kind;
	        var expressionTransformFlags = expression.transformFlags;
	        // If the node is synthesized, it means the emitter put the parentheses there,
	        // not the user. If we didn't want them, the emitter would not have put them
	        // there.
	        if (expressionKind === 207 /* AsExpression */
	            || expressionKind === 189 /* TypeAssertionExpression */) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // If the expression of a ParenthesizedExpression is a destructuring assignment,
	        // then the ParenthesizedExpression is a destructuring assignment.
	        if (expressionTransformFlags & 1024 /* DestructuringAssignment */) {
	            transformFlags |= 1024 /* DestructuringAssignment */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~536872257 /* OuterExpressionExcludes */;
	    }
	    function computeClassDeclaration(node, subtreeFlags) {
	        var transformFlags;
	        if (ts.hasModifier(node, 2 /* Ambient */)) {
	            // An ambient declaration is TypeScript syntax.
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            // A ClassDeclaration is ES6 syntax.
	            transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	            // A class with a parameter property assignment, property initializer, computed property name, or decorator is
	            // TypeScript syntax.
	            // An exported declaration may be TypeScript syntax, but is handled by the visitor
	            // for a namespace declaration.
	            if ((subtreeFlags & 274432 /* TypeScriptClassSyntaxMask */)
	                || node.typeParameters) {
	                transformFlags |= 3 /* AssertTypeScript */;
	            }
	            if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	                // A computed property name containing `this` might need to be rewritten,
	                // so propagate the ContainsLexicalThis flag upward.
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~942011713 /* ClassExcludes */;
	    }
	    function computeClassExpression(node, subtreeFlags) {
	        // A ClassExpression is ES6 syntax.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // A class with a parameter property assignment, property initializer, or decorator is
	        // TypeScript syntax.
	        if (subtreeFlags & 274432 /* TypeScriptClassSyntaxMask */
	            || node.typeParameters) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	            // A computed property name containing `this` might need to be rewritten,
	            // so propagate the ContainsLexicalThis flag upward.
	            transformFlags |= 16384 /* ContainsLexicalThis */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~942011713 /* ClassExcludes */;
	    }
	    function computeHeritageClause(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        switch (node.token) {
	            case 85 /* ExtendsKeyword */:
	                // An `extends` HeritageClause is ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 108 /* ImplementsKeyword */:
	                // An `implements` HeritageClause is TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                break;
	            default:
	                ts.Debug.fail("Unexpected token for heritage clause");
	                break;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeCatchClause(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        if (!node.variableDeclaration) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        else if (ts.isBindingPattern(node.variableDeclaration.name)) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~940574017 /* CatchClauseExcludes */;
	    }
	    function computeExpressionWithTypeArguments(node, subtreeFlags) {
	        // An ExpressionWithTypeArguments is ES6 syntax, as it is used in the
	        // extends clause of a class.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // If an ExpressionWithTypeArguments contains type arguments, then it
	        // is TypeScript syntax.
	        if (node.typeArguments) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeConstructor(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // TypeScript-specific modifiers and overloads are TypeScript syntax
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* ConstructorExcludes */;
	    }
	    function computeMethod(node, subtreeFlags) {
	        // A MethodDeclaration is ES6 syntax.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // Decorators, TypeScript-specific modifiers, type parameters, type annotations, and
	        // overloads are TypeScript syntax.
	        if (node.decorators
	            || ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type
	            || (node.name && ts.isComputedPropertyName(node.name)) // While computed method names aren't typescript, the TS transform must visit them to emit property declarations correctly
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // An async method declaration is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	        }
	        if (node.asteriskToken) {
	            transformFlags |= 768 /* AssertGenerator */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* MethodOrAccessorExcludes */;
	    }
	    function computeAccessor(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // Decorators, TypeScript-specific modifiers, type annotations, and overloads are
	        // TypeScript syntax.
	        if (node.decorators
	            || ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.type
	            || (node.name && ts.isComputedPropertyName(node.name)) // While computed accessor names aren't typescript, the TS transform must visit them to emit property declarations correctly
	            || !node.body) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // function declarations with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003668801 /* MethodOrAccessorExcludes */;
	    }
	    function computePropertyDeclaration(node, subtreeFlags) {
	        // A PropertyDeclaration is TypeScript syntax.
	        var transformFlags = subtreeFlags | 3 /* AssertTypeScript */;
	        // If the PropertyDeclaration has an initializer or a computed name, we need to inform its ancestor
	        // so that it handle the transformation.
	        if (node.initializer || ts.isComputedPropertyName(node.name)) {
	            transformFlags |= 8192 /* ContainsPropertyInitializer */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeFunctionDeclaration(node, subtreeFlags) {
	        var transformFlags;
	        var modifierFlags = ts.getModifierFlags(node);
	        var body = node.body;
	        if (!body || (modifierFlags & 2 /* Ambient */)) {
	            // An ambient declaration is TypeScript syntax.
	            // A FunctionDeclaration without a body is an overload and is TypeScript syntax.
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            transformFlags = subtreeFlags | 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	            // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	            // syntax.
	            if (modifierFlags & 2270 /* TypeScriptModifier */
	                || node.typeParameters
	                || node.type) {
	                transformFlags |= 3 /* AssertTypeScript */;
	            }
	            // An async function declaration is ES2017 syntax.
	            if (modifierFlags & 256 /* Async */) {
	                transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	            }
	            // function declarations with object rest destructuring are ES Next syntax
	            if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	                transformFlags |= 8 /* AssertESNext */;
	            }
	            // If a FunctionDeclaration's subtree has marked the container as needing to capture the
	            // lexical this, or the function contains parameters with initializers, then this node is
	            // ES6 syntax.
	            if (subtreeFlags & 163840 /* ES2015FunctionSyntaxMask */) {
	                transformFlags |= 192 /* AssertES2015 */;
	            }
	            // If a FunctionDeclaration is generator function and is the body of a
	            // transformed async function, then this node can be transformed to a
	            // down-level generator.
	            // Currently we do not support transforming any other generator fucntions
	            // down level.
	            if (node.asteriskToken) {
	                transformFlags |= 768 /* AssertGenerator */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003935041 /* FunctionExcludes */;
	    }
	    function computeFunctionExpression(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	        // syntax.
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // An async function expression is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= node.asteriskToken ? 8 /* AssertESNext */ : 16 /* AssertES2017 */;
	        }
	        // function expressions with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If a FunctionExpression's subtree has marked the container as needing to capture the
	        // lexical this, or the function contains parameters with initializers, then this node is
	        // ES6 syntax.
	        if (subtreeFlags & 163840 /* ES2015FunctionSyntaxMask */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        // If a FunctionExpression is generator function and is the body of a
	        // transformed async function, then this node can be transformed to a
	        // down-level generator.
	        if (node.asteriskToken) {
	            transformFlags |= 768 /* AssertGenerator */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003935041 /* FunctionExcludes */;
	    }
	    function computeArrowFunction(node, subtreeFlags) {
	        // An ArrowFunction is ES6 syntax, and excludes markers that should not escape the scope of an ArrowFunction.
	        var transformFlags = subtreeFlags | 192 /* AssertES2015 */;
	        // TypeScript-specific modifiers, type parameters, and type annotations are TypeScript
	        // syntax.
	        if (ts.hasModifier(node, 2270 /* TypeScriptModifier */)
	            || node.typeParameters
	            || node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        // An async arrow function is ES2017 syntax.
	        if (ts.hasModifier(node, 256 /* Async */)) {
	            transformFlags |= 16 /* AssertES2017 */;
	        }
	        // arrow functions with object rest destructuring are ES Next syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // If an ArrowFunction contains a lexical this, its container must capture the lexical this.
	        if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	            transformFlags |= 32768 /* ContainsCapturedLexicalThis */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~1003902273 /* ArrowFunctionExcludes */;
	    }
	    function computePropertyAccess(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // If a PropertyAccessExpression starts with a super keyword, then it is
	        // ES6 syntax, and requires a lexical `this` binding.
	        if (transformFlags & 134217728 /* Super */) {
	            transformFlags ^= 134217728 /* Super */;
	            transformFlags |= 268435456 /* ContainsSuper */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~671089985 /* PropertyAccessExcludes */;
	    }
	    function computeElementAccess(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        var expression = node.expression;
	        var expressionFlags = expression.transformFlags; // We do not want to aggregate flags from the argument expression for super/this capturing
	        // If an ElementAccessExpression starts with a super keyword, then it is
	        // ES6 syntax, and requires a lexical `this` binding.
	        if (expressionFlags & 134217728 /* Super */) {
	            transformFlags &= ~134217728 /* Super */;
	            transformFlags |= 268435456 /* ContainsSuper */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~671089985 /* PropertyAccessExcludes */;
	    }
	    function computeVariableDeclaration(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	        // A VariableDeclaration containing ObjectRest is ESNext syntax
	        if (subtreeFlags & 1048576 /* ContainsObjectRest */) {
	            transformFlags |= 8 /* AssertESNext */;
	        }
	        // Type annotations are TypeScript syntax.
	        if (node.type) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeVariableStatement(node, subtreeFlags) {
	        var transformFlags;
	        var declarationListTransformFlags = node.declarationList.transformFlags;
	        // An ambient declaration is TypeScript syntax.
	        if (ts.hasModifier(node, 2 /* Ambient */)) {
	            transformFlags = 3 /* AssertTypeScript */;
	        }
	        else {
	            transformFlags = subtreeFlags;
	            if (declarationListTransformFlags & 8388608 /* ContainsBindingPattern */) {
	                transformFlags |= 192 /* AssertES2015 */;
	            }
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeLabeledStatement(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // A labeled statement containing a block scoped binding *may* need to be transformed from ES6.
	        if (subtreeFlags & 4194304 /* ContainsBlockScopedBinding */
	            && ts.isIterationStatement(node, /*lookInLabeledStatements*/ true)) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeImportEquals(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // An ImportEqualsDeclaration with a namespace reference is TypeScript.
	        if (!ts.isExternalModuleImportEqualsDeclaration(node)) {
	            transformFlags |= 3 /* AssertTypeScript */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeExpressionStatement(node, subtreeFlags) {
	        var transformFlags = subtreeFlags;
	        // If the expression of an expression statement is a destructuring assignment,
	        // then we treat the statement as ES6 so that we can indicate that we do not
	        // need to hold on to the right-hand side.
	        if (node.expression.transformFlags & 1024 /* DestructuringAssignment */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~939525441 /* NodeExcludes */;
	    }
	    function computeModuleDeclaration(node, subtreeFlags) {
	        var transformFlags = 3 /* AssertTypeScript */;
	        var modifierFlags = ts.getModifierFlags(node);
	        if ((modifierFlags & 2 /* Ambient */) === 0) {
	            transformFlags |= subtreeFlags;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~977327425 /* ModuleExcludes */;
	    }
	    function computeVariableDeclarationList(node, subtreeFlags) {
	        var transformFlags = subtreeFlags | 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	        if (subtreeFlags & 8388608 /* ContainsBindingPattern */) {
	            transformFlags |= 192 /* AssertES2015 */;
	        }
	        // If a VariableDeclarationList is `let` or `const`, then it is ES6 syntax.
	        if (node.flags & 3 /* BlockScoped */) {
	            transformFlags |= 192 /* AssertES2015 */ | 4194304 /* ContainsBlockScopedBinding */;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~948962625 /* VariableDeclarationListExcludes */;
	    }
	    function computeOther(node, kind, subtreeFlags) {
	        // Mark transformations needed for each node
	        var transformFlags = subtreeFlags;
	        var excludeFlags = 939525441 /* NodeExcludes */;
	        switch (kind) {
	            case 120 /* AsyncKeyword */:
	            case 196 /* AwaitExpression */:
	                // async/await is ES2017 syntax, but may be ESNext syntax (for async generators)
	                transformFlags |= 8 /* AssertESNext */ | 16 /* AssertES2017 */;
	                break;
	            case 189 /* TypeAssertionExpression */:
	            case 207 /* AsExpression */:
	            case 300 /* PartiallyEmittedExpression */:
	                // These nodes are TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                excludeFlags = 536872257 /* OuterExpressionExcludes */;
	                break;
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	            case 117 /* AbstractKeyword */:
	            case 124 /* DeclareKeyword */:
	            case 76 /* ConstKeyword */:
	            case 237 /* EnumDeclaration */:
	            case 272 /* EnumMember */:
	            case 208 /* NonNullExpression */:
	            case 132 /* ReadonlyKeyword */:
	                // These nodes are TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */;
	                break;
	            case 254 /* JsxElement */:
	            case 255 /* JsxSelfClosingElement */:
	            case 256 /* JsxOpeningElement */:
	            case 10 /* JsxText */:
	            case 257 /* JsxClosingElement */:
	            case 258 /* JsxFragment */:
	            case 259 /* JsxOpeningFragment */:
	            case 260 /* JsxClosingFragment */:
	            case 261 /* JsxAttribute */:
	            case 262 /* JsxAttributes */:
	            case 263 /* JsxSpreadAttribute */:
	            case 264 /* JsxExpression */:
	                // These nodes are Jsx syntax.
	                transformFlags |= 4 /* AssertJsx */;
	                break;
	            case 13 /* NoSubstitutionTemplateLiteral */:
	            case 14 /* TemplateHead */:
	            case 15 /* TemplateMiddle */:
	            case 16 /* TemplateTail */:
	            case 201 /* TemplateExpression */:
	            case 188 /* TaggedTemplateExpression */:
	            case 270 /* ShorthandPropertyAssignment */:
	            case 115 /* StaticKeyword */:
	            case 209 /* MetaProperty */:
	                // These nodes are ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 9 /* StringLiteral */:
	                if (node.hasExtendedUnicodeEscape) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 8 /* NumericLiteral */:
	                if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 221 /* ForOfStatement */:
	                // This node is either ES2015 syntax or ES2017 syntax (if it is a for-await-of).
	                if (node.awaitModifier) {
	                    transformFlags |= 8 /* AssertESNext */;
	                }
	                transformFlags |= 192 /* AssertES2015 */;
	                break;
	            case 202 /* YieldExpression */:
	                // This node is either ES2015 syntax (in a generator) or ES2017 syntax (in an async
	                // generator).
	                transformFlags |= 8 /* AssertESNext */ | 192 /* AssertES2015 */ | 16777216 /* ContainsYield */;
	                break;
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 131 /* NeverKeyword */:
	            case 135 /* ObjectKeyword */:
	            case 137 /* StringKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 105 /* VoidKeyword */:
	            case 147 /* TypeParameter */:
	            case 150 /* PropertySignature */:
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 160 /* TypePredicate */:
	            case 161 /* TypeReference */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 164 /* TypeQuery */:
	            case 165 /* TypeLiteral */:
	            case 166 /* ArrayType */:
	            case 167 /* TupleType */:
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	            case 170 /* ConditionalType */:
	            case 171 /* InferType */:
	            case 172 /* ParenthesizedType */:
	            case 235 /* InterfaceDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 173 /* ThisType */:
	            case 174 /* TypeOperator */:
	            case 175 /* IndexedAccessType */:
	            case 176 /* MappedType */:
	            case 177 /* LiteralType */:
	            case 241 /* NamespaceExportDeclaration */:
	                // Types and signatures are TypeScript syntax, and exclude all other facts.
	                transformFlags = 3 /* AssertTypeScript */;
	                excludeFlags = -3 /* TypeExcludes */;
	                break;
	            case 146 /* ComputedPropertyName */:
	                // Even though computed property names are ES6, we don't treat them as such.
	                // This is so that they can flow through PropertyName transforms unaffected.
	                // Instead, we mark the container as ES6, so that it can properly handle the transform.
	                transformFlags |= 2097152 /* ContainsComputedPropertyName */;
	                if (subtreeFlags & 16384 /* ContainsLexicalThis */) {
	                    // A computed method name like `[this.getName()](x: string) { ... }` needs to
	                    // distinguish itself from the normal case of a method body containing `this`:
	                    // `this` inside a method doesn't need to be rewritten (the method provides `this`),
	                    // whereas `this` inside a computed name *might* need to be rewritten if the class/object
	                    // is inside an arrow function:
	                    // `_this = this; () => class K { [_this.getName()]() { ... } }`
	                    // To make this distinction, use ContainsLexicalThisInComputedPropertyName
	                    // instead of ContainsLexicalThis for computed property names
	                    transformFlags |= 65536 /* ContainsLexicalThisInComputedPropertyName */;
	                }
	                break;
	            case 203 /* SpreadElement */:
	                transformFlags |= 192 /* AssertES2015 */ | 524288 /* ContainsSpread */;
	                break;
	            case 271 /* SpreadAssignment */:
	                transformFlags |= 8 /* AssertESNext */ | 1048576 /* ContainsObjectSpread */;
	                break;
	            case 97 /* SuperKeyword */:
	                // This node is ES6 syntax.
	                transformFlags |= 192 /* AssertES2015 */ | 134217728 /* Super */;
	                excludeFlags = 536872257 /* OuterExpressionExcludes */; // must be set to persist `Super`
	                break;
	            case 99 /* ThisKeyword */:
	                // Mark this node and its ancestors as containing a lexical `this` keyword.
	                transformFlags |= 16384 /* ContainsLexicalThis */;
	                break;
	            case 179 /* ObjectBindingPattern */:
	                transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	                if (subtreeFlags & 524288 /* ContainsRest */) {
	                    transformFlags |= 8 /* AssertESNext */ | 1048576 /* ContainsObjectRest */;
	                }
	                excludeFlags = 940049729 /* BindingPatternExcludes */;
	                break;
	            case 180 /* ArrayBindingPattern */:
	                transformFlags |= 192 /* AssertES2015 */ | 8388608 /* ContainsBindingPattern */;
	                excludeFlags = 940049729 /* BindingPatternExcludes */;
	                break;
	            case 181 /* BindingElement */:
	                transformFlags |= 192 /* AssertES2015 */;
	                if (node.dotDotDotToken) {
	                    transformFlags |= 524288 /* ContainsRest */;
	                }
	                break;
	            case 149 /* Decorator */:
	                // This node is TypeScript syntax, and marks its container as also being TypeScript syntax.
	                transformFlags |= 3 /* AssertTypeScript */ | 4096 /* ContainsDecorators */;
	                break;
	            case 183 /* ObjectLiteralExpression */:
	                excludeFlags = 942740801 /* ObjectLiteralExcludes */;
	                if (subtreeFlags & 2097152 /* ContainsComputedPropertyName */) {
	                    // If an ObjectLiteralExpression contains a ComputedPropertyName, then it
	                    // is an ES6 node.
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                if (subtreeFlags & 65536 /* ContainsLexicalThisInComputedPropertyName */) {
	                    // A computed property name containing `this` might need to be rewritten,
	                    // so propagate the ContainsLexicalThis flag upward.
	                    transformFlags |= 16384 /* ContainsLexicalThis */;
	                }
	                if (subtreeFlags & 1048576 /* ContainsObjectSpread */) {
	                    // If an ObjectLiteralExpression contains a spread element, then it
	                    // is an ES next node.
	                    transformFlags |= 8 /* AssertESNext */;
	                }
	                break;
	            case 182 /* ArrayLiteralExpression */:
	            case 187 /* NewExpression */:
	                excludeFlags = 940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	                if (subtreeFlags & 524288 /* ContainsSpread */) {
	                    // If the this node contains a SpreadExpression, then it is an ES6
	                    // node.
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 217 /* DoStatement */:
	            case 218 /* WhileStatement */:
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	                // A loop containing a block scoped binding *may* need to be transformed from ES6.
	                if (subtreeFlags & 4194304 /* ContainsBlockScopedBinding */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 273 /* SourceFile */:
	                if (subtreeFlags & 32768 /* ContainsCapturedLexicalThis */) {
	                    transformFlags |= 192 /* AssertES2015 */;
	                }
	                break;
	            case 224 /* ReturnStatement */:
	                // Return statements may require an `await` in ESNext.
	                transformFlags |= 33554432 /* ContainsHoistedDeclarationOrCompletion */ | 8 /* AssertESNext */;
	                break;
	            case 222 /* ContinueStatement */:
	            case 223 /* BreakStatement */:
	                transformFlags |= 33554432 /* ContainsHoistedDeclarationOrCompletion */;
	                break;
	        }
	        node.transformFlags = transformFlags | 536870912 /* HasComputedFlags */;
	        return transformFlags & ~excludeFlags;
	    }
	    /**
	     * Gets the transform flags to exclude when unioning the transform flags of a subtree.
	     *
	     * NOTE: This needs to be kept up-to-date with the exclusions used in `computeTransformFlagsForNode`.
	     *       For performance reasons, `computeTransformFlagsForNode` uses local constant values rather
	     *       than calling this function.
	     */
	    /* @internal */
	    function getTransformFlagsSubtreeExclusions(kind) {
	        if (kind >= 160 /* FirstTypeNode */ && kind <= 178 /* LastTypeNode */) {
	            return -3 /* TypeExcludes */;
	        }
	        switch (kind) {
	            case 186 /* CallExpression */:
	            case 187 /* NewExpression */:
	            case 182 /* ArrayLiteralExpression */:
	                return 940049729 /* ArrayLiteralOrCallOrNewExcludes */;
	            case 238 /* ModuleDeclaration */:
	                return 977327425 /* ModuleExcludes */;
	            case 148 /* Parameter */:
	                return 939525441 /* ParameterExcludes */;
	            case 192 /* ArrowFunction */:
	                return 1003902273 /* ArrowFunctionExcludes */;
	            case 191 /* FunctionExpression */:
	            case 233 /* FunctionDeclaration */:
	                return 1003935041 /* FunctionExcludes */;
	            case 232 /* VariableDeclarationList */:
	                return 948962625 /* VariableDeclarationListExcludes */;
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	                return 942011713 /* ClassExcludes */;
	            case 154 /* Constructor */:
	                return 1003668801 /* ConstructorExcludes */;
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return 1003668801 /* MethodOrAccessorExcludes */;
	            case 119 /* AnyKeyword */:
	            case 134 /* NumberKeyword */:
	            case 131 /* NeverKeyword */:
	            case 137 /* StringKeyword */:
	            case 135 /* ObjectKeyword */:
	            case 122 /* BooleanKeyword */:
	            case 138 /* SymbolKeyword */:
	            case 105 /* VoidKeyword */:
	            case 147 /* TypeParameter */:
	            case 150 /* PropertySignature */:
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 158 /* ConstructSignature */:
	            case 159 /* IndexSignature */:
	            case 235 /* InterfaceDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	                return -3 /* TypeExcludes */;
	            case 183 /* ObjectLiteralExpression */:
	                return 942740801 /* ObjectLiteralExcludes */;
	            case 268 /* CatchClause */:
	                return 940574017 /* CatchClauseExcludes */;
	            case 179 /* ObjectBindingPattern */:
	            case 180 /* ArrayBindingPattern */:
	                return 940049729 /* BindingPatternExcludes */;
	            case 189 /* TypeAssertionExpression */:
	            case 207 /* AsExpression */:
	            case 300 /* PartiallyEmittedExpression */:
	            case 190 /* ParenthesizedExpression */:
	            case 97 /* SuperKeyword */:
	                return 536872257 /* OuterExpressionExcludes */;
	            case 184 /* PropertyAccessExpression */:
	            case 185 /* ElementAccessExpression */:
	                return 671089985 /* PropertyAccessExcludes */;
	            default:
	                return 939525441 /* NodeExcludes */;
	        }
	    }
	    ts.getTransformFlagsSubtreeExclusions = getTransformFlagsSubtreeExclusions;
	    /**
	     * "Binds" JSDoc nodes in TypeScript code.
	     * Since we will never create symbols for JSDoc, we just set parent pointers instead.
	     */
	    function setParentPointers(parent, child) {
	        child.parent = parent;
	        ts.forEachChild(child, function (grandchild) { return setParentPointers(child, grandchild); });
	    }
	})(ts || (ts = {}));
	/** @internal */
	var ts;
	(function (ts) {
	    function createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getIndexTypeOfStructuredType, getConstraintFromTypeParameter, getFirstIdentifier) {
	        return getSymbolWalker;
	        function getSymbolWalker(accept) {
	            if (accept === void 0) { accept = function () { return true; }; }
	            var visitedTypes = []; // Sparse array from id to type
	            var visitedSymbols = []; // Sparse array from id to symbol
	            return {
	                walkType: function (type) {
	                    try {
	                        visitType(type);
	                        return { visitedTypes: ts.getOwnValues(visitedTypes), visitedSymbols: ts.getOwnValues(visitedSymbols) };
	                    }
	                    finally {
	                        ts.clear(visitedTypes);
	                        ts.clear(visitedSymbols);
	                    }
	                },
	                walkSymbol: function (symbol) {
	                    try {
	                        visitSymbol(symbol);
	                        return { visitedTypes: ts.getOwnValues(visitedTypes), visitedSymbols: ts.getOwnValues(visitedSymbols) };
	                    }
	                    finally {
	                        ts.clear(visitedTypes);
	                        ts.clear(visitedSymbols);
	                    }
	                },
	            };
	            function visitType(type) {
	                if (!type) {
	                    return;
	                }
	                if (visitedTypes[type.id]) {
	                    return;
	                }
	                visitedTypes[type.id] = type;
	                // Reuse visitSymbol to visit the type's symbol,
	                //  but be sure to bail on recuring into the type if accept declines the symbol.
	                var shouldBail = visitSymbol(type.symbol);
	                if (shouldBail)
	                    return;
	                // Visit the type's related types, if any
	                if (type.flags & 65536 /* Object */) {
	                    var objectType = type;
	                    var objectFlags = objectType.objectFlags;
	                    if (objectFlags & 4 /* Reference */) {
	                        visitTypeReference(type);
	                    }
	                    if (objectFlags & 32 /* Mapped */) {
	                        visitMappedType(type);
	                    }
	                    if (objectFlags & (1 /* Class */ | 2 /* Interface */)) {
	                        visitInterfaceType(type);
	                    }
	                    if (objectFlags & (8 /* Tuple */ | 16 /* Anonymous */)) {
	                        visitObjectType(objectType);
	                    }
	                }
	                if (type.flags & 32768 /* TypeParameter */) {
	                    visitTypeParameter(type);
	                }
	                if (type.flags & 393216 /* UnionOrIntersection */) {
	                    visitUnionOrIntersectionType(type);
	                }
	                if (type.flags & 524288 /* Index */) {
	                    visitIndexType(type);
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    visitIndexedAccessType(type);
	                }
	            }
	            function visitTypeReference(type) {
	                visitType(type.target);
	                ts.forEach(type.typeArguments, visitType);
	            }
	            function visitTypeParameter(type) {
	                visitType(getConstraintFromTypeParameter(type));
	            }
	            function visitUnionOrIntersectionType(type) {
	                ts.forEach(type.types, visitType);
	            }
	            function visitIndexType(type) {
	                visitType(type.type);
	            }
	            function visitIndexedAccessType(type) {
	                visitType(type.objectType);
	                visitType(type.indexType);
	                visitType(type.constraint);
	            }
	            function visitMappedType(type) {
	                visitType(type.typeParameter);
	                visitType(type.constraintType);
	                visitType(type.templateType);
	                visitType(type.modifiersType);
	            }
	            function visitSignature(signature) {
	                var typePredicate = getTypePredicateOfSignature(signature);
	                if (typePredicate) {
	                    visitType(typePredicate.type);
	                }
	                ts.forEach(signature.typeParameters, visitType);
	                for (var _i = 0, _a = signature.parameters; _i < _a.length; _i++) {
	                    var parameter = _a[_i];
	                    visitSymbol(parameter);
	                }
	                visitType(getRestTypeOfSignature(signature));
	                visitType(getReturnTypeOfSignature(signature));
	            }
	            function visitInterfaceType(interfaceT) {
	                visitObjectType(interfaceT);
	                ts.forEach(interfaceT.typeParameters, visitType);
	                ts.forEach(getBaseTypes(interfaceT), visitType);
	                visitType(interfaceT.thisType);
	            }
	            function visitObjectType(type) {
	                var stringIndexType = getIndexTypeOfStructuredType(type, 0 /* String */);
	                visitType(stringIndexType);
	                var numberIndexType = getIndexTypeOfStructuredType(type, 1 /* Number */);
	                visitType(numberIndexType);
	                // The two checks above *should* have already resolved the type (if needed), so this should be cached
	                var resolved = resolveStructuredTypeMembers(type);
	                for (var _i = 0, _a = resolved.callSignatures; _i < _a.length; _i++) {
	                    var signature = _a[_i];
	                    visitSignature(signature);
	                }
	                for (var _b = 0, _c = resolved.constructSignatures; _b < _c.length; _b++) {
	                    var signature = _c[_b];
	                    visitSignature(signature);
	                }
	                for (var _d = 0, _e = resolved.properties; _d < _e.length; _d++) {
	                    var p = _e[_d];
	                    visitSymbol(p);
	                }
	            }
	            function visitSymbol(symbol) {
	                if (!symbol) {
	                    return;
	                }
	                var symbolId = ts.getSymbolId(symbol);
	                if (visitedSymbols[symbolId]) {
	                    return;
	                }
	                visitedSymbols[symbolId] = symbol;
	                if (!accept(symbol)) {
	                    return true;
	                }
	                var t = getTypeOfSymbol(symbol);
	                visitType(t); // Should handle members on classes and such
	                if (symbol.flags & 1952 /* HasExports */) {
	                    symbol.exports.forEach(visitSymbol);
	                }
	                ts.forEach(symbol.declarations, function (d) {
	                    // Type queries are too far resolved when we just visit the symbol's type
	                    //  (their type resolved directly to the member deeply referenced)
	                    // So to get the intervening symbols, we need to check if there's a type
	                    // query node on any of the symbol's declarations and get symbols there
	                    if (d.type && d.type.kind === 164 /* TypeQuery */) {
	                        var query = d.type;
	                        var entity = getResolvedSymbol(getFirstIdentifier(query.exprName));
	                        visitSymbol(entity);
	                    }
	                });
	            }
	        }
	    }
	    ts.createGetSymbolWalker = createGetSymbolWalker;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function trace(host) {
	        host.trace(ts.formatMessage.apply(undefined, arguments));
	    }
	    ts.trace = trace;
	    /* @internal */
	    function isTraceEnabled(compilerOptions, host) {
	        return compilerOptions.traceResolution && host.trace !== undefined;
	    }
	    ts.isTraceEnabled = isTraceEnabled;
	    function withPackageId(packageId, r) {
	        return r && { path: r.path, extension: r.ext, packageId: packageId };
	    }
	    function noPackageId(r) {
	        return withPackageId(/*packageId*/ undefined, r);
	    }
	    /**
	     * Kinds of file that we are currently looking for.
	     * Typically there is one pass with Extensions.TypeScript, then a second pass with Extensions.JavaScript.
	     */
	    var Extensions;
	    (function (Extensions) {
	        Extensions[Extensions["TypeScript"] = 0] = "TypeScript";
	        Extensions[Extensions["JavaScript"] = 1] = "JavaScript";
	        Extensions[Extensions["Json"] = 2] = "Json";
	        Extensions[Extensions["DtsOnly"] = 3] = "DtsOnly"; /** Only '.d.ts' */
	    })(Extensions || (Extensions = {}));
	    /** Used with `Extensions.DtsOnly` to extract the path from TypeScript results. */
	    function resolvedTypeScriptOnly(resolved) {
	        if (!resolved) {
	            return undefined;
	        }
	        ts.Debug.assert(ts.extensionIsTypeScript(resolved.extension));
	        return { fileName: resolved.path, packageId: resolved.packageId };
	    }
	    function createResolvedModuleWithFailedLookupLocations(resolved, originalPath, isExternalLibraryImport, failedLookupLocations) {
	        return {
	            resolvedModule: resolved && { resolvedFileName: resolved.path, originalPath: originalPath, extension: resolved.extension, isExternalLibraryImport: isExternalLibraryImport, packageId: resolved.packageId },
	            failedLookupLocations: failedLookupLocations
	        };
	    }
	    /** Reads from "main" or "types"/"typings" depending on `extensions`. */
	    function tryReadPackageJsonFields(readTypes, jsonContent, baseDirectory, state) {
	        return readTypes ? tryReadFromField("typings") || tryReadFromField("types") : tryReadFromField("main");
	        function tryReadFromField(fieldName) {
	            if (!ts.hasProperty(jsonContent, fieldName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.package_json_does_not_have_a_0_field, fieldName);
	                }
	                return;
	            }
	            var fileName = jsonContent[fieldName];
	            if (!ts.isString(fileName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Expected_type_of_0_field_in_package_json_to_be_string_got_1, fieldName, typeof fileName);
	                }
	                return;
	            }
	            var path = ts.normalizePath(ts.combinePaths(baseDirectory, fileName));
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.package_json_has_0_field_1_that_references_2, fieldName, fileName, path);
	            }
	            return path;
	        }
	    }
	    /* @internal */
	    function readJson(path, host) {
	        try {
	            var jsonText = host.readFile(path);
	            if (!jsonText)
	                return {};
	            var result = ts.parseConfigFileTextToJson(path, jsonText);
	            if (result.error) {
	                return {};
	            }
	            return result.config;
	        }
	        catch (e) {
	            // gracefully handle if readFile fails or returns not JSON
	            return {};
	        }
	    }
	    ts.readJson = readJson;
	    function getEffectiveTypeRoots(options, host) {
	        if (options.typeRoots) {
	            return options.typeRoots;
	        }
	        var currentDirectory;
	        if (options.configFilePath) {
	            currentDirectory = ts.getDirectoryPath(options.configFilePath);
	        }
	        else if (host.getCurrentDirectory) {
	            currentDirectory = host.getCurrentDirectory();
	        }
	        if (currentDirectory !== undefined) {
	            return getDefaultTypeRoots(currentDirectory, host);
	        }
	    }
	    ts.getEffectiveTypeRoots = getEffectiveTypeRoots;
	    /**
	     * Returns the path to every node_modules/@types directory from some ancestor directory.
	     * Returns undefined if there are none.
	     */
	    function getDefaultTypeRoots(currentDirectory, host) {
	        if (!host.directoryExists) {
	            return [ts.combinePaths(currentDirectory, nodeModulesAtTypes)];
	            // And if it doesn't exist, tough.
	        }
	        var typeRoots;
	        ts.forEachAncestorDirectory(ts.normalizePath(currentDirectory), function (directory) {
	            var atTypes = ts.combinePaths(directory, nodeModulesAtTypes);
	            if (host.directoryExists(atTypes)) {
	                (typeRoots || (typeRoots = [])).push(atTypes);
	            }
	            return undefined;
	        });
	        return typeRoots;
	    }
	    var nodeModulesAtTypes = ts.combinePaths("node_modules", "@types");
	    /**
	     * @param {string | undefined} containingFile - file that contains type reference directive, can be undefined if containing file is unknown.
	     * This is possible in case if resolution is performed for directives specified via 'types' parameter. In this case initial path for secondary lookups
	     * is assumed to be the same as root directory of the project.
	     */
	    function resolveTypeReferenceDirective(typeReferenceDirectiveName, containingFile, options, host) {
	        var traceEnabled = isTraceEnabled(options, host);
	        var moduleResolutionState = { compilerOptions: options, host: host, traceEnabled: traceEnabled };
	        var typeRoots = getEffectiveTypeRoots(options, host);
	        if (traceEnabled) {
	            if (containingFile === undefined) {
	                if (typeRoots === undefined) {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_not_set, typeReferenceDirectiveName);
	                }
	                else {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_not_set_root_directory_1, typeReferenceDirectiveName, typeRoots);
	                }
	            }
	            else {
	                if (typeRoots === undefined) {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_not_set, typeReferenceDirectiveName, containingFile);
	                }
	                else {
	                    trace(host, ts.Diagnostics.Resolving_type_reference_directive_0_containing_file_1_root_directory_2, typeReferenceDirectiveName, containingFile, typeRoots);
	                }
	            }
	        }
	        var failedLookupLocations = [];
	        var resolved = primaryLookup();
	        var primary = true;
	        if (!resolved) {
	            resolved = secondaryLookup();
	            primary = false;
	        }
	        var resolvedTypeReferenceDirective;
	        if (resolved) {
	            if (!options.preserveSymlinks) {
	                resolved = __assign({}, resolved, { fileName: realPath(resolved.fileName, host, traceEnabled) });
	            }
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Type_reference_directive_0_was_successfully_resolved_to_1_primary_Colon_2, typeReferenceDirectiveName, resolved.fileName, primary);
	            }
	            resolvedTypeReferenceDirective = { primary: primary, resolvedFileName: resolved.fileName, packageId: resolved.packageId };
	        }
	        return { resolvedTypeReferenceDirective: resolvedTypeReferenceDirective, failedLookupLocations: failedLookupLocations };
	        function primaryLookup() {
	            // Check primary library paths
	            if (typeRoots && typeRoots.length) {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Resolving_with_primary_search_path_0, typeRoots.join(", "));
	                }
	                return ts.forEach(typeRoots, function (typeRoot) {
	                    var candidate = ts.combinePaths(typeRoot, typeReferenceDirectiveName);
	                    var candidateDirectory = ts.getDirectoryPath(candidate);
	                    var directoryExists = directoryProbablyExists(candidateDirectory, host);
	                    if (!directoryExists && traceEnabled) {
	                        trace(host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidateDirectory);
	                    }
	                    return resolvedTypeScriptOnly(loadNodeModuleFromDirectory(Extensions.DtsOnly, candidate, failedLookupLocations, !directoryExists, moduleResolutionState));
	                });
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Root_directory_cannot_be_determined_skipping_primary_search_paths);
	                }
	            }
	        }
	        function secondaryLookup() {
	            var resolvedFile;
	            var initialLocationForSecondaryLookup = containingFile && ts.getDirectoryPath(containingFile);
	            if (initialLocationForSecondaryLookup !== undefined) {
	                // check secondary locations
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Looking_up_in_node_modules_folder_initial_location_0, initialLocationForSecondaryLookup);
	                }
	                var result = loadModuleFromNodeModules(Extensions.DtsOnly, typeReferenceDirectiveName, initialLocationForSecondaryLookup, failedLookupLocations, moduleResolutionState, /*cache*/ undefined);
	                resolvedFile = resolvedTypeScriptOnly(result && result.value);
	                if (!resolvedFile && traceEnabled) {
	                    trace(host, ts.Diagnostics.Type_reference_directive_0_was_not_resolved, typeReferenceDirectiveName);
	                }
	                return resolvedFile;
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Containing_file_is_not_specified_and_root_directory_cannot_be_determined_skipping_lookup_in_node_modules_folder);
	                }
	            }
	        }
	    }
	    ts.resolveTypeReferenceDirective = resolveTypeReferenceDirective;
	    /**
	     * Given a set of options, returns the set of type directive names
	     *   that should be included for this program automatically.
	     * This list could either come from the config file,
	     *   or from enumerating the types root + initial secondary types lookup location.
	     * More type directives might appear in the program later as a result of loading actual source files;
	     *   this list is only the set of defaults that are implicitly included.
	     */
	    function getAutomaticTypeDirectiveNames(options, host) {
	        // Use explicit type list from tsconfig.json
	        if (options.types) {
	            return options.types;
	        }
	        // Walk the primary type lookup locations
	        var result = [];
	        if (host.directoryExists && host.getDirectories) {
	            var typeRoots = getEffectiveTypeRoots(options, host);
	            if (typeRoots) {
	                for (var _i = 0, typeRoots_1 = typeRoots; _i < typeRoots_1.length; _i++) {
	                    var root = typeRoots_1[_i];
	                    if (host.directoryExists(root)) {
	                        for (var _a = 0, _b = host.getDirectories(root); _a < _b.length; _a++) {
	                            var typeDirectivePath = _b[_a];
	                            var normalized = ts.normalizePath(typeDirectivePath);
	                            var packageJsonPath = pathToPackageJson(ts.combinePaths(root, normalized));
	                            // `types-publisher` sometimes creates packages with `"typings": null` for packages that don't provide their own types.
	                            // See `createNotNeededPackageJSON` in the types-publisher` repo.
	                            // tslint:disable-next-line:no-null-keyword
	                            var isNotNeededPackage = host.fileExists(packageJsonPath) && readJson(packageJsonPath, host).typings === null;
	                            if (!isNotNeededPackage) {
	                                // Return just the type directive names
	                                result.push(ts.getBaseFileName(normalized));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        return result;
	    }
	    ts.getAutomaticTypeDirectiveNames = getAutomaticTypeDirectiveNames;
	    function createModuleResolutionCache(currentDirectory, getCanonicalFileName) {
	        return createModuleResolutionCacheWithMaps(ts.createMap(), ts.createMap(), currentDirectory, getCanonicalFileName);
	    }
	    ts.createModuleResolutionCache = createModuleResolutionCache;
	    /*@internal*/
	    function createModuleResolutionCacheWithMaps(directoryToModuleNameMap, moduleNameToDirectoryMap, currentDirectory, getCanonicalFileName) {
	        return { getOrCreateCacheForDirectory: getOrCreateCacheForDirectory, getOrCreateCacheForModuleName: getOrCreateCacheForModuleName };
	        function getOrCreateCacheForDirectory(directoryName) {
	            var path = ts.toPath(directoryName, currentDirectory, getCanonicalFileName);
	            var perFolderCache = directoryToModuleNameMap.get(path);
	            if (!perFolderCache) {
	                perFolderCache = ts.createMap();
	                directoryToModuleNameMap.set(path, perFolderCache);
	            }
	            return perFolderCache;
	        }
	        function getOrCreateCacheForModuleName(nonRelativeModuleName) {
	            if (ts.isExternalModuleNameRelative(nonRelativeModuleName)) {
	                return undefined;
	            }
	            var perModuleNameCache = moduleNameToDirectoryMap.get(nonRelativeModuleName);
	            if (!perModuleNameCache) {
	                perModuleNameCache = createPerModuleNameCache();
	                moduleNameToDirectoryMap.set(nonRelativeModuleName, perModuleNameCache);
	            }
	            return perModuleNameCache;
	        }
	        function createPerModuleNameCache() {
	            var directoryPathMap = ts.createMap();
	            return { get: get, set: set };
	            function get(directory) {
	                return directoryPathMap.get(ts.toPath(directory, currentDirectory, getCanonicalFileName));
	            }
	            /**
	             * At first this function add entry directory -> module resolution result to the table.
	             * Then it computes the set of parent folders for 'directory' that should have the same module resolution result
	             * and for every parent folder in set it adds entry: parent -> module resolution. .
	             * Lets say we first directory name: /a/b/c/d/e and resolution result is: /a/b/bar.ts.
	             * Set of parent folders that should have the same result will be:
	             * [
	             *     /a/b/c/d, /a/b/c, /a/b
	             * ]
	             * this means that request for module resolution from file in any of these folder will be immediately found in cache.
	             */
	            function set(directory, result) {
	                var path = ts.toPath(directory, currentDirectory, getCanonicalFileName);
	                // if entry is already in cache do nothing
	                if (directoryPathMap.has(path)) {
	                    return;
	                }
	                directoryPathMap.set(path, result);
	                var resolvedFileName = result.resolvedModule && result.resolvedModule.resolvedFileName;
	                // find common prefix between directory and resolved file name
	                // this common prefix should be the shorted path that has the same resolution
	                // directory: /a/b/c/d/e
	                // resolvedFileName: /a/b/foo.d.ts
	                var commonPrefix = getCommonPrefix(path, resolvedFileName);
	                var current = path;
	                while (true) {
	                    var parent = ts.getDirectoryPath(current);
	                    if (parent === current || directoryPathMap.has(parent)) {
	                        break;
	                    }
	                    directoryPathMap.set(parent, result);
	                    current = parent;
	                    if (current === commonPrefix) {
	                        break;
	                    }
	                }
	            }
	            function getCommonPrefix(directory, resolution) {
	                if (resolution === undefined) {
	                    return undefined;
	                }
	                var resolutionDirectory = ts.toPath(ts.getDirectoryPath(resolution), currentDirectory, getCanonicalFileName);
	                // find first position where directory and resolution differs
	                var i = 0;
	                while (i < Math.min(directory.length, resolutionDirectory.length) && directory.charCodeAt(i) === resolutionDirectory.charCodeAt(i)) {
	                    i++;
	                }
	                // find last directory separator before position i
	                var sep = directory.lastIndexOf(ts.directorySeparator, i);
	                if (sep < 0) {
	                    return undefined;
	                }
	                return directory.substr(0, sep);
	            }
	        }
	    }
	    ts.createModuleResolutionCacheWithMaps = createModuleResolutionCacheWithMaps;
	    function resolveModuleNameFromCache(moduleName, containingFile, cache) {
	        var containingDirectory = ts.getDirectoryPath(containingFile);
	        var perFolderCache = cache && cache.getOrCreateCacheForDirectory(containingDirectory);
	        return perFolderCache && perFolderCache.get(moduleName);
	    }
	    ts.resolveModuleNameFromCache = resolveModuleNameFromCache;
	    function resolveModuleName(moduleName, containingFile, compilerOptions, host, cache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Resolving_module_0_from_1, moduleName, containingFile);
	        }
	        var containingDirectory = ts.getDirectoryPath(containingFile);
	        var perFolderCache = cache && cache.getOrCreateCacheForDirectory(containingDirectory);
	        var result = perFolderCache && perFolderCache.get(moduleName);
	        if (result) {
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
	            }
	        }
	        else {
	            var moduleResolution = compilerOptions.moduleResolution;
	            if (moduleResolution === undefined) {
	                moduleResolution = ts.getEmitModuleKind(compilerOptions) === ts.ModuleKind.CommonJS ? ts.ModuleResolutionKind.NodeJs : ts.ModuleResolutionKind.Classic;
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Module_resolution_kind_is_not_specified_using_0, ts.ModuleResolutionKind[moduleResolution]);
	                }
	            }
	            else {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Explicitly_specified_module_resolution_kind_Colon_0, ts.ModuleResolutionKind[moduleResolution]);
	                }
	            }
	            switch (moduleResolution) {
	                case ts.ModuleResolutionKind.NodeJs:
	                    result = nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache);
	                    break;
	                case ts.ModuleResolutionKind.Classic:
	                    result = classicNameResolver(moduleName, containingFile, compilerOptions, host, cache);
	                    break;
	                default:
	                    ts.Debug.fail("Unexpected moduleResolution: " + moduleResolution);
	            }
	            if (perFolderCache) {
	                perFolderCache.set(moduleName, result);
	                // put result in per-module name cache
	                var perModuleNameCache = cache.getOrCreateCacheForModuleName(moduleName);
	                if (perModuleNameCache) {
	                    perModuleNameCache.set(containingDirectory, result);
	                }
	            }
	        }
	        if (traceEnabled) {
	            if (result.resolvedModule) {
	                trace(host, ts.Diagnostics.Module_name_0_was_successfully_resolved_to_1, moduleName, result.resolvedModule.resolvedFileName);
	            }
	            else {
	                trace(host, ts.Diagnostics.Module_name_0_was_not_resolved, moduleName);
	            }
	        }
	        return result;
	    }
	    ts.resolveModuleName = resolveModuleName;
	    /**
	     * Any module resolution kind can be augmented with optional settings: 'baseUrl', 'paths' and 'rootDirs' - they are used to
	     * mitigate differences between design time structure of the project and its runtime counterpart so the same import name
	     * can be resolved successfully by TypeScript compiler and runtime module loader.
	     * If these settings are set then loading procedure will try to use them to resolve module name and it can of failure it will
	     * fallback to standard resolution routine.
	     *
	     * - baseUrl - this setting controls how non-relative module names are resolved. If this setting is specified then non-relative
	     * names will be resolved relative to baseUrl: i.e. if baseUrl is '/a/b' then candidate location to resolve module name 'c/d' will
	     * be '/a/b/c/d'
	     * - paths - this setting can only be used when baseUrl is specified. allows to tune how non-relative module names
	     * will be resolved based on the content of the module name.
	     * Structure of 'paths' compiler options
	     * 'paths': {
	     *    pattern-1: [...substitutions],
	     *    pattern-2: [...substitutions],
	     *    ...
	     *    pattern-n: [...substitutions]
	     * }
	     * Pattern here is a string that can contain zero or one '*' character. During module resolution module name will be matched against
	     * all patterns in the list. Matching for patterns that don't contain '*' means that module name must be equal to pattern respecting the case.
	     * If pattern contains '*' then to match pattern "<prefix>*<suffix>" module name must start with the <prefix> and end with <suffix>.
	     * <MatchedStar> denotes part of the module name between <prefix> and <suffix>.
	     * If module name can be matches with multiple patterns then pattern with the longest prefix will be picked.
	     * After selecting pattern we'll use list of substitutions to get candidate locations of the module and the try to load module
	     * from the candidate location.
	     * Substitution is a string that can contain zero or one '*'. To get candidate location from substitution we'll pick every
	     * substitution in the list and replace '*' with <MatchedStar> string. If candidate location is not rooted it
	     * will be converted to absolute using baseUrl.
	     * For example:
	     * baseUrl: /a/b/c
	     * "paths": {
	     *     // match all module names
	     *     "*": [
	     *         "*",        // use matched name as is,
	     *                     // <matched name> will be looked as /a/b/c/<matched name>
	     *
	     *         "folder1/*" // substitution will convert matched name to 'folder1/<matched name>',
	     *                     // since it is not rooted then final candidate location will be /a/b/c/folder1/<matched name>
	     *     ],
	     *     // match module names that start with 'components/'
	     *     "components/*": [ "/root/components/*" ] // substitution will convert /components/folder1/<matched name> to '/root/components/folder1/<matched name>',
	     *                                              // it is rooted so it will be final candidate location
	     * }
	     *
	     * 'rootDirs' allows the project to be spreaded across multiple locations and resolve modules with relative names as if
	     * they were in the same location. For example lets say there are two files
	     * '/local/src/content/file1.ts'
	     * '/shared/components/contracts/src/content/protocols/file2.ts'
	     * After bundling content of '/shared/components/contracts/src' will be merged with '/local/src' so
	     * if file1 has the following import 'import {x} from "./protocols/file2"' it will be resolved successfully in runtime.
	     * 'rootDirs' provides the way to tell compiler that in order to get the whole project it should behave as if content of all
	     * root dirs were merged together.
	     * I.e. for the example above 'rootDirs' will have two entries: [ '/local/src', '/shared/components/contracts/src' ].
	     * Compiler will first convert './protocols/file2' into absolute path relative to the location of containing file:
	     * '/local/src/content/protocols/file2' and try to load it - failure.
	     * Then it will search 'rootDirs' looking for a longest matching prefix of this absolute path and if such prefix is found - absolute path will
	     * be converted to a path relative to found rootDir entry './content/protocols/file2' (*). As a last step compiler will check all remaining
	     * entries in 'rootDirs', use them to build absolute path out of (*) and try to resolve module from this location.
	     */
	    function tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state) {
	        if (!ts.isExternalModuleNameRelative(moduleName)) {
	            return tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, failedLookupLocations, state);
	        }
	        else {
	            return tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state);
	        }
	    }
	    function tryLoadModuleUsingRootDirs(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state) {
	        if (!state.compilerOptions.rootDirs) {
	            return undefined;
	        }
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.rootDirs_option_is_set_using_it_to_resolve_relative_module_name_0, moduleName);
	        }
	        var candidate = ts.normalizePath(ts.combinePaths(containingDirectory, moduleName));
	        var matchedRootDir;
	        var matchedNormalizedPrefix;
	        for (var _i = 0, _a = state.compilerOptions.rootDirs; _i < _a.length; _i++) {
	            var rootDir = _a[_i];
	            // rootDirs are expected to be absolute
	            // in case of tsconfig.json this will happen automatically - compiler will expand relative names
	            // using location of tsconfig.json as base location
	            var normalizedRoot = ts.normalizePath(rootDir);
	            if (!ts.endsWith(normalizedRoot, ts.directorySeparator)) {
	                normalizedRoot += ts.directorySeparator;
	            }
	            var isLongestMatchingPrefix = ts.startsWith(candidate, normalizedRoot) &&
	                (matchedNormalizedPrefix === undefined || matchedNormalizedPrefix.length < normalizedRoot.length);
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Checking_if_0_is_the_longest_matching_prefix_for_1_2, normalizedRoot, candidate, isLongestMatchingPrefix);
	            }
	            if (isLongestMatchingPrefix) {
	                matchedNormalizedPrefix = normalizedRoot;
	                matchedRootDir = rootDir;
	            }
	        }
	        if (matchedNormalizedPrefix) {
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Longest_matching_prefix_for_0_is_1, candidate, matchedNormalizedPrefix);
	            }
	            var suffix = candidate.substr(matchedNormalizedPrefix.length);
	            // first - try to load from a initial location
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, matchedNormalizedPrefix, candidate);
	            }
	            var resolvedFileName = loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(containingDirectory, state.host), state);
	            if (resolvedFileName) {
	                return resolvedFileName;
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Trying_other_entries_in_rootDirs);
	            }
	            // then try to resolve using remaining entries in rootDirs
	            for (var _b = 0, _c = state.compilerOptions.rootDirs; _b < _c.length; _b++) {
	                var rootDir = _c[_b];
	                if (rootDir === matchedRootDir) {
	                    // skip the initially matched entry
	                    continue;
	                }
	                var candidate_1 = ts.combinePaths(ts.normalizePath(rootDir), suffix);
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Loading_0_from_the_root_dir_1_candidate_location_2, suffix, rootDir, candidate_1);
	                }
	                var baseDirectory = ts.getDirectoryPath(candidate_1);
	                var resolvedFileName_1 = loader(extensions, candidate_1, failedLookupLocations, !directoryProbablyExists(baseDirectory, state.host), state);
	                if (resolvedFileName_1) {
	                    return resolvedFileName_1;
	                }
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Module_resolution_using_rootDirs_has_failed);
	            }
	        }
	        return undefined;
	    }
	    function tryLoadModuleUsingBaseUrl(extensions, moduleName, loader, failedLookupLocations, state) {
	        if (!state.compilerOptions.baseUrl) {
	            return undefined;
	        }
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.baseUrl_option_is_set_to_0_using_this_value_to_resolve_non_relative_module_name_1, state.compilerOptions.baseUrl, moduleName);
	        }
	        // string is for exact match
	        var matchedPattern;
	        if (state.compilerOptions.paths) {
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.paths_option_is_specified_looking_for_a_pattern_to_match_module_name_0, moduleName);
	            }
	            matchedPattern = ts.matchPatternOrExact(ts.getOwnKeys(state.compilerOptions.paths), moduleName);
	        }
	        if (matchedPattern) {
	            var matchedStar_1 = ts.isString(matchedPattern) ? undefined : ts.matchedText(matchedPattern, moduleName);
	            var matchedPatternText = ts.isString(matchedPattern) ? matchedPattern : ts.patternText(matchedPattern);
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Module_name_0_matched_pattern_1, moduleName, matchedPatternText);
	            }
	            return ts.forEach(state.compilerOptions.paths[matchedPatternText], function (subst) {
	                var path = matchedStar_1 ? subst.replace("*", matchedStar_1) : subst;
	                var candidate = ts.normalizePath(ts.combinePaths(state.compilerOptions.baseUrl, path));
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Trying_substitution_0_candidate_module_location_Colon_1, subst, path);
	                }
	                // A path mapping may have an extension, in contrast to an import, which should omit it.
	                var extension = ts.tryGetExtensionFromPath(candidate);
	                if (extension !== undefined) {
	                    var path_1 = tryFile(candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state);
	                    if (path_1 !== undefined) {
	                        return noPackageId({ path: path_1, ext: extension });
	                    }
	                }
	                return loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(ts.getDirectoryPath(candidate), state.host), state);
	            });
	        }
	        else {
	            var candidate = ts.normalizePath(ts.combinePaths(state.compilerOptions.baseUrl, moduleName));
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.Resolving_module_name_0_relative_to_base_url_1_2, moduleName, state.compilerOptions.baseUrl, candidate);
	            }
	            return loader(extensions, candidate, failedLookupLocations, !directoryProbablyExists(ts.getDirectoryPath(candidate), state.host), state);
	        }
	    }
	    function nodeModuleNameResolver(moduleName, containingFile, compilerOptions, host, cache) {
	        return nodeModuleNameResolverWorker(moduleName, ts.getDirectoryPath(containingFile), compilerOptions, host, cache, /*jsOnly*/ false);
	    }
	    ts.nodeModuleNameResolver = nodeModuleNameResolver;
	    /**
	     * Expose resolution logic to allow us to use Node module resolution logic from arbitrary locations.
	     * No way to do this with `require()`: https://github.com/nodejs/node/issues/5963
	     * Throws an error if the module can't be resolved.
	     */
	    /* @internal */
	    function resolveJavaScriptModule(moduleName, initialDir, host) {
	        var _a = nodeModuleNameResolverWorker(moduleName, initialDir, { moduleResolution: ts.ModuleResolutionKind.NodeJs, allowJs: true }, host, /*cache*/ undefined, /*jsOnly*/ true), resolvedModule = _a.resolvedModule, failedLookupLocations = _a.failedLookupLocations;
	        if (!resolvedModule) {
	            throw new Error("Could not resolve JS module '" + moduleName + "' starting at '" + initialDir + "'. Looked in: " + failedLookupLocations.join(", "));
	        }
	        return resolvedModule.resolvedFileName;
	    }
	    ts.resolveJavaScriptModule = resolveJavaScriptModule;
	    function nodeModuleNameResolverWorker(moduleName, containingDirectory, compilerOptions, host, cache, jsOnly) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        var failedLookupLocations = [];
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var result = jsOnly ?
	            tryResolve(Extensions.JavaScript) :
	            (tryResolve(Extensions.TypeScript) ||
	                tryResolve(Extensions.JavaScript) ||
	                (compilerOptions.resolveJsonModule ? tryResolve(Extensions.Json) : undefined));
	        if (result && result.value) {
	            var _a = result.value, resolved = _a.resolved, originalPath = _a.originalPath, isExternalLibraryImport = _a.isExternalLibraryImport;
	            return createResolvedModuleWithFailedLookupLocations(resolved, originalPath, isExternalLibraryImport, failedLookupLocations);
	        }
	        return { resolvedModule: undefined, failedLookupLocations: failedLookupLocations };
	        function tryResolve(extensions) {
	            var loader = function (extensions, candidate, failedLookupLocations, onlyRecordFailures, state) { return nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, /*considerPackageJson*/ true); };
	            var resolved = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loader, failedLookupLocations, state);
	            if (resolved) {
	                return toSearchResult({ resolved: resolved, isExternalLibraryImport: false });
	            }
	            if (!ts.isExternalModuleNameRelative(moduleName)) {
	                if (traceEnabled) {
	                    trace(host, ts.Diagnostics.Loading_module_0_from_node_modules_folder_target_file_type_1, moduleName, Extensions[extensions]);
	                }
	                var resolved_1 = loadModuleFromNodeModules(extensions, moduleName, containingDirectory, failedLookupLocations, state, cache);
	                if (!resolved_1)
	                    return undefined;
	                var resolvedValue = resolved_1.value;
	                var originalPath = void 0;
	                if (!compilerOptions.preserveSymlinks && resolvedValue) {
	                    originalPath = resolvedValue.path;
	                    var path = realPath(resolved_1.value.path, host, traceEnabled);
	                    if (path === originalPath) {
	                        originalPath = undefined;
	                    }
	                    resolvedValue = __assign({}, resolvedValue, { path: path });
	                }
	                // For node_modules lookups, get the real path so that multiple accesses to an `npm link`-ed module do not create duplicate files.
	                return { value: resolvedValue && { resolved: resolvedValue, originalPath: originalPath, isExternalLibraryImport: true } };
	            }
	            else {
	                var _a = ts.normalizePathAndParts(ts.combinePaths(containingDirectory, moduleName)), candidate = _a.path, parts = _a.parts;
	                var resolved_2 = nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state, /*considerPackageJson*/ true);
	                // Treat explicit "node_modules" import as an external library import.
	                return resolved_2 && toSearchResult({ resolved: resolved_2, isExternalLibraryImport: ts.contains(parts, "node_modules") });
	            }
	        }
	    }
	    function realPath(path, host, traceEnabled) {
	        if (!host.realpath) {
	            return path;
	        }
	        var real = ts.normalizePath(host.realpath(path));
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Resolving_real_path_for_0_result_1, path, real);
	        }
	        ts.Debug.assert(host.fileExists(real), path + " linked to nonexistent file " + real); // tslint:disable-line
	        return real;
	    }
	    function nodeLoadModuleByRelativeName(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson) {
	        if (state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.Loading_module_as_file_Slash_folder_candidate_module_location_0_target_file_type_1, candidate, Extensions[extensions]);
	        }
	        if (!ts.hasTrailingDirectorySeparator(candidate)) {
	            if (!onlyRecordFailures) {
	                var parentOfCandidate = ts.getDirectoryPath(candidate);
	                if (!directoryProbablyExists(parentOfCandidate, state.host)) {
	                    if (state.traceEnabled) {
	                        trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, parentOfCandidate);
	                    }
	                    onlyRecordFailures = true;
	                }
	            }
	            var resolvedFromFile = loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state);
	            if (resolvedFromFile) {
	                var nm = considerPackageJson ? parseNodeModuleFromPath(resolvedFromFile) : undefined;
	                var packageId = nm && getPackageJsonInfo(nm.packageDirectory, nm.subModuleName, failedLookupLocations, /*onlyRecordFailures*/ false, state).packageId;
	                return withPackageId(packageId, resolvedFromFile);
	            }
	        }
	        if (!onlyRecordFailures) {
	            var candidateExists = directoryProbablyExists(candidate, state.host);
	            if (!candidateExists) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, candidate);
	                }
	                onlyRecordFailures = true;
	            }
	        }
	        return loadNodeModuleFromDirectory(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson);
	    }
	    var nodeModulesPathPart = "/node_modules/";
	    /**
	     * This will be called on the successfully resolved path from `loadModuleFromFile`.
	     * (Not neeeded for `loadModuleFromNodeModules` as that looks up the `package.json` as part of resolution.)
	     *
	     * packageDirectory is the directory of the package itself.
	     * subModuleName is the path within the package.
	     *   For `blah/node_modules/foo/index.d.ts` this is { packageDirectory: "foo", subModuleName: "index.d.ts" }. (Part before "/node_modules/" is ignored.)
	     *   For `/node_modules/foo/bar.d.ts` this is { packageDirectory: "foo", subModuleName": "bar/index.d.ts" }.
	     *   For `/node_modules/@types/foo/bar/index.d.ts` this is { packageDirectory: "@types/foo", subModuleName: "bar/index.d.ts" }.
	     *   For `/node_modules/foo/bar/index.d.ts` this is { packageDirectory: "foo", subModuleName": "bar/index.d.ts" }.
	     */
	    function parseNodeModuleFromPath(resolved) {
	        var path = ts.normalizePath(resolved.path);
	        var idx = path.lastIndexOf(nodeModulesPathPart);
	        if (idx === -1) {
	            return undefined;
	        }
	        var indexAfterNodeModules = idx + nodeModulesPathPart.length;
	        var indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterNodeModules);
	        if (path.charCodeAt(indexAfterNodeModules) === 64 /* at */) {
	            indexAfterPackageName = moveToNextDirectorySeparatorIfAvailable(path, indexAfterPackageName);
	        }
	        var packageDirectory = path.slice(0, indexAfterPackageName);
	        var subModuleName = ts.removeExtension(path.slice(indexAfterPackageName + 1), resolved.ext) + ".d.ts" /* Dts */;
	        return { packageDirectory: packageDirectory, subModuleName: subModuleName };
	    }
	    function moveToNextDirectorySeparatorIfAvailable(path, prevSeparatorIndex) {
	        var nextSeparatorIndex = path.indexOf(ts.directorySeparator, prevSeparatorIndex + 1);
	        return nextSeparatorIndex === -1 ? prevSeparatorIndex : nextSeparatorIndex;
	    }
	    function addExtensionAndIndex(path) {
	        if (path === "") {
	            return "index.d.ts";
	        }
	        if (ts.endsWith(path, ".d.ts")) {
	            return path;
	        }
	        if (ts.endsWith(path, "/index")) {
	            return path + ".d.ts";
	        }
	        return path + "/index.d.ts";
	    }
	    /* @internal */
	    function directoryProbablyExists(directoryName, host) {
	        // if host does not support 'directoryExists' assume that directory will exist
	        return !host.directoryExists || host.directoryExists(directoryName);
	    }
	    ts.directoryProbablyExists = directoryProbablyExists;
	    function loadModuleFromFileNoPackageId(extensions, candidate, failedLookupLocations, onlyRecordFailures, state) {
	        return noPackageId(loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state));
	    }
	    /**
	     * @param {boolean} onlyRecordFailures - if true then function won't try to actually load files but instead record all attempts as failures. This flag is necessary
	     * in cases when we know upfront that all load attempts will fail (because containing folder does not exists) however we still need to record all failed lookup locations.
	     */
	    function loadModuleFromFile(extensions, candidate, failedLookupLocations, onlyRecordFailures, state) {
	        if (extensions === Extensions.Json) {
	            var extensionLess = ts.tryRemoveExtension(candidate, ".json" /* Json */);
	            return extensionLess && tryAddingExtensions(extensionLess, extensions, failedLookupLocations, onlyRecordFailures, state);
	        }
	        // First, try adding an extension. An import of "foo" could be matched by a file "foo.ts", or "foo.js" by "foo.js.ts"
	        var resolvedByAddingExtension = tryAddingExtensions(candidate, extensions, failedLookupLocations, onlyRecordFailures, state);
	        if (resolvedByAddingExtension) {
	            return resolvedByAddingExtension;
	        }
	        // If that didn't work, try stripping a ".js" or ".jsx" extension and replacing it with a TypeScript one;
	        // e.g. "./foo.js" can be matched by "./foo.ts" or "./foo.d.ts"
	        if (ts.hasJavaScriptFileExtension(candidate)) {
	            var extensionless = ts.removeFileExtension(candidate);
	            if (state.traceEnabled) {
	                var extension = candidate.substring(extensionless.length);
	                trace(state.host, ts.Diagnostics.File_name_0_has_a_1_extension_stripping_it, candidate, extension);
	            }
	            return tryAddingExtensions(extensionless, extensions, failedLookupLocations, onlyRecordFailures, state);
	        }
	    }
	    /** Try to return an existing file that adds one of the `extensions` to `candidate`. */
	    function tryAddingExtensions(candidate, extensions, failedLookupLocations, onlyRecordFailures, state) {
	        if (!onlyRecordFailures) {
	            // check if containing folder exists - if it doesn't then just record failures for all supported extensions without disk probing
	            var directory_1 = ts.getDirectoryPath(candidate);
	            if (directory_1) {
	                onlyRecordFailures = !directoryProbablyExists(directory_1, state.host);
	            }
	        }
	        switch (extensions) {
	            case Extensions.DtsOnly:
	                return tryExtension(".d.ts" /* Dts */);
	            case Extensions.TypeScript:
	                return tryExtension(".ts" /* Ts */) || tryExtension(".tsx" /* Tsx */) || tryExtension(".d.ts" /* Dts */);
	            case Extensions.JavaScript:
	                return tryExtension(".js" /* Js */) || tryExtension(".jsx" /* Jsx */);
	            case Extensions.Json:
	                return tryExtension(".json" /* Json */);
	        }
	        function tryExtension(ext) {
	            var path = tryFile(candidate + ext, failedLookupLocations, onlyRecordFailures, state);
	            return path && { path: path, ext: ext };
	        }
	    }
	    /** Return the file if it exists. */
	    function tryFile(fileName, failedLookupLocations, onlyRecordFailures, state) {
	        if (!onlyRecordFailures) {
	            if (state.host.fileExists(fileName)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.File_0_exist_use_it_as_a_name_resolution_result, fileName);
	                }
	                return fileName;
	            }
	            else {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.File_0_does_not_exist, fileName);
	                }
	            }
	        }
	        failedLookupLocations.push(fileName);
	        return undefined;
	    }
	    function loadNodeModuleFromDirectory(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, considerPackageJson) {
	        if (considerPackageJson === void 0) { considerPackageJson = true; }
	        var _a = considerPackageJson
	            ? getPackageJsonInfo(candidate, "", failedLookupLocations, onlyRecordFailures, state)
	            : { packageJsonContent: undefined, packageId: undefined }, packageJsonContent = _a.packageJsonContent, packageId = _a.packageId;
	        return withPackageId(packageId, loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, packageJsonContent));
	    }
	    function loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, onlyRecordFailures, state, packageJsonContent) {
	        var fromPackageJson = packageJsonContent && loadModuleFromPackageJson(packageJsonContent, extensions, candidate, failedLookupLocations, state);
	        if (fromPackageJson) {
	            return fromPackageJson;
	        }
	        var directoryExists = !onlyRecordFailures && directoryProbablyExists(candidate, state.host);
	        return loadModuleFromFile(extensions, ts.combinePaths(candidate, "index"), failedLookupLocations, !directoryExists, state);
	    }
	    function getPackageJsonInfo(nodeModuleDirectory, subModuleName, failedLookupLocations, onlyRecordFailures, state) {
	        var host = state.host, traceEnabled = state.traceEnabled;
	        var directoryExists = !onlyRecordFailures && directoryProbablyExists(nodeModuleDirectory, host);
	        var packageJsonPath = pathToPackageJson(nodeModuleDirectory);
	        if (directoryExists && host.fileExists(packageJsonPath)) {
	            var packageJsonContent = readJson(packageJsonPath, host);
	            if (subModuleName === "") { // looking up the root - need to handle types/typings/main redirects for subModuleName
	                var path = tryReadPackageJsonFields(/*readTypes*/ true, packageJsonContent, nodeModuleDirectory, state);
	                if (typeof path === "string") {
	                    subModuleName = addExtensionAndIndex(path.substring(nodeModuleDirectory.length + 1));
	                }
	                else {
	                    var jsPath = tryReadPackageJsonFields(/*readTypes*/ false, packageJsonContent, nodeModuleDirectory, state);
	                    if (typeof jsPath === "string" && jsPath.length > nodeModuleDirectory.length) {
	                        var potentialSubModule_1 = jsPath.substring(nodeModuleDirectory.length + 1);
	                        subModuleName = (ts.forEach(ts.supportedJavascriptExtensions, function (extension) {
	                            return ts.tryRemoveExtension(potentialSubModule_1, extension);
	                        }) || potentialSubModule_1) + ".d.ts" /* Dts */;
	                    }
	                    else {
	                        subModuleName = "index.d.ts";
	                    }
	                }
	            }
	            if (!ts.endsWith(subModuleName, ".d.ts" /* Dts */)) {
	                subModuleName = addExtensionAndIndex(subModuleName);
	            }
	            var packageId = typeof packageJsonContent.name === "string" && typeof packageJsonContent.version === "string"
	                ? { name: packageJsonContent.name, subModuleName: subModuleName, version: packageJsonContent.version }
	                : undefined;
	            if (traceEnabled) {
	                if (packageId) {
	                    trace(host, ts.Diagnostics.Found_package_json_at_0_Package_ID_is_1, packageJsonPath, ts.packageIdToString(packageId));
	                }
	                else {
	                    trace(host, ts.Diagnostics.Found_package_json_at_0, packageJsonPath);
	                }
	            }
	            return { found: true, packageJsonContent: packageJsonContent, packageId: packageId };
	        }
	        else {
	            if (directoryExists && traceEnabled) {
	                trace(host, ts.Diagnostics.File_0_does_not_exist, packageJsonPath);
	            }
	            // record package json as one of failed lookup locations - in the future if this file will appear it will invalidate resolution results
	            failedLookupLocations.push(packageJsonPath);
	            return { found: false, packageJsonContent: undefined, packageId: undefined };
	        }
	    }
	    function loadModuleFromPackageJson(jsonContent, extensions, candidate, failedLookupLocations, state) {
	        var file = tryReadPackageJsonFields(extensions !== Extensions.JavaScript && extensions !== Extensions.Json, jsonContent, candidate, state);
	        if (!file) {
	            if (extensions === Extensions.TypeScript) {
	                // When resolving typescript modules, try resolving using main field as well
	                file = tryReadPackageJsonFields(/*readTypes*/ false, jsonContent, candidate, state);
	                if (!file) {
	                    return undefined;
	                }
	            }
	            else {
	                return undefined;
	            }
	        }
	        var onlyRecordFailures = !directoryProbablyExists(ts.getDirectoryPath(file), state.host);
	        var fromFile = tryFile(file, failedLookupLocations, onlyRecordFailures, state);
	        if (fromFile) {
	            var resolved = resolvedIfExtensionMatches(extensions, fromFile);
	            if (resolved) {
	                return resolved;
	            }
	            if (state.traceEnabled) {
	                trace(state.host, ts.Diagnostics.File_0_has_an_unsupported_extension_so_skipping_it, fromFile);
	            }
	        }
	        // Even if extensions is DtsOnly, we can still look up a .ts file as a result of package.json "types"
	        var nextExtensions = extensions === Extensions.DtsOnly ? Extensions.TypeScript : extensions;
	        // Don't do package.json lookup recursively, because Node.js' package lookup doesn't.
	        var result = nodeLoadModuleByRelativeName(nextExtensions, file, failedLookupLocations, onlyRecordFailures, state, /*considerPackageJson*/ false);
	        if (result) {
	            // It won't have a `packageId` set, because we disabled `considerPackageJson`.
	            ts.Debug.assert(result.packageId === undefined);
	            return { path: result.path, ext: result.extension };
	        }
	    }
	    /** Resolve from an arbitrarily specified file. Return `undefined` if it has an unsupported extension. */
	    function resolvedIfExtensionMatches(extensions, path) {
	        var ext = ts.tryGetExtensionFromPath(path);
	        return ext !== undefined && extensionIsOk(extensions, ext) ? { path: path, ext: ext } : undefined;
	    }
	    /** True if `extension` is one of the supported `extensions`. */
	    function extensionIsOk(extensions, extension) {
	        switch (extensions) {
	            case Extensions.JavaScript:
	                return extension === ".js" /* Js */ || extension === ".jsx" /* Jsx */;
	            case Extensions.Json:
	                return extension === ".json" /* Json */;
	            case Extensions.TypeScript:
	                return extension === ".ts" /* Ts */ || extension === ".tsx" /* Tsx */ || extension === ".d.ts" /* Dts */;
	            case Extensions.DtsOnly:
	                return extension === ".d.ts" /* Dts */;
	        }
	    }
	    function pathToPackageJson(directory) {
	        return ts.combinePaths(directory, "package.json");
	    }
	    function loadModuleFromNodeModulesFolder(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, failedLookupLocations, state) {
	        var candidate = ts.normalizePath(ts.combinePaths(nodeModulesFolder, moduleName));
	        // First look for a nested package.json, as in `node_modules/foo/bar/package.json`.
	        var packageJsonContent;
	        var packageId;
	        var packageInfo = getPackageJsonInfo(candidate, "", failedLookupLocations, /*onlyRecordFailures*/ !nodeModulesFolderExists, state);
	        if (packageInfo.found) {
	            (packageJsonContent = packageInfo.packageJsonContent, packageId = packageInfo.packageId);
	        }
	        else {
	            var _a = getPackageName(moduleName), packageName = _a.packageName, rest = _a.rest;
	            if (rest !== "") { // If "rest" is empty, we just did this search above.
	                var packageRootPath = ts.combinePaths(nodeModulesFolder, packageName);
	                // Don't use a "types" or "main" from here because we're not loading the root, but a subdirectory -- just here for the packageId.
	                packageId = getPackageJsonInfo(packageRootPath, rest, failedLookupLocations, !nodeModulesFolderExists, state).packageId;
	            }
	        }
	        var pathAndExtension = loadModuleFromFile(extensions, candidate, failedLookupLocations, !nodeModulesFolderExists, state) ||
	            loadNodeModuleFromDirectoryWorker(extensions, candidate, failedLookupLocations, !nodeModulesFolderExists, state, packageJsonContent);
	        return withPackageId(packageId, pathAndExtension);
	    }
	    /* @internal */
	    function getPackageName(moduleName) {
	        var idx = moduleName.indexOf(ts.directorySeparator);
	        if (moduleName[0] === "@") {
	            idx = moduleName.indexOf(ts.directorySeparator, idx + 1);
	        }
	        return idx === -1 ? { packageName: moduleName, rest: "" } : { packageName: moduleName.slice(0, idx), rest: moduleName.slice(idx + 1) };
	    }
	    ts.getPackageName = getPackageName;
	    function loadModuleFromNodeModules(extensions, moduleName, directory, failedLookupLocations, state, cache) {
	        return loadModuleFromNodeModulesWorker(extensions, moduleName, directory, failedLookupLocations, state, /*typesOnly*/ false, cache);
	    }
	    function loadModuleFromNodeModulesAtTypes(moduleName, directory, failedLookupLocations, state) {
	        // Extensions parameter here doesn't actually matter, because typesOnly ensures we're just doing @types lookup, which is always DtsOnly.
	        return loadModuleFromNodeModulesWorker(Extensions.DtsOnly, moduleName, directory, failedLookupLocations, state, /*typesOnly*/ true, /*cache*/ undefined);
	    }
	    function loadModuleFromNodeModulesWorker(extensions, moduleName, directory, failedLookupLocations, state, typesOnly, cache) {
	        var perModuleNameCache = cache && cache.getOrCreateCacheForModuleName(moduleName);
	        return ts.forEachAncestorDirectory(ts.normalizeSlashes(directory), function (ancestorDirectory) {
	            if (ts.getBaseFileName(ancestorDirectory) !== "node_modules") {
	                var resolutionFromCache = tryFindNonRelativeModuleNameInCache(perModuleNameCache, moduleName, ancestorDirectory, state.traceEnabled, state.host, failedLookupLocations);
	                if (resolutionFromCache) {
	                    return resolutionFromCache;
	                }
	                return toSearchResult(loadModuleFromNodeModulesOneLevel(extensions, moduleName, ancestorDirectory, failedLookupLocations, state, typesOnly));
	            }
	        });
	    }
	    /** Load a module from a single node_modules directory, but not from any ancestors' node_modules directories. */
	    function loadModuleFromNodeModulesOneLevel(extensions, moduleName, directory, failedLookupLocations, state, typesOnly) {
	        if (typesOnly === void 0) { typesOnly = false; }
	        var nodeModulesFolder = ts.combinePaths(directory, "node_modules");
	        var nodeModulesFolderExists = directoryProbablyExists(nodeModulesFolder, state.host);
	        if (!nodeModulesFolderExists && state.traceEnabled) {
	            trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesFolder);
	        }
	        var packageResult = typesOnly ? undefined : loadModuleFromNodeModulesFolder(extensions, moduleName, nodeModulesFolder, nodeModulesFolderExists, failedLookupLocations, state);
	        if (packageResult) {
	            return packageResult;
	        }
	        if (extensions !== Extensions.JavaScript && extensions !== Extensions.Json) {
	            var nodeModulesAtTypes_1 = ts.combinePaths(nodeModulesFolder, "@types");
	            var nodeModulesAtTypesExists = nodeModulesFolderExists;
	            if (nodeModulesFolderExists && !directoryProbablyExists(nodeModulesAtTypes_1, state.host)) {
	                if (state.traceEnabled) {
	                    trace(state.host, ts.Diagnostics.Directory_0_does_not_exist_skipping_all_lookups_in_it, nodeModulesAtTypes_1);
	                }
	                nodeModulesAtTypesExists = false;
	            }
	            return loadModuleFromNodeModulesFolder(Extensions.DtsOnly, mangleScopedPackage(moduleName, state), nodeModulesAtTypes_1, nodeModulesAtTypesExists, failedLookupLocations, state);
	        }
	    }
	    /** Double underscores are used in DefinitelyTyped to delimit scoped packages. */
	    var mangledScopedPackageSeparator = "__";
	    /** For a scoped package, we must look in `@types/foo__bar` instead of `@types/@foo/bar`. */
	    function mangleScopedPackage(packageName, state) {
	        var mangled = getMangledNameForScopedPackage(packageName);
	        if (state.traceEnabled && mangled !== packageName) {
	            trace(state.host, ts.Diagnostics.Scoped_package_detected_looking_in_0, mangled);
	        }
	        return mangled;
	    }
	    /* @internal */
	    function getTypesPackageName(packageName) {
	        return "@types/" + getMangledNameForScopedPackage(packageName);
	    }
	    ts.getTypesPackageName = getTypesPackageName;
	    /* @internal */
	    function getMangledNameForScopedPackage(packageName) {
	        if (ts.startsWith(packageName, "@")) {
	            var replaceSlash = packageName.replace(ts.directorySeparator, mangledScopedPackageSeparator);
	            if (replaceSlash !== packageName) {
	                return replaceSlash.slice(1); // Take off the "@"
	            }
	        }
	        return packageName;
	    }
	    ts.getMangledNameForScopedPackage = getMangledNameForScopedPackage;
	    /* @internal */
	    function getPackageNameFromAtTypesDirectory(mangledName) {
	        var withoutAtTypePrefix = ts.removePrefix(mangledName, "@types/");
	        if (withoutAtTypePrefix !== mangledName) {
	            return getUnmangledNameForScopedPackage(withoutAtTypePrefix);
	        }
	        return mangledName;
	    }
	    ts.getPackageNameFromAtTypesDirectory = getPackageNameFromAtTypesDirectory;
	    /* @internal */
	    function getUnmangledNameForScopedPackage(typesPackageName) {
	        return ts.stringContains(typesPackageName, mangledScopedPackageSeparator) ?
	            "@" + typesPackageName.replace(mangledScopedPackageSeparator, ts.directorySeparator) :
	            typesPackageName;
	    }
	    ts.getUnmangledNameForScopedPackage = getUnmangledNameForScopedPackage;
	    function tryFindNonRelativeModuleNameInCache(cache, moduleName, containingDirectory, traceEnabled, host, failedLookupLocations) {
	        var result = cache && cache.get(containingDirectory);
	        if (result) {
	            if (traceEnabled) {
	                trace(host, ts.Diagnostics.Resolution_for_module_0_was_found_in_cache_from_location_1, moduleName, containingDirectory);
	            }
	            failedLookupLocations.push.apply(failedLookupLocations, result.failedLookupLocations);
	            return { value: result.resolvedModule && { path: result.resolvedModule.resolvedFileName, extension: result.resolvedModule.extension, packageId: result.resolvedModule.packageId } };
	        }
	    }
	    function classicNameResolver(moduleName, containingFile, compilerOptions, host, cache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var failedLookupLocations = [];
	        var containingDirectory = ts.getDirectoryPath(containingFile);
	        var resolved = tryResolve(Extensions.TypeScript) || tryResolve(Extensions.JavaScript);
	        // No originalPath because classic resolution doesn't resolve realPath
	        return createResolvedModuleWithFailedLookupLocations(resolved && resolved.value, /*originalPath*/ undefined, /*isExternalLibraryImport*/ false, failedLookupLocations);
	        function tryResolve(extensions) {
	            var resolvedUsingSettings = tryLoadModuleUsingOptionalResolutionSettings(extensions, moduleName, containingDirectory, loadModuleFromFileNoPackageId, failedLookupLocations, state);
	            if (resolvedUsingSettings) {
	                return { value: resolvedUsingSettings };
	            }
	            var perModuleNameCache = cache && cache.getOrCreateCacheForModuleName(moduleName);
	            if (!ts.isExternalModuleNameRelative(moduleName)) {
	                // Climb up parent directories looking for a module.
	                var resolved_3 = ts.forEachAncestorDirectory(containingDirectory, function (directory) {
	                    var resolutionFromCache = tryFindNonRelativeModuleNameInCache(perModuleNameCache, moduleName, directory, traceEnabled, host, failedLookupLocations);
	                    if (resolutionFromCache) {
	                        return resolutionFromCache;
	                    }
	                    var searchName = ts.normalizePath(ts.combinePaths(directory, moduleName));
	                    return toSearchResult(loadModuleFromFileNoPackageId(extensions, searchName, failedLookupLocations, /*onlyRecordFailures*/ false, state));
	                });
	                if (resolved_3) {
	                    return resolved_3;
	                }
	                if (extensions === Extensions.TypeScript) {
	                    // If we didn't find the file normally, look it up in @types.
	                    return loadModuleFromNodeModulesAtTypes(moduleName, containingDirectory, failedLookupLocations, state);
	                }
	            }
	            else {
	                var candidate = ts.normalizePath(ts.combinePaths(containingDirectory, moduleName));
	                return toSearchResult(loadModuleFromFileNoPackageId(extensions, candidate, failedLookupLocations, /*onlyRecordFailures*/ false, state));
	            }
	        }
	    }
	    ts.classicNameResolver = classicNameResolver;
	    /**
	     * LSHost may load a module from a global cache of typings.
	     * This is the minumum code needed to expose that functionality; the rest is in LSHost.
	     */
	    /* @internal */
	    function loadModuleFromGlobalCache(moduleName, projectName, compilerOptions, host, globalCache) {
	        var traceEnabled = isTraceEnabled(compilerOptions, host);
	        if (traceEnabled) {
	            trace(host, ts.Diagnostics.Auto_discovery_for_typings_is_enabled_in_project_0_Running_extra_resolution_pass_for_module_1_using_cache_location_2, projectName, moduleName, globalCache);
	        }
	        var state = { compilerOptions: compilerOptions, host: host, traceEnabled: traceEnabled };
	        var failedLookupLocations = [];
	        var resolved = loadModuleFromNodeModulesOneLevel(Extensions.DtsOnly, moduleName, globalCache, failedLookupLocations, state);
	        return createResolvedModuleWithFailedLookupLocations(resolved, /*originalPath*/ undefined, /*isExternalLibraryImport*/ true, failedLookupLocations);
	    }
	    ts.loadModuleFromGlobalCache = loadModuleFromGlobalCache;
	    /**
	     * Wraps value to SearchResult.
	     * @returns undefined if value is undefined or { value } otherwise
	     */
	    function toSearchResult(value) {
	        return value !== undefined ? { value: value } : undefined;
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var ambientModuleSymbolRegex = /^".+"$/;
	    var nextSymbolId = 1;
	    var nextNodeId = 1;
	    var nextMergeId = 1;
	    var nextFlowId = 1;
	    function getNodeId(node) {
	        if (!node.id) {
	            node.id = nextNodeId;
	            nextNodeId++;
	        }
	        return node.id;
	    }
	    ts.getNodeId = getNodeId;
	    function getSymbolId(symbol) {
	        if (!symbol.id) {
	            symbol.id = nextSymbolId;
	            nextSymbolId++;
	        }
	        return symbol.id;
	    }
	    ts.getSymbolId = getSymbolId;
	    function isInstantiatedModule(node, preserveConstEnums) {
	        var moduleState = ts.getModuleInstanceState(node);
	        return moduleState === 1 /* Instantiated */ ||
	            (preserveConstEnums && moduleState === 2 /* ConstEnumOnly */);
	    }
	    ts.isInstantiatedModule = isInstantiatedModule;
	    function createTypeChecker(host, produceDiagnostics) {
	        // Cancellation that controls whether or not we can cancel in the middle of type checking.
	        // In general cancelling is *not* safe for the type checker.  We might be in the middle of
	        // computing something, and we will leave our internals in an inconsistent state.  Callers
	        // who set the cancellation token should catch if a cancellation exception occurs, and
	        // should throw away and create a new TypeChecker.
	        //
	        // Currently we only support setting the cancellation token when getting diagnostics.  This
	        // is because diagnostics can be quite expensive, and we want to allow hosts to bail out if
	        // they no longer need the information (for example, if the user started editing again).
	        var cancellationToken;
	        var requestedExternalEmitHelpers;
	        var externalHelpersModule;
	        // tslint:disable variable-name
	        var Symbol = ts.objectAllocator.getSymbolConstructor();
	        var Type = ts.objectAllocator.getTypeConstructor();
	        var Signature = ts.objectAllocator.getSignatureConstructor();
	        // tslint:enable variable-name
	        var typeCount = 0;
	        var symbolCount = 0;
	        var enumCount = 0;
	        var symbolInstantiationDepth = 0;
	        var emptySymbols = ts.createSymbolTable();
	        var identityMapper = ts.identity;
	        var compilerOptions = host.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var allowSyntheticDefaultImports = ts.getAllowSyntheticDefaultImports(compilerOptions);
	        var strictNullChecks = ts.getStrictOptionValue(compilerOptions, "strictNullChecks");
	        var strictFunctionTypes = ts.getStrictOptionValue(compilerOptions, "strictFunctionTypes");
	        var strictPropertyInitialization = ts.getStrictOptionValue(compilerOptions, "strictPropertyInitialization");
	        var noImplicitAny = ts.getStrictOptionValue(compilerOptions, "noImplicitAny");
	        var noImplicitThis = ts.getStrictOptionValue(compilerOptions, "noImplicitThis");
	        var keyofStringsOnly = !!compilerOptions.keyofStringsOnly;
	        var emitResolver = createResolver();
	        var nodeBuilder = createNodeBuilder();
	        var undefinedSymbol = createSymbol(4 /* Property */, "undefined");
	        undefinedSymbol.declarations = [];
	        var argumentsSymbol = createSymbol(4 /* Property */, "arguments");
	        var requireSymbol = createSymbol(4 /* Property */, "require");
	        var moduleSymbol = createSymbol(4 /* Property */, "module");
	        /** This will be set during calls to `getResolvedSignature` where services determines an apparent number of arguments greater than what is actually provided. */
	        var apparentArgumentCount;
	        // for public members that accept a Node or one of its subtypes, we must guard against
	        // synthetic nodes created during transformations by calling `getParseTreeNode`.
	        // for most of these, we perform the guard only on `checker` to avoid any possible
	        // extra cost of calling `getParseTreeNode` when calling these functions from inside the
	        // checker.
	        var checker = {
	            getNodeCount: function () { return ts.sum(host.getSourceFiles(), "nodeCount"); },
	            getIdentifierCount: function () { return ts.sum(host.getSourceFiles(), "identifierCount"); },
	            getSymbolCount: function () { return ts.sum(host.getSourceFiles(), "symbolCount") + symbolCount; },
	            getTypeCount: function () { return typeCount; },
	            isUndefinedSymbol: function (symbol) { return symbol === undefinedSymbol; },
	            isArgumentsSymbol: function (symbol) { return symbol === argumentsSymbol; },
	            isUnknownSymbol: function (symbol) { return symbol === unknownSymbol; },
	            getMergedSymbol: getMergedSymbol,
	            getDiagnostics: getDiagnostics,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getTypeOfSymbolAtLocation: function (symbol, location) {
	                location = ts.getParseTreeNode(location);
	                return location ? getTypeOfSymbolAtLocation(symbol, location) : unknownType;
	            },
	            getSymbolsOfParameterPropertyDeclaration: function (parameter, parameterName) {
	                parameter = ts.getParseTreeNode(parameter, ts.isParameter);
	                ts.Debug.assert(parameter !== undefined, "Cannot get symbols of a synthetic parameter that cannot be resolved to a parse-tree node.");
	                return getSymbolsOfParameterPropertyDeclaration(parameter, ts.escapeLeadingUnderscores(parameterName));
	            },
	            getDeclaredTypeOfSymbol: getDeclaredTypeOfSymbol,
	            getPropertiesOfType: getPropertiesOfType,
	            getPropertyOfType: function (type, name) { return getPropertyOfType(type, ts.escapeLeadingUnderscores(name)); },
	            getIndexInfoOfType: getIndexInfoOfType,
	            getSignaturesOfType: getSignaturesOfType,
	            getIndexTypeOfType: getIndexTypeOfType,
	            getBaseTypes: getBaseTypes,
	            getBaseTypeOfLiteralType: getBaseTypeOfLiteralType,
	            getWidenedType: getWidenedType,
	            getTypeFromTypeNode: function (node) {
	                node = ts.getParseTreeNode(node, ts.isTypeNode);
	                return node ? getTypeFromTypeNode(node) : unknownType;
	            },
	            getParameterType: getTypeAtPosition,
	            getReturnTypeOfSignature: getReturnTypeOfSignature,
	            getNullableType: getNullableType,
	            getNonNullableType: getNonNullableType,
	            typeToTypeNode: nodeBuilder.typeToTypeNode,
	            indexInfoToIndexSignatureDeclaration: nodeBuilder.indexInfoToIndexSignatureDeclaration,
	            signatureToSignatureDeclaration: nodeBuilder.signatureToSignatureDeclaration,
	            symbolToEntityName: nodeBuilder.symbolToEntityName,
	            symbolToExpression: nodeBuilder.symbolToExpression,
	            symbolToTypeParameterDeclarations: nodeBuilder.symbolToTypeParameterDeclarations,
	            symbolToParameterDeclaration: nodeBuilder.symbolToParameterDeclaration,
	            typeParameterToDeclaration: nodeBuilder.typeParameterToDeclaration,
	            getSymbolsInScope: function (location, meaning) {
	                location = ts.getParseTreeNode(location);
	                return location ? getSymbolsInScope(location, meaning) : [];
	            },
	            getSymbolAtLocation: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getSymbolAtLocation(node) : undefined;
	            },
	            getShorthandAssignmentValueSymbol: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getShorthandAssignmentValueSymbol(node) : undefined;
	            },
	            getExportSpecifierLocalTargetSymbol: function (node) {
	                node = ts.getParseTreeNode(node, ts.isExportSpecifier);
	                return node ? getExportSpecifierLocalTargetSymbol(node) : undefined;
	            },
	            getExportSymbolOfSymbol: function (symbol) {
	                return getMergedSymbol(symbol.exportSymbol || symbol);
	            },
	            getTypeAtLocation: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node ? getTypeOfNode(node) : unknownType;
	            },
	            getPropertySymbolOfDestructuringAssignment: function (location) {
	                location = ts.getParseTreeNode(location, ts.isIdentifier);
	                return location ? getPropertySymbolOfDestructuringAssignment(location) : undefined;
	            },
	            signatureToString: function (signature, enclosingDeclaration, flags, kind) {
	                return signatureToString(signature, ts.getParseTreeNode(enclosingDeclaration), flags, kind);
	            },
	            typeToString: function (type, enclosingDeclaration, flags) {
	                return typeToString(type, ts.getParseTreeNode(enclosingDeclaration), flags);
	            },
	            symbolToString: function (symbol, enclosingDeclaration, meaning, flags) {
	                return symbolToString(symbol, ts.getParseTreeNode(enclosingDeclaration), meaning, flags);
	            },
	            typePredicateToString: function (predicate, enclosingDeclaration, flags) {
	                return typePredicateToString(predicate, ts.getParseTreeNode(enclosingDeclaration), flags);
	            },
	            writeSignature: function (signature, enclosingDeclaration, flags, kind, writer) {
	                return signatureToString(signature, ts.getParseTreeNode(enclosingDeclaration), flags, kind, writer);
	            },
	            writeType: function (type, enclosingDeclaration, flags, writer) {
	                return typeToString(type, ts.getParseTreeNode(enclosingDeclaration), flags, writer);
	            },
	            writeSymbol: function (symbol, enclosingDeclaration, meaning, flags, writer) {
	                return symbolToString(symbol, ts.getParseTreeNode(enclosingDeclaration), meaning, flags, writer);
	            },
	            writeTypePredicate: function (predicate, enclosingDeclaration, flags, writer) {
	                return typePredicateToString(predicate, ts.getParseTreeNode(enclosingDeclaration), flags, writer);
	            },
	            getSymbolDisplayBuilder: getSymbolDisplayBuilder,
	            getAugmentedPropertiesOfType: getAugmentedPropertiesOfType,
	            getRootSymbols: getRootSymbols,
	            getContextualType: function (node) {
	                node = ts.getParseTreeNode(node, ts.isExpression);
	                return node ? getContextualType(node) : undefined;
	            },
	            getContextualTypeForArgumentAtIndex: function (node, argIndex) {
	                node = ts.getParseTreeNode(node, ts.isCallLikeExpression);
	                return node && getContextualTypeForArgumentAtIndex(node, argIndex);
	            },
	            getContextualTypeForJsxAttribute: function (node) {
	                node = ts.getParseTreeNode(node, ts.isJsxAttributeLike);
	                return node && getContextualTypeForJsxAttribute(node);
	            },
	            isContextSensitive: isContextSensitive,
	            getFullyQualifiedName: getFullyQualifiedName,
	            getResolvedSignature: function (node, candidatesOutArray, theArgumentCount) {
	                node = ts.getParseTreeNode(node, ts.isCallLikeExpression);
	                apparentArgumentCount = theArgumentCount;
	                var res = node ? getResolvedSignature(node, candidatesOutArray) : undefined;
	                apparentArgumentCount = undefined;
	                return res;
	            },
	            getConstantValue: function (node) {
	                node = ts.getParseTreeNode(node, canHaveConstantValue);
	                return node ? getConstantValue(node) : undefined;
	            },
	            isValidPropertyAccess: function (node, propertyName) {
	                node = ts.getParseTreeNode(node, ts.isPropertyAccessOrQualifiedNameOrImportTypeNode);
	                return !!node && isValidPropertyAccess(node, ts.escapeLeadingUnderscores(propertyName));
	            },
	            isValidPropertyAccessForCompletions: function (node, type, property) {
	                node = ts.getParseTreeNode(node, ts.isPropertyAccessExpression);
	                return !!node && isValidPropertyAccessForCompletions(node, type, property);
	            },
	            getSignatureFromDeclaration: function (declaration) {
	                declaration = ts.getParseTreeNode(declaration, ts.isFunctionLike);
	                return declaration ? getSignatureFromDeclaration(declaration) : undefined;
	            },
	            isImplementationOfOverload: function (node) {
	                var parsed = ts.getParseTreeNode(node, ts.isFunctionLike);
	                return parsed ? isImplementationOfOverload(parsed) : undefined;
	            },
	            getImmediateAliasedSymbol: function (symbol) {
	                ts.Debug.assert((symbol.flags & 2097152 /* Alias */) !== 0, "Should only get Alias here.");
	                var links = getSymbolLinks(symbol);
	                if (!links.immediateTarget) {
	                    var node = getDeclarationOfAliasSymbol(symbol);
	                    ts.Debug.assert(!!node);
	                    links.immediateTarget = getTargetOfAliasDeclaration(node, /*dontRecursivelyResolve*/ true);
	                }
	                return links.immediateTarget;
	            },
	            getAliasedSymbol: resolveAlias,
	            getEmitResolver: getEmitResolver,
	            getExportsOfModule: getExportsOfModuleAsArray,
	            getExportsAndPropertiesOfModule: getExportsAndPropertiesOfModule,
	            getSymbolWalker: ts.createGetSymbolWalker(getRestTypeOfSignature, getTypePredicateOfSignature, getReturnTypeOfSignature, getBaseTypes, resolveStructuredTypeMembers, getTypeOfSymbol, getResolvedSymbol, getIndexTypeOfStructuredType, getConstraintFromTypeParameter, getFirstIdentifier),
	            getAmbientModules: getAmbientModules,
	            getAllAttributesTypeFromJsxOpeningLikeElement: function (node) {
	                node = ts.getParseTreeNode(node, ts.isJsxOpeningLikeElement);
	                return node ? getAllAttributesTypeFromJsxOpeningLikeElement(node) : undefined;
	            },
	            getJsxIntrinsicTagNamesAt: getJsxIntrinsicTagNamesAt,
	            isOptionalParameter: function (node) {
	                node = ts.getParseTreeNode(node, ts.isParameter);
	                return node ? isOptionalParameter(node) : false;
	            },
	            tryGetMemberInModuleExports: function (name, symbol) { return tryGetMemberInModuleExports(ts.escapeLeadingUnderscores(name), symbol); },
	            tryGetMemberInModuleExportsAndProperties: function (name, symbol) { return tryGetMemberInModuleExportsAndProperties(ts.escapeLeadingUnderscores(name), symbol); },
	            tryFindAmbientModuleWithoutAugmentations: function (moduleName) {
	                // we deliberately exclude augmentations
	                // since we are only interested in declarations of the module itself
	                return tryFindAmbientModule(moduleName, /*withAugmentations*/ false);
	            },
	            getApparentType: getApparentType,
	            getUnionType: getUnionType,
	            createAnonymousType: createAnonymousType,
	            createSignature: createSignature,
	            createSymbol: createSymbol,
	            createIndexInfo: createIndexInfo,
	            getAnyType: function () { return anyType; },
	            getStringType: function () { return stringType; },
	            getNumberType: function () { return numberType; },
	            createPromiseType: createPromiseType,
	            createArrayType: createArrayType,
	            getBooleanType: function () { return booleanType; },
	            getVoidType: function () { return voidType; },
	            getUndefinedType: function () { return undefinedType; },
	            getNullType: function () { return nullType; },
	            getESSymbolType: function () { return esSymbolType; },
	            getNeverType: function () { return neverType; },
	            isSymbolAccessible: isSymbolAccessible,
	            isArrayLikeType: isArrayLikeType,
	            getAllPossiblePropertiesOfTypes: getAllPossiblePropertiesOfTypes,
	            getSuggestionForNonexistentProperty: function (node, type) { return getSuggestionForNonexistentProperty(node, type); },
	            getSuggestionForNonexistentSymbol: function (location, name, meaning) { return getSuggestionForNonexistentSymbol(location, ts.escapeLeadingUnderscores(name), meaning); },
	            getSuggestionForNonexistentModule: function (node, target) { return getSuggestionForNonexistentModule(node, target); },
	            getBaseConstraintOfType: getBaseConstraintOfType,
	            getDefaultFromTypeParameter: function (type) { return type && type.flags & 32768 /* TypeParameter */ ? getDefaultFromTypeParameter(type) : undefined; },
	            resolveName: function (name, location, meaning, excludeGlobals) {
	                return resolveName(location, ts.escapeLeadingUnderscores(name), meaning, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false, excludeGlobals);
	            },
	            getJsxNamespace: function (n) { return ts.unescapeLeadingUnderscores(getJsxNamespace(n)); },
	            getAccessibleSymbolChain: getAccessibleSymbolChain,
	            getTypePredicateOfSignature: getTypePredicateOfSignature,
	            resolveExternalModuleSymbol: resolveExternalModuleSymbol,
	            tryGetThisTypeAt: function (node) {
	                node = ts.getParseTreeNode(node);
	                return node && tryGetThisTypeAt(node);
	            },
	            getTypeArgumentConstraint: function (node) {
	                node = ts.getParseTreeNode(node, ts.isTypeNode);
	                return node && getTypeArgumentConstraint(node);
	            },
	            getSuggestionDiagnostics: function (file) {
	                return (suggestionDiagnostics.get(file.fileName) || ts.emptyArray).concat(getUnusedDiagnostics());
	                function getUnusedDiagnostics() {
	                    if (file.isDeclarationFile)
	                        return ts.emptyArray;
	                    checkSourceFile(file);
	                    var diagnostics = [];
	                    ts.Debug.assert(!!(getNodeLinks(file).flags & 1 /* TypeChecked */));
	                    checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(file), function (kind, diag) {
	                        if (!unusedIsError(kind)) {
	                            diagnostics.push(__assign({}, diag, { category: ts.DiagnosticCategory.Suggestion }));
	                        }
	                    });
	                    return diagnostics;
	                }
	            },
	            runWithCancellationToken: function (token, callback) {
	                try {
	                    cancellationToken = token;
	                    return callback(checker);
	                }
	                finally {
	                    cancellationToken = undefined;
	                }
	            }
	        };
	        var tupleTypes = [];
	        var unionTypes = ts.createMap();
	        var intersectionTypes = ts.createMap();
	        var literalTypes = ts.createMap();
	        var indexedAccessTypes = ts.createMap();
	        var evolvingArrayTypes = [];
	        var undefinedProperties = ts.createMap();
	        var unknownSymbol = createSymbol(4 /* Property */, "unknown");
	        var resolvingSymbol = createSymbol(0, "__resolving__" /* Resolving */);
	        var anyType = createIntrinsicType(1 /* Any */, "any");
	        var autoType = createIntrinsicType(1 /* Any */, "any");
	        var wildcardType = createIntrinsicType(1 /* Any */, "any");
	        var unknownType = createIntrinsicType(1 /* Any */, "unknown");
	        var undefinedType = createIntrinsicType(4096 /* Undefined */, "undefined");
	        var undefinedWideningType = strictNullChecks ? undefinedType : createIntrinsicType(4096 /* Undefined */ | 16777216 /* ContainsWideningType */, "undefined");
	        var nullType = createIntrinsicType(8192 /* Null */, "null");
	        var nullWideningType = strictNullChecks ? nullType : createIntrinsicType(8192 /* Null */ | 16777216 /* ContainsWideningType */, "null");
	        var stringType = createIntrinsicType(2 /* String */, "string");
	        var numberType = createIntrinsicType(4 /* Number */, "number");
	        var trueType = createIntrinsicType(128 /* BooleanLiteral */, "true");
	        var falseType = createIntrinsicType(128 /* BooleanLiteral */, "false");
	        var booleanType = createBooleanType([trueType, falseType]);
	        var esSymbolType = createIntrinsicType(512 /* ESSymbol */, "symbol");
	        var voidType = createIntrinsicType(2048 /* Void */, "void");
	        var neverType = createIntrinsicType(16384 /* Never */, "never");
	        var silentNeverType = createIntrinsicType(16384 /* Never */, "never");
	        var implicitNeverType = createIntrinsicType(16384 /* Never */, "never");
	        var nonPrimitiveType = createIntrinsicType(134217728 /* NonPrimitive */, "object");
	        var stringNumberSymbolType = getUnionType([stringType, numberType, esSymbolType]);
	        var keyofConstraintType = keyofStringsOnly ? stringType : stringNumberSymbolType;
	        var emptyObjectType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var emptyTypeLiteralSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	        emptyTypeLiteralSymbol.members = ts.createSymbolTable();
	        var emptyTypeLiteralType = createAnonymousType(emptyTypeLiteralSymbol, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var emptyGenericType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        emptyGenericType.instantiations = ts.createMap();
	        var anyFunctionType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        // The anyFunctionType contains the anyFunctionType by definition. The flag is further propagated
	        // in getPropagatingFlagsOfTypes, and it is checked in inferFromTypes.
	        anyFunctionType.flags |= 67108864 /* ContainsAnyFunctionType */;
	        var noConstraintType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var circularConstraintType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var resolvingDefaultType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	        var markerSuperType = createType(32768 /* TypeParameter */);
	        var markerSubType = createType(32768 /* TypeParameter */);
	        markerSubType.constraint = markerSuperType;
	        var markerOtherType = createType(32768 /* TypeParameter */);
	        var noTypePredicate = createIdentifierTypePredicate("<<unresolved>>", 0, anyType);
	        var anySignature = createSignature(undefined, undefined, undefined, ts.emptyArray, anyType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var unknownSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, unknownType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var resolvingSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, anyType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var silentNeverSignature = createSignature(undefined, undefined, undefined, ts.emptyArray, silentNeverType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	        var resolvingSignaturesArray = [resolvingSignature];
	        var enumNumberIndexInfo = createIndexInfo(stringType, /*isReadonly*/ true);
	        var jsObjectLiteralIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	        var globals = ts.createSymbolTable();
	        var reverseMappedCache = ts.createMap();
	        var ambientModulesCache;
	        /**
	         * List of every ambient module with a "*" wildcard.
	         * Unlike other ambient modules, these can't be stored in `globals` because symbol tables only deal with exact matches.
	         * This is only used if there is no exact match.
	         */
	        var patternAmbientModules;
	        var globalObjectType;
	        var globalFunctionType;
	        var globalArrayType;
	        var globalReadonlyArrayType;
	        var globalStringType;
	        var globalNumberType;
	        var globalBooleanType;
	        var globalRegExpType;
	        var globalThisType;
	        var anyArrayType;
	        var autoArrayType;
	        var anyReadonlyArrayType;
	        var deferredGlobalNonNullableTypeAlias;
	        // The library files are only loaded when the feature is used.
	        // This allows users to just specify library files they want to used through --lib
	        // and they will not get an error from not having unrelated library files
	        var deferredGlobalESSymbolConstructorSymbol;
	        var deferredGlobalESSymbolType;
	        var deferredGlobalTypedPropertyDescriptorType;
	        var deferredGlobalPromiseType;
	        var deferredGlobalPromiseConstructorSymbol;
	        var deferredGlobalPromiseConstructorLikeType;
	        var deferredGlobalIterableType;
	        var deferredGlobalIteratorType;
	        var deferredGlobalIterableIteratorType;
	        var deferredGlobalAsyncIterableType;
	        var deferredGlobalAsyncIteratorType;
	        var deferredGlobalAsyncIterableIteratorType;
	        var deferredGlobalTemplateStringsArrayType;
	        var deferredGlobalImportMetaType;
	        var deferredGlobalExtractSymbol;
	        var deferredNodes;
	        var allPotentiallyUnusedIdentifiers = ts.createMap(); // key is file name
	        var flowLoopStart = 0;
	        var flowLoopCount = 0;
	        var sharedFlowCount = 0;
	        var flowAnalysisDisabled = false;
	        var emptyStringType = getLiteralType("");
	        var zeroType = getLiteralType(0);
	        var resolutionTargets = [];
	        var resolutionResults = [];
	        var resolutionPropertyNames = [];
	        var suggestionCount = 0;
	        var maximumSuggestionCount = 10;
	        var mergedSymbols = [];
	        var symbolLinks = [];
	        var nodeLinks = [];
	        var flowLoopCaches = [];
	        var flowLoopNodes = [];
	        var flowLoopKeys = [];
	        var flowLoopTypes = [];
	        var sharedFlowNodes = [];
	        var sharedFlowTypes = [];
	        var potentialThisCollisions = [];
	        var potentialNewTargetCollisions = [];
	        var awaitedTypeStack = [];
	        var diagnostics = ts.createDiagnosticCollection();
	        // Suggestion diagnostics must have a file. Keyed by source file name.
	        var suggestionDiagnostics = ts.createMultiMap();
	        var TypeFacts;
	        (function (TypeFacts) {
	            TypeFacts[TypeFacts["None"] = 0] = "None";
	            TypeFacts[TypeFacts["TypeofEQString"] = 1] = "TypeofEQString";
	            TypeFacts[TypeFacts["TypeofEQNumber"] = 2] = "TypeofEQNumber";
	            TypeFacts[TypeFacts["TypeofEQBoolean"] = 4] = "TypeofEQBoolean";
	            TypeFacts[TypeFacts["TypeofEQSymbol"] = 8] = "TypeofEQSymbol";
	            TypeFacts[TypeFacts["TypeofEQObject"] = 16] = "TypeofEQObject";
	            TypeFacts[TypeFacts["TypeofEQFunction"] = 32] = "TypeofEQFunction";
	            TypeFacts[TypeFacts["TypeofEQHostObject"] = 64] = "TypeofEQHostObject";
	            TypeFacts[TypeFacts["TypeofNEString"] = 128] = "TypeofNEString";
	            TypeFacts[TypeFacts["TypeofNENumber"] = 256] = "TypeofNENumber";
	            TypeFacts[TypeFacts["TypeofNEBoolean"] = 512] = "TypeofNEBoolean";
	            TypeFacts[TypeFacts["TypeofNESymbol"] = 1024] = "TypeofNESymbol";
	            TypeFacts[TypeFacts["TypeofNEObject"] = 2048] = "TypeofNEObject";
	            TypeFacts[TypeFacts["TypeofNEFunction"] = 4096] = "TypeofNEFunction";
	            TypeFacts[TypeFacts["TypeofNEHostObject"] = 8192] = "TypeofNEHostObject";
	            TypeFacts[TypeFacts["EQUndefined"] = 16384] = "EQUndefined";
	            TypeFacts[TypeFacts["EQNull"] = 32768] = "EQNull";
	            TypeFacts[TypeFacts["EQUndefinedOrNull"] = 65536] = "EQUndefinedOrNull";
	            TypeFacts[TypeFacts["NEUndefined"] = 131072] = "NEUndefined";
	            TypeFacts[TypeFacts["NENull"] = 262144] = "NENull";
	            TypeFacts[TypeFacts["NEUndefinedOrNull"] = 524288] = "NEUndefinedOrNull";
	            TypeFacts[TypeFacts["Truthy"] = 1048576] = "Truthy";
	            TypeFacts[TypeFacts["Falsy"] = 2097152] = "Falsy";
	            TypeFacts[TypeFacts["All"] = 4194303] = "All";
	            // The following members encode facts about particular kinds of types for use in the getTypeFacts function.
	            // The presence of a particular fact means that the given test is true for some (and possibly all) values
	            // of that kind of type.
	            TypeFacts[TypeFacts["BaseStringStrictFacts"] = 933633] = "BaseStringStrictFacts";
	            TypeFacts[TypeFacts["BaseStringFacts"] = 3145473] = "BaseStringFacts";
	            TypeFacts[TypeFacts["StringStrictFacts"] = 4079361] = "StringStrictFacts";
	            TypeFacts[TypeFacts["StringFacts"] = 4194049] = "StringFacts";
	            TypeFacts[TypeFacts["EmptyStringStrictFacts"] = 3030785] = "EmptyStringStrictFacts";
	            TypeFacts[TypeFacts["EmptyStringFacts"] = 3145473] = "EmptyStringFacts";
	            TypeFacts[TypeFacts["NonEmptyStringStrictFacts"] = 1982209] = "NonEmptyStringStrictFacts";
	            TypeFacts[TypeFacts["NonEmptyStringFacts"] = 4194049] = "NonEmptyStringFacts";
	            TypeFacts[TypeFacts["BaseNumberStrictFacts"] = 933506] = "BaseNumberStrictFacts";
	            TypeFacts[TypeFacts["BaseNumberFacts"] = 3145346] = "BaseNumberFacts";
	            TypeFacts[TypeFacts["NumberStrictFacts"] = 4079234] = "NumberStrictFacts";
	            TypeFacts[TypeFacts["NumberFacts"] = 4193922] = "NumberFacts";
	            TypeFacts[TypeFacts["ZeroStrictFacts"] = 3030658] = "ZeroStrictFacts";
	            TypeFacts[TypeFacts["ZeroFacts"] = 3145346] = "ZeroFacts";
	            TypeFacts[TypeFacts["NonZeroStrictFacts"] = 1982082] = "NonZeroStrictFacts";
	            TypeFacts[TypeFacts["NonZeroFacts"] = 4193922] = "NonZeroFacts";
	            TypeFacts[TypeFacts["BaseBooleanStrictFacts"] = 933252] = "BaseBooleanStrictFacts";
	            TypeFacts[TypeFacts["BaseBooleanFacts"] = 3145092] = "BaseBooleanFacts";
	            TypeFacts[TypeFacts["BooleanStrictFacts"] = 4078980] = "BooleanStrictFacts";
	            TypeFacts[TypeFacts["BooleanFacts"] = 4193668] = "BooleanFacts";
	            TypeFacts[TypeFacts["FalseStrictFacts"] = 3030404] = "FalseStrictFacts";
	            TypeFacts[TypeFacts["FalseFacts"] = 3145092] = "FalseFacts";
	            TypeFacts[TypeFacts["TrueStrictFacts"] = 1981828] = "TrueStrictFacts";
	            TypeFacts[TypeFacts["TrueFacts"] = 4193668] = "TrueFacts";
	            TypeFacts[TypeFacts["SymbolStrictFacts"] = 1981320] = "SymbolStrictFacts";
	            TypeFacts[TypeFacts["SymbolFacts"] = 4193160] = "SymbolFacts";
	            TypeFacts[TypeFacts["ObjectStrictFacts"] = 1972176] = "ObjectStrictFacts";
	            TypeFacts[TypeFacts["ObjectFacts"] = 4184016] = "ObjectFacts";
	            TypeFacts[TypeFacts["FunctionStrictFacts"] = 1970144] = "FunctionStrictFacts";
	            TypeFacts[TypeFacts["FunctionFacts"] = 4181984] = "FunctionFacts";
	            TypeFacts[TypeFacts["UndefinedFacts"] = 2457472] = "UndefinedFacts";
	            TypeFacts[TypeFacts["NullFacts"] = 2340752] = "NullFacts";
	        })(TypeFacts || (TypeFacts = {}));
	        var typeofEQFacts = ts.createMapFromTemplate({
	            string: 1 /* TypeofEQString */,
	            number: 2 /* TypeofEQNumber */,
	            boolean: 4 /* TypeofEQBoolean */,
	            symbol: 8 /* TypeofEQSymbol */,
	            undefined: 16384 /* EQUndefined */,
	            object: 16 /* TypeofEQObject */,
	            function: 32 /* TypeofEQFunction */
	        });
	        var typeofNEFacts = ts.createMapFromTemplate({
	            string: 128 /* TypeofNEString */,
	            number: 256 /* TypeofNENumber */,
	            boolean: 512 /* TypeofNEBoolean */,
	            symbol: 1024 /* TypeofNESymbol */,
	            undefined: 131072 /* NEUndefined */,
	            object: 2048 /* TypeofNEObject */,
	            function: 4096 /* TypeofNEFunction */
	        });
	        var typeofTypesByName = ts.createMapFromTemplate({
	            string: stringType,
	            number: numberType,
	            boolean: booleanType,
	            symbol: esSymbolType,
	            undefined: undefinedType
	        });
	        var typeofType = createTypeofType();
	        var _jsxNamespace;
	        var _jsxFactoryEntity;
	        var subtypeRelation = ts.createMap();
	        var assignableRelation = ts.createMap();
	        var definitelyAssignableRelation = ts.createMap();
	        var comparableRelation = ts.createMap();
	        var identityRelation = ts.createMap();
	        var enumRelation = ts.createMap();
	        var TypeSystemPropertyName;
	        (function (TypeSystemPropertyName) {
	            TypeSystemPropertyName[TypeSystemPropertyName["Type"] = 0] = "Type";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedBaseConstructorType"] = 1] = "ResolvedBaseConstructorType";
	            TypeSystemPropertyName[TypeSystemPropertyName["DeclaredType"] = 2] = "DeclaredType";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedReturnType"] = 3] = "ResolvedReturnType";
	            TypeSystemPropertyName[TypeSystemPropertyName["ResolvedBaseConstraint"] = 4] = "ResolvedBaseConstraint";
	        })(TypeSystemPropertyName || (TypeSystemPropertyName = {}));
	        var CheckMode;
	        (function (CheckMode) {
	            CheckMode[CheckMode["Normal"] = 0] = "Normal";
	            CheckMode[CheckMode["SkipContextSensitive"] = 1] = "SkipContextSensitive";
	            CheckMode[CheckMode["Inferential"] = 2] = "Inferential";
	            CheckMode[CheckMode["Contextual"] = 3] = "Contextual";
	        })(CheckMode || (CheckMode = {}));
	        var CallbackCheck;
	        (function (CallbackCheck) {
	            CallbackCheck[CallbackCheck["None"] = 0] = "None";
	            CallbackCheck[CallbackCheck["Bivariant"] = 1] = "Bivariant";
	            CallbackCheck[CallbackCheck["Strict"] = 2] = "Strict";
	        })(CallbackCheck || (CallbackCheck = {}));
	        var MappedTypeModifiers;
	        (function (MappedTypeModifiers) {
	            MappedTypeModifiers[MappedTypeModifiers["IncludeReadonly"] = 1] = "IncludeReadonly";
	            MappedTypeModifiers[MappedTypeModifiers["ExcludeReadonly"] = 2] = "ExcludeReadonly";
	            MappedTypeModifiers[MappedTypeModifiers["IncludeOptional"] = 4] = "IncludeOptional";
	            MappedTypeModifiers[MappedTypeModifiers["ExcludeOptional"] = 8] = "ExcludeOptional";
	        })(MappedTypeModifiers || (MappedTypeModifiers = {}));
	        var ExpandingFlags;
	        (function (ExpandingFlags) {
	            ExpandingFlags[ExpandingFlags["None"] = 0] = "None";
	            ExpandingFlags[ExpandingFlags["Source"] = 1] = "Source";
	            ExpandingFlags[ExpandingFlags["Target"] = 2] = "Target";
	            ExpandingFlags[ExpandingFlags["Both"] = 3] = "Both";
	        })(ExpandingFlags || (ExpandingFlags = {}));
	        var MembersOrExportsResolutionKind;
	        (function (MembersOrExportsResolutionKind) {
	            MembersOrExportsResolutionKind["resolvedExports"] = "resolvedExports";
	            MembersOrExportsResolutionKind["resolvedMembers"] = "resolvedMembers";
	        })(MembersOrExportsResolutionKind || (MembersOrExportsResolutionKind = {}));
	        var UnusedKind;
	        (function (UnusedKind) {
	            UnusedKind[UnusedKind["Local"] = 0] = "Local";
	            UnusedKind[UnusedKind["Parameter"] = 1] = "Parameter";
	        })(UnusedKind || (UnusedKind = {}));
	        var builtinGlobals = ts.createSymbolTable();
	        builtinGlobals.set(undefinedSymbol.escapedName, undefinedSymbol);
	        var isNotOverloadAndNotAccessor = ts.and(isNotOverload, isNotAccessor);
	        initializeTypeChecker();
	        return checker;
	        /**
	         * @deprecated
	         */
	        function getSymbolDisplayBuilder() {
	            return {
	                buildTypeDisplay: function (type, writer, enclosingDeclaration, flags) {
	                    typeToString(type, enclosingDeclaration, flags, emitTextWriterWrapper(writer));
	                },
	                buildSymbolDisplay: function (symbol, writer, enclosingDeclaration, meaning, flags) {
	                    symbolToString(symbol, enclosingDeclaration, meaning, flags | 4 /* AllowAnyNodeKind */, emitTextWriterWrapper(writer));
	                },
	                buildSignatureDisplay: function (signature, writer, enclosing, flags, kind) {
	                    signatureToString(signature, enclosing, flags, kind, emitTextWriterWrapper(writer));
	                },
	                buildIndexSignatureDisplay: function (info, writer, kind, enclosing, flags) {
	                    var sig = nodeBuilder.indexInfoToIndexSignatureDeclaration(info, kind, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, sig, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildParameterDisplay: function (symbol, writer, enclosing, flags) {
	                    var node = nodeBuilder.symbolToParameterDeclaration(symbol, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildTypeParameterDisplay: function (tp, writer, enclosing, flags) {
	                    var node = nodeBuilder.typeParameterToDeclaration(tp, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 8192 /* OmitParameterModifiers */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildTypePredicateDisplay: function (predicate, writer, enclosing, flags) {
	                    typePredicateToString(predicate, enclosing, flags, emitTextWriterWrapper(writer));
	                },
	                buildTypeParameterDisplayFromSymbol: function (symbol, writer, enclosing, flags) {
	                    var nodes = nodeBuilder.symbolToTypeParameterDeclarations(symbol, enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeList(26896 /* TypeParameters */, nodes, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildDisplayForParametersAndDelimiters: function (thisParameter, parameters, writer, enclosing, originalFlags) {
	                    var printer = ts.createPrinter({ removeComments: true });
	                    var flags = 8192 /* OmitParameterModifiers */ | 3112960 /* IgnoreErrors */ | toNodeBuilderFlags(originalFlags);
	                    var thisParameterArray = thisParameter ? [nodeBuilder.symbolToParameterDeclaration(thisParameter, enclosing, flags)] : [];
	                    var params = ts.createNodeArray(thisParameterArray.concat(ts.map(parameters, function (param) { return nodeBuilder.symbolToParameterDeclaration(param, enclosing, flags); })));
	                    printer.writeList(1296 /* CallExpressionArguments */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildDisplayForTypeParametersAndDelimiters: function (typeParameters, writer, enclosing, flags) {
	                    var printer = ts.createPrinter({ removeComments: true });
	                    var args = ts.createNodeArray(ts.map(typeParameters, function (p) { return nodeBuilder.typeParameterToDeclaration(p, enclosing, toNodeBuilderFlags(flags)); }));
	                    printer.writeList(26896 /* TypeParameters */, args, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                },
	                buildReturnTypeDisplay: function (signature, writer, enclosing, flags) {
	                    writer.writePunctuation(":");
	                    writer.writeSpace(" ");
	                    var predicate = getTypePredicateOfSignature(signature);
	                    if (predicate) {
	                        return typePredicateToString(predicate, enclosing, flags, emitTextWriterWrapper(writer));
	                    }
	                    var node = nodeBuilder.typeToTypeNode(getReturnTypeOfSignature(signature), enclosing, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	                    var printer = ts.createPrinter({ removeComments: true });
	                    printer.writeNode(4 /* Unspecified */, node, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosing)), emitTextWriterWrapper(writer));
	                }
	            };
	            function emitTextWriterWrapper(underlying) {
	                return {
	                    write: ts.noop,
	                    writeTextOfNode: ts.noop,
	                    writeLine: ts.noop,
	                    increaseIndent: function () {
	                        return underlying.increaseIndent();
	                    },
	                    decreaseIndent: function () {
	                        return underlying.decreaseIndent();
	                    },
	                    getText: function () {
	                        return "";
	                    },
	                    rawWrite: ts.noop,
	                    writeLiteral: function (s) {
	                        return underlying.writeStringLiteral(s);
	                    },
	                    getTextPos: function () {
	                        return 0;
	                    },
	                    getLine: function () {
	                        return 0;
	                    },
	                    getColumn: function () {
	                        return 0;
	                    },
	                    getIndent: function () {
	                        return 0;
	                    },
	                    isAtStartOfLine: function () {
	                        return false;
	                    },
	                    clear: function () {
	                        return underlying.clear();
	                    },
	                    writeKeyword: function (text) {
	                        return underlying.writeKeyword(text);
	                    },
	                    writeOperator: function (text) {
	                        return underlying.writeOperator(text);
	                    },
	                    writePunctuation: function (text) {
	                        return underlying.writePunctuation(text);
	                    },
	                    writeSpace: function (text) {
	                        return underlying.writeSpace(text);
	                    },
	                    writeStringLiteral: function (text) {
	                        return underlying.writeStringLiteral(text);
	                    },
	                    writeParameter: function (text) {
	                        return underlying.writeParameter(text);
	                    },
	                    writeProperty: function (text) {
	                        return underlying.writeProperty(text);
	                    },
	                    writeSymbol: function (text, symbol) {
	                        return underlying.writeSymbol(text, symbol);
	                    },
	                    trackSymbol: function (symbol, enclosing, meaning) {
	                        return underlying.trackSymbol && underlying.trackSymbol(symbol, enclosing, meaning);
	                    },
	                    reportInaccessibleThisError: function () {
	                        return underlying.reportInaccessibleThisError && underlying.reportInaccessibleThisError();
	                    },
	                    reportPrivateInBaseOfClassExpression: function (name) {
	                        return underlying.reportPrivateInBaseOfClassExpression && underlying.reportPrivateInBaseOfClassExpression(name);
	                    },
	                    reportInaccessibleUniqueSymbolError: function () {
	                        return underlying.reportInaccessibleUniqueSymbolError && underlying.reportInaccessibleUniqueSymbolError();
	                    }
	                };
	            }
	        }
	        function getJsxNamespace(location) {
	            if (location) {
	                var file_1 = ts.getSourceFileOfNode(location);
	                if (file_1) {
	                    if (file_1.localJsxNamespace) {
	                        return file_1.localJsxNamespace;
	                    }
	                    var jsxPragma = file_1.pragmas.get("jsx");
	                    if (jsxPragma) {
	                        var chosenpragma = ts.isArray(jsxPragma) ? jsxPragma[0] : jsxPragma;
	                        file_1.localJsxFactory = ts.parseIsolatedEntityName(chosenpragma.arguments.factory, languageVersion);
	                        if (file_1.localJsxFactory) {
	                            return file_1.localJsxNamespace = getFirstIdentifier(file_1.localJsxFactory).escapedText;
	                        }
	                    }
	                }
	            }
	            if (!_jsxNamespace) {
	                _jsxNamespace = "React";
	                if (compilerOptions.jsxFactory) {
	                    _jsxFactoryEntity = ts.parseIsolatedEntityName(compilerOptions.jsxFactory, languageVersion);
	                    if (_jsxFactoryEntity) {
	                        _jsxNamespace = getFirstIdentifier(_jsxFactoryEntity).escapedText;
	                    }
	                }
	                else if (compilerOptions.reactNamespace) {
	                    _jsxNamespace = ts.escapeLeadingUnderscores(compilerOptions.reactNamespace);
	                }
	            }
	            return _jsxNamespace;
	        }
	        function getEmitResolver(sourceFile, cancellationToken) {
	            // Ensure we have all the type information in place for this file so that all the
	            // emitter questions of this resolver will return the right information.
	            getDiagnostics(sourceFile, cancellationToken);
	            return emitResolver;
	        }
	        function error(location, message, arg0, arg1, arg2, arg3) {
	            var diagnostic = location
	                ? ts.createDiagnosticForNode(location, message, arg0, arg1, arg2, arg3)
	                : ts.createCompilerDiagnostic(message, arg0, arg1, arg2, arg3);
	            diagnostics.add(diagnostic);
	        }
	        function addErrorOrSuggestion(isError, diagnostic) {
	            if (isError) {
	                diagnostics.add(diagnostic);
	            }
	            else {
	                suggestionDiagnostics.add(diagnostic.file.fileName, __assign({}, diagnostic, { category: ts.DiagnosticCategory.Suggestion }));
	            }
	        }
	        function errorOrSuggestion(isError, location, message, arg0, arg1, arg2, arg3) {
	            addErrorOrSuggestion(isError, "message" in message ? ts.createDiagnosticForNode(location, message, arg0, arg1, arg2, arg3) : ts.createDiagnosticForNodeFromMessageChain(location, message));
	        }
	        function createSymbol(flags, name, checkFlags) {
	            symbolCount++;
	            var symbol = (new Symbol(flags | 33554432 /* Transient */, name));
	            symbol.checkFlags = checkFlags || 0;
	            return symbol;
	        }
	        function isTransientSymbol(symbol) {
	            return (symbol.flags & 33554432 /* Transient */) !== 0;
	        }
	        function getExcludedSymbolFlags(flags) {
	            var result = 0;
	            if (flags & 2 /* BlockScopedVariable */)
	                result |= 67216319 /* BlockScopedVariableExcludes */;
	            if (flags & 1 /* FunctionScopedVariable */)
	                result |= 67216318 /* FunctionScopedVariableExcludes */;
	            if (flags & 4 /* Property */)
	                result |= 0 /* PropertyExcludes */;
	            if (flags & 8 /* EnumMember */)
	                result |= 68008959 /* EnumMemberExcludes */;
	            if (flags & 16 /* Function */)
	                result |= 67215791 /* FunctionExcludes */;
	            if (flags & 32 /* Class */)
	                result |= 68008383 /* ClassExcludes */;
	            if (flags & 64 /* Interface */)
	                result |= 67901832 /* InterfaceExcludes */;
	            if (flags & 256 /* RegularEnum */)
	                result |= 68008191 /* RegularEnumExcludes */;
	            if (flags & 128 /* ConstEnum */)
	                result |= 68008831 /* ConstEnumExcludes */;
	            if (flags & 512 /* ValueModule */)
	                result |= 67215503 /* ValueModuleExcludes */;
	            if (flags & 8192 /* Method */)
	                result |= 67208127 /* MethodExcludes */;
	            if (flags & 32768 /* GetAccessor */)
	                result |= 67150783 /* GetAccessorExcludes */;
	            if (flags & 65536 /* SetAccessor */)
	                result |= 67183551 /* SetAccessorExcludes */;
	            if (flags & 262144 /* TypeParameter */)
	                result |= 67639784 /* TypeParameterExcludes */;
	            if (flags & 524288 /* TypeAlias */)
	                result |= 67901928 /* TypeAliasExcludes */;
	            if (flags & 2097152 /* Alias */)
	                result |= 2097152 /* AliasExcludes */;
	            return result;
	        }
	        function recordMergedSymbol(target, source) {
	            if (!source.mergeId) {
	                source.mergeId = nextMergeId;
	                nextMergeId++;
	            }
	            mergedSymbols[source.mergeId] = target;
	        }
	        function cloneSymbol(symbol) {
	            var result = createSymbol(symbol.flags, symbol.escapedName);
	            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
	            result.parent = symbol.parent;
	            if (symbol.valueDeclaration)
	                result.valueDeclaration = symbol.valueDeclaration;
	            if (symbol.constEnumOnlyModule)
	                result.constEnumOnlyModule = true;
	            if (symbol.members)
	                result.members = ts.cloneMap(symbol.members);
	            if (symbol.exports)
	                result.exports = ts.cloneMap(symbol.exports);
	            recordMergedSymbol(result, symbol);
	            return result;
	        }
	        function mergeSymbol(target, source) {
	            if (!(target.flags & getExcludedSymbolFlags(source.flags)) ||
	                (source.flags | target.flags) & 67108864 /* JSContainer */) {
	                var targetValueDeclaration = target.valueDeclaration;
	                ts.Debug.assert(!!(target.flags & 33554432 /* Transient */));
	                // Javascript static-property-assignment declarations always merge, even though they are also values
	                if (source.flags & 512 /* ValueModule */ && target.flags & 512 /* ValueModule */ && target.constEnumOnlyModule && !source.constEnumOnlyModule) {
	                    // reset flag when merging instantiated module into value module that has only const enums
	                    target.constEnumOnlyModule = false;
	                }
	                target.flags |= source.flags;
	                if (source.valueDeclaration &&
	                    (!target.valueDeclaration ||
	                        (target.valueDeclaration.kind === 238 /* ModuleDeclaration */ && source.valueDeclaration.kind !== 238 /* ModuleDeclaration */))) {
	                    // other kinds of value declarations take precedence over modules
	                    target.valueDeclaration = source.valueDeclaration;
	                }
	                ts.addRange(target.declarations, source.declarations);
	                if (source.members) {
	                    if (!target.members)
	                        target.members = ts.createSymbolTable();
	                    mergeSymbolTable(target.members, source.members);
	                }
	                if (source.exports) {
	                    if (!target.exports)
	                        target.exports = ts.createSymbolTable();
	                    mergeSymbolTable(target.exports, source.exports);
	                }
	                if ((source.flags | target.flags) & 67108864 /* JSContainer */) {
	                    var sourceInitializer = ts.getJSInitializerSymbol(source);
	                    var init = ts.getDeclaredJavascriptInitializer(targetValueDeclaration) || ts.getAssignedJavascriptInitializer(targetValueDeclaration);
	                    var targetInitializer = init && init.symbol ? init.symbol : target;
	                    if (!(targetInitializer.flags & 33554432 /* Transient */)) {
	                        var mergedInitializer = getMergedSymbol(targetInitializer);
	                        targetInitializer = mergedInitializer === targetInitializer ? cloneSymbol(targetInitializer) : mergedInitializer;
	                    }
	                    if (sourceInitializer !== source || targetInitializer !== target) {
	                        mergeSymbol(targetInitializer, sourceInitializer);
	                    }
	                }
	                recordMergedSymbol(target, source);
	            }
	            else if (target.flags & 1024 /* NamespaceModule */) {
	                error(ts.getNameOfDeclaration(source.declarations[0]), ts.Diagnostics.Cannot_augment_module_0_with_value_exports_because_it_resolves_to_a_non_module_entity, symbolToString(target));
	            }
	            else {
	                var message_2 = target.flags & 384 /* Enum */ || source.flags & 384 /* Enum */
	                    ? ts.Diagnostics.Enum_declarations_can_only_merge_with_namespace_or_other_enum_declarations
	                    : target.flags & 2 /* BlockScopedVariable */ || source.flags & 2 /* BlockScopedVariable */
	                        ? ts.Diagnostics.Cannot_redeclare_block_scoped_variable_0
	                        : ts.Diagnostics.Duplicate_identifier_0;
	                ts.forEach(source.declarations, function (node) {
	                    var errorNode = (ts.getJavascriptInitializer(node, /*isPrototypeAssignment*/ false) ? ts.getOuterNameOfJsInitializer(node) : ts.getNameOfDeclaration(node)) || node;
	                    error(errorNode, message_2, symbolToString(source));
	                });
	                ts.forEach(target.declarations, function (node) {
	                    var errorNode = (ts.getJavascriptInitializer(node, /*isPrototypeAssignment*/ false) ? ts.getOuterNameOfJsInitializer(node) : ts.getNameOfDeclaration(node)) || node;
	                    error(errorNode, message_2, symbolToString(source));
	                });
	            }
	        }
	        function combineSymbolTables(first, second) {
	            if (!first || first.size === 0)
	                return second;
	            if (!second || second.size === 0)
	                return first;
	            var combined = ts.createSymbolTable();
	            mergeSymbolTable(combined, first);
	            mergeSymbolTable(combined, second);
	            return combined;
	        }
	        function mergeSymbolTable(target, source) {
	            source.forEach(function (sourceSymbol, id) {
	                var targetSymbol = target.get(id);
	                if (!targetSymbol) {
	                    target.set(id, sourceSymbol);
	                }
	                else {
	                    if (!(targetSymbol.flags & 33554432 /* Transient */)) {
	                        targetSymbol = cloneSymbol(targetSymbol);
	                        target.set(id, targetSymbol);
	                    }
	                    mergeSymbol(targetSymbol, sourceSymbol);
	                }
	            });
	        }
	        function mergeModuleAugmentation(moduleName) {
	            var moduleAugmentation = moduleName.parent;
	            if (moduleAugmentation.symbol.declarations[0] !== moduleAugmentation) {
	                // this is a combined symbol for multiple augmentations within the same file.
	                // its symbol already has accumulated information for all declarations
	                // so we need to add it just once - do the work only for first declaration
	                ts.Debug.assert(moduleAugmentation.symbol.declarations.length > 1);
	                return;
	            }
	            if (ts.isGlobalScopeAugmentation(moduleAugmentation)) {
	                mergeSymbolTable(globals, moduleAugmentation.symbol.exports);
	            }
	            else {
	                // find a module that about to be augmented
	                // do not validate names of augmentations that are defined in ambient context
	                var moduleNotFoundError = !(moduleName.parent.parent.flags & 4194304 /* Ambient */)
	                    ? ts.Diagnostics.Invalid_module_name_in_augmentation_module_0_cannot_be_found
	                    : undefined;
	                var mainModule = resolveExternalModuleNameWorker(moduleName, moduleName, moduleNotFoundError, /*isForAugmentation*/ true);
	                if (!mainModule) {
	                    return;
	                }
	                // obtain item referenced by 'export='
	                mainModule = resolveExternalModuleSymbol(mainModule);
	                if (mainModule.flags & 1920 /* Namespace */) {
	                    // if module symbol has already been merged - it is safe to use it.
	                    // otherwise clone it
	                    mainModule = mainModule.flags & 33554432 /* Transient */ ? mainModule : cloneSymbol(mainModule);
	                    mergeSymbol(mainModule, moduleAugmentation.symbol);
	                }
	                else {
	                    // moduleName will be a StringLiteral since this is not `declare global`.
	                    error(moduleName, ts.Diagnostics.Cannot_augment_module_0_because_it_resolves_to_a_non_module_entity, moduleName.text);
	                }
	            }
	        }
	        function addToSymbolTable(target, source, message) {
	            source.forEach(function (sourceSymbol, id) {
	                var targetSymbol = target.get(id);
	                if (targetSymbol) {
	                    // Error on redeclarations
	                    ts.forEach(targetSymbol.declarations, addDeclarationDiagnostic(ts.unescapeLeadingUnderscores(id), message));
	                }
	                else {
	                    target.set(id, sourceSymbol);
	                }
	            });
	            function addDeclarationDiagnostic(id, message) {
	                return function (declaration) { return diagnostics.add(ts.createDiagnosticForNode(declaration, message, id)); };
	            }
	        }
	        function getSymbolLinks(symbol) {
	            if (symbol.flags & 33554432 /* Transient */)
	                return symbol;
	            var id = getSymbolId(symbol);
	            return symbolLinks[id] || (symbolLinks[id] = {});
	        }
	        function getNodeLinks(node) {
	            var nodeId = getNodeId(node);
	            return nodeLinks[nodeId] || (nodeLinks[nodeId] = { flags: 0 });
	        }
	        function isGlobalSourceFile(node) {
	            return node.kind === 273 /* SourceFile */ && !ts.isExternalOrCommonJsModule(node);
	        }
	        function getSymbol(symbols, name, meaning) {
	            if (meaning) {
	                var symbol = symbols.get(name);
	                if (symbol) {
	                    ts.Debug.assert((ts.getCheckFlags(symbol) & 1 /* Instantiated */) === 0, "Should never get an instantiated symbol here.");
	                    if (symbol.flags & meaning) {
	                        return symbol;
	                    }
	                    if (symbol.flags & 2097152 /* Alias */) {
	                        var target = resolveAlias(symbol);
	                        // Unknown symbol means an error occurred in alias resolution, treat it as positive answer to avoid cascading errors
	                        if (target === unknownSymbol || target.flags & meaning) {
	                            return symbol;
	                        }
	                    }
	                }
	            }
	            // return undefined if we can't find a symbol.
	        }
	        /**
	         * Get symbols that represent parameter-property-declaration as parameter and as property declaration
	         * @param parameter a parameterDeclaration node
	         * @param parameterName a name of the parameter to get the symbols for.
	         * @return a tuple of two symbols
	         */
	        function getSymbolsOfParameterPropertyDeclaration(parameter, parameterName) {
	            var constructorDeclaration = parameter.parent;
	            var classDeclaration = parameter.parent.parent;
	            var parameterSymbol = getSymbol(constructorDeclaration.locals, parameterName, 67216319 /* Value */);
	            var propertySymbol = getSymbol(getMembersOfSymbol(classDeclaration.symbol), parameterName, 67216319 /* Value */);
	            if (parameterSymbol && propertySymbol) {
	                return [parameterSymbol, propertySymbol];
	            }
	            ts.Debug.fail("There should exist two symbols, one as property declaration and one as parameter declaration");
	        }
	        function isBlockScopedNameDeclaredBeforeUse(declaration, usage) {
	            var declarationFile = ts.getSourceFileOfNode(declaration);
	            var useFile = ts.getSourceFileOfNode(usage);
	            if (declarationFile !== useFile) {
	                if ((moduleKind && (declarationFile.externalModuleIndicator || useFile.externalModuleIndicator)) ||
	                    (!compilerOptions.outFile && !compilerOptions.out) ||
	                    isInTypeQuery(usage) ||
	                    declaration.flags & 4194304 /* Ambient */) {
	                    // nodes are in different files and order cannot be determined
	                    return true;
	                }
	                // declaration is after usage
	                // can be legal if usage is deferred (i.e. inside function or in initializer of instance property)
	                if (isUsedInFunctionOrInstanceProperty(usage, declaration)) {
	                    return true;
	                }
	                var sourceFiles = host.getSourceFiles();
	                return sourceFiles.indexOf(declarationFile) <= sourceFiles.indexOf(useFile);
	            }
	            if (declaration.pos <= usage.pos) {
	                // declaration is before usage
	                if (declaration.kind === 181 /* BindingElement */) {
	                    // still might be illegal if declaration and usage are both binding elements (eg var [a = b, b = b] = [1, 2])
	                    var errorBindingElement = ts.getAncestor(usage, 181 /* BindingElement */);
	                    if (errorBindingElement) {
	                        return ts.findAncestor(errorBindingElement, ts.isBindingElement) !== ts.findAncestor(declaration, ts.isBindingElement) ||
	                            declaration.pos < errorBindingElement.pos;
	                    }
	                    // or it might be illegal if usage happens before parent variable is declared (eg var [a] = a)
	                    return isBlockScopedNameDeclaredBeforeUse(ts.getAncestor(declaration, 231 /* VariableDeclaration */), usage);
	                }
	                else if (declaration.kind === 231 /* VariableDeclaration */) {
	                    // still might be illegal if usage is in the initializer of the variable declaration (eg var a = a)
	                    return !isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage);
	                }
	                else if (ts.isClassDeclaration(declaration)) {
	                    // still might be illegal if the usage is within a computed property name in the class (eg class A { static p = "a"; [A.p]() {} })
	                    return !ts.findAncestor(usage, function (n) { return ts.isComputedPropertyName(n) && n.parent.parent === declaration; });
	                }
	                return true;
	            }
	            // declaration is after usage, but it can still be legal if usage is deferred:
	            // 1. inside an export specifier
	            // 2. inside a function
	            // 3. inside an instance property initializer, a reference to a non-instance property
	            // 4. inside a static property initializer, a reference to a static method in the same class
	            // 5. inside a TS export= declaration (since we will move the export statement during emit to avoid TDZ)
	            // or if usage is in a type context:
	            // 1. inside a type query (typeof in type position)
	            if (usage.parent.kind === 251 /* ExportSpecifier */ || (usage.parent.kind === 248 /* ExportAssignment */ && usage.parent.isExportEquals)) {
	                // export specifiers do not use the variable, they only make it available for use
	                return true;
	            }
	            // When resolving symbols for exports, the `usage` location passed in can be the export site directly
	            if (usage.kind === 248 /* ExportAssignment */ && usage.isExportEquals) {
	                return true;
	            }
	            var container = ts.getEnclosingBlockScopeContainer(declaration);
	            return isInTypeQuery(usage) || isUsedInFunctionOrInstanceProperty(usage, declaration, container);
	            function isImmediatelyUsedInInitializerOfBlockScopedVariable(declaration, usage) {
	                var container = ts.getEnclosingBlockScopeContainer(declaration);
	                switch (declaration.parent.parent.kind) {
	                    case 213 /* VariableStatement */:
	                    case 219 /* ForStatement */:
	                    case 221 /* ForOfStatement */:
	                        // variable statement/for/for-of statement case,
	                        // use site should not be inside variable declaration (initializer of declaration or binding element)
	                        if (isSameScopeDescendentOf(usage, declaration, container)) {
	                            return true;
	                        }
	                        break;
	                }
	                // ForIn/ForOf case - use site should not be used in expression part
	                return ts.isForInOrOfStatement(declaration.parent.parent) && isSameScopeDescendentOf(usage, declaration.parent.parent.expression, container);
	            }
	            function isUsedInFunctionOrInstanceProperty(usage, declaration, container) {
	                return !!ts.findAncestor(usage, function (current) {
	                    if (current === container) {
	                        return "quit";
	                    }
	                    if (ts.isFunctionLike(current)) {
	                        return true;
	                    }
	                    var initializerOfProperty = current.parent &&
	                        current.parent.kind === 151 /* PropertyDeclaration */ &&
	                        current.parent.initializer === current;
	                    if (initializerOfProperty) {
	                        if (ts.hasModifier(current.parent, 32 /* Static */)) {
	                            if (declaration.kind === 153 /* MethodDeclaration */) {
	                                return true;
	                            }
	                        }
	                        else {
	                            var isDeclarationInstanceProperty = declaration.kind === 151 /* PropertyDeclaration */ && !ts.hasModifier(declaration, 32 /* Static */);
	                            if (!isDeclarationInstanceProperty || ts.getContainingClass(usage) !== ts.getContainingClass(declaration)) {
	                                return true;
	                            }
	                        }
	                    }
	                });
	            }
	        }
	        /**
	         * Resolve a given name for a given meaning at a given location. An error is reported if the name was not found and
	         * the nameNotFoundMessage argument is not undefined. Returns the resolved symbol, or undefined if no symbol with
	         * the given name can be found.
	         *
	         * @param isUse If true, this will count towards --noUnusedLocals / --noUnusedParameters.
	         */
	        function resolveName(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, suggestedNameNotFoundMessage) {
	            if (excludeGlobals === void 0) { excludeGlobals = false; }
	            return resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, getSymbol, suggestedNameNotFoundMessage);
	        }
	        function resolveNameHelper(location, name, meaning, nameNotFoundMessage, nameArg, isUse, excludeGlobals, lookup, suggestedNameNotFoundMessage) {
	            var originalLocation = location; // needed for did-you-mean error reporting, which gathers candidates starting from the original location
	            var result;
	            var lastLocation;
	            var lastSelfReferenceLocation;
	            var propertyWithInvalidInitializer;
	            var errorLocation = location;
	            var grandparent;
	            var isInExternalModule = false;
	            loop: while (location) {
	                // Locals of a source file are not in scope (because they get merged into the global symbol table)
	                if (location.locals && !isGlobalSourceFile(location)) {
	                    if (result = lookup(location.locals, name, meaning)) {
	                        var useResult = true;
	                        if (ts.isFunctionLike(location) && lastLocation && lastLocation !== location.body) {
	                            // symbol lookup restrictions for function-like declarations
	                            // - Type parameters of a function are in scope in the entire function declaration, including the parameter
	                            //   list and return type. However, local types are only in scope in the function body.
	                            // - parameters are only in the scope of function body
	                            // This restriction does not apply to JSDoc comment types because they are parented
	                            // at a higher level than type parameters would normally be
	                            if (meaning & result.flags & 67901928 /* Type */ && lastLocation.kind !== 285 /* JSDocComment */) {
	                                useResult = result.flags & 262144 /* TypeParameter */
	                                    // type parameters are visible in parameter list, return type and type parameter list
	                                    ? lastLocation === location.type ||
	                                        lastLocation.kind === 148 /* Parameter */ ||
	                                        lastLocation.kind === 147 /* TypeParameter */
	                                    // local types not visible outside the function body
	                                    : false;
	                            }
	                            if (meaning & 67216319 /* Value */ && result.flags & 1 /* FunctionScopedVariable */) {
	                                // parameters are visible only inside function body, parameter list and return type
	                                // technically for parameter list case here we might mix parameters and variables declared in function,
	                                // however it is detected separately when checking initializers of parameters
	                                // to make sure that they reference no variables declared after them.
	                                useResult =
	                                    lastLocation.kind === 148 /* Parameter */ ||
	                                        (lastLocation === location.type &&
	                                            !!ts.findAncestor(result.valueDeclaration, ts.isParameter));
	                            }
	                        }
	                        else if (location.kind === 170 /* ConditionalType */) {
	                            // A type parameter declared using 'infer T' in a conditional type is visible only in
	                            // the true branch of the conditional type.
	                            useResult = lastLocation === location.trueType;
	                        }
	                        if (useResult) {
	                            break loop;
	                        }
	                        else {
	                            result = undefined;
	                        }
	                    }
	                }
	                switch (location.kind) {
	                    case 273 /* SourceFile */:
	                        if (!ts.isExternalOrCommonJsModule(location))
	                            break;
	                        isInExternalModule = true;
	                    // falls through
	                    case 238 /* ModuleDeclaration */:
	                        var moduleExports = getSymbolOfNode(location).exports;
	                        if (location.kind === 273 /* SourceFile */ || ts.isAmbientModule(location)) {
	                            // It's an external module. First see if the module has an export default and if the local
	                            // name of that export default matches.
	                            if (result = moduleExports.get("default" /* Default */)) {
	                                var localSymbol = ts.getLocalSymbolForExportDefault(result);
	                                if (localSymbol && (result.flags & meaning) && localSymbol.escapedName === name) {
	                                    break loop;
	                                }
	                                result = undefined;
	                            }
	                            // Because of module/namespace merging, a module's exports are in scope,
	                            // yet we never want to treat an export specifier as putting a member in scope.
	                            // Therefore, if the name we find is purely an export specifier, it is not actually considered in scope.
	                            // Two things to note about this:
	                            //     1. We have to check this without calling getSymbol. The problem with calling getSymbol
	                            //        on an export specifier is that it might find the export specifier itself, and try to
	                            //        resolve it as an alias. This will cause the checker to consider the export specifier
	                            //        a circular alias reference when it might not be.
	                            //     2. We check === SymbolFlags.Alias in order to check that the symbol is *purely*
	                            //        an alias. If we used &, we'd be throwing out symbols that have non alias aspects,
	                            //        which is not the desired behavior.
	                            var moduleExport = moduleExports.get(name);
	                            if (moduleExport &&
	                                moduleExport.flags === 2097152 /* Alias */ &&
	                                ts.getDeclarationOfKind(moduleExport, 251 /* ExportSpecifier */)) {
	                                break;
	                            }
	                        }
	                        // ES6 exports are also visible locally (except for 'default'), but commonjs exports are not (except typedefs)
	                        if (name !== "default" /* Default */ && (result = lookup(moduleExports, name, meaning & 2623475 /* ModuleMember */))) {
	                            if (ts.isSourceFile(location) && location.commonJsModuleIndicator && !result.declarations.some(ts.isJSDocTypeAlias)) {
	                                result = undefined;
	                            }
	                            else {
	                                break loop;
	                            }
	                        }
	                        break;
	                    case 237 /* EnumDeclaration */:
	                        if (result = lookup(getSymbolOfNode(location).exports, name, meaning & 8 /* EnumMember */)) {
	                            break loop;
	                        }
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                        // TypeScript 1.0 spec (April 2014): 8.4.1
	                        // Initializer expressions for instance member variables are evaluated in the scope
	                        // of the class constructor body but are not permitted to reference parameters or
	                        // local variables of the constructor. This effectively means that entities from outer scopes
	                        // by the same name as a constructor parameter or local variable are inaccessible
	                        // in initializer expressions for instance member variables.
	                        if (ts.isClassLike(location.parent) && !ts.hasModifier(location, 32 /* Static */)) {
	                            var ctor = findConstructorDeclaration(location.parent);
	                            if (ctor && ctor.locals) {
	                                if (lookup(ctor.locals, name, meaning & 67216319 /* Value */)) {
	                                    // Remember the property node, it will be used later to report appropriate error
	                                    propertyWithInvalidInitializer = location;
	                                }
	                            }
	                        }
	                        break;
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                    case 235 /* InterfaceDeclaration */:
	                        if (result = lookup(getMembersOfSymbol(getSymbolOfNode(location)), name, meaning & 67901928 /* Type */)) {
	                            if (!isTypeParameterSymbolDeclaredInContainer(result, location)) {
	                                // ignore type parameters not declared in this container
	                                result = undefined;
	                                break;
	                            }
	                            if (lastLocation && ts.hasModifier(lastLocation, 32 /* Static */)) {
	                                // TypeScript 1.0 spec (April 2014): 3.4.1
	                                // The scope of a type parameter extends over the entire declaration with which the type
	                                // parameter list is associated, with the exception of static member declarations in classes.
	                                error(errorLocation, ts.Diagnostics.Static_members_cannot_reference_class_type_parameters);
	                                return undefined;
	                            }
	                            break loop;
	                        }
	                        if (location.kind === 204 /* ClassExpression */ && meaning & 32 /* Class */) {
	                            var className = location.name;
	                            if (className && name === className.escapedText) {
	                                result = location.symbol;
	                                break loop;
	                            }
	                        }
	                        break;
	                    case 206 /* ExpressionWithTypeArguments */:
	                        // The type parameters of a class are not in scope in the base class expression.
	                        if (lastLocation === location.expression && location.parent.token === 85 /* ExtendsKeyword */) {
	                            var container = location.parent.parent;
	                            if (ts.isClassLike(container) && (result = lookup(getSymbolOfNode(container).members, name, meaning & 67901928 /* Type */))) {
	                                if (nameNotFoundMessage) {
	                                    error(errorLocation, ts.Diagnostics.Base_class_expressions_cannot_reference_class_type_parameters);
	                                }
	                                return undefined;
	                            }
	                        }
	                        break;
	                    // It is not legal to reference a class's own type parameters from a computed property name that
	                    // belongs to the class. For example:
	                    //
	                    //   function foo<T>() { return '' }
	                    //   class C<T> { // <-- Class's own type parameter T
	                    //       [foo<T>()]() { } // <-- Reference to T from class's own computed property
	                    //   }
	                    //
	                    case 146 /* ComputedPropertyName */:
	                        grandparent = location.parent.parent;
	                        if (ts.isClassLike(grandparent) || grandparent.kind === 235 /* InterfaceDeclaration */) {
	                            // A reference to this grandparent's type parameters would be an error
	                            if (result = lookup(getSymbolOfNode(grandparent).members, name, meaning & 67901928 /* Type */)) {
	                                error(errorLocation, ts.Diagnostics.A_computed_property_name_cannot_reference_a_type_parameter_from_its_containing_type);
	                                return undefined;
	                            }
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 233 /* FunctionDeclaration */:
	                    case 192 /* ArrowFunction */:
	                        if (meaning & 3 /* Variable */ && name === "arguments") {
	                            result = argumentsSymbol;
	                            break loop;
	                        }
	                        break;
	                    case 191 /* FunctionExpression */:
	                        if (meaning & 3 /* Variable */ && name === "arguments") {
	                            result = argumentsSymbol;
	                            break loop;
	                        }
	                        if (meaning & 16 /* Function */) {
	                            var functionName = location.name;
	                            if (functionName && name === functionName.escapedText) {
	                                result = location.symbol;
	                                break loop;
	                            }
	                        }
	                        break;
	                    case 149 /* Decorator */:
	                        // Decorators are resolved at the class declaration. Resolving at the parameter
	                        // or member would result in looking up locals in the method.
	                        //
	                        //   function y() {}
	                        //   class C {
	                        //       method(@y x, y) {} // <-- decorator y should be resolved at the class declaration, not the parameter.
	                        //   }
	                        //
	                        if (location.parent && location.parent.kind === 148 /* Parameter */) {
	                            location = location.parent;
	                        }
	                        //
	                        //   function y() {}
	                        //   class C {
	                        //       @y method(x, y) {} // <-- decorator y should be resolved at the class declaration, not the method.
	                        //   }
	                        //
	                        if (location.parent && ts.isClassElement(location.parent)) {
	                            location = location.parent;
	                        }
	                        break;
	                    case 296 /* JSDocTypedefTag */:
	                    case 291 /* JSDocCallbackTag */:
	                        // js type aliases do not resolve names from their host, so skip past it
	                        location = ts.getJSDocHost(location);
	                        break;
	                }
	                if (isSelfReferenceLocation(location)) {
	                    lastSelfReferenceLocation = location;
	                }
	                lastLocation = location;
	                location = location.parent;
	            }
	            // We just climbed up parents looking for the name, meaning that we started in a descendant node of `lastLocation`.
	            // If `result === lastSelfReferenceLocation.symbol`, that means that we are somewhere inside `lastSelfReferenceLocation` looking up a name, and resolving to `lastLocation` itself.
	            // That means that this is a self-reference of `lastLocation`, and shouldn't count this when considering whether `lastLocation` is used.
	            if (isUse && result && (!lastSelfReferenceLocation || result !== lastSelfReferenceLocation.symbol)) {
	                result.isReferenced |= meaning;
	            }
	            if (!result) {
	                if (lastLocation) {
	                    ts.Debug.assert(lastLocation.kind === 273 /* SourceFile */);
	                    if (lastLocation.commonJsModuleIndicator && name === "exports") {
	                        return lastLocation.symbol;
	                    }
	                }
	                if (!excludeGlobals) {
	                    result = lookup(globals, name, meaning);
	                }
	            }
	            if (!result) {
	                if (originalLocation && ts.isInJavaScriptFile(originalLocation) && originalLocation.parent) {
	                    if (ts.isRequireCall(originalLocation.parent, /*checkArgumentIsStringLiteralLike*/ false)) {
	                        return requireSymbol;
	                    }
	                    if (ts.isIdentifier(originalLocation) && ts.isPropertyAccessExpression(originalLocation.parent) &&
	                        originalLocation.escapedText === "module" && originalLocation.parent.name.escapedText === "exports") {
	                        return moduleSymbol;
	                    }
	                }
	            }
	            if (!result) {
	                if (nameNotFoundMessage) {
	                    if (!errorLocation ||
	                        !checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) &&
	                            !checkAndReportErrorForExtendingInterface(errorLocation) &&
	                            !checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) &&
	                            !checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) &&
	                            !checkAndReportErrorForUsingNamespaceModuleAsValue(errorLocation, name, meaning)) {
	                        var suggestion = void 0;
	                        if (suggestedNameNotFoundMessage && suggestionCount < maximumSuggestionCount) {
	                            suggestion = getSuggestionForNonexistentSymbol(originalLocation, name, meaning);
	                            if (suggestion) {
	                                error(errorLocation, suggestedNameNotFoundMessage, diagnosticName(nameArg), suggestion);
	                            }
	                        }
	                        if (!suggestion) {
	                            error(errorLocation, nameNotFoundMessage, diagnosticName(nameArg));
	                        }
	                        suggestionCount++;
	                    }
	                }
	                return undefined;
	            }
	            // Perform extra checks only if error reporting was requested
	            if (nameNotFoundMessage) {
	                if (propertyWithInvalidInitializer) {
	                    // We have a match, but the reference occurred within a property initializer and the identifier also binds
	                    // to a local variable in the constructor where the code will be emitted.
	                    var propertyName = propertyWithInvalidInitializer.name;
	                    error(errorLocation, ts.Diagnostics.Initializer_of_instance_member_variable_0_cannot_reference_identifier_1_declared_in_the_constructor, ts.declarationNameToString(propertyName), diagnosticName(nameArg));
	                    return undefined;
	                }
	                // Only check for block-scoped variable if we have an error location and are looking for the
	                // name with variable meaning
	                //      For example,
	                //          declare module foo {
	                //              interface bar {}
	                //          }
	                //      const foo/*1*/: foo/*2*/.bar;
	                // The foo at /*1*/ and /*2*/ will share same symbol with two meanings:
	                // block-scoped variable and namespace module. However, only when we
	                // try to resolve name in /*1*/ which is used in variable position,
	                // we want to check for block-scoped
	                if (errorLocation &&
	                    (meaning & 2 /* BlockScopedVariable */ ||
	                        ((meaning & 32 /* Class */ || meaning & 384 /* Enum */) && (meaning & 67216319 /* Value */) === 67216319 /* Value */))) {
	                    var exportOrLocalSymbol = getExportSymbolOfValueSymbolIfExported(result);
	                    if (exportOrLocalSymbol.flags & 2 /* BlockScopedVariable */ || exportOrLocalSymbol.flags & 32 /* Class */ || exportOrLocalSymbol.flags & 384 /* Enum */) {
	                        checkResolvedBlockScopedVariable(exportOrLocalSymbol, errorLocation);
	                    }
	                }
	                // If we're in an external module, we can't reference value symbols created from UMD export declarations
	                if (result && isInExternalModule && (meaning & 67216319 /* Value */) === 67216319 /* Value */ && !(originalLocation.flags & 2097152 /* JSDoc */)) {
	                    var decls = result.declarations;
	                    if (decls && decls.length === 1 && decls[0].kind === 241 /* NamespaceExportDeclaration */) {
	                        error(errorLocation, ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead, ts.unescapeLeadingUnderscores(name));
	                    }
	                }
	            }
	            return result;
	        }
	        function isSelfReferenceLocation(node) {
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 238 /* ModuleDeclaration */: // For `namespace N { N; }`
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function diagnosticName(nameArg) {
	            return ts.isString(nameArg) ? ts.unescapeLeadingUnderscores(nameArg) : ts.declarationNameToString(nameArg);
	        }
	        function isTypeParameterSymbolDeclaredInContainer(symbol, container) {
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (decl.kind === 147 /* TypeParameter */) {
	                    var parent = ts.isJSDocTemplateTag(decl.parent) ? ts.getJSDocHost(decl.parent) : decl.parent;
	                    if (parent === container) {
	                        return !(ts.isJSDocTemplateTag(decl.parent) && ts.find(decl.parent.parent.tags, ts.isJSDocTypeAlias));
	                    }
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForMissingPrefix(errorLocation, name, nameArg) {
	            if (!ts.isIdentifier(errorLocation) || errorLocation.escapedText !== name || isTypeReferenceIdentifier(errorLocation) || isInTypeQuery(errorLocation)) {
	                return false;
	            }
	            var container = ts.getThisContainer(errorLocation, /*includeArrowFunctions*/ false);
	            var location = container;
	            while (location) {
	                if (ts.isClassLike(location.parent)) {
	                    var classSymbol = getSymbolOfNode(location.parent);
	                    if (!classSymbol) {
	                        break;
	                    }
	                    // Check to see if a static member exists.
	                    var constructorType = getTypeOfSymbol(classSymbol);
	                    if (getPropertyOfType(constructorType, name)) {
	                        error(errorLocation, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0, diagnosticName(nameArg), symbolToString(classSymbol));
	                        return true;
	                    }
	                    // No static member is present.
	                    // Check if we're in an instance method and look for a relevant instance member.
	                    if (location === container && !ts.hasModifier(location, 32 /* Static */)) {
	                        var instanceType = getDeclaredTypeOfSymbol(classSymbol).thisType;
	                        if (getPropertyOfType(instanceType, name)) {
	                            error(errorLocation, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0, diagnosticName(nameArg));
	                            return true;
	                        }
	                    }
	                }
	                location = location.parent;
	            }
	            return false;
	        }
	        function checkAndReportErrorForExtendingInterface(errorLocation) {
	            var expression = getEntityNameForExtendingInterface(errorLocation);
	            var isError = !!(expression && resolveEntityName(expression, 64 /* Interface */, /*ignoreErrors*/ true));
	            if (isError) {
	                error(errorLocation, ts.Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements, ts.getTextOfNode(expression));
	            }
	            return isError;
	        }
	        /**
	         * Climbs up parents to an ExpressionWithTypeArguments, and returns its expression,
	         * but returns undefined if that expression is not an EntityNameExpression.
	         */
	        function getEntityNameForExtendingInterface(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 184 /* PropertyAccessExpression */:
	                    return node.parent ? getEntityNameForExtendingInterface(node.parent) : undefined;
	                case 206 /* ExpressionWithTypeArguments */:
	                    if (ts.isEntityNameExpression(node.expression)) {
	                        return node.expression;
	                    }
	                // falls through
	                default:
	                    return undefined;
	            }
	        }
	        function checkAndReportErrorForUsingTypeAsNamespace(errorLocation, name, meaning) {
	            var namespaceMeaning = 1920 /* Namespace */ | (ts.isInJavaScriptFile(errorLocation) ? 67216319 /* Value */ : 0);
	            if (meaning === namespaceMeaning) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 67901928 /* Type */ & ~namespaceMeaning, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                var parent = errorLocation.parent;
	                if (symbol) {
	                    if (ts.isQualifiedName(parent)) {
	                        ts.Debug.assert(parent.left === errorLocation, "Should only be resolving left side of qualified name as a namespace");
	                        var propName = parent.right.escapedText;
	                        var propType = getPropertyOfType(getDeclaredTypeOfSymbol(symbol), propName);
	                        if (propType) {
	                            error(parent, ts.Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1, ts.unescapeLeadingUnderscores(name), ts.unescapeLeadingUnderscores(propName));
	                            return true;
	                        }
	                    }
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_namespace_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForUsingTypeAsValue(errorLocation, name, meaning) {
	            if (meaning & (67216319 /* Value */ & ~1024 /* NamespaceModule */)) {
	                if (name === "any" || name === "string" || name === "number" || name === "boolean" || name === "never") {
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 67901928 /* Type */ & ~67216319 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol && !(symbol.flags & 1024 /* NamespaceModule */)) {
	                    error(errorLocation, ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkAndReportErrorForUsingNamespaceModuleAsValue(errorLocation, name, meaning) {
	            if (meaning & (67216319 /* Value */ & ~1024 /* NamespaceModule */ & ~67901928 /* Type */)) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, 1024 /* NamespaceModule */ & ~67216319 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol) {
	                    error(errorLocation, ts.Diagnostics.Cannot_use_namespace_0_as_a_value, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            else if (meaning & (67901928 /* Type */ & ~1024 /* NamespaceModule */ & ~67216319 /* Value */)) {
	                var symbol = resolveSymbol(resolveName(errorLocation, name, (512 /* ValueModule */ | 1024 /* NamespaceModule */) & ~67901928 /* Type */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false));
	                if (symbol) {
	                    error(errorLocation, ts.Diagnostics.Cannot_use_namespace_0_as_a_type, ts.unescapeLeadingUnderscores(name));
	                    return true;
	                }
	            }
	            return false;
	        }
	        function checkResolvedBlockScopedVariable(result, errorLocation) {
	            ts.Debug.assert(!!(result.flags & 2 /* BlockScopedVariable */ || result.flags & 32 /* Class */ || result.flags & 384 /* Enum */));
	            // Block-scoped variables cannot be used before their definition
	            var declaration = ts.forEach(result.declarations, function (d) { return ts.isBlockOrCatchScoped(d) || ts.isClassLike(d) || (d.kind === 237 /* EnumDeclaration */) ? d : undefined; });
	            ts.Debug.assert(declaration !== undefined, "Declaration to checkResolvedBlockScopedVariable is undefined");
	            if (!(declaration.flags & 4194304 /* Ambient */) && !isBlockScopedNameDeclaredBeforeUse(declaration, errorLocation)) {
	                if (result.flags & 2 /* BlockScopedVariable */) {
	                    error(errorLocation, ts.Diagnostics.Block_scoped_variable_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	                else if (result.flags & 32 /* Class */) {
	                    error(errorLocation, ts.Diagnostics.Class_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	                else if (result.flags & 256 /* RegularEnum */) {
	                    error(errorLocation, ts.Diagnostics.Enum_0_used_before_its_declaration, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)));
	                }
	            }
	        }
	        /* Starting from 'initial' node walk up the parent chain until 'stopAt' node is reached.
	         * If at any point current node is equal to 'parent' node - return true.
	         * Return false if 'stopAt' node is reached or isFunctionLike(current) === true.
	         */
	        function isSameScopeDescendentOf(initial, parent, stopAt) {
	            return parent && !!ts.findAncestor(initial, function (n) { return n === stopAt || ts.isFunctionLike(n) ? "quit" : n === parent; });
	        }
	        function getAnyImportSyntax(node) {
	            switch (node.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                    return node;
	                case 244 /* ImportClause */:
	                    return node.parent;
	                case 245 /* NamespaceImport */:
	                    return node.parent.parent;
	                case 247 /* ImportSpecifier */:
	                    return node.parent.parent.parent;
	                default:
	                    return undefined;
	            }
	        }
	        function getDeclarationOfAliasSymbol(symbol) {
	            return ts.find(symbol.declarations, ts.isAliasSymbolDeclaration);
	        }
	        function getTargetOfImportEqualsDeclaration(node, dontResolveAlias) {
	            if (node.moduleReference.kind === 253 /* ExternalModuleReference */) {
	                return resolveExternalModuleSymbol(resolveExternalModuleName(node, ts.getExternalModuleImportEqualsDeclarationExpression(node)));
	            }
	            return getSymbolOfPartOfRightHandSideOfImportEquals(node.moduleReference, dontResolveAlias);
	        }
	        function resolveExportByName(moduleSymbol, name, dontResolveAlias) {
	            var exportValue = moduleSymbol.exports.get("export=" /* ExportEquals */);
	            return exportValue
	                ? getPropertyOfType(getTypeOfSymbol(exportValue), name)
	                : resolveSymbol(moduleSymbol.exports.get(name), dontResolveAlias);
	        }
	        function isSyntacticDefault(node) {
	            return ((ts.isExportAssignment(node) && !node.isExportEquals) || ts.hasModifier(node, 512 /* Default */) || ts.isExportSpecifier(node));
	        }
	        function canHaveSyntheticDefault(file, moduleSymbol, dontResolveAlias) {
	            if (!allowSyntheticDefaultImports) {
	                return false;
	            }
	            // Declaration files (and ambient modules)
	            if (!file || file.isDeclarationFile) {
	                // Definitely cannot have a synthetic default if they have a syntactic default member specified
	                var defaultExportSymbol = resolveExportByName(moduleSymbol, "default" /* Default */, /*dontResolveAlias*/ true); // Dont resolve alias because we want the immediately exported symbol's declaration
	                if (defaultExportSymbol && ts.some(defaultExportSymbol.declarations, isSyntacticDefault)) {
	                    return false;
	                }
	                // It _might_ still be incorrect to assume there is no __esModule marker on the import at runtime, even if there is no `default` member
	                // So we check a bit more,
	                if (resolveExportByName(moduleSymbol, ts.escapeLeadingUnderscores("__esModule"), dontResolveAlias)) {
	                    // If there is an `__esModule` specified in the declaration (meaning someone explicitly added it or wrote it in their code),
	                    // it definitely is a module and does not have a synthetic default
	                    return false;
	                }
	                // There are _many_ declaration files not written with esmodules in mind that still get compiled into a format with __esModule set
	                // Meaning there may be no default at runtime - however to be on the permissive side, we allow access to a synthetic default member
	                // as there is no marker to indicate if the accompanying JS has `__esModule` or not, or is even native esm
	                return true;
	            }
	            // TypeScript files never have a synthetic default (as they are always emitted with an __esModule marker) _unless_ they contain an export= statement
	            if (!ts.isSourceFileJavaScript(file)) {
	                return hasExportAssignmentSymbol(moduleSymbol);
	            }
	            // JS files have a synthetic default if they do not contain ES2015+ module syntax (export = is not valid in js) _and_ do not have an __esModule marker
	            return !file.externalModuleIndicator && !resolveExportByName(moduleSymbol, ts.escapeLeadingUnderscores("__esModule"), dontResolveAlias);
	        }
	        function getTargetOfImportClause(node, dontResolveAlias) {
	            var moduleSymbol = resolveExternalModuleName(node, node.parent.moduleSpecifier);
	            if (moduleSymbol) {
	                var exportDefaultSymbol = void 0;
	                if (ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                    exportDefaultSymbol = moduleSymbol;
	                }
	                else {
	                    exportDefaultSymbol = resolveExportByName(moduleSymbol, "default" /* Default */, dontResolveAlias);
	                }
	                var file_2 = ts.find(moduleSymbol.declarations, ts.isSourceFile);
	                var hasSyntheticDefault = canHaveSyntheticDefault(file_2, moduleSymbol, dontResolveAlias);
	                if (!exportDefaultSymbol && !hasSyntheticDefault) {
	                    error(node.name, ts.Diagnostics.Module_0_has_no_default_export, symbolToString(moduleSymbol));
	                }
	                else if (hasSyntheticDefault) {
	                    // per emit behavior, a synthetic default overrides a "real" .default member if `__esModule` is not present
	                    return resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
	                }
	                return exportDefaultSymbol;
	            }
	        }
	        function getTargetOfNamespaceImport(node, dontResolveAlias) {
	            var moduleSpecifier = node.parent.parent.moduleSpecifier;
	            return resolveESModuleSymbol(resolveExternalModuleName(node, moduleSpecifier), moduleSpecifier, dontResolveAlias);
	        }
	        // This function creates a synthetic symbol that combines the value side of one symbol with the
	        // type/namespace side of another symbol. Consider this example:
	        //
	        //   declare module graphics {
	        //       interface Point {
	        //           x: number;
	        //           y: number;
	        //       }
	        //   }
	        //   declare var graphics: {
	        //       Point: new (x: number, y: number) => graphics.Point;
	        //   }
	        //   declare module "graphics" {
	        //       export = graphics;
	        //   }
	        //
	        // An 'import { Point } from "graphics"' needs to create a symbol that combines the value side 'Point'
	        // property with the type/namespace side interface 'Point'.
	        function combineValueAndTypeSymbols(valueSymbol, typeSymbol) {
	            if (valueSymbol === unknownSymbol && typeSymbol === unknownSymbol) {
	                return unknownSymbol;
	            }
	            if (valueSymbol.flags & (67901928 /* Type */ | 1920 /* Namespace */)) {
	                return valueSymbol;
	            }
	            var result = createSymbol(valueSymbol.flags | typeSymbol.flags, valueSymbol.escapedName);
	            result.declarations = ts.deduplicate(ts.concatenate(valueSymbol.declarations, typeSymbol.declarations), ts.equateValues);
	            result.parent = valueSymbol.parent || typeSymbol.parent;
	            if (valueSymbol.valueDeclaration)
	                result.valueDeclaration = valueSymbol.valueDeclaration;
	            if (typeSymbol.members)
	                result.members = typeSymbol.members;
	            if (valueSymbol.exports)
	                result.exports = valueSymbol.exports;
	            return result;
	        }
	        function getExportOfModule(symbol, name, dontResolveAlias) {
	            if (symbol.flags & 1536 /* Module */) {
	                return resolveSymbol(getExportsOfSymbol(symbol).get(name), dontResolveAlias);
	            }
	        }
	        function getPropertyOfVariable(symbol, name) {
	            if (symbol.flags & 3 /* Variable */) {
	                var typeAnnotation = symbol.valueDeclaration.type;
	                if (typeAnnotation) {
	                    return resolveSymbol(getPropertyOfType(getTypeFromTypeNode(typeAnnotation), name));
	                }
	            }
	        }
	        function getExternalModuleMember(node, specifier, dontResolveAlias) {
	            var moduleSymbol = resolveExternalModuleName(node, node.moduleSpecifier);
	            var targetSymbol = resolveESModuleSymbol(moduleSymbol, node.moduleSpecifier, dontResolveAlias);
	            if (targetSymbol) {
	                var name = specifier.propertyName || specifier.name;
	                if (name.escapedText) {
	                    if (ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                        return moduleSymbol;
	                    }
	                    var symbolFromVariable = void 0;
	                    // First check if module was specified with "export=". If so, get the member from the resolved type
	                    if (moduleSymbol && moduleSymbol.exports && moduleSymbol.exports.get("export=" /* ExportEquals */)) {
	                        symbolFromVariable = getPropertyOfType(getTypeOfSymbol(targetSymbol), name.escapedText);
	                    }
	                    else {
	                        symbolFromVariable = getPropertyOfVariable(targetSymbol, name.escapedText);
	                    }
	                    // if symbolFromVariable is export - get its final target
	                    symbolFromVariable = resolveSymbol(symbolFromVariable, dontResolveAlias);
	                    var symbolFromModule = getExportOfModule(targetSymbol, name.escapedText, dontResolveAlias);
	                    // If the export member we're looking for is default, and there is no real default but allowSyntheticDefaultImports is on, return the entire module as the default
	                    if (!symbolFromModule && allowSyntheticDefaultImports && name.escapedText === "default" /* Default */) {
	                        symbolFromModule = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) || resolveSymbol(moduleSymbol, dontResolveAlias);
	                    }
	                    var symbol = symbolFromModule && symbolFromVariable && symbolFromModule !== symbolFromVariable ?
	                        combineValueAndTypeSymbols(symbolFromVariable, symbolFromModule) :
	                        symbolFromModule || symbolFromVariable;
	                    if (!symbol) {
	                        var moduleName = getFullyQualifiedName(moduleSymbol);
	                        var declarationName = ts.declarationNameToString(name);
	                        var suggestion = getSuggestionForNonexistentModule(name, targetSymbol);
	                        if (suggestion !== undefined) {
	                            error(name, ts.Diagnostics.Module_0_has_no_exported_member_1_Did_you_mean_2, moduleName, declarationName, suggestion);
	                        }
	                        else {
	                            error(name, ts.Diagnostics.Module_0_has_no_exported_member_1, moduleName, declarationName);
	                        }
	                    }
	                    return symbol;
	                }
	            }
	        }
	        function getTargetOfImportSpecifier(node, dontResolveAlias) {
	            return getExternalModuleMember(node.parent.parent.parent, node, dontResolveAlias);
	        }
	        function getTargetOfNamespaceExportDeclaration(node, dontResolveAlias) {
	            return resolveExternalModuleSymbol(node.parent.symbol, dontResolveAlias);
	        }
	        function getTargetOfExportSpecifier(node, meaning, dontResolveAlias) {
	            return node.parent.parent.moduleSpecifier ?
	                getExternalModuleMember(node.parent.parent, node, dontResolveAlias) :
	                resolveEntityName(node.propertyName || node.name, meaning, /*ignoreErrors*/ false, dontResolveAlias);
	        }
	        function getTargetOfExportAssignment(node, dontResolveAlias) {
	            var expression = (ts.isExportAssignment(node) ? node.expression : node.right);
	            if (ts.isClassExpression(expression)) {
	                return checkExpression(expression).symbol;
	            }
	            var aliasLike = resolveEntityName(expression, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */, /*ignoreErrors*/ true, dontResolveAlias);
	            if (aliasLike) {
	                return aliasLike;
	            }
	            checkExpression(expression);
	            return getNodeLinks(expression).resolvedSymbol;
	        }
	        function getTargetOfAliasDeclaration(node, dontRecursivelyResolve) {
	            switch (node.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                    return getTargetOfImportEqualsDeclaration(node, dontRecursivelyResolve);
	                case 244 /* ImportClause */:
	                    return getTargetOfImportClause(node, dontRecursivelyResolve);
	                case 245 /* NamespaceImport */:
	                    return getTargetOfNamespaceImport(node, dontRecursivelyResolve);
	                case 247 /* ImportSpecifier */:
	                    return getTargetOfImportSpecifier(node, dontRecursivelyResolve);
	                case 251 /* ExportSpecifier */:
	                    return getTargetOfExportSpecifier(node, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */, dontRecursivelyResolve);
	                case 248 /* ExportAssignment */:
	                case 199 /* BinaryExpression */:
	                    return getTargetOfExportAssignment(node, dontRecursivelyResolve);
	                case 241 /* NamespaceExportDeclaration */:
	                    return getTargetOfNamespaceExportDeclaration(node, dontRecursivelyResolve);
	            }
	        }
	        /**
	         * Indicates that a symbol is an alias that does not merge with a local declaration.
	         * OR Is a JSContainer which may merge an alias with a local declaration
	         */
	        function isNonLocalAlias(symbol, excludes) {
	            if (excludes === void 0) { excludes = 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */; }
	            if (!symbol)
	                return false;
	            return (symbol.flags & (2097152 /* Alias */ | excludes)) === 2097152 /* Alias */ || (symbol.flags & 2097152 /* Alias */ && symbol.flags & 67108864 /* JSContainer */);
	        }
	        function resolveSymbol(symbol, dontResolveAlias) {
	            var shouldResolve = !dontResolveAlias && isNonLocalAlias(symbol);
	            return shouldResolve ? resolveAlias(symbol) : symbol;
	        }
	        function resolveAlias(symbol) {
	            ts.Debug.assert((symbol.flags & 2097152 /* Alias */) !== 0, "Should only get Alias here.");
	            var links = getSymbolLinks(symbol);
	            if (!links.target) {
	                links.target = resolvingSymbol;
	                var node = getDeclarationOfAliasSymbol(symbol);
	                ts.Debug.assert(!!node);
	                var target = getTargetOfAliasDeclaration(node);
	                if (links.target === resolvingSymbol) {
	                    links.target = target || unknownSymbol;
	                }
	                else {
	                    error(node, ts.Diagnostics.Circular_definition_of_import_alias_0, symbolToString(symbol));
	                }
	            }
	            else if (links.target === resolvingSymbol) {
	                links.target = unknownSymbol;
	            }
	            return links.target;
	        }
	        function markExportAsReferenced(node) {
	            var symbol = getSymbolOfNode(node);
	            var target = resolveAlias(symbol);
	            if (target) {
	                var markAlias = target === unknownSymbol ||
	                    ((target.flags & 67216319 /* Value */) && !isConstEnumOrConstEnumOnlyModule(target));
	                if (markAlias) {
	                    markAliasSymbolAsReferenced(symbol);
	                }
	            }
	        }
	        // When an alias symbol is referenced, we need to mark the entity it references as referenced and in turn repeat that until
	        // we reach a non-alias or an exported entity (which is always considered referenced). We do this by checking the target of
	        // the alias as an expression (which recursively takes us back here if the target references another alias).
	        function markAliasSymbolAsReferenced(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.referenced) {
	                links.referenced = true;
	                var node = getDeclarationOfAliasSymbol(symbol);
	                ts.Debug.assert(!!node);
	                if (node.kind === 248 /* ExportAssignment */) {
	                    // export default <symbol>
	                    checkExpressionCached(node.expression);
	                }
	                else if (node.kind === 251 /* ExportSpecifier */) {
	                    // export { <symbol> } or export { <symbol> as foo }
	                    checkExpressionCached(node.propertyName || node.name);
	                }
	                else if (ts.isInternalModuleImportEqualsDeclaration(node)) {
	                    // import foo = <symbol>
	                    checkExpressionCached(node.moduleReference);
	                }
	            }
	        }
	        // This function is only for imports with entity names
	        function getSymbolOfPartOfRightHandSideOfImportEquals(entityName, dontResolveAlias) {
	            // There are three things we might try to look for. In the following examples,
	            // the search term is enclosed in |...|:
	            //
	            //     import a = |b|; // Namespace
	            //     import a = |b.c|; // Value, type, namespace
	            //     import a = |b.c|.d; // Namespace
	            if (entityName.kind === 71 /* Identifier */ && ts.isRightSideOfQualifiedNameOrPropertyAccess(entityName)) {
	                entityName = entityName.parent;
	            }
	            // Check for case 1 and 3 in the above example
	            if (entityName.kind === 71 /* Identifier */ || entityName.parent.kind === 145 /* QualifiedName */) {
	                return resolveEntityName(entityName, 1920 /* Namespace */, /*ignoreErrors*/ false, dontResolveAlias);
	            }
	            else {
	                // Case 2 in above example
	                // entityName.kind could be a QualifiedName or a Missing identifier
	                ts.Debug.assert(entityName.parent.kind === 242 /* ImportEqualsDeclaration */);
	                return resolveEntityName(entityName, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */, /*ignoreErrors*/ false, dontResolveAlias);
	            }
	        }
	        function getFullyQualifiedName(symbol) {
	            return symbol.parent ? getFullyQualifiedName(symbol.parent) + "." + symbolToString(symbol) : symbolToString(symbol);
	        }
	        /**
	         * Resolves a qualified name and any involved aliases.
	         */
	        function resolveEntityName(name, meaning, ignoreErrors, dontResolveAlias, location) {
	            if (ts.nodeIsMissing(name)) {
	                return undefined;
	            }
	            var namespaceMeaning = 1920 /* Namespace */ | (ts.isInJavaScriptFile(name) ? meaning & 67216319 /* Value */ : 0);
	            var symbol;
	            if (name.kind === 71 /* Identifier */) {
	                var message = meaning === namespaceMeaning ? ts.Diagnostics.Cannot_find_namespace_0 : ts.Diagnostics.Cannot_find_name_0;
	                var symbolFromJSPrototype = ts.isInJavaScriptFile(name) ? resolveEntityNameFromJSSpecialAssignment(name, meaning) : undefined;
	                symbol = resolveName(location || name, name.escapedText, meaning, ignoreErrors || symbolFromJSPrototype ? undefined : message, name, /*isUse*/ true);
	                if (!symbol) {
	                    return symbolFromJSPrototype;
	                }
	            }
	            else if (name.kind === 145 /* QualifiedName */ || name.kind === 184 /* PropertyAccessExpression */) {
	                var left = name.kind === 145 /* QualifiedName */ ? name.left : name.expression;
	                var right = name.kind === 145 /* QualifiedName */ ? name.right : name.name;
	                var namespace_1 = resolveEntityName(left, namespaceMeaning, ignoreErrors, /*dontResolveAlias*/ false, location);
	                if (!namespace_1 || ts.nodeIsMissing(right)) {
	                    return undefined;
	                }
	                else if (namespace_1 === unknownSymbol) {
	                    return namespace_1;
	                }
	                if (ts.isInJavaScriptFile(name)) {
	                    var initializer = ts.getDeclaredJavascriptInitializer(namespace_1.valueDeclaration) || ts.getAssignedJavascriptInitializer(namespace_1.valueDeclaration);
	                    if (initializer) {
	                        namespace_1 = getSymbolOfNode(initializer);
	                    }
	                    // Currently, IIFEs may not have a symbol and we don't know about their contents. Give up in this case.
	                    if (!namespace_1) {
	                        return undefined;
	                    }
	                    if (namespace_1.valueDeclaration &&
	                        ts.isVariableDeclaration(namespace_1.valueDeclaration) &&
	                        namespace_1.valueDeclaration.initializer &&
	                        isCommonJsRequire(namespace_1.valueDeclaration.initializer)) {
	                        var moduleName = namespace_1.valueDeclaration.initializer.arguments[0];
	                        var moduleSym = resolveExternalModuleName(moduleName, moduleName);
	                        if (moduleSym) {
	                            var resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
	                            if (resolvedModuleSymbol) {
	                                namespace_1 = resolvedModuleSymbol;
	                            }
	                        }
	                    }
	                }
	                symbol = getSymbol(getExportsOfSymbol(namespace_1), right.escapedText, meaning);
	                if (!symbol) {
	                    if (!ignoreErrors) {
	                        error(right, ts.Diagnostics.Namespace_0_has_no_exported_member_1, getFullyQualifiedName(namespace_1), ts.declarationNameToString(right));
	                    }
	                    return undefined;
	                }
	            }
	            else {
	                ts.Debug.assertNever(name, "Unknown entity name kind.");
	            }
	            ts.Debug.assert((ts.getCheckFlags(symbol) & 1 /* Instantiated */) === 0, "Should never get an instantiated symbol here.");
	            return (symbol.flags & meaning) || dontResolveAlias ? symbol : resolveAlias(symbol);
	        }
	        /**
	         * 1. For prototype-property methods like `A.prototype.m = function () ...`, try to resolve names in the scope of `A` too.
	         * Note that prototype-property assignment to locations outside the current file (eg globals) doesn't work, so
	         * name resolution won't work either.
	         * 2. For property assignments like `{ x: function f () { } }`, try to resolve names in the scope of `f` too.
	         */
	        function resolveEntityNameFromJSSpecialAssignment(name, meaning) {
	            if (isJSDocTypeReference(name.parent)) {
	                var secondaryLocation = getJSSpecialAssignmentLocation(name.parent);
	                if (secondaryLocation) {
	                    return resolveName(secondaryLocation, name.escapedText, meaning, /*nameNotFoundMessage*/ undefined, name, /*isUse*/ true);
	                }
	            }
	        }
	        function getJSSpecialAssignmentLocation(node) {
	            var typeAlias = ts.findAncestor(node, function (node) { return !(ts.isJSDocNode(node) || node.flags & 2097152 /* JSDoc */) ? "quit" : ts.isJSDocTypeAlias(node); });
	            if (typeAlias) {
	                return;
	            }
	            var host = ts.getJSDocHost(node);
	            if (ts.isExpressionStatement(host) &&
	                ts.isBinaryExpression(host.expression) &&
	                ts.getSpecialPropertyAssignmentKind(host.expression) === 3 /* PrototypeProperty */) {
	                var symbol = getSymbolOfNode(host.expression.left);
	                return symbol && symbol.parent.valueDeclaration;
	            }
	            var sig = ts.getHostSignatureFromJSDocHost(host);
	            if (sig) {
	                var symbol = getSymbolOfNode(sig);
	                return symbol && symbol.valueDeclaration;
	            }
	        }
	        function resolveExternalModuleName(location, moduleReferenceExpression) {
	            return resolveExternalModuleNameWorker(location, moduleReferenceExpression, ts.Diagnostics.Cannot_find_module_0);
	        }
	        function resolveExternalModuleNameWorker(location, moduleReferenceExpression, moduleNotFoundError, isForAugmentation) {
	            if (isForAugmentation === void 0) { isForAugmentation = false; }
	            return ts.isStringLiteralLike(moduleReferenceExpression)
	                ? resolveExternalModule(location, moduleReferenceExpression.text, moduleNotFoundError, moduleReferenceExpression, isForAugmentation)
	                : undefined;
	        }
	        function resolveExternalModule(location, moduleReference, moduleNotFoundError, errorNode, isForAugmentation) {
	            if (isForAugmentation === void 0) { isForAugmentation = false; }
	            if (moduleReference === undefined) {
	                return;
	            }
	            if (ts.startsWith(moduleReference, "@types/")) {
	                var diag = ts.Diagnostics.Cannot_import_type_declaration_files_Consider_importing_0_instead_of_1;
	                var withoutAtTypePrefix = ts.removePrefix(moduleReference, "@types/");
	                error(errorNode, diag, withoutAtTypePrefix, moduleReference);
	            }
	            var ambientModule = tryFindAmbientModule(moduleReference, /*withAugmentations*/ true);
	            if (ambientModule) {
	                return ambientModule;
	            }
	            var currentSourceFile = ts.getSourceFileOfNode(location);
	            var resolvedModule = ts.getResolvedModule(currentSourceFile, moduleReference);
	            var resolutionDiagnostic = resolvedModule && ts.getResolutionDiagnostic(compilerOptions, resolvedModule);
	            var sourceFile = resolvedModule && !resolutionDiagnostic && host.getSourceFile(resolvedModule.resolvedFileName);
	            if (sourceFile) {
	                if (sourceFile.symbol) {
	                    if (resolvedModule.isExternalLibraryImport && !ts.extensionIsTypeScript(resolvedModule.extension)) {
	                        errorOnImplicitAnyModule(/*isError*/ false, errorNode, resolvedModule, moduleReference);
	                    }
	                    // merged symbol is module declaration symbol combined with all augmentations
	                    return getMergedSymbol(sourceFile.symbol);
	                }
	                if (moduleNotFoundError) {
	                    // report errors only if it was requested
	                    error(errorNode, ts.Diagnostics.File_0_is_not_a_module, sourceFile.fileName);
	                }
	                return undefined;
	            }
	            if (patternAmbientModules) {
	                var pattern = ts.findBestPatternMatch(patternAmbientModules, function (_) { return _.pattern; }, moduleReference);
	                if (pattern) {
	                    return getMergedSymbol(pattern.symbol);
	                }
	            }
	            // May be an untyped module. If so, ignore resolutionDiagnostic.
	            if (resolvedModule && !ts.resolutionExtensionIsTypeScriptOrJson(resolvedModule.extension) && resolutionDiagnostic === undefined || resolutionDiagnostic === ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type) {
	                if (isForAugmentation) {
	                    var diag = ts.Diagnostics.Invalid_module_name_in_augmentation_Module_0_resolves_to_an_untyped_module_at_1_which_cannot_be_augmented;
	                    error(errorNode, diag, moduleReference, resolvedModule.resolvedFileName);
	                }
	                else {
	                    errorOnImplicitAnyModule(/*isError*/ noImplicitAny && !!moduleNotFoundError, errorNode, resolvedModule, moduleReference);
	                }
	                // Failed imports and untyped modules are both treated in an untyped manner; only difference is whether we give a diagnostic first.
	                return undefined;
	            }
	            if (moduleNotFoundError) {
	                // For relative paths, see if this was possibly a projectReference redirect
	                if (ts.pathIsRelative(moduleReference)) {
	                    var sourceFile_1 = ts.getSourceFileOfNode(location);
	                    var redirects = sourceFile_1.redirectedReferences;
	                    if (redirects) {
	                        var normalizedTargetPath = ts.getNormalizedAbsolutePath(moduleReference, ts.getDirectoryPath(sourceFile_1.fileName));
	                        for (var _i = 0, _a = [".ts" /* Ts */, ".tsx" /* Tsx */]; _i < _a.length; _i++) {
	                            var ext = _a[_i];
	                            var probePath = normalizedTargetPath + ext;
	                            if (redirects.indexOf(probePath) >= 0) {
	                                error(errorNode, ts.Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, moduleReference, probePath);
	                                return undefined;
	                            }
	                        }
	                    }
	                }
	                if (resolutionDiagnostic) {
	                    error(errorNode, resolutionDiagnostic, moduleReference, resolvedModule.resolvedFileName);
	                }
	                else {
	                    var tsExtension = ts.tryExtractTypeScriptExtension(moduleReference);
	                    if (tsExtension) {
	                        var diag = ts.Diagnostics.An_import_path_cannot_end_with_a_0_extension_Consider_importing_1_instead;
	                        error(errorNode, diag, tsExtension, ts.removeExtension(moduleReference, tsExtension));
	                    }
	                    else {
	                        error(errorNode, moduleNotFoundError, moduleReference);
	                    }
	                }
	            }
	            return undefined;
	        }
	        function errorOnImplicitAnyModule(isError, errorNode, _a, moduleReference) {
	            var packageId = _a.packageId, resolvedFileName = _a.resolvedFileName;
	            var errorInfo = packageId && ts.chainDiagnosticMessages(
	            /*details*/ undefined, ts.Diagnostics.Try_npm_install_types_Slash_0_if_it_exists_or_add_a_new_declaration_d_ts_file_containing_declare_module_0, ts.getMangledNameForScopedPackage(packageId.name));
	            errorOrSuggestion(isError, errorNode, ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type, moduleReference, resolvedFileName));
	        }
	        // An external module with an 'export =' declaration resolves to the target of the 'export =' declaration,
	        // and an external module with no 'export =' declaration resolves to the module itself.
	        function resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias) {
	            return moduleSymbol && getMergedSymbol(getCommonJsExportEquals(resolveSymbol(moduleSymbol.exports.get("export=" /* ExportEquals */), dontResolveAlias), moduleSymbol)) || moduleSymbol;
	        }
	        function getCommonJsExportEquals(exported, moduleSymbol) {
	            if (!exported || moduleSymbol.exports.size === 1) {
	                return exported;
	            }
	            var merged = cloneSymbol(exported);
	            if (merged.exports === undefined) {
	                merged.flags = merged.flags | 512 /* ValueModule */;
	                merged.exports = ts.createSymbolTable();
	            }
	            moduleSymbol.exports.forEach(function (s, name) {
	                if (name === "export=" /* ExportEquals */)
	                    return;
	                if (!merged.exports.has(name)) {
	                    merged.exports.set(name, s);
	                }
	                else {
	                    var ms = cloneSymbol(merged.exports.get(name));
	                    mergeSymbol(ms, s);
	                    merged.exports.set(name, ms);
	                }
	            });
	            return merged;
	        }
	        // An external module with an 'export =' declaration may be referenced as an ES6 module provided the 'export ='
	        // references a symbol that is at least declared as a module or a variable. The target of the 'export =' may
	        // combine other declarations with the module or variable (e.g. a class/module, function/module, interface/variable).
	        function resolveESModuleSymbol(moduleSymbol, referencingLocation, dontResolveAlias) {
	            var symbol = resolveExternalModuleSymbol(moduleSymbol, dontResolveAlias);
	            if (!dontResolveAlias && symbol) {
	                if (!(symbol.flags & (1536 /* Module */ | 3 /* Variable */))) {
	                    error(referencingLocation, ts.Diagnostics.Module_0_resolves_to_a_non_module_entity_and_cannot_be_imported_using_this_construct, symbolToString(moduleSymbol));
	                    return symbol;
	                }
	                if (compilerOptions.esModuleInterop) {
	                    var referenceParent = referencingLocation.parent;
	                    if ((ts.isImportDeclaration(referenceParent) && ts.getNamespaceDeclarationNode(referenceParent)) ||
	                        ts.isImportCall(referenceParent)) {
	                        var type = getTypeOfSymbol(symbol);
	                        var sigs = getSignaturesOfStructuredType(type, 0 /* Call */);
	                        if (!sigs || !sigs.length) {
	                            sigs = getSignaturesOfStructuredType(type, 1 /* Construct */);
	                        }
	                        if (sigs && sigs.length) {
	                            var moduleType = getTypeWithSyntheticDefaultImportType(type, symbol, moduleSymbol);
	                            // Create a new symbol which has the module's type less the call and construct signatures
	                            var result = createSymbol(symbol.flags, symbol.escapedName);
	                            result.declarations = symbol.declarations ? symbol.declarations.slice() : [];
	                            result.parent = symbol.parent;
	                            result.target = symbol;
	                            result.originatingImport = referenceParent;
	                            if (symbol.valueDeclaration)
	                                result.valueDeclaration = symbol.valueDeclaration;
	                            if (symbol.constEnumOnlyModule)
	                                result.constEnumOnlyModule = true;
	                            if (symbol.members)
	                                result.members = ts.cloneMap(symbol.members);
	                            if (symbol.exports)
	                                result.exports = ts.cloneMap(symbol.exports);
	                            var resolvedModuleType = resolveStructuredTypeMembers(moduleType); // Should already be resolved from the signature checks above
	                            result.type = createAnonymousType(result, resolvedModuleType.members, ts.emptyArray, ts.emptyArray, resolvedModuleType.stringIndexInfo, resolvedModuleType.numberIndexInfo);
	                            return result;
	                        }
	                    }
	                }
	            }
	            return symbol;
	        }
	        function hasExportAssignmentSymbol(moduleSymbol) {
	            return moduleSymbol.exports.get("export=" /* ExportEquals */) !== undefined;
	        }
	        function getExportsOfModuleAsArray(moduleSymbol) {
	            return symbolsToArray(getExportsOfModule(moduleSymbol));
	        }
	        function getExportsAndPropertiesOfModule(moduleSymbol) {
	            var exports = getExportsOfModuleAsArray(moduleSymbol);
	            var exportEquals = resolveExternalModuleSymbol(moduleSymbol);
	            if (exportEquals !== moduleSymbol) {
	                ts.addRange(exports, getPropertiesOfType(getTypeOfSymbol(exportEquals)));
	            }
	            return exports;
	        }
	        function tryGetMemberInModuleExports(memberName, moduleSymbol) {
	            var symbolTable = getExportsOfModule(moduleSymbol);
	            if (symbolTable) {
	                return symbolTable.get(memberName);
	            }
	        }
	        function tryGetMemberInModuleExportsAndProperties(memberName, moduleSymbol) {
	            var symbol = tryGetMemberInModuleExports(memberName, moduleSymbol);
	            if (symbol) {
	                return symbol;
	            }
	            var exportEquals = resolveExternalModuleSymbol(moduleSymbol);
	            if (exportEquals === moduleSymbol) {
	                return undefined;
	            }
	            var type = getTypeOfSymbol(exportEquals);
	            return type.flags & 16382 /* Primitive */ ? undefined : getPropertyOfType(type, memberName);
	        }
	        function getExportsOfSymbol(symbol) {
	            return symbol.flags & 32 /* Class */ ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedExports" /* resolvedExports */) :
	                symbol.flags & 1536 /* Module */ ? getExportsOfModule(symbol) :
	                    symbol.exports || emptySymbols;
	        }
	        function getExportsOfModule(moduleSymbol) {
	            var links = getSymbolLinks(moduleSymbol);
	            return links.resolvedExports || (links.resolvedExports = getExportsOfModuleWorker(moduleSymbol));
	        }
	        /**
	         * Extends one symbol table with another while collecting information on name collisions for error message generation into the `lookupTable` argument
	         * Not passing `lookupTable` and `exportNode` disables this collection, and just extends the tables
	         */
	        function extendExportSymbols(target, source, lookupTable, exportNode) {
	            if (!source)
	                return;
	            source.forEach(function (sourceSymbol, id) {
	                if (id === "default" /* Default */)
	                    return;
	                var targetSymbol = target.get(id);
	                if (!targetSymbol) {
	                    target.set(id, sourceSymbol);
	                    if (lookupTable && exportNode) {
	                        lookupTable.set(id, {
	                            specifierText: ts.getTextOfNode(exportNode.moduleSpecifier)
	                        });
	                    }
	                }
	                else if (lookupTable && exportNode && targetSymbol && resolveSymbol(targetSymbol) !== resolveSymbol(sourceSymbol)) {
	                    var collisionTracker = lookupTable.get(id);
	                    if (!collisionTracker.exportsWithDuplicate) {
	                        collisionTracker.exportsWithDuplicate = [exportNode];
	                    }
	                    else {
	                        collisionTracker.exportsWithDuplicate.push(exportNode);
	                    }
	                }
	            });
	        }
	        function getExportsOfModuleWorker(moduleSymbol) {
	            var visitedSymbols = [];
	            // A module defined by an 'export=' consists on one export that needs to be resolved
	            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
	            return visit(moduleSymbol) || emptySymbols;
	            // The ES6 spec permits export * declarations in a module to circularly reference the module itself. For example,
	            // module 'a' can 'export * from "b"' and 'b' can 'export * from "a"' without error.
	            function visit(symbol) {
	                if (!(symbol && symbol.flags & 1952 /* HasExports */ && ts.pushIfUnique(visitedSymbols, symbol))) {
	                    return;
	                }
	                var symbols = ts.cloneMap(symbol.exports);
	                // All export * declarations are collected in an __export symbol by the binder
	                var exportStars = symbol.exports.get("__export" /* ExportStar */);
	                if (exportStars) {
	                    var nestedSymbols = ts.createSymbolTable();
	                    var lookupTable_1 = ts.createMap();
	                    for (var _i = 0, _a = exportStars.declarations; _i < _a.length; _i++) {
	                        var node = _a[_i];
	                        var resolvedModule = resolveExternalModuleName(node, node.moduleSpecifier);
	                        var exportedSymbols = visit(resolvedModule);
	                        extendExportSymbols(nestedSymbols, exportedSymbols, lookupTable_1, node);
	                    }
	                    lookupTable_1.forEach(function (_a, id) {
	                        var exportsWithDuplicate = _a.exportsWithDuplicate;
	                        // It's not an error if the file with multiple `export *`s with duplicate names exports a member with that name itself
	                        if (id === "export=" || !(exportsWithDuplicate && exportsWithDuplicate.length) || symbols.has(id)) {
	                            return;
	                        }
	                        for (var _i = 0, exportsWithDuplicate_1 = exportsWithDuplicate; _i < exportsWithDuplicate_1.length; _i++) {
	                            var node = exportsWithDuplicate_1[_i];
	                            diagnostics.add(ts.createDiagnosticForNode(node, ts.Diagnostics.Module_0_has_already_exported_a_member_named_1_Consider_explicitly_re_exporting_to_resolve_the_ambiguity, lookupTable_1.get(id).specifierText, ts.unescapeLeadingUnderscores(id)));
	                        }
	                    });
	                    extendExportSymbols(symbols, nestedSymbols);
	                }
	                return symbols;
	            }
	        }
	        function getMergedSymbol(symbol) {
	            var merged;
	            return symbol && symbol.mergeId && (merged = mergedSymbols[symbol.mergeId]) ? merged : symbol;
	        }
	        function getSymbolOfNode(node) {
	            return getMergedSymbol(node.symbol && getLateBoundSymbol(node.symbol));
	        }
	        function getParentOfSymbol(symbol) {
	            return getMergedSymbol(symbol.parent && getLateBoundSymbol(symbol.parent));
	        }
	        /**
	         * Attempts to find the symbol corresponding to the container a symbol is in - usually this
	         * is just its' `.parent`, but for locals, this value is `undefined`
	         */
	        function getContainerOfSymbol(symbol) {
	            var container = getParentOfSymbol(symbol);
	            if (container) {
	                return container;
	            }
	            var candidate = ts.forEach(symbol.declarations, function (d) { return !ts.isAmbientModule(d) && d.parent && hasNonGlobalAugmentationExternalModuleSymbol(d.parent) ? getSymbolOfNode(d.parent) : undefined; });
	            if (!candidate) {
	                return undefined;
	            }
	            var alias = getAliasForSymbolInContainer(candidate, symbol);
	            return alias ? candidate : undefined;
	        }
	        function getAliasForSymbolInContainer(container, symbol) {
	            if (container === getParentOfSymbol(symbol)) {
	                // fast path, `symbol` is either already the alias or isn't aliased
	                return symbol;
	            }
	            var exports = getExportsOfSymbol(container);
	            var quick = exports.get(symbol.escapedName);
	            if (quick && symbolRefersToTarget(quick)) {
	                return quick;
	            }
	            return ts.forEachEntry(exports, function (exported) {
	                if (symbolRefersToTarget(exported)) {
	                    return exported;
	                }
	            });
	            function symbolRefersToTarget(s) {
	                if (s === symbol || resolveSymbol(s) === symbol || resolveSymbol(s) === resolveSymbol(symbol)) {
	                    return s;
	                }
	            }
	        }
	        function getExportSymbolOfValueSymbolIfExported(symbol) {
	            return symbol && (symbol.flags & 1048576 /* ExportValue */) !== 0
	                ? getMergedSymbol(symbol.exportSymbol)
	                : symbol;
	        }
	        function symbolIsValue(symbol) {
	            return !!(symbol.flags & 67216319 /* Value */ || symbol.flags & 2097152 /* Alias */ && resolveAlias(symbol).flags & 67216319 /* Value */);
	        }
	        function findConstructorDeclaration(node) {
	            var members = node.members;
	            for (var _i = 0, members_2 = members; _i < members_2.length; _i++) {
	                var member = members_2[_i];
	                if (member.kind === 154 /* Constructor */ && ts.nodeIsPresent(member.body)) {
	                    return member;
	                }
	            }
	        }
	        function createType(flags) {
	            var result = new Type(checker, flags);
	            typeCount++;
	            result.id = typeCount;
	            return result;
	        }
	        function createIntrinsicType(kind, intrinsicName) {
	            var type = createType(kind);
	            type.intrinsicName = intrinsicName;
	            return type;
	        }
	        function createBooleanType(trueFalseTypes) {
	            var type = getUnionType(trueFalseTypes);
	            type.flags |= 8 /* Boolean */;
	            type.intrinsicName = "boolean";
	            return type;
	        }
	        function createObjectType(objectFlags, symbol) {
	            var type = createType(65536 /* Object */);
	            type.objectFlags = objectFlags;
	            type.symbol = symbol;
	            return type;
	        }
	        function createTypeofType() {
	            return getUnionType(ts.arrayFrom(typeofEQFacts.keys(), getLiteralType));
	        }
	        // A reserved member name starts with two underscores, but the third character cannot be an underscore
	        // or the @ symbol. A third underscore indicates an escaped form of an identifer that started
	        // with at least two underscores. The @ character indicates that the name is denoted by a well known ES
	        // Symbol instance.
	        function isReservedMemberName(name) {
	            return name.charCodeAt(0) === 95 /* _ */ &&
	                name.charCodeAt(1) === 95 /* _ */ &&
	                name.charCodeAt(2) !== 95 /* _ */ &&
	                name.charCodeAt(2) !== 64 /* at */;
	        }
	        function getNamedMembers(members) {
	            var result;
	            members.forEach(function (symbol, id) {
	                if (!isReservedMemberName(id)) {
	                    if (!result)
	                        result = [];
	                    if (symbolIsValue(symbol)) {
	                        result.push(symbol);
	                    }
	                }
	            });
	            return result || ts.emptyArray;
	        }
	        function setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo) {
	            type.members = members;
	            type.properties = getNamedMembers(members);
	            type.callSignatures = callSignatures;
	            type.constructSignatures = constructSignatures;
	            if (stringIndexInfo)
	                type.stringIndexInfo = stringIndexInfo;
	            if (numberIndexInfo)
	                type.numberIndexInfo = numberIndexInfo;
	            return type;
	        }
	        function createAnonymousType(symbol, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo) {
	            return setStructuredTypeMembers(createObjectType(16 /* Anonymous */, symbol), members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function forEachSymbolTableInScope(enclosingDeclaration, callback) {
	            var result;
	            for (var location = enclosingDeclaration; location; location = location.parent) {
	                // Locals of a source file are not in scope (because they get merged into the global symbol table)
	                if (location.locals && !isGlobalSourceFile(location)) {
	                    if (result = callback(location.locals)) {
	                        return result;
	                    }
	                }
	                switch (location.kind) {
	                    case 273 /* SourceFile */:
	                        if (!ts.isExternalOrCommonJsModule(location)) {
	                            break;
	                        }
	                    // falls through
	                    case 238 /* ModuleDeclaration */:
	                        if (result = callback(getSymbolOfNode(location).exports)) {
	                            return result;
	                        }
	                        break;
	                }
	            }
	            return callback(globals);
	        }
	        function getQualifiedLeftMeaning(rightMeaning) {
	            // If we are looking in value space, the parent meaning is value, other wise it is namespace
	            return rightMeaning === 67216319 /* Value */ ? 67216319 /* Value */ : 1920 /* Namespace */;
	        }
	        function getAccessibleSymbolChain(symbol, enclosingDeclaration, meaning, useOnlyExternalAliasing, visitedSymbolTablesMap) {
	            if (visitedSymbolTablesMap === void 0) { visitedSymbolTablesMap = ts.createMap(); }
	            if (!(symbol && !isPropertyOrMethodDeclarationSymbol(symbol))) {
	                return undefined;
	            }
	            var id = "" + getSymbolId(symbol);
	            var visitedSymbolTables = visitedSymbolTablesMap.get(id);
	            if (!visitedSymbolTables) {
	                visitedSymbolTablesMap.set(id, visitedSymbolTables = []);
	            }
	            return forEachSymbolTableInScope(enclosingDeclaration, getAccessibleSymbolChainFromSymbolTable);
	            /**
	             * @param {ignoreQualification} boolean Set when a symbol is being looked for through the exports of another symbol (meaning we have a route to qualify it already)
	             */
	            function getAccessibleSymbolChainFromSymbolTable(symbols, ignoreQualification) {
	                if (!ts.pushIfUnique(visitedSymbolTables, symbols)) {
	                    return undefined;
	                }
	                var result = trySymbolTable(symbols, ignoreQualification);
	                visitedSymbolTables.pop();
	                return result;
	            }
	            function canQualifySymbol(symbolFromSymbolTable, meaning) {
	                // If the symbol is equivalent and doesn't need further qualification, this symbol is accessible
	                return !needsQualification(symbolFromSymbolTable, enclosingDeclaration, meaning) ||
	                    // If symbol needs qualification, make sure that parent is accessible, if it is then this symbol is accessible too
	                    !!getAccessibleSymbolChain(symbolFromSymbolTable.parent, enclosingDeclaration, getQualifiedLeftMeaning(meaning), useOnlyExternalAliasing, visitedSymbolTablesMap);
	            }
	            function isAccessible(symbolFromSymbolTable, resolvedAliasSymbol, ignoreQualification) {
	                return symbol === (resolvedAliasSymbol || symbolFromSymbolTable) &&
	                    // if the symbolFromSymbolTable is not external module (it could be if it was determined as ambient external module and would be in globals table)
	                    // and if symbolFromSymbolTable or alias resolution matches the symbol,
	                    // check the symbol can be qualified, it is only then this symbol is accessible
	                    !ts.some(symbolFromSymbolTable.declarations, hasNonGlobalAugmentationExternalModuleSymbol) &&
	                    (ignoreQualification || canQualifySymbol(symbolFromSymbolTable, meaning));
	            }
	            function trySymbolTable(symbols, ignoreQualification) {
	                // If symbol is directly available by its name in the symbol table
	                if (isAccessible(symbols.get(symbol.escapedName), /*resolvedAliasSymbol*/ undefined, ignoreQualification)) {
	                    return [symbol];
	                }
	                // Check if symbol is any of the alias
	                return ts.forEachEntry(symbols, function (symbolFromSymbolTable) {
	                    if (symbolFromSymbolTable.flags & 2097152 /* Alias */
	                        && symbolFromSymbolTable.escapedName !== "export=" /* ExportEquals */
	                        && symbolFromSymbolTable.escapedName !== "default" /* Default */
	                        && !(ts.isUMDExportSymbol(symbolFromSymbolTable) && enclosingDeclaration && ts.isExternalModule(ts.getSourceFileOfNode(enclosingDeclaration)))
	                        // If `!useOnlyExternalAliasing`, we can use any type of alias to get the name
	                        && (!useOnlyExternalAliasing || ts.some(symbolFromSymbolTable.declarations, ts.isExternalModuleImportEqualsDeclaration))) {
	                        var resolvedImportedSymbol = resolveAlias(symbolFromSymbolTable);
	                        if (isAccessible(symbolFromSymbolTable, resolvedImportedSymbol, ignoreQualification)) {
	                            return [symbolFromSymbolTable];
	                        }
	                        // Look in the exported members, if we can find accessibleSymbolChain, symbol is accessible using this chain
	                        // but only if the symbolFromSymbolTable can be qualified
	                        var candidateTable = getExportsOfSymbol(resolvedImportedSymbol);
	                        var accessibleSymbolsFromExports = candidateTable && getAccessibleSymbolChainFromSymbolTable(candidateTable, /*ignoreQualification*/ true);
	                        if (accessibleSymbolsFromExports && canQualifySymbol(symbolFromSymbolTable, getQualifiedLeftMeaning(meaning))) {
	                            return [symbolFromSymbolTable].concat(accessibleSymbolsFromExports);
	                        }
	                    }
	                    if (symbolFromSymbolTable.escapedName === symbol.escapedName && symbolFromSymbolTable.exportSymbol) {
	                        if (isAccessible(getMergedSymbol(symbolFromSymbolTable.exportSymbol), /*aliasSymbol*/ undefined, ignoreQualification)) {
	                            return [symbol];
	                        }
	                    }
	                });
	            }
	        }
	        function needsQualification(symbol, enclosingDeclaration, meaning) {
	            var qualify = false;
	            forEachSymbolTableInScope(enclosingDeclaration, function (symbolTable) {
	                // If symbol of this name is not available in the symbol table we are ok
	                var symbolFromSymbolTable = getMergedSymbol(symbolTable.get(symbol.escapedName));
	                if (!symbolFromSymbolTable) {
	                    // Continue to the next symbol table
	                    return false;
	                }
	                // If the symbol with this name is present it should refer to the symbol
	                if (symbolFromSymbolTable === symbol) {
	                    // No need to qualify
	                    return true;
	                }
	                // Qualify if the symbol from symbol table has same meaning as expected
	                symbolFromSymbolTable = (symbolFromSymbolTable.flags & 2097152 /* Alias */ && !ts.getDeclarationOfKind(symbolFromSymbolTable, 251 /* ExportSpecifier */)) ? resolveAlias(symbolFromSymbolTable) : symbolFromSymbolTable;
	                if (symbolFromSymbolTable.flags & meaning) {
	                    qualify = true;
	                    return true;
	                }
	                // Continue to the next symbol table
	                return false;
	            });
	            return qualify;
	        }
	        function isPropertyOrMethodDeclarationSymbol(symbol) {
	            if (symbol.declarations && symbol.declarations.length) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    switch (declaration.kind) {
	                        case 151 /* PropertyDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            continue;
	                        default:
	                            return false;
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function isTypeSymbolAccessible(typeSymbol, enclosingDeclaration) {
	            var access = isSymbolAccessible(typeSymbol, enclosingDeclaration, 67901928 /* Type */, /*shouldComputeAliasesToMakeVisible*/ false);
	            return access.accessibility === 0 /* Accessible */;
	        }
	        function isValueSymbolAccessible(typeSymbol, enclosingDeclaration) {
	            var access = isSymbolAccessible(typeSymbol, enclosingDeclaration, 67216319 /* Value */, /*shouldComputeAliasesToMakeVisible*/ false);
	            return access.accessibility === 0 /* Accessible */;
	        }
	        /**
	         * Check if the given symbol in given enclosing declaration is accessible and mark all associated alias to be visible if requested
	         *
	         * @param symbol a Symbol to check if accessible
	         * @param enclosingDeclaration a Node containing reference to the symbol
	         * @param meaning a SymbolFlags to check if such meaning of the symbol is accessible
	         * @param shouldComputeAliasToMakeVisible a boolean value to indicate whether to return aliases to be mark visible in case the symbol is accessible
	         */
	        function isSymbolAccessible(symbol, enclosingDeclaration, meaning, shouldComputeAliasesToMakeVisible) {
	            if (symbol && enclosingDeclaration) {
	                var initialSymbol = symbol;
	                var meaningToLook = meaning;
	                while (symbol) {
	                    // Symbol is accessible if it by itself is accessible
	                    var accessibleSymbolChain = getAccessibleSymbolChain(symbol, enclosingDeclaration, meaningToLook, /*useOnlyExternalAliasing*/ false);
	                    if (accessibleSymbolChain) {
	                        var hasAccessibleDeclarations = hasVisibleDeclarations(accessibleSymbolChain[0], shouldComputeAliasesToMakeVisible);
	                        if (!hasAccessibleDeclarations) {
	                            return {
	                                accessibility: 1 /* NotAccessible */,
	                                errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                                errorModuleName: symbol !== initialSymbol ? symbolToString(symbol, enclosingDeclaration, 1920 /* Namespace */) : undefined,
	                            };
	                        }
	                        return hasAccessibleDeclarations;
	                    }
	                    else {
	                        if (ts.some(symbol.declarations, hasNonGlobalAugmentationExternalModuleSymbol)) {
	                            // Any meaning of a module symbol is always accessible via an `import` type
	                            return {
	                                accessibility: 0 /* Accessible */
	                            };
	                        }
	                    }
	                    // If we haven't got the accessible symbol, it doesn't mean the symbol is actually inaccessible.
	                    // It could be a qualified symbol and hence verify the path
	                    // e.g.:
	                    // module m {
	                    //     export class c {
	                    //     }
	                    // }
	                    // const x: typeof m.c
	                    // In the above example when we start with checking if typeof m.c symbol is accessible,
	                    // we are going to see if c can be accessed in scope directly.
	                    // But it can't, hence the accessible is going to be undefined, but that doesn't mean m.c is inaccessible
	                    // It is accessible if the parent m is accessible because then m.c can be accessed through qualification
	                    meaningToLook = getQualifiedLeftMeaning(meaning);
	                    symbol = getContainerOfSymbol(symbol);
	                }
	                // This could be a symbol that is not exported in the external module
	                // or it could be a symbol from different external module that is not aliased and hence cannot be named
	                var symbolExternalModule = ts.forEach(initialSymbol.declarations, getExternalModuleContainer);
	                if (symbolExternalModule) {
	                    var enclosingExternalModule = getExternalModuleContainer(enclosingDeclaration);
	                    if (symbolExternalModule !== enclosingExternalModule) {
	                        // name from different external module that is not visible
	                        return {
	                            accessibility: 2 /* CannotBeNamed */,
	                            errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                            errorModuleName: symbolToString(symbolExternalModule)
	                        };
	                    }
	                }
	                // Just a local name that is not accessible
	                return {
	                    accessibility: 1 /* NotAccessible */,
	                    errorSymbolName: symbolToString(initialSymbol, enclosingDeclaration, meaning),
	                };
	            }
	            return { accessibility: 0 /* Accessible */ };
	            function getExternalModuleContainer(declaration) {
	                var node = ts.findAncestor(declaration, hasExternalModuleSymbol);
	                return node && getSymbolOfNode(node);
	            }
	        }
	        function hasExternalModuleSymbol(declaration) {
	            return ts.isAmbientModule(declaration) || (declaration.kind === 273 /* SourceFile */ && ts.isExternalOrCommonJsModule(declaration));
	        }
	        function hasNonGlobalAugmentationExternalModuleSymbol(declaration) {
	            return ts.isModuleWithStringLiteralName(declaration) || (declaration.kind === 273 /* SourceFile */ && ts.isExternalOrCommonJsModule(declaration));
	        }
	        function hasVisibleDeclarations(symbol, shouldComputeAliasToMakeVisible) {
	            var aliasesToMakeVisible;
	            if (ts.forEach(symbol.declarations, function (declaration) { return !getIsDeclarationVisible(declaration); })) {
	                return undefined;
	            }
	            return { accessibility: 0 /* Accessible */, aliasesToMakeVisible: aliasesToMakeVisible };
	            function getIsDeclarationVisible(declaration) {
	                if (!isDeclarationVisible(declaration)) {
	                    // Mark the unexported alias as visible if its parent is visible
	                    // because these kind of aliases can be used to name types in declaration file
	                    var anyImportSyntax = getAnyImportSyntax(declaration);
	                    if (anyImportSyntax &&
	                        !ts.hasModifier(anyImportSyntax, 1 /* Export */) && // import clause without export
	                        isDeclarationVisible(anyImportSyntax.parent)) {
	                        return addVisibleAlias(declaration, anyImportSyntax);
	                    }
	                    else if (ts.isVariableDeclaration(declaration) && ts.isVariableStatement(declaration.parent.parent) &&
	                        !ts.hasModifier(declaration.parent.parent, 1 /* Export */) && // unexported variable statement
	                        isDeclarationVisible(declaration.parent.parent.parent)) {
	                        return addVisibleAlias(declaration, declaration.parent.parent);
	                    }
	                    else if (ts.isLateVisibilityPaintedStatement(declaration) // unexported top-level statement
	                        && !ts.hasModifier(declaration, 1 /* Export */)
	                        && isDeclarationVisible(declaration.parent)) {
	                        return addVisibleAlias(declaration, declaration);
	                    }
	                    // Declaration is not visible
	                    return false;
	                }
	                return true;
	            }
	            function addVisibleAlias(declaration, aliasingStatement) {
	                // In function "buildTypeDisplay" where we decide whether to write type-alias or serialize types,
	                // we want to just check if type- alias is accessible or not but we don't care about emitting those alias at that time
	                // since we will do the emitting later in trackSymbol.
	                if (shouldComputeAliasToMakeVisible) {
	                    getNodeLinks(declaration).isVisible = true;
	                    aliasesToMakeVisible = ts.appendIfUnique(aliasesToMakeVisible, aliasingStatement);
	                }
	                return true;
	            }
	        }
	        function isEntityNameVisible(entityName, enclosingDeclaration) {
	            // get symbol of the first identifier of the entityName
	            var meaning;
	            if (entityName.parent.kind === 164 /* TypeQuery */ ||
	                ts.isExpressionWithTypeArgumentsInClassExtendsClause(entityName.parent) ||
	                entityName.parent.kind === 146 /* ComputedPropertyName */) {
	                // Typeof value
	                meaning = 67216319 /* Value */ | 1048576 /* ExportValue */;
	            }
	            else if (entityName.kind === 145 /* QualifiedName */ || entityName.kind === 184 /* PropertyAccessExpression */ ||
	                entityName.parent.kind === 242 /* ImportEqualsDeclaration */) {
	                // Left identifier from type reference or TypeAlias
	                // Entity name of the import declaration
	                meaning = 1920 /* Namespace */;
	            }
	            else {
	                // Type Reference or TypeAlias entity = Identifier
	                meaning = 67901928 /* Type */;
	            }
	            var firstIdentifier = getFirstIdentifier(entityName);
	            var symbol = resolveName(enclosingDeclaration, firstIdentifier.escapedText, meaning, /*nodeNotFoundErrorMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	            // Verify if the symbol is accessible
	            return (symbol && hasVisibleDeclarations(symbol, /*shouldComputeAliasToMakeVisible*/ true)) || {
	                accessibility: 1 /* NotAccessible */,
	                errorSymbolName: ts.getTextOfNode(firstIdentifier),
	                errorNode: firstIdentifier
	            };
	        }
	        function symbolToString(symbol, enclosingDeclaration, meaning, flags, writer) {
	            if (flags === void 0) { flags = 4 /* AllowAnyNodeKind */; }
	            var nodeFlags = 3112960 /* IgnoreErrors */;
	            if (flags & 2 /* UseOnlyExternalAliasing */) {
	                nodeFlags |= 128 /* UseOnlyExternalAliasing */;
	            }
	            if (flags & 1 /* WriteTypeParametersOrArguments */) {
	                nodeFlags |= 512 /* WriteTypeParametersInQualifiedName */;
	            }
	            if (flags & 8 /* UseAliasDefinedOutsideCurrentScope */) {
	                nodeFlags |= 16384 /* UseAliasDefinedOutsideCurrentScope */;
	            }
	            var builder = flags & 4 /* AllowAnyNodeKind */ ? nodeBuilder.symbolToExpression : nodeBuilder.symbolToEntityName;
	            return writer ? symbolToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(symbolToStringWorker);
	            function symbolToStringWorker(writer) {
	                var entity = builder(symbol, meaning, enclosingDeclaration, nodeFlags);
	                var printer = ts.createPrinter({ removeComments: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, entity, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function signatureToString(signature, enclosingDeclaration, flags, kind, writer) {
	            return writer ? signatureToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(signatureToStringWorker);
	            function signatureToStringWorker(writer) {
	                var sigOutput;
	                if (flags & 262144 /* WriteArrowStyleSignature */) {
	                    sigOutput = kind === 1 /* Construct */ ? 163 /* ConstructorType */ : 162 /* FunctionType */;
	                }
	                else {
	                    sigOutput = kind === 1 /* Construct */ ? 158 /* ConstructSignature */ : 157 /* CallSignature */;
	                }
	                var sig = nodeBuilder.signatureToSignatureDeclaration(signature, sigOutput, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 512 /* WriteTypeParametersInQualifiedName */);
	                var printer = ts.createPrinter({ removeComments: true, omitTrailingSemicolon: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, sig, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function typeToString(type, enclosingDeclaration, flags, writer) {
	            if (flags === void 0) { flags = 1048576 /* AllowUniqueESSymbolType */ | 16384 /* UseAliasDefinedOutsideCurrentScope */; }
	            if (writer === void 0) { writer = ts.createTextWriter(""); }
	            var typeNode = nodeBuilder.typeToTypeNode(type, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */, writer);
	            ts.Debug.assert(typeNode !== undefined, "should always get typenode");
	            var options = { removeComments: true };
	            var printer = ts.createPrinter(options);
	            var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	            printer.writeNode(4 /* Unspecified */, typeNode, /*sourceFile*/ sourceFile, writer);
	            var result = writer.getText();
	            var maxLength = compilerOptions.noErrorTruncation || flags & 1 /* NoTruncation */ ? undefined : 100;
	            if (maxLength && result && result.length >= maxLength) {
	                return result.substr(0, maxLength - "...".length) + "...";
	            }
	            return result;
	        }
	        function toNodeBuilderFlags(flags) {
	            return flags & 9469291 /* NodeBuilderFlagsMask */;
	        }
	        function createNodeBuilder() {
	            return {
	                typeToTypeNode: function (type, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeToTypeNodeHelper(type, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                indexInfoToIndexSignatureDeclaration: function (indexInfo, kind, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = indexInfoToIndexSignatureDeclarationHelper(indexInfo, kind, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                signatureToSignatureDeclaration: function (signature, kind, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = signatureToSignatureDeclarationHelper(signature, kind, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToEntityName: function (symbol, meaning, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToName(symbol, context, meaning, /*expectsIdentifier*/ false);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToExpression: function (symbol, meaning, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToExpression(symbol, context, meaning);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToTypeParameterDeclarations: function (symbol, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeParametersToTypeParameterDeclarations(symbol, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                symbolToParameterDeclaration: function (symbol, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = symbolToParameterDeclaration(symbol, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	                typeParameterToDeclaration: function (parameter, enclosingDeclaration, flags, tracker) {
	                    ts.Debug.assert(enclosingDeclaration === undefined || (enclosingDeclaration.flags & 8 /* Synthesized */) === 0);
	                    var context = createNodeBuilderContext(enclosingDeclaration, flags, tracker);
	                    var resultingNode = typeParameterToDeclaration(parameter, context);
	                    var result = context.encounteredError ? undefined : resultingNode;
	                    return result;
	                },
	            };
	            function createNodeBuilderContext(enclosingDeclaration, flags, tracker) {
	                return {
	                    enclosingDeclaration: enclosingDeclaration,
	                    flags: flags,
	                    tracker: tracker && tracker.trackSymbol ? tracker : { trackSymbol: ts.noop },
	                    encounteredError: false,
	                    visitedSymbols: undefined,
	                    inferTypeParameters: undefined
	                };
	            }
	            function typeToTypeNodeHelper(type, context) {
	                if (cancellationToken && cancellationToken.throwIfCancellationRequested) {
	                    cancellationToken.throwIfCancellationRequested();
	                }
	                var inTypeAlias = context.flags & 8388608 /* InTypeAlias */;
	                context.flags &= ~8388608 /* InTypeAlias */;
	                if (!type) {
	                    context.encounteredError = true;
	                    return undefined;
	                }
	                if (type.flags & 1 /* Any */) {
	                    return ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                }
	                if (type.flags & 2 /* String */) {
	                    return ts.createKeywordTypeNode(137 /* StringKeyword */);
	                }
	                if (type.flags & 4 /* Number */) {
	                    return ts.createKeywordTypeNode(134 /* NumberKeyword */);
	                }
	                if (type.flags & 8 /* Boolean */) {
	                    return ts.createKeywordTypeNode(122 /* BooleanKeyword */);
	                }
	                if (type.flags & 256 /* EnumLiteral */ && !(type.flags & 131072 /* Union */)) {
	                    var parentSymbol = getParentOfSymbol(type.symbol);
	                    var parentName = symbolToName(parentSymbol, context, 67901928 /* Type */, /*expectsIdentifier*/ false);
	                    var enumLiteralName = getDeclaredTypeOfSymbol(parentSymbol) === type ? parentName : ts.createQualifiedName(parentName, ts.symbolName(type.symbol));
	                    return ts.createTypeReferenceNode(enumLiteralName, /*typeArguments*/ undefined);
	                }
	                if (type.flags & 272 /* EnumLike */) {
	                    var name = symbolToName(type.symbol, context, 67901928 /* Type */, /*expectsIdentifier*/ false);
	                    return ts.createTypeReferenceNode(name, /*typeArguments*/ undefined);
	                }
	                if (type.flags & (32 /* StringLiteral */)) {
	                    return ts.createLiteralTypeNode(ts.setEmitFlags(ts.createLiteral(type.value), 16777216 /* NoAsciiEscaping */));
	                }
	                if (type.flags & (64 /* NumberLiteral */)) {
	                    return ts.createLiteralTypeNode((ts.createLiteral(type.value)));
	                }
	                if (type.flags & 128 /* BooleanLiteral */) {
	                    return type.intrinsicName === "true" ? ts.createTrue() : ts.createFalse();
	                }
	                if (type.flags & 1024 /* UniqueESSymbol */) {
	                    if (!(context.flags & 1048576 /* AllowUniqueESSymbolType */)) {
	                        if (isValueSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
	                            return symbolToTypeNode(type.symbol, context, 67216319 /* Value */);
	                        }
	                        if (context.tracker.reportInaccessibleUniqueSymbolError) {
	                            context.tracker.reportInaccessibleUniqueSymbolError();
	                        }
	                    }
	                    return ts.createTypeOperatorNode(141 /* UniqueKeyword */, ts.createKeywordTypeNode(138 /* SymbolKeyword */));
	                }
	                if (type.flags & 2048 /* Void */) {
	                    return ts.createKeywordTypeNode(105 /* VoidKeyword */);
	                }
	                if (type.flags & 4096 /* Undefined */) {
	                    return ts.createKeywordTypeNode(140 /* UndefinedKeyword */);
	                }
	                if (type.flags & 8192 /* Null */) {
	                    return ts.createKeywordTypeNode(95 /* NullKeyword */);
	                }
	                if (type.flags & 16384 /* Never */) {
	                    return ts.createKeywordTypeNode(131 /* NeverKeyword */);
	                }
	                if (type.flags & 512 /* ESSymbol */) {
	                    return ts.createKeywordTypeNode(138 /* SymbolKeyword */);
	                }
	                if (type.flags & 134217728 /* NonPrimitive */) {
	                    return ts.createKeywordTypeNode(135 /* ObjectKeyword */);
	                }
	                if (type.flags & 32768 /* TypeParameter */ && type.isThisType) {
	                    if (context.flags & 4194304 /* InObjectTypeLiteral */) {
	                        if (!context.encounteredError && !(context.flags & 32768 /* AllowThisInObjectLiteral */)) {
	                            context.encounteredError = true;
	                        }
	                        if (context.tracker.reportInaccessibleThisError) {
	                            context.tracker.reportInaccessibleThisError();
	                        }
	                    }
	                    return ts.createThis();
	                }
	                var objectFlags = ts.getObjectFlags(type);
	                if (objectFlags & 4 /* Reference */) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    return typeReferenceToTypeNode(type);
	                }
	                if (type.flags & 32768 /* TypeParameter */ || objectFlags & 3 /* ClassOrInterface */) {
	                    if (type.flags & 32768 /* TypeParameter */ && ts.contains(context.inferTypeParameters, type)) {
	                        return ts.createInferTypeNode(typeParameterToDeclarationWithConstraint(type, context, /*constraintNode*/ undefined));
	                    }
	                    if (context.flags & 4 /* GenerateNamesForShadowedTypeParams */ &&
	                        type.flags & 32768 /* TypeParameter */ &&
	                        ts.length(type.symbol.declarations) &&
	                        ts.isTypeParameterDeclaration(type.symbol.declarations[0]) &&
	                        typeParameterShadowsNameInScope(type, context) &&
	                        !isTypeSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
	                        return ts.createTypeReferenceNode(ts.getGeneratedNameForNode(type.symbol.declarations[0].name, 16 /* Optimistic */ | 8 /* ReservedInNestedScopes */), /*typeArguments*/ undefined);
	                    }
	                    // Ignore constraint/default when creating a usage (as opposed to declaration) of a type parameter.
	                    return type.symbol
	                        ? symbolToTypeNode(type.symbol, context, 67901928 /* Type */)
	                        : ts.createTypeReferenceNode(ts.createIdentifier("?"), /*typeArguments*/ undefined);
	                }
	                if (!inTypeAlias && type.aliasSymbol && (context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */ || isTypeSymbolAccessible(type.aliasSymbol, context.enclosingDeclaration))) {
	                    var typeArgumentNodes = mapToTypeNodes(type.aliasTypeArguments, context);
	                    if (isReservedMemberName(type.aliasSymbol.escapedName) && !(type.aliasSymbol.flags & 32 /* Class */))
	                        return ts.createTypeReferenceNode(ts.createIdentifier(""), typeArgumentNodes);
	                    return symbolToTypeNode(type.aliasSymbol, context, 67901928 /* Type */, typeArgumentNodes);
	                }
	                if (type.flags & (131072 /* Union */ | 262144 /* Intersection */)) {
	                    var types = type.flags & 131072 /* Union */ ? formatUnionTypes(type.types) : type.types;
	                    var typeNodes = mapToTypeNodes(types, context);
	                    if (typeNodes && typeNodes.length > 0) {
	                        var unionOrIntersectionTypeNode = ts.createUnionOrIntersectionTypeNode(type.flags & 131072 /* Union */ ? 168 /* UnionType */ : 169 /* IntersectionType */, typeNodes);
	                        return unionOrIntersectionTypeNode;
	                    }
	                    else {
	                        if (!context.encounteredError && !(context.flags & 262144 /* AllowEmptyUnionOrIntersection */)) {
	                            context.encounteredError = true;
	                        }
	                        return undefined;
	                    }
	                }
	                if (objectFlags & (16 /* Anonymous */ | 32 /* Mapped */)) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    // The type is an object literal type.
	                    return createAnonymousTypeNode(type);
	                }
	                if (type.flags & 524288 /* Index */) {
	                    var indexedType = type.type;
	                    var indexTypeNode = typeToTypeNodeHelper(indexedType, context);
	                    return ts.createTypeOperatorNode(indexTypeNode);
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    var objectTypeNode = typeToTypeNodeHelper(type.objectType, context);
	                    var indexTypeNode = typeToTypeNodeHelper(type.indexType, context);
	                    return ts.createIndexedAccessTypeNode(objectTypeNode, indexTypeNode);
	                }
	                if (type.flags & 2097152 /* Conditional */) {
	                    var checkTypeNode = typeToTypeNodeHelper(type.checkType, context);
	                    var saveInferTypeParameters = context.inferTypeParameters;
	                    context.inferTypeParameters = type.root.inferTypeParameters;
	                    var extendsTypeNode = typeToTypeNodeHelper(type.extendsType, context);
	                    context.inferTypeParameters = saveInferTypeParameters;
	                    var trueTypeNode = typeToTypeNodeHelper(getTrueTypeFromConditionalType(type), context);
	                    var falseTypeNode = typeToTypeNodeHelper(getFalseTypeFromConditionalType(type), context);
	                    return ts.createConditionalTypeNode(checkTypeNode, extendsTypeNode, trueTypeNode, falseTypeNode);
	                }
	                if (type.flags & 4194304 /* Substitution */) {
	                    return typeToTypeNodeHelper(type.typeVariable, context);
	                }
	                ts.Debug.fail("Should be unreachable.");
	                function createMappedTypeNodeFromType(type) {
	                    ts.Debug.assert(!!(type.flags & 65536 /* Object */));
	                    var readonlyToken = type.declaration.readonlyToken ? ts.createToken(type.declaration.readonlyToken.kind) : undefined;
	                    var questionToken = type.declaration.questionToken ? ts.createToken(type.declaration.questionToken.kind) : undefined;
	                    var appropriateConstraintTypeNode;
	                    if (isMappedTypeWithKeyofConstraintDeclaration(type)) {
	                        // We have a { [P in keyof T]: X }
	                        // We do this to ensure we retain the toplevel keyof-ness of the type which may be lost due to keyof distribution during `getConstraintTypeFromMappedType`
	                        appropriateConstraintTypeNode = ts.createTypeOperatorNode(typeToTypeNodeHelper(getModifiersTypeFromMappedType(type), context));
	                    }
	                    else {
	                        appropriateConstraintTypeNode = typeToTypeNodeHelper(getConstraintTypeFromMappedType(type), context);
	                    }
	                    var typeParameterNode = typeParameterToDeclarationWithConstraint(getTypeParameterFromMappedType(type), context, appropriateConstraintTypeNode);
	                    var templateTypeNode = typeToTypeNodeHelper(getTemplateTypeFromMappedType(type), context);
	                    var mappedTypeNode = ts.createMappedTypeNode(readonlyToken, typeParameterNode, questionToken, templateTypeNode);
	                    return ts.setEmitFlags(mappedTypeNode, 1 /* SingleLine */);
	                }
	                function createAnonymousTypeNode(type) {
	                    var symbol = type.symbol;
	                    var id;
	                    if (symbol) {
	                        var isConstructorObject = ts.getObjectFlags(type) & 16 /* Anonymous */ && type.symbol && type.symbol.flags & 32 /* Class */;
	                        id = (isConstructorObject ? "+" : "") + getSymbolId(symbol);
	                        if (isJavaScriptConstructor(symbol.valueDeclaration)) {
	                            // Instance and static types share the same symbol; only add 'typeof' for the static side.
	                            var isInstanceType = type === getInferredClassType(symbol) ? 67901928 /* Type */ : 67216319 /* Value */;
	                            return symbolToTypeNode(symbol, context, isInstanceType);
	                        }
	                        // Always use 'typeof T' for type of class, enum, and module objects
	                        else if (symbol.flags & 32 /* Class */ && !getBaseTypeVariableOfClass(symbol) && !(symbol.valueDeclaration.kind === 204 /* ClassExpression */ && context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */) ||
	                            symbol.flags & (384 /* Enum */ | 512 /* ValueModule */) ||
	                            shouldWriteTypeOfFunctionSymbol()) {
	                            return symbolToTypeNode(symbol, context, 67216319 /* Value */);
	                        }
	                        else if (context.visitedSymbols && context.visitedSymbols.has(id)) {
	                            // If type is an anonymous type literal in a type alias declaration, use type alias name
	                            var typeAlias = getTypeAliasForTypeLiteral(type);
	                            if (typeAlias) {
	                                // The specified symbol flags need to be reinterpreted as type flags
	                                return symbolToTypeNode(typeAlias, context, 67901928 /* Type */);
	                            }
	                            else {
	                                return ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                            }
	                        }
	                        else {
	                            // Since instantiations of the same anonymous type have the same symbol, tracking symbols instead
	                            // of types allows us to catch circular references to instantiations of the same anonymous type
	                            if (!context.visitedSymbols) {
	                                context.visitedSymbols = ts.createMap();
	                            }
	                            context.visitedSymbols.set(id, true);
	                            var result = createTypeNodeFromObjectType(type);
	                            context.visitedSymbols.delete(id);
	                            return result;
	                        }
	                    }
	                    else {
	                        // Anonymous types without a symbol are never circular.
	                        return createTypeNodeFromObjectType(type);
	                    }
	                    function shouldWriteTypeOfFunctionSymbol() {
	                        var isStaticMethodSymbol = !!(symbol.flags & 8192 /* Method */) && // typeof static method
	                            ts.some(symbol.declarations, function (declaration) { return ts.hasModifier(declaration, 32 /* Static */); });
	                        var isNonLocalFunctionSymbol = !!(symbol.flags & 16 /* Function */) &&
	                            (symbol.parent || // is exported function symbol
	                                ts.forEach(symbol.declarations, function (declaration) {
	                                    return declaration.parent.kind === 273 /* SourceFile */ || declaration.parent.kind === 239 /* ModuleBlock */;
	                                }));
	                        if (isStaticMethodSymbol || isNonLocalFunctionSymbol) {
	                            // typeof is allowed only for static/non local functions
	                            return (!!(context.flags & 4096 /* UseTypeOfFunction */) || (context.visitedSymbols && context.visitedSymbols.has(id))) && // it is type of the symbol uses itself recursively
	                                (!(context.flags & 8 /* UseStructuralFallback */) || isValueSymbolAccessible(symbol, context.enclosingDeclaration)); // And the build is going to succeed without visibility error or there is no structural fallback allowed
	                        }
	                    }
	                }
	                function createTypeNodeFromObjectType(type) {
	                    if (isGenericMappedType(type)) {
	                        return createMappedTypeNodeFromType(type);
	                    }
	                    var resolved = resolveStructuredTypeMembers(type);
	                    if (!resolved.properties.length && !resolved.stringIndexInfo && !resolved.numberIndexInfo) {
	                        if (!resolved.callSignatures.length && !resolved.constructSignatures.length) {
	                            return ts.setEmitFlags(ts.createTypeLiteralNode(/*members*/ undefined), 1 /* SingleLine */);
	                        }
	                        if (resolved.callSignatures.length === 1 && !resolved.constructSignatures.length) {
	                            var signature = resolved.callSignatures[0];
	                            var signatureNode = signatureToSignatureDeclarationHelper(signature, 162 /* FunctionType */, context);
	                            return signatureNode;
	                        }
	                        if (resolved.constructSignatures.length === 1 && !resolved.callSignatures.length) {
	                            var signature = resolved.constructSignatures[0];
	                            var signatureNode = signatureToSignatureDeclarationHelper(signature, 163 /* ConstructorType */, context);
	                            return signatureNode;
	                        }
	                    }
	                    var savedFlags = context.flags;
	                    context.flags |= 4194304 /* InObjectTypeLiteral */;
	                    var members = createTypeNodesFromResolvedType(resolved);
	                    context.flags = savedFlags;
	                    var typeLiteralNode = ts.createTypeLiteralNode(members);
	                    return ts.setEmitFlags(typeLiteralNode, (context.flags & 1024 /* MultilineObjectLiterals */) ? 0 : 1 /* SingleLine */);
	                }
	                function typeReferenceToTypeNode(type) {
	                    var typeArguments = type.typeArguments || ts.emptyArray;
	                    if (type.target === globalArrayType) {
	                        if (context.flags & 2 /* WriteArrayAsGenericType */) {
	                            var typeArgumentNode = typeToTypeNodeHelper(typeArguments[0], context);
	                            return ts.createTypeReferenceNode("Array", [typeArgumentNode]);
	                        }
	                        var elementType = typeToTypeNodeHelper(typeArguments[0], context);
	                        return ts.createArrayTypeNode(elementType);
	                    }
	                    else if (type.target.objectFlags & 8 /* Tuple */) {
	                        if (typeArguments.length > 0) {
	                            var tupleConstituentNodes = mapToTypeNodes(typeArguments.slice(0, getTypeReferenceArity(type)), context);
	                            if (tupleConstituentNodes && tupleConstituentNodes.length > 0) {
	                                return ts.createTupleTypeNode(tupleConstituentNodes);
	                            }
	                        }
	                        if (context.encounteredError || (context.flags & 524288 /* AllowEmptyTuple */)) {
	                            return ts.createTupleTypeNode([]);
	                        }
	                        context.encounteredError = true;
	                        return undefined;
	                    }
	                    else if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */ &&
	                        type.symbol.valueDeclaration &&
	                        ts.isClassLike(type.symbol.valueDeclaration) &&
	                        !isValueSymbolAccessible(type.symbol, context.enclosingDeclaration)) {
	                        return createAnonymousTypeNode(type);
	                    }
	                    else {
	                        var outerTypeParameters = type.target.outerTypeParameters;
	                        var i = 0;
	                        var resultType = void 0;
	                        if (outerTypeParameters) {
	                            var length_1 = outerTypeParameters.length;
	                            while (i < length_1) {
	                                // Find group of type arguments for type parameters with the same declaring container.
	                                var start = i;
	                                var parent = getParentSymbolOfTypeParameter(outerTypeParameters[i]);
	                                do {
	                                    i++;
	                                } while (i < length_1 && getParentSymbolOfTypeParameter(outerTypeParameters[i]) === parent);
	                                // When type parameters are their own type arguments for the whole group (i.e. we have
	                                // the default outer type arguments), we don't show the group.
	                                if (!ts.rangeEquals(outerTypeParameters, typeArguments, start, i)) {
	                                    var typeArgumentSlice = mapToTypeNodes(typeArguments.slice(start, i), context);
	                                    var flags_2 = context.flags;
	                                    context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */;
	                                    var ref = symbolToTypeNode(parent, context, 67901928 /* Type */, typeArgumentSlice);
	                                    context.flags = flags_2;
	                                    resultType = !resultType ? ref : appendReferenceToType(resultType, ref);
	                                }
	                            }
	                        }
	                        var typeArgumentNodes = void 0;
	                        if (typeArguments.length > 0) {
	                            var typeParameterCount = (type.target.typeParameters || ts.emptyArray).length;
	                            typeArgumentNodes = mapToTypeNodes(typeArguments.slice(i, typeParameterCount), context);
	                        }
	                        var flags = context.flags;
	                        context.flags |= 16 /* ForbidIndexedAccessSymbolReferences */;
	                        var finalRef = symbolToTypeNode(type.symbol, context, 67901928 /* Type */, typeArgumentNodes);
	                        context.flags = flags;
	                        return !resultType ? finalRef : appendReferenceToType(resultType, finalRef);
	                    }
	                }
	                function appendReferenceToType(root, ref) {
	                    if (ts.isImportTypeNode(root)) {
	                        // first shift type arguments
	                        var innerParams = root.typeArguments;
	                        if (root.qualifier) {
	                            (ts.isIdentifier(root.qualifier) ? root.qualifier : root.qualifier.right).typeArguments = innerParams;
	                        }
	                        root.typeArguments = ref.typeArguments;
	                        // then move qualifiers
	                        var ids = getAccessStack(ref);
	                        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
	                            var id = ids_1[_i];
	                            root.qualifier = root.qualifier ? ts.createQualifiedName(root.qualifier, id) : id;
	                        }
	                        return root;
	                    }
	                    else {
	                        // first shift type arguments
	                        var innerParams = root.typeArguments;
	                        (ts.isIdentifier(root.typeName) ? root.typeName : root.typeName.right).typeArguments = innerParams;
	                        root.typeArguments = ref.typeArguments;
	                        // then move qualifiers
	                        var ids = getAccessStack(ref);
	                        for (var _a = 0, ids_2 = ids; _a < ids_2.length; _a++) {
	                            var id = ids_2[_a];
	                            root.typeName = ts.createQualifiedName(root.typeName, id);
	                        }
	                        return root;
	                    }
	                }
	                function getAccessStack(ref) {
	                    var state = ref.typeName;
	                    var ids = [];
	                    while (!ts.isIdentifier(state)) {
	                        ids.unshift(state.right);
	                        state = state.left;
	                    }
	                    ids.unshift(state);
	                    return ids;
	                }
	                function createTypeNodesFromResolvedType(resolvedType) {
	                    var typeElements = [];
	                    for (var _i = 0, _a = resolvedType.callSignatures; _i < _a.length; _i++) {
	                        var signature = _a[_i];
	                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 157 /* CallSignature */, context));
	                    }
	                    for (var _b = 0, _c = resolvedType.constructSignatures; _b < _c.length; _b++) {
	                        var signature = _c[_b];
	                        typeElements.push(signatureToSignatureDeclarationHelper(signature, 158 /* ConstructSignature */, context));
	                    }
	                    if (resolvedType.stringIndexInfo) {
	                        var indexInfo = resolvedType.objectFlags & 2048 /* ReverseMapped */ ?
	                            createIndexInfo(anyType, resolvedType.stringIndexInfo.isReadonly, resolvedType.stringIndexInfo.declaration) :
	                            resolvedType.stringIndexInfo;
	                        typeElements.push(indexInfoToIndexSignatureDeclarationHelper(indexInfo, 0 /* String */, context));
	                    }
	                    if (resolvedType.numberIndexInfo) {
	                        typeElements.push(indexInfoToIndexSignatureDeclarationHelper(resolvedType.numberIndexInfo, 1 /* Number */, context));
	                    }
	                    var properties = resolvedType.properties;
	                    if (!properties) {
	                        return typeElements;
	                    }
	                    for (var _d = 0, properties_1 = properties; _d < properties_1.length; _d++) {
	                        var propertySymbol = properties_1[_d];
	                        if (context.flags & 2048 /* WriteClassExpressionAsTypeLiteral */) {
	                            if (propertySymbol.flags & 4194304 /* Prototype */) {
	                                continue;
	                            }
	                            if (ts.getDeclarationModifierFlagsFromSymbol(propertySymbol) & (8 /* Private */ | 16 /* Protected */) && context.tracker.reportPrivateInBaseOfClassExpression) {
	                                context.tracker.reportPrivateInBaseOfClassExpression(ts.unescapeLeadingUnderscores(propertySymbol.escapedName));
	                            }
	                        }
	                        var propertyType = ts.getCheckFlags(propertySymbol) & 2048 /* ReverseMapped */ && context.flags & 33554432 /* InReverseMappedType */ ?
	                            anyType : getTypeOfSymbol(propertySymbol);
	                        var saveEnclosingDeclaration = context.enclosingDeclaration;
	                        context.enclosingDeclaration = undefined;
	                        if (ts.getCheckFlags(propertySymbol) & 1024 /* Late */) {
	                            var decl = ts.firstOrUndefined(propertySymbol.declarations);
	                            if (context.tracker.trackSymbol && hasLateBindableName(decl)) {
	                                // get symbol of the first identifier of the entityName
	                                var firstIdentifier = getFirstIdentifier(decl.name.expression);
	                                var name = resolveName(firstIdentifier, firstIdentifier.escapedText, 67216319 /* Value */ | 1048576 /* ExportValue */, /*nodeNotFoundErrorMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	                                if (name) {
	                                    context.tracker.trackSymbol(name, saveEnclosingDeclaration, 67216319 /* Value */);
	                                }
	                            }
	                        }
	                        var propertyName = symbolToName(propertySymbol, context, 67216319 /* Value */, /*expectsIdentifier*/ true);
	                        context.enclosingDeclaration = saveEnclosingDeclaration;
	                        var optionalToken = propertySymbol.flags & 16777216 /* Optional */ ? ts.createToken(55 /* QuestionToken */) : undefined;
	                        if (propertySymbol.flags & (16 /* Function */ | 8192 /* Method */) && !getPropertiesOfObjectType(propertyType).length) {
	                            var signatures = getSignaturesOfType(propertyType, 0 /* Call */);
	                            for (var _e = 0, signatures_1 = signatures; _e < signatures_1.length; _e++) {
	                                var signature = signatures_1[_e];
	                                var methodDeclaration = signatureToSignatureDeclarationHelper(signature, 152 /* MethodSignature */, context);
	                                methodDeclaration.name = propertyName;
	                                methodDeclaration.questionToken = optionalToken;
	                                if (propertySymbol.valueDeclaration) {
	                                    // Copy comments to node for declaration emit
	                                    ts.setCommentRange(methodDeclaration, propertySymbol.valueDeclaration);
	                                }
	                                typeElements.push(methodDeclaration);
	                            }
	                        }
	                        else {
	                            var savedFlags = context.flags;
	                            context.flags |= !!(ts.getCheckFlags(propertySymbol) & 2048 /* ReverseMapped */) ? 33554432 /* InReverseMappedType */ : 0;
	                            var propertyTypeNode = propertyType ? typeToTypeNodeHelper(propertyType, context) : ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                            context.flags = savedFlags;
	                            var modifiers = isReadonlySymbol(propertySymbol) ? [ts.createToken(132 /* ReadonlyKeyword */)] : undefined;
	                            var propertySignature = ts.createPropertySignature(modifiers, propertyName, optionalToken, propertyTypeNode, 
	                            /*initializer*/ undefined);
	                            if (propertySymbol.valueDeclaration) {
	                                // Copy comments to node for declaration emit
	                                ts.setCommentRange(propertySignature, propertySymbol.valueDeclaration);
	                            }
	                            typeElements.push(propertySignature);
	                        }
	                    }
	                    return typeElements.length ? typeElements : undefined;
	                }
	            }
	            function mapToTypeNodes(types, context) {
	                if (ts.some(types)) {
	                    var result = [];
	                    for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
	                        var type = types_1[_i];
	                        var typeNode = typeToTypeNodeHelper(type, context);
	                        if (typeNode) {
	                            result.push(typeNode);
	                        }
	                    }
	                    return result;
	                }
	            }
	            function indexInfoToIndexSignatureDeclarationHelper(indexInfo, kind, context) {
	                var name = ts.getNameFromIndexInfo(indexInfo) || "x";
	                var indexerTypeNode = ts.createKeywordTypeNode(kind === 0 /* String */ ? 137 /* StringKeyword */ : 134 /* NumberKeyword */);
	                var indexingParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, name, 
	                /*questionToken*/ undefined, indexerTypeNode, 
	                /*initializer*/ undefined);
	                var typeNode = indexInfo.type ? typeToTypeNodeHelper(indexInfo.type, context) : typeToTypeNodeHelper(anyType, context);
	                if (!indexInfo.type && !(context.flags & 2097152 /* AllowEmptyIndexInfoType */)) {
	                    context.encounteredError = true;
	                }
	                return ts.createIndexSignature(
	                /*decorators*/ undefined, indexInfo.isReadonly ? [ts.createToken(132 /* ReadonlyKeyword */)] : undefined, [indexingParameter], typeNode);
	            }
	            function signatureToSignatureDeclarationHelper(signature, kind, context) {
	                var typeParameters;
	                var typeArguments;
	                if (context.flags & 32 /* WriteTypeArgumentsOfSignature */ && signature.target && signature.mapper && signature.target.typeParameters) {
	                    typeArguments = signature.target.typeParameters.map(function (parameter) { return typeToTypeNodeHelper(instantiateType(parameter, signature.mapper), context); });
	                }
	                else {
	                    typeParameters = signature.typeParameters && signature.typeParameters.map(function (parameter) { return typeParameterToDeclaration(parameter, context); });
	                }
	                var parameters = signature.parameters.map(function (parameter) { return symbolToParameterDeclaration(parameter, context, kind === 154 /* Constructor */); });
	                if (signature.thisParameter) {
	                    var thisParameter = symbolToParameterDeclaration(signature.thisParameter, context);
	                    parameters.unshift(thisParameter);
	                }
	                var returnTypeNode;
	                var typePredicate = getTypePredicateOfSignature(signature);
	                if (typePredicate) {
	                    var parameterName = typePredicate.kind === 1 /* Identifier */ ?
	                        ts.setEmitFlags(ts.createIdentifier(typePredicate.parameterName), 16777216 /* NoAsciiEscaping */) :
	                        ts.createThisTypeNode();
	                    var typeNode = typeToTypeNodeHelper(typePredicate.type, context);
	                    returnTypeNode = ts.createTypePredicateNode(parameterName, typeNode);
	                }
	                else {
	                    var returnType = getReturnTypeOfSignature(signature);
	                    returnTypeNode = returnType && typeToTypeNodeHelper(returnType, context);
	                }
	                if (context.flags & 256 /* SuppressAnyReturnType */) {
	                    if (returnTypeNode && returnTypeNode.kind === 119 /* AnyKeyword */) {
	                        returnTypeNode = undefined;
	                    }
	                }
	                else if (!returnTypeNode) {
	                    returnTypeNode = ts.createKeywordTypeNode(119 /* AnyKeyword */);
	                }
	                return ts.createSignatureDeclaration(kind, typeParameters, parameters, returnTypeNode, typeArguments);
	            }
	            function typeParameterShadowsNameInScope(type, context) {
	                return !!resolveName(context.enclosingDeclaration, type.symbol.escapedName, 67901928 /* Type */, /*nameNotFoundArg*/ undefined, type.symbol.escapedName, /*isUse*/ false);
	            }
	            function typeParameterToDeclarationWithConstraint(type, context, constraintNode) {
	                var savedContextFlags = context.flags;
	                context.flags &= ~512 /* WriteTypeParametersInQualifiedName */; // Avoids potential infinite loop when building for a claimspace with a generic
	                var shouldUseGeneratedName = context.flags & 4 /* GenerateNamesForShadowedTypeParams */ &&
	                    type.symbol.declarations[0] &&
	                    ts.isTypeParameterDeclaration(type.symbol.declarations[0]) &&
	                    typeParameterShadowsNameInScope(type, context);
	                var name = shouldUseGeneratedName
	                    ? ts.getGeneratedNameForNode(type.symbol.declarations[0].name, 16 /* Optimistic */ | 8 /* ReservedInNestedScopes */)
	                    : symbolToName(type.symbol, context, 67901928 /* Type */, /*expectsIdentifier*/ true);
	                var defaultParameter = getDefaultFromTypeParameter(type);
	                var defaultParameterNode = defaultParameter && typeToTypeNodeHelper(defaultParameter, context);
	                context.flags = savedContextFlags;
	                return ts.createTypeParameterDeclaration(name, constraintNode, defaultParameterNode);
	            }
	            function typeParameterToDeclaration(type, context, constraint) {
	                if (constraint === void 0) { constraint = getConstraintFromTypeParameter(type); }
	                var constraintNode = constraint && typeToTypeNodeHelper(constraint, context);
	                return typeParameterToDeclarationWithConstraint(type, context, constraintNode);
	            }
	            function symbolToParameterDeclaration(parameterSymbol, context, preserveModifierFlags) {
	                var parameterDeclaration = ts.getDeclarationOfKind(parameterSymbol, 148 /* Parameter */);
	                if (!parameterDeclaration && !isTransientSymbol(parameterSymbol)) {
	                    parameterDeclaration = ts.getDeclarationOfKind(parameterSymbol, 292 /* JSDocParameterTag */);
	                }
	                var parameterType = getTypeOfSymbol(parameterSymbol);
	                if (parameterDeclaration && isRequiredInitializedParameter(parameterDeclaration)) {
	                    parameterType = getOptionalType(parameterType);
	                }
	                var parameterTypeNode = typeToTypeNodeHelper(parameterType, context);
	                var modifiers = !(context.flags & 8192 /* OmitParameterModifiers */) && preserveModifierFlags && parameterDeclaration && parameterDeclaration.modifiers && parameterDeclaration.modifiers.map(ts.getSynthesizedClone);
	                var isRest = parameterDeclaration ? ts.isRestParameter(parameterDeclaration) : parameterSymbol.isRestParameter;
	                var dotDotDotToken = isRest ? ts.createToken(24 /* DotDotDotToken */) : undefined;
	                var name = parameterDeclaration
	                    ? parameterDeclaration.name ?
	                        parameterDeclaration.name.kind === 71 /* Identifier */ ? ts.setEmitFlags(ts.getSynthesizedClone(parameterDeclaration.name), 16777216 /* NoAsciiEscaping */) :
	                            parameterDeclaration.name.kind === 145 /* QualifiedName */ ? ts.setEmitFlags(ts.getSynthesizedClone(parameterDeclaration.name.right), 16777216 /* NoAsciiEscaping */) :
	                                cloneBindingName(parameterDeclaration.name) :
	                        ts.symbolName(parameterSymbol)
	                    : ts.symbolName(parameterSymbol);
	                var questionToken = parameterDeclaration && isOptionalParameter(parameterDeclaration) ? ts.createToken(55 /* QuestionToken */) : undefined;
	                var parameterNode = ts.createParameter(
	                /*decorators*/ undefined, modifiers, dotDotDotToken, name, questionToken, parameterTypeNode, 
	                /*initializer*/ undefined);
	                return parameterNode;
	                function cloneBindingName(node) {
	                    return elideInitializerAndSetEmitFlags(node);
	                    function elideInitializerAndSetEmitFlags(node) {
	                        var visited = ts.visitEachChild(node, elideInitializerAndSetEmitFlags, ts.nullTransformationContext, /*nodesVisitor*/ undefined, elideInitializerAndSetEmitFlags);
	                        var clone = ts.nodeIsSynthesized(visited) ? visited : ts.getSynthesizedClone(visited);
	                        if (clone.kind === 181 /* BindingElement */) {
	                            clone.initializer = undefined;
	                        }
	                        return ts.setEmitFlags(clone, 1 /* SingleLine */ | 16777216 /* NoAsciiEscaping */);
	                    }
	                }
	            }
	            function lookupSymbolChain(symbol, context, meaning, yieldModuleSymbol) {
	                context.tracker.trackSymbol(symbol, context.enclosingDeclaration, meaning);
	                // Try to get qualified name if the symbol is not a type parameter and there is an enclosing declaration.
	                var chain;
	                var isTypeParameter = symbol.flags & 262144 /* TypeParameter */;
	                if (!isTypeParameter && (context.enclosingDeclaration || context.flags & 64 /* UseFullyQualifiedType */)) {
	                    chain = getSymbolChain(symbol, meaning, /*endOfChain*/ true);
	                    ts.Debug.assert(chain && chain.length > 0);
	                }
	                else {
	                    chain = [symbol];
	                }
	                return chain;
	                /** @param endOfChain Set to false for recursive calls; non-recursive calls should always output something. */
	                function getSymbolChain(symbol, meaning, endOfChain) {
	                    var accessibleSymbolChain = getAccessibleSymbolChain(symbol, context.enclosingDeclaration, meaning, !!(context.flags & 128 /* UseOnlyExternalAliasing */));
	                    var parentSymbol;
	                    if (!accessibleSymbolChain ||
	                        needsQualification(accessibleSymbolChain[0], context.enclosingDeclaration, accessibleSymbolChain.length === 1 ? meaning : getQualifiedLeftMeaning(meaning))) {
	                        // Go up and add our parent.
	                        var parent = getContainerOfSymbol(accessibleSymbolChain ? accessibleSymbolChain[0] : symbol);
	                        if (parent) {
	                            var parentChain = getSymbolChain(parent, getQualifiedLeftMeaning(meaning), /*endOfChain*/ false);
	                            if (parentChain) {
	                                parentSymbol = parent;
	                                accessibleSymbolChain = parentChain.concat(accessibleSymbolChain || [getAliasForSymbolInContainer(parent, symbol) || symbol]);
	                            }
	                        }
	                    }
	                    if (accessibleSymbolChain) {
	                        return accessibleSymbolChain;
	                    }
	                    if (
	                    // If this is the last part of outputting the symbol, always output. The cases apply only to parent symbols.
	                    endOfChain ||
	                        // If a parent symbol is an external module, don't write it. (We prefer just `x` vs `"foo/bar".x`.)
	                        (yieldModuleSymbol || !(!parentSymbol && ts.forEach(symbol.declarations, hasNonGlobalAugmentationExternalModuleSymbol))) &&
	                            // If a parent symbol is an anonymous type, don't write it.
	                            !(symbol.flags & (2048 /* TypeLiteral */ | 4096 /* ObjectLiteral */))) {
	                        return [symbol];
	                    }
	                }
	            }
	            function typeParametersToTypeParameterDeclarations(symbol, context) {
	                var typeParameterNodes;
	                var targetSymbol = getTargetSymbol(symbol);
	                if (targetSymbol.flags & (32 /* Class */ | 64 /* Interface */ | 524288 /* TypeAlias */)) {
	                    typeParameterNodes = ts.createNodeArray(ts.map(getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol), function (tp) { return typeParameterToDeclaration(tp, context); }));
	                }
	                return typeParameterNodes;
	            }
	            function lookupTypeParameterNodes(chain, index, context) {
	                ts.Debug.assert(chain && 0 <= index && index < chain.length);
	                var symbol = chain[index];
	                var typeParameterNodes;
	                if (context.flags & 512 /* WriteTypeParametersInQualifiedName */ && index < (chain.length - 1)) {
	                    var parentSymbol = symbol;
	                    var nextSymbol = chain[index + 1];
	                    if (ts.getCheckFlags(nextSymbol) & 1 /* Instantiated */) {
	                        var params = getTypeParametersOfClassOrInterface(parentSymbol.flags & 2097152 /* Alias */ ? resolveAlias(parentSymbol) : parentSymbol);
	                        typeParameterNodes = mapToTypeNodes(ts.map(params, nextSymbol.mapper), context);
	                    }
	                    else {
	                        typeParameterNodes = typeParametersToTypeParameterDeclarations(symbol, context);
	                    }
	                }
	                return typeParameterNodes;
	            }
	            /**
	             * Given A[B][C][D], finds A[B]
	             */
	            function getTopmostIndexedAccessType(top) {
	                if (ts.isIndexedAccessTypeNode(top.objectType)) {
	                    return getTopmostIndexedAccessType(top.objectType);
	                }
	                return top;
	            }
	            function symbolToTypeNode(symbol, context, meaning, overrideTypeArguments) {
	                var chain = lookupSymbolChain(symbol, context, meaning, !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */)); // If we're using aliases outside the current scope, dont bother with the module
	                context.flags |= 16777216 /* InInitialEntityName */;
	                var rootName = getNameOfSymbolAsWritten(chain[0], context);
	                context.flags ^= 16777216 /* InInitialEntityName */;
	                var isTypeOf = meaning === 67216319 /* Value */;
	                if (ambientModuleSymbolRegex.test(rootName)) {
	                    // module is root, must use `ImportTypeNode`
	                    var nonRootParts = chain.length > 1 ? createAccessFromSymbolChain(chain, chain.length - 1, 1) : undefined;
	                    var typeParameterNodes = overrideTypeArguments || lookupTypeParameterNodes(chain, 0, context);
	                    var lit = ts.createLiteralTypeNode(ts.createLiteral(rootName.substring(1, rootName.length - 1)));
	                    if (!nonRootParts || ts.isEntityName(nonRootParts)) {
	                        if (nonRootParts) {
	                            var lastId = ts.isIdentifier(nonRootParts) ? nonRootParts : nonRootParts.right;
	                            lastId.typeArguments = undefined;
	                        }
	                        return ts.createImportTypeNode(lit, nonRootParts, typeParameterNodes, isTypeOf);
	                    }
	                    else {
	                        var splitNode = getTopmostIndexedAccessType(nonRootParts);
	                        var qualifier = splitNode.objectType.typeName;
	                        return ts.createIndexedAccessTypeNode(ts.createImportTypeNode(lit, qualifier, typeParameterNodes, isTypeOf), splitNode.indexType);
	                    }
	                }
	                var entityName = createAccessFromSymbolChain(chain, chain.length - 1, 0);
	                if (ts.isIndexedAccessTypeNode(entityName)) {
	                    return entityName; // Indexed accesses can never be `typeof`
	                }
	                if (isTypeOf) {
	                    return ts.createTypeQueryNode(entityName);
	                }
	                else {
	                    var lastId = ts.isIdentifier(entityName) ? entityName : entityName.right;
	                    var lastTypeArgs = lastId.typeArguments;
	                    lastId.typeArguments = undefined;
	                    return ts.createTypeReferenceNode(entityName, lastTypeArgs);
	                }
	                function createAccessFromSymbolChain(chain, index, stopper) {
	                    var typeParameterNodes = index === (chain.length - 1) ? overrideTypeArguments : lookupTypeParameterNodes(chain, index, context);
	                    var symbol = chain[index];
	                    if (index === 0) {
	                        context.flags |= 16777216 /* InInitialEntityName */;
	                    }
	                    var symbolName = getNameOfSymbolAsWritten(symbol, context);
	                    if (index === 0) {
	                        context.flags ^= 16777216 /* InInitialEntityName */;
	                    }
	                    var parent = chain[index - 1];
	                    if (!(context.flags & 16 /* ForbidIndexedAccessSymbolReferences */) && parent && getMembersOfSymbol(parent) && getMembersOfSymbol(parent).get(symbol.escapedName) === symbol) {
	                        // Should use an indexed access
	                        var LHS = createAccessFromSymbolChain(chain, index - 1, stopper);
	                        if (ts.isIndexedAccessTypeNode(LHS)) {
	                            return ts.createIndexedAccessTypeNode(LHS, ts.createLiteralTypeNode(ts.createLiteral(symbolName)));
	                        }
	                        else {
	                            return ts.createIndexedAccessTypeNode(ts.createTypeReferenceNode(LHS, typeParameterNodes), ts.createLiteralTypeNode(ts.createLiteral(symbolName)));
	                        }
	                    }
	                    var identifier = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                    identifier.symbol = symbol;
	                    if (index > stopper) {
	                        var LHS = createAccessFromSymbolChain(chain, index - 1, stopper);
	                        if (!ts.isEntityName(LHS)) {
	                            return ts.Debug.fail("Impossible construct - an export of an indexed access cannot be reachable");
	                        }
	                        return ts.createQualifiedName(LHS, identifier);
	                    }
	                    return identifier;
	                }
	            }
	            function symbolToName(symbol, context, meaning, expectsIdentifier) {
	                var chain = lookupSymbolChain(symbol, context, meaning);
	                if (expectsIdentifier && chain.length !== 1
	                    && !context.encounteredError
	                    && !(context.flags & 65536 /* AllowQualifedNameInPlaceOfIdentifier */)) {
	                    context.encounteredError = true;
	                }
	                return createEntityNameFromSymbolChain(chain, chain.length - 1);
	                function createEntityNameFromSymbolChain(chain, index) {
	                    var typeParameterNodes = lookupTypeParameterNodes(chain, index, context);
	                    var symbol = chain[index];
	                    if (index === 0) {
	                        context.flags |= 16777216 /* InInitialEntityName */;
	                    }
	                    var symbolName = getNameOfSymbolAsWritten(symbol, context);
	                    if (index === 0) {
	                        context.flags ^= 16777216 /* InInitialEntityName */;
	                    }
	                    var identifier = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                    identifier.symbol = symbol;
	                    return index > 0 ? ts.createQualifiedName(createEntityNameFromSymbolChain(chain, index - 1), identifier) : identifier;
	                }
	            }
	            function symbolToExpression(symbol, context, meaning) {
	                var chain = lookupSymbolChain(symbol, context, meaning);
	                return createExpressionFromSymbolChain(chain, chain.length - 1);
	                function createExpressionFromSymbolChain(chain, index) {
	                    var typeParameterNodes = lookupTypeParameterNodes(chain, index, context);
	                    var symbol = chain[index];
	                    if (index === 0) {
	                        context.flags |= 16777216 /* InInitialEntityName */;
	                    }
	                    var symbolName = getNameOfSymbolAsWritten(symbol, context);
	                    if (index === 0) {
	                        context.flags ^= 16777216 /* InInitialEntityName */;
	                    }
	                    var firstChar = symbolName.charCodeAt(0);
	                    var canUsePropertyAccess = ts.isIdentifierStart(firstChar, languageVersion);
	                    if (index === 0 || canUsePropertyAccess) {
	                        var identifier = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                        identifier.symbol = symbol;
	                        return index > 0 ? ts.createPropertyAccess(createExpressionFromSymbolChain(chain, index - 1), identifier) : identifier;
	                    }
	                    else {
	                        if (firstChar === 91 /* openBracket */) {
	                            symbolName = symbolName.substring(1, symbolName.length - 1);
	                            firstChar = symbolName.charCodeAt(0);
	                        }
	                        var expression = void 0;
	                        if (ts.isSingleOrDoubleQuote(firstChar)) {
	                            expression = ts.createLiteral(symbolName.substring(1, symbolName.length - 1).replace(/\\./g, function (s) { return s.substring(1); }));
	                            expression.singleQuote = firstChar === 39 /* singleQuote */;
	                        }
	                        else if (("" + +symbolName) === symbolName) {
	                            expression = ts.createLiteral(+symbolName);
	                        }
	                        if (!expression) {
	                            expression = ts.setEmitFlags(ts.createIdentifier(symbolName, typeParameterNodes), 16777216 /* NoAsciiEscaping */);
	                            expression.symbol = symbol;
	                        }
	                        return ts.createElementAccess(createExpressionFromSymbolChain(chain, index - 1), expression);
	                    }
	                }
	            }
	        }
	        function typePredicateToString(typePredicate, enclosingDeclaration, flags, writer) {
	            if (flags === void 0) { flags = 16384 /* UseAliasDefinedOutsideCurrentScope */; }
	            return writer ? typePredicateToStringWorker(writer).getText() : ts.usingSingleLineStringWriter(typePredicateToStringWorker);
	            function typePredicateToStringWorker(writer) {
	                var predicate = ts.createTypePredicateNode(typePredicate.kind === 1 /* Identifier */ ? ts.createIdentifier(typePredicate.parameterName) : ts.createThisTypeNode(), nodeBuilder.typeToTypeNode(typePredicate.type, enclosingDeclaration, toNodeBuilderFlags(flags) | 3112960 /* IgnoreErrors */ | 512 /* WriteTypeParametersInQualifiedName */));
	                var printer = ts.createPrinter({ removeComments: true });
	                var sourceFile = enclosingDeclaration && ts.getSourceFileOfNode(enclosingDeclaration);
	                printer.writeNode(4 /* Unspecified */, predicate, /*sourceFile*/ sourceFile, writer);
	                return writer;
	            }
	        }
	        function formatUnionTypes(types) {
	            var result = [];
	            var flags = 0;
	            for (var i = 0; i < types.length; i++) {
	                var t = types[i];
	                flags |= t.flags;
	                if (!(t.flags & 12288 /* Nullable */)) {
	                    if (t.flags & (128 /* BooleanLiteral */ | 256 /* EnumLiteral */)) {
	                        var baseType = t.flags & 128 /* BooleanLiteral */ ? booleanType : getBaseTypeOfEnumLiteralType(t);
	                        if (baseType.flags & 131072 /* Union */) {
	                            var count = baseType.types.length;
	                            if (i + count <= types.length && types[i + count - 1] === baseType.types[count - 1]) {
	                                result.push(baseType);
	                                i += count - 1;
	                                continue;
	                            }
	                        }
	                    }
	                    result.push(t);
	                }
	            }
	            if (flags & 8192 /* Null */)
	                result.push(nullType);
	            if (flags & 4096 /* Undefined */)
	                result.push(undefinedType);
	            return result || types;
	        }
	        function visibilityToString(flags) {
	            if (flags === 8 /* Private */) {
	                return "private";
	            }
	            if (flags === 16 /* Protected */) {
	                return "protected";
	            }
	            return "public";
	        }
	        function getTypeAliasForTypeLiteral(type) {
	            if (type.symbol && type.symbol.flags & 2048 /* TypeLiteral */) {
	                var node = ts.findAncestor(type.symbol.declarations[0].parent, function (n) { return n.kind !== 172 /* ParenthesizedType */; });
	                if (node.kind === 236 /* TypeAliasDeclaration */) {
	                    return getSymbolOfNode(node);
	                }
	            }
	            return undefined;
	        }
	        function isTopLevelInExternalModuleAugmentation(node) {
	            return node && node.parent &&
	                node.parent.kind === 239 /* ModuleBlock */ &&
	                ts.isExternalModuleAugmentation(node.parent.parent);
	        }
	        function isDefaultBindingContext(location) {
	            return location.kind === 273 /* SourceFile */ || ts.isAmbientModule(location);
	        }
	        /**
	         * Gets a human-readable name for a symbol.
	         * Should *not* be used for the right-hand side of a `.` -- use `symbolName(symbol)` for that instead.
	         *
	         * Unlike `symbolName(symbol)`, this will include quotes if the name is from a string literal.
	         * It will also use a representation of a number as written instead of a decimal form, e.g. `0o11` instead of `9`.
	         */
	        function getNameOfSymbolAsWritten(symbol, context) {
	            if (context && symbol.escapedName === "default" /* Default */ && !(context.flags & 16384 /* UseAliasDefinedOutsideCurrentScope */) &&
	                // If it's not the first part of an entity name, it must print as `default`
	                (!(context.flags & 16777216 /* InInitialEntityName */) ||
	                    // if the symbol is synthesized, it will only be referenced externally it must print as `default`
	                    !symbol.declarations ||
	                    // if not in the same binding context (source file, module declaration), it must print as `default`
	                    (context.enclosingDeclaration && ts.findAncestor(symbol.declarations[0], isDefaultBindingContext) !== ts.findAncestor(context.enclosingDeclaration, isDefaultBindingContext)))) {
	                return "default";
	            }
	            if (symbol.declarations && symbol.declarations.length) {
	                if (ts.some(symbol.declarations, hasExternalModuleSymbol) && context.enclosingDeclaration) {
	                    var file_3 = ts.getDeclarationOfKind(symbol, 273 /* SourceFile */);
	                    if (!file_3 || !context.tracker.moduleResolverHost) {
	                        if (context.tracker.trackReferencedAmbientModule) {
	                            var ambientDecls = ts.filter(symbol.declarations, ts.isAmbientModule);
	                            if (ts.length(ambientDecls)) {
	                                for (var _i = 0, ambientDecls_1 = ambientDecls; _i < ambientDecls_1.length; _i++) {
	                                    var decl = ambientDecls_1[_i];
	                                    context.tracker.trackReferencedAmbientModule(decl);
	                                }
	                            }
	                        }
	                        // ambient module, just use declaration/symbol name (fallthrough)
	                    }
	                    else {
	                        var contextFile = ts.getSourceFileOfNode(ts.getOriginalNode(context.enclosingDeclaration));
	                        return "\"" + (file_3.moduleName || ts.moduleSpecifiers.getModuleSpecifiers(symbol, compilerOptions, contextFile, context.tracker.moduleResolverHost, context.tracker.moduleResolverHost.getSourceFiles(), { importModuleSpecifierPreference: "non-relative" })[0]) + "\"";
	                    }
	                }
	                var declaration = symbol.declarations[0];
	                var name = ts.getNameOfDeclaration(declaration);
	                if (name) {
	                    return ts.declarationNameToString(name);
	                }
	                if (declaration.parent && declaration.parent.kind === 231 /* VariableDeclaration */) {
	                    return ts.declarationNameToString(declaration.parent.name);
	                }
	                if (context && !context.encounteredError && !(context.flags & 131072 /* AllowAnonymousIdentifier */)) {
	                    context.encounteredError = true;
	                }
	                switch (declaration.kind) {
	                    case 204 /* ClassExpression */:
	                        return "(Anonymous class)";
	                    case 191 /* FunctionExpression */:
	                    case 192 /* ArrowFunction */:
	                        return "(Anonymous function)";
	                }
	            }
	            var nameType = symbol.nameType;
	            if (nameType) {
	                if (nameType.flags & 32 /* StringLiteral */ && !ts.isIdentifierText(nameType.value, compilerOptions.target)) {
	                    return "\"" + ts.escapeString(nameType.value, 34 /* doubleQuote */) + "\"";
	                }
	                if (nameType && nameType.flags & 1024 /* UniqueESSymbol */) {
	                    return "[" + getNameOfSymbolAsWritten(nameType.symbol, context) + "]";
	                }
	            }
	            return ts.symbolName(symbol);
	        }
	        function isDeclarationVisible(node) {
	            if (node) {
	                var links = getNodeLinks(node);
	                if (links.isVisible === undefined) {
	                    links.isVisible = !!determineIfDeclarationIsVisible();
	                }
	                return links.isVisible;
	            }
	            return false;
	            function determineIfDeclarationIsVisible() {
	                switch (node.kind) {
	                    case 291 /* JSDocCallbackTag */:
	                    case 296 /* JSDocTypedefTag */:
	                        // Top-level jsdoc type aliases are considered exported
	                        // First parent is comment node, second is hosting declaration or token; we only care about those tokens or declarations whose parent is a source file
	                        return !!(node.parent && node.parent.parent && node.parent.parent.parent && ts.isSourceFile(node.parent.parent.parent));
	                    case 181 /* BindingElement */:
	                        return isDeclarationVisible(node.parent.parent);
	                    case 231 /* VariableDeclaration */:
	                        if (ts.isBindingPattern(node.name) &&
	                            !node.name.elements.length) {
	                            // If the binding pattern is empty, this variable declaration is not visible
	                            return false;
	                        }
	                    // falls through
	                    case 238 /* ModuleDeclaration */:
	                    case 234 /* ClassDeclaration */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 236 /* TypeAliasDeclaration */:
	                    case 233 /* FunctionDeclaration */:
	                    case 237 /* EnumDeclaration */:
	                    case 242 /* ImportEqualsDeclaration */:
	                        // external module augmentation is always visible
	                        if (ts.isExternalModuleAugmentation(node)) {
	                            return true;
	                        }
	                        var parent = getDeclarationContainer(node);
	                        // If the node is not exported or it is not ambient module element (except import declaration)
	                        if (!(ts.getCombinedModifierFlags(node) & 1 /* Export */) &&
	                            !(node.kind !== 242 /* ImportEqualsDeclaration */ && parent.kind !== 273 /* SourceFile */ && parent.flags & 4194304 /* Ambient */)) {
	                            return isGlobalSourceFile(parent);
	                        }
	                        // Exported members/ambient module elements (exception import declaration) are visible if parent is visible
	                        return isDeclarationVisible(parent);
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.hasModifier(node, 8 /* Private */ | 16 /* Protected */)) {
	                            // Private/protected properties/methods are not visible
	                            return false;
	                        }
	                    // Public properties/methods are visible if its parents are visible, so:
	                    // falls through
	                    case 154 /* Constructor */:
	                    case 158 /* ConstructSignature */:
	                    case 157 /* CallSignature */:
	                    case 159 /* IndexSignature */:
	                    case 148 /* Parameter */:
	                    case 239 /* ModuleBlock */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 165 /* TypeLiteral */:
	                    case 161 /* TypeReference */:
	                    case 166 /* ArrayType */:
	                    case 167 /* TupleType */:
	                    case 168 /* UnionType */:
	                    case 169 /* IntersectionType */:
	                    case 172 /* ParenthesizedType */:
	                        return isDeclarationVisible(node.parent);
	                    // Default binding, import specifier and namespace import is visible
	                    // only on demand so by default it is not visible
	                    case 244 /* ImportClause */:
	                    case 245 /* NamespaceImport */:
	                    case 247 /* ImportSpecifier */:
	                        return false;
	                    // Type parameters are always visible
	                    case 147 /* TypeParameter */:
	                    // Source file and namespace export are always visible
	                    case 273 /* SourceFile */:
	                    case 241 /* NamespaceExportDeclaration */:
	                        return true;
	                    // Export assignments do not create name bindings outside the module
	                    case 248 /* ExportAssignment */:
	                        return false;
	                    default:
	                        return false;
	                }
	            }
	        }
	        function collectLinkedAliases(node, setVisibility) {
	            var exportSymbol;
	            if (node.parent && node.parent.kind === 248 /* ExportAssignment */) {
	                exportSymbol = resolveName(node, node.escapedText, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */, /*nameNotFoundMessage*/ undefined, node, /*isUse*/ false);
	            }
	            else if (node.parent.kind === 251 /* ExportSpecifier */) {
	                exportSymbol = getTargetOfExportSpecifier(node.parent, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */);
	            }
	            var result;
	            if (exportSymbol) {
	                buildVisibleNodeList(exportSymbol.declarations);
	            }
	            return result;
	            function buildVisibleNodeList(declarations) {
	                ts.forEach(declarations, function (declaration) {
	                    var resultNode = getAnyImportSyntax(declaration) || declaration;
	                    if (setVisibility) {
	                        getNodeLinks(declaration).isVisible = true;
	                    }
	                    else {
	                        result = result || [];
	                        ts.pushIfUnique(result, resultNode);
	                    }
	                    if (ts.isInternalModuleImportEqualsDeclaration(declaration)) {
	                        // Add the referenced top container visible
	                        var internalModuleReference = declaration.moduleReference;
	                        var firstIdentifier = getFirstIdentifier(internalModuleReference);
	                        var importSymbol = resolveName(declaration, firstIdentifier.escapedText, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */, undefined, undefined, /*isUse*/ false);
	                        if (importSymbol) {
	                            buildVisibleNodeList(importSymbol.declarations);
	                        }
	                    }
	                });
	            }
	        }
	        /**
	         * Push an entry on the type resolution stack. If an entry with the given target and the given property name
	         * is already on the stack, and no entries in between already have a type, then a circularity has occurred.
	         * In this case, the result values of the existing entry and all entries pushed after it are changed to false,
	         * and the value false is returned. Otherwise, the new entry is just pushed onto the stack, and true is returned.
	         * In order to see if the same query has already been done before, the target object and the propertyName both
	         * must match the one passed in.
	         *
	         * @param target The symbol, type, or signature whose type is being queried
	         * @param propertyName The property name that should be used to query the target for its type
	         */
	        function pushTypeResolution(target, propertyName) {
	            var resolutionCycleStartIndex = findResolutionCycleStartIndex(target, propertyName);
	            if (resolutionCycleStartIndex >= 0) {
	                // A cycle was found
	                var length_2 = resolutionTargets.length;
	                for (var i = resolutionCycleStartIndex; i < length_2; i++) {
	                    resolutionResults[i] = false;
	                }
	                return false;
	            }
	            resolutionTargets.push(target);
	            resolutionResults.push(/*items*/ true);
	            resolutionPropertyNames.push(propertyName);
	            return true;
	        }
	        function findResolutionCycleStartIndex(target, propertyName) {
	            for (var i = resolutionTargets.length - 1; i >= 0; i--) {
	                if (hasType(resolutionTargets[i], resolutionPropertyNames[i])) {
	                    return -1;
	                }
	                if (resolutionTargets[i] === target && resolutionPropertyNames[i] === propertyName) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function hasType(target, propertyName) {
	            if (propertyName === 0 /* Type */) {
	                return getSymbolLinks(target).type;
	            }
	            if (propertyName === 2 /* DeclaredType */) {
	                return getSymbolLinks(target).declaredType;
	            }
	            if (propertyName === 1 /* ResolvedBaseConstructorType */) {
	                return target.resolvedBaseConstructorType;
	            }
	            if (propertyName === 3 /* ResolvedReturnType */) {
	                return target.resolvedReturnType;
	            }
	            if (propertyName === 4 /* ResolvedBaseConstraint */) {
	                var bc = target.resolvedBaseConstraint;
	                return bc && bc !== circularConstraintType;
	            }
	            ts.Debug.fail("Unhandled TypeSystemPropertyName " + propertyName);
	        }
	        // Pop an entry from the type resolution stack and return its associated result value. The result value will
	        // be true if no circularities were detected, or false if a circularity was found.
	        function popTypeResolution() {
	            resolutionTargets.pop();
	            resolutionPropertyNames.pop();
	            return resolutionResults.pop();
	        }
	        function getDeclarationContainer(node) {
	            node = ts.findAncestor(ts.getRootDeclaration(node), function (node) {
	                switch (node.kind) {
	                    case 231 /* VariableDeclaration */:
	                    case 232 /* VariableDeclarationList */:
	                    case 247 /* ImportSpecifier */:
	                    case 246 /* NamedImports */:
	                    case 245 /* NamespaceImport */:
	                    case 244 /* ImportClause */:
	                        return false;
	                    default:
	                        return true;
	                }
	            });
	            return node && node.parent;
	        }
	        function getTypeOfPrototypeProperty(prototype) {
	            // TypeScript 1.0 spec (April 2014): 8.4
	            // Every class automatically contains a static property member named 'prototype',
	            // the type of which is an instantiation of the class type with type Any supplied as a type argument for each type parameter.
	            // It is an error to explicitly declare a static property member with the name 'prototype'.
	            var classType = getDeclaredTypeOfSymbol(getParentOfSymbol(prototype));
	            return classType.typeParameters ? createTypeReference(classType, ts.map(classType.typeParameters, function (_) { return anyType; })) : classType;
	        }
	        // Return the type of the given property in the given type, or undefined if no such property exists
	        function getTypeOfPropertyOfType(type, name) {
	            var prop = getPropertyOfType(type, name);
	            return prop ? getTypeOfSymbol(prop) : undefined;
	        }
	        function isTypeAny(type) {
	            return type && (type.flags & 1 /* Any */) !== 0;
	        }
	        // Return the type of a binding element parent. We check SymbolLinks first to see if a type has been
	        // assigned by contextual typing.
	        function getTypeForBindingElementParent(node) {
	            var symbol = getSymbolOfNode(node);
	            return symbol && getSymbolLinks(symbol).type || getTypeForVariableLikeDeclaration(node, /*includeOptionality*/ false);
	        }
	        function isComputedNonLiteralName(name) {
	            return name.kind === 146 /* ComputedPropertyName */ && !ts.isStringOrNumericLiteral(name.expression);
	        }
	        function getRestType(source, properties, symbol) {
	            source = filterType(source, function (t) { return !(t.flags & 12288 /* Nullable */); });
	            if (source.flags & 16384 /* Never */) {
	                return emptyObjectType;
	            }
	            if (source.flags & 131072 /* Union */) {
	                return mapType(source, function (t) { return getRestType(t, properties, symbol); });
	            }
	            var members = ts.createSymbolTable();
	            var names = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, properties_2 = properties; _i < properties_2.length; _i++) {
	                var name = properties_2[_i];
	                names.set(ts.getTextOfPropertyName(name), true);
	            }
	            for (var _a = 0, _b = getPropertiesOfType(source); _a < _b.length; _a++) {
	                var prop = _b[_a];
	                var inNamesToRemove = names.has(prop.escapedName);
	                var isPrivate = ts.getDeclarationModifierFlagsFromSymbol(prop) & (8 /* Private */ | 16 /* Protected */);
	                var isSetOnlyAccessor = prop.flags & 65536 /* SetAccessor */ && !(prop.flags & 32768 /* GetAccessor */);
	                if (!inNamesToRemove && !isPrivate && !isClassMethod(prop) && !isSetOnlyAccessor) {
	                    members.set(prop.escapedName, getNonReadonlySymbol(prop));
	                }
	            }
	            var stringIndexInfo = getIndexInfoOfType(source, 0 /* String */);
	            var numberIndexInfo = getIndexInfoOfType(source, 1 /* Number */);
	            return createAnonymousType(symbol, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	        }
	        /** Return the inferred type for a binding element */
	        function getTypeForBindingElement(declaration) {
	            var pattern = declaration.parent;
	            var parentType = getTypeForBindingElementParent(pattern.parent);
	            // If parent has the unknown (error) type, then so does this binding element
	            if (parentType === unknownType) {
	                return unknownType;
	            }
	            // If no type was specified or inferred for parent,
	            // infer from the initializer of the binding element if one is present.
	            // Otherwise, go with the undefined type of the parent.
	            if (!parentType) {
	                return declaration.initializer ? checkDeclarationInitializer(declaration) : parentType;
	            }
	            if (isTypeAny(parentType)) {
	                return parentType;
	            }
	            var type;
	            if (pattern.kind === 179 /* ObjectBindingPattern */) {
	                if (declaration.dotDotDotToken) {
	                    if (!isValidSpreadType(parentType)) {
	                        error(declaration, ts.Diagnostics.Rest_types_may_only_be_created_from_object_types);
	                        return unknownType;
	                    }
	                    var literalMembers = [];
	                    for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                        var element = _a[_i];
	                        if (!element.dotDotDotToken) {
	                            literalMembers.push(element.propertyName || element.name);
	                        }
	                    }
	                    type = getRestType(parentType, literalMembers, declaration.symbol);
	                }
	                else {
	                    // Use explicitly specified property name ({ p: xxx } form), or otherwise the implied name ({ p } form)
	                    var name = declaration.propertyName || declaration.name;
	                    var isLate = isLateBindableName(name);
	                    var isWellKnown = ts.isComputedPropertyName(name) && ts.isWellKnownSymbolSyntactically(name.expression);
	                    if (!isLate && !isWellKnown && isComputedNonLiteralName(name)) {
	                        var exprType = checkExpression(name.expression);
	                        if (isTypeAssignableToKind(exprType, 1536 /* ESSymbolLike */)) {
	                            if (noImplicitAny) {
	                                error(declaration, ts.Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(exprType), typeToString(parentType));
	                            }
	                            return anyType;
	                        }
	                        var indexerType = isTypeAssignableToKind(exprType, 84 /* NumberLike */) && getIndexTypeOfType(parentType, 1 /* Number */) || getIndexTypeOfType(parentType, 0 /* String */);
	                        if (!indexerType && noImplicitAny && !compilerOptions.suppressImplicitAnyIndexErrors) {
	                            if (getIndexTypeOfType(parentType, 1 /* Number */)) {
	                                error(declaration, ts.Diagnostics.Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number);
	                            }
	                            else {
	                                error(declaration, ts.Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature, typeToString(parentType));
	                            }
	                        }
	                        return indexerType || anyType;
	                    }
	                    // Use type of the specified property, or otherwise, for a numeric name, the type of the numeric index signature,
	                    // or otherwise the type of the string index signature.
	                    var nameType = isLate && checkComputedPropertyName(name);
	                    var text = isLate ? getLateBoundNameFromType(nameType) :
	                        isWellKnown ? ts.getPropertyNameForKnownSymbolName(ts.idText(name.expression.name)) :
	                            ts.getTextOfPropertyName(name);
	                    // Relax null check on ambient destructuring parameters, since the parameters have no implementation and are just documentation
	                    if (strictNullChecks && declaration.flags & 4194304 /* Ambient */ && ts.isParameterDeclaration(declaration)) {
	                        parentType = getNonNullableType(parentType);
	                    }
	                    if (isLate && nameType && !getPropertyOfType(parentType, text) && isTypeAssignableToKind(nameType, 1536 /* ESSymbolLike */)) {
	                        if (noImplicitAny) {
	                            error(declaration, ts.Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(nameType), typeToString(parentType));
	                        }
	                        return anyType;
	                    }
	                    var declaredType = getConstraintForLocation(getTypeOfPropertyOfType(parentType, text), declaration.name);
	                    type = declaredType && getFlowTypeOfReference(declaration, declaredType) ||
	                        isNumericLiteralName(text) && getIndexTypeOfType(parentType, 1 /* Number */) ||
	                        getIndexTypeOfType(parentType, 0 /* String */);
	                    if (!type) {
	                        error(name, ts.Diagnostics.Type_0_has_no_property_1_and_no_string_index_signature, typeToString(parentType), ts.declarationNameToString(name));
	                        return unknownType;
	                    }
	                }
	            }
	            else {
	                // This elementType will be used if the specific property corresponding to this index is not
	                // present (aka the tuple element property). This call also checks that the parentType is in
	                // fact an iterable or array (depending on target language).
	                var elementType = checkIteratedTypeOrElementType(parentType, pattern, /*allowStringInput*/ false, /*allowAsyncIterables*/ false);
	                if (declaration.dotDotDotToken) {
	                    // Rest element has an array type with the same element type as the parent type
	                    type = createArrayType(elementType);
	                }
	                else {
	                    // Use specific property type when parent is a tuple or numeric index type when parent is an array
	                    var propName = "" + pattern.elements.indexOf(declaration);
	                    type = isTupleLikeType(parentType)
	                        ? getTypeOfPropertyOfType(parentType, propName)
	                        : elementType;
	                    if (!type) {
	                        if (isTupleType(parentType)) {
	                            error(declaration, ts.Diagnostics.Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2, typeToString(parentType), getTypeReferenceArity(parentType), pattern.elements.length);
	                        }
	                        else {
	                            error(declaration, ts.Diagnostics.Type_0_has_no_property_1, typeToString(parentType), propName);
	                        }
	                        return unknownType;
	                    }
	                }
	            }
	            // In strict null checking mode, if a default value of a non-undefined type is specified, remove
	            // undefined from the final type.
	            if (strictNullChecks && declaration.initializer && !(getFalsyFlags(checkExpressionCached(declaration.initializer)) & 4096 /* Undefined */)) {
	                type = getTypeWithFacts(type, 131072 /* NEUndefined */);
	            }
	            return declaration.initializer ?
	                getUnionType([type, checkExpressionCached(declaration.initializer)], 2 /* Subtype */) :
	                type;
	        }
	        function getTypeForDeclarationFromJSDocComment(declaration) {
	            var jsdocType = ts.getJSDocType(declaration);
	            if (jsdocType) {
	                return getTypeFromTypeNode(jsdocType);
	            }
	            return undefined;
	        }
	        function isNullOrUndefined(node) {
	            var expr = ts.skipParentheses(node);
	            return expr.kind === 95 /* NullKeyword */ || expr.kind === 71 /* Identifier */ && getResolvedSymbol(expr) === undefinedSymbol;
	        }
	        function isEmptyArrayLiteral(node) {
	            var expr = ts.skipParentheses(node);
	            return expr.kind === 182 /* ArrayLiteralExpression */ && expr.elements.length === 0;
	        }
	        function addOptionality(type, optional) {
	            if (optional === void 0) { optional = true; }
	            return strictNullChecks && optional ? getOptionalType(type) : type;
	        }
	        // Return the inferred type for a variable, parameter, or property declaration
	        function getTypeForVariableLikeDeclaration(declaration, includeOptionality) {
	            // A variable declared in a for..in statement is of type string, or of type keyof T when the
	            // right hand expression is of a type parameter type.
	            if (ts.isVariableDeclaration(declaration) && declaration.parent.parent.kind === 220 /* ForInStatement */) {
	                var indexType = getIndexType(checkNonNullExpression(declaration.parent.parent.expression));
	                return indexType.flags & (32768 /* TypeParameter */ | 524288 /* Index */) ? getExtractStringType(indexType) : stringType;
	            }
	            if (ts.isVariableDeclaration(declaration) && declaration.parent.parent.kind === 221 /* ForOfStatement */) {
	                // checkRightHandSideOfForOf will return undefined if the for-of expression type was
	                // missing properties/signatures required to get its iteratedType (like
	                // [Symbol.iterator] or next). This may be because we accessed properties from anyType,
	                // or it may have led to an error inside getElementTypeOfIterable.
	                var forOfStatement = declaration.parent.parent;
	                return checkRightHandSideOfForOf(forOfStatement.expression, forOfStatement.awaitModifier) || anyType;
	            }
	            if (ts.isBindingPattern(declaration.parent)) {
	                return getTypeForBindingElement(declaration);
	            }
	            var isOptional = includeOptionality && (ts.isParameter(declaration) && isJSDocOptionalParameter(declaration)
	                || !ts.isBindingElement(declaration) && !ts.isVariableDeclaration(declaration) && !!declaration.questionToken);
	            // Use type from type annotation if one is present
	            var declaredType = tryGetTypeFromEffectiveTypeNode(declaration);
	            if (declaredType) {
	                return addOptionality(declaredType, isOptional);
	            }
	            if ((noImplicitAny || ts.isInJavaScriptFile(declaration)) &&
	                declaration.kind === 231 /* VariableDeclaration */ && !ts.isBindingPattern(declaration.name) &&
	                !(ts.getCombinedModifierFlags(declaration) & 1 /* Export */) && !(declaration.flags & 4194304 /* Ambient */)) {
	                // If --noImplicitAny is on or the declaration is in a Javascript file,
	                // use control flow tracked 'any' type for non-ambient, non-exported var or let variables with no
	                // initializer or a 'null' or 'undefined' initializer.
	                if (!(ts.getCombinedNodeFlags(declaration) & 2 /* Const */) && (!declaration.initializer || isNullOrUndefined(declaration.initializer))) {
	                    return autoType;
	                }
	                // Use control flow tracked 'any[]' type for non-ambient, non-exported variables with an empty array
	                // literal initializer.
	                if (declaration.initializer && isEmptyArrayLiteral(declaration.initializer)) {
	                    return autoArrayType;
	                }
	            }
	            if (declaration.kind === 148 /* Parameter */) {
	                var func = declaration.parent;
	                // For a parameter of a set accessor, use the type of the get accessor if one is present
	                if (func.kind === 156 /* SetAccessor */ && !hasNonBindableDynamicName(func)) {
	                    var getter = ts.getDeclarationOfKind(getSymbolOfNode(declaration.parent), 155 /* GetAccessor */);
	                    if (getter) {
	                        var getterSignature = getSignatureFromDeclaration(getter);
	                        var thisParameter = getAccessorThisParameter(func);
	                        if (thisParameter && declaration === thisParameter) {
	                            // Use the type from the *getter*
	                            ts.Debug.assert(!thisParameter.type);
	                            return getTypeOfSymbol(getterSignature.thisParameter);
	                        }
	                        return getReturnTypeOfSignature(getterSignature);
	                    }
	                }
	                // Use contextual parameter type if one is available
	                var type = void 0;
	                if (declaration.symbol.escapedName === "this") {
	                    type = getContextualThisParameterType(func);
	                }
	                else {
	                    type = getContextuallyTypedParameterType(declaration);
	                }
	                if (type) {
	                    return addOptionality(type, isOptional);
	                }
	            }
	            // Use the type of the initializer expression if one is present
	            if (declaration.initializer) {
	                var type = checkDeclarationInitializer(declaration);
	                return addOptionality(type, isOptional);
	            }
	            if (ts.isJsxAttribute(declaration)) {
	                // if JSX attribute doesn't have initializer, by default the attribute will have boolean value of true.
	                // I.e <Elem attr /> is sugar for <Elem attr={true} />
	                return trueType;
	            }
	            // If the declaration specifies a binding pattern, use the type implied by the binding pattern
	            if (ts.isBindingPattern(declaration.name)) {
	                return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ false, /*reportErrors*/ true);
	            }
	            // No type specified and nothing can be inferred
	            return undefined;
	        }
	        function getWidenedTypeFromJSSpecialPropertyDeclarations(symbol) {
	            // function/class/{} assignments are fresh declarations, not property assignments, so only add prototype assignments
	            var specialDeclaration = ts.getAssignedJavascriptInitializer(symbol.valueDeclaration);
	            if (specialDeclaration) {
	                return getWidenedLiteralType(checkExpressionCached(specialDeclaration));
	            }
	            var types = [];
	            var constructorTypes;
	            var definedInConstructor = false;
	            var definedInMethod = false;
	            var jsDocType;
	            var _loop_3 = function (declaration) {
	                var declarationInConstructor = false;
	                var expression = declaration.kind === 199 /* BinaryExpression */ ? declaration :
	                    declaration.kind === 184 /* PropertyAccessExpression */ ? ts.cast(declaration.parent, ts.isBinaryExpression) :
	                        undefined;
	                if (!expression) {
	                    return { value: unknownType };
	                }
	                var special = ts.getSpecialPropertyAssignmentKind(expression);
	                if (special === 4 /* ThisProperty */) {
	                    var thisContainer = ts.getThisContainer(expression, /*includeArrowFunctions*/ false);
	                    // Properties defined in a constructor (or base constructor, or javascript constructor function) don't get undefined added.
	                    // Function expressions that are assigned to the prototype count as methods.
	                    declarationInConstructor = thisContainer.kind === 154 /* Constructor */ ||
	                        thisContainer.kind === 233 /* FunctionDeclaration */ ||
	                        (thisContainer.kind === 191 /* FunctionExpression */ && !ts.isPrototypePropertyAssignment(thisContainer.parent));
	                    if (declarationInConstructor) {
	                        definedInConstructor = true;
	                    }
	                    else {
	                        definedInMethod = true;
	                    }
	                }
	                // If there is a JSDoc type, use it
	                var type_1 = getTypeForDeclarationFromJSDocComment(expression.parent);
	                if (type_1) {
	                    var declarationType = getWidenedType(type_1);
	                    if (!jsDocType) {
	                        jsDocType = declarationType;
	                    }
	                    else if (jsDocType !== unknownType && declarationType !== unknownType &&
	                        !isTypeIdenticalTo(jsDocType, declarationType) &&
	                        !(symbol.flags & 67108864 /* JSContainer */)) {
	                        errorNextVariableOrPropertyDeclarationMustHaveSameType(jsDocType, declaration, declarationType);
	                    }
	                }
	                else if (!jsDocType) {
	                    // If we don't have an explicit JSDoc type, get the type from the expression.
	                    var type_2 = getWidenedLiteralType(checkExpressionCached(expression.right));
	                    if (ts.getObjectFlags(type_2) & 16 /* Anonymous */ &&
	                        special === 2 /* ModuleExports */ &&
	                        symbol.escapedName === "export=" /* ExportEquals */) {
	                        var exportedType_1 = resolveStructuredTypeMembers(type_2);
	                        var members_3 = ts.createSymbolTable();
	                        ts.copyEntries(exportedType_1.members, members_3);
	                        symbol.exports.forEach(function (s, name) {
	                            if (members_3.has(name)) {
	                                var exportedMember = exportedType_1.members.get(name);
	                                var union = createSymbol(s.flags | exportedMember.flags, name);
	                                union.type = getUnionType([getTypeOfSymbol(s), getTypeOfSymbol(exportedMember)]);
	                                members_3.set(name, union);
	                            }
	                            else {
	                                members_3.set(name, s);
	                            }
	                        });
	                        type_2 = createAnonymousType(exportedType_1.symbol, members_3, exportedType_1.callSignatures, exportedType_1.constructSignatures, exportedType_1.stringIndexInfo, exportedType_1.numberIndexInfo);
	                    }
	                    var anyedType = type_2;
	                    if (isEmptyArrayLiteralType(type_2)) {
	                        anyedType = anyArrayType;
	                        if (noImplicitAny) {
	                            reportImplicitAnyError(expression, anyArrayType);
	                        }
	                    }
	                    types.push(anyedType);
	                    if (declarationInConstructor) {
	                        (constructorTypes || (constructorTypes = [])).push(anyedType);
	                    }
	                }
	            };
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                var state_2 = _loop_3(declaration);
	                if (typeof state_2 === "object")
	                    return state_2.value;
	            }
	            var type = jsDocType;
	            if (!type) {
	                // use only the constructor types unless they were only assigned null | undefined (including widening variants)
	                if (definedInMethod) {
	                    var propType = getTypeOfSpecialPropertyOfBaseType(symbol);
	                    if (propType) {
	                        (constructorTypes || (constructorTypes = [])).push(propType);
	                        definedInConstructor = true;
	                    }
	                }
	                var sourceTypes = ts.some(constructorTypes, function (t) { return !!(t.flags & ~(12288 /* Nullable */ | 16777216 /* ContainsWideningType */)); }) ? constructorTypes : types;
	                type = getUnionType(sourceTypes, 2 /* Subtype */);
	            }
	            var widened = getWidenedType(addOptionality(type, definedInMethod && !definedInConstructor));
	            if (filterType(widened, function (t) { return !!(t.flags & ~12288 /* Nullable */); }) === neverType) {
	                if (noImplicitAny) {
	                    reportImplicitAnyError(symbol.valueDeclaration, anyType);
	                }
	                return anyType;
	            }
	            return widened;
	        }
	        /** check for definition in base class if any declaration is in a class */
	        function getTypeOfSpecialPropertyOfBaseType(specialProperty) {
	            var parentDeclaration = ts.forEach(specialProperty.declarations, function (d) {
	                var parent = ts.getThisContainer(d, /*includeArrowFunctions*/ false).parent;
	                return ts.isClassLike(parent) && parent;
	            });
	            if (parentDeclaration) {
	                var classType = getDeclaredTypeOfSymbol(getSymbolOfNode(parentDeclaration));
	                var baseClassType = classType && getBaseTypes(classType)[0];
	                if (baseClassType) {
	                    return getTypeOfPropertyOfType(baseClassType, specialProperty.escapedName);
	                }
	            }
	        }
	        // Return the type implied by a binding pattern element. This is the type of the initializer of the element if
	        // one is present. Otherwise, if the element is itself a binding pattern, it is the type implied by the binding
	        // pattern. Otherwise, it is the type any.
	        function getTypeFromBindingElement(element, includePatternInType, reportErrors) {
	            if (element.initializer) {
	                return checkDeclarationInitializer(element);
	            }
	            if (ts.isBindingPattern(element.name)) {
	                return getTypeFromBindingPattern(element.name, includePatternInType, reportErrors);
	            }
	            if (reportErrors && noImplicitAny && !declarationBelongsToPrivateAmbientMember(element)) {
	                reportImplicitAnyError(element, anyType);
	            }
	            return anyType;
	        }
	        // Return the type implied by an object binding pattern
	        function getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors) {
	            var members = ts.createSymbolTable();
	            var stringIndexInfo;
	            var objectFlags = 128 /* ObjectLiteral */;
	            ts.forEach(pattern.elements, function (e) {
	                var name = e.propertyName || e.name;
	                if (isComputedNonLiteralName(name)) {
	                    // do not include computed properties in the implied type
	                    objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */;
	                    return;
	                }
	                if (e.dotDotDotToken) {
	                    stringIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	                    return;
	                }
	                var text = ts.getTextOfPropertyName(name);
	                var flags = 4 /* Property */ | (e.initializer ? 16777216 /* Optional */ : 0);
	                var symbol = createSymbol(flags, text);
	                symbol.type = getTypeFromBindingElement(e, includePatternInType, reportErrors);
	                symbol.bindingElement = e;
	                members.set(symbol.escapedName, symbol);
	            });
	            var result = createAnonymousType(undefined, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, undefined);
	            result.flags |= 33554432 /* ContainsObjectLiteral */;
	            result.objectFlags |= objectFlags;
	            if (includePatternInType) {
	                result.pattern = pattern;
	            }
	            return result;
	        }
	        // Return the type implied by an array binding pattern
	        function getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors) {
	            var elements = pattern.elements;
	            var lastElement = ts.lastOrUndefined(elements);
	            if (elements.length === 0 || (!ts.isOmittedExpression(lastElement) && lastElement.dotDotDotToken)) {
	                return languageVersion >= 2 /* ES2015 */ ? createIterableType(anyType) : anyArrayType;
	            }
	            // If the pattern has at least one element, and no rest element, then it should imply a tuple type.
	            var elementTypes = ts.map(elements, function (e) { return ts.isOmittedExpression(e) ? anyType : getTypeFromBindingElement(e, includePatternInType, reportErrors); });
	            var result = createTupleType(elementTypes);
	            if (includePatternInType) {
	                result = cloneTypeReference(result);
	                result.pattern = pattern;
	            }
	            return result;
	        }
	        // Return the type implied by a binding pattern. This is the type implied purely by the binding pattern itself
	        // and without regard to its context (i.e. without regard any type annotation or initializer associated with the
	        // declaration in which the binding pattern is contained). For example, the implied type of [x, y] is [any, any]
	        // and the implied type of { x, y: z = 1 } is { x: any; y: number; }. The type implied by a binding pattern is
	        // used as the contextual type of an initializer associated with the binding pattern. Also, for a destructuring
	        // parameter with no type annotation or initializer, the type implied by the binding pattern becomes the type of
	        // the parameter.
	        function getTypeFromBindingPattern(pattern, includePatternInType, reportErrors) {
	            return pattern.kind === 179 /* ObjectBindingPattern */
	                ? getTypeFromObjectBindingPattern(pattern, includePatternInType, reportErrors)
	                : getTypeFromArrayBindingPattern(pattern, includePatternInType, reportErrors);
	        }
	        // Return the type associated with a variable, parameter, or property declaration. In the simple case this is the type
	        // specified in a type annotation or inferred from an initializer. However, in the case of a destructuring declaration it
	        // is a bit more involved. For example:
	        //
	        //   var [x, s = ""] = [1, "one"];
	        //
	        // Here, the array literal [1, "one"] is contextually typed by the type [any, string], which is the implied type of the
	        // binding pattern [x, s = ""]. Because the contextual type is a tuple type, the resulting type of [1, "one"] is the
	        // tuple type [number, string]. Thus, the type inferred for 'x' is number and the type inferred for 's' is string.
	        function getWidenedTypeForVariableLikeDeclaration(declaration, reportErrors) {
	            var type = getTypeForVariableLikeDeclaration(declaration, /*includeOptionality*/ true);
	            if (type) {
	                if (reportErrors) {
	                    reportErrorsFromWidening(declaration, type);
	                }
	                // always widen a 'unique symbol' type if the type was created for a different declaration.
	                if (type.flags & 1024 /* UniqueESSymbol */ && (ts.isBindingElement(declaration) || !declaration.type) && type.symbol !== getSymbolOfNode(declaration)) {
	                    type = esSymbolType;
	                }
	                return getWidenedType(type);
	            }
	            // Rest parameters default to type any[], other parameters default to type any
	            type = ts.isParameter(declaration) && declaration.dotDotDotToken ? anyArrayType : anyType;
	            // Report implicit any errors unless this is a private property within an ambient declaration
	            if (reportErrors && noImplicitAny) {
	                if (!declarationBelongsToPrivateAmbientMember(declaration)) {
	                    reportImplicitAnyError(declaration, type);
	                }
	            }
	            return type;
	        }
	        function declarationBelongsToPrivateAmbientMember(declaration) {
	            var root = ts.getRootDeclaration(declaration);
	            var memberDeclaration = root.kind === 148 /* Parameter */ ? root.parent : root;
	            return isPrivateWithinAmbient(memberDeclaration);
	        }
	        function tryGetTypeFromEffectiveTypeNode(declaration) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	            if (typeNode) {
	                return getTypeFromTypeNode(typeNode);
	            }
	        }
	        function getTypeOfVariableOrParameterOrProperty(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                // Handle prototype property
	                if (symbol.flags & 4194304 /* Prototype */) {
	                    return links.type = getTypeOfPrototypeProperty(symbol);
	                }
	                // CommonsJS require and module both have type any.
	                if (symbol === requireSymbol || symbol === moduleSymbol) {
	                    return links.type = anyType;
	                }
	                // Handle catch clause variables
	                var declaration = symbol.valueDeclaration;
	                if (ts.isCatchClauseVariableDeclarationOrBindingElement(declaration)) {
	                    return links.type = anyType;
	                }
	                // Handle export default expressions
	                if (ts.isSourceFile(declaration)) {
	                    var jsonSourceFile = ts.cast(declaration, ts.isJsonSourceFile);
	                    return links.type = jsonSourceFile.statements.length ? checkExpression(jsonSourceFile.statements[0].expression) : emptyObjectType;
	                }
	                if (declaration.kind === 248 /* ExportAssignment */) {
	                    return links.type = checkExpression(declaration.expression);
	                }
	                if (ts.isInJavaScriptFile(declaration) && ts.isJSDocPropertyLikeTag(declaration) && declaration.typeExpression) {
	                    return links.type = getTypeFromTypeNode(declaration.typeExpression.type);
	                }
	                // Handle variable, parameter or property
	                if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                // Handle certain special assignment kinds, which happen to union across multiple declarations:
	                // * module.exports = expr
	                // * exports.p = expr
	                // * this.p = expr
	                // * className.prototype.method = expr
	                if (declaration.kind === 199 /* BinaryExpression */ ||
	                    declaration.kind === 184 /* PropertyAccessExpression */ && declaration.parent.kind === 199 /* BinaryExpression */) {
	                    type = getWidenedTypeFromJSSpecialPropertyDeclarations(symbol);
	                }
	                else if (ts.isJSDocPropertyLikeTag(declaration)
	                    || ts.isPropertyAccessExpression(declaration)
	                    || ts.isIdentifier(declaration)
	                    || (ts.isMethodDeclaration(declaration) && !ts.isObjectLiteralMethod(declaration))
	                    || ts.isMethodSignature(declaration)) {
	                    // Symbol is property of some kind that is merged with something - should use `getTypeOfFuncClassEnumModule` and not `getTypeOfVariableOrParameterOrProperty`
	                    if (symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 384 /* Enum */ | 512 /* ValueModule */)) {
	                        return getTypeOfFuncClassEnumModule(symbol);
	                    }
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || anyType;
	                }
	                else if (ts.isPropertyAssignment(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkPropertyAssignment(declaration);
	                }
	                else if (ts.isJsxAttribute(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkJsxAttribute(declaration);
	                }
	                else if (ts.isShorthandPropertyAssignment(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkExpressionForMutableLocation(declaration.name, 0 /* Normal */);
	                }
	                else if (ts.isObjectLiteralMethod(declaration)) {
	                    type = tryGetTypeFromEffectiveTypeNode(declaration) || checkObjectLiteralMethod(declaration, 0 /* Normal */);
	                }
	                else if (ts.isParameter(declaration)
	                    || ts.isPropertyDeclaration(declaration)
	                    || ts.isPropertySignature(declaration)
	                    || ts.isVariableDeclaration(declaration)
	                    || ts.isBindingElement(declaration)) {
	                    type = getWidenedTypeForVariableLikeDeclaration(declaration, /*reportErrors*/ true);
	                }
	                else {
	                    ts.Debug.fail("Unhandled declaration kind! " + ts.Debug.showSyntaxKind(declaration));
	                }
	                if (!popTypeResolution()) {
	                    type = reportCircularityError(symbol);
	                }
	                links.type = type;
	            }
	            return links.type;
	        }
	        function getAnnotatedAccessorType(accessor) {
	            if (accessor) {
	                if (accessor.kind === 155 /* GetAccessor */) {
	                    var getterTypeAnnotation = ts.getEffectiveReturnTypeNode(accessor);
	                    return getterTypeAnnotation && getTypeFromTypeNode(getterTypeAnnotation);
	                }
	                else {
	                    var setterTypeAnnotation = ts.getEffectiveSetAccessorTypeAnnotationNode(accessor);
	                    return setterTypeAnnotation && getTypeFromTypeNode(setterTypeAnnotation);
	                }
	            }
	            return undefined;
	        }
	        function getAnnotatedAccessorThisParameter(accessor) {
	            var parameter = getAccessorThisParameter(accessor);
	            return parameter && parameter.symbol;
	        }
	        function getThisTypeOfDeclaration(declaration) {
	            return getThisTypeOfSignature(getSignatureFromDeclaration(declaration));
	        }
	        function getTypeOfAccessors(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                var getter = ts.getDeclarationOfKind(symbol, 155 /* GetAccessor */);
	                var setter = ts.getDeclarationOfKind(symbol, 156 /* SetAccessor */);
	                if (getter && ts.isInJavaScriptFile(getter)) {
	                    var jsDocType = getTypeForDeclarationFromJSDocComment(getter);
	                    if (jsDocType) {
	                        return links.type = jsDocType;
	                    }
	                }
	                if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                // First try to see if the user specified a return type on the get-accessor.
	                var getterReturnType = getAnnotatedAccessorType(getter);
	                if (getterReturnType) {
	                    type = getterReturnType;
	                }
	                else {
	                    // If the user didn't specify a return type, try to use the set-accessor's parameter type.
	                    var setterParameterType = getAnnotatedAccessorType(setter);
	                    if (setterParameterType) {
	                        type = setterParameterType;
	                    }
	                    else {
	                        // If there are no specified types, try to infer it from the body of the get accessor if it exists.
	                        if (getter && getter.body) {
	                            type = getReturnTypeFromBody(getter);
	                        }
	                        // Otherwise, fall back to 'any'.
	                        else {
	                            if (noImplicitAny) {
	                                if (setter) {
	                                    error(setter, ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation, symbolToString(symbol));
	                                }
	                                else {
	                                    ts.Debug.assert(!!getter, "there must existed getter as we are current checking either setter or getter in this function");
	                                    error(getter, ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation, symbolToString(symbol));
	                                }
	                            }
	                            type = anyType;
	                        }
	                    }
	                }
	                if (!popTypeResolution()) {
	                    type = anyType;
	                    if (noImplicitAny) {
	                        var getter_1 = ts.getDeclarationOfKind(symbol, 155 /* GetAccessor */);
	                        error(getter_1, ts.Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, symbolToString(symbol));
	                    }
	                }
	                links.type = type;
	            }
	            return links.type;
	        }
	        function getBaseTypeVariableOfClass(symbol) {
	            var baseConstructorType = getBaseConstructorTypeOfClass(getDeclaredTypeOfClassOrInterface(symbol));
	            return baseConstructorType.flags & 1081344 /* TypeVariable */ ? baseConstructorType : undefined;
	        }
	        function getTypeOfFuncClassEnumModule(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                if (symbol.flags & 1536 /* Module */ && ts.isShorthandAmbientModuleSymbol(symbol)) {
	                    links.type = anyType;
	                }
	                else if (symbol.valueDeclaration.kind === 199 /* BinaryExpression */ ||
	                    symbol.valueDeclaration.kind === 184 /* PropertyAccessExpression */ && symbol.valueDeclaration.parent.kind === 199 /* BinaryExpression */) {
	                    links.type = getWidenedTypeFromJSSpecialPropertyDeclarations(symbol);
	                }
	                else {
	                    var type = createObjectType(16 /* Anonymous */, symbol);
	                    if (symbol.flags & 32 /* Class */) {
	                        var baseTypeVariable = getBaseTypeVariableOfClass(symbol);
	                        links.type = baseTypeVariable ? getIntersectionType([type, baseTypeVariable]) : type;
	                    }
	                    else {
	                        links.type = strictNullChecks && symbol.flags & 16777216 /* Optional */ ? getOptionalType(type) : type;
	                    }
	                }
	            }
	            return links.type;
	        }
	        function getTypeOfEnumMember(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                links.type = getDeclaredTypeOfEnumMember(symbol);
	            }
	            return links.type;
	        }
	        function getTypeOfAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                var targetSymbol = resolveAlias(symbol);
	                // It only makes sense to get the type of a value symbol. If the result of resolving
	                // the alias is not a value, then it has no type. To get the type associated with a
	                // type symbol, call getDeclaredTypeOfSymbol.
	                // This check is important because without it, a call to getTypeOfSymbol could end
	                // up recursively calling getTypeOfAlias, causing a stack overflow.
	                links.type = targetSymbol.flags & 67216319 /* Value */
	                    ? getTypeOfSymbol(targetSymbol)
	                    : unknownType;
	            }
	            return links.type;
	        }
	        function getTypeOfInstantiatedSymbol(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.type) {
	                if (symbolInstantiationDepth === 100) {
	                    error(symbol.valueDeclaration, ts.Diagnostics.Generic_type_instantiation_is_excessively_deep_and_possibly_infinite);
	                    links.type = unknownType;
	                }
	                else {
	                    if (!pushTypeResolution(symbol, 0 /* Type */)) {
	                        return unknownType;
	                    }
	                    symbolInstantiationDepth++;
	                    var type = instantiateType(getTypeOfSymbol(links.target), links.mapper);
	                    symbolInstantiationDepth--;
	                    if (!popTypeResolution()) {
	                        type = reportCircularityError(symbol);
	                    }
	                    links.type = type;
	                }
	            }
	            return links.type;
	        }
	        function reportCircularityError(symbol) {
	            // Check if variable has type annotation that circularly references the variable itself
	            if (ts.getEffectiveTypeAnnotationNode(symbol.valueDeclaration)) {
	                error(symbol.valueDeclaration, ts.Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_type_annotation, symbolToString(symbol));
	                return unknownType;
	            }
	            // Otherwise variable has initializer that circularly references the variable itself
	            if (noImplicitAny) {
	                error(symbol.valueDeclaration, ts.Diagnostics._0_implicitly_has_type_any_because_it_does_not_have_a_type_annotation_and_is_referenced_directly_or_indirectly_in_its_own_initializer, symbolToString(symbol));
	            }
	            return anyType;
	        }
	        function getTypeOfSymbol(symbol) {
	            if (ts.getCheckFlags(symbol) & 1 /* Instantiated */) {
	                return getTypeOfInstantiatedSymbol(symbol);
	            }
	            if (ts.getCheckFlags(symbol) & 2048 /* ReverseMapped */) {
	                return getTypeOfReverseMappedSymbol(symbol);
	            }
	            if (symbol.flags & (3 /* Variable */ | 4 /* Property */)) {
	                return getTypeOfVariableOrParameterOrProperty(symbol);
	            }
	            if (symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 384 /* Enum */ | 512 /* ValueModule */)) {
	                return getTypeOfFuncClassEnumModule(symbol);
	            }
	            if (symbol.flags & 8 /* EnumMember */) {
	                return getTypeOfEnumMember(symbol);
	            }
	            if (symbol.flags & 98304 /* Accessor */) {
	                return getTypeOfAccessors(symbol);
	            }
	            if (symbol.flags & 2097152 /* Alias */) {
	                return getTypeOfAlias(symbol);
	            }
	            return unknownType;
	        }
	        function isReferenceToType(type, target) {
	            return type !== undefined
	                && target !== undefined
	                && (ts.getObjectFlags(type) & 4 /* Reference */) !== 0
	                && type.target === target;
	        }
	        function getTargetType(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ ? type.target : type;
	        }
	        function hasBaseType(type, checkBase) {
	            return check(type);
	            function check(type) {
	                if (ts.getObjectFlags(type) & (3 /* ClassOrInterface */ | 4 /* Reference */)) {
	                    var target = getTargetType(type);
	                    return target === checkBase || ts.forEach(getBaseTypes(target), check);
	                }
	                else if (type.flags & 262144 /* Intersection */) {
	                    return ts.forEach(type.types, check);
	                }
	            }
	        }
	        // Appends the type parameters given by a list of declarations to a set of type parameters and returns the resulting set.
	        // The function allocates a new array if the input type parameter set is undefined, but otherwise it modifies the set
	        // in-place and returns the same array.
	        function appendTypeParameters(typeParameters, declarations) {
	            for (var _i = 0, declarations_2 = declarations; _i < declarations_2.length; _i++) {
	                var declaration = declarations_2[_i];
	                typeParameters = ts.appendIfUnique(typeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfNode(declaration)));
	            }
	            return typeParameters;
	        }
	        // Return the outer type parameters of a node or undefined if the node has no outer type parameters.
	        function getOuterTypeParameters(node, includeThisTypes) {
	            while (true) {
	                node = node.parent;
	                if (!node) {
	                    return undefined;
	                }
	                switch (node.kind) {
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 152 /* MethodSignature */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 283 /* JSDocFunctionType */:
	                    case 233 /* FunctionDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 191 /* FunctionExpression */:
	                    case 192 /* ArrowFunction */:
	                    case 236 /* TypeAliasDeclaration */:
	                    case 295 /* JSDocTemplateTag */:
	                    case 296 /* JSDocTypedefTag */:
	                    case 291 /* JSDocCallbackTag */:
	                    case 176 /* MappedType */:
	                    case 170 /* ConditionalType */:
	                        var outerTypeParameters = getOuterTypeParameters(node, includeThisTypes);
	                        if (node.kind === 176 /* MappedType */) {
	                            return ts.append(outerTypeParameters, getDeclaredTypeOfTypeParameter(getSymbolOfNode(node.typeParameter)));
	                        }
	                        else if (node.kind === 170 /* ConditionalType */) {
	                            return ts.concatenate(outerTypeParameters, getInferTypeParameters(node));
	                        }
	                        var outerAndOwnTypeParameters = appendTypeParameters(outerTypeParameters, ts.getEffectiveTypeParameterDeclarations(node));
	                        var thisType = includeThisTypes &&
	                            (node.kind === 234 /* ClassDeclaration */ || node.kind === 204 /* ClassExpression */ || node.kind === 235 /* InterfaceDeclaration */) &&
	                            getDeclaredTypeOfClassOrInterface(getSymbolOfNode(node)).thisType;
	                        return thisType ? ts.append(outerAndOwnTypeParameters, thisType) : outerAndOwnTypeParameters;
	                }
	            }
	        }
	        // The outer type parameters are those defined by enclosing generic classes, methods, or functions.
	        function getOuterTypeParametersOfClassOrInterface(symbol) {
	            var declaration = symbol.flags & 32 /* Class */ ? symbol.valueDeclaration : ts.getDeclarationOfKind(symbol, 235 /* InterfaceDeclaration */);
	            return getOuterTypeParameters(declaration);
	        }
	        // The local type parameters are the combined set of type parameters from all declarations of the class,
	        // interface, or type alias.
	        function getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) {
	            var result;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var node = _a[_i];
	                if (node.kind === 235 /* InterfaceDeclaration */ ||
	                    node.kind === 234 /* ClassDeclaration */ ||
	                    node.kind === 204 /* ClassExpression */ ||
	                    ts.isTypeAlias(node)) {
	                    var declaration = node;
	                    result = appendTypeParameters(result, ts.getEffectiveTypeParameterDeclarations(declaration));
	                }
	            }
	            return result;
	        }
	        // The full set of type parameters for a generic class or interface type consists of its outer type parameters plus
	        // its locally declared type parameters.
	        function getTypeParametersOfClassOrInterface(symbol) {
	            return ts.concatenate(getOuterTypeParametersOfClassOrInterface(symbol), getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol));
	        }
	        // A type is a mixin constructor if it has a single construct signature taking no type parameters and a single
	        // rest parameter of type any[].
	        function isMixinConstructorType(type) {
	            var signatures = getSignaturesOfType(type, 1 /* Construct */);
	            if (signatures.length === 1) {
	                var s = signatures[0];
	                return !s.typeParameters && s.parameters.length === 1 && s.hasRestParameter && getTypeOfParameter(s.parameters[0]) === anyArrayType;
	            }
	            return false;
	        }
	        function isConstructorType(type) {
	            if (isValidBaseType(type) && getSignaturesOfType(type, 1 /* Construct */).length > 0) {
	                return true;
	            }
	            if (type.flags & 1081344 /* TypeVariable */) {
	                var constraint = getBaseConstraintOfType(type);
	                return constraint && isValidBaseType(constraint) && isMixinConstructorType(constraint);
	            }
	            return false;
	        }
	        function getBaseTypeNodeOfClass(type) {
	            var decl = type.symbol.valueDeclaration;
	            if (ts.isInJavaScriptFile(decl)) {
	                // Prefer an @augments tag because it may have type parameters.
	                var tag = ts.getJSDocAugmentsTag(decl);
	                if (tag) {
	                    return tag.class;
	                }
	            }
	            return ts.getClassExtendsHeritageClauseElement(decl);
	        }
	        function getConstructorsForTypeArguments(type, typeArgumentNodes, location) {
	            var typeArgCount = ts.length(typeArgumentNodes);
	            var isJavaScript = ts.isInJavaScriptFile(location);
	            return ts.filter(getSignaturesOfType(type, 1 /* Construct */), function (sig) { return (isJavaScript || typeArgCount >= getMinTypeArgumentCount(sig.typeParameters)) && typeArgCount <= ts.length(sig.typeParameters); });
	        }
	        function getInstantiatedConstructorsForTypeArguments(type, typeArgumentNodes, location) {
	            var signatures = getConstructorsForTypeArguments(type, typeArgumentNodes, location);
	            var typeArguments = ts.map(typeArgumentNodes, getTypeFromTypeNode);
	            return ts.sameMap(signatures, function (sig) { return ts.some(sig.typeParameters) ? getSignatureInstantiation(sig, typeArguments, ts.isInJavaScriptFile(location)) : sig; });
	        }
	        /**
	         * The base constructor of a class can resolve to
	         * * undefinedType if the class has no extends clause,
	         * * unknownType if an error occurred during resolution of the extends expression,
	         * * nullType if the extends expression is the null value,
	         * * anyType if the extends expression has type any, or
	         * * an object type with at least one construct signature.
	         */
	        function getBaseConstructorTypeOfClass(type) {
	            if (!type.resolvedBaseConstructorType) {
	                var decl = type.symbol.valueDeclaration;
	                var extended = ts.getClassExtendsHeritageClauseElement(decl);
	                var baseTypeNode = getBaseTypeNodeOfClass(type);
	                if (!baseTypeNode) {
	                    return type.resolvedBaseConstructorType = undefinedType;
	                }
	                if (!pushTypeResolution(type, 1 /* ResolvedBaseConstructorType */)) {
	                    return unknownType;
	                }
	                var baseConstructorType = checkExpression(baseTypeNode.expression);
	                if (extended && baseTypeNode !== extended) {
	                    ts.Debug.assert(!extended.typeArguments); // Because this is in a JS file, and baseTypeNode is in an @extends tag
	                    checkExpression(extended.expression);
	                }
	                if (baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */)) {
	                    // Resolving the members of a class requires us to resolve the base class of that class.
	                    // We force resolution here such that we catch circularities now.
	                    resolveStructuredTypeMembers(baseConstructorType);
	                }
	                if (!popTypeResolution()) {
	                    error(type.symbol.valueDeclaration, ts.Diagnostics._0_is_referenced_directly_or_indirectly_in_its_own_base_expression, symbolToString(type.symbol));
	                    return type.resolvedBaseConstructorType = unknownType;
	                }
	                if (!(baseConstructorType.flags & 1 /* Any */) && baseConstructorType !== nullWideningType && !isConstructorType(baseConstructorType)) {
	                    error(baseTypeNode.expression, ts.Diagnostics.Type_0_is_not_a_constructor_function_type, typeToString(baseConstructorType));
	                    return type.resolvedBaseConstructorType = unknownType;
	                }
	                type.resolvedBaseConstructorType = baseConstructorType;
	            }
	            return type.resolvedBaseConstructorType;
	        }
	        function getBaseTypes(type) {
	            if (!type.resolvedBaseTypes) {
	                if (type.objectFlags & 8 /* Tuple */) {
	                    type.resolvedBaseTypes = [createArrayType(getUnionType(type.typeParameters))];
	                }
	                else if (type.symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                    if (type.symbol.flags & 32 /* Class */) {
	                        resolveBaseTypesOfClass(type);
	                    }
	                    if (type.symbol.flags & 64 /* Interface */) {
	                        resolveBaseTypesOfInterface(type);
	                    }
	                }
	                else {
	                    ts.Debug.fail("type must be class or interface");
	                }
	            }
	            return type.resolvedBaseTypes;
	        }
	        function resolveBaseTypesOfClass(type) {
	            type.resolvedBaseTypes = ts.resolvingEmptyArray;
	            var baseConstructorType = getApparentType(getBaseConstructorTypeOfClass(type));
	            if (!(baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */ | 1 /* Any */))) {
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            var baseTypeNode = getBaseTypeNodeOfClass(type);
	            var typeArgs = typeArgumentsFromTypeReferenceNode(baseTypeNode);
	            var baseType;
	            var originalBaseType = baseConstructorType && baseConstructorType.symbol ? getDeclaredTypeOfSymbol(baseConstructorType.symbol) : undefined;
	            if (baseConstructorType.symbol && baseConstructorType.symbol.flags & 32 /* Class */ &&
	                areAllOuterTypeParametersApplied(originalBaseType)) {
	                // When base constructor type is a class with no captured type arguments we know that the constructors all have the same type parameters as the
	                // class and all return the instance type of the class. There is no need for further checks and we can apply the
	                // type arguments in the same manner as a type reference to get the same error reporting experience.
	                baseType = getTypeFromClassOrInterfaceReference(baseTypeNode, baseConstructorType.symbol, typeArgs);
	            }
	            else if (baseConstructorType.flags & 1 /* Any */) {
	                baseType = baseConstructorType;
	            }
	            else {
	                // The class derives from a "class-like" constructor function, check that we have at least one construct signature
	                // with a matching number of type parameters and use the return type of the first instantiated signature. Elsewhere
	                // we check that all instantiated signatures return the same type.
	                var constructors = getInstantiatedConstructorsForTypeArguments(baseConstructorType, baseTypeNode.typeArguments, baseTypeNode);
	                if (!constructors.length) {
	                    error(baseTypeNode.expression, ts.Diagnostics.No_base_constructor_has_the_specified_number_of_type_arguments);
	                    return type.resolvedBaseTypes = ts.emptyArray;
	                }
	                baseType = getReturnTypeOfSignature(constructors[0]);
	            }
	            if (baseType === unknownType) {
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (!isValidBaseType(baseType)) {
	                error(baseTypeNode.expression, ts.Diagnostics.Base_constructor_return_type_0_is_not_a_class_or_interface_type, typeToString(baseType));
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (type === baseType || hasBaseType(baseType, type)) {
	                error(type.symbol.valueDeclaration, ts.Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */));
	                return type.resolvedBaseTypes = ts.emptyArray;
	            }
	            if (type.resolvedBaseTypes === ts.resolvingEmptyArray) {
	                // Circular reference, likely through instantiation of default parameters
	                // (otherwise there'd be an error from hasBaseType) - this is fine, but `.members` should be reset
	                // as `getIndexedAccessType` via `instantiateType` via `getTypeFromClassOrInterfaceReference` forces a
	                // partial instantiation of the members without the base types fully resolved
	                type.members = undefined;
	            }
	            return type.resolvedBaseTypes = [baseType];
	        }
	        function areAllOuterTypeParametersApplied(type) {
	            // An unapplied type parameter has its symbol still the same as the matching argument symbol.
	            // Since parameters are applied outer-to-inner, only the last outer parameter needs to be checked.
	            var outerTypeParameters = type.outerTypeParameters;
	            if (outerTypeParameters) {
	                var last_1 = outerTypeParameters.length - 1;
	                var typeArguments = type.typeArguments;
	                return outerTypeParameters[last_1].symbol !== typeArguments[last_1].symbol;
	            }
	            return true;
	        }
	        // A valid base type is `any`, any non-generic object type or intersection of non-generic
	        // object types.
	        function isValidBaseType(type) {
	            return type.flags & (65536 /* Object */ | 134217728 /* NonPrimitive */ | 1 /* Any */) && !isGenericMappedType(type) ||
	                type.flags & 262144 /* Intersection */ && !ts.forEach(type.types, function (t) { return !isValidBaseType(t); });
	        }
	        function resolveBaseTypesOfInterface(type) {
	            type.resolvedBaseTypes = type.resolvedBaseTypes || ts.emptyArray;
	            for (var _i = 0, _a = type.symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 235 /* InterfaceDeclaration */ && ts.getInterfaceBaseTypeNodes(declaration)) {
	                    for (var _b = 0, _c = ts.getInterfaceBaseTypeNodes(declaration); _b < _c.length; _b++) {
	                        var node = _c[_b];
	                        var baseType = getTypeFromTypeNode(node);
	                        if (baseType !== unknownType) {
	                            if (isValidBaseType(baseType)) {
	                                if (type !== baseType && !hasBaseType(baseType, type)) {
	                                    if (type.resolvedBaseTypes === ts.emptyArray) {
	                                        type.resolvedBaseTypes = [baseType];
	                                    }
	                                    else {
	                                        type.resolvedBaseTypes.push(baseType);
	                                    }
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Type_0_recursively_references_itself_as_a_base_type, typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */));
	                                }
	                            }
	                            else {
	                                error(node, ts.Diagnostics.An_interface_may_only_extend_a_class_or_another_interface);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /**
	         * Returns true if the interface given by the symbol is free of "this" references.
	         *
	         * Specifically, the result is true if the interface itself contains no references
	         * to "this" in its body, if all base types are interfaces,
	         * and if none of the base interfaces have a "this" type.
	         */
	        function isThislessInterface(symbol) {
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 235 /* InterfaceDeclaration */) {
	                    if (declaration.flags & 64 /* ContainsThis */) {
	                        return false;
	                    }
	                    var baseTypeNodes = ts.getInterfaceBaseTypeNodes(declaration);
	                    if (baseTypeNodes) {
	                        for (var _b = 0, baseTypeNodes_1 = baseTypeNodes; _b < baseTypeNodes_1.length; _b++) {
	                            var node = baseTypeNodes_1[_b];
	                            if (ts.isEntityNameExpression(node.expression)) {
	                                var baseSymbol = resolveEntityName(node.expression, 67901928 /* Type */, /*ignoreErrors*/ true);
	                                if (!baseSymbol || !(baseSymbol.flags & 64 /* Interface */) || getDeclaredTypeOfClassOrInterface(baseSymbol).thisType) {
	                                    return false;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return true;
	        }
	        function getDeclaredTypeOfClassOrInterface(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var kind = symbol.flags & 32 /* Class */ ? 1 /* Class */ : 2 /* Interface */;
	                var type = links.declaredType = createObjectType(kind, symbol);
	                var outerTypeParameters = getOuterTypeParametersOfClassOrInterface(symbol);
	                var localTypeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
	                // A class or interface is generic if it has type parameters or a "this" type. We always give classes a "this" type
	                // because it is not feasible to analyze all members to determine if the "this" type escapes the class (in particular,
	                // property types inferred from initializers and method return types inferred from return statements are very hard
	                // to exhaustively analyze). We give interfaces a "this" type if we can't definitely determine that they are free of
	                // "this" references.
	                if (outerTypeParameters || localTypeParameters || kind === 1 /* Class */ || !isThislessInterface(symbol)) {
	                    type.objectFlags |= 4 /* Reference */;
	                    type.typeParameters = ts.concatenate(outerTypeParameters, localTypeParameters);
	                    type.outerTypeParameters = outerTypeParameters;
	                    type.localTypeParameters = localTypeParameters;
	                    type.instantiations = ts.createMap();
	                    type.instantiations.set(getTypeListId(type.typeParameters), type);
	                    type.target = type;
	                    type.typeArguments = type.typeParameters;
	                    type.thisType = createType(32768 /* TypeParameter */);
	                    type.thisType.isThisType = true;
	                    type.thisType.symbol = symbol;
	                    type.thisType.constraint = type;
	                }
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfTypeAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                // Note that we use the links object as the target here because the symbol object is used as the unique
	                // identity for resolution of the 'type' property in SymbolLinks.
	                if (!pushTypeResolution(symbol, 2 /* DeclaredType */)) {
	                    return unknownType;
	                }
	                var declaration = ts.find(symbol.declarations, function (d) {
	                    return ts.isJSDocTypeAlias(d) || d.kind === 236 /* TypeAliasDeclaration */;
	                });
	                var typeNode = ts.isJSDocTypeAlias(declaration) ? declaration.typeExpression : declaration.type;
	                // If typeNode is missing, we will error in checkJSDocTypedefTag.
	                var type = typeNode ? getTypeFromTypeNode(typeNode) : unknownType;
	                if (popTypeResolution()) {
	                    var typeParameters = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol);
	                    if (typeParameters) {
	                        // Initialize the instantiation cache for generic type aliases. The declared type corresponds to
	                        // an instantiation of the type alias with the type parameters supplied as type arguments.
	                        links.typeParameters = typeParameters;
	                        links.instantiations = ts.createMap();
	                        links.instantiations.set(getTypeListId(typeParameters), type);
	                    }
	                }
	                else {
	                    type = unknownType;
	                    error(declaration.name, ts.Diagnostics.Type_alias_0_circularly_references_itself, symbolToString(symbol));
	                }
	                links.declaredType = type;
	            }
	            return links.declaredType;
	        }
	        function isStringConcatExpression(expr) {
	            if (expr.kind === 9 /* StringLiteral */) {
	                return true;
	            }
	            else if (expr.kind === 199 /* BinaryExpression */) {
	                return isStringConcatExpression(expr.left) && isStringConcatExpression(expr.right);
	            }
	            return false;
	        }
	        function isLiteralEnumMember(member) {
	            var expr = member.initializer;
	            if (!expr) {
	                return !(member.flags & 4194304 /* Ambient */);
	            }
	            switch (expr.kind) {
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                    return true;
	                case 197 /* PrefixUnaryExpression */:
	                    return expr.operator === 38 /* MinusToken */ &&
	                        expr.operand.kind === 8 /* NumericLiteral */;
	                case 71 /* Identifier */:
	                    return ts.nodeIsMissing(expr) || !!getSymbolOfNode(member.parent).exports.get(expr.escapedText);
	                case 199 /* BinaryExpression */:
	                    return isStringConcatExpression(expr);
	                default:
	                    return false;
	            }
	        }
	        function getEnumKind(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (links.enumKind !== undefined) {
	                return links.enumKind;
	            }
	            var hasNonLiteralMember = false;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var declaration = _a[_i];
	                if (declaration.kind === 237 /* EnumDeclaration */) {
	                    for (var _b = 0, _c = declaration.members; _b < _c.length; _b++) {
	                        var member = _c[_b];
	                        if (member.initializer && member.initializer.kind === 9 /* StringLiteral */) {
	                            return links.enumKind = 1 /* Literal */;
	                        }
	                        if (!isLiteralEnumMember(member)) {
	                            hasNonLiteralMember = true;
	                        }
	                    }
	                }
	            }
	            return links.enumKind = hasNonLiteralMember ? 0 /* Numeric */ : 1 /* Literal */;
	        }
	        function getBaseTypeOfEnumLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ && !(type.flags & 131072 /* Union */) ? getDeclaredTypeOfSymbol(getParentOfSymbol(type.symbol)) : type;
	        }
	        function getDeclaredTypeOfEnum(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (links.declaredType) {
	                return links.declaredType;
	            }
	            if (getEnumKind(symbol) === 1 /* Literal */) {
	                enumCount++;
	                var memberTypeList = [];
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    if (declaration.kind === 237 /* EnumDeclaration */) {
	                        for (var _b = 0, _c = declaration.members; _b < _c.length; _b++) {
	                            var member = _c[_b];
	                            var memberType = getLiteralType(getEnumMemberValue(member), enumCount, getSymbolOfNode(member));
	                            getSymbolLinks(getSymbolOfNode(member)).declaredType = memberType;
	                            memberTypeList.push(memberType);
	                        }
	                    }
	                }
	                if (memberTypeList.length) {
	                    var enumType_1 = getUnionType(memberTypeList, 1 /* Literal */, symbol, /*aliasTypeArguments*/ undefined);
	                    if (enumType_1.flags & 131072 /* Union */) {
	                        enumType_1.flags |= 256 /* EnumLiteral */;
	                        enumType_1.symbol = symbol;
	                    }
	                    return links.declaredType = enumType_1;
	                }
	            }
	            var enumType = createType(16 /* Enum */);
	            enumType.symbol = symbol;
	            return links.declaredType = enumType;
	        }
	        function getDeclaredTypeOfEnumMember(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var enumType = getDeclaredTypeOfEnum(getParentOfSymbol(symbol));
	                if (!links.declaredType) {
	                    links.declaredType = enumType;
	                }
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfTypeParameter(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                var type = createType(32768 /* TypeParameter */);
	                type.symbol = symbol;
	                links.declaredType = type;
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfAlias(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.declaredType) {
	                links.declaredType = getDeclaredTypeOfSymbol(resolveAlias(symbol));
	            }
	            return links.declaredType;
	        }
	        function getDeclaredTypeOfSymbol(symbol) {
	            return tryGetDeclaredTypeOfSymbol(symbol) || unknownType;
	        }
	        function tryGetDeclaredTypeOfSymbol(symbol) {
	            if (symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                return getDeclaredTypeOfClassOrInterface(symbol);
	            }
	            if (symbol.flags & 524288 /* TypeAlias */) {
	                return getDeclaredTypeOfTypeAlias(symbol);
	            }
	            if (symbol.flags & 262144 /* TypeParameter */) {
	                return getDeclaredTypeOfTypeParameter(symbol);
	            }
	            if (symbol.flags & 384 /* Enum */) {
	                return getDeclaredTypeOfEnum(symbol);
	            }
	            if (symbol.flags & 8 /* EnumMember */) {
	                return getDeclaredTypeOfEnumMember(symbol);
	            }
	            if (symbol.flags & 2097152 /* Alias */) {
	                return getDeclaredTypeOfAlias(symbol);
	            }
	            return undefined;
	        }
	        /**
	         * A type is free of this references if it's the any, string, number, boolean, symbol, or void keyword, a string
	         * literal type, an array with an element type that is free of this references, or a type reference that is
	         * free of this references.
	         */
	        function isThislessType(node) {
	            switch (node.kind) {
	                case 119 /* AnyKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 135 /* ObjectKeyword */:
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 131 /* NeverKeyword */:
	                case 177 /* LiteralType */:
	                    return true;
	                case 166 /* ArrayType */:
	                    return isThislessType(node.elementType);
	                case 161 /* TypeReference */:
	                    return !node.typeArguments || node.typeArguments.every(isThislessType);
	            }
	            return false;
	        }
	        /** A type parameter is thisless if its contraint is thisless, or if it has no constraint. */
	        function isThislessTypeParameter(node) {
	            return !node.constraint || isThislessType(node.constraint);
	        }
	        /**
	         * A variable-like declaration is free of this references if it has a type annotation
	         * that is thisless, or if it has no type annotation and no initializer (and is thus of type any).
	         */
	        function isThislessVariableLikeDeclaration(node) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(node);
	            return typeNode ? isThislessType(typeNode) : !ts.hasInitializer(node);
	        }
	        /**
	         * A function-like declaration is considered free of `this` references if it has a return type
	         * annotation that is free of this references and if each parameter is thisless and if
	         * each type parameter (if present) is thisless.
	         */
	        function isThislessFunctionLikeDeclaration(node) {
	            var returnType = ts.getEffectiveReturnTypeNode(node);
	            var typeParameters = ts.getEffectiveTypeParameterDeclarations(node);
	            return (node.kind === 154 /* Constructor */ || (returnType && isThislessType(returnType))) &&
	                node.parameters.every(isThislessVariableLikeDeclaration) &&
	                typeParameters.every(isThislessTypeParameter);
	        }
	        /**
	         * Returns true if the class or interface member given by the symbol is free of "this" references. The
	         * function may return false for symbols that are actually free of "this" references because it is not
	         * feasible to perform a complete analysis in all cases. In particular, property members with types
	         * inferred from their initializers and function members with inferred return types are conservatively
	         * assumed not to be free of "this" references.
	         */
	        function isThisless(symbol) {
	            if (symbol.declarations && symbol.declarations.length === 1) {
	                var declaration = symbol.declarations[0];
	                if (declaration) {
	                    switch (declaration.kind) {
	                        case 151 /* PropertyDeclaration */:
	                        case 150 /* PropertySignature */:
	                            return isThislessVariableLikeDeclaration(declaration);
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                            return isThislessFunctionLikeDeclaration(declaration);
	                    }
	                }
	            }
	            return false;
	        }
	        // The mappingThisOnly flag indicates that the only type parameter being mapped is "this". When the flag is true,
	        // we check symbols to see if we can quickly conclude they are free of "this" references, thus needing no instantiation.
	        function createInstantiatedSymbolTable(symbols, mapper, mappingThisOnly) {
	            var result = ts.createSymbolTable();
	            for (var _i = 0, symbols_2 = symbols; _i < symbols_2.length; _i++) {
	                var symbol = symbols_2[_i];
	                result.set(symbol.escapedName, mappingThisOnly && isThisless(symbol) ? symbol : instantiateSymbol(symbol, mapper));
	            }
	            return result;
	        }
	        function addInheritedMembers(symbols, baseSymbols) {
	            for (var _i = 0, baseSymbols_1 = baseSymbols; _i < baseSymbols_1.length; _i++) {
	                var s = baseSymbols_1[_i];
	                if (!symbols.has(s.escapedName)) {
	                    symbols.set(s.escapedName, s);
	                }
	            }
	        }
	        function resolveDeclaredMembers(type) {
	            if (!type.declaredProperties) {
	                var symbol = type.symbol;
	                var members = getMembersOfSymbol(symbol);
	                type.declaredProperties = getNamedMembers(members);
	                // Start with signatures at empty array in case of recursive types
	                type.declaredCallSignatures = ts.emptyArray;
	                type.declaredConstructSignatures = ts.emptyArray;
	                type.declaredCallSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */));
	                type.declaredConstructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */));
	                type.declaredStringIndexInfo = getIndexInfoOfSymbol(symbol, 0 /* String */);
	                type.declaredNumberIndexInfo = getIndexInfoOfSymbol(symbol, 1 /* Number */);
	            }
	            return type;
	        }
	        /**
	         * Indicates whether a type can be used as a late-bound name.
	         */
	        function isTypeUsableAsLateBoundName(type) {
	            return !!(type.flags & 1120 /* StringOrNumberLiteralOrUnique */);
	        }
	        /**
	         * Indicates whether a declaration name is definitely late-bindable.
	         * A declaration name is only late-bindable if:
	         * - It is a `ComputedPropertyName`.
	         * - Its expression is an `Identifier` or either a `PropertyAccessExpression` an
	         * `ElementAccessExpression` consisting only of these same three types of nodes.
	         * - The type of its expression is a string or numeric literal type, or is a `unique symbol` type.
	         */
	        function isLateBindableName(node) {
	            return ts.isComputedPropertyName(node)
	                && ts.isEntityNameExpression(node.expression)
	                && isTypeUsableAsLateBoundName(checkComputedPropertyName(node));
	        }
	        /**
	         * Indicates whether a declaration has a late-bindable dynamic name.
	         */
	        function hasLateBindableName(node) {
	            var name = ts.getNameOfDeclaration(node);
	            return name && isLateBindableName(name);
	        }
	        /**
	         * Indicates whether a declaration has a dynamic name that cannot be late-bound.
	         */
	        function hasNonBindableDynamicName(node) {
	            return ts.hasDynamicName(node) && !hasLateBindableName(node);
	        }
	        /**
	         * Indicates whether a declaration name is a dynamic name that cannot be late-bound.
	         */
	        function isNonBindableDynamicName(node) {
	            return ts.isDynamicName(node) && !isLateBindableName(node);
	        }
	        /**
	         * Gets the symbolic name for a late-bound member from its type.
	         */
	        function getLateBoundNameFromType(type) {
	            if (type.flags & 1024 /* UniqueESSymbol */) {
	                return "__@" + type.symbol.escapedName + "@" + getSymbolId(type.symbol);
	            }
	            if (type.flags & 96 /* StringOrNumberLiteral */) {
	                return ts.escapeLeadingUnderscores("" + type.value);
	            }
	        }
	        /**
	         * Adds a declaration to a late-bound dynamic member. This performs the same function for
	         * late-bound members that `addDeclarationToSymbol` in binder.ts performs for early-bound
	         * members.
	         */
	        function addDeclarationToLateBoundSymbol(symbol, member, symbolFlags) {
	            ts.Debug.assert(!!(ts.getCheckFlags(symbol) & 1024 /* Late */), "Expected a late-bound symbol.");
	            symbol.flags |= symbolFlags;
	            getSymbolLinks(member.symbol).lateSymbol = symbol;
	            if (!symbol.declarations) {
	                symbol.declarations = [member];
	            }
	            else {
	                symbol.declarations.push(member);
	            }
	            if (symbolFlags & 67216319 /* Value */) {
	                var valueDeclaration = symbol.valueDeclaration;
	                if (!valueDeclaration || valueDeclaration.kind !== member.kind) {
	                    symbol.valueDeclaration = member;
	                }
	            }
	        }
	        /**
	         * Performs late-binding of a dynamic member. This performs the same function for
	         * late-bound members that `declareSymbol` in binder.ts performs for early-bound
	         * members.
	         *
	         * If a symbol is a dynamic name from a computed property, we perform an additional "late"
	         * binding phase to attempt to resolve the name for the symbol from the type of the computed
	         * property's expression. If the type of the expression is a string-literal, numeric-literal,
	         * or unique symbol type, we can use that type as the name of the symbol.
	         *
	         * For example, given:
	         *
	         *   const x = Symbol();
	         *
	         *   interface I {
	         *     [x]: number;
	         *   }
	         *
	         * The binder gives the property `[x]: number` a special symbol with the name "__computed".
	         * In the late-binding phase we can type-check the expression `x` and see that it has a
	         * unique symbol type which we can then use as the name of the member. This allows users
	         * to define custom symbols that can be used in the members of an object type.
	         *
	         * @param parent The containing symbol for the member.
	         * @param earlySymbols The early-bound symbols of the parent.
	         * @param lateSymbols The late-bound symbols of the parent.
	         * @param decl The member to bind.
	         */
	        function lateBindMember(parent, earlySymbols, lateSymbols, decl) {
	            ts.Debug.assert(!!decl.symbol, "The member is expected to have a symbol.");
	            var links = getNodeLinks(decl);
	            if (!links.resolvedSymbol) {
	                // In the event we attempt to resolve the late-bound name of this member recursively,
	                // fall back to the early-bound name of this member.
	                links.resolvedSymbol = decl.symbol;
	                var type = checkComputedPropertyName(decl.name);
	                if (isTypeUsableAsLateBoundName(type)) {
	                    var memberName = getLateBoundNameFromType(type);
	                    var symbolFlags = decl.symbol.flags;
	                    // Get or add a late-bound symbol for the member. This allows us to merge late-bound accessor declarations.
	                    var lateSymbol = lateSymbols.get(memberName);
	                    if (!lateSymbol)
	                        lateSymbols.set(memberName, lateSymbol = createSymbol(0 /* None */, memberName, 1024 /* Late */));
	                    // Report an error if a late-bound member has the same name as an early-bound member,
	                    // or if we have another early-bound symbol declaration with the same name and
	                    // conflicting flags.
	                    var earlySymbol = earlySymbols && earlySymbols.get(memberName);
	                    if (lateSymbol.flags & getExcludedSymbolFlags(symbolFlags) || earlySymbol) {
	                        // If we have an existing early-bound member, combine its declarations so that we can
	                        // report an error at each declaration.
	                        var declarations = earlySymbol ? ts.concatenate(earlySymbol.declarations, lateSymbol.declarations) : lateSymbol.declarations;
	                        var name_2 = ts.declarationNameToString(decl.name);
	                        ts.forEach(declarations, function (declaration) { return error(ts.getNameOfDeclaration(declaration) || declaration, ts.Diagnostics.Duplicate_declaration_0, name_2); });
	                        error(decl.name || decl, ts.Diagnostics.Duplicate_declaration_0, name_2);
	                        lateSymbol = createSymbol(0 /* None */, memberName, 1024 /* Late */);
	                    }
	                    lateSymbol.nameType = type;
	                    addDeclarationToLateBoundSymbol(lateSymbol, decl, symbolFlags);
	                    if (lateSymbol.parent) {
	                        ts.Debug.assert(lateSymbol.parent === parent, "Existing symbol parent should match new one");
	                    }
	                    else {
	                        lateSymbol.parent = parent;
	                    }
	                    return links.resolvedSymbol = lateSymbol;
	                }
	            }
	            return links.resolvedSymbol;
	        }
	        function getResolvedMembersOrExportsOfSymbol(symbol, resolutionKind) {
	            var links = getSymbolLinks(symbol);
	            if (!links[resolutionKind]) {
	                var isStatic = resolutionKind === "resolvedExports" /* resolvedExports */;
	                var earlySymbols = !isStatic ? symbol.members :
	                    symbol.flags & 1536 /* Module */ ? getExportsOfModuleWorker(symbol) :
	                        symbol.exports;
	                // In the event we recursively resolve the members/exports of the symbol, we
	                // set the initial value of resolvedMembers/resolvedExports to the early-bound
	                // members/exports of the symbol.
	                links[resolutionKind] = earlySymbols || emptySymbols;
	                // fill in any as-yet-unresolved late-bound members.
	                var lateSymbols = ts.createSymbolTable();
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var members = ts.getMembersOfDeclaration(decl);
	                    if (members) {
	                        for (var _b = 0, members_4 = members; _b < members_4.length; _b++) {
	                            var member = members_4[_b];
	                            if (isStatic === ts.hasStaticModifier(member) && hasLateBindableName(member)) {
	                                lateBindMember(symbol, earlySymbols, lateSymbols, member);
	                            }
	                        }
	                    }
	                }
	                links[resolutionKind] = combineSymbolTables(earlySymbols, lateSymbols) || emptySymbols;
	            }
	            return links[resolutionKind];
	        }
	        /**
	         * Gets a SymbolTable containing both the early- and late-bound members of a symbol.
	         *
	         * For a description of late-binding, see `lateBindMember`.
	         */
	        function getMembersOfSymbol(symbol) {
	            return symbol.flags & 6240 /* LateBindingContainer */
	                ? getResolvedMembersOrExportsOfSymbol(symbol, "resolvedMembers" /* resolvedMembers */)
	                : symbol.members || emptySymbols;
	        }
	        /**
	         * If a symbol is the dynamic name of the member of an object type, get the late-bound
	         * symbol of the member.
	         *
	         * For a description of late-binding, see `lateBindMember`.
	         */
	        function getLateBoundSymbol(symbol) {
	            if (symbol.flags & 106500 /* ClassMember */ && symbol.escapedName === "__computed" /* Computed */) {
	                var links = getSymbolLinks(symbol);
	                if (!links.lateSymbol && ts.some(symbol.declarations, hasLateBindableName)) {
	                    // force late binding of members/exports. This will set the late-bound symbol
	                    if (ts.some(symbol.declarations, ts.hasStaticModifier)) {
	                        getExportsOfSymbol(symbol.parent);
	                    }
	                    else {
	                        getMembersOfSymbol(symbol.parent);
	                    }
	                }
	                return links.lateSymbol || (links.lateSymbol = symbol);
	            }
	            return symbol;
	        }
	        function getTypeWithThisArgument(type, thisArgument, needApparentType) {
	            if (ts.getObjectFlags(type) & 4 /* Reference */) {
	                var target = type.target;
	                var typeArguments = type.typeArguments;
	                if (ts.length(target.typeParameters) === ts.length(typeArguments)) {
	                    var ref = createTypeReference(target, ts.concatenate(typeArguments, [thisArgument || target.thisType]));
	                    return needApparentType ? getApparentType(ref) : ref;
	                }
	            }
	            else if (type.flags & 262144 /* Intersection */) {
	                return getIntersectionType(ts.map(type.types, function (t) { return getTypeWithThisArgument(t, thisArgument, needApparentType); }));
	            }
	            return needApparentType ? getApparentType(type) : type;
	        }
	        function resolveObjectTypeMembers(type, source, typeParameters, typeArguments) {
	            var mapper;
	            var members;
	            var callSignatures;
	            var constructSignatures;
	            var stringIndexInfo;
	            var numberIndexInfo;
	            if (ts.rangeEquals(typeParameters, typeArguments, 0, typeParameters.length)) {
	                mapper = identityMapper;
	                members = source.symbol ? getMembersOfSymbol(source.symbol) : ts.createSymbolTable(source.declaredProperties);
	                callSignatures = source.declaredCallSignatures;
	                constructSignatures = source.declaredConstructSignatures;
	                stringIndexInfo = source.declaredStringIndexInfo;
	                numberIndexInfo = source.declaredNumberIndexInfo;
	            }
	            else {
	                mapper = createTypeMapper(typeParameters, typeArguments);
	                members = createInstantiatedSymbolTable(source.declaredProperties, mapper, /*mappingThisOnly*/ typeParameters.length === 1);
	                callSignatures = instantiateSignatures(source.declaredCallSignatures, mapper);
	                constructSignatures = instantiateSignatures(source.declaredConstructSignatures, mapper);
	                stringIndexInfo = instantiateIndexInfo(source.declaredStringIndexInfo, mapper);
	                numberIndexInfo = instantiateIndexInfo(source.declaredNumberIndexInfo, mapper);
	            }
	            var baseTypes = getBaseTypes(source);
	            if (baseTypes.length) {
	                if (source.symbol && members === getMembersOfSymbol(source.symbol)) {
	                    members = ts.createSymbolTable(source.declaredProperties);
	                }
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	                var thisArgument = ts.lastOrUndefined(typeArguments);
	                for (var _i = 0, baseTypes_1 = baseTypes; _i < baseTypes_1.length; _i++) {
	                    var baseType = baseTypes_1[_i];
	                    var instantiatedBaseType = thisArgument ? getTypeWithThisArgument(instantiateType(baseType, mapper), thisArgument) : baseType;
	                    addInheritedMembers(members, getPropertiesOfType(instantiatedBaseType));
	                    callSignatures = ts.concatenate(callSignatures, getSignaturesOfType(instantiatedBaseType, 0 /* Call */));
	                    constructSignatures = ts.concatenate(constructSignatures, getSignaturesOfType(instantiatedBaseType, 1 /* Construct */));
	                    if (!stringIndexInfo) {
	                        stringIndexInfo = instantiatedBaseType === anyType ?
	                            createIndexInfo(anyType, /*isReadonly*/ false) :
	                            getIndexInfoOfType(instantiatedBaseType, 0 /* String */);
	                    }
	                    numberIndexInfo = numberIndexInfo || getIndexInfoOfType(instantiatedBaseType, 1 /* Number */);
	                }
	            }
	            setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function resolveClassOrInterfaceMembers(type) {
	            resolveObjectTypeMembers(type, resolveDeclaredMembers(type), ts.emptyArray, ts.emptyArray);
	        }
	        function resolveTypeReferenceMembers(type) {
	            var source = resolveDeclaredMembers(type.target);
	            var typeParameters = ts.concatenate(source.typeParameters, [source.thisType]);
	            var typeArguments = type.typeArguments && type.typeArguments.length === typeParameters.length ?
	                type.typeArguments : ts.concatenate(type.typeArguments, [type]);
	            resolveObjectTypeMembers(type, source, typeParameters, typeArguments);
	        }
	        function createSignature(declaration, typeParameters, thisParameter, parameters, resolvedReturnType, resolvedTypePredicate, minArgumentCount, hasRestParameter, hasLiteralTypes) {
	            var sig = new Signature(checker);
	            sig.declaration = declaration;
	            sig.typeParameters = typeParameters;
	            sig.parameters = parameters;
	            sig.thisParameter = thisParameter;
	            sig.resolvedReturnType = resolvedReturnType;
	            sig.resolvedTypePredicate = resolvedTypePredicate;
	            sig.minArgumentCount = minArgumentCount;
	            sig.hasRestParameter = hasRestParameter;
	            sig.hasLiteralTypes = hasLiteralTypes;
	            sig.target = undefined;
	            sig.mapper = undefined;
	            return sig;
	        }
	        function cloneSignature(sig) {
	            return createSignature(sig.declaration, sig.typeParameters, sig.thisParameter, sig.parameters, /*resolvedReturnType*/ undefined, 
	            /*resolvedTypePredicate*/ undefined, sig.minArgumentCount, sig.hasRestParameter, sig.hasLiteralTypes);
	        }
	        function getDefaultConstructSignatures(classType) {
	            var baseConstructorType = getBaseConstructorTypeOfClass(classType);
	            var baseSignatures = getSignaturesOfType(baseConstructorType, 1 /* Construct */);
	            if (baseSignatures.length === 0) {
	                return [createSignature(undefined, classType.localTypeParameters, undefined, ts.emptyArray, classType, /*resolvedTypePredicate*/ undefined, 0, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false)];
	            }
	            var baseTypeNode = getBaseTypeNodeOfClass(classType);
	            var isJavaScript = ts.isInJavaScriptFile(baseTypeNode);
	            var typeArguments = typeArgumentsFromTypeReferenceNode(baseTypeNode);
	            var typeArgCount = ts.length(typeArguments);
	            var result = [];
	            for (var _i = 0, baseSignatures_1 = baseSignatures; _i < baseSignatures_1.length; _i++) {
	                var baseSig = baseSignatures_1[_i];
	                var minTypeArgumentCount = getMinTypeArgumentCount(baseSig.typeParameters);
	                var typeParamCount = ts.length(baseSig.typeParameters);
	                if (isJavaScript || typeArgCount >= minTypeArgumentCount && typeArgCount <= typeParamCount) {
	                    var sig = typeParamCount ? createSignatureInstantiation(baseSig, fillMissingTypeArguments(typeArguments, baseSig.typeParameters, minTypeArgumentCount, isJavaScript)) : cloneSignature(baseSig);
	                    sig.typeParameters = classType.localTypeParameters;
	                    sig.resolvedReturnType = classType;
	                    result.push(sig);
	                }
	            }
	            return result;
	        }
	        function findMatchingSignature(signatureList, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes) {
	            for (var _i = 0, signatureList_1 = signatureList; _i < signatureList_1.length; _i++) {
	                var s = signatureList_1[_i];
	                if (compareSignaturesIdentical(s, signature, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypesIdentical)) {
	                    return s;
	                }
	            }
	        }
	        function findMatchingSignatures(signatureLists, signature, listIndex) {
	            if (signature.typeParameters) {
	                // We require an exact match for generic signatures, so we only return signatures from the first
	                // signature list and only if they have exact matches in the other signature lists.
	                if (listIndex > 0) {
	                    return undefined;
	                }
	                for (var i = 1; i < signatureLists.length; i++) {
	                    if (!findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false)) {
	                        return undefined;
	                    }
	                }
	                return [signature];
	            }
	            var result;
	            for (var i = 0; i < signatureLists.length; i++) {
	                // Allow matching non-generic signatures to have excess parameters and different return types
	                var match = i === listIndex ? signature : findMatchingSignature(signatureLists[i], signature, /*partialMatch*/ true, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true);
	                if (!match) {
	                    return undefined;
	                }
	                result = ts.appendIfUnique(result, match);
	            }
	            return result;
	        }
	        // The signatures of a union type are those signatures that are present in each of the constituent types.
	        // Generic signatures must match exactly, but non-generic signatures are allowed to have extra optional
	        // parameters and may differ in return types. When signatures differ in return types, the resulting return
	        // type is the union of the constituent return types.
	        function getUnionSignatures(types, kind) {
	            var signatureLists = ts.map(types, function (t) { return getSignaturesOfType(t, kind); });
	            var result;
	            for (var i = 0; i < signatureLists.length; i++) {
	                for (var _i = 0, _a = signatureLists[i]; _i < _a.length; _i++) {
	                    var signature = _a[_i];
	                    // Only process signatures with parameter lists that aren't already in the result list
	                    if (!result || !findMatchingSignature(result, signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true)) {
	                        var unionSignatures = findMatchingSignatures(signatureLists, signature, i);
	                        if (unionSignatures) {
	                            var s = signature;
	                            // Union the result types when more than one signature matches
	                            if (unionSignatures.length > 1) {
	                                var thisParameter = signature.thisParameter;
	                                if (ts.forEach(unionSignatures, function (sig) { return sig.thisParameter; })) {
	                                    var thisType = getUnionType(ts.map(unionSignatures, function (sig) { return sig.thisParameter ? getTypeOfSymbol(sig.thisParameter) : anyType; }), 2 /* Subtype */);
	                                    thisParameter = createSymbolWithType(signature.thisParameter, thisType);
	                                }
	                                s = cloneSignature(signature);
	                                s.thisParameter = thisParameter;
	                                s.unionSignatures = unionSignatures;
	                            }
	                            (result || (result = [])).push(s);
	                        }
	                    }
	                }
	            }
	            return result || ts.emptyArray;
	        }
	        function getUnionIndexInfo(types, kind) {
	            var indexTypes = [];
	            var isAnyReadonly = false;
	            for (var _i = 0, types_2 = types; _i < types_2.length; _i++) {
	                var type = types_2[_i];
	                var indexInfo = getIndexInfoOfType(type, kind);
	                if (!indexInfo) {
	                    return undefined;
	                }
	                indexTypes.push(indexInfo.type);
	                isAnyReadonly = isAnyReadonly || indexInfo.isReadonly;
	            }
	            return createIndexInfo(getUnionType(indexTypes, 2 /* Subtype */), isAnyReadonly);
	        }
	        function resolveUnionTypeMembers(type) {
	            // The members and properties collections are empty for union types. To get all properties of a union
	            // type use getPropertiesOfType (only the language service uses this).
	            var callSignatures = getUnionSignatures(type.types, 0 /* Call */);
	            var constructSignatures = getUnionSignatures(type.types, 1 /* Construct */);
	            var stringIndexInfo = getUnionIndexInfo(type.types, 0 /* String */);
	            var numberIndexInfo = getUnionIndexInfo(type.types, 1 /* Number */);
	            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        function intersectTypes(type1, type2) {
	            return !type1 ? type2 : !type2 ? type1 : getIntersectionType([type1, type2]);
	        }
	        function intersectIndexInfos(info1, info2) {
	            return !info1 ? info2 : !info2 ? info1 : createIndexInfo(getIntersectionType([info1.type, info2.type]), info1.isReadonly && info2.isReadonly);
	        }
	        function unionSpreadIndexInfos(info1, info2) {
	            return info1 && info2 && createIndexInfo(getUnionType([info1.type, info2.type]), info1.isReadonly || info2.isReadonly);
	        }
	        function includeMixinType(type, types, index) {
	            var mixedTypes = [];
	            for (var i = 0; i < types.length; i++) {
	                if (i === index) {
	                    mixedTypes.push(type);
	                }
	                else if (isMixinConstructorType(types[i])) {
	                    mixedTypes.push(getReturnTypeOfSignature(getSignaturesOfType(types[i], 1 /* Construct */)[0]));
	                }
	            }
	            return getIntersectionType(mixedTypes);
	        }
	        function resolveIntersectionTypeMembers(type) {
	            // The members and properties collections are empty for intersection types. To get all properties of an
	            // intersection type use getPropertiesOfType (only the language service uses this).
	            var callSignatures = ts.emptyArray;
	            var constructSignatures = ts.emptyArray;
	            var stringIndexInfo;
	            var numberIndexInfo;
	            var types = type.types;
	            var mixinCount = ts.countWhere(types, isMixinConstructorType);
	            var _loop_4 = function (i) {
	                var t = type.types[i];
	                // When an intersection type contains mixin constructor types, the construct signatures from
	                // those types are discarded and their return types are mixed into the return types of all
	                // other construct signatures in the intersection type. For example, the intersection type
	                // '{ new(...args: any[]) => A } & { new(s: string) => B }' has a single construct signature
	                // 'new(s: string) => A & B'.
	                if (mixinCount === 0 || mixinCount === types.length && i === 0 || !isMixinConstructorType(t)) {
	                    var signatures = getSignaturesOfType(t, 1 /* Construct */);
	                    if (signatures.length && mixinCount > 0) {
	                        signatures = ts.map(signatures, function (s) {
	                            var clone = cloneSignature(s);
	                            clone.resolvedReturnType = includeMixinType(getReturnTypeOfSignature(s), types, i);
	                            return clone;
	                        });
	                    }
	                    constructSignatures = ts.concatenate(constructSignatures, signatures);
	                }
	                callSignatures = ts.concatenate(callSignatures, getSignaturesOfType(t, 0 /* Call */));
	                stringIndexInfo = intersectIndexInfos(stringIndexInfo, getIndexInfoOfType(t, 0 /* String */));
	                numberIndexInfo = intersectIndexInfos(numberIndexInfo, getIndexInfoOfType(t, 1 /* Number */));
	            };
	            for (var i = 0; i < types.length; i++) {
	                _loop_4(i);
	            }
	            setStructuredTypeMembers(type, emptySymbols, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	        }
	        /**
	         * Converts an AnonymousType to a ResolvedType.
	         */
	        function resolveAnonymousTypeMembers(type) {
	            var symbol = type.symbol;
	            if (type.target) {
	                var members = createInstantiatedSymbolTable(getPropertiesOfObjectType(type.target), type.mapper, /*mappingThisOnly*/ false);
	                var callSignatures = instantiateSignatures(getSignaturesOfType(type.target, 0 /* Call */), type.mapper);
	                var constructSignatures = instantiateSignatures(getSignaturesOfType(type.target, 1 /* Construct */), type.mapper);
	                var stringIndexInfo = instantiateIndexInfo(getIndexInfoOfType(type.target, 0 /* String */), type.mapper);
	                var numberIndexInfo = instantiateIndexInfo(getIndexInfoOfType(type.target, 1 /* Number */), type.mapper);
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	            }
	            else if (symbol.flags & 2048 /* TypeLiteral */) {
	                var members = getMembersOfSymbol(symbol);
	                var callSignatures = getSignaturesOfSymbol(members.get("__call" /* Call */));
	                var constructSignatures = getSignaturesOfSymbol(members.get("__new" /* New */));
	                var stringIndexInfo = getIndexInfoOfSymbol(symbol, 0 /* String */);
	                var numberIndexInfo = getIndexInfoOfSymbol(symbol, 1 /* Number */);
	                setStructuredTypeMembers(type, members, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	            }
	            else {
	                // Combinations of function, class, enum and module
	                var members = emptySymbols;
	                var stringIndexInfo = void 0;
	                if (symbol.exports) {
	                    members = getExportsOfSymbol(symbol);
	                }
	                setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, undefined, undefined);
	                if (symbol.flags & 32 /* Class */) {
	                    var classType = getDeclaredTypeOfClassOrInterface(symbol);
	                    var baseConstructorType = getBaseConstructorTypeOfClass(classType);
	                    if (baseConstructorType.flags & (65536 /* Object */ | 262144 /* Intersection */ | 1081344 /* TypeVariable */)) {
	                        members = ts.createSymbolTable(getNamedMembers(members));
	                        addInheritedMembers(members, getPropertiesOfType(baseConstructorType));
	                    }
	                    else if (baseConstructorType === anyType) {
	                        stringIndexInfo = createIndexInfo(anyType, /*isReadonly*/ false);
	                    }
	                }
	                var numberIndexInfo = symbol.flags & 384 /* Enum */ ? enumNumberIndexInfo : undefined;
	                setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	                // We resolve the members before computing the signatures because a signature may use
	                // typeof with a qualified name expression that circularly references the type we are
	                // in the process of resolving (see issue #6072). The temporarily empty signature list
	                // will never be observed because a qualified name can't reference signatures.
	                if (symbol.flags & (16 /* Function */ | 8192 /* Method */)) {
	                    type.callSignatures = getSignaturesOfSymbol(symbol);
	                }
	                // And likewise for construct signatures for classes
	                if (symbol.flags & 32 /* Class */) {
	                    var classType = getDeclaredTypeOfClassOrInterface(symbol);
	                    var constructSignatures = getSignaturesOfSymbol(symbol.members.get("__constructor" /* Constructor */));
	                    if (!constructSignatures.length) {
	                        constructSignatures = getDefaultConstructSignatures(classType);
	                    }
	                    type.constructSignatures = constructSignatures;
	                }
	            }
	        }
	        function resolveReverseMappedTypeMembers(type) {
	            var indexInfo = getIndexInfoOfType(type.source, 0 /* String */);
	            var modifiers = getMappedTypeModifiers(type.mappedType);
	            var readonlyMask = modifiers & 1 /* IncludeReadonly */ ? false : true;
	            var optionalMask = modifiers & 4 /* IncludeOptional */ ? 0 : 16777216 /* Optional */;
	            var stringIndexInfo = indexInfo && createIndexInfo(inferReverseMappedType(indexInfo.type, type.mappedType), readonlyMask && indexInfo.isReadonly);
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfType(type.source); _i < _a.length; _i++) {
	                var prop = _a[_i];
	                var checkFlags = 2048 /* ReverseMapped */ | (readonlyMask && isReadonlySymbol(prop) ? 8 /* Readonly */ : 0);
	                var inferredProp = createSymbol(4 /* Property */ | prop.flags & optionalMask, prop.escapedName, checkFlags);
	                inferredProp.declarations = prop.declarations;
	                inferredProp.nameType = prop.nameType;
	                inferredProp.propertyType = getTypeOfSymbol(prop);
	                inferredProp.mappedType = type.mappedType;
	                members.set(prop.escapedName, inferredProp);
	            }
	            setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, undefined);
	        }
	        /** Resolve the members of a mapped type { [P in K]: T } */
	        function resolveMappedTypeMembers(type) {
	            var members = ts.createSymbolTable();
	            var stringIndexInfo;
	            var numberIndexInfo;
	            // Resolve upfront such that recursive references see an empty object type.
	            setStructuredTypeMembers(type, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	            // In { [P in K]: T }, we refer to P as the type parameter type, K as the constraint type,
	            // and T as the template type.
	            var typeParameter = getTypeParameterFromMappedType(type);
	            var constraintType = getConstraintTypeFromMappedType(type);
	            var templateType = getTemplateTypeFromMappedType(type.target || type);
	            var modifiersType = getApparentType(getModifiersTypeFromMappedType(type)); // The 'T' in 'keyof T'
	            var templateModifiers = getMappedTypeModifiers(type);
	            var include = keyofStringsOnly ? 32 /* StringLiteral */ : 1120 /* StringOrNumberLiteralOrUnique */;
	            if (isMappedTypeWithKeyofConstraintDeclaration(type)) {
	                // We have a { [P in keyof T]: X }
	                for (var _i = 0, _a = getPropertiesOfType(modifiersType); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    addMemberForKeyType(getLiteralTypeFromPropertyName(prop, include), /*_index*/ undefined, prop);
	                }
	                if (modifiersType.flags & 1 /* Any */ || getIndexInfoOfType(modifiersType, 0 /* String */)) {
	                    addMemberForKeyType(stringType);
	                }
	                if (!keyofStringsOnly && getIndexInfoOfType(modifiersType, 1 /* Number */)) {
	                    addMemberForKeyType(numberType);
	                }
	            }
	            else {
	                // First, if the constraint type is a type parameter, obtain the base constraint. Then,
	                // if the key type is a 'keyof X', obtain 'keyof C' where C is the base constraint of X.
	                // Finally, iterate over the constituents of the resulting iteration type.
	                var keyType = constraintType.flags & 7372800 /* InstantiableNonPrimitive */ ? getApparentType(constraintType) : constraintType;
	                var iterationType = keyType.flags & 524288 /* Index */ ? getIndexType(getApparentType(keyType.type)) : keyType;
	                forEachType(iterationType, addMemberForKeyType);
	            }
	            setStructuredTypeMembers(type, members, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	            function addMemberForKeyType(t, _index, origin) {
	                // Create a mapper from T to the current iteration type constituent. Then, if the
	                // mapped type is itself an instantiated type, combine the iteration mapper with the
	                // instantiation mapper.
	                var templateMapper = combineTypeMappers(type.mapper, createTypeMapper([typeParameter], [t]));
	                var propType = instantiateType(templateType, templateMapper);
	                // If the current iteration type constituent is a string literal type, create a property.
	                // Otherwise, for type string create a string index signature.
	                if (t.flags & 1120 /* StringOrNumberLiteralOrUnique */) {
	                    var propName = getLateBoundNameFromType(t);
	                    var modifiersProp = getPropertyOfType(modifiersType, propName);
	                    var isOptional = !!(templateModifiers & 4 /* IncludeOptional */ ||
	                        !(templateModifiers & 8 /* ExcludeOptional */) && modifiersProp && modifiersProp.flags & 16777216 /* Optional */);
	                    var isReadonly = !!(templateModifiers & 1 /* IncludeReadonly */ ||
	                        !(templateModifiers & 2 /* ExcludeReadonly */) && modifiersProp && isReadonlySymbol(modifiersProp));
	                    var prop = createSymbol(4 /* Property */ | (isOptional ? 16777216 /* Optional */ : 0), propName, isReadonly ? 8 /* Readonly */ : 0);
	                    // When creating an optional property in strictNullChecks mode, if 'undefined' isn't assignable to the
	                    // type, we include 'undefined' in the type. Similarly, when creating a non-optional property in strictNullChecks
	                    // mode, if the underlying property is optional we remove 'undefined' from the type.
	                    prop.type = strictNullChecks && isOptional && !isTypeAssignableTo(undefinedType, propType) ? getOptionalType(propType) :
	                        strictNullChecks && !isOptional && modifiersProp && modifiersProp.flags & 16777216 /* Optional */ ? getTypeWithFacts(propType, 131072 /* NEUndefined */) :
	                            propType;
	                    if (origin) {
	                        prop.syntheticOrigin = origin;
	                        prop.declarations = origin.declarations;
	                    }
	                    prop.nameType = t;
	                    members.set(propName, prop);
	                }
	                else if (t.flags & (1 /* Any */ | 2 /* String */)) {
	                    stringIndexInfo = createIndexInfo(propType, !!(templateModifiers & 1 /* IncludeReadonly */));
	                }
	                else if (t.flags & 4 /* Number */) {
	                    numberIndexInfo = createIndexInfo(propType, !!(templateModifiers & 1 /* IncludeReadonly */));
	                }
	            }
	        }
	        function getTypeParameterFromMappedType(type) {
	            return type.typeParameter ||
	                (type.typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfNode(type.declaration.typeParameter)));
	        }
	        function getConstraintTypeFromMappedType(type) {
	            return type.constraintType ||
	                (type.constraintType = instantiateType(getConstraintOfTypeParameter(getTypeParameterFromMappedType(type)), type.mapper || identityMapper) || unknownType);
	        }
	        function getTemplateTypeFromMappedType(type) {
	            return type.templateType ||
	                (type.templateType = type.declaration.type ?
	                    instantiateType(addOptionality(getTypeFromTypeNode(type.declaration.type), !!(getMappedTypeModifiers(type) & 4 /* IncludeOptional */)), type.mapper || identityMapper) :
	                    unknownType);
	        }
	        function getConstraintDeclarationForMappedType(type) {
	            return type.declaration.typeParameter.constraint;
	        }
	        function isMappedTypeWithKeyofConstraintDeclaration(type) {
	            var constraintDeclaration = getConstraintDeclarationForMappedType(type);
	            return constraintDeclaration.kind === 174 /* TypeOperator */ &&
	                constraintDeclaration.operator === 128 /* KeyOfKeyword */;
	        }
	        function getModifiersTypeFromMappedType(type) {
	            if (!type.modifiersType) {
	                if (isMappedTypeWithKeyofConstraintDeclaration(type)) {
	                    // If the constraint declaration is a 'keyof T' node, the modifiers type is T. We check
	                    // AST nodes here because, when T is a non-generic type, the logic below eagerly resolves
	                    // 'keyof T' to a literal union type and we can't recover T from that type.
	                    type.modifiersType = instantiateType(getTypeFromTypeNode(getConstraintDeclarationForMappedType(type).type), type.mapper || identityMapper);
	                }
	                else {
	                    // Otherwise, get the declared constraint type, and if the constraint type is a type parameter,
	                    // get the constraint of that type parameter. If the resulting type is an indexed type 'keyof T',
	                    // the modifiers type is T. Otherwise, the modifiers type is {}.
	                    var declaredType = getTypeFromMappedTypeNode(type.declaration);
	                    var constraint = getConstraintTypeFromMappedType(declaredType);
	                    var extendedConstraint = constraint && constraint.flags & 32768 /* TypeParameter */ ? getConstraintOfTypeParameter(constraint) : constraint;
	                    type.modifiersType = extendedConstraint && extendedConstraint.flags & 524288 /* Index */ ? instantiateType(extendedConstraint.type, type.mapper || identityMapper) : emptyObjectType;
	                }
	            }
	            return type.modifiersType;
	        }
	        function getMappedTypeModifiers(type) {
	            var declaration = type.declaration;
	            return (declaration.readonlyToken ? declaration.readonlyToken.kind === 38 /* MinusToken */ ? 2 /* ExcludeReadonly */ : 1 /* IncludeReadonly */ : 0) |
	                (declaration.questionToken ? declaration.questionToken.kind === 38 /* MinusToken */ ? 8 /* ExcludeOptional */ : 4 /* IncludeOptional */ : 0);
	        }
	        function getMappedTypeOptionality(type) {
	            var modifiers = getMappedTypeModifiers(type);
	            return modifiers & 8 /* ExcludeOptional */ ? -1 : modifiers & 4 /* IncludeOptional */ ? 1 : 0;
	        }
	        function getCombinedMappedTypeOptionality(type) {
	            var optionality = getMappedTypeOptionality(type);
	            var modifiersType = getModifiersTypeFromMappedType(type);
	            return optionality || (isGenericMappedType(modifiersType) ? getMappedTypeOptionality(modifiersType) : 0);
	        }
	        function isPartialMappedType(type) {
	            return !!(ts.getObjectFlags(type) & 32 /* Mapped */ && getMappedTypeModifiers(type) & 4 /* IncludeOptional */);
	        }
	        function isGenericMappedType(type) {
	            return ts.getObjectFlags(type) & 32 /* Mapped */ && isGenericIndexType(getConstraintTypeFromMappedType(type));
	        }
	        function resolveStructuredTypeMembers(type) {
	            if (!type.members) {
	                if (type.flags & 65536 /* Object */) {
	                    if (type.objectFlags & 4 /* Reference */) {
	                        resolveTypeReferenceMembers(type);
	                    }
	                    else if (type.objectFlags & 3 /* ClassOrInterface */) {
	                        resolveClassOrInterfaceMembers(type);
	                    }
	                    else if (type.objectFlags & 2048 /* ReverseMapped */) {
	                        resolveReverseMappedTypeMembers(type);
	                    }
	                    else if (type.objectFlags & 16 /* Anonymous */) {
	                        resolveAnonymousTypeMembers(type);
	                    }
	                    else if (type.objectFlags & 32 /* Mapped */) {
	                        resolveMappedTypeMembers(type);
	                    }
	                }
	                else if (type.flags & 131072 /* Union */) {
	                    resolveUnionTypeMembers(type);
	                }
	                else if (type.flags & 262144 /* Intersection */) {
	                    resolveIntersectionTypeMembers(type);
	                }
	            }
	            return type;
	        }
	        /** Return properties of an object type or an empty array for other types */
	        function getPropertiesOfObjectType(type) {
	            if (type.flags & 65536 /* Object */) {
	                return resolveStructuredTypeMembers(type).properties;
	            }
	            return ts.emptyArray;
	        }
	        /** If the given type is an object type and that type has a property by the given name,
	         * return the symbol for that property. Otherwise return undefined.
	         */
	        function getPropertyOfObjectType(type, name) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                var symbol = resolved.members.get(name);
	                if (symbol && symbolIsValue(symbol)) {
	                    return symbol;
	                }
	            }
	        }
	        function getPropertiesOfUnionOrIntersectionType(type) {
	            if (!type.resolvedProperties) {
	                var members = ts.createSymbolTable();
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var current = _a[_i];
	                    for (var _b = 0, _c = getPropertiesOfType(current); _b < _c.length; _b++) {
	                        var prop = _c[_b];
	                        if (!members.has(prop.escapedName)) {
	                            var combinedProp = getPropertyOfUnionOrIntersectionType(type, prop.escapedName);
	                            if (combinedProp) {
	                                members.set(prop.escapedName, combinedProp);
	                            }
	                        }
	                    }
	                    // The properties of a union type are those that are present in all constituent types, so
	                    // we only need to check the properties of the first type
	                    if (type.flags & 131072 /* Union */) {
	                        break;
	                    }
	                }
	                type.resolvedProperties = getNamedMembers(members);
	            }
	            return type.resolvedProperties;
	        }
	        function getPropertiesOfType(type) {
	            type = getApparentType(type);
	            return type.flags & 393216 /* UnionOrIntersection */ ?
	                getPropertiesOfUnionOrIntersectionType(type) :
	                getPropertiesOfObjectType(type);
	        }
	        function getAllPossiblePropertiesOfTypes(types) {
	            var unionType = getUnionType(types);
	            if (!(unionType.flags & 131072 /* Union */)) {
	                return getAugmentedPropertiesOfType(unionType);
	            }
	            var props = ts.createSymbolTable();
	            for (var _i = 0, types_3 = types; _i < types_3.length; _i++) {
	                var memberType = types_3[_i];
	                for (var _a = 0, _b = getAugmentedPropertiesOfType(memberType); _a < _b.length; _a++) {
	                    var escapedName = _b[_a].escapedName;
	                    if (!props.has(escapedName)) {
	                        var prop = createUnionOrIntersectionProperty(unionType, escapedName);
	                        // May be undefined if the property is private
	                        if (prop)
	                            props.set(escapedName, prop);
	                    }
	                }
	            }
	            return ts.arrayFrom(props.values());
	        }
	        function getConstraintOfType(type) {
	            return type.flags & 32768 /* TypeParameter */ ? getConstraintOfTypeParameter(type) :
	                type.flags & 1048576 /* IndexedAccess */ ? getConstraintOfIndexedAccess(type) :
	                    type.flags & 2097152 /* Conditional */ ? getConstraintOfConditionalType(type) :
	                        getBaseConstraintOfType(type);
	        }
	        function getConstraintOfTypeParameter(typeParameter) {
	            return hasNonCircularBaseConstraint(typeParameter) ? getConstraintFromTypeParameter(typeParameter) : undefined;
	        }
	        function getConstraintOfIndexedAccess(type) {
	            var objectType = getBaseConstraintOfType(type.objectType) || type.objectType;
	            var indexType = getBaseConstraintOfType(type.indexType) || type.indexType;
	            var constraint = !isGenericObjectType(objectType) && !isGenericIndexType(indexType) ? getIndexedAccessType(objectType, indexType) : undefined;
	            return constraint && constraint !== unknownType ? constraint : undefined;
	        }
	        function getDefaultConstraintOfConditionalType(type) {
	            if (!type.resolvedDefaultConstraint) {
	                var rootTrueType = type.root.trueType;
	                var rootTrueConstraint = rootTrueType.flags & 4194304 /* Substitution */ ? rootTrueType.substitute : rootTrueType;
	                type.resolvedDefaultConstraint = getUnionType([instantiateType(rootTrueConstraint, type.combinedMapper || type.mapper), getFalseTypeFromConditionalType(type)]);
	            }
	            return type.resolvedDefaultConstraint;
	        }
	        function getConstraintOfDistributiveConditionalType(type) {
	            // Check if we have a conditional type of the form 'T extends U ? X : Y', where T is a constrained
	            // type parameter. If so, create an instantiation of the conditional type where T is replaced
	            // with its constraint. We do this because if the constraint is a union type it will be distributed
	            // over the conditional type and possibly reduced. For example, 'T extends undefined ? never : T'
	            // removes 'undefined' from T.
	            if (type.root.isDistributive) {
	                var constraint = getConstraintOfType(getSimplifiedType(type.checkType));
	                if (constraint) {
	                    var mapper = makeUnaryTypeMapper(type.root.checkType, constraint);
	                    var instantiated = getConditionalTypeInstantiation(type, combineTypeMappers(mapper, type.mapper));
	                    if (!(instantiated.flags & 16384 /* Never */)) {
	                        return instantiated;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getConstraintOfConditionalType(type) {
	            return getConstraintOfDistributiveConditionalType(type) || getDefaultConstraintOfConditionalType(type);
	        }
	        function getUnionConstraintOfIntersection(type, targetIsUnion) {
	            var constraints;
	            var hasDisjointDomainType = false;
	            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (t.flags & 7897088 /* Instantiable */) {
	                    // We keep following constraints as long as we have an instantiable type that is known
	                    // not to be circular or infinite (hence we stop on index access types).
	                    var constraint = getConstraintOfType(t);
	                    while (constraint && constraint.flags & (32768 /* TypeParameter */ | 524288 /* Index */ | 2097152 /* Conditional */)) {
	                        constraint = getConstraintOfType(constraint);
	                    }
	                    if (constraint) {
	                        // A constraint that isn't a union type implies that the final type would be a non-union
	                        // type as well. Since non-union constraints are of no interest, we can exit here.
	                        if (!(constraint.flags & 131072 /* Union */)) {
	                            return undefined;
	                        }
	                        constraints = ts.append(constraints, constraint);
	                    }
	                }
	                else if (t.flags & 134233854 /* DisjointDomains */) {
	                    hasDisjointDomainType = true;
	                }
	            }
	            // If the target is a union type or if we are intersecting with types belonging to one of the
	            // disjoint domans, we may end up producing a constraint that hasn't been examined before.
	            if (constraints && (targetIsUnion || hasDisjointDomainType)) {
	                if (hasDisjointDomainType) {
	                    // We add any types belong to one of the disjoint domans because they might cause the final
	                    // intersection operation to reduce the union constraints.
	                    for (var _b = 0, _c = type.types; _b < _c.length; _b++) {
	                        var t = _c[_b];
	                        if (t.flags & 134233854 /* DisjointDomains */) {
	                            constraints = ts.append(constraints, t);
	                        }
	                    }
	                }
	                return getIntersectionType(constraints);
	            }
	            return undefined;
	        }
	        function getBaseConstraintOfInstantiableNonPrimitiveUnionOrIntersection(type) {
	            if (type.flags & (7372800 /* InstantiableNonPrimitive */ | 393216 /* UnionOrIntersection */)) {
	                var constraint = getResolvedBaseConstraint(type);
	                if (constraint !== noConstraintType && constraint !== circularConstraintType) {
	                    return constraint;
	                }
	            }
	        }
	        function getBaseConstraintOfType(type) {
	            var constraint = getBaseConstraintOfInstantiableNonPrimitiveUnionOrIntersection(type);
	            if (!constraint && type.flags & 524288 /* Index */) {
	                return keyofConstraintType;
	            }
	            return constraint;
	        }
	        /**
	         * This is similar to `getBaseConstraintOfType` except it returns the input type if there's no base constraint, instead of `undefined`
	         * It also doesn't map indexes to `string`, as where this is used this would be unneeded (and likely undesirable)
	         */
	        function getBaseConstraintOrType(type) {
	            return getBaseConstraintOfType(type) || type;
	        }
	        function hasNonCircularBaseConstraint(type) {
	            return getResolvedBaseConstraint(type) !== circularConstraintType;
	        }
	        /**
	         * Return the resolved base constraint of a type variable. The noConstraintType singleton is returned if the
	         * type variable has no constraint, and the circularConstraintType singleton is returned if the constraint
	         * circularly references the type variable.
	         */
	        function getResolvedBaseConstraint(type) {
	            var circular;
	            if (!type.resolvedBaseConstraint) {
	                var constraint = getBaseConstraint(type);
	                type.resolvedBaseConstraint = circular ? circularConstraintType : getTypeWithThisArgument(constraint || noConstraintType, type);
	            }
	            return type.resolvedBaseConstraint;
	            function getBaseConstraint(t) {
	                if (!pushTypeResolution(t, 4 /* ResolvedBaseConstraint */)) {
	                    circular = true;
	                    return undefined;
	                }
	                var result = computeBaseConstraint(getSimplifiedType(t));
	                if (!popTypeResolution()) {
	                    circular = true;
	                    return undefined;
	                }
	                return result;
	            }
	            function computeBaseConstraint(t) {
	                if (t.flags & 32768 /* TypeParameter */) {
	                    var constraint = getConstraintFromTypeParameter(t);
	                    return t.isThisType || !constraint ?
	                        constraint :
	                        getBaseConstraint(constraint);
	                }
	                if (t.flags & 393216 /* UnionOrIntersection */) {
	                    var types = t.types;
	                    var baseTypes = [];
	                    for (var _i = 0, types_4 = types; _i < types_4.length; _i++) {
	                        var type_3 = types_4[_i];
	                        var baseType = getBaseConstraint(type_3);
	                        if (baseType) {
	                            baseTypes.push(baseType);
	                        }
	                    }
	                    return t.flags & 131072 /* Union */ && baseTypes.length === types.length ? getUnionType(baseTypes) :
	                        t.flags & 262144 /* Intersection */ && baseTypes.length ? getIntersectionType(baseTypes) :
	                            undefined;
	                }
	                if (t.flags & 524288 /* Index */) {
	                    return keyofConstraintType;
	                }
	                if (t.flags & 1048576 /* IndexedAccess */) {
	                    var baseObjectType = getBaseConstraint(t.objectType);
	                    var baseIndexType = getBaseConstraint(t.indexType);
	                    var baseIndexedAccess = baseObjectType && baseIndexType ? getIndexedAccessType(baseObjectType, baseIndexType) : undefined;
	                    return baseIndexedAccess && baseIndexedAccess !== unknownType ? getBaseConstraint(baseIndexedAccess) : undefined;
	                }
	                if (t.flags & 2097152 /* Conditional */) {
	                    var constraint = getConstraintOfConditionalType(t);
	                    return constraint && getBaseConstraint(constraint);
	                }
	                if (t.flags & 4194304 /* Substitution */) {
	                    return getBaseConstraint(t.substitute);
	                }
	                if (isGenericMappedType(t)) {
	                    return emptyObjectType;
	                }
	                return t;
	            }
	        }
	        function getApparentTypeOfIntersectionType(type) {
	            return type.resolvedApparentType || (type.resolvedApparentType = getTypeWithThisArgument(type, type, /*apparentType*/ true));
	        }
	        function getResolvedTypeParameterDefault(typeParameter) {
	            if (!typeParameter.default) {
	                if (typeParameter.target) {
	                    var targetDefault = getResolvedTypeParameterDefault(typeParameter.target);
	                    typeParameter.default = targetDefault ? instantiateType(targetDefault, typeParameter.mapper) : noConstraintType;
	                }
	                else {
	                    // To block recursion, set the initial value to the resolvingDefaultType.
	                    typeParameter.default = resolvingDefaultType;
	                    var defaultDeclaration = typeParameter.symbol && ts.forEach(typeParameter.symbol.declarations, function (decl) { return ts.isTypeParameterDeclaration(decl) && decl.default; });
	                    var defaultType = defaultDeclaration ? getTypeFromTypeNode(defaultDeclaration) : noConstraintType;
	                    if (typeParameter.default === resolvingDefaultType) {
	                        // If we have not been called recursively, set the correct default type.
	                        typeParameter.default = defaultType;
	                    }
	                }
	            }
	            else if (typeParameter.default === resolvingDefaultType) {
	                // If we are called recursively for this type parameter, mark the default as circular.
	                typeParameter.default = circularConstraintType;
	            }
	            return typeParameter.default;
	        }
	        /**
	         * Gets the default type for a type parameter.
	         *
	         * If the type parameter is the result of an instantiation, this gets the instantiated
	         * default type of its target. If the type parameter has no default type or the default is
	         * circular, `undefined` is returned.
	         */
	        function getDefaultFromTypeParameter(typeParameter) {
	            var defaultType = getResolvedTypeParameterDefault(typeParameter);
	            return defaultType !== noConstraintType && defaultType !== circularConstraintType ? defaultType : undefined;
	        }
	        function hasNonCircularTypeParameterDefault(typeParameter) {
	            return getResolvedTypeParameterDefault(typeParameter) !== circularConstraintType;
	        }
	        /**
	         * Indicates whether the declaration of a typeParameter has a default type.
	         */
	        function hasTypeParameterDefault(typeParameter) {
	            return !!(typeParameter.symbol && ts.forEach(typeParameter.symbol.declarations, function (decl) { return ts.isTypeParameterDeclaration(decl) && decl.default; }));
	        }
	        /**
	         * For a type parameter, return the base constraint of the type parameter. For the string, number,
	         * boolean, and symbol primitive types, return the corresponding object types. Otherwise return the
	         * type itself. Note that the apparent type of a union type is the union type itself.
	         */
	        function getApparentType(type) {
	            var t = type.flags & 7897088 /* Instantiable */ ? getBaseConstraintOfType(type) || emptyObjectType : type;
	            return t.flags & 262144 /* Intersection */ ? getApparentTypeOfIntersectionType(t) :
	                t.flags & 34 /* StringLike */ ? globalStringType :
	                    t.flags & 84 /* NumberLike */ ? globalNumberType :
	                        t.flags & 136 /* BooleanLike */ ? globalBooleanType :
	                            t.flags & 1536 /* ESSymbolLike */ ? getGlobalESSymbolType(/*reportErrors*/ languageVersion >= 2 /* ES2015 */) :
	                                t.flags & 134217728 /* NonPrimitive */ ? emptyObjectType :
	                                    t.flags & 524288 /* Index */ ? keyofConstraintType :
	                                        t;
	        }
	        function createUnionOrIntersectionProperty(containingType, name) {
	            var props;
	            var isUnion = containingType.flags & 131072 /* Union */;
	            var excludeModifiers = isUnion ? 24 /* NonPublicAccessibilityModifier */ : 0;
	            // Flags we want to propagate to the result if they exist in all source symbols
	            var commonFlags = isUnion ? 0 /* None */ : 16777216 /* Optional */;
	            var syntheticFlag = 4 /* SyntheticMethod */;
	            var checkFlags = 0;
	            for (var _i = 0, _a = containingType.types; _i < _a.length; _i++) {
	                var current = _a[_i];
	                var type = getApparentType(current);
	                if (type !== unknownType) {
	                    var prop = getPropertyOfType(type, name);
	                    var modifiers = prop ? ts.getDeclarationModifierFlagsFromSymbol(prop) : 0;
	                    if (prop && !(modifiers & excludeModifiers)) {
	                        commonFlags &= prop.flags;
	                        props = ts.appendIfUnique(props, prop);
	                        checkFlags |= (isReadonlySymbol(prop) ? 8 /* Readonly */ : 0) |
	                            (!(modifiers & 24 /* NonPublicAccessibilityModifier */) ? 64 /* ContainsPublic */ : 0) |
	                            (modifiers & 16 /* Protected */ ? 128 /* ContainsProtected */ : 0) |
	                            (modifiers & 8 /* Private */ ? 256 /* ContainsPrivate */ : 0) |
	                            (modifiers & 32 /* Static */ ? 512 /* ContainsStatic */ : 0);
	                        if (!isPrototypeProperty(prop)) {
	                            syntheticFlag = 2 /* SyntheticProperty */;
	                        }
	                    }
	                    else if (isUnion) {
	                        checkFlags |= 16 /* Partial */;
	                    }
	                }
	            }
	            if (!props) {
	                return undefined;
	            }
	            if (props.length === 1 && !(checkFlags & 16 /* Partial */)) {
	                return props[0];
	            }
	            var declarations;
	            var commonType;
	            var nameType;
	            var propTypes = [];
	            var first = true;
	            var commonValueDeclaration;
	            var hasNonUniformValueDeclaration = false;
	            for (var _b = 0, props_1 = props; _b < props_1.length; _b++) {
	                var prop = props_1[_b];
	                if (!commonValueDeclaration) {
	                    commonValueDeclaration = prop.valueDeclaration;
	                }
	                else if (prop.valueDeclaration !== commonValueDeclaration) {
	                    hasNonUniformValueDeclaration = true;
	                }
	                declarations = ts.addRange(declarations, prop.declarations);
	                var type = getTypeOfSymbol(prop);
	                if (first) {
	                    commonType = type;
	                    nameType = prop.nameType;
	                    first = false;
	                }
	                else {
	                    if (type !== commonType) {
	                        checkFlags |= 32 /* HasNonUniformType */;
	                    }
	                }
	                propTypes.push(type);
	            }
	            var result = createSymbol(4 /* Property */ | commonFlags, name, syntheticFlag | checkFlags);
	            result.containingType = containingType;
	            if (!hasNonUniformValueDeclaration && commonValueDeclaration) {
	                result.valueDeclaration = commonValueDeclaration;
	            }
	            result.declarations = declarations;
	            result.nameType = nameType;
	            result.type = isUnion ? getUnionType(propTypes) : getIntersectionType(propTypes);
	            return result;
	        }
	        // Return the symbol for a given property in a union or intersection type, or undefined if the property
	        // does not exist in any constituent type. Note that the returned property may only be present in some
	        // constituents, in which case the isPartial flag is set when the containing type is union type. We need
	        // these partial properties when identifying discriminant properties, but otherwise they are filtered out
	        // and do not appear to be present in the union type.
	        function getUnionOrIntersectionProperty(type, name) {
	            var properties = type.propertyCache || (type.propertyCache = ts.createSymbolTable());
	            var property = properties.get(name);
	            if (!property) {
	                property = createUnionOrIntersectionProperty(type, name);
	                if (property) {
	                    properties.set(name, property);
	                }
	            }
	            return property;
	        }
	        function getPropertyOfUnionOrIntersectionType(type, name) {
	            var property = getUnionOrIntersectionProperty(type, name);
	            // We need to filter out partial properties in union types
	            return property && !(ts.getCheckFlags(property) & 16 /* Partial */) ? property : undefined;
	        }
	        /**
	         * Return the symbol for the property with the given name in the given type. Creates synthetic union properties when
	         * necessary, maps primitive types and type parameters are to their apparent types, and augments with properties from
	         * Object and Function as appropriate.
	         *
	         * @param type a type to look up property from
	         * @param name a name of property to look up in a given type
	         */
	        function getPropertyOfType(type, name) {
	            type = getApparentType(type);
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                var symbol = resolved.members.get(name);
	                if (symbol && symbolIsValue(symbol)) {
	                    return symbol;
	                }
	                if (resolved === anyFunctionType || resolved.callSignatures.length || resolved.constructSignatures.length) {
	                    var symbol_1 = getPropertyOfObjectType(globalFunctionType, name);
	                    if (symbol_1) {
	                        return symbol_1;
	                    }
	                }
	                return getPropertyOfObjectType(globalObjectType, name);
	            }
	            if (type.flags & 393216 /* UnionOrIntersection */) {
	                return getPropertyOfUnionOrIntersectionType(type, name);
	            }
	            return undefined;
	        }
	        function getSignaturesOfStructuredType(type, kind) {
	            if (type.flags & 458752 /* StructuredType */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                return kind === 0 /* Call */ ? resolved.callSignatures : resolved.constructSignatures;
	            }
	            return ts.emptyArray;
	        }
	        /**
	         * Return the signatures of the given kind in the given type. Creates synthetic union signatures when necessary and
	         * maps primitive types and type parameters are to their apparent types.
	         */
	        function getSignaturesOfType(type, kind) {
	            return getSignaturesOfStructuredType(getApparentType(type), kind);
	        }
	        function getIndexInfoOfStructuredType(type, kind) {
	            if (type.flags & 458752 /* StructuredType */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                return kind === 0 /* String */ ? resolved.stringIndexInfo : resolved.numberIndexInfo;
	            }
	        }
	        function getIndexTypeOfStructuredType(type, kind) {
	            var info = getIndexInfoOfStructuredType(type, kind);
	            return info && info.type;
	        }
	        // Return the indexing info of the given kind in the given type. Creates synthetic union index types when necessary and
	        // maps primitive types and type parameters are to their apparent types.
	        function getIndexInfoOfType(type, kind) {
	            return getIndexInfoOfStructuredType(getApparentType(type), kind);
	        }
	        // Return the index type of the given kind in the given type. Creates synthetic union index types when necessary and
	        // maps primitive types and type parameters are to their apparent types.
	        function getIndexTypeOfType(type, kind) {
	            return getIndexTypeOfStructuredType(getApparentType(type), kind);
	        }
	        function getImplicitIndexTypeOfType(type, kind) {
	            if (isObjectTypeWithInferableIndex(type)) {
	                var propTypes = [];
	                for (var _i = 0, _a = getPropertiesOfType(type); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (kind === 0 /* String */ || isNumericLiteralName(prop.escapedName)) {
	                        propTypes.push(getTypeOfSymbol(prop));
	                    }
	                }
	                if (propTypes.length) {
	                    return getUnionType(propTypes, 2 /* Subtype */);
	                }
	            }
	            return undefined;
	        }
	        // Return list of type parameters with duplicates removed (duplicate identifier errors are generated in the actual
	        // type checking functions).
	        function getTypeParametersFromDeclaration(declaration) {
	            var result;
	            for (var _i = 0, _a = ts.getEffectiveTypeParameterDeclarations(declaration); _i < _a.length; _i++) {
	                var node = _a[_i];
	                result = ts.appendIfUnique(result, getDeclaredTypeOfTypeParameter(node.symbol));
	            }
	            return result;
	        }
	        function symbolsToArray(symbols) {
	            var result = [];
	            symbols.forEach(function (symbol, id) {
	                if (!isReservedMemberName(id)) {
	                    result.push(symbol);
	                }
	            });
	            return result;
	        }
	        function isJSDocOptionalParameter(node) {
	            return ts.isInJavaScriptFile(node) && (
	            // node.type should only be a JSDocOptionalType when node is a parameter of a JSDocFunctionType
	            node.type && node.type.kind === 282 /* JSDocOptionalType */
	                || ts.getJSDocParameterTags(node).some(function (_a) {
	                    var isBracketed = _a.isBracketed, typeExpression = _a.typeExpression;
	                    return isBracketed || !!typeExpression && typeExpression.type.kind === 282 /* JSDocOptionalType */;
	                }));
	        }
	        function tryFindAmbientModule(moduleName, withAugmentations) {
	            if (ts.isExternalModuleNameRelative(moduleName)) {
	                return undefined;
	            }
	            var symbol = getSymbol(globals, '"' + moduleName + '"', 512 /* ValueModule */);
	            // merged symbol is module declaration symbol combined with all augmentations
	            return symbol && withAugmentations ? getMergedSymbol(symbol) : symbol;
	        }
	        function isOptionalParameter(node) {
	            if (ts.hasQuestionToken(node) || isOptionalJSDocParameterTag(node) || isJSDocOptionalParameter(node)) {
	                return true;
	            }
	            if (node.initializer) {
	                var signature = getSignatureFromDeclaration(node.parent);
	                var parameterIndex = node.parent.parameters.indexOf(node);
	                ts.Debug.assert(parameterIndex >= 0);
	                return parameterIndex >= signature.minArgumentCount;
	            }
	            var iife = ts.getImmediatelyInvokedFunctionExpression(node.parent);
	            if (iife) {
	                return !node.type &&
	                    !node.dotDotDotToken &&
	                    node.parent.parameters.indexOf(node) >= iife.arguments.length;
	            }
	            return false;
	        }
	        function isOptionalJSDocParameterTag(node) {
	            if (!ts.isJSDocParameterTag(node)) {
	                return false;
	            }
	            var isBracketed = node.isBracketed, typeExpression = node.typeExpression;
	            return isBracketed || !!typeExpression && typeExpression.type.kind === 282 /* JSDocOptionalType */;
	        }
	        function createTypePredicateFromTypePredicateNode(node) {
	            var parameterName = node.parameterName;
	            var type = getTypeFromTypeNode(node.type);
	            if (parameterName.kind === 71 /* Identifier */) {
	                return createIdentifierTypePredicate(parameterName && parameterName.escapedText, // TODO: GH#18217
	                parameterName && getTypePredicateParameterIndex(node.parent.parameters, parameterName), type);
	            }
	            else {
	                return createThisTypePredicate(type);
	            }
	        }
	        function createIdentifierTypePredicate(parameterName, parameterIndex, type) {
	            return { kind: 1 /* Identifier */, parameterName: parameterName, parameterIndex: parameterIndex, type: type };
	        }
	        function createThisTypePredicate(type) {
	            return { kind: 0 /* This */, type: type };
	        }
	        /**
	         * Gets the minimum number of type arguments needed to satisfy all non-optional type
	         * parameters.
	         */
	        function getMinTypeArgumentCount(typeParameters) {
	            var minTypeArgumentCount = 0;
	            if (typeParameters) {
	                for (var i = 0; i < typeParameters.length; i++) {
	                    if (!hasTypeParameterDefault(typeParameters[i])) {
	                        minTypeArgumentCount = i + 1;
	                    }
	                }
	            }
	            return minTypeArgumentCount;
	        }
	        /**
	         * Fill in default types for unsupplied type arguments. If `typeArguments` is undefined
	         * when a default type is supplied, a new array will be created and returned.
	         *
	         * @param typeArguments The supplied type arguments.
	         * @param typeParameters The requested type parameters.
	         * @param minTypeArgumentCount The minimum number of required type arguments.
	         */
	        function fillMissingTypeArguments(typeArguments, typeParameters, minTypeArgumentCount, isJavaScriptImplicitAny) {
	            var numTypeParameters = ts.length(typeParameters);
	            if (numTypeParameters) {
	                var numTypeArguments = ts.length(typeArguments);
	                if (isJavaScriptImplicitAny || (numTypeArguments >= minTypeArgumentCount && numTypeArguments <= numTypeParameters)) {
	                    if (!typeArguments) {
	                        typeArguments = [];
	                    }
	                    // Map an unsatisfied type parameter with a default type.
	                    // If a type parameter does not have a default type, or if the default type
	                    // is a forward reference, the empty object type is used.
	                    for (var i = numTypeArguments; i < numTypeParameters; i++) {
	                        typeArguments[i] = getDefaultTypeArgumentType(isJavaScriptImplicitAny);
	                    }
	                    for (var i = numTypeArguments; i < numTypeParameters; i++) {
	                        var mapper = createTypeMapper(typeParameters, typeArguments);
	                        var defaultType = getDefaultFromTypeParameter(typeParameters[i]);
	                        if (isJavaScriptImplicitAny && defaultType && isTypeIdenticalTo(defaultType, emptyObjectType)) {
	                            defaultType = anyType;
	                        }
	                        typeArguments[i] = defaultType ? instantiateType(defaultType, mapper) : getDefaultTypeArgumentType(isJavaScriptImplicitAny);
	                    }
	                    typeArguments.length = typeParameters.length;
	                }
	            }
	            return typeArguments;
	        }
	        function getSignatureFromDeclaration(declaration) {
	            var links = getNodeLinks(declaration);
	            if (!links.resolvedSignature) {
	                var parameters = [];
	                var hasLiteralTypes = false;
	                var minArgumentCount = 0;
	                var thisParameter = void 0;
	                var hasThisParameter = void 0;
	                var iife = ts.getImmediatelyInvokedFunctionExpression(declaration);
	                var isJSConstructSignature = ts.isJSDocConstructSignature(declaration);
	                var isUntypedSignatureInJSFile = !iife &&
	                    ts.isInJavaScriptFile(declaration) &&
	                    ts.isValueSignatureDeclaration(declaration) &&
	                    !ts.hasJSDocParameterTags(declaration) &&
	                    !ts.getJSDocType(declaration);
	                // If this is a JSDoc construct signature, then skip the first parameter in the
	                // parameter list.  The first parameter represents the return type of the construct
	                // signature.
	                for (var i = isJSConstructSignature ? 1 : 0; i < declaration.parameters.length; i++) {
	                    var param = declaration.parameters[i];
	                    var paramSymbol = param.symbol;
	                    var type = ts.isJSDocParameterTag(param) ? (param.typeExpression && param.typeExpression.type) : param.type;
	                    // Include parameter symbol instead of property symbol in the signature
	                    if (paramSymbol && !!(paramSymbol.flags & 4 /* Property */) && !ts.isBindingPattern(param.name)) {
	                        var resolvedSymbol = resolveName(param, paramSymbol.escapedName, 67216319 /* Value */, undefined, undefined, /*isUse*/ false);
	                        paramSymbol = resolvedSymbol;
	                    }
	                    if (i === 0 && paramSymbol.escapedName === "this") {
	                        hasThisParameter = true;
	                        thisParameter = param.symbol;
	                    }
	                    else {
	                        parameters.push(paramSymbol);
	                    }
	                    if (type && type.kind === 177 /* LiteralType */) {
	                        hasLiteralTypes = true;
	                    }
	                    // Record a new minimum argument count if this is not an optional parameter
	                    var isOptionalParameter_1 = isOptionalJSDocParameterTag(param) ||
	                        param.initializer || param.questionToken || param.dotDotDotToken ||
	                        iife && parameters.length > iife.arguments.length && !type ||
	                        isUntypedSignatureInJSFile ||
	                        isJSDocOptionalParameter(param);
	                    if (!isOptionalParameter_1) {
	                        minArgumentCount = parameters.length;
	                    }
	                }
	                // If only one accessor includes a this-type annotation, the other behaves as if it had the same type annotation
	                if ((declaration.kind === 155 /* GetAccessor */ || declaration.kind === 156 /* SetAccessor */) &&
	                    !hasNonBindableDynamicName(declaration) &&
	                    (!hasThisParameter || !thisParameter)) {
	                    var otherKind = declaration.kind === 155 /* GetAccessor */ ? 156 /* SetAccessor */ : 155 /* GetAccessor */;
	                    var other = ts.getDeclarationOfKind(getSymbolOfNode(declaration), otherKind);
	                    if (other) {
	                        thisParameter = getAnnotatedAccessorThisParameter(other);
	                    }
	                }
	                var classType = declaration.kind === 154 /* Constructor */ ?
	                    getDeclaredTypeOfClassOrInterface(getMergedSymbol(declaration.parent.symbol))
	                    : undefined;
	                var typeParameters = classType ? classType.localTypeParameters : getTypeParametersFromDeclaration(declaration);
	                var returnType = getSignatureReturnTypeFromDeclaration(declaration, isJSConstructSignature, classType);
	                var hasRestLikeParameter = ts.hasRestParameter(declaration) || ts.isInJavaScriptFile(declaration) && maybeAddJsSyntheticRestParameter(declaration, parameters);
	                links.resolvedSignature = createSignature(declaration, typeParameters, thisParameter, parameters, returnType, /*resolvedTypePredicate*/ undefined, minArgumentCount, hasRestLikeParameter, hasLiteralTypes);
	            }
	            return links.resolvedSignature;
	        }
	        /**
	         * A JS function gets a synthetic rest parameter if it references `arguments` AND:
	         * 1. It has no parameters but at least one `@param` with a type that starts with `...`
	         * OR
	         * 2. It has at least one parameter, and the last parameter has a matching `@param` with a type that starts with `...`
	         */
	        function maybeAddJsSyntheticRestParameter(declaration, parameters) {
	            if (ts.isJSDocSignature(declaration) || !containsArgumentsReference(declaration)) {
	                return false;
	            }
	            var lastParam = ts.lastOrUndefined(declaration.parameters);
	            var lastParamTags = lastParam ? ts.getJSDocParameterTags(lastParam) : ts.getJSDocTags(declaration).filter(ts.isJSDocParameterTag);
	            var lastParamVariadicType = ts.firstDefined(lastParamTags, function (p) {
	                return p.typeExpression && ts.isJSDocVariadicType(p.typeExpression.type) ? p.typeExpression.type : undefined;
	            });
	            var syntheticArgsSymbol = createSymbol(3 /* Variable */, "args");
	            syntheticArgsSymbol.type = lastParamVariadicType ? createArrayType(getTypeFromTypeNode(lastParamVariadicType.type)) : anyArrayType;
	            syntheticArgsSymbol.isRestParameter = true;
	            if (lastParamVariadicType) {
	                // Replace the last parameter with a rest parameter.
	                parameters.pop();
	            }
	            parameters.push(syntheticArgsSymbol);
	            return true;
	        }
	        function getSignatureReturnTypeFromDeclaration(declaration, isJSConstructSignature, classType) {
	            if (isJSConstructSignature) {
	                return getTypeFromTypeNode(declaration.parameters[0].type);
	            }
	            else if (classType) {
	                return classType;
	            }
	            var typeNode = ts.getEffectiveReturnTypeNode(declaration);
	            if (typeNode) {
	                return getTypeFromTypeNode(typeNode);
	            }
	            // TypeScript 1.0 spec (April 2014):
	            // If only one accessor includes a type annotation, the other behaves as if it had the same type annotation.
	            if (declaration.kind === 155 /* GetAccessor */ && !hasNonBindableDynamicName(declaration)) {
	                var setter = ts.getDeclarationOfKind(getSymbolOfNode(declaration), 156 /* SetAccessor */);
	                return getAnnotatedAccessorType(setter);
	            }
	            if (ts.nodeIsMissing(declaration.body)) {
	                return anyType;
	            }
	        }
	        function containsArgumentsReference(declaration) {
	            var links = getNodeLinks(declaration);
	            if (links.containsArgumentsReference === undefined) {
	                if (links.flags & 8192 /* CaptureArguments */) {
	                    links.containsArgumentsReference = true;
	                }
	                else {
	                    links.containsArgumentsReference = traverse(declaration.body);
	                }
	            }
	            return links.containsArgumentsReference;
	            function traverse(node) {
	                if (!node)
	                    return false;
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        return node.escapedText === "arguments" && ts.isExpressionNode(node);
	                    case 151 /* PropertyDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return node.name.kind === 146 /* ComputedPropertyName */
	                            && traverse(node.name);
	                    default:
	                        return !ts.nodeStartsNewLexicalEnvironment(node) && !ts.isPartOfTypeNode(node) && ts.forEachChild(node, traverse);
	                }
	            }
	        }
	        function getSignaturesOfSymbol(symbol) {
	            if (!symbol)
	                return ts.emptyArray;
	            var result = [];
	            for (var i = 0; i < symbol.declarations.length; i++) {
	                var decl = symbol.declarations[i];
	                var node = ts.isPropertyAccessExpression(decl) ? ts.getAssignedJavascriptInitializer(decl) : decl;
	                if (!ts.isFunctionLike(node))
	                    continue;
	                // Don't include signature if node is the implementation of an overloaded function. A node is considered
	                // an implementation node if it has a body and the previous node is of the same kind and immediately
	                // precedes the implementation node (i.e. has the same parent and ends where the implementation starts).
	                if (i > 0 && node.body) {
	                    var previous = symbol.declarations[i - 1];
	                    if (node.parent === previous.parent && node.kind === previous.kind && node.pos === previous.end) {
	                        continue;
	                    }
	                }
	                result.push(getSignatureFromDeclaration(node));
	            }
	            return result;
	        }
	        function resolveExternalModuleTypeByLiteral(name) {
	            var moduleSym = resolveExternalModuleName(name, name);
	            if (moduleSym) {
	                var resolvedModuleSymbol = resolveExternalModuleSymbol(moduleSym);
	                if (resolvedModuleSymbol) {
	                    return getTypeOfSymbol(resolvedModuleSymbol);
	                }
	            }
	            return anyType;
	        }
	        function getThisTypeOfSignature(signature) {
	            if (signature.thisParameter) {
	                return getTypeOfSymbol(signature.thisParameter);
	            }
	        }
	        function signatureHasTypePredicate(signature) {
	            return getTypePredicateOfSignature(signature) !== undefined;
	        }
	        function getTypePredicateOfSignature(signature) {
	            if (!signature.resolvedTypePredicate) {
	                if (signature.target) {
	                    var targetTypePredicate = getTypePredicateOfSignature(signature.target);
	                    signature.resolvedTypePredicate = targetTypePredicate ? instantiateTypePredicate(targetTypePredicate, signature.mapper) : noTypePredicate;
	                }
	                else if (signature.unionSignatures) {
	                    signature.resolvedTypePredicate = getUnionTypePredicate(signature.unionSignatures) || noTypePredicate;
	                }
	                else {
	                    var declaration = signature.declaration;
	                    signature.resolvedTypePredicate = declaration && declaration.type && declaration.type.kind === 160 /* TypePredicate */ ?
	                        createTypePredicateFromTypePredicateNode(declaration.type) :
	                        noTypePredicate;
	                }
	                ts.Debug.assert(!!signature.resolvedTypePredicate);
	            }
	            return signature.resolvedTypePredicate === noTypePredicate ? undefined : signature.resolvedTypePredicate;
	        }
	        function getReturnTypeOfSignature(signature) {
	            if (!signature.resolvedReturnType) {
	                if (!pushTypeResolution(signature, 3 /* ResolvedReturnType */)) {
	                    return unknownType;
	                }
	                var type = void 0;
	                if (signature.target) {
	                    type = instantiateType(getReturnTypeOfSignature(signature.target), signature.mapper);
	                }
	                else if (signature.unionSignatures) {
	                    type = getUnionType(ts.map(signature.unionSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	                }
	                else {
	                    type = getReturnTypeFromBody(signature.declaration);
	                }
	                if (!popTypeResolution()) {
	                    type = anyType;
	                    if (noImplicitAny) {
	                        var declaration = signature.declaration;
	                        var name = ts.getNameOfDeclaration(declaration);
	                        if (name) {
	                            error(name, ts.Diagnostics._0_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions, ts.declarationNameToString(name));
	                        }
	                        else {
	                            error(declaration, ts.Diagnostics.Function_implicitly_has_return_type_any_because_it_does_not_have_a_return_type_annotation_and_is_referenced_directly_or_indirectly_in_one_of_its_return_expressions);
	                        }
	                    }
	                }
	                signature.resolvedReturnType = type;
	            }
	            return signature.resolvedReturnType;
	        }
	        function isResolvingReturnTypeOfSignature(signature) {
	            return !signature.resolvedReturnType && findResolutionCycleStartIndex(signature, 3 /* ResolvedReturnType */) >= 0;
	        }
	        function getRestTypeOfSignature(signature) {
	            if (signature.hasRestParameter) {
	                var type = getTypeOfSymbol(ts.lastOrUndefined(signature.parameters));
	                if (ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalArrayType) {
	                    return type.typeArguments[0];
	                }
	            }
	            return anyType;
	        }
	        function getSignatureInstantiation(signature, typeArguments, isJavascript) {
	            typeArguments = fillMissingTypeArguments(typeArguments, signature.typeParameters, getMinTypeArgumentCount(signature.typeParameters), isJavascript);
	            var instantiations = signature.instantiations || (signature.instantiations = ts.createMap());
	            var id = getTypeListId(typeArguments);
	            var instantiation = instantiations.get(id);
	            if (!instantiation) {
	                instantiations.set(id, instantiation = createSignatureInstantiation(signature, typeArguments));
	            }
	            return instantiation;
	        }
	        function createSignatureInstantiation(signature, typeArguments) {
	            return instantiateSignature(signature, createSignatureTypeMapper(signature, typeArguments), /*eraseTypeParameters*/ true);
	        }
	        function createSignatureTypeMapper(signature, typeArguments) {
	            return createTypeMapper(signature.typeParameters, typeArguments);
	        }
	        function getErasedSignature(signature) {
	            return signature.typeParameters ?
	                signature.erasedSignatureCache || (signature.erasedSignatureCache = createErasedSignature(signature)) :
	                signature;
	        }
	        function createErasedSignature(signature) {
	            // Create an instantiation of the signature where all type arguments are the any type.
	            return instantiateSignature(signature, createTypeEraser(signature.typeParameters), /*eraseTypeParameters*/ true);
	        }
	        function getCanonicalSignature(signature) {
	            return signature.typeParameters ?
	                signature.canonicalSignatureCache || (signature.canonicalSignatureCache = createCanonicalSignature(signature)) :
	                signature;
	        }
	        function createCanonicalSignature(signature) {
	            // Create an instantiation of the signature where each unconstrained type parameter is replaced with
	            // its original. When a generic class or interface is instantiated, each generic method in the class or
	            // interface is instantiated with a fresh set of cloned type parameters (which we need to handle scenarios
	            // where different generations of the same type parameter are in scope). This leads to a lot of new type
	            // identities, and potentially a lot of work comparing those identities, so here we create an instantiation
	            // that uses the original type identities for all unconstrained type parameters.
	            return getSignatureInstantiation(signature, ts.map(signature.typeParameters, function (tp) { return tp.target && !getConstraintOfTypeParameter(tp.target) ? tp.target : tp; }), ts.isInJavaScriptFile(signature.declaration));
	        }
	        function getBaseSignature(signature) {
	            var typeParameters = signature.typeParameters;
	            if (typeParameters) {
	                var typeEraser_1 = createTypeEraser(typeParameters);
	                var baseConstraints = ts.map(typeParameters, function (tp) { return instantiateType(getBaseConstraintOfType(tp), typeEraser_1) || emptyObjectType; });
	                return instantiateSignature(signature, createTypeMapper(typeParameters, baseConstraints), /*eraseTypeParameters*/ true);
	            }
	            return signature;
	        }
	        function getOrCreateTypeFromSignature(signature) {
	            // There are two ways to declare a construct signature, one is by declaring a class constructor
	            // using the constructor keyword, and the other is declaring a bare construct signature in an
	            // object type literal or interface (using the new keyword). Each way of declaring a constructor
	            // will result in a different declaration kind.
	            if (!signature.isolatedSignatureType) {
	                var isConstructor = signature.declaration.kind === 154 /* Constructor */ || signature.declaration.kind === 158 /* ConstructSignature */;
	                var type = createObjectType(16 /* Anonymous */);
	                type.members = emptySymbols;
	                type.properties = ts.emptyArray;
	                type.callSignatures = !isConstructor ? [signature] : ts.emptyArray;
	                type.constructSignatures = isConstructor ? [signature] : ts.emptyArray;
	                signature.isolatedSignatureType = type;
	            }
	            return signature.isolatedSignatureType;
	        }
	        function getIndexSymbol(symbol) {
	            return symbol.members.get("__index" /* Index */);
	        }
	        function getIndexDeclarationOfSymbol(symbol, kind) {
	            var syntaxKind = kind === 1 /* Number */ ? 134 /* NumberKeyword */ : 137 /* StringKeyword */;
	            var indexSymbol = getIndexSymbol(symbol);
	            if (indexSymbol) {
	                for (var _i = 0, _a = indexSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var node = ts.cast(decl, ts.isIndexSignatureDeclaration);
	                    if (node.parameters.length === 1) {
	                        var parameter = node.parameters[0];
	                        if (parameter.type && parameter.type.kind === syntaxKind) {
	                            return node;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function createIndexInfo(type, isReadonly, declaration) {
	            return { type: type, isReadonly: isReadonly, declaration: declaration };
	        }
	        function getIndexInfoOfSymbol(symbol, kind) {
	            var declaration = getIndexDeclarationOfSymbol(symbol, kind);
	            if (declaration) {
	                return createIndexInfo(declaration.type ? getTypeFromTypeNode(declaration.type) : anyType, ts.hasModifier(declaration, 64 /* Readonly */), declaration);
	            }
	            return undefined;
	        }
	        function getConstraintDeclaration(type) {
	            var decl = type.symbol && ts.getDeclarationOfKind(type.symbol, 147 /* TypeParameter */);
	            return decl && decl.constraint;
	        }
	        function getInferredTypeParameterConstraint(typeParameter) {
	            var inferences;
	            if (typeParameter.symbol) {
	                for (var _i = 0, _a = typeParameter.symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    // When an 'infer T' declaration is immediately contained in a type reference node
	                    // (such as 'Foo<infer T>'), T's constraint is inferred from the constraint of the
	                    // corresponding type parameter in 'Foo'. When multiple 'infer T' declarations are
	                    // present, we form an intersection of the inferred constraint types.
	                    if (declaration.parent.kind === 171 /* InferType */ && declaration.parent.parent.kind === 161 /* TypeReference */) {
	                        var typeReference = declaration.parent.parent;
	                        var typeParameters = getTypeParametersForTypeReference(typeReference);
	                        if (typeParameters) {
	                            var index = typeReference.typeArguments.indexOf(declaration.parent);
	                            if (index < typeParameters.length) {
	                                var declaredConstraint = getConstraintOfTypeParameter(typeParameters[index]);
	                                if (declaredConstraint) {
	                                    // Type parameter constraints can reference other type parameters so
	                                    // constraints need to be instantiated. If instantiation produces the
	                                    // type parameter itself, we discard that inference. For example, in
	                                    //   type Foo<T extends string, U extends T> = [T, U];
	                                    //   type Bar<T> = T extends Foo<infer X, infer X> ? Foo<X, X> : T;
	                                    // the instantiated constraint for U is X, so we discard that inference.
	                                    var mapper = createTypeMapper(typeParameters, getEffectiveTypeArguments(typeReference, typeParameters));
	                                    var constraint = instantiateType(declaredConstraint, mapper);
	                                    if (constraint !== typeParameter) {
	                                        inferences = ts.append(inferences, constraint);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            return inferences && getIntersectionType(inferences);
	        }
	        function getConstraintFromTypeParameter(typeParameter) {
	            if (!typeParameter.constraint) {
	                if (typeParameter.target) {
	                    var targetConstraint = getConstraintOfTypeParameter(typeParameter.target);
	                    typeParameter.constraint = targetConstraint ? instantiateType(targetConstraint, typeParameter.mapper) : noConstraintType;
	                }
	                else {
	                    var constraintDeclaration = getConstraintDeclaration(typeParameter);
	                    typeParameter.constraint = constraintDeclaration ? getTypeFromTypeNode(constraintDeclaration) :
	                        getInferredTypeParameterConstraint(typeParameter) || noConstraintType;
	                }
	            }
	            return typeParameter.constraint === noConstraintType ? undefined : typeParameter.constraint;
	        }
	        function getParentSymbolOfTypeParameter(typeParameter) {
	            return getSymbolOfNode(ts.getDeclarationOfKind(typeParameter.symbol, 147 /* TypeParameter */).parent);
	        }
	        function getTypeListId(types) {
	            var result = "";
	            if (types) {
	                var length_3 = types.length;
	                var i = 0;
	                while (i < length_3) {
	                    var startId = types[i].id;
	                    var count = 1;
	                    while (i + count < length_3 && types[i + count].id === startId + count) {
	                        count++;
	                    }
	                    if (result.length) {
	                        result += ",";
	                    }
	                    result += startId;
	                    if (count > 1) {
	                        result += ":" + count;
	                    }
	                    i += count;
	                }
	            }
	            return result;
	        }
	        // This function is used to propagate certain flags when creating new object type references and union types.
	        // It is only necessary to do so if a constituent type might be the undefined type, the null type, the type
	        // of an object literal or the anyFunctionType. This is because there are operations in the type checker
	        // that care about the presence of such types at arbitrary depth in a containing type.
	        function getPropagatingFlagsOfTypes(types, excludeKinds) {
	            var result = 0;
	            for (var _i = 0, types_5 = types; _i < types_5.length; _i++) {
	                var type = types_5[_i];
	                if (!(type.flags & excludeKinds)) {
	                    result |= type.flags;
	                }
	            }
	            return result & 117440512 /* PropagatingFlags */;
	        }
	        function createTypeReference(target, typeArguments) {
	            var id = getTypeListId(typeArguments);
	            var type = target.instantiations.get(id);
	            if (!type) {
	                type = createObjectType(4 /* Reference */, target.symbol);
	                target.instantiations.set(id, type);
	                type.flags |= typeArguments ? getPropagatingFlagsOfTypes(typeArguments, /*excludeKinds*/ 0) : 0;
	                type.target = target;
	                type.typeArguments = typeArguments;
	            }
	            return type;
	        }
	        function cloneTypeReference(source) {
	            var type = createType(source.flags);
	            type.symbol = source.symbol;
	            type.objectFlags = source.objectFlags;
	            type.target = source.target;
	            type.typeArguments = source.typeArguments;
	            return type;
	        }
	        function getTypeReferenceArity(type) {
	            return ts.length(type.target.typeParameters);
	        }
	        /**
	         * Get type from type-reference that reference to class or interface
	         */
	        function getTypeFromClassOrInterfaceReference(node, symbol, typeArgs) {
	            var type = getDeclaredTypeOfSymbol(getMergedSymbol(symbol));
	            var typeParameters = type.localTypeParameters;
	            if (typeParameters) {
	                var numTypeArguments = ts.length(node.typeArguments);
	                var minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
	                var isJs = ts.isInJavaScriptFile(node);
	                var isJsImplicitAny = !noImplicitAny && isJs;
	                if (!isJsImplicitAny && (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length)) {
	                    var missingAugmentsTag = isJs && node.parent.kind !== 289 /* JSDocAugmentsTag */;
	                    var diag = minTypeArgumentCount === typeParameters.length
	                        ? missingAugmentsTag
	                            ? ts.Diagnostics.Expected_0_type_arguments_provide_these_with_an_extends_tag
	                            : ts.Diagnostics.Generic_type_0_requires_1_type_argument_s
	                        : missingAugmentsTag
	                            ? ts.Diagnostics.Expected_0_1_type_arguments_provide_these_with_an_extends_tag
	                            : ts.Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments;
	                    var typeStr = typeToString(type, /*enclosingDeclaration*/ undefined, 2 /* WriteArrayAsGenericType */);
	                    error(node, diag, typeStr, minTypeArgumentCount, typeParameters.length);
	                    if (!isJs) {
	                        // TODO: Adopt same permissive behavior in TS as in JS to reduce follow-on editing experience failures (requires editing fillMissingTypeArguments)
	                        return unknownType;
	                    }
	                }
	                // In a type reference, the outer type parameters of the referenced class or interface are automatically
	                // supplied as type arguments and the type reference only specifies arguments for the local type parameters
	                // of the class or interface.
	                var typeArguments = ts.concatenate(type.outerTypeParameters, fillMissingTypeArguments(typeArgs, typeParameters, minTypeArgumentCount, isJs));
	                return createTypeReference(type, typeArguments);
	            }
	            return checkNoTypeArguments(node, symbol) ? type : unknownType;
	        }
	        function getTypeAliasInstantiation(symbol, typeArguments) {
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var links = getSymbolLinks(symbol);
	            var typeParameters = links.typeParameters;
	            var id = getTypeListId(typeArguments);
	            var instantiation = links.instantiations.get(id);
	            if (!instantiation) {
	                links.instantiations.set(id, instantiation = instantiateType(type, createTypeMapper(typeParameters, fillMissingTypeArguments(typeArguments, typeParameters, getMinTypeArgumentCount(typeParameters), ts.isInJavaScriptFile(symbol.valueDeclaration)))));
	            }
	            return instantiation;
	        }
	        /**
	         * Get type from reference to type alias. When a type alias is generic, the declared type of the type alias may include
	         * references to the type parameters of the alias. We replace those with the actual type arguments by instantiating the
	         * declared type. Instantiations are cached using the type identities of the type arguments as the key.
	         */
	        function getTypeFromTypeAliasReference(node, symbol, typeArguments) {
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var typeParameters = getSymbolLinks(symbol).typeParameters;
	            if (typeParameters) {
	                var numTypeArguments = ts.length(node.typeArguments);
	                var minTypeArgumentCount = getMinTypeArgumentCount(typeParameters);
	                if (numTypeArguments < minTypeArgumentCount || numTypeArguments > typeParameters.length) {
	                    error(node, minTypeArgumentCount === typeParameters.length
	                        ? ts.Diagnostics.Generic_type_0_requires_1_type_argument_s
	                        : ts.Diagnostics.Generic_type_0_requires_between_1_and_2_type_arguments, symbolToString(symbol), minTypeArgumentCount, typeParameters.length);
	                    return unknownType;
	                }
	                return getTypeAliasInstantiation(symbol, typeArguments);
	            }
	            return checkNoTypeArguments(node, symbol) ? type : unknownType;
	        }
	        function getTypeReferenceName(node) {
	            switch (node.kind) {
	                case 161 /* TypeReference */:
	                    return node.typeName;
	                case 206 /* ExpressionWithTypeArguments */:
	                    // We only support expressions that are simple qualified names. For other
	                    // expressions this produces undefined.
	                    var expr = node.expression;
	                    if (ts.isEntityNameExpression(expr)) {
	                        return expr;
	                    }
	                // fall through;
	            }
	            return undefined;
	        }
	        function resolveTypeReferenceName(typeReferenceName, meaning) {
	            if (!typeReferenceName) {
	                return unknownSymbol;
	            }
	            return resolveEntityName(typeReferenceName, meaning) || unknownSymbol;
	        }
	        function getTypeReferenceType(node, symbol) {
	            var typeArguments = typeArgumentsFromTypeReferenceNode(node); // Do unconditionally so we mark type arguments as referenced.
	            if (symbol === unknownSymbol) {
	                return unknownType;
	            }
	            var type = getTypeReferenceTypeWorker(node, symbol, typeArguments);
	            if (type) {
	                return type;
	            }
	            // Get type from reference to named type that cannot be generic (enum or type parameter)
	            var res = tryGetDeclaredTypeOfSymbol(symbol);
	            if (res) {
	                return checkNoTypeArguments(node, symbol) ?
	                    res.flags & 32768 /* TypeParameter */ ? getConstrainedTypeVariable(res, node) : res :
	                    unknownType;
	            }
	            if (!(symbol.flags & 67216319 /* Value */ && isJSDocTypeReference(node))) {
	                return unknownType;
	            }
	            var jsdocType = getJSDocTypeReference(node, symbol, typeArguments);
	            if (jsdocType) {
	                return jsdocType;
	            }
	            // Resolve the type reference as a Type for the purpose of reporting errors.
	            resolveTypeReferenceName(getTypeReferenceName(node), 67901928 /* Type */);
	            return getTypeOfSymbol(symbol);
	        }
	        /**
	         * A jsdoc TypeReference may have resolved to a value (as opposed to a type). If
	         * the symbol is a constructor function, return the inferred class type; otherwise,
	         * the type of this reference is just the type of the value we resolved to.
	         */
	        function getJSDocTypeReference(node, symbol, typeArguments) {
	            var assignedType = getAssignedClassType(symbol);
	            var valueType = getTypeOfSymbol(symbol);
	            var referenceType = valueType.symbol && valueType.symbol !== symbol && !isInferredClassType(valueType) && getTypeReferenceTypeWorker(node, valueType.symbol, typeArguments);
	            if (referenceType || assignedType) {
	                return referenceType && assignedType ? getIntersectionType([assignedType, referenceType]) : referenceType || assignedType;
	            }
	        }
	        function getTypeReferenceTypeWorker(node, symbol, typeArguments) {
	            if (symbol.flags & (32 /* Class */ | 64 /* Interface */)) {
	                if (symbol.valueDeclaration && ts.isBinaryExpression(symbol.valueDeclaration.parent)) {
	                    var jsdocType = getJSDocTypeReference(node, symbol, typeArguments);
	                    if (jsdocType) {
	                        return jsdocType;
	                    }
	                }
	                return getTypeFromClassOrInterfaceReference(node, symbol, typeArguments);
	            }
	            if (symbol.flags & 524288 /* TypeAlias */) {
	                return getTypeFromTypeAliasReference(node, symbol, typeArguments);
	            }
	            if (symbol.flags & 16 /* Function */ &&
	                isJSDocTypeReference(node) &&
	                (symbol.members || ts.getJSDocClassTag(symbol.valueDeclaration))) {
	                return getInferredClassType(symbol);
	            }
	        }
	        function getSubstitutionType(typeVariable, substitute) {
	            var result = createType(4194304 /* Substitution */);
	            result.typeVariable = typeVariable;
	            result.substitute = substitute;
	            return result;
	        }
	        function isUnaryTupleTypeNode(node) {
	            return node.kind === 167 /* TupleType */ && node.elementTypes.length === 1;
	        }
	        function getImpliedConstraint(typeVariable, checkNode, extendsNode) {
	            return isUnaryTupleTypeNode(checkNode) && isUnaryTupleTypeNode(extendsNode) ? getImpliedConstraint(typeVariable, checkNode.elementTypes[0], extendsNode.elementTypes[0]) :
	                getActualTypeVariable(getTypeFromTypeNode(checkNode)) === typeVariable ? getTypeFromTypeNode(extendsNode) :
	                    undefined;
	        }
	        function getConstrainedTypeVariable(typeVariable, node) {
	            var constraints;
	            while (node && !ts.isStatement(node) && node.kind !== 285 /* JSDocComment */) {
	                var parent = node.parent;
	                if (parent.kind === 170 /* ConditionalType */ && node === parent.trueType) {
	                    var constraint = getImpliedConstraint(typeVariable, parent.checkType, parent.extendsType);
	                    if (constraint) {
	                        constraints = ts.append(constraints, constraint);
	                    }
	                }
	                node = parent;
	            }
	            return constraints ? getSubstitutionType(typeVariable, getIntersectionType(ts.append(constraints, typeVariable))) : typeVariable;
	        }
	        function isJSDocTypeReference(node) {
	            return node.flags & 2097152 /* JSDoc */ && node.kind === 161 /* TypeReference */;
	        }
	        function checkNoTypeArguments(node, symbol) {
	            if (node.typeArguments) {
	                error(node, ts.Diagnostics.Type_0_is_not_generic, symbol ? symbolToString(symbol) : node.typeName ? ts.declarationNameToString(node.typeName) : "(anonymous)");
	                return false;
	            }
	            return true;
	        }
	        function getIntendedTypeFromJSDocTypeReference(node) {
	            if (ts.isIdentifier(node.typeName)) {
	                var typeArgs = node.typeArguments;
	                switch (node.typeName.escapedText) {
	                    case "String":
	                        checkNoTypeArguments(node);
	                        return stringType;
	                    case "Number":
	                        checkNoTypeArguments(node);
	                        return numberType;
	                    case "Boolean":
	                        checkNoTypeArguments(node);
	                        return booleanType;
	                    case "Void":
	                        checkNoTypeArguments(node);
	                        return voidType;
	                    case "Undefined":
	                        checkNoTypeArguments(node);
	                        return undefinedType;
	                    case "Null":
	                        checkNoTypeArguments(node);
	                        return nullType;
	                    case "Function":
	                    case "function":
	                        checkNoTypeArguments(node);
	                        return globalFunctionType;
	                    case "Array":
	                    case "array":
	                        return !typeArgs || !typeArgs.length ? anyArrayType : undefined;
	                    case "Promise":
	                    case "promise":
	                        return !typeArgs || !typeArgs.length ? createPromiseType(anyType) : undefined;
	                    case "Object":
	                        if (typeArgs && typeArgs.length === 2) {
	                            if (ts.isJSDocIndexSignature(node)) {
	                                var indexed = getTypeFromTypeNode(typeArgs[0]);
	                                var target = getTypeFromTypeNode(typeArgs[1]);
	                                var index = createIndexInfo(target, /*isReadonly*/ false);
	                                return createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, indexed === stringType && index, indexed === numberType && index);
	                            }
	                            return anyType;
	                        }
	                        checkNoTypeArguments(node);
	                        return anyType;
	                }
	            }
	        }
	        function getTypeFromJSDocNullableTypeNode(node) {
	            var type = getTypeFromTypeNode(node.type);
	            return strictNullChecks ? getNullableType(type, 8192 /* Null */) : type;
	        }
	        function getTypeFromTypeReference(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var symbol = void 0;
	                var type = void 0;
	                var meaning = 67901928 /* Type */;
	                if (isJSDocTypeReference(node)) {
	                    type = getIntendedTypeFromJSDocTypeReference(node);
	                    meaning |= 67216319 /* Value */;
	                }
	                if (!type) {
	                    symbol = resolveTypeReferenceName(getTypeReferenceName(node), meaning);
	                    type = getTypeReferenceType(node, symbol);
	                }
	                // Cache both the resolved symbol and the resolved type. The resolved symbol is needed in when we check the
	                // type reference in checkTypeReferenceNode.
	                links.resolvedSymbol = symbol;
	                links.resolvedType = type;
	            }
	            return links.resolvedType;
	        }
	        function typeArgumentsFromTypeReferenceNode(node) {
	            return ts.map(node.typeArguments, getTypeFromTypeNode);
	        }
	        function getTypeFromTypeQueryNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                // TypeScript 1.0 spec (April 2014): 3.6.3
	                // The expression is processed as an identifier expression (section 4.3)
	                // or property access expression(section 4.10),
	                // the widened type(section 3.9) of which becomes the result.
	                links.resolvedType = getWidenedType(checkExpression(node.exprName));
	            }
	            return links.resolvedType;
	        }
	        function getTypeOfGlobalSymbol(symbol, arity) {
	            function getTypeDeclaration(symbol) {
	                var declarations = symbol.declarations;
	                for (var _i = 0, declarations_3 = declarations; _i < declarations_3.length; _i++) {
	                    var declaration = declarations_3[_i];
	                    switch (declaration.kind) {
	                        case 234 /* ClassDeclaration */:
	                        case 235 /* InterfaceDeclaration */:
	                        case 237 /* EnumDeclaration */:
	                            return declaration;
	                    }
	                }
	            }
	            if (!symbol) {
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            var type = getDeclaredTypeOfSymbol(symbol);
	            if (!(type.flags & 65536 /* Object */)) {
	                error(getTypeDeclaration(symbol), ts.Diagnostics.Global_type_0_must_be_a_class_or_interface_type, ts.symbolName(symbol));
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            if (ts.length(type.typeParameters) !== arity) {
	                error(getTypeDeclaration(symbol), ts.Diagnostics.Global_type_0_must_have_1_type_parameter_s, ts.symbolName(symbol), arity);
	                return arity ? emptyGenericType : emptyObjectType;
	            }
	            return type;
	        }
	        function getGlobalValueSymbol(name, reportErrors) {
	            return getGlobalSymbol(name, 67216319 /* Value */, reportErrors ? ts.Diagnostics.Cannot_find_global_value_0 : undefined);
	        }
	        function getGlobalTypeSymbol(name, reportErrors) {
	            return getGlobalSymbol(name, 67901928 /* Type */, reportErrors ? ts.Diagnostics.Cannot_find_global_type_0 : undefined);
	        }
	        function getGlobalSymbol(name, meaning, diagnostic) {
	            // Don't track references for global symbols anyway, so value if `isReference` is arbitrary
	            return resolveName(undefined, name, meaning, diagnostic, name, /*isUse*/ false);
	        }
	        function getGlobalType(name, arity, reportErrors) {
	            var symbol = getGlobalTypeSymbol(name, reportErrors);
	            return symbol || reportErrors ? getTypeOfGlobalSymbol(symbol, arity) : undefined;
	        }
	        function getGlobalTypedPropertyDescriptorType() {
	            return deferredGlobalTypedPropertyDescriptorType || (deferredGlobalTypedPropertyDescriptorType = getGlobalType("TypedPropertyDescriptor", /*arity*/ 1, /*reportErrors*/ true)) || emptyGenericType;
	        }
	        function getGlobalTemplateStringsArrayType() {
	            return deferredGlobalTemplateStringsArrayType || (deferredGlobalTemplateStringsArrayType = getGlobalType("TemplateStringsArray", /*arity*/ 0, /*reportErrors*/ true)) || emptyObjectType;
	        }
	        function getGlobalImportMetaType() {
	            return deferredGlobalImportMetaType || (deferredGlobalImportMetaType = getGlobalType("ImportMeta", /*arity*/ 0, /*reportErrors*/ true)) || emptyObjectType;
	        }
	        function getGlobalESSymbolConstructorSymbol(reportErrors) {
	            return deferredGlobalESSymbolConstructorSymbol || (deferredGlobalESSymbolConstructorSymbol = getGlobalValueSymbol("Symbol", reportErrors));
	        }
	        function getGlobalESSymbolType(reportErrors) {
	            return deferredGlobalESSymbolType || (deferredGlobalESSymbolType = getGlobalType("Symbol", /*arity*/ 0, reportErrors)) || emptyObjectType;
	        }
	        function getGlobalPromiseType(reportErrors) {
	            return deferredGlobalPromiseType || (deferredGlobalPromiseType = getGlobalType("Promise", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalPromiseConstructorSymbol(reportErrors) {
	            return deferredGlobalPromiseConstructorSymbol || (deferredGlobalPromiseConstructorSymbol = getGlobalValueSymbol("Promise", reportErrors));
	        }
	        function getGlobalPromiseConstructorLikeType(reportErrors) {
	            return deferredGlobalPromiseConstructorLikeType || (deferredGlobalPromiseConstructorLikeType = getGlobalType("PromiseConstructorLike", /*arity*/ 0, reportErrors)) || emptyObjectType;
	        }
	        function getGlobalAsyncIterableType(reportErrors) {
	            return deferredGlobalAsyncIterableType || (deferredGlobalAsyncIterableType = getGlobalType("AsyncIterable", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalAsyncIteratorType(reportErrors) {
	            return deferredGlobalAsyncIteratorType || (deferredGlobalAsyncIteratorType = getGlobalType("AsyncIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalAsyncIterableIteratorType(reportErrors) {
	            return deferredGlobalAsyncIterableIteratorType || (deferredGlobalAsyncIterableIteratorType = getGlobalType("AsyncIterableIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIterableType(reportErrors) {
	            return deferredGlobalIterableType || (deferredGlobalIterableType = getGlobalType("Iterable", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIteratorType(reportErrors) {
	            return deferredGlobalIteratorType || (deferredGlobalIteratorType = getGlobalType("Iterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalIterableIteratorType(reportErrors) {
	            return deferredGlobalIterableIteratorType || (deferredGlobalIterableIteratorType = getGlobalType("IterableIterator", /*arity*/ 1, reportErrors)) || emptyGenericType;
	        }
	        function getGlobalTypeOrUndefined(name, arity) {
	            if (arity === void 0) { arity = 0; }
	            var symbol = getGlobalSymbol(name, 67901928 /* Type */, /*diagnostic*/ undefined);
	            return symbol && getTypeOfGlobalSymbol(symbol, arity);
	        }
	        function getGlobalExtractSymbol() {
	            return deferredGlobalExtractSymbol || (deferredGlobalExtractSymbol = getGlobalSymbol("Extract", 524288 /* TypeAlias */, ts.Diagnostics.Cannot_find_global_type_0));
	        }
	        /**
	         * Instantiates a global type that is generic with some element type, and returns that instantiation.
	         */
	        function createTypeFromGenericGlobalType(genericGlobalType, typeArguments) {
	            return genericGlobalType !== emptyGenericType ? createTypeReference(genericGlobalType, typeArguments) : emptyObjectType;
	        }
	        function createTypedPropertyDescriptorType(propertyType) {
	            return createTypeFromGenericGlobalType(getGlobalTypedPropertyDescriptorType(), [propertyType]);
	        }
	        function createAsyncIterableType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalAsyncIterableType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createAsyncIterableIteratorType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalAsyncIterableIteratorType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createIterableType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalIterableType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createIterableIteratorType(iteratedType) {
	            return createTypeFromGenericGlobalType(getGlobalIterableIteratorType(/*reportErrors*/ true), [iteratedType]);
	        }
	        function createArrayType(elementType) {
	            return createTypeFromGenericGlobalType(globalArrayType, [elementType]);
	        }
	        function getTypeFromArrayTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = createArrayType(getTypeFromTypeNode(node.elementType));
	            }
	            return links.resolvedType;
	        }
	        // We represent tuple types as type references to synthesized generic interface types created by
	        // this function. The types are of the form:
	        //
	        //   interface Tuple<T0, T1, T2, ...> extends Array<T0 | T1 | T2 | ...> { 0: T0, 1: T1, 2: T2, ... }
	        //
	        // Note that the generic type created by this function has no symbol associated with it. The same
	        // is true for each of the synthesized type parameters.
	        function createTupleTypeOfArity(arity) {
	            var typeParameters = [];
	            var properties = [];
	            for (var i = 0; i < arity; i++) {
	                var typeParameter = createType(32768 /* TypeParameter */);
	                typeParameters.push(typeParameter);
	                var property = createSymbol(4 /* Property */, "" + i);
	                property.type = typeParameter;
	                properties.push(property);
	            }
	            var lengthSymbol = createSymbol(4 /* Property */, "length");
	            lengthSymbol.type = getLiteralType(arity);
	            properties.push(lengthSymbol);
	            var type = createObjectType(8 /* Tuple */ | 4 /* Reference */);
	            type.typeParameters = typeParameters;
	            type.outerTypeParameters = undefined;
	            type.localTypeParameters = typeParameters;
	            type.instantiations = ts.createMap();
	            type.instantiations.set(getTypeListId(type.typeParameters), type);
	            type.target = type;
	            type.typeArguments = type.typeParameters;
	            type.thisType = createType(32768 /* TypeParameter */);
	            type.thisType.isThisType = true;
	            type.thisType.constraint = type;
	            type.declaredProperties = properties;
	            type.declaredCallSignatures = ts.emptyArray;
	            type.declaredConstructSignatures = ts.emptyArray;
	            type.declaredStringIndexInfo = undefined;
	            type.declaredNumberIndexInfo = undefined;
	            return type;
	        }
	        function getTupleTypeOfArity(arity) {
	            return tupleTypes[arity] || (tupleTypes[arity] = createTupleTypeOfArity(arity));
	        }
	        function createTupleType(elementTypes) {
	            return createTypeReference(getTupleTypeOfArity(elementTypes.length), elementTypes);
	        }
	        function getTypeFromTupleTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = createTupleType(ts.map(node.elementTypes, getTypeFromTypeNode));
	            }
	            return links.resolvedType;
	        }
	        function getTypeId(type) {
	            return type.id;
	        }
	        function containsType(types, type) {
	            return ts.binarySearch(types, type, getTypeId, ts.compareValues) >= 0;
	        }
	        // Return true if the given intersection type contains
	        // more than one unit type or,
	        // an object type and a nullable type (null or undefined), or
	        // a string-like type and a type known to be non-string-like, or
	        // a number-like type and a type known to be non-number-like, or
	        // a symbol-like type and a type known to be non-symbol-like, or
	        // a void-like type and a type known to be non-void-like, or
	        // a non-primitive type and a type known to be primitive.
	        function isEmptyIntersectionType(type) {
	            var combined = 0;
	            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (t.flags & 13536 /* Unit */ && combined & 13536 /* Unit */) {
	                    return true;
	                }
	                combined |= t.flags;
	                if (combined & 12288 /* Nullable */ && combined & (65536 /* Object */ | 134217728 /* NonPrimitive */) ||
	                    combined & 134217728 /* NonPrimitive */ && combined & (134233854 /* DisjointDomains */ & ~134217728 /* NonPrimitive */) ||
	                    combined & 34 /* StringLike */ && combined & (134233854 /* DisjointDomains */ & ~34 /* StringLike */) ||
	                    combined & 84 /* NumberLike */ && combined & (134233854 /* DisjointDomains */ & ~84 /* NumberLike */) ||
	                    combined & 1536 /* ESSymbolLike */ && combined & (134233854 /* DisjointDomains */ & ~1536 /* ESSymbolLike */) ||
	                    combined & 6144 /* VoidLike */ && combined & (134233854 /* DisjointDomains */ & ~6144 /* VoidLike */)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function addTypeToUnion(typeSet, includes, type) {
	            var flags = type.flags;
	            if (flags & 131072 /* Union */) {
	                return addTypesToUnion(typeSet, includes, type.types);
	            }
	            // We ignore 'never' types in unions. Likewise, we ignore intersections of unit types as they are
	            // another form of 'never' (in that they have an empty value domain). We could in theory turn
	            // intersections of unit types into 'never' upon construction, but deferring the reduction makes it
	            // easier to reason about their origin.
	            if (!(flags & 16384 /* Never */ || flags & 262144 /* Intersection */ && isEmptyIntersectionType(type))) {
	                includes |= flags & ~117440512 /* ConstructionFlags */;
	                if (flags & 1 /* Any */) {
	                    if (type === wildcardType)
	                        includes |= 33554432 /* Wildcard */;
	                }
	                else if (!strictNullChecks && flags & 12288 /* Nullable */) {
	                    if (!(flags & 16777216 /* ContainsWideningType */))
	                        includes |= 16777216 /* NonWideningType */;
	                }
	                else {
	                    var len = typeSet.length;
	                    var index = len && type.id > typeSet[len - 1].id ? ~len : ts.binarySearch(typeSet, type, getTypeId, ts.compareValues);
	                    if (index < 0) {
	                        if (!(flags & 65536 /* Object */ && type.objectFlags & 16 /* Anonymous */ &&
	                            type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */) && containsIdenticalType(typeSet, type))) {
	                            typeSet.splice(~index, 0, type);
	                        }
	                    }
	                }
	            }
	            return includes;
	        }
	        // Add the given types to the given type set. Order is preserved, duplicates are removed,
	        // and nested types of the given kind are flattened into the set.
	        function addTypesToUnion(typeSet, includes, types) {
	            for (var _i = 0, types_6 = types; _i < types_6.length; _i++) {
	                var type = types_6[_i];
	                includes = addTypeToUnion(typeSet, includes, type);
	            }
	            return includes;
	        }
	        function containsIdenticalType(types, type) {
	            for (var _i = 0, types_7 = types; _i < types_7.length; _i++) {
	                var t = types_7[_i];
	                if (isTypeIdenticalTo(t, type)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isSubtypeOfAny(source, targets) {
	            for (var _i = 0, targets_1 = targets; _i < targets_1.length; _i++) {
	                var target = targets_1[_i];
	                if (source !== target && isTypeSubtypeOf(source, target) && (!(ts.getObjectFlags(getTargetType(source)) & 1 /* Class */) ||
	                    !(ts.getObjectFlags(getTargetType(target)) & 1 /* Class */) ||
	                    isTypeDerivedFrom(source, target))) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isSetOfLiteralsFromSameEnum(types) {
	            var first = types[0];
	            if (first.flags & 256 /* EnumLiteral */) {
	                var firstEnum = getParentOfSymbol(first.symbol);
	                for (var i = 1; i < types.length; i++) {
	                    var other = types[i];
	                    if (!(other.flags & 256 /* EnumLiteral */) || (firstEnum !== getParentOfSymbol(other.symbol))) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function removeSubtypes(types) {
	            if (types.length === 0 || isSetOfLiteralsFromSameEnum(types)) {
	                return;
	            }
	            var i = types.length;
	            while (i > 0) {
	                i--;
	                if (isSubtypeOfAny(types[i], types)) {
	                    ts.orderedRemoveItemAt(types, i);
	                }
	            }
	        }
	        function removeRedundantLiteralTypes(types, includes) {
	            var i = types.length;
	            while (i > 0) {
	                i--;
	                var t = types[i];
	                var remove = t.flags & 32 /* StringLiteral */ && includes & 2 /* String */ ||
	                    t.flags & 64 /* NumberLiteral */ && includes & 4 /* Number */ ||
	                    t.flags & 1024 /* UniqueESSymbol */ && includes & 512 /* ESSymbol */ ||
	                    t.flags & 96 /* StringOrNumberLiteral */ && t.flags & 8388608 /* FreshLiteral */ && containsType(types, t.regularType);
	                if (remove) {
	                    ts.orderedRemoveItemAt(types, i);
	                }
	            }
	        }
	        // We sort and deduplicate the constituent types based on object identity. If the subtypeReduction
	        // flag is specified we also reduce the constituent type set to only include types that aren't subtypes
	        // of other types. Subtype reduction is expensive for large union types and is possible only when union
	        // types are known not to circularly reference themselves (as is the case with union types created by
	        // expression constructs such as array literals and the || and ?: operators). Named types can
	        // circularly reference themselves and therefore cannot be subtype reduced during their declaration.
	        // For example, "type Item = string | (() => Item" is a named type that circularly references itself.
	        function getUnionType(types, unionReduction, aliasSymbol, aliasTypeArguments) {
	            if (unionReduction === void 0) { unionReduction = 1 /* Literal */; }
	            if (types.length === 0) {
	                return neverType;
	            }
	            if (types.length === 1) {
	                return types[0];
	            }
	            var typeSet = [];
	            var includes = addTypesToUnion(typeSet, 0, types);
	            if (includes & 1 /* Any */) {
	                return includes & 33554432 /* Wildcard */ ? wildcardType : anyType;
	            }
	            switch (unionReduction) {
	                case 1 /* Literal */:
	                    if (includes & 1120 /* StringOrNumberLiteralOrUnique */) {
	                        removeRedundantLiteralTypes(typeSet, includes);
	                    }
	                    break;
	                case 2 /* Subtype */:
	                    removeSubtypes(typeSet);
	                    break;
	            }
	            if (typeSet.length === 0) {
	                return includes & 8192 /* Null */ ? includes & 16777216 /* NonWideningType */ ? nullType : nullWideningType :
	                    includes & 4096 /* Undefined */ ? includes & 16777216 /* NonWideningType */ ? undefinedType : undefinedWideningType :
	                        neverType;
	            }
	            return getUnionTypeFromSortedList(typeSet, includes & 8374815 /* NotUnit */ ? 0 : 268435456 /* UnionOfUnitTypes */, aliasSymbol, aliasTypeArguments);
	        }
	        function getUnionTypePredicate(signatures) {
	            var first;
	            var types = [];
	            for (var _i = 0, signatures_2 = signatures; _i < signatures_2.length; _i++) {
	                var sig = signatures_2[_i];
	                var pred = getTypePredicateOfSignature(sig);
	                if (!pred) {
	                    continue;
	                }
	                if (first) {
	                    if (!typePredicateKindsMatch(first, pred)) {
	                        // No common type predicate.
	                        return undefined;
	                    }
	                }
	                else {
	                    first = pred;
	                }
	                types.push(pred.type);
	            }
	            if (!first) {
	                // No union signatures had a type predicate.
	                return undefined;
	            }
	            var unionType = getUnionType(types);
	            return ts.isIdentifierTypePredicate(first)
	                ? createIdentifierTypePredicate(first.parameterName, first.parameterIndex, unionType)
	                : createThisTypePredicate(unionType);
	        }
	        function typePredicateKindsMatch(a, b) {
	            return ts.isIdentifierTypePredicate(a)
	                ? ts.isIdentifierTypePredicate(b) && a.parameterIndex === b.parameterIndex
	                : !ts.isIdentifierTypePredicate(b);
	        }
	        // This function assumes the constituent type list is sorted and deduplicated.
	        function getUnionTypeFromSortedList(types, unionOfUnitTypes, aliasSymbol, aliasTypeArguments) {
	            if (types.length === 0) {
	                return neverType;
	            }
	            if (types.length === 1) {
	                return types[0];
	            }
	            var id = getTypeListId(types);
	            var type = unionTypes.get(id);
	            if (!type) {
	                var propagatedFlags = getPropagatingFlagsOfTypes(types, /*excludeKinds*/ 12288 /* Nullable */);
	                type = createType(131072 /* Union */ | propagatedFlags | unionOfUnitTypes);
	                unionTypes.set(id, type);
	                type.types = types;
	                /*
	                Note: This is the alias symbol (or lack thereof) that we see when we first encounter this union type.
	                For aliases of identical unions, eg `type T = A | B; type U = A | B`, the symbol of the first alias encountered is the aliasSymbol.
	                (In the language service, the order may depend on the order in which a user takes actions, such as hovering over symbols.)
	                It's important that we create equivalent union types only once, so that's an unfortunate side effect.
	                */
	                type.aliasSymbol = aliasSymbol;
	                type.aliasTypeArguments = aliasTypeArguments;
	            }
	            return type;
	        }
	        function getTypeFromUnionTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var aliasSymbol = getAliasSymbolForTypeNode(node);
	                links.resolvedType = getUnionType(ts.map(node.types, getTypeFromTypeNode), 1 /* Literal */, aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol));
	            }
	            return links.resolvedType;
	        }
	        function addTypeToIntersection(typeSet, includes, type) {
	            var flags = type.flags;
	            if (flags & 262144 /* Intersection */) {
	                return addTypesToIntersection(typeSet, includes, type.types);
	            }
	            if (ts.getObjectFlags(type) & 16 /* Anonymous */ && isEmptyObjectType(type)) {
	                includes |= 67108864 /* EmptyObject */;
	            }
	            else {
	                includes |= flags & ~117440512 /* ConstructionFlags */;
	                if (flags & 1 /* Any */) {
	                    if (type === wildcardType)
	                        includes |= 33554432 /* Wildcard */;
	                }
	                else if ((strictNullChecks || !(flags & 12288 /* Nullable */)) && !ts.contains(typeSet, type) &&
	                    !(flags & 65536 /* Object */ && type.objectFlags & 16 /* Anonymous */ &&
	                        type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */) &&
	                        containsIdenticalType(typeSet, type))) {
	                    typeSet.push(type);
	                }
	            }
	            return includes;
	        }
	        // Add the given types to the given type set. Order is preserved, freshness is removed from literal
	        // types, duplicates are removed, and nested types of the given kind are flattened into the set.
	        function addTypesToIntersection(typeSet, includes, types) {
	            for (var _i = 0, types_8 = types; _i < types_8.length; _i++) {
	                var type = types_8[_i];
	                includes = addTypeToIntersection(typeSet, includes, getRegularTypeOfLiteralType(type));
	            }
	            return includes;
	        }
	        function removeRedundantPrimitiveTypes(types, includes) {
	            var i = types.length;
	            while (i > 0) {
	                i--;
	                var t = types[i];
	                var remove = t.flags & 2 /* String */ && includes & 32 /* StringLiteral */ ||
	                    t.flags & 4 /* Number */ && includes & 64 /* NumberLiteral */ ||
	                    t.flags & 512 /* ESSymbol */ && includes & 1024 /* UniqueESSymbol */;
	                if (remove) {
	                    ts.orderedRemoveItemAt(types, i);
	                }
	            }
	        }
	        // When intersecting unions of unit types we can simply intersect based on type identity.
	        // Here we remove all unions of unit types from the given list and replace them with a
	        // a single union containing an intersection of the unit types.
	        function intersectUnionsOfUnitTypes(types) {
	            var unionIndex = ts.findIndex(types, function (t) { return (t.flags & 268435456 /* UnionOfUnitTypes */) !== 0; });
	            var unionType = types[unionIndex];
	            var intersection = unionType.types;
	            var i = types.length - 1;
	            var _loop_5 = function () {
	                var t = types[i];
	                if (t.flags & 268435456 /* UnionOfUnitTypes */) {
	                    intersection = ts.filter(intersection, function (u) { return containsType(t.types, u); });
	                    ts.orderedRemoveItemAt(types, i);
	                }
	                i--;
	            };
	            while (i > unionIndex) {
	                _loop_5();
	            }
	            if (intersection === unionType.types) {
	                return false;
	            }
	            types[unionIndex] = getUnionTypeFromSortedList(intersection, unionType.flags & 268435456 /* UnionOfUnitTypes */);
	            return true;
	        }
	        // We normalize combinations of intersection and union types based on the distributive property of the '&'
	        // operator. Specifically, because X & (A | B) is equivalent to X & A | X & B, we can transform intersection
	        // types with union type constituents into equivalent union types with intersection type constituents and
	        // effectively ensure that union types are always at the top level in type representations.
	        //
	        // We do not perform structural deduplication on intersection types. Intersection types are created only by the &
	        // type operator and we can't reduce those because we want to support recursive intersection types. For example,
	        // a type alias of the form "type List<T> = T & { next: List<T> }" cannot be reduced during its declaration.
	        // Also, unlike union types, the order of the constituent types is preserved in order that overload resolution
	        // for intersections of types with signatures can be deterministic.
	        function getIntersectionType(types, aliasSymbol, aliasTypeArguments) {
	            if (types.length === 0) {
	                return emptyObjectType;
	            }
	            var typeSet = [];
	            var includes = addTypesToIntersection(typeSet, 0, types);
	            if (includes & 16384 /* Never */) {
	                return neverType;
	            }
	            if (includes & 1 /* Any */) {
	                return includes & 33554432 /* Wildcard */ ? wildcardType : anyType;
	            }
	            if (includes & 2 /* String */ && includes & 32 /* StringLiteral */ ||
	                includes & 4 /* Number */ && includes & 64 /* NumberLiteral */ ||
	                includes & 512 /* ESSymbol */ && includes & 1024 /* UniqueESSymbol */) {
	                removeRedundantPrimitiveTypes(typeSet, includes);
	            }
	            if (includes & 67108864 /* EmptyObject */ && !(includes & 65536 /* Object */)) {
	                typeSet.push(emptyObjectType);
	            }
	            if (typeSet.length === 1) {
	                return typeSet[0];
	            }
	            if (includes & 131072 /* Union */) {
	                if (includes & 268435456 /* UnionOfUnitTypes */ && intersectUnionsOfUnitTypes(typeSet)) {
	                    // When the intersection creates a reduced set (which might mean that *all* union types have
	                    // disappeared), we restart the operation to get a new set of combined flags. Once we have
	                    // reduced we'll never reduce again, so this occurs at most once.
	                    return getIntersectionType(typeSet, aliasSymbol, aliasTypeArguments);
	                }
	                // We are attempting to construct a type of the form X & (A | B) & Y. Transform this into a type of
	                // the form X & A & Y | X & B & Y and recursively reduce until no union type constituents remain.
	                var unionIndex_1 = ts.findIndex(typeSet, function (t) { return (t.flags & 131072 /* Union */) !== 0; });
	                var unionType = typeSet[unionIndex_1];
	                return getUnionType(ts.map(unionType.types, function (t) { return getIntersectionType(ts.replaceElement(typeSet, unionIndex_1, t)); }), 1 /* Literal */, aliasSymbol, aliasTypeArguments);
	            }
	            var id = getTypeListId(typeSet);
	            var type = intersectionTypes.get(id);
	            if (!type) {
	                var propagatedFlags = getPropagatingFlagsOfTypes(typeSet, /*excludeKinds*/ 12288 /* Nullable */);
	                type = createType(262144 /* Intersection */ | propagatedFlags);
	                intersectionTypes.set(id, type);
	                type.types = typeSet;
	                type.aliasSymbol = aliasSymbol; // See comment in `getUnionTypeFromSortedList`.
	                type.aliasTypeArguments = aliasTypeArguments;
	            }
	            return type;
	        }
	        function getTypeFromIntersectionTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var aliasSymbol = getAliasSymbolForTypeNode(node);
	                links.resolvedType = getIntersectionType(ts.map(node.types, getTypeFromTypeNode), aliasSymbol, getTypeArgumentsForAliasSymbol(aliasSymbol));
	            }
	            return links.resolvedType;
	        }
	        function createIndexType(type, stringsOnly) {
	            var result = createType(524288 /* Index */);
	            result.type = type;
	            result.stringsOnly = stringsOnly;
	            return result;
	        }
	        function getIndexTypeForGenericType(type, stringsOnly) {
	            return stringsOnly ?
	                type.resolvedStringIndexType || (type.resolvedStringIndexType = createIndexType(type, /*stringsOnly*/ true)) :
	                type.resolvedIndexType || (type.resolvedIndexType = createIndexType(type, /*stringsOnly*/ false));
	        }
	        function getLiteralTypeFromPropertyName(prop, include) {
	            if (!(ts.getDeclarationModifierFlagsFromSymbol(prop) & 24 /* NonPublicAccessibilityModifier */)) {
	                var type = getLateBoundSymbol(prop).nameType;
	                if (!type && !ts.isKnownSymbol(prop)) {
	                    var name = ts.getNameOfDeclaration(prop.valueDeclaration);
	                    type = name && ts.isNumericLiteral(name) ? getLiteralType(+name.text) :
	                        name && name.kind === 146 /* ComputedPropertyName */ && ts.isNumericLiteral(name.expression) ? getLiteralType(+name.expression.text) :
	                            getLiteralType(ts.symbolName(prop));
	                }
	                if (type && type.flags & include) {
	                    return type;
	                }
	            }
	            return neverType;
	        }
	        function getLiteralTypeFromPropertyNames(type, include) {
	            return getUnionType(ts.map(getPropertiesOfType(type), function (t) { return getLiteralTypeFromPropertyName(t, include); }));
	        }
	        function getNonEnumNumberIndexInfo(type) {
	            var numberIndexInfo = getIndexInfoOfType(type, 1 /* Number */);
	            return numberIndexInfo !== enumNumberIndexInfo ? numberIndexInfo : undefined;
	        }
	        function getIndexType(type, stringsOnly) {
	            if (stringsOnly === void 0) { stringsOnly = keyofStringsOnly; }
	            return type.flags & 131072 /* Union */ ? getIntersectionType(ts.map(type.types, function (t) { return getIndexType(t, stringsOnly); })) :
	                type.flags & 262144 /* Intersection */ ? getUnionType(ts.map(type.types, function (t) { return getIndexType(t, stringsOnly); })) :
	                    maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */) ? getIndexTypeForGenericType(type, stringsOnly) :
	                        ts.getObjectFlags(type) & 32 /* Mapped */ ? getConstraintTypeFromMappedType(type) :
	                            type === wildcardType ? wildcardType :
	                                type.flags & 1 /* Any */ ? keyofConstraintType :
	                                    stringsOnly ? getIndexInfoOfType(type, 0 /* String */) ? stringType : getLiteralTypeFromPropertyNames(type, 32 /* StringLiteral */) :
	                                        getIndexInfoOfType(type, 0 /* String */) ? getUnionType([stringType, numberType, getLiteralTypeFromPropertyNames(type, 1024 /* UniqueESSymbol */)]) :
	                                            getNonEnumNumberIndexInfo(type) ? getUnionType([numberType, getLiteralTypeFromPropertyNames(type, 32 /* StringLiteral */ | 1024 /* UniqueESSymbol */)]) :
	                                                getLiteralTypeFromPropertyNames(type, 1120 /* StringOrNumberLiteralOrUnique */);
	        }
	        function getExtractStringType(type) {
	            if (keyofStringsOnly) {
	                return type;
	            }
	            var extractTypeAlias = getGlobalExtractSymbol();
	            return extractTypeAlias ? getTypeAliasInstantiation(extractTypeAlias, [type, stringType]) : stringType;
	        }
	        function getIndexTypeOrString(type) {
	            var indexType = getExtractStringType(getIndexType(type));
	            return indexType.flags & 16384 /* Never */ ? stringType : indexType;
	        }
	        function getTypeFromTypeOperatorNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                switch (node.operator) {
	                    case 128 /* KeyOfKeyword */:
	                        links.resolvedType = getIndexType(getTypeFromTypeNode(node.type));
	                        break;
	                    case 141 /* UniqueKeyword */:
	                        links.resolvedType = node.type.kind === 138 /* SymbolKeyword */
	                            ? getESSymbolLikeTypeForNode(ts.walkUpParenthesizedTypes(node.parent))
	                            : unknownType;
	                        break;
	                }
	            }
	            return links.resolvedType;
	        }
	        function createIndexedAccessType(objectType, indexType) {
	            var type = createType(1048576 /* IndexedAccess */);
	            type.objectType = objectType;
	            type.indexType = indexType;
	            return type;
	        }
	        function getPropertyTypeForIndexType(objectType, indexType, accessNode, cacheSymbol) {
	            var accessExpression = accessNode && accessNode.kind === 185 /* ElementAccessExpression */ ? accessNode : undefined;
	            var propName = isTypeUsableAsLateBoundName(indexType) ? getLateBoundNameFromType(indexType) :
	                accessExpression && checkThatExpressionIsProperSymbolReference(accessExpression.argumentExpression, indexType, /*reportError*/ false) ?
	                    ts.getPropertyNameForKnownSymbolName(ts.idText(accessExpression.argumentExpression.name)) :
	                    undefined;
	            if (propName !== undefined) {
	                var prop = getPropertyOfType(objectType, propName);
	                if (prop) {
	                    if (accessExpression) {
	                        markPropertyAsReferenced(prop, accessExpression, /*isThisAccess*/ accessExpression.expression.kind === 99 /* ThisKeyword */);
	                        if (ts.isAssignmentTarget(accessExpression) && (isReferenceToReadonlyEntity(accessExpression, prop) || isReferenceThroughNamespaceImport(accessExpression))) {
	                            error(accessExpression.argumentExpression, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, symbolToString(prop));
	                            return unknownType;
	                        }
	                        if (cacheSymbol) {
	                            getNodeLinks(accessNode).resolvedSymbol = prop;
	                        }
	                    }
	                    return getTypeOfSymbol(prop);
	                }
	            }
	            if (!(indexType.flags & 12288 /* Nullable */) && isTypeAssignableToKind(indexType, 34 /* StringLike */ | 84 /* NumberLike */ | 1536 /* ESSymbolLike */)) {
	                if (isTypeAny(objectType)) {
	                    return objectType;
	                }
	                var indexInfo = isTypeAssignableToKind(indexType, 84 /* NumberLike */) && getIndexInfoOfType(objectType, 1 /* Number */) ||
	                    getIndexInfoOfType(objectType, 0 /* String */) ||
	                    undefined;
	                if (indexInfo) {
	                    if (accessNode && !isTypeAssignableToKind(indexType, 2 /* String */ | 4 /* Number */)) {
	                        var indexNode = accessNode.kind === 185 /* ElementAccessExpression */ ? accessNode.argumentExpression : accessNode.indexType;
	                        error(indexNode, ts.Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
	                    }
	                    else if (accessExpression && indexInfo.isReadonly && (ts.isAssignmentTarget(accessExpression) || ts.isDeleteTarget(accessExpression))) {
	                        error(accessExpression, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
	                    }
	                    return indexInfo.type;
	                }
	                if (indexType.flags & 16384 /* Never */) {
	                    return neverType;
	                }
	                if (accessExpression && !isConstEnumObjectType(objectType)) {
	                    if (noImplicitAny && !compilerOptions.suppressImplicitAnyIndexErrors) {
	                        if (getIndexTypeOfType(objectType, 1 /* Number */)) {
	                            error(accessExpression.argumentExpression, ts.Diagnostics.Element_implicitly_has_an_any_type_because_index_expression_is_not_of_type_number);
	                        }
	                        else {
	                            error(accessExpression, ts.Diagnostics.Element_implicitly_has_an_any_type_because_type_0_has_no_index_signature, typeToString(objectType));
	                        }
	                    }
	                    return anyType;
	                }
	            }
	            if (accessNode) {
	                var indexNode = accessNode.kind === 185 /* ElementAccessExpression */ ? accessNode.argumentExpression : accessNode.indexType;
	                if (indexType.flags & (32 /* StringLiteral */ | 64 /* NumberLiteral */)) {
	                    error(indexNode, ts.Diagnostics.Property_0_does_not_exist_on_type_1, "" + indexType.value, typeToString(objectType));
	                }
	                else if (indexType.flags & (2 /* String */ | 4 /* Number */)) {
	                    error(indexNode, ts.Diagnostics.Type_0_has_no_matching_index_signature_for_type_1, typeToString(objectType), typeToString(indexType));
	                }
	                else {
	                    error(indexNode, ts.Diagnostics.Type_0_cannot_be_used_as_an_index_type, typeToString(indexType));
	                }
	            }
	            return unknownType;
	        }
	        function isGenericObjectType(type) {
	            return maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */ | 536870912 /* GenericMappedType */);
	        }
	        function isGenericIndexType(type) {
	            return maybeTypeOfKind(type, 7372800 /* InstantiableNonPrimitive */ | 524288 /* Index */);
	        }
	        // Return true if the given type is a non-generic object type with a string index signature and no
	        // other members.
	        function isStringIndexOnlyType(type) {
	            if (type.flags & 65536 /* Object */ && !isGenericMappedType(type)) {
	                var t = resolveStructuredTypeMembers(type);
	                return t.properties.length === 0 &&
	                    t.callSignatures.length === 0 && t.constructSignatures.length === 0 &&
	                    t.stringIndexInfo && !t.numberIndexInfo;
	            }
	            return false;
	        }
	        function isMappedTypeToNever(type) {
	            return ts.getObjectFlags(type) & 32 /* Mapped */ && getTemplateTypeFromMappedType(type) === neverType;
	        }
	        function getSimplifiedType(type) {
	            return type.flags & 1048576 /* IndexedAccess */ ? getSimplifiedIndexedAccessType(type) : type;
	        }
	        // Transform an indexed access to a simpler form, if possible. Return the simpler form, or return
	        // the type itself if no transformation is possible.
	        function getSimplifiedIndexedAccessType(type) {
	            if (type.simplified) {
	                return type.simplified === circularConstraintType ? type : type.simplified;
	            }
	            type.simplified = circularConstraintType;
	            var objectType = type.objectType;
	            if (objectType.flags & 262144 /* Intersection */ && isGenericObjectType(objectType)) {
	                // Given an indexed access type T[K], if T is an intersection containing one or more generic types and one or
	                // more object types with only a string index signature, e.g. '(U & V & { [x: string]: D })[K]', return a
	                // transformed type of the form '(U & V)[K] | D'. This allows us to properly reason about higher order indexed
	                // access types with default property values as expressed by D.
	                if (ts.some(objectType.types, isStringIndexOnlyType)) {
	                    var regularTypes = [];
	                    var stringIndexTypes = [];
	                    for (var _i = 0, _a = objectType.types; _i < _a.length; _i++) {
	                        var t = _a[_i];
	                        if (isStringIndexOnlyType(t)) {
	                            stringIndexTypes.push(getIndexTypeOfType(t, 0 /* String */));
	                        }
	                        else {
	                            regularTypes.push(t);
	                        }
	                    }
	                    return type.simplified = getUnionType([
	                        getSimplifiedType(getIndexedAccessType(getIntersectionType(regularTypes), type.indexType)),
	                        getIntersectionType(stringIndexTypes)
	                    ]);
	                }
	                // Given an indexed access type T[K], if T is an intersection containing one or more generic types and one or
	                // more mapped types with a template type `never`, '(U & V & { [P in T]: never })[K]', return a
	                // transformed type that removes the never-mapped type: '(U & V)[K]'. This mirrors what would happen
	                // eventually anyway, but it easier to reason about.
	                if (ts.some(objectType.types, isMappedTypeToNever)) {
	                    var nonNeverTypes = ts.filter(objectType.types, function (t) { return !isMappedTypeToNever(t); });
	                    return type.simplified = getSimplifiedType(getIndexedAccessType(getIntersectionType(nonNeverTypes), type.indexType));
	                }
	            }
	            // If the object type is a mapped type { [P in K]: E }, where K is generic, instantiate E using a mapper
	            // that substitutes the index type for P. For example, for an index access { [P in K]: Box<T[P]> }[X], we
	            // construct the type Box<T[X]>. We do not further simplify the result because mapped types can be recursive
	            // and we might never terminate.
	            if (isGenericMappedType(objectType)) {
	                return type.simplified = substituteIndexedMappedType(objectType, type);
	            }
	            if (objectType.flags & 32768 /* TypeParameter */) {
	                var constraint = getConstraintFromTypeParameter(objectType);
	                if (constraint && isGenericMappedType(constraint)) {
	                    return type.simplified = substituteIndexedMappedType(constraint, type);
	                }
	            }
	            return type.simplified = type;
	        }
	        function substituteIndexedMappedType(objectType, type) {
	            var mapper = createTypeMapper([getTypeParameterFromMappedType(objectType)], [type.indexType]);
	            var templateMapper = combineTypeMappers(objectType.mapper, mapper);
	            return instantiateType(getTemplateTypeFromMappedType(objectType), templateMapper);
	        }
	        function getIndexedAccessType(objectType, indexType, accessNode) {
	            if (objectType === wildcardType || indexType === wildcardType) {
	                return wildcardType;
	            }
	            // If the index type is generic, or if the object type is generic and doesn't originate in an expression,
	            // we are performing a higher-order index access where we cannot meaningfully access the properties of the
	            // object type. Note that for a generic T and a non-generic K, we eagerly resolve T[K] if it originates in
	            // an expression. This is to preserve backwards compatibility. For example, an element access 'this["foo"]'
	            // has always been resolved eagerly using the constraint type of 'this' at the given location.
	            if (isGenericIndexType(indexType) || !(accessNode && accessNode.kind === 185 /* ElementAccessExpression */) && isGenericObjectType(objectType)) {
	                if (objectType.flags & 1 /* Any */) {
	                    return objectType;
	                }
	                // Defer the operation by creating an indexed access type.
	                var id = objectType.id + "," + indexType.id;
	                var type = indexedAccessTypes.get(id);
	                if (!type) {
	                    indexedAccessTypes.set(id, type = createIndexedAccessType(objectType, indexType));
	                }
	                return type;
	            }
	            // In the following we resolve T[K] to the type of the property in T selected by K.
	            // We treat boolean as different from other unions to improve errors;
	            // skipping straight to getPropertyTypeForIndexType gives errors with 'boolean' instead of 'true'.
	            var apparentObjectType = getApparentType(objectType);
	            if (indexType.flags & 131072 /* Union */ && !(indexType.flags & 8 /* Boolean */)) {
	                var propTypes = [];
	                for (var _i = 0, _a = indexType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    var propType = getPropertyTypeForIndexType(apparentObjectType, t, accessNode, /*cacheSymbol*/ false);
	                    if (propType === unknownType) {
	                        return unknownType;
	                    }
	                    propTypes.push(propType);
	                }
	                return getUnionType(propTypes);
	            }
	            return getPropertyTypeForIndexType(apparentObjectType, indexType, accessNode, /*cacheSymbol*/ true);
	        }
	        function getTypeFromIndexedAccessTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var objectType = getTypeFromTypeNode(node.objectType);
	                var indexType = getTypeFromTypeNode(node.indexType);
	                var resolved = getIndexedAccessType(objectType, indexType, node);
	                links.resolvedType = resolved.flags & 1048576 /* IndexedAccess */ &&
	                    resolved.objectType === objectType &&
	                    resolved.indexType === indexType ?
	                    getConstrainedTypeVariable(resolved, node) : resolved;
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromMappedTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var type = createObjectType(32 /* Mapped */, node.symbol);
	                type.declaration = node;
	                type.aliasSymbol = getAliasSymbolForTypeNode(node);
	                type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(type.aliasSymbol);
	                links.resolvedType = type;
	                // Eagerly resolve the constraint type which forces an error if the constraint type circularly
	                // references itself through one or more type aliases.
	                getConstraintTypeFromMappedType(type);
	            }
	            return links.resolvedType;
	        }
	        function getActualTypeVariable(type) {
	            return type.flags & 4194304 /* Substitution */ ? type.typeVariable : type;
	        }
	        function getConditionalType(root, mapper) {
	            var checkType = instantiateType(root.checkType, mapper);
	            var extendsType = instantiateType(root.extendsType, mapper);
	            if (checkType === wildcardType || extendsType === wildcardType) {
	                return wildcardType;
	            }
	            // If this is a distributive conditional type and the check type is generic we need to defer
	            // resolution of the conditional type such that a later instantiation will properly distribute
	            // over union types.
	            var isDeferred = root.isDistributive && maybeTypeOfKind(checkType, 7897088 /* Instantiable */);
	            var combinedMapper;
	            if (root.inferTypeParameters) {
	                var context_1 = createInferenceContext(root.inferTypeParameters, /*signature*/ undefined, 0 /* None */);
	                if (!isDeferred) {
	                    // We don't want inferences from constraints as they may cause us to eagerly resolve the
	                    // conditional type instead of deferring resolution. Also, we always want strict function
	                    // types rules (i.e. proper contravariance) for inferences.
	                    inferTypes(context_1.inferences, checkType, extendsType, 32 /* NoConstraints */ | 64 /* AlwaysStrict */);
	                }
	                combinedMapper = combineTypeMappers(mapper, context_1);
	            }
	            if (!isDeferred) {
	                // Return union of trueType and falseType for 'any' since it matches anything
	                if (checkType.flags & 1 /* Any */) {
	                    return getUnionType([instantiateType(root.trueType, combinedMapper || mapper), instantiateType(root.falseType, mapper)]);
	                }
	                // Instantiate the extends type including inferences for 'infer T' type parameters
	                var inferredExtendsType = combinedMapper ? instantiateType(root.extendsType, combinedMapper) : extendsType;
	                // Return falseType for a definitely false extends check. We check an instantations of the two
	                // types with type parameters mapped to the wildcard type, the most permissive instantiations
	                // possible (the wildcard type is assignable to and from all types). If those are not related,
	                // then no instatiations will be and we can just return the false branch type.
	                if (!isTypeAssignableTo(getWildcardInstantiation(checkType), getWildcardInstantiation(inferredExtendsType))) {
	                    return instantiateType(root.falseType, mapper);
	                }
	                // Return trueType for a definitely true extends check. The definitely assignable relation excludes
	                // type variable constraints from consideration. Without the definitely assignable relation, the type
	                //   type Foo<T extends { x: any }> = T extends { x: string } ? string : number
	                // would immediately resolve to 'string' instead of being deferred.
	                if (checkTypeRelatedTo(checkType, inferredExtendsType, definitelyAssignableRelation, /*errorNode*/ undefined)) {
	                    return instantiateType(root.trueType, combinedMapper || mapper);
	                }
	            }
	            // Return a deferred type for a check that is neither definitely true nor definitely false
	            var erasedCheckType = getActualTypeVariable(checkType);
	            var result = createType(2097152 /* Conditional */);
	            result.root = root;
	            result.checkType = erasedCheckType;
	            result.extendsType = extendsType;
	            result.mapper = mapper;
	            result.combinedMapper = combinedMapper;
	            result.aliasSymbol = root.aliasSymbol;
	            result.aliasTypeArguments = instantiateTypes(root.aliasTypeArguments, mapper);
	            return result;
	        }
	        function getTrueTypeFromConditionalType(type) {
	            return type.resolvedTrueType || (type.resolvedTrueType = instantiateType(type.root.trueType, type.mapper));
	        }
	        function getFalseTypeFromConditionalType(type) {
	            return type.resolvedFalseType || (type.resolvedFalseType = instantiateType(type.root.falseType, type.mapper));
	        }
	        function getInferTypeParameters(node) {
	            var result;
	            if (node.locals) {
	                node.locals.forEach(function (symbol) {
	                    if (symbol.flags & 262144 /* TypeParameter */) {
	                        result = ts.append(result, getDeclaredTypeOfSymbol(symbol));
	                    }
	                });
	            }
	            return result;
	        }
	        function isPossiblyReferencedInConditionalType(tp, node) {
	            if (isTypeParameterPossiblyReferenced(tp, node)) {
	                return true;
	            }
	            while (node) {
	                if (node.kind === 170 /* ConditionalType */) {
	                    if (isTypeParameterPossiblyReferenced(tp, node.extendsType)) {
	                        return true;
	                    }
	                }
	                node = node.parent;
	            }
	            return false;
	        }
	        function getTypeFromConditionalTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                var checkType = getTypeFromTypeNode(node.checkType);
	                var aliasSymbol = getAliasSymbolForTypeNode(node);
	                var aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
	                var allOuterTypeParameters = getOuterTypeParameters(node, /*includeThisTypes*/ true);
	                var outerTypeParameters = aliasTypeArguments ? allOuterTypeParameters : ts.filter(allOuterTypeParameters, function (tp) { return isPossiblyReferencedInConditionalType(tp, node); });
	                var root = {
	                    node: node,
	                    checkType: checkType,
	                    extendsType: getTypeFromTypeNode(node.extendsType),
	                    trueType: getTypeFromTypeNode(node.trueType),
	                    falseType: getTypeFromTypeNode(node.falseType),
	                    isDistributive: !!(checkType.flags & 32768 /* TypeParameter */),
	                    inferTypeParameters: getInferTypeParameters(node),
	                    outerTypeParameters: outerTypeParameters,
	                    instantiations: undefined,
	                    aliasSymbol: aliasSymbol,
	                    aliasTypeArguments: aliasTypeArguments
	                };
	                links.resolvedType = getConditionalType(root, /*mapper*/ undefined);
	                if (outerTypeParameters) {
	                    root.instantiations = ts.createMap();
	                    root.instantiations.set(getTypeListId(outerTypeParameters), links.resolvedType);
	                }
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromInferTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getDeclaredTypeOfTypeParameter(getSymbolOfNode(node.typeParameter));
	            }
	            return links.resolvedType;
	        }
	        function getIdentifierChain(node) {
	            if (ts.isIdentifier(node)) {
	                return [node];
	            }
	            else {
	                return ts.append(getIdentifierChain(node.left), node.right);
	            }
	        }
	        function getTypeFromImportTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                if (node.isTypeOf && node.typeArguments) { // Only the non-typeof form can make use of type arguments
	                    error(node, ts.Diagnostics.Type_arguments_cannot_be_used_here);
	                    links.resolvedSymbol = unknownSymbol;
	                    return links.resolvedType = unknownType;
	                }
	                if (!ts.isLiteralImportTypeNode(node)) {
	                    error(node.argument, ts.Diagnostics.String_literal_expected);
	                    links.resolvedSymbol = unknownSymbol;
	                    return links.resolvedType = unknownType;
	                }
	                var argumentType = getTypeFromTypeNode(node.argument);
	                var targetMeaning = node.isTypeOf ? 67216319 /* Value */ : 67901928 /* Type */;
	                // TODO: Future work: support unions/generics/whatever via a deferred import-type
	                var moduleName = argumentType.value;
	                var innerModuleSymbol = resolveExternalModule(node, moduleName, ts.Diagnostics.Cannot_find_module_0, node, /*isForAugmentation*/ false);
	                if (!innerModuleSymbol) {
	                    links.resolvedSymbol = unknownSymbol;
	                    return links.resolvedType = unknownType;
	                }
	                var moduleSymbol_1 = resolveExternalModuleSymbol(innerModuleSymbol, /*dontResolveAlias*/ false);
	                if (!ts.nodeIsMissing(node.qualifier)) {
	                    var nameStack = getIdentifierChain(node.qualifier);
	                    var currentNamespace = moduleSymbol_1;
	                    var current = void 0;
	                    while (current = nameStack.shift()) {
	                        var meaning = nameStack.length ? 1920 /* Namespace */ : targetMeaning;
	                        var next = getSymbol(getExportsOfSymbol(getMergedSymbol(resolveSymbol(currentNamespace))), current.escapedText, meaning);
	                        if (!next) {
	                            error(current, ts.Diagnostics.Namespace_0_has_no_exported_member_1, getFullyQualifiedName(currentNamespace), ts.declarationNameToString(current));
	                            return links.resolvedType = unknownType;
	                        }
	                        getNodeLinks(current).resolvedSymbol = next;
	                        getNodeLinks(current.parent).resolvedSymbol = next;
	                        currentNamespace = next;
	                    }
	                    resolveImportSymbolType(node, links, currentNamespace, targetMeaning);
	                }
	                else {
	                    if (moduleSymbol_1.flags & targetMeaning) {
	                        resolveImportSymbolType(node, links, moduleSymbol_1, targetMeaning);
	                    }
	                    else {
	                        error(node, targetMeaning === 67216319 /* Value */ ? ts.Diagnostics.Module_0_does_not_refer_to_a_value_but_is_used_as_a_value_here : ts.Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here, moduleName);
	                        links.resolvedSymbol = unknownSymbol;
	                        links.resolvedType = unknownType;
	                    }
	                }
	            }
	            return links.resolvedType;
	        }
	        function resolveImportSymbolType(node, links, symbol, meaning) {
	            var resolvedSymbol = resolveSymbol(symbol);
	            links.resolvedSymbol = resolvedSymbol;
	            if (meaning === 67216319 /* Value */) {
	                return links.resolvedType = getTypeOfSymbol(symbol); // intentionally doesn't use resolved symbol so type is cached as expected on the alias
	            }
	            else {
	                return links.resolvedType = getTypeReferenceType(node, resolvedSymbol); // getTypeReferenceType doesn't handle aliases - it must get the resolved symbol
	            }
	        }
	        function getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                // Deferred resolution of members is handled by resolveObjectTypeMembers
	                var aliasSymbol = getAliasSymbolForTypeNode(node);
	                if (getMembersOfSymbol(node.symbol).size === 0 && !aliasSymbol) {
	                    links.resolvedType = emptyTypeLiteralType;
	                }
	                else {
	                    var type = createObjectType(16 /* Anonymous */, node.symbol);
	                    type.aliasSymbol = aliasSymbol;
	                    type.aliasTypeArguments = getTypeArgumentsForAliasSymbol(aliasSymbol);
	                    if (ts.isJSDocTypeLiteral(node) && node.isArrayType) {
	                        type = createArrayType(type);
	                    }
	                    links.resolvedType = type;
	                }
	            }
	            return links.resolvedType;
	        }
	        function getAliasSymbolForTypeNode(node) {
	            return ts.isTypeAlias(node.parent) ? getSymbolOfNode(node.parent) : undefined;
	        }
	        function getTypeArgumentsForAliasSymbol(symbol) {
	            return symbol ? getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(symbol) : undefined;
	        }
	        /**
	         * Since the source of spread types are object literals, which are not binary,
	         * this function should be called in a left folding style, with left = previous result of getSpreadType
	         * and right = the new element to be spread.
	         */
	        function getSpreadType(left, right, symbol, typeFlags, objectFlags) {
	            if (left.flags & 1 /* Any */ || right.flags & 1 /* Any */) {
	                return anyType;
	            }
	            if (left.flags & 16384 /* Never */) {
	                return right;
	            }
	            if (right.flags & 16384 /* Never */) {
	                return left;
	            }
	            if (left.flags & 131072 /* Union */) {
	                return mapType(left, function (t) { return getSpreadType(t, right, symbol, typeFlags, objectFlags); });
	            }
	            if (right.flags & 131072 /* Union */) {
	                return mapType(right, function (t) { return getSpreadType(left, t, symbol, typeFlags, objectFlags); });
	            }
	            if (right.flags & (136 /* BooleanLike */ | 84 /* NumberLike */ | 34 /* StringLike */ | 272 /* EnumLike */ | 134217728 /* NonPrimitive */ | 524288 /* Index */)) {
	                return left;
	            }
	            var members = ts.createSymbolTable();
	            var skippedPrivateMembers = ts.createUnderscoreEscapedMap();
	            var stringIndexInfo;
	            var numberIndexInfo;
	            if (left === emptyObjectType) {
	                // for the first spread element, left === emptyObjectType, so take the right's string indexer
	                stringIndexInfo = getIndexInfoOfType(right, 0 /* String */);
	                numberIndexInfo = getIndexInfoOfType(right, 1 /* Number */);
	            }
	            else {
	                stringIndexInfo = unionSpreadIndexInfos(getIndexInfoOfType(left, 0 /* String */), getIndexInfoOfType(right, 0 /* String */));
	                numberIndexInfo = unionSpreadIndexInfos(getIndexInfoOfType(left, 1 /* Number */), getIndexInfoOfType(right, 1 /* Number */));
	            }
	            for (var _i = 0, _a = getPropertiesOfType(right); _i < _a.length; _i++) {
	                var rightProp = _a[_i];
	                // we approximate own properties as non-methods plus methods that are inside the object literal
	                var isSetterWithoutGetter = rightProp.flags & 65536 /* SetAccessor */ && !(rightProp.flags & 32768 /* GetAccessor */);
	                if (ts.getDeclarationModifierFlagsFromSymbol(rightProp) & (8 /* Private */ | 16 /* Protected */)) {
	                    skippedPrivateMembers.set(rightProp.escapedName, true);
	                }
	                else if (!isClassMethod(rightProp) && !isSetterWithoutGetter) {
	                    members.set(rightProp.escapedName, getNonReadonlySymbol(rightProp));
	                }
	            }
	            for (var _b = 0, _c = getPropertiesOfType(left); _b < _c.length; _b++) {
	                var leftProp = _c[_b];
	                if (leftProp.flags & 65536 /* SetAccessor */ && !(leftProp.flags & 32768 /* GetAccessor */)
	                    || skippedPrivateMembers.has(leftProp.escapedName)
	                    || isClassMethod(leftProp)) {
	                    continue;
	                }
	                if (members.has(leftProp.escapedName)) {
	                    var rightProp = members.get(leftProp.escapedName);
	                    var rightType = getTypeOfSymbol(rightProp);
	                    if (rightProp.flags & 16777216 /* Optional */) {
	                        var declarations = ts.concatenate(leftProp.declarations, rightProp.declarations);
	                        var flags = 4 /* Property */ | (leftProp.flags & 16777216 /* Optional */);
	                        var result = createSymbol(flags, leftProp.escapedName);
	                        result.type = getUnionType([getTypeOfSymbol(leftProp), getTypeWithFacts(rightType, 131072 /* NEUndefined */)]);
	                        result.leftSpread = leftProp;
	                        result.rightSpread = rightProp;
	                        result.declarations = declarations;
	                        result.nameType = leftProp.nameType;
	                        members.set(leftProp.escapedName, result);
	                    }
	                }
	                else {
	                    members.set(leftProp.escapedName, getNonReadonlySymbol(leftProp));
	                }
	            }
	            var spread = createAnonymousType(symbol, members, ts.emptyArray, ts.emptyArray, getNonReadonlyIndexSignature(stringIndexInfo), getNonReadonlyIndexSignature(numberIndexInfo));
	            spread.flags |= typeFlags | 33554432 /* ContainsObjectLiteral */;
	            spread.objectFlags |= objectFlags | (128 /* ObjectLiteral */ | 1024 /* ContainsSpread */);
	            return spread;
	        }
	        function getNonReadonlySymbol(prop) {
	            if (!isReadonlySymbol(prop)) {
	                return prop;
	            }
	            var flags = 4 /* Property */ | (prop.flags & 16777216 /* Optional */);
	            var result = createSymbol(flags, prop.escapedName);
	            result.type = getTypeOfSymbol(prop);
	            result.declarations = prop.declarations;
	            result.nameType = prop.nameType;
	            result.syntheticOrigin = prop;
	            return result;
	        }
	        function getNonReadonlyIndexSignature(index) {
	            if (index && index.isReadonly) {
	                return createIndexInfo(index.type, /*isReadonly*/ false, index.declaration);
	            }
	            return index;
	        }
	        function isClassMethod(prop) {
	            return prop.flags & 8192 /* Method */ && ts.find(prop.declarations, function (decl) { return ts.isClassLike(decl.parent); });
	        }
	        function createLiteralType(flags, value, symbol) {
	            var type = createType(flags);
	            type.symbol = symbol;
	            type.value = value;
	            return type;
	        }
	        function getFreshTypeOfLiteralType(type) {
	            if (type.flags & 96 /* StringOrNumberLiteral */ && !(type.flags & 8388608 /* FreshLiteral */)) {
	                if (!type.freshType) {
	                    var freshType = createLiteralType(type.flags | 8388608 /* FreshLiteral */, type.value, type.symbol);
	                    freshType.regularType = type;
	                    type.freshType = freshType;
	                }
	                return type.freshType;
	            }
	            return type;
	        }
	        function getRegularTypeOfLiteralType(type) {
	            return type.flags & 96 /* StringOrNumberLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? type.regularType :
	                type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getRegularTypeOfLiteralType)) :
	                    type;
	        }
	        function getLiteralType(value, enumId, symbol) {
	            // We store all literal types in a single map with keys of the form '#NNN' and '@SSS',
	            // where NNN is the text representation of a numeric literal and SSS are the characters
	            // of a string literal. For literal enum members we use 'EEE#NNN' and 'EEE@SSS', where
	            // EEE is a unique id for the containing enum type.
	            var qualifier = typeof value === "number" ? "#" : "@";
	            var key = enumId ? enumId + qualifier + value : qualifier + value;
	            var type = literalTypes.get(key);
	            if (!type) {
	                var flags = (typeof value === "number" ? 64 /* NumberLiteral */ : 32 /* StringLiteral */) | (enumId ? 256 /* EnumLiteral */ : 0);
	                literalTypes.set(key, type = createLiteralType(flags, value, symbol));
	            }
	            return type;
	        }
	        function getTypeFromLiteralTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getRegularTypeOfLiteralType(checkExpression(node.literal));
	            }
	            return links.resolvedType;
	        }
	        function createUniqueESSymbolType(symbol) {
	            var type = createType(1024 /* UniqueESSymbol */);
	            type.symbol = symbol;
	            return type;
	        }
	        function getESSymbolLikeTypeForNode(node) {
	            if (ts.isValidESSymbolDeclaration(node)) {
	                var symbol = getSymbolOfNode(node);
	                var links = getSymbolLinks(symbol);
	                return links.uniqueESSymbolType || (links.uniqueESSymbolType = createUniqueESSymbolType(symbol));
	            }
	            return esSymbolType;
	        }
	        function getThisType(node) {
	            var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	            var parent = container && container.parent;
	            if (parent && (ts.isClassLike(parent) || parent.kind === 235 /* InterfaceDeclaration */)) {
	                if (!ts.hasModifier(container, 32 /* Static */) &&
	                    (container.kind !== 154 /* Constructor */ || ts.isNodeDescendantOf(node, container.body))) {
	                    return getDeclaredTypeOfClassOrInterface(getSymbolOfNode(parent)).thisType;
	                }
	            }
	            error(node, ts.Diagnostics.A_this_type_is_available_only_in_a_non_static_member_of_a_class_or_interface);
	            return unknownType;
	        }
	        function getTypeFromThisTypeNode(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                links.resolvedType = getThisType(node);
	            }
	            return links.resolvedType;
	        }
	        function getTypeFromTypeNode(node) {
	            switch (node.kind) {
	                case 119 /* AnyKeyword */:
	                case 278 /* JSDocAllType */:
	                case 279 /* JSDocUnknownType */:
	                    return anyType;
	                case 137 /* StringKeyword */:
	                    return stringType;
	                case 134 /* NumberKeyword */:
	                    return numberType;
	                case 122 /* BooleanKeyword */:
	                    return booleanType;
	                case 138 /* SymbolKeyword */:
	                    return esSymbolType;
	                case 105 /* VoidKeyword */:
	                    return voidType;
	                case 140 /* UndefinedKeyword */:
	                    return undefinedType;
	                case 95 /* NullKeyword */:
	                    return nullType;
	                case 131 /* NeverKeyword */:
	                    return neverType;
	                case 135 /* ObjectKeyword */:
	                    return node.flags & 65536 /* JavaScriptFile */ ? anyType : nonPrimitiveType;
	                case 173 /* ThisType */:
	                case 99 /* ThisKeyword */:
	                    return getTypeFromThisTypeNode(node);
	                case 177 /* LiteralType */:
	                    return getTypeFromLiteralTypeNode(node);
	                case 161 /* TypeReference */:
	                    return getTypeFromTypeReference(node);
	                case 160 /* TypePredicate */:
	                    return booleanType;
	                case 206 /* ExpressionWithTypeArguments */:
	                    return getTypeFromTypeReference(node);
	                case 164 /* TypeQuery */:
	                    return getTypeFromTypeQueryNode(node);
	                case 166 /* ArrayType */:
	                    return getTypeFromArrayTypeNode(node);
	                case 167 /* TupleType */:
	                    return getTypeFromTupleTypeNode(node);
	                case 168 /* UnionType */:
	                    return getTypeFromUnionTypeNode(node);
	                case 169 /* IntersectionType */:
	                    return getTypeFromIntersectionTypeNode(node);
	                case 280 /* JSDocNullableType */:
	                    return getTypeFromJSDocNullableTypeNode(node);
	                case 282 /* JSDocOptionalType */:
	                    return addOptionality(getTypeFromTypeNode(node.type));
	                case 172 /* ParenthesizedType */:
	                case 281 /* JSDocNonNullableType */:
	                case 277 /* JSDocTypeExpression */:
	                    return getTypeFromTypeNode(node.type);
	                case 284 /* JSDocVariadicType */:
	                    return getTypeFromJSDocVariadicType(node);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 165 /* TypeLiteral */:
	                case 286 /* JSDocTypeLiteral */:
	                case 283 /* JSDocFunctionType */:
	                case 287 /* JSDocSignature */:
	                    return getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
	                case 174 /* TypeOperator */:
	                    return getTypeFromTypeOperatorNode(node);
	                case 175 /* IndexedAccessType */:
	                    return getTypeFromIndexedAccessTypeNode(node);
	                case 176 /* MappedType */:
	                    return getTypeFromMappedTypeNode(node);
	                case 170 /* ConditionalType */:
	                    return getTypeFromConditionalTypeNode(node);
	                case 171 /* InferType */:
	                    return getTypeFromInferTypeNode(node);
	                case 178 /* ImportType */:
	                    return getTypeFromImportTypeNode(node);
	                // This function assumes that an identifier or qualified name is a type expression
	                // Callers should first ensure this by calling isTypeNode
	                case 71 /* Identifier */:
	                case 145 /* QualifiedName */:
	                    var symbol = getSymbolAtLocation(node);
	                    return symbol && getDeclaredTypeOfSymbol(symbol);
	                default:
	                    return unknownType;
	            }
	        }
	        function instantiateList(items, mapper, instantiator) {
	            if (items && items.length) {
	                for (var i = 0; i < items.length; i++) {
	                    var item = items[i];
	                    var mapped = instantiator(item, mapper);
	                    if (item !== mapped) {
	                        var result = i === 0 ? [] : items.slice(0, i);
	                        result.push(mapped);
	                        for (i++; i < items.length; i++) {
	                            result.push(instantiator(items[i], mapper));
	                        }
	                        return result;
	                    }
	                }
	            }
	            return items;
	        }
	        function instantiateTypes(types, mapper) {
	            return instantiateList(types, mapper, instantiateType);
	        }
	        function instantiateSignatures(signatures, mapper) {
	            return instantiateList(signatures, mapper, instantiateSignature);
	        }
	        function makeUnaryTypeMapper(source, target) {
	            return function (t) { return t === source ? target : t; };
	        }
	        function makeBinaryTypeMapper(source1, target1, source2, target2) {
	            return function (t) { return t === source1 ? target1 : t === source2 ? target2 : t; };
	        }
	        function makeArrayTypeMapper(sources, targets) {
	            return function (t) {
	                for (var i = 0; i < sources.length; i++) {
	                    if (t === sources[i]) {
	                        return targets ? targets[i] : anyType;
	                    }
	                }
	                return t;
	            };
	        }
	        function createTypeMapper(sources, targets) {
	            ts.Debug.assert(targets === undefined || sources.length === targets.length);
	            return sources.length === 1 ? makeUnaryTypeMapper(sources[0], targets ? targets[0] : anyType) :
	                sources.length === 2 ? makeBinaryTypeMapper(sources[0], targets ? targets[0] : anyType, sources[1], targets ? targets[1] : anyType) :
	                    makeArrayTypeMapper(sources, targets);
	        }
	        function createTypeEraser(sources) {
	            return createTypeMapper(sources, /*targets*/ undefined);
	        }
	        /**
	         * Maps forward-references to later types parameters to the empty object type.
	         * This is used during inference when instantiating type parameter defaults.
	         */
	        function createBackreferenceMapper(typeParameters, index) {
	            return function (t) { return typeParameters.indexOf(t) >= index ? emptyObjectType : t; };
	        }
	        function isInferenceContext(mapper) {
	            return !!mapper.typeParameters;
	        }
	        function cloneTypeMapper(mapper) {
	            return mapper && isInferenceContext(mapper) ?
	                createInferenceContext(mapper.typeParameters, mapper.signature, mapper.flags | 2 /* NoDefault */, mapper.compareTypes, mapper.inferences) :
	                mapper;
	        }
	        function combineTypeMappers(mapper1, mapper2) {
	            if (!mapper1)
	                return mapper2;
	            if (!mapper2)
	                return mapper1;
	            return function (t) { return instantiateType(mapper1(t), mapper2); };
	        }
	        function createReplacementMapper(source, target, baseMapper) {
	            return function (t) { return t === source ? target : baseMapper(t); };
	        }
	        function wildcardMapper(type) {
	            return type.flags & 32768 /* TypeParameter */ ? wildcardType : type;
	        }
	        function cloneTypeParameter(typeParameter) {
	            var result = createType(32768 /* TypeParameter */);
	            result.symbol = typeParameter.symbol;
	            result.target = typeParameter;
	            return result;
	        }
	        function instantiateTypePredicate(predicate, mapper) {
	            if (ts.isIdentifierTypePredicate(predicate)) {
	                return {
	                    kind: 1 /* Identifier */,
	                    parameterName: predicate.parameterName,
	                    parameterIndex: predicate.parameterIndex,
	                    type: instantiateType(predicate.type, mapper)
	                };
	            }
	            else {
	                return {
	                    kind: 0 /* This */,
	                    type: instantiateType(predicate.type, mapper)
	                };
	            }
	        }
	        function instantiateSignature(signature, mapper, eraseTypeParameters) {
	            var freshTypeParameters;
	            if (signature.typeParameters && !eraseTypeParameters) {
	                // First create a fresh set of type parameters, then include a mapping from the old to the
	                // new type parameters in the mapper function. Finally store this mapper in the new type
	                // parameters such that we can use it when instantiating constraints.
	                freshTypeParameters = ts.map(signature.typeParameters, cloneTypeParameter);
	                mapper = combineTypeMappers(createTypeMapper(signature.typeParameters, freshTypeParameters), mapper);
	                for (var _i = 0, freshTypeParameters_1 = freshTypeParameters; _i < freshTypeParameters_1.length; _i++) {
	                    var tp = freshTypeParameters_1[_i];
	                    tp.mapper = mapper;
	                }
	            }
	            // Don't compute resolvedReturnType and resolvedTypePredicate now,
	            // because using `mapper` now could trigger inferences to become fixed. (See `createInferenceContext`.)
	            // See GH#17600.
	            var result = createSignature(signature.declaration, freshTypeParameters, signature.thisParameter && instantiateSymbol(signature.thisParameter, mapper), instantiateList(signature.parameters, mapper, instantiateSymbol), 
	            /*resolvedReturnType*/ undefined, 
	            /*resolvedTypePredicate*/ undefined, signature.minArgumentCount, signature.hasRestParameter, signature.hasLiteralTypes);
	            result.target = signature;
	            result.mapper = mapper;
	            return result;
	        }
	        function instantiateSymbol(symbol, mapper) {
	            var links = getSymbolLinks(symbol);
	            if (links.type && !maybeTypeOfKind(links.type, 65536 /* Object */ | 7897088 /* Instantiable */)) {
	                // If the type of the symbol is already resolved, and if that type could not possibly
	                // be affected by instantiation, simply return the symbol itself.
	                return symbol;
	            }
	            if (ts.getCheckFlags(symbol) & 1 /* Instantiated */) {
	                // If symbol being instantiated is itself a instantiation, fetch the original target and combine the
	                // type mappers. This ensures that original type identities are properly preserved and that aliases
	                // always reference a non-aliases.
	                symbol = links.target;
	                mapper = combineTypeMappers(links.mapper, mapper);
	            }
	            // Keep the flags from the symbol we're instantiating.  Mark that is instantiated, and
	            // also transient so that we can just store data on it directly.
	            var result = createSymbol(symbol.flags, symbol.escapedName, 1 /* Instantiated */ | (ts.getCheckFlags(symbol) & 1024 /* Late */));
	            result.declarations = symbol.declarations;
	            result.parent = symbol.parent;
	            result.target = symbol;
	            result.mapper = mapper;
	            if (symbol.valueDeclaration) {
	                result.valueDeclaration = symbol.valueDeclaration;
	            }
	            if (symbol.nameType) {
	                result.nameType = symbol.nameType;
	            }
	            if (isTransientSymbol(symbol)) {
	                if (symbol.isRestParameter) {
	                    result.isRestParameter = symbol.isRestParameter;
	                }
	            }
	            return result;
	        }
	        function getAnonymousTypeInstantiation(type, mapper) {
	            var target = type.objectFlags & 64 /* Instantiated */ ? type.target : type;
	            var symbol = target.symbol;
	            var links = getSymbolLinks(symbol);
	            var typeParameters = links.outerTypeParameters;
	            if (!typeParameters) {
	                // The first time an anonymous type is instantiated we compute and store a list of the type
	                // parameters that are in scope (and therefore potentially referenced). For type literals that
	                // aren't the right hand side of a generic type alias declaration we optimize by reducing the
	                // set of type parameters to those that are possibly referenced in the literal.
	                var declaration_1 = symbol.declarations[0];
	                if (ts.isInJavaScriptFile(declaration_1)) {
	                    var paramTag = ts.findAncestor(declaration_1, ts.isJSDocParameterTag);
	                    if (paramTag) {
	                        var paramSymbol = ts.getParameterSymbolFromJSDoc(paramTag);
	                        if (paramSymbol) {
	                            declaration_1 = paramSymbol.valueDeclaration;
	                        }
	                    }
	                }
	                var outerTypeParameters = getOuterTypeParameters(declaration_1, /*includeThisTypes*/ true);
	                if (isJavaScriptConstructor(declaration_1)) {
	                    var templateTagParameters = getTypeParametersFromDeclaration(declaration_1);
	                    outerTypeParameters = ts.addRange(outerTypeParameters, templateTagParameters);
	                }
	                typeParameters = outerTypeParameters || ts.emptyArray;
	                typeParameters = symbol.flags & 2048 /* TypeLiteral */ && !target.aliasTypeArguments ?
	                    ts.filter(typeParameters, function (tp) { return isTypeParameterPossiblyReferenced(tp, declaration_1); }) :
	                    typeParameters;
	                links.outerTypeParameters = typeParameters;
	                if (typeParameters.length) {
	                    links.instantiations = ts.createMap();
	                    links.instantiations.set(getTypeListId(typeParameters), target);
	                }
	            }
	            if (typeParameters.length) {
	                // We are instantiating an anonymous type that has one or more type parameters in scope. Apply the
	                // mapper to the type parameters to produce the effective list of type arguments, and compute the
	                // instantiation cache key from the type IDs of the type arguments.
	                var combinedMapper = type.objectFlags & 64 /* Instantiated */ ? combineTypeMappers(type.mapper, mapper) : mapper;
	                var typeArguments = ts.map(typeParameters, combinedMapper);
	                var id = getTypeListId(typeArguments);
	                var result = links.instantiations.get(id);
	                if (!result) {
	                    var newMapper = createTypeMapper(typeParameters, typeArguments);
	                    result = target.objectFlags & 32 /* Mapped */ ? instantiateMappedType(target, newMapper) : instantiateAnonymousType(target, newMapper);
	                    links.instantiations.set(id, result);
	                }
	                return result;
	            }
	            return type;
	        }
	        function maybeTypeParameterReference(node) {
	            return !(node.kind === 145 /* QualifiedName */ ||
	                node.parent.kind === 161 /* TypeReference */ && node.parent.typeArguments && node === node.parent.typeName);
	        }
	        function isTypeParameterPossiblyReferenced(tp, node) {
	            // If the type parameter doesn't have exactly one declaration, if there are invening statement blocks
	            // between the node and the type parameter declaration, if the node contains actual references to the
	            // type parameter, or if the node contains type queries, we consider the type parameter possibly referenced.
	            if (tp.symbol && tp.symbol.declarations && tp.symbol.declarations.length === 1) {
	                var container_3 = tp.symbol.declarations[0].parent;
	                if (ts.findAncestor(node, function (n) { return n.kind === 212 /* Block */ ? "quit" : n === container_3; })) {
	                    return ts.forEachChild(node, containsReference);
	                }
	            }
	            return true;
	            function containsReference(node) {
	                switch (node.kind) {
	                    case 173 /* ThisType */:
	                        return tp.isThisType;
	                    case 71 /* Identifier */:
	                        return !tp.isThisType && ts.isPartOfTypeNode(node) && maybeTypeParameterReference(node) &&
	                            getTypeFromTypeNode(node) === tp;
	                    case 164 /* TypeQuery */:
	                        return true;
	                }
	                return ts.forEachChild(node, containsReference);
	            }
	        }
	        function instantiateMappedType(type, mapper) {
	            // Check if we have a homomorphic mapped type, i.e. a type of the form { [P in keyof T]: X } for some
	            // type variable T. If so, the mapped type is distributive over a union type and when T is instantiated
	            // to a union type A | B, we produce { [P in keyof A]: X } | { [P in keyof B]: X }. Furthermore, for
	            // homomorphic mapped types we leave primitive types alone. For example, when T is instantiated to a
	            // union type A | undefined, we produce { [P in keyof A]: X } | undefined.
	            var constraintType = getConstraintTypeFromMappedType(type);
	            if (constraintType.flags & 524288 /* Index */) {
	                var typeVariable_1 = constraintType.type;
	                if (typeVariable_1.flags & 32768 /* TypeParameter */) {
	                    var mappedTypeVariable = instantiateType(typeVariable_1, mapper);
	                    if (typeVariable_1 !== mappedTypeVariable) {
	                        return mapType(mappedTypeVariable, function (t) {
	                            if (isMappableType(t)) {
	                                return instantiateAnonymousType(type, createReplacementMapper(typeVariable_1, t, mapper));
	                            }
	                            return t;
	                        });
	                    }
	                }
	            }
	            return instantiateAnonymousType(type, mapper);
	        }
	        function isMappableType(type) {
	            return type.flags & (1 /* Any */ | 7372800 /* InstantiableNonPrimitive */ | 65536 /* Object */ | 262144 /* Intersection */);
	        }
	        function instantiateAnonymousType(type, mapper) {
	            var result = createObjectType(type.objectFlags | 64 /* Instantiated */, type.symbol);
	            if (type.objectFlags & 32 /* Mapped */) {
	                result.declaration = type.declaration;
	            }
	            result.target = type;
	            result.mapper = mapper;
	            result.aliasSymbol = type.aliasSymbol;
	            result.aliasTypeArguments = instantiateTypes(type.aliasTypeArguments, mapper);
	            return result;
	        }
	        function getConditionalTypeInstantiation(type, mapper) {
	            var root = type.root;
	            if (root.outerTypeParameters) {
	                // We are instantiating a conditional type that has one or more type parameters in scope. Apply the
	                // mapper to the type parameters to produce the effective list of type arguments, and compute the
	                // instantiation cache key from the type IDs of the type arguments.
	                var typeArguments = ts.map(root.outerTypeParameters, mapper);
	                var id = getTypeListId(typeArguments);
	                var result = root.instantiations.get(id);
	                if (!result) {
	                    var newMapper = createTypeMapper(root.outerTypeParameters, typeArguments);
	                    result = instantiateConditionalType(root, newMapper);
	                    root.instantiations.set(id, result);
	                }
	                return result;
	            }
	            return type;
	        }
	        function instantiateConditionalType(root, mapper) {
	            // Check if we have a conditional type where the check type is a naked type parameter. If so,
	            // the conditional type is distributive over union types and when T is instantiated to a union
	            // type A | B, we produce (A extends U ? X : Y) | (B extends U ? X : Y).
	            if (root.isDistributive) {
	                var checkType_1 = root.checkType;
	                var instantiatedType = mapper(checkType_1);
	                if (checkType_1 !== instantiatedType && instantiatedType.flags & (131072 /* Union */ | 16384 /* Never */)) {
	                    return mapType(instantiatedType, function (t) { return getConditionalType(root, createReplacementMapper(checkType_1, t, mapper)); });
	                }
	            }
	            return getConditionalType(root, mapper);
	        }
	        function instantiateType(type, mapper) {
	            if (type && mapper && mapper !== identityMapper) {
	                if (type.flags & 32768 /* TypeParameter */) {
	                    return mapper(type);
	                }
	                if (type.flags & 65536 /* Object */) {
	                    if (type.objectFlags & 16 /* Anonymous */) {
	                        // If the anonymous type originates in a declaration of a function, method, class, or
	                        // interface, in an object type literal, or in an object literal expression, we may need
	                        // to instantiate the type because it might reference a type parameter.
	                        return type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */ | 32 /* Class */ | 2048 /* TypeLiteral */ | 4096 /* ObjectLiteral */) && type.symbol.declarations ?
	                            getAnonymousTypeInstantiation(type, mapper) : type;
	                    }
	                    if (type.objectFlags & 32 /* Mapped */) {
	                        return getAnonymousTypeInstantiation(type, mapper);
	                    }
	                    if (type.objectFlags & 4 /* Reference */) {
	                        var typeArguments = type.typeArguments;
	                        var newTypeArguments = instantiateTypes(typeArguments, mapper);
	                        return newTypeArguments !== typeArguments ? createTypeReference(type.target, newTypeArguments) : type;
	                    }
	                }
	                if (type.flags & 131072 /* Union */ && !(type.flags & 16382 /* Primitive */)) {
	                    var types = type.types;
	                    var newTypes = instantiateTypes(types, mapper);
	                    return newTypes !== types ? getUnionType(newTypes, 1 /* Literal */, type.aliasSymbol, instantiateTypes(type.aliasTypeArguments, mapper)) : type;
	                }
	                if (type.flags & 262144 /* Intersection */) {
	                    var types = type.types;
	                    var newTypes = instantiateTypes(types, mapper);
	                    return newTypes !== types ? getIntersectionType(newTypes, type.aliasSymbol, instantiateTypes(type.aliasTypeArguments, mapper)) : type;
	                }
	                if (type.flags & 524288 /* Index */) {
	                    return getIndexType(instantiateType(type.type, mapper));
	                }
	                if (type.flags & 1048576 /* IndexedAccess */) {
	                    return getIndexedAccessType(instantiateType(type.objectType, mapper), instantiateType(type.indexType, mapper));
	                }
	                if (type.flags & 2097152 /* Conditional */) {
	                    return getConditionalTypeInstantiation(type, combineTypeMappers(type.mapper, mapper));
	                }
	                if (type.flags & 4194304 /* Substitution */) {
	                    return instantiateType(type.typeVariable, mapper);
	                }
	            }
	            return type;
	        }
	        function getWildcardInstantiation(type) {
	            return type.flags & (16382 /* Primitive */ | 1 /* Any */ | 16384 /* Never */) ? type :
	                type.wildcardInstantiation || (type.wildcardInstantiation = instantiateType(type, wildcardMapper));
	        }
	        function instantiateIndexInfo(info, mapper) {
	            return info && createIndexInfo(instantiateType(info.type, mapper), info.isReadonly, info.declaration);
	        }
	        // Returns true if the given expression contains (at any level of nesting) a function or arrow expression
	        // that is subject to contextual typing.
	        function isContextSensitive(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            switch (node.kind) {
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                case 153 /* MethodDeclaration */:
	                    return isContextSensitiveFunctionLikeDeclaration(node);
	                case 183 /* ObjectLiteralExpression */:
	                    return ts.forEach(node.properties, isContextSensitive);
	                case 182 /* ArrayLiteralExpression */:
	                    return ts.forEach(node.elements, isContextSensitive);
	                case 200 /* ConditionalExpression */:
	                    return isContextSensitive(node.whenTrue) ||
	                        isContextSensitive(node.whenFalse);
	                case 199 /* BinaryExpression */:
	                    return node.operatorToken.kind === 54 /* BarBarToken */ &&
	                        (isContextSensitive(node.left) || isContextSensitive(node.right));
	                case 269 /* PropertyAssignment */:
	                    return isContextSensitive(node.initializer);
	                case 190 /* ParenthesizedExpression */:
	                    return isContextSensitive(node.expression);
	                case 262 /* JsxAttributes */:
	                    return ts.forEach(node.properties, isContextSensitive);
	                case 261 /* JsxAttribute */:
	                    // If there is no initializer, JSX attribute has a boolean value of true which is not context sensitive.
	                    return node.initializer && isContextSensitive(node.initializer);
	                case 264 /* JsxExpression */:
	                    // It is possible to that node.expression is undefined (e.g <div x={} />)
	                    return node.expression && isContextSensitive(node.expression);
	            }
	            return false;
	        }
	        function isContextSensitiveFunctionLikeDeclaration(node) {
	            // Functions with type parameters are not context sensitive.
	            if (node.typeParameters) {
	                return false;
	            }
	            // Functions with any parameters that lack type annotations are context sensitive.
	            if (ts.forEach(node.parameters, function (p) { return !ts.getEffectiveTypeAnnotationNode(p); })) {
	                return true;
	            }
	            if (node.kind !== 192 /* ArrowFunction */) {
	                // If the first parameter is not an explicit 'this' parameter, then the function has
	                // an implicit 'this' parameter which is subject to contextual typing.
	                var parameter = ts.firstOrUndefined(node.parameters);
	                if (!(parameter && ts.parameterIsThisKeyword(parameter))) {
	                    return true;
	                }
	            }
	            // TODO(anhans): A block should be context-sensitive if it has a context-sensitive return value.
	            return node.body.kind === 212 /* Block */ ? false : isContextSensitive(node.body);
	        }
	        function isContextSensitiveFunctionOrObjectLiteralMethod(func) {
	            return (ts.isInJavaScriptFile(func) && ts.isFunctionDeclaration(func) || isFunctionExpressionOrArrowFunction(func) || ts.isObjectLiteralMethod(func)) &&
	                isContextSensitiveFunctionLikeDeclaration(func);
	        }
	        function getTypeWithoutSignatures(type) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                if (resolved.constructSignatures.length) {
	                    var result = createObjectType(16 /* Anonymous */, type.symbol);
	                    result.members = resolved.members;
	                    result.properties = resolved.properties;
	                    result.callSignatures = ts.emptyArray;
	                    result.constructSignatures = ts.emptyArray;
	                    return result;
	                }
	            }
	            else if (type.flags & 262144 /* Intersection */) {
	                return getIntersectionType(ts.map(type.types, getTypeWithoutSignatures));
	            }
	            return type;
	        }
	        // TYPE CHECKING
	        function isTypeIdenticalTo(source, target) {
	            return isTypeRelatedTo(source, target, identityRelation);
	        }
	        function compareTypesIdentical(source, target) {
	            return isTypeRelatedTo(source, target, identityRelation) ? -1 /* True */ : 0 /* False */;
	        }
	        function compareTypesAssignable(source, target) {
	            return isTypeRelatedTo(source, target, assignableRelation) ? -1 /* True */ : 0 /* False */;
	        }
	        function isTypeSubtypeOf(source, target) {
	            return isTypeRelatedTo(source, target, subtypeRelation);
	        }
	        function isTypeAssignableTo(source, target) {
	            return isTypeRelatedTo(source, target, assignableRelation);
	        }
	        // An object type S is considered to be derived from an object type T if
	        // S is a union type and every constituent of S is derived from T,
	        // T is a union type and S is derived from at least one constituent of T, or
	        // S is a type variable with a base constraint that is derived from T,
	        // T is one of the global types Object and Function and S is a subtype of T, or
	        // T occurs directly or indirectly in an 'extends' clause of S.
	        // Note that this check ignores type parameters and only considers the
	        // inheritance hierarchy.
	        function isTypeDerivedFrom(source, target) {
	            return source.flags & 131072 /* Union */ ? ts.every(source.types, function (t) { return isTypeDerivedFrom(t, target); }) :
	                target.flags & 131072 /* Union */ ? ts.some(target.types, function (t) { return isTypeDerivedFrom(source, t); }) :
	                    source.flags & 7372800 /* InstantiableNonPrimitive */ ? isTypeDerivedFrom(getBaseConstraintOfType(source) || emptyObjectType, target) :
	                        target === globalObjectType || target === globalFunctionType ? isTypeSubtypeOf(source, target) :
	                            hasBaseType(source, getTargetType(target));
	        }
	        /**
	         * This is *not* a bi-directional relationship.
	         * If one needs to check both directions for comparability, use a second call to this function or 'checkTypeComparableTo'.
	         *
	         * A type S is comparable to a type T if some (but not necessarily all) of the possible values of S are also possible values of T.
	         * It is used to check following cases:
	         *   - the types of the left and right sides of equality/inequality operators (`===`, `!==`, `==`, `!=`).
	         *   - the types of `case` clause expressions and their respective `switch` expressions.
	         *   - the type of an expression in a type assertion with the type being asserted.
	         */
	        function isTypeComparableTo(source, target) {
	            return isTypeRelatedTo(source, target, comparableRelation);
	        }
	        function areTypesComparable(type1, type2) {
	            return isTypeComparableTo(type1, type2) || isTypeComparableTo(type2, type1);
	        }
	        function checkTypeAssignableTo(source, target, errorNode, headMessage, containingMessageChain) {
	            return checkTypeRelatedTo(source, target, assignableRelation, errorNode, headMessage, containingMessageChain);
	        }
	        /**
	         * This is *not* a bi-directional relationship.
	         * If one needs to check both directions for comparability, use a second call to this function or 'isTypeComparableTo'.
	         */
	        function checkTypeComparableTo(source, target, errorNode, headMessage, containingMessageChain) {
	            return checkTypeRelatedTo(source, target, comparableRelation, errorNode, headMessage, containingMessageChain);
	        }
	        function isSignatureAssignableTo(source, target, ignoreReturnTypes) {
	            return compareSignaturesRelated(source, target, 0 /* None */, ignoreReturnTypes, /*reportErrors*/ false, 
	            /*errorReporter*/ undefined, compareTypesAssignable) !== 0 /* False */;
	        }
	        /**
	         * See signatureRelatedTo, compareSignaturesIdentical
	         */
	        function compareSignaturesRelated(source, target, callbackCheck, ignoreReturnTypes, reportErrors, errorReporter, compareTypes) {
	            // TODO (drosen): De-duplicate code between related functions.
	            if (source === target) {
	                return -1 /* True */;
	            }
	            if (!target.hasRestParameter && source.minArgumentCount > target.parameters.length) {
	                return 0 /* False */;
	            }
	            if (source.typeParameters && source.typeParameters !== target.typeParameters) {
	                target = getCanonicalSignature(target);
	                source = instantiateSignatureInContextOf(source, target, /*contextualMapper*/ undefined, compareTypes);
	            }
	            var kind = target.declaration ? target.declaration.kind : 0 /* Unknown */;
	            var strictVariance = !callbackCheck && strictFunctionTypes && kind !== 153 /* MethodDeclaration */ &&
	                kind !== 152 /* MethodSignature */ && kind !== 154 /* Constructor */;
	            var result = -1 /* True */;
	            var sourceThisType = getThisTypeOfSignature(source);
	            if (sourceThisType && sourceThisType !== voidType) {
	                var targetThisType = getThisTypeOfSignature(target);
	                if (targetThisType) {
	                    // void sources are assignable to anything.
	                    var related = !strictVariance && compareTypes(sourceThisType, targetThisType, /*reportErrors*/ false)
	                        || compareTypes(targetThisType, sourceThisType, reportErrors);
	                    if (!related) {
	                        if (reportErrors) {
	                            errorReporter(ts.Diagnostics.The_this_types_of_each_signature_are_incompatible);
	                        }
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	            }
	            var sourceMax = getNumNonRestParameters(source);
	            var targetMax = getNumNonRestParameters(target);
	            var checkCount = getNumParametersToCheckForSignatureRelatability(source, sourceMax, target, targetMax);
	            var sourceParams = source.parameters;
	            var targetParams = target.parameters;
	            for (var i = 0; i < checkCount; i++) {
	                var sourceType = i < sourceMax ? getTypeOfParameter(sourceParams[i]) : getRestTypeOfSignature(source);
	                var targetType = i < targetMax ? getTypeOfParameter(targetParams[i]) : getRestTypeOfSignature(target);
	                // In order to ensure that any generic type Foo<T> is at least co-variant with respect to T no matter
	                // how Foo uses T, we need to relate parameters bi-variantly (given that parameters are input positions,
	                // they naturally relate only contra-variantly). However, if the source and target parameters both have
	                // function types with a single call signature, we know we are relating two callback parameters. In
	                // that case it is sufficient to only relate the parameters of the signatures co-variantly because,
	                // similar to return values, callback parameters are output positions. This means that a Promise<T>,
	                // where T is used only in callback parameter positions, will be co-variant (as opposed to bi-variant)
	                // with respect to T.
	                var sourceSig = callbackCheck ? undefined : getSingleCallSignature(getNonNullableType(sourceType));
	                var targetSig = callbackCheck ? undefined : getSingleCallSignature(getNonNullableType(targetType));
	                var callbacks = sourceSig && targetSig && !signatureHasTypePredicate(sourceSig) && !signatureHasTypePredicate(targetSig) &&
	                    (getFalsyFlags(sourceType) & 12288 /* Nullable */) === (getFalsyFlags(targetType) & 12288 /* Nullable */);
	                var related = callbacks ?
	                    compareSignaturesRelated(targetSig, sourceSig, strictVariance ? 2 /* Strict */ : 1 /* Bivariant */, /*ignoreReturnTypes*/ false, reportErrors, errorReporter, compareTypes) :
	                    !callbackCheck && !strictVariance && compareTypes(sourceType, targetType, /*reportErrors*/ false) || compareTypes(targetType, sourceType, reportErrors);
	                if (!related) {
	                    if (reportErrors) {
	                        errorReporter(ts.Diagnostics.Types_of_parameters_0_and_1_are_incompatible, ts.symbolName(sourceParams[i < sourceMax ? i : sourceMax]), ts.symbolName(targetParams[i < targetMax ? i : targetMax]));
	                    }
	                    return 0 /* False */;
	                }
	                result &= related;
	            }
	            if (!ignoreReturnTypes) {
	                var targetReturnType = getReturnTypeOfSignature(target);
	                if (targetReturnType === voidType) {
	                    return result;
	                }
	                var sourceReturnType = getReturnTypeOfSignature(source);
	                // The following block preserves behavior forbidding boolean returning functions from being assignable to type guard returning functions
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                if (targetTypePredicate) {
	                    var sourceTypePredicate = getTypePredicateOfSignature(source);
	                    if (sourceTypePredicate) {
	                        result &= compareTypePredicateRelatedTo(sourceTypePredicate, targetTypePredicate, source.declaration, target.declaration, reportErrors, errorReporter, compareTypes);
	                    }
	                    else if (ts.isIdentifierTypePredicate(targetTypePredicate)) {
	                        if (reportErrors) {
	                            errorReporter(ts.Diagnostics.Signature_0_must_be_a_type_predicate, signatureToString(source));
	                        }
	                        return 0 /* False */;
	                    }
	                }
	                else {
	                    // When relating callback signatures, we still need to relate return types bi-variantly as otherwise
	                    // the containing type wouldn't be co-variant. For example, interface Foo<T> { add(cb: () => T): void }
	                    // wouldn't be co-variant for T without this rule.
	                    result &= callbackCheck === 1 /* Bivariant */ && compareTypes(targetReturnType, sourceReturnType, /*reportErrors*/ false) ||
	                        compareTypes(sourceReturnType, targetReturnType, reportErrors);
	                }
	            }
	            return result;
	        }
	        function compareTypePredicateRelatedTo(source, target, sourceDeclaration, targetDeclaration, reportErrors, errorReporter, compareTypes) {
	            if (source.kind !== target.kind) {
	                if (reportErrors) {
	                    errorReporter(ts.Diagnostics.A_this_based_type_guard_is_not_compatible_with_a_parameter_based_type_guard);
	                    errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	                }
	                return 0 /* False */;
	            }
	            if (source.kind === 1 /* Identifier */) {
	                var targetPredicate = target;
	                var sourceIndex = source.parameterIndex - (ts.getThisParameter(sourceDeclaration) ? 1 : 0);
	                var targetIndex = targetPredicate.parameterIndex - (ts.getThisParameter(targetDeclaration) ? 1 : 0);
	                if (sourceIndex !== targetIndex) {
	                    if (reportErrors) {
	                        errorReporter(ts.Diagnostics.Parameter_0_is_not_in_the_same_position_as_parameter_1, source.parameterName, targetPredicate.parameterName);
	                        errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	                    }
	                    return 0 /* False */;
	                }
	            }
	            var related = compareTypes(source.type, target.type, reportErrors);
	            if (related === 0 /* False */ && reportErrors) {
	                errorReporter(ts.Diagnostics.Type_predicate_0_is_not_assignable_to_1, typePredicateToString(source), typePredicateToString(target));
	            }
	            return related;
	        }
	        function isImplementationCompatibleWithOverload(implementation, overload) {
	            var erasedSource = getErasedSignature(implementation);
	            var erasedTarget = getErasedSignature(overload);
	            // First see if the return types are compatible in either direction.
	            var sourceReturnType = getReturnTypeOfSignature(erasedSource);
	            var targetReturnType = getReturnTypeOfSignature(erasedTarget);
	            if (targetReturnType === voidType
	                || isTypeRelatedTo(targetReturnType, sourceReturnType, assignableRelation)
	                || isTypeRelatedTo(sourceReturnType, targetReturnType, assignableRelation)) {
	                return isSignatureAssignableTo(erasedSource, erasedTarget, /*ignoreReturnTypes*/ true);
	            }
	            return false;
	        }
	        function getNumNonRestParameters(signature) {
	            var numParams = signature.parameters.length;
	            return signature.hasRestParameter ?
	                numParams - 1 :
	                numParams;
	        }
	        function getNumParametersToCheckForSignatureRelatability(source, sourceNonRestParamCount, target, targetNonRestParamCount) {
	            if (source.hasRestParameter === target.hasRestParameter) {
	                if (source.hasRestParameter) {
	                    // If both have rest parameters, get the max and add 1 to
	                    // compensate for the rest parameter.
	                    return Math.max(sourceNonRestParamCount, targetNonRestParamCount) + 1;
	                }
	                else {
	                    return Math.min(sourceNonRestParamCount, targetNonRestParamCount);
	                }
	            }
	            else {
	                // Return the count for whichever signature doesn't have rest parameters.
	                return source.hasRestParameter ?
	                    targetNonRestParamCount :
	                    sourceNonRestParamCount;
	            }
	        }
	        function isEmptyResolvedType(t) {
	            return t.properties.length === 0 &&
	                t.callSignatures.length === 0 &&
	                t.constructSignatures.length === 0 &&
	                !t.stringIndexInfo &&
	                !t.numberIndexInfo;
	        }
	        function isEmptyObjectType(type) {
	            return type.flags & 65536 /* Object */ ? isEmptyResolvedType(resolveStructuredTypeMembers(type)) :
	                type.flags & 134217728 /* NonPrimitive */ ? true :
	                    type.flags & 131072 /* Union */ ? ts.forEach(type.types, isEmptyObjectType) :
	                        type.flags & 262144 /* Intersection */ ? !ts.forEach(type.types, function (t) { return !isEmptyObjectType(t); }) :
	                            false;
	        }
	        function isEnumTypeRelatedTo(sourceSymbol, targetSymbol, errorReporter) {
	            if (sourceSymbol === targetSymbol) {
	                return true;
	            }
	            var id = getSymbolId(sourceSymbol) + "," + getSymbolId(targetSymbol);
	            var relation = enumRelation.get(id);
	            if (relation !== undefined) {
	                return relation;
	            }
	            if (sourceSymbol.escapedName !== targetSymbol.escapedName || !(sourceSymbol.flags & 256 /* RegularEnum */) || !(targetSymbol.flags & 256 /* RegularEnum */)) {
	                enumRelation.set(id, false);
	                return false;
	            }
	            var targetEnumType = getTypeOfSymbol(targetSymbol);
	            for (var _i = 0, _a = getPropertiesOfType(getTypeOfSymbol(sourceSymbol)); _i < _a.length; _i++) {
	                var property = _a[_i];
	                if (property.flags & 8 /* EnumMember */) {
	                    var targetProperty = getPropertyOfType(targetEnumType, property.escapedName);
	                    if (!targetProperty || !(targetProperty.flags & 8 /* EnumMember */)) {
	                        if (errorReporter) {
	                            errorReporter(ts.Diagnostics.Property_0_is_missing_in_type_1, ts.symbolName(property), typeToString(getDeclaredTypeOfSymbol(targetSymbol), /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */));
	                        }
	                        enumRelation.set(id, false);
	                        return false;
	                    }
	                }
	            }
	            enumRelation.set(id, true);
	            return true;
	        }
	        function isSimpleTypeRelatedTo(source, target, relation, errorReporter) {
	            var s = source.flags;
	            var t = target.flags;
	            if (t & 1 /* Any */ || s & 16384 /* Never */ || source === wildcardType)
	                return true;
	            if (t & 16384 /* Never */)
	                return false;
	            if (s & 34 /* StringLike */ && t & 2 /* String */)
	                return true;
	            if (s & 32 /* StringLiteral */ && s & 256 /* EnumLiteral */ &&
	                t & 32 /* StringLiteral */ && !(t & 256 /* EnumLiteral */) &&
	                source.value === target.value)
	                return true;
	            if (s & 84 /* NumberLike */ && t & 4 /* Number */)
	                return true;
	            if (s & 64 /* NumberLiteral */ && s & 256 /* EnumLiteral */ &&
	                t & 64 /* NumberLiteral */ && !(t & 256 /* EnumLiteral */) &&
	                source.value === target.value)
	                return true;
	            if (s & 136 /* BooleanLike */ && t & 8 /* Boolean */)
	                return true;
	            if (s & 1536 /* ESSymbolLike */ && t & 512 /* ESSymbol */)
	                return true;
	            if (s & 16 /* Enum */ && t & 16 /* Enum */ && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter))
	                return true;
	            if (s & 256 /* EnumLiteral */ && t & 256 /* EnumLiteral */) {
	                if (s & 131072 /* Union */ && t & 131072 /* Union */ && isEnumTypeRelatedTo(source.symbol, target.symbol, errorReporter))
	                    return true;
	                if (s & 224 /* Literal */ && t & 224 /* Literal */ &&
	                    source.value === target.value &&
	                    isEnumTypeRelatedTo(getParentOfSymbol(source.symbol), getParentOfSymbol(target.symbol), errorReporter))
	                    return true;
	            }
	            if (s & 4096 /* Undefined */ && (!strictNullChecks || t & (4096 /* Undefined */ | 2048 /* Void */)))
	                return true;
	            if (s & 8192 /* Null */ && (!strictNullChecks || t & 8192 /* Null */))
	                return true;
	            if (s & 65536 /* Object */ && t & 134217728 /* NonPrimitive */)
	                return true;
	            if (s & 1024 /* UniqueESSymbol */ || t & 1024 /* UniqueESSymbol */)
	                return false;
	            if (relation === assignableRelation || relation === definitelyAssignableRelation || relation === comparableRelation) {
	                if (s & 1 /* Any */)
	                    return true;
	                // Type number or any numeric literal type is assignable to any numeric enum type or any
	                // numeric enum literal type. This rule exists for backwards compatibility reasons because
	                // bit-flag enum types sometimes look like literal enum types with numeric literal values.
	                if (s & (4 /* Number */ | 64 /* NumberLiteral */) && !(s & 256 /* EnumLiteral */) && (t & 16 /* Enum */ || t & 64 /* NumberLiteral */ && t & 256 /* EnumLiteral */))
	                    return true;
	            }
	            return false;
	        }
	        function isTypeRelatedTo(source, target, relation) {
	            if (source.flags & 96 /* StringOrNumberLiteral */ && source.flags & 8388608 /* FreshLiteral */) {
	                source = source.regularType;
	            }
	            if (target.flags & 96 /* StringOrNumberLiteral */ && target.flags & 8388608 /* FreshLiteral */) {
	                target = target.regularType;
	            }
	            if (source === target ||
	                relation === comparableRelation && !(target.flags & 16384 /* Never */) && isSimpleTypeRelatedTo(target, source, relation) ||
	                relation !== identityRelation && isSimpleTypeRelatedTo(source, target, relation)) {
	                return true;
	            }
	            if (source.flags & 65536 /* Object */ && target.flags & 65536 /* Object */) {
	                var related = relation.get(getRelationKey(source, target, relation));
	                if (related !== undefined) {
	                    return related === 1 /* Succeeded */;
	                }
	            }
	            if (source.flags & 8355840 /* StructuredOrInstantiable */ || target.flags & 8355840 /* StructuredOrInstantiable */) {
	                return checkTypeRelatedTo(source, target, relation, /*errorNode*/ undefined);
	            }
	            return false;
	        }
	        function isIgnoredJsxProperty(source, sourceProp, targetMemberType) {
	            return ts.getObjectFlags(source) & 4096 /* JsxAttributes */ && !(isUnhyphenatedJsxName(sourceProp.escapedName) || targetMemberType);
	        }
	        /**
	         * Checks if 'source' is related to 'target' (e.g.: is a assignable to).
	         * @param source The left-hand-side of the relation.
	         * @param target The right-hand-side of the relation.
	         * @param relation The relation considered. One of 'identityRelation', 'subtypeRelation', 'assignableRelation', or 'comparableRelation'.
	         * Used as both to determine which checks are performed and as a cache of previously computed results.
	         * @param errorNode The suggested node upon which all errors will be reported, if defined. This may or may not be the actual node used.
	         * @param headMessage If the error chain should be prepended by a head message, then headMessage will be used.
	         * @param containingMessageChain A chain of errors to prepend any new errors found.
	         */
	        function checkTypeRelatedTo(source, target, relation, errorNode, headMessage, containingMessageChain) {
	            var errorInfo;
	            var maybeKeys;
	            var sourceStack;
	            var targetStack;
	            var maybeCount = 0;
	            var depth = 0;
	            var expandingFlags = 0 /* None */;
	            var overflow = false;
	            var isIntersectionConstituent = false;
	            ts.Debug.assert(relation !== identityRelation || !errorNode, "no error reporting in identity checking");
	            var result = isRelatedTo(source, target, /*reportErrors*/ !!errorNode, headMessage);
	            if (overflow) {
	                error(errorNode, ts.Diagnostics.Excessive_stack_depth_comparing_types_0_and_1, typeToString(source), typeToString(target));
	            }
	            else if (errorInfo) {
	                if (containingMessageChain) {
	                    var chain_1 = containingMessageChain();
	                    if (chain_1) {
	                        errorInfo = ts.concatenateDiagnosticMessageChains(chain_1, errorInfo);
	                    }
	                }
	                diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(errorNode, errorInfo));
	            }
	            // Check if we should issue an extra diagnostic to produce a quickfix for a slightly incorrect import statement
	            if (headMessage && errorNode && !result && source.symbol) {
	                var links = getSymbolLinks(source.symbol);
	                if (links.originatingImport && !ts.isImportCall(links.originatingImport)) {
	                    var helpfulRetry = checkTypeRelatedTo(getTypeOfSymbol(links.target), target, relation, /*errorNode*/ undefined);
	                    if (helpfulRetry) {
	                        // Likely an incorrect import. Issue a helpful diagnostic to produce a quickfix to change the import
	                        diagnostics.add(ts.createDiagnosticForNode(links.originatingImport, ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime));
	                    }
	                }
	            }
	            return result !== 0 /* False */;
	            function reportError(message, arg0, arg1, arg2) {
	                ts.Debug.assert(!!errorNode);
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, message, arg0, arg1, arg2);
	            }
	            function reportRelationError(message, source, target) {
	                var sourceType = typeToString(source);
	                var targetType = typeToString(target);
	                if (sourceType === targetType) {
	                    sourceType = typeToString(source, /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */);
	                    targetType = typeToString(target, /*enclosingDeclaration*/ undefined, 64 /* UseFullyQualifiedType */);
	                }
	                if (!message) {
	                    if (relation === comparableRelation) {
	                        message = ts.Diagnostics.Type_0_is_not_comparable_to_type_1;
	                    }
	                    else if (sourceType === targetType) {
	                        message = ts.Diagnostics.Type_0_is_not_assignable_to_type_1_Two_different_types_with_this_name_exist_but_they_are_unrelated;
	                    }
	                    else {
	                        message = ts.Diagnostics.Type_0_is_not_assignable_to_type_1;
	                    }
	                }
	                reportError(message, sourceType, targetType);
	            }
	            function tryElaborateErrorsForPrimitivesAndObjects(source, target) {
	                var sourceType = typeToString(source);
	                var targetType = typeToString(target);
	                if ((globalStringType === source && stringType === target) ||
	                    (globalNumberType === source && numberType === target) ||
	                    (globalBooleanType === source && booleanType === target) ||
	                    (getGlobalESSymbolType(/*reportErrors*/ false) === source && esSymbolType === target)) {
	                    reportError(ts.Diagnostics._0_is_a_primitive_but_1_is_a_wrapper_object_Prefer_using_0_when_possible, targetType, sourceType);
	                }
	            }
	            function isUnionOrIntersectionTypeWithoutNullableConstituents(type) {
	                if (!(type.flags & 393216 /* UnionOrIntersection */)) {
	                    return false;
	                }
	                // at this point we know that this is union or intersection type possibly with nullable constituents.
	                // check if we still will have compound type if we ignore nullable components.
	                var seenNonNullable = false;
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (t.flags & 12288 /* Nullable */) {
	                        continue;
	                    }
	                    if (seenNonNullable) {
	                        return true;
	                    }
	                    seenNonNullable = true;
	                }
	                return false;
	            }
	            /**
	             * Compare two types and return
	             * * Ternary.True if they are related with no assumptions,
	             * * Ternary.Maybe if they are related with assumptions of other relationships, or
	             * * Ternary.False if they are not related.
	             */
	            function isRelatedTo(source, target, reportErrors, headMessage) {
	                if (source.flags & 96 /* StringOrNumberLiteral */ && source.flags & 8388608 /* FreshLiteral */) {
	                    source = source.regularType;
	                }
	                if (target.flags & 96 /* StringOrNumberLiteral */ && target.flags & 8388608 /* FreshLiteral */) {
	                    target = target.regularType;
	                }
	                if (source.flags & 4194304 /* Substitution */) {
	                    source = relation === definitelyAssignableRelation ? source.typeVariable : source.substitute;
	                }
	                if (target.flags & 4194304 /* Substitution */) {
	                    target = target.typeVariable;
	                }
	                if (source.flags & 1048576 /* IndexedAccess */) {
	                    source = getSimplifiedType(source);
	                }
	                if (target.flags & 1048576 /* IndexedAccess */) {
	                    target = getSimplifiedType(target);
	                }
	                // both types are the same - covers 'they are the same primitive type or both are Any' or the same type parameter cases
	                if (source === target)
	                    return -1 /* True */;
	                if (relation === identityRelation) {
	                    return isIdenticalTo(source, target);
	                }
	                if (relation === comparableRelation && !(target.flags & 16384 /* Never */) && isSimpleTypeRelatedTo(target, source, relation) ||
	                    isSimpleTypeRelatedTo(source, target, relation, reportErrors ? reportError : undefined))
	                    return -1 /* True */;
	                if (isObjectLiteralType(source) && source.flags & 8388608 /* FreshLiteral */) {
	                    var discriminantType = target.flags & 131072 /* Union */ ? findMatchingDiscriminantType(source, target) : undefined;
	                    if (hasExcessProperties(source, target, discriminantType, reportErrors)) {
	                        if (reportErrors) {
	                            reportRelationError(headMessage, source, target);
	                        }
	                        return 0 /* False */;
	                    }
	                    // Above we check for excess properties with respect to the entire target type. When union
	                    // and intersection types are further deconstructed on the target side, we don't want to
	                    // make the check again (as it might fail for a partial target type). Therefore we obtain
	                    // the regular source type and proceed with that.
	                    if (isUnionOrIntersectionTypeWithoutNullableConstituents(target) && !discriminantType) {
	                        source = getRegularTypeOfObjectLiteral(source);
	                    }
	                }
	                if (relation !== comparableRelation &&
	                    !(source.flags & 393216 /* UnionOrIntersection */) &&
	                    !(target.flags & 131072 /* Union */) &&
	                    !isIntersectionConstituent &&
	                    source !== globalObjectType &&
	                    (getPropertiesOfType(source).length > 0 || typeHasCallOrConstructSignatures(source)) &&
	                    isWeakType(target) &&
	                    !hasCommonProperties(source, target)) {
	                    if (reportErrors) {
	                        var calls = getSignaturesOfType(source, 0 /* Call */);
	                        var constructs = getSignaturesOfType(source, 1 /* Construct */);
	                        if (calls.length > 0 && isRelatedTo(getReturnTypeOfSignature(calls[0]), target, /*reportErrors*/ false) ||
	                            constructs.length > 0 && isRelatedTo(getReturnTypeOfSignature(constructs[0]), target, /*reportErrors*/ false)) {
	                            reportError(ts.Diagnostics.Value_of_type_0_has_no_properties_in_common_with_type_1_Did_you_mean_to_call_it, typeToString(source), typeToString(target));
	                        }
	                        else {
	                            reportError(ts.Diagnostics.Type_0_has_no_properties_in_common_with_type_1, typeToString(source), typeToString(target));
	                        }
	                    }
	                    return 0 /* False */;
	                }
	                var result = 0 /* False */;
	                var saveErrorInfo = errorInfo;
	                var saveIsIntersectionConstituent = isIntersectionConstituent;
	                isIntersectionConstituent = false;
	                // Note that these checks are specifically ordered to produce correct results. In particular,
	                // we need to deconstruct unions before intersections (because unions are always at the top),
	                // and we need to handle "each" relations before "some" relations for the same kind of type.
	                if (source.flags & 131072 /* Union */) {
	                    result = relation === comparableRelation ?
	                        someTypeRelatedToType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */)) :
	                        eachTypeRelatedToType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */));
	                }
	                else {
	                    if (target.flags & 131072 /* Union */) {
	                        result = typeRelatedToSomeType(source, target, reportErrors && !(source.flags & 16382 /* Primitive */) && !(target.flags & 16382 /* Primitive */));
	                    }
	                    else if (target.flags & 262144 /* Intersection */) {
	                        isIntersectionConstituent = true;
	                        result = typeRelatedToEachType(source, target, reportErrors);
	                    }
	                    else if (source.flags & 262144 /* Intersection */) {
	                        // Check to see if any constituents of the intersection are immediately related to the target.
	                        //
	                        // Don't report errors though. Checking whether a constituent is related to the source is not actually
	                        // useful and leads to some confusing error messages. Instead it is better to let the below checks
	                        // take care of this, or to not elaborate at all. For instance,
	                        //
	                        //    - For an object type (such as 'C = A & B'), users are usually more interested in structural errors.
	                        //
	                        //    - For a union type (such as '(A | B) = (C & D)'), it's better to hold onto the whole intersection
	                        //          than to report that 'D' is not assignable to 'A' or 'B'.
	                        //
	                        //    - For a primitive type or type parameter (such as 'number = A & B') there is no point in
	                        //          breaking the intersection apart.
	                        result = someTypeRelatedToType(source, target, /*reportErrors*/ false);
	                    }
	                    if (!result && (source.flags & 8355840 /* StructuredOrInstantiable */ || target.flags & 8355840 /* StructuredOrInstantiable */)) {
	                        if (result = recursiveTypeRelatedTo(source, target, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                        }
	                    }
	                }
	                if (!result && source.flags & 262144 /* Intersection */) {
	                    // The combined constraint of an intersection type is the intersection of the constraints of
	                    // the constituents. When an intersection type contains instantiable types with union type
	                    // constraints, there are situations where we need to examine the combined constraint. One is
	                    // when the target is a union type. Another is when the intersection contains types belonging
	                    // to one of the disjoint domains. For example, given type variables T and U, each with the
	                    // constraint 'string | number', the combined constraint of 'T & U' is 'string | number' and
	                    // we need to check this constraint against a union on the target side. Also, given a type
	                    // variable V constrained to 'string | number', 'V & number' has a combined constraint of
	                    // 'string & number | number & number' which reduces to just 'number'.
	                    var constraint = getUnionConstraintOfIntersection(source, !!(target.flags & 131072 /* Union */));
	                    if (constraint) {
	                        if (result = isRelatedTo(constraint, target, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                        }
	                    }
	                }
	                isIntersectionConstituent = saveIsIntersectionConstituent;
	                if (!result && reportErrors) {
	                    if (source.flags & 65536 /* Object */ && target.flags & 16382 /* Primitive */) {
	                        tryElaborateErrorsForPrimitivesAndObjects(source, target);
	                    }
	                    else if (source.symbol && source.flags & 65536 /* Object */ && globalObjectType === source) {
	                        reportError(ts.Diagnostics.The_Object_type_is_assignable_to_very_few_other_types_Did_you_mean_to_use_the_any_type_instead);
	                    }
	                    reportRelationError(headMessage, source, target);
	                }
	                return result;
	            }
	            function isIdenticalTo(source, target) {
	                var result;
	                var flags = source.flags & target.flags;
	                if (flags & 65536 /* Object */) {
	                    return recursiveTypeRelatedTo(source, target, /*reportErrors*/ false);
	                }
	                if (flags & (131072 /* Union */ | 262144 /* Intersection */)) {
	                    if (result = eachTypeRelatedToSomeType(source, target)) {
	                        if (result &= eachTypeRelatedToSomeType(target, source)) {
	                            return result;
	                        }
	                    }
	                }
	                if (flags & 524288 /* Index */) {
	                    return isRelatedTo(source.type, target.type, /*reportErrors*/ false);
	                }
	                if (flags & 1048576 /* IndexedAccess */) {
	                    if (result = isRelatedTo(source.objectType, target.objectType, /*reportErrors*/ false)) {
	                        if (result &= isRelatedTo(source.indexType, target.indexType, /*reportErrors*/ false)) {
	                            return result;
	                        }
	                    }
	                }
	                if (flags & 2097152 /* Conditional */) {
	                    if (source.root.isDistributive === target.root.isDistributive) {
	                        if (result = isRelatedTo(source.checkType, target.checkType, /*reportErrors*/ false)) {
	                            if (result &= isRelatedTo(source.extendsType, target.extendsType, /*reportErrors*/ false)) {
	                                if (result &= isRelatedTo(getTrueTypeFromConditionalType(source), getTrueTypeFromConditionalType(target), /*reportErrors*/ false)) {
	                                    if (result &= isRelatedTo(getFalseTypeFromConditionalType(source), getFalseTypeFromConditionalType(target), /*reportErrors*/ false)) {
	                                        return result;
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                if (flags & 4194304 /* Substitution */) {
	                    return isRelatedTo(source.substitute, target.substitute, /*reportErrors*/ false);
	                }
	                return 0 /* False */;
	            }
	            function hasExcessProperties(source, target, discriminant, reportErrors) {
	                if (maybeTypeOfKind(target, 65536 /* Object */) && !(ts.getObjectFlags(target) & 512 /* ObjectLiteralPatternWithComputedProperties */)) {
	                    var isComparingJsxAttributes = !!(ts.getObjectFlags(source) & 4096 /* JsxAttributes */);
	                    if ((relation === assignableRelation || relation === definitelyAssignableRelation || relation === comparableRelation) &&
	                        (isTypeSubsetOf(globalObjectType, target) || (!isComparingJsxAttributes && isEmptyObjectType(target)))) {
	                        return false;
	                    }
	                    if (discriminant) {
	                        // check excess properties against discriminant type only, not the entire union
	                        return hasExcessProperties(source, discriminant, /*discriminant*/ undefined, reportErrors);
	                    }
	                    var _loop_6 = function (prop) {
	                        if (!isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) {
	                            if (reportErrors) {
	                                // We know *exactly* where things went wrong when comparing the types.
	                                // Use this property as the error node as this will be more helpful in
	                                // reasoning about what went wrong.
	                                ts.Debug.assert(!!errorNode);
	                                if (ts.isJsxAttributes(errorNode) || ts.isJsxOpeningLikeElement(errorNode)) {
	                                    // JsxAttributes has an object-literal flag and undergo same type-assignablity check as normal object-literal.
	                                    // However, using an object-literal error message will be very confusing to the users so we give different a message.
	                                    reportError(ts.Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(prop), typeToString(target));
	                                }
	                                else {
	                                    // use the property's value declaration if the property is assigned inside the literal itself
	                                    var objectLiteralDeclaration_1 = source.symbol && ts.firstOrUndefined(source.symbol.declarations);
	                                    var suggestion = void 0;
	                                    if (prop.valueDeclaration && ts.findAncestor(prop.valueDeclaration, function (d) { return d === objectLiteralDeclaration_1; })) {
	                                        var propDeclaration = prop.valueDeclaration;
	                                        ts.Debug.assertNode(propDeclaration, ts.isObjectLiteralElementLike);
	                                        errorNode = propDeclaration;
	                                        if (ts.isIdentifier(propDeclaration.name)) {
	                                            suggestion = getSuggestionForNonexistentProperty(propDeclaration.name, target);
	                                        }
	                                    }
	                                    if (suggestion !== undefined) {
	                                        reportError(ts.Diagnostics.Object_literal_may_only_specify_known_properties_but_0_does_not_exist_in_type_1_Did_you_mean_to_write_2, symbolToString(prop), typeToString(target), suggestion);
	                                    }
	                                    else {
	                                        reportError(ts.Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(prop), typeToString(target));
	                                    }
	                                }
	                            }
	                            return { value: true };
	                        }
	                    };
	                    for (var _i = 0, _a = getPropertiesOfObjectType(source); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        var state_3 = _loop_6(prop);
	                        if (typeof state_3 === "object")
	                            return state_3.value;
	                    }
	                }
	                return false;
	            }
	            function eachTypeRelatedToSomeType(source, target) {
	                var result = -1 /* True */;
	                var sourceTypes = source.types;
	                for (var _i = 0, sourceTypes_1 = sourceTypes; _i < sourceTypes_1.length; _i++) {
	                    var sourceType = sourceTypes_1[_i];
	                    var related = typeRelatedToSomeType(sourceType, target, /*reportErrors*/ false);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function typeRelatedToSomeType(source, target, reportErrors) {
	                var targetTypes = target.types;
	                if (target.flags & 131072 /* Union */ && containsType(targetTypes, source)) {
	                    return -1 /* True */;
	                }
	                for (var _i = 0, targetTypes_1 = targetTypes; _i < targetTypes_1.length; _i++) {
	                    var type = targetTypes_1[_i];
	                    var related = isRelatedTo(source, type, /*reportErrors*/ false);
	                    if (related) {
	                        return related;
	                    }
	                }
	                if (reportErrors) {
	                    var discriminantType = findMatchingDiscriminantType(source, target);
	                    isRelatedTo(source, discriminantType || targetTypes[targetTypes.length - 1], /*reportErrors*/ true);
	                }
	                return 0 /* False */;
	            }
	            // Keep this up-to-date with the same logic within `getApparentTypeOfContextualType`, since they should behave similarly
	            function findMatchingDiscriminantType(source, target) {
	                var match;
	                var sourceProperties = getPropertiesOfObjectType(source);
	                if (sourceProperties) {
	                    var sourcePropertiesFiltered = findDiscriminantProperties(sourceProperties, target);
	                    if (sourcePropertiesFiltered) {
	                        for (var _i = 0, sourcePropertiesFiltered_1 = sourcePropertiesFiltered; _i < sourcePropertiesFiltered_1.length; _i++) {
	                            var sourceProperty = sourcePropertiesFiltered_1[_i];
	                            var sourceType = getTypeOfSymbol(sourceProperty);
	                            for (var _a = 0, _b = target.types; _a < _b.length; _a++) {
	                                var type = _b[_a];
	                                var targetType = getTypeOfPropertyOfType(type, sourceProperty.escapedName);
	                                if (targetType && isRelatedTo(sourceType, targetType)) {
	                                    if (type === match)
	                                        continue; // Finding multiple fields which discriminate to the same type is fine
	                                    if (match) {
	                                        return undefined;
	                                    }
	                                    match = type;
	                                }
	                            }
	                        }
	                    }
	                }
	                return match;
	            }
	            function typeRelatedToEachType(source, target, reportErrors) {
	                var result = -1 /* True */;
	                var targetTypes = target.types;
	                for (var _i = 0, targetTypes_2 = targetTypes; _i < targetTypes_2.length; _i++) {
	                    var targetType = targetTypes_2[_i];
	                    var related = isRelatedTo(source, targetType, reportErrors);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function someTypeRelatedToType(source, target, reportErrors) {
	                var sourceTypes = source.types;
	                if (source.flags & 131072 /* Union */ && containsType(sourceTypes, target)) {
	                    return -1 /* True */;
	                }
	                var len = sourceTypes.length;
	                for (var i = 0; i < len; i++) {
	                    var related = isRelatedTo(sourceTypes[i], target, reportErrors && i === len - 1);
	                    if (related) {
	                        return related;
	                    }
	                }
	                return 0 /* False */;
	            }
	            function eachTypeRelatedToType(source, target, reportErrors) {
	                var result = -1 /* True */;
	                var sourceTypes = source.types;
	                for (var _i = 0, sourceTypes_2 = sourceTypes; _i < sourceTypes_2.length; _i++) {
	                    var sourceType = sourceTypes_2[_i];
	                    var related = isRelatedTo(sourceType, target, reportErrors);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function typeArgumentsRelatedTo(source, target, variances, reportErrors) {
	                var sources = source.typeArguments || ts.emptyArray;
	                var targets = target.typeArguments || ts.emptyArray;
	                if (sources.length !== targets.length && relation === identityRelation) {
	                    return 0 /* False */;
	                }
	                var length = sources.length <= targets.length ? sources.length : targets.length;
	                var result = -1 /* True */;
	                for (var i = 0; i < length; i++) {
	                    // When variance information isn't available we default to covariance. This happens
	                    // in the process of computing variance information for recursive types and when
	                    // comparing 'this' type arguments.
	                    var variance = i < variances.length ? variances[i] : 1 /* Covariant */;
	                    // We ignore arguments for independent type parameters (because they're never witnessed).
	                    if (variance !== 4 /* Independent */) {
	                        var s = sources[i];
	                        var t = targets[i];
	                        var related = -1 /* True */;
	                        if (variance === 1 /* Covariant */) {
	                            related = isRelatedTo(s, t, reportErrors);
	                        }
	                        else if (variance === 2 /* Contravariant */) {
	                            related = isRelatedTo(t, s, reportErrors);
	                        }
	                        else if (variance === 3 /* Bivariant */) {
	                            // In the bivariant case we first compare contravariantly without reporting
	                            // errors. Then, if that doesn't succeed, we compare covariantly with error
	                            // reporting. Thus, error elaboration will be based on the the covariant check,
	                            // which is generally easier to reason about.
	                            related = isRelatedTo(t, s, /*reportErrors*/ false);
	                            if (!related) {
	                                related = isRelatedTo(s, t, reportErrors);
	                            }
	                        }
	                        else {
	                            // In the invariant case we first compare covariantly, and only when that
	                            // succeeds do we proceed to compare contravariantly. Thus, error elaboration
	                            // will typically be based on the covariant check.
	                            related = isRelatedTo(s, t, reportErrors);
	                            if (related) {
	                                related &= isRelatedTo(t, s, reportErrors);
	                            }
	                        }
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                return result;
	            }
	            // Determine if possibly recursive types are related. First, check if the result is already available in the global cache.
	            // Second, check if we have already started a comparison of the given two types in which case we assume the result to be true.
	            // Third, check if both types are part of deeply nested chains of generic type instantiations and if so assume the types are
	            // equal and infinitely expanding. Fourth, if we have reached a depth of 100 nested comparisons, assume we have runaway recursion
	            // and issue an error. Otherwise, actually compare the structure of the two types.
	            function recursiveTypeRelatedTo(source, target, reportErrors) {
	                if (overflow) {
	                    return 0 /* False */;
	                }
	                var id = getRelationKey(source, target, relation);
	                var related = relation.get(id);
	                if (related !== undefined) {
	                    if (reportErrors && related === 2 /* Failed */) {
	                        // We are elaborating errors and the cached result is an unreported failure. Record the result as a reported
	                        // failure and continue computing the relation such that errors get reported.
	                        relation.set(id, 3 /* FailedAndReported */);
	                    }
	                    else {
	                        return related === 1 /* Succeeded */ ? -1 /* True */ : 0 /* False */;
	                    }
	                }
	                if (!maybeKeys) {
	                    maybeKeys = [];
	                    sourceStack = [];
	                    targetStack = [];
	                }
	                else {
	                    for (var i = 0; i < maybeCount; i++) {
	                        // If source and target are already being compared, consider them related with assumptions
	                        if (id === maybeKeys[i]) {
	                            return 1 /* Maybe */;
	                        }
	                    }
	                    if (depth === 100) {
	                        overflow = true;
	                        return 0 /* False */;
	                    }
	                }
	                var maybeStart = maybeCount;
	                maybeKeys[maybeCount] = id;
	                maybeCount++;
	                sourceStack[depth] = source;
	                targetStack[depth] = target;
	                depth++;
	                var saveExpandingFlags = expandingFlags;
	                if (!(expandingFlags & 1 /* Source */) && isDeeplyNestedType(source, sourceStack, depth))
	                    expandingFlags |= 1 /* Source */;
	                if (!(expandingFlags & 2 /* Target */) && isDeeplyNestedType(target, targetStack, depth))
	                    expandingFlags |= 2 /* Target */;
	                var result = expandingFlags !== 3 /* Both */ ? structuredTypeRelatedTo(source, target, reportErrors) : 1 /* Maybe */;
	                expandingFlags = saveExpandingFlags;
	                depth--;
	                if (result) {
	                    if (result === -1 /* True */ || depth === 0) {
	                        // If result is definitely true, record all maybe keys as having succeeded
	                        for (var i = maybeStart; i < maybeCount; i++) {
	                            relation.set(maybeKeys[i], 1 /* Succeeded */);
	                        }
	                        maybeCount = maybeStart;
	                    }
	                }
	                else {
	                    // A false result goes straight into global cache (when something is false under
	                    // assumptions it will also be false without assumptions)
	                    relation.set(id, reportErrors ? 3 /* FailedAndReported */ : 2 /* Failed */);
	                    maybeCount = maybeStart;
	                }
	                return result;
	            }
	            function getConstraintForRelation(type) {
	                return relation === definitelyAssignableRelation ? undefined : getConstraintOfType(type);
	            }
	            function structuredTypeRelatedTo(source, target, reportErrors) {
	                var result;
	                var originalErrorInfo;
	                var saveErrorInfo = errorInfo;
	                if (target.flags & 32768 /* TypeParameter */) {
	                    // A source type { [P in keyof T]: X } is related to a target type T if X is related to T[P].
	                    if (ts.getObjectFlags(source) & 32 /* Mapped */ && getConstraintTypeFromMappedType(source) === getIndexType(target)) {
	                        if (!(getMappedTypeModifiers(source) & 4 /* IncludeOptional */)) {
	                            var templateType = getTemplateTypeFromMappedType(source);
	                            var indexedAccessType = getIndexedAccessType(target, getTypeParameterFromMappedType(source));
	                            if (result = isRelatedTo(templateType, indexedAccessType, reportErrors)) {
	                                return result;
	                            }
	                        }
	                    }
	                }
	                else if (target.flags & 524288 /* Index */) {
	                    // A keyof S is related to a keyof T if T is related to S.
	                    if (source.flags & 524288 /* Index */) {
	                        if (result = isRelatedTo(target.type, source.type, /*reportErrors*/ false)) {
	                            return result;
	                        }
	                    }
	                    // A type S is assignable to keyof T if S is assignable to keyof C, where C is the
	                    // simplified form of T or, if T doesn't simplify, the constraint of T.
	                    if (relation !== definitelyAssignableRelation) {
	                        var simplified = getSimplifiedType(target.type);
	                        var constraint = simplified !== target.type ? simplified : getConstraintOfType(target.type);
	                        if (constraint) {
	                            if (result = isRelatedTo(source, getIndexType(constraint, target.stringsOnly), reportErrors)) {
	                                return result;
	                            }
	                        }
	                    }
	                }
	                else if (target.flags & 1048576 /* IndexedAccess */) {
	                    // A type S is related to a type T[K] if S is related to C, where C is the
	                    // constraint of T[K]
	                    var constraint = getConstraintForRelation(target);
	                    if (constraint) {
	                        if (result = isRelatedTo(source, constraint, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                }
	                else if (isGenericMappedType(target)) {
	                    // A source type T is related to a target type { [P in X]: T[P] }
	                    var template = getTemplateTypeFromMappedType(target);
	                    var modifiers = getMappedTypeModifiers(target);
	                    if (!(modifiers & 8 /* ExcludeOptional */)) {
	                        if (template.flags & 1048576 /* IndexedAccess */ && template.objectType === source &&
	                            template.indexType === getTypeParameterFromMappedType(target)) {
	                            return -1 /* True */;
	                        }
	                        // A source type T is related to a target type { [P in keyof T]: X } if T[P] is related to X.
	                        if (!isGenericMappedType(source) && getConstraintTypeFromMappedType(target) === getIndexType(source)) {
	                            var indexedAccessType = getIndexedAccessType(source, getTypeParameterFromMappedType(target));
	                            var templateType = getTemplateTypeFromMappedType(target);
	                            if (result = isRelatedTo(indexedAccessType, templateType, reportErrors)) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                }
	                if (source.flags & 1081344 /* TypeVariable */) {
	                    if (source.flags & 1048576 /* IndexedAccess */ && target.flags & 1048576 /* IndexedAccess */) {
	                        // A type S[K] is related to a type T[J] if S is related to T and K is related to J.
	                        if (result = isRelatedTo(source.objectType, target.objectType, reportErrors)) {
	                            result &= isRelatedTo(source.indexType, target.indexType, reportErrors);
	                        }
	                        if (result) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                    var constraint = getConstraintForRelation(source);
	                    if (!constraint || (source.flags & 32768 /* TypeParameter */ && constraint.flags & 1 /* Any */)) {
	                        // A type variable with no constraint is not related to the non-primitive object type.
	                        if (result = isRelatedTo(emptyObjectType, extractTypesOfKind(target, ~134217728 /* NonPrimitive */))) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                    else {
	                        var instantiated = getTypeWithThisArgument(constraint, source);
	                        if (result = isRelatedTo(instantiated, target, reportErrors)) {
	                            errorInfo = saveErrorInfo;
	                            return result;
	                        }
	                    }
	                }
	                else if (source.flags & 524288 /* Index */) {
	                    if (result = isRelatedTo(keyofConstraintType, target, reportErrors)) {
	                        errorInfo = saveErrorInfo;
	                        return result;
	                    }
	                }
	                else if (source.flags & 2097152 /* Conditional */) {
	                    if (target.flags & 2097152 /* Conditional */) {
	                        // Two conditional types 'T1 extends U1 ? X1 : Y1' and 'T2 extends U2 ? X2 : Y2' are related if
	                        // one of T1 and T2 is related to the other, U1 and U2 are identical types, X1 is related to X2,
	                        // and Y1 is related to Y2.
	                        if (isTypeIdenticalTo(source.extendsType, target.extendsType) &&
	                            (isRelatedTo(source.checkType, target.checkType) || isRelatedTo(target.checkType, source.checkType))) {
	                            if (result = isRelatedTo(getTrueTypeFromConditionalType(source), getTrueTypeFromConditionalType(target), reportErrors)) {
	                                result &= isRelatedTo(getFalseTypeFromConditionalType(source), getFalseTypeFromConditionalType(target), reportErrors);
	                            }
	                            if (result) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                    else if (relation !== definitelyAssignableRelation) {
	                        var distributiveConstraint = getConstraintOfDistributiveConditionalType(source);
	                        if (distributiveConstraint) {
	                            if (result = isRelatedTo(distributiveConstraint, target, reportErrors)) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                        var defaultConstraint = getDefaultConstraintOfConditionalType(source);
	                        if (defaultConstraint) {
	                            if (result = isRelatedTo(defaultConstraint, target, reportErrors)) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                        }
	                    }
	                }
	                else {
	                    if (ts.getObjectFlags(source) & 4 /* Reference */ && ts.getObjectFlags(target) & 4 /* Reference */ && source.target === target.target &&
	                        !(ts.getObjectFlags(source) & 8192 /* MarkerType */ || ts.getObjectFlags(target) & 8192 /* MarkerType */)) {
	                        // We have type references to the same generic type, and the type references are not marker
	                        // type references (which are intended by be compared structurally). Obtain the variance
	                        // information for the type parameters and relate the type arguments accordingly.
	                        var variances = getVariances(source.target);
	                        if (result = typeArgumentsRelatedTo(source, target, variances, reportErrors)) {
	                            return result;
	                        }
	                        // The type arguments did not relate appropriately, but it may be because we have no variance
	                        // information (in which case typeArgumentsRelatedTo defaulted to covariance for all type
	                        // arguments). It might also be the case that the target type has a 'void' type argument for
	                        // a covariant type parameter that is only used in return positions within the generic type
	                        // (in which case any type argument is permitted on the source side). In those cases we proceed
	                        // with a structural comparison. Otherwise, we know for certain the instantiations aren't
	                        // related and we can return here.
	                        if (variances !== ts.emptyArray && !hasCovariantVoidArgument(target, variances)) {
	                            // In some cases generic types that are covariant in regular type checking mode become
	                            // invariant in --strictFunctionTypes mode because one or more type parameters are used in
	                            // both co- and contravariant positions. In order to make it easier to diagnose *why* such
	                            // types are invariant, if any of the type parameters are invariant we reset the reported
	                            // errors and instead force a structural comparison (which will include elaborations that
	                            // reveal the reason).
	                            if (!(reportErrors && ts.some(variances, function (v) { return v === 0 /* Invariant */; }))) {
	                                return 0 /* False */;
	                            }
	                            // We remember the original error information so we can restore it in case the structural
	                            // comparison unexpectedly succeeds. This can happen when the structural comparison result
	                            // is a Ternary.Maybe for example caused by the recursion depth limiter.
	                            originalErrorInfo = errorInfo;
	                            errorInfo = saveErrorInfo;
	                        }
	                    }
	                    // Even if relationship doesn't hold for unions, intersections, or generic type references,
	                    // it may hold in a structural comparison.
	                    var sourceIsPrimitive = !!(source.flags & 16382 /* Primitive */);
	                    if (relation !== identityRelation) {
	                        source = getApparentType(source);
	                    }
	                    // In a check of the form X = A & B, we will have previously checked if A relates to X or B relates
	                    // to X. Failing both of those we want to check if the aggregation of A and B's members structurally
	                    // relates to X. Thus, we include intersection types on the source side here.
	                    if (source.flags & (65536 /* Object */ | 262144 /* Intersection */) && target.flags & 65536 /* Object */) {
	                        // Report structural errors only if we haven't reported any errors yet
	                        var reportStructuralErrors = reportErrors && errorInfo === saveErrorInfo && !sourceIsPrimitive;
	                        // An empty object type is related to any mapped type that includes a '?' modifier.
	                        if (isPartialMappedType(target) && !isGenericMappedType(source) && isEmptyObjectType(source)) {
	                            result = -1 /* True */;
	                        }
	                        else if (isGenericMappedType(target)) {
	                            result = isGenericMappedType(source) ? mappedTypeRelatedTo(source, target, reportStructuralErrors) : 0 /* False */;
	                        }
	                        else {
	                            result = propertiesRelatedTo(source, target, reportStructuralErrors);
	                            if (result) {
	                                result &= signaturesRelatedTo(source, target, 0 /* Call */, reportStructuralErrors);
	                                if (result) {
	                                    result &= signaturesRelatedTo(source, target, 1 /* Construct */, reportStructuralErrors);
	                                    if (result) {
	                                        result &= indexTypesRelatedTo(source, target, 0 /* String */, sourceIsPrimitive, reportStructuralErrors);
	                                        if (result) {
	                                            result &= indexTypesRelatedTo(source, target, 1 /* Number */, sourceIsPrimitive, reportStructuralErrors);
	                                        }
	                                    }
	                                }
	                            }
	                        }
	                        if (result) {
	                            if (!originalErrorInfo) {
	                                errorInfo = saveErrorInfo;
	                                return result;
	                            }
	                            errorInfo = originalErrorInfo;
	                        }
	                    }
	                }
	                return 0 /* False */;
	            }
	            // A type [P in S]: X is related to a type [Q in T]: Y if T is related to S and X' is
	            // related to Y, where X' is an instantiation of X in which P is replaced with Q. Notice
	            // that S and T are contra-variant whereas X and Y are co-variant.
	            function mappedTypeRelatedTo(source, target, reportErrors) {
	                var modifiersRelated = relation === comparableRelation || (relation === identityRelation ? getMappedTypeModifiers(source) === getMappedTypeModifiers(target) :
	                    getCombinedMappedTypeOptionality(source) <= getCombinedMappedTypeOptionality(target));
	                if (modifiersRelated) {
	                    var result_2;
	                    if (result_2 = isRelatedTo(getConstraintTypeFromMappedType(target), getConstraintTypeFromMappedType(source), reportErrors)) {
	                        var mapper = createTypeMapper([getTypeParameterFromMappedType(source)], [getTypeParameterFromMappedType(target)]);
	                        return result_2 & isRelatedTo(instantiateType(getTemplateTypeFromMappedType(source), mapper), getTemplateTypeFromMappedType(target), reportErrors);
	                    }
	                }
	                return 0 /* False */;
	            }
	            function propertiesRelatedTo(source, target, reportErrors) {
	                if (relation === identityRelation) {
	                    return propertiesIdenticalTo(source, target);
	                }
	                var requireOptionalProperties = relation === subtypeRelation && !isObjectLiteralType(source) && !isEmptyArrayLiteralType(source);
	                var unmatchedProperty = getUnmatchedProperty(source, target, requireOptionalProperties);
	                if (unmatchedProperty) {
	                    if (reportErrors) {
	                        reportError(ts.Diagnostics.Property_0_is_missing_in_type_1, symbolToString(unmatchedProperty), typeToString(source));
	                    }
	                    return 0 /* False */;
	                }
	                if (isObjectLiteralType(target)) {
	                    for (var _i = 0, _a = getPropertiesOfType(source); _i < _a.length; _i++) {
	                        var sourceProp = _a[_i];
	                        if (!getPropertyOfObjectType(target, sourceProp.escapedName)) {
	                            var sourceType = getTypeOfSymbol(sourceProp);
	                            if (!(sourceType === undefinedType || sourceType === undefinedWideningType)) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_does_not_exist_on_type_1, symbolToString(sourceProp), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                        }
	                    }
	                }
	                var result = -1 /* True */;
	                var properties = getPropertiesOfObjectType(target);
	                for (var _b = 0, properties_3 = properties; _b < properties_3.length; _b++) {
	                    var targetProp = properties_3[_b];
	                    if (!(targetProp.flags & 4194304 /* Prototype */)) {
	                        var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                        if (sourceProp && sourceProp !== targetProp) {
	                            if (isIgnoredJsxProperty(source, sourceProp, getTypeOfSymbol(targetProp))) {
	                                continue;
	                            }
	                            var sourcePropFlags = ts.getDeclarationModifierFlagsFromSymbol(sourceProp);
	                            var targetPropFlags = ts.getDeclarationModifierFlagsFromSymbol(targetProp);
	                            if (sourcePropFlags & 8 /* Private */ || targetPropFlags & 8 /* Private */) {
	                                var hasDifferingDeclarations = sourceProp.valueDeclaration !== targetProp.valueDeclaration;
	                                if (ts.getCheckFlags(sourceProp) & 256 /* ContainsPrivate */ && hasDifferingDeclarations) {
	                                    if (reportErrors) {
	                                        reportError(ts.Diagnostics.Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1, symbolToString(sourceProp), typeToString(source));
	                                    }
	                                    return 0 /* False */;
	                                }
	                                if (hasDifferingDeclarations) {
	                                    if (reportErrors) {
	                                        if (sourcePropFlags & 8 /* Private */ && targetPropFlags & 8 /* Private */) {
	                                            reportError(ts.Diagnostics.Types_have_separate_declarations_of_a_private_property_0, symbolToString(targetProp));
	                                        }
	                                        else {
	                                            reportError(ts.Diagnostics.Property_0_is_private_in_type_1_but_not_in_type_2, symbolToString(targetProp), typeToString(sourcePropFlags & 8 /* Private */ ? source : target), typeToString(sourcePropFlags & 8 /* Private */ ? target : source));
	                                        }
	                                    }
	                                    return 0 /* False */;
	                                }
	                            }
	                            else if (targetPropFlags & 16 /* Protected */) {
	                                if (!isValidOverrideOf(sourceProp, targetProp)) {
	                                    if (reportErrors) {
	                                        reportError(ts.Diagnostics.Property_0_is_protected_but_type_1_is_not_a_class_derived_from_2, symbolToString(targetProp), typeToString(getDeclaringClass(sourceProp) || source), typeToString(getDeclaringClass(targetProp) || target));
	                                    }
	                                    return 0 /* False */;
	                                }
	                            }
	                            else if (sourcePropFlags & 16 /* Protected */) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_is_protected_in_type_1_but_public_in_type_2, symbolToString(targetProp), typeToString(source), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                            var related = isRelatedTo(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp), reportErrors);
	                            if (!related) {
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Types_of_property_0_are_incompatible, symbolToString(targetProp));
	                                }
	                                return 0 /* False */;
	                            }
	                            result &= related;
	                            // When checking for comparability, be more lenient with optional properties.
	                            if (relation !== comparableRelation && sourceProp.flags & 16777216 /* Optional */ && !(targetProp.flags & 16777216 /* Optional */)) {
	                                // TypeScript 1.0 spec (April 2014): 3.8.3
	                                // S is a subtype of a type T, and T is a supertype of S if ...
	                                // S' and T are object types and, for each member M in T..
	                                // M is a property and S' contains a property N where
	                                // if M is a required property, N is also a required property
	                                // (M - property in T)
	                                // (N - property in S)
	                                if (reportErrors) {
	                                    reportError(ts.Diagnostics.Property_0_is_optional_in_type_1_but_required_in_type_2, symbolToString(targetProp), typeToString(source), typeToString(target));
	                                }
	                                return 0 /* False */;
	                            }
	                        }
	                    }
	                }
	                return result;
	            }
	            /**
	             * A type is 'weak' if it is an object type with at least one optional property
	             * and no required properties, call/construct signatures or index signatures
	             */
	            function isWeakType(type) {
	                if (type.flags & 65536 /* Object */) {
	                    var resolved = resolveStructuredTypeMembers(type);
	                    return resolved.callSignatures.length === 0 && resolved.constructSignatures.length === 0 &&
	                        !resolved.stringIndexInfo && !resolved.numberIndexInfo &&
	                        resolved.properties.length > 0 &&
	                        ts.every(resolved.properties, function (p) { return !!(p.flags & 16777216 /* Optional */); });
	                }
	                if (type.flags & 262144 /* Intersection */) {
	                    return ts.every(type.types, isWeakType);
	                }
	                return false;
	            }
	            function hasCommonProperties(source, target) {
	                var isComparingJsxAttributes = !!(ts.getObjectFlags(source) & 4096 /* JsxAttributes */);
	                for (var _i = 0, _a = getPropertiesOfType(source); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (isKnownProperty(target, prop.escapedName, isComparingJsxAttributes)) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	            function propertiesIdenticalTo(source, target) {
	                if (!(source.flags & 65536 /* Object */ && target.flags & 65536 /* Object */)) {
	                    return 0 /* False */;
	                }
	                var sourceProperties = getPropertiesOfObjectType(source);
	                var targetProperties = getPropertiesOfObjectType(target);
	                if (sourceProperties.length !== targetProperties.length) {
	                    return 0 /* False */;
	                }
	                var result = -1 /* True */;
	                for (var _i = 0, sourceProperties_1 = sourceProperties; _i < sourceProperties_1.length; _i++) {
	                    var sourceProp = sourceProperties_1[_i];
	                    var targetProp = getPropertyOfObjectType(target, sourceProp.escapedName);
	                    if (!targetProp) {
	                        return 0 /* False */;
	                    }
	                    var related = compareProperties(sourceProp, targetProp, isRelatedTo);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function signaturesRelatedTo(source, target, kind, reportErrors) {
	                if (relation === identityRelation) {
	                    return signaturesIdenticalTo(source, target, kind);
	                }
	                if (target === anyFunctionType || source === anyFunctionType) {
	                    return -1 /* True */;
	                }
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                if (kind === 1 /* Construct */ && sourceSignatures.length && targetSignatures.length) {
	                    if (ts.isAbstractConstructorType(source) && !ts.isAbstractConstructorType(target)) {
	                        // An abstract constructor type is not assignable to a non-abstract constructor type
	                        // as it would otherwise be possible to new an abstract class. Note that the assignability
	                        // check we perform for an extends clause excludes construct signatures from the target,
	                        // so this check never proceeds.
	                        if (reportErrors) {
	                            reportError(ts.Diagnostics.Cannot_assign_an_abstract_constructor_type_to_a_non_abstract_constructor_type);
	                        }
	                        return 0 /* False */;
	                    }
	                    if (!constructorVisibilitiesAreCompatible(sourceSignatures[0], targetSignatures[0], reportErrors)) {
	                        return 0 /* False */;
	                    }
	                }
	                var result = -1 /* True */;
	                var saveErrorInfo = errorInfo;
	                if (ts.getObjectFlags(source) & 64 /* Instantiated */ && ts.getObjectFlags(target) & 64 /* Instantiated */ && source.symbol === target.symbol) {
	                    // We have instantiations of the same anonymous type (which typically will be the type of a
	                    // method). Simply do a pairwise comparison of the signatures in the two signature lists instead
	                    // of the much more expensive N * M comparison matrix we explore below. We erase type parameters
	                    // as they are known to always be the same.
	                    for (var i = 0; i < targetSignatures.length; i++) {
	                        var related = signatureRelatedTo(sourceSignatures[i], targetSignatures[i], /*erase*/ true, reportErrors);
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                else if (sourceSignatures.length === 1 && targetSignatures.length === 1) {
	                    // For simple functions (functions with a single signature) we only erase type parameters for
	                    // the comparable relation. Otherwise, if the source signature is generic, we instantiate it
	                    // in the context of the target signature before checking the relationship. Ideally we'd do
	                    // this regardless of the number of signatures, but the potential costs are prohibitive due
	                    // to the quadratic nature of the logic below.
	                    var eraseGenerics = relation === comparableRelation || compilerOptions.noStrictGenericChecks;
	                    result = signatureRelatedTo(sourceSignatures[0], targetSignatures[0], eraseGenerics, reportErrors);
	                }
	                else {
	                    outer: for (var _i = 0, targetSignatures_1 = targetSignatures; _i < targetSignatures_1.length; _i++) {
	                        var t = targetSignatures_1[_i];
	                        // Only elaborate errors from the first failure
	                        var shouldElaborateErrors = reportErrors;
	                        for (var _a = 0, sourceSignatures_1 = sourceSignatures; _a < sourceSignatures_1.length; _a++) {
	                            var s = sourceSignatures_1[_a];
	                            var related = signatureRelatedTo(s, t, /*erase*/ true, shouldElaborateErrors);
	                            if (related) {
	                                result &= related;
	                                errorInfo = saveErrorInfo;
	                                continue outer;
	                            }
	                            shouldElaborateErrors = false;
	                        }
	                        if (shouldElaborateErrors) {
	                            reportError(ts.Diagnostics.Type_0_provides_no_match_for_the_signature_1, typeToString(source), signatureToString(t, /*enclosingDeclaration*/ undefined, /*flags*/ undefined, kind));
	                        }
	                        return 0 /* False */;
	                    }
	                }
	                return result;
	            }
	            /**
	             * See signatureAssignableTo, compareSignaturesIdentical
	             */
	            function signatureRelatedTo(source, target, erase, reportErrors) {
	                return compareSignaturesRelated(erase ? getErasedSignature(source) : source, erase ? getErasedSignature(target) : target, 0 /* None */, /*ignoreReturnTypes*/ false, reportErrors, reportError, isRelatedTo);
	            }
	            function signaturesIdenticalTo(source, target, kind) {
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                if (sourceSignatures.length !== targetSignatures.length) {
	                    return 0 /* False */;
	                }
	                var result = -1 /* True */;
	                for (var i = 0; i < sourceSignatures.length; i++) {
	                    var related = compareSignaturesIdentical(sourceSignatures[i], targetSignatures[i], /*partialMatch*/ false, /*ignoreThisTypes*/ false, /*ignoreReturnTypes*/ false, isRelatedTo);
	                    if (!related) {
	                        return 0 /* False */;
	                    }
	                    result &= related;
	                }
	                return result;
	            }
	            function eachPropertyRelatedTo(source, target, kind, reportErrors) {
	                var result = -1 /* True */;
	                for (var _i = 0, _a = getPropertiesOfObjectType(source); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (isIgnoredJsxProperty(source, prop, /*targetMemberType*/ undefined)) {
	                        continue;
	                    }
	                    // Skip over symbol-named members
	                    if (prop.nameType && prop.nameType.flags & 1024 /* UniqueESSymbol */) {
	                        continue;
	                    }
	                    if (kind === 0 /* String */ || isNumericLiteralName(prop.escapedName)) {
	                        var related = isRelatedTo(getTypeOfSymbol(prop), target, reportErrors);
	                        if (!related) {
	                            if (reportErrors) {
	                                reportError(ts.Diagnostics.Property_0_is_incompatible_with_index_signature, symbolToString(prop));
	                            }
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	                return result;
	            }
	            function indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors) {
	                var related = isRelatedTo(sourceInfo.type, targetInfo.type, reportErrors);
	                if (!related && reportErrors) {
	                    reportError(ts.Diagnostics.Index_signatures_are_incompatible);
	                }
	                return related;
	            }
	            function indexTypesRelatedTo(source, target, kind, sourceIsPrimitive, reportErrors) {
	                if (relation === identityRelation) {
	                    return indexTypesIdenticalTo(source, target, kind);
	                }
	                var targetInfo = getIndexInfoOfType(target, kind);
	                if (!targetInfo || targetInfo.type.flags & 1 /* Any */ && !sourceIsPrimitive) {
	                    // Index signature of type any permits assignment from everything but primitives
	                    return -1 /* True */;
	                }
	                var sourceInfo = getIndexInfoOfType(source, kind) ||
	                    kind === 1 /* Number */ && getIndexInfoOfType(source, 0 /* String */);
	                if (sourceInfo) {
	                    return indexInfoRelatedTo(sourceInfo, targetInfo, reportErrors);
	                }
	                if (isGenericMappedType(source)) {
	                    // A generic mapped type { [P in K]: T } is related to an index signature { [x: string]: U }
	                    // if T is related to U.
	                    return kind === 0 /* String */ && isRelatedTo(getTemplateTypeFromMappedType(source), targetInfo.type, reportErrors);
	                }
	                if (isObjectTypeWithInferableIndex(source)) {
	                    var related = -1 /* True */;
	                    if (kind === 0 /* String */) {
	                        var sourceNumberInfo = getIndexInfoOfType(source, 1 /* Number */);
	                        if (sourceNumberInfo) {
	                            related = indexInfoRelatedTo(sourceNumberInfo, targetInfo, reportErrors);
	                        }
	                    }
	                    if (related) {
	                        related &= eachPropertyRelatedTo(source, targetInfo.type, kind, reportErrors);
	                    }
	                    return related;
	                }
	                if (reportErrors) {
	                    reportError(ts.Diagnostics.Index_signature_is_missing_in_type_0, typeToString(source));
	                }
	                return 0 /* False */;
	            }
	            function indexTypesIdenticalTo(source, target, indexKind) {
	                var targetInfo = getIndexInfoOfType(target, indexKind);
	                var sourceInfo = getIndexInfoOfType(source, indexKind);
	                if (!sourceInfo && !targetInfo) {
	                    return -1 /* True */;
	                }
	                if (sourceInfo && targetInfo && sourceInfo.isReadonly === targetInfo.isReadonly) {
	                    return isRelatedTo(sourceInfo.type, targetInfo.type);
	                }
	                return 0 /* False */;
	            }
	            function constructorVisibilitiesAreCompatible(sourceSignature, targetSignature, reportErrors) {
	                if (!sourceSignature.declaration || !targetSignature.declaration) {
	                    return true;
	                }
	                var sourceAccessibility = ts.getSelectedModifierFlags(sourceSignature.declaration, 24 /* NonPublicAccessibilityModifier */);
	                var targetAccessibility = ts.getSelectedModifierFlags(targetSignature.declaration, 24 /* NonPublicAccessibilityModifier */);
	                // A public, protected and private signature is assignable to a private signature.
	                if (targetAccessibility === 8 /* Private */) {
	                    return true;
	                }
	                // A public and protected signature is assignable to a protected signature.
	                if (targetAccessibility === 16 /* Protected */ && sourceAccessibility !== 8 /* Private */) {
	                    return true;
	                }
	                // Only a public signature is assignable to public signature.
	                if (targetAccessibility !== 16 /* Protected */ && !sourceAccessibility) {
	                    return true;
	                }
	                if (reportErrors) {
	                    reportError(ts.Diagnostics.Cannot_assign_a_0_constructor_type_to_a_1_constructor_type, visibilityToString(sourceAccessibility), visibilityToString(targetAccessibility));
	                }
	                return false;
	            }
	        }
	        // Return a type reference where the source type parameter is replaced with the target marker
	        // type, and flag the result as a marker type reference.
	        function getMarkerTypeReference(type, source, target) {
	            var result = createTypeReference(type, ts.map(type.typeParameters, function (t) { return t === source ? target : t; }));
	            result.objectFlags |= 8192 /* MarkerType */;
	            return result;
	        }
	        // Return an array containing the variance of each type parameter. The variance is effectively
	        // a digest of the type comparisons that occur for each type argument when instantiations of the
	        // generic type are structurally compared. We infer the variance information by comparing
	        // instantiations of the generic type for type arguments with known relations. The function
	        // returns the emptyArray singleton if we're not in strictFunctionTypes mode or if the function
	        // has been invoked recursively for the given generic type.
	        function getVariances(type) {
	            if (!strictFunctionTypes) {
	                return ts.emptyArray;
	            }
	            var typeParameters = type.typeParameters || ts.emptyArray;
	            var variances = type.variances;
	            if (!variances) {
	                if (type === globalArrayType || type === globalReadonlyArrayType) {
	                    // Arrays are known to be covariant, no need to spend time computing this
	                    variances = [1 /* Covariant */];
	                }
	                else {
	                    // The emptyArray singleton is used to signal a recursive invocation.
	                    type.variances = ts.emptyArray;
	                    variances = [];
	                    for (var _i = 0, typeParameters_1 = typeParameters; _i < typeParameters_1.length; _i++) {
	                        var tp = typeParameters_1[_i];
	                        // We first compare instantiations where the type parameter is replaced with
	                        // marker types that have a known subtype relationship. From this we can infer
	                        // invariance, covariance, contravariance or bivariance.
	                        var typeWithSuper = getMarkerTypeReference(type, tp, markerSuperType);
	                        var typeWithSub = getMarkerTypeReference(type, tp, markerSubType);
	                        var variance = (isTypeAssignableTo(typeWithSub, typeWithSuper) ? 1 /* Covariant */ : 0) |
	                            (isTypeAssignableTo(typeWithSuper, typeWithSub) ? 2 /* Contravariant */ : 0);
	                        // If the instantiations appear to be related bivariantly it may be because the
	                        // type parameter is independent (i.e. it isn't witnessed anywhere in the generic
	                        // type). To determine this we compare instantiations where the type parameter is
	                        // replaced with marker types that are known to be unrelated.
	                        if (variance === 3 /* Bivariant */ && isTypeAssignableTo(getMarkerTypeReference(type, tp, markerOtherType), typeWithSuper)) {
	                            variance = 4 /* Independent */;
	                        }
	                        variances.push(variance);
	                    }
	                }
	                type.variances = variances;
	            }
	            return variances;
	        }
	        // Return true if the given type reference has a 'void' type argument for a covariant type parameter.
	        // See comment at call in recursiveTypeRelatedTo for when this case matters.
	        function hasCovariantVoidArgument(type, variances) {
	            for (var i = 0; i < variances.length; i++) {
	                if (variances[i] === 1 /* Covariant */ && type.typeArguments[i].flags & 2048 /* Void */) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function isUnconstrainedTypeParameter(type) {
	            return type.flags & 32768 /* TypeParameter */ && !getConstraintFromTypeParameter(type);
	        }
	        function isTypeReferenceWithGenericArguments(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && ts.some(type.typeArguments, function (t) { return isUnconstrainedTypeParameter(t) || isTypeReferenceWithGenericArguments(t); });
	        }
	        /**
	         * getTypeReferenceId(A<T, number, U>) returns "111=0-12=1"
	         *   where A.id=111 and number.id=12
	         */
	        function getTypeReferenceId(type, typeParameters, depth) {
	            if (depth === void 0) { depth = 0; }
	            var result = "" + type.target.id;
	            for (var _i = 0, _a = type.typeArguments; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (isUnconstrainedTypeParameter(t)) {
	                    var index = typeParameters.indexOf(t);
	                    if (index < 0) {
	                        index = typeParameters.length;
	                        typeParameters.push(t);
	                    }
	                    result += "=" + index;
	                }
	                else if (depth < 4 && isTypeReferenceWithGenericArguments(t)) {
	                    result += "<" + getTypeReferenceId(t, typeParameters, depth + 1) + ">";
	                }
	                else {
	                    result += "-" + t.id;
	                }
	            }
	            return result;
	        }
	        /**
	         * To improve caching, the relation key for two generic types uses the target's id plus ids of the type parameters.
	         * For other cases, the types ids are used.
	         */
	        function getRelationKey(source, target, relation) {
	            if (relation === identityRelation && source.id > target.id) {
	                var temp = source;
	                source = target;
	                target = temp;
	            }
	            if (isTypeReferenceWithGenericArguments(source) && isTypeReferenceWithGenericArguments(target)) {
	                var typeParameters = [];
	                return getTypeReferenceId(source, typeParameters) + "," + getTypeReferenceId(target, typeParameters);
	            }
	            return source.id + "," + target.id;
	        }
	        // Invoke the callback for each underlying property symbol of the given symbol and return the first
	        // value that isn't undefined.
	        function forEachProperty(prop, callback) {
	            if (ts.getCheckFlags(prop) & 6 /* Synthetic */) {
	                for (var _i = 0, _a = prop.containingType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    var p = getPropertyOfType(t, prop.escapedName);
	                    var result = p && forEachProperty(p, callback);
	                    if (result) {
	                        return result;
	                    }
	                }
	                return undefined;
	            }
	            return callback(prop);
	        }
	        // Return the declaring class type of a property or undefined if property not declared in class
	        function getDeclaringClass(prop) {
	            return prop.parent && prop.parent.flags & 32 /* Class */ ? getDeclaredTypeOfSymbol(getParentOfSymbol(prop)) : undefined;
	        }
	        // Return true if some underlying source property is declared in a class that derives
	        // from the given base class.
	        function isPropertyInClassDerivedFrom(prop, baseClass) {
	            return forEachProperty(prop, function (sp) {
	                var sourceClass = getDeclaringClass(sp);
	                return sourceClass ? hasBaseType(sourceClass, baseClass) : false;
	            });
	        }
	        // Return true if source property is a valid override of protected parts of target property.
	        function isValidOverrideOf(sourceProp, targetProp) {
	            return !forEachProperty(targetProp, function (tp) { return ts.getDeclarationModifierFlagsFromSymbol(tp) & 16 /* Protected */ ?
	                !isPropertyInClassDerivedFrom(sourceProp, getDeclaringClass(tp)) : false; });
	        }
	        // Return true if the given class derives from each of the declaring classes of the protected
	        // constituents of the given property.
	        function isClassDerivedFromDeclaringClasses(checkClass, prop) {
	            return forEachProperty(prop, function (p) { return ts.getDeclarationModifierFlagsFromSymbol(p) & 16 /* Protected */ ?
	                !hasBaseType(checkClass, getDeclaringClass(p)) : false; }) ? undefined : checkClass;
	        }
	        // Return true if the given type is deeply nested. We consider this to be the case when structural type comparisons
	        // for 5 or more occurrences or instantiations of the type have been recorded on the given stack. It is possible,
	        // though highly unlikely, for this test to be true in a situation where a chain of instantiations is not infinitely
	        // expanding. Effectively, we will generate a false positive when two types are structurally equal to at least 5
	        // levels, but unequal at some level beyond that.
	        function isDeeplyNestedType(type, stack, depth) {
	            // We track all object types that have an associated symbol (representing the origin of the type)
	            if (depth >= 5 && type.flags & 65536 /* Object */) {
	                var symbol = type.symbol;
	                if (symbol) {
	                    var count = 0;
	                    for (var i = 0; i < depth; i++) {
	                        var t = stack[i];
	                        if (t.flags & 65536 /* Object */ && t.symbol === symbol) {
	                            count++;
	                            if (count >= 5)
	                                return true;
	                        }
	                    }
	                }
	            }
	            return false;
	        }
	        function isPropertyIdenticalTo(sourceProp, targetProp) {
	            return compareProperties(sourceProp, targetProp, compareTypesIdentical) !== 0 /* False */;
	        }
	        function compareProperties(sourceProp, targetProp, compareTypes) {
	            // Two members are considered identical when
	            // - they are public properties with identical names, optionality, and types,
	            // - they are private or protected properties originating in the same declaration and having identical types
	            if (sourceProp === targetProp) {
	                return -1 /* True */;
	            }
	            var sourcePropAccessibility = ts.getDeclarationModifierFlagsFromSymbol(sourceProp) & 24 /* NonPublicAccessibilityModifier */;
	            var targetPropAccessibility = ts.getDeclarationModifierFlagsFromSymbol(targetProp) & 24 /* NonPublicAccessibilityModifier */;
	            if (sourcePropAccessibility !== targetPropAccessibility) {
	                return 0 /* False */;
	            }
	            if (sourcePropAccessibility) {
	                if (getTargetSymbol(sourceProp) !== getTargetSymbol(targetProp)) {
	                    return 0 /* False */;
	                }
	            }
	            else {
	                if ((sourceProp.flags & 16777216 /* Optional */) !== (targetProp.flags & 16777216 /* Optional */)) {
	                    return 0 /* False */;
	                }
	            }
	            if (isReadonlySymbol(sourceProp) !== isReadonlySymbol(targetProp)) {
	                return 0 /* False */;
	            }
	            return compareTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
	        }
	        function isMatchingSignature(source, target, partialMatch) {
	            // A source signature matches a target signature if the two signatures have the same number of required,
	            // optional, and rest parameters.
	            if (source.parameters.length === target.parameters.length &&
	                source.minArgumentCount === target.minArgumentCount &&
	                source.hasRestParameter === target.hasRestParameter) {
	                return true;
	            }
	            // A source signature partially matches a target signature if the target signature has no fewer required
	            // parameters and no more overall parameters than the source signature (where a signature with a rest
	            // parameter is always considered to have more overall parameters than one without).
	            var sourceRestCount = source.hasRestParameter ? 1 : 0;
	            var targetRestCount = target.hasRestParameter ? 1 : 0;
	            if (partialMatch && source.minArgumentCount <= target.minArgumentCount && (sourceRestCount > targetRestCount ||
	                sourceRestCount === targetRestCount && source.parameters.length >= target.parameters.length)) {
	                return true;
	            }
	            return false;
	        }
	        /**
	         * See signatureRelatedTo, compareSignaturesIdentical
	         */
	        function compareSignaturesIdentical(source, target, partialMatch, ignoreThisTypes, ignoreReturnTypes, compareTypes) {
	            // TODO (drosen): De-duplicate code between related functions.
	            if (source === target) {
	                return -1 /* True */;
	            }
	            if (!(isMatchingSignature(source, target, partialMatch))) {
	                return 0 /* False */;
	            }
	            // Check that the two signatures have the same number of type parameters. We might consider
	            // also checking that any type parameter constraints match, but that would require instantiating
	            // the constraints with a common set of type arguments to get relatable entities in places where
	            // type parameters occur in the constraints. The complexity of doing that doesn't seem worthwhile,
	            // particularly as we're comparing erased versions of the signatures below.
	            if (ts.length(source.typeParameters) !== ts.length(target.typeParameters)) {
	                return 0 /* False */;
	            }
	            // Spec 1.0 Section 3.8.3 & 3.8.4:
	            // M and N (the signatures) are instantiated using type Any as the type argument for all type parameters declared by M and N
	            source = getErasedSignature(source);
	            target = getErasedSignature(target);
	            var result = -1 /* True */;
	            if (!ignoreThisTypes) {
	                var sourceThisType = getThisTypeOfSignature(source);
	                if (sourceThisType) {
	                    var targetThisType = getThisTypeOfSignature(target);
	                    if (targetThisType) {
	                        var related = compareTypes(sourceThisType, targetThisType);
	                        if (!related) {
	                            return 0 /* False */;
	                        }
	                        result &= related;
	                    }
	                }
	            }
	            var targetLen = target.parameters.length;
	            for (var i = 0; i < targetLen; i++) {
	                var s = isRestParameterIndex(source, i) ? getRestTypeOfSignature(source) : getTypeOfParameter(source.parameters[i]);
	                var t = isRestParameterIndex(target, i) ? getRestTypeOfSignature(target) : getTypeOfParameter(target.parameters[i]);
	                var related = compareTypes(s, t);
	                if (!related) {
	                    return 0 /* False */;
	                }
	                result &= related;
	            }
	            if (!ignoreReturnTypes) {
	                var sourceTypePredicate = getTypePredicateOfSignature(source);
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                result &= sourceTypePredicate !== undefined || targetTypePredicate !== undefined
	                    ? compareTypePredicatesIdentical(sourceTypePredicate, targetTypePredicate, compareTypes)
	                    // If they're both type predicates their return types will both be `boolean`, so no need to compare those.
	                    : compareTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
	            }
	            return result;
	        }
	        function compareTypePredicatesIdentical(source, target, compareTypes) {
	            return source === undefined || target === undefined || !typePredicateKindsMatch(source, target) ? 0 /* False */ : compareTypes(source.type, target.type);
	        }
	        function isRestParameterIndex(signature, parameterIndex) {
	            return signature.hasRestParameter && parameterIndex >= signature.parameters.length - 1;
	        }
	        function literalTypesWithSameBaseType(types) {
	            var commonBaseType;
	            for (var _i = 0, types_9 = types; _i < types_9.length; _i++) {
	                var t = types_9[_i];
	                var baseType = getBaseTypeOfLiteralType(t);
	                if (!commonBaseType) {
	                    commonBaseType = baseType;
	                }
	                if (baseType === t || baseType !== commonBaseType) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        // When the candidate types are all literal types with the same base type, return a union
	        // of those literal types. Otherwise, return the leftmost type for which no type to the
	        // right is a supertype.
	        function getSupertypeOrUnion(types) {
	            return literalTypesWithSameBaseType(types) ?
	                getUnionType(types) :
	                ts.reduceLeft(types, function (s, t) { return isTypeSubtypeOf(s, t) ? t : s; });
	        }
	        function getCommonSupertype(types) {
	            if (!strictNullChecks) {
	                return getSupertypeOrUnion(types);
	            }
	            var primaryTypes = ts.filter(types, function (t) { return !(t.flags & 12288 /* Nullable */); });
	            return primaryTypes.length ?
	                getNullableType(getSupertypeOrUnion(primaryTypes), getFalsyFlagsOfTypes(types) & 12288 /* Nullable */) :
	                getUnionType(types, 2 /* Subtype */);
	        }
	        // Return the leftmost type for which no type to the right is a subtype.
	        function getCommonSubtype(types) {
	            return ts.reduceLeft(types, function (s, t) { return isTypeSubtypeOf(t, s) ? t : s; });
	        }
	        function isArrayType(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalArrayType;
	        }
	        function isArrayLikeType(type) {
	            // A type is array-like if it is a reference to the global Array or global ReadonlyArray type,
	            // or if it is not the undefined or null type and if it is assignable to ReadonlyArray<any>
	            return ts.getObjectFlags(type) & 4 /* Reference */ && (type.target === globalArrayType || type.target === globalReadonlyArrayType) ||
	                !(type.flags & 12288 /* Nullable */) && isTypeAssignableTo(type, anyReadonlyArrayType);
	        }
	        function isEmptyArrayLiteralType(type) {
	            var elementType = isArrayType(type) ? type.typeArguments[0] : undefined;
	            return elementType === undefinedWideningType || elementType === implicitNeverType;
	        }
	        function isTupleLikeType(type) {
	            return !!getPropertyOfType(type, "0");
	        }
	        function isNeitherUnitTypeNorNever(type) {
	            return !(type.flags & (13536 /* Unit */ | 16384 /* Never */));
	        }
	        function isUnitType(type) {
	            return !!(type.flags & 13536 /* Unit */);
	        }
	        function isLiteralType(type) {
	            return type.flags & 8 /* Boolean */ ? true :
	                type.flags & 131072 /* Union */ ? type.flags & 256 /* EnumLiteral */ ? true : !ts.forEach(type.types, function (t) { return !isUnitType(t); }) :
	                    isUnitType(type);
	        }
	        function getBaseTypeOfLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ ? getBaseTypeOfEnumLiteralType(type) :
	                type.flags & 32 /* StringLiteral */ ? stringType :
	                    type.flags & 64 /* NumberLiteral */ ? numberType :
	                        type.flags & 128 /* BooleanLiteral */ ? booleanType :
	                            type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getBaseTypeOfLiteralType)) :
	                                type;
	        }
	        function getWidenedLiteralType(type) {
	            return type.flags & 256 /* EnumLiteral */ ? getBaseTypeOfEnumLiteralType(type) :
	                type.flags & 32 /* StringLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? stringType :
	                    type.flags & 64 /* NumberLiteral */ && type.flags & 8388608 /* FreshLiteral */ ? numberType :
	                        type.flags & 128 /* BooleanLiteral */ ? booleanType :
	                            type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getWidenedLiteralType)) :
	                                type;
	        }
	        function getWidenedUniqueESSymbolType(type) {
	            return type.flags & 1024 /* UniqueESSymbol */ ? esSymbolType :
	                type.flags & 131072 /* Union */ ? getUnionType(ts.sameMap(type.types, getWidenedUniqueESSymbolType)) :
	                    type;
	        }
	        function getWidenedLiteralLikeTypeForContextualType(type, contextualType) {
	            if (!isLiteralOfContextualType(type, contextualType)) {
	                type = getWidenedUniqueESSymbolType(getWidenedLiteralType(type));
	            }
	            return type;
	        }
	        /**
	         * Check if a Type was written as a tuple type literal.
	         * Prefer using isTupleLikeType() unless the use of `elementTypes` is required.
	         */
	        function isTupleType(type) {
	            return !!(ts.getObjectFlags(type) & 4 /* Reference */ && type.target.objectFlags & 8 /* Tuple */);
	        }
	        function getFalsyFlagsOfTypes(types) {
	            var result = 0;
	            for (var _i = 0, types_10 = types; _i < types_10.length; _i++) {
	                var t = types_10[_i];
	                result |= getFalsyFlags(t);
	            }
	            return result;
	        }
	        // Returns the String, Number, Boolean, StringLiteral, NumberLiteral, BooleanLiteral, Void, Undefined, or Null
	        // flags for the string, number, boolean, "", 0, false, void, undefined, or null types respectively. Returns
	        // no flags for all other types (including non-falsy literal types).
	        function getFalsyFlags(type) {
	            return type.flags & 131072 /* Union */ ? getFalsyFlagsOfTypes(type.types) :
	                type.flags & 32 /* StringLiteral */ ? type.value === "" ? 32 /* StringLiteral */ : 0 :
	                    type.flags & 64 /* NumberLiteral */ ? type.value === 0 ? 64 /* NumberLiteral */ : 0 :
	                        type.flags & 128 /* BooleanLiteral */ ? type === falseType ? 128 /* BooleanLiteral */ : 0 :
	                            type.flags & 14574 /* PossiblyFalsy */;
	        }
	        function removeDefinitelyFalsyTypes(type) {
	            return getFalsyFlags(type) & 14560 /* DefinitelyFalsy */ ?
	                filterType(type, function (t) { return !(getFalsyFlags(t) & 14560 /* DefinitelyFalsy */); }) :
	                type;
	        }
	        function extractDefinitelyFalsyTypes(type) {
	            return mapType(type, getDefinitelyFalsyPartOfType);
	        }
	        function getDefinitelyFalsyPartOfType(type) {
	            return type.flags & 2 /* String */ ? emptyStringType :
	                type.flags & 4 /* Number */ ? zeroType :
	                    type.flags & 8 /* Boolean */ || type === falseType ? falseType :
	                        type.flags & (2048 /* Void */ | 4096 /* Undefined */ | 8192 /* Null */) ||
	                            type.flags & 32 /* StringLiteral */ && type.value === "" ||
	                            type.flags & 64 /* NumberLiteral */ && type.value === 0 ? type :
	                            neverType;
	        }
	        /**
	         * Add undefined or null or both to a type if they are missing.
	         * @param type - type to add undefined and/or null to if not present
	         * @param flags - Either TypeFlags.Undefined or TypeFlags.Null, or both
	         */
	        function getNullableType(type, flags) {
	            var missing = (flags & ~type.flags) & (4096 /* Undefined */ | 8192 /* Null */);
	            return missing === 0 ? type :
	                missing === 4096 /* Undefined */ ? getUnionType([type, undefinedType]) :
	                    missing === 8192 /* Null */ ? getUnionType([type, nullType]) :
	                        getUnionType([type, undefinedType, nullType]);
	        }
	        function getOptionalType(type) {
	            ts.Debug.assert(strictNullChecks);
	            return type.flags & 4096 /* Undefined */ ? type : getUnionType([type, undefinedType]);
	        }
	        function getGlobalNonNullableTypeInstantiation(type) {
	            if (!deferredGlobalNonNullableTypeAlias) {
	                deferredGlobalNonNullableTypeAlias = getGlobalSymbol("NonNullable", 524288 /* TypeAlias */, /*diagnostic*/ undefined) || unknownSymbol;
	            }
	            // Use NonNullable global type alias if available to improve quick info/declaration emit
	            if (deferredGlobalNonNullableTypeAlias !== unknownSymbol) {
	                return getTypeAliasInstantiation(deferredGlobalNonNullableTypeAlias, [type]);
	            }
	            return getTypeWithFacts(type, 524288 /* NEUndefinedOrNull */); // Type alias unavailable, fall back to non-higherorder behavior
	        }
	        function getNonNullableType(type) {
	            return strictNullChecks ? getGlobalNonNullableTypeInstantiation(type) : type;
	        }
	        /**
	         * Return true if type was inferred from an object literal, written as an object type literal, or is the shape of a module
	         * with no call or construct signatures.
	         */
	        function isObjectTypeWithInferableIndex(type) {
	            return type.symbol && (type.symbol.flags & (4096 /* ObjectLiteral */ | 2048 /* TypeLiteral */ | 512 /* ValueModule */)) !== 0 &&
	                !typeHasCallOrConstructSignatures(type);
	        }
	        function createSymbolWithType(source, type) {
	            var symbol = createSymbol(source.flags, source.escapedName);
	            symbol.declarations = source.declarations;
	            symbol.parent = source.parent;
	            symbol.type = type;
	            symbol.target = source;
	            if (source.valueDeclaration) {
	                symbol.valueDeclaration = source.valueDeclaration;
	            }
	            if (source.nameType) {
	                symbol.nameType = source.nameType;
	            }
	            return symbol;
	        }
	        function transformTypeOfMembers(type, f) {
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfObjectType(type); _i < _a.length; _i++) {
	                var property = _a[_i];
	                var original = getTypeOfSymbol(property);
	                var updated = f(original);
	                members.set(property.escapedName, updated === original ? property : createSymbolWithType(property, updated));
	            }
	            return members;
	        }
	        /**
	         * If the the provided object literal is subject to the excess properties check,
	         * create a new that is exempt. Recursively mark object literal members as exempt.
	         * Leave signatures alone since they are not subject to the check.
	         */
	        function getRegularTypeOfObjectLiteral(type) {
	            if (!(isObjectLiteralType(type) && type.flags & 8388608 /* FreshLiteral */)) {
	                return type;
	            }
	            var regularType = type.regularType;
	            if (regularType) {
	                return regularType;
	            }
	            var resolved = type;
	            var members = transformTypeOfMembers(type, getRegularTypeOfObjectLiteral);
	            var regularNew = createAnonymousType(resolved.symbol, members, resolved.callSignatures, resolved.constructSignatures, resolved.stringIndexInfo, resolved.numberIndexInfo);
	            regularNew.flags = resolved.flags & ~8388608 /* FreshLiteral */;
	            regularNew.objectFlags |= 128 /* ObjectLiteral */;
	            type.regularType = regularNew;
	            return regularNew;
	        }
	        function createWideningContext(parent, propertyName, siblings) {
	            return { parent: parent, propertyName: propertyName, siblings: siblings, resolvedProperties: undefined };
	        }
	        function getSiblingsOfContext(context) {
	            if (!context.siblings) {
	                var siblings_1 = [];
	                for (var _i = 0, _a = getSiblingsOfContext(context.parent); _i < _a.length; _i++) {
	                    var type = _a[_i];
	                    if (isObjectLiteralType(type)) {
	                        var prop = getPropertyOfObjectType(type, context.propertyName);
	                        if (prop) {
	                            forEachType(getTypeOfSymbol(prop), function (t) {
	                                siblings_1.push(t);
	                            });
	                        }
	                    }
	                }
	                context.siblings = siblings_1;
	            }
	            return context.siblings;
	        }
	        function getPropertiesOfContext(context) {
	            if (!context.resolvedProperties) {
	                var names = ts.createMap();
	                for (var _i = 0, _a = getSiblingsOfContext(context); _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (isObjectLiteralType(t) && !(ts.getObjectFlags(t) & 1024 /* ContainsSpread */)) {
	                        for (var _b = 0, _c = getPropertiesOfType(t); _b < _c.length; _b++) {
	                            var prop = _c[_b];
	                            names.set(prop.escapedName, prop);
	                        }
	                    }
	                }
	                context.resolvedProperties = ts.arrayFrom(names.values());
	            }
	            return context.resolvedProperties;
	        }
	        function getWidenedProperty(prop, context) {
	            var original = getTypeOfSymbol(prop);
	            var propContext = context && createWideningContext(context, prop.escapedName, /*siblings*/ undefined);
	            var widened = getWidenedTypeWithContext(original, propContext);
	            return widened === original ? prop : createSymbolWithType(prop, widened);
	        }
	        function getUndefinedProperty(prop) {
	            var cached = undefinedProperties.get(prop.escapedName);
	            if (cached) {
	                return cached;
	            }
	            var result = createSymbolWithType(prop, undefinedType);
	            result.flags |= 16777216 /* Optional */;
	            undefinedProperties.set(prop.escapedName, result);
	            return result;
	        }
	        function getWidenedTypeOfObjectLiteral(type, context) {
	            var members = ts.createSymbolTable();
	            for (var _i = 0, _a = getPropertiesOfObjectType(type); _i < _a.length; _i++) {
	                var prop = _a[_i];
	                // Since get accessors already widen their return value there is no need to
	                // widen accessor based properties here.
	                members.set(prop.escapedName, prop.flags & 4 /* Property */ ? getWidenedProperty(prop, context) : prop);
	            }
	            if (context) {
	                for (var _b = 0, _c = getPropertiesOfContext(context); _b < _c.length; _b++) {
	                    var prop = _c[_b];
	                    if (!members.has(prop.escapedName)) {
	                        members.set(prop.escapedName, getUndefinedProperty(prop));
	                    }
	                }
	            }
	            var stringIndexInfo = getIndexInfoOfType(type, 0 /* String */);
	            var numberIndexInfo = getIndexInfoOfType(type, 1 /* Number */);
	            return createAnonymousType(type.symbol, members, ts.emptyArray, ts.emptyArray, stringIndexInfo && createIndexInfo(getWidenedType(stringIndexInfo.type), stringIndexInfo.isReadonly), numberIndexInfo && createIndexInfo(getWidenedType(numberIndexInfo.type), numberIndexInfo.isReadonly));
	        }
	        function getWidenedType(type) {
	            return getWidenedTypeWithContext(type, /*context*/ undefined);
	        }
	        function getWidenedTypeWithContext(type, context) {
	            if (type.flags & 50331648 /* RequiresWidening */) {
	                if (type.flags & 12288 /* Nullable */) {
	                    return anyType;
	                }
	                if (isObjectLiteralType(type)) {
	                    return getWidenedTypeOfObjectLiteral(type, context);
	                }
	                if (type.flags & 131072 /* Union */) {
	                    var unionContext_1 = context || createWideningContext(/*parent*/ undefined, /*propertyName*/ undefined, type.types);
	                    var widenedTypes = ts.sameMap(type.types, function (t) { return t.flags & 12288 /* Nullable */ ? t : getWidenedTypeWithContext(t, unionContext_1); });
	                    // Widening an empty object literal transitions from a highly restrictive type to
	                    // a highly inclusive one. For that reason we perform subtype reduction here if the
	                    // union includes empty object types (e.g. reducing {} | string to just {}).
	                    return getUnionType(widenedTypes, ts.some(widenedTypes, isEmptyObjectType) ? 2 /* Subtype */ : 1 /* Literal */);
	                }
	                if (isArrayType(type) || isTupleType(type)) {
	                    return createTypeReference(type.target, ts.sameMap(type.typeArguments, getWidenedType));
	                }
	            }
	            return type;
	        }
	        /**
	         * Reports implicit any errors that occur as a result of widening 'null' and 'undefined'
	         * to 'any'. A call to reportWideningErrorsInType is normally accompanied by a call to
	         * getWidenedType. But in some cases getWidenedType is called without reporting errors
	         * (type argument inference is an example).
	         *
	         * The return value indicates whether an error was in fact reported. The particular circumstances
	         * are on a best effort basis. Currently, if the null or undefined that causes widening is inside
	         * an object literal property (arbitrarily deeply), this function reports an error. If no error is
	         * reported, reportImplicitAnyError is a suitable fallback to report a general error.
	         */
	        function reportWideningErrorsInType(type) {
	            var errorReported = false;
	            if (type.flags & 16777216 /* ContainsWideningType */) {
	                if (type.flags & 131072 /* Union */) {
	                    if (ts.some(type.types, isEmptyObjectType)) {
	                        errorReported = true;
	                    }
	                    else {
	                        for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                            var t = _a[_i];
	                            if (reportWideningErrorsInType(t)) {
	                                errorReported = true;
	                            }
	                        }
	                    }
	                }
	                if (isArrayType(type) || isTupleType(type)) {
	                    for (var _b = 0, _c = type.typeArguments; _b < _c.length; _b++) {
	                        var t = _c[_b];
	                        if (reportWideningErrorsInType(t)) {
	                            errorReported = true;
	                        }
	                    }
	                }
	                if (isObjectLiteralType(type)) {
	                    for (var _d = 0, _e = getPropertiesOfObjectType(type); _d < _e.length; _d++) {
	                        var p = _e[_d];
	                        var t = getTypeOfSymbol(p);
	                        if (t.flags & 16777216 /* ContainsWideningType */) {
	                            if (!reportWideningErrorsInType(t)) {
	                                error(p.valueDeclaration, ts.Diagnostics.Object_literal_s_property_0_implicitly_has_an_1_type, symbolToString(p), typeToString(getWidenedType(t)));
	                            }
	                            errorReported = true;
	                        }
	                    }
	                }
	            }
	            return errorReported;
	        }
	        function reportImplicitAnyError(declaration, type) {
	            var typeAsString = typeToString(getWidenedType(type));
	            var diagnostic;
	            switch (declaration.kind) {
	                case 199 /* BinaryExpression */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    diagnostic = ts.Diagnostics.Member_0_implicitly_has_an_1_type;
	                    break;
	                case 148 /* Parameter */:
	                    diagnostic = declaration.dotDotDotToken ?
	                        ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type :
	                        ts.Diagnostics.Parameter_0_implicitly_has_an_1_type;
	                    break;
	                case 181 /* BindingElement */:
	                    diagnostic = ts.Diagnostics.Binding_element_0_implicitly_has_an_1_type;
	                    break;
	                case 233 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    if (!declaration.name) {
	                        error(declaration, ts.Diagnostics.Function_expression_which_lacks_return_type_annotation_implicitly_has_an_0_return_type, typeAsString);
	                        return;
	                    }
	                    diagnostic = ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type;
	                    break;
	                case 176 /* MappedType */:
	                    error(declaration, ts.Diagnostics.Mapped_object_type_implicitly_has_an_any_template_type);
	                    return;
	                default:
	                    diagnostic = ts.Diagnostics.Variable_0_implicitly_has_an_1_type;
	            }
	            error(declaration, diagnostic, ts.declarationNameToString(ts.getNameOfDeclaration(declaration)), typeAsString);
	        }
	        function reportErrorsFromWidening(declaration, type) {
	            if (produceDiagnostics && noImplicitAny && type.flags & 16777216 /* ContainsWideningType */) {
	                // Report implicit any error within type if possible, otherwise report error on declaration
	                if (!reportWideningErrorsInType(type)) {
	                    reportImplicitAnyError(declaration, type);
	                }
	            }
	        }
	        function forEachMatchingParameterType(source, target, callback) {
	            var sourceMax = source.parameters.length;
	            var targetMax = target.parameters.length;
	            var count;
	            if (source.hasRestParameter && target.hasRestParameter) {
	                count = Math.max(sourceMax, targetMax);
	            }
	            else if (source.hasRestParameter) {
	                count = targetMax;
	            }
	            else if (target.hasRestParameter) {
	                count = sourceMax;
	            }
	            else {
	                count = Math.min(sourceMax, targetMax);
	            }
	            for (var i = 0; i < count; i++) {
	                callback(getTypeAtPosition(source, i), getTypeAtPosition(target, i));
	            }
	        }
	        function createInferenceContext(typeParameters, signature, flags, compareTypes, baseInferences) {
	            var inferences = baseInferences ? baseInferences.map(cloneInferenceInfo) : typeParameters.map(createInferenceInfo);
	            var context = mapper;
	            context.typeParameters = typeParameters;
	            context.signature = signature;
	            context.inferences = inferences;
	            context.flags = flags;
	            context.compareTypes = compareTypes || compareTypesAssignable;
	            return context;
	            function mapper(t) {
	                for (var i = 0; i < inferences.length; i++) {
	                    if (t === inferences[i].typeParameter) {
	                        inferences[i].isFixed = true;
	                        return getInferredType(context, i);
	                    }
	                }
	                return t;
	            }
	        }
	        function createInferenceInfo(typeParameter) {
	            return {
	                typeParameter: typeParameter,
	                candidates: undefined,
	                contraCandidates: undefined,
	                inferredType: undefined,
	                priority: undefined,
	                topLevel: true,
	                isFixed: false
	            };
	        }
	        function cloneInferenceInfo(inference) {
	            return {
	                typeParameter: inference.typeParameter,
	                candidates: inference.candidates && inference.candidates.slice(),
	                contraCandidates: inference.contraCandidates && inference.contraCandidates.slice(),
	                inferredType: inference.inferredType,
	                priority: inference.priority,
	                topLevel: inference.topLevel,
	                isFixed: inference.isFixed
	            };
	        }
	        // Return true if the given type could possibly reference a type parameter for which
	        // we perform type inference (i.e. a type parameter of a generic function). We cache
	        // results for union and intersection types for performance reasons.
	        function couldContainTypeVariables(type) {
	            var objectFlags = ts.getObjectFlags(type);
	            return !!(type.flags & 7897088 /* Instantiable */ ||
	                objectFlags & 4 /* Reference */ && ts.forEach(type.typeArguments, couldContainTypeVariables) ||
	                objectFlags & 16 /* Anonymous */ && type.symbol && type.symbol.flags & (16 /* Function */ | 8192 /* Method */ | 2048 /* TypeLiteral */ | 32 /* Class */) ||
	                objectFlags & 32 /* Mapped */ ||
	                type.flags & 393216 /* UnionOrIntersection */ && couldUnionOrIntersectionContainTypeVariables(type));
	        }
	        function couldUnionOrIntersectionContainTypeVariables(type) {
	            if (type.couldContainTypeVariables === undefined) {
	                type.couldContainTypeVariables = ts.forEach(type.types, couldContainTypeVariables);
	            }
	            return type.couldContainTypeVariables;
	        }
	        function isTypeParameterAtTopLevel(type, typeParameter) {
	            return type === typeParameter || type.flags & 393216 /* UnionOrIntersection */ && ts.forEach(type.types, function (t) { return isTypeParameterAtTopLevel(t, typeParameter); });
	        }
	        /** Create an object with properties named in the string literal type. Every property has type `any` */
	        function createEmptyObjectTypeFromStringLiteral(type) {
	            var members = ts.createSymbolTable();
	            forEachType(type, function (t) {
	                if (!(t.flags & 32 /* StringLiteral */)) {
	                    return;
	                }
	                var name = ts.escapeLeadingUnderscores(t.value);
	                var literalProp = createSymbol(4 /* Property */, name);
	                literalProp.type = anyType;
	                if (t.symbol) {
	                    literalProp.declarations = t.symbol.declarations;
	                    literalProp.valueDeclaration = t.symbol.valueDeclaration;
	                }
	                members.set(name, literalProp);
	            });
	            var indexInfo = type.flags & 2 /* String */ ? createIndexInfo(emptyObjectType, /*isReadonly*/ false) : undefined;
	            return createAnonymousType(undefined, members, ts.emptyArray, ts.emptyArray, indexInfo, undefined);
	        }
	        /**
	         * Infer a suitable input type for a homomorphic mapped type { [P in keyof T]: X }. We construct
	         * an object type with the same set of properties as the source type, where the type of each
	         * property is computed by inferring from the source property type to X for the type
	         * variable T[P] (i.e. we treat the type T[P] as the type variable we're inferring for).
	         */
	        function inferTypeForHomomorphicMappedType(source, target) {
	            var key = source.id + "," + target.id;
	            if (reverseMappedCache.has(key)) {
	                return reverseMappedCache.get(key);
	            }
	            reverseMappedCache.set(key, undefined);
	            var type = createReverseMappedType(source, target);
	            reverseMappedCache.set(key, type);
	            return type;
	        }
	        function createReverseMappedType(source, target) {
	            var properties = getPropertiesOfType(source);
	            if (properties.length === 0 && !getIndexInfoOfType(source, 0 /* String */)) {
	                return undefined;
	            }
	            // If any property contains context sensitive functions that have been skipped, the source type
	            // is incomplete and we can't infer a meaningful input type.
	            for (var _i = 0, properties_4 = properties; _i < properties_4.length; _i++) {
	                var prop = properties_4[_i];
	                if (getTypeOfSymbol(prop).flags & 67108864 /* ContainsAnyFunctionType */) {
	                    return undefined;
	                }
	            }
	            var reversed = createObjectType(2048 /* ReverseMapped */ | 16 /* Anonymous */, /*symbol*/ undefined);
	            reversed.source = source;
	            reversed.mappedType = target;
	            return reversed;
	        }
	        function getTypeOfReverseMappedSymbol(symbol) {
	            return inferReverseMappedType(symbol.propertyType, symbol.mappedType);
	        }
	        function inferReverseMappedType(sourceType, target) {
	            var typeParameter = getIndexedAccessType(getConstraintTypeFromMappedType(target).type, getTypeParameterFromMappedType(target));
	            var templateType = getTemplateTypeFromMappedType(target);
	            var inference = createInferenceInfo(typeParameter);
	            inferTypes([inference], sourceType, templateType);
	            return getTypeFromInference(inference);
	        }
	        function getUnmatchedProperty(source, target, requireOptionalProperties) {
	            var properties = target.flags & 262144 /* Intersection */ ? getPropertiesOfUnionOrIntersectionType(target) : getPropertiesOfObjectType(target);
	            for (var _i = 0, properties_5 = properties; _i < properties_5.length; _i++) {
	                var targetProp = properties_5[_i];
	                if (requireOptionalProperties || !(targetProp.flags & 16777216 /* Optional */)) {
	                    var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                    if (!sourceProp) {
	                        return targetProp;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function typesDefinitelyUnrelated(source, target) {
	            // Two tuple types with different arity are definitely unrelated.
	            // Two object types that each have a property that is unmatched in the other are definitely unrelated.
	            return isTupleType(source) && isTupleType(target) && getTypeReferenceArity(source) !== getTypeReferenceArity(target) ||
	                !!getUnmatchedProperty(source, target, /*requireOptionalProperties*/ false) && !!getUnmatchedProperty(target, source, /*requireOptionalProperties*/ false);
	        }
	        function getTypeFromInference(inference) {
	            return inference.candidates ? getUnionType(inference.candidates, 2 /* Subtype */) :
	                inference.contraCandidates ? getIntersectionType(inference.contraCandidates) :
	                    emptyObjectType;
	        }
	        function inferTypes(inferences, originalSource, originalTarget, priority) {
	            if (priority === void 0) { priority = 0; }
	            var symbolStack;
	            var visited;
	            var contravariant = false;
	            var propagationType;
	            inferFromTypes(originalSource, originalTarget);
	            function inferFromTypes(source, target) {
	                if (!couldContainTypeVariables(target)) {
	                    return;
	                }
	                if (source === wildcardType) {
	                    // We are inferring from an 'any' type. We want to infer this type for every type parameter
	                    // referenced in the target type, so we record it as the propagation type and infer from the
	                    // target to itself. Then, as we find candidates we substitute the propagation type.
	                    var savePropagationType = propagationType;
	                    propagationType = source;
	                    inferFromTypes(target, target);
	                    propagationType = savePropagationType;
	                    return;
	                }
	                if (source.aliasSymbol && source.aliasTypeArguments && source.aliasSymbol === target.aliasSymbol) {
	                    // Source and target are types originating in the same generic type alias declaration.
	                    // Simply infer from source type arguments to target type arguments.
	                    var sourceTypes = source.aliasTypeArguments;
	                    var targetTypes = target.aliasTypeArguments;
	                    for (var i = 0; i < sourceTypes.length; i++) {
	                        inferFromTypes(sourceTypes[i], targetTypes[i]);
	                    }
	                    return;
	                }
	                if (source.flags & 131072 /* Union */ && target.flags & 131072 /* Union */ && !(source.flags & 256 /* EnumLiteral */ && target.flags & 256 /* EnumLiteral */) ||
	                    source.flags & 262144 /* Intersection */ && target.flags & 262144 /* Intersection */) {
	                    // Source and target are both unions or both intersections. If source and target
	                    // are the same type, just relate each constituent type to itself.
	                    if (source === target) {
	                        for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                            var t = _a[_i];
	                            inferFromTypes(t, t);
	                        }
	                        return;
	                    }
	                    // Find each source constituent type that has an identically matching target constituent
	                    // type, and for each such type infer from the type to itself. When inferring from a
	                    // type to itself we effectively find all type parameter occurrences within that type
	                    // and infer themselves as their type arguments. We have special handling for numeric
	                    // and string literals because the number and string types are not represented as unions
	                    // of all their possible values.
	                    var matchingTypes = void 0;
	                    for (var _b = 0, _c = source.types; _b < _c.length; _b++) {
	                        var t = _c[_b];
	                        if (typeIdenticalToSomeType(t, target.types)) {
	                            (matchingTypes || (matchingTypes = [])).push(t);
	                            inferFromTypes(t, t);
	                        }
	                        else if (t.flags & (64 /* NumberLiteral */ | 32 /* StringLiteral */)) {
	                            var b = getBaseTypeOfLiteralType(t);
	                            if (typeIdenticalToSomeType(b, target.types)) {
	                                (matchingTypes || (matchingTypes = [])).push(t, b);
	                            }
	                        }
	                    }
	                    // Next, to improve the quality of inferences, reduce the source and target types by
	                    // removing the identically matched constituents. For example, when inferring from
	                    // 'string | string[]' to 'string | T' we reduce the types to 'string[]' and 'T'.
	                    if (matchingTypes) {
	                        source = removeTypesFromUnionOrIntersection(source, matchingTypes);
	                        target = removeTypesFromUnionOrIntersection(target, matchingTypes);
	                    }
	                }
	                if (target.flags & 1081344 /* TypeVariable */) {
	                    // If target is a type parameter, make an inference, unless the source type contains
	                    // the anyFunctionType (the wildcard type that's used to avoid contextually typing functions).
	                    // Because the anyFunctionType is internal, it should not be exposed to the user by adding
	                    // it as an inference candidate. Hopefully, a better candidate will come along that does
	                    // not contain anyFunctionType when we come back to this argument for its second round
	                    // of inference. Also, we exclude inferences for silentNeverType (which is used as a wildcard
	                    // when constructing types from type parameters that had no inference candidates).
	                    if (source.flags & 67108864 /* ContainsAnyFunctionType */ || source === silentNeverType) {
	                        return;
	                    }
	                    var inference = getInferenceInfoForType(target);
	                    if (inference) {
	                        if (!inference.isFixed) {
	                            if (inference.priority === undefined || priority < inference.priority) {
	                                inference.candidates = undefined;
	                                inference.contraCandidates = undefined;
	                                inference.priority = priority;
	                            }
	                            if (priority === inference.priority) {
	                                var candidate = propagationType || source;
	                                if (contravariant) {
	                                    inference.contraCandidates = ts.append(inference.contraCandidates, candidate);
	                                }
	                                else {
	                                    inference.candidates = ts.append(inference.candidates, candidate);
	                                }
	                            }
	                            if (!(priority & 8 /* ReturnType */) && target.flags & 32768 /* TypeParameter */ && !isTypeParameterAtTopLevel(originalTarget, target)) {
	                                inference.topLevel = false;
	                            }
	                        }
	                        return;
	                    }
	                }
	                if (ts.getObjectFlags(source) & 4 /* Reference */ && ts.getObjectFlags(target) & 4 /* Reference */ && source.target === target.target) {
	                    // If source and target are references to the same generic type, infer from type arguments
	                    var sourceTypes = source.typeArguments || ts.emptyArray;
	                    var targetTypes = target.typeArguments || ts.emptyArray;
	                    var count = sourceTypes.length < targetTypes.length ? sourceTypes.length : targetTypes.length;
	                    var variances = getVariances(source.target);
	                    for (var i = 0; i < count; i++) {
	                        if (i < variances.length && variances[i] === 2 /* Contravariant */) {
	                            inferFromContravariantTypes(sourceTypes[i], targetTypes[i]);
	                        }
	                        else {
	                            inferFromTypes(sourceTypes[i], targetTypes[i]);
	                        }
	                    }
	                }
	                else if (source.flags & 524288 /* Index */ && target.flags & 524288 /* Index */) {
	                    contravariant = !contravariant;
	                    inferFromTypes(source.type, target.type);
	                    contravariant = !contravariant;
	                }
	                else if ((isLiteralType(source) || source.flags & 2 /* String */) && target.flags & 524288 /* Index */) {
	                    var empty = createEmptyObjectTypeFromStringLiteral(source);
	                    contravariant = !contravariant;
	                    var savePriority = priority;
	                    priority |= 16 /* LiteralKeyof */;
	                    inferFromTypes(empty, target.type);
	                    priority = savePriority;
	                    contravariant = !contravariant;
	                }
	                else if (source.flags & 1048576 /* IndexedAccess */ && target.flags & 1048576 /* IndexedAccess */) {
	                    inferFromTypes(source.objectType, target.objectType);
	                    inferFromTypes(source.indexType, target.indexType);
	                }
	                else if (source.flags & 2097152 /* Conditional */ && target.flags & 2097152 /* Conditional */) {
	                    inferFromTypes(source.checkType, target.checkType);
	                    inferFromTypes(source.extendsType, target.extendsType);
	                    inferFromTypes(getTrueTypeFromConditionalType(source), getTrueTypeFromConditionalType(target));
	                    inferFromTypes(getFalseTypeFromConditionalType(source), getFalseTypeFromConditionalType(target));
	                }
	                else if (target.flags & 393216 /* UnionOrIntersection */) {
	                    var targetTypes = target.types;
	                    var typeVariableCount = 0;
	                    var typeVariable = void 0;
	                    // First infer to each type in union or intersection that isn't a type variable
	                    for (var _d = 0, targetTypes_3 = targetTypes; _d < targetTypes_3.length; _d++) {
	                        var t = targetTypes_3[_d];
	                        if (getInferenceInfoForType(t)) {
	                            typeVariable = t;
	                            typeVariableCount++;
	                        }
	                        else {
	                            inferFromTypes(source, t);
	                        }
	                    }
	                    // Next, if target containings a single naked type variable, make a secondary inference to that type
	                    // variable. This gives meaningful results for union types in co-variant positions and intersection
	                    // types in contra-variant positions (such as callback parameters).
	                    if (typeVariableCount === 1) {
	                        var savePriority = priority;
	                        priority |= 1 /* NakedTypeVariable */;
	                        inferFromTypes(source, typeVariable);
	                        priority = savePriority;
	                    }
	                }
	                else if (source.flags & 131072 /* Union */) {
	                    // Source is a union or intersection type, infer from each constituent type
	                    var sourceTypes = source.types;
	                    for (var _e = 0, sourceTypes_3 = sourceTypes; _e < sourceTypes_3.length; _e++) {
	                        var sourceType = sourceTypes_3[_e];
	                        inferFromTypes(sourceType, target);
	                    }
	                }
	                else {
	                    if (!(priority & 32 /* NoConstraints */ && source.flags & (262144 /* Intersection */ | 7897088 /* Instantiable */))) {
	                        source = getApparentType(source);
	                    }
	                    if (source.flags & (65536 /* Object */ | 262144 /* Intersection */)) {
	                        var key = source.id + "," + target.id;
	                        if (visited && visited.get(key)) {
	                            return;
	                        }
	                        (visited || (visited = ts.createMap())).set(key, true);
	                        // If we are already processing another target type with the same associated symbol (such as
	                        // an instantiation of the same generic type), we do not explore this target as it would yield
	                        // no further inferences. We exclude the static side of classes from this check since it shares
	                        // its symbol with the instance side which would lead to false positives.
	                        var isNonConstructorObject = target.flags & 65536 /* Object */ &&
	                            !(ts.getObjectFlags(target) & 16 /* Anonymous */ && target.symbol && target.symbol.flags & 32 /* Class */);
	                        var symbol = isNonConstructorObject ? target.symbol : undefined;
	                        if (symbol) {
	                            if (ts.contains(symbolStack, symbol)) {
	                                return;
	                            }
	                            (symbolStack || (symbolStack = [])).push(symbol);
	                            inferFromObjectTypes(source, target);
	                            symbolStack.pop();
	                        }
	                        else {
	                            inferFromObjectTypes(source, target);
	                        }
	                    }
	                }
	            }
	            function inferFromContravariantTypes(source, target) {
	                if (strictFunctionTypes || priority & 64 /* AlwaysStrict */) {
	                    contravariant = !contravariant;
	                    inferFromTypes(source, target);
	                    contravariant = !contravariant;
	                }
	                else {
	                    inferFromTypes(source, target);
	                }
	            }
	            function getInferenceInfoForType(type) {
	                if (type.flags & 1081344 /* TypeVariable */) {
	                    for (var _i = 0, inferences_1 = inferences; _i < inferences_1.length; _i++) {
	                        var inference = inferences_1[_i];
	                        if (type === inference.typeParameter) {
	                            return inference;
	                        }
	                    }
	                }
	                return undefined;
	            }
	            function inferFromObjectTypes(source, target) {
	                if (isGenericMappedType(source) && isGenericMappedType(target)) {
	                    // The source and target types are generic types { [P in S]: X } and { [P in T]: Y }, so we infer
	                    // from S to T and from X to Y.
	                    inferFromTypes(getConstraintTypeFromMappedType(source), getConstraintTypeFromMappedType(target));
	                    inferFromTypes(getTemplateTypeFromMappedType(source), getTemplateTypeFromMappedType(target));
	                }
	                if (ts.getObjectFlags(target) & 32 /* Mapped */) {
	                    var constraintType = getConstraintTypeFromMappedType(target);
	                    if (constraintType.flags & 524288 /* Index */) {
	                        // We're inferring from some source type S to a homomorphic mapped type { [P in keyof T]: X },
	                        // where T is a type variable. Use inferTypeForHomomorphicMappedType to infer a suitable source
	                        // type and then make a secondary inference from that type to T. We make a secondary inference
	                        // such that direct inferences to T get priority over inferences to Partial<T>, for example.
	                        var inference = getInferenceInfoForType(constraintType.type);
	                        if (inference && !inference.isFixed) {
	                            var inferredType = inferTypeForHomomorphicMappedType(source, target);
	                            if (inferredType) {
	                                var savePriority = priority;
	                                priority |= 2 /* HomomorphicMappedType */;
	                                inferFromTypes(inferredType, inference.typeParameter);
	                                priority = savePriority;
	                            }
	                        }
	                        return;
	                    }
	                    if (constraintType.flags & 32768 /* TypeParameter */) {
	                        // We're inferring from some source type S to a mapped type { [P in T]: X }, where T is a type
	                        // parameter. Infer from 'keyof S' to T and infer from a union of each property type in S to X.
	                        var savePriority = priority;
	                        priority |= 4 /* MappedTypeConstraint */;
	                        inferFromTypes(getIndexType(source), constraintType);
	                        priority = savePriority;
	                        inferFromTypes(getUnionType(ts.map(getPropertiesOfType(source), getTypeOfSymbol)), getTemplateTypeFromMappedType(target));
	                        return;
	                    }
	                }
	                // Infer from the members of source and target only if the two types are possibly related
	                if (!typesDefinitelyUnrelated(source, target)) {
	                    inferFromProperties(source, target);
	                    inferFromSignatures(source, target, 0 /* Call */);
	                    inferFromSignatures(source, target, 1 /* Construct */);
	                    inferFromIndexTypes(source, target);
	                }
	            }
	            function inferFromProperties(source, target) {
	                var properties = getPropertiesOfObjectType(target);
	                for (var _i = 0, properties_6 = properties; _i < properties_6.length; _i++) {
	                    var targetProp = properties_6[_i];
	                    var sourceProp = getPropertyOfType(source, targetProp.escapedName);
	                    if (sourceProp) {
	                        inferFromTypes(getTypeOfSymbol(sourceProp), getTypeOfSymbol(targetProp));
	                    }
	                }
	            }
	            function inferFromSignatures(source, target, kind) {
	                var sourceSignatures = getSignaturesOfType(source, kind);
	                var targetSignatures = getSignaturesOfType(target, kind);
	                var sourceLen = sourceSignatures.length;
	                var targetLen = targetSignatures.length;
	                var len = sourceLen < targetLen ? sourceLen : targetLen;
	                for (var i = 0; i < len; i++) {
	                    inferFromSignature(getBaseSignature(sourceSignatures[sourceLen - len + i]), getBaseSignature(targetSignatures[targetLen - len + i]));
	                }
	            }
	            function inferFromSignature(source, target) {
	                forEachMatchingParameterType(source, target, inferFromContravariantTypes);
	                var sourceTypePredicate = getTypePredicateOfSignature(source);
	                var targetTypePredicate = getTypePredicateOfSignature(target);
	                if (sourceTypePredicate && targetTypePredicate && sourceTypePredicate.kind === targetTypePredicate.kind) {
	                    inferFromTypes(sourceTypePredicate.type, targetTypePredicate.type);
	                }
	                else {
	                    inferFromTypes(getReturnTypeOfSignature(source), getReturnTypeOfSignature(target));
	                }
	            }
	            function inferFromIndexTypes(source, target) {
	                var targetStringIndexType = getIndexTypeOfType(target, 0 /* String */);
	                if (targetStringIndexType) {
	                    var sourceIndexType = getIndexTypeOfType(source, 0 /* String */) ||
	                        getImplicitIndexTypeOfType(source, 0 /* String */);
	                    if (sourceIndexType) {
	                        inferFromTypes(sourceIndexType, targetStringIndexType);
	                    }
	                }
	                var targetNumberIndexType = getIndexTypeOfType(target, 1 /* Number */);
	                if (targetNumberIndexType) {
	                    var sourceIndexType = getIndexTypeOfType(source, 1 /* Number */) ||
	                        getIndexTypeOfType(source, 0 /* String */) ||
	                        getImplicitIndexTypeOfType(source, 1 /* Number */);
	                    if (sourceIndexType) {
	                        inferFromTypes(sourceIndexType, targetNumberIndexType);
	                    }
	                }
	            }
	        }
	        function typeIdenticalToSomeType(type, types) {
	            for (var _i = 0, types_11 = types; _i < types_11.length; _i++) {
	                var t = types_11[_i];
	                if (isTypeIdenticalTo(t, type)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Return a new union or intersection type computed by removing a given set of types
	         * from a given union or intersection type.
	         */
	        function removeTypesFromUnionOrIntersection(type, typesToRemove) {
	            var reducedTypes = [];
	            for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (!typeIdenticalToSomeType(t, typesToRemove)) {
	                    reducedTypes.push(t);
	                }
	            }
	            return type.flags & 131072 /* Union */ ? getUnionType(reducedTypes) : getIntersectionType(reducedTypes);
	        }
	        function hasPrimitiveConstraint(type) {
	            var constraint = getConstraintOfTypeParameter(type);
	            return constraint && maybeTypeOfKind(constraint, 16382 /* Primitive */ | 524288 /* Index */);
	        }
	        function isObjectLiteralType(type) {
	            return !!(ts.getObjectFlags(type) & 128 /* ObjectLiteral */);
	        }
	        function widenObjectLiteralCandidates(candidates) {
	            if (candidates.length > 1) {
	                var objectLiterals = ts.filter(candidates, isObjectLiteralType);
	                if (objectLiterals.length) {
	                    var objectLiteralsType = getWidenedType(getUnionType(objectLiterals, 2 /* Subtype */));
	                    return ts.concatenate(ts.filter(candidates, function (t) { return !isObjectLiteralType(t); }), [objectLiteralsType]);
	                }
	            }
	            return candidates;
	        }
	        function getContravariantInference(inference) {
	            return inference.priority & 28 /* PriorityImpliesCombination */ ? getIntersectionType(inference.contraCandidates) : getCommonSubtype(inference.contraCandidates);
	        }
	        function getCovariantInference(inference, context, signature) {
	            // Extract all object literal types and replace them with a single widened and normalized type.
	            var candidates = widenObjectLiteralCandidates(inference.candidates);
	            // We widen inferred literal types if
	            // all inferences were made to top-level occurrences of the type parameter, and
	            // the type parameter has no constraint or its constraint includes no primitive or literal types, and
	            // the type parameter was fixed during inference or does not occur at top-level in the return type.
	            var primitiveConstraint = hasPrimitiveConstraint(inference.typeParameter);
	            var widenLiteralTypes = !primitiveConstraint && inference.topLevel &&
	                (inference.isFixed || !isTypeParameterAtTopLevel(getReturnTypeOfSignature(signature), inference.typeParameter));
	            var baseCandidates = primitiveConstraint ? ts.sameMap(candidates, getRegularTypeOfLiteralType) :
	                widenLiteralTypes ? ts.sameMap(candidates, getWidenedLiteralType) :
	                    candidates;
	            // If all inferences were made from contravariant positions, infer a common subtype. Otherwise, if
	            // union types were requested or if all inferences were made from the return type position, infer a
	            // union type. Otherwise, infer a common supertype.
	            var unwidenedType = context.flags & 1 /* InferUnionTypes */ || inference.priority & 28 /* PriorityImpliesCombination */ ?
	                getUnionType(baseCandidates, 2 /* Subtype */) :
	                getCommonSupertype(baseCandidates);
	            return getWidenedType(unwidenedType);
	        }
	        function getInferredType(context, index) {
	            var inference = context.inferences[index];
	            var inferredType = inference.inferredType;
	            if (!inferredType) {
	                var signature = context.signature;
	                if (signature) {
	                    if (inference.candidates) {
	                        inferredType = getCovariantInference(inference, context, signature);
	                        // If we have inferred 'never' but have contravariant candidates. To get a more specific type we
	                        // infer from the contravariant candidates instead.
	                        if (inferredType.flags & 16384 /* Never */ && inference.contraCandidates) {
	                            inferredType = getContravariantInference(inference);
	                        }
	                    }
	                    else if (inference.contraCandidates) {
	                        // We only have contravariant inferences, infer the best common subtype of those
	                        inferredType = getContravariantInference(inference);
	                    }
	                    else if (context.flags & 2 /* NoDefault */) {
	                        // We use silentNeverType as the wildcard that signals no inferences.
	                        inferredType = silentNeverType;
	                    }
	                    else {
	                        // Infer either the default or the empty object type when no inferences were
	                        // made. It is important to remember that in this case, inference still
	                        // succeeds, meaning there is no error for not having inference candidates. An
	                        // inference error only occurs when there are *conflicting* candidates, i.e.
	                        // candidates with no common supertype.
	                        var defaultType = getDefaultFromTypeParameter(inference.typeParameter);
	                        if (defaultType) {
	                            // Instantiate the default type. Any forward reference to a type
	                            // parameter should be instantiated to the empty object type.
	                            inferredType = instantiateType(defaultType, combineTypeMappers(createBackreferenceMapper(context.signature.typeParameters, index), context));
	                        }
	                        else {
	                            inferredType = getDefaultTypeArgumentType(!!(context.flags & 4 /* AnyDefault */));
	                        }
	                    }
	                }
	                else {
	                    inferredType = getTypeFromInference(inference);
	                }
	                inference.inferredType = inferredType;
	                var constraint = getConstraintOfTypeParameter(inference.typeParameter);
	                if (constraint) {
	                    var instantiatedConstraint = instantiateType(constraint, context);
	                    if (!context.compareTypes(inferredType, getTypeWithThisArgument(instantiatedConstraint, inferredType))) {
	                        inference.inferredType = inferredType = instantiatedConstraint;
	                    }
	                }
	            }
	            return inferredType;
	        }
	        function getDefaultTypeArgumentType(isInJavaScriptFile) {
	            return isInJavaScriptFile ? anyType : emptyObjectType;
	        }
	        function getInferredTypes(context) {
	            var result = [];
	            for (var i = 0; i < context.inferences.length; i++) {
	                result.push(getInferredType(context, i));
	            }
	            return result;
	        }
	        // EXPRESSION TYPE CHECKING
	        function getResolvedSymbol(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedSymbol) {
	                links.resolvedSymbol = !ts.nodeIsMissing(node) &&
	                    resolveName(node, node.escapedText, 67216319 /* Value */ | 1048576 /* ExportValue */, ts.Diagnostics.Cannot_find_name_0, node, !ts.isWriteOnlyAccess(node), 
	                    /*excludeGlobals*/ false, ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1) || unknownSymbol;
	            }
	            return links.resolvedSymbol;
	        }
	        function isInTypeQuery(node) {
	            // TypeScript 1.0 spec (April 2014): 3.6.3
	            // A type query consists of the keyword typeof followed by an expression.
	            // The expression is restricted to a single identifier or a sequence of identifiers separated by periods
	            return !!ts.findAncestor(node, function (n) { return n.kind === 164 /* TypeQuery */ ? true : n.kind === 71 /* Identifier */ || n.kind === 145 /* QualifiedName */ ? false : "quit"; });
	        }
	        // Return the flow cache key for a "dotted name" (i.e. a sequence of identifiers
	        // separated by dots). The key consists of the id of the symbol referenced by the
	        // leftmost identifier followed by zero or more property names separated by dots.
	        // The result is undefined if the reference isn't a dotted name. We prefix nodes
	        // occurring in an apparent type position with '@' because the control flow type
	        // of such nodes may be based on the apparent type instead of the declared type.
	        function getFlowCacheKey(node) {
	            if (node.kind === 71 /* Identifier */) {
	                var symbol = getResolvedSymbol(node);
	                return symbol !== unknownSymbol ? (isConstraintPosition(node) ? "@" : "") + getSymbolId(symbol) : undefined;
	            }
	            if (node.kind === 99 /* ThisKeyword */) {
	                return "0";
	            }
	            if (node.kind === 184 /* PropertyAccessExpression */) {
	                var key = getFlowCacheKey(node.expression);
	                return key && key + "." + ts.idText(node.name);
	            }
	            if (node.kind === 181 /* BindingElement */) {
	                var container = node.parent.parent;
	                var key = container.kind === 181 /* BindingElement */ ? getFlowCacheKey(container) : (container.initializer && getFlowCacheKey(container.initializer));
	                var text = getBindingElementNameText(node);
	                var result = key && text && (key + "." + text);
	                return result;
	            }
	            return undefined;
	        }
	        function getBindingElementNameText(element) {
	            if (element.parent.kind === 179 /* ObjectBindingPattern */) {
	                var name = element.propertyName || element.name;
	                switch (name.kind) {
	                    case 71 /* Identifier */:
	                        return ts.idText(name);
	                    case 146 /* ComputedPropertyName */:
	                        return ts.isStringOrNumericLiteral(name.expression) ? name.expression.text : undefined;
	                    case 9 /* StringLiteral */:
	                    case 8 /* NumericLiteral */:
	                        return name.text;
	                    default:
	                        // Per types, array and object binding patterns remain, however they should never be present if propertyName is not defined
	                        ts.Debug.fail("Unexpected name kind for binding element name");
	                }
	            }
	            else {
	                return "" + element.parent.elements.indexOf(element);
	            }
	        }
	        function isMatchingReference(source, target) {
	            switch (source.kind) {
	                case 71 /* Identifier */:
	                    return target.kind === 71 /* Identifier */ && getResolvedSymbol(source) === getResolvedSymbol(target) ||
	                        (target.kind === 231 /* VariableDeclaration */ || target.kind === 181 /* BindingElement */) &&
	                            getExportSymbolOfValueSymbolIfExported(getResolvedSymbol(source)) === getSymbolOfNode(target);
	                case 99 /* ThisKeyword */:
	                    return target.kind === 99 /* ThisKeyword */;
	                case 97 /* SuperKeyword */:
	                    return target.kind === 97 /* SuperKeyword */;
	                case 184 /* PropertyAccessExpression */:
	                    return target.kind === 184 /* PropertyAccessExpression */ &&
	                        source.name.escapedText === target.name.escapedText &&
	                        isMatchingReference(source.expression, target.expression);
	                case 181 /* BindingElement */:
	                    if (target.kind !== 184 /* PropertyAccessExpression */)
	                        return false;
	                    var t = target;
	                    if (t.name.escapedText !== getBindingElementNameText(source))
	                        return false;
	                    if (source.parent.parent.kind === 181 /* BindingElement */ && isMatchingReference(source.parent.parent, t.expression)) {
	                        return true;
	                    }
	                    if (source.parent.parent.kind === 231 /* VariableDeclaration */) {
	                        var maybeId = source.parent.parent.initializer;
	                        return maybeId && isMatchingReference(maybeId, t.expression);
	                    }
	            }
	            return false;
	        }
	        function containsMatchingReference(source, target) {
	            while (source.kind === 184 /* PropertyAccessExpression */) {
	                source = source.expression;
	                if (isMatchingReference(source, target)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        // Return true if target is a property access xxx.yyy, source is a property access xxx.zzz, the declared
	        // type of xxx is a union type, and yyy is a property that is possibly a discriminant. We consider a property
	        // a possible discriminant if its type differs in the constituents of containing union type, and if every
	        // choice is a unit type or a union of unit types.
	        function containsMatchingReferenceDiscriminant(source, target) {
	            return target.kind === 184 /* PropertyAccessExpression */ &&
	                containsMatchingReference(source, target.expression) &&
	                isDiscriminantProperty(getDeclaredTypeOfReference(target.expression), target.name.escapedText);
	        }
	        function getDeclaredTypeOfReference(expr) {
	            if (expr.kind === 71 /* Identifier */) {
	                return getTypeOfSymbol(getResolvedSymbol(expr));
	            }
	            if (expr.kind === 184 /* PropertyAccessExpression */) {
	                var type = getDeclaredTypeOfReference(expr.expression);
	                return type && getTypeOfPropertyOfType(type, expr.name.escapedText);
	            }
	            return undefined;
	        }
	        function isDiscriminantProperty(type, name) {
	            if (type && type.flags & 131072 /* Union */) {
	                var prop = getUnionOrIntersectionProperty(type, name);
	                if (prop && ts.getCheckFlags(prop) & 2 /* SyntheticProperty */) {
	                    if (prop.isDiscriminantProperty === undefined) {
	                        prop.isDiscriminantProperty = prop.checkFlags & 32 /* HasNonUniformType */ && isLiteralType(getTypeOfSymbol(prop));
	                    }
	                    return prop.isDiscriminantProperty;
	                }
	            }
	            return false;
	        }
	        function findDiscriminantProperties(sourceProperties, target) {
	            var result;
	            for (var _i = 0, sourceProperties_2 = sourceProperties; _i < sourceProperties_2.length; _i++) {
	                var sourceProperty = sourceProperties_2[_i];
	                if (isDiscriminantProperty(target, sourceProperty.escapedName)) {
	                    if (result) {
	                        result.push(sourceProperty);
	                        continue;
	                    }
	                    result = [sourceProperty];
	                }
	            }
	            return result;
	        }
	        function isOrContainsMatchingReference(source, target) {
	            return isMatchingReference(source, target) || containsMatchingReference(source, target);
	        }
	        function hasMatchingArgument(callExpression, reference) {
	            if (callExpression.arguments) {
	                for (var _i = 0, _a = callExpression.arguments; _i < _a.length; _i++) {
	                    var argument = _a[_i];
	                    if (isOrContainsMatchingReference(reference, argument)) {
	                        return true;
	                    }
	                }
	            }
	            if (callExpression.expression.kind === 184 /* PropertyAccessExpression */ &&
	                isOrContainsMatchingReference(reference, callExpression.expression.expression)) {
	                return true;
	            }
	            return false;
	        }
	        function getFlowNodeId(flow) {
	            if (!flow.id) {
	                flow.id = nextFlowId;
	                nextFlowId++;
	            }
	            return flow.id;
	        }
	        function typeMaybeAssignableTo(source, target) {
	            if (!(source.flags & 131072 /* Union */)) {
	                return isTypeAssignableTo(source, target);
	            }
	            for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                var t = _a[_i];
	                if (isTypeAssignableTo(t, target)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        // Remove those constituent types of declaredType to which no constituent type of assignedType is assignable.
	        // For example, when a variable of type number | string | boolean is assigned a value of type number | boolean,
	        // we remove type string.
	        function getAssignmentReducedType(declaredType, assignedType) {
	            if (declaredType !== assignedType) {
	                if (assignedType.flags & 16384 /* Never */) {
	                    return assignedType;
	                }
	                var reducedType = filterType(declaredType, function (t) { return typeMaybeAssignableTo(assignedType, t); });
	                if (!(reducedType.flags & 16384 /* Never */)) {
	                    return reducedType;
	                }
	            }
	            return declaredType;
	        }
	        function getTypeFactsOfTypes(types) {
	            var result = 0 /* None */;
	            for (var _i = 0, types_12 = types; _i < types_12.length; _i++) {
	                var t = types_12[_i];
	                result |= getTypeFacts(t);
	            }
	            return result;
	        }
	        function isFunctionObjectType(type) {
	            // We do a quick check for a "bind" property before performing the more expensive subtype
	            // check. This gives us a quicker out in the common case where an object type is not a function.
	            var resolved = resolveStructuredTypeMembers(type);
	            return !!(resolved.callSignatures.length || resolved.constructSignatures.length ||
	                resolved.members.get("bind") && isTypeSubtypeOf(type, globalFunctionType));
	        }
	        function getTypeFacts(type) {
	            var flags = type.flags;
	            if (flags & 2 /* String */) {
	                return strictNullChecks ? 4079361 /* StringStrictFacts */ : 4194049 /* StringFacts */;
	            }
	            if (flags & 32 /* StringLiteral */) {
	                var isEmpty = type.value === "";
	                return strictNullChecks ?
	                    isEmpty ? 3030785 /* EmptyStringStrictFacts */ : 1982209 /* NonEmptyStringStrictFacts */ :
	                    isEmpty ? 3145473 /* EmptyStringFacts */ : 4194049 /* NonEmptyStringFacts */;
	            }
	            if (flags & (4 /* Number */ | 16 /* Enum */)) {
	                return strictNullChecks ? 4079234 /* NumberStrictFacts */ : 4193922 /* NumberFacts */;
	            }
	            if (flags & 64 /* NumberLiteral */) {
	                var isZero = type.value === 0;
	                return strictNullChecks ?
	                    isZero ? 3030658 /* ZeroStrictFacts */ : 1982082 /* NonZeroStrictFacts */ :
	                    isZero ? 3145346 /* ZeroFacts */ : 4193922 /* NonZeroFacts */;
	            }
	            if (flags & 8 /* Boolean */) {
	                return strictNullChecks ? 4078980 /* BooleanStrictFacts */ : 4193668 /* BooleanFacts */;
	            }
	            if (flags & 136 /* BooleanLike */) {
	                return strictNullChecks ?
	                    type === falseType ? 3030404 /* FalseStrictFacts */ : 1981828 /* TrueStrictFacts */ :
	                    type === falseType ? 3145092 /* FalseFacts */ : 4193668 /* TrueFacts */;
	            }
	            if (flags & 65536 /* Object */) {
	                return isFunctionObjectType(type) ?
	                    strictNullChecks ? 1970144 /* FunctionStrictFacts */ : 4181984 /* FunctionFacts */ :
	                    strictNullChecks ? 1972176 /* ObjectStrictFacts */ : 4184016 /* ObjectFacts */;
	            }
	            if (flags & (2048 /* Void */ | 4096 /* Undefined */)) {
	                return 2457472 /* UndefinedFacts */;
	            }
	            if (flags & 8192 /* Null */) {
	                return 2340752 /* NullFacts */;
	            }
	            if (flags & 1536 /* ESSymbolLike */) {
	                return strictNullChecks ? 1981320 /* SymbolStrictFacts */ : 4193160 /* SymbolFacts */;
	            }
	            if (flags & 134217728 /* NonPrimitive */) {
	                return strictNullChecks ? 1972176 /* ObjectStrictFacts */ : 4184016 /* ObjectFacts */;
	            }
	            if (flags & 7897088 /* Instantiable */) {
	                return getTypeFacts(getBaseConstraintOfType(type) || emptyObjectType);
	            }
	            if (flags & 393216 /* UnionOrIntersection */) {
	                return getTypeFactsOfTypes(type.types);
	            }
	            return 4194303 /* All */;
	        }
	        function getTypeWithFacts(type, include) {
	            return filterType(type, function (t) { return (getTypeFacts(t) & include) !== 0; });
	        }
	        function getTypeWithDefault(type, defaultExpression) {
	            if (defaultExpression) {
	                var defaultType = getTypeOfExpression(defaultExpression);
	                return getUnionType([getTypeWithFacts(type, 131072 /* NEUndefined */), defaultType]);
	            }
	            return type;
	        }
	        function getTypeOfDestructuredProperty(type, name) {
	            var text = ts.getTextOfPropertyName(name);
	            return getConstraintForLocation(getTypeOfPropertyOfType(type, text), name) ||
	                isNumericLiteralName(text) && getIndexTypeOfType(type, 1 /* Number */) ||
	                getIndexTypeOfType(type, 0 /* String */) ||
	                unknownType;
	        }
	        function getTypeOfDestructuredArrayElement(type, index) {
	            return isTupleLikeType(type) && getTypeOfPropertyOfType(type, "" + index) ||
	                checkIteratedTypeOrElementType(type, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) ||
	                unknownType;
	        }
	        function getTypeOfDestructuredSpreadExpression(type) {
	            return createArrayType(checkIteratedTypeOrElementType(type, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType);
	        }
	        function getAssignedTypeOfBinaryExpression(node) {
	            var isDestructuringDefaultAssignment = node.parent.kind === 182 /* ArrayLiteralExpression */ && isDestructuringAssignmentTarget(node.parent) ||
	                node.parent.kind === 269 /* PropertyAssignment */ && isDestructuringAssignmentTarget(node.parent.parent);
	            return isDestructuringDefaultAssignment ?
	                getTypeWithDefault(getAssignedType(node), node.right) :
	                getTypeOfExpression(node.right);
	        }
	        function isDestructuringAssignmentTarget(parent) {
	            return parent.parent.kind === 199 /* BinaryExpression */ && parent.parent.left === parent ||
	                parent.parent.kind === 221 /* ForOfStatement */ && parent.parent.initializer === parent;
	        }
	        function getAssignedTypeOfArrayLiteralElement(node, element) {
	            return getTypeOfDestructuredArrayElement(getAssignedType(node), node.elements.indexOf(element));
	        }
	        function getAssignedTypeOfSpreadExpression(node) {
	            return getTypeOfDestructuredSpreadExpression(getAssignedType(node.parent));
	        }
	        function getAssignedTypeOfPropertyAssignment(node) {
	            return getTypeOfDestructuredProperty(getAssignedType(node.parent), node.name);
	        }
	        function getAssignedTypeOfShorthandPropertyAssignment(node) {
	            return getTypeWithDefault(getAssignedTypeOfPropertyAssignment(node), node.objectAssignmentInitializer);
	        }
	        function getAssignedType(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 220 /* ForInStatement */:
	                    return stringType;
	                case 221 /* ForOfStatement */:
	                    return checkRightHandSideOfForOf(parent.expression, parent.awaitModifier) || unknownType;
	                case 199 /* BinaryExpression */:
	                    return getAssignedTypeOfBinaryExpression(parent);
	                case 193 /* DeleteExpression */:
	                    return undefinedType;
	                case 182 /* ArrayLiteralExpression */:
	                    return getAssignedTypeOfArrayLiteralElement(parent, node);
	                case 203 /* SpreadElement */:
	                    return getAssignedTypeOfSpreadExpression(parent);
	                case 269 /* PropertyAssignment */:
	                    return getAssignedTypeOfPropertyAssignment(parent);
	                case 270 /* ShorthandPropertyAssignment */:
	                    return getAssignedTypeOfShorthandPropertyAssignment(parent);
	            }
	            return unknownType;
	        }
	        function getInitialTypeOfBindingElement(node) {
	            var pattern = node.parent;
	            var parentType = getInitialType(pattern.parent);
	            var type = pattern.kind === 179 /* ObjectBindingPattern */ ?
	                getTypeOfDestructuredProperty(parentType, node.propertyName || node.name) :
	                !node.dotDotDotToken ?
	                    getTypeOfDestructuredArrayElement(parentType, pattern.elements.indexOf(node)) :
	                    getTypeOfDestructuredSpreadExpression(parentType);
	            return getTypeWithDefault(type, node.initializer);
	        }
	        function getTypeOfInitializer(node) {
	            // Return the cached type if one is available. If the type of the variable was inferred
	            // from its initializer, we'll already have cached the type. Otherwise we compute it now
	            // without caching such that transient types are reflected.
	            var links = getNodeLinks(node);
	            return links.resolvedType || getTypeOfExpression(node);
	        }
	        function getInitialTypeOfVariableDeclaration(node) {
	            if (node.initializer) {
	                return getTypeOfInitializer(node.initializer);
	            }
	            if (node.parent.parent.kind === 220 /* ForInStatement */) {
	                return stringType;
	            }
	            if (node.parent.parent.kind === 221 /* ForOfStatement */) {
	                return checkRightHandSideOfForOf(node.parent.parent.expression, node.parent.parent.awaitModifier) || unknownType;
	            }
	            return unknownType;
	        }
	        function getInitialType(node) {
	            return node.kind === 231 /* VariableDeclaration */ ?
	                getInitialTypeOfVariableDeclaration(node) :
	                getInitialTypeOfBindingElement(node);
	        }
	        function getInitialOrAssignedType(node) {
	            return node.kind === 231 /* VariableDeclaration */ || node.kind === 181 /* BindingElement */ ?
	                getInitialType(node) :
	                getAssignedType(node);
	        }
	        function isEmptyArrayAssignment(node) {
	            return node.kind === 231 /* VariableDeclaration */ && node.initializer &&
	                isEmptyArrayLiteral(node.initializer) ||
	                node.kind !== 181 /* BindingElement */ && node.parent.kind === 199 /* BinaryExpression */ &&
	                    isEmptyArrayLiteral(node.parent.right);
	        }
	        function getReferenceCandidate(node) {
	            switch (node.kind) {
	                case 190 /* ParenthesizedExpression */:
	                    return getReferenceCandidate(node.expression);
	                case 199 /* BinaryExpression */:
	                    switch (node.operatorToken.kind) {
	                        case 58 /* EqualsToken */:
	                            return getReferenceCandidate(node.left);
	                        case 26 /* CommaToken */:
	                            return getReferenceCandidate(node.right);
	                    }
	            }
	            return node;
	        }
	        function getReferenceRoot(node) {
	            var parent = node.parent;
	            return parent.kind === 190 /* ParenthesizedExpression */ ||
	                parent.kind === 199 /* BinaryExpression */ && parent.operatorToken.kind === 58 /* EqualsToken */ && parent.left === node ||
	                parent.kind === 199 /* BinaryExpression */ && parent.operatorToken.kind === 26 /* CommaToken */ && parent.right === node ?
	                getReferenceRoot(parent) : node;
	        }
	        function getTypeOfSwitchClause(clause) {
	            if (clause.kind === 265 /* CaseClause */) {
	                return getRegularTypeOfLiteralType(getTypeOfExpression(clause.expression));
	            }
	            return neverType;
	        }
	        function getSwitchClauseTypes(switchStatement) {
	            var links = getNodeLinks(switchStatement);
	            if (!links.switchTypes) {
	                links.switchTypes = [];
	                for (var _i = 0, _a = switchStatement.caseBlock.clauses; _i < _a.length; _i++) {
	                    var clause = _a[_i];
	                    links.switchTypes.push(getTypeOfSwitchClause(clause));
	                }
	            }
	            return links.switchTypes;
	        }
	        function eachTypeContainedIn(source, types) {
	            return source.flags & 131072 /* Union */ ? !ts.forEach(source.types, function (t) { return !ts.contains(types, t); }) : ts.contains(types, source);
	        }
	        function isTypeSubsetOf(source, target) {
	            return source === target || target.flags & 131072 /* Union */ && isTypeSubsetOfUnion(source, target);
	        }
	        function isTypeSubsetOfUnion(source, target) {
	            if (source.flags & 131072 /* Union */) {
	                for (var _i = 0, _a = source.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (!containsType(target.types, t)) {
	                        return false;
	                    }
	                }
	                return true;
	            }
	            if (source.flags & 256 /* EnumLiteral */ && getBaseTypeOfEnumLiteralType(source) === target) {
	                return true;
	            }
	            return containsType(target.types, source);
	        }
	        function forEachType(type, f) {
	            return type.flags & 131072 /* Union */ ? ts.forEach(type.types, f) : f(type);
	        }
	        function filterType(type, f) {
	            if (type.flags & 131072 /* Union */) {
	                var types = type.types;
	                var filtered = ts.filter(types, f);
	                return filtered === types ? type : getUnionTypeFromSortedList(filtered, type.flags & 268435456 /* UnionOfUnitTypes */);
	            }
	            return f(type) ? type : neverType;
	        }
	        // Apply a mapping function to a type and return the resulting type. If the source type
	        // is a union type, the mapping function is applied to each constituent type and a union
	        // of the resulting types is returned.
	        function mapType(type, mapper, noReductions) {
	            if (type.flags & 16384 /* Never */) {
	                return type;
	            }
	            if (!(type.flags & 131072 /* Union */)) {
	                return mapper(type);
	            }
	            var types = type.types;
	            var mappedType;
	            var mappedTypes;
	            for (var _i = 0, types_13 = types; _i < types_13.length; _i++) {
	                var current = types_13[_i];
	                var t = mapper(current);
	                if (t) {
	                    if (!mappedType) {
	                        mappedType = t;
	                    }
	                    else if (!mappedTypes) {
	                        mappedTypes = [mappedType, t];
	                    }
	                    else {
	                        mappedTypes.push(t);
	                    }
	                }
	            }
	            return mappedTypes ? getUnionType(mappedTypes, noReductions ? 0 /* None */ : 1 /* Literal */) : mappedType;
	        }
	        function extractTypesOfKind(type, kind) {
	            return filterType(type, function (t) { return (t.flags & kind) !== 0; });
	        }
	        // Return a new type in which occurrences of the string and number primitive types in
	        // typeWithPrimitives have been replaced with occurrences of string literals and numeric
	        // literals in typeWithLiterals, respectively.
	        function replacePrimitivesWithLiterals(typeWithPrimitives, typeWithLiterals) {
	            if (isTypeSubsetOf(stringType, typeWithPrimitives) && maybeTypeOfKind(typeWithLiterals, 32 /* StringLiteral */) ||
	                isTypeSubsetOf(numberType, typeWithPrimitives) && maybeTypeOfKind(typeWithLiterals, 64 /* NumberLiteral */)) {
	                return mapType(typeWithPrimitives, function (t) {
	                    return t.flags & 2 /* String */ ? extractTypesOfKind(typeWithLiterals, 2 /* String */ | 32 /* StringLiteral */) :
	                        t.flags & 4 /* Number */ ? extractTypesOfKind(typeWithLiterals, 4 /* Number */ | 64 /* NumberLiteral */) :
	                            t;
	                });
	            }
	            return typeWithPrimitives;
	        }
	        function isIncomplete(flowType) {
	            return flowType.flags === 0;
	        }
	        function getTypeFromFlowType(flowType) {
	            return flowType.flags === 0 ? flowType.type : flowType;
	        }
	        function createFlowType(type, incomplete) {
	            return incomplete ? { flags: 0, type: type } : type;
	        }
	        // An evolving array type tracks the element types that have so far been seen in an
	        // 'x.push(value)' or 'x[n] = value' operation along the control flow graph. Evolving
	        // array types are ultimately converted into manifest array types (using getFinalArrayType)
	        // and never escape the getFlowTypeOfReference function.
	        function createEvolvingArrayType(elementType) {
	            var result = createObjectType(256 /* EvolvingArray */);
	            result.elementType = elementType;
	            return result;
	        }
	        function getEvolvingArrayType(elementType) {
	            return evolvingArrayTypes[elementType.id] || (evolvingArrayTypes[elementType.id] = createEvolvingArrayType(elementType));
	        }
	        // When adding evolving array element types we do not perform subtype reduction. Instead,
	        // we defer subtype reduction until the evolving array type is finalized into a manifest
	        // array type.
	        function addEvolvingArrayElementType(evolvingArrayType, node) {
	            var elementType = getBaseTypeOfLiteralType(getContextFreeTypeOfExpression(node));
	            return isTypeSubsetOf(elementType, evolvingArrayType.elementType) ? evolvingArrayType : getEvolvingArrayType(getUnionType([evolvingArrayType.elementType, elementType]));
	        }
	        function createFinalArrayType(elementType) {
	            return elementType.flags & 16384 /* Never */ ?
	                autoArrayType :
	                createArrayType(elementType.flags & 131072 /* Union */ ?
	                    getUnionType(elementType.types, 2 /* Subtype */) :
	                    elementType);
	        }
	        // We perform subtype reduction upon obtaining the final array type from an evolving array type.
	        function getFinalArrayType(evolvingArrayType) {
	            return evolvingArrayType.finalArrayType || (evolvingArrayType.finalArrayType = createFinalArrayType(evolvingArrayType.elementType));
	        }
	        function finalizeEvolvingArrayType(type) {
	            return ts.getObjectFlags(type) & 256 /* EvolvingArray */ ? getFinalArrayType(type) : type;
	        }
	        function getElementTypeOfEvolvingArrayType(type) {
	            return ts.getObjectFlags(type) & 256 /* EvolvingArray */ ? type.elementType : neverType;
	        }
	        function isEvolvingArrayTypeList(types) {
	            var hasEvolvingArrayType = false;
	            for (var _i = 0, types_14 = types; _i < types_14.length; _i++) {
	                var t = types_14[_i];
	                if (!(t.flags & 16384 /* Never */)) {
	                    if (!(ts.getObjectFlags(t) & 256 /* EvolvingArray */)) {
	                        return false;
	                    }
	                    hasEvolvingArrayType = true;
	                }
	            }
	            return hasEvolvingArrayType;
	        }
	        // At flow control branch or loop junctions, if the type along every antecedent code path
	        // is an evolving array type, we construct a combined evolving array type. Otherwise we
	        // finalize all evolving array types.
	        function getUnionOrEvolvingArrayType(types, subtypeReduction) {
	            return isEvolvingArrayTypeList(types) ?
	                getEvolvingArrayType(getUnionType(ts.map(types, getElementTypeOfEvolvingArrayType))) :
	                getUnionType(ts.sameMap(types, finalizeEvolvingArrayType), subtypeReduction);
	        }
	        // Return true if the given node is 'x' in an 'x.length', x.push(value)', 'x.unshift(value)' or
	        // 'x[n] = value' operation, where 'n' is an expression of type any, undefined, or a number-like type.
	        function isEvolvingArrayOperationTarget(node) {
	            var root = getReferenceRoot(node);
	            var parent = root.parent;
	            var isLengthPushOrUnshift = parent.kind === 184 /* PropertyAccessExpression */ && (parent.name.escapedText === "length" ||
	                parent.parent.kind === 186 /* CallExpression */ && ts.isPushOrUnshiftIdentifier(parent.name));
	            var isElementAssignment = parent.kind === 185 /* ElementAccessExpression */ &&
	                parent.expression === root &&
	                parent.parent.kind === 199 /* BinaryExpression */ &&
	                parent.parent.operatorToken.kind === 58 /* EqualsToken */ &&
	                parent.parent.left === parent &&
	                !ts.isAssignmentTarget(parent.parent) &&
	                isTypeAssignableToKind(getTypeOfExpression(parent.argumentExpression), 84 /* NumberLike */);
	            return isLengthPushOrUnshift || isElementAssignment;
	        }
	        function maybeTypePredicateCall(node) {
	            var links = getNodeLinks(node);
	            if (links.maybeTypePredicate === undefined) {
	                links.maybeTypePredicate = getMaybeTypePredicate(node);
	            }
	            return links.maybeTypePredicate;
	        }
	        function getMaybeTypePredicate(node) {
	            if (node.expression.kind !== 97 /* SuperKeyword */) {
	                var funcType = checkNonNullExpression(node.expression);
	                if (funcType !== silentNeverType) {
	                    var apparentType = getApparentType(funcType);
	                    return apparentType !== unknownType && ts.some(getSignaturesOfType(apparentType, 0 /* Call */), signatureHasTypePredicate);
	                }
	            }
	            return false;
	        }
	        function reportFlowControlError(node) {
	            var block = ts.findAncestor(node, ts.isFunctionOrModuleBlock);
	            var sourceFile = ts.getSourceFileOfNode(node);
	            var span = ts.getSpanOfTokenAtPosition(sourceFile, block.statements.pos);
	            diagnostics.add(ts.createFileDiagnostic(sourceFile, span.start, span.length, ts.Diagnostics.The_containing_function_or_module_body_is_too_large_for_control_flow_analysis));
	        }
	        function getFlowTypeOfReference(reference, declaredType, initialType, flowContainer, couldBeUninitialized) {
	            if (initialType === void 0) { initialType = declaredType; }
	            var key;
	            var flowDepth = 0;
	            if (flowAnalysisDisabled) {
	                return unknownType;
	            }
	            if (!reference.flowNode || !couldBeUninitialized && !(declaredType.flags & 142575359 /* Narrowable */)) {
	                return declaredType;
	            }
	            var sharedFlowStart = sharedFlowCount;
	            var evolvedType = getTypeFromFlowType(getTypeAtFlowNode(reference.flowNode));
	            sharedFlowCount = sharedFlowStart;
	            // When the reference is 'x' in an 'x.length', 'x.push(value)', 'x.unshift(value)' or x[n] = value' operation,
	            // we give type 'any[]' to 'x' instead of using the type determined by control flow analysis such that operations
	            // on empty arrays are possible without implicit any errors and new element types can be inferred without
	            // type mismatch errors.
	            var resultType = ts.getObjectFlags(evolvedType) & 256 /* EvolvingArray */ && isEvolvingArrayOperationTarget(reference) ? anyArrayType : finalizeEvolvingArrayType(evolvedType);
	            if (reference.parent && reference.parent.kind === 208 /* NonNullExpression */ && getTypeWithFacts(resultType, 524288 /* NEUndefinedOrNull */).flags & 16384 /* Never */) {
	                return declaredType;
	            }
	            return resultType;
	            function getTypeAtFlowNode(flow) {
	                if (flowDepth === 2500) {
	                    // We have made 2500 recursive invocations. To avoid overflowing the call stack we report an error
	                    // and disable further control flow analysis in the containing function or module body.
	                    flowAnalysisDisabled = true;
	                    reportFlowControlError(reference);
	                    return unknownType;
	                }
	                flowDepth++;
	                while (true) {
	                    var flags = flow.flags;
	                    if (flags & 1024 /* Shared */) {
	                        // We cache results of flow type resolution for shared nodes that were previously visited in
	                        // the same getFlowTypeOfReference invocation. A node is considered shared when it is the
	                        // antecedent of more than one node.
	                        for (var i = sharedFlowStart; i < sharedFlowCount; i++) {
	                            if (sharedFlowNodes[i] === flow) {
	                                flowDepth--;
	                                return sharedFlowTypes[i];
	                            }
	                        }
	                    }
	                    var type = void 0;
	                    if (flags & 4096 /* AfterFinally */) {
	                        // block flow edge: finally -> pre-try (for larger explanation check comment in binder.ts - bindTryStatement
	                        flow.locked = true;
	                        type = getTypeAtFlowNode(flow.antecedent);
	                        flow.locked = false;
	                    }
	                    else if (flags & 2048 /* PreFinally */) {
	                        // locked pre-finally flows are filtered out in getTypeAtFlowBranchLabel
	                        // so here just redirect to antecedent
	                        flow = flow.antecedent;
	                        continue;
	                    }
	                    else if (flags & 16 /* Assignment */) {
	                        type = getTypeAtFlowAssignment(flow);
	                        if (!type) {
	                            flow = flow.antecedent;
	                            continue;
	                        }
	                    }
	                    else if (flags & 96 /* Condition */) {
	                        type = getTypeAtFlowCondition(flow);
	                    }
	                    else if (flags & 128 /* SwitchClause */) {
	                        type = getTypeAtSwitchClause(flow);
	                    }
	                    else if (flags & 12 /* Label */) {
	                        if (flow.antecedents.length === 1) {
	                            flow = flow.antecedents[0];
	                            continue;
	                        }
	                        type = flags & 4 /* BranchLabel */ ?
	                            getTypeAtFlowBranchLabel(flow) :
	                            getTypeAtFlowLoopLabel(flow);
	                    }
	                    else if (flags & 256 /* ArrayMutation */) {
	                        type = getTypeAtFlowArrayMutation(flow);
	                        if (!type) {
	                            flow = flow.antecedent;
	                            continue;
	                        }
	                    }
	                    else if (flags & 2 /* Start */) {
	                        // Check if we should continue with the control flow of the containing function.
	                        var container = flow.container;
	                        if (container && container !== flowContainer && reference.kind !== 184 /* PropertyAccessExpression */ && reference.kind !== 99 /* ThisKeyword */) {
	                            flow = container.flowNode;
	                            continue;
	                        }
	                        // At the top of the flow we have the initial type.
	                        type = initialType;
	                    }
	                    else {
	                        // Unreachable code errors are reported in the binding phase. Here we
	                        // simply return the non-auto declared type to reduce follow-on errors.
	                        type = convertAutoToAny(declaredType);
	                    }
	                    if (flags & 1024 /* Shared */) {
	                        // Record visited node and the associated type in the cache.
	                        sharedFlowNodes[sharedFlowCount] = flow;
	                        sharedFlowTypes[sharedFlowCount] = type;
	                        sharedFlowCount++;
	                    }
	                    flowDepth--;
	                    return type;
	                }
	            }
	            function getTypeAtFlowAssignment(flow) {
	                var node = flow.node;
	                // Assignments only narrow the computed type if the declared type is a union type. Thus, we
	                // only need to evaluate the assigned type if the declared type is a union type.
	                if (isMatchingReference(reference, node)) {
	                    if (ts.getAssignmentTargetKind(node) === 2 /* Compound */) {
	                        var flowType = getTypeAtFlowNode(flow.antecedent);
	                        return createFlowType(getBaseTypeOfLiteralType(getTypeFromFlowType(flowType)), isIncomplete(flowType));
	                    }
	                    if (declaredType === autoType || declaredType === autoArrayType) {
	                        if (isEmptyArrayAssignment(node)) {
	                            return getEvolvingArrayType(neverType);
	                        }
	                        var assignedType = getBaseTypeOfLiteralType(getInitialOrAssignedType(node));
	                        return isTypeAssignableTo(assignedType, declaredType) ? assignedType : anyArrayType;
	                    }
	                    if (declaredType.flags & 131072 /* Union */) {
	                        return getAssignmentReducedType(declaredType, getInitialOrAssignedType(node));
	                    }
	                    return declaredType;
	                }
	                // We didn't have a direct match. However, if the reference is a dotted name, this
	                // may be an assignment to a left hand part of the reference. For example, for a
	                // reference 'x.y.z', we may be at an assignment to 'x.y' or 'x'. In that case,
	                // return the declared type.
	                if (containsMatchingReference(reference, node)) {
	                    return declaredType;
	                }
	                // Assignment doesn't affect reference
	                return undefined;
	            }
	            function getTypeAtFlowArrayMutation(flow) {
	                if (declaredType === autoType || declaredType === autoArrayType) {
	                    var node = flow.node;
	                    var expr = node.kind === 186 /* CallExpression */ ?
	                        node.expression.expression :
	                        node.left.expression;
	                    if (isMatchingReference(reference, getReferenceCandidate(expr))) {
	                        var flowType = getTypeAtFlowNode(flow.antecedent);
	                        var type = getTypeFromFlowType(flowType);
	                        if (ts.getObjectFlags(type) & 256 /* EvolvingArray */) {
	                            var evolvedType_1 = type;
	                            if (node.kind === 186 /* CallExpression */) {
	                                for (var _i = 0, _a = node.arguments; _i < _a.length; _i++) {
	                                    var arg = _a[_i];
	                                    evolvedType_1 = addEvolvingArrayElementType(evolvedType_1, arg);
	                                }
	                            }
	                            else {
	                                var indexType = getTypeOfExpression(node.left.argumentExpression);
	                                if (isTypeAssignableToKind(indexType, 84 /* NumberLike */)) {
	                                    evolvedType_1 = addEvolvingArrayElementType(evolvedType_1, node.right);
	                                }
	                            }
	                            return evolvedType_1 === type ? flowType : createFlowType(evolvedType_1, isIncomplete(flowType));
	                        }
	                        return flowType;
	                    }
	                }
	                return undefined;
	            }
	            function getTypeAtFlowCondition(flow) {
	                var flowType = getTypeAtFlowNode(flow.antecedent);
	                var type = getTypeFromFlowType(flowType);
	                if (type.flags & 16384 /* Never */) {
	                    return flowType;
	                }
	                // If we have an antecedent type (meaning we're reachable in some way), we first
	                // attempt to narrow the antecedent type. If that produces the never type, and if
	                // the antecedent type is incomplete (i.e. a transient type in a loop), then we
	                // take the type guard as an indication that control *could* reach here once we
	                // have the complete type. We proceed by switching to the silent never type which
	                // doesn't report errors when operators are applied to it. Note that this is the
	                // *only* place a silent never type is ever generated.
	                var assumeTrue = (flow.flags & 32 /* TrueCondition */) !== 0;
	                var nonEvolvingType = finalizeEvolvingArrayType(type);
	                var narrowedType = narrowType(nonEvolvingType, flow.expression, assumeTrue);
	                if (narrowedType === nonEvolvingType) {
	                    return flowType;
	                }
	                var incomplete = isIncomplete(flowType);
	                var resultType = incomplete && narrowedType.flags & 16384 /* Never */ ? silentNeverType : narrowedType;
	                return createFlowType(resultType, incomplete);
	            }
	            function getTypeAtSwitchClause(flow) {
	                var flowType = getTypeAtFlowNode(flow.antecedent);
	                var type = getTypeFromFlowType(flowType);
	                var expr = flow.switchStatement.expression;
	                if (isMatchingReference(reference, expr)) {
	                    type = narrowTypeBySwitchOnDiscriminant(type, flow.switchStatement, flow.clauseStart, flow.clauseEnd);
	                }
	                else if (isMatchingReferenceDiscriminant(expr, type)) {
	                    type = narrowTypeByDiscriminant(type, expr, function (t) { return narrowTypeBySwitchOnDiscriminant(t, flow.switchStatement, flow.clauseStart, flow.clauseEnd); });
	                }
	                return createFlowType(type, isIncomplete(flowType));
	            }
	            function getTypeAtFlowBranchLabel(flow) {
	                var antecedentTypes = [];
	                var subtypeReduction = false;
	                var seenIncomplete = false;
	                for (var _i = 0, _a = flow.antecedents; _i < _a.length; _i++) {
	                    var antecedent = _a[_i];
	                    if (antecedent.flags & 2048 /* PreFinally */ && antecedent.lock.locked) {
	                        // if flow correspond to branch from pre-try to finally and this branch is locked - this means that
	                        // we initially have started following the flow outside the finally block.
	                        // in this case we should ignore this branch.
	                        continue;
	                    }
	                    var flowType = getTypeAtFlowNode(antecedent);
	                    var type = getTypeFromFlowType(flowType);
	                    // If the type at a particular antecedent path is the declared type and the
	                    // reference is known to always be assigned (i.e. when declared and initial types
	                    // are the same), there is no reason to process more antecedents since the only
	                    // possible outcome is subtypes that will be removed in the final union type anyway.
	                    if (type === declaredType && declaredType === initialType) {
	                        return type;
	                    }
	                    ts.pushIfUnique(antecedentTypes, type);
	                    // If an antecedent type is not a subset of the declared type, we need to perform
	                    // subtype reduction. This happens when a "foreign" type is injected into the control
	                    // flow using the instanceof operator or a user defined type predicate.
	                    if (!isTypeSubsetOf(type, declaredType)) {
	                        subtypeReduction = true;
	                    }
	                    if (isIncomplete(flowType)) {
	                        seenIncomplete = true;
	                    }
	                }
	                return createFlowType(getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */ : 1 /* Literal */), seenIncomplete);
	            }
	            function getTypeAtFlowLoopLabel(flow) {
	                // If we have previously computed the control flow type for the reference at
	                // this flow loop junction, return the cached type.
	                var id = getFlowNodeId(flow);
	                var cache = flowLoopCaches[id] || (flowLoopCaches[id] = ts.createMap());
	                if (!key) {
	                    key = getFlowCacheKey(reference);
	                    // No cache key is generated when binding patterns are in unnarrowable situations
	                    if (!key) {
	                        return declaredType;
	                    }
	                }
	                var cached = cache.get(key);
	                if (cached) {
	                    return cached;
	                }
	                // If this flow loop junction and reference are already being processed, return
	                // the union of the types computed for each branch so far, marked as incomplete.
	                // It is possible to see an empty array in cases where loops are nested and the
	                // back edge of the outer loop reaches an inner loop that is already being analyzed.
	                // In such cases we restart the analysis of the inner loop, which will then see
	                // a non-empty in-process array for the outer loop and eventually terminate because
	                // the first antecedent of a loop junction is always the non-looping control flow
	                // path that leads to the top.
	                for (var i = flowLoopStart; i < flowLoopCount; i++) {
	                    if (flowLoopNodes[i] === flow && flowLoopKeys[i] === key && flowLoopTypes[i].length) {
	                        return createFlowType(getUnionOrEvolvingArrayType(flowLoopTypes[i], 1 /* Literal */), /*incomplete*/ true);
	                    }
	                }
	                // Add the flow loop junction and reference to the in-process stack and analyze
	                // each antecedent code path.
	                var antecedentTypes = [];
	                var subtypeReduction = false;
	                var firstAntecedentType;
	                flowLoopNodes[flowLoopCount] = flow;
	                flowLoopKeys[flowLoopCount] = key;
	                flowLoopTypes[flowLoopCount] = antecedentTypes;
	                for (var _i = 0, _a = flow.antecedents; _i < _a.length; _i++) {
	                    var antecedent = _a[_i];
	                    flowLoopCount++;
	                    var flowType = getTypeAtFlowNode(antecedent);
	                    flowLoopCount--;
	                    if (!firstAntecedentType) {
	                        firstAntecedentType = flowType;
	                    }
	                    var type = getTypeFromFlowType(flowType);
	                    // If we see a value appear in the cache it is a sign that control flow analysis
	                    // was restarted and completed by checkExpressionCached. We can simply pick up
	                    // the resulting type and bail out.
	                    var cached_1 = cache.get(key);
	                    if (cached_1) {
	                        return cached_1;
	                    }
	                    ts.pushIfUnique(antecedentTypes, type);
	                    // If an antecedent type is not a subset of the declared type, we need to perform
	                    // subtype reduction. This happens when a "foreign" type is injected into the control
	                    // flow using the instanceof operator or a user defined type predicate.
	                    if (!isTypeSubsetOf(type, declaredType)) {
	                        subtypeReduction = true;
	                    }
	                    // If the type at a particular antecedent path is the declared type there is no
	                    // reason to process more antecedents since the only possible outcome is subtypes
	                    // that will be removed in the final union type anyway.
	                    if (type === declaredType) {
	                        break;
	                    }
	                }
	                // The result is incomplete if the first antecedent (the non-looping control flow path)
	                // is incomplete.
	                var result = getUnionOrEvolvingArrayType(antecedentTypes, subtypeReduction ? 2 /* Subtype */ : 1 /* Literal */);
	                if (isIncomplete(firstAntecedentType)) {
	                    return createFlowType(result, /*incomplete*/ true);
	                }
	                cache.set(key, result);
	                return result;
	            }
	            function isMatchingReferenceDiscriminant(expr, computedType) {
	                return expr.kind === 184 /* PropertyAccessExpression */ &&
	                    computedType.flags & 131072 /* Union */ &&
	                    isMatchingReference(reference, expr.expression) &&
	                    isDiscriminantProperty(computedType, expr.name.escapedText);
	            }
	            function narrowTypeByDiscriminant(type, propAccess, narrowType) {
	                var propName = propAccess.name.escapedText;
	                var propType = getTypeOfPropertyOfType(type, propName);
	                var narrowedPropType = propType && narrowType(propType);
	                return propType === narrowedPropType ? type : filterType(type, function (t) { return isTypeComparableTo(getTypeOfPropertyOfType(t, propName), narrowedPropType); });
	            }
	            function narrowTypeByTruthiness(type, expr, assumeTrue) {
	                if (isMatchingReference(reference, expr)) {
	                    return getTypeWithFacts(type, assumeTrue ? 1048576 /* Truthy */ : 2097152 /* Falsy */);
	                }
	                if (isMatchingReferenceDiscriminant(expr, declaredType)) {
	                    return narrowTypeByDiscriminant(type, expr, function (t) { return getTypeWithFacts(t, assumeTrue ? 1048576 /* Truthy */ : 2097152 /* Falsy */); });
	                }
	                if (containsMatchingReferenceDiscriminant(reference, expr)) {
	                    return declaredType;
	                }
	                return type;
	            }
	            function isTypePresencePossible(type, propName, assumeTrue) {
	                if (getIndexInfoOfType(type, 0 /* String */)) {
	                    return true;
	                }
	                var prop = getPropertyOfType(type, propName);
	                if (prop) {
	                    return prop.flags & 16777216 /* Optional */ ? true : assumeTrue;
	                }
	                return !assumeTrue;
	            }
	            function narrowByInKeyword(type, literal, assumeTrue) {
	                if ((type.flags & (131072 /* Union */ | 65536 /* Object */)) || (type.flags & 32768 /* TypeParameter */ && type.isThisType)) {
	                    var propName_1 = ts.escapeLeadingUnderscores(literal.text);
	                    return filterType(type, function (t) { return isTypePresencePossible(t, propName_1, assumeTrue); });
	                }
	                return type;
	            }
	            function narrowTypeByBinaryExpression(type, expr, assumeTrue) {
	                switch (expr.operatorToken.kind) {
	                    case 58 /* EqualsToken */:
	                        return narrowTypeByTruthiness(type, expr.left, assumeTrue);
	                    case 32 /* EqualsEqualsToken */:
	                    case 33 /* ExclamationEqualsToken */:
	                    case 34 /* EqualsEqualsEqualsToken */:
	                    case 35 /* ExclamationEqualsEqualsToken */:
	                        var operator_1 = expr.operatorToken.kind;
	                        var left_1 = getReferenceCandidate(expr.left);
	                        var right_1 = getReferenceCandidate(expr.right);
	                        if (left_1.kind === 194 /* TypeOfExpression */ && ts.isStringLiteralLike(right_1)) {
	                            return narrowTypeByTypeof(type, left_1, operator_1, right_1, assumeTrue);
	                        }
	                        if (right_1.kind === 194 /* TypeOfExpression */ && ts.isStringLiteralLike(left_1)) {
	                            return narrowTypeByTypeof(type, right_1, operator_1, left_1, assumeTrue);
	                        }
	                        if (isMatchingReference(reference, left_1)) {
	                            return narrowTypeByEquality(type, operator_1, right_1, assumeTrue);
	                        }
	                        if (isMatchingReference(reference, right_1)) {
	                            return narrowTypeByEquality(type, operator_1, left_1, assumeTrue);
	                        }
	                        if (isMatchingReferenceDiscriminant(left_1, declaredType)) {
	                            return narrowTypeByDiscriminant(type, left_1, function (t) { return narrowTypeByEquality(t, operator_1, right_1, assumeTrue); });
	                        }
	                        if (isMatchingReferenceDiscriminant(right_1, declaredType)) {
	                            return narrowTypeByDiscriminant(type, right_1, function (t) { return narrowTypeByEquality(t, operator_1, left_1, assumeTrue); });
	                        }
	                        if (containsMatchingReferenceDiscriminant(reference, left_1) || containsMatchingReferenceDiscriminant(reference, right_1)) {
	                            return declaredType;
	                        }
	                        break;
	                    case 93 /* InstanceOfKeyword */:
	                        return narrowTypeByInstanceof(type, expr, assumeTrue);
	                    case 92 /* InKeyword */:
	                        var target = getReferenceCandidate(expr.right);
	                        if (ts.isStringLiteralLike(expr.left) && isMatchingReference(reference, target)) {
	                            return narrowByInKeyword(type, expr.left, assumeTrue);
	                        }
	                        break;
	                    case 26 /* CommaToken */:
	                        return narrowType(type, expr.right, assumeTrue);
	                }
	                return type;
	            }
	            function narrowTypeByEquality(type, operator, value, assumeTrue) {
	                if (type.flags & 1 /* Any */) {
	                    return type;
	                }
	                if (operator === 33 /* ExclamationEqualsToken */ || operator === 35 /* ExclamationEqualsEqualsToken */) {
	                    assumeTrue = !assumeTrue;
	                }
	                var valueType = getTypeOfExpression(value);
	                if (valueType.flags & 12288 /* Nullable */) {
	                    if (!strictNullChecks) {
	                        return type;
	                    }
	                    var doubleEquals = operator === 32 /* EqualsEqualsToken */ || operator === 33 /* ExclamationEqualsToken */;
	                    var facts = doubleEquals ?
	                        assumeTrue ? 65536 /* EQUndefinedOrNull */ : 524288 /* NEUndefinedOrNull */ :
	                        valueType.flags & 8192 /* Null */ ?
	                            assumeTrue ? 32768 /* EQNull */ : 262144 /* NENull */ :
	                            assumeTrue ? 16384 /* EQUndefined */ : 131072 /* NEUndefined */;
	                    return getTypeWithFacts(type, facts);
	                }
	                if (type.flags & 134283777 /* NotUnionOrUnit */) {
	                    return type;
	                }
	                if (assumeTrue) {
	                    var narrowedType = filterType(type, function (t) { return areTypesComparable(t, valueType); });
	                    return narrowedType.flags & 16384 /* Never */ ? type : replacePrimitivesWithLiterals(narrowedType, valueType);
	                }
	                if (isUnitType(valueType)) {
	                    var regularType_1 = getRegularTypeOfLiteralType(valueType);
	                    return filterType(type, function (t) { return getRegularTypeOfLiteralType(t) !== regularType_1; });
	                }
	                return type;
	            }
	            function narrowTypeByTypeof(type, typeOfExpr, operator, literal, assumeTrue) {
	                // We have '==', '!=', '====', or !==' operator with 'typeof xxx' and string literal operands
	                var target = getReferenceCandidate(typeOfExpr.expression);
	                if (!isMatchingReference(reference, target)) {
	                    // For a reference of the form 'x.y', a 'typeof x === ...' type guard resets the
	                    // narrowed type of 'y' to its declared type.
	                    if (containsMatchingReference(reference, target)) {
	                        return declaredType;
	                    }
	                    return type;
	                }
	                if (operator === 33 /* ExclamationEqualsToken */ || operator === 35 /* ExclamationEqualsEqualsToken */) {
	                    assumeTrue = !assumeTrue;
	                }
	                if (assumeTrue && !(type.flags & 131072 /* Union */)) {
	                    // We narrow a non-union type to an exact primitive type if the non-union type
	                    // is a supertype of that primitive type. For example, type 'any' can be narrowed
	                    // to one of the primitive types.
	                    var targetType = typeofTypesByName.get(literal.text);
	                    if (targetType) {
	                        if (isTypeSubtypeOf(targetType, type)) {
	                            return targetType;
	                        }
	                        if (type.flags & 7897088 /* Instantiable */) {
	                            var constraint = getBaseConstraintOfType(type) || anyType;
	                            if (isTypeSubtypeOf(targetType, constraint)) {
	                                return getIntersectionType([type, targetType]);
	                            }
	                        }
	                    }
	                }
	                var facts = assumeTrue ?
	                    typeofEQFacts.get(literal.text) || 64 /* TypeofEQHostObject */ :
	                    typeofNEFacts.get(literal.text) || 8192 /* TypeofNEHostObject */;
	                return getTypeWithFacts(type, facts);
	            }
	            function narrowTypeBySwitchOnDiscriminant(type, switchStatement, clauseStart, clauseEnd) {
	                // We only narrow if all case expressions specify values with unit types
	                var switchTypes = getSwitchClauseTypes(switchStatement);
	                if (!switchTypes.length) {
	                    return type;
	                }
	                var clauseTypes = switchTypes.slice(clauseStart, clauseEnd);
	                var hasDefaultClause = clauseStart === clauseEnd || ts.contains(clauseTypes, neverType);
	                var discriminantType = getUnionType(clauseTypes);
	                var caseType = discriminantType.flags & 16384 /* Never */ ? neverType :
	                    replacePrimitivesWithLiterals(filterType(type, function (t) { return areTypesComparable(discriminantType, t); }), discriminantType);
	                if (!hasDefaultClause) {
	                    return caseType;
	                }
	                var defaultType = filterType(type, function (t) { return !(isUnitType(t) && ts.contains(switchTypes, getRegularTypeOfLiteralType(t))); });
	                return caseType.flags & 16384 /* Never */ ? defaultType : getUnionType([caseType, defaultType]);
	            }
	            function narrowTypeByInstanceof(type, expr, assumeTrue) {
	                var left = getReferenceCandidate(expr.left);
	                if (!isMatchingReference(reference, left)) {
	                    // For a reference of the form 'x.y', an 'x instanceof T' type guard resets the
	                    // narrowed type of 'y' to its declared type.
	                    if (containsMatchingReference(reference, left)) {
	                        return declaredType;
	                    }
	                    return type;
	                }
	                // Check that right operand is a function type with a prototype property
	                var rightType = getTypeOfExpression(expr.right);
	                if (!isTypeSubtypeOf(rightType, globalFunctionType)) {
	                    return type;
	                }
	                var targetType;
	                var prototypeProperty = getPropertyOfType(rightType, "prototype");
	                if (prototypeProperty) {
	                    // Target type is type of the prototype property
	                    var prototypePropertyType = getTypeOfSymbol(prototypeProperty);
	                    if (!isTypeAny(prototypePropertyType)) {
	                        targetType = prototypePropertyType;
	                    }
	                }
	                // Don't narrow from 'any' if the target type is exactly 'Object' or 'Function'
	                if (isTypeAny(type) && (targetType === globalObjectType || targetType === globalFunctionType)) {
	                    return type;
	                }
	                if (!targetType) {
	                    // Target type is type of construct signature
	                    var constructSignatures = void 0;
	                    if (ts.getObjectFlags(rightType) & 2 /* Interface */) {
	                        constructSignatures = resolveDeclaredMembers(rightType).declaredConstructSignatures;
	                    }
	                    else if (ts.getObjectFlags(rightType) & 16 /* Anonymous */) {
	                        constructSignatures = getSignaturesOfType(rightType, 1 /* Construct */);
	                    }
	                    if (constructSignatures && constructSignatures.length) {
	                        targetType = getUnionType(ts.map(constructSignatures, function (signature) { return getReturnTypeOfSignature(getErasedSignature(signature)); }));
	                    }
	                }
	                if (targetType) {
	                    return getNarrowedType(type, targetType, assumeTrue, isTypeDerivedFrom);
	                }
	                return type;
	            }
	            function getNarrowedType(type, candidate, assumeTrue, isRelated) {
	                if (!assumeTrue) {
	                    return filterType(type, function (t) { return !isRelated(t, candidate); });
	                }
	                // If the current type is a union type, remove all constituents that couldn't be instances of
	                // the candidate type. If one or more constituents remain, return a union of those.
	                if (type.flags & 131072 /* Union */) {
	                    var assignableType = filterType(type, function (t) { return isRelated(t, candidate); });
	                    if (!(assignableType.flags & 16384 /* Never */)) {
	                        return assignableType;
	                    }
	                }
	                // If the candidate type is a subtype of the target type, narrow to the candidate type.
	                // Otherwise, if the target type is assignable to the candidate type, keep the target type.
	                // Otherwise, if the candidate type is assignable to the target type, narrow to the candidate
	                // type. Otherwise, the types are completely unrelated, so narrow to an intersection of the
	                // two types.
	                return isTypeSubtypeOf(candidate, type) ? candidate :
	                    isTypeAssignableTo(type, candidate) ? type :
	                        isTypeAssignableTo(candidate, type) ? candidate :
	                            getIntersectionType([type, candidate]);
	            }
	            function narrowTypeByTypePredicate(type, callExpression, assumeTrue) {
	                if (!hasMatchingArgument(callExpression, reference) || !maybeTypePredicateCall(callExpression)) {
	                    return type;
	                }
	                var signature = getResolvedSignature(callExpression);
	                var predicate = getTypePredicateOfSignature(signature);
	                if (!predicate) {
	                    return type;
	                }
	                // Don't narrow from 'any' if the predicate type is exactly 'Object' or 'Function'
	                if (isTypeAny(type) && (predicate.type === globalObjectType || predicate.type === globalFunctionType)) {
	                    return type;
	                }
	                if (ts.isIdentifierTypePredicate(predicate)) {
	                    var predicateArgument = callExpression.arguments[predicate.parameterIndex - (signature.thisParameter ? 1 : 0)];
	                    if (predicateArgument) {
	                        if (isMatchingReference(reference, predicateArgument)) {
	                            return getNarrowedType(type, predicate.type, assumeTrue, isTypeSubtypeOf);
	                        }
	                        if (containsMatchingReference(reference, predicateArgument)) {
	                            return declaredType;
	                        }
	                    }
	                }
	                else {
	                    var invokedExpression = ts.skipParentheses(callExpression.expression);
	                    if (invokedExpression.kind === 185 /* ElementAccessExpression */ || invokedExpression.kind === 184 /* PropertyAccessExpression */) {
	                        var accessExpression = invokedExpression;
	                        var possibleReference = ts.skipParentheses(accessExpression.expression);
	                        if (isMatchingReference(reference, possibleReference)) {
	                            return getNarrowedType(type, predicate.type, assumeTrue, isTypeSubtypeOf);
	                        }
	                        if (containsMatchingReference(reference, possibleReference)) {
	                            return declaredType;
	                        }
	                    }
	                }
	                return type;
	            }
	            // Narrow the given type based on the given expression having the assumed boolean value. The returned type
	            // will be a subtype or the same type as the argument.
	            function narrowType(type, expr, assumeTrue) {
	                switch (expr.kind) {
	                    case 71 /* Identifier */:
	                    case 99 /* ThisKeyword */:
	                    case 97 /* SuperKeyword */:
	                    case 184 /* PropertyAccessExpression */:
	                        return narrowTypeByTruthiness(type, expr, assumeTrue);
	                    case 186 /* CallExpression */:
	                        return narrowTypeByTypePredicate(type, expr, assumeTrue);
	                    case 190 /* ParenthesizedExpression */:
	                        return narrowType(type, expr.expression, assumeTrue);
	                    case 199 /* BinaryExpression */:
	                        return narrowTypeByBinaryExpression(type, expr, assumeTrue);
	                    case 197 /* PrefixUnaryExpression */:
	                        if (expr.operator === 51 /* ExclamationToken */) {
	                            return narrowType(type, expr.operand, !assumeTrue);
	                        }
	                        break;
	                }
	                return type;
	            }
	        }
	        function getTypeOfSymbolAtLocation(symbol, location) {
	            symbol = symbol.exportSymbol || symbol;
	            // If we have an identifier or a property access at the given location, if the location is
	            // an dotted name expression, and if the location is not an assignment target, obtain the type
	            // of the expression (which will reflect control flow analysis). If the expression indeed
	            // resolved to the given symbol, return the narrowed type.
	            if (location.kind === 71 /* Identifier */) {
	                if (ts.isRightSideOfQualifiedNameOrPropertyAccess(location)) {
	                    location = location.parent;
	                }
	                if (ts.isExpressionNode(location) && !ts.isAssignmentTarget(location)) {
	                    var type = getTypeOfExpression(location);
	                    if (getExportSymbolOfValueSymbolIfExported(getNodeLinks(location).resolvedSymbol) === symbol) {
	                        return type;
	                    }
	                }
	            }
	            // The location isn't a reference to the given symbol, meaning we're being asked
	            // a hypothetical question of what type the symbol would have if there was a reference
	            // to it at the given location. Since we have no control flow information for the
	            // hypothetical reference (control flow information is created and attached by the
	            // binder), we simply return the declared type of the symbol.
	            return getTypeOfSymbol(symbol);
	        }
	        function getControlFlowContainer(node) {
	            return ts.findAncestor(node.parent, function (node) {
	                return ts.isFunctionLike(node) && !ts.getImmediatelyInvokedFunctionExpression(node) ||
	                    node.kind === 239 /* ModuleBlock */ ||
	                    node.kind === 273 /* SourceFile */ ||
	                    node.kind === 151 /* PropertyDeclaration */;
	            });
	        }
	        // Check if a parameter is assigned anywhere within its declaring function.
	        function isParameterAssigned(symbol) {
	            var func = ts.getRootDeclaration(symbol.valueDeclaration).parent;
	            var links = getNodeLinks(func);
	            if (!(links.flags & 4194304 /* AssignmentsMarked */)) {
	                links.flags |= 4194304 /* AssignmentsMarked */;
	                if (!hasParentWithAssignmentsMarked(func)) {
	                    markParameterAssignments(func);
	                }
	            }
	            return symbol.isAssigned || false;
	        }
	        function hasParentWithAssignmentsMarked(node) {
	            return !!ts.findAncestor(node.parent, function (node) { return ts.isFunctionLike(node) && !!(getNodeLinks(node).flags & 4194304 /* AssignmentsMarked */); });
	        }
	        function markParameterAssignments(node) {
	            if (node.kind === 71 /* Identifier */) {
	                if (ts.isAssignmentTarget(node)) {
	                    var symbol = getResolvedSymbol(node);
	                    if (symbol.valueDeclaration && ts.getRootDeclaration(symbol.valueDeclaration).kind === 148 /* Parameter */) {
	                        symbol.isAssigned = true;
	                    }
	                }
	            }
	            else {
	                ts.forEachChild(node, markParameterAssignments);
	            }
	        }
	        function isConstVariable(symbol) {
	            return symbol.flags & 3 /* Variable */ && (getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */) !== 0 && getTypeOfSymbol(symbol) !== autoArrayType;
	        }
	        /** remove undefined from the annotated type of a parameter when there is an initializer (that doesn't include undefined) */
	        function removeOptionalityFromDeclaredType(declaredType, declaration) {
	            var annotationIncludesUndefined = strictNullChecks &&
	                declaration.kind === 148 /* Parameter */ &&
	                declaration.initializer &&
	                getFalsyFlags(declaredType) & 4096 /* Undefined */ &&
	                !(getFalsyFlags(checkExpression(declaration.initializer)) & 4096 /* Undefined */);
	            return annotationIncludesUndefined ? getTypeWithFacts(declaredType, 131072 /* NEUndefined */) : declaredType;
	        }
	        function isConstraintPosition(node) {
	            var parent = node.parent;
	            return parent.kind === 184 /* PropertyAccessExpression */ ||
	                parent.kind === 186 /* CallExpression */ && parent.expression === node ||
	                parent.kind === 185 /* ElementAccessExpression */ && parent.expression === node ||
	                parent.kind === 181 /* BindingElement */ && parent.name === node && !!parent.initializer;
	        }
	        function typeHasNullableConstraint(type) {
	            return type.flags & 7372800 /* InstantiableNonPrimitive */ && maybeTypeOfKind(getBaseConstraintOfType(type) || emptyObjectType, 12288 /* Nullable */);
	        }
	        function getConstraintForLocation(type, node) {
	            // When a node is the left hand expression of a property access, element access, or call expression,
	            // and the type of the node includes type variables with constraints that are nullable, we fetch the
	            // apparent type of the node *before* performing control flow analysis such that narrowings apply to
	            // the constraint type.
	            if (type && isConstraintPosition(node) && forEachType(type, typeHasNullableConstraint)) {
	                return mapType(getWidenedType(type), getBaseConstraintOrType);
	            }
	            return type;
	        }
	        function markAliasReferenced(symbol, location) {
	            if (isNonLocalAlias(symbol, /*excludes*/ 67216319 /* Value */) && !isInTypeQuery(location) && !isConstEnumOrConstEnumOnlyModule(resolveAlias(symbol))) {
	                markAliasSymbolAsReferenced(symbol);
	            }
	        }
	        function checkIdentifier(node) {
	            var symbol = getResolvedSymbol(node);
	            if (symbol === unknownSymbol) {
	                return unknownType;
	            }
	            // As noted in ECMAScript 6 language spec, arrow functions never have an arguments objects.
	            // Although in down-level emit of arrow function, we emit it using function expression which means that
	            // arguments objects will be bound to the inner object; emitting arrow function natively in ES6, arguments objects
	            // will be bound to non-arrow function that contain this arrow function. This results in inconsistent behavior.
	            // To avoid that we will give an error to users if they use arguments objects in arrow function so that they
	            // can explicitly bound arguments objects
	            if (symbol === argumentsSymbol) {
	                var container = ts.getContainingFunction(node);
	                if (languageVersion < 2 /* ES2015 */) {
	                    if (container.kind === 192 /* ArrowFunction */) {
	                        error(node, ts.Diagnostics.The_arguments_object_cannot_be_referenced_in_an_arrow_function_in_ES3_and_ES5_Consider_using_a_standard_function_expression);
	                    }
	                    else if (ts.hasModifier(container, 256 /* Async */)) {
	                        error(node, ts.Diagnostics.The_arguments_object_cannot_be_referenced_in_an_async_function_or_method_in_ES3_and_ES5_Consider_using_a_standard_function_or_method);
	                    }
	                }
	                getNodeLinks(container).flags |= 8192 /* CaptureArguments */;
	                return getTypeOfSymbol(symbol);
	            }
	            // We should only mark aliases as referenced if there isn't a local value declaration
	            // for the symbol. Also, don't mark any property access expression LHS - checkPropertyAccessExpression will handle that
	            if (!(node.parent && ts.isPropertyAccessExpression(node.parent) && node.parent.expression === node)) {
	                markAliasReferenced(symbol, node);
	            }
	            var localOrExportSymbol = getExportSymbolOfValueSymbolIfExported(symbol);
	            var declaration = localOrExportSymbol.valueDeclaration;
	            if (localOrExportSymbol.flags & 32 /* Class */) {
	                // Due to the emit for class decorators, any reference to the class from inside of the class body
	                // must instead be rewritten to point to a temporary variable to avoid issues with the double-bind
	                // behavior of class names in ES6.
	                if (declaration.kind === 234 /* ClassDeclaration */
	                    && ts.nodeIsDecorated(declaration)) {
	                    var container = ts.getContainingClass(node);
	                    while (container !== undefined) {
	                        if (container === declaration && container.name !== node) {
	                            getNodeLinks(declaration).flags |= 8388608 /* ClassWithConstructorReference */;
	                            getNodeLinks(node).flags |= 16777216 /* ConstructorReferenceInClass */;
	                            break;
	                        }
	                        container = ts.getContainingClass(container);
	                    }
	                }
	                else if (declaration.kind === 204 /* ClassExpression */) {
	                    // When we emit a class expression with static members that contain a reference
	                    // to the constructor in the initializer, we will need to substitute that
	                    // binding with an alias as the class name is not in scope.
	                    var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	                    while (container !== undefined) {
	                        if (container.parent === declaration) {
	                            if (container.kind === 151 /* PropertyDeclaration */ && ts.hasModifier(container, 32 /* Static */)) {
	                                getNodeLinks(declaration).flags |= 8388608 /* ClassWithConstructorReference */;
	                                getNodeLinks(node).flags |= 16777216 /* ConstructorReferenceInClass */;
	                            }
	                            break;
	                        }
	                        container = ts.getThisContainer(container, /*includeArrowFunctions*/ false);
	                    }
	                }
	            }
	            checkNestedBlockScopedBinding(node, symbol);
	            var type = getConstraintForLocation(getTypeOfSymbol(localOrExportSymbol), node);
	            var assignmentKind = ts.getAssignmentTargetKind(node);
	            if (assignmentKind) {
	                if (!(localOrExportSymbol.flags & 3 /* Variable */) &&
	                    !(ts.isInJavaScriptFile(node) && localOrExportSymbol.flags & 512 /* ValueModule */)) {
	                    error(node, ts.Diagnostics.Cannot_assign_to_0_because_it_is_not_a_variable, symbolToString(symbol));
	                    return unknownType;
	                }
	                if (isReadonlySymbol(localOrExportSymbol)) {
	                    error(node, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, symbolToString(symbol));
	                    return unknownType;
	                }
	            }
	            var isAlias = localOrExportSymbol.flags & 2097152 /* Alias */;
	            // We only narrow variables and parameters occurring in a non-assignment position. For all other
	            // entities we simply return the declared type.
	            if (localOrExportSymbol.flags & 3 /* Variable */) {
	                if (assignmentKind === 1 /* Definite */) {
	                    return type;
	                }
	            }
	            else if (isAlias) {
	                declaration = ts.find(symbol.declarations, isSomeImportDeclaration);
	            }
	            else {
	                return type;
	            }
	            if (!declaration) {
	                return type;
	            }
	            // The declaration container is the innermost function that encloses the declaration of the variable
	            // or parameter. The flow container is the innermost function starting with which we analyze the control
	            // flow graph to determine the control flow based type.
	            var isParameter = ts.getRootDeclaration(declaration).kind === 148 /* Parameter */;
	            var declarationContainer = getControlFlowContainer(declaration);
	            var flowContainer = getControlFlowContainer(node);
	            var isOuterVariable = flowContainer !== declarationContainer;
	            var isSpreadDestructuringAsignmentTarget = node.parent && node.parent.parent && ts.isSpreadAssignment(node.parent) && isDestructuringAssignmentTarget(node.parent.parent);
	            // When the control flow originates in a function expression or arrow function and we are referencing
	            // a const variable or parameter from an outer function, we extend the origin of the control flow
	            // analysis to include the immediately enclosing function.
	            while (flowContainer !== declarationContainer && (flowContainer.kind === 191 /* FunctionExpression */ ||
	                flowContainer.kind === 192 /* ArrowFunction */ || ts.isObjectLiteralOrClassExpressionMethod(flowContainer)) &&
	                (isConstVariable(localOrExportSymbol) || isParameter && !isParameterAssigned(localOrExportSymbol))) {
	                flowContainer = getControlFlowContainer(flowContainer);
	            }
	            // We only look for uninitialized variables in strict null checking mode, and only when we can analyze
	            // the entire control flow graph from the variable's declaration (i.e. when the flow container and
	            // declaration container are the same).
	            var assumeInitialized = isParameter || isAlias || isOuterVariable || isSpreadDestructuringAsignmentTarget ||
	                type !== autoType && type !== autoArrayType && (!strictNullChecks || (type.flags & 1 /* Any */) !== 0 ||
	                    isInTypeQuery(node) || node.parent.kind === 251 /* ExportSpecifier */) ||
	                node.parent.kind === 208 /* NonNullExpression */ ||
	                declaration.kind === 231 /* VariableDeclaration */ && declaration.exclamationToken ||
	                declaration.flags & 4194304 /* Ambient */;
	            var initialType = assumeInitialized ? (isParameter ? removeOptionalityFromDeclaredType(type, declaration) : type) :
	                type === autoType || type === autoArrayType ? undefinedType :
	                    getOptionalType(type);
	            var flowType = getFlowTypeOfReference(node, type, initialType, flowContainer, !assumeInitialized);
	            // A variable is considered uninitialized when it is possible to analyze the entire control flow graph
	            // from declaration to use, and when the variable's declared type doesn't include undefined but the
	            // control flow based type does include undefined.
	            if (type === autoType || type === autoArrayType) {
	                if (flowType === autoType || flowType === autoArrayType) {
	                    if (noImplicitAny) {
	                        error(ts.getNameOfDeclaration(declaration), ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined, symbolToString(symbol), typeToString(flowType));
	                        error(node, ts.Diagnostics.Variable_0_implicitly_has_an_1_type, symbolToString(symbol), typeToString(flowType));
	                    }
	                    return convertAutoToAny(flowType);
	                }
	            }
	            else if (!assumeInitialized && !(getFalsyFlags(type) & 4096 /* Undefined */) && getFalsyFlags(flowType) & 4096 /* Undefined */) {
	                error(node, ts.Diagnostics.Variable_0_is_used_before_being_assigned, symbolToString(symbol));
	                // Return the declared type to reduce follow-on errors
	                return type;
	            }
	            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
	        }
	        function isInsideFunction(node, threshold) {
	            return !!ts.findAncestor(node, function (n) { return n === threshold ? "quit" : ts.isFunctionLike(n); });
	        }
	        function checkNestedBlockScopedBinding(node, symbol) {
	            if (languageVersion >= 2 /* ES2015 */ ||
	                (symbol.flags & (2 /* BlockScopedVariable */ | 32 /* Class */)) === 0 ||
	                symbol.valueDeclaration.parent.kind === 268 /* CatchClause */) {
	                return;
	            }
	            // 1. walk from the use site up to the declaration and check
	            // if there is anything function like between declaration and use-site (is binding/class is captured in function).
	            // 2. walk from the declaration up to the boundary of lexical environment and check
	            // if there is an iteration statement in between declaration and boundary (is binding/class declared inside iteration statement)
	            var container = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	            var usedInFunction = isInsideFunction(node.parent, container);
	            var current = container;
	            var containedInIterationStatement = false;
	            while (current && !ts.nodeStartsNewLexicalEnvironment(current)) {
	                if (ts.isIterationStatement(current, /*lookInLabeledStatements*/ false)) {
	                    containedInIterationStatement = true;
	                    break;
	                }
	                current = current.parent;
	            }
	            if (containedInIterationStatement) {
	                if (usedInFunction) {
	                    // mark iteration statement as containing block-scoped binding captured in some function
	                    getNodeLinks(current).flags |= 65536 /* LoopWithCapturedBlockScopedBinding */;
	                }
	                // mark variables that are declared in loop initializer and reassigned inside the body of ForStatement.
	                // if body of ForStatement will be converted to function then we'll need a extra machinery to propagate reassigned values back.
	                if (container.kind === 219 /* ForStatement */ &&
	                    ts.getAncestor(symbol.valueDeclaration, 232 /* VariableDeclarationList */).parent === container &&
	                    isAssignedInBodyOfForStatement(node, container)) {
	                    getNodeLinks(symbol.valueDeclaration).flags |= 2097152 /* NeedsLoopOutParameter */;
	                }
	                // set 'declared inside loop' bit on the block-scoped binding
	                getNodeLinks(symbol.valueDeclaration).flags |= 262144 /* BlockScopedBindingInLoop */;
	            }
	            if (usedInFunction) {
	                getNodeLinks(symbol.valueDeclaration).flags |= 131072 /* CapturedBlockScopedBinding */;
	            }
	        }
	        function isAssignedInBodyOfForStatement(node, container) {
	            // skip parenthesized nodes
	            var current = node;
	            while (current.parent.kind === 190 /* ParenthesizedExpression */) {
	                current = current.parent;
	            }
	            // check if node is used as LHS in some assignment expression
	            var isAssigned = false;
	            if (ts.isAssignmentTarget(current)) {
	                isAssigned = true;
	            }
	            else if ((current.parent.kind === 197 /* PrefixUnaryExpression */ || current.parent.kind === 198 /* PostfixUnaryExpression */)) {
	                var expr = current.parent;
	                isAssigned = expr.operator === 43 /* PlusPlusToken */ || expr.operator === 44 /* MinusMinusToken */;
	            }
	            if (!isAssigned) {
	                return false;
	            }
	            // at this point we know that node is the target of assignment
	            // now check that modification happens inside the statement part of the ForStatement
	            return !!ts.findAncestor(current, function (n) { return n === container ? "quit" : n === container.statement; });
	        }
	        function captureLexicalThis(node, container) {
	            getNodeLinks(node).flags |= 2 /* LexicalThis */;
	            if (container.kind === 151 /* PropertyDeclaration */ || container.kind === 154 /* Constructor */) {
	                var classNode = container.parent;
	                getNodeLinks(classNode).flags |= 4 /* CaptureThis */;
	            }
	            else {
	                getNodeLinks(container).flags |= 4 /* CaptureThis */;
	            }
	        }
	        function findFirstSuperCall(n) {
	            if (ts.isSuperCall(n)) {
	                return n;
	            }
	            else if (ts.isFunctionLike(n)) {
	                return undefined;
	            }
	            return ts.forEachChild(n, findFirstSuperCall);
	        }
	        /**
	         * Return a cached result if super-statement is already found.
	         * Otherwise, find a super statement in a given constructor function and cache the result in the node-links of the constructor
	         *
	         * @param constructor constructor-function to look for super statement
	         */
	        function getSuperCallInConstructor(constructor) {
	            var links = getNodeLinks(constructor);
	            // Only trying to find super-call if we haven't yet tried to find one.  Once we try, we will record the result
	            if (links.hasSuperCall === undefined) {
	                links.superCall = findFirstSuperCall(constructor.body);
	                links.hasSuperCall = links.superCall ? true : false;
	            }
	            return links.superCall;
	        }
	        /**
	         * Check if the given class-declaration extends null then return true.
	         * Otherwise, return false
	         * @param classDecl a class declaration to check if it extends null
	         */
	        function classDeclarationExtendsNull(classDecl) {
	            var classSymbol = getSymbolOfNode(classDecl);
	            var classInstanceType = getDeclaredTypeOfSymbol(classSymbol);
	            var baseConstructorType = getBaseConstructorTypeOfClass(classInstanceType);
	            return baseConstructorType === nullWideningType;
	        }
	        function checkThisBeforeSuper(node, container, diagnosticMessage) {
	            var containingClassDecl = container.parent;
	            var baseTypeNode = ts.getClassExtendsHeritageClauseElement(containingClassDecl);
	            // If a containing class does not have extends clause or the class extends null
	            // skip checking whether super statement is called before "this" accessing.
	            if (baseTypeNode && !classDeclarationExtendsNull(containingClassDecl)) {
	                var superCall = getSuperCallInConstructor(container);
	                // We should give an error in the following cases:
	                //      - No super-call
	                //      - "this" is accessing before super-call.
	                //          i.e super(this)
	                //              this.x; super();
	                // We want to make sure that super-call is done before accessing "this" so that
	                // "this" is not accessed as a parameter of the super-call.
	                if (!superCall || superCall.end > node.pos) {
	                    // In ES6, super inside constructor of class-declaration has to precede "this" accessing
	                    error(node, diagnosticMessage);
	                }
	            }
	        }
	        function checkThisExpression(node) {
	            // Stop at the first arrow function so that we can
	            // tell whether 'this' needs to be captured.
	            var container = ts.getThisContainer(node, /* includeArrowFunctions */ true);
	            var needToCaptureLexicalThis = false;
	            if (container.kind === 154 /* Constructor */) {
	                checkThisBeforeSuper(node, container, ts.Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class);
	            }
	            // Now skip arrow functions to get the "real" owner of 'this'.
	            if (container.kind === 192 /* ArrowFunction */) {
	                container = ts.getThisContainer(container, /* includeArrowFunctions */ false);
	                // When targeting es6, arrow function lexically bind "this" so we do not need to do the work of binding "this" in emitted code
	                needToCaptureLexicalThis = (languageVersion < 2 /* ES2015 */);
	            }
	            switch (container.kind) {
	                case 238 /* ModuleDeclaration */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_module_or_namespace_body);
	                    // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    break;
	                case 237 /* EnumDeclaration */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_current_location);
	                    // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    break;
	                case 154 /* Constructor */:
	                    if (isInConstructorArgumentInitializer(node, container)) {
	                        error(node, ts.Diagnostics.this_cannot_be_referenced_in_constructor_arguments);
	                        // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    }
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    if (ts.hasModifier(container, 32 /* Static */)) {
	                        error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_static_property_initializer);
	                        // do not return here so in case if lexical this is captured - it will be reflected in flags on NodeLinks
	                    }
	                    break;
	                case 146 /* ComputedPropertyName */:
	                    error(node, ts.Diagnostics.this_cannot_be_referenced_in_a_computed_property_name);
	                    break;
	            }
	            if (needToCaptureLexicalThis) {
	                captureLexicalThis(node, container);
	            }
	            var type = tryGetThisTypeAt(node, container);
	            if (!type && noImplicitThis) {
	                // With noImplicitThis, functions may not reference 'this' if it has type 'any'
	                error(node, ts.Diagnostics.this_implicitly_has_type_any_because_it_does_not_have_a_type_annotation);
	            }
	            return type || anyType;
	        }
	        function tryGetThisTypeAt(node, container) {
	            if (container === void 0) { container = ts.getThisContainer(node, /*includeArrowFunctions*/ false); }
	            if (ts.isFunctionLike(container) &&
	                (!isInParameterInitializerBeforeContainingFunction(node) || ts.getThisParameter(container))) {
	                // Note: a parameter initializer should refer to class-this unless function-this is explicitly annotated.
	                // If this is a function in a JS file, it might be a class method. Check if it's the RHS
	                // of a x.prototype.y = function [name]() { .... }
	                if (container.kind === 191 /* FunctionExpression */ &&
	                    container.parent.kind === 199 /* BinaryExpression */ &&
	                    ts.getSpecialPropertyAssignmentKind(container.parent) === 3 /* PrototypeProperty */) {
	                    // Get the 'x' of 'x.prototype.y = f' (here, 'f' is 'container')
	                    var className = container.parent // x.prototype.y = f
	                        .left // x.prototype.y
	                        .expression // x.prototype
	                        .expression; // x
	                    var classSymbol = checkExpression(className).symbol;
	                    if (classSymbol && classSymbol.members && (classSymbol.flags & 16 /* Function */)) {
	                        return getFlowTypeOfReference(node, getInferredClassType(classSymbol));
	                    }
	                }
	                var thisType = getThisTypeOfDeclaration(container) || getContextualThisParameterType(container);
	                if (thisType) {
	                    return getFlowTypeOfReference(node, thisType);
	                }
	            }
	            if (ts.isClassLike(container.parent)) {
	                var symbol = getSymbolOfNode(container.parent);
	                var type = ts.hasModifier(container, 32 /* Static */) ? getTypeOfSymbol(symbol) : getDeclaredTypeOfSymbol(symbol).thisType;
	                return getFlowTypeOfReference(node, type);
	            }
	            if (ts.isInJavaScriptFile(node)) {
	                var type = getTypeForThisExpressionFromJSDoc(container);
	                if (type && type !== unknownType) {
	                    return getFlowTypeOfReference(node, type);
	                }
	            }
	        }
	        function getTypeForThisExpressionFromJSDoc(node) {
	            var jsdocType = ts.getJSDocType(node);
	            if (jsdocType && jsdocType.kind === 283 /* JSDocFunctionType */) {
	                var jsDocFunctionType = jsdocType;
	                if (jsDocFunctionType.parameters.length > 0 &&
	                    jsDocFunctionType.parameters[0].name &&
	                    jsDocFunctionType.parameters[0].name.escapedText === "this") {
	                    return getTypeFromTypeNode(jsDocFunctionType.parameters[0].type);
	                }
	            }
	        }
	        function isInConstructorArgumentInitializer(node, constructorDecl) {
	            return !!ts.findAncestor(node, function (n) { return n === constructorDecl ? "quit" : n.kind === 148 /* Parameter */; });
	        }
	        function checkSuperExpression(node) {
	            var isCallExpression = node.parent.kind === 186 /* CallExpression */ && node.parent.expression === node;
	            var container = ts.getSuperContainer(node, /*stopOnFunctions*/ true);
	            var needToCaptureLexicalThis = false;
	            // adjust the container reference in case if super is used inside arrow functions with arbitrarily deep nesting
	            if (!isCallExpression) {
	                while (container && container.kind === 192 /* ArrowFunction */) {
	                    container = ts.getSuperContainer(container, /*stopOnFunctions*/ true);
	                    needToCaptureLexicalThis = languageVersion < 2 /* ES2015 */;
	                }
	            }
	            var canUseSuperExpression = isLegalUsageOfSuperExpression(container);
	            var nodeCheckFlag = 0;
	            if (!canUseSuperExpression) {
	                // issue more specific error if super is used in computed property name
	                // class A { foo() { return "1" }}
	                // class B {
	                //     [super.foo()]() {}
	                // }
	                var current = ts.findAncestor(node, function (n) { return n === container ? "quit" : n.kind === 146 /* ComputedPropertyName */; });
	                if (current && current.kind === 146 /* ComputedPropertyName */) {
	                    error(node, ts.Diagnostics.super_cannot_be_referenced_in_a_computed_property_name);
	                }
	                else if (isCallExpression) {
	                    error(node, ts.Diagnostics.Super_calls_are_not_permitted_outside_constructors_or_in_nested_functions_inside_constructors);
	                }
	                else if (!container || !container.parent || !(ts.isClassLike(container.parent) || container.parent.kind === 183 /* ObjectLiteralExpression */)) {
	                    error(node, ts.Diagnostics.super_can_only_be_referenced_in_members_of_derived_classes_or_object_literal_expressions);
	                }
	                else {
	                    error(node, ts.Diagnostics.super_property_access_is_permitted_only_in_a_constructor_member_function_or_member_accessor_of_a_derived_class);
	                }
	                return unknownType;
	            }
	            if (!isCallExpression && container.kind === 154 /* Constructor */) {
	                checkThisBeforeSuper(node, container, ts.Diagnostics.super_must_be_called_before_accessing_a_property_of_super_in_the_constructor_of_a_derived_class);
	            }
	            if (ts.hasModifier(container, 32 /* Static */) || isCallExpression) {
	                nodeCheckFlag = 512 /* SuperStatic */;
	            }
	            else {
	                nodeCheckFlag = 256 /* SuperInstance */;
	            }
	            getNodeLinks(node).flags |= nodeCheckFlag;
	            // Due to how we emit async functions, we need to specialize the emit for an async method that contains a `super` reference.
	            // This is due to the fact that we emit the body of an async function inside of a generator function. As generator
	            // functions cannot reference `super`, we emit a helper inside of the method body, but outside of the generator. This helper
	            // uses an arrow function, which is permitted to reference `super`.
	            //
	            // There are two primary ways we can access `super` from within an async method. The first is getting the value of a property
	            // or indexed access on super, either as part of a right-hand-side expression or call expression. The second is when setting the value
	            // of a property or indexed access, either as part of an assignment expression or destructuring assignment.
	            //
	            // The simplest case is reading a value, in which case we will emit something like the following:
	            //
	            //  // ts
	            //  ...
	            //  async asyncMethod() {
	            //    let x = await super.asyncMethod();
	            //    return x;
	            //  }
	            //  ...
	            //
	            //  // js
	            //  ...
	            //  asyncMethod() {
	            //      const _super = name => super[name];
	            //      return __awaiter(this, arguments, Promise, function *() {
	            //          let x = yield _super("asyncMethod").call(this);
	            //          return x;
	            //      });
	            //  }
	            //  ...
	            //
	            // The more complex case is when we wish to assign a value, especially as part of a destructuring assignment. As both cases
	            // are legal in ES6, but also likely less frequent, we emit the same more complex helper for both scenarios:
	            //
	            //  // ts
	            //  ...
	            //  async asyncMethod(ar: Promise<any[]>) {
	            //      [super.a, super.b] = await ar;
	            //  }
	            //  ...
	            //
	            //  // js
	            //  ...
	            //  asyncMethod(ar) {
	            //      const _super = (function (geti, seti) {
	            //          const cache = Object.create(null);
	            //          return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });
	            //      })(name => super[name], (name, value) => super[name] = value);
	            //      return __awaiter(this, arguments, Promise, function *() {
	            //          [_super("a").value, _super("b").value] = yield ar;
	            //      });
	            //  }
	            //  ...
	            //
	            // This helper creates an object with a "value" property that wraps the `super` property or indexed access for both get and set.
	            // This is required for destructuring assignments, as a call expression cannot be used as the target of a destructuring assignment
	            // while a property access can.
	            if (container.kind === 153 /* MethodDeclaration */ && ts.hasModifier(container, 256 /* Async */)) {
	                if (ts.isSuperProperty(node.parent) && ts.isAssignmentTarget(node.parent)) {
	                    getNodeLinks(container).flags |= 4096 /* AsyncMethodWithSuperBinding */;
	                }
	                else {
	                    getNodeLinks(container).flags |= 2048 /* AsyncMethodWithSuper */;
	                }
	            }
	            if (needToCaptureLexicalThis) {
	                // call expressions are allowed only in constructors so they should always capture correct 'this'
	                // super property access expressions can also appear in arrow functions -
	                // in this case they should also use correct lexical this
	                captureLexicalThis(node.parent, container);
	            }
	            if (container.parent.kind === 183 /* ObjectLiteralExpression */) {
	                if (languageVersion < 2 /* ES2015 */) {
	                    error(node, ts.Diagnostics.super_is_only_allowed_in_members_of_object_literal_expressions_when_option_target_is_ES2015_or_higher);
	                    return unknownType;
	                }
	                else {
	                    // for object literal assume that type of 'super' is 'any'
	                    return anyType;
	                }
	            }
	            // at this point the only legal case for parent is ClassLikeDeclaration
	            var classLikeDeclaration = container.parent;
	            if (!ts.getClassExtendsHeritageClauseElement(classLikeDeclaration)) {
	                error(node, ts.Diagnostics.super_can_only_be_referenced_in_a_derived_class);
	                return unknownType;
	            }
	            var classType = getDeclaredTypeOfSymbol(getSymbolOfNode(classLikeDeclaration));
	            var baseClassType = classType && getBaseTypes(classType)[0];
	            if (!baseClassType) {
	                return unknownType;
	            }
	            if (container.kind === 154 /* Constructor */ && isInConstructorArgumentInitializer(node, container)) {
	                // issue custom error message for super property access in constructor arguments (to be aligned with old compiler)
	                error(node, ts.Diagnostics.super_cannot_be_referenced_in_constructor_arguments);
	                return unknownType;
	            }
	            return nodeCheckFlag === 512 /* SuperStatic */
	                ? getBaseConstructorTypeOfClass(classType)
	                : getTypeWithThisArgument(baseClassType, classType.thisType);
	            function isLegalUsageOfSuperExpression(container) {
	                if (!container) {
	                    return false;
	                }
	                if (isCallExpression) {
	                    // TS 1.0 SPEC (April 2014): 4.8.1
	                    // Super calls are only permitted in constructors of derived classes
	                    return container.kind === 154 /* Constructor */;
	                }
	                else {
	                    // TS 1.0 SPEC (April 2014)
	                    // 'super' property access is allowed
	                    // - In a constructor, instance member function, instance member accessor, or instance member variable initializer where this references a derived class instance
	                    // - In a static member function or static member accessor
	                    // topmost container must be something that is directly nested in the class declaration\object literal expression
	                    if (ts.isClassLike(container.parent) || container.parent.kind === 183 /* ObjectLiteralExpression */) {
	                        if (ts.hasModifier(container, 32 /* Static */)) {
	                            return container.kind === 153 /* MethodDeclaration */ ||
	                                container.kind === 152 /* MethodSignature */ ||
	                                container.kind === 155 /* GetAccessor */ ||
	                                container.kind === 156 /* SetAccessor */;
	                        }
	                        else {
	                            return container.kind === 153 /* MethodDeclaration */ ||
	                                container.kind === 152 /* MethodSignature */ ||
	                                container.kind === 155 /* GetAccessor */ ||
	                                container.kind === 156 /* SetAccessor */ ||
	                                container.kind === 151 /* PropertyDeclaration */ ||
	                                container.kind === 150 /* PropertySignature */ ||
	                                container.kind === 154 /* Constructor */;
	                        }
	                    }
	                }
	                return false;
	            }
	        }
	        function getContainingObjectLiteral(func) {
	            return (func.kind === 153 /* MethodDeclaration */ ||
	                func.kind === 155 /* GetAccessor */ ||
	                func.kind === 156 /* SetAccessor */) && func.parent.kind === 183 /* ObjectLiteralExpression */ ? func.parent :
	                func.kind === 191 /* FunctionExpression */ && func.parent.kind === 269 /* PropertyAssignment */ ? func.parent.parent :
	                    undefined;
	        }
	        function getThisTypeArgument(type) {
	            return ts.getObjectFlags(type) & 4 /* Reference */ && type.target === globalThisType ? type.typeArguments[0] : undefined;
	        }
	        function getThisTypeFromContextualType(type) {
	            return mapType(type, function (t) {
	                return t.flags & 262144 /* Intersection */ ? ts.forEach(t.types, getThisTypeArgument) : getThisTypeArgument(t);
	            });
	        }
	        function getContextualThisParameterType(func) {
	            if (func.kind === 192 /* ArrowFunction */) {
	                return undefined;
	            }
	            if (isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
	                var contextualSignature = getContextualSignature(func);
	                if (contextualSignature) {
	                    var thisParameter = contextualSignature.thisParameter;
	                    if (thisParameter) {
	                        return getTypeOfSymbol(thisParameter);
	                    }
	                }
	            }
	            var inJs = ts.isInJavaScriptFile(func);
	            if (noImplicitThis || inJs) {
	                var containingLiteral = getContainingObjectLiteral(func);
	                if (containingLiteral) {
	                    // We have an object literal method. Check if the containing object literal has a contextual type
	                    // that includes a ThisType<T>. If so, T is the contextual type for 'this'. We continue looking in
	                    // any directly enclosing object literals.
	                    var contextualType = getApparentTypeOfContextualType(containingLiteral);
	                    var literal = containingLiteral;
	                    var type = contextualType;
	                    while (type) {
	                        var thisType = getThisTypeFromContextualType(type);
	                        if (thisType) {
	                            return instantiateType(thisType, getContextualMapper(containingLiteral));
	                        }
	                        if (literal.parent.kind !== 269 /* PropertyAssignment */) {
	                            break;
	                        }
	                        literal = literal.parent.parent;
	                        type = getApparentTypeOfContextualType(literal);
	                    }
	                    // There was no contextual ThisType<T> for the containing object literal, so the contextual type
	                    // for 'this' is the non-null form of the contextual type for the containing object literal or
	                    // the type of the object literal itself.
	                    return contextualType ? getNonNullableType(contextualType) : checkExpressionCached(containingLiteral);
	                }
	                // In an assignment of the form 'obj.xxx = function(...)' or 'obj[xxx] = function(...)', the
	                // contextual type for 'this' is 'obj'.
	                var parent = func.parent;
	                if (parent.kind === 199 /* BinaryExpression */ && parent.operatorToken.kind === 58 /* EqualsToken */) {
	                    var target = parent.left;
	                    if (target.kind === 184 /* PropertyAccessExpression */ || target.kind === 185 /* ElementAccessExpression */) {
	                        var expression = target.expression;
	                        // Don't contextually type `this` as `exports` in `exports.Point = function(x, y) { this.x = x; this.y = y; }`
	                        if (inJs && ts.isIdentifier(expression)) {
	                            var sourceFile = ts.getSourceFileOfNode(parent);
	                            if (sourceFile.commonJsModuleIndicator && getResolvedSymbol(expression) === sourceFile.symbol) {
	                                return undefined;
	                            }
	                        }
	                        return checkExpressionCached(expression);
	                    }
	                }
	            }
	            return undefined;
	        }
	        // Return contextual type of parameter or undefined if no contextual type is available
	        function getContextuallyTypedParameterType(parameter) {
	            var func = parameter.parent;
	            if (!isContextSensitiveFunctionOrObjectLiteralMethod(func)) {
	                return undefined;
	            }
	            var iife = ts.getImmediatelyInvokedFunctionExpression(func);
	            if (iife && iife.arguments) {
	                var indexOfParameter = func.parameters.indexOf(parameter);
	                if (parameter.dotDotDotToken) {
	                    var restTypes = [];
	                    for (var i = indexOfParameter; i < iife.arguments.length; i++) {
	                        restTypes.push(getWidenedLiteralType(checkExpression(iife.arguments[i])));
	                    }
	                    return restTypes.length ? createArrayType(getUnionType(restTypes)) : undefined;
	                }
	                var links = getNodeLinks(iife);
	                var cached = links.resolvedSignature;
	                links.resolvedSignature = anySignature;
	                var type = indexOfParameter < iife.arguments.length ?
	                    getWidenedLiteralType(checkExpression(iife.arguments[indexOfParameter])) :
	                    parameter.initializer ? undefined : undefinedWideningType;
	                links.resolvedSignature = cached;
	                return type;
	            }
	            var contextualSignature = getContextualSignature(func);
	            if (contextualSignature) {
	                var funcHasRestParameters = ts.hasRestParameter(func);
	                var len = func.parameters.length - (funcHasRestParameters ? 1 : 0);
	                var indexOfParameter = func.parameters.indexOf(parameter);
	                if (ts.getThisParameter(func) !== undefined && !contextualSignature.thisParameter) {
	                    ts.Debug.assert(indexOfParameter !== 0); // Otherwise we should not have called `getContextuallyTypedParameterType`.
	                    indexOfParameter -= 1;
	                }
	                if (indexOfParameter < len) {
	                    return getTypeAtPosition(contextualSignature, indexOfParameter);
	                }
	                // If last parameter is contextually rest parameter get its type
	                if (funcHasRestParameters &&
	                    indexOfParameter === (func.parameters.length - 1) &&
	                    isRestParameterIndex(contextualSignature, func.parameters.length - 1)) {
	                    return getTypeOfSymbol(ts.lastOrUndefined(contextualSignature.parameters));
	                }
	            }
	        }
	        // In a variable, parameter or property declaration with a type annotation,
	        //   the contextual type of an initializer expression is the type of the variable, parameter or property.
	        // Otherwise, in a parameter declaration of a contextually typed function expression,
	        //   the contextual type of an initializer expression is the contextual type of the parameter.
	        // Otherwise, in a variable or parameter declaration with a binding pattern name,
	        //   the contextual type of an initializer expression is the type implied by the binding pattern.
	        // Otherwise, in a binding pattern inside a variable or parameter declaration,
	        //   the contextual type of an initializer expression is the type annotation of the containing declaration, if present.
	        function getContextualTypeForInitializerExpression(node) {
	            var declaration = node.parent;
	            if (ts.hasInitializer(declaration) && node === declaration.initializer) {
	                var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	                if (typeNode) {
	                    return getTypeFromTypeNode(typeNode);
	                }
	                if (declaration.kind === 148 /* Parameter */) {
	                    var type = getContextuallyTypedParameterType(declaration);
	                    if (type) {
	                        return type;
	                    }
	                }
	                if (ts.isBindingPattern(declaration.name)) {
	                    return getTypeFromBindingPattern(declaration.name, /*includePatternInType*/ true, /*reportErrors*/ false);
	                }
	                if (ts.isBindingPattern(declaration.parent)) {
	                    var parentDeclaration = declaration.parent.parent;
	                    var name = declaration.propertyName || declaration.name;
	                    if (parentDeclaration.kind !== 181 /* BindingElement */) {
	                        var parentTypeNode = ts.getEffectiveTypeAnnotationNode(parentDeclaration);
	                        if (parentTypeNode && !ts.isBindingPattern(name)) {
	                            var text = ts.getTextOfPropertyName(name);
	                            if (text) {
	                                return getTypeOfPropertyOfType(getTypeFromTypeNode(parentTypeNode), text);
	                            }
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getContextualTypeForReturnExpression(node) {
	            var func = ts.getContainingFunction(node);
	            if (func) {
	                var functionFlags = ts.getFunctionFlags(func);
	                if (functionFlags & 1 /* Generator */) { // AsyncGenerator function or Generator function
	                    return undefined;
	                }
	                var contextualReturnType = getContextualReturnType(func);
	                return functionFlags & 2 /* Async */
	                    ? contextualReturnType && getAwaitedTypeOfPromise(contextualReturnType) // Async function
	                    : contextualReturnType; // Regular function
	            }
	            return undefined;
	        }
	        function getContextualTypeForYieldOperand(node) {
	            var func = ts.getContainingFunction(node);
	            if (func) {
	                var functionFlags = ts.getFunctionFlags(func);
	                var contextualReturnType = getContextualReturnType(func);
	                if (contextualReturnType) {
	                    return node.asteriskToken
	                        ? contextualReturnType
	                        : getIteratedTypeOfGenerator(contextualReturnType, (functionFlags & 2 /* Async */) !== 0);
	                }
	            }
	            return undefined;
	        }
	        function isInParameterInitializerBeforeContainingFunction(node) {
	            var inBindingInitializer = false;
	            while (node.parent && !ts.isFunctionLike(node.parent)) {
	                if (ts.isParameter(node.parent) && (inBindingInitializer || node.parent.initializer === node)) {
	                    return true;
	                }
	                if (ts.isBindingElement(node.parent) && node.parent.initializer === node) {
	                    inBindingInitializer = true;
	                }
	                node = node.parent;
	            }
	            return false;
	        }
	        function getContextualReturnType(functionDecl) {
	            // If the containing function has a return type annotation, is a constructor, or is a get accessor whose
	            // corresponding set accessor has a type annotation, return statements in the function are contextually typed
	            if (functionDecl.kind === 154 /* Constructor */ ||
	                ts.getEffectiveReturnTypeNode(functionDecl) ||
	                isGetAccessorWithAnnotatedSetAccessor(functionDecl)) {
	                return getReturnTypeOfSignature(getSignatureFromDeclaration(functionDecl));
	            }
	            // Otherwise, if the containing function is contextually typed by a function type with exactly one call signature
	            // and that call signature is non-generic, return statements are contextually typed by the return type of the signature
	            var signature = getContextualSignatureForFunctionLikeDeclaration(functionDecl);
	            if (signature && !isResolvingReturnTypeOfSignature(signature)) {
	                return getReturnTypeOfSignature(signature);
	            }
	            return undefined;
	        }
	        // In a typed function call, an argument or substitution expression is contextually typed by the type of the corresponding parameter.
	        function getContextualTypeForArgument(callTarget, arg) {
	            var args = getEffectiveCallArguments(callTarget);
	            var argIndex = args.indexOf(arg); // -1 for e.g. the expression of a CallExpression, or the tag of a TaggedTemplateExpression
	            return argIndex === -1 ? undefined : getContextualTypeForArgumentAtIndex(callTarget, argIndex);
	        }
	        function getContextualTypeForArgumentAtIndex(callTarget, argIndex) {
	            // If we're already in the process of resolving the given signature, don't resolve again as
	            // that could cause infinite recursion. Instead, return anySignature.
	            var signature = getNodeLinks(callTarget).resolvedSignature === resolvingSignature ? resolvingSignature : getResolvedSignature(callTarget);
	            return getTypeAtPosition(signature, argIndex);
	        }
	        function getContextualTypeForSubstitutionExpression(template, substitutionExpression) {
	            if (template.parent.kind === 188 /* TaggedTemplateExpression */) {
	                return getContextualTypeForArgument(template.parent, substitutionExpression);
	            }
	            return undefined;
	        }
	        function getContextualTypeForBinaryOperand(node) {
	            var binaryExpression = node.parent;
	            var left = binaryExpression.left, operatorToken = binaryExpression.operatorToken, right = binaryExpression.right;
	            switch (operatorToken.kind) {
	                case 58 /* EqualsToken */:
	                    return node === right && isContextSensitiveAssignment(binaryExpression) ? getTypeOfExpression(left) : undefined;
	                case 54 /* BarBarToken */:
	                    // When an || expression has a contextual type, the operands are contextually typed by that type. When an ||
	                    // expression has no contextual type, the right operand is contextually typed by the type of the left operand,
	                    // except for the special case of Javascript declarations of the form `namespace.prop = namespace.prop || {}`
	                    var type = getContextualType(binaryExpression);
	                    return !type && node === right && !ts.getDeclaredJavascriptInitializer(binaryExpression.parent) && !ts.getAssignedJavascriptInitializer(binaryExpression) ?
	                        getTypeOfExpression(left) : type;
	                case 53 /* AmpersandAmpersandToken */:
	                case 26 /* CommaToken */:
	                    return node === right ? getContextualType(binaryExpression) : undefined;
	                default:
	                    return undefined;
	            }
	        }
	        // In an assignment expression, the right operand is contextually typed by the type of the left operand.
	        // Don't do this for special property assignments to avoid circularity.
	        function isContextSensitiveAssignment(binaryExpression) {
	            var kind = ts.getSpecialPropertyAssignmentKind(binaryExpression);
	            switch (kind) {
	                case 0 /* None */:
	                    return true;
	                case 5 /* Property */:
	                    // If `binaryExpression.left` was assigned a symbol, then this is a new declaration; otherwise it is an assignment to an existing declaration.
	                    // See `bindStaticPropertyAssignment` in `binder.ts`.
	                    return !binaryExpression.left.symbol;
	                case 1 /* ExportsProperty */:
	                case 2 /* ModuleExports */:
	                case 3 /* PrototypeProperty */:
	                case 4 /* ThisProperty */:
	                case 6 /* Prototype */:
	                    return false;
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        function getTypeOfPropertyOfContextualType(type, name) {
	            return mapType(type, function (t) {
	                var prop = t.flags & 458752 /* StructuredType */ ? getPropertyOfType(t, name) : undefined;
	                return prop ? getTypeOfSymbol(prop) : undefined;
	            }, /*noReductions*/ true);
	        }
	        function getIndexTypeOfContextualType(type, kind) {
	            return mapType(type, function (t) { return getIndexTypeOfStructuredType(t, kind); }, /*noReductions*/ true);
	        }
	        // Return true if the given contextual type is a tuple-like type
	        function contextualTypeIsTupleLikeType(type) {
	            return !!(type.flags & 131072 /* Union */ ? ts.forEach(type.types, isTupleLikeType) : isTupleLikeType(type));
	        }
	        // In an object literal contextually typed by a type T, the contextual type of a property assignment is the type of
	        // the matching property in T, if one exists. Otherwise, it is the type of the numeric index signature in T, if one
	        // exists. Otherwise, it is the type of the string index signature in T, if one exists.
	        function getContextualTypeForObjectLiteralMethod(node) {
	            ts.Debug.assert(ts.isObjectLiteralMethod(node));
	            if (node.flags & 8388608 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            return getContextualTypeForObjectLiteralElement(node);
	        }
	        function getContextualTypeForObjectLiteralElement(element) {
	            var objectLiteral = element.parent;
	            var type = getApparentTypeOfContextualType(objectLiteral);
	            if (type) {
	                if (!hasNonBindableDynamicName(element)) {
	                    // For a (non-symbol) computed property, there is no reason to look up the name
	                    // in the type. It will just be "__computed", which does not appear in any
	                    // SymbolTable.
	                    var symbolName_1 = getSymbolOfNode(element).escapedName;
	                    var propertyType = getTypeOfPropertyOfContextualType(type, symbolName_1);
	                    if (propertyType) {
	                        return propertyType;
	                    }
	                }
	                return isNumericName(element.name) && getIndexTypeOfContextualType(type, 1 /* Number */) ||
	                    getIndexTypeOfContextualType(type, 0 /* String */);
	            }
	            return undefined;
	        }
	        // In an array literal contextually typed by a type T, the contextual type of an element expression at index N is
	        // the type of the property with the numeric name N in T, if one exists. Otherwise, if T has a numeric index signature,
	        // it is the type of the numeric index signature in T. Otherwise, in ES6 and higher, the contextual type is the iterated
	        // type of T.
	        function getContextualTypeForElementExpression(arrayContextualType, index) {
	            return arrayContextualType && (getTypeOfPropertyOfContextualType(arrayContextualType, "" + index)
	                || getIndexTypeOfContextualType(arrayContextualType, 1 /* Number */)
	                || getIteratedTypeOrElementType(arrayContextualType, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false, /*checkAssignability*/ false));
	        }
	        // In a contextually typed conditional expression, the true/false expressions are contextually typed by the same type.
	        function getContextualTypeForConditionalOperand(node) {
	            var conditional = node.parent;
	            return node === conditional.whenTrue || node === conditional.whenFalse ? getContextualType(conditional) : undefined;
	        }
	        function getContextualTypeForChildJsxExpression(node) {
	            var attributesType = getApparentTypeOfContextualType(node.openingElement.tagName);
	            // JSX expression is in children of JSX Element, we will look for an "children" atttribute (we get the name from JSX.ElementAttributesProperty)
	            var jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(node));
	            return attributesType && !isTypeAny(attributesType) && jsxChildrenPropertyName && jsxChildrenPropertyName !== "" ? getTypeOfPropertyOfContextualType(attributesType, jsxChildrenPropertyName) : undefined;
	        }
	        function getContextualTypeForJsxExpression(node) {
	            var exprParent = node.parent;
	            return ts.isJsxAttributeLike(exprParent)
	                ? getContextualType(node)
	                : ts.isJsxElement(exprParent)
	                    ? getContextualTypeForChildJsxExpression(exprParent)
	                    : undefined;
	        }
	        function getContextualTypeForJsxAttribute(attribute) {
	            // When we trying to resolve JsxOpeningLikeElement as a stateless function element, we will already give its attributes a contextual type
	            // which is a type of the parameter of the signature we are trying out.
	            // If there is no contextual type (e.g. we are trying to resolve stateful component), get attributes type from resolving element's tagName
	            if (ts.isJsxAttribute(attribute)) {
	                var attributesType = getApparentTypeOfContextualType(attribute.parent);
	                if (!attributesType || isTypeAny(attributesType)) {
	                    return undefined;
	                }
	                return getTypeOfPropertyOfContextualType(attributesType, attribute.name.escapedText);
	            }
	            else {
	                return getContextualType(attribute.parent);
	            }
	        }
	        // Return true if the given expression is possibly a discriminant value. We limit the kinds of
	        // expressions we check to those that don't depend on their contextual type in order not to cause
	        // recursive (and possibly infinite) invocations of getContextualType.
	        function isPossiblyDiscriminantValue(node) {
	            switch (node.kind) {
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 95 /* NullKeyword */:
	                case 71 /* Identifier */:
	                    return true;
	                case 184 /* PropertyAccessExpression */:
	                case 190 /* ParenthesizedExpression */:
	                    return isPossiblyDiscriminantValue(node.expression);
	            }
	            return false;
	        }
	        // Return the contextual type for a given expression node. During overload resolution, a contextual type may temporarily
	        // be "pushed" onto a node using the contextualType property.
	        function getApparentTypeOfContextualType(node) {
	            var contextualType = getContextualType(node);
	            contextualType = contextualType && mapType(contextualType, getApparentType);
	            if (!(contextualType && contextualType.flags & 131072 /* Union */ && ts.isObjectLiteralExpression(node))) {
	                return contextualType;
	            }
	            // Keep the below up-to-date with the work done within `isRelatedTo` by `findMatchingDiscriminantType`
	            var match;
	            propLoop: for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var prop = _a[_i];
	                if (!prop.symbol)
	                    continue;
	                if (prop.kind !== 269 /* PropertyAssignment */)
	                    continue;
	                if (isPossiblyDiscriminantValue(prop.initializer) && isDiscriminantProperty(contextualType, prop.symbol.escapedName)) {
	                    var discriminatingType = checkExpression(prop.initializer);
	                    for (var _b = 0, _c = contextualType.types; _b < _c.length; _b++) {
	                        var type = _c[_b];
	                        var targetType = getTypeOfPropertyOfType(type, prop.symbol.escapedName);
	                        if (targetType && checkTypeAssignableTo(discriminatingType, targetType, /*errorNode*/ undefined)) {
	                            if (match) {
	                                if (type === match)
	                                    continue; // Finding multiple fields which discriminate to the same type is fine
	                                match = undefined;
	                                break propLoop;
	                            }
	                            match = type;
	                        }
	                    }
	                }
	            }
	            return match || contextualType;
	        }
	        /**
	         * Woah! Do you really want to use this function?
	         *
	         * Unless you're trying to get the *non-apparent* type for a
	         * value-literal type or you're authoring relevant portions of this algorithm,
	         * you probably meant to use 'getApparentTypeOfContextualType'.
	         * Otherwise this may not be very useful.
	         *
	         * In cases where you *are* working on this function, you should understand
	         * when it is appropriate to use 'getContextualType' and 'getApparentTypeOfContextualType'.
	         *
	         *   - Use 'getContextualType' when you are simply going to propagate the result to the expression.
	         *   - Use 'getApparentTypeOfContextualType' when you're going to need the members of the type.
	         *
	         * @param node the expression whose contextual type will be returned.
	         * @returns the contextual type of an expression.
	         */
	        function getContextualType(node) {
	            if (node.flags & 8388608 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            if (node.contextualType) {
	                return node.contextualType;
	            }
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 231 /* VariableDeclaration */:
	                case 148 /* Parameter */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 181 /* BindingElement */:
	                    return getContextualTypeForInitializerExpression(node);
	                case 192 /* ArrowFunction */:
	                case 224 /* ReturnStatement */:
	                    return getContextualTypeForReturnExpression(node);
	                case 202 /* YieldExpression */:
	                    return getContextualTypeForYieldOperand(parent);
	                case 186 /* CallExpression */:
	                case 187 /* NewExpression */:
	                    return getContextualTypeForArgument(parent, node);
	                case 189 /* TypeAssertionExpression */:
	                case 207 /* AsExpression */:
	                    return getTypeFromTypeNode(parent.type);
	                case 199 /* BinaryExpression */:
	                    return getContextualTypeForBinaryOperand(node);
	                case 269 /* PropertyAssignment */:
	                case 270 /* ShorthandPropertyAssignment */:
	                    return getContextualTypeForObjectLiteralElement(parent);
	                case 271 /* SpreadAssignment */:
	                    return getApparentTypeOfContextualType(parent.parent);
	                case 182 /* ArrayLiteralExpression */: {
	                    var arrayLiteral = parent;
	                    var type = getApparentTypeOfContextualType(arrayLiteral);
	                    return getContextualTypeForElementExpression(type, ts.indexOfNode(arrayLiteral.elements, node));
	                }
	                case 200 /* ConditionalExpression */:
	                    return getContextualTypeForConditionalOperand(node);
	                case 210 /* TemplateSpan */:
	                    ts.Debug.assert(parent.parent.kind === 201 /* TemplateExpression */);
	                    return getContextualTypeForSubstitutionExpression(parent.parent, node);
	                case 190 /* ParenthesizedExpression */: {
	                    // Like in `checkParenthesizedExpression`, an `/** @type {xyz} */` comment before a parenthesized expression acts as a type cast.
	                    var tag = ts.isInJavaScriptFile(parent) ? ts.getJSDocTypeTag(parent) : undefined;
	                    return tag ? getTypeFromTypeNode(tag.typeExpression.type) : getContextualType(parent);
	                }
	                case 264 /* JsxExpression */:
	                    return getContextualTypeForJsxExpression(parent);
	                case 261 /* JsxAttribute */:
	                case 263 /* JsxSpreadAttribute */:
	                    return getContextualTypeForJsxAttribute(parent);
	                case 256 /* JsxOpeningElement */:
	                case 255 /* JsxSelfClosingElement */:
	                    return getContextualJsxElementAttributesType(parent);
	            }
	            return undefined;
	        }
	        function getContextualMapper(node) {
	            node = ts.findAncestor(node, function (n) { return !!n.contextualMapper; });
	            return node ? node.contextualMapper : identityMapper;
	        }
	        function getContextualJsxElementAttributesType(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            var valueType = checkExpression(node.tagName);
	            if (isTypeAny(valueType)) {
	                // Short-circuit if the class tag is using an element type 'any'
	                return anyType;
	            }
	            var isJs = ts.isInJavaScriptFile(node);
	            return mapType(valueType, function (t) { return getJsxSignaturesParameterTypes(t, isJs, node); });
	        }
	        function getJsxSignaturesParameterTypes(valueType, isJs, context) {
	            // If the elemType is a string type, we have to return anyType to prevent an error downstream as we will try to find construct or call signature of the type
	            if (valueType.flags & 2 /* String */) {
	                return anyType;
	            }
	            else if (valueType.flags & 32 /* StringLiteral */) {
	                // If the elemType is a stringLiteral type, we can then provide a check to make sure that the string literal type is one of the Jsx intrinsic element type
	                // For example:
	                //      var CustomTag: "h1" = "h1";
	                //      <CustomTag> Hello World </CustomTag>
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, context);
	                if (intrinsicElementsType !== unknownType) {
	                    var stringLiteralTypeName = valueType.value;
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, ts.escapeLeadingUnderscores(stringLiteralTypeName));
	                    if (intrinsicProp) {
	                        return getTypeOfSymbol(intrinsicProp);
	                    }
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        return indexSignatureType;
	                    }
	                }
	                return anyType;
	            }
	            // Resolve the signatures, preferring constructor
	            var signatures = getSignaturesOfType(valueType, 1 /* Construct */);
	            var ctor = true;
	            if (signatures.length === 0) {
	                // No construct signatures, try call signatures
	                signatures = getSignaturesOfType(valueType, 0 /* Call */);
	                ctor = false;
	                if (signatures.length === 0) {
	                    // We found no signatures at all, which is an error
	                    return unknownType;
	                }
	            }
	            var links = getNodeLinks(context);
	            if (!links.resolvedSignatures) {
	                links.resolvedSignatures = ts.createMap();
	            }
	            var cacheKey = "" + getTypeId(valueType);
	            var cachedResolved = links.resolvedSignatures.get(cacheKey);
	            if (cachedResolved && cachedResolved !== resolvingSignaturesArray) {
	                signatures = cachedResolved;
	            }
	            else if (!cachedResolved) {
	                links.resolvedSignatures.set(cacheKey, resolvingSignaturesArray);
	                links.resolvedSignatures.set(cacheKey, signatures = instantiateJsxSignatures(context, signatures));
	            }
	            return getUnionType(ts.map(signatures, ctor ? function (t) { return getJsxPropsTypeFromClassType(t, isJs, context, /*reportErrors*/ false); } : function (t) { return getJsxPropsTypeFromCallSignature(t, context); }), 0 /* None */);
	        }
	        function getJsxPropsTypeFromCallSignature(sig, context) {
	            var propsType = getTypeOfFirstParameterOfSignatureWithFallback(sig, emptyObjectType);
	            var intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
	            if (intrinsicAttribs !== unknownType) {
	                propsType = intersectTypes(intrinsicAttribs, propsType);
	            }
	            return propsType;
	        }
	        function getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation) {
	            var instanceType = getReturnTypeOfSignature(sig);
	            return isTypeAny(instanceType) ? instanceType : getTypeOfPropertyOfType(instanceType, forcedLookupLocation);
	        }
	        function getJsxPropsTypeFromClassType(sig, isJs, context, reportErrors) {
	            var forcedLookupLocation = getJsxElementPropertiesName(getJsxNamespaceAt(context));
	            var attributesType = forcedLookupLocation === undefined
	                // If there is no type ElementAttributesProperty, return the type of the first parameter of the signature, which should be the props type
	                ? getTypeOfFirstParameterOfSignatureWithFallback(sig, emptyObjectType)
	                : forcedLookupLocation === ""
	                    // If there is no e.g. 'props' member in ElementAttributesProperty, use the element class type instead
	                    ? getReturnTypeOfSignature(sig)
	                    // Otherwise get the type of the property on the signature return type
	                    : getJsxPropsTypeForSignatureFromMember(sig, forcedLookupLocation);
	            if (!attributesType) {
	                // There is no property named 'props' on this instance type
	                if (reportErrors && !!forcedLookupLocation && !!ts.length(context.attributes.properties)) {
	                    error(context, ts.Diagnostics.JSX_element_class_does_not_support_attributes_because_it_does_not_have_a_0_property, ts.unescapeLeadingUnderscores(forcedLookupLocation));
	                }
	                return emptyObjectType;
	            }
	            else if (isTypeAny(attributesType)) {
	                // Props is of type 'any' or unknown
	                return attributesType;
	            }
	            else {
	                // Normal case -- add in IntrinsicClassElements<T> and IntrinsicElements
	                var apparentAttributesType = attributesType;
	                var intrinsicClassAttribs = getJsxType(JsxNames.IntrinsicClassAttributes, context);
	                if (intrinsicClassAttribs !== unknownType) {
	                    var typeParams = getLocalTypeParametersOfClassOrInterfaceOrTypeAlias(intrinsicClassAttribs.symbol);
	                    var hostClassType = getReturnTypeOfSignature(sig);
	                    apparentAttributesType = intersectTypes(typeParams
	                        ? createTypeReference(intrinsicClassAttribs, fillMissingTypeArguments([hostClassType], typeParams, getMinTypeArgumentCount(typeParams), isJs))
	                        : intrinsicClassAttribs, apparentAttributesType);
	                }
	                var intrinsicAttribs = getJsxType(JsxNames.IntrinsicAttributes, context);
	                if (intrinsicAttribs !== unknownType) {
	                    apparentAttributesType = intersectTypes(intrinsicAttribs, apparentAttributesType);
	                }
	                return apparentAttributesType;
	            }
	        }
	        // If the given type is an object or union type with a single signature, and if that signature has at
	        // least as many parameters as the given function, return the signature. Otherwise return undefined.
	        function getContextualCallSignature(type, node) {
	            var signatures = getSignaturesOfType(type, 0 /* Call */);
	            if (signatures.length === 1) {
	                var signature = signatures[0];
	                if (!isAritySmaller(signature, node)) {
	                    return signature;
	                }
	            }
	        }
	        /** If the contextual signature has fewer parameters than the function expression, do not use it */
	        function isAritySmaller(signature, target) {
	            var targetParameterCount = 0;
	            for (; targetParameterCount < target.parameters.length; targetParameterCount++) {
	                var param = target.parameters[targetParameterCount];
	                if (param.initializer || param.questionToken || param.dotDotDotToken || isJSDocOptionalParameter(param)) {
	                    break;
	                }
	            }
	            if (target.parameters.length && ts.parameterIsThisKeyword(target.parameters[0])) {
	                targetParameterCount--;
	            }
	            var sourceLength = signature.hasRestParameter ? Number.MAX_VALUE : signature.parameters.length;
	            return sourceLength < targetParameterCount;
	        }
	        function isFunctionExpressionOrArrowFunction(node) {
	            return node.kind === 191 /* FunctionExpression */ || node.kind === 192 /* ArrowFunction */;
	        }
	        function getContextualSignatureForFunctionLikeDeclaration(node) {
	            // Only function expressions, arrow functions, and object literal methods are contextually typed.
	            return isFunctionExpressionOrArrowFunction(node) || ts.isObjectLiteralMethod(node)
	                ? getContextualSignature(node)
	                : undefined;
	        }
	        function getContextualTypeForFunctionLikeDeclaration(node) {
	            return ts.isObjectLiteralMethod(node) ?
	                getContextualTypeForObjectLiteralMethod(node) :
	                getApparentTypeOfContextualType(node);
	        }
	        // Return the contextual signature for a given expression node. A contextual type provides a
	        // contextual signature if it has a single call signature and if that call signature is non-generic.
	        // If the contextual type is a union type, get the signature from each type possible and if they are
	        // all identical ignoring their return type, the result is same signature but with return type as
	        // union type of return types from these signatures
	        function getContextualSignature(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            var type;
	            if (ts.isInJavaScriptFile(node)) {
	                var jsdoc = ts.getJSDocType(node);
	                if (jsdoc) {
	                    type = getTypeFromTypeNode(jsdoc);
	                }
	            }
	            if (!type) {
	                type = getContextualTypeForFunctionLikeDeclaration(node);
	            }
	            if (!type) {
	                return undefined;
	            }
	            if (!(type.flags & 131072 /* Union */)) {
	                return getContextualCallSignature(type, node);
	            }
	            var signatureList;
	            var types = type.types;
	            for (var _i = 0, types_15 = types; _i < types_15.length; _i++) {
	                var current = types_15[_i];
	                var signature = getContextualCallSignature(current, node);
	                if (signature) {
	                    if (!signatureList) {
	                        // This signature will contribute to contextual union signature
	                        signatureList = [signature];
	                    }
	                    else if (!compareSignaturesIdentical(signatureList[0], signature, /*partialMatch*/ false, /*ignoreThisTypes*/ true, /*ignoreReturnTypes*/ true, compareTypesIdentical)) {
	                        // Signatures aren't identical, do not use
	                        return undefined;
	                    }
	                    else {
	                        // Use this signature for contextual union signature
	                        signatureList.push(signature);
	                    }
	                }
	            }
	            // Result is union of signatures collected (return type is union of return types of this signature set)
	            var result;
	            if (signatureList) {
	                result = cloneSignature(signatureList[0]);
	                result.unionSignatures = signatureList;
	            }
	            return result;
	        }
	        function checkSpreadExpression(node, checkMode) {
	            if (languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                checkExternalEmitHelpers(node, 1536 /* SpreadIncludes */);
	            }
	            var arrayOrIterableType = checkExpression(node.expression, checkMode);
	            return checkIteratedTypeOrElementType(arrayOrIterableType, node.expression, /*allowStringInput*/ false, /*allowAsyncIterables*/ false);
	        }
	        function hasDefaultValue(node) {
	            return (node.kind === 181 /* BindingElement */ && !!node.initializer) ||
	                (node.kind === 199 /* BinaryExpression */ && node.operatorToken.kind === 58 /* EqualsToken */);
	        }
	        function checkArrayLiteral(node, checkMode) {
	            var elements = node.elements;
	            var hasSpreadElement = false;
	            var elementTypes = [];
	            var inDestructuringPattern = ts.isAssignmentTarget(node);
	            var contextualType = getApparentTypeOfContextualType(node);
	            for (var index = 0; index < elements.length; index++) {
	                var e = elements[index];
	                if (inDestructuringPattern && e.kind === 203 /* SpreadElement */) {
	                    // Given the following situation:
	                    //    var c: {};
	                    //    [...c] = ["", 0];
	                    //
	                    // c is represented in the tree as a spread element in an array literal.
	                    // But c really functions as a rest element, and its purpose is to provide
	                    // a contextual type for the right hand side of the assignment. Therefore,
	                    // instead of calling checkExpression on "...c", which will give an error
	                    // if c is not iterable/array-like, we need to act as if we are trying to
	                    // get the contextual element type from it. So we do something similar to
	                    // getContextualTypeForElementExpression, which will crucially not error
	                    // if there is no index type / iterated type.
	                    var restArrayType = checkExpression(e.expression, checkMode);
	                    var restElementType = getIndexTypeOfType(restArrayType, 1 /* Number */) ||
	                        getIteratedTypeOrElementType(restArrayType, /*errorNode*/ undefined, /*allowStringInput*/ false, /*allowAsyncIterables*/ false, /*checkAssignability*/ false);
	                    if (restElementType) {
	                        elementTypes.push(restElementType);
	                    }
	                }
	                else {
	                    var elementContextualType = getContextualTypeForElementExpression(contextualType, index);
	                    var type = checkExpressionForMutableLocation(e, checkMode, elementContextualType);
	                    elementTypes.push(type);
	                }
	                hasSpreadElement = hasSpreadElement || e.kind === 203 /* SpreadElement */;
	            }
	            if (!hasSpreadElement) {
	                // If array literal is actually a destructuring pattern, mark it as an implied type. We do this such
	                // that we get the same behavior for "var [x, y] = []" and "[x, y] = []".
	                if (inDestructuringPattern && elementTypes.length) {
	                    var type = cloneTypeReference(createTupleType(elementTypes));
	                    type.pattern = node;
	                    return type;
	                }
	                if (contextualType && contextualTypeIsTupleLikeType(contextualType)) {
	                    var pattern = contextualType.pattern;
	                    // If array literal is contextually typed by a binding pattern or an assignment pattern, pad the resulting
	                    // tuple type with the corresponding binding or assignment element types to make the lengths equal.
	                    if (pattern && (pattern.kind === 180 /* ArrayBindingPattern */ || pattern.kind === 182 /* ArrayLiteralExpression */)) {
	                        var patternElements = pattern.elements;
	                        for (var i = elementTypes.length; i < patternElements.length; i++) {
	                            var patternElement = patternElements[i];
	                            if (hasDefaultValue(patternElement)) {
	                                elementTypes.push(contextualType.typeArguments[i]);
	                            }
	                            else {
	                                if (patternElement.kind !== 205 /* OmittedExpression */) {
	                                    error(patternElement, ts.Diagnostics.Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value);
	                                }
	                                elementTypes.push(strictNullChecks ? implicitNeverType : undefinedWideningType);
	                            }
	                        }
	                    }
	                    if (elementTypes.length) {
	                        return createTupleType(elementTypes);
	                    }
	                }
	            }
	            return createArrayType(elementTypes.length ?
	                getUnionType(elementTypes, 2 /* Subtype */) :
	                strictNullChecks ? implicitNeverType : undefinedWideningType);
	        }
	        function isNumericName(name) {
	            switch (name.kind) {
	                case 146 /* ComputedPropertyName */:
	                    return isNumericComputedName(name);
	                case 71 /* Identifier */:
	                    return isNumericLiteralName(name.escapedText);
	                case 8 /* NumericLiteral */:
	                case 9 /* StringLiteral */:
	                    return isNumericLiteralName(name.text);
	                default:
	                    return false;
	            }
	        }
	        function isNumericComputedName(name) {
	            // It seems odd to consider an expression of type Any to result in a numeric name,
	            // but this behavior is consistent with checkIndexedAccess
	            return isTypeAssignableToKind(checkComputedPropertyName(name), 84 /* NumberLike */);
	        }
	        function isInfinityOrNaNString(name) {
	            return name === "Infinity" || name === "-Infinity" || name === "NaN";
	        }
	        function isNumericLiteralName(name) {
	            // The intent of numeric names is that
	            //     - they are names with text in a numeric form, and that
	            //     - setting properties/indexing with them is always equivalent to doing so with the numeric literal 'numLit',
	            //         acquired by applying the abstract 'ToNumber' operation on the name's text.
	            //
	            // The subtlety is in the latter portion, as we cannot reliably say that anything that looks like a numeric literal is a numeric name.
	            // In fact, it is the case that the text of the name must be equal to 'ToString(numLit)' for this to hold.
	            //
	            // Consider the property name '"0xF00D"'. When one indexes with '0xF00D', they are actually indexing with the value of 'ToString(0xF00D)'
	            // according to the ECMAScript specification, so it is actually as if the user indexed with the string '"61453"'.
	            // Thus, the text of all numeric literals equivalent to '61543' such as '0xF00D', '0xf00D', '0170015', etc. are not valid numeric names
	            // because their 'ToString' representation is not equal to their original text.
	            // This is motivated by ECMA-262 sections 9.3.1, 9.8.1, 11.1.5, and 11.2.1.
	            //
	            // Here, we test whether 'ToString(ToNumber(name))' is exactly equal to 'name'.
	            // The '+' prefix operator is equivalent here to applying the abstract ToNumber operation.
	            // Applying the 'toString()' method on a number gives us the abstract ToString operation on a number.
	            //
	            // Note that this accepts the values 'Infinity', '-Infinity', and 'NaN', and that this is intentional.
	            // This is desired behavior, because when indexing with them as numeric entities, you are indexing
	            // with the strings '"Infinity"', '"-Infinity"', and '"NaN"' respectively.
	            return (+name).toString() === name;
	        }
	        function checkComputedPropertyName(node) {
	            var links = getNodeLinks(node.expression);
	            if (!links.resolvedType) {
	                links.resolvedType = checkExpression(node.expression);
	                // This will allow types number, string, symbol or any. It will also allow enums, the unknown
	                // type, and any union of these types (like string | number).
	                if (links.resolvedType.flags & 12288 /* Nullable */ ||
	                    !isTypeAssignableToKind(links.resolvedType, 34 /* StringLike */ | 84 /* NumberLike */ | 1536 /* ESSymbolLike */) &&
	                        !isTypeAssignableTo(links.resolvedType, stringNumberSymbolType)) {
	                    error(node, ts.Diagnostics.A_computed_property_name_must_be_of_type_string_number_symbol_or_any);
	                }
	                else {
	                    checkThatExpressionIsProperSymbolReference(node.expression, links.resolvedType, /*reportError*/ true);
	                }
	            }
	            return links.resolvedType;
	        }
	        function getObjectLiteralIndexInfo(propertyNodes, offset, properties, kind) {
	            var propTypes = [];
	            for (var i = 0; i < properties.length; i++) {
	                if (kind === 0 /* String */ || isNumericName(propertyNodes[i + offset].name)) {
	                    propTypes.push(getTypeOfSymbol(properties[i]));
	                }
	            }
	            var unionType = propTypes.length ? getUnionType(propTypes, 2 /* Subtype */) : undefinedType;
	            return createIndexInfo(unionType, /*isReadonly*/ false);
	        }
	        function checkObjectLiteral(node, checkMode) {
	            var inDestructuringPattern = ts.isAssignmentTarget(node);
	            // Grammar checking
	            checkGrammarObjectLiteralExpression(node, inDestructuringPattern);
	            var propertiesTable;
	            var propertiesArray = [];
	            var spread = emptyObjectType;
	            var propagatedFlags = 8388608 /* FreshLiteral */;
	            var contextualType = getApparentTypeOfContextualType(node);
	            var contextualTypeHasPattern = contextualType && contextualType.pattern &&
	                (contextualType.pattern.kind === 179 /* ObjectBindingPattern */ || contextualType.pattern.kind === 183 /* ObjectLiteralExpression */);
	            var isInJSFile = ts.isInJavaScriptFile(node) && !ts.isInJsonFile(node);
	            var isJSObjectLiteral = !contextualType && isInJSFile;
	            var typeFlags = 0;
	            var patternWithComputedProperties = false;
	            var hasComputedStringProperty = false;
	            var hasComputedNumberProperty = false;
	            if (isInJSFile && node.properties.length === 0) {
	                // an empty JS object literal that nonetheless has members is a JS namespace
	                var symbol = getSymbolOfNode(node);
	                if (symbol.exports) {
	                    propertiesTable = symbol.exports;
	                    symbol.exports.forEach(function (symbol) { return propertiesArray.push(getMergedSymbol(symbol)); });
	                    return createObjectLiteralType();
	                }
	            }
	            propertiesTable = ts.createSymbolTable();
	            var offset = 0;
	            for (var i = 0; i < node.properties.length; i++) {
	                var memberDecl = node.properties[i];
	                var member = getSymbolOfNode(memberDecl);
	                var computedNameType = memberDecl.name && memberDecl.name.kind === 146 /* ComputedPropertyName */ && !ts.isWellKnownSymbolSyntactically(memberDecl.name.expression) ?
	                    checkComputedPropertyName(memberDecl.name) : undefined;
	                if (memberDecl.kind === 269 /* PropertyAssignment */ ||
	                    memberDecl.kind === 270 /* ShorthandPropertyAssignment */ ||
	                    ts.isObjectLiteralMethod(memberDecl)) {
	                    var type = memberDecl.kind === 269 /* PropertyAssignment */ ? checkPropertyAssignment(memberDecl, checkMode) :
	                        memberDecl.kind === 270 /* ShorthandPropertyAssignment */ ? checkExpressionForMutableLocation(memberDecl.name, checkMode) :
	                            checkObjectLiteralMethod(memberDecl, checkMode);
	                    if (isInJSFile) {
	                        var jsDocType = getTypeForDeclarationFromJSDocComment(memberDecl);
	                        if (jsDocType) {
	                            checkTypeAssignableTo(type, jsDocType, memberDecl);
	                            type = jsDocType;
	                        }
	                    }
	                    typeFlags |= type.flags;
	                    var nameType = computedNameType && computedNameType.flags & 1120 /* StringOrNumberLiteralOrUnique */ ?
	                        computedNameType : undefined;
	                    var prop = nameType ?
	                        createSymbol(4 /* Property */ | member.flags, getLateBoundNameFromType(nameType), 1024 /* Late */) :
	                        createSymbol(4 /* Property */ | member.flags, member.escapedName);
	                    if (nameType) {
	                        prop.nameType = nameType;
	                    }
	                    if (inDestructuringPattern) {
	                        // If object literal is an assignment pattern and if the assignment pattern specifies a default value
	                        // for the property, make the property optional.
	                        var isOptional = (memberDecl.kind === 269 /* PropertyAssignment */ && hasDefaultValue(memberDecl.initializer)) ||
	                            (memberDecl.kind === 270 /* ShorthandPropertyAssignment */ && memberDecl.objectAssignmentInitializer);
	                        if (isOptional) {
	                            prop.flags |= 16777216 /* Optional */;
	                        }
	                    }
	                    else if (contextualTypeHasPattern && !(ts.getObjectFlags(contextualType) & 512 /* ObjectLiteralPatternWithComputedProperties */)) {
	                        // If object literal is contextually typed by the implied type of a binding pattern, and if the
	                        // binding pattern specifies a default value for the property, make the property optional.
	                        var impliedProp = getPropertyOfType(contextualType, member.escapedName);
	                        if (impliedProp) {
	                            prop.flags |= impliedProp.flags & 16777216 /* Optional */;
	                        }
	                        else if (!compilerOptions.suppressExcessPropertyErrors && !getIndexInfoOfType(contextualType, 0 /* String */)) {
	                            error(memberDecl.name, ts.Diagnostics.Object_literal_may_only_specify_known_properties_and_0_does_not_exist_in_type_1, symbolToString(member), typeToString(contextualType));
	                        }
	                    }
	                    prop.declarations = member.declarations;
	                    prop.parent = member.parent;
	                    if (member.valueDeclaration) {
	                        prop.valueDeclaration = member.valueDeclaration;
	                    }
	                    prop.type = type;
	                    prop.target = member;
	                    member = prop;
	                }
	                else if (memberDecl.kind === 271 /* SpreadAssignment */) {
	                    if (languageVersion < 2 /* ES2015 */) {
	                        checkExternalEmitHelpers(memberDecl, 2 /* Assign */);
	                    }
	                    if (propertiesArray.length > 0) {
	                        spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                        propertiesArray = [];
	                        propertiesTable = ts.createSymbolTable();
	                        hasComputedStringProperty = false;
	                        hasComputedNumberProperty = false;
	                        typeFlags = 0;
	                    }
	                    var type = checkExpression(memberDecl.expression);
	                    if (!isValidSpreadType(type)) {
	                        error(memberDecl, ts.Diagnostics.Spread_types_may_only_be_created_from_object_types);
	                        return unknownType;
	                    }
	                    spread = getSpreadType(spread, type, node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                    offset = i + 1;
	                    continue;
	                }
	                else {
	                    // TypeScript 1.0 spec (April 2014)
	                    // A get accessor declaration is processed in the same manner as
	                    // an ordinary function declaration(section 6.1) with no parameters.
	                    // A set accessor declaration is processed in the same manner
	                    // as an ordinary function declaration with a single parameter and a Void return type.
	                    ts.Debug.assert(memberDecl.kind === 155 /* GetAccessor */ || memberDecl.kind === 156 /* SetAccessor */);
	                    checkNodeDeferred(memberDecl);
	                }
	                if (computedNameType && !(computedNameType.flags & 1120 /* StringOrNumberLiteralOrUnique */)) {
	                    if (isTypeAssignableTo(computedNameType, stringNumberSymbolType)) {
	                        if (isTypeAssignableTo(computedNameType, numberType)) {
	                            hasComputedNumberProperty = true;
	                        }
	                        else {
	                            hasComputedStringProperty = true;
	                        }
	                        if (inDestructuringPattern) {
	                            patternWithComputedProperties = true;
	                        }
	                    }
	                }
	                else {
	                    propertiesTable.set(member.escapedName, member);
	                }
	                propertiesArray.push(member);
	            }
	            // If object literal is contextually typed by the implied type of a binding pattern, augment the result
	            // type with those properties for which the binding pattern specifies a default value.
	            if (contextualTypeHasPattern) {
	                for (var _i = 0, _a = getPropertiesOfType(contextualType); _i < _a.length; _i++) {
	                    var prop = _a[_i];
	                    if (!propertiesTable.get(prop.escapedName) && !(spread && getPropertyOfType(spread, prop.escapedName))) {
	                        if (!(prop.flags & 16777216 /* Optional */)) {
	                            error(prop.valueDeclaration || prop.bindingElement, ts.Diagnostics.Initializer_provides_no_value_for_this_binding_element_and_the_binding_element_has_no_default_value);
	                        }
	                        propertiesTable.set(prop.escapedName, prop);
	                        propertiesArray.push(prop);
	                    }
	                }
	            }
	            if (spread !== emptyObjectType) {
	                if (propertiesArray.length > 0) {
	                    spread = getSpreadType(spread, createObjectLiteralType(), node.symbol, propagatedFlags, /*objectFlags*/ 0);
	                }
	                return spread;
	            }
	            return createObjectLiteralType();
	            function createObjectLiteralType() {
	                var stringIndexInfo = isJSObjectLiteral ? jsObjectLiteralIndexInfo : hasComputedStringProperty ? getObjectLiteralIndexInfo(node.properties, offset, propertiesArray, 0 /* String */) : undefined;
	                var numberIndexInfo = hasComputedNumberProperty && !isJSObjectLiteral ? getObjectLiteralIndexInfo(node.properties, offset, propertiesArray, 1 /* Number */) : undefined;
	                var result = createAnonymousType(node.symbol, propertiesTable, ts.emptyArray, ts.emptyArray, stringIndexInfo, numberIndexInfo);
	                var freshObjectLiteralFlag = compilerOptions.suppressExcessPropertyErrors ? 0 : 8388608 /* FreshLiteral */;
	                result.flags |= 33554432 /* ContainsObjectLiteral */ | freshObjectLiteralFlag | (typeFlags & 117440512 /* PropagatingFlags */);
	                result.objectFlags |= 128 /* ObjectLiteral */;
	                if (patternWithComputedProperties) {
	                    result.objectFlags |= 512 /* ObjectLiteralPatternWithComputedProperties */;
	                }
	                if (inDestructuringPattern) {
	                    result.pattern = node;
	                }
	                if (!(result.flags & 12288 /* Nullable */)) {
	                    propagatedFlags |= (result.flags & 117440512 /* PropagatingFlags */);
	                }
	                return result;
	            }
	        }
	        function isValidSpreadType(type) {
	            return !!(type.flags & (1 /* Any */ | 134217728 /* NonPrimitive */) ||
	                getFalsyFlags(type) & 14560 /* DefinitelyFalsy */ && isValidSpreadType(removeDefinitelyFalsyTypes(type)) ||
	                type.flags & 65536 /* Object */ && !isGenericMappedType(type) ||
	                type.flags & 393216 /* UnionOrIntersection */ && !ts.forEach(type.types, function (t) { return !isValidSpreadType(t); }));
	        }
	        function checkJsxSelfClosingElement(node, checkMode) {
	            checkJsxOpeningLikeElementOrOpeningFragment(node, checkMode);
	            return getJsxElementTypeAt(node) || anyType;
	        }
	        function checkJsxElement(node, checkMode) {
	            // Check attributes
	            checkJsxOpeningLikeElementOrOpeningFragment(node.openingElement, checkMode);
	            // Perform resolution on the closing tag so that rename/go to definition/etc work
	            if (isJsxIntrinsicIdentifier(node.closingElement.tagName)) {
	                getIntrinsicTagSymbol(node.closingElement);
	            }
	            else {
	                checkExpression(node.closingElement.tagName);
	            }
	            return getJsxElementTypeAt(node) || anyType;
	        }
	        function checkJsxFragment(node, checkMode) {
	            checkJsxOpeningLikeElementOrOpeningFragment(node.openingFragment, checkMode);
	            if (compilerOptions.jsx === 2 /* React */ && (compilerOptions.jsxFactory || ts.getSourceFileOfNode(node).pragmas.has("jsx"))) {
	                error(node, compilerOptions.jsxFactory
	                    ? ts.Diagnostics.JSX_fragment_is_not_supported_when_using_jsxFactory
	                    : ts.Diagnostics.JSX_fragment_is_not_supported_when_using_an_inline_JSX_factory_pragma);
	            }
	            return getJsxElementTypeAt(node) || anyType;
	        }
	        /**
	         * Returns true iff the JSX element name would be a valid JS identifier, ignoring restrictions about keywords not being identifiers
	         */
	        function isUnhyphenatedJsxName(name) {
	            // - is the only character supported in JSX attribute names that isn't valid in JavaScript identifiers
	            return !ts.stringContains(name, "-");
	        }
	        /**
	         * Returns true iff React would emit this tag name as a string rather than an identifier or qualified name
	         */
	        function isJsxIntrinsicIdentifier(tagName) {
	            // TODO (yuisu): comment
	            switch (tagName.kind) {
	                case 184 /* PropertyAccessExpression */:
	                case 99 /* ThisKeyword */:
	                    return false;
	                case 71 /* Identifier */:
	                    return ts.isIntrinsicJsxName(tagName.escapedText);
	                default:
	                    ts.Debug.fail();
	            }
	        }
	        function checkJsxAttribute(node, checkMode) {
	            return node.initializer
	                ? checkExpressionForMutableLocation(node.initializer, checkMode)
	                : trueType; // <Elem attr /> is sugar for <Elem attr={true} />
	        }
	        /**
	         * Get attributes type of the JSX opening-like element. The result is from resolving "attributes" property of the opening-like element.
	         *
	         * @param openingLikeElement a JSX opening-like element
	         * @param filter a function to remove attributes that will not participate in checking whether attributes are assignable
	         * @return an anonymous type (similar to the one returned by checkObjectLiteral) in which its properties are attributes property.
	         * @remarks Because this function calls getSpreadType, it needs to use the same checks as checkObjectLiteral,
	         * which also calls getSpreadType.
	         */
	        function createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode) {
	            var attributes = openingLikeElement.attributes;
	            var attributesTable = ts.createSymbolTable();
	            var spread = emptyObjectType;
	            var hasSpreadAnyType = false;
	            var typeToIntersect;
	            var explicitlySpecifyChildrenAttribute = false;
	            var jsxChildrenPropertyName = getJsxElementChildrenPropertyName(getJsxNamespaceAt(openingLikeElement));
	            for (var _i = 0, _a = attributes.properties; _i < _a.length; _i++) {
	                var attributeDecl = _a[_i];
	                var member = attributeDecl.symbol;
	                if (ts.isJsxAttribute(attributeDecl)) {
	                    var exprType = checkJsxAttribute(attributeDecl, checkMode);
	                    var attributeSymbol = createSymbol(4 /* Property */ | 33554432 /* Transient */ | member.flags, member.escapedName);
	                    attributeSymbol.declarations = member.declarations;
	                    attributeSymbol.parent = member.parent;
	                    if (member.valueDeclaration) {
	                        attributeSymbol.valueDeclaration = member.valueDeclaration;
	                    }
	                    attributeSymbol.type = exprType;
	                    attributeSymbol.target = member;
	                    attributesTable.set(attributeSymbol.escapedName, attributeSymbol);
	                    if (attributeDecl.name.escapedText === jsxChildrenPropertyName) {
	                        explicitlySpecifyChildrenAttribute = true;
	                    }
	                }
	                else {
	                    ts.Debug.assert(attributeDecl.kind === 263 /* JsxSpreadAttribute */);
	                    if (attributesTable.size > 0) {
	                        spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                        attributesTable = ts.createSymbolTable();
	                    }
	                    var exprType = checkExpressionCached(attributeDecl.expression, checkMode);
	                    if (isTypeAny(exprType)) {
	                        hasSpreadAnyType = true;
	                    }
	                    if (isValidSpreadType(exprType)) {
	                        spread = getSpreadType(spread, exprType, openingLikeElement.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                    }
	                    else {
	                        typeToIntersect = typeToIntersect ? getIntersectionType([typeToIntersect, exprType]) : exprType;
	                    }
	                }
	            }
	            if (!hasSpreadAnyType) {
	                if (attributesTable.size > 0) {
	                    spread = getSpreadType(spread, createJsxAttributesType(), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                }
	            }
	            // Handle children attribute
	            var parent = openingLikeElement.parent.kind === 254 /* JsxElement */ ? openingLikeElement.parent : undefined;
	            // We have to check that openingElement of the parent is the one we are visiting as this may not be true for selfClosingElement
	            if (parent && parent.openingElement === openingLikeElement && parent.children.length > 0) {
	                var childrenTypes = checkJsxChildren(parent, checkMode);
	                if (!hasSpreadAnyType && jsxChildrenPropertyName && jsxChildrenPropertyName !== "") {
	                    // Error if there is a attribute named "children" explicitly specified and children element.
	                    // This is because children element will overwrite the value from attributes.
	                    // Note: we will not warn "children" attribute overwritten if "children" attribute is specified in object spread.
	                    if (explicitlySpecifyChildrenAttribute) {
	                        error(attributes, ts.Diagnostics._0_are_specified_twice_The_attribute_named_0_will_be_overwritten, ts.unescapeLeadingUnderscores(jsxChildrenPropertyName));
	                    }
	                    // If there are children in the body of JSX element, create dummy attribute "children" with the union of children types so that it will pass the attribute checking process
	                    var childrenPropSymbol = createSymbol(4 /* Property */ | 33554432 /* Transient */, jsxChildrenPropertyName);
	                    childrenPropSymbol.type = childrenTypes.length === 1 ?
	                        childrenTypes[0] :
	                        createArrayType(getUnionType(childrenTypes));
	                    var childPropMap = ts.createSymbolTable();
	                    childPropMap.set(jsxChildrenPropertyName, childrenPropSymbol);
	                    spread = getSpreadType(spread, createAnonymousType(attributes.symbol, childPropMap, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined), attributes.symbol, /*typeFlags*/ 0, 4096 /* JsxAttributes */);
	                }
	            }
	            if (hasSpreadAnyType) {
	                return anyType;
	            }
	            if (typeToIntersect && spread !== emptyObjectType) {
	                return getIntersectionType([typeToIntersect, spread]);
	            }
	            return typeToIntersect || (spread === emptyObjectType ? createJsxAttributesType() : spread);
	            /**
	             * Create anonymous type from given attributes symbol table.
	             * @param symbol a symbol of JsxAttributes containing attributes corresponding to attributesTable
	             * @param attributesTable a symbol table of attributes property
	             */
	            function createJsxAttributesType() {
	                var result = createAnonymousType(attributes.symbol, attributesTable, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined);
	                result.flags |= 33554432 /* ContainsObjectLiteral */;
	                result.objectFlags |= 128 /* ObjectLiteral */ | 4096 /* JsxAttributes */;
	                return result;
	            }
	        }
	        function checkJsxChildren(node, checkMode) {
	            var childrenTypes = [];
	            for (var _i = 0, _a = node.children; _i < _a.length; _i++) {
	                var child = _a[_i];
	                // In React, JSX text that contains only whitespaces will be ignored so we don't want to type-check that
	                // because then type of children property will have constituent of string type.
	                if (child.kind === 10 /* JsxText */) {
	                    if (!child.containsOnlyWhiteSpaces) {
	                        childrenTypes.push(stringType);
	                    }
	                }
	                else {
	                    childrenTypes.push(checkExpressionForMutableLocation(child, checkMode));
	                }
	            }
	            return childrenTypes;
	        }
	        /**
	         * Check attributes property of opening-like element. This function is called during chooseOverload to get call signature of a JSX opening-like element.
	         * (See "checkApplicableSignatureForJsxOpeningLikeElement" for how the function is used)
	         * @param node a JSXAttributes to be resolved of its type
	         */
	        function checkJsxAttributes(node, checkMode) {
	            return createJsxAttributesTypeFromAttributesProperty(node.parent, checkMode);
	        }
	        function getJsxType(name, location) {
	            var namespace = getJsxNamespaceAt(location);
	            var exports = namespace && getExportsOfSymbol(namespace);
	            var typeSymbol = exports && getSymbol(exports, name, 67901928 /* Type */);
	            return typeSymbol ? getDeclaredTypeOfSymbol(typeSymbol) : unknownType;
	        }
	        /**
	         * Looks up an intrinsic tag name and returns a symbol that either points to an intrinsic
	         * property (in which case nodeLinks.jsxFlags will be IntrinsicNamedElement) or an intrinsic
	         * string index signature (in which case nodeLinks.jsxFlags will be IntrinsicIndexedElement).
	         * May also return unknownSymbol if both of these lookups fail.
	         */
	        function getIntrinsicTagSymbol(node) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedSymbol) {
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, node);
	                if (intrinsicElementsType !== unknownType) {
	                    // Property case
	                    if (!ts.isIdentifier(node.tagName))
	                        return ts.Debug.fail();
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, node.tagName.escapedText);
	                    if (intrinsicProp) {
	                        links.jsxFlags |= 1 /* IntrinsicNamedElement */;
	                        return links.resolvedSymbol = intrinsicProp;
	                    }
	                    // Intrinsic string indexer case
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        links.jsxFlags |= 2 /* IntrinsicIndexedElement */;
	                        return links.resolvedSymbol = intrinsicElementsType.symbol;
	                    }
	                    // Wasn't found
	                    error(node, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.idText(node.tagName), "JSX." + JsxNames.IntrinsicElements);
	                    return links.resolvedSymbol = unknownSymbol;
	                }
	                else {
	                    if (noImplicitAny) {
	                        error(node, ts.Diagnostics.JSX_element_implicitly_has_type_any_because_no_interface_JSX_0_exists, ts.unescapeLeadingUnderscores(JsxNames.IntrinsicElements));
	                    }
	                    return links.resolvedSymbol = unknownSymbol;
	                }
	            }
	            return links.resolvedSymbol;
	        }
	        function instantiateJsxSignatures(node, signatures) {
	            var instantiatedSignatures = [];
	            var candidateForTypeArgumentError;
	            var hasTypeArgumentError = !!node.typeArguments;
	            for (var _i = 0, signatures_3 = signatures; _i < signatures_3.length; _i++) {
	                var signature = signatures_3[_i];
	                if (signature.typeParameters) {
	                    var isJavascript = ts.isInJavaScriptFile(node);
	                    var typeArgumentInstantiated = getJsxSignatureTypeArgumentInstantiation(signature, node, isJavascript, /*reportErrors*/ false);
	                    if (typeArgumentInstantiated) {
	                        hasTypeArgumentError = false;
	                        instantiatedSignatures.push(typeArgumentInstantiated);
	                    }
	                    else {
	                        if (node.typeArguments && hasCorrectTypeArgumentArity(signature, node.typeArguments)) {
	                            candidateForTypeArgumentError = signature;
	                        }
	                        var inferenceContext = createInferenceContext(signature.typeParameters, signature, /*flags*/ isJavascript ? 4 /* AnyDefault */ : 0 /* None */);
	                        var typeArguments = inferJsxTypeArguments(signature, node, inferenceContext);
	                        instantiatedSignatures.push(getSignatureInstantiation(signature, typeArguments, isJavascript));
	                    }
	                }
	                else {
	                    instantiatedSignatures.push(signature);
	                }
	            }
	            if (node.typeArguments && hasTypeArgumentError) {
	                if (candidateForTypeArgumentError) {
	                    checkTypeArguments(candidateForTypeArgumentError, node.typeArguments, /*reportErrors*/ true);
	                }
	                // Length check to avoid issuing an arity error on length=0, the "Type argument list cannot be empty" grammar error alone is fine
	                else if (node.typeArguments.length !== 0) {
	                    diagnostics.add(getTypeArgumentArityError(node, signatures, node.typeArguments));
	                }
	            }
	            return instantiatedSignatures;
	        }
	        function getJsxSignatureTypeArgumentInstantiation(signature, node, isJavascript, reportErrors) {
	            if (!node.typeArguments) {
	                return;
	            }
	            if (!hasCorrectTypeArgumentArity(signature, node.typeArguments)) {
	                return;
	            }
	            var args = checkTypeArguments(signature, node.typeArguments, reportErrors);
	            if (!args) {
	                return;
	            }
	            return getSignatureInstantiation(signature, args, isJavascript);
	        }
	        function getJsxNamespaceAt(location) {
	            var namespaceName = getJsxNamespace(location);
	            var resolvedNamespace = resolveName(location, namespaceName, 1920 /* Namespace */, /*diagnosticMessage*/ undefined, namespaceName, /*isUse*/ false);
	            if (resolvedNamespace) {
	                var candidate = getSymbol(getExportsOfSymbol(resolveSymbol(resolvedNamespace)), JsxNames.JSX, 1920 /* Namespace */);
	                if (candidate) {
	                    return candidate;
	                }
	            }
	            // JSX global fallback
	            return getGlobalSymbol(JsxNames.JSX, 1920 /* Namespace */, /*diagnosticMessage*/ undefined);
	        }
	        /**
	         * Look into JSX namespace and then look for container with matching name as nameOfAttribPropContainer.
	         * Get a single property from that container if existed. Report an error if there are more than one property.
	         *
	         * @param nameOfAttribPropContainer a string of value JsxNames.ElementAttributesPropertyNameContainer or JsxNames.ElementChildrenAttributeNameContainer
	         *          if other string is given or the container doesn't exist, return undefined.
	         */
	        function getNameFromJsxElementAttributesContainer(nameOfAttribPropContainer, jsxNamespace) {
	            // JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute [symbol]
	            var jsxElementAttribPropInterfaceSym = jsxNamespace && getSymbol(jsxNamespace.exports, nameOfAttribPropContainer, 67901928 /* Type */);
	            // JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute [type]
	            var jsxElementAttribPropInterfaceType = jsxElementAttribPropInterfaceSym && getDeclaredTypeOfSymbol(jsxElementAttribPropInterfaceSym);
	            // The properties of JSX.ElementAttributesProperty | JSX.ElementChildrenAttribute
	            var propertiesOfJsxElementAttribPropInterface = jsxElementAttribPropInterfaceType && getPropertiesOfType(jsxElementAttribPropInterfaceType);
	            if (propertiesOfJsxElementAttribPropInterface) {
	                // Element Attributes has zero properties, so the element attributes type will be the class instance type
	                if (propertiesOfJsxElementAttribPropInterface.length === 0) {
	                    return "";
	                }
	                // Element Attributes has one property, so the element attributes type will be the type of the corresponding
	                // property of the class instance type
	                else if (propertiesOfJsxElementAttribPropInterface.length === 1) {
	                    return propertiesOfJsxElementAttribPropInterface[0].escapedName;
	                }
	                else if (propertiesOfJsxElementAttribPropInterface.length > 1) {
	                    // More than one property on ElementAttributesProperty is an error
	                    error(jsxElementAttribPropInterfaceSym.declarations[0], ts.Diagnostics.The_global_type_JSX_0_may_not_have_more_than_one_property, ts.unescapeLeadingUnderscores(nameOfAttribPropContainer));
	                }
	            }
	            return undefined;
	        }
	        /// e.g. "props" for React.d.ts,
	        /// or 'undefined' if ElementAttributesProperty doesn't exist (which means all
	        ///     non-intrinsic elements' attributes type is 'any'),
	        /// or '' if it has 0 properties (which means every
	        ///     non-intrinsic elements' attributes type is the element instance type)
	        function getJsxElementPropertiesName(jsxNamespace) {
	            return getNameFromJsxElementAttributesContainer(JsxNames.ElementAttributesPropertyNameContainer, jsxNamespace);
	        }
	        function getJsxElementChildrenPropertyName(jsxNamespace) {
	            return getNameFromJsxElementAttributesContainer(JsxNames.ElementChildrenAttributeNameContainer, jsxNamespace);
	        }
	        function getApparentTypeOfJsxPropsType(propsType) {
	            if (!propsType) {
	                return undefined;
	            }
	            if (propsType.flags & 262144 /* Intersection */) {
	                var propsApparentType = [];
	                for (var _i = 0, _a = propsType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    propsApparentType.push(getApparentType(t));
	                }
	                return getIntersectionType(propsApparentType);
	            }
	            return getApparentType(propsType);
	        }
	        /**
	         * Get JSX attributes type by trying to resolve openingLikeElement as a stateless function component.
	         * Return only attributes type of successfully resolved call signature.
	         * This function assumes that the caller handled other possible element type of the JSX element (e.g. stateful component)
	         * Unlike tryGetAllJsxStatelessFunctionAttributesType, this function is a default behavior of type-checkers.
	         * @param openingLikeElement a JSX opening-like element to find attributes type
	         * @param elementType a type of the opening-like element. This elementType can't be an union type
	         * @param elemInstanceType an element instance type (the result of newing or invoking this tag)
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global
	         */
	        function defaultTryGetJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            if (!elementClassType || !isTypeAssignableTo(elemInstanceType, elementClassType)) {
	                var jsxStatelessElementType = getJsxStatelessElementTypeAt(openingLikeElement);
	                if (jsxStatelessElementType) {
	                    // We don't call getResolvedSignature here because we have already resolve the type of JSX Element.
	                    var callSignature = getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, /*candidatesOutArray*/ undefined);
	                    if (callSignature !== unknownSignature) {
	                        var callReturnType = callSignature && getReturnTypeOfSignature(callSignature);
	                        var paramType = callReturnType && (callSignature.parameters.length === 0 ? emptyObjectType : getTypeOfSymbol(callSignature.parameters[0]));
	                        paramType = getApparentTypeOfJsxPropsType(paramType);
	                        if (callReturnType && isTypeAssignableTo(callReturnType, jsxStatelessElementType)) {
	                            // Intersect in JSX.IntrinsicAttributes if it exists
	                            var intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes, openingLikeElement);
	                            if (intrinsicAttributes !== unknownType) {
	                                paramType = intersectTypes(intrinsicAttributes, paramType);
	                            }
	                            return paramType;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        /**
	         * Get JSX attributes type by trying to resolve openingLikeElement as a stateless function component.
	         * Return all attributes type of resolved call signature including candidate signatures.
	         * This function assumes that the caller handled other possible element type of the JSX element.
	         * This function is a behavior used by language service when looking up completion in JSX element.
	         * @param openingLikeElement a JSX opening-like element to find attributes type
	         * @param elementType a type of the opening-like element. This elementType can't be an union type
	         * @param elemInstanceType an element instance type (the result of newing or invoking this tag)
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global
	         */
	        function tryGetAllJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            if (!elementClassType || !isTypeAssignableTo(elemInstanceType, elementClassType)) {
	                // Is this is a stateless function component? See if its single signature's return type is assignable to the JSX Element Type
	                var jsxStatelessElementType = getJsxStatelessElementTypeAt(openingLikeElement);
	                if (jsxStatelessElementType) {
	                    // We don't call getResolvedSignature because here we have already resolve the type of JSX Element.
	                    var candidatesOutArray = [];
	                    getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, candidatesOutArray);
	                    var result = void 0;
	                    var allMatchingAttributesType = void 0;
	                    for (var _i = 0, candidatesOutArray_1 = candidatesOutArray; _i < candidatesOutArray_1.length; _i++) {
	                        var candidate = candidatesOutArray_1[_i];
	                        var callReturnType = getReturnTypeOfSignature(candidate);
	                        var paramType = callReturnType && (candidate.parameters.length === 0 ? emptyObjectType : getTypeOfSymbol(candidate.parameters[0]));
	                        paramType = getApparentTypeOfJsxPropsType(paramType);
	                        if (callReturnType && isTypeAssignableTo(callReturnType, jsxStatelessElementType)) {
	                            var shouldBeCandidate = true;
	                            for (var _a = 0, _b = openingLikeElement.attributes.properties; _a < _b.length; _a++) {
	                                var attribute = _b[_a];
	                                if (ts.isJsxAttribute(attribute) &&
	                                    isUnhyphenatedJsxName(attribute.name.escapedText) &&
	                                    !getPropertyOfType(paramType, attribute.name.escapedText)) {
	                                    shouldBeCandidate = false;
	                                    break;
	                                }
	                            }
	                            if (shouldBeCandidate) {
	                                result = intersectTypes(result, paramType);
	                            }
	                            allMatchingAttributesType = intersectTypes(allMatchingAttributesType, paramType);
	                        }
	                    }
	                    // If we can't find any matching, just return everything.
	                    if (!result) {
	                        result = allMatchingAttributesType;
	                    }
	                    // Intersect in JSX.IntrinsicAttributes if it exists
	                    var intrinsicAttributes = getJsxType(JsxNames.IntrinsicAttributes, openingLikeElement);
	                    if (intrinsicAttributes !== unknownType) {
	                        result = intersectTypes(intrinsicAttributes, result);
	                    }
	                    return result;
	                }
	            }
	            return undefined;
	        }
	        function getInstantiatedJsxSignatures(openingLikeElement, elementType, reportErrors) {
	            var links = getNodeLinks(openingLikeElement);
	            if (!links.resolvedSignatures) {
	                links.resolvedSignatures = ts.createMap();
	            }
	            var cacheKey = "" + getTypeId(elementType);
	            if (links.resolvedSignatures.get(cacheKey) && links.resolvedSignatures.get(cacheKey) === resolvingSignaturesArray) {
	                return;
	            }
	            else if (links.resolvedSignatures.get(cacheKey)) {
	                return links.resolvedSignatures.get(cacheKey);
	            }
	            links.resolvedSignatures.set(cacheKey, resolvingSignaturesArray);
	            // Resolve the signatures, preferring constructor
	            var signatures = getSignaturesOfType(elementType, 1 /* Construct */);
	            if (signatures.length === 0) {
	                // No construct signatures, try call signatures
	                signatures = getSignaturesOfType(elementType, 0 /* Call */);
	                if (signatures.length === 0) {
	                    // We found no signatures at all, which is an error
	                    if (reportErrors) {
	                        error(openingLikeElement.tagName, ts.Diagnostics.JSX_element_type_0_does_not_have_any_construct_or_call_signatures, ts.getTextOfNode(openingLikeElement.tagName));
	                    }
	                    return;
	                }
	            }
	            // Instantiate in context of source type
	            var results = instantiateJsxSignatures(openingLikeElement, signatures);
	            links.resolvedSignatures.set(cacheKey, results);
	            return results;
	        }
	        /**
	         * Resolve attributes type of the given opening-like element. The attributes type is a type of attributes associated with the given elementType.
	         * For instance:
	         *      declare function Foo(attr: { p1: string}): JSX.Element;
	         *      <Foo p1={10} />;  // This function will try resolve "Foo" and return an attributes type of "Foo" which is "{ p1: string }"
	         *
	         * The function is intended to initially be called from getAttributesTypeFromJsxOpeningLikeElement which already handle JSX-intrinsic-element..
	         * This function will try to resolve custom JSX attributes type in following order: string literal, stateless function, and stateful component
	         *
	         * @param openingLikeElement a non-intrinsic JSXOPeningLikeElement
	         * @param shouldIncludeAllStatelessAttributesType a boolean indicating whether to include all attributes types from all stateless function signature
	         * @param sourceAttributesType Is the attributes type the user passed, and is used to create inferences in the target type if present
	         * @param elementType an instance type of the given opening-like element. If undefined, the function will check type openinglikeElement's tagname.
	         * @param elementClassType a JSX-ElementClass type. This is a result of looking up ElementClass interface in the JSX global (imported from react.d.ts)
	         * @return attributes type if able to resolve the type of node
	         *         anyType if there is no type ElementAttributesProperty or there is an error
	         *         emptyObjectType if there is no "prop" in the element instance type
	         */
	        function resolveCustomJsxElementAttributesType(openingLikeElement, shouldIncludeAllStatelessAttributesType, elementType, elementClassType) {
	            if (elementType.flags & 131072 /* Union */) {
	                var types = elementType.types;
	                return getUnionType(types.map(function (type) {
	                    return resolveCustomJsxElementAttributesType(openingLikeElement, shouldIncludeAllStatelessAttributesType, type, elementClassType);
	                }), 2 /* Subtype */);
	            }
	            // Shortcircuit any
	            if (isTypeAny(elementType)) {
	                return elementType;
	            }
	            // If the elemType is a string type, we have to return anyType to prevent an error downstream as we will try to find construct or call signature of the type
	            else if (elementType.flags & 2 /* String */) {
	                return anyType;
	            }
	            else if (elementType.flags & 32 /* StringLiteral */) {
	                // If the elemType is a stringLiteral type, we can then provide a check to make sure that the string literal type is one of the Jsx intrinsic element type
	                // For example:
	                //      var CustomTag: "h1" = "h1";
	                //      <CustomTag> Hello World </CustomTag>
	                var intrinsicElementsType = getJsxType(JsxNames.IntrinsicElements, openingLikeElement);
	                if (intrinsicElementsType !== unknownType) {
	                    var stringLiteralTypeName = elementType.value;
	                    var intrinsicProp = getPropertyOfType(intrinsicElementsType, ts.escapeLeadingUnderscores(stringLiteralTypeName));
	                    if (intrinsicProp) {
	                        return getTypeOfSymbol(intrinsicProp);
	                    }
	                    var indexSignatureType = getIndexTypeOfType(intrinsicElementsType, 0 /* String */);
	                    if (indexSignatureType) {
	                        return indexSignatureType;
	                    }
	                    error(openingLikeElement, ts.Diagnostics.Property_0_does_not_exist_on_type_1, stringLiteralTypeName, "JSX." + JsxNames.IntrinsicElements);
	                }
	                // If we need to report an error, we already done so here. So just return any to prevent any more error downstream
	                return anyType;
	            }
	            // Get the element instance type (the result of newing or invoking this tag)
	            var instantiatedSignatures = getInstantiatedJsxSignatures(openingLikeElement, elementType, /*reportErrors*/ true);
	            if (!ts.length(instantiatedSignatures)) {
	                return unknownType;
	            }
	            var elemInstanceType = getUnionType(ts.map(instantiatedSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	            // If we should include all stateless attributes type, then get all attributes type from all stateless function signature.
	            // Otherwise get only attributes type from the signature picked by choose-overload logic.
	            var statelessAttributesType = shouldIncludeAllStatelessAttributesType ?
	                tryGetAllJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType) :
	                defaultTryGetJsxStatelessFunctionAttributesType(openingLikeElement, elementType, elemInstanceType, elementClassType);
	            if (statelessAttributesType) {
	                return statelessAttributesType;
	            }
	            // Issue an error if this return type isn't assignable to JSX.ElementClass
	            if (elementClassType) {
	                checkTypeRelatedTo(elemInstanceType, elementClassType, assignableRelation, openingLikeElement, ts.Diagnostics.JSX_element_type_0_is_not_a_constructor_function_for_JSX_elements);
	            }
	            var isJs = ts.isInJavaScriptFile(openingLikeElement);
	            return getUnionType(ts.map(instantiatedSignatures, function (sig) { return getJsxPropsTypeFromClassType(sig, isJs, openingLikeElement, /*reportErrors*/ true); }));
	        }
	        /**
	         * Get attributes type of the given intrinsic opening-like Jsx element by resolving the tag name.
	         * The function is intended to be called from a function which has checked that the opening element is an intrinsic element.
	         * @param node an intrinsic JSX opening-like element
	         */
	        function getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node) {
	            ts.Debug.assert(isJsxIntrinsicIdentifier(node.tagName));
	            var links = getNodeLinks(node);
	            if (!links.resolvedJsxElementAttributesType) {
	                var symbol = getIntrinsicTagSymbol(node);
	                if (links.jsxFlags & 1 /* IntrinsicNamedElement */) {
	                    return links.resolvedJsxElementAttributesType = getTypeOfSymbol(symbol);
	                }
	                else if (links.jsxFlags & 2 /* IntrinsicIndexedElement */) {
	                    return links.resolvedJsxElementAttributesType = getIndexInfoOfSymbol(symbol, 0 /* String */).type;
	                }
	                else {
	                    return links.resolvedJsxElementAttributesType = unknownType;
	                }
	            }
	            return links.resolvedJsxElementAttributesType;
	        }
	        /**
	         * Get attributes type of the given custom opening-like JSX element.
	         * This function is intended to be called from a caller that handles intrinsic JSX element already.
	         * @param node a custom JSX opening-like element
	         * @param shouldIncludeAllStatelessAttributesType a boolean value used by language service to get all possible attributes type from an overload stateless function component
	         */
	        function getCustomJsxElementAttributesType(node, shouldIncludeAllStatelessAttributesType) {
	            return resolveCustomJsxElementAttributesType(node, shouldIncludeAllStatelessAttributesType, checkExpression(node.tagName), getJsxElementClassTypeAt(node));
	        }
	        /**
	         * Get all possible attributes type, especially from an overload stateless function component, of the given JSX opening-like element.
	         * This function is called by language service (see: completions-tryGetGlobalSymbols).
	         * @param node a JSX opening-like element to get attributes type for
	         */
	        function getAllAttributesTypeFromJsxOpeningLikeElement(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            else {
	                // Because in language service, the given JSX opening-like element may be incomplete and therefore,
	                // we can't resolve to exact signature if the element is a stateless function component so the best thing to do is return all attributes type from all overloads.
	                return getCustomJsxElementAttributesType(node, /*shouldIncludeAllStatelessAttributesType*/ true);
	            }
	        }
	        /**
	         * Get the attributes type, which indicates the attributes that are valid on the given JSXOpeningLikeElement.
	         * @param node a JSXOpeningLikeElement node
	         * @return an attributes type of the given node
	         */
	        function getAttributesTypeFromJsxOpeningLikeElement(node) {
	            if (isJsxIntrinsicIdentifier(node.tagName)) {
	                return getIntrinsicAttributesTypeFromJsxOpeningLikeElement(node);
	            }
	            else {
	                return getCustomJsxElementAttributesType(node, /*shouldIncludeAllStatelessAttributesType*/ false);
	            }
	        }
	        /**
	         * Given a JSX attribute, returns the symbol for the corresponds property
	         * of the element attributes type. Will return unknownSymbol for attributes
	         * that have no matching element attributes type property.
	         */
	        function getJsxAttributePropertySymbol(attrib) {
	            var attributesType = getAttributesTypeFromJsxOpeningLikeElement(attrib.parent.parent);
	            var prop = getPropertyOfType(attributesType, attrib.name.escapedText);
	            return prop || unknownSymbol;
	        }
	        function getJsxElementClassTypeAt(location) {
	            var type = getJsxType(JsxNames.ElementClass, location);
	            if (type === unknownType)
	                return undefined;
	            return type;
	        }
	        function getJsxElementTypeAt(location) {
	            return getJsxType(JsxNames.Element, location);
	        }
	        function getJsxStatelessElementTypeAt(location) {
	            var jsxElementType = getJsxElementTypeAt(location);
	            if (jsxElementType) {
	                return getUnionType([jsxElementType, nullType]);
	            }
	        }
	        /**
	         * Returns all the properties of the Jsx.IntrinsicElements interface
	         */
	        function getJsxIntrinsicTagNamesAt(location) {
	            var intrinsics = getJsxType(JsxNames.IntrinsicElements, location);
	            return intrinsics ? getPropertiesOfType(intrinsics) : ts.emptyArray;
	        }
	        function checkJsxPreconditions(errorNode) {
	            // Preconditions for using JSX
	            if ((compilerOptions.jsx || 0 /* None */) === 0 /* None */) {
	                error(errorNode, ts.Diagnostics.Cannot_use_JSX_unless_the_jsx_flag_is_provided);
	            }
	            if (getJsxElementTypeAt(errorNode) === undefined) {
	                if (noImplicitAny) {
	                    error(errorNode, ts.Diagnostics.JSX_element_implicitly_has_type_any_because_the_global_type_JSX_Element_does_not_exist);
	                }
	            }
	        }
	        function checkJsxOpeningLikeElementOrOpeningFragment(node, checkMode) {
	            var isNodeOpeningLikeElement = ts.isJsxOpeningLikeElement(node);
	            if (isNodeOpeningLikeElement) {
	                checkGrammarJsxElement(node);
	            }
	            checkJsxPreconditions(node);
	            // The reactNamespace/jsxFactory's root symbol should be marked as 'used' so we don't incorrectly elide its import.
	            // And if there is no reactNamespace/jsxFactory's symbol in scope when targeting React emit, we should issue an error.
	            var reactRefErr = diagnostics && compilerOptions.jsx === 2 /* React */ ? ts.Diagnostics.Cannot_find_name_0 : undefined;
	            var reactNamespace = getJsxNamespace(node);
	            var reactLocation = isNodeOpeningLikeElement ? node.tagName : node;
	            var reactSym = resolveName(reactLocation, reactNamespace, 67216319 /* Value */, reactRefErr, reactNamespace, /*isUse*/ true);
	            if (reactSym) {
	                // Mark local symbol as referenced here because it might not have been marked
	                // if jsx emit was not react as there wont be error being emitted
	                reactSym.isReferenced = 67108863 /* All */;
	                // If react symbol is alias, mark it as refereced
	                if (reactSym.flags & 2097152 /* Alias */ && !isConstEnumOrConstEnumOnlyModule(resolveAlias(reactSym))) {
	                    markAliasSymbolAsReferenced(reactSym);
	                }
	            }
	            if (isNodeOpeningLikeElement) {
	                checkJsxAttributesAssignableToTagNameAttributes(node, checkMode);
	            }
	            else {
	                checkJsxChildren(node.parent);
	            }
	        }
	        /**
	         * Check if a property with the given name is known anywhere in the given type. In an object type, a property
	         * is considered known if
	         * 1. the object type is empty and the check is for assignability, or
	         * 2. if the object type has index signatures, or
	         * 3. if the property is actually declared in the object type
	         *    (this means that 'toString', for example, is not usually a known property).
	         * 4. In a union or intersection type,
	         *    a property is considered known if it is known in any constituent type.
	         * @param targetType a type to search a given name in
	         * @param name a property name to search
	         * @param isComparingJsxAttributes a boolean flag indicating whether we are searching in JsxAttributesType
	         */
	        function isKnownProperty(targetType, name, isComparingJsxAttributes) {
	            if (targetType.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(targetType);
	                if (resolved.stringIndexInfo ||
	                    resolved.numberIndexInfo && isNumericLiteralName(name) ||
	                    getPropertyOfObjectType(targetType, name) ||
	                    isComparingJsxAttributes && !isUnhyphenatedJsxName(name)) {
	                    // For JSXAttributes, if the attribute has a hyphenated name, consider that the attribute to be known.
	                    return true;
	                }
	            }
	            else if (targetType.flags & 393216 /* UnionOrIntersection */) {
	                for (var _i = 0, _a = targetType.types; _i < _a.length; _i++) {
	                    var t = _a[_i];
	                    if (isKnownProperty(t, name, isComparingJsxAttributes)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        /**
	         * Check whether the given attributes of JSX opening-like element is assignable to the tagName attributes.
	         *      Get the attributes type of the opening-like element through resolving the tagName, "target attributes"
	         *      Check assignablity between given attributes property, "source attributes", and the "target attributes"
	         * @param openingLikeElement an opening-like JSX element to check its JSXAttributes
	         */
	        function checkJsxAttributesAssignableToTagNameAttributes(openingLikeElement, checkMode) {
	            // The function involves following steps:
	            //      1. Figure out expected attributes type by resolving tagName of the JSX opening-like element, targetAttributesType.
	            //         During these steps, we will try to resolve the tagName as intrinsic name, stateless function, stateful component (in the order)
	            //      2. Solved JSX attributes type given by users, sourceAttributesType, which is by resolving "attributes" property of the JSX opening-like element.
	            //      3. Check if the two are assignable to each other
	            // targetAttributesType is a type of an attribute from resolving tagName of an opening-like JSX element.
	            var targetAttributesType = isJsxIntrinsicIdentifier(openingLikeElement.tagName) ?
	                getIntrinsicAttributesTypeFromJsxOpeningLikeElement(openingLikeElement) :
	                getCustomJsxElementAttributesType(openingLikeElement, /*shouldIncludeAllStatelessAttributesType*/ false);
	            // sourceAttributesType is a type of an attributes properties.
	            // i.e <div attr1={10} attr2="string" />
	            //     attr1 and attr2 are treated as JSXAttributes attached in the JsxOpeningLikeElement as "attributes".
	            var sourceAttributesType = createJsxAttributesTypeFromAttributesProperty(openingLikeElement, checkMode);
	            // Check if sourceAttributesType assignable to targetAttributesType though this check will allow excess properties
	            var isSourceAttributeTypeAssignableToTarget = isTypeAssignableTo(sourceAttributesType, targetAttributesType);
	            // After we check for assignability, we will do another pass to check that all explicitly specified attributes have correct name corresponding in targetAttributeType.
	            // This will allow excess properties in spread type as it is very common pattern to spread outer attributes into React component in its render method.
	            if (isSourceAttributeTypeAssignableToTarget && !isTypeAny(sourceAttributesType) && !isTypeAny(targetAttributesType)) {
	                for (var _i = 0, _a = openingLikeElement.attributes.properties; _i < _a.length; _i++) {
	                    var attribute = _a[_i];
	                    if (!ts.isJsxAttribute(attribute)) {
	                        continue;
	                    }
	                    var attrName = attribute.name;
	                    var isNotIgnoredJsxProperty = (isUnhyphenatedJsxName(ts.idText(attrName)) || !!(getPropertyOfType(targetAttributesType, attrName.escapedText)));
	                    if (isNotIgnoredJsxProperty && !isKnownProperty(targetAttributesType, attrName.escapedText, /*isComparingJsxAttributes*/ true)) {
	                        error(attribute, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.idText(attrName), typeToString(targetAttributesType));
	                        // We break here so that errors won't be cascading
	                        break;
	                    }
	                }
	            }
	            else if (!isSourceAttributeTypeAssignableToTarget) {
	                // Assignability failure - check each prop individually, and if that fails, fall back on the bad error span
	                if (ts.length(openingLikeElement.attributes.properties)) {
	                    var reportedError = false;
	                    var _loop_7 = function (prop) {
	                        if (ts.isJsxSpreadAttribute(prop))
	                            return "continue";
	                        var name = ts.idText(prop.name);
	                        var sourcePropType = getIndexedAccessType(sourceAttributesType, getLiteralType(name));
	                        var targetPropType = getIndexedAccessType(targetAttributesType, getLiteralType(name));
	                        var rootChain = function () { return ts.chainDiagnosticMessages(
	                        /*details*/ undefined, ts.Diagnostics.Types_of_property_0_are_incompatible, name); };
	                        if (!checkTypeAssignableTo(sourcePropType, targetPropType, prop, /*headMessage*/ undefined, rootChain)) {
	                            reportedError = true;
	                        }
	                    };
	                    for (var _b = 0, _c = openingLikeElement.attributes.properties; _b < _c.length; _b++) {
	                        var prop = _c[_b];
	                        _loop_7(prop);
	                    }
	                    if (reportedError) {
	                        return;
	                    }
	                }
	                // Report fallback error on just the component name
	                checkTypeAssignableTo(sourceAttributesType, targetAttributesType, openingLikeElement.tagName);
	            }
	        }
	        function checkJsxExpression(node, checkMode) {
	            if (node.expression) {
	                var type = checkExpression(node.expression, checkMode);
	                if (node.dotDotDotToken && type !== anyType && !isArrayType(type)) {
	                    error(node, ts.Diagnostics.JSX_spread_child_must_be_an_array_type);
	                }
	                return type;
	            }
	            else {
	                return unknownType;
	            }
	        }
	        // If a symbol is a synthesized symbol with no value declaration, we assume it is a property. Example of this are the synthesized
	        // '.prototype' property as well as synthesized tuple index properties.
	        function getDeclarationKindFromSymbol(s) {
	            return s.valueDeclaration ? s.valueDeclaration.kind : 151 /* PropertyDeclaration */;
	        }
	        function getDeclarationNodeFlagsFromSymbol(s) {
	            return s.valueDeclaration ? ts.getCombinedNodeFlags(s.valueDeclaration) : 0;
	        }
	        /**
	         * Return whether this symbol is a member of a prototype somewhere
	         * Note that this is not tracked well within the compiler, so the answer may be incorrect.
	         */
	        function isPrototypeProperty(symbol) {
	            if (symbol.flags & 8192 /* Method */ || ts.getCheckFlags(symbol) & 4 /* SyntheticMethod */) {
	                return true;
	            }
	            if (ts.isInJavaScriptFile(symbol.valueDeclaration)) {
	                var parent = symbol.valueDeclaration.parent;
	                return parent && ts.isBinaryExpression(parent) &&
	                    ts.getSpecialPropertyAssignmentKind(parent) === 3 /* PrototypeProperty */;
	            }
	        }
	        /**
	         * Check whether the requested property access is valid.
	         * Returns true if node is a valid property access, and false otherwise.
	         * @param node The node to be checked.
	         * @param left The left hand side of the property access (e.g.: the super in `super.foo`).
	         * @param type The type of left.
	         * @param prop The symbol for the right hand side of the property access.
	         */
	        function checkPropertyAccessibility(node, left, type, prop) {
	            var flags = ts.getDeclarationModifierFlagsFromSymbol(prop);
	            var errorNode = node.kind === 184 /* PropertyAccessExpression */ || node.kind === 231 /* VariableDeclaration */ ?
	                node.name :
	                node.kind === 178 /* ImportType */ ?
	                    node :
	                    node.right;
	            if (ts.getCheckFlags(prop) & 256 /* ContainsPrivate */) {
	                // Synthetic property with private constituent property
	                error(errorNode, ts.Diagnostics.Property_0_has_conflicting_declarations_and_is_inaccessible_in_type_1, symbolToString(prop), typeToString(type));
	                return false;
	            }
	            if (left.kind === 97 /* SuperKeyword */) {
	                // TS 1.0 spec (April 2014): 4.8.2
	                // - In a constructor, instance member function, instance member accessor, or
	                //   instance member variable initializer where this references a derived class instance,
	                //   a super property access is permitted and must specify a public instance member function of the base class.
	                // - In a static member function or static member accessor
	                //   where this references the constructor function object of a derived class,
	                //   a super property access is permitted and must specify a public static member function of the base class.
	                if (languageVersion < 2 /* ES2015 */) {
	                    if (symbolHasNonMethodDeclaration(prop)) {
	                        error(errorNode, ts.Diagnostics.Only_public_and_protected_methods_of_the_base_class_are_accessible_via_the_super_keyword);
	                        return false;
	                    }
	                }
	                if (flags & 128 /* Abstract */) {
	                    // A method cannot be accessed in a super property access if the method is abstract.
	                    // This error could mask a private property access error. But, a member
	                    // cannot simultaneously be private and abstract, so this will trigger an
	                    // additional error elsewhere.
	                    error(errorNode, ts.Diagnostics.Abstract_method_0_in_class_1_cannot_be_accessed_via_super_expression, symbolToString(prop), typeToString(getDeclaringClass(prop)));
	                    return false;
	                }
	            }
	            // Referencing abstract properties within their own constructors is not allowed
	            if ((flags & 128 /* Abstract */) && ts.isThisProperty(node) && symbolHasNonMethodDeclaration(prop)) {
	                var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
	                if (declaringClassDeclaration && isNodeWithinConstructorOfClass(node, declaringClassDeclaration)) {
	                    error(errorNode, ts.Diagnostics.Abstract_property_0_in_class_1_cannot_be_accessed_in_the_constructor, symbolToString(prop), ts.getTextOfIdentifierOrLiteral(declaringClassDeclaration.name));
	                    return false;
	                }
	            }
	            // Public properties are otherwise accessible.
	            if (!(flags & 24 /* NonPublicAccessibilityModifier */)) {
	                return true;
	            }
	            // Property is known to be private or protected at this point
	            // Private property is accessible if the property is within the declaring class
	            if (flags & 8 /* Private */) {
	                var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(getParentOfSymbol(prop));
	                if (!isNodeWithinClass(node, declaringClassDeclaration)) {
	                    error(errorNode, ts.Diagnostics.Property_0_is_private_and_only_accessible_within_class_1, symbolToString(prop), typeToString(getDeclaringClass(prop)));
	                    return false;
	                }
	                return true;
	            }
	            // Property is known to be protected at this point
	            // All protected properties of a supertype are accessible in a super access
	            if (left.kind === 97 /* SuperKeyword */) {
	                return true;
	            }
	            // Find the first enclosing class that has the declaring classes of the protected constituents
	            // of the property as base classes
	            var enclosingClass = forEachEnclosingClass(node, function (enclosingDeclaration) {
	                var enclosingClass = getDeclaredTypeOfSymbol(getSymbolOfNode(enclosingDeclaration));
	                return isClassDerivedFromDeclaringClasses(enclosingClass, prop) ? enclosingClass : undefined;
	            });
	            // A protected property is accessible if the property is within the declaring class or classes derived from it
	            if (!enclosingClass) {
	                error(errorNode, ts.Diagnostics.Property_0_is_protected_and_only_accessible_within_class_1_and_its_subclasses, symbolToString(prop), typeToString(getDeclaringClass(prop) || type));
	                return false;
	            }
	            // No further restrictions for static properties
	            if (flags & 32 /* Static */) {
	                return true;
	            }
	            if (type.flags & 32768 /* TypeParameter */) {
	                // get the original type -- represented as the type constraint of the 'this' type
	                type = type.isThisType ? getConstraintOfTypeParameter(type) : getBaseConstraintOfType(type);
	            }
	            if (!type || !hasBaseType(type, enclosingClass)) {
	                error(errorNode, ts.Diagnostics.Property_0_is_protected_and_only_accessible_through_an_instance_of_class_1, symbolToString(prop), typeToString(enclosingClass));
	                return false;
	            }
	            return true;
	        }
	        function symbolHasNonMethodDeclaration(symbol) {
	            return forEachProperty(symbol, function (prop) {
	                var propKind = getDeclarationKindFromSymbol(prop);
	                return propKind !== 153 /* MethodDeclaration */ && propKind !== 152 /* MethodSignature */;
	            });
	        }
	        function checkNonNullExpression(node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic) {
	            return checkNonNullType(checkExpression(node), node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic);
	        }
	        function checkNonNullType(type, node, nullDiagnostic, undefinedDiagnostic, nullOrUndefinedDiagnostic) {
	            var kind = (strictNullChecks ? getFalsyFlags(type) : type.flags) & 12288 /* Nullable */;
	            if (kind) {
	                error(node, kind & 4096 /* Undefined */ ? kind & 8192 /* Null */ ?
	                    (nullOrUndefinedDiagnostic || ts.Diagnostics.Object_is_possibly_null_or_undefined) :
	                    (undefinedDiagnostic || ts.Diagnostics.Object_is_possibly_undefined) :
	                    (nullDiagnostic || ts.Diagnostics.Object_is_possibly_null));
	                var t = getNonNullableType(type);
	                return t.flags & (12288 /* Nullable */ | 16384 /* Never */) ? unknownType : t;
	            }
	            return type;
	        }
	        function checkPropertyAccessExpression(node) {
	            return checkPropertyAccessExpressionOrQualifiedName(node, node.expression, node.name);
	        }
	        function checkQualifiedName(node) {
	            return checkPropertyAccessExpressionOrQualifiedName(node, node.left, node.right);
	        }
	        function checkPropertyAccessExpressionOrQualifiedName(node, left, right) {
	            var propType;
	            var leftType = checkNonNullExpression(left);
	            var parentSymbol = getNodeLinks(left).resolvedSymbol;
	            var apparentType = getApparentType(getWidenedType(leftType));
	            if (isTypeAny(apparentType) || apparentType === silentNeverType) {
	                if (ts.isIdentifier(left) && parentSymbol) {
	                    markAliasReferenced(parentSymbol, node);
	                }
	                return apparentType;
	            }
	            var assignmentKind = ts.getAssignmentTargetKind(node);
	            var prop = getPropertyOfType(apparentType, right.escapedText);
	            if (ts.isIdentifier(left) && parentSymbol && !(prop && isConstEnumOrConstEnumOnlyModule(prop))) {
	                markAliasReferenced(parentSymbol, node);
	            }
	            if (!prop) {
	                var indexInfo = getIndexInfoOfType(apparentType, 0 /* String */);
	                if (!(indexInfo && indexInfo.type)) {
	                    if (right.escapedText && !checkAndReportErrorForExtendingInterface(node)) {
	                        reportNonexistentProperty(right, leftType.flags & 32768 /* TypeParameter */ && leftType.isThisType ? apparentType : leftType);
	                    }
	                    return unknownType;
	                }
	                if (indexInfo.isReadonly && (ts.isAssignmentTarget(node) || ts.isDeleteTarget(node))) {
	                    error(node, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(apparentType));
	                }
	                propType = indexInfo.type;
	            }
	            else {
	                checkPropertyNotUsedBeforeDeclaration(prop, node, right);
	                markPropertyAsReferenced(prop, node, left.kind === 99 /* ThisKeyword */);
	                getNodeLinks(node).resolvedSymbol = prop;
	                checkPropertyAccessibility(node, left, apparentType, prop);
	                if (assignmentKind) {
	                    if (isReferenceToReadonlyEntity(node, prop) || isReferenceThroughNamespaceImport(node)) {
	                        error(right, ts.Diagnostics.Cannot_assign_to_0_because_it_is_a_constant_or_a_read_only_property, ts.idText(right));
	                        return unknownType;
	                    }
	                }
	                propType = getConstraintForLocation(getTypeOfSymbol(prop), node);
	            }
	            // Only compute control flow type if this is a property access expression that isn't an
	            // assignment target, and the referenced property was declared as a variable, property,
	            // accessor, or optional method.
	            if (node.kind !== 184 /* PropertyAccessExpression */ ||
	                assignmentKind === 1 /* Definite */ ||
	                prop && !(prop.flags & (3 /* Variable */ | 4 /* Property */ | 98304 /* Accessor */)) && !(prop.flags & 8192 /* Method */ && propType.flags & 131072 /* Union */)) {
	                return propType;
	            }
	            // If strict null checks and strict property initialization checks are enabled, if we have
	            // a this.xxx property access, if the property is an instance property without an initializer,
	            // and if we are in a constructor of the same class as the property declaration, assume that
	            // the property is uninitialized at the top of the control flow.
	            var assumeUninitialized = false;
	            if (strictNullChecks && strictPropertyInitialization && left.kind === 99 /* ThisKeyword */) {
	                var declaration = prop && prop.valueDeclaration;
	                if (declaration && isInstancePropertyWithoutInitializer(declaration)) {
	                    var flowContainer = getControlFlowContainer(node);
	                    if (flowContainer.kind === 154 /* Constructor */ && flowContainer.parent === declaration.parent) {
	                        assumeUninitialized = true;
	                    }
	                }
	            }
	            var flowType = getFlowTypeOfReference(node, propType, assumeUninitialized ? getOptionalType(propType) : propType);
	            if (assumeUninitialized && !(getFalsyFlags(propType) & 4096 /* Undefined */) && getFalsyFlags(flowType) & 4096 /* Undefined */) {
	                error(right, ts.Diagnostics.Property_0_is_used_before_being_assigned, symbolToString(prop));
	                // Return the declared type to reduce follow-on errors
	                return propType;
	            }
	            return assignmentKind ? getBaseTypeOfLiteralType(flowType) : flowType;
	        }
	        function checkPropertyNotUsedBeforeDeclaration(prop, node, right) {
	            var valueDeclaration = prop.valueDeclaration;
	            if (!valueDeclaration) {
	                return;
	            }
	            if (isInPropertyInitializer(node) &&
	                !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)
	                && !isPropertyDeclaredInAncestorClass(prop)) {
	                error(right, ts.Diagnostics.Block_scoped_variable_0_used_before_its_declaration, ts.idText(right));
	            }
	            else if (valueDeclaration.kind === 234 /* ClassDeclaration */ &&
	                node.parent.kind !== 161 /* TypeReference */ &&
	                !(valueDeclaration.flags & 4194304 /* Ambient */) &&
	                !isBlockScopedNameDeclaredBeforeUse(valueDeclaration, right)) {
	                error(right, ts.Diagnostics.Class_0_used_before_its_declaration, ts.idText(right));
	            }
	        }
	        function isInPropertyInitializer(node) {
	            return !!ts.findAncestor(node, function (node) {
	                switch (node.kind) {
	                    case 151 /* PropertyDeclaration */:
	                        return true;
	                    case 269 /* PropertyAssignment */:
	                        // We might be in `a = { b: this.b }`, so keep looking. See `tests/cases/compiler/useBeforeDeclaration_propertyAssignment.ts`.
	                        return false;
	                    default:
	                        return ts.isExpressionNode(node) ? false : "quit";
	                }
	            });
	        }
	        /**
	         * It's possible that "prop.valueDeclaration" is a local declaration, but the property was also declared in a superclass.
	         * In that case we won't consider it used before its declaration, because it gets its value from the superclass' declaration.
	         */
	        function isPropertyDeclaredInAncestorClass(prop) {
	            if (!(prop.parent.flags & 32 /* Class */)) {
	                return false;
	            }
	            var classType = getTypeOfSymbol(prop.parent);
	            while (true) {
	                classType = classType.symbol && getSuperClass(classType);
	                if (!classType) {
	                    return false;
	                }
	                var superProperty = getPropertyOfType(classType, prop.escapedName);
	                if (superProperty && superProperty.valueDeclaration) {
	                    return true;
	                }
	            }
	        }
	        function getSuperClass(classType) {
	            var x = getBaseTypes(classType);
	            if (x.length === 0) {
	                return undefined;
	            }
	            return getIntersectionType(x);
	        }
	        function reportNonexistentProperty(propNode, containingType) {
	            var errorInfo;
	            if (containingType.flags & 131072 /* Union */ && !(containingType.flags & 16382 /* Primitive */)) {
	                for (var _i = 0, _a = containingType.types; _i < _a.length; _i++) {
	                    var subtype = _a[_i];
	                    if (!getPropertyOfType(subtype, propNode.escapedText)) {
	                        errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.declarationNameToString(propNode), typeToString(subtype));
	                        break;
	                    }
	                }
	            }
	            var promisedType = getPromisedTypeOfPromise(containingType);
	            if (promisedType && getPropertyOfType(promisedType, propNode.escapedText)) {
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_forget_to_use_await, ts.declarationNameToString(propNode), typeToString(containingType));
	            }
	            else {
	                var suggestion = getSuggestionForNonexistentProperty(propNode, containingType);
	                if (suggestion !== undefined) {
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2, ts.declarationNameToString(propNode), typeToString(containingType), suggestion);
	                }
	                else {
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Property_0_does_not_exist_on_type_1, ts.declarationNameToString(propNode), typeToString(containingType));
	                }
	            }
	            diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(propNode, errorInfo));
	        }
	        function getSuggestionForNonexistentProperty(node, containingType) {
	            var suggestion = getSpellingSuggestionForName(ts.idText(node), getPropertiesOfType(containingType), 67216319 /* Value */);
	            return suggestion && ts.symbolName(suggestion);
	        }
	        function getSuggestionForNonexistentSymbol(location, outerName, meaning) {
	            ts.Debug.assert(outerName !== undefined, "outername should always be defined");
	            var result = resolveNameHelper(location, outerName, meaning, /*nameNotFoundMessage*/ undefined, outerName, /*isUse*/ false, /*excludeGlobals*/ false, function (symbols, name, meaning) {
	                ts.Debug.assertEqual(outerName, name, "name should equal outerName");
	                var symbol = getSymbol(symbols, name, meaning);
	                // Sometimes the symbol is found when location is a return type of a function: `typeof x` and `x` is declared in the body of the function
	                // So the table *contains* `x` but `x` isn't actually in scope.
	                // However, resolveNameHelper will continue and call this callback again, so we'll eventually get a correct suggestion.
	                return symbol || getSpellingSuggestionForName(ts.unescapeLeadingUnderscores(name), ts.arrayFrom(symbols.values()), meaning);
	            });
	            return result && ts.symbolName(result);
	        }
	        function getSuggestionForNonexistentModule(name, targetModule) {
	            var suggestion = targetModule.exports && getSpellingSuggestionForName(ts.idText(name), getExportsOfModuleAsArray(targetModule), 2623475 /* ModuleMember */);
	            return suggestion && ts.symbolName(suggestion);
	        }
	        /**
	         * Given a name and a list of symbols whose names are *not* equal to the name, return a spelling suggestion if there is one that is close enough.
	         * Names less than length 3 only check for case-insensitive equality, not levenshtein distance.
	         *
	         * If there is a candidate that's the same except for case, return that.
	         * If there is a candidate that's within one edit of the name, return that.
	         * Otherwise, return the candidate with the smallest Levenshtein distance,
	         *    except for candidates:
	         *      * With no name
	         *      * Whose meaning doesn't match the `meaning` parameter.
	         *      * Whose length differs from the target name by more than 0.34 of the length of the name.
	         *      * Whose levenshtein distance is more than 0.4 of the length of the name
	         *        (0.4 allows 1 substitution/transposition for every 5 characters,
	         *         and 1 insertion/deletion at 3 characters)
	         */
	        function getSpellingSuggestionForName(name, symbols, meaning) {
	            var maximumLengthDifference = Math.min(2, Math.floor(name.length * 0.34));
	            var bestDistance = Math.floor(name.length * 0.4) + 1; // If the best result isn't better than this, don't bother.
	            var bestCandidate;
	            var justCheckExactMatches = false;
	            var nameLowerCase = name.toLowerCase();
	            for (var _i = 0, symbols_3 = symbols; _i < symbols_3.length; _i++) {
	                var candidate = symbols_3[_i];
	                var candidateName = ts.symbolName(candidate);
	                if (candidateName.charCodeAt(0) === 34 /* doubleQuote */
	                    || !(candidate.flags & meaning && Math.abs(candidateName.length - nameLowerCase.length) <= maximumLengthDifference)) {
	                    continue;
	                }
	                var candidateNameLowerCase = candidateName.toLowerCase();
	                if (candidateNameLowerCase === nameLowerCase) {
	                    return candidate;
	                }
	                if (justCheckExactMatches) {
	                    continue;
	                }
	                if (candidateName.length < 3) {
	                    // Don't bother, user would have noticed a 2-character name having an extra character
	                    continue;
	                }
	                // Only care about a result better than the best so far.
	                var distance = levenshteinWithMax(nameLowerCase, candidateNameLowerCase, bestDistance - 1);
	                if (distance === undefined) {
	                    continue;
	                }
	                if (distance < 3) {
	                    justCheckExactMatches = true;
	                    bestCandidate = candidate;
	                }
	                else {
	                    ts.Debug.assert(distance < bestDistance); // Else `levenshteinWithMax` should return undefined
	                    bestDistance = distance;
	                    bestCandidate = candidate;
	                }
	            }
	            return bestCandidate;
	        }
	        function levenshteinWithMax(s1, s2, max) {
	            var previous = new Array(s2.length + 1);
	            var current = new Array(s2.length + 1);
	            /** Represents any value > max. We don't care about the particular value. */
	            var big = max + 1;
	            for (var i = 0; i <= s2.length; i++) {
	                previous[i] = i;
	            }
	            for (var i = 1; i <= s1.length; i++) {
	                var c1 = s1.charCodeAt(i - 1);
	                var minJ = i > max ? i - max : 1;
	                var maxJ = s2.length > max + i ? max + i : s2.length;
	                current[0] = i;
	                /** Smallest value of the matrix in the ith column. */
	                var colMin = i;
	                for (var j = 1; j < minJ; j++) {
	                    current[j] = big;
	                }
	                for (var j = minJ; j <= maxJ; j++) {
	                    var dist = c1 === s2.charCodeAt(j - 1)
	                        ? previous[j - 1]
	                        : Math.min(/*delete*/ previous[j] + 1, /*insert*/ current[j - 1] + 1, /*substitute*/ previous[j - 1] + 2);
	                    current[j] = dist;
	                    colMin = Math.min(colMin, dist);
	                }
	                for (var j = maxJ + 1; j <= s2.length; j++) {
	                    current[j] = big;
	                }
	                if (colMin > max) {
	                    // Give up -- everything in this column is > max and it can't get better in future columns.
	                    return undefined;
	                }
	                var temp = previous;
	                previous = current;
	                current = temp;
	            }
	            var res = previous[s2.length];
	            return res > max ? undefined : res;
	        }
	        function markPropertyAsReferenced(prop, nodeForCheckWriteOnly, isThisAccess) {
	            if (!prop || !(prop.flags & 106500 /* ClassMember */) || !prop.valueDeclaration || !ts.hasModifier(prop.valueDeclaration, 8 /* Private */)) {
	                return;
	            }
	            if (nodeForCheckWriteOnly && ts.isWriteOnlyAccess(nodeForCheckWriteOnly) && !(prop.flags & 65536 /* SetAccessor */ && !(prop.flags & 32768 /* GetAccessor */))) {
	                return;
	            }
	            if (isThisAccess) {
	                // Find any FunctionLikeDeclaration because those create a new 'this' binding. But this should only matter for methods (or getters/setters).
	                var containingMethod = ts.findAncestor(nodeForCheckWriteOnly, ts.isFunctionLikeDeclaration);
	                if (containingMethod && containingMethod.symbol === prop) {
	                    return;
	                }
	            }
	            (ts.getCheckFlags(prop) & 1 /* Instantiated */ ? getSymbolLinks(prop).target : prop).isReferenced = 67108863 /* All */;
	        }
	        function isValidPropertyAccess(node, propertyName) {
	            switch (node.kind) {
	                case 184 /* PropertyAccessExpression */:
	                    return isValidPropertyAccessWithType(node, node.expression, propertyName, getWidenedType(checkExpression(node.expression)));
	                case 145 /* QualifiedName */:
	                    return isValidPropertyAccessWithType(node, node.left, propertyName, getWidenedType(checkExpression(node.left)));
	                case 178 /* ImportType */:
	                    return isValidPropertyAccessWithType(node, node, propertyName, getTypeFromTypeNode(node));
	            }
	        }
	        function isValidPropertyAccessForCompletions(node, type, property) {
	            return isValidPropertyAccessWithType(node, node.kind === 178 /* ImportType */ ? node : node.expression, property.escapedName, type)
	                && (!(property.flags & 8192 /* Method */) || isValidMethodAccess(property, type));
	        }
	        function isValidMethodAccess(method, actualThisType) {
	            var propType = getTypeOfFuncClassEnumModule(method);
	            var signatures = getSignaturesOfType(getNonNullableType(propType), 0 /* Call */);
	            ts.Debug.assert(signatures.length !== 0);
	            return signatures.some(function (sig) {
	                var signatureThisType = getThisTypeOfSignature(sig);
	                return !signatureThisType || isTypeAssignableTo(actualThisType, getInstantiatedSignatureThisType(sig, signatureThisType, actualThisType));
	            });
	        }
	        function getInstantiatedSignatureThisType(sig, signatureThisType, actualThisType) {
	            if (!sig.typeParameters) {
	                return signatureThisType;
	            }
	            var context = createInferenceContext(sig.typeParameters, sig, 0 /* None */);
	            inferTypes(context.inferences, actualThisType, signatureThisType);
	            return instantiateType(signatureThisType, createSignatureTypeMapper(sig, getInferredTypes(context)));
	        }
	        function isValidPropertyAccessWithType(node, left, propertyName, type) {
	            if (type === unknownType || isTypeAny(type)) {
	                return true;
	            }
	            var prop = getPropertyOfType(type, propertyName);
	            return prop ? checkPropertyAccessibility(node, left, type, prop)
	                // In js files properties of unions are allowed in completion
	                : ts.isInJavaScriptFile(node) && (type.flags & 131072 /* Union */) && type.types.some(function (elementType) { return isValidPropertyAccessWithType(node, left, propertyName, elementType); });
	        }
	        /**
	         * Return the symbol of the for-in variable declared or referenced by the given for-in statement.
	         */
	        function getForInVariableSymbol(node) {
	            var initializer = node.initializer;
	            if (initializer.kind === 232 /* VariableDeclarationList */) {
	                var variable = initializer.declarations[0];
	                if (variable && !ts.isBindingPattern(variable.name)) {
	                    return getSymbolOfNode(variable);
	                }
	            }
	            else if (initializer.kind === 71 /* Identifier */) {
	                return getResolvedSymbol(initializer);
	            }
	            return undefined;
	        }
	        /**
	         * Return true if the given type is considered to have numeric property names.
	         */
	        function hasNumericPropertyNames(type) {
	            return getIndexTypeOfType(type, 1 /* Number */) && !getIndexTypeOfType(type, 0 /* String */);
	        }
	        /**
	         * Return true if given node is an expression consisting of an identifier (possibly parenthesized)
	         * that references a for-in variable for an object with numeric property names.
	         */
	        function isForInVariableForNumericPropertyNames(expr) {
	            var e = ts.skipParentheses(expr);
	            if (e.kind === 71 /* Identifier */) {
	                var symbol = getResolvedSymbol(e);
	                if (symbol.flags & 3 /* Variable */) {
	                    var child = expr;
	                    var node = expr.parent;
	                    while (node) {
	                        if (node.kind === 220 /* ForInStatement */ &&
	                            child === node.statement &&
	                            getForInVariableSymbol(node) === symbol &&
	                            hasNumericPropertyNames(getTypeOfExpression(node.expression))) {
	                            return true;
	                        }
	                        child = node;
	                        node = node.parent;
	                    }
	                }
	            }
	            return false;
	        }
	        function checkIndexedAccess(node) {
	            var objectType = checkNonNullExpression(node.expression);
	            var indexExpression = node.argumentExpression;
	            if (!indexExpression) {
	                var sourceFile = ts.getSourceFileOfNode(node);
	                if (node.parent.kind === 187 /* NewExpression */ && node.parent.expression === node) {
	                    var start = ts.skipTrivia(sourceFile.text, node.expression.end);
	                    var end = node.end;
	                    grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.new_T_cannot_be_used_to_create_an_array_Use_new_Array_T_instead);
	                }
	                else {
	                    var start = node.end - "]".length;
	                    var end = node.end;
	                    grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.Expression_expected);
	                }
	                return unknownType;
	            }
	            var indexType = isForInVariableForNumericPropertyNames(indexExpression) ? numberType : checkExpression(indexExpression);
	            if (objectType === unknownType || objectType === silentNeverType) {
	                return objectType;
	            }
	            if (isConstEnumObjectType(objectType) && indexExpression.kind !== 9 /* StringLiteral */) {
	                error(indexExpression, ts.Diagnostics.A_const_enum_member_can_only_be_accessed_using_a_string_literal);
	                return unknownType;
	            }
	            return checkIndexedAccessIndexType(getIndexedAccessType(objectType, indexType, node), node);
	        }
	        function checkThatExpressionIsProperSymbolReference(expression, expressionType, reportError) {
	            if (expressionType === unknownType) {
	                // There is already an error, so no need to report one.
	                return false;
	            }
	            if (!ts.isWellKnownSymbolSyntactically(expression)) {
	                return false;
	            }
	            // Make sure the property type is the primitive symbol type
	            if ((expressionType.flags & 1536 /* ESSymbolLike */) === 0) {
	                if (reportError) {
	                    error(expression, ts.Diagnostics.A_computed_property_name_of_the_form_0_must_be_of_type_symbol, ts.getTextOfNode(expression));
	                }
	                return false;
	            }
	            // The name is Symbol.<someName>, so make sure Symbol actually resolves to the
	            // global Symbol object
	            var leftHandSide = expression.expression;
	            var leftHandSideSymbol = getResolvedSymbol(leftHandSide);
	            if (!leftHandSideSymbol) {
	                return false;
	            }
	            var globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ true);
	            if (!globalESSymbol) {
	                // Already errored when we tried to look up the symbol
	                return false;
	            }
	            if (leftHandSideSymbol !== globalESSymbol) {
	                if (reportError) {
	                    error(leftHandSide, ts.Diagnostics.Symbol_reference_does_not_refer_to_the_global_Symbol_constructor_object);
	                }
	                return false;
	            }
	            return true;
	        }
	        function callLikeExpressionMayHaveTypeArguments(node) {
	            // TODO: Also include tagged templates (https://github.com/Microsoft/TypeScript/issues/11947)
	            return ts.isCallOrNewExpression(node);
	        }
	        function resolveUntypedCall(node) {
	            if (callLikeExpressionMayHaveTypeArguments(node)) {
	                // Check type arguments even though we will give an error that untyped calls may not accept type arguments.
	                // This gets us diagnostics for the type arguments and marks them as referenced.
	                ts.forEach(node.typeArguments, checkSourceElement);
	            }
	            if (node.kind === 188 /* TaggedTemplateExpression */) {
	                checkExpression(node.template);
	            }
	            else if (node.kind !== 149 /* Decorator */) {
	                ts.forEach(node.arguments, function (argument) {
	                    checkExpression(argument);
	                });
	            }
	            return anySignature;
	        }
	        function resolveErrorCall(node) {
	            resolveUntypedCall(node);
	            return unknownSignature;
	        }
	        // Re-order candidate signatures into the result array. Assumes the result array to be empty.
	        // The candidate list orders groups in reverse, but within a group signatures are kept in declaration order
	        // A nit here is that we reorder only signatures that belong to the same symbol,
	        // so order how inherited signatures are processed is still preserved.
	        // interface A { (x: string): void }
	        // interface B extends A { (x: 'foo'): string }
	        // const b: B;
	        // b('foo') // <- here overloads should be processed as [(x:'foo'): string, (x: string): void]
	        function reorderCandidates(signatures, result) {
	            var lastParent;
	            var lastSymbol;
	            var cutoffIndex = 0;
	            var index;
	            var specializedIndex = -1;
	            var spliceIndex;
	            ts.Debug.assert(!result.length);
	            for (var _i = 0, signatures_4 = signatures; _i < signatures_4.length; _i++) {
	                var signature = signatures_4[_i];
	                var symbol = signature.declaration && getSymbolOfNode(signature.declaration);
	                var parent = signature.declaration && signature.declaration.parent;
	                if (!lastSymbol || symbol === lastSymbol) {
	                    if (lastParent && parent === lastParent) {
	                        index++;
	                    }
	                    else {
	                        lastParent = parent;
	                        index = cutoffIndex;
	                    }
	                }
	                else {
	                    // current declaration belongs to a different symbol
	                    // set cutoffIndex so re-orderings in the future won't change result set from 0 to cutoffIndex
	                    index = cutoffIndex = result.length;
	                    lastParent = parent;
	                }
	                lastSymbol = symbol;
	                // specialized signatures always need to be placed before non-specialized signatures regardless
	                // of the cutoff position; see GH#1133
	                if (signature.hasLiteralTypes) {
	                    specializedIndex++;
	                    spliceIndex = specializedIndex;
	                    // The cutoff index always needs to be greater than or equal to the specialized signature index
	                    // in order to prevent non-specialized signatures from being added before a specialized
	                    // signature.
	                    cutoffIndex++;
	                }
	                else {
	                    spliceIndex = index;
	                }
	                result.splice(spliceIndex, 0, signature);
	            }
	        }
	        function getSpreadArgumentIndex(args) {
	            for (var i = 0; i < args.length; i++) {
	                var arg = args[i];
	                if (arg && arg.kind === 203 /* SpreadElement */) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function hasCorrectArity(node, args, signature, signatureHelpTrailingComma) {
	            if (signatureHelpTrailingComma === void 0) { signatureHelpTrailingComma = false; }
	            var argCount; // Apparent number of arguments we will have in this call
	            var typeArguments; // Type arguments (undefined if none)
	            var callIsIncomplete; // In incomplete call we want to be lenient when we have too few arguments
	            var spreadArgIndex = -1;
	            if (ts.isJsxOpeningLikeElement(node)) {
	                // The arity check will be done in "checkApplicableSignatureForJsxOpeningLikeElement".
	                return true;
	            }
	            if (node.kind === 188 /* TaggedTemplateExpression */) {
	                // Even if the call is incomplete, we'll have a missing expression as our last argument,
	                // so we can say the count is just the arg list length
	                argCount = args.length;
	                typeArguments = node.typeArguments;
	                if (node.template.kind === 201 /* TemplateExpression */) {
	                    // If a tagged template expression lacks a tail literal, the call is incomplete.
	                    // Specifically, a template only can end in a TemplateTail or a Missing literal.
	                    var lastSpan = ts.lastOrUndefined(node.template.templateSpans);
	                    ts.Debug.assert(lastSpan !== undefined); // we should always have at least one span.
	                    callIsIncomplete = ts.nodeIsMissing(lastSpan.literal) || !!lastSpan.literal.isUnterminated;
	                }
	                else {
	                    // If the template didn't end in a backtick, or its beginning occurred right prior to EOF,
	                    // then this might actually turn out to be a TemplateHead in the future;
	                    // so we consider the call to be incomplete.
	                    var templateLiteral = node.template;
	                    ts.Debug.assert(templateLiteral.kind === 13 /* NoSubstitutionTemplateLiteral */);
	                    callIsIncomplete = !!templateLiteral.isUnterminated;
	                }
	            }
	            else if (node.kind === 149 /* Decorator */) {
	                typeArguments = undefined;
	                argCount = getEffectiveArgumentCount(node, /*args*/ undefined, signature);
	            }
	            else {
	                if (!node.arguments) {
	                    // This only happens when we have something of the form: 'new C'
	                    ts.Debug.assert(node.kind === 187 /* NewExpression */);
	                    return signature.minArgumentCount === 0;
	                }
	                argCount = signatureHelpTrailingComma ? args.length + 1 : args.length;
	                // If we are missing the close parenthesis, the call is incomplete.
	                callIsIncomplete = node.arguments.end === node.end;
	                typeArguments = node.typeArguments;
	                spreadArgIndex = getSpreadArgumentIndex(args);
	            }
	            if (!hasCorrectTypeArgumentArity(signature, typeArguments)) {
	                return false;
	            }
	            // If a spread argument is present, check that it corresponds to a rest parameter or at least that it's in the valid range.
	            if (spreadArgIndex >= 0) {
	                return isRestParameterIndex(signature, spreadArgIndex) ||
	                    signature.minArgumentCount <= spreadArgIndex && spreadArgIndex < signature.parameters.length;
	            }
	            // Too many arguments implies incorrect arity.
	            if (!signature.hasRestParameter && argCount > signature.parameters.length) {
	                return false;
	            }
	            // If the call is incomplete, we should skip the lower bound check.
	            var hasEnoughArguments = argCount >= signature.minArgumentCount;
	            return callIsIncomplete || hasEnoughArguments;
	        }
	        function hasCorrectTypeArgumentArity(signature, typeArguments) {
	            // If the user supplied type arguments, but the number of type arguments does not match
	            // the declared number of type parameters, the call has an incorrect arity.
	            var numTypeParameters = ts.length(signature.typeParameters);
	            var minTypeArgumentCount = getMinTypeArgumentCount(signature.typeParameters);
	            return !typeArguments ||
	                (typeArguments.length >= minTypeArgumentCount && typeArguments.length <= numTypeParameters);
	        }
	        // If type has a single call signature and no other members, return that signature. Otherwise, return undefined.
	        function getSingleCallSignature(type) {
	            if (type.flags & 65536 /* Object */) {
	                var resolved = resolveStructuredTypeMembers(type);
	                if (resolved.callSignatures.length === 1 && resolved.constructSignatures.length === 0 &&
	                    resolved.properties.length === 0 && !resolved.stringIndexInfo && !resolved.numberIndexInfo) {
	                    return resolved.callSignatures[0];
	                }
	            }
	            return undefined;
	        }
	        // Instantiate a generic signature in the context of a non-generic signature (section 3.8.5 in TypeScript spec)
	        function instantiateSignatureInContextOf(signature, contextualSignature, contextualMapper, compareTypes) {
	            var context = createInferenceContext(signature.typeParameters, signature, 1 /* InferUnionTypes */, compareTypes);
	            forEachMatchingParameterType(contextualSignature, signature, function (source, target) {
	                // Type parameters from outer context referenced by source type are fixed by instantiation of the source type
	                inferTypes(context.inferences, instantiateType(source, contextualMapper || identityMapper), target);
	            });
	            if (!contextualMapper) {
	                inferTypes(context.inferences, getReturnTypeOfSignature(contextualSignature), getReturnTypeOfSignature(signature), 8 /* ReturnType */);
	            }
	            return getSignatureInstantiation(signature, getInferredTypes(context), ts.isInJavaScriptFile(contextualSignature.declaration));
	        }
	        function inferJsxTypeArguments(signature, node, context) {
	            // Skip context sensitive pass
	            var skipContextParamType = getTypeAtPosition(signature, 0);
	            var checkAttrTypeSkipContextSensitive = checkExpressionWithContextualType(node.attributes, skipContextParamType, identityMapper);
	            inferTypes(context.inferences, checkAttrTypeSkipContextSensitive, skipContextParamType);
	            // Standard pass
	            var paramType = getTypeAtPosition(signature, 0);
	            var checkAttrType = checkExpressionWithContextualType(node.attributes, paramType, context);
	            inferTypes(context.inferences, checkAttrType, paramType);
	            return getInferredTypes(context);
	        }
	        function inferTypeArguments(node, signature, args, excludeArgument, context) {
	            // Clear out all the inference results from the last time inferTypeArguments was called on this context
	            for (var _i = 0, _a = context.inferences; _i < _a.length; _i++) {
	                var inference = _a[_i];
	                // As an optimization, we don't have to clear (and later recompute) inferred types
	                // for type parameters that have already been fixed on the previous call to inferTypeArguments.
	                // It would be just as correct to reset all of them. But then we'd be repeating the same work
	                // for the type parameters that were fixed, namely the work done by getInferredType.
	                if (!inference.isFixed) {
	                    inference.inferredType = undefined;
	                }
	            }
	            // If a contextual type is available, infer from that type to the return type of the call expression. For
	            // example, given a 'function wrap<T, U>(cb: (x: T) => U): (x: T) => U' and a call expression
	            // 'let f: (x: string) => number = wrap(s => s.length)', we infer from the declared type of 'f' to the
	            // return type of 'wrap'.
	            if (node.kind !== 149 /* Decorator */) {
	                var contextualType = getContextualType(node);
	                if (contextualType) {
	                    // We clone the contextual mapper to avoid disturbing a resolution in progress for an
	                    // outer call expression. Effectively we just want a snapshot of whatever has been
	                    // inferred for any outer call expression so far.
	                    var instantiatedType = instantiateType(contextualType, cloneTypeMapper(getContextualMapper(node)));
	                    // If the contextual type is a generic function type with a single call signature, we
	                    // instantiate the type with its own type parameters and type arguments. This ensures that
	                    // the type parameters are not erased to type any during type inference such that they can
	                    // be inferred as actual types from the contextual type. For example:
	                    //   declare function arrayMap<T, U>(f: (x: T) => U): (a: T[]) => U[];
	                    //   const boxElements: <A>(a: A[]) => { value: A }[] = arrayMap(value => ({ value }));
	                    // Above, the type of the 'value' parameter is inferred to be 'A'.
	                    var contextualSignature = getSingleCallSignature(instantiatedType);
	                    var inferenceSourceType = contextualSignature && contextualSignature.typeParameters ?
	                        getOrCreateTypeFromSignature(getSignatureInstantiation(contextualSignature, contextualSignature.typeParameters, ts.isInJavaScriptFile(node))) :
	                        instantiatedType;
	                    var inferenceTargetType = getReturnTypeOfSignature(signature);
	                    // Inferences made from return types have lower priority than all other inferences.
	                    inferTypes(context.inferences, inferenceSourceType, inferenceTargetType, 8 /* ReturnType */);
	                }
	            }
	            var thisType = getThisTypeOfSignature(signature);
	            if (thisType) {
	                var thisArgumentNode = getThisArgumentOfCall(node);
	                var thisArgumentType = thisArgumentNode ? checkExpression(thisArgumentNode) : voidType;
	                inferTypes(context.inferences, thisArgumentType, thisType);
	            }
	            // We perform two passes over the arguments. In the first pass we infer from all arguments, but use
	            // wildcards for all context sensitive function expressions.
	            var argCount = getEffectiveArgumentCount(node, args, signature);
	            for (var i = 0; i < argCount; i++) {
	                var arg = getEffectiveArgument(node, args, i);
	                // If the effective argument is 'undefined', then it is an argument that is present but is synthetic.
	                if (arg === undefined || arg.kind !== 205 /* OmittedExpression */) {
	                    var paramType = getTypeAtPosition(signature, i);
	                    var argType = getEffectiveArgumentType(node, i);
	                    // If the effective argument type is 'undefined', there is no synthetic type
	                    // for the argument. In that case, we should check the argument.
	                    if (argType === undefined) {
	                        // For context sensitive arguments we pass the identityMapper, which is a signal to treat all
	                        // context sensitive function expressions as wildcards
	                        var mapper = excludeArgument && excludeArgument[i] !== undefined ? identityMapper : context;
	                        argType = checkExpressionWithContextualType(arg, paramType, mapper);
	                    }
	                    inferTypes(context.inferences, argType, paramType);
	                }
	            }
	            // In the second pass we visit only context sensitive arguments, and only those that aren't excluded, this
	            // time treating function expressions normally (which may cause previously inferred type arguments to be fixed
	            // as we construct types for contextually typed parameters)
	            // Decorators will not have `excludeArgument`, as their arguments cannot be contextually typed.
	            // Tagged template expressions will always have `undefined` for `excludeArgument[0]`.
	            if (excludeArgument) {
	                for (var i = 0; i < argCount; i++) {
	                    // No need to check for omitted args and template expressions, their exclusion value is always undefined
	                    if (excludeArgument[i] === false) {
	                        var arg = args[i];
	                        var paramType = getTypeAtPosition(signature, i);
	                        inferTypes(context.inferences, checkExpressionWithContextualType(arg, paramType, context), paramType);
	                    }
	                }
	            }
	            return getInferredTypes(context);
	        }
	        function checkTypeArguments(signature, typeArgumentNodes, reportErrors, headMessage) {
	            var isJavascript = ts.isInJavaScriptFile(signature.declaration);
	            var typeParameters = signature.typeParameters;
	            var typeArgumentTypes = fillMissingTypeArguments(ts.map(typeArgumentNodes, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), isJavascript);
	            var mapper;
	            for (var i = 0; i < typeArgumentNodes.length; i++) {
	                ts.Debug.assert(typeParameters[i] !== undefined, "Should not call checkTypeArguments with too many type arguments");
	                var constraint = getConstraintOfTypeParameter(typeParameters[i]);
	                if (!constraint)
	                    continue;
	                var errorInfo = reportErrors && headMessage && (function () { return ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1); });
	                var typeArgumentHeadMessage = headMessage || ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1;
	                if (!mapper) {
	                    mapper = createTypeMapper(typeParameters, typeArgumentTypes);
	                }
	                var typeArgument = typeArgumentTypes[i];
	                if (!checkTypeAssignableTo(typeArgument, getTypeWithThisArgument(instantiateType(constraint, mapper), typeArgument), reportErrors ? typeArgumentNodes[i] : undefined, typeArgumentHeadMessage, errorInfo)) {
	                    return false;
	                }
	            }
	            return typeArgumentTypes;
	        }
	        /**
	         * Check if the given signature can possibly be a signature called by the JSX opening-like element.
	         * @param node a JSX opening-like element we are trying to figure its call signature
	         * @param signature a candidate signature we are trying whether it is a call signature
	         * @param relation a relationship to check parameter and argument type
	         * @param excludeArgument
	         */
	        function checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation) {
	            // JSX opening-like element has correct arity for stateless-function component if the one of the following condition is true:
	            //      1. callIsIncomplete
	            //      2. attributes property has same number of properties as the parameter object type.
	            //         We can figure that out by resolving attributes property and check number of properties in the resolved type
	            // If the call has correct arity, we will then check if the argument type and parameter type is assignable
	            var callIsIncomplete = node.attributes.end === node.end; // If we are missing the close "/>", the call is incomplete
	            if (callIsIncomplete) {
	                return true;
	            }
	            var headMessage = ts.Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
	            // Stateless function components can have maximum of three arguments: "props", "context", and "updater".
	            // However "context" and "updater" are implicit and can't be specify by users. Only the first parameter, props,
	            // can be specified by users through attributes property.
	            var paramType = getTypeAtPosition(signature, 0);
	            var attributesType = checkExpressionWithContextualType(node.attributes, paramType, /*contextualMapper*/ undefined);
	            var argProperties = getPropertiesOfType(attributesType);
	            for (var _i = 0, argProperties_1 = argProperties; _i < argProperties_1.length; _i++) {
	                var arg = argProperties_1[_i];
	                if (!getPropertyOfType(paramType, arg.escapedName) && isUnhyphenatedJsxName(arg.escapedName)) {
	                    return false;
	                }
	            }
	            return checkTypeRelatedTo(attributesType, paramType, relation, /*errorNode*/ undefined, headMessage);
	        }
	        function checkApplicableSignature(node, args, signature, relation, excludeArgument, reportErrors) {
	            if (ts.isJsxOpeningLikeElement(node)) {
	                return checkApplicableSignatureForJsxOpeningLikeElement(node, signature, relation);
	            }
	            var thisType = getThisTypeOfSignature(signature);
	            if (thisType && thisType !== voidType && node.kind !== 187 /* NewExpression */) {
	                // If the called expression is not of the form `x.f` or `x["f"]`, then sourceType = voidType
	                // If the signature's 'this' type is voidType, then the check is skipped -- anything is compatible.
	                // If the expression is a new expression, then the check is skipped.
	                var thisArgumentNode = getThisArgumentOfCall(node);
	                var thisArgumentType = thisArgumentNode ? checkExpression(thisArgumentNode) : voidType;
	                var errorNode = reportErrors ? (thisArgumentNode || node) : undefined;
	                var headMessage_1 = ts.Diagnostics.The_this_context_of_type_0_is_not_assignable_to_method_s_this_of_type_1;
	                if (!checkTypeRelatedTo(thisArgumentType, getThisTypeOfSignature(signature), relation, errorNode, headMessage_1)) {
	                    return false;
	                }
	            }
	            var headMessage = ts.Diagnostics.Argument_of_type_0_is_not_assignable_to_parameter_of_type_1;
	            var argCount = getEffectiveArgumentCount(node, args, signature);
	            for (var i = 0; i < argCount; i++) {
	                var arg = getEffectiveArgument(node, args, i);
	                // If the effective argument is 'undefined', then it is an argument that is present but is synthetic.
	                if (arg === undefined || arg.kind !== 205 /* OmittedExpression */) {
	                    // Check spread elements against rest type (from arity check we know spread argument corresponds to a rest parameter)
	                    var paramType = getTypeAtPosition(signature, i);
	                    // If the effective argument type is undefined, there is no synthetic type for the argument.
	                    // In that case, we should check the argument.
	                    var argType = getEffectiveArgumentType(node, i) ||
	                        checkExpressionWithContextualType(arg, paramType, excludeArgument && excludeArgument[i] ? identityMapper : undefined);
	                    // If one or more arguments are still excluded (as indicated by a non-null excludeArgument parameter),
	                    // we obtain the regular type of any object literal arguments because we may not have inferred complete
	                    // parameter types yet and therefore excess property checks may yield false positives (see #17041).
	                    var checkArgType = excludeArgument ? getRegularTypeOfObjectLiteral(argType) : argType;
	                    // Use argument expression as error location when reporting errors
	                    var errorNode = reportErrors ? getEffectiveArgumentErrorNode(node, i, arg) : undefined;
	                    if (!checkTypeRelatedTo(checkArgType, paramType, relation, errorNode, headMessage)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        /**
	         * Returns the this argument in calls like x.f(...) and x[f](...). Undefined otherwise.
	         */
	        function getThisArgumentOfCall(node) {
	            if (node.kind === 186 /* CallExpression */) {
	                var callee = ts.skipOuterExpressions(node.expression);
	                if (callee.kind === 184 /* PropertyAccessExpression */ || callee.kind === 185 /* ElementAccessExpression */) {
	                    return callee.expression;
	                }
	            }
	        }
	        /**
	         * Returns the effective arguments for an expression that works like a function invocation.
	         *
	         * If 'node' is a CallExpression or a NewExpression, then its argument list is returned.
	         * If 'node' is a TaggedTemplateExpression, a new argument list is constructed from the substitution
	         *    expressions, where the first element of the list is `undefined`.
	         * If 'node' is a Decorator, the argument list will be `undefined`, and its arguments and types
	         *    will be supplied from calls to `getEffectiveArgumentCount` and `getEffectiveArgumentType`.
	         */
	        function getEffectiveCallArguments(node) {
	            if (node.kind === 188 /* TaggedTemplateExpression */) {
	                var template = node.template;
	                var args_4 = [undefined];
	                if (template.kind === 201 /* TemplateExpression */) {
	                    ts.forEach(template.templateSpans, function (span) {
	                        args_4.push(span.expression);
	                    });
	                }
	                return args_4;
	            }
	            else if (node.kind === 149 /* Decorator */) {
	                // For a decorator, we return undefined as we will determine
	                // the number and types of arguments for a decorator using
	                // `getEffectiveArgumentCount` and `getEffectiveArgumentType` below.
	                return undefined;
	            }
	            else if (ts.isJsxOpeningLikeElement(node)) {
	                return node.attributes.properties.length > 0 ? [node.attributes] : ts.emptyArray;
	            }
	            else {
	                return node.arguments || ts.emptyArray;
	            }
	        }
	        /**
	         * Returns the effective argument count for a node that works like a function invocation.
	         * If 'node' is a Decorator, the number of arguments is derived from the decoration
	         *    target and the signature:
	         *    If 'node.target' is a class declaration or class expression, the effective argument
	         *       count is 1.
	         *    If 'node.target' is a parameter declaration, the effective argument count is 3.
	         *    If 'node.target' is a property declaration, the effective argument count is 2.
	         *    If 'node.target' is a method or accessor declaration, the effective argument count
	         *       is 3, although it can be 2 if the signature only accepts two arguments, allowing
	         *       us to match a property decorator.
	         * Otherwise, the argument count is the length of the 'args' array.
	         */
	        function getEffectiveArgumentCount(node, args, signature) {
	            if (node.kind === 149 /* Decorator */) {
	                switch (node.parent.kind) {
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                        // A class decorator will have one argument (see `ClassDecorator` in core.d.ts)
	                        return 1;
	                    case 151 /* PropertyDeclaration */:
	                        // A property declaration decorator will have two arguments (see
	                        // `PropertyDecorator` in core.d.ts)
	                        return 2;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        // A method or accessor declaration decorator will have two or three arguments (see
	                        // `PropertyDecorator` and `MethodDecorator` in core.d.ts)
	                        // If we are emitting decorators for ES3, we will only pass two arguments.
	                        if (languageVersion === 0 /* ES3 */) {
	                            return 2;
	                        }
	                        // If the method decorator signature only accepts a target and a key, we will only
	                        // type check those arguments.
	                        return signature.parameters.length >= 3 ? 3 : 2;
	                    case 148 /* Parameter */:
	                        // A parameter declaration decorator will have three arguments (see
	                        // `ParameterDecorator` in core.d.ts)
	                        return 3;
	                }
	            }
	            else {
	                return args.length;
	            }
	        }
	        /**
	         * Returns the effective type of the first argument to a decorator.
	         * If 'node' is a class declaration or class expression, the effective argument type
	         *    is the type of the static side of the class.
	         * If 'node' is a parameter declaration, the effective argument type is either the type
	         *    of the static or instance side of the class for the parameter's parent method,
	         *    depending on whether the method is declared static.
	         *    For a constructor, the type is always the type of the static side of the class.
	         * If 'node' is a property, method, or accessor declaration, the effective argument
	         *    type is the type of the static or instance side of the parent class for class
	         *    element, depending on whether the element is declared static.
	         */
	        function getEffectiveDecoratorFirstArgumentType(node) {
	            // The first argument to a decorator is its `target`.
	            if (node.kind === 234 /* ClassDeclaration */) {
	                // For a class decorator, the `target` is the type of the class (e.g. the
	                // "static" or "constructor" side of the class)
	                var classSymbol = getSymbolOfNode(node);
	                return getTypeOfSymbol(classSymbol);
	            }
	            if (node.kind === 148 /* Parameter */) {
	                // For a parameter decorator, the `target` is the parent type of the
	                // parameter's containing method.
	                node = node.parent;
	                if (node.kind === 154 /* Constructor */) {
	                    var classSymbol = getSymbolOfNode(node);
	                    return getTypeOfSymbol(classSymbol);
	                }
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // For a property or method decorator, the `target` is the
	                // "static"-side type of the parent of the member if the member is
	                // declared "static"; otherwise, it is the "instance"-side type of the
	                // parent of the member.
	                return getParentTypeOfClassElement(node);
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective type for the second argument to a decorator.
	         * If 'node' is a parameter, its effective argument type is one of the following:
	         *    If 'node.parent' is a constructor, the effective argument type is 'any', as we
	         *       will emit `undefined`.
	         *    If 'node.parent' is a member with an identifier, numeric, or string literal name,
	         *       the effective argument type will be a string literal type for the member name.
	         *    If 'node.parent' is a computed property name, the effective argument type will
	         *       either be a symbol type or the string type.
	         * If 'node' is a member with an identifier, numeric, or string literal name, the
	         *    effective argument type will be a string literal type for the member name.
	         * If 'node' is a computed property name, the effective argument type will either
	         *    be a symbol type or the string type.
	         * A class decorator does not have a second argument type.
	         */
	        function getEffectiveDecoratorSecondArgumentType(node) {
	            // The second argument to a decorator is its `propertyKey`
	            if (node.kind === 234 /* ClassDeclaration */) {
	                ts.Debug.fail("Class decorators should not have a second synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 148 /* Parameter */) {
	                node = node.parent;
	                if (node.kind === 154 /* Constructor */) {
	                    // For a constructor parameter decorator, the `propertyKey` will be `undefined`.
	                    return anyType;
	                }
	                // For a non-constructor parameter decorator, the `propertyKey` will be either
	                // a string or a symbol, based on the name of the parameter's containing method.
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // The `propertyKey` for a property or method decorator will be a
	                // string literal type if the member name is an identifier, number, or string;
	                // otherwise, if the member name is a computed property name it will
	                // be either string or symbol.
	                var element = node;
	                switch (element.name.kind) {
	                    case 71 /* Identifier */:
	                        return getLiteralType(ts.idText(element.name));
	                    case 8 /* NumericLiteral */:
	                    case 9 /* StringLiteral */:
	                        return getLiteralType(element.name.text);
	                    case 146 /* ComputedPropertyName */:
	                        var nameType = checkComputedPropertyName(element.name);
	                        if (isTypeAssignableToKind(nameType, 1536 /* ESSymbolLike */)) {
	                            return nameType;
	                        }
	                        else {
	                            return stringType;
	                        }
	                    default:
	                        ts.Debug.fail("Unsupported property name.");
	                        return unknownType;
	                }
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective argument type for the third argument to a decorator.
	         * If 'node' is a parameter, the effective argument type is the number type.
	         * If 'node' is a method or accessor, the effective argument type is a
	         *    `TypedPropertyDescriptor<T>` instantiated with the type of the member.
	         * Class and property decorators do not have a third effective argument.
	         */
	        function getEffectiveDecoratorThirdArgumentType(node) {
	            // The third argument to a decorator is either its `descriptor` for a method decorator
	            // or its `parameterIndex` for a parameter decorator
	            if (node.kind === 234 /* ClassDeclaration */) {
	                ts.Debug.fail("Class decorators should not have a third synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 148 /* Parameter */) {
	                // The `parameterIndex` for a parameter decorator is always a number
	                return numberType;
	            }
	            if (node.kind === 151 /* PropertyDeclaration */) {
	                ts.Debug.fail("Property decorators should not have a third synthetic argument.");
	                return unknownType;
	            }
	            if (node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // The `descriptor` for a method decorator will be a `TypedPropertyDescriptor<T>`
	                // for the type of the member.
	                var propertyType = getTypeOfNode(node);
	                return createTypedPropertyDescriptorType(propertyType);
	            }
	            ts.Debug.fail("Unsupported decorator target.");
	            return unknownType;
	        }
	        /**
	         * Returns the effective argument type for the provided argument to a decorator.
	         */
	        function getEffectiveDecoratorArgumentType(node, argIndex) {
	            if (argIndex === 0) {
	                return getEffectiveDecoratorFirstArgumentType(node.parent);
	            }
	            else if (argIndex === 1) {
	                return getEffectiveDecoratorSecondArgumentType(node.parent);
	            }
	            else if (argIndex === 2) {
	                return getEffectiveDecoratorThirdArgumentType(node.parent);
	            }
	            ts.Debug.fail("Decorators should not have a fourth synthetic argument.");
	            return unknownType;
	        }
	        /**
	         * Gets the effective argument type for an argument in a call expression.
	         */
	        function getEffectiveArgumentType(node, argIndex) {
	            // Decorators provide special arguments, a tagged template expression provides
	            // a special first argument, and string literals get string literal types
	            // unless we're reporting errors
	            if (node.kind === 149 /* Decorator */) {
	                return getEffectiveDecoratorArgumentType(node, argIndex);
	            }
	            else if (argIndex === 0 && node.kind === 188 /* TaggedTemplateExpression */) {
	                return getGlobalTemplateStringsArrayType();
	            }
	            // This is not a synthetic argument, so we return 'undefined'
	            // to signal that the caller needs to check the argument.
	            return undefined;
	        }
	        /**
	         * Gets the effective argument expression for an argument in a call expression.
	         */
	        function getEffectiveArgument(node, args, argIndex) {
	            // For a decorator or the first argument of a tagged template expression we return undefined.
	            if (node.kind === 149 /* Decorator */ ||
	                (argIndex === 0 && node.kind === 188 /* TaggedTemplateExpression */)) {
	                return undefined;
	            }
	            return args[argIndex];
	        }
	        /**
	         * Gets the error node to use when reporting errors for an effective argument.
	         */
	        function getEffectiveArgumentErrorNode(node, argIndex, arg) {
	            if (node.kind === 149 /* Decorator */) {
	                // For a decorator, we use the expression of the decorator for error reporting.
	                return node.expression;
	            }
	            else if (argIndex === 0 && node.kind === 188 /* TaggedTemplateExpression */) {
	                // For a the first argument of a tagged template expression, we use the template of the tag for error reporting.
	                return node.template;
	            }
	            else {
	                return arg;
	            }
	        }
	        function getTypeArgumentArityError(node, signatures, typeArguments) {
	            var min = Infinity;
	            var max = -Infinity;
	            for (var _i = 0, signatures_5 = signatures; _i < signatures_5.length; _i++) {
	                var sig = signatures_5[_i];
	                min = Math.min(min, getMinTypeArgumentCount(sig.typeParameters));
	                max = Math.max(max, ts.length(sig.typeParameters));
	            }
	            var paramCount = min === max ? min : min + "-" + max;
	            return ts.createDiagnosticForNodeArray(ts.getSourceFileOfNode(node), typeArguments, ts.Diagnostics.Expected_0_type_arguments_but_got_1, paramCount, typeArguments.length);
	        }
	        function resolveCall(node, signatures, candidatesOutArray, fallbackError) {
	            var isTaggedTemplate = node.kind === 188 /* TaggedTemplateExpression */;
	            var isDecorator = node.kind === 149 /* Decorator */;
	            var isJsxOpeningOrSelfClosingElement = ts.isJsxOpeningLikeElement(node);
	            var typeArguments;
	            if (!isDecorator) {
	                typeArguments = node.typeArguments;
	                // We already perform checking on the type arguments on the class declaration itself.
	                if (isTaggedTemplate || isJsxOpeningOrSelfClosingElement || node.expression.kind !== 97 /* SuperKeyword */) {
	                    ts.forEach(typeArguments, checkSourceElement);
	                }
	            }
	            var candidates = candidatesOutArray || [];
	            // reorderCandidates fills up the candidates array directly
	            reorderCandidates(signatures, candidates);
	            if (!candidates.length) {
	                diagnostics.add(ts.createDiagnosticForNode(node, ts.Diagnostics.Call_target_does_not_contain_any_signatures));
	                return resolveErrorCall(node);
	            }
	            var args = getEffectiveCallArguments(node);
	            // The following applies to any value of 'excludeArgument[i]':
	            //    - true:      the argument at 'i' is susceptible to a one-time permanent contextual typing.
	            //    - undefined: the argument at 'i' is *not* susceptible to permanent contextual typing.
	            //    - false:     the argument at 'i' *was* and *has been* permanently contextually typed.
	            //
	            // The idea is that we will perform type argument inference & assignability checking once
	            // without using the susceptible parameters that are functions, and once more for each of those
	            // parameters, contextually typing each as we go along.
	            //
	            // For a tagged template, then the first argument be 'undefined' if necessary
	            // because it represents a TemplateStringsArray.
	            //
	            // For a decorator, no arguments are susceptible to contextual typing due to the fact
	            // decorators are applied to a declaration by the emitter, and not to an expression.
	            var isSingleNonGenericCandidate = candidates.length === 1 && !candidates[0].typeParameters;
	            var excludeArgument;
	            var excludeCount = 0;
	            if (!isDecorator && !isSingleNonGenericCandidate) {
	                // We do not need to call `getEffectiveArgumentCount` here as it only
	                // applies when calculating the number of arguments for a decorator.
	                for (var i = isTaggedTemplate ? 1 : 0; i < args.length; i++) {
	                    if (isContextSensitive(args[i])) {
	                        if (!excludeArgument) {
	                            excludeArgument = new Array(args.length);
	                        }
	                        excludeArgument[i] = true;
	                        excludeCount++;
	                    }
	                }
	            }
	            // The following variables are captured and modified by calls to chooseOverload.
	            // If overload resolution or type argument inference fails, we want to report the
	            // best error possible. The best error is one which says that an argument was not
	            // assignable to a parameter. This implies that everything else about the overload
	            // was fine. So if there is any overload that is only incorrect because of an
	            // argument, we will report an error on that one.
	            //
	            //     function foo(s: string): void;
	            //     function foo(n: number): void; // Report argument error on this overload
	            //     function foo(): void;
	            //     foo(true);
	            //
	            // If none of the overloads even made it that far, there are two possibilities.
	            // There was a problem with type arguments for some overload, in which case
	            // report an error on that. Or none of the overloads even had correct arity,
	            // in which case give an arity error.
	            //
	            //     function foo<T extends string>(x: T): void; // Report type argument error
	            //     function foo(): void;
	            //     foo<number>(0);
	            //
	            var candidateForArgumentError;
	            var candidateForTypeArgumentError;
	            var result;
	            // If we are in signature help, a trailing comma indicates that we intend to provide another argument,
	            // so we will only accept overloads with arity at least 1 higher than the current number of provided arguments.
	            var signatureHelpTrailingComma = candidatesOutArray && node.kind === 186 /* CallExpression */ && node.arguments.hasTrailingComma;
	            // Section 4.12.1:
	            // if the candidate list contains one or more signatures for which the type of each argument
	            // expression is a subtype of each corresponding parameter type, the return type of the first
	            // of those signatures becomes the return type of the function call.
	            // Otherwise, the return type of the first signature in the candidate list becomes the return
	            // type of the function call.
	            //
	            // Whether the call is an error is determined by assignability of the arguments. The subtype pass
	            // is just important for choosing the best signature. So in the case where there is only one
	            // signature, the subtype pass is useless. So skipping it is an optimization.
	            if (candidates.length > 1) {
	                result = chooseOverload(candidates, subtypeRelation, signatureHelpTrailingComma);
	            }
	            if (!result) {
	                result = chooseOverload(candidates, assignableRelation, signatureHelpTrailingComma);
	            }
	            if (result) {
	                return result;
	            }
	            // No signatures were applicable. Now report errors based on the last applicable signature with
	            // no arguments excluded from assignability checks.
	            // If candidate is undefined, it means that no candidates had a suitable arity. In that case,
	            // skip the checkApplicableSignature check.
	            if (candidateForArgumentError) {
	                if (isJsxOpeningOrSelfClosingElement) {
	                    // We do not report any error here because any error will be handled in "resolveCustomJsxElementAttributesType".
	                    return candidateForArgumentError;
	                }
	                // excludeArgument is undefined, in this case also equivalent to [undefined, undefined, ...]
	                // The importance of excludeArgument is to prevent us from typing function expression parameters
	                // in arguments too early. If possible, we'd like to only type them once we know the correct
	                // overload. However, this matters for the case where the call is correct. When the call is
	                // an error, we don't need to exclude any arguments, although it would cause no harm to do so.
	                checkApplicableSignature(node, args, candidateForArgumentError, assignableRelation, /*excludeArgument*/ undefined, /*reportErrors*/ true);
	            }
	            else if (candidateForTypeArgumentError) {
	                checkTypeArguments(candidateForTypeArgumentError, node.typeArguments, /*reportErrors*/ true, fallbackError);
	            }
	            else if (typeArguments && ts.every(signatures, function (sig) { return ts.length(sig.typeParameters) !== typeArguments.length; })) {
	                diagnostics.add(getTypeArgumentArityError(node, signatures, typeArguments));
	            }
	            else if (args) {
	                var min_1 = Number.POSITIVE_INFINITY;
	                var max = Number.NEGATIVE_INFINITY;
	                for (var _i = 0, signatures_6 = signatures; _i < signatures_6.length; _i++) {
	                    var sig = signatures_6[_i];
	                    min_1 = Math.min(min_1, sig.minArgumentCount);
	                    max = Math.max(max, sig.parameters.length);
	                }
	                var hasRestParameter_1 = ts.some(signatures, function (sig) { return sig.hasRestParameter; });
	                var hasSpreadArgument = getSpreadArgumentIndex(args) > -1;
	                var paramCount = hasRestParameter_1 ? min_1 :
	                    min_1 < max ? min_1 + "-" + max :
	                        min_1;
	                var argCount = args.length;
	                if (argCount <= max && hasSpreadArgument) {
	                    argCount--;
	                }
	                var error_1 = hasRestParameter_1 && hasSpreadArgument ? ts.Diagnostics.Expected_at_least_0_arguments_but_got_1_or_more :
	                    hasRestParameter_1 ? ts.Diagnostics.Expected_at_least_0_arguments_but_got_1 :
	                        hasSpreadArgument ? ts.Diagnostics.Expected_0_arguments_but_got_1_or_more :
	                            ts.Diagnostics.Expected_0_arguments_but_got_1;
	                diagnostics.add(ts.createDiagnosticForNode(node, error_1, paramCount, argCount));
	            }
	            else if (fallbackError) {
	                diagnostics.add(ts.createDiagnosticForNode(node, fallbackError));
	            }
	            // No signature was applicable. We have already reported the errors for the invalid signature.
	            // If this is a type resolution session, e.g. Language Service, try to get better information than anySignature.
	            // Pick the longest signature. This way we can get a contextual type for cases like:
	            //     declare function f(a: { xa: number; xb: number; }, b: number);
	            //     f({ |
	            // Also, use explicitly-supplied type arguments if they are provided, so we can get a contextual signature in cases like:
	            //     declare function f<T>(k: keyof T);
	            //     f<Foo>("
	            if (!produceDiagnostics) {
	                ts.Debug.assert(candidates.length > 0); // Else would have exited above.
	                var bestIndex = getLongestCandidateIndex(candidates, apparentArgumentCount === undefined ? args.length : apparentArgumentCount);
	                var candidate = candidates[bestIndex];
	                var typeParameters = candidate.typeParameters;
	                if (typeParameters && callLikeExpressionMayHaveTypeArguments(node) && node.typeArguments) {
	                    var typeArguments_1 = node.typeArguments.map(getTypeOfNode);
	                    while (typeArguments_1.length > typeParameters.length) {
	                        typeArguments_1.pop();
	                    }
	                    while (typeArguments_1.length < typeParameters.length) {
	                        typeArguments_1.push(getDefaultTypeArgumentType(ts.isInJavaScriptFile(node)));
	                    }
	                    var instantiated = createSignatureInstantiation(candidate, typeArguments_1);
	                    candidates[bestIndex] = instantiated;
	                    return instantiated;
	                }
	                return candidate;
	            }
	            return resolveErrorCall(node);
	            function chooseOverload(candidates, relation, signatureHelpTrailingComma) {
	                if (signatureHelpTrailingComma === void 0) { signatureHelpTrailingComma = false; }
	                candidateForArgumentError = undefined;
	                candidateForTypeArgumentError = undefined;
	                if (isSingleNonGenericCandidate) {
	                    var candidate = candidates[0];
	                    if (!hasCorrectArity(node, args, candidate, signatureHelpTrailingComma)) {
	                        return undefined;
	                    }
	                    if (!checkApplicableSignature(node, args, candidate, relation, excludeArgument, /*reportErrors*/ false)) {
	                        candidateForArgumentError = candidate;
	                        return undefined;
	                    }
	                    return candidate;
	                }
	                for (var candidateIndex = 0; candidateIndex < candidates.length; candidateIndex++) {
	                    var originalCandidate = candidates[candidateIndex];
	                    if (!hasCorrectArity(node, args, originalCandidate, signatureHelpTrailingComma)) {
	                        continue;
	                    }
	                    var candidate = void 0;
	                    var inferenceContext = originalCandidate.typeParameters ?
	                        createInferenceContext(originalCandidate.typeParameters, originalCandidate, /*flags*/ ts.isInJavaScriptFile(node) ? 4 /* AnyDefault */ : 0 /* None */) :
	                        undefined;
	                    while (true) {
	                        candidate = originalCandidate;
	                        if (candidate.typeParameters) {
	                            var typeArgumentTypes = void 0;
	                            if (typeArguments) {
	                                var typeArgumentResult = checkTypeArguments(candidate, typeArguments, /*reportErrors*/ false);
	                                if (typeArgumentResult) {
	                                    typeArgumentTypes = typeArgumentResult;
	                                }
	                                else {
	                                    candidateForTypeArgumentError = originalCandidate;
	                                    break;
	                                }
	                            }
	                            else {
	                                typeArgumentTypes = inferTypeArguments(node, candidate, args, excludeArgument, inferenceContext);
	                            }
	                            var isJavascript = ts.isInJavaScriptFile(candidate.declaration);
	                            candidate = getSignatureInstantiation(candidate, typeArgumentTypes, isJavascript);
	                        }
	                        if (!checkApplicableSignature(node, args, candidate, relation, excludeArgument, /*reportErrors*/ false)) {
	                            candidateForArgumentError = candidate;
	                            break;
	                        }
	                        if (excludeCount === 0) {
	                            candidates[candidateIndex] = candidate;
	                            return candidate;
	                        }
	                        excludeCount--;
	                        if (excludeCount > 0) {
	                            excludeArgument[excludeArgument.indexOf(/*value*/ true)] = false;
	                        }
	                        else {
	                            excludeArgument = undefined;
	                        }
	                    }
	                }
	                return undefined;
	            }
	        }
	        function getLongestCandidateIndex(candidates, argsCount) {
	            var maxParamsIndex = -1;
	            var maxParams = -1;
	            for (var i = 0; i < candidates.length; i++) {
	                var candidate = candidates[i];
	                if (candidate.hasRestParameter || candidate.parameters.length >= argsCount) {
	                    return i;
	                }
	                if (candidate.parameters.length > maxParams) {
	                    maxParams = candidate.parameters.length;
	                    maxParamsIndex = i;
	                }
	            }
	            return maxParamsIndex;
	        }
	        function resolveCallExpression(node, candidatesOutArray) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                var superType = checkSuperExpression(node.expression);
	                if (isTypeAny(superType)) {
	                    ts.forEach(node.arguments, checkExpresionNoReturn); // Still visit arguments so they get marked for visibility, etc
	                    return anySignature;
	                }
	                if (superType !== unknownType) {
	                    // In super call, the candidate signatures are the matching arity signatures of the base constructor function instantiated
	                    // with the type arguments specified in the extends clause.
	                    var baseTypeNode = ts.getClassExtendsHeritageClauseElement(ts.getContainingClass(node));
	                    if (baseTypeNode) {
	                        var baseConstructors = getInstantiatedConstructorsForTypeArguments(superType, baseTypeNode.typeArguments, baseTypeNode);
	                        return resolveCall(node, baseConstructors, candidatesOutArray);
	                    }
	                }
	                return resolveUntypedCall(node);
	            }
	            var funcType = checkNonNullExpression(node.expression, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_null, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_undefined, ts.Diagnostics.Cannot_invoke_an_object_which_is_possibly_null_or_undefined);
	            if (funcType === silentNeverType) {
	                return silentNeverSignature;
	            }
	            var apparentType = getApparentType(funcType);
	            if (apparentType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            // Technically, this signatures list may be incomplete. We are taking the apparent type,
	            // but we are not including call signatures that may have been added to the Object or
	            // Function interface, since they have none by default. This is a bit of a leap of faith
	            // that the user will not add any.
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            // TS 1.0 Spec: 4.12
	            // In an untyped function call no TypeArgs are permitted, Args can be any argument list, no contextual
	            // types are provided for the argument expressions, and the result is always of type Any.
	            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, constructSignatures.length)) {
	                // The unknownType indicates that an error already occurred (and was reported).  No
	                // need to report another error in this case.
	                if (funcType !== unknownType && node.typeArguments) {
	                    error(node, ts.Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
	                }
	                return resolveUntypedCall(node);
	            }
	            // If FuncExpr's apparent type(section 3.8.1) is a function type, the call is a typed function call.
	            // TypeScript employs overload resolution in typed function calls in order to support functions
	            // with multiple call signatures.
	            if (!callSignatures.length) {
	                if (constructSignatures.length) {
	                    error(node, ts.Diagnostics.Value_of_type_0_is_not_callable_Did_you_mean_to_include_new, typeToString(funcType));
	                }
	                else {
	                    invocationError(node, apparentType, 0 /* Call */);
	                }
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray);
	        }
	        /**
	         * TS 1.0 spec: 4.12
	         * If FuncExpr is of type Any, or of an object type that has no call or construct signatures
	         * but is a subtype of the Function interface, the call is an untyped function call.
	         */
	        function isUntypedFunctionCall(funcType, apparentFuncType, numCallSignatures, numConstructSignatures) {
	            // We exclude union types because we may have a union of function types that happen to have no common signatures.
	            return isTypeAny(funcType) || isTypeAny(apparentFuncType) && funcType.flags & 32768 /* TypeParameter */ ||
	                !numCallSignatures && !numConstructSignatures && !(apparentFuncType.flags & (131072 /* Union */ | 16384 /* Never */)) && isTypeAssignableTo(funcType, globalFunctionType);
	        }
	        function resolveNewExpression(node, candidatesOutArray) {
	            if (node.arguments && languageVersion < 1 /* ES5 */) {
	                var spreadIndex = getSpreadArgumentIndex(node.arguments);
	                if (spreadIndex >= 0) {
	                    error(node.arguments[spreadIndex], ts.Diagnostics.Spread_operator_in_new_expressions_is_only_available_when_targeting_ECMAScript_5_and_higher);
	                }
	            }
	            var expressionType = checkNonNullExpression(node.expression);
	            if (expressionType === silentNeverType) {
	                return silentNeverSignature;
	            }
	            // If expressionType's apparent type(section 3.8.1) is an object type with one or
	            // more construct signatures, the expression is processed in the same manner as a
	            // function call, but using the construct signatures as the initial set of candidate
	            // signatures for overload resolution. The result type of the function call becomes
	            // the result type of the operation.
	            expressionType = getApparentType(expressionType);
	            if (expressionType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            // TS 1.0 spec: 4.11
	            // If expressionType is of type Any, Args can be any argument
	            // list and the result of the operation is of type Any.
	            if (isTypeAny(expressionType)) {
	                if (node.typeArguments) {
	                    error(node, ts.Diagnostics.Untyped_function_calls_may_not_accept_type_arguments);
	                }
	                return resolveUntypedCall(node);
	            }
	            // Technically, this signatures list may be incomplete. We are taking the apparent type,
	            // but we are not including construct signatures that may have been added to the Object or
	            // Function interface, since they have none by default. This is a bit of a leap of faith
	            // that the user will not add any.
	            var constructSignatures = getSignaturesOfType(expressionType, 1 /* Construct */);
	            if (constructSignatures.length) {
	                if (!isConstructorAccessible(node, constructSignatures[0])) {
	                    return resolveErrorCall(node);
	                }
	                // If the expression is a class of abstract type, then it cannot be instantiated.
	                // Note, only class declarations can be declared abstract.
	                // In the case of a merged class-module or class-interface declaration,
	                // only the class declaration node will have the Abstract flag set.
	                var valueDecl = expressionType.symbol && ts.getClassLikeDeclarationOfSymbol(expressionType.symbol);
	                if (valueDecl && ts.hasModifier(valueDecl, 128 /* Abstract */)) {
	                    error(node, ts.Diagnostics.Cannot_create_an_instance_of_an_abstract_class);
	                    return resolveErrorCall(node);
	                }
	                return resolveCall(node, constructSignatures, candidatesOutArray);
	            }
	            // If expressionType's apparent type is an object type with no construct signatures but
	            // one or more call signatures, the expression is processed as a function call. A compile-time
	            // error occurs if the result of the function call is not Void. The type of the result of the
	            // operation is Any. It is an error to have a Void this type.
	            var callSignatures = getSignaturesOfType(expressionType, 0 /* Call */);
	            if (callSignatures.length) {
	                var signature = resolveCall(node, callSignatures, candidatesOutArray);
	                if (!isJavaScriptConstructor(signature.declaration) && getReturnTypeOfSignature(signature) !== voidType) {
	                    error(node, ts.Diagnostics.Only_a_void_function_can_be_called_with_the_new_keyword);
	                }
	                if (getThisTypeOfSignature(signature) === voidType) {
	                    error(node, ts.Diagnostics.A_function_that_is_called_with_the_new_keyword_cannot_have_a_this_type_that_is_void);
	                }
	                return signature;
	            }
	            invocationError(node, expressionType, 1 /* Construct */);
	            return resolveErrorCall(node);
	        }
	        function isConstructorAccessible(node, signature) {
	            if (!signature || !signature.declaration) {
	                return true;
	            }
	            var declaration = signature.declaration;
	            var modifiers = ts.getSelectedModifierFlags(declaration, 24 /* NonPublicAccessibilityModifier */);
	            // Public constructor is accessible.
	            if (!modifiers) {
	                return true;
	            }
	            var declaringClassDeclaration = ts.getClassLikeDeclarationOfSymbol(declaration.parent.symbol);
	            var declaringClass = getDeclaredTypeOfSymbol(declaration.parent.symbol);
	            // A private or protected constructor can only be instantiated within its own class (or a subclass, for protected)
	            if (!isNodeWithinClass(node, declaringClassDeclaration)) {
	                var containingClass = ts.getContainingClass(node);
	                if (containingClass) {
	                    var containingType = getTypeOfNode(containingClass);
	                    var baseTypes = getBaseTypes(containingType);
	                    while (baseTypes.length) {
	                        var baseType = baseTypes[0];
	                        if (modifiers & 16 /* Protected */ &&
	                            baseType.symbol === declaration.parent.symbol) {
	                            return true;
	                        }
	                        baseTypes = getBaseTypes(baseType);
	                    }
	                }
	                if (modifiers & 8 /* Private */) {
	                    error(node, ts.Diagnostics.Constructor_of_class_0_is_private_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
	                }
	                if (modifiers & 16 /* Protected */) {
	                    error(node, ts.Diagnostics.Constructor_of_class_0_is_protected_and_only_accessible_within_the_class_declaration, typeToString(declaringClass));
	                }
	                return false;
	            }
	            return true;
	        }
	        function invocationError(node, apparentType, kind) {
	            error(node, kind === 0 /* Call */
	                ? ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures
	                : ts.Diagnostics.Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature, typeToString(apparentType));
	            invocationErrorRecovery(apparentType, kind);
	        }
	        function invocationErrorRecovery(apparentType, kind) {
	            if (!apparentType.symbol) {
	                return;
	            }
	            var importNode = getSymbolLinks(apparentType.symbol).originatingImport;
	            // Create a diagnostic on the originating import if possible onto which we can attach a quickfix
	            //  An import call expression cannot be rewritten into another form to correct the error - the only solution is to use `.default` at the use-site
	            if (importNode && !ts.isImportCall(importNode)) {
	                var sigs = getSignaturesOfType(getTypeOfSymbol(getSymbolLinks(apparentType.symbol).target), kind);
	                if (!sigs || !sigs.length)
	                    return;
	                error(importNode, ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime);
	            }
	        }
	        function resolveTaggedTemplateExpression(node, candidatesOutArray) {
	            var tagType = checkExpression(node.tag);
	            var apparentType = getApparentType(tagType);
	            if (apparentType === unknownType) {
	                // Another error has already been reported
	                return resolveErrorCall(node);
	            }
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            if (isUntypedFunctionCall(tagType, apparentType, callSignatures.length, constructSignatures.length)) {
	                return resolveUntypedCall(node);
	            }
	            if (!callSignatures.length) {
	                invocationError(node, apparentType, 0 /* Call */);
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray);
	        }
	        /**
	         * Gets the localized diagnostic head message to use for errors when resolving a decorator as a call expression.
	         */
	        function getDiagnosticHeadMessageForDecoratorResolution(node) {
	            switch (node.parent.kind) {
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_class_decorator_when_called_as_an_expression;
	                case 148 /* Parameter */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_parameter_decorator_when_called_as_an_expression;
	                case 151 /* PropertyDeclaration */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_property_decorator_when_called_as_an_expression;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return ts.Diagnostics.Unable_to_resolve_signature_of_method_decorator_when_called_as_an_expression;
	            }
	        }
	        /**
	         * Resolves a decorator as if it were a call expression.
	         */
	        function resolveDecorator(node, candidatesOutArray) {
	            var funcType = checkExpression(node.expression);
	            var apparentType = getApparentType(funcType);
	            if (apparentType === unknownType) {
	                return resolveErrorCall(node);
	            }
	            var callSignatures = getSignaturesOfType(apparentType, 0 /* Call */);
	            var constructSignatures = getSignaturesOfType(apparentType, 1 /* Construct */);
	            if (isUntypedFunctionCall(funcType, apparentType, callSignatures.length, constructSignatures.length)) {
	                return resolveUntypedCall(node);
	            }
	            if (isPotentiallyUncalledDecorator(node, callSignatures)) {
	                var nodeStr = ts.getTextOfNode(node.expression, /*includeTrivia*/ false);
	                error(node, ts.Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0, nodeStr);
	                return resolveErrorCall(node);
	            }
	            var headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
	            if (!callSignatures.length) {
	                var errorInfo = void 0;
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures, typeToString(apparentType));
	                errorInfo = ts.chainDiagnosticMessages(errorInfo, headMessage);
	                diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(node, errorInfo));
	                invocationErrorRecovery(apparentType, 0 /* Call */);
	                return resolveErrorCall(node);
	            }
	            return resolveCall(node, callSignatures, candidatesOutArray, headMessage);
	        }
	        /**
	         * Sometimes, we have a decorator that could accept zero arguments,
	         * but is receiving too many arguments as part of the decorator invocation.
	         * In those cases, a user may have meant to *call* the expression before using it as a decorator.
	         */
	        function isPotentiallyUncalledDecorator(decorator, signatures) {
	            return signatures.length && ts.every(signatures, function (signature) {
	                return signature.minArgumentCount === 0 &&
	                    !signature.hasRestParameter &&
	                    signature.parameters.length < getEffectiveArgumentCount(decorator, /*args*/ undefined, signature);
	            });
	        }
	        /**
	         * This function is similar to getResolvedSignature but is exclusively for trying to resolve JSX stateless-function component.
	         * The main reason we have to use this function instead of getResolvedSignature because, the caller of this function will already check the type of openingLikeElement's tagName
	         * and pass the type as elementType. The elementType can not be a union (as such case should be handled by the caller of this function)
	         * Note: at this point, we are still not sure whether the opening-like element is a stateless function component or not.
	         * @param openingLikeElement an opening-like JSX element to try to resolve as JSX stateless function
	         * @param elementType an element type of the opneing-like element by checking opening-like element's tagname.
	         * @param candidatesOutArray an array of signature to be filled in by the function. It is passed by signature help in the language service;
	         *                           the function will fill it up with appropriate candidate signatures
	         */
	        function getResolvedJsxStatelessFunctionSignature(openingLikeElement, elementType, candidatesOutArray) {
	            ts.Debug.assert(!(elementType.flags & 131072 /* Union */));
	            var callSignatures = elementType && getSignaturesOfType(elementType, 0 /* Call */);
	            if (callSignatures && callSignatures.length > 0) {
	                return resolveCall(openingLikeElement, callSignatures, candidatesOutArray);
	            }
	            return undefined;
	        }
	        function resolveSignature(node, candidatesOutArray) {
	            switch (node.kind) {
	                case 186 /* CallExpression */:
	                    return resolveCallExpression(node, candidatesOutArray);
	                case 187 /* NewExpression */:
	                    return resolveNewExpression(node, candidatesOutArray);
	                case 188 /* TaggedTemplateExpression */:
	                    return resolveTaggedTemplateExpression(node, candidatesOutArray);
	                case 149 /* Decorator */:
	                    return resolveDecorator(node, candidatesOutArray);
	                case 256 /* JsxOpeningElement */:
	                case 255 /* JsxSelfClosingElement */:
	                    // This code-path is called by language service
	                    var exprTypes = checkExpression(node.tagName);
	                    return forEachType(exprTypes, function (exprType) {
	                        var sfcResult = getResolvedJsxStatelessFunctionSignature(node, exprType, candidatesOutArray);
	                        if (sfcResult && sfcResult !== unknownSignature) {
	                            return sfcResult;
	                        }
	                        var sigs = getInstantiatedJsxSignatures(node, exprType);
	                        if (candidatesOutArray && ts.length(sigs)) {
	                            candidatesOutArray.push.apply(candidatesOutArray, sigs);
	                        }
	                        return ts.length(sigs) ? sigs[0] : unknownSignature;
	                    }) || unknownSignature;
	            }
	            ts.Debug.assertNever(node, "Branch in 'resolveSignature' should be unreachable.");
	        }
	        /**
	         * Resolve a signature of a given call-like expression.
	         * @param node a call-like expression to try resolve a signature for
	         * @param candidatesOutArray an array of signature to be filled in by the function. It is passed by signature help in the language service;
	         *                           the function will fill it up with appropriate candidate signatures
	         * @return a signature of the call-like expression or undefined if one can't be found
	         */
	        function getResolvedSignature(node, candidatesOutArray) {
	            var links = getNodeLinks(node);
	            // If getResolvedSignature has already been called, we will have cached the resolvedSignature.
	            // However, it is possible that either candidatesOutArray was not passed in the first time,
	            // or that a different candidatesOutArray was passed in. Therefore, we need to redo the work
	            // to correctly fill the candidatesOutArray.
	            var cached = links.resolvedSignature;
	            if (cached && cached !== resolvingSignature && !candidatesOutArray) {
	                return cached;
	            }
	            links.resolvedSignature = resolvingSignature;
	            var result = resolveSignature(node, candidatesOutArray);
	            // If signature resolution originated in control flow type analysis (for example to compute the
	            // assigned type in a flow assignment) we don't cache the result as it may be based on temporary
	            // types from the control flow analysis.
	            links.resolvedSignature = flowLoopStart === flowLoopCount ? result : cached;
	            return result;
	        }
	        /**
	         * Indicates whether a declaration can be treated as a constructor in a JavaScript
	         * file.
	         */
	        function isJavaScriptConstructor(node) {
	            if (node && ts.isInJavaScriptFile(node)) {
	                // If the node has a @class tag, treat it like a constructor.
	                if (ts.getJSDocClassTag(node))
	                    return true;
	                // If the symbol of the node has members, treat it like a constructor.
	                var symbol = ts.isFunctionDeclaration(node) || ts.isFunctionExpression(node) ? getSymbolOfNode(node) :
	                    ts.isVariableDeclaration(node) && node.initializer && ts.isFunctionExpression(node.initializer) ? getSymbolOfNode(node.initializer) :
	                        undefined;
	                return symbol && symbol.members !== undefined;
	            }
	            return false;
	        }
	        function getJavaScriptClassType(symbol) {
	            var initializer = ts.getDeclaredJavascriptInitializer(symbol.valueDeclaration);
	            if (initializer) {
	                symbol = getSymbolOfNode(initializer);
	            }
	            var inferred;
	            if (isJavaScriptConstructor(symbol.valueDeclaration)) {
	                inferred = getInferredClassType(symbol);
	            }
	            var assigned = getAssignedClassType(symbol);
	            var valueType = getTypeOfSymbol(symbol);
	            if (valueType.symbol && !isInferredClassType(valueType) && isJavaScriptConstructor(valueType.symbol.valueDeclaration)) {
	                inferred = getInferredClassType(valueType.symbol);
	            }
	            return assigned && inferred ?
	                getIntersectionType([inferred, assigned]) :
	                assigned || inferred;
	        }
	        function getAssignedClassType(symbol) {
	            var decl = symbol.valueDeclaration;
	            var assignmentSymbol = decl && decl.parent &&
	                (ts.isBinaryExpression(decl.parent) && getSymbolOfNode(decl.parent.left) ||
	                    ts.isVariableDeclaration(decl.parent) && getSymbolOfNode(decl.parent));
	            if (assignmentSymbol) {
	                var prototype = ts.forEach(assignmentSymbol.declarations, getAssignedJavascriptPrototype);
	                if (prototype) {
	                    return checkExpression(prototype);
	                }
	            }
	        }
	        function getAssignedJavascriptPrototype(node) {
	            if (!node.parent) {
	                return false;
	            }
	            var parent = node.parent;
	            while (parent && parent.kind === 184 /* PropertyAccessExpression */) {
	                parent = parent.parent;
	            }
	            if (parent && ts.isBinaryExpression(parent) && ts.isPrototypeAccess(parent.left) && parent.operatorToken.kind === 58 /* EqualsToken */) {
	                var right = ts.getInitializerOfBinaryExpression(parent);
	                return ts.isObjectLiteralExpression(right) && right;
	            }
	        }
	        function getInferredClassType(symbol) {
	            var links = getSymbolLinks(symbol);
	            if (!links.inferredClassType) {
	                links.inferredClassType = createAnonymousType(symbol, getMembersOfSymbol(symbol) || emptySymbols, ts.emptyArray, ts.emptyArray, /*stringIndexType*/ undefined, /*numberIndexType*/ undefined);
	            }
	            return links.inferredClassType;
	        }
	        function isInferredClassType(type) {
	            return type.symbol
	                && ts.getObjectFlags(type) & 16 /* Anonymous */
	                && getSymbolLinks(type.symbol).inferredClassType === type;
	        }
	        /**
	         * Syntactically and semantically checks a call or new expression.
	         * @param node The call/new expression to be checked.
	         * @returns On success, the expression's signature's return type. On failure, anyType.
	         */
	        function checkCallExpression(node) {
	            if (!checkGrammarTypeArguments(node, node.typeArguments))
	                checkGrammarArguments(node.arguments);
	            var signature = getResolvedSignature(node);
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return voidType;
	            }
	            if (node.kind === 187 /* NewExpression */) {
	                var declaration = signature.declaration;
	                if (declaration &&
	                    declaration.kind !== 154 /* Constructor */ &&
	                    declaration.kind !== 158 /* ConstructSignature */ &&
	                    declaration.kind !== 163 /* ConstructorType */ &&
	                    !ts.isJSDocConstructSignature(declaration)) {
	                    // When resolved signature is a call signature (and not a construct signature) the result type is any, unless
	                    // the declaring function had members created through 'x.prototype.y = expr' or 'this.y = expr' psuedodeclarations
	                    // in a JS file
	                    // Note:JS inferred classes might come from a variable declaration instead of a function declaration.
	                    // In this case, using getResolvedSymbol directly is required to avoid losing the members from the declaration.
	                    var funcSymbol = checkExpression(node.expression).symbol;
	                    if (!funcSymbol && node.expression.kind === 71 /* Identifier */) {
	                        funcSymbol = getResolvedSymbol(node.expression);
	                    }
	                    var type = funcSymbol && getJavaScriptClassType(funcSymbol);
	                    if (type) {
	                        return signature.target ? instantiateType(type, signature.mapper) : type;
	                    }
	                    if (noImplicitAny) {
	                        error(node, ts.Diagnostics.new_expression_whose_target_lacks_a_construct_signature_implicitly_has_an_any_type);
	                    }
	                    return anyType;
	                }
	            }
	            // In JavaScript files, calls to any identifier 'require' are treated as external module imports
	            if (ts.isInJavaScriptFile(node) && isCommonJsRequire(node)) {
	                return resolveExternalModuleTypeByLiteral(node.arguments[0]);
	            }
	            var returnType = getReturnTypeOfSignature(signature);
	            // Treat any call to the global 'Symbol' function that is part of a const variable or readonly property
	            // as a fresh unique symbol literal type.
	            if (returnType.flags & 1536 /* ESSymbolLike */ && isSymbolOrSymbolForCall(node)) {
	                return getESSymbolLikeTypeForNode(ts.walkUpParenthesizedExpressions(node.parent));
	            }
	            return returnType;
	        }
	        function isSymbolOrSymbolForCall(node) {
	            if (!ts.isCallExpression(node))
	                return false;
	            var left = node.expression;
	            if (ts.isPropertyAccessExpression(left) && left.name.escapedText === "for") {
	                left = left.expression;
	            }
	            if (!ts.isIdentifier(left) || left.escapedText !== "Symbol") {
	                return false;
	            }
	            // make sure `Symbol` is the global symbol
	            var globalESSymbol = getGlobalESSymbolConstructorSymbol(/*reportErrors*/ false);
	            if (!globalESSymbol) {
	                return false;
	            }
	            return globalESSymbol === resolveName(left, "Symbol", 67216319 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	        }
	        function checkImportCallExpression(node) {
	            // Check grammar of dynamic import
	            if (!checkGrammarArguments(node.arguments))
	                checkGrammarImportCallExpression(node);
	            if (node.arguments.length === 0) {
	                return createPromiseReturnType(node, anyType);
	            }
	            var specifier = node.arguments[0];
	            var specifierType = checkExpressionCached(specifier);
	            // Even though multiple arugments is grammatically incorrect, type-check extra arguments for completion
	            for (var i = 1; i < node.arguments.length; ++i) {
	                checkExpressionCached(node.arguments[i]);
	            }
	            if (specifierType.flags & 4096 /* Undefined */ || specifierType.flags & 8192 /* Null */ || !isTypeAssignableTo(specifierType, stringType)) {
	                error(specifier, ts.Diagnostics.Dynamic_import_s_specifier_must_be_of_type_string_but_here_has_type_0, typeToString(specifierType));
	            }
	            // resolveExternalModuleName will return undefined if the moduleReferenceExpression is not a string literal
	            var moduleSymbol = resolveExternalModuleName(node, specifier);
	            if (moduleSymbol) {
	                var esModuleSymbol = resolveESModuleSymbol(moduleSymbol, specifier, /*dontRecursivelyResolve*/ true);
	                if (esModuleSymbol) {
	                    return createPromiseReturnType(node, getTypeWithSyntheticDefaultImportType(getTypeOfSymbol(esModuleSymbol), esModuleSymbol, moduleSymbol));
	                }
	            }
	            return createPromiseReturnType(node, anyType);
	        }
	        function getTypeWithSyntheticDefaultImportType(type, symbol, originalSymbol) {
	            if (allowSyntheticDefaultImports && type && type !== unknownType) {
	                var synthType = type;
	                if (!synthType.syntheticType) {
	                    var file_4 = ts.find(originalSymbol.declarations, ts.isSourceFile);
	                    var hasSyntheticDefault = canHaveSyntheticDefault(file_4, originalSymbol, /*dontResolveAlias*/ false);
	                    if (hasSyntheticDefault) {
	                        var memberTable = ts.createSymbolTable();
	                        var newSymbol = createSymbol(2097152 /* Alias */, "default" /* Default */);
	                        newSymbol.target = resolveSymbol(symbol);
	                        memberTable.set("default" /* Default */, newSymbol);
	                        var anonymousSymbol = createSymbol(2048 /* TypeLiteral */, "__type" /* Type */);
	                        var defaultContainingObject = createAnonymousType(anonymousSymbol, memberTable, ts.emptyArray, ts.emptyArray, /*stringIndexInfo*/ undefined, /*numberIndexInfo*/ undefined);
	                        anonymousSymbol.type = defaultContainingObject;
	                        synthType.syntheticType = isValidSpreadType(type) ? getSpreadType(type, defaultContainingObject, anonymousSymbol, /*typeFLags*/ 0, /*objectFlags*/ 0) : defaultContainingObject;
	                    }
	                    else {
	                        synthType.syntheticType = type;
	                    }
	                }
	                return synthType.syntheticType;
	            }
	            return type;
	        }
	        function isCommonJsRequire(node) {
	            if (!ts.isRequireCall(node, /*checkArgumentIsStringLiteralLike*/ true)) {
	                return false;
	            }
	            // Make sure require is not a local function
	            if (!ts.isIdentifier(node.expression))
	                return ts.Debug.fail();
	            var resolvedRequire = resolveName(node.expression, node.expression.escapedText, 67216319 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	            if (resolvedRequire === requireSymbol) {
	                return true;
	            }
	            // project includes symbol named 'require' - make sure that it is ambient and local non-alias
	            if (resolvedRequire.flags & 2097152 /* Alias */) {
	                return false;
	            }
	            var targetDeclarationKind = resolvedRequire.flags & 16 /* Function */
	                ? 233 /* FunctionDeclaration */
	                : resolvedRequire.flags & 3 /* Variable */
	                    ? 231 /* VariableDeclaration */
	                    : 0 /* Unknown */;
	            if (targetDeclarationKind !== 0 /* Unknown */) {
	                var decl = ts.getDeclarationOfKind(resolvedRequire, targetDeclarationKind);
	                // function/variable declaration should be ambient
	                return !!decl && !!(decl.flags & 4194304 /* Ambient */);
	            }
	            return false;
	        }
	        function checkTaggedTemplateExpression(node) {
	            checkGrammarTypeArguments(node, node.typeArguments);
	            if (languageVersion < 2 /* ES2015 */) {
	                checkExternalEmitHelpers(node, 65536 /* MakeTemplateObject */);
	            }
	            return getReturnTypeOfSignature(getResolvedSignature(node));
	        }
	        function checkAssertion(node) {
	            return checkAssertionWorker(node, node.type, node.expression);
	        }
	        function checkAssertionWorker(errNode, type, expression, checkMode) {
	            var exprType = getRegularTypeOfObjectLiteral(getBaseTypeOfLiteralType(checkExpression(expression, checkMode)));
	            checkSourceElement(type);
	            var targetType = getTypeFromTypeNode(type);
	            if (produceDiagnostics && targetType !== unknownType) {
	                var widenedType = getWidenedType(exprType);
	                if (!isTypeComparableTo(targetType, widenedType)) {
	                    checkTypeComparableTo(exprType, targetType, errNode, ts.Diagnostics.Type_0_cannot_be_converted_to_type_1);
	                }
	            }
	            return targetType;
	        }
	        function checkNonNullAssertion(node) {
	            return getNonNullableType(checkExpression(node.expression));
	        }
	        function checkMetaProperty(node) {
	            checkGrammarMetaProperty(node);
	            if (node.keywordToken === 94 /* NewKeyword */) {
	                return checkNewTargetMetaProperty(node);
	            }
	            if (node.keywordToken === 91 /* ImportKeyword */) {
	                return checkImportMetaProperty(node);
	            }
	        }
	        function checkNewTargetMetaProperty(node) {
	            var container = ts.getNewTargetContainer(node);
	            if (!container) {
	                error(node, ts.Diagnostics.Meta_property_0_is_only_allowed_in_the_body_of_a_function_declaration_function_expression_or_constructor, "new.target");
	                return unknownType;
	            }
	            else if (container.kind === 154 /* Constructor */) {
	                var symbol = getSymbolOfNode(container.parent);
	                return getTypeOfSymbol(symbol);
	            }
	            else {
	                var symbol = getSymbolOfNode(container);
	                return getTypeOfSymbol(symbol);
	            }
	        }
	        function checkImportMetaProperty(node) {
	            if (languageVersion < 6 /* ESNext */ || moduleKind < ts.ModuleKind.ESNext) {
	                error(node, ts.Diagnostics.The_import_meta_meta_property_is_only_allowed_using_ESNext_for_the_target_and_module_compiler_options);
	            }
	            var file = ts.getSourceFileOfNode(node);
	            ts.Debug.assert(!!(file.flags & 1048576 /* PossiblyContainsImportMeta */), "Containing file is missing import meta node flag.");
	            ts.Debug.assert(!!file.externalModuleIndicator, "Containing file should be a module.");
	            return node.name.escapedText === "meta" ? getGlobalImportMetaType() : unknownType;
	        }
	        function getTypeOfParameter(symbol) {
	            var type = getTypeOfSymbol(symbol);
	            if (strictNullChecks) {
	                var declaration = symbol.valueDeclaration;
	                if (declaration && ts.hasInitializer(declaration)) {
	                    return getOptionalType(type);
	                }
	            }
	            return type;
	        }
	        function getTypeAtPosition(signature, pos) {
	            return signature.hasRestParameter ?
	                pos < signature.parameters.length - 1 ? getTypeOfParameter(signature.parameters[pos]) : getRestTypeOfSignature(signature) :
	                pos < signature.parameters.length ? getTypeOfParameter(signature.parameters[pos]) : anyType;
	        }
	        function getTypeOfFirstParameterOfSignature(signature) {
	            return getTypeOfFirstParameterOfSignatureWithFallback(signature, neverType);
	        }
	        function getTypeOfFirstParameterOfSignatureWithFallback(signature, fallbackType) {
	            return signature.parameters.length > 0 ? getTypeAtPosition(signature, 0) : fallbackType;
	        }
	        function inferFromAnnotatedParameters(signature, context, mapper) {
	            var len = signature.parameters.length - (signature.hasRestParameter ? 1 : 0);
	            for (var i = 0; i < len; i++) {
	                var declaration = signature.parameters[i].valueDeclaration;
	                if (declaration.type) {
	                    var typeNode = ts.getEffectiveTypeAnnotationNode(declaration);
	                    if (typeNode) {
	                        inferTypes(mapper.inferences, getTypeFromTypeNode(typeNode), getTypeAtPosition(context, i));
	                    }
	                }
	            }
	        }
	        function assignContextualParameterTypes(signature, context) {
	            signature.typeParameters = context.typeParameters;
	            if (context.thisParameter) {
	                var parameter = signature.thisParameter;
	                if (!parameter || parameter.valueDeclaration && !parameter.valueDeclaration.type) {
	                    if (!parameter) {
	                        signature.thisParameter = createSymbolWithType(context.thisParameter, /*type*/ undefined);
	                    }
	                    assignTypeToParameterAndFixTypeParameters(signature.thisParameter, getTypeOfSymbol(context.thisParameter));
	                }
	            }
	            var len = signature.parameters.length - (signature.hasRestParameter ? 1 : 0);
	            for (var i = 0; i < len; i++) {
	                var parameter = signature.parameters[i];
	                if (!ts.getEffectiveTypeAnnotationNode(parameter.valueDeclaration)) {
	                    var contextualParameterType = getTypeAtPosition(context, i);
	                    assignTypeToParameterAndFixTypeParameters(parameter, contextualParameterType);
	                }
	            }
	            if (signature.hasRestParameter && isRestParameterIndex(context, signature.parameters.length - 1)) {
	                // parameter might be a transient symbol generated by use of `arguments` in the function body.
	                var parameter = ts.lastOrUndefined(signature.parameters);
	                if (isTransientSymbol(parameter) || !ts.getEffectiveTypeAnnotationNode(parameter.valueDeclaration)) {
	                    var contextualParameterType = getTypeOfSymbol(ts.lastOrUndefined(context.parameters));
	                    assignTypeToParameterAndFixTypeParameters(parameter, contextualParameterType);
	                }
	            }
	        }
	        // When contextual typing assigns a type to a parameter that contains a binding pattern, we also need to push
	        // the destructured type into the contained binding elements.
	        function assignBindingElementTypes(pattern) {
	            for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (!ts.isOmittedExpression(element)) {
	                    if (element.name.kind === 71 /* Identifier */) {
	                        getSymbolLinks(getSymbolOfNode(element)).type = getTypeForBindingElement(element);
	                    }
	                    else {
	                        assignBindingElementTypes(element.name);
	                    }
	                }
	            }
	        }
	        function assignTypeToParameterAndFixTypeParameters(parameter, contextualType) {
	            var links = getSymbolLinks(parameter);
	            if (!links.type) {
	                links.type = contextualType;
	                var decl = parameter.valueDeclaration;
	                if (decl.name.kind !== 71 /* Identifier */) {
	                    // if inference didn't come up with anything but {}, fall back to the binding pattern if present.
	                    if (links.type === emptyObjectType) {
	                        links.type = getTypeFromBindingPattern(decl.name);
	                    }
	                    assignBindingElementTypes(decl.name);
	                }
	            }
	        }
	        function createPromiseType(promisedType) {
	            // creates a `Promise<T>` type where `T` is the promisedType argument
	            var globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
	            if (globalPromiseType !== emptyGenericType) {
	                // if the promised type is itself a promise, get the underlying type; otherwise, fallback to the promised type
	                promisedType = getAwaitedType(promisedType) || emptyObjectType;
	                return createTypeReference(globalPromiseType, [promisedType]);
	            }
	            return emptyObjectType;
	        }
	        function createPromiseReturnType(func, promisedType) {
	            var promiseType = createPromiseType(promisedType);
	            if (promiseType === emptyObjectType) {
	                error(func, ts.isImportCall(func) ?
	                    ts.Diagnostics.A_dynamic_import_call_returns_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option :
	                    ts.Diagnostics.An_async_function_or_method_must_return_a_Promise_Make_sure_you_have_a_declaration_for_Promise_or_include_ES2015_in_your_lib_option);
	                return unknownType;
	            }
	            else if (!getGlobalPromiseConstructorSymbol(/*reportErrors*/ true)) {
	                error(func, ts.isImportCall(func) ?
	                    ts.Diagnostics.A_dynamic_import_call_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option :
	                    ts.Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
	            }
	            return promiseType;
	        }
	        function getReturnTypeFromBody(func, checkMode) {
	            if (!func.body) {
	                return unknownType;
	            }
	            var functionFlags = ts.getFunctionFlags(func);
	            var type;
	            if (func.body.kind !== 212 /* Block */) {
	                type = checkExpressionCached(func.body, checkMode);
	                if (functionFlags & 2 /* Async */) {
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                    // return type of the body should be unwrapped to its awaited type, which we will wrap in
	                    // the native Promise<T> type later in this function.
	                    type = checkAwaitedType(type, /*errorNode*/ func, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                }
	            }
	            else {
	                var types = checkAndAggregateReturnExpressionTypes(func, checkMode);
	                if (functionFlags & 1 /* Generator */) { // Generator or AsyncGenerator function
	                    types = ts.concatenate(checkAndAggregateYieldOperandTypes(func, checkMode), types);
	                    if (!types || types.length === 0) {
	                        var iterableIteratorAny = functionFlags & 2 /* Async */
	                            ? createAsyncIterableIteratorType(anyType) // AsyncGenerator function
	                            : createIterableIteratorType(anyType); // Generator function
	                        if (noImplicitAny) {
	                            error(func.asteriskToken, ts.Diagnostics.Generator_implicitly_has_type_0_because_it_does_not_yield_any_values_Consider_supplying_a_return_type, typeToString(iterableIteratorAny));
	                        }
	                        return iterableIteratorAny;
	                    }
	                }
	                else {
	                    if (!types) {
	                        // For an async function, the return type will not be never, but rather a Promise for never.
	                        return functionFlags & 2 /* Async */
	                            ? createPromiseReturnType(func, neverType) // Async function
	                            : neverType; // Normal function
	                    }
	                    if (types.length === 0) {
	                        // For an async function, the return type will not be void, but rather a Promise for void.
	                        return functionFlags & 2 /* Async */
	                            ? createPromiseReturnType(func, voidType) // Async function
	                            : voidType; // Normal function
	                    }
	                }
	                // Return a union of the return expression types.
	                type = getUnionType(types, 2 /* Subtype */);
	            }
	            var contextualSignature = getContextualSignatureForFunctionLikeDeclaration(func);
	            if (!contextualSignature) {
	                reportErrorsFromWidening(func, type);
	            }
	            if (isUnitType(type)) {
	                var contextualType = !contextualSignature ? undefined :
	                    contextualSignature === getSignatureFromDeclaration(func) ? type :
	                        getReturnTypeOfSignature(contextualSignature);
	                if (contextualType) {
	                    switch (functionFlags & 3 /* AsyncGenerator */) {
	                        case 3 /* AsyncGenerator */:
	                            contextualType = getIteratedTypeOfGenerator(contextualType, /*isAsyncGenerator*/ true);
	                            break;
	                        case 1 /* Generator */:
	                            contextualType = getIteratedTypeOfGenerator(contextualType, /*isAsyncGenerator*/ false);
	                            break;
	                        case 2 /* Async */:
	                            contextualType = getPromisedTypeOfPromise(contextualType);
	                            break;
	                    }
	                }
	                type = getWidenedLiteralLikeTypeForContextualType(type, contextualType);
	            }
	            var widenedType = getWidenedType(type);
	            switch (functionFlags & 3 /* AsyncGenerator */) {
	                case 3 /* AsyncGenerator */:
	                    return createAsyncIterableIteratorType(widenedType);
	                case 1 /* Generator */:
	                    return createIterableIteratorType(widenedType);
	                case 2 /* Async */:
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                    // return type of the body is awaited type of the body, wrapped in a native Promise<T> type.
	                    return createPromiseType(widenedType);
	                default:
	                    return widenedType;
	            }
	        }
	        function checkAndAggregateYieldOperandTypes(func, checkMode) {
	            var aggregatedTypes = [];
	            var isAsync = (ts.getFunctionFlags(func) & 2 /* Async */) !== 0;
	            ts.forEachYieldExpression(func.body, function (yieldExpression) {
	                ts.pushIfUnique(aggregatedTypes, getYieldedTypeOfYieldExpression(yieldExpression, isAsync, checkMode));
	            });
	            return aggregatedTypes;
	        }
	        function getYieldedTypeOfYieldExpression(node, isAsync, checkMode) {
	            var errorNode = node.expression || node;
	            var expressionType = node.expression ? checkExpressionCached(node.expression, checkMode) : undefinedWideningType;
	            // A `yield*` expression effectively yields everything that its operand yields
	            var yieldedType = node.asteriskToken ? checkIteratedTypeOrElementType(expressionType, errorNode, /*allowStringInput*/ false, isAsync) : expressionType;
	            return !isAsync ? yieldedType : getAwaitedType(yieldedType, errorNode, node.asteriskToken
	                ? ts.Diagnostics.Type_of_iterated_elements_of_a_yield_Asterisk_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member
	                : ts.Diagnostics.Type_of_yield_operand_in_an_async_generator_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	        }
	        function isExhaustiveSwitchStatement(node) {
	            if (!node.possiblyExhaustive) {
	                return false;
	            }
	            var type = getTypeOfExpression(node.expression);
	            if (!isLiteralType(type)) {
	                return false;
	            }
	            var switchTypes = getSwitchClauseTypes(node);
	            if (!switchTypes.length || ts.some(switchTypes, isNeitherUnitTypeNorNever)) {
	                return false;
	            }
	            return eachTypeContainedIn(mapType(type, getRegularTypeOfLiteralType), switchTypes);
	        }
	        function functionHasImplicitReturn(func) {
	            if (!(func.flags & 128 /* HasImplicitReturn */)) {
	                return false;
	            }
	            if (ts.some(func.body.statements, function (statement) { return statement.kind === 226 /* SwitchStatement */ && isExhaustiveSwitchStatement(statement); })) {
	                return false;
	            }
	            return true;
	        }
	        /** NOTE: Return value of `[]` means a different thing than `undefined`. `[]` means func returns `void`, `undefined` means it returns `never`. */
	        function checkAndAggregateReturnExpressionTypes(func, checkMode) {
	            var functionFlags = ts.getFunctionFlags(func);
	            var aggregatedTypes = [];
	            var hasReturnWithNoExpression = functionHasImplicitReturn(func);
	            var hasReturnOfTypeNever = false;
	            ts.forEachReturnStatement(func.body, function (returnStatement) {
	                var expr = returnStatement.expression;
	                if (expr) {
	                    var type = checkExpressionCached(expr, checkMode);
	                    if (functionFlags & 2 /* Async */) {
	                        // From within an async function you can return either a non-promise value or a promise. Any
	                        // Promise/A+ compatible implementation will always assimilate any foreign promise, so the
	                        // return type of the body should be unwrapped to its awaited type, which should be wrapped in
	                        // the native Promise<T> type by the caller.
	                        type = checkAwaitedType(type, func, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                    }
	                    if (type.flags & 16384 /* Never */) {
	                        hasReturnOfTypeNever = true;
	                    }
	                    ts.pushIfUnique(aggregatedTypes, type);
	                }
	                else {
	                    hasReturnWithNoExpression = true;
	                }
	            });
	            if (aggregatedTypes.length === 0 && !hasReturnWithNoExpression && (hasReturnOfTypeNever || mayReturnNever(func))) {
	                return undefined;
	            }
	            if (strictNullChecks && aggregatedTypes.length && hasReturnWithNoExpression &&
	                !(isJavaScriptConstructor(func) && aggregatedTypes.some(function (t) { return t.symbol === func.symbol; }))) {
	                // Javascript "callable constructors", containing eg `if (!(this instanceof A)) return new A()` should not add undefined
	                ts.pushIfUnique(aggregatedTypes, undefinedType);
	            }
	            return aggregatedTypes;
	        }
	        function mayReturnNever(func) {
	            switch (func.kind) {
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return true;
	                case 153 /* MethodDeclaration */:
	                    return func.parent.kind === 183 /* ObjectLiteralExpression */;
	                default:
	                    return false;
	            }
	        }
	        /**
	         * TypeScript Specification 1.0 (6.3) - July 2014
	         *   An explicitly typed function whose return type isn't the Void type,
	         *   the Any type, or a union type containing the Void or Any type as a constituent
	         *   must have at least one return statement somewhere in its body.
	         *   An exception to this rule is if the function implementation consists of a single 'throw' statement.
	         *
	         * @param returnType - return type of the function, can be undefined if return type is not explicitly specified
	         */
	        function checkAllCodePathsInNonVoidFunctionReturnOrThrow(func, returnType) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // Functions with with an explicitly specified 'void' or 'any' return type don't need any return expressions.
	            if (returnType && maybeTypeOfKind(returnType, 1 /* Any */ | 2048 /* Void */)) {
	                return;
	            }
	            // If all we have is a function signature, or an arrow function with an expression body, then there is nothing to check.
	            // also if HasImplicitReturn flag is not set this means that all codepaths in function body end with return or throw
	            if (func.kind === 152 /* MethodSignature */ || ts.nodeIsMissing(func.body) || func.body.kind !== 212 /* Block */ || !functionHasImplicitReturn(func)) {
	                return;
	            }
	            var hasExplicitReturn = func.flags & 256 /* HasExplicitReturn */;
	            if (returnType && returnType.flags & 16384 /* Never */) {
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.A_function_returning_never_cannot_have_a_reachable_end_point);
	            }
	            else if (returnType && !hasExplicitReturn) {
	                // minimal check: function has syntactic return type annotation and no explicit return statements in the body
	                // this function does not conform to the specification.
	                // NOTE: having returnType !== undefined is a precondition for entering this branch so func.type will always be present
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.A_function_whose_declared_type_is_neither_void_nor_any_must_return_a_value);
	            }
	            else if (returnType && strictNullChecks && !isTypeAssignableTo(undefinedType, returnType)) {
	                error(ts.getEffectiveReturnTypeNode(func), ts.Diagnostics.Function_lacks_ending_return_statement_and_return_type_does_not_include_undefined);
	            }
	            else if (compilerOptions.noImplicitReturns) {
	                if (!returnType) {
	                    // If return type annotation is omitted check if function has any explicit return statements.
	                    // If it does not have any - its inferred return type is void - don't do any checks.
	                    // Otherwise get inferred return type from function body and report error only if it is not void / anytype
	                    if (!hasExplicitReturn) {
	                        return;
	                    }
	                    var inferredReturnType = getReturnTypeOfSignature(getSignatureFromDeclaration(func));
	                    if (isUnwrappedReturnTypeVoidOrAny(func, inferredReturnType)) {
	                        return;
	                    }
	                }
	                error(ts.getEffectiveReturnTypeNode(func) || func, ts.Diagnostics.Not_all_code_paths_return_a_value);
	            }
	        }
	        function checkFunctionExpressionOrObjectLiteralMethod(node, checkMode) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            // The identityMapper object is used to indicate that function expressions are wildcards
	            if (checkMode === 1 /* SkipContextSensitive */ && isContextSensitive(node)) {
	                return anyFunctionType;
	            }
	            // Grammar checking
	            var hasGrammarError = checkGrammarFunctionLikeDeclaration(node);
	            if (!hasGrammarError && node.kind === 191 /* FunctionExpression */) {
	                checkGrammarForGenerator(node);
	            }
	            var links = getNodeLinks(node);
	            var type = getTypeOfSymbol(getMergedSymbol(node.symbol));
	            if (isTypeAny(type)) {
	                return type;
	            }
	            // Check if function expression is contextually typed and assign parameter types if so.
	            if (!(links.flags & 1024 /* ContextChecked */)) {
	                var contextualSignature = getContextualSignature(node);
	                // If a type check is started at a function expression that is an argument of a function call, obtaining the
	                // contextual type may recursively get back to here during overload resolution of the call. If so, we will have
	                // already assigned contextual types.
	                if (!(links.flags & 1024 /* ContextChecked */)) {
	                    links.flags |= 1024 /* ContextChecked */;
	                    if (contextualSignature) {
	                        var signature = getSignaturesOfType(type, 0 /* Call */)[0];
	                        if (isContextSensitive(node)) {
	                            var contextualMapper = getContextualMapper(node);
	                            if (checkMode === 2 /* Inferential */) {
	                                inferFromAnnotatedParameters(signature, contextualSignature, contextualMapper);
	                            }
	                            var instantiatedContextualSignature = contextualMapper === identityMapper ?
	                                contextualSignature : instantiateSignature(contextualSignature, contextualMapper);
	                            assignContextualParameterTypes(signature, instantiatedContextualSignature);
	                        }
	                        if (!ts.getEffectiveReturnTypeNode(node) && !signature.resolvedReturnType) {
	                            var returnType = getReturnTypeFromBody(node, checkMode);
	                            if (!signature.resolvedReturnType) {
	                                signature.resolvedReturnType = returnType;
	                            }
	                        }
	                    }
	                    checkSignatureDeclaration(node);
	                    checkNodeDeferred(node);
	                }
	            }
	            return type;
	        }
	        function checkFunctionExpressionOrObjectLiteralMethodDeferred(node) {
	            ts.Debug.assert(node.kind !== 153 /* MethodDeclaration */ || ts.isObjectLiteralMethod(node));
	            var functionFlags = ts.getFunctionFlags(node);
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            var returnOrPromisedType = returnTypeNode &&
	                ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */ ?
	                    checkAsyncFunctionReturnType(node) : // Async function
	                    getTypeFromTypeNode(returnTypeNode)); // AsyncGenerator function, Generator function, or normal function
	            if ((functionFlags & 1 /* Generator */) === 0) { // Async function or normal function
	                // return is not necessary in the body of generators
	                checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnOrPromisedType);
	            }
	            if (node.body) {
	                if (!returnTypeNode) {
	                    // There are some checks that are only performed in getReturnTypeFromBody, that may produce errors
	                    // we need. An example is the noImplicitAny errors resulting from widening the return expression
	                    // of a function. Because checking of function expression bodies is deferred, there was never an
	                    // appropriate time to do this during the main walk of the file (see the comment at the top of
	                    // checkFunctionExpressionBodies). So it must be done now.
	                    getReturnTypeOfSignature(getSignatureFromDeclaration(node));
	                }
	                if (node.body.kind === 212 /* Block */) {
	                    checkSourceElement(node.body);
	                }
	                else {
	                    // From within an async function you can return either a non-promise value or a promise. Any
	                    // Promise/A+ compatible implementation will always assimilate any foreign promise, so we
	                    // should not be checking assignability of a promise to the return type. Instead, we need to
	                    // check assignability of the awaited type of the expression body against the promised type of
	                    // its return type annotation.
	                    var exprType = checkExpression(node.body);
	                    if (returnOrPromisedType) {
	                        if ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */) { // Async function
	                            var awaitedType = checkAwaitedType(exprType, node.body, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                            checkTypeAssignableTo(awaitedType, returnOrPromisedType, node.body);
	                        }
	                        else { // Normal function
	                            checkTypeAssignableTo(exprType, returnOrPromisedType, node.body);
	                        }
	                    }
	                }
	            }
	        }
	        function checkArithmeticOperandType(operand, type, diagnostic) {
	            if (!isTypeAssignableToKind(type, 84 /* NumberLike */)) {
	                error(operand, diagnostic);
	                return false;
	            }
	            return true;
	        }
	        function isReadonlySymbol(symbol) {
	            // The following symbols are considered read-only:
	            // Properties with a 'readonly' modifier
	            // Variables declared with 'const'
	            // Get accessors without matching set accessors
	            // Enum members
	            // Unions and intersections of the above (unions and intersections eagerly set isReadonly on creation)
	            return !!(ts.getCheckFlags(symbol) & 8 /* Readonly */ ||
	                symbol.flags & 4 /* Property */ && ts.getDeclarationModifierFlagsFromSymbol(symbol) & 64 /* Readonly */ ||
	                symbol.flags & 3 /* Variable */ && getDeclarationNodeFlagsFromSymbol(symbol) & 2 /* Const */ ||
	                symbol.flags & 98304 /* Accessor */ && !(symbol.flags & 65536 /* SetAccessor */) ||
	                symbol.flags & 8 /* EnumMember */);
	        }
	        function isReferenceToReadonlyEntity(expr, symbol) {
	            if (isReadonlySymbol(symbol)) {
	                // Allow assignments to readonly properties within constructors of the same class declaration.
	                if (symbol.flags & 4 /* Property */ &&
	                    (expr.kind === 184 /* PropertyAccessExpression */ || expr.kind === 185 /* ElementAccessExpression */) &&
	                    expr.expression.kind === 99 /* ThisKeyword */) {
	                    // Look for if this is the constructor for the class that `symbol` is a property of.
	                    var func = ts.getContainingFunction(expr);
	                    if (!(func && func.kind === 154 /* Constructor */)) {
	                        return true;
	                    }
	                    // If func.parent is a class and symbol is a (readonly) property of that class, or
	                    // if func is a constructor and symbol is a (readonly) parameter property declared in it,
	                    // then symbol is writeable here.
	                    return !(func.parent === symbol.valueDeclaration.parent || func === symbol.valueDeclaration.parent);
	                }
	                return true;
	            }
	            return false;
	        }
	        function isReferenceThroughNamespaceImport(expr) {
	            if (expr.kind === 184 /* PropertyAccessExpression */ || expr.kind === 185 /* ElementAccessExpression */) {
	                var node = ts.skipParentheses(expr.expression);
	                if (node.kind === 71 /* Identifier */) {
	                    var symbol = getNodeLinks(node).resolvedSymbol;
	                    if (symbol.flags & 2097152 /* Alias */) {
	                        var declaration = getDeclarationOfAliasSymbol(symbol);
	                        return declaration && declaration.kind === 245 /* NamespaceImport */;
	                    }
	                }
	            }
	            return false;
	        }
	        function checkReferenceExpression(expr, invalidReferenceMessage) {
	            // References are combinations of identifiers, parentheses, and property accesses.
	            var node = ts.skipOuterExpressions(expr, 2 /* Assertions */ | 1 /* Parentheses */);
	            if (node.kind !== 71 /* Identifier */ && node.kind !== 184 /* PropertyAccessExpression */ && node.kind !== 185 /* ElementAccessExpression */) {
	                error(expr, invalidReferenceMessage);
	                return false;
	            }
	            return true;
	        }
	        function checkDeleteExpression(node) {
	            checkExpression(node.expression);
	            var expr = ts.skipParentheses(node.expression);
	            if (expr.kind !== 184 /* PropertyAccessExpression */ && expr.kind !== 185 /* ElementAccessExpression */) {
	                error(expr, ts.Diagnostics.The_operand_of_a_delete_operator_must_be_a_property_reference);
	                return booleanType;
	            }
	            var links = getNodeLinks(expr);
	            var symbol = getExportSymbolOfValueSymbolIfExported(links.resolvedSymbol);
	            if (symbol && isReadonlySymbol(symbol)) {
	                error(expr, ts.Diagnostics.The_operand_of_a_delete_operator_cannot_be_a_read_only_property);
	            }
	            return booleanType;
	        }
	        function checkTypeOfExpression(node) {
	            checkExpression(node.expression);
	            return typeofType;
	        }
	        function checkVoidExpression(node) {
	            checkExpression(node.expression);
	            return undefinedWideningType;
	        }
	        function checkAwaitExpression(node) {
	            // Grammar checking
	            if (produceDiagnostics) {
	                if (!(node.flags & 16384 /* AwaitContext */)) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.await_expression_is_only_allowed_within_an_async_function);
	                }
	                if (isInParameterInitializerBeforeContainingFunction(node)) {
	                    error(node, ts.Diagnostics.await_expressions_cannot_be_used_in_a_parameter_initializer);
	                }
	            }
	            var operandType = checkExpression(node.expression);
	            return checkAwaitedType(operandType, node, ts.Diagnostics.Type_of_await_operand_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	        }
	        function checkPrefixUnaryExpression(node) {
	            var operandType = checkExpression(node.operand);
	            if (operandType === silentNeverType) {
	                return silentNeverType;
	            }
	            if (node.operand.kind === 8 /* NumericLiteral */) {
	                if (node.operator === 38 /* MinusToken */) {
	                    return getFreshTypeOfLiteralType(getLiteralType(-node.operand.text));
	                }
	                else if (node.operator === 37 /* PlusToken */) {
	                    return getFreshTypeOfLiteralType(getLiteralType(+node.operand.text));
	                }
	            }
	            switch (node.operator) {
	                case 37 /* PlusToken */:
	                case 38 /* MinusToken */:
	                case 52 /* TildeToken */:
	                    checkNonNullType(operandType, node.operand);
	                    if (maybeTypeOfKind(operandType, 1536 /* ESSymbolLike */)) {
	                        error(node.operand, ts.Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, ts.tokenToString(node.operator));
	                    }
	                    return numberType;
	                case 51 /* ExclamationToken */:
	                    var facts = getTypeFacts(operandType) & (1048576 /* Truthy */ | 2097152 /* Falsy */);
	                    return facts === 1048576 /* Truthy */ ? falseType :
	                        facts === 2097152 /* Falsy */ ? trueType :
	                            booleanType;
	                case 43 /* PlusPlusToken */:
	                case 44 /* MinusMinusToken */:
	                    var ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), ts.Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type);
	                    if (ok) {
	                        // run check only if former checks succeeded to avoid reporting cascading errors
	                        checkReferenceExpression(node.operand, ts.Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access);
	                    }
	                    return numberType;
	            }
	            return unknownType;
	        }
	        function checkPostfixUnaryExpression(node) {
	            var operandType = checkExpression(node.operand);
	            if (operandType === silentNeverType) {
	                return silentNeverType;
	            }
	            var ok = checkArithmeticOperandType(node.operand, checkNonNullType(operandType, node.operand), ts.Diagnostics.An_arithmetic_operand_must_be_of_type_any_number_or_an_enum_type);
	            if (ok) {
	                // run check only if former checks succeeded to avoid reporting cascading errors
	                checkReferenceExpression(node.operand, ts.Diagnostics.The_operand_of_an_increment_or_decrement_operator_must_be_a_variable_or_a_property_access);
	            }
	            return numberType;
	        }
	        // Return true if type might be of the given kind. A union or intersection type might be of a given
	        // kind if at least one constituent type is of the given kind.
	        function maybeTypeOfKind(type, kind) {
	            if (type.flags & kind || kind & 536870912 /* GenericMappedType */ && isGenericMappedType(type)) {
	                return true;
	            }
	            if (type.flags & 393216 /* UnionOrIntersection */) {
	                var types = type.types;
	                for (var _i = 0, types_16 = types; _i < types_16.length; _i++) {
	                    var t = types_16[_i];
	                    if (maybeTypeOfKind(t, kind)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function isTypeAssignableToKind(source, kind, strict) {
	            if (source.flags & kind) {
	                return true;
	            }
	            if (strict && source.flags & (1 /* Any */ | 2048 /* Void */ | 4096 /* Undefined */ | 8192 /* Null */)) {
	                return false;
	            }
	            return (kind & 84 /* NumberLike */ && isTypeAssignableTo(source, numberType)) ||
	                (kind & 34 /* StringLike */ && isTypeAssignableTo(source, stringType)) ||
	                (kind & 136 /* BooleanLike */ && isTypeAssignableTo(source, booleanType)) ||
	                (kind & 2048 /* Void */ && isTypeAssignableTo(source, voidType)) ||
	                (kind & 16384 /* Never */ && isTypeAssignableTo(source, neverType)) ||
	                (kind & 8192 /* Null */ && isTypeAssignableTo(source, nullType)) ||
	                (kind & 4096 /* Undefined */ && isTypeAssignableTo(source, undefinedType)) ||
	                (kind & 512 /* ESSymbol */ && isTypeAssignableTo(source, esSymbolType)) ||
	                (kind & 134217728 /* NonPrimitive */ && isTypeAssignableTo(source, nonPrimitiveType));
	        }
	        function allTypesAssignableToKind(source, kind, strict) {
	            return source.flags & 131072 /* Union */ ?
	                ts.every(source.types, function (subType) { return allTypesAssignableToKind(subType, kind, strict); }) :
	                isTypeAssignableToKind(source, kind, strict);
	        }
	        function isConstEnumObjectType(type) {
	            return ts.getObjectFlags(type) & 16 /* Anonymous */ && type.symbol && isConstEnumSymbol(type.symbol);
	        }
	        function isConstEnumSymbol(symbol) {
	            return (symbol.flags & 128 /* ConstEnum */) !== 0;
	        }
	        function checkInstanceOfExpression(left, right, leftType, rightType) {
	            if (leftType === silentNeverType || rightType === silentNeverType) {
	                return silentNeverType;
	            }
	            // TypeScript 1.0 spec (April 2014): 4.15.4
	            // The instanceof operator requires the left operand to be of type Any, an object type, or a type parameter type,
	            // and the right operand to be of type Any, a subtype of the 'Function' interface type, or have a call or construct signature.
	            // The result is always of the Boolean primitive type.
	            // NOTE: do not raise error if leftType is unknown as related error was already reported
	            if (!isTypeAny(leftType) &&
	                allTypesAssignableToKind(leftType, 16382 /* Primitive */)) {
	                error(left, ts.Diagnostics.The_left_hand_side_of_an_instanceof_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
	            }
	            // NOTE: do not raise error if right is unknown as related error was already reported
	            if (!(isTypeAny(rightType) || typeHasCallOrConstructSignatures(rightType) || isTypeSubtypeOf(rightType, globalFunctionType))) {
	                error(right, ts.Diagnostics.The_right_hand_side_of_an_instanceof_expression_must_be_of_type_any_or_of_a_type_assignable_to_the_Function_interface_type);
	            }
	            return booleanType;
	        }
	        function checkInExpression(left, right, leftType, rightType) {
	            if (leftType === silentNeverType || rightType === silentNeverType) {
	                return silentNeverType;
	            }
	            leftType = checkNonNullType(leftType, left);
	            rightType = checkNonNullType(rightType, right);
	            // TypeScript 1.0 spec (April 2014): 4.15.5
	            // The in operator requires the left operand to be of type Any, the String primitive type, or the Number primitive type,
	            // and the right operand to be of type Any, an object type, or a type parameter type.
	            // The result is always of the Boolean primitive type.
	            if (!(isTypeComparableTo(leftType, stringType) || isTypeAssignableToKind(leftType, 84 /* NumberLike */ | 1536 /* ESSymbolLike */))) {
	                error(left, ts.Diagnostics.The_left_hand_side_of_an_in_expression_must_be_of_type_any_string_number_or_symbol);
	            }
	            if (!isTypeAssignableToKind(rightType, 134217728 /* NonPrimitive */ | 7372800 /* InstantiableNonPrimitive */)) {
	                error(right, ts.Diagnostics.The_right_hand_side_of_an_in_expression_must_be_of_type_any_an_object_type_or_a_type_parameter);
	            }
	            return booleanType;
	        }
	        function checkObjectLiteralAssignment(node, sourceType) {
	            var properties = node.properties;
	            checkGrammarForDisallowedTrailingComma(properties, ts.Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
	            if (strictNullChecks && properties.length === 0) {
	                return checkNonNullType(sourceType, node);
	            }
	            for (var _i = 0, properties_7 = properties; _i < properties_7.length; _i++) {
	                var p = properties_7[_i];
	                checkObjectLiteralDestructuringPropertyAssignment(sourceType, p, properties);
	            }
	            return sourceType;
	        }
	        /** Note: If property cannot be a SpreadAssignment, then allProperties does not need to be provided */
	        function checkObjectLiteralDestructuringPropertyAssignment(objectLiteralType, property, allProperties) {
	            if (property.kind === 269 /* PropertyAssignment */ || property.kind === 270 /* ShorthandPropertyAssignment */) {
	                var name = property.name;
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(name);
	                }
	                if (isComputedNonLiteralName(name)) {
	                    return undefined;
	                }
	                var text = ts.getTextOfPropertyName(name);
	                var type = isTypeAny(objectLiteralType)
	                    ? objectLiteralType
	                    : getTypeOfPropertyOfType(objectLiteralType, text) ||
	                        isNumericLiteralName(text) && getIndexTypeOfType(objectLiteralType, 1 /* Number */) ||
	                        getIndexTypeOfType(objectLiteralType, 0 /* String */);
	                if (type) {
	                    if (property.kind === 270 /* ShorthandPropertyAssignment */) {
	                        return checkDestructuringAssignment(property, type);
	                    }
	                    else {
	                        // non-shorthand property assignments should always have initializers
	                        return checkDestructuringAssignment(property.initializer, type);
	                    }
	                }
	                else {
	                    error(name, ts.Diagnostics.Type_0_has_no_property_1_and_no_string_index_signature, typeToString(objectLiteralType), ts.declarationNameToString(name));
	                }
	            }
	            else if (property.kind === 271 /* SpreadAssignment */) {
	                if (languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(property, 4 /* Rest */);
	                }
	                var nonRestNames = [];
	                if (allProperties) {
	                    for (var i = 0; i < allProperties.length - 1; i++) {
	                        nonRestNames.push(allProperties[i].name);
	                    }
	                }
	                var type = getRestType(objectLiteralType, nonRestNames, objectLiteralType.symbol);
	                return checkDestructuringAssignment(property.expression, type);
	            }
	            else {
	                error(property, ts.Diagnostics.Property_assignment_expected);
	            }
	        }
	        function checkArrayLiteralAssignment(node, sourceType, checkMode) {
	            var elements = node.elements;
	            checkGrammarForDisallowedTrailingComma(elements, ts.Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
	            if (languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                checkExternalEmitHelpers(node, 512 /* Read */);
	            }
	            // This elementType will be used if the specific property corresponding to this index is not
	            // present (aka the tuple element property). This call also checks that the parentType is in
	            // fact an iterable or array (depending on target language).
	            var elementType = checkIteratedTypeOrElementType(sourceType, node, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType;
	            for (var i = 0; i < elements.length; i++) {
	                checkArrayLiteralDestructuringElementAssignment(node, sourceType, i, elementType, checkMode);
	            }
	            return sourceType;
	        }
	        function checkArrayLiteralDestructuringElementAssignment(node, sourceType, elementIndex, elementType, checkMode) {
	            var elements = node.elements;
	            var element = elements[elementIndex];
	            if (element.kind !== 205 /* OmittedExpression */) {
	                if (element.kind !== 203 /* SpreadElement */) {
	                    var propName = "" + elementIndex;
	                    var type = isTypeAny(sourceType)
	                        ? sourceType
	                        : isTupleLikeType(sourceType)
	                            ? getTypeOfPropertyOfType(sourceType, propName)
	                            : elementType;
	                    if (type) {
	                        return checkDestructuringAssignment(element, type, checkMode);
	                    }
	                    else {
	                        // We still need to check element expression here because we may need to set appropriate flag on the expression
	                        // such as NodeCheckFlags.LexicalThis on "this"expression.
	                        checkExpression(element);
	                        if (isTupleType(sourceType)) {
	                            error(element, ts.Diagnostics.Tuple_type_0_with_length_1_cannot_be_assigned_to_tuple_with_length_2, typeToString(sourceType), getTypeReferenceArity(sourceType), elements.length);
	                        }
	                        else {
	                            error(element, ts.Diagnostics.Type_0_has_no_property_1, typeToString(sourceType), propName);
	                        }
	                    }
	                }
	                else {
	                    if (elementIndex < elements.length - 1) {
	                        error(element, ts.Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
	                    }
	                    else {
	                        var restExpression = element.expression;
	                        if (restExpression.kind === 199 /* BinaryExpression */ && restExpression.operatorToken.kind === 58 /* EqualsToken */) {
	                            error(restExpression.operatorToken, ts.Diagnostics.A_rest_element_cannot_have_an_initializer);
	                        }
	                        else {
	                            return checkDestructuringAssignment(restExpression, createArrayType(elementType), checkMode);
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function checkDestructuringAssignment(exprOrAssignment, sourceType, checkMode) {
	            var target;
	            if (exprOrAssignment.kind === 270 /* ShorthandPropertyAssignment */) {
	                var prop = exprOrAssignment;
	                if (prop.objectAssignmentInitializer) {
	                    // In strict null checking mode, if a default value of a non-undefined type is specified, remove
	                    // undefined from the final type.
	                    if (strictNullChecks &&
	                        !(getFalsyFlags(checkExpression(prop.objectAssignmentInitializer)) & 4096 /* Undefined */)) {
	                        sourceType = getTypeWithFacts(sourceType, 131072 /* NEUndefined */);
	                    }
	                    checkBinaryLikeExpression(prop.name, prop.equalsToken, prop.objectAssignmentInitializer, checkMode);
	                }
	                target = exprOrAssignment.name;
	            }
	            else {
	                target = exprOrAssignment;
	            }
	            if (target.kind === 199 /* BinaryExpression */ && target.operatorToken.kind === 58 /* EqualsToken */) {
	                checkBinaryExpression(target, checkMode);
	                target = target.left;
	            }
	            if (target.kind === 183 /* ObjectLiteralExpression */) {
	                return checkObjectLiteralAssignment(target, sourceType);
	            }
	            if (target.kind === 182 /* ArrayLiteralExpression */) {
	                return checkArrayLiteralAssignment(target, sourceType, checkMode);
	            }
	            return checkReferenceAssignment(target, sourceType, checkMode);
	        }
	        function checkReferenceAssignment(target, sourceType, checkMode) {
	            var targetType = checkExpression(target, checkMode);
	            var error = target.parent.kind === 271 /* SpreadAssignment */ ?
	                ts.Diagnostics.The_target_of_an_object_rest_assignment_must_be_a_variable_or_a_property_access :
	                ts.Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access;
	            if (checkReferenceExpression(target, error)) {
	                checkTypeAssignableTo(sourceType, targetType, target, /*headMessage*/ undefined);
	            }
	            return sourceType;
	        }
	        /**
	         * This is a *shallow* check: An expression is side-effect-free if the
	         * evaluation of the expression *itself* cannot produce side effects.
	         * For example, x++ / 3 is side-effect free because the / operator
	         * does not have side effects.
	         * The intent is to "smell test" an expression for correctness in positions where
	         * its value is discarded (e.g. the left side of the comma operator).
	         */
	        function isSideEffectFree(node) {
	            node = ts.skipParentheses(node);
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 9 /* StringLiteral */:
	                case 12 /* RegularExpressionLiteral */:
	                case 188 /* TaggedTemplateExpression */:
	                case 201 /* TemplateExpression */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 95 /* NullKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 191 /* FunctionExpression */:
	                case 204 /* ClassExpression */:
	                case 192 /* ArrowFunction */:
	                case 182 /* ArrayLiteralExpression */:
	                case 183 /* ObjectLiteralExpression */:
	                case 194 /* TypeOfExpression */:
	                case 208 /* NonNullExpression */:
	                case 255 /* JsxSelfClosingElement */:
	                case 254 /* JsxElement */:
	                    return true;
	                case 200 /* ConditionalExpression */:
	                    return isSideEffectFree(node.whenTrue) &&
	                        isSideEffectFree(node.whenFalse);
	                case 199 /* BinaryExpression */:
	                    if (ts.isAssignmentOperator(node.operatorToken.kind)) {
	                        return false;
	                    }
	                    return isSideEffectFree(node.left) &&
	                        isSideEffectFree(node.right);
	                case 197 /* PrefixUnaryExpression */:
	                case 198 /* PostfixUnaryExpression */:
	                    // Unary operators ~, !, +, and - have no side effects.
	                    // The rest do.
	                    switch (node.operator) {
	                        case 51 /* ExclamationToken */:
	                        case 37 /* PlusToken */:
	                        case 38 /* MinusToken */:
	                        case 52 /* TildeToken */:
	                            return true;
	                    }
	                    return false;
	                // Some forms listed here for clarity
	                case 195 /* VoidExpression */: // Explicit opt-out
	                case 189 /* TypeAssertionExpression */: // Not SEF, but can produce useful type warnings
	                case 207 /* AsExpression */: // Not SEF, but can produce useful type warnings
	                default:
	                    return false;
	            }
	        }
	        function isTypeEqualityComparableTo(source, target) {
	            return (target.flags & 12288 /* Nullable */) !== 0 || isTypeComparableTo(source, target);
	        }
	        function checkBinaryExpression(node, checkMode) {
	            if (ts.isInJavaScriptFile(node) && ts.getAssignedJavascriptInitializer(node)) {
	                return checkExpression(node.right, checkMode);
	            }
	            return checkBinaryLikeExpression(node.left, node.operatorToken, node.right, checkMode, node);
	        }
	        function checkBinaryLikeExpression(left, operatorToken, right, checkMode, errorNode) {
	            var operator = operatorToken.kind;
	            if (operator === 58 /* EqualsToken */ && (left.kind === 183 /* ObjectLiteralExpression */ || left.kind === 182 /* ArrayLiteralExpression */)) {
	                return checkDestructuringAssignment(left, checkExpression(right, checkMode), checkMode);
	            }
	            var leftType = checkExpression(left, checkMode);
	            var rightType = checkExpression(right, checkMode);
	            switch (operator) {
	                case 39 /* AsteriskToken */:
	                case 40 /* AsteriskAsteriskToken */:
	                case 61 /* AsteriskEqualsToken */:
	                case 62 /* AsteriskAsteriskEqualsToken */:
	                case 41 /* SlashToken */:
	                case 63 /* SlashEqualsToken */:
	                case 42 /* PercentToken */:
	                case 64 /* PercentEqualsToken */:
	                case 38 /* MinusToken */:
	                case 60 /* MinusEqualsToken */:
	                case 45 /* LessThanLessThanToken */:
	                case 65 /* LessThanLessThanEqualsToken */:
	                case 46 /* GreaterThanGreaterThanToken */:
	                case 66 /* GreaterThanGreaterThanEqualsToken */:
	                case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                case 49 /* BarToken */:
	                case 69 /* BarEqualsToken */:
	                case 50 /* CaretToken */:
	                case 70 /* CaretEqualsToken */:
	                case 48 /* AmpersandToken */:
	                case 68 /* AmpersandEqualsToken */:
	                    if (leftType === silentNeverType || rightType === silentNeverType) {
	                        return silentNeverType;
	                    }
	                    leftType = checkNonNullType(leftType, left);
	                    rightType = checkNonNullType(rightType, right);
	                    var suggestedOperator = void 0;
	                    // if a user tries to apply a bitwise operator to 2 boolean operands
	                    // try and return them a helpful suggestion
	                    if ((leftType.flags & 136 /* BooleanLike */) &&
	                        (rightType.flags & 136 /* BooleanLike */) &&
	                        (suggestedOperator = getSuggestedBooleanOperator(operatorToken.kind)) !== undefined) {
	                        error(errorNode || operatorToken, ts.Diagnostics.The_0_operator_is_not_allowed_for_boolean_types_Consider_using_1_instead, ts.tokenToString(operatorToken.kind), ts.tokenToString(suggestedOperator));
	                    }
	                    else {
	                        // otherwise just check each operand separately and report errors as normal
	                        var leftOk = checkArithmeticOperandType(left, leftType, ts.Diagnostics.The_left_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type);
	                        var rightOk = checkArithmeticOperandType(right, rightType, ts.Diagnostics.The_right_hand_side_of_an_arithmetic_operation_must_be_of_type_any_number_or_an_enum_type);
	                        if (leftOk && rightOk) {
	                            checkAssignmentOperator(numberType);
	                        }
	                    }
	                    return numberType;
	                case 37 /* PlusToken */:
	                case 59 /* PlusEqualsToken */:
	                    if (leftType === silentNeverType || rightType === silentNeverType) {
	                        return silentNeverType;
	                    }
	                    if (!isTypeAssignableToKind(leftType, 34 /* StringLike */) && !isTypeAssignableToKind(rightType, 34 /* StringLike */)) {
	                        leftType = checkNonNullType(leftType, left);
	                        rightType = checkNonNullType(rightType, right);
	                    }
	                    var resultType = void 0;
	                    if (isTypeAssignableToKind(leftType, 84 /* NumberLike */, /*strict*/ true) && isTypeAssignableToKind(rightType, 84 /* NumberLike */, /*strict*/ true)) {
	                        // Operands of an enum type are treated as having the primitive type Number.
	                        // If both operands are of the Number primitive type, the result is of the Number primitive type.
	                        resultType = numberType;
	                    }
	                    else if (isTypeAssignableToKind(leftType, 34 /* StringLike */, /*strict*/ true) || isTypeAssignableToKind(rightType, 34 /* StringLike */, /*strict*/ true)) {
	                        // If one or both operands are of the String primitive type, the result is of the String primitive type.
	                        resultType = stringType;
	                    }
	                    else if (isTypeAny(leftType) || isTypeAny(rightType)) {
	                        // Otherwise, the result is of type Any.
	                        // NOTE: unknown type here denotes error type. Old compiler treated this case as any type so do we.
	                        resultType = leftType === unknownType || rightType === unknownType ? unknownType : anyType;
	                    }
	                    // Symbols are not allowed at all in arithmetic expressions
	                    if (resultType && !checkForDisallowedESSymbolOperand(operator)) {
	                        return resultType;
	                    }
	                    if (!resultType) {
	                        reportOperatorError();
	                        return anyType;
	                    }
	                    if (operator === 59 /* PlusEqualsToken */) {
	                        checkAssignmentOperator(resultType);
	                    }
	                    return resultType;
	                case 27 /* LessThanToken */:
	                case 29 /* GreaterThanToken */:
	                case 30 /* LessThanEqualsToken */:
	                case 31 /* GreaterThanEqualsToken */:
	                    if (checkForDisallowedESSymbolOperand(operator)) {
	                        leftType = getBaseTypeOfLiteralType(checkNonNullType(leftType, left));
	                        rightType = getBaseTypeOfLiteralType(checkNonNullType(rightType, right));
	                        if (!isTypeComparableTo(leftType, rightType) && !isTypeComparableTo(rightType, leftType)) {
	                            reportOperatorError();
	                        }
	                    }
	                    return booleanType;
	                case 32 /* EqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                    var leftIsLiteral = isLiteralType(leftType);
	                    var rightIsLiteral = isLiteralType(rightType);
	                    if (!leftIsLiteral || !rightIsLiteral) {
	                        leftType = leftIsLiteral ? getBaseTypeOfLiteralType(leftType) : leftType;
	                        rightType = rightIsLiteral ? getBaseTypeOfLiteralType(rightType) : rightType;
	                    }
	                    if (!isTypeEqualityComparableTo(leftType, rightType) && !isTypeEqualityComparableTo(rightType, leftType)) {
	                        reportOperatorError();
	                    }
	                    return booleanType;
	                case 93 /* InstanceOfKeyword */:
	                    return checkInstanceOfExpression(left, right, leftType, rightType);
	                case 92 /* InKeyword */:
	                    return checkInExpression(left, right, leftType, rightType);
	                case 53 /* AmpersandAmpersandToken */:
	                    return getTypeFacts(leftType) & 1048576 /* Truthy */ ?
	                        getUnionType([extractDefinitelyFalsyTypes(strictNullChecks ? leftType : getBaseTypeOfLiteralType(rightType)), rightType]) :
	                        leftType;
	                case 54 /* BarBarToken */:
	                    return getTypeFacts(leftType) & 2097152 /* Falsy */ ?
	                        getUnionType([removeDefinitelyFalsyTypes(leftType), rightType], 2 /* Subtype */) :
	                        leftType;
	                case 58 /* EqualsToken */:
	                    checkSpecialAssignment(left, right);
	                    checkAssignmentOperator(rightType);
	                    return getRegularTypeOfObjectLiteral(rightType);
	                case 26 /* CommaToken */:
	                    if (!compilerOptions.allowUnreachableCode && isSideEffectFree(left) && !isEvalNode(right)) {
	                        error(left, ts.Diagnostics.Left_side_of_comma_operator_is_unused_and_has_no_side_effects);
	                    }
	                    return rightType;
	            }
	            function checkSpecialAssignment(left, right) {
	                var special = ts.getSpecialPropertyAssignmentKind(left.parent);
	                if (special === 2 /* ModuleExports */) {
	                    var rightType_1 = checkExpression(right, checkMode);
	                    for (var _i = 0, _a = getPropertiesOfObjectType(rightType_1); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        var propType = getTypeOfSymbol(prop);
	                        if (propType.symbol && propType.symbol.flags & 32 /* Class */) {
	                            var name = prop.escapedName;
	                            var symbol = resolveName(prop.valueDeclaration, name, 67901928 /* Type */, undefined, name, /*isUse*/ false);
	                            if (symbol) {
	                                grammarErrorOnNode(symbol.declarations[0], ts.Diagnostics.Duplicate_identifier_0, ts.unescapeLeadingUnderscores(name));
	                                return grammarErrorOnNode(prop.valueDeclaration, ts.Diagnostics.Duplicate_identifier_0, ts.unescapeLeadingUnderscores(name));
	                            }
	                        }
	                    }
	                }
	            }
	            function isEvalNode(node) {
	                return node.kind === 71 /* Identifier */ && node.escapedText === "eval";
	            }
	            // Return true if there was no error, false if there was an error.
	            function checkForDisallowedESSymbolOperand(operator) {
	                var offendingSymbolOperand = maybeTypeOfKind(leftType, 1536 /* ESSymbolLike */) ? left :
	                    maybeTypeOfKind(rightType, 1536 /* ESSymbolLike */) ? right :
	                        undefined;
	                if (offendingSymbolOperand) {
	                    error(offendingSymbolOperand, ts.Diagnostics.The_0_operator_cannot_be_applied_to_type_symbol, ts.tokenToString(operator));
	                    return false;
	                }
	                return true;
	            }
	            function getSuggestedBooleanOperator(operator) {
	                switch (operator) {
	                    case 49 /* BarToken */:
	                    case 69 /* BarEqualsToken */:
	                        return 54 /* BarBarToken */;
	                    case 50 /* CaretToken */:
	                    case 70 /* CaretEqualsToken */:
	                        return 35 /* ExclamationEqualsEqualsToken */;
	                    case 48 /* AmpersandToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                        return 53 /* AmpersandAmpersandToken */;
	                    default:
	                        return undefined;
	                }
	            }
	            function checkAssignmentOperator(valueType) {
	                if (produceDiagnostics && ts.isAssignmentOperator(operator)) {
	                    // TypeScript 1.0 spec (April 2014): 4.17
	                    // An assignment of the form
	                    //    VarExpr = ValueExpr
	                    // requires VarExpr to be classified as a reference
	                    // A compound assignment furthermore requires VarExpr to be classified as a reference (section 4.1)
	                    // and the type of the non-compound operation to be assignable to the type of VarExpr.
	                    if (checkReferenceExpression(left, ts.Diagnostics.The_left_hand_side_of_an_assignment_expression_must_be_a_variable_or_a_property_access)
	                        && (!ts.isIdentifier(left) || ts.unescapeLeadingUnderscores(left.escapedText) !== "exports")) {
	                        // to avoid cascading errors check assignability only if 'isReference' check succeeded and no errors were reported
	                        checkTypeAssignableTo(valueType, leftType, left, /*headMessage*/ undefined);
	                    }
	                }
	            }
	            function reportOperatorError() {
	                error(errorNode || operatorToken, ts.Diagnostics.Operator_0_cannot_be_applied_to_types_1_and_2, ts.tokenToString(operatorToken.kind), typeToString(leftType), typeToString(rightType));
	            }
	        }
	        function isYieldExpressionInClass(node) {
	            var current = node;
	            var parent = node.parent;
	            while (parent) {
	                if (ts.isFunctionLike(parent) && current === parent.body) {
	                    return false;
	                }
	                else if (ts.isClassLike(current)) {
	                    return true;
	                }
	                current = parent;
	                parent = parent.parent;
	            }
	            return false;
	        }
	        function checkYieldExpression(node) {
	            // Grammar checking
	            if (produceDiagnostics) {
	                if (!(node.flags & 4096 /* YieldContext */) || isYieldExpressionInClass(node)) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.A_yield_expression_is_only_allowed_in_a_generator_body);
	                }
	                if (isInParameterInitializerBeforeContainingFunction(node)) {
	                    error(node, ts.Diagnostics.yield_expressions_cannot_be_used_in_a_parameter_initializer);
	                }
	            }
	            var func = ts.getContainingFunction(node);
	            var functionFlags = func ? ts.getFunctionFlags(func) : 0 /* Normal */;
	            if (!(functionFlags & 1 /* Generator */)) {
	                // If the user's code is syntactically correct, the func should always have a star. After all, we are in a yield context.
	                return anyType;
	            }
	            if (node.asteriskToken) {
	                // Async generator functions prior to ESNext require the __await, __asyncDelegator,
	                // and __asyncValues helpers
	                if ((functionFlags & 3 /* AsyncGenerator */) === 3 /* AsyncGenerator */ &&
	                    languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(node, 26624 /* AsyncDelegatorIncludes */);
	                }
	                // Generator functions prior to ES2015 require the __values helper
	                if ((functionFlags & 3 /* AsyncGenerator */) === 1 /* Generator */ &&
	                    languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                    checkExternalEmitHelpers(node, 256 /* Values */);
	                }
	            }
	            var isAsync = (functionFlags & 2 /* Async */) !== 0;
	            var yieldedType = getYieldedTypeOfYieldExpression(node, isAsync);
	            // There is no point in doing an assignability check if the function
	            // has no explicit return type because the return type is directly computed
	            // from the yield expressions.
	            var returnType = ts.getEffectiveReturnTypeNode(func);
	            if (returnType) {
	                var signatureElementType = getIteratedTypeOfGenerator(getTypeFromTypeNode(returnType), isAsync) || anyType;
	                checkTypeAssignableTo(yieldedType, signatureElementType, node.expression || node, /*headMessage*/ undefined);
	            }
	            // Both yield and yield* expressions have type 'any'
	            return anyType;
	        }
	        function checkConditionalExpression(node, checkMode) {
	            checkExpression(node.condition);
	            var type1 = checkExpression(node.whenTrue, checkMode);
	            var type2 = checkExpression(node.whenFalse, checkMode);
	            return getUnionType([type1, type2], 2 /* Subtype */);
	        }
	        function checkTemplateExpression(node) {
	            // We just want to check each expressions, but we are unconcerned with
	            // the type of each expression, as any value may be coerced into a string.
	            // It is worth asking whether this is what we really want though.
	            // A place where we actually *are* concerned with the expressions' types are
	            // in tagged templates.
	            ts.forEach(node.templateSpans, function (templateSpan) {
	                if (maybeTypeOfKind(checkExpression(templateSpan.expression), 1536 /* ESSymbolLike */)) {
	                    error(templateSpan.expression, ts.Diagnostics.Type_0_cannot_be_converted_to_type_1, typeToString(esSymbolType), typeToString(stringType));
	                }
	            });
	            return stringType;
	        }
	        function getContextNode(node) {
	            if (node.kind === 262 /* JsxAttributes */) {
	                return node.parent.parent; // Needs to be the root JsxElement, so it encompasses the attributes _and_ the children (which are essentially part of the attributes)
	            }
	            return node;
	        }
	        function checkExpressionWithContextualType(node, contextualType, contextualMapper) {
	            var context = getContextNode(node);
	            var saveContextualType = context.contextualType;
	            var saveContextualMapper = context.contextualMapper;
	            context.contextualType = contextualType;
	            context.contextualMapper = contextualMapper;
	            var checkMode = contextualMapper === identityMapper ? 1 /* SkipContextSensitive */ :
	                contextualMapper ? 2 /* Inferential */ : 3 /* Contextual */;
	            var result = checkExpression(node, checkMode);
	            context.contextualType = saveContextualType;
	            context.contextualMapper = saveContextualMapper;
	            return result;
	        }
	        function checkExpressionCached(node, checkMode) {
	            var links = getNodeLinks(node);
	            if (!links.resolvedType) {
	                if (checkMode) {
	                    return checkExpression(node, checkMode);
	                }
	                // When computing a type that we're going to cache, we need to ignore any ongoing control flow
	                // analysis because variables may have transient types in indeterminable states. Moving flowLoopStart
	                // to the top of the stack ensures all transient types are computed from a known point.
	                var saveFlowLoopStart = flowLoopStart;
	                flowLoopStart = flowLoopCount;
	                links.resolvedType = checkExpression(node, checkMode);
	                flowLoopStart = saveFlowLoopStart;
	            }
	            return links.resolvedType;
	        }
	        function isTypeAssertion(node) {
	            node = ts.skipParentheses(node);
	            return node.kind === 189 /* TypeAssertionExpression */ || node.kind === 207 /* AsExpression */;
	        }
	        function checkDeclarationInitializer(declaration) {
	            var inJs = ts.isInJavaScriptFile(declaration);
	            var initializer = inJs && ts.getDeclaredJavascriptInitializer(declaration) || declaration.initializer;
	            var type = getTypeOfExpression(initializer, /*cache*/ true);
	            var widened = ts.getCombinedNodeFlags(declaration) & 2 /* Const */ ||
	                (ts.getCombinedModifierFlags(declaration) & 64 /* Readonly */ && !ts.isParameterPropertyDeclaration(declaration)) ||
	                isTypeAssertion(initializer) ? type : getWidenedLiteralType(type);
	            if (inJs) {
	                if (widened.flags & 12288 /* Nullable */) {
	                    if (noImplicitAny) {
	                        reportImplicitAnyError(declaration, anyType);
	                    }
	                    return anyType;
	                }
	                else if (isEmptyArrayLiteralType(widened)) {
	                    if (noImplicitAny) {
	                        reportImplicitAnyError(declaration, anyArrayType);
	                    }
	                    return anyArrayType;
	                }
	            }
	            return widened;
	        }
	        function isLiteralOfContextualType(candidateType, contextualType) {
	            if (contextualType) {
	                if (contextualType.flags & 393216 /* UnionOrIntersection */) {
	                    var types = contextualType.types;
	                    return ts.some(types, function (t) { return isLiteralOfContextualType(candidateType, t); });
	                }
	                if (contextualType.flags & 7372800 /* InstantiableNonPrimitive */) {
	                    // If the contextual type is a type variable constrained to a primitive type, consider
	                    // this a literal context for literals of that primitive type. For example, given a
	                    // type parameter 'T extends string', infer string literal types for T.
	                    var constraint = getBaseConstraintOfType(contextualType) || emptyObjectType;
	                    return maybeTypeOfKind(constraint, 2 /* String */) && maybeTypeOfKind(candidateType, 32 /* StringLiteral */) ||
	                        maybeTypeOfKind(constraint, 4 /* Number */) && maybeTypeOfKind(candidateType, 64 /* NumberLiteral */) ||
	                        maybeTypeOfKind(constraint, 512 /* ESSymbol */) && maybeTypeOfKind(candidateType, 1024 /* UniqueESSymbol */) ||
	                        isLiteralOfContextualType(candidateType, constraint);
	                }
	                // If the contextual type is a literal of a particular primitive type, we consider this a
	                // literal context for all literals of that primitive type.
	                return contextualType.flags & (32 /* StringLiteral */ | 524288 /* Index */) && maybeTypeOfKind(candidateType, 32 /* StringLiteral */) ||
	                    contextualType.flags & 64 /* NumberLiteral */ && maybeTypeOfKind(candidateType, 64 /* NumberLiteral */) ||
	                    contextualType.flags & 128 /* BooleanLiteral */ && maybeTypeOfKind(candidateType, 128 /* BooleanLiteral */) ||
	                    contextualType.flags & 1024 /* UniqueESSymbol */ && maybeTypeOfKind(candidateType, 1024 /* UniqueESSymbol */);
	            }
	            return false;
	        }
	        function checkExpressionForMutableLocation(node, checkMode, contextualType) {
	            if (arguments.length === 2) {
	                contextualType = getContextualType(node);
	            }
	            var type = checkExpression(node, checkMode);
	            return isTypeAssertion(node) ? type :
	                getWidenedLiteralLikeTypeForContextualType(type, contextualType);
	        }
	        function checkPropertyAssignment(node, checkMode) {
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	            }
	            return checkExpressionForMutableLocation(node.initializer, checkMode);
	        }
	        function checkObjectLiteralMethod(node, checkMode) {
	            // Grammar checking
	            checkGrammarMethod(node);
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	            }
	            var uninstantiatedType = checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
	            return instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
	        }
	        function instantiateTypeWithSingleGenericCallSignature(node, type, checkMode) {
	            if (checkMode === 2 /* Inferential */) {
	                var signature = getSingleCallSignature(type);
	                if (signature && signature.typeParameters) {
	                    var contextualType = getApparentTypeOfContextualType(node);
	                    if (contextualType) {
	                        var contextualSignature = getSingleCallSignature(getNonNullableType(contextualType));
	                        if (contextualSignature && !contextualSignature.typeParameters) {
	                            return getOrCreateTypeFromSignature(instantiateSignatureInContextOf(signature, contextualSignature, getContextualMapper(node)));
	                        }
	                    }
	                }
	            }
	            return type;
	        }
	        /**
	         * Returns the type of an expression. Unlike checkExpression, this function is simply concerned
	         * with computing the type and may not fully check all contained sub-expressions for errors.
	         * A cache argument of true indicates that if the function performs a full type check, it is ok
	         * to cache the result.
	         */
	        function getTypeOfExpression(node, cache) {
	            // Optimize for the common case of a call to a function with a single non-generic call
	            // signature where we can just fetch the return type without checking the arguments.
	            if (node.kind === 186 /* CallExpression */ && node.expression.kind !== 97 /* SuperKeyword */ && !ts.isRequireCall(node, /*checkArgumentIsStringLiteralLike*/ true) && !isSymbolOrSymbolForCall(node)) {
	                var funcType = checkNonNullExpression(node.expression);
	                var signature = getSingleCallSignature(funcType);
	                if (signature && !signature.typeParameters) {
	                    return getReturnTypeOfSignature(signature);
	                }
	            }
	            // Otherwise simply call checkExpression. Ideally, the entire family of checkXXX functions
	            // should have a parameter that indicates whether full error checking is required such that
	            // we can perform the optimizations locally.
	            return cache ? checkExpressionCached(node) : checkExpression(node);
	        }
	        /**
	         * Returns the type of an expression. Unlike checkExpression, this function is simply concerned
	         * with computing the type and may not fully check all contained sub-expressions for errors.
	         * It is intended for uses where you know there is no contextual type,
	         * and requesting the contextual type might cause a circularity or other bad behaviour.
	         * It sets the contextual type of the node to any before calling getTypeOfExpression.
	         */
	        function getContextFreeTypeOfExpression(node) {
	            var saveContextualType = node.contextualType;
	            node.contextualType = anyType;
	            var type = getTypeOfExpression(node);
	            node.contextualType = saveContextualType;
	            return type;
	        }
	        function checkExpresionNoReturn(node) {
	            checkExpression(node);
	        }
	        // Checks an expression and returns its type. The contextualMapper parameter serves two purposes: When
	        // contextualMapper is not undefined and not equal to the identityMapper function object it indicates that the
	        // expression is being inferentially typed (section 4.15.2 in spec) and provides the type mapper to use in
	        // conjunction with the generic contextual type. When contextualMapper is equal to the identityMapper function
	        // object, it serves as an indicator that all contained function and arrow expressions should be considered to
	        // have the wildcard function type; this form of type check is used during overload resolution to exclude
	        // contextually typed function and arrow expressions in the initial phase.
	        function checkExpression(node, checkMode) {
	            var type;
	            if (node.kind === 145 /* QualifiedName */) {
	                type = checkQualifiedName(node);
	            }
	            else {
	                var uninstantiatedType = checkExpressionWorker(node, checkMode);
	                type = instantiateTypeWithSingleGenericCallSignature(node, uninstantiatedType, checkMode);
	            }
	            if (isConstEnumObjectType(type)) {
	                // enum object type for const enums are only permitted in:
	                // - 'left' in property access
	                // - 'object' in indexed access
	                // - target in rhs of import statement
	                var ok = (node.parent.kind === 184 /* PropertyAccessExpression */ && node.parent.expression === node) ||
	                    (node.parent.kind === 185 /* ElementAccessExpression */ && node.parent.expression === node) ||
	                    ((node.kind === 71 /* Identifier */ || node.kind === 145 /* QualifiedName */) && isInRightSideOfImportOrExportAssignment(node) ||
	                        (node.parent.kind === 164 /* TypeQuery */ && node.parent.exprName === node));
	                if (!ok) {
	                    error(node, ts.Diagnostics.const_enums_can_only_be_used_in_property_or_index_access_expressions_or_the_right_hand_side_of_an_import_declaration_or_export_assignment_or_type_query);
	                }
	            }
	            return type;
	        }
	        function checkParenthesizedExpression(node, checkMode) {
	            var tag = ts.isInJavaScriptFile(node) ? ts.getJSDocTypeTag(node) : undefined;
	            if (tag) {
	                return checkAssertionWorker(tag, tag.typeExpression.type, node.expression, checkMode);
	            }
	            return checkExpression(node.expression, checkMode);
	        }
	        function checkExpressionWorker(node, checkMode) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return checkIdentifier(node);
	                case 99 /* ThisKeyword */:
	                    return checkThisExpression(node);
	                case 97 /* SuperKeyword */:
	                    return checkSuperExpression(node);
	                case 95 /* NullKeyword */:
	                    return nullWideningType;
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 9 /* StringLiteral */:
	                    return getFreshTypeOfLiteralType(getLiteralType(node.text));
	                case 8 /* NumericLiteral */:
	                    checkGrammarNumericLiteral(node);
	                    return getFreshTypeOfLiteralType(getLiteralType(+node.text));
	                case 101 /* TrueKeyword */:
	                    return trueType;
	                case 86 /* FalseKeyword */:
	                    return falseType;
	                case 201 /* TemplateExpression */:
	                    return checkTemplateExpression(node);
	                case 12 /* RegularExpressionLiteral */:
	                    return globalRegExpType;
	                case 182 /* ArrayLiteralExpression */:
	                    return checkArrayLiteral(node, checkMode);
	                case 183 /* ObjectLiteralExpression */:
	                    return checkObjectLiteral(node, checkMode);
	                case 184 /* PropertyAccessExpression */:
	                    return checkPropertyAccessExpression(node);
	                case 185 /* ElementAccessExpression */:
	                    return checkIndexedAccess(node);
	                case 186 /* CallExpression */:
	                    if (node.expression.kind === 91 /* ImportKeyword */) {
	                        return checkImportCallExpression(node);
	                    }
	                /* falls through */
	                case 187 /* NewExpression */:
	                    return checkCallExpression(node);
	                case 188 /* TaggedTemplateExpression */:
	                    return checkTaggedTemplateExpression(node);
	                case 190 /* ParenthesizedExpression */:
	                    return checkParenthesizedExpression(node, checkMode);
	                case 204 /* ClassExpression */:
	                    return checkClassExpression(node);
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return checkFunctionExpressionOrObjectLiteralMethod(node, checkMode);
	                case 194 /* TypeOfExpression */:
	                    return checkTypeOfExpression(node);
	                case 189 /* TypeAssertionExpression */:
	                case 207 /* AsExpression */:
	                    return checkAssertion(node);
	                case 208 /* NonNullExpression */:
	                    return checkNonNullAssertion(node);
	                case 209 /* MetaProperty */:
	                    return checkMetaProperty(node);
	                case 193 /* DeleteExpression */:
	                    return checkDeleteExpression(node);
	                case 195 /* VoidExpression */:
	                    return checkVoidExpression(node);
	                case 196 /* AwaitExpression */:
	                    return checkAwaitExpression(node);
	                case 197 /* PrefixUnaryExpression */:
	                    return checkPrefixUnaryExpression(node);
	                case 198 /* PostfixUnaryExpression */:
	                    return checkPostfixUnaryExpression(node);
	                case 199 /* BinaryExpression */:
	                    return checkBinaryExpression(node, checkMode);
	                case 200 /* ConditionalExpression */:
	                    return checkConditionalExpression(node, checkMode);
	                case 203 /* SpreadElement */:
	                    return checkSpreadExpression(node, checkMode);
	                case 205 /* OmittedExpression */:
	                    return undefinedWideningType;
	                case 202 /* YieldExpression */:
	                    return checkYieldExpression(node);
	                case 264 /* JsxExpression */:
	                    return checkJsxExpression(node, checkMode);
	                case 254 /* JsxElement */:
	                    return checkJsxElement(node, checkMode);
	                case 255 /* JsxSelfClosingElement */:
	                    return checkJsxSelfClosingElement(node, checkMode);
	                case 258 /* JsxFragment */:
	                    return checkJsxFragment(node, checkMode);
	                case 262 /* JsxAttributes */:
	                    return checkJsxAttributes(node, checkMode);
	                case 256 /* JsxOpeningElement */:
	                    ts.Debug.fail("Shouldn't ever directly check a JsxOpeningElement");
	            }
	            return unknownType;
	        }
	        // DECLARATION AND STATEMENT TYPE CHECKING
	        function checkTypeParameter(node) {
	            // Grammar Checking
	            if (node.expression) {
	                grammarErrorOnFirstToken(node.expression, ts.Diagnostics.Type_expected);
	            }
	            checkSourceElement(node.constraint);
	            checkSourceElement(node.default);
	            var typeParameter = getDeclaredTypeOfTypeParameter(getSymbolOfNode(node));
	            if (!hasNonCircularBaseConstraint(typeParameter)) {
	                error(node.constraint, ts.Diagnostics.Type_parameter_0_has_a_circular_constraint, typeToString(typeParameter));
	            }
	            if (!hasNonCircularTypeParameterDefault(typeParameter)) {
	                error(node.default, ts.Diagnostics.Type_parameter_0_has_a_circular_default, typeToString(typeParameter));
	            }
	            var constraintType = getConstraintOfTypeParameter(typeParameter);
	            var defaultType = getDefaultFromTypeParameter(typeParameter);
	            if (constraintType && defaultType) {
	                checkTypeAssignableTo(defaultType, getTypeWithThisArgument(constraintType, defaultType), node.default, ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
	            }
	            if (produceDiagnostics) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Type_parameter_name_cannot_be_0);
	            }
	        }
	        function checkParameter(node) {
	            // Grammar checking
	            // It is a SyntaxError if the Identifier "eval" or the Identifier "arguments" occurs as the
	            // Identifier in a PropertySetParameterList of a PropertyAssignment that is contained in strict code
	            // or if its FunctionBody is strict code(11.1.5).
	            checkGrammarDecoratorsAndModifiers(node);
	            checkVariableLikeDeclaration(node);
	            var func = ts.getContainingFunction(node);
	            if (ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	                if (!(func.kind === 154 /* Constructor */ && ts.nodeIsPresent(func.body))) {
	                    error(node, ts.Diagnostics.A_parameter_property_is_only_allowed_in_a_constructor_implementation);
	                }
	            }
	            if (node.questionToken && ts.isBindingPattern(node.name) && func.body) {
	                error(node, ts.Diagnostics.A_binding_pattern_parameter_cannot_be_optional_in_an_implementation_signature);
	            }
	            if (node.name && ts.isIdentifier(node.name) && (node.name.escapedText === "this" || node.name.escapedText === "new")) {
	                if (func.parameters.indexOf(node) !== 0) {
	                    error(node, ts.Diagnostics.A_0_parameter_must_be_the_first_parameter, node.name.escapedText);
	                }
	                if (func.kind === 154 /* Constructor */ || func.kind === 158 /* ConstructSignature */ || func.kind === 163 /* ConstructorType */) {
	                    error(node, ts.Diagnostics.A_constructor_cannot_have_a_this_parameter);
	                }
	            }
	            // Only check rest parameter type if it's not a binding pattern. Since binding patterns are
	            // not allowed in a rest parameter, we already have an error from checkGrammarParameterList.
	            if (node.dotDotDotToken && !ts.isBindingPattern(node.name) && !isArrayType(getTypeOfSymbol(node.symbol))) {
	                error(node, ts.Diagnostics.A_rest_parameter_must_be_of_an_array_type);
	            }
	        }
	        function getTypePredicateParameterIndex(parameterList, parameter) {
	            if (parameterList) {
	                for (var i = 0; i < parameterList.length; i++) {
	                    var param = parameterList[i];
	                    if (param.name.kind === 71 /* Identifier */ && param.name.escapedText === parameter.escapedText) {
	                        return i;
	                    }
	                }
	            }
	            return -1;
	        }
	        function checkTypePredicate(node) {
	            var parent = getTypePredicateParent(node);
	            if (!parent) {
	                // The parent must not be valid.
	                error(node, ts.Diagnostics.A_type_predicate_is_only_allowed_in_return_type_position_for_functions_and_methods);
	                return;
	            }
	            var typePredicate = getTypePredicateOfSignature(getSignatureFromDeclaration(parent));
	            if (!typePredicate) {
	                return;
	            }
	            checkSourceElement(node.type);
	            var parameterName = node.parameterName;
	            if (ts.isThisTypePredicate(typePredicate)) {
	                getTypeFromThisTypeNode(parameterName);
	            }
	            else {
	                if (typePredicate.parameterIndex >= 0) {
	                    if (parent.parameters[typePredicate.parameterIndex].dotDotDotToken) {
	                        error(parameterName, ts.Diagnostics.A_type_predicate_cannot_reference_a_rest_parameter);
	                    }
	                    else {
	                        var leadingError = function () { return ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.A_type_predicate_s_type_must_be_assignable_to_its_parameter_s_type); };
	                        checkTypeAssignableTo(typePredicate.type, getTypeOfNode(parent.parameters[typePredicate.parameterIndex]), node.type, 
	                        /*headMessage*/ undefined, leadingError);
	                    }
	                }
	                else if (parameterName) {
	                    var hasReportedError = false;
	                    for (var _i = 0, _a = parent.parameters; _i < _a.length; _i++) {
	                        var name = _a[_i].name;
	                        if (ts.isBindingPattern(name) &&
	                            checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, parameterName, typePredicate.parameterName)) {
	                            hasReportedError = true;
	                            break;
	                        }
	                    }
	                    if (!hasReportedError) {
	                        error(node.parameterName, ts.Diagnostics.Cannot_find_parameter_0, typePredicate.parameterName);
	                    }
	                }
	            }
	        }
	        function getTypePredicateParent(node) {
	            switch (node.parent.kind) {
	                case 192 /* ArrowFunction */:
	                case 157 /* CallSignature */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 162 /* FunctionType */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    var parent = node.parent;
	                    if (node === parent.type) {
	                        return parent;
	                    }
	            }
	        }
	        function checkIfTypePredicateVariableIsDeclaredInBindingPattern(pattern, predicateVariableNode, predicateVariableName) {
	            for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (ts.isOmittedExpression(element)) {
	                    continue;
	                }
	                var name = element.name;
	                if (name.kind === 71 /* Identifier */ && name.escapedText === predicateVariableName) {
	                    error(predicateVariableNode, ts.Diagnostics.A_type_predicate_cannot_reference_element_0_in_a_binding_pattern, predicateVariableName);
	                    return true;
	                }
	                else if (name.kind === 180 /* ArrayBindingPattern */ || name.kind === 179 /* ObjectBindingPattern */) {
	                    if (checkIfTypePredicateVariableIsDeclaredInBindingPattern(name, predicateVariableNode, predicateVariableName)) {
	                        return true;
	                    }
	                }
	            }
	        }
	        function checkSignatureDeclaration(node) {
	            // Grammar checking
	            if (node.kind === 159 /* IndexSignature */) {
	                checkGrammarIndexSignature(node);
	            }
	            // TODO (yuisu): Remove this check in else-if when SyntaxKind.Construct is moved and ambient context is handled
	            else if (node.kind === 162 /* FunctionType */ || node.kind === 233 /* FunctionDeclaration */ || node.kind === 163 /* ConstructorType */ ||
	                node.kind === 157 /* CallSignature */ || node.kind === 154 /* Constructor */ ||
	                node.kind === 158 /* ConstructSignature */) {
	                checkGrammarFunctionLikeDeclaration(node);
	            }
	            var functionFlags = ts.getFunctionFlags(node);
	            if (!(functionFlags & 4 /* Invalid */)) {
	                // Async generators prior to ESNext require the __await and __asyncGenerator helpers
	                if ((functionFlags & 3 /* AsyncGenerator */) === 3 /* AsyncGenerator */ && languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(node, 6144 /* AsyncGeneratorIncludes */);
	                }
	                // Async functions prior to ES2017 require the __awaiter helper
	                if ((functionFlags & 3 /* AsyncGenerator */) === 2 /* Async */ && languageVersion < 4 /* ES2017 */) {
	                    checkExternalEmitHelpers(node, 64 /* Awaiter */);
	                }
	                // Generator functions, Async functions, and Async Generator functions prior to
	                // ES2015 require the __generator helper
	                if ((functionFlags & 3 /* AsyncGenerator */) !== 0 /* Normal */ && languageVersion < 2 /* ES2015 */) {
	                    checkExternalEmitHelpers(node, 128 /* Generator */);
	                }
	            }
	            checkTypeParameters(node.typeParameters);
	            ts.forEach(node.parameters, checkParameter);
	            // TODO(rbuckton): Should we start checking JSDoc types?
	            if (node.type) {
	                checkSourceElement(node.type);
	            }
	            if (produceDiagnostics) {
	                checkCollisionWithArgumentsInGeneratedCode(node);
	                var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	                if (noImplicitAny && !returnTypeNode) {
	                    switch (node.kind) {
	                        case 158 /* ConstructSignature */:
	                            error(node, ts.Diagnostics.Construct_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
	                            break;
	                        case 157 /* CallSignature */:
	                            error(node, ts.Diagnostics.Call_signature_which_lacks_return_type_annotation_implicitly_has_an_any_return_type);
	                            break;
	                    }
	                }
	                if (returnTypeNode) {
	                    var functionFlags_1 = ts.getFunctionFlags(node);
	                    if ((functionFlags_1 & (4 /* Invalid */ | 1 /* Generator */)) === 1 /* Generator */) {
	                        var returnType = getTypeFromTypeNode(returnTypeNode);
	                        if (returnType === voidType) {
	                            error(returnTypeNode, ts.Diagnostics.A_generator_cannot_have_a_void_type_annotation);
	                        }
	                        else {
	                            var generatorElementType = getIteratedTypeOfGenerator(returnType, (functionFlags_1 & 2 /* Async */) !== 0) || anyType;
	                            var iterableIteratorInstantiation = functionFlags_1 & 2 /* Async */
	                                ? createAsyncIterableIteratorType(generatorElementType) // AsyncGenerator function
	                                : createIterableIteratorType(generatorElementType); // Generator function
	                            // Naively, one could check that IterableIterator<any> is assignable to the return type annotation.
	                            // However, that would not catch the error in the following case.
	                            //
	                            //    interface BadGenerator extends Iterable<number>, Iterator<string> { }
	                            //    function* g(): BadGenerator { } // Iterable and Iterator have different types!
	                            //
	                            checkTypeAssignableTo(iterableIteratorInstantiation, returnType, returnTypeNode);
	                        }
	                    }
	                    else if ((functionFlags_1 & 3 /* AsyncGenerator */) === 2 /* Async */) {
	                        checkAsyncFunctionReturnType(node);
	                    }
	                }
	                if (node.kind !== 159 /* IndexSignature */ && node.kind !== 283 /* JSDocFunctionType */) {
	                    registerForUnusedIdentifiersCheck(node);
	                }
	            }
	        }
	        function checkClassForDuplicateDeclarations(node) {
	            var Declaration;
	            (function (Declaration) {
	                Declaration[Declaration["Getter"] = 1] = "Getter";
	                Declaration[Declaration["Setter"] = 2] = "Setter";
	                Declaration[Declaration["Method"] = 4] = "Method";
	                Declaration[Declaration["Property"] = 3] = "Property";
	            })(Declaration || (Declaration = {}));
	            var instanceNames = ts.createUnderscoreEscapedMap();
	            var staticNames = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (member.kind === 154 /* Constructor */) {
	                    for (var _b = 0, _c = member.parameters; _b < _c.length; _b++) {
	                        var param = _c[_b];
	                        if (ts.isParameterPropertyDeclaration(param) && !ts.isBindingPattern(param.name)) {
	                            addName(instanceNames, param.name, param.name.escapedText, 3 /* Property */);
	                        }
	                    }
	                }
	                else {
	                    var isStatic = ts.hasModifier(member, 32 /* Static */);
	                    var names = isStatic ? staticNames : instanceNames;
	                    var memberName = member.name && ts.getPropertyNameForPropertyNameNode(member.name);
	                    if (memberName) {
	                        switch (member.kind) {
	                            case 155 /* GetAccessor */:
	                                addName(names, member.name, memberName, 1 /* Getter */);
	                                break;
	                            case 156 /* SetAccessor */:
	                                addName(names, member.name, memberName, 2 /* Setter */);
	                                break;
	                            case 151 /* PropertyDeclaration */:
	                                addName(names, member.name, memberName, 3 /* Property */);
	                                break;
	                            case 153 /* MethodDeclaration */:
	                                addName(names, member.name, memberName, 4 /* Method */);
	                                break;
	                        }
	                    }
	                }
	            }
	            function addName(names, location, name, meaning) {
	                var prev = names.get(name);
	                if (prev) {
	                    if (prev & 4 /* Method */) {
	                        if (meaning !== 4 /* Method */) {
	                            error(location, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(location));
	                        }
	                    }
	                    else if (prev & meaning) {
	                        error(location, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(location));
	                    }
	                    else {
	                        names.set(name, prev | meaning);
	                    }
	                }
	                else {
	                    names.set(name, meaning);
	                }
	            }
	        }
	        /**
	         * Static members being set on a constructor function may conflict with built-in properties
	         * of Function. Esp. in ECMAScript 5 there are non-configurable and non-writable
	         * built-in properties. This check issues a transpile error when a class has a static
	         * member with the same name as a non-writable built-in property.
	         *
	         * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.3.3
	         * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.3.5
	         * @see http://www.ecma-international.org/ecma-262/6.0/#sec-properties-of-the-function-constructor
	         * @see http://www.ecma-international.org/ecma-262/6.0/#sec-function-instances
	         */
	        function checkClassForStaticPropertyNameConflicts(node) {
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                var memberNameNode = member.name;
	                var isStatic = ts.hasModifier(member, 32 /* Static */);
	                if (isStatic && memberNameNode) {
	                    var memberName = ts.getPropertyNameForPropertyNameNode(memberNameNode);
	                    switch (memberName) {
	                        case "name":
	                        case "length":
	                        case "caller":
	                        case "arguments":
	                        case "prototype":
	                            var message = ts.Diagnostics.Static_property_0_conflicts_with_built_in_property_Function_0_of_constructor_function_1;
	                            var className = getNameOfSymbolAsWritten(getSymbolOfNode(node));
	                            error(memberNameNode, message, memberName, className);
	                            break;
	                    }
	                }
	            }
	        }
	        function checkObjectTypeForDuplicateDeclarations(node) {
	            var names = ts.createMap();
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (member.kind === 150 /* PropertySignature */) {
	                    var memberName = void 0;
	                    switch (member.name.kind) {
	                        case 9 /* StringLiteral */:
	                        case 8 /* NumericLiteral */:
	                            memberName = member.name.text;
	                            break;
	                        case 71 /* Identifier */:
	                            memberName = ts.idText(member.name);
	                            break;
	                        default:
	                            continue;
	                    }
	                    if (names.get(memberName)) {
	                        error(ts.getNameOfDeclaration(member.symbol.valueDeclaration), ts.Diagnostics.Duplicate_identifier_0, memberName);
	                        error(member.name, ts.Diagnostics.Duplicate_identifier_0, memberName);
	                    }
	                    else {
	                        names.set(memberName, true);
	                    }
	                }
	            }
	        }
	        function checkTypeForDuplicateIndexSignatures(node) {
	            if (node.kind === 235 /* InterfaceDeclaration */) {
	                var nodeSymbol = getSymbolOfNode(node);
	                // in case of merging interface declaration it is possible that we'll enter this check procedure several times for every declaration
	                // to prevent this run check only for the first declaration of a given kind
	                if (nodeSymbol.declarations.length > 0 && nodeSymbol.declarations[0] !== node) {
	                    return;
	                }
	            }
	            // TypeScript 1.0 spec (April 2014)
	            // 3.7.4: An object type can contain at most one string index signature and one numeric index signature.
	            // 8.5: A class declaration can have at most one string index member declaration and one numeric index member declaration
	            var indexSymbol = getIndexSymbol(getSymbolOfNode(node));
	            if (indexSymbol) {
	                var seenNumericIndexer = false;
	                var seenStringIndexer = false;
	                for (var _i = 0, _a = indexSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var declaration = decl;
	                    if (declaration.parameters.length === 1 && declaration.parameters[0].type) {
	                        switch (declaration.parameters[0].type.kind) {
	                            case 137 /* StringKeyword */:
	                                if (!seenStringIndexer) {
	                                    seenStringIndexer = true;
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Duplicate_string_index_signature);
	                                }
	                                break;
	                            case 134 /* NumberKeyword */:
	                                if (!seenNumericIndexer) {
	                                    seenNumericIndexer = true;
	                                }
	                                else {
	                                    error(declaration, ts.Diagnostics.Duplicate_number_index_signature);
	                                }
	                                break;
	                        }
	                    }
	                }
	            }
	        }
	        function checkPropertyDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && !checkGrammarProperty(node))
	                checkGrammarComputedPropertyName(node.name);
	            checkVariableLikeDeclaration(node);
	        }
	        function checkMethodDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarMethod(node))
	                checkGrammarComputedPropertyName(node.name);
	            // Grammar checking for modifiers is done inside the function checkGrammarFunctionLikeDeclaration
	            checkFunctionOrMethodDeclaration(node);
	            // Abstract methods cannot have an implementation.
	            // Extra checks are to avoid reporting multiple errors relating to the "abstractness" of the node.
	            if (ts.hasModifier(node, 128 /* Abstract */) && node.kind === 153 /* MethodDeclaration */ && node.body) {
	                error(node, ts.Diagnostics.Method_0_cannot_have_an_implementation_because_it_is_marked_abstract, ts.declarationNameToString(node.name));
	            }
	        }
	        function checkConstructorDeclaration(node) {
	            // Grammar check on signature of constructor and modifier of the constructor is done in checkSignatureDeclaration function.
	            checkSignatureDeclaration(node);
	            // Grammar check for checking only related to constructorDeclaration
	            if (!checkGrammarConstructorTypeParameters(node))
	                checkGrammarConstructorTypeAnnotation(node);
	            checkSourceElement(node.body);
	            var symbol = getSymbolOfNode(node);
	            var firstDeclaration = ts.getDeclarationOfKind(symbol, node.kind);
	            // Only type check the symbol once
	            if (node === firstDeclaration) {
	                checkFunctionOrConstructorSymbol(symbol);
	            }
	            // exit early in the case of signature - super checks are not relevant to them
	            if (ts.nodeIsMissing(node.body)) {
	                return;
	            }
	            if (!produceDiagnostics) {
	                return;
	            }
	            function isInstancePropertyWithInitializer(n) {
	                return n.kind === 151 /* PropertyDeclaration */ &&
	                    !ts.hasModifier(n, 32 /* Static */) &&
	                    !!n.initializer;
	            }
	            // TS 1.0 spec (April 2014): 8.3.2
	            // Constructors of classes with no extends clause may not contain super calls, whereas
	            // constructors of derived classes must contain at least one super call somewhere in their function body.
	            var containingClassDecl = node.parent;
	            if (ts.getClassExtendsHeritageClauseElement(containingClassDecl)) {
	                captureLexicalThis(node.parent, containingClassDecl);
	                var classExtendsNull = classDeclarationExtendsNull(containingClassDecl);
	                var superCall = getSuperCallInConstructor(node);
	                if (superCall) {
	                    if (classExtendsNull) {
	                        error(superCall, ts.Diagnostics.A_constructor_cannot_contain_a_super_call_when_its_class_extends_null);
	                    }
	                    // The first statement in the body of a constructor (excluding prologue directives) must be a super call
	                    // if both of the following are true:
	                    // - The containing class is a derived class.
	                    // - The constructor declares parameter properties
	                    //   or the containing class declares instance member variables with initializers.
	                    var superCallShouldBeFirst = ts.some(node.parent.members, isInstancePropertyWithInitializer) ||
	                        ts.some(node.parameters, function (p) { return ts.hasModifier(p, 92 /* ParameterPropertyModifier */); });
	                    // Skip past any prologue directives to find the first statement
	                    // to ensure that it was a super call.
	                    if (superCallShouldBeFirst) {
	                        var statements = node.body.statements;
	                        var superCallStatement = void 0;
	                        for (var _i = 0, statements_2 = statements; _i < statements_2.length; _i++) {
	                            var statement = statements_2[_i];
	                            if (statement.kind === 215 /* ExpressionStatement */ && ts.isSuperCall(statement.expression)) {
	                                superCallStatement = statement;
	                                break;
	                            }
	                            if (!ts.isPrologueDirective(statement)) {
	                                break;
	                            }
	                        }
	                        if (!superCallStatement) {
	                            error(node, ts.Diagnostics.A_super_call_must_be_the_first_statement_in_the_constructor_when_a_class_contains_initialized_properties_or_has_parameter_properties);
	                        }
	                    }
	                }
	                else if (!classExtendsNull) {
	                    error(node, ts.Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call);
	                }
	            }
	        }
	        function checkAccessorDeclaration(node) {
	            if (produceDiagnostics) {
	                // Grammar checking accessors
	                if (!checkGrammarFunctionLikeDeclaration(node) && !checkGrammarAccessor(node))
	                    checkGrammarComputedPropertyName(node.name);
	                checkDecorators(node);
	                checkSignatureDeclaration(node);
	                if (node.kind === 155 /* GetAccessor */) {
	                    if (!(node.flags & 4194304 /* Ambient */) && ts.nodeIsPresent(node.body) && (node.flags & 128 /* HasImplicitReturn */)) {
	                        if (!(node.flags & 256 /* HasExplicitReturn */)) {
	                            error(node.name, ts.Diagnostics.A_get_accessor_must_return_a_value);
	                        }
	                    }
	                }
	                // Do not use hasDynamicName here, because that returns false for well known symbols.
	                // We want to perform checkComputedPropertyName for all computed properties, including
	                // well known symbols.
	                if (node.name.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(node.name);
	                }
	                if (!hasNonBindableDynamicName(node)) {
	                    // TypeScript 1.0 spec (April 2014): 8.4.3
	                    // Accessors for the same member name must specify the same accessibility.
	                    var otherKind = node.kind === 155 /* GetAccessor */ ? 156 /* SetAccessor */ : 155 /* GetAccessor */;
	                    var otherAccessor = ts.getDeclarationOfKind(getSymbolOfNode(node), otherKind);
	                    if (otherAccessor) {
	                        var nodeFlags = ts.getModifierFlags(node);
	                        var otherFlags = ts.getModifierFlags(otherAccessor);
	                        if ((nodeFlags & 28 /* AccessibilityModifier */) !== (otherFlags & 28 /* AccessibilityModifier */)) {
	                            error(node.name, ts.Diagnostics.Getter_and_setter_accessors_do_not_agree_in_visibility);
	                        }
	                        if ((nodeFlags & 128 /* Abstract */) !== (otherFlags & 128 /* Abstract */)) {
	                            error(node.name, ts.Diagnostics.Accessors_must_both_be_abstract_or_non_abstract);
	                        }
	                        // TypeScript 1.0 spec (April 2014): 4.5
	                        // If both accessors include type annotations, the specified types must be identical.
	                        checkAccessorDeclarationTypesIdentical(node, otherAccessor, getAnnotatedAccessorType, ts.Diagnostics.get_and_set_accessor_must_have_the_same_type);
	                        checkAccessorDeclarationTypesIdentical(node, otherAccessor, getThisTypeOfDeclaration, ts.Diagnostics.get_and_set_accessor_must_have_the_same_this_type);
	                    }
	                }
	                var returnType = getTypeOfAccessors(getSymbolOfNode(node));
	                if (node.kind === 155 /* GetAccessor */) {
	                    checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnType);
	                }
	            }
	            checkSourceElement(node.body);
	        }
	        function checkAccessorDeclarationTypesIdentical(first, second, getAnnotatedType, message) {
	            var firstType = getAnnotatedType(first);
	            var secondType = getAnnotatedType(second);
	            if (firstType && secondType && !isTypeIdenticalTo(firstType, secondType)) {
	                error(first, message);
	            }
	        }
	        function checkMissingDeclaration(node) {
	            checkDecorators(node);
	        }
	        function getEffectiveTypeArguments(node, typeParameters) {
	            return fillMissingTypeArguments(ts.map(node.typeArguments, getTypeFromTypeNode), typeParameters, getMinTypeArgumentCount(typeParameters), ts.isInJavaScriptFile(node));
	        }
	        function checkTypeArgumentConstraints(node, typeParameters) {
	            var typeArguments;
	            var mapper;
	            var result = true;
	            for (var i = 0; i < typeParameters.length; i++) {
	                var constraint = getConstraintOfTypeParameter(typeParameters[i]);
	                if (constraint) {
	                    if (!typeArguments) {
	                        typeArguments = getEffectiveTypeArguments(node, typeParameters);
	                        mapper = createTypeMapper(typeParameters, typeArguments);
	                    }
	                    result = result && checkTypeAssignableTo(typeArguments[i], instantiateType(constraint, mapper), node.typeArguments[i], ts.Diagnostics.Type_0_does_not_satisfy_the_constraint_1);
	                }
	            }
	            return result;
	        }
	        function getTypeParametersForTypeReference(node) {
	            var type = getTypeFromTypeReference(node);
	            if (type !== unknownType) {
	                var symbol = getNodeLinks(node).resolvedSymbol;
	                if (symbol) {
	                    return symbol.flags & 524288 /* TypeAlias */ && getSymbolLinks(symbol).typeParameters ||
	                        (ts.getObjectFlags(type) & 4 /* Reference */ ? type.target.localTypeParameters : undefined);
	                }
	            }
	            return undefined;
	        }
	        function checkTypeReferenceNode(node) {
	            checkGrammarTypeArguments(node, node.typeArguments);
	            if (node.kind === 161 /* TypeReference */ && node.typeName.jsdocDotPos !== undefined && !ts.isInJavaScriptFile(node) && !ts.isInJSDoc(node)) {
	                grammarErrorAtPos(node, node.typeName.jsdocDotPos, 1, ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
	            }
	            var type = getTypeFromTypeReference(node);
	            if (type !== unknownType) {
	                if (node.typeArguments) {
	                    // Do type argument local checks only if referenced type is successfully resolved
	                    ts.forEach(node.typeArguments, checkSourceElement);
	                    if (produceDiagnostics) {
	                        var typeParameters = getTypeParametersForTypeReference(node);
	                        if (typeParameters) {
	                            checkTypeArgumentConstraints(node, typeParameters);
	                        }
	                    }
	                }
	                if (type.flags & 16 /* Enum */ && getNodeLinks(node).resolvedSymbol.flags & 8 /* EnumMember */) {
	                    error(node, ts.Diagnostics.Enum_type_0_has_members_with_initializers_that_are_not_literals, typeToString(type));
	                }
	            }
	        }
	        function getTypeArgumentConstraint(node) {
	            var typeReferenceNode = ts.tryCast(node.parent, ts.isTypeReferenceType);
	            if (!typeReferenceNode)
	                return undefined;
	            var typeParameters = getTypeParametersForTypeReference(typeReferenceNode);
	            var constraint = getConstraintOfTypeParameter(typeParameters[typeReferenceNode.typeArguments.indexOf(node)]);
	            return constraint && instantiateType(constraint, createTypeMapper(typeParameters, getEffectiveTypeArguments(typeReferenceNode, typeParameters)));
	        }
	        function checkTypeQuery(node) {
	            getTypeFromTypeQueryNode(node);
	        }
	        function checkTypeLiteral(node) {
	            ts.forEach(node.members, checkSourceElement);
	            if (produceDiagnostics) {
	                var type = getTypeFromTypeLiteralOrFunctionOrConstructorTypeNode(node);
	                checkIndexConstraints(type);
	                checkTypeForDuplicateIndexSignatures(node);
	                checkObjectTypeForDuplicateDeclarations(node);
	            }
	        }
	        function checkArrayType(node) {
	            checkSourceElement(node.elementType);
	        }
	        function checkTupleType(node) {
	            // Grammar checking
	            var hasErrorFromDisallowedTrailingComma = checkGrammarForDisallowedTrailingComma(node.elementTypes);
	            if (!hasErrorFromDisallowedTrailingComma && node.elementTypes.length === 0) {
	                grammarErrorOnNode(node, ts.Diagnostics.A_tuple_type_element_list_cannot_be_empty);
	            }
	            ts.forEach(node.elementTypes, checkSourceElement);
	        }
	        function checkUnionOrIntersectionType(node) {
	            ts.forEach(node.types, checkSourceElement);
	        }
	        function checkIndexedAccessIndexType(type, accessNode) {
	            if (!(type.flags & 1048576 /* IndexedAccess */)) {
	                return type;
	            }
	            // Check if the index type is assignable to 'keyof T' for the object type.
	            var objectType = type.objectType;
	            var indexType = type.indexType;
	            if (isTypeAssignableTo(indexType, getIndexType(objectType, /*stringsOnly*/ false))) {
	                if (accessNode.kind === 185 /* ElementAccessExpression */ && ts.isAssignmentTarget(accessNode) &&
	                    ts.getObjectFlags(objectType) & 32 /* Mapped */ && getMappedTypeModifiers(objectType) & 1 /* IncludeReadonly */) {
	                    error(accessNode, ts.Diagnostics.Index_signature_in_type_0_only_permits_reading, typeToString(objectType));
	                }
	                return type;
	            }
	            // Check if we're indexing with a numeric type and if either object or index types
	            // is a generic type with a constraint that has a numeric index signature.
	            if (getIndexInfoOfType(getApparentType(objectType), 1 /* Number */) && isTypeAssignableToKind(indexType, 84 /* NumberLike */)) {
	                return type;
	            }
	            error(accessNode, ts.Diagnostics.Type_0_cannot_be_used_to_index_type_1, typeToString(indexType), typeToString(objectType));
	            return type;
	        }
	        function checkIndexedAccessType(node) {
	            checkSourceElement(node.objectType);
	            checkSourceElement(node.indexType);
	            checkIndexedAccessIndexType(getTypeFromIndexedAccessTypeNode(node), node);
	        }
	        function checkMappedType(node) {
	            checkSourceElement(node.typeParameter);
	            checkSourceElement(node.type);
	            if (noImplicitAny && !node.type) {
	                reportImplicitAnyError(node, anyType);
	            }
	            var type = getTypeFromMappedTypeNode(node);
	            var constraintType = getConstraintTypeFromMappedType(type);
	            checkTypeAssignableTo(constraintType, keyofConstraintType, node.typeParameter.constraint);
	        }
	        function checkTypeOperator(node) {
	            checkGrammarTypeOperatorNode(node);
	            checkSourceElement(node.type);
	        }
	        function checkConditionalType(node) {
	            ts.forEachChild(node, checkSourceElement);
	        }
	        function checkInferType(node) {
	            if (!ts.findAncestor(node, function (n) { return n.parent && n.parent.kind === 170 /* ConditionalType */ && n.parent.extendsType === n; })) {
	                grammarErrorOnNode(node, ts.Diagnostics.infer_declarations_are_only_permitted_in_the_extends_clause_of_a_conditional_type);
	            }
	            checkSourceElement(node.typeParameter);
	        }
	        function checkImportType(node) {
	            checkSourceElement(node.argument);
	            getTypeFromTypeNode(node);
	        }
	        function isPrivateWithinAmbient(node) {
	            return ts.hasModifier(node, 8 /* Private */) && !!(node.flags & 4194304 /* Ambient */);
	        }
	        function getEffectiveDeclarationFlags(n, flagsToCheck) {
	            var flags = ts.getCombinedModifierFlags(n);
	            // children of classes (even ambient classes) should not be marked as ambient or export
	            // because those flags have no useful semantics there.
	            if (n.parent.kind !== 235 /* InterfaceDeclaration */ &&
	                n.parent.kind !== 234 /* ClassDeclaration */ &&
	                n.parent.kind !== 204 /* ClassExpression */ &&
	                n.flags & 4194304 /* Ambient */) {
	                if (!(flags & 2 /* Ambient */) && !(ts.isModuleBlock(n.parent) && ts.isModuleDeclaration(n.parent.parent) && ts.isGlobalScopeAugmentation(n.parent.parent))) {
	                    // It is nested in an ambient context, which means it is automatically exported
	                    flags |= 1 /* Export */;
	                }
	                flags |= 2 /* Ambient */;
	            }
	            return flags & flagsToCheck;
	        }
	        function checkFunctionOrConstructorSymbol(symbol) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            function getCanonicalOverload(overloads, implementation) {
	                // Consider the canonical set of flags to be the flags of the bodyDeclaration or the first declaration
	                // Error on all deviations from this canonical set of flags
	                // The caveat is that if some overloads are defined in lib.d.ts, we don't want to
	                // report the errors on those. To achieve this, we will say that the implementation is
	                // the canonical signature only if it is in the same container as the first overload
	                var implementationSharesContainerWithFirstOverload = implementation !== undefined && implementation.parent === overloads[0].parent;
	                return implementationSharesContainerWithFirstOverload ? implementation : overloads[0];
	            }
	            function checkFlagAgreementBetweenOverloads(overloads, implementation, flagsToCheck, someOverloadFlags, allOverloadFlags) {
	                // Error if some overloads have a flag that is not shared by all overloads. To find the
	                // deviations, we XOR someOverloadFlags with allOverloadFlags
	                var someButNotAllOverloadFlags = someOverloadFlags ^ allOverloadFlags;
	                if (someButNotAllOverloadFlags !== 0) {
	                    var canonicalFlags_1 = getEffectiveDeclarationFlags(getCanonicalOverload(overloads, implementation), flagsToCheck);
	                    ts.forEach(overloads, function (o) {
	                        var deviation = getEffectiveDeclarationFlags(o, flagsToCheck) ^ canonicalFlags_1;
	                        if (deviation & 1 /* Export */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_exported_or_non_exported);
	                        }
	                        else if (deviation & 2 /* Ambient */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_ambient_or_non_ambient);
	                        }
	                        else if (deviation & (8 /* Private */ | 16 /* Protected */)) {
	                            error(ts.getNameOfDeclaration(o) || o, ts.Diagnostics.Overload_signatures_must_all_be_public_private_or_protected);
	                        }
	                        else if (deviation & 128 /* Abstract */) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_abstract_or_non_abstract);
	                        }
	                    });
	                }
	            }
	            function checkQuestionTokenAgreementBetweenOverloads(overloads, implementation, someHaveQuestionToken, allHaveQuestionToken) {
	                if (someHaveQuestionToken !== allHaveQuestionToken) {
	                    var canonicalHasQuestionToken_1 = ts.hasQuestionToken(getCanonicalOverload(overloads, implementation));
	                    ts.forEach(overloads, function (o) {
	                        var deviation = ts.hasQuestionToken(o) !== canonicalHasQuestionToken_1;
	                        if (deviation) {
	                            error(ts.getNameOfDeclaration(o), ts.Diagnostics.Overload_signatures_must_all_be_optional_or_required);
	                        }
	                    });
	                }
	            }
	            var flagsToCheck = 1 /* Export */ | 2 /* Ambient */ | 8 /* Private */ | 16 /* Protected */ | 128 /* Abstract */;
	            var someNodeFlags = 0 /* None */;
	            var allNodeFlags = flagsToCheck;
	            var someHaveQuestionToken = false;
	            var allHaveQuestionToken = true;
	            var hasOverloads = false;
	            var bodyDeclaration;
	            var lastSeenNonAmbientDeclaration;
	            var previousDeclaration;
	            var declarations = symbol.declarations;
	            var isConstructor = (symbol.flags & 16384 /* Constructor */) !== 0;
	            function reportImplementationExpectedError(node) {
	                if (node.name && ts.nodeIsMissing(node.name)) {
	                    return;
	                }
	                var seen = false;
	                var subsequentNode = ts.forEachChild(node.parent, function (c) {
	                    if (seen) {
	                        return c;
	                    }
	                    else {
	                        seen = c === node;
	                    }
	                });
	                // We may be here because of some extra nodes between overloads that could not be parsed into a valid node.
	                // In this case the subsequent node is not really consecutive (.pos !== node.end), and we must ignore it here.
	                if (subsequentNode && subsequentNode.pos === node.end) {
	                    if (subsequentNode.kind === node.kind) {
	                        var errorNode_1 = subsequentNode.name || subsequentNode;
	                        // TODO: GH#17345: These are methods, so handle computed name case. (`Always allowing computed property names is *not* the correct behavior!)
	                        var subsequentName = subsequentNode.name;
	                        if (node.name && subsequentName &&
	                            (ts.isComputedPropertyName(node.name) && ts.isComputedPropertyName(subsequentName) ||
	                                !ts.isComputedPropertyName(node.name) && !ts.isComputedPropertyName(subsequentName) && ts.getEscapedTextOfIdentifierOrLiteral(node.name) === ts.getEscapedTextOfIdentifierOrLiteral(subsequentName))) {
	                            var reportError = (node.kind === 153 /* MethodDeclaration */ || node.kind === 152 /* MethodSignature */) &&
	                                ts.hasModifier(node, 32 /* Static */) !== ts.hasModifier(subsequentNode, 32 /* Static */);
	                            // we can get here in two cases
	                            // 1. mixed static and instance class members
	                            // 2. something with the same name was defined before the set of overloads that prevents them from merging
	                            // here we'll report error only for the first case since for second we should already report error in binder
	                            if (reportError) {
	                                var diagnostic = ts.hasModifier(node, 32 /* Static */) ? ts.Diagnostics.Function_overload_must_be_static : ts.Diagnostics.Function_overload_must_not_be_static;
	                                error(errorNode_1, diagnostic);
	                            }
	                            return;
	                        }
	                        else if (ts.nodeIsPresent(subsequentNode.body)) {
	                            error(errorNode_1, ts.Diagnostics.Function_implementation_name_must_be_0, ts.declarationNameToString(node.name));
	                            return;
	                        }
	                    }
	                }
	                var errorNode = node.name || node;
	                if (isConstructor) {
	                    error(errorNode, ts.Diagnostics.Constructor_implementation_is_missing);
	                }
	                else {
	                    // Report different errors regarding non-consecutive blocks of declarations depending on whether
	                    // the node in question is abstract.
	                    if (ts.hasModifier(node, 128 /* Abstract */)) {
	                        error(errorNode, ts.Diagnostics.All_declarations_of_an_abstract_method_must_be_consecutive);
	                    }
	                    else {
	                        error(errorNode, ts.Diagnostics.Function_implementation_is_missing_or_not_immediately_following_the_declaration);
	                    }
	                }
	            }
	            var duplicateFunctionDeclaration = false;
	            var multipleConstructorImplementation = false;
	            for (var _i = 0, declarations_4 = declarations; _i < declarations_4.length; _i++) {
	                var current = declarations_4[_i];
	                var node = current;
	                var inAmbientContext = node.flags & 4194304 /* Ambient */;
	                var inAmbientContextOrInterface = node.parent.kind === 235 /* InterfaceDeclaration */ || node.parent.kind === 165 /* TypeLiteral */ || inAmbientContext;
	                if (inAmbientContextOrInterface) {
	                    // check if declarations are consecutive only if they are non-ambient
	                    // 1. ambient declarations can be interleaved
	                    // i.e. this is legal
	                    //     declare function foo();
	                    //     declare function bar();
	                    //     declare function foo();
	                    // 2. mixing ambient and non-ambient declarations is a separate error that will be reported - do not want to report an extra one
	                    previousDeclaration = undefined;
	                }
	                if (node.kind === 233 /* FunctionDeclaration */ || node.kind === 153 /* MethodDeclaration */ || node.kind === 152 /* MethodSignature */ || node.kind === 154 /* Constructor */) {
	                    var currentNodeFlags = getEffectiveDeclarationFlags(node, flagsToCheck);
	                    someNodeFlags |= currentNodeFlags;
	                    allNodeFlags &= currentNodeFlags;
	                    someHaveQuestionToken = someHaveQuestionToken || ts.hasQuestionToken(node);
	                    allHaveQuestionToken = allHaveQuestionToken && ts.hasQuestionToken(node);
	                    if (ts.nodeIsPresent(node.body) && bodyDeclaration) {
	                        if (isConstructor) {
	                            multipleConstructorImplementation = true;
	                        }
	                        else {
	                            duplicateFunctionDeclaration = true;
	                        }
	                    }
	                    else if (previousDeclaration && previousDeclaration.parent === node.parent && previousDeclaration.end !== node.pos) {
	                        reportImplementationExpectedError(previousDeclaration);
	                    }
	                    if (ts.nodeIsPresent(node.body)) {
	                        if (!bodyDeclaration) {
	                            bodyDeclaration = node;
	                        }
	                    }
	                    else {
	                        hasOverloads = true;
	                    }
	                    previousDeclaration = node;
	                    if (!inAmbientContextOrInterface) {
	                        lastSeenNonAmbientDeclaration = node;
	                    }
	                }
	            }
	            if (multipleConstructorImplementation) {
	                ts.forEach(declarations, function (declaration) {
	                    error(declaration, ts.Diagnostics.Multiple_constructor_implementations_are_not_allowed);
	                });
	            }
	            if (duplicateFunctionDeclaration) {
	                ts.forEach(declarations, function (declaration) {
	                    error(ts.getNameOfDeclaration(declaration), ts.Diagnostics.Duplicate_function_implementation);
	                });
	            }
	            // Abstract methods can't have an implementation -- in particular, they don't need one.
	            if (lastSeenNonAmbientDeclaration && !lastSeenNonAmbientDeclaration.body &&
	                !ts.hasModifier(lastSeenNonAmbientDeclaration, 128 /* Abstract */) && !lastSeenNonAmbientDeclaration.questionToken) {
	                reportImplementationExpectedError(lastSeenNonAmbientDeclaration);
	            }
	            if (hasOverloads) {
	                checkFlagAgreementBetweenOverloads(declarations, bodyDeclaration, flagsToCheck, someNodeFlags, allNodeFlags);
	                checkQuestionTokenAgreementBetweenOverloads(declarations, bodyDeclaration, someHaveQuestionToken, allHaveQuestionToken);
	                if (bodyDeclaration) {
	                    var signatures = getSignaturesOfSymbol(symbol);
	                    var bodySignature = getSignatureFromDeclaration(bodyDeclaration);
	                    for (var _a = 0, signatures_7 = signatures; _a < signatures_7.length; _a++) {
	                        var signature = signatures_7[_a];
	                        if (!isImplementationCompatibleWithOverload(bodySignature, signature)) {
	                            error(signature.declaration, ts.Diagnostics.Overload_signature_is_not_compatible_with_function_implementation);
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	        function checkExportsOnMergedDeclarations(node) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // if localSymbol is defined on node then node itself is exported - check is required
	            var symbol = node.localSymbol;
	            if (!symbol) {
	                // local symbol is undefined => this declaration is non-exported.
	                // however symbol might contain other declarations that are exported
	                symbol = getSymbolOfNode(node);
	                if (!symbol.exportSymbol) {
	                    // this is a pure local symbol (all declarations are non-exported) - no need to check anything
	                    return;
	                }
	            }
	            // run the check only for the first declaration in the list
	            if (ts.getDeclarationOfKind(symbol, node.kind) !== node) {
	                return;
	            }
	            var exportedDeclarationSpaces = 0 /* None */;
	            var nonExportedDeclarationSpaces = 0 /* None */;
	            var defaultExportedDeclarationSpaces = 0 /* None */;
	            for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                var d = _a[_i];
	                var declarationSpaces = getDeclarationSpaces(d);
	                var effectiveDeclarationFlags = getEffectiveDeclarationFlags(d, 1 /* Export */ | 512 /* Default */);
	                if (effectiveDeclarationFlags & 1 /* Export */) {
	                    if (effectiveDeclarationFlags & 512 /* Default */) {
	                        defaultExportedDeclarationSpaces |= declarationSpaces;
	                    }
	                    else {
	                        exportedDeclarationSpaces |= declarationSpaces;
	                    }
	                }
	                else {
	                    nonExportedDeclarationSpaces |= declarationSpaces;
	                }
	            }
	            // Spaces for anything not declared a 'default export'.
	            var nonDefaultExportedDeclarationSpaces = exportedDeclarationSpaces | nonExportedDeclarationSpaces;
	            var commonDeclarationSpacesForExportsAndLocals = exportedDeclarationSpaces & nonExportedDeclarationSpaces;
	            var commonDeclarationSpacesForDefaultAndNonDefault = defaultExportedDeclarationSpaces & nonDefaultExportedDeclarationSpaces;
	            if (commonDeclarationSpacesForExportsAndLocals || commonDeclarationSpacesForDefaultAndNonDefault) {
	                // declaration spaces for exported and non-exported declarations intersect
	                for (var _b = 0, _c = symbol.declarations; _b < _c.length; _b++) {
	                    var d = _c[_b];
	                    var declarationSpaces = getDeclarationSpaces(d);
	                    var name = ts.getNameOfDeclaration(d);
	                    // Only error on the declarations that contributed to the intersecting spaces.
	                    if (declarationSpaces & commonDeclarationSpacesForDefaultAndNonDefault) {
	                        error(name, ts.Diagnostics.Merged_declaration_0_cannot_include_a_default_export_declaration_Consider_adding_a_separate_export_default_0_declaration_instead, ts.declarationNameToString(name));
	                    }
	                    else if (declarationSpaces & commonDeclarationSpacesForExportsAndLocals) {
	                        error(name, ts.Diagnostics.Individual_declarations_in_merged_declaration_0_must_be_all_exported_or_all_local, ts.declarationNameToString(name));
	                    }
	                }
	            }
	            var DeclarationSpaces;
	            (function (DeclarationSpaces) {
	                DeclarationSpaces[DeclarationSpaces["None"] = 0] = "None";
	                DeclarationSpaces[DeclarationSpaces["ExportValue"] = 1] = "ExportValue";
	                DeclarationSpaces[DeclarationSpaces["ExportType"] = 2] = "ExportType";
	                DeclarationSpaces[DeclarationSpaces["ExportNamespace"] = 4] = "ExportNamespace";
	            })(DeclarationSpaces || (DeclarationSpaces = {}));
	            function getDeclarationSpaces(decl) {
	                var d = decl;
	                switch (d.kind) {
	                    case 235 /* InterfaceDeclaration */:
	                    case 236 /* TypeAliasDeclaration */:
	                    // A jsdoc typedef and callback are, by definition, type aliases
	                    case 296 /* JSDocTypedefTag */:
	                    case 291 /* JSDocCallbackTag */:
	                        return 2 /* ExportType */;
	                    case 238 /* ModuleDeclaration */:
	                        return ts.isAmbientModule(d) || ts.getModuleInstanceState(d) !== 0 /* NonInstantiated */
	                            ? 4 /* ExportNamespace */ | 1 /* ExportValue */
	                            : 4 /* ExportNamespace */;
	                    case 234 /* ClassDeclaration */:
	                    case 237 /* EnumDeclaration */:
	                        return 2 /* ExportType */ | 1 /* ExportValue */;
	                    case 273 /* SourceFile */:
	                        return 2 /* ExportType */ | 1 /* ExportValue */ | 4 /* ExportNamespace */;
	                    case 248 /* ExportAssignment */:
	                        // Export assigned entity name expressions act as aliases and should fall through, otherwise they export values
	                        if (!ts.isEntityNameExpression(d.expression)) {
	                            return 1 /* ExportValue */;
	                        }
	                        d = d.expression;
	                    /* falls through */
	                    // The below options all declare an Alias, which is allowed to merge with other values within the importing module
	                    case 242 /* ImportEqualsDeclaration */:
	                    case 245 /* NamespaceImport */:
	                    case 244 /* ImportClause */:
	                        var result_3 = 0 /* None */;
	                        var target = resolveAlias(getSymbolOfNode(d));
	                        ts.forEach(target.declarations, function (d) { result_3 |= getDeclarationSpaces(d); });
	                        return result_3;
	                    case 231 /* VariableDeclaration */:
	                    case 181 /* BindingElement */:
	                    case 233 /* FunctionDeclaration */:
	                    case 247 /* ImportSpecifier */: // https://github.com/Microsoft/TypeScript/pull/7591
	                        return 1 /* ExportValue */;
	                    default:
	                        ts.Debug.fail(ts.Debug.showSyntaxKind(d));
	                }
	            }
	        }
	        function getAwaitedTypeOfPromise(type, errorNode, diagnosticMessage) {
	            var promisedType = getPromisedTypeOfPromise(type, errorNode);
	            return promisedType && getAwaitedType(promisedType, errorNode, diagnosticMessage);
	        }
	        /**
	         * Gets the "promised type" of a promise.
	         * @param type The type of the promise.
	         * @remarks The "promised type" of a type is the type of the "value" parameter of the "onfulfilled" callback.
	         */
	        function getPromisedTypeOfPromise(promise, errorNode) {
	            //
	            //  { // promise
	            //      then( // thenFunction
	            //          onfulfilled: ( // onfulfilledParameterType
	            //              value: T // valueParameterType
	            //          ) => any
	            //      ): any;
	            //  }
	            //
	            if (isTypeAny(promise)) {
	                return undefined;
	            }
	            var typeAsPromise = promise;
	            if (typeAsPromise.promisedTypeOfPromise) {
	                return typeAsPromise.promisedTypeOfPromise;
	            }
	            if (isReferenceToType(promise, getGlobalPromiseType(/*reportErrors*/ false))) {
	                return typeAsPromise.promisedTypeOfPromise = promise.typeArguments[0];
	            }
	            var thenFunction = getTypeOfPropertyOfType(promise, "then");
	            if (isTypeAny(thenFunction)) {
	                return undefined;
	            }
	            var thenSignatures = thenFunction ? getSignaturesOfType(thenFunction, 0 /* Call */) : ts.emptyArray;
	            if (thenSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, ts.Diagnostics.A_promise_must_have_a_then_method);
	                }
	                return undefined;
	            }
	            var onfulfilledParameterType = getTypeWithFacts(getUnionType(ts.map(thenSignatures, getTypeOfFirstParameterOfSignature)), 524288 /* NEUndefinedOrNull */);
	            if (isTypeAny(onfulfilledParameterType)) {
	                return undefined;
	            }
	            var onfulfilledParameterSignatures = getSignaturesOfType(onfulfilledParameterType, 0 /* Call */);
	            if (onfulfilledParameterSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, ts.Diagnostics.The_first_parameter_of_the_then_method_of_a_promise_must_be_a_callback);
	                }
	                return undefined;
	            }
	            return typeAsPromise.promisedTypeOfPromise = getUnionType(ts.map(onfulfilledParameterSignatures, getTypeOfFirstParameterOfSignature), 2 /* Subtype */);
	        }
	        /**
	         * Gets the "awaited type" of a type.
	         * @param type The type to await.
	         * @remarks The "awaited type" of an expression is its "promised type" if the expression is a
	         * Promise-like type; otherwise, it is the type of the expression. This is used to reflect
	         * The runtime behavior of the `await` keyword.
	         */
	        function checkAwaitedType(type, errorNode, diagnosticMessage) {
	            return getAwaitedType(type, errorNode, diagnosticMessage) || unknownType;
	        }
	        function getAwaitedType(type, errorNode, diagnosticMessage) {
	            var typeAsAwaitable = type;
	            if (typeAsAwaitable.awaitedTypeOfType) {
	                return typeAsAwaitable.awaitedTypeOfType;
	            }
	            if (isTypeAny(type)) {
	                return typeAsAwaitable.awaitedTypeOfType = type;
	            }
	            if (type.flags & 131072 /* Union */) {
	                var types = void 0;
	                for (var _i = 0, _a = type.types; _i < _a.length; _i++) {
	                    var constituentType = _a[_i];
	                    types = ts.append(types, getAwaitedType(constituentType, errorNode, diagnosticMessage));
	                }
	                if (!types) {
	                    return undefined;
	                }
	                return typeAsAwaitable.awaitedTypeOfType = getUnionType(types);
	            }
	            var promisedType = getPromisedTypeOfPromise(type);
	            if (promisedType) {
	                if (type.id === promisedType.id || awaitedTypeStack.indexOf(promisedType.id) >= 0) {
	                    // Verify that we don't have a bad actor in the form of a promise whose
	                    // promised type is the same as the promise type, or a mutually recursive
	                    // promise. If so, we return undefined as we cannot guess the shape. If this
	                    // were the actual case in the JavaScript, this Promise would never resolve.
	                    //
	                    // An example of a bad actor with a singly-recursive promise type might
	                    // be:
	                    //
	                    //  interface BadPromise {
	                    //      then(
	                    //          onfulfilled: (value: BadPromise) => any,
	                    //          onrejected: (error: any) => any): BadPromise;
	                    //  }
	                    // The above interface will pass the PromiseLike check, and return a
	                    // promised type of `BadPromise`. Since this is a self reference, we
	                    // don't want to keep recursing ad infinitum.
	                    //
	                    // An example of a bad actor in the form of a mutually-recursive
	                    // promise type might be:
	                    //
	                    //  interface BadPromiseA {
	                    //      then(
	                    //          onfulfilled: (value: BadPromiseB) => any,
	                    //          onrejected: (error: any) => any): BadPromiseB;
	                    //  }
	                    //
	                    //  interface BadPromiseB {
	                    //      then(
	                    //          onfulfilled: (value: BadPromiseA) => any,
	                    //          onrejected: (error: any) => any): BadPromiseA;
	                    //  }
	                    //
	                    if (errorNode) {
	                        error(errorNode, ts.Diagnostics.Type_is_referenced_directly_or_indirectly_in_the_fulfillment_callback_of_its_own_then_method);
	                    }
	                    return undefined;
	                }
	                // Keep track of the type we're about to unwrap to avoid bad recursive promise types.
	                // See the comments above for more information.
	                awaitedTypeStack.push(type.id);
	                var awaitedType = getAwaitedType(promisedType, errorNode, diagnosticMessage);
	                awaitedTypeStack.pop();
	                if (!awaitedType) {
	                    return undefined;
	                }
	                return typeAsAwaitable.awaitedTypeOfType = awaitedType;
	            }
	            // The type was not a promise, so it could not be unwrapped any further.
	            // As long as the type does not have a callable "then" property, it is
	            // safe to return the type; otherwise, an error will be reported in
	            // the call to getNonThenableType and we will return undefined.
	            //
	            // An example of a non-promise "thenable" might be:
	            //
	            //  await { then(): void {} }
	            //
	            // The "thenable" does not match the minimal definition for a promise. When
	            // a Promise/A+-compatible or ES6 promise tries to adopt this value, the promise
	            // will never settle. We treat this as an error to help flag an early indicator
	            // of a runtime problem. If the user wants to return this value from an async
	            // function, they would need to wrap it in some other value. If they want it to
	            // be treated as a promise, they can cast to <any>.
	            var thenFunction = getTypeOfPropertyOfType(type, "then");
	            if (thenFunction && getSignaturesOfType(thenFunction, 0 /* Call */).length > 0) {
	                if (errorNode) {
	                    ts.Debug.assert(!!diagnosticMessage);
	                    error(errorNode, diagnosticMessage);
	                }
	                return undefined;
	            }
	            return typeAsAwaitable.awaitedTypeOfType = type;
	        }
	        /**
	         * Checks the return type of an async function to ensure it is a compatible
	         * Promise implementation.
	         *
	         * This checks that an async function has a valid Promise-compatible return type,
	         * and returns the *awaited type* of the promise. An async function has a valid
	         * Promise-compatible return type if the resolved value of the return type has a
	         * construct signature that takes in an `initializer` function that in turn supplies
	         * a `resolve` function as one of its arguments and results in an object with a
	         * callable `then` signature.
	         *
	         * @param node The signature to check
	         */
	        function checkAsyncFunctionReturnType(node) {
	            // As part of our emit for an async function, we will need to emit the entity name of
	            // the return type annotation as an expression. To meet the necessary runtime semantics
	            // for __awaiter, we must also check that the type of the declaration (e.g. the static
	            // side or "constructor" of the promise type) is compatible `PromiseConstructorLike`.
	            //
	            // An example might be (from lib.es6.d.ts):
	            //
	            //  interface Promise<T> { ... }
	            //  interface PromiseConstructor {
	            //      new <T>(...): Promise<T>;
	            //  }
	            //  declare var Promise: PromiseConstructor;
	            //
	            // When an async function declares a return type annotation of `Promise<T>`, we
	            // need to get the type of the `Promise` variable declaration above, which would
	            // be `PromiseConstructor`.
	            //
	            // The same case applies to a class:
	            //
	            //  declare class Promise<T> {
	            //      constructor(...);
	            //      then<U>(...): Promise<U>;
	            //  }
	            //
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            var returnType = getTypeFromTypeNode(returnTypeNode);
	            if (languageVersion >= 2 /* ES2015 */) {
	                if (returnType === unknownType) {
	                    return unknownType;
	                }
	                var globalPromiseType = getGlobalPromiseType(/*reportErrors*/ true);
	                if (globalPromiseType !== emptyGenericType && !isReferenceToType(returnType, globalPromiseType)) {
	                    // The promise type was not a valid type reference to the global promise type, so we
	                    // report an error and return the unknown type.
	                    error(returnTypeNode, ts.Diagnostics.The_return_type_of_an_async_function_or_method_must_be_the_global_Promise_T_type);
	                    return unknownType;
	                }
	            }
	            else {
	                // Always mark the type node as referenced if it points to a value
	                markTypeNodeAsReferenced(returnTypeNode);
	                if (returnType === unknownType) {
	                    return unknownType;
	                }
	                var promiseConstructorName = ts.getEntityNameFromTypeNode(returnTypeNode);
	                if (promiseConstructorName === undefined) {
	                    error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, typeToString(returnType));
	                    return unknownType;
	                }
	                var promiseConstructorSymbol = resolveEntityName(promiseConstructorName, 67216319 /* Value */, /*ignoreErrors*/ true);
	                var promiseConstructorType = promiseConstructorSymbol ? getTypeOfSymbol(promiseConstructorSymbol) : unknownType;
	                if (promiseConstructorType === unknownType) {
	                    if (promiseConstructorName.kind === 71 /* Identifier */ && promiseConstructorName.escapedText === "Promise" && getTargetType(returnType) === getGlobalPromiseType(/*reportErrors*/ false)) {
	                        error(returnTypeNode, ts.Diagnostics.An_async_function_or_method_in_ES5_SlashES3_requires_the_Promise_constructor_Make_sure_you_have_a_declaration_for_the_Promise_constructor_or_include_ES2015_in_your_lib_option);
	                    }
	                    else {
	                        error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, ts.entityNameToString(promiseConstructorName));
	                    }
	                    return unknownType;
	                }
	                var globalPromiseConstructorLikeType = getGlobalPromiseConstructorLikeType(/*reportErrors*/ true);
	                if (globalPromiseConstructorLikeType === emptyObjectType) {
	                    // If we couldn't resolve the global PromiseConstructorLike type we cannot verify
	                    // compatibility with __awaiter.
	                    error(returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value, ts.entityNameToString(promiseConstructorName));
	                    return unknownType;
	                }
	                if (!checkTypeAssignableTo(promiseConstructorType, globalPromiseConstructorLikeType, returnTypeNode, ts.Diagnostics.Type_0_is_not_a_valid_async_function_return_type_in_ES5_SlashES3_because_it_does_not_refer_to_a_Promise_compatible_constructor_value)) {
	                    return unknownType;
	                }
	                // Verify there is no local declaration that could collide with the promise constructor.
	                var rootName = promiseConstructorName && getFirstIdentifier(promiseConstructorName);
	                var collidingSymbol = getSymbol(node.locals, rootName.escapedText, 67216319 /* Value */);
	                if (collidingSymbol) {
	                    error(collidingSymbol.valueDeclaration, ts.Diagnostics.Duplicate_identifier_0_Compiler_uses_declaration_1_to_support_async_functions, ts.idText(rootName), ts.entityNameToString(promiseConstructorName));
	                    return unknownType;
	                }
	            }
	            // Get and return the awaited type of the return type.
	            return checkAwaitedType(returnType, node, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	        }
	        /** Check a decorator */
	        function checkDecorator(node) {
	            var signature = getResolvedSignature(node);
	            var returnType = getReturnTypeOfSignature(signature);
	            if (returnType.flags & 1 /* Any */) {
	                return;
	            }
	            var expectedReturnType;
	            var headMessage = getDiagnosticHeadMessageForDecoratorResolution(node);
	            var errorInfo;
	            switch (node.parent.kind) {
	                case 234 /* ClassDeclaration */:
	                    var classSymbol = getSymbolOfNode(node.parent);
	                    var classConstructorType = getTypeOfSymbol(classSymbol);
	                    expectedReturnType = getUnionType([classConstructorType, voidType]);
	                    break;
	                case 148 /* Parameter */:
	                    expectedReturnType = voidType;
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.The_return_type_of_a_parameter_decorator_function_must_be_either_void_or_any);
	                    break;
	                case 151 /* PropertyDeclaration */:
	                    expectedReturnType = voidType;
	                    errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.The_return_type_of_a_property_decorator_function_must_be_either_void_or_any);
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    var methodType = getTypeOfNode(node.parent);
	                    var descriptorType = createTypedPropertyDescriptorType(methodType);
	                    expectedReturnType = getUnionType([descriptorType, voidType]);
	                    break;
	            }
	            checkTypeAssignableTo(returnType, expectedReturnType, node, headMessage, function () { return errorInfo; });
	        }
	        /**
	         * If a TypeNode can be resolved to a value symbol imported from an external module, it is
	         * marked as referenced to prevent import elision.
	         */
	        function markTypeNodeAsReferenced(node) {
	            markEntityNameOrEntityExpressionAsReference(node && ts.getEntityNameFromTypeNode(node));
	        }
	        function markEntityNameOrEntityExpressionAsReference(typeName) {
	            if (!typeName)
	                return;
	            var rootName = getFirstIdentifier(typeName);
	            var meaning = (typeName.kind === 71 /* Identifier */ ? 67901928 /* Type */ : 1920 /* Namespace */) | 2097152 /* Alias */;
	            var rootSymbol = resolveName(rootName, rootName.escapedText, meaning, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isRefernce*/ true);
	            if (rootSymbol
	                && rootSymbol.flags & 2097152 /* Alias */
	                && symbolIsValue(rootSymbol)
	                && !isConstEnumOrConstEnumOnlyModule(resolveAlias(rootSymbol))) {
	                markAliasSymbolAsReferenced(rootSymbol);
	            }
	        }
	        /**
	         * This function marks the type used for metadata decorator as referenced if it is import
	         * from external module.
	         * This is different from markTypeNodeAsReferenced because it tries to simplify type nodes in
	         * union and intersection type
	         * @param node
	         */
	        function markDecoratorMedataDataTypeNodeAsReferenced(node) {
	            var entityName = getEntityNameForDecoratorMetadata(node);
	            if (entityName && ts.isEntityName(entityName)) {
	                markEntityNameOrEntityExpressionAsReference(entityName);
	            }
	        }
	        function getEntityNameForDecoratorMetadata(node) {
	            if (node) {
	                switch (node.kind) {
	                    case 169 /* IntersectionType */:
	                    case 168 /* UnionType */:
	                        var commonEntityName = void 0;
	                        for (var _i = 0, _a = node.types; _i < _a.length; _i++) {
	                            var typeNode = _a[_i];
	                            while (typeNode.kind === 172 /* ParenthesizedType */) {
	                                typeNode = typeNode.type; // Skip parens if need be
	                            }
	                            if (typeNode.kind === 131 /* NeverKeyword */) {
	                                continue; // Always elide `never` from the union/intersection if possible
	                            }
	                            if (!strictNullChecks && (typeNode.kind === 95 /* NullKeyword */ || typeNode.kind === 140 /* UndefinedKeyword */)) {
	                                continue; // Elide null and undefined from unions for metadata, just like what we did prior to the implementation of strict null checks
	                            }
	                            var individualEntityName = getEntityNameForDecoratorMetadata(typeNode);
	                            if (!individualEntityName) {
	                                // Individual is something like string number
	                                // So it would be serialized to either that type or object
	                                // Safe to return here
	                                return undefined;
	                            }
	                            if (commonEntityName) {
	                                // Note this is in sync with the transformation that happens for type node.
	                                // Keep this in sync with serializeUnionOrIntersectionType
	                                // Verify if they refer to same entity and is identifier
	                                // return undefined if they dont match because we would emit object
	                                if (!ts.isIdentifier(commonEntityName) ||
	                                    !ts.isIdentifier(individualEntityName) ||
	                                    commonEntityName.escapedText !== individualEntityName.escapedText) {
	                                    return undefined;
	                                }
	                            }
	                            else {
	                                commonEntityName = individualEntityName;
	                            }
	                        }
	                        return commonEntityName;
	                    case 172 /* ParenthesizedType */:
	                        return getEntityNameForDecoratorMetadata(node.type);
	                    case 161 /* TypeReference */:
	                        return node.typeName;
	                }
	            }
	        }
	        function getParameterTypeNodeForDecoratorCheck(node) {
	            var typeNode = ts.getEffectiveTypeAnnotationNode(node);
	            return ts.isRestParameter(node) ? ts.getRestParameterElementType(typeNode) : typeNode;
	        }
	        /** Check the decorators of a node */
	        function checkDecorators(node) {
	            if (!node.decorators) {
	                return;
	            }
	            // skip this check for nodes that cannot have decorators. These should have already had an error reported by
	            // checkGrammarDecorators.
	            if (!ts.nodeCanBeDecorated(node, node.parent, node.parent.parent)) {
	                return;
	            }
	            if (!compilerOptions.experimentalDecorators) {
	                error(node, ts.Diagnostics.Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning);
	            }
	            var firstDecorator = node.decorators[0];
	            checkExternalEmitHelpers(firstDecorator, 8 /* Decorate */);
	            if (node.kind === 148 /* Parameter */) {
	                checkExternalEmitHelpers(firstDecorator, 32 /* Param */);
	            }
	            if (compilerOptions.emitDecoratorMetadata) {
	                checkExternalEmitHelpers(firstDecorator, 16 /* Metadata */);
	                // we only need to perform these checks if we are emitting serialized type metadata for the target of a decorator.
	                switch (node.kind) {
	                    case 234 /* ClassDeclaration */:
	                        var constructor = ts.getFirstConstructorWithBody(node);
	                        if (constructor) {
	                            for (var _i = 0, _a = constructor.parameters; _i < _a.length; _i++) {
	                                var parameter = _a[_i];
	                                markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                            }
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        for (var _b = 0, _c = node.parameters; _b < _c.length; _b++) {
	                            var parameter = _c[_b];
	                            markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                        }
	                        markDecoratorMedataDataTypeNodeAsReferenced(ts.getEffectiveReturnTypeNode(node));
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                        markDecoratorMedataDataTypeNodeAsReferenced(ts.getEffectiveTypeAnnotationNode(node));
	                        break;
	                    case 148 /* Parameter */:
	                        markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(node));
	                        var containingSignature = node.parent;
	                        for (var _d = 0, _e = containingSignature.parameters; _d < _e.length; _d++) {
	                            var parameter = _e[_d];
	                            markDecoratorMedataDataTypeNodeAsReferenced(getParameterTypeNodeForDecoratorCheck(parameter));
	                        }
	                        break;
	                }
	            }
	            ts.forEach(node.decorators, checkDecorator);
	        }
	        function checkFunctionDeclaration(node) {
	            if (produceDiagnostics) {
	                checkFunctionOrMethodDeclaration(node);
	                checkGrammarForGenerator(node);
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	        }
	        function checkJSDocTypeAliasTag(node) {
	            if (!node.typeExpression) {
	                // If the node had `@property` tags, `typeExpression` would have been set to the first property tag.
	                error(node.name, ts.Diagnostics.JSDoc_typedef_tag_should_either_have_a_type_annotation_or_be_followed_by_property_or_member_tags);
	            }
	            if (node.name) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Type_alias_name_cannot_be_0);
	            }
	            checkSourceElement(node.typeExpression);
	        }
	        function checkJSDocParameterTag(node) {
	            checkSourceElement(node.typeExpression);
	            if (!ts.getParameterSymbolFromJSDoc(node)) {
	                var decl = ts.getHostSignatureFromJSDoc(node);
	                // don't issue an error for invalid hosts -- just functions --
	                // and give a better error message when the host function mentions `arguments`
	                // but the tag doesn't have an array type
	                if (decl) {
	                    var i = ts.getJSDocTags(decl).filter(ts.isJSDocParameterTag).indexOf(node);
	                    if (i > -1 && i < decl.parameters.length && ts.isBindingPattern(decl.parameters[i].name)) {
	                        return;
	                    }
	                    if (!containsArgumentsReference(decl)) {
	                        error(node.name, ts.Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name, ts.idText(node.name.kind === 145 /* QualifiedName */ ? node.name.right : node.name));
	                    }
	                    else if (ts.findLast(ts.getJSDocTags(decl), ts.isJSDocParameterTag) === node &&
	                        node.typeExpression && node.typeExpression.type &&
	                        !isArrayType(getTypeFromTypeNode(node.typeExpression.type))) {
	                        error(node.name, ts.Diagnostics.JSDoc_param_tag_has_name_0_but_there_is_no_parameter_with_that_name_It_would_match_arguments_if_it_had_an_array_type, ts.idText(node.name.kind === 145 /* QualifiedName */ ? node.name.right : node.name));
	                    }
	                }
	            }
	        }
	        function checkJSDocAugmentsTag(node) {
	            var classLike = ts.getJSDocHost(node);
	            if (!ts.isClassDeclaration(classLike) && !ts.isClassExpression(classLike)) {
	                error(classLike, ts.Diagnostics.JSDoc_0_is_not_attached_to_a_class, ts.idText(node.tagName));
	                return;
	            }
	            var augmentsTags = ts.getJSDocTags(classLike).filter(ts.isJSDocAugmentsTag);
	            ts.Debug.assert(augmentsTags.length > 0);
	            if (augmentsTags.length > 1) {
	                error(augmentsTags[1], ts.Diagnostics.Class_declarations_cannot_have_more_than_one_augments_or_extends_tag);
	            }
	            var name = getIdentifierFromEntityNameExpression(node.class.expression);
	            var extend = ts.getClassExtendsHeritageClauseElement(classLike);
	            if (extend) {
	                var className = getIdentifierFromEntityNameExpression(extend.expression);
	                if (className && name.escapedText !== className.escapedText) {
	                    error(name, ts.Diagnostics.JSDoc_0_1_does_not_match_the_extends_2_clause, ts.idText(node.tagName), ts.idText(name), ts.idText(className));
	                }
	            }
	        }
	        function getIdentifierFromEntityNameExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return node;
	                case 184 /* PropertyAccessExpression */:
	                    return node.name;
	                default:
	                    return undefined;
	            }
	        }
	        function checkFunctionOrMethodDeclaration(node) {
	            checkDecorators(node);
	            checkSignatureDeclaration(node);
	            var functionFlags = ts.getFunctionFlags(node);
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name && node.name.kind === 146 /* ComputedPropertyName */) {
	                // This check will account for methods in class/interface declarations,
	                // as well as accessors in classes/object literals
	                checkComputedPropertyName(node.name);
	            }
	            if (!hasNonBindableDynamicName(node)) {
	                // first we want to check the local symbol that contain this declaration
	                // - if node.localSymbol !== undefined - this is current declaration is exported and localSymbol points to the local symbol
	                // - if node.localSymbol === undefined - this node is non-exported so we can just pick the result of getSymbolOfNode
	                var symbol = getSymbolOfNode(node);
	                var localSymbol = node.localSymbol || symbol;
	                // Since the javascript won't do semantic analysis like typescript,
	                // if the javascript file comes before the typescript file and both contain same name functions,
	                // checkFunctionOrConstructorSymbol wouldn't be called if we didnt ignore javascript function.
	                var firstDeclaration = ts.find(localSymbol.declarations, 
	                // Get first non javascript function declaration
	                function (declaration) { return declaration.kind === node.kind && !(declaration.flags & 65536 /* JavaScriptFile */); });
	                // Only type check the symbol once
	                if (node === firstDeclaration) {
	                    checkFunctionOrConstructorSymbol(localSymbol);
	                }
	                if (symbol.parent) {
	                    // run check once for the first declaration
	                    if (ts.getDeclarationOfKind(symbol, node.kind) === node) {
	                        // run check on export symbol to check that modifiers agree across all exported declarations
	                        checkFunctionOrConstructorSymbol(symbol);
	                    }
	                }
	            }
	            var body = node.kind === 152 /* MethodSignature */ ? undefined : node.body;
	            checkSourceElement(body);
	            var returnTypeNode = ts.getEffectiveReturnTypeNode(node);
	            if ((functionFlags & 1 /* Generator */) === 0) { // Async function or normal function
	                var returnOrPromisedType = returnTypeNode && (functionFlags & 2 /* Async */
	                    ? checkAsyncFunctionReturnType(node) // Async function
	                    : getTypeFromTypeNode(returnTypeNode)); // normal function
	                checkAllCodePathsInNonVoidFunctionReturnOrThrow(node, returnOrPromisedType);
	            }
	            if (produceDiagnostics && !returnTypeNode) {
	                // Report an implicit any error if there is no body, no explicit return type, and node is not a private method
	                // in an ambient context
	                if (noImplicitAny && ts.nodeIsMissing(body) && !isPrivateWithinAmbient(node)) {
	                    reportImplicitAnyError(node, anyType);
	                }
	                if (functionFlags & 1 /* Generator */ && ts.nodeIsPresent(body)) {
	                    // A generator with a body and no type annotation can still cause errors. It can error if the
	                    // yielded values have no common supertype, or it can give an implicit any error if it has no
	                    // yielded values. The only way to trigger these errors is to try checking its return type.
	                    getReturnTypeOfSignature(getSignatureFromDeclaration(node));
	                }
	            }
	        }
	        function registerForUnusedIdentifiersCheck(node) {
	            // May be in a call such as getTypeOfNode that happened to call this. But potentiallyUnusedIdentifiers is only defined in the scope of `checkSourceFile`.
	            if (produceDiagnostics) {
	                var sourceFile = ts.getSourceFileOfNode(node);
	                var potentiallyUnusedIdentifiers = allPotentiallyUnusedIdentifiers.get(sourceFile.path);
	                if (!potentiallyUnusedIdentifiers) {
	                    potentiallyUnusedIdentifiers = [];
	                    allPotentiallyUnusedIdentifiers.set(sourceFile.path, potentiallyUnusedIdentifiers);
	                }
	                // TODO: GH#22580
	                // Debug.assert(addToSeen(seenPotentiallyUnusedIdentifiers, getNodeId(node)), "Adding potentially-unused identifier twice");
	                potentiallyUnusedIdentifiers.push(node);
	            }
	        }
	        function checkUnusedIdentifiers(potentiallyUnusedIdentifiers, addDiagnostic) {
	            for (var _i = 0, potentiallyUnusedIdentifiers_1 = potentiallyUnusedIdentifiers; _i < potentiallyUnusedIdentifiers_1.length; _i++) {
	                var node = potentiallyUnusedIdentifiers_1[_i];
	                switch (node.kind) {
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                        checkUnusedClassMembers(node, addDiagnostic);
	                        checkUnusedTypeParameters(node, addDiagnostic);
	                        break;
	                    case 235 /* InterfaceDeclaration */:
	                        checkUnusedTypeParameters(node, addDiagnostic);
	                        break;
	                    case 273 /* SourceFile */:
	                    case 238 /* ModuleDeclaration */:
	                    case 212 /* Block */:
	                    case 240 /* CaseBlock */:
	                    case 219 /* ForStatement */:
	                    case 220 /* ForInStatement */:
	                    case 221 /* ForOfStatement */:
	                        checkUnusedLocalsAndParameters(node, addDiagnostic);
	                        break;
	                    case 154 /* Constructor */:
	                    case 191 /* FunctionExpression */:
	                    case 233 /* FunctionDeclaration */:
	                    case 192 /* ArrowFunction */:
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        if (node.body) {
	                            checkUnusedLocalsAndParameters(node, addDiagnostic);
	                        }
	                        checkUnusedTypeParameters(node, addDiagnostic);
	                        break;
	                    case 152 /* MethodSignature */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 236 /* TypeAliasDeclaration */:
	                        checkUnusedTypeParameters(node, addDiagnostic);
	                        break;
	                    default:
	                        ts.Debug.assertNever(node, "Node should not have been registered for unused identifiers check");
	                }
	            }
	        }
	        function errorUnusedLocal(declaration, name, addDiagnostic) {
	            var node = ts.getNameOfDeclaration(declaration) || declaration;
	            var message = isTypeDeclaration(declaration) ? ts.Diagnostics._0_is_declared_but_never_used : ts.Diagnostics._0_is_declared_but_its_value_is_never_read;
	            addDiagnostic(0 /* Local */, ts.createDiagnosticForNode(node, message, name));
	        }
	        function parameterNameStartsWithUnderscore(parameterName) {
	            return parameterName && isIdentifierThatStartsWithUnderScore(parameterName);
	        }
	        function isIdentifierThatStartsWithUnderScore(node) {
	            return ts.isIdentifier(node) && ts.idText(node).charCodeAt(0) === 95 /* _ */;
	        }
	        function checkUnusedClassMembers(node, addDiagnostic) {
	            if (!(node.flags & 4194304 /* Ambient */)) {
	                for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    switch (member.kind) {
	                        case 153 /* MethodDeclaration */:
	                        case 151 /* PropertyDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            if (member.kind === 156 /* SetAccessor */ && member.symbol.flags & 32768 /* GetAccessor */) {
	                                // Already would have reported an error on the getter.
	                                break;
	                            }
	                            var symbol = getSymbolOfNode(member);
	                            if (!symbol.isReferenced && ts.hasModifier(member, 8 /* Private */)) {
	                                addDiagnostic(0 /* Local */, ts.createDiagnosticForNode(member.name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, symbolToString(symbol)));
	                            }
	                            break;
	                        case 154 /* Constructor */:
	                            for (var _b = 0, _c = member.parameters; _b < _c.length; _b++) {
	                                var parameter = _c[_b];
	                                if (!parameter.symbol.isReferenced && ts.hasModifier(parameter, 8 /* Private */)) {
	                                    addDiagnostic(0 /* Local */, ts.createDiagnosticForNode(parameter.name, ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read, ts.symbolName(parameter.symbol)));
	                                }
	                            }
	                            break;
	                        case 159 /* IndexSignature */:
	                        case 211 /* SemicolonClassElement */:
	                            // Can't be private
	                            break;
	                        default:
	                            ts.Debug.fail();
	                    }
	                }
	            }
	        }
	        function checkUnusedTypeParameters(node, addDiagnostic) {
	            // Only report errors on the last declaration for the type parameter container;
	            // this ensures that all uses have been accounted for.
	            var typeParameters = ts.getEffectiveTypeParameterDeclarations(node);
	            if (!(node.flags & 4194304 /* Ambient */) && ts.last(getSymbolOfNode(node).declarations) === node) {
	                for (var _i = 0, typeParameters_2 = typeParameters; _i < typeParameters_2.length; _i++) {
	                    var typeParameter = typeParameters_2[_i];
	                    if (!(getMergedSymbol(typeParameter.symbol).isReferenced & 262144 /* TypeParameter */) && !isIdentifierThatStartsWithUnderScore(typeParameter.name)) {
	                        addDiagnostic(1 /* Parameter */, ts.createDiagnosticForNode(typeParameter.name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.symbolName(typeParameter.symbol)));
	                    }
	                }
	            }
	        }
	        function addToGroup(map, key, value, getKey) {
	            var keyString = String(getKey(key));
	            var group = map.get(keyString);
	            if (group) {
	                group[1].push(value);
	            }
	            else {
	                map.set(keyString, [key, [value]]);
	            }
	        }
	        function tryGetRootParameterDeclaration(node) {
	            return ts.tryCast(ts.getRootDeclaration(node), ts.isParameter);
	        }
	        function checkUnusedLocalsAndParameters(nodeWithLocals, addDiagnostic) {
	            if (nodeWithLocals.flags & 4194304 /* Ambient */)
	                return;
	            // Ideally we could use the ImportClause directly as a key, but must wait until we have full ES6 maps. So must store key along with value.
	            var unusedImports = ts.createMap();
	            var unusedDestructures = ts.createMap();
	            var unusedVariables = ts.createMap();
	            nodeWithLocals.locals.forEach(function (local) {
	                // If it's purely a type parameter, ignore, will be checked in `checkUnusedTypeParameters`.
	                // If it's a type parameter merged with a parameter, check if the parameter-side is used.
	                if (local.flags & 262144 /* TypeParameter */ ? !(local.flags & 3 /* Variable */ && !(local.isReferenced & 3 /* Variable */)) : local.isReferenced || local.exportSymbol) {
	                    return;
	                }
	                for (var _i = 0, _a = local.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    if (ts.isAmbientModule(declaration))
	                        continue;
	                    if (isImportedDeclaration(declaration)) {
	                        addToGroup(unusedImports, importClauseFromImported(declaration), declaration, getNodeId);
	                    }
	                    else if (ts.isBindingElement(declaration) && ts.isObjectBindingPattern(declaration.parent)) {
	                        // In `{ a, ...b }, `a` is considered used since it removes a property from `b`. `b` may still be unused though.
	                        var lastElement = ts.last(declaration.parent.elements);
	                        if (declaration === lastElement || !ts.last(declaration.parent.elements).dotDotDotToken) {
	                            addToGroup(unusedDestructures, declaration.parent, declaration, getNodeId);
	                        }
	                    }
	                    else if (ts.isVariableDeclaration(declaration)) {
	                        if (!isIdentifierThatStartsWithUnderScore(declaration.name) || !ts.isForInOrOfStatement(declaration.parent.parent)) {
	                            addToGroup(unusedVariables, declaration.parent, declaration, getNodeId);
	                        }
	                    }
	                    else {
	                        var parameter = local.valueDeclaration && tryGetRootParameterDeclaration(local.valueDeclaration);
	                        if (parameter) {
	                            var name = ts.getNameOfDeclaration(local.valueDeclaration);
	                            if (!ts.isParameterPropertyDeclaration(parameter) && !ts.parameterIsThisKeyword(parameter) && !parameterNameStartsWithUnderscore(name)) {
	                                addDiagnostic(1 /* Parameter */, ts.createDiagnosticForNode(name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.symbolName(local)));
	                            }
	                        }
	                        else {
	                            errorUnusedLocal(declaration, ts.symbolName(local), addDiagnostic);
	                        }
	                    }
	                }
	            });
	            unusedImports.forEach(function (_a) {
	                var importClause = _a[0], unuseds = _a[1];
	                var importDecl = importClause.parent;
	                var nDeclarations = (importClause.name ? 1 : 0) +
	                    (importClause.namedBindings ?
	                        (importClause.namedBindings.kind === 245 /* NamespaceImport */ ? 1 : importClause.namedBindings.elements.length)
	                        : 0);
	                if (nDeclarations === unuseds.length) {
	                    addDiagnostic(0 /* Local */, unuseds.length === 1
	                        ? ts.createDiagnosticForNode(importDecl, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.idText(ts.first(unuseds).name))
	                        : ts.createDiagnosticForNode(importDecl, ts.Diagnostics.All_imports_in_import_declaration_are_unused));
	                }
	                else {
	                    for (var _i = 0, unuseds_1 = unuseds; _i < unuseds_1.length; _i++) {
	                        var unused = unuseds_1[_i];
	                        errorUnusedLocal(unused, ts.idText(unused.name), addDiagnostic);
	                    }
	                }
	            });
	            unusedDestructures.forEach(function (_a) {
	                var bindingPattern = _a[0], bindingElements = _a[1];
	                var kind = tryGetRootParameterDeclaration(bindingPattern.parent) ? 1 /* Parameter */ : 0 /* Local */;
	                if (bindingPattern.elements.length === bindingElements.length) {
	                    if (bindingElements.length === 1 && bindingPattern.parent.kind === 231 /* VariableDeclaration */ && bindingPattern.parent.parent.kind === 232 /* VariableDeclarationList */) {
	                        addToGroup(unusedVariables, bindingPattern.parent.parent, bindingPattern.parent, getNodeId);
	                    }
	                    else {
	                        addDiagnostic(kind, bindingElements.length === 1
	                            ? ts.createDiagnosticForNode(bindingPattern, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.idText(ts.cast(ts.first(bindingElements).name, ts.isIdentifier)))
	                            : ts.createDiagnosticForNode(bindingPattern, ts.Diagnostics.All_destructured_elements_are_unused));
	                    }
	                }
	                else {
	                    for (var _i = 0, bindingElements_1 = bindingElements; _i < bindingElements_1.length; _i++) {
	                        var e = bindingElements_1[_i];
	                        addDiagnostic(kind, ts.createDiagnosticForNode(e, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.idText(ts.cast(e.name, ts.isIdentifier))));
	                    }
	                }
	            });
	            unusedVariables.forEach(function (_a) {
	                var declarationList = _a[0], declarations = _a[1];
	                if (declarationList.declarations.length === declarations.length) {
	                    addDiagnostic(0 /* Local */, declarations.length === 1
	                        ? ts.createDiagnosticForNode(ts.first(declarations).name, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, bindingNameText(ts.first(declarations).name))
	                        : ts.createDiagnosticForNode(declarationList.parent.kind === 213 /* VariableStatement */ ? declarationList.parent : declarationList, ts.Diagnostics.All_variables_are_unused));
	                }
	                else {
	                    for (var _i = 0, declarations_5 = declarations; _i < declarations_5.length; _i++) {
	                        var decl = declarations_5[_i];
	                        addDiagnostic(0 /* Local */, ts.createDiagnosticForNode(decl, ts.Diagnostics._0_is_declared_but_its_value_is_never_read, ts.idText(ts.cast(decl.name, ts.isIdentifier))));
	                    }
	                }
	            });
	        }
	        function bindingNameText(name) {
	            switch (name.kind) {
	                case 71 /* Identifier */:
	                    return ts.idText(name);
	                case 180 /* ArrayBindingPattern */:
	                case 179 /* ObjectBindingPattern */:
	                    return bindingNameText(ts.cast(ts.first(name.elements), ts.isBindingElement).name);
	                default:
	                    return ts.Debug.assertNever(name);
	            }
	        }
	        function isImportedDeclaration(node) {
	            return node.kind === 244 /* ImportClause */ || node.kind === 247 /* ImportSpecifier */ || node.kind === 245 /* NamespaceImport */;
	        }
	        function importClauseFromImported(decl) {
	            return decl.kind === 244 /* ImportClause */ ? decl : decl.kind === 245 /* NamespaceImport */ ? decl.parent : decl.parent.parent;
	        }
	        function checkBlock(node) {
	            // Grammar checking for SyntaxKind.Block
	            if (node.kind === 212 /* Block */) {
	                checkGrammarStatementInAmbientContext(node);
	            }
	            if (ts.isFunctionOrModuleBlock(node)) {
	                var saveFlowAnalysisDisabled = flowAnalysisDisabled;
	                ts.forEach(node.statements, checkSourceElement);
	                flowAnalysisDisabled = saveFlowAnalysisDisabled;
	            }
	            else {
	                ts.forEach(node.statements, checkSourceElement);
	            }
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkCollisionWithArgumentsInGeneratedCode(node) {
	            // no rest parameters \ declaration context \ overload - no codegen impact
	            if (languageVersion >= 2 /* ES2015 */ || compilerOptions.noEmit || !ts.hasRestParameter(node) || node.flags & 4194304 /* Ambient */ || ts.nodeIsMissing(node.body)) {
	                return;
	            }
	            ts.forEach(node.parameters, function (p) {
	                if (p.name && !ts.isBindingPattern(p.name) && p.name.escapedText === argumentsSymbol.escapedName) {
	                    error(p, ts.Diagnostics.Duplicate_identifier_arguments_Compiler_uses_arguments_to_initialize_rest_parameters);
	                }
	            });
	        }
	        function needCollisionCheckForIdentifier(node, identifier, name) {
	            if (!(identifier && identifier.escapedText === name)) {
	                return false;
	            }
	            if (node.kind === 151 /* PropertyDeclaration */ ||
	                node.kind === 150 /* PropertySignature */ ||
	                node.kind === 153 /* MethodDeclaration */ ||
	                node.kind === 152 /* MethodSignature */ ||
	                node.kind === 155 /* GetAccessor */ ||
	                node.kind === 156 /* SetAccessor */) {
	                // it is ok to have member named '_super' or '_this' - member access is always qualified
	                return false;
	            }
	            if (node.flags & 4194304 /* Ambient */) {
	                // ambient context - no codegen impact
	                return false;
	            }
	            var root = ts.getRootDeclaration(node);
	            if (root.kind === 148 /* Parameter */ && ts.nodeIsMissing(root.parent.body)) {
	                // just an overload - no codegen impact
	                return false;
	            }
	            return true;
	        }
	        // this function will run after checking the source file so 'CaptureThis' is correct for all nodes
	        function checkIfThisIsCapturedInEnclosingScope(node) {
	            ts.findAncestor(node, function (current) {
	                if (getNodeCheckFlags(current) & 4 /* CaptureThis */) {
	                    var isDeclaration_1 = node.kind !== 71 /* Identifier */;
	                    if (isDeclaration_1) {
	                        error(ts.getNameOfDeclaration(node), ts.Diagnostics.Duplicate_identifier_this_Compiler_uses_variable_declaration_this_to_capture_this_reference);
	                    }
	                    else {
	                        error(node, ts.Diagnostics.Expression_resolves_to_variable_declaration_this_that_compiler_uses_to_capture_this_reference);
	                    }
	                    return true;
	                }
	            });
	        }
	        function checkIfNewTargetIsCapturedInEnclosingScope(node) {
	            ts.findAncestor(node, function (current) {
	                if (getNodeCheckFlags(current) & 8 /* CaptureNewTarget */) {
	                    var isDeclaration_2 = node.kind !== 71 /* Identifier */;
	                    if (isDeclaration_2) {
	                        error(ts.getNameOfDeclaration(node), ts.Diagnostics.Duplicate_identifier_newTarget_Compiler_uses_variable_declaration_newTarget_to_capture_new_target_meta_property_reference);
	                    }
	                    else {
	                        error(node, ts.Diagnostics.Expression_resolves_to_variable_declaration_newTarget_that_compiler_uses_to_capture_new_target_meta_property_reference);
	                    }
	                    return true;
	                }
	            });
	        }
	        function checkCollisionWithRequireExportsInGeneratedCode(node, name) {
	            // No need to check for require or exports for ES6 modules and later
	            if (moduleKind >= ts.ModuleKind.ES2015 || compilerOptions.noEmit) {
	                return;
	            }
	            if (!needCollisionCheckForIdentifier(node, name, "require") && !needCollisionCheckForIdentifier(node, name, "exports")) {
	                return;
	            }
	            // Uninstantiated modules shouldnt do this check
	            if (ts.isModuleDeclaration(node) && ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                return;
	            }
	            // In case of variable declaration, node.parent is variable statement so look at the variable statement's parent
	            var parent = getDeclarationContainer(node);
	            if (parent.kind === 273 /* SourceFile */ && ts.isExternalOrCommonJsModule(parent)) {
	                // If the declaration happens to be in external module, report error that require and exports are reserved keywords
	                error(name, ts.Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module, ts.declarationNameToString(name), ts.declarationNameToString(name));
	            }
	        }
	        function checkCollisionWithGlobalPromiseInGeneratedCode(node, name) {
	            if (languageVersion >= 4 /* ES2017 */ || compilerOptions.noEmit || !needCollisionCheckForIdentifier(node, name, "Promise")) {
	                return;
	            }
	            // Uninstantiated modules shouldnt do this check
	            if (ts.isModuleDeclaration(node) && ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                return;
	            }
	            // In case of variable declaration, node.parent is variable statement so look at the variable statement's parent
	            var parent = getDeclarationContainer(node);
	            if (parent.kind === 273 /* SourceFile */ && ts.isExternalOrCommonJsModule(parent) && parent.flags & 1024 /* HasAsyncFunctions */) {
	                // If the declaration happens to be in external module, report error that Promise is a reserved identifier.
	                error(name, ts.Diagnostics.Duplicate_identifier_0_Compiler_reserves_name_1_in_top_level_scope_of_a_module_containing_async_functions, ts.declarationNameToString(name), ts.declarationNameToString(name));
	            }
	        }
	        function checkVarDeclaredNamesNotShadowed(node) {
	            // - ScriptBody : StatementList
	            // It is a Syntax Error if any element of the LexicallyDeclaredNames of StatementList
	            // also occurs in the VarDeclaredNames of StatementList.
	            // - Block : { StatementList }
	            // It is a Syntax Error if any element of the LexicallyDeclaredNames of StatementList
	            // also occurs in the VarDeclaredNames of StatementList.
	            // Variable declarations are hoisted to the top of their function scope. They can shadow
	            // block scoped declarations, which bind tighter. this will not be flagged as duplicate definition
	            // by the binder as the declaration scope is different.
	            // A non-initialized declaration is a no-op as the block declaration will resolve before the var
	            // declaration. the problem is if the declaration has an initializer. this will act as a write to the
	            // block declared value. this is fine for let, but not const.
	            // Only consider declarations with initializers, uninitialized const declarations will not
	            // step on a let/const variable.
	            // Do not consider const and const declarations, as duplicate block-scoped declarations
	            // are handled by the binder.
	            // We are only looking for const declarations that step on let\const declarations from a
	            // different scope. e.g.:
	            //      {
	            //          const x = 0; // localDeclarationSymbol obtained after name resolution will correspond to this declaration
	            //          const x = 0; // symbol for this declaration will be 'symbol'
	            //      }
	            // skip block-scoped variables and parameters
	            if ((ts.getCombinedNodeFlags(node) & 3 /* BlockScoped */) !== 0 || ts.isParameterDeclaration(node)) {
	                return;
	            }
	            // skip variable declarations that don't have initializers
	            // NOTE: in ES6 spec initializer is required in variable declarations where name is binding pattern
	            // so we'll always treat binding elements as initialized
	            if (node.kind === 231 /* VariableDeclaration */ && !node.initializer) {
	                return;
	            }
	            var symbol = getSymbolOfNode(node);
	            if (symbol.flags & 1 /* FunctionScopedVariable */) {
	                if (!ts.isIdentifier(node.name))
	                    return ts.Debug.fail();
	                var localDeclarationSymbol = resolveName(node, node.name.escapedText, 3 /* Variable */, /*nodeNotFoundErrorMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	                if (localDeclarationSymbol &&
	                    localDeclarationSymbol !== symbol &&
	                    localDeclarationSymbol.flags & 2 /* BlockScopedVariable */) {
	                    if (getDeclarationNodeFlagsFromSymbol(localDeclarationSymbol) & 3 /* BlockScoped */) {
	                        var varDeclList = ts.getAncestor(localDeclarationSymbol.valueDeclaration, 232 /* VariableDeclarationList */);
	                        var container = varDeclList.parent.kind === 213 /* VariableStatement */ && varDeclList.parent.parent
	                            ? varDeclList.parent.parent
	                            : undefined;
	                        // names of block-scoped and function scoped variables can collide only
	                        // if block scoped variable is defined in the function\module\source file scope (because of variable hoisting)
	                        var namesShareScope = container &&
	                            (container.kind === 212 /* Block */ && ts.isFunctionLike(container.parent) ||
	                                container.kind === 239 /* ModuleBlock */ ||
	                                container.kind === 238 /* ModuleDeclaration */ ||
	                                container.kind === 273 /* SourceFile */);
	                        // here we know that function scoped variable is shadowed by block scoped one
	                        // if they are defined in the same scope - binder has already reported redeclaration error
	                        // otherwise if variable has an initializer - show error that initialization will fail
	                        // since LHS will be block scoped name instead of function scoped
	                        if (!namesShareScope) {
	                            var name = symbolToString(localDeclarationSymbol);
	                            error(node, ts.Diagnostics.Cannot_initialize_outer_scoped_variable_0_in_the_same_scope_as_block_scoped_declaration_1, name, name);
	                        }
	                    }
	                }
	            }
	        }
	        // Check that a parameter initializer contains no references to parameters declared to the right of itself
	        function checkParameterInitializer(node) {
	            if (ts.getRootDeclaration(node).kind !== 148 /* Parameter */) {
	                return;
	            }
	            var func = ts.getContainingFunction(node);
	            visit(node.initializer);
	            function visit(n) {
	                if (ts.isTypeNode(n) || ts.isDeclarationName(n)) {
	                    // do not dive in types
	                    // skip declaration names (i.e. in object literal expressions)
	                    return;
	                }
	                if (n.kind === 184 /* PropertyAccessExpression */) {
	                    // skip property names in property access expression
	                    return visit(n.expression);
	                }
	                else if (n.kind === 71 /* Identifier */) {
	                    // check FunctionLikeDeclaration.locals (stores parameters\function local variable)
	                    // if it contains entry with a specified name
	                    var symbol = resolveName(n, n.escapedText, 67216319 /* Value */ | 2097152 /* Alias */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false);
	                    if (!symbol || symbol === unknownSymbol || !symbol.valueDeclaration) {
	                        return;
	                    }
	                    if (symbol.valueDeclaration === node) {
	                        error(n, ts.Diagnostics.Parameter_0_cannot_be_referenced_in_its_initializer, ts.declarationNameToString(node.name));
	                        return;
	                    }
	                    // locals map for function contain both parameters and function locals
	                    // so we need to do a bit of extra work to check if reference is legal
	                    var enclosingContainer = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	                    if (enclosingContainer === func) {
	                        if (symbol.valueDeclaration.kind === 148 /* Parameter */ ||
	                            symbol.valueDeclaration.kind === 181 /* BindingElement */) {
	                            // it is ok to reference parameter in initializer if either
	                            // - parameter is located strictly on the left of current parameter declaration
	                            if (symbol.valueDeclaration.pos < node.pos) {
	                                return;
	                            }
	                            // - parameter is wrapped in function-like entity
	                            if (ts.findAncestor(n, function (current) {
	                                if (current === node.initializer) {
	                                    return "quit";
	                                }
	                                return ts.isFunctionLike(current.parent) ||
	                                    // computed property names/initializers in instance property declaration of class like entities
	                                    // are executed in constructor and thus deferred
	                                    (current.parent.kind === 151 /* PropertyDeclaration */ &&
	                                        !(ts.hasModifier(current.parent, 32 /* Static */)) &&
	                                        ts.isClassLike(current.parent.parent));
	                            })) {
	                                return;
	                            }
	                            // fall through to report error
	                        }
	                        error(n, ts.Diagnostics.Initializer_of_parameter_0_cannot_reference_identifier_1_declared_after_it, ts.declarationNameToString(node.name), ts.declarationNameToString(n));
	                    }
	                }
	                else {
	                    return ts.forEachChild(n, visit);
	                }
	            }
	        }
	        function convertAutoToAny(type) {
	            return type === autoType ? anyType : type === autoArrayType ? anyArrayType : type;
	        }
	        // Check variable, parameter, or property declaration
	        function checkVariableLikeDeclaration(node) {
	            checkDecorators(node);
	            if (!ts.isBindingElement(node)) {
	                checkSourceElement(node.type);
	            }
	            // JSDoc `function(string, string): string` syntax results in parameters with no name
	            if (!node.name) {
	                return;
	            }
	            // For a computed property, just check the initializer and exit
	            // Do not use hasDynamicName here, because that returns false for well known symbols.
	            // We want to perform checkComputedPropertyName for all computed properties, including
	            // well known symbols.
	            if (node.name.kind === 146 /* ComputedPropertyName */) {
	                checkComputedPropertyName(node.name);
	                if (node.initializer) {
	                    checkExpressionCached(node.initializer);
	                }
	            }
	            if (node.kind === 181 /* BindingElement */) {
	                if (node.parent.kind === 179 /* ObjectBindingPattern */ && languageVersion < 6 /* ESNext */) {
	                    checkExternalEmitHelpers(node, 4 /* Rest */);
	                }
	                // check computed properties inside property names of binding elements
	                if (node.propertyName && node.propertyName.kind === 146 /* ComputedPropertyName */) {
	                    checkComputedPropertyName(node.propertyName);
	                }
	                // check private/protected variable access
	                var parent = node.parent.parent;
	                var parentType = getTypeForBindingElementParent(parent);
	                var name = node.propertyName || node.name;
	                if (!ts.isBindingPattern(name)) {
	                    var property = getPropertyOfType(parentType, ts.getTextOfPropertyName(name));
	                    markPropertyAsReferenced(property, /*nodeForCheckWriteOnly*/ undefined, /*isThisAccess*/ false); // A destructuring is never a write-only reference.
	                    if (parent.initializer && property) {
	                        checkPropertyAccessibility(parent, parent.initializer, parentType, property);
	                    }
	                }
	            }
	            // For a binding pattern, check contained binding elements
	            if (ts.isBindingPattern(node.name)) {
	                if (node.name.kind === 180 /* ArrayBindingPattern */ && languageVersion < 2 /* ES2015 */ && compilerOptions.downlevelIteration) {
	                    checkExternalEmitHelpers(node, 512 /* Read */);
	                }
	                ts.forEach(node.name.elements, checkSourceElement);
	            }
	            // For a parameter declaration with an initializer, error and exit if the containing function doesn't have a body
	            if (node.initializer && ts.getRootDeclaration(node).kind === 148 /* Parameter */ && ts.nodeIsMissing(ts.getContainingFunction(node).body)) {
	                error(node, ts.Diagnostics.A_parameter_initializer_is_only_allowed_in_a_function_or_constructor_implementation);
	                return;
	            }
	            // For a binding pattern, validate the initializer and exit
	            if (ts.isBindingPattern(node.name)) {
	                // Don't validate for-in initializer as it is already an error
	                if (node.initializer && node.parent.parent.kind !== 220 /* ForInStatement */) {
	                    var initializerType = checkExpressionCached(node.initializer);
	                    if (strictNullChecks && node.name.elements.length === 0) {
	                        checkNonNullType(initializerType, node);
	                    }
	                    else {
	                        checkTypeAssignableTo(initializerType, getWidenedTypeForVariableLikeDeclaration(node), node, /*headMessage*/ undefined);
	                    }
	                    checkParameterInitializer(node);
	                }
	                return;
	            }
	            var symbol = getSymbolOfNode(node);
	            var type = convertAutoToAny(getTypeOfSymbol(symbol));
	            if (node === symbol.valueDeclaration) {
	                // Node is the primary declaration of the symbol, just validate the initializer
	                // Don't validate for-in initializer as it is already an error
	                if (node.initializer && node.parent.parent.kind !== 220 /* ForInStatement */) {
	                    var initializer = ts.isInJavaScriptFile(node) && ts.getDeclaredJavascriptInitializer(node) || node.initializer;
	                    checkTypeAssignableTo(checkExpressionCached(initializer), type, node, /*headMessage*/ undefined);
	                    checkParameterInitializer(node);
	                }
	            }
	            else {
	                // Node is a secondary declaration, check that type is identical to primary declaration and check that
	                // initializer is consistent with type associated with the node
	                var declarationType = convertAutoToAny(getWidenedTypeForVariableLikeDeclaration(node));
	                if (type !== unknownType && declarationType !== unknownType &&
	                    !isTypeIdenticalTo(type, declarationType) &&
	                    !(symbol.flags & 67108864 /* JSContainer */)) {
	                    errorNextVariableOrPropertyDeclarationMustHaveSameType(type, node, declarationType);
	                }
	                if (node.initializer) {
	                    checkTypeAssignableTo(checkExpressionCached(node.initializer), declarationType, node, /*headMessage*/ undefined);
	                }
	                if (!areDeclarationFlagsIdentical(node, symbol.valueDeclaration)) {
	                    error(ts.getNameOfDeclaration(symbol.valueDeclaration), ts.Diagnostics.All_declarations_of_0_must_have_identical_modifiers, ts.declarationNameToString(node.name));
	                    error(node.name, ts.Diagnostics.All_declarations_of_0_must_have_identical_modifiers, ts.declarationNameToString(node.name));
	                }
	            }
	            if (node.kind !== 151 /* PropertyDeclaration */ && node.kind !== 150 /* PropertySignature */) {
	                // We know we don't have a binding pattern or computed name here
	                checkExportsOnMergedDeclarations(node);
	                if (node.kind === 231 /* VariableDeclaration */ || node.kind === 181 /* BindingElement */) {
	                    checkVarDeclaredNamesNotShadowed(node);
	                }
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	        }
	        function errorNextVariableOrPropertyDeclarationMustHaveSameType(firstType, nextDeclaration, nextType) {
	            var nextDeclarationName = ts.getNameOfDeclaration(nextDeclaration);
	            var message = nextDeclaration.kind === 151 /* PropertyDeclaration */ || nextDeclaration.kind === 150 /* PropertySignature */
	                ? ts.Diagnostics.Subsequent_property_declarations_must_have_the_same_type_Property_0_must_be_of_type_1_but_here_has_type_2
	                : ts.Diagnostics.Subsequent_variable_declarations_must_have_the_same_type_Variable_0_must_be_of_type_1_but_here_has_type_2;
	            error(nextDeclarationName, message, ts.declarationNameToString(nextDeclarationName), typeToString(firstType), typeToString(nextType));
	        }
	        function areDeclarationFlagsIdentical(left, right) {
	            if ((left.kind === 148 /* Parameter */ && right.kind === 231 /* VariableDeclaration */) ||
	                (left.kind === 231 /* VariableDeclaration */ && right.kind === 148 /* Parameter */)) {
	                // Differences in optionality between parameters and variables are allowed.
	                return true;
	            }
	            if (ts.hasQuestionToken(left) !== ts.hasQuestionToken(right)) {
	                return false;
	            }
	            var interestingFlags = 8 /* Private */ |
	                16 /* Protected */ |
	                256 /* Async */ |
	                128 /* Abstract */ |
	                64 /* Readonly */ |
	                32 /* Static */;
	            return ts.getSelectedModifierFlags(left, interestingFlags) === ts.getSelectedModifierFlags(right, interestingFlags);
	        }
	        function checkVariableDeclaration(node) {
	            checkGrammarVariableDeclaration(node);
	            return checkVariableLikeDeclaration(node);
	        }
	        function checkBindingElement(node) {
	            checkGrammarBindingElement(node);
	            return checkVariableLikeDeclaration(node);
	        }
	        function checkVariableStatement(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && !checkGrammarVariableDeclarationList(node.declarationList))
	                checkGrammarForDisallowedLetOrConstStatement(node);
	            ts.forEach(node.declarationList.declarations, checkSourceElement);
	        }
	        function checkExpressionStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	        }
	        function checkIfStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	            checkSourceElement(node.thenStatement);
	            if (node.thenStatement.kind === 214 /* EmptyStatement */) {
	                error(node.thenStatement, ts.Diagnostics.The_body_of_an_if_statement_cannot_be_the_empty_statement);
	            }
	            checkSourceElement(node.elseStatement);
	        }
	        function checkDoStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkSourceElement(node.statement);
	            checkExpression(node.expression);
	        }
	        function checkWhileStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkExpression(node.expression);
	            checkSourceElement(node.statement);
	        }
	        function checkForStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.initializer && node.initializer.kind === 232 /* VariableDeclarationList */) {
	                    checkGrammarVariableDeclarationList(node.initializer);
	                }
	            }
	            if (node.initializer) {
	                if (node.initializer.kind === 232 /* VariableDeclarationList */) {
	                    ts.forEach(node.initializer.declarations, checkVariableDeclaration);
	                }
	                else {
	                    checkExpression(node.initializer);
	                }
	            }
	            if (node.condition)
	                checkExpression(node.condition);
	            if (node.incrementor)
	                checkExpression(node.incrementor);
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForOfStatement(node) {
	            checkGrammarForInOrForOfStatement(node);
	            if (node.awaitModifier) {
	                var functionFlags = ts.getFunctionFlags(ts.getContainingFunction(node));
	                if ((functionFlags & (4 /* Invalid */ | 2 /* Async */)) === 2 /* Async */ && languageVersion < 6 /* ESNext */) {
	                    // for..await..of in an async function or async generator function prior to ESNext requires the __asyncValues helper
	                    checkExternalEmitHelpers(node, 16384 /* ForAwaitOfIncludes */);
	                }
	            }
	            else if (compilerOptions.downlevelIteration && languageVersion < 2 /* ES2015 */) {
	                // for..of prior to ES2015 requires the __values helper when downlevelIteration is enabled
	                checkExternalEmitHelpers(node, 256 /* ForOfIncludes */);
	            }
	            // Check the LHS and RHS
	            // If the LHS is a declaration, just check it as a variable declaration, which will in turn check the RHS
	            // via checkRightHandSideOfForOf.
	            // If the LHS is an expression, check the LHS, as a destructuring assignment or as a reference.
	            // Then check that the RHS is assignable to it.
	            if (node.initializer.kind === 232 /* VariableDeclarationList */) {
	                checkForInOrForOfVariableDeclaration(node);
	            }
	            else {
	                var varExpr = node.initializer;
	                var iteratedType = checkRightHandSideOfForOf(node.expression, node.awaitModifier);
	                // There may be a destructuring assignment on the left side
	                if (varExpr.kind === 182 /* ArrayLiteralExpression */ || varExpr.kind === 183 /* ObjectLiteralExpression */) {
	                    // iteratedType may be undefined. In this case, we still want to check the structure of
	                    // varExpr, in particular making sure it's a valid LeftHandSideExpression. But we'd like
	                    // to short circuit the type relation checking as much as possible, so we pass the unknownType.
	                    checkDestructuringAssignment(varExpr, iteratedType || unknownType);
	                }
	                else {
	                    var leftType = checkExpression(varExpr);
	                    checkReferenceExpression(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_of_statement_must_be_a_variable_or_a_property_access);
	                    // iteratedType will be undefined if the rightType was missing properties/signatures
	                    // required to get its iteratedType (like [Symbol.iterator] or next). This may be
	                    // because we accessed properties from anyType, or it may have led to an error inside
	                    // getElementTypeOfIterable.
	                    if (iteratedType) {
	                        checkTypeAssignableTo(iteratedType, leftType, varExpr, /*headMessage*/ undefined);
	                    }
	                }
	            }
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForInStatement(node) {
	            // Grammar checking
	            checkGrammarForInOrForOfStatement(node);
	            var rightType = checkNonNullExpression(node.expression);
	            // TypeScript 1.0 spec (April 2014): 5.4
	            // In a 'for-in' statement of the form
	            // for (let VarDecl in Expr) Statement
	            //   VarDecl must be a variable declaration without a type annotation that declares a variable of type Any,
	            //   and Expr must be an expression of type Any, an object type, or a type parameter type.
	            if (node.initializer.kind === 232 /* VariableDeclarationList */) {
	                var variable = node.initializer.declarations[0];
	                if (variable && ts.isBindingPattern(variable.name)) {
	                    error(variable.name, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
	                }
	                checkForInOrForOfVariableDeclaration(node);
	            }
	            else {
	                // In a 'for-in' statement of the form
	                // for (Var in Expr) Statement
	                //   Var must be an expression classified as a reference of type Any or the String primitive type,
	                //   and Expr must be an expression of type Any, an object type, or a type parameter type.
	                var varExpr = node.initializer;
	                var leftType = checkExpression(varExpr);
	                if (varExpr.kind === 182 /* ArrayLiteralExpression */ || varExpr.kind === 183 /* ObjectLiteralExpression */) {
	                    error(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_be_a_destructuring_pattern);
	                }
	                else if (!isTypeAssignableTo(getIndexTypeOrString(rightType), leftType)) {
	                    error(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_of_type_string_or_any);
	                }
	                else {
	                    // run check only former check succeeded to avoid cascading errors
	                    checkReferenceExpression(varExpr, ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_must_be_a_variable_or_a_property_access);
	                }
	            }
	            // unknownType is returned i.e. if node.expression is identifier whose name cannot be resolved
	            // in this case error about missing name is already reported - do not report extra one
	            if (rightType === neverType || !isTypeAssignableToKind(rightType, 134217728 /* NonPrimitive */ | 7372800 /* InstantiableNonPrimitive */)) {
	                error(node.expression, ts.Diagnostics.The_right_hand_side_of_a_for_in_statement_must_be_of_type_any_an_object_type_or_a_type_parameter_but_here_has_type_0, typeToString(rightType));
	            }
	            checkSourceElement(node.statement);
	            if (node.locals) {
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkForInOrForOfVariableDeclaration(iterationStatement) {
	            var variableDeclarationList = iterationStatement.initializer;
	            // checkGrammarForInOrForOfStatement will check that there is exactly one declaration.
	            if (variableDeclarationList.declarations.length >= 1) {
	                var decl = variableDeclarationList.declarations[0];
	                checkVariableDeclaration(decl);
	            }
	        }
	        function checkRightHandSideOfForOf(rhsExpression, awaitModifier) {
	            var expressionType = checkNonNullExpression(rhsExpression);
	            return checkIteratedTypeOrElementType(expressionType, rhsExpression, /*allowStringInput*/ true, awaitModifier !== undefined);
	        }
	        function checkIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables) {
	            if (isTypeAny(inputType)) {
	                return inputType;
	            }
	            return getIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables, /*checkAssignability*/ true) || anyType;
	        }
	        /**
	         * When consuming an iterable type in a for..of, spread, or iterator destructuring assignment
	         * we want to get the iterated type of an iterable for ES2015 or later, or the iterated type
	         * of a iterable (if defined globally) or element type of an array like for ES2015 or earlier.
	         */
	        function getIteratedTypeOrElementType(inputType, errorNode, allowStringInput, allowAsyncIterables, checkAssignability) {
	            if (inputType === neverType) {
	                reportTypeNotIterableError(errorNode, inputType, allowAsyncIterables);
	                return undefined;
	            }
	            var uplevelIteration = languageVersion >= 2 /* ES2015 */;
	            var downlevelIteration = !uplevelIteration && compilerOptions.downlevelIteration;
	            // Get the iterated type of an `Iterable<T>` or `IterableIterator<T>` only in ES2015
	            // or higher, when inside of an async generator or for-await-if, or when
	            // downlevelIteration is requested.
	            if (uplevelIteration || downlevelIteration || allowAsyncIterables) {
	                // We only report errors for an invalid iterable type in ES2015 or higher.
	                var iteratedType = getIteratedTypeOfIterable(inputType, uplevelIteration ? errorNode : undefined, allowAsyncIterables, /*allowSyncIterables*/ true, checkAssignability);
	                if (iteratedType || uplevelIteration) {
	                    return iteratedType;
	                }
	            }
	            var arrayType = inputType;
	            var reportedError = false;
	            var hasStringConstituent = false;
	            // If strings are permitted, remove any string-like constituents from the array type.
	            // This allows us to find other non-string element types from an array unioned with
	            // a string.
	            if (allowStringInput) {
	                if (arrayType.flags & 131072 /* Union */) {
	                    // After we remove all types that are StringLike, we will know if there was a string constituent
	                    // based on whether the result of filter is a new array.
	                    var arrayTypes = inputType.types;
	                    var filteredTypes = ts.filter(arrayTypes, function (t) { return !(t.flags & 34 /* StringLike */); });
	                    if (filteredTypes !== arrayTypes) {
	                        arrayType = getUnionType(filteredTypes, 2 /* Subtype */);
	                    }
	                }
	                else if (arrayType.flags & 34 /* StringLike */) {
	                    arrayType = neverType;
	                }
	                hasStringConstituent = arrayType !== inputType;
	                if (hasStringConstituent) {
	                    if (languageVersion < 1 /* ES5 */) {
	                        if (errorNode) {
	                            error(errorNode, ts.Diagnostics.Using_a_string_in_a_for_of_statement_is_only_supported_in_ECMAScript_5_and_higher);
	                            reportedError = true;
	                        }
	                    }
	                    // Now that we've removed all the StringLike types, if no constituents remain, then the entire
	                    // arrayOrStringType was a string.
	                    if (arrayType.flags & 16384 /* Never */) {
	                        return stringType;
	                    }
	                }
	            }
	            if (!isArrayLikeType(arrayType)) {
	                if (errorNode && !reportedError) {
	                    // Which error we report depends on whether we allow strings or if there was a
	                    // string constituent. For example, if the input type is number | string, we
	                    // want to say that number is not an array type. But if the input was just
	                    // number and string input is allowed, we want to say that number is not an
	                    // array type or a string type.
	                    var isIterable = !!getIteratedTypeOfIterable(inputType, /* errorNode */ undefined, allowAsyncIterables, /*allowSyncIterables*/ true, checkAssignability);
	                    var diagnostic = !allowStringInput || hasStringConstituent
	                        ? downlevelIteration
	                            ? ts.Diagnostics.Type_0_is_not_an_array_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator
	                            : isIterable
	                                ? ts.Diagnostics.Type_0_is_not_an_array_type_Use_compiler_option_downlevelIteration_to_allow_iterating_of_iterators
	                                : ts.Diagnostics.Type_0_is_not_an_array_type
	                        : downlevelIteration
	                            ? ts.Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_or_does_not_have_a_Symbol_iterator_method_that_returns_an_iterator
	                            : isIterable
	                                ? ts.Diagnostics.Type_0_is_not_an_array_type_or_a_string_type_Use_compiler_option_downlevelIteration_to_allow_iterating_of_iterators
	                                : ts.Diagnostics.Type_0_is_not_an_array_type_or_a_string_type;
	                    error(errorNode, diagnostic, typeToString(arrayType));
	                }
	                return hasStringConstituent ? stringType : undefined;
	            }
	            var arrayElementType = getIndexTypeOfType(arrayType, 1 /* Number */);
	            if (hasStringConstituent && arrayElementType) {
	                // This is just an optimization for the case where arrayOrStringType is string | string[]
	                if (arrayElementType.flags & 34 /* StringLike */) {
	                    return stringType;
	                }
	                return getUnionType([arrayElementType, stringType], 2 /* Subtype */);
	            }
	            return arrayElementType;
	        }
	        /**
	         * We want to treat type as an iterable, and get the type it is an iterable of. The iterable
	         * must have the following structure (annotated with the names of the variables below):
	         *
	         *     { // iterable
	         *         [Symbol.iterator]: { // iteratorMethod
	         *             (): Iterator<T>
	         *         }
	         *     }
	         *
	         * For an async iterable, we expect the following structure:
	         *
	         *     { // iterable
	         *         [Symbol.asyncIterator]: { // iteratorMethod
	         *             (): AsyncIterator<T>
	         *         }
	         *     }
	         *
	         * T is the type we are after. At every level that involves analyzing return types
	         * of signatures, we union the return types of all the signatures.
	         *
	         * Another thing to note is that at any step of this process, we could run into a dead end,
	         * meaning either the property is missing, or we run into the anyType. If either of these things
	         * happens, we return undefined to signal that we could not find the iterated type. If a property
	         * is missing, and the previous step did not result in 'any', then we also give an error if the
	         * caller requested it. Then the caller can decide what to do in the case where there is no iterated
	         * type. This is different from returning anyType, because that would signify that we have matched the
	         * whole pattern and that T (above) is 'any'.
	         *
	         * For a **for-of** statement, `yield*` (in a normal generator), spread, array
	         * destructuring, or normal generator we will only ever look for a `[Symbol.iterator]()`
	         * method.
	         *
	         * For an async generator we will only ever look at the `[Symbol.asyncIterator]()` method.
	         *
	         * For a **for-await-of** statement or a `yield*` in an async generator we will look for
	         * the `[Symbol.asyncIterator]()` method first, and then the `[Symbol.iterator]()` method.
	         */
	        function getIteratedTypeOfIterable(type, errorNode, allowAsyncIterables, allowSyncIterables, checkAssignability) {
	            if (isTypeAny(type)) {
	                return undefined;
	            }
	            return mapType(type, getIteratedType);
	            function getIteratedType(type) {
	                var typeAsIterable = type;
	                if (allowAsyncIterables) {
	                    if (typeAsIterable.iteratedTypeOfAsyncIterable) {
	                        return typeAsIterable.iteratedTypeOfAsyncIterable;
	                    }
	                    // As an optimization, if the type is an instantiation of the global `AsyncIterable<T>`
	                    // or the global `AsyncIterableIterator<T>` then just grab its type argument.
	                    if (isReferenceToType(type, getGlobalAsyncIterableType(/*reportErrors*/ false)) ||
	                        isReferenceToType(type, getGlobalAsyncIterableIteratorType(/*reportErrors*/ false))) {
	                        return typeAsIterable.iteratedTypeOfAsyncIterable = type.typeArguments[0];
	                    }
	                }
	                if (allowSyncIterables) {
	                    if (typeAsIterable.iteratedTypeOfIterable) {
	                        return typeAsIterable.iteratedTypeOfIterable;
	                    }
	                    // As an optimization, if the type is an instantiation of the global `Iterable<T>` or
	                    // `IterableIterator<T>` then just grab its type argument.
	                    if (isReferenceToType(type, getGlobalIterableType(/*reportErrors*/ false)) ||
	                        isReferenceToType(type, getGlobalIterableIteratorType(/*reportErrors*/ false))) {
	                        return typeAsIterable.iteratedTypeOfIterable = type.typeArguments[0];
	                    }
	                }
	                var asyncMethodType = allowAsyncIterables && getTypeOfPropertyOfType(type, ts.getPropertyNameForKnownSymbolName("asyncIterator"));
	                var methodType = asyncMethodType || (allowSyncIterables && getTypeOfPropertyOfType(type, ts.getPropertyNameForKnownSymbolName("iterator")));
	                if (isTypeAny(methodType)) {
	                    return undefined;
	                }
	                var signatures = methodType && getSignaturesOfType(methodType, 0 /* Call */);
	                if (!ts.some(signatures)) {
	                    if (errorNode) {
	                        // only report on the first error
	                        reportTypeNotIterableError(errorNode, type, allowAsyncIterables);
	                        errorNode = undefined;
	                    }
	                    return undefined;
	                }
	                var returnType = getUnionType(ts.map(signatures, getReturnTypeOfSignature), 2 /* Subtype */);
	                var iteratedType = getIteratedTypeOfIterator(returnType, errorNode, /*isAsyncIterator*/ !!asyncMethodType);
	                if (checkAssignability && errorNode && iteratedType) {
	                    // If `checkAssignability` was specified, we were called from
	                    // `checkIteratedTypeOrElementType`. As such, we need to validate that
	                    // the type passed in is actually an Iterable.
	                    checkTypeAssignableTo(type, asyncMethodType
	                        ? createAsyncIterableType(iteratedType)
	                        : createIterableType(iteratedType), errorNode);
	                }
	                return asyncMethodType
	                    ? typeAsIterable.iteratedTypeOfAsyncIterable = iteratedType
	                    : typeAsIterable.iteratedTypeOfIterable = iteratedType;
	            }
	        }
	        function reportTypeNotIterableError(errorNode, type, allowAsyncIterables) {
	            error(errorNode, allowAsyncIterables
	                ? ts.Diagnostics.Type_0_must_have_a_Symbol_asyncIterator_method_that_returns_an_async_iterator
	                : ts.Diagnostics.Type_0_must_have_a_Symbol_iterator_method_that_returns_an_iterator, typeToString(type));
	        }
	        /**
	         * This function has very similar logic as getIteratedTypeOfIterable, except that it operates on
	         * Iterators instead of Iterables. Here is the structure:
	         *
	         *  { // iterator
	         *      next: { // nextMethod
	         *          (): { // nextResult
	         *              value: T // nextValue
	         *          }
	         *      }
	         *  }
	         *
	         * For an async iterator, we expect the following structure:
	         *
	         *  { // iterator
	         *      next: { // nextMethod
	         *          (): PromiseLike<{ // nextResult
	         *              value: T // nextValue
	         *          }>
	         *      }
	         *  }
	         */
	        function getIteratedTypeOfIterator(type, errorNode, isAsyncIterator) {
	            if (isTypeAny(type)) {
	                return undefined;
	            }
	            var typeAsIterator = type;
	            if (isAsyncIterator ? typeAsIterator.iteratedTypeOfAsyncIterator : typeAsIterator.iteratedTypeOfIterator) {
	                return isAsyncIterator ? typeAsIterator.iteratedTypeOfAsyncIterator : typeAsIterator.iteratedTypeOfIterator;
	            }
	            // As an optimization, if the type is an instantiation of the global `Iterator<T>` (for
	            // a non-async iterator) or the global `AsyncIterator<T>` (for an async-iterator) then
	            // just grab its type argument.
	            var getIteratorType = isAsyncIterator ? getGlobalAsyncIteratorType : getGlobalIteratorType;
	            if (isReferenceToType(type, getIteratorType(/*reportErrors*/ false))) {
	                return isAsyncIterator
	                    ? typeAsIterator.iteratedTypeOfAsyncIterator = type.typeArguments[0]
	                    : typeAsIterator.iteratedTypeOfIterator = type.typeArguments[0];
	            }
	            // Both async and non-async iterators must have a `next` method.
	            var nextMethod = getTypeOfPropertyOfType(type, "next");
	            if (isTypeAny(nextMethod)) {
	                return undefined;
	            }
	            var nextMethodSignatures = nextMethod ? getSignaturesOfType(nextMethod, 0 /* Call */) : ts.emptyArray;
	            if (nextMethodSignatures.length === 0) {
	                if (errorNode) {
	                    error(errorNode, isAsyncIterator
	                        ? ts.Diagnostics.An_async_iterator_must_have_a_next_method
	                        : ts.Diagnostics.An_iterator_must_have_a_next_method);
	                }
	                return undefined;
	            }
	            var nextResult = getUnionType(ts.map(nextMethodSignatures, getReturnTypeOfSignature), 2 /* Subtype */);
	            if (isTypeAny(nextResult)) {
	                return undefined;
	            }
	            // For an async iterator, we must get the awaited type of the return type.
	            if (isAsyncIterator) {
	                nextResult = getAwaitedTypeOfPromise(nextResult, errorNode, ts.Diagnostics.The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property);
	                if (isTypeAny(nextResult)) {
	                    return undefined;
	                }
	            }
	            var nextValue = nextResult && getTypeOfPropertyOfType(nextResult, "value");
	            if (!nextValue) {
	                if (errorNode) {
	                    error(errorNode, isAsyncIterator
	                        ? ts.Diagnostics.The_type_returned_by_the_next_method_of_an_async_iterator_must_be_a_promise_for_a_type_with_a_value_property
	                        : ts.Diagnostics.The_type_returned_by_the_next_method_of_an_iterator_must_have_a_value_property);
	                }
	                return undefined;
	            }
	            return isAsyncIterator
	                ? typeAsIterator.iteratedTypeOfAsyncIterator = nextValue
	                : typeAsIterator.iteratedTypeOfIterator = nextValue;
	        }
	        /**
	         * A generator may have a return type of `Iterator<T>`, `Iterable<T>`, or
	         * `IterableIterator<T>`. An async generator may have a return type of `AsyncIterator<T>`,
	         * `AsyncIterable<T>`, or `AsyncIterableIterator<T>`. This function can be used to extract
	         * the iterated type from this return type for contextual typing and verifying signatures.
	         */
	        function getIteratedTypeOfGenerator(returnType, isAsyncGenerator) {
	            if (isTypeAny(returnType)) {
	                return undefined;
	            }
	            return getIteratedTypeOfIterable(returnType, /*errorNode*/ undefined, /*allowAsyncIterables*/ isAsyncGenerator, /*allowSyncIterables*/ !isAsyncGenerator, /*checkAssignability*/ false)
	                || getIteratedTypeOfIterator(returnType, /*errorNode*/ undefined, isAsyncGenerator);
	        }
	        function checkBreakOrContinueStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node))
	                checkGrammarBreakOrContinueStatement(node);
	            // TODO: Check that target label is valid
	        }
	        function isGetAccessorWithAnnotatedSetAccessor(node) {
	            return node.kind === 155 /* GetAccessor */
	                && ts.getEffectiveSetAccessorTypeAnnotationNode(ts.getDeclarationOfKind(node.symbol, 156 /* SetAccessor */)) !== undefined;
	        }
	        function isUnwrappedReturnTypeVoidOrAny(func, returnType) {
	            var unwrappedReturnType = (ts.getFunctionFlags(func) & 3 /* AsyncGenerator */) === 2 /* Async */
	                ? getPromisedTypeOfPromise(returnType) // Async function
	                : returnType; // AsyncGenerator function, Generator function, or normal function
	            return unwrappedReturnType && maybeTypeOfKind(unwrappedReturnType, 2048 /* Void */ | 1 /* Any */);
	        }
	        function checkReturnStatement(node) {
	            // Grammar checking
	            if (checkGrammarStatementInAmbientContext(node)) {
	                return;
	            }
	            var func = ts.getContainingFunction(node);
	            if (!func) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.A_return_statement_can_only_be_used_within_a_function_body);
	                return;
	            }
	            var signature = getSignatureFromDeclaration(func);
	            var returnType = getReturnTypeOfSignature(signature);
	            var functionFlags = ts.getFunctionFlags(func);
	            var isGenerator = functionFlags & 1 /* Generator */;
	            if (strictNullChecks || node.expression || returnType.flags & 16384 /* Never */) {
	                var exprType = node.expression ? checkExpressionCached(node.expression) : undefinedType;
	                if (isGenerator) { // AsyncGenerator function or Generator function
	                    // A generator does not need its return expressions checked against its return type.
	                    // Instead, the yield expressions are checked against the element type.
	                    // TODO: Check return types of generators when return type tracking is added
	                    // for generators.
	                    return;
	                }
	                else if (func.kind === 156 /* SetAccessor */) {
	                    if (node.expression) {
	                        error(node, ts.Diagnostics.Setters_cannot_return_a_value);
	                    }
	                }
	                else if (func.kind === 154 /* Constructor */) {
	                    if (node.expression && !checkTypeAssignableTo(exprType, returnType, node)) {
	                        error(node, ts.Diagnostics.Return_type_of_constructor_signature_must_be_assignable_to_the_instance_type_of_the_class);
	                    }
	                }
	                else if (ts.getEffectiveReturnTypeNode(func) || isGetAccessorWithAnnotatedSetAccessor(func)) {
	                    if (functionFlags & 2 /* Async */) { // Async function
	                        var promisedType = getPromisedTypeOfPromise(returnType);
	                        var awaitedType = checkAwaitedType(exprType, node, ts.Diagnostics.The_return_type_of_an_async_function_must_either_be_a_valid_promise_or_must_not_contain_a_callable_then_member);
	                        if (promisedType) {
	                            // If the function has a return type, but promisedType is
	                            // undefined, an error will be reported in checkAsyncFunctionReturnType
	                            // so we don't need to report one here.
	                            checkTypeAssignableTo(awaitedType, promisedType, node);
	                        }
	                    }
	                    else {
	                        checkTypeAssignableTo(exprType, returnType, node);
	                    }
	                }
	            }
	            else if (func.kind !== 154 /* Constructor */ && compilerOptions.noImplicitReturns && !isUnwrappedReturnTypeVoidOrAny(func, returnType) && !isGenerator) {
	                // The function has a return type, but the return statement doesn't have an expression.
	                error(node, ts.Diagnostics.Not_all_code_paths_return_a_value);
	            }
	        }
	        function checkWithStatement(node) {
	            // Grammar checking for withStatement
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.flags & 16384 /* AwaitContext */) {
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.with_statements_are_not_allowed_in_an_async_function_block);
	                }
	            }
	            checkExpression(node.expression);
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var start = ts.getSpanOfTokenAtPosition(sourceFile, node.pos).start;
	                var end = node.statement.pos;
	                grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.The_with_statement_is_not_supported_All_symbols_in_a_with_block_will_have_type_any);
	            }
	        }
	        function checkSwitchStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            var firstDefaultClause;
	            var hasDuplicateDefaultClause = false;
	            var expressionType = checkExpression(node.expression);
	            var expressionIsLiteral = isLiteralType(expressionType);
	            ts.forEach(node.caseBlock.clauses, function (clause) {
	                // Grammar check for duplicate default clauses, skip if we already report duplicate default clause
	                if (clause.kind === 266 /* DefaultClause */ && !hasDuplicateDefaultClause) {
	                    if (firstDefaultClause === undefined) {
	                        firstDefaultClause = clause;
	                    }
	                    else {
	                        var sourceFile = ts.getSourceFileOfNode(node);
	                        var start = ts.skipTrivia(sourceFile.text, clause.pos);
	                        var end = clause.statements.length > 0 ? clause.statements[0].pos : clause.end;
	                        grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.A_default_clause_cannot_appear_more_than_once_in_a_switch_statement);
	                        hasDuplicateDefaultClause = true;
	                    }
	                }
	                if (produceDiagnostics && clause.kind === 265 /* CaseClause */) {
	                    // TypeScript 1.0 spec (April 2014): 5.9
	                    // In a 'switch' statement, each 'case' expression must be of a type that is comparable
	                    // to or from the type of the 'switch' expression.
	                    var caseType = checkExpression(clause.expression);
	                    var caseIsLiteral = isLiteralType(caseType);
	                    var comparedExpressionType = expressionType;
	                    if (!caseIsLiteral || !expressionIsLiteral) {
	                        caseType = caseIsLiteral ? getBaseTypeOfLiteralType(caseType) : caseType;
	                        comparedExpressionType = getBaseTypeOfLiteralType(expressionType);
	                    }
	                    if (!isTypeEqualityComparableTo(comparedExpressionType, caseType)) {
	                        // expressionType is not comparable to caseType, try the reversed check and report errors if it fails
	                        checkTypeComparableTo(caseType, comparedExpressionType, clause.expression, /*headMessage*/ undefined);
	                    }
	                }
	                ts.forEach(clause.statements, checkSourceElement);
	            });
	            if (node.caseBlock.locals) {
	                registerForUnusedIdentifiersCheck(node.caseBlock);
	            }
	        }
	        function checkLabeledStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                ts.findAncestor(node.parent, function (current) {
	                    if (ts.isFunctionLike(current)) {
	                        return "quit";
	                    }
	                    if (current.kind === 227 /* LabeledStatement */ && current.label.escapedText === node.label.escapedText) {
	                        grammarErrorOnNode(node.label, ts.Diagnostics.Duplicate_label_0, ts.getTextOfNode(node.label));
	                        return true;
	                    }
	                });
	            }
	            // ensure that label is unique
	            checkSourceElement(node.statement);
	        }
	        function checkThrowStatement(node) {
	            // Grammar checking
	            if (!checkGrammarStatementInAmbientContext(node)) {
	                if (node.expression === undefined) {
	                    grammarErrorAfterFirstToken(node, ts.Diagnostics.Line_break_not_permitted_here);
	                }
	            }
	            if (node.expression) {
	                checkExpression(node.expression);
	            }
	        }
	        function checkTryStatement(node) {
	            // Grammar checking
	            checkGrammarStatementInAmbientContext(node);
	            checkBlock(node.tryBlock);
	            var catchClause = node.catchClause;
	            if (catchClause) {
	                // Grammar checking
	                if (catchClause.variableDeclaration) {
	                    if (catchClause.variableDeclaration.type) {
	                        grammarErrorOnFirstToken(catchClause.variableDeclaration.type, ts.Diagnostics.Catch_clause_variable_cannot_have_a_type_annotation);
	                    }
	                    else if (catchClause.variableDeclaration.initializer) {
	                        grammarErrorOnFirstToken(catchClause.variableDeclaration.initializer, ts.Diagnostics.Catch_clause_variable_cannot_have_an_initializer);
	                    }
	                    else {
	                        var blockLocals_1 = catchClause.block.locals;
	                        if (blockLocals_1) {
	                            ts.forEachKey(catchClause.locals, function (caughtName) {
	                                var blockLocal = blockLocals_1.get(caughtName);
	                                if (blockLocal && (blockLocal.flags & 2 /* BlockScopedVariable */) !== 0) {
	                                    grammarErrorOnNode(blockLocal.valueDeclaration, ts.Diagnostics.Cannot_redeclare_identifier_0_in_catch_clause, caughtName);
	                                }
	                            });
	                        }
	                    }
	                }
	                checkBlock(catchClause.block);
	            }
	            if (node.finallyBlock) {
	                checkBlock(node.finallyBlock);
	            }
	        }
	        function checkIndexConstraints(type) {
	            var declaredNumberIndexer = getIndexDeclarationOfSymbol(type.symbol, 1 /* Number */);
	            var declaredStringIndexer = getIndexDeclarationOfSymbol(type.symbol, 0 /* String */);
	            var stringIndexType = getIndexTypeOfType(type, 0 /* String */);
	            var numberIndexType = getIndexTypeOfType(type, 1 /* Number */);
	            if (stringIndexType || numberIndexType) {
	                ts.forEach(getPropertiesOfObjectType(type), function (prop) {
	                    var propType = getTypeOfSymbol(prop);
	                    checkIndexConstraintForProperty(prop, propType, type, declaredStringIndexer, stringIndexType, 0 /* String */);
	                    checkIndexConstraintForProperty(prop, propType, type, declaredNumberIndexer, numberIndexType, 1 /* Number */);
	                });
	                if (ts.getObjectFlags(type) & 1 /* Class */ && ts.isClassLike(type.symbol.valueDeclaration)) {
	                    var classDeclaration = type.symbol.valueDeclaration;
	                    for (var _i = 0, _a = classDeclaration.members; _i < _a.length; _i++) {
	                        var member = _a[_i];
	                        // Only process instance properties with computed names here.
	                        // Static properties cannot be in conflict with indexers,
	                        // and properties with literal names were already checked.
	                        if (!ts.hasModifier(member, 32 /* Static */) && hasNonBindableDynamicName(member)) {
	                            var symbol = getSymbolOfNode(member);
	                            var propType = getTypeOfSymbol(symbol);
	                            checkIndexConstraintForProperty(symbol, propType, type, declaredStringIndexer, stringIndexType, 0 /* String */);
	                            checkIndexConstraintForProperty(symbol, propType, type, declaredNumberIndexer, numberIndexType, 1 /* Number */);
	                        }
	                    }
	                }
	            }
	            var errorNode;
	            if (stringIndexType && numberIndexType) {
	                errorNode = declaredNumberIndexer || declaredStringIndexer;
	                // condition 'errorNode === undefined' may appear if types does not declare nor string neither number indexer
	                if (!errorNode && (ts.getObjectFlags(type) & 2 /* Interface */)) {
	                    var someBaseTypeHasBothIndexers = ts.forEach(getBaseTypes(type), function (base) { return getIndexTypeOfType(base, 0 /* String */) && getIndexTypeOfType(base, 1 /* Number */); });
	                    errorNode = someBaseTypeHasBothIndexers ? undefined : type.symbol.declarations[0];
	                }
	            }
	            if (errorNode && !isTypeAssignableTo(numberIndexType, stringIndexType)) {
	                error(errorNode, ts.Diagnostics.Numeric_index_type_0_is_not_assignable_to_string_index_type_1, typeToString(numberIndexType), typeToString(stringIndexType));
	            }
	            function checkIndexConstraintForProperty(prop, propertyType, containingType, indexDeclaration, indexType, indexKind) {
	                // ESSymbol properties apply to neither string nor numeric indexers.
	                if (!indexType || ts.isKnownSymbol(prop)) {
	                    return;
	                }
	                var propDeclaration = prop.valueDeclaration;
	                // index is numeric and property name is not valid numeric literal
	                if (indexKind === 1 /* Number */ && !(propDeclaration ? isNumericName(ts.getNameOfDeclaration(propDeclaration)) : isNumericLiteralName(prop.escapedName))) {
	                    return;
	                }
	                // perform property check if property or indexer is declared in 'type'
	                // this allows us to rule out cases when both property and indexer are inherited from the base class
	                var errorNode;
	                if (propDeclaration &&
	                    (propDeclaration.kind === 199 /* BinaryExpression */ ||
	                        ts.getNameOfDeclaration(propDeclaration).kind === 146 /* ComputedPropertyName */ ||
	                        prop.parent === containingType.symbol)) {
	                    errorNode = propDeclaration;
	                }
	                else if (indexDeclaration) {
	                    errorNode = indexDeclaration;
	                }
	                else if (ts.getObjectFlags(containingType) & 2 /* Interface */) {
	                    // for interfaces property and indexer might be inherited from different bases
	                    // check if any base class already has both property and indexer.
	                    // check should be performed only if 'type' is the first type that brings property\indexer together
	                    var someBaseClassHasBothPropertyAndIndexer = ts.forEach(getBaseTypes(containingType), function (base) { return getPropertyOfObjectType(base, prop.escapedName) && getIndexTypeOfType(base, indexKind); });
	                    errorNode = someBaseClassHasBothPropertyAndIndexer ? undefined : containingType.symbol.declarations[0];
	                }
	                if (errorNode && !isTypeAssignableTo(propertyType, indexType)) {
	                    var errorMessage = indexKind === 0 /* String */
	                        ? ts.Diagnostics.Property_0_of_type_1_is_not_assignable_to_string_index_type_2
	                        : ts.Diagnostics.Property_0_of_type_1_is_not_assignable_to_numeric_index_type_2;
	                    error(errorNode, errorMessage, symbolToString(prop), typeToString(propertyType), typeToString(indexType));
	                }
	            }
	        }
	        function checkTypeNameIsReserved(name, message) {
	            // TS 1.0 spec (April 2014): 3.6.1
	            // The predefined type keywords are reserved and cannot be used as names of user defined types.
	            switch (name.escapedText) {
	                case "any":
	                case "number":
	                case "boolean":
	                case "string":
	                case "symbol":
	                case "void":
	                case "object":
	                    error(name, message, name.escapedText);
	            }
	        }
	        /**
	         * Check each type parameter and check that type parameters have no duplicate type parameter declarations
	         */
	        function checkTypeParameters(typeParameterDeclarations) {
	            if (typeParameterDeclarations) {
	                var seenDefault = false;
	                for (var i = 0; i < typeParameterDeclarations.length; i++) {
	                    var node = typeParameterDeclarations[i];
	                    checkTypeParameter(node);
	                    if (produceDiagnostics) {
	                        if (node.default) {
	                            seenDefault = true;
	                        }
	                        else if (seenDefault) {
	                            error(node, ts.Diagnostics.Required_type_parameters_may_not_follow_optional_type_parameters);
	                        }
	                        for (var j = 0; j < i; j++) {
	                            if (typeParameterDeclarations[j].symbol === node.symbol) {
	                                error(node.name, ts.Diagnostics.Duplicate_identifier_0, ts.declarationNameToString(node.name));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /** Check that type parameter lists are identical across multiple declarations */
	        function checkTypeParameterListsIdentical(symbol) {
	            if (symbol.declarations.length === 1) {
	                return;
	            }
	            var links = getSymbolLinks(symbol);
	            if (!links.typeParametersChecked) {
	                links.typeParametersChecked = true;
	                var declarations = getClassOrInterfaceDeclarationsOfSymbol(symbol);
	                if (declarations.length <= 1) {
	                    return;
	                }
	                var type = getDeclaredTypeOfSymbol(symbol);
	                if (!areTypeParametersIdentical(declarations, type.localTypeParameters)) {
	                    // Report an error on every conflicting declaration.
	                    var name = symbolToString(symbol);
	                    for (var _i = 0, declarations_6 = declarations; _i < declarations_6.length; _i++) {
	                        var declaration = declarations_6[_i];
	                        error(declaration.name, ts.Diagnostics.All_declarations_of_0_must_have_identical_type_parameters, name);
	                    }
	                }
	            }
	        }
	        function areTypeParametersIdentical(declarations, targetParameters) {
	            var maxTypeArgumentCount = ts.length(targetParameters);
	            var minTypeArgumentCount = getMinTypeArgumentCount(targetParameters);
	            for (var _i = 0, declarations_7 = declarations; _i < declarations_7.length; _i++) {
	                var declaration = declarations_7[_i];
	                // If this declaration has too few or too many type parameters, we report an error
	                var sourceParameters = ts.getEffectiveTypeParameterDeclarations(declaration);
	                var numTypeParameters = sourceParameters.length;
	                if (numTypeParameters < minTypeArgumentCount || numTypeParameters > maxTypeArgumentCount) {
	                    return false;
	                }
	                for (var i = 0; i < numTypeParameters; i++) {
	                    var source = sourceParameters[i];
	                    var target = targetParameters[i];
	                    // If the type parameter node does not have the same as the resolved type
	                    // parameter at this position, we report an error.
	                    if (source.name.escapedText !== target.symbol.escapedName) {
	                        return false;
	                    }
	                    // If the type parameter node does not have an identical constraint as the resolved
	                    // type parameter at this position, we report an error.
	                    var sourceConstraint = source.constraint && getTypeFromTypeNode(source.constraint);
	                    var targetConstraint = getConstraintFromTypeParameter(target);
	                    if (sourceConstraint) {
	                        // relax check if later interface augmentation has no constraint
	                        if (!targetConstraint || !isTypeIdenticalTo(sourceConstraint, targetConstraint)) {
	                            return false;
	                        }
	                    }
	                    // If the type parameter node has a default and it is not identical to the default
	                    // for the type parameter at this position, we report an error.
	                    var sourceDefault = source.default && getTypeFromTypeNode(source.default);
	                    var targetDefault = getDefaultFromTypeParameter(target);
	                    if (sourceDefault && targetDefault && !isTypeIdenticalTo(sourceDefault, targetDefault)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        function checkClassExpression(node) {
	            checkClassLikeDeclaration(node);
	            checkNodeDeferred(node);
	            return getTypeOfSymbol(getSymbolOfNode(node));
	        }
	        function checkClassExpressionDeferred(node) {
	            ts.forEach(node.members, checkSourceElement);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function checkClassDeclaration(node) {
	            if (!node.name && !ts.hasModifier(node, 512 /* Default */)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.A_class_declaration_without_the_default_modifier_must_have_a_name);
	            }
	            checkClassLikeDeclaration(node);
	            ts.forEach(node.members, checkSourceElement);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function checkClassLikeDeclaration(node) {
	            checkGrammarClassLikeDeclaration(node);
	            checkDecorators(node);
	            if (node.name) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Class_name_cannot_be_0);
	                checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            }
	            checkTypeParameters(ts.getEffectiveTypeParameterDeclarations(node));
	            checkExportsOnMergedDeclarations(node);
	            var symbol = getSymbolOfNode(node);
	            var type = getDeclaredTypeOfSymbol(symbol);
	            var typeWithThis = getTypeWithThisArgument(type);
	            var staticType = getTypeOfSymbol(symbol);
	            checkTypeParameterListsIdentical(symbol);
	            checkClassForDuplicateDeclarations(node);
	            // Only check for reserved static identifiers on non-ambient context.
	            if (!(node.flags & 4194304 /* Ambient */)) {
	                checkClassForStaticPropertyNameConflicts(node);
	            }
	            var baseTypeNode = ts.getClassExtendsHeritageClauseElement(node);
	            if (baseTypeNode) {
	                if (languageVersion < 2 /* ES2015 */) {
	                    checkExternalEmitHelpers(baseTypeNode.parent, 1 /* Extends */);
	                }
	                var baseTypes = getBaseTypes(type);
	                if (baseTypes.length && produceDiagnostics) {
	                    var baseType_1 = baseTypes[0];
	                    var baseConstructorType = getBaseConstructorTypeOfClass(type);
	                    var staticBaseType = getApparentType(baseConstructorType);
	                    checkBaseTypeAccessibility(staticBaseType, baseTypeNode);
	                    checkSourceElement(baseTypeNode.expression);
	                    if (ts.some(baseTypeNode.typeArguments)) {
	                        ts.forEach(baseTypeNode.typeArguments, checkSourceElement);
	                        for (var _i = 0, _a = getConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode); _i < _a.length; _i++) {
	                            var constructor = _a[_i];
	                            if (!checkTypeArgumentConstraints(baseTypeNode, constructor.typeParameters)) {
	                                break;
	                            }
	                        }
	                    }
	                    var baseWithThis = getTypeWithThisArgument(baseType_1, type.thisType);
	                    if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ undefined)) {
	                        issueMemberSpecificError(node, typeWithThis, baseWithThis, ts.Diagnostics.Class_0_incorrectly_extends_base_class_1);
	                    }
	                    checkTypeAssignableTo(staticType, getTypeWithoutSignatures(staticBaseType), node.name || node, ts.Diagnostics.Class_static_side_0_incorrectly_extends_base_class_static_side_1);
	                    if (baseConstructorType.flags & 1081344 /* TypeVariable */ && !isMixinConstructorType(staticType)) {
	                        error(node.name || node, ts.Diagnostics.A_mixin_class_must_have_a_constructor_with_a_single_rest_parameter_of_type_any);
	                    }
	                    if (!(staticBaseType.symbol && staticBaseType.symbol.flags & 32 /* Class */) && !(baseConstructorType.flags & 1081344 /* TypeVariable */)) {
	                        // When the static base type is a "class-like" constructor function (but not actually a class), we verify
	                        // that all instantiated base constructor signatures return the same type. We can simply compare the type
	                        // references (as opposed to checking the structure of the types) because elsewhere we have already checked
	                        // that the base type is a class or interface type (and not, for example, an anonymous object type).
	                        var constructors = getInstantiatedConstructorsForTypeArguments(staticBaseType, baseTypeNode.typeArguments, baseTypeNode);
	                        if (ts.forEach(constructors, function (sig) { return getReturnTypeOfSignature(sig) !== baseType_1; })) {
	                            error(baseTypeNode.expression, ts.Diagnostics.Base_constructors_must_all_have_the_same_return_type);
	                        }
	                    }
	                    checkKindsOfPropertyMemberOverrides(type, baseType_1);
	                }
	            }
	            var implementedTypeNodes = ts.getClassImplementsHeritageClauseElements(node);
	            if (implementedTypeNodes) {
	                for (var _b = 0, implementedTypeNodes_1 = implementedTypeNodes; _b < implementedTypeNodes_1.length; _b++) {
	                    var typeRefNode = implementedTypeNodes_1[_b];
	                    if (!ts.isEntityNameExpression(typeRefNode.expression)) {
	                        error(typeRefNode.expression, ts.Diagnostics.A_class_can_only_implement_an_identifier_Slashqualified_name_with_optional_type_arguments);
	                    }
	                    checkTypeReferenceNode(typeRefNode);
	                    if (produceDiagnostics) {
	                        var t = getTypeFromTypeNode(typeRefNode);
	                        if (t !== unknownType) {
	                            if (isValidBaseType(t)) {
	                                var genericDiag = t.symbol && t.symbol.flags & 32 /* Class */ ?
	                                    ts.Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass :
	                                    ts.Diagnostics.Class_0_incorrectly_implements_interface_1;
	                                var baseWithThis = getTypeWithThisArgument(t, type.thisType);
	                                if (!checkTypeAssignableTo(typeWithThis, baseWithThis, /*errorNode*/ undefined)) {
	                                    issueMemberSpecificError(node, typeWithThis, baseWithThis, genericDiag);
	                                }
	                            }
	                            else {
	                                error(typeRefNode, ts.Diagnostics.A_class_may_only_implement_another_class_or_interface);
	                            }
	                        }
	                    }
	                }
	            }
	            if (produceDiagnostics) {
	                checkIndexConstraints(type);
	                checkTypeForDuplicateIndexSignatures(node);
	                checkPropertyInitialization(node);
	            }
	        }
	        function issueMemberSpecificError(node, typeWithThis, baseWithThis, broadDiag) {
	            // iterate over all implemented properties and issue errors on each one which isn't compatible, rather than the class as a whole, if possible
	            var issuedMemberError = false;
	            var _loop_8 = function (member) {
	                if (ts.hasStaticModifier(member)) {
	                    return "continue";
	                }
	                var declaredProp = member.name && getSymbolAtLocation(member.name) || getSymbolAtLocation(member);
	                if (declaredProp) {
	                    var prop = getPropertyOfType(typeWithThis, declaredProp.escapedName);
	                    var baseProp = getPropertyOfType(baseWithThis, declaredProp.escapedName);
	                    if (prop && baseProp) {
	                        var rootChain = function () { return ts.chainDiagnosticMessages(
	                        /*details*/ undefined, ts.Diagnostics.Property_0_in_type_1_is_not_assignable_to_the_same_property_in_base_type_2, symbolToString(declaredProp), typeToString(typeWithThis), typeToString(baseWithThis)); };
	                        if (!checkTypeAssignableTo(getTypeOfSymbol(prop), getTypeOfSymbol(baseProp), member.name || member, /*message*/ undefined, rootChain)) {
	                            issuedMemberError = true;
	                        }
	                    }
	                }
	            };
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                _loop_8(member);
	            }
	            if (!issuedMemberError) {
	                // check again with diagnostics to generate a less-specific error
	                checkTypeAssignableTo(typeWithThis, baseWithThis, node.name || node, broadDiag);
	            }
	        }
	        function checkBaseTypeAccessibility(type, node) {
	            var signatures = getSignaturesOfType(type, 1 /* Construct */);
	            if (signatures.length) {
	                var declaration = signatures[0].declaration;
	                if (declaration && ts.hasModifier(declaration, 8 /* Private */)) {
	                    var typeClassDeclaration = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                    if (!isNodeWithinClass(node, typeClassDeclaration)) {
	                        error(node, ts.Diagnostics.Cannot_extend_a_class_0_Class_constructor_is_marked_as_private, getFullyQualifiedName(type.symbol));
	                    }
	                }
	            }
	        }
	        function getTargetSymbol(s) {
	            // if symbol is instantiated its flags are not copied from the 'target'
	            // so we'll need to get back original 'target' symbol to work with correct set of flags
	            return ts.getCheckFlags(s) & 1 /* Instantiated */ ? s.target : s;
	        }
	        function getClassOrInterfaceDeclarationsOfSymbol(symbol) {
	            return ts.filter(symbol.declarations, function (d) {
	                return d.kind === 234 /* ClassDeclaration */ || d.kind === 235 /* InterfaceDeclaration */;
	            });
	        }
	        function checkKindsOfPropertyMemberOverrides(type, baseType) {
	            // TypeScript 1.0 spec (April 2014): 8.2.3
	            // A derived class inherits all members from its base class it doesn't override.
	            // Inheritance means that a derived class implicitly contains all non - overridden members of the base class.
	            // Both public and private property members are inherited, but only public property members can be overridden.
	            // A property member in a derived class is said to override a property member in a base class
	            // when the derived class property member has the same name and kind(instance or static)
	            // as the base class property member.
	            // The type of an overriding property member must be assignable(section 3.8.4)
	            // to the type of the overridden property member, or otherwise a compile - time error occurs.
	            // Base class instance member functions can be overridden by derived class instance member functions,
	            // but not by other kinds of members.
	            // Base class instance member variables and accessors can be overridden by
	            // derived class instance member variables and accessors, but not by other kinds of members.
	            // NOTE: assignability is checked in checkClassDeclaration
	            var baseProperties = getPropertiesOfType(baseType);
	            for (var _i = 0, baseProperties_1 = baseProperties; _i < baseProperties_1.length; _i++) {
	                var baseProperty = baseProperties_1[_i];
	                var base = getTargetSymbol(baseProperty);
	                if (base.flags & 4194304 /* Prototype */) {
	                    continue;
	                }
	                var derived = getTargetSymbol(getPropertyOfObjectType(type, base.escapedName));
	                var baseDeclarationFlags = ts.getDeclarationModifierFlagsFromSymbol(base);
	                ts.Debug.assert(!!derived, "derived should point to something, even if it is the base class' declaration.");
	                if (derived) {
	                    // In order to resolve whether the inherited method was overridden in the base class or not,
	                    // we compare the Symbols obtained. Since getTargetSymbol returns the symbol on the *uninstantiated*
	                    // type declaration, derived and base resolve to the same symbol even in the case of generic classes.
	                    if (derived === base) {
	                        // derived class inherits base without override/redeclaration
	                        var derivedClassDecl = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                        // It is an error to inherit an abstract member without implementing it or being declared abstract.
	                        // If there is no declaration for the derived class (as in the case of class expressions),
	                        // then the class cannot be declared abstract.
	                        if (baseDeclarationFlags & 128 /* Abstract */ && (!derivedClassDecl || !ts.hasModifier(derivedClassDecl, 128 /* Abstract */))) {
	                            if (derivedClassDecl.kind === 204 /* ClassExpression */) {
	                                error(derivedClassDecl, ts.Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1, symbolToString(baseProperty), typeToString(baseType));
	                            }
	                            else {
	                                error(derivedClassDecl, ts.Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2, typeToString(type), symbolToString(baseProperty), typeToString(baseType));
	                            }
	                        }
	                    }
	                    else {
	                        // derived overrides base.
	                        var derivedDeclarationFlags = ts.getDeclarationModifierFlagsFromSymbol(derived);
	                        if (baseDeclarationFlags & 8 /* Private */ || derivedDeclarationFlags & 8 /* Private */) {
	                            // either base or derived property is private - not override, skip it
	                            continue;
	                        }
	                        if (isPrototypeProperty(base) && isPrototypeProperty(derived) || base.flags & 98308 /* PropertyOrAccessor */ && derived.flags & 98308 /* PropertyOrAccessor */) {
	                            // method is overridden with method or property/accessor is overridden with property/accessor - correct case
	                            continue;
	                        }
	                        var errorMessage = void 0;
	                        if (isPrototypeProperty(base)) {
	                            if (derived.flags & 98304 /* Accessor */) {
	                                errorMessage = ts.Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_accessor;
	                            }
	                            else {
	                                errorMessage = ts.Diagnostics.Class_0_defines_instance_member_function_1_but_extended_class_2_defines_it_as_instance_member_property;
	                            }
	                        }
	                        else if (base.flags & 98304 /* Accessor */) {
	                            errorMessage = ts.Diagnostics.Class_0_defines_instance_member_accessor_1_but_extended_class_2_defines_it_as_instance_member_function;
	                        }
	                        else {
	                            errorMessage = ts.Diagnostics.Class_0_defines_instance_member_property_1_but_extended_class_2_defines_it_as_instance_member_function;
	                        }
	                        error(ts.getNameOfDeclaration(derived.valueDeclaration) || derived.valueDeclaration, errorMessage, typeToString(baseType), symbolToString(base), typeToString(type));
	                    }
	                }
	            }
	        }
	        function checkInheritedPropertiesAreIdentical(type, typeNode) {
	            var baseTypes = getBaseTypes(type);
	            if (baseTypes.length < 2) {
	                return true;
	            }
	            var seen = ts.createUnderscoreEscapedMap();
	            ts.forEach(resolveDeclaredMembers(type).declaredProperties, function (p) { seen.set(p.escapedName, { prop: p, containingType: type }); });
	            var ok = true;
	            for (var _i = 0, baseTypes_2 = baseTypes; _i < baseTypes_2.length; _i++) {
	                var base = baseTypes_2[_i];
	                var properties = getPropertiesOfType(getTypeWithThisArgument(base, type.thisType));
	                for (var _a = 0, properties_8 = properties; _a < properties_8.length; _a++) {
	                    var prop = properties_8[_a];
	                    var existing = seen.get(prop.escapedName);
	                    if (!existing) {
	                        seen.set(prop.escapedName, { prop: prop, containingType: base });
	                    }
	                    else {
	                        var isInheritedProperty = existing.containingType !== type;
	                        if (isInheritedProperty && !isPropertyIdenticalTo(existing.prop, prop)) {
	                            ok = false;
	                            var typeName1 = typeToString(existing.containingType);
	                            var typeName2 = typeToString(base);
	                            var errorInfo = ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Named_property_0_of_types_1_and_2_are_not_identical, symbolToString(prop), typeName1, typeName2);
	                            errorInfo = ts.chainDiagnosticMessages(errorInfo, ts.Diagnostics.Interface_0_cannot_simultaneously_extend_types_1_and_2, typeToString(type), typeName1, typeName2);
	                            diagnostics.add(ts.createDiagnosticForNodeFromMessageChain(typeNode, errorInfo));
	                        }
	                    }
	                }
	            }
	            return ok;
	        }
	        function checkPropertyInitialization(node) {
	            if (!strictNullChecks || !strictPropertyInitialization || node.flags & 4194304 /* Ambient */) {
	                return;
	            }
	            var constructor = findConstructorDeclaration(node);
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (isInstancePropertyWithoutInitializer(member)) {
	                    var propName = member.name;
	                    if (ts.isIdentifier(propName)) {
	                        var type = getTypeOfSymbol(getSymbolOfNode(member));
	                        if (!(type.flags & 1 /* Any */ || getFalsyFlags(type) & 4096 /* Undefined */)) {
	                            if (!constructor || !isPropertyInitializedInConstructor(propName, type, constructor)) {
	                                error(member.name, ts.Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor, ts.declarationNameToString(propName));
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        function isInstancePropertyWithoutInitializer(node) {
	            return node.kind === 151 /* PropertyDeclaration */ &&
	                !ts.hasModifier(node, 32 /* Static */ | 128 /* Abstract */) &&
	                !node.exclamationToken &&
	                !node.initializer;
	        }
	        function isPropertyInitializedInConstructor(propName, propType, constructor) {
	            var reference = ts.createPropertyAccess(ts.createThis(), propName);
	            reference.flowNode = constructor.returnFlowNode;
	            var flowType = getFlowTypeOfReference(reference, propType, getOptionalType(propType));
	            return !(getFalsyFlags(flowType) & 4096 /* Undefined */);
	        }
	        function checkInterfaceDeclaration(node) {
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node))
	                checkGrammarInterfaceDeclaration(node);
	            checkTypeParameters(node.typeParameters);
	            if (produceDiagnostics) {
	                checkTypeNameIsReserved(node.name, ts.Diagnostics.Interface_name_cannot_be_0);
	                checkExportsOnMergedDeclarations(node);
	                var symbol = getSymbolOfNode(node);
	                checkTypeParameterListsIdentical(symbol);
	                // Only check this symbol once
	                var firstInterfaceDecl = ts.getDeclarationOfKind(symbol, 235 /* InterfaceDeclaration */);
	                if (node === firstInterfaceDecl) {
	                    var type = getDeclaredTypeOfSymbol(symbol);
	                    var typeWithThis = getTypeWithThisArgument(type);
	                    // run subsequent checks only if first set succeeded
	                    if (checkInheritedPropertiesAreIdentical(type, node.name)) {
	                        for (var _i = 0, _a = getBaseTypes(type); _i < _a.length; _i++) {
	                            var baseType = _a[_i];
	                            checkTypeAssignableTo(typeWithThis, getTypeWithThisArgument(baseType, type.thisType), node.name, ts.Diagnostics.Interface_0_incorrectly_extends_interface_1);
	                        }
	                        checkIndexConstraints(type);
	                    }
	                }
	                checkObjectTypeForDuplicateDeclarations(node);
	            }
	            ts.forEach(ts.getInterfaceBaseTypeNodes(node), function (heritageElement) {
	                if (!ts.isEntityNameExpression(heritageElement.expression)) {
	                    error(heritageElement.expression, ts.Diagnostics.An_interface_can_only_extend_an_identifier_Slashqualified_name_with_optional_type_arguments);
	                }
	                checkTypeReferenceNode(heritageElement);
	            });
	            ts.forEach(node.members, checkSourceElement);
	            if (produceDiagnostics) {
	                checkTypeForDuplicateIndexSignatures(node);
	                registerForUnusedIdentifiersCheck(node);
	            }
	        }
	        function checkTypeAliasDeclaration(node) {
	            // Grammar checking
	            checkGrammarDecoratorsAndModifiers(node);
	            checkTypeNameIsReserved(node.name, ts.Diagnostics.Type_alias_name_cannot_be_0);
	            checkTypeParameters(node.typeParameters);
	            checkSourceElement(node.type);
	            registerForUnusedIdentifiersCheck(node);
	        }
	        function computeEnumMemberValues(node) {
	            var nodeLinks = getNodeLinks(node);
	            if (!(nodeLinks.flags & 16384 /* EnumValuesComputed */)) {
	                nodeLinks.flags |= 16384 /* EnumValuesComputed */;
	                var autoValue = 0;
	                for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    var value = computeMemberValue(member, autoValue);
	                    getNodeLinks(member).enumMemberValue = value;
	                    autoValue = typeof value === "number" ? value + 1 : undefined;
	                }
	            }
	        }
	        function computeMemberValue(member, autoValue) {
	            if (isComputedNonLiteralName(member.name)) {
	                error(member.name, ts.Diagnostics.Computed_property_names_are_not_allowed_in_enums);
	            }
	            else {
	                var text = ts.getTextOfPropertyName(member.name);
	                if (isNumericLiteralName(text) && !isInfinityOrNaNString(text)) {
	                    error(member.name, ts.Diagnostics.An_enum_member_cannot_have_a_numeric_name);
	                }
	            }
	            if (member.initializer) {
	                return computeConstantValue(member);
	            }
	            // In ambient enum declarations that specify no const modifier, enum member declarations that omit
	            // a value are considered computed members (as opposed to having auto-incremented values).
	            if (member.parent.flags & 4194304 /* Ambient */ && !ts.isConst(member.parent)) {
	                return undefined;
	            }
	            // If the member declaration specifies no value, the member is considered a constant enum member.
	            // If the member is the first member in the enum declaration, it is assigned the value zero.
	            // Otherwise, it is assigned the value of the immediately preceding member plus one, and an error
	            // occurs if the immediately preceding member is not a constant enum member.
	            if (autoValue !== undefined) {
	                return autoValue;
	            }
	            error(member.name, ts.Diagnostics.Enum_member_must_have_initializer);
	            return undefined;
	        }
	        function computeConstantValue(member) {
	            var enumKind = getEnumKind(getSymbolOfNode(member.parent));
	            var isConstEnum = ts.isConst(member.parent);
	            var initializer = member.initializer;
	            var value = enumKind === 1 /* Literal */ && !isLiteralEnumMember(member) ? undefined : evaluate(initializer);
	            if (value !== undefined) {
	                if (isConstEnum && typeof value === "number" && !isFinite(value)) {
	                    error(initializer, isNaN(value) ?
	                        ts.Diagnostics.const_enum_member_initializer_was_evaluated_to_disallowed_value_NaN :
	                        ts.Diagnostics.const_enum_member_initializer_was_evaluated_to_a_non_finite_value);
	                }
	            }
	            else if (enumKind === 1 /* Literal */) {
	                error(initializer, ts.Diagnostics.Computed_values_are_not_permitted_in_an_enum_with_string_valued_members);
	                return 0;
	            }
	            else if (isConstEnum) {
	                error(initializer, ts.Diagnostics.In_const_enum_declarations_member_initializer_must_be_constant_expression);
	            }
	            else if (member.parent.flags & 4194304 /* Ambient */) {
	                error(initializer, ts.Diagnostics.In_ambient_enum_declarations_member_initializer_must_be_constant_expression);
	            }
	            else {
	                // Only here do we need to check that the initializer is assignable to the enum type.
	                checkTypeAssignableTo(checkExpression(initializer), getDeclaredTypeOfSymbol(getSymbolOfNode(member.parent)), initializer, /*headMessage*/ undefined);
	            }
	            return value;
	            function evaluate(expr) {
	                switch (expr.kind) {
	                    case 197 /* PrefixUnaryExpression */:
	                        var value_2 = evaluate(expr.operand);
	                        if (typeof value_2 === "number") {
	                            switch (expr.operator) {
	                                case 37 /* PlusToken */: return value_2;
	                                case 38 /* MinusToken */: return -value_2;
	                                case 52 /* TildeToken */: return ~value_2;
	                            }
	                        }
	                        break;
	                    case 199 /* BinaryExpression */:
	                        var left = evaluate(expr.left);
	                        var right = evaluate(expr.right);
	                        if (typeof left === "number" && typeof right === "number") {
	                            switch (expr.operatorToken.kind) {
	                                case 49 /* BarToken */: return left | right;
	                                case 48 /* AmpersandToken */: return left & right;
	                                case 46 /* GreaterThanGreaterThanToken */: return left >> right;
	                                case 47 /* GreaterThanGreaterThanGreaterThanToken */: return left >>> right;
	                                case 45 /* LessThanLessThanToken */: return left << right;
	                                case 50 /* CaretToken */: return left ^ right;
	                                case 39 /* AsteriskToken */: return left * right;
	                                case 41 /* SlashToken */: return left / right;
	                                case 37 /* PlusToken */: return left + right;
	                                case 38 /* MinusToken */: return left - right;
	                                case 42 /* PercentToken */: return left % right;
	                                case 40 /* AsteriskAsteriskToken */: return Math.pow(left, right);
	                            }
	                        }
	                        else if (typeof left === "string" && typeof right === "string" && expr.operatorToken.kind === 37 /* PlusToken */) {
	                            return left + right;
	                        }
	                        break;
	                    case 9 /* StringLiteral */:
	                        return expr.text;
	                    case 8 /* NumericLiteral */:
	                        checkGrammarNumericLiteral(expr);
	                        return +expr.text;
	                    case 190 /* ParenthesizedExpression */:
	                        return evaluate(expr.expression);
	                    case 71 /* Identifier */:
	                        return ts.nodeIsMissing(expr) ? 0 : evaluateEnumMember(expr, getSymbolOfNode(member.parent), expr.escapedText);
	                    case 185 /* ElementAccessExpression */:
	                    case 184 /* PropertyAccessExpression */:
	                        var ex = expr;
	                        if (isConstantMemberAccess(ex)) {
	                            var type = getTypeOfExpression(ex.expression);
	                            if (type.symbol && type.symbol.flags & 384 /* Enum */) {
	                                var name = void 0;
	                                if (ex.kind === 184 /* PropertyAccessExpression */) {
	                                    name = ex.name.escapedText;
	                                }
	                                else {
	                                    var argument = ex.argumentExpression;
	                                    ts.Debug.assert(ts.isLiteralExpression(argument));
	                                    name = ts.escapeLeadingUnderscores(argument.text);
	                                }
	                                return evaluateEnumMember(expr, type.symbol, name);
	                            }
	                        }
	                        break;
	                }
	                return undefined;
	            }
	            function evaluateEnumMember(expr, enumSymbol, name) {
	                var memberSymbol = enumSymbol.exports.get(name);
	                if (memberSymbol) {
	                    var declaration = memberSymbol.valueDeclaration;
	                    if (declaration !== member) {
	                        if (isBlockScopedNameDeclaredBeforeUse(declaration, member)) {
	                            return getEnumMemberValue(declaration);
	                        }
	                        error(expr, ts.Diagnostics.A_member_initializer_in_a_enum_declaration_cannot_reference_members_declared_after_it_including_members_defined_in_other_enums);
	                        return 0;
	                    }
	                }
	                return undefined;
	            }
	        }
	        function isConstantMemberAccess(node) {
	            return node.kind === 71 /* Identifier */ ||
	                node.kind === 184 /* PropertyAccessExpression */ && isConstantMemberAccess(node.expression) ||
	                node.kind === 185 /* ElementAccessExpression */ && isConstantMemberAccess(node.expression) &&
	                    node.argumentExpression.kind === 9 /* StringLiteral */;
	        }
	        function checkEnumDeclaration(node) {
	            if (!produceDiagnostics) {
	                return;
	            }
	            // Grammar checking
	            checkGrammarDecoratorsAndModifiers(node);
	            checkTypeNameIsReserved(node.name, ts.Diagnostics.Enum_name_cannot_be_0);
	            checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	            checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            checkExportsOnMergedDeclarations(node);
	            computeEnumMemberValues(node);
	            var enumIsConst = ts.isConst(node);
	            if (compilerOptions.isolatedModules && enumIsConst && node.flags & 4194304 /* Ambient */) {
	                error(node.name, ts.Diagnostics.Ambient_const_enums_are_not_allowed_when_the_isolatedModules_flag_is_provided);
	            }
	            // Spec 2014 - Section 9.3:
	            // It isn't possible for one enum declaration to continue the automatic numbering sequence of another,
	            // and when an enum type has multiple declarations, only one declaration is permitted to omit a value
	            // for the first member.
	            //
	            // Only perform this check once per symbol
	            var enumSymbol = getSymbolOfNode(node);
	            var firstDeclaration = ts.getDeclarationOfKind(enumSymbol, node.kind);
	            if (node === firstDeclaration) {
	                if (enumSymbol.declarations.length > 1) {
	                    // check that const is placed\omitted on all enum declarations
	                    ts.forEach(enumSymbol.declarations, function (decl) {
	                        if (ts.isConstEnumDeclaration(decl) !== enumIsConst) {
	                            error(ts.getNameOfDeclaration(decl), ts.Diagnostics.Enum_declarations_must_all_be_const_or_non_const);
	                        }
	                    });
	                }
	                var seenEnumMissingInitialInitializer_1 = false;
	                ts.forEach(enumSymbol.declarations, function (declaration) {
	                    // return true if we hit a violation of the rule, false otherwise
	                    if (declaration.kind !== 237 /* EnumDeclaration */) {
	                        return false;
	                    }
	                    var enumDeclaration = declaration;
	                    if (!enumDeclaration.members.length) {
	                        return false;
	                    }
	                    var firstEnumMember = enumDeclaration.members[0];
	                    if (!firstEnumMember.initializer) {
	                        if (seenEnumMissingInitialInitializer_1) {
	                            error(firstEnumMember.name, ts.Diagnostics.In_an_enum_with_multiple_declarations_only_one_declaration_can_omit_an_initializer_for_its_first_enum_element);
	                        }
	                        else {
	                            seenEnumMissingInitialInitializer_1 = true;
	                        }
	                    }
	                });
	            }
	        }
	        function getFirstNonAmbientClassOrFunctionDeclaration(symbol) {
	            var declarations = symbol.declarations;
	            for (var _i = 0, declarations_8 = declarations; _i < declarations_8.length; _i++) {
	                var declaration = declarations_8[_i];
	                if ((declaration.kind === 234 /* ClassDeclaration */ ||
	                    (declaration.kind === 233 /* FunctionDeclaration */ && ts.nodeIsPresent(declaration.body))) &&
	                    !(declaration.flags & 4194304 /* Ambient */)) {
	                    return declaration;
	                }
	            }
	            return undefined;
	        }
	        function inSameLexicalScope(node1, node2) {
	            var container1 = ts.getEnclosingBlockScopeContainer(node1);
	            var container2 = ts.getEnclosingBlockScopeContainer(node2);
	            if (isGlobalSourceFile(container1)) {
	                return isGlobalSourceFile(container2);
	            }
	            else if (isGlobalSourceFile(container2)) {
	                return false;
	            }
	            else {
	                return container1 === container2;
	            }
	        }
	        function checkModuleDeclaration(node) {
	            if (produceDiagnostics) {
	                // Grammar checking
	                var isGlobalAugmentation = ts.isGlobalScopeAugmentation(node);
	                var inAmbientContext = node.flags & 4194304 /* Ambient */;
	                if (isGlobalAugmentation && !inAmbientContext) {
	                    error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_should_have_declare_modifier_unless_they_appear_in_already_ambient_context);
	                }
	                var isAmbientExternalModule = ts.isAmbientModule(node);
	                var contextErrorMessage = isAmbientExternalModule
	                    ? ts.Diagnostics.An_ambient_module_declaration_is_only_allowed_at_the_top_level_in_a_file
	                    : ts.Diagnostics.A_namespace_declaration_is_only_allowed_in_a_namespace_or_module;
	                if (checkGrammarModuleElementContext(node, contextErrorMessage)) {
	                    // If we hit a module declaration in an illegal context, just bail out to avoid cascading errors.
	                    return;
	                }
	                if (!checkGrammarDecoratorsAndModifiers(node)) {
	                    if (!inAmbientContext && node.name.kind === 9 /* StringLiteral */) {
	                        grammarErrorOnNode(node.name, ts.Diagnostics.Only_ambient_modules_can_use_quoted_names);
	                    }
	                }
	                if (ts.isIdentifier(node.name)) {
	                    checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	                    checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	                }
	                checkExportsOnMergedDeclarations(node);
	                var symbol = getSymbolOfNode(node);
	                // The following checks only apply on a non-ambient instantiated module declaration.
	                if (symbol.flags & 512 /* ValueModule */
	                    && symbol.declarations.length > 1
	                    && !inAmbientContext
	                    && isInstantiatedModule(node, compilerOptions.preserveConstEnums || compilerOptions.isolatedModules)) {
	                    var firstNonAmbientClassOrFunc = getFirstNonAmbientClassOrFunctionDeclaration(symbol);
	                    if (firstNonAmbientClassOrFunc) {
	                        if (ts.getSourceFileOfNode(node) !== ts.getSourceFileOfNode(firstNonAmbientClassOrFunc)) {
	                            error(node.name, ts.Diagnostics.A_namespace_declaration_cannot_be_in_a_different_file_from_a_class_or_function_with_which_it_is_merged);
	                        }
	                        else if (node.pos < firstNonAmbientClassOrFunc.pos) {
	                            error(node.name, ts.Diagnostics.A_namespace_declaration_cannot_be_located_prior_to_a_class_or_function_with_which_it_is_merged);
	                        }
	                    }
	                    // if the module merges with a class declaration in the same lexical scope,
	                    // we need to track this to ensure the correct emit.
	                    var mergedClass = ts.getDeclarationOfKind(symbol, 234 /* ClassDeclaration */);
	                    if (mergedClass &&
	                        inSameLexicalScope(node, mergedClass)) {
	                        getNodeLinks(node).flags |= 32768 /* LexicalModuleMergesWithClass */;
	                    }
	                }
	                if (isAmbientExternalModule) {
	                    if (ts.isExternalModuleAugmentation(node)) {
	                        // body of the augmentation should be checked for consistency only if augmentation was applied to its target (either global scope or module)
	                        // otherwise we'll be swamped in cascading errors.
	                        // We can detect if augmentation was applied using following rules:
	                        // - augmentation for a global scope is always applied
	                        // - augmentation for some external module is applied if symbol for augmentation is merged (it was combined with target module).
	                        var checkBody = isGlobalAugmentation || (getSymbolOfNode(node).flags & 33554432 /* Transient */);
	                        if (checkBody && node.body) {
	                            for (var _i = 0, _a = node.body.statements; _i < _a.length; _i++) {
	                                var statement = _a[_i];
	                                checkModuleAugmentationElement(statement, isGlobalAugmentation);
	                            }
	                        }
	                    }
	                    else if (isGlobalSourceFile(node.parent)) {
	                        if (isGlobalAugmentation) {
	                            error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
	                        }
	                        else if (ts.isExternalModuleNameRelative(ts.getTextOfIdentifierOrLiteral(node.name))) {
	                            error(node.name, ts.Diagnostics.Ambient_module_declaration_cannot_specify_relative_module_name);
	                        }
	                    }
	                    else {
	                        if (isGlobalAugmentation) {
	                            error(node.name, ts.Diagnostics.Augmentations_for_the_global_scope_can_only_be_directly_nested_in_external_modules_or_ambient_module_declarations);
	                        }
	                        else {
	                            // Node is not an augmentation and is not located on the script level.
	                            // This means that this is declaration of ambient module that is located in other module or namespace which is prohibited.
	                            error(node.name, ts.Diagnostics.Ambient_modules_cannot_be_nested_in_other_modules_or_namespaces);
	                        }
	                    }
	                }
	            }
	            if (node.body) {
	                checkSourceElement(node.body);
	                if (!ts.isGlobalScopeAugmentation(node)) {
	                    registerForUnusedIdentifiersCheck(node);
	                }
	            }
	        }
	        function checkModuleAugmentationElement(node, isGlobalAugmentation) {
	            switch (node.kind) {
	                case 213 /* VariableStatement */:
	                    // error each individual name in variable statement instead of marking the entire variable statement
	                    for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                        var decl = _a[_i];
	                        checkModuleAugmentationElement(decl, isGlobalAugmentation);
	                    }
	                    break;
	                case 248 /* ExportAssignment */:
	                case 249 /* ExportDeclaration */:
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.Exports_and_export_assignments_are_not_permitted_in_module_augmentations);
	                    break;
	                case 242 /* ImportEqualsDeclaration */:
	                case 243 /* ImportDeclaration */:
	                    grammarErrorOnFirstToken(node, ts.Diagnostics.Imports_are_not_permitted_in_module_augmentations_Consider_moving_them_to_the_enclosing_external_module);
	                    break;
	                case 181 /* BindingElement */:
	                case 231 /* VariableDeclaration */:
	                    var name = node.name;
	                    if (ts.isBindingPattern(name)) {
	                        for (var _b = 0, _c = name.elements; _b < _c.length; _b++) {
	                            var el = _c[_b];
	                            // mark individual names in binding pattern
	                            checkModuleAugmentationElement(el, isGlobalAugmentation);
	                        }
	                        break;
	                    }
	                // falls through
	                case 234 /* ClassDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 233 /* FunctionDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                    if (isGlobalAugmentation) {
	                        return;
	                    }
	                    var symbol = getSymbolOfNode(node);
	                    if (symbol) {
	                        // module augmentations cannot introduce new names on the top level scope of the module
	                        // this is done it two steps
	                        // 1. quick check - if symbol for node is not merged - this is local symbol to this augmentation - report error
	                        // 2. main check - report error if value declaration of the parent symbol is module augmentation)
	                        var reportError = !(symbol.flags & 33554432 /* Transient */);
	                        if (!reportError) {
	                            // symbol should not originate in augmentation
	                            reportError = ts.isExternalModuleAugmentation(symbol.parent.declarations[0]);
	                        }
	                    }
	                    break;
	            }
	        }
	        function getFirstIdentifier(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return node;
	                case 145 /* QualifiedName */:
	                    do {
	                        node = node.left;
	                    } while (node.kind !== 71 /* Identifier */);
	                    return node;
	                case 184 /* PropertyAccessExpression */:
	                    do {
	                        node = node.expression;
	                    } while (node.kind !== 71 /* Identifier */);
	                    return node;
	            }
	        }
	        function checkExternalImportOrExportDeclaration(node) {
	            var moduleName = ts.getExternalModuleName(node);
	            if (ts.nodeIsMissing(moduleName)) {
	                // Should be a parse error.
	                return false;
	            }
	            if (!ts.isStringLiteral(moduleName)) {
	                error(moduleName, ts.Diagnostics.String_literal_expected);
	                return false;
	            }
	            var inAmbientExternalModule = node.parent.kind === 239 /* ModuleBlock */ && ts.isAmbientModule(node.parent.parent);
	            if (node.parent.kind !== 273 /* SourceFile */ && !inAmbientExternalModule) {
	                error(moduleName, node.kind === 249 /* ExportDeclaration */ ?
	                    ts.Diagnostics.Export_declarations_are_not_permitted_in_a_namespace :
	                    ts.Diagnostics.Import_declarations_in_a_namespace_cannot_reference_a_module);
	                return false;
	            }
	            if (inAmbientExternalModule && ts.isExternalModuleNameRelative(moduleName.text)) {
	                // we have already reported errors on top level imports\exports in external module augmentations in checkModuleDeclaration
	                // no need to do this again.
	                if (!isTopLevelInExternalModuleAugmentation(node)) {
	                    // TypeScript 1.0 spec (April 2013): 12.1.6
	                    // An ExternalImportDeclaration in an AmbientExternalModuleDeclaration may reference
	                    // other external modules only through top - level external module names.
	                    // Relative external module names are not permitted.
	                    error(node, ts.Diagnostics.Import_or_export_declaration_in_an_ambient_module_declaration_cannot_reference_module_through_relative_module_name);
	                    return false;
	                }
	            }
	            return true;
	        }
	        function checkAliasSymbol(node) {
	            var symbol = getSymbolOfNode(node);
	            var target = resolveAlias(symbol);
	            if (target !== unknownSymbol) {
	                // For external modules symbol represent local symbol for an alias.
	                // This local symbol will merge any other local declarations (excluding other aliases)
	                // and symbol.flags will contains combined representation for all merged declaration.
	                // Based on symbol.flags we can compute a set of excluded meanings (meaning that resolved alias should not have,
	                // otherwise it will conflict with some local declaration). Note that in addition to normal flags we include matching SymbolFlags.Export*
	                // in order to prevent collisions with declarations that were exported from the current module (they still contribute to local names).
	                var excludedMeanings = (symbol.flags & (67216319 /* Value */ | 1048576 /* ExportValue */) ? 67216319 /* Value */ : 0) |
	                    (symbol.flags & 67901928 /* Type */ ? 67901928 /* Type */ : 0) |
	                    (symbol.flags & 1920 /* Namespace */ ? 1920 /* Namespace */ : 0);
	                if (target.flags & excludedMeanings) {
	                    var message = node.kind === 251 /* ExportSpecifier */ ?
	                        ts.Diagnostics.Export_declaration_conflicts_with_exported_declaration_of_0 :
	                        ts.Diagnostics.Import_declaration_conflicts_with_local_declaration_of_0;
	                    error(node, message, symbolToString(symbol));
	                }
	                // Don't allow to re-export something with no value side when `--isolatedModules` is set.
	                if (compilerOptions.isolatedModules
	                    && node.kind === 251 /* ExportSpecifier */
	                    && !(target.flags & 67216319 /* Value */)
	                    && !(node.flags & 4194304 /* Ambient */)) {
	                    error(node, ts.Diagnostics.Cannot_re_export_a_type_when_the_isolatedModules_flag_is_provided);
	                }
	            }
	        }
	        function checkImportBinding(node) {
	            checkCollisionWithRequireExportsInGeneratedCode(node, node.name);
	            checkCollisionWithGlobalPromiseInGeneratedCode(node, node.name);
	            checkAliasSymbol(node);
	        }
	        function checkImportDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_import_declaration_can_only_be_used_in_a_namespace_or_module)) {
	                // If we hit an import declaration in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_import_declaration_cannot_have_modifiers);
	            }
	            if (checkExternalImportOrExportDeclaration(node)) {
	                var importClause = node.importClause;
	                if (importClause) {
	                    if (importClause.name) {
	                        checkImportBinding(importClause);
	                    }
	                    if (importClause.namedBindings) {
	                        if (importClause.namedBindings.kind === 245 /* NamespaceImport */) {
	                            checkImportBinding(importClause.namedBindings);
	                        }
	                        else {
	                            var moduleExisted = resolveExternalModuleName(node, node.moduleSpecifier);
	                            if (moduleExisted) {
	                                ts.forEach(importClause.namedBindings.elements, checkImportBinding);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        function checkImportEqualsDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_import_declaration_can_only_be_used_in_a_namespace_or_module)) {
	                // If we hit an import declaration in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            checkGrammarDecoratorsAndModifiers(node);
	            if (ts.isInternalModuleImportEqualsDeclaration(node) || checkExternalImportOrExportDeclaration(node)) {
	                checkImportBinding(node);
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    markExportAsReferenced(node);
	                }
	                if (node.moduleReference.kind !== 253 /* ExternalModuleReference */) {
	                    var target = resolveAlias(getSymbolOfNode(node));
	                    if (target !== unknownSymbol) {
	                        if (target.flags & 67216319 /* Value */) {
	                            // Target is a value symbol, check that it is not hidden by a local declaration with the same name
	                            var moduleName = getFirstIdentifier(node.moduleReference);
	                            if (!(resolveEntityName(moduleName, 67216319 /* Value */ | 1920 /* Namespace */).flags & 1920 /* Namespace */)) {
	                                error(moduleName, ts.Diagnostics.Module_0_is_hidden_by_a_local_declaration_with_the_same_name, ts.declarationNameToString(moduleName));
	                            }
	                        }
	                        if (target.flags & 67901928 /* Type */) {
	                            checkTypeNameIsReserved(node.name, ts.Diagnostics.Import_name_cannot_be_0);
	                        }
	                    }
	                }
	                else {
	                    if (moduleKind >= ts.ModuleKind.ES2015 && !(node.flags & 4194304 /* Ambient */)) {
	                        // Import equals declaration is deprecated in es6 or above
	                        grammarErrorOnNode(node, ts.Diagnostics.Import_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_import_Asterisk_as_ns_from_mod_import_a_from_mod_import_d_from_mod_or_another_module_format_instead);
	                    }
	                }
	            }
	        }
	        function checkExportDeclaration(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_export_declaration_can_only_be_used_in_a_module)) {
	                // If we hit an export in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_export_declaration_cannot_have_modifiers);
	            }
	            if (!node.moduleSpecifier || checkExternalImportOrExportDeclaration(node)) {
	                if (node.exportClause) {
	                    // export { x, y }
	                    // export { x, y } from "foo"
	                    ts.forEach(node.exportClause.elements, checkExportSpecifier);
	                    var inAmbientExternalModule = node.parent.kind === 239 /* ModuleBlock */ && ts.isAmbientModule(node.parent.parent);
	                    var inAmbientNamespaceDeclaration = !inAmbientExternalModule && node.parent.kind === 239 /* ModuleBlock */ &&
	                        !node.moduleSpecifier && node.flags & 4194304 /* Ambient */;
	                    if (node.parent.kind !== 273 /* SourceFile */ && !inAmbientExternalModule && !inAmbientNamespaceDeclaration) {
	                        error(node, ts.Diagnostics.Export_declarations_are_not_permitted_in_a_namespace);
	                    }
	                }
	                else {
	                    // export * from "foo"
	                    var moduleSymbol_2 = resolveExternalModuleName(node, node.moduleSpecifier);
	                    if (moduleSymbol_2 && hasExportAssignmentSymbol(moduleSymbol_2)) {
	                        error(node.moduleSpecifier, ts.Diagnostics.Module_0_uses_export_and_cannot_be_used_with_export_Asterisk, symbolToString(moduleSymbol_2));
	                    }
	                    if (moduleKind !== ts.ModuleKind.System && moduleKind !== ts.ModuleKind.ES2015 && moduleKind !== ts.ModuleKind.ESNext) {
	                        checkExternalEmitHelpers(node, 32768 /* ExportStar */);
	                    }
	                }
	            }
	        }
	        function checkGrammarModuleElementContext(node, errorMessage) {
	            var isInAppropriateContext = node.parent.kind === 273 /* SourceFile */ || node.parent.kind === 239 /* ModuleBlock */ || node.parent.kind === 238 /* ModuleDeclaration */;
	            if (!isInAppropriateContext) {
	                grammarErrorOnFirstToken(node, errorMessage);
	            }
	            return !isInAppropriateContext;
	        }
	        function checkExportSpecifier(node) {
	            checkAliasSymbol(node);
	            if (compilerOptions.declaration) {
	                collectLinkedAliases(node.propertyName || node.name, /*setVisibility*/ true);
	            }
	            if (!node.parent.parent.moduleSpecifier) {
	                var exportedName = node.propertyName || node.name;
	                // find immediate value referenced by exported name (SymbolFlags.Alias is set so we don't chase down aliases)
	                var symbol = resolveName(exportedName, exportedName.escapedText, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */, 
	                /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	                if (symbol && (symbol === undefinedSymbol || isGlobalSourceFile(getDeclarationContainer(symbol.declarations[0])))) {
	                    error(exportedName, ts.Diagnostics.Cannot_export_0_Only_local_declarations_can_be_exported_from_a_module, ts.idText(exportedName));
	                }
	                else {
	                    markExportAsReferenced(node);
	                }
	            }
	        }
	        function checkExportAssignment(node) {
	            if (checkGrammarModuleElementContext(node, ts.Diagnostics.An_export_assignment_can_only_be_used_in_a_module)) {
	                // If we hit an export assignment in an illegal context, just bail out to avoid cascading errors.
	                return;
	            }
	            var container = node.parent.kind === 273 /* SourceFile */ ? node.parent : node.parent.parent;
	            if (container.kind === 238 /* ModuleDeclaration */ && !ts.isAmbientModule(container)) {
	                if (node.isExportEquals) {
	                    error(node, ts.Diagnostics.An_export_assignment_cannot_be_used_in_a_namespace);
	                }
	                else {
	                    error(node, ts.Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
	                }
	                return;
	            }
	            // Grammar checking
	            if (!checkGrammarDecoratorsAndModifiers(node) && ts.hasModifiers(node)) {
	                grammarErrorOnFirstToken(node, ts.Diagnostics.An_export_assignment_cannot_have_modifiers);
	            }
	            if (node.expression.kind === 71 /* Identifier */) {
	                markExportAsReferenced(node);
	                if (compilerOptions.declaration) {
	                    collectLinkedAliases(node.expression, /*setVisibility*/ true);
	                }
	            }
	            else {
	                checkExpressionCached(node.expression);
	            }
	            checkExternalModuleExports(container);
	            if ((node.flags & 4194304 /* Ambient */) && !ts.isEntityNameExpression(node.expression)) {
	                grammarErrorOnNode(node.expression, ts.Diagnostics.The_expression_of_an_export_assignment_must_be_an_identifier_or_qualified_name_in_an_ambient_context);
	            }
	            if (node.isExportEquals && !(node.flags & 4194304 /* Ambient */)) {
	                if (moduleKind >= ts.ModuleKind.ES2015) {
	                    // export assignment is not supported in es6 modules
	                    grammarErrorOnNode(node, ts.Diagnostics.Export_assignment_cannot_be_used_when_targeting_ECMAScript_modules_Consider_using_export_default_or_another_module_format_instead);
	                }
	                else if (moduleKind === ts.ModuleKind.System) {
	                    // system modules does not support export assignment
	                    grammarErrorOnNode(node, ts.Diagnostics.Export_assignment_is_not_supported_when_module_flag_is_system);
	                }
	            }
	        }
	        function hasExportedMembers(moduleSymbol) {
	            return ts.forEachEntry(moduleSymbol.exports, function (_, id) { return id !== "export="; });
	        }
	        function checkExternalModuleExports(node) {
	            var moduleSymbol = getSymbolOfNode(node);
	            var links = getSymbolLinks(moduleSymbol);
	            if (!links.exportsChecked) {
	                var exportEqualsSymbol = moduleSymbol.exports.get("export=");
	                if (exportEqualsSymbol && hasExportedMembers(moduleSymbol)) {
	                    var declaration = getDeclarationOfAliasSymbol(exportEqualsSymbol) || exportEqualsSymbol.valueDeclaration;
	                    if (!isTopLevelInExternalModuleAugmentation(declaration) && !ts.isInJavaScriptFile(declaration)) {
	                        error(declaration, ts.Diagnostics.An_export_assignment_cannot_be_used_in_a_module_with_other_exported_elements);
	                    }
	                }
	                // Checks for export * conflicts
	                var exports_1 = getExportsOfModule(moduleSymbol);
	                if (exports_1) {
	                    exports_1.forEach(function (_a, id) {
	                        var declarations = _a.declarations, flags = _a.flags;
	                        if (id === "__export") {
	                            return;
	                        }
	                        // ECMA262: 15.2.1.1 It is a Syntax Error if the ExportedNames of ModuleItemList contains any duplicate entries.
	                        // (TS Exceptions: namespaces, function overloads, enums, and interfaces)
	                        if (flags & (1920 /* Namespace */ | 64 /* Interface */ | 384 /* Enum */)) {
	                            return;
	                        }
	                        var exportedDeclarationsCount = ts.countWhere(declarations, isNotOverloadAndNotAccessor);
	                        if (flags & 524288 /* TypeAlias */ && exportedDeclarationsCount <= 2) {
	                            // it is legal to merge type alias with other values
	                            // so count should be either 1 (just type alias) or 2 (type alias + merged value)
	                            return;
	                        }
	                        if (exportedDeclarationsCount > 1) {
	                            for (var _i = 0, declarations_9 = declarations; _i < declarations_9.length; _i++) {
	                                var declaration = declarations_9[_i];
	                                if (isNotOverload(declaration)) {
	                                    diagnostics.add(ts.createDiagnosticForNode(declaration, ts.Diagnostics.Cannot_redeclare_exported_variable_0, ts.unescapeLeadingUnderscores(id)));
	                                }
	                            }
	                        }
	                    });
	                }
	                links.exportsChecked = true;
	            }
	        }
	        function isNotAccessor(declaration) {
	            // Accessors check for their own matching duplicates, and in contexts where they are valid, there are already duplicate identifier checks
	            return !ts.isAccessor(declaration);
	        }
	        function isNotOverload(declaration) {
	            return (declaration.kind !== 233 /* FunctionDeclaration */ && declaration.kind !== 153 /* MethodDeclaration */) ||
	                !!declaration.body;
	        }
	        function checkSourceElement(node) {
	            if (!node) {
	                return;
	            }
	            if (ts.isInJavaScriptFile(node) && node.jsDoc) {
	                for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                    var tags = _a[_i].tags;
	                    ts.forEach(tags, checkSourceElement);
	                }
	            }
	            var kind = node.kind;
	            if (cancellationToken) {
	                // Only bother checking on a few construct kinds.  We don't want to be excessively
	                // hitting the cancellation token on every node we check.
	                switch (kind) {
	                    case 238 /* ModuleDeclaration */:
	                    case 234 /* ClassDeclaration */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 233 /* FunctionDeclaration */:
	                        cancellationToken.throwIfCancellationRequested();
	                }
	            }
	            switch (kind) {
	                case 147 /* TypeParameter */:
	                    return checkTypeParameter(node);
	                case 148 /* Parameter */:
	                    return checkParameter(node);
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return checkPropertyDeclaration(node);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 159 /* IndexSignature */:
	                    return checkSignatureDeclaration(node);
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    return checkMethodDeclaration(node);
	                case 154 /* Constructor */:
	                    return checkConstructorDeclaration(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return checkAccessorDeclaration(node);
	                case 161 /* TypeReference */:
	                    return checkTypeReferenceNode(node);
	                case 160 /* TypePredicate */:
	                    return checkTypePredicate(node);
	                case 164 /* TypeQuery */:
	                    return checkTypeQuery(node);
	                case 165 /* TypeLiteral */:
	                    return checkTypeLiteral(node);
	                case 166 /* ArrayType */:
	                    return checkArrayType(node);
	                case 167 /* TupleType */:
	                    return checkTupleType(node);
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                    return checkUnionOrIntersectionType(node);
	                case 172 /* ParenthesizedType */:
	                    return checkSourceElement(node.type);
	                case 174 /* TypeOperator */:
	                    return checkTypeOperator(node);
	                case 170 /* ConditionalType */:
	                    return checkConditionalType(node);
	                case 171 /* InferType */:
	                    return checkInferType(node);
	                case 178 /* ImportType */:
	                    return checkImportType(node);
	                case 289 /* JSDocAugmentsTag */:
	                    return checkJSDocAugmentsTag(node);
	                case 296 /* JSDocTypedefTag */:
	                case 291 /* JSDocCallbackTag */:
	                    return checkJSDocTypeAliasTag(node);
	                case 292 /* JSDocParameterTag */:
	                    return checkJSDocParameterTag(node);
	                case 283 /* JSDocFunctionType */:
	                    checkSignatureDeclaration(node);
	                // falls through
	                case 281 /* JSDocNonNullableType */:
	                case 280 /* JSDocNullableType */:
	                case 278 /* JSDocAllType */:
	                case 279 /* JSDocUnknownType */:
	                case 286 /* JSDocTypeLiteral */:
	                    checkJSDocTypeIsInJsFile(node);
	                    ts.forEachChild(node, checkSourceElement);
	                    return;
	                case 284 /* JSDocVariadicType */:
	                    checkJSDocVariadicType(node);
	                    return;
	                case 277 /* JSDocTypeExpression */:
	                    return checkSourceElement(node.type);
	                case 175 /* IndexedAccessType */:
	                    return checkIndexedAccessType(node);
	                case 176 /* MappedType */:
	                    return checkMappedType(node);
	                case 233 /* FunctionDeclaration */:
	                    return checkFunctionDeclaration(node);
	                case 212 /* Block */:
	                case 239 /* ModuleBlock */:
	                    return checkBlock(node);
	                case 213 /* VariableStatement */:
	                    return checkVariableStatement(node);
	                case 215 /* ExpressionStatement */:
	                    return checkExpressionStatement(node);
	                case 216 /* IfStatement */:
	                    return checkIfStatement(node);
	                case 217 /* DoStatement */:
	                    return checkDoStatement(node);
	                case 218 /* WhileStatement */:
	                    return checkWhileStatement(node);
	                case 219 /* ForStatement */:
	                    return checkForStatement(node);
	                case 220 /* ForInStatement */:
	                    return checkForInStatement(node);
	                case 221 /* ForOfStatement */:
	                    return checkForOfStatement(node);
	                case 222 /* ContinueStatement */:
	                case 223 /* BreakStatement */:
	                    return checkBreakOrContinueStatement(node);
	                case 224 /* ReturnStatement */:
	                    return checkReturnStatement(node);
	                case 225 /* WithStatement */:
	                    return checkWithStatement(node);
	                case 226 /* SwitchStatement */:
	                    return checkSwitchStatement(node);
	                case 227 /* LabeledStatement */:
	                    return checkLabeledStatement(node);
	                case 228 /* ThrowStatement */:
	                    return checkThrowStatement(node);
	                case 229 /* TryStatement */:
	                    return checkTryStatement(node);
	                case 231 /* VariableDeclaration */:
	                    return checkVariableDeclaration(node);
	                case 181 /* BindingElement */:
	                    return checkBindingElement(node);
	                case 234 /* ClassDeclaration */:
	                    return checkClassDeclaration(node);
	                case 235 /* InterfaceDeclaration */:
	                    return checkInterfaceDeclaration(node);
	                case 236 /* TypeAliasDeclaration */:
	                    return checkTypeAliasDeclaration(node);
	                case 237 /* EnumDeclaration */:
	                    return checkEnumDeclaration(node);
	                case 238 /* ModuleDeclaration */:
	                    return checkModuleDeclaration(node);
	                case 243 /* ImportDeclaration */:
	                    return checkImportDeclaration(node);
	                case 242 /* ImportEqualsDeclaration */:
	                    return checkImportEqualsDeclaration(node);
	                case 249 /* ExportDeclaration */:
	                    return checkExportDeclaration(node);
	                case 248 /* ExportAssignment */:
	                    return checkExportAssignment(node);
	                case 214 /* EmptyStatement */:
	                case 230 /* DebuggerStatement */:
	                    checkGrammarStatementInAmbientContext(node);
	                    return;
	                case 252 /* MissingDeclaration */:
	                    return checkMissingDeclaration(node);
	            }
	        }
	        function checkJSDocTypeIsInJsFile(node) {
	            if (!ts.isInJavaScriptFile(node)) {
	                grammarErrorOnNode(node, ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments);
	            }
	        }
	        function checkJSDocVariadicType(node) {
	            checkJSDocTypeIsInJsFile(node);
	            checkSourceElement(node.type);
	            // Only legal location is in the *last* parameter tag or last parameter of a JSDoc function.
	            var parent = node.parent;
	            if (ts.isParameter(parent) && ts.isJSDocFunctionType(parent.parent)) {
	                if (ts.last(parent.parent.parameters) !== parent) {
	                    error(node, ts.Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
	                }
	                return;
	            }
	            if (!ts.isJSDocTypeExpression(parent)) {
	                error(node, ts.Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
	            }
	            var paramTag = parent.parent;
	            if (!ts.isJSDocParameterTag(paramTag)) {
	                error(node, ts.Diagnostics.JSDoc_may_only_appear_in_the_last_parameter_of_a_signature);
	                return;
	            }
	            var param = ts.getParameterSymbolFromJSDoc(paramTag);
	            if (!param) {
	                // We will error in `checkJSDocParameterTag`.
	                return;
	            }
	            var host = ts.getHostSignatureFromJSDoc(paramTag);
	            if (!host || ts.last(host.parameters).symbol !== param) {
	                error(node, ts.Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
	            }
	        }
	        function getTypeFromJSDocVariadicType(node) {
	            var type = getTypeFromTypeNode(node.type);
	            var parent = node.parent;
	            var paramTag = parent.parent;
	            if (ts.isJSDocTypeExpression(parent) && ts.isJSDocParameterTag(paramTag)) {
	                // Else we will add a diagnostic, see `checkJSDocVariadicType`.
	                var host_1 = ts.getHostSignatureFromJSDoc(paramTag);
	                if (host_1) {
	                    /*
	                    Only return an array type if the corresponding parameter is marked as a rest parameter, or if there are no parameters.
	                    So in the following situation we will not create an array type:
	                        /** @param {...number} a * /
	                        function f(a) {}
	                    Because `a` will just be of type `number | undefined`. A synthetic `...args` will also be added, which *will* get an array type.
	                    */
	                    var lastParamDeclaration = ts.lastOrUndefined(host_1.parameters);
	                    var symbol = ts.getParameterSymbolFromJSDoc(paramTag);
	                    if (!lastParamDeclaration ||
	                        symbol && lastParamDeclaration.symbol === symbol && ts.isRestParameter(lastParamDeclaration)) {
	                        return createArrayType(type);
	                    }
	                }
	            }
	            if (ts.isParameter(parent) && ts.isJSDocFunctionType(parent.parent)) {
	                return createArrayType(type);
	            }
	            return addOptionality(type);
	        }
	        // Function and class expression bodies are checked after all statements in the enclosing body. This is
	        // to ensure constructs like the following are permitted:
	        //     const foo = function () {
	        //        const s = foo();
	        //        return "hello";
	        //     }
	        // Here, performing a full type check of the body of the function expression whilst in the process of
	        // determining the type of foo would cause foo to be given type any because of the recursive reference.
	        // Delaying the type check of the body ensures foo has been assigned a type.
	        function checkNodeDeferred(node) {
	            if (deferredNodes) {
	                deferredNodes.push(node);
	            }
	        }
	        function checkDeferredNodes() {
	            for (var _i = 0, deferredNodes_1 = deferredNodes; _i < deferredNodes_1.length; _i++) {
	                var node = deferredNodes_1[_i];
	                switch (node.kind) {
	                    case 191 /* FunctionExpression */:
	                    case 192 /* ArrowFunction */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        checkFunctionExpressionOrObjectLiteralMethodDeferred(node);
	                        break;
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        checkAccessorDeclaration(node);
	                        break;
	                    case 204 /* ClassExpression */:
	                        checkClassExpressionDeferred(node);
	                        break;
	                }
	            }
	        }
	        function checkSourceFile(node) {
	            ts.performance.mark("beforeCheck");
	            checkSourceFileWorker(node);
	            ts.performance.mark("afterCheck");
	            ts.performance.measure("Check", "beforeCheck", "afterCheck");
	        }
	        function unusedIsError(kind) {
	            switch (kind) {
	                case 0 /* Local */:
	                    return compilerOptions.noUnusedLocals;
	                case 1 /* Parameter */:
	                    return compilerOptions.noUnusedParameters;
	                default:
	                    return ts.Debug.assertNever(kind);
	            }
	        }
	        function getPotentiallyUnusedIdentifiers(sourceFile) {
	            return allPotentiallyUnusedIdentifiers.get(sourceFile.path) || ts.emptyArray;
	        }
	        // Fully type check a source file and collect the relevant diagnostics.
	        function checkSourceFileWorker(node) {
	            var links = getNodeLinks(node);
	            if (!(links.flags & 1 /* TypeChecked */)) {
	                // If skipLibCheck is enabled, skip type checking if file is a declaration file.
	                // If skipDefaultLibCheck is enabled, skip type checking if file contains a
	                // '/// <reference no-default-lib="true"/>' directive.
	                if (compilerOptions.skipLibCheck && node.isDeclarationFile || compilerOptions.skipDefaultLibCheck && node.hasNoDefaultLib) {
	                    return;
	                }
	                // Grammar checking
	                checkGrammarSourceFile(node);
	                ts.clear(potentialThisCollisions);
	                ts.clear(potentialNewTargetCollisions);
	                deferredNodes = [];
	                ts.forEach(node.statements, checkSourceElement);
	                checkDeferredNodes();
	                if (ts.isExternalOrCommonJsModule(node)) {
	                    registerForUnusedIdentifiersCheck(node);
	                }
	                if (!node.isDeclarationFile && (compilerOptions.noUnusedLocals || compilerOptions.noUnusedParameters)) {
	                    checkUnusedIdentifiers(getPotentiallyUnusedIdentifiers(node), function (kind, diag) {
	                        if (unusedIsError(kind)) {
	                            diagnostics.add(diag);
	                        }
	                    });
	                }
	                deferredNodes = undefined;
	                if (ts.isExternalOrCommonJsModule(node)) {
	                    checkExternalModuleExports(node);
	                }
	                if (potentialThisCollisions.length) {
	                    ts.forEach(potentialThisCollisions, checkIfThisIsCapturedInEnclosingScope);
	                    ts.clear(potentialThisCollisions);
	                }
	                if (potentialNewTargetCollisions.length) {
	                    ts.forEach(potentialNewTargetCollisions, checkIfNewTargetIsCapturedInEnclosingScope);
	                    ts.clear(potentialNewTargetCollisions);
	                }
	                links.flags |= 1 /* TypeChecked */;
	            }
	        }
	        function getDiagnostics(sourceFile, ct) {
	            try {
	                // Record the cancellation token so it can be checked later on during checkSourceElement.
	                // Do this in a finally block so we can ensure that it gets reset back to nothing after
	                // this call is done.
	                cancellationToken = ct;
	                return getDiagnosticsWorker(sourceFile);
	            }
	            finally {
	                cancellationToken = undefined;
	            }
	        }
	        function getDiagnosticsWorker(sourceFile) {
	            throwIfNonDiagnosticsProducing();
	            if (sourceFile) {
	                // Some global diagnostics are deferred until they are needed and
	                // may not be reported in the firt call to getGlobalDiagnostics.
	                // We should catch these changes and report them.
	                var previousGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
	                var previousGlobalDiagnosticsSize = previousGlobalDiagnostics.length;
	                checkSourceFile(sourceFile);
	                var semanticDiagnostics = diagnostics.getDiagnostics(sourceFile.fileName);
	                var currentGlobalDiagnostics = diagnostics.getGlobalDiagnostics();
	                if (currentGlobalDiagnostics !== previousGlobalDiagnostics) {
	                    // If the arrays are not the same reference, new diagnostics were added.
	                    var deferredGlobalDiagnostics = ts.relativeComplement(previousGlobalDiagnostics, currentGlobalDiagnostics, ts.compareDiagnostics);
	                    return ts.concatenate(deferredGlobalDiagnostics, semanticDiagnostics);
	                }
	                else if (previousGlobalDiagnosticsSize === 0 && currentGlobalDiagnostics.length > 0) {
	                    // If the arrays are the same reference, but the length has changed, a single
	                    // new diagnostic was added as DiagnosticCollection attempts to reuse the
	                    // same array.
	                    return ts.concatenate(currentGlobalDiagnostics, semanticDiagnostics);
	                }
	                return semanticDiagnostics;
	            }
	            // Global diagnostics are always added when a file is not provided to
	            // getDiagnostics
	            ts.forEach(host.getSourceFiles(), checkSourceFile);
	            return diagnostics.getDiagnostics();
	        }
	        function getGlobalDiagnostics() {
	            throwIfNonDiagnosticsProducing();
	            return diagnostics.getGlobalDiagnostics();
	        }
	        function throwIfNonDiagnosticsProducing() {
	            if (!produceDiagnostics) {
	                throw new Error("Trying to get diagnostics from a type checker that does not produce them.");
	            }
	        }
	        // Language service support
	        function getSymbolsInScope(location, meaning) {
	            if (location.flags & 8388608 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return [];
	            }
	            var symbols = ts.createSymbolTable();
	            var isStatic = false;
	            populateSymbols();
	            return symbolsToArray(symbols);
	            function populateSymbols() {
	                while (location) {
	                    if (location.locals && !isGlobalSourceFile(location)) {
	                        copySymbols(location.locals, meaning);
	                    }
	                    switch (location.kind) {
	                        case 238 /* ModuleDeclaration */:
	                            copySymbols(getSymbolOfNode(location).exports, meaning & 2623475 /* ModuleMember */);
	                            break;
	                        case 237 /* EnumDeclaration */:
	                            copySymbols(getSymbolOfNode(location).exports, meaning & 8 /* EnumMember */);
	                            break;
	                        case 204 /* ClassExpression */:
	                            var className = location.name;
	                            if (className) {
	                                copySymbol(location.symbol, meaning);
	                            }
	                        // falls through
	                        // this fall-through is necessary because we would like to handle
	                        // type parameter inside class expression similar to how we handle it in classDeclaration and interface Declaration
	                        case 234 /* ClassDeclaration */:
	                        case 235 /* InterfaceDeclaration */:
	                            // If we didn't come from static member of class or interface,
	                            // add the type parameters into the symbol table
	                            // (type parameters of classDeclaration/classExpression and interface are in member property of the symbol.
	                            // Note: that the memberFlags come from previous iteration.
	                            if (!isStatic) {
	                                copySymbols(getMembersOfSymbol(getSymbolOfNode(location)), meaning & 67901928 /* Type */);
	                            }
	                            break;
	                        case 191 /* FunctionExpression */:
	                            var funcName = location.name;
	                            if (funcName) {
	                                copySymbol(location.symbol, meaning);
	                            }
	                            break;
	                    }
	                    if (ts.introducesArgumentsExoticObject(location)) {
	                        copySymbol(argumentsSymbol, meaning);
	                    }
	                    isStatic = ts.hasModifier(location, 32 /* Static */);
	                    location = location.parent;
	                }
	                copySymbols(globals, meaning);
	            }
	            /**
	             * Copy the given symbol into symbol tables if the symbol has the given meaning
	             * and it doesn't already existed in the symbol table
	             * @param key a key for storing in symbol table; if undefined, use symbol.name
	             * @param symbol the symbol to be added into symbol table
	             * @param meaning meaning of symbol to filter by before adding to symbol table
	             */
	            function copySymbol(symbol, meaning) {
	                if (ts.getCombinedLocalAndExportSymbolFlags(symbol) & meaning) {
	                    var id = symbol.escapedName;
	                    // We will copy all symbol regardless of its reserved name because
	                    // symbolsToArray will check whether the key is a reserved name and
	                    // it will not copy symbol with reserved name to the array
	                    if (!symbols.has(id)) {
	                        symbols.set(id, symbol);
	                    }
	                }
	            }
	            function copySymbols(source, meaning) {
	                if (meaning) {
	                    source.forEach(function (symbol) {
	                        copySymbol(symbol, meaning);
	                    });
	                }
	            }
	        }
	        function isTypeDeclarationName(name) {
	            return name.kind === 71 /* Identifier */ &&
	                isTypeDeclaration(name.parent) &&
	                name.parent.name === name;
	        }
	        function isTypeDeclaration(node) {
	            switch (node.kind) {
	                case 147 /* TypeParameter */:
	                case 234 /* ClassDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 237 /* EnumDeclaration */:
	                    return true;
	            }
	        }
	        // True if the given identifier is part of a type reference
	        function isTypeReferenceIdentifier(entityName) {
	            var node = entityName;
	            while (node.parent && node.parent.kind === 145 /* QualifiedName */) {
	                node = node.parent;
	            }
	            return node.parent && node.parent.kind === 161 /* TypeReference */;
	        }
	        function isHeritageClauseElementIdentifier(entityName) {
	            var node = entityName;
	            while (node.parent && node.parent.kind === 184 /* PropertyAccessExpression */) {
	                node = node.parent;
	            }
	            return node.parent && node.parent.kind === 206 /* ExpressionWithTypeArguments */;
	        }
	        function forEachEnclosingClass(node, callback) {
	            var result;
	            while (true) {
	                node = ts.getContainingClass(node);
	                if (!node)
	                    break;
	                if (result = callback(node))
	                    break;
	            }
	            return result;
	        }
	        function isNodeWithinConstructorOfClass(node, classDeclaration) {
	            return ts.findAncestor(node, function (element) {
	                if (ts.isConstructorDeclaration(element) && ts.nodeIsPresent(element.body) && element.parent === classDeclaration) {
	                    return true;
	                }
	                else if (element === classDeclaration || ts.isFunctionLikeDeclaration(element)) {
	                    return "quit";
	                }
	                return false;
	            });
	        }
	        function isNodeWithinClass(node, classDeclaration) {
	            return !!forEachEnclosingClass(node, function (n) { return n === classDeclaration; });
	        }
	        function getLeftSideOfImportEqualsOrExportAssignment(nodeOnRightSide) {
	            while (nodeOnRightSide.parent.kind === 145 /* QualifiedName */) {
	                nodeOnRightSide = nodeOnRightSide.parent;
	            }
	            if (nodeOnRightSide.parent.kind === 242 /* ImportEqualsDeclaration */) {
	                return nodeOnRightSide.parent.moduleReference === nodeOnRightSide && nodeOnRightSide.parent;
	            }
	            if (nodeOnRightSide.parent.kind === 248 /* ExportAssignment */) {
	                return nodeOnRightSide.parent.expression === nodeOnRightSide && nodeOnRightSide.parent;
	            }
	            return undefined;
	        }
	        function isInRightSideOfImportOrExportAssignment(node) {
	            return getLeftSideOfImportEqualsOrExportAssignment(node) !== undefined;
	        }
	        function getSpecialPropertyAssignmentSymbolFromEntityName(entityName) {
	            var specialPropertyAssignmentKind = ts.getSpecialPropertyAssignmentKind(entityName.parent.parent);
	            switch (specialPropertyAssignmentKind) {
	                case 1 /* ExportsProperty */:
	                case 3 /* PrototypeProperty */:
	                    return getSymbolOfNode(entityName.parent);
	                case 4 /* ThisProperty */:
	                case 2 /* ModuleExports */:
	                case 5 /* Property */:
	                    return getSymbolOfNode(entityName.parent.parent);
	            }
	        }
	        function isImportTypeQualifierPart(node) {
	            var parent = node.parent;
	            while (ts.isQualifiedName(parent)) {
	                node = parent;
	                parent = parent.parent;
	            }
	            if (parent && parent.kind === 178 /* ImportType */ && parent.qualifier === node) {
	                return parent;
	            }
	            return undefined;
	        }
	        function getSymbolOfEntityNameOrPropertyAccessExpression(entityName) {
	            if (ts.isDeclarationName(entityName)) {
	                return getSymbolOfNode(entityName.parent);
	            }
	            if (ts.isInJavaScriptFile(entityName) &&
	                entityName.parent.kind === 184 /* PropertyAccessExpression */ &&
	                entityName.parent === entityName.parent.parent.left) {
	                // Check if this is a special property assignment
	                var specialPropertyAssignmentSymbol = getSpecialPropertyAssignmentSymbolFromEntityName(entityName);
	                if (specialPropertyAssignmentSymbol) {
	                    return specialPropertyAssignmentSymbol;
	                }
	            }
	            if (entityName.parent.kind === 248 /* ExportAssignment */ && ts.isEntityNameExpression(entityName)) {
	                // Even an entity name expression that doesn't resolve as an entityname may still typecheck as a property access expression
	                var success = resolveEntityName(entityName, 
	                /*all meanings*/ 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */, /*ignoreErrors*/ true);
	                if (success && success !== unknownSymbol) {
	                    return success;
	                }
	            }
	            else if (!ts.isPropertyAccessExpression(entityName) && isInRightSideOfImportOrExportAssignment(entityName)) {
	                // Since we already checked for ExportAssignment, this really could only be an Import
	                var importEqualsDeclaration = ts.getAncestor(entityName, 242 /* ImportEqualsDeclaration */);
	                ts.Debug.assert(importEqualsDeclaration !== undefined);
	                return getSymbolOfPartOfRightHandSideOfImportEquals(entityName, /*dontResolveAlias*/ true);
	            }
	            if (!ts.isPropertyAccessExpression(entityName)) {
	                var possibleImportNode = isImportTypeQualifierPart(entityName);
	                if (possibleImportNode) {
	                    getTypeFromTypeNode(possibleImportNode);
	                    var sym = getNodeLinks(entityName).resolvedSymbol;
	                    return sym === unknownSymbol ? undefined : sym;
	                }
	            }
	            while (ts.isRightSideOfQualifiedNameOrPropertyAccess(entityName)) {
	                entityName = entityName.parent;
	            }
	            if (isHeritageClauseElementIdentifier(entityName)) {
	                var meaning = 0 /* None */;
	                // In an interface or class, we're definitely interested in a type.
	                if (entityName.parent.kind === 206 /* ExpressionWithTypeArguments */) {
	                    meaning = 67901928 /* Type */;
	                    // In a class 'extends' clause we are also looking for a value.
	                    if (ts.isExpressionWithTypeArgumentsInClassExtendsClause(entityName.parent)) {
	                        meaning |= 67216319 /* Value */;
	                    }
	                }
	                else {
	                    meaning = 1920 /* Namespace */;
	                }
	                meaning |= 2097152 /* Alias */;
	                var entityNameSymbol = ts.isEntityNameExpression(entityName) ? resolveEntityName(entityName, meaning) : undefined;
	                if (entityNameSymbol) {
	                    return entityNameSymbol;
	                }
	            }
	            if (entityName.parent.kind === 292 /* JSDocParameterTag */) {
	                return ts.getParameterSymbolFromJSDoc(entityName.parent);
	            }
	            if (entityName.parent.kind === 147 /* TypeParameter */ && entityName.parent.parent.kind === 295 /* JSDocTemplateTag */) {
	                ts.Debug.assert(!ts.isInJavaScriptFile(entityName)); // Otherwise `isDeclarationName` would have been true.
	                var typeParameter = ts.getTypeParameterFromJsDoc(entityName.parent);
	                return typeParameter && typeParameter.symbol;
	            }
	            if (ts.isExpressionNode(entityName)) {
	                if (ts.nodeIsMissing(entityName)) {
	                    // Missing entity name.
	                    return undefined;
	                }
	                if (entityName.kind === 71 /* Identifier */) {
	                    if (ts.isJSXTagName(entityName) && isJsxIntrinsicIdentifier(entityName)) {
	                        var symbol = getIntrinsicTagSymbol(entityName.parent);
	                        return symbol === unknownSymbol ? undefined : symbol;
	                    }
	                    return resolveEntityName(entityName, 67216319 /* Value */, /*ignoreErrors*/ false, /*dontResolveAlias*/ true);
	                }
	                else if (entityName.kind === 184 /* PropertyAccessExpression */ || entityName.kind === 145 /* QualifiedName */) {
	                    var links = getNodeLinks(entityName);
	                    if (links.resolvedSymbol) {
	                        return links.resolvedSymbol;
	                    }
	                    if (entityName.kind === 184 /* PropertyAccessExpression */) {
	                        checkPropertyAccessExpression(entityName);
	                    }
	                    else {
	                        checkQualifiedName(entityName);
	                    }
	                    return links.resolvedSymbol;
	                }
	            }
	            else if (isTypeReferenceIdentifier(entityName)) {
	                var meaning = entityName.parent.kind === 161 /* TypeReference */ ? 67901928 /* Type */ : 1920 /* Namespace */;
	                return resolveEntityName(entityName, meaning, /*ignoreErrors*/ false, /*dontResolveAlias*/ true);
	            }
	            else if (entityName.parent.kind === 261 /* JsxAttribute */) {
	                return getJsxAttributePropertySymbol(entityName.parent);
	            }
	            if (entityName.parent.kind === 160 /* TypePredicate */) {
	                return resolveEntityName(entityName, /*meaning*/ 1 /* FunctionScopedVariable */);
	            }
	            // Do we want to return undefined here?
	            return undefined;
	        }
	        function getSymbolAtLocation(node) {
	            if (node.kind === 273 /* SourceFile */) {
	                return ts.isExternalModule(node) ? getMergedSymbol(node.symbol) : undefined;
	            }
	            if (node.flags & 8388608 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return undefined;
	            }
	            if (isDeclarationNameOrImportPropertyName(node)) {
	                // This is a declaration, call getSymbolOfNode
	                return getSymbolOfNode(node.parent);
	            }
	            else if (ts.isLiteralComputedPropertyDeclarationName(node)) {
	                return getSymbolOfNode(node.parent.parent);
	            }
	            if (node.kind === 71 /* Identifier */) {
	                if (isInRightSideOfImportOrExportAssignment(node)) {
	                    return getSymbolOfEntityNameOrPropertyAccessExpression(node);
	                }
	                else if (node.parent.kind === 181 /* BindingElement */ &&
	                    node.parent.parent.kind === 179 /* ObjectBindingPattern */ &&
	                    node === node.parent.propertyName) {
	                    var typeOfPattern = getTypeOfNode(node.parent.parent);
	                    var propertyDeclaration = typeOfPattern && getPropertyOfType(typeOfPattern, node.escapedText);
	                    if (propertyDeclaration) {
	                        return propertyDeclaration;
	                    }
	                }
	            }
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 184 /* PropertyAccessExpression */:
	                case 145 /* QualifiedName */:
	                    return getSymbolOfEntityNameOrPropertyAccessExpression(node);
	                case 99 /* ThisKeyword */:
	                    var container = ts.getThisContainer(node, /*includeArrowFunctions*/ false);
	                    if (ts.isFunctionLike(container)) {
	                        var sig = getSignatureFromDeclaration(container);
	                        if (sig.thisParameter) {
	                            return sig.thisParameter;
	                        }
	                    }
	                    if (ts.isInExpressionContext(node)) {
	                        return checkExpression(node).symbol;
	                    }
	                // falls through
	                case 173 /* ThisType */:
	                    return getTypeFromThisTypeNode(node).symbol;
	                case 97 /* SuperKeyword */:
	                    return checkExpression(node).symbol;
	                case 123 /* ConstructorKeyword */:
	                    // constructor keyword for an overload, should take us to the definition if it exist
	                    var constructorDeclaration = node.parent;
	                    if (constructorDeclaration && constructorDeclaration.kind === 154 /* Constructor */) {
	                        return constructorDeclaration.parent.symbol;
	                    }
	                    return undefined;
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                    // 1). import x = require("./mo/*gotToDefinitionHere*/d")
	                    // 2). External module name in an import declaration
	                    // 3). Dynamic import call or require in javascript
	                    // 4). type A = import("./f/*gotToDefinitionHere*/oo")
	                    if ((ts.isExternalModuleImportEqualsDeclaration(node.parent.parent) && ts.getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node) ||
	                        ((node.parent.kind === 243 /* ImportDeclaration */ || node.parent.kind === 249 /* ExportDeclaration */) && node.parent.moduleSpecifier === node) ||
	                        ((ts.isInJavaScriptFile(node) && ts.isRequireCall(node.parent, /*checkArgumentIsStringLiteralLike*/ false)) || ts.isImportCall(node.parent)) ||
	                        (ts.isLiteralTypeNode(node.parent) && ts.isLiteralImportTypeNode(node.parent.parent) && node.parent.parent.argument === node.parent)) {
	                        return resolveExternalModuleName(node, node);
	                    }
	                // falls through
	                case 8 /* NumericLiteral */:
	                    // index access
	                    var objectType = ts.isElementAccessExpression(node.parent)
	                        ? node.parent.argumentExpression === node ? getTypeOfExpression(node.parent.expression) : undefined
	                        : ts.isLiteralTypeNode(node.parent) && ts.isIndexedAccessTypeNode(node.parent.parent)
	                            ? getTypeFromTypeNode(node.parent.parent.objectType)
	                            : undefined;
	                    return objectType && getPropertyOfType(objectType, ts.escapeLeadingUnderscores(node.text));
	                case 79 /* DefaultKeyword */:
	                case 89 /* FunctionKeyword */:
	                case 36 /* EqualsGreaterThanToken */:
	                    return getSymbolOfNode(node.parent);
	                case 178 /* ImportType */:
	                    return ts.isLiteralImportTypeNode(node) ? getSymbolAtLocation(node.argument.literal) : undefined;
	                default:
	                    return undefined;
	            }
	        }
	        function getShorthandAssignmentValueSymbol(location) {
	            if (location && location.kind === 270 /* ShorthandPropertyAssignment */) {
	                return resolveEntityName(location.name, 67216319 /* Value */ | 2097152 /* Alias */);
	            }
	            return undefined;
	        }
	        /** Returns the target of an export specifier without following aliases */
	        function getExportSpecifierLocalTargetSymbol(node) {
	            return node.parent.parent.moduleSpecifier ?
	                getExternalModuleMember(node.parent.parent, node) :
	                resolveEntityName(node.propertyName || node.name, 67216319 /* Value */ | 67901928 /* Type */ | 1920 /* Namespace */ | 2097152 /* Alias */);
	        }
	        function getTypeOfNode(node) {
	            if (node.flags & 8388608 /* InWithStatement */) {
	                // We cannot answer semantic questions within a with block, do not proceed any further
	                return unknownType;
	            }
	            if (ts.isPartOfTypeNode(node)) {
	                var typeFromTypeNode = getTypeFromTypeNode(node);
	                if (typeFromTypeNode && ts.isExpressionWithTypeArgumentsInClassImplementsClause(node)) {
	                    var containingClass = ts.getContainingClass(node);
	                    var classType = getTypeOfNode(containingClass);
	                    typeFromTypeNode = getTypeWithThisArgument(typeFromTypeNode, classType.thisType);
	                }
	                return typeFromTypeNode;
	            }
	            if (ts.isExpressionNode(node)) {
	                return getRegularTypeOfExpression(node);
	            }
	            if (ts.isExpressionWithTypeArgumentsInClassExtendsClause(node)) {
	                // A SyntaxKind.ExpressionWithTypeArguments is considered a type node, except when it occurs in the
	                // extends clause of a class. We handle that case here.
	                var classNode = ts.getContainingClass(node);
	                var classType = getDeclaredTypeOfSymbol(getSymbolOfNode(classNode));
	                var baseType = getBaseTypes(classType)[0];
	                return baseType && getTypeWithThisArgument(baseType, classType.thisType);
	            }
	            if (isTypeDeclaration(node)) {
	                // In this case, we call getSymbolOfNode instead of getSymbolAtLocation because it is a declaration
	                var symbol = getSymbolOfNode(node);
	                return getDeclaredTypeOfSymbol(symbol);
	            }
	            if (isTypeDeclarationName(node)) {
	                var symbol = getSymbolAtLocation(node);
	                return symbol && getDeclaredTypeOfSymbol(symbol);
	            }
	            if (ts.isDeclaration(node)) {
	                // In this case, we call getSymbolOfNode instead of getSymbolAtLocation because it is a declaration
	                var symbol = getSymbolOfNode(node);
	                return getTypeOfSymbol(symbol);
	            }
	            if (isDeclarationNameOrImportPropertyName(node)) {
	                var symbol = getSymbolAtLocation(node);
	                return symbol && getTypeOfSymbol(symbol);
	            }
	            if (ts.isBindingPattern(node)) {
	                return getTypeForVariableLikeDeclaration(node.parent, /*includeOptionality*/ true);
	            }
	            if (isInRightSideOfImportOrExportAssignment(node)) {
	                var symbol = getSymbolAtLocation(node);
	                if (symbol) {
	                    var declaredType = getDeclaredTypeOfSymbol(symbol);
	                    return declaredType !== unknownType ? declaredType : getTypeOfSymbol(symbol);
	                }
	            }
	            return unknownType;
	        }
	        // Gets the type of object literal or array literal of destructuring assignment.
	        // { a } from
	        //     for ( { a } of elems) {
	        //     }
	        // [ a ] from
	        //     [a] = [ some array ...]
	        function getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr) {
	            ts.Debug.assert(expr.kind === 183 /* ObjectLiteralExpression */ || expr.kind === 182 /* ArrayLiteralExpression */);
	            // If this is from "for of"
	            //     for ( { a } of elems) {
	            //     }
	            if (expr.parent.kind === 221 /* ForOfStatement */) {
	                var iteratedType = checkRightHandSideOfForOf(expr.parent.expression, expr.parent.awaitModifier);
	                return checkDestructuringAssignment(expr, iteratedType || unknownType);
	            }
	            // If this is from "for" initializer
	            //     for ({a } = elems[0];.....) { }
	            if (expr.parent.kind === 199 /* BinaryExpression */) {
	                var iteratedType = getTypeOfExpression(expr.parent.right);
	                return checkDestructuringAssignment(expr, iteratedType || unknownType);
	            }
	            // If this is from nested object binding pattern
	            //     for ({ skills: { primary, secondary } } = multiRobot, i = 0; i < 1; i++) {
	            if (expr.parent.kind === 269 /* PropertyAssignment */) {
	                var typeOfParentObjectLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr.parent.parent);
	                return checkObjectLiteralDestructuringPropertyAssignment(typeOfParentObjectLiteral || unknownType, expr.parent);
	            }
	            // Array literal assignment - array destructuring pattern
	            ts.Debug.assert(expr.parent.kind === 182 /* ArrayLiteralExpression */);
	            //    [{ property1: p1, property2 }] = elems;
	            var typeOfArrayLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(expr.parent);
	            var elementType = checkIteratedTypeOrElementType(typeOfArrayLiteral || unknownType, expr.parent, /*allowStringInput*/ false, /*allowAsyncIterables*/ false) || unknownType;
	            return checkArrayLiteralDestructuringElementAssignment(expr.parent, typeOfArrayLiteral, expr.parent.elements.indexOf(expr), elementType || unknownType);
	        }
	        // Gets the property symbol corresponding to the property in destructuring assignment
	        // 'property1' from
	        //     for ( { property1: a } of elems) {
	        //     }
	        // 'property1' at location 'a' from:
	        //     [a] = [ property1, property2 ]
	        function getPropertySymbolOfDestructuringAssignment(location) {
	            // Get the type of the object or array literal and then look for property of given name in the type
	            var typeOfObjectLiteral = getTypeOfArrayLiteralOrObjectLiteralDestructuringAssignment(location.parent.parent);
	            return typeOfObjectLiteral && getPropertyOfType(typeOfObjectLiteral, location.escapedText);
	        }
	        function getRegularTypeOfExpression(expr) {
	            if (ts.isRightSideOfQualifiedNameOrPropertyAccess(expr)) {
	                expr = expr.parent;
	            }
	            return getRegularTypeOfLiteralType(getTypeOfExpression(expr));
	        }
	        /**
	         * Gets either the static or instance type of a class element, based on
	         * whether the element is declared as "static".
	         */
	        function getParentTypeOfClassElement(node) {
	            var classSymbol = getSymbolOfNode(node.parent);
	            return ts.hasModifier(node, 32 /* Static */)
	                ? getTypeOfSymbol(classSymbol)
	                : getDeclaredTypeOfSymbol(classSymbol);
	        }
	        // Return the list of properties of the given type, augmented with properties from Function
	        // if the type has call or construct signatures
	        function getAugmentedPropertiesOfType(type) {
	            type = getApparentType(type);
	            var propsByName = ts.createSymbolTable(getPropertiesOfType(type));
	            if (typeHasCallOrConstructSignatures(type)) {
	                ts.forEach(getPropertiesOfType(globalFunctionType), function (p) {
	                    if (!propsByName.has(p.escapedName)) {
	                        propsByName.set(p.escapedName, p);
	                    }
	                });
	            }
	            return getNamedMembers(propsByName);
	        }
	        function typeHasCallOrConstructSignatures(type) {
	            return ts.typeHasCallOrConstructSignatures(type, checker);
	        }
	        function getRootSymbols(symbol) {
	            var roots = getImmediateRootSymbols(symbol);
	            return roots ? ts.flatMap(roots, getRootSymbols) : [symbol];
	        }
	        function getImmediateRootSymbols(symbol) {
	            if (ts.getCheckFlags(symbol) & 6 /* Synthetic */) {
	                return ts.mapDefined(getSymbolLinks(symbol).containingType.types, function (type) { return getPropertyOfType(type, symbol.escapedName); });
	            }
	            else if (symbol.flags & 33554432 /* Transient */) {
	                var _a = symbol, leftSpread = _a.leftSpread, rightSpread = _a.rightSpread, syntheticOrigin = _a.syntheticOrigin;
	                return leftSpread ? [leftSpread, rightSpread]
	                    : syntheticOrigin ? [syntheticOrigin]
	                        : ts.singleElementArray(tryGetAliasTarget(symbol));
	            }
	            return undefined;
	        }
	        function tryGetAliasTarget(symbol) {
	            var target;
	            var next = symbol;
	            while (next = getSymbolLinks(next).target) {
	                target = next;
	            }
	            return target;
	        }
	        // Emitter support
	        function isArgumentsLocalBinding(node) {
	            if (!ts.isGeneratedIdentifier(node)) {
	                node = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (node) {
	                    var isPropertyName_1 = node.parent.kind === 184 /* PropertyAccessExpression */ && node.parent.name === node;
	                    return !isPropertyName_1 && getReferencedValueSymbol(node) === argumentsSymbol;
	                }
	            }
	            return false;
	        }
	        function moduleExportsSomeValue(moduleReferenceExpression) {
	            var moduleSymbol = resolveExternalModuleName(moduleReferenceExpression.parent, moduleReferenceExpression);
	            if (!moduleSymbol || ts.isShorthandAmbientModuleSymbol(moduleSymbol)) {
	                // If the module is not found or is shorthand, assume that it may export a value.
	                return true;
	            }
	            var hasExportAssignment = hasExportAssignmentSymbol(moduleSymbol);
	            // if module has export assignment then 'resolveExternalModuleSymbol' will return resolved symbol for export assignment
	            // otherwise it will return moduleSymbol itself
	            moduleSymbol = resolveExternalModuleSymbol(moduleSymbol);
	            var symbolLinks = getSymbolLinks(moduleSymbol);
	            if (symbolLinks.exportsSomeValue === undefined) {
	                // for export assignments - check if resolved symbol for RHS is itself a value
	                // otherwise - check if at least one export is value
	                symbolLinks.exportsSomeValue = hasExportAssignment
	                    ? !!(moduleSymbol.flags & 67216319 /* Value */)
	                    : ts.forEachEntry(getExportsOfModule(moduleSymbol), isValue);
	            }
	            return symbolLinks.exportsSomeValue;
	            function isValue(s) {
	                s = resolveSymbol(s);
	                return s && !!(s.flags & 67216319 /* Value */);
	            }
	        }
	        function isNameOfModuleOrEnumDeclaration(node) {
	            var parent = node.parent;
	            return parent && ts.isModuleOrEnumDeclaration(parent) && node === parent.name;
	        }
	        // When resolved as an expression identifier, if the given node references an exported entity, return the declaration
	        // node of the exported entity's container. Otherwise, return undefined.
	        function getReferencedExportContainer(node, prefixLocals) {
	            node = ts.getParseTreeNode(node, ts.isIdentifier);
	            if (node) {
	                // When resolving the export container for the name of a module or enum
	                // declaration, we need to start resolution at the declaration's container.
	                // Otherwise, we could incorrectly resolve the export container as the
	                // declaration if it contains an exported member with the same name.
	                var symbol = getReferencedValueSymbol(node, /*startInDeclarationContainer*/ isNameOfModuleOrEnumDeclaration(node));
	                if (symbol) {
	                    if (symbol.flags & 1048576 /* ExportValue */) {
	                        // If we reference an exported entity within the same module declaration, then whether
	                        // we prefix depends on the kind of entity. SymbolFlags.ExportHasLocal encompasses all the
	                        // kinds that we do NOT prefix.
	                        var exportSymbol = getMergedSymbol(symbol.exportSymbol);
	                        if (!prefixLocals && exportSymbol.flags & 944 /* ExportHasLocal */ && !(exportSymbol.flags & 3 /* Variable */)) {
	                            return undefined;
	                        }
	                        symbol = exportSymbol;
	                    }
	                    var parentSymbol_1 = getParentOfSymbol(symbol);
	                    if (parentSymbol_1) {
	                        if (parentSymbol_1.flags & 512 /* ValueModule */ && parentSymbol_1.valueDeclaration.kind === 273 /* SourceFile */) {
	                            var symbolFile = parentSymbol_1.valueDeclaration;
	                            var referenceFile = ts.getSourceFileOfNode(node);
	                            // If `node` accesses an export and that export isn't in the same file, then symbol is a namespace export, so return undefined.
	                            var symbolIsUmdExport = symbolFile !== referenceFile;
	                            return symbolIsUmdExport ? undefined : symbolFile;
	                        }
	                        return ts.findAncestor(node.parent, function (n) { return ts.isModuleOrEnumDeclaration(n) && getSymbolOfNode(n) === parentSymbol_1; });
	                    }
	                }
	            }
	        }
	        // When resolved as an expression identifier, if the given node references an import, return the declaration of
	        // that import. Otherwise, return undefined.
	        function getReferencedImportDeclaration(node) {
	            node = ts.getParseTreeNode(node, ts.isIdentifier);
	            if (node) {
	                var symbol = getReferencedValueSymbol(node);
	                // We should only get the declaration of an alias if there isn't a local value
	                // declaration for the symbol
	                if (isNonLocalAlias(symbol, /*excludes*/ 67216319 /* Value */)) {
	                    return getDeclarationOfAliasSymbol(symbol);
	                }
	            }
	            return undefined;
	        }
	        function isSymbolOfDeclarationWithCollidingName(symbol) {
	            if (symbol.flags & 418 /* BlockScoped */) {
	                var links = getSymbolLinks(symbol);
	                if (links.isDeclarationWithCollidingName === undefined) {
	                    var container = ts.getEnclosingBlockScopeContainer(symbol.valueDeclaration);
	                    if (ts.isStatementWithLocals(container)) {
	                        var nodeLinks_1 = getNodeLinks(symbol.valueDeclaration);
	                        if (resolveName(container.parent, symbol.escapedName, 67216319 /* Value */, /*nameNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ false)) {
	                            // redeclaration - always should be renamed
	                            links.isDeclarationWithCollidingName = true;
	                        }
	                        else if (nodeLinks_1.flags & 131072 /* CapturedBlockScopedBinding */) {
	                            // binding is captured in the function
	                            // should be renamed if:
	                            // - binding is not top level - top level bindings never collide with anything
	                            // AND
	                            //   - binding is not declared in loop, should be renamed to avoid name reuse across siblings
	                            //     let a, b
	                            //     { let x = 1; a = () => x; }
	                            //     { let x = 100; b = () => x; }
	                            //     console.log(a()); // should print '1'
	                            //     console.log(b()); // should print '100'
	                            //     OR
	                            //   - binding is declared inside loop but not in inside initializer of iteration statement or directly inside loop body
	                            //     * variables from initializer are passed to rewritten loop body as parameters so they are not captured directly
	                            //     * variables that are declared immediately in loop body will become top level variable after loop is rewritten and thus
	                            //       they will not collide with anything
	                            var isDeclaredInLoop = nodeLinks_1.flags & 262144 /* BlockScopedBindingInLoop */;
	                            var inLoopInitializer = ts.isIterationStatement(container, /*lookInLabeledStatements*/ false);
	                            var inLoopBodyBlock = container.kind === 212 /* Block */ && ts.isIterationStatement(container.parent, /*lookInLabeledStatements*/ false);
	                            links.isDeclarationWithCollidingName = !ts.isBlockScopedContainerTopLevel(container) && (!isDeclaredInLoop || (!inLoopInitializer && !inLoopBodyBlock));
	                        }
	                        else {
	                            links.isDeclarationWithCollidingName = false;
	                        }
	                    }
	                }
	                return links.isDeclarationWithCollidingName;
	            }
	            return false;
	        }
	        // When resolved as an expression identifier, if the given node references a nested block scoped entity with
	        // a name that either hides an existing name or might hide it when compiled downlevel,
	        // return the declaration of that entity. Otherwise, return undefined.
	        function getReferencedDeclarationWithCollidingName(node) {
	            if (!ts.isGeneratedIdentifier(node)) {
	                node = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (node) {
	                    var symbol = getReferencedValueSymbol(node);
	                    if (symbol && isSymbolOfDeclarationWithCollidingName(symbol)) {
	                        return symbol.valueDeclaration;
	                    }
	                }
	            }
	            return undefined;
	        }
	        // Return true if the given node is a declaration of a nested block scoped entity with a name that either hides an
	        // existing name or might hide a name when compiled downlevel
	        function isDeclarationWithCollidingName(node) {
	            node = ts.getParseTreeNode(node, ts.isDeclaration);
	            if (node) {
	                var symbol = getSymbolOfNode(node);
	                if (symbol) {
	                    return isSymbolOfDeclarationWithCollidingName(symbol);
	                }
	            }
	            return false;
	        }
	        function isValueAliasDeclaration(node) {
	            switch (node.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                case 244 /* ImportClause */:
	                case 245 /* NamespaceImport */:
	                case 247 /* ImportSpecifier */:
	                case 251 /* ExportSpecifier */:
	                    return isAliasResolvedToValue(getSymbolOfNode(node) || unknownSymbol);
	                case 249 /* ExportDeclaration */:
	                    var exportClause = node.exportClause;
	                    return exportClause && ts.forEach(exportClause.elements, isValueAliasDeclaration);
	                case 248 /* ExportAssignment */:
	                    return node.expression
	                        && node.expression.kind === 71 /* Identifier */
	                        ? isAliasResolvedToValue(getSymbolOfNode(node) || unknownSymbol)
	                        : true;
	            }
	            return false;
	        }
	        function isTopLevelValueImportEqualsWithEntityName(node) {
	            node = ts.getParseTreeNode(node, ts.isImportEqualsDeclaration);
	            if (node === undefined || node.parent.kind !== 273 /* SourceFile */ || !ts.isInternalModuleImportEqualsDeclaration(node)) {
	                // parent is not source file or it is not reference to internal module
	                return false;
	            }
	            var isValue = isAliasResolvedToValue(getSymbolOfNode(node));
	            return isValue && node.moduleReference && !ts.nodeIsMissing(node.moduleReference);
	        }
	        function isAliasResolvedToValue(symbol) {
	            var target = resolveAlias(symbol);
	            if (target === unknownSymbol) {
	                return true;
	            }
	            // const enums and modules that contain only const enums are not considered values from the emit perspective
	            // unless 'preserveConstEnums' option is set to true
	            return target.flags & 67216319 /* Value */ &&
	                (compilerOptions.preserveConstEnums || !isConstEnumOrConstEnumOnlyModule(target));
	        }
	        function isConstEnumOrConstEnumOnlyModule(s) {
	            return isConstEnumSymbol(s) || s.constEnumOnlyModule;
	        }
	        function isReferencedAliasDeclaration(node, checkChildren) {
	            if (ts.isAliasSymbolDeclaration(node)) {
	                var symbol = getSymbolOfNode(node);
	                if (symbol && getSymbolLinks(symbol).referenced) {
	                    return true;
	                }
	                var target = getSymbolLinks(symbol).target;
	                if (target && ts.getModifierFlags(node) & 1 /* Export */ && target.flags & 67216319 /* Value */) {
	                    // An `export import ... =` of a value symbol is always considered referenced
	                    return true;
	                }
	            }
	            if (checkChildren) {
	                return ts.forEachChild(node, function (node) { return isReferencedAliasDeclaration(node, checkChildren); });
	            }
	            return false;
	        }
	        function isImplementationOfOverload(node) {
	            if (ts.nodeIsPresent(node.body)) {
	                if (ts.isGetAccessor(node) || ts.isSetAccessor(node))
	                    return false; // Get or set accessors can never be overload implementations, but can have up to 2 signatures
	                var symbol = getSymbolOfNode(node);
	                var signaturesOfSymbol = getSignaturesOfSymbol(symbol);
	                // If this function body corresponds to function with multiple signature, it is implementation of overload
	                // e.g.: function foo(a: string): string;
	                //       function foo(a: number): number;
	                //       function foo(a: any) { // This is implementation of the overloads
	                //           return a;
	                //       }
	                return signaturesOfSymbol.length > 1 ||
	                    // If there is single signature for the symbol, it is overload if that signature isn't coming from the node
	                    // e.g.: function foo(a: string): string;
	                    //       function foo(a: any) { // This is implementation of the overloads
	                    //           return a;
	                    //       }
	                    (signaturesOfSymbol.length === 1 && signaturesOfSymbol[0].declaration !== node);
	            }
	            return false;
	        }
	        function isRequiredInitializedParameter(parameter) {
	            return strictNullChecks &&
	                !isOptionalParameter(parameter) &&
	                !ts.isJSDocParameterTag(parameter) &&
	                parameter.initializer &&
	                !ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */);
	        }
	        function isOptionalUninitializedParameterProperty(parameter) {
	            return strictNullChecks &&
	                isOptionalParameter(parameter) &&
	                !parameter.initializer &&
	                ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */);
	        }
	        function getNodeCheckFlags(node) {
	            return getNodeLinks(node).flags;
	        }
	        function getEnumMemberValue(node) {
	            computeEnumMemberValues(node.parent);
	            return getNodeLinks(node).enumMemberValue;
	        }
	        function canHaveConstantValue(node) {
	            switch (node.kind) {
	                case 272 /* EnumMember */:
	                case 184 /* PropertyAccessExpression */:
	                case 185 /* ElementAccessExpression */:
	                    return true;
	            }
	            return false;
	        }
	        function getConstantValue(node) {
	            if (node.kind === 272 /* EnumMember */) {
	                return getEnumMemberValue(node);
	            }
	            var symbol = getNodeLinks(node).resolvedSymbol;
	            if (symbol && (symbol.flags & 8 /* EnumMember */)) {
	                // inline property\index accesses only for const enums
	                if (ts.isConstEnumDeclaration(symbol.valueDeclaration.parent)) {
	                    return getEnumMemberValue(symbol.valueDeclaration);
	                }
	            }
	            return undefined;
	        }
	        function isFunctionType(type) {
	            return type.flags & 65536 /* Object */ && getSignaturesOfType(type, 0 /* Call */).length > 0;
	        }
	        function getTypeReferenceSerializationKind(typeName, location) {
	            // ensure both `typeName` and `location` are parse tree nodes.
	            typeName = ts.getParseTreeNode(typeName, ts.isEntityName);
	            if (!typeName)
	                return ts.TypeReferenceSerializationKind.Unknown;
	            if (location) {
	                location = ts.getParseTreeNode(location);
	                if (!location)
	                    return ts.TypeReferenceSerializationKind.Unknown;
	            }
	            // Resolve the symbol as a value to ensure the type can be reached at runtime during emit.
	            var valueSymbol = resolveEntityName(typeName, 67216319 /* Value */, /*ignoreErrors*/ true, /*dontResolveAlias*/ false, location);
	            // Resolve the symbol as a type so that we can provide a more useful hint for the type serializer.
	            var typeSymbol = resolveEntityName(typeName, 67901928 /* Type */, /*ignoreErrors*/ true, /*dontResolveAlias*/ false, location);
	            if (valueSymbol && valueSymbol === typeSymbol) {
	                var globalPromiseSymbol = getGlobalPromiseConstructorSymbol(/*reportErrors*/ false);
	                if (globalPromiseSymbol && valueSymbol === globalPromiseSymbol) {
	                    return ts.TypeReferenceSerializationKind.Promise;
	                }
	                var constructorType = getTypeOfSymbol(valueSymbol);
	                if (constructorType && isConstructorType(constructorType)) {
	                    return ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue;
	                }
	            }
	            // We might not be able to resolve type symbol so use unknown type in that case (eg error case)
	            if (!typeSymbol) {
	                return ts.TypeReferenceSerializationKind.Unknown;
	            }
	            var type = getDeclaredTypeOfSymbol(typeSymbol);
	            if (type === unknownType) {
	                return ts.TypeReferenceSerializationKind.Unknown;
	            }
	            else if (type.flags & 1 /* Any */) {
	                return ts.TypeReferenceSerializationKind.ObjectType;
	            }
	            else if (isTypeAssignableToKind(type, 2048 /* Void */ | 12288 /* Nullable */ | 16384 /* Never */)) {
	                return ts.TypeReferenceSerializationKind.VoidNullableOrNeverType;
	            }
	            else if (isTypeAssignableToKind(type, 136 /* BooleanLike */)) {
	                return ts.TypeReferenceSerializationKind.BooleanType;
	            }
	            else if (isTypeAssignableToKind(type, 84 /* NumberLike */)) {
	                return ts.TypeReferenceSerializationKind.NumberLikeType;
	            }
	            else if (isTypeAssignableToKind(type, 34 /* StringLike */)) {
	                return ts.TypeReferenceSerializationKind.StringLikeType;
	            }
	            else if (isTupleType(type)) {
	                return ts.TypeReferenceSerializationKind.ArrayLikeType;
	            }
	            else if (isTypeAssignableToKind(type, 1536 /* ESSymbolLike */)) {
	                return ts.TypeReferenceSerializationKind.ESSymbolType;
	            }
	            else if (isFunctionType(type)) {
	                return ts.TypeReferenceSerializationKind.TypeWithCallSignature;
	            }
	            else if (isArrayType(type)) {
	                return ts.TypeReferenceSerializationKind.ArrayLikeType;
	            }
	            else {
	                return ts.TypeReferenceSerializationKind.ObjectType;
	            }
	        }
	        function createTypeOfDeclaration(declaration, enclosingDeclaration, flags, tracker, addUndefined) {
	            declaration = ts.getParseTreeNode(declaration, ts.isVariableLikeOrAccessor);
	            if (!declaration) {
	                return ts.createToken(119 /* AnyKeyword */);
	            }
	            // Get type of the symbol if this is the valid symbol otherwise get type at location
	            var symbol = getSymbolOfNode(declaration);
	            var type = symbol && !(symbol.flags & (2048 /* TypeLiteral */ | 131072 /* Signature */))
	                ? getWidenedLiteralType(getTypeOfSymbol(symbol))
	                : unknownType;
	            if (type.flags & 1024 /* UniqueESSymbol */ &&
	                type.symbol === symbol) {
	                flags |= 1048576 /* AllowUniqueESSymbolType */;
	            }
	            if (addUndefined) {
	                type = getOptionalType(type);
	            }
	            return nodeBuilder.typeToTypeNode(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, tracker);
	        }
	        function createReturnTypeOfSignatureDeclaration(signatureDeclaration, enclosingDeclaration, flags, tracker) {
	            signatureDeclaration = ts.getParseTreeNode(signatureDeclaration, ts.isFunctionLike);
	            if (!signatureDeclaration) {
	                return ts.createToken(119 /* AnyKeyword */);
	            }
	            var signature = getSignatureFromDeclaration(signatureDeclaration);
	            return nodeBuilder.typeToTypeNode(getReturnTypeOfSignature(signature), enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, tracker);
	        }
	        function createTypeOfExpression(expr, enclosingDeclaration, flags, tracker) {
	            expr = ts.getParseTreeNode(expr, ts.isExpression);
	            if (!expr) {
	                return ts.createToken(119 /* AnyKeyword */);
	            }
	            var type = getWidenedType(getRegularTypeOfExpression(expr));
	            return nodeBuilder.typeToTypeNode(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */, tracker);
	        }
	        function hasGlobalName(name) {
	            return globals.has(ts.escapeLeadingUnderscores(name));
	        }
	        function getReferencedValueSymbol(reference, startInDeclarationContainer) {
	            var resolvedSymbol = getNodeLinks(reference).resolvedSymbol;
	            if (resolvedSymbol) {
	                return resolvedSymbol;
	            }
	            var location = reference;
	            if (startInDeclarationContainer) {
	                // When resolving the name of a declaration as a value, we need to start resolution
	                // at a point outside of the declaration.
	                var parent = reference.parent;
	                if (ts.isDeclaration(parent) && reference === parent.name) {
	                    location = getDeclarationContainer(parent);
	                }
	            }
	            return resolveName(location, reference.escapedText, 67216319 /* Value */ | 1048576 /* ExportValue */ | 2097152 /* Alias */, /*nodeNotFoundMessage*/ undefined, /*nameArg*/ undefined, /*isUse*/ true);
	        }
	        function getReferencedValueDeclaration(reference) {
	            if (!ts.isGeneratedIdentifier(reference)) {
	                reference = ts.getParseTreeNode(reference, ts.isIdentifier);
	                if (reference) {
	                    var symbol = getReferencedValueSymbol(reference);
	                    if (symbol) {
	                        return getExportSymbolOfValueSymbolIfExported(symbol).valueDeclaration;
	                    }
	                }
	            }
	            return undefined;
	        }
	        function isLiteralConstDeclaration(node) {
	            if (ts.isConst(node)) {
	                var type = getTypeOfSymbol(getSymbolOfNode(node));
	                return !!(type.flags & 96 /* StringOrNumberLiteral */ && type.flags & 8388608 /* FreshLiteral */);
	            }
	            return false;
	        }
	        function literalTypeToNode(type) {
	            return ts.createLiteral(type.value);
	        }
	        function createLiteralConstValue(node) {
	            var type = getTypeOfSymbol(getSymbolOfNode(node));
	            return literalTypeToNode(type);
	        }
	        function createResolver() {
	            // this variable and functions that use it are deliberately moved here from the outer scope
	            // to avoid scope pollution
	            var resolvedTypeReferenceDirectives = host.getResolvedTypeReferenceDirectives();
	            var fileToDirective;
	            if (resolvedTypeReferenceDirectives) {
	                // populate reverse mapping: file path -> type reference directive that was resolved to this file
	                fileToDirective = ts.createMap();
	                resolvedTypeReferenceDirectives.forEach(function (resolvedDirective, key) {
	                    if (!resolvedDirective || !resolvedDirective.resolvedFileName) {
	                        return;
	                    }
	                    var file = host.getSourceFile(resolvedDirective.resolvedFileName);
	                    fileToDirective.set(file.path, key);
	                });
	            }
	            return {
	                getReferencedExportContainer: getReferencedExportContainer,
	                getReferencedImportDeclaration: getReferencedImportDeclaration,
	                getReferencedDeclarationWithCollidingName: getReferencedDeclarationWithCollidingName,
	                isDeclarationWithCollidingName: isDeclarationWithCollidingName,
	                isValueAliasDeclaration: function (node) {
	                    node = ts.getParseTreeNode(node);
	                    // Synthesized nodes are always treated like values.
	                    return node ? isValueAliasDeclaration(node) : true;
	                },
	                hasGlobalName: hasGlobalName,
	                isReferencedAliasDeclaration: function (node, checkChildren) {
	                    node = ts.getParseTreeNode(node);
	                    // Synthesized nodes are always treated as referenced.
	                    return node ? isReferencedAliasDeclaration(node, checkChildren) : true;
	                },
	                getNodeCheckFlags: function (node) {
	                    node = ts.getParseTreeNode(node);
	                    return node ? getNodeCheckFlags(node) : undefined;
	                },
	                isTopLevelValueImportEqualsWithEntityName: isTopLevelValueImportEqualsWithEntityName,
	                isDeclarationVisible: isDeclarationVisible,
	                isImplementationOfOverload: isImplementationOfOverload,
	                isRequiredInitializedParameter: isRequiredInitializedParameter,
	                isOptionalUninitializedParameterProperty: isOptionalUninitializedParameterProperty,
	                createTypeOfDeclaration: createTypeOfDeclaration,
	                createReturnTypeOfSignatureDeclaration: createReturnTypeOfSignatureDeclaration,
	                createTypeOfExpression: createTypeOfExpression,
	                createLiteralConstValue: createLiteralConstValue,
	                isSymbolAccessible: isSymbolAccessible,
	                isEntityNameVisible: isEntityNameVisible,
	                getConstantValue: function (node) {
	                    node = ts.getParseTreeNode(node, canHaveConstantValue);
	                    return node ? getConstantValue(node) : undefined;
	                },
	                collectLinkedAliases: collectLinkedAliases,
	                getReferencedValueDeclaration: getReferencedValueDeclaration,
	                getTypeReferenceSerializationKind: getTypeReferenceSerializationKind,
	                isOptionalParameter: isOptionalParameter,
	                moduleExportsSomeValue: moduleExportsSomeValue,
	                isArgumentsLocalBinding: isArgumentsLocalBinding,
	                getExternalModuleFileFromDeclaration: getExternalModuleFileFromDeclaration,
	                getTypeReferenceDirectivesForEntityName: getTypeReferenceDirectivesForEntityName,
	                getTypeReferenceDirectivesForSymbol: getTypeReferenceDirectivesForSymbol,
	                isLiteralConstDeclaration: isLiteralConstDeclaration,
	                isLateBound: function (node) {
	                    node = ts.getParseTreeNode(node, ts.isDeclaration);
	                    var symbol = node && getSymbolOfNode(node);
	                    return !!(symbol && ts.getCheckFlags(symbol) & 1024 /* Late */);
	                },
	                getJsxFactoryEntity: function (location) { return location ? (getJsxNamespace(location), (ts.getSourceFileOfNode(location).localJsxFactory || _jsxFactoryEntity)) : _jsxFactoryEntity; },
	                getAllAccessorDeclarations: function (accessor) {
	                    accessor = ts.getParseTreeNode(accessor, ts.isGetOrSetAccessorDeclaration);
	                    var otherKind = accessor.kind === 156 /* SetAccessor */ ? 155 /* GetAccessor */ : 156 /* SetAccessor */;
	                    var otherAccessor = ts.getDeclarationOfKind(getSymbolOfNode(accessor), otherKind);
	                    var firstAccessor = otherAccessor && (otherAccessor.pos < accessor.pos) ? otherAccessor : accessor;
	                    var secondAccessor = otherAccessor && (otherAccessor.pos < accessor.pos) ? accessor : otherAccessor;
	                    var setAccessor = accessor.kind === 156 /* SetAccessor */ ? accessor : otherAccessor;
	                    var getAccessor = accessor.kind === 155 /* GetAccessor */ ? accessor : otherAccessor;
	                    return {
	                        firstAccessor: firstAccessor,
	                        secondAccessor: secondAccessor,
	                        setAccessor: setAccessor,
	                        getAccessor: getAccessor
	                    };
	                }
	            };
	            function isInHeritageClause(node) {
	                return node.parent && node.parent.kind === 206 /* ExpressionWithTypeArguments */ && node.parent.parent && node.parent.parent.kind === 267 /* HeritageClause */;
	            }
	            // defined here to avoid outer scope pollution
	            function getTypeReferenceDirectivesForEntityName(node) {
	                // program does not have any files with type reference directives - bail out
	                if (!fileToDirective) {
	                    return undefined;
	                }
	                // property access can only be used as values, or types when within an expression with type arguments inside a heritage clause
	                // qualified names can only be used as types\namespaces
	                // identifiers are treated as values only if they appear in type queries
	                var meaning = 67901928 /* Type */ | 1920 /* Namespace */;
	                if ((node.kind === 71 /* Identifier */ && isInTypeQuery(node)) || (node.kind === 184 /* PropertyAccessExpression */ && !isInHeritageClause(node))) {
	                    meaning = 67216319 /* Value */ | 1048576 /* ExportValue */;
	                }
	                var symbol = resolveEntityName(node, meaning, /*ignoreErrors*/ true);
	                return symbol && symbol !== unknownSymbol ? getTypeReferenceDirectivesForSymbol(symbol, meaning) : undefined;
	            }
	            // defined here to avoid outer scope pollution
	            function getTypeReferenceDirectivesForSymbol(symbol, meaning) {
	                // program does not have any files with type reference directives - bail out
	                if (!fileToDirective) {
	                    return undefined;
	                }
	                if (!isSymbolFromTypeDeclarationFile(symbol)) {
	                    return undefined;
	                }
	                // check what declarations in the symbol can contribute to the target meaning
	                var typeReferenceDirectives;
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    // check meaning of the local symbol to see if declaration needs to be analyzed further
	                    if (decl.symbol && decl.symbol.flags & meaning) {
	                        var file_5 = ts.getSourceFileOfNode(decl);
	                        var typeReferenceDirective = fileToDirective.get(file_5.path);
	                        if (typeReferenceDirective) {
	                            (typeReferenceDirectives || (typeReferenceDirectives = [])).push(typeReferenceDirective);
	                        }
	                        else {
	                            // found at least one entry that does not originate from type reference directive
	                            return undefined;
	                        }
	                    }
	                }
	                return typeReferenceDirectives;
	            }
	            function isSymbolFromTypeDeclarationFile(symbol) {
	                // bail out if symbol does not have associated declarations (i.e. this is transient symbol created for property in binding pattern)
	                if (!symbol.declarations) {
	                    return false;
	                }
	                // walk the parent chain for symbols to make sure that top level parent symbol is in the global scope
	                // external modules cannot define or contribute to type declaration files
	                var current = symbol;
	                while (true) {
	                    var parent = getParentOfSymbol(current);
	                    if (parent) {
	                        current = parent;
	                    }
	                    else {
	                        break;
	                    }
	                }
	                if (current.valueDeclaration && current.valueDeclaration.kind === 273 /* SourceFile */ && current.flags & 512 /* ValueModule */) {
	                    return false;
	                }
	                // check that at least one declaration of top level symbol originates from type declaration file
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var file_6 = ts.getSourceFileOfNode(decl);
	                    if (fileToDirective.has(file_6.path)) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        }
	        function getExternalModuleFileFromDeclaration(declaration) {
	            var specifier = declaration.kind === 238 /* ModuleDeclaration */ ? ts.tryCast(declaration.name, ts.isStringLiteral) : ts.getExternalModuleName(declaration);
	            var moduleSymbol = resolveExternalModuleNameWorker(specifier, specifier, /*moduleNotFoundError*/ undefined);
	            if (!moduleSymbol) {
	                return undefined;
	            }
	            return ts.getDeclarationOfKind(moduleSymbol, 273 /* SourceFile */);
	        }
	        function initializeTypeChecker() {
	            // Bind all source files and propagate errors
	            for (var _i = 0, _a = host.getSourceFiles(); _i < _a.length; _i++) {
	                var file_7 = _a[_i];
	                ts.bindSourceFile(file_7, compilerOptions);
	            }
	            // Initialize global symbol table
	            var augmentations;
	            for (var _b = 0, _c = host.getSourceFiles(); _b < _c.length; _b++) {
	                var file_8 = _c[_b];
	                if (!ts.isExternalOrCommonJsModule(file_8)) {
	                    mergeSymbolTable(globals, file_8.locals);
	                }
	                if (file_8.patternAmbientModules && file_8.patternAmbientModules.length) {
	                    patternAmbientModules = ts.concatenate(patternAmbientModules, file_8.patternAmbientModules);
	                }
	                if (file_8.moduleAugmentations.length) {
	                    (augmentations || (augmentations = [])).push(file_8.moduleAugmentations);
	                }
	                if (file_8.symbol && file_8.symbol.globalExports) {
	                    // Merge in UMD exports with first-in-wins semantics (see #9771)
	                    var source = file_8.symbol.globalExports;
	                    source.forEach(function (sourceSymbol, id) {
	                        if (!globals.has(id)) {
	                            globals.set(id, sourceSymbol);
	                        }
	                    });
	                }
	            }
	            // We do global augmentations seperately from module augmentations (and before creating global types) because they
	            //  1. Affect global types. We won't have the correct global types until global augmentations are merged. Also,
	            //  2. Module augmentation instantiation requires creating the type of a module, which, in turn, can require
	            //       checking for an export or property on the module (if export=) which, in turn, can fall back to the
	            //       apparent type of the module - either globalObjectType or globalFunctionType - which wouldn't exist if we
	            //       did module augmentations prior to finalizing the global types.
	            if (augmentations) {
	                // merge _global_ module augmentations.
	                // this needs to be done after global symbol table is initialized to make sure that all ambient modules are indexed
	                for (var _d = 0, augmentations_1 = augmentations; _d < augmentations_1.length; _d++) {
	                    var list = augmentations_1[_d];
	                    for (var _e = 0, list_1 = list; _e < list_1.length; _e++) {
	                        var augmentation = list_1[_e];
	                        if (!ts.isGlobalScopeAugmentation(augmentation.parent))
	                            continue;
	                        mergeModuleAugmentation(augmentation);
	                    }
	                }
	            }
	            // Setup global builtins
	            addToSymbolTable(globals, builtinGlobals, ts.Diagnostics.Declaration_name_conflicts_with_built_in_global_identifier_0);
	            getSymbolLinks(undefinedSymbol).type = undefinedWideningType;
	            getSymbolLinks(argumentsSymbol).type = getGlobalType("IArguments", /*arity*/ 0, /*reportErrors*/ true);
	            getSymbolLinks(unknownSymbol).type = unknownType;
	            // Initialize special types
	            globalArrayType = getGlobalType("Array", /*arity*/ 1, /*reportErrors*/ true);
	            globalObjectType = getGlobalType("Object", /*arity*/ 0, /*reportErrors*/ true);
	            globalFunctionType = getGlobalType("Function", /*arity*/ 0, /*reportErrors*/ true);
	            globalStringType = getGlobalType("String", /*arity*/ 0, /*reportErrors*/ true);
	            globalNumberType = getGlobalType("Number", /*arity*/ 0, /*reportErrors*/ true);
	            globalBooleanType = getGlobalType("Boolean", /*arity*/ 0, /*reportErrors*/ true);
	            globalRegExpType = getGlobalType("RegExp", /*arity*/ 0, /*reportErrors*/ true);
	            anyArrayType = createArrayType(anyType);
	            autoArrayType = createArrayType(autoType);
	            if (autoArrayType === emptyObjectType) {
	                // autoArrayType is used as a marker, so even if global Array type is not defined, it needs to be a unique type
	                autoArrayType = createAnonymousType(undefined, emptySymbols, ts.emptyArray, ts.emptyArray, undefined, undefined);
	            }
	            globalReadonlyArrayType = getGlobalTypeOrUndefined("ReadonlyArray", /*arity*/ 1);
	            anyReadonlyArrayType = globalReadonlyArrayType ? createTypeFromGenericGlobalType(globalReadonlyArrayType, [anyType]) : anyArrayType;
	            globalThisType = getGlobalTypeOrUndefined("ThisType", /*arity*/ 1);
	            if (augmentations) {
	                // merge _nonglobal_ module augmentations.
	                // this needs to be done after global symbol table is initialized to make sure that all ambient modules are indexed
	                for (var _f = 0, augmentations_2 = augmentations; _f < augmentations_2.length; _f++) {
	                    var list = augmentations_2[_f];
	                    for (var _g = 0, list_2 = list; _g < list_2.length; _g++) {
	                        var augmentation = list_2[_g];
	                        if (ts.isGlobalScopeAugmentation(augmentation.parent))
	                            continue;
	                        mergeModuleAugmentation(augmentation);
	                    }
	                }
	            }
	        }
	        function checkExternalEmitHelpers(location, helpers) {
	            if ((requestedExternalEmitHelpers & helpers) !== helpers && compilerOptions.importHelpers) {
	                var sourceFile = ts.getSourceFileOfNode(location);
	                if (ts.isEffectiveExternalModule(sourceFile, compilerOptions) && !(location.flags & 4194304 /* Ambient */)) {
	                    var helpersModule = resolveHelpersModule(sourceFile, location);
	                    if (helpersModule !== unknownSymbol) {
	                        var uncheckedHelpers = helpers & ~requestedExternalEmitHelpers;
	                        for (var helper = 1 /* FirstEmitHelper */; helper <= 65536 /* LastEmitHelper */; helper <<= 1) {
	                            if (uncheckedHelpers & helper) {
	                                var name = getHelperName(helper);
	                                var symbol = getSymbol(helpersModule.exports, ts.escapeLeadingUnderscores(name), 67216319 /* Value */);
	                                if (!symbol) {
	                                    error(location, ts.Diagnostics.This_syntax_requires_an_imported_helper_named_1_but_module_0_has_no_exported_member_1, ts.externalHelpersModuleNameText, name);
	                                }
	                            }
	                        }
	                    }
	                    requestedExternalEmitHelpers |= helpers;
	                }
	            }
	        }
	        function getHelperName(helper) {
	            switch (helper) {
	                case 1 /* Extends */: return "__extends";
	                case 2 /* Assign */: return "__assign";
	                case 4 /* Rest */: return "__rest";
	                case 8 /* Decorate */: return "__decorate";
	                case 16 /* Metadata */: return "__metadata";
	                case 32 /* Param */: return "__param";
	                case 64 /* Awaiter */: return "__awaiter";
	                case 128 /* Generator */: return "__generator";
	                case 256 /* Values */: return "__values";
	                case 512 /* Read */: return "__read";
	                case 1024 /* Spread */: return "__spread";
	                case 2048 /* Await */: return "__await";
	                case 4096 /* AsyncGenerator */: return "__asyncGenerator";
	                case 8192 /* AsyncDelegator */: return "__asyncDelegator";
	                case 16384 /* AsyncValues */: return "__asyncValues";
	                case 32768 /* ExportStar */: return "__exportStar";
	                case 65536 /* MakeTemplateObject */: return "__makeTemplateObject";
	                default: ts.Debug.fail("Unrecognized helper");
	            }
	        }
	        function resolveHelpersModule(node, errorNode) {
	            if (!externalHelpersModule) {
	                externalHelpersModule = resolveExternalModule(node, ts.externalHelpersModuleNameText, ts.Diagnostics.This_syntax_requires_an_imported_helper_but_module_0_cannot_be_found, errorNode) || unknownSymbol;
	            }
	            return externalHelpersModule;
	        }
	        // GRAMMAR CHECKING
	        function checkGrammarDecoratorsAndModifiers(node) {
	            return checkGrammarDecorators(node) || checkGrammarModifiers(node);
	        }
	        function checkGrammarDecorators(node) {
	            if (!node.decorators) {
	                return false;
	            }
	            if (!ts.nodeCanBeDecorated(node, node.parent, node.parent.parent)) {
	                if (node.kind === 153 /* MethodDeclaration */ && !ts.nodeIsPresent(node.body)) {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.A_decorator_can_only_decorate_a_method_implementation_not_an_overload);
	                }
	                else {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.Decorators_are_not_valid_here);
	                }
	            }
	            else if (node.kind === 155 /* GetAccessor */ || node.kind === 156 /* SetAccessor */) {
	                var accessors = ts.getAllAccessorDeclarations(node.parent.members, node);
	                if (accessors.firstAccessor.decorators && node === accessors.secondAccessor) {
	                    return grammarErrorOnFirstToken(node, ts.Diagnostics.Decorators_cannot_be_applied_to_multiple_get_Slashset_accessors_of_the_same_name);
	                }
	            }
	            return false;
	        }
	        function checkGrammarModifiers(node) {
	            var quickResult = reportObviousModifierErrors(node);
	            if (quickResult !== undefined) {
	                return quickResult;
	            }
	            var lastStatic, lastDeclare, lastAsync, lastReadonly;
	            var flags = 0 /* None */;
	            for (var _i = 0, _a = node.modifiers; _i < _a.length; _i++) {
	                var modifier = _a[_i];
	                if (modifier.kind !== 132 /* ReadonlyKeyword */) {
	                    if (node.kind === 150 /* PropertySignature */ || node.kind === 152 /* MethodSignature */) {
	                        return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_type_member, ts.tokenToString(modifier.kind));
	                    }
	                    if (node.kind === 159 /* IndexSignature */) {
	                        return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_an_index_signature, ts.tokenToString(modifier.kind));
	                    }
	                }
	                switch (modifier.kind) {
	                    case 76 /* ConstKeyword */:
	                        if (node.kind !== 237 /* EnumDeclaration */ && node.parent.kind === 234 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.A_class_member_cannot_have_the_0_keyword, ts.tokenToString(76 /* ConstKeyword */));
	                        }
	                        break;
	                    case 114 /* PublicKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                    case 112 /* PrivateKeyword */:
	                        var text = visibilityToString(ts.modifierToFlag(modifier.kind));
	                        if (flags & 28 /* AccessibilityModifier */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.Accessibility_modifier_already_seen);
	                        }
	                        else if (flags & 32 /* Static */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "static");
	                        }
	                        else if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "readonly");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "async");
	                        }
	                        else if (node.parent.kind === 239 /* ModuleBlock */ || node.parent.kind === 273 /* SourceFile */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, text);
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            if (modifier.kind === 112 /* PrivateKeyword */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, text, "abstract");
	                            }
	                            else {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, text, "abstract");
	                            }
	                        }
	                        flags |= ts.modifierToFlag(modifier.kind);
	                        break;
	                    case 115 /* StaticKeyword */:
	                        if (flags & 32 /* Static */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "static");
	                        }
	                        else if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "static", "readonly");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "static", "async");
	                        }
	                        else if (node.parent.kind === 239 /* ModuleBlock */ || node.parent.kind === 273 /* SourceFile */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_module_or_namespace_element, "static");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "static");
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
	                        }
	                        flags |= 32 /* Static */;
	                        lastStatic = modifier;
	                        break;
	                    case 132 /* ReadonlyKeyword */:
	                        if (flags & 64 /* Readonly */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "readonly");
	                        }
	                        else if (node.kind !== 151 /* PropertyDeclaration */ && node.kind !== 150 /* PropertySignature */ && node.kind !== 159 /* IndexSignature */ && node.kind !== 148 /* Parameter */) {
	                            // If node.kind === SyntaxKind.Parameter, checkParameter report an error if it's not a parameter property.
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.readonly_modifier_can_only_appear_on_a_property_declaration_or_index_signature);
	                        }
	                        flags |= 64 /* Readonly */;
	                        lastReadonly = modifier;
	                        break;
	                    case 84 /* ExportKeyword */:
	                        if (flags & 1 /* Export */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "export");
	                        }
	                        else if (flags & 2 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "declare");
	                        }
	                        else if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "abstract");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_must_precede_1_modifier, "export", "async");
	                        }
	                        else if (node.parent.kind === 234 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_class_element, "export");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "export");
	                        }
	                        flags |= 1 /* Export */;
	                        break;
	                    case 79 /* DefaultKeyword */:
	                        var container = node.parent.kind === 273 /* SourceFile */ ? node.parent : node.parent.parent;
	                        if (container.kind === 238 /* ModuleDeclaration */ && !ts.isAmbientModule(container)) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.A_default_export_can_only_be_used_in_an_ECMAScript_style_module);
	                        }
	                        flags |= 512 /* Default */;
	                        break;
	                    case 124 /* DeclareKeyword */:
	                        if (flags & 2 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "declare");
	                        }
	                        else if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
	                        }
	                        else if (node.parent.kind === 234 /* ClassDeclaration */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_class_element, "declare");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "declare");
	                        }
	                        else if ((node.parent.flags & 4194304 /* Ambient */) && node.parent.kind === 239 /* ModuleBlock */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics.A_declare_modifier_cannot_be_used_in_an_already_ambient_context);
	                        }
	                        flags |= 2 /* Ambient */;
	                        lastDeclare = modifier;
	                        break;
	                    case 117 /* AbstractKeyword */:
	                        if (flags & 128 /* Abstract */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "abstract");
	                        }
	                        if (node.kind !== 234 /* ClassDeclaration */) {
	                            if (node.kind !== 153 /* MethodDeclaration */ &&
	                                node.kind !== 151 /* PropertyDeclaration */ &&
	                                node.kind !== 155 /* GetAccessor */ &&
	                                node.kind !== 156 /* SetAccessor */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics.abstract_modifier_can_only_appear_on_a_class_method_or_property_declaration);
	                            }
	                            if (!(node.parent.kind === 234 /* ClassDeclaration */ && ts.hasModifier(node.parent, 128 /* Abstract */))) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics.Abstract_methods_can_only_appear_within_an_abstract_class);
	                            }
	                            if (flags & 32 /* Static */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "static", "abstract");
	                            }
	                            if (flags & 8 /* Private */) {
	                                return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_with_1_modifier, "private", "abstract");
	                            }
	                        }
	                        flags |= 128 /* Abstract */;
	                        break;
	                    case 120 /* AsyncKeyword */:
	                        if (flags & 256 /* Async */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_already_seen, "async");
	                        }
	                        else if (flags & 2 /* Ambient */ || node.parent.flags & 4194304 /* Ambient */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_be_used_in_an_ambient_context, "async");
	                        }
	                        else if (node.kind === 148 /* Parameter */) {
	                            return grammarErrorOnNode(modifier, ts.Diagnostics._0_modifier_cannot_appear_on_a_parameter, "async");
	                        }
	                        flags |= 256 /* Async */;
	                        lastAsync = modifier;
	                        break;
	                }
	            }
	            if (node.kind === 154 /* Constructor */) {
	                if (flags & 32 /* Static */) {
	                    return grammarErrorOnNode(lastStatic, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "static");
	                }
	                if (flags & 128 /* Abstract */) {
	                    return grammarErrorOnNode(lastStatic, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "abstract");
	                }
	                else if (flags & 256 /* Async */) {
	                    return grammarErrorOnNode(lastAsync, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "async");
	                }
	                else if (flags & 64 /* Readonly */) {
	                    return grammarErrorOnNode(lastReadonly, ts.Diagnostics._0_modifier_cannot_appear_on_a_constructor_declaration, "readonly");
	                }
	                return;
	            }
	            else if ((node.kind === 243 /* ImportDeclaration */ || node.kind === 242 /* ImportEqualsDeclaration */) && flags & 2 /* Ambient */) {
	                return grammarErrorOnNode(lastDeclare, ts.Diagnostics.A_0_modifier_cannot_be_used_with_an_import_declaration, "declare");
	            }
	            else if (node.kind === 148 /* Parameter */ && (flags & 92 /* ParameterPropertyModifier */) && ts.isBindingPattern(node.name)) {
	                return grammarErrorOnNode(node, ts.Diagnostics.A_parameter_property_may_not_be_declared_using_a_binding_pattern);
	            }
	            else if (node.kind === 148 /* Parameter */ && (flags & 92 /* ParameterPropertyModifier */) && node.dotDotDotToken) {
	                return grammarErrorOnNode(node, ts.Diagnostics.A_parameter_property_cannot_be_declared_using_a_rest_parameter);
	            }
	            if (flags & 256 /* Async */) {
	                return checkGrammarAsyncModifier(node, lastAsync);
	            }
	        }
	        /**
	         * true | false: Early return this value from checkGrammarModifiers.
	         * undefined: Need to do full checking on the modifiers.
	         */
	        function reportObviousModifierErrors(node) {
	            return !node.modifiers
	                ? false
	                : shouldReportBadModifier(node)
	                    ? grammarErrorOnFirstToken(node, ts.Diagnostics.Modifiers_cannot_appear_here)
	                    : undefined;
	        }
	        function shouldReportBadModifier(node) {
	            switch (node.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 154 /* Constructor */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 159 /* IndexSignature */:
	                case 238 /* ModuleDeclaration */:
	                case 243 /* ImportDeclaration */:
	                case 242 /* ImportEqualsDeclaration */:
	                case 249 /* ExportDeclaration */:
	                case 248 /* ExportAssignment */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                case 148 /* Parameter */:
	                    return false;
	                default:
	                    if (node.parent.kind === 239 /* ModuleBlock */ || node.parent.kind === 273 /* SourceFile */) {
	                        return false;
	                    }
	                    switch (node.kind) {
	                        case 233 /* FunctionDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 120 /* AsyncKeyword */);
	                        case 234 /* ClassDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 117 /* AbstractKeyword */);
	                        case 235 /* InterfaceDeclaration */:
	                        case 213 /* VariableStatement */:
	                        case 236 /* TypeAliasDeclaration */:
	                            return true;
	                        case 237 /* EnumDeclaration */:
	                            return nodeHasAnyModifiersExcept(node, 76 /* ConstKeyword */);
	                        default:
	                            ts.Debug.fail();
	                            return false;
	                    }
	            }
	        }
	        function nodeHasAnyModifiersExcept(node, allowedModifier) {
	            return node.modifiers.length > 1 || node.modifiers[0].kind !== allowedModifier;
	        }
	        function checkGrammarAsyncModifier(node, asyncModifier) {
	            switch (node.kind) {
	                case 153 /* MethodDeclaration */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return false;
	            }
	            return grammarErrorOnNode(asyncModifier, ts.Diagnostics._0_modifier_cannot_be_used_here, "async");
	        }
	        function checkGrammarForDisallowedTrailingComma(list, diag) {
	            if (diag === void 0) { diag = ts.Diagnostics.Trailing_comma_not_allowed; }
	            if (list && list.hasTrailingComma) {
	                return grammarErrorAtPos(list[0], list.end - ",".length, ",".length, diag);
	            }
	        }
	        function checkGrammarTypeParameterList(typeParameters, file) {
	            if (typeParameters && typeParameters.length === 0) {
	                var start = typeParameters.pos - "<".length;
	                var end = ts.skipTrivia(file.text, typeParameters.end) + ">".length;
	                return grammarErrorAtPos(file, start, end - start, ts.Diagnostics.Type_parameter_list_cannot_be_empty);
	            }
	        }
	        function checkGrammarParameterList(parameters) {
	            var seenOptionalParameter = false;
	            var parameterCount = parameters.length;
	            for (var i = 0; i < parameterCount; i++) {
	                var parameter = parameters[i];
	                if (parameter.dotDotDotToken) {
	                    if (i !== (parameterCount - 1)) {
	                        return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.A_rest_parameter_must_be_last_in_a_parameter_list);
	                    }
	                    if (!(parameter.flags & 4194304 /* Ambient */)) { // Allow `...foo,` in ambient declarations; see GH#23070
	                        checkGrammarForDisallowedTrailingComma(parameters, ts.Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
	                    }
	                    if (ts.isBindingPattern(parameter.name)) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
	                    }
	                    if (parameter.questionToken) {
	                        return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.A_rest_parameter_cannot_be_optional);
	                    }
	                    if (parameter.initializer) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_rest_parameter_cannot_have_an_initializer);
	                    }
	                }
	                else if (parameter.questionToken) {
	                    seenOptionalParameter = true;
	                    if (parameter.initializer) {
	                        return grammarErrorOnNode(parameter.name, ts.Diagnostics.Parameter_cannot_have_question_mark_and_initializer);
	                    }
	                }
	                else if (seenOptionalParameter && !parameter.initializer) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.A_required_parameter_cannot_follow_an_optional_parameter);
	                }
	            }
	        }
	        function checkGrammarFunctionLikeDeclaration(node) {
	            // Prevent cascading error by short-circuit
	            var file = ts.getSourceFileOfNode(node);
	            return checkGrammarDecoratorsAndModifiers(node) || checkGrammarTypeParameterList(node.typeParameters, file) ||
	                checkGrammarParameterList(node.parameters) || checkGrammarArrowFunction(node, file);
	        }
	        function checkGrammarClassLikeDeclaration(node) {
	            var file = ts.getSourceFileOfNode(node);
	            return checkGrammarClassDeclarationHeritageClauses(node) || checkGrammarTypeParameterList(node.typeParameters, file);
	        }
	        function checkGrammarArrowFunction(node, file) {
	            if (!ts.isArrowFunction(node)) {
	                return false;
	            }
	            var equalsGreaterThanToken = node.equalsGreaterThanToken;
	            var startLine = ts.getLineAndCharacterOfPosition(file, equalsGreaterThanToken.pos).line;
	            var endLine = ts.getLineAndCharacterOfPosition(file, equalsGreaterThanToken.end).line;
	            return startLine !== endLine && grammarErrorOnNode(equalsGreaterThanToken, ts.Diagnostics.Line_terminator_not_permitted_before_arrow);
	        }
	        function checkGrammarIndexSignatureParameters(node) {
	            var parameter = node.parameters[0];
	            if (node.parameters.length !== 1) {
	                if (parameter) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_must_have_exactly_one_parameter);
	                }
	                else {
	                    return grammarErrorOnNode(node, ts.Diagnostics.An_index_signature_must_have_exactly_one_parameter);
	                }
	            }
	            if (parameter.dotDotDotToken) {
	                return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.An_index_signature_cannot_have_a_rest_parameter);
	            }
	            if (ts.hasModifiers(parameter)) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_cannot_have_an_accessibility_modifier);
	            }
	            if (parameter.questionToken) {
	                return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.An_index_signature_parameter_cannot_have_a_question_mark);
	            }
	            if (parameter.initializer) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_cannot_have_an_initializer);
	            }
	            if (!parameter.type) {
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_must_have_a_type_annotation);
	            }
	            if (parameter.type.kind !== 137 /* StringKeyword */ && parameter.type.kind !== 134 /* NumberKeyword */) {
	                var type = getTypeFromTypeNode(parameter.type);
	                if (type.flags & 2 /* String */ || type.flags & 4 /* Number */) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_cannot_be_a_type_alias_Consider_writing_0_Colon_1_Colon_2_instead, ts.getTextOfNode(parameter.name), typeToString(type), typeToString(getTypeFromTypeNode(node.type)));
	                }
	                if (type.flags & 131072 /* Union */ && allTypesAssignableToKind(type, 32 /* StringLiteral */, /*strict*/ true)) {
	                    return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_cannot_be_a_union_type_Consider_using_a_mapped_object_type_instead);
	                }
	                return grammarErrorOnNode(parameter.name, ts.Diagnostics.An_index_signature_parameter_type_must_be_string_or_number);
	            }
	            if (!node.type) {
	                return grammarErrorOnNode(node, ts.Diagnostics.An_index_signature_must_have_a_type_annotation);
	            }
	        }
	        function checkGrammarIndexSignature(node) {
	            // Prevent cascading error by short-circuit
	            return checkGrammarDecoratorsAndModifiers(node) || checkGrammarIndexSignatureParameters(node);
	        }
	        function checkGrammarForAtLeastOneTypeArgument(node, typeArguments) {
	            if (typeArguments && typeArguments.length === 0) {
	                var sourceFile = ts.getSourceFileOfNode(node);
	                var start = typeArguments.pos - "<".length;
	                var end = ts.skipTrivia(sourceFile.text, typeArguments.end) + ">".length;
	                return grammarErrorAtPos(sourceFile, start, end - start, ts.Diagnostics.Type_argument_list_cannot_be_empty);
	            }
	        }
	        function checkGrammarTypeArguments(node, typeArguments) {
	            return checkGrammarForDisallowedTrailingComma(typeArguments) ||
	                checkGrammarForAtLeastOneTypeArgument(node, typeArguments);
	        }
	        function checkGrammarForOmittedArgument(args) {
	            if (args) {
	                for (var _i = 0, args_5 = args; _i < args_5.length; _i++) {
	                    var arg = args_5[_i];
	                    if (arg.kind === 205 /* OmittedExpression */) {
	                        return grammarErrorAtPos(arg, arg.pos, 0, ts.Diagnostics.Argument_expression_expected);
	                    }
	                }
	            }
	        }
	        function checkGrammarArguments(args) {
	            return checkGrammarForOmittedArgument(args);
	        }
	        function checkGrammarHeritageClause(node) {
	            var types = node.types;
	            if (checkGrammarForDisallowedTrailingComma(types)) {
	                return true;
	            }
	            if (types && types.length === 0) {
	                var listType = ts.tokenToString(node.token);
	                return grammarErrorAtPos(node, types.pos, 0, ts.Diagnostics._0_list_cannot_be_empty, listType);
	            }
	            return ts.forEach(types, checkGrammarExpressionWithTypeArguments);
	        }
	        function checkGrammarExpressionWithTypeArguments(node) {
	            return checkGrammarTypeArguments(node, node.typeArguments);
	        }
	        function checkGrammarClassDeclarationHeritageClauses(node) {
	            var seenExtendsClause = false;
	            var seenImplementsClause = false;
	            if (!checkGrammarDecoratorsAndModifiers(node) && node.heritageClauses) {
	                for (var _i = 0, _a = node.heritageClauses; _i < _a.length; _i++) {
	                    var heritageClause = _a[_i];
	                    if (heritageClause.token === 85 /* ExtendsKeyword */) {
	                        if (seenExtendsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_already_seen);
	                        }
	                        if (seenImplementsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_must_precede_implements_clause);
	                        }
	                        if (heritageClause.types.length > 1) {
	                            return grammarErrorOnFirstToken(heritageClause.types[1], ts.Diagnostics.Classes_can_only_extend_a_single_class);
	                        }
	                        seenExtendsClause = true;
	                    }
	                    else {
	                        ts.Debug.assert(heritageClause.token === 108 /* ImplementsKeyword */);
	                        if (seenImplementsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.implements_clause_already_seen);
	                        }
	                        seenImplementsClause = true;
	                    }
	                    // Grammar checking heritageClause inside class declaration
	                    checkGrammarHeritageClause(heritageClause);
	                }
	            }
	        }
	        function checkGrammarInterfaceDeclaration(node) {
	            var seenExtendsClause = false;
	            if (node.heritageClauses) {
	                for (var _i = 0, _a = node.heritageClauses; _i < _a.length; _i++) {
	                    var heritageClause = _a[_i];
	                    if (heritageClause.token === 85 /* ExtendsKeyword */) {
	                        if (seenExtendsClause) {
	                            return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.extends_clause_already_seen);
	                        }
	                        seenExtendsClause = true;
	                    }
	                    else {
	                        ts.Debug.assert(heritageClause.token === 108 /* ImplementsKeyword */);
	                        return grammarErrorOnFirstToken(heritageClause, ts.Diagnostics.Interface_declaration_cannot_have_implements_clause);
	                    }
	                    // Grammar checking heritageClause inside class declaration
	                    checkGrammarHeritageClause(heritageClause);
	                }
	            }
	            return false;
	        }
	        function checkGrammarComputedPropertyName(node) {
	            // If node is not a computedPropertyName, just skip the grammar checking
	            if (node.kind !== 146 /* ComputedPropertyName */) {
	                return false;
	            }
	            var computedPropertyName = node;
	            if (computedPropertyName.expression.kind === 199 /* BinaryExpression */ && computedPropertyName.expression.operatorToken.kind === 26 /* CommaToken */) {
	                return grammarErrorOnNode(computedPropertyName.expression, ts.Diagnostics.A_comma_expression_is_not_allowed_in_a_computed_property_name);
	            }
	        }
	        function checkGrammarForGenerator(node) {
	            if (node.asteriskToken) {
	                ts.Debug.assert(node.kind === 233 /* FunctionDeclaration */ ||
	                    node.kind === 191 /* FunctionExpression */ ||
	                    node.kind === 153 /* MethodDeclaration */);
	                if (node.flags & 4194304 /* Ambient */) {
	                    return grammarErrorOnNode(node.asteriskToken, ts.Diagnostics.Generators_are_not_allowed_in_an_ambient_context);
	                }
	                if (!node.body) {
	                    return grammarErrorOnNode(node.asteriskToken, ts.Diagnostics.An_overload_signature_cannot_be_declared_as_a_generator);
	                }
	            }
	        }
	        function checkGrammarForInvalidQuestionMark(questionToken, message) {
	            if (questionToken) {
	                return grammarErrorOnNode(questionToken, message);
	            }
	        }
	        function checkGrammarObjectLiteralExpression(node, inDestructuring) {
	            var Flags;
	            (function (Flags) {
	                Flags[Flags["Property"] = 1] = "Property";
	                Flags[Flags["GetAccessor"] = 2] = "GetAccessor";
	                Flags[Flags["SetAccessor"] = 4] = "SetAccessor";
	                Flags[Flags["GetOrSetAccessor"] = 6] = "GetOrSetAccessor";
	            })(Flags || (Flags = {}));
	            var seen = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var prop = _a[_i];
	                if (prop.kind === 271 /* SpreadAssignment */) {
	                    continue;
	                }
	                var name = prop.name;
	                if (name.kind === 146 /* ComputedPropertyName */) {
	                    // If the name is not a ComputedPropertyName, the grammar checking will skip it
	                    checkGrammarComputedPropertyName(name);
	                }
	                if (prop.kind === 270 /* ShorthandPropertyAssignment */ && !inDestructuring && prop.objectAssignmentInitializer) {
	                    // having objectAssignmentInitializer is only valid in ObjectAssignmentPattern
	                    // outside of destructuring it is a syntax error
	                    return grammarErrorOnNode(prop.equalsToken, ts.Diagnostics.can_only_be_used_in_an_object_literal_property_inside_a_destructuring_assignment);
	                }
	                // Modifiers are never allowed on properties except for 'async' on a method declaration
	                if (prop.modifiers) {
	                    for (var _b = 0, _c = prop.modifiers; _b < _c.length; _b++) {
	                        var mod = _c[_b];
	                        if (mod.kind !== 120 /* AsyncKeyword */ || prop.kind !== 153 /* MethodDeclaration */) {
	                            grammarErrorOnNode(mod, ts.Diagnostics._0_modifier_cannot_be_used_here, ts.getTextOfNode(mod));
	                        }
	                    }
	                }
	                // ECMA-262 11.1.5 Object Initializer
	                // If previous is not undefined then throw a SyntaxError exception if any of the following conditions are true
	                // a.This production is contained in strict code and IsDataDescriptor(previous) is true and
	                // IsDataDescriptor(propId.descriptor) is true.
	                //    b.IsDataDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true.
	                //    c.IsAccessorDescriptor(previous) is true and IsDataDescriptor(propId.descriptor) is true.
	                //    d.IsAccessorDescriptor(previous) is true and IsAccessorDescriptor(propId.descriptor) is true
	                // and either both previous and propId.descriptor have[[Get]] fields or both previous and propId.descriptor have[[Set]] fields
	                var currentKind = void 0;
	                switch (prop.kind) {
	                    case 269 /* PropertyAssignment */:
	                    case 270 /* ShorthandPropertyAssignment */:
	                        // Grammar checking for computedPropertyName and shorthandPropertyAssignment
	                        checkGrammarForInvalidQuestionMark(prop.questionToken, ts.Diagnostics.An_object_member_cannot_be_declared_optional);
	                        if (name.kind === 8 /* NumericLiteral */) {
	                            checkGrammarNumericLiteral(name);
	                        }
	                    // falls through
	                    case 153 /* MethodDeclaration */:
	                        currentKind = 1 /* Property */;
	                        break;
	                    case 155 /* GetAccessor */:
	                        currentKind = 2 /* GetAccessor */;
	                        break;
	                    case 156 /* SetAccessor */:
	                        currentKind = 4 /* SetAccessor */;
	                        break;
	                    default:
	                        ts.Debug.assertNever(prop, "Unexpected syntax kind:" + prop.kind);
	                }
	                var effectiveName = ts.getPropertyNameForPropertyNameNode(name);
	                if (effectiveName === undefined) {
	                    continue;
	                }
	                var existingKind = seen.get(effectiveName);
	                if (!existingKind) {
	                    seen.set(effectiveName, currentKind);
	                }
	                else {
	                    if (currentKind === 1 /* Property */ && existingKind === 1 /* Property */) {
	                        grammarErrorOnNode(name, ts.Diagnostics.Duplicate_identifier_0, ts.getTextOfNode(name));
	                    }
	                    else if ((currentKind & 6 /* GetOrSetAccessor */) && (existingKind & 6 /* GetOrSetAccessor */)) {
	                        if (existingKind !== 6 /* GetOrSetAccessor */ && currentKind !== existingKind) {
	                            seen.set(effectiveName, currentKind | existingKind);
	                        }
	                        else {
	                            return grammarErrorOnNode(name, ts.Diagnostics.An_object_literal_cannot_have_multiple_get_Slashset_accessors_with_the_same_name);
	                        }
	                    }
	                    else {
	                        return grammarErrorOnNode(name, ts.Diagnostics.An_object_literal_cannot_have_property_and_accessor_with_the_same_name);
	                    }
	                }
	            }
	        }
	        function checkGrammarJsxElement(node) {
	            checkGrammarTypeArguments(node, node.typeArguments);
	            var seen = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.attributes.properties; _i < _a.length; _i++) {
	                var attr = _a[_i];
	                if (attr.kind === 263 /* JsxSpreadAttribute */) {
	                    continue;
	                }
	                var name = attr.name, initializer = attr.initializer;
	                if (!seen.get(name.escapedText)) {
	                    seen.set(name.escapedText, true);
	                }
	                else {
	                    return grammarErrorOnNode(name, ts.Diagnostics.JSX_elements_cannot_have_multiple_attributes_with_the_same_name);
	                }
	                if (initializer && initializer.kind === 264 /* JsxExpression */ && !initializer.expression) {
	                    return grammarErrorOnNode(initializer, ts.Diagnostics.JSX_attributes_must_only_be_assigned_a_non_empty_expression);
	                }
	            }
	        }
	        function checkGrammarForInOrForOfStatement(forInOrOfStatement) {
	            if (checkGrammarStatementInAmbientContext(forInOrOfStatement)) {
	                return true;
	            }
	            if (forInOrOfStatement.kind === 221 /* ForOfStatement */ && forInOrOfStatement.awaitModifier) {
	                if ((forInOrOfStatement.flags & 16384 /* AwaitContext */) === 0 /* None */) {
	                    return grammarErrorOnNode(forInOrOfStatement.awaitModifier, ts.Diagnostics.A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator);
	                }
	            }
	            if (forInOrOfStatement.initializer.kind === 232 /* VariableDeclarationList */) {
	                var variableList = forInOrOfStatement.initializer;
	                if (!checkGrammarVariableDeclarationList(variableList)) {
	                    var declarations = variableList.declarations;
	                    // declarations.length can be zero if there is an error in variable declaration in for-of or for-in
	                    // See http://www.ecma-international.org/ecma-262/6.0/#sec-for-in-and-for-of-statements for details
	                    // For example:
	                    //      var let = 10;
	                    //      for (let of [1,2,3]) {} // this is invalid ES6 syntax
	                    //      for (let in [1,2,3]) {} // this is invalid ES6 syntax
	                    // We will then want to skip on grammar checking on variableList declaration
	                    if (!declarations.length) {
	                        return false;
	                    }
	                    if (declarations.length > 1) {
	                        var diagnostic = forInOrOfStatement.kind === 220 /* ForInStatement */
	                            ? ts.Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_in_statement
	                            : ts.Diagnostics.Only_a_single_variable_declaration_is_allowed_in_a_for_of_statement;
	                        return grammarErrorOnFirstToken(variableList.declarations[1], diagnostic);
	                    }
	                    var firstDeclaration = declarations[0];
	                    if (firstDeclaration.initializer) {
	                        var diagnostic = forInOrOfStatement.kind === 220 /* ForInStatement */
	                            ? ts.Diagnostics.The_variable_declaration_of_a_for_in_statement_cannot_have_an_initializer
	                            : ts.Diagnostics.The_variable_declaration_of_a_for_of_statement_cannot_have_an_initializer;
	                        return grammarErrorOnNode(firstDeclaration.name, diagnostic);
	                    }
	                    if (firstDeclaration.type) {
	                        var diagnostic = forInOrOfStatement.kind === 220 /* ForInStatement */
	                            ? ts.Diagnostics.The_left_hand_side_of_a_for_in_statement_cannot_use_a_type_annotation
	                            : ts.Diagnostics.The_left_hand_side_of_a_for_of_statement_cannot_use_a_type_annotation;
	                        return grammarErrorOnNode(firstDeclaration, diagnostic);
	                    }
	                }
	            }
	            return false;
	        }
	        function checkGrammarAccessor(accessor) {
	            var kind = accessor.kind;
	            if (languageVersion < 1 /* ES5 */) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.Accessors_are_only_available_when_targeting_ECMAScript_5_and_higher);
	            }
	            else if (accessor.flags & 4194304 /* Ambient */) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.An_accessor_cannot_be_declared_in_an_ambient_context);
	            }
	            else if (accessor.body === undefined && !ts.hasModifier(accessor, 128 /* Abstract */)) {
	                return grammarErrorAtPos(accessor, accessor.end - 1, ";".length, ts.Diagnostics._0_expected, "{");
	            }
	            else if (accessor.body && ts.hasModifier(accessor, 128 /* Abstract */)) {
	                return grammarErrorOnNode(accessor, ts.Diagnostics.An_abstract_accessor_cannot_have_an_implementation);
	            }
	            else if (accessor.typeParameters) {
	                return grammarErrorOnNode(accessor.name, ts.Diagnostics.An_accessor_cannot_have_type_parameters);
	            }
	            else if (!doesAccessorHaveCorrectParameterCount(accessor)) {
	                return grammarErrorOnNode(accessor.name, kind === 155 /* GetAccessor */ ?
	                    ts.Diagnostics.A_get_accessor_cannot_have_parameters :
	                    ts.Diagnostics.A_set_accessor_must_have_exactly_one_parameter);
	            }
	            else if (kind === 156 /* SetAccessor */) {
	                if (accessor.type) {
	                    return grammarErrorOnNode(accessor.name, ts.Diagnostics.A_set_accessor_cannot_have_a_return_type_annotation);
	                }
	                else {
	                    var parameter = accessor.parameters[0];
	                    if (parameter.dotDotDotToken) {
	                        return grammarErrorOnNode(parameter.dotDotDotToken, ts.Diagnostics.A_set_accessor_cannot_have_rest_parameter);
	                    }
	                    else if (parameter.questionToken) {
	                        return grammarErrorOnNode(parameter.questionToken, ts.Diagnostics.A_set_accessor_cannot_have_an_optional_parameter);
	                    }
	                    else if (parameter.initializer) {
	                        return grammarErrorOnNode(accessor.name, ts.Diagnostics.A_set_accessor_parameter_cannot_have_an_initializer);
	                    }
	                }
	            }
	        }
	        /** Does the accessor have the right number of parameters?
	         * A get accessor has no parameters or a single `this` parameter.
	         * A set accessor has one parameter or a `this` parameter and one more parameter.
	         */
	        function doesAccessorHaveCorrectParameterCount(accessor) {
	            return getAccessorThisParameter(accessor) || accessor.parameters.length === (accessor.kind === 155 /* GetAccessor */ ? 0 : 1);
	        }
	        function getAccessorThisParameter(accessor) {
	            if (accessor.parameters.length === (accessor.kind === 155 /* GetAccessor */ ? 1 : 2)) {
	                return ts.getThisParameter(accessor);
	            }
	        }
	        function checkGrammarTypeOperatorNode(node) {
	            if (node.operator === 141 /* UniqueKeyword */) {
	                if (node.type.kind !== 138 /* SymbolKeyword */) {
	                    return grammarErrorOnNode(node.type, ts.Diagnostics._0_expected, ts.tokenToString(138 /* SymbolKeyword */));
	                }
	                var parent = ts.walkUpParenthesizedTypes(node.parent);
	                switch (parent.kind) {
	                    case 231 /* VariableDeclaration */:
	                        var decl = parent;
	                        if (decl.name.kind !== 71 /* Identifier */) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_may_not_be_used_on_a_variable_declaration_with_a_binding_name);
	                        }
	                        if (!ts.isVariableDeclarationInVariableStatement(decl)) {
	                            return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_are_only_allowed_on_variables_in_a_variable_statement);
	                        }
	                        if (!(decl.parent.flags & 2 /* Const */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_variable_whose_type_is_a_unique_symbol_type_must_be_const);
	                        }
	                        break;
	                    case 151 /* PropertyDeclaration */:
	                        if (!ts.hasModifier(parent, 32 /* Static */) ||
	                            !ts.hasModifier(parent, 64 /* Readonly */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_property_of_a_class_whose_type_is_a_unique_symbol_type_must_be_both_static_and_readonly);
	                        }
	                        break;
	                    case 150 /* PropertySignature */:
	                        if (!ts.hasModifier(parent, 64 /* Readonly */)) {
	                            return grammarErrorOnNode(parent.name, ts.Diagnostics.A_property_of_an_interface_or_type_literal_whose_type_is_a_unique_symbol_type_must_be_readonly);
	                        }
	                        break;
	                    default:
	                        return grammarErrorOnNode(node, ts.Diagnostics.unique_symbol_types_are_not_allowed_here);
	                }
	            }
	        }
	        function checkGrammarForInvalidDynamicName(node, message) {
	            if (isNonBindableDynamicName(node)) {
	                return grammarErrorOnNode(node, message);
	            }
	        }
	        function checkGrammarMethod(node) {
	            if (checkGrammarFunctionLikeDeclaration(node)) {
	                return true;
	            }
	            if (node.kind === 153 /* MethodDeclaration */) {
	                if (node.parent.kind === 183 /* ObjectLiteralExpression */) {
	                    // We only disallow modifier on a method declaration if it is a property of object-literal-expression
	                    if (node.modifiers && !(node.modifiers.length === 1 && ts.first(node.modifiers).kind === 120 /* AsyncKeyword */)) {
	                        return grammarErrorOnFirstToken(node, ts.Diagnostics.Modifiers_cannot_appear_here);
	                    }
	                    else if (checkGrammarForInvalidQuestionMark(node.questionToken, ts.Diagnostics.An_object_member_cannot_be_declared_optional)) {
	                        return true;
	                    }
	                    else if (node.body === undefined) {
	                        return grammarErrorAtPos(node, node.end - 1, ";".length, ts.Diagnostics._0_expected, "{");
	                    }
	                }
	                if (checkGrammarForGenerator(node)) {
	                    return true;
	                }
	            }
	            if (ts.isClassLike(node.parent)) {
	                // Technically, computed properties in ambient contexts is disallowed
	                // for property declarations and accessors too, not just methods.
	                // However, property declarations disallow computed names in general,
	                // and accessors are not allowed in ambient contexts in general,
	                // so this error only really matters for methods.
	                if (node.flags & 4194304 /* Ambient */) {
	                    return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_ambient_context_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	                }
	                else if (node.kind === 153 /* MethodDeclaration */ && !node.body) {
	                    return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_method_overload_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	                }
	            }
	            else if (node.parent.kind === 235 /* InterfaceDeclaration */) {
	                return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	            }
	            else if (node.parent.kind === 165 /* TypeLiteral */) {
	                return checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type);
	            }
	        }
	        function checkGrammarBreakOrContinueStatement(node) {
	            var current = node;
	            while (current) {
	                if (ts.isFunctionLike(current)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.Jump_target_cannot_cross_function_boundary);
	                }
	                switch (current.kind) {
	                    case 227 /* LabeledStatement */:
	                        if (node.label && current.label.escapedText === node.label.escapedText) {
	                            // found matching label - verify that label usage is correct
	                            // continue can only target labels that are on iteration statements
	                            var isMisplacedContinueLabel = node.kind === 222 /* ContinueStatement */
	                                && !ts.isIterationStatement(current.statement, /*lookInLabeledStatement*/ true);
	                            if (isMisplacedContinueLabel) {
	                                return grammarErrorOnNode(node, ts.Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement);
	                            }
	                            return false;
	                        }
	                        break;
	                    case 226 /* SwitchStatement */:
	                        if (node.kind === 223 /* BreakStatement */ && !node.label) {
	                            // unlabeled break within switch statement - ok
	                            return false;
	                        }
	                        break;
	                    default:
	                        if (ts.isIterationStatement(current, /*lookInLabeledStatement*/ false) && !node.label) {
	                            // unlabeled break or continue within iteration statement - ok
	                            return false;
	                        }
	                        break;
	                }
	                current = current.parent;
	            }
	            if (node.label) {
	                var message = node.kind === 223 /* BreakStatement */
	                    ? ts.Diagnostics.A_break_statement_can_only_jump_to_a_label_of_an_enclosing_statement
	                    : ts.Diagnostics.A_continue_statement_can_only_jump_to_a_label_of_an_enclosing_iteration_statement;
	                return grammarErrorOnNode(node, message);
	            }
	            else {
	                var message = node.kind === 223 /* BreakStatement */
	                    ? ts.Diagnostics.A_break_statement_can_only_be_used_within_an_enclosing_iteration_or_switch_statement
	                    : ts.Diagnostics.A_continue_statement_can_only_be_used_within_an_enclosing_iteration_statement;
	                return grammarErrorOnNode(node, message);
	            }
	        }
	        function checkGrammarBindingElement(node) {
	            if (node.dotDotDotToken) {
	                var elements = node.parent.elements;
	                if (node !== ts.last(elements)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.A_rest_element_must_be_last_in_a_destructuring_pattern);
	                }
	                checkGrammarForDisallowedTrailingComma(elements, ts.Diagnostics.A_rest_parameter_or_binding_pattern_may_not_have_a_trailing_comma);
	                if (node.name.kind === 180 /* ArrayBindingPattern */ || node.name.kind === 179 /* ObjectBindingPattern */) {
	                    return grammarErrorOnNode(node.name, ts.Diagnostics.A_rest_element_cannot_contain_a_binding_pattern);
	                }
	                if (node.propertyName) {
	                    return grammarErrorOnNode(node.name, ts.Diagnostics.A_rest_element_cannot_have_a_property_name);
	                }
	                if (node.initializer) {
	                    // Error on equals token which immediately precedes the initializer
	                    return grammarErrorAtPos(node, node.initializer.pos - 1, 1, ts.Diagnostics.A_rest_element_cannot_have_an_initializer);
	                }
	            }
	        }
	        function isStringOrNumberLiteralExpression(expr) {
	            return expr.kind === 9 /* StringLiteral */ || expr.kind === 8 /* NumericLiteral */ ||
	                expr.kind === 197 /* PrefixUnaryExpression */ && expr.operator === 38 /* MinusToken */ &&
	                    expr.operand.kind === 8 /* NumericLiteral */;
	        }
	        function checkGrammarVariableDeclaration(node) {
	            if (node.parent.parent.kind !== 220 /* ForInStatement */ && node.parent.parent.kind !== 221 /* ForOfStatement */) {
	                if (node.flags & 4194304 /* Ambient */) {
	                    if (node.initializer) {
	                        if (ts.isConst(node) && !node.type) {
	                            if (!isStringOrNumberLiteralExpression(node.initializer)) {
	                                return grammarErrorOnNode(node.initializer, ts.Diagnostics.A_const_initializer_in_an_ambient_context_must_be_a_string_or_numeric_literal);
	                            }
	                        }
	                        else {
	                            // Error on equals token which immediate precedes the initializer
	                            var equalsTokenLength = "=".length;
	                            return grammarErrorAtPos(node, node.initializer.pos - equalsTokenLength, equalsTokenLength, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	                        }
	                    }
	                    if (node.initializer && !(ts.isConst(node) && isStringOrNumberLiteralExpression(node.initializer))) {
	                        // Error on equals token which immediate precedes the initializer
	                        var equalsTokenLength = "=".length;
	                        return grammarErrorAtPos(node, node.initializer.pos - equalsTokenLength, equalsTokenLength, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	                    }
	                }
	                else if (!node.initializer) {
	                    if (ts.isBindingPattern(node.name) && !ts.isBindingPattern(node.parent)) {
	                        return grammarErrorOnNode(node, ts.Diagnostics.A_destructuring_declaration_must_have_an_initializer);
	                    }
	                    if (ts.isConst(node)) {
	                        return grammarErrorOnNode(node, ts.Diagnostics.const_declarations_must_be_initialized);
	                    }
	                }
	            }
	            if (node.exclamationToken && (node.parent.parent.kind !== 213 /* VariableStatement */ || !node.type || node.initializer || node.flags & 4194304 /* Ambient */)) {
	                return grammarErrorOnNode(node.exclamationToken, ts.Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
	            }
	            if (compilerOptions.module !== ts.ModuleKind.ES2015 && compilerOptions.module !== ts.ModuleKind.ESNext && compilerOptions.module !== ts.ModuleKind.System && !compilerOptions.noEmit &&
	                !(node.parent.parent.flags & 4194304 /* Ambient */) && ts.hasModifier(node.parent.parent, 1 /* Export */)) {
	                checkESModuleMarker(node.name);
	            }
	            var checkLetConstNames = (ts.isLet(node) || ts.isConst(node));
	            // 1. LexicalDeclaration : LetOrConst BindingList ;
	            // It is a Syntax Error if the BoundNames of BindingList contains "let".
	            // 2. ForDeclaration: ForDeclaration : LetOrConst ForBinding
	            // It is a Syntax Error if the BoundNames of ForDeclaration contains "let".
	            // It is a SyntaxError if a VariableDeclaration or VariableDeclarationNoIn occurs within strict code
	            // and its Identifier is eval or arguments
	            return checkLetConstNames && checkGrammarNameInLetOrConstDeclarations(node.name);
	        }
	        function checkESModuleMarker(name) {
	            if (name.kind === 71 /* Identifier */) {
	                if (ts.idText(name) === "__esModule") {
	                    return grammarErrorOnNode(name, ts.Diagnostics.Identifier_expected_esModule_is_reserved_as_an_exported_marker_when_transforming_ECMAScript_modules);
	                }
	            }
	            else {
	                var elements = name.elements;
	                for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
	                    var element = elements_1[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        return checkESModuleMarker(element.name);
	                    }
	                }
	            }
	        }
	        function checkGrammarNameInLetOrConstDeclarations(name) {
	            if (name.kind === 71 /* Identifier */) {
	                if (name.originalKeywordKind === 110 /* LetKeyword */) {
	                    return grammarErrorOnNode(name, ts.Diagnostics.let_is_not_allowed_to_be_used_as_a_name_in_let_or_const_declarations);
	                }
	            }
	            else {
	                var elements = name.elements;
	                for (var _i = 0, elements_2 = elements; _i < elements_2.length; _i++) {
	                    var element = elements_2[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        checkGrammarNameInLetOrConstDeclarations(element.name);
	                    }
	                }
	            }
	        }
	        function checkGrammarVariableDeclarationList(declarationList) {
	            var declarations = declarationList.declarations;
	            if (checkGrammarForDisallowedTrailingComma(declarationList.declarations)) {
	                return true;
	            }
	            if (!declarationList.declarations.length) {
	                return grammarErrorAtPos(declarationList, declarations.pos, declarations.end - declarations.pos, ts.Diagnostics.Variable_declaration_list_cannot_be_empty);
	            }
	        }
	        function allowLetAndConstDeclarations(parent) {
	            switch (parent.kind) {
	                case 216 /* IfStatement */:
	                case 217 /* DoStatement */:
	                case 218 /* WhileStatement */:
	                case 225 /* WithStatement */:
	                case 219 /* ForStatement */:
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                    return false;
	                case 227 /* LabeledStatement */:
	                    return allowLetAndConstDeclarations(parent.parent);
	            }
	            return true;
	        }
	        function checkGrammarForDisallowedLetOrConstStatement(node) {
	            if (!allowLetAndConstDeclarations(node.parent)) {
	                if (ts.isLet(node.declarationList)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.let_declarations_can_only_be_declared_inside_a_block);
	                }
	                else if (ts.isConst(node.declarationList)) {
	                    return grammarErrorOnNode(node, ts.Diagnostics.const_declarations_can_only_be_declared_inside_a_block);
	                }
	            }
	        }
	        function checkGrammarMetaProperty(node) {
	            var escapedText = node.name.escapedText;
	            switch (node.keywordToken) {
	                case 94 /* NewKeyword */:
	                    if (escapedText !== "target") {
	                        return grammarErrorOnNode(node.name, ts.Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, node.name.escapedText, ts.tokenToString(node.keywordToken), "target");
	                    }
	                    break;
	                case 91 /* ImportKeyword */:
	                    if (escapedText !== "meta") {
	                        return grammarErrorOnNode(node.name, ts.Diagnostics._0_is_not_a_valid_meta_property_for_keyword_1_Did_you_mean_2, node.name.escapedText, ts.tokenToString(node.keywordToken), "meta");
	                    }
	                    break;
	            }
	        }
	        function hasParseDiagnostics(sourceFile) {
	            return sourceFile.parseDiagnostics.length > 0;
	        }
	        function grammarErrorOnFirstToken(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var span = ts.getSpanOfTokenAtPosition(sourceFile, node.pos);
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, span.start, span.length, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function grammarErrorAtPos(nodeForSourceFile, start, length, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(nodeForSourceFile);
	            if (!hasParseDiagnostics(sourceFile)) {
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, start, length, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function grammarErrorOnNode(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                diagnostics.add(ts.createDiagnosticForNode(node, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function checkGrammarConstructorTypeParameters(node) {
	            var typeParameters = ts.getEffectiveTypeParameterDeclarations(node);
	            if (ts.isNodeArray(typeParameters)) {
	                var pos = typeParameters.pos, end = typeParameters.end;
	                return grammarErrorAtPos(node, pos, end - pos, ts.Diagnostics.Type_parameters_cannot_appear_on_a_constructor_declaration);
	            }
	        }
	        function checkGrammarConstructorTypeAnnotation(node) {
	            var type = ts.getEffectiveReturnTypeNode(node);
	            if (type) {
	                return grammarErrorOnNode(type, ts.Diagnostics.Type_annotation_cannot_appear_on_a_constructor_declaration);
	            }
	        }
	        function checkGrammarProperty(node) {
	            if (ts.isClassLike(node.parent)) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_class_property_declaration_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	            }
	            else if (node.parent.kind === 235 /* InterfaceDeclaration */) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_an_interface_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	                if (node.initializer) {
	                    return grammarErrorOnNode(node.initializer, ts.Diagnostics.An_interface_property_cannot_have_an_initializer);
	                }
	            }
	            else if (node.parent.kind === 165 /* TypeLiteral */) {
	                if (checkGrammarForInvalidDynamicName(node.name, ts.Diagnostics.A_computed_property_name_in_a_type_literal_must_refer_to_an_expression_whose_type_is_a_literal_type_or_a_unique_symbol_type)) {
	                    return true;
	                }
	                if (node.initializer) {
	                    return grammarErrorOnNode(node.initializer, ts.Diagnostics.A_type_literal_property_cannot_have_an_initializer);
	                }
	            }
	            if (node.flags & 4194304 /* Ambient */ && node.initializer) {
	                return grammarErrorOnFirstToken(node.initializer, ts.Diagnostics.Initializers_are_not_allowed_in_ambient_contexts);
	            }
	            if (ts.isPropertyDeclaration(node) && node.exclamationToken && (!ts.isClassLike(node.parent) || !node.type || node.initializer ||
	                node.flags & 4194304 /* Ambient */ || ts.hasModifier(node, 32 /* Static */ | 128 /* Abstract */))) {
	                return grammarErrorOnNode(node.exclamationToken, ts.Diagnostics.A_definite_assignment_assertion_is_not_permitted_in_this_context);
	            }
	        }
	        function checkGrammarTopLevelElementForRequiredDeclareModifier(node) {
	            // A declare modifier is required for any top level .d.ts declaration except export=, export default, export as namespace
	            // interfaces and imports categories:
	            //
	            //  DeclarationElement:
	            //     ExportAssignment
	            //     export_opt   InterfaceDeclaration
	            //     export_opt   TypeAliasDeclaration
	            //     export_opt   ImportDeclaration
	            //     export_opt   ExternalImportDeclaration
	            //     export_opt   AmbientDeclaration
	            //
	            // TODO: The spec needs to be amended to reflect this grammar.
	            if (node.kind === 235 /* InterfaceDeclaration */ ||
	                node.kind === 236 /* TypeAliasDeclaration */ ||
	                node.kind === 243 /* ImportDeclaration */ ||
	                node.kind === 242 /* ImportEqualsDeclaration */ ||
	                node.kind === 249 /* ExportDeclaration */ ||
	                node.kind === 248 /* ExportAssignment */ ||
	                node.kind === 241 /* NamespaceExportDeclaration */ ||
	                ts.hasModifier(node, 2 /* Ambient */ | 1 /* Export */ | 512 /* Default */)) {
	                return false;
	            }
	            return grammarErrorOnFirstToken(node, ts.Diagnostics.A_declare_modifier_is_required_for_a_top_level_declaration_in_a_d_ts_file);
	        }
	        function checkGrammarTopLevelElementsForRequiredDeclareModifier(file) {
	            for (var _i = 0, _a = file.statements; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (ts.isDeclaration(decl) || decl.kind === 213 /* VariableStatement */) {
	                    if (checkGrammarTopLevelElementForRequiredDeclareModifier(decl)) {
	                        return true;
	                    }
	                }
	            }
	        }
	        function checkGrammarSourceFile(node) {
	            return !!(node.flags & 4194304 /* Ambient */) && checkGrammarTopLevelElementsForRequiredDeclareModifier(node);
	        }
	        function checkGrammarStatementInAmbientContext(node) {
	            if (node.flags & 4194304 /* Ambient */) {
	                // An accessors is already reported about the ambient context
	                if (ts.isAccessor(node.parent)) {
	                    return getNodeLinks(node).hasReportedStatementInAmbientContext = true;
	                }
	                // Find containing block which is either Block, ModuleBlock, SourceFile
	                var links = getNodeLinks(node);
	                if (!links.hasReportedStatementInAmbientContext && ts.isFunctionLike(node.parent)) {
	                    return getNodeLinks(node).hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, ts.Diagnostics.An_implementation_cannot_be_declared_in_ambient_contexts);
	                }
	                // We are either parented by another statement, or some sort of block.
	                // If we're in a block, we only want to really report an error once
	                // to prevent noisiness.  So use a bit on the block to indicate if
	                // this has already been reported, and don't report if it has.
	                //
	                if (node.parent.kind === 212 /* Block */ || node.parent.kind === 239 /* ModuleBlock */ || node.parent.kind === 273 /* SourceFile */) {
	                    var links_1 = getNodeLinks(node.parent);
	                    // Check if the containing block ever report this error
	                    if (!links_1.hasReportedStatementInAmbientContext) {
	                        return links_1.hasReportedStatementInAmbientContext = grammarErrorOnFirstToken(node, ts.Diagnostics.Statements_are_not_allowed_in_ambient_contexts);
	                    }
	                }
	                else {
	                    // We must be parented by a statement.  If so, there's no need
	                    // to report the error as our parent will have already done it.
	                    // Debug.assert(isStatement(node.parent));
	                }
	            }
	        }
	        function checkGrammarNumericLiteral(node) {
	            // Grammar checking
	            if (node.numericLiteralFlags & 32 /* Octal */) {
	                var diagnosticMessage = void 0;
	                if (languageVersion >= 1 /* ES5 */) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literals_are_not_available_when_targeting_ECMAScript_5_and_higher_Use_the_syntax_0;
	                }
	                else if (ts.isChildOfNodeWithKind(node, 177 /* LiteralType */)) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literal_types_must_use_ES2015_syntax_Use_the_syntax_0;
	                }
	                else if (ts.isChildOfNodeWithKind(node, 272 /* EnumMember */)) {
	                    diagnosticMessage = ts.Diagnostics.Octal_literals_are_not_allowed_in_enums_members_initializer_Use_the_syntax_0;
	                }
	                if (diagnosticMessage) {
	                    var withMinus = ts.isPrefixUnaryExpression(node.parent) && node.parent.operator === 38 /* MinusToken */;
	                    var literal = (withMinus ? "-" : "") + "0o" + node.text;
	                    return grammarErrorOnNode(withMinus ? node.parent : node, diagnosticMessage, literal);
	                }
	            }
	        }
	        function grammarErrorAfterFirstToken(node, message, arg0, arg1, arg2) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            if (!hasParseDiagnostics(sourceFile)) {
	                var span = ts.getSpanOfTokenAtPosition(sourceFile, node.pos);
	                diagnostics.add(ts.createFileDiagnostic(sourceFile, ts.textSpanEnd(span), /*length*/ 0, message, arg0, arg1, arg2));
	                return true;
	            }
	        }
	        function getAmbientModules() {
	            if (!ambientModulesCache) {
	                ambientModulesCache = [];
	                globals.forEach(function (global, sym) {
	                    // No need to `unescapeLeadingUnderscores`, an escaped symbol is never an ambient module.
	                    if (ambientModuleSymbolRegex.test(sym)) {
	                        ambientModulesCache.push(global);
	                    }
	                });
	            }
	            return ambientModulesCache;
	        }
	        function checkGrammarImportCallExpression(node) {
	            if (moduleKind === ts.ModuleKind.ES2015) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_is_only_supported_when_module_flag_is_commonjs_or_esNext);
	            }
	            if (node.typeArguments) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_cannot_have_type_arguments);
	            }
	            var nodeArguments = node.arguments;
	            if (nodeArguments.length !== 1) {
	                return grammarErrorOnNode(node, ts.Diagnostics.Dynamic_import_must_have_one_specifier_as_an_argument);
	            }
	            // see: parseArgumentOrArrayLiteralElement...we use this function which parse arguments of callExpression to parse specifier for dynamic import.
	            // parseArgumentOrArrayLiteralElement allows spread element to be in an argument list which is not allowed as specifier in dynamic import.
	            if (ts.isSpreadElement(nodeArguments[0])) {
	                return grammarErrorOnNode(nodeArguments[0], ts.Diagnostics.Specifier_of_dynamic_import_cannot_be_spread_element);
	            }
	        }
	    }
	    ts.createTypeChecker = createTypeChecker;
	    /** Like 'isDeclarationName', but returns true for LHS of `import { x as y }` or `export { x as y }`. */
	    function isDeclarationNameOrImportPropertyName(name) {
	        switch (name.parent.kind) {
	            case 247 /* ImportSpecifier */:
	            case 251 /* ExportSpecifier */:
	                return ts.isIdentifier(name);
	            default:
	                return ts.isDeclarationName(name);
	        }
	    }
	    function isSomeImportDeclaration(decl) {
	        switch (decl.kind) {
	            case 244 /* ImportClause */: // For default import
	            case 242 /* ImportEqualsDeclaration */:
	            case 245 /* NamespaceImport */:
	            case 247 /* ImportSpecifier */: // For rename import `x as y`
	                return true;
	            case 71 /* Identifier */:
	                // For regular import, `decl` is an Identifier under the ImportSpecifier.
	                return decl.parent.kind === 247 /* ImportSpecifier */;
	            default:
	                return false;
	        }
	    }
	    var JsxNames;
	    (function (JsxNames) {
	        // tslint:disable variable-name
	        JsxNames.JSX = "JSX";
	        JsxNames.IntrinsicElements = "IntrinsicElements";
	        JsxNames.ElementClass = "ElementClass";
	        JsxNames.ElementAttributesPropertyNameContainer = "ElementAttributesProperty"; // TODO: Deprecate and remove support
	        JsxNames.ElementChildrenAttributeNameContainer = "ElementChildrenAttribute";
	        JsxNames.Element = "Element";
	        JsxNames.IntrinsicAttributes = "IntrinsicAttributes";
	        JsxNames.IntrinsicClassAttributes = "IntrinsicClassAttributes";
	        // tslint:enable variable-name
	    })(JsxNames || (JsxNames = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function createSynthesizedNode(kind) {
	        var node = ts.createNode(kind, -1, -1);
	        node.flags |= 8 /* Synthesized */;
	        return node;
	    }
	    /* @internal */
	    function updateNode(updated, original) {
	        if (updated !== original) {
	            setOriginalNode(updated, original);
	            setTextRange(updated, original);
	            ts.aggregateTransformFlags(updated);
	        }
	        return updated;
	    }
	    ts.updateNode = updateNode;
	    /**
	     * Make `elements` into a `NodeArray<T>`. If `elements` is `undefined`, returns an empty `NodeArray<T>`.
	     */
	    function createNodeArray(elements, hasTrailingComma) {
	        if (!elements || elements === ts.emptyArray) {
	            elements = [];
	        }
	        else if (ts.isNodeArray(elements)) {
	            return elements;
	        }
	        var array = elements;
	        array.pos = -1;
	        array.end = -1;
	        array.hasTrailingComma = hasTrailingComma;
	        return array;
	    }
	    ts.createNodeArray = createNodeArray;
	    /**
	     * Creates a shallow, memberwise clone of a node with no source map location.
	     */
	    /* @internal */
	    function getSynthesizedClone(node) {
	        // We don't use "clone" from core.ts here, as we need to preserve the prototype chain of
	        // the original node. We also need to exclude specific properties and only include own-
	        // properties (to skip members already defined on the shared prototype).
	        if (node === undefined) {
	            return undefined;
	        }
	        var clone = createSynthesizedNode(node.kind);
	        clone.flags |= node.flags;
	        setOriginalNode(clone, node);
	        for (var key in node) {
	            if (clone.hasOwnProperty(key) || !node.hasOwnProperty(key)) {
	                continue;
	            }
	            clone[key] = node[key];
	        }
	        return clone;
	    }
	    ts.getSynthesizedClone = getSynthesizedClone;
	    function createLiteral(value, isSingleQuote) {
	        if (typeof value === "number") {
	            return createNumericLiteral(value + "");
	        }
	        if (typeof value === "boolean") {
	            return value ? createTrue() : createFalse();
	        }
	        if (ts.isString(value)) {
	            var res = createStringLiteral(value);
	            if (isSingleQuote)
	                res.singleQuote = true;
	            return res;
	        }
	        return createLiteralFromNode(value);
	    }
	    ts.createLiteral = createLiteral;
	    function createNumericLiteral(value) {
	        var node = createSynthesizedNode(8 /* NumericLiteral */);
	        node.text = value;
	        node.numericLiteralFlags = 0;
	        return node;
	    }
	    ts.createNumericLiteral = createNumericLiteral;
	    function createStringLiteral(text) {
	        var node = createSynthesizedNode(9 /* StringLiteral */);
	        node.text = text;
	        return node;
	    }
	    ts.createStringLiteral = createStringLiteral;
	    function createRegularExpressionLiteral(text) {
	        var node = createSynthesizedNode(12 /* RegularExpressionLiteral */);
	        node.text = text;
	        return node;
	    }
	    ts.createRegularExpressionLiteral = createRegularExpressionLiteral;
	    function createLiteralFromNode(sourceNode) {
	        var node = createStringLiteral(ts.getTextOfIdentifierOrLiteral(sourceNode));
	        node.textSourceNode = sourceNode;
	        return node;
	    }
	    function createIdentifier(text, typeArguments) {
	        var node = createSynthesizedNode(71 /* Identifier */);
	        node.escapedText = ts.escapeLeadingUnderscores(text);
	        node.originalKeywordKind = text ? ts.stringToToken(text) : 0 /* Unknown */;
	        node.autoGenerateFlags = 0 /* None */;
	        node.autoGenerateId = 0;
	        if (typeArguments) {
	            node.typeArguments = createNodeArray(typeArguments);
	        }
	        return node;
	    }
	    ts.createIdentifier = createIdentifier;
	    function updateIdentifier(node, typeArguments) {
	        return node.typeArguments !== typeArguments
	            ? updateNode(createIdentifier(ts.idText(node), typeArguments), node)
	            : node;
	    }
	    ts.updateIdentifier = updateIdentifier;
	    var nextAutoGenerateId = 0;
	    function createTempVariable(recordTempVariable, reservedInNestedScopes) {
	        var name = createIdentifier("");
	        name.autoGenerateFlags = 1 /* Auto */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        if (recordTempVariable) {
	            recordTempVariable(name);
	        }
	        if (reservedInNestedScopes) {
	            name.autoGenerateFlags |= 8 /* ReservedInNestedScopes */;
	        }
	        return name;
	    }
	    ts.createTempVariable = createTempVariable;
	    /** Create a unique temporary variable for use in a loop. */
	    function createLoopVariable() {
	        var name = createIdentifier("");
	        name.autoGenerateFlags = 2 /* Loop */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.createLoopVariable = createLoopVariable;
	    /** Create a unique name based on the supplied text. */
	    function createUniqueName(text) {
	        var name = createIdentifier(text);
	        name.autoGenerateFlags = 3 /* Unique */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.createUniqueName = createUniqueName;
	    /** Create a unique name based on the supplied text. */
	    function createOptimisticUniqueName(text) {
	        var name = createIdentifier(text);
	        name.autoGenerateFlags = 3 /* Unique */ | 16 /* Optimistic */;
	        name.autoGenerateId = nextAutoGenerateId;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.createOptimisticUniqueName = createOptimisticUniqueName;
	    /** Create a unique name based on the supplied text. This does not consider names injected by the transformer. */
	    function createFileLevelUniqueName(text) {
	        var name = createOptimisticUniqueName(text);
	        name.autoGenerateFlags |= 32 /* FileLevel */;
	        return name;
	    }
	    ts.createFileLevelUniqueName = createFileLevelUniqueName;
	    function getGeneratedNameForNode(node, flags) {
	        var name = createIdentifier(ts.isIdentifier(node) ? ts.idText(node) : "");
	        name.autoGenerateFlags = 4 /* Node */ | flags;
	        name.autoGenerateId = nextAutoGenerateId;
	        name.original = node;
	        nextAutoGenerateId++;
	        return name;
	    }
	    ts.getGeneratedNameForNode = getGeneratedNameForNode;
	    // Punctuation
	    function createToken(token) {
	        return createSynthesizedNode(token);
	    }
	    ts.createToken = createToken;
	    // Reserved words
	    function createSuper() {
	        return createSynthesizedNode(97 /* SuperKeyword */);
	    }
	    ts.createSuper = createSuper;
	    function createThis() {
	        return createSynthesizedNode(99 /* ThisKeyword */);
	    }
	    ts.createThis = createThis;
	    function createNull() {
	        return createSynthesizedNode(95 /* NullKeyword */);
	    }
	    ts.createNull = createNull;
	    function createTrue() {
	        return createSynthesizedNode(101 /* TrueKeyword */);
	    }
	    ts.createTrue = createTrue;
	    function createFalse() {
	        return createSynthesizedNode(86 /* FalseKeyword */);
	    }
	    ts.createFalse = createFalse;
	    // Modifiers
	    function createModifier(kind) {
	        return createToken(kind);
	    }
	    ts.createModifier = createModifier;
	    function createModifiersFromModifierFlags(flags) {
	        var result = [];
	        if (flags & 1 /* Export */) {
	            result.push(createModifier(84 /* ExportKeyword */));
	        }
	        if (flags & 2 /* Ambient */) {
	            result.push(createModifier(124 /* DeclareKeyword */));
	        }
	        if (flags & 512 /* Default */) {
	            result.push(createModifier(79 /* DefaultKeyword */));
	        }
	        if (flags & 2048 /* Const */) {
	            result.push(createModifier(76 /* ConstKeyword */));
	        }
	        if (flags & 4 /* Public */) {
	            result.push(createModifier(114 /* PublicKeyword */));
	        }
	        if (flags & 8 /* Private */) {
	            result.push(createModifier(112 /* PrivateKeyword */));
	        }
	        if (flags & 16 /* Protected */) {
	            result.push(createModifier(113 /* ProtectedKeyword */));
	        }
	        if (flags & 128 /* Abstract */) {
	            result.push(createModifier(117 /* AbstractKeyword */));
	        }
	        if (flags & 32 /* Static */) {
	            result.push(createModifier(115 /* StaticKeyword */));
	        }
	        if (flags & 64 /* Readonly */) {
	            result.push(createModifier(132 /* ReadonlyKeyword */));
	        }
	        if (flags & 256 /* Async */) {
	            result.push(createModifier(120 /* AsyncKeyword */));
	        }
	        return result;
	    }
	    ts.createModifiersFromModifierFlags = createModifiersFromModifierFlags;
	    // Names
	    function createQualifiedName(left, right) {
	        var node = createSynthesizedNode(145 /* QualifiedName */);
	        node.left = left;
	        node.right = asName(right);
	        return node;
	    }
	    ts.createQualifiedName = createQualifiedName;
	    function updateQualifiedName(node, left, right) {
	        return node.left !== left
	            || node.right !== right
	            ? updateNode(createQualifiedName(left, right), node)
	            : node;
	    }
	    ts.updateQualifiedName = updateQualifiedName;
	    function parenthesizeForComputedName(expression) {
	        return (ts.isBinaryExpression(expression) && expression.operatorToken.kind === 26 /* CommaToken */) ||
	            expression.kind === 301 /* CommaListExpression */ ?
	            createParen(expression) :
	            expression;
	    }
	    function createComputedPropertyName(expression) {
	        var node = createSynthesizedNode(146 /* ComputedPropertyName */);
	        node.expression = parenthesizeForComputedName(expression);
	        return node;
	    }
	    ts.createComputedPropertyName = createComputedPropertyName;
	    function updateComputedPropertyName(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createComputedPropertyName(expression), node)
	            : node;
	    }
	    ts.updateComputedPropertyName = updateComputedPropertyName;
	    // Signature elements
	    function createTypeParameterDeclaration(name, constraint, defaultType) {
	        var node = createSynthesizedNode(147 /* TypeParameter */);
	        node.name = asName(name);
	        node.constraint = constraint;
	        node.default = defaultType;
	        return node;
	    }
	    ts.createTypeParameterDeclaration = createTypeParameterDeclaration;
	    function updateTypeParameterDeclaration(node, name, constraint, defaultType) {
	        return node.name !== name
	            || node.constraint !== constraint
	            || node.default !== defaultType
	            ? updateNode(createTypeParameterDeclaration(name, constraint, defaultType), node)
	            : node;
	    }
	    ts.updateTypeParameterDeclaration = updateTypeParameterDeclaration;
	    function createParameter(decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
	        var node = createSynthesizedNode(148 /* Parameter */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.dotDotDotToken = dotDotDotToken;
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.type = type;
	        node.initializer = initializer ? ts.parenthesizeExpressionForList(initializer) : undefined;
	        return node;
	    }
	    ts.createParameter = createParameter;
	    function updateParameter(node, decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.dotDotDotToken !== dotDotDotToken
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createParameter(decorators, modifiers, dotDotDotToken, name, questionToken, type, initializer), node)
	            : node;
	    }
	    ts.updateParameter = updateParameter;
	    function createDecorator(expression) {
	        var node = createSynthesizedNode(149 /* Decorator */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        return node;
	    }
	    ts.createDecorator = createDecorator;
	    function updateDecorator(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createDecorator(expression), node)
	            : node;
	    }
	    ts.updateDecorator = updateDecorator;
	    // Type Elements
	    function createPropertySignature(modifiers, name, questionToken, type, initializer) {
	        var node = createSynthesizedNode(150 /* PropertySignature */);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.type = type;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createPropertySignature = createPropertySignature;
	    function updatePropertySignature(node, modifiers, name, questionToken, type, initializer) {
	        return node.modifiers !== modifiers
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createPropertySignature(modifiers, name, questionToken, type, initializer), node)
	            : node;
	    }
	    ts.updatePropertySignature = updatePropertySignature;
	    function createProperty(decorators, modifiers, name, questionOrExclamationToken, type, initializer) {
	        var node = createSynthesizedNode(151 /* PropertyDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.questionToken = questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 55 /* QuestionToken */ ? questionOrExclamationToken : undefined;
	        node.exclamationToken = questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 51 /* ExclamationToken */ ? questionOrExclamationToken : undefined;
	        node.type = type;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createProperty = createProperty;
	    function updateProperty(node, decorators, modifiers, name, questionOrExclamationToken, type, initializer) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.questionToken !== (questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 55 /* QuestionToken */ ? questionOrExclamationToken : undefined)
	            || node.exclamationToken !== (questionOrExclamationToken !== undefined && questionOrExclamationToken.kind === 51 /* ExclamationToken */ ? questionOrExclamationToken : undefined)
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createProperty(decorators, modifiers, name, questionOrExclamationToken, type, initializer), node)
	            : node;
	    }
	    ts.updateProperty = updateProperty;
	    function createMethodSignature(typeParameters, parameters, type, name, questionToken) {
	        var node = createSignatureDeclaration(152 /* MethodSignature */, typeParameters, parameters, type);
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        return node;
	    }
	    ts.createMethodSignature = createMethodSignature;
	    function updateMethodSignature(node, typeParameters, parameters, type, name, questionToken) {
	        return node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.name !== name
	            || node.questionToken !== questionToken
	            ? updateNode(createMethodSignature(typeParameters, parameters, type, name, questionToken), node)
	            : node;
	    }
	    ts.updateMethodSignature = updateMethodSignature;
	    function createMethod(decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(153 /* MethodDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.questionToken = questionToken;
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createMethod = createMethod;
	    function updateMethod(node, decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.name !== name
	            || node.questionToken !== questionToken
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createMethod(decorators, modifiers, asteriskToken, name, questionToken, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateMethod = updateMethod;
	    function createConstructor(decorators, modifiers, parameters, body) {
	        var node = createSynthesizedNode(154 /* Constructor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.type = undefined;
	        node.body = body;
	        return node;
	    }
	    ts.createConstructor = createConstructor;
	    function updateConstructor(node, decorators, modifiers, parameters, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.parameters !== parameters
	            || node.body !== body
	            ? updateNode(createConstructor(decorators, modifiers, parameters, body), node)
	            : node;
	    }
	    ts.updateConstructor = updateConstructor;
	    function createGetAccessor(decorators, modifiers, name, parameters, type, body) {
	        var node = createSynthesizedNode(155 /* GetAccessor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createGetAccessor = createGetAccessor;
	    function updateGetAccessor(node, decorators, modifiers, name, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createGetAccessor(decorators, modifiers, name, parameters, type, body), node)
	            : node;
	    }
	    ts.updateGetAccessor = updateGetAccessor;
	    function createSetAccessor(decorators, modifiers, name, parameters, body) {
	        var node = createSynthesizedNode(156 /* SetAccessor */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = undefined;
	        node.parameters = createNodeArray(parameters);
	        node.body = body;
	        return node;
	    }
	    ts.createSetAccessor = createSetAccessor;
	    function updateSetAccessor(node, decorators, modifiers, name, parameters, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.parameters !== parameters
	            || node.body !== body
	            ? updateNode(createSetAccessor(decorators, modifiers, name, parameters, body), node)
	            : node;
	    }
	    ts.updateSetAccessor = updateSetAccessor;
	    function createCallSignature(typeParameters, parameters, type) {
	        return createSignatureDeclaration(157 /* CallSignature */, typeParameters, parameters, type);
	    }
	    ts.createCallSignature = createCallSignature;
	    function updateCallSignature(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateCallSignature = updateCallSignature;
	    function createConstructSignature(typeParameters, parameters, type) {
	        return createSignatureDeclaration(158 /* ConstructSignature */, typeParameters, parameters, type);
	    }
	    ts.createConstructSignature = createConstructSignature;
	    function updateConstructSignature(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateConstructSignature = updateConstructSignature;
	    function createIndexSignature(decorators, modifiers, parameters, type) {
	        var node = createSynthesizedNode(159 /* IndexSignature */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        return node;
	    }
	    ts.createIndexSignature = createIndexSignature;
	    function updateIndexSignature(node, decorators, modifiers, parameters, type) {
	        return node.parameters !== parameters
	            || node.type !== type
	            || node.decorators !== decorators
	            || node.modifiers !== modifiers
	            ? updateNode(createIndexSignature(decorators, modifiers, parameters, type), node)
	            : node;
	    }
	    ts.updateIndexSignature = updateIndexSignature;
	    /* @internal */
	    function createSignatureDeclaration(kind, typeParameters, parameters, type, typeArguments) {
	        var node = createSynthesizedNode(kind);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = asNodeArray(parameters);
	        node.type = type;
	        node.typeArguments = asNodeArray(typeArguments);
	        return node;
	    }
	    ts.createSignatureDeclaration = createSignatureDeclaration;
	    function updateSignatureDeclaration(node, typeParameters, parameters, type) {
	        return node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            ? updateNode(createSignatureDeclaration(node.kind, typeParameters, parameters, type), node)
	            : node;
	    }
	    // Types
	    function createKeywordTypeNode(kind) {
	        return createSynthesizedNode(kind);
	    }
	    ts.createKeywordTypeNode = createKeywordTypeNode;
	    function createTypePredicateNode(parameterName, type) {
	        var node = createSynthesizedNode(160 /* TypePredicate */);
	        node.parameterName = asName(parameterName);
	        node.type = type;
	        return node;
	    }
	    ts.createTypePredicateNode = createTypePredicateNode;
	    function updateTypePredicateNode(node, parameterName, type) {
	        return node.parameterName !== parameterName
	            || node.type !== type
	            ? updateNode(createTypePredicateNode(parameterName, type), node)
	            : node;
	    }
	    ts.updateTypePredicateNode = updateTypePredicateNode;
	    function createTypeReferenceNode(typeName, typeArguments) {
	        var node = createSynthesizedNode(161 /* TypeReference */);
	        node.typeName = asName(typeName);
	        node.typeArguments = typeArguments && ts.parenthesizeTypeParameters(typeArguments);
	        return node;
	    }
	    ts.createTypeReferenceNode = createTypeReferenceNode;
	    function updateTypeReferenceNode(node, typeName, typeArguments) {
	        return node.typeName !== typeName
	            || node.typeArguments !== typeArguments
	            ? updateNode(createTypeReferenceNode(typeName, typeArguments), node)
	            : node;
	    }
	    ts.updateTypeReferenceNode = updateTypeReferenceNode;
	    function createFunctionTypeNode(typeParameters, parameters, type) {
	        return createSignatureDeclaration(162 /* FunctionType */, typeParameters, parameters, type);
	    }
	    ts.createFunctionTypeNode = createFunctionTypeNode;
	    function updateFunctionTypeNode(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateFunctionTypeNode = updateFunctionTypeNode;
	    function createConstructorTypeNode(typeParameters, parameters, type) {
	        return createSignatureDeclaration(163 /* ConstructorType */, typeParameters, parameters, type);
	    }
	    ts.createConstructorTypeNode = createConstructorTypeNode;
	    function updateConstructorTypeNode(node, typeParameters, parameters, type) {
	        return updateSignatureDeclaration(node, typeParameters, parameters, type);
	    }
	    ts.updateConstructorTypeNode = updateConstructorTypeNode;
	    function createTypeQueryNode(exprName) {
	        var node = createSynthesizedNode(164 /* TypeQuery */);
	        node.exprName = exprName;
	        return node;
	    }
	    ts.createTypeQueryNode = createTypeQueryNode;
	    function updateTypeQueryNode(node, exprName) {
	        return node.exprName !== exprName
	            ? updateNode(createTypeQueryNode(exprName), node)
	            : node;
	    }
	    ts.updateTypeQueryNode = updateTypeQueryNode;
	    function createTypeLiteralNode(members) {
	        var node = createSynthesizedNode(165 /* TypeLiteral */);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createTypeLiteralNode = createTypeLiteralNode;
	    function updateTypeLiteralNode(node, members) {
	        return node.members !== members
	            ? updateNode(createTypeLiteralNode(members), node)
	            : node;
	    }
	    ts.updateTypeLiteralNode = updateTypeLiteralNode;
	    function createArrayTypeNode(elementType) {
	        var node = createSynthesizedNode(166 /* ArrayType */);
	        node.elementType = ts.parenthesizeArrayTypeMember(elementType);
	        return node;
	    }
	    ts.createArrayTypeNode = createArrayTypeNode;
	    function updateArrayTypeNode(node, elementType) {
	        return node.elementType !== elementType
	            ? updateNode(createArrayTypeNode(elementType), node)
	            : node;
	    }
	    ts.updateArrayTypeNode = updateArrayTypeNode;
	    function createTupleTypeNode(elementTypes) {
	        var node = createSynthesizedNode(167 /* TupleType */);
	        node.elementTypes = createNodeArray(elementTypes);
	        return node;
	    }
	    ts.createTupleTypeNode = createTupleTypeNode;
	    function updateTypleTypeNode(node, elementTypes) {
	        return node.elementTypes !== elementTypes
	            ? updateNode(createTupleTypeNode(elementTypes), node)
	            : node;
	    }
	    ts.updateTypleTypeNode = updateTypleTypeNode;
	    function createUnionTypeNode(types) {
	        return createUnionOrIntersectionTypeNode(168 /* UnionType */, types);
	    }
	    ts.createUnionTypeNode = createUnionTypeNode;
	    function updateUnionTypeNode(node, types) {
	        return updateUnionOrIntersectionTypeNode(node, types);
	    }
	    ts.updateUnionTypeNode = updateUnionTypeNode;
	    function createIntersectionTypeNode(types) {
	        return createUnionOrIntersectionTypeNode(169 /* IntersectionType */, types);
	    }
	    ts.createIntersectionTypeNode = createIntersectionTypeNode;
	    function updateIntersectionTypeNode(node, types) {
	        return updateUnionOrIntersectionTypeNode(node, types);
	    }
	    ts.updateIntersectionTypeNode = updateIntersectionTypeNode;
	    function createUnionOrIntersectionTypeNode(kind, types) {
	        var node = createSynthesizedNode(kind);
	        node.types = ts.parenthesizeElementTypeMembers(types);
	        return node;
	    }
	    ts.createUnionOrIntersectionTypeNode = createUnionOrIntersectionTypeNode;
	    function updateUnionOrIntersectionTypeNode(node, types) {
	        return node.types !== types
	            ? updateNode(createUnionOrIntersectionTypeNode(node.kind, types), node)
	            : node;
	    }
	    function createConditionalTypeNode(checkType, extendsType, trueType, falseType) {
	        var node = createSynthesizedNode(170 /* ConditionalType */);
	        node.checkType = ts.parenthesizeConditionalTypeMember(checkType);
	        node.extendsType = ts.parenthesizeConditionalTypeMember(extendsType);
	        node.trueType = trueType;
	        node.falseType = falseType;
	        return node;
	    }
	    ts.createConditionalTypeNode = createConditionalTypeNode;
	    function updateConditionalTypeNode(node, checkType, extendsType, trueType, falseType) {
	        return node.checkType !== checkType
	            || node.extendsType !== extendsType
	            || node.trueType !== trueType
	            || node.falseType !== falseType
	            ? updateNode(createConditionalTypeNode(checkType, extendsType, trueType, falseType), node)
	            : node;
	    }
	    ts.updateConditionalTypeNode = updateConditionalTypeNode;
	    function createInferTypeNode(typeParameter) {
	        var node = createSynthesizedNode(171 /* InferType */);
	        node.typeParameter = typeParameter;
	        return node;
	    }
	    ts.createInferTypeNode = createInferTypeNode;
	    function updateInferTypeNode(node, typeParameter) {
	        return node.typeParameter !== typeParameter
	            ? updateNode(createInferTypeNode(typeParameter), node)
	            : node;
	    }
	    ts.updateInferTypeNode = updateInferTypeNode;
	    function createImportTypeNode(argument, qualifier, typeArguments, isTypeOf) {
	        var node = createSynthesizedNode(178 /* ImportType */);
	        node.argument = argument;
	        node.qualifier = qualifier;
	        node.typeArguments = asNodeArray(typeArguments);
	        node.isTypeOf = isTypeOf;
	        return node;
	    }
	    ts.createImportTypeNode = createImportTypeNode;
	    function updateImportTypeNode(node, argument, qualifier, typeArguments, isTypeOf) {
	        return node.argument !== argument
	            || node.qualifier !== qualifier
	            || node.typeArguments !== typeArguments
	            || node.isTypeOf !== isTypeOf
	            ? updateNode(createImportTypeNode(argument, qualifier, typeArguments, isTypeOf), node)
	            : node;
	    }
	    ts.updateImportTypeNode = updateImportTypeNode;
	    function createParenthesizedType(type) {
	        var node = createSynthesizedNode(172 /* ParenthesizedType */);
	        node.type = type;
	        return node;
	    }
	    ts.createParenthesizedType = createParenthesizedType;
	    function updateParenthesizedType(node, type) {
	        return node.type !== type
	            ? updateNode(createParenthesizedType(type), node)
	            : node;
	    }
	    ts.updateParenthesizedType = updateParenthesizedType;
	    function createThisTypeNode() {
	        return createSynthesizedNode(173 /* ThisType */);
	    }
	    ts.createThisTypeNode = createThisTypeNode;
	    function createTypeOperatorNode(operatorOrType, type) {
	        var node = createSynthesizedNode(174 /* TypeOperator */);
	        node.operator = typeof operatorOrType === "number" ? operatorOrType : 128 /* KeyOfKeyword */;
	        node.type = ts.parenthesizeElementTypeMember(typeof operatorOrType === "number" ? type : operatorOrType);
	        return node;
	    }
	    ts.createTypeOperatorNode = createTypeOperatorNode;
	    function updateTypeOperatorNode(node, type) {
	        return node.type !== type ? updateNode(createTypeOperatorNode(node.operator, type), node) : node;
	    }
	    ts.updateTypeOperatorNode = updateTypeOperatorNode;
	    function createIndexedAccessTypeNode(objectType, indexType) {
	        var node = createSynthesizedNode(175 /* IndexedAccessType */);
	        node.objectType = ts.parenthesizeElementTypeMember(objectType);
	        node.indexType = indexType;
	        return node;
	    }
	    ts.createIndexedAccessTypeNode = createIndexedAccessTypeNode;
	    function updateIndexedAccessTypeNode(node, objectType, indexType) {
	        return node.objectType !== objectType
	            || node.indexType !== indexType
	            ? updateNode(createIndexedAccessTypeNode(objectType, indexType), node)
	            : node;
	    }
	    ts.updateIndexedAccessTypeNode = updateIndexedAccessTypeNode;
	    function createMappedTypeNode(readonlyToken, typeParameter, questionToken, type) {
	        var node = createSynthesizedNode(176 /* MappedType */);
	        node.readonlyToken = readonlyToken;
	        node.typeParameter = typeParameter;
	        node.questionToken = questionToken;
	        node.type = type;
	        return node;
	    }
	    ts.createMappedTypeNode = createMappedTypeNode;
	    function updateMappedTypeNode(node, readonlyToken, typeParameter, questionToken, type) {
	        return node.readonlyToken !== readonlyToken
	            || node.typeParameter !== typeParameter
	            || node.questionToken !== questionToken
	            || node.type !== type
	            ? updateNode(createMappedTypeNode(readonlyToken, typeParameter, questionToken, type), node)
	            : node;
	    }
	    ts.updateMappedTypeNode = updateMappedTypeNode;
	    function createLiteralTypeNode(literal) {
	        var node = createSynthesizedNode(177 /* LiteralType */);
	        node.literal = literal;
	        return node;
	    }
	    ts.createLiteralTypeNode = createLiteralTypeNode;
	    function updateLiteralTypeNode(node, literal) {
	        return node.literal !== literal
	            ? updateNode(createLiteralTypeNode(literal), node)
	            : node;
	    }
	    ts.updateLiteralTypeNode = updateLiteralTypeNode;
	    // Binding Patterns
	    function createObjectBindingPattern(elements) {
	        var node = createSynthesizedNode(179 /* ObjectBindingPattern */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createObjectBindingPattern = createObjectBindingPattern;
	    function updateObjectBindingPattern(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createObjectBindingPattern(elements), node)
	            : node;
	    }
	    ts.updateObjectBindingPattern = updateObjectBindingPattern;
	    function createArrayBindingPattern(elements) {
	        var node = createSynthesizedNode(180 /* ArrayBindingPattern */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createArrayBindingPattern = createArrayBindingPattern;
	    function updateArrayBindingPattern(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createArrayBindingPattern(elements), node)
	            : node;
	    }
	    ts.updateArrayBindingPattern = updateArrayBindingPattern;
	    function createBindingElement(dotDotDotToken, propertyName, name, initializer) {
	        var node = createSynthesizedNode(181 /* BindingElement */);
	        node.dotDotDotToken = dotDotDotToken;
	        node.propertyName = asName(propertyName);
	        node.name = asName(name);
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createBindingElement = createBindingElement;
	    function updateBindingElement(node, dotDotDotToken, propertyName, name, initializer) {
	        return node.propertyName !== propertyName
	            || node.dotDotDotToken !== dotDotDotToken
	            || node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createBindingElement(dotDotDotToken, propertyName, name, initializer), node)
	            : node;
	    }
	    ts.updateBindingElement = updateBindingElement;
	    // Expression
	    function createArrayLiteral(elements, multiLine) {
	        var node = createSynthesizedNode(182 /* ArrayLiteralExpression */);
	        node.elements = ts.parenthesizeListElements(createNodeArray(elements));
	        if (multiLine)
	            node.multiLine = true;
	        return node;
	    }
	    ts.createArrayLiteral = createArrayLiteral;
	    function updateArrayLiteral(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createArrayLiteral(elements, node.multiLine), node)
	            : node;
	    }
	    ts.updateArrayLiteral = updateArrayLiteral;
	    function createObjectLiteral(properties, multiLine) {
	        var node = createSynthesizedNode(183 /* ObjectLiteralExpression */);
	        node.properties = createNodeArray(properties);
	        if (multiLine)
	            node.multiLine = true;
	        return node;
	    }
	    ts.createObjectLiteral = createObjectLiteral;
	    function updateObjectLiteral(node, properties) {
	        return node.properties !== properties
	            ? updateNode(createObjectLiteral(properties, node.multiLine), node)
	            : node;
	    }
	    ts.updateObjectLiteral = updateObjectLiteral;
	    function createPropertyAccess(expression, name) {
	        var node = createSynthesizedNode(184 /* PropertyAccessExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.name = asName(name);
	        setEmitFlags(node, 131072 /* NoIndentation */);
	        return node;
	    }
	    ts.createPropertyAccess = createPropertyAccess;
	    function updatePropertyAccess(node, expression, name) {
	        // Because we are updating existed propertyAccess we want to inherit its emitFlags
	        // instead of using the default from createPropertyAccess
	        return node.expression !== expression
	            || node.name !== name
	            ? updateNode(setEmitFlags(createPropertyAccess(expression, name), ts.getEmitFlags(node)), node)
	            : node;
	    }
	    ts.updatePropertyAccess = updatePropertyAccess;
	    function createElementAccess(expression, index) {
	        var node = createSynthesizedNode(185 /* ElementAccessExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.argumentExpression = asExpression(index);
	        return node;
	    }
	    ts.createElementAccess = createElementAccess;
	    function updateElementAccess(node, expression, argumentExpression) {
	        return node.expression !== expression
	            || node.argumentExpression !== argumentExpression
	            ? updateNode(createElementAccess(expression, argumentExpression), node)
	            : node;
	    }
	    ts.updateElementAccess = updateElementAccess;
	    function createCall(expression, typeArguments, argumentsArray) {
	        var node = createSynthesizedNode(186 /* CallExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        node.arguments = ts.parenthesizeListElements(createNodeArray(argumentsArray));
	        return node;
	    }
	    ts.createCall = createCall;
	    function updateCall(node, expression, typeArguments, argumentsArray) {
	        return node.expression !== expression
	            || node.typeArguments !== typeArguments
	            || node.arguments !== argumentsArray
	            ? updateNode(createCall(expression, typeArguments, argumentsArray), node)
	            : node;
	    }
	    ts.updateCall = updateCall;
	    function createNew(expression, typeArguments, argumentsArray) {
	        var node = createSynthesizedNode(187 /* NewExpression */);
	        node.expression = ts.parenthesizeForNew(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        node.arguments = argumentsArray ? ts.parenthesizeListElements(createNodeArray(argumentsArray)) : undefined;
	        return node;
	    }
	    ts.createNew = createNew;
	    function updateNew(node, expression, typeArguments, argumentsArray) {
	        return node.expression !== expression
	            || node.typeArguments !== typeArguments
	            || node.arguments !== argumentsArray
	            ? updateNode(createNew(expression, typeArguments, argumentsArray), node)
	            : node;
	    }
	    ts.updateNew = updateNew;
	    function createTaggedTemplate(tag, typeArgumentsOrTemplate, template) {
	        var node = createSynthesizedNode(188 /* TaggedTemplateExpression */);
	        node.tag = ts.parenthesizeForAccess(tag);
	        if (template) {
	            node.typeArguments = asNodeArray(typeArgumentsOrTemplate);
	            node.template = template;
	        }
	        else {
	            node.typeArguments = undefined;
	            node.template = typeArgumentsOrTemplate;
	        }
	        return node;
	    }
	    ts.createTaggedTemplate = createTaggedTemplate;
	    function updateTaggedTemplate(node, tag, typeArgumentsOrTemplate, template) {
	        return node.tag !== tag
	            || (template
	                ? node.typeArguments !== typeArgumentsOrTemplate || node.template !== template
	                : node.typeArguments !== undefined || node.template !== typeArgumentsOrTemplate)
	            ? updateNode(createTaggedTemplate(tag, typeArgumentsOrTemplate, template), node)
	            : node;
	    }
	    ts.updateTaggedTemplate = updateTaggedTemplate;
	    function createTypeAssertion(type, expression) {
	        var node = createSynthesizedNode(189 /* TypeAssertionExpression */);
	        node.type = type;
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createTypeAssertion = createTypeAssertion;
	    function updateTypeAssertion(node, type, expression) {
	        return node.type !== type
	            || node.expression !== expression
	            ? updateNode(createTypeAssertion(type, expression), node)
	            : node;
	    }
	    ts.updateTypeAssertion = updateTypeAssertion;
	    function createParen(expression) {
	        var node = createSynthesizedNode(190 /* ParenthesizedExpression */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createParen = createParen;
	    function updateParen(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createParen(expression), node)
	            : node;
	    }
	    ts.updateParen = updateParen;
	    function createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(191 /* FunctionExpression */);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createFunctionExpression = createFunctionExpression;
	    function updateFunctionExpression(node, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        return node.name !== name
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createFunctionExpression(modifiers, asteriskToken, name, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateFunctionExpression = updateFunctionExpression;
	    function createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body) {
	        var node = createSynthesizedNode(192 /* ArrowFunction */);
	        node.modifiers = asNodeArray(modifiers);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.equalsGreaterThanToken = equalsGreaterThanToken || createToken(36 /* EqualsGreaterThanToken */);
	        node.body = ts.parenthesizeConciseBody(body);
	        return node;
	    }
	    ts.createArrowFunction = createArrowFunction;
	    function updateArrowFunction(node, modifiers, typeParameters, parameters, type, equalsGreaterThanTokenOrBody, bodyOrUndefined) {
	        var equalsGreaterThanToken;
	        var body;
	        if (bodyOrUndefined === undefined) {
	            equalsGreaterThanToken = node.equalsGreaterThanToken;
	            body = ts.cast(equalsGreaterThanTokenOrBody, ts.isConciseBody);
	        }
	        else {
	            equalsGreaterThanToken = ts.cast(equalsGreaterThanTokenOrBody, function (n) {
	                return n.kind === 36 /* EqualsGreaterThanToken */;
	            });
	            body = bodyOrUndefined;
	        }
	        return node.modifiers !== modifiers
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.equalsGreaterThanToken !== equalsGreaterThanToken
	            || node.body !== body
	            ? updateNode(createArrowFunction(modifiers, typeParameters, parameters, type, equalsGreaterThanToken, body), node)
	            : node;
	    }
	    ts.updateArrowFunction = updateArrowFunction;
	    function createDelete(expression) {
	        var node = createSynthesizedNode(193 /* DeleteExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createDelete = createDelete;
	    function updateDelete(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createDelete(expression), node)
	            : node;
	    }
	    ts.updateDelete = updateDelete;
	    function createTypeOf(expression) {
	        var node = createSynthesizedNode(194 /* TypeOfExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createTypeOf = createTypeOf;
	    function updateTypeOf(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createTypeOf(expression), node)
	            : node;
	    }
	    ts.updateTypeOf = updateTypeOf;
	    function createVoid(expression) {
	        var node = createSynthesizedNode(195 /* VoidExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createVoid = createVoid;
	    function updateVoid(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createVoid(expression), node)
	            : node;
	    }
	    ts.updateVoid = updateVoid;
	    function createAwait(expression) {
	        var node = createSynthesizedNode(196 /* AwaitExpression */);
	        node.expression = ts.parenthesizePrefixOperand(expression);
	        return node;
	    }
	    ts.createAwait = createAwait;
	    function updateAwait(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createAwait(expression), node)
	            : node;
	    }
	    ts.updateAwait = updateAwait;
	    function createPrefix(operator, operand) {
	        var node = createSynthesizedNode(197 /* PrefixUnaryExpression */);
	        node.operator = operator;
	        node.operand = ts.parenthesizePrefixOperand(operand);
	        return node;
	    }
	    ts.createPrefix = createPrefix;
	    function updatePrefix(node, operand) {
	        return node.operand !== operand
	            ? updateNode(createPrefix(node.operator, operand), node)
	            : node;
	    }
	    ts.updatePrefix = updatePrefix;
	    function createPostfix(operand, operator) {
	        var node = createSynthesizedNode(198 /* PostfixUnaryExpression */);
	        node.operand = ts.parenthesizePostfixOperand(operand);
	        node.operator = operator;
	        return node;
	    }
	    ts.createPostfix = createPostfix;
	    function updatePostfix(node, operand) {
	        return node.operand !== operand
	            ? updateNode(createPostfix(operand, node.operator), node)
	            : node;
	    }
	    ts.updatePostfix = updatePostfix;
	    function createBinary(left, operator, right) {
	        var node = createSynthesizedNode(199 /* BinaryExpression */);
	        var operatorToken = asToken(operator);
	        var operatorKind = operatorToken.kind;
	        node.left = ts.parenthesizeBinaryOperand(operatorKind, left, /*isLeftSideOfBinary*/ true, /*leftOperand*/ undefined);
	        node.operatorToken = operatorToken;
	        node.right = ts.parenthesizeBinaryOperand(operatorKind, right, /*isLeftSideOfBinary*/ false, node.left);
	        return node;
	    }
	    ts.createBinary = createBinary;
	    function updateBinary(node, left, right, operator) {
	        return node.left !== left
	            || node.right !== right
	            ? updateNode(createBinary(left, operator || node.operatorToken, right), node)
	            : node;
	    }
	    ts.updateBinary = updateBinary;
	    function createConditional(condition, questionTokenOrWhenTrue, whenTrueOrWhenFalse, colonToken, whenFalse) {
	        var node = createSynthesizedNode(200 /* ConditionalExpression */);
	        node.condition = ts.parenthesizeForConditionalHead(condition);
	        node.questionToken = whenFalse ? questionTokenOrWhenTrue : createToken(55 /* QuestionToken */);
	        node.whenTrue = ts.parenthesizeSubexpressionOfConditionalExpression(whenFalse ? whenTrueOrWhenFalse : questionTokenOrWhenTrue);
	        node.colonToken = whenFalse ? colonToken : createToken(56 /* ColonToken */);
	        node.whenFalse = ts.parenthesizeSubexpressionOfConditionalExpression(whenFalse ? whenFalse : whenTrueOrWhenFalse);
	        return node;
	    }
	    ts.createConditional = createConditional;
	    function updateConditional(node, condition) {
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        if (args.length === 2) {
	            var whenTrue_1 = args[0], whenFalse_1 = args[1];
	            return updateConditional(node, condition, node.questionToken, whenTrue_1, node.colonToken, whenFalse_1);
	        }
	        ts.Debug.assert(args.length === 4);
	        var questionToken = args[0], whenTrue = args[1], colonToken = args[2], whenFalse = args[3];
	        return node.condition !== condition
	            || node.questionToken !== questionToken
	            || node.whenTrue !== whenTrue
	            || node.colonToken !== colonToken
	            || node.whenFalse !== whenFalse
	            ? updateNode(createConditional(condition, questionToken, whenTrue, colonToken, whenFalse), node)
	            : node;
	    }
	    ts.updateConditional = updateConditional;
	    function createTemplateExpression(head, templateSpans) {
	        var node = createSynthesizedNode(201 /* TemplateExpression */);
	        node.head = head;
	        node.templateSpans = createNodeArray(templateSpans);
	        return node;
	    }
	    ts.createTemplateExpression = createTemplateExpression;
	    function updateTemplateExpression(node, head, templateSpans) {
	        return node.head !== head
	            || node.templateSpans !== templateSpans
	            ? updateNode(createTemplateExpression(head, templateSpans), node)
	            : node;
	    }
	    ts.updateTemplateExpression = updateTemplateExpression;
	    function createTemplateHead(text) {
	        var node = createSynthesizedNode(14 /* TemplateHead */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateHead = createTemplateHead;
	    function createTemplateMiddle(text) {
	        var node = createSynthesizedNode(15 /* TemplateMiddle */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateMiddle = createTemplateMiddle;
	    function createTemplateTail(text) {
	        var node = createSynthesizedNode(16 /* TemplateTail */);
	        node.text = text;
	        return node;
	    }
	    ts.createTemplateTail = createTemplateTail;
	    function createNoSubstitutionTemplateLiteral(text) {
	        var node = createSynthesizedNode(13 /* NoSubstitutionTemplateLiteral */);
	        node.text = text;
	        return node;
	    }
	    ts.createNoSubstitutionTemplateLiteral = createNoSubstitutionTemplateLiteral;
	    function createYield(asteriskTokenOrExpression, expression) {
	        var node = createSynthesizedNode(202 /* YieldExpression */);
	        node.asteriskToken = asteriskTokenOrExpression && asteriskTokenOrExpression.kind === 39 /* AsteriskToken */ ? asteriskTokenOrExpression : undefined;
	        node.expression = asteriskTokenOrExpression && asteriskTokenOrExpression.kind !== 39 /* AsteriskToken */ ? asteriskTokenOrExpression : expression;
	        return node;
	    }
	    ts.createYield = createYield;
	    function updateYield(node, asteriskToken, expression) {
	        return node.expression !== expression
	            || node.asteriskToken !== asteriskToken
	            ? updateNode(createYield(asteriskToken, expression), node)
	            : node;
	    }
	    ts.updateYield = updateYield;
	    function createSpread(expression) {
	        var node = createSynthesizedNode(203 /* SpreadElement */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        return node;
	    }
	    ts.createSpread = createSpread;
	    function updateSpread(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createSpread(expression), node)
	            : node;
	    }
	    ts.updateSpread = updateSpread;
	    function createClassExpression(modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(204 /* ClassExpression */);
	        node.decorators = undefined;
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createClassExpression = createClassExpression;
	    function updateClassExpression(node, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createClassExpression(modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateClassExpression = updateClassExpression;
	    function createOmittedExpression() {
	        return createSynthesizedNode(205 /* OmittedExpression */);
	    }
	    ts.createOmittedExpression = createOmittedExpression;
	    function createExpressionWithTypeArguments(typeArguments, expression) {
	        var node = createSynthesizedNode(206 /* ExpressionWithTypeArguments */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        node.typeArguments = asNodeArray(typeArguments);
	        return node;
	    }
	    ts.createExpressionWithTypeArguments = createExpressionWithTypeArguments;
	    function updateExpressionWithTypeArguments(node, typeArguments, expression) {
	        return node.typeArguments !== typeArguments
	            || node.expression !== expression
	            ? updateNode(createExpressionWithTypeArguments(typeArguments, expression), node)
	            : node;
	    }
	    ts.updateExpressionWithTypeArguments = updateExpressionWithTypeArguments;
	    function createAsExpression(expression, type) {
	        var node = createSynthesizedNode(207 /* AsExpression */);
	        node.expression = expression;
	        node.type = type;
	        return node;
	    }
	    ts.createAsExpression = createAsExpression;
	    function updateAsExpression(node, expression, type) {
	        return node.expression !== expression
	            || node.type !== type
	            ? updateNode(createAsExpression(expression, type), node)
	            : node;
	    }
	    ts.updateAsExpression = updateAsExpression;
	    function createNonNullExpression(expression) {
	        var node = createSynthesizedNode(208 /* NonNullExpression */);
	        node.expression = ts.parenthesizeForAccess(expression);
	        return node;
	    }
	    ts.createNonNullExpression = createNonNullExpression;
	    function updateNonNullExpression(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createNonNullExpression(expression), node)
	            : node;
	    }
	    ts.updateNonNullExpression = updateNonNullExpression;
	    function createMetaProperty(keywordToken, name) {
	        var node = createSynthesizedNode(209 /* MetaProperty */);
	        node.keywordToken = keywordToken;
	        node.name = name;
	        return node;
	    }
	    ts.createMetaProperty = createMetaProperty;
	    function updateMetaProperty(node, name) {
	        return node.name !== name
	            ? updateNode(createMetaProperty(node.keywordToken, name), node)
	            : node;
	    }
	    ts.updateMetaProperty = updateMetaProperty;
	    // Misc
	    function createTemplateSpan(expression, literal) {
	        var node = createSynthesizedNode(210 /* TemplateSpan */);
	        node.expression = expression;
	        node.literal = literal;
	        return node;
	    }
	    ts.createTemplateSpan = createTemplateSpan;
	    function updateTemplateSpan(node, expression, literal) {
	        return node.expression !== expression
	            || node.literal !== literal
	            ? updateNode(createTemplateSpan(expression, literal), node)
	            : node;
	    }
	    ts.updateTemplateSpan = updateTemplateSpan;
	    function createSemicolonClassElement() {
	        return createSynthesizedNode(211 /* SemicolonClassElement */);
	    }
	    ts.createSemicolonClassElement = createSemicolonClassElement;
	    // Element
	    function createBlock(statements, multiLine) {
	        var block = createSynthesizedNode(212 /* Block */);
	        block.statements = createNodeArray(statements);
	        if (multiLine)
	            block.multiLine = multiLine;
	        return block;
	    }
	    ts.createBlock = createBlock;
	    /* @internal */
	    function createExpressionStatement(expression) {
	        var node = createSynthesizedNode(215 /* ExpressionStatement */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createExpressionStatement = createExpressionStatement;
	    function updateBlock(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createBlock(statements, node.multiLine), node)
	            : node;
	    }
	    ts.updateBlock = updateBlock;
	    function createVariableStatement(modifiers, declarationList) {
	        var node = createSynthesizedNode(213 /* VariableStatement */);
	        node.decorators = undefined;
	        node.modifiers = asNodeArray(modifiers);
	        node.declarationList = ts.isArray(declarationList) ? createVariableDeclarationList(declarationList) : declarationList;
	        return node;
	    }
	    ts.createVariableStatement = createVariableStatement;
	    function updateVariableStatement(node, modifiers, declarationList) {
	        return node.modifiers !== modifiers
	            || node.declarationList !== declarationList
	            ? updateNode(createVariableStatement(modifiers, declarationList), node)
	            : node;
	    }
	    ts.updateVariableStatement = updateVariableStatement;
	    function createEmptyStatement() {
	        return createSynthesizedNode(214 /* EmptyStatement */);
	    }
	    ts.createEmptyStatement = createEmptyStatement;
	    function createStatement(expression) {
	        return createExpressionStatement(ts.parenthesizeExpressionForExpressionStatement(expression));
	    }
	    ts.createStatement = createStatement;
	    function updateStatement(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createStatement(expression), node)
	            : node;
	    }
	    ts.updateStatement = updateStatement;
	    function createIf(expression, thenStatement, elseStatement) {
	        var node = createSynthesizedNode(216 /* IfStatement */);
	        node.expression = expression;
	        node.thenStatement = thenStatement;
	        node.elseStatement = elseStatement;
	        return node;
	    }
	    ts.createIf = createIf;
	    function updateIf(node, expression, thenStatement, elseStatement) {
	        return node.expression !== expression
	            || node.thenStatement !== thenStatement
	            || node.elseStatement !== elseStatement
	            ? updateNode(createIf(expression, thenStatement, elseStatement), node)
	            : node;
	    }
	    ts.updateIf = updateIf;
	    function createDo(statement, expression) {
	        var node = createSynthesizedNode(217 /* DoStatement */);
	        node.statement = statement;
	        node.expression = expression;
	        return node;
	    }
	    ts.createDo = createDo;
	    function updateDo(node, statement, expression) {
	        return node.statement !== statement
	            || node.expression !== expression
	            ? updateNode(createDo(statement, expression), node)
	            : node;
	    }
	    ts.updateDo = updateDo;
	    function createWhile(expression, statement) {
	        var node = createSynthesizedNode(218 /* WhileStatement */);
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createWhile = createWhile;
	    function updateWhile(node, expression, statement) {
	        return node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createWhile(expression, statement), node)
	            : node;
	    }
	    ts.updateWhile = updateWhile;
	    function createFor(initializer, condition, incrementor, statement) {
	        var node = createSynthesizedNode(219 /* ForStatement */);
	        node.initializer = initializer;
	        node.condition = condition;
	        node.incrementor = incrementor;
	        node.statement = statement;
	        return node;
	    }
	    ts.createFor = createFor;
	    function updateFor(node, initializer, condition, incrementor, statement) {
	        return node.initializer !== initializer
	            || node.condition !== condition
	            || node.incrementor !== incrementor
	            || node.statement !== statement
	            ? updateNode(createFor(initializer, condition, incrementor, statement), node)
	            : node;
	    }
	    ts.updateFor = updateFor;
	    function createForIn(initializer, expression, statement) {
	        var node = createSynthesizedNode(220 /* ForInStatement */);
	        node.initializer = initializer;
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createForIn = createForIn;
	    function updateForIn(node, initializer, expression, statement) {
	        return node.initializer !== initializer
	            || node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createForIn(initializer, expression, statement), node)
	            : node;
	    }
	    ts.updateForIn = updateForIn;
	    function createForOf(awaitModifier, initializer, expression, statement) {
	        var node = createSynthesizedNode(221 /* ForOfStatement */);
	        node.awaitModifier = awaitModifier;
	        node.initializer = initializer;
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createForOf = createForOf;
	    function updateForOf(node, awaitModifier, initializer, expression, statement) {
	        return node.awaitModifier !== awaitModifier
	            || node.initializer !== initializer
	            || node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createForOf(awaitModifier, initializer, expression, statement), node)
	            : node;
	    }
	    ts.updateForOf = updateForOf;
	    function createContinue(label) {
	        var node = createSynthesizedNode(222 /* ContinueStatement */);
	        node.label = asName(label);
	        return node;
	    }
	    ts.createContinue = createContinue;
	    function updateContinue(node, label) {
	        return node.label !== label
	            ? updateNode(createContinue(label), node)
	            : node;
	    }
	    ts.updateContinue = updateContinue;
	    function createBreak(label) {
	        var node = createSynthesizedNode(223 /* BreakStatement */);
	        node.label = asName(label);
	        return node;
	    }
	    ts.createBreak = createBreak;
	    function updateBreak(node, label) {
	        return node.label !== label
	            ? updateNode(createBreak(label), node)
	            : node;
	    }
	    ts.updateBreak = updateBreak;
	    function createReturn(expression) {
	        var node = createSynthesizedNode(224 /* ReturnStatement */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createReturn = createReturn;
	    function updateReturn(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createReturn(expression), node)
	            : node;
	    }
	    ts.updateReturn = updateReturn;
	    function createWith(expression, statement) {
	        var node = createSynthesizedNode(225 /* WithStatement */);
	        node.expression = expression;
	        node.statement = statement;
	        return node;
	    }
	    ts.createWith = createWith;
	    function updateWith(node, expression, statement) {
	        return node.expression !== expression
	            || node.statement !== statement
	            ? updateNode(createWith(expression, statement), node)
	            : node;
	    }
	    ts.updateWith = updateWith;
	    function createSwitch(expression, caseBlock) {
	        var node = createSynthesizedNode(226 /* SwitchStatement */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        node.caseBlock = caseBlock;
	        return node;
	    }
	    ts.createSwitch = createSwitch;
	    function updateSwitch(node, expression, caseBlock) {
	        return node.expression !== expression
	            || node.caseBlock !== caseBlock
	            ? updateNode(createSwitch(expression, caseBlock), node)
	            : node;
	    }
	    ts.updateSwitch = updateSwitch;
	    function createLabel(label, statement) {
	        var node = createSynthesizedNode(227 /* LabeledStatement */);
	        node.label = asName(label);
	        node.statement = statement;
	        return node;
	    }
	    ts.createLabel = createLabel;
	    function updateLabel(node, label, statement) {
	        return node.label !== label
	            || node.statement !== statement
	            ? updateNode(createLabel(label, statement), node)
	            : node;
	    }
	    ts.updateLabel = updateLabel;
	    function createThrow(expression) {
	        var node = createSynthesizedNode(228 /* ThrowStatement */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createThrow = createThrow;
	    function updateThrow(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createThrow(expression), node)
	            : node;
	    }
	    ts.updateThrow = updateThrow;
	    function createTry(tryBlock, catchClause, finallyBlock) {
	        var node = createSynthesizedNode(229 /* TryStatement */);
	        node.tryBlock = tryBlock;
	        node.catchClause = catchClause;
	        node.finallyBlock = finallyBlock;
	        return node;
	    }
	    ts.createTry = createTry;
	    function updateTry(node, tryBlock, catchClause, finallyBlock) {
	        return node.tryBlock !== tryBlock
	            || node.catchClause !== catchClause
	            || node.finallyBlock !== finallyBlock
	            ? updateNode(createTry(tryBlock, catchClause, finallyBlock), node)
	            : node;
	    }
	    ts.updateTry = updateTry;
	    function createDebuggerStatement() {
	        return createSynthesizedNode(230 /* DebuggerStatement */);
	    }
	    ts.createDebuggerStatement = createDebuggerStatement;
	    function createVariableDeclaration(name, type, initializer) {
	        var node = createSynthesizedNode(231 /* VariableDeclaration */);
	        node.name = asName(name);
	        node.type = type;
	        node.initializer = initializer !== undefined ? ts.parenthesizeExpressionForList(initializer) : undefined;
	        return node;
	    }
	    ts.createVariableDeclaration = createVariableDeclaration;
	    function updateVariableDeclaration(node, name, type, initializer) {
	        return node.name !== name
	            || node.type !== type
	            || node.initializer !== initializer
	            ? updateNode(createVariableDeclaration(name, type, initializer), node)
	            : node;
	    }
	    ts.updateVariableDeclaration = updateVariableDeclaration;
	    function createVariableDeclarationList(declarations, flags) {
	        var node = createSynthesizedNode(232 /* VariableDeclarationList */);
	        node.flags |= flags & 3 /* BlockScoped */;
	        node.declarations = createNodeArray(declarations);
	        return node;
	    }
	    ts.createVariableDeclarationList = createVariableDeclarationList;
	    function updateVariableDeclarationList(node, declarations) {
	        return node.declarations !== declarations
	            ? updateNode(createVariableDeclarationList(declarations, node.flags), node)
	            : node;
	    }
	    ts.updateVariableDeclarationList = updateVariableDeclarationList;
	    function createFunctionDeclaration(decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        var node = createSynthesizedNode(233 /* FunctionDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.asteriskToken = asteriskToken;
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.parameters = createNodeArray(parameters);
	        node.type = type;
	        node.body = body;
	        return node;
	    }
	    ts.createFunctionDeclaration = createFunctionDeclaration;
	    function updateFunctionDeclaration(node, decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.asteriskToken !== asteriskToken
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.parameters !== parameters
	            || node.type !== type
	            || node.body !== body
	            ? updateNode(createFunctionDeclaration(decorators, modifiers, asteriskToken, name, typeParameters, parameters, type, body), node)
	            : node;
	    }
	    ts.updateFunctionDeclaration = updateFunctionDeclaration;
	    function createClassDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(234 /* ClassDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createClassDeclaration = createClassDeclaration;
	    function updateClassDeclaration(node, decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createClassDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateClassDeclaration = updateClassDeclaration;
	    function createInterfaceDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        var node = createSynthesizedNode(235 /* InterfaceDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.heritageClauses = asNodeArray(heritageClauses);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createInterfaceDeclaration = createInterfaceDeclaration;
	    function updateInterfaceDeclaration(node, decorators, modifiers, name, typeParameters, heritageClauses, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.heritageClauses !== heritageClauses
	            || node.members !== members
	            ? updateNode(createInterfaceDeclaration(decorators, modifiers, name, typeParameters, heritageClauses, members), node)
	            : node;
	    }
	    ts.updateInterfaceDeclaration = updateInterfaceDeclaration;
	    function createTypeAliasDeclaration(decorators, modifiers, name, typeParameters, type) {
	        var node = createSynthesizedNode(236 /* TypeAliasDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.typeParameters = asNodeArray(typeParameters);
	        node.type = type;
	        return node;
	    }
	    ts.createTypeAliasDeclaration = createTypeAliasDeclaration;
	    function updateTypeAliasDeclaration(node, decorators, modifiers, name, typeParameters, type) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.typeParameters !== typeParameters
	            || node.type !== type
	            ? updateNode(createTypeAliasDeclaration(decorators, modifiers, name, typeParameters, type), node)
	            : node;
	    }
	    ts.updateTypeAliasDeclaration = updateTypeAliasDeclaration;
	    function createEnumDeclaration(decorators, modifiers, name, members) {
	        var node = createSynthesizedNode(237 /* EnumDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.members = createNodeArray(members);
	        return node;
	    }
	    ts.createEnumDeclaration = createEnumDeclaration;
	    function updateEnumDeclaration(node, decorators, modifiers, name, members) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.members !== members
	            ? updateNode(createEnumDeclaration(decorators, modifiers, name, members), node)
	            : node;
	    }
	    ts.updateEnumDeclaration = updateEnumDeclaration;
	    function createModuleDeclaration(decorators, modifiers, name, body, flags) {
	        var node = createSynthesizedNode(238 /* ModuleDeclaration */);
	        node.flags |= flags & (16 /* Namespace */ | 4 /* NestedNamespace */ | 512 /* GlobalAugmentation */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = name;
	        node.body = body;
	        return node;
	    }
	    ts.createModuleDeclaration = createModuleDeclaration;
	    function updateModuleDeclaration(node, decorators, modifiers, name, body) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.body !== body
	            ? updateNode(createModuleDeclaration(decorators, modifiers, name, body, node.flags), node)
	            : node;
	    }
	    ts.updateModuleDeclaration = updateModuleDeclaration;
	    function createModuleBlock(statements) {
	        var node = createSynthesizedNode(239 /* ModuleBlock */);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createModuleBlock = createModuleBlock;
	    function updateModuleBlock(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createModuleBlock(statements), node)
	            : node;
	    }
	    ts.updateModuleBlock = updateModuleBlock;
	    function createCaseBlock(clauses) {
	        var node = createSynthesizedNode(240 /* CaseBlock */);
	        node.clauses = createNodeArray(clauses);
	        return node;
	    }
	    ts.createCaseBlock = createCaseBlock;
	    function updateCaseBlock(node, clauses) {
	        return node.clauses !== clauses
	            ? updateNode(createCaseBlock(clauses), node)
	            : node;
	    }
	    ts.updateCaseBlock = updateCaseBlock;
	    function createNamespaceExportDeclaration(name) {
	        var node = createSynthesizedNode(241 /* NamespaceExportDeclaration */);
	        node.name = asName(name);
	        return node;
	    }
	    ts.createNamespaceExportDeclaration = createNamespaceExportDeclaration;
	    function updateNamespaceExportDeclaration(node, name) {
	        return node.name !== name
	            ? updateNode(createNamespaceExportDeclaration(name), node)
	            : node;
	    }
	    ts.updateNamespaceExportDeclaration = updateNamespaceExportDeclaration;
	    function createImportEqualsDeclaration(decorators, modifiers, name, moduleReference) {
	        var node = createSynthesizedNode(242 /* ImportEqualsDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.name = asName(name);
	        node.moduleReference = moduleReference;
	        return node;
	    }
	    ts.createImportEqualsDeclaration = createImportEqualsDeclaration;
	    function updateImportEqualsDeclaration(node, decorators, modifiers, name, moduleReference) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.name !== name
	            || node.moduleReference !== moduleReference
	            ? updateNode(createImportEqualsDeclaration(decorators, modifiers, name, moduleReference), node)
	            : node;
	    }
	    ts.updateImportEqualsDeclaration = updateImportEqualsDeclaration;
	    function createImportDeclaration(decorators, modifiers, importClause, moduleSpecifier) {
	        var node = createSynthesizedNode(243 /* ImportDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.importClause = importClause;
	        node.moduleSpecifier = moduleSpecifier;
	        return node;
	    }
	    ts.createImportDeclaration = createImportDeclaration;
	    function updateImportDeclaration(node, decorators, modifiers, importClause, moduleSpecifier) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.importClause !== importClause
	            || node.moduleSpecifier !== moduleSpecifier
	            ? updateNode(createImportDeclaration(decorators, modifiers, importClause, moduleSpecifier), node)
	            : node;
	    }
	    ts.updateImportDeclaration = updateImportDeclaration;
	    function createImportClause(name, namedBindings) {
	        var node = createSynthesizedNode(244 /* ImportClause */);
	        node.name = name;
	        node.namedBindings = namedBindings;
	        return node;
	    }
	    ts.createImportClause = createImportClause;
	    function updateImportClause(node, name, namedBindings) {
	        return node.name !== name
	            || node.namedBindings !== namedBindings
	            ? updateNode(createImportClause(name, namedBindings), node)
	            : node;
	    }
	    ts.updateImportClause = updateImportClause;
	    function createNamespaceImport(name) {
	        var node = createSynthesizedNode(245 /* NamespaceImport */);
	        node.name = name;
	        return node;
	    }
	    ts.createNamespaceImport = createNamespaceImport;
	    function updateNamespaceImport(node, name) {
	        return node.name !== name
	            ? updateNode(createNamespaceImport(name), node)
	            : node;
	    }
	    ts.updateNamespaceImport = updateNamespaceImport;
	    function createNamedImports(elements) {
	        var node = createSynthesizedNode(246 /* NamedImports */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createNamedImports = createNamedImports;
	    function updateNamedImports(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createNamedImports(elements), node)
	            : node;
	    }
	    ts.updateNamedImports = updateNamedImports;
	    function createImportSpecifier(propertyName, name) {
	        var node = createSynthesizedNode(247 /* ImportSpecifier */);
	        node.propertyName = propertyName;
	        node.name = name;
	        return node;
	    }
	    ts.createImportSpecifier = createImportSpecifier;
	    function updateImportSpecifier(node, propertyName, name) {
	        return node.propertyName !== propertyName
	            || node.name !== name
	            ? updateNode(createImportSpecifier(propertyName, name), node)
	            : node;
	    }
	    ts.updateImportSpecifier = updateImportSpecifier;
	    function createExportAssignment(decorators, modifiers, isExportEquals, expression) {
	        var node = createSynthesizedNode(248 /* ExportAssignment */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.isExportEquals = isExportEquals;
	        node.expression = isExportEquals ? ts.parenthesizeBinaryOperand(58 /* EqualsToken */, expression, /*isLeftSideOfBinary*/ false, /*leftOperand*/ undefined) : ts.parenthesizeDefaultExpression(expression);
	        return node;
	    }
	    ts.createExportAssignment = createExportAssignment;
	    function updateExportAssignment(node, decorators, modifiers, expression) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.expression !== expression
	            ? updateNode(createExportAssignment(decorators, modifiers, node.isExportEquals, expression), node)
	            : node;
	    }
	    ts.updateExportAssignment = updateExportAssignment;
	    function createExportDeclaration(decorators, modifiers, exportClause, moduleSpecifier) {
	        var node = createSynthesizedNode(249 /* ExportDeclaration */);
	        node.decorators = asNodeArray(decorators);
	        node.modifiers = asNodeArray(modifiers);
	        node.exportClause = exportClause;
	        node.moduleSpecifier = moduleSpecifier;
	        return node;
	    }
	    ts.createExportDeclaration = createExportDeclaration;
	    function updateExportDeclaration(node, decorators, modifiers, exportClause, moduleSpecifier) {
	        return node.decorators !== decorators
	            || node.modifiers !== modifiers
	            || node.exportClause !== exportClause
	            || node.moduleSpecifier !== moduleSpecifier
	            ? updateNode(createExportDeclaration(decorators, modifiers, exportClause, moduleSpecifier), node)
	            : node;
	    }
	    ts.updateExportDeclaration = updateExportDeclaration;
	    function createNamedExports(elements) {
	        var node = createSynthesizedNode(250 /* NamedExports */);
	        node.elements = createNodeArray(elements);
	        return node;
	    }
	    ts.createNamedExports = createNamedExports;
	    function updateNamedExports(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createNamedExports(elements), node)
	            : node;
	    }
	    ts.updateNamedExports = updateNamedExports;
	    function createExportSpecifier(propertyName, name) {
	        var node = createSynthesizedNode(251 /* ExportSpecifier */);
	        node.propertyName = asName(propertyName);
	        node.name = asName(name);
	        return node;
	    }
	    ts.createExportSpecifier = createExportSpecifier;
	    function updateExportSpecifier(node, propertyName, name) {
	        return node.propertyName !== propertyName
	            || node.name !== name
	            ? updateNode(createExportSpecifier(propertyName, name), node)
	            : node;
	    }
	    ts.updateExportSpecifier = updateExportSpecifier;
	    // Module references
	    function createExternalModuleReference(expression) {
	        var node = createSynthesizedNode(253 /* ExternalModuleReference */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createExternalModuleReference = createExternalModuleReference;
	    function updateExternalModuleReference(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createExternalModuleReference(expression), node)
	            : node;
	    }
	    ts.updateExternalModuleReference = updateExternalModuleReference;
	    // JSX
	    function createJsxElement(openingElement, children, closingElement) {
	        var node = createSynthesizedNode(254 /* JsxElement */);
	        node.openingElement = openingElement;
	        node.children = createNodeArray(children);
	        node.closingElement = closingElement;
	        return node;
	    }
	    ts.createJsxElement = createJsxElement;
	    function updateJsxElement(node, openingElement, children, closingElement) {
	        return node.openingElement !== openingElement
	            || node.children !== children
	            || node.closingElement !== closingElement
	            ? updateNode(createJsxElement(openingElement, children, closingElement), node)
	            : node;
	    }
	    ts.updateJsxElement = updateJsxElement;
	    function createJsxSelfClosingElement(tagName, typeArguments, attributes) {
	        var node = createSynthesizedNode(255 /* JsxSelfClosingElement */);
	        node.tagName = tagName;
	        node.typeArguments = typeArguments && createNodeArray(typeArguments);
	        node.attributes = attributes;
	        return node;
	    }
	    ts.createJsxSelfClosingElement = createJsxSelfClosingElement;
	    function updateJsxSelfClosingElement(node, tagName, typeArguments, attributes) {
	        return node.tagName !== tagName
	            || node.typeArguments !== typeArguments
	            || node.attributes !== attributes
	            ? updateNode(createJsxSelfClosingElement(tagName, typeArguments, attributes), node)
	            : node;
	    }
	    ts.updateJsxSelfClosingElement = updateJsxSelfClosingElement;
	    function createJsxOpeningElement(tagName, typeArguments, attributes) {
	        var node = createSynthesizedNode(256 /* JsxOpeningElement */);
	        node.tagName = tagName;
	        node.typeArguments = typeArguments && createNodeArray(typeArguments);
	        node.attributes = attributes;
	        return node;
	    }
	    ts.createJsxOpeningElement = createJsxOpeningElement;
	    function updateJsxOpeningElement(node, tagName, typeArguments, attributes) {
	        return node.tagName !== tagName
	            || node.typeArguments !== typeArguments
	            || node.attributes !== attributes
	            ? updateNode(createJsxOpeningElement(tagName, typeArguments, attributes), node)
	            : node;
	    }
	    ts.updateJsxOpeningElement = updateJsxOpeningElement;
	    function createJsxClosingElement(tagName) {
	        var node = createSynthesizedNode(257 /* JsxClosingElement */);
	        node.tagName = tagName;
	        return node;
	    }
	    ts.createJsxClosingElement = createJsxClosingElement;
	    function updateJsxClosingElement(node, tagName) {
	        return node.tagName !== tagName
	            ? updateNode(createJsxClosingElement(tagName), node)
	            : node;
	    }
	    ts.updateJsxClosingElement = updateJsxClosingElement;
	    function createJsxFragment(openingFragment, children, closingFragment) {
	        var node = createSynthesizedNode(258 /* JsxFragment */);
	        node.openingFragment = openingFragment;
	        node.children = createNodeArray(children);
	        node.closingFragment = closingFragment;
	        return node;
	    }
	    ts.createJsxFragment = createJsxFragment;
	    function updateJsxFragment(node, openingFragment, children, closingFragment) {
	        return node.openingFragment !== openingFragment
	            || node.children !== children
	            || node.closingFragment !== closingFragment
	            ? updateNode(createJsxFragment(openingFragment, children, closingFragment), node)
	            : node;
	    }
	    ts.updateJsxFragment = updateJsxFragment;
	    function createJsxAttribute(name, initializer) {
	        var node = createSynthesizedNode(261 /* JsxAttribute */);
	        node.name = name;
	        node.initializer = initializer;
	        return node;
	    }
	    ts.createJsxAttribute = createJsxAttribute;
	    function updateJsxAttribute(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createJsxAttribute(name, initializer), node)
	            : node;
	    }
	    ts.updateJsxAttribute = updateJsxAttribute;
	    function createJsxAttributes(properties) {
	        var node = createSynthesizedNode(262 /* JsxAttributes */);
	        node.properties = createNodeArray(properties);
	        return node;
	    }
	    ts.createJsxAttributes = createJsxAttributes;
	    function updateJsxAttributes(node, properties) {
	        return node.properties !== properties
	            ? updateNode(createJsxAttributes(properties), node)
	            : node;
	    }
	    ts.updateJsxAttributes = updateJsxAttributes;
	    function createJsxSpreadAttribute(expression) {
	        var node = createSynthesizedNode(263 /* JsxSpreadAttribute */);
	        node.expression = expression;
	        return node;
	    }
	    ts.createJsxSpreadAttribute = createJsxSpreadAttribute;
	    function updateJsxSpreadAttribute(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createJsxSpreadAttribute(expression), node)
	            : node;
	    }
	    ts.updateJsxSpreadAttribute = updateJsxSpreadAttribute;
	    function createJsxExpression(dotDotDotToken, expression) {
	        var node = createSynthesizedNode(264 /* JsxExpression */);
	        node.dotDotDotToken = dotDotDotToken;
	        node.expression = expression;
	        return node;
	    }
	    ts.createJsxExpression = createJsxExpression;
	    function updateJsxExpression(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createJsxExpression(node.dotDotDotToken, expression), node)
	            : node;
	    }
	    ts.updateJsxExpression = updateJsxExpression;
	    // Clauses
	    function createCaseClause(expression, statements) {
	        var node = createSynthesizedNode(265 /* CaseClause */);
	        node.expression = ts.parenthesizeExpressionForList(expression);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createCaseClause = createCaseClause;
	    function updateCaseClause(node, expression, statements) {
	        return node.expression !== expression
	            || node.statements !== statements
	            ? updateNode(createCaseClause(expression, statements), node)
	            : node;
	    }
	    ts.updateCaseClause = updateCaseClause;
	    function createDefaultClause(statements) {
	        var node = createSynthesizedNode(266 /* DefaultClause */);
	        node.statements = createNodeArray(statements);
	        return node;
	    }
	    ts.createDefaultClause = createDefaultClause;
	    function updateDefaultClause(node, statements) {
	        return node.statements !== statements
	            ? updateNode(createDefaultClause(statements), node)
	            : node;
	    }
	    ts.updateDefaultClause = updateDefaultClause;
	    function createHeritageClause(token, types) {
	        var node = createSynthesizedNode(267 /* HeritageClause */);
	        node.token = token;
	        node.types = createNodeArray(types);
	        return node;
	    }
	    ts.createHeritageClause = createHeritageClause;
	    function updateHeritageClause(node, types) {
	        return node.types !== types
	            ? updateNode(createHeritageClause(node.token, types), node)
	            : node;
	    }
	    ts.updateHeritageClause = updateHeritageClause;
	    function createCatchClause(variableDeclaration, block) {
	        var node = createSynthesizedNode(268 /* CatchClause */);
	        node.variableDeclaration = ts.isString(variableDeclaration) ? createVariableDeclaration(variableDeclaration) : variableDeclaration;
	        node.block = block;
	        return node;
	    }
	    ts.createCatchClause = createCatchClause;
	    function updateCatchClause(node, variableDeclaration, block) {
	        return node.variableDeclaration !== variableDeclaration
	            || node.block !== block
	            ? updateNode(createCatchClause(variableDeclaration, block), node)
	            : node;
	    }
	    ts.updateCatchClause = updateCatchClause;
	    // Property assignments
	    function createPropertyAssignment(name, initializer) {
	        var node = createSynthesizedNode(269 /* PropertyAssignment */);
	        node.name = asName(name);
	        node.questionToken = undefined;
	        node.initializer = ts.parenthesizeExpressionForList(initializer);
	        return node;
	    }
	    ts.createPropertyAssignment = createPropertyAssignment;
	    function updatePropertyAssignment(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createPropertyAssignment(name, initializer), node)
	            : node;
	    }
	    ts.updatePropertyAssignment = updatePropertyAssignment;
	    function createShorthandPropertyAssignment(name, objectAssignmentInitializer) {
	        var node = createSynthesizedNode(270 /* ShorthandPropertyAssignment */);
	        node.name = asName(name);
	        node.objectAssignmentInitializer = objectAssignmentInitializer !== undefined ? ts.parenthesizeExpressionForList(objectAssignmentInitializer) : undefined;
	        return node;
	    }
	    ts.createShorthandPropertyAssignment = createShorthandPropertyAssignment;
	    function updateShorthandPropertyAssignment(node, name, objectAssignmentInitializer) {
	        return node.name !== name
	            || node.objectAssignmentInitializer !== objectAssignmentInitializer
	            ? updateNode(createShorthandPropertyAssignment(name, objectAssignmentInitializer), node)
	            : node;
	    }
	    ts.updateShorthandPropertyAssignment = updateShorthandPropertyAssignment;
	    function createSpreadAssignment(expression) {
	        var node = createSynthesizedNode(271 /* SpreadAssignment */);
	        node.expression = expression !== undefined ? ts.parenthesizeExpressionForList(expression) : undefined;
	        return node;
	    }
	    ts.createSpreadAssignment = createSpreadAssignment;
	    function updateSpreadAssignment(node, expression) {
	        return node.expression !== expression
	            ? updateNode(createSpreadAssignment(expression), node)
	            : node;
	    }
	    ts.updateSpreadAssignment = updateSpreadAssignment;
	    // Enum
	    function createEnumMember(name, initializer) {
	        var node = createSynthesizedNode(272 /* EnumMember */);
	        node.name = asName(name);
	        node.initializer = initializer && ts.parenthesizeExpressionForList(initializer);
	        return node;
	    }
	    ts.createEnumMember = createEnumMember;
	    function updateEnumMember(node, name, initializer) {
	        return node.name !== name
	            || node.initializer !== initializer
	            ? updateNode(createEnumMember(name, initializer), node)
	            : node;
	    }
	    ts.updateEnumMember = updateEnumMember;
	    // Top-level nodes
	    function updateSourceFileNode(node, statements, isDeclarationFile, referencedFiles, typeReferences, hasNoDefaultLib) {
	        if (node.statements !== statements ||
	            (isDeclarationFile !== undefined && node.isDeclarationFile !== isDeclarationFile) ||
	            (referencedFiles !== undefined && node.referencedFiles !== referencedFiles) ||
	            (typeReferences !== undefined && node.typeReferenceDirectives !== typeReferences) ||
	            (hasNoDefaultLib !== undefined && node.hasNoDefaultLib !== hasNoDefaultLib)) {
	            var updated = createSynthesizedNode(273 /* SourceFile */);
	            updated.flags |= node.flags;
	            updated.statements = createNodeArray(statements);
	            updated.endOfFileToken = node.endOfFileToken;
	            updated.fileName = node.fileName;
	            updated.path = node.path;
	            updated.text = node.text;
	            updated.isDeclarationFile = isDeclarationFile === undefined ? node.isDeclarationFile : isDeclarationFile;
	            updated.referencedFiles = referencedFiles === undefined ? node.referencedFiles : referencedFiles;
	            updated.typeReferenceDirectives = typeReferences === undefined ? node.typeReferenceDirectives : typeReferences;
	            updated.hasNoDefaultLib = hasNoDefaultLib === undefined ? node.hasNoDefaultLib : hasNoDefaultLib;
	            if (node.amdDependencies !== undefined)
	                updated.amdDependencies = node.amdDependencies;
	            if (node.moduleName !== undefined)
	                updated.moduleName = node.moduleName;
	            if (node.languageVariant !== undefined)
	                updated.languageVariant = node.languageVariant;
	            if (node.renamedDependencies !== undefined)
	                updated.renamedDependencies = node.renamedDependencies;
	            if (node.languageVersion !== undefined)
	                updated.languageVersion = node.languageVersion;
	            if (node.scriptKind !== undefined)
	                updated.scriptKind = node.scriptKind;
	            if (node.externalModuleIndicator !== undefined)
	                updated.externalModuleIndicator = node.externalModuleIndicator;
	            if (node.commonJsModuleIndicator !== undefined)
	                updated.commonJsModuleIndicator = node.commonJsModuleIndicator;
	            if (node.identifiers !== undefined)
	                updated.identifiers = node.identifiers;
	            if (node.nodeCount !== undefined)
	                updated.nodeCount = node.nodeCount;
	            if (node.identifierCount !== undefined)
	                updated.identifierCount = node.identifierCount;
	            if (node.symbolCount !== undefined)
	                updated.symbolCount = node.symbolCount;
	            if (node.parseDiagnostics !== undefined)
	                updated.parseDiagnostics = node.parseDiagnostics;
	            if (node.bindDiagnostics !== undefined)
	                updated.bindDiagnostics = node.bindDiagnostics;
	            if (node.bindSuggestionDiagnostics !== undefined)
	                updated.bindSuggestionDiagnostics = node.bindSuggestionDiagnostics;
	            if (node.lineMap !== undefined)
	                updated.lineMap = node.lineMap;
	            if (node.classifiableNames !== undefined)
	                updated.classifiableNames = node.classifiableNames;
	            if (node.resolvedModules !== undefined)
	                updated.resolvedModules = node.resolvedModules;
	            if (node.resolvedTypeReferenceDirectiveNames !== undefined)
	                updated.resolvedTypeReferenceDirectiveNames = node.resolvedTypeReferenceDirectiveNames;
	            if (node.imports !== undefined)
	                updated.imports = node.imports;
	            if (node.moduleAugmentations !== undefined)
	                updated.moduleAugmentations = node.moduleAugmentations;
	            if (node.pragmas !== undefined)
	                updated.pragmas = node.pragmas;
	            if (node.localJsxFactory !== undefined)
	                updated.localJsxFactory = node.localJsxFactory;
	            if (node.localJsxNamespace !== undefined)
	                updated.localJsxNamespace = node.localJsxNamespace;
	            return updateNode(updated, node);
	        }
	        return node;
	    }
	    ts.updateSourceFileNode = updateSourceFileNode;
	    /**
	     * Creates a shallow, memberwise clone of a node for mutation.
	     */
	    function getMutableClone(node) {
	        var clone = getSynthesizedClone(node);
	        clone.pos = node.pos;
	        clone.end = node.end;
	        clone.parent = node.parent;
	        return clone;
	    }
	    ts.getMutableClone = getMutableClone;
	    // Transformation nodes
	    /**
	     * Creates a synthetic statement to act as a placeholder for a not-emitted statement in
	     * order to preserve comments.
	     *
	     * @param original The original statement.
	     */
	    function createNotEmittedStatement(original) {
	        var node = createSynthesizedNode(299 /* NotEmittedStatement */);
	        node.original = original;
	        setTextRange(node, original);
	        return node;
	    }
	    ts.createNotEmittedStatement = createNotEmittedStatement;
	    /**
	     * Creates a synthetic element to act as a placeholder for the end of an emitted declaration in
	     * order to properly emit exports.
	     */
	    /* @internal */
	    function createEndOfDeclarationMarker(original) {
	        var node = createSynthesizedNode(303 /* EndOfDeclarationMarker */);
	        node.emitNode = {};
	        node.original = original;
	        return node;
	    }
	    ts.createEndOfDeclarationMarker = createEndOfDeclarationMarker;
	    /**
	     * Creates a synthetic element to act as a placeholder for the beginning of a merged declaration in
	     * order to properly emit exports.
	     */
	    /* @internal */
	    function createMergeDeclarationMarker(original) {
	        var node = createSynthesizedNode(302 /* MergeDeclarationMarker */);
	        node.emitNode = {};
	        node.original = original;
	        return node;
	    }
	    ts.createMergeDeclarationMarker = createMergeDeclarationMarker;
	    /**
	     * Creates a synthetic expression to act as a placeholder for a not-emitted expression in
	     * order to preserve comments or sourcemap positions.
	     *
	     * @param expression The inner expression to emit.
	     * @param original The original outer expression.
	     * @param location The location for the expression. Defaults to the positions from "original" if provided.
	     */
	    function createPartiallyEmittedExpression(expression, original) {
	        var node = createSynthesizedNode(300 /* PartiallyEmittedExpression */);
	        node.expression = expression;
	        node.original = original;
	        setTextRange(node, original);
	        return node;
	    }
	    ts.createPartiallyEmittedExpression = createPartiallyEmittedExpression;
	    function updatePartiallyEmittedExpression(node, expression) {
	        if (node.expression !== expression) {
	            return updateNode(createPartiallyEmittedExpression(expression, node.original), node);
	        }
	        return node;
	    }
	    ts.updatePartiallyEmittedExpression = updatePartiallyEmittedExpression;
	    function flattenCommaElements(node) {
	        if (ts.nodeIsSynthesized(node) && !ts.isParseTreeNode(node) && !node.original && !node.emitNode && !node.id) {
	            if (node.kind === 301 /* CommaListExpression */) {
	                return node.elements;
	            }
	            if (ts.isBinaryExpression(node) && node.operatorToken.kind === 26 /* CommaToken */) {
	                return [node.left, node.right];
	            }
	        }
	        return node;
	    }
	    function createCommaList(elements) {
	        var node = createSynthesizedNode(301 /* CommaListExpression */);
	        node.elements = createNodeArray(ts.sameFlatMap(elements, flattenCommaElements));
	        return node;
	    }
	    ts.createCommaList = createCommaList;
	    function updateCommaList(node, elements) {
	        return node.elements !== elements
	            ? updateNode(createCommaList(elements), node)
	            : node;
	    }
	    ts.updateCommaList = updateCommaList;
	    function createBundle(sourceFiles, prepends) {
	        if (prepends === void 0) { prepends = ts.emptyArray; }
	        var node = ts.createNode(274 /* Bundle */);
	        node.prepends = prepends;
	        node.sourceFiles = sourceFiles;
	        return node;
	    }
	    ts.createBundle = createBundle;
	    function createUnparsedSourceFile(text) {
	        var node = ts.createNode(275 /* UnparsedSource */);
	        node.text = text;
	        return node;
	    }
	    ts.createUnparsedSourceFile = createUnparsedSourceFile;
	    function createInputFiles(javascript, declaration) {
	        var node = ts.createNode(276 /* InputFiles */);
	        node.javascriptText = javascript;
	        node.declarationText = declaration;
	        return node;
	    }
	    ts.createInputFiles = createInputFiles;
	    function updateBundle(node, sourceFiles, prepends) {
	        if (prepends === void 0) { prepends = ts.emptyArray; }
	        if (node.sourceFiles !== sourceFiles || node.prepends !== prepends) {
	            return createBundle(sourceFiles, prepends);
	        }
	        return node;
	    }
	    ts.updateBundle = updateBundle;
	    function createImmediatelyInvokedFunctionExpression(statements, param, paramValue) {
	        return createCall(createFunctionExpression(
	        /*modifiers*/ undefined, 
	        /*asteriskToken*/ undefined, 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ param ? [param] : [], 
	        /*type*/ undefined, createBlock(statements, /*multiLine*/ true)), 
	        /*typeArguments*/ undefined, 
	        /*argumentsArray*/ paramValue ? [paramValue] : []);
	    }
	    ts.createImmediatelyInvokedFunctionExpression = createImmediatelyInvokedFunctionExpression;
	    function createImmediatelyInvokedArrowFunction(statements, param, paramValue) {
	        return createCall(createArrowFunction(
	        /*modifiers*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ param ? [param] : [], 
	        /*type*/ undefined, 
	        /*equalsGreaterThanToken*/ undefined, createBlock(statements, /*multiLine*/ true)), 
	        /*typeArguments*/ undefined, 
	        /*argumentsArray*/ paramValue ? [paramValue] : []);
	    }
	    ts.createImmediatelyInvokedArrowFunction = createImmediatelyInvokedArrowFunction;
	    function createComma(left, right) {
	        return createBinary(left, 26 /* CommaToken */, right);
	    }
	    ts.createComma = createComma;
	    function createLessThan(left, right) {
	        return createBinary(left, 27 /* LessThanToken */, right);
	    }
	    ts.createLessThan = createLessThan;
	    function createAssignment(left, right) {
	        return createBinary(left, 58 /* EqualsToken */, right);
	    }
	    ts.createAssignment = createAssignment;
	    function createStrictEquality(left, right) {
	        return createBinary(left, 34 /* EqualsEqualsEqualsToken */, right);
	    }
	    ts.createStrictEquality = createStrictEquality;
	    function createStrictInequality(left, right) {
	        return createBinary(left, 35 /* ExclamationEqualsEqualsToken */, right);
	    }
	    ts.createStrictInequality = createStrictInequality;
	    function createAdd(left, right) {
	        return createBinary(left, 37 /* PlusToken */, right);
	    }
	    ts.createAdd = createAdd;
	    function createSubtract(left, right) {
	        return createBinary(left, 38 /* MinusToken */, right);
	    }
	    ts.createSubtract = createSubtract;
	    function createPostfixIncrement(operand) {
	        return createPostfix(operand, 43 /* PlusPlusToken */);
	    }
	    ts.createPostfixIncrement = createPostfixIncrement;
	    function createLogicalAnd(left, right) {
	        return createBinary(left, 53 /* AmpersandAmpersandToken */, right);
	    }
	    ts.createLogicalAnd = createLogicalAnd;
	    function createLogicalOr(left, right) {
	        return createBinary(left, 54 /* BarBarToken */, right);
	    }
	    ts.createLogicalOr = createLogicalOr;
	    function createLogicalNot(operand) {
	        return createPrefix(51 /* ExclamationToken */, operand);
	    }
	    ts.createLogicalNot = createLogicalNot;
	    function createVoidZero() {
	        return createVoid(createLiteral(0));
	    }
	    ts.createVoidZero = createVoidZero;
	    function createExportDefault(expression) {
	        return createExportAssignment(/*decorators*/ undefined, /*modifiers*/ undefined, /*isExportEquals*/ false, expression);
	    }
	    ts.createExportDefault = createExportDefault;
	    function createExternalModuleExport(exportName) {
	        return createExportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, createNamedExports([createExportSpecifier(/*propertyName*/ undefined, exportName)]));
	    }
	    ts.createExternalModuleExport = createExternalModuleExport;
	    function asName(name) {
	        return ts.isString(name) ? createIdentifier(name) : name;
	    }
	    function asExpression(value) {
	        return ts.isString(value) || typeof value === "number" ? createLiteral(value) : value;
	    }
	    function asNodeArray(array) {
	        return array ? createNodeArray(array) : undefined;
	    }
	    function asToken(value) {
	        return typeof value === "number" ? createToken(value) : value;
	    }
	    /**
	     * Clears any EmitNode entries from parse-tree nodes.
	     * @param sourceFile A source file.
	     */
	    function disposeEmitNodes(sourceFile) {
	        // During transformation we may need to annotate a parse tree node with transient
	        // transformation properties. As parse tree nodes live longer than transformation
	        // nodes, we need to make sure we reclaim any memory allocated for custom ranges
	        // from these nodes to ensure we do not hold onto entire subtrees just for position
	        // information. We also need to reset these nodes to a pre-transformation state
	        // for incremental parsing scenarios so that we do not impact later emit.
	        sourceFile = ts.getSourceFileOfNode(ts.getParseTreeNode(sourceFile));
	        var emitNode = sourceFile && sourceFile.emitNode;
	        var annotatedNodes = emitNode && emitNode.annotatedNodes;
	        if (annotatedNodes) {
	            for (var _i = 0, annotatedNodes_1 = annotatedNodes; _i < annotatedNodes_1.length; _i++) {
	                var node = annotatedNodes_1[_i];
	                node.emitNode = undefined;
	            }
	        }
	    }
	    ts.disposeEmitNodes = disposeEmitNodes;
	    /**
	     * Associates a node with the current transformation, initializing
	     * various transient transformation properties.
	     */
	    /* @internal */
	    function getOrCreateEmitNode(node) {
	        if (!node.emitNode) {
	            if (ts.isParseTreeNode(node)) {
	                // To avoid holding onto transformation artifacts, we keep track of any
	                // parse tree node we are annotating. This allows us to clean them up after
	                // all transformations have completed.
	                if (node.kind === 273 /* SourceFile */) {
	                    return node.emitNode = { annotatedNodes: [node] };
	                }
	                var sourceFile = ts.getSourceFileOfNode(node);
	                getOrCreateEmitNode(sourceFile).annotatedNodes.push(node);
	            }
	            node.emitNode = {};
	        }
	        return node.emitNode;
	    }
	    ts.getOrCreateEmitNode = getOrCreateEmitNode;
	    function setTextRange(range, location) {
	        if (location) {
	            range.pos = location.pos;
	            range.end = location.end;
	        }
	        return range;
	    }
	    ts.setTextRange = setTextRange;
	    /**
	     * Sets flags that control emit behavior of a node.
	     */
	    function setEmitFlags(node, emitFlags) {
	        getOrCreateEmitNode(node).flags = emitFlags;
	        return node;
	    }
	    ts.setEmitFlags = setEmitFlags;
	    /**
	     * Sets flags that control emit behavior of a node.
	     */
	    /* @internal */
	    function addEmitFlags(node, emitFlags) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.flags = emitNode.flags | emitFlags;
	        return node;
	    }
	    ts.addEmitFlags = addEmitFlags;
	    /**
	     * Gets a custom text range to use when emitting source maps.
	     */
	    function getSourceMapRange(node) {
	        var emitNode = node.emitNode;
	        return (emitNode && emitNode.sourceMapRange) || node;
	    }
	    ts.getSourceMapRange = getSourceMapRange;
	    /**
	     * Sets a custom text range to use when emitting source maps.
	     */
	    function setSourceMapRange(node, range) {
	        getOrCreateEmitNode(node).sourceMapRange = range;
	        return node;
	    }
	    ts.setSourceMapRange = setSourceMapRange;
	    // tslint:disable-next-line variable-name
	    var SourceMapSource;
	    /**
	     * Create an external source map source file reference
	     */
	    function createSourceMapSource(fileName, text, skipTrivia) {
	        return new (SourceMapSource || (SourceMapSource = ts.objectAllocator.getSourceMapSourceConstructor()))(fileName, text, skipTrivia);
	    }
	    ts.createSourceMapSource = createSourceMapSource;
	    /**
	     * Gets the TextRange to use for source maps for a token of a node.
	     */
	    function getTokenSourceMapRange(node, token) {
	        var emitNode = node.emitNode;
	        var tokenSourceMapRanges = emitNode && emitNode.tokenSourceMapRanges;
	        return tokenSourceMapRanges && tokenSourceMapRanges[token];
	    }
	    ts.getTokenSourceMapRange = getTokenSourceMapRange;
	    /**
	     * Sets the TextRange to use for source maps for a token of a node.
	     */
	    function setTokenSourceMapRange(node, token, range) {
	        var emitNode = getOrCreateEmitNode(node);
	        var tokenSourceMapRanges = emitNode.tokenSourceMapRanges || (emitNode.tokenSourceMapRanges = []);
	        tokenSourceMapRanges[token] = range;
	        return node;
	    }
	    ts.setTokenSourceMapRange = setTokenSourceMapRange;
	    /**
	     * Gets a custom text range to use when emitting comments.
	     */
	    /*@internal*/
	    function getStartsOnNewLine(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.startsOnNewLine;
	    }
	    ts.getStartsOnNewLine = getStartsOnNewLine;
	    /**
	     * Sets a custom text range to use when emitting comments.
	     */
	    /*@internal*/
	    function setStartsOnNewLine(node, newLine) {
	        getOrCreateEmitNode(node).startsOnNewLine = newLine;
	        return node;
	    }
	    ts.setStartsOnNewLine = setStartsOnNewLine;
	    /**
	     * Gets a custom text range to use when emitting comments.
	     */
	    function getCommentRange(node) {
	        var emitNode = node.emitNode;
	        return (emitNode && emitNode.commentRange) || node;
	    }
	    ts.getCommentRange = getCommentRange;
	    /**
	     * Sets a custom text range to use when emitting comments.
	     */
	    function setCommentRange(node, range) {
	        getOrCreateEmitNode(node).commentRange = range;
	        return node;
	    }
	    ts.setCommentRange = setCommentRange;
	    function getSyntheticLeadingComments(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.leadingComments;
	    }
	    ts.getSyntheticLeadingComments = getSyntheticLeadingComments;
	    function setSyntheticLeadingComments(node, comments) {
	        getOrCreateEmitNode(node).leadingComments = comments;
	        return node;
	    }
	    ts.setSyntheticLeadingComments = setSyntheticLeadingComments;
	    function addSyntheticLeadingComment(node, kind, text, hasTrailingNewLine) {
	        return setSyntheticLeadingComments(node, ts.append(getSyntheticLeadingComments(node), { kind: kind, pos: -1, end: -1, hasTrailingNewLine: hasTrailingNewLine, text: text }));
	    }
	    ts.addSyntheticLeadingComment = addSyntheticLeadingComment;
	    function getSyntheticTrailingComments(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.trailingComments;
	    }
	    ts.getSyntheticTrailingComments = getSyntheticTrailingComments;
	    function setSyntheticTrailingComments(node, comments) {
	        getOrCreateEmitNode(node).trailingComments = comments;
	        return node;
	    }
	    ts.setSyntheticTrailingComments = setSyntheticTrailingComments;
	    function addSyntheticTrailingComment(node, kind, text, hasTrailingNewLine) {
	        return setSyntheticTrailingComments(node, ts.append(getSyntheticTrailingComments(node), { kind: kind, pos: -1, end: -1, hasTrailingNewLine: hasTrailingNewLine, text: text }));
	    }
	    ts.addSyntheticTrailingComment = addSyntheticTrailingComment;
	    function moveSyntheticComments(node, original) {
	        setSyntheticLeadingComments(node, getSyntheticLeadingComments(original));
	        setSyntheticTrailingComments(node, getSyntheticTrailingComments(original));
	        var emit = getOrCreateEmitNode(original);
	        emit.leadingComments = undefined;
	        emit.trailingComments = undefined;
	        return node;
	    }
	    ts.moveSyntheticComments = moveSyntheticComments;
	    /**
	     * Gets the constant value to emit for an expression.
	     */
	    function getConstantValue(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.constantValue;
	    }
	    ts.getConstantValue = getConstantValue;
	    /**
	     * Sets the constant value to emit for an expression.
	     */
	    function setConstantValue(node, value) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.constantValue = value;
	        return node;
	    }
	    ts.setConstantValue = setConstantValue;
	    /**
	     * Adds an EmitHelper to a node.
	     */
	    function addEmitHelper(node, helper) {
	        var emitNode = getOrCreateEmitNode(node);
	        emitNode.helpers = ts.append(emitNode.helpers, helper);
	        return node;
	    }
	    ts.addEmitHelper = addEmitHelper;
	    /**
	     * Add EmitHelpers to a node.
	     */
	    function addEmitHelpers(node, helpers) {
	        if (ts.some(helpers)) {
	            var emitNode = getOrCreateEmitNode(node);
	            for (var _i = 0, helpers_1 = helpers; _i < helpers_1.length; _i++) {
	                var helper = helpers_1[_i];
	                emitNode.helpers = ts.appendIfUnique(emitNode.helpers, helper);
	            }
	        }
	        return node;
	    }
	    ts.addEmitHelpers = addEmitHelpers;
	    /**
	     * Removes an EmitHelper from a node.
	     */
	    function removeEmitHelper(node, helper) {
	        var emitNode = node.emitNode;
	        if (emitNode) {
	            var helpers = emitNode.helpers;
	            if (helpers) {
	                return ts.orderedRemoveItem(helpers, helper);
	            }
	        }
	        return false;
	    }
	    ts.removeEmitHelper = removeEmitHelper;
	    /**
	     * Gets the EmitHelpers of a node.
	     */
	    function getEmitHelpers(node) {
	        var emitNode = node.emitNode;
	        return emitNode && emitNode.helpers;
	    }
	    ts.getEmitHelpers = getEmitHelpers;
	    /**
	     * Moves matching emit helpers from a source node to a target node.
	     */
	    function moveEmitHelpers(source, target, predicate) {
	        var sourceEmitNode = source.emitNode;
	        var sourceEmitHelpers = sourceEmitNode && sourceEmitNode.helpers;
	        if (!ts.some(sourceEmitHelpers))
	            return;
	        var targetEmitNode = getOrCreateEmitNode(target);
	        var helpersRemoved = 0;
	        for (var i = 0; i < sourceEmitHelpers.length; i++) {
	            var helper = sourceEmitHelpers[i];
	            if (predicate(helper)) {
	                helpersRemoved++;
	                targetEmitNode.helpers = ts.appendIfUnique(targetEmitNode.helpers, helper);
	            }
	            else if (helpersRemoved > 0) {
	                sourceEmitHelpers[i - helpersRemoved] = helper;
	            }
	        }
	        if (helpersRemoved > 0) {
	            sourceEmitHelpers.length -= helpersRemoved;
	        }
	    }
	    ts.moveEmitHelpers = moveEmitHelpers;
	    /* @internal */
	    function compareEmitHelpers(x, y) {
	        if (x === y)
	            return 0 /* EqualTo */;
	        if (x.priority === y.priority)
	            return 0 /* EqualTo */;
	        if (x.priority === undefined)
	            return 1 /* GreaterThan */;
	        if (y.priority === undefined)
	            return -1 /* LessThan */;
	        return ts.compareValues(x.priority, y.priority);
	    }
	    ts.compareEmitHelpers = compareEmitHelpers;
	    function setOriginalNode(node, original) {
	        node.original = original;
	        if (original) {
	            var emitNode = original.emitNode;
	            if (emitNode)
	                node.emitNode = mergeEmitNode(emitNode, node.emitNode);
	        }
	        return node;
	    }
	    ts.setOriginalNode = setOriginalNode;
	    function mergeEmitNode(sourceEmitNode, destEmitNode) {
	        var flags = sourceEmitNode.flags, leadingComments = sourceEmitNode.leadingComments, trailingComments = sourceEmitNode.trailingComments, commentRange = sourceEmitNode.commentRange, sourceMapRange = sourceEmitNode.sourceMapRange, tokenSourceMapRanges = sourceEmitNode.tokenSourceMapRanges, constantValue = sourceEmitNode.constantValue, helpers = sourceEmitNode.helpers, startsOnNewLine = sourceEmitNode.startsOnNewLine;
	        if (!destEmitNode)
	            destEmitNode = {};
	        // We are using `.slice()` here in case `destEmitNode.leadingComments` is pushed to later.
	        if (leadingComments)
	            destEmitNode.leadingComments = ts.addRange(leadingComments.slice(), destEmitNode.leadingComments);
	        if (trailingComments)
	            destEmitNode.trailingComments = ts.addRange(trailingComments.slice(), destEmitNode.trailingComments);
	        if (flags)
	            destEmitNode.flags = flags;
	        if (commentRange)
	            destEmitNode.commentRange = commentRange;
	        if (sourceMapRange)
	            destEmitNode.sourceMapRange = sourceMapRange;
	        if (tokenSourceMapRanges)
	            destEmitNode.tokenSourceMapRanges = mergeTokenSourceMapRanges(tokenSourceMapRanges, destEmitNode.tokenSourceMapRanges);
	        if (constantValue !== undefined)
	            destEmitNode.constantValue = constantValue;
	        if (helpers)
	            destEmitNode.helpers = ts.addRange(destEmitNode.helpers, helpers);
	        if (startsOnNewLine !== undefined)
	            destEmitNode.startsOnNewLine = startsOnNewLine;
	        return destEmitNode;
	    }
	    function mergeTokenSourceMapRanges(sourceRanges, destRanges) {
	        if (!destRanges)
	            destRanges = [];
	        for (var key in sourceRanges) {
	            destRanges[key] = sourceRanges[key];
	        }
	        return destRanges;
	    }
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    ts.nullTransformationContext = {
	        enableEmitNotification: ts.noop,
	        enableSubstitution: ts.noop,
	        endLexicalEnvironment: function () { return undefined; },
	        getCompilerOptions: ts.notImplemented,
	        getEmitHost: ts.notImplemented,
	        getEmitResolver: ts.notImplemented,
	        hoistFunctionDeclaration: ts.noop,
	        hoistVariableDeclaration: ts.noop,
	        isEmitNotificationEnabled: ts.notImplemented,
	        isSubstitutionEnabled: ts.notImplemented,
	        onEmitNode: ts.noop,
	        onSubstituteNode: ts.notImplemented,
	        readEmitHelpers: ts.notImplemented,
	        requestEmitHelper: ts.noop,
	        resumeLexicalEnvironment: ts.noop,
	        startLexicalEnvironment: ts.noop,
	        suspendLexicalEnvironment: ts.noop,
	        addDiagnostic: ts.noop,
	    };
	    function createTypeCheck(value, tag) {
	        return tag === "undefined"
	            ? ts.createStrictEquality(value, ts.createVoidZero())
	            : ts.createStrictEquality(ts.createTypeOf(value), ts.createLiteral(tag));
	    }
	    ts.createTypeCheck = createTypeCheck;
	    function createMemberAccessForPropertyName(target, memberName, location) {
	        if (ts.isComputedPropertyName(memberName)) {
	            return ts.setTextRange(ts.createElementAccess(target, memberName.expression), location);
	        }
	        else {
	            var expression = ts.setTextRange(ts.isIdentifier(memberName)
	                ? ts.createPropertyAccess(target, memberName)
	                : ts.createElementAccess(target, memberName), memberName);
	            ts.getOrCreateEmitNode(expression).flags |= 64 /* NoNestedSourceMaps */;
	            return expression;
	        }
	    }
	    ts.createMemberAccessForPropertyName = createMemberAccessForPropertyName;
	    function createFunctionCall(func, thisArg, argumentsList, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(func, "call"), 
	        /*typeArguments*/ undefined, [
	            thisArg
	        ].concat(argumentsList)), location);
	    }
	    ts.createFunctionCall = createFunctionCall;
	    function createFunctionApply(func, thisArg, argumentsExpression, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(func, "apply"), 
	        /*typeArguments*/ undefined, [
	            thisArg,
	            argumentsExpression
	        ]), location);
	    }
	    ts.createFunctionApply = createFunctionApply;
	    function createArraySlice(array, start) {
	        var argumentsList = [];
	        if (start !== undefined) {
	            argumentsList.push(typeof start === "number" ? ts.createLiteral(start) : start);
	        }
	        return ts.createCall(ts.createPropertyAccess(array, "slice"), /*typeArguments*/ undefined, argumentsList);
	    }
	    ts.createArraySlice = createArraySlice;
	    function createArrayConcat(array, values) {
	        return ts.createCall(ts.createPropertyAccess(array, "concat"), 
	        /*typeArguments*/ undefined, values);
	    }
	    ts.createArrayConcat = createArrayConcat;
	    function createMathPow(left, right, location) {
	        return ts.setTextRange(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Math"), "pow"), 
	        /*typeArguments*/ undefined, [left, right]), location);
	    }
	    ts.createMathPow = createMathPow;
	    function createReactNamespace(reactNamespace, parent) {
	        // To ensure the emit resolver can properly resolve the namespace, we need to
	        // treat this identifier as if it were a source tree node by clearing the `Synthesized`
	        // flag and setting a parent node.
	        var react = ts.createIdentifier(reactNamespace || "React");
	        react.flags &= ~8 /* Synthesized */;
	        // Set the parent that is in parse tree
	        // this makes sure that parent chain is intact for checker to traverse complete scope tree
	        react.parent = ts.getParseTreeNode(parent);
	        return react;
	    }
	    function createJsxFactoryExpressionFromEntityName(jsxFactory, parent) {
	        if (ts.isQualifiedName(jsxFactory)) {
	            var left = createJsxFactoryExpressionFromEntityName(jsxFactory.left, parent);
	            var right = ts.createIdentifier(ts.idText(jsxFactory.right));
	            right.escapedText = jsxFactory.right.escapedText;
	            return ts.createPropertyAccess(left, right);
	        }
	        else {
	            return createReactNamespace(ts.idText(jsxFactory), parent);
	        }
	    }
	    function createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parent) {
	        return jsxFactoryEntity ?
	            createJsxFactoryExpressionFromEntityName(jsxFactoryEntity, parent) :
	            ts.createPropertyAccess(createReactNamespace(reactNamespace, parent), "createElement");
	    }
	    function createExpressionForJsxElement(jsxFactoryEntity, reactNamespace, tagName, props, children, parentElement, location) {
	        var argumentsList = [tagName];
	        if (props) {
	            argumentsList.push(props);
	        }
	        if (children && children.length > 0) {
	            if (!props) {
	                argumentsList.push(ts.createNull());
	            }
	            if (children.length > 1) {
	                for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
	                    var child = children_1[_i];
	                    startOnNewLine(child);
	                    argumentsList.push(child);
	                }
	            }
	            else {
	                argumentsList.push(children[0]);
	            }
	        }
	        return ts.setTextRange(ts.createCall(createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parentElement), 
	        /*typeArguments*/ undefined, argumentsList), location);
	    }
	    ts.createExpressionForJsxElement = createExpressionForJsxElement;
	    function createExpressionForJsxFragment(jsxFactoryEntity, reactNamespace, children, parentElement, location) {
	        var tagName = ts.createPropertyAccess(createReactNamespace(reactNamespace, parentElement), "Fragment");
	        var argumentsList = [tagName];
	        argumentsList.push(ts.createNull());
	        if (children && children.length > 0) {
	            if (children.length > 1) {
	                for (var _i = 0, children_2 = children; _i < children_2.length; _i++) {
	                    var child = children_2[_i];
	                    startOnNewLine(child);
	                    argumentsList.push(child);
	                }
	            }
	            else {
	                argumentsList.push(children[0]);
	            }
	        }
	        return ts.setTextRange(ts.createCall(createJsxFactoryExpression(jsxFactoryEntity, reactNamespace, parentElement), 
	        /*typeArguments*/ undefined, argumentsList), location);
	    }
	    ts.createExpressionForJsxFragment = createExpressionForJsxFragment;
	    // Helpers
	    function getHelperName(name) {
	        return ts.setEmitFlags(ts.createIdentifier(name), 4096 /* HelperName */ | 2 /* AdviseOnEmitNode */);
	    }
	    ts.getHelperName = getHelperName;
	    var valuesHelper = {
	        name: "typescript:values",
	        scoped: false,
	        text: "\n            var __values = (this && this.__values) || function (o) {\n                var m = typeof Symbol === \"function\" && o[Symbol.iterator], i = 0;\n                if (m) return m.call(o);\n                return {\n                    next: function () {\n                        if (o && i >= o.length) o = void 0;\n                        return { value: o && o[i++], done: !o };\n                    }\n                };\n            };"
	    };
	    function createValuesHelper(context, expression, location) {
	        context.requestEmitHelper(valuesHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__values"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	    ts.createValuesHelper = createValuesHelper;
	    var readHelper = {
	        name: "typescript:read",
	        scoped: false,
	        text: "\n            var __read = (this && this.__read) || function (o, n) {\n                var m = typeof Symbol === \"function\" && o[Symbol.iterator];\n                if (!m) return o;\n                var i = m.call(o), r, ar = [], e;\n                try {\n                    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);\n                }\n                catch (error) { e = { error: error }; }\n                finally {\n                    try {\n                        if (r && !r.done && (m = i[\"return\"])) m.call(i);\n                    }\n                    finally { if (e) throw e.error; }\n                }\n                return ar;\n            };"
	    };
	    function createReadHelper(context, iteratorRecord, count, location) {
	        context.requestEmitHelper(readHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__read"), 
	        /*typeArguments*/ undefined, count !== undefined
	            ? [iteratorRecord, ts.createLiteral(count)]
	            : [iteratorRecord]), location);
	    }
	    ts.createReadHelper = createReadHelper;
	    var spreadHelper = {
	        name: "typescript:spread",
	        scoped: false,
	        text: "\n            var __spread = (this && this.__spread) || function () {\n                for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));\n                return ar;\n            };"
	    };
	    function createSpreadHelper(context, argumentList, location) {
	        context.requestEmitHelper(readHelper);
	        context.requestEmitHelper(spreadHelper);
	        return ts.setTextRange(ts.createCall(getHelperName("__spread"), 
	        /*typeArguments*/ undefined, argumentList), location);
	    }
	    ts.createSpreadHelper = createSpreadHelper;
	    // Utilities
	    function createForOfBindingStatement(node, boundValue) {
	        if (ts.isVariableDeclarationList(node)) {
	            var firstDeclaration = ts.firstOrUndefined(node.declarations);
	            var updatedDeclaration = ts.updateVariableDeclaration(firstDeclaration, firstDeclaration.name, 
	            /*typeNode*/ undefined, boundValue);
	            return ts.setTextRange(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.updateVariableDeclarationList(node, [updatedDeclaration])), 
	            /*location*/ node);
	        }
	        else {
	            var updatedExpression = ts.setTextRange(ts.createAssignment(node, boundValue), /*location*/ node);
	            return ts.setTextRange(ts.createStatement(updatedExpression), /*location*/ node);
	        }
	    }
	    ts.createForOfBindingStatement = createForOfBindingStatement;
	    function insertLeadingStatement(dest, source) {
	        if (ts.isBlock(dest)) {
	            return ts.updateBlock(dest, ts.setTextRange(ts.createNodeArray([source].concat(dest.statements)), dest.statements));
	        }
	        else {
	            return ts.createBlock(ts.createNodeArray([dest, source]), /*multiLine*/ true);
	        }
	    }
	    ts.insertLeadingStatement = insertLeadingStatement;
	    function restoreEnclosingLabel(node, outermostLabeledStatement, afterRestoreLabelCallback) {
	        if (!outermostLabeledStatement) {
	            return node;
	        }
	        var updated = ts.updateLabel(outermostLabeledStatement, outermostLabeledStatement.label, outermostLabeledStatement.statement.kind === 227 /* LabeledStatement */
	            ? restoreEnclosingLabel(node, outermostLabeledStatement.statement)
	            : node);
	        if (afterRestoreLabelCallback) {
	            afterRestoreLabelCallback(outermostLabeledStatement);
	        }
	        return updated;
	    }
	    ts.restoreEnclosingLabel = restoreEnclosingLabel;
	    function shouldBeCapturedInTempVariable(node, cacheIdentifiers) {
	        var target = ts.skipParentheses(node);
	        switch (target.kind) {
	            case 71 /* Identifier */:
	                return cacheIdentifiers;
	            case 99 /* ThisKeyword */:
	            case 8 /* NumericLiteral */:
	            case 9 /* StringLiteral */:
	                return false;
	            case 182 /* ArrayLiteralExpression */:
	                var elements = target.elements;
	                if (elements.length === 0) {
	                    return false;
	                }
	                return true;
	            case 183 /* ObjectLiteralExpression */:
	                return target.properties.length > 0;
	            default:
	                return true;
	        }
	    }
	    function createCallBinding(expression, recordTempVariable, languageVersion, cacheIdentifiers) {
	        var callee = skipOuterExpressions(expression, 7 /* All */);
	        var thisArg;
	        var target;
	        if (ts.isSuperProperty(callee)) {
	            thisArg = ts.createThis();
	            target = callee;
	        }
	        else if (callee.kind === 97 /* SuperKeyword */) {
	            thisArg = ts.createThis();
	            target = languageVersion < 2 /* ES2015 */
	                ? ts.setTextRange(ts.createIdentifier("_super"), callee)
	                : callee;
	        }
	        else if (ts.getEmitFlags(callee) & 4096 /* HelperName */) {
	            thisArg = ts.createVoidZero();
	            target = parenthesizeForAccess(callee);
	        }
	        else {
	            switch (callee.kind) {
	                case 184 /* PropertyAccessExpression */: {
	                    if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
	                        // for `a.b()` target is `(_a = a).b` and thisArg is `_a`
	                        thisArg = ts.createTempVariable(recordTempVariable);
	                        target = ts.createPropertyAccess(ts.setTextRange(ts.createAssignment(thisArg, callee.expression), callee.expression), callee.name);
	                        ts.setTextRange(target, callee);
	                    }
	                    else {
	                        thisArg = callee.expression;
	                        target = callee;
	                    }
	                    break;
	                }
	                case 185 /* ElementAccessExpression */: {
	                    if (shouldBeCapturedInTempVariable(callee.expression, cacheIdentifiers)) {
	                        // for `a[b]()` target is `(_a = a)[b]` and thisArg is `_a`
	                        thisArg = ts.createTempVariable(recordTempVariable);
	                        target = ts.createElementAccess(ts.setTextRange(ts.createAssignment(thisArg, callee.expression), callee.expression), callee.argumentExpression);
	                        ts.setTextRange(target, callee);
	                    }
	                    else {
	                        thisArg = callee.expression;
	                        target = callee;
	                    }
	                    break;
	                }
	                default: {
	                    // for `a()` target is `a` and thisArg is `void 0`
	                    thisArg = ts.createVoidZero();
	                    target = parenthesizeForAccess(expression);
	                    break;
	                }
	            }
	        }
	        return { target: target, thisArg: thisArg };
	    }
	    ts.createCallBinding = createCallBinding;
	    function inlineExpressions(expressions) {
	        // Avoid deeply nested comma expressions as traversing them during emit can result in "Maximum call
	        // stack size exceeded" errors.
	        return expressions.length > 10
	            ? ts.createCommaList(expressions)
	            : ts.reduceLeft(expressions, ts.createComma);
	    }
	    ts.inlineExpressions = inlineExpressions;
	    function createExpressionFromEntityName(node) {
	        if (ts.isQualifiedName(node)) {
	            var left = createExpressionFromEntityName(node.left);
	            var right = ts.getMutableClone(node.right);
	            return ts.setTextRange(ts.createPropertyAccess(left, right), node);
	        }
	        else {
	            return ts.getMutableClone(node);
	        }
	    }
	    ts.createExpressionFromEntityName = createExpressionFromEntityName;
	    function createExpressionForPropertyName(memberName) {
	        if (ts.isIdentifier(memberName)) {
	            return ts.createLiteral(memberName);
	        }
	        else if (ts.isComputedPropertyName(memberName)) {
	            return ts.getMutableClone(memberName.expression);
	        }
	        else {
	            return ts.getMutableClone(memberName);
	        }
	    }
	    ts.createExpressionForPropertyName = createExpressionForPropertyName;
	    function createExpressionForObjectLiteralElementLike(node, property, receiver) {
	        switch (property.kind) {
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	                return createExpressionForAccessorDeclaration(node.properties, property, receiver, node.multiLine);
	            case 269 /* PropertyAssignment */:
	                return createExpressionForPropertyAssignment(property, receiver);
	            case 270 /* ShorthandPropertyAssignment */:
	                return createExpressionForShorthandPropertyAssignment(property, receiver);
	            case 153 /* MethodDeclaration */:
	                return createExpressionForMethodDeclaration(property, receiver);
	        }
	    }
	    ts.createExpressionForObjectLiteralElementLike = createExpressionForObjectLiteralElementLike;
	    function createExpressionForAccessorDeclaration(properties, property, receiver, multiLine) {
	        var _a = ts.getAllAccessorDeclarations(properties, property), firstAccessor = _a.firstAccessor, getAccessor = _a.getAccessor, setAccessor = _a.setAccessor;
	        if (property === firstAccessor) {
	            var properties_9 = [];
	            if (getAccessor) {
	                var getterFunction = ts.createFunctionExpression(getAccessor.modifiers, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, getAccessor.parameters, 
	                /*type*/ undefined, getAccessor.body);
	                ts.setTextRange(getterFunction, getAccessor);
	                ts.setOriginalNode(getterFunction, getAccessor);
	                var getter = ts.createPropertyAssignment("get", getterFunction);
	                properties_9.push(getter);
	            }
	            if (setAccessor) {
	                var setterFunction = ts.createFunctionExpression(setAccessor.modifiers, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, setAccessor.parameters, 
	                /*type*/ undefined, setAccessor.body);
	                ts.setTextRange(setterFunction, setAccessor);
	                ts.setOriginalNode(setterFunction, setAccessor);
	                var setter = ts.createPropertyAssignment("set", setterFunction);
	                properties_9.push(setter);
	            }
	            properties_9.push(ts.createPropertyAssignment("enumerable", ts.createTrue()));
	            properties_9.push(ts.createPropertyAssignment("configurable", ts.createTrue()));
	            var expression = ts.setTextRange(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	            /*typeArguments*/ undefined, [
	                receiver,
	                createExpressionForPropertyName(property.name),
	                ts.createObjectLiteral(properties_9, multiLine)
	            ]), 
	            /*location*/ firstAccessor);
	            return ts.aggregateTransformFlags(expression);
	        }
	        return undefined;
	    }
	    function createExpressionForPropertyAssignment(property, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, property.name, /*location*/ property.name), property.initializer), property), property));
	    }
	    function createExpressionForShorthandPropertyAssignment(property, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, property.name, /*location*/ property.name), ts.getSynthesizedClone(property.name)), 
	        /*location*/ property), 
	        /*original*/ property));
	    }
	    function createExpressionForMethodDeclaration(method, receiver) {
	        return ts.aggregateTransformFlags(ts.setOriginalNode(ts.setTextRange(ts.createAssignment(createMemberAccessForPropertyName(receiver, method.name, /*location*/ method.name), ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(method.modifiers, method.asteriskToken, 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, method.parameters, 
	        /*type*/ undefined, method.body), 
	        /*location*/ method), 
	        /*original*/ method)), 
	        /*location*/ method), 
	        /*original*/ method));
	    }
	    /**
	     * Gets the internal name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the body of an ES5 class function body. An internal name will *never*
	     * be prefixed with an module or namespace export modifier like "exports." when emitted as an
	     * expression. An internal name will also *never* be renamed due to a collision with a block
	     * scoped variable.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getInternalName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 16384 /* LocalName */ | 32768 /* InternalName */);
	    }
	    ts.getInternalName = getInternalName;
	    /**
	     * Gets whether an identifier should only be referred to by its internal name.
	     */
	    function isInternalName(node) {
	        return (ts.getEmitFlags(node) & 32768 /* InternalName */) !== 0;
	    }
	    ts.isInternalName = isInternalName;
	    /**
	     * Gets the local name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the declaration's immediate scope (classes, enums, namespaces). A
	     * local name will *never* be prefixed with an module or namespace export modifier like
	     * "exports." when emitted as an expression.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getLocalName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 16384 /* LocalName */);
	    }
	    ts.getLocalName = getLocalName;
	    /**
	     * Gets whether an identifier should only be referred to by its local name.
	     */
	    function isLocalName(node) {
	        return (ts.getEmitFlags(node) & 16384 /* LocalName */) !== 0;
	    }
	    ts.isLocalName = isLocalName;
	    /**
	     * Gets the export name of a declaration. This is primarily used for declarations that can be
	     * referred to by name in the declaration's immediate scope (classes, enums, namespaces). An
	     * export name will *always* be prefixed with an module or namespace export modifier like
	     * `"exports."` when emitted as an expression if the name points to an exported symbol.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getExportName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps, 8192 /* ExportName */);
	    }
	    ts.getExportName = getExportName;
	    /**
	     * Gets whether an identifier should only be referred to by its export representation if the
	     * name points to an exported symbol.
	     */
	    function isExportName(node) {
	        return (ts.getEmitFlags(node) & 8192 /* ExportName */) !== 0;
	    }
	    ts.isExportName = isExportName;
	    /**
	     * Gets the name of a declaration for use in declarations.
	     *
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getDeclarationName(node, allowComments, allowSourceMaps) {
	        return getName(node, allowComments, allowSourceMaps);
	    }
	    ts.getDeclarationName = getDeclarationName;
	    function getName(node, allowComments, allowSourceMaps, emitFlags) {
	        var nodeName = ts.getNameOfDeclaration(node);
	        if (nodeName && ts.isIdentifier(nodeName) && !ts.isGeneratedIdentifier(nodeName)) {
	            var name = ts.getMutableClone(nodeName);
	            emitFlags |= ts.getEmitFlags(nodeName);
	            if (!allowSourceMaps)
	                emitFlags |= 48 /* NoSourceMap */;
	            if (!allowComments)
	                emitFlags |= 1536 /* NoComments */;
	            if (emitFlags)
	                ts.setEmitFlags(name, emitFlags);
	            return name;
	        }
	        return ts.getGeneratedNameForNode(node);
	    }
	    /**
	     * Gets the exported name of a declaration for use in expressions.
	     *
	     * An exported name will *always* be prefixed with an module or namespace export modifier like
	     * "exports." if the name points to an exported symbol.
	     *
	     * @param ns The namespace identifier.
	     * @param node The declaration.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getExternalModuleOrNamespaceExportName(ns, node, allowComments, allowSourceMaps) {
	        if (ns && ts.hasModifier(node, 1 /* Export */)) {
	            return getNamespaceMemberName(ns, getName(node), allowComments, allowSourceMaps);
	        }
	        return getExportName(node, allowComments, allowSourceMaps);
	    }
	    ts.getExternalModuleOrNamespaceExportName = getExternalModuleOrNamespaceExportName;
	    /**
	     * Gets a namespace-qualified name for use in expressions.
	     *
	     * @param ns The namespace identifier.
	     * @param name The name.
	     * @param allowComments A value indicating whether comments may be emitted for the name.
	     * @param allowSourceMaps A value indicating whether source maps may be emitted for the name.
	     */
	    function getNamespaceMemberName(ns, name, allowComments, allowSourceMaps) {
	        var qualifiedName = ts.createPropertyAccess(ns, ts.nodeIsSynthesized(name) ? name : ts.getSynthesizedClone(name));
	        ts.setTextRange(qualifiedName, name);
	        var emitFlags;
	        if (!allowSourceMaps)
	            emitFlags |= 48 /* NoSourceMap */;
	        if (!allowComments)
	            emitFlags |= 1536 /* NoComments */;
	        if (emitFlags)
	            ts.setEmitFlags(qualifiedName, emitFlags);
	        return qualifiedName;
	    }
	    ts.getNamespaceMemberName = getNamespaceMemberName;
	    function convertToFunctionBody(node, multiLine) {
	        return ts.isBlock(node) ? node : ts.setTextRange(ts.createBlock([ts.setTextRange(ts.createReturn(node), node)], multiLine), node);
	    }
	    ts.convertToFunctionBody = convertToFunctionBody;
	    function convertFunctionDeclarationToExpression(node) {
	        ts.Debug.assert(!!node.body);
	        var updated = ts.createFunctionExpression(node.modifiers, node.asteriskToken, node.name, node.typeParameters, node.parameters, node.type, node.body);
	        ts.setOriginalNode(updated, node);
	        ts.setTextRange(updated, node);
	        if (ts.getStartsOnNewLine(node)) {
	            ts.setStartsOnNewLine(updated, /*newLine*/ true);
	        }
	        ts.aggregateTransformFlags(updated);
	        return updated;
	    }
	    ts.convertFunctionDeclarationToExpression = convertFunctionDeclarationToExpression;
	    function isUseStrictPrologue(node) {
	        return ts.isStringLiteral(node.expression) && node.expression.text === "use strict";
	    }
	    /**
	     * Add any necessary prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     *
	     * @param target: result statements array
	     * @param source: origin statements array
	     * @param ensureUseStrict: boolean determining whether the function need to add prologue-directives
	     * @param visitor: Optional callback used to visit any custom prologue directives.
	     */
	    function addPrologue(target, source, ensureUseStrict, visitor) {
	        var offset = addStandardPrologue(target, source, ensureUseStrict);
	        return addCustomPrologue(target, source, offset, visitor);
	    }
	    ts.addPrologue = addPrologue;
	    /**
	     * Add just the standard (string-expression) prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     */
	    function addStandardPrologue(target, source, ensureUseStrict) {
	        ts.Debug.assert(target.length === 0, "Prologue directives should be at the first statement in the target statements array");
	        var foundUseStrict = false;
	        var statementOffset = 0;
	        var numStatements = source.length;
	        while (statementOffset < numStatements) {
	            var statement = source[statementOffset];
	            if (ts.isPrologueDirective(statement)) {
	                if (isUseStrictPrologue(statement)) {
	                    foundUseStrict = true;
	                }
	                target.push(statement);
	            }
	            else {
	                break;
	            }
	            statementOffset++;
	        }
	        if (ensureUseStrict && !foundUseStrict) {
	            target.push(startOnNewLine(ts.createStatement(ts.createLiteral("use strict"))));
	        }
	        return statementOffset;
	    }
	    ts.addStandardPrologue = addStandardPrologue;
	    /**
	     * Add just the custom prologue-directives into target statement-array.
	     * The function needs to be called during each transformation step.
	     * This function needs to be called whenever we transform the statement
	     * list of a source file, namespace, or function-like body.
	     */
	    function addCustomPrologue(target, source, statementOffset, visitor) {
	        var numStatements = source.length;
	        while (statementOffset < numStatements) {
	            var statement = source[statementOffset];
	            if (ts.getEmitFlags(statement) & 1048576 /* CustomPrologue */) {
	                ts.append(target, visitor ? ts.visitNode(statement, visitor, ts.isStatement) : statement);
	            }
	            else {
	                break;
	            }
	            statementOffset++;
	        }
	        return statementOffset;
	    }
	    ts.addCustomPrologue = addCustomPrologue;
	    function startsWithUseStrict(statements) {
	        var firstStatement = ts.firstOrUndefined(statements);
	        return firstStatement !== undefined
	            && ts.isPrologueDirective(firstStatement)
	            && isUseStrictPrologue(firstStatement);
	    }
	    ts.startsWithUseStrict = startsWithUseStrict;
	    /**
	     * Ensures "use strict" directive is added
	     *
	     * @param statements An array of statements
	     */
	    function ensureUseStrict(statements) {
	        var foundUseStrict = false;
	        for (var _i = 0, statements_3 = statements; _i < statements_3.length; _i++) {
	            var statement = statements_3[_i];
	            if (ts.isPrologueDirective(statement)) {
	                if (isUseStrictPrologue(statement)) {
	                    foundUseStrict = true;
	                    break;
	                }
	            }
	            else {
	                break;
	            }
	        }
	        if (!foundUseStrict) {
	            return ts.setTextRange(ts.createNodeArray([
	                startOnNewLine(ts.createStatement(ts.createLiteral("use strict")))
	            ].concat(statements)), statements);
	        }
	        return statements;
	    }
	    ts.ensureUseStrict = ensureUseStrict;
	    /**
	     * Wraps the operand to a BinaryExpression in parentheses if they are needed to preserve the intended
	     * order of operations.
	     *
	     * @param binaryOperator The operator for the BinaryExpression.
	     * @param operand The operand for the BinaryExpression.
	     * @param isLeftSideOfBinary A value indicating whether the operand is the left side of the
	     *                           BinaryExpression.
	     */
	    function parenthesizeBinaryOperand(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
	        var skipped = ts.skipPartiallyEmittedExpressions(operand);
	        // If the resulting expression is already parenthesized, we do not need to do any further processing.
	        if (skipped.kind === 190 /* ParenthesizedExpression */) {
	            return operand;
	        }
	        return binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand)
	            ? ts.createParen(operand)
	            : operand;
	    }
	    ts.parenthesizeBinaryOperand = parenthesizeBinaryOperand;
	    /**
	     * Determines whether the operand to a BinaryExpression needs to be parenthesized.
	     *
	     * @param binaryOperator The operator for the BinaryExpression.
	     * @param operand The operand for the BinaryExpression.
	     * @param isLeftSideOfBinary A value indicating whether the operand is the left side of the
	     *                           BinaryExpression.
	     */
	    function binaryOperandNeedsParentheses(binaryOperator, operand, isLeftSideOfBinary, leftOperand) {
	        // If the operand has lower precedence, then it needs to be parenthesized to preserve the
	        // intent of the expression. For example, if the operand is `a + b` and the operator is
	        // `*`, then we need to parenthesize the operand to preserve the intended order of
	        // operations: `(a + b) * x`.
	        //
	        // If the operand has higher precedence, then it does not need to be parenthesized. For
	        // example, if the operand is `a * b` and the operator is `+`, then we do not need to
	        // parenthesize to preserve the intended order of operations: `a * b + x`.
	        //
	        // If the operand has the same precedence, then we need to check the associativity of
	        // the operator based on whether this is the left or right operand of the expression.
	        //
	        // For example, if `a / d` is on the right of operator `*`, we need to parenthesize
	        // to preserve the intended order of operations: `x * (a / d)`
	        //
	        // If `a ** d` is on the left of operator `**`, we need to parenthesize to preserve
	        // the intended order of operations: `(a ** b) ** c`
	        var binaryOperatorPrecedence = ts.getOperatorPrecedence(199 /* BinaryExpression */, binaryOperator);
	        var binaryOperatorAssociativity = ts.getOperatorAssociativity(199 /* BinaryExpression */, binaryOperator);
	        var emittedOperand = ts.skipPartiallyEmittedExpressions(operand);
	        var operandPrecedence = ts.getExpressionPrecedence(emittedOperand);
	        switch (ts.compareValues(operandPrecedence, binaryOperatorPrecedence)) {
	            case -1 /* LessThan */:
	                // If the operand is the right side of a right-associative binary operation
	                // and is a yield expression, then we do not need parentheses.
	                if (!isLeftSideOfBinary
	                    && binaryOperatorAssociativity === 1 /* Right */
	                    && operand.kind === 202 /* YieldExpression */) {
	                    return false;
	                }
	                return true;
	            case 1 /* GreaterThan */:
	                return false;
	            case 0 /* EqualTo */:
	                if (isLeftSideOfBinary) {
	                    // No need to parenthesize the left operand when the binary operator is
	                    // left associative:
	                    //  (a*b)/x    -> a*b/x
	                    //  (a**b)/x   -> a**b/x
	                    //
	                    // Parentheses are needed for the left operand when the binary operator is
	                    // right associative:
	                    //  (a/b)**x   -> (a/b)**x
	                    //  (a**b)**x  -> (a**b)**x
	                    return binaryOperatorAssociativity === 1 /* Right */;
	                }
	                else {
	                    if (ts.isBinaryExpression(emittedOperand)
	                        && emittedOperand.operatorToken.kind === binaryOperator) {
	                        // No need to parenthesize the right operand when the binary operator and
	                        // operand are the same and one of the following:
	                        //  x*(a*b)     => x*a*b
	                        //  x|(a|b)     => x|a|b
	                        //  x&(a&b)     => x&a&b
	                        //  x^(a^b)     => x^a^b
	                        if (operatorHasAssociativeProperty(binaryOperator)) {
	                            return false;
	                        }
	                        // No need to parenthesize the right operand when the binary operator
	                        // is plus (+) if both the left and right operands consist solely of either
	                        // literals of the same kind or binary plus (+) expressions for literals of
	                        // the same kind (recursively).
	                        //  "a"+(1+2)       => "a"+(1+2)
	                        //  "a"+("b"+"c")   => "a"+"b"+"c"
	                        if (binaryOperator === 37 /* PlusToken */) {
	                            var leftKind = leftOperand ? getLiteralKindOfBinaryPlusOperand(leftOperand) : 0 /* Unknown */;
	                            if (ts.isLiteralKind(leftKind) && leftKind === getLiteralKindOfBinaryPlusOperand(emittedOperand)) {
	                                return false;
	                            }
	                        }
	                    }
	                    // No need to parenthesize the right operand when the operand is right
	                    // associative:
	                    //  x/(a**b)    -> x/a**b
	                    //  x**(a**b)   -> x**a**b
	                    //
	                    // Parentheses are needed for the right operand when the operand is left
	                    // associative:
	                    //  x/(a*b)     -> x/(a*b)
	                    //  x**(a/b)    -> x**(a/b)
	                    var operandAssociativity = ts.getExpressionAssociativity(emittedOperand);
	                    return operandAssociativity === 0 /* Left */;
	                }
	        }
	    }
	    /**
	     * Determines whether a binary operator is mathematically associative.
	     *
	     * @param binaryOperator The binary operator.
	     */
	    function operatorHasAssociativeProperty(binaryOperator) {
	        // The following operators are associative in JavaScript:
	        //  (a*b)*c     -> a*(b*c)  -> a*b*c
	        //  (a|b)|c     -> a|(b|c)  -> a|b|c
	        //  (a&b)&c     -> a&(b&c)  -> a&b&c
	        //  (a^b)^c     -> a^(b^c)  -> a^b^c
	        //
	        // While addition is associative in mathematics, JavaScript's `+` is not
	        // guaranteed to be associative as it is overloaded with string concatenation.
	        return binaryOperator === 39 /* AsteriskToken */
	            || binaryOperator === 49 /* BarToken */
	            || binaryOperator === 48 /* AmpersandToken */
	            || binaryOperator === 50 /* CaretToken */;
	    }
	    /**
	     * This function determines whether an expression consists of a homogeneous set of
	     * literal expressions or binary plus expressions that all share the same literal kind.
	     * It is used to determine whether the right-hand operand of a binary plus expression can be
	     * emitted without parentheses.
	     */
	    function getLiteralKindOfBinaryPlusOperand(node) {
	        node = ts.skipPartiallyEmittedExpressions(node);
	        if (ts.isLiteralKind(node.kind)) {
	            return node.kind;
	        }
	        if (node.kind === 199 /* BinaryExpression */ && node.operatorToken.kind === 37 /* PlusToken */) {
	            if (node.cachedLiteralKind !== undefined) {
	                return node.cachedLiteralKind;
	            }
	            var leftKind = getLiteralKindOfBinaryPlusOperand(node.left);
	            var literalKind = ts.isLiteralKind(leftKind)
	                && leftKind === getLiteralKindOfBinaryPlusOperand(node.right)
	                ? leftKind
	                : 0 /* Unknown */;
	            node.cachedLiteralKind = literalKind;
	            return literalKind;
	        }
	        return 0 /* Unknown */;
	    }
	    function parenthesizeForConditionalHead(condition) {
	        var conditionalPrecedence = ts.getOperatorPrecedence(200 /* ConditionalExpression */, 55 /* QuestionToken */);
	        var emittedCondition = ts.skipPartiallyEmittedExpressions(condition);
	        var conditionPrecedence = ts.getExpressionPrecedence(emittedCondition);
	        if (ts.compareValues(conditionPrecedence, conditionalPrecedence) === -1 /* LessThan */) {
	            return ts.createParen(condition);
	        }
	        return condition;
	    }
	    ts.parenthesizeForConditionalHead = parenthesizeForConditionalHead;
	    function parenthesizeSubexpressionOfConditionalExpression(e) {
	        // per ES grammar both 'whenTrue' and 'whenFalse' parts of conditional expression are assignment expressions
	        // so in case when comma expression is introduced as a part of previous transformations
	        // if should be wrapped in parens since comma operator has the lowest precedence
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(e);
	        return emittedExpression.kind === 199 /* BinaryExpression */ && emittedExpression.operatorToken.kind === 26 /* CommaToken */ ||
	            emittedExpression.kind === 301 /* CommaListExpression */
	            ? ts.createParen(e)
	            : e;
	    }
	    ts.parenthesizeSubexpressionOfConditionalExpression = parenthesizeSubexpressionOfConditionalExpression;
	    /**
	     *  [Per the spec](https://tc39.github.io/ecma262/#prod-ExportDeclaration), `export default` accepts _AssigmentExpression_ but
	     *  has a lookahead restriction for `function`, `async function`, and `class`.
	     *
	     * Basically, that means we need to parenthesize in the following cases:
	     *
	     * - BinaryExpression of CommaToken
	     * - CommaList (synthetic list of multiple comma expressions)
	     * - FunctionExpression
	     * - ClassExpression
	     */
	    function parenthesizeDefaultExpression(e) {
	        var check = ts.skipPartiallyEmittedExpressions(e);
	        return (check.kind === 204 /* ClassExpression */ ||
	            check.kind === 191 /* FunctionExpression */ ||
	            check.kind === 301 /* CommaListExpression */ ||
	            ts.isBinaryExpression(check) && check.operatorToken.kind === 26 /* CommaToken */)
	            ? ts.createParen(e)
	            : e;
	    }
	    ts.parenthesizeDefaultExpression = parenthesizeDefaultExpression;
	    /**
	     * Wraps an expression in parentheses if it is needed in order to use the expression
	     * as the expression of a NewExpression node.
	     *
	     * @param expression The Expression node.
	     */
	    function parenthesizeForNew(expression) {
	        var leftmostExpr = getLeftmostExpression(expression, /*stopAtCallExpressions*/ true);
	        switch (leftmostExpr.kind) {
	            case 186 /* CallExpression */:
	                return ts.createParen(expression);
	            case 187 /* NewExpression */:
	                return !leftmostExpr.arguments
	                    ? ts.createParen(expression)
	                    : expression;
	        }
	        return parenthesizeForAccess(expression);
	    }
	    ts.parenthesizeForNew = parenthesizeForNew;
	    /**
	     * Wraps an expression in parentheses if it is needed in order to use the expression for
	     * property or element access.
	     *
	     * @param expr The expression node.
	     */
	    function parenthesizeForAccess(expression) {
	        // isLeftHandSideExpression is almost the correct criterion for when it is not necessary
	        // to parenthesize the expression before a dot. The known exception is:
	        //
	        //    NewExpression:
	        //       new C.x        -> not the same as (new C).x
	        //
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        if (ts.isLeftHandSideExpression(emittedExpression)
	            && (emittedExpression.kind !== 187 /* NewExpression */ || emittedExpression.arguments)) {
	            return expression;
	        }
	        return ts.setTextRange(ts.createParen(expression), expression);
	    }
	    ts.parenthesizeForAccess = parenthesizeForAccess;
	    function parenthesizePostfixOperand(operand) {
	        return ts.isLeftHandSideExpression(operand)
	            ? operand
	            : ts.setTextRange(ts.createParen(operand), operand);
	    }
	    ts.parenthesizePostfixOperand = parenthesizePostfixOperand;
	    function parenthesizePrefixOperand(operand) {
	        return ts.isUnaryExpression(operand)
	            ? operand
	            : ts.setTextRange(ts.createParen(operand), operand);
	    }
	    ts.parenthesizePrefixOperand = parenthesizePrefixOperand;
	    function parenthesizeListElements(elements) {
	        var result;
	        for (var i = 0; i < elements.length; i++) {
	            var element = parenthesizeExpressionForList(elements[i]);
	            if (result !== undefined || element !== elements[i]) {
	                if (result === undefined) {
	                    result = elements.slice(0, i);
	                }
	                result.push(element);
	            }
	        }
	        if (result !== undefined) {
	            return ts.setTextRange(ts.createNodeArray(result, elements.hasTrailingComma), elements);
	        }
	        return elements;
	    }
	    ts.parenthesizeListElements = parenthesizeListElements;
	    function parenthesizeExpressionForList(expression) {
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        var expressionPrecedence = ts.getExpressionPrecedence(emittedExpression);
	        var commaPrecedence = ts.getOperatorPrecedence(199 /* BinaryExpression */, 26 /* CommaToken */);
	        return expressionPrecedence > commaPrecedence
	            ? expression
	            : ts.setTextRange(ts.createParen(expression), expression);
	    }
	    ts.parenthesizeExpressionForList = parenthesizeExpressionForList;
	    function parenthesizeExpressionForExpressionStatement(expression) {
	        var emittedExpression = ts.skipPartiallyEmittedExpressions(expression);
	        if (ts.isCallExpression(emittedExpression)) {
	            var callee = emittedExpression.expression;
	            var kind = ts.skipPartiallyEmittedExpressions(callee).kind;
	            if (kind === 191 /* FunctionExpression */ || kind === 192 /* ArrowFunction */) {
	                var mutableCall = ts.getMutableClone(emittedExpression);
	                mutableCall.expression = ts.setTextRange(ts.createParen(callee), callee);
	                return recreateOuterExpressions(expression, mutableCall, 4 /* PartiallyEmittedExpressions */);
	            }
	        }
	        var leftmostExpressionKind = getLeftmostExpression(emittedExpression, /*stopAtCallExpressions*/ false).kind;
	        if (leftmostExpressionKind === 183 /* ObjectLiteralExpression */ || leftmostExpressionKind === 191 /* FunctionExpression */) {
	            return ts.setTextRange(ts.createParen(expression), expression);
	        }
	        return expression;
	    }
	    ts.parenthesizeExpressionForExpressionStatement = parenthesizeExpressionForExpressionStatement;
	    function parenthesizeConditionalTypeMember(member) {
	        return member.kind === 170 /* ConditionalType */ ? ts.createParenthesizedType(member) : member;
	    }
	    ts.parenthesizeConditionalTypeMember = parenthesizeConditionalTypeMember;
	    function parenthesizeElementTypeMember(member) {
	        switch (member.kind) {
	            case 168 /* UnionType */:
	            case 169 /* IntersectionType */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return ts.createParenthesizedType(member);
	        }
	        return parenthesizeConditionalTypeMember(member);
	    }
	    ts.parenthesizeElementTypeMember = parenthesizeElementTypeMember;
	    function parenthesizeArrayTypeMember(member) {
	        switch (member.kind) {
	            case 164 /* TypeQuery */:
	            case 174 /* TypeOperator */:
	            case 171 /* InferType */:
	                return ts.createParenthesizedType(member);
	        }
	        return parenthesizeElementTypeMember(member);
	    }
	    ts.parenthesizeArrayTypeMember = parenthesizeArrayTypeMember;
	    function parenthesizeElementTypeMembers(members) {
	        return ts.createNodeArray(ts.sameMap(members, parenthesizeElementTypeMember));
	    }
	    ts.parenthesizeElementTypeMembers = parenthesizeElementTypeMembers;
	    function parenthesizeTypeParameters(typeParameters) {
	        if (ts.some(typeParameters)) {
	            var params = [];
	            for (var i = 0; i < typeParameters.length; ++i) {
	                var entry = typeParameters[i];
	                params.push(i === 0 && ts.isFunctionOrConstructorTypeNode(entry) && entry.typeParameters ?
	                    ts.createParenthesizedType(entry) :
	                    entry);
	            }
	            return ts.createNodeArray(params);
	        }
	    }
	    ts.parenthesizeTypeParameters = parenthesizeTypeParameters;
	    function getLeftmostExpression(node, stopAtCallExpressions) {
	        while (true) {
	            switch (node.kind) {
	                case 198 /* PostfixUnaryExpression */:
	                    node = node.operand;
	                    continue;
	                case 199 /* BinaryExpression */:
	                    node = node.left;
	                    continue;
	                case 200 /* ConditionalExpression */:
	                    node = node.condition;
	                    continue;
	                case 186 /* CallExpression */:
	                    if (stopAtCallExpressions) {
	                        return node;
	                    }
	                // falls through
	                case 185 /* ElementAccessExpression */:
	                case 184 /* PropertyAccessExpression */:
	                    node = node.expression;
	                    continue;
	                case 300 /* PartiallyEmittedExpression */:
	                    node = node.expression;
	                    continue;
	            }
	            return node;
	        }
	    }
	    function parenthesizeConciseBody(body) {
	        if (!ts.isBlock(body) && getLeftmostExpression(body, /*stopAtCallExpressions*/ false).kind === 183 /* ObjectLiteralExpression */) {
	            return ts.setTextRange(ts.createParen(body), body);
	        }
	        return body;
	    }
	    ts.parenthesizeConciseBody = parenthesizeConciseBody;
	    var OuterExpressionKinds;
	    (function (OuterExpressionKinds) {
	        OuterExpressionKinds[OuterExpressionKinds["Parentheses"] = 1] = "Parentheses";
	        OuterExpressionKinds[OuterExpressionKinds["Assertions"] = 2] = "Assertions";
	        OuterExpressionKinds[OuterExpressionKinds["PartiallyEmittedExpressions"] = 4] = "PartiallyEmittedExpressions";
	        OuterExpressionKinds[OuterExpressionKinds["All"] = 7] = "All";
	    })(OuterExpressionKinds = ts.OuterExpressionKinds || (ts.OuterExpressionKinds = {}));
	    function isOuterExpression(node, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        switch (node.kind) {
	            case 190 /* ParenthesizedExpression */:
	                return (kinds & 1 /* Parentheses */) !== 0;
	            case 189 /* TypeAssertionExpression */:
	            case 207 /* AsExpression */:
	            case 208 /* NonNullExpression */:
	                return (kinds & 2 /* Assertions */) !== 0;
	            case 300 /* PartiallyEmittedExpression */:
	                return (kinds & 4 /* PartiallyEmittedExpressions */) !== 0;
	        }
	        return false;
	    }
	    ts.isOuterExpression = isOuterExpression;
	    function skipOuterExpressions(node, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        var previousNode;
	        do {
	            previousNode = node;
	            if (kinds & 1 /* Parentheses */) {
	                node = ts.skipParentheses(node);
	            }
	            if (kinds & 2 /* Assertions */) {
	                node = skipAssertions(node);
	            }
	            if (kinds & 4 /* PartiallyEmittedExpressions */) {
	                node = ts.skipPartiallyEmittedExpressions(node);
	            }
	        } while (previousNode !== node);
	        return node;
	    }
	    ts.skipOuterExpressions = skipOuterExpressions;
	    function skipAssertions(node) {
	        while (ts.isAssertionExpression(node) || node.kind === 208 /* NonNullExpression */) {
	            node = node.expression;
	        }
	        return node;
	    }
	    ts.skipAssertions = skipAssertions;
	    function updateOuterExpression(outerExpression, expression) {
	        switch (outerExpression.kind) {
	            case 190 /* ParenthesizedExpression */: return ts.updateParen(outerExpression, expression);
	            case 189 /* TypeAssertionExpression */: return ts.updateTypeAssertion(outerExpression, outerExpression.type, expression);
	            case 207 /* AsExpression */: return ts.updateAsExpression(outerExpression, expression, outerExpression.type);
	            case 208 /* NonNullExpression */: return ts.updateNonNullExpression(outerExpression, expression);
	            case 300 /* PartiallyEmittedExpression */: return ts.updatePartiallyEmittedExpression(outerExpression, expression);
	        }
	    }
	    /**
	     * Determines whether a node is a parenthesized expression that can be ignored when recreating outer expressions.
	     *
	     * A parenthesized expression can be ignored when all of the following are true:
	     *
	     * - It's `pos` and `end` are not -1
	     * - It does not have a custom source map range
	     * - It does not have a custom comment range
	     * - It does not have synthetic leading or trailing comments
	     *
	     * If an outermost parenthesized expression is ignored, but the containing expression requires a parentheses around
	     * the expression to maintain precedence, a new parenthesized expression should be created automatically when
	     * the containing expression is created/updated.
	     */
	    function isIgnorableParen(node) {
	        return node.kind === 190 /* ParenthesizedExpression */
	            && ts.nodeIsSynthesized(node)
	            && ts.nodeIsSynthesized(ts.getSourceMapRange(node))
	            && ts.nodeIsSynthesized(ts.getCommentRange(node))
	            && !ts.some(ts.getSyntheticLeadingComments(node))
	            && !ts.some(ts.getSyntheticTrailingComments(node));
	    }
	    function recreateOuterExpressions(outerExpression, innerExpression, kinds) {
	        if (kinds === void 0) { kinds = 7 /* All */; }
	        if (outerExpression && isOuterExpression(outerExpression, kinds) && !isIgnorableParen(outerExpression)) {
	            return updateOuterExpression(outerExpression, recreateOuterExpressions(outerExpression.expression, innerExpression));
	        }
	        return innerExpression;
	    }
	    ts.recreateOuterExpressions = recreateOuterExpressions;
	    function startOnNewLine(node) {
	        return ts.setStartsOnNewLine(node, /*newLine*/ true);
	    }
	    ts.startOnNewLine = startOnNewLine;
	    function getExternalHelpersModuleName(node) {
	        var parseNode = ts.getOriginalNode(node, ts.isSourceFile);
	        var emitNode = parseNode && parseNode.emitNode;
	        return emitNode && emitNode.externalHelpersModuleName;
	    }
	    ts.getExternalHelpersModuleName = getExternalHelpersModuleName;
	    function getOrCreateExternalHelpersModuleNameIfNeeded(node, compilerOptions, hasExportStarsToExportValues, hasImportStarOrImportDefault) {
	        if (compilerOptions.importHelpers && ts.isEffectiveExternalModule(node, compilerOptions)) {
	            var externalHelpersModuleName = getExternalHelpersModuleName(node);
	            if (externalHelpersModuleName) {
	                return externalHelpersModuleName;
	            }
	            var moduleKind = ts.getEmitModuleKind(compilerOptions);
	            var create = (hasExportStarsToExportValues || (compilerOptions.esModuleInterop && hasImportStarOrImportDefault))
	                && moduleKind !== ts.ModuleKind.System
	                && moduleKind !== ts.ModuleKind.ES2015
	                && moduleKind !== ts.ModuleKind.ESNext;
	            if (!create) {
	                var helpers = ts.getEmitHelpers(node);
	                if (helpers) {
	                    for (var _i = 0, helpers_2 = helpers; _i < helpers_2.length; _i++) {
	                        var helper = helpers_2[_i];
	                        if (!helper.scoped) {
	                            create = true;
	                            break;
	                        }
	                    }
	                }
	            }
	            if (create) {
	                var parseNode = ts.getOriginalNode(node, ts.isSourceFile);
	                var emitNode = ts.getOrCreateEmitNode(parseNode);
	                return emitNode.externalHelpersModuleName || (emitNode.externalHelpersModuleName = ts.createUniqueName(ts.externalHelpersModuleNameText));
	            }
	        }
	    }
	    ts.getOrCreateExternalHelpersModuleNameIfNeeded = getOrCreateExternalHelpersModuleNameIfNeeded;
	    /**
	     * Get the name of that target module from an import or export declaration
	     */
	    function getLocalNameForExternalImport(node, sourceFile) {
	        var namespaceDeclaration = ts.getNamespaceDeclarationNode(node);
	        if (namespaceDeclaration && !ts.isDefaultImport(node)) {
	            var name = namespaceDeclaration.name;
	            return ts.isGeneratedIdentifier(name) ? name : ts.createIdentifier(ts.getSourceTextOfNodeFromSourceFile(sourceFile, name) || ts.idText(name));
	        }
	        if (node.kind === 243 /* ImportDeclaration */ && node.importClause) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        if (node.kind === 249 /* ExportDeclaration */ && node.moduleSpecifier) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        return undefined;
	    }
	    ts.getLocalNameForExternalImport = getLocalNameForExternalImport;
	    /**
	     * Get the name of a target module from an import/export declaration as should be written in the emitted output.
	     * The emitted output name can be different from the input if:
	     *  1. The module has a /// <amd-module name="<new name>" />
	     *  2. --out or --outFile is used, making the name relative to the rootDir
	     *  3- The containing SourceFile has an entry in renamedDependencies for the import as requested by some module loaders (e.g. System).
	     * Otherwise, a new StringLiteral node representing the module name will be returned.
	     */
	    function getExternalModuleNameLiteral(importNode, sourceFile, host, resolver, compilerOptions) {
	        var moduleName = ts.getExternalModuleName(importNode);
	        if (moduleName.kind === 9 /* StringLiteral */) {
	            return tryGetModuleNameFromDeclaration(importNode, host, resolver, compilerOptions)
	                || tryRenameExternalModule(moduleName, sourceFile)
	                || ts.getSynthesizedClone(moduleName);
	        }
	        return undefined;
	    }
	    ts.getExternalModuleNameLiteral = getExternalModuleNameLiteral;
	    /**
	     * Some bundlers (SystemJS builder) sometimes want to rename dependencies.
	     * Here we check if alternative name was provided for a given moduleName and return it if possible.
	     */
	    function tryRenameExternalModule(moduleName, sourceFile) {
	        var rename = sourceFile.renamedDependencies && sourceFile.renamedDependencies.get(moduleName.text);
	        return rename && ts.createLiteral(rename);
	    }
	    /**
	     * Get the name of a module as should be written in the emitted output.
	     * The emitted output name can be different from the input if:
	     *  1. The module has a /// <amd-module name="<new name>" />
	     *  2. --out or --outFile is used, making the name relative to the rootDir
	     * Otherwise, a new StringLiteral node representing the module name will be returned.
	     */
	    function tryGetModuleNameFromFile(file, host, options) {
	        if (!file) {
	            return undefined;
	        }
	        if (file.moduleName) {
	            return ts.createLiteral(file.moduleName);
	        }
	        if (!file.isDeclarationFile && (options.out || options.outFile)) {
	            return ts.createLiteral(ts.getExternalModuleNameFromPath(host, file.fileName));
	        }
	        return undefined;
	    }
	    ts.tryGetModuleNameFromFile = tryGetModuleNameFromFile;
	    function tryGetModuleNameFromDeclaration(declaration, host, resolver, compilerOptions) {
	        return tryGetModuleNameFromFile(resolver.getExternalModuleFileFromDeclaration(declaration), host, compilerOptions);
	    }
	    /**
	     * Gets the initializer of an BindingOrAssignmentElement.
	     */
	    function getInitializerOfBindingOrAssignmentElement(bindingElement) {
	        if (ts.isDeclarationBindingElement(bindingElement)) {
	            // `1` in `let { a = 1 } = ...`
	            // `1` in `let { a: b = 1 } = ...`
	            // `1` in `let { a: {b} = 1 } = ...`
	            // `1` in `let { a: [b] = 1 } = ...`
	            // `1` in `let [a = 1] = ...`
	            // `1` in `let [{a} = 1] = ...`
	            // `1` in `let [[a] = 1] = ...`
	            return bindingElement.initializer;
	        }
	        if (ts.isPropertyAssignment(bindingElement)) {
	            // `1` in `({ a: b = 1 } = ...)`
	            // `1` in `({ a: {b} = 1 } = ...)`
	            // `1` in `({ a: [b] = 1 } = ...)`
	            return ts.isAssignmentExpression(bindingElement.initializer, /*excludeCompoundAssignment*/ true)
	                ? bindingElement.initializer.right
	                : undefined;
	        }
	        if (ts.isShorthandPropertyAssignment(bindingElement)) {
	            // `1` in `({ a = 1 } = ...)`
	            return bindingElement.objectAssignmentInitializer;
	        }
	        if (ts.isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) {
	            // `1` in `[a = 1] = ...`
	            // `1` in `[{a} = 1] = ...`
	            // `1` in `[[a] = 1] = ...`
	            return bindingElement.right;
	        }
	        if (ts.isSpreadElement(bindingElement)) {
	            // Recovery consistent with existing emit.
	            return getInitializerOfBindingOrAssignmentElement(bindingElement.expression);
	        }
	    }
	    ts.getInitializerOfBindingOrAssignmentElement = getInitializerOfBindingOrAssignmentElement;
	    /**
	     * Gets the name of an BindingOrAssignmentElement.
	     */
	    function getTargetOfBindingOrAssignmentElement(bindingElement) {
	        if (ts.isDeclarationBindingElement(bindingElement)) {
	            // `a` in `let { a } = ...`
	            // `a` in `let { a = 1 } = ...`
	            // `b` in `let { a: b } = ...`
	            // `b` in `let { a: b = 1 } = ...`
	            // `a` in `let { ...a } = ...`
	            // `{b}` in `let { a: {b} } = ...`
	            // `{b}` in `let { a: {b} = 1 } = ...`
	            // `[b]` in `let { a: [b] } = ...`
	            // `[b]` in `let { a: [b] = 1 } = ...`
	            // `a` in `let [a] = ...`
	            // `a` in `let [a = 1] = ...`
	            // `a` in `let [...a] = ...`
	            // `{a}` in `let [{a}] = ...`
	            // `{a}` in `let [{a} = 1] = ...`
	            // `[a]` in `let [[a]] = ...`
	            // `[a]` in `let [[a] = 1] = ...`
	            return bindingElement.name;
	        }
	        if (ts.isObjectLiteralElementLike(bindingElement)) {
	            switch (bindingElement.kind) {
	                case 269 /* PropertyAssignment */:
	                    // `b` in `({ a: b } = ...)`
	                    // `b` in `({ a: b = 1 } = ...)`
	                    // `{b}` in `({ a: {b} } = ...)`
	                    // `{b}` in `({ a: {b} = 1 } = ...)`
	                    // `[b]` in `({ a: [b] } = ...)`
	                    // `[b]` in `({ a: [b] = 1 } = ...)`
	                    // `b.c` in `({ a: b.c } = ...)`
	                    // `b.c` in `({ a: b.c = 1 } = ...)`
	                    // `b[0]` in `({ a: b[0] } = ...)`
	                    // `b[0]` in `({ a: b[0] = 1 } = ...)`
	                    return getTargetOfBindingOrAssignmentElement(bindingElement.initializer);
	                case 270 /* ShorthandPropertyAssignment */:
	                    // `a` in `({ a } = ...)`
	                    // `a` in `({ a = 1 } = ...)`
	                    return bindingElement.name;
	                case 271 /* SpreadAssignment */:
	                    // `a` in `({ ...a } = ...)`
	                    return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
	            }
	            // no target
	            return undefined;
	        }
	        if (ts.isAssignmentExpression(bindingElement, /*excludeCompoundAssignment*/ true)) {
	            // `a` in `[a = 1] = ...`
	            // `{a}` in `[{a} = 1] = ...`
	            // `[a]` in `[[a] = 1] = ...`
	            // `a.b` in `[a.b = 1] = ...`
	            // `a[0]` in `[a[0] = 1] = ...`
	            return getTargetOfBindingOrAssignmentElement(bindingElement.left);
	        }
	        if (ts.isSpreadElement(bindingElement)) {
	            // `a` in `[...a] = ...`
	            return getTargetOfBindingOrAssignmentElement(bindingElement.expression);
	        }
	        // `a` in `[a] = ...`
	        // `{a}` in `[{a}] = ...`
	        // `[a]` in `[[a]] = ...`
	        // `a.b` in `[a.b] = ...`
	        // `a[0]` in `[a[0]] = ...`
	        return bindingElement;
	    }
	    ts.getTargetOfBindingOrAssignmentElement = getTargetOfBindingOrAssignmentElement;
	    /**
	     * Determines whether an BindingOrAssignmentElement is a rest element.
	     */
	    function getRestIndicatorOfBindingOrAssignmentElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 148 /* Parameter */:
	            case 181 /* BindingElement */:
	                // `...` in `let [...a] = ...`
	                return bindingElement.dotDotDotToken;
	            case 203 /* SpreadElement */:
	            case 271 /* SpreadAssignment */:
	                // `...` in `[...a] = ...`
	                return bindingElement;
	        }
	        return undefined;
	    }
	    ts.getRestIndicatorOfBindingOrAssignmentElement = getRestIndicatorOfBindingOrAssignmentElement;
	    /**
	     * Gets the property name of a BindingOrAssignmentElement
	     */
	    function getPropertyNameOfBindingOrAssignmentElement(bindingElement) {
	        switch (bindingElement.kind) {
	            case 181 /* BindingElement */:
	                // `a` in `let { a: b } = ...`
	                // `[a]` in `let { [a]: b } = ...`
	                // `"a"` in `let { "a": b } = ...`
	                // `1` in `let { 1: b } = ...`
	                if (bindingElement.propertyName) {
	                    var propertyName = bindingElement.propertyName;
	                    return ts.isComputedPropertyName(propertyName) && ts.isStringOrNumericLiteral(propertyName.expression)
	                        ? propertyName.expression
	                        : propertyName;
	                }
	                break;
	            case 269 /* PropertyAssignment */:
	                // `a` in `({ a: b } = ...)`
	                // `[a]` in `({ [a]: b } = ...)`
	                // `"a"` in `({ "a": b } = ...)`
	                // `1` in `({ 1: b } = ...)`
	                if (bindingElement.name) {
	                    var propertyName = bindingElement.name;
	                    return ts.isComputedPropertyName(propertyName) && ts.isStringOrNumericLiteral(propertyName.expression)
	                        ? propertyName.expression
	                        : propertyName;
	                }
	                break;
	            case 271 /* SpreadAssignment */:
	                // `a` in `({ ...a } = ...)`
	                return bindingElement.name;
	        }
	        var target = getTargetOfBindingOrAssignmentElement(bindingElement);
	        if (target && ts.isPropertyName(target)) {
	            return ts.isComputedPropertyName(target) && ts.isStringOrNumericLiteral(target.expression)
	                ? target.expression
	                : target;
	        }
	        ts.Debug.fail("Invalid property name for binding element.");
	    }
	    ts.getPropertyNameOfBindingOrAssignmentElement = getPropertyNameOfBindingOrAssignmentElement;
	    /**
	     * Gets the elements of a BindingOrAssignmentPattern
	     */
	    function getElementsOfBindingOrAssignmentPattern(name) {
	        switch (name.kind) {
	            case 179 /* ObjectBindingPattern */:
	            case 180 /* ArrayBindingPattern */:
	            case 182 /* ArrayLiteralExpression */:
	                // `a` in `{a}`
	                // `a` in `[a]`
	                return name.elements;
	            case 183 /* ObjectLiteralExpression */:
	                // `a` in `{a}`
	                return name.properties;
	        }
	    }
	    ts.getElementsOfBindingOrAssignmentPattern = getElementsOfBindingOrAssignmentPattern;
	    function convertToArrayAssignmentElement(element) {
	        if (ts.isBindingElement(element)) {
	            if (element.dotDotDotToken) {
	                ts.Debug.assertNode(element.name, ts.isIdentifier);
	                return ts.setOriginalNode(ts.setTextRange(ts.createSpread(element.name), element), element);
	            }
	            var expression = convertToAssignmentElementTarget(element.name);
	            return element.initializer
	                ? ts.setOriginalNode(ts.setTextRange(ts.createAssignment(expression, element.initializer), element), element)
	                : expression;
	        }
	        ts.Debug.assertNode(element, ts.isExpression);
	        return element;
	    }
	    ts.convertToArrayAssignmentElement = convertToArrayAssignmentElement;
	    function convertToObjectAssignmentElement(element) {
	        if (ts.isBindingElement(element)) {
	            if (element.dotDotDotToken) {
	                ts.Debug.assertNode(element.name, ts.isIdentifier);
	                return ts.setOriginalNode(ts.setTextRange(ts.createSpreadAssignment(element.name), element), element);
	            }
	            if (element.propertyName) {
	                var expression = convertToAssignmentElementTarget(element.name);
	                return ts.setOriginalNode(ts.setTextRange(ts.createPropertyAssignment(element.propertyName, element.initializer ? ts.createAssignment(expression, element.initializer) : expression), element), element);
	            }
	            ts.Debug.assertNode(element.name, ts.isIdentifier);
	            return ts.setOriginalNode(ts.setTextRange(ts.createShorthandPropertyAssignment(element.name, element.initializer), element), element);
	        }
	        ts.Debug.assertNode(element, ts.isObjectLiteralElementLike);
	        return element;
	    }
	    ts.convertToObjectAssignmentElement = convertToObjectAssignmentElement;
	    function convertToAssignmentPattern(node) {
	        switch (node.kind) {
	            case 180 /* ArrayBindingPattern */:
	            case 182 /* ArrayLiteralExpression */:
	                return convertToArrayAssignmentPattern(node);
	            case 179 /* ObjectBindingPattern */:
	            case 183 /* ObjectLiteralExpression */:
	                return convertToObjectAssignmentPattern(node);
	        }
	    }
	    ts.convertToAssignmentPattern = convertToAssignmentPattern;
	    function convertToObjectAssignmentPattern(node) {
	        if (ts.isObjectBindingPattern(node)) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createObjectLiteral(ts.map(node.elements, convertToObjectAssignmentElement)), node), node);
	        }
	        ts.Debug.assertNode(node, ts.isObjectLiteralExpression);
	        return node;
	    }
	    ts.convertToObjectAssignmentPattern = convertToObjectAssignmentPattern;
	    function convertToArrayAssignmentPattern(node) {
	        if (ts.isArrayBindingPattern(node)) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createArrayLiteral(ts.map(node.elements, convertToArrayAssignmentElement)), node), node);
	        }
	        ts.Debug.assertNode(node, ts.isArrayLiteralExpression);
	        return node;
	    }
	    ts.convertToArrayAssignmentPattern = convertToArrayAssignmentPattern;
	    function convertToAssignmentElementTarget(node) {
	        if (ts.isBindingPattern(node)) {
	            return convertToAssignmentPattern(node);
	        }
	        ts.Debug.assertNode(node, ts.isExpression);
	        return node;
	    }
	    ts.convertToAssignmentElementTarget = convertToAssignmentElementTarget;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var isTypeNodeOrTypeParameterDeclaration = ts.or(ts.isTypeNode, ts.isTypeParameterDeclaration);
	    function visitNode(node, visitor, test, lift) {
	        if (node === undefined || visitor === undefined) {
	            return node;
	        }
	        ts.aggregateTransformFlags(node);
	        var visited = visitor(node);
	        if (visited === node) {
	            return node;
	        }
	        var visitedNode;
	        if (visited === undefined) {
	            return undefined;
	        }
	        else if (ts.isArray(visited)) {
	            visitedNode = (lift || extractSingleNode)(visited);
	        }
	        else {
	            visitedNode = visited;
	        }
	        ts.Debug.assertNode(visitedNode, test);
	        ts.aggregateTransformFlags(visitedNode);
	        return visitedNode;
	    }
	    ts.visitNode = visitNode;
	    /**
	     * Visits a NodeArray using the supplied visitor, possibly returning a new NodeArray in its place.
	     *
	     * @param nodes The NodeArray to visit.
	     * @param visitor The callback used to visit a Node.
	     * @param test A node test to execute for each node.
	     * @param start An optional value indicating the starting offset at which to start visiting.
	     * @param count An optional value indicating the maximum number of nodes to visit.
	     */
	    function visitNodes(nodes, visitor, test, start, count) {
	        if (nodes === undefined || visitor === undefined) {
	            return nodes;
	        }
	        var updated;
	        // Ensure start and count have valid values
	        var length = nodes.length;
	        if (start === undefined || start < 0) {
	            start = 0;
	        }
	        if (count === undefined || count > length - start) {
	            count = length - start;
	        }
	        if (start > 0 || count < length) {
	            // If we are not visiting all of the original nodes, we must always create a new array.
	            // Since this is a fragment of a node array, we do not copy over the previous location
	            // and will only copy over `hasTrailingComma` if we are including the last element.
	            updated = ts.createNodeArray([], /*hasTrailingComma*/ nodes.hasTrailingComma && start + count === length);
	        }
	        // Visit each original node.
	        for (var i = 0; i < count; i++) {
	            var node = nodes[i + start];
	            ts.aggregateTransformFlags(node);
	            var visited = node !== undefined ? visitor(node) : undefined;
	            if (updated !== undefined || visited === undefined || visited !== node) {
	                if (updated === undefined) {
	                    // Ensure we have a copy of `nodes`, up to the current index.
	                    updated = ts.createNodeArray(nodes.slice(0, i), nodes.hasTrailingComma);
	                    ts.setTextRange(updated, nodes);
	                }
	                if (visited) {
	                    if (ts.isArray(visited)) {
	                        for (var _i = 0, visited_1 = visited; _i < visited_1.length; _i++) {
	                            var visitedNode = visited_1[_i];
	                            ts.Debug.assertNode(visitedNode, test);
	                            ts.aggregateTransformFlags(visitedNode);
	                            updated.push(visitedNode);
	                        }
	                    }
	                    else {
	                        ts.Debug.assertNode(visited, test);
	                        ts.aggregateTransformFlags(visited);
	                        updated.push(visited);
	                    }
	                }
	            }
	        }
	        return updated || nodes;
	    }
	    ts.visitNodes = visitNodes;
	    /**
	     * Starts a new lexical environment and visits a statement list, ending the lexical environment
	     * and merging hoisted declarations upon completion.
	     */
	    function visitLexicalEnvironment(statements, visitor, context, start, ensureUseStrict) {
	        context.startLexicalEnvironment();
	        statements = visitNodes(statements, visitor, ts.isStatement, start);
	        if (ensureUseStrict && !ts.startsWithUseStrict(statements)) {
	            statements = ts.setTextRange(ts.createNodeArray([ts.createStatement(ts.createLiteral("use strict"))].concat(statements)), statements);
	        }
	        var declarations = context.endLexicalEnvironment();
	        return ts.setTextRange(ts.createNodeArray(ts.concatenate(declarations, statements)), statements);
	    }
	    ts.visitLexicalEnvironment = visitLexicalEnvironment;
	    /**
	     * Starts a new lexical environment and visits a parameter list, suspending the lexical
	     * environment upon completion.
	     */
	    function visitParameterList(nodes, visitor, context, nodesVisitor) {
	        if (nodesVisitor === void 0) { nodesVisitor = visitNodes; }
	        context.startLexicalEnvironment();
	        var updated = nodesVisitor(nodes, visitor, ts.isParameterDeclaration);
	        context.suspendLexicalEnvironment();
	        return updated;
	    }
	    ts.visitParameterList = visitParameterList;
	    function visitFunctionBody(node, visitor, context) {
	        context.resumeLexicalEnvironment();
	        var updated = visitNode(node, visitor, ts.isConciseBody);
	        var declarations = context.endLexicalEnvironment();
	        if (ts.some(declarations)) {
	            var block = ts.convertToFunctionBody(updated);
	            var statements = ts.mergeLexicalEnvironment(block.statements, declarations);
	            return ts.updateBlock(block, statements);
	        }
	        return updated;
	    }
	    ts.visitFunctionBody = visitFunctionBody;
	    function visitEachChild(node, visitor, context, nodesVisitor, tokenVisitor) {
	        if (nodesVisitor === void 0) { nodesVisitor = visitNodes; }
	        if (node === undefined) {
	            return undefined;
	        }
	        var kind = node.kind;
	        // No need to visit nodes with no children.
	        if ((kind > 0 /* FirstToken */ && kind <= 144 /* LastToken */) || kind === 173 /* ThisType */) {
	            return node;
	        }
	        switch (kind) {
	            // Names
	            case 71 /* Identifier */:
	                return ts.updateIdentifier(node, nodesVisitor(node.typeArguments, visitor, isTypeNodeOrTypeParameterDeclaration));
	            case 145 /* QualifiedName */:
	                return ts.updateQualifiedName(node, visitNode(node.left, visitor, ts.isEntityName), visitNode(node.right, visitor, ts.isIdentifier));
	            case 146 /* ComputedPropertyName */:
	                return ts.updateComputedPropertyName(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Signature elements
	            case 147 /* TypeParameter */:
	                return ts.updateTypeParameterDeclaration(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.constraint, visitor, ts.isTypeNode), visitNode(node.default, visitor, ts.isTypeNode));
	            case 148 /* Parameter */:
	                return ts.updateParameter(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.dotDotDotToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isBindingName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 149 /* Decorator */:
	                return ts.updateDecorator(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Type elements
	            case 150 /* PropertySignature */:
	                return ts.updatePropertySignature(node, nodesVisitor(node.modifiers, visitor, ts.isToken), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 151 /* PropertyDeclaration */:
	                return ts.updateProperty(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 152 /* MethodSignature */:
	                return ts.updateMethodSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken));
	            case 153 /* MethodDeclaration */:
	                return ts.updateMethod(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.questionToken, tokenVisitor, ts.isToken), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 154 /* Constructor */:
	                return ts.updateConstructor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context));
	            case 155 /* GetAccessor */:
	                return ts.updateGetAccessor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 156 /* SetAccessor */:
	                return ts.updateSetAccessor(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isPropertyName), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitFunctionBody(node.body, visitor, context));
	            case 157 /* CallSignature */:
	                return ts.updateCallSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 158 /* ConstructSignature */:
	                return ts.updateConstructSignature(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 159 /* IndexSignature */:
	                return ts.updateIndexSignature(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            // Types
	            case 160 /* TypePredicate */:
	                return ts.updateTypePredicateNode(node, visitNode(node.parameterName, visitor), visitNode(node.type, visitor, ts.isTypeNode));
	            case 161 /* TypeReference */:
	                return ts.updateTypeReferenceNode(node, visitNode(node.typeName, visitor, ts.isEntityName), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode));
	            case 162 /* FunctionType */:
	                return ts.updateFunctionTypeNode(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 163 /* ConstructorType */:
	                return ts.updateConstructorTypeNode(node, nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.parameters, visitor, ts.isParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 164 /* TypeQuery */:
	                return ts.updateTypeQueryNode(node, visitNode(node.exprName, visitor, ts.isEntityName));
	            case 165 /* TypeLiteral */:
	                return ts.updateTypeLiteralNode(node, nodesVisitor(node.members, visitor, ts.isTypeElement));
	            case 166 /* ArrayType */:
	                return ts.updateArrayTypeNode(node, visitNode(node.elementType, visitor, ts.isTypeNode));
	            case 167 /* TupleType */:
	                return ts.updateTypleTypeNode(node, nodesVisitor(node.elementTypes, visitor, ts.isTypeNode));
	            case 168 /* UnionType */:
	                return ts.updateUnionTypeNode(node, nodesVisitor(node.types, visitor, ts.isTypeNode));
	            case 169 /* IntersectionType */:
	                return ts.updateIntersectionTypeNode(node, nodesVisitor(node.types, visitor, ts.isTypeNode));
	            case 170 /* ConditionalType */:
	                return ts.updateConditionalTypeNode(node, visitNode(node.checkType, visitor, ts.isTypeNode), visitNode(node.extendsType, visitor, ts.isTypeNode), visitNode(node.trueType, visitor, ts.isTypeNode), visitNode(node.falseType, visitor, ts.isTypeNode));
	            case 171 /* InferType */:
	                return ts.updateInferTypeNode(node, visitNode(node.typeParameter, visitor, ts.isTypeParameterDeclaration));
	            case 178 /* ImportType */:
	                return ts.updateImportTypeNode(node, visitNode(node.argument, visitor, ts.isTypeNode), visitNode(node.qualifier, visitor, ts.isEntityName), visitNodes(node.typeArguments, visitor, ts.isTypeNode), node.isTypeOf);
	            case 172 /* ParenthesizedType */:
	                return ts.updateParenthesizedType(node, visitNode(node.type, visitor, ts.isTypeNode));
	            case 174 /* TypeOperator */:
	                return ts.updateTypeOperatorNode(node, visitNode(node.type, visitor, ts.isTypeNode));
	            case 175 /* IndexedAccessType */:
	                return ts.updateIndexedAccessTypeNode(node, visitNode(node.objectType, visitor, ts.isTypeNode), visitNode(node.indexType, visitor, ts.isTypeNode));
	            case 176 /* MappedType */:
	                return ts.updateMappedTypeNode(node, visitNode(node.readonlyToken, tokenVisitor, ts.isToken), visitNode(node.typeParameter, visitor, ts.isTypeParameterDeclaration), visitNode(node.questionToken, tokenVisitor, ts.isToken), visitNode(node.type, visitor, ts.isTypeNode));
	            case 177 /* LiteralType */:
	                return ts.updateLiteralTypeNode(node, visitNode(node.literal, visitor, ts.isExpression));
	            // Binding patterns
	            case 179 /* ObjectBindingPattern */:
	                return ts.updateObjectBindingPattern(node, nodesVisitor(node.elements, visitor, ts.isBindingElement));
	            case 180 /* ArrayBindingPattern */:
	                return ts.updateArrayBindingPattern(node, nodesVisitor(node.elements, visitor, ts.isArrayBindingElement));
	            case 181 /* BindingElement */:
	                return ts.updateBindingElement(node, visitNode(node.dotDotDotToken, tokenVisitor, ts.isToken), visitNode(node.propertyName, visitor, ts.isPropertyName), visitNode(node.name, visitor, ts.isBindingName), visitNode(node.initializer, visitor, ts.isExpression));
	            // Expression
	            case 182 /* ArrayLiteralExpression */:
	                return ts.updateArrayLiteral(node, nodesVisitor(node.elements, visitor, ts.isExpression));
	            case 183 /* ObjectLiteralExpression */:
	                return ts.updateObjectLiteral(node, nodesVisitor(node.properties, visitor, ts.isObjectLiteralElementLike));
	            case 184 /* PropertyAccessExpression */:
	                return ts.updatePropertyAccess(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.name, visitor, ts.isIdentifier));
	            case 185 /* ElementAccessExpression */:
	                return ts.updateElementAccess(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.argumentExpression, visitor, ts.isExpression));
	            case 186 /* CallExpression */:
	                return ts.updateCall(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), nodesVisitor(node.arguments, visitor, ts.isExpression));
	            case 187 /* NewExpression */:
	                return ts.updateNew(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), nodesVisitor(node.arguments, visitor, ts.isExpression));
	            case 188 /* TaggedTemplateExpression */:
	                return ts.updateTaggedTemplate(node, visitNode(node.tag, visitor, ts.isExpression), visitNodes(node.typeArguments, visitor, ts.isExpression), visitNode(node.template, visitor, ts.isTemplateLiteral));
	            case 189 /* TypeAssertionExpression */:
	                return ts.updateTypeAssertion(node, visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.expression, visitor, ts.isExpression));
	            case 190 /* ParenthesizedExpression */:
	                return ts.updateParen(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 191 /* FunctionExpression */:
	                return ts.updateFunctionExpression(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 192 /* ArrowFunction */:
	                return ts.updateArrowFunction(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.equalsGreaterThanToken, visitor, ts.isToken), visitFunctionBody(node.body, visitor, context));
	            case 193 /* DeleteExpression */:
	                return ts.updateDelete(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 194 /* TypeOfExpression */:
	                return ts.updateTypeOf(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 195 /* VoidExpression */:
	                return ts.updateVoid(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 196 /* AwaitExpression */:
	                return ts.updateAwait(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 197 /* PrefixUnaryExpression */:
	                return ts.updatePrefix(node, visitNode(node.operand, visitor, ts.isExpression));
	            case 198 /* PostfixUnaryExpression */:
	                return ts.updatePostfix(node, visitNode(node.operand, visitor, ts.isExpression));
	            case 199 /* BinaryExpression */:
	                return ts.updateBinary(node, visitNode(node.left, visitor, ts.isExpression), visitNode(node.right, visitor, ts.isExpression), visitNode(node.operatorToken, visitor, ts.isToken));
	            case 200 /* ConditionalExpression */:
	                return ts.updateConditional(node, visitNode(node.condition, visitor, ts.isExpression), visitNode(node.questionToken, visitor, ts.isToken), visitNode(node.whenTrue, visitor, ts.isExpression), visitNode(node.colonToken, visitor, ts.isToken), visitNode(node.whenFalse, visitor, ts.isExpression));
	            case 201 /* TemplateExpression */:
	                return ts.updateTemplateExpression(node, visitNode(node.head, visitor, ts.isTemplateHead), nodesVisitor(node.templateSpans, visitor, ts.isTemplateSpan));
	            case 202 /* YieldExpression */:
	                return ts.updateYield(node, visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.expression, visitor, ts.isExpression));
	            case 203 /* SpreadElement */:
	                return ts.updateSpread(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 204 /* ClassExpression */:
	                return ts.updateClassExpression(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isClassElement));
	            case 206 /* ExpressionWithTypeArguments */:
	                return ts.updateExpressionWithTypeArguments(node, nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), visitNode(node.expression, visitor, ts.isExpression));
	            case 207 /* AsExpression */:
	                return ts.updateAsExpression(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.type, visitor, ts.isTypeNode));
	            case 208 /* NonNullExpression */:
	                return ts.updateNonNullExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 209 /* MetaProperty */:
	                return ts.updateMetaProperty(node, visitNode(node.name, visitor, ts.isIdentifier));
	            // Misc
	            case 210 /* TemplateSpan */:
	                return ts.updateTemplateSpan(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.literal, visitor, ts.isTemplateMiddleOrTemplateTail));
	            // Element
	            case 212 /* Block */:
	                return ts.updateBlock(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 213 /* VariableStatement */:
	                return ts.updateVariableStatement(node, nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.declarationList, visitor, ts.isVariableDeclarationList));
	            case 215 /* ExpressionStatement */:
	                return ts.updateStatement(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 216 /* IfStatement */:
	                return ts.updateIf(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.thenStatement, visitor, ts.isStatement, ts.liftToBlock), visitNode(node.elseStatement, visitor, ts.isStatement, ts.liftToBlock));
	            case 217 /* DoStatement */:
	                return ts.updateDo(node, visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock), visitNode(node.expression, visitor, ts.isExpression));
	            case 218 /* WhileStatement */:
	                return ts.updateWhile(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 219 /* ForStatement */:
	                return ts.updateFor(node, visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.condition, visitor, ts.isExpression), visitNode(node.incrementor, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 220 /* ForInStatement */:
	                return ts.updateForIn(node, visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 221 /* ForOfStatement */:
	                return ts.updateForOf(node, visitNode(node.awaitModifier, visitor, ts.isToken), visitNode(node.initializer, visitor, ts.isForInitializer), visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 222 /* ContinueStatement */:
	                return ts.updateContinue(node, visitNode(node.label, visitor, ts.isIdentifier));
	            case 223 /* BreakStatement */:
	                return ts.updateBreak(node, visitNode(node.label, visitor, ts.isIdentifier));
	            case 224 /* ReturnStatement */:
	                return ts.updateReturn(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 225 /* WithStatement */:
	                return ts.updateWith(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 226 /* SwitchStatement */:
	                return ts.updateSwitch(node, visitNode(node.expression, visitor, ts.isExpression), visitNode(node.caseBlock, visitor, ts.isCaseBlock));
	            case 227 /* LabeledStatement */:
	                return ts.updateLabel(node, visitNode(node.label, visitor, ts.isIdentifier), visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            case 228 /* ThrowStatement */:
	                return ts.updateThrow(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 229 /* TryStatement */:
	                return ts.updateTry(node, visitNode(node.tryBlock, visitor, ts.isBlock), visitNode(node.catchClause, visitor, ts.isCatchClause), visitNode(node.finallyBlock, visitor, ts.isBlock));
	            case 231 /* VariableDeclaration */:
	                return ts.updateVariableDeclaration(node, visitNode(node.name, visitor, ts.isBindingName), visitNode(node.type, visitor, ts.isTypeNode), visitNode(node.initializer, visitor, ts.isExpression));
	            case 232 /* VariableDeclarationList */:
	                return ts.updateVariableDeclarationList(node, nodesVisitor(node.declarations, visitor, ts.isVariableDeclaration));
	            case 233 /* FunctionDeclaration */:
	                return ts.updateFunctionDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.asteriskToken, tokenVisitor, ts.isToken), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitParameterList(node.parameters, visitor, context, nodesVisitor), visitNode(node.type, visitor, ts.isTypeNode), visitFunctionBody(node.body, visitor, context));
	            case 234 /* ClassDeclaration */:
	                return ts.updateClassDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isClassElement));
	            case 235 /* InterfaceDeclaration */:
	                return ts.updateInterfaceDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), nodesVisitor(node.heritageClauses, visitor, ts.isHeritageClause), nodesVisitor(node.members, visitor, ts.isTypeElement));
	            case 236 /* TypeAliasDeclaration */:
	                return ts.updateTypeAliasDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.typeParameters, visitor, ts.isTypeParameterDeclaration), visitNode(node.type, visitor, ts.isTypeNode));
	            case 237 /* EnumDeclaration */:
	                return ts.updateEnumDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), nodesVisitor(node.members, visitor, ts.isEnumMember));
	            case 238 /* ModuleDeclaration */:
	                return ts.updateModuleDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.body, visitor, ts.isModuleBody));
	            case 239 /* ModuleBlock */:
	                return ts.updateModuleBlock(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 240 /* CaseBlock */:
	                return ts.updateCaseBlock(node, nodesVisitor(node.clauses, visitor, ts.isCaseOrDefaultClause));
	            case 241 /* NamespaceExportDeclaration */:
	                return ts.updateNamespaceExportDeclaration(node, visitNode(node.name, visitor, ts.isIdentifier));
	            case 242 /* ImportEqualsDeclaration */:
	                return ts.updateImportEqualsDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.moduleReference, visitor, ts.isModuleReference));
	            case 243 /* ImportDeclaration */:
	                return ts.updateImportDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.importClause, visitor, ts.isImportClause), visitNode(node.moduleSpecifier, visitor, ts.isExpression));
	            case 244 /* ImportClause */:
	                return ts.updateImportClause(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.namedBindings, visitor, ts.isNamedImportBindings));
	            case 245 /* NamespaceImport */:
	                return ts.updateNamespaceImport(node, visitNode(node.name, visitor, ts.isIdentifier));
	            case 246 /* NamedImports */:
	                return ts.updateNamedImports(node, nodesVisitor(node.elements, visitor, ts.isImportSpecifier));
	            case 247 /* ImportSpecifier */:
	                return ts.updateImportSpecifier(node, visitNode(node.propertyName, visitor, ts.isIdentifier), visitNode(node.name, visitor, ts.isIdentifier));
	            case 248 /* ExportAssignment */:
	                return ts.updateExportAssignment(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.expression, visitor, ts.isExpression));
	            case 249 /* ExportDeclaration */:
	                return ts.updateExportDeclaration(node, nodesVisitor(node.decorators, visitor, ts.isDecorator), nodesVisitor(node.modifiers, visitor, ts.isModifier), visitNode(node.exportClause, visitor, ts.isNamedExports), visitNode(node.moduleSpecifier, visitor, ts.isExpression));
	            case 250 /* NamedExports */:
	                return ts.updateNamedExports(node, nodesVisitor(node.elements, visitor, ts.isExportSpecifier));
	            case 251 /* ExportSpecifier */:
	                return ts.updateExportSpecifier(node, visitNode(node.propertyName, visitor, ts.isIdentifier), visitNode(node.name, visitor, ts.isIdentifier));
	            // Module references
	            case 253 /* ExternalModuleReference */:
	                return ts.updateExternalModuleReference(node, visitNode(node.expression, visitor, ts.isExpression));
	            // JSX
	            case 254 /* JsxElement */:
	                return ts.updateJsxElement(node, visitNode(node.openingElement, visitor, ts.isJsxOpeningElement), nodesVisitor(node.children, visitor, ts.isJsxChild), visitNode(node.closingElement, visitor, ts.isJsxClosingElement));
	            case 255 /* JsxSelfClosingElement */:
	                return ts.updateJsxSelfClosingElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), visitNode(node.attributes, visitor, ts.isJsxAttributes));
	            case 256 /* JsxOpeningElement */:
	                return ts.updateJsxOpeningElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression), nodesVisitor(node.typeArguments, visitor, ts.isTypeNode), visitNode(node.attributes, visitor, ts.isJsxAttributes));
	            case 257 /* JsxClosingElement */:
	                return ts.updateJsxClosingElement(node, visitNode(node.tagName, visitor, ts.isJsxTagNameExpression));
	            case 258 /* JsxFragment */:
	                return ts.updateJsxFragment(node, visitNode(node.openingFragment, visitor, ts.isJsxOpeningFragment), nodesVisitor(node.children, visitor, ts.isJsxChild), visitNode(node.closingFragment, visitor, ts.isJsxClosingFragment));
	            case 261 /* JsxAttribute */:
	                return ts.updateJsxAttribute(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.initializer, visitor, ts.isStringLiteralOrJsxExpression));
	            case 262 /* JsxAttributes */:
	                return ts.updateJsxAttributes(node, nodesVisitor(node.properties, visitor, ts.isJsxAttributeLike));
	            case 263 /* JsxSpreadAttribute */:
	                return ts.updateJsxSpreadAttribute(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 264 /* JsxExpression */:
	                return ts.updateJsxExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Clauses
	            case 265 /* CaseClause */:
	                return ts.updateCaseClause(node, visitNode(node.expression, visitor, ts.isExpression), nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 266 /* DefaultClause */:
	                return ts.updateDefaultClause(node, nodesVisitor(node.statements, visitor, ts.isStatement));
	            case 267 /* HeritageClause */:
	                return ts.updateHeritageClause(node, nodesVisitor(node.types, visitor, ts.isExpressionWithTypeArguments));
	            case 268 /* CatchClause */:
	                return ts.updateCatchClause(node, visitNode(node.variableDeclaration, visitor, ts.isVariableDeclaration), visitNode(node.block, visitor, ts.isBlock));
	            // Property assignments
	            case 269 /* PropertyAssignment */:
	                return ts.updatePropertyAssignment(node, visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.initializer, visitor, ts.isExpression));
	            case 270 /* ShorthandPropertyAssignment */:
	                return ts.updateShorthandPropertyAssignment(node, visitNode(node.name, visitor, ts.isIdentifier), visitNode(node.objectAssignmentInitializer, visitor, ts.isExpression));
	            case 271 /* SpreadAssignment */:
	                return ts.updateSpreadAssignment(node, visitNode(node.expression, visitor, ts.isExpression));
	            // Enum
	            case 272 /* EnumMember */:
	                return ts.updateEnumMember(node, visitNode(node.name, visitor, ts.isPropertyName), visitNode(node.initializer, visitor, ts.isExpression));
	            // Top-level nodes
	            case 273 /* SourceFile */:
	                return ts.updateSourceFileNode(node, visitLexicalEnvironment(node.statements, visitor, context));
	            // Transformation nodes
	            case 300 /* PartiallyEmittedExpression */:
	                return ts.updatePartiallyEmittedExpression(node, visitNode(node.expression, visitor, ts.isExpression));
	            case 301 /* CommaListExpression */:
	                return ts.updateCommaList(node, nodesVisitor(node.elements, visitor, ts.isExpression));
	            default:
	                // No need to visit nodes with no children.
	                return node;
	        }
	    }
	    ts.visitEachChild = visitEachChild;
	    /**
	     * Extracts the single node from a NodeArray.
	     *
	     * @param nodes The NodeArray.
	     */
	    function extractSingleNode(nodes) {
	        ts.Debug.assert(nodes.length <= 1, "Too many nodes written to output.");
	        return ts.singleOrUndefined(nodes);
	    }
	})(ts || (ts = {}));
	/* @internal */
	(function (ts) {
	    function reduceNode(node, f, initial) {
	        return node ? f(initial, node) : initial;
	    }
	    function reduceNodeArray(nodes, f, initial) {
	        return nodes ? f(initial, nodes) : initial;
	    }
	    /**
	     * Similar to `reduceLeft`, performs a reduction against each child of a node.
	     * NOTE: Unlike `forEachChild`, this does *not* visit every node.
	     *
	     * @param node The node containing the children to reduce.
	     * @param initial The initial value to supply to the reduction.
	     * @param f The callback function
	     */
	    function reduceEachChild(node, initial, cbNode, cbNodeArray) {
	        if (node === undefined) {
	            return initial;
	        }
	        var reduceNodes = cbNodeArray ? reduceNodeArray : ts.reduceLeft;
	        var cbNodes = cbNodeArray || cbNode;
	        var kind = node.kind;
	        // No need to visit nodes with no children.
	        if ((kind > 0 /* FirstToken */ && kind <= 144 /* LastToken */)) {
	            return initial;
	        }
	        // We do not yet support types.
	        if ((kind >= 160 /* TypePredicate */ && kind <= 177 /* LiteralType */)) {
	            return initial;
	        }
	        var result = initial;
	        switch (node.kind) {
	            // Leaf nodes
	            case 211 /* SemicolonClassElement */:
	            case 214 /* EmptyStatement */:
	            case 205 /* OmittedExpression */:
	            case 230 /* DebuggerStatement */:
	            case 299 /* NotEmittedStatement */:
	                // No need to visit nodes with no children.
	                break;
	            // Names
	            case 145 /* QualifiedName */:
	                result = reduceNode(node.left, cbNode, result);
	                result = reduceNode(node.right, cbNode, result);
	                break;
	            case 146 /* ComputedPropertyName */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Signature elements
	            case 148 /* Parameter */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 149 /* Decorator */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Type member
	            case 150 /* PropertySignature */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.questionToken, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 151 /* PropertyDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 153 /* MethodDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 154 /* Constructor */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 155 /* GetAccessor */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 156 /* SetAccessor */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            // Binding patterns
	            case 179 /* ObjectBindingPattern */:
	            case 180 /* ArrayBindingPattern */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 181 /* BindingElement */:
	                result = reduceNode(node.propertyName, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            // Expression
	            case 182 /* ArrayLiteralExpression */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 183 /* ObjectLiteralExpression */:
	                result = reduceNodes(node.properties, cbNodes, result);
	                break;
	            case 184 /* PropertyAccessExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 185 /* ElementAccessExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.argumentExpression, cbNode, result);
	                break;
	            case 186 /* CallExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                result = reduceNodes(node.arguments, cbNodes, result);
	                break;
	            case 187 /* NewExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                result = reduceNodes(node.arguments, cbNodes, result);
	                break;
	            case 188 /* TaggedTemplateExpression */:
	                result = reduceNode(node.tag, cbNode, result);
	                result = reduceNode(node.template, cbNode, result);
	                break;
	            case 189 /* TypeAssertionExpression */:
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 191 /* FunctionExpression */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 192 /* ArrowFunction */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 190 /* ParenthesizedExpression */:
	            case 193 /* DeleteExpression */:
	            case 194 /* TypeOfExpression */:
	            case 195 /* VoidExpression */:
	            case 196 /* AwaitExpression */:
	            case 202 /* YieldExpression */:
	            case 203 /* SpreadElement */:
	            case 208 /* NonNullExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 197 /* PrefixUnaryExpression */:
	            case 198 /* PostfixUnaryExpression */:
	                result = reduceNode(node.operand, cbNode, result);
	                break;
	            case 199 /* BinaryExpression */:
	                result = reduceNode(node.left, cbNode, result);
	                result = reduceNode(node.right, cbNode, result);
	                break;
	            case 200 /* ConditionalExpression */:
	                result = reduceNode(node.condition, cbNode, result);
	                result = reduceNode(node.whenTrue, cbNode, result);
	                result = reduceNode(node.whenFalse, cbNode, result);
	                break;
	            case 201 /* TemplateExpression */:
	                result = reduceNode(node.head, cbNode, result);
	                result = reduceNodes(node.templateSpans, cbNodes, result);
	                break;
	            case 204 /* ClassExpression */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.heritageClauses, cbNodes, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 206 /* ExpressionWithTypeArguments */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNodes(node.typeArguments, cbNodes, result);
	                break;
	            case 207 /* AsExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                break;
	            // Misc
	            case 210 /* TemplateSpan */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.literal, cbNode, result);
	                break;
	            // Element
	            case 212 /* Block */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 213 /* VariableStatement */:
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.declarationList, cbNode, result);
	                break;
	            case 215 /* ExpressionStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 216 /* IfStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.thenStatement, cbNode, result);
	                result = reduceNode(node.elseStatement, cbNode, result);
	                break;
	            case 217 /* DoStatement */:
	                result = reduceNode(node.statement, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 218 /* WhileStatement */:
	            case 225 /* WithStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 219 /* ForStatement */:
	                result = reduceNode(node.initializer, cbNode, result);
	                result = reduceNode(node.condition, cbNode, result);
	                result = reduceNode(node.incrementor, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	                result = reduceNode(node.initializer, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 224 /* ReturnStatement */:
	            case 228 /* ThrowStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 226 /* SwitchStatement */:
	                result = reduceNode(node.expression, cbNode, result);
	                result = reduceNode(node.caseBlock, cbNode, result);
	                break;
	            case 227 /* LabeledStatement */:
	                result = reduceNode(node.label, cbNode, result);
	                result = reduceNode(node.statement, cbNode, result);
	                break;
	            case 229 /* TryStatement */:
	                result = reduceNode(node.tryBlock, cbNode, result);
	                result = reduceNode(node.catchClause, cbNode, result);
	                result = reduceNode(node.finallyBlock, cbNode, result);
	                break;
	            case 231 /* VariableDeclaration */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 232 /* VariableDeclarationList */:
	                result = reduceNodes(node.declarations, cbNodes, result);
	                break;
	            case 233 /* FunctionDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.parameters, cbNodes, result);
	                result = reduceNode(node.type, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 234 /* ClassDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.typeParameters, cbNodes, result);
	                result = reduceNodes(node.heritageClauses, cbNodes, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 237 /* EnumDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNodes(node.members, cbNodes, result);
	                break;
	            case 238 /* ModuleDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.body, cbNode, result);
	                break;
	            case 239 /* ModuleBlock */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 240 /* CaseBlock */:
	                result = reduceNodes(node.clauses, cbNodes, result);
	                break;
	            case 242 /* ImportEqualsDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.moduleReference, cbNode, result);
	                break;
	            case 243 /* ImportDeclaration */:
	                result = reduceNodes(node.decorators, cbNodes, result);
	                result = reduceNodes(node.modifiers, cbNodes, result);
	                result = reduceNode(node.importClause, cbNode, result);
	                result = reduceNode(node.moduleSpecifier, cbNode, result);
	                break;
	            case 244 /* ImportClause */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.namedBindings, cbNode, result);
	                break;
	            case 245 /* NamespaceImport */:
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 246 /* NamedImports */:
	            case 250 /* NamedExports */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            case 247 /* ImportSpecifier */:
	            case 251 /* ExportSpecifier */:
	                result = reduceNode(node.propertyName, cbNode, result);
	                result = reduceNode(node.name, cbNode, result);
	                break;
	            case 248 /* ExportAssignment */:
	                result = ts.reduceLeft(node.decorators, cbNode, result);
	                result = ts.reduceLeft(node.modifiers, cbNode, result);
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 249 /* ExportDeclaration */:
	                result = ts.reduceLeft(node.decorators, cbNode, result);
	                result = ts.reduceLeft(node.modifiers, cbNode, result);
	                result = reduceNode(node.exportClause, cbNode, result);
	                result = reduceNode(node.moduleSpecifier, cbNode, result);
	                break;
	            // Module references
	            case 253 /* ExternalModuleReference */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // JSX
	            case 254 /* JsxElement */:
	                result = reduceNode(node.openingElement, cbNode, result);
	                result = ts.reduceLeft(node.children, cbNode, result);
	                result = reduceNode(node.closingElement, cbNode, result);
	                break;
	            case 258 /* JsxFragment */:
	                result = reduceNode(node.openingFragment, cbNode, result);
	                result = ts.reduceLeft(node.children, cbNode, result);
	                result = reduceNode(node.closingFragment, cbNode, result);
	                break;
	            case 255 /* JsxSelfClosingElement */:
	            case 256 /* JsxOpeningElement */:
	                result = reduceNode(node.tagName, cbNode, result);
	                result = reduceNode(node.attributes, cbNode, result);
	                break;
	            case 262 /* JsxAttributes */:
	                result = reduceNodes(node.properties, cbNodes, result);
	                break;
	            case 257 /* JsxClosingElement */:
	                result = reduceNode(node.tagName, cbNode, result);
	                break;
	            case 261 /* JsxAttribute */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 263 /* JsxSpreadAttribute */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 264 /* JsxExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Clauses
	            case 265 /* CaseClause */:
	                result = reduceNode(node.expression, cbNode, result);
	            // falls through
	            case 266 /* DefaultClause */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            case 267 /* HeritageClause */:
	                result = reduceNodes(node.types, cbNodes, result);
	                break;
	            case 268 /* CatchClause */:
	                result = reduceNode(node.variableDeclaration, cbNode, result);
	                result = reduceNode(node.block, cbNode, result);
	                break;
	            // Property assignments
	            case 269 /* PropertyAssignment */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            case 270 /* ShorthandPropertyAssignment */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.objectAssignmentInitializer, cbNode, result);
	                break;
	            case 271 /* SpreadAssignment */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            // Enum
	            case 272 /* EnumMember */:
	                result = reduceNode(node.name, cbNode, result);
	                result = reduceNode(node.initializer, cbNode, result);
	                break;
	            // Top-level nodes
	            case 273 /* SourceFile */:
	                result = reduceNodes(node.statements, cbNodes, result);
	                break;
	            // Transformation nodes
	            case 300 /* PartiallyEmittedExpression */:
	                result = reduceNode(node.expression, cbNode, result);
	                break;
	            case 301 /* CommaListExpression */:
	                result = reduceNodes(node.elements, cbNodes, result);
	                break;
	            default:
	                break;
	        }
	        return result;
	    }
	    ts.reduceEachChild = reduceEachChild;
	    function mergeLexicalEnvironment(statements, declarations) {
	        if (!ts.some(declarations)) {
	            return statements;
	        }
	        return ts.isNodeArray(statements)
	            ? ts.setTextRange(ts.createNodeArray(ts.prependStatements(statements.slice(), declarations)), statements)
	            : ts.prependStatements(statements, declarations);
	    }
	    ts.mergeLexicalEnvironment = mergeLexicalEnvironment;
	    /**
	     * Lifts a NodeArray containing only Statement nodes to a block.
	     *
	     * @param nodes The NodeArray.
	     */
	    function liftToBlock(nodes) {
	        Debug.assert(ts.every(nodes, ts.isStatement), "Cannot lift nodes to a Block.");
	        return ts.singleOrUndefined(nodes) || ts.createBlock(nodes);
	    }
	    ts.liftToBlock = liftToBlock;
	    /**
	     * Aggregates the TransformFlags for a Node and its subtree.
	     */
	    function aggregateTransformFlags(node) {
	        aggregateTransformFlagsForNode(node);
	        return node;
	    }
	    ts.aggregateTransformFlags = aggregateTransformFlags;
	    /**
	     * Aggregates the TransformFlags for a Node and its subtree. The flags for the subtree are
	     * computed first, then the transform flags for the current node are computed from the subtree
	     * flags and the state of the current node. Finally, the transform flags of the node are
	     * returned, excluding any flags that should not be included in its parent node's subtree
	     * flags.
	     */
	    function aggregateTransformFlagsForNode(node) {
	        if (node === undefined) {
	            return 0 /* None */;
	        }
	        if (node.transformFlags & 536870912 /* HasComputedFlags */) {
	            return node.transformFlags & ~ts.getTransformFlagsSubtreeExclusions(node.kind);
	        }
	        var subtreeFlags = aggregateTransformFlagsForSubtree(node);
	        return ts.computeTransformFlagsForNode(node, subtreeFlags);
	    }
	    function aggregateTransformFlagsForNodeArray(nodes) {
	        if (nodes === undefined) {
	            return 0 /* None */;
	        }
	        var subtreeFlags = 0 /* None */;
	        var nodeArrayFlags = 0 /* None */;
	        for (var _i = 0, nodes_3 = nodes; _i < nodes_3.length; _i++) {
	            var node = nodes_3[_i];
	            subtreeFlags |= aggregateTransformFlagsForNode(node);
	            nodeArrayFlags |= node.transformFlags & ~536870912 /* HasComputedFlags */;
	        }
	        nodes.transformFlags = nodeArrayFlags | 536870912 /* HasComputedFlags */;
	        return subtreeFlags;
	    }
	    /**
	     * Aggregates the transform flags for the subtree of a node.
	     */
	    function aggregateTransformFlagsForSubtree(node) {
	        // We do not transform ambient declarations or types, so there is no need to
	        // recursively aggregate transform flags.
	        if (ts.hasModifier(node, 2 /* Ambient */) || (ts.isTypeNode(node) && node.kind !== 206 /* ExpressionWithTypeArguments */)) {
	            return 0 /* None */;
	        }
	        // Aggregate the transform flags of each child.
	        return reduceEachChild(node, 0 /* None */, aggregateTransformFlagsForChildNode, aggregateTransformFlagsForChildNodes);
	    }
	    /**
	     * Aggregates the TransformFlags of a child node with the TransformFlags of its
	     * siblings.
	     */
	    function aggregateTransformFlagsForChildNode(transformFlags, node) {
	        return transformFlags | aggregateTransformFlagsForNode(node);
	    }
	    function aggregateTransformFlagsForChildNodes(transformFlags, nodes) {
	        return transformFlags | aggregateTransformFlagsForNodeArray(nodes);
	    }
	    var Debug;
	    (function (Debug) {
	        var isDebugInfoEnabled = false;
	        function failBadSyntaxKind(node, message) {
	            return Debug.fail((message || "Unexpected node.") + "\r\nNode " + ts.formatSyntaxKind(node.kind) + " was unexpected.", failBadSyntaxKind);
	        }
	        Debug.failBadSyntaxKind = failBadSyntaxKind;
	        Debug.assertEachNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (nodes, test, message) { return Debug.assert(test === undefined || ts.every(nodes, test), message || "Unexpected node.", function () { return "Node array did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertEachNode); }
	            : ts.noop;
	        Debug.assertNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, test, message) { return Debug.assert(test === undefined || test(node), message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertNode); }
	            : ts.noop;
	        Debug.assertOptionalNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, test, message) { return Debug.assert(test === undefined || node === undefined || test(node), message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " did not pass test '" + Debug.getFunctionName(test) + "'."; }, Debug.assertOptionalNode); }
	            : ts.noop;
	        Debug.assertOptionalToken = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, kind, message) { return Debug.assert(kind === undefined || node === undefined || node.kind === kind, message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " was not a '" + ts.formatSyntaxKind(kind) + "' token."; }, Debug.assertOptionalToken); }
	            : ts.noop;
	        Debug.assertMissingNode = Debug.shouldAssert(1 /* Normal */)
	            ? function (node, message) { return Debug.assert(node === undefined, message || "Unexpected node.", function () { return "Node " + ts.formatSyntaxKind(node.kind) + " was unexpected'."; }, Debug.assertMissingNode); }
	            : ts.noop;
	        /**
	         * Injects debug information into frequently used types.
	         */
	        function enableDebugInfo() {
	            if (isDebugInfoEnabled)
	                return;
	            // Add additional properties in debug mode to assist with debugging.
	            Object.defineProperties(ts.objectAllocator.getSymbolConstructor().prototype, {
	                __debugFlags: { get: function () { return ts.formatSymbolFlags(this.flags); } }
	            });
	            Object.defineProperties(ts.objectAllocator.getTypeConstructor().prototype, {
	                __debugFlags: { get: function () { return ts.formatTypeFlags(this.flags); } },
	                __debugObjectFlags: { get: function () { return this.flags & 65536 /* Object */ ? ts.formatObjectFlags(this.objectFlags) : ""; } },
	                __debugTypeToString: { value: function () { return this.checker.typeToString(this); } },
	            });
	            var nodeConstructors = [
	                ts.objectAllocator.getNodeConstructor(),
	                ts.objectAllocator.getIdentifierConstructor(),
	                ts.objectAllocator.getTokenConstructor(),
	                ts.objectAllocator.getSourceFileConstructor()
	            ];
	            for (var _i = 0, nodeConstructors_1 = nodeConstructors; _i < nodeConstructors_1.length; _i++) {
	                var ctor = nodeConstructors_1[_i];
	                if (!ctor.prototype.hasOwnProperty("__debugKind")) {
	                    Object.defineProperties(ctor.prototype, {
	                        __debugKind: { get: function () { return ts.formatSyntaxKind(this.kind); } },
	                        __debugModifierFlags: { get: function () { return ts.formatModifierFlags(ts.getModifierFlagsNoCache(this)); } },
	                        __debugTransformFlags: { get: function () { return ts.formatTransformFlags(this.transformFlags); } },
	                        __debugEmitFlags: { get: function () { return ts.formatEmitFlags(ts.getEmitFlags(this)); } },
	                        __debugGetText: {
	                            value: function (includeTrivia) {
	                                if (ts.nodeIsSynthesized(this))
	                                    return "";
	                                var parseNode = ts.getParseTreeNode(this);
	                                var sourceFile = parseNode && ts.getSourceFileOfNode(parseNode);
	                                return sourceFile ? ts.getSourceTextOfNodeFromSourceFile(sourceFile, parseNode, includeTrivia) : "";
	                            }
	                        }
	                    });
	                }
	            }
	            isDebugInfoEnabled = true;
	        }
	        Debug.enableDebugInfo = enableDebugInfo;
	    })(Debug = ts.Debug || (ts.Debug = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function getOriginalNodeId(node) {
	        node = ts.getOriginalNode(node);
	        return node ? ts.getNodeId(node) : 0;
	    }
	    ts.getOriginalNodeId = getOriginalNodeId;
	    function containsDefaultReference(node) {
	        if (!node)
	            return false;
	        if (!ts.isNamedImports(node))
	            return false;
	        return ts.some(node.elements, isNamedDefaultReference);
	    }
	    function isNamedDefaultReference(e) {
	        return e.propertyName && e.propertyName.escapedText === "default" /* Default */;
	    }
	    function chainBundle(transformSourceFile) {
	        return transformSourceFileOrBundle;
	        function transformSourceFileOrBundle(node) {
	            return node.kind === 273 /* SourceFile */ ? transformSourceFile(node) : transformBundle(node);
	        }
	        function transformBundle(node) {
	            return ts.createBundle(ts.map(node.sourceFiles, transformSourceFile), node.prepends);
	        }
	    }
	    ts.chainBundle = chainBundle;
	    function getImportNeedsImportStarHelper(node) {
	        if (!!ts.getNamespaceDeclarationNode(node)) {
	            return true;
	        }
	        var bindings = node.importClause && node.importClause.namedBindings;
	        if (!bindings) {
	            return false;
	        }
	        if (!ts.isNamedImports(bindings))
	            return false;
	        var defaultRefCount = 0;
	        for (var _i = 0, _a = bindings.elements; _i < _a.length; _i++) {
	            var binding = _a[_i];
	            if (isNamedDefaultReference(binding)) {
	                defaultRefCount++;
	            }
	        }
	        // Import star is required if there's default named refs mixed with non-default refs, or if theres non-default refs and it has a default import
	        return (defaultRefCount > 0 && defaultRefCount !== bindings.elements.length) || (!!(bindings.elements.length - defaultRefCount) && ts.isDefaultImport(node));
	    }
	    ts.getImportNeedsImportStarHelper = getImportNeedsImportStarHelper;
	    function getImportNeedsImportDefaultHelper(node) {
	        // Import default is needed if there's a default import or a default ref and no other refs (meaning an import star helper wasn't requested)
	        return !getImportNeedsImportStarHelper(node) && (ts.isDefaultImport(node) || (node.importClause && ts.isNamedImports(node.importClause.namedBindings) && containsDefaultReference(node.importClause.namedBindings)));
	    }
	    ts.getImportNeedsImportDefaultHelper = getImportNeedsImportDefaultHelper;
	    function collectExternalModuleInfo(sourceFile, resolver, compilerOptions) {
	        var externalImports = [];
	        var exportSpecifiers = ts.createMultiMap();
	        var exportedBindings = [];
	        var uniqueExports = ts.createMap();
	        var exportedNames;
	        var hasExportDefault = false;
	        var exportEquals;
	        var hasExportStarsToExportValues = false;
	        var hasImportStarOrImportDefault = false;
	        for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	            var node = _a[_i];
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    // import "mod"
	                    // import x from "mod"
	                    // import * as x from "mod"
	                    // import { x, y } from "mod"
	                    externalImports.push(node);
	                    hasImportStarOrImportDefault = hasImportStarOrImportDefault || getImportNeedsImportStarHelper(node) || getImportNeedsImportDefaultHelper(node);
	                    break;
	                case 242 /* ImportEqualsDeclaration */:
	                    if (node.moduleReference.kind === 253 /* ExternalModuleReference */) {
	                        // import x = require("mod")
	                        externalImports.push(node);
	                    }
	                    break;
	                case 249 /* ExportDeclaration */:
	                    if (node.moduleSpecifier) {
	                        if (!node.exportClause) {
	                            // export * from "mod"
	                            externalImports.push(node);
	                            hasExportStarsToExportValues = true;
	                        }
	                        else {
	                            // export { x, y } from "mod"
	                            externalImports.push(node);
	                        }
	                    }
	                    else {
	                        // export { x, y }
	                        for (var _b = 0, _c = node.exportClause.elements; _b < _c.length; _b++) {
	                            var specifier = _c[_b];
	                            if (!uniqueExports.get(ts.idText(specifier.name))) {
	                                var name = specifier.propertyName || specifier.name;
	                                exportSpecifiers.add(ts.idText(name), specifier);
	                                var decl = resolver.getReferencedImportDeclaration(name)
	                                    || resolver.getReferencedValueDeclaration(name);
	                                if (decl) {
	                                    multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(decl), specifier.name);
	                                }
	                                uniqueExports.set(ts.idText(specifier.name), true);
	                                exportedNames = ts.append(exportedNames, specifier.name);
	                            }
	                        }
	                    }
	                    break;
	                case 248 /* ExportAssignment */:
	                    if (node.isExportEquals && !exportEquals) {
	                        // export = x
	                        exportEquals = node;
	                    }
	                    break;
	                case 213 /* VariableStatement */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        for (var _d = 0, _e = node.declarationList.declarations; _d < _e.length; _d++) {
	                            var decl = _e[_d];
	                            exportedNames = collectExportedVariableInfo(decl, uniqueExports, exportedNames);
	                        }
	                    }
	                    break;
	                case 233 /* FunctionDeclaration */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        if (ts.hasModifier(node, 512 /* Default */)) {
	                            // export default function() { }
	                            if (!hasExportDefault) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), ts.getDeclarationName(node));
	                                hasExportDefault = true;
	                            }
	                        }
	                        else {
	                            // export function x() { }
	                            var name = node.name;
	                            if (!uniqueExports.get(ts.idText(name))) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
	                                uniqueExports.set(ts.idText(name), true);
	                                exportedNames = ts.append(exportedNames, name);
	                            }
	                        }
	                    }
	                    break;
	                case 234 /* ClassDeclaration */:
	                    if (ts.hasModifier(node, 1 /* Export */)) {
	                        if (ts.hasModifier(node, 512 /* Default */)) {
	                            // export default class { }
	                            if (!hasExportDefault) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), ts.getDeclarationName(node));
	                                hasExportDefault = true;
	                            }
	                        }
	                        else {
	                            // export class x { }
	                            var name = node.name;
	                            if (name && !uniqueExports.get(ts.idText(name))) {
	                                multiMapSparseArrayAdd(exportedBindings, getOriginalNodeId(node), name);
	                                uniqueExports.set(ts.idText(name), true);
	                                exportedNames = ts.append(exportedNames, name);
	                            }
	                        }
	                    }
	                    break;
	            }
	        }
	        var externalHelpersModuleName = ts.getOrCreateExternalHelpersModuleNameIfNeeded(sourceFile, compilerOptions, hasExportStarsToExportValues, hasImportStarOrImportDefault);
	        var externalHelpersImportDeclaration = externalHelpersModuleName && ts.createImportDeclaration(
	        /*decorators*/ undefined, 
	        /*modifiers*/ undefined, ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(externalHelpersModuleName)), ts.createLiteral(ts.externalHelpersModuleNameText));
	        if (externalHelpersImportDeclaration) {
	            ts.addEmitFlags(externalHelpersImportDeclaration, 67108864 /* NeverApplyImportHelper */);
	            externalImports.unshift(externalHelpersImportDeclaration);
	        }
	        return { externalImports: externalImports, exportSpecifiers: exportSpecifiers, exportEquals: exportEquals, hasExportStarsToExportValues: hasExportStarsToExportValues, exportedBindings: exportedBindings, exportedNames: exportedNames, externalHelpersImportDeclaration: externalHelpersImportDeclaration };
	    }
	    ts.collectExternalModuleInfo = collectExternalModuleInfo;
	    function collectExportedVariableInfo(decl, uniqueExports, exportedNames) {
	        if (ts.isBindingPattern(decl.name)) {
	            for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (!ts.isOmittedExpression(element)) {
	                    exportedNames = collectExportedVariableInfo(element, uniqueExports, exportedNames);
	                }
	            }
	        }
	        else if (!ts.isGeneratedIdentifier(decl.name)) {
	            var text = ts.idText(decl.name);
	            if (!uniqueExports.get(text)) {
	                uniqueExports.set(text, true);
	                exportedNames = ts.append(exportedNames, decl.name);
	            }
	        }
	        return exportedNames;
	    }
	    /** Use a sparse array as a multi-map. */
	    function multiMapSparseArrayAdd(map, key, value) {
	        var values = map[key];
	        if (values) {
	            values.push(value);
	        }
	        else {
	            map[key] = values = [value];
	        }
	        return values;
	    }
	    /**
	     * Used in the module transformer to check if an expression is reasonably without sideeffect,
	     *  and thus better to copy into multiple places rather than to cache in a temporary variable
	     *  - this is mostly subjective beyond the requirement that the expression not be sideeffecting
	     */
	    function isSimpleCopiableExpression(expression) {
	        return ts.isStringLiteralLike(expression) ||
	            expression.kind === 8 /* NumericLiteral */ ||
	            ts.isKeyword(expression.kind) ||
	            ts.isIdentifier(expression);
	    }
	    ts.isSimpleCopiableExpression = isSimpleCopiableExpression;
	    /**
	     * @param input Template string input strings
	     * @param args Names which need to be made file-level unique
	     */
	    function helperString(input) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        return function (uniqueName) {
	            var result = "";
	            for (var i = 0; i < args.length; i++) {
	                result += input[i];
	                result += uniqueName(args[i]);
	            }
	            result += input[input.length - 1];
	            return result;
	        };
	    }
	    ts.helperString = helperString;
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    var FlattenLevel;
	    (function (FlattenLevel) {
	        FlattenLevel[FlattenLevel["All"] = 0] = "All";
	        FlattenLevel[FlattenLevel["ObjectRest"] = 1] = "ObjectRest";
	    })(FlattenLevel = ts.FlattenLevel || (ts.FlattenLevel = {}));
	    /**
	     * Flattens a DestructuringAssignment or a VariableDeclaration to an expression.
	     *
	     * @param node The node to flatten.
	     * @param visitor An optional visitor used to visit initializers.
	     * @param context The transformation context.
	     * @param level Indicates the extent to which flattening should occur.
	     * @param needsValue An optional value indicating whether the value from the right-hand-side of
	     * the destructuring assignment is needed as part of a larger expression.
	     * @param createAssignmentCallback An optional callback used to create the assignment expression.
	     */
	    function flattenDestructuringAssignment(node, visitor, context, level, needsValue, createAssignmentCallback) {
	        var location = node;
	        var value;
	        if (ts.isDestructuringAssignment(node)) {
	            value = node.right;
	            while (ts.isEmptyArrayLiteral(node.left) || ts.isEmptyObjectLiteral(node.left)) {
	                if (ts.isDestructuringAssignment(value)) {
	                    location = node = value;
	                    value = node.right;
	                }
	                else {
	                    return ts.visitNode(value, visitor, ts.isExpression);
	                }
	            }
	        }
	        var expressions;
	        var flattenContext = {
	            context: context,
	            level: level,
	            downlevelIteration: context.getCompilerOptions().downlevelIteration,
	            hoistTempVariables: true,
	            emitExpression: emitExpression,
	            emitBindingOrAssignment: emitBindingOrAssignment,
	            createArrayBindingOrAssignmentPattern: makeArrayAssignmentPattern,
	            createObjectBindingOrAssignmentPattern: makeObjectAssignmentPattern,
	            createArrayBindingOrAssignmentElement: makeAssignmentElement,
	            visitor: visitor
	        };
	        if (value) {
	            value = ts.visitNode(value, visitor, ts.isExpression);
	            if (ts.isIdentifier(value) && bindingOrAssignmentElementAssignsToName(node, value.escapedText)) {
	                // If the right-hand value of the assignment is also an assignment target then
	                // we need to cache the right-hand value.
	                value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ false, location);
	            }
	            else if (needsValue) {
	                // If the right-hand value of the destructuring assignment needs to be preserved (as
	                // is the case when the destructuring assignment is part of a larger expression),
	                // then we need to cache the right-hand value.
	                //
	                // The source map location for the assignment should point to the entire binary
	                // expression.
	                value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ true, location);
	            }
	            else if (ts.nodeIsSynthesized(node)) {
	                // Generally, the source map location for a destructuring assignment is the root
	                // expression.
	                //
	                // However, if the root expression is synthesized (as in the case
	                // of the initializer when transforming a ForOfStatement), then the source map
	                // location should point to the right-hand value of the expression.
	                location = value;
	            }
	        }
	        flattenBindingOrAssignmentElement(flattenContext, node, value, location, /*skipInitializer*/ ts.isDestructuringAssignment(node));
	        if (value && needsValue) {
	            if (!ts.some(expressions)) {
	                return value;
	            }
	            expressions.push(value);
	        }
	        return ts.aggregateTransformFlags(ts.inlineExpressions(expressions)) || ts.createOmittedExpression();
	        function emitExpression(expression) {
	            // NOTE: this completely disables source maps, but aligns with the behavior of
	            //       `emitAssignment` in the old emitter.
	            ts.setEmitFlags(expression, 64 /* NoNestedSourceMaps */);
	            ts.aggregateTransformFlags(expression);
	            expressions = ts.append(expressions, expression);
	        }
	        function emitBindingOrAssignment(target, value, location, original) {
	            ts.Debug.assertNode(target, createAssignmentCallback ? ts.isIdentifier : ts.isExpression);
	            var expression = createAssignmentCallback
	                ? createAssignmentCallback(target, value, location)
	                : ts.setTextRange(ts.createAssignment(ts.visitNode(target, visitor, ts.isExpression), value), location);
	            expression.original = original;
	            emitExpression(expression);
	        }
	    }
	    ts.flattenDestructuringAssignment = flattenDestructuringAssignment;
	    function bindingOrAssignmentElementAssignsToName(element, escapedName) {
	        var target = ts.getTargetOfBindingOrAssignmentElement(element);
	        if (ts.isBindingOrAssignmentPattern(target)) {
	            return bindingOrAssignmentPatternAssignsToName(target, escapedName);
	        }
	        else if (ts.isIdentifier(target)) {
	            return target.escapedText === escapedName;
	        }
	        return false;
	    }
	    function bindingOrAssignmentPatternAssignsToName(pattern, escapedName) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        for (var _i = 0, elements_3 = elements; _i < elements_3.length; _i++) {
	            var element = elements_3[_i];
	            if (bindingOrAssignmentElementAssignsToName(element, escapedName)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * Flattens a VariableDeclaration or ParameterDeclaration to one or more variable declarations.
	     *
	     * @param node The node to flatten.
	     * @param visitor An optional visitor used to visit initializers.
	     * @param context The transformation context.
	     * @param boundValue The value bound to the declaration.
	     * @param skipInitializer A value indicating whether to ignore the initializer of `node`.
	     * @param hoistTempVariables Indicates whether temporary variables should not be recorded in-line.
	     * @param level Indicates the extent to which flattening should occur.
	     */
	    function flattenDestructuringBinding(node, visitor, context, level, rval, hoistTempVariables, skipInitializer) {
	        var pendingExpressions;
	        var pendingDeclarations = [];
	        var declarations = [];
	        var flattenContext = {
	            context: context,
	            level: level,
	            downlevelIteration: context.getCompilerOptions().downlevelIteration,
	            hoistTempVariables: hoistTempVariables,
	            emitExpression: emitExpression,
	            emitBindingOrAssignment: emitBindingOrAssignment,
	            createArrayBindingOrAssignmentPattern: makeArrayBindingPattern,
	            createObjectBindingOrAssignmentPattern: makeObjectBindingPattern,
	            createArrayBindingOrAssignmentElement: makeBindingElement,
	            visitor: visitor
	        };
	        if (ts.isVariableDeclaration(node)) {
	            var initializer = ts.getInitializerOfBindingOrAssignmentElement(node);
	            if (initializer && ts.isIdentifier(initializer) && bindingOrAssignmentElementAssignsToName(node, initializer.escapedText)) {
	                // If the right-hand value of the assignment is also an assignment target then
	                // we need to cache the right-hand value.
	                initializer = ensureIdentifier(flattenContext, initializer, /*reuseIdentifierExpressions*/ false, initializer);
	                node = ts.updateVariableDeclaration(node, node.name, node.type, initializer);
	            }
	        }
	        flattenBindingOrAssignmentElement(flattenContext, node, rval, node, skipInitializer);
	        if (pendingExpressions) {
	            var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            if (hoistTempVariables) {
	                var value = ts.inlineExpressions(pendingExpressions);
	                pendingExpressions = undefined;
	                emitBindingOrAssignment(temp, value, /*location*/ undefined, /*original*/ undefined);
	            }
	            else {
	                context.hoistVariableDeclaration(temp);
	                var pendingDeclaration = ts.lastOrUndefined(pendingDeclarations);
	                pendingDeclaration.pendingExpressions = ts.append(pendingDeclaration.pendingExpressions, ts.createAssignment(temp, pendingDeclaration.value));
	                ts.addRange(pendingDeclaration.pendingExpressions, pendingExpressions);
	                pendingDeclaration.value = temp;
	            }
	        }
	        for (var _i = 0, pendingDeclarations_1 = pendingDeclarations; _i < pendingDeclarations_1.length; _i++) {
	            var _a = pendingDeclarations_1[_i], pendingExpressions_1 = _a.pendingExpressions, name = _a.name, value = _a.value, location = _a.location, original = _a.original;
	            var variable = ts.createVariableDeclaration(name, 
	            /*type*/ undefined, pendingExpressions_1 ? ts.inlineExpressions(ts.append(pendingExpressions_1, value)) : value);
	            variable.original = original;
	            ts.setTextRange(variable, location);
	            if (ts.isIdentifier(name)) {
	                ts.setEmitFlags(variable, 64 /* NoNestedSourceMaps */);
	            }
	            ts.aggregateTransformFlags(variable);
	            declarations.push(variable);
	        }
	        return declarations;
	        function emitExpression(value) {
	            pendingExpressions = ts.append(pendingExpressions, value);
	        }
	        function emitBindingOrAssignment(target, value, location, original) {
	            ts.Debug.assertNode(target, ts.isBindingName);
	            if (pendingExpressions) {
	                value = ts.inlineExpressions(ts.append(pendingExpressions, value));
	                pendingExpressions = undefined;
	            }
	            pendingDeclarations.push({ pendingExpressions: pendingExpressions, name: target, value: value, location: location, original: original });
	        }
	    }
	    ts.flattenDestructuringBinding = flattenDestructuringBinding;
	    /**
	     * Flattens a BindingOrAssignmentElement into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param element The element to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     * @param skipInitializer An optional value indicating whether to include the initializer
	     * for the element.
	     */
	    function flattenBindingOrAssignmentElement(flattenContext, element, value, location, skipInitializer) {
	        if (!skipInitializer) {
	            var initializer = ts.visitNode(ts.getInitializerOfBindingOrAssignmentElement(element), flattenContext.visitor, ts.isExpression);
	            if (initializer) {
	                // Combine value and initializer
	                value = value ? createDefaultValueCheck(flattenContext, value, initializer, location) : initializer;
	            }
	            else if (!value) {
	                // Use 'void 0' in absence of value and initializer
	                value = ts.createVoidZero();
	            }
	        }
	        var bindingTarget = ts.getTargetOfBindingOrAssignmentElement(element);
	        if (ts.isObjectBindingOrAssignmentPattern(bindingTarget)) {
	            flattenObjectBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value, location);
	        }
	        else if (ts.isArrayBindingOrAssignmentPattern(bindingTarget)) {
	            flattenArrayBindingOrAssignmentPattern(flattenContext, element, bindingTarget, value, location);
	        }
	        else {
	            flattenContext.emitBindingOrAssignment(bindingTarget, value, location, /*original*/ element);
	        }
	    }
	    /**
	     * Flattens an ObjectBindingOrAssignmentPattern into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param parent The parent element of the pattern.
	     * @param pattern The ObjectBindingOrAssignmentPattern to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     */
	    function flattenObjectBindingOrAssignmentPattern(flattenContext, parent, pattern, value, location) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        var numElements = elements.length;
	        if (numElements !== 1) {
	            // For anything other than a single-element destructuring we need to generate a temporary
	            // to ensure value is evaluated exactly once. Additionally, if we have zero elements
	            // we need to emit *something* to ensure that in case a 'var' keyword was already emitted,
	            // so in that case, we'll intentionally create that temporary.
	            var reuseIdentifierExpressions = !ts.isDeclarationBindingElement(parent) || numElements !== 0;
	            value = ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location);
	        }
	        var bindingElements;
	        var computedTempVariables;
	        for (var i = 0; i < numElements; i++) {
	            var element = elements[i];
	            if (!ts.getRestIndicatorOfBindingOrAssignmentElement(element)) {
	                var propertyName = ts.getPropertyNameOfBindingOrAssignmentElement(element);
	                if (flattenContext.level >= 1 /* ObjectRest */
	                    && !(element.transformFlags & (524288 /* ContainsRest */ | 1048576 /* ContainsObjectRest */))
	                    && !(ts.getTargetOfBindingOrAssignmentElement(element).transformFlags & (524288 /* ContainsRest */ | 1048576 /* ContainsObjectRest */))
	                    && !ts.isComputedPropertyName(propertyName)) {
	                    bindingElements = ts.append(bindingElements, element);
	                }
	                else {
	                    if (bindingElements) {
	                        flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	                        bindingElements = undefined;
	                    }
	                    var rhsValue = createDestructuringPropertyAccess(flattenContext, value, propertyName);
	                    if (ts.isComputedPropertyName(propertyName)) {
	                        computedTempVariables = ts.append(computedTempVariables, rhsValue.argumentExpression);
	                    }
	                    flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	                }
	            }
	            else if (i === numElements - 1) {
	                if (bindingElements) {
	                    flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	                    bindingElements = undefined;
	                }
	                var rhsValue = createRestCall(flattenContext.context, value, elements, computedTempVariables, pattern);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, element);
	            }
	        }
	        if (bindingElements) {
	            flattenContext.emitBindingOrAssignment(flattenContext.createObjectBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	        }
	    }
	    /**
	     * Flattens an ArrayBindingOrAssignmentPattern into zero or more bindings or assignments.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param parent The parent element of the pattern.
	     * @param pattern The ArrayBindingOrAssignmentPattern to flatten.
	     * @param value The current RHS value to assign to the element.
	     * @param location The location to use for source maps and comments.
	     */
	    function flattenArrayBindingOrAssignmentPattern(flattenContext, parent, pattern, value, location) {
	        var elements = ts.getElementsOfBindingOrAssignmentPattern(pattern);
	        var numElements = elements.length;
	        if (flattenContext.level < 1 /* ObjectRest */ && flattenContext.downlevelIteration) {
	            // Read the elements of the iterable into an array
	            value = ensureIdentifier(flattenContext, ts.createReadHelper(flattenContext.context, value, numElements > 0 && ts.getRestIndicatorOfBindingOrAssignmentElement(elements[numElements - 1])
	                ? undefined
	                : numElements, location), 
	            /*reuseIdentifierExpressions*/ false, location);
	        }
	        else if (numElements !== 1 && (flattenContext.level < 1 /* ObjectRest */ || numElements === 0)
	            || ts.every(elements, ts.isOmittedExpression)) {
	            // For anything other than a single-element destructuring we need to generate a temporary
	            // to ensure value is evaluated exactly once. Additionally, if we have zero elements
	            // we need to emit *something* to ensure that in case a 'var' keyword was already emitted,
	            // so in that case, we'll intentionally create that temporary.
	            // Or all the elements of the binding pattern are omitted expression such as "var [,] = [1,2]",
	            // then we will create temporary variable.
	            var reuseIdentifierExpressions = !ts.isDeclarationBindingElement(parent) || numElements !== 0;
	            value = ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location);
	        }
	        var bindingElements;
	        var restContainingElements;
	        for (var i = 0; i < numElements; i++) {
	            var element = elements[i];
	            if (flattenContext.level >= 1 /* ObjectRest */) {
	                // If an array pattern contains an ObjectRest, we must cache the result so that we
	                // can perform the ObjectRest destructuring in a different declaration
	                if (element.transformFlags & 1048576 /* ContainsObjectRest */) {
	                    var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                    if (flattenContext.hoistTempVariables) {
	                        flattenContext.context.hoistVariableDeclaration(temp);
	                    }
	                    restContainingElements = ts.append(restContainingElements, [temp, element]);
	                    bindingElements = ts.append(bindingElements, flattenContext.createArrayBindingOrAssignmentElement(temp));
	                }
	                else {
	                    bindingElements = ts.append(bindingElements, element);
	                }
	            }
	            else if (ts.isOmittedExpression(element)) {
	                continue;
	            }
	            else if (!ts.getRestIndicatorOfBindingOrAssignmentElement(element)) {
	                var rhsValue = ts.createElementAccess(value, i);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	            }
	            else if (i === numElements - 1) {
	                var rhsValue = ts.createArraySlice(value, i);
	                flattenBindingOrAssignmentElement(flattenContext, element, rhsValue, /*location*/ element);
	            }
	        }
	        if (bindingElements) {
	            flattenContext.emitBindingOrAssignment(flattenContext.createArrayBindingOrAssignmentPattern(bindingElements), value, location, pattern);
	        }
	        if (restContainingElements) {
	            for (var _i = 0, restContainingElements_1 = restContainingElements; _i < restContainingElements_1.length; _i++) {
	                var _a = restContainingElements_1[_i], id = _a[0], element = _a[1];
	                flattenBindingOrAssignmentElement(flattenContext, element, id, element);
	            }
	        }
	    }
	    /**
	     * Creates an expression used to provide a default value if a value is `undefined` at runtime.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value The RHS value to test.
	     * @param defaultValue The default value to use if `value` is `undefined` at runtime.
	     * @param location The location to use for source maps and comments.
	     */
	    function createDefaultValueCheck(flattenContext, value, defaultValue, location) {
	        value = ensureIdentifier(flattenContext, value, /*reuseIdentifierExpressions*/ true, location);
	        return ts.createConditional(ts.createTypeCheck(value, "undefined"), defaultValue, value);
	    }
	    /**
	     * Creates either a PropertyAccessExpression or an ElementAccessExpression for the
	     * right-hand side of a transformed destructuring assignment.
	     *
	     * @link https://tc39.github.io/ecma262/#sec-runtime-semantics-keyeddestructuringassignmentevaluation
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value The RHS value that is the source of the property.
	     * @param propertyName The destructuring property name.
	     */
	    function createDestructuringPropertyAccess(flattenContext, value, propertyName) {
	        if (ts.isComputedPropertyName(propertyName)) {
	            var argumentExpression = ensureIdentifier(flattenContext, ts.visitNode(propertyName.expression, flattenContext.visitor), /*reuseIdentifierExpressions*/ false, /*location*/ propertyName);
	            return ts.createElementAccess(value, argumentExpression);
	        }
	        else if (ts.isStringOrNumericLiteral(propertyName)) {
	            var argumentExpression = ts.getSynthesizedClone(propertyName);
	            argumentExpression.text = argumentExpression.text;
	            return ts.createElementAccess(value, argumentExpression);
	        }
	        else {
	            var name = ts.createIdentifier(ts.idText(propertyName));
	            return ts.createPropertyAccess(value, name);
	        }
	    }
	    /**
	     * Ensures that there exists a declared identifier whose value holds the given expression.
	     * This function is useful to ensure that the expression's value can be read from in subsequent expressions.
	     * Unless 'reuseIdentifierExpressions' is false, 'value' will be returned if it is just an identifier.
	     *
	     * @param flattenContext Options used to control flattening.
	     * @param value the expression whose value needs to be bound.
	     * @param reuseIdentifierExpressions true if identifier expressions can simply be returned;
	     * false if it is necessary to always emit an identifier.
	     * @param location The location to use for source maps and comments.
	     */
	    function ensureIdentifier(flattenContext, value, reuseIdentifierExpressions, location) {
	        if (ts.isIdentifier(value) && reuseIdentifierExpressions) {
	            return value;
	        }
	        else {
	            var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            if (flattenContext.hoistTempVariables) {
	                flattenContext.context.hoistVariableDeclaration(temp);
	                flattenContext.emitExpression(ts.setTextRange(ts.createAssignment(temp, value), location));
	            }
	            else {
	                flattenContext.emitBindingOrAssignment(temp, value, location, /*original*/ undefined);
	            }
	            return temp;
	        }
	    }
	    function makeArrayBindingPattern(elements) {
	        ts.Debug.assertEachNode(elements, ts.isArrayBindingElement);
	        return ts.createArrayBindingPattern(elements);
	    }
	    function makeArrayAssignmentPattern(elements) {
	        return ts.createArrayLiteral(ts.map(elements, ts.convertToArrayAssignmentElement));
	    }
	    function makeObjectBindingPattern(elements) {
	        ts.Debug.assertEachNode(elements, ts.isBindingElement);
	        return ts.createObjectBindingPattern(elements);
	    }
	    function makeObjectAssignmentPattern(elements) {
	        return ts.createObjectLiteral(ts.map(elements, ts.convertToObjectAssignmentElement));
	    }
	    function makeBindingElement(name) {
	        return ts.createBindingElement(/*dotDotDotToken*/ undefined, /*propertyName*/ undefined, name);
	    }
	    function makeAssignmentElement(name) {
	        return name;
	    }
	    var restHelper = {
	        name: "typescript:rest",
	        scoped: false,
	        text: "\n            var __rest = (this && this.__rest) || function (s, e) {\n                var t = {};\n                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)\n                    t[p] = s[p];\n                if (s != null && typeof Object.getOwnPropertySymbols === \"function\")\n                    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)\n                        t[p[i]] = s[p[i]];\n                return t;\n            };"
	    };
	    /** Given value: o, propName: p, pattern: { a, b, ...p } from the original statement
	     * `{ a, b, ...p } = o`, create `p = __rest(o, ["a", "b"]);`
	     */
	    function createRestCall(context, value, elements, computedTempVariables, location) {
	        context.requestEmitHelper(restHelper);
	        var propertyNames = [];
	        var computedTempVariableOffset = 0;
	        for (var i = 0; i < elements.length - 1; i++) {
	            var propertyName = ts.getPropertyNameOfBindingOrAssignmentElement(elements[i]);
	            if (propertyName) {
	                if (ts.isComputedPropertyName(propertyName)) {
	                    var temp = computedTempVariables[computedTempVariableOffset];
	                    computedTempVariableOffset++;
	                    // typeof _tmp === "symbol" ? _tmp : _tmp + ""
	                    propertyNames.push(ts.createConditional(ts.createTypeCheck(temp, "symbol"), temp, ts.createAdd(temp, ts.createLiteral(""))));
	                }
	                else {
	                    propertyNames.push(ts.createLiteral(propertyName));
	                }
	            }
	        }
	        return ts.createCall(ts.getHelperName("__rest"), 
	        /*typeArguments*/ undefined, [
	            value,
	            ts.setTextRange(ts.createArrayLiteral(propertyNames), location)
	        ]);
	    }
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    /**
	     * Indicates whether to emit type metadata in the new format.
	     */
	    var USE_NEW_TYPE_METADATA_FORMAT = false;
	    var TypeScriptSubstitutionFlags;
	    (function (TypeScriptSubstitutionFlags) {
	        /** Enables substitutions for decorated classes. */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["ClassAliases"] = 1] = "ClassAliases";
	        /** Enables substitutions for namespace exports. */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["NamespaceExports"] = 2] = "NamespaceExports";
	        /* Enables substitutions for unqualified enum members */
	        TypeScriptSubstitutionFlags[TypeScriptSubstitutionFlags["NonQualifiedEnumMembers"] = 8] = "NonQualifiedEnumMembers";
	    })(TypeScriptSubstitutionFlags || (TypeScriptSubstitutionFlags = {}));
	    var ClassFacts;
	    (function (ClassFacts) {
	        ClassFacts[ClassFacts["None"] = 0] = "None";
	        ClassFacts[ClassFacts["HasStaticInitializedProperties"] = 1] = "HasStaticInitializedProperties";
	        ClassFacts[ClassFacts["HasConstructorDecorators"] = 2] = "HasConstructorDecorators";
	        ClassFacts[ClassFacts["HasMemberDecorators"] = 4] = "HasMemberDecorators";
	        ClassFacts[ClassFacts["IsExportOfNamespace"] = 8] = "IsExportOfNamespace";
	        ClassFacts[ClassFacts["IsNamedExternalExport"] = 16] = "IsNamedExternalExport";
	        ClassFacts[ClassFacts["IsDefaultExternalExport"] = 32] = "IsDefaultExternalExport";
	        ClassFacts[ClassFacts["IsDerivedClass"] = 64] = "IsDerivedClass";
	        ClassFacts[ClassFacts["UseImmediatelyInvokedFunctionExpression"] = 128] = "UseImmediatelyInvokedFunctionExpression";
	        ClassFacts[ClassFacts["HasAnyDecorators"] = 6] = "HasAnyDecorators";
	        ClassFacts[ClassFacts["NeedsName"] = 5] = "NeedsName";
	        ClassFacts[ClassFacts["MayNeedImmediatelyInvokedFunctionExpression"] = 7] = "MayNeedImmediatelyInvokedFunctionExpression";
	        ClassFacts[ClassFacts["IsExported"] = 56] = "IsExported";
	    })(ClassFacts || (ClassFacts = {}));
	    function transformTypeScript(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var strictNullChecks = ts.getStrictOptionValue(compilerOptions, "strictNullChecks");
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        // Save the previous transformation hooks.
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        // Set new transformation hooks.
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        // Enable substitution for property/element access to emit const enum values.
	        context.enableSubstitution(184 /* PropertyAccessExpression */);
	        context.enableSubstitution(185 /* ElementAccessExpression */);
	        // These variables contain state that changes as we descend into the tree.
	        var currentSourceFile;
	        var currentNamespace;
	        var currentNamespaceContainerName;
	        var currentScope;
	        var currentScopeFirstDeclarationsOfName;
	        /**
	         * Keeps track of whether expression substitution has been enabled for specific edge cases.
	         * They are persisted between each SourceFile transformation and should not be reset.
	         */
	        var enabledSubstitutions;
	        /**
	         * A map that keeps track of aliases created for classes with decorators to avoid issues
	         * with the double-binding behavior of classes.
	         */
	        var classAliases;
	        /**
	         * Keeps track of whether we are within any containing namespaces when performing
	         * just-in-time substitution while printing an expression identifier.
	         */
	        var applicableSubstitutions;
	        /**
	         * Tracks what computed name expressions originating from elided names must be inlined
	         * at the next execution site, in document order
	         */
	        var pendingExpressions;
	        return transformSourceFileOrBundle;
	        function transformSourceFileOrBundle(node) {
	            if (node.kind === 274 /* Bundle */) {
	                return transformBundle(node);
	            }
	            return transformSourceFile(node);
	        }
	        function transformBundle(node) {
	            return ts.createBundle(node.sourceFiles.map(transformSourceFile), ts.mapDefined(node.prepends, function (prepend) {
	                if (prepend.kind === 276 /* InputFiles */) {
	                    return ts.createUnparsedSourceFile(prepend.javascriptText);
	                }
	                return prepend;
	            }));
	        }
	        /**
	         * Transform TypeScript-specific syntax in a SourceFile.
	         *
	         * @param node A SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            var visited = saveStateAndInvoke(node, visitSourceFile);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            currentSourceFile = undefined;
	            return visited;
	        }
	        /**
	         * Visits a node, saving and restoring state variables on the stack.
	         *
	         * @param node The node to visit.
	         */
	        function saveStateAndInvoke(node, f) {
	            // Save state
	            var savedCurrentScope = currentScope;
	            var savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
	            // Handle state changes before visiting a node.
	            onBeforeVisitNode(node);
	            var visited = f(node);
	            // Restore state
	            if (currentScope !== savedCurrentScope) {
	                currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
	            }
	            currentScope = savedCurrentScope;
	            return visited;
	        }
	        /**
	         * Performs actions that should always occur immediately before visiting a node.
	         *
	         * @param node The node to visit.
	         */
	        function onBeforeVisitNode(node) {
	            switch (node.kind) {
	                case 273 /* SourceFile */:
	                case 240 /* CaseBlock */:
	                case 239 /* ModuleBlock */:
	                case 212 /* Block */:
	                    currentScope = node;
	                    currentScopeFirstDeclarationsOfName = undefined;
	                    break;
	                case 234 /* ClassDeclaration */:
	                case 233 /* FunctionDeclaration */:
	                    if (ts.hasModifier(node, 2 /* Ambient */)) {
	                        break;
	                    }
	                    // Record these declarations provided that they have a name.
	                    if (node.name) {
	                        recordEmittedDeclarationInScope(node);
	                    }
	                    else {
	                        // These nodes should always have names unless they are default-exports;
	                        // however, class declaration parsing allows for undefined names, so syntactically invalid
	                        // programs may also have an undefined name.
	                        ts.Debug.assert(node.kind === 234 /* ClassDeclaration */ || ts.hasModifier(node, 512 /* Default */));
	                    }
	                    break;
	            }
	        }
	        /**
	         * General-purpose node visitor.
	         *
	         * @param node The node to visit.
	         */
	        function visitor(node) {
	            return saveStateAndInvoke(node, visitorWorker);
	        }
	        /**
	         * Visits and possibly transforms any node.
	         *
	         * @param node The node to visit.
	         */
	        function visitorWorker(node) {
	            if (node.transformFlags & 1 /* TypeScript */) {
	                // This node is explicitly marked as TypeScript, so we should transform the node.
	                return visitTypeScript(node);
	            }
	            else if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                // This node contains TypeScript, so we should visit its children.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            return node;
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a SourceFile.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            return saveStateAndInvoke(node, sourceElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a SourceFile.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitorWorker(node) {
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                case 242 /* ImportEqualsDeclaration */:
	                case 248 /* ExportAssignment */:
	                case 249 /* ExportDeclaration */:
	                    return visitEllidableStatement(node);
	                default:
	                    return visitorWorker(node);
	            }
	        }
	        function visitEllidableStatement(node) {
	            var parsed = ts.getParseTreeNode(node);
	            if (parsed !== node) {
	                // If the node has been transformed by a `before` transformer, perform no ellision on it
	                // As the type information we would attempt to lookup to perform ellision is potentially unavailable for the synthesized nodes
	                // We do not reuse `visitorWorker`, as the ellidable statement syntax kinds are technically unrecognized by the switch-case in `visitTypeScript`,
	                // and will trigger debug failures when debug verbosity is turned up
	                if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                    // This node contains TypeScript, so we should visit its children.
	                    return ts.visitEachChild(node, visitor, context);
	                }
	                // Otherwise, we can just return the node
	                return node;
	            }
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 242 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 248 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                case 249 /* ExportDeclaration */:
	                    return visitExportDeclaration(node);
	                default:
	                    ts.Debug.fail("Unhandled ellided statement");
	            }
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a namespace.
	         *
	         * @param node The node to visit.
	         */
	        function namespaceElementVisitor(node) {
	            return saveStateAndInvoke(node, namespaceElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a namespace.
	         *
	         * @param node The node to visit.
	         */
	        function namespaceElementVisitorWorker(node) {
	            if (node.kind === 249 /* ExportDeclaration */ ||
	                node.kind === 243 /* ImportDeclaration */ ||
	                node.kind === 244 /* ImportClause */ ||
	                (node.kind === 242 /* ImportEqualsDeclaration */ &&
	                    node.moduleReference.kind === 253 /* ExternalModuleReference */)) {
	                // do not emit ES6 imports and exports since they are illegal inside a namespace
	                return undefined;
	            }
	            else if (node.transformFlags & 1 /* TypeScript */ || ts.hasModifier(node, 1 /* Export */)) {
	                // This node is explicitly marked as TypeScript, or is exported at the namespace
	                // level, so we should transform the node.
	                return visitTypeScript(node);
	            }
	            else if (node.transformFlags & 2 /* ContainsTypeScript */) {
	                // This node contains TypeScript, so we should visit its children.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            return node;
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a class with TypeScript syntax.
	         *
	         * @param node The node to visit.
	         */
	        function classElementVisitor(node) {
	            return saveStateAndInvoke(node, classElementVisitorWorker);
	        }
	        /**
	         * Specialized visitor that visits the immediate children of a class with TypeScript syntax.
	         *
	         * @param node The node to visit.
	         */
	        function classElementVisitorWorker(node) {
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    // TypeScript constructors are transformed in `visitClassDeclaration`.
	                    // We elide them here as `visitorWorker` checks transform flags, which could
	                    // erronously include an ES6 constructor without TypeScript syntax.
	                    return undefined;
	                case 151 /* PropertyDeclaration */:
	                case 159 /* IndexSignature */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 153 /* MethodDeclaration */:
	                    // Fallback to the default visit behavior.
	                    return visitorWorker(node);
	                case 211 /* SemicolonClassElement */:
	                    return node;
	                default:
	                    return ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        function modifierVisitor(node) {
	            if (ts.modifierToFlag(node.kind) & 2270 /* TypeScriptModifier */) {
	                return undefined;
	            }
	            else if (currentNamespace && node.kind === 84 /* ExportKeyword */) {
	                return undefined;
	            }
	            return node;
	        }
	        /**
	         * Branching visitor, visits a TypeScript syntax node.
	         *
	         * @param node The node to visit.
	         */
	        function visitTypeScript(node) {
	            if (ts.hasModifier(node, 2 /* Ambient */) && ts.isStatement(node)) {
	                // TypeScript ambient declarations are elided, but some comments may be preserved.
	                // See the implementation of `getLeadingComments` in comments.ts for more details.
	                return ts.createNotEmittedStatement(node);
	            }
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    // ES6 export and default modifiers are elided when inside a namespace.
	                    return currentNamespace ? undefined : node;
	                case 114 /* PublicKeyword */:
	                case 112 /* PrivateKeyword */:
	                case 113 /* ProtectedKeyword */:
	                case 117 /* AbstractKeyword */:
	                case 76 /* ConstKeyword */:
	                case 124 /* DeclareKeyword */:
	                case 132 /* ReadonlyKeyword */:
	                // TypeScript accessibility and readonly modifiers are elided.
	                case 166 /* ArrayType */:
	                case 167 /* TupleType */:
	                case 165 /* TypeLiteral */:
	                case 160 /* TypePredicate */:
	                case 147 /* TypeParameter */:
	                case 119 /* AnyKeyword */:
	                case 122 /* BooleanKeyword */:
	                case 137 /* StringKeyword */:
	                case 134 /* NumberKeyword */:
	                case 131 /* NeverKeyword */:
	                case 105 /* VoidKeyword */:
	                case 138 /* SymbolKeyword */:
	                case 163 /* ConstructorType */:
	                case 162 /* FunctionType */:
	                case 164 /* TypeQuery */:
	                case 161 /* TypeReference */:
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                case 170 /* ConditionalType */:
	                case 172 /* ParenthesizedType */:
	                case 173 /* ThisType */:
	                case 174 /* TypeOperator */:
	                case 175 /* IndexedAccessType */:
	                case 176 /* MappedType */:
	                case 177 /* LiteralType */:
	                // TypeScript type nodes are elided.
	                case 159 /* IndexSignature */:
	                // TypeScript index signatures are elided.
	                case 149 /* Decorator */:
	                // TypeScript decorators are elided. They will be emitted as part of visitClassDeclaration.
	                case 236 /* TypeAliasDeclaration */:
	                    // TypeScript type-only declarations are elided.
	                    return undefined;
	                case 151 /* PropertyDeclaration */:
	                    // TypeScript property declarations are elided. However their names are still visited, and can potentially be retained if they could have sideeffects
	                    return visitPropertyDeclaration(node);
	                case 241 /* NamespaceExportDeclaration */:
	                    // TypeScript namespace export declarations are elided.
	                    return undefined;
	                case 154 /* Constructor */:
	                    return visitConstructor(node);
	                case 235 /* InterfaceDeclaration */:
	                    // TypeScript interfaces are elided, but some comments may be preserved.
	                    // See the implementation of `getLeadingComments` in comments.ts for more details.
	                    return ts.createNotEmittedStatement(node);
	                case 234 /* ClassDeclaration */:
	                    // This is a class declaration with TypeScript syntax extensions.
	                    //
	                    // TypeScript class syntax extensions include:
	                    // - decorators
	                    // - optional `implements` heritage clause
	                    // - parameter property assignments in the constructor
	                    // - property declarations
	                    // - index signatures
	                    // - method overload signatures
	                    return visitClassDeclaration(node);
	                case 204 /* ClassExpression */:
	                    // This is a class expression with TypeScript syntax extensions.
	                    //
	                    // TypeScript class syntax extensions include:
	                    // - decorators
	                    // - optional `implements` heritage clause
	                    // - parameter property assignments in the constructor
	                    // - property declarations
	                    // - index signatures
	                    // - method overload signatures
	                    return visitClassExpression(node);
	                case 267 /* HeritageClause */:
	                    // This is a heritage clause with TypeScript syntax extensions.
	                    //
	                    // TypeScript heritage clause extensions include:
	                    // - `implements` clause
	                    return visitHeritageClause(node);
	                case 206 /* ExpressionWithTypeArguments */:
	                    // TypeScript supports type arguments on an expression in an `extends` heritage clause.
	                    return visitExpressionWithTypeArguments(node);
	                case 153 /* MethodDeclaration */:
	                    // TypeScript method declarations may have decorators, modifiers
	                    // or type annotations.
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                    // Get Accessors can have TypeScript modifiers, decorators, and type annotations.
	                    return visitGetAccessor(node);
	                case 156 /* SetAccessor */:
	                    // Set Accessors can have TypeScript modifiers and type annotations.
	                    return visitSetAccessor(node);
	                case 233 /* FunctionDeclaration */:
	                    // Typescript function declarations can have modifiers, decorators, and type annotations.
	                    return visitFunctionDeclaration(node);
	                case 191 /* FunctionExpression */:
	                    // TypeScript function expressions can have modifiers and type annotations.
	                    return visitFunctionExpression(node);
	                case 192 /* ArrowFunction */:
	                    // TypeScript arrow functions can have modifiers and type annotations.
	                    return visitArrowFunction(node);
	                case 148 /* Parameter */:
	                    // This is a parameter declaration with TypeScript syntax extensions.
	                    //
	                    // TypeScript parameter declaration syntax extensions include:
	                    // - decorators
	                    // - accessibility modifiers
	                    // - the question mark (?) token for optional parameters
	                    // - type annotations
	                    // - this parameters
	                    return visitParameter(node);
	                case 190 /* ParenthesizedExpression */:
	                    // ParenthesizedExpressions are TypeScript if their expression is a
	                    // TypeAssertion or AsExpression
	                    return visitParenthesizedExpression(node);
	                case 189 /* TypeAssertionExpression */:
	                case 207 /* AsExpression */:
	                    // TypeScript type assertions are removed, but their subtrees are preserved.
	                    return visitAssertionExpression(node);
	                case 186 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 187 /* NewExpression */:
	                    return visitNewExpression(node);
	                case 188 /* TaggedTemplateExpression */:
	                    return visitTaggedTemplateExpression(node);
	                case 208 /* NonNullExpression */:
	                    // TypeScript non-null expressions are removed, but their subtrees are preserved.
	                    return visitNonNullExpression(node);
	                case 237 /* EnumDeclaration */:
	                    // TypeScript enum declarations do not exist in ES6 and must be rewritten.
	                    return visitEnumDeclaration(node);
	                case 213 /* VariableStatement */:
	                    // TypeScript namespace exports for variable statements must be transformed.
	                    return visitVariableStatement(node);
	                case 231 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 238 /* ModuleDeclaration */:
	                    // TypeScript namespace declarations must be transformed.
	                    return visitModuleDeclaration(node);
	                case 242 /* ImportEqualsDeclaration */:
	                    // TypeScript namespace or external module import.
	                    return visitImportEqualsDeclaration(node);
	                default:
	                    return ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        function visitSourceFile(node) {
	            var alwaysStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") &&
	                !(ts.isExternalModule(node) && moduleKind >= ts.ModuleKind.ES2015) &&
	                !ts.isJsonSourceFile(node);
	            return ts.updateSourceFileNode(node, ts.visitLexicalEnvironment(node.statements, sourceElementVisitor, context, /*start*/ 0, alwaysStrict));
	        }
	        /**
	         * Tests whether we should emit a __decorate call for a class declaration.
	         */
	        function shouldEmitDecorateCallForClass(node) {
	            if (node.decorators && node.decorators.length > 0) {
	                return true;
	            }
	            var constructor = ts.getFirstConstructorWithBody(node);
	            if (constructor) {
	                return ts.forEach(constructor.parameters, shouldEmitDecorateCallForParameter);
	            }
	            return false;
	        }
	        /**
	         * Tests whether we should emit a __decorate call for a parameter declaration.
	         */
	        function shouldEmitDecorateCallForParameter(parameter) {
	            return parameter.decorators !== undefined && parameter.decorators.length > 0;
	        }
	        function getClassFacts(node, staticProperties) {
	            var facts = 0 /* None */;
	            if (ts.some(staticProperties))
	                facts |= 1 /* HasStaticInitializedProperties */;
	            var extendsClauseElement = ts.getClassExtendsHeritageClauseElement(node);
	            if (extendsClauseElement && ts.skipOuterExpressions(extendsClauseElement.expression).kind !== 95 /* NullKeyword */)
	                facts |= 64 /* IsDerivedClass */;
	            if (shouldEmitDecorateCallForClass(node))
	                facts |= 2 /* HasConstructorDecorators */;
	            if (ts.childIsDecorated(node))
	                facts |= 4 /* HasMemberDecorators */;
	            if (isExportOfNamespace(node))
	                facts |= 8 /* IsExportOfNamespace */;
	            else if (isDefaultExternalModuleExport(node))
	                facts |= 32 /* IsDefaultExternalExport */;
	            else if (isNamedExternalModuleExport(node))
	                facts |= 16 /* IsNamedExternalExport */;
	            if (languageVersion <= 1 /* ES5 */ && (facts & 7 /* MayNeedImmediatelyInvokedFunctionExpression */))
	                facts |= 128 /* UseImmediatelyInvokedFunctionExpression */;
	            return facts;
	        }
	        /**
	         * Transforms a class declaration with TypeScript syntax into compatible ES6.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The class has decorators.
	         * - The class has property declarations with initializers.
	         * - The class contains a constructor that contains parameters with accessibility modifiers.
	         * - The class is an export in a TypeScript namespace.
	         *
	         * @param node The node to transform.
	         */
	        function visitClassDeclaration(node) {
	            var savedPendingExpressions = pendingExpressions;
	            pendingExpressions = undefined;
	            var staticProperties = getInitializedProperties(node, /*isStatic*/ true);
	            var facts = getClassFacts(node, staticProperties);
	            if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */) {
	                context.startLexicalEnvironment();
	            }
	            var name = node.name || (facts & 5 /* NeedsName */ ? ts.getGeneratedNameForNode(node) : undefined);
	            var classStatement = facts & 2 /* HasConstructorDecorators */
	                ? createClassDeclarationHeadWithDecorators(node, name, facts)
	                : createClassDeclarationHeadWithoutDecorators(node, name, facts);
	            var statements = [classStatement];
	            // Write any pending expressions from elided or moved computed property names
	            if (ts.some(pendingExpressions)) {
	                statements.push(ts.createStatement(ts.inlineExpressions(pendingExpressions)));
	            }
	            pendingExpressions = savedPendingExpressions;
	            // Emit static property assignment. Because classDeclaration is lexically evaluated,
	            // it is safe to emit static property assignment after classDeclaration
	            // From ES6 specification:
	            //      HasLexicalDeclaration (N) : Determines if the argument identifier has a binding in this environment record that was created using
	            //                                  a lexical declaration such as a LexicalDeclaration or a ClassDeclaration.
	            if (facts & 1 /* HasStaticInitializedProperties */) {
	                addInitializedPropertyStatements(statements, staticProperties, facts & 128 /* UseImmediatelyInvokedFunctionExpression */ ? ts.getInternalName(node) : ts.getLocalName(node));
	            }
	            // Write any decorators of the node.
	            addClassElementDecorationStatements(statements, node, /*isStatic*/ false);
	            addClassElementDecorationStatements(statements, node, /*isStatic*/ true);
	            addConstructorDecorationStatement(statements, node);
	            if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */) {
	                // When we emit a TypeScript class down to ES5, we must wrap it in an IIFE so that the
	                // 'es2015' transformer can properly nest static initializers and decorators. The result
	                // looks something like:
	                //
	                //  var C = function () {
	                //      class C {
	                //      }
	                //      C.static_prop = 1;
	                //      return C;
	                //  }();
	                //
	                var closingBraceLocation = ts.createTokenRange(ts.skipTrivia(currentSourceFile.text, node.members.end), 18 /* CloseBraceToken */);
	                var localName = ts.getInternalName(node);
	                // The following partially-emitted expression exists purely to align our sourcemap
	                // emit with the original emitter.
	                var outer = ts.createPartiallyEmittedExpression(localName);
	                outer.end = closingBraceLocation.end;
	                ts.setEmitFlags(outer, 1536 /* NoComments */);
	                var statement = ts.createReturn(outer);
	                statement.pos = closingBraceLocation.pos;
	                ts.setEmitFlags(statement, 1536 /* NoComments */ | 384 /* NoTokenSourceMaps */);
	                statements.push(statement);
	                ts.prependStatements(statements, context.endLexicalEnvironment());
	                var iife = ts.createImmediatelyInvokedArrowFunction(statements);
	                ts.setEmitFlags(iife, 33554432 /* TypeScriptClassWrapper */);
	                var varStatement = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ false), 
	                    /*type*/ undefined, iife)
	                ]));
	                ts.setOriginalNode(varStatement, node);
	                ts.setCommentRange(varStatement, node);
	                ts.setSourceMapRange(varStatement, ts.moveRangePastDecorators(node));
	                ts.startOnNewLine(varStatement);
	                statements = [varStatement];
	            }
	            // If the class is exported as part of a TypeScript namespace, emit the namespace export.
	            // Otherwise, if the class was exported at the top level and was decorated, emit an export
	            // declaration or export default for the class.
	            if (facts & 8 /* IsExportOfNamespace */) {
	                addExportMemberAssignment(statements, node);
	            }
	            else if (facts & 128 /* UseImmediatelyInvokedFunctionExpression */ || facts & 2 /* HasConstructorDecorators */) {
	                if (facts & 32 /* IsDefaultExternalExport */) {
	                    statements.push(ts.createExportDefault(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
	                }
	                else if (facts & 16 /* IsNamedExternalExport */) {
	                    statements.push(ts.createExternalModuleExport(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true)));
	                }
	            }
	            if (statements.length > 1) {
	                // Add a DeclarationMarker as a marker for the end of the declaration
	                statements.push(ts.createEndOfDeclarationMarker(node));
	                ts.setEmitFlags(classStatement, ts.getEmitFlags(classStatement) | 4194304 /* HasEndOfDeclarationMarker */);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Transforms a non-decorated class declaration and appends the resulting statements.
	         *
	         * @param node A ClassDeclaration node.
	         * @param name The name of the class.
	         * @param facts Precomputed facts about the class.
	         */
	        function createClassDeclarationHeadWithoutDecorators(node, name, facts) {
	            //  ${modifiers} class ${name} ${heritageClauses} {
	            //      ${members}
	            //  }
	            // we do not emit modifiers on the declaration if we are emitting an IIFE
	            var modifiers = !(facts & 128 /* UseImmediatelyInvokedFunctionExpression */)
	                ? ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier)
	                : undefined;
	            var classDeclaration = ts.createClassDeclaration(
	            /*decorators*/ undefined, modifiers, name, 
	            /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause), transformClassMembers(node, (facts & 64 /* IsDerivedClass */) !== 0));
	            // To better align with the old emitter, we should not emit a trailing source map
	            // entry if the class has static properties.
	            var emitFlags = ts.getEmitFlags(node);
	            if (facts & 1 /* HasStaticInitializedProperties */) {
	                emitFlags |= 32 /* NoTrailingSourceMap */;
	            }
	            ts.setTextRange(classDeclaration, node);
	            ts.setOriginalNode(classDeclaration, node);
	            ts.setEmitFlags(classDeclaration, emitFlags);
	            return classDeclaration;
	        }
	        /**
	         * Transforms a decorated class declaration and appends the resulting statements. If
	         * the class requires an alias to avoid issues with double-binding, the alias is returned.
	         */
	        function createClassDeclarationHeadWithDecorators(node, name, facts) {
	            // When we emit an ES6 class that has a class decorator, we must tailor the
	            // emit to certain specific cases.
	            //
	            // In the simplest case, we emit the class declaration as a let declaration, and
	            // evaluate decorators after the close of the class body:
	            //
	            //  [Example 1]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  class C {                       | }
	            //  }                               | C = __decorate([dec], C);
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export class C {                | }
	            //  }                               | C = __decorate([dec], C);
	            //                                  | export { C };
	            //  ---------------------------------------------------------------------
	            //
	            // If a class declaration contains a reference to itself *inside* of the class body,
	            // this introduces two bindings to the class: One outside of the class body, and one
	            // inside of the class body. If we apply decorators as in [Example 1] above, there
	            // is the possibility that the decorator `dec` will return a new value for the
	            // constructor, which would result in the binding inside of the class no longer
	            // pointing to the same reference as the binding outside of the class.
	            //
	            // As a result, we must instead rewrite all references to the class *inside* of the
	            // class body to instead point to a local temporary alias for the class:
	            //
	            //  [Example 2]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = C_1 = class C {
	            //  class C {                       |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export class C {                |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | export { C };
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //
	            // If a class declaration is the default export of a module, we instead emit
	            // the export after the decorated declaration:
	            //
	            //  [Example 3]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let default_1 = class {
	            //  export default class {          | }
	            //  }                               | default_1 = __decorate([dec], default_1);
	            //                                  | export default default_1;
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export default class C {        | }
	            //  }                               | C = __decorate([dec], C);
	            //                                  | export default C;
	            //  ---------------------------------------------------------------------
	            //
	            // If the class declaration is the default export and a reference to itself
	            // inside of the class body, we must emit both an alias for the class *and*
	            // move the export after the declaration:
	            //
	            //  [Example 4]
	            //  ---------------------------------------------------------------------
	            //  TypeScript                      | Javascript
	            //  ---------------------------------------------------------------------
	            //  @dec                            | let C = class C {
	            //  export default class C {        |   static x() { return C_1.y; }
	            //    static x() { return C.y; }    | }
	            //    static y = 1;                 | C.y = 1;
	            //  }                               | C = C_1 = __decorate([dec], C);
	            //                                  | export default C;
	            //                                  | var C_1;
	            //  ---------------------------------------------------------------------
	            //
	            var location = ts.moveRangePastDecorators(node);
	            var classAlias = getClassAliasIfNeeded(node);
	            var declName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  ... = class ${name} ${heritageClauses} {
	            //      ${members}
	            //  }
	            var heritageClauses = ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause);
	            var members = transformClassMembers(node, (facts & 64 /* IsDerivedClass */) !== 0);
	            var classExpression = ts.createClassExpression(/*modifiers*/ undefined, name, /*typeParameters*/ undefined, heritageClauses, members);
	            ts.setOriginalNode(classExpression, node);
	            ts.setTextRange(classExpression, location);
	            //  let ${name} = ${classExpression} where name is either declaredName if the class doesn't contain self-reference
	            //                                         or decoratedClassAlias if the class contain self-reference.
	            var statement = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(declName, 
	                /*type*/ undefined, classAlias ? ts.createAssignment(classAlias, classExpression) : classExpression)
	            ], 1 /* Let */));
	            ts.setOriginalNode(statement, node);
	            ts.setTextRange(statement, location);
	            ts.setCommentRange(statement, node);
	            return statement;
	        }
	        /**
	         * Transforms a class expression with TypeScript syntax into compatible ES6.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The class has property declarations with initializers.
	         * - The class contains a constructor that contains parameters with accessibility modifiers.
	         *
	         * @param node The node to transform.
	         */
	        function visitClassExpression(node) {
	            var savedPendingExpressions = pendingExpressions;
	            pendingExpressions = undefined;
	            var staticProperties = getInitializedProperties(node, /*isStatic*/ true);
	            var heritageClauses = ts.visitNodes(node.heritageClauses, visitor, ts.isHeritageClause);
	            var members = transformClassMembers(node, ts.some(heritageClauses, function (c) { return c.token === 85 /* ExtendsKeyword */; }));
	            var classExpression = ts.createClassExpression(
	            /*modifiers*/ undefined, node.name, 
	            /*typeParameters*/ undefined, heritageClauses, members);
	            ts.setOriginalNode(classExpression, node);
	            ts.setTextRange(classExpression, node);
	            if (ts.some(staticProperties) || ts.some(pendingExpressions)) {
	                var expressions = [];
	                var isClassWithConstructorReference = resolver.getNodeCheckFlags(node) & 8388608 /* ClassWithConstructorReference */;
	                var temp = ts.createTempVariable(hoistVariableDeclaration, !!isClassWithConstructorReference);
	                if (isClassWithConstructorReference) {
	                    // record an alias as the class name is not in scope for statics.
	                    enableSubstitutionForClassAliases();
	                    var alias = ts.getSynthesizedClone(temp);
	                    alias.autoGenerateFlags &= ~8 /* ReservedInNestedScopes */;
	                    classAliases[ts.getOriginalNodeId(node)] = alias;
	                }
	                // To preserve the behavior of the old emitter, we explicitly indent
	                // the body of a class with static initializers.
	                ts.setEmitFlags(classExpression, 65536 /* Indented */ | ts.getEmitFlags(classExpression));
	                expressions.push(ts.startOnNewLine(ts.createAssignment(temp, classExpression)));
	                // Add any pending expressions leftover from elided or relocated computed property names
	                ts.addRange(expressions, ts.map(pendingExpressions, ts.startOnNewLine));
	                pendingExpressions = savedPendingExpressions;
	                ts.addRange(expressions, generateInitializedPropertyExpressions(staticProperties, temp));
	                expressions.push(ts.startOnNewLine(temp));
	                return ts.inlineExpressions(expressions);
	            }
	            pendingExpressions = savedPendingExpressions;
	            return classExpression;
	        }
	        /**
	         * Transforms the members of a class.
	         *
	         * @param node The current class.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformClassMembers(node, isDerivedClass) {
	            var members = [];
	            var constructor = transformConstructor(node, isDerivedClass);
	            if (constructor) {
	                members.push(constructor);
	            }
	            ts.addRange(members, ts.visitNodes(node.members, classElementVisitor, ts.isClassElement));
	            return ts.setTextRange(ts.createNodeArray(members), /*location*/ node.members);
	        }
	        /**
	         * Transforms (or creates) a constructor for a class.
	         *
	         * @param node The current class.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformConstructor(node, isDerivedClass) {
	            // Check if we have property assignment inside class declaration.
	            // If there is a property assignment, we need to emit constructor whether users define it or not
	            // If there is no property assignment, we can omit constructor if users do not define it
	            var hasInstancePropertyWithInitializer = ts.forEach(node.members, isInstanceInitializedProperty);
	            var hasParameterPropertyAssignments = node.transformFlags & 262144 /* ContainsParameterPropertyAssignments */;
	            var constructor = ts.getFirstConstructorWithBody(node);
	            // If the class does not contain nodes that require a synthesized constructor,
	            // accept the current constructor if it exists.
	            if (!hasInstancePropertyWithInitializer && !hasParameterPropertyAssignments) {
	                return ts.visitEachChild(constructor, visitor, context);
	            }
	            var parameters = transformConstructorParameters(constructor);
	            var body = transformConstructorBody(node, constructor, isDerivedClass);
	            //  constructor(${parameters}) {
	            //      ${body}
	            //  }
	            return ts.startOnNewLine(ts.setOriginalNode(ts.setTextRange(ts.createConstructor(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, parameters, body), constructor || node), constructor));
	        }
	        /**
	         * Transforms (or creates) the parameters for the constructor of a class with
	         * parameter property assignments or instance property initializers.
	         *
	         * @param constructor The constructor declaration.
	         */
	        function transformConstructorParameters(constructor) {
	            // The ES2015 spec specifies in 14.5.14. Runtime Semantics: ClassDefinitionEvaluation:
	            // If constructor is empty, then
	            //     If ClassHeritag_eopt is present and protoParent is not null, then
	            //          Let constructor be the result of parsing the source text
	            //              constructor(...args) { super (...args);}
	            //          using the syntactic grammar with the goal symbol MethodDefinition[~Yield].
	            //      Else,
	            //           Let constructor be the result of parsing the source text
	            //               constructor( ){ }
	            //           using the syntactic grammar with the goal symbol MethodDefinition[~Yield].
	            //
	            // While we could emit the '...args' rest parameter, certain later tools in the pipeline might
	            // downlevel the '...args' portion less efficiently by naively copying the contents of 'arguments' to an array.
	            // Instead, we'll avoid using a rest parameter and spread into the super call as
	            // 'super(...arguments)' instead of 'super(...args)', as you can see in "transformConstructorBody".
	            return ts.visitParameterList(constructor && constructor.parameters, visitor, context)
	                || [];
	        }
	        /**
	         * Transforms (or creates) a constructor body for a class with parameter property
	         * assignments or instance property initializers.
	         *
	         * @param node The current class.
	         * @param constructor The current class constructor.
	         * @param isDerivedClass A value indicating whether the class has an extends clause that does not extend 'null'.
	         */
	        function transformConstructorBody(node, constructor, isDerivedClass) {
	            var statements = [];
	            var indexOfFirstStatement = 0;
	            resumeLexicalEnvironment();
	            if (constructor) {
	                indexOfFirstStatement = addPrologueDirectivesAndInitialSuperCall(constructor, statements);
	                // Add parameters with property assignments. Transforms this:
	                //
	                //  constructor (public x, public y) {
	                //  }
	                //
	                // Into this:
	                //
	                //  constructor (x, y) {
	                //      this.x = x;
	                //      this.y = y;
	                //  }
	                //
	                var propertyAssignments = getParametersWithPropertyAssignments(constructor);
	                ts.addRange(statements, ts.map(propertyAssignments, transformParameterWithPropertyAssignment));
	            }
	            else if (isDerivedClass) {
	                // Add a synthetic `super` call:
	                //
	                //  super(...arguments);
	                //
	                statements.push(ts.createStatement(ts.createCall(ts.createSuper(), 
	                /*typeArguments*/ undefined, [ts.createSpread(ts.createIdentifier("arguments"))])));
	            }
	            // Add the property initializers. Transforms this:
	            //
	            //  public x = 1;
	            //
	            // Into this:
	            //
	            //  constructor() {
	            //      this.x = 1;
	            //  }
	            //
	            var properties = getInitializedProperties(node, /*isStatic*/ false);
	            addInitializedPropertyStatements(statements, properties, ts.createThis());
	            if (constructor) {
	                // The class already had a constructor, so we should add the existing statements, skipping the initial super call.
	                ts.addRange(statements, ts.visitNodes(constructor.body.statements, visitor, ts.isStatement, indexOfFirstStatement));
	            }
	            // End the lexical environment.
	            statements = ts.mergeLexicalEnvironment(statements, endLexicalEnvironment());
	            return ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ constructor ? constructor.body.statements : node.members), 
	            /*multiLine*/ true), 
	            /*location*/ constructor ? constructor.body : undefined);
	        }
	        /**
	         * Adds super call and preceding prologue directives into the list of statements.
	         *
	         * @param ctor The constructor node.
	         * @returns index of the statement that follows super call
	         */
	        function addPrologueDirectivesAndInitialSuperCall(ctor, result) {
	            if (ctor.body) {
	                var statements = ctor.body.statements;
	                // add prologue directives to the list (if any)
	                var index = ts.addPrologue(result, statements, /*ensureUseStrict*/ false, visitor);
	                if (index === statements.length) {
	                    // list contains nothing but prologue directives (or empty) - exit
	                    return index;
	                }
	                var statement = statements[index];
	                if (statement.kind === 215 /* ExpressionStatement */ && ts.isSuperCall(statement.expression)) {
	                    result.push(ts.visitNode(statement, visitor, ts.isStatement));
	                    return index + 1;
	                }
	                return index;
	            }
	            return 0;
	        }
	        /**
	         * Gets all parameters of a constructor that should be transformed into property assignments.
	         *
	         * @param node The constructor node.
	         */
	        function getParametersWithPropertyAssignments(node) {
	            return ts.filter(node.parameters, isParameterWithPropertyAssignment);
	        }
	        /**
	         * Determines whether a parameter should be transformed into a property assignment.
	         *
	         * @param parameter The parameter node.
	         */
	        function isParameterWithPropertyAssignment(parameter) {
	            return ts.hasModifier(parameter, 92 /* ParameterPropertyModifier */)
	                && ts.isIdentifier(parameter.name);
	        }
	        /**
	         * Transforms a parameter into a property assignment statement.
	         *
	         * @param node The parameter declaration.
	         */
	        function transformParameterWithPropertyAssignment(node) {
	            ts.Debug.assert(ts.isIdentifier(node.name));
	            var name = node.name;
	            var propertyName = ts.getMutableClone(name);
	            ts.setEmitFlags(propertyName, 1536 /* NoComments */ | 48 /* NoSourceMap */);
	            var localName = ts.getMutableClone(name);
	            ts.setEmitFlags(localName, 1536 /* NoComments */);
	            return ts.startOnNewLine(ts.setEmitFlags(ts.setTextRange(ts.createStatement(ts.createAssignment(ts.setTextRange(ts.createPropertyAccess(ts.createThis(), propertyName), node.name), localName)), ts.moveRangePos(node, -1)), 1536 /* NoComments */));
	        }
	        /**
	         * Gets all property declarations with initializers on either the static or instance side of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to get properties from the static or instance side of the class.
	         */
	        function getInitializedProperties(node, isStatic) {
	            return ts.filter(node.members, isStatic ? isStaticInitializedProperty : isInstanceInitializedProperty);
	        }
	        /**
	         * Gets a value indicating whether a class element is a static property declaration with an initializer.
	         *
	         * @param member The class element node.
	         */
	        function isStaticInitializedProperty(member) {
	            return isInitializedProperty(member, /*isStatic*/ true);
	        }
	        /**
	         * Gets a value indicating whether a class element is an instance property declaration with an initializer.
	         *
	         * @param member The class element node.
	         */
	        function isInstanceInitializedProperty(member) {
	            return isInitializedProperty(member, /*isStatic*/ false);
	        }
	        /**
	         * Gets a value indicating whether a class element is either a static or an instance property declaration with an initializer.
	         *
	         * @param member The class element node.
	         * @param isStatic A value indicating whether the member should be a static or instance member.
	         */
	        function isInitializedProperty(member, isStatic) {
	            return member.kind === 151 /* PropertyDeclaration */
	                && isStatic === ts.hasModifier(member, 32 /* Static */)
	                && member.initializer !== undefined;
	        }
	        /**
	         * Generates assignment statements for property initializers.
	         *
	         * @param properties An array of property declarations to transform.
	         * @param receiver The receiver on which each property should be assigned.
	         */
	        function addInitializedPropertyStatements(statements, properties, receiver) {
	            for (var _i = 0, properties_10 = properties; _i < properties_10.length; _i++) {
	                var property = properties_10[_i];
	                var statement = ts.createStatement(transformInitializedProperty(property, receiver));
	                ts.setSourceMapRange(statement, ts.moveRangePastModifiers(property));
	                ts.setCommentRange(statement, property);
	                statements.push(statement);
	            }
	        }
	        /**
	         * Generates assignment expressions for property initializers.
	         *
	         * @param properties An array of property declarations to transform.
	         * @param receiver The receiver on which each property should be assigned.
	         */
	        function generateInitializedPropertyExpressions(properties, receiver) {
	            var expressions = [];
	            for (var _i = 0, properties_11 = properties; _i < properties_11.length; _i++) {
	                var property = properties_11[_i];
	                var expression = transformInitializedProperty(property, receiver);
	                ts.startOnNewLine(expression);
	                ts.setSourceMapRange(expression, ts.moveRangePastModifiers(property));
	                ts.setCommentRange(expression, property);
	                expressions.push(expression);
	            }
	            return expressions;
	        }
	        /**
	         * Transforms a property initializer into an assignment statement.
	         *
	         * @param property The property declaration.
	         * @param receiver The object receiving the property assignment.
	         */
	        function transformInitializedProperty(property, receiver) {
	            // We generate a name here in order to reuse the value cached by the relocated computed name expression (which uses the same generated name)
	            var propertyName = ts.isComputedPropertyName(property.name) && !isSimpleInlineableExpression(property.name.expression)
	                ? ts.updateComputedPropertyName(property.name, ts.getGeneratedNameForNode(property.name))
	                : property.name;
	            var initializer = ts.visitNode(property.initializer, visitor, ts.isExpression);
	            var memberAccess = ts.createMemberAccessForPropertyName(receiver, propertyName, /*location*/ propertyName);
	            return ts.createAssignment(memberAccess, initializer);
	        }
	        /**
	         * Gets either the static or instance members of a class that are decorated, or have
	         * parameters that are decorated.
	         *
	         * @param node The class containing the member.
	         * @param isStatic A value indicating whether to retrieve static or instance members of
	         *                 the class.
	         */
	        function getDecoratedClassElements(node, isStatic) {
	            return ts.filter(node.members, isStatic ? function (m) { return isStaticDecoratedClassElement(m, node); } : function (m) { return isInstanceDecoratedClassElement(m, node); });
	        }
	        /**
	         * Determines whether a class member is a static member of a class that is decorated, or
	         * has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isStaticDecoratedClassElement(member, parent) {
	            return isDecoratedClassElement(member, /*isStatic*/ true, parent);
	        }
	        /**
	         * Determines whether a class member is an instance member of a class that is decorated,
	         * or has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isInstanceDecoratedClassElement(member, parent) {
	            return isDecoratedClassElement(member, /*isStatic*/ false, parent);
	        }
	        /**
	         * Determines whether a class member is either a static or an instance member of a class
	         * that is decorated, or has parameters that are decorated.
	         *
	         * @param member The class member.
	         */
	        function isDecoratedClassElement(member, isStatic, parent) {
	            return ts.nodeOrChildIsDecorated(member, parent)
	                && isStatic === ts.hasModifier(member, 32 /* Static */);
	        }
	        /**
	         * Gets an array of arrays of decorators for the parameters of a function-like node.
	         * The offset into the result array should correspond to the offset of the parameter.
	         *
	         * @param node The function-like node.
	         */
	        function getDecoratorsOfParameters(node) {
	            var decorators;
	            if (node) {
	                var parameters = node.parameters;
	                for (var i = 0; i < parameters.length; i++) {
	                    var parameter = parameters[i];
	                    if (decorators || parameter.decorators) {
	                        if (!decorators) {
	                            decorators = new Array(parameters.length);
	                        }
	                        decorators[i] = parameter.decorators;
	                    }
	                }
	            }
	            return decorators;
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the class and the decorators for the
	         * parameters of the constructor of the class.
	         *
	         * @param node The class node.
	         */
	        function getAllDecoratorsOfConstructor(node) {
	            var decorators = node.decorators;
	            var parameters = getDecoratorsOfParameters(ts.getFirstConstructorWithBody(node));
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return {
	                decorators: decorators,
	                parameters: parameters
	            };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the member and its parameters.
	         *
	         * @param node The class node that contains the member.
	         * @param member The class member.
	         */
	        function getAllDecoratorsOfClassElement(node, member) {
	            switch (member.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return getAllDecoratorsOfAccessors(node, member);
	                case 153 /* MethodDeclaration */:
	                    return getAllDecoratorsOfMethod(member);
	                case 151 /* PropertyDeclaration */:
	                    return getAllDecoratorsOfProperty(member);
	                default:
	                    return undefined;
	            }
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the accessor and its parameters.
	         *
	         * @param node The class node that contains the accessor.
	         * @param accessor The class accessor member.
	         */
	        function getAllDecoratorsOfAccessors(node, accessor) {
	            if (!accessor.body) {
	                return undefined;
	            }
	            var _a = ts.getAllAccessorDeclarations(node.members, accessor), firstAccessor = _a.firstAccessor, secondAccessor = _a.secondAccessor, setAccessor = _a.setAccessor;
	            var firstAccessorWithDecorators = firstAccessor.decorators ? firstAccessor : secondAccessor && secondAccessor.decorators ? secondAccessor : undefined;
	            if (!firstAccessorWithDecorators || accessor !== firstAccessorWithDecorators) {
	                return undefined;
	            }
	            var decorators = firstAccessorWithDecorators.decorators;
	            var parameters = getDecoratorsOfParameters(setAccessor);
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return { decorators: decorators, parameters: parameters };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the method and its parameters.
	         *
	         * @param method The class method member.
	         */
	        function getAllDecoratorsOfMethod(method) {
	            if (!method.body) {
	                return undefined;
	            }
	            var decorators = method.decorators;
	            var parameters = getDecoratorsOfParameters(method);
	            if (!decorators && !parameters) {
	                return undefined;
	            }
	            return { decorators: decorators, parameters: parameters };
	        }
	        /**
	         * Gets an AllDecorators object containing the decorators for the property.
	         *
	         * @param property The class property member.
	         */
	        function getAllDecoratorsOfProperty(property) {
	            var decorators = property.decorators;
	            if (!decorators) {
	                return undefined;
	            }
	            return { decorators: decorators };
	        }
	        /**
	         * Transforms all of the decorators for a declaration into an array of expressions.
	         *
	         * @param node The declaration node.
	         * @param allDecorators An object containing all of the decorators for the declaration.
	         */
	        function transformAllDecoratorsOfDeclaration(node, container, allDecorators) {
	            if (!allDecorators) {
	                return undefined;
	            }
	            var decoratorExpressions = [];
	            ts.addRange(decoratorExpressions, ts.map(allDecorators.decorators, transformDecorator));
	            ts.addRange(decoratorExpressions, ts.flatMap(allDecorators.parameters, transformDecoratorsOfParameter));
	            addTypeMetadata(node, container, decoratorExpressions);
	            return decoratorExpressions;
	        }
	        /**
	         * Generates statements used to apply decorators to either the static or instance members
	         * of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to generate statements for static or
	         *                 instance members.
	         */
	        function addClassElementDecorationStatements(statements, node, isStatic) {
	            ts.addRange(statements, ts.map(generateClassElementDecorationExpressions(node, isStatic), expressionToStatement));
	        }
	        /**
	         * Generates expressions used to apply decorators to either the static or instance members
	         * of a class.
	         *
	         * @param node The class node.
	         * @param isStatic A value indicating whether to generate expressions for static or
	         *                 instance members.
	         */
	        function generateClassElementDecorationExpressions(node, isStatic) {
	            var members = getDecoratedClassElements(node, isStatic);
	            var expressions;
	            for (var _i = 0, members_5 = members; _i < members_5.length; _i++) {
	                var member = members_5[_i];
	                var expression = generateClassElementDecorationExpression(node, member);
	                if (expression) {
	                    if (!expressions) {
	                        expressions = [expression];
	                    }
	                    else {
	                        expressions.push(expression);
	                    }
	                }
	            }
	            return expressions;
	        }
	        /**
	         * Generates an expression used to evaluate class element decorators at runtime.
	         *
	         * @param node The class node that contains the member.
	         * @param member The class member.
	         */
	        function generateClassElementDecorationExpression(node, member) {
	            var allDecorators = getAllDecoratorsOfClassElement(node, member);
	            var decoratorExpressions = transformAllDecoratorsOfDeclaration(member, node, allDecorators);
	            if (!decoratorExpressions) {
	                return undefined;
	            }
	            // Emit the call to __decorate. Given the following:
	            //
	            //   class C {
	            //     @dec method(@dec2 x) {}
	            //     @dec get accessor() {}
	            //     @dec prop;
	            //   }
	            //
	            // The emit for a method is:
	            //
	            //   __decorate([
	            //       dec,
	            //       __param(0, dec2),
	            //       __metadata("design:type", Function),
	            //       __metadata("design:paramtypes", [Object]),
	            //       __metadata("design:returntype", void 0)
	            //   ], C.prototype, "method", null);
	            //
	            // The emit for an accessor is:
	            //
	            //   __decorate([
	            //       dec
	            //   ], C.prototype, "accessor", null);
	            //
	            // The emit for a property is:
	            //
	            //   __decorate([
	            //       dec
	            //   ], C.prototype, "prop");
	            //
	            var prefix = getClassMemberPrefix(node, member);
	            var memberName = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ true);
	            var descriptor = languageVersion > 0 /* ES3 */
	                ? member.kind === 151 /* PropertyDeclaration */
	                    // We emit `void 0` here to indicate to `__decorate` that it can invoke `Object.defineProperty` directly, but that it
	                    // should not invoke `Object.getOwnPropertyDescriptor`.
	                    ? ts.createVoidZero()
	                    // We emit `null` here to indicate to `__decorate` that it can invoke `Object.getOwnPropertyDescriptor` directly.
	                    // We have this extra argument here so that we can inject an explicit property descriptor at a later date.
	                    : ts.createNull()
	                : undefined;
	            var helper = createDecorateHelper(context, decoratorExpressions, prefix, memberName, descriptor, ts.moveRangePastDecorators(member));
	            ts.setEmitFlags(helper, 1536 /* NoComments */);
	            return helper;
	        }
	        /**
	         * Generates a __decorate helper call for a class constructor.
	         *
	         * @param node The class node.
	         */
	        function addConstructorDecorationStatement(statements, node) {
	            var expression = generateConstructorDecorationExpression(node);
	            if (expression) {
	                statements.push(ts.setOriginalNode(ts.createStatement(expression), node));
	            }
	        }
	        /**
	         * Generates a __decorate helper call for a class constructor.
	         *
	         * @param node The class node.
	         */
	        function generateConstructorDecorationExpression(node) {
	            var allDecorators = getAllDecoratorsOfConstructor(node);
	            var decoratorExpressions = transformAllDecoratorsOfDeclaration(node, node, allDecorators);
	            if (!decoratorExpressions) {
	                return undefined;
	            }
	            var classAlias = classAliases && classAliases[ts.getOriginalNodeId(node)];
	            var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            var decorate = createDecorateHelper(context, decoratorExpressions, localName);
	            var expression = ts.createAssignment(localName, classAlias ? ts.createAssignment(classAlias, decorate) : decorate);
	            ts.setEmitFlags(expression, 1536 /* NoComments */);
	            ts.setSourceMapRange(expression, ts.moveRangePastDecorators(node));
	            return expression;
	        }
	        /**
	         * Transforms a decorator into an expression.
	         *
	         * @param decorator The decorator node.
	         */
	        function transformDecorator(decorator) {
	            return ts.visitNode(decorator.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Transforms the decorators of a parameter.
	         *
	         * @param decorators The decorators for the parameter at the provided offset.
	         * @param parameterOffset The offset of the parameter.
	         */
	        function transformDecoratorsOfParameter(decorators, parameterOffset) {
	            var expressions;
	            if (decorators) {
	                expressions = [];
	                for (var _i = 0, decorators_1 = decorators; _i < decorators_1.length; _i++) {
	                    var decorator = decorators_1[_i];
	                    var helper = createParamHelper(context, transformDecorator(decorator), parameterOffset, 
	                    /*location*/ decorator.expression);
	                    ts.setEmitFlags(helper, 1536 /* NoComments */);
	                    expressions.push(helper);
	                }
	            }
	            return expressions;
	        }
	        /**
	         * Adds optional type metadata for a declaration.
	         *
	         * @param node The declaration node.
	         * @param decoratorExpressions The destination array to which to add new decorator expressions.
	         */
	        function addTypeMetadata(node, container, decoratorExpressions) {
	            if (USE_NEW_TYPE_METADATA_FORMAT) {
	                addNewTypeMetadata(node, container, decoratorExpressions);
	            }
	            else {
	                addOldTypeMetadata(node, container, decoratorExpressions);
	            }
	        }
	        function addOldTypeMetadata(node, container, decoratorExpressions) {
	            if (compilerOptions.emitDecoratorMetadata) {
	                if (shouldAddTypeMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:type", serializeTypeOfNode(node)));
	                }
	                if (shouldAddParamTypesMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:paramtypes", serializeParameterTypesOfNode(node, container)));
	                }
	                if (shouldAddReturnTypeMetadata(node)) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:returntype", serializeReturnTypeOfNode(node)));
	                }
	            }
	        }
	        function addNewTypeMetadata(node, container, decoratorExpressions) {
	            if (compilerOptions.emitDecoratorMetadata) {
	                var properties = void 0;
	                if (shouldAddTypeMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("type", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeTypeOfNode(node))));
	                }
	                if (shouldAddParamTypesMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("paramTypes", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeParameterTypesOfNode(node, container))));
	                }
	                if (shouldAddReturnTypeMetadata(node)) {
	                    (properties || (properties = [])).push(ts.createPropertyAssignment("returnType", ts.createArrowFunction(/*modifiers*/ undefined, /*typeParameters*/ undefined, [], /*type*/ undefined, ts.createToken(36 /* EqualsGreaterThanToken */), serializeReturnTypeOfNode(node))));
	                }
	                if (properties) {
	                    decoratorExpressions.push(createMetadataHelper(context, "design:typeinfo", ts.createObjectLiteral(properties, /*multiLine*/ true)));
	                }
	            }
	        }
	        /**
	         * Determines whether to emit the "design:type" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddTypeMetadata(node) {
	            var kind = node.kind;
	            return kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */
	                || kind === 151 /* PropertyDeclaration */;
	        }
	        /**
	         * Determines whether to emit the "design:returntype" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddReturnTypeMetadata(node) {
	            return node.kind === 153 /* MethodDeclaration */;
	        }
	        /**
	         * Determines whether to emit the "design:paramtypes" metadata based on the node's kind.
	         * The caller should have already tested whether the node has decorators and whether the
	         * emitDecoratorMetadata compiler option is set.
	         *
	         * @param node The node to test.
	         */
	        function shouldAddParamTypesMetadata(node) {
	            switch (node.kind) {
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                    return ts.getFirstConstructorWithBody(node) !== undefined;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return true;
	            }
	            return false;
	        }
	        /**
	         * Serializes the type of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its type serialized.
	         */
	        function serializeTypeOfNode(node) {
	            switch (node.kind) {
	                case 151 /* PropertyDeclaration */:
	                case 148 /* Parameter */:
	                case 155 /* GetAccessor */:
	                    return serializeTypeNode(node.type);
	                case 156 /* SetAccessor */:
	                    return serializeTypeNode(ts.getSetAccessorTypeAnnotationNode(node));
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                case 153 /* MethodDeclaration */:
	                    return ts.createIdentifier("Function");
	                default:
	                    return ts.createVoidZero();
	            }
	        }
	        /**
	         * Serializes the types of the parameters of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its parameter types serialized.
	         */
	        function serializeParameterTypesOfNode(node, container) {
	            var valueDeclaration = ts.isClassLike(node)
	                ? ts.getFirstConstructorWithBody(node)
	                : ts.isFunctionLike(node) && ts.nodeIsPresent(node.body)
	                    ? node
	                    : undefined;
	            var expressions = [];
	            if (valueDeclaration) {
	                var parameters = getParametersOfDecoratedDeclaration(valueDeclaration, container);
	                var numParameters = parameters.length;
	                for (var i = 0; i < numParameters; i++) {
	                    var parameter = parameters[i];
	                    if (i === 0 && ts.isIdentifier(parameter.name) && parameter.name.escapedText === "this") {
	                        continue;
	                    }
	                    if (parameter.dotDotDotToken) {
	                        expressions.push(serializeTypeNode(ts.getRestParameterElementType(parameter.type)));
	                    }
	                    else {
	                        expressions.push(serializeTypeOfNode(parameter));
	                    }
	                }
	            }
	            return ts.createArrayLiteral(expressions);
	        }
	        function getParametersOfDecoratedDeclaration(node, container) {
	            if (container && node.kind === 155 /* GetAccessor */) {
	                var setAccessor = ts.getAllAccessorDeclarations(container.members, node).setAccessor;
	                if (setAccessor) {
	                    return setAccessor.parameters;
	                }
	            }
	            return node.parameters;
	        }
	        /**
	         * Serializes the return type of a node for use with decorator type metadata.
	         *
	         * @param node The node that should have its return type serialized.
	         */
	        function serializeReturnTypeOfNode(node) {
	            if (ts.isFunctionLike(node) && node.type) {
	                return serializeTypeNode(node.type);
	            }
	            else if (ts.isAsyncFunction(node)) {
	                return ts.createIdentifier("Promise");
	            }
	            return ts.createVoidZero();
	        }
	        /**
	         * Serializes a type node for use with decorator type metadata.
	         *
	         * Types are serialized in the following fashion:
	         * - Void types point to "undefined" (e.g. "void 0")
	         * - Function and Constructor types point to the global "Function" constructor.
	         * - Interface types with a call or construct signature types point to the global
	         *   "Function" constructor.
	         * - Array and Tuple types point to the global "Array" constructor.
	         * - Type predicates and booleans point to the global "Boolean" constructor.
	         * - String literal types and strings point to the global "String" constructor.
	         * - Enum and number types point to the global "Number" constructor.
	         * - Symbol types point to the global "Symbol" constructor.
	         * - Type references to classes (or class-like variables) point to the constructor for the class.
	         * - Anything else points to the global "Object" constructor.
	         *
	         * @param node The type node to serialize.
	         */
	        function serializeTypeNode(node) {
	            if (node === undefined) {
	                return ts.createIdentifier("Object");
	            }
	            switch (node.kind) {
	                case 105 /* VoidKeyword */:
	                case 140 /* UndefinedKeyword */:
	                case 95 /* NullKeyword */:
	                case 131 /* NeverKeyword */:
	                    return ts.createVoidZero();
	                case 172 /* ParenthesizedType */:
	                    return serializeTypeNode(node.type);
	                case 162 /* FunctionType */:
	                case 163 /* ConstructorType */:
	                    return ts.createIdentifier("Function");
	                case 166 /* ArrayType */:
	                case 167 /* TupleType */:
	                    return ts.createIdentifier("Array");
	                case 160 /* TypePredicate */:
	                case 122 /* BooleanKeyword */:
	                    return ts.createIdentifier("Boolean");
	                case 137 /* StringKeyword */:
	                    return ts.createIdentifier("String");
	                case 135 /* ObjectKeyword */:
	                    return ts.createIdentifier("Object");
	                case 177 /* LiteralType */:
	                    switch (node.literal.kind) {
	                        case 9 /* StringLiteral */:
	                            return ts.createIdentifier("String");
	                        case 8 /* NumericLiteral */:
	                            return ts.createIdentifier("Number");
	                        case 101 /* TrueKeyword */:
	                        case 86 /* FalseKeyword */:
	                            return ts.createIdentifier("Boolean");
	                        default:
	                            return ts.Debug.failBadSyntaxKind(node.literal);
	                    }
	                case 134 /* NumberKeyword */:
	                    return ts.createIdentifier("Number");
	                case 138 /* SymbolKeyword */:
	                    return languageVersion < 2 /* ES2015 */
	                        ? getGlobalSymbolNameWithFallback()
	                        : ts.createIdentifier("Symbol");
	                case 161 /* TypeReference */:
	                    return serializeTypeReferenceNode(node);
	                case 169 /* IntersectionType */:
	                case 168 /* UnionType */:
	                    return serializeUnionOrIntersectionType(node);
	                case 164 /* TypeQuery */:
	                case 174 /* TypeOperator */:
	                case 175 /* IndexedAccessType */:
	                case 176 /* MappedType */:
	                case 165 /* TypeLiteral */:
	                case 119 /* AnyKeyword */:
	                case 173 /* ThisType */:
	                case 178 /* ImportType */:
	                    break;
	                default:
	                    return ts.Debug.failBadSyntaxKind(node);
	            }
	            return ts.createIdentifier("Object");
	        }
	        function serializeUnionOrIntersectionType(node) {
	            // Note when updating logic here also update getEntityNameForDecoratorMetadata
	            // so that aliases can be marked as referenced
	            var serializedUnion;
	            for (var _i = 0, _a = node.types; _i < _a.length; _i++) {
	                var typeNode = _a[_i];
	                while (typeNode.kind === 172 /* ParenthesizedType */) {
	                    typeNode = typeNode.type; // Skip parens if need be
	                }
	                if (typeNode.kind === 131 /* NeverKeyword */) {
	                    continue; // Always elide `never` from the union/intersection if possible
	                }
	                if (!strictNullChecks && (typeNode.kind === 95 /* NullKeyword */ || typeNode.kind === 140 /* UndefinedKeyword */)) {
	                    continue; // Elide null and undefined from unions for metadata, just like what we did prior to the implementation of strict null checks
	                }
	                var serializedIndividual = serializeTypeNode(typeNode);
	                if (ts.isIdentifier(serializedIndividual) && serializedIndividual.escapedText === "Object") {
	                    // One of the individual is global object, return immediately
	                    return serializedIndividual;
	                }
	                // If there exists union that is not void 0 expression, check if the the common type is identifier.
	                // anything more complex and we will just default to Object
	                else if (serializedUnion) {
	                    // Different types
	                    if (!ts.isIdentifier(serializedUnion) ||
	                        !ts.isIdentifier(serializedIndividual) ||
	                        serializedUnion.escapedText !== serializedIndividual.escapedText) {
	                        return ts.createIdentifier("Object");
	                    }
	                }
	                else {
	                    // Initialize the union type
	                    serializedUnion = serializedIndividual;
	                }
	            }
	            // If we were able to find common type, use it
	            return serializedUnion || ts.createVoidZero(); // Fallback is only hit if all union constituients are null/undefined/never
	        }
	        /**
	         * Serializes a TypeReferenceNode to an appropriate JS constructor value for use with
	         * decorator type metadata.
	         *
	         * @param node The type reference node.
	         */
	        function serializeTypeReferenceNode(node) {
	            var kind = resolver.getTypeReferenceSerializationKind(node.typeName, currentScope);
	            switch (kind) {
	                case ts.TypeReferenceSerializationKind.Unknown:
	                    var serialized = serializeEntityNameAsExpression(node.typeName, /*useFallback*/ true);
	                    var temp = ts.createTempVariable(hoistVariableDeclaration);
	                    return ts.createLogicalOr(ts.createLogicalAnd(ts.createTypeCheck(ts.createAssignment(temp, serialized), "function"), temp), ts.createIdentifier("Object"));
	                case ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue:
	                    return serializeEntityNameAsExpression(node.typeName, /*useFallback*/ false);
	                case ts.TypeReferenceSerializationKind.VoidNullableOrNeverType:
	                    return ts.createVoidZero();
	                case ts.TypeReferenceSerializationKind.BooleanType:
	                    return ts.createIdentifier("Boolean");
	                case ts.TypeReferenceSerializationKind.NumberLikeType:
	                    return ts.createIdentifier("Number");
	                case ts.TypeReferenceSerializationKind.StringLikeType:
	                    return ts.createIdentifier("String");
	                case ts.TypeReferenceSerializationKind.ArrayLikeType:
	                    return ts.createIdentifier("Array");
	                case ts.TypeReferenceSerializationKind.ESSymbolType:
	                    return languageVersion < 2 /* ES2015 */
	                        ? getGlobalSymbolNameWithFallback()
	                        : ts.createIdentifier("Symbol");
	                case ts.TypeReferenceSerializationKind.TypeWithCallSignature:
	                    return ts.createIdentifier("Function");
	                case ts.TypeReferenceSerializationKind.Promise:
	                    return ts.createIdentifier("Promise");
	                case ts.TypeReferenceSerializationKind.ObjectType:
	                    return ts.createIdentifier("Object");
	                default:
	                    return ts.Debug.assertNever(kind);
	            }
	        }
	        /**
	         * Serializes an entity name as an expression for decorator type metadata.
	         *
	         * @param node The entity name to serialize.
	         * @param useFallback A value indicating whether to use logical operators to test for the
	         *                    entity name at runtime.
	         */
	        function serializeEntityNameAsExpression(node, useFallback) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    // Create a clone of the name with a new parent, and treat it as if it were
	                    // a source tree node for the purposes of the checker.
	                    var name = ts.getMutableClone(node);
	                    name.flags &= ~8 /* Synthesized */;
	                    name.original = undefined;
	                    name.parent = ts.getParseTreeNode(currentScope); // ensure the parent is set to a parse tree node.
	                    if (useFallback) {
	                        return ts.createLogicalAnd(ts.createStrictInequality(ts.createTypeOf(name), ts.createLiteral("undefined")), name);
	                    }
	                    return name;
	                case 145 /* QualifiedName */:
	                    return serializeQualifiedNameAsExpression(node, useFallback);
	            }
	        }
	        /**
	         * Serializes an qualified name as an expression for decorator type metadata.
	         *
	         * @param node The qualified name to serialize.
	         * @param useFallback A value indicating whether to use logical operators to test for the
	         *                    qualified name at runtime.
	         */
	        function serializeQualifiedNameAsExpression(node, useFallback) {
	            var left;
	            if (node.left.kind === 71 /* Identifier */) {
	                left = serializeEntityNameAsExpression(node.left, useFallback);
	            }
	            else if (useFallback) {
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                left = ts.createLogicalAnd(ts.createAssignment(temp, serializeEntityNameAsExpression(node.left, /*useFallback*/ true)), temp);
	            }
	            else {
	                left = serializeEntityNameAsExpression(node.left, /*useFallback*/ false);
	            }
	            return ts.createPropertyAccess(left, node.right);
	        }
	        /**
	         * Gets an expression that points to the global "Symbol" constructor at runtime if it is
	         * available.
	         */
	        function getGlobalSymbolNameWithFallback() {
	            return ts.createConditional(ts.createTypeCheck(ts.createIdentifier("Symbol"), "function"), ts.createIdentifier("Symbol"), ts.createIdentifier("Object"));
	        }
	        /**
	         * A simple inlinable expression is an expression which can be copied into multiple locations
	         * without risk of repeating any sideeffects and whose value could not possibly change between
	         * any such locations
	         */
	        function isSimpleInlineableExpression(expression) {
	            return !ts.isIdentifier(expression) && ts.isSimpleCopiableExpression(expression) ||
	                ts.isWellKnownSymbolSyntactically(expression);
	        }
	        /**
	         * Gets an expression that represents a property name. For a computed property, a
	         * name is generated for the node.
	         *
	         * @param member The member whose name should be converted into an expression.
	         */
	        function getExpressionForPropertyName(member, generateNameForComputedPropertyName) {
	            var name = member.name;
	            if (ts.isComputedPropertyName(name)) {
	                return generateNameForComputedPropertyName && !isSimpleInlineableExpression(name.expression)
	                    ? ts.getGeneratedNameForNode(name)
	                    : name.expression;
	            }
	            else if (ts.isIdentifier(name)) {
	                return ts.createLiteral(ts.idText(name));
	            }
	            else {
	                return ts.getSynthesizedClone(name);
	            }
	        }
	        /**
	         * If the name is a computed property, this function transforms it, then either returns an expression which caches the
	         * value of the result or the expression itself if the value is either unused or safe to inline into multiple locations
	         * @param shouldHoist Does the expression need to be reused? (ie, for an initializer or a decorator)
	         * @param omitSimple Should expressions with no observable side-effects be elided? (ie, the expression is not hoisted for a decorator or initializer and is a literal)
	         */
	        function getPropertyNameExpressionIfNeeded(name, shouldHoist, omitSimple) {
	            if (ts.isComputedPropertyName(name)) {
	                var expression = ts.visitNode(name.expression, visitor, ts.isExpression);
	                var innerExpression = ts.skipPartiallyEmittedExpressions(expression);
	                var inlinable = isSimpleInlineableExpression(innerExpression);
	                if (!inlinable && shouldHoist) {
	                    var generatedName = ts.getGeneratedNameForNode(name);
	                    hoistVariableDeclaration(generatedName);
	                    return ts.createAssignment(generatedName, expression);
	                }
	                return (omitSimple && (inlinable || ts.isIdentifier(innerExpression))) ? undefined : expression;
	            }
	        }
	        /**
	         * Visits the property name of a class element, for use when emitting property
	         * initializers. For a computed property on a node with decorators, a temporary
	         * value is stored for later use.
	         *
	         * @param member The member whose name should be visited.
	         */
	        function visitPropertyNameOfClassElement(member) {
	            var name = member.name;
	            var expr = getPropertyNameExpressionIfNeeded(name, ts.some(member.decorators), /*omitSimple*/ false);
	            if (expr) { // expr only exists if `name` is a computed property name
	                // Inline any pending expressions from previous elided or relocated computed property name expressions in order to preserve execution order
	                if (ts.some(pendingExpressions)) {
	                    expr = ts.inlineExpressions(pendingExpressions.concat([expr]));
	                    pendingExpressions.length = 0;
	                }
	                return ts.updateComputedPropertyName(name, expr);
	            }
	            else {
	                return name;
	            }
	        }
	        /**
	         * Transforms a HeritageClause with TypeScript syntax.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The node is a non-`extends` heritage clause that should be elided.
	         * - The node is an `extends` heritage clause that should be visited, but only allow a single type.
	         *
	         * @param node The HeritageClause to transform.
	         */
	        function visitHeritageClause(node) {
	            if (node.token === 85 /* ExtendsKeyword */) {
	                var types = ts.visitNodes(node.types, visitor, ts.isExpressionWithTypeArguments, 0, 1);
	                return ts.setTextRange(ts.createHeritageClause(85 /* ExtendsKeyword */, types), node);
	            }
	            return undefined;
	        }
	        /**
	         * Transforms an ExpressionWithTypeArguments with TypeScript syntax.
	         *
	         * This function will only be called when one of the following conditions are met:
	         * - The node contains type arguments that should be elided.
	         *
	         * @param node The ExpressionWithTypeArguments to transform.
	         */
	        function visitExpressionWithTypeArguments(node) {
	            return ts.updateExpressionWithTypeArguments(node, 
	            /*typeArguments*/ undefined, ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression));
	        }
	        /**
	         * Determines whether to emit a function-like declaration. We should not emit the
	         * declaration if it does not have a body.
	         *
	         * @param node The declaration node.
	         */
	        function shouldEmitFunctionLikeDeclaration(node) {
	            return !ts.nodeIsMissing(node.body);
	        }
	        function visitPropertyDeclaration(node) {
	            var expr = getPropertyNameExpressionIfNeeded(node.name, ts.some(node.decorators) || !!node.initializer, /*omitSimple*/ true);
	            if (expr && !isSimpleInlineableExpression(expr)) {
	                (pendingExpressions || (pendingExpressions = [])).push(expr);
	            }
	            return undefined;
	        }
	        function visitConstructor(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return undefined;
	            }
	            return ts.updateConstructor(node, ts.visitNodes(node.decorators, visitor, ts.isDecorator), ts.visitNodes(node.modifiers, visitor, ts.isModifier), ts.visitParameterList(node.parameters, visitor, context), ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a method declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is an overload
	         * - The node is marked as abstract, public, private, protected, or readonly
	         * - The node has a computed property name
	         *
	         * @param node The method node.
	         */
	        function visitMethodDeclaration(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateMethod(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, visitPropertyNameOfClassElement(node), 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Determines whether to emit an accessor declaration. We should not emit the
	         * declaration if it does not have a body and is abstract.
	         *
	         * @param node The declaration node.
	         */
	        function shouldEmitAccessorDeclaration(node) {
	            return !(ts.nodeIsMissing(node.body) && ts.hasModifier(node, 128 /* Abstract */));
	        }
	        /**
	         * Visits a get accessor declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as abstract, public, private, or protected
	         * - The node has a computed property name
	         *
	         * @param node The get accessor node.
	         */
	        function visitGetAccessor(node) {
	            if (!shouldEmitAccessorDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateGetAccessor(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), visitPropertyNameOfClassElement(node), ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Visits a set accessor declaration of a class.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as abstract, public, private, or protected
	         * - The node has a computed property name
	         *
	         * @param node The set accessor node.
	         */
	        function visitSetAccessor(node) {
	            if (!shouldEmitAccessorDeclaration(node)) {
	                return undefined;
	            }
	            var updated = ts.updateSetAccessor(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), visitPropertyNameOfClassElement(node), ts.visitParameterList(node.parameters, visitor, context), ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (updated !== node) {
	                // While we emit the source map for the node after skipping decorators and modifiers,
	                // we need to emit the comments for the original range.
	                ts.setCommentRange(updated, node);
	                ts.setSourceMapRange(updated, ts.moveRangePastDecorators(node));
	            }
	            return updated;
	        }
	        /**
	         * Visits a function declaration.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is an overload
	         * - The node is exported from a TypeScript namespace
	         * - The node has decorators
	         *
	         * @param node The function node.
	         */
	        function visitFunctionDeclaration(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return ts.createNotEmittedStatement(node);
	            }
	            var updated = ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            if (isExportOfNamespace(node)) {
	                var statements = [updated];
	                addExportMemberAssignment(statements, node);
	                return statements;
	            }
	            return updated;
	        }
	        /**
	         * Visits a function expression node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node has type annotations
	         *
	         * @param node The function expression node.
	         */
	        function visitFunctionExpression(node) {
	            if (!shouldEmitFunctionLikeDeclaration(node)) {
	                return ts.createOmittedExpression();
	            }
	            var updated = ts.updateFunctionExpression(node, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.visitFunctionBody(node.body, visitor, context) || ts.createBlock([]));
	            return updated;
	        }
	        /**
	         * @remarks
	         * This function will be called when one of the following conditions are met:
	         * - The node has type annotations
	         */
	        function visitArrowFunction(node) {
	            var updated = ts.updateArrowFunction(node, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, ts.visitFunctionBody(node.body, visitor, context));
	            return updated;
	        }
	        /**
	         * Visits a parameter declaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node has an accessibility modifier.
	         * - The node has a questionToken.
	         * - The node's kind is ThisKeyword.
	         *
	         * @param node The parameter declaration node.
	         */
	        function visitParameter(node) {
	            if (ts.parameterIsThisKeyword(node)) {
	                return undefined;
	            }
	            var parameter = ts.createParameter(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, node.dotDotDotToken, ts.visitNode(node.name, visitor, ts.isBindingName), 
	            /*questionToken*/ undefined, 
	            /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	            // While we emit the source map for the node after skipping decorators and modifiers,
	            // we need to emit the comments for the original range.
	            ts.setOriginalNode(parameter, node);
	            ts.setTextRange(parameter, ts.moveRangePastModifiers(node));
	            ts.setCommentRange(parameter, node);
	            ts.setSourceMapRange(parameter, ts.moveRangePastModifiers(node));
	            ts.setEmitFlags(parameter.name, 32 /* NoTrailingSourceMap */);
	            return parameter;
	        }
	        /**
	         * Visits a variable statement in a namespace.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is exported from a TypeScript namespace.
	         */
	        function visitVariableStatement(node) {
	            if (isExportOfNamespace(node)) {
	                var variables = ts.getInitializedVariables(node.declarationList);
	                if (variables.length === 0) {
	                    // elide statement if there are no initialized variables.
	                    return undefined;
	                }
	                return ts.setTextRange(ts.createStatement(ts.inlineExpressions(ts.map(variables, transformInitializedVariable))), node);
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformInitializedVariable(node) {
	            var name = node.name;
	            if (ts.isBindingPattern(name)) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 0 /* All */, 
	                /*needsValue*/ false, createNamespaceExportExpression);
	            }
	            else {
	                return ts.setTextRange(ts.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(name), ts.visitNode(node.initializer, visitor, ts.isExpression)), 
	                /*location*/ node);
	            }
	        }
	        function visitVariableDeclaration(node) {
	            return ts.updateVariableDeclaration(node, ts.visitNode(node.name, visitor, ts.isBindingName), 
	            /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	        }
	        /**
	         * Visits a parenthesized expression that contains either a type assertion or an `as`
	         * expression.
	         *
	         * @param node The parenthesized expression node.
	         */
	        function visitParenthesizedExpression(node) {
	            var innerExpression = ts.skipOuterExpressions(node.expression, ~2 /* Assertions */);
	            if (ts.isAssertionExpression(innerExpression)) {
	                // Make sure we consider all nested cast expressions, e.g.:
	                // (<any><number><any>-A).x;
	                var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	                // We have an expression of the form: (<Type>SubExpr). Emitting this as (SubExpr)
	                // is really not desirable. We would like to emit the subexpression as-is. Omitting
	                // the parentheses, however, could cause change in the semantics of the generated
	                // code if the casted expression has a lower precedence than the rest of the
	                // expression.
	                //
	                // To preserve comments, we return a "PartiallyEmittedExpression" here which will
	                // preserve the position information of the original expression.
	                //
	                // Due to the auto-parenthesization rules used by the visitor and factory functions
	                // we can safely elide the parentheses here, as a new synthetic
	                // ParenthesizedExpression will be inserted if we remove parentheses too
	                // aggressively.
	                // HOWEVER - if there are leading comments on the expression itself, to handle ASI
	                // correctly for return and throw, we must keep the parenthesis
	                if (ts.length(ts.getLeadingCommentRangesOfNode(expression, currentSourceFile))) {
	                    return ts.updateParen(node, expression);
	                }
	                return ts.createPartiallyEmittedExpression(expression, node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitAssertionExpression(node) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            return ts.createPartiallyEmittedExpression(expression, node);
	        }
	        function visitNonNullExpression(node) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression);
	            return ts.createPartiallyEmittedExpression(expression, node);
	        }
	        function visitCallExpression(node) {
	            return ts.updateCall(node, ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        function visitNewExpression(node) {
	            return ts.updateNew(node, ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        function visitTaggedTemplateExpression(node) {
	            return ts.updateTaggedTemplate(node, ts.visitNode(node.tag, visitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNode(node.template, visitor, ts.isExpression));
	        }
	        /**
	         * Determines whether to emit an enum declaration.
	         *
	         * @param node The enum declaration node.
	         */
	        function shouldEmitEnumDeclaration(node) {
	            return !ts.isConst(node)
	                || compilerOptions.preserveConstEnums
	                || compilerOptions.isolatedModules;
	        }
	        /**
	         * Visits an enum declaration.
	         *
	         * This function will be called any time a TypeScript enum is encountered.
	         *
	         * @param node The enum declaration node.
	         */
	        function visitEnumDeclaration(node) {
	            if (!shouldEmitEnumDeclaration(node)) {
	                return undefined;
	            }
	            var statements = [];
	            // We request to be advised when the printer is about to print this node. This allows
	            // us to set up the correct state for later substitutions.
	            var emitFlags = 2 /* AdviseOnEmitNode */;
	            // If needed, we should emit a variable declaration for the enum. If we emit
	            // a leading variable declaration, we should not emit leading comments for the
	            // enum body.
	            if (addVarForEnumOrModuleDeclaration(statements, node)) {
	                // We should still emit the comments if we are emitting a system module.
	                if (moduleKind !== ts.ModuleKind.System || currentScope !== currentSourceFile) {
	                    emitFlags |= 512 /* NoLeadingComments */;
	                }
	            }
	            // `parameterName` is the declaration name used inside of the enum.
	            var parameterName = getNamespaceParameterName(node);
	            // `containerName` is the expression used inside of the enum for assignments.
	            var containerName = getNamespaceContainerName(node);
	            // `exportName` is the expression used within this node's container for any exported references.
	            var exportName = ts.hasModifier(node, 1 /* Export */)
	                ? ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true)
	                : ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  x || (x = {})
	            //  exports.x || (exports.x = {})
	            var moduleArg = ts.createLogicalOr(exportName, ts.createAssignment(exportName, ts.createObjectLiteral()));
	            if (hasNamespaceQualifiedExportName(node)) {
	                // `localName` is the expression used within this node's containing scope for any local references.
	                var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	                //  x = (exports.x || (exports.x = {}))
	                moduleArg = ts.createAssignment(localName, moduleArg);
	            }
	            //  (function (x) {
	            //      x[x["y"] = 0] = "y";
	            //      ...
	            //  })(x || (x = {}));
	            var enumStatement = ts.createStatement(ts.createCall(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	            /*type*/ undefined, transformEnumBody(node, containerName)), 
	            /*typeArguments*/ undefined, [moduleArg]));
	            ts.setOriginalNode(enumStatement, node);
	            ts.setTextRange(enumStatement, node);
	            ts.setEmitFlags(enumStatement, emitFlags);
	            statements.push(enumStatement);
	            // Add a DeclarationMarker for the enum to preserve trailing comments and mark
	            // the end of the declaration.
	            statements.push(ts.createEndOfDeclarationMarker(node));
	            return statements;
	        }
	        /**
	         * Transforms the body of an enum declaration.
	         *
	         * @param node The enum declaration node.
	         */
	        function transformEnumBody(node, localName) {
	            var savedCurrentNamespaceLocalName = currentNamespaceContainerName;
	            currentNamespaceContainerName = localName;
	            var statements = [];
	            startLexicalEnvironment();
	            var members = ts.map(node.members, transformEnumMember);
	            ts.prependStatements(statements, endLexicalEnvironment());
	            ts.addRange(statements, members);
	            currentNamespaceContainerName = savedCurrentNamespaceLocalName;
	            return ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), /*location*/ node.members), 
	            /*multiLine*/ true);
	        }
	        /**
	         * Transforms an enum member into a statement.
	         *
	         * @param member The enum member node.
	         */
	        function transformEnumMember(member) {
	            // enums don't support computed properties
	            // we pass false as 'generateNameForComputedPropertyName' for a backward compatibility purposes
	            // old emitter always generate 'expression' part of the name as-is.
	            var name = getExpressionForPropertyName(member, /*generateNameForComputedPropertyName*/ false);
	            var valueExpression = transformEnumMemberDeclarationValue(member);
	            var innerAssignment = ts.createAssignment(ts.createElementAccess(currentNamespaceContainerName, name), valueExpression);
	            var outerAssignment = valueExpression.kind === 9 /* StringLiteral */ ?
	                innerAssignment :
	                ts.createAssignment(ts.createElementAccess(currentNamespaceContainerName, innerAssignment), name);
	            return ts.setTextRange(ts.createStatement(ts.setTextRange(outerAssignment, member)), member);
	        }
	        /**
	         * Transforms the value of an enum member.
	         *
	         * @param member The enum member node.
	         */
	        function transformEnumMemberDeclarationValue(member) {
	            var value = resolver.getConstantValue(member);
	            if (value !== undefined) {
	                return ts.createLiteral(value);
	            }
	            else {
	                enableSubstitutionForNonQualifiedEnumMembers();
	                if (member.initializer) {
	                    return ts.visitNode(member.initializer, visitor, ts.isExpression);
	                }
	                else {
	                    return ts.createVoidZero();
	                }
	            }
	        }
	        /**
	         * Determines whether to elide a module declaration.
	         *
	         * @param node The module declaration node.
	         */
	        function shouldEmitModuleDeclaration(node) {
	            return ts.isInstantiatedModule(node, compilerOptions.preserveConstEnums || compilerOptions.isolatedModules);
	        }
	        /**
	         * Determines whether an exported declaration will have a qualified export name (e.g. `f.x`
	         * or `exports.x`).
	         */
	        function hasNamespaceQualifiedExportName(node) {
	            return isExportOfNamespace(node)
	                || (isExternalModuleExport(node)
	                    && moduleKind !== ts.ModuleKind.ES2015
	                    && moduleKind !== ts.ModuleKind.ESNext
	                    && moduleKind !== ts.ModuleKind.System);
	        }
	        /**
	         * Records that a declaration was emitted in the current scope, if it was the first
	         * declaration for the provided symbol.
	         */
	        function recordEmittedDeclarationInScope(node) {
	            if (!currentScopeFirstDeclarationsOfName) {
	                currentScopeFirstDeclarationsOfName = ts.createUnderscoreEscapedMap();
	            }
	            var name = declaredNameInScope(node);
	            if (!currentScopeFirstDeclarationsOfName.has(name)) {
	                currentScopeFirstDeclarationsOfName.set(name, node);
	            }
	        }
	        /**
	         * Determines whether a declaration is the first declaration with
	         * the same name emitted in the current scope.
	         */
	        function isFirstEmittedDeclarationInScope(node) {
	            if (currentScopeFirstDeclarationsOfName) {
	                var name = declaredNameInScope(node);
	                return currentScopeFirstDeclarationsOfName.get(name) === node;
	            }
	            return true;
	        }
	        function declaredNameInScope(node) {
	            ts.Debug.assertNode(node.name, ts.isIdentifier);
	            return node.name.escapedText;
	        }
	        /**
	         * Adds a leading VariableStatement for a enum or module declaration.
	         */
	        function addVarForEnumOrModuleDeclaration(statements, node) {
	            // Emit a variable statement for the module. We emit top-level enums as a `var`
	            // declaration to avoid static errors in global scripts scripts due to redeclaration.
	            // enums in any other scope are emitted as a `let` declaration.
	            var statement = ts.createVariableStatement(ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true))
	            ], currentScope.kind === 273 /* SourceFile */ ? 0 /* None */ : 1 /* Let */));
	            ts.setOriginalNode(statement, node);
	            recordEmittedDeclarationInScope(node);
	            if (isFirstEmittedDeclarationInScope(node)) {
	                // Adjust the source map emit to match the old emitter.
	                if (node.kind === 237 /* EnumDeclaration */) {
	                    ts.setSourceMapRange(statement.declarationList, node);
	                }
	                else {
	                    ts.setSourceMapRange(statement, node);
	                }
	                // Trailing comments for module declaration should be emitted after the function closure
	                // instead of the variable statement:
	                //
	                //     /** Module comment*/
	                //     module m1 {
	                //         function foo4Export() {
	                //         }
	                //     } // trailing comment module
	                //
	                // Should emit:
	                //
	                //     /** Module comment*/
	                //     var m1;
	                //     (function (m1) {
	                //         function foo4Export() {
	                //         }
	                //     })(m1 || (m1 = {})); // trailing comment module
	                //
	                ts.setCommentRange(statement, node);
	                ts.setEmitFlags(statement, 1024 /* NoTrailingComments */ | 4194304 /* HasEndOfDeclarationMarker */);
	                statements.push(statement);
	                return true;
	            }
	            else {
	                // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	                // declaration we do not emit a leading variable declaration. To preserve the
	                // begin/end semantics of the declararation and to properly handle exports
	                // we wrap the leading variable declaration in a `MergeDeclarationMarker`.
	                var mergeMarker = ts.createMergeDeclarationMarker(statement);
	                ts.setEmitFlags(mergeMarker, 1536 /* NoComments */ | 4194304 /* HasEndOfDeclarationMarker */);
	                statements.push(mergeMarker);
	                return false;
	            }
	        }
	        /**
	         * Visits a module declaration node.
	         *
	         * This function will be called any time a TypeScript namespace (ModuleDeclaration) is encountered.
	         *
	         * @param node The module declaration node.
	         */
	        function visitModuleDeclaration(node) {
	            if (!shouldEmitModuleDeclaration(node)) {
	                return ts.createNotEmittedStatement(node);
	            }
	            ts.Debug.assertNode(node.name, ts.isIdentifier, "A TypeScript namespace should have an Identifier name.");
	            enableSubstitutionForNamespaceExports();
	            var statements = [];
	            // We request to be advised when the printer is about to print this node. This allows
	            // us to set up the correct state for later substitutions.
	            var emitFlags = 2 /* AdviseOnEmitNode */;
	            // If needed, we should emit a variable declaration for the module. If we emit
	            // a leading variable declaration, we should not emit leading comments for the
	            // module body.
	            if (addVarForEnumOrModuleDeclaration(statements, node)) {
	                // We should still emit the comments if we are emitting a system module.
	                if (moduleKind !== ts.ModuleKind.System || currentScope !== currentSourceFile) {
	                    emitFlags |= 512 /* NoLeadingComments */;
	                }
	            }
	            // `parameterName` is the declaration name used inside of the namespace.
	            var parameterName = getNamespaceParameterName(node);
	            // `containerName` is the expression used inside of the namespace for exports.
	            var containerName = getNamespaceContainerName(node);
	            // `exportName` is the expression used within this node's container for any exported references.
	            var exportName = ts.hasModifier(node, 1 /* Export */)
	                ? ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true)
	                : ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	            //  x || (x = {})
	            //  exports.x || (exports.x = {})
	            var moduleArg = ts.createLogicalOr(exportName, ts.createAssignment(exportName, ts.createObjectLiteral()));
	            if (hasNamespaceQualifiedExportName(node)) {
	                // `localName` is the expression used within this node's containing scope for any local references.
	                var localName = ts.getLocalName(node, /*allowComments*/ false, /*allowSourceMaps*/ true);
	                //  x = (exports.x || (exports.x = {}))
	                moduleArg = ts.createAssignment(localName, moduleArg);
	            }
	            //  (function (x_1) {
	            //      x_1.y = ...;
	            //  })(x || (x = {}));
	            var moduleStatement = ts.createStatement(ts.createCall(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	            /*type*/ undefined, transformModuleBody(node, containerName)), 
	            /*typeArguments*/ undefined, [moduleArg]));
	            ts.setOriginalNode(moduleStatement, node);
	            ts.setTextRange(moduleStatement, node);
	            ts.setEmitFlags(moduleStatement, emitFlags);
	            statements.push(moduleStatement);
	            // Add a DeclarationMarker for the namespace to preserve trailing comments and mark
	            // the end of the declaration.
	            statements.push(ts.createEndOfDeclarationMarker(node));
	            return statements;
	        }
	        /**
	         * Transforms the body of a module declaration.
	         *
	         * @param node The module declaration node.
	         */
	        function transformModuleBody(node, namespaceLocalName) {
	            var savedCurrentNamespaceContainerName = currentNamespaceContainerName;
	            var savedCurrentNamespace = currentNamespace;
	            var savedCurrentScopeFirstDeclarationsOfName = currentScopeFirstDeclarationsOfName;
	            currentNamespaceContainerName = namespaceLocalName;
	            currentNamespace = node;
	            currentScopeFirstDeclarationsOfName = undefined;
	            var statements = [];
	            startLexicalEnvironment();
	            var statementsLocation;
	            var blockLocation;
	            var body = node.body;
	            if (body.kind === 239 /* ModuleBlock */) {
	                saveStateAndInvoke(body, function (body) { return ts.addRange(statements, ts.visitNodes(body.statements, namespaceElementVisitor, ts.isStatement)); });
	                statementsLocation = body.statements;
	                blockLocation = body;
	            }
	            else {
	                var result = visitModuleDeclaration(body);
	                if (result) {
	                    if (ts.isArray(result)) {
	                        ts.addRange(statements, result);
	                    }
	                    else {
	                        statements.push(result);
	                    }
	                }
	                var moduleBlock = getInnerMostModuleDeclarationFromDottedModule(node).body;
	                statementsLocation = ts.moveRangePos(moduleBlock.statements, -1);
	            }
	            ts.prependStatements(statements, endLexicalEnvironment());
	            currentNamespaceContainerName = savedCurrentNamespaceContainerName;
	            currentNamespace = savedCurrentNamespace;
	            currentScopeFirstDeclarationsOfName = savedCurrentScopeFirstDeclarationsOfName;
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ statementsLocation), 
	            /*multiLine*/ true);
	            ts.setTextRange(block, blockLocation);
	            // namespace hello.hi.world {
	            //      function foo() {}
	            //
	            //      // TODO, blah
	            // }
	            //
	            // should be emitted as
	            //
	            // var hello;
	            // (function (hello) {
	            //     var hi;
	            //     (function (hi) {
	            //         var world;
	            //         (function (world) {
	            //             function foo() { }
	            //             // TODO, blah
	            //         })(world = hi.world || (hi.world = {}));
	            //     })(hi = hello.hi || (hello.hi = {}));
	            // })(hello || (hello = {}));
	            // We only want to emit comment on the namespace which contains block body itself, not the containing namespaces.
	            if (body.kind !== 239 /* ModuleBlock */) {
	                ts.setEmitFlags(block, ts.getEmitFlags(block) | 1536 /* NoComments */);
	            }
	            return block;
	        }
	        function getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration) {
	            if (moduleDeclaration.body.kind === 238 /* ModuleDeclaration */) {
	                var recursiveInnerModule = getInnerMostModuleDeclarationFromDottedModule(moduleDeclaration.body);
	                return recursiveInnerModule || moduleDeclaration.body;
	            }
	        }
	        /**
	         * Visits an import declaration, eliding it if it is not referenced.
	         *
	         * @param node The import declaration node.
	         */
	        function visitImportDeclaration(node) {
	            if (!node.importClause) {
	                // Do not elide a side-effect only import declaration.
	                //  import "foo";
	                return node;
	            }
	            // Elide the declaration if the import clause was elided.
	            var importClause = ts.visitNode(node.importClause, visitImportClause, ts.isImportClause);
	            return importClause
	                ? ts.updateImportDeclaration(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, importClause, node.moduleSpecifier)
	                : undefined;
	        }
	        /**
	         * Visits an import clause, eliding it if it is not referenced.
	         *
	         * @param node The import clause node.
	         */
	        function visitImportClause(node) {
	            // Elide the import clause if we elide both its name and its named bindings.
	            var name = resolver.isReferencedAliasDeclaration(node) ? node.name : undefined;
	            var namedBindings = ts.visitNode(node.namedBindings, visitNamedImportBindings, ts.isNamedImportBindings);
	            return (name || namedBindings) ? ts.updateImportClause(node, name, namedBindings) : undefined;
	        }
	        /**
	         * Visits named import bindings, eliding it if it is not referenced.
	         *
	         * @param node The named import bindings node.
	         */
	        function visitNamedImportBindings(node) {
	            if (node.kind === 245 /* NamespaceImport */) {
	                // Elide a namespace import if it is not referenced.
	                return resolver.isReferencedAliasDeclaration(node) ? node : undefined;
	            }
	            else {
	                // Elide named imports if all of its import specifiers are elided.
	                var elements = ts.visitNodes(node.elements, visitImportSpecifier, ts.isImportSpecifier);
	                return ts.some(elements) ? ts.updateNamedImports(node, elements) : undefined;
	            }
	        }
	        /**
	         * Visits an import specifier, eliding it if it is not referenced.
	         *
	         * @param node The import specifier node.
	         */
	        function visitImportSpecifier(node) {
	            // Elide an import specifier if it is not referenced.
	            return resolver.isReferencedAliasDeclaration(node) ? node : undefined;
	        }
	        /**
	         * Visits an export assignment, eliding it if it does not contain a clause that resolves
	         * to a value.
	         *
	         * @param node The export assignment node.
	         */
	        function visitExportAssignment(node) {
	            // Elide the export assignment if it does not reference a value.
	            return resolver.isValueAliasDeclaration(node)
	                ? ts.visitEachChild(node, visitor, context)
	                : undefined;
	        }
	        /**
	         * Visits an export declaration, eliding it if it does not contain a clause that resolves
	         * to a value.
	         *
	         * @param node The export declaration node.
	         */
	        function visitExportDeclaration(node) {
	            if (!node.exportClause) {
	                // Elide a star export if the module it references does not export a value.
	                return compilerOptions.isolatedModules || resolver.moduleExportsSomeValue(node.moduleSpecifier) ? node : undefined;
	            }
	            if (!resolver.isValueAliasDeclaration(node)) {
	                // Elide the export declaration if it does not export a value.
	                return undefined;
	            }
	            // Elide the export declaration if all of its named exports are elided.
	            var exportClause = ts.visitNode(node.exportClause, visitNamedExports, ts.isNamedExports);
	            return exportClause
	                ? ts.updateExportDeclaration(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, exportClause, node.moduleSpecifier)
	                : undefined;
	        }
	        /**
	         * Visits named exports, eliding it if it does not contain an export specifier that
	         * resolves to a value.
	         *
	         * @param node The named exports node.
	         */
	        function visitNamedExports(node) {
	            // Elide the named exports if all of its export specifiers were elided.
	            var elements = ts.visitNodes(node.elements, visitExportSpecifier, ts.isExportSpecifier);
	            return ts.some(elements) ? ts.updateNamedExports(node, elements) : undefined;
	        }
	        /**
	         * Visits an export specifier, eliding it if it does not resolve to a value.
	         *
	         * @param node The export specifier node.
	         */
	        function visitExportSpecifier(node) {
	            // Elide an export specifier if it does not reference a value.
	            return resolver.isValueAliasDeclaration(node) ? node : undefined;
	        }
	        /**
	         * Determines whether to emit an import equals declaration.
	         *
	         * @param node The import equals declaration node.
	         */
	        function shouldEmitImportEqualsDeclaration(node) {
	            // preserve old compiler's behavior: emit 'var' for import declaration (even if we do not consider them referenced) when
	            // - current file is not external module
	            // - import declaration is top level and target is value imported by entity name
	            return resolver.isReferencedAliasDeclaration(node)
	                || (!ts.isExternalModule(currentSourceFile)
	                    && resolver.isTopLevelValueImportEqualsWithEntityName(node));
	        }
	        /**
	         * Visits an import equals declaration.
	         *
	         * @param node The import equals declaration node.
	         */
	        function visitImportEqualsDeclaration(node) {
	            if (ts.isExternalModuleImportEqualsDeclaration(node)) {
	                // Elide external module `import=` if it is not referenced.
	                return resolver.isReferencedAliasDeclaration(node)
	                    ? ts.visitEachChild(node, visitor, context)
	                    : undefined;
	            }
	            if (!shouldEmitImportEqualsDeclaration(node)) {
	                return undefined;
	            }
	            var moduleReference = ts.createExpressionFromEntityName(node.moduleReference);
	            ts.setEmitFlags(moduleReference, 1536 /* NoComments */ | 2048 /* NoNestedComments */);
	            if (isNamedExternalModuleExport(node) || !isExportOfNamespace(node)) {
	                //  export var ${name} = ${moduleReference};
	                //  var ${name} = ${moduleReference};
	                return ts.setOriginalNode(ts.setTextRange(ts.createVariableStatement(ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.createVariableDeclarationList([
	                    ts.setOriginalNode(ts.createVariableDeclaration(node.name, 
	                    /*type*/ undefined, moduleReference), node)
	                ])), node), node);
	            }
	            else {
	                // exports.${name} = ${moduleReference};
	                return ts.setOriginalNode(createNamespaceExport(node.name, moduleReference, node), node);
	            }
	        }
	        /**
	         * Gets a value indicating whether the node is exported from a namespace.
	         *
	         * @param node The node to test.
	         */
	        function isExportOfNamespace(node) {
	            return currentNamespace !== undefined && ts.hasModifier(node, 1 /* Export */);
	        }
	        /**
	         * Gets a value indicating whether the node is exported from an external module.
	         *
	         * @param node The node to test.
	         */
	        function isExternalModuleExport(node) {
	            return currentNamespace === undefined && ts.hasModifier(node, 1 /* Export */);
	        }
	        /**
	         * Gets a value indicating whether the node is a named export from an external module.
	         *
	         * @param node The node to test.
	         */
	        function isNamedExternalModuleExport(node) {
	            return isExternalModuleExport(node)
	                && !ts.hasModifier(node, 512 /* Default */);
	        }
	        /**
	         * Gets a value indicating whether the node is the default export of an external module.
	         *
	         * @param node The node to test.
	         */
	        function isDefaultExternalModuleExport(node) {
	            return isExternalModuleExport(node)
	                && ts.hasModifier(node, 512 /* Default */);
	        }
	        /**
	         * Creates a statement for the provided expression. This is used in calls to `map`.
	         */
	        function expressionToStatement(expression) {
	            return ts.createStatement(expression);
	        }
	        function addExportMemberAssignment(statements, node) {
	            var expression = ts.createAssignment(ts.getExternalModuleOrNamespaceExportName(currentNamespaceContainerName, node, /*allowComments*/ false, /*allowSourceMaps*/ true), ts.getLocalName(node));
	            ts.setSourceMapRange(expression, ts.createRange(node.name ? node.name.pos : node.pos, node.end));
	            var statement = ts.createStatement(expression);
	            ts.setSourceMapRange(statement, ts.createRange(-1, node.end));
	            statements.push(statement);
	        }
	        function createNamespaceExport(exportName, exportValue, location) {
	            return ts.setTextRange(ts.createStatement(ts.createAssignment(ts.getNamespaceMemberName(currentNamespaceContainerName, exportName, /*allowComments*/ false, /*allowSourceMaps*/ true), exportValue)), location);
	        }
	        function createNamespaceExportExpression(exportName, exportValue, location) {
	            return ts.setTextRange(ts.createAssignment(getNamespaceMemberNameWithSourceMapsAndWithoutComments(exportName), exportValue), location);
	        }
	        function getNamespaceMemberNameWithSourceMapsAndWithoutComments(name) {
	            return ts.getNamespaceMemberName(currentNamespaceContainerName, name, /*allowComments*/ false, /*allowSourceMaps*/ true);
	        }
	        /**
	         * Gets the declaration name used inside of a namespace or enum.
	         */
	        function getNamespaceParameterName(node) {
	            var name = ts.getGeneratedNameForNode(node);
	            ts.setSourceMapRange(name, node.name);
	            return name;
	        }
	        /**
	         * Gets the expression used to refer to a namespace or enum within the body
	         * of its declaration.
	         */
	        function getNamespaceContainerName(node) {
	            return ts.getGeneratedNameForNode(node);
	        }
	        /**
	         * Gets a local alias for a class declaration if it is a decorated class with an internal
	         * reference to the static side of the class. This is necessary to avoid issues with
	         * double-binding semantics for the class name.
	         */
	        function getClassAliasIfNeeded(node) {
	            if (resolver.getNodeCheckFlags(node) & 8388608 /* ClassWithConstructorReference */) {
	                enableSubstitutionForClassAliases();
	                var classAlias = ts.createUniqueName(node.name && !ts.isGeneratedIdentifier(node.name) ? ts.idText(node.name) : "default");
	                classAliases[ts.getOriginalNodeId(node)] = classAlias;
	                hoistVariableDeclaration(classAlias);
	                return classAlias;
	            }
	        }
	        function getClassPrototype(node) {
	            return ts.createPropertyAccess(ts.getDeclarationName(node), "prototype");
	        }
	        function getClassMemberPrefix(node, member) {
	            return ts.hasModifier(member, 32 /* Static */)
	                ? ts.getDeclarationName(node)
	                : getClassPrototype(node);
	        }
	        function enableSubstitutionForNonQualifiedEnumMembers() {
	            if ((enabledSubstitutions & 8 /* NonQualifiedEnumMembers */) === 0) {
	                enabledSubstitutions |= 8 /* NonQualifiedEnumMembers */;
	                context.enableSubstitution(71 /* Identifier */);
	            }
	        }
	        function enableSubstitutionForClassAliases() {
	            if ((enabledSubstitutions & 1 /* ClassAliases */) === 0) {
	                enabledSubstitutions |= 1 /* ClassAliases */;
	                // We need to enable substitutions for identifiers. This allows us to
	                // substitute class names inside of a class declaration.
	                context.enableSubstitution(71 /* Identifier */);
	                // Keep track of class aliases.
	                classAliases = [];
	            }
	        }
	        function enableSubstitutionForNamespaceExports() {
	            if ((enabledSubstitutions & 2 /* NamespaceExports */) === 0) {
	                enabledSubstitutions |= 2 /* NamespaceExports */;
	                // We need to enable substitutions for identifiers and shorthand property assignments. This allows us to
	                // substitute the names of exported members of a namespace.
	                context.enableSubstitution(71 /* Identifier */);
	                context.enableSubstitution(270 /* ShorthandPropertyAssignment */);
	                // We need to be notified when entering and exiting namespaces.
	                context.enableEmitNotification(238 /* ModuleDeclaration */);
	            }
	        }
	        function isTransformedModuleDeclaration(node) {
	            return ts.getOriginalNode(node).kind === 238 /* ModuleDeclaration */;
	        }
	        function isTransformedEnumDeclaration(node) {
	            return ts.getOriginalNode(node).kind === 237 /* EnumDeclaration */;
	        }
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            var savedApplicableSubstitutions = applicableSubstitutions;
	            var savedCurrentSourceFile = currentSourceFile;
	            if (ts.isSourceFile(node)) {
	                currentSourceFile = node;
	            }
	            if (enabledSubstitutions & 2 /* NamespaceExports */ && isTransformedModuleDeclaration(node)) {
	                applicableSubstitutions |= 2 /* NamespaceExports */;
	            }
	            if (enabledSubstitutions & 8 /* NonQualifiedEnumMembers */ && isTransformedEnumDeclaration(node)) {
	                applicableSubstitutions |= 8 /* NonQualifiedEnumMembers */;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	            applicableSubstitutions = savedApplicableSubstitutions;
	            currentSourceFile = savedCurrentSourceFile;
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        function substituteShorthandPropertyAssignment(node) {
	            if (enabledSubstitutions & 2 /* NamespaceExports */) {
	                var name = node.name;
	                var exportedName = trySubstituteNamespaceExportedName(name);
	                if (exportedName) {
	                    // A shorthand property with an assignment initializer is probably part of a
	                    // destructuring assignment
	                    if (node.objectAssignmentInitializer) {
	                        var initializer = ts.createAssignment(exportedName, node.objectAssignmentInitializer);
	                        return ts.setTextRange(ts.createPropertyAssignment(name, initializer), node);
	                    }
	                    return ts.setTextRange(ts.createPropertyAssignment(name, exportedName), node);
	                }
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 184 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 185 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            return trySubstituteClassAlias(node)
	                || trySubstituteNamespaceExportedName(node)
	                || node;
	        }
	        function trySubstituteClassAlias(node) {
	            if (enabledSubstitutions & 1 /* ClassAliases */) {
	                if (resolver.getNodeCheckFlags(node) & 16777216 /* ConstructorReferenceInClass */) {
	                    // Due to the emit for class decorators, any reference to the class from inside of the class body
	                    // must instead be rewritten to point to a temporary variable to avoid issues with the double-bind
	                    // behavior of class names in ES6.
	                    // Also, when emitting statics for class expressions, we must substitute a class alias for
	                    // constructor references in static property initializers.
	                    var declaration = resolver.getReferencedValueDeclaration(node);
	                    if (declaration) {
	                        var classAlias = classAliases[declaration.id];
	                        if (classAlias) {
	                            var clone_1 = ts.getSynthesizedClone(classAlias);
	                            ts.setSourceMapRange(clone_1, node);
	                            ts.setCommentRange(clone_1, node);
	                            return clone_1;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function trySubstituteNamespaceExportedName(node) {
	            // If this is explicitly a local name, do not substitute.
	            if (enabledSubstitutions & applicableSubstitutions && !ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                // If we are nested within a namespace declaration, we may need to qualifiy
	                // an identifier that is exported from a merged namespace.
	                var container = resolver.getReferencedExportContainer(node, /*prefixLocals*/ false);
	                if (container && container.kind !== 273 /* SourceFile */) {
	                    var substitute = (applicableSubstitutions & 2 /* NamespaceExports */ && container.kind === 238 /* ModuleDeclaration */) ||
	                        (applicableSubstitutions & 8 /* NonQualifiedEnumMembers */ && container.kind === 237 /* EnumDeclaration */);
	                    if (substitute) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(container), node), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return undefined;
	        }
	        function substitutePropertyAccessExpression(node) {
	            return substituteConstantValue(node);
	        }
	        function substituteElementAccessExpression(node) {
	            return substituteConstantValue(node);
	        }
	        function substituteConstantValue(node) {
	            var constantValue = tryGetConstEnumValue(node);
	            if (constantValue !== undefined) {
	                // track the constant value on the node for the printer in needsDotDotForPropertyAccess
	                ts.setConstantValue(node, constantValue);
	                var substitute = ts.createLiteral(constantValue);
	                if (!compilerOptions.removeComments) {
	                    var propertyName = ts.isPropertyAccessExpression(node)
	                        ? ts.declarationNameToString(node.name)
	                        : ts.getTextOfNode(node.argumentExpression);
	                    ts.addSyntheticTrailingComment(substitute, 3 /* MultiLineCommentTrivia */, " " + propertyName + " ");
	                }
	                return substitute;
	            }
	            return node;
	        }
	        function tryGetConstEnumValue(node) {
	            if (compilerOptions.isolatedModules) {
	                return undefined;
	            }
	            return ts.isPropertyAccessExpression(node) || ts.isElementAccessExpression(node) ? resolver.getConstantValue(node) : undefined;
	        }
	    }
	    ts.transformTypeScript = transformTypeScript;
	    function createDecorateHelper(context, decoratorExpressions, target, memberName, descriptor, location) {
	        var argumentsArray = [];
	        argumentsArray.push(ts.createArrayLiteral(decoratorExpressions, /*multiLine*/ true));
	        argumentsArray.push(target);
	        if (memberName) {
	            argumentsArray.push(memberName);
	            if (descriptor) {
	                argumentsArray.push(descriptor);
	            }
	        }
	        context.requestEmitHelper(decorateHelper);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__decorate"), 
	        /*typeArguments*/ undefined, argumentsArray), location);
	    }
	    var decorateHelper = {
	        name: "typescript:decorate",
	        scoped: false,
	        priority: 2,
	        text: "\n            var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {\n                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;\n                if (typeof Reflect === \"object\" && typeof Reflect.decorate === \"function\") r = Reflect.decorate(decorators, target, key, desc);\n                else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;\n                return c > 3 && r && Object.defineProperty(target, key, r), r;\n            };"
	    };
	    function createMetadataHelper(context, metadataKey, metadataValue) {
	        context.requestEmitHelper(metadataHelper);
	        return ts.createCall(ts.getHelperName("__metadata"), 
	        /*typeArguments*/ undefined, [
	            ts.createLiteral(metadataKey),
	            metadataValue
	        ]);
	    }
	    var metadataHelper = {
	        name: "typescript:metadata",
	        scoped: false,
	        priority: 3,
	        text: "\n            var __metadata = (this && this.__metadata) || function (k, v) {\n                if (typeof Reflect === \"object\" && typeof Reflect.metadata === \"function\") return Reflect.metadata(k, v);\n            };"
	    };
	    function createParamHelper(context, expression, parameterOffset, location) {
	        context.requestEmitHelper(paramHelper);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__param"), 
	        /*typeArguments*/ undefined, [
	            ts.createLiteral(parameterOffset),
	            expression
	        ]), location);
	    }
	    var paramHelper = {
	        name: "typescript:param",
	        scoped: false,
	        priority: 4,
	        text: "\n            var __param = (this && this.__param) || function (paramIndex, decorator) {\n                return function (target, key) { decorator(target, key, paramIndex); }\n            };"
	    };
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    var ES2017SubstitutionFlags;
	    (function (ES2017SubstitutionFlags) {
	        /** Enables substitutions for async methods with `super` calls. */
	        ES2017SubstitutionFlags[ES2017SubstitutionFlags["AsyncMethodsWithSuper"] = 1] = "AsyncMethodsWithSuper";
	    })(ES2017SubstitutionFlags || (ES2017SubstitutionFlags = {}));
	    function transformES2017(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        /**
	         * Keeps track of whether expression substitution has been enabled for specific edge cases.
	         * They are persisted between each SourceFile transformation and should not be reset.
	         */
	        var enabledSubstitutions;
	        /**
	         * This keeps track of containers where `super` is valid, for use with
	         * just-in-time substitution for `super` expressions inside of async methods.
	         */
	        var enclosingSuperContainerFlags = 0;
	        var enclosingFunctionParameterNames;
	        // Save the previous transformation hooks.
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        // Set new transformation hooks.
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            if ((node.transformFlags & 16 /* ContainsES2017 */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 120 /* AsyncKeyword */:
	                    // ES2017 async modifier should be elided for targets < ES2017
	                    return undefined;
	                case 196 /* AwaitExpression */:
	                    return visitAwaitExpression(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 191 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 192 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function asyncBodyVisitor(node) {
	            if (ts.isNodeWithPossibleHoistedDeclaration(node)) {
	                switch (node.kind) {
	                    case 213 /* VariableStatement */:
	                        return visitVariableStatementInAsyncBody(node);
	                    case 219 /* ForStatement */:
	                        return visitForStatementInAsyncBody(node);
	                    case 220 /* ForInStatement */:
	                        return visitForInStatementInAsyncBody(node);
	                    case 221 /* ForOfStatement */:
	                        return visitForOfStatementInAsyncBody(node);
	                    case 268 /* CatchClause */:
	                        return visitCatchClauseInAsyncBody(node);
	                    case 212 /* Block */:
	                    case 226 /* SwitchStatement */:
	                    case 240 /* CaseBlock */:
	                    case 265 /* CaseClause */:
	                    case 266 /* DefaultClause */:
	                    case 229 /* TryStatement */:
	                    case 217 /* DoStatement */:
	                    case 218 /* WhileStatement */:
	                    case 216 /* IfStatement */:
	                    case 225 /* WithStatement */:
	                    case 227 /* LabeledStatement */:
	                        return ts.visitEachChild(node, asyncBodyVisitor, context);
	                    default:
	                        return ts.Debug.assertNever(node, "Unhandled node.");
	                }
	            }
	            return visitor(node);
	        }
	        function visitCatchClauseInAsyncBody(node) {
	            var catchClauseNames = ts.createUnderscoreEscapedMap();
	            recordDeclarationName(node.variableDeclaration, catchClauseNames);
	            // names declared in a catch variable are block scoped
	            var catchClauseUnshadowedNames;
	            catchClauseNames.forEach(function (_, escapedName) {
	                if (enclosingFunctionParameterNames.has(escapedName)) {
	                    if (!catchClauseUnshadowedNames) {
	                        catchClauseUnshadowedNames = ts.cloneMap(enclosingFunctionParameterNames);
	                    }
	                    catchClauseUnshadowedNames.delete(escapedName);
	                }
	            });
	            if (catchClauseUnshadowedNames) {
	                var savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
	                enclosingFunctionParameterNames = catchClauseUnshadowedNames;
	                var result = ts.visitEachChild(node, asyncBodyVisitor, context);
	                enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
	                return result;
	            }
	            else {
	                return ts.visitEachChild(node, asyncBodyVisitor, context);
	            }
	        }
	        function visitVariableStatementInAsyncBody(node) {
	            if (isVariableDeclarationListWithCollidingName(node.declarationList)) {
	                var expression = visitVariableDeclarationListWithCollidingNames(node.declarationList, /*hasReceiver*/ false);
	                return expression ? ts.createStatement(expression) : undefined;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitForInStatementInAsyncBody(node) {
	            return ts.updateForIn(node, isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        function visitForOfStatementInAsyncBody(node) {
	            return ts.updateForOf(node, ts.visitNode(node.awaitModifier, visitor, ts.isToken), isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ true)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        function visitForStatementInAsyncBody(node) {
	            return ts.updateFor(node, isVariableDeclarationListWithCollidingName(node.initializer)
	                ? visitVariableDeclarationListWithCollidingNames(node.initializer, /*hasReceiver*/ false)
	                : ts.visitNode(node.initializer, visitor, ts.isForInitializer), ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, asyncBodyVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits an AwaitExpression node.
	         *
	         * This function will be called any time a ES2017 await expression is encountered.
	         *
	         * @param node The node to visit.
	         */
	        function visitAwaitExpression(node) {
	            return ts.setOriginalNode(ts.setTextRange(ts.createYield(
	            /*asteriskToken*/ undefined, ts.visitNode(node.expression, visitor, ts.isExpression)), node), node);
	        }
	        /**
	         * Visits a MethodDeclaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked as async
	         *
	         * @param node The node to visit.
	         */
	        function visitMethodDeclaration(node) {
	            return ts.updateMethod(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            return ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits a FunctionExpression node.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionExpression(node) {
	            return ts.updateFunctionExpression(node, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        /**
	         * Visits an ArrowFunction.
	         *
	         * This function will be called when one of the following conditions are met:
	         * - The node is marked async
	         *
	         * @param node The node to visit.
	         */
	        function visitArrowFunction(node) {
	            return ts.updateArrowFunction(node, ts.visitNodes(node.modifiers, visitor, ts.isModifier), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, ts.getFunctionFlags(node) & 2 /* Async */
	                ? transformAsyncFunctionBody(node)
	                : ts.visitFunctionBody(node.body, visitor, context));
	        }
	        function recordDeclarationName(_a, names) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                names.set(name.escapedText, true);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        recordDeclarationName(element, names);
	                    }
	                }
	            }
	        }
	        function isVariableDeclarationListWithCollidingName(node) {
	            return node
	                && ts.isVariableDeclarationList(node)
	                && !(node.flags & 3 /* BlockScoped */)
	                && ts.forEach(node.declarations, collidesWithParameterName);
	        }
	        function visitVariableDeclarationListWithCollidingNames(node, hasReceiver) {
	            hoistVariableDeclarationList(node);
	            var variables = ts.getInitializedVariables(node);
	            if (variables.length === 0) {
	                if (hasReceiver) {
	                    return ts.visitNode(ts.convertToAssignmentElementTarget(node.declarations[0].name), visitor, ts.isExpression);
	                }
	                return undefined;
	            }
	            return ts.inlineExpressions(ts.map(variables, transformInitializedVariable));
	        }
	        function hoistVariableDeclarationList(node) {
	            ts.forEach(node.declarations, hoistVariable);
	        }
	        function hoistVariable(_a) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                hoistVariableDeclaration(name);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        hoistVariable(element);
	                    }
	                }
	            }
	        }
	        function transformInitializedVariable(node) {
	            var converted = ts.setSourceMapRange(ts.createAssignment(ts.convertToAssignmentElementTarget(node.name), node.initializer), node);
	            return ts.visitNode(converted, visitor, ts.isExpression);
	        }
	        function collidesWithParameterName(_a) {
	            var name = _a.name;
	            if (ts.isIdentifier(name)) {
	                return enclosingFunctionParameterNames.has(name.escapedText);
	            }
	            else {
	                for (var _i = 0, _b = name.elements; _i < _b.length; _i++) {
	                    var element = _b[_i];
	                    if (!ts.isOmittedExpression(element) && collidesWithParameterName(element)) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function transformAsyncFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var original = ts.getOriginalNode(node, ts.isFunctionLike);
	            var nodeType = original.type;
	            var promiseConstructor = languageVersion < 2 /* ES2015 */ ? getPromiseConstructor(nodeType) : undefined;
	            var isArrowFunction = node.kind === 192 /* ArrowFunction */;
	            var hasLexicalArguments = (resolver.getNodeCheckFlags(node) & 8192 /* CaptureArguments */) !== 0;
	            // An async function is emit as an outer function that calls an inner
	            // generator function. To preserve lexical bindings, we pass the current
	            // `this` and `arguments` objects to `__awaiter`. The generator function
	            // passed to `__awaiter` is executed inside of the callback to the
	            // promise constructor.
	            var savedEnclosingFunctionParameterNames = enclosingFunctionParameterNames;
	            enclosingFunctionParameterNames = ts.createUnderscoreEscapedMap();
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                recordDeclarationName(parameter, enclosingFunctionParameterNames);
	            }
	            var result;
	            if (!isArrowFunction) {
	                var statements = [];
	                var statementOffset = ts.addPrologue(statements, node.body.statements, /*ensureUseStrict*/ false, visitor);
	                statements.push(ts.createReturn(createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body, statementOffset))));
	                ts.prependStatements(statements, endLexicalEnvironment());
	                var block = ts.createBlock(statements, /*multiLine*/ true);
	                ts.setTextRange(block, node.body);
	                // Minor optimization, emit `_super` helper to capture `super` access in an arrow.
	                // This step isn't needed if we eventually transform this to ES5.
	                if (languageVersion >= 2 /* ES2015 */) {
	                    if (resolver.getNodeCheckFlags(node) & 4096 /* AsyncMethodWithSuperBinding */) {
	                        enableSubstitutionForAsyncMethodsWithSuper();
	                        ts.addEmitHelper(block, ts.advancedAsyncSuperHelper);
	                    }
	                    else if (resolver.getNodeCheckFlags(node) & 2048 /* AsyncMethodWithSuper */) {
	                        enableSubstitutionForAsyncMethodsWithSuper();
	                        ts.addEmitHelper(block, ts.asyncSuperHelper);
	                    }
	                }
	                result = block;
	            }
	            else {
	                var expression = createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, transformAsyncFunctionBodyWorker(node.body));
	                var declarations = endLexicalEnvironment();
	                if (ts.some(declarations)) {
	                    var block = ts.convertToFunctionBody(expression);
	                    result = ts.updateBlock(block, ts.setTextRange(ts.createNodeArray(ts.concatenate(declarations, block.statements)), block.statements));
	                }
	                else {
	                    result = expression;
	                }
	            }
	            enclosingFunctionParameterNames = savedEnclosingFunctionParameterNames;
	            return result;
	        }
	        function transformAsyncFunctionBodyWorker(body, start) {
	            if (ts.isBlock(body)) {
	                return ts.updateBlock(body, ts.visitNodes(body.statements, asyncBodyVisitor, ts.isStatement, start));
	            }
	            else {
	                return ts.convertToFunctionBody(ts.visitNode(body, asyncBodyVisitor, ts.isConciseBody));
	            }
	        }
	        function getPromiseConstructor(type) {
	            var typeName = type && ts.getEntityNameFromTypeNode(type);
	            if (typeName && ts.isEntityName(typeName)) {
	                var serializationKind = resolver.getTypeReferenceSerializationKind(typeName);
	                if (serializationKind === ts.TypeReferenceSerializationKind.TypeWithConstructSignatureAndValue
	                    || serializationKind === ts.TypeReferenceSerializationKind.Unknown) {
	                    return typeName;
	                }
	            }
	            return undefined;
	        }
	        function enableSubstitutionForAsyncMethodsWithSuper() {
	            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */) === 0) {
	                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */;
	                // We need to enable substitutions for call, property access, and element access
	                // if we need to rewrite super calls.
	                context.enableSubstitution(186 /* CallExpression */);
	                context.enableSubstitution(184 /* PropertyAccessExpression */);
	                context.enableSubstitution(185 /* ElementAccessExpression */);
	                // We need to be notified when entering and exiting declarations that bind super.
	                context.enableEmitNotification(234 /* ClassDeclaration */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(154 /* Constructor */);
	            }
	        }
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            // If we need to support substitutions for `super` in an async method,
	            // we should track it here.
	            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ && isSuperContainer(node)) {
	                var superContainerFlags = resolver.getNodeCheckFlags(node) & (2048 /* AsyncMethodWithSuper */ | 4096 /* AsyncMethodWithSuperBinding */);
	                if (superContainerFlags !== enclosingSuperContainerFlags) {
	                    var savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
	                    enclosingSuperContainerFlags = superContainerFlags;
	                    previousOnEmitNode(hint, node, emitCallback);
	                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
	                    return;
	                }
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */ && enclosingSuperContainerFlags) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 184 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 185 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	                case 186 /* CallExpression */:
	                    return substituteCallExpression(node);
	            }
	            return node;
	        }
	        function substitutePropertyAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(ts.createLiteral(ts.idText(node.name)), node);
	            }
	            return node;
	        }
	        function substituteElementAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(node.argumentExpression, node);
	            }
	            return node;
	        }
	        function substituteCallExpression(node) {
	            var expression = node.expression;
	            if (ts.isSuperProperty(expression)) {
	                var argumentExpression = ts.isPropertyAccessExpression(expression)
	                    ? substitutePropertyAccessExpression(expression)
	                    : substituteElementAccessExpression(expression);
	                return ts.createCall(ts.createPropertyAccess(argumentExpression, "call"), 
	                /*typeArguments*/ undefined, [
	                    ts.createThis()
	                ].concat(node.arguments));
	            }
	            return node;
	        }
	        function isSuperContainer(node) {
	            var kind = node.kind;
	            return kind === 234 /* ClassDeclaration */
	                || kind === 154 /* Constructor */
	                || kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */;
	        }
	        function createSuperAccessInAsyncMethod(argumentExpression, location) {
	            if (enclosingSuperContainerFlags & 4096 /* AsyncMethodWithSuperBinding */) {
	                return ts.setTextRange(ts.createPropertyAccess(ts.createCall(ts.createFileLevelUniqueName("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), "value"), location);
	            }
	            else {
	                return ts.setTextRange(ts.createCall(ts.createFileLevelUniqueName("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), location);
	            }
	        }
	    }
	    ts.transformES2017 = transformES2017;
	    var awaiterHelper = {
	        name: "typescript:awaiter",
	        scoped: false,
	        priority: 5,
	        text: "\n            var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {\n                return new (P || (P = Promise))(function (resolve, reject) {\n                    function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }\n                    function rejected(value) { try { step(generator[\"throw\"](value)); } catch (e) { reject(e); } }\n                    function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }\n                    step((generator = generator.apply(thisArg, _arguments || [])).next());\n                });\n            };"
	    };
	    function createAwaiterHelper(context, hasLexicalArguments, promiseConstructor, body) {
	        context.requestEmitHelper(awaiterHelper);
	        var generatorFunc = ts.createFunctionExpression(
	        /*modifiers*/ undefined, ts.createToken(39 /* AsteriskToken */), 
	        /*name*/ undefined, 
	        /*typeParameters*/ undefined, 
	        /*parameters*/ [], 
	        /*type*/ undefined, body);
	        // Mark this node as originally an async function
	        (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 262144 /* AsyncFunctionBody */ | 524288 /* ReuseTempVariableScope */;
	        return ts.createCall(ts.getHelperName("__awaiter"), 
	        /*typeArguments*/ undefined, [
	            ts.createThis(),
	            hasLexicalArguments ? ts.createIdentifier("arguments") : ts.createVoidZero(),
	            promiseConstructor ? ts.createExpressionFromEntityName(promiseConstructor) : ts.createVoidZero(),
	            generatorFunc
	        ]);
	    }
	    ts.asyncSuperHelper = {
	        name: "typescript:async-super",
	        scoped: true,
	        text: ts.helperString(__makeTemplateObject(["\n            const ", " = name => super[name];"], ["\n            const ", " = name => super[name];"]), "_super")
	    };
	    ts.advancedAsyncSuperHelper = {
	        name: "typescript:advanced-async-super",
	        scoped: true,
	        text: ts.helperString(__makeTemplateObject(["\n            const ", " = (function (geti, seti) {\n                const cache = Object.create(null);\n                return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });\n            })(name => super[name], (name, value) => super[name] = value);"], ["\n            const ", " = (function (geti, seti) {\n                const cache = Object.create(null);\n                return name => cache[name] || (cache[name] = { get value() { return geti(name); }, set value(v) { seti(name, v); } });\n            })(name => super[name], (name, value) => super[name] = value);"]), "_super")
	    };
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    var ESNextSubstitutionFlags;
	    (function (ESNextSubstitutionFlags) {
	        /** Enables substitutions for async methods with `super` calls. */
	        ESNextSubstitutionFlags[ESNextSubstitutionFlags["AsyncMethodsWithSuper"] = 1] = "AsyncMethodsWithSuper";
	    })(ESNextSubstitutionFlags || (ESNextSubstitutionFlags = {}));
	    function transformESNext(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var resolver = context.getEmitResolver();
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var previousOnEmitNode = context.onEmitNode;
	        context.onEmitNode = onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var enabledSubstitutions;
	        var enclosingFunctionFlags;
	        var enclosingSuperContainerFlags = 0;
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            return visitorWorker(node, /*noDestructuringValue*/ false);
	        }
	        function visitorNoDestructuringValue(node) {
	            return visitorWorker(node, /*noDestructuringValue*/ true);
	        }
	        function visitorNoAsyncModifier(node) {
	            if (node.kind === 120 /* AsyncKeyword */) {
	                return undefined;
	            }
	            return node;
	        }
	        function visitorWorker(node, noDestructuringValue) {
	            if ((node.transformFlags & 8 /* ContainsESNext */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 196 /* AwaitExpression */:
	                    return visitAwaitExpression(node);
	                case 202 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 224 /* ReturnStatement */:
	                    return visitReturnStatement(node);
	                case 227 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 183 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 199 /* BinaryExpression */:
	                    return visitBinaryExpression(node, noDestructuringValue);
	                case 231 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 221 /* ForOfStatement */:
	                    return visitForOfStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 219 /* ForStatement */:
	                    return visitForStatement(node);
	                case 195 /* VoidExpression */:
	                    return visitVoidExpression(node);
	                case 154 /* Constructor */:
	                    return visitConstructorDeclaration(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                    return visitGetAccessorDeclaration(node);
	                case 156 /* SetAccessor */:
	                    return visitSetAccessorDeclaration(node);
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 191 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 192 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                case 148 /* Parameter */:
	                    return visitParameter(node);
	                case 215 /* ExpressionStatement */:
	                    return visitExpressionStatement(node);
	                case 190 /* ParenthesizedExpression */:
	                    return visitParenthesizedExpression(node, noDestructuringValue);
	                case 268 /* CatchClause */:
	                    return visitCatchClause(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitAwaitExpression(node) {
	            if (enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */) {
	                return ts.setOriginalNode(ts.setTextRange(ts.createYield(createAwaitHelper(context, ts.visitNode(node.expression, visitor, ts.isExpression))), 
	                /*location*/ node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitYieldExpression(node) {
	            if (enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */) {
	                if (node.asteriskToken) {
	                    var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	                    return ts.setOriginalNode(ts.setTextRange(ts.createYield(createAwaitHelper(context, ts.updateYield(node, node.asteriskToken, createAsyncDelegatorHelper(context, createAsyncValuesHelper(context, expression, expression), expression)))), node), node);
	                }
	                return ts.setOriginalNode(ts.setTextRange(ts.createYield(createDownlevelAwait(node.expression
	                    ? ts.visitNode(node.expression, visitor, ts.isExpression)
	                    : ts.createVoidZero())), node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitReturnStatement(node) {
	            if (enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */) {
	                return ts.updateReturn(node, createDownlevelAwait(node.expression ? ts.visitNode(node.expression, visitor, ts.isExpression) : ts.createVoidZero()));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitLabeledStatement(node) {
	            if (enclosingFunctionFlags & 2 /* Async */) {
	                var statement = ts.unwrapInnermostStatementOfLabel(node);
	                if (statement.kind === 221 /* ForOfStatement */ && statement.awaitModifier) {
	                    return visitForOfStatement(statement, node);
	                }
	                return ts.restoreEnclosingLabel(ts.visitEachChild(statement, visitor, context), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function chunkObjectLiteralElements(elements) {
	            var chunkObject;
	            var objects = [];
	            for (var _i = 0, elements_4 = elements; _i < elements_4.length; _i++) {
	                var e = elements_4[_i];
	                if (e.kind === 271 /* SpreadAssignment */) {
	                    if (chunkObject) {
	                        objects.push(ts.createObjectLiteral(chunkObject));
	                        chunkObject = undefined;
	                    }
	                    var target = e.expression;
	                    objects.push(ts.visitNode(target, visitor, ts.isExpression));
	                }
	                else {
	                    chunkObject = ts.append(chunkObject, e.kind === 269 /* PropertyAssignment */
	                        ? ts.createPropertyAssignment(e.name, ts.visitNode(e.initializer, visitor, ts.isExpression))
	                        : ts.visitNode(e, visitor, ts.isObjectLiteralElementLike));
	                }
	            }
	            if (chunkObject) {
	                objects.push(ts.createObjectLiteral(chunkObject));
	            }
	            return objects;
	        }
	        function visitObjectLiteralExpression(node) {
	            if (node.transformFlags & 1048576 /* ContainsObjectSpread */) {
	                // spread elements emit like so:
	                // non-spread elements are chunked together into object literals, and then all are passed to __assign:
	                //     { a, ...o, b } => __assign({a}, o, {b});
	                // If the first element is a spread element, then the first argument to __assign is {}:
	                //     { ...o, a, b, ...o2 } => __assign({}, o, {a, b}, o2)
	                var objects = chunkObjectLiteralElements(node.properties);
	                if (objects.length && objects[0].kind !== 183 /* ObjectLiteralExpression */) {
	                    objects.unshift(ts.createObjectLiteral());
	                }
	                return createAssignHelper(context, objects);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitExpressionStatement(node) {
	            return ts.visitEachChild(node, visitorNoDestructuringValue, context);
	        }
	        function visitParenthesizedExpression(node, noDestructuringValue) {
	            return ts.visitEachChild(node, noDestructuringValue ? visitorNoDestructuringValue : visitor, context);
	        }
	        function visitCatchClause(node) {
	            if (!node.variableDeclaration) {
	                return ts.updateCatchClause(node, ts.createVariableDeclaration(ts.createTempVariable(/*recordTempVariable*/ undefined)), ts.visitNode(node.block, visitor, ts.isBlock));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a BinaryExpression that contains a destructuring assignment.
	         *
	         * @param node A BinaryExpression node.
	         */
	        function visitBinaryExpression(node, noDestructuringValue) {
	            if (ts.isDestructuringAssignment(node) && node.left.transformFlags & 1048576 /* ContainsObjectRest */) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 1 /* ObjectRest */, !noDestructuringValue);
	            }
	            else if (node.operatorToken.kind === 26 /* CommaToken */) {
	                return ts.updateBinary(node, ts.visitNode(node.left, visitorNoDestructuringValue, ts.isExpression), ts.visitNode(node.right, noDestructuringValue ? visitorNoDestructuringValue : visitor, ts.isExpression));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a VariableDeclaration node with a binding pattern.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclaration(node) {
	            // If we are here it is because the name contains a binding pattern with a rest somewhere in it.
	            if (ts.isBindingPattern(node.name) && node.name.transformFlags & 1048576 /* ContainsObjectRest */) {
	                return ts.flattenDestructuringBinding(node, visitor, context, 1 /* ObjectRest */);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitForStatement(node) {
	            return ts.updateFor(node, ts.visitNode(node.initializer, visitorNoDestructuringValue, ts.isForInitializer), ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement));
	        }
	        function visitVoidExpression(node) {
	            return ts.visitEachChild(node, visitorNoDestructuringValue, context);
	        }
	        /**
	         * Visits a ForOfStatement and converts it into a ES2015-compatible ForOfStatement.
	         *
	         * @param node A ForOfStatement.
	         */
	        function visitForOfStatement(node, outermostLabeledStatement) {
	            if (node.initializer.transformFlags & 1048576 /* ContainsObjectRest */) {
	                node = transformForOfStatementWithObjectRest(node);
	            }
	            if (node.awaitModifier) {
	                return transformForAwaitOfStatement(node, outermostLabeledStatement);
	            }
	            else {
	                return ts.restoreEnclosingLabel(ts.visitEachChild(node, visitor, context), outermostLabeledStatement);
	            }
	        }
	        function transformForOfStatementWithObjectRest(node) {
	            var initializerWithoutParens = ts.skipParentheses(node.initializer);
	            if (ts.isVariableDeclarationList(initializerWithoutParens) || ts.isAssignmentPattern(initializerWithoutParens)) {
	                var bodyLocation = void 0;
	                var statementsLocation = void 0;
	                var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                var statements = [ts.createForOfBindingStatement(initializerWithoutParens, temp)];
	                if (ts.isBlock(node.statement)) {
	                    ts.addRange(statements, node.statement.statements);
	                    bodyLocation = node.statement;
	                    statementsLocation = node.statement.statements;
	                }
	                else if (node.statement) {
	                    ts.append(statements, node.statement);
	                    bodyLocation = node.statement;
	                    statementsLocation = node.statement;
	                }
	                return ts.updateForOf(node, node.awaitModifier, ts.setTextRange(ts.createVariableDeclarationList([
	                    ts.setTextRange(ts.createVariableDeclaration(temp), node.initializer)
	                ], 1 /* Let */), node.initializer), node.expression, ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), 
	                /*multiLine*/ true), bodyLocation));
	            }
	            return node;
	        }
	        function convertForOfStatementHead(node, boundValue) {
	            var binding = ts.createForOfBindingStatement(node.initializer, boundValue);
	            var bodyLocation;
	            var statementsLocation;
	            var statements = [ts.visitNode(binding, visitor, ts.isStatement)];
	            var statement = ts.visitNode(node.statement, visitor, ts.isStatement);
	            if (ts.isBlock(statement)) {
	                ts.addRange(statements, statement.statements);
	                bodyLocation = statement;
	                statementsLocation = statement.statements;
	            }
	            else {
	                statements.push(statement);
	            }
	            return ts.setEmitFlags(ts.setTextRange(ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), statementsLocation), 
	            /*multiLine*/ true), bodyLocation), 48 /* NoSourceMap */ | 384 /* NoTokenSourceMaps */);
	        }
	        function createDownlevelAwait(expression) {
	            return enclosingFunctionFlags & 1 /* Generator */
	                ? ts.createYield(/*asteriskToken*/ undefined, createAwaitHelper(context, expression))
	                : ts.createAwait(expression);
	        }
	        function transformForAwaitOfStatement(node, outermostLabeledStatement) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            var iterator = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var result = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(iterator) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var errorRecord = ts.createUniqueName("e");
	            var catchVariable = ts.getGeneratedNameForNode(errorRecord);
	            var returnMethod = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var callValues = createAsyncValuesHelper(context, expression, /*location*/ node.expression);
	            var callNext = ts.createCall(ts.createPropertyAccess(iterator, "next"), /*typeArguments*/ undefined, []);
	            var getDone = ts.createPropertyAccess(result, "done");
	            var getValue = ts.createPropertyAccess(result, "value");
	            var callReturn = ts.createFunctionCall(returnMethod, iterator, []);
	            hoistVariableDeclaration(errorRecord);
	            hoistVariableDeclaration(returnMethod);
	            var forStatement = ts.setEmitFlags(ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(iterator, /*type*/ undefined, callValues), node.expression),
	                ts.createVariableDeclaration(result)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.createComma(ts.createAssignment(result, createDownlevelAwait(callNext)), ts.createLogicalNot(getDone)), 
	            /*incrementor*/ undefined, 
	            /*statement*/ convertForOfStatementHead(node, getValue)), 
	            /*location*/ node), 256 /* NoTokenTrailingSourceMaps */);
	            return ts.createTry(ts.createBlock([
	                ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement)
	            ]), ts.createCatchClause(ts.createVariableDeclaration(catchVariable), ts.setEmitFlags(ts.createBlock([
	                ts.createStatement(ts.createAssignment(errorRecord, ts.createObjectLiteral([
	                    ts.createPropertyAssignment("error", catchVariable)
	                ])))
	            ]), 1 /* SingleLine */)), ts.createBlock([
	                ts.createTry(
	                /*tryBlock*/ ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(ts.createLogicalAnd(ts.createLogicalAnd(result, ts.createLogicalNot(getDone)), ts.createAssignment(returnMethod, ts.createPropertyAccess(iterator, "return"))), ts.createStatement(createDownlevelAwait(callReturn))), 1 /* SingleLine */)
	                ]), 
	                /*catchClause*/ undefined, 
	                /*finallyBlock*/ ts.setEmitFlags(ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(errorRecord, ts.createThrow(ts.createPropertyAccess(errorRecord, "error"))), 1 /* SingleLine */)
	                ]), 1 /* SingleLine */))
	            ]));
	        }
	        function visitParameter(node) {
	            if (node.transformFlags & 1048576 /* ContainsObjectRest */) {
	                // Binding patterns are converted into a generated name and are
	                // evaluated inside the function body.
	                return ts.updateParameter(node, 
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, node.dotDotDotToken, ts.getGeneratedNameForNode(node), 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, ts.visitNode(node.initializer, visitor, ts.isExpression));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitConstructorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateConstructor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitParameterList(node.parameters, visitor, context), transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitGetAccessorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateGetAccessor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitSetAccessorDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = 0 /* Normal */;
	            var updated = ts.updateSetAccessor(node, 
	            /*decorators*/ undefined, node.modifiers, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitParameterList(node.parameters, visitor, context), transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitMethodDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateMethod(node, 
	            /*decorators*/ undefined, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, ts.visitNode(node.name, visitor, ts.isPropertyName), ts.visitNode(/*questionToken*/ undefined, visitor, ts.isToken), 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitFunctionDeclaration(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitArrowFunction(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateArrowFunction(node, node.modifiers, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, node.equalsGreaterThanToken, transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function visitFunctionExpression(node) {
	            var savedEnclosingFunctionFlags = enclosingFunctionFlags;
	            enclosingFunctionFlags = ts.getFunctionFlags(node);
	            var updated = ts.updateFunctionExpression(node, enclosingFunctionFlags & 1 /* Generator */
	                ? ts.visitNodes(node.modifiers, visitorNoAsyncModifier, ts.isModifier)
	                : node.modifiers, enclosingFunctionFlags & 2 /* Async */
	                ? undefined
	                : node.asteriskToken, node.name, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, enclosingFunctionFlags & 2 /* Async */ && enclosingFunctionFlags & 1 /* Generator */
	                ? transformAsyncGeneratorFunctionBody(node)
	                : transformFunctionBody(node));
	            enclosingFunctionFlags = savedEnclosingFunctionFlags;
	            return updated;
	        }
	        function transformAsyncGeneratorFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var statements = [];
	            var statementOffset = ts.addPrologue(statements, node.body.statements, /*ensureUseStrict*/ false, visitor);
	            appendObjectRestAssignmentsIfNeeded(statements, node);
	            statements.push(ts.createReturn(createAsyncGeneratorHelper(context, ts.createFunctionExpression(
	            /*modifiers*/ undefined, ts.createToken(39 /* AsteriskToken */), node.name && ts.getGeneratedNameForNode(node.name), 
	            /*typeParameters*/ undefined, 
	            /*parameters*/ [], 
	            /*type*/ undefined, ts.updateBlock(node.body, ts.visitLexicalEnvironment(node.body.statements, visitor, context, statementOffset))))));
	            ts.prependStatements(statements, endLexicalEnvironment());
	            var block = ts.updateBlock(node.body, statements);
	            // Minor optimization, emit `_super` helper to capture `super` access in an arrow.
	            // This step isn't needed if we eventually transform this to ES5.
	            if (languageVersion >= 2 /* ES2015 */) {
	                if (resolver.getNodeCheckFlags(node) & 4096 /* AsyncMethodWithSuperBinding */) {
	                    enableSubstitutionForAsyncMethodsWithSuper();
	                    ts.addEmitHelper(block, ts.advancedAsyncSuperHelper);
	                }
	                else if (resolver.getNodeCheckFlags(node) & 2048 /* AsyncMethodWithSuper */) {
	                    enableSubstitutionForAsyncMethodsWithSuper();
	                    ts.addEmitHelper(block, ts.asyncSuperHelper);
	                }
	            }
	            return block;
	        }
	        function transformFunctionBody(node) {
	            resumeLexicalEnvironment();
	            var statementOffset = 0;
	            var statements = [];
	            var body = ts.visitNode(node.body, visitor, ts.isConciseBody);
	            if (ts.isBlock(body)) {
	                statementOffset = ts.addPrologue(statements, body.statements, /*ensureUseStrict*/ false, visitor);
	            }
	            ts.addRange(statements, appendObjectRestAssignmentsIfNeeded(/*statements*/ undefined, node));
	            var leadingStatements = endLexicalEnvironment();
	            if (statementOffset > 0 || ts.some(statements) || ts.some(leadingStatements)) {
	                var block = ts.convertToFunctionBody(body, /*multiLine*/ true);
	                ts.prependStatements(statements, leadingStatements);
	                ts.addRange(statements, block.statements.slice(statementOffset));
	                return ts.updateBlock(block, ts.setTextRange(ts.createNodeArray(statements), block.statements));
	            }
	            return body;
	        }
	        function appendObjectRestAssignmentsIfNeeded(statements, node) {
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                if (parameter.transformFlags & 1048576 /* ContainsObjectRest */) {
	                    var temp = ts.getGeneratedNameForNode(parameter);
	                    var declarations = ts.flattenDestructuringBinding(parameter, visitor, context, 1 /* ObjectRest */, temp, 
	                    /*doNotRecordTempVariablesInLine*/ false, 
	                    /*skipInitializer*/ true);
	                    if (ts.some(declarations)) {
	                        var statement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList(declarations));
	                        ts.setEmitFlags(statement, 1048576 /* CustomPrologue */);
	                        statements = ts.append(statements, statement);
	                    }
	                }
	            }
	            return statements;
	        }
	        function enableSubstitutionForAsyncMethodsWithSuper() {
	            if ((enabledSubstitutions & 1 /* AsyncMethodsWithSuper */) === 0) {
	                enabledSubstitutions |= 1 /* AsyncMethodsWithSuper */;
	                // We need to enable substitutions for call, property access, and element access
	                // if we need to rewrite super calls.
	                context.enableSubstitution(186 /* CallExpression */);
	                context.enableSubstitution(184 /* PropertyAccessExpression */);
	                context.enableSubstitution(185 /* ElementAccessExpression */);
	                // We need to be notified when entering and exiting declarations that bind super.
	                context.enableEmitNotification(234 /* ClassDeclaration */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(154 /* Constructor */);
	            }
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to be printed.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            // If we need to support substitutions for `super` in an async method,
	            // we should track it here.
	            if (enabledSubstitutions & 1 /* AsyncMethodsWithSuper */ && isSuperContainer(node)) {
	                var superContainerFlags = resolver.getNodeCheckFlags(node) & (2048 /* AsyncMethodWithSuper */ | 4096 /* AsyncMethodWithSuperBinding */);
	                if (superContainerFlags !== enclosingSuperContainerFlags) {
	                    var savedEnclosingSuperContainerFlags = enclosingSuperContainerFlags;
	                    enclosingSuperContainerFlags = superContainerFlags;
	                    previousOnEmitNode(hint, node, emitCallback);
	                    enclosingSuperContainerFlags = savedEnclosingSuperContainerFlags;
	                    return;
	                }
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint The context for the emitter.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */ && enclosingSuperContainerFlags) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 184 /* PropertyAccessExpression */:
	                    return substitutePropertyAccessExpression(node);
	                case 185 /* ElementAccessExpression */:
	                    return substituteElementAccessExpression(node);
	                case 186 /* CallExpression */:
	                    return substituteCallExpression(node);
	            }
	            return node;
	        }
	        function substitutePropertyAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(ts.createLiteral(ts.idText(node.name)), node);
	            }
	            return node;
	        }
	        function substituteElementAccessExpression(node) {
	            if (node.expression.kind === 97 /* SuperKeyword */) {
	                return createSuperAccessInAsyncMethod(node.argumentExpression, node);
	            }
	            return node;
	        }
	        function substituteCallExpression(node) {
	            var expression = node.expression;
	            if (ts.isSuperProperty(expression)) {
	                var argumentExpression = ts.isPropertyAccessExpression(expression)
	                    ? substitutePropertyAccessExpression(expression)
	                    : substituteElementAccessExpression(expression);
	                return ts.createCall(ts.createPropertyAccess(argumentExpression, "call"), 
	                /*typeArguments*/ undefined, [
	                    ts.createThis()
	                ].concat(node.arguments));
	            }
	            return node;
	        }
	        function isSuperContainer(node) {
	            var kind = node.kind;
	            return kind === 234 /* ClassDeclaration */
	                || kind === 154 /* Constructor */
	                || kind === 153 /* MethodDeclaration */
	                || kind === 155 /* GetAccessor */
	                || kind === 156 /* SetAccessor */;
	        }
	        function createSuperAccessInAsyncMethod(argumentExpression, location) {
	            if (enclosingSuperContainerFlags & 4096 /* AsyncMethodWithSuperBinding */) {
	                return ts.setTextRange(ts.createPropertyAccess(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), "value"), location);
	            }
	            else {
	                return ts.setTextRange(ts.createCall(ts.createIdentifier("_super"), 
	                /*typeArguments*/ undefined, [argumentExpression]), location);
	            }
	        }
	    }
	    ts.transformESNext = transformESNext;
	    var assignHelper = {
	        name: "typescript:assign",
	        scoped: false,
	        priority: 1,
	        text: "\n            var __assign = (this && this.__assign) || Object.assign || function(t) {\n                for (var s, i = 1, n = arguments.length; i < n; i++) {\n                    s = arguments[i];\n                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))\n                        t[p] = s[p];\n                }\n                return t;\n            };"
	    };
	    function createAssignHelper(context, attributesSegments) {
	        if (context.getCompilerOptions().target >= 2 /* ES2015 */) {
	            return ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "assign"), 
	            /*typeArguments*/ undefined, attributesSegments);
	        }
	        context.requestEmitHelper(assignHelper);
	        return ts.createCall(ts.getHelperName("__assign"), 
	        /*typeArguments*/ undefined, attributesSegments);
	    }
	    ts.createAssignHelper = createAssignHelper;
	    var awaitHelper = {
	        name: "typescript:await",
	        scoped: false,
	        text: "\n            var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }"
	    };
	    function createAwaitHelper(context, expression) {
	        context.requestEmitHelper(awaitHelper);
	        return ts.createCall(ts.getHelperName("__await"), /*typeArguments*/ undefined, [expression]);
	    }
	    var asyncGeneratorHelper = {
	        name: "typescript:asyncGenerator",
	        scoped: false,
	        text: "\n            var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {\n                if (!Symbol.asyncIterator) throw new TypeError(\"Symbol.asyncIterator is not defined.\");\n                var g = generator.apply(thisArg, _arguments || []), i, q = [];\n                return i = {}, verb(\"next\"), verb(\"throw\"), verb(\"return\"), i[Symbol.asyncIterator] = function () { return this; }, i;\n                function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }\n                function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }\n                function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }\n                function fulfill(value) { resume(\"next\", value); }\n                function reject(value) { resume(\"throw\", value); }\n                function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }\n            };"
	    };
	    function createAsyncGeneratorHelper(context, generatorFunc) {
	        context.requestEmitHelper(awaitHelper);
	        context.requestEmitHelper(asyncGeneratorHelper);
	        // Mark this node as originally an async function
	        (generatorFunc.emitNode || (generatorFunc.emitNode = {})).flags |= 262144 /* AsyncFunctionBody */;
	        return ts.createCall(ts.getHelperName("__asyncGenerator"), 
	        /*typeArguments*/ undefined, [
	            ts.createThis(),
	            ts.createIdentifier("arguments"),
	            generatorFunc
	        ]);
	    }
	    var asyncDelegator = {
	        name: "typescript:asyncDelegator",
	        scoped: false,
	        text: "\n            var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {\n                var i, p;\n                return i = {}, verb(\"next\"), verb(\"throw\", function (e) { throw e; }), verb(\"return\"), i[Symbol.iterator] = function () { return this; }, i;\n                function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === \"return\" } : f ? f(v) : v; } : f; }\n            };"
	    };
	    function createAsyncDelegatorHelper(context, expression, location) {
	        context.requestEmitHelper(awaitHelper);
	        context.requestEmitHelper(asyncDelegator);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__asyncDelegator"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	    var asyncValues = {
	        name: "typescript:asyncValues",
	        scoped: false,
	        text: "\n            var __asyncValues = (this && this.__asyncValues) || function (o) {\n                if (!Symbol.asyncIterator) throw new TypeError(\"Symbol.asyncIterator is not defined.\");\n                var m = o[Symbol.asyncIterator], i;\n                return m ? m.call(o) : (o = typeof __values === \"function\" ? __values(o) : o[Symbol.iterator](), i = {}, verb(\"next\"), verb(\"throw\"), verb(\"return\"), i[Symbol.asyncIterator] = function () { return this; }, i);\n                function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }\n                function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }\n            };"
	    };
	    function createAsyncValuesHelper(context, expression, location) {
	        context.requestEmitHelper(asyncValues);
	        return ts.setTextRange(ts.createCall(ts.getHelperName("__asyncValues"), 
	        /*typeArguments*/ undefined, [expression]), location);
	    }
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformJsx(context) {
	        var compilerOptions = context.getCompilerOptions();
	        var currentSourceFile;
	        return ts.chainBundle(transformSourceFile);
	        /**
	         * Transform JSX-specific syntax in a SourceFile.
	         *
	         * @param node A SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        function visitor(node) {
	            if (node.transformFlags & 4 /* ContainsJsx */) {
	                return visitorWorker(node);
	            }
	            else {
	                return node;
	            }
	        }
	        function visitorWorker(node) {
	            switch (node.kind) {
	                case 254 /* JsxElement */:
	                    return visitJsxElement(node, /*isChild*/ false);
	                case 255 /* JsxSelfClosingElement */:
	                    return visitJsxSelfClosingElement(node, /*isChild*/ false);
	                case 258 /* JsxFragment */:
	                    return visitJsxFragment(node, /*isChild*/ false);
	                case 264 /* JsxExpression */:
	                    return visitJsxExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformJsxChildToExpression(node) {
	            switch (node.kind) {
	                case 10 /* JsxText */:
	                    return visitJsxText(node);
	                case 264 /* JsxExpression */:
	                    return visitJsxExpression(node);
	                case 254 /* JsxElement */:
	                    return visitJsxElement(node, /*isChild*/ true);
	                case 255 /* JsxSelfClosingElement */:
	                    return visitJsxSelfClosingElement(node, /*isChild*/ true);
	                case 258 /* JsxFragment */:
	                    return visitJsxFragment(node, /*isChild*/ true);
	                default:
	                    return ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        function visitJsxElement(node, isChild) {
	            return visitJsxOpeningLikeElement(node.openingElement, node.children, isChild, /*location*/ node);
	        }
	        function visitJsxSelfClosingElement(node, isChild) {
	            return visitJsxOpeningLikeElement(node, /*children*/ undefined, isChild, /*location*/ node);
	        }
	        function visitJsxFragment(node, isChild) {
	            return visitJsxOpeningFragment(node.openingFragment, node.children, isChild, /*location*/ node);
	        }
	        function visitJsxOpeningLikeElement(node, children, isChild, location) {
	            var tagName = getTagName(node);
	            var objectProperties;
	            var attrs = node.attributes.properties;
	            if (attrs.length === 0) {
	                // When there are no attributes, React wants "null"
	                objectProperties = ts.createNull();
	            }
	            else {
	                // Map spans of JsxAttribute nodes into object literals and spans
	                // of JsxSpreadAttribute nodes into expressions.
	                var segments = ts.flatten(ts.spanMap(attrs, ts.isJsxSpreadAttribute, function (attrs, isSpread) { return isSpread
	                    ? ts.map(attrs, transformJsxSpreadAttributeToExpression)
	                    : ts.createObjectLiteral(ts.map(attrs, transformJsxAttributeToObjectLiteralElement)); }));
	                if (ts.isJsxSpreadAttribute(attrs[0])) {
	                    // We must always emit at least one object literal before a spread
	                    // argument.
	                    segments.unshift(ts.createObjectLiteral());
	                }
	                // Either emit one big object literal (no spread attribs), or
	                // a call to the __assign helper.
	                objectProperties = ts.singleOrUndefined(segments);
	                if (!objectProperties) {
	                    objectProperties = ts.createAssignHelper(context, segments);
	                }
	            }
	            var element = ts.createExpressionForJsxElement(context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, tagName, objectProperties, ts.mapDefined(children, transformJsxChildToExpression), node, location);
	            if (isChild) {
	                ts.startOnNewLine(element);
	            }
	            return element;
	        }
	        function visitJsxOpeningFragment(node, children, isChild, location) {
	            var element = ts.createExpressionForJsxFragment(context.getEmitResolver().getJsxFactoryEntity(currentSourceFile), compilerOptions.reactNamespace, ts.mapDefined(children, transformJsxChildToExpression), node, location);
	            if (isChild) {
	                ts.startOnNewLine(element);
	            }
	            return element;
	        }
	        function transformJsxSpreadAttributeToExpression(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        function transformJsxAttributeToObjectLiteralElement(node) {
	            var name = getAttributeName(node);
	            var expression = transformJsxAttributeInitializer(node.initializer);
	            return ts.createPropertyAssignment(name, expression);
	        }
	        function transformJsxAttributeInitializer(node) {
	            if (node === undefined) {
	                return ts.createTrue();
	            }
	            else if (node.kind === 9 /* StringLiteral */) {
	                // Always recreate the literal to escape any escape sequences or newlines which may be in the original jsx string and which
	                // Need to be escaped to be handled correctly in a normal string
	                var literal = ts.createLiteral(tryDecodeEntities(node.text) || node.text);
	                literal.singleQuote = node.singleQuote !== undefined ? node.singleQuote : !ts.isStringDoubleQuoted(node, currentSourceFile);
	                return ts.setTextRange(literal, node);
	            }
	            else if (node.kind === 264 /* JsxExpression */) {
	                if (node.expression === undefined) {
	                    return ts.createTrue();
	                }
	                return visitJsxExpression(node);
	            }
	            else {
	                return ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        function visitJsxText(node) {
	            var fixed = fixupWhitespaceAndDecodeEntities(ts.getTextOfNode(node, /*includeTrivia*/ true));
	            return fixed === undefined ? undefined : ts.createLiteral(fixed);
	        }
	        /**
	         * JSX trims whitespace at the end and beginning of lines, except that the
	         * start/end of a tag is considered a start/end of a line only if that line is
	         * on the same line as the closing tag. See examples in
	         * tests/cases/conformance/jsx/tsxReactEmitWhitespace.tsx
	         * See also https://www.w3.org/TR/html4/struct/text.html#h-9.1 and https://www.w3.org/TR/CSS2/text.html#white-space-model
	         *
	         * An equivalent algorithm would be:
	         * - If there is only one line, return it.
	         * - If there is only whitespace (but multiple lines), return `undefined`.
	         * - Split the text into lines.
	         * - 'trimRight' the first line, 'trimLeft' the last line, 'trim' middle lines.
	         * - Decode entities on each line (individually).
	         * - Remove empty lines and join the rest with " ".
	         */
	        function fixupWhitespaceAndDecodeEntities(text) {
	            var acc;
	            // First non-whitespace character on this line.
	            var firstNonWhitespace = 0;
	            // Last non-whitespace character on this line.
	            var lastNonWhitespace = -1;
	            // These initial values are special because the first line is:
	            // firstNonWhitespace = 0 to indicate that we want leading whitsepace,
	            // but lastNonWhitespace = -1 as a special flag to indicate that we *don't* include the line if it's all whitespace.
	            for (var i = 0; i < text.length; i++) {
	                var c = text.charCodeAt(i);
	                if (ts.isLineBreak(c)) {
	                    // If we've seen any non-whitespace characters on this line, add the 'trim' of the line.
	                    // (lastNonWhitespace === -1 is a special flag to detect whether the first line is all whitespace.)
	                    if (firstNonWhitespace !== -1 && lastNonWhitespace !== -1) {
	                        acc = addLineOfJsxText(acc, text.substr(firstNonWhitespace, lastNonWhitespace - firstNonWhitespace + 1));
	                    }
	                    // Reset firstNonWhitespace for the next line.
	                    // Don't bother to reset lastNonWhitespace because we ignore it if firstNonWhitespace = -1.
	                    firstNonWhitespace = -1;
	                }
	                else if (!ts.isWhiteSpaceSingleLine(c)) {
	                    lastNonWhitespace = i;
	                    if (firstNonWhitespace === -1) {
	                        firstNonWhitespace = i;
	                    }
	                }
	            }
	            return firstNonWhitespace !== -1
	                // Last line had a non-whitespace character. Emit the 'trimLeft', meaning keep trailing whitespace.
	                ? addLineOfJsxText(acc, text.substr(firstNonWhitespace))
	                // Last line was all whitespace, so ignore it
	                : acc;
	        }
	        function addLineOfJsxText(acc, trimmedLine) {
	            // We do not escape the string here as that is handled by the printer
	            // when it emits the literal. We do, however, need to decode JSX entities.
	            var decoded = decodeEntities(trimmedLine);
	            return acc === undefined ? decoded : acc + " " + decoded;
	        }
	        /**
	         * Replace entities like "&nbsp;", "&#123;", and "&#xDEADBEEF;" with the characters they encode.
	         * See https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
	         */
	        function decodeEntities(text) {
	            return text.replace(/&((#((\d+)|x([\da-fA-F]+)))|(\w+));/g, function (match, _all, _number, _digits, decimal, hex, word) {
	                if (decimal) {
	                    return String.fromCharCode(parseInt(decimal, 10));
	                }
	                else if (hex) {
	                    return String.fromCharCode(parseInt(hex, 16));
	                }
	                else {
	                    var ch = entities.get(word);
	                    // If this is not a valid entity, then just use `match` (replace it with itself, i.e. don't replace)
	                    return ch ? String.fromCharCode(ch) : match;
	                }
	            });
	        }
	        /** Like `decodeEntities` but returns `undefined` if there were no entities to decode. */
	        function tryDecodeEntities(text) {
	            var decoded = decodeEntities(text);
	            return decoded === text ? undefined : decoded;
	        }
	        function getTagName(node) {
	            if (node.kind === 254 /* JsxElement */) {
	                return getTagName(node.openingElement);
	            }
	            else {
	                var name = node.tagName;
	                if (ts.isIdentifier(name) && ts.isIntrinsicJsxName(name.escapedText)) {
	                    return ts.createLiteral(ts.idText(name));
	                }
	                else {
	                    return ts.createExpressionFromEntityName(name);
	                }
	            }
	        }
	        /**
	         * Emit an attribute name, which is quoted if it needs to be quoted. Because
	         * these emit into an object literal property name, we don't need to be worried
	         * about keywords, just non-identifier characters
	         */
	        function getAttributeName(node) {
	            var name = node.name;
	            var text = ts.idText(name);
	            if (/^[A-Za-z_]\w*$/.test(text)) {
	                return name;
	            }
	            else {
	                return ts.createLiteral(text);
	            }
	        }
	        function visitJsxExpression(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	    }
	    ts.transformJsx = transformJsx;
	    var entities = ts.createMapFromTemplate({
	        quot: 0x0022,
	        amp: 0x0026,
	        apos: 0x0027,
	        lt: 0x003C,
	        gt: 0x003E,
	        nbsp: 0x00A0,
	        iexcl: 0x00A1,
	        cent: 0x00A2,
	        pound: 0x00A3,
	        curren: 0x00A4,
	        yen: 0x00A5,
	        brvbar: 0x00A6,
	        sect: 0x00A7,
	        uml: 0x00A8,
	        copy: 0x00A9,
	        ordf: 0x00AA,
	        laquo: 0x00AB,
	        not: 0x00AC,
	        shy: 0x00AD,
	        reg: 0x00AE,
	        macr: 0x00AF,
	        deg: 0x00B0,
	        plusmn: 0x00B1,
	        sup2: 0x00B2,
	        sup3: 0x00B3,
	        acute: 0x00B4,
	        micro: 0x00B5,
	        para: 0x00B6,
	        middot: 0x00B7,
	        cedil: 0x00B8,
	        sup1: 0x00B9,
	        ordm: 0x00BA,
	        raquo: 0x00BB,
	        frac14: 0x00BC,
	        frac12: 0x00BD,
	        frac34: 0x00BE,
	        iquest: 0x00BF,
	        Agrave: 0x00C0,
	        Aacute: 0x00C1,
	        Acirc: 0x00C2,
	        Atilde: 0x00C3,
	        Auml: 0x00C4,
	        Aring: 0x00C5,
	        AElig: 0x00C6,
	        Ccedil: 0x00C7,
	        Egrave: 0x00C8,
	        Eacute: 0x00C9,
	        Ecirc: 0x00CA,
	        Euml: 0x00CB,
	        Igrave: 0x00CC,
	        Iacute: 0x00CD,
	        Icirc: 0x00CE,
	        Iuml: 0x00CF,
	        ETH: 0x00D0,
	        Ntilde: 0x00D1,
	        Ograve: 0x00D2,
	        Oacute: 0x00D3,
	        Ocirc: 0x00D4,
	        Otilde: 0x00D5,
	        Ouml: 0x00D6,
	        times: 0x00D7,
	        Oslash: 0x00D8,
	        Ugrave: 0x00D9,
	        Uacute: 0x00DA,
	        Ucirc: 0x00DB,
	        Uuml: 0x00DC,
	        Yacute: 0x00DD,
	        THORN: 0x00DE,
	        szlig: 0x00DF,
	        agrave: 0x00E0,
	        aacute: 0x00E1,
	        acirc: 0x00E2,
	        atilde: 0x00E3,
	        auml: 0x00E4,
	        aring: 0x00E5,
	        aelig: 0x00E6,
	        ccedil: 0x00E7,
	        egrave: 0x00E8,
	        eacute: 0x00E9,
	        ecirc: 0x00EA,
	        euml: 0x00EB,
	        igrave: 0x00EC,
	        iacute: 0x00ED,
	        icirc: 0x00EE,
	        iuml: 0x00EF,
	        eth: 0x00F0,
	        ntilde: 0x00F1,
	        ograve: 0x00F2,
	        oacute: 0x00F3,
	        ocirc: 0x00F4,
	        otilde: 0x00F5,
	        ouml: 0x00F6,
	        divide: 0x00F7,
	        oslash: 0x00F8,
	        ugrave: 0x00F9,
	        uacute: 0x00FA,
	        ucirc: 0x00FB,
	        uuml: 0x00FC,
	        yacute: 0x00FD,
	        thorn: 0x00FE,
	        yuml: 0x00FF,
	        OElig: 0x0152,
	        oelig: 0x0153,
	        Scaron: 0x0160,
	        scaron: 0x0161,
	        Yuml: 0x0178,
	        fnof: 0x0192,
	        circ: 0x02C6,
	        tilde: 0x02DC,
	        Alpha: 0x0391,
	        Beta: 0x0392,
	        Gamma: 0x0393,
	        Delta: 0x0394,
	        Epsilon: 0x0395,
	        Zeta: 0x0396,
	        Eta: 0x0397,
	        Theta: 0x0398,
	        Iota: 0x0399,
	        Kappa: 0x039A,
	        Lambda: 0x039B,
	        Mu: 0x039C,
	        Nu: 0x039D,
	        Xi: 0x039E,
	        Omicron: 0x039F,
	        Pi: 0x03A0,
	        Rho: 0x03A1,
	        Sigma: 0x03A3,
	        Tau: 0x03A4,
	        Upsilon: 0x03A5,
	        Phi: 0x03A6,
	        Chi: 0x03A7,
	        Psi: 0x03A8,
	        Omega: 0x03A9,
	        alpha: 0x03B1,
	        beta: 0x03B2,
	        gamma: 0x03B3,
	        delta: 0x03B4,
	        epsilon: 0x03B5,
	        zeta: 0x03B6,
	        eta: 0x03B7,
	        theta: 0x03B8,
	        iota: 0x03B9,
	        kappa: 0x03BA,
	        lambda: 0x03BB,
	        mu: 0x03BC,
	        nu: 0x03BD,
	        xi: 0x03BE,
	        omicron: 0x03BF,
	        pi: 0x03C0,
	        rho: 0x03C1,
	        sigmaf: 0x03C2,
	        sigma: 0x03C3,
	        tau: 0x03C4,
	        upsilon: 0x03C5,
	        phi: 0x03C6,
	        chi: 0x03C7,
	        psi: 0x03C8,
	        omega: 0x03C9,
	        thetasym: 0x03D1,
	        upsih: 0x03D2,
	        piv: 0x03D6,
	        ensp: 0x2002,
	        emsp: 0x2003,
	        thinsp: 0x2009,
	        zwnj: 0x200C,
	        zwj: 0x200D,
	        lrm: 0x200E,
	        rlm: 0x200F,
	        ndash: 0x2013,
	        mdash: 0x2014,
	        lsquo: 0x2018,
	        rsquo: 0x2019,
	        sbquo: 0x201A,
	        ldquo: 0x201C,
	        rdquo: 0x201D,
	        bdquo: 0x201E,
	        dagger: 0x2020,
	        Dagger: 0x2021,
	        bull: 0x2022,
	        hellip: 0x2026,
	        permil: 0x2030,
	        prime: 0x2032,
	        Prime: 0x2033,
	        lsaquo: 0x2039,
	        rsaquo: 0x203A,
	        oline: 0x203E,
	        frasl: 0x2044,
	        euro: 0x20AC,
	        image: 0x2111,
	        weierp: 0x2118,
	        real: 0x211C,
	        trade: 0x2122,
	        alefsym: 0x2135,
	        larr: 0x2190,
	        uarr: 0x2191,
	        rarr: 0x2192,
	        darr: 0x2193,
	        harr: 0x2194,
	        crarr: 0x21B5,
	        lArr: 0x21D0,
	        uArr: 0x21D1,
	        rArr: 0x21D2,
	        dArr: 0x21D3,
	        hArr: 0x21D4,
	        forall: 0x2200,
	        part: 0x2202,
	        exist: 0x2203,
	        empty: 0x2205,
	        nabla: 0x2207,
	        isin: 0x2208,
	        notin: 0x2209,
	        ni: 0x220B,
	        prod: 0x220F,
	        sum: 0x2211,
	        minus: 0x2212,
	        lowast: 0x2217,
	        radic: 0x221A,
	        prop: 0x221D,
	        infin: 0x221E,
	        ang: 0x2220,
	        and: 0x2227,
	        or: 0x2228,
	        cap: 0x2229,
	        cup: 0x222A,
	        int: 0x222B,
	        there4: 0x2234,
	        sim: 0x223C,
	        cong: 0x2245,
	        asymp: 0x2248,
	        ne: 0x2260,
	        equiv: 0x2261,
	        le: 0x2264,
	        ge: 0x2265,
	        sub: 0x2282,
	        sup: 0x2283,
	        nsub: 0x2284,
	        sube: 0x2286,
	        supe: 0x2287,
	        oplus: 0x2295,
	        otimes: 0x2297,
	        perp: 0x22A5,
	        sdot: 0x22C5,
	        lceil: 0x2308,
	        rceil: 0x2309,
	        lfloor: 0x230A,
	        rfloor: 0x230B,
	        lang: 0x2329,
	        rang: 0x232A,
	        loz: 0x25CA,
	        spades: 0x2660,
	        clubs: 0x2663,
	        hearts: 0x2665,
	        diams: 0x2666
	    });
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformES2016(context) {
	        var hoistVariableDeclaration = context.hoistVariableDeclaration;
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitor(node) {
	            if ((node.transformFlags & 32 /* ContainsES2016 */) === 0) {
	                return node;
	            }
	            switch (node.kind) {
	                case 199 /* BinaryExpression */:
	                    return visitBinaryExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitBinaryExpression(node) {
	            switch (node.operatorToken.kind) {
	                case 62 /* AsteriskAsteriskEqualsToken */:
	                    return visitExponentiationAssignmentExpression(node);
	                case 40 /* AsteriskAsteriskToken */:
	                    return visitExponentiationExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitExponentiationAssignmentExpression(node) {
	            var target;
	            var value;
	            var left = ts.visitNode(node.left, visitor, ts.isExpression);
	            var right = ts.visitNode(node.right, visitor, ts.isExpression);
	            if (ts.isElementAccessExpression(left)) {
	                // Transforms `a[x] **= b` into `(_a = a)[_x = x] = Math.pow(_a[_x], b)`
	                var expressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                var argumentExpressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                target = ts.setTextRange(ts.createElementAccess(ts.setTextRange(ts.createAssignment(expressionTemp, left.expression), left.expression), ts.setTextRange(ts.createAssignment(argumentExpressionTemp, left.argumentExpression), left.argumentExpression)), left);
	                value = ts.setTextRange(ts.createElementAccess(expressionTemp, argumentExpressionTemp), left);
	            }
	            else if (ts.isPropertyAccessExpression(left)) {
	                // Transforms `a.x **= b` into `(_a = a).x = Math.pow(_a.x, b)`
	                var expressionTemp = ts.createTempVariable(hoistVariableDeclaration);
	                target = ts.setTextRange(ts.createPropertyAccess(ts.setTextRange(ts.createAssignment(expressionTemp, left.expression), left.expression), left.name), left);
	                value = ts.setTextRange(ts.createPropertyAccess(expressionTemp, left.name), left);
	            }
	            else {
	                // Transforms `a **= b` into `a = Math.pow(a, b)`
	                target = left;
	                value = left;
	            }
	            return ts.setTextRange(ts.createAssignment(target, ts.createMathPow(value, right, /*location*/ node)), node);
	        }
	        function visitExponentiationExpression(node) {
	            // Transforms `a ** b` into `Math.pow(a, b)`
	            var left = ts.visitNode(node.left, visitor, ts.isExpression);
	            var right = ts.visitNode(node.right, visitor, ts.isExpression);
	            return ts.createMathPow(left, right, /*location*/ node);
	        }
	    }
	    ts.transformES2016 = transformES2016;
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    var ES2015SubstitutionFlags;
	    (function (ES2015SubstitutionFlags) {
	        /** Enables substitutions for captured `this` */
	        ES2015SubstitutionFlags[ES2015SubstitutionFlags["CapturedThis"] = 1] = "CapturedThis";
	        /** Enables substitutions for block-scoped bindings. */
	        ES2015SubstitutionFlags[ES2015SubstitutionFlags["BlockScopedBindings"] = 2] = "BlockScopedBindings";
	    })(ES2015SubstitutionFlags || (ES2015SubstitutionFlags = {}));
	    var CopyDirection;
	    (function (CopyDirection) {
	        CopyDirection[CopyDirection["ToOriginal"] = 0] = "ToOriginal";
	        CopyDirection[CopyDirection["ToOutParameter"] = 1] = "ToOutParameter";
	    })(CopyDirection || (CopyDirection = {}));
	    var Jump;
	    (function (Jump) {
	        Jump[Jump["Break"] = 2] = "Break";
	        Jump[Jump["Continue"] = 4] = "Continue";
	        Jump[Jump["Return"] = 8] = "Return";
	    })(Jump || (Jump = {}));
	    var SuperCaptureResult;
	    (function (SuperCaptureResult) {
	        /**
	         * A capture may have been added for calls to 'super', but
	         * the caller should emit subsequent statements normally.
	         */
	        SuperCaptureResult[SuperCaptureResult["NoReplacement"] = 0] = "NoReplacement";
	        /**
	         * A call to 'super()' got replaced with a capturing statement like:
	         *
	         *  var _this = _super.call(...) || this;
	         *
	         * Callers should skip the current statement.
	         */
	        SuperCaptureResult[SuperCaptureResult["ReplaceSuperCapture"] = 1] = "ReplaceSuperCapture";
	        /**
	         * A call to 'super()' got replaced with a capturing statement like:
	         *
	         *  return _super.call(...) || this;
	         *
	         * Callers should skip the current statement and avoid any returns of '_this'.
	         */
	        SuperCaptureResult[SuperCaptureResult["ReplaceWithReturn"] = 2] = "ReplaceWithReturn";
	    })(SuperCaptureResult || (SuperCaptureResult = {}));
	    // Facts we track as we traverse the tree
	    var HierarchyFacts;
	    (function (HierarchyFacts) {
	        HierarchyFacts[HierarchyFacts["None"] = 0] = "None";
	        //
	        // Ancestor facts
	        //
	        HierarchyFacts[HierarchyFacts["Function"] = 1] = "Function";
	        HierarchyFacts[HierarchyFacts["ArrowFunction"] = 2] = "ArrowFunction";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBody"] = 4] = "AsyncFunctionBody";
	        HierarchyFacts[HierarchyFacts["NonStaticClassElement"] = 8] = "NonStaticClassElement";
	        HierarchyFacts[HierarchyFacts["CapturesThis"] = 16] = "CapturesThis";
	        HierarchyFacts[HierarchyFacts["ExportedVariableStatement"] = 32] = "ExportedVariableStatement";
	        HierarchyFacts[HierarchyFacts["TopLevel"] = 64] = "TopLevel";
	        HierarchyFacts[HierarchyFacts["Block"] = 128] = "Block";
	        HierarchyFacts[HierarchyFacts["IterationStatement"] = 256] = "IterationStatement";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlock"] = 512] = "IterationStatementBlock";
	        HierarchyFacts[HierarchyFacts["ForStatement"] = 1024] = "ForStatement";
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatement"] = 2048] = "ForInOrForOfStatement";
	        HierarchyFacts[HierarchyFacts["ConstructorWithCapturedSuper"] = 4096] = "ConstructorWithCapturedSuper";
	        HierarchyFacts[HierarchyFacts["ComputedPropertyName"] = 8192] = "ComputedPropertyName";
	        // NOTE: do not add more ancestor flags without also updating AncestorFactsMask below.
	        //
	        // Ancestor masks
	        //
	        HierarchyFacts[HierarchyFacts["AncestorFactsMask"] = 16383] = "AncestorFactsMask";
	        // We are always in *some* kind of block scope, but only specific block-scope containers are
	        // top-level or Blocks.
	        HierarchyFacts[HierarchyFacts["BlockScopeIncludes"] = 0] = "BlockScopeIncludes";
	        HierarchyFacts[HierarchyFacts["BlockScopeExcludes"] = 4032] = "BlockScopeExcludes";
	        // A source file is a top-level block scope.
	        HierarchyFacts[HierarchyFacts["SourceFileIncludes"] = 64] = "SourceFileIncludes";
	        HierarchyFacts[HierarchyFacts["SourceFileExcludes"] = 3968] = "SourceFileExcludes";
	        // Functions, methods, and accessors are both new lexical scopes and new block scopes.
	        HierarchyFacts[HierarchyFacts["FunctionIncludes"] = 65] = "FunctionIncludes";
	        HierarchyFacts[HierarchyFacts["FunctionExcludes"] = 16286] = "FunctionExcludes";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBodyIncludes"] = 69] = "AsyncFunctionBodyIncludes";
	        HierarchyFacts[HierarchyFacts["AsyncFunctionBodyExcludes"] = 16278] = "AsyncFunctionBodyExcludes";
	        // Arrow functions are lexically scoped to their container, but are new block scopes.
	        HierarchyFacts[HierarchyFacts["ArrowFunctionIncludes"] = 66] = "ArrowFunctionIncludes";
	        HierarchyFacts[HierarchyFacts["ArrowFunctionExcludes"] = 16256] = "ArrowFunctionExcludes";
	        // Constructors are both new lexical scopes and new block scopes. Constructors are also
	        // always considered non-static members of a class.
	        HierarchyFacts[HierarchyFacts["ConstructorIncludes"] = 73] = "ConstructorIncludes";
	        HierarchyFacts[HierarchyFacts["ConstructorExcludes"] = 16278] = "ConstructorExcludes";
	        // 'do' and 'while' statements are not block scopes. We track that the subtree is contained
	        // within an IterationStatement to indicate whether the embedded statement is an
	        // IterationStatementBlock.
	        HierarchyFacts[HierarchyFacts["DoOrWhileStatementIncludes"] = 256] = "DoOrWhileStatementIncludes";
	        HierarchyFacts[HierarchyFacts["DoOrWhileStatementExcludes"] = 0] = "DoOrWhileStatementExcludes";
	        // 'for' statements are new block scopes and have special handling for 'let' declarations.
	        HierarchyFacts[HierarchyFacts["ForStatementIncludes"] = 1280] = "ForStatementIncludes";
	        HierarchyFacts[HierarchyFacts["ForStatementExcludes"] = 3008] = "ForStatementExcludes";
	        // 'for-in' and 'for-of' statements are new block scopes and have special handling for
	        // 'let' declarations.
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatementIncludes"] = 2304] = "ForInOrForOfStatementIncludes";
	        HierarchyFacts[HierarchyFacts["ForInOrForOfStatementExcludes"] = 1984] = "ForInOrForOfStatementExcludes";
	        // Blocks (other than function bodies) are new block scopes.
	        HierarchyFacts[HierarchyFacts["BlockIncludes"] = 128] = "BlockIncludes";
	        HierarchyFacts[HierarchyFacts["BlockExcludes"] = 3904] = "BlockExcludes";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlockIncludes"] = 512] = "IterationStatementBlockIncludes";
	        HierarchyFacts[HierarchyFacts["IterationStatementBlockExcludes"] = 4032] = "IterationStatementBlockExcludes";
	        // Computed property names track subtree flags differently than their containing members.
	        HierarchyFacts[HierarchyFacts["ComputedPropertyNameIncludes"] = 8192] = "ComputedPropertyNameIncludes";
	        HierarchyFacts[HierarchyFacts["ComputedPropertyNameExcludes"] = 0] = "ComputedPropertyNameExcludes";
	        //
	        // Subtree facts
	        //
	        HierarchyFacts[HierarchyFacts["NewTarget"] = 16384] = "NewTarget";
	        HierarchyFacts[HierarchyFacts["NewTargetInComputedPropertyName"] = 32768] = "NewTargetInComputedPropertyName";
	        //
	        // Subtree masks
	        //
	        HierarchyFacts[HierarchyFacts["SubtreeFactsMask"] = -16384] = "SubtreeFactsMask";
	        HierarchyFacts[HierarchyFacts["PropagateNewTargetMask"] = 49152] = "PropagateNewTargetMask";
	    })(HierarchyFacts || (HierarchyFacts = {}));
	    function transformES2015(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var currentSourceFile;
	        var currentText;
	        var hierarchyFacts;
	        var taggedTemplateStringDeclarations;
	        function recordTaggedTemplateString(temp) {
	            taggedTemplateStringDeclarations = ts.append(taggedTemplateStringDeclarations, ts.createVariableDeclaration(temp));
	        }
	        /**
	         * Used to track if we are emitting body of the converted loop
	         */
	        var convertedLoopState;
	        /**
	         * Keeps track of whether substitutions have been enabled for specific cases.
	         * They are persisted between each SourceFile transformation and should not
	         * be reset.
	         */
	        var enabledSubstitutions;
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            currentSourceFile = node;
	            currentText = node.text;
	            var visited = visitSourceFile(node);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            currentSourceFile = undefined;
	            currentText = undefined;
	            taggedTemplateStringDeclarations = undefined;
	            hierarchyFacts = 0 /* None */;
	            return visited;
	        }
	        /**
	         * Sets the `HierarchyFacts` for this node prior to visiting this node's subtree, returning the facts set prior to modification.
	         * @param excludeFacts The existing `HierarchyFacts` to reset before visiting the subtree.
	         * @param includeFacts The new `HierarchyFacts` to set before visiting the subtree.
	         */
	        function enterSubtree(excludeFacts, includeFacts) {
	            var ancestorFacts = hierarchyFacts;
	            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & 16383 /* AncestorFactsMask */;
	            return ancestorFacts;
	        }
	        /**
	         * Restores the `HierarchyFacts` for this node's ancestor after visiting this node's
	         * subtree, propagating specific facts from the subtree.
	         * @param ancestorFacts The `HierarchyFacts` of the ancestor to restore after visiting the subtree.
	         * @param excludeFacts The existing `HierarchyFacts` of the subtree that should not be propagated.
	         * @param includeFacts The new `HierarchyFacts` of the subtree that should be propagated.
	         */
	        function exitSubtree(ancestorFacts, excludeFacts, includeFacts) {
	            hierarchyFacts = (hierarchyFacts & ~excludeFacts | includeFacts) & -16384 /* SubtreeFactsMask */ | ancestorFacts;
	        }
	        function isReturnVoidStatementInConstructorWithCapturedSuper(node) {
	            return hierarchyFacts & 4096 /* ConstructorWithCapturedSuper */
	                && node.kind === 224 /* ReturnStatement */
	                && !node.expression;
	        }
	        function shouldVisitNode(node) {
	            return (node.transformFlags & 128 /* ContainsES2015 */) !== 0
	                || convertedLoopState !== undefined
	                || (hierarchyFacts & 4096 /* ConstructorWithCapturedSuper */ && (ts.isStatement(node) || (node.kind === 212 /* Block */)))
	                || (ts.isIterationStatement(node, /*lookInLabeledStatements*/ false) && shouldConvertIterationStatementBody(node))
	                || (ts.getEmitFlags(node) & 33554432 /* TypeScriptClassWrapper */) !== 0;
	        }
	        function visitor(node) {
	            if (shouldVisitNode(node)) {
	                return visitJavaScript(node);
	            }
	            else {
	                return node;
	            }
	        }
	        function functionBodyVisitor(node) {
	            if (shouldVisitNode(node)) {
	                return visitBlock(node, /*isFunctionBody*/ true);
	            }
	            return node;
	        }
	        function callExpressionVisitor(node) {
	            if (node.kind === 97 /* SuperKeyword */) {
	                return visitSuperKeyword(/*isExpressionOfCall*/ true);
	            }
	            return visitor(node);
	        }
	        function visitJavaScript(node) {
	            switch (node.kind) {
	                case 115 /* StaticKeyword */:
	                    return undefined; // elide static keyword
	                case 234 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 204 /* ClassExpression */:
	                    return visitClassExpression(node);
	                case 148 /* Parameter */:
	                    return visitParameter(node);
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 192 /* ArrowFunction */:
	                    return visitArrowFunction(node);
	                case 191 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 231 /* VariableDeclaration */:
	                    return visitVariableDeclaration(node);
	                case 71 /* Identifier */:
	                    return visitIdentifier(node);
	                case 232 /* VariableDeclarationList */:
	                    return visitVariableDeclarationList(node);
	                case 226 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 240 /* CaseBlock */:
	                    return visitCaseBlock(node);
	                case 212 /* Block */:
	                    return visitBlock(node, /*isFunctionBody*/ false);
	                case 223 /* BreakStatement */:
	                case 222 /* ContinueStatement */:
	                    return visitBreakOrContinueStatement(node);
	                case 227 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 217 /* DoStatement */:
	                case 218 /* WhileStatement */:
	                    return visitDoOrWhileStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 219 /* ForStatement */:
	                    return visitForStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 220 /* ForInStatement */:
	                    return visitForInStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 221 /* ForOfStatement */:
	                    return visitForOfStatement(node, /*outermostLabeledStatement*/ undefined);
	                case 215 /* ExpressionStatement */:
	                    return visitExpressionStatement(node);
	                case 183 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 268 /* CatchClause */:
	                    return visitCatchClause(node);
	                case 270 /* ShorthandPropertyAssignment */:
	                    return visitShorthandPropertyAssignment(node);
	                case 146 /* ComputedPropertyName */:
	                    return visitComputedPropertyName(node);
	                case 182 /* ArrayLiteralExpression */:
	                    return visitArrayLiteralExpression(node);
	                case 186 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 187 /* NewExpression */:
	                    return visitNewExpression(node);
	                case 190 /* ParenthesizedExpression */:
	                    return visitParenthesizedExpression(node, /*needsDestructuringValue*/ true);
	                case 199 /* BinaryExpression */:
	                    return visitBinaryExpression(node, /*needsDestructuringValue*/ true);
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 14 /* TemplateHead */:
	                case 15 /* TemplateMiddle */:
	                case 16 /* TemplateTail */:
	                    return visitTemplateLiteral(node);
	                case 9 /* StringLiteral */:
	                    return visitStringLiteral(node);
	                case 8 /* NumericLiteral */:
	                    return visitNumericLiteral(node);
	                case 188 /* TaggedTemplateExpression */:
	                    return visitTaggedTemplateExpression(node);
	                case 201 /* TemplateExpression */:
	                    return visitTemplateExpression(node);
	                case 202 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 203 /* SpreadElement */:
	                    return visitSpreadElement(node);
	                case 97 /* SuperKeyword */:
	                    return visitSuperKeyword(/*isExpressionOfCall*/ false);
	                case 99 /* ThisKeyword */:
	                    return visitThisKeyword(node);
	                case 209 /* MetaProperty */:
	                    return visitMetaProperty(node);
	                case 153 /* MethodDeclaration */:
	                    return visitMethodDeclaration(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return visitAccessorDeclaration(node);
	                case 213 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 224 /* ReturnStatement */:
	                    return visitReturnStatement(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function visitSourceFile(node) {
	            var ancestorFacts = enterSubtree(3968 /* SourceFileExcludes */, 64 /* SourceFileIncludes */);
	            var statements = [];
	            startLexicalEnvironment();
	            var statementOffset = ts.addStandardPrologue(statements, node.statements, /*ensureUseStrict*/ false);
	            addCaptureThisForNodeIfNeeded(statements, node);
	            statementOffset = ts.addCustomPrologue(statements, node.statements, statementOffset, visitor);
	            ts.addRange(statements, ts.visitNodes(node.statements, visitor, ts.isStatement, statementOffset));
	            if (taggedTemplateStringDeclarations) {
	                statements.push(ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList(taggedTemplateStringDeclarations)));
	            }
	            ts.prependStatements(statements, endLexicalEnvironment());
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	        }
	        function visitSwitchStatement(node) {
	            if (convertedLoopState !== undefined) {
	                var savedAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
	                // for switch statement allow only non-labeled break
	                convertedLoopState.allowedNonLabeledJumps |= 2 /* Break */;
	                var result = ts.visitEachChild(node, visitor, context);
	                convertedLoopState.allowedNonLabeledJumps = savedAllowedNonLabeledJumps;
	                return result;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitCaseBlock(node) {
	            var ancestorFacts = enterSubtree(4032 /* BlockScopeExcludes */, 0 /* BlockScopeIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function returnCapturedThis(node) {
	            return ts.setOriginalNode(ts.createReturn(ts.createFileLevelUniqueName("_this")), node);
	        }
	        function visitReturnStatement(node) {
	            if (convertedLoopState) {
	                convertedLoopState.nonLocalJumps |= 8 /* Return */;
	                if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) {
	                    node = returnCapturedThis(node);
	                }
	                return ts.createReturn(ts.createObjectLiteral([
	                    ts.createPropertyAssignment(ts.createIdentifier("value"), node.expression
	                        ? ts.visitNode(node.expression, visitor, ts.isExpression)
	                        : ts.createVoidZero())
	                ]));
	            }
	            else if (isReturnVoidStatementInConstructorWithCapturedSuper(node)) {
	                return returnCapturedThis(node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitThisKeyword(node) {
	            if (convertedLoopState) {
	                if (hierarchyFacts & 2 /* ArrowFunction */) {
	                    // if the enclosing function is an ArrowFunction then we use the captured 'this' keyword.
	                    convertedLoopState.containsLexicalThis = true;
	                    return node;
	                }
	                return convertedLoopState.thisName || (convertedLoopState.thisName = ts.createUniqueName("this"));
	            }
	            return node;
	        }
	        function visitIdentifier(node) {
	            if (!convertedLoopState) {
	                return node;
	            }
	            if (ts.isGeneratedIdentifier(node)) {
	                return node;
	            }
	            if (node.escapedText !== "arguments" || !resolver.isArgumentsLocalBinding(node)) {
	                return node;
	            }
	            return convertedLoopState.argumentsName || (convertedLoopState.argumentsName = ts.createUniqueName("arguments"));
	        }
	        function visitBreakOrContinueStatement(node) {
	            if (convertedLoopState) {
	                // check if we can emit break/continue as is
	                // it is possible if either
	                //   - break/continue is labeled and label is located inside the converted loop
	                //   - break/continue is non-labeled and located in non-converted loop/switch statement
	                var jump = node.kind === 223 /* BreakStatement */ ? 2 /* Break */ : 4 /* Continue */;
	                var canUseBreakOrContinue = (node.label && convertedLoopState.labels && convertedLoopState.labels.get(ts.idText(node.label))) ||
	                    (!node.label && (convertedLoopState.allowedNonLabeledJumps & jump));
	                if (!canUseBreakOrContinue) {
	                    var labelMarker = void 0;
	                    if (!node.label) {
	                        if (node.kind === 223 /* BreakStatement */) {
	                            convertedLoopState.nonLocalJumps |= 2 /* Break */;
	                            labelMarker = "break";
	                        }
	                        else {
	                            convertedLoopState.nonLocalJumps |= 4 /* Continue */;
	                            // note: return value is emitted only to simplify debugging, call to converted loop body does not do any dispatching on it.
	                            labelMarker = "continue";
	                        }
	                    }
	                    else {
	                        if (node.kind === 223 /* BreakStatement */) {
	                            labelMarker = "break-" + node.label.escapedText;
	                            setLabeledJump(convertedLoopState, /*isBreak*/ true, ts.idText(node.label), labelMarker);
	                        }
	                        else {
	                            labelMarker = "continue-" + node.label.escapedText;
	                            setLabeledJump(convertedLoopState, /*isBreak*/ false, ts.idText(node.label), labelMarker);
	                        }
	                    }
	                    var returnExpression = ts.createLiteral(labelMarker);
	                    if (convertedLoopState.loopOutParameters.length) {
	                        var outParams = convertedLoopState.loopOutParameters;
	                        var expr = void 0;
	                        for (var i = 0; i < outParams.length; i++) {
	                            var copyExpr = copyOutParameter(outParams[i], 1 /* ToOutParameter */);
	                            if (i === 0) {
	                                expr = copyExpr;
	                            }
	                            else {
	                                expr = ts.createBinary(expr, 26 /* CommaToken */, copyExpr);
	                            }
	                        }
	                        returnExpression = ts.createBinary(expr, 26 /* CommaToken */, returnExpression);
	                    }
	                    return ts.createReturn(returnExpression);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a ClassDeclaration and transforms it into a variable statement.
	         *
	         * @param node A ClassDeclaration node.
	         */
	        function visitClassDeclaration(node) {
	            // [source]
	            //      class C { }
	            //
	            // [output]
	            //      var C = (function () {
	            //          function C() {
	            //          }
	            //          return C;
	            //      }());
	            var variable = ts.createVariableDeclaration(ts.getLocalName(node, /*allowComments*/ true), 
	            /*type*/ undefined, transformClassLikeDeclarationToExpression(node));
	            ts.setOriginalNode(variable, node);
	            var statements = [];
	            var statement = ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList([variable]));
	            ts.setOriginalNode(statement, node);
	            ts.setTextRange(statement, node);
	            ts.startOnNewLine(statement);
	            statements.push(statement);
	            // Add an `export default` statement for default exports (for `--target es5 --module es6`)
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                var exportStatement = ts.hasModifier(node, 512 /* Default */)
	                    ? ts.createExportDefault(ts.getLocalName(node))
	                    : ts.createExternalModuleExport(ts.getLocalName(node));
	                ts.setOriginalNode(exportStatement, statement);
	                statements.push(exportStatement);
	            }
	            var emitFlags = ts.getEmitFlags(node);
	            if ((emitFlags & 4194304 /* HasEndOfDeclarationMarker */) === 0) {
	                // Add a DeclarationMarker as a marker for the end of the declaration
	                statements.push(ts.createEndOfDeclarationMarker(node));
	                ts.setEmitFlags(statement, emitFlags | 4194304 /* HasEndOfDeclarationMarker */);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a ClassExpression and transforms it into an expression.
	         *
	         * @param node A ClassExpression node.
	         */
	        function visitClassExpression(node) {
	            // [source]
	            //      C = class { }
	            //
	            // [output]
	            //      C = (function () {
	            //          function class_1() {
	            //          }
	            //          return class_1;
	            //      }())
	            return transformClassLikeDeclarationToExpression(node);
	        }
	        /**
	         * Transforms a ClassExpression or ClassDeclaration into an expression.
	         *
	         * @param node A ClassExpression or ClassDeclaration node.
	         */
	        function transformClassLikeDeclarationToExpression(node) {
	            // [source]
	            //      class C extends D {
	            //          constructor() {}
	            //          method() {}
	            //          get prop() {}
	            //          set prop(v) {}
	            //      }
	            //
	            // [output]
	            //      (function (_super) {
	            //          __extends(C, _super);
	            //          function C() {
	            //          }
	            //          C.prototype.method = function () {}
	            //          Object.defineProperty(C.prototype, "prop", {
	            //              get: function() {},
	            //              set: function() {},
	            //              enumerable: true,
	            //              configurable: true
	            //          });
	            //          return C;
	            //      }(D))
	            if (node.name) {
	                enableSubstitutionsForBlockScopedBindings();
	            }
	            var extendsClauseElement = ts.getClassExtendsHeritageClauseElement(node);
	            var classFunction = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, extendsClauseElement ? [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, ts.createFileLevelUniqueName("_super"))] : [], 
	            /*type*/ undefined, transformClassBody(node, extendsClauseElement));
	            // To preserve the behavior of the old emitter, we explicitly indent
	            // the body of the function here if it was requested in an earlier
	            // transformation.
	            ts.setEmitFlags(classFunction, (ts.getEmitFlags(node) & 65536 /* Indented */) | 524288 /* ReuseTempVariableScope */);
	            // "inner" and "outer" below are added purely to preserve source map locations from
	            // the old emitter
	            var inner = ts.createPartiallyEmittedExpression(classFunction);
	            inner.end = node.end;
	            ts.setEmitFlags(inner, 1536 /* NoComments */);
	            var outer = ts.createPartiallyEmittedExpression(inner);
	            outer.end = ts.skipTrivia(currentText, node.pos);
	            ts.setEmitFlags(outer, 1536 /* NoComments */);
	            var result = ts.createParen(ts.createCall(outer, 
	            /*typeArguments*/ undefined, extendsClauseElement
	                ? [ts.visitNode(extendsClauseElement.expression, visitor, ts.isExpression)]
	                : []));
	            ts.addSyntheticLeadingComment(result, 3 /* MultiLineCommentTrivia */, "* @class ");
	            return result;
	        }
	        /**
	         * Transforms a ClassExpression or ClassDeclaration into a function body.
	         *
	         * @param node A ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function transformClassBody(node, extendsClauseElement) {
	            var statements = [];
	            startLexicalEnvironment();
	            addExtendsHelperIfNeeded(statements, node, extendsClauseElement);
	            addConstructor(statements, node, extendsClauseElement);
	            addClassMembers(statements, node);
	            // Create a synthetic text range for the return statement.
	            var closingBraceLocation = ts.createTokenRange(ts.skipTrivia(currentText, node.members.end), 18 /* CloseBraceToken */);
	            var localName = ts.getInternalName(node);
	            // The following partially-emitted expression exists purely to align our sourcemap
	            // emit with the original emitter.
	            var outer = ts.createPartiallyEmittedExpression(localName);
	            outer.end = closingBraceLocation.end;
	            ts.setEmitFlags(outer, 1536 /* NoComments */);
	            var statement = ts.createReturn(outer);
	            statement.pos = closingBraceLocation.pos;
	            ts.setEmitFlags(statement, 1536 /* NoComments */ | 384 /* NoTokenSourceMaps */);
	            statements.push(statement);
	            ts.prependStatements(statements, endLexicalEnvironment());
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), /*location*/ node.members), /*multiLine*/ true);
	            ts.setEmitFlags(block, 1536 /* NoComments */);
	            return block;
	        }
	        /**
	         * Adds a call to the `__extends` helper if needed for a class.
	         *
	         * @param statements The statements of the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function addExtendsHelperIfNeeded(statements, node, extendsClauseElement) {
	            if (extendsClauseElement) {
	                statements.push(ts.setTextRange(ts.createStatement(createExtendsHelper(context, ts.getInternalName(node))), 
	                /*location*/ extendsClauseElement));
	            }
	        }
	        /**
	         * Adds the constructor of the class to a class body function.
	         *
	         * @param statements The statements of the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         */
	        function addConstructor(statements, node, extendsClauseElement) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16278 /* ConstructorExcludes */, 73 /* ConstructorIncludes */);
	            var constructor = ts.getFirstConstructorWithBody(node);
	            var hasSynthesizedSuper = hasSynthesizedDefaultSuperCall(constructor, extendsClauseElement !== undefined);
	            var constructorFunction = ts.createFunctionDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, ts.getInternalName(node), 
	            /*typeParameters*/ undefined, transformConstructorParameters(constructor, hasSynthesizedSuper), 
	            /*type*/ undefined, transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper));
	            ts.setTextRange(constructorFunction, constructor || node);
	            if (extendsClauseElement) {
	                ts.setEmitFlags(constructorFunction, 8 /* CapturesThis */);
	            }
	            statements.push(constructorFunction);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	        }
	        /**
	         * Transforms the parameters of the constructor declaration of a class.
	         *
	         * @param constructor The constructor for the class.
	         * @param hasSynthesizedSuper A value indicating whether the constructor starts with a
	         *                            synthesized `super` call.
	         */
	        function transformConstructorParameters(constructor, hasSynthesizedSuper) {
	            // If the TypeScript transformer needed to synthesize a constructor for property
	            // initializers, it would have also added a synthetic `...args` parameter and
	            // `super` call.
	            // If this is the case, we do not include the synthetic `...args` parameter and
	            // will instead use the `arguments` object in ES5/3.
	            return ts.visitParameterList(constructor && !hasSynthesizedSuper && constructor.parameters, visitor, context)
	                || [];
	        }
	        /**
	         * Transforms the body of a constructor declaration of a class.
	         *
	         * @param constructor The constructor for the class.
	         * @param node The node which contains the constructor.
	         * @param extendsClauseElement The expression for the class `extends` clause.
	         * @param hasSynthesizedSuper A value indicating whether the constructor starts with a
	         *                            synthesized `super` call.
	         */
	        function transformConstructorBody(constructor, node, extendsClauseElement, hasSynthesizedSuper) {
	            var statements = [];
	            resumeLexicalEnvironment();
	            var statementOffset = -1;
	            if (hasSynthesizedSuper) {
	                // If a super call has already been synthesized,
	                // we're going to assume that we should just transform everything after that.
	                // The assumption is that no prior step in the pipeline has added any prologue directives.
	                statementOffset = 0;
	            }
	            else if (constructor) {
	                statementOffset = ts.addStandardPrologue(statements, constructor.body.statements, /*ensureUseStrict*/ false);
	            }
	            if (constructor) {
	                addDefaultValueAssignmentsIfNeeded(statements, constructor);
	                addRestParameterIfNeeded(statements, constructor, hasSynthesizedSuper);
	                if (!hasSynthesizedSuper) {
	                    // If no super call has been synthesized, emit custom prologue directives.
	                    statementOffset = ts.addCustomPrologue(statements, constructor.body.statements, statementOffset, visitor);
	                }
	                ts.Debug.assert(statementOffset >= 0, "statementOffset not initialized correctly!");
	            }
	            // determine whether the class is known syntactically to be a derived class (e.g. a
	            // class that extends a value that is not syntactically known to be `null`).
	            var isDerivedClass = extendsClauseElement && ts.skipOuterExpressions(extendsClauseElement.expression).kind !== 95 /* NullKeyword */;
	            var superCaptureStatus = declareOrCaptureOrReturnThisForConstructorIfNeeded(statements, constructor, isDerivedClass, hasSynthesizedSuper, statementOffset);
	            // The last statement expression was replaced. Skip it.
	            if (superCaptureStatus === 1 /* ReplaceSuperCapture */ || superCaptureStatus === 2 /* ReplaceWithReturn */) {
	                statementOffset++;
	            }
	            if (constructor) {
	                if (superCaptureStatus === 1 /* ReplaceSuperCapture */) {
	                    hierarchyFacts |= 4096 /* ConstructorWithCapturedSuper */;
	                }
	                ts.addRange(statements, ts.visitNodes(constructor.body.statements, visitor, ts.isStatement, /*start*/ statementOffset));
	            }
	            // Return `_this` unless we're sure enough that it would be pointless to add a return statement.
	            // If there's a constructor that we can tell returns in enough places, then we *do not* want to add a return.
	            if (isDerivedClass
	                && superCaptureStatus !== 2 /* ReplaceWithReturn */
	                && !(constructor && isSufficientlyCoveredByReturnStatements(constructor.body))) {
	                statements.push(ts.createReturn(ts.createFileLevelUniqueName("_this")));
	            }
	            ts.prependStatements(statements, endLexicalEnvironment());
	            if (constructor) {
	                prependCaptureNewTargetIfNeeded(statements, constructor, /*copyOnWrite*/ false);
	            }
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(statements), 
	            /*location*/ constructor ? constructor.body.statements : node.members), 
	            /*multiLine*/ true);
	            ts.setTextRange(block, constructor ? constructor.body : node);
	            if (!constructor) {
	                ts.setEmitFlags(block, 1536 /* NoComments */);
	            }
	            return block;
	        }
	        /**
	         * We want to try to avoid emitting a return statement in certain cases if a user already returned something.
	         * It would generate obviously dead code, so we'll try to make things a little bit prettier
	         * by doing a minimal check on whether some common patterns always explicitly return.
	         */
	        function isSufficientlyCoveredByReturnStatements(statement) {
	            // A return statement is considered covered.
	            if (statement.kind === 224 /* ReturnStatement */) {
	                return true;
	            }
	            // An if-statement with two covered branches is covered.
	            else if (statement.kind === 216 /* IfStatement */) {
	                var ifStatement = statement;
	                if (ifStatement.elseStatement) {
	                    return isSufficientlyCoveredByReturnStatements(ifStatement.thenStatement) &&
	                        isSufficientlyCoveredByReturnStatements(ifStatement.elseStatement);
	                }
	            }
	            // A block is covered if it has a last statement which is covered.
	            else if (statement.kind === 212 /* Block */) {
	                var lastStatement = ts.lastOrUndefined(statement.statements);
	                if (lastStatement && isSufficientlyCoveredByReturnStatements(lastStatement)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Declares a `_this` variable for derived classes and for when arrow functions capture `this`.
	         *
	         * @returns The new statement offset into the `statements` array.
	         */
	        function declareOrCaptureOrReturnThisForConstructorIfNeeded(statements, ctor, isDerivedClass, hasSynthesizedSuper, statementOffset) {
	            // If this isn't a derived class, just capture 'this' for arrow functions if necessary.
	            if (!isDerivedClass) {
	                if (ctor) {
	                    addCaptureThisForNodeIfNeeded(statements, ctor);
	                }
	                return 0 /* NoReplacement */;
	            }
	            // We must be here because the user didn't write a constructor
	            // but we needed to call 'super(...args)' anyway as per 14.5.14 of the ES2016 spec.
	            // If that's the case we can just immediately return the result of a 'super()' call.
	            if (!ctor) {
	                statements.push(ts.createReturn(createDefaultSuperCallOrThis()));
	                return 2 /* ReplaceWithReturn */;
	            }
	            // The constructor exists, but it and the 'super()' call it contains were generated
	            // for something like property initializers.
	            // Create a captured '_this' variable and assume it will subsequently be used.
	            if (hasSynthesizedSuper) {
	                captureThisForNode(statements, ctor, createDefaultSuperCallOrThis());
	                enableSubstitutionsForCapturedThis();
	                return 1 /* ReplaceSuperCapture */;
	            }
	            // Most of the time, a 'super' call will be the first real statement in a constructor body.
	            // In these cases, we'd like to transform these into a *single* statement instead of a declaration
	            // followed by an assignment statement for '_this'. For instance, if we emitted without an initializer,
	            // we'd get:
	            //
	            //      var _this;
	            //      _this = _super.call(...) || this;
	            //
	            // instead of
	            //
	            //      var _this = _super.call(...) || this;
	            //
	            // Additionally, if the 'super()' call is the last statement, we should just avoid capturing
	            // entirely and immediately return the result like so:
	            //
	            //      return _super.call(...) || this;
	            //
	            var firstStatement;
	            var superCallExpression;
	            var ctorStatements = ctor.body.statements;
	            if (statementOffset < ctorStatements.length) {
	                firstStatement = ctorStatements[statementOffset];
	                if (firstStatement.kind === 215 /* ExpressionStatement */ && ts.isSuperCall(firstStatement.expression)) {
	                    superCallExpression = visitImmediateSuperCallInBody(firstStatement.expression);
	                }
	            }
	            // Return the result if we have an immediate super() call on the last statement,
	            // but only if the constructor itself doesn't use 'this' elsewhere.
	            if (superCallExpression
	                && statementOffset === ctorStatements.length - 1
	                && !(ctor.transformFlags & (16384 /* ContainsLexicalThis */ | 32768 /* ContainsCapturedLexicalThis */))) {
	                var returnStatement = ts.createReturn(superCallExpression);
	                if (superCallExpression.kind !== 199 /* BinaryExpression */
	                    || superCallExpression.left.kind !== 186 /* CallExpression */) {
	                    ts.Debug.fail("Assumed generated super call would have form 'super.call(...) || this'.");
	                }
	                // Shift comments from the original super call to the return statement.
	                ts.setCommentRange(returnStatement, ts.getCommentRange(ts.setEmitFlags(superCallExpression.left, 1536 /* NoComments */)));
	                statements.push(returnStatement);
	                return 2 /* ReplaceWithReturn */;
	            }
	            // Perform the capture.
	            captureThisForNode(statements, ctor, superCallExpression || createActualThis(), firstStatement);
	            // If we're actually replacing the original statement, we need to signal this to the caller.
	            if (superCallExpression) {
	                return 1 /* ReplaceSuperCapture */;
	            }
	            return 0 /* NoReplacement */;
	        }
	        function createActualThis() {
	            return ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */);
	        }
	        function createDefaultSuperCallOrThis() {
	            return ts.createLogicalOr(ts.createLogicalAnd(ts.createStrictInequality(ts.createFileLevelUniqueName("_super"), ts.createNull()), ts.createFunctionApply(ts.createFileLevelUniqueName("_super"), createActualThis(), ts.createIdentifier("arguments"))), createActualThis());
	        }
	        /**
	         * Visits a parameter declaration.
	         *
	         * @param node A ParameterDeclaration node.
	         */
	        function visitParameter(node) {
	            if (node.dotDotDotToken) {
	                // rest parameters are elided
	                return undefined;
	            }
	            else if (ts.isBindingPattern(node.name)) {
	                // Binding patterns are converted into a generated name and are
	                // evaluated inside the function body.
	                return ts.setOriginalNode(ts.setTextRange(ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, ts.getGeneratedNameForNode(node), 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, 
	                /*initializer*/ undefined), 
	                /*location*/ node), 
	                /*original*/ node);
	            }
	            else if (node.initializer) {
	                // Initializers are elided
	                return ts.setOriginalNode(ts.setTextRange(ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, node.name, 
	                /*questionToken*/ undefined, 
	                /*type*/ undefined, 
	                /*initializer*/ undefined), 
	                /*location*/ node), 
	                /*original*/ node);
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Gets a value indicating whether we need to add default value assignments for a
	         * function-like node.
	         *
	         * @param node A function-like node.
	         */
	        function shouldAddDefaultValueAssignments(node) {
	            return (node.transformFlags & 131072 /* ContainsDefaultValueAssignments */) !== 0;
	        }
	        /**
	         * Adds statements to the body of a function-like node if it contains parameters with
	         * binding patterns or initializers.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A function-like node.
	         */
	        function addDefaultValueAssignmentsIfNeeded(statements, node) {
	            if (!shouldAddDefaultValueAssignments(node)) {
	                return;
	            }
	            for (var _i = 0, _a = node.parameters; _i < _a.length; _i++) {
	                var parameter = _a[_i];
	                var name = parameter.name, initializer = parameter.initializer, dotDotDotToken = parameter.dotDotDotToken;
	                // A rest parameter cannot have a binding pattern or an initializer,
	                // so let's just ignore it.
	                if (dotDotDotToken) {
	                    continue;
	                }
	                if (ts.isBindingPattern(name)) {
	                    addDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer);
	                }
	                else if (initializer) {
	                    addDefaultValueAssignmentForInitializer(statements, parameter, name, initializer);
	                }
	            }
	        }
	        /**
	         * Adds statements to the body of a function-like node for parameters with binding patterns
	         *
	         * @param statements The statements for the new function body.
	         * @param parameter The parameter for the function.
	         * @param name The name of the parameter.
	         * @param initializer The initializer for the parameter.
	         */
	        function addDefaultValueAssignmentForBindingPattern(statements, parameter, name, initializer) {
	            var temp = ts.getGeneratedNameForNode(parameter);
	            // In cases where a binding pattern is simply '[]' or '{}',
	            // we usually don't want to emit a var declaration; however, in the presence
	            // of an initializer, we must emit that expression to preserve side effects.
	            if (name.elements.length > 0) {
	                statements.push(ts.setEmitFlags(ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList(ts.flattenDestructuringBinding(parameter, visitor, context, 0 /* All */, temp))), 1048576 /* CustomPrologue */));
	            }
	            else if (initializer) {
	                statements.push(ts.setEmitFlags(ts.createStatement(ts.createAssignment(temp, ts.visitNode(initializer, visitor, ts.isExpression))), 1048576 /* CustomPrologue */));
	            }
	        }
	        /**
	         * Adds statements to the body of a function-like node for parameters with initializers.
	         *
	         * @param statements The statements for the new function body.
	         * @param parameter The parameter for the function.
	         * @param name The name of the parameter.
	         * @param initializer The initializer for the parameter.
	         */
	        function addDefaultValueAssignmentForInitializer(statements, parameter, name, initializer) {
	            initializer = ts.visitNode(initializer, visitor, ts.isExpression);
	            var statement = ts.createIf(ts.createTypeCheck(ts.getSynthesizedClone(name), "undefined"), ts.setEmitFlags(ts.setTextRange(ts.createBlock([
	                ts.createStatement(ts.setEmitFlags(ts.setTextRange(ts.createAssignment(ts.setEmitFlags(ts.getMutableClone(name), 48 /* NoSourceMap */), ts.setEmitFlags(initializer, 48 /* NoSourceMap */ | ts.getEmitFlags(initializer) | 1536 /* NoComments */)), parameter), 1536 /* NoComments */))
	            ]), parameter), 1 /* SingleLine */ | 32 /* NoTrailingSourceMap */ | 384 /* NoTokenSourceMaps */ | 1536 /* NoComments */));
	            ts.startOnNewLine(statement);
	            ts.setTextRange(statement, parameter);
	            ts.setEmitFlags(statement, 384 /* NoTokenSourceMaps */ | 32 /* NoTrailingSourceMap */ | 1048576 /* CustomPrologue */ | 1536 /* NoComments */);
	            statements.push(statement);
	        }
	        /**
	         * Gets a value indicating whether we need to add statements to handle a rest parameter.
	         *
	         * @param node A ParameterDeclaration node.
	         * @param inConstructorWithSynthesizedSuper A value indicating whether the parameter is
	         *                                          part of a constructor declaration with a
	         *                                          synthesized call to `super`
	         */
	        function shouldAddRestParameter(node, inConstructorWithSynthesizedSuper) {
	            return node && node.dotDotDotToken && node.name.kind === 71 /* Identifier */ && !inConstructorWithSynthesizedSuper;
	        }
	        /**
	         * Adds statements to the body of a function-like node if it contains a rest parameter.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A function-like node.
	         * @param inConstructorWithSynthesizedSuper A value indicating whether the parameter is
	         *                                          part of a constructor declaration with a
	         *                                          synthesized call to `super`
	         */
	        function addRestParameterIfNeeded(statements, node, inConstructorWithSynthesizedSuper) {
	            var parameter = ts.lastOrUndefined(node.parameters);
	            if (!shouldAddRestParameter(parameter, inConstructorWithSynthesizedSuper)) {
	                return;
	            }
	            // `declarationName` is the name of the local declaration for the parameter.
	            var declarationName = ts.getMutableClone(parameter.name);
	            ts.setEmitFlags(declarationName, 48 /* NoSourceMap */);
	            // `expressionName` is the name of the parameter used in expressions.
	            var expressionName = ts.getSynthesizedClone(parameter.name);
	            var restIndex = node.parameters.length - 1;
	            var temp = ts.createLoopVariable();
	            // var param = [];
	            statements.push(ts.setEmitFlags(ts.setTextRange(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(declarationName, 
	                /*type*/ undefined, ts.createArrayLiteral([]))
	            ])), 
	            /*location*/ parameter), 1048576 /* CustomPrologue */));
	            // for (var _i = restIndex; _i < arguments.length; _i++) {
	            //   param[_i - restIndex] = arguments[_i];
	            // }
	            var forStatement = ts.createFor(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(temp, /*type*/ undefined, ts.createLiteral(restIndex))
	            ]), parameter), ts.setTextRange(ts.createLessThan(temp, ts.createPropertyAccess(ts.createIdentifier("arguments"), "length")), parameter), ts.setTextRange(ts.createPostfixIncrement(temp), parameter), ts.createBlock([
	                ts.startOnNewLine(ts.setTextRange(ts.createStatement(ts.createAssignment(ts.createElementAccess(expressionName, restIndex === 0
	                    ? temp
	                    : ts.createSubtract(temp, ts.createLiteral(restIndex))), ts.createElementAccess(ts.createIdentifier("arguments"), temp))), 
	                /*location*/ parameter))
	            ]));
	            ts.setEmitFlags(forStatement, 1048576 /* CustomPrologue */);
	            ts.startOnNewLine(forStatement);
	            statements.push(forStatement);
	        }
	        /**
	         * Adds a statement to capture the `this` of a function declaration if it is needed.
	         *
	         * @param statements The statements for the new function body.
	         * @param node A node.
	         */
	        function addCaptureThisForNodeIfNeeded(statements, node) {
	            if (node.transformFlags & 32768 /* ContainsCapturedLexicalThis */ && node.kind !== 192 /* ArrowFunction */) {
	                captureThisForNode(statements, node, ts.createThis());
	            }
	        }
	        function captureThisForNode(statements, node, initializer, originalStatement) {
	            enableSubstitutionsForCapturedThis();
	            var captureThisStatement = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(ts.createFileLevelUniqueName("_this"), 
	                /*type*/ undefined, initializer)
	            ]));
	            ts.setEmitFlags(captureThisStatement, 1536 /* NoComments */ | 1048576 /* CustomPrologue */);
	            ts.setTextRange(captureThisStatement, originalStatement);
	            ts.setSourceMapRange(captureThisStatement, node);
	            statements.push(captureThisStatement);
	        }
	        function prependCaptureNewTargetIfNeeded(statements, node, copyOnWrite) {
	            if (hierarchyFacts & 16384 /* NewTarget */) {
	                var newTarget = void 0;
	                switch (node.kind) {
	                    case 192 /* ArrowFunction */:
	                        return statements;
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        // Methods and accessors cannot be constructors, so 'new.target' will
	                        // always return 'undefined'.
	                        newTarget = ts.createVoidZero();
	                        break;
	                    case 154 /* Constructor */:
	                        // Class constructors can only be called with `new`, so `this.constructor`
	                        // should be relatively safe to use.
	                        newTarget = ts.createPropertyAccess(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), "constructor");
	                        break;
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                        // Functions can be called or constructed, and may have a `this` due to
	                        // being a member or when calling an imported function via `other_1.f()`.
	                        newTarget = ts.createConditional(ts.createLogicalAnd(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), ts.createBinary(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), 93 /* InstanceOfKeyword */, ts.getLocalName(node))), ts.createPropertyAccess(ts.setEmitFlags(ts.createThis(), 4 /* NoSubstitution */), "constructor"), ts.createVoidZero());
	                        break;
	                    default:
	                        return ts.Debug.failBadSyntaxKind(node);
	                }
	                var captureNewTargetStatement = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(ts.createFileLevelUniqueName("_newTarget"), 
	                    /*type*/ undefined, newTarget)
	                ]));
	                if (copyOnWrite) {
	                    return [captureNewTargetStatement].concat(statements);
	                }
	                statements.unshift(captureNewTargetStatement);
	            }
	            return statements;
	        }
	        /**
	         * Adds statements to the class body function for a class to define the members of the
	         * class.
	         *
	         * @param statements The statements for the class body function.
	         * @param node The ClassExpression or ClassDeclaration node.
	         */
	        function addClassMembers(statements, node) {
	            for (var _i = 0, _a = node.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                switch (member.kind) {
	                    case 211 /* SemicolonClassElement */:
	                        statements.push(transformSemicolonClassElementToStatement(member));
	                        break;
	                    case 153 /* MethodDeclaration */:
	                        statements.push(transformClassMethodDeclarationToStatement(getClassMemberPrefix(node, member), member, node));
	                        break;
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        var accessors = ts.getAllAccessorDeclarations(node.members, member);
	                        if (member === accessors.firstAccessor) {
	                            statements.push(transformAccessorsToStatement(getClassMemberPrefix(node, member), accessors, node));
	                        }
	                        break;
	                    case 154 /* Constructor */:
	                        // Constructors are handled in visitClassExpression/visitClassDeclaration
	                        break;
	                    default:
	                        ts.Debug.failBadSyntaxKind(node);
	                        break;
	                }
	            }
	        }
	        /**
	         * Transforms a SemicolonClassElement into a statement for a class body function.
	         *
	         * @param member The SemicolonClassElement node.
	         */
	        function transformSemicolonClassElementToStatement(member) {
	            return ts.setTextRange(ts.createEmptyStatement(), member);
	        }
	        /**
	         * Transforms a MethodDeclaration into a statement for a class body function.
	         *
	         * @param receiver The receiver for the member.
	         * @param member The MethodDeclaration node.
	         */
	        function transformClassMethodDeclarationToStatement(receiver, member, container) {
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            var commentRange = ts.getCommentRange(member);
	            var sourceMapRange = ts.getSourceMapRange(member);
	            var memberName = ts.createMemberAccessForPropertyName(receiver, ts.visitNode(member.name, visitor, ts.isPropertyName), /*location*/ member.name);
	            var memberFunction = transformFunctionLikeToExpression(member, /*location*/ member, /*name*/ undefined, container);
	            ts.setEmitFlags(memberFunction, 1536 /* NoComments */);
	            ts.setSourceMapRange(memberFunction, sourceMapRange);
	            var statement = ts.setTextRange(ts.createStatement(ts.createAssignment(memberName, memberFunction)), 
	            /*location*/ member);
	            ts.setOriginalNode(statement, member);
	            ts.setCommentRange(statement, commentRange);
	            // The location for the statement is used to emit comments only.
	            // No source map should be emitted for this statement to align with the
	            // old emitter.
	            ts.setEmitFlags(statement, 48 /* NoSourceMap */);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return statement;
	        }
	        /**
	         * Transforms a set of related of get/set accessors into a statement for a class body function.
	         *
	         * @param receiver The receiver for the member.
	         * @param accessors The set of related get/set accessors.
	         */
	        function transformAccessorsToStatement(receiver, accessors, container) {
	            var statement = ts.createStatement(transformAccessorsToExpression(receiver, accessors, container, /*startsOnNewLine*/ false));
	            // The location for the statement is used to emit source maps only.
	            // No comments should be emitted for this statement to align with the
	            // old emitter.
	            ts.setEmitFlags(statement, 1536 /* NoComments */);
	            ts.setSourceMapRange(statement, ts.getSourceMapRange(accessors.firstAccessor));
	            return statement;
	        }
	        /**
	         * Transforms a set of related get/set accessors into an expression for either a class
	         * body function or an ObjectLiteralExpression with computed properties.
	         *
	         * @param receiver The receiver for the member.
	         */
	        function transformAccessorsToExpression(receiver, _a, container, startsOnNewLine) {
	            var firstAccessor = _a.firstAccessor, getAccessor = _a.getAccessor, setAccessor = _a.setAccessor;
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            // To align with source maps in the old emitter, the receiver and property name
	            // arguments are both mapped contiguously to the accessor name.
	            var target = ts.getMutableClone(receiver);
	            ts.setEmitFlags(target, 1536 /* NoComments */ | 32 /* NoTrailingSourceMap */);
	            ts.setSourceMapRange(target, firstAccessor.name);
	            var propertyName = ts.createExpressionForPropertyName(ts.visitNode(firstAccessor.name, visitor, ts.isPropertyName));
	            ts.setEmitFlags(propertyName, 1536 /* NoComments */ | 16 /* NoLeadingSourceMap */);
	            ts.setSourceMapRange(propertyName, firstAccessor.name);
	            var properties = [];
	            if (getAccessor) {
	                var getterFunction = transformFunctionLikeToExpression(getAccessor, /*location*/ undefined, /*name*/ undefined, container);
	                ts.setSourceMapRange(getterFunction, ts.getSourceMapRange(getAccessor));
	                ts.setEmitFlags(getterFunction, 512 /* NoLeadingComments */);
	                var getter = ts.createPropertyAssignment("get", getterFunction);
	                ts.setCommentRange(getter, ts.getCommentRange(getAccessor));
	                properties.push(getter);
	            }
	            if (setAccessor) {
	                var setterFunction = transformFunctionLikeToExpression(setAccessor, /*location*/ undefined, /*name*/ undefined, container);
	                ts.setSourceMapRange(setterFunction, ts.getSourceMapRange(setAccessor));
	                ts.setEmitFlags(setterFunction, 512 /* NoLeadingComments */);
	                var setter = ts.createPropertyAssignment("set", setterFunction);
	                ts.setCommentRange(setter, ts.getCommentRange(setAccessor));
	                properties.push(setter);
	            }
	            properties.push(ts.createPropertyAssignment("enumerable", ts.createTrue()), ts.createPropertyAssignment("configurable", ts.createTrue()));
	            var call = ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	            /*typeArguments*/ undefined, [
	                target,
	                propertyName,
	                ts.createObjectLiteral(properties, /*multiLine*/ true)
	            ]);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(call);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return call;
	        }
	        /**
	         * Visits an ArrowFunction and transforms it into a FunctionExpression.
	         *
	         * @param node An ArrowFunction node.
	         */
	        function visitArrowFunction(node) {
	            if (node.transformFlags & 16384 /* ContainsLexicalThis */) {
	                enableSubstitutionsForCapturedThis();
	            }
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16256 /* ArrowFunctionExcludes */, 66 /* ArrowFunctionIncludes */);
	            var func = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	            /*type*/ undefined, transformFunctionBody(node));
	            ts.setTextRange(func, node);
	            ts.setOriginalNode(func, node);
	            ts.setEmitFlags(func, 8 /* CapturesThis */);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return func;
	        }
	        /**
	         * Visits a FunctionExpression node.
	         *
	         * @param node a FunctionExpression node.
	         */
	        function visitFunctionExpression(node) {
	            var ancestorFacts = ts.getEmitFlags(node) & 262144 /* AsyncFunctionBody */
	                ? enterSubtree(16278 /* AsyncFunctionBodyExcludes */, 69 /* AsyncFunctionBodyIncludes */)
	                : enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = node.transformFlags & 64 /* ES2015 */
	                ? transformFunctionBody(node)
	                : visitFunctionBodyDownLevel(node);
	            var name = hierarchyFacts & 16384 /* NewTarget */
	                ? ts.getLocalName(node)
	                : node.name;
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.updateFunctionExpression(node, 
	            /*modifiers*/ undefined, node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body);
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * @param node a FunctionDeclaration node.
	         */
	        function visitFunctionDeclaration(node) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = node.transformFlags & 64 /* ES2015 */
	                ? transformFunctionBody(node)
	                : visitFunctionBodyDownLevel(node);
	            var name = hierarchyFacts & 16384 /* NewTarget */
	                ? ts.getLocalName(node)
	                : node.name;
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.updateFunctionDeclaration(node, 
	            /*decorators*/ undefined, ts.visitNodes(node.modifiers, visitor, ts.isModifier), node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body);
	        }
	        /**
	         * Transforms a function-like node into a FunctionExpression.
	         *
	         * @param node The function-like node to transform.
	         * @param location The source-map location for the new FunctionExpression.
	         * @param name The name of the new FunctionExpression.
	         */
	        function transformFunctionLikeToExpression(node, location, name, container) {
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = container && ts.isClassLike(container) && !ts.hasModifier(node, 32 /* Static */)
	                ? enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */ | 8 /* NonStaticClassElement */)
	                : enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = transformFunctionBody(node);
	            if (hierarchyFacts & 16384 /* NewTarget */ && !name && (node.kind === 233 /* FunctionDeclaration */ || node.kind === 191 /* FunctionExpression */)) {
	                name = ts.getGeneratedNameForNode(node);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(
	            /*modifiers*/ undefined, node.asteriskToken, name, 
	            /*typeParameters*/ undefined, parameters, 
	            /*type*/ undefined, body), location), 
	            /*original*/ node);
	        }
	        /**
	         * Transforms the body of a function-like node.
	         *
	         * @param node A function-like node.
	         */
	        function transformFunctionBody(node) {
	            var multiLine = false; // indicates whether the block *must* be emitted as multiple lines
	            var singleLine = false; // indicates whether the block *may* be emitted as a single line
	            var statementsLocation;
	            var closeBraceLocation;
	            var leadingStatements = [];
	            var statements = [];
	            var body = node.body;
	            var statementOffset;
	            resumeLexicalEnvironment();
	            if (ts.isBlock(body)) {
	                // ensureUseStrict is false because no new prologue-directive should be added.
	                // addStandardPrologue will put already-existing directives at the beginning of the target statement-array
	                statementOffset = ts.addStandardPrologue(leadingStatements, body.statements, /*ensureUseStrict*/ false);
	            }
	            addCaptureThisForNodeIfNeeded(leadingStatements, node);
	            addDefaultValueAssignmentsIfNeeded(leadingStatements, node);
	            addRestParameterIfNeeded(leadingStatements, node, /*inConstructorWithSynthesizedSuper*/ false);
	            if (ts.isBlock(body)) {
	                // addCustomPrologue puts already-existing directives at the beginning of the target statement-array
	                statementOffset = ts.addCustomPrologue(leadingStatements, body.statements, statementOffset, visitor);
	                statementsLocation = body.statements;
	                ts.addRange(statements, ts.visitNodes(body.statements, visitor, ts.isStatement, statementOffset));
	                // If the original body was a multi-line block, this must be a multi-line block.
	                if (!multiLine && body.multiLine) {
	                    multiLine = true;
	                }
	            }
	            else {
	                ts.Debug.assert(node.kind === 192 /* ArrowFunction */);
	                // To align with the old emitter, we use a synthetic end position on the location
	                // for the statement list we synthesize when we down-level an arrow function with
	                // an expression function body. This prevents both comments and source maps from
	                // being emitted for the end position only.
	                statementsLocation = ts.moveRangeEnd(body, -1);
	                var equalsGreaterThanToken = node.equalsGreaterThanToken;
	                if (!ts.nodeIsSynthesized(equalsGreaterThanToken) && !ts.nodeIsSynthesized(body)) {
	                    if (ts.rangeEndIsOnSameLineAsRangeStart(equalsGreaterThanToken, body, currentSourceFile)) {
	                        singleLine = true;
	                    }
	                    else {
	                        multiLine = true;
	                    }
	                }
	                var expression = ts.visitNode(body, visitor, ts.isExpression);
	                var returnStatement = ts.createReturn(expression);
	                ts.setTextRange(returnStatement, body);
	                ts.moveSyntheticComments(returnStatement, body);
	                ts.setEmitFlags(returnStatement, 384 /* NoTokenSourceMaps */ | 32 /* NoTrailingSourceMap */ | 1024 /* NoTrailingComments */);
	                statements.push(returnStatement);
	                // To align with the source map emit for the old emitter, we set a custom
	                // source map location for the close brace.
	                closeBraceLocation = body;
	            }
	            var lexicalEnvironment = context.endLexicalEnvironment();
	            ts.prependStatements(statements, lexicalEnvironment);
	            prependCaptureNewTargetIfNeeded(statements, node, /*copyOnWrite*/ false);
	            // If we added any final generated statements, this must be a multi-line block
	            if (ts.some(leadingStatements) || ts.some(lexicalEnvironment)) {
	                multiLine = true;
	            }
	            var block = ts.createBlock(ts.setTextRange(ts.createNodeArray(leadingStatements.concat(statements)), statementsLocation), multiLine);
	            ts.setTextRange(block, node.body);
	            if (!multiLine && singleLine) {
	                ts.setEmitFlags(block, 1 /* SingleLine */);
	            }
	            if (closeBraceLocation) {
	                ts.setTokenSourceMapRange(block, 18 /* CloseBraceToken */, closeBraceLocation);
	            }
	            ts.setOriginalNode(block, node.body);
	            return block;
	        }
	        function visitFunctionBodyDownLevel(node) {
	            var updated = ts.visitFunctionBody(node.body, functionBodyVisitor, context);
	            return ts.updateBlock(updated, ts.setTextRange(ts.createNodeArray(prependCaptureNewTargetIfNeeded(updated.statements, node, /*copyOnWrite*/ true)), 
	            /*location*/ updated.statements));
	        }
	        function visitBlock(node, isFunctionBody) {
	            if (isFunctionBody) {
	                // A function body is not a block scope.
	                return ts.visitEachChild(node, visitor, context);
	            }
	            var ancestorFacts = hierarchyFacts & 256 /* IterationStatement */
	                ? enterSubtree(4032 /* IterationStatementBlockExcludes */, 512 /* IterationStatementBlockIncludes */)
	                : enterSubtree(3904 /* BlockExcludes */, 128 /* BlockIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits an ExpressionStatement that contains a destructuring assignment.
	         *
	         * @param node An ExpressionStatement node.
	         */
	        function visitExpressionStatement(node) {
	            // If we are here it is most likely because our expression is a destructuring assignment.
	            switch (node.expression.kind) {
	                case 190 /* ParenthesizedExpression */:
	                    return ts.updateStatement(node, visitParenthesizedExpression(node.expression, /*needsDestructuringValue*/ false));
	                case 199 /* BinaryExpression */:
	                    return ts.updateStatement(node, visitBinaryExpression(node.expression, /*needsDestructuringValue*/ false));
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a ParenthesizedExpression that may contain a destructuring assignment.
	         *
	         * @param node A ParenthesizedExpression node.
	         * @param needsDestructuringValue A value indicating whether we need to hold onto the rhs
	         *                                of a destructuring assignment.
	         */
	        function visitParenthesizedExpression(node, needsDestructuringValue) {
	            // If we are here it is most likely because our expression is a destructuring assignment.
	            if (!needsDestructuringValue) {
	                // By default we always emit the RHS at the end of a flattened destructuring
	                // expression. If we are in a state where we do not need the destructuring value,
	                // we pass that information along to the children that care about it.
	                switch (node.expression.kind) {
	                    case 190 /* ParenthesizedExpression */:
	                        return ts.updateParen(node, visitParenthesizedExpression(node.expression, /*needsDestructuringValue*/ false));
	                    case 199 /* BinaryExpression */:
	                        return ts.updateParen(node, visitBinaryExpression(node.expression, /*needsDestructuringValue*/ false));
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a BinaryExpression that contains a destructuring assignment.
	         *
	         * @param node A BinaryExpression node.
	         * @param needsDestructuringValue A value indicating whether we need to hold onto the rhs
	         *                                of a destructuring assignment.
	         */
	        function visitBinaryExpression(node, needsDestructuringValue) {
	            // If we are here it is because this is a destructuring assignment.
	            if (ts.isDestructuringAssignment(node)) {
	                return ts.flattenDestructuringAssignment(node, visitor, context, 0 /* All */, needsDestructuringValue);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitVariableStatement(node) {
	            var ancestorFacts = enterSubtree(0 /* None */, ts.hasModifier(node, 1 /* Export */) ? 32 /* ExportedVariableStatement */ : 0 /* None */);
	            var updated;
	            if (convertedLoopState && (node.declarationList.flags & 3 /* BlockScoped */) === 0) {
	                // we are inside a converted loop - hoist variable declarations
	                var assignments = void 0;
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    hoistVariableDeclarationDeclaredInConvertedLoop(convertedLoopState, decl);
	                    if (decl.initializer) {
	                        var assignment = void 0;
	                        if (ts.isBindingPattern(decl.name)) {
	                            assignment = ts.flattenDestructuringAssignment(decl, visitor, context, 0 /* All */);
	                        }
	                        else {
	                            assignment = ts.createBinary(decl.name, 58 /* EqualsToken */, ts.visitNode(decl.initializer, visitor, ts.isExpression));
	                            ts.setTextRange(assignment, decl);
	                        }
	                        assignments = ts.append(assignments, assignment);
	                    }
	                }
	                if (assignments) {
	                    updated = ts.setTextRange(ts.createStatement(ts.inlineExpressions(assignments)), node);
	                }
	                else {
	                    // none of declarations has initializer - the entire variable statement can be deleted
	                    updated = undefined;
	                }
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits a VariableDeclarationList that is block scoped (e.g. `let` or `const`).
	         *
	         * @param node A VariableDeclarationList node.
	         */
	        function visitVariableDeclarationList(node) {
	            if (node.transformFlags & 64 /* ES2015 */) {
	                if (node.flags & 3 /* BlockScoped */) {
	                    enableSubstitutionsForBlockScopedBindings();
	                }
	                var declarations = ts.flatMap(node.declarations, node.flags & 1 /* Let */
	                    ? visitVariableDeclarationInLetDeclarationList
	                    : visitVariableDeclaration);
	                var declarationList = ts.createVariableDeclarationList(declarations);
	                ts.setOriginalNode(declarationList, node);
	                ts.setTextRange(declarationList, node);
	                ts.setCommentRange(declarationList, node);
	                if (node.transformFlags & 8388608 /* ContainsBindingPattern */
	                    && (ts.isBindingPattern(node.declarations[0].name) || ts.isBindingPattern(ts.lastOrUndefined(node.declarations).name))) {
	                    // If the first or last declaration is a binding pattern, we need to modify
	                    // the source map range for the declaration list.
	                    var firstDeclaration = ts.firstOrUndefined(declarations);
	                    if (firstDeclaration) {
	                        var lastDeclaration = ts.lastOrUndefined(declarations);
	                        ts.setSourceMapRange(declarationList, ts.createRange(firstDeclaration.pos, lastDeclaration.end));
	                    }
	                }
	                return declarationList;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Gets a value indicating whether we should emit an explicit initializer for a variable
	         * declaration in a `let` declaration list.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function shouldEmitExplicitInitializerForLetDeclaration(node) {
	            // Nested let bindings might need to be initialized explicitly to preserve
	            // ES6 semantic:
	            //
	            //  { let x = 1; }
	            //  { let x; } // x here should be undefined. not 1
	            //
	            // Top level bindings never collide with anything and thus don't require
	            // explicit initialization. As for nested let bindings there are two cases:
	            //
	            // - Nested let bindings that were not renamed definitely should be
	            //   initialized explicitly:
	            //
	            //    { let x = 1; }
	            //    { let x; if (some-condition) { x = 1}; if (x) { /*1*/ } }
	            //
	            //   Without explicit initialization code in /*1*/ can be executed even if
	            //   some-condition is evaluated to false.
	            //
	            // - Renaming introduces fresh name that should not collide with any
	            //   existing names, however renamed bindings sometimes also should be
	            //   explicitly initialized. One particular case: non-captured binding
	            //   declared inside loop body (but not in loop initializer):
	            //
	            //    let x;
	            //    for (;;) {
	            //        let x;
	            //    }
	            //
	            //   In downlevel codegen inner 'x' will be renamed so it won't collide
	            //   with outer 'x' however it will should be reset on every iteration as
	            //   if it was declared anew.
	            //
	            //   * Why non-captured binding?
	            //     - Because if loop contains block scoped binding captured in some
	            //       function then loop body will be rewritten to have a fresh scope
	            //       on every iteration so everything will just work.
	            //
	            //   * Why loop initializer is excluded?
	            //     - Since we've introduced a fresh name it already will be undefined.
	            var flags = resolver.getNodeCheckFlags(node);
	            var isCapturedInFunction = flags & 131072 /* CapturedBlockScopedBinding */;
	            var isDeclaredInLoop = flags & 262144 /* BlockScopedBindingInLoop */;
	            var emittedAsTopLevel = (hierarchyFacts & 64 /* TopLevel */) !== 0
	                || (isCapturedInFunction
	                    && isDeclaredInLoop
	                    && (hierarchyFacts & 512 /* IterationStatementBlock */) !== 0);
	            var emitExplicitInitializer = !emittedAsTopLevel
	                && (hierarchyFacts & 2048 /* ForInOrForOfStatement */) === 0
	                && (!resolver.isDeclarationWithCollidingName(node)
	                    || (isDeclaredInLoop
	                        && !isCapturedInFunction
	                        && (hierarchyFacts & (1024 /* ForStatement */ | 2048 /* ForInOrForOfStatement */)) === 0));
	            return emitExplicitInitializer;
	        }
	        /**
	         * Visits a VariableDeclaration in a `let` declaration list.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclarationInLetDeclarationList(node) {
	            // For binding pattern names that lack initializers there is no point to emit
	            // explicit initializer since downlevel codegen for destructuring will fail
	            // in the absence of initializer so all binding elements will say uninitialized
	            var name = node.name;
	            if (ts.isBindingPattern(name)) {
	                return visitVariableDeclaration(node);
	            }
	            if (!node.initializer && shouldEmitExplicitInitializerForLetDeclaration(node)) {
	                var clone_2 = ts.getMutableClone(node);
	                clone_2.initializer = ts.createVoidZero();
	                return clone_2;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a VariableDeclaration node with a binding pattern.
	         *
	         * @param node A VariableDeclaration node.
	         */
	        function visitVariableDeclaration(node) {
	            var ancestorFacts = enterSubtree(32 /* ExportedVariableStatement */, 0 /* None */);
	            var updated;
	            if (ts.isBindingPattern(node.name)) {
	                updated = ts.flattenDestructuringBinding(node, visitor, context, 0 /* All */, 
	                /*value*/ undefined, (ancestorFacts & 32 /* ExportedVariableStatement */) !== 0);
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function recordLabel(node) {
	            convertedLoopState.labels.set(ts.idText(node.label), true);
	        }
	        function resetLabel(node) {
	            convertedLoopState.labels.set(ts.idText(node.label), false);
	        }
	        function visitLabeledStatement(node) {
	            if (convertedLoopState && !convertedLoopState.labels) {
	                convertedLoopState.labels = ts.createMap();
	            }
	            var statement = ts.unwrapInnermostStatementOfLabel(node, convertedLoopState && recordLabel);
	            return ts.isIterationStatement(statement, /*lookInLabeledStatements*/ false)
	                ? visitIterationStatement(statement, /*outermostLabeledStatement*/ node)
	                : ts.restoreEnclosingLabel(ts.visitNode(statement, visitor, ts.isStatement), node, convertedLoopState && resetLabel);
	        }
	        function visitIterationStatement(node, outermostLabeledStatement) {
	            switch (node.kind) {
	                case 217 /* DoStatement */:
	                case 218 /* WhileStatement */:
	                    return visitDoOrWhileStatement(node, outermostLabeledStatement);
	                case 219 /* ForStatement */:
	                    return visitForStatement(node, outermostLabeledStatement);
	                case 220 /* ForInStatement */:
	                    return visitForInStatement(node, outermostLabeledStatement);
	                case 221 /* ForOfStatement */:
	                    return visitForOfStatement(node, outermostLabeledStatement);
	            }
	        }
	        function visitIterationStatementWithFacts(excludeFacts, includeFacts, node, outermostLabeledStatement, convert) {
	            var ancestorFacts = enterSubtree(excludeFacts, includeFacts);
	            var updated = convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, convert);
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function visitDoOrWhileStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(0 /* DoOrWhileStatementExcludes */, 256 /* DoOrWhileStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(3008 /* ForStatementExcludes */, 1280 /* ForStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForInStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(1984 /* ForInOrForOfStatementExcludes */, 2304 /* ForInOrForOfStatementIncludes */, node, outermostLabeledStatement);
	        }
	        function visitForOfStatement(node, outermostLabeledStatement) {
	            return visitIterationStatementWithFacts(1984 /* ForInOrForOfStatementExcludes */, 2304 /* ForInOrForOfStatementIncludes */, node, outermostLabeledStatement, compilerOptions.downlevelIteration ? convertForOfStatementForIterable : convertForOfStatementForArray);
	        }
	        function convertForOfStatementHead(node, boundValue, convertedLoopBodyStatements) {
	            var statements = [];
	            if (ts.isVariableDeclarationList(node.initializer)) {
	                if (node.initializer.flags & 3 /* BlockScoped */) {
	                    enableSubstitutionsForBlockScopedBindings();
	                }
	                var firstOriginalDeclaration = ts.firstOrUndefined(node.initializer.declarations);
	                if (firstOriginalDeclaration && ts.isBindingPattern(firstOriginalDeclaration.name)) {
	                    // This works whether the declaration is a var, let, or const.
	                    // It will use rhsIterationValue _a[_i] as the initializer.
	                    var declarations = ts.flattenDestructuringBinding(firstOriginalDeclaration, visitor, context, 0 /* All */, boundValue);
	                    var declarationList = ts.setTextRange(ts.createVariableDeclarationList(declarations), node.initializer);
	                    ts.setOriginalNode(declarationList, node.initializer);
	                    // Adjust the source map range for the first declaration to align with the old
	                    // emitter.
	                    var firstDeclaration = declarations[0];
	                    var lastDeclaration = ts.lastOrUndefined(declarations);
	                    ts.setSourceMapRange(declarationList, ts.createRange(firstDeclaration.pos, lastDeclaration.end));
	                    statements.push(ts.createVariableStatement(
	                    /*modifiers*/ undefined, declarationList));
	                }
	                else {
	                    // The following call does not include the initializer, so we have
	                    // to emit it separately.
	                    statements.push(ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.setOriginalNode(ts.setTextRange(ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(firstOriginalDeclaration ? firstOriginalDeclaration.name : ts.createTempVariable(/*recordTempVariable*/ undefined), 
	                        /*type*/ undefined, boundValue)
	                    ]), ts.moveRangePos(node.initializer, -1)), node.initializer)), ts.moveRangeEnd(node.initializer, -1)));
	                }
	            }
	            else {
	                // Initializer is an expression. Emit the expression in the body, so that it's
	                // evaluated on every iteration.
	                var assignment = ts.createAssignment(node.initializer, boundValue);
	                if (ts.isDestructuringAssignment(assignment)) {
	                    ts.aggregateTransformFlags(assignment);
	                    statements.push(ts.createStatement(visitBinaryExpression(assignment, /*needsDestructuringValue*/ false)));
	                }
	                else {
	                    assignment.end = node.initializer.end;
	                    statements.push(ts.setTextRange(ts.createStatement(ts.visitNode(assignment, visitor, ts.isExpression)), ts.moveRangeEnd(node.initializer, -1)));
	                }
	            }
	            if (convertedLoopBodyStatements) {
	                return createSyntheticBlockForConvertedStatements(ts.addRange(statements, convertedLoopBodyStatements));
	            }
	            else {
	                var statement = ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock);
	                if (ts.isBlock(statement)) {
	                    return ts.updateBlock(statement, ts.setTextRange(ts.createNodeArray(ts.concatenate(statements, statement.statements)), statement.statements));
	                }
	                else {
	                    statements.push(statement);
	                    return createSyntheticBlockForConvertedStatements(statements);
	                }
	            }
	        }
	        function createSyntheticBlockForConvertedStatements(statements) {
	            return ts.setEmitFlags(ts.createBlock(ts.createNodeArray(statements), 
	            /*multiLine*/ true), 48 /* NoSourceMap */ | 384 /* NoTokenSourceMaps */);
	        }
	        function convertForOfStatementForArray(node, outermostLabeledStatement, convertedLoopBodyStatements) {
	            // The following ES6 code:
	            //
	            //    for (let v of expr) { }
	            //
	            // should be emitted as
	            //
	            //    for (var _i = 0, _a = expr; _i < _a.length; _i++) {
	            //        var v = _a[_i];
	            //    }
	            //
	            // where _a and _i are temps emitted to capture the RHS and the counter,
	            // respectively.
	            // When the left hand side is an expression instead of a let declaration,
	            // the "let v" is not emitted.
	            // When the left hand side is a let/const, the v is renamed if there is
	            // another v in scope.
	            // Note that all assignments to the LHS are emitted in the body, including
	            // all destructuring.
	            // Note also that because an extra statement is needed to assign to the LHS,
	            // for-of bodies are always emitted as blocks.
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            // In the case where the user wrote an identifier as the RHS, like this:
	            //
	            //     for (let v of arr) { }
	            //
	            // we don't want to emit a temporary variable for the RHS, just use it directly.
	            var counter = ts.createLoopVariable();
	            var rhsReference = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            // The old emitter does not emit source maps for the expression
	            ts.setEmitFlags(expression, 48 /* NoSourceMap */ | ts.getEmitFlags(expression));
	            var forStatement = ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(counter, /*type*/ undefined, ts.createLiteral(0)), ts.moveRangePos(node.expression, -1)),
	                ts.setTextRange(ts.createVariableDeclaration(rhsReference, /*type*/ undefined, expression), node.expression)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.setTextRange(ts.createLessThan(counter, ts.createPropertyAccess(rhsReference, "length")), node.expression), 
	            /*incrementor*/ ts.setTextRange(ts.createPostfixIncrement(counter), node.expression), 
	            /*statement*/ convertForOfStatementHead(node, ts.createElementAccess(rhsReference, counter), convertedLoopBodyStatements)), 
	            /*location*/ node);
	            // Disable trailing source maps for the OpenParenToken to align source map emit with the old emitter.
	            ts.setEmitFlags(forStatement, 256 /* NoTokenTrailingSourceMaps */);
	            ts.setTextRange(forStatement, node);
	            return ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel);
	        }
	        function convertForOfStatementForIterable(node, outermostLabeledStatement, convertedLoopBodyStatements) {
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            var iterator = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(expression) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var result = ts.isIdentifier(expression) ? ts.getGeneratedNameForNode(iterator) : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var errorRecord = ts.createUniqueName("e");
	            var catchVariable = ts.getGeneratedNameForNode(errorRecord);
	            var returnMethod = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            var values = ts.createValuesHelper(context, expression, node.expression);
	            var next = ts.createCall(ts.createPropertyAccess(iterator, "next"), /*typeArguments*/ undefined, []);
	            hoistVariableDeclaration(errorRecord);
	            hoistVariableDeclaration(returnMethod);
	            var forStatement = ts.setEmitFlags(ts.setTextRange(ts.createFor(
	            /*initializer*/ ts.setEmitFlags(ts.setTextRange(ts.createVariableDeclarationList([
	                ts.setTextRange(ts.createVariableDeclaration(iterator, /*type*/ undefined, values), node.expression),
	                ts.createVariableDeclaration(result, /*type*/ undefined, next)
	            ]), node.expression), 2097152 /* NoHoisting */), 
	            /*condition*/ ts.createLogicalNot(ts.createPropertyAccess(result, "done")), 
	            /*incrementor*/ ts.createAssignment(result, next), 
	            /*statement*/ convertForOfStatementHead(node, ts.createPropertyAccess(result, "value"), convertedLoopBodyStatements)), 
	            /*location*/ node), 256 /* NoTokenTrailingSourceMaps */);
	            return ts.createTry(ts.createBlock([
	                ts.restoreEnclosingLabel(forStatement, outermostLabeledStatement, convertedLoopState && resetLabel)
	            ]), ts.createCatchClause(ts.createVariableDeclaration(catchVariable), ts.setEmitFlags(ts.createBlock([
	                ts.createStatement(ts.createAssignment(errorRecord, ts.createObjectLiteral([
	                    ts.createPropertyAssignment("error", catchVariable)
	                ])))
	            ]), 1 /* SingleLine */)), ts.createBlock([
	                ts.createTry(
	                /*tryBlock*/ ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(ts.createLogicalAnd(ts.createLogicalAnd(result, ts.createLogicalNot(ts.createPropertyAccess(result, "done"))), ts.createAssignment(returnMethod, ts.createPropertyAccess(iterator, "return"))), ts.createStatement(ts.createFunctionCall(returnMethod, iterator, []))), 1 /* SingleLine */),
	                ]), 
	                /*catchClause*/ undefined, 
	                /*finallyBlock*/ ts.setEmitFlags(ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(errorRecord, ts.createThrow(ts.createPropertyAccess(errorRecord, "error"))), 1 /* SingleLine */)
	                ]), 1 /* SingleLine */))
	            ]));
	        }
	        /**
	         * Visits an ObjectLiteralExpression with computed property names.
	         *
	         * @param node An ObjectLiteralExpression node.
	         */
	        function visitObjectLiteralExpression(node) {
	            // We are here because a ComputedPropertyName was used somewhere in the expression.
	            var properties = node.properties;
	            var numProperties = properties.length;
	            // Find the first computed property.
	            // Everything until that point can be emitted as part of the initial object literal.
	            var numInitialProperties = numProperties;
	            var numInitialPropertiesWithoutYield = numProperties;
	            for (var i = 0; i < numProperties; i++) {
	                var property = properties[i];
	                if ((property.transformFlags & 16777216 /* ContainsYield */ && hierarchyFacts & 4 /* AsyncFunctionBody */)
	                    && i < numInitialPropertiesWithoutYield) {
	                    numInitialPropertiesWithoutYield = i;
	                }
	                if (property.name.kind === 146 /* ComputedPropertyName */) {
	                    numInitialProperties = i;
	                    break;
	                }
	            }
	            if (numInitialProperties !== numProperties) {
	                if (numInitialPropertiesWithoutYield < numInitialProperties) {
	                    numInitialProperties = numInitialPropertiesWithoutYield;
	                }
	                // For computed properties, we need to create a unique handle to the object
	                // literal so we can modify it without risking internal assignments tainting the object.
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                // Write out the first non-computed properties, then emit the rest through indexing on the temp variable.
	                var expressions = [];
	                var assignment = ts.createAssignment(temp, ts.setEmitFlags(ts.createObjectLiteral(ts.visitNodes(properties, visitor, ts.isObjectLiteralElementLike, 0, numInitialProperties), node.multiLine), 65536 /* Indented */));
	                if (node.multiLine) {
	                    ts.startOnNewLine(assignment);
	                }
	                expressions.push(assignment);
	                addObjectLiteralMembers(expressions, node, temp, numInitialProperties);
	                // We need to clone the temporary identifier so that we can write it on a
	                // new line
	                expressions.push(node.multiLine ? ts.startOnNewLine(ts.getMutableClone(temp)) : temp);
	                return ts.inlineExpressions(expressions);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function shouldConvertIterationStatementBody(node) {
	            return (resolver.getNodeCheckFlags(node) & 65536 /* LoopWithCapturedBlockScopedBinding */) !== 0;
	        }
	        /**
	         * Records constituents of name for the given variable to be hoisted in the outer scope.
	         */
	        function hoistVariableDeclarationDeclaredInConvertedLoop(state, node) {
	            if (!state.hoistedLocalVariables) {
	                state.hoistedLocalVariables = [];
	            }
	            visit(node.name);
	            function visit(node) {
	                if (node.kind === 71 /* Identifier */) {
	                    state.hoistedLocalVariables.push(node);
	                }
	                else {
	                    for (var _i = 0, _a = node.elements; _i < _a.length; _i++) {
	                        var element = _a[_i];
	                        if (!ts.isOmittedExpression(element)) {
	                            visit(element.name);
	                        }
	                    }
	                }
	            }
	        }
	        function convertIterationStatementBodyIfNecessary(node, outermostLabeledStatement, convert) {
	            if (!shouldConvertIterationStatementBody(node)) {
	                var saveAllowedNonLabeledJumps = void 0;
	                if (convertedLoopState) {
	                    // we get here if we are trying to emit normal loop loop inside converted loop
	                    // set allowedNonLabeledJumps to Break | Continue to mark that break\continue inside the loop should be emitted as is
	                    saveAllowedNonLabeledJumps = convertedLoopState.allowedNonLabeledJumps;
	                    convertedLoopState.allowedNonLabeledJumps = 2 /* Break */ | 4 /* Continue */;
	                }
	                var result = convert
	                    ? convert(node, outermostLabeledStatement, /*convertedLoopBodyStatements*/ undefined)
	                    : ts.restoreEnclosingLabel(ts.visitEachChild(node, visitor, context), outermostLabeledStatement, convertedLoopState && resetLabel);
	                if (convertedLoopState) {
	                    convertedLoopState.allowedNonLabeledJumps = saveAllowedNonLabeledJumps;
	                }
	                return result;
	            }
	            var functionName = ts.createUniqueName("_loop");
	            var loopInitializer;
	            switch (node.kind) {
	                case 219 /* ForStatement */:
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                    var initializer = node.initializer;
	                    if (initializer && initializer.kind === 232 /* VariableDeclarationList */) {
	                        loopInitializer = initializer;
	                    }
	                    break;
	            }
	            // variables that will be passed to the loop as parameters
	            var loopParameters = [];
	            // variables declared in the loop initializer that will be changed inside the loop
	            var loopOutParameters = [];
	            if (loopInitializer && (ts.getCombinedNodeFlags(loopInitializer) & 3 /* BlockScoped */)) {
	                for (var _i = 0, _a = loopInitializer.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    processLoopVariableDeclaration(decl, loopParameters, loopOutParameters);
	                }
	            }
	            var outerConvertedLoopState = convertedLoopState;
	            convertedLoopState = { loopOutParameters: loopOutParameters };
	            if (outerConvertedLoopState) {
	                // convertedOuterLoopState !== undefined means that this converted loop is nested in another converted loop.
	                // if outer converted loop has already accumulated some state - pass it through
	                if (outerConvertedLoopState.argumentsName) {
	                    // outer loop has already used 'arguments' so we've already have some name to alias it
	                    // use the same name in all nested loops
	                    convertedLoopState.argumentsName = outerConvertedLoopState.argumentsName;
	                }
	                if (outerConvertedLoopState.thisName) {
	                    // outer loop has already used 'this' so we've already have some name to alias it
	                    // use the same name in all nested loops
	                    convertedLoopState.thisName = outerConvertedLoopState.thisName;
	                }
	                if (outerConvertedLoopState.hoistedLocalVariables) {
	                    // we've already collected some non-block scoped variable declarations in enclosing loop
	                    // use the same storage in nested loop
	                    convertedLoopState.hoistedLocalVariables = outerConvertedLoopState.hoistedLocalVariables;
	                }
	            }
	            startLexicalEnvironment();
	            var loopBody = ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock);
	            var lexicalEnvironment = endLexicalEnvironment();
	            var currentState = convertedLoopState;
	            convertedLoopState = outerConvertedLoopState;
	            if (loopOutParameters.length || lexicalEnvironment) {
	                var statements_4 = ts.isBlock(loopBody) ? loopBody.statements.slice() : [loopBody];
	                if (loopOutParameters.length) {
	                    copyOutParameters(loopOutParameters, 1 /* ToOutParameter */, statements_4);
	                }
	                ts.prependStatements(statements_4, lexicalEnvironment);
	                loopBody = ts.createBlock(statements_4, /*multiline*/ true);
	            }
	            if (ts.isBlock(loopBody)) {
	                loopBody.multiLine = true;
	            }
	            else {
	                loopBody = ts.createBlock([loopBody], /*multiline*/ true);
	            }
	            var containsYield = (node.statement.transformFlags & 16777216 /* ContainsYield */) !== 0;
	            var isAsyncBlockContainingAwait = containsYield && (hierarchyFacts & 4 /* AsyncFunctionBody */) !== 0;
	            var loopBodyFlags = 0;
	            if (currentState.containsLexicalThis) {
	                loopBodyFlags |= 8 /* CapturesThis */;
	            }
	            if (isAsyncBlockContainingAwait) {
	                loopBodyFlags |= 262144 /* AsyncFunctionBody */;
	            }
	            var convertedLoopVariable = ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.setEmitFlags(ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(functionName, 
	                /*type*/ undefined, ts.setEmitFlags(ts.createFunctionExpression(
	                /*modifiers*/ undefined, containsYield ? ts.createToken(39 /* AsteriskToken */) : undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, loopParameters, 
	                /*type*/ undefined, loopBody), loopBodyFlags))
	            ]), 2097152 /* NoHoisting */));
	            var statements = [convertedLoopVariable];
	            var extraVariableDeclarations;
	            // propagate state from the inner loop to the outer loop if necessary
	            if (currentState.argumentsName) {
	                // if alias for arguments is set
	                if (outerConvertedLoopState) {
	                    // pass it to outer converted loop
	                    outerConvertedLoopState.argumentsName = currentState.argumentsName;
	                }
	                else {
	                    // this is top level converted loop and we need to create an alias for 'arguments' object
	                    (extraVariableDeclarations || (extraVariableDeclarations = [])).push(ts.createVariableDeclaration(currentState.argumentsName, 
	                    /*type*/ undefined, ts.createIdentifier("arguments")));
	                }
	            }
	            if (currentState.thisName) {
	                // if alias for this is set
	                if (outerConvertedLoopState) {
	                    // pass it to outer converted loop
	                    outerConvertedLoopState.thisName = currentState.thisName;
	                }
	                else {
	                    // this is top level converted loop so we need to create an alias for 'this' here
	                    // NOTE:
	                    // if converted loops were all nested in arrow function then we'll always emit '_this' so convertedLoopState.thisName will not be set.
	                    // If it is set this means that all nested loops are not nested in arrow function and it is safe to capture 'this'.
	                    (extraVariableDeclarations || (extraVariableDeclarations = [])).push(ts.createVariableDeclaration(currentState.thisName, 
	                    /*type*/ undefined, ts.createIdentifier("this")));
	                }
	            }
	            if (currentState.hoistedLocalVariables) {
	                // if hoistedLocalVariables !== undefined this means that we've possibly collected some variable declarations to be hoisted later
	                if (outerConvertedLoopState) {
	                    // pass them to outer converted loop
	                    outerConvertedLoopState.hoistedLocalVariables = currentState.hoistedLocalVariables;
	                }
	                else {
	                    if (!extraVariableDeclarations) {
	                        extraVariableDeclarations = [];
	                    }
	                    // hoist collected variable declarations
	                    for (var _b = 0, _c = currentState.hoistedLocalVariables; _b < _c.length; _b++) {
	                        var identifier = _c[_b];
	                        extraVariableDeclarations.push(ts.createVariableDeclaration(identifier));
	                    }
	                }
	            }
	            // add extra variables to hold out parameters if necessary
	            if (loopOutParameters.length) {
	                if (!extraVariableDeclarations) {
	                    extraVariableDeclarations = [];
	                }
	                for (var _d = 0, loopOutParameters_1 = loopOutParameters; _d < loopOutParameters_1.length; _d++) {
	                    var outParam = loopOutParameters_1[_d];
	                    extraVariableDeclarations.push(ts.createVariableDeclaration(outParam.outParamName));
	                }
	            }
	            // create variable statement to hold all introduced variable declarations
	            if (extraVariableDeclarations) {
	                statements.push(ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList(extraVariableDeclarations)));
	            }
	            var convertedLoopBodyStatements = generateCallToConvertedLoop(functionName, loopParameters, currentState, containsYield);
	            var loop;
	            if (convert) {
	                loop = convert(node, outermostLabeledStatement, convertedLoopBodyStatements);
	            }
	            else {
	                var clone_3 = ts.getMutableClone(node);
	                // clean statement part
	                clone_3.statement = undefined;
	                // visit childnodes to transform initializer/condition/incrementor parts
	                clone_3 = ts.visitEachChild(clone_3, visitor, context);
	                // set loop statement
	                clone_3.statement = ts.createBlock(convertedLoopBodyStatements, /*multiline*/ true);
	                // reset and re-aggregate the transform flags
	                clone_3.transformFlags = 0;
	                ts.aggregateTransformFlags(clone_3);
	                loop = ts.restoreEnclosingLabel(clone_3, outermostLabeledStatement, convertedLoopState && resetLabel);
	            }
	            statements.push(loop);
	            return statements;
	        }
	        function copyOutParameter(outParam, copyDirection) {
	            var source = copyDirection === 0 /* ToOriginal */ ? outParam.outParamName : outParam.originalName;
	            var target = copyDirection === 0 /* ToOriginal */ ? outParam.originalName : outParam.outParamName;
	            return ts.createBinary(target, 58 /* EqualsToken */, source);
	        }
	        function copyOutParameters(outParams, copyDirection, statements) {
	            for (var _i = 0, outParams_1 = outParams; _i < outParams_1.length; _i++) {
	                var outParam = outParams_1[_i];
	                statements.push(ts.createStatement(copyOutParameter(outParam, copyDirection)));
	            }
	        }
	        function generateCallToConvertedLoop(loopFunctionExpressionName, parameters, state, isAsyncBlockContainingAwait) {
	            var outerConvertedLoopState = convertedLoopState;
	            var statements = [];
	            // loop is considered simple if it does not have any return statements or break\continue that transfer control outside of the loop
	            // simple loops are emitted as just 'loop()';
	            // NOTE: if loop uses only 'continue' it still will be emitted as simple loop
	            var isSimpleLoop = !(state.nonLocalJumps & ~4 /* Continue */) &&
	                !state.labeledNonLocalBreaks &&
	                !state.labeledNonLocalContinues;
	            var call = ts.createCall(loopFunctionExpressionName, /*typeArguments*/ undefined, ts.map(parameters, function (p) { return p.name; }));
	            var callResult = isAsyncBlockContainingAwait
	                ? ts.createYield(ts.createToken(39 /* AsteriskToken */), ts.setEmitFlags(call, 8388608 /* Iterator */))
	                : call;
	            if (isSimpleLoop) {
	                statements.push(ts.createStatement(callResult));
	                copyOutParameters(state.loopOutParameters, 0 /* ToOriginal */, statements);
	            }
	            else {
	                var loopResultName = ts.createUniqueName("state");
	                var stateVariable = ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(loopResultName, /*type*/ undefined, callResult)]));
	                statements.push(stateVariable);
	                copyOutParameters(state.loopOutParameters, 0 /* ToOriginal */, statements);
	                if (state.nonLocalJumps & 8 /* Return */) {
	                    var returnStatement = void 0;
	                    if (outerConvertedLoopState) {
	                        outerConvertedLoopState.nonLocalJumps |= 8 /* Return */;
	                        returnStatement = ts.createReturn(loopResultName);
	                    }
	                    else {
	                        returnStatement = ts.createReturn(ts.createPropertyAccess(loopResultName, "value"));
	                    }
	                    statements.push(ts.createIf(ts.createBinary(ts.createTypeOf(loopResultName), 34 /* EqualsEqualsEqualsToken */, ts.createLiteral("object")), returnStatement));
	                }
	                if (state.nonLocalJumps & 2 /* Break */) {
	                    statements.push(ts.createIf(ts.createBinary(loopResultName, 34 /* EqualsEqualsEqualsToken */, ts.createLiteral("break")), ts.createBreak()));
	                }
	                if (state.labeledNonLocalBreaks || state.labeledNonLocalContinues) {
	                    var caseClauses = [];
	                    processLabeledJumps(state.labeledNonLocalBreaks, /*isBreak*/ true, loopResultName, outerConvertedLoopState, caseClauses);
	                    processLabeledJumps(state.labeledNonLocalContinues, /*isBreak*/ false, loopResultName, outerConvertedLoopState, caseClauses);
	                    statements.push(ts.createSwitch(loopResultName, ts.createCaseBlock(caseClauses)));
	                }
	            }
	            return statements;
	        }
	        function setLabeledJump(state, isBreak, labelText, labelMarker) {
	            if (isBreak) {
	                if (!state.labeledNonLocalBreaks) {
	                    state.labeledNonLocalBreaks = ts.createMap();
	                }
	                state.labeledNonLocalBreaks.set(labelText, labelMarker);
	            }
	            else {
	                if (!state.labeledNonLocalContinues) {
	                    state.labeledNonLocalContinues = ts.createMap();
	                }
	                state.labeledNonLocalContinues.set(labelText, labelMarker);
	            }
	        }
	        function processLabeledJumps(table, isBreak, loopResultName, outerLoop, caseClauses) {
	            if (!table) {
	                return;
	            }
	            table.forEach(function (labelMarker, labelText) {
	                var statements = [];
	                // if there are no outer converted loop or outer label in question is located inside outer converted loop
	                // then emit labeled break\continue
	                // otherwise propagate pair 'label -> marker' to outer converted loop and emit 'return labelMarker' so outer loop can later decide what to do
	                if (!outerLoop || (outerLoop.labels && outerLoop.labels.get(labelText))) {
	                    var label = ts.createIdentifier(labelText);
	                    statements.push(isBreak ? ts.createBreak(label) : ts.createContinue(label));
	                }
	                else {
	                    setLabeledJump(outerLoop, isBreak, labelText, labelMarker);
	                    statements.push(ts.createReturn(loopResultName));
	                }
	                caseClauses.push(ts.createCaseClause(ts.createLiteral(labelMarker), statements));
	            });
	        }
	        function processLoopVariableDeclaration(decl, loopParameters, loopOutParameters) {
	            var name = decl.name;
	            if (ts.isBindingPattern(name)) {
	                for (var _i = 0, _a = name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        processLoopVariableDeclaration(element, loopParameters, loopOutParameters);
	                    }
	                }
	            }
	            else {
	                loopParameters.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, name));
	                if (resolver.getNodeCheckFlags(decl) & 2097152 /* NeedsLoopOutParameter */) {
	                    var outParamName = ts.createUniqueName("out_" + ts.idText(name));
	                    loopOutParameters.push({ originalName: name, outParamName: outParamName });
	                }
	            }
	        }
	        /**
	         * Adds the members of an object literal to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node An ObjectLiteralExpression node.
	         * @param receiver The receiver for members of the ObjectLiteralExpression.
	         * @param numInitialNonComputedProperties The number of initial properties without
	         *                                        computed property names.
	         */
	        function addObjectLiteralMembers(expressions, node, receiver, start) {
	            var properties = node.properties;
	            var numProperties = properties.length;
	            for (var i = start; i < numProperties; i++) {
	                var property = properties[i];
	                switch (property.kind) {
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        var accessors = ts.getAllAccessorDeclarations(node.properties, property);
	                        if (property === accessors.firstAccessor) {
	                            expressions.push(transformAccessorsToExpression(receiver, accessors, node, node.multiLine));
	                        }
	                        break;
	                    case 153 /* MethodDeclaration */:
	                        expressions.push(transformObjectLiteralMethodDeclarationToExpression(property, receiver, node, node.multiLine));
	                        break;
	                    case 269 /* PropertyAssignment */:
	                        expressions.push(transformPropertyAssignmentToExpression(property, receiver, node.multiLine));
	                        break;
	                    case 270 /* ShorthandPropertyAssignment */:
	                        expressions.push(transformShorthandPropertyAssignmentToExpression(property, receiver, node.multiLine));
	                        break;
	                    default:
	                        ts.Debug.failBadSyntaxKind(node);
	                        break;
	                }
	            }
	        }
	        /**
	         * Transforms a PropertyAssignment node into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the PropertyAssignment.
	         * @param property The PropertyAssignment node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(property.name, visitor, ts.isPropertyName)), ts.visitNode(property.initializer, visitor, ts.isExpression));
	            ts.setTextRange(expression, property);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            return expression;
	        }
	        /**
	         * Transforms a ShorthandPropertyAssignment node into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the ShorthandPropertyAssignment.
	         * @param property The ShorthandPropertyAssignment node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformShorthandPropertyAssignmentToExpression(property, receiver, startsOnNewLine) {
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(property.name, visitor, ts.isPropertyName)), ts.getSynthesizedClone(property.name));
	            ts.setTextRange(expression, property);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            return expression;
	        }
	        /**
	         * Transforms a MethodDeclaration of an ObjectLiteralExpression into an expression.
	         *
	         * @param node The ObjectLiteralExpression that contains the MethodDeclaration.
	         * @param method The MethodDeclaration node.
	         * @param receiver The receiver for the assignment.
	         */
	        function transformObjectLiteralMethodDeclarationToExpression(method, receiver, container, startsOnNewLine) {
	            var ancestorFacts = enterSubtree(0 /* None */, 0 /* None */);
	            var expression = ts.createAssignment(ts.createMemberAccessForPropertyName(receiver, ts.visitNode(method.name, visitor, ts.isPropertyName)), transformFunctionLikeToExpression(method, /*location*/ method, /*name*/ undefined, container));
	            ts.setTextRange(expression, method);
	            if (startsOnNewLine) {
	                ts.startOnNewLine(expression);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 16384 /* NewTarget */ : 0 /* None */);
	            return expression;
	        }
	        function visitCatchClause(node) {
	            var ancestorFacts = enterSubtree(4032 /* BlockScopeExcludes */, 0 /* BlockScopeIncludes */);
	            var updated;
	            ts.Debug.assert(!!node.variableDeclaration, "Catch clause variable should always be present when downleveling ES2015.");
	            if (ts.isBindingPattern(node.variableDeclaration.name)) {
	                var temp = ts.createTempVariable(/*recordTempVariable*/ undefined);
	                var newVariableDeclaration = ts.createVariableDeclaration(temp);
	                ts.setTextRange(newVariableDeclaration, node.variableDeclaration);
	                var vars = ts.flattenDestructuringBinding(node.variableDeclaration, visitor, context, 0 /* All */, temp);
	                var list = ts.createVariableDeclarationList(vars);
	                ts.setTextRange(list, node.variableDeclaration);
	                var destructure = ts.createVariableStatement(/*modifiers*/ undefined, list);
	                updated = ts.updateCatchClause(node, newVariableDeclaration, addStatementToStartOfBlock(node.block, destructure));
	            }
	            else {
	                updated = ts.visitEachChild(node, visitor, context);
	            }
	            exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	            return updated;
	        }
	        function addStatementToStartOfBlock(block, statement) {
	            var transformedStatements = ts.visitNodes(block.statements, visitor, ts.isStatement);
	            return ts.updateBlock(block, [statement].concat(transformedStatements));
	        }
	        /**
	         * Visits a MethodDeclaration of an ObjectLiteralExpression and transforms it into a
	         * PropertyAssignment.
	         *
	         * @param node A MethodDeclaration node.
	         */
	        function visitMethodDeclaration(node) {
	            // We should only get here for methods on an object literal with regular identifier names.
	            // Methods on classes are handled in visitClassDeclaration/visitClassExpression.
	            // Methods with computed property names are handled in visitObjectLiteralExpression.
	            ts.Debug.assert(!ts.isComputedPropertyName(node.name));
	            var functionExpression = transformFunctionLikeToExpression(node, /*location*/ ts.moveRangePos(node, -1), /*name*/ undefined, /*container*/ undefined);
	            ts.setEmitFlags(functionExpression, 512 /* NoLeadingComments */ | ts.getEmitFlags(functionExpression));
	            return ts.setTextRange(ts.createPropertyAssignment(node.name, functionExpression), 
	            /*location*/ node);
	        }
	        /**
	         * Visits an AccessorDeclaration of an ObjectLiteralExpression.
	         *
	         * @param node An AccessorDeclaration node.
	         */
	        function visitAccessorDeclaration(node) {
	            ts.Debug.assert(!ts.isComputedPropertyName(node.name));
	            var savedConvertedLoopState = convertedLoopState;
	            convertedLoopState = undefined;
	            var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, 65 /* FunctionIncludes */);
	            var updated;
	            var parameters = ts.visitParameterList(node.parameters, visitor, context);
	            var body = node.transformFlags & (32768 /* ContainsCapturedLexicalThis */ | 128 /* ContainsES2015 */)
	                ? transformFunctionBody(node)
	                : visitFunctionBodyDownLevel(node);
	            if (node.kind === 155 /* GetAccessor */) {
	                updated = ts.updateGetAccessor(node, node.decorators, node.modifiers, node.name, parameters, node.type, body);
	            }
	            else {
	                updated = ts.updateSetAccessor(node, node.decorators, node.modifiers, node.name, parameters, body);
	            }
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, 0 /* None */);
	            convertedLoopState = savedConvertedLoopState;
	            return updated;
	        }
	        /**
	         * Visits a ShorthandPropertyAssignment and transforms it into a PropertyAssignment.
	         *
	         * @param node A ShorthandPropertyAssignment node.
	         */
	        function visitShorthandPropertyAssignment(node) {
	            return ts.setTextRange(ts.createPropertyAssignment(node.name, ts.getSynthesizedClone(node.name)), 
	            /*location*/ node);
	        }
	        function visitComputedPropertyName(node) {
	            var ancestorFacts = enterSubtree(0 /* ComputedPropertyNameExcludes */, 8192 /* ComputedPropertyNameIncludes */);
	            var updated = ts.visitEachChild(node, visitor, context);
	            exitSubtree(ancestorFacts, 49152 /* PropagateNewTargetMask */, hierarchyFacts & 49152 /* PropagateNewTargetMask */ ? 32768 /* NewTargetInComputedPropertyName */ : 0 /* None */);
	            return updated;
	        }
	        /**
	         * Visits a YieldExpression node.
	         *
	         * @param node A YieldExpression node.
	         */
	        function visitYieldExpression(node) {
	            // `yield` expressions are transformed using the generators transformer.
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits an ArrayLiteralExpression that contains a spread element.
	         *
	         * @param node An ArrayLiteralExpression node.
	         */
	        function visitArrayLiteralExpression(node) {
	            if (node.transformFlags & 64 /* ES2015 */) {
	                // We are here because we contain a SpreadElementExpression.
	                return transformAndSpreadElements(node.elements, /*needsUniqueCopy*/ true, node.multiLine, /*hasTrailingComma*/ node.elements.hasTrailingComma);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a CallExpression that contains either a spread element or `super`.
	         *
	         * @param node a CallExpression.
	         */
	        function visitCallExpression(node) {
	            if (ts.getEmitFlags(node) & 33554432 /* TypeScriptClassWrapper */) {
	                return visitTypeScriptClassWrapper(node);
	            }
	            if (node.transformFlags & 64 /* ES2015 */) {
	                return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ true);
	            }
	            return ts.updateCall(node, ts.visitNode(node.expression, callExpressionVisitor, ts.isExpression), 
	            /*typeArguments*/ undefined, ts.visitNodes(node.arguments, visitor, ts.isExpression));
	        }
	        function visitTypeScriptClassWrapper(node) {
	            // This is a call to a class wrapper function (an IIFE) created by the 'ts' transformer.
	            // The wrapper has a form similar to:
	            //
	            //  (function() {
	            //      class C { // 1
	            //      }
	            //      C.x = 1; // 2
	            //      return C;
	            //  }())
	            //
	            // When we transform the class, we end up with something like this:
	            //
	            //  (function () {
	            //      var C = (function () { // 3
	            //          function C() {
	            //          }
	            //          return C; // 4
	            //      }());
	            //      C.x = 1;
	            //      return C;
	            //  }())
	            //
	            // We want to simplify the two nested IIFEs to end up with something like this:
	            //
	            //  (function () {
	            //      function C() {
	            //      }
	            //      C.x = 1;
	            //      return C;
	            //  }())
	            // We skip any outer expressions in a number of places to get to the innermost
	            // expression, but we will restore them later to preserve comments and source maps.
	            var body = ts.cast(ts.cast(ts.skipOuterExpressions(node.expression), ts.isArrowFunction).body, ts.isBlock);
	            // The class statements are the statements generated by visiting the first statement with initializer of the
	            // body (1), while all other statements are added to remainingStatements (2)
	            var isVariableStatementWithInitializer = function (stmt) { return ts.isVariableStatement(stmt) && !!ts.firstOrUndefined(stmt.declarationList.declarations).initializer; };
	            var bodyStatements = ts.visitNodes(body.statements, visitor, ts.isStatement);
	            var classStatements = ts.filter(bodyStatements, isVariableStatementWithInitializer);
	            var remainingStatements = ts.filter(bodyStatements, function (stmt) { return !isVariableStatementWithInitializer(stmt); });
	            var varStatement = ts.cast(ts.firstOrUndefined(classStatements), ts.isVariableStatement);
	            // We know there is only one variable declaration here as we verified this in an
	            // earlier call to isTypeScriptClassWrapper
	            var variable = varStatement.declarationList.declarations[0];
	            var initializer = ts.skipOuterExpressions(variable.initializer);
	            // Under certain conditions, the 'ts' transformer may introduce a class alias, which
	            // we see as an assignment, for example:
	            //
	            //  (function () {
	            //      var C_1;
	            //      var C = C_1 = (function () {
	            //          function C() {
	            //          }
	            //          C.x = function () { return C_1; }
	            //          return C;
	            //      }());
	            //      C = C_1 = __decorate([dec], C);
	            //      return C;
	            //  }())
	            //
	            var aliasAssignment = ts.tryCast(initializer, ts.isAssignmentExpression);
	            // The underlying call (3) is another IIFE that may contain a '_super' argument.
	            var call = ts.cast(aliasAssignment ? ts.skipOuterExpressions(aliasAssignment.right) : initializer, ts.isCallExpression);
	            var func = ts.cast(ts.skipOuterExpressions(call.expression), ts.isFunctionExpression);
	            var funcStatements = func.body.statements;
	            var classBodyStart = 0;
	            var classBodyEnd = -1;
	            var statements = [];
	            if (aliasAssignment) {
	                // If we have a class alias assignment, we need to move it to the down-level constructor
	                // function we generated for the class.
	                var extendsCall = ts.tryCast(funcStatements[classBodyStart], ts.isExpressionStatement);
	                if (extendsCall) {
	                    statements.push(extendsCall);
	                    classBodyStart++;
	                }
	                // The next statement is the function declaration.
	                statements.push(funcStatements[classBodyStart]);
	                classBodyStart++;
	                // Add the class alias following the declaration.
	                statements.push(ts.createStatement(ts.createAssignment(aliasAssignment.left, ts.cast(variable.name, ts.isIdentifier))));
	            }
	            // Find the trailing 'return' statement (4)
	            while (!ts.isReturnStatement(ts.elementAt(funcStatements, classBodyEnd))) {
	                classBodyEnd--;
	            }
	            // When we extract the statements of the inner IIFE, we exclude the 'return' statement (4)
	            // as we already have one that has been introduced by the 'ts' transformer.
	            ts.addRange(statements, funcStatements, classBodyStart, classBodyEnd);
	            if (classBodyEnd < -1) {
	                // If there were any hoisted declarations following the return statement, we should
	                // append them.
	                ts.addRange(statements, funcStatements, classBodyEnd + 1);
	            }
	            // Add the remaining statements of the outer wrapper.
	            ts.addRange(statements, remainingStatements);
	            // The 'es2015' class transform may add an end-of-declaration marker. If so we will add it
	            // after the remaining statements from the 'ts' transformer.
	            ts.addRange(statements, classStatements, /*start*/ 1);
	            // Recreate any outer parentheses or partially-emitted expressions to preserve source map
	            // and comment locations.
	            return ts.recreateOuterExpressions(node.expression, ts.recreateOuterExpressions(variable.initializer, ts.recreateOuterExpressions(aliasAssignment && aliasAssignment.right, ts.updateCall(call, ts.recreateOuterExpressions(call.expression, ts.updateFunctionExpression(func, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, func.parameters, 
	            /*type*/ undefined, ts.updateBlock(func.body, statements))), 
	            /*typeArguments*/ undefined, call.arguments))));
	        }
	        function visitImmediateSuperCallInBody(node) {
	            return visitCallExpressionWithPotentialCapturedThisAssignment(node, /*assignToCapturedThis*/ false);
	        }
	        function visitCallExpressionWithPotentialCapturedThisAssignment(node, assignToCapturedThis) {
	            // We are here either because SuperKeyword was used somewhere in the expression, or
	            // because we contain a SpreadElementExpression.
	            if (node.transformFlags & 524288 /* ContainsSpread */ ||
	                node.expression.kind === 97 /* SuperKeyword */ ||
	                ts.isSuperProperty(ts.skipOuterExpressions(node.expression))) {
	                var _a = ts.createCallBinding(node.expression, hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                if (node.expression.kind === 97 /* SuperKeyword */) {
	                    ts.setEmitFlags(thisArg, 4 /* NoSubstitution */);
	                }
	                var resultingCall = void 0;
	                if (node.transformFlags & 524288 /* ContainsSpread */) {
	                    // [source]
	                    //      f(...a, b)
	                    //      x.m(...a, b)
	                    //      super(...a, b)
	                    //      super.m(...a, b) // in static
	                    //      super.m(...a, b) // in instance
	                    //
	                    // [output]
	                    //      f.apply(void 0, a.concat([b]))
	                    //      (_a = x).m.apply(_a, a.concat([b]))
	                    //      _super.apply(this, a.concat([b]))
	                    //      _super.m.apply(this, a.concat([b]))
	                    //      _super.prototype.m.apply(this, a.concat([b]))
	                    resultingCall = ts.createFunctionApply(ts.visitNode(target, callExpressionVisitor, ts.isExpression), ts.visitNode(thisArg, visitor, ts.isExpression), transformAndSpreadElements(node.arguments, /*needsUniqueCopy*/ false, /*multiLine*/ false, /*hasTrailingComma*/ false));
	                }
	                else {
	                    // [source]
	                    //      super(a)
	                    //      super.m(a) // in static
	                    //      super.m(a) // in instance
	                    //
	                    // [output]
	                    //      _super.call(this, a)
	                    //      _super.m.call(this, a)
	                    //      _super.prototype.m.call(this, a)
	                    resultingCall = ts.createFunctionCall(ts.visitNode(target, callExpressionVisitor, ts.isExpression), ts.visitNode(thisArg, visitor, ts.isExpression), ts.visitNodes(node.arguments, visitor, ts.isExpression), 
	                    /*location*/ node);
	                }
	                if (node.expression.kind === 97 /* SuperKeyword */) {
	                    var actualThis = ts.createThis();
	                    ts.setEmitFlags(actualThis, 4 /* NoSubstitution */);
	                    var initializer = ts.createLogicalOr(resultingCall, actualThis);
	                    resultingCall = assignToCapturedThis
	                        ? ts.createAssignment(ts.createFileLevelUniqueName("_this"), initializer)
	                        : initializer;
	                }
	                return ts.setOriginalNode(resultingCall, node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a NewExpression that contains a spread element.
	         *
	         * @param node A NewExpression node.
	         */
	        function visitNewExpression(node) {
	            if (node.transformFlags & 524288 /* ContainsSpread */) {
	                // We are here because we contain a SpreadElementExpression.
	                // [source]
	                //      new C(...a)
	                //
	                // [output]
	                //      new ((_a = C).bind.apply(_a, [void 0].concat(a)))()
	                var _a = ts.createCallBinding(ts.createPropertyAccess(node.expression, "bind"), hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                return ts.createNew(ts.createFunctionApply(ts.visitNode(target, visitor, ts.isExpression), thisArg, transformAndSpreadElements(ts.createNodeArray([ts.createVoidZero()].concat(node.arguments)), /*needsUniqueCopy*/ false, /*multiLine*/ false, /*hasTrailingComma*/ false)), 
	                /*typeArguments*/ undefined, []);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Transforms an array of Expression nodes that contains a SpreadExpression.
	         *
	         * @param elements The array of Expression nodes.
	         * @param needsUniqueCopy A value indicating whether to ensure that the result is a fresh array.
	         * @param multiLine A value indicating whether the result should be emitted on multiple lines.
	         */
	        function transformAndSpreadElements(elements, needsUniqueCopy, multiLine, hasTrailingComma) {
	            // [source]
	            //      [a, ...b, c]
	            //
	            // [output]
	            //      [a].concat(b, [c])
	            // Map spans of spread expressions into their expressions and spans of other
	            // expressions into an array literal.
	            var numElements = elements.length;
	            var segments = ts.flatten(ts.spanMap(elements, partitionSpread, function (partition, visitPartition, _start, end) {
	                return visitPartition(partition, multiLine, hasTrailingComma && end === numElements);
	            }));
	            if (compilerOptions.downlevelIteration) {
	                if (segments.length === 1) {
	                    var firstSegment = segments[0];
	                    if (ts.isCallExpression(firstSegment)
	                        && ts.isIdentifier(firstSegment.expression)
	                        && (ts.getEmitFlags(firstSegment.expression) & 4096 /* HelperName */)
	                        && firstSegment.expression.escapedText === "___spread") {
	                        return segments[0];
	                    }
	                }
	                return ts.createSpreadHelper(context, segments);
	            }
	            else {
	                if (segments.length === 1) {
	                    var firstElement = elements[0];
	                    return needsUniqueCopy && ts.isSpreadElement(firstElement) && firstElement.expression.kind !== 182 /* ArrayLiteralExpression */
	                        ? ts.createArraySlice(segments[0])
	                        : segments[0];
	                }
	                // Rewrite using the pattern <segment0>.concat(<segment1>, <segment2>, ...)
	                return ts.createArrayConcat(segments.shift(), segments);
	            }
	        }
	        function partitionSpread(node) {
	            return ts.isSpreadElement(node)
	                ? visitSpanOfSpreads
	                : visitSpanOfNonSpreads;
	        }
	        function visitSpanOfSpreads(chunk) {
	            return ts.map(chunk, visitExpressionOfSpread);
	        }
	        function visitSpanOfNonSpreads(chunk, multiLine, hasTrailingComma) {
	            return ts.createArrayLiteral(ts.visitNodes(ts.createNodeArray(chunk, hasTrailingComma), visitor, ts.isExpression), multiLine);
	        }
	        function visitSpreadElement(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Transforms the expression of a SpreadExpression node.
	         *
	         * @param node A SpreadExpression node.
	         */
	        function visitExpressionOfSpread(node) {
	            return ts.visitNode(node.expression, visitor, ts.isExpression);
	        }
	        /**
	         * Visits a template literal.
	         *
	         * @param node A template literal.
	         */
	        function visitTemplateLiteral(node) {
	            return ts.setTextRange(ts.createLiteral(node.text), node);
	        }
	        /**
	         * Visits a string literal with an extended unicode escape.
	         *
	         * @param node A string literal.
	         */
	        function visitStringLiteral(node) {
	            if (node.hasExtendedUnicodeEscape) {
	                return ts.setTextRange(ts.createLiteral(node.text), node);
	            }
	            return node;
	        }
	        /**
	         * Visits a binary or octal (ES6) numeric literal.
	         *
	         * @param node A string literal.
	         */
	        function visitNumericLiteral(node) {
	            if (node.numericLiteralFlags & 384 /* BinaryOrOctalSpecifier */) {
	                return ts.setTextRange(ts.createNumericLiteral(node.text), node);
	            }
	            return node;
	        }
	        /**
	         * Visits a TaggedTemplateExpression node.
	         *
	         * @param node A TaggedTemplateExpression node.
	         */
	        function visitTaggedTemplateExpression(node) {
	            // Visit the tag expression
	            var tag = ts.visitNode(node.tag, visitor, ts.isExpression);
	            // Build up the template arguments and the raw and cooked strings for the template.
	            // We start out with 'undefined' for the first argument and revisit later
	            // to avoid walking over the template string twice and shifting all our arguments over after the fact.
	            var templateArguments = [undefined];
	            var cookedStrings = [];
	            var rawStrings = [];
	            var template = node.template;
	            if (ts.isNoSubstitutionTemplateLiteral(template)) {
	                cookedStrings.push(ts.createLiteral(template.text));
	                rawStrings.push(getRawLiteral(template));
	            }
	            else {
	                cookedStrings.push(ts.createLiteral(template.head.text));
	                rawStrings.push(getRawLiteral(template.head));
	                for (var _i = 0, _a = template.templateSpans; _i < _a.length; _i++) {
	                    var templateSpan = _a[_i];
	                    cookedStrings.push(ts.createLiteral(templateSpan.literal.text));
	                    rawStrings.push(getRawLiteral(templateSpan.literal));
	                    templateArguments.push(ts.visitNode(templateSpan.expression, visitor, ts.isExpression));
	                }
	            }
	            var helperCall = createTemplateObjectHelper(context, ts.createArrayLiteral(cookedStrings), ts.createArrayLiteral(rawStrings));
	            // Create a variable to cache the template object if we're in a module.
	            // Do not do this in the global scope, as any variable we currently generate could conflict with
	            // variables from outside of the current compilation. In the future, we can revisit this behavior.
	            if (ts.isExternalModule(currentSourceFile)) {
	                var tempVar = ts.createUniqueName("templateObject");
	                recordTaggedTemplateString(tempVar);
	                templateArguments[0] = ts.createLogicalOr(tempVar, ts.createAssignment(tempVar, helperCall));
	            }
	            else {
	                templateArguments[0] = helperCall;
	            }
	            return ts.createCall(tag, /*typeArguments*/ undefined, templateArguments);
	        }
	        /**
	         * Creates an ES5 compatible literal from an ES6 template literal.
	         *
	         * @param node The ES6 template literal.
	         */
	        function getRawLiteral(node) {
	            // Find original source text, since we need to emit the raw strings of the tagged template.
	            // The raw strings contain the (escaped) strings of what the user wrote.
	            // Examples: `\n` is converted to "\\n", a template string with a newline to "\n".
	            var text = ts.getSourceTextOfNodeFromSourceFile(currentSourceFile, node);
	            // text contains the original source, it will also contain quotes ("`"), dolar signs and braces ("${" and "}"),
	            // thus we need to remove those characters.
	            // First template piece starts with "`", others with "}"
	            // Last template piece ends with "`", others with "${"
	            var isLast = node.kind === 13 /* NoSubstitutionTemplateLiteral */ || node.kind === 16 /* TemplateTail */;
	            text = text.substring(1, text.length - (isLast ? 1 : 2));
	            // Newline normalization:
	            // ES6 Spec 11.8.6.1 - Static Semantics of TV's and TRV's
	            // <CR><LF> and <CR> LineTerminatorSequences are normalized to <LF> for both TV and TRV.
	            text = text.replace(/\r\n?/g, "\n");
	            return ts.setTextRange(ts.createLiteral(text), node);
	        }
	        /**
	         * Visits a TemplateExpression node.
	         *
	         * @param node A TemplateExpression node.
	         */
	        function visitTemplateExpression(node) {
	            var expressions = [];
	            addTemplateHead(expressions, node);
	            addTemplateSpans(expressions, node);
	            // createAdd will check if each expression binds less closely than binary '+'.
	            // If it does, it wraps the expression in parentheses. Otherwise, something like
	            //    `abc${ 1 << 2 }`
	            // becomes
	            //    "abc" + 1 << 2 + ""
	            // which is really
	            //    ("abc" + 1) << (2 + "")
	            // rather than
	            //    "abc" + (1 << 2) + ""
	            var expression = ts.reduceLeft(expressions, ts.createAdd);
	            if (ts.nodeIsSynthesized(expression)) {
	                expression.pos = node.pos;
	                expression.end = node.end;
	            }
	            return expression;
	        }
	        /**
	         * Gets a value indicating whether we need to include the head of a TemplateExpression.
	         *
	         * @param node A TemplateExpression node.
	         */
	        function shouldAddTemplateHead(node) {
	            // If this expression has an empty head literal and the first template span has a non-empty
	            // literal, then emitting the empty head literal is not necessary.
	            //     `${ foo } and ${ bar }`
	            // can be emitted as
	            //     foo + " and " + bar
	            // This is because it is only required that one of the first two operands in the emit
	            // output must be a string literal, so that the other operand and all following operands
	            // are forced into strings.
	            //
	            // If the first template span has an empty literal, then the head must still be emitted.
	            //     `${ foo }${ bar }`
	            // must still be emitted as
	            //     "" + foo + bar
	            // There is always atleast one templateSpan in this code path, since
	            // NoSubstitutionTemplateLiterals are directly emitted via emitLiteral()
	            ts.Debug.assert(node.templateSpans.length !== 0);
	            return node.head.text.length !== 0 || node.templateSpans[0].literal.text.length === 0;
	        }
	        /**
	         * Adds the head of a TemplateExpression to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node A TemplateExpression node.
	         */
	        function addTemplateHead(expressions, node) {
	            if (!shouldAddTemplateHead(node)) {
	                return;
	            }
	            expressions.push(ts.createLiteral(node.head.text));
	        }
	        /**
	         * Visits and adds the template spans of a TemplateExpression to an array of expressions.
	         *
	         * @param expressions An array of expressions.
	         * @param node A TemplateExpression node.
	         */
	        function addTemplateSpans(expressions, node) {
	            for (var _i = 0, _a = node.templateSpans; _i < _a.length; _i++) {
	                var span = _a[_i];
	                expressions.push(ts.visitNode(span.expression, visitor, ts.isExpression));
	                // Only emit if the literal is non-empty.
	                // The binary '+' operator is left-associative, so the first string concatenation
	                // with the head will force the result up to this point to be a string.
	                // Emitting a '+ ""' has no semantic effect for middles and tails.
	                if (span.literal.text.length !== 0) {
	                    expressions.push(ts.createLiteral(span.literal.text));
	                }
	            }
	        }
	        /**
	         * Visits the `super` keyword
	         */
	        function visitSuperKeyword(isExpressionOfCall) {
	            return hierarchyFacts & 8 /* NonStaticClassElement */
	                && !isExpressionOfCall
	                ? ts.createPropertyAccess(ts.createFileLevelUniqueName("_super"), "prototype")
	                : ts.createFileLevelUniqueName("_super");
	        }
	        function visitMetaProperty(node) {
	            if (node.keywordToken === 94 /* NewKeyword */ && node.name.escapedText === "target") {
	                if (hierarchyFacts & 8192 /* ComputedPropertyName */) {
	                    hierarchyFacts |= 32768 /* NewTargetInComputedPropertyName */;
	                }
	                else {
	                    hierarchyFacts |= 16384 /* NewTarget */;
	                }
	                return ts.createFileLevelUniqueName("_newTarget");
	            }
	            return node;
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to be printed.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (enabledSubstitutions & 1 /* CapturedThis */ && ts.isFunctionLike(node)) {
	                // If we are tracking a captured `this`, keep track of the enclosing function.
	                var ancestorFacts = enterSubtree(16286 /* FunctionExcludes */, ts.getEmitFlags(node) & 8 /* CapturesThis */
	                    ? 65 /* FunctionIncludes */ | 16 /* CapturesThis */
	                    : 65 /* FunctionIncludes */);
	                previousOnEmitNode(hint, node, emitCallback);
	                exitSubtree(ancestorFacts, 0 /* None */, 0 /* None */);
	                return;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Enables a more costly code path for substitutions when we determine a source file
	         * contains block-scoped bindings (e.g. `let` or `const`).
	         */
	        function enableSubstitutionsForBlockScopedBindings() {
	            if ((enabledSubstitutions & 2 /* BlockScopedBindings */) === 0) {
	                enabledSubstitutions |= 2 /* BlockScopedBindings */;
	                context.enableSubstitution(71 /* Identifier */);
	            }
	        }
	        /**
	         * Enables a more costly code path for substitutions when we determine a source file
	         * contains a captured `this`.
	         */
	        function enableSubstitutionsForCapturedThis() {
	            if ((enabledSubstitutions & 1 /* CapturedThis */) === 0) {
	                enabledSubstitutions |= 1 /* CapturedThis */;
	                context.enableSubstitution(99 /* ThisKeyword */);
	                context.enableEmitNotification(154 /* Constructor */);
	                context.enableEmitNotification(153 /* MethodDeclaration */);
	                context.enableEmitNotification(155 /* GetAccessor */);
	                context.enableEmitNotification(156 /* SetAccessor */);
	                context.enableEmitNotification(192 /* ArrowFunction */);
	                context.enableEmitNotification(191 /* FunctionExpression */);
	                context.enableEmitNotification(233 /* FunctionDeclaration */);
	            }
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint The context for the emitter.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            if (ts.isIdentifier(node)) {
	                return substituteIdentifier(node);
	            }
	            return node;
	        }
	        /**
	         * Hooks substitutions for non-expression identifiers.
	         */
	        function substituteIdentifier(node) {
	            // Only substitute the identifier if we have enabled substitutions for block-scoped
	            // bindings.
	            if (enabledSubstitutions & 2 /* BlockScopedBindings */ && !ts.isInternalName(node)) {
	                var original = ts.getParseTreeNode(node, ts.isIdentifier);
	                if (original && isNameOfDeclarationWithCollidingName(original)) {
	                    return ts.setTextRange(ts.getGeneratedNameForNode(original), node);
	                }
	            }
	            return node;
	        }
	        /**
	         * Determines whether a name is the name of a declaration with a colliding name.
	         * NOTE: This function expects to be called with an original source tree node.
	         *
	         * @param node An original source tree node.
	         */
	        function isNameOfDeclarationWithCollidingName(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 181 /* BindingElement */:
	                case 234 /* ClassDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 231 /* VariableDeclaration */:
	                    return parent.name === node
	                        && resolver.isDeclarationWithCollidingName(parent);
	            }
	            return false;
	        }
	        /**
	         * Substitutes an expression.
	         *
	         * @param node An Expression node.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 99 /* ThisKeyword */:
	                    return substituteThisKeyword(node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes an expression identifier.
	         *
	         * @param node An Identifier node.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (enabledSubstitutions & 2 /* BlockScopedBindings */ && !ts.isInternalName(node)) {
	                var declaration = resolver.getReferencedDeclarationWithCollidingName(node);
	                if (declaration && !(ts.isClassLike(declaration) && isPartOfClassBody(declaration, node))) {
	                    return ts.setTextRange(ts.getGeneratedNameForNode(ts.getNameOfDeclaration(declaration)), node);
	                }
	            }
	            return node;
	        }
	        function isPartOfClassBody(declaration, node) {
	            var currentNode = ts.getParseTreeNode(node);
	            if (!currentNode || currentNode === declaration || currentNode.end <= declaration.pos || currentNode.pos >= declaration.end) {
	                // if the node has no correlation to a parse tree node, its definitely not
	                // part of the body.
	                // if the node is outside of the document range of the declaration, its
	                // definitely not part of the body.
	                return false;
	            }
	            var blockScope = ts.getEnclosingBlockScopeContainer(declaration);
	            while (currentNode) {
	                if (currentNode === blockScope || currentNode === declaration) {
	                    // if we are in the enclosing block scope of the declaration, we are definitely
	                    // not inside the class body.
	                    return false;
	                }
	                if (ts.isClassElement(currentNode) && currentNode.parent === declaration) {
	                    return true;
	                }
	                currentNode = currentNode.parent;
	            }
	            return false;
	        }
	        /**
	         * Substitutes `this` when contained within an arrow function.
	         *
	         * @param node The ThisKeyword node.
	         */
	        function substituteThisKeyword(node) {
	            if (enabledSubstitutions & 1 /* CapturedThis */
	                && hierarchyFacts & 16 /* CapturesThis */) {
	                return ts.setTextRange(ts.createFileLevelUniqueName("_this"), node);
	            }
	            return node;
	        }
	        function getClassMemberPrefix(node, member) {
	            return ts.hasModifier(member, 32 /* Static */)
	                ? ts.getInternalName(node)
	                : ts.createPropertyAccess(ts.getInternalName(node), "prototype");
	        }
	        function hasSynthesizedDefaultSuperCall(constructor, hasExtendsClause) {
	            if (!constructor || !hasExtendsClause) {
	                return false;
	            }
	            if (ts.some(constructor.parameters)) {
	                return false;
	            }
	            var statement = ts.firstOrUndefined(constructor.body.statements);
	            if (!statement || !ts.nodeIsSynthesized(statement) || statement.kind !== 215 /* ExpressionStatement */) {
	                return false;
	            }
	            var statementExpression = statement.expression;
	            if (!ts.nodeIsSynthesized(statementExpression) || statementExpression.kind !== 186 /* CallExpression */) {
	                return false;
	            }
	            var callTarget = statementExpression.expression;
	            if (!ts.nodeIsSynthesized(callTarget) || callTarget.kind !== 97 /* SuperKeyword */) {
	                return false;
	            }
	            var callArgument = ts.singleOrUndefined(statementExpression.arguments);
	            if (!callArgument || !ts.nodeIsSynthesized(callArgument) || callArgument.kind !== 203 /* SpreadElement */) {
	                return false;
	            }
	            var expression = callArgument.expression;
	            return ts.isIdentifier(expression) && expression.escapedText === "arguments";
	        }
	    }
	    ts.transformES2015 = transformES2015;
	    function createExtendsHelper(context, name) {
	        context.requestEmitHelper(extendsHelper);
	        return ts.createCall(ts.getHelperName("__extends"), 
	        /*typeArguments*/ undefined, [
	            name,
	            ts.createFileLevelUniqueName("_super")
	        ]);
	    }
	    function createTemplateObjectHelper(context, cooked, raw) {
	        context.requestEmitHelper(templateObjectHelper);
	        return ts.createCall(ts.getHelperName("__makeTemplateObject"), 
	        /*typeArguments*/ undefined, [
	            cooked,
	            raw
	        ]);
	    }
	    var extendsHelper = {
	        name: "typescript:extends",
	        scoped: false,
	        priority: 0,
	        text: "\n            var __extends = (this && this.__extends) || (function () {\n                var extendStatics = Object.setPrototypeOf ||\n                    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||\n                    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };\n                return function (d, b) {\n                    extendStatics(d, b);\n                    function __() { this.constructor = d; }\n                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());\n                };\n            })();"
	    };
	    var templateObjectHelper = {
	        name: "typescript:makeTemplateObject",
	        scoped: false,
	        priority: 0,
	        text: "\n            var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {\n                if (Object.defineProperty) { Object.defineProperty(cooked, \"raw\", { value: raw }); } else { cooked.raw = raw; }\n                return cooked;\n            };"
	    };
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    /**
	     * Transforms ES5 syntax into ES3 syntax.
	     *
	     * @param context Context and state information for the transformation.
	     */
	    function transformES5(context) {
	        var compilerOptions = context.getCompilerOptions();
	        // enable emit notification only if using --jsx preserve or react-native
	        var previousOnEmitNode;
	        var noSubstitution;
	        if (compilerOptions.jsx === 1 /* Preserve */ || compilerOptions.jsx === 3 /* ReactNative */) {
	            previousOnEmitNode = context.onEmitNode;
	            context.onEmitNode = onEmitNode;
	            context.enableEmitNotification(256 /* JsxOpeningElement */);
	            context.enableEmitNotification(257 /* JsxClosingElement */);
	            context.enableEmitNotification(255 /* JsxSelfClosingElement */);
	            noSubstitution = [];
	        }
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.enableSubstitution(184 /* PropertyAccessExpression */);
	        context.enableSubstitution(269 /* PropertyAssignment */);
	        return ts.chainBundle(transformSourceFile);
	        /**
	         * Transforms an ES5 source file to ES3.
	         *
	         * @param node A SourceFile
	         */
	        function transformSourceFile(node) {
	            return node;
	        }
	        /**
	         * Called by the printer just before a node is printed.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback A callback used to emit the node.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            switch (node.kind) {
	                case 256 /* JsxOpeningElement */:
	                case 257 /* JsxClosingElement */:
	                case 255 /* JsxSelfClosingElement */:
	                    var tagName = node.tagName;
	                    noSubstitution[ts.getOriginalNodeId(tagName)] = true;
	                    break;
	            }
	            previousOnEmitNode(hint, node, emitCallback);
	        }
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            if (node.id && noSubstitution && noSubstitution[node.id]) {
	                return previousOnSubstituteNode(hint, node);
	            }
	            node = previousOnSubstituteNode(hint, node);
	            if (ts.isPropertyAccessExpression(node)) {
	                return substitutePropertyAccessExpression(node);
	            }
	            else if (ts.isPropertyAssignment(node)) {
	                return substitutePropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes a PropertyAccessExpression whose name is a reserved word.
	         *
	         * @param node A PropertyAccessExpression
	         */
	        function substitutePropertyAccessExpression(node) {
	            var literalName = trySubstituteReservedName(node.name);
	            if (literalName) {
	                return ts.setTextRange(ts.createElementAccess(node.expression, literalName), node);
	            }
	            return node;
	        }
	        /**
	         * Substitutes a PropertyAssignment whose name is a reserved word.
	         *
	         * @param node A PropertyAssignment
	         */
	        function substitutePropertyAssignment(node) {
	            var literalName = ts.isIdentifier(node.name) && trySubstituteReservedName(node.name);
	            if (literalName) {
	                return ts.updatePropertyAssignment(node, literalName, node.initializer);
	            }
	            return node;
	        }
	        /**
	         * If an identifier name is a reserved word, returns a string literal for the name.
	         *
	         * @param name An Identifier
	         */
	        function trySubstituteReservedName(name) {
	            var token = name.originalKeywordKind || (ts.nodeIsSynthesized(name) ? ts.stringToToken(ts.idText(name)) : undefined);
	            if (token >= 72 /* FirstReservedWord */ && token <= 107 /* LastReservedWord */) {
	                return ts.setTextRange(ts.createLiteral(name), name);
	            }
	            return undefined;
	        }
	    }
	    ts.transformES5 = transformES5;
	})(ts || (ts = {}));
	// Transforms generator functions into a compatible ES5 representation with similar runtime
	// semantics. This is accomplished by first transforming the body of each generator
	// function into an intermediate representation that is the compiled into a JavaScript
	// switch statement.
	//
	// Many functions in this transformer will contain comments indicating the expected
	// intermediate representation. For illustrative purposes, the following intermediate
	// language is used to define this intermediate representation:
	//
	//  .nop                            - Performs no operation.
	//  .local NAME, ...                - Define local variable declarations.
	//  .mark LABEL                     - Mark the location of a label.
	//  .br LABEL                       - Jump to a label. If jumping out of a protected
	//                                    region, all .finally blocks are executed.
	//  .brtrue LABEL, (x)              - Jump to a label IIF the expression `x` is truthy.
	//                                    If jumping out of a protected region, all .finally
	//                                    blocks are executed.
	//  .brfalse LABEL, (x)             - Jump to a label IIF the expression `x` is falsey.
	//                                    If jumping out of a protected region, all .finally
	//                                    blocks are executed.
	//  .yield (x)                      - Yield the value of the optional expression `x`.
	//                                    Resume at the next label.
	//  .yieldstar (x)                  - Delegate yield to the value of the optional
	//                                    expression `x`. Resume at the next label.
	//                                    NOTE: `x` must be an Iterator, not an Iterable.
	//  .loop CONTINUE, BREAK           - Marks the beginning of a loop. Any "continue" or
	//                                    "break" abrupt completions jump to the CONTINUE or
	//                                    BREAK labels, respectively.
	//  .endloop                        - Marks the end of a loop.
	//  .with (x)                       - Marks the beginning of a WithStatement block, using
	//                                    the supplied expression.
	//  .endwith                        - Marks the end of a WithStatement.
	//  .switch                         - Marks the beginning of a SwitchStatement.
	//  .endswitch                      - Marks the end of a SwitchStatement.
	//  .labeled NAME                   - Marks the beginning of a LabeledStatement with the
	//                                    supplied name.
	//  .endlabeled                     - Marks the end of a LabeledStatement.
	//  .try TRY, CATCH, FINALLY, END   - Marks the beginning of a protected region, and the
	//                                    labels for each block.
	//  .catch (x)                      - Marks the beginning of a catch block.
	//  .finally                        - Marks the beginning of a finally block.
	//  .endfinally                     - Marks the end of a finally block.
	//  .endtry                         - Marks the end of a protected region.
	//  .throw (x)                      - Throws the value of the expression `x`.
	//  .return (x)                     - Returns the value of the expression `x`.
	//
	// In addition, the illustrative intermediate representation introduces some special
	// variables:
	//
	//  %sent%                          - Either returns the next value sent to the generator,
	//                                    returns the result of a delegated yield, or throws
	//                                    the exception sent to the generator.
	//  %error%                         - Returns the value of the current exception in a
	//                                    catch block.
	//
	// This intermediate representation is then compiled into JavaScript syntax. The resulting
	// compilation output looks something like the following:
	//
	//  function f() {
	//      var /*locals*/;
	//      /*functions*/
	//      return __generator(function (state) {
	//          switch (state.label) {
	//              /*cases per label*/
	//          }
	//      });
	//  }
	//
	// Each of the above instructions corresponds to JavaScript emit similar to the following:
	//
	//  .local NAME                   | var NAME;
	// -------------------------------|----------------------------------------------
	//  .mark LABEL                   | case LABEL:
	// -------------------------------|----------------------------------------------
	//  .br LABEL                     |     return [3 /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .brtrue LABEL, (x)            |     if (x) return [3 /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .brfalse LABEL, (x)           |     if (!(x)) return [3, /*break*/, LABEL];
	// -------------------------------|----------------------------------------------
	//  .yield (x)                    |     return [4 /*yield*/, x];
	//  .mark RESUME                  | case RESUME:
	//      a = %sent%;               |     a = state.sent();
	// -------------------------------|----------------------------------------------
	//  .yieldstar (x)                |     return [5 /*yield**/, x];
	//  .mark RESUME                  | case RESUME:
	//      a = %sent%;               |     a = state.sent();
	// -------------------------------|----------------------------------------------
	//  .with (_a)                    |     with (_a) {
	//      a();                      |         a();
	//                                |     }
	//                                |     state.label = LABEL;
	//  .mark LABEL                   | case LABEL:
	//                                |     with (_a) {
	//      b();                      |         b();
	//                                |     }
	//  .endwith                      |
	// -------------------------------|----------------------------------------------
	//                                | case 0:
	//                                |     state.trys = [];
	//                                | ...
	//  .try TRY, CATCH, FINALLY, END |
	//  .mark TRY                     | case TRY:
	//                                |     state.trys.push([TRY, CATCH, FINALLY, END]);
	//  .nop                          |
	//      a();                      |     a();
	//  .br END                       |     return [3 /*break*/, END];
	//  .catch (e)                    |
	//  .mark CATCH                   | case CATCH:
	//                                |     e = state.sent();
	//      b();                      |     b();
	//  .br END                       |     return [3 /*break*/, END];
	//  .finally                      |
	//  .mark FINALLY                 | case FINALLY:
	//      c();                      |     c();
	//  .endfinally                   |     return [7 /*endfinally*/];
	//  .endtry                       |
	//  .mark END                     | case END:
	/*@internal*/
	var ts;
	(function (ts) {
	    var OpCode;
	    (function (OpCode) {
	        OpCode[OpCode["Nop"] = 0] = "Nop";
	        OpCode[OpCode["Statement"] = 1] = "Statement";
	        OpCode[OpCode["Assign"] = 2] = "Assign";
	        OpCode[OpCode["Break"] = 3] = "Break";
	        OpCode[OpCode["BreakWhenTrue"] = 4] = "BreakWhenTrue";
	        OpCode[OpCode["BreakWhenFalse"] = 5] = "BreakWhenFalse";
	        OpCode[OpCode["Yield"] = 6] = "Yield";
	        OpCode[OpCode["YieldStar"] = 7] = "YieldStar";
	        OpCode[OpCode["Return"] = 8] = "Return";
	        OpCode[OpCode["Throw"] = 9] = "Throw";
	        OpCode[OpCode["Endfinally"] = 10] = "Endfinally"; // Marks the end of a `finally` block
	    })(OpCode || (OpCode = {}));
	    // whether a generated code block is opening or closing at the current operation for a FunctionBuilder
	    var BlockAction;
	    (function (BlockAction) {
	        BlockAction[BlockAction["Open"] = 0] = "Open";
	        BlockAction[BlockAction["Close"] = 1] = "Close";
	    })(BlockAction || (BlockAction = {}));
	    // the kind for a generated code block in a FunctionBuilder
	    var CodeBlockKind;
	    (function (CodeBlockKind) {
	        CodeBlockKind[CodeBlockKind["Exception"] = 0] = "Exception";
	        CodeBlockKind[CodeBlockKind["With"] = 1] = "With";
	        CodeBlockKind[CodeBlockKind["Switch"] = 2] = "Switch";
	        CodeBlockKind[CodeBlockKind["Loop"] = 3] = "Loop";
	        CodeBlockKind[CodeBlockKind["Labeled"] = 4] = "Labeled";
	    })(CodeBlockKind || (CodeBlockKind = {}));
	    // the state for a generated code exception block
	    var ExceptionBlockState;
	    (function (ExceptionBlockState) {
	        ExceptionBlockState[ExceptionBlockState["Try"] = 0] = "Try";
	        ExceptionBlockState[ExceptionBlockState["Catch"] = 1] = "Catch";
	        ExceptionBlockState[ExceptionBlockState["Finally"] = 2] = "Finally";
	        ExceptionBlockState[ExceptionBlockState["Done"] = 3] = "Done";
	    })(ExceptionBlockState || (ExceptionBlockState = {}));
	    // NOTE: changes to this enum should be reflected in the __generator helper.
	    var Instruction;
	    (function (Instruction) {
	        Instruction[Instruction["Next"] = 0] = "Next";
	        Instruction[Instruction["Throw"] = 1] = "Throw";
	        Instruction[Instruction["Return"] = 2] = "Return";
	        Instruction[Instruction["Break"] = 3] = "Break";
	        Instruction[Instruction["Yield"] = 4] = "Yield";
	        Instruction[Instruction["YieldStar"] = 5] = "YieldStar";
	        Instruction[Instruction["Catch"] = 6] = "Catch";
	        Instruction[Instruction["Endfinally"] = 7] = "Endfinally";
	    })(Instruction || (Instruction = {}));
	    function getInstructionName(instruction) {
	        switch (instruction) {
	            case 2 /* Return */: return "return";
	            case 3 /* Break */: return "break";
	            case 4 /* Yield */: return "yield";
	            case 5 /* YieldStar */: return "yield*";
	            case 7 /* Endfinally */: return "endfinally";
	        }
	    }
	    function transformGenerators(context) {
	        var resumeLexicalEnvironment = context.resumeLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistFunctionDeclaration = context.hoistFunctionDeclaration, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var resolver = context.getEmitResolver();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onSubstituteNode = onSubstituteNode;
	        var renamedCatchVariables;
	        var renamedCatchVariableDeclarations;
	        var inGeneratorFunctionBody;
	        var inStatementContainingYield;
	        // The following three arrays store information about generated code blocks.
	        // All three arrays are correlated by their index. This approach is used over allocating
	        // objects to store the same information to avoid GC overhead.
	        //
	        var blocks; // Information about the code block
	        var blockOffsets; // The operation offset at which a code block begins or ends
	        var blockActions; // Whether the code block is opened or closed
	        var blockStack; // A stack of currently open code blocks
	        // Labels are used to mark locations in the code that can be the target of a Break (jump)
	        // operation. These are translated into case clauses in a switch statement.
	        // The following two arrays are correlated by their index. This approach is used over
	        // allocating objects to store the same information to avoid GC overhead.
	        //
	        var labelOffsets; // The operation offset at which the label is defined.
	        var labelExpressions; // The NumericLiteral nodes bound to each label.
	        var nextLabelId = 1; // The next label id to use.
	        // Operations store information about generated code for the function body. This
	        // Includes things like statements, assignments, breaks (jumps), and yields.
	        // The following three arrays are correlated by their index. This approach is used over
	        // allocating objects to store the same information to avoid GC overhead.
	        //
	        var operations; // The operation to perform.
	        var operationArguments; // The arguments to the operation.
	        var operationLocations; // The source map location for the operation.
	        var state; // The name of the state object used by the generator at runtime.
	        // The following variables store information used by the `build` function:
	        //
	        var blockIndex = 0; // The index of the current block.
	        var labelNumber = 0; // The current label number.
	        var labelNumbers;
	        var lastOperationWasAbrupt; // Indicates whether the last operation was abrupt (break/continue).
	        var lastOperationWasCompletion; // Indicates whether the last operation was a completion (return/throw).
	        var clauses; // The case clauses generated for labels.
	        var statements; // The statements for the current label.
	        var exceptionBlockStack; // A stack of containing exception blocks.
	        var currentExceptionBlock; // The current exception block.
	        var withBlockStack; // A stack containing `with` blocks.
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || (node.transformFlags & 512 /* ContainsGenerator */) === 0) {
	                return node;
	            }
	            var visited = ts.visitEachChild(node, visitor, context);
	            ts.addEmitHelpers(visited, context.readEmitHelpers());
	            return visited;
	        }
	        /**
	         * Visits a node.
	         *
	         * @param node The node to visit.
	         */
	        function visitor(node) {
	            var transformFlags = node.transformFlags;
	            if (inStatementContainingYield) {
	                return visitJavaScriptInStatementContainingYield(node);
	            }
	            else if (inGeneratorFunctionBody) {
	                return visitJavaScriptInGeneratorFunctionBody(node);
	            }
	            else if (transformFlags & 256 /* Generator */) {
	                return visitGenerator(node);
	            }
	            else if (transformFlags & 512 /* ContainsGenerator */) {
	                return ts.visitEachChild(node, visitor, context);
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Visits a node that is contained within a statement that contains yield.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptInStatementContainingYield(node) {
	            switch (node.kind) {
	                case 217 /* DoStatement */:
	                    return visitDoStatement(node);
	                case 218 /* WhileStatement */:
	                    return visitWhileStatement(node);
	                case 226 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 227 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                default:
	                    return visitJavaScriptInGeneratorFunctionBody(node);
	            }
	        }
	        /**
	         * Visits a node that is contained within a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptInGeneratorFunctionBody(node) {
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 191 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return visitAccessorDeclaration(node);
	                case 213 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 219 /* ForStatement */:
	                    return visitForStatement(node);
	                case 220 /* ForInStatement */:
	                    return visitForInStatement(node);
	                case 223 /* BreakStatement */:
	                    return visitBreakStatement(node);
	                case 222 /* ContinueStatement */:
	                    return visitContinueStatement(node);
	                case 224 /* ReturnStatement */:
	                    return visitReturnStatement(node);
	                default:
	                    if (node.transformFlags & 16777216 /* ContainsYield */) {
	                        return visitJavaScriptContainingYield(node);
	                    }
	                    else if (node.transformFlags & (512 /* ContainsGenerator */ | 33554432 /* ContainsHoistedDeclarationOrCompletion */)) {
	                        return ts.visitEachChild(node, visitor, context);
	                    }
	                    else {
	                        return node;
	                    }
	            }
	        }
	        /**
	         * Visits a node that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitJavaScriptContainingYield(node) {
	            switch (node.kind) {
	                case 199 /* BinaryExpression */:
	                    return visitBinaryExpression(node);
	                case 200 /* ConditionalExpression */:
	                    return visitConditionalExpression(node);
	                case 202 /* YieldExpression */:
	                    return visitYieldExpression(node);
	                case 182 /* ArrayLiteralExpression */:
	                    return visitArrayLiteralExpression(node);
	                case 183 /* ObjectLiteralExpression */:
	                    return visitObjectLiteralExpression(node);
	                case 185 /* ElementAccessExpression */:
	                    return visitElementAccessExpression(node);
	                case 186 /* CallExpression */:
	                    return visitCallExpression(node);
	                case 187 /* NewExpression */:
	                    return visitNewExpression(node);
	                default:
	                    return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        /**
	         * Visits a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitGenerator(node) {
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 191 /* FunctionExpression */:
	                    return visitFunctionExpression(node);
	                default:
	                    return ts.Debug.failBadSyntaxKind(node);
	            }
	        }
	        /**
	         * Visits a function declaration.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The function declaration is a generator function.
	         * - The function declaration is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            // Currently, we only support generators that were originally async functions.
	            if (node.asteriskToken) {
	                node = ts.setOriginalNode(ts.setTextRange(ts.createFunctionDeclaration(
	                /*decorators*/ undefined, node.modifiers, 
	                /*asteriskToken*/ undefined, node.name, 
	                /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	                /*type*/ undefined, transformGeneratorFunctionBody(node.body)), 
	                /*location*/ node), node);
	            }
	            else {
	                var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	                var savedInStatementContainingYield = inStatementContainingYield;
	                inGeneratorFunctionBody = false;
	                inStatementContainingYield = false;
	                node = ts.visitEachChild(node, visitor, context);
	                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	                inStatementContainingYield = savedInStatementContainingYield;
	            }
	            if (inGeneratorFunctionBody) {
	                // Function declarations in a generator function body are hoisted
	                // to the top of the lexical scope and elided from the current statement.
	                hoistFunctionDeclaration(node);
	                return undefined;
	            }
	            else {
	                return node;
	            }
	        }
	        /**
	         * Visits a function expression.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The function expression is a generator function.
	         * - The function expression is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionExpression(node) {
	            // Currently, we only support generators that were originally async functions.
	            if (node.asteriskToken) {
	                node = ts.setOriginalNode(ts.setTextRange(ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, node.name, 
	                /*typeParameters*/ undefined, ts.visitParameterList(node.parameters, visitor, context), 
	                /*type*/ undefined, transformGeneratorFunctionBody(node.body)), 
	                /*location*/ node), node);
	            }
	            else {
	                var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	                var savedInStatementContainingYield = inStatementContainingYield;
	                inGeneratorFunctionBody = false;
	                inStatementContainingYield = false;
	                node = ts.visitEachChild(node, visitor, context);
	                inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	                inStatementContainingYield = savedInStatementContainingYield;
	            }
	            return node;
	        }
	        /**
	         * Visits a get or set accessor declaration.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The accessor is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitAccessorDeclaration(node) {
	            var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	            var savedInStatementContainingYield = inStatementContainingYield;
	            inGeneratorFunctionBody = false;
	            inStatementContainingYield = false;
	            node = ts.visitEachChild(node, visitor, context);
	            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	            inStatementContainingYield = savedInStatementContainingYield;
	            return node;
	        }
	        /**
	         * Transforms the body of a generator function declaration.
	         *
	         * @param node The function body to transform.
	         */
	        function transformGeneratorFunctionBody(body) {
	            // Save existing generator state
	            var statements = [];
	            var savedInGeneratorFunctionBody = inGeneratorFunctionBody;
	            var savedInStatementContainingYield = inStatementContainingYield;
	            var savedBlocks = blocks;
	            var savedBlockOffsets = blockOffsets;
	            var savedBlockActions = blockActions;
	            var savedBlockStack = blockStack;
	            var savedLabelOffsets = labelOffsets;
	            var savedLabelExpressions = labelExpressions;
	            var savedNextLabelId = nextLabelId;
	            var savedOperations = operations;
	            var savedOperationArguments = operationArguments;
	            var savedOperationLocations = operationLocations;
	            var savedState = state;
	            // Initialize generator state
	            inGeneratorFunctionBody = true;
	            inStatementContainingYield = false;
	            blocks = undefined;
	            blockOffsets = undefined;
	            blockActions = undefined;
	            blockStack = undefined;
	            labelOffsets = undefined;
	            labelExpressions = undefined;
	            nextLabelId = 1;
	            operations = undefined;
	            operationArguments = undefined;
	            operationLocations = undefined;
	            state = ts.createTempVariable(/*recordTempVariable*/ undefined);
	            // Build the generator
	            resumeLexicalEnvironment();
	            var statementOffset = ts.addPrologue(statements, body.statements, /*ensureUseStrict*/ false, visitor);
	            transformAndEmitStatements(body.statements, statementOffset);
	            var buildResult = build();
	            ts.prependStatements(statements, endLexicalEnvironment());
	            statements.push(ts.createReturn(buildResult));
	            // Restore previous generator state
	            inGeneratorFunctionBody = savedInGeneratorFunctionBody;
	            inStatementContainingYield = savedInStatementContainingYield;
	            blocks = savedBlocks;
	            blockOffsets = savedBlockOffsets;
	            blockActions = savedBlockActions;
	            blockStack = savedBlockStack;
	            labelOffsets = savedLabelOffsets;
	            labelExpressions = savedLabelExpressions;
	            nextLabelId = savedNextLabelId;
	            operations = savedOperations;
	            operationArguments = savedOperationArguments;
	            operationLocations = savedOperationLocations;
	            state = savedState;
	            return ts.setTextRange(ts.createBlock(statements, body.multiLine), body);
	        }
	        /**
	         * Visits a variable statement.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The variable statement is contained within the body of a generator function.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            if (node.transformFlags & 16777216 /* ContainsYield */) {
	                transformAndEmitVariableDeclarationList(node.declarationList);
	                return undefined;
	            }
	            else {
	                // Do not hoist custom prologues.
	                if (ts.getEmitFlags(node) & 1048576 /* CustomPrologue */) {
	                    return node;
	                }
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                var variables = ts.getInitializedVariables(node.declarationList);
	                if (variables.length === 0) {
	                    return undefined;
	                }
	                return ts.setSourceMapRange(ts.createStatement(ts.inlineExpressions(ts.map(variables, transformInitializedVariable))), node);
	            }
	        }
	        /**
	         * Visits a binary expression.
	         *
	         * This will be called when one of the following conditions are met:
	         * - The node contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitBinaryExpression(node) {
	            switch (ts.getExpressionAssociativity(node)) {
	                case 0 /* Left */:
	                    return visitLeftAssociativeBinaryExpression(node);
	                case 1 /* Right */:
	                    return visitRightAssociativeBinaryExpression(node);
	                default:
	                    ts.Debug.fail("Unknown associativity.");
	            }
	        }
	        function isCompoundAssignment(kind) {
	            return kind >= 59 /* FirstCompoundAssignment */
	                && kind <= 70 /* LastCompoundAssignment */;
	        }
	        function getOperatorForCompoundAssignment(kind) {
	            switch (kind) {
	                case 59 /* PlusEqualsToken */: return 37 /* PlusToken */;
	                case 60 /* MinusEqualsToken */: return 38 /* MinusToken */;
	                case 61 /* AsteriskEqualsToken */: return 39 /* AsteriskToken */;
	                case 62 /* AsteriskAsteriskEqualsToken */: return 40 /* AsteriskAsteriskToken */;
	                case 63 /* SlashEqualsToken */: return 41 /* SlashToken */;
	                case 64 /* PercentEqualsToken */: return 42 /* PercentToken */;
	                case 65 /* LessThanLessThanEqualsToken */: return 45 /* LessThanLessThanToken */;
	                case 66 /* GreaterThanGreaterThanEqualsToken */: return 46 /* GreaterThanGreaterThanToken */;
	                case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */: return 47 /* GreaterThanGreaterThanGreaterThanToken */;
	                case 68 /* AmpersandEqualsToken */: return 48 /* AmpersandToken */;
	                case 69 /* BarEqualsToken */: return 49 /* BarToken */;
	                case 70 /* CaretEqualsToken */: return 50 /* CaretToken */;
	            }
	        }
	        /**
	         * Visits a right-associative binary expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitRightAssociativeBinaryExpression(node) {
	            var left = node.left, right = node.right;
	            if (containsYield(right)) {
	                var target = void 0;
	                switch (left.kind) {
	                    case 184 /* PropertyAccessExpression */:
	                        // [source]
	                        //      a.b = yield;
	                        //
	                        // [intermediate]
	                        //  .local _a
	                        //      _a = a;
	                        //  .yield resumeLabel
	                        //  .mark resumeLabel
	                        //      _a.b = %sent%;
	                        target = ts.updatePropertyAccess(left, cacheExpression(ts.visitNode(left.expression, visitor, ts.isLeftHandSideExpression)), left.name);
	                        break;
	                    case 185 /* ElementAccessExpression */:
	                        // [source]
	                        //      a[b] = yield;
	                        //
	                        // [intermediate]
	                        //  .local _a, _b
	                        //      _a = a;
	                        //      _b = b;
	                        //  .yield resumeLabel
	                        //  .mark resumeLabel
	                        //      _a[_b] = %sent%;
	                        target = ts.updateElementAccess(left, cacheExpression(ts.visitNode(left.expression, visitor, ts.isLeftHandSideExpression)), cacheExpression(ts.visitNode(left.argumentExpression, visitor, ts.isExpression)));
	                        break;
	                    default:
	                        target = ts.visitNode(left, visitor, ts.isExpression);
	                        break;
	                }
	                var operator = node.operatorToken.kind;
	                if (isCompoundAssignment(operator)) {
	                    return ts.setTextRange(ts.createAssignment(target, ts.setTextRange(ts.createBinary(cacheExpression(target), getOperatorForCompoundAssignment(operator), ts.visitNode(right, visitor, ts.isExpression)), node)), node);
	                }
	                else {
	                    return ts.updateBinary(node, target, ts.visitNode(right, visitor, ts.isExpression));
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitLeftAssociativeBinaryExpression(node) {
	            if (containsYield(node.right)) {
	                if (ts.isLogicalOperator(node.operatorToken.kind)) {
	                    return visitLogicalBinaryExpression(node);
	                }
	                else if (node.operatorToken.kind === 26 /* CommaToken */) {
	                    return visitCommaExpression(node);
	                }
	                // [source]
	                //      a() + (yield) + c()
	                //
	                // [intermediate]
	                //  .local _a
	                //      _a = a();
	                //  .yield resumeLabel
	                //      _a + %sent% + c()
	                var clone_4 = ts.getMutableClone(node);
	                clone_4.left = cacheExpression(ts.visitNode(node.left, visitor, ts.isExpression));
	                clone_4.right = ts.visitNode(node.right, visitor, ts.isExpression);
	                return clone_4;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a logical binary expression containing `yield`.
	         *
	         * @param node A node to visit.
	         */
	        function visitLogicalBinaryExpression(node) {
	            // Logical binary expressions (`&&` and `||`) are shortcutting expressions and need
	            // to be transformed as such:
	            //
	            // [source]
	            //      x = a() && yield;
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = a();
	            //  .brfalse resultLabel, (_a)
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .mark resultLabel
	            //      x = _a;
	            //
	            // [source]
	            //      x = a() || yield;
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = a();
	            //  .brtrue resultLabel, (_a)
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .mark resultLabel
	            //      x = _a;
	            var resultLabel = defineLabel();
	            var resultLocal = declareLocal();
	            emitAssignment(resultLocal, ts.visitNode(node.left, visitor, ts.isExpression), /*location*/ node.left);
	            if (node.operatorToken.kind === 53 /* AmpersandAmpersandToken */) {
	                // Logical `&&` shortcuts when the left-hand operand is falsey.
	                emitBreakWhenFalse(resultLabel, resultLocal, /*location*/ node.left);
	            }
	            else {
	                // Logical `||` shortcuts when the left-hand operand is truthy.
	                emitBreakWhenTrue(resultLabel, resultLocal, /*location*/ node.left);
	            }
	            emitAssignment(resultLocal, ts.visitNode(node.right, visitor, ts.isExpression), /*location*/ node.right);
	            markLabel(resultLabel);
	            return resultLocal;
	        }
	        /**
	         * Visits a comma expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitCommaExpression(node) {
	            // [source]
	            //      x = a(), yield, b();
	            //
	            // [intermediate]
	            //      a();
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      x = %sent%, b();
	            var pendingExpressions = [];
	            visit(node.left);
	            visit(node.right);
	            return ts.inlineExpressions(pendingExpressions);
	            function visit(node) {
	                if (ts.isBinaryExpression(node) && node.operatorToken.kind === 26 /* CommaToken */) {
	                    visit(node.left);
	                    visit(node.right);
	                }
	                else {
	                    if (containsYield(node) && pendingExpressions.length > 0) {
	                        emitWorker(1 /* Statement */, [ts.createStatement(ts.inlineExpressions(pendingExpressions))]);
	                        pendingExpressions = [];
	                    }
	                    pendingExpressions.push(ts.visitNode(node, visitor, ts.isExpression));
	                }
	            }
	        }
	        /**
	         * Visits a conditional expression containing `yield`.
	         *
	         * @param node The node to visit.
	         */
	        function visitConditionalExpression(node) {
	            // [source]
	            //      x = a() ? yield : b();
	            //
	            // [intermediate]
	            //  .local _a
	            //  .brfalse whenFalseLabel, (a())
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      _a = %sent%;
	            //  .br resultLabel
	            //  .mark whenFalseLabel
	            //      _a = b();
	            //  .mark resultLabel
	            //      x = _a;
	            // We only need to perform a specific transformation if a `yield` expression exists
	            // in either the `whenTrue` or `whenFalse` branches.
	            // A `yield` in the condition will be handled by the normal visitor.
	            if (containsYield(node.whenTrue) || containsYield(node.whenFalse)) {
	                var whenFalseLabel = defineLabel();
	                var resultLabel = defineLabel();
	                var resultLocal = declareLocal();
	                emitBreakWhenFalse(whenFalseLabel, ts.visitNode(node.condition, visitor, ts.isExpression), /*location*/ node.condition);
	                emitAssignment(resultLocal, ts.visitNode(node.whenTrue, visitor, ts.isExpression), /*location*/ node.whenTrue);
	                emitBreak(resultLabel);
	                markLabel(whenFalseLabel);
	                emitAssignment(resultLocal, ts.visitNode(node.whenFalse, visitor, ts.isExpression), /*location*/ node.whenFalse);
	                markLabel(resultLabel);
	                return resultLocal;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        /**
	         * Visits a `yield` expression.
	         *
	         * @param node The node to visit.
	         */
	        function visitYieldExpression(node) {
	            // [source]
	            //      x = yield a();
	            //
	            // [intermediate]
	            //  .yield resumeLabel, (a())
	            //  .mark resumeLabel
	            //      x = %sent%;
	            var resumeLabel = defineLabel();
	            var expression = ts.visitNode(node.expression, visitor, ts.isExpression);
	            if (node.asteriskToken) {
	                var iterator = (ts.getEmitFlags(node.expression) & 8388608 /* Iterator */) === 0
	                    ? ts.createValuesHelper(context, expression, /*location*/ node)
	                    : expression;
	                emitYieldStar(iterator, /*location*/ node);
	            }
	            else {
	                emitYield(expression, /*location*/ node);
	            }
	            markLabel(resumeLabel);
	            return createGeneratorResume(/*location*/ node);
	        }
	        /**
	         * Visits an ArrayLiteralExpression that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitArrayLiteralExpression(node) {
	            return visitElements(node.elements, /*leadingElement*/ undefined, /*location*/ undefined, node.multiLine);
	        }
	        /**
	         * Visits an array of expressions containing one or more YieldExpression nodes
	         * and returns an expression for the resulting value.
	         *
	         * @param elements The elements to visit.
	         * @param multiLine Whether array literals created should be emitted on multiple lines.
	         */
	        function visitElements(elements, leadingElement, location, multiLine) {
	            // [source]
	            //      ar = [1, yield, 2];
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = [1];
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      ar = _a.concat([%sent%, 2]);
	            var numInitialElements = countInitialNodesWithoutYield(elements);
	            var temp;
	            if (numInitialElements > 0) {
	                temp = declareLocal();
	                var initialElements = ts.visitNodes(elements, visitor, ts.isExpression, 0, numInitialElements);
	                emitAssignment(temp, ts.createArrayLiteral(leadingElement
	                    ? [leadingElement].concat(initialElements) : initialElements));
	                leadingElement = undefined;
	            }
	            var expressions = ts.reduceLeft(elements, reduceElement, [], numInitialElements);
	            return temp
	                ? ts.createArrayConcat(temp, [ts.createArrayLiteral(expressions, multiLine)])
	                : ts.setTextRange(ts.createArrayLiteral(leadingElement ? [leadingElement].concat(expressions) : expressions, multiLine), location);
	            function reduceElement(expressions, element) {
	                if (containsYield(element) && expressions.length > 0) {
	                    var hasAssignedTemp = temp !== undefined;
	                    if (!temp) {
	                        temp = declareLocal();
	                    }
	                    emitAssignment(temp, hasAssignedTemp
	                        ? ts.createArrayConcat(temp, [ts.createArrayLiteral(expressions, multiLine)])
	                        : ts.createArrayLiteral(leadingElement ? [leadingElement].concat(expressions) : expressions, multiLine));
	                    leadingElement = undefined;
	                    expressions = [];
	                }
	                expressions.push(ts.visitNode(element, visitor, ts.isExpression));
	                return expressions;
	            }
	        }
	        function visitObjectLiteralExpression(node) {
	            // [source]
	            //      o = {
	            //          a: 1,
	            //          b: yield,
	            //          c: 2
	            //      };
	            //
	            // [intermediate]
	            //  .local _a
	            //      _a = {
	            //          a: 1
	            //      };
	            //  .yield resumeLabel
	            //  .mark resumeLabel
	            //      o = (_a.b = %sent%,
	            //          _a.c = 2,
	            //          _a);
	            var properties = node.properties;
	            var multiLine = node.multiLine;
	            var numInitialProperties = countInitialNodesWithoutYield(properties);
	            var temp = declareLocal();
	            emitAssignment(temp, ts.createObjectLiteral(ts.visitNodes(properties, visitor, ts.isObjectLiteralElementLike, 0, numInitialProperties), multiLine));
	            var expressions = ts.reduceLeft(properties, reduceProperty, [], numInitialProperties);
	            expressions.push(multiLine ? ts.startOnNewLine(ts.getMutableClone(temp)) : temp);
	            return ts.inlineExpressions(expressions);
	            function reduceProperty(expressions, property) {
	                if (containsYield(property) && expressions.length > 0) {
	                    emitStatement(ts.createStatement(ts.inlineExpressions(expressions)));
	                    expressions = [];
	                }
	                var expression = ts.createExpressionForObjectLiteralElementLike(node, property, temp);
	                var visited = ts.visitNode(expression, visitor, ts.isExpression);
	                if (visited) {
	                    if (multiLine) {
	                        ts.startOnNewLine(visited);
	                    }
	                    expressions.push(visited);
	                }
	                return expressions;
	            }
	        }
	        /**
	         * Visits an ElementAccessExpression that contains a YieldExpression.
	         *
	         * @param node The node to visit.
	         */
	        function visitElementAccessExpression(node) {
	            if (containsYield(node.argumentExpression)) {
	                // [source]
	                //      a = x[yield];
	                //
	                // [intermediate]
	                //  .local _a
	                //      _a = x;
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      a = _a[%sent%]
	                var clone_5 = ts.getMutableClone(node);
	                clone_5.expression = cacheExpression(ts.visitNode(node.expression, visitor, ts.isLeftHandSideExpression));
	                clone_5.argumentExpression = ts.visitNode(node.argumentExpression, visitor, ts.isExpression);
	                return clone_5;
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitCallExpression(node) {
	            if (!ts.isImportCall(node) && ts.forEach(node.arguments, containsYield)) {
	                // [source]
	                //      a.b(1, yield, 2);
	                //
	                // [intermediate]
	                //  .local _a, _b, _c
	                //      _b = (_a = a).b;
	                //      _c = [1];
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      _b.apply(_a, _c.concat([%sent%, 2]));
	                var _a = ts.createCallBinding(node.expression, hoistVariableDeclaration, languageVersion, /*cacheIdentifiers*/ true), target = _a.target, thisArg = _a.thisArg;
	                return ts.setOriginalNode(ts.createFunctionApply(cacheExpression(ts.visitNode(target, visitor, ts.isLeftHandSideExpression)), thisArg, visitElements(node.arguments), 
	                /*location*/ node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function visitNewExpression(node) {
	            if (ts.forEach(node.arguments, containsYield)) {
	                // [source]
	                //      new a.b(1, yield, 2);
	                //
	                // [intermediate]
	                //  .local _a, _b, _c
	                //      _b = (_a = a.b).bind;
	                //      _c = [1];
	                //  .yield resumeLabel
	                //  .mark resumeLabel
	                //      new (_b.apply(_a, _c.concat([%sent%, 2])));
	                var _a = ts.createCallBinding(ts.createPropertyAccess(node.expression, "bind"), hoistVariableDeclaration), target = _a.target, thisArg = _a.thisArg;
	                return ts.setOriginalNode(ts.setTextRange(ts.createNew(ts.createFunctionApply(cacheExpression(ts.visitNode(target, visitor, ts.isExpression)), thisArg, visitElements(node.arguments, 
	                /*leadingElement*/ ts.createVoidZero())), 
	                /*typeArguments*/ undefined, []), node), node);
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitStatements(statements, start) {
	            if (start === void 0) { start = 0; }
	            var numStatements = statements.length;
	            for (var i = start; i < numStatements; i++) {
	                transformAndEmitStatement(statements[i]);
	            }
	        }
	        function transformAndEmitEmbeddedStatement(node) {
	            if (ts.isBlock(node)) {
	                transformAndEmitStatements(node.statements);
	            }
	            else {
	                transformAndEmitStatement(node);
	            }
	        }
	        function transformAndEmitStatement(node) {
	            var savedInStatementContainingYield = inStatementContainingYield;
	            if (!inStatementContainingYield) {
	                inStatementContainingYield = containsYield(node);
	            }
	            transformAndEmitStatementWorker(node);
	            inStatementContainingYield = savedInStatementContainingYield;
	        }
	        function transformAndEmitStatementWorker(node) {
	            switch (node.kind) {
	                case 212 /* Block */:
	                    return transformAndEmitBlock(node);
	                case 215 /* ExpressionStatement */:
	                    return transformAndEmitExpressionStatement(node);
	                case 216 /* IfStatement */:
	                    return transformAndEmitIfStatement(node);
	                case 217 /* DoStatement */:
	                    return transformAndEmitDoStatement(node);
	                case 218 /* WhileStatement */:
	                    return transformAndEmitWhileStatement(node);
	                case 219 /* ForStatement */:
	                    return transformAndEmitForStatement(node);
	                case 220 /* ForInStatement */:
	                    return transformAndEmitForInStatement(node);
	                case 222 /* ContinueStatement */:
	                    return transformAndEmitContinueStatement(node);
	                case 223 /* BreakStatement */:
	                    return transformAndEmitBreakStatement(node);
	                case 224 /* ReturnStatement */:
	                    return transformAndEmitReturnStatement(node);
	                case 225 /* WithStatement */:
	                    return transformAndEmitWithStatement(node);
	                case 226 /* SwitchStatement */:
	                    return transformAndEmitSwitchStatement(node);
	                case 227 /* LabeledStatement */:
	                    return transformAndEmitLabeledStatement(node);
	                case 228 /* ThrowStatement */:
	                    return transformAndEmitThrowStatement(node);
	                case 229 /* TryStatement */:
	                    return transformAndEmitTryStatement(node);
	                default:
	                    return emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitBlock(node) {
	            if (containsYield(node)) {
	                transformAndEmitStatements(node.statements);
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitExpressionStatement(node) {
	            emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	        }
	        function transformAndEmitVariableDeclarationList(node) {
	            for (var _i = 0, _a = node.declarations; _i < _a.length; _i++) {
	                var variable = _a[_i];
	                var name = ts.getSynthesizedClone(variable.name);
	                ts.setCommentRange(name, variable.name);
	                hoistVariableDeclaration(name);
	            }
	            var variables = ts.getInitializedVariables(node);
	            var numVariables = variables.length;
	            var variablesWritten = 0;
	            var pendingExpressions = [];
	            while (variablesWritten < numVariables) {
	                for (var i = variablesWritten; i < numVariables; i++) {
	                    var variable = variables[i];
	                    if (containsYield(variable.initializer) && pendingExpressions.length > 0) {
	                        break;
	                    }
	                    pendingExpressions.push(transformInitializedVariable(variable));
	                }
	                if (pendingExpressions.length) {
	                    emitStatement(ts.createStatement(ts.inlineExpressions(pendingExpressions)));
	                    variablesWritten += pendingExpressions.length;
	                    pendingExpressions = [];
	                }
	            }
	            return undefined;
	        }
	        function transformInitializedVariable(node) {
	            return ts.setSourceMapRange(ts.createAssignment(ts.setSourceMapRange(ts.getSynthesizedClone(node.name), node.name), ts.visitNode(node.initializer, visitor, ts.isExpression)), node);
	        }
	        function transformAndEmitIfStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      if (x)
	                //          /*thenStatement*/
	                //      else
	                //          /*elseStatement*/
	                //
	                // [intermediate]
	                //  .brfalse elseLabel, (x)
	                //      /*thenStatement*/
	                //  .br endLabel
	                //  .mark elseLabel
	                //      /*elseStatement*/
	                //  .mark endLabel
	                if (containsYield(node.thenStatement) || containsYield(node.elseStatement)) {
	                    var endLabel = defineLabel();
	                    var elseLabel = node.elseStatement ? defineLabel() : undefined;
	                    emitBreakWhenFalse(node.elseStatement ? elseLabel : endLabel, ts.visitNode(node.expression, visitor, ts.isExpression), /*location*/ node.expression);
	                    transformAndEmitEmbeddedStatement(node.thenStatement);
	                    if (node.elseStatement) {
	                        emitBreak(endLabel);
	                        markLabel(elseLabel);
	                        transformAndEmitEmbeddedStatement(node.elseStatement);
	                    }
	                    markLabel(endLabel);
	                }
	                else {
	                    emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	                }
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitDoStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      do {
	                //          /*body*/
	                //      }
	                //      while (i < 10);
	                //
	                // [intermediate]
	                //  .loop conditionLabel, endLabel
	                //  .mark loopLabel
	                //      /*body*/
	                //  .mark conditionLabel
	                //  .brtrue loopLabel, (i < 10)
	                //  .endloop
	                //  .mark endLabel
	                var conditionLabel = defineLabel();
	                var loopLabel = defineLabel();
	                beginLoopBlock(/*continueLabel*/ conditionLabel);
	                markLabel(loopLabel);
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(conditionLabel);
	                emitBreakWhenTrue(loopLabel, ts.visitNode(node.expression, visitor, ts.isExpression));
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitDoStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	                node = ts.visitEachChild(node, visitor, context);
	                endLoopBlock();
	                return node;
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformAndEmitWhileStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      while (i < 10) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .loop loopLabel, endLabel
	                //  .mark loopLabel
	                //  .brfalse endLabel, (i < 10)
	                //      /*body*/
	                //  .br loopLabel
	                //  .endloop
	                //  .mark endLabel
	                var loopLabel = defineLabel();
	                var endLabel = beginLoopBlock(loopLabel);
	                markLabel(loopLabel);
	                emitBreakWhenFalse(endLabel, ts.visitNode(node.expression, visitor, ts.isExpression));
	                transformAndEmitEmbeddedStatement(node.statement);
	                emitBreak(loopLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitWhileStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	                node = ts.visitEachChild(node, visitor, context);
	                endLoopBlock();
	                return node;
	            }
	            else {
	                return ts.visitEachChild(node, visitor, context);
	            }
	        }
	        function transformAndEmitForStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      for (var i = 0; i < 10; i++) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .local i
	                //      i = 0;
	                //  .loop incrementLabel, endLoopLabel
	                //  .mark conditionLabel
	                //  .brfalse endLoopLabel, (i < 10)
	                //      /*body*/
	                //  .mark incrementLabel
	                //      i++;
	                //  .br conditionLabel
	                //  .endloop
	                //  .mark endLoopLabel
	                var conditionLabel = defineLabel();
	                var incrementLabel = defineLabel();
	                var endLabel = beginLoopBlock(incrementLabel);
	                if (node.initializer) {
	                    var initializer = node.initializer;
	                    if (ts.isVariableDeclarationList(initializer)) {
	                        transformAndEmitVariableDeclarationList(initializer);
	                    }
	                    else {
	                        emitStatement(ts.setTextRange(ts.createStatement(ts.visitNode(initializer, visitor, ts.isExpression)), initializer));
	                    }
	                }
	                markLabel(conditionLabel);
	                if (node.condition) {
	                    emitBreakWhenFalse(endLabel, ts.visitNode(node.condition, visitor, ts.isExpression));
	                }
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(incrementLabel);
	                if (node.incrementor) {
	                    emitStatement(ts.setTextRange(ts.createStatement(ts.visitNode(node.incrementor, visitor, ts.isExpression)), node.incrementor));
	                }
	                emitBreak(conditionLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitForStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	            }
	            var initializer = node.initializer;
	            if (initializer && ts.isVariableDeclarationList(initializer)) {
	                for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                var variables = ts.getInitializedVariables(initializer);
	                node = ts.updateFor(node, variables.length > 0
	                    ? ts.inlineExpressions(ts.map(variables, transformInitializedVariable))
	                    : undefined, ts.visitNode(node.condition, visitor, ts.isExpression), ts.visitNode(node.incrementor, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            }
	            else {
	                node = ts.visitEachChild(node, visitor, context);
	            }
	            if (inStatementContainingYield) {
	                endLoopBlock();
	            }
	            return node;
	        }
	        function transformAndEmitForInStatement(node) {
	            // TODO(rbuckton): Source map locations
	            if (containsYield(node)) {
	                // [source]
	                //      for (var p in o) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a, _b, _i
	                //      _a = [];
	                //      for (_b in o) _a.push(_b);
	                //      _i = 0;
	                //  .loop incrementLabel, endLoopLabel
	                //  .mark conditionLabel
	                //  .brfalse endLoopLabel, (_i < _a.length)
	                //      p = _a[_i];
	                //      /*body*/
	                //  .mark incrementLabel
	                //      _b++;
	                //  .br conditionLabel
	                //  .endloop
	                //  .mark endLoopLabel
	                var keysArray = declareLocal(); // _a
	                var key = declareLocal(); // _b
	                var keysIndex = ts.createLoopVariable(); // _i
	                var initializer = node.initializer;
	                hoistVariableDeclaration(keysIndex);
	                emitAssignment(keysArray, ts.createArrayLiteral());
	                emitStatement(ts.createForIn(key, ts.visitNode(node.expression, visitor, ts.isExpression), ts.createStatement(ts.createCall(ts.createPropertyAccess(keysArray, "push"), 
	                /*typeArguments*/ undefined, [key]))));
	                emitAssignment(keysIndex, ts.createLiteral(0));
	                var conditionLabel = defineLabel();
	                var incrementLabel = defineLabel();
	                var endLabel = beginLoopBlock(incrementLabel);
	                markLabel(conditionLabel);
	                emitBreakWhenFalse(endLabel, ts.createLessThan(keysIndex, ts.createPropertyAccess(keysArray, "length")));
	                var variable = void 0;
	                if (ts.isVariableDeclarationList(initializer)) {
	                    for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                        var variable_1 = _a[_i];
	                        hoistVariableDeclaration(variable_1.name);
	                    }
	                    variable = ts.getSynthesizedClone(initializer.declarations[0].name);
	                }
	                else {
	                    variable = ts.visitNode(initializer, visitor, ts.isExpression);
	                    ts.Debug.assert(ts.isLeftHandSideExpression(variable));
	                }
	                emitAssignment(variable, ts.createElementAccess(keysArray, keysIndex));
	                transformAndEmitEmbeddedStatement(node.statement);
	                markLabel(incrementLabel);
	                emitStatement(ts.createStatement(ts.createPostfixIncrement(keysIndex)));
	                emitBreak(conditionLabel);
	                endLoopBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitForInStatement(node) {
	            // [source]
	            //      for (var x in a) {
	            //          /*body*/
	            //      }
	            //
	            // [intermediate]
	            //  .local x
	            //  .loop
	            //      for (x in a) {
	            //          /*body*/
	            //      }
	            //  .endloop
	            if (inStatementContainingYield) {
	                beginScriptLoopBlock();
	            }
	            var initializer = node.initializer;
	            if (ts.isVariableDeclarationList(initializer)) {
	                for (var _i = 0, _a = initializer.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    hoistVariableDeclaration(variable.name);
	                }
	                node = ts.updateForIn(node, initializer.declarations[0].name, ts.visitNode(node.expression, visitor, ts.isExpression), ts.visitNode(node.statement, visitor, ts.isStatement, ts.liftToBlock));
	            }
	            else {
	                node = ts.visitEachChild(node, visitor, context);
	            }
	            if (inStatementContainingYield) {
	                endLoopBlock();
	            }
	            return node;
	        }
	        function transformAndEmitContinueStatement(node) {
	            var label = findContinueTarget(node.label ? ts.idText(node.label) : undefined);
	            if (label > 0) {
	                emitBreak(label, /*location*/ node);
	            }
	            else {
	                // invalid continue without a containing loop. Leave the node as is, per #17875.
	                emitStatement(node);
	            }
	        }
	        function visitContinueStatement(node) {
	            if (inStatementContainingYield) {
	                var label = findContinueTarget(node.label && ts.idText(node.label));
	                if (label > 0) {
	                    return createInlineBreak(label, /*location*/ node);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitBreakStatement(node) {
	            var label = findBreakTarget(node.label ? ts.idText(node.label) : undefined);
	            if (label > 0) {
	                emitBreak(label, /*location*/ node);
	            }
	            else {
	                // invalid break without a containing loop, switch, or labeled statement. Leave the node as is, per #17875.
	                emitStatement(node);
	            }
	        }
	        function visitBreakStatement(node) {
	            if (inStatementContainingYield) {
	                var label = findBreakTarget(node.label && ts.idText(node.label));
	                if (label > 0) {
	                    return createInlineBreak(label, /*location*/ node);
	                }
	            }
	            return ts.visitEachChild(node, visitor, context);
	        }
	        function transformAndEmitReturnStatement(node) {
	            emitReturn(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function visitReturnStatement(node) {
	            return createInlineReturn(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function transformAndEmitWithStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      with (x) {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .with (x)
	                //      /*body*/
	                //  .endwith
	                beginWithBlock(cacheExpression(ts.visitNode(node.expression, visitor, ts.isExpression)));
	                transformAndEmitEmbeddedStatement(node.statement);
	                endWithBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function transformAndEmitSwitchStatement(node) {
	            if (containsYield(node.caseBlock)) {
	                // [source]
	                //      switch (x) {
	                //          case a:
	                //              /*caseStatements*/
	                //          case b:
	                //              /*caseStatements*/
	                //          default:
	                //              /*defaultStatements*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a
	                //  .switch endLabel
	                //      _a = x;
	                //      switch (_a) {
	                //          case a:
	                //  .br clauseLabels[0]
	                //      }
	                //      switch (_a) {
	                //          case b:
	                //  .br clauseLabels[1]
	                //      }
	                //  .br clauseLabels[2]
	                //  .mark clauseLabels[0]
	                //      /*caseStatements*/
	                //  .mark clauseLabels[1]
	                //      /*caseStatements*/
	                //  .mark clauseLabels[2]
	                //      /*caseStatements*/
	                //  .endswitch
	                //  .mark endLabel
	                var caseBlock = node.caseBlock;
	                var numClauses = caseBlock.clauses.length;
	                var endLabel = beginSwitchBlock();
	                var expression = cacheExpression(ts.visitNode(node.expression, visitor, ts.isExpression));
	                // Create labels for each clause and find the index of the first default clause.
	                var clauseLabels = [];
	                var defaultClauseIndex = -1;
	                for (var i = 0; i < numClauses; i++) {
	                    var clause = caseBlock.clauses[i];
	                    clauseLabels.push(defineLabel());
	                    if (clause.kind === 266 /* DefaultClause */ && defaultClauseIndex === -1) {
	                        defaultClauseIndex = i;
	                    }
	                }
	                // Emit switch statements for each run of case clauses either from the first case
	                // clause or the next case clause with a `yield` in its expression, up to the next
	                // case clause with a `yield` in its expression.
	                var clausesWritten = 0;
	                var pendingClauses = [];
	                while (clausesWritten < numClauses) {
	                    var defaultClausesSkipped = 0;
	                    for (var i = clausesWritten; i < numClauses; i++) {
	                        var clause = caseBlock.clauses[i];
	                        if (clause.kind === 265 /* CaseClause */) {
	                            if (containsYield(clause.expression) && pendingClauses.length > 0) {
	                                break;
	                            }
	                            pendingClauses.push(ts.createCaseClause(ts.visitNode(clause.expression, visitor, ts.isExpression), [
	                                createInlineBreak(clauseLabels[i], /*location*/ clause.expression)
	                            ]));
	                        }
	                        else {
	                            defaultClausesSkipped++;
	                        }
	                    }
	                    if (pendingClauses.length) {
	                        emitStatement(ts.createSwitch(expression, ts.createCaseBlock(pendingClauses)));
	                        clausesWritten += pendingClauses.length;
	                        pendingClauses = [];
	                    }
	                    if (defaultClausesSkipped > 0) {
	                        clausesWritten += defaultClausesSkipped;
	                        defaultClausesSkipped = 0;
	                    }
	                }
	                if (defaultClauseIndex >= 0) {
	                    emitBreak(clauseLabels[defaultClauseIndex]);
	                }
	                else {
	                    emitBreak(endLabel);
	                }
	                for (var i = 0; i < numClauses; i++) {
	                    markLabel(clauseLabels[i]);
	                    transformAndEmitStatements(caseBlock.clauses[i].statements);
	                }
	                endSwitchBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitSwitchStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptSwitchBlock();
	            }
	            node = ts.visitEachChild(node, visitor, context);
	            if (inStatementContainingYield) {
	                endSwitchBlock();
	            }
	            return node;
	        }
	        function transformAndEmitLabeledStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      x: {
	                //          /*body*/
	                //      }
	                //
	                // [intermediate]
	                //  .labeled "x", endLabel
	                //      /*body*/
	                //  .endlabeled
	                //  .mark endLabel
	                beginLabeledBlock(ts.idText(node.label));
	                transformAndEmitEmbeddedStatement(node.statement);
	                endLabeledBlock();
	            }
	            else {
	                emitStatement(ts.visitNode(node, visitor, ts.isStatement));
	            }
	        }
	        function visitLabeledStatement(node) {
	            if (inStatementContainingYield) {
	                beginScriptLabeledBlock(ts.idText(node.label));
	            }
	            node = ts.visitEachChild(node, visitor, context);
	            if (inStatementContainingYield) {
	                endLabeledBlock();
	            }
	            return node;
	        }
	        function transformAndEmitThrowStatement(node) {
	            emitThrow(ts.visitNode(node.expression, visitor, ts.isExpression), 
	            /*location*/ node);
	        }
	        function transformAndEmitTryStatement(node) {
	            if (containsYield(node)) {
	                // [source]
	                //      try {
	                //          /*tryBlock*/
	                //      }
	                //      catch (e) {
	                //          /*catchBlock*/
	                //      }
	                //      finally {
	                //          /*finallyBlock*/
	                //      }
	                //
	                // [intermediate]
	                //  .local _a
	                //  .try tryLabel, catchLabel, finallyLabel, endLabel
	                //  .mark tryLabel
	                //  .nop
	                //      /*tryBlock*/
	                //  .br endLabel
	                //  .catch
	                //  .mark catchLabel
	                //      _a = %error%;
	                //      /*catchBlock*/
	                //  .br endLabel
	                //  .finally
	                //  .mark finallyLabel
	                //      /*finallyBlock*/
	                //  .endfinally
	                //  .endtry
	                //  .mark endLabel
	                beginExceptionBlock();
	                transformAndEmitEmbeddedStatement(node.tryBlock);
	                if (node.catchClause) {
	                    beginCatchBlock(node.catchClause.variableDeclaration);
	                    transformAndEmitEmbeddedStatement(node.catchClause.block);
	                }
	                if (node.finallyBlock) {
	                    beginFinallyBlock();
	                    transformAndEmitEmbeddedStatement(node.finallyBlock);
	                }
	                endExceptionBlock();
	            }
	            else {
	                emitStatement(ts.visitEachChild(node, visitor, context));
	            }
	        }
	        function containsYield(node) {
	            return node && (node.transformFlags & 16777216 /* ContainsYield */) !== 0;
	        }
	        function countInitialNodesWithoutYield(nodes) {
	            var numNodes = nodes.length;
	            for (var i = 0; i < numNodes; i++) {
	                if (containsYield(nodes[i])) {
	                    return i;
	                }
	            }
	            return -1;
	        }
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            return node;
	        }
	        function substituteExpression(node) {
	            if (ts.isIdentifier(node)) {
	                return substituteExpressionIdentifier(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            if (!ts.isGeneratedIdentifier(node) && renamedCatchVariables && renamedCatchVariables.has(ts.idText(node))) {
	                var original = ts.getOriginalNode(node);
	                if (ts.isIdentifier(original) && original.parent) {
	                    var declaration = resolver.getReferencedValueDeclaration(original);
	                    if (declaration) {
	                        var name = renamedCatchVariableDeclarations[ts.getOriginalNodeId(declaration)];
	                        if (name) {
	                            var clone_6 = ts.getMutableClone(name);
	                            ts.setSourceMapRange(clone_6, node);
	                            ts.setCommentRange(clone_6, node);
	                            return clone_6;
	                        }
	                    }
	                }
	            }
	            return node;
	        }
	        function cacheExpression(node) {
	            var temp;
	            if (ts.isGeneratedIdentifier(node) || ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                return node;
	            }
	            temp = ts.createTempVariable(hoistVariableDeclaration);
	            emitAssignment(temp, node, /*location*/ node);
	            return temp;
	        }
	        function declareLocal(name) {
	            var temp = name
	                ? ts.createUniqueName(name)
	                : ts.createTempVariable(/*recordTempVariable*/ undefined);
	            hoistVariableDeclaration(temp);
	            return temp;
	        }
	        /**
	         * Defines a label, uses as the target of a Break operation.
	         */
	        function defineLabel() {
	            if (!labelOffsets) {
	                labelOffsets = [];
	            }
	            var label = nextLabelId;
	            nextLabelId++;
	            labelOffsets[label] = -1;
	            return label;
	        }
	        /**
	         * Marks the current operation with the specified label.
	         */
	        function markLabel(label) {
	            ts.Debug.assert(labelOffsets !== undefined, "No labels were defined.");
	            labelOffsets[label] = operations ? operations.length : 0;
	        }
	        /**
	         * Begins a block operation (With, Break/Continue, Try/Catch/Finally)
	         *
	         * @param block Information about the block.
	         */
	        function beginBlock(block) {
	            if (!blocks) {
	                blocks = [];
	                blockActions = [];
	                blockOffsets = [];
	                blockStack = [];
	            }
	            var index = blockActions.length;
	            blockActions[index] = 0 /* Open */;
	            blockOffsets[index] = operations ? operations.length : 0;
	            blocks[index] = block;
	            blockStack.push(block);
	            return index;
	        }
	        /**
	         * Ends the current block operation.
	         */
	        function endBlock() {
	            var block = peekBlock();
	            ts.Debug.assert(block !== undefined, "beginBlock was never called.");
	            var index = blockActions.length;
	            blockActions[index] = 1 /* Close */;
	            blockOffsets[index] = operations ? operations.length : 0;
	            blocks[index] = block;
	            blockStack.pop();
	            return block;
	        }
	        /**
	         * Gets the current open block.
	         */
	        function peekBlock() {
	            return ts.lastOrUndefined(blockStack);
	        }
	        /**
	         * Gets the kind of the current open block.
	         */
	        function peekBlockKind() {
	            var block = peekBlock();
	            return block && block.kind;
	        }
	        /**
	         * Begins a code block for a generated `with` statement.
	         *
	         * @param expression An identifier representing expression for the `with` block.
	         */
	        function beginWithBlock(expression) {
	            var startLabel = defineLabel();
	            var endLabel = defineLabel();
	            markLabel(startLabel);
	            beginBlock({
	                kind: 1 /* With */,
	                expression: expression,
	                startLabel: startLabel,
	                endLabel: endLabel
	            });
	        }
	        /**
	         * Ends a code block for a generated `with` statement.
	         */
	        function endWithBlock() {
	            ts.Debug.assert(peekBlockKind() === 1 /* With */);
	            var block = endBlock();
	            markLabel(block.endLabel);
	        }
	        /**
	         * Begins a code block for a generated `try` statement.
	         */
	        function beginExceptionBlock() {
	            var startLabel = defineLabel();
	            var endLabel = defineLabel();
	            markLabel(startLabel);
	            beginBlock({
	                kind: 0 /* Exception */,
	                state: 0 /* Try */,
	                startLabel: startLabel,
	                endLabel: endLabel
	            });
	            emitNop();
	            return endLabel;
	        }
	        /**
	         * Enters the `catch` clause of a generated `try` statement.
	         *
	         * @param variable The catch variable.
	         */
	        function beginCatchBlock(variable) {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            // generated identifiers should already be unique within a file
	            var name;
	            if (ts.isGeneratedIdentifier(variable.name)) {
	                name = variable.name;
	                hoistVariableDeclaration(variable.name);
	            }
	            else {
	                var text = ts.idText(variable.name);
	                name = declareLocal(text);
	                if (!renamedCatchVariables) {
	                    renamedCatchVariables = ts.createMap();
	                    renamedCatchVariableDeclarations = [];
	                    context.enableSubstitution(71 /* Identifier */);
	                }
	                renamedCatchVariables.set(text, true);
	                renamedCatchVariableDeclarations[ts.getOriginalNodeId(variable)] = name;
	            }
	            var exception = peekBlock();
	            ts.Debug.assert(exception.state < 1 /* Catch */);
	            var endLabel = exception.endLabel;
	            emitBreak(endLabel);
	            var catchLabel = defineLabel();
	            markLabel(catchLabel);
	            exception.state = 1 /* Catch */;
	            exception.catchVariable = name;
	            exception.catchLabel = catchLabel;
	            emitAssignment(name, ts.createCall(ts.createPropertyAccess(state, "sent"), /*typeArguments*/ undefined, []));
	            emitNop();
	        }
	        /**
	         * Enters the `finally` block of a generated `try` statement.
	         */
	        function beginFinallyBlock() {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            var exception = peekBlock();
	            ts.Debug.assert(exception.state < 2 /* Finally */);
	            var endLabel = exception.endLabel;
	            emitBreak(endLabel);
	            var finallyLabel = defineLabel();
	            markLabel(finallyLabel);
	            exception.state = 2 /* Finally */;
	            exception.finallyLabel = finallyLabel;
	        }
	        /**
	         * Ends the code block for a generated `try` statement.
	         */
	        function endExceptionBlock() {
	            ts.Debug.assert(peekBlockKind() === 0 /* Exception */);
	            var exception = endBlock();
	            var state = exception.state;
	            if (state < 2 /* Finally */) {
	                emitBreak(exception.endLabel);
	            }
	            else {
	                emitEndfinally();
	            }
	            markLabel(exception.endLabel);
	            emitNop();
	            exception.state = 3 /* Done */;
	        }
	        /**
	         * Begins a code block that supports `break` or `continue` statements that are defined in
	         * the source tree and not from generated code.
	         *
	         * @param labelText Names from containing labeled statements.
	         */
	        function beginScriptLoopBlock() {
	            beginBlock({
	                kind: 3 /* Loop */,
	                isScript: true,
	                breakLabel: -1,
	                continueLabel: -1
	            });
	        }
	        /**
	         * Begins a code block that supports `break` or `continue` statements that are defined in
	         * generated code. Returns a label used to mark the operation to which to jump when a
	         * `break` statement targets this block.
	         *
	         * @param continueLabel A Label used to mark the operation to which to jump when a
	         *                      `continue` statement targets this block.
	         */
	        function beginLoopBlock(continueLabel) {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 3 /* Loop */,
	                isScript: false,
	                breakLabel: breakLabel,
	                continueLabel: continueLabel,
	            });
	            return breakLabel;
	        }
	        /**
	         * Ends a code block that supports `break` or `continue` statements that are defined in
	         * generated code or in the source tree.
	         */
	        function endLoopBlock() {
	            ts.Debug.assert(peekBlockKind() === 3 /* Loop */);
	            var block = endBlock();
	            var breakLabel = block.breakLabel;
	            if (!block.isScript) {
	                markLabel(breakLabel);
	            }
	        }
	        /**
	         * Begins a code block that supports `break` statements that are defined in the source
	         * tree and not from generated code.
	         *
	         */
	        function beginScriptSwitchBlock() {
	            beginBlock({
	                kind: 2 /* Switch */,
	                isScript: true,
	                breakLabel: -1
	            });
	        }
	        /**
	         * Begins a code block that supports `break` statements that are defined in generated code.
	         * Returns a label used to mark the operation to which to jump when a `break` statement
	         * targets this block.
	         */
	        function beginSwitchBlock() {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 2 /* Switch */,
	                isScript: false,
	                breakLabel: breakLabel,
	            });
	            return breakLabel;
	        }
	        /**
	         * Ends a code block that supports `break` statements that are defined in generated code.
	         */
	        function endSwitchBlock() {
	            ts.Debug.assert(peekBlockKind() === 2 /* Switch */);
	            var block = endBlock();
	            var breakLabel = block.breakLabel;
	            if (!block.isScript) {
	                markLabel(breakLabel);
	            }
	        }
	        function beginScriptLabeledBlock(labelText) {
	            beginBlock({
	                kind: 4 /* Labeled */,
	                isScript: true,
	                labelText: labelText,
	                breakLabel: -1
	            });
	        }
	        function beginLabeledBlock(labelText) {
	            var breakLabel = defineLabel();
	            beginBlock({
	                kind: 4 /* Labeled */,
	                isScript: false,
	                labelText: labelText,
	                breakLabel: breakLabel
	            });
	        }
	        function endLabeledBlock() {
	            ts.Debug.assert(peekBlockKind() === 4 /* Labeled */);
	            var block = endBlock();
	            if (!block.isScript) {
	                markLabel(block.breakLabel);
	            }
	        }
	        /**
	         * Indicates whether the provided block supports `break` statements.
	         *
	         * @param block A code block.
	         */
	        function supportsUnlabeledBreak(block) {
	            return block.kind === 2 /* Switch */
	                || block.kind === 3 /* Loop */;
	        }
	        /**
	         * Indicates whether the provided block supports `break` statements with labels.
	         *
	         * @param block A code block.
	         */
	        function supportsLabeledBreakOrContinue(block) {
	            return block.kind === 4 /* Labeled */;
	        }
	        /**
	         * Indicates whether the provided block supports `continue` statements.
	         *
	         * @param block A code block.
	         */
	        function supportsUnlabeledContinue(block) {
	            return block.kind === 3 /* Loop */;
	        }
	        function hasImmediateContainingLabeledBlock(labelText, start) {
	            for (var j = start; j >= 0; j--) {
	                var containingBlock = blockStack[j];
	                if (supportsLabeledBreakOrContinue(containingBlock)) {
	                    if (containingBlock.labelText === labelText) {
	                        return true;
	                    }
	                }
	                else {
	                    break;
	                }
	            }
	            return false;
	        }
	        /**
	         * Finds the label that is the target for a `break` statement.
	         *
	         * @param labelText An optional name of a containing labeled statement.
	         */
	        function findBreakTarget(labelText) {
	            if (blockStack) {
	                if (labelText) {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsLabeledBreakOrContinue(block) && block.labelText === labelText) {
	                            return block.breakLabel;
	                        }
	                        else if (supportsUnlabeledBreak(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) {
	                            return block.breakLabel;
	                        }
	                    }
	                }
	                else {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledBreak(block)) {
	                            return block.breakLabel;
	                        }
	                    }
	                }
	            }
	            return 0;
	        }
	        /**
	         * Finds the label that is the target for a `continue` statement.
	         *
	         * @param labelText An optional name of a containing labeled statement.
	         */
	        function findContinueTarget(labelText) {
	            if (blockStack) {
	                if (labelText) {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledContinue(block) && hasImmediateContainingLabeledBlock(labelText, i - 1)) {
	                            return block.continueLabel;
	                        }
	                    }
	                }
	                else {
	                    for (var i = blockStack.length - 1; i >= 0; i--) {
	                        var block = blockStack[i];
	                        if (supportsUnlabeledContinue(block)) {
	                            return block.continueLabel;
	                        }
	                    }
	                }
	            }
	            return 0;
	        }
	        /**
	         * Creates an expression that can be used to indicate the value for a label.
	         *
	         * @param label A label.
	         */
	        function createLabel(label) {
	            if (label > 0) {
	                if (labelExpressions === undefined) {
	                    labelExpressions = [];
	                }
	                var expression = ts.createLiteral(-1);
	                if (labelExpressions[label] === undefined) {
	                    labelExpressions[label] = [expression];
	                }
	                else {
	                    labelExpressions[label].push(expression);
	                }
	                return expression;
	            }
	            return ts.createOmittedExpression();
	        }
	        /**
	         * Creates a numeric literal for the provided instruction.
	         */
	        function createInstruction(instruction) {
	            var literal = ts.createLiteral(instruction);
	            ts.addSyntheticTrailingComment(literal, 3 /* MultiLineCommentTrivia */, getInstructionName(instruction));
	            return literal;
	        }
	        /**
	         * Creates a statement that can be used indicate a Break operation to the provided label.
	         *
	         * @param label A label.
	         * @param location An optional source map location for the statement.
	         */
	        function createInlineBreak(label, location) {
	            ts.Debug.assertLessThan(0, label, "Invalid label");
	            return ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), location);
	        }
	        /**
	         * Creates a statement that can be used indicate a Return operation.
	         *
	         * @param expression The expression for the return statement.
	         * @param location An optional source map location for the statement.
	         */
	        function createInlineReturn(expression, location) {
	            return ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(2 /* Return */), expression]
	                : [createInstruction(2 /* Return */)])), location);
	        }
	        /**
	         * Creates an expression that can be used to resume from a Yield operation.
	         */
	        function createGeneratorResume(location) {
	            return ts.setTextRange(ts.createCall(ts.createPropertyAccess(state, "sent"), 
	            /*typeArguments*/ undefined, []), location);
	        }
	        /**
	         * Emits an empty instruction.
	         */
	        function emitNop() {
	            emitWorker(0 /* Nop */);
	        }
	        /**
	         * Emits a Statement.
	         *
	         * @param node A statement.
	         */
	        function emitStatement(node) {
	            if (node) {
	                emitWorker(1 /* Statement */, [node]);
	            }
	            else {
	                emitNop();
	            }
	        }
	        /**
	         * Emits an Assignment operation.
	         *
	         * @param left The left-hand side of the assignment.
	         * @param right The right-hand side of the assignment.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitAssignment(left, right, location) {
	            emitWorker(2 /* Assign */, [left, right], location);
	        }
	        /**
	         * Emits a Break operation to the specified label.
	         *
	         * @param label A label.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreak(label, location) {
	            emitWorker(3 /* Break */, [label], location);
	        }
	        /**
	         * Emits a Break operation to the specified label when a condition evaluates to a truthy
	         * value at runtime.
	         *
	         * @param label A label.
	         * @param condition The condition.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreakWhenTrue(label, condition, location) {
	            emitWorker(4 /* BreakWhenTrue */, [label, condition], location);
	        }
	        /**
	         * Emits a Break to the specified label when a condition evaluates to a falsey value at
	         * runtime.
	         *
	         * @param label A label.
	         * @param condition The condition.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitBreakWhenFalse(label, condition, location) {
	            emitWorker(5 /* BreakWhenFalse */, [label, condition], location);
	        }
	        /**
	         * Emits a YieldStar operation for the provided expression.
	         *
	         * @param expression An optional value for the yield operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitYieldStar(expression, location) {
	            emitWorker(7 /* YieldStar */, [expression], location);
	        }
	        /**
	         * Emits a Yield operation for the provided expression.
	         *
	         * @param expression An optional value for the yield operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitYield(expression, location) {
	            emitWorker(6 /* Yield */, [expression], location);
	        }
	        /**
	         * Emits a Return operation for the provided expression.
	         *
	         * @param expression An optional value for the operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitReturn(expression, location) {
	            emitWorker(8 /* Return */, [expression], location);
	        }
	        /**
	         * Emits a Throw operation for the provided expression.
	         *
	         * @param expression A value for the operation.
	         * @param location An optional source map location for the assignment.
	         */
	        function emitThrow(expression, location) {
	            emitWorker(9 /* Throw */, [expression], location);
	        }
	        /**
	         * Emits an Endfinally operation. This is used to handle `finally` block semantics.
	         */
	        function emitEndfinally() {
	            emitWorker(10 /* Endfinally */);
	        }
	        /**
	         * Emits an operation.
	         *
	         * @param code The OpCode for the operation.
	         * @param args The optional arguments for the operation.
	         */
	        function emitWorker(code, args, location) {
	            if (operations === undefined) {
	                operations = [];
	                operationArguments = [];
	                operationLocations = [];
	            }
	            if (labelOffsets === undefined) {
	                // mark entry point
	                markLabel(defineLabel());
	            }
	            var operationIndex = operations.length;
	            operations[operationIndex] = code;
	            operationArguments[operationIndex] = args;
	            operationLocations[operationIndex] = location;
	        }
	        /**
	         * Builds the generator function body.
	         */
	        function build() {
	            blockIndex = 0;
	            labelNumber = 0;
	            labelNumbers = undefined;
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            clauses = undefined;
	            statements = undefined;
	            exceptionBlockStack = undefined;
	            currentExceptionBlock = undefined;
	            withBlockStack = undefined;
	            var buildResult = buildStatements();
	            return createGeneratorHelper(context, ts.setEmitFlags(ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, state)], 
	            /*type*/ undefined, ts.createBlock(buildResult, 
	            /*multiLine*/ buildResult.length > 0)), 524288 /* ReuseTempVariableScope */));
	        }
	        /**
	         * Builds the statements for the generator function body.
	         */
	        function buildStatements() {
	            if (operations) {
	                for (var operationIndex = 0; operationIndex < operations.length; operationIndex++) {
	                    writeOperation(operationIndex);
	                }
	                flushFinalLabel(operations.length);
	            }
	            else {
	                flushFinalLabel(0);
	            }
	            if (clauses) {
	                var labelExpression = ts.createPropertyAccess(state, "label");
	                var switchStatement = ts.createSwitch(labelExpression, ts.createCaseBlock(clauses));
	                return [ts.startOnNewLine(switchStatement)];
	            }
	            if (statements) {
	                return statements;
	            }
	            return [];
	        }
	        /**
	         * Flush the current label and advance to a new label.
	         */
	        function flushLabel() {
	            if (!statements) {
	                return;
	            }
	            appendLabel(/*markLabelEnd*/ !lastOperationWasAbrupt);
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            labelNumber++;
	        }
	        /**
	         * Flush the final label of the generator function body.
	         */
	        function flushFinalLabel(operationIndex) {
	            if (isFinalLabelReachable(operationIndex)) {
	                tryEnterLabel(operationIndex);
	                withBlockStack = undefined;
	                writeReturn(/*expression*/ undefined, /*operationLocation*/ undefined);
	            }
	            if (statements && clauses) {
	                appendLabel(/*markLabelEnd*/ false);
	            }
	            updateLabelExpressions();
	        }
	        /**
	         * Tests whether the final label of the generator function body
	         * is reachable by user code.
	         */
	        function isFinalLabelReachable(operationIndex) {
	            // if the last operation was *not* a completion (return/throw) then
	            // the final label is reachable.
	            if (!lastOperationWasCompletion) {
	                return true;
	            }
	            // if there are no labels defined or referenced, then the final label is
	            // not reachable.
	            if (!labelOffsets || !labelExpressions) {
	                return false;
	            }
	            // if the label for this offset is referenced, then the final label
	            // is reachable.
	            for (var label = 0; label < labelOffsets.length; label++) {
	                if (labelOffsets[label] === operationIndex && labelExpressions[label]) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        /**
	         * Appends a case clause for the last label and sets the new label.
	         *
	         * @param markLabelEnd Indicates that the transition between labels was a fall-through
	         *                     from a previous case clause and the change in labels should be
	         *                     reflected on the `state` object.
	         */
	        function appendLabel(markLabelEnd) {
	            if (!clauses) {
	                clauses = [];
	            }
	            if (statements) {
	                if (withBlockStack) {
	                    // The previous label was nested inside one or more `with` blocks, so we
	                    // surround the statements in generated `with` blocks to create the same environment.
	                    for (var i = withBlockStack.length - 1; i >= 0; i--) {
	                        var withBlock = withBlockStack[i];
	                        statements = [ts.createWith(withBlock.expression, ts.createBlock(statements))];
	                    }
	                }
	                if (currentExceptionBlock) {
	                    // The previous label was nested inside of an exception block, so we must
	                    // indicate entry into a protected region by pushing the label numbers
	                    // for each block in the protected region.
	                    var startLabel = currentExceptionBlock.startLabel, catchLabel = currentExceptionBlock.catchLabel, finallyLabel = currentExceptionBlock.finallyLabel, endLabel = currentExceptionBlock.endLabel;
	                    statements.unshift(ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createPropertyAccess(state, "trys"), "push"), 
	                    /*typeArguments*/ undefined, [
	                        ts.createArrayLiteral([
	                            createLabel(startLabel),
	                            createLabel(catchLabel),
	                            createLabel(finallyLabel),
	                            createLabel(endLabel)
	                        ])
	                    ])));
	                    currentExceptionBlock = undefined;
	                }
	                if (markLabelEnd) {
	                    // The case clause for the last label falls through to this label, so we
	                    // add an assignment statement to reflect the change in labels.
	                    statements.push(ts.createStatement(ts.createAssignment(ts.createPropertyAccess(state, "label"), ts.createLiteral(labelNumber + 1))));
	                }
	            }
	            clauses.push(ts.createCaseClause(ts.createLiteral(labelNumber), statements || []));
	            statements = undefined;
	        }
	        /**
	         * Tries to enter into a new label at the current operation index.
	         */
	        function tryEnterLabel(operationIndex) {
	            if (!labelOffsets) {
	                return;
	            }
	            for (var label = 0; label < labelOffsets.length; label++) {
	                if (labelOffsets[label] === operationIndex) {
	                    flushLabel();
	                    if (labelNumbers === undefined) {
	                        labelNumbers = [];
	                    }
	                    if (labelNumbers[labelNumber] === undefined) {
	                        labelNumbers[labelNumber] = [label];
	                    }
	                    else {
	                        labelNumbers[labelNumber].push(label);
	                    }
	                }
	            }
	        }
	        /**
	         * Updates literal expressions for labels with actual label numbers.
	         */
	        function updateLabelExpressions() {
	            if (labelExpressions !== undefined && labelNumbers !== undefined) {
	                for (var labelNumber_1 = 0; labelNumber_1 < labelNumbers.length; labelNumber_1++) {
	                    var labels = labelNumbers[labelNumber_1];
	                    if (labels !== undefined) {
	                        for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
	                            var label = labels_1[_i];
	                            var expressions = labelExpressions[label];
	                            if (expressions !== undefined) {
	                                for (var _a = 0, expressions_1 = expressions; _a < expressions_1.length; _a++) {
	                                    var expression = expressions_1[_a];
	                                    expression.text = String(labelNumber_1);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        /**
	         * Tries to enter or leave a code block.
	         */
	        function tryEnterOrLeaveBlock(operationIndex) {
	            if (blocks) {
	                for (; blockIndex < blockActions.length && blockOffsets[blockIndex] <= operationIndex; blockIndex++) {
	                    var block = blocks[blockIndex];
	                    var blockAction = blockActions[blockIndex];
	                    switch (block.kind) {
	                        case 0 /* Exception */:
	                            if (blockAction === 0 /* Open */) {
	                                if (!exceptionBlockStack) {
	                                    exceptionBlockStack = [];
	                                }
	                                if (!statements) {
	                                    statements = [];
	                                }
	                                exceptionBlockStack.push(currentExceptionBlock);
	                                currentExceptionBlock = block;
	                            }
	                            else if (blockAction === 1 /* Close */) {
	                                currentExceptionBlock = exceptionBlockStack.pop();
	                            }
	                            break;
	                        case 1 /* With */:
	                            if (blockAction === 0 /* Open */) {
	                                if (!withBlockStack) {
	                                    withBlockStack = [];
	                                }
	                                withBlockStack.push(block);
	                            }
	                            else if (blockAction === 1 /* Close */) {
	                                withBlockStack.pop();
	                            }
	                            break;
	                        // default: do nothing
	                    }
	                }
	            }
	        }
	        /**
	         * Writes an operation as a statement to the current label's statement list.
	         *
	         * @param operation The OpCode of the operation
	         */
	        function writeOperation(operationIndex) {
	            tryEnterLabel(operationIndex);
	            tryEnterOrLeaveBlock(operationIndex);
	            // early termination, nothing else to process in this label
	            if (lastOperationWasAbrupt) {
	                return;
	            }
	            lastOperationWasAbrupt = false;
	            lastOperationWasCompletion = false;
	            var opcode = operations[operationIndex];
	            if (opcode === 0 /* Nop */) {
	                return;
	            }
	            else if (opcode === 10 /* Endfinally */) {
	                return writeEndfinally();
	            }
	            var args = operationArguments[operationIndex];
	            if (opcode === 1 /* Statement */) {
	                return writeStatement(args[0]);
	            }
	            var location = operationLocations[operationIndex];
	            switch (opcode) {
	                case 2 /* Assign */:
	                    return writeAssign(args[0], args[1], location);
	                case 3 /* Break */:
	                    return writeBreak(args[0], location);
	                case 4 /* BreakWhenTrue */:
	                    return writeBreakWhenTrue(args[0], args[1], location);
	                case 5 /* BreakWhenFalse */:
	                    return writeBreakWhenFalse(args[0], args[1], location);
	                case 6 /* Yield */:
	                    return writeYield(args[0], location);
	                case 7 /* YieldStar */:
	                    return writeYieldStar(args[0], location);
	                case 8 /* Return */:
	                    return writeReturn(args[0], location);
	                case 9 /* Throw */:
	                    return writeThrow(args[0], location);
	            }
	        }
	        /**
	         * Writes a statement to the current label's statement list.
	         *
	         * @param statement A statement to write.
	         */
	        function writeStatement(statement) {
	            if (statement) {
	                if (!statements) {
	                    statements = [statement];
	                }
	                else {
	                    statements.push(statement);
	                }
	            }
	        }
	        /**
	         * Writes an Assign operation to the current label's statement list.
	         *
	         * @param left The left-hand side of the assignment.
	         * @param right The right-hand side of the assignment.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeAssign(left, right, operationLocation) {
	            writeStatement(ts.setTextRange(ts.createStatement(ts.createAssignment(left, right)), operationLocation));
	        }
	        /**
	         * Writes a Throw operation to the current label's statement list.
	         *
	         * @param expression The value to throw.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeThrow(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            lastOperationWasCompletion = true;
	            writeStatement(ts.setTextRange(ts.createThrow(expression), operationLocation));
	        }
	        /**
	         * Writes a Return operation to the current label's statement list.
	         *
	         * @param expression The value to return.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeReturn(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            lastOperationWasCompletion = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(2 /* Return */), expression]
	                : [createInstruction(2 /* Return */)])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a Break operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreak(label, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a BreakWhenTrue operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param condition The condition for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreakWhenTrue(label, condition, operationLocation) {
	            writeStatement(ts.setEmitFlags(ts.createIf(condition, ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */)), 1 /* SingleLine */));
	        }
	        /**
	         * Writes a BreakWhenFalse operation to the current label's statement list.
	         *
	         * @param label The label for the Break.
	         * @param condition The condition for the Break.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeBreakWhenFalse(label, condition, operationLocation) {
	            writeStatement(ts.setEmitFlags(ts.createIf(ts.createLogicalNot(condition), ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(3 /* Break */),
	                createLabel(label)
	            ])), operationLocation), 384 /* NoTokenSourceMaps */)), 1 /* SingleLine */));
	        }
	        /**
	         * Writes a Yield operation to the current label's statement list.
	         *
	         * @param expression The expression to yield.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeYield(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral(expression
	                ? [createInstruction(4 /* Yield */), expression]
	                : [createInstruction(4 /* Yield */)])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes a YieldStar instruction to the current label's statement list.
	         *
	         * @param expression The expression to yield.
	         * @param operationLocation The source map location for the operation.
	         */
	        function writeYieldStar(expression, operationLocation) {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.setEmitFlags(ts.setTextRange(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(5 /* YieldStar */),
	                expression
	            ])), operationLocation), 384 /* NoTokenSourceMaps */));
	        }
	        /**
	         * Writes an Endfinally instruction to the current label's statement list.
	         */
	        function writeEndfinally() {
	            lastOperationWasAbrupt = true;
	            writeStatement(ts.createReturn(ts.createArrayLiteral([
	                createInstruction(7 /* Endfinally */)
	            ])));
	        }
	    }
	    ts.transformGenerators = transformGenerators;
	    function createGeneratorHelper(context, body) {
	        context.requestEmitHelper(generatorHelper);
	        return ts.createCall(ts.getHelperName("__generator"), 
	        /*typeArguments*/ undefined, [ts.createThis(), body]);
	    }
	    // The __generator helper is used by down-level transformations to emulate the runtime
	    // semantics of an ES2015 generator function. When called, this helper returns an
	    // object that implements the Iterator protocol, in that it has `next`, `return`, and
	    // `throw` methods that step through the generator when invoked.
	    //
	    // parameters:
	    //  @param thisArg  The value to use as the `this` binding for the transformed generator body.
	    //  @param body     A function that acts as the transformed generator body.
	    //
	    // variables:
	    //  _       Persistent state for the generator that is shared between the helper and the
	    //          generator body. The state object has the following members:
	    //            sent() - A method that returns or throws the current completion value.
	    //            label  - The next point at which to resume evaluation of the generator body.
	    //            trys   - A stack of protected regions (try/catch/finally blocks).
	    //            ops    - A stack of pending instructions when inside of a finally block.
	    //  f       A value indicating whether the generator is executing.
	    //  y       An iterator to delegate for a yield*.
	    //  t       A temporary variable that holds one of the following values (note that these
	    //          cases do not overlap):
	    //          - The completion value when resuming from a `yield` or `yield*`.
	    //          - The error value for a catch block.
	    //          - The current protected region (array of try/catch/finally/end labels).
	    //          - The verb (`next`, `throw`, or `return` method) to delegate to the expression
	    //            of a `yield*`.
	    //          - The result of evaluating the verb delegated to the expression of a `yield*`.
	    //
	    // functions:
	    //  verb(n)     Creates a bound callback to the `step` function for opcode `n`.
	    //  step(op)    Evaluates opcodes in a generator body until execution is suspended or
	    //              completed.
	    //
	    // The __generator helper understands a limited set of instructions:
	    //  0: next(value?)     - Start or resume the generator with the specified value.
	    //  1: throw(error)     - Resume the generator with an exception. If the generator is
	    //                        suspended inside of one or more protected regions, evaluates
	    //                        any intervening finally blocks between the current label and
	    //                        the nearest catch block or function boundary. If uncaught, the
	    //                        exception is thrown to the caller.
	    //  2: return(value?)   - Resume the generator as if with a return. If the generator is
	    //                        suspended inside of one or more protected regions, evaluates any
	    //                        intervening finally blocks.
	    //  3: break(label)     - Jump to the specified label. If the label is outside of the
	    //                        current protected region, evaluates any intervening finally
	    //                        blocks.
	    //  4: yield(value?)    - Yield execution to the caller with an optional value. When
	    //                        resumed, the generator will continue at the next label.
	    //  5: yield*(value)    - Delegates evaluation to the supplied iterator. When
	    //                        delegation completes, the generator will continue at the next
	    //                        label.
	    //  6: catch(error)     - Handles an exception thrown from within the generator body. If
	    //                        the current label is inside of one or more protected regions,
	    //                        evaluates any intervening finally blocks between the current
	    //                        label and the nearest catch block or function boundary. If
	    //                        uncaught, the exception is thrown to the caller.
	    //  7: endfinally       - Ends a finally block, resuming the last instruction prior to
	    //                        entering a finally block.
	    //
	    // For examples of how these are used, see the comments in ./transformers/generators.ts
	    var generatorHelper = {
	        name: "typescript:generator",
	        scoped: false,
	        priority: 6,
	        text: "\n            var __generator = (this && this.__generator) || function (thisArg, body) {\n                var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;\n                return g = { next: verb(0), \"throw\": verb(1), \"return\": verb(2) }, typeof Symbol === \"function\" && (g[Symbol.iterator] = function() { return this; }), g;\n                function verb(n) { return function (v) { return step([n, v]); }; }\n                function step(op) {\n                    if (f) throw new TypeError(\"Generator is already executing.\");\n                    while (_) try {\n                        if (f = 1, y && (t = op[0] & 2 ? y[\"return\"] : op[0] ? y[\"throw\"] || ((t = y[\"return\"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;\n                        if (y = 0, t) op = [op[0] & 2, t.value];\n                        switch (op[0]) {\n                            case 0: case 1: t = op; break;\n                            case 4: _.label++; return { value: op[1], done: false };\n                            case 5: _.label++; y = op[1]; op = [0]; continue;\n                            case 7: op = _.ops.pop(); _.trys.pop(); continue;\n                            default:\n                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }\n                                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }\n                                if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }\n                                if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }\n                                if (t[2]) _.ops.pop();\n                                _.trys.pop(); continue;\n                        }\n                        op = body.call(thisArg, _);\n                    } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }\n                    if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };\n                }\n            };"
	    };
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformModule(context) {
	        function getTransformModuleDelegate(moduleKind) {
	            switch (moduleKind) {
	                case ts.ModuleKind.AMD: return transformAMDModule;
	                case ts.ModuleKind.UMD: return transformUMDModule;
	                default: return transformCommonJSModule;
	            }
	        }
	        var startLexicalEnvironment = context.startLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var host = context.getEmitHost();
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.enableSubstitution(71 /* Identifier */); // Substitutes expression identifiers with imported/exported symbols.
	        context.enableSubstitution(199 /* BinaryExpression */); // Substitutes assignments to exported symbols.
	        context.enableSubstitution(197 /* PrefixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(198 /* PostfixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(270 /* ShorthandPropertyAssignment */); // Substitutes shorthand property assignments for imported/exported symbols.
	        context.enableEmitNotification(273 /* SourceFile */); // Restore state when substituting nodes in a file.
	        var moduleInfoMap = []; // The ExternalModuleInfo for each file.
	        var deferredExports = []; // Exports to defer until an EndOfDeclarationMarker is found.
	        var currentSourceFile; // The current file.
	        var currentModuleInfo; // The ExternalModuleInfo for the current file.
	        var noSubstitution; // Set of nodes for which substitution rules should be ignored.
	        var needUMDDynamicImportHelper;
	        return ts.chainBundle(transformSourceFile);
	        /**
	         * Transforms the module aspects of a SourceFile.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || !(ts.isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return node;
	            }
	            currentSourceFile = node;
	            currentModuleInfo = ts.collectExternalModuleInfo(node, resolver, compilerOptions);
	            moduleInfoMap[ts.getOriginalNodeId(node)] = currentModuleInfo;
	            // Perform the transformation.
	            var transformModule = getTransformModuleDelegate(moduleKind);
	            var updated = transformModule(node);
	            currentSourceFile = undefined;
	            currentModuleInfo = undefined;
	            needUMDDynamicImportHelper = false;
	            return ts.aggregateTransformFlags(updated);
	        }
	        function shouldEmitUnderscoreUnderscoreESModule() {
	            if (!currentModuleInfo.exportEquals && ts.isExternalModule(currentSourceFile)) {
	                return true;
	            }
	            return false;
	        }
	        /**
	         * Transforms a SourceFile into a CommonJS module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformCommonJSModule(node) {
	            startLexicalEnvironment();
	            var statements = [];
	            var ensureUseStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") || (!compilerOptions.noImplicitUseStrict && ts.isExternalModule(currentSourceFile));
	            var statementOffset = ts.addPrologue(statements, node.statements, ensureUseStrict, sourceElementVisitor);
	            if (shouldEmitUnderscoreUnderscoreESModule()) {
	                ts.append(statements, createUnderscoreUnderscoreESModule());
	            }
	            ts.append(statements, ts.visitNode(currentModuleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement));
	            ts.addRange(statements, ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset));
	            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ false);
	            ts.prependStatements(statements, endLexicalEnvironment());
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	            if (currentModuleInfo.hasExportStarsToExportValues && !compilerOptions.importHelpers) {
	                // If we have any `export * from ...` declarations
	                // we need to inform the emitter to add the __export helper.
	                ts.addEmitHelper(updated, exportStarHelper);
	            }
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Transforms a SourceFile into an AMD module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformAMDModule(node) {
	            var define = ts.createIdentifier("define");
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            // An AMD define function has the following shape:
	            //
	            //     define(id?, dependencies?, factory);
	            //
	            // This has the shape of the following:
	            //
	            //     define(name, ["module1", "module2"], function (module1Alias) { ... }
	            //
	            // The location of the alias in the parameter list in the factory function needs to
	            // match the position of the module name in the dependency list.
	            //
	            // To ensure this is true in cases of modules with no aliases, e.g.:
	            //
	            //     import "module"
	            //
	            // or
	            //
	            //     /// <amd-dependency path= "a.css" />
	            //
	            // we need to add modules without alias names to the end of the dependencies list
	            var _a = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ true), aliasedModuleNames = _a.aliasedModuleNames, unaliasedModuleNames = _a.unaliasedModuleNames, importAliasNames = _a.importAliasNames;
	            // Create an updated SourceFile:
	            //
	            //     define(moduleName?, ["module1", "module2"], function ...
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(define, 
	                /*typeArguments*/ undefined, (moduleName ? [moduleName] : []).concat([
	                    // Add the dependency array argument:
	                    //
	                    //     ["require", "exports", module1", "module2", ...]
	                    ts.createArrayLiteral([
	                        ts.createLiteral("require"),
	                        ts.createLiteral("exports")
	                    ].concat(aliasedModuleNames, unaliasedModuleNames)),
	                    // Add the module body function argument:
	                    //
	                    //     function (require, exports, module1, module2) ...
	                    ts.createFunctionExpression(
	                    /*modifiers*/ undefined, 
	                    /*asteriskToken*/ undefined, 
	                    /*name*/ undefined, 
	                    /*typeParameters*/ undefined, [
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "require"),
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "exports")
	                    ].concat(importAliasNames), 
	                    /*type*/ undefined, transformAsynchronousModuleBody(node))
	                ])))
	            ]), 
	            /*location*/ node.statements));
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Transforms a SourceFile into a UMD module.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformUMDModule(node) {
	            var _a = collectAsynchronousDependencies(node, /*includeNonAmdDependencies*/ false), aliasedModuleNames = _a.aliasedModuleNames, unaliasedModuleNames = _a.unaliasedModuleNames, importAliasNames = _a.importAliasNames;
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            var umdHeader = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "factory")], 
	            /*type*/ undefined, ts.setTextRange(ts.createBlock([
	                ts.createIf(ts.createLogicalAnd(ts.createTypeCheck(ts.createIdentifier("module"), "object"), ts.createTypeCheck(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), "object")), ts.createBlock([
	                    ts.createVariableStatement(
	                    /*modifiers*/ undefined, [
	                        ts.createVariableDeclaration("v", 
	                        /*type*/ undefined, ts.createCall(ts.createIdentifier("factory"), 
	                        /*typeArguments*/ undefined, [
	                            ts.createIdentifier("require"),
	                            ts.createIdentifier("exports")
	                        ]))
	                    ]),
	                    ts.setEmitFlags(ts.createIf(ts.createStrictInequality(ts.createIdentifier("v"), ts.createIdentifier("undefined")), ts.createStatement(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), ts.createIdentifier("v")))), 1 /* SingleLine */)
	                ]), ts.createIf(ts.createLogicalAnd(ts.createTypeCheck(ts.createIdentifier("define"), "function"), ts.createPropertyAccess(ts.createIdentifier("define"), "amd")), ts.createBlock([
	                    ts.createStatement(ts.createCall(ts.createIdentifier("define"), 
	                    /*typeArguments*/ undefined, (moduleName ? [moduleName] : []).concat([
	                        ts.createArrayLiteral([
	                            ts.createLiteral("require"),
	                            ts.createLiteral("exports")
	                        ].concat(aliasedModuleNames, unaliasedModuleNames)),
	                        ts.createIdentifier("factory")
	                    ])))
	                ])))
	            ], 
	            /*multiLine*/ true), 
	            /*location*/ undefined));
	            // Create an updated SourceFile:
	            //
	            //  (function (factory) {
	            //      if (typeof module === "object" && typeof module.exports === "object") {
	            //          var v = factory(require, exports);
	            //          if (v !== undefined) module.exports = v;
	            //      }
	            //      else if (typeof define === 'function' && define.amd) {
	            //          define(["require", "exports"], factory);
	            //      }
	            //  })(function ...)
	            var updated = ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(umdHeader, 
	                /*typeArguments*/ undefined, [
	                    // Add the module body function argument:
	                    //
	                    //     function (require, exports) ...
	                    ts.createFunctionExpression(
	                    /*modifiers*/ undefined, 
	                    /*asteriskToken*/ undefined, 
	                    /*name*/ undefined, 
	                    /*typeParameters*/ undefined, [
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "require"),
	                        ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, "exports")
	                    ].concat(importAliasNames), 
	                    /*type*/ undefined, transformAsynchronousModuleBody(node))
	                ]))
	            ]), 
	            /*location*/ node.statements));
	            ts.addEmitHelpers(updated, context.readEmitHelpers());
	            return updated;
	        }
	        /**
	         * Collect the additional asynchronous dependencies for the module.
	         *
	         * @param node The source file.
	         * @param includeNonAmdDependencies A value indicating whether to include non-AMD dependencies.
	         */
	        function collectAsynchronousDependencies(node, includeNonAmdDependencies) {
	            // names of modules with corresponding parameter in the factory function
	            var aliasedModuleNames = [];
	            // names of modules with no corresponding parameters in factory function
	            var unaliasedModuleNames = [];
	            // names of the parameters in the factory function; these
	            // parameters need to match the indexes of the corresponding
	            // module names in aliasedModuleNames.
	            var importAliasNames = [];
	            // Fill in amd-dependency tags
	            for (var _i = 0, _a = node.amdDependencies; _i < _a.length; _i++) {
	                var amdDependency = _a[_i];
	                if (amdDependency.name) {
	                    aliasedModuleNames.push(ts.createLiteral(amdDependency.path));
	                    importAliasNames.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, amdDependency.name));
	                }
	                else {
	                    unaliasedModuleNames.push(ts.createLiteral(amdDependency.path));
	                }
	            }
	            for (var _b = 0, _c = currentModuleInfo.externalImports; _b < _c.length; _b++) {
	                var importNode = _c[_b];
	                // Find the name of the external module
	                var externalModuleName = ts.getExternalModuleNameLiteral(importNode, currentSourceFile, host, resolver, compilerOptions);
	                // Find the name of the module alias, if there is one
	                var importAliasName = ts.getLocalNameForExternalImport(importNode, currentSourceFile);
	                // It is possible that externalModuleName is undefined if it is not string literal.
	                // This can happen in the invalid import syntax.
	                // E.g : "import * from alias from 'someLib';"
	                if (externalModuleName) {
	                    if (includeNonAmdDependencies && importAliasName) {
	                        // Set emitFlags on the name of the classDeclaration
	                        // This is so that when printer will not substitute the identifier
	                        ts.setEmitFlags(importAliasName, 4 /* NoSubstitution */);
	                        aliasedModuleNames.push(externalModuleName);
	                        importAliasNames.push(ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, importAliasName));
	                    }
	                    else {
	                        unaliasedModuleNames.push(externalModuleName);
	                    }
	                }
	            }
	            return { aliasedModuleNames: aliasedModuleNames, unaliasedModuleNames: unaliasedModuleNames, importAliasNames: importAliasNames };
	        }
	        function getAMDImportExpressionForImport(node) {
	            if (ts.isImportEqualsDeclaration(node) || ts.isExportDeclaration(node) || !ts.getExternalModuleNameLiteral(node, currentSourceFile, host, resolver, compilerOptions)) {
	                return undefined;
	            }
	            var name = ts.getLocalNameForExternalImport(node, currentSourceFile);
	            var expr = getHelperExpressionForImport(node, name);
	            if (expr === name) {
	                return undefined;
	            }
	            return ts.createStatement(ts.createAssignment(name, expr));
	        }
	        /**
	         * Transforms a SourceFile into an AMD or UMD module body.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformAsynchronousModuleBody(node) {
	            startLexicalEnvironment();
	            var statements = [];
	            var statementOffset = ts.addPrologue(statements, node.statements, /*ensureUseStrict*/ !compilerOptions.noImplicitUseStrict, sourceElementVisitor);
	            if (shouldEmitUnderscoreUnderscoreESModule()) {
	                ts.append(statements, createUnderscoreUnderscoreESModule());
	            }
	            // Visit each statement of the module body.
	            ts.append(statements, ts.visitNode(currentModuleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement));
	            if (moduleKind === ts.ModuleKind.AMD) {
	                ts.addRange(statements, ts.mapDefined(currentModuleInfo.externalImports, getAMDImportExpressionForImport));
	            }
	            ts.addRange(statements, ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset));
	            // Append the 'export =' statement if provided.
	            addExportEqualsIfNeeded(statements, /*emitAsReturn*/ true);
	            // End the lexical environment for the module body
	            // and merge any new lexical declarations.
	            ts.prependStatements(statements, endLexicalEnvironment());
	            var body = ts.createBlock(statements, /*multiLine*/ true);
	            if (currentModuleInfo.hasExportStarsToExportValues && !compilerOptions.importHelpers) {
	                // If we have any `export * from ...` declarations
	                // we need to inform the emitter to add the __export helper.
	                ts.addEmitHelper(body, exportStarHelper);
	            }
	            if (needUMDDynamicImportHelper) {
	                ts.addEmitHelper(body, dynamicImportUMDHelper);
	            }
	            return body;
	        }
	        /**
	         * Adds the down-level representation of `export=` to the statement list if one exists
	         * in the source file.
	         *
	         * @param statements The Statement list to modify.
	         * @param emitAsReturn A value indicating whether to emit the `export=` statement as a
	         * return statement.
	         */
	        function addExportEqualsIfNeeded(statements, emitAsReturn) {
	            if (currentModuleInfo.exportEquals) {
	                var expressionResult = ts.visitNode(currentModuleInfo.exportEquals.expression, moduleExpressionElementVisitor);
	                if (expressionResult) {
	                    if (emitAsReturn) {
	                        var statement = ts.createReturn(expressionResult);
	                        ts.setTextRange(statement, currentModuleInfo.exportEquals);
	                        ts.setEmitFlags(statement, 384 /* NoTokenSourceMaps */ | 1536 /* NoComments */);
	                        statements.push(statement);
	                    }
	                    else {
	                        var statement = ts.createStatement(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("module"), "exports"), expressionResult));
	                        ts.setTextRange(statement, currentModuleInfo.exportEquals);
	                        ts.setEmitFlags(statement, 1536 /* NoComments */);
	                        statements.push(statement);
	                    }
	                }
	            }
	        }
	        //
	        // Top-Level Source Element Visitors
	        //
	        /**
	         * Visits a node at the top level of the source file.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 242 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 249 /* ExportDeclaration */:
	                    return visitExportDeclaration(node);
	                case 248 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                case 213 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 234 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 302 /* MergeDeclarationMarker */:
	                    return visitMergeDeclarationMarker(node);
	                case 303 /* EndOfDeclarationMarker */:
	                    return visitEndOfDeclarationMarker(node);
	                default:
	                    return ts.visitEachChild(node, moduleExpressionElementVisitor, context);
	            }
	        }
	        function moduleExpressionElementVisitor(node) {
	            // This visitor does not need to descend into the tree if there is no dynamic import or destructuring assignment,
	            // as export/import statements are only transformed at the top level of a file.
	            if (!(node.transformFlags & 67108864 /* ContainsDynamicImport */) && !(node.transformFlags & 2048 /* ContainsDestructuringAssignment */)) {
	                return node;
	            }
	            if (ts.isImportCall(node)) {
	                return visitImportCallExpression(node);
	            }
	            else if (node.transformFlags & 1024 /* DestructuringAssignment */ && ts.isBinaryExpression(node)) {
	                return visitDestructuringAssignment(node);
	            }
	            else {
	                return ts.visitEachChild(node, moduleExpressionElementVisitor, context);
	            }
	        }
	        function destructuringNeedsFlattening(node) {
	            if (ts.isObjectLiteralExpression(node)) {
	                for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                    var elem = _a[_i];
	                    switch (elem.kind) {
	                        case 269 /* PropertyAssignment */:
	                            if (destructuringNeedsFlattening(elem.initializer)) {
	                                return true;
	                            }
	                            break;
	                        case 270 /* ShorthandPropertyAssignment */:
	                            if (destructuringNeedsFlattening(elem.name)) {
	                                return true;
	                            }
	                            break;
	                        case 271 /* SpreadAssignment */:
	                            if (destructuringNeedsFlattening(elem.expression)) {
	                                return true;
	                            }
	                            break;
	                        case 153 /* MethodDeclaration */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                            return false;
	                        default: ts.Debug.assertNever(elem, "Unhandled object member kind");
	                    }
	                }
	            }
	            else if (ts.isArrayLiteralExpression(node)) {
	                for (var _b = 0, _c = node.elements; _b < _c.length; _b++) {
	                    var elem = _c[_b];
	                    if (ts.isSpreadElement(elem)) {
	                        if (destructuringNeedsFlattening(elem.expression)) {
	                            return true;
	                        }
	                    }
	                    else if (destructuringNeedsFlattening(elem)) {
	                        return true;
	                    }
	                }
	            }
	            else if (ts.isIdentifier(node)) {
	                return ts.length(getExports(node)) > (ts.isExportName(node) ? 1 : 0);
	            }
	            return false;
	        }
	        function visitDestructuringAssignment(node) {
	            if (destructuringNeedsFlattening(node.left)) {
	                return ts.flattenDestructuringAssignment(node, moduleExpressionElementVisitor, context, 0 /* All */, /*needsValue*/ false, createAllExportExpressions);
	            }
	            return ts.visitEachChild(node, moduleExpressionElementVisitor, context);
	        }
	        function visitImportCallExpression(node) {
	            var argument = ts.visitNode(ts.firstOrUndefined(node.arguments), moduleExpressionElementVisitor);
	            var containsLexicalThis = !!(node.transformFlags & 16384 /* ContainsLexicalThis */);
	            switch (compilerOptions.module) {
	                case ts.ModuleKind.AMD:
	                    return createImportCallExpressionAMD(argument, containsLexicalThis);
	                case ts.ModuleKind.UMD:
	                    return createImportCallExpressionUMD(argument, containsLexicalThis);
	                case ts.ModuleKind.CommonJS:
	                default:
	                    return createImportCallExpressionCommonJS(argument, containsLexicalThis);
	            }
	        }
	        function createImportCallExpressionUMD(arg, containsLexicalThis) {
	            // (function (factory) {
	            //      ... (regular UMD)
	            // }
	            // })(function (require, exports, useSyncRequire) {
	            //      "use strict";
	            //      Object.defineProperty(exports, "__esModule", { value: true });
	            //      var __syncRequire = typeof module === "object" && typeof module.exports === "object";
	            //      var __resolved = new Promise(function (resolve) { resolve(); });
	            //      .....
	            //      __syncRequire
	            //          ? __resolved.then(function () { return require(x); }) /*CommonJs Require*/
	            //          : new Promise(function (_a, _b) { require([x], _a, _b); }); /*Amd Require*/
	            // });
	            needUMDDynamicImportHelper = true;
	            if (ts.isSimpleCopiableExpression(arg)) {
	                var argClone = ts.isGeneratedIdentifier(arg) ? arg : ts.isStringLiteral(arg) ? ts.createLiteral(arg) : ts.setEmitFlags(ts.setTextRange(ts.getSynthesizedClone(arg), arg), 1536 /* NoComments */);
	                return ts.createConditional(
	                /*condition*/ ts.createIdentifier("__syncRequire"), 
	                /*whenTrue*/ createImportCallExpressionCommonJS(arg, containsLexicalThis), 
	                /*whenFalse*/ createImportCallExpressionAMD(argClone, containsLexicalThis));
	            }
	            else {
	                var temp = ts.createTempVariable(hoistVariableDeclaration);
	                return ts.createComma(ts.createAssignment(temp, arg), ts.createConditional(
	                /*condition*/ ts.createIdentifier("__syncRequire"), 
	                /*whenTrue*/ createImportCallExpressionCommonJS(temp, containsLexicalThis), 
	                /*whenFalse*/ createImportCallExpressionAMD(temp, containsLexicalThis)));
	            }
	        }
	        function createImportCallExpressionAMD(arg, containsLexicalThis) {
	            // improt("./blah")
	            // emit as
	            // define(["require", "exports", "blah"], function (require, exports) {
	            //     ...
	            //     new Promise(function (_a, _b) { require([x], _a, _b); }); /*Amd Require*/
	            // });
	            var resolve = ts.createUniqueName("resolve");
	            var reject = ts.createUniqueName("reject");
	            var parameters = [
	                ts.createParameter(/*decorator*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, /*name*/ resolve),
	                ts.createParameter(/*decorator*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, /*name*/ reject)
	            ];
	            var body = ts.createBlock([
	                ts.createStatement(ts.createCall(ts.createIdentifier("require"), 
	                /*typeArguments*/ undefined, [ts.createArrayLiteral([arg || ts.createOmittedExpression()]), resolve, reject]))
	            ]);
	            var func;
	            if (languageVersion >= 2 /* ES2015 */) {
	                func = ts.createArrowFunction(
	                /*modifiers*/ undefined, 
	                /*typeParameters*/ undefined, parameters, 
	                /*type*/ undefined, 
	                /*equalsGreaterThanToken*/ undefined, body);
	            }
	            else {
	                func = ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, parameters, 
	                /*type*/ undefined, body);
	                // if there is a lexical 'this' in the import call arguments, ensure we indicate
	                // that this new function expression indicates it captures 'this' so that the
	                // es2015 transformer will properly substitute 'this' with '_this'.
	                if (containsLexicalThis) {
	                    ts.setEmitFlags(func, 8 /* CapturesThis */);
	                }
	            }
	            var promise = ts.createNew(ts.createIdentifier("Promise"), /*typeArguments*/ undefined, [func]);
	            if (compilerOptions.esModuleInterop) {
	                context.requestEmitHelper(importStarHelper);
	                return ts.createCall(ts.createPropertyAccess(promise, ts.createIdentifier("then")), /*typeArguments*/ undefined, [ts.getHelperName("__importStar")]);
	            }
	            return promise;
	        }
	        function createImportCallExpressionCommonJS(arg, containsLexicalThis) {
	            // import("./blah")
	            // emit as
	            // Promise.resolve().then(function () { return require(x); }) /*CommonJs Require*/
	            // We have to wrap require in then callback so that require is done in asynchronously
	            // if we simply do require in resolve callback in Promise constructor. We will execute the loading immediately
	            var promiseResolveCall = ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Promise"), "resolve"), /*typeArguments*/ undefined, /*argumentsArray*/ []);
	            var requireCall = ts.createCall(ts.createIdentifier("require"), /*typeArguments*/ undefined, arg ? [arg] : []);
	            if (compilerOptions.esModuleInterop) {
	                context.requestEmitHelper(importStarHelper);
	                requireCall = ts.createCall(ts.getHelperName("__importStar"), /*typeArguments*/ undefined, [requireCall]);
	            }
	            var func;
	            if (languageVersion >= 2 /* ES2015 */) {
	                func = ts.createArrowFunction(
	                /*modifiers*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, 
	                /*equalsGreaterThanToken*/ undefined, requireCall);
	            }
	            else {
	                func = ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, ts.createBlock([ts.createReturn(requireCall)]));
	                // if there is a lexical 'this' in the import call arguments, ensure we indicate
	                // that this new function expression indicates it captures 'this' so that the
	                // es2015 transformer will properly substitute 'this' with '_this'.
	                if (containsLexicalThis) {
	                    ts.setEmitFlags(func, 8 /* CapturesThis */);
	                }
	            }
	            return ts.createCall(ts.createPropertyAccess(promiseResolveCall, "then"), /*typeArguments*/ undefined, [func]);
	        }
	        function getHelperExpressionForImport(node, innerExpr) {
	            if (!compilerOptions.esModuleInterop || ts.getEmitFlags(node) & 67108864 /* NeverApplyImportHelper */) {
	                return innerExpr;
	            }
	            if (ts.getImportNeedsImportStarHelper(node)) {
	                context.requestEmitHelper(importStarHelper);
	                return ts.createCall(ts.getHelperName("__importStar"), /*typeArguments*/ undefined, [innerExpr]);
	            }
	            if (ts.getImportNeedsImportDefaultHelper(node)) {
	                context.requestEmitHelper(importDefaultHelper);
	                return ts.createCall(ts.getHelperName("__importDefault"), /*typeArguments*/ undefined, [innerExpr]);
	            }
	            return innerExpr;
	        }
	        /**
	         * Visits an ImportDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportDeclaration(node) {
	            var statements;
	            var namespaceDeclaration = ts.getNamespaceDeclarationNode(node);
	            if (moduleKind !== ts.ModuleKind.AMD) {
	                if (!node.importClause) {
	                    // import "mod";
	                    return ts.setTextRange(ts.createStatement(createRequireCall(node)), node);
	                }
	                else {
	                    var variables = [];
	                    if (namespaceDeclaration && !ts.isDefaultImport(node)) {
	                        // import * as n from "mod";
	                        variables.push(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                        /*type*/ undefined, getHelperExpressionForImport(node, createRequireCall(node))));
	                    }
	                    else {
	                        // import d from "mod";
	                        // import { x, y } from "mod";
	                        // import d, { x, y } from "mod";
	                        // import d, * as n from "mod";
	                        variables.push(ts.createVariableDeclaration(ts.getGeneratedNameForNode(node), 
	                        /*type*/ undefined, getHelperExpressionForImport(node, createRequireCall(node))));
	                        if (namespaceDeclaration && ts.isDefaultImport(node)) {
	                            variables.push(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                            /*type*/ undefined, ts.getGeneratedNameForNode(node)));
	                        }
	                    }
	                    statements = ts.append(statements, ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList(variables, languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)), 
	                    /*location*/ node));
	                }
	            }
	            else if (namespaceDeclaration && ts.isDefaultImport(node)) {
	                // import d, * as n from "mod";
	                statements = ts.append(statements, ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.setTextRange(ts.createVariableDeclaration(ts.getSynthesizedClone(namespaceDeclaration.name), 
	                    /*type*/ undefined, ts.getGeneratedNameForNode(node)), 
	                    /*location*/ node)
	                ], languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Creates a `require()` call to import an external module.
	         *
	         * @param importNode The declararation to import.
	         */
	        function createRequireCall(importNode) {
	            var moduleName = ts.getExternalModuleNameLiteral(importNode, currentSourceFile, host, resolver, compilerOptions);
	            var args = [];
	            if (moduleName) {
	                args.push(moduleName);
	            }
	            return ts.createCall(ts.createIdentifier("require"), /*typeArguments*/ undefined, args);
	        }
	        /**
	         * Visits an ImportEqualsDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportEqualsDeclaration(node) {
	            ts.Debug.assert(ts.isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
	            var statements;
	            if (moduleKind !== ts.ModuleKind.AMD) {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(createExportExpression(node.name, createRequireCall(node))), node));
	                }
	                else {
	                    statements = ts.append(statements, ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(ts.getSynthesizedClone(node.name), 
	                        /*type*/ undefined, createRequireCall(node))
	                    ], 
	                    /*flags*/ languageVersion >= 2 /* ES2015 */ ? 2 /* Const */ : 0 /* None */)), node));
	                }
	            }
	            else {
	                if (ts.hasModifier(node, 1 /* Export */)) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(createExportExpression(ts.getExportName(node), ts.getLocalName(node))), node));
	                }
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportEqualsDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportEqualsDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ExportDeclaration node.
	         *
	         * @param The node to visit.
	         */
	        function visitExportDeclaration(node) {
	            if (!node.moduleSpecifier) {
	                // Elide export declarations with no module specifier as they are handled
	                // elsewhere.
	                return undefined;
	            }
	            var generatedName = ts.getGeneratedNameForNode(node);
	            if (node.exportClause) {
	                var statements = [];
	                // export { x, y } from "mod";
	                if (moduleKind !== ts.ModuleKind.AMD) {
	                    statements.push(ts.setTextRange(ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                        ts.createVariableDeclaration(generatedName, 
	                        /*type*/ undefined, createRequireCall(node))
	                    ])), 
	                    /*location*/ node));
	                }
	                for (var _i = 0, _a = node.exportClause.elements; _i < _a.length; _i++) {
	                    var specifier = _a[_i];
	                    var exportedValue = ts.createPropertyAccess(generatedName, specifier.propertyName || specifier.name);
	                    statements.push(ts.setTextRange(ts.createStatement(createExportExpression(ts.getExportName(specifier), exportedValue)), specifier));
	                }
	                return ts.singleOrMany(statements);
	            }
	            else {
	                // export * from "mod";
	                return ts.setTextRange(ts.createStatement(createExportStarHelper(context, moduleKind !== ts.ModuleKind.AMD ? createRequireCall(node) : generatedName)), node);
	            }
	        }
	        /**
	         * Visits an ExportAssignment node.
	         *
	         * @param node The node to visit.
	         */
	        function visitExportAssignment(node) {
	            if (node.isExportEquals) {
	                return undefined;
	            }
	            var statements;
	            var original = node.original;
	            if (original && hasAssociatedEndOfDeclarationMarker(original)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportStatement(deferredExports[id], ts.createIdentifier("default"), ts.visitNode(node.expression, moduleExpressionElementVisitor), /*location*/ node, /*allowComments*/ true);
	            }
	            else {
	                statements = appendExportStatement(statements, ts.createIdentifier("default"), ts.visitNode(node.expression, moduleExpressionElementVisitor), /*location*/ node, /*allowComments*/ true);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a FunctionDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            var statements;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                statements = ts.append(statements, ts.setOriginalNode(ts.setTextRange(ts.createFunctionDeclaration(
	                /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.parameters, moduleExpressionElementVisitor), 
	                /*type*/ undefined, ts.visitEachChild(node.body, moduleExpressionElementVisitor, context)), 
	                /*location*/ node), 
	                /*original*/ node));
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, moduleExpressionElementVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a ClassDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitClassDeclaration(node) {
	            var statements;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                statements = ts.append(statements, ts.setOriginalNode(ts.setTextRange(ts.createClassDeclaration(
	                /*decorators*/ undefined, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, moduleExpressionElementVisitor), ts.visitNodes(node.members, moduleExpressionElementVisitor)), node), node));
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, moduleExpressionElementVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a VariableStatement node.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            var statements;
	            var variables;
	            var expressions;
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                var modifiers = void 0;
	                // If we're exporting these variables, then these just become assignments to 'exports.x'.
	                // We only want to emit assignments for variables with initializers.
	                for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    if (ts.isIdentifier(variable.name) && ts.isLocalName(variable.name)) {
	                        if (!modifiers) {
	                            modifiers = ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier);
	                        }
	                        variables = ts.append(variables, variable);
	                    }
	                    else if (variable.initializer) {
	                        expressions = ts.append(expressions, transformInitializedVariable(variable));
	                    }
	                }
	                if (variables) {
	                    statements = ts.append(statements, ts.updateVariableStatement(node, modifiers, ts.updateVariableDeclarationList(node.declarationList, variables)));
	                }
	                if (expressions) {
	                    statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.inlineExpressions(expressions)), node));
	                }
	            }
	            else {
	                statements = ts.append(statements, ts.visitEachChild(node, moduleExpressionElementVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfVariableStatement(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        function createAllExportExpressions(name, value, location) {
	            var exportedNames = getExports(name);
	            if (exportedNames) {
	                // For each additional export of the declaration, apply an export assignment.
	                var expression = ts.isExportName(name) ? value : ts.createAssignment(name, value);
	                for (var _i = 0, exportedNames_1 = exportedNames; _i < exportedNames_1.length; _i++) {
	                    var exportName = exportedNames_1[_i];
	                    // Mark the node to prevent triggering substitution.
	                    ts.setEmitFlags(expression, 4 /* NoSubstitution */);
	                    expression = createExportExpression(exportName, expression, /*location*/ location);
	                }
	                return expression;
	            }
	            return ts.createAssignment(name, value);
	        }
	        /**
	         * Transforms an exported variable with an initializer into an expression.
	         *
	         * @param node The node to transform.
	         */
	        function transformInitializedVariable(node) {
	            if (ts.isBindingPattern(node.name)) {
	                return ts.flattenDestructuringAssignment(ts.visitNode(node, moduleExpressionElementVisitor), 
	                /*visitor*/ undefined, context, 0 /* All */, 
	                /*needsValue*/ false, createAllExportExpressions);
	            }
	            else {
	                return ts.createAssignment(ts.setTextRange(ts.createPropertyAccess(ts.createIdentifier("exports"), node.name), 
	                /*location*/ node.name), ts.visitNode(node.initializer, moduleExpressionElementVisitor));
	            }
	        }
	        /**
	         * Visits a MergeDeclarationMarker used as a placeholder for the beginning of a merged
	         * and transformed declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitMergeDeclarationMarker(node) {
	            // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	            // declaration we do not emit a leading variable declaration. To preserve the
	            // begin/end semantics of the declararation and to properly handle exports
	            // we wrapped the leading variable declaration in a `MergeDeclarationMarker`.
	            //
	            // To balance the declaration, add the exports of the elided variable
	            // statement.
	            if (hasAssociatedEndOfDeclarationMarker(node) && node.original.kind === 213 /* VariableStatement */) {
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node.original);
	            }
	            return node;
	        }
	        /**
	         * Determines whether a node has an associated EndOfDeclarationMarker.
	         *
	         * @param node The node to test.
	         */
	        function hasAssociatedEndOfDeclarationMarker(node) {
	            return (ts.getEmitFlags(node) & 4194304 /* HasEndOfDeclarationMarker */) !== 0;
	        }
	        /**
	         * Visits a DeclarationMarker used as a placeholder for the end of a transformed
	         * declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitEndOfDeclarationMarker(node) {
	            // For some transformations we emit an `EndOfDeclarationMarker` to mark the actual
	            // end of the transformed declaration. We use this marker to emit any deferred exports
	            // of the declaration.
	            var id = ts.getOriginalNodeId(node);
	            var statements = deferredExports[id];
	            if (statements) {
	                delete deferredExports[id];
	                return ts.append(statements, node);
	            }
	            return node;
	        }
	        /**
	         * Appends the exports of an ImportDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            var importClause = decl.importClause;
	            if (!importClause) {
	                return statements;
	            }
	            if (importClause.name) {
	                statements = appendExportsOfDeclaration(statements, importClause);
	            }
	            var namedBindings = importClause.namedBindings;
	            if (namedBindings) {
	                switch (namedBindings.kind) {
	                    case 245 /* NamespaceImport */:
	                        statements = appendExportsOfDeclaration(statements, namedBindings);
	                        break;
	                    case 246 /* NamedImports */:
	                        for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                            var importBinding = _a[_i];
	                            statements = appendExportsOfDeclaration(statements, importBinding);
	                        }
	                        break;
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of an ImportEqualsDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportEqualsDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            return appendExportsOfDeclaration(statements, decl);
	        }
	        /**
	         * Appends the exports of a VariableStatement to a statement list, returning the statement
	         * list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param node The VariableStatement whose exports are to be recorded.
	         */
	        function appendExportsOfVariableStatement(statements, node) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                statements = appendExportsOfBindingElement(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a VariableDeclaration or BindingElement to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfBindingElement(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.isBindingPattern(decl.name)) {
	                for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        statements = appendExportsOfBindingElement(statements, element);
	                    }
	                }
	            }
	            else if (!ts.isGeneratedIdentifier(decl.name)) {
	                statements = appendExportsOfDeclaration(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a ClassDeclaration or FunctionDeclaration to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfHoistedDeclaration(statements, decl) {
	            if (currentModuleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.hasModifier(decl, 1 /* Export */)) {
	                var exportName = ts.hasModifier(decl, 512 /* Default */) ? ts.createIdentifier("default") : ts.getDeclarationName(decl);
	                statements = appendExportStatement(statements, exportName, ts.getLocalName(decl), /*location*/ decl);
	            }
	            if (decl.name) {
	                statements = appendExportsOfDeclaration(statements, decl);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a declaration to a statement list, returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration to export.
	         */
	        function appendExportsOfDeclaration(statements, decl) {
	            var name = ts.getDeclarationName(decl);
	            var exportSpecifiers = currentModuleInfo.exportSpecifiers.get(ts.idText(name));
	            if (exportSpecifiers) {
	                for (var _i = 0, exportSpecifiers_1 = exportSpecifiers; _i < exportSpecifiers_1.length; _i++) {
	                    var exportSpecifier = exportSpecifiers_1[_i];
	                    statements = appendExportStatement(statements, exportSpecifier.name, name, /*location*/ exportSpecifier.name);
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the down-level representation of an export to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param exportName The name of the export.
	         * @param expression The expression to export.
	         * @param location The location to use for source maps and comments for the export.
	         * @param allowComments Whether to allow comments on the export.
	         */
	        function appendExportStatement(statements, exportName, expression, location, allowComments) {
	            statements = ts.append(statements, createExportStatement(exportName, expression, location, allowComments));
	            return statements;
	        }
	        function createUnderscoreUnderscoreESModule() {
	            var statement;
	            if (languageVersion === 0 /* ES3 */) {
	                statement = ts.createStatement(createExportExpression(ts.createIdentifier("__esModule"), ts.createLiteral(/*value*/ true)));
	            }
	            else {
	                statement = ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("Object"), "defineProperty"), 
	                /*typeArguments*/ undefined, [
	                    ts.createIdentifier("exports"),
	                    ts.createLiteral("__esModule"),
	                    ts.createObjectLiteral([
	                        ts.createPropertyAssignment("value", ts.createLiteral(/*value*/ true))
	                    ])
	                ]));
	            }
	            ts.setEmitFlags(statement, 1048576 /* CustomPrologue */);
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param location The location to use for source maps and comments for the export.
	         * @param allowComments An optional value indicating whether to emit comments for the statement.
	         */
	        function createExportStatement(name, value, location, allowComments) {
	            var statement = ts.setTextRange(ts.createStatement(createExportExpression(name, value)), location);
	            ts.startOnNewLine(statement);
	            if (!allowComments) {
	                ts.setEmitFlags(statement, 1536 /* NoComments */);
	            }
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param location The location to use for source maps and comments for the export.
	         */
	        function createExportExpression(name, value, location) {
	            return ts.setTextRange(ts.createAssignment(ts.createPropertyAccess(ts.createIdentifier("exports"), ts.getSynthesizedClone(name)), value), location);
	        }
	        //
	        // Modifier Visitors
	        //
	        /**
	         * Visit nodes to elide module-specific modifiers.
	         *
	         * @param node The node to visit.
	         */
	        function modifierVisitor(node) {
	            // Elide module-specific modifiers.
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return undefined;
	            }
	            return node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit notifications.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (node.kind === 273 /* SourceFile */) {
	                currentSourceFile = node;
	                currentModuleInfo = moduleInfoMap[ts.getOriginalNodeId(currentSourceFile)];
	                noSubstitution = [];
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	                currentModuleInfo = undefined;
	                noSubstitution = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (node.id && noSubstitution[node.id]) {
	                return node;
	            }
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for a ShorthandPropertyAssignment whose declaration name is an imported
	         * or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteShorthandPropertyAssignment(node) {
	            var name = node.name;
	            var exportedOrImportedName = substituteExpressionIdentifier(name);
	            if (exportedOrImportedName !== name) {
	                // A shorthand property with an assignment initializer is probably part of a
	                // destructuring assignment
	                if (node.objectAssignmentInitializer) {
	                    var initializer = ts.createAssignment(exportedOrImportedName, node.objectAssignmentInitializer);
	                    return ts.setTextRange(ts.createPropertyAssignment(name, initializer), node);
	                }
	                return ts.setTextRange(ts.createPropertyAssignment(name, exportedOrImportedName), node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Expression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 199 /* BinaryExpression */:
	                    return substituteBinaryExpression(node);
	                case 198 /* PostfixUnaryExpression */:
	                case 197 /* PrefixUnaryExpression */:
	                    return substituteUnaryExpression(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Identifier expression that may contain an imported or exported
	         * symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	                return node;
	            }
	            if (!ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                var exportContainer = resolver.getReferencedExportContainer(node, ts.isExportName(node));
	                if (exportContainer && exportContainer.kind === 273 /* SourceFile */) {
	                    return ts.setTextRange(ts.createPropertyAccess(ts.createIdentifier("exports"), ts.getSynthesizedClone(node)), 
	                    /*location*/ node);
	                }
	                var importDeclaration = resolver.getReferencedImportDeclaration(node);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default")), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        var name = importDeclaration.propertyName || importDeclaration.name;
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(name)), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a BinaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteBinaryExpression(node) {
	            // When we see an assignment expression whose left-hand side is an exported symbol,
	            // we should ensure all exports of that symbol are updated with the correct value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if (ts.isAssignmentOperator(node.operatorToken.kind)
	                && ts.isIdentifier(node.left)
	                && !ts.isGeneratedIdentifier(node.left)
	                && !ts.isLocalName(node.left)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.left)) {
	                var exportedNames = getExports(node.left);
	                if (exportedNames) {
	                    // For each additional export of the declaration, apply an export assignment.
	                    var expression = node;
	                    for (var _i = 0, exportedNames_2 = exportedNames; _i < exportedNames_2.length; _i++) {
	                        var exportName = exportedNames_2[_i];
	                        // Mark the node to prevent triggering this rule again.
	                        noSubstitution[ts.getNodeId(expression)] = true;
	                        expression = createExportExpression(exportName, expression, /*location*/ node);
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a UnaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnaryExpression(node) {
	            // When we see a prefix or postfix increment expression whose operand is an exported
	            // symbol, we should ensure all exports of that symbol are updated with the correct
	            // value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if ((node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */)
	                && ts.isIdentifier(node.operand)
	                && !ts.isGeneratedIdentifier(node.operand)
	                && !ts.isLocalName(node.operand)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.operand)) {
	                var exportedNames = getExports(node.operand);
	                if (exportedNames) {
	                    var expression = node.kind === 198 /* PostfixUnaryExpression */
	                        ? ts.setTextRange(ts.createBinary(node.operand, ts.createToken(node.operator === 43 /* PlusPlusToken */ ? 59 /* PlusEqualsToken */ : 60 /* MinusEqualsToken */), ts.createLiteral(1)), 
	                        /*location*/ node)
	                        : node;
	                    for (var _i = 0, exportedNames_3 = exportedNames; _i < exportedNames_3.length; _i++) {
	                        var exportName = exportedNames_3[_i];
	                        // Mark the node to prevent triggering this rule again.
	                        noSubstitution[ts.getNodeId(expression)] = true;
	                        expression = createExportExpression(exportName, expression);
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Gets the additional exports of a name.
	         *
	         * @param name The name.
	         */
	        function getExports(name) {
	            if (!ts.isGeneratedIdentifier(name)) {
	                var valueDeclaration = resolver.getReferencedImportDeclaration(name)
	                    || resolver.getReferencedValueDeclaration(name);
	                if (valueDeclaration) {
	                    return currentModuleInfo
	                        && currentModuleInfo.exportedBindings[ts.getOriginalNodeId(valueDeclaration)];
	                }
	            }
	        }
	    }
	    ts.transformModule = transformModule;
	    // emit output for the __export helper function
	    var exportStarHelper = {
	        name: "typescript:export-star",
	        scoped: true,
	        text: "\n            function __export(m) {\n                for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];\n            }"
	    };
	    function createExportStarHelper(context, module) {
	        var compilerOptions = context.getCompilerOptions();
	        return compilerOptions.importHelpers
	            ? ts.createCall(ts.getHelperName("__exportStar"), /*typeArguments*/ undefined, [module, ts.createIdentifier("exports")])
	            : ts.createCall(ts.createIdentifier("__export"), /*typeArguments*/ undefined, [module]);
	    }
	    // emit helper for dynamic import
	    var dynamicImportUMDHelper = {
	        name: "typescript:dynamicimport-sync-require",
	        scoped: true,
	        text: "\n            var __syncRequire = typeof module === \"object\" && typeof module.exports === \"object\";"
	    };
	    // emit helper for `import * as Name from "foo"`
	    var importStarHelper = {
	        name: "typescript:commonjsimportstar",
	        scoped: false,
	        text: "\nvar __importStar = (this && this.__importStar) || function (mod) {\n    if (mod && mod.__esModule) return mod;\n    var result = {};\n    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];\n    result[\"default\"] = mod;\n    return result;\n};"
	    };
	    // emit helper for `import Name from "foo"`
	    var importDefaultHelper = {
	        name: "typescript:commonjsimportdefault",
	        scoped: false,
	        text: "\nvar __importDefault = (this && this.__importDefault) || function (mod) {\n    return (mod && mod.__esModule) ? mod : { \"default\": mod };\n};"
	    };
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformSystemModule(context) {
	        var startLexicalEnvironment = context.startLexicalEnvironment, endLexicalEnvironment = context.endLexicalEnvironment, hoistVariableDeclaration = context.hoistVariableDeclaration;
	        var compilerOptions = context.getCompilerOptions();
	        var resolver = context.getEmitResolver();
	        var host = context.getEmitHost();
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        var previousOnEmitNode = context.onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.enableSubstitution(71 /* Identifier */); // Substitutes expression identifiers for imported symbols.
	        context.enableSubstitution(270 /* ShorthandPropertyAssignment */); // Substitutes expression identifiers for imported symbols
	        context.enableSubstitution(199 /* BinaryExpression */); // Substitutes assignments to exported symbols.
	        context.enableSubstitution(197 /* PrefixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableSubstitution(198 /* PostfixUnaryExpression */); // Substitutes updates to exported symbols.
	        context.enableEmitNotification(273 /* SourceFile */); // Restore state when substituting nodes in a file.
	        var moduleInfoMap = []; // The ExternalModuleInfo for each file.
	        var deferredExports = []; // Exports to defer until an EndOfDeclarationMarker is found.
	        var exportFunctionsMap = []; // The export function associated with a source file.
	        var noSubstitutionMap = []; // Set of nodes for which substitution rules should be ignored for each file.
	        var currentSourceFile; // The current file.
	        var moduleInfo; // ExternalModuleInfo for the current file.
	        var exportFunction; // The export function for the current file.
	        var contextObject; // The context object for the current file.
	        var hoistedStatements;
	        var enclosingBlockScopedContainer;
	        var noSubstitution; // Set of nodes for which substitution rules should be ignored.
	        return ts.chainBundle(transformSourceFile);
	        /**
	         * Transforms the module aspects of a SourceFile.
	         *
	         * @param node The SourceFile node.
	         */
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile || !(ts.isEffectiveExternalModule(node, compilerOptions) || node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return node;
	            }
	            var id = ts.getOriginalNodeId(node);
	            currentSourceFile = node;
	            enclosingBlockScopedContainer = node;
	            // System modules have the following shape:
	            //
	            //     System.register(['dep-1', ... 'dep-n'], function(exports) {/* module body function */})
	            //
	            // The parameter 'exports' here is a callback '<T>(name: string, value: T) => T' that
	            // is used to publish exported values. 'exports' returns its 'value' argument so in
	            // most cases expressions that mutate exported values can be rewritten as:
	            //
	            //     expr -> exports('name', expr)
	            //
	            // The only exception in this rule is postfix unary operators,
	            // see comment to 'substitutePostfixUnaryExpression' for more details
	            // Collect information about the external module and dependency groups.
	            moduleInfo = moduleInfoMap[id] = ts.collectExternalModuleInfo(node, resolver, compilerOptions);
	            // Make sure that the name of the 'exports' function does not conflict with
	            // existing identifiers.
	            exportFunction = ts.createUniqueName("exports");
	            exportFunctionsMap[id] = exportFunction;
	            contextObject = ts.createUniqueName("context");
	            // Add the body of the module.
	            var dependencyGroups = collectDependencyGroups(moduleInfo.externalImports);
	            var moduleBodyBlock = createSystemModuleBody(node, dependencyGroups);
	            var moduleBodyFunction = ts.createFunctionExpression(
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, 
	            /*name*/ undefined, 
	            /*typeParameters*/ undefined, [
	                ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, exportFunction),
	                ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, contextObject)
	            ], 
	            /*type*/ undefined, moduleBodyBlock);
	            // Write the call to `System.register`
	            // Clear the emit-helpers flag for later passes since we'll have already used it in the module body
	            // So the helper will be emit at the correct position instead of at the top of the source-file
	            var moduleName = ts.tryGetModuleNameFromFile(node, host, compilerOptions);
	            var dependencies = ts.createArrayLiteral(ts.map(dependencyGroups, function (dependencyGroup) { return dependencyGroup.name; }));
	            var updated = ts.setEmitFlags(ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray([
	                ts.createStatement(ts.createCall(ts.createPropertyAccess(ts.createIdentifier("System"), "register"), 
	                /*typeArguments*/ undefined, moduleName
	                    ? [moduleName, dependencies, moduleBodyFunction]
	                    : [dependencies, moduleBodyFunction]))
	            ]), node.statements)), 1024 /* NoTrailingComments */);
	            if (!(compilerOptions.outFile || compilerOptions.out)) {
	                ts.moveEmitHelpers(updated, moduleBodyBlock, function (helper) { return !helper.scoped; });
	            }
	            if (noSubstitution) {
	                noSubstitutionMap[id] = noSubstitution;
	                noSubstitution = undefined;
	            }
	            currentSourceFile = undefined;
	            moduleInfo = undefined;
	            exportFunction = undefined;
	            contextObject = undefined;
	            hoistedStatements = undefined;
	            enclosingBlockScopedContainer = undefined;
	            return ts.aggregateTransformFlags(updated);
	        }
	        /**
	         * Collects the dependency groups for this files imports.
	         *
	         * @param externalImports The imports for the file.
	         */
	        function collectDependencyGroups(externalImports) {
	            var groupIndices = ts.createMap();
	            var dependencyGroups = [];
	            for (var _i = 0, externalImports_1 = externalImports; _i < externalImports_1.length; _i++) {
	                var externalImport = externalImports_1[_i];
	                var externalModuleName = ts.getExternalModuleNameLiteral(externalImport, currentSourceFile, host, resolver, compilerOptions);
	                if (externalModuleName) {
	                    var text = externalModuleName.text;
	                    var groupIndex = groupIndices.get(text);
	                    if (groupIndex !== undefined) {
	                        // deduplicate/group entries in dependency list by the dependency name
	                        dependencyGroups[groupIndex].externalImports.push(externalImport);
	                    }
	                    else {
	                        groupIndices.set(text, dependencyGroups.length);
	                        dependencyGroups.push({
	                            name: externalModuleName,
	                            externalImports: [externalImport]
	                        });
	                    }
	                }
	            }
	            return dependencyGroups;
	        }
	        /**
	         * Adds the statements for the module body function for the source file.
	         *
	         * @param node The source file for the module.
	         * @param dependencyGroups The grouped dependencies of the module.
	         */
	        function createSystemModuleBody(node, dependencyGroups) {
	            // Shape of the body in system modules:
	            //
	            //  function (exports) {
	            //      <list of local aliases for imports>
	            //      <hoisted variable declarations>
	            //      <hoisted function declarations>
	            //      return {
	            //          setters: [
	            //              <list of setter function for imports>
	            //          ],
	            //          execute: function() {
	            //              <module statements>
	            //          }
	            //      }
	            //      <temp declarations>
	            //  }
	            //
	            // i.e:
	            //
	            //   import {x} from 'file1'
	            //   var y = 1;
	            //   export function foo() { return y + x(); }
	            //   console.log(y);
	            //
	            // Will be transformed to:
	            //
	            //  function(exports) {
	            //      function foo() { return y + file_1.x(); }
	            //      exports("foo", foo);
	            //      var file_1, y;
	            //      return {
	            //          setters: [
	            //              function(v) { file_1 = v }
	            //          ],
	            //          execute(): function() {
	            //              y = 1;
	            //              console.log(y);
	            //          }
	            //      };
	            //  }
	            var statements = [];
	            // We start a new lexical environment in this function body, but *not* in the
	            // body of the execute function. This allows us to emit temporary declarations
	            // only in the outer module body and not in the inner one.
	            startLexicalEnvironment();
	            // Add any prologue directives.
	            var ensureUseStrict = ts.getStrictOptionValue(compilerOptions, "alwaysStrict") || (!compilerOptions.noImplicitUseStrict && ts.isExternalModule(currentSourceFile));
	            var statementOffset = ts.addPrologue(statements, node.statements, ensureUseStrict, sourceElementVisitor);
	            // var __moduleName = context_1 && context_1.id;
	            statements.push(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration("__moduleName", 
	                /*type*/ undefined, ts.createLogicalAnd(contextObject, ts.createPropertyAccess(contextObject, "id")))
	            ])));
	            // Visit the synthetic external helpers import declaration if present
	            ts.visitNode(moduleInfo.externalHelpersImportDeclaration, sourceElementVisitor, ts.isStatement);
	            // Visit the statements of the source file, emitting any transformations into
	            // the `executeStatements` array. We do this *before* we fill the `setters` array
	            // as we both emit transformations as well as aggregate some data used when creating
	            // setters. This allows us to reduce the number of times we need to loop through the
	            // statements of the source file.
	            var executeStatements = ts.visitNodes(node.statements, sourceElementVisitor, ts.isStatement, statementOffset);
	            // Emit early exports for function declarations.
	            ts.addRange(statements, hoistedStatements);
	            // We emit hoisted variables early to align roughly with our previous emit output.
	            // Two key differences in this approach are:
	            // - Temporary variables will appear at the top rather than at the bottom of the file
	            ts.prependStatements(statements, endLexicalEnvironment());
	            var exportStarFunction = addExportStarIfNeeded(statements);
	            var moduleObject = ts.createObjectLiteral([
	                ts.createPropertyAssignment("setters", createSettersArray(exportStarFunction, dependencyGroups)),
	                ts.createPropertyAssignment("execute", ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, 
	                /*parameters*/ [], 
	                /*type*/ undefined, ts.createBlock(executeStatements, /*multiLine*/ true)))
	            ]);
	            moduleObject.multiLine = true;
	            statements.push(ts.createReturn(moduleObject));
	            return ts.createBlock(statements, /*multiLine*/ true);
	        }
	        /**
	         * Adds an exportStar function to a statement list if it is needed for the file.
	         *
	         * @param statements A statement list.
	         */
	        function addExportStarIfNeeded(statements) {
	            if (!moduleInfo.hasExportStarsToExportValues) {
	                return;
	            }
	            // when resolving exports local exported entries/indirect exported entries in the module
	            // should always win over entries with similar names that were added via star exports
	            // to support this we store names of local/indirect exported entries in a set.
	            // this set is used to filter names brought by star expors.
	            // local names set should only be added if we have anything exported
	            if (!moduleInfo.exportedNames && moduleInfo.exportSpecifiers.size === 0) {
	                // no exported declarations (export var ...) or export specifiers (export {x})
	                // check if we have any non star export declarations.
	                var hasExportDeclarationWithExportClause = false;
	                for (var _i = 0, _a = moduleInfo.externalImports; _i < _a.length; _i++) {
	                    var externalImport = _a[_i];
	                    if (externalImport.kind === 249 /* ExportDeclaration */ && externalImport.exportClause) {
	                        hasExportDeclarationWithExportClause = true;
	                        break;
	                    }
	                }
	                if (!hasExportDeclarationWithExportClause) {
	                    // we still need to emit exportStar helper
	                    var exportStarFunction_1 = createExportStarFunction(/*localNames*/ undefined);
	                    statements.push(exportStarFunction_1);
	                    return exportStarFunction_1.name;
	                }
	            }
	            var exportedNames = [];
	            if (moduleInfo.exportedNames) {
	                for (var _b = 0, _c = moduleInfo.exportedNames; _b < _c.length; _b++) {
	                    var exportedLocalName = _c[_b];
	                    if (exportedLocalName.escapedText === "default") {
	                        continue;
	                    }
	                    // write name of exported declaration, i.e 'export var x...'
	                    exportedNames.push(ts.createPropertyAssignment(ts.createLiteral(exportedLocalName), ts.createTrue()));
	                }
	            }
	            for (var _d = 0, _e = moduleInfo.externalImports; _d < _e.length; _d++) {
	                var externalImport = _e[_d];
	                if (externalImport.kind !== 249 /* ExportDeclaration */) {
	                    continue;
	                }
	                if (!externalImport.exportClause) {
	                    // export * from ...
	                    continue;
	                }
	                for (var _f = 0, _g = externalImport.exportClause.elements; _f < _g.length; _f++) {
	                    var element = _g[_f];
	                    // write name of indirectly exported entry, i.e. 'export {x} from ...'
	                    exportedNames.push(ts.createPropertyAssignment(ts.createLiteral(ts.idText(element.name || element.propertyName)), ts.createTrue()));
	                }
	            }
	            var exportedNamesStorageRef = ts.createUniqueName("exportedNames");
	            statements.push(ts.createVariableStatement(
	            /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                ts.createVariableDeclaration(exportedNamesStorageRef, 
	                /*type*/ undefined, ts.createObjectLiteral(exportedNames, /*multiline*/ true))
	            ])));
	            var exportStarFunction = createExportStarFunction(exportedNamesStorageRef);
	            statements.push(exportStarFunction);
	            return exportStarFunction.name;
	        }
	        /**
	         * Creates an exportStar function for the file, with an optional set of excluded local
	         * names.
	         *
	         * @param localNames An optional reference to an object containing a set of excluded local
	         * names.
	         */
	        function createExportStarFunction(localNames) {
	            var exportStarFunction = ts.createUniqueName("exportStar");
	            var m = ts.createIdentifier("m");
	            var n = ts.createIdentifier("n");
	            var exports = ts.createIdentifier("exports");
	            var condition = ts.createStrictInequality(n, ts.createLiteral("default"));
	            if (localNames) {
	                condition = ts.createLogicalAnd(condition, ts.createLogicalNot(ts.createCall(ts.createPropertyAccess(localNames, "hasOwnProperty"), 
	                /*typeArguments*/ undefined, [n])));
	            }
	            return ts.createFunctionDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*asteriskToken*/ undefined, exportStarFunction, 
	            /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, m)], 
	            /*type*/ undefined, ts.createBlock([
	                ts.createVariableStatement(
	                /*modifiers*/ undefined, ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(exports, 
	                    /*type*/ undefined, ts.createObjectLiteral([]))
	                ])),
	                ts.createForIn(ts.createVariableDeclarationList([
	                    ts.createVariableDeclaration(n, /*type*/ undefined)
	                ]), m, ts.createBlock([
	                    ts.setEmitFlags(ts.createIf(condition, ts.createStatement(ts.createAssignment(ts.createElementAccess(exports, n), ts.createElementAccess(m, n)))), 1 /* SingleLine */)
	                ])),
	                ts.createStatement(ts.createCall(exportFunction, 
	                /*typeArguments*/ undefined, [exports]))
	            ], /*multiline*/ true));
	        }
	        /**
	         * Creates an array setter callbacks for each dependency group.
	         *
	         * @param exportStarFunction A reference to an exportStarFunction for the file.
	         * @param dependencyGroups An array of grouped dependencies.
	         */
	        function createSettersArray(exportStarFunction, dependencyGroups) {
	            var setters = [];
	            for (var _i = 0, dependencyGroups_1 = dependencyGroups; _i < dependencyGroups_1.length; _i++) {
	                var group_1 = dependencyGroups_1[_i];
	                // derive a unique name for parameter from the first named entry in the group
	                var localName = ts.forEach(group_1.externalImports, function (i) { return ts.getLocalNameForExternalImport(i, currentSourceFile); });
	                var parameterName = localName ? ts.getGeneratedNameForNode(localName) : ts.createUniqueName("");
	                var statements = [];
	                for (var _a = 0, _b = group_1.externalImports; _a < _b.length; _a++) {
	                    var entry = _b[_a];
	                    var importVariableName = ts.getLocalNameForExternalImport(entry, currentSourceFile);
	                    switch (entry.kind) {
	                        case 243 /* ImportDeclaration */:
	                            if (!entry.importClause) {
	                                // 'import "..."' case
	                                // module is imported only for side-effects, no emit required
	                                break;
	                            }
	                        // falls through
	                        case 242 /* ImportEqualsDeclaration */:
	                            ts.Debug.assert(importVariableName !== undefined);
	                            // save import into the local
	                            statements.push(ts.createStatement(ts.createAssignment(importVariableName, parameterName)));
	                            break;
	                        case 249 /* ExportDeclaration */:
	                            ts.Debug.assert(importVariableName !== undefined);
	                            if (entry.exportClause) {
	                                //  export {a, b as c} from 'foo'
	                                //
	                                // emit as:
	                                //
	                                //  exports_({
	                                //     "a": _["a"],
	                                //     "c": _["b"]
	                                //  });
	                                var properties = [];
	                                for (var _c = 0, _d = entry.exportClause.elements; _c < _d.length; _c++) {
	                                    var e = _d[_c];
	                                    properties.push(ts.createPropertyAssignment(ts.createLiteral(ts.idText(e.name)), ts.createElementAccess(parameterName, ts.createLiteral(ts.idText(e.propertyName || e.name)))));
	                                }
	                                statements.push(ts.createStatement(ts.createCall(exportFunction, 
	                                /*typeArguments*/ undefined, [ts.createObjectLiteral(properties, /*multiline*/ true)])));
	                            }
	                            else {
	                                //  export * from 'foo'
	                                //
	                                // emit as:
	                                //
	                                //  exportStar(foo_1_1);
	                                statements.push(ts.createStatement(ts.createCall(exportStarFunction, 
	                                /*typeArguments*/ undefined, [parameterName])));
	                            }
	                            break;
	                    }
	                }
	                setters.push(ts.createFunctionExpression(
	                /*modifiers*/ undefined, 
	                /*asteriskToken*/ undefined, 
	                /*name*/ undefined, 
	                /*typeParameters*/ undefined, [ts.createParameter(/*decorators*/ undefined, /*modifiers*/ undefined, /*dotDotDotToken*/ undefined, parameterName)], 
	                /*type*/ undefined, ts.createBlock(statements, /*multiLine*/ true)));
	            }
	            return ts.createArrayLiteral(setters, /*multiLine*/ true);
	        }
	        //
	        // Top-level Source Element Visitors
	        //
	        /**
	         * Visit source elements at the top-level of a module.
	         *
	         * @param node The node to visit.
	         */
	        function sourceElementVisitor(node) {
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return visitImportDeclaration(node);
	                case 242 /* ImportEqualsDeclaration */:
	                    return visitImportEqualsDeclaration(node);
	                case 249 /* ExportDeclaration */:
	                    // ExportDeclarations are elided as they are handled via
	                    // `appendExportsOfDeclaration`.
	                    return undefined;
	                case 248 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	                default:
	                    return nestedElementVisitor(node);
	            }
	        }
	        /**
	         * Visits an ImportDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportDeclaration(node) {
	            var statements;
	            if (node.importClause) {
	                hoistVariableDeclaration(ts.getLocalNameForExternalImport(node, currentSourceFile));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ImportEqualsDeclaration node.
	         *
	         * @param node The node to visit.
	         */
	        function visitImportEqualsDeclaration(node) {
	            ts.Debug.assert(ts.isExternalModuleImportEqualsDeclaration(node), "import= for internal module references should be handled in an earlier transformer.");
	            var statements;
	            hoistVariableDeclaration(ts.getLocalNameForExternalImport(node, currentSourceFile));
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfImportEqualsDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfImportEqualsDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits an ExportAssignment node.
	         *
	         * @param node The node to visit.
	         */
	        function visitExportAssignment(node) {
	            if (node.isExportEquals) {
	                // Elide `export=` as it is illegal in a SystemJS module.
	                return undefined;
	            }
	            var expression = ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression);
	            var original = node.original;
	            if (original && hasAssociatedEndOfDeclarationMarker(original)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportStatement(deferredExports[id], ts.createIdentifier("default"), expression, /*allowComments*/ true);
	            }
	            else {
	                return createExportStatement(ts.createIdentifier("default"), expression, /*allowComments*/ true);
	            }
	        }
	        /**
	         * Visits a FunctionDeclaration, hoisting it to the outer module body function.
	         *
	         * @param node The node to visit.
	         */
	        function visitFunctionDeclaration(node) {
	            if (ts.hasModifier(node, 1 /* Export */)) {
	                hoistedStatements = ts.append(hoistedStatements, ts.updateFunctionDeclaration(node, node.decorators, ts.visitNodes(node.modifiers, modifierVisitor, ts.isModifier), node.asteriskToken, ts.getDeclarationName(node, /*allowComments*/ true, /*allowSourceMaps*/ true), 
	                /*typeParameters*/ undefined, ts.visitNodes(node.parameters, destructuringAndImportCallVisitor, ts.isParameterDeclaration), 
	                /*type*/ undefined, ts.visitNode(node.body, destructuringAndImportCallVisitor, ts.isBlock)));
	            }
	            else {
	                hoistedStatements = ts.append(hoistedStatements, ts.visitEachChild(node, destructuringAndImportCallVisitor, context));
	            }
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                hoistedStatements = appendExportsOfHoistedDeclaration(hoistedStatements, node);
	            }
	            return undefined;
	        }
	        /**
	         * Visits a ClassDeclaration, hoisting its name to the outer module body function.
	         *
	         * @param node The node to visit.
	         */
	        function visitClassDeclaration(node) {
	            var statements;
	            // Hoist the name of the class declaration to the outer module body function.
	            var name = ts.getLocalName(node);
	            hoistVariableDeclaration(name);
	            // Rewrite the class declaration into an assignment of a class expression.
	            statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.createAssignment(name, ts.setTextRange(ts.createClassExpression(
	            /*modifiers*/ undefined, node.name, 
	            /*typeParameters*/ undefined, ts.visitNodes(node.heritageClauses, destructuringAndImportCallVisitor, ts.isHeritageClause), ts.visitNodes(node.members, destructuringAndImportCallVisitor, ts.isClassElement)), node))), node));
	            if (hasAssociatedEndOfDeclarationMarker(node)) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfHoistedDeclaration(deferredExports[id], node);
	            }
	            else {
	                statements = appendExportsOfHoistedDeclaration(statements, node);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Visits a variable statement, hoisting declared names to the top-level module body.
	         * Each declaration is rewritten into an assignment expression.
	         *
	         * @param node The node to visit.
	         */
	        function visitVariableStatement(node) {
	            if (!shouldHoistVariableDeclarationList(node.declarationList)) {
	                return ts.visitNode(node, destructuringAndImportCallVisitor, ts.isStatement);
	            }
	            var expressions;
	            var isExportedDeclaration = ts.hasModifier(node, 1 /* Export */);
	            var isMarkedDeclaration = hasAssociatedEndOfDeclarationMarker(node);
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var variable = _a[_i];
	                if (variable.initializer) {
	                    expressions = ts.append(expressions, transformInitializedVariable(variable, isExportedDeclaration && !isMarkedDeclaration));
	                }
	                else {
	                    hoistBindingElement(variable);
	                }
	            }
	            var statements;
	            if (expressions) {
	                statements = ts.append(statements, ts.setTextRange(ts.createStatement(ts.inlineExpressions(expressions)), node));
	            }
	            if (isMarkedDeclaration) {
	                // Defer exports until we encounter an EndOfDeclarationMarker node
	                var id = ts.getOriginalNodeId(node);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node, isExportedDeclaration);
	            }
	            else {
	                statements = appendExportsOfVariableStatement(statements, node, /*exportSelf*/ false);
	            }
	            return ts.singleOrMany(statements);
	        }
	        /**
	         * Hoists the declared names of a VariableDeclaration or BindingElement.
	         *
	         * @param node The declaration to hoist.
	         */
	        function hoistBindingElement(node) {
	            if (ts.isBindingPattern(node.name)) {
	                for (var _i = 0, _a = node.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        hoistBindingElement(element);
	                    }
	                }
	            }
	            else {
	                hoistVariableDeclaration(ts.getSynthesizedClone(node.name));
	            }
	        }
	        /**
	         * Determines whether a VariableDeclarationList should be hoisted.
	         *
	         * @param node The node to test.
	         */
	        function shouldHoistVariableDeclarationList(node) {
	            // hoist only non-block scoped declarations or block scoped declarations parented by source file
	            return (ts.getEmitFlags(node) & 2097152 /* NoHoisting */) === 0
	                && (enclosingBlockScopedContainer.kind === 273 /* SourceFile */
	                    || (ts.getOriginalNode(node).flags & 3 /* BlockScoped */) === 0);
	        }
	        /**
	         * Transform an initialized variable declaration into an expression.
	         *
	         * @param node The node to transform.
	         * @param isExportedDeclaration A value indicating whether the variable is exported.
	         */
	        function transformInitializedVariable(node, isExportedDeclaration) {
	            var createAssignment = isExportedDeclaration ? createExportedVariableAssignment : createNonExportedVariableAssignment;
	            return ts.isBindingPattern(node.name)
	                ? ts.flattenDestructuringAssignment(node, destructuringAndImportCallVisitor, context, 0 /* All */, 
	                /*needsValue*/ false, createAssignment)
	                : node.initializer ? createAssignment(node.name, ts.visitNode(node.initializer, destructuringAndImportCallVisitor, ts.isExpression)) : node.name;
	        }
	        /**
	         * Creates an assignment expression for an exported variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         */
	        function createExportedVariableAssignment(name, value, location) {
	            return createVariableAssignment(name, value, location, /*isExportedDeclaration*/ true);
	        }
	        /**
	         * Creates an assignment expression for a non-exported variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         */
	        function createNonExportedVariableAssignment(name, value, location) {
	            return createVariableAssignment(name, value, location, /*isExportedDeclaration*/ false);
	        }
	        /**
	         * Creates an assignment expression for a variable declaration.
	         *
	         * @param name The name of the variable.
	         * @param value The value of the variable's initializer.
	         * @param location The source map location for the assignment.
	         * @param isExportedDeclaration A value indicating whether the variable is exported.
	         */
	        function createVariableAssignment(name, value, location, isExportedDeclaration) {
	            hoistVariableDeclaration(ts.getSynthesizedClone(name));
	            return isExportedDeclaration
	                ? createExportExpression(name, preventSubstitution(ts.setTextRange(ts.createAssignment(name, value), location)))
	                : preventSubstitution(ts.setTextRange(ts.createAssignment(name, value), location));
	        }
	        /**
	         * Visits a MergeDeclarationMarker used as a placeholder for the beginning of a merged
	         * and transformed declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitMergeDeclarationMarker(node) {
	            // For an EnumDeclaration or ModuleDeclaration that merges with a preceeding
	            // declaration we do not emit a leading variable declaration. To preserve the
	            // begin/end semantics of the declararation and to properly handle exports
	            // we wrapped the leading variable declaration in a `MergeDeclarationMarker`.
	            //
	            // To balance the declaration, we defer the exports of the elided variable
	            // statement until we visit this declaration's `EndOfDeclarationMarker`.
	            if (hasAssociatedEndOfDeclarationMarker(node) && node.original.kind === 213 /* VariableStatement */) {
	                var id = ts.getOriginalNodeId(node);
	                var isExportedDeclaration = ts.hasModifier(node.original, 1 /* Export */);
	                deferredExports[id] = appendExportsOfVariableStatement(deferredExports[id], node.original, isExportedDeclaration);
	            }
	            return node;
	        }
	        /**
	         * Determines whether a node has an associated EndOfDeclarationMarker.
	         *
	         * @param node The node to test.
	         */
	        function hasAssociatedEndOfDeclarationMarker(node) {
	            return (ts.getEmitFlags(node) & 4194304 /* HasEndOfDeclarationMarker */) !== 0;
	        }
	        /**
	         * Visits a DeclarationMarker used as a placeholder for the end of a transformed
	         * declaration.
	         *
	         * @param node The node to visit.
	         */
	        function visitEndOfDeclarationMarker(node) {
	            // For some transformations we emit an `EndOfDeclarationMarker` to mark the actual
	            // end of the transformed declaration. We use this marker to emit any deferred exports
	            // of the declaration.
	            var id = ts.getOriginalNodeId(node);
	            var statements = deferredExports[id];
	            if (statements) {
	                delete deferredExports[id];
	                return ts.append(statements, node);
	            }
	            else {
	                var original = ts.getOriginalNode(node);
	                if (ts.isModuleOrEnumDeclaration(original)) {
	                    return ts.append(appendExportsOfDeclaration(statements, original), node);
	                }
	            }
	            return node;
	        }
	        /**
	         * Appends the exports of an ImportDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var importClause = decl.importClause;
	            if (!importClause) {
	                return statements;
	            }
	            if (importClause.name) {
	                statements = appendExportsOfDeclaration(statements, importClause);
	            }
	            var namedBindings = importClause.namedBindings;
	            if (namedBindings) {
	                switch (namedBindings.kind) {
	                    case 245 /* NamespaceImport */:
	                        statements = appendExportsOfDeclaration(statements, namedBindings);
	                        break;
	                    case 246 /* NamedImports */:
	                        for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                            var importBinding = _a[_i];
	                            statements = appendExportsOfDeclaration(statements, importBinding);
	                        }
	                        break;
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the export of an ImportEqualsDeclaration to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfImportEqualsDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            return appendExportsOfDeclaration(statements, decl);
	        }
	        /**
	         * Appends the exports of a VariableStatement to a statement list, returning the statement
	         * list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param node The VariableStatement whose exports are to be recorded.
	         * @param exportSelf A value indicating whether to also export each VariableDeclaration of
	         * `nodes` declaration list.
	         */
	        function appendExportsOfVariableStatement(statements, node, exportSelf) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                var decl = _a[_i];
	                if (decl.initializer || exportSelf) {
	                    statements = appendExportsOfBindingElement(statements, decl, exportSelf);
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a VariableDeclaration or BindingElement to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         * @param exportSelf A value indicating whether to also export the declaration itself.
	         */
	        function appendExportsOfBindingElement(statements, decl, exportSelf) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            if (ts.isBindingPattern(decl.name)) {
	                for (var _i = 0, _a = decl.name.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    if (!ts.isOmittedExpression(element)) {
	                        statements = appendExportsOfBindingElement(statements, element, exportSelf);
	                    }
	                }
	            }
	            else if (!ts.isGeneratedIdentifier(decl.name)) {
	                var excludeName = void 0;
	                if (exportSelf) {
	                    statements = appendExportStatement(statements, decl.name, ts.getLocalName(decl));
	                    excludeName = ts.idText(decl.name);
	                }
	                statements = appendExportsOfDeclaration(statements, decl, excludeName);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a ClassDeclaration or FunctionDeclaration to a statement list,
	         * returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration whose exports are to be recorded.
	         */
	        function appendExportsOfHoistedDeclaration(statements, decl) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var excludeName;
	            if (ts.hasModifier(decl, 1 /* Export */)) {
	                var exportName = ts.hasModifier(decl, 512 /* Default */) ? ts.createLiteral("default") : decl.name;
	                statements = appendExportStatement(statements, exportName, ts.getLocalName(decl));
	                excludeName = ts.getTextOfIdentifierOrLiteral(exportName);
	            }
	            if (decl.name) {
	                statements = appendExportsOfDeclaration(statements, decl, excludeName);
	            }
	            return statements;
	        }
	        /**
	         * Appends the exports of a declaration to a statement list, returning the statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param decl The declaration to export.
	         * @param excludeName An optional name to exclude from exports.
	         */
	        function appendExportsOfDeclaration(statements, decl, excludeName) {
	            if (moduleInfo.exportEquals) {
	                return statements;
	            }
	            var name = ts.getDeclarationName(decl);
	            var exportSpecifiers = moduleInfo.exportSpecifiers.get(ts.idText(name));
	            if (exportSpecifiers) {
	                for (var _i = 0, exportSpecifiers_2 = exportSpecifiers; _i < exportSpecifiers_2.length; _i++) {
	                    var exportSpecifier = exportSpecifiers_2[_i];
	                    if (exportSpecifier.name.escapedText !== excludeName) {
	                        statements = appendExportStatement(statements, exportSpecifier.name, name);
	                    }
	                }
	            }
	            return statements;
	        }
	        /**
	         * Appends the down-level representation of an export to a statement list, returning the
	         * statement list.
	         *
	         * @param statements A statement list to which the down-level export statements are to be
	         * appended. If `statements` is `undefined`, a new array is allocated if statements are
	         * appended.
	         * @param exportName The name of the export.
	         * @param expression The expression to export.
	         * @param allowComments Whether to allow comments on the export.
	         */
	        function appendExportStatement(statements, exportName, expression, allowComments) {
	            statements = ts.append(statements, createExportStatement(exportName, expression, allowComments));
	            return statements;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         * @param allowComments An optional value indicating whether to emit comments for the statement.
	         */
	        function createExportStatement(name, value, allowComments) {
	            var statement = ts.createStatement(createExportExpression(name, value));
	            ts.startOnNewLine(statement);
	            if (!allowComments) {
	                ts.setEmitFlags(statement, 1536 /* NoComments */);
	            }
	            return statement;
	        }
	        /**
	         * Creates a call to the current file's export function to export a value.
	         *
	         * @param name The bound name of the export.
	         * @param value The exported value.
	         */
	        function createExportExpression(name, value) {
	            var exportName = ts.isIdentifier(name) ? ts.createLiteral(name) : name;
	            ts.setEmitFlags(value, ts.getEmitFlags(value) | 1536 /* NoComments */);
	            return ts.setCommentRange(ts.createCall(exportFunction, /*typeArguments*/ undefined, [exportName, value]), value);
	        }
	        //
	        // Top-Level or Nested Source Element Visitors
	        //
	        /**
	         * Visit nested elements at the top-level of a module.
	         *
	         * @param node The node to visit.
	         */
	        function nestedElementVisitor(node) {
	            switch (node.kind) {
	                case 213 /* VariableStatement */:
	                    return visitVariableStatement(node);
	                case 233 /* FunctionDeclaration */:
	                    return visitFunctionDeclaration(node);
	                case 234 /* ClassDeclaration */:
	                    return visitClassDeclaration(node);
	                case 219 /* ForStatement */:
	                    return visitForStatement(node);
	                case 220 /* ForInStatement */:
	                    return visitForInStatement(node);
	                case 221 /* ForOfStatement */:
	                    return visitForOfStatement(node);
	                case 217 /* DoStatement */:
	                    return visitDoStatement(node);
	                case 218 /* WhileStatement */:
	                    return visitWhileStatement(node);
	                case 227 /* LabeledStatement */:
	                    return visitLabeledStatement(node);
	                case 225 /* WithStatement */:
	                    return visitWithStatement(node);
	                case 226 /* SwitchStatement */:
	                    return visitSwitchStatement(node);
	                case 240 /* CaseBlock */:
	                    return visitCaseBlock(node);
	                case 265 /* CaseClause */:
	                    return visitCaseClause(node);
	                case 266 /* DefaultClause */:
	                    return visitDefaultClause(node);
	                case 229 /* TryStatement */:
	                    return visitTryStatement(node);
	                case 268 /* CatchClause */:
	                    return visitCatchClause(node);
	                case 212 /* Block */:
	                    return visitBlock(node);
	                case 302 /* MergeDeclarationMarker */:
	                    return visitMergeDeclarationMarker(node);
	                case 303 /* EndOfDeclarationMarker */:
	                    return visitEndOfDeclarationMarker(node);
	                default:
	                    return destructuringAndImportCallVisitor(node);
	            }
	        }
	        /**
	         * Visits the body of a ForStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateFor(node, visitForInitializer(node.initializer), ts.visitNode(node.condition, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.incrementor, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a ForInStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForInStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateForIn(node, visitForInitializer(node.initializer), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a ForOfStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitForOfStatement(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateForOf(node, node.awaitModifier, visitForInitializer(node.initializer), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Determines whether to hoist the initializer of a ForStatement, ForInStatement, or
	         * ForOfStatement.
	         *
	         * @param node The node to test.
	         */
	        function shouldHoistForInitializer(node) {
	            return ts.isVariableDeclarationList(node)
	                && shouldHoistVariableDeclarationList(node);
	        }
	        /**
	         * Visits the initializer of a ForStatement, ForInStatement, or ForOfStatement
	         *
	         * @param node The node to visit.
	         */
	        function visitForInitializer(node) {
	            if (!node) {
	                return node;
	            }
	            if (shouldHoistForInitializer(node)) {
	                var expressions = void 0;
	                for (var _i = 0, _a = node.declarations; _i < _a.length; _i++) {
	                    var variable = _a[_i];
	                    expressions = ts.append(expressions, transformInitializedVariable(variable, /*isExportedDeclaration*/ false));
	                    if (!variable.initializer) {
	                        hoistBindingElement(variable);
	                    }
	                }
	                return expressions ? ts.inlineExpressions(expressions) : ts.createOmittedExpression();
	            }
	            else {
	                return ts.visitEachChild(node, nestedElementVisitor, context);
	            }
	        }
	        /**
	         * Visits the body of a DoStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitDoStatement(node) {
	            return ts.updateDo(node, ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock), ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression));
	        }
	        /**
	         * Visits the body of a WhileStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitWhileStatement(node) {
	            return ts.updateWhile(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a LabeledStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitLabeledStatement(node) {
	            return ts.updateLabel(node, node.label, ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a WithStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitWithStatement(node) {
	            return ts.updateWith(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.statement, nestedElementVisitor, ts.isStatement, ts.liftToBlock));
	        }
	        /**
	         * Visits the body of a SwitchStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitSwitchStatement(node) {
	            return ts.updateSwitch(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNode(node.caseBlock, nestedElementVisitor, ts.isCaseBlock));
	        }
	        /**
	         * Visits the body of a CaseBlock to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCaseBlock(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateCaseBlock(node, ts.visitNodes(node.clauses, nestedElementVisitor, ts.isCaseOrDefaultClause));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a CaseClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCaseClause(node) {
	            return ts.updateCaseClause(node, ts.visitNode(node.expression, destructuringAndImportCallVisitor, ts.isExpression), ts.visitNodes(node.statements, nestedElementVisitor, ts.isStatement));
	        }
	        /**
	         * Visits the body of a DefaultClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitDefaultClause(node) {
	            return ts.visitEachChild(node, nestedElementVisitor, context);
	        }
	        /**
	         * Visits the body of a TryStatement to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitTryStatement(node) {
	            return ts.visitEachChild(node, nestedElementVisitor, context);
	        }
	        /**
	         * Visits the body of a CatchClause to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitCatchClause(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.updateCatchClause(node, node.variableDeclaration, ts.visitNode(node.block, nestedElementVisitor, ts.isBlock));
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        /**
	         * Visits the body of a Block to hoist declarations.
	         *
	         * @param node The node to visit.
	         */
	        function visitBlock(node) {
	            var savedEnclosingBlockScopedContainer = enclosingBlockScopedContainer;
	            enclosingBlockScopedContainer = node;
	            node = ts.visitEachChild(node, nestedElementVisitor, context);
	            enclosingBlockScopedContainer = savedEnclosingBlockScopedContainer;
	            return node;
	        }
	        //
	        // Destructuring Assignment Visitors
	        //
	        /**
	         * Visit nodes to flatten destructuring assignments to exported symbols.
	         *
	         * @param node The node to visit.
	         */
	        function destructuringAndImportCallVisitor(node) {
	            if (node.transformFlags & 1024 /* DestructuringAssignment */
	                && node.kind === 199 /* BinaryExpression */) {
	                return visitDestructuringAssignment(node);
	            }
	            else if (ts.isImportCall(node)) {
	                return visitImportCallExpression(node);
	            }
	            else if ((node.transformFlags & 2048 /* ContainsDestructuringAssignment */) || (node.transformFlags & 67108864 /* ContainsDynamicImport */)) {
	                return ts.visitEachChild(node, destructuringAndImportCallVisitor, context);
	            }
	            else {
	                return node;
	            }
	        }
	        function visitImportCallExpression(node) {
	            // import("./blah")
	            // emit as
	            // System.register([], function (_export, _context) {
	            //     return {
	            //         setters: [],
	            //         execute: () => {
	            //             _context.import('./blah');
	            //         }
	            //     };
	            // });
	            return ts.createCall(ts.createPropertyAccess(contextObject, ts.createIdentifier("import")), 
	            /*typeArguments*/ undefined, ts.some(node.arguments) ? [ts.visitNode(node.arguments[0], destructuringAndImportCallVisitor)] : []);
	        }
	        /**
	         * Visits a DestructuringAssignment to flatten destructuring to exported symbols.
	         *
	         * @param node The node to visit.
	         */
	        function visitDestructuringAssignment(node) {
	            if (hasExportedReferenceInDestructuringTarget(node.left)) {
	                return ts.flattenDestructuringAssignment(node, destructuringAndImportCallVisitor, context, 0 /* All */, 
	                /*needsValue*/ true);
	            }
	            return ts.visitEachChild(node, destructuringAndImportCallVisitor, context);
	        }
	        /**
	         * Determines whether the target of a destructuring assigment refers to an exported symbol.
	         *
	         * @param node The destructuring target.
	         */
	        function hasExportedReferenceInDestructuringTarget(node) {
	            if (ts.isAssignmentExpression(node, /*excludeCompoundAssignment*/ true)) {
	                return hasExportedReferenceInDestructuringTarget(node.left);
	            }
	            else if (ts.isSpreadElement(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.expression);
	            }
	            else if (ts.isObjectLiteralExpression(node)) {
	                return ts.some(node.properties, hasExportedReferenceInDestructuringTarget);
	            }
	            else if (ts.isArrayLiteralExpression(node)) {
	                return ts.some(node.elements, hasExportedReferenceInDestructuringTarget);
	            }
	            else if (ts.isShorthandPropertyAssignment(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.name);
	            }
	            else if (ts.isPropertyAssignment(node)) {
	                return hasExportedReferenceInDestructuringTarget(node.initializer);
	            }
	            else if (ts.isIdentifier(node)) {
	                var container = resolver.getReferencedExportContainer(node);
	                return container !== undefined && container.kind === 273 /* SourceFile */;
	            }
	            else {
	                return false;
	            }
	        }
	        //
	        // Modifier Visitors
	        //
	        /**
	         * Visit nodes to elide module-specific modifiers.
	         *
	         * @param node The node to visit.
	         */
	        function modifierVisitor(node) {
	            switch (node.kind) {
	                case 84 /* ExportKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return undefined;
	            }
	            return node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit notifications.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (node.kind === 273 /* SourceFile */) {
	                var id = ts.getOriginalNodeId(node);
	                currentSourceFile = node;
	                moduleInfo = moduleInfoMap[id];
	                exportFunction = exportFunctionsMap[id];
	                noSubstitution = noSubstitutionMap[id];
	                if (noSubstitution) {
	                    delete noSubstitutionMap[id];
	                }
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	                moduleInfo = undefined;
	                exportFunction = undefined;
	                noSubstitution = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (isSubstitutionPrevented(node)) {
	                return node;
	            }
	            if (hint === 1 /* Expression */) {
	                return substituteExpression(node);
	            }
	            else if (hint === 4 /* Unspecified */) {
	                return substituteUnspecified(node);
	            }
	            return node;
	        }
	        /**
	         * Substitute the node, if necessary.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnspecified(node) {
	            switch (node.kind) {
	                case 270 /* ShorthandPropertyAssignment */:
	                    return substituteShorthandPropertyAssignment(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for a ShorthandPropertyAssignment whose name that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteShorthandPropertyAssignment(node) {
	            var name = node.name;
	            if (!ts.isGeneratedIdentifier(name) && !ts.isLocalName(name)) {
	                var importDeclaration = resolver.getReferencedImportDeclaration(name);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAssignment(ts.getSynthesizedClone(name), ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default"))), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAssignment(ts.getSynthesizedClone(name), ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(importDeclaration.propertyName || importDeclaration.name))), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitute the expression, if necessary.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpression(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return substituteExpressionIdentifier(node);
	                case 199 /* BinaryExpression */:
	                    return substituteBinaryExpression(node);
	                case 197 /* PrefixUnaryExpression */:
	                case 198 /* PostfixUnaryExpression */:
	                    return substituteUnaryExpression(node);
	            }
	            return node;
	        }
	        /**
	         * Substitution for an Identifier expression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	                return node;
	            }
	            // When we see an identifier in an expression position that
	            // points to an imported symbol, we should substitute a qualified
	            // reference to the imported symbol if one is needed.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            if (!ts.isGeneratedIdentifier(node) && !ts.isLocalName(node)) {
	                var importDeclaration = resolver.getReferencedImportDeclaration(node);
	                if (importDeclaration) {
	                    if (ts.isImportClause(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent), ts.createIdentifier("default")), 
	                        /*location*/ node);
	                    }
	                    else if (ts.isImportSpecifier(importDeclaration)) {
	                        return ts.setTextRange(ts.createPropertyAccess(ts.getGeneratedNameForNode(importDeclaration.parent.parent.parent), ts.getSynthesizedClone(importDeclaration.propertyName || importDeclaration.name)), 
	                        /*location*/ node);
	                    }
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a BinaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteBinaryExpression(node) {
	            // When we see an assignment expression whose left-hand side is an exported symbol,
	            // we should ensure all exports of that symbol are updated with the correct value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if (ts.isAssignmentOperator(node.operatorToken.kind)
	                && ts.isIdentifier(node.left)
	                && !ts.isGeneratedIdentifier(node.left)
	                && !ts.isLocalName(node.left)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.left)) {
	                var exportedNames = getExports(node.left);
	                if (exportedNames) {
	                    // For each additional export of the declaration, apply an export assignment.
	                    var expression = node;
	                    for (var _i = 0, exportedNames_4 = exportedNames; _i < exportedNames_4.length; _i++) {
	                        var exportName = exportedNames_4[_i];
	                        expression = createExportExpression(exportName, preventSubstitution(expression));
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Substitution for a UnaryExpression that may contain an imported or exported symbol.
	         *
	         * @param node The node to substitute.
	         */
	        function substituteUnaryExpression(node) {
	            // When we see a prefix or postfix increment expression whose operand is an exported
	            // symbol, we should ensure all exports of that symbol are updated with the correct
	            // value.
	            //
	            // - We do not substitute generated identifiers for any reason.
	            // - We do not substitute identifiers tagged with the LocalName flag.
	            // - We do not substitute identifiers that were originally the name of an enum or
	            //   namespace due to how they are transformed in TypeScript.
	            // - We only substitute identifiers that are exported at the top level.
	            if ((node.operator === 43 /* PlusPlusToken */ || node.operator === 44 /* MinusMinusToken */)
	                && ts.isIdentifier(node.operand)
	                && !ts.isGeneratedIdentifier(node.operand)
	                && !ts.isLocalName(node.operand)
	                && !ts.isDeclarationNameOfEnumOrNamespace(node.operand)) {
	                var exportedNames = getExports(node.operand);
	                if (exportedNames) {
	                    var expression = node.kind === 198 /* PostfixUnaryExpression */
	                        ? ts.setTextRange(ts.createPrefix(node.operator, node.operand), node)
	                        : node;
	                    for (var _i = 0, exportedNames_5 = exportedNames; _i < exportedNames_5.length; _i++) {
	                        var exportName = exportedNames_5[_i];
	                        expression = createExportExpression(exportName, preventSubstitution(expression));
	                    }
	                    if (node.kind === 198 /* PostfixUnaryExpression */) {
	                        expression = node.operator === 43 /* PlusPlusToken */
	                            ? ts.createSubtract(preventSubstitution(expression), ts.createLiteral(1))
	                            : ts.createAdd(preventSubstitution(expression), ts.createLiteral(1));
	                    }
	                    return expression;
	                }
	            }
	            return node;
	        }
	        /**
	         * Gets the exports of a name.
	         *
	         * @param name The name.
	         */
	        function getExports(name) {
	            var exportedNames;
	            if (!ts.isGeneratedIdentifier(name)) {
	                var valueDeclaration = resolver.getReferencedImportDeclaration(name)
	                    || resolver.getReferencedValueDeclaration(name);
	                if (valueDeclaration) {
	                    var exportContainer = resolver.getReferencedExportContainer(name, /*prefixLocals*/ false);
	                    if (exportContainer && exportContainer.kind === 273 /* SourceFile */) {
	                        exportedNames = ts.append(exportedNames, ts.getDeclarationName(valueDeclaration));
	                    }
	                    exportedNames = ts.addRange(exportedNames, moduleInfo && moduleInfo.exportedBindings[ts.getOriginalNodeId(valueDeclaration)]);
	                }
	            }
	            return exportedNames;
	        }
	        /**
	         * Prevent substitution of a node for this transformer.
	         *
	         * @param node The node which should not be substituted.
	         */
	        function preventSubstitution(node) {
	            if (noSubstitution === undefined)
	                noSubstitution = [];
	            noSubstitution[ts.getNodeId(node)] = true;
	            return node;
	        }
	        /**
	         * Determines whether a node should not be substituted.
	         *
	         * @param node The node to test.
	         */
	        function isSubstitutionPrevented(node) {
	            return noSubstitution && node.id && noSubstitution[node.id];
	        }
	    }
	    ts.transformSystemModule = transformSystemModule;
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function transformES2015Module(context) {
	        var compilerOptions = context.getCompilerOptions();
	        var previousOnEmitNode = context.onEmitNode;
	        var previousOnSubstituteNode = context.onSubstituteNode;
	        context.onEmitNode = onEmitNode;
	        context.onSubstituteNode = onSubstituteNode;
	        context.enableEmitNotification(273 /* SourceFile */);
	        context.enableSubstitution(71 /* Identifier */);
	        var currentSourceFile;
	        return ts.chainBundle(transformSourceFile);
	        function transformSourceFile(node) {
	            if (node.isDeclarationFile) {
	                return node;
	            }
	            if (ts.isExternalModule(node) || compilerOptions.isolatedModules) {
	                var externalHelpersModuleName = ts.getOrCreateExternalHelpersModuleNameIfNeeded(node, compilerOptions);
	                if (externalHelpersModuleName) {
	                    var statements = [];
	                    var statementOffset = ts.addPrologue(statements, node.statements);
	                    var tslibImport = ts.createImportDeclaration(
	                    /*decorators*/ undefined, 
	                    /*modifiers*/ undefined, ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(externalHelpersModuleName)), ts.createLiteral(ts.externalHelpersModuleNameText));
	                    ts.addEmitFlags(tslibImport, 67108864 /* NeverApplyImportHelper */);
	                    ts.append(statements, tslibImport);
	                    ts.addRange(statements, ts.visitNodes(node.statements, visitor, ts.isStatement, statementOffset));
	                    return ts.updateSourceFileNode(node, ts.setTextRange(ts.createNodeArray(statements), node.statements));
	                }
	                else {
	                    return ts.visitEachChild(node, visitor, context);
	                }
	            }
	            return node;
	        }
	        function visitor(node) {
	            switch (node.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                    // Elide `import=` as it is not legal with --module ES6
	                    return undefined;
	                case 248 /* ExportAssignment */:
	                    return visitExportAssignment(node);
	            }
	            return node;
	        }
	        function visitExportAssignment(node) {
	            // Elide `export=` as it is not legal with --module ES6
	            return node.isExportEquals ? undefined : node;
	        }
	        //
	        // Emit Notification
	        //
	        /**
	         * Hook for node emit.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emit A callback used to emit the node in the printer.
	         */
	        function onEmitNode(hint, node, emitCallback) {
	            if (ts.isSourceFile(node)) {
	                currentSourceFile = node;
	                previousOnEmitNode(hint, node, emitCallback);
	                currentSourceFile = undefined;
	            }
	            else {
	                previousOnEmitNode(hint, node, emitCallback);
	            }
	        }
	        //
	        // Substitutions
	        //
	        /**
	         * Hooks node substitutions.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to substitute.
	         */
	        function onSubstituteNode(hint, node) {
	            node = previousOnSubstituteNode(hint, node);
	            if (ts.isIdentifier(node) && hint === 1 /* Expression */) {
	                return substituteExpressionIdentifier(node);
	            }
	            return node;
	        }
	        function substituteExpressionIdentifier(node) {
	            if (ts.getEmitFlags(node) & 4096 /* HelperName */) {
	                var externalHelpersModuleName = ts.getExternalHelpersModuleName(currentSourceFile);
	                if (externalHelpersModuleName) {
	                    return ts.createPropertyAccess(externalHelpersModuleName, node);
	                }
	            }
	            return node;
	        }
	    }
	    ts.transformES2015Module = transformES2015Module;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function canProduceDiagnostics(node) {
	        return ts.isVariableDeclaration(node) ||
	            ts.isPropertyDeclaration(node) ||
	            ts.isPropertySignature(node) ||
	            ts.isBindingElement(node) ||
	            ts.isSetAccessor(node) ||
	            ts.isGetAccessor(node) ||
	            ts.isConstructSignatureDeclaration(node) ||
	            ts.isCallSignatureDeclaration(node) ||
	            ts.isMethodDeclaration(node) ||
	            ts.isMethodSignature(node) ||
	            ts.isFunctionDeclaration(node) ||
	            ts.isParameter(node) ||
	            ts.isTypeParameterDeclaration(node) ||
	            ts.isExpressionWithTypeArguments(node) ||
	            ts.isImportEqualsDeclaration(node) ||
	            ts.isTypeAliasDeclaration(node) ||
	            ts.isConstructorDeclaration(node) ||
	            ts.isIndexSignatureDeclaration(node);
	    }
	    ts.canProduceDiagnostics = canProduceDiagnostics;
	    function createGetSymbolAccessibilityDiagnosticForNodeName(node) {
	        if (ts.isSetAccessor(node) || ts.isGetAccessor(node)) {
	            return getAccessorNameVisibilityError;
	        }
	        else if (ts.isMethodSignature(node) || ts.isMethodDeclaration(node)) {
	            return getMethodNameVisibilityError;
	        }
	        else {
	            return createGetSymbolAccessibilityDiagnosticForNode(node);
	        }
	        function getAccessorNameVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage = getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
	            return diagnosticMessage !== undefined ? {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: node.name
	            } : undefined;
	        }
	        function getAccessorNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	            if (ts.hasModifier(node, 32 /* Static */)) {
	                return symbolAccessibilityResult.errorModuleName ?
	                    symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                        ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                        ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
	            }
	            else if (node.parent.kind === 234 /* ClassDeclaration */) {
	                return symbolAccessibilityResult.errorModuleName ?
	                    symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                        ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                        ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
	            }
	            else {
	                return symbolAccessibilityResult.errorModuleName ?
	                    ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
	            }
	        }
	        function getMethodNameVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage = getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult);
	            return diagnosticMessage !== undefined ? {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: node.name
	            } : undefined;
	        }
	        function getMethodNameVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	            if (ts.hasModifier(node, 32 /* Static */)) {
	                return symbolAccessibilityResult.errorModuleName ?
	                    symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                        ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                        ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Public_static_method_0_of_exported_class_has_or_is_using_private_name_1;
	            }
	            else if (node.parent.kind === 234 /* ClassDeclaration */) {
	                return symbolAccessibilityResult.errorModuleName ?
	                    symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                        ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                        ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Public_method_0_of_exported_class_has_or_is_using_private_name_1;
	            }
	            else {
	                return symbolAccessibilityResult.errorModuleName ?
	                    ts.Diagnostics.Method_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Method_0_of_exported_interface_has_or_is_using_private_name_1;
	            }
	        }
	    }
	    ts.createGetSymbolAccessibilityDiagnosticForNodeName = createGetSymbolAccessibilityDiagnosticForNodeName;
	    function createGetSymbolAccessibilityDiagnosticForNode(node) {
	        if (ts.isVariableDeclaration(node) || ts.isPropertyDeclaration(node) || ts.isPropertySignature(node) || ts.isBindingElement(node) || ts.isConstructorDeclaration(node)) {
	            return getVariableDeclarationTypeVisibilityError;
	        }
	        else if (ts.isSetAccessor(node) || ts.isGetAccessor(node)) {
	            return getAccessorDeclarationTypeVisibilityError;
	        }
	        else if (ts.isConstructSignatureDeclaration(node) || ts.isCallSignatureDeclaration(node) || ts.isMethodDeclaration(node) || ts.isMethodSignature(node) || ts.isFunctionDeclaration(node) || ts.isIndexSignatureDeclaration(node)) {
	            return getReturnTypeVisibilityError;
	        }
	        else if (ts.isParameter(node)) {
	            if (ts.isParameterPropertyDeclaration(node) && ts.hasModifier(node.parent, 8 /* Private */)) {
	                return getVariableDeclarationTypeVisibilityError;
	            }
	            return getParameterDeclarationTypeVisibilityError;
	        }
	        else if (ts.isTypeParameterDeclaration(node)) {
	            return getTypeParameterConstraintVisibilityError;
	        }
	        else if (ts.isExpressionWithTypeArguments(node)) {
	            return getHeritageClauseVisibilityError;
	        }
	        else if (ts.isImportEqualsDeclaration(node)) {
	            return getImportEntityNameVisibilityError;
	        }
	        else if (ts.isTypeAliasDeclaration(node)) {
	            return getTypeAliasDeclarationVisibilityError;
	        }
	        else {
	            ts.Debug.assertNever(node, "Attempted to set a declaration diagnostic context for unhandled node kind: " + ts.SyntaxKind[node.kind]);
	        }
	        function getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	            if (node.kind === 231 /* VariableDeclaration */ || node.kind === 181 /* BindingElement */) {
	                return symbolAccessibilityResult.errorModuleName ?
	                    symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                        ts.Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                        ts.Diagnostics.Exported_variable_0_has_or_is_using_name_1_from_private_module_2 :
	                    ts.Diagnostics.Exported_variable_0_has_or_is_using_private_name_1;
	            }
	            // This check is to ensure we don't report error on constructor parameter property as that error would be reported during parameter emit
	            // The only exception here is if the constructor was marked as private. we are not emitting the constructor parameters at all.
	            else if (node.kind === 151 /* PropertyDeclaration */ || node.kind === 150 /* PropertySignature */ ||
	                (node.kind === 148 /* Parameter */ && ts.hasModifier(node.parent, 8 /* Private */))) {
	                // TODO(jfreeman): Deal with computed properties in error reporting.
	                if (ts.hasModifier(node, 32 /* Static */)) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_static_property_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else if (node.parent.kind === 234 /* ClassDeclaration */ || node.kind === 148 /* Parameter */) {
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Public_property_0_of_exported_class_has_or_is_using_private_name_1;
	                }
	                else {
	                    // Interfaces cannot have types that cannot be named
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Property_0_of_exported_interface_has_or_is_using_private_name_1;
	                }
	            }
	        }
	        function getVariableDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage = getVariableDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
	            return diagnosticMessage !== undefined ? {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: node.name
	            } : undefined;
	        }
	        function getAccessorDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage;
	            if (node.kind === 156 /* SetAccessor */) {
	                // Getters can infer the return type from the returned expression, but setters cannot, so the
	                // "_from_external_module_1_but_cannot_be_named" case cannot occur.
	                if (ts.hasModifier(node, 32 /* Static */)) {
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_type_of_public_static_setter_0_from_exported_class_has_or_is_using_private_name_1;
	                }
	                else {
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_type_of_public_setter_0_from_exported_class_has_or_is_using_private_name_1;
	                }
	            }
	            else {
	                if (ts.hasModifier(node, 32 /* Static */)) {
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Return_type_of_public_static_getter_0_from_exported_class_has_or_is_using_private_name_1;
	                }
	                else {
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Return_type_of_public_getter_0_from_exported_class_has_or_is_using_private_name_1;
	                }
	            }
	            return {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node.name,
	                typeName: node.name
	            };
	        }
	        function getReturnTypeVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage;
	            switch (node.kind) {
	                case 158 /* ConstructSignature */:
	                    // Interfaces cannot have return types that cannot be named
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                        ts.Diagnostics.Return_type_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_0;
	                    break;
	                case 157 /* CallSignature */:
	                    // Interfaces cannot have return types that cannot be named
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                        ts.Diagnostics.Return_type_of_call_signature_from_exported_interface_has_or_is_using_private_name_0;
	                    break;
	                case 159 /* IndexSignature */:
	                    // Interfaces cannot have return types that cannot be named
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                        ts.Diagnostics.Return_type_of_index_signature_from_exported_interface_has_or_is_using_private_name_0;
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    if (ts.hasModifier(node, 32 /* Static */)) {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                                ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_public_static_method_from_exported_class_has_or_is_using_private_name_0;
	                    }
	                    else if (node.parent.kind === 234 /* ClassDeclaration */) {
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                                ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_public_method_from_exported_class_has_or_is_using_private_name_0;
	                    }
	                    else {
	                        // Interfaces cannot have return types that cannot be named
	                        diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_name_0_from_private_module_1 :
	                            ts.Diagnostics.Return_type_of_method_from_exported_interface_has_or_is_using_private_name_0;
	                    }
	                    break;
	                case 233 /* FunctionDeclaration */:
	                    diagnosticMessage = symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_external_module_1_but_cannot_be_named :
	                            ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_name_0_from_private_module_1 :
	                        ts.Diagnostics.Return_type_of_exported_function_has_or_is_using_private_name_0;
	                    break;
	                default:
	                    ts.Debug.fail("This is unknown kind for signature: " + node.kind);
	            }
	            return {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node.name || node
	            };
	        }
	        function getParameterDeclarationTypeVisibilityError(symbolAccessibilityResult) {
	            var diagnosticMessage = getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult);
	            return diagnosticMessage !== undefined ? {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: node.name
	            } : undefined;
	        }
	        function getParameterDeclarationTypeVisibilityDiagnosticMessage(symbolAccessibilityResult) {
	            switch (node.parent.kind) {
	                case 154 /* Constructor */:
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_0_of_constructor_from_exported_class_has_or_is_using_private_name_1;
	                case 158 /* ConstructSignature */:
	                case 163 /* ConstructorType */:
	                    // Interfaces cannot have parameter types that cannot be named
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
	                case 157 /* CallSignature */:
	                    // Interfaces cannot have parameter types that cannot be named
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
	                case 159 /* IndexSignature */:
	                    // Interfaces cannot have parameter types that cannot be named
	                    return symbolAccessibilityResult.errorModuleName ?
	                        ts.Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_0_of_index_signature_from_exported_interface_has_or_is_using_private_name_1;
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    if (ts.hasModifier(node.parent, 32 /* Static */)) {
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else if (node.parent.parent.kind === 234 /* ClassDeclaration */) {
	                        return symbolAccessibilityResult.errorModuleName ?
	                            symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                                ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                                ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        // Interfaces cannot have parameter types that cannot be named
	                        return symbolAccessibilityResult.errorModuleName ?
	                            ts.Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_name_1_from_private_module_2 :
	                            ts.Diagnostics.Parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
	                    }
	                case 233 /* FunctionDeclaration */:
	                case 162 /* FunctionType */:
	                    return symbolAccessibilityResult.errorModuleName ?
	                        symbolAccessibilityResult.accessibility === 2 /* CannotBeNamed */ ?
	                            ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_external_module_2_but_cannot_be_named :
	                            ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_name_1_from_private_module_2 :
	                        ts.Diagnostics.Parameter_0_of_exported_function_has_or_is_using_private_name_1;
	                default:
	                    ts.Debug.fail("Unknown parent for parameter: " + ts.SyntaxKind[node.parent.kind]);
	            }
	        }
	        function getTypeParameterConstraintVisibilityError() {
	            // Type parameter constraints are named by user so we should always be able to name it
	            var diagnosticMessage;
	            switch (node.parent.kind) {
	                case 234 /* ClassDeclaration */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_class_has_or_is_using_private_name_1;
	                    break;
	                case 235 /* InterfaceDeclaration */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_interface_has_or_is_using_private_name_1;
	                    break;
	                case 158 /* ConstructSignature */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_constructor_signature_from_exported_interface_has_or_is_using_private_name_1;
	                    break;
	                case 157 /* CallSignature */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_call_signature_from_exported_interface_has_or_is_using_private_name_1;
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                    if (ts.hasModifier(node.parent, 32 /* Static */)) {
	                        diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_public_static_method_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else if (node.parent.parent.kind === 234 /* ClassDeclaration */) {
	                        diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_public_method_from_exported_class_has_or_is_using_private_name_1;
	                    }
	                    else {
	                        diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_method_from_exported_interface_has_or_is_using_private_name_1;
	                    }
	                    break;
	                case 233 /* FunctionDeclaration */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_function_has_or_is_using_private_name_1;
	                    break;
	                case 236 /* TypeAliasDeclaration */:
	                    diagnosticMessage = ts.Diagnostics.Type_parameter_0_of_exported_type_alias_has_or_is_using_private_name_1;
	                    break;
	                default:
	                    ts.Debug.fail("This is unknown parent for type parameter: " + node.parent.kind);
	            }
	            return {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: node.name
	            };
	        }
	        function getHeritageClauseVisibilityError() {
	            var diagnosticMessage;
	            // Heritage clause is written by user so it can always be named
	            if (node.parent.parent.kind === 234 /* ClassDeclaration */) {
	                // Class or Interface implemented/extended is inaccessible
	                diagnosticMessage = node.parent.token === 108 /* ImplementsKeyword */ ?
	                    ts.Diagnostics.Implements_clause_of_exported_class_0_has_or_is_using_private_name_1 :
	                    ts.Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1;
	            }
	            else {
	                // interface is inaccessible
	                diagnosticMessage = ts.Diagnostics.extends_clause_of_exported_interface_0_has_or_is_using_private_name_1;
	            }
	            return {
	                diagnosticMessage: diagnosticMessage,
	                errorNode: node,
	                typeName: ts.getNameOfDeclaration(node.parent.parent)
	            };
	        }
	        function getImportEntityNameVisibilityError() {
	            return {
	                diagnosticMessage: ts.Diagnostics.Import_declaration_0_is_using_private_name_1,
	                errorNode: node,
	                typeName: node.name
	            };
	        }
	        function getTypeAliasDeclarationVisibilityError() {
	            return {
	                diagnosticMessage: ts.Diagnostics.Exported_type_alias_0_has_or_is_using_private_name_1,
	                errorNode: node.type,
	                typeName: node.name
	            };
	        }
	    }
	    ts.createGetSymbolAccessibilityDiagnosticForNode = createGetSymbolAccessibilityDiagnosticForNode;
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function getDeclarationDiagnostics(host, resolver, file) {
	        if (file && ts.isSourceFileJavaScript(file)) {
	            return []; // No declaration diagnostics for js for now
	        }
	        var compilerOptions = host.getCompilerOptions();
	        var result = ts.transformNodes(resolver, host, compilerOptions, file ? [file] : ts.filter(host.getSourceFiles(), ts.isSourceFileNotJavaScript), [transformDeclarations], /*allowDtsFiles*/ false);
	        return result.diagnostics;
	    }
	    ts.getDeclarationDiagnostics = getDeclarationDiagnostics;
	    var declarationEmitNodeBuilderFlags = 1024 /* MultilineObjectLiterals */ |
	        2048 /* WriteClassExpressionAsTypeLiteral */ |
	        4096 /* UseTypeOfFunction */ |
	        8 /* UseStructuralFallback */ |
	        524288 /* AllowEmptyTuple */ |
	        4 /* GenerateNamesForShadowedTypeParams */;
	    /**
	     * Transforms a ts file into a .d.ts file
	     * This process requires type information, which is retrieved through the emit resolver. Because of this,
	     * in many places this transformer assumes it will be operating on parse tree nodes directly.
	     * This means that _no transforms should be allowed to occur before this one_.
	     */
	    function transformDeclarations(context) {
	        var throwDiagnostic = function () { return ts.Debug.fail("Diagnostic emitted without context"); };
	        var getSymbolAccessibilityDiagnostic = throwDiagnostic;
	        var needsDeclare = true;
	        var isBundledEmit = false;
	        var resultHasExternalModuleIndicator = false;
	        var needsScopeFixMarker = false;
	        var resultHasScopeMarker = false;
	        var enclosingDeclaration;
	        var necessaryTypeRefernces;
	        var lateMarkedStatements;
	        var lateStatementReplacementMap;
	        var suppressNewDiagnosticContexts;
	        var host = context.getEmitHost();
	        var symbolTracker = {
	            trackSymbol: trackSymbol,
	            reportInaccessibleThisError: reportInaccessibleThisError,
	            reportInaccessibleUniqueSymbolError: reportInaccessibleUniqueSymbolError,
	            reportPrivateInBaseOfClassExpression: reportPrivateInBaseOfClassExpression,
	            moduleResolverHost: host,
	            trackReferencedAmbientModule: trackReferencedAmbientModule,
	        };
	        var errorNameNode;
	        var currentSourceFile;
	        var refs;
	        var resolver = context.getEmitResolver();
	        var options = context.getCompilerOptions();
	        var newLine = ts.getNewLineCharacter(options);
	        var noResolve = options.noResolve, stripInternal = options.stripInternal;
	        return transformRoot;
	        function recordTypeReferenceDirectivesIfNecessary(typeReferenceDirectives) {
	            if (!typeReferenceDirectives) {
	                return;
	            }
	            necessaryTypeRefernces = necessaryTypeRefernces || ts.createMap();
	            for (var _i = 0, typeReferenceDirectives_2 = typeReferenceDirectives; _i < typeReferenceDirectives_2.length; _i++) {
	                var ref = typeReferenceDirectives_2[_i];
	                necessaryTypeRefernces.set(ref, true);
	            }
	        }
	        function trackReferencedAmbientModule(node) {
	            var container = ts.getSourceFileOfNode(node);
	            refs.set("" + ts.getOriginalNodeId(container), container);
	        }
	        function handleSymbolAccessibilityError(symbolAccessibilityResult) {
	            if (symbolAccessibilityResult.accessibility === 0 /* Accessible */) {
	                // Add aliases back onto the possible imports list if they're not there so we can try them again with updated visibility info
	                if (symbolAccessibilityResult && symbolAccessibilityResult.aliasesToMakeVisible) {
	                    if (!lateMarkedStatements) {
	                        lateMarkedStatements = symbolAccessibilityResult.aliasesToMakeVisible;
	                    }
	                    else {
	                        for (var _i = 0, _a = symbolAccessibilityResult.aliasesToMakeVisible; _i < _a.length; _i++) {
	                            var ref = _a[_i];
	                            ts.pushIfUnique(lateMarkedStatements, ref);
	                        }
	                    }
	                }
	                // TODO: Do all these accessibility checks inside/after the first pass in the checker when declarations are enabled, if possible
	            }
	            else {
	                // Report error
	                var errorInfo = getSymbolAccessibilityDiagnostic(symbolAccessibilityResult);
	                if (errorInfo) {
	                    if (errorInfo.typeName) {
	                        context.addDiagnostic(ts.createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, ts.getTextOfNode(errorInfo.typeName), symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
	                    }
	                    else {
	                        context.addDiagnostic(ts.createDiagnosticForNode(symbolAccessibilityResult.errorNode || errorInfo.errorNode, errorInfo.diagnosticMessage, symbolAccessibilityResult.errorSymbolName, symbolAccessibilityResult.errorModuleName));
	                    }
	                }
	            }
	        }
	        function trackSymbol(symbol, enclosingDeclaration, meaning) {
	            if (symbol.flags & 262144 /* TypeParameter */)
	                return;
	            handleSymbolAccessibilityError(resolver.isSymbolAccessible(symbol, enclosingDeclaration, meaning, /*shouldComputeAliasesToMakeVisible*/ true));
	            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForSymbol(symbol, meaning));
	        }
	        function reportPrivateInBaseOfClassExpression(propertyName) {
	            if (errorNameNode) {
	                context.addDiagnostic(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.Property_0_of_exported_class_expression_may_not_be_private_or_protected, propertyName));
	            }
	        }
	        function reportInaccessibleUniqueSymbolError() {
	            if (errorNameNode) {
	                context.addDiagnostic(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, ts.declarationNameToString(errorNameNode), "unique symbol"));
	            }
	        }
	        function reportInaccessibleThisError() {
	            if (errorNameNode) {
	                context.addDiagnostic(ts.createDiagnosticForNode(errorNameNode, ts.Diagnostics.The_inferred_type_of_0_references_an_inaccessible_1_type_A_type_annotation_is_necessary, ts.declarationNameToString(errorNameNode), "this"));
	            }
	        }
	        function transformRoot(node) {
	            if (node.kind === 273 /* SourceFile */ && (node.isDeclarationFile || ts.isSourceFileJavaScript(node))) {
	                return node;
	            }
	            if (node.kind === 274 /* Bundle */) {
	                isBundledEmit = true;
	                var refs_1 = ts.createMap();
	                var hasNoDefaultLib_1 = false;
	                var bundle = ts.createBundle(ts.map(node.sourceFiles, function (sourceFile) {
	                    if (sourceFile.isDeclarationFile || ts.isSourceFileJavaScript(sourceFile))
	                        return; // Omit declaration files from bundle results, too
	                    hasNoDefaultLib_1 = hasNoDefaultLib_1 || sourceFile.hasNoDefaultLib;
	                    currentSourceFile = sourceFile;
	                    enclosingDeclaration = sourceFile;
	                    lateMarkedStatements = undefined;
	                    suppressNewDiagnosticContexts = false;
	                    lateStatementReplacementMap = ts.createMap();
	                    getSymbolAccessibilityDiagnostic = throwDiagnostic;
	                    needsScopeFixMarker = false;
	                    resultHasScopeMarker = false;
	                    collectReferences(sourceFile, refs_1);
	                    if (ts.isExternalModule(sourceFile)) {
	                        resultHasExternalModuleIndicator = false; // unused in external module bundle emit (all external modules are within module blocks, therefore are known to be modules)
	                        needsDeclare = false;
	                        var statements_5 = ts.visitNodes(sourceFile.statements, visitDeclarationStatements);
	                        var newFile = ts.updateSourceFileNode(sourceFile, [ts.createModuleDeclaration([], [ts.createModifier(124 /* DeclareKeyword */)], ts.createLiteral(ts.getResolvedExternalModuleName(context.getEmitHost(), sourceFile)), ts.createModuleBlock(ts.setTextRange(ts.createNodeArray(transformAndReplaceLatePaintedStatements(statements_5)), sourceFile.statements)))], /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false);
	                        return newFile;
	                    }
	                    needsDeclare = true;
	                    var updated = ts.visitNodes(sourceFile.statements, visitDeclarationStatements);
	                    return ts.updateSourceFileNode(sourceFile, transformAndReplaceLatePaintedStatements(updated), /*isDeclarationFile*/ true, /*referencedFiles*/ [], /*typeReferences*/ [], /*hasNoDefaultLib*/ false);
	                }), ts.mapDefined(node.prepends, function (prepend) {
	                    if (prepend.kind === 276 /* InputFiles */) {
	                        return ts.createUnparsedSourceFile(prepend.declarationText);
	                    }
	                }));
	                bundle.syntheticFileReferences = [];
	                bundle.syntheticTypeReferences = getFileReferencesForUsedTypeReferences();
	                bundle.hasNoDefaultLib = hasNoDefaultLib_1;
	                var outputFilePath_1 = ts.getDirectoryPath(ts.normalizeSlashes(ts.getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
	                var referenceVisitor_1 = mapReferencesIntoArray(bundle.syntheticFileReferences, outputFilePath_1);
	                refs_1.forEach(referenceVisitor_1);
	                return bundle;
	            }
	            // Single source file
	            needsDeclare = true;
	            needsScopeFixMarker = false;
	            resultHasScopeMarker = false;
	            enclosingDeclaration = node;
	            currentSourceFile = node;
	            getSymbolAccessibilityDiagnostic = throwDiagnostic;
	            isBundledEmit = false;
	            resultHasExternalModuleIndicator = false;
	            suppressNewDiagnosticContexts = false;
	            lateMarkedStatements = undefined;
	            lateStatementReplacementMap = ts.createMap();
	            necessaryTypeRefernces = undefined;
	            refs = collectReferences(currentSourceFile, ts.createMap());
	            var references = [];
	            var outputFilePath = ts.getDirectoryPath(ts.normalizeSlashes(ts.getOutputPathsFor(node, host, /*forceDtsPaths*/ true).declarationFilePath));
	            var referenceVisitor = mapReferencesIntoArray(references, outputFilePath);
	            var statements = ts.visitNodes(node.statements, visitDeclarationStatements);
	            var combinedStatements = ts.setTextRange(ts.createNodeArray(transformAndReplaceLatePaintedStatements(statements)), node.statements);
	            refs.forEach(referenceVisitor);
	            var emittedImports = ts.filter(combinedStatements, ts.isAnyImportSyntax);
	            if (ts.isExternalModule(node) && (!resultHasExternalModuleIndicator || (needsScopeFixMarker && !resultHasScopeMarker))) {
	                combinedStatements = ts.setTextRange(ts.createNodeArray(combinedStatements.concat([ts.createExportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, ts.createNamedExports([]), /*moduleSpecifier*/ undefined)])), combinedStatements);
	            }
	            var updated = ts.updateSourceFileNode(node, combinedStatements, /*isDeclarationFile*/ true, references, getFileReferencesForUsedTypeReferences(), node.hasNoDefaultLib);
	            return updated;
	            function getFileReferencesForUsedTypeReferences() {
	                return necessaryTypeRefernces ? ts.mapDefined(ts.arrayFrom(necessaryTypeRefernces.keys()), getFileReferenceForTypeName) : [];
	            }
	            function getFileReferenceForTypeName(typeName) {
	                // Elide type references for which we have imports
	                if (emittedImports) {
	                    for (var _i = 0, emittedImports_1 = emittedImports; _i < emittedImports_1.length; _i++) {
	                        var importStatement = emittedImports_1[_i];
	                        if (ts.isImportEqualsDeclaration(importStatement) && ts.isExternalModuleReference(importStatement.moduleReference)) {
	                            var expr = importStatement.moduleReference.expression;
	                            if (ts.isStringLiteralLike(expr) && expr.text === typeName) {
	                                return undefined;
	                            }
	                        }
	                        else if (ts.isImportDeclaration(importStatement) && ts.isStringLiteral(importStatement.moduleSpecifier) && importStatement.moduleSpecifier.text === typeName) {
	                            return undefined;
	                        }
	                    }
	                }
	                return { fileName: typeName, pos: -1, end: -1 };
	            }
	            function mapReferencesIntoArray(references, outputFilePath) {
	                return function (file) {
	                    var declFileName;
	                    if (file.isDeclarationFile) { // Neither decl files or js should have their refs changed
	                        declFileName = file.fileName;
	                    }
	                    else {
	                        if (isBundledEmit && ts.contains(node.sourceFiles, file))
	                            return; // Omit references to files which are being merged
	                        var paths = ts.getOutputPathsFor(file, host, /*forceDtsPaths*/ true);
	                        declFileName = paths.declarationFilePath || paths.jsFilePath;
	                    }
	                    if (declFileName) {
	                        var fileName = ts.getRelativePathToDirectoryOrUrl(outputFilePath, declFileName, host.getCurrentDirectory(), host.getCanonicalFileName, 
	                        /*isAbsolutePathAnUrl*/ false);
	                        if (ts.startsWith(fileName, "./") && ts.hasExtension(fileName)) {
	                            fileName = fileName.substring(2);
	                        }
	                        references.push({ pos: -1, end: -1, fileName: fileName });
	                    }
	                };
	            }
	        }
	        function collectReferences(sourceFile, ret) {
	            if (noResolve || ts.isSourceFileJavaScript(sourceFile))
	                return ret;
	            ts.forEach(sourceFile.referencedFiles, function (f) {
	                var elem = ts.tryResolveScriptReference(host, sourceFile, f);
	                if (elem) {
	                    ret.set("" + ts.getOriginalNodeId(elem), elem);
	                }
	            });
	            return ret;
	        }
	        function filterBindingPatternInitializers(name) {
	            if (name.kind === 71 /* Identifier */) {
	                return name;
	            }
	            else {
	                if (name.kind === 180 /* ArrayBindingPattern */) {
	                    return ts.updateArrayBindingPattern(name, ts.visitNodes(name.elements, visitBindingElement));
	                }
	                else {
	                    return ts.updateObjectBindingPattern(name, ts.visitNodes(name.elements, visitBindingElement));
	                }
	            }
	            function visitBindingElement(elem) {
	                if (elem.kind === 205 /* OmittedExpression */) {
	                    return elem;
	                }
	                return ts.updateBindingElement(elem, elem.dotDotDotToken, elem.propertyName, filterBindingPatternInitializers(elem.name), shouldPrintWithInitializer(elem) ? elem.initializer : undefined);
	            }
	        }
	        function ensureParameter(p, modifierMask) {
	            var oldDiag;
	            if (!suppressNewDiagnosticContexts) {
	                oldDiag = getSymbolAccessibilityDiagnostic;
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(p);
	            }
	            var newParam = ts.updateParameter(p, 
	            /*decorators*/ undefined, maskModifiers(p, modifierMask), p.dotDotDotToken, filterBindingPatternInitializers(p.name), resolver.isOptionalParameter(p) ? (p.questionToken || ts.createToken(55 /* QuestionToken */)) : undefined, ensureType(p, p.type, /*ignorePrivate*/ true), // Ignore private param props, since this type is going straight back into a param
	            ensureNoInitializer(p));
	            if (!suppressNewDiagnosticContexts) {
	                getSymbolAccessibilityDiagnostic = oldDiag;
	            }
	            return newParam;
	        }
	        function shouldPrintWithInitializer(node) {
	            return canHaveLiteralInitializer(node) && resolver.isLiteralConstDeclaration(ts.getParseTreeNode(node)); // TODO: Make safe
	        }
	        function ensureNoInitializer(node) {
	            if (shouldPrintWithInitializer(node)) {
	                return resolver.createLiteralConstValue(ts.getParseTreeNode(node)); // TODO: Make safe
	            }
	            return undefined;
	        }
	        function ensureType(node, type, ignorePrivate) {
	            if (!ignorePrivate && ts.hasModifier(node, 8 /* Private */)) {
	                // Private nodes emit no types (except private parameter properties, whose parameter types are actually visible)
	                return;
	            }
	            if (shouldPrintWithInitializer(node)) {
	                // Literal const declarations will have an initializer ensured rather than a type
	                return;
	            }
	            var shouldUseResolverType = node.kind === 148 /* Parameter */ &&
	                (resolver.isRequiredInitializedParameter(node) ||
	                    resolver.isOptionalUninitializedParameterProperty(node));
	            if (type && !shouldUseResolverType) {
	                return ts.visitNode(type, visitDeclarationSubtree);
	            }
	            if (!ts.getParseTreeNode(node)) {
	                return type ? ts.visitNode(type, visitDeclarationSubtree) : ts.createKeywordTypeNode(119 /* AnyKeyword */);
	            }
	            if (node.kind === 156 /* SetAccessor */) {
	                // Set accessors with no associated type node (from it's param or get accessor return) are `any` since they are never contextually typed right now
	                // (The inferred type here will be void, but the old declaration emitter printed `any`, so this replicates that)
	                return ts.createKeywordTypeNode(119 /* AnyKeyword */);
	            }
	            errorNameNode = node.name;
	            var oldDiag;
	            if (!suppressNewDiagnosticContexts) {
	                oldDiag = getSymbolAccessibilityDiagnostic;
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(node);
	            }
	            if (node.kind === 231 /* VariableDeclaration */ || node.kind === 181 /* BindingElement */) {
	                return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
	            }
	            if (node.kind === 148 /* Parameter */
	                || node.kind === 151 /* PropertyDeclaration */
	                || node.kind === 150 /* PropertySignature */) {
	                if (!node.initializer)
	                    return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker, shouldUseResolverType));
	                return cleanup(resolver.createTypeOfDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker, shouldUseResolverType) || resolver.createTypeOfExpression(node.initializer, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
	            }
	            return cleanup(resolver.createReturnTypeOfSignatureDeclaration(node, enclosingDeclaration, declarationEmitNodeBuilderFlags, symbolTracker));
	            function cleanup(returnValue) {
	                errorNameNode = undefined;
	                if (!suppressNewDiagnosticContexts) {
	                    getSymbolAccessibilityDiagnostic = oldDiag;
	                }
	                return returnValue || ts.createKeywordTypeNode(119 /* AnyKeyword */);
	            }
	        }
	        function isDeclarationAndNotVisible(node) {
	            node = ts.getParseTreeNode(node);
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 237 /* EnumDeclaration */:
	                    return !resolver.isDeclarationVisible(node);
	                // The following should be doing their own visibility checks based on filtering their members
	                case 231 /* VariableDeclaration */:
	                    return !getBindingNameVisible(node);
	                case 242 /* ImportEqualsDeclaration */:
	                case 243 /* ImportDeclaration */:
	                case 249 /* ExportDeclaration */:
	                case 248 /* ExportAssignment */:
	                    return false;
	            }
	            return false;
	        }
	        function getBindingNameVisible(elem) {
	            if (ts.isOmittedExpression(elem)) {
	                return false;
	            }
	            if (ts.isBindingPattern(elem.name)) {
	                // If any child binding pattern element has been marked visible (usually by collect linked aliases), then this is visible
	                return ts.forEach(elem.name.elements, getBindingNameVisible);
	            }
	            else {
	                return resolver.isDeclarationVisible(elem);
	            }
	        }
	        function updateParamsList(node, params, modifierMask) {
	            if (ts.hasModifier(node, 8 /* Private */)) {
	                return undefined;
	            }
	            var newParams = ts.map(params, function (p) { return ensureParameter(p, modifierMask); });
	            if (!newParams) {
	                return undefined;
	            }
	            return ts.createNodeArray(newParams, params.hasTrailingComma);
	        }
	        function ensureTypeParams(node, params) {
	            return ts.hasModifier(node, 8 /* Private */) ? undefined : ts.visitNodes(params, visitDeclarationSubtree);
	        }
	        function isEnclosingDeclaration(node) {
	            return ts.isSourceFile(node)
	                || ts.isTypeAliasDeclaration(node)
	                || ts.isModuleDeclaration(node)
	                || ts.isClassDeclaration(node)
	                || ts.isInterfaceDeclaration(node)
	                || ts.isFunctionLike(node)
	                || ts.isIndexSignatureDeclaration(node)
	                || ts.isMappedTypeNode(node);
	        }
	        function checkEntityNameVisibility(entityName, enclosingDeclaration) {
	            var visibilityResult = resolver.isEntityNameVisible(entityName, enclosingDeclaration);
	            handleSymbolAccessibilityError(visibilityResult);
	            recordTypeReferenceDirectivesIfNecessary(resolver.getTypeReferenceDirectivesForEntityName(entityName));
	        }
	        function preserveJsDoc(updated, original) {
	            if (ts.hasJSDocNodes(updated) && ts.hasJSDocNodes(original)) {
	                updated.jsDoc = original.jsDoc;
	            }
	            return ts.setCommentRange(updated, ts.getCommentRange(original));
	        }
	        function rewriteModuleSpecifier(parent, input) {
	            if (!input)
	                return;
	            resultHasExternalModuleIndicator = resultHasExternalModuleIndicator || (parent.kind !== 238 /* ModuleDeclaration */ && parent.kind !== 178 /* ImportType */);
	            if (input.kind === 9 /* StringLiteral */ && isBundledEmit) {
	                var newName = ts.getExternalModuleNameFromDeclaration(context.getEmitHost(), resolver, parent);
	                if (newName) {
	                    return ts.createLiteral(newName);
	                }
	            }
	            return input;
	        }
	        function transformImportEqualsDeclaration(decl) {
	            if (!resolver.isDeclarationVisible(decl))
	                return;
	            if (decl.moduleReference.kind === 253 /* ExternalModuleReference */) {
	                // Rewrite external module names if necessary
	                var specifier = ts.getExternalModuleImportEqualsDeclarationExpression(decl);
	                return ts.updateImportEqualsDeclaration(decl, 
	                /*decorators*/ undefined, decl.modifiers, decl.name, ts.updateExternalModuleReference(decl.moduleReference, rewriteModuleSpecifier(decl, specifier)));
	            }
	            else {
	                var oldDiag = getSymbolAccessibilityDiagnostic;
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(decl);
	                checkEntityNameVisibility(decl.moduleReference, enclosingDeclaration);
	                getSymbolAccessibilityDiagnostic = oldDiag;
	                return decl;
	            }
	        }
	        function transformImportDeclaration(decl) {
	            if (!decl.importClause) {
	                // import "mod" - possibly needed for side effects? (global interface patches, module augmentations, etc)
	                return ts.updateImportDeclaration(decl, 
	                /*decorators*/ undefined, decl.modifiers, decl.importClause, rewriteModuleSpecifier(decl, decl.moduleSpecifier));
	            }
	            // The `importClause` visibility corresponds to the default's visibility.
	            var visibleDefaultBinding = decl.importClause && decl.importClause.name && resolver.isDeclarationVisible(decl.importClause) ? decl.importClause.name : undefined;
	            if (!decl.importClause.namedBindings) {
	                // No named bindings (either namespace or list), meaning the import is just default or should be elided
	                return visibleDefaultBinding && ts.updateImportDeclaration(decl, /*decorators*/ undefined, decl.modifiers, ts.updateImportClause(decl.importClause, visibleDefaultBinding, 
	                /*namedBindings*/ undefined), rewriteModuleSpecifier(decl, decl.moduleSpecifier));
	            }
	            if (decl.importClause.namedBindings.kind === 245 /* NamespaceImport */) {
	                // Namespace import (optionally with visible default)
	                var namedBindings = resolver.isDeclarationVisible(decl.importClause.namedBindings) ? decl.importClause.namedBindings : /*namedBindings*/ undefined;
	                return visibleDefaultBinding || namedBindings ? ts.updateImportDeclaration(decl, /*decorators*/ undefined, decl.modifiers, ts.updateImportClause(decl.importClause, visibleDefaultBinding, namedBindings), rewriteModuleSpecifier(decl, decl.moduleSpecifier)) : undefined;
	            }
	            // Named imports (optionally with visible default)
	            var bindingList = ts.mapDefined(decl.importClause.namedBindings.elements, function (b) { return resolver.isDeclarationVisible(b) ? b : undefined; });
	            if ((bindingList && bindingList.length) || visibleDefaultBinding) {
	                return ts.updateImportDeclaration(decl, 
	                /*decorators*/ undefined, decl.modifiers, ts.updateImportClause(decl.importClause, visibleDefaultBinding, bindingList && bindingList.length ? ts.updateNamedImports(decl.importClause.namedBindings, bindingList) : undefined), rewriteModuleSpecifier(decl, decl.moduleSpecifier));
	            }
	            // Nothing visible
	        }
	        function transformAndReplaceLatePaintedStatements(statements) {
	            // This is a `while` loop because `handleSymbolAccessibilityError` can see additional import aliases marked as visible during
	            // error handling which must now be included in the output and themselves checked for errors.
	            // For example:
	            // ```
	            // module A {
	            //   export module Q {}
	            //   import B = Q;
	            //   import C = B;
	            //   export import D = C;
	            // }
	            // ```
	            // In such a scenario, only Q and D are initially visible, but we don't consider imports as private names - instead we say they if they are referenced they must
	            // be recorded. So while checking D's visibility we mark C as visible, then we must check C which in turn marks B, completing the chain of
	            // dependent imports and allowing a valid declaration file output. Today, this dependent alias marking only happens for internal import aliases.
	            while (ts.length(lateMarkedStatements)) {
	                var i = lateMarkedStatements.shift();
	                if (!ts.isLateVisibilityPaintedStatement(i)) {
	                    return ts.Debug.fail("Late replaced statement was found which is not handled by the declaration transformer!: " + (ts.SyntaxKind ? ts.SyntaxKind[i.kind] : i.kind));
	                }
	                var result = transformTopLevelDeclaration(i, /*privateDeclaration*/ true);
	                lateStatementReplacementMap.set("" + ts.getOriginalNodeId(i), result);
	            }
	            // And lastly, we need to get the final form of all those indetermine import declarations from before and add them to the output list
	            // (and remove them from the set to examine for outter declarations)
	            return ts.visitNodes(statements, visitLateVisibilityMarkedStatements);
	            function visitLateVisibilityMarkedStatements(statement) {
	                if (ts.isLateVisibilityPaintedStatement(statement)) {
	                    var key = "" + ts.getOriginalNodeId(statement);
	                    if (lateStatementReplacementMap.has(key)) {
	                        var result = lateStatementReplacementMap.get(key);
	                        lateStatementReplacementMap.delete(key);
	                        if (result && ts.isSourceFile(statement.parent)) {
	                            if (ts.isArray(result) ? ts.some(result, needsScopeMarker) : needsScopeMarker(result)) {
	                                // Top-level declarations in .d.ts files are always considered exported even without a modifier unless there's an export assignment or specifier
	                                needsScopeFixMarker = true;
	                            }
	                            if (ts.isArray(result) ? ts.some(result, isExternalModuleIndicator) : isExternalModuleIndicator(result)) {
	                                resultHasExternalModuleIndicator = true;
	                            }
	                        }
	                        return result;
	                    }
	                }
	                return statement;
	            }
	        }
	        function isExternalModuleIndicator(result) {
	            // Exported top-level member indicates moduleness
	            return ts.isAnyImportOrReExport(result) || ts.isExportAssignment(result) || ts.hasModifier(result, 1 /* Export */);
	        }
	        function needsScopeMarker(result) {
	            return !ts.isAnyImportOrReExport(result) && !ts.isExportAssignment(result) && !ts.hasModifier(result, 1 /* Export */) && !ts.isAmbientModule(result);
	        }
	        function visitDeclarationSubtree(input) {
	            if (shouldStripInternal(input))
	                return;
	            if (ts.isDeclaration(input)) {
	                if (isDeclarationAndNotVisible(input))
	                    return;
	                if (ts.hasDynamicName(input) && !resolver.isLateBound(ts.getParseTreeNode(input))) {
	                    return;
	                }
	            }
	            // Elide implementation signatures from overload sets
	            if (ts.isFunctionLike(input) && resolver.isImplementationOfOverload(input))
	                return;
	            // Elide semicolon class statements
	            if (ts.isSemicolonClassElement(input))
	                return;
	            var previousEnclosingDeclaration;
	            if (isEnclosingDeclaration(input)) {
	                previousEnclosingDeclaration = enclosingDeclaration;
	                enclosingDeclaration = input;
	            }
	            var oldDiag = getSymbolAccessibilityDiagnostic;
	            // Emit methods which are private as properties with no type information
	            if (ts.isMethodDeclaration(input) || ts.isMethodSignature(input)) {
	                if (ts.hasModifier(input, 8 /* Private */)) {
	                    if (input.symbol && input.symbol.declarations && input.symbol.declarations[0] !== input)
	                        return; // Elide all but the first overload
	                    return cleanup(ts.createProperty(/*decorators*/ undefined, ensureModifiers(input), input.name, /*questionToken*/ undefined, /*type*/ undefined, /*initializer*/ undefined));
	                }
	            }
	            var canProdiceDiagnostic = ts.canProduceDiagnostics(input);
	            if (canProdiceDiagnostic && !suppressNewDiagnosticContexts) {
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(input);
	            }
	            if (ts.isTypeQueryNode(input)) {
	                checkEntityNameVisibility(input.exprName, enclosingDeclaration);
	            }
	            var oldWithinObjectLiteralType = suppressNewDiagnosticContexts;
	            var shouldEnterSuppressNewDiagnosticsContextContext = ((input.kind === 165 /* TypeLiteral */ || input.kind === 176 /* MappedType */) && input.parent.kind !== 236 /* TypeAliasDeclaration */);
	            if (shouldEnterSuppressNewDiagnosticsContextContext) {
	                // We stop making new diagnostic contexts within object literal types. Unless it's an object type on the RHS of a type alias declaration. Then we do.
	                suppressNewDiagnosticContexts = true;
	            }
	            if (isProcessedComponent(input)) {
	                switch (input.kind) {
	                    case 206 /* ExpressionWithTypeArguments */: {
	                        if ((ts.isEntityName(input.expression) || ts.isEntityNameExpression(input.expression))) {
	                            checkEntityNameVisibility(input.expression, enclosingDeclaration);
	                        }
	                        var node = ts.visitEachChild(input, visitDeclarationSubtree, context);
	                        return cleanup(ts.updateExpressionWithTypeArguments(node, ts.parenthesizeTypeParameters(node.typeArguments), node.expression));
	                    }
	                    case 161 /* TypeReference */: {
	                        checkEntityNameVisibility(input.typeName, enclosingDeclaration);
	                        var node = ts.visitEachChild(input, visitDeclarationSubtree, context);
	                        return cleanup(ts.updateTypeReferenceNode(node, node.typeName, ts.parenthesizeTypeParameters(node.typeArguments)));
	                    }
	                    case 158 /* ConstructSignature */:
	                        return cleanup(ts.updateConstructSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type)));
	                    case 154 /* Constructor */: {
	                        var isPrivate = ts.hasModifier(input, 8 /* Private */);
	                        // A constructor declaration may not have a type annotation
	                        var ctor = ts.createSignatureDeclaration(154 /* Constructor */, isPrivate ? undefined : ensureTypeParams(input, input.typeParameters), isPrivate ? undefined : updateParamsList(input, input.parameters, 0 /* None */), 
	                        /*type*/ undefined);
	                        ctor.modifiers = ts.createNodeArray(ensureModifiers(input));
	                        return cleanup(ctor);
	                    }
	                    case 153 /* MethodDeclaration */: {
	                        var sig = ts.createSignatureDeclaration(152 /* MethodSignature */, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type));
	                        sig.name = input.name;
	                        sig.modifiers = ts.createNodeArray(ensureModifiers(input));
	                        sig.questionToken = input.questionToken;
	                        return cleanup(sig);
	                    }
	                    case 155 /* GetAccessor */: {
	                        var newNode = ensureAccessor(input);
	                        return cleanup(newNode);
	                    }
	                    case 156 /* SetAccessor */: {
	                        var newNode = ensureAccessor(input);
	                        return cleanup(newNode);
	                    }
	                    case 151 /* PropertyDeclaration */:
	                        return cleanup(ts.updateProperty(input, 
	                        /*decorators*/ undefined, ensureModifiers(input), input.name, input.questionToken, !ts.hasModifier(input, 8 /* Private */) ? ensureType(input, input.type) : undefined, ensureNoInitializer(input)));
	                    case 150 /* PropertySignature */:
	                        return cleanup(ts.updatePropertySignature(input, ensureModifiers(input), input.name, input.questionToken, !ts.hasModifier(input, 8 /* Private */) ? ensureType(input, input.type) : undefined, ensureNoInitializer(input)));
	                    case 152 /* MethodSignature */: {
	                        return cleanup(ts.updateMethodSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type), input.name, input.questionToken));
	                    }
	                    case 157 /* CallSignature */: {
	                        return cleanup(ts.updateCallSignature(input, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type)));
	                    }
	                    case 159 /* IndexSignature */: {
	                        return cleanup(ts.updateIndexSignature(input, 
	                        /*decorators*/ undefined, ensureModifiers(input), updateParamsList(input, input.parameters), ts.visitNode(input.type, visitDeclarationSubtree) || ts.createKeywordTypeNode(119 /* AnyKeyword */)));
	                    }
	                    case 231 /* VariableDeclaration */: {
	                        if (ts.isBindingPattern(input.name)) {
	                            return recreateBindingPattern(input.name);
	                        }
	                        shouldEnterSuppressNewDiagnosticsContextContext = true;
	                        suppressNewDiagnosticContexts = true; // Variable declaration types also suppress new diagnostic contexts, provided the contexts wouldn't be made for binding pattern types
	                        return cleanup(ts.updateVariableDeclaration(input, input.name, ensureType(input, input.type), ensureNoInitializer(input)));
	                    }
	                    case 147 /* TypeParameter */: {
	                        if (isPrivateMethodTypeParameter(input) && (input.default || input.constraint)) {
	                            return cleanup(ts.updateTypeParameterDeclaration(input, input.name, /*constraint*/ undefined, /*defaultType*/ undefined));
	                        }
	                        return cleanup(ts.visitEachChild(input, visitDeclarationSubtree, context));
	                    }
	                    case 170 /* ConditionalType */: {
	                        // We have to process conditional types in a special way because for visibility purposes we need to push a new enclosingDeclaration
	                        // just for the `infer` types in the true branch. It's an implicit declaration scope that only applies to _part_ of the type.
	                        var checkType = ts.visitNode(input.checkType, visitDeclarationSubtree);
	                        var extendsType = ts.visitNode(input.extendsType, visitDeclarationSubtree);
	                        var oldEnclosingDecl = enclosingDeclaration;
	                        enclosingDeclaration = input.trueType;
	                        var trueType = ts.visitNode(input.trueType, visitDeclarationSubtree);
	                        enclosingDeclaration = oldEnclosingDecl;
	                        var falseType = ts.visitNode(input.falseType, visitDeclarationSubtree);
	                        return cleanup(ts.updateConditionalTypeNode(input, checkType, extendsType, trueType, falseType));
	                    }
	                    case 162 /* FunctionType */: {
	                        return cleanup(ts.updateFunctionTypeNode(input, ts.visitNodes(input.typeParameters, visitDeclarationSubtree), updateParamsList(input, input.parameters), ts.visitNode(input.type, visitDeclarationSubtree)));
	                    }
	                    case 163 /* ConstructorType */: {
	                        return cleanup(ts.updateConstructorTypeNode(input, ts.visitNodes(input.typeParameters, visitDeclarationSubtree), updateParamsList(input, input.parameters), ts.visitNode(input.type, visitDeclarationSubtree)));
	                    }
	                    case 178 /* ImportType */: {
	                        if (!ts.isLiteralImportTypeNode(input))
	                            return cleanup(input);
	                        return cleanup(ts.updateImportTypeNode(input, ts.updateLiteralTypeNode(input.argument, rewriteModuleSpecifier(input, input.argument.literal)), input.qualifier, ts.visitNodes(input.typeArguments, visitDeclarationSubtree, ts.isTypeNode), input.isTypeOf));
	                    }
	                    default: ts.Debug.assertNever(input, "Attempted to process unhandled node kind: " + ts.SyntaxKind[input.kind]);
	                }
	            }
	            return cleanup(ts.visitEachChild(input, visitDeclarationSubtree, context));
	            function cleanup(returnValue) {
	                if (returnValue && canProdiceDiagnostic && ts.hasDynamicName(input)) {
	                    checkName(input);
	                }
	                if (isEnclosingDeclaration(input)) {
	                    enclosingDeclaration = previousEnclosingDeclaration;
	                }
	                if (canProdiceDiagnostic && !suppressNewDiagnosticContexts) {
	                    getSymbolAccessibilityDiagnostic = oldDiag;
	                }
	                if (shouldEnterSuppressNewDiagnosticsContextContext) {
	                    suppressNewDiagnosticContexts = oldWithinObjectLiteralType;
	                }
	                if (returnValue === input) {
	                    return returnValue;
	                }
	                return returnValue && ts.setOriginalNode(preserveJsDoc(returnValue, input), input);
	            }
	        }
	        function isPrivateMethodTypeParameter(node) {
	            return node.parent.kind === 153 /* MethodDeclaration */ && ts.hasModifier(node.parent, 8 /* Private */);
	        }
	        function visitDeclarationStatements(input) {
	            if (!isPreservedDeclarationStatement(input)) {
	                // return undefined for unmatched kinds to omit them from the tree
	                return;
	            }
	            if (shouldStripInternal(input))
	                return;
	            switch (input.kind) {
	                case 249 /* ExportDeclaration */: {
	                    if (ts.isSourceFile(input.parent)) {
	                        resultHasExternalModuleIndicator = true;
	                        resultHasScopeMarker = true;
	                    }
	                    // Always visible if the parent node isn't dropped for being not visible
	                    // Rewrite external module names if necessary
	                    return ts.updateExportDeclaration(input, /*decorators*/ undefined, input.modifiers, input.exportClause, rewriteModuleSpecifier(input, input.moduleSpecifier));
	                }
	                case 248 /* ExportAssignment */: {
	                    // Always visible if the parent node isn't dropped for being not visible
	                    if (ts.isSourceFile(input.parent)) {
	                        resultHasExternalModuleIndicator = true;
	                        resultHasScopeMarker = true;
	                    }
	                    if (input.expression.kind === 71 /* Identifier */) {
	                        return input;
	                    }
	                    else {
	                        var newId = ts.createOptimisticUniqueName("_default");
	                        getSymbolAccessibilityDiagnostic = function () { return ({
	                            diagnosticMessage: ts.Diagnostics.Default_export_of_the_module_has_or_is_using_private_name_0,
	                            errorNode: input
	                        }); };
	                        var varDecl = ts.createVariableDeclaration(newId, resolver.createTypeOfExpression(input.expression, input, declarationEmitNodeBuilderFlags, symbolTracker), /*initializer*/ undefined);
	                        var statement = ts.createVariableStatement(needsDeclare ? [ts.createModifier(124 /* DeclareKeyword */)] : [], ts.createVariableDeclarationList([varDecl], 2 /* Const */));
	                        return [statement, ts.updateExportAssignment(input, input.decorators, input.modifiers, newId)];
	                    }
	                }
	            }
	            var result = transformTopLevelDeclaration(input);
	            // Don't actually transform yet; just leave as original node - will be elided/swapped by late pass
	            lateStatementReplacementMap.set("" + ts.getOriginalNodeId(input), result);
	            return input;
	        }
	        function transformTopLevelDeclaration(input, isPrivate) {
	            if (shouldStripInternal(input))
	                return;
	            switch (input.kind) {
	                case 242 /* ImportEqualsDeclaration */: {
	                    return transformImportEqualsDeclaration(input);
	                }
	                case 243 /* ImportDeclaration */: {
	                    return transformImportDeclaration(input);
	                }
	            }
	            if (ts.isDeclaration(input) && isDeclarationAndNotVisible(input))
	                return;
	            // Elide implementation signatures from overload sets
	            if (ts.isFunctionLike(input) && resolver.isImplementationOfOverload(input))
	                return;
	            var previousEnclosingDeclaration;
	            if (isEnclosingDeclaration(input)) {
	                previousEnclosingDeclaration = enclosingDeclaration;
	                enclosingDeclaration = input;
	            }
	            var canProdiceDiagnostic = ts.canProduceDiagnostics(input);
	            var oldDiag = getSymbolAccessibilityDiagnostic;
	            if (canProdiceDiagnostic) {
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(input);
	            }
	            var previousNeedsDeclare = needsDeclare;
	            switch (input.kind) {
	                case 236 /* TypeAliasDeclaration */: // Type aliases get `declare`d if need be (for legacy support), but that's all
	                    return cleanup(ts.updateTypeAliasDeclaration(input, 
	                    /*decorators*/ undefined, ensureModifiers(input, isPrivate), input.name, ts.visitNodes(input.typeParameters, visitDeclarationSubtree, ts.isTypeParameterDeclaration), ts.visitNode(input.type, visitDeclarationSubtree, ts.isTypeNode)));
	                case 235 /* InterfaceDeclaration */: {
	                    return cleanup(ts.updateInterfaceDeclaration(input, 
	                    /*decorators*/ undefined, ensureModifiers(input, isPrivate), input.name, ensureTypeParams(input, input.typeParameters), transformHeritageClauses(input.heritageClauses), ts.visitNodes(input.members, visitDeclarationSubtree)));
	                }
	                case 233 /* FunctionDeclaration */: {
	                    // Generators lose their generator-ness, excepting their return type
	                    return cleanup(ts.updateFunctionDeclaration(input, 
	                    /*decorators*/ undefined, ensureModifiers(input, isPrivate), 
	                    /*asteriskToken*/ undefined, input.name, ensureTypeParams(input, input.typeParameters), updateParamsList(input, input.parameters), ensureType(input, input.type), 
	                    /*body*/ undefined));
	                }
	                case 238 /* ModuleDeclaration */: {
	                    needsDeclare = false;
	                    var inner = input.body;
	                    if (inner && inner.kind === 239 /* ModuleBlock */) {
	                        var statements = ts.visitNodes(inner.statements, visitDeclarationStatements);
	                        var body = ts.updateModuleBlock(inner, transformAndReplaceLatePaintedStatements(statements));
	                        needsDeclare = previousNeedsDeclare;
	                        var mods = ensureModifiers(input, isPrivate);
	                        return cleanup(ts.updateModuleDeclaration(input, 
	                        /*decorators*/ undefined, mods, ts.isExternalModuleAugmentation(input) ? rewriteModuleSpecifier(input, input.name) : input.name, body));
	                    }
	                    else {
	                        needsDeclare = previousNeedsDeclare;
	                        var mods = ensureModifiers(input, isPrivate);
	                        needsDeclare = false;
	                        ts.visitNode(inner, visitDeclarationStatements);
	                        // eagerly transform nested namespaces (the nesting doesn't need any elision or painting done)
	                        var id = "" + ts.getOriginalNodeId(inner);
	                        var body = lateStatementReplacementMap.get(id);
	                        lateStatementReplacementMap.delete(id);
	                        return cleanup(ts.updateModuleDeclaration(input, 
	                        /*decorators*/ undefined, mods, input.name, body));
	                    }
	                }
	                case 234 /* ClassDeclaration */: {
	                    var modifiers = ts.createNodeArray(ensureModifiers(input, isPrivate));
	                    var typeParameters = ensureTypeParams(input, input.typeParameters);
	                    var ctor = ts.getFirstConstructorWithBody(input);
	                    var parameterProperties = void 0;
	                    if (ctor) {
	                        var oldDiag_1 = getSymbolAccessibilityDiagnostic;
	                        parameterProperties = ts.compact(ts.flatMap(ctor.parameters, function (param) {
	                            if (!ts.hasModifier(param, 92 /* ParameterPropertyModifier */))
	                                return;
	                            getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(param);
	                            if (param.name.kind === 71 /* Identifier */) {
	                                return preserveJsDoc(ts.createProperty(
	                                /*decorators*/ undefined, ensureModifiers(param), param.name, param.questionToken, ensureType(param, param.type), ensureNoInitializer(param)), param);
	                            }
	                            else {
	                                // Pattern - this is currently an error, but we emit declarations for it somewhat correctly
	                                return walkBindingPattern(param.name);
	                            }
	                            function walkBindingPattern(pattern) {
	                                var elems;
	                                for (var _i = 0, _a = pattern.elements; _i < _a.length; _i++) {
	                                    var elem = _a[_i];
	                                    if (ts.isOmittedExpression(elem))
	                                        continue;
	                                    if (ts.isBindingPattern(elem.name)) {
	                                        elems = ts.concatenate(elems, walkBindingPattern(elem.name));
	                                    }
	                                    elems = elems || [];
	                                    elems.push(ts.createProperty(
	                                    /*decorators*/ undefined, ensureModifiers(param), elem.name, 
	                                    /*questionToken*/ undefined, ensureType(elem, /*type*/ undefined), 
	                                    /*initializer*/ undefined));
	                                }
	                                return elems;
	                            }
	                        }));
	                        getSymbolAccessibilityDiagnostic = oldDiag_1;
	                    }
	                    var members = ts.createNodeArray(ts.concatenate(parameterProperties, ts.visitNodes(input.members, visitDeclarationSubtree)));
	                    var extendsClause_1 = ts.getClassExtendsHeritageClauseElement(input);
	                    if (extendsClause_1 && !ts.isEntityNameExpression(extendsClause_1.expression) && extendsClause_1.expression.kind !== 95 /* NullKeyword */) {
	                        // We must add a temporary declaration for the extends clause expression
	                        var newId_1 = ts.createOptimisticUniqueName(ts.unescapeLeadingUnderscores(input.name.escapedText) + "_base");
	                        getSymbolAccessibilityDiagnostic = function () { return ({
	                            diagnosticMessage: ts.Diagnostics.extends_clause_of_exported_class_0_has_or_is_using_private_name_1,
	                            errorNode: extendsClause_1,
	                            typeName: input.name
	                        }); };
	                        var varDecl = ts.createVariableDeclaration(newId_1, resolver.createTypeOfExpression(extendsClause_1.expression, input, declarationEmitNodeBuilderFlags, symbolTracker), /*initializer*/ undefined);
	                        var statement = ts.createVariableStatement(needsDeclare ? [ts.createModifier(124 /* DeclareKeyword */)] : [], ts.createVariableDeclarationList([varDecl], 2 /* Const */));
	                        var heritageClauses = ts.createNodeArray(ts.map(input.heritageClauses, function (clause) {
	                            if (clause.token === 85 /* ExtendsKeyword */) {
	                                var oldDiag_2 = getSymbolAccessibilityDiagnostic;
	                                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(clause.types[0]);
	                                var newClause = ts.updateHeritageClause(clause, ts.map(clause.types, function (t) { return ts.updateExpressionWithTypeArguments(t, ts.visitNodes(t.typeArguments, visitDeclarationSubtree), newId_1); }));
	                                getSymbolAccessibilityDiagnostic = oldDiag_2;
	                                return newClause;
	                            }
	                            return ts.updateHeritageClause(clause, ts.visitNodes(ts.createNodeArray(ts.filter(clause.types, function (t) { return ts.isEntityNameExpression(t.expression) || t.expression.kind === 95 /* NullKeyword */; })), visitDeclarationSubtree));
	                        }));
	                        return [statement, cleanup(ts.updateClassDeclaration(input, 
	                            /*decorators*/ undefined, modifiers, input.name, typeParameters, heritageClauses, members))];
	                    }
	                    else {
	                        var heritageClauses = transformHeritageClauses(input.heritageClauses);
	                        return cleanup(ts.updateClassDeclaration(input, 
	                        /*decorators*/ undefined, modifiers, input.name, typeParameters, heritageClauses, members));
	                    }
	                }
	                case 213 /* VariableStatement */: {
	                    return cleanup(transformVariableStatement(input, isPrivate));
	                }
	                case 237 /* EnumDeclaration */: {
	                    return cleanup(ts.updateEnumDeclaration(input, /*decorators*/ undefined, ts.createNodeArray(ensureModifiers(input, isPrivate)), input.name, ts.createNodeArray(ts.mapDefined(input.members, function (m) {
	                        if (shouldStripInternal(m))
	                            return;
	                        // Rewrite enum values to their constants, if available
	                        var constValue = resolver.getConstantValue(m);
	                        return preserveJsDoc(ts.updateEnumMember(m, m.name, constValue !== undefined ? ts.createLiteral(constValue) : undefined), m);
	                    }))));
	                }
	            }
	            // Anything left unhandled is an error, so this should be unreachable
	            return ts.Debug.assertNever(input, "Unhandled top-level node in declaration emit: " + ts.SyntaxKind[input.kind]);
	            function cleanup(node) {
	                if (isEnclosingDeclaration(input)) {
	                    enclosingDeclaration = previousEnclosingDeclaration;
	                }
	                if (canProdiceDiagnostic) {
	                    getSymbolAccessibilityDiagnostic = oldDiag;
	                }
	                if (input.kind === 238 /* ModuleDeclaration */) {
	                    needsDeclare = previousNeedsDeclare;
	                }
	                if (node === input) {
	                    return node;
	                }
	                return node && ts.setOriginalNode(preserveJsDoc(node, input), input);
	            }
	        }
	        function transformVariableStatement(input, privateDeclaration) {
	            if (!ts.forEach(input.declarationList.declarations, getBindingNameVisible))
	                return;
	            var nodes = ts.visitNodes(input.declarationList.declarations, visitDeclarationSubtree);
	            if (!ts.length(nodes))
	                return;
	            return ts.updateVariableStatement(input, ts.createNodeArray(ensureModifiers(input, privateDeclaration)), ts.updateVariableDeclarationList(input.declarationList, nodes));
	        }
	        function recreateBindingPattern(d) {
	            return ts.flatten(ts.mapDefined(d.elements, function (e) { return recreateBindingElement(e); }));
	        }
	        function recreateBindingElement(e) {
	            if (e.kind === 205 /* OmittedExpression */) {
	                return;
	            }
	            if (e.name) {
	                if (!getBindingNameVisible(e))
	                    return;
	                if (ts.isBindingPattern(e.name)) {
	                    return recreateBindingPattern(e.name);
	                }
	                else {
	                    return ts.createVariableDeclaration(e.name, ensureType(e, /*type*/ undefined), /*initializer*/ undefined);
	                }
	            }
	        }
	        function checkName(node) {
	            var oldDiag;
	            if (!suppressNewDiagnosticContexts) {
	                oldDiag = getSymbolAccessibilityDiagnostic;
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNodeName(node);
	            }
	            errorNameNode = node.name;
	            ts.Debug.assert(resolver.isLateBound(ts.getParseTreeNode(node))); // Should only be called with dynamic names
	            var decl = node;
	            var entityName = decl.name.expression;
	            checkEntityNameVisibility(entityName, enclosingDeclaration);
	            if (!suppressNewDiagnosticContexts) {
	                getSymbolAccessibilityDiagnostic = oldDiag;
	            }
	            errorNameNode = undefined;
	        }
	        function hasInternalAnnotation(range) {
	            var comment = currentSourceFile.text.substring(range.pos, range.end);
	            return ts.stringContains(comment, "@internal");
	        }
	        function shouldStripInternal(node) {
	            if (stripInternal && node) {
	                var leadingCommentRanges = ts.getLeadingCommentRangesOfNode(ts.getParseTreeNode(node), currentSourceFile);
	                if (ts.forEach(leadingCommentRanges, hasInternalAnnotation)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        function ensureModifiers(node, privateDeclaration) {
	            var currentFlags = ts.getModifierFlags(node);
	            var newFlags = ensureModifierFlags(node, privateDeclaration);
	            if (currentFlags === newFlags) {
	                return node.modifiers;
	            }
	            return ts.createModifiersFromModifierFlags(newFlags);
	        }
	        function ensureModifierFlags(node, privateDeclaration) {
	            var mask = 3071 /* All */ ^ (4 /* Public */ | 256 /* Async */); // No async modifiers in declaration files
	            var additions = (needsDeclare && !isAlwaysType(node)) ? 2 /* Ambient */ : 0 /* None */;
	            var parentIsFile = node.parent.kind === 273 /* SourceFile */;
	            if (!parentIsFile || (isBundledEmit && parentIsFile && ts.isExternalModule(node.parent))) {
	                mask ^= ((privateDeclaration || (isBundledEmit && parentIsFile) ? 0 : 1 /* Export */) | 512 /* Default */ | 2 /* Ambient */);
	                additions = 0 /* None */;
	            }
	            return maskModifierFlags(node, mask, additions);
	        }
	        function ensureAccessor(node) {
	            var accessors = resolver.getAllAccessorDeclarations(node);
	            if (node.kind !== accessors.firstAccessor.kind) {
	                return;
	            }
	            var accessorType = getTypeAnnotationFromAccessor(node);
	            if (!accessorType && accessors.secondAccessor) {
	                accessorType = getTypeAnnotationFromAccessor(accessors.secondAccessor);
	                // If we end up pulling the type from the second accessor, we also need to change the diagnostic context to get the expected error message
	                getSymbolAccessibilityDiagnostic = ts.createGetSymbolAccessibilityDiagnosticForNode(accessors.secondAccessor);
	            }
	            var prop = ts.createProperty(/*decorators*/ undefined, maskModifiers(node, /*mask*/ undefined, (!accessors.setAccessor) ? 64 /* Readonly */ : 0 /* None */), node.name, node.questionToken, ensureType(node, accessorType), /*initializer*/ undefined);
	            var leadingsSyntheticCommentRanges = accessors.secondAccessor && ts.getLeadingCommentRangesOfNode(accessors.secondAccessor, currentSourceFile);
	            if (leadingsSyntheticCommentRanges) {
	                var _loop_9 = function (range) {
	                    if (range.kind === 3 /* MultiLineCommentTrivia */) {
	                        var text = currentSourceFile.text.slice(range.pos + 2, range.end - 2);
	                        var lines = text.split(/\r\n?|\n/g);
	                        if (lines.length > 1) {
	                            var lastLines = lines.slice(1);
	                            var indentation_1 = ts.guessIndentation(lastLines);
	                            text = [lines[0]].concat(ts.map(lastLines, function (l) { return l.slice(indentation_1); })).join(newLine);
	                        }
	                        ts.addSyntheticLeadingComment(prop, range.kind, text, range.hasTrailingNewLine);
	                    }
	                };
	                for (var _i = 0, leadingsSyntheticCommentRanges_1 = leadingsSyntheticCommentRanges; _i < leadingsSyntheticCommentRanges_1.length; _i++) {
	                    var range = leadingsSyntheticCommentRanges_1[_i];
	                    _loop_9(range);
	                }
	            }
	            return prop;
	        }
	        function transformHeritageClauses(nodes) {
	            return ts.createNodeArray(ts.filter(ts.map(nodes, function (clause) { return ts.updateHeritageClause(clause, ts.visitNodes(ts.createNodeArray(ts.filter(clause.types, function (t) {
	                return ts.isEntityNameExpression(t.expression) || (clause.token === 85 /* ExtendsKeyword */ && t.expression.kind === 95 /* NullKeyword */);
	            })), visitDeclarationSubtree)); }), function (clause) { return clause.types && !!clause.types.length; }));
	        }
	    }
	    ts.transformDeclarations = transformDeclarations;
	    function isAlwaysType(node) {
	        if (node.kind === 235 /* InterfaceDeclaration */) {
	            return true;
	        }
	        return false;
	    }
	    // Elide "public" modifier, as it is the default
	    function maskModifiers(node, modifierMask, modifierAdditions) {
	        return ts.createModifiersFromModifierFlags(maskModifierFlags(node, modifierMask, modifierAdditions));
	    }
	    function maskModifierFlags(node, modifierMask, modifierAdditions) {
	        if (modifierMask === void 0) { modifierMask = 3071 /* All */ ^ 4 /* Public */; }
	        if (modifierAdditions === void 0) { modifierAdditions = 0 /* None */; }
	        var flags = (ts.getModifierFlags(node) & modifierMask) | modifierAdditions;
	        if (flags & 512 /* Default */ && flags & 2 /* Ambient */) {
	            flags ^= 2 /* Ambient */; // `declare` is never required alongside `default` (and would be an error if printed)
	        }
	        return flags;
	    }
	    function getTypeAnnotationFromAccessor(accessor) {
	        if (accessor) {
	            return accessor.kind === 155 /* GetAccessor */
	                ? accessor.type // Getter - return type
	                : accessor.parameters.length > 0
	                    ? accessor.parameters[0].type // Setter parameter type
	                    : undefined;
	        }
	    }
	    function canHaveLiteralInitializer(node) {
	        switch (node.kind) {
	            case 231 /* VariableDeclaration */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 148 /* Parameter */:
	                return true;
	        }
	        return false;
	    }
	    function isPreservedDeclarationStatement(node) {
	        switch (node.kind) {
	            case 233 /* FunctionDeclaration */:
	            case 238 /* ModuleDeclaration */:
	            case 242 /* ImportEqualsDeclaration */:
	            case 235 /* InterfaceDeclaration */:
	            case 234 /* ClassDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 237 /* EnumDeclaration */:
	            case 213 /* VariableStatement */:
	            case 243 /* ImportDeclaration */:
	            case 249 /* ExportDeclaration */:
	            case 248 /* ExportAssignment */:
	                return true;
	        }
	        return false;
	    }
	    function isProcessedComponent(node) {
	        switch (node.kind) {
	            case 158 /* ConstructSignature */:
	            case 154 /* Constructor */:
	            case 153 /* MethodDeclaration */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 152 /* MethodSignature */:
	            case 157 /* CallSignature */:
	            case 159 /* IndexSignature */:
	            case 231 /* VariableDeclaration */:
	            case 147 /* TypeParameter */:
	            case 206 /* ExpressionWithTypeArguments */:
	            case 161 /* TypeReference */:
	            case 170 /* ConditionalType */:
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	            case 178 /* ImportType */:
	                return true;
	        }
	        return false;
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function getModuleTransformer(moduleKind) {
	        switch (moduleKind) {
	            case ts.ModuleKind.ESNext:
	            case ts.ModuleKind.ES2015:
	                return ts.transformES2015Module;
	            case ts.ModuleKind.System:
	                return ts.transformSystemModule;
	            default:
	                return ts.transformModule;
	        }
	    }
	    var TransformationState;
	    (function (TransformationState) {
	        TransformationState[TransformationState["Uninitialized"] = 0] = "Uninitialized";
	        TransformationState[TransformationState["Initialized"] = 1] = "Initialized";
	        TransformationState[TransformationState["Completed"] = 2] = "Completed";
	        TransformationState[TransformationState["Disposed"] = 3] = "Disposed";
	    })(TransformationState || (TransformationState = {}));
	    var SyntaxKindFeatureFlags;
	    (function (SyntaxKindFeatureFlags) {
	        SyntaxKindFeatureFlags[SyntaxKindFeatureFlags["Substitution"] = 1] = "Substitution";
	        SyntaxKindFeatureFlags[SyntaxKindFeatureFlags["EmitNotifications"] = 2] = "EmitNotifications";
	    })(SyntaxKindFeatureFlags || (SyntaxKindFeatureFlags = {}));
	    function getTransformers(compilerOptions, customTransformers) {
	        var jsx = compilerOptions.jsx;
	        var languageVersion = ts.getEmitScriptTarget(compilerOptions);
	        var moduleKind = ts.getEmitModuleKind(compilerOptions);
	        var transformers = [];
	        ts.addRange(transformers, customTransformers && customTransformers.before);
	        transformers.push(ts.transformTypeScript);
	        if (jsx === 2 /* React */) {
	            transformers.push(ts.transformJsx);
	        }
	        if (languageVersion < 6 /* ESNext */) {
	            transformers.push(ts.transformESNext);
	        }
	        if (languageVersion < 4 /* ES2017 */) {
	            transformers.push(ts.transformES2017);
	        }
	        if (languageVersion < 3 /* ES2016 */) {
	            transformers.push(ts.transformES2016);
	        }
	        if (languageVersion < 2 /* ES2015 */) {
	            transformers.push(ts.transformES2015);
	            transformers.push(ts.transformGenerators);
	        }
	        transformers.push(getModuleTransformer(moduleKind));
	        // The ES5 transformer is last so that it can substitute expressions like `exports.default`
	        // for ES3.
	        if (languageVersion < 1 /* ES5 */) {
	            transformers.push(ts.transformES5);
	        }
	        ts.addRange(transformers, customTransformers && customTransformers.after);
	        return transformers;
	    }
	    ts.getTransformers = getTransformers;
	    /**
	     * Transforms an array of SourceFiles by passing them through each transformer.
	     *
	     * @param resolver The emit resolver provided by the checker.
	     * @param host The emit host object used to interact with the file system.
	     * @param options Compiler options to surface in the `TransformationContext`.
	     * @param nodes An array of nodes to transform.
	     * @param transforms An array of `TransformerFactory` callbacks.
	     * @param allowDtsFiles A value indicating whether to allow the transformation of .d.ts files.
	     */
	    function transformNodes(resolver, host, options, nodes, transformers, allowDtsFiles) {
	        var enabledSyntaxKindFeatures = new Array(304 /* Count */);
	        var lexicalEnvironmentVariableDeclarations;
	        var lexicalEnvironmentFunctionDeclarations;
	        var lexicalEnvironmentVariableDeclarationsStack = [];
	        var lexicalEnvironmentFunctionDeclarationsStack = [];
	        var lexicalEnvironmentStackOffset = 0;
	        var lexicalEnvironmentSuspended = false;
	        var emitHelpers;
	        var onSubstituteNode = function (_, node) { return node; };
	        var onEmitNode = function (hint, node, callback) { return callback(hint, node); };
	        var state = 0 /* Uninitialized */;
	        var diagnostics = [];
	        // The transformation context is provided to each transformer as part of transformer
	        // initialization.
	        var context = {
	            getCompilerOptions: function () { return options; },
	            getEmitResolver: function () { return resolver; },
	            getEmitHost: function () { return host; },
	            startLexicalEnvironment: startLexicalEnvironment,
	            suspendLexicalEnvironment: suspendLexicalEnvironment,
	            resumeLexicalEnvironment: resumeLexicalEnvironment,
	            endLexicalEnvironment: endLexicalEnvironment,
	            hoistVariableDeclaration: hoistVariableDeclaration,
	            hoistFunctionDeclaration: hoistFunctionDeclaration,
	            requestEmitHelper: requestEmitHelper,
	            readEmitHelpers: readEmitHelpers,
	            enableSubstitution: enableSubstitution,
	            enableEmitNotification: enableEmitNotification,
	            isSubstitutionEnabled: isSubstitutionEnabled,
	            isEmitNotificationEnabled: isEmitNotificationEnabled,
	            get onSubstituteNode() { return onSubstituteNode; },
	            set onSubstituteNode(value) {
	                ts.Debug.assert(state < 1 /* Initialized */, "Cannot modify transformation hooks after initialization has completed.");
	                ts.Debug.assert(value !== undefined, "Value must not be 'undefined'");
	                onSubstituteNode = value;
	            },
	            get onEmitNode() { return onEmitNode; },
	            set onEmitNode(value) {
	                ts.Debug.assert(state < 1 /* Initialized */, "Cannot modify transformation hooks after initialization has completed.");
	                ts.Debug.assert(value !== undefined, "Value must not be 'undefined'");
	                onEmitNode = value;
	            },
	            addDiagnostic: function (diag) {
	                diagnostics.push(diag);
	            }
	        };
	        // Ensure the parse tree is clean before applying transformations
	        for (var _i = 0, nodes_4 = nodes; _i < nodes_4.length; _i++) {
	            var node = nodes_4[_i];
	            ts.disposeEmitNodes(ts.getSourceFileOfNode(ts.getParseTreeNode(node)));
	        }
	        ts.performance.mark("beforeTransform");
	        // Chain together and initialize each transformer.
	        var transformation = ts.chain.apply(void 0, transformers)(context);
	        // prevent modification of transformation hooks.
	        state = 1 /* Initialized */;
	        // Transform each node.
	        var transformed = ts.map(nodes, allowDtsFiles ? transformation : transformRoot);
	        // prevent modification of the lexical environment.
	        state = 2 /* Completed */;
	        ts.performance.mark("afterTransform");
	        ts.performance.measure("transformTime", "beforeTransform", "afterTransform");
	        return {
	            transformed: transformed,
	            substituteNode: substituteNode,
	            emitNodeWithNotification: emitNodeWithNotification,
	            dispose: dispose,
	            diagnostics: diagnostics
	        };
	        function transformRoot(node) {
	            return node && (!ts.isSourceFile(node) || !node.isDeclarationFile) ? transformation(node) : node;
	        }
	        /**
	         * Enables expression substitutions in the pretty printer for the provided SyntaxKind.
	         */
	        function enableSubstitution(kind) {
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            enabledSyntaxKindFeatures[kind] |= 1 /* Substitution */;
	        }
	        /**
	         * Determines whether expression substitutions are enabled for the provided node.
	         */
	        function isSubstitutionEnabled(node) {
	            return (enabledSyntaxKindFeatures[node.kind] & 1 /* Substitution */) !== 0
	                && (ts.getEmitFlags(node) & 4 /* NoSubstitution */) === 0;
	        }
	        /**
	         * Emits a node with possible substitution.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node or its substitute.
	         */
	        function substituteNode(hint, node) {
	            ts.Debug.assert(state < 3 /* Disposed */, "Cannot substitute a node after the result is disposed.");
	            return node && isSubstitutionEnabled(node) && onSubstituteNode(hint, node) || node;
	        }
	        /**
	         * Enables before/after emit notifications in the pretty printer for the provided SyntaxKind.
	         */
	        function enableEmitNotification(kind) {
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            enabledSyntaxKindFeatures[kind] |= 2 /* EmitNotifications */;
	        }
	        /**
	         * Determines whether before/after emit notifications should be raised in the pretty
	         * printer when it emits a node.
	         */
	        function isEmitNotificationEnabled(node) {
	            return (enabledSyntaxKindFeatures[node.kind] & 2 /* EmitNotifications */) !== 0
	                || (ts.getEmitFlags(node) & 2 /* AdviseOnEmitNode */) !== 0;
	        }
	        /**
	         * Emits a node with possible emit notification.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function emitNodeWithNotification(hint, node, emitCallback) {
	            ts.Debug.assert(state < 3 /* Disposed */, "Cannot invoke TransformationResult callbacks after the result is disposed.");
	            if (node) {
	                if (isEmitNotificationEnabled(node)) {
	                    onEmitNode(hint, node, emitCallback);
	                }
	                else {
	                    emitCallback(hint, node);
	                }
	            }
	        }
	        /**
	         * Records a hoisted variable declaration for the provided name within a lexical environment.
	         */
	        function hoistVariableDeclaration(name) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            var decl = ts.setEmitFlags(ts.createVariableDeclaration(name), 64 /* NoNestedSourceMaps */);
	            if (!lexicalEnvironmentVariableDeclarations) {
	                lexicalEnvironmentVariableDeclarations = [decl];
	            }
	            else {
	                lexicalEnvironmentVariableDeclarations.push(decl);
	            }
	        }
	        /**
	         * Records a hoisted function declaration within a lexical environment.
	         */
	        function hoistFunctionDeclaration(func) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            if (!lexicalEnvironmentFunctionDeclarations) {
	                lexicalEnvironmentFunctionDeclarations = [func];
	            }
	            else {
	                lexicalEnvironmentFunctionDeclarations.push(func);
	            }
	        }
	        /**
	         * Starts a new lexical environment. Any existing hoisted variable or function declarations
	         * are pushed onto a stack, and the related storage variables are reset.
	         */
	        function startLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
	            // Save the current lexical environment. Rather than resizing the array we adjust the
	            // stack size variable. This allows us to reuse existing array slots we've
	            // already allocated between transformations to avoid allocation and GC overhead during
	            // transformation.
	            lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentVariableDeclarations;
	            lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset] = lexicalEnvironmentFunctionDeclarations;
	            lexicalEnvironmentStackOffset++;
	            lexicalEnvironmentVariableDeclarations = undefined;
	            lexicalEnvironmentFunctionDeclarations = undefined;
	        }
	        /** Suspends the current lexical environment, usually after visiting a parameter list. */
	        function suspendLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is already suspended.");
	            lexicalEnvironmentSuspended = true;
	        }
	        /** Resumes a suspended lexical environment, usually before visiting a function body. */
	        function resumeLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(lexicalEnvironmentSuspended, "Lexical environment is not suspended.");
	            lexicalEnvironmentSuspended = false;
	        }
	        /**
	         * Ends a lexical environment. The previous set of hoisted declarations are restored and
	         * any hoisted declarations added in this environment are returned.
	         */
	        function endLexicalEnvironment() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the lexical environment during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the lexical environment after transformation has completed.");
	            ts.Debug.assert(!lexicalEnvironmentSuspended, "Lexical environment is suspended.");
	            var statements;
	            if (lexicalEnvironmentVariableDeclarations || lexicalEnvironmentFunctionDeclarations) {
	                if (lexicalEnvironmentFunctionDeclarations) {
	                    statements = lexicalEnvironmentFunctionDeclarations.slice();
	                }
	                if (lexicalEnvironmentVariableDeclarations) {
	                    var statement = ts.createVariableStatement(
	                    /*modifiers*/ undefined, ts.createVariableDeclarationList(lexicalEnvironmentVariableDeclarations));
	                    if (!statements) {
	                        statements = [statement];
	                    }
	                    else {
	                        statements.push(statement);
	                    }
	                }
	            }
	            // Restore the previous lexical environment.
	            lexicalEnvironmentStackOffset--;
	            lexicalEnvironmentVariableDeclarations = lexicalEnvironmentVariableDeclarationsStack[lexicalEnvironmentStackOffset];
	            lexicalEnvironmentFunctionDeclarations = lexicalEnvironmentFunctionDeclarationsStack[lexicalEnvironmentStackOffset];
	            if (lexicalEnvironmentStackOffset === 0) {
	                lexicalEnvironmentVariableDeclarationsStack = [];
	                lexicalEnvironmentFunctionDeclarationsStack = [];
	            }
	            return statements;
	        }
	        function requestEmitHelper(helper) {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the transformation context during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            ts.Debug.assert(!helper.scoped, "Cannot request a scoped emit helper.");
	            emitHelpers = ts.append(emitHelpers, helper);
	        }
	        function readEmitHelpers() {
	            ts.Debug.assert(state > 0 /* Uninitialized */, "Cannot modify the transformation context during initialization.");
	            ts.Debug.assert(state < 2 /* Completed */, "Cannot modify the transformation context after transformation has completed.");
	            var helpers = emitHelpers;
	            emitHelpers = undefined;
	            return helpers;
	        }
	        function dispose() {
	            if (state < 3 /* Disposed */) {
	                // Clean up emit nodes on parse tree
	                for (var _i = 0, nodes_5 = nodes; _i < nodes_5.length; _i++) {
	                    var node = nodes_5[_i];
	                    ts.disposeEmitNodes(ts.getSourceFileOfNode(ts.getParseTreeNode(node)));
	                }
	                // Release references to external entries for GC purposes.
	                lexicalEnvironmentVariableDeclarations = undefined;
	                lexicalEnvironmentVariableDeclarationsStack = undefined;
	                lexicalEnvironmentFunctionDeclarations = undefined;
	                lexicalEnvironmentFunctionDeclarationsStack = undefined;
	                onSubstituteNode = undefined;
	                onEmitNode = undefined;
	                emitHelpers = undefined;
	                // Prevent further use of the transformation result.
	                state = 3 /* Disposed */;
	            }
	        }
	    }
	    ts.transformNodes = transformNodes;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    // Used for initialize lastEncodedSourceMapSpan and reset lastEncodedSourceMapSpan when updateLastEncodedAndRecordedSpans
	    var defaultLastEncodedSourceMapSpan = {
	        emittedLine: 1,
	        emittedColumn: 1,
	        sourceLine: 1,
	        sourceColumn: 1,
	        sourceIndex: 0
	    };
	    function createSourceMapWriter(host, writer, compilerOptions) {
	        if (compilerOptions === void 0) { compilerOptions = host.getCompilerOptions(); }
	        var extendedDiagnostics = compilerOptions.extendedDiagnostics;
	        var currentSource;
	        var currentSourceText;
	        var sourceMapDir; // The directory in which sourcemap will be
	        // Current source map file and its index in the sources list
	        var sourceMapSourceIndex;
	        // Last recorded and encoded spans
	        var lastRecordedSourceMapSpan;
	        var lastEncodedSourceMapSpan;
	        var lastEncodedNameIndex;
	        // Source map data
	        var sourceMapData;
	        var sourceMapDataList;
	        var disabled = !(compilerOptions.sourceMap || compilerOptions.inlineSourceMap);
	        return {
	            initialize: initialize,
	            reset: reset,
	            setSourceFile: setSourceFile,
	            emitPos: emitPos,
	            emitNodeWithSourceMap: emitNodeWithSourceMap,
	            emitTokenWithSourceMap: emitTokenWithSourceMap,
	            getText: getText,
	            getSourceMappingURL: getSourceMappingURL,
	        };
	        /**
	         * Skips trivia such as comments and white-space that can optionally overriden by the source map source
	         */
	        function skipSourceTrivia(pos) {
	            return currentSource.skipTrivia ? currentSource.skipTrivia(pos) : ts.skipTrivia(currentSourceText, pos);
	        }
	        /**
	         * Initialize the SourceMapWriter for a new output file.
	         *
	         * @param filePath The path to the generated output file.
	         * @param sourceMapFilePath The path to the output source map file.
	         * @param sourceFileOrBundle The input source file or bundle for the program.
	         */
	        function initialize(filePath, sourceMapFilePath, sourceFileOrBundle, outputSourceMapDataList) {
	            if (disabled || ts.fileExtensionIs(filePath, ".json" /* Json */)) {
	                return;
	            }
	            if (sourceMapData) {
	                reset();
	            }
	            sourceMapDataList = outputSourceMapDataList;
	            currentSource = undefined;
	            currentSourceText = undefined;
	            // Current source map file and its index in the sources list
	            sourceMapSourceIndex = -1;
	            // Last recorded and encoded spans
	            lastRecordedSourceMapSpan = undefined;
	            lastEncodedSourceMapSpan = defaultLastEncodedSourceMapSpan;
	            lastEncodedNameIndex = 0;
	            // Initialize source map data
	            sourceMapData = {
	                sourceMapFilePath: sourceMapFilePath,
	                jsSourceMappingURL: !compilerOptions.inlineSourceMap ? ts.getBaseFileName(ts.normalizeSlashes(sourceMapFilePath)) : undefined,
	                sourceMapFile: ts.getBaseFileName(ts.normalizeSlashes(filePath)),
	                sourceMapSourceRoot: compilerOptions.sourceRoot || "",
	                sourceMapSources: [],
	                inputSourceFileNames: [],
	                sourceMapNames: [],
	                sourceMapMappings: "",
	                sourceMapSourcesContent: compilerOptions.inlineSources ? [] : undefined,
	                sourceMapDecodedMappings: []
	            };
	            // Normalize source root and make sure it has trailing "/" so that it can be used to combine paths with the
	            // relative paths of the sources list in the sourcemap
	            sourceMapData.sourceMapSourceRoot = ts.normalizeSlashes(sourceMapData.sourceMapSourceRoot);
	            if (sourceMapData.sourceMapSourceRoot.length && sourceMapData.sourceMapSourceRoot.charCodeAt(sourceMapData.sourceMapSourceRoot.length - 1) !== 47 /* slash */) {
	                sourceMapData.sourceMapSourceRoot += ts.directorySeparator;
	            }
	            if (compilerOptions.mapRoot) {
	                sourceMapDir = ts.normalizeSlashes(compilerOptions.mapRoot);
	                if (sourceFileOrBundle.kind === 273 /* SourceFile */) { // emitting single module file
	                    // For modules or multiple emit files the mapRoot will have directory structure like the sources
	                    // So if src\a.ts and src\lib\b.ts are compiled together user would be moving the maps into mapRoot\a.js.map and mapRoot\lib\b.js.map
	                    sourceMapDir = ts.getDirectoryPath(ts.getSourceFilePathInNewDir(sourceFileOrBundle, host, sourceMapDir));
	                }
	                if (!ts.isRootedDiskPath(sourceMapDir) && !ts.isUrl(sourceMapDir)) {
	                    // The relative paths are relative to the common directory
	                    sourceMapDir = ts.combinePaths(host.getCommonSourceDirectory(), sourceMapDir);
	                    sourceMapData.jsSourceMappingURL = ts.getRelativePathToDirectoryOrUrl(ts.getDirectoryPath(ts.normalizePath(filePath)), // get the relative sourceMapDir path based on jsFilePath
	                    ts.combinePaths(sourceMapDir, sourceMapData.jsSourceMappingURL), // this is where user expects to see sourceMap
	                    host.getCurrentDirectory(), host.getCanonicalFileName, 
	                    /*isAbsolutePathAnUrl*/ true);
	                }
	                else {
	                    sourceMapData.jsSourceMappingURL = ts.combinePaths(sourceMapDir, sourceMapData.jsSourceMappingURL);
	                }
	            }
	            else {
	                sourceMapDir = ts.getDirectoryPath(ts.normalizePath(filePath));
	            }
	        }
	        /**
	         * Reset the SourceMapWriter to an empty state.
	         */
	        function reset() {
	            if (disabled) {
	                return;
	            }
	            // Record source map data for the test harness.
	            if (sourceMapDataList) {
	                sourceMapDataList.push(sourceMapData);
	            }
	            currentSource = undefined;
	            sourceMapDir = undefined;
	            sourceMapSourceIndex = undefined;
	            lastRecordedSourceMapSpan = undefined;
	            lastEncodedSourceMapSpan = undefined;
	            lastEncodedNameIndex = undefined;
	            sourceMapData = undefined;
	            sourceMapDataList = undefined;
	        }
	        // Encoding for sourcemap span
	        function encodeLastRecordedSourceMapSpan() {
	            if (!lastRecordedSourceMapSpan || lastRecordedSourceMapSpan === lastEncodedSourceMapSpan) {
	                return;
	            }
	            var prevEncodedEmittedColumn = lastEncodedSourceMapSpan.emittedColumn;
	            // Line/Comma delimiters
	            if (lastEncodedSourceMapSpan.emittedLine === lastRecordedSourceMapSpan.emittedLine) {
	                // Emit comma to separate the entry
	                if (sourceMapData.sourceMapMappings) {
	                    sourceMapData.sourceMapMappings += ",";
	                }
	            }
	            else {
	                // Emit line delimiters
	                for (var encodedLine = lastEncodedSourceMapSpan.emittedLine; encodedLine < lastRecordedSourceMapSpan.emittedLine; encodedLine++) {
	                    sourceMapData.sourceMapMappings += ";";
	                }
	                prevEncodedEmittedColumn = 1;
	            }
	            // 1. Relative Column 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.emittedColumn - prevEncodedEmittedColumn);
	            // 2. Relative sourceIndex
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceIndex - lastEncodedSourceMapSpan.sourceIndex);
	            // 3. Relative sourceLine 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceLine - lastEncodedSourceMapSpan.sourceLine);
	            // 4. Relative sourceColumn 0 based
	            sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.sourceColumn - lastEncodedSourceMapSpan.sourceColumn);
	            // 5. Relative namePosition 0 based
	            if (lastRecordedSourceMapSpan.nameIndex >= 0) {
	                ts.Debug.assert(false, "We do not support name index right now, Make sure to update updateLastEncodedAndRecordedSpans when we start using this");
	                sourceMapData.sourceMapMappings += base64VLQFormatEncode(lastRecordedSourceMapSpan.nameIndex - lastEncodedNameIndex);
	                lastEncodedNameIndex = lastRecordedSourceMapSpan.nameIndex;
	            }
	            lastEncodedSourceMapSpan = lastRecordedSourceMapSpan;
	            sourceMapData.sourceMapDecodedMappings.push(lastEncodedSourceMapSpan);
	        }
	        /**
	         * Emits a mapping.
	         *
	         * If the position is synthetic (undefined or a negative value), no mapping will be
	         * created.
	         *
	         * @param pos The position.
	         */
	        function emitPos(pos) {
	            if (disabled || ts.positionIsSynthesized(pos) || isJsonSourceMapSource(currentSource)) {
	                return;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beforeSourcemap");
	            }
	            var sourceLinePos = ts.getLineAndCharacterOfPosition(currentSource, pos);
	            // Convert the location to be one-based.
	            sourceLinePos.line++;
	            sourceLinePos.character++;
	            var emittedLine = writer.getLine();
	            var emittedColumn = writer.getColumn();
	            // If this location wasn't recorded or the location in source is going backwards, record the span
	            if (!lastRecordedSourceMapSpan ||
	                lastRecordedSourceMapSpan.emittedLine !== emittedLine ||
	                lastRecordedSourceMapSpan.emittedColumn !== emittedColumn ||
	                (lastRecordedSourceMapSpan.sourceIndex === sourceMapSourceIndex &&
	                    (lastRecordedSourceMapSpan.sourceLine > sourceLinePos.line ||
	                        (lastRecordedSourceMapSpan.sourceLine === sourceLinePos.line && lastRecordedSourceMapSpan.sourceColumn > sourceLinePos.character)))) {
	                // Encode the last recordedSpan before assigning new
	                encodeLastRecordedSourceMapSpan();
	                // New span
	                lastRecordedSourceMapSpan = {
	                    emittedLine: emittedLine,
	                    emittedColumn: emittedColumn,
	                    sourceLine: sourceLinePos.line,
	                    sourceColumn: sourceLinePos.character,
	                    sourceIndex: sourceMapSourceIndex
	                };
	            }
	            else {
	                // Take the new pos instead since there is no change in emittedLine and column since last location
	                lastRecordedSourceMapSpan.sourceLine = sourceLinePos.line;
	                lastRecordedSourceMapSpan.sourceColumn = sourceLinePos.character;
	                lastRecordedSourceMapSpan.sourceIndex = sourceMapSourceIndex;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("afterSourcemap");
	                ts.performance.measure("Source Map", "beforeSourcemap", "afterSourcemap");
	            }
	        }
	        /**
	         * Emits a node with possible leading and trailing source maps.
	         *
	         * @param hint A hint as to the intended usage of the node.
	         * @param node The node to emit.
	         * @param emitCallback The callback used to emit the node.
	         */
	        function emitNodeWithSourceMap(hint, node, emitCallback) {
	            if (disabled || ts.isInJsonFile(node)) {
	                return emitCallback(hint, node);
	            }
	            if (node) {
	                var emitNode = node.emitNode;
	                var emitFlags = emitNode && emitNode.flags;
	                var range = emitNode && emitNode.sourceMapRange;
	                var _a = range || node, pos = _a.pos, end = _a.end;
	                var source = range && range.source;
	                var oldSource = currentSource;
	                if (source === oldSource)
	                    source = undefined;
	                if (source)
	                    setSourceFile(source);
	                if (node.kind !== 299 /* NotEmittedStatement */
	                    && (emitFlags & 16 /* NoLeadingSourceMap */) === 0
	                    && pos >= 0) {
	                    emitPos(skipSourceTrivia(pos));
	                }
	                if (source)
	                    setSourceFile(oldSource);
	                if (emitFlags & 64 /* NoNestedSourceMaps */) {
	                    disabled = true;
	                    emitCallback(hint, node);
	                    disabled = false;
	                }
	                else {
	                    emitCallback(hint, node);
	                }
	                if (source)
	                    setSourceFile(source);
	                if (node.kind !== 299 /* NotEmittedStatement */
	                    && (emitFlags & 32 /* NoTrailingSourceMap */) === 0
	                    && end >= 0) {
	                    emitPos(end);
	                }
	                if (source)
	                    setSourceFile(oldSource);
	            }
	        }
	        /**
	         * Emits a token of a node with possible leading and trailing source maps.
	         *
	         * @param node The node containing the token.
	         * @param token The token to emit.
	         * @param tokenStartPos The start pos of the token.
	         * @param emitCallback The callback used to emit the token.
	         */
	        function emitTokenWithSourceMap(node, token, writer, tokenPos, emitCallback) {
	            if (disabled || ts.isInJsonFile(node)) {
	                return emitCallback(token, writer, tokenPos);
	            }
	            var emitNode = node && node.emitNode;
	            var emitFlags = emitNode && emitNode.flags;
	            var range = emitNode && emitNode.tokenSourceMapRanges && emitNode.tokenSourceMapRanges[token];
	            tokenPos = skipSourceTrivia(range ? range.pos : tokenPos);
	            if ((emitFlags & 128 /* NoTokenLeadingSourceMaps */) === 0 && tokenPos >= 0) {
	                emitPos(tokenPos);
	            }
	            tokenPos = emitCallback(token, writer, tokenPos);
	            if (range)
	                tokenPos = range.end;
	            if ((emitFlags & 256 /* NoTokenTrailingSourceMaps */) === 0 && tokenPos >= 0) {
	                emitPos(tokenPos);
	            }
	            return tokenPos;
	        }
	        function isJsonSourceMapSource(sourceFile) {
	            return ts.fileExtensionIs(sourceFile.fileName, ".json" /* Json */);
	        }
	        /**
	         * Set the current source file.
	         *
	         * @param sourceFile The source file.
	         */
	        function setSourceFile(sourceFile) {
	            if (disabled) {
	                return;
	            }
	            currentSource = sourceFile;
	            currentSourceText = currentSource.text;
	            if (isJsonSourceMapSource(sourceFile)) {
	                return;
	            }
	            // Add the file to tsFilePaths
	            // If sourceroot option: Use the relative path corresponding to the common directory path
	            // otherwise source locations relative to map file location
	            var sourcesDirectoryPath = compilerOptions.sourceRoot ? host.getCommonSourceDirectory() : sourceMapDir;
	            var source = ts.getRelativePathToDirectoryOrUrl(sourcesDirectoryPath, currentSource.fileName, host.getCurrentDirectory(), host.getCanonicalFileName, 
	            /*isAbsolutePathAnUrl*/ true);
	            sourceMapSourceIndex = sourceMapData.sourceMapSources.indexOf(source);
	            if (sourceMapSourceIndex === -1) {
	                sourceMapSourceIndex = sourceMapData.sourceMapSources.length;
	                sourceMapData.sourceMapSources.push(source);
	                // The one that can be used from program to get the actual source file
	                sourceMapData.inputSourceFileNames.push(currentSource.fileName);
	                if (compilerOptions.inlineSources) {
	                    sourceMapData.sourceMapSourcesContent.push(currentSource.text);
	                }
	            }
	        }
	        /**
	         * Gets the text for the source map.
	         */
	        function getText() {
	            if (disabled || isJsonSourceMapSource(currentSource)) {
	                return;
	            }
	            encodeLastRecordedSourceMapSpan();
	            return JSON.stringify({
	                version: 3,
	                file: sourceMapData.sourceMapFile,
	                sourceRoot: sourceMapData.sourceMapSourceRoot,
	                sources: sourceMapData.sourceMapSources,
	                names: sourceMapData.sourceMapNames,
	                mappings: sourceMapData.sourceMapMappings,
	                sourcesContent: sourceMapData.sourceMapSourcesContent,
	            });
	        }
	        /**
	         * Gets the SourceMappingURL for the source map.
	         */
	        function getSourceMappingURL() {
	            if (disabled || isJsonSourceMapSource(currentSource)) {
	                return;
	            }
	            if (compilerOptions.inlineSourceMap) {
	                // Encode the sourceMap into the sourceMap url
	                var base64SourceMapText = ts.base64encode(ts.sys, getText());
	                return sourceMapData.jsSourceMappingURL = "data:application/json;base64," + base64SourceMapText;
	            }
	            else {
	                return sourceMapData.jsSourceMappingURL;
	            }
	        }
	    }
	    ts.createSourceMapWriter = createSourceMapWriter;
	    var base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	    function base64FormatEncode(inValue) {
	        if (inValue < 64) {
	            return base64Chars.charAt(inValue);
	        }
	        throw TypeError(inValue + ": not a 64 based value");
	    }
	    function base64VLQFormatEncode(inValue) {
	        // Add a new least significant bit that has the sign of the value.
	        // if negative number the least significant bit that gets added to the number has value 1
	        // else least significant bit value that gets added is 0
	        // eg. -1 changes to binary : 01 [1] => 3
	        //     +1 changes to binary : 01 [0] => 2
	        if (inValue < 0) {
	            inValue = ((-inValue) << 1) + 1;
	        }
	        else {
	            inValue = inValue << 1;
	        }
	        // Encode 5 bits at a time starting from least significant bits
	        var encodedStr = "";
	        do {
	            var currentDigit = inValue & 31; // 11111
	            inValue = inValue >> 5;
	            if (inValue > 0) {
	                // There are still more digits to decode, set the msb (6th bit)
	                currentDigit = currentDigit | 32;
	            }
	            encodedStr = encodedStr + base64FormatEncode(currentDigit);
	        } while (inValue > 0);
	        return encodedStr;
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function createCommentWriter(printerOptions, emitPos) {
	        var extendedDiagnostics = printerOptions.extendedDiagnostics;
	        var newLine = ts.getNewLineCharacter(printerOptions);
	        var writer;
	        var containerPos = -1;
	        var containerEnd = -1;
	        var declarationListContainerEnd = -1;
	        var currentSourceFile;
	        var currentText;
	        var currentLineMap;
	        var detachedCommentsInfo;
	        var hasWrittenComment = false;
	        var disabled = printerOptions.removeComments;
	        return {
	            reset: reset,
	            setWriter: setWriter,
	            setSourceFile: setSourceFile,
	            emitNodeWithComments: emitNodeWithComments,
	            emitBodyWithDetachedComments: emitBodyWithDetachedComments,
	            emitTrailingCommentsOfPosition: emitTrailingCommentsOfPosition,
	            emitLeadingCommentsOfPosition: emitLeadingCommentsOfPosition,
	        };
	        function emitNodeWithComments(hint, node, emitCallback) {
	            if (disabled) {
	                emitCallback(hint, node);
	                return;
	            }
	            if (node) {
	                hasWrittenComment = false;
	                var emitNode = node.emitNode;
	                var emitFlags = emitNode && emitNode.flags;
	                var _a = emitNode && emitNode.commentRange || node, pos = _a.pos, end = _a.end;
	                if ((pos < 0 && end < 0) || (pos === end)) {
	                    // Both pos and end are synthesized, so just emit the node without comments.
	                    emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback);
	                }
	                else {
	                    if (extendedDiagnostics) {
	                        ts.performance.mark("preEmitNodeWithComment");
	                    }
	                    var isEmittedNode = node.kind !== 299 /* NotEmittedStatement */;
	                    // We have to explicitly check that the node is JsxText because if the compilerOptions.jsx is "preserve" we will not do any transformation.
	                    // It is expensive to walk entire tree just to set one kind of node to have no comments.
	                    var skipLeadingComments = pos < 0 || (emitFlags & 512 /* NoLeadingComments */) !== 0 || node.kind === 10 /* JsxText */;
	                    var skipTrailingComments = end < 0 || (emitFlags & 1024 /* NoTrailingComments */) !== 0 || node.kind === 10 /* JsxText */;
	                    // Emit leading comments if the position is not synthesized and the node
	                    // has not opted out from emitting leading comments.
	                    if (!skipLeadingComments) {
	                        emitLeadingComments(pos, isEmittedNode);
	                    }
	                    // Save current container state on the stack.
	                    var savedContainerPos = containerPos;
	                    var savedContainerEnd = containerEnd;
	                    var savedDeclarationListContainerEnd = declarationListContainerEnd;
	                    if (!skipLeadingComments) {
	                        containerPos = pos;
	                    }
	                    if (!skipTrailingComments) {
	                        containerEnd = end;
	                        // To avoid invalid comment emit in a down-level binding pattern, we
	                        // keep track of the last declaration list container's end
	                        if (node.kind === 232 /* VariableDeclarationList */) {
	                            declarationListContainerEnd = end;
	                        }
	                    }
	                    if (extendedDiagnostics) {
	                        ts.performance.measure("commentTime", "preEmitNodeWithComment");
	                    }
	                    emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback);
	                    if (extendedDiagnostics) {
	                        ts.performance.mark("postEmitNodeWithComment");
	                    }
	                    // Restore previous container state.
	                    containerPos = savedContainerPos;
	                    containerEnd = savedContainerEnd;
	                    declarationListContainerEnd = savedDeclarationListContainerEnd;
	                    // Emit trailing comments if the position is not synthesized and the node
	                    // has not opted out from emitting leading comments and is an emitted node.
	                    if (!skipTrailingComments && isEmittedNode) {
	                        emitTrailingComments(end);
	                    }
	                    if (extendedDiagnostics) {
	                        ts.performance.measure("commentTime", "postEmitNodeWithComment");
	                    }
	                }
	            }
	        }
	        function emitNodeWithSynthesizedComments(hint, node, emitNode, emitFlags, emitCallback) {
	            var leadingComments = emitNode && emitNode.leadingComments;
	            if (ts.some(leadingComments)) {
	                if (extendedDiagnostics) {
	                    ts.performance.mark("preEmitNodeWithSynthesizedComments");
	                }
	                ts.forEach(leadingComments, emitLeadingSynthesizedComment);
	                if (extendedDiagnostics) {
	                    ts.performance.measure("commentTime", "preEmitNodeWithSynthesizedComments");
	                }
	            }
	            emitNodeWithNestedComments(hint, node, emitFlags, emitCallback);
	            var trailingComments = emitNode && emitNode.trailingComments;
	            if (ts.some(trailingComments)) {
	                if (extendedDiagnostics) {
	                    ts.performance.mark("postEmitNodeWithSynthesizedComments");
	                }
	                ts.forEach(trailingComments, emitTrailingSynthesizedComment);
	                if (extendedDiagnostics) {
	                    ts.performance.measure("commentTime", "postEmitNodeWithSynthesizedComments");
	                }
	            }
	        }
	        function emitLeadingSynthesizedComment(comment) {
	            if (comment.kind === 2 /* SingleLineCommentTrivia */) {
	                writer.writeLine();
	            }
	            writeSynthesizedComment(comment);
	            if (comment.hasTrailingNewLine || comment.kind === 2 /* SingleLineCommentTrivia */) {
	                writer.writeLine();
	            }
	            else {
	                writer.write(" ");
	            }
	        }
	        function emitTrailingSynthesizedComment(comment) {
	            if (!writer.isAtStartOfLine()) {
	                writer.write(" ");
	            }
	            writeSynthesizedComment(comment);
	            if (comment.hasTrailingNewLine) {
	                writer.writeLine();
	            }
	        }
	        function writeSynthesizedComment(comment) {
	            var text = formatSynthesizedComment(comment);
	            var lineMap = comment.kind === 3 /* MultiLineCommentTrivia */ ? ts.computeLineStarts(text) : undefined;
	            ts.writeCommentRange(text, lineMap, writer, 0, text.length, newLine);
	        }
	        function formatSynthesizedComment(comment) {
	            return comment.kind === 3 /* MultiLineCommentTrivia */
	                ? "/*" + comment.text + "*/"
	                : "//" + comment.text;
	        }
	        function emitNodeWithNestedComments(hint, node, emitFlags, emitCallback) {
	            if (emitFlags & 2048 /* NoNestedComments */) {
	                disabled = true;
	                emitCallback(hint, node);
	                disabled = false;
	            }
	            else {
	                emitCallback(hint, node);
	            }
	        }
	        function emitBodyWithDetachedComments(node, detachedRange, emitCallback) {
	            if (extendedDiagnostics) {
	                ts.performance.mark("preEmitBodyWithDetachedComments");
	            }
	            var pos = detachedRange.pos, end = detachedRange.end;
	            var emitFlags = ts.getEmitFlags(node);
	            var skipLeadingComments = pos < 0 || (emitFlags & 512 /* NoLeadingComments */) !== 0;
	            var skipTrailingComments = disabled || end < 0 || (emitFlags & 1024 /* NoTrailingComments */) !== 0;
	            if (!skipLeadingComments) {
	                emitDetachedCommentsAndUpdateCommentsInfo(detachedRange);
	            }
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "preEmitBodyWithDetachedComments");
	            }
	            if (emitFlags & 2048 /* NoNestedComments */ && !disabled) {
	                disabled = true;
	                emitCallback(node);
	                disabled = false;
	            }
	            else {
	                emitCallback(node);
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beginEmitBodyWithDetachedCommetns");
	            }
	            if (!skipTrailingComments) {
	                emitLeadingComments(detachedRange.end, /*isEmittedNode*/ true);
	                if (hasWrittenComment && !writer.isAtStartOfLine()) {
	                    writer.writeLine();
	                }
	            }
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "beginEmitBodyWithDetachedCommetns");
	            }
	        }
	        function emitLeadingComments(pos, isEmittedNode) {
	            hasWrittenComment = false;
	            if (isEmittedNode) {
	                forEachLeadingCommentToEmit(pos, emitLeadingComment);
	            }
	            else if (pos === 0) {
	                // If the node will not be emitted in JS, remove all the comments(normal, pinned and ///) associated with the node,
	                // unless it is a triple slash comment at the top of the file.
	                // For Example:
	                //      /// <reference-path ...>
	                //      declare var x;
	                //      /// <reference-path ...>
	                //      interface F {}
	                //  The first /// will NOT be removed while the second one will be removed even though both node will not be emitted
	                forEachLeadingCommentToEmit(pos, emitTripleSlashLeadingComment);
	            }
	        }
	        function emitTripleSlashLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
	            if (isTripleSlashComment(commentPos, commentEnd)) {
	                emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos);
	            }
	        }
	        function shouldWriteComment(text, pos) {
	            if (printerOptions.onlyPrintJsDocStyle) {
	                return (ts.isJSDocLikeText(text, pos) || ts.isPinnedComment(text, pos));
	            }
	            return true;
	        }
	        function emitLeadingComment(commentPos, commentEnd, kind, hasTrailingNewLine, rangePos) {
	            if (!shouldWriteComment(currentText, commentPos))
	                return;
	            if (!hasWrittenComment) {
	                ts.emitNewLineBeforeLeadingCommentOfPosition(currentLineMap, writer, rangePos, commentPos);
	                hasWrittenComment = true;
	            }
	            // Leading comments are emitted at /*leading comment1 */space/*leading comment*/space
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	            else if (kind === 3 /* MultiLineCommentTrivia */) {
	                writer.write(" ");
	            }
	        }
	        function emitLeadingCommentsOfPosition(pos) {
	            if (disabled || pos === -1) {
	                return;
	            }
	            emitLeadingComments(pos, /*isEmittedNode*/ true);
	        }
	        function emitTrailingComments(pos) {
	            forEachTrailingCommentToEmit(pos, emitTrailingComment);
	        }
	        function emitTrailingComment(commentPos, commentEnd, _kind, hasTrailingNewLine) {
	            if (!shouldWriteComment(currentText, commentPos))
	                return;
	            // trailing comments are emitted at space/*trailing comment1 */space/*trailing comment2*/
	            if (!writer.isAtStartOfLine()) {
	                writer.write(" ");
	            }
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	        }
	        function emitTrailingCommentsOfPosition(pos, prefixSpace) {
	            if (disabled) {
	                return;
	            }
	            if (extendedDiagnostics) {
	                ts.performance.mark("beforeEmitTrailingCommentsOfPosition");
	            }
	            forEachTrailingCommentToEmit(pos, prefixSpace ? emitTrailingComment : emitTrailingCommentOfPosition);
	            if (extendedDiagnostics) {
	                ts.performance.measure("commentTime", "beforeEmitTrailingCommentsOfPosition");
	            }
	        }
	        function emitTrailingCommentOfPosition(commentPos, commentEnd, _kind, hasTrailingNewLine) {
	            // trailing comments of a position are emitted at /*trailing comment1 */space/*trailing comment*/space
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(currentText, currentLineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	            if (hasTrailingNewLine) {
	                writer.writeLine();
	            }
	            else {
	                writer.write(" ");
	            }
	        }
	        function forEachLeadingCommentToEmit(pos, cb) {
	            // Emit the leading comments only if the container's pos doesn't match because the container should take care of emitting these comments
	            if (containerPos === -1 || pos !== containerPos) {
	                if (hasDetachedComments(pos)) {
	                    forEachLeadingCommentWithoutDetachedComments(cb);
	                }
	                else {
	                    ts.forEachLeadingCommentRange(currentText, pos, cb, /*state*/ pos);
	                }
	            }
	        }
	        function forEachTrailingCommentToEmit(end, cb) {
	            // Emit the trailing comments only if the container's end doesn't match because the container should take care of emitting these comments
	            if (containerEnd === -1 || (end !== containerEnd && end !== declarationListContainerEnd)) {
	                ts.forEachTrailingCommentRange(currentText, end, cb);
	            }
	        }
	        function reset() {
	            currentSourceFile = undefined;
	            currentText = undefined;
	            currentLineMap = undefined;
	            detachedCommentsInfo = undefined;
	        }
	        function setWriter(output) {
	            writer = output;
	        }
	        function setSourceFile(sourceFile) {
	            currentSourceFile = sourceFile;
	            currentText = currentSourceFile.text;
	            currentLineMap = ts.getLineStarts(currentSourceFile);
	            detachedCommentsInfo = undefined;
	        }
	        function hasDetachedComments(pos) {
	            return detachedCommentsInfo !== undefined && ts.lastOrUndefined(detachedCommentsInfo).nodePos === pos;
	        }
	        function forEachLeadingCommentWithoutDetachedComments(cb) {
	            // get the leading comments from detachedPos
	            var pos = ts.lastOrUndefined(detachedCommentsInfo).detachedCommentEndPos;
	            if (detachedCommentsInfo.length - 1) {
	                detachedCommentsInfo.pop();
	            }
	            else {
	                detachedCommentsInfo = undefined;
	            }
	            ts.forEachLeadingCommentRange(currentText, pos, cb, /*state*/ pos);
	        }
	        function emitDetachedCommentsAndUpdateCommentsInfo(range) {
	            var currentDetachedCommentInfo = ts.emitDetachedComments(currentText, currentLineMap, writer, writeComment, range, newLine, disabled);
	            if (currentDetachedCommentInfo) {
	                if (detachedCommentsInfo) {
	                    detachedCommentsInfo.push(currentDetachedCommentInfo);
	                }
	                else {
	                    detachedCommentsInfo = [currentDetachedCommentInfo];
	                }
	            }
	        }
	        function writeComment(text, lineMap, writer, commentPos, commentEnd, newLine) {
	            if (!shouldWriteComment(currentText, commentPos))
	                return;
	            if (emitPos)
	                emitPos(commentPos);
	            ts.writeCommentRange(text, lineMap, writer, commentPos, commentEnd, newLine);
	            if (emitPos)
	                emitPos(commentEnd);
	        }
	        /**
	         * Determine if the given comment is a triple-slash
	         *
	         * @return true if the comment is a triple-slash comment else false
	         */
	        function isTripleSlashComment(commentPos, commentEnd) {
	            return ts.isRecognizedTripleSlashComment(currentText, commentPos, commentEnd);
	        }
	    }
	    ts.createCommentWriter = createCommentWriter;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var infoExtension = ".tsbundleinfo";
	    var brackets = createBracketsMap();
	    /*@internal*/
	    /**
	     * Iterates over the source files that are expected to have an emit output.
	     *
	     * @param host An EmitHost.
	     * @param action The action to execute.
	     * @param sourceFilesOrTargetSourceFile
	     *   If an array, the full list of source files to emit.
	     *   Else, calls `getSourceFilesToEmit` with the (optional) target source file to determine the list of source files to emit.
	     */
	    function forEachEmittedFile(host, action, sourceFilesOrTargetSourceFile, emitOnlyDtsFiles) {
	        var sourceFiles = ts.isArray(sourceFilesOrTargetSourceFile) ? sourceFilesOrTargetSourceFile : ts.getSourceFilesToEmit(host, sourceFilesOrTargetSourceFile);
	        var options = host.getCompilerOptions();
	        if (options.outFile || options.out) {
	            if (sourceFiles.length) {
	                var bundle = ts.createBundle(sourceFiles, host.getPrependNodes());
	                var result = action(getOutputPathsFor(bundle, host, emitOnlyDtsFiles), bundle);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	        else {
	            for (var _a = 0, sourceFiles_1 = sourceFiles; _a < sourceFiles_1.length; _a++) {
	                var sourceFile = sourceFiles_1[_a];
	                var result = action(getOutputPathsFor(sourceFile, host, emitOnlyDtsFiles), sourceFile);
	                if (result) {
	                    return result;
	                }
	            }
	        }
	    }
	    ts.forEachEmittedFile = forEachEmittedFile;
	    /*@internal*/
	    function getOutputPathsFor(sourceFile, host, forceDtsPaths) {
	        var options = host.getCompilerOptions();
	        if (sourceFile.kind === 274 /* Bundle */) {
	            var jsFilePath = options.outFile || options.out;
	            var sourceMapFilePath = getSourceMapFilePath(jsFilePath, options);
	            var declarationFilePath = (forceDtsPaths || options.declaration) ? ts.removeFileExtension(jsFilePath) + ".d.ts" /* Dts */ : undefined;
	            var declarationMapPath = ts.getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : undefined;
	            var bundleInfoPath = options.references && jsFilePath && (ts.removeFileExtension(jsFilePath) + infoExtension);
	            return { jsFilePath: jsFilePath, sourceMapFilePath: sourceMapFilePath, declarationFilePath: declarationFilePath, declarationMapPath: declarationMapPath, bundleInfoPath: bundleInfoPath };
	        }
	        else {
	            var jsFilePath = ts.getOwnEmitOutputFilePath(sourceFile, host, getOutputExtension(sourceFile, options));
	            var sourceMapFilePath = ts.isJsonSourceFile(sourceFile) ? undefined : getSourceMapFilePath(jsFilePath, options);
	            // For legacy reasons (ie, we have baselines capturing the behavior), js files don't report a .d.ts output path - this would only matter if `declaration` and `allowJs` were both on, which is currently an error
	            var isJs = ts.isSourceFileJavaScript(sourceFile);
	            var declarationFilePath = ((forceDtsPaths || options.declaration) && !isJs) ? ts.getDeclarationEmitOutputFilePath(sourceFile, host) : undefined;
	            var declarationMapPath = ts.getAreDeclarationMapsEnabled(options) ? declarationFilePath + ".map" : undefined;
	            return { jsFilePath: jsFilePath, sourceMapFilePath: sourceMapFilePath, declarationFilePath: declarationFilePath, declarationMapPath: declarationMapPath, bundleInfoPath: undefined };
	        }
	    }
	    ts.getOutputPathsFor = getOutputPathsFor;
	    function getSourceMapFilePath(jsFilePath, options) {
	        return (options.sourceMap && !options.inlineSourceMap) ? jsFilePath + ".map" : undefined;
	    }
	    function createDefaultBundleInfo() {
	        return {
	            originalOffset: -1,
	            totalLength: -1
	        };
	    }
	    // JavaScript files are always LanguageVariant.JSX, as JSX syntax is allowed in .js files also.
	    // So for JavaScript files, '.jsx' is only emitted if the input was '.jsx', and JsxEmit.Preserve.
	    // For TypeScript, the only time to emit with a '.jsx' extension, is on JSX input, and JsxEmit.Preserve
	    /* @internal */
	    function getOutputExtension(sourceFile, options) {
	        if (ts.isJsonSourceFile(sourceFile)) {
	            return ".json" /* Json */;
	        }
	        if (options.jsx === 1 /* Preserve */) {
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                if (ts.fileExtensionIs(sourceFile.fileName, ".jsx" /* Jsx */)) {
	                    return ".jsx" /* Jsx */;
	                }
	            }
	            else if (sourceFile.languageVariant === 1 /* JSX */) {
	                // TypeScript source file preserving JSX syntax
	                return ".jsx" /* Jsx */;
	            }
	        }
	        return ".js" /* Js */;
	    }
	    ts.getOutputExtension = getOutputExtension;
	    /*@internal*/
	    // targetSourceFile is when users only want one file in entire project to be emitted. This is used in compileOnSave feature
	    function emitFiles(resolver, host, targetSourceFile, emitOnlyDtsFiles, transformers, declarationTransformers) {
	        var compilerOptions = host.getCompilerOptions();
	        var sourceMapDataList = (compilerOptions.sourceMap || compilerOptions.inlineSourceMap || ts.getAreDeclarationMapsEnabled(compilerOptions)) ? [] : undefined;
	        var emittedFilesList = compilerOptions.listEmittedFiles ? [] : undefined;
	        var emitterDiagnostics = ts.createDiagnosticCollection();
	        var newLine = host.getNewLine();
	        var writer = ts.createTextWriter(newLine);
	        var sourceMap = ts.createSourceMapWriter(host, writer);
	        var declarationSourceMap = ts.createSourceMapWriter(host, writer, {
	            sourceMap: compilerOptions.declarationMap,
	            sourceRoot: compilerOptions.sourceRoot,
	            mapRoot: compilerOptions.mapRoot,
	            extendedDiagnostics: compilerOptions.extendedDiagnostics,
	        });
	        var bundleInfo = createDefaultBundleInfo();
	        var emitSkipped = false;
	        // Emit each output file
	        ts.performance.mark("beforePrint");
	        forEachEmittedFile(host, emitSourceFileOrBundle, ts.getSourceFilesToEmit(host, targetSourceFile), emitOnlyDtsFiles);
	        ts.performance.measure("printTime", "beforePrint");
	        return {
	            emitSkipped: emitSkipped,
	            diagnostics: emitterDiagnostics.getDiagnostics(),
	            emittedFiles: emittedFilesList,
	            sourceMaps: sourceMapDataList
	        };
	        function emitSourceFileOrBundle(_a, sourceFileOrBundle) {
	            var jsFilePath = _a.jsFilePath, sourceMapFilePath = _a.sourceMapFilePath, declarationFilePath = _a.declarationFilePath, declarationMapPath = _a.declarationMapPath, bundleInfoPath = _a.bundleInfoPath;
	            emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath, bundleInfoPath);
	            emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath);
	            if (!emitSkipped && emittedFilesList) {
	                if (!emitOnlyDtsFiles) {
	                    emittedFilesList.push(jsFilePath);
	                }
	                if (sourceMapFilePath) {
	                    emittedFilesList.push(sourceMapFilePath);
	                }
	                if (declarationFilePath) {
	                    emittedFilesList.push(declarationFilePath);
	                }
	                if (bundleInfoPath) {
	                    emittedFilesList.push(bundleInfoPath);
	                }
	            }
	        }
	        function emitJsFileOrBundle(sourceFileOrBundle, jsFilePath, sourceMapFilePath, bundleInfoPath) {
	            // Make sure not to write js file and source map file if any of them cannot be written
	            if (host.isEmitBlocked(jsFilePath) || compilerOptions.noEmit || compilerOptions.emitDeclarationOnly) {
	                emitSkipped = true;
	                return;
	            }
	            if (emitOnlyDtsFiles) {
	                return;
	            }
	            // Transform the source files
	            var transform = ts.transformNodes(resolver, host, compilerOptions, [sourceFileOrBundle], transformers, /*allowDtsFiles*/ false);
	            // Create a printer to print the nodes
	            var printer = createPrinter(__assign({}, compilerOptions, { noEmitHelpers: compilerOptions.noEmitHelpers }), {
	                // resolver hooks
	                hasGlobalName: resolver.hasGlobalName,
	                // transform hooks
	                onEmitNode: transform.emitNodeWithNotification,
	                substituteNode: transform.substituteNode,
	                // sourcemap hooks
	                onEmitSourceMapOfNode: sourceMap.emitNodeWithSourceMap,
	                onEmitSourceMapOfToken: sourceMap.emitTokenWithSourceMap,
	                onEmitSourceMapOfPosition: sourceMap.emitPos,
	                // emitter hooks
	                onSetSourceFile: setSourceFile,
	            });
	            ts.Debug.assert(transform.transformed.length === 1, "Should only see one output from the transform");
	            printSourceFileOrBundle(jsFilePath, sourceMapFilePath, transform.transformed[0], bundleInfoPath, printer, sourceMap);
	            // Clean up emit nodes on parse tree
	            transform.dispose();
	        }
	        function emitDeclarationFileOrBundle(sourceFileOrBundle, declarationFilePath, declarationMapPath) {
	            if (!(declarationFilePath && !ts.isInJavaScriptFile(sourceFileOrBundle))) {
	                return;
	            }
	            var sourceFiles = ts.isSourceFile(sourceFileOrBundle) ? [sourceFileOrBundle] : sourceFileOrBundle.sourceFiles;
	            // Setup and perform the transformation to retrieve declarations from the input files
	            var nonJsFiles = ts.filter(sourceFiles, ts.isSourceFileNotJavaScript);
	            var inputListOrBundle = (compilerOptions.outFile || compilerOptions.out) ? [ts.createBundle(nonJsFiles, !ts.isSourceFile(sourceFileOrBundle) ? sourceFileOrBundle.prepends : undefined)] : nonJsFiles;
	            var declarationTransform = ts.transformNodes(resolver, host, compilerOptions, inputListOrBundle, ts.concatenate([ts.transformDeclarations], declarationTransformers), /*allowDtsFiles*/ false);
	            if (ts.length(declarationTransform.diagnostics)) {
	                for (var _a = 0, _b = declarationTransform.diagnostics; _a < _b.length; _a++) {
	                    var diagnostic = _b[_a];
	                    emitterDiagnostics.add(diagnostic);
	                }
	            }
	            var declarationPrinter = createPrinter(__assign({}, compilerOptions, { onlyPrintJsDocStyle: true, noEmitHelpers: true }), {
	                // resolver hooks
	                hasGlobalName: resolver.hasGlobalName,
	                // sourcemap hooks
	                onEmitSourceMapOfNode: declarationSourceMap.emitNodeWithSourceMap,
	                onEmitSourceMapOfToken: declarationSourceMap.emitTokenWithSourceMap,
	                onEmitSourceMapOfPosition: declarationSourceMap.emitPos,
	                onSetSourceFile: setSourceFileForDeclarationSourceMaps,
	                // transform hooks
	                onEmitNode: declarationTransform.emitNodeWithNotification,
	                substituteNode: declarationTransform.substituteNode,
	            });
	            var declBlocked = (!!declarationTransform.diagnostics && !!declarationTransform.diagnostics.length) || !!host.isEmitBlocked(declarationFilePath) || !!compilerOptions.noEmit;
	            emitSkipped = emitSkipped || declBlocked;
	            if (!declBlocked || emitOnlyDtsFiles) {
	                ts.Debug.assert(declarationTransform.transformed.length === 1, "Should only see one output from the decl transform");
	                printSourceFileOrBundle(declarationFilePath, declarationMapPath, declarationTransform.transformed[0], /* bundleInfopath*/ undefined, declarationPrinter, declarationSourceMap);
	            }
	            declarationTransform.dispose();
	        }
	        function printSourceFileOrBundle(jsFilePath, sourceMapFilePath, sourceFileOrBundle, bundleInfoPath, printer, mapRecorder) {
	            var bundle = sourceFileOrBundle.kind === 274 /* Bundle */ ? sourceFileOrBundle : undefined;
	            var sourceFile = sourceFileOrBundle.kind === 273 /* SourceFile */ ? sourceFileOrBundle : undefined;
	            var sourceFiles = bundle ? bundle.sourceFiles : [sourceFile];
	            mapRecorder.initialize(jsFilePath, sourceMapFilePath || "", sourceFileOrBundle, sourceMapDataList);
	            if (bundle) {
	                printer.writeBundle(bundle, writer, bundleInfo);
	            }
	            else {
	                printer.writeFile(sourceFile, writer);
	            }
	            writer.writeLine();
	            var sourceMappingURL = mapRecorder.getSourceMappingURL();
	            if (sourceMappingURL) {
	                writer.write("//# " + "sourceMappingURL" + "=" + sourceMappingURL); // Sometimes tools can sometimes see this line as a source mapping url comment
	            }
	            // Write the source map
	            if (sourceMapFilePath) {
	                ts.writeFile(host, emitterDiagnostics, sourceMapFilePath, mapRecorder.getText(), /*writeByteOrderMark*/ false, sourceFiles);
	            }
	            // Write the output file
	            ts.writeFile(host, emitterDiagnostics, jsFilePath, writer.getText(), compilerOptions.emitBOM, sourceFiles);
	            // Write bundled offset information if applicable
	            if (bundleInfoPath) {
	                bundleInfo.totalLength = writer.getTextPos();
	                ts.writeFile(host, emitterDiagnostics, bundleInfoPath, JSON.stringify(bundleInfo, undefined, 2), /*writeByteOrderMark*/ false);
	            }
	            // Reset state
	            mapRecorder.reset();
	            writer.clear();
	            bundleInfo = createDefaultBundleInfo();
	        }
	        function setSourceFile(node) {
	            sourceMap.setSourceFile(node);
	        }
	        function setSourceFileForDeclarationSourceMaps(node) {
	            declarationSourceMap.setSourceFile(node);
	        }
	    }
	    ts.emitFiles = emitFiles;
	    var PipelinePhase;
	    (function (PipelinePhase) {
	        PipelinePhase[PipelinePhase["Notification"] = 0] = "Notification";
	        PipelinePhase[PipelinePhase["Comments"] = 1] = "Comments";
	        PipelinePhase[PipelinePhase["SourceMaps"] = 2] = "SourceMaps";
	        PipelinePhase[PipelinePhase["Emit"] = 3] = "Emit";
	    })(PipelinePhase || (PipelinePhase = {}));
	    function createPrinter(printerOptions, handlers) {
	        if (printerOptions === void 0) { printerOptions = {}; }
	        if (handlers === void 0) { handlers = {}; }
	        var hasGlobalName = handlers.hasGlobalName, onEmitSourceMapOfNode = handlers.onEmitSourceMapOfNode, onEmitSourceMapOfToken = handlers.onEmitSourceMapOfToken, onEmitSourceMapOfPosition = handlers.onEmitSourceMapOfPosition, onEmitNode = handlers.onEmitNode, onSetSourceFile = handlers.onSetSourceFile, substituteNode = handlers.substituteNode, onBeforeEmitNodeArray = handlers.onBeforeEmitNodeArray, onAfterEmitNodeArray = handlers.onAfterEmitNodeArray, onBeforeEmitToken = handlers.onBeforeEmitToken, onAfterEmitToken = handlers.onAfterEmitToken;
	        var newLine = ts.getNewLineCharacter(printerOptions);
	        var comments = ts.createCommentWriter(printerOptions, onEmitSourceMapOfPosition);
	        var emitNodeWithComments = comments.emitNodeWithComments, emitBodyWithDetachedComments = comments.emitBodyWithDetachedComments, emitTrailingCommentsOfPosition = comments.emitTrailingCommentsOfPosition, emitLeadingCommentsOfPosition = comments.emitLeadingCommentsOfPosition;
	        var currentSourceFile;
	        var nodeIdToGeneratedName; // Map of generated names for specific nodes.
	        var autoGeneratedIdToGeneratedName; // Map of generated names for temp and loop variables.
	        var generatedNames; // Set of names generated by the NameGenerator.
	        var tempFlagsStack; // Stack of enclosing name generation scopes.
	        var tempFlags; // TempFlags for the current name generation scope.
	        var reservedNamesStack; // Stack of TempFlags reserved in enclosing name generation scopes.
	        var reservedNames; // TempFlags to reserve in nested name generation scopes.
	        var writer;
	        var ownWriter;
	        var write = writeBase;
	        var commitPendingSemicolon = ts.noop;
	        var writeSemicolon = writeSemicolonInternal;
	        var pendingSemicolon = false;
	        if (printerOptions.omitTrailingSemicolon) {
	            commitPendingSemicolon = commitPendingSemicolonInternal;
	            writeSemicolon = deferWriteSemicolon;
	        }
	        var syntheticParent = { pos: -1, end: -1 };
	        var moduleKind = ts.getEmitModuleKind(printerOptions);
	        var bundledHelpers = ts.createMap();
	        var isOwnFileEmit;
	        reset();
	        return {
	            // public API
	            printNode: printNode,
	            printList: printList,
	            printFile: printFile,
	            printBundle: printBundle,
	            // internal API
	            writeNode: writeNode,
	            writeList: writeList,
	            writeFile: writeFile,
	            writeBundle: writeBundle
	        };
	        function printNode(hint, node, sourceFile) {
	            switch (hint) {
	                case 0 /* SourceFile */:
	                    ts.Debug.assert(ts.isSourceFile(node), "Expected a SourceFile node.");
	                    break;
	                case 2 /* IdentifierName */:
	                    ts.Debug.assert(ts.isIdentifier(node), "Expected an Identifier node.");
	                    break;
	                case 1 /* Expression */:
	                    ts.Debug.assert(ts.isExpression(node), "Expected an Expression node.");
	                    break;
	            }
	            switch (node.kind) {
	                case 273 /* SourceFile */: return printFile(node);
	                case 274 /* Bundle */: return printBundle(node);
	                case 275 /* UnparsedSource */: return printUnparsedSource(node);
	            }
	            writeNode(hint, node, sourceFile, beginPrint());
	            return endPrint();
	        }
	        function printList(format, nodes, sourceFile) {
	            writeList(format, nodes, sourceFile, beginPrint());
	            return endPrint();
	        }
	        function printBundle(bundle) {
	            writeBundle(bundle, beginPrint());
	            return endPrint();
	        }
	        function printFile(sourceFile) {
	            writeFile(sourceFile, beginPrint());
	            return endPrint();
	        }
	        function printUnparsedSource(unparsed) {
	            writeUnparsedSource(unparsed, beginPrint());
	            return endPrint();
	        }
	        function writeNode(hint, node, sourceFile, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            print(hint, node, sourceFile);
	            reset();
	            writer = previousWriter;
	        }
	        function writeList(format, nodes, sourceFile, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            if (sourceFile) {
	                setSourceFile(sourceFile);
	            }
	            emitList(syntheticParent, nodes, format);
	            reset();
	            writer = previousWriter;
	        }
	        function writeBundle(bundle, output, bundleInfo) {
	            isOwnFileEmit = false;
	            var previousWriter = writer;
	            setWriter(output);
	            emitShebangIfNeeded(bundle);
	            emitPrologueDirectivesIfNeeded(bundle);
	            emitHelpers(bundle);
	            emitSyntheticTripleSlashReferencesIfNeeded(bundle);
	            for (var _a = 0, _b = bundle.prepends; _a < _b.length; _a++) {
	                var prepend = _b[_a];
	                print(4 /* Unspecified */, prepend, /*sourceFile*/ undefined);
	                writeLine();
	            }
	            if (bundleInfo) {
	                bundleInfo.originalOffset = writer.getTextPos();
	            }
	            for (var _c = 0, _d = bundle.sourceFiles; _c < _d.length; _c++) {
	                var sourceFile = _d[_c];
	                print(0 /* SourceFile */, sourceFile, sourceFile);
	            }
	            reset();
	            writer = previousWriter;
	        }
	        function writeUnparsedSource(unparsed, output) {
	            var previousWriter = writer;
	            setWriter(output);
	            print(4 /* Unspecified */, unparsed, /*sourceFile*/ undefined);
	            reset();
	            writer = previousWriter;
	        }
	        function writeFile(sourceFile, output) {
	            isOwnFileEmit = true;
	            var previousWriter = writer;
	            setWriter(output);
	            emitShebangIfNeeded(sourceFile);
	            emitPrologueDirectivesIfNeeded(sourceFile);
	            print(0 /* SourceFile */, sourceFile, sourceFile);
	            reset();
	            writer = previousWriter;
	        }
	        function beginPrint() {
	            return ownWriter || (ownWriter = ts.createTextWriter(newLine));
	        }
	        function endPrint() {
	            var text = ownWriter.getText();
	            ownWriter.clear();
	            return text;
	        }
	        function print(hint, node, sourceFile) {
	            if (sourceFile) {
	                setSourceFile(sourceFile);
	            }
	            var pipelinePhase = getPipelinePhase(0 /* Notification */, hint);
	            pipelinePhase(hint, node);
	        }
	        function setSourceFile(sourceFile) {
	            currentSourceFile = sourceFile;
	            comments.setSourceFile(sourceFile);
	            if (onSetSourceFile) {
	                onSetSourceFile(sourceFile);
	            }
	        }
	        function setWriter(output) {
	            writer = output;
	            comments.setWriter(output);
	        }
	        function reset() {
	            nodeIdToGeneratedName = [];
	            autoGeneratedIdToGeneratedName = [];
	            generatedNames = ts.createMap();
	            tempFlagsStack = [];
	            tempFlags = 0 /* Auto */;
	            reservedNamesStack = [];
	            comments.reset();
	            setWriter(/*output*/ undefined);
	        }
	        function emit(node) {
	            if (!node)
	                return;
	            var pipelinePhase = getPipelinePhase(0 /* Notification */, 4 /* Unspecified */);
	            pipelinePhase(4 /* Unspecified */, node);
	        }
	        function emitIdentifierName(node) {
	            if (!node)
	                return;
	            var pipelinePhase = getPipelinePhase(0 /* Notification */, 2 /* IdentifierName */);
	            pipelinePhase(2 /* IdentifierName */, node);
	        }
	        function emitExpression(node) {
	            if (!node)
	                return;
	            var pipelinePhase = getPipelinePhase(0 /* Notification */, 1 /* Expression */);
	            pipelinePhase(1 /* Expression */, node);
	        }
	        function getPipelinePhase(phase, hint) {
	            switch (phase) {
	                case 0 /* Notification */:
	                    if (onEmitNode) {
	                        return pipelineEmitWithNotification;
	                    }
	                // falls through
	                case 1 /* Comments */:
	                    if (emitNodeWithComments && hint !== 0 /* SourceFile */) {
	                        return pipelineEmitWithComments;
	                    }
	                    return pipelineEmitWithoutComments;
	                case 2 /* SourceMaps */:
	                    if (onEmitSourceMapOfNode && hint !== 0 /* SourceFile */ && hint !== 2 /* IdentifierName */) {
	                        return pipelineEmitWithSourceMap;
	                    }
	                // falls through
	                case 3 /* Emit */:
	                    return pipelineEmitWithHint;
	                default:
	                    return ts.Debug.assertNever(phase, "Unexpected value for PipelinePhase: " + phase);
	            }
	        }
	        function getNextPipelinePhase(currentPhase, hint) {
	            return getPipelinePhase(currentPhase + 1, hint);
	        }
	        function pipelineEmitWithNotification(hint, node) {
	            ts.Debug.assertDefined(onEmitNode);
	            onEmitNode(hint, node, getNextPipelinePhase(0 /* Notification */, hint));
	        }
	        function pipelineEmitWithComments(hint, node) {
	            ts.Debug.assertDefined(emitNodeWithComments);
	            ts.Debug.assert(hint !== 0 /* SourceFile */);
	            emitNodeWithComments(hint, trySubstituteNode(hint, node), getNextPipelinePhase(1 /* Comments */, hint));
	        }
	        function pipelineEmitWithoutComments(hint, node) {
	            var pipelinePhase = getNextPipelinePhase(1 /* Comments */, hint);
	            pipelinePhase(hint, trySubstituteNode(hint, node));
	        }
	        function pipelineEmitWithSourceMap(hint, node) {
	            ts.Debug.assertDefined(onEmitSourceMapOfNode);
	            ts.Debug.assert(hint !== 0 /* SourceFile */ && hint !== 2 /* IdentifierName */);
	            onEmitSourceMapOfNode(hint, node, pipelineEmitWithHint);
	        }
	        function pipelineEmitWithHint(hint, node) {
	            if (hint === 0 /* SourceFile */)
	                return emitSourceFile(ts.cast(node, ts.isSourceFile));
	            if (hint === 2 /* IdentifierName */)
	                return emitIdentifier(ts.cast(node, ts.isIdentifier));
	            if (hint === 3 /* MappedTypeParameter */)
	                return emitMappedTypeParameter(ts.cast(node, ts.isTypeParameterDeclaration));
	            if (hint === 4 /* Unspecified */) {
	                if (ts.isKeyword(node.kind))
	                    return writeTokenNode(node, writeKeyword);
	                switch (node.kind) {
	                    // Pseudo-literals
	                    case 14 /* TemplateHead */:
	                    case 15 /* TemplateMiddle */:
	                    case 16 /* TemplateTail */:
	                        return emitLiteral(node);
	                    case 275 /* UnparsedSource */:
	                        return emitUnparsedSource(node);
	                    // Identifiers
	                    case 71 /* Identifier */:
	                        return emitIdentifier(node);
	                    // Parse tree nodes
	                    // Names
	                    case 145 /* QualifiedName */:
	                        return emitQualifiedName(node);
	                    case 146 /* ComputedPropertyName */:
	                        return emitComputedPropertyName(node);
	                    // Signature elements
	                    case 147 /* TypeParameter */:
	                        return emitTypeParameter(node);
	                    case 148 /* Parameter */:
	                        return emitParameter(node);
	                    case 149 /* Decorator */:
	                        return emitDecorator(node);
	                    // Type members
	                    case 150 /* PropertySignature */:
	                        return emitPropertySignature(node);
	                    case 151 /* PropertyDeclaration */:
	                        return emitPropertyDeclaration(node);
	                    case 152 /* MethodSignature */:
	                        return emitMethodSignature(node);
	                    case 153 /* MethodDeclaration */:
	                        return emitMethodDeclaration(node);
	                    case 154 /* Constructor */:
	                        return emitConstructor(node);
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return emitAccessorDeclaration(node);
	                    case 157 /* CallSignature */:
	                        return emitCallSignature(node);
	                    case 158 /* ConstructSignature */:
	                        return emitConstructSignature(node);
	                    case 159 /* IndexSignature */:
	                        return emitIndexSignature(node);
	                    // Types
	                    case 160 /* TypePredicate */:
	                        return emitTypePredicate(node);
	                    case 161 /* TypeReference */:
	                        return emitTypeReference(node);
	                    case 162 /* FunctionType */:
	                        return emitFunctionType(node);
	                    case 283 /* JSDocFunctionType */:
	                        return emitJSDocFunctionType(node);
	                    case 163 /* ConstructorType */:
	                        return emitConstructorType(node);
	                    case 164 /* TypeQuery */:
	                        return emitTypeQuery(node);
	                    case 165 /* TypeLiteral */:
	                        return emitTypeLiteral(node);
	                    case 166 /* ArrayType */:
	                        return emitArrayType(node);
	                    case 167 /* TupleType */:
	                        return emitTupleType(node);
	                    case 168 /* UnionType */:
	                        return emitUnionType(node);
	                    case 169 /* IntersectionType */:
	                        return emitIntersectionType(node);
	                    case 170 /* ConditionalType */:
	                        return emitConditionalType(node);
	                    case 171 /* InferType */:
	                        return emitInferType(node);
	                    case 172 /* ParenthesizedType */:
	                        return emitParenthesizedType(node);
	                    case 206 /* ExpressionWithTypeArguments */:
	                        return emitExpressionWithTypeArguments(node);
	                    case 173 /* ThisType */:
	                        return emitThisType();
	                    case 174 /* TypeOperator */:
	                        return emitTypeOperator(node);
	                    case 175 /* IndexedAccessType */:
	                        return emitIndexedAccessType(node);
	                    case 176 /* MappedType */:
	                        return emitMappedType(node);
	                    case 177 /* LiteralType */:
	                        return emitLiteralType(node);
	                    case 178 /* ImportType */:
	                        return emitImportTypeNode(node);
	                    case 278 /* JSDocAllType */:
	                        write("*");
	                        return;
	                    case 279 /* JSDocUnknownType */:
	                        write("?");
	                        return;
	                    case 280 /* JSDocNullableType */:
	                        return emitJSDocNullableType(node);
	                    case 281 /* JSDocNonNullableType */:
	                        return emitJSDocNonNullableType(node);
	                    case 282 /* JSDocOptionalType */:
	                        return emitJSDocOptionalType(node);
	                    case 284 /* JSDocVariadicType */:
	                        return emitJSDocVariadicType(node);
	                    // Binding patterns
	                    case 179 /* ObjectBindingPattern */:
	                        return emitObjectBindingPattern(node);
	                    case 180 /* ArrayBindingPattern */:
	                        return emitArrayBindingPattern(node);
	                    case 181 /* BindingElement */:
	                        return emitBindingElement(node);
	                    // Misc
	                    case 210 /* TemplateSpan */:
	                        return emitTemplateSpan(node);
	                    case 211 /* SemicolonClassElement */:
	                        return emitSemicolonClassElement();
	                    // Statements
	                    case 212 /* Block */:
	                        return emitBlock(node);
	                    case 213 /* VariableStatement */:
	                        return emitVariableStatement(node);
	                    case 214 /* EmptyStatement */:
	                        return emitEmptyStatement();
	                    case 215 /* ExpressionStatement */:
	                        return emitExpressionStatement(node);
	                    case 216 /* IfStatement */:
	                        return emitIfStatement(node);
	                    case 217 /* DoStatement */:
	                        return emitDoStatement(node);
	                    case 218 /* WhileStatement */:
	                        return emitWhileStatement(node);
	                    case 219 /* ForStatement */:
	                        return emitForStatement(node);
	                    case 220 /* ForInStatement */:
	                        return emitForInStatement(node);
	                    case 221 /* ForOfStatement */:
	                        return emitForOfStatement(node);
	                    case 222 /* ContinueStatement */:
	                        return emitContinueStatement(node);
	                    case 223 /* BreakStatement */:
	                        return emitBreakStatement(node);
	                    case 224 /* ReturnStatement */:
	                        return emitReturnStatement(node);
	                    case 225 /* WithStatement */:
	                        return emitWithStatement(node);
	                    case 226 /* SwitchStatement */:
	                        return emitSwitchStatement(node);
	                    case 227 /* LabeledStatement */:
	                        return emitLabeledStatement(node);
	                    case 228 /* ThrowStatement */:
	                        return emitThrowStatement(node);
	                    case 229 /* TryStatement */:
	                        return emitTryStatement(node);
	                    case 230 /* DebuggerStatement */:
	                        return emitDebuggerStatement(node);
	                    // Declarations
	                    case 231 /* VariableDeclaration */:
	                        return emitVariableDeclaration(node);
	                    case 232 /* VariableDeclarationList */:
	                        return emitVariableDeclarationList(node);
	                    case 233 /* FunctionDeclaration */:
	                        return emitFunctionDeclaration(node);
	                    case 234 /* ClassDeclaration */:
	                        return emitClassDeclaration(node);
	                    case 235 /* InterfaceDeclaration */:
	                        return emitInterfaceDeclaration(node);
	                    case 236 /* TypeAliasDeclaration */:
	                        return emitTypeAliasDeclaration(node);
	                    case 237 /* EnumDeclaration */:
	                        return emitEnumDeclaration(node);
	                    case 238 /* ModuleDeclaration */:
	                        return emitModuleDeclaration(node);
	                    case 239 /* ModuleBlock */:
	                        return emitModuleBlock(node);
	                    case 240 /* CaseBlock */:
	                        return emitCaseBlock(node);
	                    case 241 /* NamespaceExportDeclaration */:
	                        return emitNamespaceExportDeclaration(node);
	                    case 242 /* ImportEqualsDeclaration */:
	                        return emitImportEqualsDeclaration(node);
	                    case 243 /* ImportDeclaration */:
	                        return emitImportDeclaration(node);
	                    case 244 /* ImportClause */:
	                        return emitImportClause(node);
	                    case 245 /* NamespaceImport */:
	                        return emitNamespaceImport(node);
	                    case 246 /* NamedImports */:
	                        return emitNamedImports(node);
	                    case 247 /* ImportSpecifier */:
	                        return emitImportSpecifier(node);
	                    case 248 /* ExportAssignment */:
	                        return emitExportAssignment(node);
	                    case 249 /* ExportDeclaration */:
	                        return emitExportDeclaration(node);
	                    case 250 /* NamedExports */:
	                        return emitNamedExports(node);
	                    case 251 /* ExportSpecifier */:
	                        return emitExportSpecifier(node);
	                    case 252 /* MissingDeclaration */:
	                        return;
	                    // Module references
	                    case 253 /* ExternalModuleReference */:
	                        return emitExternalModuleReference(node);
	                    // JSX (non-expression)
	                    case 10 /* JsxText */:
	                        return emitJsxText(node);
	                    case 256 /* JsxOpeningElement */:
	                    case 259 /* JsxOpeningFragment */:
	                        return emitJsxOpeningElementOrFragment(node);
	                    case 257 /* JsxClosingElement */:
	                    case 260 /* JsxClosingFragment */:
	                        return emitJsxClosingElementOrFragment(node);
	                    case 261 /* JsxAttribute */:
	                        return emitJsxAttribute(node);
	                    case 262 /* JsxAttributes */:
	                        return emitJsxAttributes(node);
	                    case 263 /* JsxSpreadAttribute */:
	                        return emitJsxSpreadAttribute(node);
	                    case 264 /* JsxExpression */:
	                        return emitJsxExpression(node);
	                    // Clauses
	                    case 265 /* CaseClause */:
	                        return emitCaseClause(node);
	                    case 266 /* DefaultClause */:
	                        return emitDefaultClause(node);
	                    case 267 /* HeritageClause */:
	                        return emitHeritageClause(node);
	                    case 268 /* CatchClause */:
	                        return emitCatchClause(node);
	                    // Property assignments
	                    case 269 /* PropertyAssignment */:
	                        return emitPropertyAssignment(node);
	                    case 270 /* ShorthandPropertyAssignment */:
	                        return emitShorthandPropertyAssignment(node);
	                    case 271 /* SpreadAssignment */:
	                        return emitSpreadAssignment(node);
	                    // Enum
	                    case 272 /* EnumMember */:
	                        return emitEnumMember(node);
	                    // JSDoc nodes (ignored)
	                    // Transformation nodes (ignored)
	                }
	                if (ts.isExpression(node)) {
	                    hint = 1 /* Expression */;
	                    node = trySubstituteNode(1 /* Expression */, node);
	                }
	                else if (ts.isToken(node)) {
	                    return writeTokenNode(node, writePunctuation);
	                }
	            }
	            if (hint === 1 /* Expression */) {
	                switch (node.kind) {
	                    // Literals
	                    case 8 /* NumericLiteral */:
	                        return emitNumericLiteral(node);
	                    case 9 /* StringLiteral */:
	                    case 12 /* RegularExpressionLiteral */:
	                    case 13 /* NoSubstitutionTemplateLiteral */:
	                        return emitLiteral(node);
	                    // Identifiers
	                    case 71 /* Identifier */:
	                        return emitIdentifier(node);
	                    // Reserved words
	                    case 86 /* FalseKeyword */:
	                    case 95 /* NullKeyword */:
	                    case 97 /* SuperKeyword */:
	                    case 101 /* TrueKeyword */:
	                    case 99 /* ThisKeyword */:
	                    case 91 /* ImportKeyword */:
	                        writeTokenNode(node, writeKeyword);
	                        return;
	                    // Expressions
	                    case 182 /* ArrayLiteralExpression */:
	                        return emitArrayLiteralExpression(node);
	                    case 183 /* ObjectLiteralExpression */:
	                        return emitObjectLiteralExpression(node);
	                    case 184 /* PropertyAccessExpression */:
	                        return emitPropertyAccessExpression(node);
	                    case 185 /* ElementAccessExpression */:
	                        return emitElementAccessExpression(node);
	                    case 186 /* CallExpression */:
	                        return emitCallExpression(node);
	                    case 187 /* NewExpression */:
	                        return emitNewExpression(node);
	                    case 188 /* TaggedTemplateExpression */:
	                        return emitTaggedTemplateExpression(node);
	                    case 189 /* TypeAssertionExpression */:
	                        return emitTypeAssertionExpression(node);
	                    case 190 /* ParenthesizedExpression */:
	                        return emitParenthesizedExpression(node);
	                    case 191 /* FunctionExpression */:
	                        return emitFunctionExpression(node);
	                    case 192 /* ArrowFunction */:
	                        return emitArrowFunction(node);
	                    case 193 /* DeleteExpression */:
	                        return emitDeleteExpression(node);
	                    case 194 /* TypeOfExpression */:
	                        return emitTypeOfExpression(node);
	                    case 195 /* VoidExpression */:
	                        return emitVoidExpression(node);
	                    case 196 /* AwaitExpression */:
	                        return emitAwaitExpression(node);
	                    case 197 /* PrefixUnaryExpression */:
	                        return emitPrefixUnaryExpression(node);
	                    case 198 /* PostfixUnaryExpression */:
	                        return emitPostfixUnaryExpression(node);
	                    case 199 /* BinaryExpression */:
	                        return emitBinaryExpression(node);
	                    case 200 /* ConditionalExpression */:
	                        return emitConditionalExpression(node);
	                    case 201 /* TemplateExpression */:
	                        return emitTemplateExpression(node);
	                    case 202 /* YieldExpression */:
	                        return emitYieldExpression(node);
	                    case 203 /* SpreadElement */:
	                        return emitSpreadExpression(node);
	                    case 204 /* ClassExpression */:
	                        return emitClassExpression(node);
	                    case 205 /* OmittedExpression */:
	                        return;
	                    case 207 /* AsExpression */:
	                        return emitAsExpression(node);
	                    case 208 /* NonNullExpression */:
	                        return emitNonNullExpression(node);
	                    case 209 /* MetaProperty */:
	                        return emitMetaProperty(node);
	                    // JSX
	                    case 254 /* JsxElement */:
	                        return emitJsxElement(node);
	                    case 255 /* JsxSelfClosingElement */:
	                        return emitJsxSelfClosingElement(node);
	                    case 258 /* JsxFragment */:
	                        return emitJsxFragment(node);
	                    // Transformation nodes
	                    case 300 /* PartiallyEmittedExpression */:
	                        return emitPartiallyEmittedExpression(node);
	                    case 301 /* CommaListExpression */:
	                        return emitCommaList(node);
	                }
	            }
	        }
	        function emitMappedTypeParameter(node) {
	            emit(node.name);
	            writeSpace();
	            writeKeyword("in");
	            writeSpace();
	            emit(node.constraint);
	        }
	        function trySubstituteNode(hint, node) {
	            return node && substituteNode && substituteNode(hint, node) || node;
	        }
	        function emitHelpers(node) {
	            var helpersEmitted = false;
	            var bundle = node.kind === 274 /* Bundle */ ? node : undefined;
	            if (bundle && moduleKind === ts.ModuleKind.None) {
	                return;
	            }
	            var numNodes = bundle ? bundle.sourceFiles.length : 1;
	            for (var i = 0; i < numNodes; i++) {
	                var currentNode = bundle ? bundle.sourceFiles[i] : node;
	                var sourceFile = ts.isSourceFile(currentNode) ? currentNode : currentSourceFile;
	                var shouldSkip = printerOptions.noEmitHelpers || ts.getExternalHelpersModuleName(sourceFile) !== undefined;
	                var shouldBundle = ts.isSourceFile(currentNode) && !isOwnFileEmit;
	                var helpers = ts.getEmitHelpers(currentNode);
	                if (helpers) {
	                    for (var _a = 0, _b = ts.stableSort(helpers, ts.compareEmitHelpers); _a < _b.length; _a++) {
	                        var helper = _b[_a];
	                        if (!helper.scoped) {
	                            // Skip the helper if it can be skipped and the noEmitHelpers compiler
	                            // option is set, or if it can be imported and the importHelpers compiler
	                            // option is set.
	                            if (shouldSkip)
	                                continue;
	                            // Skip the helper if it can be bundled but hasn't already been emitted and we
	                            // are emitting a bundled module.
	                            if (shouldBundle) {
	                                if (bundledHelpers.get(helper.name)) {
	                                    continue;
	                                }
	                                bundledHelpers.set(helper.name, true);
	                            }
	                        }
	                        else if (bundle) {
	                            // Skip the helper if it is scoped and we are emitting bundled helpers
	                            continue;
	                        }
	                        if (typeof helper.text === "string") {
	                            writeLines(helper.text);
	                        }
	                        else {
	                            writeLines(helper.text(makeFileLevelOptmiisticUniqueName));
	                        }
	                        helpersEmitted = true;
	                    }
	                }
	            }
	            return helpersEmitted;
	        }
	        //
	        // Literals/Pseudo-literals
	        //
	        // SyntaxKind.NumericLiteral
	        function emitNumericLiteral(node) {
	            emitLiteral(node);
	        }
	        // SyntaxKind.StringLiteral
	        // SyntaxKind.RegularExpressionLiteral
	        // SyntaxKind.NoSubstitutionTemplateLiteral
	        // SyntaxKind.TemplateHead
	        // SyntaxKind.TemplateMiddle
	        // SyntaxKind.TemplateTail
	        function emitLiteral(node) {
	            var text = getLiteralTextOfNode(node);
	            if ((printerOptions.sourceMap || printerOptions.inlineSourceMap)
	                && (node.kind === 9 /* StringLiteral */ || ts.isTemplateLiteralKind(node.kind))) {
	                writeLiteral(text);
	            }
	            else {
	                // Quick info expects all literals to be called with writeStringLiteral, as there's no specific type for numberLiterals
	                writeStringLiteral(text);
	            }
	        }
	        // SyntaxKind.UnparsedSource
	        function emitUnparsedSource(unparsed) {
	            write(unparsed.text);
	        }
	        //
	        // Identifiers
	        //
	        function emitIdentifier(node) {
	            var writeText = node.symbol ? writeSymbol : write;
	            writeText(getTextOfNode(node, /*includeTrivia*/ false), node.symbol);
	            emitList(node, node.typeArguments, 26896 /* TypeParameters */); // Call emitList directly since it could be an array of TypeParameterDeclarations _or_ type arguments
	        }
	        //
	        // Names
	        //
	        function emitQualifiedName(node) {
	            emitEntityName(node.left);
	            writePunctuation(".");
	            emit(node.right);
	        }
	        function emitEntityName(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        function emitComputedPropertyName(node) {
	            writePunctuation("[");
	            emitExpression(node.expression);
	            writePunctuation("]");
	        }
	        //
	        // Signature elements
	        //
	        function emitTypeParameter(node) {
	            emit(node.name);
	            if (node.constraint) {
	                writeSpace();
	                writeKeyword("extends");
	                writeSpace();
	                emit(node.constraint);
	            }
	            if (node.default) {
	                writeSpace();
	                writeOperator("=");
	                writeSpace();
	                emit(node.default);
	            }
	        }
	        function emitParameter(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.dotDotDotToken);
	            emitNodeWithWriter(node.name, writeParameter);
	            emit(node.questionToken);
	            if (node.parent && node.parent.kind === 283 /* JSDocFunctionType */ && !node.name) {
	                emit(node.type);
	            }
	            else {
	                emitTypeAnnotation(node.type);
	            }
	            // The comment position has to fallback to any present node within the parameterdeclaration because as it turns out, the parser can make parameter declarations with _just_ an initializer.
	            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name ? node.name.end : node.modifiers ? node.modifiers.end : node.decorators ? node.decorators.end : node.pos, node);
	        }
	        function emitDecorator(decorator) {
	            writePunctuation("@");
	            emitExpression(decorator.expression);
	        }
	        //
	        // Type members
	        //
	        function emitPropertySignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitNodeWithWriter(node.name, writeProperty);
	            emit(node.questionToken);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitPropertyDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.name);
	            emit(node.questionToken);
	            emit(node.exclamationToken);
	            emitTypeAnnotation(node.type);
	            emitInitializer(node.initializer, node.type ? node.type.end : node.questionToken ? node.questionToken.end : node.name.end, node);
	            writeSemicolon();
	        }
	        function emitMethodSignature(node) {
	            pushNameGenerationScope(node);
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.name);
	            emit(node.questionToken);
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	            popNameGenerationScope(node);
	        }
	        function emitMethodDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emit(node.asteriskToken);
	            emit(node.name);
	            emit(node.questionToken);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitConstructor(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("constructor");
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitAccessorDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword(node.kind === 155 /* GetAccessor */ ? "get" : "set");
	            writeSpace();
	            emit(node.name);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitCallSignature(node) {
	            pushNameGenerationScope(node);
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	            popNameGenerationScope(node);
	        }
	        function emitConstructSignature(node) {
	            pushNameGenerationScope(node);
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("new");
	            writeSpace();
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	            popNameGenerationScope(node);
	        }
	        function emitIndexSignature(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitParametersForIndexSignature(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSemicolon();
	        }
	        function emitSemicolonClassElement() {
	            writeSemicolon();
	        }
	        //
	        // Types
	        //
	        function emitTypePredicate(node) {
	            emit(node.parameterName);
	            writeSpace();
	            writeKeyword("is");
	            writeSpace();
	            emit(node.type);
	        }
	        function emitTypeReference(node) {
	            emit(node.typeName);
	            emitTypeArguments(node, node.typeArguments);
	        }
	        function emitFunctionType(node) {
	            pushNameGenerationScope(node);
	            emitTypeParameters(node, node.typeParameters);
	            emitParametersForArrow(node, node.parameters);
	            writeSpace();
	            writePunctuation("=>");
	            writeSpace();
	            emit(node.type);
	            popNameGenerationScope(node);
	        }
	        function emitJSDocFunctionType(node) {
	            write("function");
	            emitParameters(node, node.parameters);
	            write(":");
	            emit(node.type);
	        }
	        function emitJSDocNullableType(node) {
	            write("?");
	            emit(node.type);
	        }
	        function emitJSDocNonNullableType(node) {
	            write("!");
	            emit(node.type);
	        }
	        function emitJSDocOptionalType(node) {
	            emit(node.type);
	            write("=");
	        }
	        function emitConstructorType(node) {
	            pushNameGenerationScope(node);
	            writeKeyword("new");
	            writeSpace();
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            writeSpace();
	            writePunctuation("=>");
	            writeSpace();
	            emit(node.type);
	            popNameGenerationScope(node);
	        }
	        function emitTypeQuery(node) {
	            writeKeyword("typeof");
	            writeSpace();
	            emit(node.exprName);
	        }
	        function emitTypeLiteral(node) {
	            writePunctuation("{");
	            var flags = ts.getEmitFlags(node) & 1 /* SingleLine */ ? 384 /* SingleLineTypeLiteralMembers */ : 16449 /* MultiLineTypeLiteralMembers */;
	            emitList(node, node.members, flags | 262144 /* NoSpaceIfEmpty */);
	            writePunctuation("}");
	        }
	        function emitArrayType(node) {
	            emit(node.elementType);
	            writePunctuation("[");
	            writePunctuation("]");
	        }
	        function emitJSDocVariadicType(node) {
	            write("...");
	            emit(node.type);
	        }
	        function emitTupleType(node) {
	            writePunctuation("[");
	            emitList(node, node.elementTypes, 272 /* TupleTypeElements */);
	            writePunctuation("]");
	        }
	        function emitUnionType(node) {
	            emitList(node, node.types, 260 /* UnionTypeConstituents */);
	        }
	        function emitIntersectionType(node) {
	            emitList(node, node.types, 264 /* IntersectionTypeConstituents */);
	        }
	        function emitConditionalType(node) {
	            emit(node.checkType);
	            writeSpace();
	            writeKeyword("extends");
	            writeSpace();
	            emit(node.extendsType);
	            writeSpace();
	            writePunctuation("?");
	            writeSpace();
	            emit(node.trueType);
	            writeSpace();
	            writePunctuation(":");
	            writeSpace();
	            emit(node.falseType);
	        }
	        function emitInferType(node) {
	            writeKeyword("infer");
	            writeSpace();
	            emit(node.typeParameter);
	        }
	        function emitParenthesizedType(node) {
	            writePunctuation("(");
	            emit(node.type);
	            writePunctuation(")");
	        }
	        function emitThisType() {
	            writeKeyword("this");
	        }
	        function emitTypeOperator(node) {
	            writeTokenText(node.operator, writeKeyword);
	            writeSpace();
	            emit(node.type);
	        }
	        function emitIndexedAccessType(node) {
	            emit(node.objectType);
	            writePunctuation("[");
	            emit(node.indexType);
	            writePunctuation("]");
	        }
	        function emitMappedType(node) {
	            var emitFlags = ts.getEmitFlags(node);
	            writePunctuation("{");
	            if (emitFlags & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	                increaseIndent();
	            }
	            if (node.readonlyToken) {
	                emit(node.readonlyToken);
	                if (node.readonlyToken.kind !== 132 /* ReadonlyKeyword */) {
	                    writeKeyword("readonly");
	                }
	                writeSpace();
	            }
	            writePunctuation("[");
	            var pipelinePhase = getPipelinePhase(0 /* Notification */, 3 /* MappedTypeParameter */);
	            pipelinePhase(3 /* MappedTypeParameter */, node.typeParameter);
	            writePunctuation("]");
	            if (node.questionToken) {
	                emit(node.questionToken);
	                if (node.questionToken.kind !== 55 /* QuestionToken */) {
	                    writePunctuation("?");
	                }
	            }
	            writePunctuation(":");
	            writeSpace();
	            emit(node.type);
	            writeSemicolon();
	            if (emitFlags & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	                decreaseIndent();
	            }
	            writePunctuation("}");
	        }
	        function emitLiteralType(node) {
	            emitExpression(node.literal);
	        }
	        function emitImportTypeNode(node) {
	            if (node.isTypeOf) {
	                writeKeyword("typeof");
	                writeSpace();
	            }
	            writeKeyword("import");
	            writePunctuation("(");
	            emit(node.argument);
	            writePunctuation(")");
	            if (node.qualifier) {
	                writePunctuation(".");
	                emit(node.qualifier);
	            }
	            emitTypeArguments(node, node.typeArguments);
	        }
	        //
	        // Binding patterns
	        //
	        function emitObjectBindingPattern(node) {
	            writePunctuation("{");
	            emitList(node, node.elements, 262576 /* ObjectBindingPatternElements */);
	            writePunctuation("}");
	        }
	        function emitArrayBindingPattern(node) {
	            writePunctuation("[");
	            emitList(node, node.elements, 262448 /* ArrayBindingPatternElements */);
	            writePunctuation("]");
	        }
	        function emitBindingElement(node) {
	            emit(node.dotDotDotToken);
	            if (node.propertyName) {
	                emit(node.propertyName);
	                writePunctuation(":");
	                writeSpace();
	            }
	            emit(node.name);
	            emitInitializer(node.initializer, node.name.end, node);
	        }
	        //
	        // Expressions
	        //
	        function emitArrayLiteralExpression(node) {
	            var elements = node.elements;
	            var preferNewLine = node.multiLine ? 32768 /* PreferNewLine */ : 0 /* None */;
	            emitExpressionList(node, elements, 4466 /* ArrayLiteralExpressionElements */ | preferNewLine);
	        }
	        function emitObjectLiteralExpression(node) {
	            ts.forEach(node.properties, generateMemberNames);
	            var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	            if (indentedFlag) {
	                increaseIndent();
	            }
	            var preferNewLine = node.multiLine ? 32768 /* PreferNewLine */ : 0 /* None */;
	            var allowTrailingComma = currentSourceFile.languageVersion >= 1 /* ES5 */ && !ts.isJsonSourceFile(currentSourceFile) ? 32 /* AllowTrailingComma */ : 0 /* None */;
	            emitList(node, node.properties, 263122 /* ObjectLiteralExpressionProperties */ | allowTrailingComma | preferNewLine);
	            if (indentedFlag) {
	                decreaseIndent();
	            }
	        }
	        function emitPropertyAccessExpression(node) {
	            var indentBeforeDot = false;
	            var indentAfterDot = false;
	            if (!(ts.getEmitFlags(node) & 131072 /* NoIndentation */)) {
	                var dotRangeStart = node.expression.end;
	                var dotRangeEnd = ts.skipTrivia(currentSourceFile.text, node.expression.end) + 1;
	                var dotToken = ts.createToken(23 /* DotToken */);
	                dotToken.pos = dotRangeStart;
	                dotToken.end = dotRangeEnd;
	                indentBeforeDot = needsIndentation(node, node.expression, dotToken);
	                indentAfterDot = needsIndentation(node, dotToken, node.name);
	            }
	            emitExpression(node.expression);
	            increaseIndentIf(indentBeforeDot);
	            var shouldEmitDotDot = !indentBeforeDot && needsDotDotForPropertyAccess(node.expression);
	            if (shouldEmitDotDot) {
	                writePunctuation(".");
	            }
	            emitTokenWithComment(23 /* DotToken */, node.expression.end, writePunctuation, node);
	            increaseIndentIf(indentAfterDot);
	            emit(node.name);
	            decreaseIndentIf(indentBeforeDot, indentAfterDot);
	        }
	        // 1..toString is a valid property access, emit a dot after the literal
	        // Also emit a dot if expression is a integer const enum value - it will appear in generated code as numeric literal
	        function needsDotDotForPropertyAccess(expression) {
	            expression = ts.skipPartiallyEmittedExpressions(expression);
	            if (ts.isNumericLiteral(expression)) {
	                // check if numeric literal is a decimal literal that was originally written with a dot
	                var text = getLiteralTextOfNode(expression);
	                return !expression.numericLiteralFlags
	                    && !ts.stringContains(text, ts.tokenToString(23 /* DotToken */));
	            }
	            else if (ts.isPropertyAccessExpression(expression) || ts.isElementAccessExpression(expression)) {
	                // check if constant enum value is integer
	                var constantValue = ts.getConstantValue(expression);
	                // isFinite handles cases when constantValue is undefined
	                return typeof constantValue === "number" && isFinite(constantValue)
	                    && Math.floor(constantValue) === constantValue
	                    && printerOptions.removeComments;
	            }
	        }
	        function emitElementAccessExpression(node) {
	            emitExpression(node.expression);
	            emitTokenWithComment(21 /* OpenBracketToken */, node.expression.end, writePunctuation, node);
	            emitExpression(node.argumentExpression);
	            emitTokenWithComment(22 /* CloseBracketToken */, node.argumentExpression.end, writePunctuation, node);
	        }
	        function emitCallExpression(node) {
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	            emitExpressionList(node, node.arguments, 1296 /* CallExpressionArguments */);
	        }
	        function emitNewExpression(node) {
	            emitTokenWithComment(94 /* NewKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	            emitExpressionList(node, node.arguments, 9488 /* NewExpressionArguments */);
	        }
	        function emitTaggedTemplateExpression(node) {
	            emitExpression(node.tag);
	            emitTypeArguments(node, node.typeArguments);
	            writeSpace();
	            emitExpression(node.template);
	        }
	        function emitTypeAssertionExpression(node) {
	            writePunctuation("<");
	            emit(node.type);
	            writePunctuation(">");
	            emitExpression(node.expression);
	        }
	        function emitParenthesizedExpression(node) {
	            var openParenPos = emitTokenWithComment(19 /* OpenParenToken */, node.pos, writePunctuation, node);
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression ? node.expression.end : openParenPos, writePunctuation, node);
	        }
	        function emitFunctionExpression(node) {
	            generateNameIfNeeded(node.name);
	            emitFunctionDeclarationOrExpression(node);
	        }
	        function emitArrowFunction(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            emitSignatureAndBody(node, emitArrowFunctionHead);
	        }
	        function emitArrowFunctionHead(node) {
	            emitTypeParameters(node, node.typeParameters);
	            emitParametersForArrow(node, node.parameters);
	            emitTypeAnnotation(node.type);
	            writeSpace();
	            emit(node.equalsGreaterThanToken);
	        }
	        function emitDeleteExpression(node) {
	            emitTokenWithComment(80 /* DeleteKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitTypeOfExpression(node) {
	            emitTokenWithComment(103 /* TypeOfKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitVoidExpression(node) {
	            emitTokenWithComment(105 /* VoidKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitAwaitExpression(node) {
	            emitTokenWithComment(121 /* AwaitKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	        }
	        function emitPrefixUnaryExpression(node) {
	            writeTokenText(node.operator, writeOperator);
	            if (shouldEmitWhitespaceBeforeOperand(node)) {
	                writeSpace();
	            }
	            emitExpression(node.operand);
	        }
	        function shouldEmitWhitespaceBeforeOperand(node) {
	            // In some cases, we need to emit a space between the operator and the operand. One obvious case
	            // is when the operator is an identifier, like delete or typeof. We also need to do this for plus
	            // and minus expressions in certain cases. Specifically, consider the following two cases (parens
	            // are just for clarity of exposition, and not part of the source code):
	            //
	            //  (+(+1))
	            //  (+(++1))
	            //
	            // We need to emit a space in both cases. In the first case, the absence of a space will make
	            // the resulting expression a prefix increment operation. And in the second, it will make the resulting
	            // expression a prefix increment whose operand is a plus expression - (++(+x))
	            // The same is true of minus of course.
	            var operand = node.operand;
	            return operand.kind === 197 /* PrefixUnaryExpression */
	                && ((node.operator === 37 /* PlusToken */ && (operand.operator === 37 /* PlusToken */ || operand.operator === 43 /* PlusPlusToken */))
	                    || (node.operator === 38 /* MinusToken */ && (operand.operator === 38 /* MinusToken */ || operand.operator === 44 /* MinusMinusToken */)));
	        }
	        function emitPostfixUnaryExpression(node) {
	            emitExpression(node.operand);
	            writeTokenText(node.operator, writeOperator);
	        }
	        function emitBinaryExpression(node) {
	            var isCommaOperator = node.operatorToken.kind !== 26 /* CommaToken */;
	            var indentBeforeOperator = needsIndentation(node, node.left, node.operatorToken);
	            var indentAfterOperator = needsIndentation(node, node.operatorToken, node.right);
	            emitExpression(node.left);
	            increaseIndentIf(indentBeforeOperator, isCommaOperator ? " " : undefined);
	            emitLeadingCommentsOfPosition(node.operatorToken.pos);
	            writeTokenNode(node.operatorToken, writeOperator);
	            emitTrailingCommentsOfPosition(node.operatorToken.end, /*prefixSpace*/ true); // Binary operators should have a space before the comment starts
	            increaseIndentIf(indentAfterOperator, " ");
	            emitExpression(node.right);
	            decreaseIndentIf(indentBeforeOperator, indentAfterOperator);
	        }
	        function emitConditionalExpression(node) {
	            var indentBeforeQuestion = needsIndentation(node, node.condition, node.questionToken);
	            var indentAfterQuestion = needsIndentation(node, node.questionToken, node.whenTrue);
	            var indentBeforeColon = needsIndentation(node, node.whenTrue, node.colonToken);
	            var indentAfterColon = needsIndentation(node, node.colonToken, node.whenFalse);
	            emitExpression(node.condition);
	            increaseIndentIf(indentBeforeQuestion, " ");
	            emit(node.questionToken);
	            increaseIndentIf(indentAfterQuestion, " ");
	            emitExpression(node.whenTrue);
	            decreaseIndentIf(indentBeforeQuestion, indentAfterQuestion);
	            increaseIndentIf(indentBeforeColon, " ");
	            emit(node.colonToken);
	            increaseIndentIf(indentAfterColon, " ");
	            emitExpression(node.whenFalse);
	            decreaseIndentIf(indentBeforeColon, indentAfterColon);
	        }
	        function emitTemplateExpression(node) {
	            emit(node.head);
	            emitList(node, node.templateSpans, 131072 /* TemplateExpressionSpans */);
	        }
	        function emitYieldExpression(node) {
	            emitTokenWithComment(116 /* YieldKeyword */, node.pos, writeKeyword, node);
	            emit(node.asteriskToken);
	            emitExpressionWithLeadingSpace(node.expression);
	        }
	        function emitSpreadExpression(node) {
	            writePunctuation("...");
	            emitExpression(node.expression);
	        }
	        function emitClassExpression(node) {
	            generateNameIfNeeded(node.name);
	            emitClassDeclarationOrExpression(node);
	        }
	        function emitExpressionWithTypeArguments(node) {
	            emitExpression(node.expression);
	            emitTypeArguments(node, node.typeArguments);
	        }
	        function emitAsExpression(node) {
	            emitExpression(node.expression);
	            if (node.type) {
	                writeSpace();
	                writeKeyword("as");
	                writeSpace();
	                emit(node.type);
	            }
	        }
	        function emitNonNullExpression(node) {
	            emitExpression(node.expression);
	            writeOperator("!");
	        }
	        function emitMetaProperty(node) {
	            writeToken(node.keywordToken, node.pos, writePunctuation);
	            writePunctuation(".");
	            emit(node.name);
	        }
	        //
	        // Misc
	        //
	        function emitTemplateSpan(node) {
	            emitExpression(node.expression);
	            emit(node.literal);
	        }
	        //
	        // Statements
	        //
	        function emitBlock(node) {
	            emitBlockStatements(node, /*forceSingleLine*/ !node.multiLine && isEmptyBlock(node));
	        }
	        function emitBlockStatements(node, forceSingleLine) {
	            emitTokenWithComment(17 /* OpenBraceToken */, node.pos, writePunctuation, /*contextNode*/ node);
	            var format = forceSingleLine || ts.getEmitFlags(node) & 1 /* SingleLine */ ? 384 /* SingleLineBlockStatements */ : 65 /* MultiLineBlockStatements */;
	            emitList(node, node.statements, format);
	            emitTokenWithComment(18 /* CloseBraceToken */, node.statements.end, writePunctuation, /*contextNode*/ node, /*indentLeading*/ !!(format & 1 /* MultiLine */));
	        }
	        function emitVariableStatement(node) {
	            emitModifiers(node, node.modifiers);
	            emit(node.declarationList);
	            writeSemicolon();
	        }
	        function emitEmptyStatement() {
	            writeSemicolon();
	        }
	        function emitExpressionStatement(node) {
	            emitExpression(node.expression);
	            if (!ts.isJsonSourceFile(currentSourceFile)) {
	                writeSemicolon();
	            }
	        }
	        function emitIfStatement(node) {
	            var openParenPos = emitTokenWithComment(90 /* IfKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            emitEmbeddedStatement(node, node.thenStatement);
	            if (node.elseStatement) {
	                writeLineOrSpace(node);
	                emitTokenWithComment(82 /* ElseKeyword */, node.thenStatement.end, writeKeyword, node);
	                if (node.elseStatement.kind === 216 /* IfStatement */) {
	                    writeSpace();
	                    emit(node.elseStatement);
	                }
	                else {
	                    emitEmbeddedStatement(node, node.elseStatement);
	                }
	            }
	        }
	        function emitWhileClause(node, startPos) {
	            var openParenPos = emitTokenWithComment(106 /* WhileKeyword */, startPos, writeKeyword, node);
	            writeSpace();
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	        }
	        function emitDoStatement(node) {
	            emitTokenWithComment(81 /* DoKeyword */, node.pos, writeKeyword, node);
	            emitEmbeddedStatement(node, node.statement);
	            if (ts.isBlock(node.statement)) {
	                writeSpace();
	            }
	            else {
	                writeLineOrSpace(node);
	            }
	            emitWhileClause(node, node.statement.end);
	            writePunctuation(";");
	        }
	        function emitWhileStatement(node) {
	            emitWhileClause(node, node.pos);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForStatement(node) {
	            var openParenPos = emitTokenWithComment(88 /* ForKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            var pos = emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, /*contextNode*/ node);
	            emitForBinding(node.initializer);
	            pos = emitTokenWithComment(25 /* SemicolonToken */, node.initializer ? node.initializer.end : pos, writeSemicolon, node);
	            emitExpressionWithLeadingSpace(node.condition);
	            pos = emitTokenWithComment(25 /* SemicolonToken */, node.condition ? node.condition.end : pos, writeSemicolon, node);
	            emitExpressionWithLeadingSpace(node.incrementor);
	            emitTokenWithComment(20 /* CloseParenToken */, node.incrementor ? node.incrementor.end : pos, writePunctuation, node);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForInStatement(node) {
	            var openParenPos = emitTokenWithComment(88 /* ForKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitForBinding(node.initializer);
	            writeSpace();
	            emitTokenWithComment(92 /* InKeyword */, node.initializer.end, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForOfStatement(node) {
	            var openParenPos = emitTokenWithComment(88 /* ForKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitWithTrailingSpace(node.awaitModifier);
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitForBinding(node.initializer);
	            writeSpace();
	            emitTokenWithComment(144 /* OfKeyword */, node.initializer.end, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitForBinding(node) {
	            if (node !== undefined) {
	                if (node.kind === 232 /* VariableDeclarationList */) {
	                    emit(node);
	                }
	                else {
	                    emitExpression(node);
	                }
	            }
	        }
	        function emitContinueStatement(node) {
	            emitTokenWithComment(77 /* ContinueKeyword */, node.pos, writeKeyword, node);
	            emitWithLeadingSpace(node.label);
	            writeSemicolon();
	        }
	        function emitBreakStatement(node) {
	            emitTokenWithComment(72 /* BreakKeyword */, node.pos, writeKeyword, node);
	            emitWithLeadingSpace(node.label);
	            writeSemicolon();
	        }
	        function emitTokenWithComment(token, pos, writer, contextNode, indentLeading) {
	            var node = ts.getParseTreeNode(contextNode);
	            var isSimilarNode = node && node.kind === contextNode.kind;
	            var startPos = pos;
	            if (isSimilarNode) {
	                pos = ts.skipTrivia(currentSourceFile.text, pos);
	            }
	            if (emitLeadingCommentsOfPosition && isSimilarNode && contextNode.pos !== startPos) {
	                var needsIndent = indentLeading && !ts.positionsAreOnSameLine(startPos, pos, currentSourceFile);
	                if (needsIndent) {
	                    increaseIndent();
	                }
	                emitLeadingCommentsOfPosition(startPos);
	                if (needsIndent) {
	                    decreaseIndent();
	                }
	            }
	            pos = writeTokenText(token, writer, pos);
	            if (emitTrailingCommentsOfPosition && isSimilarNode && contextNode.end !== pos) {
	                emitTrailingCommentsOfPosition(pos, /*prefixSpace*/ true);
	            }
	            return pos;
	        }
	        function emitReturnStatement(node) {
	            emitTokenWithComment(96 /* ReturnKeyword */, node.pos, writeKeyword, /*contextNode*/ node);
	            emitExpressionWithLeadingSpace(node.expression);
	            writeSemicolon();
	        }
	        function emitWithStatement(node) {
	            var openParenPos = emitTokenWithComment(107 /* WithKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            emitEmbeddedStatement(node, node.statement);
	        }
	        function emitSwitchStatement(node) {
	            var openParenPos = emitTokenWithComment(98 /* SwitchKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	            emitExpression(node.expression);
	            emitTokenWithComment(20 /* CloseParenToken */, node.expression.end, writePunctuation, node);
	            writeSpace();
	            emit(node.caseBlock);
	        }
	        function emitLabeledStatement(node) {
	            emit(node.label);
	            emitTokenWithComment(56 /* ColonToken */, node.label.end, writePunctuation, node);
	            writeSpace();
	            emit(node.statement);
	        }
	        function emitThrowStatement(node) {
	            emitTokenWithComment(100 /* ThrowKeyword */, node.pos, writeKeyword, node);
	            emitExpressionWithLeadingSpace(node.expression);
	            writeSemicolon();
	        }
	        function emitTryStatement(node) {
	            emitTokenWithComment(102 /* TryKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emit(node.tryBlock);
	            if (node.catchClause) {
	                writeLineOrSpace(node);
	                emit(node.catchClause);
	            }
	            if (node.finallyBlock) {
	                writeLineOrSpace(node);
	                emitTokenWithComment(87 /* FinallyKeyword */, (node.catchClause || node.tryBlock).end, writeKeyword, node);
	                writeSpace();
	                emit(node.finallyBlock);
	            }
	        }
	        function emitDebuggerStatement(node) {
	            writeToken(78 /* DebuggerKeyword */, node.pos, writeKeyword);
	            writeSemicolon();
	        }
	        //
	        // Declarations
	        //
	        function emitVariableDeclaration(node) {
	            emit(node.name);
	            emitTypeAnnotation(node.type);
	            emitInitializer(node.initializer, node.type ? node.type.end : node.name.end, node);
	        }
	        function emitVariableDeclarationList(node) {
	            writeKeyword(ts.isLet(node) ? "let" : ts.isConst(node) ? "const" : "var");
	            writeSpace();
	            emitList(node, node.declarations, 272 /* VariableDeclarationList */);
	        }
	        function emitFunctionDeclaration(node) {
	            emitFunctionDeclarationOrExpression(node);
	        }
	        function emitFunctionDeclarationOrExpression(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("function");
	            emit(node.asteriskToken);
	            writeSpace();
	            emitIdentifierName(node.name);
	            emitSignatureAndBody(node, emitSignatureHead);
	        }
	        function emitBlockCallback(_hint, body) {
	            emitBlockFunctionBody(body);
	        }
	        function emitSignatureAndBody(node, emitSignatureHead) {
	            var body = node.body;
	            if (body) {
	                if (ts.isBlock(body)) {
	                    var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	                    if (indentedFlag) {
	                        increaseIndent();
	                    }
	                    pushNameGenerationScope(node);
	                    ts.forEach(node.parameters, generateNames);
	                    generateNames(node.body);
	                    emitSignatureHead(node);
	                    if (onEmitNode) {
	                        onEmitNode(4 /* Unspecified */, body, emitBlockCallback);
	                    }
	                    else {
	                        emitBlockFunctionBody(body);
	                    }
	                    popNameGenerationScope(node);
	                    if (indentedFlag) {
	                        decreaseIndent();
	                    }
	                }
	                else {
	                    emitSignatureHead(node);
	                    writeSpace();
	                    emitExpression(body);
	                }
	            }
	            else {
	                emitSignatureHead(node);
	                writeSemicolon();
	            }
	        }
	        function emitSignatureHead(node) {
	            emitTypeParameters(node, node.typeParameters);
	            emitParameters(node, node.parameters);
	            emitTypeAnnotation(node.type);
	        }
	        function shouldEmitBlockFunctionBodyOnSingleLine(body) {
	            // We must emit a function body as a single-line body in the following case:
	            // * The body has NodeEmitFlags.SingleLine specified.
	            // We must emit a function body as a multi-line body in the following cases:
	            // * The body is explicitly marked as multi-line.
	            // * A non-synthesized body's start and end position are on different lines.
	            // * Any statement in the body starts on a new line.
	            if (ts.getEmitFlags(body) & 1 /* SingleLine */) {
	                return true;
	            }
	            if (body.multiLine) {
	                return false;
	            }
	            if (!ts.nodeIsSynthesized(body) && !ts.rangeIsOnSingleLine(body, currentSourceFile)) {
	                return false;
	            }
	            if (shouldWriteLeadingLineTerminator(body, body.statements, 2 /* PreserveLines */)
	                || shouldWriteClosingLineTerminator(body, body.statements, 2 /* PreserveLines */)) {
	                return false;
	            }
	            var previousStatement;
	            for (var _a = 0, _b = body.statements; _a < _b.length; _a++) {
	                var statement = _b[_a];
	                if (shouldWriteSeparatingLineTerminator(previousStatement, statement, 2 /* PreserveLines */)) {
	                    return false;
	                }
	                previousStatement = statement;
	            }
	            return true;
	        }
	        function emitBlockFunctionBody(body) {
	            writeSpace();
	            writePunctuation("{");
	            increaseIndent();
	            var emitBlockFunctionBody = shouldEmitBlockFunctionBodyOnSingleLine(body)
	                ? emitBlockFunctionBodyOnSingleLine
	                : emitBlockFunctionBodyWorker;
	            if (emitBodyWithDetachedComments) {
	                emitBodyWithDetachedComments(body, body.statements, emitBlockFunctionBody);
	            }
	            else {
	                emitBlockFunctionBody(body);
	            }
	            decreaseIndent();
	            writeToken(18 /* CloseBraceToken */, body.statements.end, writePunctuation, body);
	        }
	        function emitBlockFunctionBodyOnSingleLine(body) {
	            emitBlockFunctionBodyWorker(body, /*emitBlockFunctionBodyOnSingleLine*/ true);
	        }
	        function emitBlockFunctionBodyWorker(body, emitBlockFunctionBodyOnSingleLine) {
	            // Emit all the prologue directives (like "use strict").
	            var statementOffset = emitPrologueDirectives(body.statements, /*startWithNewLine*/ true);
	            var pos = writer.getTextPos();
	            emitHelpers(body);
	            if (statementOffset === 0 && pos === writer.getTextPos() && emitBlockFunctionBodyOnSingleLine) {
	                decreaseIndent();
	                emitList(body, body.statements, 384 /* SingleLineFunctionBodyStatements */);
	                increaseIndent();
	            }
	            else {
	                emitList(body, body.statements, 1 /* MultiLineFunctionBodyStatements */, statementOffset);
	            }
	        }
	        function emitClassDeclaration(node) {
	            emitClassDeclarationOrExpression(node);
	        }
	        function emitClassDeclarationOrExpression(node) {
	            ts.forEach(node.members, generateMemberNames);
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("class");
	            if (node.name) {
	                writeSpace();
	                emitIdentifierName(node.name);
	            }
	            var indentedFlag = ts.getEmitFlags(node) & 65536 /* Indented */;
	            if (indentedFlag) {
	                increaseIndent();
	            }
	            emitTypeParameters(node, node.typeParameters);
	            emitList(node, node.heritageClauses, 0 /* ClassHeritageClauses */);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 65 /* ClassMembers */);
	            writePunctuation("}");
	            if (indentedFlag) {
	                decreaseIndent();
	            }
	        }
	        function emitInterfaceDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("interface");
	            writeSpace();
	            emit(node.name);
	            emitTypeParameters(node, node.typeParameters);
	            emitList(node, node.heritageClauses, 256 /* HeritageClauses */);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 65 /* InterfaceMembers */);
	            writePunctuation("}");
	        }
	        function emitTypeAliasDeclaration(node) {
	            emitDecorators(node, node.decorators);
	            emitModifiers(node, node.modifiers);
	            writeKeyword("type");
	            writeSpace();
	            emit(node.name);
	            emitTypeParameters(node, node.typeParameters);
	            writeSpace();
	            writePunctuation("=");
	            writeSpace();
	            emit(node.type);
	            writeSemicolon();
	        }
	        function emitEnumDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            writeKeyword("enum");
	            writeSpace();
	            emit(node.name);
	            writeSpace();
	            writePunctuation("{");
	            emitList(node, node.members, 81 /* EnumMembers */);
	            writePunctuation("}");
	        }
	        function emitModuleDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            if (~node.flags & 512 /* GlobalAugmentation */) {
	                writeKeyword(node.flags & 16 /* Namespace */ ? "namespace" : "module");
	                writeSpace();
	            }
	            emit(node.name);
	            var body = node.body;
	            if (!body)
	                return writeSemicolon();
	            while (body.kind === 238 /* ModuleDeclaration */) {
	                writePunctuation(".");
	                emit(body.name);
	                body = body.body;
	            }
	            writeSpace();
	            emit(body);
	        }
	        function emitModuleBlock(node) {
	            pushNameGenerationScope(node);
	            ts.forEach(node.statements, generateNames);
	            emitBlockStatements(node, /*forceSingleLine*/ isEmptyBlock(node));
	            popNameGenerationScope(node);
	        }
	        function emitCaseBlock(node) {
	            emitTokenWithComment(17 /* OpenBraceToken */, node.pos, writePunctuation, node);
	            emitList(node, node.clauses, 65 /* CaseBlockClauses */);
	            emitTokenWithComment(18 /* CloseBraceToken */, node.clauses.end, writePunctuation, node, /*indentLeading*/ true);
	        }
	        function emitImportEqualsDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            emitTokenWithComment(91 /* ImportKeyword */, node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
	            writeSpace();
	            emit(node.name);
	            writeSpace();
	            emitTokenWithComment(58 /* EqualsToken */, node.name.end, writePunctuation, node);
	            writeSpace();
	            emitModuleReference(node.moduleReference);
	            writeSemicolon();
	        }
	        function emitModuleReference(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        function emitImportDeclaration(node) {
	            emitModifiers(node, node.modifiers);
	            emitTokenWithComment(91 /* ImportKeyword */, node.modifiers ? node.modifiers.end : node.pos, writeKeyword, node);
	            writeSpace();
	            if (node.importClause) {
	                emit(node.importClause);
	                writeSpace();
	                emitTokenWithComment(142 /* FromKeyword */, node.importClause.end, writeKeyword, node);
	                writeSpace();
	            }
	            emitExpression(node.moduleSpecifier);
	            writeSemicolon();
	        }
	        function emitImportClause(node) {
	            emit(node.name);
	            if (node.name && node.namedBindings) {
	                emitTokenWithComment(26 /* CommaToken */, node.name.end, writePunctuation, node);
	                writeSpace();
	            }
	            emit(node.namedBindings);
	        }
	        function emitNamespaceImport(node) {
	            var asPos = emitTokenWithComment(39 /* AsteriskToken */, node.pos, writePunctuation, node);
	            writeSpace();
	            emitTokenWithComment(118 /* AsKeyword */, asPos, writeKeyword, node);
	            writeSpace();
	            emit(node.name);
	        }
	        function emitNamedImports(node) {
	            emitNamedImportsOrExports(node);
	        }
	        function emitImportSpecifier(node) {
	            emitImportOrExportSpecifier(node);
	        }
	        function emitExportAssignment(node) {
	            var nextPos = emitTokenWithComment(84 /* ExportKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            if (node.isExportEquals) {
	                emitTokenWithComment(58 /* EqualsToken */, nextPos, writeOperator, node);
	            }
	            else {
	                emitTokenWithComment(79 /* DefaultKeyword */, nextPos, writeKeyword, node);
	            }
	            writeSpace();
	            emitExpression(node.expression);
	            writeSemicolon();
	        }
	        function emitExportDeclaration(node) {
	            var nextPos = emitTokenWithComment(84 /* ExportKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            if (node.exportClause) {
	                emit(node.exportClause);
	            }
	            else {
	                nextPos = emitTokenWithComment(39 /* AsteriskToken */, nextPos, writePunctuation, node);
	            }
	            if (node.moduleSpecifier) {
	                writeSpace();
	                var fromPos = node.exportClause ? node.exportClause.end : nextPos;
	                emitTokenWithComment(142 /* FromKeyword */, fromPos, writeKeyword, node);
	                writeSpace();
	                emitExpression(node.moduleSpecifier);
	            }
	            writeSemicolon();
	        }
	        function emitNamespaceExportDeclaration(node) {
	            var nextPos = emitTokenWithComment(84 /* ExportKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            nextPos = emitTokenWithComment(118 /* AsKeyword */, nextPos, writeKeyword, node);
	            writeSpace();
	            nextPos = emitTokenWithComment(130 /* NamespaceKeyword */, nextPos, writeKeyword, node);
	            writeSpace();
	            emit(node.name);
	            writeSemicolon();
	        }
	        function emitNamedExports(node) {
	            emitNamedImportsOrExports(node);
	        }
	        function emitExportSpecifier(node) {
	            emitImportOrExportSpecifier(node);
	        }
	        function emitNamedImportsOrExports(node) {
	            writePunctuation("{");
	            emitList(node, node.elements, 262576 /* NamedImportsOrExportsElements */);
	            writePunctuation("}");
	        }
	        function emitImportOrExportSpecifier(node) {
	            if (node.propertyName) {
	                emit(node.propertyName);
	                writeSpace();
	                emitTokenWithComment(118 /* AsKeyword */, node.propertyName.end, writeKeyword, node);
	                writeSpace();
	            }
	            emit(node.name);
	        }
	        //
	        // Module references
	        //
	        function emitExternalModuleReference(node) {
	            writeKeyword("require");
	            writePunctuation("(");
	            emitExpression(node.expression);
	            writePunctuation(")");
	        }
	        //
	        // JSX
	        //
	        function emitJsxElement(node) {
	            emit(node.openingElement);
	            emitList(node, node.children, 131072 /* JsxElementOrFragmentChildren */);
	            emit(node.closingElement);
	        }
	        function emitJsxSelfClosingElement(node) {
	            writePunctuation("<");
	            emitJsxTagName(node.tagName);
	            writeSpace();
	            emit(node.attributes);
	            writePunctuation("/>");
	        }
	        function emitJsxFragment(node) {
	            emit(node.openingFragment);
	            emitList(node, node.children, 131072 /* JsxElementOrFragmentChildren */);
	            emit(node.closingFragment);
	        }
	        function emitJsxOpeningElementOrFragment(node) {
	            writePunctuation("<");
	            if (ts.isJsxOpeningElement(node)) {
	                emitJsxTagName(node.tagName);
	                if (node.attributes.properties && node.attributes.properties.length > 0) {
	                    writeSpace();
	                }
	                emit(node.attributes);
	            }
	            writePunctuation(">");
	        }
	        function emitJsxText(node) {
	            commitPendingSemicolon();
	            writer.writeLiteral(getTextOfNode(node, /*includeTrivia*/ true));
	        }
	        function emitJsxClosingElementOrFragment(node) {
	            writePunctuation("</");
	            if (ts.isJsxClosingElement(node)) {
	                emitJsxTagName(node.tagName);
	            }
	            writePunctuation(">");
	        }
	        function emitJsxAttributes(node) {
	            emitList(node, node.properties, 131328 /* JsxElementAttributes */);
	        }
	        function emitJsxAttribute(node) {
	            emit(node.name);
	            emitNodeWithPrefix("=", writePunctuation, node.initializer, emit);
	        }
	        function emitJsxSpreadAttribute(node) {
	            writePunctuation("{...");
	            emitExpression(node.expression);
	            writePunctuation("}");
	        }
	        function emitJsxExpression(node) {
	            if (node.expression) {
	                writePunctuation("{");
	                emit(node.dotDotDotToken);
	                emitExpression(node.expression);
	                writePunctuation("}");
	            }
	        }
	        function emitJsxTagName(node) {
	            if (node.kind === 71 /* Identifier */) {
	                emitExpression(node);
	            }
	            else {
	                emit(node);
	            }
	        }
	        //
	        // Clauses
	        //
	        function emitCaseClause(node) {
	            emitTokenWithComment(73 /* CaseKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            emitExpression(node.expression);
	            emitCaseOrDefaultClauseRest(node, node.statements, node.expression.end);
	        }
	        function emitDefaultClause(node) {
	            var pos = emitTokenWithComment(79 /* DefaultKeyword */, node.pos, writeKeyword, node);
	            emitCaseOrDefaultClauseRest(node, node.statements, pos);
	        }
	        function emitCaseOrDefaultClauseRest(parentNode, statements, colonPos) {
	            var emitAsSingleStatement = statements.length === 1 &&
	                (
	                // treat synthesized nodes as located on the same line for emit purposes
	                ts.nodeIsSynthesized(parentNode) ||
	                    ts.nodeIsSynthesized(statements[0]) ||
	                    ts.rangeStartPositionsAreOnSameLine(parentNode, statements[0], currentSourceFile));
	            var format = 81985 /* CaseOrDefaultClauseStatements */;
	            if (emitAsSingleStatement) {
	                writeToken(56 /* ColonToken */, colonPos, writePunctuation, parentNode);
	                writeSpace();
	                format &= ~(1 /* MultiLine */ | 64 /* Indented */);
	            }
	            else {
	                emitTokenWithComment(56 /* ColonToken */, colonPos, writePunctuation, parentNode);
	            }
	            emitList(parentNode, statements, format);
	        }
	        function emitHeritageClause(node) {
	            writeSpace();
	            writeTokenText(node.token, writeKeyword);
	            writeSpace();
	            emitList(node, node.types, 272 /* HeritageClauseTypes */);
	        }
	        function emitCatchClause(node) {
	            var openParenPos = emitTokenWithComment(74 /* CatchKeyword */, node.pos, writeKeyword, node);
	            writeSpace();
	            if (node.variableDeclaration) {
	                emitTokenWithComment(19 /* OpenParenToken */, openParenPos, writePunctuation, node);
	                emit(node.variableDeclaration);
	                emitTokenWithComment(20 /* CloseParenToken */, node.variableDeclaration.end, writePunctuation, node);
	                writeSpace();
	            }
	            emit(node.block);
	        }
	        //
	        // Property assignments
	        //
	        function emitPropertyAssignment(node) {
	            emit(node.name);
	            writePunctuation(":");
	            writeSpace();
	            // This is to ensure that we emit comment in the following case:
	            //      For example:
	            //          obj = {
	            //              id: /*comment1*/ ()=>void
	            //          }
	            // "comment1" is not considered to be leading comment for node.initializer
	            // but rather a trailing comment on the previous node.
	            var initializer = node.initializer;
	            if (emitTrailingCommentsOfPosition && (ts.getEmitFlags(initializer) & 512 /* NoLeadingComments */) === 0) {
	                var commentRange = ts.getCommentRange(initializer);
	                emitTrailingCommentsOfPosition(commentRange.pos);
	            }
	            emitExpression(initializer);
	        }
	        function emitShorthandPropertyAssignment(node) {
	            emit(node.name);
	            if (node.objectAssignmentInitializer) {
	                writeSpace();
	                writePunctuation("=");
	                writeSpace();
	                emitExpression(node.objectAssignmentInitializer);
	            }
	        }
	        function emitSpreadAssignment(node) {
	            if (node.expression) {
	                writePunctuation("...");
	                emitExpression(node.expression);
	            }
	        }
	        //
	        // Enum
	        //
	        function emitEnumMember(node) {
	            emit(node.name);
	            emitInitializer(node.initializer, node.name.end, node);
	        }
	        //
	        // Top-level nodes
	        //
	        function emitSourceFile(node) {
	            writeLine();
	            var statements = node.statements;
	            if (emitBodyWithDetachedComments) {
	                // Emit detached comment if there are no prologue directives or if the first node is synthesized.
	                // The synthesized node will have no leading comment so some comments may be missed.
	                var shouldEmitDetachedComment = statements.length === 0 ||
	                    !ts.isPrologueDirective(statements[0]) ||
	                    ts.nodeIsSynthesized(statements[0]);
	                if (shouldEmitDetachedComment) {
	                    emitBodyWithDetachedComments(node, statements, emitSourceFileWorker);
	                    return;
	                }
	            }
	            emitSourceFileWorker(node);
	        }
	        function emitSyntheticTripleSlashReferencesIfNeeded(node) {
	            emitTripleSlashDirectives(node.hasNoDefaultLib, node.syntheticFileReferences || [], node.syntheticTypeReferences || []);
	        }
	        function emitTripleSlashDirectivesIfNeeded(node) {
	            if (node.isDeclarationFile)
	                emitTripleSlashDirectives(node.hasNoDefaultLib, node.referencedFiles, node.typeReferenceDirectives);
	        }
	        function emitTripleSlashDirectives(hasNoDefaultLib, files, types) {
	            if (hasNoDefaultLib) {
	                write("/// <reference no-default-lib=\"true\"/>");
	                writeLine();
	            }
	            if (currentSourceFile && currentSourceFile.moduleName) {
	                write("/// <amd-module name=\"" + currentSourceFile.moduleName + "\" />");
	                writeLine();
	            }
	            if (currentSourceFile && currentSourceFile.amdDependencies) {
	                for (var _a = 0, _b = currentSourceFile.amdDependencies; _a < _b.length; _a++) {
	                    var dep = _b[_a];
	                    if (dep.name) {
	                        write("/// <amd-dependency name=\"" + dep.name + "\" path=\"" + dep.path + "\" />");
	                    }
	                    else {
	                        write("/// <amd-dependency path=\"" + dep.path + "\" />");
	                    }
	                    writeLine();
	                }
	            }
	            for (var _c = 0, files_1 = files; _c < files_1.length; _c++) {
	                var directive = files_1[_c];
	                write("/// <reference path=\"" + directive.fileName + "\" />");
	                writeLine();
	            }
	            for (var _d = 0, types_17 = types; _d < types_17.length; _d++) {
	                var directive = types_17[_d];
	                write("/// <reference types=\"" + directive.fileName + "\" />");
	                writeLine();
	            }
	        }
	        function emitSourceFileWorker(node) {
	            var statements = node.statements;
	            pushNameGenerationScope(node);
	            ts.forEach(node.statements, generateNames);
	            emitHelpers(node);
	            var index = ts.findIndex(statements, function (statement) { return !ts.isPrologueDirective(statement); });
	            emitTripleSlashDirectivesIfNeeded(node);
	            emitList(node, statements, 1 /* MultiLine */, index === -1 ? statements.length : index);
	            popNameGenerationScope(node);
	        }
	        // Transformation nodes
	        function emitPartiallyEmittedExpression(node) {
	            emitExpression(node.expression);
	        }
	        function emitCommaList(node) {
	            emitExpressionList(node, node.elements, 272 /* CommaListElements */);
	        }
	        /**
	         * Emits any prologue directives at the start of a Statement list, returning the
	         * number of prologue directives written to the output.
	         */
	        function emitPrologueDirectives(statements, startWithNewLine, seenPrologueDirectives) {
	            for (var i = 0; i < statements.length; i++) {
	                var statement = statements[i];
	                if (ts.isPrologueDirective(statement)) {
	                    var shouldEmitPrologueDirective = seenPrologueDirectives ? !seenPrologueDirectives.has(statement.expression.text) : true;
	                    if (shouldEmitPrologueDirective) {
	                        if (startWithNewLine || i > 0) {
	                            writeLine();
	                        }
	                        emit(statement);
	                        if (seenPrologueDirectives) {
	                            seenPrologueDirectives.set(statement.expression.text, true);
	                        }
	                    }
	                }
	                else {
	                    // return index of the first non prologue directive
	                    return i;
	                }
	            }
	            return statements.length;
	        }
	        function emitPrologueDirectivesIfNeeded(sourceFileOrBundle) {
	            if (ts.isSourceFile(sourceFileOrBundle)) {
	                setSourceFile(sourceFileOrBundle);
	                emitPrologueDirectives(sourceFileOrBundle.statements);
	            }
	            else {
	                var seenPrologueDirectives = ts.createMap();
	                for (var _a = 0, _b = sourceFileOrBundle.sourceFiles; _a < _b.length; _a++) {
	                    var sourceFile = _b[_a];
	                    setSourceFile(sourceFile);
	                    emitPrologueDirectives(sourceFile.statements, /*startWithNewLine*/ true, seenPrologueDirectives);
	                }
	            }
	        }
	        function emitShebangIfNeeded(sourceFileOrBundle) {
	            if (ts.isSourceFile(sourceFileOrBundle)) {
	                var shebang = ts.getShebang(sourceFileOrBundle.text);
	                if (shebang) {
	                    write(shebang);
	                    writeLine();
	                    return true;
	                }
	            }
	            else {
	                for (var _a = 0, _b = sourceFileOrBundle.sourceFiles; _a < _b.length; _a++) {
	                    var sourceFile = _b[_a];
	                    // Emit only the first encountered shebang
	                    if (emitShebangIfNeeded(sourceFile)) {
	                        break;
	                    }
	                }
	            }
	        }
	        //
	        // Helpers
	        //
	        function emitNodeWithWriter(node, writer) {
	            if (!node)
	                return;
	            var savedWrite = write;
	            write = writer;
	            emit(node);
	            write = savedWrite;
	        }
	        function emitModifiers(node, modifiers) {
	            if (modifiers && modifiers.length) {
	                emitList(node, modifiers, 131328 /* Modifiers */);
	                writeSpace();
	            }
	        }
	        function emitTypeAnnotation(node) {
	            if (node) {
	                writePunctuation(":");
	                writeSpace();
	                emit(node);
	            }
	        }
	        function emitInitializer(node, equalCommentStartPos, container) {
	            if (node) {
	                writeSpace();
	                emitTokenWithComment(58 /* EqualsToken */, equalCommentStartPos, writeOperator, container);
	                writeSpace();
	                emitExpression(node);
	            }
	        }
	        function emitNodeWithPrefix(prefix, prefixWriter, node, emit) {
	            if (node) {
	                prefixWriter(prefix);
	                emit(node);
	            }
	        }
	        function emitWithLeadingSpace(node) {
	            if (node) {
	                writeSpace();
	                emit(node);
	            }
	        }
	        function emitExpressionWithLeadingSpace(node) {
	            if (node) {
	                writeSpace();
	                emitExpression(node);
	            }
	        }
	        function emitWithTrailingSpace(node) {
	            if (node) {
	                emit(node);
	                writeSpace();
	            }
	        }
	        function emitEmbeddedStatement(parent, node) {
	            if (ts.isBlock(node) || ts.getEmitFlags(parent) & 1 /* SingleLine */) {
	                writeSpace();
	                emit(node);
	            }
	            else {
	                writeLine();
	                increaseIndent();
	                emit(node);
	                decreaseIndent();
	            }
	        }
	        function emitDecorators(parentNode, decorators) {
	            emitList(parentNode, decorators, 24577 /* Decorators */);
	        }
	        function emitTypeArguments(parentNode, typeArguments) {
	            emitList(parentNode, typeArguments, 26896 /* TypeArguments */);
	        }
	        function emitTypeParameters(parentNode, typeParameters) {
	            if (ts.isFunctionLike(parentNode) && parentNode.typeArguments) { // Quick info uses type arguments in place of type parameters on instantiated signatures
	                return emitTypeArguments(parentNode, parentNode.typeArguments);
	            }
	            emitList(parentNode, typeParameters, 26896 /* TypeParameters */);
	        }
	        function emitParameters(parentNode, parameters) {
	            emitList(parentNode, parameters, 1296 /* Parameters */);
	        }
	        function canEmitSimpleArrowHead(parentNode, parameters) {
	            var parameter = ts.singleOrUndefined(parameters);
	            return parameter
	                && parameter.pos === parentNode.pos // may not have parsed tokens between parent and parameter
	                && !(ts.isArrowFunction(parentNode) && parentNode.type) // arrow function may not have return type annotation
	                && !ts.some(parentNode.decorators) // parent may not have decorators
	                && !ts.some(parentNode.modifiers) // parent may not have modifiers
	                && !ts.some(parentNode.typeParameters) // parent may not have type parameters
	                && !ts.some(parameter.decorators) // parameter may not have decorators
	                && !ts.some(parameter.modifiers) // parameter may not have modifiers
	                && !parameter.dotDotDotToken // parameter may not be rest
	                && !parameter.questionToken // parameter may not be optional
	                && !parameter.type // parameter may not have a type annotation
	                && !parameter.initializer // parameter may not have an initializer
	                && ts.isIdentifier(parameter.name); // parameter name must be identifier
	        }
	        function emitParametersForArrow(parentNode, parameters) {
	            if (canEmitSimpleArrowHead(parentNode, parameters)) {
	                emitList(parentNode, parameters, 1296 /* Parameters */ & ~1024 /* Parenthesis */);
	            }
	            else {
	                emitParameters(parentNode, parameters);
	            }
	        }
	        function emitParametersForIndexSignature(parentNode, parameters) {
	            emitList(parentNode, parameters, 4432 /* IndexSignatureParameters */);
	        }
	        function emitList(parentNode, children, format, start, count) {
	            emitNodeList(emit, parentNode, children, format, start, count);
	        }
	        function emitExpressionList(parentNode, children, format, start, count) {
	            emitNodeList(emitExpression, parentNode, children, format, start, count);
	        }
	        function writeDelimiter(format) {
	            switch (format & 28 /* DelimitersMask */) {
	                case 0 /* None */:
	                    break;
	                case 16 /* CommaDelimited */:
	                    writePunctuation(",");
	                    break;
	                case 4 /* BarDelimited */:
	                    writeSpace();
	                    writePunctuation("|");
	                    break;
	                case 8 /* AmpersandDelimited */:
	                    writeSpace();
	                    writePunctuation("&");
	                    break;
	            }
	        }
	        function emitNodeList(emit, parentNode, children, format, start, count) {
	            if (start === void 0) { start = 0; }
	            if (count === void 0) { count = children ? children.length - start : 0; }
	            var isUndefined = children === undefined;
	            if (isUndefined && format & 8192 /* OptionalIfUndefined */) {
	                return;
	            }
	            var isEmpty = isUndefined || start >= children.length || count === 0;
	            if (isEmpty && format & 16384 /* OptionalIfEmpty */) {
	                if (onBeforeEmitNodeArray) {
	                    onBeforeEmitNodeArray(children);
	                }
	                if (onAfterEmitNodeArray) {
	                    onAfterEmitNodeArray(children);
	                }
	                return;
	            }
	            if (format & 7680 /* BracketsMask */) {
	                writePunctuation(getOpeningBracket(format));
	                if (isEmpty && !isUndefined) {
	                    emitTrailingCommentsOfPosition(children.pos, /*prefixSpace*/ true); // Emit comments within empty bracketed lists
	                }
	            }
	            if (onBeforeEmitNodeArray) {
	                onBeforeEmitNodeArray(children);
	            }
	            if (isEmpty) {
	                // Write a line terminator if the parent node was multi-line
	                if (format & 1 /* MultiLine */) {
	                    writeLine();
	                }
	                else if (format & 128 /* SpaceBetweenBraces */ && !(format & 262144 /* NoSpaceIfEmpty */)) {
	                    writeSpace();
	                }
	            }
	            else {
	                // Write the opening line terminator or leading whitespace.
	                var mayEmitInterveningComments = (format & 131072 /* NoInterveningComments */) === 0;
	                var shouldEmitInterveningComments = mayEmitInterveningComments;
	                if (shouldWriteLeadingLineTerminator(parentNode, children, format)) {
	                    writeLine();
	                    shouldEmitInterveningComments = false;
	                }
	                else if (format & 128 /* SpaceBetweenBraces */) {
	                    writeSpace();
	                }
	                // Increase the indent, if requested.
	                if (format & 64 /* Indented */) {
	                    increaseIndent();
	                }
	                // Emit each child.
	                var previousSibling = void 0;
	                var shouldDecreaseIndentAfterEmit = void 0;
	                for (var i = 0; i < count; i++) {
	                    var child = children[start + i];
	                    // Write the delimiter if this is not the first node.
	                    if (previousSibling) {
	                        // i.e
	                        //      function commentedParameters(
	                        //          /* Parameter a */
	                        //          a
	                        //          /* End of parameter a */ -> this comment isn't considered to be trailing comment of parameter "a" due to newline
	                        //          ,
	                        if (format & 28 /* DelimitersMask */ && previousSibling.end !== parentNode.end) {
	                            emitLeadingCommentsOfPosition(previousSibling.end);
	                        }
	                        writeDelimiter(format);
	                        // Write either a line terminator or whitespace to separate the elements.
	                        if (shouldWriteSeparatingLineTerminator(previousSibling, child, format)) {
	                            // If a synthesized node in a single-line list starts on a new
	                            // line, we should increase the indent.
	                            if ((format & (3 /* LinesMask */ | 64 /* Indented */)) === 0 /* SingleLine */) {
	                                increaseIndent();
	                                shouldDecreaseIndentAfterEmit = true;
	                            }
	                            writeLine();
	                            shouldEmitInterveningComments = false;
	                        }
	                        else if (previousSibling && format & 256 /* SpaceBetweenSiblings */) {
	                            writeSpace();
	                        }
	                    }
	                    // Emit this child.
	                    if (shouldEmitInterveningComments) {
	                        if (emitTrailingCommentsOfPosition) {
	                            var commentRange = ts.getCommentRange(child);
	                            emitTrailingCommentsOfPosition(commentRange.pos);
	                        }
	                    }
	                    else {
	                        shouldEmitInterveningComments = mayEmitInterveningComments;
	                    }
	                    emit(child);
	                    if (shouldDecreaseIndentAfterEmit) {
	                        decreaseIndent();
	                        shouldDecreaseIndentAfterEmit = false;
	                    }
	                    previousSibling = child;
	                }
	                // Write a trailing comma, if requested.
	                var hasTrailingComma = (format & 32 /* AllowTrailingComma */) && children.hasTrailingComma;
	                if (format & 16 /* CommaDelimited */ && hasTrailingComma) {
	                    writePunctuation(",");
	                }
	                // Emit any trailing comment of the last element in the list
	                // i.e
	                //       var array = [...
	                //          2
	                //          /* end of element 2 */
	                //       ];
	                if (previousSibling && format & 28 /* DelimitersMask */ && previousSibling.end !== parentNode.end && !(ts.getEmitFlags(previousSibling) & 1024 /* NoTrailingComments */)) {
	                    emitLeadingCommentsOfPosition(previousSibling.end);
	                }
	                // Decrease the indent, if requested.
	                if (format & 64 /* Indented */) {
	                    decreaseIndent();
	                }
	                // Write the closing line terminator or closing whitespace.
	                if (shouldWriteClosingLineTerminator(parentNode, children, format)) {
	                    writeLine();
	                }
	                else if (format & 128 /* SpaceBetweenBraces */) {
	                    writeSpace();
	                }
	            }
	            if (onAfterEmitNodeArray) {
	                onAfterEmitNodeArray(children);
	            }
	            if (format & 7680 /* BracketsMask */) {
	                if (isEmpty && !isUndefined) {
	                    emitLeadingCommentsOfPosition(children.end); // Emit leading comments within empty lists
	                }
	                writePunctuation(getClosingBracket(format));
	            }
	        }
	        function commitPendingSemicolonInternal() {
	            if (pendingSemicolon) {
	                writeSemicolonInternal();
	                pendingSemicolon = false;
	            }
	        }
	        function writeLiteral(s) {
	            commitPendingSemicolon();
	            writer.writeLiteral(s);
	        }
	        function writeStringLiteral(s) {
	            commitPendingSemicolon();
	            writer.writeStringLiteral(s);
	        }
	        function writeBase(s) {
	            commitPendingSemicolon();
	            writer.write(s);
	        }
	        function writeSymbol(s, sym) {
	            commitPendingSemicolon();
	            writer.writeSymbol(s, sym);
	        }
	        function writePunctuation(s) {
	            commitPendingSemicolon();
	            writer.writePunctuation(s);
	        }
	        function deferWriteSemicolon() {
	            pendingSemicolon = true;
	        }
	        function writeSemicolonInternal() {
	            writer.writePunctuation(";");
	        }
	        function writeKeyword(s) {
	            commitPendingSemicolon();
	            writer.writeKeyword(s);
	        }
	        function writeOperator(s) {
	            commitPendingSemicolon();
	            writer.writeOperator(s);
	        }
	        function writeParameter(s) {
	            commitPendingSemicolon();
	            writer.writeParameter(s);
	        }
	        function writeSpace() {
	            commitPendingSemicolon();
	            writer.writeSpace(" ");
	        }
	        function writeProperty(s) {
	            commitPendingSemicolon();
	            writer.writeProperty(s);
	        }
	        function writeLine() {
	            commitPendingSemicolon();
	            writer.writeLine();
	        }
	        function increaseIndent() {
	            commitPendingSemicolon();
	            writer.increaseIndent();
	        }
	        function decreaseIndent() {
	            commitPendingSemicolon();
	            writer.decreaseIndent();
	        }
	        function writeToken(token, pos, writer, contextNode) {
	            return onEmitSourceMapOfToken
	                ? onEmitSourceMapOfToken(contextNode, token, writer, pos, writeTokenText)
	                : writeTokenText(token, writer, pos);
	        }
	        function writeTokenNode(node, writer) {
	            if (onBeforeEmitToken) {
	                onBeforeEmitToken(node);
	            }
	            writer(ts.tokenToString(node.kind));
	            if (onAfterEmitToken) {
	                onAfterEmitToken(node);
	            }
	        }
	        function writeTokenText(token, writer, pos) {
	            var tokenString = ts.tokenToString(token);
	            writer(tokenString);
	            return pos < 0 ? pos : pos + tokenString.length;
	        }
	        function writeLineOrSpace(node) {
	            if (ts.getEmitFlags(node) & 1 /* SingleLine */) {
	                writeSpace();
	            }
	            else {
	                writeLine();
	            }
	        }
	        function writeLines(text) {
	            var lines = text.split(/\r\n?|\n/g);
	            var indentation = ts.guessIndentation(lines);
	            for (var _a = 0, lines_2 = lines; _a < lines_2.length; _a++) {
	                var lineText = lines_2[_a];
	                var line = indentation ? lineText.slice(indentation) : lineText;
	                if (line.length) {
	                    writeLine();
	                    write(line);
	                    writeLine();
	                }
	            }
	        }
	        function increaseIndentIf(value, valueToWriteWhenNotIndenting) {
	            if (value) {
	                increaseIndent();
	                writeLine();
	            }
	            else if (valueToWriteWhenNotIndenting) {
	                write(valueToWriteWhenNotIndenting);
	            }
	        }
	        // Helper function to decrease the indent if we previously indented.  Allows multiple
	        // previous indent values to be considered at a time.  This also allows caller to just
	        // call this once, passing in all their appropriate indent values, instead of needing
	        // to call this helper function multiple times.
	        function decreaseIndentIf(value1, value2) {
	            if (value1) {
	                decreaseIndent();
	            }
	            if (value2) {
	                decreaseIndent();
	            }
	        }
	        function shouldWriteLeadingLineTerminator(parentNode, children, format) {
	            if (format & 1 /* MultiLine */) {
	                return true;
	            }
	            if (format & 2 /* PreserveLines */) {
	                if (format & 32768 /* PreferNewLine */) {
	                    return true;
	                }
	                var firstChild = children[0];
	                if (firstChild === undefined) {
	                    return !ts.rangeIsOnSingleLine(parentNode, currentSourceFile);
	                }
	                else if (ts.positionIsSynthesized(parentNode.pos) || ts.nodeIsSynthesized(firstChild)) {
	                    return synthesizedNodeStartsOnNewLine(firstChild, format);
	                }
	                else {
	                    return !ts.rangeStartPositionsAreOnSameLine(parentNode, firstChild, currentSourceFile);
	                }
	            }
	            else {
	                return false;
	            }
	        }
	        function shouldWriteSeparatingLineTerminator(previousNode, nextNode, format) {
	            if (format & 1 /* MultiLine */) {
	                return true;
	            }
	            else if (format & 2 /* PreserveLines */) {
	                if (previousNode === undefined || nextNode === undefined) {
	                    return false;
	                }
	                else if (ts.nodeIsSynthesized(previousNode) || ts.nodeIsSynthesized(nextNode)) {
	                    return synthesizedNodeStartsOnNewLine(previousNode, format) || synthesizedNodeStartsOnNewLine(nextNode, format);
	                }
	                else {
	                    return !ts.rangeEndIsOnSameLineAsRangeStart(previousNode, nextNode, currentSourceFile);
	                }
	            }
	            else {
	                return ts.getStartsOnNewLine(nextNode);
	            }
	        }
	        function shouldWriteClosingLineTerminator(parentNode, children, format) {
	            if (format & 1 /* MultiLine */) {
	                return (format & 65536 /* NoTrailingNewLine */) === 0;
	            }
	            else if (format & 2 /* PreserveLines */) {
	                if (format & 32768 /* PreferNewLine */) {
	                    return true;
	                }
	                var lastChild = ts.lastOrUndefined(children);
	                if (lastChild === undefined) {
	                    return !ts.rangeIsOnSingleLine(parentNode, currentSourceFile);
	                }
	                else if (ts.positionIsSynthesized(parentNode.pos) || ts.nodeIsSynthesized(lastChild)) {
	                    return synthesizedNodeStartsOnNewLine(lastChild, format);
	                }
	                else {
	                    return !ts.rangeEndPositionsAreOnSameLine(parentNode, lastChild, currentSourceFile);
	                }
	            }
	            else {
	                return false;
	            }
	        }
	        function synthesizedNodeStartsOnNewLine(node, format) {
	            if (ts.nodeIsSynthesized(node)) {
	                var startsOnNewLine = ts.getStartsOnNewLine(node);
	                if (startsOnNewLine === undefined) {
	                    return (format & 32768 /* PreferNewLine */) !== 0;
	                }
	                return startsOnNewLine;
	            }
	            return (format & 32768 /* PreferNewLine */) !== 0;
	        }
	        function needsIndentation(parent, node1, node2) {
	            parent = skipSynthesizedParentheses(parent);
	            node1 = skipSynthesizedParentheses(node1);
	            node2 = skipSynthesizedParentheses(node2);
	            // Always use a newline for synthesized code if the synthesizer desires it.
	            if (ts.getStartsOnNewLine(node2)) {
	                return true;
	            }
	            return !ts.nodeIsSynthesized(parent)
	                && !ts.nodeIsSynthesized(node1)
	                && !ts.nodeIsSynthesized(node2)
	                && !ts.rangeEndIsOnSameLineAsRangeStart(node1, node2, currentSourceFile);
	        }
	        function isEmptyBlock(block) {
	            return block.statements.length === 0
	                && ts.rangeEndIsOnSameLineAsRangeStart(block, block, currentSourceFile);
	        }
	        function skipSynthesizedParentheses(node) {
	            while (node.kind === 190 /* ParenthesizedExpression */ && ts.nodeIsSynthesized(node)) {
	                node = node.expression;
	            }
	            return node;
	        }
	        function getTextOfNode(node, includeTrivia) {
	            if (ts.isGeneratedIdentifier(node)) {
	                return generateName(node);
	            }
	            else if (ts.isIdentifier(node) && (ts.nodeIsSynthesized(node) || !node.parent || !currentSourceFile || (node.parent && currentSourceFile && ts.getSourceFileOfNode(node) !== ts.getOriginalNode(currentSourceFile)))) {
	                return ts.idText(node);
	            }
	            else if (node.kind === 9 /* StringLiteral */ && node.textSourceNode) {
	                return getTextOfNode(node.textSourceNode, includeTrivia);
	            }
	            else if (ts.isLiteralExpression(node) && (ts.nodeIsSynthesized(node) || !node.parent)) {
	                return node.text;
	            }
	            return ts.getSourceTextOfNodeFromSourceFile(currentSourceFile, node, includeTrivia);
	        }
	        function getLiteralTextOfNode(node) {
	            if (node.kind === 9 /* StringLiteral */ && node.textSourceNode) {
	                var textSourceNode = node.textSourceNode;
	                if (ts.isIdentifier(textSourceNode)) {
	                    return ts.getEmitFlags(node) & 16777216 /* NoAsciiEscaping */ ?
	                        "\"" + ts.escapeString(getTextOfNode(textSourceNode)) + "\"" :
	                        "\"" + ts.escapeNonAsciiString(getTextOfNode(textSourceNode)) + "\"";
	                }
	                else {
	                    return getLiteralTextOfNode(textSourceNode);
	                }
	            }
	            return ts.getLiteralText(node, currentSourceFile);
	        }
	        /**
	         * Push a new name generation scope.
	         */
	        function pushNameGenerationScope(node) {
	            if (node && ts.getEmitFlags(node) & 524288 /* ReuseTempVariableScope */) {
	                return;
	            }
	            tempFlagsStack.push(tempFlags);
	            tempFlags = 0;
	            reservedNamesStack.push(reservedNames);
	        }
	        /**
	         * Pop the current name generation scope.
	         */
	        function popNameGenerationScope(node) {
	            if (node && ts.getEmitFlags(node) & 524288 /* ReuseTempVariableScope */) {
	                return;
	            }
	            tempFlags = tempFlagsStack.pop();
	            reservedNames = reservedNamesStack.pop();
	        }
	        function reserveNameInNestedScopes(name) {
	            if (!reservedNames || reservedNames === ts.lastOrUndefined(reservedNamesStack)) {
	                reservedNames = ts.createMap();
	            }
	            reservedNames.set(name, true);
	        }
	        function generateNames(node) {
	            if (!node)
	                return;
	            switch (node.kind) {
	                case 212 /* Block */:
	                    ts.forEach(node.statements, generateNames);
	                    break;
	                case 227 /* LabeledStatement */:
	                case 225 /* WithStatement */:
	                case 217 /* DoStatement */:
	                case 218 /* WhileStatement */:
	                    generateNames(node.statement);
	                    break;
	                case 216 /* IfStatement */:
	                    generateNames(node.thenStatement);
	                    generateNames(node.elseStatement);
	                    break;
	                case 219 /* ForStatement */:
	                case 221 /* ForOfStatement */:
	                case 220 /* ForInStatement */:
	                    generateNames(node.initializer);
	                    generateNames(node.statement);
	                    break;
	                case 226 /* SwitchStatement */:
	                    generateNames(node.caseBlock);
	                    break;
	                case 240 /* CaseBlock */:
	                    ts.forEach(node.clauses, generateNames);
	                    break;
	                case 265 /* CaseClause */:
	                case 266 /* DefaultClause */:
	                    ts.forEach(node.statements, generateNames);
	                    break;
	                case 229 /* TryStatement */:
	                    generateNames(node.tryBlock);
	                    generateNames(node.catchClause);
	                    generateNames(node.finallyBlock);
	                    break;
	                case 268 /* CatchClause */:
	                    generateNames(node.variableDeclaration);
	                    generateNames(node.block);
	                    break;
	                case 213 /* VariableStatement */:
	                    generateNames(node.declarationList);
	                    break;
	                case 232 /* VariableDeclarationList */:
	                    ts.forEach(node.declarations, generateNames);
	                    break;
	                case 231 /* VariableDeclaration */:
	                case 148 /* Parameter */:
	                case 181 /* BindingElement */:
	                case 234 /* ClassDeclaration */:
	                    generateNameIfNeeded(node.name);
	                    break;
	                case 233 /* FunctionDeclaration */:
	                    generateNameIfNeeded(node.name);
	                    if (ts.getEmitFlags(node) & 524288 /* ReuseTempVariableScope */) {
	                        ts.forEach(node.parameters, generateNames);
	                        generateNames(node.body);
	                    }
	                    break;
	                case 179 /* ObjectBindingPattern */:
	                case 180 /* ArrayBindingPattern */:
	                    ts.forEach(node.elements, generateNames);
	                    break;
	                case 243 /* ImportDeclaration */:
	                    generateNames(node.importClause);
	                    break;
	                case 244 /* ImportClause */:
	                    generateNameIfNeeded(node.name);
	                    generateNames(node.namedBindings);
	                    break;
	                case 245 /* NamespaceImport */:
	                    generateNameIfNeeded(node.name);
	                    break;
	                case 246 /* NamedImports */:
	                    ts.forEach(node.elements, generateNames);
	                    break;
	                case 247 /* ImportSpecifier */:
	                    generateNameIfNeeded(node.propertyName || node.name);
	                    break;
	            }
	        }
	        function generateMemberNames(node) {
	            if (!node)
	                return;
	            switch (node.kind) {
	                case 269 /* PropertyAssignment */:
	                case 270 /* ShorthandPropertyAssignment */:
	                case 151 /* PropertyDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    generateNameIfNeeded(node.name);
	                    break;
	            }
	        }
	        function generateNameIfNeeded(name) {
	            if (name) {
	                if (ts.isGeneratedIdentifier(name)) {
	                    generateName(name);
	                }
	                else if (ts.isBindingPattern(name)) {
	                    generateNames(name);
	                }
	            }
	        }
	        /**
	         * Generate the text for a generated identifier.
	         */
	        function generateName(name) {
	            if ((name.autoGenerateFlags & 7 /* KindMask */) === 4 /* Node */) {
	                // Node names generate unique names based on their original node
	                // and are cached based on that node's id.
	                return generateNameCached(getNodeForGeneratedName(name), name.autoGenerateFlags);
	            }
	            else {
	                // Auto, Loop, and Unique names are cached based on their unique
	                // autoGenerateId.
	                var autoGenerateId = name.autoGenerateId;
	                return autoGeneratedIdToGeneratedName[autoGenerateId] || (autoGeneratedIdToGeneratedName[autoGenerateId] = makeName(name));
	            }
	        }
	        function generateNameCached(node, flags) {
	            var nodeId = ts.getNodeId(node);
	            return nodeIdToGeneratedName[nodeId] || (nodeIdToGeneratedName[nodeId] = generateNameForNode(node, flags));
	        }
	        /**
	         * Returns a value indicating whether a name is unique globally, within the current file,
	         * or within the NameGenerator.
	         */
	        function isUniqueName(name) {
	            return isFileLevelUniqueName(name)
	                && !generatedNames.has(name)
	                && !(reservedNames && reservedNames.has(name));
	        }
	        /**
	         * Returns a value indicating whether a name is unique globally or within the current file.
	         */
	        function isFileLevelUniqueName(name) {
	            return currentSourceFile ? ts.isFileLevelUniqueName(currentSourceFile, name, hasGlobalName) : true;
	        }
	        /**
	         * Returns a value indicating whether a name is unique within a container.
	         */
	        function isUniqueLocalName(name, container) {
	            for (var node = container; ts.isNodeDescendantOf(node, container); node = node.nextContainer) {
	                if (node.locals) {
	                    var local = node.locals.get(ts.escapeLeadingUnderscores(name));
	                    // We conservatively include alias symbols to cover cases where they're emitted as locals
	                    if (local && local.flags & (67216319 /* Value */ | 1048576 /* ExportValue */ | 2097152 /* Alias */)) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        }
	        /**
	         * Return the next available name in the pattern _a ... _z, _0, _1, ...
	         * TempFlags._i or TempFlags._n may be used to express a preference for that dedicated name.
	         * Note that names generated by makeTempVariableName and makeUniqueName will never conflict.
	         */
	        function makeTempVariableName(flags, reservedInNestedScopes) {
	            if (flags && !(tempFlags & flags)) {
	                var name = flags === 268435456 /* _i */ ? "_i" : "_n";
	                if (isUniqueName(name)) {
	                    tempFlags |= flags;
	                    if (reservedInNestedScopes) {
	                        reserveNameInNestedScopes(name);
	                    }
	                    return name;
	                }
	            }
	            while (true) {
	                var count = tempFlags & 268435455 /* CountMask */;
	                tempFlags++;
	                // Skip over 'i' and 'n'
	                if (count !== 8 && count !== 13) {
	                    var name = count < 26
	                        ? "_" + String.fromCharCode(97 /* a */ + count)
	                        : "_" + (count - 26);
	                    if (isUniqueName(name)) {
	                        if (reservedInNestedScopes) {
	                            reserveNameInNestedScopes(name);
	                        }
	                        return name;
	                    }
	                }
	            }
	        }
	        /**
	         * Generate a name that is unique within the current file and doesn't conflict with any names
	         * in global scope. The name is formed by adding an '_n' suffix to the specified base name,
	         * where n is a positive integer. Note that names generated by makeTempVariableName and
	         * makeUniqueName are guaranteed to never conflict.
	         * If `optimistic` is set, the first instance will use 'baseName' verbatim instead of 'baseName_1'
	         */
	        function makeUniqueName(baseName, checkFn, optimistic, scoped) {
	            if (checkFn === void 0) { checkFn = isUniqueName; }
	            if (optimistic) {
	                if (checkFn(baseName)) {
	                    if (scoped) {
	                        reserveNameInNestedScopes(baseName);
	                    }
	                    else {
	                        generatedNames.set(baseName, true);
	                    }
	                    return baseName;
	                }
	            }
	            // Find the first unique 'name_n', where n is a positive number
	            if (baseName.charCodeAt(baseName.length - 1) !== 95 /* _ */) {
	                baseName += "_";
	            }
	            var i = 1;
	            while (true) {
	                var generatedName = baseName + i;
	                if (checkFn(generatedName)) {
	                    if (scoped) {
	                        reserveNameInNestedScopes(generatedName);
	                    }
	                    else {
	                        generatedNames.set(generatedName, true);
	                    }
	                    return generatedName;
	                }
	                i++;
	            }
	        }
	        function makeFileLevelOptmiisticUniqueName(name) {
	            return makeUniqueName(name, isFileLevelUniqueName, /*optimistic*/ true);
	        }
	        /**
	         * Generates a unique name for a ModuleDeclaration or EnumDeclaration.
	         */
	        function generateNameForModuleOrEnum(node) {
	            var name = getTextOfNode(node.name);
	            // Use module/enum name itself if it is unique, otherwise make a unique variation
	            return isUniqueLocalName(name, node) ? name : makeUniqueName(name);
	        }
	        /**
	         * Generates a unique name for an ImportDeclaration or ExportDeclaration.
	         */
	        function generateNameForImportOrExportDeclaration(node) {
	            var expr = ts.getExternalModuleName(node);
	            var baseName = ts.isStringLiteral(expr) ?
	                ts.makeIdentifierFromModuleName(expr.text) : "module";
	            return makeUniqueName(baseName);
	        }
	        /**
	         * Generates a unique name for a default export.
	         */
	        function generateNameForExportDefault() {
	            return makeUniqueName("default");
	        }
	        /**
	         * Generates a unique name for a class expression.
	         */
	        function generateNameForClassExpression() {
	            return makeUniqueName("class");
	        }
	        function generateNameForMethodOrAccessor(node) {
	            if (ts.isIdentifier(node.name)) {
	                return generateNameCached(node.name);
	            }
	            return makeTempVariableName(0 /* Auto */);
	        }
	        /**
	         * Generates a unique name from a node.
	         */
	        function generateNameForNode(node, flags) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                    return makeUniqueName(getTextOfNode(node), isUniqueName, !!(flags & 16 /* Optimistic */), !!(flags & 8 /* ReservedInNestedScopes */));
	                case 238 /* ModuleDeclaration */:
	                case 237 /* EnumDeclaration */:
	                    return generateNameForModuleOrEnum(node);
	                case 243 /* ImportDeclaration */:
	                case 249 /* ExportDeclaration */:
	                    return generateNameForImportOrExportDeclaration(node);
	                case 233 /* FunctionDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 248 /* ExportAssignment */:
	                    return generateNameForExportDefault();
	                case 204 /* ClassExpression */:
	                    return generateNameForClassExpression();
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return generateNameForMethodOrAccessor(node);
	                default:
	                    return makeTempVariableName(0 /* Auto */);
	            }
	        }
	        /**
	         * Generates a unique identifier for a node.
	         */
	        function makeName(name) {
	            switch (name.autoGenerateFlags & 7 /* KindMask */) {
	                case 1 /* Auto */:
	                    return makeTempVariableName(0 /* Auto */, !!(name.autoGenerateFlags & 8 /* ReservedInNestedScopes */));
	                case 2 /* Loop */:
	                    return makeTempVariableName(268435456 /* _i */, !!(name.autoGenerateFlags & 8 /* ReservedInNestedScopes */));
	                case 3 /* Unique */:
	                    return makeUniqueName(ts.idText(name), (name.autoGenerateFlags & 32 /* FileLevel */) ? isFileLevelUniqueName : isUniqueName, !!(name.autoGenerateFlags & 16 /* Optimistic */), !!(name.autoGenerateFlags & 8 /* ReservedInNestedScopes */));
	            }
	            ts.Debug.fail("Unsupported GeneratedIdentifierKind.");
	        }
	        /**
	         * Gets the node from which a name should be generated.
	         */
	        function getNodeForGeneratedName(name) {
	            var autoGenerateId = name.autoGenerateId;
	            var node = name;
	            var original = node.original;
	            while (original) {
	                node = original;
	                // if "node" is a different generated name (having a different
	                // "autoGenerateId"), use it and stop traversing.
	                if (ts.isIdentifier(node)
	                    && !!(node.autoGenerateFlags & 4 /* Node */)
	                    && node.autoGenerateId !== autoGenerateId) {
	                    break;
	                }
	                original = node.original;
	            }
	            // otherwise, return the original node for the source;
	            return node;
	        }
	    }
	    ts.createPrinter = createPrinter;
	    function createBracketsMap() {
	        var brackets = [];
	        brackets[512 /* Braces */] = ["{", "}"];
	        brackets[1024 /* Parenthesis */] = ["(", ")"];
	        brackets[2048 /* AngleBrackets */] = ["<", ">"];
	        brackets[4096 /* SquareBrackets */] = ["[", "]"];
	        return brackets;
	    }
	    function getOpeningBracket(format) {
	        return brackets[format & 7680 /* BracketsMask */][0];
	    }
	    function getClosingBracket(format) {
	        return brackets[format & 7680 /* BracketsMask */][1];
	    }
	    // Flags enum to track count of temp variables and a few dedicated names
	    var TempFlags;
	    (function (TempFlags) {
	        TempFlags[TempFlags["Auto"] = 0] = "Auto";
	        TempFlags[TempFlags["CountMask"] = 268435455] = "CountMask";
	        TempFlags[TempFlags["_i"] = 268435456] = "_i";
	    })(TempFlags || (TempFlags = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames) {
	        if (!host.getDirectories || !host.readDirectory) {
	            return undefined;
	        }
	        var cachedReadDirectoryResult = ts.createMap();
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        return {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            fileExists: fileExists,
	            readFile: function (path, encoding) { return host.readFile(path, encoding); },
	            directoryExists: host.directoryExists && directoryExists,
	            getDirectories: getDirectories,
	            readDirectory: readDirectory,
	            createDirectory: host.createDirectory && createDirectory,
	            writeFile: host.writeFile && writeFile,
	            addOrDeleteFileOrDirectory: addOrDeleteFileOrDirectory,
	            addOrDeleteFile: addOrDeleteFile,
	            clearCache: clearCache
	        };
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function getCachedFileSystemEntries(rootDirPath) {
	            return cachedReadDirectoryResult.get(ts.ensureTrailingDirectorySeparator(rootDirPath));
	        }
	        function getCachedFileSystemEntriesForBaseDir(path) {
	            return getCachedFileSystemEntries(ts.getDirectoryPath(path));
	        }
	        function getBaseNameOfFileName(fileName) {
	            return ts.getBaseFileName(ts.normalizePath(fileName));
	        }
	        function createCachedFileSystemEntries(rootDir, rootDirPath) {
	            var resultFromHost = {
	                files: ts.map(host.readDirectory(rootDir, /*extensions*/ undefined, /*exclude*/ undefined, /*include*/ ["*.*"]), getBaseNameOfFileName) || [],
	                directories: host.getDirectories(rootDir) || []
	            };
	            cachedReadDirectoryResult.set(ts.ensureTrailingDirectorySeparator(rootDirPath), resultFromHost);
	            return resultFromHost;
	        }
	        /**
	         * If the readDirectory result was already cached, it returns that
	         * Otherwise gets result from host and caches it.
	         * The host request is done under try catch block to avoid caching incorrect result
	         */
	        function tryReadDirectory(rootDir, rootDirPath) {
	            rootDirPath = ts.ensureTrailingDirectorySeparator(rootDirPath);
	            var cachedResult = getCachedFileSystemEntries(rootDirPath);
	            if (cachedResult) {
	                return cachedResult;
	            }
	            try {
	                return createCachedFileSystemEntries(rootDir, rootDirPath);
	            }
	            catch (_e) {
	                // If there is exception to read directories, dont cache the result and direct the calls to host
	                ts.Debug.assert(!cachedReadDirectoryResult.has(ts.ensureTrailingDirectorySeparator(rootDirPath)));
	                return undefined;
	            }
	        }
	        function fileNameEqual(name1, name2) {
	            return getCanonicalFileName(name1) === getCanonicalFileName(name2);
	        }
	        function hasEntry(entries, name) {
	            return ts.some(entries, function (file) { return fileNameEqual(file, name); });
	        }
	        function updateFileSystemEntry(entries, baseName, isValid) {
	            if (hasEntry(entries, baseName)) {
	                if (!isValid) {
	                    return ts.filterMutate(entries, function (entry) { return !fileNameEqual(entry, baseName); });
	                }
	            }
	            else if (isValid) {
	                return entries.push(baseName);
	            }
	        }
	        function writeFile(fileName, data, writeByteOrderMark) {
	            var path = toPath(fileName);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            if (result) {
	                updateFilesOfFileSystemEntry(result, getBaseNameOfFileName(fileName), /*fileExists*/ true);
	            }
	            return host.writeFile(fileName, data, writeByteOrderMark);
	        }
	        function fileExists(fileName) {
	            var path = toPath(fileName);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            return result && hasEntry(result.files, getBaseNameOfFileName(fileName)) ||
	                host.fileExists(fileName);
	        }
	        function directoryExists(dirPath) {
	            var path = toPath(dirPath);
	            return cachedReadDirectoryResult.has(ts.ensureTrailingDirectorySeparator(path)) || host.directoryExists(dirPath);
	        }
	        function createDirectory(dirPath) {
	            var path = toPath(dirPath);
	            var result = getCachedFileSystemEntriesForBaseDir(path);
	            var baseFileName = getBaseNameOfFileName(dirPath);
	            if (result) {
	                updateFileSystemEntry(result.directories, baseFileName, /*isValid*/ true);
	            }
	            host.createDirectory(dirPath);
	        }
	        function getDirectories(rootDir) {
	            var rootDirPath = toPath(rootDir);
	            var result = tryReadDirectory(rootDir, rootDirPath);
	            if (result) {
	                return result.directories.slice();
	            }
	            return host.getDirectories(rootDir);
	        }
	        function readDirectory(rootDir, extensions, excludes, includes, depth) {
	            var rootDirPath = toPath(rootDir);
	            var result = tryReadDirectory(rootDir, rootDirPath);
	            if (result) {
	                return ts.matchFiles(rootDir, extensions, excludes, includes, useCaseSensitiveFileNames, currentDirectory, depth, getFileSystemEntries);
	            }
	            return host.readDirectory(rootDir, extensions, excludes, includes, depth);
	            function getFileSystemEntries(dir) {
	                var path = toPath(dir);
	                if (path === rootDirPath) {
	                    return result;
	                }
	                return tryReadDirectory(dir, path) || ts.emptyFileSystemEntries;
	            }
	        }
	        function addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath) {
	            var existingResult = getCachedFileSystemEntries(fileOrDirectoryPath);
	            if (existingResult) {
	                // Just clear the cache for now
	                // For now just clear the cache, since this could mean that multiple level entries might need to be re-evaluated
	                clearCache();
	                return undefined;
	            }
	            var parentResult = getCachedFileSystemEntriesForBaseDir(fileOrDirectoryPath);
	            if (!parentResult) {
	                return undefined;
	            }
	            // This was earlier a file (hence not in cached directory contents)
	            // or we never cached the directory containing it
	            if (!host.directoryExists) {
	                // Since host doesnt support directory exists, clear the cache as otherwise it might not be same
	                clearCache();
	                return undefined;
	            }
	            var baseName = getBaseNameOfFileName(fileOrDirectory);
	            var fsQueryResult = {
	                fileExists: host.fileExists(fileOrDirectoryPath),
	                directoryExists: host.directoryExists(fileOrDirectoryPath)
	            };
	            if (fsQueryResult.directoryExists || hasEntry(parentResult.directories, baseName)) {
	                // Folder added or removed, clear the cache instead of updating the folder and its structure
	                clearCache();
	            }
	            else {
	                // No need to update the directory structure, just files
	                updateFilesOfFileSystemEntry(parentResult, baseName, fsQueryResult.fileExists);
	            }
	            return fsQueryResult;
	        }
	        function addOrDeleteFile(fileName, filePath, eventKind) {
	            if (eventKind === ts.FileWatcherEventKind.Changed) {
	                return;
	            }
	            var parentResult = getCachedFileSystemEntriesForBaseDir(filePath);
	            if (parentResult) {
	                updateFilesOfFileSystemEntry(parentResult, getBaseNameOfFileName(fileName), eventKind === ts.FileWatcherEventKind.Created);
	            }
	        }
	        function updateFilesOfFileSystemEntry(parentResult, baseName, fileExists) {
	            updateFileSystemEntry(parentResult.files, baseName, fileExists);
	        }
	        function clearCache() {
	            cachedReadDirectoryResult.clear();
	        }
	    }
	    ts.createCachedDirectoryStructureHost = createCachedDirectoryStructureHost;
	    var ConfigFileProgramReloadLevel;
	    (function (ConfigFileProgramReloadLevel) {
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["None"] = 0] = "None";
	        /** Update the file name list from the disk */
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["Partial"] = 1] = "Partial";
	        /** Reload completely by re-reading contents of config file from disk and updating program */
	        ConfigFileProgramReloadLevel[ConfigFileProgramReloadLevel["Full"] = 2] = "Full";
	    })(ConfigFileProgramReloadLevel = ts.ConfigFileProgramReloadLevel || (ts.ConfigFileProgramReloadLevel = {}));
	    /**
	     * Updates the existing missing file watches with the new set of missing files after new program is created
	     */
	    function updateMissingFilePathsWatch(program, missingFileWatches, createMissingFileWatch) {
	        var missingFilePaths = program.getMissingFilePaths();
	        var newMissingFilePathMap = ts.arrayToSet(missingFilePaths);
	        // Update the missing file paths watcher
	        ts.mutateMap(missingFileWatches, newMissingFilePathMap, {
	            // Watch the missing files
	            createNewValue: createMissingFileWatch,
	            // Files that are no longer missing (e.g. because they are no longer required)
	            // should no longer be watched.
	            onDeleteValue: ts.closeFileWatcher
	        });
	    }
	    ts.updateMissingFilePathsWatch = updateMissingFilePathsWatch;
	    /**
	     * Updates the existing wild card directory watches with the new set of wild card directories from the config file
	     * after new program is created because the config file was reloaded or program was created first time from the config file
	     * Note that there is no need to call this function when the program is updated with additional files without reloading config files,
	     * as wildcard directories wont change unless reloading config file
	     */
	    function updateWatchingWildcardDirectories(existingWatchedForWildcards, wildcardDirectories, watchDirectory) {
	        ts.mutateMap(existingWatchedForWildcards, wildcardDirectories, {
	            // Create new watch and recursive info
	            createNewValue: createWildcardDirectoryWatcher,
	            // Close existing watch thats not needed any more
	            onDeleteValue: closeFileWatcherOf,
	            // Close existing watch that doesnt match in the flags
	            onExistingValue: updateWildcardDirectoryWatcher
	        });
	        function createWildcardDirectoryWatcher(directory, flags) {
	            // Create new watch and recursive info
	            return {
	                watcher: watchDirectory(directory, flags),
	                flags: flags
	            };
	        }
	        function updateWildcardDirectoryWatcher(existingWatcher, flags, directory) {
	            // Watcher needs to be updated if the recursive flags dont match
	            if (existingWatcher.flags === flags) {
	                return;
	            }
	            existingWatcher.watcher.close();
	            existingWatchedForWildcards.set(directory, createWildcardDirectoryWatcher(directory, flags));
	        }
	    }
	    ts.updateWatchingWildcardDirectories = updateWatchingWildcardDirectories;
	    function isEmittedFileOfProgram(program, file) {
	        if (!program) {
	            return false;
	        }
	        return program.isEmittedFile(file);
	    }
	    ts.isEmittedFileOfProgram = isEmittedFileOfProgram;
	    var WatchLogLevel;
	    (function (WatchLogLevel) {
	        WatchLogLevel[WatchLogLevel["None"] = 0] = "None";
	        WatchLogLevel[WatchLogLevel["TriggerOnly"] = 1] = "TriggerOnly";
	        WatchLogLevel[WatchLogLevel["Verbose"] = 2] = "Verbose";
	    })(WatchLogLevel = ts.WatchLogLevel || (ts.WatchLogLevel = {}));
	    function getWatchFactory(watchLogLevel, log, getDetailWatchInfo) {
	        return getWatchFactoryWith(watchLogLevel, log, getDetailWatchInfo, watchFile, watchDirectory);
	    }
	    ts.getWatchFactory = getWatchFactory;
	    function getWatchFactoryWith(watchLogLevel, log, getDetailWatchInfo, watchFile, watchDirectory) {
	        var createFileWatcher = getCreateFileWatcher(watchLogLevel, watchFile);
	        var createFilePathWatcher = watchLogLevel === WatchLogLevel.None ? watchFilePath : createFileWatcher;
	        var createDirectoryWatcher = getCreateFileWatcher(watchLogLevel, watchDirectory);
	        return {
	            watchFile: function (host, file, callback, pollingInterval, detailInfo1, detailInfo2) {
	                return createFileWatcher(host, file, callback, pollingInterval, /*passThrough*/ undefined, detailInfo1, detailInfo2, watchFile, log, "FileWatcher", getDetailWatchInfo);
	            },
	            watchFilePath: function (host, file, callback, pollingInterval, path, detailInfo1, detailInfo2) {
	                return createFilePathWatcher(host, file, callback, pollingInterval, path, detailInfo1, detailInfo2, watchFile, log, "FileWatcher", getDetailWatchInfo);
	            },
	            watchDirectory: function (host, directory, callback, flags, detailInfo1, detailInfo2) {
	                return createDirectoryWatcher(host, directory, callback, flags, /*passThrough*/ undefined, detailInfo1, detailInfo2, watchDirectory, log, "DirectoryWatcher", getDetailWatchInfo);
	            }
	        };
	        function watchFilePath(host, file, callback, pollingInterval, path) {
	            return watchFile(host, file, function (fileName, eventKind) { return callback(fileName, eventKind, path); }, pollingInterval);
	        }
	    }
	    function watchFile(host, file, callback, pollingInterval) {
	        return host.watchFile(file, callback, pollingInterval);
	    }
	    function watchDirectory(host, directory, callback, flags) {
	        return host.watchDirectory(directory, callback, (flags & 1 /* Recursive */) !== 0);
	    }
	    function getCreateFileWatcher(watchLogLevel, addWatch) {
	        switch (watchLogLevel) {
	            case WatchLogLevel.None:
	                return addWatch;
	            case WatchLogLevel.TriggerOnly:
	                return createFileWatcherWithTriggerLogging;
	            case WatchLogLevel.Verbose:
	                return createFileWatcherWithLogging;
	        }
	    }
	    function createFileWatcherWithLogging(host, file, cb, flags, passThrough, detailInfo1, detailInfo2, addWatch, log, watchCaption, getDetailWatchInfo) {
	        log(watchCaption + ":: Added:: " + getWatchInfo(file, flags, detailInfo1, detailInfo2, getDetailWatchInfo));
	        var watcher = createFileWatcherWithTriggerLogging(host, file, cb, flags, passThrough, detailInfo1, detailInfo2, addWatch, log, watchCaption, getDetailWatchInfo);
	        return {
	            close: function () {
	                log(watchCaption + ":: Close:: " + getWatchInfo(file, flags, detailInfo1, detailInfo2, getDetailWatchInfo));
	                watcher.close();
	            }
	        };
	    }
	    function createFileWatcherWithTriggerLogging(host, file, cb, flags, passThrough, detailInfo1, detailInfo2, addWatch, log, watchCaption, getDetailWatchInfo) {
	        return addWatch(host, file, function (fileName, cbOptional) {
	            var triggerredInfo = watchCaption + ":: Triggered with " + fileName + (cbOptional !== undefined ? cbOptional : "") + ":: " + getWatchInfo(file, flags, detailInfo1, detailInfo2, getDetailWatchInfo);
	            log(triggerredInfo);
	            var start = ts.timestamp();
	            cb(fileName, cbOptional, passThrough);
	            var elapsed = ts.timestamp() - start;
	            log("Elapsed:: " + elapsed + "ms " + triggerredInfo);
	        }, flags);
	    }
	    function getWatchInfo(file, flags, detailInfo1, detailInfo2, getDetailWatchInfo) {
	        return "WatchInfo: " + file + " " + flags + " " + (getDetailWatchInfo ? getDetailWatchInfo(detailInfo1, detailInfo2) : detailInfo1);
	    }
	    function closeFileWatcherOf(objWithWatcher) {
	        objWithWatcher.watcher.close();
	    }
	    ts.closeFileWatcherOf = closeFileWatcherOf;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var ignoreDiagnosticCommentRegEx = /(^\s*$)|(^\s*\/\/\/?\s*(@ts-ignore)?)/;
	    function findConfigFile(searchPath, fileExists, configName) {
	        if (configName === void 0) { configName = "tsconfig.json"; }
	        return ts.forEachAncestorDirectory(searchPath, function (ancestor) {
	            var fileName = ts.combinePaths(ancestor, configName);
	            return fileExists(fileName) ? fileName : undefined;
	        });
	    }
	    ts.findConfigFile = findConfigFile;
	    function resolveTripleslashReference(moduleName, containingFile) {
	        var basePath = ts.getDirectoryPath(containingFile);
	        var referencedFileName = ts.isRootedDiskPath(moduleName) ? moduleName : ts.combinePaths(basePath, moduleName);
	        return ts.normalizePath(referencedFileName);
	    }
	    ts.resolveTripleslashReference = resolveTripleslashReference;
	    /* @internal */
	    function computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName) {
	        var commonPathComponents;
	        var failed = ts.forEach(fileNames, function (sourceFile) {
	            // Each file contributes into common source file path
	            var sourcePathComponents = ts.getNormalizedPathComponents(sourceFile, currentDirectory);
	            sourcePathComponents.pop(); // The base file name is not part of the common directory path
	            if (!commonPathComponents) {
	                // first file
	                commonPathComponents = sourcePathComponents;
	                return;
	            }
	            var n = Math.min(commonPathComponents.length, sourcePathComponents.length);
	            for (var i = 0; i < n; i++) {
	                if (getCanonicalFileName(commonPathComponents[i]) !== getCanonicalFileName(sourcePathComponents[i])) {
	                    if (i === 0) {
	                        // Failed to find any common path component
	                        return true;
	                    }
	                    // New common path found that is 0 -> i-1
	                    commonPathComponents.length = i;
	                    break;
	                }
	            }
	            // If the sourcePathComponents was shorter than the commonPathComponents, truncate to the sourcePathComponents
	            if (sourcePathComponents.length < commonPathComponents.length) {
	                commonPathComponents.length = sourcePathComponents.length;
	            }
	        });
	        // A common path can not be found when paths span multiple drives on windows, for example
	        if (failed) {
	            return "";
	        }
	        if (!commonPathComponents) { // Can happen when all input files are .d.ts files
	            return currentDirectory;
	        }
	        return ts.getPathFromPathComponents(commonPathComponents);
	    }
	    ts.computeCommonSourceDirectoryOfFilenames = computeCommonSourceDirectoryOfFilenames;
	    function createCompilerHost(options, setParentNodes) {
	        var existingDirectories = ts.createMap();
	        function getCanonicalFileName(fileName) {
	            // if underlying system can distinguish between two files whose names differs only in cases then file name already in canonical form.
	            // otherwise use toLowerCase as a canonical form.
	            return ts.sys.useCaseSensitiveFileNames ? fileName : fileName.toLowerCase();
	        }
	        function getSourceFile(fileName, languageVersion, onError) {
	            var text;
	            try {
	                ts.performance.mark("beforeIORead");
	                text = ts.sys.readFile(fileName, options.charset);
	                ts.performance.mark("afterIORead");
	                ts.performance.measure("I/O Read", "beforeIORead", "afterIORead");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	                text = "";
	            }
	            return text !== undefined ? ts.createSourceFile(fileName, text, languageVersion, setParentNodes) : undefined;
	        }
	        function directoryExists(directoryPath) {
	            if (existingDirectories.has(directoryPath)) {
	                return true;
	            }
	            if (ts.sys.directoryExists(directoryPath)) {
	                existingDirectories.set(directoryPath, true);
	                return true;
	            }
	            return false;
	        }
	        function ensureDirectoriesExist(directoryPath) {
	            if (directoryPath.length > ts.getRootLength(directoryPath) && !directoryExists(directoryPath)) {
	                var parentDirectory = ts.getDirectoryPath(directoryPath);
	                ensureDirectoriesExist(parentDirectory);
	                ts.sys.createDirectory(directoryPath);
	            }
	        }
	        var outputFingerprints;
	        function writeFileIfUpdated(fileName, data, writeByteOrderMark) {
	            if (!outputFingerprints) {
	                outputFingerprints = ts.createMap();
	            }
	            var hash = ts.sys.createHash(data);
	            var mtimeBefore = ts.sys.getModifiedTime(fileName);
	            if (mtimeBefore) {
	                var fingerprint = outputFingerprints.get(fileName);
	                // If output has not been changed, and the file has no external modification
	                if (fingerprint &&
	                    fingerprint.byteOrderMark === writeByteOrderMark &&
	                    fingerprint.hash === hash &&
	                    fingerprint.mtime.getTime() === mtimeBefore.getTime()) {
	                    return;
	                }
	            }
	            ts.sys.writeFile(fileName, data, writeByteOrderMark);
	            var mtimeAfter = ts.sys.getModifiedTime(fileName);
	            outputFingerprints.set(fileName, {
	                hash: hash,
	                byteOrderMark: writeByteOrderMark,
	                mtime: mtimeAfter
	            });
	        }
	        function writeFile(fileName, data, writeByteOrderMark, onError) {
	            try {
	                ts.performance.mark("beforeIOWrite");
	                ensureDirectoriesExist(ts.getDirectoryPath(ts.normalizePath(fileName)));
	                if (ts.isWatchSet(options) && ts.sys.createHash && ts.sys.getModifiedTime) {
	                    writeFileIfUpdated(fileName, data, writeByteOrderMark);
	                }
	                else {
	                    ts.sys.writeFile(fileName, data, writeByteOrderMark);
	                }
	                ts.performance.mark("afterIOWrite");
	                ts.performance.measure("I/O Write", "beforeIOWrite", "afterIOWrite");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	            }
	        }
	        function getDefaultLibLocation() {
	            return ts.getDirectoryPath(ts.normalizePath(ts.sys.getExecutingFilePath()));
	        }
	        var newLine = ts.getNewLineCharacter(options);
	        var realpath = ts.sys.realpath && (function (path) { return ts.sys.realpath(path); });
	        return {
	            getSourceFile: getSourceFile,
	            getDefaultLibLocation: getDefaultLibLocation,
	            getDefaultLibFileName: function (options) { return ts.combinePaths(getDefaultLibLocation(), ts.getDefaultLibFileName(options)); },
	            writeFile: writeFile,
	            getCurrentDirectory: ts.memoize(function () { return ts.sys.getCurrentDirectory(); }),
	            useCaseSensitiveFileNames: function () { return ts.sys.useCaseSensitiveFileNames; },
	            getCanonicalFileName: getCanonicalFileName,
	            getNewLine: function () { return newLine; },
	            fileExists: function (fileName) { return ts.sys.fileExists(fileName); },
	            readFile: function (fileName) { return ts.sys.readFile(fileName); },
	            trace: function (s) { return ts.sys.write(s + newLine); },
	            directoryExists: function (directoryName) { return ts.sys.directoryExists(directoryName); },
	            getEnvironmentVariable: function (name) { return ts.sys.getEnvironmentVariable ? ts.sys.getEnvironmentVariable(name) : ""; },
	            getDirectories: function (path) { return ts.sys.getDirectories(path); },
	            realpath: realpath,
	            readDirectory: function (path, extensions, include, exclude, depth) { return ts.sys.readDirectory(path, extensions, include, exclude, depth); }
	        };
	    }
	    ts.createCompilerHost = createCompilerHost;
	    function getPreEmitDiagnostics(program, sourceFile, cancellationToken) {
	        var diagnostics = program.getConfigFileParsingDiagnostics().concat(program.getOptionsDiagnostics(cancellationToken), program.getSyntacticDiagnostics(sourceFile, cancellationToken), program.getGlobalDiagnostics(cancellationToken), program.getSemanticDiagnostics(sourceFile, cancellationToken));
	        if (program.getCompilerOptions().declaration) {
	            ts.addRange(diagnostics, program.getDeclarationDiagnostics(sourceFile, cancellationToken));
	        }
	        return ts.sortAndDeduplicateDiagnostics(diagnostics);
	    }
	    ts.getPreEmitDiagnostics = getPreEmitDiagnostics;
	    function formatDiagnostics(diagnostics, host) {
	        var output = "";
	        for (var _i = 0, diagnostics_1 = diagnostics; _i < diagnostics_1.length; _i++) {
	            var diagnostic = diagnostics_1[_i];
	            output += formatDiagnostic(diagnostic, host);
	        }
	        return output;
	    }
	    ts.formatDiagnostics = formatDiagnostics;
	    function formatDiagnostic(diagnostic, host) {
	        var errorMessage = ts.diagnosticCategoryName(diagnostic) + " TS" + diagnostic.code + ": " + flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine()) + host.getNewLine();
	        if (diagnostic.file) {
	            var _a = ts.getLineAndCharacterOfPosition(diagnostic.file, diagnostic.start), line = _a.line, character = _a.character;
	            var fileName = diagnostic.file.fileName;
	            var relativeFileName = ts.convertToRelativePath(fileName, host.getCurrentDirectory(), function (fileName) { return host.getCanonicalFileName(fileName); });
	            return relativeFileName + "(" + (line + 1) + "," + (character + 1) + "): " + errorMessage;
	        }
	        return errorMessage;
	    }
	    ts.formatDiagnostic = formatDiagnostic;
	    /** @internal */
	    var ForegroundColorEscapeSequences;
	    (function (ForegroundColorEscapeSequences) {
	        ForegroundColorEscapeSequences["Grey"] = "\u001B[90m";
	        ForegroundColorEscapeSequences["Red"] = "\u001B[91m";
	        ForegroundColorEscapeSequences["Yellow"] = "\u001B[93m";
	        ForegroundColorEscapeSequences["Blue"] = "\u001B[94m";
	        ForegroundColorEscapeSequences["Cyan"] = "\u001B[96m";
	    })(ForegroundColorEscapeSequences = ts.ForegroundColorEscapeSequences || (ts.ForegroundColorEscapeSequences = {}));
	    var gutterStyleSequence = "\u001b[30;47m";
	    var gutterSeparator = " ";
	    var resetEscapeSequence = "\u001b[0m";
	    var ellipsis = "...";
	    function getCategoryFormat(category) {
	        switch (category) {
	            case ts.DiagnosticCategory.Error: return ForegroundColorEscapeSequences.Red;
	            case ts.DiagnosticCategory.Warning: return ForegroundColorEscapeSequences.Yellow;
	            case ts.DiagnosticCategory.Suggestion: return ts.Debug.fail("Should never get an Info diagnostic on the command line.");
	            case ts.DiagnosticCategory.Message: return ForegroundColorEscapeSequences.Blue;
	        }
	    }
	    /** @internal */
	    function formatColorAndReset(text, formatStyle) {
	        return formatStyle + text + resetEscapeSequence;
	    }
	    ts.formatColorAndReset = formatColorAndReset;
	    function padLeft(s, length) {
	        while (s.length < length) {
	            s = " " + s;
	        }
	        return s;
	    }
	    function formatDiagnosticsWithColorAndContext(diagnostics, host) {
	        var output = "";
	        for (var _i = 0, diagnostics_2 = diagnostics; _i < diagnostics_2.length; _i++) {
	            var diagnostic = diagnostics_2[_i];
	            var context_2 = "";
	            if (diagnostic.file) {
	                var start = diagnostic.start, length_4 = diagnostic.length, file_9 = diagnostic.file;
	                var _a = ts.getLineAndCharacterOfPosition(file_9, start), firstLine = _a.line, firstLineChar = _a.character;
	                var _b = ts.getLineAndCharacterOfPosition(file_9, start + length_4), lastLine = _b.line, lastLineChar = _b.character;
	                var lastLineInFile = ts.getLineAndCharacterOfPosition(file_9, file_9.text.length).line;
	                var relativeFileName = host ? ts.convertToRelativePath(file_9.fileName, host.getCurrentDirectory(), function (fileName) { return host.getCanonicalFileName(fileName); }) : file_9.fileName;
	                var hasMoreThanFiveLines = (lastLine - firstLine) >= 4;
	                var gutterWidth = (lastLine + 1 + "").length;
	                if (hasMoreThanFiveLines) {
	                    gutterWidth = Math.max(ellipsis.length, gutterWidth);
	                }
	                for (var i = firstLine; i <= lastLine; i++) {
	                    context_2 += host.getNewLine();
	                    // If the error spans over 5 lines, we'll only show the first 2 and last 2 lines,
	                    // so we'll skip ahead to the second-to-last line.
	                    if (hasMoreThanFiveLines && firstLine + 1 < i && i < lastLine - 1) {
	                        context_2 += formatColorAndReset(padLeft(ellipsis, gutterWidth), gutterStyleSequence) + gutterSeparator + host.getNewLine();
	                        i = lastLine - 1;
	                    }
	                    var lineStart = ts.getPositionOfLineAndCharacter(file_9, i, 0);
	                    var lineEnd = i < lastLineInFile ? ts.getPositionOfLineAndCharacter(file_9, i + 1, 0) : file_9.text.length;
	                    var lineContent = file_9.text.slice(lineStart, lineEnd);
	                    lineContent = lineContent.replace(/\s+$/g, ""); // trim from end
	                    lineContent = lineContent.replace("\t", " "); // convert tabs to single spaces
	                    // Output the gutter and the actual contents of the line.
	                    context_2 += formatColorAndReset(padLeft(i + 1 + "", gutterWidth), gutterStyleSequence) + gutterSeparator;
	                    context_2 += lineContent + host.getNewLine();
	                    // Output the gutter and the error span for the line using tildes.
	                    context_2 += formatColorAndReset(padLeft("", gutterWidth), gutterStyleSequence) + gutterSeparator;
	                    context_2 += ForegroundColorEscapeSequences.Red;
	                    if (i === firstLine) {
	                        // If we're on the last line, then limit it to the last character of the last line.
	                        // Otherwise, we'll just squiggle the rest of the line, giving 'slice' no end position.
	                        var lastCharForLine = i === lastLine ? lastLineChar : undefined;
	                        context_2 += lineContent.slice(0, firstLineChar).replace(/\S/g, " ");
	                        context_2 += lineContent.slice(firstLineChar, lastCharForLine).replace(/./g, "~");
	                    }
	                    else if (i === lastLine) {
	                        context_2 += lineContent.slice(0, lastLineChar).replace(/./g, "~");
	                    }
	                    else {
	                        // Squiggle the entire line.
	                        context_2 += lineContent.replace(/./g, "~");
	                    }
	                    context_2 += resetEscapeSequence;
	                }
	                output += formatColorAndReset(relativeFileName, ForegroundColorEscapeSequences.Cyan);
	                output += ":";
	                output += formatColorAndReset("" + (firstLine + 1), ForegroundColorEscapeSequences.Yellow);
	                output += ":";
	                output += formatColorAndReset("" + (firstLineChar + 1), ForegroundColorEscapeSequences.Yellow);
	                output += " - ";
	            }
	            output += formatColorAndReset(ts.diagnosticCategoryName(diagnostic), getCategoryFormat(diagnostic.category));
	            output += formatColorAndReset(" TS" + diagnostic.code + ": ", ForegroundColorEscapeSequences.Grey);
	            output += flattenDiagnosticMessageText(diagnostic.messageText, host.getNewLine());
	            if (diagnostic.file) {
	                output += host.getNewLine();
	                output += context_2;
	            }
	            output += host.getNewLine();
	        }
	        return output + host.getNewLine();
	    }
	    ts.formatDiagnosticsWithColorAndContext = formatDiagnosticsWithColorAndContext;
	    function flattenDiagnosticMessageText(messageText, newLine) {
	        if (ts.isString(messageText)) {
	            return messageText;
	        }
	        else {
	            var diagnosticChain = messageText;
	            var result = "";
	            var indent = 0;
	            while (diagnosticChain) {
	                if (indent) {
	                    result += newLine;
	                    for (var i = 0; i < indent; i++) {
	                        result += "  ";
	                    }
	                }
	                result += diagnosticChain.messageText;
	                indent++;
	                diagnosticChain = diagnosticChain.next;
	            }
	            return result;
	        }
	    }
	    ts.flattenDiagnosticMessageText = flattenDiagnosticMessageText;
	    function loadWithLocalCache(names, containingFile, loader) {
	        if (names.length === 0) {
	            return [];
	        }
	        var resolutions = [];
	        var cache = ts.createMap();
	        for (var _i = 0, names_1 = names; _i < names_1.length; _i++) {
	            var name = names_1[_i];
	            var result = void 0;
	            if (cache.has(name)) {
	                result = cache.get(name);
	            }
	            else {
	                cache.set(name, result = loader(name, containingFile));
	            }
	            resolutions.push(result);
	        }
	        return resolutions;
	    }
	    /**
	     * Determines if program structure is upto date or needs to be recreated
	     */
	    /* @internal */
	    function isProgramUptoDate(program, rootFileNames, newOptions, getSourceVersion, fileExists, hasInvalidatedResolution, hasChangedAutomaticTypeDirectiveNames) {
	        // If we haven't created a program yet or have changed automatic type directives, then it is not up-to-date
	        if (!program || hasChangedAutomaticTypeDirectiveNames) {
	            return false;
	        }
	        // If number of files in the program do not match, it is not up-to-date
	        if (program.getRootFileNames().length !== rootFileNames.length) {
	            return false;
	        }
	        // If any file is not up-to-date, then the whole program is not up-to-date
	        if (program.getSourceFiles().some(sourceFileNotUptoDate)) {
	            return false;
	        }
	        // If any of the missing file paths are now created
	        if (program.getMissingFilePaths().some(fileExists)) {
	            return false;
	        }
	        var currentOptions = program.getCompilerOptions();
	        // If the compilation settings do no match, then the program is not up-to-date
	        if (!ts.compareDataObjects(currentOptions, newOptions)) {
	            return false;
	        }
	        // If everything matches but the text of config file is changed,
	        // error locations can change for program options, so update the program
	        if (currentOptions.configFile && newOptions.configFile) {
	            return currentOptions.configFile.text === newOptions.configFile.text;
	        }
	        return true;
	        function sourceFileNotUptoDate(sourceFile) {
	            return sourceFile.version !== getSourceVersion(sourceFile.path) ||
	                hasInvalidatedResolution(sourceFile.path);
	        }
	    }
	    ts.isProgramUptoDate = isProgramUptoDate;
	    function getConfigFileParsingDiagnostics(configFileParseResult) {
	        return configFileParseResult.options.configFile ? configFileParseResult.options.configFile.parseDiagnostics.concat(configFileParseResult.errors) :
	            configFileParseResult.errors;
	    }
	    ts.getConfigFileParsingDiagnostics = getConfigFileParsingDiagnostics;
	    /**
	     * Determined if source file needs to be re-created even if its text hasn't changed
	     */
	    function shouldProgramCreateNewSourceFiles(program, newOptions) {
	        // If any of these options change, we can't reuse old source file even if version match
	        // The change in options like these could result in change in syntax tree change
	        var oldOptions = program && program.getCompilerOptions();
	        return oldOptions && (oldOptions.target !== newOptions.target ||
	            oldOptions.module !== newOptions.module ||
	            oldOptions.moduleResolution !== newOptions.moduleResolution ||
	            oldOptions.noResolve !== newOptions.noResolve ||
	            oldOptions.jsx !== newOptions.jsx ||
	            oldOptions.allowJs !== newOptions.allowJs ||
	            oldOptions.disableSizeLimit !== newOptions.disableSizeLimit ||
	            oldOptions.baseUrl !== newOptions.baseUrl ||
	            !ts.equalOwnProperties(oldOptions.paths, newOptions.paths));
	    }
	    function createCreateProgramOptions(rootNames, options, host, oldProgram, configFileParsingDiagnostics) {
	        return {
	            rootNames: rootNames,
	            options: options,
	            host: host,
	            oldProgram: oldProgram,
	            configFileParsingDiagnostics: configFileParsingDiagnostics
	        };
	    }
	    function createProgram(rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) {
	        var createProgramOptions = ts.isArray(rootNamesOrOptions) ? createCreateProgramOptions(rootNamesOrOptions, _options, _host, _oldProgram, _configFileParsingDiagnostics) : rootNamesOrOptions;
	        var rootNames = createProgramOptions.rootNames, options = createProgramOptions.options, configFileParsingDiagnostics = createProgramOptions.configFileParsingDiagnostics, projectReferences = createProgramOptions.projectReferences;
	        var host = createProgramOptions.host, oldProgram = createProgramOptions.oldProgram;
	        var program;
	        var files = [];
	        var commonSourceDirectory;
	        var diagnosticsProducingTypeChecker;
	        var noDiagnosticsTypeChecker;
	        var classifiableNames;
	        var modifiedFilePaths;
	        var cachedSemanticDiagnosticsForFile = {};
	        var cachedDeclarationDiagnosticsForFile = {};
	        var resolvedTypeReferenceDirectives = ts.createMap();
	        var fileProcessingDiagnostics = ts.createDiagnosticCollection();
	        // The below settings are to track if a .js file should be add to the program if loaded via searching under node_modules.
	        // This works as imported modules are discovered recursively in a depth first manner, specifically:
	        // - For each root file, findSourceFile is called.
	        // - This calls processImportedModules for each module imported in the source file.
	        // - This calls resolveModuleNames, and then calls findSourceFile for each resolved module.
	        // As all these operations happen - and are nested - within the createProgram call, they close over the below variables.
	        // The current resolution depth is tracked by incrementing/decrementing as the depth first search progresses.
	        var maxNodeModuleJsDepth = typeof options.maxNodeModuleJsDepth === "number" ? options.maxNodeModuleJsDepth : 0;
	        var currentNodeModulesDepth = 0;
	        // If a module has some of its imports skipped due to being at the depth limit under node_modules, then track
	        // this, as it may be imported at a shallower depth later, and then it will need its skipped imports processed.
	        var modulesWithElidedImports = ts.createMap();
	        // Track source files that are source files found by searching under node_modules, as these shouldn't be compiled.
	        var sourceFilesFoundSearchingNodeModules = ts.createMap();
	        ts.performance.mark("beforeProgram");
	        host = host || createCompilerHost(options);
	        var configParsingHost = parseConfigHostFromCompilerHost(host);
	        var skipDefaultLib = options.noLib;
	        var getDefaultLibraryFileName = ts.memoize(function () { return host.getDefaultLibFileName(options); });
	        var defaultLibraryPath = host.getDefaultLibLocation ? host.getDefaultLibLocation() : ts.getDirectoryPath(getDefaultLibraryFileName());
	        var programDiagnostics = ts.createDiagnosticCollection();
	        var currentDirectory = host.getCurrentDirectory();
	        var supportedExtensions = ts.getSupportedExtensions(options);
	        // Map storing if there is emit blocking diagnostics for given input
	        var hasEmitBlockingDiagnostics = ts.createMap();
	        var _compilerOptionsObjectLiteralSyntax;
	        var _referencesArrayLiteralSyntax;
	        var moduleResolutionCache;
	        var resolveModuleNamesWorker;
	        var hasInvalidatedResolution = host.hasInvalidatedResolution || ts.returnFalse;
	        if (host.resolveModuleNames) {
	            resolveModuleNamesWorker = function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(ts.Debug.assertEachDefined(moduleNames), containingFile, reusedNames).map(function (resolved) {
	                // An older host may have omitted extension, in which case we should infer it from the file extension of resolvedFileName.
	                if (!resolved || resolved.extension !== undefined) {
	                    return resolved;
	                }
	                var withExtension = ts.clone(resolved);
	                withExtension.extension = ts.extensionFromPath(resolved.resolvedFileName);
	                return withExtension;
	            }); };
	        }
	        else {
	            moduleResolutionCache = ts.createModuleResolutionCache(currentDirectory, function (x) { return host.getCanonicalFileName(x); });
	            var loader_1 = function (moduleName, containingFile) { return ts.resolveModuleName(moduleName, containingFile, options, host, moduleResolutionCache).resolvedModule; };
	            resolveModuleNamesWorker = function (moduleNames, containingFile) { return loadWithLocalCache(ts.Debug.assertEachDefined(moduleNames), containingFile, loader_1); };
	        }
	        var resolveTypeReferenceDirectiveNamesWorker;
	        if (host.resolveTypeReferenceDirectives) {
	            resolveTypeReferenceDirectiveNamesWorker = function (typeDirectiveNames, containingFile) { return host.resolveTypeReferenceDirectives(ts.Debug.assertEachDefined(typeDirectiveNames), containingFile); };
	        }
	        else {
	            var loader_2 = function (typesRef, containingFile) { return ts.resolveTypeReferenceDirective(typesRef, containingFile, options, host).resolvedTypeReferenceDirective; };
	            resolveTypeReferenceDirectiveNamesWorker = function (typeReferenceDirectiveNames, containingFile) { return loadWithLocalCache(ts.Debug.assertEachDefined(typeReferenceDirectiveNames), containingFile, loader_2); };
	        }
	        // Map from a stringified PackageId to the source file with that id.
	        // Only one source file may have a given packageId. Others become redirects (see createRedirectSourceFile).
	        // `packageIdToSourceFile` is only used while building the program, while `sourceFileToPackageName` and `isSourceFileTargetOfRedirect` are kept around.
	        var packageIdToSourceFile = ts.createMap();
	        // Maps from a SourceFile's `.path` to the name of the package it was imported with.
	        var sourceFileToPackageName = ts.createMap();
	        var redirectTargetsSet = ts.createMap();
	        var filesByName = ts.createMap();
	        var missingFilePaths;
	        // stores 'filename -> file association' ignoring case
	        // used to track cases when two file names differ only in casing
	        var filesByNameIgnoreCase = host.useCaseSensitiveFileNames() ? ts.createMap() : undefined;
	        // A parallel array to projectReferences storing the results of reading in the referenced tsconfig files
	        var resolvedProjectReferences = projectReferences ? [] : undefined;
	        var projectReferenceRedirects = ts.createMap();
	        if (projectReferences) {
	            for (var _i = 0, projectReferences_1 = projectReferences; _i < projectReferences_1.length; _i++) {
	                var ref = projectReferences_1[_i];
	                var parsedRef = parseProjectReferenceConfigFile(ref);
	                resolvedProjectReferences.push(parsedRef);
	                if (parsedRef) {
	                    if (parsedRef.commandLine.options.outFile) {
	                        var dtsOutfile = ts.changeExtension(parsedRef.commandLine.options.outFile, ".d.ts");
	                        processSourceFile(dtsOutfile, /*isDefaultLib*/ false, /*packageId*/ undefined);
	                    }
	                    addProjectReferenceRedirects(parsedRef.commandLine, projectReferenceRedirects);
	                }
	            }
	        }
	        var shouldCreateNewSourceFile = shouldProgramCreateNewSourceFiles(oldProgram, options);
	        var structuralIsReused = tryReuseStructureFromOldProgram();
	        if (structuralIsReused !== 2 /* Completely */) {
	            ts.forEach(rootNames, function (name) { return processRootFile(name, /*isDefaultLib*/ false); });
	            // load type declarations specified via 'types' argument or implicitly from types/ and node_modules/@types folders
	            var typeReferences = ts.getAutomaticTypeDirectiveNames(options, host);
	            if (typeReferences.length) {
	                // This containingFilename needs to match with the one used in managed-side
	                var containingDirectory = options.configFilePath ? ts.getDirectoryPath(options.configFilePath) : host.getCurrentDirectory();
	                var containingFilename = ts.combinePaths(containingDirectory, "__inferred type names__.ts");
	                var resolutions = resolveTypeReferenceDirectiveNamesWorker(typeReferences, containingFilename);
	                for (var i = 0; i < typeReferences.length; i++) {
	                    processTypeReferenceDirective(typeReferences[i], resolutions[i]);
	                }
	            }
	            // Do not process the default library if:
	            //  - The '--noLib' flag is used.
	            //  - A 'no-default-lib' reference comment is encountered in
	            //      processing the root files.
	            if (!skipDefaultLib) {
	                // If '--lib' is not specified, include default library file according to '--target'
	                // otherwise, using options specified in '--lib' instead of '--target' default library file
	                var defaultLibraryFileName = getDefaultLibraryFileName();
	                if (!options.lib && defaultLibraryFileName) {
	                    processRootFile(defaultLibraryFileName, /*isDefaultLib*/ true);
	                }
	                else {
	                    ts.forEach(options.lib, function (libFileName) {
	                        processRootFile(ts.combinePaths(defaultLibraryPath, libFileName), /*isDefaultLib*/ true);
	                    });
	                }
	            }
	            missingFilePaths = ts.arrayFrom(filesByName.keys(), function (p) { return p; }).filter(function (p) { return !filesByName.get(p); });
	        }
	        ts.Debug.assert(!!missingFilePaths);
	        // Release any files we have acquired in the old program but are
	        // not part of the new program.
	        if (oldProgram && host.onReleaseOldSourceFile) {
	            var oldSourceFiles = oldProgram.getSourceFiles();
	            for (var _a = 0, oldSourceFiles_1 = oldSourceFiles; _a < oldSourceFiles_1.length; _a++) {
	                var oldSourceFile = oldSourceFiles_1[_a];
	                if (!getSourceFile(oldSourceFile.path) || shouldCreateNewSourceFile) {
	                    host.onReleaseOldSourceFile(oldSourceFile, oldProgram.getCompilerOptions());
	                }
	            }
	        }
	        // unconditionally set oldProgram to undefined to prevent it from being captured in closure
	        oldProgram = undefined;
	        program = {
	            getRootFileNames: function () { return rootNames; },
	            getSourceFile: getSourceFile,
	            getSourceFileByPath: getSourceFileByPath,
	            getSourceFiles: function () { return files; },
	            getMissingFilePaths: function () { return missingFilePaths; },
	            getCompilerOptions: function () { return options; },
	            getSyntacticDiagnostics: getSyntacticDiagnostics,
	            getOptionsDiagnostics: getOptionsDiagnostics,
	            getGlobalDiagnostics: getGlobalDiagnostics,
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            getDeclarationDiagnostics: getDeclarationDiagnostics,
	            getTypeChecker: getTypeChecker,
	            getClassifiableNames: getClassifiableNames,
	            getDiagnosticsProducingTypeChecker: getDiagnosticsProducingTypeChecker,
	            getCommonSourceDirectory: getCommonSourceDirectory,
	            emit: emit,
	            getCurrentDirectory: function () { return currentDirectory; },
	            getNodeCount: function () { return getDiagnosticsProducingTypeChecker().getNodeCount(); },
	            getIdentifierCount: function () { return getDiagnosticsProducingTypeChecker().getIdentifierCount(); },
	            getSymbolCount: function () { return getDiagnosticsProducingTypeChecker().getSymbolCount(); },
	            getTypeCount: function () { return getDiagnosticsProducingTypeChecker().getTypeCount(); },
	            getFileProcessingDiagnostics: function () { return fileProcessingDiagnostics; },
	            getResolvedTypeReferenceDirectives: function () { return resolvedTypeReferenceDirectives; },
	            isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary,
	            isSourceFileDefaultLibrary: isSourceFileDefaultLibrary,
	            dropDiagnosticsProducingTypeChecker: dropDiagnosticsProducingTypeChecker,
	            getSourceFileFromReference: getSourceFileFromReference,
	            sourceFileToPackageName: sourceFileToPackageName,
	            redirectTargetsSet: redirectTargetsSet,
	            isEmittedFile: isEmittedFile,
	            getConfigFileParsingDiagnostics: getConfigFileParsingDiagnostics,
	            getResolvedModuleWithFailedLookupLocationsFromCache: getResolvedModuleWithFailedLookupLocationsFromCache,
	            getProjectReferences: getProjectReferences
	        };
	        verifyCompilerOptions();
	        ts.performance.mark("afterProgram");
	        ts.performance.measure("Program", "beforeProgram", "afterProgram");
	        return program;
	        function getResolvedModuleWithFailedLookupLocationsFromCache(moduleName, containingFile) {
	            return moduleResolutionCache && ts.resolveModuleNameFromCache(moduleName, containingFile, moduleResolutionCache);
	        }
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function getCommonSourceDirectory() {
	            if (commonSourceDirectory === undefined) {
	                var emittedFiles = ts.filter(files, function (file) { return ts.sourceFileMayBeEmitted(file, options, isSourceFileFromExternalLibrary); });
	                if (options.rootDir && checkSourceFilesBelongToPath(emittedFiles, options.rootDir)) {
	                    // If a rootDir is specified use it as the commonSourceDirectory
	                    commonSourceDirectory = ts.getNormalizedAbsolutePath(options.rootDir, currentDirectory);
	                }
	                else if (options.composite) {
	                    // Project compilations never infer their root from the input source paths
	                    commonSourceDirectory = ts.getDirectoryPath(ts.normalizeSlashes(options.configFilePath));
	                    checkSourceFilesBelongToPath(emittedFiles, commonSourceDirectory);
	                }
	                else {
	                    commonSourceDirectory = computeCommonSourceDirectory(emittedFiles);
	                }
	                if (commonSourceDirectory && commonSourceDirectory[commonSourceDirectory.length - 1] !== ts.directorySeparator) {
	                    // Make sure directory path ends with directory separator so this string can directly
	                    // used to replace with "" to get the relative path of the source file and the relative path doesn't
	                    // start with / making it rooted path
	                    commonSourceDirectory += ts.directorySeparator;
	                }
	            }
	            return commonSourceDirectory;
	        }
	        function getClassifiableNames() {
	            if (!classifiableNames) {
	                // Initialize a checker so that all our files are bound.
	                getTypeChecker();
	                classifiableNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, files_2 = files; _i < files_2.length; _i++) {
	                    var sourceFile = files_2[_i];
	                    ts.copyEntries(sourceFile.classifiableNames, classifiableNames);
	                }
	            }
	            return classifiableNames;
	        }
	        function resolveModuleNamesReusingOldState(moduleNames, containingFile, file, oldProgramState) {
	            if (structuralIsReused === 0 /* Not */ && !file.ambientModuleNames.length) {
	                // If the old program state does not permit reusing resolutions and `file` does not contain locally defined ambient modules,
	                // the best we can do is fallback to the default logic.
	                return resolveModuleNamesWorker(moduleNames, containingFile);
	            }
	            var oldSourceFile = oldProgramState.program && oldProgramState.program.getSourceFile(containingFile);
	            if (oldSourceFile !== file && file.resolvedModules) {
	                // `file` was created for the new program.
	                //
	                // We only set `file.resolvedModules` via work from the current function,
	                // so it is defined iff we already called the current function on `file`.
	                // That call happened no later than the creation of the `file` object,
	                // which per above occurred during the current program creation.
	                // Since we assume the filesystem does not change during program creation,
	                // it is safe to reuse resolutions from the earlier call.
	                var result_4 = [];
	                for (var _i = 0, moduleNames_1 = moduleNames; _i < moduleNames_1.length; _i++) {
	                    var moduleName = moduleNames_1[_i];
	                    var resolvedModule = file.resolvedModules.get(moduleName);
	                    result_4.push(resolvedModule);
	                }
	                return result_4;
	            }
	            // At this point, we know at least one of the following hold:
	            // - file has local declarations for ambient modules
	            // - old program state is available
	            // With this information, we can infer some module resolutions without performing resolution.
	            /** An ordered list of module names for which we cannot recover the resolution. */
	            var unknownModuleNames;
	            /**
	             * The indexing of elements in this list matches that of `moduleNames`.
	             *
	             * Before combining results, result[i] is in one of the following states:
	             * * undefined: needs to be recomputed,
	             * * predictedToResolveToAmbientModuleMarker: known to be an ambient module.
	             * Needs to be reset to undefined before returning,
	             * * ResolvedModuleFull instance: can be reused.
	             */
	            var result;
	            var reusedNames;
	            /** A transient placeholder used to mark predicted resolution in the result list. */
	            var predictedToResolveToAmbientModuleMarker = {};
	            for (var i = 0; i < moduleNames.length; i++) {
	                var moduleName = moduleNames[i];
	                // If the source file is unchanged and doesnt have invalidated resolution, reuse the module resolutions
	                if (file === oldSourceFile && !hasInvalidatedResolution(oldSourceFile.path)) {
	                    var oldResolvedModule = oldSourceFile && oldSourceFile.resolvedModules.get(moduleName);
	                    if (oldResolvedModule) {
	                        if (ts.isTraceEnabled(options, host)) {
	                            ts.trace(host, ts.Diagnostics.Reusing_resolution_of_module_0_to_file_1_from_old_program, moduleName, containingFile);
	                        }
	                        (result || (result = new Array(moduleNames.length)))[i] = oldResolvedModule;
	                        (reusedNames || (reusedNames = [])).push(moduleName);
	                        continue;
	                    }
	                }
	                // We know moduleName resolves to an ambient module provided that moduleName:
	                // - is in the list of ambient modules locally declared in the current source file.
	                // - resolved to an ambient module in the old program whose declaration is in an unmodified file
	                //   (so the same module declaration will land in the new program)
	                var resolvesToAmbientModuleInNonModifiedFile = false;
	                if (ts.contains(file.ambientModuleNames, moduleName)) {
	                    resolvesToAmbientModuleInNonModifiedFile = true;
	                    if (ts.isTraceEnabled(options, host)) {
	                        ts.trace(host, ts.Diagnostics.Module_0_was_resolved_as_locally_declared_ambient_module_in_file_1, moduleName, containingFile);
	                    }
	                }
	                else {
	                    resolvesToAmbientModuleInNonModifiedFile = moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName, oldProgramState);
	                }
	                if (resolvesToAmbientModuleInNonModifiedFile) {
	                    (result || (result = new Array(moduleNames.length)))[i] = predictedToResolveToAmbientModuleMarker;
	                }
	                else {
	                    // Resolution failed in the old program, or resolved to an ambient module for which we can't reuse the result.
	                    (unknownModuleNames || (unknownModuleNames = [])).push(moduleName);
	                }
	            }
	            var resolutions = unknownModuleNames && unknownModuleNames.length
	                ? resolveModuleNamesWorker(unknownModuleNames, containingFile, reusedNames)
	                : ts.emptyArray;
	            // Combine results of resolutions and predicted results
	            if (!result) {
	                // There were no unresolved/ambient resolutions.
	                ts.Debug.assert(resolutions.length === moduleNames.length);
	                return resolutions;
	            }
	            var j = 0;
	            for (var i = 0; i < result.length; i++) {
	                if (result[i]) {
	                    // `result[i]` is either a `ResolvedModuleFull` or a marker.
	                    // If it is the former, we can leave it as is.
	                    if (result[i] === predictedToResolveToAmbientModuleMarker) {
	                        result[i] = undefined;
	                    }
	                }
	                else {
	                    result[i] = resolutions[j];
	                    j++;
	                }
	            }
	            ts.Debug.assert(j === resolutions.length);
	            return result;
	            // If we change our policy of rechecking failed lookups on each program create,
	            // we should adjust the value returned here.
	            function moduleNameResolvesToAmbientModuleInNonModifiedFile(moduleName, oldProgramState) {
	                var resolutionToFile = ts.getResolvedModule(oldProgramState.oldSourceFile, moduleName);
	                var resolvedFile = resolutionToFile && oldProgramState.program && oldProgramState.program.getSourceFile(resolutionToFile.resolvedFileName);
	                if (resolutionToFile && resolvedFile && !resolvedFile.externalModuleIndicator) {
	                    // In the old program, we resolved to an ambient module that was in the same
	                    //   place as we expected to find an actual module file.
	                    // We actually need to return 'false' here even though this seems like a 'true' case
	                    //   because the normal module resolution algorithm will find this anyway.
	                    return false;
	                }
	                var ambientModule = oldProgramState.program && oldProgramState.program.getTypeChecker().tryFindAmbientModuleWithoutAugmentations(moduleName);
	                if (!(ambientModule && ambientModule.declarations)) {
	                    return false;
	                }
	                // at least one of declarations should come from non-modified source file
	                var firstUnmodifiedFile = ts.forEach(ambientModule.declarations, function (d) {
	                    var f = ts.getSourceFileOfNode(d);
	                    return !ts.contains(oldProgramState.modifiedFilePaths, f.path) && f;
	                });
	                if (!firstUnmodifiedFile) {
	                    return false;
	                }
	                if (ts.isTraceEnabled(options, host)) {
	                    ts.trace(host, ts.Diagnostics.Module_0_was_resolved_as_ambient_module_declared_in_1_since_this_file_was_not_modified, moduleName, firstUnmodifiedFile.fileName);
	                }
	                return true;
	            }
	        }
	        function tryReuseStructureFromOldProgram() {
	            if (!oldProgram) {
	                return 0 /* Not */;
	            }
	            // check properties that can affect structure of the program or module resolution strategy
	            // if any of these properties has changed - structure cannot be reused
	            var oldOptions = oldProgram.getCompilerOptions();
	            if (ts.changesAffectModuleResolution(oldOptions, options)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            ts.Debug.assert(!(oldProgram.structureIsReused & (2 /* Completely */ | 1 /* SafeModules */)));
	            // there is an old program, check if we can reuse its structure
	            var oldRootNames = oldProgram.getRootFileNames();
	            if (!ts.arrayIsEqualTo(oldRootNames, rootNames)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            if (!ts.arrayIsEqualTo(options.types, oldOptions.types)) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            // Check if any referenced project tsconfig files are different
	            var oldRefs = oldProgram.getProjectReferences();
	            if (projectReferences) {
	                if (!oldRefs) {
	                    return oldProgram.structureIsReused = 0 /* Not */;
	                }
	                for (var i = 0; i < projectReferences.length; i++) {
	                    var oldRef = oldRefs[i];
	                    if (oldRef) {
	                        var newRef = parseProjectReferenceConfigFile(projectReferences[i]);
	                        if (!newRef || newRef.sourceFile !== oldRef.sourceFile) {
	                            // Resolved project reference has gone missing or changed
	                            return oldProgram.structureIsReused = 0 /* Not */;
	                        }
	                    }
	                    else {
	                        // A previously-unresolved reference may be resolved now
	                        if (parseProjectReferenceConfigFile(projectReferences[i]) !== undefined) {
	                            return oldProgram.structureIsReused = 0 /* Not */;
	                        }
	                    }
	                }
	            }
	            else {
	                if (oldRefs) {
	                    return oldProgram.structureIsReused = 0 /* Not */;
	                }
	            }
	            // check if program source files has changed in the way that can affect structure of the program
	            var newSourceFiles = [];
	            var filePaths = [];
	            var modifiedSourceFiles = [];
	            oldProgram.structureIsReused = 2 /* Completely */;
	            // If the missing file paths are now present, it can change the progam structure,
	            // and hence cant reuse the structure.
	            // This is same as how we dont reuse the structure if one of the file from old program is now missing
	            if (oldProgram.getMissingFilePaths().some(function (missingFilePath) { return host.fileExists(missingFilePath); })) {
	                return oldProgram.structureIsReused = 0 /* Not */;
	            }
	            var oldSourceFiles = oldProgram.getSourceFiles();
	            var SeenPackageName;
	            (function (SeenPackageName) {
	                SeenPackageName[SeenPackageName["Exists"] = 0] = "Exists";
	                SeenPackageName[SeenPackageName["Modified"] = 1] = "Modified";
	            })(SeenPackageName || (SeenPackageName = {}));
	            var seenPackageNames = ts.createMap();
	            for (var _i = 0, oldSourceFiles_2 = oldSourceFiles; _i < oldSourceFiles_2.length; _i++) {
	                var oldSourceFile = oldSourceFiles_2[_i];
	                var newSourceFile = host.getSourceFileByPath
	                    ? host.getSourceFileByPath(oldSourceFile.fileName, oldSourceFile.path, options.target, /*onError*/ undefined, shouldCreateNewSourceFile)
	                    : host.getSourceFile(oldSourceFile.fileName, options.target, /*onError*/ undefined, shouldCreateNewSourceFile);
	                if (!newSourceFile) {
	                    return oldProgram.structureIsReused = 0 /* Not */;
	                }
	                ts.Debug.assert(!newSourceFile.redirectInfo, "Host should not return a redirect source file from `getSourceFile`");
	                var fileChanged = void 0;
	                if (oldSourceFile.redirectInfo) {
	                    // We got `newSourceFile` by path, so it is actually for the unredirected file.
	                    // This lets us know if the unredirected file has changed. If it has we should break the redirect.
	                    if (newSourceFile !== oldSourceFile.redirectInfo.unredirected) {
	                        // Underlying file has changed. Might not redirect anymore. Must rebuild program.
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    fileChanged = false;
	                    newSourceFile = oldSourceFile; // Use the redirect.
	                }
	                else if (oldProgram.redirectTargetsSet.has(oldSourceFile.path)) {
	                    // If a redirected-to source file changes, the redirect may be broken.
	                    if (newSourceFile !== oldSourceFile) {
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    fileChanged = false;
	                }
	                else {
	                    fileChanged = newSourceFile !== oldSourceFile;
	                }
	                newSourceFile.path = oldSourceFile.path;
	                filePaths.push(newSourceFile.path);
	                var packageName = oldProgram.sourceFileToPackageName.get(oldSourceFile.path);
	                if (packageName !== undefined) {
	                    // If there are 2 different source files for the same package name and at least one of them changes,
	                    // they might become redirects. So we must rebuild the program.
	                    var prevKind = seenPackageNames.get(packageName);
	                    var newKind = fileChanged ? 1 /* Modified */ : 0 /* Exists */;
	                    if ((prevKind !== undefined && newKind === 1 /* Modified */) || prevKind === 1 /* Modified */) {
	                        return oldProgram.structureIsReused = 0 /* Not */;
	                    }
	                    seenPackageNames.set(packageName, newKind);
	                }
	                if (fileChanged) {
	                    // The `newSourceFile` object was created for the new program.
	                    if (oldSourceFile.hasNoDefaultLib !== newSourceFile.hasNoDefaultLib) {
	                        // value of no-default-lib has changed
	                        // this will affect if default library is injected into the list of files
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // check tripleslash references
	                    if (!ts.arrayIsEqualTo(oldSourceFile.referencedFiles, newSourceFile.referencedFiles, fileReferenceIsEqualTo)) {
	                        // tripleslash references has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // check imports and module augmentations
	                    collectExternalModuleReferences(newSourceFile);
	                    if (!ts.arrayIsEqualTo(oldSourceFile.imports, newSourceFile.imports, moduleNameIsEqualTo)) {
	                        // imports has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if (!ts.arrayIsEqualTo(oldSourceFile.moduleAugmentations, newSourceFile.moduleAugmentations, moduleNameIsEqualTo)) {
	                        // moduleAugmentations has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if ((oldSourceFile.flags & 1572864 /* PermanentlySetIncrementalFlags */) !== (newSourceFile.flags & 1572864 /* PermanentlySetIncrementalFlags */)) {
	                        // dynamicImport has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    if (!ts.arrayIsEqualTo(oldSourceFile.typeReferenceDirectives, newSourceFile.typeReferenceDirectives, fileReferenceIsEqualTo)) {
	                        // 'types' references has changed
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                    }
	                    // tentatively approve the file
	                    modifiedSourceFiles.push({ oldFile: oldSourceFile, newFile: newSourceFile });
	                }
	                else if (hasInvalidatedResolution(oldSourceFile.path)) {
	                    // 'module/types' references could have changed
	                    oldProgram.structureIsReused = 1 /* SafeModules */;
	                    // add file to the modified list so that we will resolve it later
	                    modifiedSourceFiles.push({ oldFile: oldSourceFile, newFile: newSourceFile });
	                }
	                // if file has passed all checks it should be safe to reuse it
	                newSourceFiles.push(newSourceFile);
	            }
	            if (oldProgram.structureIsReused !== 2 /* Completely */) {
	                return oldProgram.structureIsReused;
	            }
	            modifiedFilePaths = modifiedSourceFiles.map(function (f) { return f.newFile.path; });
	            // try to verify results of module resolution
	            for (var _a = 0, modifiedSourceFiles_1 = modifiedSourceFiles; _a < modifiedSourceFiles_1.length; _a++) {
	                var _b = modifiedSourceFiles_1[_a], oldSourceFile = _b.oldFile, newSourceFile = _b.newFile;
	                var newSourceFilePath = ts.getNormalizedAbsolutePath(newSourceFile.fileName, currentDirectory);
	                if (resolveModuleNamesWorker) {
	                    var moduleNames = getModuleNames(newSourceFile);
	                    var oldProgramState = { program: oldProgram, oldSourceFile: oldSourceFile, modifiedFilePaths: modifiedFilePaths };
	                    var resolutions = resolveModuleNamesReusingOldState(moduleNames, newSourceFilePath, newSourceFile, oldProgramState);
	                    // ensure that module resolution results are still correct
	                    var resolutionsChanged = ts.hasChangesInResolutions(moduleNames, resolutions, oldSourceFile.resolvedModules, ts.moduleResolutionIsEqualTo);
	                    if (resolutionsChanged) {
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                        newSourceFile.resolvedModules = ts.zipToMap(moduleNames, resolutions);
	                    }
	                    else {
	                        newSourceFile.resolvedModules = oldSourceFile.resolvedModules;
	                    }
	                }
	                if (resolveTypeReferenceDirectiveNamesWorker) {
	                    var typesReferenceDirectives = ts.map(newSourceFile.typeReferenceDirectives, function (x) { return x.fileName; });
	                    var resolutions = resolveTypeReferenceDirectiveNamesWorker(typesReferenceDirectives, newSourceFilePath);
	                    // ensure that types resolutions are still correct
	                    var resolutionsChanged = ts.hasChangesInResolutions(typesReferenceDirectives, resolutions, oldSourceFile.resolvedTypeReferenceDirectiveNames, ts.typeDirectiveIsEqualTo);
	                    if (resolutionsChanged) {
	                        oldProgram.structureIsReused = 1 /* SafeModules */;
	                        newSourceFile.resolvedTypeReferenceDirectiveNames = ts.zipToMap(typesReferenceDirectives, resolutions);
	                    }
	                    else {
	                        newSourceFile.resolvedTypeReferenceDirectiveNames = oldSourceFile.resolvedTypeReferenceDirectiveNames;
	                    }
	                }
	            }
	            if (oldProgram.structureIsReused !== 2 /* Completely */) {
	                return oldProgram.structureIsReused;
	            }
	            if (host.hasChangedAutomaticTypeDirectiveNames) {
	                return oldProgram.structureIsReused = 1 /* SafeModules */;
	            }
	            missingFilePaths = oldProgram.getMissingFilePaths();
	            // update fileName -> file mapping
	            for (var i = 0; i < newSourceFiles.length; i++) {
	                filesByName.set(filePaths[i], newSourceFiles[i]);
	                // Set the file as found during node modules search if it was found that way in old progra,
	                if (oldProgram.isSourceFileFromExternalLibrary(oldProgram.getSourceFileByPath(filePaths[i]))) {
	                    sourceFilesFoundSearchingNodeModules.set(filePaths[i], true);
	                }
	            }
	            files = newSourceFiles;
	            fileProcessingDiagnostics = oldProgram.getFileProcessingDiagnostics();
	            for (var _c = 0, modifiedSourceFiles_2 = modifiedSourceFiles; _c < modifiedSourceFiles_2.length; _c++) {
	                var modifiedFile = modifiedSourceFiles_2[_c];
	                fileProcessingDiagnostics.reattachFileDiagnostics(modifiedFile.newFile);
	            }
	            resolvedTypeReferenceDirectives = oldProgram.getResolvedTypeReferenceDirectives();
	            sourceFileToPackageName = oldProgram.sourceFileToPackageName;
	            redirectTargetsSet = oldProgram.redirectTargetsSet;
	            return oldProgram.structureIsReused = 2 /* Completely */;
	        }
	        function getEmitHost(writeFileCallback) {
	            return __assign({ getPrependNodes: getPrependNodes,
	                getCanonicalFileName: getCanonicalFileName, getCommonSourceDirectory: program.getCommonSourceDirectory, getCompilerOptions: program.getCompilerOptions, getCurrentDirectory: function () { return currentDirectory; }, getNewLine: function () { return host.getNewLine(); }, getSourceFile: program.getSourceFile, getSourceFileByPath: program.getSourceFileByPath, getSourceFiles: program.getSourceFiles, isSourceFileFromExternalLibrary: isSourceFileFromExternalLibrary, writeFile: writeFileCallback || (function (fileName, data, writeByteOrderMark, onError, sourceFiles) { return host.writeFile(fileName, data, writeByteOrderMark, onError, sourceFiles); }), isEmitBlocked: isEmitBlocked, readFile: function (f) { return host.readFile(f); }, fileExists: function (f) { return host.fileExists(f); } }, (host.directoryExists ? { directoryExists: function (f) { return host.directoryExists(f); } } : {}));
	        }
	        function getProjectReferences() {
	            if (!resolvedProjectReferences)
	                return;
	            return resolvedProjectReferences;
	        }
	        function getPrependNodes() {
	            if (!projectReferences) {
	                return ts.emptyArray;
	            }
	            var nodes = [];
	            for (var i = 0; i < projectReferences.length; i++) {
	                var ref = projectReferences[i];
	                var resolvedRefOpts = resolvedProjectReferences[i].commandLine;
	                if (ref.prepend && resolvedRefOpts && resolvedRefOpts.options) {
	                    // Upstream project didn't have outFile set -- skip (error will have been issued earlier)
	                    if (!resolvedRefOpts.options.outFile)
	                        continue;
	                    var dtsFilename = ts.changeExtension(resolvedRefOpts.options.outFile, ".d.ts");
	                    var js = host.readFile(resolvedRefOpts.options.outFile) || "/* Input file " + resolvedRefOpts.options.outFile + " was missing */\r\n";
	                    var dts = host.readFile(dtsFilename) || "/* Input file " + dtsFilename + " was missing */\r\n";
	                    var node = ts.createInputFiles(js, dts);
	                    nodes.push(node);
	                }
	            }
	            return nodes;
	        }
	        function isSourceFileFromExternalLibrary(file) {
	            return sourceFilesFoundSearchingNodeModules.get(file.path);
	        }
	        function isSourceFileDefaultLibrary(file) {
	            if (file.hasNoDefaultLib) {
	                return true;
	            }
	            if (!options.noLib) {
	                return false;
	            }
	            // If '--lib' is not specified, include default library file according to '--target'
	            // otherwise, using options specified in '--lib' instead of '--target' default library file
	            var equalityComparer = host.useCaseSensitiveFileNames() ? ts.equateStringsCaseSensitive : ts.equateStringsCaseInsensitive;
	            if (!options.lib) {
	                return equalityComparer(file.fileName, getDefaultLibraryFileName());
	            }
	            else {
	                return ts.forEach(options.lib, function (libFileName) { return equalityComparer(file.fileName, ts.combinePaths(defaultLibraryPath, libFileName)); });
	            }
	        }
	        function getDiagnosticsProducingTypeChecker() {
	            return diagnosticsProducingTypeChecker || (diagnosticsProducingTypeChecker = ts.createTypeChecker(program, /*produceDiagnostics:*/ true));
	        }
	        function dropDiagnosticsProducingTypeChecker() {
	            diagnosticsProducingTypeChecker = undefined;
	        }
	        function getTypeChecker() {
	            return noDiagnosticsTypeChecker || (noDiagnosticsTypeChecker = ts.createTypeChecker(program, /*produceDiagnostics:*/ false));
	        }
	        function emit(sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, transformers) {
	            return runWithCancellationToken(function () { return emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, transformers); });
	        }
	        function isEmitBlocked(emitFileName) {
	            return hasEmitBlockingDiagnostics.has(toPath(emitFileName));
	        }
	        function emitWorker(program, sourceFile, writeFileCallback, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            var declarationDiagnostics = [];
	            if (!emitOnlyDtsFiles) {
	                if (options.noEmit) {
	                    return { diagnostics: declarationDiagnostics, sourceMaps: undefined, emittedFiles: undefined, emitSkipped: true };
	                }
	                // If the noEmitOnError flag is set, then check if we have any errors so far.  If so,
	                // immediately bail out.  Note that we pass 'undefined' for 'sourceFile' so that we
	                // get any preEmit diagnostics, not just the ones
	                if (options.noEmitOnError) {
	                    var diagnostics = program.getOptionsDiagnostics(cancellationToken).concat(program.getSyntacticDiagnostics(sourceFile, cancellationToken), program.getGlobalDiagnostics(cancellationToken), program.getSemanticDiagnostics(sourceFile, cancellationToken));
	                    if (diagnostics.length === 0 && program.getCompilerOptions().declaration) {
	                        declarationDiagnostics = program.getDeclarationDiagnostics(/*sourceFile*/ undefined, cancellationToken);
	                    }
	                    if (diagnostics.length > 0 || declarationDiagnostics.length > 0) {
	                        return {
	                            diagnostics: ts.concatenate(diagnostics, declarationDiagnostics),
	                            sourceMaps: undefined,
	                            emittedFiles: undefined,
	                            emitSkipped: true
	                        };
	                    }
	                }
	            }
	            // Create the emit resolver outside of the "emitTime" tracking code below.  That way
	            // any cost associated with it (like type checking) are appropriate associated with
	            // the type-checking counter.
	            //
	            // If the -out option is specified, we should not pass the source file to getEmitResolver.
	            // This is because in the -out scenario all files need to be emitted, and therefore all
	            // files need to be type checked. And the way to specify that all files need to be type
	            // checked is to not pass the file to getEmitResolver.
	            var emitResolver = getDiagnosticsProducingTypeChecker().getEmitResolver((options.outFile || options.out) ? undefined : sourceFile, cancellationToken);
	            ts.performance.mark("beforeEmit");
	            var transformers = emitOnlyDtsFiles ? [] : ts.getTransformers(options, customTransformers);
	            var emitResult = ts.emitFiles(emitResolver, getEmitHost(writeFileCallback), sourceFile, emitOnlyDtsFiles, transformers, customTransformers && customTransformers.afterDeclarations);
	            ts.performance.mark("afterEmit");
	            ts.performance.measure("Emit", "beforeEmit", "afterEmit");
	            return emitResult;
	        }
	        function getSourceFile(fileName) {
	            return getSourceFileByPath(toPath(fileName));
	        }
	        function getSourceFileByPath(path) {
	            return filesByName.get(path);
	        }
	        function getDiagnosticsHelper(sourceFile, getDiagnostics, cancellationToken) {
	            if (sourceFile) {
	                return getDiagnostics(sourceFile, cancellationToken);
	            }
	            return ts.sortAndDeduplicateDiagnostics(ts.flatMap(program.getSourceFiles(), function (sourceFile) {
	                if (cancellationToken) {
	                    cancellationToken.throwIfCancellationRequested();
	                }
	                return getDiagnostics(sourceFile, cancellationToken);
	            }));
	        }
	        function getSyntacticDiagnostics(sourceFile, cancellationToken) {
	            return getDiagnosticsHelper(sourceFile, getSyntacticDiagnosticsForFile, cancellationToken);
	        }
	        function getSemanticDiagnostics(sourceFile, cancellationToken) {
	            return getDiagnosticsHelper(sourceFile, getSemanticDiagnosticsForFile, cancellationToken);
	        }
	        function getDeclarationDiagnostics(sourceFile, cancellationToken) {
	            var options = program.getCompilerOptions();
	            // collect diagnostics from the program only once if either no source file was specified or out/outFile is set (bundled emit)
	            if (!sourceFile || options.out || options.outFile) {
	                return getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
	            }
	            else {
	                return getDiagnosticsHelper(sourceFile, getDeclarationDiagnosticsForFile, cancellationToken);
	            }
	        }
	        function getSyntacticDiagnosticsForFile(sourceFile) {
	            // For JavaScript files, we report semantic errors for using TypeScript-only
	            // constructs from within a JavaScript file as syntactic errors.
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                if (!sourceFile.additionalSyntacticDiagnostics) {
	                    sourceFile.additionalSyntacticDiagnostics = getJavaScriptSyntacticDiagnosticsForFile(sourceFile);
	                }
	                return ts.concatenate(sourceFile.additionalSyntacticDiagnostics, sourceFile.parseDiagnostics);
	            }
	            return sourceFile.parseDiagnostics;
	        }
	        function runWithCancellationToken(func) {
	            try {
	                return func();
	            }
	            catch (e) {
	                if (e instanceof ts.OperationCanceledException) {
	                    // We were canceled while performing the operation.  Because our type checker
	                    // might be a bad state, we need to throw it away.
	                    //
	                    // Note: we are overly aggressive here.  We do not actually *have* to throw away
	                    // the "noDiagnosticsTypeChecker".  However, for simplicity, i'd like to keep
	                    // the lifetimes of these two TypeCheckers the same.  Also, we generally only
	                    // cancel when the user has made a change anyways.  And, in that case, we (the
	                    // program instance) will get thrown away anyways.  So trying to keep one of
	                    // these type checkers alive doesn't serve much purpose.
	                    noDiagnosticsTypeChecker = undefined;
	                    diagnosticsProducingTypeChecker = undefined;
	                }
	                throw e;
	            }
	        }
	        function getSemanticDiagnosticsForFile(sourceFile, cancellationToken) {
	            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedSemanticDiagnosticsForFile, getSemanticDiagnosticsForFileNoCache);
	        }
	        function getSemanticDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
	            return runWithCancellationToken(function () {
	                // If skipLibCheck is enabled, skip reporting errors if file is a declaration file.
	                // If skipDefaultLibCheck is enabled, skip reporting errors if file contains a
	                // '/// <reference no-default-lib="true"/>' directive.
	                if (options.skipLibCheck && sourceFile.isDeclarationFile || options.skipDefaultLibCheck && sourceFile.hasNoDefaultLib) {
	                    return ts.emptyArray;
	                }
	                var typeChecker = getDiagnosticsProducingTypeChecker();
	                ts.Debug.assert(!!sourceFile.bindDiagnostics);
	                var isCheckJs = ts.isCheckJsEnabledForFile(sourceFile, options);
	                // By default, only type-check .ts, .tsx, 'Deferred' and 'External' files (external files are added by plugins)
	                var includeBindAndCheckDiagnostics = sourceFile.scriptKind === 3 /* TS */ || sourceFile.scriptKind === 4 /* TSX */ ||
	                    sourceFile.scriptKind === 5 /* External */ || isCheckJs || sourceFile.scriptKind === 7 /* Deferred */;
	                var bindDiagnostics = includeBindAndCheckDiagnostics ? sourceFile.bindDiagnostics : ts.emptyArray;
	                var checkDiagnostics = includeBindAndCheckDiagnostics ? typeChecker.getDiagnostics(sourceFile, cancellationToken) : ts.emptyArray;
	                var fileProcessingDiagnosticsInFile = fileProcessingDiagnostics.getDiagnostics(sourceFile.fileName);
	                var programDiagnosticsInFile = programDiagnostics.getDiagnostics(sourceFile.fileName);
	                var diagnostics;
	                for (var _i = 0, _a = [bindDiagnostics, checkDiagnostics, fileProcessingDiagnosticsInFile, programDiagnosticsInFile, isCheckJs ? sourceFile.jsDocDiagnostics : undefined]; _i < _a.length; _i++) {
	                    var diags = _a[_i];
	                    if (diags) {
	                        for (var _b = 0, diags_1 = diags; _b < diags_1.length; _b++) {
	                            var diag = diags_1[_b];
	                            if (shouldReportDiagnostic(diag)) {
	                                diagnostics = ts.append(diagnostics, diag);
	                            }
	                        }
	                    }
	                }
	                return diagnostics;
	            });
	        }
	        /**
	         * Skip errors if previous line start with '// @ts-ignore' comment, not counting non-empty non-comment lines
	         */
	        function shouldReportDiagnostic(diagnostic) {
	            var file = diagnostic.file, start = diagnostic.start;
	            if (file) {
	                var lineStarts = ts.getLineStarts(file);
	                var line = ts.computeLineAndCharacterOfPosition(lineStarts, start).line;
	                while (line > 0) {
	                    var previousLineText = file.text.slice(lineStarts[line - 1], lineStarts[line]);
	                    var result = ignoreDiagnosticCommentRegEx.exec(previousLineText);
	                    if (!result) {
	                        // non-empty line
	                        return true;
	                    }
	                    if (result[3]) {
	                        // @ts-ignore
	                        return false;
	                    }
	                    line--;
	                }
	            }
	            return true;
	        }
	        function getJavaScriptSyntacticDiagnosticsForFile(sourceFile) {
	            return runWithCancellationToken(function () {
	                var diagnostics = [];
	                var parent = sourceFile;
	                walk(sourceFile);
	                return diagnostics;
	                function walk(node) {
	                    // Return directly from the case if the given node doesnt want to visit each child
	                    // Otherwise break to visit each child
	                    switch (parent.kind) {
	                        case 148 /* Parameter */:
	                        case 151 /* PropertyDeclaration */:
	                            if (parent.questionToken === node) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, "?"));
	                                return;
	                            }
	                        // falls through
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 191 /* FunctionExpression */:
	                        case 233 /* FunctionDeclaration */:
	                        case 192 /* ArrowFunction */:
	                        case 231 /* VariableDeclaration */:
	                            // type annotation
	                            if (parent.type === node) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.types_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                    }
	                    switch (node.kind) {
	                        case 242 /* ImportEqualsDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.import_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 248 /* ExportAssignment */:
	                            if (node.isExportEquals) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.export_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 267 /* HeritageClause */:
	                            var heritageClause = node;
	                            if (heritageClause.token === 108 /* ImplementsKeyword */) {
	                                diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.implements_clauses_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 235 /* InterfaceDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.interface_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 238 /* ModuleDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.module_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 236 /* TypeAliasDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.type_aliases_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 237 /* EnumDeclaration */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.enum_declarations_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 208 /* NonNullExpression */:
	                            diagnostics.push(createDiagnosticForNode(node, ts.Diagnostics.non_null_assertions_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 207 /* AsExpression */:
	                            diagnostics.push(createDiagnosticForNode(node.type, ts.Diagnostics.type_assertion_expressions_can_only_be_used_in_a_ts_file));
	                            return;
	                        case 189 /* TypeAssertionExpression */:
	                            ts.Debug.fail(); // Won't parse these in a JS file anyway, as they are interpreted as JSX.
	                    }
	                    var prevParent = parent;
	                    parent = node;
	                    ts.forEachChild(node, walk, walkArray);
	                    parent = prevParent;
	                }
	                function walkArray(nodes) {
	                    if (parent.decorators === nodes && !options.experimentalDecorators) {
	                        diagnostics.push(createDiagnosticForNode(parent, ts.Diagnostics.Experimental_support_for_decorators_is_a_feature_that_is_subject_to_change_in_a_future_release_Set_the_experimentalDecorators_option_to_remove_this_warning));
	                    }
	                    switch (parent.kind) {
	                        case 234 /* ClassDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 154 /* Constructor */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 191 /* FunctionExpression */:
	                        case 233 /* FunctionDeclaration */:
	                        case 192 /* ArrowFunction */:
	                            // Check type parameters
	                            if (nodes === parent.typeParameters) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.type_parameter_declarations_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                        // falls through
	                        case 213 /* VariableStatement */:
	                            // Check modifiers
	                            if (nodes === parent.modifiers) {
	                                return checkModifiers(nodes, parent.kind === 213 /* VariableStatement */);
	                            }
	                            break;
	                        case 151 /* PropertyDeclaration */:
	                            // Check modifiers of property declaration
	                            if (nodes === parent.modifiers) {
	                                for (var _i = 0, _a = nodes; _i < _a.length; _i++) {
	                                    var modifier = _a[_i];
	                                    if (modifier.kind !== 115 /* StaticKeyword */) {
	                                        diagnostics.push(createDiagnosticForNode(modifier, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, ts.tokenToString(modifier.kind)));
	                                    }
	                                }
	                                return;
	                            }
	                            break;
	                        case 148 /* Parameter */:
	                            // Check modifiers of parameter declaration
	                            if (nodes === parent.modifiers) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.parameter_modifiers_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                        case 186 /* CallExpression */:
	                        case 187 /* NewExpression */:
	                        case 206 /* ExpressionWithTypeArguments */:
	                        case 255 /* JsxSelfClosingElement */:
	                        case 256 /* JsxOpeningElement */:
	                            // Check type arguments
	                            if (nodes === parent.typeArguments) {
	                                diagnostics.push(createDiagnosticForNodeArray(nodes, ts.Diagnostics.type_arguments_can_only_be_used_in_a_ts_file));
	                                return;
	                            }
	                            break;
	                    }
	                    for (var _b = 0, nodes_6 = nodes; _b < nodes_6.length; _b++) {
	                        var node = nodes_6[_b];
	                        walk(node);
	                    }
	                }
	                function checkModifiers(modifiers, isConstValid) {
	                    for (var _i = 0, modifiers_1 = modifiers; _i < modifiers_1.length; _i++) {
	                        var modifier = modifiers_1[_i];
	                        switch (modifier.kind) {
	                            case 76 /* ConstKeyword */:
	                                if (isConstValid) {
	                                    continue;
	                                }
	                            // to report error,
	                            // falls through
	                            case 114 /* PublicKeyword */:
	                            case 112 /* PrivateKeyword */:
	                            case 113 /* ProtectedKeyword */:
	                            case 132 /* ReadonlyKeyword */:
	                            case 124 /* DeclareKeyword */:
	                            case 117 /* AbstractKeyword */:
	                                diagnostics.push(createDiagnosticForNode(modifier, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, ts.tokenToString(modifier.kind)));
	                                break;
	                            // These are all legal modifiers.
	                            case 115 /* StaticKeyword */:
	                            case 84 /* ExportKeyword */:
	                            case 79 /* DefaultKeyword */:
	                        }
	                    }
	                }
	                function createDiagnosticForNodeArray(nodes, message, arg0, arg1, arg2) {
	                    var start = nodes.pos;
	                    return ts.createFileDiagnostic(sourceFile, start, nodes.end - start, message, arg0, arg1, arg2);
	                }
	                // Since these are syntactic diagnostics, parent might not have been set
	                // this means the sourceFile cannot be infered from the node
	                function createDiagnosticForNode(node, message, arg0, arg1, arg2) {
	                    return ts.createDiagnosticForNodeInSourceFile(sourceFile, node, message, arg0, arg1, arg2);
	                }
	            });
	        }
	        function getDeclarationDiagnosticsWorker(sourceFile, cancellationToken) {
	            return getAndCacheDiagnostics(sourceFile, cancellationToken, cachedDeclarationDiagnosticsForFile, getDeclarationDiagnosticsForFileNoCache);
	        }
	        function getDeclarationDiagnosticsForFileNoCache(sourceFile, cancellationToken) {
	            return runWithCancellationToken(function () {
	                var resolver = getDiagnosticsProducingTypeChecker().getEmitResolver(sourceFile, cancellationToken);
	                // Don't actually write any files since we're just getting diagnostics.
	                return ts.getDeclarationDiagnostics(getEmitHost(ts.noop), resolver, sourceFile);
	            });
	        }
	        function getAndCacheDiagnostics(sourceFile, cancellationToken, cache, getDiagnostics) {
	            var cachedResult = sourceFile
	                ? cache.perFile && cache.perFile.get(sourceFile.path)
	                : cache.allDiagnostics;
	            if (cachedResult) {
	                return cachedResult;
	            }
	            var result = getDiagnostics(sourceFile, cancellationToken) || ts.emptyArray;
	            if (sourceFile) {
	                if (!cache.perFile) {
	                    cache.perFile = ts.createMap();
	                }
	                cache.perFile.set(sourceFile.path, result);
	            }
	            else {
	                cache.allDiagnostics = result;
	            }
	            return result;
	        }
	        function getDeclarationDiagnosticsForFile(sourceFile, cancellationToken) {
	            return sourceFile.isDeclarationFile ? [] : getDeclarationDiagnosticsWorker(sourceFile, cancellationToken);
	        }
	        function getOptionsDiagnostics() {
	            return ts.sortAndDeduplicateDiagnostics(ts.concatenate(fileProcessingDiagnostics.getGlobalDiagnostics(), ts.concatenate(programDiagnostics.getGlobalDiagnostics(), options.configFile ? programDiagnostics.getDiagnostics(options.configFile.fileName) : [])));
	        }
	        function getGlobalDiagnostics() {
	            return ts.sortAndDeduplicateDiagnostics(getDiagnosticsProducingTypeChecker().getGlobalDiagnostics().slice());
	        }
	        function getConfigFileParsingDiagnostics() {
	            return configFileParsingDiagnostics || ts.emptyArray;
	        }
	        function processRootFile(fileName, isDefaultLib) {
	            processSourceFile(ts.normalizePath(fileName), isDefaultLib, /*packageId*/ undefined);
	        }
	        function fileReferenceIsEqualTo(a, b) {
	            return a.fileName === b.fileName;
	        }
	        function moduleNameIsEqualTo(a, b) {
	            return a.kind === 71 /* Identifier */
	                ? b.kind === 71 /* Identifier */ && a.escapedText === b.escapedText
	                : b.kind === 9 /* StringLiteral */ && a.text === b.text;
	        }
	        function collectExternalModuleReferences(file) {
	            if (file.imports) {
	                return;
	            }
	            var isJavaScriptFile = ts.isSourceFileJavaScript(file);
	            var isExternalModuleFile = ts.isExternalModule(file);
	            // file.imports may not be undefined if there exists dynamic import
	            var imports;
	            var moduleAugmentations;
	            var ambientModules;
	            // If we are importing helpers, we need to add a synthetic reference to resolve the
	            // helpers library.
	            if (options.importHelpers
	                && (options.isolatedModules || isExternalModuleFile)
	                && !file.isDeclarationFile) {
	                // synthesize 'import "tslib"' declaration
	                var externalHelpersModuleReference = ts.createLiteral(ts.externalHelpersModuleNameText);
	                var importDecl = ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, /*importClause*/ undefined, externalHelpersModuleReference);
	                ts.addEmitFlags(importDecl, 67108864 /* NeverApplyImportHelper */);
	                externalHelpersModuleReference.parent = importDecl;
	                importDecl.parent = file;
	                imports = [externalHelpersModuleReference];
	            }
	            for (var _i = 0, _a = file.statements; _i < _a.length; _i++) {
	                var node = _a[_i];
	                collectModuleReferences(node, /*inAmbientModule*/ false);
	                if ((file.flags & 524288 /* PossiblyContainsDynamicImport */) || isJavaScriptFile) {
	                    collectDynamicImportOrRequireCalls(node);
	                }
	            }
	            if ((file.flags & 524288 /* PossiblyContainsDynamicImport */) || isJavaScriptFile) {
	                collectDynamicImportOrRequireCalls(file.endOfFileToken);
	            }
	            file.imports = imports || ts.emptyArray;
	            file.moduleAugmentations = moduleAugmentations || ts.emptyArray;
	            file.ambientModuleNames = ambientModules || ts.emptyArray;
	            return;
	            function collectModuleReferences(node, inAmbientModule) {
	                if (ts.isAnyImportOrReExport(node)) {
	                    var moduleNameExpr = ts.getExternalModuleName(node);
	                    // TypeScript 1.0 spec (April 2014): 12.1.6
	                    // An ExternalImportDeclaration in an AmbientExternalModuleDeclaration may reference other external modules
	                    // only through top - level external module names. Relative external module names are not permitted.
	                    if (moduleNameExpr && ts.isStringLiteral(moduleNameExpr) && moduleNameExpr.text && (!inAmbientModule || !ts.isExternalModuleNameRelative(moduleNameExpr.text))) {
	                        imports = ts.append(imports, moduleNameExpr);
	                    }
	                }
	                else if (ts.isModuleDeclaration(node)) {
	                    if (ts.isAmbientModule(node) && (inAmbientModule || ts.hasModifier(node, 2 /* Ambient */) || file.isDeclarationFile)) {
	                        var nameText = ts.getTextOfIdentifierOrLiteral(node.name);
	                        // Ambient module declarations can be interpreted as augmentations for some existing external modules.
	                        // This will happen in two cases:
	                        // - if current file is external module then module augmentation is a ambient module declaration defined in the top level scope
	                        // - if current file is not external module then module augmentation is an ambient module declaration with non-relative module name
	                        //   immediately nested in top level ambient module declaration .
	                        if (isExternalModuleFile || (inAmbientModule && !ts.isExternalModuleNameRelative(nameText))) {
	                            (moduleAugmentations || (moduleAugmentations = [])).push(node.name);
	                        }
	                        else if (!inAmbientModule) {
	                            if (file.isDeclarationFile) {
	                                // for global .d.ts files record name of ambient module
	                                (ambientModules || (ambientModules = [])).push(nameText);
	                            }
	                            // An AmbientExternalModuleDeclaration declares an external module.
	                            // This type of declaration is permitted only in the global module.
	                            // The StringLiteral must specify a top - level external module name.
	                            // Relative external module names are not permitted
	                            // NOTE: body of ambient module is always a module block, if it exists
	                            var body = node.body;
	                            if (body) {
	                                for (var _i = 0, _a = body.statements; _i < _a.length; _i++) {
	                                    var statement = _a[_i];
	                                    collectModuleReferences(statement, /*inAmbientModule*/ true);
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	            function collectDynamicImportOrRequireCalls(node) {
	                if (ts.isRequireCall(node, /*checkArgumentIsStringLiteralLike*/ true)) {
	                    imports = ts.append(imports, node.arguments[0]);
	                }
	                // we have to check the argument list has length of 1. We will still have to process these even though we have parsing error.
	                else if (ts.isImportCall(node) && node.arguments.length === 1 && ts.isStringLiteralLike(node.arguments[0])) {
	                    imports = ts.append(imports, node.arguments[0]);
	                }
	                else if (ts.isLiteralImportTypeNode(node)) {
	                    imports = ts.append(imports, node.argument.literal);
	                }
	                collectDynamicImportOrRequireCallsForEachChild(node);
	                if (ts.hasJSDocNodes(node)) {
	                    ts.forEach(node.jsDoc, collectDynamicImportOrRequireCallsForEachChild);
	                }
	            }
	            function collectDynamicImportOrRequireCallsForEachChild(node) {
	                ts.forEachChild(node, collectDynamicImportOrRequireCalls);
	            }
	        }
	        /** This should have similar behavior to 'processSourceFile' without diagnostics or mutation. */
	        function getSourceFileFromReference(referencingFile, ref) {
	            return getSourceFileFromReferenceWorker(resolveTripleslashReference(ref.fileName, referencingFile.fileName), function (fileName) { return filesByName.get(toPath(fileName)); });
	        }
	        function getSourceFileFromReferenceWorker(fileName, getSourceFile, fail, refFile) {
	            if (ts.hasExtension(fileName)) {
	                if (!options.allowNonTsExtensions && !ts.forEach(supportedExtensions, function (extension) { return ts.fileExtensionIs(host.getCanonicalFileName(fileName), extension); })) {
	                    if (fail)
	                        fail(ts.Diagnostics.File_0_has_unsupported_extension_The_only_supported_extensions_are_1, fileName, "'" + supportedExtensions.join("', '") + "'");
	                    return undefined;
	                }
	                var sourceFile = getSourceFile(fileName);
	                if (fail) {
	                    if (!sourceFile) {
	                        var redirect = getProjectReferenceRedirect(fileName);
	                        if (redirect) {
	                            fail(ts.Diagnostics.Output_file_0_has_not_been_built_from_source_file_1, redirect, fileName);
	                        }
	                        else {
	                            fail(ts.Diagnostics.File_0_not_found, fileName);
	                        }
	                    }
	                    else if (refFile && host.getCanonicalFileName(fileName) === host.getCanonicalFileName(refFile.fileName)) {
	                        fail(ts.Diagnostics.A_file_cannot_have_a_reference_to_itself);
	                    }
	                }
	                return sourceFile;
	            }
	            else {
	                var sourceFileNoExtension = options.allowNonTsExtensions && getSourceFile(fileName);
	                if (sourceFileNoExtension)
	                    return sourceFileNoExtension;
	                if (fail && options.allowNonTsExtensions) {
	                    fail(ts.Diagnostics.File_0_not_found, fileName);
	                    return undefined;
	                }
	                var sourceFileWithAddedExtension = ts.forEach(supportedExtensions, function (extension) { return getSourceFile(fileName + extension); });
	                if (fail && !sourceFileWithAddedExtension)
	                    fail(ts.Diagnostics.File_0_not_found, fileName + ".ts" /* Ts */);
	                return sourceFileWithAddedExtension;
	            }
	        }
	        /** This has side effects through `findSourceFile`. */
	        function processSourceFile(fileName, isDefaultLib, packageId, refFile, refPos, refEnd) {
	            getSourceFileFromReferenceWorker(fileName, function (fileName) { return findSourceFile(fileName, toPath(fileName), isDefaultLib, refFile, refPos, refEnd, packageId); }, function (diagnostic) {
	                var args = [];
	                for (var _i = 1; _i < arguments.length; _i++) {
	                    args[_i - 1] = arguments[_i];
	                }
	                fileProcessingDiagnostics.add(refFile !== undefined && refEnd !== undefined && refPos !== undefined
	                    ? ts.createFileDiagnostic.apply(void 0, [refFile, refPos, refEnd - refPos, diagnostic].concat(args)) : ts.createCompilerDiagnostic.apply(void 0, [diagnostic].concat(args)));
	            }, refFile);
	        }
	        function reportFileNamesDifferOnlyInCasingError(fileName, existingFileName, refFile, refPos, refEnd) {
	            if (refFile !== undefined && refPos !== undefined && refEnd !== undefined) {
	                fileProcessingDiagnostics.add(ts.createFileDiagnostic(refFile, refPos, refEnd - refPos, ts.Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, fileName, existingFileName));
	            }
	            else {
	                fileProcessingDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.File_name_0_differs_from_already_included_file_name_1_only_in_casing, fileName, existingFileName));
	            }
	        }
	        function createRedirectSourceFile(redirectTarget, unredirected, fileName, path) {
	            var redirect = Object.create(redirectTarget);
	            redirect.fileName = fileName;
	            redirect.path = path;
	            redirect.redirectInfo = { redirectTarget: redirectTarget, unredirected: unredirected };
	            Object.defineProperties(redirect, {
	                id: {
	                    get: function () { return this.redirectInfo.redirectTarget.id; },
	                    set: function (value) { this.redirectInfo.redirectTarget.id = value; },
	                },
	                symbol: {
	                    get: function () { return this.redirectInfo.redirectTarget.symbol; },
	                    set: function (value) { this.redirectInfo.redirectTarget.symbol = value; },
	                },
	            });
	            return redirect;
	        }
	        // Get source file from normalized fileName
	        function findSourceFile(fileName, path, isDefaultLib, refFile, refPos, refEnd, packageId) {
	            if (filesByName.has(path)) {
	                var file_10 = filesByName.get(path);
	                // try to check if we've already seen this file but with a different casing in path
	                // NOTE: this only makes sense for case-insensitive file systems
	                if (file_10 && options.forceConsistentCasingInFileNames && ts.getNormalizedAbsolutePath(file_10.fileName, currentDirectory) !== ts.getNormalizedAbsolutePath(fileName, currentDirectory)) {
	                    reportFileNamesDifferOnlyInCasingError(fileName, file_10.fileName, refFile, refPos, refEnd);
	                }
	                // If the file was previously found via a node_modules search, but is now being processed as a root file,
	                // then everything it sucks in may also be marked incorrectly, and needs to be checked again.
	                if (file_10 && sourceFilesFoundSearchingNodeModules.get(file_10.path) && currentNodeModulesDepth === 0) {
	                    sourceFilesFoundSearchingNodeModules.set(file_10.path, false);
	                    if (!options.noResolve) {
	                        processReferencedFiles(file_10, isDefaultLib);
	                        processTypeReferenceDirectives(file_10);
	                    }
	                    modulesWithElidedImports.set(file_10.path, false);
	                    processImportedModules(file_10);
	                }
	                // See if we need to reprocess the imports due to prior skipped imports
	                else if (file_10 && modulesWithElidedImports.get(file_10.path)) {
	                    if (currentNodeModulesDepth < maxNodeModuleJsDepth) {
	                        modulesWithElidedImports.set(file_10.path, false);
	                        processImportedModules(file_10);
	                    }
	                }
	                return file_10;
	            }
	            var redirectedPath;
	            if (refFile) {
	                var redirect = getProjectReferenceRedirect(fileName);
	                if (redirect) {
	                    (refFile.redirectedReferences || (refFile.redirectedReferences = [])).push(fileName);
	                    fileName = redirect;
	                    // Once we start redirecting to a file, we can potentially come back to it
	                    // via a back-reference from another file in the .d.ts folder. If that happens we'll
	                    // end up trying to add it to the program *again* because we were tracking it via its
	                    // original (un-redirected) name. So we have to map both the original path and the redirected path
	                    // to the source file we're about to find/create
	                    redirectedPath = toPath(redirect);
	                }
	            }
	            // We haven't looked for this file, do so now and cache result
	            var file = host.getSourceFile(fileName, options.target, function (hostErrorMessage) {
	                if (refFile !== undefined && refPos !== undefined && refEnd !== undefined) {
	                    fileProcessingDiagnostics.add(ts.createFileDiagnostic(refFile, refPos, refEnd - refPos, ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, hostErrorMessage));
	                }
	                else {
	                    fileProcessingDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, hostErrorMessage));
	                }
	            }, shouldCreateNewSourceFile);
	            if (packageId) {
	                var packageIdKey = ts.packageIdToString(packageId);
	                var fileFromPackageId = packageIdToSourceFile.get(packageIdKey);
	                if (fileFromPackageId) {
	                    // Some other SourceFile already exists with this package name and version.
	                    // Instead of creating a duplicate, just redirect to the existing one.
	                    var dupFile = createRedirectSourceFile(fileFromPackageId, file, fileName, path);
	                    redirectTargetsSet.set(fileFromPackageId.path, true);
	                    filesByName.set(path, dupFile);
	                    sourceFileToPackageName.set(path, packageId.name);
	                    files.push(dupFile);
	                    return dupFile;
	                }
	                else if (file) {
	                    // This is the first source file to have this packageId.
	                    packageIdToSourceFile.set(packageIdKey, file);
	                    sourceFileToPackageName.set(path, packageId.name);
	                }
	            }
	            filesByName.set(path, file);
	            if (redirectedPath) {
	                filesByName.set(redirectedPath, file);
	            }
	            if (file) {
	                sourceFilesFoundSearchingNodeModules.set(path, currentNodeModulesDepth > 0);
	                file.path = path;
	                if (host.useCaseSensitiveFileNames()) {
	                    var pathLowerCase = path.toLowerCase();
	                    // for case-sensitive file systems check if we've already seen some file with similar filename ignoring case
	                    var existingFile = filesByNameIgnoreCase.get(pathLowerCase);
	                    if (existingFile) {
	                        reportFileNamesDifferOnlyInCasingError(fileName, existingFile.fileName, refFile, refPos, refEnd);
	                    }
	                    else {
	                        filesByNameIgnoreCase.set(pathLowerCase, file);
	                    }
	                }
	                skipDefaultLib = skipDefaultLib || file.hasNoDefaultLib;
	                if (!options.noResolve) {
	                    processReferencedFiles(file, isDefaultLib);
	                    processTypeReferenceDirectives(file);
	                }
	                // always process imported modules to record module name resolutions
	                processImportedModules(file);
	                if (isDefaultLib) {
	                    files.unshift(file);
	                }
	                else {
	                    files.push(file);
	                }
	            }
	            return file;
	        }
	        function getProjectReferenceRedirect(fileName) {
	            var path = toPath(fileName);
	            // If this file is produced by a referenced project, we need to rewrite it to
	            // look in the output folder of the referenced project rather than the input
	            var normalized = ts.getNormalizedAbsolutePath(fileName, path);
	            var result;
	            projectReferenceRedirects.forEach(function (v, k) {
	                if (result !== undefined) {
	                    return undefined;
	                }
	                if (normalized.indexOf(k) === 0) {
	                    result = ts.changeExtension(fileName.replace(k, v), ".d.ts");
	                }
	            });
	            return result;
	        }
	        function processReferencedFiles(file, isDefaultLib) {
	            ts.forEach(file.referencedFiles, function (ref) {
	                var referencedFileName = resolveTripleslashReference(ref.fileName, file.fileName);
	                processSourceFile(referencedFileName, isDefaultLib, /*packageId*/ undefined, file, ref.pos, ref.end);
	            });
	        }
	        function processTypeReferenceDirectives(file) {
	            // We lower-case all type references because npm automatically lowercases all packages. See GH#9824.
	            var typeDirectives = ts.map(file.typeReferenceDirectives, function (ref) { return ref.fileName.toLocaleLowerCase(); });
	            if (!typeDirectives) {
	                return;
	            }
	            var resolutions = resolveTypeReferenceDirectiveNamesWorker(typeDirectives, file.fileName);
	            for (var i = 0; i < typeDirectives.length; i++) {
	                var ref = file.typeReferenceDirectives[i];
	                var resolvedTypeReferenceDirective = resolutions[i];
	                // store resolved type directive on the file
	                var fileName = ref.fileName.toLocaleLowerCase();
	                ts.setResolvedTypeReferenceDirective(file, fileName, resolvedTypeReferenceDirective);
	                processTypeReferenceDirective(fileName, resolvedTypeReferenceDirective, file, ref.pos, ref.end);
	            }
	        }
	        function processTypeReferenceDirective(typeReferenceDirective, resolvedTypeReferenceDirective, refFile, refPos, refEnd) {
	            // If we already found this library as a primary reference - nothing to do
	            var previousResolution = resolvedTypeReferenceDirectives.get(typeReferenceDirective);
	            if (previousResolution && previousResolution.primary) {
	                return;
	            }
	            var saveResolution = true;
	            if (resolvedTypeReferenceDirective) {
	                if (resolvedTypeReferenceDirective.primary) {
	                    // resolved from the primary path
	                    processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, refFile, refPos, refEnd);
	                }
	                else {
	                    // If we already resolved to this file, it must have been a secondary reference. Check file contents
	                    // for sameness and possibly issue an error
	                    if (previousResolution) {
	                        // Don't bother reading the file again if it's the same file.
	                        if (resolvedTypeReferenceDirective.resolvedFileName !== previousResolution.resolvedFileName) {
	                            var otherFileText = host.readFile(resolvedTypeReferenceDirective.resolvedFileName);
	                            if (otherFileText !== getSourceFile(previousResolution.resolvedFileName).text) {
	                                fileProcessingDiagnostics.add(createDiagnostic(refFile, refPos, refEnd, ts.Diagnostics.Conflicting_definitions_for_0_found_at_1_and_2_Consider_installing_a_specific_version_of_this_library_to_resolve_the_conflict, typeReferenceDirective, resolvedTypeReferenceDirective.resolvedFileName, previousResolution.resolvedFileName));
	                            }
	                        }
	                        // don't overwrite previous resolution result
	                        saveResolution = false;
	                    }
	                    else {
	                        // First resolution of this library
	                        processSourceFile(resolvedTypeReferenceDirective.resolvedFileName, /*isDefaultLib*/ false, resolvedTypeReferenceDirective.packageId, refFile, refPos, refEnd);
	                    }
	                }
	            }
	            else {
	                fileProcessingDiagnostics.add(createDiagnostic(refFile, refPos, refEnd, ts.Diagnostics.Cannot_find_type_definition_file_for_0, typeReferenceDirective));
	            }
	            if (saveResolution) {
	                resolvedTypeReferenceDirectives.set(typeReferenceDirective, resolvedTypeReferenceDirective);
	            }
	        }
	        function createDiagnostic(refFile, refPos, refEnd, message) {
	            var args = [];
	            for (var _i = 4; _i < arguments.length; _i++) {
	                args[_i - 4] = arguments[_i];
	            }
	            if (refFile === undefined || refPos === undefined || refEnd === undefined) {
	                return ts.createCompilerDiagnostic.apply(void 0, [message].concat(args));
	            }
	            else {
	                return ts.createFileDiagnostic.apply(void 0, [refFile, refPos, refEnd - refPos, message].concat(args));
	            }
	        }
	        function getCanonicalFileName(fileName) {
	            return host.getCanonicalFileName(fileName);
	        }
	        function processImportedModules(file) {
	            collectExternalModuleReferences(file);
	            if (file.imports.length || file.moduleAugmentations.length) {
	                // Because global augmentation doesn't have string literal name, we can check for global augmentation as such.
	                var moduleNames = getModuleNames(file);
	                var oldProgramState = { program: oldProgram, oldSourceFile: oldProgram && oldProgram.getSourceFile(file.fileName), modifiedFilePaths: modifiedFilePaths };
	                var resolutions = resolveModuleNamesReusingOldState(moduleNames, ts.getNormalizedAbsolutePath(file.fileName, currentDirectory), file, oldProgramState);
	                ts.Debug.assert(resolutions.length === moduleNames.length);
	                for (var i = 0; i < moduleNames.length; i++) {
	                    var resolution = resolutions[i];
	                    ts.setResolvedModule(file, moduleNames[i], resolution);
	                    if (!resolution) {
	                        continue;
	                    }
	                    var isFromNodeModulesSearch = resolution.isExternalLibraryImport;
	                    var isJsFile = !ts.resolutionExtensionIsTypeScriptOrJson(resolution.extension);
	                    var isJsFileFromNodeModules = isFromNodeModulesSearch && isJsFile;
	                    var resolvedFileName = resolution.resolvedFileName;
	                    if (isFromNodeModulesSearch) {
	                        currentNodeModulesDepth++;
	                    }
	                    // add file to program only if:
	                    // - resolution was successful
	                    // - noResolve is falsy
	                    // - module name comes from the list of imports
	                    // - it's not a top level JavaScript module that exceeded the search max
	                    var elideImport = isJsFileFromNodeModules && currentNodeModulesDepth > maxNodeModuleJsDepth;
	                    // Don't add the file if it has a bad extension (e.g. 'tsx' if we don't have '--allowJs')
	                    // This may still end up being an untyped module -- the file won't be included but imports will be allowed.
	                    var shouldAddFile = resolvedFileName
	                        && !getResolutionDiagnostic(options, resolution)
	                        && !options.noResolve
	                        && i < file.imports.length
	                        && !elideImport
	                        && !(isJsFile && !options.allowJs)
	                        && (ts.isInJavaScriptFile(file.imports[i]) || !(file.imports[i].flags & 2097152 /* JSDoc */));
	                    if (elideImport) {
	                        modulesWithElidedImports.set(file.path, true);
	                    }
	                    else if (shouldAddFile) {
	                        var path = toPath(resolvedFileName);
	                        var pos = ts.skipTrivia(file.text, file.imports[i].pos);
	                        findSourceFile(resolvedFileName, path, /*isDefaultLib*/ false, file, pos, file.imports[i].end, resolution.packageId);
	                    }
	                    if (isFromNodeModulesSearch) {
	                        currentNodeModulesDepth--;
	                    }
	                }
	            }
	            else {
	                // no imports - drop cached module resolutions
	                file.resolvedModules = undefined;
	            }
	        }
	        function computeCommonSourceDirectory(sourceFiles) {
	            var fileNames = [];
	            for (var _i = 0, sourceFiles_2 = sourceFiles; _i < sourceFiles_2.length; _i++) {
	                var file_11 = sourceFiles_2[_i];
	                if (!file_11.isDeclarationFile) {
	                    fileNames.push(file_11.fileName);
	                }
	            }
	            return computeCommonSourceDirectoryOfFilenames(fileNames, currentDirectory, getCanonicalFileName);
	        }
	        function checkSourceFilesBelongToPath(sourceFiles, rootDirectory) {
	            var allFilesBelongToPath = true;
	            if (sourceFiles) {
	                var absoluteRootDirectoryPath = host.getCanonicalFileName(ts.getNormalizedAbsolutePath(rootDirectory, currentDirectory));
	                for (var _i = 0, sourceFiles_3 = sourceFiles; _i < sourceFiles_3.length; _i++) {
	                    var sourceFile = sourceFiles_3[_i];
	                    if (!sourceFile.isDeclarationFile) {
	                        var absoluteSourceFilePath = host.getCanonicalFileName(ts.getNormalizedAbsolutePath(sourceFile.fileName, currentDirectory));
	                        if (absoluteSourceFilePath.indexOf(absoluteRootDirectoryPath) !== 0) {
	                            programDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.File_0_is_not_under_rootDir_1_rootDir_is_expected_to_contain_all_source_files, sourceFile.fileName, options.rootDir));
	                            allFilesBelongToPath = false;
	                        }
	                    }
	                }
	            }
	            return allFilesBelongToPath;
	        }
	        function parseProjectReferenceConfigFile(ref) {
	            // The actual filename (i.e. add "/tsconfig.json" if necessary)
	            var refPath = resolveProjectReferencePath(host, ref);
	            // An absolute path pointing to the containing directory of the config file
	            var basePath = ts.getNormalizedAbsolutePath(ts.getDirectoryPath(refPath), host.getCurrentDirectory());
	            var sourceFile = host.getSourceFile(refPath, 100 /* JSON */);
	            if (sourceFile === undefined) {
	                return undefined;
	            }
	            var commandLine = ts.parseJsonSourceFileConfigFileContent(sourceFile, configParsingHost, basePath, /*existingOptions*/ undefined, refPath);
	            return { commandLine: commandLine, sourceFile: sourceFile };
	        }
	        function addProjectReferenceRedirects(referencedProject, target) {
	            var rootDir = ts.normalizePath(referencedProject.options.rootDir || ts.getDirectoryPath(referencedProject.options.configFilePath));
	            target.set(rootDir, getDeclarationOutputDirectory(referencedProject));
	        }
	        function getDeclarationOutputDirectory(proj) {
	            return proj.options.declarationDir ||
	                proj.options.outDir ||
	                ts.getDirectoryPath(proj.options.configFilePath);
	        }
	        function verifyCompilerOptions() {
	            if (options.strictPropertyInitialization && !options.strictNullChecks) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "strictPropertyInitialization", "strictNullChecks");
	            }
	            if (options.isolatedModules) {
	                if (options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "declaration", "isolatedModules");
	                }
	                if (options.noEmitOnError) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "noEmitOnError", "isolatedModules");
	                }
	                if (options.out) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", "isolatedModules");
	                }
	                if (options.outFile) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "outFile", "isolatedModules");
	                }
	            }
	            if (options.inlineSourceMap) {
	                if (options.sourceMap) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "sourceMap", "inlineSourceMap");
	                }
	                if (options.mapRoot) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "mapRoot", "inlineSourceMap");
	                }
	            }
	            if (options.paths && options.baseUrl === undefined) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_paths_cannot_be_used_without_specifying_baseUrl_option, "paths");
	            }
	            if (options.composite) {
	                if (options.declaration === false) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Composite_projects_may_not_disable_declaration_emit, "declaration");
	                }
	            }
	            if (projectReferences) {
	                for (var i = 0; i < projectReferences.length; i++) {
	                    var ref = projectReferences[i];
	                    var resolvedRefOpts = resolvedProjectReferences[i] && resolvedProjectReferences[i].commandLine.options;
	                    if (resolvedRefOpts === undefined) {
	                        createDiagnosticForReference(i, ts.Diagnostics.File_0_does_not_exist, ref.path);
	                        continue;
	                    }
	                    if (!resolvedRefOpts.composite) {
	                        createDiagnosticForReference(i, ts.Diagnostics.Referenced_project_0_must_have_setting_composite_Colon_true, ref.path);
	                    }
	                    if (ref.prepend) {
	                        if (resolvedRefOpts.outFile) {
	                            if (!host.fileExists(resolvedRefOpts.outFile)) {
	                                createDiagnosticForReference(i, ts.Diagnostics.Output_file_0_from_project_1_does_not_exist, resolvedRefOpts.outFile, ref.path);
	                            }
	                        }
	                        else {
	                            createDiagnosticForReference(i, ts.Diagnostics.Cannot_prepend_project_0_because_it_does_not_have_outFile_set, ref.path);
	                        }
	                    }
	                }
	            }
	            // List of collected files is complete; validate exhautiveness if this is a project with a file list
	            if (options.composite && rootNames.length < files.length) {
	                var normalizedRootNames = rootNames.map(function (r) { return ts.normalizePath(r).toLowerCase(); });
	                var sourceFiles = files.filter(function (f) { return !f.isDeclarationFile; }).map(function (f) { return ts.normalizePath(f.path).toLowerCase(); });
	                var _loop_10 = function (file_12) {
	                    if (normalizedRootNames.every(function (r) { return r !== file_12; })) {
	                        programDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.File_0_is_not_in_project_file_list_Projects_must_list_all_files_or_use_an_include_pattern, file_12));
	                    }
	                };
	                for (var _i = 0, sourceFiles_4 = sourceFiles; _i < sourceFiles_4.length; _i++) {
	                    var file_12 = sourceFiles_4[_i];
	                    _loop_10(file_12);
	                }
	            }
	            if (options.paths) {
	                for (var key in options.paths) {
	                    if (!ts.hasProperty(options.paths, key)) {
	                        continue;
	                    }
	                    if (!ts.hasZeroOrOneAsteriskCharacter(key)) {
	                        createDiagnosticForOptionPaths(/*onKey*/ true, key, ts.Diagnostics.Pattern_0_can_have_at_most_one_Asterisk_character, key);
	                    }
	                    if (ts.isArray(options.paths[key])) {
	                        var len = options.paths[key].length;
	                        if (len === 0) {
	                            createDiagnosticForOptionPaths(/*onKey*/ false, key, ts.Diagnostics.Substitutions_for_pattern_0_shouldn_t_be_an_empty_array, key);
	                        }
	                        for (var i = 0; i < len; i++) {
	                            var subst = options.paths[key][i];
	                            var typeOfSubst = typeof subst;
	                            if (typeOfSubst === "string") {
	                                if (!ts.hasZeroOrOneAsteriskCharacter(subst)) {
	                                    createDiagnosticForOptionPathKeyValue(key, i, ts.Diagnostics.Substitution_0_in_pattern_1_in_can_have_at_most_one_Asterisk_character, subst, key);
	                                }
	                            }
	                            else {
	                                createDiagnosticForOptionPathKeyValue(key, i, ts.Diagnostics.Substitution_0_for_pattern_1_has_incorrect_type_expected_string_got_2, subst, key, typeOfSubst);
	                            }
	                        }
	                    }
	                    else {
	                        createDiagnosticForOptionPaths(/*onKey*/ false, key, ts.Diagnostics.Substitutions_for_pattern_0_should_be_an_array, key);
	                    }
	                }
	            }
	            if (!options.sourceMap && !options.inlineSourceMap) {
	                if (options.inlineSources) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "inlineSources");
	                }
	                if (options.sourceRoot) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_can_only_be_used_when_either_option_inlineSourceMap_or_option_sourceMap_is_provided, "sourceRoot");
	                }
	            }
	            if (options.out && options.outFile) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "out", "outFile");
	            }
	            if (options.mapRoot && !(options.sourceMap || options.declarationMap)) {
	                // Error to specify --mapRoot without --sourcemap
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1_or_option_2, "mapRoot", "sourceMap", "declarationMap");
	            }
	            if (options.declarationDir) {
	                if (!options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "declarationDir", "declaration");
	                }
	                if (options.out || options.outFile) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "declarationDir", options.out ? "out" : "outFile");
	                }
	            }
	            if (options.declarationMap && !options.declaration) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "declarationMap", "declaration");
	            }
	            if (options.lib && options.noLib) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "lib", "noLib");
	            }
	            if (options.noImplicitUseStrict && ts.getStrictOptionValue(options, "alwaysStrict")) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "noImplicitUseStrict", "alwaysStrict");
	            }
	            var languageVersion = options.target || 0 /* ES3 */;
	            var outFile = options.outFile || options.out;
	            var firstNonAmbientExternalModuleSourceFile = ts.forEach(files, function (f) { return ts.isExternalModule(f) && !f.isDeclarationFile ? f : undefined; });
	            if (options.isolatedModules) {
	                if (options.module === ts.ModuleKind.None && languageVersion < 2 /* ES2015 */) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_isolatedModules_can_only_be_used_when_either_option_module_is_provided_or_option_target_is_ES2015_or_higher, "isolatedModules", "target");
	                }
	                var firstNonExternalModuleSourceFile = ts.forEach(files, function (f) { return !ts.isExternalModule(f) && !f.isDeclarationFile ? f : undefined; });
	                if (firstNonExternalModuleSourceFile) {
	                    var span = ts.getErrorSpanForNode(firstNonExternalModuleSourceFile, firstNonExternalModuleSourceFile);
	                    programDiagnostics.add(ts.createFileDiagnostic(firstNonExternalModuleSourceFile, span.start, span.length, ts.Diagnostics.Cannot_compile_namespaces_when_the_isolatedModules_flag_is_provided));
	                }
	            }
	            else if (firstNonAmbientExternalModuleSourceFile && languageVersion < 2 /* ES2015 */ && options.module === ts.ModuleKind.None) {
	                // We cannot use createDiagnosticFromNode because nodes do not have parents yet
	                var span = ts.getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
	                programDiagnostics.add(ts.createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, ts.Diagnostics.Cannot_use_imports_exports_or_module_augmentations_when_module_is_none));
	            }
	            // Cannot specify module gen that isn't amd or system with --out
	            if (outFile) {
	                if (options.module && !(options.module === ts.ModuleKind.AMD || options.module === ts.ModuleKind.System)) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Only_amd_and_system_modules_are_supported_alongside_0, options.out ? "out" : "outFile", "module");
	                }
	                else if (options.module === undefined && firstNonAmbientExternalModuleSourceFile) {
	                    var span = ts.getErrorSpanForNode(firstNonAmbientExternalModuleSourceFile, firstNonAmbientExternalModuleSourceFile.externalModuleIndicator);
	                    programDiagnostics.add(ts.createFileDiagnostic(firstNonAmbientExternalModuleSourceFile, span.start, span.length, ts.Diagnostics.Cannot_compile_modules_using_option_0_unless_the_module_flag_is_amd_or_system, options.out ? "out" : "outFile"));
	                }
	            }
	            if (options.resolveJsonModule) {
	                if (ts.getEmitModuleResolutionKind(options) !== ts.ModuleResolutionKind.NodeJs) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_resolveJsonModule_cannot_be_specified_without_node_module_resolution_strategy, "resolveJsonModule");
	                }
	            }
	            // there has to be common source directory if user specified --outdir || --sourceRoot
	            // if user specified --mapRoot, there needs to be common source directory if there would be multiple files being emitted
	            if (options.outDir || // there is --outDir specified
	                options.sourceRoot || // there is --sourceRoot specified
	                options.mapRoot) { // there is --mapRoot specified
	                // Precalculate and cache the common source directory
	                var dir = getCommonSourceDirectory();
	                // If we failed to find a good common directory, but outDir is specified and at least one of our files is on a windows drive/URL/other resource, add a failure
	                if (options.outDir && dir === "" && ts.forEach(files, function (file) { return ts.getRootLength(file.fileName) > 1; })) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Cannot_find_the_common_subdirectory_path_for_the_input_files, "outDir");
	                }
	            }
	            if (!options.noEmit && options.allowJs && options.declaration) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "allowJs", "declaration");
	            }
	            if (options.checkJs && !options.allowJs) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "checkJs", "allowJs"));
	            }
	            if (options.emitDeclarationOnly) {
	                if (!options.declaration) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDeclarationOnly", "declaration");
	                }
	                if (options.noEmit) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "emitDeclarationOnly", "noEmit");
	                }
	            }
	            if (options.emitDecoratorMetadata &&
	                !options.experimentalDecorators) {
	                createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_without_specifying_option_1, "emitDecoratorMetadata", "experimentalDecorators");
	            }
	            if (options.jsxFactory) {
	                if (options.reactNamespace) {
	                    createDiagnosticForOptionName(ts.Diagnostics.Option_0_cannot_be_specified_with_option_1, "reactNamespace", "jsxFactory");
	                }
	                if (!ts.parseIsolatedEntityName(options.jsxFactory, languageVersion)) {
	                    createOptionValueDiagnostic("jsxFactory", ts.Diagnostics.Invalid_value_for_jsxFactory_0_is_not_a_valid_identifier_or_qualified_name, options.jsxFactory);
	                }
	            }
	            else if (options.reactNamespace && !ts.isIdentifierText(options.reactNamespace, languageVersion)) {
	                createOptionValueDiagnostic("reactNamespace", ts.Diagnostics.Invalid_value_for_reactNamespace_0_is_not_a_valid_identifier, options.reactNamespace);
	            }
	            // If the emit is enabled make sure that every output file is unique and not overwriting any of the input files
	            if (!options.noEmit && !options.suppressOutputPathCheck) {
	                var emitHost = getEmitHost();
	                var emitFilesSeen_1 = ts.createMap();
	                ts.forEachEmittedFile(emitHost, function (emitFileNames) {
	                    if (!options.emitDeclarationOnly) {
	                        verifyEmitFilePath(emitFileNames.jsFilePath, emitFilesSeen_1);
	                    }
	                    verifyEmitFilePath(emitFileNames.declarationFilePath, emitFilesSeen_1);
	                });
	            }
	            // Verify that all the emit files are unique and don't overwrite input files
	            function verifyEmitFilePath(emitFileName, emitFilesSeen) {
	                if (emitFileName) {
	                    var emitFilePath = toPath(emitFileName);
	                    // Report error if the output overwrites input file
	                    if (filesByName.has(emitFilePath)) {
	                        var chain_2;
	                        if (!options.configFilePath) {
	                            // The program is from either an inferred project or an external project
	                            chain_2 = ts.chainDiagnosticMessages(/*details*/ undefined, ts.Diagnostics.Adding_a_tsconfig_json_file_will_help_organize_projects_that_contain_both_TypeScript_and_JavaScript_files_Learn_more_at_https_Colon_Slash_Slashaka_ms_Slashtsconfig);
	                        }
	                        chain_2 = ts.chainDiagnosticMessages(chain_2, ts.Diagnostics.Cannot_write_file_0_because_it_would_overwrite_input_file, emitFileName);
	                        blockEmittingOfFile(emitFileName, ts.createCompilerDiagnosticFromMessageChain(chain_2));
	                    }
	                    var emitFileKey = !host.useCaseSensitiveFileNames() ? emitFilePath.toLocaleLowerCase() : emitFilePath;
	                    // Report error if multiple files write into same file
	                    if (emitFilesSeen.has(emitFileKey)) {
	                        // Already seen the same emit file - report error
	                        blockEmittingOfFile(emitFileName, ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_write_file_0_because_it_would_be_overwritten_by_multiple_input_files, emitFileName));
	                    }
	                    else {
	                        emitFilesSeen.set(emitFileKey, true);
	                    }
	                }
	            }
	        }
	        function createDiagnosticForOptionPathKeyValue(key, valueIndex, message, arg0, arg1, arg2) {
	            var needCompilerDiagnostic = true;
	            var pathsSyntax = getOptionPathsSyntax();
	            for (var _i = 0, pathsSyntax_1 = pathsSyntax; _i < pathsSyntax_1.length; _i++) {
	                var pathProp = pathsSyntax_1[_i];
	                if (ts.isObjectLiteralExpression(pathProp.initializer)) {
	                    for (var _a = 0, _b = ts.getPropertyAssignment(pathProp.initializer, key); _a < _b.length; _a++) {
	                        var keyProps = _b[_a];
	                        if (ts.isArrayLiteralExpression(keyProps.initializer) &&
	                            keyProps.initializer.elements.length > valueIndex) {
	                            programDiagnostics.add(ts.createDiagnosticForNodeInSourceFile(options.configFile, keyProps.initializer.elements[valueIndex], message, arg0, arg1, arg2));
	                            needCompilerDiagnostic = false;
	                        }
	                    }
	                }
	            }
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0, arg1, arg2));
	            }
	        }
	        function createDiagnosticForOptionPaths(onKey, key, message, arg0) {
	            var needCompilerDiagnostic = true;
	            var pathsSyntax = getOptionPathsSyntax();
	            for (var _i = 0, pathsSyntax_2 = pathsSyntax; _i < pathsSyntax_2.length; _i++) {
	                var pathProp = pathsSyntax_2[_i];
	                if (ts.isObjectLiteralExpression(pathProp.initializer) &&
	                    createOptionDiagnosticInObjectLiteralSyntax(pathProp.initializer, onKey, key, /*key2*/ undefined, message, arg0)) {
	                    needCompilerDiagnostic = false;
	                }
	            }
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0));
	            }
	        }
	        function getOptionsSyntaxByName(name) {
	            var compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
	            if (compilerOptionsObjectLiteralSyntax) {
	                return ts.getPropertyAssignment(compilerOptionsObjectLiteralSyntax, name);
	            }
	            return undefined;
	        }
	        function getOptionPathsSyntax() {
	            return getOptionsSyntaxByName("paths") || ts.emptyArray;
	        }
	        function createDiagnosticForOptionName(message, option1, option2, option3) {
	            createDiagnosticForOption(/*onKey*/ true, option1, option2, message, option1, option2, option3);
	        }
	        function createOptionValueDiagnostic(option1, message, arg0) {
	            createDiagnosticForOption(/*onKey*/ false, option1, /*option2*/ undefined, message, arg0);
	        }
	        function createDiagnosticForReference(index, message, arg0, arg1) {
	            var referencesSyntax = getProjectReferencesSyntax();
	            if (referencesSyntax) {
	                if (createOptionDiagnosticInArrayLiteralSyntax(referencesSyntax, index, message, arg0, arg1)) {
	                    return;
	                }
	            }
	            programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0, arg1));
	        }
	        function createDiagnosticForOption(onKey, option1, option2, message, arg0, arg1, arg2) {
	            var compilerOptionsObjectLiteralSyntax = getCompilerOptionsObjectLiteralSyntax();
	            var needCompilerDiagnostic = !compilerOptionsObjectLiteralSyntax ||
	                !createOptionDiagnosticInObjectLiteralSyntax(compilerOptionsObjectLiteralSyntax, onKey, option1, option2, message, arg0, arg1, arg2);
	            if (needCompilerDiagnostic) {
	                programDiagnostics.add(ts.createCompilerDiagnostic(message, arg0, arg1, arg2));
	            }
	        }
	        function getProjectReferencesSyntax() {
	            if (_referencesArrayLiteralSyntax === undefined) {
	                _referencesArrayLiteralSyntax = null; // tslint:disable-line:no-null-keyword
	                if (options.configFile) {
	                    var jsonObjectLiteral = ts.getTsConfigObjectLiteralExpression(options.configFile);
	                    for (var _i = 0, _a = ts.getPropertyAssignment(jsonObjectLiteral, "references"); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        if (ts.isArrayLiteralExpression(prop.initializer)) {
	                            _referencesArrayLiteralSyntax = prop.initializer;
	                            break;
	                        }
	                    }
	                }
	            }
	            return _referencesArrayLiteralSyntax;
	        }
	        function getCompilerOptionsObjectLiteralSyntax() {
	            if (_compilerOptionsObjectLiteralSyntax === undefined) {
	                _compilerOptionsObjectLiteralSyntax = null; // tslint:disable-line:no-null-keyword
	                var jsonObjectLiteral = ts.getTsConfigObjectLiteralExpression(options.configFile);
	                if (jsonObjectLiteral) {
	                    for (var _i = 0, _a = ts.getPropertyAssignment(jsonObjectLiteral, "compilerOptions"); _i < _a.length; _i++) {
	                        var prop = _a[_i];
	                        if (ts.isObjectLiteralExpression(prop.initializer)) {
	                            _compilerOptionsObjectLiteralSyntax = prop.initializer;
	                            break;
	                        }
	                    }
	                }
	            }
	            return _compilerOptionsObjectLiteralSyntax;
	        }
	        function createOptionDiagnosticInObjectLiteralSyntax(objectLiteral, onKey, key1, key2, message, arg0, arg1, arg2) {
	            var props = ts.getPropertyAssignment(objectLiteral, key1, key2);
	            for (var _i = 0, props_2 = props; _i < props_2.length; _i++) {
	                var prop = props_2[_i];
	                programDiagnostics.add(ts.createDiagnosticForNodeInSourceFile(options.configFile, onKey ? prop.name : prop.initializer, message, arg0, arg1, arg2));
	            }
	            return !!props.length;
	        }
	        function createOptionDiagnosticInArrayLiteralSyntax(arrayLiteral, index, message, arg0, arg1, arg2) {
	            if (arrayLiteral.elements.length <= index) {
	                // Out-of-bounds
	                return false;
	            }
	            programDiagnostics.add(ts.createDiagnosticForNodeInSourceFile(options.configFile, arrayLiteral.elements[index], message, arg0, arg1, arg2));
	        }
	        function blockEmittingOfFile(emitFileName, diag) {
	            hasEmitBlockingDiagnostics.set(toPath(emitFileName), true);
	            programDiagnostics.add(diag);
	        }
	        function isEmittedFile(file) {
	            if (options.noEmit) {
	                return false;
	            }
	            // If this is source file, its not emitted file
	            var filePath = toPath(file);
	            if (getSourceFileByPath(filePath)) {
	                return false;
	            }
	            // If options have --outFile or --out just check that
	            var out = options.outFile || options.out;
	            if (out) {
	                return isSameFile(filePath, out) || isSameFile(filePath, ts.removeFileExtension(out) + ".d.ts" /* Dts */);
	            }
	            // If --outDir, check if file is in that directory
	            if (options.outDir) {
	                return ts.containsPath(options.outDir, filePath, currentDirectory, !host.useCaseSensitiveFileNames());
	            }
	            if (ts.fileExtensionIsOneOf(filePath, ts.supportedJavascriptExtensions) || ts.fileExtensionIs(filePath, ".d.ts" /* Dts */)) {
	                // Otherwise just check if sourceFile with the name exists
	                var filePathWithoutExtension = ts.removeFileExtension(filePath);
	                return !!getSourceFileByPath(ts.combinePaths(filePathWithoutExtension, ".ts" /* Ts */)) ||
	                    !!getSourceFileByPath(ts.combinePaths(filePathWithoutExtension, ".tsx" /* Tsx */));
	            }
	            return false;
	        }
	        function isSameFile(file1, file2) {
	            return ts.comparePaths(file1, file2, currentDirectory, !host.useCaseSensitiveFileNames()) === 0 /* EqualTo */;
	        }
	    }
	    ts.createProgram = createProgram;
	    /* @internal */
	    function parseConfigHostFromCompilerHost(host) {
	        return {
	            fileExists: function (f) { return host.fileExists(f); },
	            readDirectory: function (root, extensions, includes, depth) { return host.readDirectory ? host.readDirectory(root, extensions, includes, depth) : []; },
	            readFile: function (f) { return host.readFile(f); },
	            useCaseSensitiveFileNames: host.useCaseSensitiveFileNames(),
	            getCurrentDirectory: function () { return host.getCurrentDirectory(); },
	            onUnRecoverableConfigFileDiagnostic: function () { return undefined; }
	        };
	    }
	    ts.parseConfigHostFromCompilerHost = parseConfigHostFromCompilerHost;
	    /**
	     * Returns the target config filename of a project reference
	     */
	    function resolveProjectReferencePath(host, ref) {
	        if (!host.fileExists(ref.path)) {
	            return ts.combinePaths(ref.path, "tsconfig.json");
	        }
	        return ref.path;
	    }
	    /* @internal */
	    /**
	     * Returns a DiagnosticMessage if we won't include a resolved module due to its extension.
	     * The DiagnosticMessage's parameters are the imported module name, and the filename it resolved to.
	     * This returns a diagnostic even if the module will be an untyped module.
	     */
	    function getResolutionDiagnostic(options, _a) {
	        var extension = _a.extension;
	        switch (extension) {
	            case ".ts" /* Ts */:
	            case ".d.ts" /* Dts */:
	            case ".json" /* Json */: // Since module is resolved to json file only when --resolveJsonModule, we dont need further check
	                // These are always allowed.
	                return undefined;
	            case ".tsx" /* Tsx */:
	                return needJsx();
	            case ".jsx" /* Jsx */:
	                return needJsx() || needAllowJs();
	            case ".js" /* Js */:
	                return needAllowJs();
	        }
	        function needJsx() {
	            return options.jsx ? undefined : ts.Diagnostics.Module_0_was_resolved_to_1_but_jsx_is_not_set;
	        }
	        function needAllowJs() {
	            return options.allowJs || !ts.getStrictOptionValue(options, "noImplicitAny") ? undefined : ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type;
	        }
	    }
	    ts.getResolutionDiagnostic = getResolutionDiagnostic;
	    function getModuleNames(_a) {
	        var imports = _a.imports, moduleAugmentations = _a.moduleAugmentations;
	        var res = imports.map(function (i) { return i.text; });
	        for (var _i = 0, moduleAugmentations_1 = moduleAugmentations; _i < moduleAugmentations_1.length; _i++) {
	            var aug = moduleAugmentations_1[_i];
	            if (aug.kind === 9 /* StringLiteral */) {
	                res.push(aug.text);
	            }
	            // Do nothing if it's an Identifier; we don't need to do module resolution for `declare global`.
	        }
	        return res;
	    }
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers) {
	        var outputFiles = [];
	        var emitResult = program.emit(sourceFile, writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers);
	        return { outputFiles: outputFiles, emitSkipped: emitResult.emitSkipped };
	        function writeFile(fileName, text, writeByteOrderMark) {
	            outputFiles.push({ name: fileName, writeByteOrderMark: writeByteOrderMark, text: text });
	        }
	    }
	    ts.getFileEmitOutput = getFileEmitOutput;
	})(ts || (ts = {}));
	/*@internal*/
	(function (ts) {
	    var BuilderState;
	    (function (BuilderState) {
	        /**
	         * Gets the referenced files for a file from the program with values for the keys as referenced file's path to be true
	         */
	        function getReferencedFiles(program, sourceFile, getCanonicalFileName) {
	            var referencedFiles;
	            // We need to use a set here since the code can contain the same import twice,
	            // but that will only be one dependency.
	            // To avoid invernal conversion, the key of the referencedFiles map must be of type Path
	            if (sourceFile.imports && sourceFile.imports.length > 0) {
	                var checker = program.getTypeChecker();
	                for (var _i = 0, _a = sourceFile.imports; _i < _a.length; _i++) {
	                    var importName = _a[_i];
	                    var symbol = checker.getSymbolAtLocation(importName);
	                    if (symbol && symbol.declarations && symbol.declarations[0]) {
	                        var declarationSourceFile = ts.getSourceFileOfNode(symbol.declarations[0]);
	                        if (declarationSourceFile) {
	                            addReferencedFile(declarationSourceFile.path);
	                        }
	                    }
	                }
	            }
	            var sourceFileDirectory = ts.getDirectoryPath(sourceFile.path);
	            // Handle triple slash references
	            if (sourceFile.referencedFiles && sourceFile.referencedFiles.length > 0) {
	                for (var _b = 0, _c = sourceFile.referencedFiles; _b < _c.length; _b++) {
	                    var referencedFile = _c[_b];
	                    var referencedPath = ts.toPath(referencedFile.fileName, sourceFileDirectory, getCanonicalFileName);
	                    addReferencedFile(referencedPath);
	                }
	            }
	            // Handle type reference directives
	            if (sourceFile.resolvedTypeReferenceDirectiveNames) {
	                sourceFile.resolvedTypeReferenceDirectiveNames.forEach(function (resolvedTypeReferenceDirective) {
	                    if (!resolvedTypeReferenceDirective) {
	                        return;
	                    }
	                    var fileName = resolvedTypeReferenceDirective.resolvedFileName;
	                    var typeFilePath = ts.toPath(fileName, sourceFileDirectory, getCanonicalFileName);
	                    addReferencedFile(typeFilePath);
	                });
	            }
	            return referencedFiles;
	            function addReferencedFile(referencedPath) {
	                if (!referencedFiles) {
	                    referencedFiles = ts.createMap();
	                }
	                referencedFiles.set(referencedPath, true);
	            }
	        }
	        /**
	         * Returns true if oldState is reusable, that is the emitKind = module/non module has not changed
	         */
	        function canReuseOldState(newReferencedMap, oldState) {
	            return oldState && !oldState.referencedMap === !newReferencedMap;
	        }
	        BuilderState.canReuseOldState = canReuseOldState;
	        /**
	         * Creates the state of file references and signature for the new program from oldState if it is safe
	         */
	        function create(newProgram, getCanonicalFileName, oldState) {
	            var fileInfos = ts.createMap();
	            var referencedMap = newProgram.getCompilerOptions().module !== ts.ModuleKind.None ? ts.createMap() : undefined;
	            var hasCalledUpdateShapeSignature = ts.createMap();
	            var useOldState = canReuseOldState(referencedMap, oldState);
	            // Create the reference map, and set the file infos
	            for (var _i = 0, _a = newProgram.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                var version_1 = sourceFile.version;
	                var oldInfo = useOldState && oldState.fileInfos.get(sourceFile.path);
	                if (referencedMap) {
	                    var newReferences = getReferencedFiles(newProgram, sourceFile, getCanonicalFileName);
	                    if (newReferences) {
	                        referencedMap.set(sourceFile.path, newReferences);
	                    }
	                }
	                fileInfos.set(sourceFile.path, { version: version_1, signature: oldInfo && oldInfo.signature });
	            }
	            return {
	                fileInfos: fileInfos,
	                referencedMap: referencedMap,
	                hasCalledUpdateShapeSignature: hasCalledUpdateShapeSignature,
	                allFilesExcludingDefaultLibraryFile: undefined,
	                allFileNames: undefined
	            };
	        }
	        BuilderState.create = create;
	        /**
	         * Gets the files affected by the path from the program
	         */
	        function getFilesAffectedBy(state, programOfThisState, path, cancellationToken, computeHash, cacheToUpdateSignature) {
	            // Since the operation could be cancelled, the signatures are always stored in the cache
	            // They will be commited once it is safe to use them
	            // eg when calling this api from tsserver, if there is no cancellation of the operation
	            // In the other cases the affected files signatures are commited only after the iteration through the result is complete
	            var signatureCache = cacheToUpdateSignature || ts.createMap();
	            var sourceFile = programOfThisState.getSourceFileByPath(path);
	            if (!sourceFile) {
	                return ts.emptyArray;
	            }
	            if (!updateShapeSignature(state, programOfThisState, sourceFile, signatureCache, cancellationToken, computeHash)) {
	                return [sourceFile];
	            }
	            var result = (state.referencedMap ? getFilesAffectedByUpdatedShapeWhenModuleEmit : getFilesAffectedByUpdatedShapeWhenNonModuleEmit)(state, programOfThisState, sourceFile, signatureCache, cancellationToken, computeHash);
	            if (!cacheToUpdateSignature) {
	                // Commit all the signatures in the signature cache
	                updateSignaturesFromCache(state, signatureCache);
	            }
	            return result;
	        }
	        BuilderState.getFilesAffectedBy = getFilesAffectedBy;
	        /**
	         * Updates the signatures from the cache into state's fileinfo signatures
	         * This should be called whenever it is safe to commit the state of the builder
	         */
	        function updateSignaturesFromCache(state, signatureCache) {
	            signatureCache.forEach(function (signature, path) {
	                state.fileInfos.get(path).signature = signature;
	                state.hasCalledUpdateShapeSignature.set(path, true);
	            });
	        }
	        BuilderState.updateSignaturesFromCache = updateSignaturesFromCache;
	        /**
	         * Returns if the shape of the signature has changed since last emit
	         */
	        function updateShapeSignature(state, programOfThisState, sourceFile, cacheToUpdateSignature, cancellationToken, computeHash) {
	            ts.Debug.assert(!!sourceFile);
	            // If we have cached the result for this file, that means hence forth we should assume file shape is uptodate
	            if (state.hasCalledUpdateShapeSignature.has(sourceFile.path) || cacheToUpdateSignature.has(sourceFile.path)) {
	                return false;
	            }
	            var info = state.fileInfos.get(sourceFile.path);
	            ts.Debug.assert(!!info);
	            var prevSignature = info.signature;
	            var latestSignature;
	            if (sourceFile.isDeclarationFile) {
	                latestSignature = sourceFile.version;
	            }
	            else {
	                var emitOutput = ts.getFileEmitOutput(programOfThisState, sourceFile, /*emitOnlyDtsFiles*/ true, cancellationToken);
	                if (emitOutput.outputFiles && emitOutput.outputFiles.length > 0) {
	                    latestSignature = computeHash(emitOutput.outputFiles[0].text);
	                }
	                else {
	                    latestSignature = prevSignature;
	                }
	            }
	            cacheToUpdateSignature.set(sourceFile.path, latestSignature);
	            return !prevSignature || latestSignature !== prevSignature;
	        }
	        /**
	         * Get all the dependencies of the sourceFile
	         */
	        function getAllDependencies(state, programOfThisState, sourceFile) {
	            var _a;
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            // With --out or --outFile all outputs go into single file, all files depend on each other
	            if (compilerOptions.outFile || compilerOptions.out) {
	                return getAllFileNames(state, programOfThisState);
	            }
	            // If this is non module emit, or its a global file, it depends on all the source files
	            if (!state.referencedMap || (!ts.isExternalModule(sourceFile) && !containsOnlyAmbientModules(sourceFile))) {
	                return getAllFileNames(state, programOfThisState);
	            }
	            // Get the references, traversing deep from the referenceMap
	            var seenMap = ts.createMap();
	            var queue = [sourceFile.path];
	            while (queue.length) {
	                var path = queue.pop();
	                if (!seenMap.has(path)) {
	                    seenMap.set(path, true);
	                    var references = state.referencedMap.get(path);
	                    if (references) {
	                        var iterator = references.keys();
	                        for (var _b = iterator.next(), value = _b.value, done = _b.done; !done; _a = iterator.next(), value = _a.value, done = _a.done, _a) {
	                            queue.push(value);
	                        }
	                    }
	                }
	            }
	            return ts.arrayFrom(ts.mapDefinedIterator(seenMap.keys(), function (path) {
	                var file = programOfThisState.getSourceFileByPath(path);
	                return file ? file.fileName : path;
	            }));
	        }
	        BuilderState.getAllDependencies = getAllDependencies;
	        /**
	         * Gets the names of all files from the program
	         */
	        function getAllFileNames(state, programOfThisState) {
	            if (!state.allFileNames) {
	                var sourceFiles = programOfThisState.getSourceFiles();
	                state.allFileNames = sourceFiles === ts.emptyArray ? ts.emptyArray : sourceFiles.map(function (file) { return file.fileName; });
	            }
	            return state.allFileNames;
	        }
	        /**
	         * Gets the files referenced by the the file path
	         */
	        function getReferencedByPaths(state, referencedFilePath) {
	            return ts.arrayFrom(ts.mapDefinedIterator(state.referencedMap.entries(), function (_a) {
	                var filePath = _a[0], referencesInFile = _a[1];
	                return referencesInFile.has(referencedFilePath) ? filePath : undefined;
	            }));
	        }
	        /**
	         * For script files that contains only ambient external modules, although they are not actually external module files,
	         * they can only be consumed via importing elements from them. Regular script files cannot consume them. Therefore,
	         * there are no point to rebuild all script files if these special files have changed. However, if any statement
	         * in the file is not ambient external module, we treat it as a regular script file.
	         */
	        function containsOnlyAmbientModules(sourceFile) {
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                if (!ts.isModuleWithStringLiteralName(statement)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        /**
	         * Gets all files of the program excluding the default library file
	         */
	        function getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, firstSourceFile) {
	            // Use cached result
	            if (state.allFilesExcludingDefaultLibraryFile) {
	                return state.allFilesExcludingDefaultLibraryFile;
	            }
	            var result;
	            addSourceFile(firstSourceFile);
	            for (var _i = 0, _a = programOfThisState.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                if (sourceFile !== firstSourceFile) {
	                    addSourceFile(sourceFile);
	                }
	            }
	            state.allFilesExcludingDefaultLibraryFile = result || ts.emptyArray;
	            return state.allFilesExcludingDefaultLibraryFile;
	            function addSourceFile(sourceFile) {
	                if (!programOfThisState.isSourceFileDefaultLibrary(sourceFile)) {
	                    (result || (result = [])).push(sourceFile);
	                }
	            }
	        }
	        /**
	         * When program emits non modular code, gets the files affected by the sourceFile whose shape has changed
	         */
	        function getFilesAffectedByUpdatedShapeWhenNonModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape) {
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            // If `--out` or `--outFile` is specified, any new emit will result in re-emitting the entire project,
	            // so returning the file itself is good enough.
	            if (compilerOptions && (compilerOptions.out || compilerOptions.outFile)) {
	                return [sourceFileWithUpdatedShape];
	            }
	            return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
	        }
	        /**
	         * When program emits modular code, gets the files affected by the sourceFile whose shape has changed
	         */
	        function getFilesAffectedByUpdatedShapeWhenModuleEmit(state, programOfThisState, sourceFileWithUpdatedShape, cacheToUpdateSignature, cancellationToken, computeHash) {
	            if (!ts.isExternalModule(sourceFileWithUpdatedShape) && !containsOnlyAmbientModules(sourceFileWithUpdatedShape)) {
	                return getAllFilesExcludingDefaultLibraryFile(state, programOfThisState, sourceFileWithUpdatedShape);
	            }
	            var compilerOptions = programOfThisState.getCompilerOptions();
	            if (compilerOptions && (compilerOptions.isolatedModules || compilerOptions.out || compilerOptions.outFile)) {
	                return [sourceFileWithUpdatedShape];
	            }
	            // Now we need to if each file in the referencedBy list has a shape change as well.
	            // Because if so, its own referencedBy files need to be saved as well to make the
	            // emitting result consistent with files on disk.
	            var seenFileNamesMap = ts.createMap();
	            // Start with the paths this file was referenced by
	            seenFileNamesMap.set(sourceFileWithUpdatedShape.path, sourceFileWithUpdatedShape);
	            var queue = getReferencedByPaths(state, sourceFileWithUpdatedShape.path);
	            while (queue.length > 0) {
	                var currentPath = queue.pop();
	                if (!seenFileNamesMap.has(currentPath)) {
	                    var currentSourceFile = programOfThisState.getSourceFileByPath(currentPath);
	                    seenFileNamesMap.set(currentPath, currentSourceFile);
	                    if (currentSourceFile && updateShapeSignature(state, programOfThisState, currentSourceFile, cacheToUpdateSignature, cancellationToken, computeHash)) {
	                        queue.push.apply(queue, getReferencedByPaths(state, currentPath));
	                    }
	                }
	            }
	            // Return array of values that needs emit
	            // Return array of values that needs emit
	            return ts.arrayFrom(ts.mapDefinedIterator(seenFileNamesMap.values(), function (value) { return value; }));
	        }
	    })(BuilderState = ts.BuilderState || (ts.BuilderState = {}));
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    function hasSameKeys(map1, map2) {
	        // Has same size and every key is present in both maps
	        return map1 === map2 || map1 && map2 && map1.size === map2.size && !ts.forEachKey(map1, function (key) { return !map2.has(key); });
	    }
	    /**
	     * Create the state so that we can iterate on changedFiles/affected files
	     */
	    function createBuilderProgramState(newProgram, getCanonicalFileName, oldState) {
	        var state = ts.BuilderState.create(newProgram, getCanonicalFileName, oldState);
	        state.program = newProgram;
	        var compilerOptions = newProgram.getCompilerOptions();
	        if (!compilerOptions.outFile && !compilerOptions.out) {
	            state.semanticDiagnosticsPerFile = ts.createMap();
	        }
	        state.changedFilesSet = ts.createMap();
	        var useOldState = ts.BuilderState.canReuseOldState(state.referencedMap, oldState);
	        var canCopySemanticDiagnostics = useOldState && oldState.semanticDiagnosticsPerFile && !!state.semanticDiagnosticsPerFile;
	        if (useOldState) {
	            // Verify the sanity of old state
	            if (!oldState.currentChangedFilePath) {
	                ts.Debug.assert(!oldState.affectedFiles && (!oldState.currentAffectedFilesSignatures || !oldState.currentAffectedFilesSignatures.size), "Cannot reuse if only few affected files of currentChangedFile were iterated");
	            }
	            if (canCopySemanticDiagnostics) {
	                ts.Debug.assert(!ts.forEachKey(oldState.changedFilesSet, function (path) { return oldState.semanticDiagnosticsPerFile.has(path); }), "Semantic diagnostics shouldnt be available for changed files");
	            }
	            // Copy old state's changed files set
	            ts.copyEntries(oldState.changedFilesSet, state.changedFilesSet);
	        }
	        // Update changed files and copy semantic diagnostics if we can
	        var referencedMap = state.referencedMap;
	        var oldReferencedMap = useOldState && oldState.referencedMap;
	        state.fileInfos.forEach(function (info, sourceFilePath) {
	            var oldInfo;
	            var newReferences;
	            // if not using old state, every file is changed
	            if (!useOldState ||
	                // File wasnt present in old state
	                !(oldInfo = oldState.fileInfos.get(sourceFilePath)) ||
	                // versions dont match
	                oldInfo.version !== info.version ||
	                // Referenced files changed
	                !hasSameKeys(newReferences = referencedMap && referencedMap.get(sourceFilePath), oldReferencedMap && oldReferencedMap.get(sourceFilePath)) ||
	                // Referenced file was deleted in the new program
	                newReferences && ts.forEachKey(newReferences, function (path) { return !state.fileInfos.has(path) && oldState.fileInfos.has(path); })) {
	                // Register file as changed file and do not copy semantic diagnostics, since all changed files need to be re-evaluated
	                state.changedFilesSet.set(sourceFilePath, true);
	            }
	            else if (canCopySemanticDiagnostics) {
	                // Unchanged file copy diagnostics
	                var diagnostics = oldState.semanticDiagnosticsPerFile.get(sourceFilePath);
	                if (diagnostics) {
	                    state.semanticDiagnosticsPerFile.set(sourceFilePath, diagnostics);
	                }
	            }
	        });
	        return state;
	    }
	    /**
	     * Verifies that source file is ok to be used in calls that arent handled by next
	     */
	    function assertSourceFileOkWithoutNextAffectedCall(state, sourceFile) {
	        ts.Debug.assert(!sourceFile || !state.affectedFiles || state.affectedFiles[state.affectedFilesIndex - 1] !== sourceFile || !state.semanticDiagnosticsPerFile.has(sourceFile.path));
	    }
	    /**
	     * This function returns the next affected file to be processed.
	     * Note that until doneAffected is called it would keep reporting same result
	     * This is to allow the callers to be able to actually remove affected file only when the operation is complete
	     * eg. if during diagnostics check cancellation token ends up cancelling the request, the affected file should be retained
	     */
	    function getNextAffectedFile(state, cancellationToken, computeHash) {
	        while (true) {
	            var affectedFiles = state.affectedFiles;
	            if (affectedFiles) {
	                var seenAffectedFiles = state.seenAffectedFiles, semanticDiagnosticsPerFile = state.semanticDiagnosticsPerFile;
	                var affectedFilesIndex = state.affectedFilesIndex;
	                while (affectedFilesIndex < affectedFiles.length) {
	                    var affectedFile = affectedFiles[affectedFilesIndex];
	                    if (!seenAffectedFiles.has(affectedFile.path)) {
	                        // Set the next affected file as seen and remove the cached semantic diagnostics
	                        state.affectedFilesIndex = affectedFilesIndex;
	                        semanticDiagnosticsPerFile.delete(affectedFile.path);
	                        return affectedFile;
	                    }
	                    seenAffectedFiles.set(affectedFile.path, true);
	                    affectedFilesIndex++;
	                }
	                // Remove the changed file from the change set
	                state.changedFilesSet.delete(state.currentChangedFilePath);
	                state.currentChangedFilePath = undefined;
	                // Commit the changes in file signature
	                ts.BuilderState.updateSignaturesFromCache(state, state.currentAffectedFilesSignatures);
	                state.currentAffectedFilesSignatures.clear();
	                state.affectedFiles = undefined;
	            }
	            // Get next changed file
	            var nextKey = state.changedFilesSet.keys().next();
	            if (nextKey.done) {
	                // Done
	                return undefined;
	            }
	            // With --out or --outFile all outputs go into single file
	            // so operations are performed directly on program, return program
	            var compilerOptions = state.program.getCompilerOptions();
	            if (compilerOptions.outFile || compilerOptions.out) {
	                ts.Debug.assert(!state.semanticDiagnosticsPerFile);
	                return state.program;
	            }
	            // Get next batch of affected files
	            state.currentAffectedFilesSignatures = state.currentAffectedFilesSignatures || ts.createMap();
	            state.affectedFiles = ts.BuilderState.getFilesAffectedBy(state, state.program, nextKey.value, cancellationToken, computeHash, state.currentAffectedFilesSignatures);
	            state.currentChangedFilePath = nextKey.value;
	            state.semanticDiagnosticsPerFile.delete(nextKey.value);
	            state.affectedFilesIndex = 0;
	            state.seenAffectedFiles = state.seenAffectedFiles || ts.createMap();
	        }
	    }
	    /**
	     * This is called after completing operation on the next affected file.
	     * The operations here are postponed to ensure that cancellation during the iteration is handled correctly
	     */
	    function doneWithAffectedFile(state, affected) {
	        if (affected === state.program) {
	            state.changedFilesSet.clear();
	        }
	        else {
	            state.seenAffectedFiles.set(affected.path, true);
	            state.affectedFilesIndex++;
	        }
	    }
	    /**
	     * Returns the result with affected file
	     */
	    function toAffectedFileResult(state, result, affected) {
	        doneWithAffectedFile(state, affected);
	        return { result: result, affected: affected };
	    }
	    /**
	     * Gets the semantic diagnostics either from cache if present, or otherwise from program and caches it
	     * Note that it is assumed that the when asked about semantic diagnostics, the file has been taken out of affected files/changed file set
	     */
	    function getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken) {
	        var path = sourceFile.path;
	        var cachedDiagnostics = state.semanticDiagnosticsPerFile.get(path);
	        // Report the semantic diagnostics from the cache if we already have those diagnostics present
	        if (cachedDiagnostics) {
	            return cachedDiagnostics;
	        }
	        // Diagnostics werent cached, get them from program, and cache the result
	        var diagnostics = state.program.getSemanticDiagnostics(sourceFile, cancellationToken);
	        state.semanticDiagnosticsPerFile.set(path, diagnostics);
	        return diagnostics;
	    }
	    var BuilderProgramKind;
	    (function (BuilderProgramKind) {
	        BuilderProgramKind[BuilderProgramKind["SemanticDiagnosticsBuilderProgram"] = 0] = "SemanticDiagnosticsBuilderProgram";
	        BuilderProgramKind[BuilderProgramKind["EmitAndSemanticDiagnosticsBuilderProgram"] = 1] = "EmitAndSemanticDiagnosticsBuilderProgram";
	    })(BuilderProgramKind = ts.BuilderProgramKind || (ts.BuilderProgramKind = {}));
	    function getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics) {
	        var host;
	        var newProgram;
	        var oldProgram;
	        if (newProgramOrRootNames === undefined) {
	            ts.Debug.assert(hostOrOptions === undefined);
	            host = oldProgramOrHost;
	            oldProgram = configFileParsingDiagnosticsOrOldProgram;
	            ts.Debug.assert(!!oldProgram);
	            newProgram = oldProgram.getProgram();
	        }
	        else if (ts.isArray(newProgramOrRootNames)) {
	            oldProgram = configFileParsingDiagnosticsOrOldProgram;
	            newProgram = ts.createProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, oldProgram && oldProgram.getProgram(), configFileParsingDiagnostics);
	            host = oldProgramOrHost;
	        }
	        else {
	            newProgram = newProgramOrRootNames;
	            host = hostOrOptions;
	            oldProgram = oldProgramOrHost;
	            configFileParsingDiagnostics = configFileParsingDiagnosticsOrOldProgram;
	        }
	        return { host: host, newProgram: newProgram, oldProgram: oldProgram, configFileParsingDiagnostics: configFileParsingDiagnostics || ts.emptyArray };
	    }
	    ts.getBuilderCreationParameters = getBuilderCreationParameters;
	    function createBuilderProgram(kind, _a) {
	        var newProgram = _a.newProgram, host = _a.host, oldProgram = _a.oldProgram, configFileParsingDiagnostics = _a.configFileParsingDiagnostics;
	        // Return same program if underlying program doesnt change
	        var oldState = oldProgram && oldProgram.getState();
	        if (oldState && newProgram === oldState.program && configFileParsingDiagnostics === newProgram.getConfigFileParsingDiagnostics()) {
	            newProgram = undefined;
	            oldState = undefined;
	            return oldProgram;
	        }
	        /**
	         * Create the canonical file name for identity
	         */
	        var getCanonicalFileName = ts.createGetCanonicalFileName(host.useCaseSensitiveFileNames());
	        /**
	         * Computing hash to for signature verification
	         */
	        var computeHash = host.createHash || ts.identity;
	        var state = createBuilderProgramState(newProgram, getCanonicalFileName, oldState);
	        // To ensure that we arent storing any references to old program or new program without state
	        newProgram = undefined;
	        oldProgram = undefined;
	        oldState = undefined;
	        var result = {
	            getState: function () { return state; },
	            getProgram: function () { return state.program; },
	            getCompilerOptions: function () { return state.program.getCompilerOptions(); },
	            getSourceFile: function (fileName) { return state.program.getSourceFile(fileName); },
	            getSourceFiles: function () { return state.program.getSourceFiles(); },
	            getOptionsDiagnostics: function (cancellationToken) { return state.program.getOptionsDiagnostics(cancellationToken); },
	            getGlobalDiagnostics: function (cancellationToken) { return state.program.getGlobalDiagnostics(cancellationToken); },
	            getConfigFileParsingDiagnostics: function () { return configFileParsingDiagnostics || state.program.getConfigFileParsingDiagnostics(); },
	            getSyntacticDiagnostics: function (sourceFile, cancellationToken) { return state.program.getSyntacticDiagnostics(sourceFile, cancellationToken); },
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            emit: emit,
	            getAllDependencies: function (sourceFile) { return ts.BuilderState.getAllDependencies(state, state.program, sourceFile); },
	            getCurrentDirectory: function () { return state.program.getCurrentDirectory(); }
	        };
	        if (kind === BuilderProgramKind.SemanticDiagnosticsBuilderProgram) {
	            result.getSemanticDiagnosticsOfNextAffectedFile = getSemanticDiagnosticsOfNextAffectedFile;
	        }
	        else if (kind === BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram) {
	            result.emitNextAffectedFile = emitNextAffectedFile;
	        }
	        else {
	            ts.notImplemented();
	        }
	        return result;
	        /**
	         * Emits the next affected file's emit result (EmitResult and sourceFiles emitted) or returns undefined if iteration is complete
	         * The first of writeFile if provided, writeFile of BuilderProgramHost if provided, writeFile of compiler host
	         * in that order would be used to write the files
	         */
	        function emitNextAffectedFile(writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            var affected = getNextAffectedFile(state, cancellationToken, computeHash);
	            if (!affected) {
	                // Done
	                return undefined;
	            }
	            return toAffectedFileResult(state, 
	            // When whole program is affected, do emit only once (eg when --out or --outFile is specified)
	            // Otherwise just affected file
	            state.program.emit(affected === state.program ? undefined : affected, writeFile || host.writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers), affected);
	        }
	        /**
	         * Emits the JavaScript and declaration files.
	         * When targetSource file is specified, emits the files corresponding to that source file,
	         * otherwise for the whole program.
	         * In case of EmitAndSemanticDiagnosticsBuilderProgram, when targetSourceFile is specified,
	         * it is assumed that that file is handled from affected file list. If targetSourceFile is not specified,
	         * it will only emit all the affected files instead of whole program
	         *
	         * The first of writeFile if provided, writeFile of BuilderProgramHost if provided, writeFile of compiler host
	         * in that order would be used to write the files
	         */
	        function emit(targetSourceFile, writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers) {
	            if (kind === BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram) {
	                assertSourceFileOkWithoutNextAffectedCall(state, targetSourceFile);
	                if (!targetSourceFile) {
	                    // Emit and report any errors we ran into.
	                    var sourceMaps = [];
	                    var emitSkipped = void 0;
	                    var diagnostics = void 0;
	                    var emittedFiles = [];
	                    var affectedEmitResult = void 0;
	                    while (affectedEmitResult = emitNextAffectedFile(writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers)) {
	                        emitSkipped = emitSkipped || affectedEmitResult.result.emitSkipped;
	                        diagnostics = ts.addRange(diagnostics, affectedEmitResult.result.diagnostics);
	                        emittedFiles = ts.addRange(emittedFiles, affectedEmitResult.result.emittedFiles);
	                        sourceMaps = ts.addRange(sourceMaps, affectedEmitResult.result.sourceMaps);
	                    }
	                    return {
	                        emitSkipped: emitSkipped,
	                        diagnostics: diagnostics || ts.emptyArray,
	                        emittedFiles: emittedFiles,
	                        sourceMaps: sourceMaps
	                    };
	                }
	            }
	            return state.program.emit(targetSourceFile, writeFile || host.writeFile, cancellationToken, emitOnlyDtsFiles, customTransformers);
	        }
	        /**
	         * Return the semantic diagnostics for the next affected file or undefined if iteration is complete
	         * If provided ignoreSourceFile would be called before getting the diagnostics and would ignore the sourceFile if the returned value was true
	         */
	        function getSemanticDiagnosticsOfNextAffectedFile(cancellationToken, ignoreSourceFile) {
	            while (true) {
	                var affected = getNextAffectedFile(state, cancellationToken, computeHash);
	                if (!affected) {
	                    // Done
	                    return undefined;
	                }
	                else if (affected === state.program) {
	                    // When whole program is affected, get all semantic diagnostics (eg when --out or --outFile is specified)
	                    return toAffectedFileResult(state, state.program.getSemanticDiagnostics(/*targetSourceFile*/ undefined, cancellationToken), affected);
	                }
	                // Get diagnostics for the affected file if its not ignored
	                if (ignoreSourceFile && ignoreSourceFile(affected)) {
	                    // Get next affected file
	                    doneWithAffectedFile(state, affected);
	                    continue;
	                }
	                return toAffectedFileResult(state, getSemanticDiagnosticsOfFile(state, affected, cancellationToken), affected);
	            }
	        }
	        /**
	         * Gets the semantic diagnostics from the program corresponding to this state of file (if provided) or whole program
	         * The semantic diagnostics are cached and managed here
	         * Note that it is assumed that when asked about semantic diagnostics through this API,
	         * the file has been taken out of affected files so it is safe to use cache or get from program and cache the diagnostics
	         * In case of SemanticDiagnosticsBuilderProgram if the source file is not provided,
	         * it will iterate through all the affected files, to ensure that cache stays valid and yet provide a way to get all semantic diagnostics
	         */
	        function getSemanticDiagnostics(sourceFile, cancellationToken) {
	            assertSourceFileOkWithoutNextAffectedCall(state, sourceFile);
	            var compilerOptions = state.program.getCompilerOptions();
	            if (compilerOptions.outFile || compilerOptions.out) {
	                ts.Debug.assert(!state.semanticDiagnosticsPerFile);
	                // We dont need to cache the diagnostics just return them from program
	                return state.program.getSemanticDiagnostics(sourceFile, cancellationToken);
	            }
	            if (sourceFile) {
	                return getSemanticDiagnosticsOfFile(state, sourceFile, cancellationToken);
	            }
	            if (kind === BuilderProgramKind.SemanticDiagnosticsBuilderProgram) {
	                // When semantic builder asks for diagnostics of the whole program,
	                // ensure that all the affected files are handled
	                var affected = void 0;
	                while (affected = getNextAffectedFile(state, cancellationToken, computeHash)) {
	                    doneWithAffectedFile(state, affected);
	                }
	            }
	            var diagnostics;
	            for (var _i = 0, _a = state.program.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile_2 = _a[_i];
	                diagnostics = ts.addRange(diagnostics, getSemanticDiagnosticsOfFile(state, sourceFile_2, cancellationToken));
	            }
	            return diagnostics || ts.emptyArray;
	        }
	    }
	    ts.createBuilderProgram = createBuilderProgram;
	})(ts || (ts = {}));
	(function (ts) {
	    function createSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics) {
	        return ts.createBuilderProgram(ts.BuilderProgramKind.SemanticDiagnosticsBuilderProgram, ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics));
	    }
	    ts.createSemanticDiagnosticsBuilderProgram = createSemanticDiagnosticsBuilderProgram;
	    function createEmitAndSemanticDiagnosticsBuilderProgram(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics) {
	        return ts.createBuilderProgram(ts.BuilderProgramKind.EmitAndSemanticDiagnosticsBuilderProgram, ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics));
	    }
	    ts.createEmitAndSemanticDiagnosticsBuilderProgram = createEmitAndSemanticDiagnosticsBuilderProgram;
	    function createAbstractBuilder(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics) {
	        var program = ts.getBuilderCreationParameters(newProgramOrRootNames, hostOrOptions, oldProgramOrHost, configFileParsingDiagnosticsOrOldProgram, configFileParsingDiagnostics).newProgram;
	        return {
	            // Only return program, all other methods are not implemented
	            getProgram: function () { return program; },
	            getState: ts.notImplemented,
	            getCompilerOptions: ts.notImplemented,
	            getSourceFile: ts.notImplemented,
	            getSourceFiles: ts.notImplemented,
	            getOptionsDiagnostics: ts.notImplemented,
	            getGlobalDiagnostics: ts.notImplemented,
	            getConfigFileParsingDiagnostics: ts.notImplemented,
	            getSyntacticDiagnostics: ts.notImplemented,
	            getSemanticDiagnostics: ts.notImplemented,
	            emit: ts.notImplemented,
	            getAllDependencies: ts.notImplemented,
	            getCurrentDirectory: ts.notImplemented
	        };
	    }
	    ts.createAbstractBuilder = createAbstractBuilder;
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    ts.maxNumberOfFilesToIterateForInvalidation = 256;
	    function createResolutionCache(resolutionHost, rootDirForResolution, logChangesWhenResolvingModule) {
	        var filesWithChangedSetOfUnresolvedImports;
	        var filesWithInvalidatedResolutions;
	        var filesWithInvalidatedNonRelativeUnresolvedImports;
	        var allFilesHaveInvalidatedResolution = false;
	        var getCurrentDirectory = ts.memoize(function () { return resolutionHost.getCurrentDirectory(); });
	        var cachedDirectoryStructureHost = resolutionHost.getCachedDirectoryStructureHost();
	        // The resolvedModuleNames and resolvedTypeReferenceDirectives are the cache of resolutions per file.
	        // The key in the map is source file's path.
	        // The values are Map of resolutions with key being name lookedup.
	        var resolvedModuleNames = ts.createMap();
	        var perDirectoryResolvedModuleNames = ts.createMap();
	        var nonRelaticeModuleNameCache = ts.createMap();
	        var moduleResolutionCache = ts.createModuleResolutionCacheWithMaps(perDirectoryResolvedModuleNames, nonRelaticeModuleNameCache, getCurrentDirectory(), resolutionHost.getCanonicalFileName);
	        var resolvedTypeReferenceDirectives = ts.createMap();
	        var perDirectoryResolvedTypeReferenceDirectives = ts.createMap();
	        /**
	         * These are the extensions that failed lookup files will have by default,
	         * any other extension of failed lookup will be store that path in custom failed lookup path
	         * This helps in not having to comb through all resolutions when files are added/removed
	         * Note that .d.ts file also has .d.ts extension hence will be part of default extensions
	         */
	        var failedLookupDefaultExtensions = [".ts" /* Ts */, ".tsx" /* Tsx */, ".js" /* Js */, ".jsx" /* Jsx */, ".json" /* Json */];
	        var customFailedLookupPaths = ts.createMap();
	        var directoryWatchesOfFailedLookups = ts.createMap();
	        var rootDir = rootDirForResolution && ts.removeTrailingDirectorySeparator(ts.getNormalizedAbsolutePath(rootDirForResolution, getCurrentDirectory()));
	        var rootPath = rootDir && resolutionHost.toPath(rootDir);
	        // TypeRoot watches for the types that get added as part of getAutomaticTypeDirectiveNames
	        var typeRootsWatches = ts.createMap();
	        return {
	            startRecordingFilesWithChangedResolutions: startRecordingFilesWithChangedResolutions,
	            finishRecordingFilesWithChangedResolutions: finishRecordingFilesWithChangedResolutions,
	            // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
	            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
	            startCachingPerDirectoryResolution: clearPerDirectoryResolutions,
	            finishCachingPerDirectoryResolution: finishCachingPerDirectoryResolution,
	            resolveModuleNames: resolveModuleNames,
	            getResolvedModuleWithFailedLookupLocationsFromCache: getResolvedModuleWithFailedLookupLocationsFromCache,
	            resolveTypeReferenceDirectives: resolveTypeReferenceDirectives,
	            removeResolutionsOfFile: removeResolutionsOfFile,
	            invalidateResolutionOfFile: invalidateResolutionOfFile,
	            setFilesWithInvalidatedNonRelativeUnresolvedImports: setFilesWithInvalidatedNonRelativeUnresolvedImports,
	            createHasInvalidatedResolution: createHasInvalidatedResolution,
	            updateTypeRootsWatch: updateTypeRootsWatch,
	            closeTypeRootsWatch: closeTypeRootsWatch,
	            clear: clear
	        };
	        function getResolvedModule(resolution) {
	            return resolution.resolvedModule;
	        }
	        function getResolvedTypeReferenceDirective(resolution) {
	            return resolution.resolvedTypeReferenceDirective;
	        }
	        function isInDirectoryPath(dir, file) {
	            if (dir === undefined || file.length <= dir.length) {
	                return false;
	            }
	            return ts.startsWith(file, dir) && file[dir.length] === ts.directorySeparator;
	        }
	        function clear() {
	            ts.clearMap(directoryWatchesOfFailedLookups, ts.closeFileWatcherOf);
	            customFailedLookupPaths.clear();
	            closeTypeRootsWatch();
	            resolvedModuleNames.clear();
	            resolvedTypeReferenceDirectives.clear();
	            allFilesHaveInvalidatedResolution = false;
	            // perDirectoryResolvedModuleNames and perDirectoryResolvedTypeReferenceDirectives could be non empty if there was exception during program update
	            // (between startCachingPerDirectoryResolution and finishCachingPerDirectoryResolution)
	            clearPerDirectoryResolutions();
	        }
	        function startRecordingFilesWithChangedResolutions() {
	            filesWithChangedSetOfUnresolvedImports = [];
	        }
	        function finishRecordingFilesWithChangedResolutions() {
	            var collected = filesWithChangedSetOfUnresolvedImports;
	            filesWithChangedSetOfUnresolvedImports = undefined;
	            return collected;
	        }
	        function isFileWithInvalidatedNonRelativeUnresolvedImports(path) {
	            if (!filesWithInvalidatedNonRelativeUnresolvedImports) {
	                return false;
	            }
	            // Invalidated if file has unresolved imports
	            var value = filesWithInvalidatedNonRelativeUnresolvedImports.get(path);
	            return value && !!value.length;
	        }
	        function createHasInvalidatedResolution(forceAllFilesAsInvalidated) {
	            if (allFilesHaveInvalidatedResolution || forceAllFilesAsInvalidated) {
	                // Any file asked would have invalidated resolution
	                filesWithInvalidatedResolutions = undefined;
	                return ts.returnTrue;
	            }
	            var collected = filesWithInvalidatedResolutions;
	            filesWithInvalidatedResolutions = undefined;
	            return function (path) { return (collected && collected.has(path)) ||
	                isFileWithInvalidatedNonRelativeUnresolvedImports(path); };
	        }
	        function clearPerDirectoryResolutions() {
	            perDirectoryResolvedModuleNames.clear();
	            nonRelaticeModuleNameCache.clear();
	            perDirectoryResolvedTypeReferenceDirectives.clear();
	        }
	        function finishCachingPerDirectoryResolution() {
	            allFilesHaveInvalidatedResolution = false;
	            filesWithInvalidatedNonRelativeUnresolvedImports = undefined;
	            directoryWatchesOfFailedLookups.forEach(function (watcher, path) {
	                if (watcher.refCount === 0) {
	                    directoryWatchesOfFailedLookups.delete(path);
	                    watcher.watcher.close();
	                }
	            });
	            clearPerDirectoryResolutions();
	        }
	        function resolveModuleName(moduleName, containingFile, compilerOptions, host) {
	            var primaryResult = ts.resolveModuleName(moduleName, containingFile, compilerOptions, host, moduleResolutionCache);
	            // return result immediately only if global cache support is not enabled or if it is .ts, .tsx or .d.ts
	            if (!resolutionHost.getGlobalCache) {
	                return primaryResult;
	            }
	            // otherwise try to load typings from @types
	            var globalCache = resolutionHost.getGlobalCache();
	            if (globalCache !== undefined && !ts.isExternalModuleNameRelative(moduleName) && !(primaryResult.resolvedModule && ts.extensionIsTypeScript(primaryResult.resolvedModule.extension))) {
	                // create different collection of failed lookup locations for second pass
	                // if it will fail and we've already found something during the first pass - we don't want to pollute its results
	                var _a = ts.loadModuleFromGlobalCache(moduleName, resolutionHost.projectName, compilerOptions, host, globalCache), resolvedModule = _a.resolvedModule, failedLookupLocations = _a.failedLookupLocations;
	                if (resolvedModule) {
	                    return { resolvedModule: resolvedModule, failedLookupLocations: ts.addRange(primaryResult.failedLookupLocations, failedLookupLocations) };
	                }
	            }
	            // Default return the result from the first pass
	            return primaryResult;
	        }
	        function resolveNamesWithLocalCache(names, containingFile, cache, perDirectoryCache, loader, getResolutionWithResolvedFileName, reusedNames, logChanges) {
	            var path = resolutionHost.toPath(containingFile);
	            var resolutionsInFile = cache.get(path) || cache.set(path, ts.createMap()).get(path);
	            var dirPath = ts.getDirectoryPath(path);
	            var perDirectoryResolution = perDirectoryCache.get(dirPath);
	            if (!perDirectoryResolution) {
	                perDirectoryResolution = ts.createMap();
	                perDirectoryCache.set(dirPath, perDirectoryResolution);
	            }
	            var resolvedModules = [];
	            var compilerOptions = resolutionHost.getCompilationSettings();
	            var hasInvalidatedNonRelativeUnresolvedImport = logChanges && isFileWithInvalidatedNonRelativeUnresolvedImports(path);
	            var seenNamesInFile = ts.createMap();
	            for (var _i = 0, names_2 = names; _i < names_2.length; _i++) {
	                var name = names_2[_i];
	                var resolution = resolutionsInFile.get(name);
	                // Resolution is valid if it is present and not invalidated
	                if (!seenNamesInFile.has(name) &&
	                    allFilesHaveInvalidatedResolution || !resolution || resolution.isInvalidated ||
	                    // If the name is unresolved import that was invalidated, recalculate
	                    (hasInvalidatedNonRelativeUnresolvedImport && !ts.isExternalModuleNameRelative(name) && !getResolutionWithResolvedFileName(resolution))) {
	                    var existingResolution = resolution;
	                    var resolutionInDirectory = perDirectoryResolution.get(name);
	                    if (resolutionInDirectory) {
	                        resolution = resolutionInDirectory;
	                    }
	                    else {
	                        resolution = loader(name, containingFile, compilerOptions, resolutionHost);
	                        perDirectoryResolution.set(name, resolution);
	                    }
	                    resolutionsInFile.set(name, resolution);
	                    watchFailedLookupLocationOfResolution(resolution);
	                    if (existingResolution) {
	                        stopWatchFailedLookupLocationOfResolution(existingResolution);
	                    }
	                    if (logChanges && filesWithChangedSetOfUnresolvedImports && !resolutionIsEqualTo(existingResolution, resolution)) {
	                        filesWithChangedSetOfUnresolvedImports.push(path);
	                        // reset log changes to avoid recording the same file multiple times
	                        logChanges = false;
	                    }
	                }
	                ts.Debug.assert(resolution !== undefined && !resolution.isInvalidated);
	                seenNamesInFile.set(name, true);
	                resolvedModules.push(getResolutionWithResolvedFileName(resolution));
	            }
	            // Stop watching and remove the unused name
	            resolutionsInFile.forEach(function (resolution, name) {
	                if (!seenNamesInFile.has(name) && !ts.contains(reusedNames, name)) {
	                    stopWatchFailedLookupLocationOfResolution(resolution);
	                    resolutionsInFile.delete(name);
	                }
	            });
	            return resolvedModules;
	            function resolutionIsEqualTo(oldResolution, newResolution) {
	                if (oldResolution === newResolution) {
	                    return true;
	                }
	                if (!oldResolution || !newResolution) {
	                    return false;
	                }
	                var oldResult = getResolutionWithResolvedFileName(oldResolution);
	                var newResult = getResolutionWithResolvedFileName(newResolution);
	                if (oldResult === newResult) {
	                    return true;
	                }
	                if (!oldResult || !newResult) {
	                    return false;
	                }
	                return oldResult.resolvedFileName === newResult.resolvedFileName;
	            }
	        }
	        function resolveTypeReferenceDirectives(typeDirectiveNames, containingFile) {
	            return resolveNamesWithLocalCache(typeDirectiveNames, containingFile, resolvedTypeReferenceDirectives, perDirectoryResolvedTypeReferenceDirectives, ts.resolveTypeReferenceDirective, getResolvedTypeReferenceDirective, 
	            /*reusedNames*/ undefined, /*logChanges*/ false);
	        }
	        function resolveModuleNames(moduleNames, containingFile, reusedNames) {
	            return resolveNamesWithLocalCache(moduleNames, containingFile, resolvedModuleNames, perDirectoryResolvedModuleNames, resolveModuleName, getResolvedModule, reusedNames, logChangesWhenResolvingModule);
	        }
	        function getResolvedModuleWithFailedLookupLocationsFromCache(moduleName, containingFile) {
	            var cache = resolvedModuleNames.get(resolutionHost.toPath(containingFile));
	            return cache && cache.get(moduleName);
	        }
	        function isNodeModulesDirectory(dirPath) {
	            return ts.endsWith(dirPath, "/node_modules");
	        }
	        function isNodeModulesAtTypesDirectory(dirPath) {
	            return ts.endsWith(dirPath, "/node_modules/@types");
	        }
	        /**
	         * Filter out paths like
	         * "/", "/user", "/user/username", "/user/username/folderAtRoot",
	         * "c:/", "c:/users", "c:/users/username", "c:/users/username/folderAtRoot", "c:/folderAtRoot"
	         * @param dirPath
	         */
	        function canWatchDirectory(dirPath) {
	            var rootLength = ts.getRootLength(dirPath);
	            if (dirPath.length === rootLength) {
	                // Ignore "/", "c:/"
	                return false;
	            }
	            var nextDirectorySeparator = dirPath.indexOf(ts.directorySeparator, rootLength);
	            if (nextDirectorySeparator === -1) {
	                // ignore "/user", "c:/users" or "c:/folderAtRoot"
	                return false;
	            }
	            if (dirPath.charCodeAt(0) !== 47 /* slash */ &&
	                dirPath.substr(rootLength, nextDirectorySeparator).search(/users/i) === -1) {
	                // Paths like c:/folderAtRoot/subFolder are allowed
	                return true;
	            }
	            for (var searchIndex = nextDirectorySeparator + 1, searchLevels = 2; searchLevels > 0; searchLevels--) {
	                searchIndex = dirPath.indexOf(ts.directorySeparator, searchIndex) + 1;
	                if (searchIndex === 0) {
	                    // Folder isnt at expected minimun levels
	                    return false;
	                }
	            }
	            return true;
	        }
	        function filterFSRootDirectoriesToWatch(watchPath, dirPath) {
	            if (!canWatchDirectory(dirPath)) {
	                watchPath.ignore = true;
	            }
	            return watchPath;
	        }
	        function getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath) {
	            if (isInDirectoryPath(rootPath, failedLookupLocationPath)) {
	                return { dir: rootDir, dirPath: rootPath };
	            }
	            return getDirectoryToWatchFromFailedLookupLocationDirectory(ts.getDirectoryPath(ts.getNormalizedAbsolutePath(failedLookupLocation, getCurrentDirectory())), ts.getDirectoryPath(failedLookupLocationPath));
	        }
	        function getDirectoryToWatchFromFailedLookupLocationDirectory(dir, dirPath) {
	            // If directory path contains node module, get the most parent node_modules directory for watching
	            while (ts.stringContains(dirPath, "/node_modules/")) {
	                dir = ts.getDirectoryPath(dir);
	                dirPath = ts.getDirectoryPath(dirPath);
	            }
	            // If the directory is node_modules use it to watch
	            if (isNodeModulesDirectory(dirPath)) {
	                return filterFSRootDirectoriesToWatch({ dir: dir, dirPath: dirPath }, ts.getDirectoryPath(dirPath));
	            }
	            // Use some ancestor of the root directory
	            var subDirectory;
	            if (rootPath !== undefined) {
	                while (!isInDirectoryPath(dirPath, rootPath)) {
	                    var parentPath = ts.getDirectoryPath(dirPath);
	                    if (parentPath === dirPath) {
	                        break;
	                    }
	                    subDirectory = dirPath.slice(parentPath.length + ts.directorySeparator.length);
	                    dirPath = parentPath;
	                    dir = ts.getDirectoryPath(dir);
	                }
	            }
	            return filterFSRootDirectoriesToWatch({ dir: dir, dirPath: dirPath, subDirectory: subDirectory }, dirPath);
	        }
	        function isPathWithDefaultFailedLookupExtension(path) {
	            return ts.fileExtensionIsOneOf(path, failedLookupDefaultExtensions);
	        }
	        function watchFailedLookupLocationOfResolution(resolution) {
	            // No need to set the resolution refCount
	            if (!resolution.failedLookupLocations || !resolution.failedLookupLocations.length) {
	                return;
	            }
	            if (resolution.refCount !== undefined) {
	                resolution.refCount++;
	                return;
	            }
	            resolution.refCount = 1;
	            var failedLookupLocations = resolution.failedLookupLocations;
	            var setAtRoot = false;
	            for (var _i = 0, failedLookupLocations_1 = failedLookupLocations; _i < failedLookupLocations_1.length; _i++) {
	                var failedLookupLocation = failedLookupLocations_1[_i];
	                var failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
	                var _a = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath), dir = _a.dir, dirPath = _a.dirPath, ignore = _a.ignore, subDirectory = _a.subDirectory;
	                if (!ignore) {
	                    // If the failed lookup location path is not one of the supported extensions,
	                    // store it in the custom path
	                    if (!isPathWithDefaultFailedLookupExtension(failedLookupLocationPath)) {
	                        var refCount = customFailedLookupPaths.get(failedLookupLocationPath) || 0;
	                        customFailedLookupPaths.set(failedLookupLocationPath, refCount + 1);
	                    }
	                    if (dirPath === rootPath) {
	                        setAtRoot = true;
	                    }
	                    else {
	                        setDirectoryWatcher(dir, dirPath, subDirectory);
	                    }
	                }
	            }
	            if (setAtRoot) {
	                setDirectoryWatcher(rootDir, rootPath);
	            }
	        }
	        function setDirectoryWatcher(dir, dirPath, subDirectory) {
	            var dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
	            if (dirWatcher) {
	                dirWatcher.refCount++;
	            }
	            else {
	                dirWatcher = { watcher: createDirectoryWatcher(dir, dirPath), refCount: 1 };
	                directoryWatchesOfFailedLookups.set(dirPath, dirWatcher);
	            }
	            if (subDirectory) {
	                var subDirectoryMap = dirWatcher.subDirectoryMap || (dirWatcher.subDirectoryMap = ts.createMap());
	                var existing = subDirectoryMap.get(subDirectory) || 0;
	                subDirectoryMap.set(subDirectory, existing + 1);
	            }
	        }
	        function stopWatchFailedLookupLocationOfResolution(resolution) {
	            if (!resolution.failedLookupLocations || !resolution.failedLookupLocations.length) {
	                return;
	            }
	            resolution.refCount--;
	            if (resolution.refCount) {
	                return;
	            }
	            var failedLookupLocations = resolution.failedLookupLocations;
	            var removeAtRoot = false;
	            for (var _i = 0, failedLookupLocations_2 = failedLookupLocations; _i < failedLookupLocations_2.length; _i++) {
	                var failedLookupLocation = failedLookupLocations_2[_i];
	                var failedLookupLocationPath = resolutionHost.toPath(failedLookupLocation);
	                var _a = getDirectoryToWatchFailedLookupLocation(failedLookupLocation, failedLookupLocationPath), dirPath = _a.dirPath, ignore = _a.ignore, subDirectory = _a.subDirectory;
	                if (!ignore) {
	                    var refCount = customFailedLookupPaths.get(failedLookupLocationPath);
	                    if (refCount) {
	                        if (refCount === 1) {
	                            customFailedLookupPaths.delete(failedLookupLocationPath);
	                        }
	                        else {
	                            ts.Debug.assert(refCount > 1);
	                            customFailedLookupPaths.set(failedLookupLocationPath, refCount - 1);
	                        }
	                    }
	                    if (dirPath === rootPath) {
	                        removeAtRoot = true;
	                    }
	                    else {
	                        removeDirectoryWatcher(dirPath, subDirectory);
	                    }
	                }
	            }
	            if (removeAtRoot) {
	                removeDirectoryWatcher(rootPath);
	            }
	        }
	        function removeDirectoryWatcher(dirPath, subDirectory) {
	            var dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
	            if (subDirectory) {
	                var existing = dirWatcher.subDirectoryMap.get(subDirectory);
	                if (existing === 1) {
	                    dirWatcher.subDirectoryMap.delete(subDirectory);
	                }
	                else {
	                    dirWatcher.subDirectoryMap.set(subDirectory, existing - 1);
	                }
	            }
	            // Do not close the watcher yet since it might be needed by other failed lookup locations.
	            dirWatcher.refCount--;
	        }
	        function inWatchedSubdirectory(dirPath, fileOrDirectoryPath) {
	            var dirWatcher = directoryWatchesOfFailedLookups.get(dirPath);
	            if (!dirWatcher || !dirWatcher.subDirectoryMap)
	                return false;
	            return ts.forEachKey(dirWatcher.subDirectoryMap, function (subDirectory) {
	                var fullSubDirectory = dirPath + "/" + subDirectory;
	                return fullSubDirectory === fileOrDirectoryPath || isInDirectoryPath(fullSubDirectory, fileOrDirectoryPath);
	            });
	        }
	        function createDirectoryWatcher(directory, dirPath) {
	            return resolutionHost.watchDirectoryOfFailedLookupLocation(directory, function (fileOrDirectory) {
	                var fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
	                if (cachedDirectoryStructureHost) {
	                    // Since the file existence changed, update the sourceFiles cache
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                // If the files are added to project root or node_modules directory, always run through the invalidation process
	                // Otherwise run through invalidation only if adding to the immediate directory
	                if (!allFilesHaveInvalidatedResolution &&
	                    (dirPath === rootPath || isNodeModulesDirectory(dirPath) || ts.getDirectoryPath(fileOrDirectoryPath) === dirPath || inWatchedSubdirectory(dirPath, fileOrDirectoryPath))) {
	                    if (invalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath)) {
	                        resolutionHost.onInvalidatedResolution();
	                    }
	                }
	            }, 1 /* Recursive */);
	        }
	        function removeResolutionsOfFileFromCache(cache, filePath) {
	            // Deleted file, stop watching failed lookups for all the resolutions in the file
	            var resolutions = cache.get(filePath);
	            if (resolutions) {
	                resolutions.forEach(stopWatchFailedLookupLocationOfResolution);
	                cache.delete(filePath);
	            }
	        }
	        function removeResolutionsOfFile(filePath) {
	            removeResolutionsOfFileFromCache(resolvedModuleNames, filePath);
	            removeResolutionsOfFileFromCache(resolvedTypeReferenceDirectives, filePath);
	        }
	        function invalidateResolutionCache(cache, isInvalidatedResolution, getResolutionWithResolvedFileName) {
	            var seen = ts.createMap();
	            cache.forEach(function (resolutions, containingFilePath) {
	                var dirPath = ts.getDirectoryPath(containingFilePath);
	                var seenInDir = seen.get(dirPath);
	                if (!seenInDir) {
	                    seenInDir = ts.createMap();
	                    seen.set(dirPath, seenInDir);
	                }
	                resolutions.forEach(function (resolution, name) {
	                    if (seenInDir.has(name)) {
	                        return;
	                    }
	                    seenInDir.set(name, true);
	                    if (!resolution.isInvalidated && isInvalidatedResolution(resolution, getResolutionWithResolvedFileName)) {
	                        // Mark the file as needing re-evaluation of module resolution instead of using it blindly.
	                        resolution.isInvalidated = true;
	                        (filesWithInvalidatedResolutions || (filesWithInvalidatedResolutions = ts.createMap())).set(containingFilePath, true);
	                    }
	                });
	            });
	        }
	        function hasReachedResolutionIterationLimit() {
	            var maxSize = resolutionHost.maxNumberOfFilesToIterateForInvalidation || ts.maxNumberOfFilesToIterateForInvalidation;
	            return resolvedModuleNames.size > maxSize || resolvedTypeReferenceDirectives.size > maxSize;
	        }
	        function invalidateResolutions(isInvalidatedResolution) {
	            // If more than maxNumberOfFilesToIterateForInvalidation present,
	            // just invalidated all files and recalculate the resolutions for files instead
	            if (hasReachedResolutionIterationLimit()) {
	                allFilesHaveInvalidatedResolution = true;
	                return;
	            }
	            invalidateResolutionCache(resolvedModuleNames, isInvalidatedResolution, getResolvedModule);
	            invalidateResolutionCache(resolvedTypeReferenceDirectives, isInvalidatedResolution, getResolvedTypeReferenceDirective);
	        }
	        function invalidateResolutionOfFile(filePath) {
	            removeResolutionsOfFile(filePath);
	            invalidateResolutions(
	            // Resolution is invalidated if the resulting file name is same as the deleted file path
	            function (resolution, getResolutionWithResolvedFileName) {
	                var result = getResolutionWithResolvedFileName(resolution);
	                return result && resolutionHost.toPath(result.resolvedFileName) === filePath;
	            });
	        }
	        function setFilesWithInvalidatedNonRelativeUnresolvedImports(filesMap) {
	            ts.Debug.assert(filesWithInvalidatedNonRelativeUnresolvedImports === filesMap || filesWithInvalidatedNonRelativeUnresolvedImports === undefined);
	            filesWithInvalidatedNonRelativeUnresolvedImports = filesMap;
	        }
	        function invalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, isCreatingWatchedDirectory) {
	            var isChangedFailedLookupLocation;
	            if (isCreatingWatchedDirectory) {
	                // Watching directory is created
	                // Invalidate any resolution has failed lookup in this directory
	                isChangedFailedLookupLocation = function (location) { return isInDirectoryPath(fileOrDirectoryPath, resolutionHost.toPath(location)); };
	            }
	            else {
	                // Some file or directory in the watching directory is created
	                // Return early if it does not have any of the watching extension or not the custom failed lookup path
	                var dirOfFileOrDirectory = ts.getDirectoryPath(fileOrDirectoryPath);
	                if (isNodeModulesAtTypesDirectory(fileOrDirectoryPath) || isNodeModulesDirectory(fileOrDirectoryPath) ||
	                    isNodeModulesAtTypesDirectory(dirOfFileOrDirectory) || isNodeModulesDirectory(dirOfFileOrDirectory)) {
	                    // Invalidate any resolution from this directory
	                    isChangedFailedLookupLocation = function (location) {
	                        var locationPath = resolutionHost.toPath(location);
	                        return locationPath === fileOrDirectoryPath || ts.startsWith(resolutionHost.toPath(location), fileOrDirectoryPath);
	                    };
	                }
	                else {
	                    if (!isPathWithDefaultFailedLookupExtension(fileOrDirectoryPath) && !customFailedLookupPaths.has(fileOrDirectoryPath)) {
	                        return false;
	                    }
	                    // Ignore emits from the program
	                    if (ts.isEmittedFileOfProgram(resolutionHost.getCurrentProgram(), fileOrDirectoryPath)) {
	                        return false;
	                    }
	                    // Resolution need to be invalidated if failed lookup location is same as the file or directory getting created
	                    isChangedFailedLookupLocation = function (location) { return resolutionHost.toPath(location) === fileOrDirectoryPath; };
	                }
	            }
	            var hasChangedFailedLookupLocation = function (resolution) { return ts.some(resolution.failedLookupLocations, isChangedFailedLookupLocation); };
	            var invalidatedFilesCount = filesWithInvalidatedResolutions && filesWithInvalidatedResolutions.size;
	            invalidateResolutions(
	            // Resolution is invalidated if the resulting file name is same as the deleted file path
	            hasChangedFailedLookupLocation);
	            return allFilesHaveInvalidatedResolution || filesWithInvalidatedResolutions && filesWithInvalidatedResolutions.size !== invalidatedFilesCount;
	        }
	        function closeTypeRootsWatch() {
	            ts.clearMap(typeRootsWatches, ts.closeFileWatcher);
	        }
	        function getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, typeRootPath) {
	            if (allFilesHaveInvalidatedResolution) {
	                return undefined;
	            }
	            if (isInDirectoryPath(rootPath, typeRootPath)) {
	                return rootPath;
	            }
	            var _a = getDirectoryToWatchFromFailedLookupLocationDirectory(typeRoot, typeRootPath), dirPath = _a.dirPath, ignore = _a.ignore;
	            return !ignore && directoryWatchesOfFailedLookups.has(dirPath) && dirPath;
	        }
	        function createTypeRootsWatch(typeRootPath, typeRoot) {
	            // Create new watch and recursive info
	            return resolutionHost.watchTypeRootsDirectory(typeRoot, function (fileOrDirectory) {
	                var fileOrDirectoryPath = resolutionHost.toPath(fileOrDirectory);
	                if (cachedDirectoryStructureHost) {
	                    // Since the file existence changed, update the sourceFiles cache
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                // For now just recompile
	                // We could potentially store more data here about whether it was/would be really be used or not
	                // and with that determine to trigger compilation but for now this is enough
	                resolutionHost.onChangedAutomaticTypeDirectiveNames();
	                // Since directory watchers invoked are flaky, the failed lookup location events might not be triggered
	                // So handle to failed lookup locations here as well to ensure we are invalidating resolutions
	                var dirPath = getDirectoryToWatchFailedLookupLocationFromTypeRoot(typeRoot, typeRootPath);
	                if (dirPath && invalidateResolutionOfFailedLookupLocation(fileOrDirectoryPath, dirPath === fileOrDirectoryPath)) {
	                    resolutionHost.onInvalidatedResolution();
	                }
	            }, 1 /* Recursive */);
	        }
	        /**
	         * Watches the types that would get added as part of getAutomaticTypeDirectiveNames
	         * To be called when compiler options change
	         */
	        function updateTypeRootsWatch() {
	            var options = resolutionHost.getCompilationSettings();
	            if (options.types) {
	                // No need to do any watch since resolution cache is going to handle the failed lookups
	                // for the types added by this
	                closeTypeRootsWatch();
	                return;
	            }
	            // we need to assume the directories exist to ensure that we can get all the type root directories that get included
	            // But filter directories that are at root level to say directory doesnt exist, so that we arent watching them
	            var typeRoots = ts.getEffectiveTypeRoots(options, { directoryExists: directoryExistsForTypeRootWatch, getCurrentDirectory: getCurrentDirectory });
	            if (typeRoots) {
	                ts.mutateMap(typeRootsWatches, ts.arrayToMap(typeRoots, function (tr) { return resolutionHost.toPath(tr); }), {
	                    createNewValue: createTypeRootsWatch,
	                    onDeleteValue: ts.closeFileWatcher
	                });
	            }
	            else {
	                closeTypeRootsWatch();
	            }
	        }
	        /**
	         * Use this function to return if directory exists to get type roots to watch
	         * If we return directory exists then only the paths will be added to type roots
	         * Hence return true for all directories except root directories which are filtered from watching
	         */
	        function directoryExistsForTypeRootWatch(nodeTypesDirectory) {
	            var dir = ts.getDirectoryPath(ts.getDirectoryPath(nodeTypesDirectory));
	            var dirPath = resolutionHost.toPath(dir);
	            return dirPath === rootPath || canWatchDirectory(dirPath);
	        }
	    }
	    ts.createResolutionCache = createResolutionCache;
	})(ts || (ts = {}));
	// Used by importFixes to synthesize import module specifiers.
	/* @internal */
	var ts;
	(function (ts) {
	    var moduleSpecifiers;
	    (function (moduleSpecifiers) {
	        // Note: fromSourceFile is just for usesJsExtensionOnImports
	        function getModuleSpecifier(compilerOptions, fromSourceFile, fromSourceFileName, toFileName, host, preferences) {
	            if (preferences === void 0) { preferences = {}; }
	            var info = getInfo(compilerOptions, fromSourceFile, fromSourceFileName, host);
	            return getGlobalModuleSpecifier(toFileName, info, host, compilerOptions) ||
	                ts.first(getLocalModuleSpecifiers(toFileName, info, compilerOptions, preferences));
	        }
	        moduleSpecifiers.getModuleSpecifier = getModuleSpecifier;
	        // For each symlink/original for a module, returns a list of ways to import that file.
	        function getModuleSpecifiers(moduleSymbol, compilerOptions, importingSourceFile, host, files, preferences) {
	            var ambient = tryGetModuleNameFromAmbientModule(moduleSymbol);
	            if (ambient)
	                return [[ambient]];
	            var info = getInfo(compilerOptions, importingSourceFile, importingSourceFile.path, host);
	            if (!files) {
	                return ts.Debug.fail("Files list must be present to resolve symlinks in specifier resolution");
	            }
	            var modulePaths = getAllModulePaths(files, ts.getSourceFileOfNode(moduleSymbol.valueDeclaration), info.getCanonicalFileName, host);
	            var global = ts.mapDefined(modulePaths, function (moduleFileName) { return getGlobalModuleSpecifier(moduleFileName, info, host, compilerOptions); });
	            return global.length ? global.map(function (g) { return [g]; }) : modulePaths.map(function (moduleFileName) {
	                return getLocalModuleSpecifiers(moduleFileName, info, compilerOptions, preferences);
	            });
	        }
	        moduleSpecifiers.getModuleSpecifiers = getModuleSpecifiers;
	        // importingSourceFileName is separate because getEditsForFileRename may need to specify an updated path
	        function getInfo(compilerOptions, importingSourceFile, importingSourceFileName, host) {
	            var moduleResolutionKind = ts.getEmitModuleResolutionKind(compilerOptions);
	            var addJsExtension = usesJsExtensionOnImports(importingSourceFile);
	            var getCanonicalFileName = ts.createGetCanonicalFileName(host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : true);
	            var sourceDirectory = ts.getDirectoryPath(importingSourceFileName);
	            return { moduleResolutionKind: moduleResolutionKind, addJsExtension: addJsExtension, getCanonicalFileName: getCanonicalFileName, sourceDirectory: sourceDirectory };
	        }
	        function getGlobalModuleSpecifier(moduleFileName, _a, host, compilerOptions) {
	            var addJsExtension = _a.addJsExtension, getCanonicalFileName = _a.getCanonicalFileName, sourceDirectory = _a.sourceDirectory;
	            return tryGetModuleNameFromTypeRoots(compilerOptions, host, getCanonicalFileName, moduleFileName, addJsExtension)
	                || tryGetModuleNameAsNodeModule(compilerOptions, moduleFileName, host, getCanonicalFileName, sourceDirectory)
	                || compilerOptions.rootDirs && tryGetModuleNameFromRootDirs(compilerOptions.rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName);
	        }
	        function getLocalModuleSpecifiers(moduleFileName, _a, compilerOptions, preferences) {
	            var moduleResolutionKind = _a.moduleResolutionKind, addJsExtension = _a.addJsExtension, getCanonicalFileName = _a.getCanonicalFileName, sourceDirectory = _a.sourceDirectory;
	            var baseUrl = compilerOptions.baseUrl, paths = compilerOptions.paths;
	            var relativePath = removeExtensionAndIndexPostFix(ts.ensurePathIsNonModuleName(ts.getRelativePathFromDirectory(sourceDirectory, moduleFileName, getCanonicalFileName)), moduleResolutionKind, addJsExtension);
	            if (!baseUrl || preferences.importModuleSpecifierPreference === "relative") {
	                return [relativePath];
	            }
	            var relativeToBaseUrl = getRelativePathIfInDirectory(moduleFileName, baseUrl, getCanonicalFileName);
	            if (!relativeToBaseUrl) {
	                return [relativePath];
	            }
	            var importRelativeToBaseUrl = removeExtensionAndIndexPostFix(relativeToBaseUrl, moduleResolutionKind, addJsExtension);
	            if (paths) {
	                var fromPaths = tryGetModuleNameFromPaths(ts.removeFileExtension(relativeToBaseUrl), importRelativeToBaseUrl, paths);
	                if (fromPaths) {
	                    return [fromPaths];
	                }
	            }
	            if (preferences.importModuleSpecifierPreference === "non-relative") {
	                return [importRelativeToBaseUrl];
	            }
	            if (preferences.importModuleSpecifierPreference !== undefined)
	                ts.Debug.assertNever(preferences.importModuleSpecifierPreference);
	            if (isPathRelativeToParent(relativeToBaseUrl)) {
	                return [relativePath];
	            }
	            /*
	            Prefer a relative import over a baseUrl import if it doesn't traverse up to baseUrl.
	    
	            Suppose we have:
	                baseUrl = /base
	                sourceDirectory = /base/a/b
	                moduleFileName = /base/foo/bar
	            Then:
	                relativePath = ../../foo/bar
	                getRelativePathNParents(relativePath) = 2
	                pathFromSourceToBaseUrl = ../../
	                getRelativePathNParents(pathFromSourceToBaseUrl) = 2
	                2 < 2 = false
	            In this case we should prefer using the baseUrl path "/a/b" instead of the relative path "../../foo/bar".
	    
	            Suppose we have:
	                baseUrl = /base
	                sourceDirectory = /base/foo/a
	                moduleFileName = /base/foo/bar
	            Then:
	                relativePath = ../a
	                getRelativePathNParents(relativePath) = 1
	                pathFromSourceToBaseUrl = ../../
	                getRelativePathNParents(pathFromSourceToBaseUrl) = 2
	                1 < 2 = true
	            In this case we should prefer using the relative path "../a" instead of the baseUrl path "foo/a".
	            */
	            var pathFromSourceToBaseUrl = ts.ensurePathIsNonModuleName(ts.getRelativePathFromDirectory(sourceDirectory, baseUrl, getCanonicalFileName));
	            var relativeFirst = getRelativePathNParents(relativePath) < getRelativePathNParents(pathFromSourceToBaseUrl);
	            return relativeFirst ? [relativePath, importRelativeToBaseUrl] : [importRelativeToBaseUrl, relativePath];
	        }
	        function usesJsExtensionOnImports(_a) {
	            var imports = _a.imports;
	            return ts.firstDefined(imports, function (_a) {
	                var text = _a.text;
	                return ts.pathIsRelative(text) ? ts.fileExtensionIs(text, ".js" /* Js */) : undefined;
	            }) || false;
	        }
	        function discoverProbableSymlinks(files) {
	            var symlinks = ts.mapDefined(files, function (sf) {
	                return sf.resolvedModules && ts.firstDefinedIterator(sf.resolvedModules.values(), function (res) {
	                    return res && res.originalPath && res.resolvedFileName !== res.originalPath ? [res.resolvedFileName, res.originalPath] : undefined;
	                });
	            });
	            var result = ts.createMap();
	            if (symlinks) {
	                for (var _i = 0, symlinks_1 = symlinks; _i < symlinks_1.length; _i++) {
	                    var _a = symlinks_1[_i], resolvedPath = _a[0], originalPath = _a[1];
	                    var resolvedParts = ts.getPathComponents(resolvedPath);
	                    var originalParts = ts.getPathComponents(originalPath);
	                    while (resolvedParts[resolvedParts.length - 1] === originalParts[originalParts.length - 1]) {
	                        resolvedParts.pop();
	                        originalParts.pop();
	                    }
	                    result.set(ts.getPathFromPathComponents(originalParts), ts.getPathFromPathComponents(resolvedParts));
	                }
	            }
	            return result;
	        }
	        function getAllModulePathsUsingIndirectSymlinks(files, target, getCanonicalFileName, host) {
	            var links = discoverProbableSymlinks(files);
	            var paths = ts.arrayFrom(links.keys());
	            var options;
	            for (var _i = 0, paths_2 = paths; _i < paths_2.length; _i++) {
	                var path = paths_2[_i];
	                var resolved = links.get(path);
	                if (ts.startsWith(target, resolved + "/")) {
	                    var relative = ts.getRelativePathFromDirectory(resolved, target, getCanonicalFileName);
	                    var option = ts.resolvePath(path, relative);
	                    if (!host.fileExists || host.fileExists(option)) {
	                        if (!options)
	                            options = [];
	                        options.push(option);
	                    }
	                }
	            }
	            var resolvedtarget = host.getCurrentDirectory ? ts.resolvePath(host.getCurrentDirectory(), target) : target;
	            if (options) {
	                options.push(resolvedtarget); // Since these are speculative, we also include the original resolved name as a possibility
	                return options;
	            }
	            return [resolvedtarget];
	        }
	        /**
	         * Looks for a existing imports that use symlinks to this module.
	         * Only if no symlink is available, the real path will be used.
	         */
	        function getAllModulePaths(files, _a, getCanonicalFileName, host) {
	            var fileName = _a.fileName;
	            var symlinks = ts.mapDefined(files, function (sf) {
	                return sf.resolvedModules && ts.firstDefinedIterator(sf.resolvedModules.values(), function (res) {
	                    return res && res.resolvedFileName === fileName ? res.originalPath : undefined;
	                });
	            });
	            return symlinks.length === 0 ? getAllModulePathsUsingIndirectSymlinks(files, fileName, getCanonicalFileName, host) : symlinks;
	        }
	        function getRelativePathNParents(relativePath) {
	            var components = ts.getPathComponents(relativePath);
	            if (components[0] || components.length === 1)
	                return 0;
	            for (var i = 1; i < components.length; i++) {
	                if (components[i] !== "..")
	                    return i - 1;
	            }
	            return components.length - 1;
	        }
	        function tryGetModuleNameFromAmbientModule(moduleSymbol) {
	            var decl = moduleSymbol.valueDeclaration;
	            if (ts.isModuleDeclaration(decl) && ts.isStringLiteral(decl.name)) {
	                return decl.name.text;
	            }
	        }
	        function tryGetModuleNameFromPaths(relativeToBaseUrlWithIndex, relativeToBaseUrl, paths) {
	            for (var key in paths) {
	                for (var _i = 0, _a = paths[key]; _i < _a.length; _i++) {
	                    var patternText_1 = _a[_i];
	                    var pattern = ts.removeFileExtension(ts.normalizePath(patternText_1));
	                    var indexOfStar = pattern.indexOf("*");
	                    if (indexOfStar === 0 && pattern.length === 1) {
	                        continue;
	                    }
	                    else if (indexOfStar !== -1) {
	                        var prefix = pattern.substr(0, indexOfStar);
	                        var suffix = pattern.substr(indexOfStar + 1);
	                        if (relativeToBaseUrl.length >= prefix.length + suffix.length &&
	                            ts.startsWith(relativeToBaseUrl, prefix) &&
	                            ts.endsWith(relativeToBaseUrl, suffix)) {
	                            var matchedStar = relativeToBaseUrl.substr(prefix.length, relativeToBaseUrl.length - suffix.length);
	                            return key.replace("*", matchedStar);
	                        }
	                    }
	                    else if (pattern === relativeToBaseUrl || pattern === relativeToBaseUrlWithIndex) {
	                        return key;
	                    }
	                }
	            }
	        }
	        function tryGetModuleNameFromRootDirs(rootDirs, moduleFileName, sourceDirectory, getCanonicalFileName) {
	            var normalizedTargetPath = getPathRelativeToRootDirs(moduleFileName, rootDirs, getCanonicalFileName);
	            if (normalizedTargetPath === undefined) {
	                return undefined;
	            }
	            var normalizedSourcePath = getPathRelativeToRootDirs(sourceDirectory, rootDirs, getCanonicalFileName);
	            var relativePath = normalizedSourcePath !== undefined ? ts.ensurePathIsNonModuleName(ts.getRelativePathFromDirectory(normalizedSourcePath, normalizedTargetPath, getCanonicalFileName)) : normalizedTargetPath;
	            return ts.removeFileExtension(relativePath);
	        }
	        function tryGetModuleNameFromTypeRoots(options, host, getCanonicalFileName, moduleFileName, addJsExtension) {
	            var roots = ts.getEffectiveTypeRoots(options, host);
	            return ts.firstDefined(roots, function (unNormalizedTypeRoot) {
	                var typeRoot = ts.toPath(unNormalizedTypeRoot, /*basePath*/ undefined, getCanonicalFileName);
	                if (ts.startsWith(moduleFileName, typeRoot)) {
	                    // For a type definition, we can strip `/index` even with classic resolution.
	                    return removeExtensionAndIndexPostFix(moduleFileName.substring(typeRoot.length + 1), ts.ModuleResolutionKind.NodeJs, addJsExtension);
	                }
	            });
	        }
	        function tryGetModuleNameAsNodeModule(options, moduleFileName, host, getCanonicalFileName, sourceDirectory) {
	            if (ts.getEmitModuleResolutionKind(options) !== ts.ModuleResolutionKind.NodeJs) {
	                // nothing to do here
	                return undefined;
	            }
	            var parts = getNodeModulePathParts(moduleFileName);
	            if (!parts) {
	                return undefined;
	            }
	            // Simplify the full file path to something that can be resolved by Node.
	            // If the module could be imported by a directory name, use that directory's name
	            var moduleSpecifier = getDirectoryOrExtensionlessFileName(moduleFileName);
	            // Get a path that's relative to node_modules or the importing file's path
	            moduleSpecifier = getNodeResolvablePath(moduleSpecifier);
	            // If the module was found in @types, get the actual Node package name
	            return ts.getPackageNameFromAtTypesDirectory(moduleSpecifier);
	            function getDirectoryOrExtensionlessFileName(path) {
	                // If the file is the main module, it can be imported by the package name
	                var packageRootPath = path.substring(0, parts.packageRootIndex);
	                var packageJsonPath = ts.combinePaths(packageRootPath, "package.json");
	                if (host.fileExists(packageJsonPath)) {
	                    var packageJsonContent = JSON.parse(host.readFile(packageJsonPath));
	                    if (packageJsonContent) {
	                        var mainFileRelative = packageJsonContent.typings || packageJsonContent.types || packageJsonContent.main;
	                        if (mainFileRelative) {
	                            var mainExportFile = ts.toPath(mainFileRelative, packageRootPath, getCanonicalFileName);
	                            if (mainExportFile === getCanonicalFileName(path)) {
	                                return packageRootPath;
	                            }
	                        }
	                    }
	                }
	                // We still have a file name - remove the extension
	                var fullModulePathWithoutExtension = ts.removeFileExtension(path);
	                // If the file is /index, it can be imported by its directory name
	                // IFF there is not _also_ a file by the same name
	                if (getCanonicalFileName(fullModulePathWithoutExtension.substring(parts.fileNameIndex)) === "/index" && !tryGetAnyFileFromPath(host, fullModulePathWithoutExtension.substring(0, parts.fileNameIndex))) {
	                    return fullModulePathWithoutExtension.substring(0, parts.fileNameIndex);
	                }
	                return fullModulePathWithoutExtension;
	            }
	            function getNodeResolvablePath(path) {
	                var basePath = path.substring(0, parts.topLevelNodeModulesIndex);
	                if (sourceDirectory.indexOf(basePath) === 0) {
	                    // if node_modules folder is in this folder or any of its parent folders, no need to keep it.
	                    return path.substring(parts.topLevelPackageNameIndex + 1);
	                }
	                else {
	                    return ts.ensurePathIsNonModuleName(ts.getRelativePathFromDirectory(sourceDirectory, path, getCanonicalFileName));
	                }
	            }
	        }
	        function tryGetAnyFileFromPath(host, path) {
	            // We check all js, `node` and `json` extensions in addition to TS, since node module resolution would also choose those over the directory
	            var extensions = ts.getSupportedExtensions({ allowJs: true }, [{ extension: "node", isMixedContent: false }, { extension: "json", isMixedContent: false, scriptKind: 6 /* JSON */ }]);
	            for (var _i = 0, extensions_3 = extensions; _i < extensions_3.length; _i++) {
	                var e = extensions_3[_i];
	                var fullPath = path + e;
	                if (host.fileExists(fullPath)) { // TODO: GH#18217
	                    return fullPath;
	                }
	            }
	        }
	        function getNodeModulePathParts(fullPath) {
	            // If fullPath can't be valid module file within node_modules, returns undefined.
	            // Example of expected pattern: /base/path/node_modules/[@scope/otherpackage/@otherscope/node_modules/]package/[subdirectory/]file.js
	            // Returns indices:                       ^            ^                                                      ^             ^
	            var topLevelNodeModulesIndex = 0;
	            var topLevelPackageNameIndex = 0;
	            var packageRootIndex = 0;
	            var fileNameIndex = 0;
	            var States;
	            (function (States) {
	                States[States["BeforeNodeModules"] = 0] = "BeforeNodeModules";
	                States[States["NodeModules"] = 1] = "NodeModules";
	                States[States["Scope"] = 2] = "Scope";
	                States[States["PackageContent"] = 3] = "PackageContent";
	            })(States || (States = {}));
	            var partStart = 0;
	            var partEnd = 0;
	            var state = 0 /* BeforeNodeModules */;
	            while (partEnd >= 0) {
	                partStart = partEnd;
	                partEnd = fullPath.indexOf("/", partStart + 1);
	                switch (state) {
	                    case 0 /* BeforeNodeModules */:
	                        if (fullPath.indexOf("/node_modules/", partStart) === partStart) {
	                            topLevelNodeModulesIndex = partStart;
	                            topLevelPackageNameIndex = partEnd;
	                            state = 1 /* NodeModules */;
	                        }
	                        break;
	                    case 1 /* NodeModules */:
	                    case 2 /* Scope */:
	                        if (state === 1 /* NodeModules */ && fullPath.charAt(partStart + 1) === "@") {
	                            state = 2 /* Scope */;
	                        }
	                        else {
	                            packageRootIndex = partEnd;
	                            state = 3 /* PackageContent */;
	                        }
	                        break;
	                    case 3 /* PackageContent */:
	                        if (fullPath.indexOf("/node_modules/", partStart) === partStart) {
	                            state = 1 /* NodeModules */;
	                        }
	                        else {
	                            state = 3 /* PackageContent */;
	                        }
	                        break;
	                }
	            }
	            fileNameIndex = partStart;
	            return state > 1 /* NodeModules */ ? { topLevelNodeModulesIndex: topLevelNodeModulesIndex, topLevelPackageNameIndex: topLevelPackageNameIndex, packageRootIndex: packageRootIndex, fileNameIndex: fileNameIndex } : undefined;
	        }
	        function getPathRelativeToRootDirs(path, rootDirs, getCanonicalFileName) {
	            return ts.firstDefined(rootDirs, function (rootDir) {
	                var relativePath = getRelativePathIfInDirectory(path, rootDir, getCanonicalFileName);
	                return isPathRelativeToParent(relativePath) ? undefined : relativePath;
	            });
	        }
	        function removeExtensionAndIndexPostFix(fileName, moduleResolutionKind, addJsExtension) {
	            var noExtension = ts.removeFileExtension(fileName);
	            return addJsExtension
	                ? noExtension + ".js"
	                : moduleResolutionKind === ts.ModuleResolutionKind.NodeJs
	                    ? ts.removeSuffix(noExtension, "/index")
	                    : noExtension;
	        }
	        function getRelativePathIfInDirectory(path, directoryPath, getCanonicalFileName) {
	            var relativePath = ts.getRelativePathToDirectoryOrUrl(directoryPath, path, directoryPath, getCanonicalFileName, /*isAbsolutePathAnUrl*/ false);
	            return ts.isRootedDiskPath(relativePath) ? undefined : relativePath;
	        }
	        function isPathRelativeToParent(path) {
	            return ts.startsWith(path, "..");
	        }
	    })(moduleSpecifiers = ts.moduleSpecifiers || (ts.moduleSpecifiers = {}));
	})(ts || (ts = {}));
	/*@internal*/
	var ts;
	(function (ts) {
	    var sysFormatDiagnosticsHost = ts.sys ? {
	        getCurrentDirectory: function () { return ts.sys.getCurrentDirectory(); },
	        getNewLine: function () { return ts.sys.newLine; },
	        getCanonicalFileName: ts.createGetCanonicalFileName(ts.sys.useCaseSensitiveFileNames)
	    } : undefined;
	    /**
	     * Create a function that reports error by writing to the system and handles the formating of the diagnostic
	     */
	    function createDiagnosticReporter(system, pretty) {
	        var host = system === ts.sys ? sysFormatDiagnosticsHost : {
	            getCurrentDirectory: function () { return system.getCurrentDirectory(); },
	            getNewLine: function () { return system.newLine; },
	            getCanonicalFileName: ts.createGetCanonicalFileName(system.useCaseSensitiveFileNames),
	        };
	        if (!pretty) {
	            return function (diagnostic) { return system.write(ts.formatDiagnostic(diagnostic, host)); };
	        }
	        var diagnostics = new Array(1);
	        return function (diagnostic) {
	            diagnostics[0] = diagnostic;
	            system.write(ts.formatDiagnosticsWithColorAndContext(diagnostics, host) + host.getNewLine());
	            diagnostics[0] = undefined;
	        };
	    }
	    ts.createDiagnosticReporter = createDiagnosticReporter;
	    /** @internal */
	    ts.nonClearingMessageCodes = [
	        ts.Diagnostics.Found_1_error_Watching_for_file_changes.code,
	        ts.Diagnostics.Found_0_errors_Watching_for_file_changes.code
	    ];
	    /**
	     * @returns Whether the screen was cleared.
	     */
	    function clearScreenIfNotWatchingForFileChanges(system, diagnostic, options) {
	        if (system.clearScreen &&
	            !options.preserveWatchOutput &&
	            !options.extendedDiagnostics &&
	            !options.diagnostics &&
	            !ts.contains(ts.nonClearingMessageCodes, diagnostic.code)) {
	            system.clearScreen();
	            return true;
	        }
	        return false;
	    }
	    /** @internal */
	    ts.screenStartingMessageCodes = [
	        ts.Diagnostics.Starting_compilation_in_watch_mode.code,
	        ts.Diagnostics.File_change_detected_Starting_incremental_compilation.code,
	    ];
	    function getPlainDiagnosticFollowingNewLines(diagnostic, newLine) {
	        return ts.contains(ts.screenStartingMessageCodes, diagnostic.code)
	            ? newLine + newLine
	            : newLine;
	    }
	    /**
	     * Create a function that reports watch status by writing to the system and handles the formating of the diagnostic
	     */
	    function createWatchStatusReporter(system, pretty) {
	        return pretty ?
	            function (diagnostic, newLine, options) {
	                clearScreenIfNotWatchingForFileChanges(system, diagnostic, options);
	                var output = "[" + ts.formatColorAndReset(new Date().toLocaleTimeString(), ts.ForegroundColorEscapeSequences.Grey) + "] ";
	                output += "" + ts.flattenDiagnosticMessageText(diagnostic.messageText, system.newLine) + (newLine + newLine);
	                system.write(output);
	            } :
	            function (diagnostic, newLine, options) {
	                var output = "";
	                if (!clearScreenIfNotWatchingForFileChanges(system, diagnostic, options)) {
	                    output += newLine;
	                }
	                output += new Date().toLocaleTimeString() + " - ";
	                output += "" + ts.flattenDiagnosticMessageText(diagnostic.messageText, system.newLine) + getPlainDiagnosticFollowingNewLines(diagnostic, newLine);
	                system.write(output);
	            };
	    }
	    ts.createWatchStatusReporter = createWatchStatusReporter;
	    /** Parses config file using System interface */
	    function parseConfigFileWithSystem(configFileName, optionsToExtend, system, reportDiagnostic) {
	        var host = system;
	        host.onUnRecoverableConfigFileDiagnostic = function (diagnostic) { return reportUnrecoverableDiagnostic(ts.sys, reportDiagnostic, diagnostic); };
	        var result = ts.getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host);
	        host.onUnRecoverableConfigFileDiagnostic = undefined;
	        return result;
	    }
	    ts.parseConfigFileWithSystem = parseConfigFileWithSystem;
	    /**
	     * Helper that emit files, report diagnostics and lists emitted and/or source files depending on compiler options
	     */
	    function emitFilesAndReportErrors(program, reportDiagnostic, writeFileName, reportSummary) {
	        // First get and report any syntactic errors.
	        var diagnostics = program.getConfigFileParsingDiagnostics().slice();
	        var configFileParsingDiagnosticsLength = diagnostics.length;
	        ts.addRange(diagnostics, program.getSyntacticDiagnostics());
	        var reportSemanticDiagnostics = false;
	        // If we didn't have any syntactic errors, then also try getting the global and
	        // semantic errors.
	        if (diagnostics.length === configFileParsingDiagnosticsLength) {
	            ts.addRange(diagnostics, program.getOptionsDiagnostics());
	            ts.addRange(diagnostics, program.getGlobalDiagnostics());
	            if (diagnostics.length === configFileParsingDiagnosticsLength) {
	                reportSemanticDiagnostics = true;
	            }
	        }
	        // Emit and report any errors we ran into.
	        var _a = program.emit(), emittedFiles = _a.emittedFiles, emitSkipped = _a.emitSkipped, emitDiagnostics = _a.diagnostics;
	        ts.addRange(diagnostics, emitDiagnostics);
	        if (reportSemanticDiagnostics) {
	            ts.addRange(diagnostics, program.getSemanticDiagnostics());
	        }
	        ts.sortAndDeduplicateDiagnostics(diagnostics).forEach(reportDiagnostic);
	        if (writeFileName) {
	            var currentDir_1 = program.getCurrentDirectory();
	            ts.forEach(emittedFiles, function (file) {
	                var filepath = ts.getNormalizedAbsolutePath(file, currentDir_1);
	                writeFileName("TSFILE: " + filepath);
	            });
	            if (program.getCompilerOptions().listFiles) {
	                ts.forEach(program.getSourceFiles(), function (file) {
	                    writeFileName(file.fileName);
	                });
	            }
	        }
	        if (reportSummary) {
	            reportSummary(diagnostics.filter(function (diagnostic) { return diagnostic.category === ts.DiagnosticCategory.Error; }).length);
	        }
	        if (emitSkipped && diagnostics.length > 0) {
	            // If the emitter didn't emit anything, then pass that value along.
	            return ts.ExitStatus.DiagnosticsPresent_OutputsSkipped;
	        }
	        else if (diagnostics.length > 0) {
	            // The emitter emitted something, inform the caller if that happened in the presence
	            // of diagnostics or not.
	            return ts.ExitStatus.DiagnosticsPresent_OutputsGenerated;
	        }
	        return ts.ExitStatus.Success;
	    }
	    ts.emitFilesAndReportErrors = emitFilesAndReportErrors;
	    var noopFileWatcher = { close: ts.noop };
	    /**
	     * Creates the watch compiler host that can be extended with config file or root file names and options host
	     */
	    function createWatchCompilerHost(system, createProgram, reportDiagnostic, reportWatchStatus) {
	        if (system === void 0) { system = ts.sys; }
	        if (!createProgram) {
	            createProgram = ts.createEmitAndSemanticDiagnosticsBuilderProgram;
	        }
	        var host = system;
	        var useCaseSensitiveFileNames = function () { return system.useCaseSensitiveFileNames; };
	        var writeFileName = function (s) { return system.write(s + system.newLine); };
	        var onWatchStatusChange = reportWatchStatus || createWatchStatusReporter(system);
	        return {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            getNewLine: function () { return system.newLine; },
	            getCurrentDirectory: function () { return system.getCurrentDirectory(); },
	            getDefaultLibLocation: getDefaultLibLocation,
	            getDefaultLibFileName: function (options) { return ts.combinePaths(getDefaultLibLocation(), ts.getDefaultLibFileName(options)); },
	            fileExists: function (path) { return system.fileExists(path); },
	            readFile: function (path, encoding) { return system.readFile(path, encoding); },
	            directoryExists: function (path) { return system.directoryExists(path); },
	            getDirectories: function (path) { return system.getDirectories(path); },
	            readDirectory: function (path, extensions, exclude, include, depth) { return system.readDirectory(path, extensions, exclude, include, depth); },
	            realpath: system.realpath && (function (path) { return system.realpath(path); }),
	            getEnvironmentVariable: system.getEnvironmentVariable && (function (name) { return system.getEnvironmentVariable(name); }),
	            watchFile: system.watchFile ? (function (path, callback, pollingInterval) { return system.watchFile(path, callback, pollingInterval); }) : function () { return noopFileWatcher; },
	            watchDirectory: system.watchDirectory ? (function (path, callback, recursive) { return system.watchDirectory(path, callback, recursive); }) : function () { return noopFileWatcher; },
	            setTimeout: system.setTimeout ? (function (callback, ms) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                var _a;
	                return (_a = system.setTimeout).call.apply(_a, [system, callback, ms].concat(args));
	            }) : ts.noop,
	            clearTimeout: system.clearTimeout ? (function (timeoutId) { return system.clearTimeout(timeoutId); }) : ts.noop,
	            trace: function (s) { return system.write(s); },
	            onWatchStatusChange: onWatchStatusChange,
	            createDirectory: function (path) { return system.createDirectory(path); },
	            writeFile: function (path, data, writeByteOrderMark) { return system.writeFile(path, data, writeByteOrderMark); },
	            onCachedDirectoryStructureHostCreate: function (cacheHost) { return host = cacheHost || system; },
	            createHash: system.createHash && (function (s) { return system.createHash(s); }),
	            createProgram: createProgram,
	            afterProgramCreate: emitFilesAndReportErrorUsingBuilder
	        };
	        function getDefaultLibLocation() {
	            return ts.getDirectoryPath(ts.normalizePath(system.getExecutingFilePath()));
	        }
	        function emitFilesAndReportErrorUsingBuilder(builderProgram) {
	            var compilerOptions = builderProgram.getCompilerOptions();
	            var newLine = ts.getNewLineCharacter(compilerOptions, function () { return system.newLine; });
	            var reportSummary = function (errorCount) {
	                if (errorCount === 1) {
	                    onWatchStatusChange(ts.createCompilerDiagnostic(ts.Diagnostics.Found_1_error_Watching_for_file_changes, errorCount), newLine, compilerOptions);
	                }
	                else {
	                    onWatchStatusChange(ts.createCompilerDiagnostic(ts.Diagnostics.Found_0_errors_Watching_for_file_changes, errorCount, errorCount), newLine, compilerOptions);
	                }
	            };
	            emitFilesAndReportErrors(builderProgram, reportDiagnostic, writeFileName, reportSummary);
	        }
	    }
	    /**
	     * Report error and exit
	     */
	    function reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic) {
	        reportDiagnostic(diagnostic);
	        system.exit(ts.ExitStatus.DiagnosticsPresent_OutputsSkipped);
	    }
	    /**
	     * Creates the watch compiler host from system for config file in watch mode
	     */
	    function createWatchCompilerHostOfConfigFile(configFileName, optionsToExtend, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        reportDiagnostic = reportDiagnostic || createDiagnosticReporter(system);
	        var host = createWatchCompilerHost(system, createProgram, reportDiagnostic, reportWatchStatus);
	        host.onUnRecoverableConfigFileDiagnostic = function (diagnostic) { return reportUnrecoverableDiagnostic(system, reportDiagnostic, diagnostic); };
	        host.configFileName = configFileName;
	        host.optionsToExtend = optionsToExtend;
	        return host;
	    }
	    ts.createWatchCompilerHostOfConfigFile = createWatchCompilerHostOfConfigFile;
	    /**
	     * Creates the watch compiler host from system for compiling root files and options in watch mode
	     */
	    function createWatchCompilerHostOfFilesAndCompilerOptions(rootFiles, options, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        var host = createWatchCompilerHost(system, createProgram, reportDiagnostic || createDiagnosticReporter(system), reportWatchStatus);
	        host.rootFiles = rootFiles;
	        host.options = options;
	        return host;
	    }
	    ts.createWatchCompilerHostOfFilesAndCompilerOptions = createWatchCompilerHostOfFilesAndCompilerOptions;
	})(ts || (ts = {}));
	(function (ts) {
	    function createWatchCompilerHost(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus) {
	        if (ts.isArray(rootFilesOrConfigFileName)) {
	            return ts.createWatchCompilerHostOfFilesAndCompilerOptions(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus);
	        }
	        else {
	            return ts.createWatchCompilerHostOfConfigFile(rootFilesOrConfigFileName, options, system, createProgram, reportDiagnostic, reportWatchStatus);
	        }
	    }
	    ts.createWatchCompilerHost = createWatchCompilerHost;
	    var initialVersion = 1;
	    function createWatchProgram(host) {
	        var builderProgram;
	        var reloadLevel; // level to indicate if the program needs to be reloaded from config file/just filenames etc
	        var missingFilesMap; // Map of file watchers for the missing files
	        var watchedWildcardDirectories; // map of watchers for the wild card directories in the config file
	        var timerToUpdateProgram; // timer callback to recompile the program
	        var sourceFilesCache = ts.createMap(); // Cache that stores the source file and version info
	        var missingFilePathsRequestedForRelease; // These paths are held temparirly so that we can remove the entry from source file cache if the file is not tracked by missing files
	        var hasChangedCompilerOptions = false; // True if the compiler options have changed between compilations
	        var hasChangedAutomaticTypeDirectiveNames = false; // True if the automatic type directives have changed
	        var useCaseSensitiveFileNames = host.useCaseSensitiveFileNames();
	        var currentDirectory = host.getCurrentDirectory();
	        var getCurrentDirectory = function () { return currentDirectory; };
	        var readFile = function (path, encoding) { return host.readFile(path, encoding); };
	        var configFileName = host.configFileName, _a = host.optionsToExtend, optionsToExtendForConfigFile = _a === void 0 ? {} : _a, createProgram = host.createProgram;
	        var rootFileNames = host.rootFiles, compilerOptions = host.options;
	        var configFileSpecs;
	        var configFileParsingDiagnostics;
	        var hasChangedConfigFileParsingErrors = false;
	        var cachedDirectoryStructureHost = configFileName && ts.createCachedDirectoryStructureHost(host, currentDirectory, useCaseSensitiveFileNames);
	        if (cachedDirectoryStructureHost && host.onCachedDirectoryStructureHostCreate) {
	            host.onCachedDirectoryStructureHostCreate(cachedDirectoryStructureHost);
	        }
	        var directoryStructureHost = cachedDirectoryStructureHost || host;
	        var parseConfigFileHost = {
	            useCaseSensitiveFileNames: useCaseSensitiveFileNames,
	            readDirectory: function (path, extensions, exclude, include, depth) { return directoryStructureHost.readDirectory(path, extensions, exclude, include, depth); },
	            fileExists: function (path) { return host.fileExists(path); },
	            readFile: readFile,
	            getCurrentDirectory: getCurrentDirectory,
	            onUnRecoverableConfigFileDiagnostic: host.onUnRecoverableConfigFileDiagnostic
	        };
	        // From tsc we want to get already parsed result and hence check for rootFileNames
	        var newLine = updateNewLine();
	        reportWatchDiagnostic(ts.Diagnostics.Starting_compilation_in_watch_mode);
	        if (configFileName) {
	            newLine = ts.getNewLineCharacter(optionsToExtendForConfigFile, function () { return host.getNewLine(); });
	            if (host.configFileParsingResult) {
	                setConfigFileParsingResult(host.configFileParsingResult);
	            }
	            else {
	                ts.Debug.assert(!rootFileNames);
	                parseConfigFile();
	            }
	            newLine = updateNewLine();
	        }
	        var trace = host.trace && (function (s) { host.trace(s + newLine); });
	        var watchLogLevel = trace ? compilerOptions.extendedDiagnostics ? ts.WatchLogLevel.Verbose :
	            compilerOptions.diagnostis ? ts.WatchLogLevel.TriggerOnly : ts.WatchLogLevel.None : ts.WatchLogLevel.None;
	        var writeLog = watchLogLevel !== ts.WatchLogLevel.None ? trace : ts.noop;
	        var _b = ts.getWatchFactory(watchLogLevel, writeLog), watchFile = _b.watchFile, watchFilePath = _b.watchFilePath, watchDirectory = _b.watchDirectory;
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        writeLog("Current directory: " + currentDirectory + " CaseSensitiveFileNames: " + useCaseSensitiveFileNames);
	        if (configFileName) {
	            watchFile(host, configFileName, scheduleProgramReload, ts.PollingInterval.High, "Config file");
	        }
	        var compilerHost = {
	            // Members for CompilerHost
	            getSourceFile: function (fileName, languageVersion, onError, shouldCreateNewSourceFile) { return getVersionedSourceFileByPath(fileName, toPath(fileName), languageVersion, onError, shouldCreateNewSourceFile); },
	            getSourceFileByPath: getVersionedSourceFileByPath,
	            getDefaultLibLocation: host.getDefaultLibLocation && (function () { return host.getDefaultLibLocation(); }),
	            getDefaultLibFileName: function (options) { return host.getDefaultLibFileName(options); },
	            writeFile: writeFile,
	            getCurrentDirectory: getCurrentDirectory,
	            useCaseSensitiveFileNames: function () { return useCaseSensitiveFileNames; },
	            getCanonicalFileName: getCanonicalFileName,
	            getNewLine: function () { return newLine; },
	            fileExists: fileExists,
	            readFile: readFile,
	            trace: trace,
	            directoryExists: directoryStructureHost.directoryExists && (function (path) { return directoryStructureHost.directoryExists(path); }),
	            getDirectories: directoryStructureHost.getDirectories && (function (path) { return directoryStructureHost.getDirectories(path); }),
	            realpath: host.realpath && (function (s) { return host.realpath(s); }),
	            getEnvironmentVariable: host.getEnvironmentVariable ? (function (name) { return host.getEnvironmentVariable(name); }) : (function () { return ""; }),
	            onReleaseOldSourceFile: onReleaseOldSourceFile,
	            createHash: host.createHash && (function (data) { return host.createHash(data); }),
	            // Members for ResolutionCacheHost
	            toPath: toPath,
	            getCompilationSettings: function () { return compilerOptions; },
	            watchDirectoryOfFailedLookupLocation: function (dir, cb, flags) { return watchDirectory(host, dir, cb, flags, "Failed Lookup Locations"); },
	            watchTypeRootsDirectory: function (dir, cb, flags) { return watchDirectory(host, dir, cb, flags, "Type roots"); },
	            getCachedDirectoryStructureHost: function () { return cachedDirectoryStructureHost; },
	            onInvalidatedResolution: scheduleProgramUpdate,
	            onChangedAutomaticTypeDirectiveNames: function () {
	                hasChangedAutomaticTypeDirectiveNames = true;
	                scheduleProgramUpdate();
	            },
	            maxNumberOfFilesToIterateForInvalidation: host.maxNumberOfFilesToIterateForInvalidation,
	            getCurrentProgram: getCurrentProgram,
	            writeLog: writeLog
	        };
	        // Cache for the module resolution
	        var resolutionCache = ts.createResolutionCache(compilerHost, configFileName ?
	            ts.getDirectoryPath(ts.getNormalizedAbsolutePath(configFileName, currentDirectory)) :
	            currentDirectory, 
	        /*logChangesWhenResolvingModule*/ false);
	        // Resolve module using host module resolution strategy if provided otherwise use resolution cache to resolve module names
	        compilerHost.resolveModuleNames = host.resolveModuleNames ?
	            (function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(moduleNames, containingFile, reusedNames); }) :
	            (function (moduleNames, containingFile, reusedNames) { return resolutionCache.resolveModuleNames(moduleNames, containingFile, reusedNames); });
	        compilerHost.resolveTypeReferenceDirectives = host.resolveTypeReferenceDirectives ?
	            (function (typeDirectiveNames, containingFile) { return host.resolveTypeReferenceDirectives(typeDirectiveNames, containingFile); }) :
	            (function (typeDirectiveNames, containingFile) { return resolutionCache.resolveTypeReferenceDirectives(typeDirectiveNames, containingFile); });
	        var userProvidedResolution = !!host.resolveModuleNames || !!host.resolveTypeReferenceDirectives;
	        synchronizeProgram();
	        // Update the wild card directory watch
	        watchConfigFileWildCardDirectories();
	        return configFileName ?
	            { getCurrentProgram: getCurrentBuilderProgram, getProgram: synchronizeProgram } :
	            { getCurrentProgram: getCurrentBuilderProgram, getProgram: synchronizeProgram, updateRootFileNames: updateRootFileNames };
	        function getCurrentBuilderProgram() {
	            return builderProgram;
	        }
	        function getCurrentProgram() {
	            return builderProgram && builderProgram.getProgram();
	        }
	        function synchronizeProgram() {
	            writeLog("Synchronizing program");
	            var program = getCurrentProgram();
	            if (hasChangedCompilerOptions) {
	                newLine = updateNewLine();
	                if (program && ts.changesAffectModuleResolution(program.getCompilerOptions(), compilerOptions)) {
	                    resolutionCache.clear();
	                }
	            }
	            // All resolutions are invalid if user provided resolutions
	            var hasInvalidatedResolution = resolutionCache.createHasInvalidatedResolution(userProvidedResolution);
	            if (ts.isProgramUptoDate(getCurrentProgram(), rootFileNames, compilerOptions, getSourceVersion, fileExists, hasInvalidatedResolution, hasChangedAutomaticTypeDirectiveNames)) {
	                if (hasChangedConfigFileParsingErrors) {
	                    builderProgram = createProgram(/*rootNames*/ undefined, /*options*/ undefined, compilerHost, builderProgram, configFileParsingDiagnostics);
	                    hasChangedConfigFileParsingErrors = false;
	                }
	            }
	            else {
	                createNewProgram(program, hasInvalidatedResolution);
	            }
	            if (host.afterProgramCreate) {
	                host.afterProgramCreate(builderProgram);
	            }
	            return builderProgram;
	        }
	        function createNewProgram(program, hasInvalidatedResolution) {
	            // Compile the program
	            if (watchLogLevel !== ts.WatchLogLevel.None) {
	                writeLog("CreatingProgramWith::");
	                writeLog("  roots: " + JSON.stringify(rootFileNames));
	                writeLog("  options: " + JSON.stringify(compilerOptions));
	            }
	            var needsUpdateInTypeRootWatch = hasChangedCompilerOptions || !program;
	            hasChangedCompilerOptions = false;
	            hasChangedConfigFileParsingErrors = false;
	            resolutionCache.startCachingPerDirectoryResolution();
	            compilerHost.hasInvalidatedResolution = hasInvalidatedResolution;
	            compilerHost.hasChangedAutomaticTypeDirectiveNames = hasChangedAutomaticTypeDirectiveNames;
	            builderProgram = createProgram(rootFileNames, compilerOptions, compilerHost, builderProgram, configFileParsingDiagnostics);
	            resolutionCache.finishCachingPerDirectoryResolution();
	            // Update watches
	            ts.updateMissingFilePathsWatch(builderProgram.getProgram(), missingFilesMap || (missingFilesMap = ts.createMap()), watchMissingFilePath);
	            if (needsUpdateInTypeRootWatch) {
	                resolutionCache.updateTypeRootsWatch();
	            }
	            if (missingFilePathsRequestedForRelease) {
	                // These are the paths that program creater told us as not in use any more but were missing on the disk.
	                // We didnt remove the entry for them from sourceFiles cache so that we dont have to do File IO,
	                // if there is already watcher for it (for missing files)
	                // At this point our watches were updated, hence now we know that these paths are not tracked and need to be removed
	                // so that at later time we have correct result of their presence
	                for (var _i = 0, missingFilePathsRequestedForRelease_1 = missingFilePathsRequestedForRelease; _i < missingFilePathsRequestedForRelease_1.length; _i++) {
	                    var missingFilePath = missingFilePathsRequestedForRelease_1[_i];
	                    if (!missingFilesMap.has(missingFilePath)) {
	                        sourceFilesCache.delete(missingFilePath);
	                    }
	                }
	                missingFilePathsRequestedForRelease = undefined;
	            }
	        }
	        function updateRootFileNames(files) {
	            ts.Debug.assert(!configFileName, "Cannot update root file names with config file watch mode");
	            rootFileNames = files;
	            scheduleProgramUpdate();
	        }
	        function updateNewLine() {
	            return ts.getNewLineCharacter(compilerOptions || optionsToExtendForConfigFile, function () { return host.getNewLine(); });
	        }
	        function toPath(fileName) {
	            return ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	        }
	        function isFileMissingOnHost(hostSourceFile) {
	            return typeof hostSourceFile === "number";
	        }
	        function isFilePresentOnHost(hostSourceFile) {
	            return !!hostSourceFile.sourceFile;
	        }
	        function fileExists(fileName) {
	            var path = toPath(fileName);
	            // If file is missing on host from cache, we can definitely say file doesnt exist
	            // otherwise we need to ensure from the disk
	            if (isFileMissingOnHost(sourceFilesCache.get(path))) {
	                return true;
	            }
	            return directoryStructureHost.fileExists(fileName);
	        }
	        function getVersionedSourceFileByPath(fileName, path, languageVersion, onError, shouldCreateNewSourceFile) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            // No source file on the host
	            if (isFileMissingOnHost(hostSourceFile)) {
	                return undefined;
	            }
	            // Create new source file if requested or the versions dont match
	            if (!hostSourceFile || shouldCreateNewSourceFile || !isFilePresentOnHost(hostSourceFile) || hostSourceFile.version.toString() !== hostSourceFile.sourceFile.version) {
	                var sourceFile = getNewSourceFile();
	                if (hostSourceFile) {
	                    if (shouldCreateNewSourceFile) {
	                        hostSourceFile.version++;
	                    }
	                    if (sourceFile) {
	                        // Set the source file and create file watcher now that file was present on the disk
	                        hostSourceFile.sourceFile = sourceFile;
	                        sourceFile.version = hostSourceFile.version.toString();
	                        if (!hostSourceFile.fileWatcher) {
	                            hostSourceFile.fileWatcher = watchFilePath(host, fileName, onSourceFileChange, ts.PollingInterval.Low, path, "Source file");
	                        }
	                    }
	                    else {
	                        // There is no source file on host any more, close the watch, missing file paths will track it
	                        if (isFilePresentOnHost(hostSourceFile)) {
	                            hostSourceFile.fileWatcher.close();
	                        }
	                        sourceFilesCache.set(path, hostSourceFile.version);
	                    }
	                }
	                else {
	                    if (sourceFile) {
	                        sourceFile.version = initialVersion.toString();
	                        var fileWatcher = watchFilePath(host, fileName, onSourceFileChange, ts.PollingInterval.Low, path, "Source file");
	                        sourceFilesCache.set(path, { sourceFile: sourceFile, version: initialVersion, fileWatcher: fileWatcher });
	                    }
	                    else {
	                        sourceFilesCache.set(path, initialVersion);
	                    }
	                }
	                return sourceFile;
	            }
	            return hostSourceFile.sourceFile;
	            function getNewSourceFile() {
	                var text;
	                try {
	                    ts.performance.mark("beforeIORead");
	                    text = host.readFile(fileName, compilerOptions.charset);
	                    ts.performance.mark("afterIORead");
	                    ts.performance.measure("I/O Read", "beforeIORead", "afterIORead");
	                }
	                catch (e) {
	                    if (onError) {
	                        onError(e.message);
	                    }
	                }
	                return text !== undefined ? ts.createSourceFile(fileName, text, languageVersion) : undefined;
	            }
	        }
	        function nextSourceFileVersion(path) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            if (hostSourceFile !== undefined) {
	                if (isFileMissingOnHost(hostSourceFile)) {
	                    // The next version, lets set it as presence unknown file
	                    sourceFilesCache.set(path, { version: Number(hostSourceFile) + 1 });
	                }
	                else {
	                    hostSourceFile.version++;
	                }
	            }
	        }
	        function getSourceVersion(path) {
	            var hostSourceFile = sourceFilesCache.get(path);
	            return !hostSourceFile || isFileMissingOnHost(hostSourceFile) ? undefined : hostSourceFile.version.toString();
	        }
	        function onReleaseOldSourceFile(oldSourceFile, _oldOptions) {
	            var hostSourceFileInfo = sourceFilesCache.get(oldSourceFile.path);
	            // If this is the source file thats in the cache and new program doesnt need it,
	            // remove the cached entry.
	            // Note we arent deleting entry if file became missing in new program or
	            // there was version update and new source file was created.
	            if (hostSourceFileInfo) {
	                // record the missing file paths so they can be removed later if watchers arent tracking them
	                if (isFileMissingOnHost(hostSourceFileInfo)) {
	                    (missingFilePathsRequestedForRelease || (missingFilePathsRequestedForRelease = [])).push(oldSourceFile.path);
	                }
	                else if (hostSourceFileInfo.sourceFile === oldSourceFile) {
	                    if (hostSourceFileInfo.fileWatcher) {
	                        hostSourceFileInfo.fileWatcher.close();
	                    }
	                    sourceFilesCache.delete(oldSourceFile.path);
	                    resolutionCache.removeResolutionsOfFile(oldSourceFile.path);
	                }
	            }
	        }
	        function reportWatchDiagnostic(message) {
	            if (host.onWatchStatusChange) {
	                host.onWatchStatusChange(ts.createCompilerDiagnostic(message), newLine, compilerOptions || optionsToExtendForConfigFile);
	            }
	        }
	        // Upon detecting a file change, wait for 250ms and then perform a recompilation. This gives batch
	        // operations (such as saving all modified files in an editor) a chance to complete before we kick
	        // off a new compilation.
	        function scheduleProgramUpdate() {
	            if (!host.setTimeout || !host.clearTimeout) {
	                return;
	            }
	            if (timerToUpdateProgram) {
	                host.clearTimeout(timerToUpdateProgram);
	            }
	            writeLog("Scheduling update");
	            timerToUpdateProgram = host.setTimeout(updateProgram, 250);
	        }
	        function scheduleProgramReload() {
	            ts.Debug.assert(!!configFileName);
	            reloadLevel = ts.ConfigFileProgramReloadLevel.Full;
	            scheduleProgramUpdate();
	        }
	        function updateProgram() {
	            timerToUpdateProgram = undefined;
	            reportWatchDiagnostic(ts.Diagnostics.File_change_detected_Starting_incremental_compilation);
	            switch (reloadLevel) {
	                case ts.ConfigFileProgramReloadLevel.Partial:
	                    return reloadFileNamesFromConfigFile();
	                case ts.ConfigFileProgramReloadLevel.Full:
	                    return reloadConfigFile();
	                default:
	                    synchronizeProgram();
	                    return;
	            }
	        }
	        function reloadFileNamesFromConfigFile() {
	            writeLog("Reloading new file names and options");
	            var result = ts.getFileNamesFromConfigSpecs(configFileSpecs, ts.getDirectoryPath(configFileName), compilerOptions, parseConfigFileHost);
	            if (result.fileNames.length) {
	                configFileParsingDiagnostics = ts.filter(configFileParsingDiagnostics, function (error) { return !ts.isErrorNoInputFiles(error); });
	                hasChangedConfigFileParsingErrors = true;
	            }
	            else if (!configFileSpecs.filesSpecs && !ts.some(configFileParsingDiagnostics, ts.isErrorNoInputFiles)) {
	                configFileParsingDiagnostics = configFileParsingDiagnostics.concat(ts.getErrorForNoInputFiles(configFileSpecs, configFileName));
	                hasChangedConfigFileParsingErrors = true;
	            }
	            rootFileNames = result.fileNames;
	            // Update the program
	            synchronizeProgram();
	        }
	        function reloadConfigFile() {
	            writeLog("Reloading config file: " + configFileName);
	            reloadLevel = ts.ConfigFileProgramReloadLevel.None;
	            if (cachedDirectoryStructureHost) {
	                cachedDirectoryStructureHost.clearCache();
	            }
	            parseConfigFile();
	            hasChangedCompilerOptions = true;
	            synchronizeProgram();
	            // Update the wild card directory watch
	            watchConfigFileWildCardDirectories();
	        }
	        function parseConfigFile() {
	            setConfigFileParsingResult(ts.getParsedCommandLineOfConfigFile(configFileName, optionsToExtendForConfigFile, parseConfigFileHost));
	        }
	        function setConfigFileParsingResult(configFileParseResult) {
	            rootFileNames = configFileParseResult.fileNames;
	            compilerOptions = configFileParseResult.options;
	            configFileSpecs = configFileParseResult.configFileSpecs;
	            configFileParsingDiagnostics = ts.getConfigFileParsingDiagnostics(configFileParseResult);
	            hasChangedConfigFileParsingErrors = true;
	        }
	        function onSourceFileChange(fileName, eventKind, path) {
	            updateCachedSystemWithFile(fileName, path, eventKind);
	            // Update the source file cache
	            if (eventKind === ts.FileWatcherEventKind.Deleted && sourceFilesCache.get(path)) {
	                resolutionCache.invalidateResolutionOfFile(path);
	            }
	            nextSourceFileVersion(path);
	            // Update the program
	            scheduleProgramUpdate();
	        }
	        function updateCachedSystemWithFile(fileName, path, eventKind) {
	            if (cachedDirectoryStructureHost) {
	                cachedDirectoryStructureHost.addOrDeleteFile(fileName, path, eventKind);
	            }
	        }
	        function watchMissingFilePath(missingFilePath) {
	            return watchFilePath(host, missingFilePath, onMissingFileChange, ts.PollingInterval.Medium, missingFilePath, "Missing file");
	        }
	        function onMissingFileChange(fileName, eventKind, missingFilePath) {
	            updateCachedSystemWithFile(fileName, missingFilePath, eventKind);
	            if (eventKind === ts.FileWatcherEventKind.Created && missingFilesMap.has(missingFilePath)) {
	                missingFilesMap.get(missingFilePath).close();
	                missingFilesMap.delete(missingFilePath);
	                // Delete the entry in the source files cache so that new source file is created
	                nextSourceFileVersion(missingFilePath);
	                // When a missing file is created, we should update the graph.
	                scheduleProgramUpdate();
	            }
	        }
	        function watchConfigFileWildCardDirectories() {
	            if (configFileSpecs) {
	                ts.updateWatchingWildcardDirectories(watchedWildcardDirectories || (watchedWildcardDirectories = ts.createMap()), ts.createMapFromTemplate(configFileSpecs.wildcardDirectories), watchWildcardDirectory);
	            }
	            else if (watchedWildcardDirectories) {
	                ts.clearMap(watchedWildcardDirectories, ts.closeFileWatcherOf);
	            }
	        }
	        function watchWildcardDirectory(directory, flags) {
	            return watchDirectory(host, directory, function (fileOrDirectory) {
	                ts.Debug.assert(!!configFileName);
	                var fileOrDirectoryPath = toPath(fileOrDirectory);
	                // Since the file existance changed, update the sourceFiles cache
	                if (cachedDirectoryStructureHost) {
	                    cachedDirectoryStructureHost.addOrDeleteFileOrDirectory(fileOrDirectory, fileOrDirectoryPath);
	                }
	                nextSourceFileVersion(fileOrDirectoryPath);
	                // If the the added or created file or directory is not supported file name, ignore the file
	                // But when watched directory is added/removed, we need to reload the file list
	                if (fileOrDirectoryPath !== directory && ts.hasExtension(fileOrDirectoryPath) && !ts.isSupportedSourceFileName(fileOrDirectory, compilerOptions)) {
	                    writeLog("Project: " + configFileName + " Detected file add/remove of non supported extension: " + fileOrDirectory);
	                    return;
	                }
	                // Reload is pending, do the reload
	                if (reloadLevel !== ts.ConfigFileProgramReloadLevel.Full) {
	                    reloadLevel = ts.ConfigFileProgramReloadLevel.Partial;
	                    // Schedule Update the program
	                    scheduleProgramUpdate();
	                }
	            }, flags, "Wild card directories");
	        }
	        function ensureDirectoriesExist(directoryPath) {
	            if (directoryPath.length > ts.getRootLength(directoryPath) && !host.directoryExists(directoryPath)) {
	                var parentDirectory = ts.getDirectoryPath(directoryPath);
	                ensureDirectoriesExist(parentDirectory);
	                host.createDirectory(directoryPath);
	            }
	        }
	        function writeFile(fileName, text, writeByteOrderMark, onError) {
	            try {
	                ts.performance.mark("beforeIOWrite");
	                ensureDirectoriesExist(ts.getDirectoryPath(ts.normalizePath(fileName)));
	                host.writeFile(fileName, text, writeByteOrderMark);
	                ts.performance.mark("afterIOWrite");
	                ts.performance.measure("I/O Write", "beforeIOWrite", "afterIOWrite");
	            }
	            catch (e) {
	                if (onError) {
	                    onError(e.message);
	                }
	            }
	        }
	    }
	    ts.createWatchProgram = createWatchProgram;
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /* @internal */
	    ts.compileOnSaveCommandLineOption = { name: "compileOnSave", type: "boolean" };
	    /* @internal */
	    ts.optionDeclarations = [
	        // CommandLine only options
	        {
	            name: "help",
	            shortName: "h",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Print_this_message,
	        },
	        {
	            name: "help",
	            shortName: "?",
	            type: "boolean"
	        },
	        {
	            name: "all",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Show_all_compiler_options,
	        },
	        {
	            name: "version",
	            shortName: "v",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Print_the_compiler_s_version,
	        },
	        {
	            name: "init",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Initializes_a_TypeScript_project_and_creates_a_tsconfig_json_file,
	        },
	        {
	            name: "project",
	            shortName: "p",
	            type: "string",
	            isFilePath: true,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            paramType: ts.Diagnostics.FILE_OR_DIRECTORY,
	            description: ts.Diagnostics.Compile_the_project_given_the_path_to_its_configuration_file_or_to_a_folder_with_a_tsconfig_json,
	        },
	        {
	            name: "pretty",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Stylize_errors_and_messages_using_color_and_context_experimental
	        },
	        {
	            name: "preserveWatchOutput",
	            type: "boolean",
	            showInSimplifiedHelpView: false,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Whether_to_keep_outdated_console_output_in_watch_mode_instead_of_clearing_the_screen,
	        },
	        {
	            name: "watch",
	            shortName: "w",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Command_line_Options,
	            description: ts.Diagnostics.Watch_input_files,
	        },
	        // Basic
	        {
	            name: "target",
	            shortName: "t",
	            type: ts.createMapFromTemplate({
	                es3: 0 /* ES3 */,
	                es5: 1 /* ES5 */,
	                es6: 2 /* ES2015 */,
	                es2015: 2 /* ES2015 */,
	                es2016: 3 /* ES2016 */,
	                es2017: 4 /* ES2017 */,
	                es2018: 5 /* ES2018 */,
	                esnext: 6 /* ESNext */,
	            }),
	            paramType: ts.Diagnostics.VERSION,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_ECMAScript_target_version_Colon_ES3_default_ES5_ES2015_ES2016_ES2017_ES2018_or_ESNEXT,
	        },
	        {
	            name: "module",
	            shortName: "m",
	            type: ts.createMapFromTemplate({
	                none: ts.ModuleKind.None,
	                commonjs: ts.ModuleKind.CommonJS,
	                amd: ts.ModuleKind.AMD,
	                system: ts.ModuleKind.System,
	                umd: ts.ModuleKind.UMD,
	                es6: ts.ModuleKind.ES2015,
	                es2015: ts.ModuleKind.ES2015,
	                esnext: ts.ModuleKind.ESNext
	            }),
	            paramType: ts.Diagnostics.KIND,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_module_code_generation_Colon_none_commonjs_amd_system_umd_es2015_or_ESNext,
	        },
	        {
	            name: "lib",
	            type: "list",
	            element: {
	                name: "lib",
	                type: ts.createMapFromTemplate({
	                    // JavaScript only
	                    "es5": "lib.es5.d.ts",
	                    "es6": "lib.es2015.d.ts",
	                    "es2015": "lib.es2015.d.ts",
	                    "es7": "lib.es2016.d.ts",
	                    "es2016": "lib.es2016.d.ts",
	                    "es2017": "lib.es2017.d.ts",
	                    "es2018": "lib.es2018.d.ts",
	                    "esnext": "lib.esnext.d.ts",
	                    // Host only
	                    "dom": "lib.dom.d.ts",
	                    "dom.iterable": "lib.dom.iterable.d.ts",
	                    "webworker": "lib.webworker.d.ts",
	                    "scripthost": "lib.scripthost.d.ts",
	                    // ES2015 Or ESNext By-feature options
	                    "es2015.core": "lib.es2015.core.d.ts",
	                    "es2015.collection": "lib.es2015.collection.d.ts",
	                    "es2015.generator": "lib.es2015.generator.d.ts",
	                    "es2015.iterable": "lib.es2015.iterable.d.ts",
	                    "es2015.promise": "lib.es2015.promise.d.ts",
	                    "es2015.proxy": "lib.es2015.proxy.d.ts",
	                    "es2015.reflect": "lib.es2015.reflect.d.ts",
	                    "es2015.symbol": "lib.es2015.symbol.d.ts",
	                    "es2015.symbol.wellknown": "lib.es2015.symbol.wellknown.d.ts",
	                    "es2016.array.include": "lib.es2016.array.include.d.ts",
	                    "es2017.object": "lib.es2017.object.d.ts",
	                    "es2017.sharedmemory": "lib.es2017.sharedmemory.d.ts",
	                    "es2017.string": "lib.es2017.string.d.ts",
	                    "es2017.intl": "lib.es2017.intl.d.ts",
	                    "es2017.typedarrays": "lib.es2017.typedarrays.d.ts",
	                    "es2018.intl": "lib.es2018.intl.d.ts",
	                    "es2018.promise": "lib.es2018.promise.d.ts",
	                    "es2018.regexp": "lib.es2018.regexp.d.ts",
	                    "esnext.array": "lib.esnext.array.d.ts",
	                    "esnext.asynciterable": "lib.esnext.asynciterable.d.ts",
	                }),
	            },
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_library_files_to_be_included_in_the_compilation
	        },
	        {
	            name: "allowJs",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Allow_javascript_files_to_be_compiled
	        },
	        {
	            name: "checkJs",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Report_errors_in_js_files
	        },
	        {
	            name: "jsx",
	            type: ts.createMapFromTemplate({
	                "preserve": 1 /* Preserve */,
	                "react-native": 3 /* ReactNative */,
	                "react": 2 /* React */
	            }),
	            paramType: ts.Diagnostics.KIND,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_JSX_code_generation_Colon_preserve_react_native_or_react,
	        },
	        {
	            name: "declaration",
	            shortName: "d",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Generates_corresponding_d_ts_file,
	        },
	        {
	            name: "declarationMap",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Generates_a_sourcemap_for_each_corresponding_d_ts_file,
	        },
	        {
	            name: "emitDeclarationOnly",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Only_emit_d_ts_declaration_files,
	        },
	        {
	            name: "sourceMap",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Generates_corresponding_map_file,
	        },
	        {
	            name: "outFile",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.FILE,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Concatenate_and_emit_output_to_single_file,
	        },
	        {
	            name: "outDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.DIRECTORY,
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Redirect_output_structure_to_the_directory,
	        },
	        {
	            name: "rootDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Specify_the_root_directory_of_input_files_Use_to_control_the_output_directory_structure_with_outDir,
	        },
	        {
	            name: "composite",
	            type: "boolean",
	            isTSConfigOnly: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Enable_project_compilation,
	        },
	        {
	            name: "removeComments",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Do_not_emit_comments_to_output,
	        },
	        {
	            name: "noEmit",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Do_not_emit_outputs,
	        },
	        {
	            name: "importHelpers",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Import_emit_helpers_from_tslib
	        },
	        {
	            name: "downlevelIteration",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Provide_full_support_for_iterables_in_for_of_spread_and_destructuring_when_targeting_ES5_or_ES3
	        },
	        {
	            name: "isolatedModules",
	            type: "boolean",
	            category: ts.Diagnostics.Basic_Options,
	            description: ts.Diagnostics.Transpile_each_file_as_a_separate_module_similar_to_ts_transpileModule
	        },
	        // Strict Type Checks
	        {
	            name: "strict",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_all_strict_type_checking_options
	        },
	        {
	            name: "noImplicitAny",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Raise_error_on_expressions_and_declarations_with_an_implied_any_type,
	        },
	        {
	            name: "strictNullChecks",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_null_checks
	        },
	        {
	            name: "strictFunctionTypes",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_checking_of_function_types
	        },
	        {
	            name: "strictPropertyInitialization",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Enable_strict_checking_of_property_initialization_in_classes
	        },
	        {
	            name: "noImplicitThis",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Raise_error_on_this_expressions_with_an_implied_any_type,
	        },
	        {
	            name: "alwaysStrict",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Strict_Type_Checking_Options,
	            description: ts.Diagnostics.Parse_in_strict_mode_and_emit_use_strict_for_each_source_file
	        },
	        // Additional Checks
	        {
	            name: "noUnusedLocals",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_on_unused_locals,
	        },
	        {
	            name: "noUnusedParameters",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_on_unused_parameters,
	        },
	        {
	            name: "noImplicitReturns",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_error_when_not_all_code_paths_in_function_return_a_value
	        },
	        {
	            name: "noFallthroughCasesInSwitch",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Additional_Checks,
	            description: ts.Diagnostics.Report_errors_for_fallthrough_cases_in_switch_statement
	        },
	        // Module Resolution
	        {
	            name: "moduleResolution",
	            type: ts.createMapFromTemplate({
	                node: ts.ModuleResolutionKind.NodeJs,
	                classic: ts.ModuleResolutionKind.Classic,
	            }),
	            paramType: ts.Diagnostics.STRATEGY,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Specify_module_resolution_strategy_Colon_node_Node_js_or_classic_TypeScript_pre_1_6,
	        },
	        {
	            name: "baseUrl",
	            type: "string",
	            isFilePath: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Base_directory_to_resolve_non_absolute_module_names
	        },
	        {
	            // this option can only be specified in tsconfig.json
	            // use type = object to copy the value as-is
	            name: "paths",
	            type: "object",
	            isTSConfigOnly: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.A_series_of_entries_which_re_map_imports_to_lookup_locations_relative_to_the_baseUrl
	        },
	        {
	            // this option can only be specified in tsconfig.json
	            // use type = object to copy the value as-is
	            name: "rootDirs",
	            type: "list",
	            isTSConfigOnly: true,
	            element: {
	                name: "rootDirs",
	                type: "string",
	                isFilePath: true
	            },
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.List_of_root_folders_whose_combined_content_represents_the_structure_of_the_project_at_runtime
	        },
	        {
	            name: "typeRoots",
	            type: "list",
	            element: {
	                name: "typeRoots",
	                type: "string",
	                isFilePath: true
	            },
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.List_of_folders_to_include_type_definitions_from
	        },
	        {
	            name: "types",
	            type: "list",
	            element: {
	                name: "types",
	                type: "string"
	            },
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Type_declaration_files_to_be_included_in_compilation
	        },
	        {
	            name: "allowSyntheticDefaultImports",
	            type: "boolean",
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Allow_default_imports_from_modules_with_no_default_export_This_does_not_affect_code_emit_just_typechecking
	        },
	        {
	            name: "esModuleInterop",
	            type: "boolean",
	            showInSimplifiedHelpView: true,
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Enables_emit_interoperability_between_CommonJS_and_ES_Modules_via_creation_of_namespace_objects_for_all_imports_Implies_allowSyntheticDefaultImports
	        },
	        {
	            name: "preserveSymlinks",
	            type: "boolean",
	            category: ts.Diagnostics.Module_Resolution_Options,
	            description: ts.Diagnostics.Do_not_resolve_the_real_path_of_symlinks,
	        },
	        // Source Maps
	        {
	            name: "sourceRoot",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Specify_the_location_where_debugger_should_locate_TypeScript_files_instead_of_source_locations,
	        },
	        {
	            name: "mapRoot",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.LOCATION,
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Specify_the_location_where_debugger_should_locate_map_files_instead_of_generated_locations,
	        },
	        {
	            name: "inlineSourceMap",
	            type: "boolean",
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Emit_a_single_file_with_source_maps_instead_of_having_a_separate_file
	        },
	        {
	            name: "inlineSources",
	            type: "boolean",
	            category: ts.Diagnostics.Source_Map_Options,
	            description: ts.Diagnostics.Emit_the_source_alongside_the_sourcemaps_within_a_single_file_requires_inlineSourceMap_or_sourceMap_to_be_set
	        },
	        // Experimental
	        {
	            name: "experimentalDecorators",
	            type: "boolean",
	            category: ts.Diagnostics.Experimental_Options,
	            description: ts.Diagnostics.Enables_experimental_support_for_ES7_decorators
	        },
	        {
	            name: "emitDecoratorMetadata",
	            type: "boolean",
	            category: ts.Diagnostics.Experimental_Options,
	            description: ts.Diagnostics.Enables_experimental_support_for_emitting_type_metadata_for_decorators
	        },
	        // Advanced
	        {
	            name: "jsxFactory",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Specify_the_JSX_factory_function_to_use_when_targeting_react_JSX_emit_e_g_React_createElement_or_h
	        },
	        {
	            name: "diagnostics",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Show_diagnostic_information
	        },
	        {
	            name: "extendedDiagnostics",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Show_verbose_diagnostic_information
	        },
	        {
	            name: "traceResolution",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Enable_tracing_of_the_name_resolution_process
	        },
	        {
	            name: "resolveJsonModule",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Include_modules_imported_with_json_extension
	        },
	        {
	            name: "listFiles",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Print_names_of_files_part_of_the_compilation
	        },
	        {
	            name: "listEmittedFiles",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Print_names_of_generated_files_part_of_the_compilation
	        },
	        {
	            name: "out",
	            type: "string",
	            isFilePath: false,
	            // for correct behaviour, please use outFile
	            category: ts.Diagnostics.Advanced_Options,
	            paramType: ts.Diagnostics.FILE,
	            description: ts.Diagnostics.Deprecated_Use_outFile_instead_Concatenate_and_emit_output_to_single_file,
	        },
	        {
	            name: "reactNamespace",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Deprecated_Use_jsxFactory_instead_Specify_the_object_invoked_for_createElement_when_targeting_react_JSX_emit
	        },
	        {
	            name: "skipDefaultLibCheck",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Deprecated_Use_skipLibCheck_instead_Skip_type_checking_of_default_library_declaration_files
	        },
	        {
	            name: "charset",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_character_set_of_the_input_files
	        },
	        {
	            name: "emitBOM",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Emit_a_UTF_8_Byte_Order_Mark_BOM_in_the_beginning_of_output_files
	        },
	        {
	            name: "locale",
	            type: "string",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_locale_used_when_displaying_messages_to_the_user_e_g_en_us
	        },
	        {
	            name: "newLine",
	            type: ts.createMapFromTemplate({
	                crlf: 0 /* CarriageReturnLineFeed */,
	                lf: 1 /* LineFeed */
	            }),
	            paramType: ts.Diagnostics.NEWLINE,
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Specify_the_end_of_line_sequence_to_be_used_when_emitting_files_Colon_CRLF_dos_or_LF_unix,
	        },
	        {
	            name: "noErrorTruncation",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_truncate_error_messages
	        },
	        {
	            name: "noLib",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_include_the_default_library_file_lib_d_ts
	        },
	        {
	            name: "noResolve",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_add_triple_slash_references_or_imported_modules_to_the_list_of_compiled_files
	        },
	        {
	            name: "stripInternal",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_declarations_for_code_that_has_an_internal_annotation,
	        },
	        {
	            name: "disableSizeLimit",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disable_size_limitations_on_JavaScript_projects
	        },
	        {
	            name: "noImplicitUseStrict",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_use_strict_directives_in_module_output
	        },
	        {
	            name: "noEmitHelpers",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_generate_custom_helper_functions_like_extends_in_compiled_output
	        },
	        {
	            name: "noEmitOnError",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_emit_outputs_if_any_errors_were_reported,
	        },
	        {
	            name: "preserveConstEnums",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_erase_const_enum_declarations_in_generated_code
	        },
	        {
	            name: "declarationDir",
	            type: "string",
	            isFilePath: true,
	            paramType: ts.Diagnostics.DIRECTORY,
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Output_directory_for_generated_declaration_files
	        },
	        {
	            name: "skipLibCheck",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Skip_type_checking_of_declaration_files,
	        },
	        {
	            name: "allowUnusedLabels",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_report_errors_on_unused_labels
	        },
	        {
	            name: "allowUnreachableCode",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Do_not_report_errors_on_unreachable_code
	        },
	        {
	            name: "suppressExcessPropertyErrors",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Suppress_excess_property_checks_for_object_literals,
	        },
	        {
	            name: "suppressImplicitAnyIndexErrors",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Suppress_noImplicitAny_errors_for_indexing_objects_lacking_index_signatures,
	        },
	        {
	            name: "forceConsistentCasingInFileNames",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disallow_inconsistently_cased_references_to_the_same_file
	        },
	        {
	            name: "maxNodeModuleJsDepth",
	            type: "number",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.The_maximum_dependency_depth_to_search_under_node_modules_and_load_JavaScript_files
	        },
	        {
	            name: "noStrictGenericChecks",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Disable_strict_checking_of_generic_signatures_in_function_types,
	        },
	        {
	            name: "keyofStringsOnly",
	            type: "boolean",
	            category: ts.Diagnostics.Advanced_Options,
	            description: ts.Diagnostics.Resolve_keyof_to_string_valued_property_names_only_no_numbers_or_symbols,
	        },
	        {
	            // A list of plugins to load in the language service
	            name: "plugins",
	            type: "list",
	            isTSConfigOnly: true,
	            element: {
	                name: "plugin",
	                type: "object"
	            },
	            description: ts.Diagnostics.List_of_language_service_plugins
	        }
	    ];
	    /* @internal */
	    ts.typeAcquisitionDeclarations = [
	        {
	            /* @deprecated typingOptions.enableAutoDiscovery
	             * Use typeAcquisition.enable instead.
	             */
	            name: "enableAutoDiscovery",
	            type: "boolean",
	        },
	        {
	            name: "enable",
	            type: "boolean",
	        },
	        {
	            name: "include",
	            type: "list",
	            element: {
	                name: "include",
	                type: "string"
	            }
	        },
	        {
	            name: "exclude",
	            type: "list",
	            element: {
	                name: "exclude",
	                type: "string"
	            }
	        }
	    ];
	    /* @internal */
	    ts.defaultInitCompilerOptions = {
	        module: ts.ModuleKind.CommonJS,
	        target: 1 /* ES5 */,
	        strict: true,
	        esModuleInterop: true
	    };
	    var optionNameMapCache;
	    /* @internal */
	    function convertEnableAutoDiscoveryToEnable(typeAcquisition) {
	        // Convert deprecated typingOptions.enableAutoDiscovery to typeAcquisition.enable
	        if (typeAcquisition && typeAcquisition.enableAutoDiscovery !== undefined && typeAcquisition.enable === undefined) {
	            return {
	                enable: typeAcquisition.enableAutoDiscovery,
	                include: typeAcquisition.include || [],
	                exclude: typeAcquisition.exclude || []
	            };
	        }
	        return typeAcquisition;
	    }
	    ts.convertEnableAutoDiscoveryToEnable = convertEnableAutoDiscoveryToEnable;
	    function getOptionNameMap() {
	        if (optionNameMapCache) {
	            return optionNameMapCache;
	        }
	        var optionNameMap = ts.createMap();
	        var shortOptionNames = ts.createMap();
	        ts.forEach(ts.optionDeclarations, function (option) {
	            optionNameMap.set(option.name.toLowerCase(), option);
	            if (option.shortName) {
	                shortOptionNames.set(option.shortName, option.name);
	            }
	        });
	        optionNameMapCache = { optionNameMap: optionNameMap, shortOptionNames: shortOptionNames };
	        return optionNameMapCache;
	    }
	    /* @internal */
	    function createCompilerDiagnosticForInvalidCustomType(opt) {
	        return createDiagnosticForInvalidCustomType(opt, ts.createCompilerDiagnostic);
	    }
	    ts.createCompilerDiagnosticForInvalidCustomType = createCompilerDiagnosticForInvalidCustomType;
	    function createDiagnosticForInvalidCustomType(opt, createDiagnostic) {
	        var namesOfType = ts.arrayFrom(opt.type.keys()).map(function (key) { return "'" + key + "'"; }).join(", ");
	        return createDiagnostic(ts.Diagnostics.Argument_for_0_option_must_be_Colon_1, "--" + opt.name, namesOfType);
	    }
	    /* @internal */
	    function parseCustomTypeOption(opt, value, errors) {
	        return convertJsonOptionOfCustomType(opt, trimString(value || ""), errors);
	    }
	    ts.parseCustomTypeOption = parseCustomTypeOption;
	    /* @internal */
	    function parseListTypeOption(opt, value, errors) {
	        if (value === void 0) { value = ""; }
	        value = trimString(value);
	        if (ts.startsWith(value, "-")) {
	            return undefined;
	        }
	        if (value === "") {
	            return [];
	        }
	        var values = value.split(",");
	        switch (opt.element.type) {
	            case "number":
	                return ts.map(values, parseInt);
	            case "string":
	                return ts.map(values, function (v) { return v || ""; });
	            default:
	                return ts.filter(ts.map(values, function (v) { return parseCustomTypeOption(opt.element, v, errors); }), function (v) { return !!v; });
	        }
	    }
	    ts.parseListTypeOption = parseListTypeOption;
	    function parseCommandLine(commandLine, readFile) {
	        var options = {};
	        var fileNames = [];
	        var projectReferences = undefined;
	        var errors = [];
	        parseStrings(commandLine);
	        return {
	            options: options,
	            fileNames: fileNames,
	            projectReferences: projectReferences,
	            errors: errors
	        };
	        function parseStrings(args) {
	            var i = 0;
	            while (i < args.length) {
	                var s = args[i];
	                i++;
	                if (s.charCodeAt(0) === 64 /* at */) {
	                    parseResponseFile(s.slice(1));
	                }
	                else if (s.charCodeAt(0) === 45 /* minus */) {
	                    var opt = getOptionFromName(s.slice(s.charCodeAt(1) === 45 /* minus */ ? 2 : 1), /*allowShort*/ true);
	                    if (opt) {
	                        if (opt.isTSConfigOnly) {
	                            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Option_0_can_only_be_specified_in_tsconfig_json_file, opt.name));
	                        }
	                        else {
	                            // Check to see if no argument was provided (e.g. "--locale" is the last command-line argument).
	                            if (!args[i] && opt.type !== "boolean") {
	                                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_expects_an_argument, opt.name));
	                            }
	                            switch (opt.type) {
	                                case "number":
	                                    options[opt.name] = parseInt(args[i]);
	                                    i++;
	                                    break;
	                                case "boolean":
	                                    // boolean flag has optional value true, false, others
	                                    var optValue = args[i];
	                                    options[opt.name] = optValue !== "false";
	                                    // consume next argument as boolean flag value
	                                    if (optValue === "false" || optValue === "true") {
	                                        i++;
	                                    }
	                                    break;
	                                case "string":
	                                    options[opt.name] = args[i] || "";
	                                    i++;
	                                    break;
	                                case "list":
	                                    var result = parseListTypeOption(opt, args[i], errors);
	                                    options[opt.name] = result || [];
	                                    if (result) {
	                                        i++;
	                                    }
	                                    break;
	                                // If not a primitive, the possible types are specified in what is effectively a map of options.
	                                default:
	                                    options[opt.name] = parseCustomTypeOption(opt, args[i], errors);
	                                    i++;
	                                    break;
	                            }
	                        }
	                    }
	                    else {
	                        errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unknown_compiler_option_0, s));
	                    }
	                }
	                else {
	                    fileNames.push(s);
	                }
	            }
	        }
	        function parseResponseFile(fileName) {
	            var text = readFile ? readFile(fileName) : ts.sys.readFile(fileName);
	            if (!text) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.File_0_not_found, fileName));
	                return;
	            }
	            var args = [];
	            var pos = 0;
	            while (true) {
	                while (pos < text.length && text.charCodeAt(pos) <= 32 /* space */)
	                    pos++;
	                if (pos >= text.length)
	                    break;
	                var start = pos;
	                if (text.charCodeAt(start) === 34 /* doubleQuote */) {
	                    pos++;
	                    while (pos < text.length && text.charCodeAt(pos) !== 34 /* doubleQuote */)
	                        pos++;
	                    if (pos < text.length) {
	                        args.push(text.substring(start + 1, pos));
	                        pos++;
	                    }
	                    else {
	                        errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unterminated_quoted_string_in_response_file_0, fileName));
	                    }
	                }
	                else {
	                    while (text.charCodeAt(pos) > 32 /* space */)
	                        pos++;
	                    args.push(text.substring(start, pos));
	                }
	            }
	            parseStrings(args);
	        }
	    }
	    ts.parseCommandLine = parseCommandLine;
	    /** @internal */
	    function getOptionFromName(optionName, allowShort) {
	        if (allowShort === void 0) { allowShort = false; }
	        optionName = optionName.toLowerCase();
	        var _a = getOptionNameMap(), optionNameMap = _a.optionNameMap, shortOptionNames = _a.shortOptionNames;
	        // Try to translate short option names to their full equivalents.
	        if (allowShort) {
	            var short = shortOptionNames.get(optionName);
	            if (short !== undefined) {
	                optionName = short;
	            }
	        }
	        return optionNameMap.get(optionName);
	    }
	    ts.getOptionFromName = getOptionFromName;
	    /**
	     * Reads the config file, reports errors if any and exits if the config file cannot be found
	     */
	    function getParsedCommandLineOfConfigFile(configFileName, optionsToExtend, host) {
	        var configFileText;
	        try {
	            configFileText = host.readFile(configFileName);
	        }
	        catch (e) {
	            var error = ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, configFileName, e.message);
	            host.onUnRecoverableConfigFileDiagnostic(error);
	            return undefined;
	        }
	        if (!configFileText) {
	            var error = ts.createCompilerDiagnostic(ts.Diagnostics.File_0_not_found, configFileName);
	            host.onUnRecoverableConfigFileDiagnostic(error);
	            return undefined;
	        }
	        var result = ts.parseJsonText(configFileName, configFileText);
	        var cwd = host.getCurrentDirectory();
	        return parseJsonSourceFileConfigFileContent(result, host, ts.getNormalizedAbsolutePath(ts.getDirectoryPath(configFileName), cwd), optionsToExtend, ts.getNormalizedAbsolutePath(configFileName, cwd));
	    }
	    ts.getParsedCommandLineOfConfigFile = getParsedCommandLineOfConfigFile;
	    /**
	     * Read tsconfig.json file
	     * @param fileName The path to the config file
	     */
	    function readConfigFile(fileName, readFile) {
	        var textOrDiagnostic = tryReadFile(fileName, readFile);
	        return ts.isString(textOrDiagnostic) ? parseConfigFileTextToJson(fileName, textOrDiagnostic) : { config: {}, error: textOrDiagnostic };
	    }
	    ts.readConfigFile = readConfigFile;
	    /**
	     * Parse the text of the tsconfig.json file
	     * @param fileName The path to the config file
	     * @param jsonText The text of the config file
	     */
	    function parseConfigFileTextToJson(fileName, jsonText) {
	        var jsonSourceFile = ts.parseJsonText(fileName, jsonText);
	        return {
	            config: convertToObject(jsonSourceFile, jsonSourceFile.parseDiagnostics),
	            error: jsonSourceFile.parseDiagnostics.length ? jsonSourceFile.parseDiagnostics[0] : undefined
	        };
	    }
	    ts.parseConfigFileTextToJson = parseConfigFileTextToJson;
	    /**
	     * Read tsconfig.json file
	     * @param fileName The path to the config file
	     */
	    function readJsonConfigFile(fileName, readFile) {
	        var textOrDiagnostic = tryReadFile(fileName, readFile);
	        return ts.isString(textOrDiagnostic) ? ts.parseJsonText(fileName, textOrDiagnostic) : { parseDiagnostics: [textOrDiagnostic] };
	    }
	    ts.readJsonConfigFile = readJsonConfigFile;
	    function tryReadFile(fileName, readFile) {
	        var text;
	        try {
	            text = readFile(fileName);
	        }
	        catch (e) {
	            return ts.createCompilerDiagnostic(ts.Diagnostics.Cannot_read_file_0_Colon_1, fileName, e.message);
	        }
	        return text === undefined ? ts.createCompilerDiagnostic(ts.Diagnostics.The_specified_path_does_not_exist_Colon_0, fileName) : text;
	    }
	    function commandLineOptionsToMap(options) {
	        return ts.arrayToMap(options, function (option) { return option.name; });
	    }
	    var _tsconfigRootOptions;
	    function getTsconfigRootOptionsMap() {
	        if (_tsconfigRootOptions === undefined) {
	            _tsconfigRootOptions = {
	                name: undefined,
	                type: "object",
	                elementOptions: commandLineOptionsToMap([
	                    {
	                        name: "compilerOptions",
	                        type: "object",
	                        elementOptions: commandLineOptionsToMap(ts.optionDeclarations),
	                        extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_compiler_option_0
	                    },
	                    {
	                        name: "typingOptions",
	                        type: "object",
	                        elementOptions: commandLineOptionsToMap(ts.typeAcquisitionDeclarations),
	                        extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_type_acquisition_option_0
	                    },
	                    {
	                        name: "typeAcquisition",
	                        type: "object",
	                        elementOptions: commandLineOptionsToMap(ts.typeAcquisitionDeclarations),
	                        extraKeyDiagnosticMessage: ts.Diagnostics.Unknown_type_acquisition_option_0
	                    },
	                    {
	                        name: "extends",
	                        type: "string"
	                    },
	                    {
	                        name: "references",
	                        type: "list",
	                        element: {
	                            name: "references",
	                            type: "object"
	                        }
	                    },
	                    {
	                        name: "files",
	                        type: "list",
	                        element: {
	                            name: "files",
	                            type: "string"
	                        }
	                    },
	                    {
	                        name: "include",
	                        type: "list",
	                        element: {
	                            name: "include",
	                            type: "string"
	                        }
	                    },
	                    {
	                        name: "exclude",
	                        type: "list",
	                        element: {
	                            name: "exclude",
	                            type: "string"
	                        }
	                    },
	                    ts.compileOnSaveCommandLineOption
	                ])
	            };
	        }
	        return _tsconfigRootOptions;
	    }
	    /**
	     * Convert the json syntax tree into the json value
	     */
	    function convertToObject(sourceFile, errors) {
	        return convertToObjectWorker(sourceFile, errors, /*returnValue*/ true, /*knownRootOptions*/ undefined, /*jsonConversionNotifier*/ undefined);
	    }
	    ts.convertToObject = convertToObject;
	    /**
	     * Convert the json syntax tree into the json value and report errors
	     * This returns the json value (apart from checking errors) only if returnValue provided is true.
	     * Otherwise it just checks the errors and returns undefined
	     */
	    /*@internal*/
	    function convertToObjectWorker(sourceFile, errors, returnValue, knownRootOptions, jsonConversionNotifier) {
	        if (!sourceFile.statements.length) {
	            return returnValue ? {} : undefined;
	        }
	        return convertPropertyValueToJson(sourceFile.statements[0].expression, knownRootOptions);
	        function isRootOptionMap(knownOptions) {
	            return knownRootOptions && knownRootOptions.elementOptions === knownOptions;
	        }
	        function convertObjectLiteralExpressionToJson(node, knownOptions, extraKeyDiagnosticMessage, parentOption) {
	            var result = returnValue ? {} : undefined;
	            for (var _i = 0, _a = node.properties; _i < _a.length; _i++) {
	                var element = _a[_i];
	                if (element.kind !== 269 /* PropertyAssignment */) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element, ts.Diagnostics.Property_assignment_expected));
	                    continue;
	                }
	                if (element.questionToken) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.questionToken, ts.Diagnostics._0_can_only_be_used_in_a_ts_file, "?"));
	                }
	                if (!isDoubleQuotedString(element.name)) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.name, ts.Diagnostics.String_literal_with_double_quotes_expected));
	                }
	                var keyText = ts.unescapeLeadingUnderscores(ts.getTextOfPropertyName(element.name));
	                var option = knownOptions ? knownOptions.get(keyText) : undefined;
	                if (extraKeyDiagnosticMessage && !option) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, element.name, extraKeyDiagnosticMessage, keyText));
	                }
	                var value = convertPropertyValueToJson(element.initializer, option);
	                if (typeof keyText !== "undefined") {
	                    if (returnValue) {
	                        result[keyText] = value;
	                    }
	                    // Notify key value set, if user asked for it
	                    if (jsonConversionNotifier &&
	                        // Current callbacks are only on known parent option or if we are setting values in the root
	                        (parentOption || isRootOptionMap(knownOptions))) {
	                        var isValidOptionValue = isCompilerOptionsValue(option, value);
	                        if (parentOption) {
	                            if (isValidOptionValue) {
	                                // Notify option set in the parent if its a valid option value
	                                jsonConversionNotifier.onSetValidOptionKeyValueInParent(parentOption, option, value);
	                            }
	                        }
	                        else if (isRootOptionMap(knownOptions)) {
	                            if (isValidOptionValue) {
	                                // Notify about the valid root key value being set
	                                jsonConversionNotifier.onSetValidOptionKeyValueInRoot(keyText, element.name, value, element.initializer);
	                            }
	                            else if (!option) {
	                                // Notify about the unknown root key value being set
	                                jsonConversionNotifier.onSetUnknownOptionKeyValueInRoot(keyText, element.name, value, element.initializer);
	                            }
	                        }
	                    }
	                }
	            }
	            return result;
	        }
	        function convertArrayLiteralExpressionToJson(elements, elementOption) {
	            return (returnValue ? elements.map : elements.forEach).call(elements, function (element) { return convertPropertyValueToJson(element, elementOption); });
	        }
	        function convertPropertyValueToJson(valueExpression, option) {
	            switch (valueExpression.kind) {
	                case 101 /* TrueKeyword */:
	                    reportInvalidOptionValue(option && option.type !== "boolean");
	                    return true;
	                case 86 /* FalseKeyword */:
	                    reportInvalidOptionValue(option && option.type !== "boolean");
	                    return false;
	                case 95 /* NullKeyword */:
	                    reportInvalidOptionValue(option && option.name === "extends"); // "extends" is the only option we don't allow null/undefined for
	                    return null; // tslint:disable-line:no-null-keyword
	                case 9 /* StringLiteral */:
	                    if (!isDoubleQuotedString(valueExpression)) {
	                        errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.String_literal_with_double_quotes_expected));
	                    }
	                    reportInvalidOptionValue(option && (ts.isString(option.type) && option.type !== "string"));
	                    var text = valueExpression.text;
	                    if (option && !ts.isString(option.type)) {
	                        var customOption = option;
	                        // Validate custom option type
	                        if (!customOption.type.has(text.toLowerCase())) {
	                            errors.push(createDiagnosticForInvalidCustomType(customOption, function (message, arg0, arg1) { return ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, message, arg0, arg1); }));
	                        }
	                    }
	                    return text;
	                case 8 /* NumericLiteral */:
	                    reportInvalidOptionValue(option && option.type !== "number");
	                    return Number(valueExpression.text);
	                case 197 /* PrefixUnaryExpression */:
	                    if (valueExpression.operator !== 38 /* MinusToken */ || valueExpression.operand.kind !== 8 /* NumericLiteral */) {
	                        break; // not valid JSON syntax
	                    }
	                    reportInvalidOptionValue(option && option.type !== "number");
	                    return -Number(valueExpression.operand.text);
	                case 183 /* ObjectLiteralExpression */:
	                    reportInvalidOptionValue(option && option.type !== "object");
	                    var objectLiteralExpression = valueExpression;
	                    // Currently having element option declaration in the tsconfig with type "object"
	                    // determines if it needs onSetValidOptionKeyValueInParent callback or not
	                    // At moment there are only "compilerOptions", "typeAcquisition" and "typingOptions"
	                    // that satifies it and need it to modify options set in them (for normalizing file paths)
	                    // vs what we set in the json
	                    // If need arises, we can modify this interface and callbacks as needed
	                    if (option) {
	                        var _a = option, elementOptions = _a.elementOptions, extraKeyDiagnosticMessage = _a.extraKeyDiagnosticMessage, optionName = _a.name;
	                        return convertObjectLiteralExpressionToJson(objectLiteralExpression, elementOptions, extraKeyDiagnosticMessage, optionName);
	                    }
	                    else {
	                        return convertObjectLiteralExpressionToJson(objectLiteralExpression, /* knownOptions*/ undefined, 
	                        /*extraKeyDiagnosticMessage */ undefined, /*parentOption*/ undefined);
	                    }
	                case 182 /* ArrayLiteralExpression */:
	                    reportInvalidOptionValue(option && option.type !== "list");
	                    return convertArrayLiteralExpressionToJson(valueExpression.elements, option && option.element);
	            }
	            // Not in expected format
	            if (option) {
	                reportInvalidOptionValue(/*isError*/ true);
	            }
	            else {
	                errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.Property_value_can_only_be_string_literal_numeric_literal_true_false_null_object_literal_or_array_literal));
	            }
	            return undefined;
	            function reportInvalidOptionValue(isError) {
	                if (isError) {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueExpression, ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, option.name, getCompilerOptionValueTypeString(option)));
	                }
	            }
	        }
	        function isDoubleQuotedString(node) {
	            return ts.isStringLiteral(node) && ts.isStringDoubleQuoted(node, sourceFile);
	        }
	    }
	    ts.convertToObjectWorker = convertToObjectWorker;
	    function getCompilerOptionValueTypeString(option) {
	        return option.type === "list" ?
	            "Array" :
	            ts.isString(option.type) ? option.type : "string";
	    }
	    function isCompilerOptionsValue(option, value) {
	        if (option) {
	            if (isNullOrUndefined(value))
	                return true; // All options are undefinable/nullable
	            if (option.type === "list") {
	                return ts.isArray(value);
	            }
	            var expectedType = ts.isString(option.type) ? option.type : "string";
	            return typeof value === expectedType;
	        }
	    }
	    /**
	     * Generate tsconfig configuration when running command line "--init"
	     * @param options commandlineOptions to be generated into tsconfig.json
	     * @param fileNames array of filenames to be generated into tsconfig.json
	     */
	    /* @internal */
	    function generateTSConfig(options, fileNames, newLine) {
	        var compilerOptions = ts.extend(options, ts.defaultInitCompilerOptions);
	        var compilerOptionsMap = serializeCompilerOptions(compilerOptions);
	        return writeConfigurations();
	        function getCustomTypeMapOfCommandLineOption(optionDefinition) {
	            if (optionDefinition.type === "string" || optionDefinition.type === "number" || optionDefinition.type === "boolean") {
	                // this is of a type CommandLineOptionOfPrimitiveType
	                return undefined;
	            }
	            else if (optionDefinition.type === "list") {
	                return getCustomTypeMapOfCommandLineOption(optionDefinition.element);
	            }
	            else {
	                return optionDefinition.type;
	            }
	        }
	        function getNameOfCompilerOptionValue(value, customTypeMap) {
	            // There is a typeMap associated with this command-line option so use it to map value back to its name
	            return ts.forEachEntry(customTypeMap, function (mapValue, key) {
	                if (mapValue === value) {
	                    return key;
	                }
	            });
	        }
	        function serializeCompilerOptions(options) {
	            var result = ts.createMap();
	            var optionsNameMap = getOptionNameMap().optionNameMap;
	            var _loop_11 = function (name) {
	                if (ts.hasProperty(options, name)) {
	                    // tsconfig only options cannot be specified via command line,
	                    // so we can assume that only types that can appear here string | number | boolean
	                    if (optionsNameMap.has(name) && optionsNameMap.get(name).category === ts.Diagnostics.Command_line_Options) {
	                        return "continue";
	                    }
	                    var value = options[name];
	                    var optionDefinition = optionsNameMap.get(name.toLowerCase());
	                    if (optionDefinition) {
	                        var customTypeMap_1 = getCustomTypeMapOfCommandLineOption(optionDefinition);
	                        if (!customTypeMap_1) {
	                            // There is no map associated with this compiler option then use the value as-is
	                            // This is the case if the value is expect to be string, number, boolean or list of string
	                            result.set(name, value);
	                        }
	                        else {
	                            if (optionDefinition.type === "list") {
	                                result.set(name, value.map(function (element) { return getNameOfCompilerOptionValue(element, customTypeMap_1); }));
	                            }
	                            else {
	                                // There is a typeMap associated with this command-line option so use it to map value back to its name
	                                result.set(name, getNameOfCompilerOptionValue(value, customTypeMap_1));
	                            }
	                        }
	                    }
	                }
	            };
	            for (var name in options) {
	                _loop_11(name);
	            }
	            return result;
	        }
	        function getDefaultValueForOption(option) {
	            switch (option.type) {
	                case "number":
	                    return 1;
	                case "boolean":
	                    return true;
	                case "string":
	                    return option.isFilePath ? "./" : "";
	                case "list":
	                    return [];
	                case "object":
	                    return {};
	                default:
	                    return option.type.keys().next().value;
	            }
	        }
	        function makePadding(paddingLength) {
	            return Array(paddingLength + 1).join(" ");
	        }
	        function isAllowedOption(_a) {
	            var category = _a.category, name = _a.name;
	            // Skip options which do not have a category or have category `Command_line_Options`
	            // Exclude all possible `Advanced_Options` in tsconfig.json which were NOT defined in command line
	            return category !== undefined
	                && category !== ts.Diagnostics.Command_line_Options
	                && (category !== ts.Diagnostics.Advanced_Options || compilerOptionsMap.has(name));
	        }
	        function writeConfigurations() {
	            // Filter applicable options to place in the file
	            var categorizedOptions = ts.createMultiMap();
	            for (var _i = 0, optionDeclarations_1 = ts.optionDeclarations; _i < optionDeclarations_1.length; _i++) {
	                var option = optionDeclarations_1[_i];
	                var category = option.category;
	                if (isAllowedOption(option)) {
	                    categorizedOptions.add(ts.getLocaleSpecificMessage(category), option);
	                }
	            }
	            // Serialize all options and their descriptions
	            var marginLength = 0;
	            var seenKnownKeys = 0;
	            var nameColumn = [];
	            var descriptionColumn = [];
	            categorizedOptions.forEach(function (options, category) {
	                if (nameColumn.length !== 0) {
	                    nameColumn.push("");
	                    descriptionColumn.push("");
	                }
	                nameColumn.push("/* " + category + " */");
	                descriptionColumn.push("");
	                for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
	                    var option = options_1[_i];
	                    var optionName = void 0;
	                    if (compilerOptionsMap.has(option.name)) {
	                        optionName = "\"" + option.name + "\": " + JSON.stringify(compilerOptionsMap.get(option.name)) + ((seenKnownKeys += 1) === compilerOptionsMap.size ? "" : ",");
	                    }
	                    else {
	                        optionName = "// \"" + option.name + "\": " + JSON.stringify(getDefaultValueForOption(option)) + ",";
	                    }
	                    nameColumn.push(optionName);
	                    descriptionColumn.push("/* " + (option.description && ts.getLocaleSpecificMessage(option.description) || option.name) + " */");
	                    marginLength = Math.max(optionName.length, marginLength);
	                }
	            });
	            // Write the output
	            var tab = makePadding(2);
	            var result = [];
	            result.push("{");
	            result.push(tab + "\"compilerOptions\": {");
	            // Print out each row, aligning all the descriptions on the same column.
	            for (var i = 0; i < nameColumn.length; i++) {
	                var optionName = nameColumn[i];
	                var description = descriptionColumn[i];
	                result.push(optionName && "" + tab + tab + optionName + (description && (makePadding(marginLength - optionName.length + 2) + description)));
	            }
	            if (fileNames.length) {
	                result.push(tab + "},");
	                result.push(tab + "\"files\": [");
	                for (var i = 0; i < fileNames.length; i++) {
	                    result.push("" + tab + tab + JSON.stringify(fileNames[i]) + (i === fileNames.length - 1 ? "" : ","));
	                }
	                result.push(tab + "]");
	            }
	            else {
	                result.push(tab + "}");
	            }
	            result.push("}");
	            return result.join(newLine);
	        }
	    }
	    ts.generateTSConfig = generateTSConfig;
	    /**
	     * Parse the contents of a config file (tsconfig.json).
	     * @param json The contents of the config file to parse
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     */
	    function parseJsonConfigFileContent(json, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        return parseJsonConfigFileContentWorker(json, /*sourceFile*/ undefined, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions);
	    }
	    ts.parseJsonConfigFileContent = parseJsonConfigFileContent;
	    /**
	     * Parse the contents of a config file (tsconfig.json).
	     * @param jsonNode The contents of the config file to parse
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     */
	    function parseJsonSourceFileConfigFileContent(sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        return parseJsonConfigFileContentWorker(/*json*/ undefined, sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions);
	    }
	    ts.parseJsonSourceFileConfigFileContent = parseJsonSourceFileConfigFileContent;
	    /*@internal*/
	    function setConfigFileInOptions(options, configFile) {
	        if (configFile) {
	            Object.defineProperty(options, "configFile", { enumerable: false, writable: false, value: configFile });
	        }
	    }
	    ts.setConfigFileInOptions = setConfigFileInOptions;
	    function isNullOrUndefined(x) {
	        // tslint:disable-next-line:no-null-keyword
	        return x === undefined || x === null;
	    }
	    function directoryOfCombinedPath(fileName, basePath) {
	        // Use the `getNormalizedAbsolutePath` function to avoid canonicalizing the path, as it must remain noncanonical
	        // until consistient casing errors are reported
	        return ts.getDirectoryPath(ts.getNormalizedAbsolutePath(fileName, basePath));
	    }
	    /**
	     * Parse the contents of a config file from json or json source file (tsconfig.json).
	     * @param json The contents of the config file to parse
	     * @param sourceFile sourceFile corresponding to the Json
	     * @param host Instance of ParseConfigHost used to enumerate files in folder.
	     * @param basePath A root directory to resolve relative path entries in the config
	     *    file to. e.g. outDir
	     * @param resolutionStack Only present for backwards-compatibility. Should be empty.
	     */
	    function parseJsonConfigFileContentWorker(json, sourceFile, host, basePath, existingOptions, configFileName, resolutionStack, extraFileExtensions) {
	        if (existingOptions === void 0) { existingOptions = {}; }
	        if (resolutionStack === void 0) { resolutionStack = []; }
	        if (extraFileExtensions === void 0) { extraFileExtensions = []; }
	        ts.Debug.assert((json === undefined && sourceFile !== undefined) || (json !== undefined && sourceFile === undefined));
	        var errors = [];
	        var parsedConfig = parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors);
	        var raw = parsedConfig.raw;
	        var options = ts.extend(existingOptions, parsedConfig.options || {});
	        options.configFilePath = configFileName && ts.normalizeSlashes(configFileName);
	        setConfigFileInOptions(options, sourceFile);
	        var _a = getFileNames(), fileNames = _a.fileNames, wildcardDirectories = _a.wildcardDirectories, spec = _a.spec, projectReferences = _a.projectReferences;
	        return {
	            options: options,
	            fileNames: fileNames,
	            projectReferences: projectReferences,
	            typeAcquisition: parsedConfig.typeAcquisition || getDefaultTypeAcquisition(),
	            raw: raw,
	            errors: errors,
	            wildcardDirectories: wildcardDirectories,
	            compileOnSave: !!raw.compileOnSave,
	            configFileSpecs: spec
	        };
	        function getFileNames() {
	            var filesSpecs;
	            if (ts.hasProperty(raw, "files") && !isNullOrUndefined(raw.files)) {
	                if (ts.isArray(raw.files)) {
	                    filesSpecs = raw.files;
	                    if (filesSpecs.length === 0) {
	                        createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json");
	                    }
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "files", "Array");
	                }
	            }
	            var includeSpecs;
	            if (ts.hasProperty(raw, "include") && !isNullOrUndefined(raw.include)) {
	                if (ts.isArray(raw.include)) {
	                    includeSpecs = raw.include;
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "include", "Array");
	                }
	            }
	            var excludeSpecs;
	            if (ts.hasProperty(raw, "exclude") && !isNullOrUndefined(raw.exclude)) {
	                if (ts.isArray(raw.exclude)) {
	                    excludeSpecs = raw.exclude;
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "exclude", "Array");
	                }
	            }
	            else if (raw.compilerOptions) {
	                var outDir = raw.compilerOptions.outDir;
	                var declarationDir = raw.compilerOptions.declarationDir;
	                if (outDir || declarationDir) {
	                    excludeSpecs = [outDir, declarationDir].filter(function (d) { return !!d; });
	                }
	            }
	            if (filesSpecs === undefined && includeSpecs === undefined) {
	                includeSpecs = ["**/*"];
	            }
	            var result = matchFileNames(filesSpecs, includeSpecs, excludeSpecs, configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath, options, host, errors, extraFileExtensions, sourceFile);
	            if (result.fileNames.length === 0 && !ts.hasProperty(raw, "files") && resolutionStack.length === 0 && !ts.hasProperty(raw, "references")) {
	                errors.push(getErrorForNoInputFiles(result.spec, configFileName));
	            }
	            if (ts.hasProperty(raw, "references") && !isNullOrUndefined(raw.references)) {
	                if (ts.isArray(raw.references)) {
	                    var references = [];
	                    for (var _i = 0, _a = raw.references; _i < _a.length; _i++) {
	                        var ref = _a[_i];
	                        if (typeof ref.path !== "string") {
	                            createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "reference.path", "string");
	                        }
	                        else {
	                            references.push({
	                                path: ts.getNormalizedAbsolutePath(ref.path, basePath),
	                                originalPath: ref.path,
	                                prepend: ref.prepend,
	                                circular: ref.circular
	                            });
	                        }
	                    }
	                    result.projectReferences = references;
	                }
	                else {
	                    createCompilerDiagnosticOnlyIfJson(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "references", "Array");
	                }
	            }
	            return result;
	        }
	        function createCompilerDiagnosticOnlyIfJson(message, arg0, arg1) {
	            if (!sourceFile) {
	                errors.push(ts.createCompilerDiagnostic(message, arg0, arg1));
	            }
	        }
	    }
	    /*@internal*/
	    function isErrorNoInputFiles(error) {
	        return error.code === ts.Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2.code;
	    }
	    ts.isErrorNoInputFiles = isErrorNoInputFiles;
	    /*@internal*/
	    function getErrorForNoInputFiles(_a, configFileName) {
	        var includeSpecs = _a.includeSpecs, excludeSpecs = _a.excludeSpecs;
	        return ts.createCompilerDiagnostic(ts.Diagnostics.No_inputs_were_found_in_config_file_0_Specified_include_paths_were_1_and_exclude_paths_were_2, configFileName || "tsconfig.json", JSON.stringify(includeSpecs || []), JSON.stringify(excludeSpecs || []));
	    }
	    ts.getErrorForNoInputFiles = getErrorForNoInputFiles;
	    function isSuccessfulParsedTsconfig(value) {
	        return !!value.options;
	    }
	    /**
	     * This *just* extracts options/include/exclude/files out of a config file.
	     * It does *not* resolve the included files.
	     */
	    function parseConfig(json, sourceFile, host, basePath, configFileName, resolutionStack, errors) {
	        basePath = ts.normalizeSlashes(basePath);
	        var resolvedPath = ts.getNormalizedAbsolutePath(configFileName || "", basePath);
	        if (resolutionStack.indexOf(resolvedPath) >= 0) {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Circularity_detected_while_resolving_configuration_Colon_0, resolutionStack.concat([resolvedPath]).join(" -> ")));
	            return { raw: json || convertToObject(sourceFile, errors) };
	        }
	        var ownConfig = json ?
	            parseOwnConfigOfJson(json, host, basePath, configFileName, errors) :
	            parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors);
	        if (ownConfig.extendedConfigPath) {
	            // copy the resolution stack so it is never reused between branches in potential diamond-problem scenarios.
	            resolutionStack = resolutionStack.concat([resolvedPath]);
	            var extendedConfig = getExtendedConfig(sourceFile, ownConfig.extendedConfigPath, host, basePath, resolutionStack, errors);
	            if (extendedConfig && isSuccessfulParsedTsconfig(extendedConfig)) {
	                var baseRaw_1 = extendedConfig.raw;
	                var raw_1 = ownConfig.raw;
	                var setPropertyInRawIfNotUndefined = function (propertyName) {
	                    var value = raw_1[propertyName] || baseRaw_1[propertyName];
	                    if (value) {
	                        raw_1[propertyName] = value;
	                    }
	                };
	                setPropertyInRawIfNotUndefined("include");
	                setPropertyInRawIfNotUndefined("exclude");
	                setPropertyInRawIfNotUndefined("files");
	                if (raw_1.compileOnSave === undefined) {
	                    raw_1.compileOnSave = baseRaw_1.compileOnSave;
	                }
	                ownConfig.options = ts.assign({}, extendedConfig.options, ownConfig.options);
	                // TODO extend type typeAcquisition
	            }
	        }
	        return ownConfig;
	    }
	    function parseOwnConfigOfJson(json, host, basePath, configFileName, errors) {
	        if (ts.hasProperty(json, "excludes")) {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
	        }
	        var options = convertCompilerOptionsFromJsonWorker(json.compilerOptions, basePath, errors, configFileName);
	        // typingOptions has been deprecated and is only supported for backward compatibility purposes.
	        // It should be removed in future releases - use typeAcquisition instead.
	        var typeAcquisition = convertTypeAcquisitionFromJsonWorker(json.typeAcquisition || json.typingOptions, basePath, errors, configFileName);
	        json.compileOnSave = convertCompileOnSaveOptionFromJson(json, basePath, errors);
	        var extendedConfigPath;
	        if (json.extends) {
	            if (!ts.isString(json.extends)) {
	                errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, "extends", "string"));
	            }
	            else {
	                var newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
	                extendedConfigPath = getExtendsConfigPath(json.extends, host, newBase, errors, ts.createCompilerDiagnostic);
	            }
	        }
	        return { raw: json, options: options, typeAcquisition: typeAcquisition, extendedConfigPath: extendedConfigPath };
	    }
	    function parseOwnConfigOfJsonSourceFile(sourceFile, host, basePath, configFileName, errors) {
	        var options = getDefaultCompilerOptions(configFileName);
	        var typeAcquisition, typingOptionstypeAcquisition;
	        var extendedConfigPath;
	        var optionsIterator = {
	            onSetValidOptionKeyValueInParent: function (parentOption, option, value) {
	                ts.Debug.assert(parentOption === "compilerOptions" || parentOption === "typeAcquisition" || parentOption === "typingOptions");
	                var currentOption = parentOption === "compilerOptions" ?
	                    options :
	                    parentOption === "typeAcquisition" ?
	                        (typeAcquisition || (typeAcquisition = getDefaultTypeAcquisition(configFileName))) :
	                        (typingOptionstypeAcquisition || (typingOptionstypeAcquisition = getDefaultTypeAcquisition(configFileName)));
	                currentOption[option.name] = normalizeOptionValue(option, basePath, value);
	            },
	            onSetValidOptionKeyValueInRoot: function (key, _keyNode, value, valueNode) {
	                switch (key) {
	                    case "extends":
	                        var newBase = configFileName ? directoryOfCombinedPath(configFileName, basePath) : basePath;
	                        extendedConfigPath = getExtendsConfigPath(value, host, newBase, errors, function (message, arg0) {
	                            return ts.createDiagnosticForNodeInSourceFile(sourceFile, valueNode, message, arg0);
	                        });
	                        return;
	                    case "files":
	                        if (value.length === 0) {
	                            errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, valueNode, ts.Diagnostics.The_files_list_in_config_file_0_is_empty, configFileName || "tsconfig.json"));
	                        }
	                        return;
	                }
	            },
	            onSetUnknownOptionKeyValueInRoot: function (key, keyNode, _value, _valueNode) {
	                if (key === "excludes") {
	                    errors.push(ts.createDiagnosticForNodeInSourceFile(sourceFile, keyNode, ts.Diagnostics.Unknown_option_excludes_Did_you_mean_exclude));
	                }
	            }
	        };
	        var json = convertToObjectWorker(sourceFile, errors, /*returnValue*/ true, getTsconfigRootOptionsMap(), optionsIterator);
	        if (!typeAcquisition) {
	            if (typingOptionstypeAcquisition) {
	                typeAcquisition = (typingOptionstypeAcquisition.enableAutoDiscovery !== undefined) ?
	                    {
	                        enable: typingOptionstypeAcquisition.enableAutoDiscovery,
	                        include: typingOptionstypeAcquisition.include,
	                        exclude: typingOptionstypeAcquisition.exclude
	                    } :
	                    typingOptionstypeAcquisition;
	            }
	            else {
	                typeAcquisition = getDefaultTypeAcquisition(configFileName);
	            }
	        }
	        return { raw: json, options: options, typeAcquisition: typeAcquisition, extendedConfigPath: extendedConfigPath };
	    }
	    function getExtendsConfigPath(extendedConfig, host, basePath, errors, createDiagnostic) {
	        extendedConfig = ts.normalizeSlashes(extendedConfig);
	        // If the path isn't a rooted or relative path, don't try to resolve it (we reserve the right to special case module-id like paths in the future)
	        if (!(ts.isRootedDiskPath(extendedConfig) || ts.startsWith(extendedConfig, "./") || ts.startsWith(extendedConfig, "../"))) {
	            errors.push(createDiagnostic(ts.Diagnostics.A_path_in_an_extends_option_must_be_relative_or_rooted_but_0_is_not, extendedConfig));
	            return undefined;
	        }
	        var extendedConfigPath = ts.getNormalizedAbsolutePath(extendedConfig, basePath);
	        if (!host.fileExists(extendedConfigPath) && !ts.endsWith(extendedConfigPath, ".json" /* Json */)) {
	            extendedConfigPath = extendedConfigPath + ".json";
	            if (!host.fileExists(extendedConfigPath)) {
	                errors.push(createDiagnostic(ts.Diagnostics.File_0_does_not_exist, extendedConfig));
	                return undefined;
	            }
	        }
	        return extendedConfigPath;
	    }
	    function getExtendedConfig(sourceFile, extendedConfigPath, host, basePath, resolutionStack, errors) {
	        var _a;
	        var extendedResult = readJsonConfigFile(extendedConfigPath, function (path) { return host.readFile(path); });
	        if (sourceFile) {
	            (sourceFile.extendedSourceFiles || (sourceFile.extendedSourceFiles = [])).push(extendedResult.fileName);
	        }
	        if (extendedResult.parseDiagnostics.length) {
	            errors.push.apply(errors, extendedResult.parseDiagnostics);
	            return undefined;
	        }
	        var extendedDirname = ts.getDirectoryPath(extendedConfigPath);
	        var extendedConfig = parseConfig(/*json*/ undefined, extendedResult, host, extendedDirname, ts.getBaseFileName(extendedConfigPath), resolutionStack, errors);
	        if (sourceFile) {
	            (_a = sourceFile.extendedSourceFiles).push.apply(_a, extendedResult.extendedSourceFiles);
	        }
	        if (isSuccessfulParsedTsconfig(extendedConfig)) {
	            // Update the paths to reflect base path
	            var relativeDifference_1 = ts.convertToRelativePath(extendedDirname, basePath, ts.identity);
	            var updatePath_1 = function (path) { return ts.isRootedDiskPath(path) ? path : ts.combinePaths(relativeDifference_1, path); };
	            var mapPropertiesInRawIfNotUndefined = function (propertyName) {
	                if (raw_2[propertyName]) {
	                    raw_2[propertyName] = ts.map(raw_2[propertyName], updatePath_1);
	                }
	            };
	            var raw_2 = extendedConfig.raw;
	            mapPropertiesInRawIfNotUndefined("include");
	            mapPropertiesInRawIfNotUndefined("exclude");
	            mapPropertiesInRawIfNotUndefined("files");
	        }
	        return extendedConfig;
	    }
	    function convertCompileOnSaveOptionFromJson(jsonOption, basePath, errors) {
	        if (!ts.hasProperty(jsonOption, ts.compileOnSaveCommandLineOption.name)) {
	            return undefined;
	        }
	        var result = convertJsonOption(ts.compileOnSaveCommandLineOption, jsonOption.compileOnSave, basePath, errors);
	        if (typeof result === "boolean" && result) {
	            return result;
	        }
	        return false;
	    }
	    function convertCompilerOptionsFromJson(jsonOptions, basePath, configFileName) {
	        var errors = [];
	        var options = convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName);
	        return { options: options, errors: errors };
	    }
	    ts.convertCompilerOptionsFromJson = convertCompilerOptionsFromJson;
	    function convertTypeAcquisitionFromJson(jsonOptions, basePath, configFileName) {
	        var errors = [];
	        var options = convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName);
	        return { options: options, errors: errors };
	    }
	    ts.convertTypeAcquisitionFromJson = convertTypeAcquisitionFromJson;
	    function getDefaultCompilerOptions(configFileName) {
	        var options = configFileName && ts.getBaseFileName(configFileName) === "jsconfig.json"
	            ? { allowJs: true, maxNodeModuleJsDepth: 2, allowSyntheticDefaultImports: true, skipLibCheck: true, noEmit: true }
	            : {};
	        return options;
	    }
	    function convertCompilerOptionsFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
	        var options = getDefaultCompilerOptions(configFileName);
	        convertOptionsFromJson(ts.optionDeclarations, jsonOptions, basePath, options, ts.Diagnostics.Unknown_compiler_option_0, errors);
	        if (configFileName) {
	            options.configFilePath = ts.normalizeSlashes(configFileName);
	        }
	        return options;
	    }
	    function getDefaultTypeAcquisition(configFileName) {
	        return { enable: configFileName && ts.getBaseFileName(configFileName) === "jsconfig.json", include: [], exclude: [] };
	    }
	    function convertTypeAcquisitionFromJsonWorker(jsonOptions, basePath, errors, configFileName) {
	        var options = getDefaultTypeAcquisition(configFileName);
	        var typeAcquisition = convertEnableAutoDiscoveryToEnable(jsonOptions);
	        convertOptionsFromJson(ts.typeAcquisitionDeclarations, typeAcquisition, basePath, options, ts.Diagnostics.Unknown_type_acquisition_option_0, errors);
	        return options;
	    }
	    function convertOptionsFromJson(optionDeclarations, jsonOptions, basePath, defaultOptions, diagnosticMessage, errors) {
	        if (!jsonOptions) {
	            return;
	        }
	        var optionNameMap = commandLineOptionsToMap(optionDeclarations);
	        for (var id in jsonOptions) {
	            var opt = optionNameMap.get(id);
	            if (opt) {
	                defaultOptions[opt.name] = convertJsonOption(opt, jsonOptions[id], basePath, errors);
	            }
	            else {
	                errors.push(ts.createCompilerDiagnostic(diagnosticMessage, id));
	            }
	        }
	    }
	    function convertJsonOption(opt, value, basePath, errors) {
	        if (isCompilerOptionsValue(opt, value)) {
	            var optType = opt.type;
	            if (optType === "list" && ts.isArray(value)) {
	                return convertJsonOptionOfListType(opt, value, basePath, errors);
	            }
	            else if (!ts.isString(optType)) {
	                return convertJsonOptionOfCustomType(opt, value, errors);
	            }
	            return normalizeNonListOptionValue(opt, basePath, value);
	        }
	        else {
	            errors.push(ts.createCompilerDiagnostic(ts.Diagnostics.Compiler_option_0_requires_a_value_of_type_1, opt.name, getCompilerOptionValueTypeString(opt)));
	        }
	    }
	    function normalizeOptionValue(option, basePath, value) {
	        if (isNullOrUndefined(value))
	            return undefined;
	        if (option.type === "list") {
	            var listOption_1 = option;
	            if (listOption_1.element.isFilePath || !ts.isString(listOption_1.element.type)) {
	                return ts.filter(ts.map(value, function (v) { return normalizeOptionValue(listOption_1.element, basePath, v); }), function (v) { return !!v; });
	            }
	            return value;
	        }
	        else if (!ts.isString(option.type)) {
	            return option.type.get(ts.isString(value) ? value.toLowerCase() : value);
	        }
	        return normalizeNonListOptionValue(option, basePath, value);
	    }
	    function normalizeNonListOptionValue(option, basePath, value) {
	        if (option.isFilePath) {
	            value = ts.normalizePath(ts.combinePaths(basePath, value));
	            if (value === "") {
	                value = ".";
	            }
	        }
	        return value;
	    }
	    function convertJsonOptionOfCustomType(opt, value, errors) {
	        if (isNullOrUndefined(value))
	            return undefined;
	        var key = value.toLowerCase();
	        var val = opt.type.get(key);
	        if (val !== undefined) {
	            return val;
	        }
	        else {
	            errors.push(createCompilerDiagnosticForInvalidCustomType(opt));
	        }
	    }
	    function convertJsonOptionOfListType(option, values, basePath, errors) {
	        return ts.filter(ts.map(values, function (v) { return convertJsonOption(option.element, v, basePath, errors); }), function (v) { return !!v; });
	    }
	    function trimString(s) {
	        return typeof s.trim === "function" ? s.trim() : s.replace(/^[\s]+|[\s]+$/g, "");
	    }
	    /**
	     * Tests for a path that ends in a recursive directory wildcard.
	     * Matches **, \**, **\, and \**\, but not a**b.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  (^|\/)      # matches either the beginning of the string or a directory separator.
	     *  \*\*        # matches the recursive directory wildcard "**".
	     *  \/?$        # matches an optional trailing directory separator at the end of the string.
	     */
	    var invalidTrailingRecursionPattern = /(^|\/)\*\*\/?$/;
	    /**
	     * Tests for a path where .. appears after a recursive directory wildcard.
	     * Matches **\..\*, **\a\..\*, and **\.., but not ..\**\*
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  (^|\/)      # matches either the beginning of the string or a directory separator.
	     *  \*\*\/      # matches a recursive directory wildcard "**" followed by a directory separator.
	     *  (.*\/)?     # optionally matches any number of characters followed by a directory separator.
	     *  \.\.        # matches a parent directory path component ".."
	     *  ($|\/)      # matches either the end of the string or a directory separator.
	     */
	    var invalidDotDotAfterRecursiveWildcardPattern = /(^|\/)\*\*\/(.*\/)?\.\.($|\/)/;
	    /**
	     * Tests for a path containing a wildcard character in a directory component of the path.
	     * Matches \*\, \?\, and \a*b\, but not \a\ or \a\*.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  \/          # matches a directory separator.
	     *  [^/]*?      # matches any number of characters excluding directory separators (non-greedy).
	     *  [*?]        # matches either a wildcard character (* or ?)
	     *  [^/]*       # matches any number of characters excluding directory separators (greedy).
	     *  \/          # matches a directory separator.
	     */
	    var watchRecursivePattern = /\/[^/]*?[*?][^/]*\//;
	    /**
	     * Matches the portion of a wildcard path that does not contain wildcards.
	     * Matches \a of \a\*, or \a\b\c of \a\b\c\?\d.
	     *
	     * NOTE: used \ in place of / above to avoid issues with multiline comments.
	     *
	     * Breakdown:
	     *  ^                   # matches the beginning of the string
	     *  [^*?]*              # matches any number of non-wildcard characters
	     *  (?=\/[^/]*[*?])     # lookahead that matches a directory separator followed by
	     *                      # a path component that contains at least one wildcard character (* or ?).
	     */
	    var wildcardDirectoryPattern = /^[^*?]*(?=\/[^/]*[*?])/;
	    /**
	     * Expands an array of file specifications.
	     *
	     * @param filesSpecs The literal file names to include.
	     * @param includeSpecs The wildcard file specifications to include.
	     * @param excludeSpecs The wildcard file specifications to exclude.
	     * @param basePath The base path for any relative file specifications.
	     * @param options Compiler options.
	     * @param host The host used to resolve files and directories.
	     * @param errors An array for diagnostic reporting.
	     */
	    function matchFileNames(filesSpecs, includeSpecs, excludeSpecs, basePath, options, host, errors, extraFileExtensions, jsonSourceFile) {
	        basePath = ts.normalizePath(basePath);
	        var validatedIncludeSpecs, validatedExcludeSpecs;
	        // The exclude spec list is converted into a regular expression, which allows us to quickly
	        // test whether a file or directory should be excluded before recursively traversing the
	        // file system.
	        if (includeSpecs) {
	            validatedIncludeSpecs = validateSpecs(includeSpecs, errors, /*allowTrailingRecursion*/ false, jsonSourceFile, "include");
	        }
	        if (excludeSpecs) {
	            validatedExcludeSpecs = validateSpecs(excludeSpecs, errors, /*allowTrailingRecursion*/ true, jsonSourceFile, "exclude");
	        }
	        // Wildcard directories (provided as part of a wildcard path) are stored in a
	        // file map that marks whether it was a regular wildcard match (with a `*` or `?` token),
	        // or a recursive directory. This information is used by filesystem watchers to monitor for
	        // new entries in these paths.
	        var wildcardDirectories = getWildcardDirectories(validatedIncludeSpecs, validatedExcludeSpecs, basePath, host.useCaseSensitiveFileNames);
	        var spec = { filesSpecs: filesSpecs, referencesSpecs: undefined, includeSpecs: includeSpecs, excludeSpecs: excludeSpecs, validatedIncludeSpecs: validatedIncludeSpecs, validatedExcludeSpecs: validatedExcludeSpecs, wildcardDirectories: wildcardDirectories };
	        return getFileNamesFromConfigSpecs(spec, basePath, options, host, extraFileExtensions);
	    }
	    /**
	     * Gets the file names from the provided config file specs that contain, files, include, exclude and
	     * other properties needed to resolve the file names
	     * @param spec The config file specs extracted with file names to include, wildcards to include/exclude and other details
	     * @param basePath The base path for any relative file specifications.
	     * @param options Compiler options.
	     * @param host The host used to resolve files and directories.
	     * @param extraFileExtensions optionaly file extra file extension information from host
	     */
	    /* @internal */
	    function getFileNamesFromConfigSpecs(spec, basePath, options, host, extraFileExtensions) {
	        if (extraFileExtensions === void 0) { extraFileExtensions = []; }
	        basePath = ts.normalizePath(basePath);
	        var keyMapper = host.useCaseSensitiveFileNames ? ts.identity : ts.toLowerCase;
	        // Literal file names (provided via the "files" array in tsconfig.json) are stored in a
	        // file map with a possibly case insensitive key. We use this map later when when including
	        // wildcard paths.
	        var literalFileMap = ts.createMap();
	        // Wildcard paths (provided via the "includes" array in tsconfig.json) are stored in a
	        // file map with a possibly case insensitive key. We use this map to store paths matched
	        // via wildcard, and to handle extension priority.
	        var wildcardFileMap = ts.createMap();
	        var filesSpecs = spec.filesSpecs, validatedIncludeSpecs = spec.validatedIncludeSpecs, validatedExcludeSpecs = spec.validatedExcludeSpecs, wildcardDirectories = spec.wildcardDirectories;
	        // Rather than requery this for each file and filespec, we query the supported extensions
	        // once and store it on the expansion context.
	        var supportedExtensions = ts.getSupportedExtensions(options, extraFileExtensions);
	        // Literal files are always included verbatim. An "include" or "exclude" specification cannot
	        // remove a literal file.
	        if (filesSpecs) {
	            for (var _i = 0, filesSpecs_1 = filesSpecs; _i < filesSpecs_1.length; _i++) {
	                var fileName = filesSpecs_1[_i];
	                var file_13 = ts.getNormalizedAbsolutePath(fileName, basePath);
	                literalFileMap.set(keyMapper(file_13), file_13);
	            }
	        }
	        if (validatedIncludeSpecs && validatedIncludeSpecs.length > 0) {
	            for (var _a = 0, _b = host.readDirectory(basePath, supportedExtensions, validatedExcludeSpecs, validatedIncludeSpecs, /*depth*/ undefined); _a < _b.length; _a++) {
	                var file_14 = _b[_a];
	                // If we have already included a literal or wildcard path with a
	                // higher priority extension, we should skip this file.
	                //
	                // This handles cases where we may encounter both <file>.ts and
	                // <file>.d.ts (or <file>.js if "allowJs" is enabled) in the same
	                // directory when they are compilation outputs.
	                if (hasFileWithHigherPriorityExtension(file_14, literalFileMap, wildcardFileMap, supportedExtensions, keyMapper)) {
	                    continue;
	                }
	                // We may have included a wildcard path with a lower priority
	                // extension due to the user-defined order of entries in the
	                // "include" array. If there is a lower priority extension in the
	                // same directory, we should remove it.
	                removeWildcardFilesWithLowerPriorityExtension(file_14, wildcardFileMap, supportedExtensions, keyMapper);
	                var key = keyMapper(file_14);
	                if (!literalFileMap.has(key) && !wildcardFileMap.has(key)) {
	                    wildcardFileMap.set(key, file_14);
	                }
	            }
	        }
	        var literalFiles = ts.arrayFrom(literalFileMap.values());
	        var wildcardFiles = ts.arrayFrom(wildcardFileMap.values());
	        var projectReferences = spec.referencesSpecs && spec.referencesSpecs.map(function (r) {
	            return __assign({}, r, { path: ts.getNormalizedAbsolutePath(r.path, basePath) });
	        });
	        return {
	            fileNames: literalFiles.concat(wildcardFiles),
	            projectReferences: projectReferences,
	            wildcardDirectories: wildcardDirectories,
	            spec: spec
	        };
	    }
	    ts.getFileNamesFromConfigSpecs = getFileNamesFromConfigSpecs;
	    function validateSpecs(specs, errors, allowTrailingRecursion, jsonSourceFile, specKey) {
	        return specs.filter(function (spec) {
	            var diag = specToDiagnostic(spec, allowTrailingRecursion);
	            if (diag !== undefined) {
	                errors.push(createDiagnostic(diag, spec));
	            }
	            return diag === undefined;
	        });
	        function createDiagnostic(message, spec) {
	            var element = ts.getTsConfigPropArrayElementValue(jsonSourceFile, specKey, spec);
	            return element ?
	                ts.createDiagnosticForNodeInSourceFile(jsonSourceFile, element, message, spec) :
	                ts.createCompilerDiagnostic(message, spec);
	        }
	    }
	    function specToDiagnostic(spec, allowTrailingRecursion) {
	        if (!allowTrailingRecursion && invalidTrailingRecursionPattern.test(spec)) {
	            return ts.Diagnostics.File_specification_cannot_end_in_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0;
	        }
	        else if (invalidDotDotAfterRecursiveWildcardPattern.test(spec)) {
	            return ts.Diagnostics.File_specification_cannot_contain_a_parent_directory_that_appears_after_a_recursive_directory_wildcard_Asterisk_Asterisk_Colon_0;
	        }
	    }
	    /**
	     * Gets directories in a set of include patterns that should be watched for changes.
	     */
	    function getWildcardDirectories(include, exclude, path, useCaseSensitiveFileNames) {
	        // We watch a directory recursively if it contains a wildcard anywhere in a directory segment
	        // of the pattern:
	        //
	        //  /a/b/**/d   - Watch /a/b recursively to catch changes to any d in any subfolder recursively
	        //  /a/b/*/d    - Watch /a/b recursively to catch any d in any immediate subfolder, even if a new subfolder is added
	        //  /a/b        - Watch /a/b recursively to catch changes to anything in any recursive subfoler
	        //
	        // We watch a directory without recursion if it contains a wildcard in the file segment of
	        // the pattern:
	        //
	        //  /a/b/*      - Watch /a/b directly to catch any new file
	        //  /a/b/a?z    - Watch /a/b directly to catch any new file matching a?z
	        var rawExcludeRegex = ts.getRegularExpressionForWildcard(exclude, path, "exclude");
	        var excludeRegex = rawExcludeRegex && new RegExp(rawExcludeRegex, useCaseSensitiveFileNames ? "" : "i");
	        var wildcardDirectories = {};
	        if (include !== undefined) {
	            var recursiveKeys = [];
	            for (var _i = 0, include_1 = include; _i < include_1.length; _i++) {
	                var file_15 = include_1[_i];
	                var spec = ts.normalizePath(ts.combinePaths(path, file_15));
	                if (excludeRegex && excludeRegex.test(spec)) {
	                    continue;
	                }
	                var match = getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames);
	                if (match) {
	                    var key = match.key, flags = match.flags;
	                    var existingFlags = wildcardDirectories[key];
	                    if (existingFlags === undefined || existingFlags < flags) {
	                        wildcardDirectories[key] = flags;
	                        if (flags === 1 /* Recursive */) {
	                            recursiveKeys.push(key);
	                        }
	                    }
	                }
	            }
	            // Remove any subpaths under an existing recursively watched directory.
	            for (var key in wildcardDirectories) {
	                if (ts.hasProperty(wildcardDirectories, key)) {
	                    for (var _a = 0, recursiveKeys_1 = recursiveKeys; _a < recursiveKeys_1.length; _a++) {
	                        var recursiveKey = recursiveKeys_1[_a];
	                        if (key !== recursiveKey && ts.containsPath(recursiveKey, key, path, !useCaseSensitiveFileNames)) {
	                            delete wildcardDirectories[key];
	                        }
	                    }
	                }
	            }
	        }
	        return wildcardDirectories;
	    }
	    function getWildcardDirectoryFromSpec(spec, useCaseSensitiveFileNames) {
	        var match = wildcardDirectoryPattern.exec(spec);
	        if (match) {
	            return {
	                key: useCaseSensitiveFileNames ? match[0] : match[0].toLowerCase(),
	                flags: watchRecursivePattern.test(spec) ? 1 /* Recursive */ : 0 /* None */
	            };
	        }
	        if (ts.isImplicitGlob(spec)) {
	            return { key: spec, flags: 1 /* Recursive */ };
	        }
	        return undefined;
	    }
	    /**
	     * Determines whether a literal or wildcard file has already been included that has a higher
	     * extension priority.
	     *
	     * @param file The path to the file.
	     * @param extensionPriority The priority of the extension.
	     * @param context The expansion context.
	     */
	    function hasFileWithHigherPriorityExtension(file, literalFiles, wildcardFiles, extensions, keyMapper) {
	        var extensionPriority = ts.getExtensionPriority(file, extensions);
	        var adjustedExtensionPriority = ts.adjustExtensionPriority(extensionPriority, extensions);
	        for (var i = 0 /* Highest */; i < adjustedExtensionPriority; i++) {
	            var higherPriorityExtension = extensions[i];
	            var higherPriorityPath = keyMapper(ts.changeExtension(file, higherPriorityExtension));
	            if (literalFiles.has(higherPriorityPath) || wildcardFiles.has(higherPriorityPath)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * Removes files included via wildcard expansion with a lower extension priority that have
	     * already been included.
	     *
	     * @param file The path to the file.
	     * @param extensionPriority The priority of the extension.
	     * @param context The expansion context.
	     */
	    function removeWildcardFilesWithLowerPriorityExtension(file, wildcardFiles, extensions, keyMapper) {
	        var extensionPriority = ts.getExtensionPriority(file, extensions);
	        var nextExtensionPriority = ts.getNextLowestExtensionPriority(extensionPriority, extensions);
	        for (var i = nextExtensionPriority; i < extensions.length; i++) {
	            var lowerPriorityExtension = extensions[i];
	            var lowerPriorityPath = keyMapper(ts.changeExtension(file, lowerPriorityExtension));
	            wildcardFiles.delete(lowerPriorityPath);
	        }
	    }
	    /**
	     * Produces a cleaned version of compiler options with personally identifiying info (aka, paths) removed.
	     * Also converts enum values back to strings.
	     */
	    /* @internal */
	    function convertCompilerOptionsForTelemetry(opts) {
	        var out = {};
	        for (var key in opts) {
	            if (opts.hasOwnProperty(key)) {
	                var type = getOptionFromName(key);
	                if (type !== undefined) { // Ignore unknown options
	                    out[key] = getOptionValueWithEmptyStrings(opts[key], type);
	                }
	            }
	        }
	        return out;
	    }
	    ts.convertCompilerOptionsForTelemetry = convertCompilerOptionsForTelemetry;
	    function getOptionValueWithEmptyStrings(value, option) {
	        switch (option.type) {
	            case "object": // "paths". Can't get any useful information from the value since we blank out strings, so just return "".
	                return "";
	            case "string": // Could be any arbitrary string -- use empty string instead.
	                return "";
	            case "number": // Allow numbers, but be sure to check it's actually a number.
	                return typeof value === "number" ? value : "";
	            case "boolean":
	                return typeof value === "boolean" ? value : "";
	            case "list":
	                var elementType_1 = option.element;
	                return ts.isArray(value) ? value.map(function (v) { return getOptionValueWithEmptyStrings(v, elementType_1); }) : "";
	            default:
	                return ts.forEachEntry(option.type, function (optionEnumValue, optionStringValue) {
	                    if (optionEnumValue === value) {
	                        return optionStringValue;
	                    }
	                });
	        }
	    }
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    var ScriptSnapshot;
	    (function (ScriptSnapshot) {
	        var StringScriptSnapshot = /** @class */ (function () {
	            function StringScriptSnapshot(text) {
	                this.text = text;
	            }
	            StringScriptSnapshot.prototype.getText = function (start, end) {
	                return start === 0 && end === this.text.length
	                    ? this.text
	                    : this.text.substring(start, end);
	            };
	            StringScriptSnapshot.prototype.getLength = function () {
	                return this.text.length;
	            };
	            StringScriptSnapshot.prototype.getChangeRange = function () {
	                // Text-based snapshots do not support incremental parsing. Return undefined
	                // to signal that to the caller.
	                return undefined;
	            };
	            return StringScriptSnapshot;
	        }());
	        function fromString(text) {
	            return new StringScriptSnapshot(text);
	        }
	        ScriptSnapshot.fromString = fromString;
	    })(ScriptSnapshot = ts.ScriptSnapshot || (ts.ScriptSnapshot = {}));
	    /* @internal */
	    ts.defaultPreferences = {};
	    var TextChange = /** @class */ (function () {
	        function TextChange() {
	        }
	        return TextChange;
	    }());
	    ts.TextChange = TextChange;
	    var HighlightSpanKind;
	    (function (HighlightSpanKind) {
	        HighlightSpanKind["none"] = "none";
	        HighlightSpanKind["definition"] = "definition";
	        HighlightSpanKind["reference"] = "reference";
	        HighlightSpanKind["writtenReference"] = "writtenReference";
	    })(HighlightSpanKind = ts.HighlightSpanKind || (ts.HighlightSpanKind = {}));
	    var IndentStyle;
	    (function (IndentStyle) {
	        IndentStyle[IndentStyle["None"] = 0] = "None";
	        IndentStyle[IndentStyle["Block"] = 1] = "Block";
	        IndentStyle[IndentStyle["Smart"] = 2] = "Smart";
	    })(IndentStyle = ts.IndentStyle || (ts.IndentStyle = {}));
	    var SymbolDisplayPartKind;
	    (function (SymbolDisplayPartKind) {
	        SymbolDisplayPartKind[SymbolDisplayPartKind["aliasName"] = 0] = "aliasName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["className"] = 1] = "className";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["enumName"] = 2] = "enumName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["fieldName"] = 3] = "fieldName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["interfaceName"] = 4] = "interfaceName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["keyword"] = 5] = "keyword";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["lineBreak"] = 6] = "lineBreak";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["numericLiteral"] = 7] = "numericLiteral";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["stringLiteral"] = 8] = "stringLiteral";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["localName"] = 9] = "localName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["methodName"] = 10] = "methodName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["moduleName"] = 11] = "moduleName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["operator"] = 12] = "operator";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["parameterName"] = 13] = "parameterName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["propertyName"] = 14] = "propertyName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["punctuation"] = 15] = "punctuation";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["space"] = 16] = "space";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["text"] = 17] = "text";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["typeParameterName"] = 18] = "typeParameterName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["enumMemberName"] = 19] = "enumMemberName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["functionName"] = 20] = "functionName";
	        SymbolDisplayPartKind[SymbolDisplayPartKind["regularExpressionLiteral"] = 21] = "regularExpressionLiteral";
	    })(SymbolDisplayPartKind = ts.SymbolDisplayPartKind || (ts.SymbolDisplayPartKind = {}));
	    var OutliningSpanKind;
	    (function (OutliningSpanKind) {
	        /** Single or multi-line comments */
	        OutliningSpanKind["Comment"] = "comment";
	        /** Sections marked by '// #region' and '// #endregion' comments */
	        OutliningSpanKind["Region"] = "region";
	        /** Declarations and expressions */
	        OutliningSpanKind["Code"] = "code";
	        /** Contiguous blocks of import declarations */
	        OutliningSpanKind["Imports"] = "imports";
	    })(OutliningSpanKind = ts.OutliningSpanKind || (ts.OutliningSpanKind = {}));
	    var OutputFileType;
	    (function (OutputFileType) {
	        OutputFileType[OutputFileType["JavaScript"] = 0] = "JavaScript";
	        OutputFileType[OutputFileType["SourceMap"] = 1] = "SourceMap";
	        OutputFileType[OutputFileType["Declaration"] = 2] = "Declaration";
	    })(OutputFileType = ts.OutputFileType || (ts.OutputFileType = {}));
	    var EndOfLineState;
	    (function (EndOfLineState) {
	        EndOfLineState[EndOfLineState["None"] = 0] = "None";
	        EndOfLineState[EndOfLineState["InMultiLineCommentTrivia"] = 1] = "InMultiLineCommentTrivia";
	        EndOfLineState[EndOfLineState["InSingleQuoteStringLiteral"] = 2] = "InSingleQuoteStringLiteral";
	        EndOfLineState[EndOfLineState["InDoubleQuoteStringLiteral"] = 3] = "InDoubleQuoteStringLiteral";
	        EndOfLineState[EndOfLineState["InTemplateHeadOrNoSubstitutionTemplate"] = 4] = "InTemplateHeadOrNoSubstitutionTemplate";
	        EndOfLineState[EndOfLineState["InTemplateMiddleOrTail"] = 5] = "InTemplateMiddleOrTail";
	        EndOfLineState[EndOfLineState["InTemplateSubstitutionPosition"] = 6] = "InTemplateSubstitutionPosition";
	    })(EndOfLineState = ts.EndOfLineState || (ts.EndOfLineState = {}));
	    var TokenClass;
	    (function (TokenClass) {
	        TokenClass[TokenClass["Punctuation"] = 0] = "Punctuation";
	        TokenClass[TokenClass["Keyword"] = 1] = "Keyword";
	        TokenClass[TokenClass["Operator"] = 2] = "Operator";
	        TokenClass[TokenClass["Comment"] = 3] = "Comment";
	        TokenClass[TokenClass["Whitespace"] = 4] = "Whitespace";
	        TokenClass[TokenClass["Identifier"] = 5] = "Identifier";
	        TokenClass[TokenClass["NumberLiteral"] = 6] = "NumberLiteral";
	        TokenClass[TokenClass["StringLiteral"] = 7] = "StringLiteral";
	        TokenClass[TokenClass["RegExpLiteral"] = 8] = "RegExpLiteral";
	    })(TokenClass = ts.TokenClass || (ts.TokenClass = {}));
	    var ScriptElementKind;
	    (function (ScriptElementKind) {
	        ScriptElementKind["unknown"] = "";
	        ScriptElementKind["warning"] = "warning";
	        /** predefined type (void) or keyword (class) */
	        ScriptElementKind["keyword"] = "keyword";
	        /** top level script node */
	        ScriptElementKind["scriptElement"] = "script";
	        /** module foo {} */
	        ScriptElementKind["moduleElement"] = "module";
	        /** class X {} */
	        ScriptElementKind["classElement"] = "class";
	        /** var x = class X {} */
	        ScriptElementKind["localClassElement"] = "local class";
	        /** interface Y {} */
	        ScriptElementKind["interfaceElement"] = "interface";
	        /** type T = ... */
	        ScriptElementKind["typeElement"] = "type";
	        /** enum E */
	        ScriptElementKind["enumElement"] = "enum";
	        ScriptElementKind["enumMemberElement"] = "enum member";
	        /**
	         * Inside module and script only
	         * const v = ..
	         */
	        ScriptElementKind["variableElement"] = "var";
	        /** Inside function */
	        ScriptElementKind["localVariableElement"] = "local var";
	        /**
	         * Inside module and script only
	         * function f() { }
	         */
	        ScriptElementKind["functionElement"] = "function";
	        /** Inside function */
	        ScriptElementKind["localFunctionElement"] = "local function";
	        /** class X { [public|private]* foo() {} } */
	        ScriptElementKind["memberFunctionElement"] = "method";
	        /** class X { [public|private]* [get|set] foo:number; } */
	        ScriptElementKind["memberGetAccessorElement"] = "getter";
	        ScriptElementKind["memberSetAccessorElement"] = "setter";
	        /**
	         * class X { [public|private]* foo:number; }
	         * interface Y { foo:number; }
	         */
	        ScriptElementKind["memberVariableElement"] = "property";
	        /** class X { constructor() { } } */
	        ScriptElementKind["constructorImplementationElement"] = "constructor";
	        /** interface Y { ():number; } */
	        ScriptElementKind["callSignatureElement"] = "call";
	        /** interface Y { []:number; } */
	        ScriptElementKind["indexSignatureElement"] = "index";
	        /** interface Y { new():Y; } */
	        ScriptElementKind["constructSignatureElement"] = "construct";
	        /** function foo(*Y*: string) */
	        ScriptElementKind["parameterElement"] = "parameter";
	        ScriptElementKind["typeParameterElement"] = "type parameter";
	        ScriptElementKind["primitiveType"] = "primitive type";
	        ScriptElementKind["label"] = "label";
	        ScriptElementKind["alias"] = "alias";
	        ScriptElementKind["constElement"] = "const";
	        ScriptElementKind["letElement"] = "let";
	        ScriptElementKind["directory"] = "directory";
	        ScriptElementKind["externalModuleName"] = "external module name";
	        /**
	         * <JsxTagName attribute1 attribute2={0} />
	         */
	        ScriptElementKind["jsxAttribute"] = "JSX attribute";
	        /** String literal */
	        ScriptElementKind["string"] = "string";
	    })(ScriptElementKind = ts.ScriptElementKind || (ts.ScriptElementKind = {}));
	    var ScriptElementKindModifier;
	    (function (ScriptElementKindModifier) {
	        ScriptElementKindModifier["none"] = "";
	        ScriptElementKindModifier["publicMemberModifier"] = "public";
	        ScriptElementKindModifier["privateMemberModifier"] = "private";
	        ScriptElementKindModifier["protectedMemberModifier"] = "protected";
	        ScriptElementKindModifier["exportedModifier"] = "export";
	        ScriptElementKindModifier["ambientModifier"] = "declare";
	        ScriptElementKindModifier["staticModifier"] = "static";
	        ScriptElementKindModifier["abstractModifier"] = "abstract";
	        ScriptElementKindModifier["optionalModifier"] = "optional";
	    })(ScriptElementKindModifier = ts.ScriptElementKindModifier || (ts.ScriptElementKindModifier = {}));
	    var ClassificationTypeNames;
	    (function (ClassificationTypeNames) {
	        ClassificationTypeNames["comment"] = "comment";
	        ClassificationTypeNames["identifier"] = "identifier";
	        ClassificationTypeNames["keyword"] = "keyword";
	        ClassificationTypeNames["numericLiteral"] = "number";
	        ClassificationTypeNames["operator"] = "operator";
	        ClassificationTypeNames["stringLiteral"] = "string";
	        ClassificationTypeNames["whiteSpace"] = "whitespace";
	        ClassificationTypeNames["text"] = "text";
	        ClassificationTypeNames["punctuation"] = "punctuation";
	        ClassificationTypeNames["className"] = "class name";
	        ClassificationTypeNames["enumName"] = "enum name";
	        ClassificationTypeNames["interfaceName"] = "interface name";
	        ClassificationTypeNames["moduleName"] = "module name";
	        ClassificationTypeNames["typeParameterName"] = "type parameter name";
	        ClassificationTypeNames["typeAliasName"] = "type alias name";
	        ClassificationTypeNames["parameterName"] = "parameter name";
	        ClassificationTypeNames["docCommentTagName"] = "doc comment tag name";
	        ClassificationTypeNames["jsxOpenTagName"] = "jsx open tag name";
	        ClassificationTypeNames["jsxCloseTagName"] = "jsx close tag name";
	        ClassificationTypeNames["jsxSelfClosingTagName"] = "jsx self closing tag name";
	        ClassificationTypeNames["jsxAttribute"] = "jsx attribute";
	        ClassificationTypeNames["jsxText"] = "jsx text";
	        ClassificationTypeNames["jsxAttributeStringLiteralValue"] = "jsx attribute string literal value";
	    })(ClassificationTypeNames = ts.ClassificationTypeNames || (ts.ClassificationTypeNames = {}));
	    var ClassificationType;
	    (function (ClassificationType) {
	        ClassificationType[ClassificationType["comment"] = 1] = "comment";
	        ClassificationType[ClassificationType["identifier"] = 2] = "identifier";
	        ClassificationType[ClassificationType["keyword"] = 3] = "keyword";
	        ClassificationType[ClassificationType["numericLiteral"] = 4] = "numericLiteral";
	        ClassificationType[ClassificationType["operator"] = 5] = "operator";
	        ClassificationType[ClassificationType["stringLiteral"] = 6] = "stringLiteral";
	        ClassificationType[ClassificationType["regularExpressionLiteral"] = 7] = "regularExpressionLiteral";
	        ClassificationType[ClassificationType["whiteSpace"] = 8] = "whiteSpace";
	        ClassificationType[ClassificationType["text"] = 9] = "text";
	        ClassificationType[ClassificationType["punctuation"] = 10] = "punctuation";
	        ClassificationType[ClassificationType["className"] = 11] = "className";
	        ClassificationType[ClassificationType["enumName"] = 12] = "enumName";
	        ClassificationType[ClassificationType["interfaceName"] = 13] = "interfaceName";
	        ClassificationType[ClassificationType["moduleName"] = 14] = "moduleName";
	        ClassificationType[ClassificationType["typeParameterName"] = 15] = "typeParameterName";
	        ClassificationType[ClassificationType["typeAliasName"] = 16] = "typeAliasName";
	        ClassificationType[ClassificationType["parameterName"] = 17] = "parameterName";
	        ClassificationType[ClassificationType["docCommentTagName"] = 18] = "docCommentTagName";
	        ClassificationType[ClassificationType["jsxOpenTagName"] = 19] = "jsxOpenTagName";
	        ClassificationType[ClassificationType["jsxCloseTagName"] = 20] = "jsxCloseTagName";
	        ClassificationType[ClassificationType["jsxSelfClosingTagName"] = 21] = "jsxSelfClosingTagName";
	        ClassificationType[ClassificationType["jsxAttribute"] = 22] = "jsxAttribute";
	        ClassificationType[ClassificationType["jsxText"] = 23] = "jsxText";
	        ClassificationType[ClassificationType["jsxAttributeStringLiteralValue"] = 24] = "jsxAttributeStringLiteralValue";
	    })(ClassificationType = ts.ClassificationType || (ts.ClassificationType = {}));
	})(ts || (ts = {}));
	// These utilities are common to multiple language service features.
	/* @internal */
	var ts;
	(function (ts) {
	    ts.scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ true);
	    var SemanticMeaning;
	    (function (SemanticMeaning) {
	        SemanticMeaning[SemanticMeaning["None"] = 0] = "None";
	        SemanticMeaning[SemanticMeaning["Value"] = 1] = "Value";
	        SemanticMeaning[SemanticMeaning["Type"] = 2] = "Type";
	        SemanticMeaning[SemanticMeaning["Namespace"] = 4] = "Namespace";
	        SemanticMeaning[SemanticMeaning["All"] = 7] = "All";
	    })(SemanticMeaning = ts.SemanticMeaning || (ts.SemanticMeaning = {}));
	    function getMeaningFromDeclaration(node) {
	        switch (node.kind) {
	            case 148 /* Parameter */:
	            case 231 /* VariableDeclaration */:
	            case 181 /* BindingElement */:
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 269 /* PropertyAssignment */:
	            case 270 /* ShorthandPropertyAssignment */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 192 /* ArrowFunction */:
	            case 268 /* CatchClause */:
	            case 261 /* JsxAttribute */:
	                return 1 /* Value */;
	            case 147 /* TypeParameter */:
	            case 235 /* InterfaceDeclaration */:
	            case 236 /* TypeAliasDeclaration */:
	            case 165 /* TypeLiteral */:
	                return 2 /* Type */;
	            case 296 /* JSDocTypedefTag */:
	                // If it has no name node, it shares the name with the value declaration below it.
	                return node.name === undefined ? 1 /* Value */ | 2 /* Type */ : 2 /* Type */;
	            case 272 /* EnumMember */:
	            case 234 /* ClassDeclaration */:
	                return 1 /* Value */ | 2 /* Type */;
	            case 238 /* ModuleDeclaration */:
	                if (ts.isAmbientModule(node)) {
	                    return 4 /* Namespace */ | 1 /* Value */;
	                }
	                else if (ts.getModuleInstanceState(node) === 1 /* Instantiated */) {
	                    return 4 /* Namespace */ | 1 /* Value */;
	                }
	                else {
	                    return 4 /* Namespace */;
	                }
	            case 237 /* EnumDeclaration */:
	            case 246 /* NamedImports */:
	            case 247 /* ImportSpecifier */:
	            case 242 /* ImportEqualsDeclaration */:
	            case 243 /* ImportDeclaration */:
	            case 248 /* ExportAssignment */:
	            case 249 /* ExportDeclaration */:
	                return 7 /* All */;
	            // An external module can be a Value
	            case 273 /* SourceFile */:
	                return 4 /* Namespace */ | 1 /* Value */;
	        }
	        return 7 /* All */;
	    }
	    ts.getMeaningFromDeclaration = getMeaningFromDeclaration;
	    function getMeaningFromLocation(node) {
	        if (node.kind === 273 /* SourceFile */) {
	            return 1 /* Value */;
	        }
	        else if (node.parent.kind === 248 /* ExportAssignment */) {
	            return 7 /* All */;
	        }
	        else if (isInRightSideOfInternalImportEqualsDeclaration(node)) {
	            return getMeaningFromRightHandSideOfImportEquals(node);
	        }
	        else if (ts.isDeclarationName(node)) {
	            return getMeaningFromDeclaration(node.parent);
	        }
	        else if (isTypeReference(node)) {
	            return 2 /* Type */;
	        }
	        else if (isNamespaceReference(node)) {
	            return 4 /* Namespace */;
	        }
	        else if (ts.isTypeParameterDeclaration(node.parent)) {
	            ts.Debug.assert(ts.isJSDocTemplateTag(node.parent.parent)); // Else would be handled by isDeclarationName
	            return 2 /* Type */;
	        }
	        else if (ts.isLiteralTypeNode(node.parent)) {
	            // This might be T["name"], which is actually referencing a property and not a type. So allow both meanings.
	            return 2 /* Type */ | 1 /* Value */;
	        }
	        else {
	            return 1 /* Value */;
	        }
	    }
	    ts.getMeaningFromLocation = getMeaningFromLocation;
	    function getMeaningFromRightHandSideOfImportEquals(node) {
	        //     import a = |b|; // Namespace
	        //     import a = |b.c|; // Value, type, namespace
	        //     import a = |b.c|.d; // Namespace
	        var name = node.kind === 145 /* QualifiedName */ ? node : ts.isQualifiedName(node.parent) && node.parent.right === node ? node.parent : undefined;
	        return name && name.parent.kind === 242 /* ImportEqualsDeclaration */ ? 7 /* All */ : 4 /* Namespace */;
	    }
	    function isInRightSideOfInternalImportEqualsDeclaration(node) {
	        while (node.parent.kind === 145 /* QualifiedName */) {
	            node = node.parent;
	        }
	        return ts.isInternalModuleImportEqualsDeclaration(node.parent) && node.parent.moduleReference === node;
	    }
	    ts.isInRightSideOfInternalImportEqualsDeclaration = isInRightSideOfInternalImportEqualsDeclaration;
	    function isNamespaceReference(node) {
	        return isQualifiedNameNamespaceReference(node) || isPropertyAccessNamespaceReference(node);
	    }
	    function isQualifiedNameNamespaceReference(node) {
	        var root = node;
	        var isLastClause = true;
	        if (root.parent.kind === 145 /* QualifiedName */) {
	            while (root.parent && root.parent.kind === 145 /* QualifiedName */) {
	                root = root.parent;
	            }
	            isLastClause = root.right === node;
	        }
	        return root.parent.kind === 161 /* TypeReference */ && !isLastClause;
	    }
	    function isPropertyAccessNamespaceReference(node) {
	        var root = node;
	        var isLastClause = true;
	        if (root.parent.kind === 184 /* PropertyAccessExpression */) {
	            while (root.parent && root.parent.kind === 184 /* PropertyAccessExpression */) {
	                root = root.parent;
	            }
	            isLastClause = root.name === node;
	        }
	        if (!isLastClause && root.parent.kind === 206 /* ExpressionWithTypeArguments */ && root.parent.parent.kind === 267 /* HeritageClause */) {
	            var decl = root.parent.parent.parent;
	            return (decl.kind === 234 /* ClassDeclaration */ && root.parent.parent.token === 108 /* ImplementsKeyword */) ||
	                (decl.kind === 235 /* InterfaceDeclaration */ && root.parent.parent.token === 85 /* ExtendsKeyword */);
	        }
	        return false;
	    }
	    function isTypeReference(node) {
	        if (ts.isRightSideOfQualifiedNameOrPropertyAccess(node)) {
	            node = node.parent;
	        }
	        switch (node.kind) {
	            case 99 /* ThisKeyword */:
	                return !ts.isExpressionNode(node);
	            case 173 /* ThisType */:
	                return true;
	        }
	        switch (node.parent.kind) {
	            case 161 /* TypeReference */:
	                return true;
	            case 178 /* ImportType */:
	                return !node.parent.isTypeOf;
	            case 206 /* ExpressionWithTypeArguments */:
	                return !ts.isExpressionWithTypeArgumentsInClassExtendsClause(node.parent);
	        }
	        return false;
	    }
	    function isCallExpressionTarget(node) {
	        return isCallOrNewExpressionTarget(node, 186 /* CallExpression */);
	    }
	    ts.isCallExpressionTarget = isCallExpressionTarget;
	    function isNewExpressionTarget(node) {
	        return isCallOrNewExpressionTarget(node, 187 /* NewExpression */);
	    }
	    ts.isNewExpressionTarget = isNewExpressionTarget;
	    function isCallOrNewExpressionTarget(node, kind) {
	        var target = climbPastPropertyAccess(node);
	        return target && target.parent && target.parent.kind === kind && target.parent.expression === target;
	    }
	    function climbPastPropertyAccess(node) {
	        return isRightSideOfPropertyAccess(node) ? node.parent : node;
	    }
	    ts.climbPastPropertyAccess = climbPastPropertyAccess;
	    function getTargetLabel(referenceNode, labelName) {
	        while (referenceNode) {
	            if (referenceNode.kind === 227 /* LabeledStatement */ && referenceNode.label.escapedText === labelName) {
	                return referenceNode.label;
	            }
	            referenceNode = referenceNode.parent;
	        }
	        return undefined;
	    }
	    ts.getTargetLabel = getTargetLabel;
	    function isJumpStatementTarget(node) {
	        return node.kind === 71 /* Identifier */ && ts.isBreakOrContinueStatement(node.parent) && node.parent.label === node;
	    }
	    ts.isJumpStatementTarget = isJumpStatementTarget;
	    function isLabelOfLabeledStatement(node) {
	        return node.kind === 71 /* Identifier */ && ts.isLabeledStatement(node.parent) && node.parent.label === node;
	    }
	    ts.isLabelOfLabeledStatement = isLabelOfLabeledStatement;
	    function isLabelName(node) {
	        return isLabelOfLabeledStatement(node) || isJumpStatementTarget(node);
	    }
	    ts.isLabelName = isLabelName;
	    function isRightSideOfQualifiedName(node) {
	        return node.parent.kind === 145 /* QualifiedName */ && node.parent.right === node;
	    }
	    ts.isRightSideOfQualifiedName = isRightSideOfQualifiedName;
	    function isRightSideOfPropertyAccess(node) {
	        return node && node.parent && node.parent.kind === 184 /* PropertyAccessExpression */ && node.parent.name === node;
	    }
	    ts.isRightSideOfPropertyAccess = isRightSideOfPropertyAccess;
	    function isNameOfModuleDeclaration(node) {
	        return node.parent.kind === 238 /* ModuleDeclaration */ && node.parent.name === node;
	    }
	    ts.isNameOfModuleDeclaration = isNameOfModuleDeclaration;
	    function isNameOfFunctionDeclaration(node) {
	        return node.kind === 71 /* Identifier */ &&
	            ts.isFunctionLike(node.parent) && node.parent.name === node;
	    }
	    ts.isNameOfFunctionDeclaration = isNameOfFunctionDeclaration;
	    function isLiteralNameOfPropertyDeclarationOrIndexAccess(node) {
	        switch (node.parent.kind) {
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	            case 269 /* PropertyAssignment */:
	            case 272 /* EnumMember */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 238 /* ModuleDeclaration */:
	                return ts.getNameOfDeclaration(node.parent) === node;
	            case 185 /* ElementAccessExpression */:
	                return node.parent.argumentExpression === node;
	            case 146 /* ComputedPropertyName */:
	                return true;
	            case 177 /* LiteralType */:
	                return node.parent.parent.kind === 175 /* IndexedAccessType */;
	        }
	    }
	    ts.isLiteralNameOfPropertyDeclarationOrIndexAccess = isLiteralNameOfPropertyDeclarationOrIndexAccess;
	    function isExpressionOfExternalModuleImportEqualsDeclaration(node) {
	        return ts.isExternalModuleImportEqualsDeclaration(node.parent.parent) &&
	            ts.getExternalModuleImportEqualsDeclarationExpression(node.parent.parent) === node;
	    }
	    ts.isExpressionOfExternalModuleImportEqualsDeclaration = isExpressionOfExternalModuleImportEqualsDeclaration;
	    function getContainerNode(node) {
	        if (ts.isJSDocTypeAlias(node)) {
	            // This doesn't just apply to the node immediately under the comment, but to everything in its parent's scope.
	            // node.parent = the JSDoc comment, node.parent.parent = the node having the comment.
	            // Then we get parent again in the loop.
	            node = node.parent.parent;
	        }
	        while (true) {
	            node = node.parent;
	            if (!node) {
	                return undefined;
	            }
	            switch (node.kind) {
	                case 273 /* SourceFile */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 234 /* ClassDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                    return node;
	            }
	        }
	    }
	    ts.getContainerNode = getContainerNode;
	    function getNodeKind(node) {
	        switch (node.kind) {
	            case 273 /* SourceFile */:
	                return ts.isExternalModule(node) ? "module" /* moduleElement */ : "script" /* scriptElement */;
	            case 238 /* ModuleDeclaration */:
	                return "module" /* moduleElement */;
	            case 234 /* ClassDeclaration */:
	            case 204 /* ClassExpression */:
	                return "class" /* classElement */;
	            case 235 /* InterfaceDeclaration */: return "interface" /* interfaceElement */;
	            case 236 /* TypeAliasDeclaration */:
	            case 291 /* JSDocCallbackTag */:
	            case 296 /* JSDocTypedefTag */:
	                return "type" /* typeElement */;
	            case 237 /* EnumDeclaration */: return "enum" /* enumElement */;
	            case 231 /* VariableDeclaration */:
	                return getKindOfVariableDeclaration(node);
	            case 181 /* BindingElement */:
	                return getKindOfVariableDeclaration(ts.getRootDeclaration(node));
	            case 192 /* ArrowFunction */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	                return "function" /* functionElement */;
	            case 155 /* GetAccessor */: return "getter" /* memberGetAccessorElement */;
	            case 156 /* SetAccessor */: return "setter" /* memberSetAccessorElement */;
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	                return "method" /* memberFunctionElement */;
	            case 151 /* PropertyDeclaration */:
	            case 150 /* PropertySignature */:
	                return "property" /* memberVariableElement */;
	            case 159 /* IndexSignature */: return "index" /* indexSignatureElement */;
	            case 158 /* ConstructSignature */: return "construct" /* constructSignatureElement */;
	            case 157 /* CallSignature */: return "call" /* callSignatureElement */;
	            case 154 /* Constructor */: return "constructor" /* constructorImplementationElement */;
	            case 147 /* TypeParameter */: return "type parameter" /* typeParameterElement */;
	            case 272 /* EnumMember */: return "enum member" /* enumMemberElement */;
	            case 148 /* Parameter */: return ts.hasModifier(node, 92 /* ParameterPropertyModifier */) ? "property" /* memberVariableElement */ : "parameter" /* parameterElement */;
	            case 242 /* ImportEqualsDeclaration */:
	            case 247 /* ImportSpecifier */:
	            case 244 /* ImportClause */:
	            case 251 /* ExportSpecifier */:
	            case 245 /* NamespaceImport */:
	                return "alias" /* alias */;
	            case 199 /* BinaryExpression */:
	                var kind = ts.getSpecialPropertyAssignmentKind(node);
	                var right = node.right;
	                switch (kind) {
	                    case 0 /* None */:
	                        return "" /* unknown */;
	                    case 1 /* ExportsProperty */:
	                    case 2 /* ModuleExports */:
	                        var rightKind = getNodeKind(right);
	                        return rightKind === "" /* unknown */ ? "const" /* constElement */ : rightKind;
	                    case 3 /* PrototypeProperty */:
	                        return ts.isFunctionExpression(right) ? "method" /* memberFunctionElement */ : "property" /* memberVariableElement */;
	                    case 4 /* ThisProperty */:
	                        return "property" /* memberVariableElement */; // property
	                    case 5 /* Property */:
	                        // static method / property
	                        return ts.isFunctionExpression(right) ? "method" /* memberFunctionElement */ : "property" /* memberVariableElement */;
	                    case 6 /* Prototype */:
	                        return "local class" /* localClassElement */;
	                    default: {
	                        ts.assertTypeIsNever(kind);
	                        return "" /* unknown */;
	                    }
	                }
	            default:
	                return "" /* unknown */;
	        }
	        function getKindOfVariableDeclaration(v) {
	            return ts.isConst(v)
	                ? "const" /* constElement */
	                : ts.isLet(v)
	                    ? "let" /* letElement */
	                    : "var" /* variableElement */;
	        }
	    }
	    ts.getNodeKind = getNodeKind;
	    function isThis(node) {
	        switch (node.kind) {
	            case 99 /* ThisKeyword */:
	                // case SyntaxKind.ThisType: TODO: GH#9267
	                return true;
	            case 71 /* Identifier */:
	                // 'this' as a parameter
	                return ts.identifierIsThisKeyword(node) && node.parent.kind === 148 /* Parameter */;
	            default:
	                return false;
	        }
	    }
	    ts.isThis = isThis;
	    // Matches the beginning of a triple slash directive
	    var tripleSlashDirectivePrefixRegex = /^\/\/\/\s*</;
	    function getLineStartPositionForPosition(position, sourceFile) {
	        var lineStarts = ts.getLineStarts(sourceFile);
	        var line = sourceFile.getLineAndCharacterOfPosition(position).line;
	        return lineStarts[line];
	    }
	    ts.getLineStartPositionForPosition = getLineStartPositionForPosition;
	    function rangeContainsRange(r1, r2) {
	        return startEndContainsRange(r1.pos, r1.end, r2);
	    }
	    ts.rangeContainsRange = rangeContainsRange;
	    function rangeContainsPosition(r, pos) {
	        return r.pos <= pos && pos <= r.end;
	    }
	    ts.rangeContainsPosition = rangeContainsPosition;
	    function startEndContainsRange(start, end, range) {
	        return start <= range.pos && end >= range.end;
	    }
	    ts.startEndContainsRange = startEndContainsRange;
	    function rangeContainsStartEnd(range, start, end) {
	        return range.pos <= start && range.end >= end;
	    }
	    ts.rangeContainsStartEnd = rangeContainsStartEnd;
	    function rangeOverlapsWithStartEnd(r1, start, end) {
	        return startEndOverlapsWithStartEnd(r1.pos, r1.end, start, end);
	    }
	    ts.rangeOverlapsWithStartEnd = rangeOverlapsWithStartEnd;
	    function startEndOverlapsWithStartEnd(start1, end1, start2, end2) {
	        var start = Math.max(start1, start2);
	        var end = Math.min(end1, end2);
	        return start < end;
	    }
	    ts.startEndOverlapsWithStartEnd = startEndOverlapsWithStartEnd;
	    /**
	     * Assumes `candidate.start <= position` holds.
	     */
	    function positionBelongsToNode(candidate, position, sourceFile) {
	        ts.Debug.assert(candidate.pos <= position);
	        return position < candidate.end || !isCompletedNode(candidate, sourceFile);
	    }
	    ts.positionBelongsToNode = positionBelongsToNode;
	    function isCompletedNode(n, sourceFile) {
	        if (ts.nodeIsMissing(n)) {
	            return false;
	        }
	        switch (n.kind) {
	            case 234 /* ClassDeclaration */:
	            case 235 /* InterfaceDeclaration */:
	            case 237 /* EnumDeclaration */:
	            case 183 /* ObjectLiteralExpression */:
	            case 179 /* ObjectBindingPattern */:
	            case 165 /* TypeLiteral */:
	            case 212 /* Block */:
	            case 239 /* ModuleBlock */:
	            case 240 /* CaseBlock */:
	            case 246 /* NamedImports */:
	            case 250 /* NamedExports */:
	                return nodeEndsWith(n, 18 /* CloseBraceToken */, sourceFile);
	            case 268 /* CatchClause */:
	                return isCompletedNode(n.block, sourceFile);
	            case 187 /* NewExpression */:
	                if (!n.arguments) {
	                    return true;
	                }
	            // falls through
	            case 186 /* CallExpression */:
	            case 190 /* ParenthesizedExpression */:
	            case 172 /* ParenthesizedType */:
	                return nodeEndsWith(n, 20 /* CloseParenToken */, sourceFile);
	            case 162 /* FunctionType */:
	            case 163 /* ConstructorType */:
	                return isCompletedNode(n.type, sourceFile);
	            case 154 /* Constructor */:
	            case 155 /* GetAccessor */:
	            case 156 /* SetAccessor */:
	            case 233 /* FunctionDeclaration */:
	            case 191 /* FunctionExpression */:
	            case 153 /* MethodDeclaration */:
	            case 152 /* MethodSignature */:
	            case 158 /* ConstructSignature */:
	            case 157 /* CallSignature */:
	            case 192 /* ArrowFunction */:
	                if (n.body) {
	                    return isCompletedNode(n.body, sourceFile);
	                }
	                if (n.type) {
	                    return isCompletedNode(n.type, sourceFile);
	                }
	                // Even though type parameters can be unclosed, we can get away with
	                // having at least a closing paren.
	                return hasChildOfKind(n, 20 /* CloseParenToken */, sourceFile);
	            case 238 /* ModuleDeclaration */:
	                return n.body && isCompletedNode(n.body, sourceFile);
	            case 216 /* IfStatement */:
	                if (n.elseStatement) {
	                    return isCompletedNode(n.elseStatement, sourceFile);
	                }
	                return isCompletedNode(n.thenStatement, sourceFile);
	            case 215 /* ExpressionStatement */:
	                return isCompletedNode(n.expression, sourceFile) ||
	                    hasChildOfKind(n, 25 /* SemicolonToken */, sourceFile);
	            case 182 /* ArrayLiteralExpression */:
	            case 180 /* ArrayBindingPattern */:
	            case 185 /* ElementAccessExpression */:
	            case 146 /* ComputedPropertyName */:
	            case 167 /* TupleType */:
	                return nodeEndsWith(n, 22 /* CloseBracketToken */, sourceFile);
	            case 159 /* IndexSignature */:
	                if (n.type) {
	                    return isCompletedNode(n.type, sourceFile);
	                }
	                return hasChildOfKind(n, 22 /* CloseBracketToken */, sourceFile);
	            case 265 /* CaseClause */:
	            case 266 /* DefaultClause */:
	                // there is no such thing as terminator token for CaseClause/DefaultClause so for simplicity always consider them non-completed
	                return false;
	            case 219 /* ForStatement */:
	            case 220 /* ForInStatement */:
	            case 221 /* ForOfStatement */:
	            case 218 /* WhileStatement */:
	                return isCompletedNode(n.statement, sourceFile);
	            case 217 /* DoStatement */:
	                // rough approximation: if DoStatement has While keyword - then if node is completed is checking the presence of ')';
	                return hasChildOfKind(n, 106 /* WhileKeyword */, sourceFile)
	                    ? nodeEndsWith(n, 20 /* CloseParenToken */, sourceFile)
	                    : isCompletedNode(n.statement, sourceFile);
	            case 164 /* TypeQuery */:
	                return isCompletedNode(n.exprName, sourceFile);
	            case 194 /* TypeOfExpression */:
	            case 193 /* DeleteExpression */:
	            case 195 /* VoidExpression */:
	            case 202 /* YieldExpression */:
	            case 203 /* SpreadElement */:
	                var unaryWordExpression = n;
	                return isCompletedNode(unaryWordExpression.expression, sourceFile);
	            case 188 /* TaggedTemplateExpression */:
	                return isCompletedNode(n.template, sourceFile);
	            case 201 /* TemplateExpression */:
	                var lastSpan = ts.lastOrUndefined(n.templateSpans);
	                return isCompletedNode(lastSpan, sourceFile);
	            case 210 /* TemplateSpan */:
	                return ts.nodeIsPresent(n.literal);
	            case 249 /* ExportDeclaration */:
	            case 243 /* ImportDeclaration */:
	                return ts.nodeIsPresent(n.moduleSpecifier);
	            case 197 /* PrefixUnaryExpression */:
	                return isCompletedNode(n.operand, sourceFile);
	            case 199 /* BinaryExpression */:
	                return isCompletedNode(n.right, sourceFile);
	            case 200 /* ConditionalExpression */:
	                return isCompletedNode(n.whenFalse, sourceFile);
	            default:
	                return true;
	        }
	    }
	    /*
	     * Checks if node ends with 'expectedLastToken'.
	     * If child at position 'length - 1' is 'SemicolonToken' it is skipped and 'expectedLastToken' is compared with child at position 'length - 2'.
	     */
	    function nodeEndsWith(n, expectedLastToken, sourceFile) {
	        var children = n.getChildren(sourceFile);
	        if (children.length) {
	            var last_2 = ts.lastOrUndefined(children);
	            if (last_2.kind === expectedLastToken) {
	                return true;
	            }
	            else if (last_2.kind === 25 /* SemicolonToken */ && children.length !== 1) {
	                return children[children.length - 2].kind === expectedLastToken;
	            }
	        }
	        return false;
	    }
	    function findListItemInfo(node) {
	        var list = findContainingList(node);
	        // It is possible at this point for syntaxList to be undefined, either if
	        // node.parent had no list child, or if none of its list children contained
	        // the span of node. If this happens, return undefined. The caller should
	        // handle this case.
	        if (!list) {
	            return undefined;
	        }
	        var children = list.getChildren();
	        var listItemIndex = ts.indexOfNode(children, node);
	        return {
	            listItemIndex: listItemIndex,
	            list: list
	        };
	    }
	    ts.findListItemInfo = findListItemInfo;
	    function hasChildOfKind(n, kind, sourceFile) {
	        return !!findChildOfKind(n, kind, sourceFile);
	    }
	    ts.hasChildOfKind = hasChildOfKind;
	    function findChildOfKind(n, kind, sourceFile) {
	        return ts.find(n.getChildren(sourceFile), function (c) { return c.kind === kind; });
	    }
	    ts.findChildOfKind = findChildOfKind;
	    function findContainingList(node) {
	        // The node might be a list element (nonsynthetic) or a comma (synthetic). Either way, it will
	        // be parented by the container of the SyntaxList, not the SyntaxList itself.
	        // In order to find the list item index, we first need to locate SyntaxList itself and then search
	        // for the position of the relevant node (or comma).
	        var syntaxList = ts.find(node.parent.getChildren(), function (c) { return ts.isSyntaxList(c) && rangeContainsRange(c, node); });
	        // Either we didn't find an appropriate list, or the list must contain us.
	        ts.Debug.assert(!syntaxList || ts.contains(syntaxList.getChildren(), node));
	        return syntaxList;
	    }
	    ts.findContainingList = findContainingList;
	    /**
	     * Gets the token whose text has range [start, end) and
	     * position >= start and (position < end or (position === end && token is literal or keyword or identifier))
	     */
	    function getTouchingPropertyName(sourceFile, position, includeJsDocComment) {
	        return getTouchingToken(sourceFile, position, includeJsDocComment, function (n) { return ts.isPropertyNameLiteral(n) || ts.isKeyword(n.kind); });
	    }
	    ts.getTouchingPropertyName = getTouchingPropertyName;
	    /**
	     * Returns the token if position is in [start, end).
	     * If position === end, returns the preceding token if includeItemAtEndPosition(previousToken) === true
	     */
	    function getTouchingToken(sourceFile, position, includeJsDocComment, includePrecedingTokenAtEndPosition) {
	        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ false, includePrecedingTokenAtEndPosition, /*includeEndPosition*/ false, includeJsDocComment);
	    }
	    ts.getTouchingToken = getTouchingToken;
	    /** Returns a token if position is in [start-of-leading-trivia, end) */
	    function getTokenAtPosition(sourceFile, position, includeJsDocComment, includeEndPosition) {
	        return getTokenAtPositionWorker(sourceFile, position, /*allowPositionInLeadingTrivia*/ true, /*includePrecedingTokenAtEndPosition*/ undefined, includeEndPosition, includeJsDocComment);
	    }
	    ts.getTokenAtPosition = getTokenAtPosition;
	    /** Get the token whose text contains the position */
	    function getTokenAtPositionWorker(sourceFile, position, allowPositionInLeadingTrivia, includePrecedingTokenAtEndPosition, includeEndPosition, includeJsDocComment) {
	        var current = sourceFile;
	        outer: while (true) {
	            if (ts.isToken(current)) {
	                // exit early
	                return current;
	            }
	            // find the child that contains 'position'
	            for (var _i = 0, _a = current.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (!includeJsDocComment && ts.isJSDocNode(child)) {
	                    continue;
	                }
	                var start = allowPositionInLeadingTrivia ? child.getFullStart() : child.getStart(sourceFile, includeJsDocComment);
	                if (start > position) {
	                    // If this child begins after position, then all subsequent children will as well.
	                    break;
	                }
	                var end = child.getEnd();
	                if (position < end || (position === end && (child.kind === 1 /* EndOfFileToken */ || includeEndPosition))) {
	                    current = child;
	                    continue outer;
	                }
	                else if (includePrecedingTokenAtEndPosition && end === position) {
	                    var previousToken = findPrecedingToken(position, sourceFile, child);
	                    if (previousToken && includePrecedingTokenAtEndPosition(previousToken)) {
	                        return previousToken;
	                    }
	                }
	            }
	            return current;
	        }
	    }
	    /**
	     * The token on the left of the position is the token that strictly includes the position
	     * or sits to the left of the cursor if it is on a boundary. For example
	     *
	     *   fo|o               -> will return foo
	     *   foo <comment> |bar -> will return foo
	     *
	     */
	    function findTokenOnLeftOfPosition(file, position) {
	        // Ideally, getTokenAtPosition should return a token. However, it is currently
	        // broken, so we do a check to make sure the result was indeed a token.
	        var tokenAtPosition = getTokenAtPosition(file, position, /*includeJsDocComment*/ false);
	        if (ts.isToken(tokenAtPosition) && position > tokenAtPosition.getStart(file) && position < tokenAtPosition.getEnd()) {
	            return tokenAtPosition;
	        }
	        return findPrecedingToken(position, file);
	    }
	    ts.findTokenOnLeftOfPosition = findTokenOnLeftOfPosition;
	    function findNextToken(previousToken, parent, sourceFile) {
	        return find(parent);
	        function find(n) {
	            if (ts.isToken(n) && n.pos === previousToken.end) {
	                // this is token that starts at the end of previous token - return it
	                return n;
	            }
	            var children = n.getChildren();
	            for (var _i = 0, children_3 = children; _i < children_3.length; _i++) {
	                var child = children_3[_i];
	                var shouldDiveInChildNode = 
	                // previous token is enclosed somewhere in the child
	                (child.pos <= previousToken.pos && child.end > previousToken.end) ||
	                    // previous token ends exactly at the beginning of child
	                    (child.pos === previousToken.end);
	                if (shouldDiveInChildNode && nodeHasTokens(child, sourceFile)) {
	                    return find(child);
	                }
	            }
	            return undefined;
	        }
	    }
	    ts.findNextToken = findNextToken;
	    /**
	     * Finds the rightmost token satisfying `token.end <= position`,
	     * excluding `JsxText` tokens containing only whitespace.
	     */
	    function findPrecedingToken(position, sourceFile, startNode, includeJsDoc) {
	        var result = find(startNode || sourceFile);
	        ts.Debug.assert(!(result && isWhiteSpaceOnlyJsxText(result)));
	        return result;
	        function find(n) {
	            if (isNonWhitespaceToken(n)) {
	                return n;
	            }
	            var children = n.getChildren(sourceFile);
	            for (var i = 0; i < children.length; i++) {
	                var child = children[i];
	                // Note that the span of a node's tokens is [node.getStart(...), node.end).
	                // Given that `position < child.end` and child has constituent tokens, we distinguish these cases:
	                // 1) `position` precedes `child`'s tokens or `child` has no tokens (ie: in a comment or whitespace preceding `child`):
	                // we need to find the last token in a previous child.
	                // 2) `position` is within the same span: we recurse on `child`.
	                if (position < child.end) {
	                    var start = child.getStart(sourceFile, includeJsDoc);
	                    var lookInPreviousChild = (start >= position) || // cursor in the leading trivia
	                        !nodeHasTokens(child, sourceFile) ||
	                        isWhiteSpaceOnlyJsxText(child);
	                    if (lookInPreviousChild) {
	                        // actual start of the node is past the position - previous token should be at the end of previous child
	                        var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ i, sourceFile);
	                        return candidate && findRightmostToken(candidate, sourceFile);
	                    }
	                    else {
	                        // candidate should be in this node
	                        return find(child);
	                    }
	                }
	            }
	            ts.Debug.assert(startNode !== undefined || n.kind === 273 /* SourceFile */ || ts.isJSDocCommentContainingNode(n));
	            // Here we know that none of child token nodes embrace the position,
	            // the only known case is when position is at the end of the file.
	            // Try to find the rightmost token in the file without filtering.
	            // Namely we are skipping the check: 'position < node.end'
	            if (children.length) {
	                var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile);
	                return candidate && findRightmostToken(candidate, sourceFile);
	            }
	        }
	    }
	    ts.findPrecedingToken = findPrecedingToken;
	    function isNonWhitespaceToken(n) {
	        return ts.isToken(n) && !isWhiteSpaceOnlyJsxText(n);
	    }
	    function findRightmostToken(n, sourceFile) {
	        if (isNonWhitespaceToken(n)) {
	            return n;
	        }
	        var children = n.getChildren(sourceFile);
	        var candidate = findRightmostChildNodeWithTokens(children, /*exclusiveStartPosition*/ children.length, sourceFile);
	        return candidate && findRightmostToken(candidate, sourceFile);
	    }
	    /**
	     * Finds the rightmost child to the left of `children[exclusiveStartPosition]` which is a non-all-whitespace token or has constituent tokens.
	     */
	    function findRightmostChildNodeWithTokens(children, exclusiveStartPosition, sourceFile) {
	        for (var i = exclusiveStartPosition - 1; i >= 0; i--) {
	            var child = children[i];
	            if (isWhiteSpaceOnlyJsxText(child)) {
	                ts.Debug.assert(i > 0, "`JsxText` tokens should not be the first child of `JsxElement | JsxSelfClosingElement`");
	            }
	            else if (nodeHasTokens(children[i], sourceFile)) {
	                return children[i];
	            }
	        }
	    }
	    function isInString(sourceFile, position, previousToken) {
	        if (previousToken === void 0) { previousToken = findPrecedingToken(position, sourceFile); }
	        if (previousToken && ts.isStringTextContainingNode(previousToken)) {
	            var start = previousToken.getStart();
	            var end = previousToken.getEnd();
	            // To be "in" one of these literals, the position has to be:
	            //   1. entirely within the token text.
	            //   2. at the end position of an unterminated token.
	            //   3. at the end of a regular expression (due to trailing flags like '/foo/g').
	            if (start < position && position < end) {
	                return true;
	            }
	            if (position === end) {
	                return !!previousToken.isUnterminated;
	            }
	        }
	        return false;
	    }
	    ts.isInString = isInString;
	    /**
	     * returns true if the position is in between the open and close elements of an JSX expression.
	     */
	    function isInsideJsxElementOrAttribute(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        if (!token) {
	            return false;
	        }
	        if (token.kind === 10 /* JsxText */) {
	            return true;
	        }
	        // <div>Hello |</div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 10 /* JsxText */) {
	            return true;
	        }
	        // <div> { | </div> or <div a={| </div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 264 /* JsxExpression */) {
	            return true;
	        }
	        // <div> {
	        // |
	        // } < /div>
	        if (token && token.kind === 18 /* CloseBraceToken */ && token.parent.kind === 264 /* JsxExpression */) {
	            return true;
	        }
	        // <div>|</div>
	        if (token.kind === 27 /* LessThanToken */ && token.parent.kind === 257 /* JsxClosingElement */) {
	            return true;
	        }
	        return false;
	    }
	    ts.isInsideJsxElementOrAttribute = isInsideJsxElementOrAttribute;
	    function isWhiteSpaceOnlyJsxText(node) {
	        return ts.isJsxText(node) && node.containsOnlyWhiteSpaces;
	    }
	    function isInTemplateString(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        return ts.isTemplateLiteralKind(token.kind) && position > token.getStart(sourceFile);
	    }
	    ts.isInTemplateString = isInTemplateString;
	    function findPrecedingMatchingToken(token, matchingTokenKind, sourceFile) {
	        var tokenKind = token.kind;
	        var remainingMatchingTokens = 0;
	        while (true) {
	            token = findPrecedingToken(token.getFullStart(), sourceFile);
	            if (!token) {
	                return undefined;
	            }
	            if (token.kind === matchingTokenKind) {
	                if (remainingMatchingTokens === 0) {
	                    return token;
	                }
	                remainingMatchingTokens--;
	            }
	            else if (token.kind === tokenKind) {
	                remainingMatchingTokens++;
	            }
	        }
	    }
	    ts.findPrecedingMatchingToken = findPrecedingMatchingToken;
	    function isPossiblyTypeArgumentPosition(token, sourceFile) {
	        // This function determines if the node could be type argument position
	        // Since during editing, when type argument list is not complete,
	        // the tree could be of any shape depending on the tokens parsed before current node,
	        // scanning of the previous identifier followed by "<" before current node would give us better result
	        // Note that we also balance out the already provided type arguments, arrays, object literals while doing so
	        var remainingLessThanTokens = 0;
	        while (token) {
	            switch (token.kind) {
	                case 27 /* LessThanToken */:
	                    // Found the beginning of the generic argument expression
	                    token = findPrecedingToken(token.getFullStart(), sourceFile);
	                    var tokenIsIdentifier = token && ts.isIdentifier(token);
	                    if (!remainingLessThanTokens || !tokenIsIdentifier) {
	                        return tokenIsIdentifier;
	                    }
	                    remainingLessThanTokens--;
	                    break;
	                case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    remainingLessThanTokens = +3;
	                    break;
	                case 46 /* GreaterThanGreaterThanToken */:
	                    remainingLessThanTokens = +2;
	                    break;
	                case 29 /* GreaterThanToken */:
	                    remainingLessThanTokens++;
	                    break;
	                case 18 /* CloseBraceToken */:
	                    // This can be object type, skip until we find the matching open brace token
	                    // Skip until the matching open brace token
	                    token = findPrecedingMatchingToken(token, 17 /* OpenBraceToken */, sourceFile);
	                    if (!token)
	                        return false;
	                    break;
	                case 20 /* CloseParenToken */:
	                    // This can be object type, skip until we find the matching open brace token
	                    // Skip until the matching open brace token
	                    token = findPrecedingMatchingToken(token, 19 /* OpenParenToken */, sourceFile);
	                    if (!token)
	                        return false;
	                    break;
	                case 22 /* CloseBracketToken */:
	                    // This can be object type, skip until we find the matching open brace token
	                    // Skip until the matching open brace token
	                    token = findPrecedingMatchingToken(token, 21 /* OpenBracketToken */, sourceFile);
	                    if (!token)
	                        return false;
	                    break;
	                // Valid tokens in a type name. Skip.
	                case 26 /* CommaToken */:
	                case 36 /* EqualsGreaterThanToken */:
	                case 71 /* Identifier */:
	                case 9 /* StringLiteral */:
	                case 8 /* NumericLiteral */:
	                case 101 /* TrueKeyword */:
	                case 86 /* FalseKeyword */:
	                case 103 /* TypeOfKeyword */:
	                case 85 /* ExtendsKeyword */:
	                case 128 /* KeyOfKeyword */:
	                case 23 /* DotToken */:
	                case 49 /* BarToken */:
	                case 55 /* QuestionToken */:
	                case 56 /* ColonToken */:
	                    break;
	                default:
	                    if (ts.isTypeNode(token)) {
	                        break;
	                    }
	                    // Invalid token in type
	                    return false;
	            }
	            token = findPrecedingToken(token.getFullStart(), sourceFile);
	        }
	        return false;
	    }
	    ts.isPossiblyTypeArgumentPosition = isPossiblyTypeArgumentPosition;
	    /**
	     * Returns true if the cursor at position in sourceFile is within a comment.
	     *
	     * @param tokenAtPosition Must equal `getTokenAtPosition(sourceFile, position)
	     * @param predicate Additional predicate to test on the comment range.
	     */
	    function isInComment(sourceFile, position, tokenAtPosition, predicate) {
	        return !!ts.formatting.getRangeOfEnclosingComment(sourceFile, position, /*onlyMultiLine*/ false, /*precedingToken*/ undefined, tokenAtPosition, predicate);
	    }
	    ts.isInComment = isInComment;
	    function hasDocComment(sourceFile, position) {
	        var token = getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	        // First, we have to see if this position actually landed in a comment.
	        var commentRanges = ts.getLeadingCommentRanges(sourceFile.text, token.pos);
	        return ts.forEach(commentRanges, jsDocPrefix);
	        function jsDocPrefix(c) {
	            var text = sourceFile.text;
	            return text.length >= c.pos + 3 && text[c.pos] === "/" && text[c.pos + 1] === "*" && text[c.pos + 2] === "*";
	        }
	    }
	    ts.hasDocComment = hasDocComment;
	    function nodeHasTokens(n, sourceFile) {
	        // If we have a token or node that has a non-zero width, it must have tokens.
	        // Note: getWidth() does not take trivia into account.
	        return n.getWidth(sourceFile) !== 0;
	    }
	    function getNodeModifiers(node) {
	        var flags = ts.getCombinedModifierFlags(node);
	        var result = [];
	        if (flags & 8 /* Private */)
	            result.push("private" /* privateMemberModifier */);
	        if (flags & 16 /* Protected */)
	            result.push("protected" /* protectedMemberModifier */);
	        if (flags & 4 /* Public */)
	            result.push("public" /* publicMemberModifier */);
	        if (flags & 32 /* Static */)
	            result.push("static" /* staticModifier */);
	        if (flags & 128 /* Abstract */)
	            result.push("abstract" /* abstractModifier */);
	        if (flags & 1 /* Export */)
	            result.push("export" /* exportedModifier */);
	        if (node.flags & 4194304 /* Ambient */)
	            result.push("declare" /* ambientModifier */);
	        return result.length > 0 ? result.join(",") : "" /* none */;
	    }
	    ts.getNodeModifiers = getNodeModifiers;
	    function getTypeArgumentOrTypeParameterList(node) {
	        if (node.kind === 161 /* TypeReference */ || node.kind === 186 /* CallExpression */) {
	            return node.typeArguments;
	        }
	        if (ts.isFunctionLike(node) || node.kind === 234 /* ClassDeclaration */ || node.kind === 235 /* InterfaceDeclaration */) {
	            return node.typeParameters;
	        }
	        return undefined;
	    }
	    ts.getTypeArgumentOrTypeParameterList = getTypeArgumentOrTypeParameterList;
	    function isComment(kind) {
	        return kind === 2 /* SingleLineCommentTrivia */ || kind === 3 /* MultiLineCommentTrivia */;
	    }
	    ts.isComment = isComment;
	    function isStringOrRegularExpressionOrTemplateLiteral(kind) {
	        if (kind === 9 /* StringLiteral */
	            || kind === 12 /* RegularExpressionLiteral */
	            || ts.isTemplateLiteralKind(kind)) {
	            return true;
	        }
	        return false;
	    }
	    ts.isStringOrRegularExpressionOrTemplateLiteral = isStringOrRegularExpressionOrTemplateLiteral;
	    function isPunctuation(kind) {
	        return 17 /* FirstPunctuation */ <= kind && kind <= 70 /* LastPunctuation */;
	    }
	    ts.isPunctuation = isPunctuation;
	    function isInsideTemplateLiteral(node, position) {
	        return ts.isTemplateLiteralKind(node.kind)
	            && (node.getStart() < position && position < node.getEnd()) || (!!node.isUnterminated && position === node.getEnd());
	    }
	    ts.isInsideTemplateLiteral = isInsideTemplateLiteral;
	    function isAccessibilityModifier(kind) {
	        switch (kind) {
	            case 114 /* PublicKeyword */:
	            case 112 /* PrivateKeyword */:
	            case 113 /* ProtectedKeyword */:
	                return true;
	        }
	        return false;
	    }
	    ts.isAccessibilityModifier = isAccessibilityModifier;
	    function cloneCompilerOptions(options) {
	        var result = ts.clone(options);
	        ts.setConfigFileInOptions(result, options && options.configFile);
	        return result;
	    }
	    ts.cloneCompilerOptions = cloneCompilerOptions;
	    function isArrayLiteralOrObjectLiteralDestructuringPattern(node) {
	        if (node.kind === 182 /* ArrayLiteralExpression */ ||
	            node.kind === 183 /* ObjectLiteralExpression */) {
	            // [a,b,c] from:
	            // [a, b, c] = someExpression;
	            if (node.parent.kind === 199 /* BinaryExpression */ &&
	                node.parent.left === node &&
	                node.parent.operatorToken.kind === 58 /* EqualsToken */) {
	                return true;
	            }
	            // [a, b, c] from:
	            // for([a, b, c] of expression)
	            if (node.parent.kind === 221 /* ForOfStatement */ &&
	                node.parent.initializer === node) {
	                return true;
	            }
	            // [a, b, c] of
	            // [x, [a, b, c] ] = someExpression
	            // or
	            // {x, a: {a, b, c} } = someExpression
	            if (isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.kind === 269 /* PropertyAssignment */ ? node.parent.parent : node.parent)) {
	                return true;
	            }
	        }
	        return false;
	    }
	    ts.isArrayLiteralOrObjectLiteralDestructuringPattern = isArrayLiteralOrObjectLiteralDestructuringPattern;
	    function isInReferenceComment(sourceFile, position) {
	        return isInComment(sourceFile, position, /*tokenAtPosition*/ undefined, function (c) {
	            var commentText = sourceFile.text.substring(c.pos, c.end);
	            return tripleSlashDirectivePrefixRegex.test(commentText);
	        });
	    }
	    ts.isInReferenceComment = isInReferenceComment;
	    function isInNonReferenceComment(sourceFile, position) {
	        return isInComment(sourceFile, position, /*tokenAtPosition*/ undefined, function (c) {
	            var commentText = sourceFile.text.substring(c.pos, c.end);
	            return !tripleSlashDirectivePrefixRegex.test(commentText);
	        });
	    }
	    ts.isInNonReferenceComment = isInNonReferenceComment;
	    function createTextSpanFromNode(node, sourceFile) {
	        return ts.createTextSpanFromBounds(node.getStart(sourceFile), node.getEnd());
	    }
	    ts.createTextSpanFromNode = createTextSpanFromNode;
	    function createTextSpanFromRange(range) {
	        return ts.createTextSpanFromBounds(range.pos, range.end);
	    }
	    ts.createTextSpanFromRange = createTextSpanFromRange;
	    function createTextRangeFromSpan(span) {
	        return ts.createTextRange(span.start, span.start + span.length);
	    }
	    ts.createTextRangeFromSpan = createTextRangeFromSpan;
	    function createTextChangeFromStartLength(start, length, newText) {
	        return createTextChange(ts.createTextSpan(start, length), newText);
	    }
	    ts.createTextChangeFromStartLength = createTextChangeFromStartLength;
	    function createTextChange(span, newText) {
	        return { span: span, newText: newText };
	    }
	    ts.createTextChange = createTextChange;
	    ts.typeKeywords = [
	        119 /* AnyKeyword */,
	        122 /* BooleanKeyword */,
	        128 /* KeyOfKeyword */,
	        131 /* NeverKeyword */,
	        95 /* NullKeyword */,
	        134 /* NumberKeyword */,
	        135 /* ObjectKeyword */,
	        137 /* StringKeyword */,
	        138 /* SymbolKeyword */,
	        105 /* VoidKeyword */,
	        140 /* UndefinedKeyword */,
	        141 /* UniqueKeyword */,
	    ];
	    function isTypeKeyword(kind) {
	        return ts.contains(ts.typeKeywords, kind);
	    }
	    ts.isTypeKeyword = isTypeKeyword;
	    /** True if the symbol is for an external module, as opposed to a namespace. */
	    function isExternalModuleSymbol(moduleSymbol) {
	        ts.Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */));
	        return moduleSymbol.name.charCodeAt(0) === 34 /* doubleQuote */;
	    }
	    ts.isExternalModuleSymbol = isExternalModuleSymbol;
	    function nodeSeenTracker() {
	        var seen = [];
	        return function (node) {
	            var id = ts.getNodeId(node);
	            return !seen[id] && (seen[id] = true);
	        };
	    }
	    ts.nodeSeenTracker = nodeSeenTracker;
	    function getSnapshotText(snap) {
	        return snap.getText(0, snap.getLength());
	    }
	    ts.getSnapshotText = getSnapshotText;
	    function repeatString(str, count) {
	        var result = "";
	        for (var i = 0; i < count; i++) {
	            result += str;
	        }
	        return result;
	    }
	    ts.repeatString = repeatString;
	    function skipConstraint(type) {
	        return type.isTypeParameter() ? type.getConstraint() : type;
	    }
	    ts.skipConstraint = skipConstraint;
	    function getNameFromPropertyName(name) {
	        return name.kind === 146 /* ComputedPropertyName */
	            // treat computed property names where expression is string/numeric literal as just string/numeric literal
	            ? ts.isStringOrNumericLiteral(name.expression) ? name.expression.text : undefined
	            : ts.getTextOfIdentifierOrLiteral(name);
	    }
	    ts.getNameFromPropertyName = getNameFromPropertyName;
	    function programContainsEs6Modules(program) {
	        return program.getSourceFiles().some(function (s) { return !s.isDeclarationFile && !program.isSourceFileFromExternalLibrary(s) && !!s.externalModuleIndicator; });
	    }
	    ts.programContainsEs6Modules = programContainsEs6Modules;
	    function compilerOptionsIndicateEs6Modules(compilerOptions) {
	        return !!compilerOptions.module || compilerOptions.target >= 2 /* ES2015 */ || !!compilerOptions.noEmit;
	    }
	    ts.compilerOptionsIndicateEs6Modules = compilerOptionsIndicateEs6Modules;
	    function hostUsesCaseSensitiveFileNames(host) {
	        return host.useCaseSensitiveFileNames ? host.useCaseSensitiveFileNames() : false;
	    }
	    ts.hostUsesCaseSensitiveFileNames = hostUsesCaseSensitiveFileNames;
	    function hostGetCanonicalFileName(host) {
	        return ts.createGetCanonicalFileName(hostUsesCaseSensitiveFileNames(host));
	    }
	    ts.hostGetCanonicalFileName = hostGetCanonicalFileName;
	    function makeImportIfNecessary(defaultImport, namedImports, moduleSpecifier, quotePreference) {
	        return defaultImport || namedImports && namedImports.length ? makeImport(defaultImport, namedImports, moduleSpecifier, quotePreference) : undefined;
	    }
	    ts.makeImportIfNecessary = makeImportIfNecessary;
	    function makeImport(defaultImport, namedImports, moduleSpecifier, quotePreference) {
	        return ts.createImportDeclaration(
	        /*decorators*/ undefined, 
	        /*modifiers*/ undefined, defaultImport || namedImports
	            ? ts.createImportClause(defaultImport, namedImports && namedImports.length ? ts.createNamedImports(namedImports) : undefined)
	            : undefined, typeof moduleSpecifier === "string" ? makeStringLiteral(moduleSpecifier, quotePreference) : moduleSpecifier);
	    }
	    ts.makeImport = makeImport;
	    function makeStringLiteral(text, quotePreference) {
	        return ts.createLiteral(text, quotePreference === 0 /* Single */);
	    }
	    ts.makeStringLiteral = makeStringLiteral;
	    var QuotePreference;
	    (function (QuotePreference) {
	        QuotePreference[QuotePreference["Single"] = 0] = "Single";
	        QuotePreference[QuotePreference["Double"] = 1] = "Double";
	    })(QuotePreference = ts.QuotePreference || (ts.QuotePreference = {}));
	    function getQuotePreference(sourceFile, preferences) {
	        if (preferences.quotePreference) {
	            return preferences.quotePreference === "single" ? 0 /* Single */ : 1 /* Double */;
	        }
	        else {
	            var firstModuleSpecifier = ts.firstOrUndefined(sourceFile.imports);
	            return !!firstModuleSpecifier && !ts.isStringDoubleQuoted(firstModuleSpecifier, sourceFile) ? 0 /* Single */ : 1 /* Double */;
	        }
	    }
	    ts.getQuotePreference = getQuotePreference;
	    function symbolNameNoDefault(symbol) {
	        var escaped = symbolEscapedNameNoDefault(symbol);
	        return escaped === undefined ? undefined : ts.unescapeLeadingUnderscores(escaped);
	    }
	    ts.symbolNameNoDefault = symbolNameNoDefault;
	    function symbolEscapedNameNoDefault(symbol) {
	        if (symbol.escapedName !== "default" /* Default */) {
	            return symbol.escapedName;
	        }
	        return ts.firstDefined(symbol.declarations, function (decl) {
	            var name = ts.getNameOfDeclaration(decl);
	            return name && name.kind === 71 /* Identifier */ ? name.escapedText : undefined;
	        });
	    }
	    ts.symbolEscapedNameNoDefault = symbolEscapedNameNoDefault;
	    function getPropertySymbolFromBindingElement(checker, bindingElement) {
	        var typeOfPattern = checker.getTypeAtLocation(bindingElement.parent);
	        var propSymbol = typeOfPattern && checker.getPropertyOfType(typeOfPattern, bindingElement.name.text);
	        if (propSymbol && propSymbol.flags & 98304 /* Accessor */) {
	            // See GH#16922
	            ts.Debug.assert(!!(propSymbol.flags & 33554432 /* Transient */));
	            return propSymbol.target;
	        }
	        return propSymbol;
	    }
	    ts.getPropertySymbolFromBindingElement = getPropertySymbolFromBindingElement;
	    var NodeSet = /** @class */ (function () {
	        function NodeSet() {
	            this.map = ts.createMap();
	        }
	        NodeSet.prototype.add = function (node) {
	            this.map.set(String(ts.getNodeId(node)), node);
	        };
	        NodeSet.prototype.has = function (node) {
	            return this.map.has(String(ts.getNodeId(node)));
	        };
	        NodeSet.prototype.forEach = function (cb) {
	            this.map.forEach(cb);
	        };
	        NodeSet.prototype.some = function (pred) {
	            return ts.forEachEntry(this.map, pred) || false;
	        };
	        return NodeSet;
	    }());
	    ts.NodeSet = NodeSet;
	})(ts || (ts = {}));
	// Display-part writer helpers
	/* @internal */
	(function (ts) {
	    function isFirstDeclarationOfSymbolParameter(symbol) {
	        return symbol.declarations && symbol.declarations.length > 0 && symbol.declarations[0].kind === 148 /* Parameter */;
	    }
	    ts.isFirstDeclarationOfSymbolParameter = isFirstDeclarationOfSymbolParameter;
	    var displayPartWriter = getDisplayPartWriter();
	    function getDisplayPartWriter() {
	        var displayParts;
	        var lineStart;
	        var indent;
	        resetWriter();
	        var unknownWrite = function (text) { return writeKind(text, ts.SymbolDisplayPartKind.text); };
	        return {
	            displayParts: function () { return displayParts; },
	            writeKeyword: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.keyword); },
	            writeOperator: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.operator); },
	            writePunctuation: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.punctuation); },
	            writeSpace: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.space); },
	            writeStringLiteral: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.stringLiteral); },
	            writeParameter: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.parameterName); },
	            writeProperty: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.propertyName); },
	            writeLiteral: function (text) { return writeKind(text, ts.SymbolDisplayPartKind.stringLiteral); },
	            writeSymbol: writeSymbol,
	            writeLine: writeLine,
	            write: unknownWrite,
	            writeTextOfNode: unknownWrite,
	            getText: function () { return ""; },
	            getTextPos: function () { return 0; },
	            getColumn: function () { return 0; },
	            getLine: function () { return 0; },
	            isAtStartOfLine: function () { return false; },
	            rawWrite: ts.notImplemented,
	            getIndent: function () { return indent; },
	            increaseIndent: function () { indent++; },
	            decreaseIndent: function () { indent--; },
	            clear: resetWriter,
	            trackSymbol: ts.noop,
	            reportInaccessibleThisError: ts.noop,
	            reportInaccessibleUniqueSymbolError: ts.noop,
	            reportPrivateInBaseOfClassExpression: ts.noop,
	        };
	        function writeIndent() {
	            if (lineStart) {
	                var indentString = ts.getIndentString(indent);
	                if (indentString) {
	                    displayParts.push(displayPart(indentString, ts.SymbolDisplayPartKind.space));
	                }
	                lineStart = false;
	            }
	        }
	        function writeKind(text, kind) {
	            writeIndent();
	            displayParts.push(displayPart(text, kind));
	        }
	        function writeSymbol(text, symbol) {
	            writeIndent();
	            displayParts.push(symbolPart(text, symbol));
	        }
	        function writeLine() {
	            displayParts.push(lineBreakPart());
	            lineStart = true;
	        }
	        function resetWriter() {
	            displayParts = [];
	            lineStart = true;
	            indent = 0;
	        }
	    }
	    function symbolPart(text, symbol) {
	        return displayPart(text, displayPartKind(symbol));
	        function displayPartKind(symbol) {
	            var flags = symbol.flags;
	            if (flags & 3 /* Variable */) {
	                return isFirstDeclarationOfSymbolParameter(symbol) ? ts.SymbolDisplayPartKind.parameterName : ts.SymbolDisplayPartKind.localName;
	            }
	            else if (flags & 4 /* Property */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 32768 /* GetAccessor */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 65536 /* SetAccessor */) {
	                return ts.SymbolDisplayPartKind.propertyName;
	            }
	            else if (flags & 8 /* EnumMember */) {
	                return ts.SymbolDisplayPartKind.enumMemberName;
	            }
	            else if (flags & 16 /* Function */) {
	                return ts.SymbolDisplayPartKind.functionName;
	            }
	            else if (flags & 32 /* Class */) {
	                return ts.SymbolDisplayPartKind.className;
	            }
	            else if (flags & 64 /* Interface */) {
	                return ts.SymbolDisplayPartKind.interfaceName;
	            }
	            else if (flags & 384 /* Enum */) {
	                return ts.SymbolDisplayPartKind.enumName;
	            }
	            else if (flags & 1536 /* Module */) {
	                return ts.SymbolDisplayPartKind.moduleName;
	            }
	            else if (flags & 8192 /* Method */) {
	                return ts.SymbolDisplayPartKind.methodName;
	            }
	            else if (flags & 262144 /* TypeParameter */) {
	                return ts.SymbolDisplayPartKind.typeParameterName;
	            }
	            else if (flags & 524288 /* TypeAlias */) {
	                return ts.SymbolDisplayPartKind.aliasName;
	            }
	            else if (flags & 2097152 /* Alias */) {
	                return ts.SymbolDisplayPartKind.aliasName;
	            }
	            return ts.SymbolDisplayPartKind.text;
	        }
	    }
	    ts.symbolPart = symbolPart;
	    function displayPart(text, kind) {
	        return { text: text, kind: ts.SymbolDisplayPartKind[kind] };
	    }
	    ts.displayPart = displayPart;
	    function spacePart() {
	        return displayPart(" ", ts.SymbolDisplayPartKind.space);
	    }
	    ts.spacePart = spacePart;
	    function keywordPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.keyword);
	    }
	    ts.keywordPart = keywordPart;
	    function punctuationPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.punctuation);
	    }
	    ts.punctuationPart = punctuationPart;
	    function operatorPart(kind) {
	        return displayPart(ts.tokenToString(kind), ts.SymbolDisplayPartKind.operator);
	    }
	    ts.operatorPart = operatorPart;
	    function textOrKeywordPart(text) {
	        var kind = ts.stringToToken(text);
	        return kind === undefined
	            ? textPart(text)
	            : keywordPart(kind);
	    }
	    ts.textOrKeywordPart = textOrKeywordPart;
	    function textPart(text) {
	        return displayPart(text, ts.SymbolDisplayPartKind.text);
	    }
	    ts.textPart = textPart;
	    var carriageReturnLineFeed = "\r\n";
	    /**
	     * The default is CRLF.
	     */
	    function getNewLineOrDefaultFromHost(host, formatSettings) {
	        return (formatSettings && formatSettings.newLineCharacter) ||
	            (host.getNewLine && host.getNewLine()) ||
	            carriageReturnLineFeed;
	    }
	    ts.getNewLineOrDefaultFromHost = getNewLineOrDefaultFromHost;
	    function lineBreakPart() {
	        return displayPart("\n", ts.SymbolDisplayPartKind.lineBreak);
	    }
	    ts.lineBreakPart = lineBreakPart;
	    /* @internal */
	    function mapToDisplayParts(writeDisplayParts) {
	        try {
	            writeDisplayParts(displayPartWriter);
	            return displayPartWriter.displayParts();
	        }
	        finally {
	            displayPartWriter.clear();
	        }
	    }
	    ts.mapToDisplayParts = mapToDisplayParts;
	    function typeToDisplayParts(typechecker, type, enclosingDeclaration, flags) {
	        return mapToDisplayParts(function (writer) {
	            typechecker.writeType(type, enclosingDeclaration, flags | 1024 /* MultilineObjectLiterals */ | 16384 /* UseAliasDefinedOutsideCurrentScope */, writer);
	        });
	    }
	    ts.typeToDisplayParts = typeToDisplayParts;
	    function symbolToDisplayParts(typeChecker, symbol, enclosingDeclaration, meaning, flags) {
	        return mapToDisplayParts(function (writer) {
	            typeChecker.writeSymbol(symbol, enclosingDeclaration, meaning, flags | 8 /* UseAliasDefinedOutsideCurrentScope */, writer);
	        });
	    }
	    ts.symbolToDisplayParts = symbolToDisplayParts;
	    function signatureToDisplayParts(typechecker, signature, enclosingDeclaration, flags) {
	        flags |= 16384 /* UseAliasDefinedOutsideCurrentScope */ | 1024 /* MultilineObjectLiterals */ | 32 /* WriteTypeArgumentsOfSignature */ | 8192 /* OmitParameterModifiers */;
	        return mapToDisplayParts(function (writer) {
	            typechecker.writeSignature(signature, enclosingDeclaration, flags, /*signatureKind*/ undefined, writer);
	        });
	    }
	    ts.signatureToDisplayParts = signatureToDisplayParts;
	    function isImportOrExportSpecifierName(location) {
	        return location.parent &&
	            (location.parent.kind === 247 /* ImportSpecifier */ || location.parent.kind === 251 /* ExportSpecifier */) &&
	            location.parent.propertyName === location;
	    }
	    ts.isImportOrExportSpecifierName = isImportOrExportSpecifierName;
	    /**
	     * Strip off existed single quotes or double quotes from a given string
	     *
	     * @return non-quoted string
	     */
	    function stripQuotes(name) {
	        var length = name.length;
	        if (length >= 2 && name.charCodeAt(0) === name.charCodeAt(length - 1) && startsWithQuote(name)) {
	            return name.substring(1, length - 1);
	        }
	        return name;
	    }
	    ts.stripQuotes = stripQuotes;
	    function startsWithQuote(name) {
	        return ts.isSingleOrDoubleQuote(name.charCodeAt(0));
	    }
	    ts.startsWithQuote = startsWithQuote;
	    function scriptKindIs(fileName, host) {
	        var scriptKinds = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            scriptKinds[_i - 2] = arguments[_i];
	        }
	        var scriptKind = getScriptKind(fileName, host);
	        return ts.forEach(scriptKinds, function (k) { return k === scriptKind; });
	    }
	    ts.scriptKindIs = scriptKindIs;
	    function getScriptKind(fileName, host) {
	        // First check to see if the script kind was specified by the host. Chances are the host
	        // may override the default script kind for the file extension.
	        return ts.ensureScriptKind(fileName, host && host.getScriptKind && host.getScriptKind(fileName));
	    }
	    ts.getScriptKind = getScriptKind;
	    function getUniqueSymbolId(symbol, checker) {
	        return ts.getSymbolId(ts.skipAlias(symbol, checker));
	    }
	    ts.getUniqueSymbolId = getUniqueSymbolId;
	    function getFirstNonSpaceCharacterPosition(text, position) {
	        while (ts.isWhiteSpaceLike(text.charCodeAt(position))) {
	            position += 1;
	        }
	        return position;
	    }
	    ts.getFirstNonSpaceCharacterPosition = getFirstNonSpaceCharacterPosition;
	    /**
	     * Creates a deep, memberwise clone of a node with no source map location.
	     *
	     * WARNING: This is an expensive operation and is only intended to be used in refactorings
	     * and code fixes (because those are triggered by explicit user actions).
	     */
	    function getSynthesizedDeepClone(node, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = true; }
	        var clone = node && getSynthesizedDeepCloneWorker(node);
	        if (clone && !includeTrivia)
	            suppressLeadingAndTrailingTrivia(clone);
	        return clone;
	    }
	    ts.getSynthesizedDeepClone = getSynthesizedDeepClone;
	    function getSynthesizedDeepCloneWorker(node) {
	        var visited = ts.visitEachChild(node, getSynthesizedDeepClone, ts.nullTransformationContext);
	        if (visited === node) {
	            // This only happens for leaf nodes - internal nodes always see their children change.
	            var clone_7 = ts.getSynthesizedClone(node);
	            if (ts.isStringLiteral(clone_7)) {
	                clone_7.textSourceNode = node;
	            }
	            else if (ts.isNumericLiteral(clone_7)) {
	                clone_7.numericLiteralFlags = node.numericLiteralFlags;
	            }
	            return ts.setTextRange(clone_7, node);
	        }
	        // PERF: As an optimization, rather than calling getSynthesizedClone, we'll update
	        // the new node created by visitEachChild with the extra changes getSynthesizedClone
	        // would have made.
	        visited.parent = undefined;
	        return visited;
	    }
	    function getSynthesizedDeepClones(nodes, includeTrivia) {
	        if (includeTrivia === void 0) { includeTrivia = true; }
	        return nodes && ts.createNodeArray(nodes.map(function (n) { return getSynthesizedDeepClone(n, includeTrivia); }), nodes.hasTrailingComma);
	    }
	    ts.getSynthesizedDeepClones = getSynthesizedDeepClones;
	    /**
	     * Sets EmitFlags to suppress leading and trailing trivia on the node.
	     */
	    /* @internal */
	    function suppressLeadingAndTrailingTrivia(node) {
	        suppressLeadingTrivia(node);
	        suppressTrailingTrivia(node);
	    }
	    ts.suppressLeadingAndTrailingTrivia = suppressLeadingAndTrailingTrivia;
	    /**
	     * Sets EmitFlags to suppress leading trivia on the node.
	     */
	    /* @internal */
	    function suppressLeadingTrivia(node) {
	        addEmitFlagsRecursively(node, 512 /* NoLeadingComments */, getFirstChild);
	    }
	    ts.suppressLeadingTrivia = suppressLeadingTrivia;
	    /**
	     * Sets EmitFlags to suppress trailing trivia on the node.
	     */
	    /* @internal */
	    function suppressTrailingTrivia(node) {
	        addEmitFlagsRecursively(node, 1024 /* NoTrailingComments */, ts.getLastChild);
	    }
	    ts.suppressTrailingTrivia = suppressTrailingTrivia;
	    function addEmitFlagsRecursively(node, flag, getChild) {
	        ts.addEmitFlags(node, flag);
	        var child = getChild(node);
	        if (child)
	            addEmitFlagsRecursively(child, flag, getChild);
	    }
	    function getFirstChild(node) {
	        return node.forEachChild(function (child) { return child; });
	    }
	    /* @internal */
	    function getUniqueName(baseName, sourceFile) {
	        var nameText = baseName;
	        for (var i = 1; !ts.isFileLevelUniqueName(sourceFile, nameText); i++) {
	            nameText = baseName + "_" + i;
	        }
	        return nameText;
	    }
	    ts.getUniqueName = getUniqueName;
	    /**
	     * @return The index of the (only) reference to the extracted symbol.  We want the cursor
	     * to be on the reference, rather than the declaration, because it's closer to where the
	     * user was before extracting it.
	     */
	    /* @internal */
	    function getRenameLocation(edits, renameFilename, name, preferLastLocation) {
	        var delta = 0;
	        var lastPos = -1;
	        for (var _i = 0, edits_1 = edits; _i < edits_1.length; _i++) {
	            var _a = edits_1[_i], fileName = _a.fileName, textChanges_2 = _a.textChanges;
	            ts.Debug.assert(fileName === renameFilename);
	            for (var _b = 0, textChanges_1 = textChanges_2; _b < textChanges_1.length; _b++) {
	                var change = textChanges_1[_b];
	                var span = change.span, newText = change.newText;
	                var index = indexInTextChange(newText, name);
	                if (index !== -1) {
	                    lastPos = span.start + delta + index;
	                    // If the reference comes first, return immediately.
	                    if (!preferLastLocation) {
	                        return lastPos;
	                    }
	                }
	                delta += newText.length - span.length;
	            }
	        }
	        // If the declaration comes first, return the position of the last occurrence.
	        ts.Debug.assert(preferLastLocation);
	        ts.Debug.assert(lastPos >= 0);
	        return lastPos;
	    }
	    ts.getRenameLocation = getRenameLocation;
	    function indexInTextChange(change, name) {
	        if (ts.startsWith(change, name))
	            return 0;
	        // Add a " " to avoid references inside words
	        var idx = change.indexOf(" " + name);
	        if (idx === -1)
	            idx = change.indexOf("." + name);
	        if (idx === -1)
	            idx = change.indexOf('"' + name);
	        return idx === -1 ? -1 : idx + 1;
	    }
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function createClassifier() {
	        var scanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false);
	        function getClassificationsForLine(text, lexState, syntacticClassifierAbsent) {
	            return convertClassificationsToResult(getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent), text);
	        }
	        // If there is a syntactic classifier ('syntacticClassifierAbsent' is false),
	        // we will be more conservative in order to avoid conflicting with the syntactic classifier.
	        function getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent) {
	            var token = 0 /* Unknown */;
	            var lastNonTriviaToken = 0 /* Unknown */;
	            // Just a stack of TemplateHeads and OpenCurlyBraces, used to perform rudimentary (inexact)
	            // classification on template strings. Because of the context free nature of templates,
	            // the only precise way to classify a template portion would be by propagating the stack across
	            // lines, just as we do with the end-of-line state. However, this is a burden for implementers,
	            // and the behavior is entirely subsumed by the syntactic classifier anyway, so we instead
	            // flatten any nesting when the template stack is non-empty and encode it in the end-of-line state.
	            // Situations in which this fails are
	            //  1) When template strings are nested across different lines:
	            //          `hello ${ `world
	            //          ` }`
	            //
	            //     Where on the second line, you will get the closing of a template,
	            //     a closing curly, and a new template.
	            //
	            //  2) When substitution expressions have curly braces and the curly brace falls on the next line:
	            //          `hello ${ () => {
	            //          return "world" } } `
	            //
	            //     Where on the second line, you will get the 'return' keyword,
	            //     a string literal, and a template end consisting of '} } `'.
	            var templateStack = [];
	            var _a = getPrefixFromLexState(lexState), prefix = _a.prefix, pushTemplate = _a.pushTemplate;
	            text = prefix + text;
	            var offset = prefix.length;
	            if (pushTemplate) {
	                templateStack.push(14 /* TemplateHead */);
	            }
	            scanner.setText(text);
	            var endOfLineState = 0 /* None */;
	            var spans = [];
	            // We can run into an unfortunate interaction between the lexical and syntactic classifier
	            // when the user is typing something generic.  Consider the case where the user types:
	            //
	            //      Foo<number
	            //
	            // From the lexical classifier's perspective, 'number' is a keyword, and so the word will
	            // be classified as such.  However, from the syntactic classifier's tree-based perspective
	            // this is simply an expression with the identifier 'number' on the RHS of the less than
	            // token.  So the classification will go back to being an identifier.  The moment the user
	            // types again, number will become a keyword, then an identifier, etc. etc.
	            //
	            // To try to avoid this problem, we avoid classifying contextual keywords as keywords
	            // when the user is potentially typing something generic.  We just can't do a good enough
	            // job at the lexical level, and so well leave it up to the syntactic classifier to make
	            // the determination.
	            //
	            // In order to determine if the user is potentially typing something generic, we use a
	            // weak heuristic where we track < and > tokens.  It's a weak heuristic, but should
	            // work well enough in practice.
	            var angleBracketStack = 0;
	            do {
	                token = scanner.scan();
	                if (!ts.isTrivia(token)) {
	                    handleToken();
	                    lastNonTriviaToken = token;
	                }
	                var end = scanner.getTextPos();
	                pushEncodedClassification(scanner.getTokenPos(), end, offset, classFromKind(token), spans);
	                if (end >= text.length) {
	                    var end_1 = getNewEndOfLineState(scanner, token, ts.lastOrUndefined(templateStack));
	                    if (end_1 !== undefined) {
	                        endOfLineState = end_1;
	                    }
	                }
	            } while (token !== 1 /* EndOfFileToken */);
	            function handleToken() {
	                switch (token) {
	                    case 41 /* SlashToken */:
	                    case 63 /* SlashEqualsToken */:
	                        if (!noRegexTable[lastNonTriviaToken] && scanner.reScanSlashToken() === 12 /* RegularExpressionLiteral */) {
	                            token = 12 /* RegularExpressionLiteral */;
	                        }
	                        break;
	                    case 27 /* LessThanToken */:
	                        if (lastNonTriviaToken === 71 /* Identifier */) {
	                            // Could be the start of something generic.  Keep track of that by bumping
	                            // up the current count of generic contexts we may be in.
	                            angleBracketStack++;
	                        }
	                        break;
	                    case 29 /* GreaterThanToken */:
	                        if (angleBracketStack > 0) {
	                            // If we think we're currently in something generic, then mark that that
	                            // generic entity is complete.
	                            angleBracketStack--;
	                        }
	                        break;
	                    case 119 /* AnyKeyword */:
	                    case 137 /* StringKeyword */:
	                    case 134 /* NumberKeyword */:
	                    case 122 /* BooleanKeyword */:
	                    case 138 /* SymbolKeyword */:
	                        if (angleBracketStack > 0 && !syntacticClassifierAbsent) {
	                            // If it looks like we're could be in something generic, don't classify this
	                            // as a keyword.  We may just get overwritten by the syntactic classifier,
	                            // causing a noisy experience for the user.
	                            token = 71 /* Identifier */;
	                        }
	                        break;
	                    case 14 /* TemplateHead */:
	                        templateStack.push(token);
	                        break;
	                    case 17 /* OpenBraceToken */:
	                        // If we don't have anything on the template stack,
	                        // then we aren't trying to keep track of a previously scanned template head.
	                        if (templateStack.length > 0) {
	                            templateStack.push(token);
	                        }
	                        break;
	                    case 18 /* CloseBraceToken */:
	                        // If we don't have anything on the template stack,
	                        // then we aren't trying to keep track of a previously scanned template head.
	                        if (templateStack.length > 0) {
	                            var lastTemplateStackToken = ts.lastOrUndefined(templateStack);
	                            if (lastTemplateStackToken === 14 /* TemplateHead */) {
	                                token = scanner.reScanTemplateToken();
	                                // Only pop on a TemplateTail; a TemplateMiddle indicates there is more for us.
	                                if (token === 16 /* TemplateTail */) {
	                                    templateStack.pop();
	                                }
	                                else {
	                                    ts.Debug.assertEqual(token, 15 /* TemplateMiddle */, "Should have been a template middle.");
	                                }
	                            }
	                            else {
	                                ts.Debug.assertEqual(lastTemplateStackToken, 17 /* OpenBraceToken */, "Should have been an open brace");
	                                templateStack.pop();
	                            }
	                        }
	                        break;
	                    default:
	                        if (!ts.isKeyword(token)) {
	                            break;
	                        }
	                        if (lastNonTriviaToken === 23 /* DotToken */) {
	                            token = 71 /* Identifier */;
	                        }
	                        else if (ts.isKeyword(lastNonTriviaToken) && ts.isKeyword(token) && !canFollow(lastNonTriviaToken, token)) {
	                            // We have two keywords in a row.  Only treat the second as a keyword if
	                            // it's a sequence that could legally occur in the language.  Otherwise
	                            // treat it as an identifier.  This way, if someone writes "private var"
	                            // we recognize that 'var' is actually an identifier here.
	                            token = 71 /* Identifier */;
	                        }
	                }
	            }
	            return { endOfLineState: endOfLineState, spans: spans };
	        }
	        return { getClassificationsForLine: getClassificationsForLine, getEncodedLexicalClassifications: getEncodedLexicalClassifications };
	    }
	    ts.createClassifier = createClassifier;
	    /// We do not have a full parser support to know when we should parse a regex or not
	    /// If we consider every slash token to be a regex, we could be missing cases like "1/2/3", where
	    /// we have a series of divide operator. this list allows us to be more accurate by ruling out
	    /// locations where a regexp cannot exist.
	    var noRegexTable = ts.arrayToNumericMap([
	        71 /* Identifier */,
	        9 /* StringLiteral */,
	        8 /* NumericLiteral */,
	        12 /* RegularExpressionLiteral */,
	        99 /* ThisKeyword */,
	        43 /* PlusPlusToken */,
	        44 /* MinusMinusToken */,
	        20 /* CloseParenToken */,
	        22 /* CloseBracketToken */,
	        18 /* CloseBraceToken */,
	        101 /* TrueKeyword */,
	        86 /* FalseKeyword */,
	    ], function (token) { return token; }, function () { return true; });
	    function getNewEndOfLineState(scanner, token, lastOnTemplateStack) {
	        switch (token) {
	            case 9 /* StringLiteral */: {
	                // Check to see if we finished up on a multiline string literal.
	                if (!scanner.isUnterminated())
	                    return undefined;
	                var tokenText = scanner.getTokenText();
	                var lastCharIndex = tokenText.length - 1;
	                var numBackslashes = 0;
	                while (tokenText.charCodeAt(lastCharIndex - numBackslashes) === 92 /* backslash */) {
	                    numBackslashes++;
	                }
	                // If we have an odd number of backslashes, then the multiline string is unclosed
	                if ((numBackslashes & 1) === 0)
	                    return undefined;
	                return tokenText.charCodeAt(0) === 34 /* doubleQuote */ ? 3 /* InDoubleQuoteStringLiteral */ : 2 /* InSingleQuoteStringLiteral */;
	            }
	            case 3 /* MultiLineCommentTrivia */:
	                // Check to see if the multiline comment was unclosed.
	                return scanner.isUnterminated() ? 1 /* InMultiLineCommentTrivia */ : undefined;
	            default:
	                if (ts.isTemplateLiteralKind(token)) {
	                    if (!scanner.isUnterminated()) {
	                        return undefined;
	                    }
	                    switch (token) {
	                        case 16 /* TemplateTail */:
	                            return 5 /* InTemplateMiddleOrTail */;
	                        case 13 /* NoSubstitutionTemplateLiteral */:
	                            return 4 /* InTemplateHeadOrNoSubstitutionTemplate */;
	                        default:
	                            return ts.Debug.fail("Only 'NoSubstitutionTemplateLiteral's and 'TemplateTail's can be unterminated; got SyntaxKind #" + token);
	                    }
	                }
	                return lastOnTemplateStack === 14 /* TemplateHead */ ? 6 /* InTemplateSubstitutionPosition */ : undefined;
	        }
	    }
	    function pushEncodedClassification(start, end, offset, classification, result) {
	        if (classification === 8 /* whiteSpace */) {
	            // Don't bother with whitespace classifications.  They're not needed.
	            return;
	        }
	        if (start === 0 && offset > 0) {
	            // We're classifying the first token, and this was a case where we prepended text.
	            // We should consider the start of this token to be at the start of the original text.
	            start += offset;
	        }
	        var length = end - start;
	        if (length > 0) {
	            // All our tokens are in relation to the augmented text.  Move them back to be
	            // relative to the original text.
	            result.push(start - offset, length, classification);
	        }
	    }
	    function convertClassificationsToResult(classifications, text) {
	        var entries = [];
	        var dense = classifications.spans;
	        var lastEnd = 0;
	        for (var i = 0; i < dense.length; i += 3) {
	            var start = dense[i];
	            var length_5 = dense[i + 1];
	            var type = dense[i + 2];
	            // Make a whitespace entry between the last item and this one.
	            if (lastEnd >= 0) {
	                var whitespaceLength_1 = start - lastEnd;
	                if (whitespaceLength_1 > 0) {
	                    entries.push({ length: whitespaceLength_1, classification: ts.TokenClass.Whitespace });
	                }
	            }
	            entries.push({ length: length_5, classification: convertClassification(type) });
	            lastEnd = start + length_5;
	        }
	        var whitespaceLength = text.length - lastEnd;
	        if (whitespaceLength > 0) {
	            entries.push({ length: whitespaceLength, classification: ts.TokenClass.Whitespace });
	        }
	        return { entries: entries, finalLexState: classifications.endOfLineState };
	    }
	    function convertClassification(type) {
	        switch (type) {
	            case 1 /* comment */: return ts.TokenClass.Comment;
	            case 3 /* keyword */: return ts.TokenClass.Keyword;
	            case 4 /* numericLiteral */: return ts.TokenClass.NumberLiteral;
	            case 5 /* operator */: return ts.TokenClass.Operator;
	            case 6 /* stringLiteral */: return ts.TokenClass.StringLiteral;
	            case 8 /* whiteSpace */: return ts.TokenClass.Whitespace;
	            case 10 /* punctuation */: return ts.TokenClass.Punctuation;
	            case 2 /* identifier */:
	            case 11 /* className */:
	            case 12 /* enumName */:
	            case 13 /* interfaceName */:
	            case 14 /* moduleName */:
	            case 15 /* typeParameterName */:
	            case 16 /* typeAliasName */:
	            case 9 /* text */:
	            case 17 /* parameterName */:
	                return ts.TokenClass.Identifier;
	        }
	    }
	    /** Returns true if 'keyword2' can legally follow 'keyword1' in any language construct. */
	    function canFollow(keyword1, keyword2) {
	        if (!ts.isAccessibilityModifier(keyword1)) {
	            // Assume any other keyword combination is legal.
	            // This can be refined in the future if there are more cases we want the classifier to be better at.
	            return true;
	        }
	        switch (keyword2) {
	            case 125 /* GetKeyword */:
	            case 136 /* SetKeyword */:
	            case 123 /* ConstructorKeyword */:
	            case 115 /* StaticKeyword */:
	                return true; // Allow things like "public get", "public constructor" and "public static".
	            default:
	                return false; // Any other keyword following "public" is actually an identifier, not a real keyword.
	        }
	    }
	    function getPrefixFromLexState(lexState) {
	        // If we're in a string literal, then prepend: "\
	        // (and a newline).  That way when we lex we'll think we're still in a string literal.
	        //
	        // If we're in a multiline comment, then prepend: /*
	        // (and a newline).  That way when we lex we'll think we're still in a multiline comment.
	        switch (lexState) {
	            case 3 /* InDoubleQuoteStringLiteral */:
	                return { prefix: "\"\\\n" };
	            case 2 /* InSingleQuoteStringLiteral */:
	                return { prefix: "'\\\n" };
	            case 1 /* InMultiLineCommentTrivia */:
	                return { prefix: "/*\n" };
	            case 4 /* InTemplateHeadOrNoSubstitutionTemplate */:
	                return { prefix: "`\n" };
	            case 5 /* InTemplateMiddleOrTail */:
	                return { prefix: "}\n", pushTemplate: true };
	            case 6 /* InTemplateSubstitutionPosition */:
	                return { prefix: "", pushTemplate: true };
	            case 0 /* None */:
	                return { prefix: "" };
	            default:
	                return ts.Debug.assertNever(lexState);
	        }
	    }
	    function isBinaryExpressionOperatorToken(token) {
	        switch (token) {
	            case 39 /* AsteriskToken */:
	            case 41 /* SlashToken */:
	            case 42 /* PercentToken */:
	            case 37 /* PlusToken */:
	            case 38 /* MinusToken */:
	            case 45 /* LessThanLessThanToken */:
	            case 46 /* GreaterThanGreaterThanToken */:
	            case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	            case 27 /* LessThanToken */:
	            case 29 /* GreaterThanToken */:
	            case 30 /* LessThanEqualsToken */:
	            case 31 /* GreaterThanEqualsToken */:
	            case 93 /* InstanceOfKeyword */:
	            case 92 /* InKeyword */:
	            case 118 /* AsKeyword */:
	            case 32 /* EqualsEqualsToken */:
	            case 33 /* ExclamationEqualsToken */:
	            case 34 /* EqualsEqualsEqualsToken */:
	            case 35 /* ExclamationEqualsEqualsToken */:
	            case 48 /* AmpersandToken */:
	            case 50 /* CaretToken */:
	            case 49 /* BarToken */:
	            case 53 /* AmpersandAmpersandToken */:
	            case 54 /* BarBarToken */:
	            case 69 /* BarEqualsToken */:
	            case 68 /* AmpersandEqualsToken */:
	            case 70 /* CaretEqualsToken */:
	            case 65 /* LessThanLessThanEqualsToken */:
	            case 66 /* GreaterThanGreaterThanEqualsToken */:
	            case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	            case 59 /* PlusEqualsToken */:
	            case 60 /* MinusEqualsToken */:
	            case 61 /* AsteriskEqualsToken */:
	            case 63 /* SlashEqualsToken */:
	            case 64 /* PercentEqualsToken */:
	            case 58 /* EqualsToken */:
	            case 26 /* CommaToken */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    function isPrefixUnaryExpressionOperatorToken(token) {
	        switch (token) {
	            case 37 /* PlusToken */:
	            case 38 /* MinusToken */:
	            case 52 /* TildeToken */:
	            case 51 /* ExclamationToken */:
	            case 43 /* PlusPlusToken */:
	            case 44 /* MinusMinusToken */:
	                return true;
	            default:
	                return false;
	        }
	    }
	    function classFromKind(token) {
	        if (ts.isKeyword(token)) {
	            return 3 /* keyword */;
	        }
	        else if (isBinaryExpressionOperatorToken(token) || isPrefixUnaryExpressionOperatorToken(token)) {
	            return 5 /* operator */;
	        }
	        else if (token >= 17 /* FirstPunctuation */ && token <= 70 /* LastPunctuation */) {
	            return 10 /* punctuation */;
	        }
	        switch (token) {
	            case 8 /* NumericLiteral */:
	                return 4 /* numericLiteral */;
	            case 9 /* StringLiteral */:
	                return 6 /* stringLiteral */;
	            case 12 /* RegularExpressionLiteral */:
	                return 7 /* regularExpressionLiteral */;
	            case 7 /* ConflictMarkerTrivia */:
	            case 3 /* MultiLineCommentTrivia */:
	            case 2 /* SingleLineCommentTrivia */:
	                return 1 /* comment */;
	            case 5 /* WhitespaceTrivia */:
	            case 4 /* NewLineTrivia */:
	                return 8 /* whiteSpace */;
	            case 71 /* Identifier */:
	            default:
	                if (ts.isTemplateLiteralKind(token)) {
	                    return 6 /* stringLiteral */;
	                }
	                return 2 /* identifier */;
	        }
	    }
	    /* @internal */
	    function getSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
	        return convertClassificationsToSpans(getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span));
	    }
	    ts.getSemanticClassifications = getSemanticClassifications;
	    function checkForClassificationCancellation(cancellationToken, kind) {
	        // We don't want to actually call back into our host on every node to find out if we've
	        // been canceled.  That would be an enormous amount of chattyness, along with the all
	        // the overhead of marshalling the data to/from the host.  So instead we pick a few
	        // reasonable node kinds to bother checking on.  These node kinds represent high level
	        // constructs that we would expect to see commonly, but just at a far less frequent
	        // interval.
	        //
	        // For example, in checker.ts (around 750k) we only have around 600 of these constructs.
	        // That means we're calling back into the host around every 1.2k of the file we process.
	        // Lib.d.ts has similar numbers.
	        switch (kind) {
	            case 238 /* ModuleDeclaration */:
	            case 234 /* ClassDeclaration */:
	            case 235 /* InterfaceDeclaration */:
	            case 233 /* FunctionDeclaration */:
	                cancellationToken.throwIfCancellationRequested();
	        }
	    }
	    /* @internal */
	    function getEncodedSemanticClassifications(typeChecker, cancellationToken, sourceFile, classifiableNames, span) {
	        var spans = [];
	        sourceFile.forEachChild(function cb(node) {
	            // Only walk into nodes that intersect the requested span.
	            if (!node || !ts.textSpanIntersectsWith(span, node.pos, node.getFullWidth())) {
	                return;
	            }
	            checkForClassificationCancellation(cancellationToken, node.kind);
	            // Only bother calling into the typechecker if this is an identifier that
	            // could possibly resolve to a type name.  This makes classification run
	            // in a third of the time it would normally take.
	            if (ts.isIdentifier(node) && !ts.nodeIsMissing(node) && classifiableNames.has(node.escapedText)) {
	                var symbol = typeChecker.getSymbolAtLocation(node);
	                var type = symbol && classifySymbol(symbol, ts.getMeaningFromLocation(node), typeChecker);
	                if (type) {
	                    pushClassification(node.getStart(sourceFile), node.getEnd(), type);
	                }
	            }
	            node.forEachChild(cb);
	        });
	        return { spans: spans, endOfLineState: 0 /* None */ };
	        function pushClassification(start, end, type) {
	            spans.push(start);
	            spans.push(end - start);
	            spans.push(type);
	        }
	    }
	    ts.getEncodedSemanticClassifications = getEncodedSemanticClassifications;
	    function classifySymbol(symbol, meaningAtPosition, checker) {
	        var flags = symbol.getFlags();
	        if ((flags & 2885600 /* Classifiable */) === 0 /* None */) {
	            return undefined;
	        }
	        else if (flags & 32 /* Class */) {
	            return 11 /* className */;
	        }
	        else if (flags & 384 /* Enum */) {
	            return 12 /* enumName */;
	        }
	        else if (flags & 524288 /* TypeAlias */) {
	            return 16 /* typeAliasName */;
	        }
	        else if (flags & 1536 /* Module */) {
	            // Only classify a module as such if
	            //  - It appears in a namespace context.
	            //  - There exists a module declaration which actually impacts the value side.
	            return meaningAtPosition & 4 /* Namespace */ || meaningAtPosition & 1 /* Value */ && hasValueSideModule(symbol) ? 14 /* moduleName */ : undefined;
	        }
	        else if (flags & 2097152 /* Alias */) {
	            return classifySymbol(checker.getAliasedSymbol(symbol), meaningAtPosition, checker);
	        }
	        else if (meaningAtPosition & 2 /* Type */) {
	            return flags & 64 /* Interface */ ? 13 /* interfaceName */ : flags & 262144 /* TypeParameter */ ? 15 /* typeParameterName */ : undefined;
	        }
	        else {
	            return undefined;
	        }
	    }
	    /** Returns true if there exists a module that introduces entities on the value side. */
	    function hasValueSideModule(symbol) {
	        return ts.some(symbol.declarations, function (declaration) {
	            return ts.isModuleDeclaration(declaration) && ts.getModuleInstanceState(declaration) === 1 /* Instantiated */;
	        });
	    }
	    function getClassificationTypeName(type) {
	        switch (type) {
	            case 1 /* comment */: return "comment" /* comment */;
	            case 2 /* identifier */: return "identifier" /* identifier */;
	            case 3 /* keyword */: return "keyword" /* keyword */;
	            case 4 /* numericLiteral */: return "number" /* numericLiteral */;
	            case 5 /* operator */: return "operator" /* operator */;
	            case 6 /* stringLiteral */: return "string" /* stringLiteral */;
	            case 8 /* whiteSpace */: return "whitespace" /* whiteSpace */;
	            case 9 /* text */: return "text" /* text */;
	            case 10 /* punctuation */: return "punctuation" /* punctuation */;
	            case 11 /* className */: return "class name" /* className */;
	            case 12 /* enumName */: return "enum name" /* enumName */;
	            case 13 /* interfaceName */: return "interface name" /* interfaceName */;
	            case 14 /* moduleName */: return "module name" /* moduleName */;
	            case 15 /* typeParameterName */: return "type parameter name" /* typeParameterName */;
	            case 16 /* typeAliasName */: return "type alias name" /* typeAliasName */;
	            case 17 /* parameterName */: return "parameter name" /* parameterName */;
	            case 18 /* docCommentTagName */: return "doc comment tag name" /* docCommentTagName */;
	            case 19 /* jsxOpenTagName */: return "jsx open tag name" /* jsxOpenTagName */;
	            case 20 /* jsxCloseTagName */: return "jsx close tag name" /* jsxCloseTagName */;
	            case 21 /* jsxSelfClosingTagName */: return "jsx self closing tag name" /* jsxSelfClosingTagName */;
	            case 22 /* jsxAttribute */: return "jsx attribute" /* jsxAttribute */;
	            case 23 /* jsxText */: return "jsx text" /* jsxText */;
	            case 24 /* jsxAttributeStringLiteralValue */: return "jsx attribute string literal value" /* jsxAttributeStringLiteralValue */;
	        }
	    }
	    function convertClassificationsToSpans(classifications) {
	        ts.Debug.assert(classifications.spans.length % 3 === 0);
	        var dense = classifications.spans;
	        var result = [];
	        for (var i = 0; i < dense.length; i += 3) {
	            result.push({
	                textSpan: ts.createTextSpan(dense[i], dense[i + 1]),
	                classificationType: getClassificationTypeName(dense[i + 2])
	            });
	        }
	        return result;
	    }
	    /* @internal */
	    function getSyntacticClassifications(cancellationToken, sourceFile, span) {
	        return convertClassificationsToSpans(getEncodedSyntacticClassifications(cancellationToken, sourceFile, span));
	    }
	    ts.getSyntacticClassifications = getSyntacticClassifications;
	    /* @internal */
	    function getEncodedSyntacticClassifications(cancellationToken, sourceFile, span) {
	        var spanStart = span.start;
	        var spanLength = span.length;
	        // Make a scanner we can get trivia from.
	        var triviaScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
	        var mergeConflictScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, sourceFile.languageVariant, sourceFile.text);
	        var result = [];
	        processElement(sourceFile);
	        return { spans: result, endOfLineState: 0 /* None */ };
	        function pushClassification(start, length, type) {
	            result.push(start);
	            result.push(length);
	            result.push(type);
	        }
	        function classifyLeadingTriviaAndGetTokenStart(token) {
	            triviaScanner.setTextPos(token.pos);
	            while (true) {
	                var start = triviaScanner.getTextPos();
	                // only bother scanning if we have something that could be trivia.
	                if (!ts.couldStartTrivia(sourceFile.text, start)) {
	                    return start;
	                }
	                var kind = triviaScanner.scan();
	                var end = triviaScanner.getTextPos();
	                var width = end - start;
	                // The moment we get something that isn't trivia, then stop processing.
	                if (!ts.isTrivia(kind)) {
	                    return start;
	                }
	                switch (kind) {
	                    case 4 /* NewLineTrivia */:
	                    case 5 /* WhitespaceTrivia */:
	                        // Don't bother with newlines/whitespace.
	                        continue;
	                    case 2 /* SingleLineCommentTrivia */:
	                    case 3 /* MultiLineCommentTrivia */:
	                        // Only bother with the trivia if it at least intersects the span of interest.
	                        classifyComment(token, kind, start, width);
	                        // Classifying a comment might cause us to reuse the trivia scanner
	                        // (because of jsdoc comments).  So after we classify the comment make
	                        // sure we set the scanner position back to where it needs to be.
	                        triviaScanner.setTextPos(end);
	                        continue;
	                    case 7 /* ConflictMarkerTrivia */:
	                        var text = sourceFile.text;
	                        var ch = text.charCodeAt(start);
	                        // for the <<<<<<< and >>>>>>> markers, we just add them in as comments
	                        // in the classification stream.
	                        if (ch === 60 /* lessThan */ || ch === 62 /* greaterThan */) {
	                            pushClassification(start, width, 1 /* comment */);
	                            continue;
	                        }
	                        // for the ||||||| and ======== markers, add a comment for the first line,
	                        // and then lex all subsequent lines up until the end of the conflict marker.
	                        ts.Debug.assert(ch === 124 /* bar */ || ch === 61 /* equals */);
	                        classifyDisabledMergeCode(text, start, end);
	                        break;
	                    case 6 /* ShebangTrivia */:
	                        // TODO: Maybe we should classify these.
	                        break;
	                    default:
	                        ts.Debug.assertNever(kind);
	                }
	            }
	        }
	        function classifyComment(token, kind, start, width) {
	            if (kind === 3 /* MultiLineCommentTrivia */) {
	                // See if this is a doc comment.  If so, we'll classify certain portions of it
	                // specially.
	                var docCommentAndDiagnostics = ts.parseIsolatedJSDocComment(sourceFile.text, start, width);
	                if (docCommentAndDiagnostics && docCommentAndDiagnostics.jsDoc) {
	                    // TODO: This should be predicated on `token["kind"]` being compatible with `HasJSDoc["kind"]`
	                    docCommentAndDiagnostics.jsDoc.parent = token;
	                    classifyJSDocComment(docCommentAndDiagnostics.jsDoc);
	                    return;
	                }
	            }
	            // Simple comment.  Just add as is.
	            pushCommentRange(start, width);
	        }
	        function pushCommentRange(start, width) {
	            pushClassification(start, width, 1 /* comment */);
	        }
	        function classifyJSDocComment(docComment) {
	            var pos = docComment.pos;
	            if (docComment.tags) {
	                for (var _i = 0, _a = docComment.tags; _i < _a.length; _i++) {
	                    var tag = _a[_i];
	                    // As we walk through each tag, classify the portion of text from the end of
	                    // the last tag (or the start of the entire doc comment) as 'comment'.
	                    if (tag.pos !== pos) {
	                        pushCommentRange(pos, tag.pos - pos);
	                    }
	                    pushClassification(tag.atToken.pos, tag.atToken.end - tag.atToken.pos, 10 /* punctuation */); // "@"
	                    pushClassification(tag.tagName.pos, tag.tagName.end - tag.tagName.pos, 18 /* docCommentTagName */); // e.g. "param"
	                    pos = tag.tagName.end;
	                    switch (tag.kind) {
	                        case 292 /* JSDocParameterTag */:
	                            processJSDocParameterTag(tag);
	                            break;
	                        case 295 /* JSDocTemplateTag */:
	                            processJSDocTemplateTag(tag);
	                            pos = tag.end;
	                            break;
	                        case 294 /* JSDocTypeTag */:
	                            processElement(tag.typeExpression);
	                            pos = tag.end;
	                            break;
	                        case 293 /* JSDocReturnTag */:
	                            processElement(tag.typeExpression);
	                            pos = tag.end;
	                            break;
	                    }
	                }
	            }
	            if (pos !== docComment.end) {
	                pushCommentRange(pos, docComment.end - pos);
	            }
	            return;
	            function processJSDocParameterTag(tag) {
	                if (tag.isNameFirst) {
	                    pushCommentRange(pos, tag.name.pos - pos);
	                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */);
	                    pos = tag.name.end;
	                }
	                if (tag.typeExpression) {
	                    pushCommentRange(pos, tag.typeExpression.pos - pos);
	                    processElement(tag.typeExpression);
	                    pos = tag.typeExpression.end;
	                }
	                if (!tag.isNameFirst) {
	                    pushCommentRange(pos, tag.name.pos - pos);
	                    pushClassification(tag.name.pos, tag.name.end - tag.name.pos, 17 /* parameterName */);
	                    pos = tag.name.end;
	                }
	            }
	        }
	        function processJSDocTemplateTag(tag) {
	            for (var _i = 0, _a = tag.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                processElement(child);
	            }
	        }
	        function classifyDisabledMergeCode(text, start, end) {
	            // Classify the line that the ||||||| or ======= marker is on as a comment.
	            // Then just lex all further tokens and add them to the result.
	            var i;
	            for (i = start; i < end; i++) {
	                if (ts.isLineBreak(text.charCodeAt(i))) {
	                    break;
	                }
	            }
	            pushClassification(start, i - start, 1 /* comment */);
	            mergeConflictScanner.setTextPos(i);
	            while (mergeConflictScanner.getTextPos() < end) {
	                classifyDisabledCodeToken();
	            }
	        }
	        function classifyDisabledCodeToken() {
	            var start = mergeConflictScanner.getTextPos();
	            var tokenKind = mergeConflictScanner.scan();
	            var end = mergeConflictScanner.getTextPos();
	            var type = classifyTokenType(tokenKind);
	            if (type) {
	                pushClassification(start, end - start, type);
	            }
	        }
	        /**
	         * Returns true if node should be treated as classified and no further processing is required.
	         * False will mean that node is not classified and traverse routine should recurse into node contents.
	         */
	        function tryClassifyNode(node) {
	            if (ts.isJSDoc(node)) {
	                return true;
	            }
	            if (ts.nodeIsMissing(node)) {
	                return true;
	            }
	            var classifiedElementName = tryClassifyJsxElementName(node);
	            if (!ts.isToken(node) && node.kind !== 10 /* JsxText */ && classifiedElementName === undefined) {
	                return false;
	            }
	            var tokenStart = node.kind === 10 /* JsxText */ ? node.pos : classifyLeadingTriviaAndGetTokenStart(node);
	            var tokenWidth = node.end - tokenStart;
	            ts.Debug.assert(tokenWidth >= 0);
	            if (tokenWidth > 0) {
	                var type = classifiedElementName || classifyTokenType(node.kind, node);
	                if (type) {
	                    pushClassification(tokenStart, tokenWidth, type);
	                }
	            }
	            return true;
	        }
	        function tryClassifyJsxElementName(token) {
	            switch (token.parent && token.parent.kind) {
	                case 256 /* JsxOpeningElement */:
	                    if (token.parent.tagName === token) {
	                        return 19 /* jsxOpenTagName */;
	                    }
	                    break;
	                case 257 /* JsxClosingElement */:
	                    if (token.parent.tagName === token) {
	                        return 20 /* jsxCloseTagName */;
	                    }
	                    break;
	                case 255 /* JsxSelfClosingElement */:
	                    if (token.parent.tagName === token) {
	                        return 21 /* jsxSelfClosingTagName */;
	                    }
	                    break;
	                case 261 /* JsxAttribute */:
	                    if (token.parent.name === token) {
	                        return 22 /* jsxAttribute */;
	                    }
	                    break;
	            }
	            return undefined;
	        }
	        // for accurate classification, the actual token should be passed in.  however, for
	        // cases like 'disabled merge code' classification, we just get the token kind and
	        // classify based on that instead.
	        function classifyTokenType(tokenKind, token) {
	            if (ts.isKeyword(tokenKind)) {
	                return 3 /* keyword */;
	            }
	            // Special case `<` and `>`: If they appear in a generic context they are punctuation,
	            // not operators.
	            if (tokenKind === 27 /* LessThanToken */ || tokenKind === 29 /* GreaterThanToken */) {
	                // If the node owning the token has a type argument list or type parameter list, then
	                // we can effectively assume that a '<' and '>' belong to those lists.
	                if (token && ts.getTypeArgumentOrTypeParameterList(token.parent)) {
	                    return 10 /* punctuation */;
	                }
	            }
	            if (ts.isPunctuation(tokenKind)) {
	                if (token) {
	                    if (tokenKind === 58 /* EqualsToken */) {
	                        // the '=' in a variable declaration is special cased here.
	                        if (token.parent.kind === 231 /* VariableDeclaration */ ||
	                            token.parent.kind === 151 /* PropertyDeclaration */ ||
	                            token.parent.kind === 148 /* Parameter */ ||
	                            token.parent.kind === 261 /* JsxAttribute */) {
	                            return 5 /* operator */;
	                        }
	                    }
	                    if (token.parent.kind === 199 /* BinaryExpression */ ||
	                        token.parent.kind === 197 /* PrefixUnaryExpression */ ||
	                        token.parent.kind === 198 /* PostfixUnaryExpression */ ||
	                        token.parent.kind === 200 /* ConditionalExpression */) {
	                        return 5 /* operator */;
	                    }
	                }
	                return 10 /* punctuation */;
	            }
	            else if (tokenKind === 8 /* NumericLiteral */) {
	                return 4 /* numericLiteral */;
	            }
	            else if (tokenKind === 9 /* StringLiteral */) {
	                return token.parent.kind === 261 /* JsxAttribute */ ? 24 /* jsxAttributeStringLiteralValue */ : 6 /* stringLiteral */;
	            }
	            else if (tokenKind === 12 /* RegularExpressionLiteral */) {
	                // TODO: we should get another classification type for these literals.
	                return 6 /* stringLiteral */;
	            }
	            else if (ts.isTemplateLiteralKind(tokenKind)) {
	                // TODO (drosen): we should *also* get another classification type for these literals.
	                return 6 /* stringLiteral */;
	            }
	            else if (tokenKind === 10 /* JsxText */) {
	                return 23 /* jsxText */;
	            }
	            else if (tokenKind === 71 /* Identifier */) {
	                if (token) {
	                    switch (token.parent.kind) {
	                        case 234 /* ClassDeclaration */:
	                            if (token.parent.name === token) {
	                                return 11 /* className */;
	                            }
	                            return;
	                        case 147 /* TypeParameter */:
	                            if (token.parent.name === token) {
	                                return 15 /* typeParameterName */;
	                            }
	                            return;
	                        case 235 /* InterfaceDeclaration */:
	                            if (token.parent.name === token) {
	                                return 13 /* interfaceName */;
	                            }
	                            return;
	                        case 237 /* EnumDeclaration */:
	                            if (token.parent.name === token) {
	                                return 12 /* enumName */;
	                            }
	                            return;
	                        case 238 /* ModuleDeclaration */:
	                            if (token.parent.name === token) {
	                                return 14 /* moduleName */;
	                            }
	                            return;
	                        case 148 /* Parameter */:
	                            if (token.parent.name === token) {
	                                return ts.isThisIdentifier(token) ? 3 /* keyword */ : 17 /* parameterName */;
	                            }
	                            return;
	                    }
	                }
	                return 2 /* identifier */;
	            }
	        }
	        function processElement(element) {
	            if (!element) {
	                return;
	            }
	            // Ignore nodes that don't intersect the original span to classify.
	            if (ts.decodedTextSpanIntersectsWith(spanStart, spanLength, element.pos, element.getFullWidth())) {
	                checkForClassificationCancellation(cancellationToken, element.kind);
	                for (var _i = 0, _a = element.getChildren(sourceFile); _i < _a.length; _i++) {
	                    var child = _a[_i];
	                    if (!tryClassifyNode(child)) {
	                        // Recurse into our child nodes.
	                        processElement(child);
	                    }
	                }
	            }
	        }
	    }
	    ts.getEncodedSyntacticClassifications = getEncodedSyntacticClassifications;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var Completions;
	    (function (Completions) {
	        var PathCompletions;
	        (function (PathCompletions) {
	            function nameAndKind(name, kind) {
	                return { name: name, kind: kind };
	            }
	            function addReplacementSpans(text, textStart, names) {
	                var span = getDirectoryFragmentTextSpan(text, textStart);
	                return names.map(function (_a) {
	                    var name = _a.name, kind = _a.kind;
	                    return ({ name: name, kind: kind, span: span });
	                });
	            }
	            function getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker) {
	                return addReplacementSpans(node.text, node.getStart(sourceFile) + 1, getStringLiteralCompletionsFromModuleNamesWorker(node, compilerOptions, host, typeChecker));
	            }
	            PathCompletions.getStringLiteralCompletionsFromModuleNames = getStringLiteralCompletionsFromModuleNames;
	            function getStringLiteralCompletionsFromModuleNamesWorker(node, compilerOptions, host, typeChecker) {
	                var literalValue = ts.normalizeSlashes(node.text);
	                var scriptPath = node.getSourceFile().path;
	                var scriptDirectory = ts.getDirectoryPath(scriptPath);
	                if (isPathRelativeToScript(literalValue) || ts.isRootedDiskPath(literalValue)) {
	                    var extensions = getSupportedExtensionsForModuleResolution(compilerOptions);
	                    if (compilerOptions.rootDirs) {
	                        return getCompletionEntriesForDirectoryFragmentWithRootDirs(compilerOptions.rootDirs, literalValue, scriptDirectory, extensions, /*includeExtensions*/ false, compilerOptions, host, scriptPath);
	                    }
	                    else {
	                        return getCompletionEntriesForDirectoryFragment(literalValue, scriptDirectory, extensions, /*includeExtensions*/ false, host, scriptPath);
	                    }
	                }
	                else {
	                    // Check for node modules
	                    return getCompletionEntriesForNonRelativeModules(literalValue, scriptDirectory, compilerOptions, host, typeChecker);
	                }
	            }
	            function getSupportedExtensionsForModuleResolution(compilerOptions) {
	                var extensions = ts.getSupportedExtensions(compilerOptions);
	                return compilerOptions.resolveJsonModule && ts.getEmitModuleResolutionKind(compilerOptions) === ts.ModuleResolutionKind.NodeJs ?
	                    extensions.concat(".json" /* Json */) :
	                    extensions;
	            }
	            /**
	             * Takes a script path and returns paths for all potential folders that could be merged with its
	             * containing folder via the "rootDirs" compiler option
	             */
	            function getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptPath, ignoreCase) {
	                // Make all paths absolute/normalized if they are not already
	                rootDirs = rootDirs.map(function (rootDirectory) { return ts.normalizePath(ts.isRootedDiskPath(rootDirectory) ? rootDirectory : ts.combinePaths(basePath, rootDirectory)); });
	                // Determine the path to the directory containing the script relative to the root directory it is contained within
	                var relativeDirectory = ts.firstDefined(rootDirs, function (rootDirectory) {
	                    return ts.containsPath(rootDirectory, scriptPath, basePath, ignoreCase) ? scriptPath.substr(rootDirectory.length) : undefined;
	                });
	                // Now find a path for each potential directory that is to be merged with the one containing the script
	                return ts.deduplicate(rootDirs.map(function (rootDirectory) { return ts.combinePaths(rootDirectory, relativeDirectory); }), ts.equateStringsCaseSensitive, ts.compareStringsCaseSensitive);
	            }
	            function getCompletionEntriesForDirectoryFragmentWithRootDirs(rootDirs, fragment, scriptPath, extensions, includeExtensions, compilerOptions, host, exclude) {
	                var basePath = compilerOptions.project || host.getCurrentDirectory();
	                var ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
	                var baseDirectories = getBaseDirectoriesFromRootDirs(rootDirs, basePath, scriptPath, ignoreCase);
	                var result = [];
	                for (var _i = 0, baseDirectories_1 = baseDirectories; _i < baseDirectories_1.length; _i++) {
	                    var baseDirectory = baseDirectories_1[_i];
	                    getCompletionEntriesForDirectoryFragment(fragment, baseDirectory, extensions, includeExtensions, host, exclude, result);
	                }
	                return result;
	            }
	            /**
	             * Given a path ending at a directory, gets the completions for the path, and filters for those entries containing the basename.
	             */
	            function getCompletionEntriesForDirectoryFragment(fragment, scriptPath, extensions, includeExtensions, host, exclude, result) {
	                if (result === void 0) { result = []; }
	                if (fragment === undefined) {
	                    fragment = "";
	                }
	                fragment = ts.normalizeSlashes(fragment);
	                /**
	                 * Remove the basename from the path. Note that we don't use the basename to filter completions;
	                 * the client is responsible for refining completions.
	                 */
	                if (!ts.hasTrailingDirectorySeparator(fragment)) {
	                    fragment = ts.getDirectoryPath(fragment);
	                }
	                if (fragment === "") {
	                    fragment = "." + ts.directorySeparator;
	                }
	                fragment = ts.ensureTrailingDirectorySeparator(fragment);
	                // const absolutePath = normalizeAndPreserveTrailingSlash(isRootedDiskPath(fragment) ? fragment : combinePaths(scriptPath, fragment)); // TODO(rbuckton): should use resolvePaths
	                var absolutePath = ts.resolvePath(scriptPath, fragment);
	                var baseDirectory = ts.hasTrailingDirectorySeparator(absolutePath) ? absolutePath : ts.getDirectoryPath(absolutePath);
	                var ignoreCase = !(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames());
	                if (tryDirectoryExists(host, baseDirectory)) {
	                    // Enumerate the available files if possible
	                    var files = tryReadDirectory(host, baseDirectory, extensions, /*exclude*/ undefined, /*include*/ ["./*"]);
	                    if (files) {
	                        /**
	                         * Multiple file entries might map to the same truncated name once we remove extensions
	                         * (happens iff includeExtensions === false)so we use a set-like data structure. Eg:
	                         *
	                         * both foo.ts and foo.tsx become foo
	                         */
	                        var foundFiles = ts.createMap();
	                        for (var _i = 0, files_3 = files; _i < files_3.length; _i++) {
	                            var filePath = files_3[_i];
	                            filePath = ts.normalizePath(filePath);
	                            if (exclude && ts.comparePaths(filePath, exclude, scriptPath, ignoreCase) === 0 /* EqualTo */) {
	                                continue;
	                            }
	                            var foundFileName = includeExtensions || ts.fileExtensionIs(filePath, ".json" /* Json */) ? ts.getBaseFileName(filePath) : ts.removeFileExtension(ts.getBaseFileName(filePath));
	                            if (!foundFiles.has(foundFileName)) {
	                                foundFiles.set(foundFileName, true);
	                            }
	                        }
	                        ts.forEachKey(foundFiles, function (foundFile) {
	                            result.push(nameAndKind(foundFile, "script" /* scriptElement */));
	                        });
	                    }
	                    // If possible, get folder completion as well
	                    var directories = tryGetDirectories(host, baseDirectory);
	                    if (directories) {
	                        for (var _a = 0, directories_1 = directories; _a < directories_1.length; _a++) {
	                            var directory_2 = directories_1[_a];
	                            var directoryName = ts.getBaseFileName(ts.normalizePath(directory_2));
	                            if (directoryName !== "@types") {
	                                result.push(nameAndKind(directoryName, "directory" /* directory */));
	                            }
	                        }
	                    }
	                }
	                return result;
	            }
	            /**
	             * Check all of the declared modules and those in node modules. Possible sources of modules:
	             *      Modules that are found by the type checker
	             *      Modules found relative to "baseUrl" compliler options (including patterns from "paths" compiler option)
	             *      Modules from node_modules (i.e. those listed in package.json)
	             *          This includes all files that are found in node_modules/moduleName/ with acceptable file extensions
	             */
	            function getCompletionEntriesForNonRelativeModules(fragment, scriptPath, compilerOptions, host, typeChecker) {
	                var baseUrl = compilerOptions.baseUrl, paths = compilerOptions.paths;
	                var result = [];
	                var fileExtensions = getSupportedExtensionsForModuleResolution(compilerOptions);
	                if (baseUrl) {
	                    var projectDir = compilerOptions.project || host.getCurrentDirectory();
	                    var absolute = ts.isRootedDiskPath(baseUrl) ? baseUrl : ts.combinePaths(projectDir, baseUrl);
	                    getCompletionEntriesForDirectoryFragment(fragment, ts.normalizePath(absolute), fileExtensions, /*includeExtensions*/ false, host, /*exclude*/ undefined, result);
	                    for (var path in paths) {
	                        var patterns = paths[path];
	                        if (paths.hasOwnProperty(path) && patterns) {
	                            var _loop_12 = function (name, kind) {
	                                // Path mappings may provide a duplicate way to get to something we've already added, so don't add again.
	                                if (!result.some(function (entry) { return entry.name === name; })) {
	                                    result.push(nameAndKind(name, kind));
	                                }
	                            };
	                            for (var _i = 0, _a = getCompletionsForPathMapping(path, patterns, fragment, baseUrl, fileExtensions, host); _i < _a.length; _i++) {
	                                var _b = _a[_i], name = _b.name, kind = _b.kind;
	                                _loop_12(name, kind);
	                            }
	                        }
	                    }
	                }
	                var fragmentDirectory = containsSlash(fragment) ? ts.hasTrailingDirectorySeparator(fragment) ? fragment : ts.getDirectoryPath(fragment) : undefined;
	                for (var _c = 0, _d = getAmbientModuleCompletions(fragment, fragmentDirectory, typeChecker); _c < _d.length; _c++) {
	                    var ambientName = _d[_c];
	                    result.push(nameAndKind(ambientName, "external module name" /* externalModuleName */));
	                }
	                getCompletionEntriesFromTypings(host, compilerOptions, scriptPath, result);
	                if (ts.getEmitModuleResolutionKind(compilerOptions) === ts.ModuleResolutionKind.NodeJs) {
	                    // If looking for a global package name, don't just include everything in `node_modules` because that includes dependencies' own dependencies.
	                    // (But do if we didn't find anything, e.g. 'package.json' missing.)
	                    var foundGlobal = false;
	                    if (fragmentDirectory === undefined) {
	                        var _loop_13 = function (moduleName) {
	                            if (!result.some(function (entry) { return entry.name === moduleName; })) {
	                                foundGlobal = true;
	                                result.push(nameAndKind(moduleName, "external module name" /* externalModuleName */));
	                            }
	                        };
	                        for (var _e = 0, _f = enumerateNodeModulesVisibleToScript(host, scriptPath); _e < _f.length; _e++) {
	                            var moduleName = _f[_e];
	                            _loop_13(moduleName);
	                        }
	                    }
	                    if (!foundGlobal) {
	                        ts.forEachAncestorDirectory(scriptPath, function (ancestor) {
	                            var nodeModules = ts.combinePaths(ancestor, "node_modules");
	                            if (tryDirectoryExists(host, nodeModules)) {
	                                getCompletionEntriesForDirectoryFragment(fragment, nodeModules, fileExtensions, /*includeExtensions*/ false, host, /*exclude*/ undefined, result);
	                            }
	                        });
	                    }
	                }
	                return result;
	            }
	            function getCompletionsForPathMapping(path, patterns, fragment, baseUrl, fileExtensions, host) {
	                if (!ts.endsWith(path, "*")) {
	                    // For a path mapping "foo": ["/x/y/z.ts"], add "foo" itself as a completion.
	                    return !ts.stringContains(path, "*") && ts.startsWith(path, fragment) ? [{ name: path, kind: "directory" /* directory */ }] : ts.emptyArray;
	                }
	                var pathPrefix = path.slice(0, path.length - 1);
	                if (!ts.startsWith(fragment, pathPrefix)) {
	                    return [{ name: pathPrefix, kind: "directory" /* directory */ }];
	                }
	                var remainingFragment = fragment.slice(pathPrefix.length);
	                return ts.flatMap(patterns, function (pattern) { return getModulesForPathsPattern(remainingFragment, baseUrl, pattern, fileExtensions, host); });
	            }
	            function getModulesForPathsPattern(fragment, baseUrl, pattern, fileExtensions, host) {
	                if (!host.readDirectory) {
	                    return undefined;
	                }
	                var parsed = ts.hasZeroOrOneAsteriskCharacter(pattern) ? ts.tryParsePattern(pattern) : undefined;
	                if (!parsed) {
	                    return undefined;
	                }
	                // The prefix has two effective parts: the directory path and the base component after the filepath that is not a
	                // full directory component. For example: directory/path/of/prefix/base*
	                var normalizedPrefix = ts.resolvePath(parsed.prefix);
	                var normalizedPrefixDirectory = ts.hasTrailingDirectorySeparator(parsed.prefix) ? normalizedPrefix : ts.getDirectoryPath(normalizedPrefix);
	                var normalizedPrefixBase = ts.hasTrailingDirectorySeparator(parsed.prefix) ? "" : ts.getBaseFileName(normalizedPrefix);
	                var fragmentHasPath = containsSlash(fragment);
	                var fragmentDirectory = fragmentHasPath ? ts.hasTrailingDirectorySeparator(fragment) ? fragment : ts.getDirectoryPath(fragment) : undefined;
	                // Try and expand the prefix to include any path from the fragment so that we can limit the readDirectory call
	                var expandedPrefixDirectory = fragmentHasPath ? ts.combinePaths(normalizedPrefixDirectory, normalizedPrefixBase + fragmentDirectory) : normalizedPrefixDirectory;
	                var normalizedSuffix = ts.normalizePath(parsed.suffix);
	                // Need to normalize after combining: If we combinePaths("a", "../b"), we want "b" and not "a/../b".
	                var baseDirectory = ts.normalizePath(ts.combinePaths(baseUrl, expandedPrefixDirectory));
	                var completePrefix = fragmentHasPath ? baseDirectory : ts.ensureTrailingDirectorySeparator(baseDirectory) + normalizedPrefixBase;
	                // If we have a suffix, then we need to read the directory all the way down. We could create a glob
	                // that encodes the suffix, but we would have to escape the character "?" which readDirectory
	                // doesn't support. For now, this is safer but slower
	                var includeGlob = normalizedSuffix ? "**/*" : "./*";
	                var matches = tryReadDirectory(host, baseDirectory, fileExtensions, /*exclude*/ undefined, [includeGlob]).map(function (name) { return ({ name: name, kind: "script" /* scriptElement */ }); });
	                var directories = tryGetDirectories(host, baseDirectory).map(function (d) { return ts.combinePaths(baseDirectory, d); }).map(function (name) { return ({ name: name, kind: "directory" /* directory */ }); });
	                // Trim away prefix and suffix
	                return ts.mapDefined(ts.concatenate(matches, directories), function (_a) {
	                    var name = _a.name, kind = _a.kind;
	                    var normalizedMatch = ts.normalizePath(name);
	                    var inner = withoutStartAndEnd(normalizedMatch, completePrefix, normalizedSuffix);
	                    return inner !== undefined ? { name: removeLeadingDirectorySeparator(ts.removeFileExtension(inner)), kind: kind } : undefined;
	                });
	            }
	            function withoutStartAndEnd(s, start, end) {
	                return ts.startsWith(s, start) && ts.endsWith(s, end) ? s.slice(start.length, s.length - end.length) : undefined;
	            }
	            function removeLeadingDirectorySeparator(path) {
	                return path[0] === ts.directorySeparator ? path.slice(1) : path;
	            }
	            function getAmbientModuleCompletions(fragment, fragmentDirectory, checker) {
	                // Get modules that the type checker picked up
	                var ambientModules = checker.getAmbientModules().map(function (sym) { return ts.stripQuotes(sym.name); });
	                var nonRelativeModuleNames = ambientModules.filter(function (moduleName) { return ts.startsWith(moduleName, fragment); });
	                // Nested modules of the form "module-name/sub" need to be adjusted to only return the string
	                // after the last '/' that appears in the fragment because that's where the replacement span
	                // starts
	                if (fragmentDirectory !== undefined) {
	                    var moduleNameWithSeperator_1 = ts.ensureTrailingDirectorySeparator(fragmentDirectory);
	                    return nonRelativeModuleNames.map(function (nonRelativeModuleName) { return ts.removePrefix(nonRelativeModuleName, moduleNameWithSeperator_1); });
	                }
	                return nonRelativeModuleNames;
	            }
	            function getTripleSlashReferenceCompletion(sourceFile, position, compilerOptions, host) {
	                var token = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	                var commentRanges = ts.getLeadingCommentRanges(sourceFile.text, token.pos);
	                var range = commentRanges && ts.find(commentRanges, function (commentRange) { return position >= commentRange.pos && position <= commentRange.end; });
	                if (!range) {
	                    return undefined;
	                }
	                var text = sourceFile.text.slice(range.pos, position);
	                var match = tripleSlashDirectiveFragmentRegex.exec(text);
	                if (!match) {
	                    return undefined;
	                }
	                var prefix = match[1], kind = match[2], toComplete = match[3];
	                var scriptPath = ts.getDirectoryPath(sourceFile.path);
	                var names = kind === "path" ? getCompletionEntriesForDirectoryFragment(toComplete, scriptPath, ts.getSupportedExtensions(compilerOptions), /*includeExtensions*/ true, host, sourceFile.path)
	                    : kind === "types" ? getCompletionEntriesFromTypings(host, compilerOptions, scriptPath)
	                        : undefined;
	                return names && addReplacementSpans(toComplete, range.pos + prefix.length, names);
	            }
	            PathCompletions.getTripleSlashReferenceCompletion = getTripleSlashReferenceCompletion;
	            function getCompletionEntriesFromTypings(host, options, scriptPath, result) {
	                if (result === void 0) { result = []; }
	                // Check for typings specified in compiler options
	                var seen = ts.createMap();
	                if (options.types) {
	                    for (var _i = 0, _a = options.types; _i < _a.length; _i++) {
	                        var typesName = _a[_i];
	                        var moduleName = ts.getUnmangledNameForScopedPackage(typesName);
	                        pushResult(moduleName);
	                    }
	                }
	                else if (host.getDirectories) {
	                    var typeRoots = void 0;
	                    try {
	                        typeRoots = ts.getEffectiveTypeRoots(options, host);
	                    }
	                    catch ( /* Wrap in try catch because getEffectiveTypeRoots touches the filesystem */_b) { /* Wrap in try catch because getEffectiveTypeRoots touches the filesystem */ }
	                    if (typeRoots) {
	                        for (var _c = 0, typeRoots_2 = typeRoots; _c < typeRoots_2.length; _c++) {
	                            var root = typeRoots_2[_c];
	                            getCompletionEntriesFromDirectories(root);
	                        }
	                    }
	                    // Also get all @types typings installed in visible node_modules directories
	                    for (var _d = 0, _e = findPackageJsons(scriptPath, host); _d < _e.length; _d++) {
	                        var packageJson = _e[_d];
	                        var typesDir = ts.combinePaths(ts.getDirectoryPath(packageJson), "node_modules/@types");
	                        getCompletionEntriesFromDirectories(typesDir);
	                    }
	                }
	                return result;
	                function getCompletionEntriesFromDirectories(directory) {
	                    ts.Debug.assert(!!host.getDirectories);
	                    if (tryDirectoryExists(host, directory)) {
	                        var directories = tryGetDirectories(host, directory);
	                        if (directories) {
	                            for (var _i = 0, directories_2 = directories; _i < directories_2.length; _i++) {
	                                var typeDirectory = directories_2[_i];
	                                typeDirectory = ts.normalizePath(typeDirectory);
	                                var directoryName = ts.getBaseFileName(typeDirectory);
	                                var moduleName = ts.getUnmangledNameForScopedPackage(directoryName);
	                                pushResult(moduleName);
	                            }
	                        }
	                    }
	                }
	                function pushResult(moduleName) {
	                    if (!seen.has(moduleName)) {
	                        result.push(nameAndKind(moduleName, "external module name" /* externalModuleName */));
	                        seen.set(moduleName, true);
	                    }
	                }
	            }
	            function findPackageJsons(directory, host) {
	                var paths = [];
	                ts.forEachAncestorDirectory(directory, function (ancestor) {
	                    var currentConfigPath = ts.findConfigFile(ancestor, function (f) { return tryFileExists(host, f); }, "package.json");
	                    if (!currentConfigPath) {
	                        return true; // break out
	                    }
	                    paths.push(currentConfigPath);
	                });
	                return paths;
	            }
	            function enumerateNodeModulesVisibleToScript(host, scriptPath) {
	                if (!host.readFile || !host.fileExists)
	                    return ts.emptyArray;
	                var result = [];
	                for (var _i = 0, _a = findPackageJsons(scriptPath, host); _i < _a.length; _i++) {
	                    var packageJson = _a[_i];
	                    var contents = ts.readJson(packageJson, host); // Cast to assert that readFile is defined
	                    // Provide completions for all non @types dependencies
	                    for (var _b = 0, nodeModulesDependencyKeys_1 = nodeModulesDependencyKeys; _b < nodeModulesDependencyKeys_1.length; _b++) {
	                        var key = nodeModulesDependencyKeys_1[_b];
	                        var dependencies = contents[key];
	                        if (!dependencies)
	                            continue;
	                        for (var dep in dependencies) {
	                            if (dependencies.hasOwnProperty(dep) && !ts.startsWith(dep, "@types/")) {
	                                result.push(dep);
	                            }
	                        }
	                    }
	                }
	                return result;
	            }
	            // Replace everything after the last directory seperator that appears
	            function getDirectoryFragmentTextSpan(text, textStart) {
	                var index = Math.max(text.lastIndexOf(ts.directorySeparator), text.lastIndexOf("\\"));
	                var offset = index !== -1 ? index + 1 : 0;
	                // If the range is an identifier, span is unnecessary.
	                var length = text.length - offset;
	                return length === 0 || ts.isIdentifierText(text.substr(offset, length), 6 /* ESNext */) ? undefined : ts.createTextSpan(textStart + offset, length);
	            }
	            // Returns true if the path is explicitly relative to the script (i.e. relative to . or ..)
	            function isPathRelativeToScript(path) {
	                if (path && path.length >= 2 && path.charCodeAt(0) === 46 /* dot */) {
	                    var slashIndex = path.length >= 3 && path.charCodeAt(1) === 46 /* dot */ ? 2 : 1;
	                    var slashCharCode = path.charCodeAt(slashIndex);
	                    return slashCharCode === 47 /* slash */ || slashCharCode === 92 /* backslash */;
	                }
	                return false;
	            }
	            /**
	             * Matches a triple slash reference directive with an incomplete string literal for its path. Used
	             * to determine if the caret is currently within the string literal and capture the literal fragment
	             * for completions.
	             * For example, this matches
	             *
	             * /// <reference path="fragment
	             *
	             * but not
	             *
	             * /// <reference path="fragment"
	             */
	            var tripleSlashDirectiveFragmentRegex = /^(\/\/\/\s*<reference\s+(path|types)\s*=\s*(?:'|"))([^\3"]*)$/;
	            var nodeModulesDependencyKeys = ["dependencies", "devDependencies", "peerDependencies", "optionalDependencies"];
	            function tryGetDirectories(host, directoryName) {
	                return tryIOAndConsumeErrors(host, host.getDirectories, directoryName) || [];
	            }
	            function tryReadDirectory(host, path, extensions, exclude, include) {
	                return tryIOAndConsumeErrors(host, host.readDirectory, path, extensions, exclude, include) || ts.emptyArray;
	            }
	            function tryFileExists(host, path) {
	                return tryIOAndConsumeErrors(host, host.fileExists, path);
	            }
	            function tryDirectoryExists(host, path) {
	                try {
	                    return ts.directoryProbablyExists(path, host);
	                }
	                catch ( /*ignore*/_a) { /*ignore*/ }
	                return undefined;
	            }
	            function tryIOAndConsumeErrors(host, toApply) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                try {
	                    return toApply && toApply.apply(host, args);
	                }
	                catch ( /*ignore*/_a) { /*ignore*/ }
	                return undefined;
	            }
	            function containsSlash(fragment) {
	                return ts.stringContains(fragment, ts.directorySeparator);
	            }
	        })(PathCompletions = Completions.PathCompletions || (Completions.PathCompletions = {}));
	    })(Completions = ts.Completions || (ts.Completions = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var Completions;
	    (function (Completions) {
	        var KeywordCompletionFilters;
	        (function (KeywordCompletionFilters) {
	            KeywordCompletionFilters[KeywordCompletionFilters["None"] = 0] = "None";
	            KeywordCompletionFilters[KeywordCompletionFilters["ClassElementKeywords"] = 1] = "ClassElementKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["InterfaceElementKeywords"] = 2] = "InterfaceElementKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["ConstructorParameterKeywords"] = 3] = "ConstructorParameterKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["FunctionLikeBodyKeywords"] = 4] = "FunctionLikeBodyKeywords";
	            KeywordCompletionFilters[KeywordCompletionFilters["TypeKeywords"] = 5] = "TypeKeywords";
	        })(KeywordCompletionFilters || (KeywordCompletionFilters = {}));
	        var GlobalsSearch;
	        (function (GlobalsSearch) {
	            GlobalsSearch[GlobalsSearch["Continue"] = 0] = "Continue";
	            GlobalsSearch[GlobalsSearch["Success"] = 1] = "Success";
	            GlobalsSearch[GlobalsSearch["Fail"] = 2] = "Fail";
	        })(GlobalsSearch || (GlobalsSearch = {}));
	        function getCompletionsAtPosition(host, program, log, sourceFile, position, preferences, triggerCharacter) {
	            var typeChecker = program.getTypeChecker();
	            var compilerOptions = program.getCompilerOptions();
	            if (ts.isInReferenceComment(sourceFile, position)) {
	                var entries = Completions.PathCompletions.getTripleSlashReferenceCompletion(sourceFile, position, compilerOptions, host);
	                return entries && convertPathCompletions(entries);
	            }
	            var contextToken = ts.findPrecedingToken(position, sourceFile);
	            if (triggerCharacter && !isValidTrigger(sourceFile, triggerCharacter, contextToken, position))
	                return undefined;
	            if (ts.isInString(sourceFile, position, contextToken)) {
	                return !contextToken || !ts.isStringLiteralLike(contextToken)
	                    ? undefined
	                    : convertStringLiteralCompletions(getStringLiteralCompletionEntries(sourceFile, contextToken, position, typeChecker, compilerOptions, host), sourceFile, typeChecker, log, preferences);
	            }
	            if (contextToken && ts.isBreakOrContinueStatement(contextToken.parent)
	                && (contextToken.kind === 72 /* BreakKeyword */ || contextToken.kind === 77 /* ContinueKeyword */ || contextToken.kind === 71 /* Identifier */)) {
	                return getLabelCompletionAtPosition(contextToken.parent);
	            }
	            var completionData = getCompletionData(program, log, sourceFile, position, preferences, /*detailsEntryId*/ undefined);
	            if (!completionData) {
	                return undefined;
	            }
	            switch (completionData.kind) {
	                case 0 /* Data */:
	                    return completionInfoFromData(sourceFile, typeChecker, compilerOptions, log, completionData, preferences);
	                case 1 /* JsDocTagName */:
	                    // If the current position is a jsDoc tag name, only tag names should be provided for completion
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocTagNameCompletions());
	                case 2 /* JsDocTag */:
	                    // If the current position is a jsDoc tag, only tags should be provided for completion
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocTagCompletions());
	                case 3 /* JsDocParameterName */:
	                    return jsdocCompletionInfo(ts.JsDoc.getJSDocParameterNameCompletions(completionData.tag));
	                default:
	                    return ts.Debug.assertNever(completionData);
	            }
	        }
	        Completions.getCompletionsAtPosition = getCompletionsAtPosition;
	        function convertStringLiteralCompletions(completion, sourceFile, checker, log, preferences) {
	            if (completion === undefined) {
	                return undefined;
	            }
	            switch (completion.kind) {
	                case 0 /* Paths */:
	                    return convertPathCompletions(completion.paths);
	                case 1 /* Properties */: {
	                    var entries = [];
	                    getCompletionEntriesFromSymbols(completion.symbols, entries, sourceFile, sourceFile, checker, 6 /* ESNext */, log, 4 /* String */, preferences); // Target will not be used, so arbitrary
	                    return { isGlobalCompletion: false, isMemberCompletion: true, isNewIdentifierLocation: completion.hasIndexSignature, entries: entries };
	                }
	                case 2 /* Types */: {
	                    var entries = completion.types.map(function (type) { return ({ name: type.value, kindModifiers: "" /* none */, kind: "string" /* string */, sortText: "0" }); });
	                    return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: completion.isNewIdentifier, entries: entries };
	                }
	                default:
	                    return ts.Debug.assertNever(completion);
	            }
	        }
	        function convertPathCompletions(pathCompletions) {
	            var isGlobalCompletion = false; // We don't want the editor to offer any other completions, such as snippets, inside a comment.
	            var isNewIdentifierLocation = true; // The user may type in a path that doesn't yet exist, creating a "new identifier" with respect to the collection of identifiers the server is aware of.
	            var entries = pathCompletions.map(function (_a) {
	                var name = _a.name, kind = _a.kind, span = _a.span;
	                return ({ name: name, kind: kind, kindModifiers: "" /* none */, sortText: "0", replacementSpan: span });
	            });
	            return { isGlobalCompletion: isGlobalCompletion, isMemberCompletion: false, isNewIdentifierLocation: isNewIdentifierLocation, entries: entries };
	        }
	        function jsdocCompletionInfo(entries) {
	            return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: false, entries: entries };
	        }
	        function completionInfoFromData(sourceFile, typeChecker, compilerOptions, log, completionData, preferences) {
	            var symbols = completionData.symbols, completionKind = completionData.completionKind, isInSnippetScope = completionData.isInSnippetScope, isNewIdentifierLocation = completionData.isNewIdentifierLocation, location = completionData.location, propertyAccessToConvert = completionData.propertyAccessToConvert, keywordFilters = completionData.keywordFilters, symbolToOriginInfoMap = completionData.symbolToOriginInfoMap, recommendedCompletion = completionData.recommendedCompletion, isJsxInitializer = completionData.isJsxInitializer;
	            if (sourceFile.languageVariant === 1 /* JSX */ && location && location.parent && ts.isJsxClosingElement(location.parent)) {
	                // In the TypeScript JSX element, if such element is not defined. When users query for completion at closing tag,
	                // instead of simply giving unknown value, the completion will return the tag-name of an associated opening-element.
	                // For example:
	                //     var x = <div> </ /*1*/>
	                // The completion list at "1" will contain "div" with type any
	                var tagName = location.parent.parent.openingElement.tagName;
	                return { isGlobalCompletion: false, isMemberCompletion: true, isNewIdentifierLocation: false,
	                    entries: [{
	                            name: tagName.getFullText(),
	                            kind: "class" /* classElement */,
	                            kindModifiers: undefined,
	                            sortText: "0",
	                        }] };
	            }
	            var entries = [];
	            if (ts.isSourceFileJavaScript(sourceFile)) {
	                var uniqueNames = getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, compilerOptions.target, log, completionKind, preferences, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap);
	                getJavaScriptCompletionEntries(sourceFile, location.pos, uniqueNames, compilerOptions.target, entries);
	            }
	            else {
	                if ((!symbols || symbols.length === 0) && keywordFilters === 0 /* None */) {
	                    return undefined;
	                }
	                getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, compilerOptions.target, log, completionKind, preferences, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap);
	            }
	            // TODO add filter for keyword based on type/value/namespace and also location
	            // Add all keywords if
	            // - this is not a member completion list (all the keywords)
	            // - other filters are enabled in required scenario so add those keywords
	            var isMemberCompletion = isMemberCompletionKind(completionKind);
	            if (keywordFilters !== 0 /* None */ || !isMemberCompletion) {
	                ts.addRange(entries, getKeywordCompletions(keywordFilters));
	            }
	            return { isGlobalCompletion: isInSnippetScope, isMemberCompletion: isMemberCompletion, isNewIdentifierLocation: isNewIdentifierLocation, entries: entries };
	        }
	        function isMemberCompletionKind(kind) {
	            switch (kind) {
	                case 0 /* ObjectPropertyDeclaration */:
	                case 3 /* MemberLike */:
	                case 2 /* PropertyAccess */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function getJavaScriptCompletionEntries(sourceFile, position, uniqueNames, target, entries) {
	            ts.getNameTable(sourceFile).forEach(function (pos, name) {
	                // Skip identifiers produced only from the current location
	                if (pos === position) {
	                    return;
	                }
	                var realName = ts.unescapeLeadingUnderscores(name);
	                if (ts.addToSeen(uniqueNames, realName) && ts.isIdentifierText(realName, target) && !ts.isStringANonContextualKeyword(realName)) {
	                    entries.push({
	                        name: realName,
	                        kind: "warning" /* warning */,
	                        kindModifiers: "",
	                        sortText: "1"
	                    });
	                }
	            });
	        }
	        function createCompletionEntry(symbol, location, sourceFile, typeChecker, target, kind, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, preferences) {
	            var info = getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind);
	            if (!info) {
	                return undefined;
	            }
	            var name = info.name, needsConvertPropertyAccess = info.needsConvertPropertyAccess;
	            var insertText;
	            var replacementSpan;
	            if (origin && origin.type === "this-type") {
	                insertText = needsConvertPropertyAccess ? "this[" + quote(name, preferences) + "]" : "this." + name;
	            }
	            // We should only have needsConvertPropertyAccess if there's a property access to convert. But see #21790.
	            // Somehow there was a global with a non-identifier name. Hopefully someone will complain about getting a "foo bar" global completion and provide a repro.
	            else if ((origin && origin.type === "symbol-member" || needsConvertPropertyAccess) && propertyAccessToConvert) {
	                insertText = needsConvertPropertyAccess ? "[" + quote(name, preferences) + "]" : "[" + name + "]";
	                var dot = ts.findChildOfKind(propertyAccessToConvert, 23 /* DotToken */, sourceFile);
	                // If the text after the '.' starts with this name, write over it. Else, add new text.
	                var end = ts.startsWith(name, propertyAccessToConvert.name.text) ? propertyAccessToConvert.name.end : dot.end;
	                replacementSpan = ts.createTextSpanFromBounds(dot.getStart(sourceFile), end);
	            }
	            if (isJsxInitializer) {
	                if (insertText === undefined)
	                    insertText = name;
	                insertText = "{" + insertText + "}";
	                if (typeof isJsxInitializer !== "boolean") {
	                    replacementSpan = ts.createTextSpanFromNode(isJsxInitializer, sourceFile);
	                }
	            }
	            if (insertText !== undefined && !preferences.includeCompletionsWithInsertText) {
	                return undefined;
	            }
	            // TODO(drosen): Right now we just permit *all* semantic meanings when calling
	            // 'getSymbolKind' which is permissible given that it is backwards compatible; but
	            // really we should consider passing the meaning for the node so that we don't report
	            // that a suggestion for a value is an interface.  We COULD also just do what
	            // 'getSymbolModifiers' does, which is to use the first declaration.
	            // Use a 'sortText' of 0' so that all symbol completion entries come before any other
	            // entries (like JavaScript identifier entries).
	            return {
	                name: name,
	                kind: ts.SymbolDisplay.getSymbolKind(typeChecker, symbol, location),
	                kindModifiers: ts.SymbolDisplay.getSymbolModifiers(symbol),
	                sortText: "0",
	                source: getSourceFromOrigin(origin),
	                hasAction: trueOrUndefined(!!origin && origin.type === "export"),
	                isRecommended: trueOrUndefined(isRecommendedCompletionMatch(symbol, recommendedCompletion, typeChecker)),
	                insertText: insertText,
	                replacementSpan: replacementSpan,
	            };
	        }
	        function quote(text, preferences) {
	            var quoted = JSON.stringify(text);
	            switch (preferences.quotePreference) {
	                case undefined:
	                case "double":
	                    return quoted;
	                case "single":
	                    return "'" + ts.stripQuotes(quoted).replace("'", "\\'").replace('\\"', '"') + "'";
	                default:
	                    return ts.Debug.assertNever(preferences.quotePreference);
	            }
	        }
	        function isRecommendedCompletionMatch(localSymbol, recommendedCompletion, checker) {
	            return localSymbol === recommendedCompletion ||
	                !!(localSymbol.flags & 1048576 /* ExportValue */) && checker.getExportSymbolOfSymbol(localSymbol) === recommendedCompletion;
	        }
	        function trueOrUndefined(b) {
	            return b ? true : undefined;
	        }
	        function getSourceFromOrigin(origin) {
	            return origin && origin.type === "export" ? ts.stripQuotes(origin.moduleSymbol.name) : undefined;
	        }
	        function getCompletionEntriesFromSymbols(symbols, entries, location, sourceFile, typeChecker, target, log, kind, preferences, propertyAccessToConvert, isJsxInitializer, recommendedCompletion, symbolToOriginInfoMap) {
	            var start = ts.timestamp();
	            // Tracks unique names.
	            // We don't set this for global variables or completions from external module exports, because we can have multiple of those.
	            // Based on the order we add things we will always see locals first, then globals, then module exports.
	            // So adding a completion for a local will prevent us from adding completions for external module exports sharing the same name.
	            var uniques = ts.createMap();
	            for (var _i = 0, symbols_4 = symbols; _i < symbols_4.length; _i++) {
	                var symbol = symbols_4[_i];
	                var origin = symbolToOriginInfoMap ? symbolToOriginInfoMap[ts.getSymbolId(symbol)] : undefined;
	                var entry = createCompletionEntry(symbol, location, sourceFile, typeChecker, target, kind, origin, recommendedCompletion, propertyAccessToConvert, isJsxInitializer, preferences);
	                if (!entry) {
	                    continue;
	                }
	                var name = entry.name;
	                if (uniques.has(name)) {
	                    continue;
	                }
	                // Latter case tests whether this is a global variable.
	                if (!origin && !(symbol.parent === undefined && !ts.some(symbol.declarations, function (d) { return d.getSourceFile() === location.getSourceFile(); }))) {
	                    uniques.set(name, true);
	                }
	                entries.push(entry);
	            }
	            log("getCompletionsAtPosition: getCompletionEntriesFromSymbols: " + (ts.timestamp() - start));
	            return uniques;
	        }
	        function getLabelCompletionAtPosition(node) {
	            var entries = getLabelStatementCompletions(node);
	            if (entries.length) {
	                return { isGlobalCompletion: false, isMemberCompletion: false, isNewIdentifierLocation: false, entries: entries };
	            }
	        }
	        function getLabelStatementCompletions(node) {
	            var entries = [];
	            var uniques = ts.createMap();
	            var current = node;
	            while (current) {
	                if (ts.isFunctionLike(current)) {
	                    break;
	                }
	                if (ts.isLabeledStatement(current)) {
	                    var name = current.label.text;
	                    if (!uniques.has(name)) {
	                        uniques.set(name, true);
	                        entries.push({
	                            name: name,
	                            kindModifiers: "" /* none */,
	                            kind: "label" /* label */,
	                            sortText: "0"
	                        });
	                    }
	                }
	                current = current.parent;
	            }
	            return entries;
	        }
	        var StringLiteralCompletionKind;
	        (function (StringLiteralCompletionKind) {
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Paths"] = 0] = "Paths";
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Properties"] = 1] = "Properties";
	            StringLiteralCompletionKind[StringLiteralCompletionKind["Types"] = 2] = "Types";
	        })(StringLiteralCompletionKind || (StringLiteralCompletionKind = {}));
	        function getStringLiteralCompletionEntries(sourceFile, node, position, typeChecker, compilerOptions, host) {
	            switch (node.parent.kind) {
	                case 177 /* LiteralType */:
	                    switch (node.parent.parent.kind) {
	                        case 161 /* TypeReference */:
	                            return { kind: 2 /* Types */, types: getStringLiteralTypes(typeChecker.getTypeArgumentConstraint(node.parent), typeChecker), isNewIdentifier: false };
	                        case 175 /* IndexedAccessType */:
	                            // Get all apparent property names
	                            // i.e. interface Foo {
	                            //          foo: string;
	                            //          bar: string;
	                            //      }
	                            //      let x: Foo["/*completion position*/"]
	                            return stringLiteralCompletionsFromProperties(typeChecker.getTypeFromTypeNode(node.parent.parent.objectType));
	                        case 178 /* ImportType */:
	                            return { kind: 0 /* Paths */, paths: Completions.PathCompletions.getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker) };
	                        default:
	                            return undefined;
	                    }
	                case 269 /* PropertyAssignment */:
	                    if (ts.isObjectLiteralExpression(node.parent.parent) && node.parent.name === node) {
	                        // Get quoted name of properties of the object literal expression
	                        // i.e. interface ConfigFiles {
	                        //          'jspm:dev': string
	                        //      }
	                        //      let files: ConfigFiles = {
	                        //          '/*completion position*/'
	                        //      }
	                        //
	                        //      function foo(c: ConfigFiles) {}
	                        //      foo({
	                        //          '/*completion position*/'
	                        //      });
	                        return stringLiteralCompletionsFromProperties(typeChecker.getContextualType(node.parent.parent));
	                    }
	                    return fromContextualType();
	                case 185 /* ElementAccessExpression */: {
	                    var _a = node.parent, expression = _a.expression, argumentExpression = _a.argumentExpression;
	                    if (node === argumentExpression) {
	                        // Get all names of properties on the expression
	                        // i.e. interface A {
	                        //      'prop1': string
	                        // }
	                        // let a: A;
	                        // a['/*completion position*/']
	                        return stringLiteralCompletionsFromProperties(typeChecker.getTypeAtLocation(expression));
	                    }
	                    return undefined;
	                }
	                case 186 /* CallExpression */:
	                case 187 /* NewExpression */:
	                    if (!ts.isRequireCall(node.parent, /*checkArgumentIsStringLiteralLike*/ false) && !ts.isImportCall(node.parent)) {
	                        var argumentInfo = ts.SignatureHelp.getImmediatelyContainingArgumentInfo(node, position, sourceFile);
	                        // Get string literal completions from specialized signatures of the target
	                        // i.e. declare function f(a: 'A');
	                        // f("/*completion position*/")
	                        return argumentInfo ? getStringLiteralCompletionsFromSignature(argumentInfo, typeChecker) : fromContextualType();
	                    }
	                // falls through (is `require("")` or `import("")`)
	                case 243 /* ImportDeclaration */:
	                case 249 /* ExportDeclaration */:
	                case 253 /* ExternalModuleReference */:
	                    // Get all known external module names or complete a path to a module
	                    // i.e. import * as ns from "/*completion position*/";
	                    //      var y = import("/*completion position*/");
	                    //      import x = require("/*completion position*/");
	                    //      var y = require("/*completion position*/");
	                    //      export * from "/*completion position*/";
	                    return { kind: 0 /* Paths */, paths: Completions.PathCompletions.getStringLiteralCompletionsFromModuleNames(sourceFile, node, compilerOptions, host, typeChecker) };
	                default:
	                    return fromContextualType();
	            }
	            function fromContextualType() {
	                // Get completion for string literal from string literal type
	                // i.e. var x: "hi" | "hello" = "/*completion position*/"
	                return { kind: 2 /* Types */, types: getStringLiteralTypes(getContextualTypeFromParent(node, typeChecker), typeChecker), isNewIdentifier: false };
	            }
	        }
	        function getStringLiteralCompletionsFromSignature(argumentInfo, checker) {
	            var isNewIdentifier = false;
	            var uniques = ts.createMap();
	            var candidates = [];
	            checker.getResolvedSignature(argumentInfo.invocation, candidates, argumentInfo.argumentCount);
	            var types = ts.flatMap(candidates, function (candidate) {
	                if (!candidate.hasRestParameter && argumentInfo.argumentCount > candidate.parameters.length)
	                    return;
	                var type = checker.getParameterType(candidate, argumentInfo.argumentIndex);
	                isNewIdentifier = isNewIdentifier || !!(type.flags & 2 /* String */);
	                return getStringLiteralTypes(type, checker, uniques);
	            });
	            return { kind: 2 /* Types */, types: types, isNewIdentifier: isNewIdentifier };
	        }
	        function stringLiteralCompletionsFromProperties(type) {
	            return type && { kind: 1 /* Properties */, symbols: type.getApparentProperties(), hasIndexSignature: hasIndexSignature(type) };
	        }
	        function getStringLiteralTypes(type, typeChecker, uniques) {
	            if (uniques === void 0) { uniques = ts.createMap(); }
	            if (!type)
	                return ts.emptyArray;
	            type = ts.skipConstraint(type);
	            return type.isUnion()
	                ? ts.flatMap(type.types, function (t) { return getStringLiteralTypes(t, typeChecker, uniques); })
	                : type.isStringLiteral() && !(type.flags & 256 /* EnumLiteral */) && ts.addToSeen(uniques, type.value)
	                    ? [type]
	                    : ts.emptyArray;
	        }
	        function getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId) {
	            var completionData = getCompletionData(program, log, sourceFile, position, { includeCompletionsForModuleExports: true, includeCompletionsWithInsertText: true }, entryId);
	            if (!completionData) {
	                return { type: "none" };
	            }
	            if (completionData.kind !== 0 /* Data */) {
	                return { type: "request", request: completionData };
	            }
	            var symbols = completionData.symbols, location = completionData.location, completionKind = completionData.completionKind, symbolToOriginInfoMap = completionData.symbolToOriginInfoMap, previousToken = completionData.previousToken, isJsxInitializer = completionData.isJsxInitializer;
	            // Find the symbol with the matching entry name.
	            // We don't need to perform character checks here because we're only comparing the
	            // name against 'entryName' (which is known to be good), not building a new
	            // completion entry.
	            return ts.firstDefined(symbols, function (symbol) {
	                var origin = symbolToOriginInfoMap[ts.getSymbolId(symbol)];
	                var info = getCompletionEntryDisplayNameForSymbol(symbol, program.getCompilerOptions().target, origin, completionKind);
	                return info && info.name === entryId.name && getSourceFromOrigin(origin) === entryId.source
	                    ? { type: "symbol", symbol: symbol, location: location, symbolToOriginInfoMap: symbolToOriginInfoMap, previousToken: previousToken, isJsxInitializer: isJsxInitializer }
	                    : undefined;
	            }) || { type: "none" };
	        }
	        function getSymbolName(symbol, origin, target) {
	            return origin && origin.type === "export" && origin.isDefaultExport && symbol.escapedName === "default" /* Default */
	                // Name of "export default foo;" is "foo". Name of "export default 0" is the filename converted to camelCase.
	                ? ts.firstDefined(symbol.declarations, function (d) { return ts.isExportAssignment(d) && ts.isIdentifier(d.expression) ? d.expression.text : undefined; })
	                    || ts.codefix.moduleSymbolToValidIdentifier(origin.moduleSymbol, target)
	                : symbol.name;
	        }
	        function getCompletionEntryDetails(program, log, sourceFile, position, entryId, host, formatContext, getCanonicalFileName, preferences, cancellationToken) {
	            var typeChecker = program.getTypeChecker();
	            var compilerOptions = program.getCompilerOptions();
	            var name = entryId.name;
	            var contextToken = ts.findPrecedingToken(position, sourceFile);
	            if (ts.isInString(sourceFile, position, contextToken)) {
	                var stringLiteralCompletions = !contextToken || !ts.isStringLiteralLike(contextToken)
	                    ? undefined
	                    : getStringLiteralCompletionEntries(sourceFile, contextToken, position, typeChecker, compilerOptions, host);
	                return stringLiteralCompletions && stringLiteralCompletionDetails(name, contextToken, stringLiteralCompletions, sourceFile, typeChecker, cancellationToken);
	            }
	            // Compute all the completion symbols again.
	            var symbolCompletion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId);
	            switch (symbolCompletion.type) {
	                case "request": {
	                    var request = symbolCompletion.request;
	                    switch (request.kind) {
	                        case 1 /* JsDocTagName */:
	                            return ts.JsDoc.getJSDocTagNameCompletionDetails(name);
	                        case 2 /* JsDocTag */:
	                            return ts.JsDoc.getJSDocTagCompletionDetails(name);
	                        case 3 /* JsDocParameterName */:
	                            return ts.JsDoc.getJSDocParameterNameCompletionDetails(name);
	                        default:
	                            return ts.Debug.assertNever(request);
	                    }
	                }
	                case "symbol": {
	                    var symbol = symbolCompletion.symbol, location = symbolCompletion.location, symbolToOriginInfoMap = symbolCompletion.symbolToOriginInfoMap, previousToken = symbolCompletion.previousToken;
	                    var _a = getCompletionEntryCodeActionsAndSourceDisplay(symbolToOriginInfoMap, symbol, program, typeChecker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, program.getSourceFiles(), preferences), codeActions = _a.codeActions, sourceDisplay = _a.sourceDisplay;
	                    return createCompletionDetailsForSymbol(symbol, typeChecker, sourceFile, location, cancellationToken, codeActions, sourceDisplay);
	                }
	                case "none":
	                    // Didn't find a symbol with this name.  See if we can find a keyword instead.
	                    return allKeywordsCompletions().some(function (c) { return c.name === name; }) ? createCompletionDetails(name, "" /* none */, "keyword" /* keyword */, [ts.displayPart(name, ts.SymbolDisplayPartKind.keyword)]) : undefined;
	            }
	        }
	        Completions.getCompletionEntryDetails = getCompletionEntryDetails;
	        function createCompletionDetailsForSymbol(symbol, checker, sourceFile, location, cancellationToken, codeActions, sourceDisplay) {
	            var _a = checker.runWithCancellationToken(cancellationToken, function (checker) {
	                return ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, sourceFile, location, location, 7 /* All */);
	            }), displayParts = _a.displayParts, documentation = _a.documentation, symbolKind = _a.symbolKind, tags = _a.tags;
	            return createCompletionDetails(symbol.name, ts.SymbolDisplay.getSymbolModifiers(symbol), symbolKind, displayParts, documentation, tags, codeActions, sourceDisplay);
	        }
	        function stringLiteralCompletionDetails(name, location, completion, sourceFile, checker, cancellationToken) {
	            switch (completion.kind) {
	                case 0 /* Paths */: {
	                    var match = ts.find(completion.paths, function (p) { return p.name === name; });
	                    return match && createCompletionDetails(name, "" /* none */, match.kind, [ts.textPart(name)]);
	                }
	                case 1 /* Properties */: {
	                    var match = ts.find(completion.symbols, function (s) { return s.name === name; });
	                    return match && createCompletionDetailsForSymbol(match, checker, sourceFile, location, cancellationToken);
	                }
	                case 2 /* Types */:
	                    return ts.find(completion.types, function (t) { return t.value === name; }) ? createCompletionDetails(name, "" /* none */, "type" /* typeElement */, [ts.textPart(name)]) : undefined;
	                default:
	                    return ts.Debug.assertNever(completion);
	            }
	        }
	        function createCompletionDetails(name, kindModifiers, kind, displayParts, documentation, tags, codeActions, source) {
	            return { name: name, kindModifiers: kindModifiers, kind: kind, displayParts: displayParts, documentation: documentation, tags: tags, codeActions: codeActions, source: source };
	        }
	        function getCompletionEntryCodeActionsAndSourceDisplay(symbolToOriginInfoMap, symbol, program, checker, host, compilerOptions, sourceFile, previousToken, formatContext, getCanonicalFileName, allSourceFiles, preferences) {
	            var symbolOriginInfo = symbolToOriginInfoMap[ts.getSymbolId(symbol)];
	            if (!symbolOriginInfo || symbolOriginInfo.type !== "export") {
	                return { codeActions: undefined, sourceDisplay: undefined };
	            }
	            var moduleSymbol = symbolOriginInfo.moduleSymbol;
	            var exportedSymbol = checker.getMergedSymbol(ts.skipAlias(symbol.exportSymbol || symbol, checker));
	            var _a = ts.codefix.getImportCompletionAction(exportedSymbol, moduleSymbol, sourceFile, getSymbolName(symbol, symbolOriginInfo, compilerOptions.target), host, program, checker, compilerOptions, allSourceFiles, formatContext, getCanonicalFileName, previousToken, preferences), moduleSpecifier = _a.moduleSpecifier, codeAction = _a.codeAction;
	            return { sourceDisplay: [ts.textPart(moduleSpecifier)], codeActions: [codeAction] };
	        }
	        function getCompletionEntrySymbol(program, log, sourceFile, position, entryId) {
	            var completion = getSymbolCompletionFromEntryId(program, log, sourceFile, position, entryId);
	            return completion.type === "symbol" ? completion.symbol : undefined;
	        }
	        Completions.getCompletionEntrySymbol = getCompletionEntrySymbol;
	        var CompletionDataKind;
	        (function (CompletionDataKind) {
	            CompletionDataKind[CompletionDataKind["Data"] = 0] = "Data";
	            CompletionDataKind[CompletionDataKind["JsDocTagName"] = 1] = "JsDocTagName";
	            CompletionDataKind[CompletionDataKind["JsDocTag"] = 2] = "JsDocTag";
	            CompletionDataKind[CompletionDataKind["JsDocParameterName"] = 3] = "JsDocParameterName";
	        })(CompletionDataKind || (CompletionDataKind = {}));
	        var CompletionKind;
	        (function (CompletionKind) {
	            CompletionKind[CompletionKind["ObjectPropertyDeclaration"] = 0] = "ObjectPropertyDeclaration";
	            CompletionKind[CompletionKind["Global"] = 1] = "Global";
	            CompletionKind[CompletionKind["PropertyAccess"] = 2] = "PropertyAccess";
	            CompletionKind[CompletionKind["MemberLike"] = 3] = "MemberLike";
	            CompletionKind[CompletionKind["String"] = 4] = "String";
	            CompletionKind[CompletionKind["None"] = 5] = "None";
	        })(CompletionKind || (CompletionKind = {}));
	        function getRecommendedCompletion(currentToken, position, sourceFile, checker) {
	            var ty = getContextualType(currentToken, position, sourceFile, checker);
	            var symbol = ty && ty.symbol;
	            // Don't include make a recommended completion for an abstract class
	            return symbol && (symbol.flags & 384 /* Enum */ || symbol.flags & 32 /* Class */ && !ts.isAbstractConstructorSymbol(symbol))
	                ? getFirstSymbolInChain(symbol, currentToken, checker)
	                : undefined;
	        }
	        function getContextualType(currentToken, position, sourceFile, checker) {
	            var parent = currentToken.parent;
	            switch (currentToken.kind) {
	                case 71 /* Identifier */:
	                    return getContextualTypeFromParent(currentToken, checker);
	                case 58 /* EqualsToken */:
	                    switch (parent.kind) {
	                        case 231 /* VariableDeclaration */:
	                            return checker.getContextualType(parent.initializer);
	                        case 199 /* BinaryExpression */:
	                            return checker.getTypeAtLocation(parent.left);
	                        case 261 /* JsxAttribute */:
	                            return checker.getContextualTypeForJsxAttribute(parent);
	                        default:
	                            return undefined;
	                    }
	                case 94 /* NewKeyword */:
	                    return checker.getContextualType(parent);
	                case 73 /* CaseKeyword */:
	                    return getSwitchedType(ts.cast(parent, ts.isCaseClause), checker);
	                case 17 /* OpenBraceToken */:
	                    return ts.isJsxExpression(parent) && parent.parent.kind !== 254 /* JsxElement */ ? checker.getContextualTypeForJsxAttribute(parent.parent) : undefined;
	                default:
	                    var argInfo = ts.SignatureHelp.getImmediatelyContainingArgumentInfo(currentToken, position, sourceFile);
	                    return argInfo
	                        // At `,`, treat this as the next argument after the comma.
	                        ? checker.getContextualTypeForArgumentAtIndex(argInfo.invocation, argInfo.argumentIndex + (currentToken.kind === 26 /* CommaToken */ ? 1 : 0))
	                        : isEqualityOperatorKind(currentToken.kind) && ts.isBinaryExpression(parent) && isEqualityOperatorKind(parent.operatorToken.kind)
	                            // completion at `x ===/**/` should be for the right side
	                            ? checker.getTypeAtLocation(parent.left)
	                            : checker.getContextualType(currentToken);
	            }
	        }
	        function getContextualTypeFromParent(node, checker) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 187 /* NewExpression */:
	                    return checker.getContextualType(parent);
	                case 199 /* BinaryExpression */: {
	                    var _a = parent, left = _a.left, operatorToken = _a.operatorToken, right = _a.right;
	                    return isEqualityOperatorKind(operatorToken.kind)
	                        ? checker.getTypeAtLocation(node === right ? left : right)
	                        : checker.getContextualType(node);
	                }
	                case 265 /* CaseClause */:
	                    return parent.expression === node ? getSwitchedType(parent, checker) : undefined;
	                default:
	                    return checker.getContextualType(node);
	            }
	        }
	        function getSwitchedType(caseClause, checker) {
	            return checker.getTypeAtLocation(caseClause.parent.parent.expression);
	        }
	        function getFirstSymbolInChain(symbol, enclosingDeclaration, checker) {
	            var chain = checker.getAccessibleSymbolChain(symbol, enclosingDeclaration, /*meaning*/ 67108863 /* All */, /*useOnlyExternalAliasing*/ false);
	            if (chain)
	                return ts.first(chain);
	            return symbol.parent && (isModuleSymbol(symbol.parent) ? symbol : getFirstSymbolInChain(symbol.parent, enclosingDeclaration, checker));
	        }
	        function isModuleSymbol(symbol) {
	            return symbol.declarations.some(function (d) { return d.kind === 273 /* SourceFile */; });
	        }
	        function getCompletionData(program, log, sourceFile, position, preferences, detailsEntryId) {
	            var typeChecker = program.getTypeChecker();
	            var start = ts.timestamp();
	            var currentToken = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false); // TODO: GH#15853
	            // We will check for jsdoc comments with insideComment and getJsDocTagAtPosition. (TODO: that seems rather inefficient to check the same thing so many times.)
	            log("getCompletionData: Get current token: " + (ts.timestamp() - start));
	            start = ts.timestamp();
	            // Completion not allowed inside comments, bail out if this is the case
	            var insideComment = ts.isInComment(sourceFile, position, currentToken);
	            log("getCompletionData: Is inside comment: " + (ts.timestamp() - start));
	            var insideJsDocTagTypeExpression = false;
	            var isInSnippetScope = false;
	            if (insideComment) {
	                if (ts.hasDocComment(sourceFile, position)) {
	                    if (sourceFile.text.charCodeAt(position - 1) === 64 /* at */) {
	                        // The current position is next to the '@' sign, when no tag name being provided yet.
	                        // Provide a full list of tag names
	                        return { kind: 1 /* JsDocTagName */ };
	                    }
	                    else {
	                        // When completion is requested without "@", we will have check to make sure that
	                        // there are no comments prefix the request position. We will only allow "*" and space.
	                        // e.g
	                        //   /** |c| /*
	                        //
	                        //   /**
	                        //     |c|
	                        //    */
	                        //
	                        //   /**
	                        //    * |c|
	                        //    */
	                        //
	                        //   /**
	                        //    *         |c|
	                        //    */
	                        var lineStart = ts.getLineStartPositionForPosition(position, sourceFile);
	                        if (!(sourceFile.text.substring(lineStart, position).match(/[^\*|\s|(/\*\*)]/))) {
	                            return { kind: 2 /* JsDocTag */ };
	                        }
	                    }
	                }
	                // Completion should work inside certain JsDoc tags. For example:
	                //     /** @type {number | string} */
	                // Completion should work in the brackets
	                var tag = getJsDocTagAtPosition(currentToken, position);
	                if (tag) {
	                    if (tag.tagName.pos <= position && position <= tag.tagName.end) {
	                        return { kind: 1 /* JsDocTagName */ };
	                    }
	                    if (isTagWithTypeExpression(tag) && tag.typeExpression && tag.typeExpression.kind === 277 /* JSDocTypeExpression */) {
	                        currentToken = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ true);
	                        if (!currentToken ||
	                            (!ts.isDeclarationName(currentToken) &&
	                                (currentToken.parent.kind !== 297 /* JSDocPropertyTag */ ||
	                                    currentToken.parent.name !== currentToken))) {
	                            // Use as type location if inside tag's type expression
	                            insideJsDocTagTypeExpression = isCurrentlyEditingNode(tag.typeExpression);
	                        }
	                    }
	                    if (ts.isJSDocParameterTag(tag) && (ts.nodeIsMissing(tag.name) || tag.name.pos <= position && position <= tag.name.end)) {
	                        return { kind: 3 /* JsDocParameterName */, tag: tag };
	                    }
	                }
	                if (!insideJsDocTagTypeExpression) {
	                    // Proceed if the current position is in jsDoc tag expression; otherwise it is a normal
	                    // comment or the plain text part of a jsDoc comment, so no completion should be available
	                    log("Returning an empty list because completion was inside a regular comment or plain text part of a JsDoc comment.");
	                    return undefined;
	                }
	            }
	            start = ts.timestamp();
	            var previousToken = ts.findPrecedingToken(position, sourceFile, /*startNode*/ undefined, insideJsDocTagTypeExpression);
	            log("getCompletionData: Get previous token 1: " + (ts.timestamp() - start));
	            // The decision to provide completion depends on the contextToken, which is determined through the previousToken.
	            // Note: 'previousToken' (and thus 'contextToken') can be undefined if we are the beginning of the file
	            var contextToken = previousToken;
	            // Check if the caret is at the end of an identifier; this is a partial identifier that we want to complete: e.g. a.toS|
	            // Skip this partial identifier and adjust the contextToken to the token that precedes it.
	            if (contextToken && position <= contextToken.end && (ts.isIdentifier(contextToken) || ts.isKeyword(contextToken.kind))) {
	                var start_4 = ts.timestamp();
	                contextToken = ts.findPrecedingToken(contextToken.getFullStart(), sourceFile, /*startNode*/ undefined, insideJsDocTagTypeExpression);
	                log("getCompletionData: Get previous token 2: " + (ts.timestamp() - start_4));
	            }
	            // Find the node where completion is requested on.
	            // Also determine whether we are trying to complete with members of that node
	            // or attributes of a JSX tag.
	            var node = currentToken;
	            var propertyAccessToConvert;
	            var isRightOfDot = false;
	            var isRightOfOpenTag = false;
	            var isStartingCloseTag = false;
	            var isJsxInitializer = false;
	            var location = ts.getTouchingPropertyName(sourceFile, position, insideJsDocTagTypeExpression); // TODO: GH#15853
	            if (contextToken) {
	                // Bail out if this is a known invalid completion location
	                if (isCompletionListBlocker(contextToken)) {
	                    log("Returning an empty list because completion was requested in an invalid position.");
	                    return undefined;
	                }
	                var parent = contextToken.parent;
	                if (contextToken.kind === 23 /* DotToken */) {
	                    isRightOfDot = true;
	                    switch (parent.kind) {
	                        case 184 /* PropertyAccessExpression */:
	                            propertyAccessToConvert = parent;
	                            node = propertyAccessToConvert.expression;
	                            break;
	                        case 145 /* QualifiedName */:
	                            node = parent.left;
	                            break;
	                        case 178 /* ImportType */:
	                            node = parent;
	                            break;
	                        default:
	                            // There is nothing that precedes the dot, so this likely just a stray character
	                            // or leading into a '...' token. Just bail out instead.
	                            return undefined;
	                    }
	                }
	                else if (sourceFile.languageVariant === 1 /* JSX */) {
	                    // <UI.Test /* completion position */ />
	                    // If the tagname is a property access expression, we will then walk up to the top most of property access expression.
	                    // Then, try to get a JSX container and its associated attributes type.
	                    if (parent && parent.kind === 184 /* PropertyAccessExpression */) {
	                        contextToken = parent;
	                        parent = parent.parent;
	                    }
	                    // Fix location
	                    if (currentToken.parent === location) {
	                        switch (currentToken.kind) {
	                            case 29 /* GreaterThanToken */:
	                                if (currentToken.parent.kind === 254 /* JsxElement */ || currentToken.parent.kind === 256 /* JsxOpeningElement */) {
	                                    location = currentToken;
	                                }
	                                break;
	                            case 41 /* SlashToken */:
	                                if (currentToken.parent.kind === 255 /* JsxSelfClosingElement */) {
	                                    location = currentToken;
	                                }
	                                break;
	                        }
	                    }
	                    switch (parent.kind) {
	                        case 257 /* JsxClosingElement */:
	                            if (contextToken.kind === 41 /* SlashToken */) {
	                                isStartingCloseTag = true;
	                                location = contextToken;
	                            }
	                            break;
	                        case 199 /* BinaryExpression */:
	                            if (!(parent.left.flags & 32768 /* ThisNodeHasError */)) {
	                                // It has a left-hand side, so we're not in an opening JSX tag.
	                                break;
	                            }
	                        // falls through
	                        case 255 /* JsxSelfClosingElement */:
	                        case 254 /* JsxElement */:
	                        case 256 /* JsxOpeningElement */:
	                            if (contextToken.kind === 27 /* LessThanToken */) {
	                                isRightOfOpenTag = true;
	                                location = contextToken;
	                            }
	                            break;
	                        case 261 /* JsxAttribute */:
	                            switch (previousToken.kind) {
	                                case 58 /* EqualsToken */:
	                                    isJsxInitializer = true;
	                                    break;
	                                case 71 /* Identifier */:
	                                    // For `<div x=[|f/**/|]`, `parent` will be `x` and `previousToken.parent` will be `f` (which is its own JsxAttribute)
	                                    if (parent !== previousToken.parent && !parent.initializer) {
	                                        isJsxInitializer = previousToken;
	                                    }
	                            }
	                            break;
	                    }
	                }
	            }
	            var semanticStart = ts.timestamp();
	            var completionKind = 5 /* None */;
	            var isNewIdentifierLocation = false;
	            var keywordFilters = 0 /* None */;
	            var symbols = [];
	            var symbolToOriginInfoMap = [];
	            if (isRightOfDot) {
	                getTypeScriptMemberSymbols();
	            }
	            else if (isRightOfOpenTag) {
	                var tagSymbols = ts.Debug.assertEachDefined(typeChecker.getJsxIntrinsicTagNamesAt(location), "getJsxIntrinsicTagNames() should all be defined");
	                tryGetGlobalSymbols();
	                symbols = tagSymbols.concat(symbols);
	                completionKind = 3 /* MemberLike */;
	            }
	            else if (isStartingCloseTag) {
	                var tagName = contextToken.parent.parent.openingElement.tagName;
	                var tagSymbol = typeChecker.getSymbolAtLocation(tagName);
	                if (tagSymbol) {
	                    symbols = [tagSymbol];
	                }
	                completionKind = 3 /* MemberLike */;
	            }
	            else {
	                // For JavaScript or TypeScript, if we're not after a dot, then just try to get the
	                // global symbols in scope.  These results should be valid for either language as
	                // the set of symbols that can be referenced from this location.
	                if (!tryGetGlobalSymbols()) {
	                    return undefined;
	                }
	            }
	            log("getCompletionData: Semantic work: " + (ts.timestamp() - semanticStart));
	            var recommendedCompletion = previousToken && getRecommendedCompletion(previousToken, position, sourceFile, typeChecker);
	            return { kind: 0 /* Data */, symbols: symbols, completionKind: completionKind, isInSnippetScope: isInSnippetScope, propertyAccessToConvert: propertyAccessToConvert, isNewIdentifierLocation: isNewIdentifierLocation, location: location, keywordFilters: keywordFilters, symbolToOriginInfoMap: symbolToOriginInfoMap, recommendedCompletion: recommendedCompletion, previousToken: previousToken, isJsxInitializer: isJsxInitializer };
	            function isTagWithTypeExpression(tag) {
	                switch (tag.kind) {
	                    case 292 /* JSDocParameterTag */:
	                    case 297 /* JSDocPropertyTag */:
	                    case 293 /* JSDocReturnTag */:
	                    case 294 /* JSDocTypeTag */:
	                    case 296 /* JSDocTypedefTag */:
	                        return true;
	                }
	            }
	            function getTypeScriptMemberSymbols() {
	                // Right of dot member completion list
	                completionKind = 2 /* PropertyAccess */;
	                // Since this is qualified name check its a type node location
	                var isImportType = ts.isLiteralImportTypeNode(node);
	                var isTypeLocation = insideJsDocTagTypeExpression || (isImportType && !node.isTypeOf) || ts.isPartOfTypeNode(node.parent);
	                var isRhsOfImportDeclaration = ts.isInRightSideOfInternalImportEqualsDeclaration(node);
	                var allowTypeOrValue = isRhsOfImportDeclaration || (!isTypeLocation && ts.isPossiblyTypeArgumentPosition(contextToken, sourceFile));
	                if (ts.isEntityName(node) || isImportType) {
	                    var symbol = typeChecker.getSymbolAtLocation(node);
	                    if (symbol) {
	                        symbol = ts.skipAlias(symbol, typeChecker);
	                        if (symbol.flags & (1536 /* Module */ | 384 /* Enum */)) {
	                            // Extract module or enum members
	                            var exportedSymbols = ts.Debug.assertEachDefined(typeChecker.getExportsOfModule(symbol), "getExportsOfModule() should all be defined");
	                            var isValidValueAccess_1 = function (symbol) { return typeChecker.isValidPropertyAccess(isImportType ? node : (node.parent), symbol.name); };
	                            var isValidTypeAccess_1 = function (symbol) { return symbolCanBeReferencedAtTypeLocation(symbol); };
	                            var isValidAccess = allowTypeOrValue ?
	                                // Any kind is allowed when dotting off namespace in internal import equals declaration
	                                function (symbol) { return isValidTypeAccess_1(symbol) || isValidValueAccess_1(symbol); } :
	                                isTypeLocation ? isValidTypeAccess_1 : isValidValueAccess_1;
	                            for (var _i = 0, exportedSymbols_1 = exportedSymbols; _i < exportedSymbols_1.length; _i++) {
	                                var symbol_2 = exportedSymbols_1[_i];
	                                if (isValidAccess(symbol_2)) {
	                                    symbols.push(symbol_2);
	                                }
	                            }
	                            // If the module is merged with a value, we must get the type of the class and add its propertes (for inherited static methods).
	                            if (!isTypeLocation && symbol.declarations.some(function (d) { return d.kind !== 273 /* SourceFile */ && d.kind !== 238 /* ModuleDeclaration */ && d.kind !== 237 /* EnumDeclaration */; })) {
	                                addTypeProperties(typeChecker.getTypeOfSymbolAtLocation(symbol, node));
	                            }
	                            return;
	                        }
	                    }
	                }
	                if (!isTypeLocation) {
	                    addTypeProperties(typeChecker.getTypeAtLocation(node));
	                }
	            }
	            function addTypeProperties(type) {
	                isNewIdentifierLocation = hasIndexSignature(type);
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    // In javascript files, for union types, we don't just get the members that
	                    // the individual types have in common, we also include all the members that
	                    // each individual type has. This is because we're going to add all identifiers
	                    // anyways. So we might as well elevate the members that were at least part
	                    // of the individual types to a higher status since we know what they are.
	                    symbols.push.apply(symbols, getPropertiesForCompletion(type, typeChecker, /*isForAccess*/ true));
	                }
	                else {
	                    for (var _i = 0, _a = type.getApparentProperties(); _i < _a.length; _i++) {
	                        var symbol = _a[_i];
	                        if (typeChecker.isValidPropertyAccessForCompletions(node.kind === 178 /* ImportType */ ? node : node.parent, type, symbol)) {
	                            addPropertySymbol(symbol);
	                        }
	                    }
	                }
	            }
	            function addPropertySymbol(symbol) {
	                // If this is e.g. [Symbol.iterator], add a completion for `Symbol`.
	                var symbolSymbol = ts.firstDefined(symbol.declarations, function (decl) {
	                    var name = ts.getNameOfDeclaration(decl);
	                    var leftName = name.kind === 146 /* ComputedPropertyName */ ? getLeftMostName(name.expression) : undefined;
	                    return leftName && typeChecker.getSymbolAtLocation(leftName);
	                });
	                if (symbolSymbol) {
	                    symbols.push(symbolSymbol);
	                    symbolToOriginInfoMap[ts.getSymbolId(symbolSymbol)] = { type: "symbol-member" };
	                }
	                else {
	                    symbols.push(symbol);
	                }
	            }
	            /** Given 'a.b.c', returns 'a'. */
	            function getLeftMostName(e) {
	                return ts.isIdentifier(e) ? e : ts.isPropertyAccessExpression(e) ? getLeftMostName(e.expression) : undefined;
	            }
	            function tryGetGlobalSymbols() {
	                var result = tryGetObjectLikeCompletionSymbols()
	                    || tryGetImportOrExportClauseCompletionSymbols()
	                    || tryGetConstructorCompletion()
	                    || tryGetClassLikeCompletionSymbols()
	                    || tryGetJsxCompletionSymbols()
	                    || (getGlobalCompletions(), 1 /* Success */);
	                return result === 1 /* Success */;
	            }
	            function tryGetConstructorCompletion() {
	                if (!tryGetConstructorLikeCompletionContainer(contextToken))
	                    return 0 /* Continue */;
	                // no members, only keywords
	                completionKind = 5 /* None */;
	                // Declaring new property/method/accessor
	                isNewIdentifierLocation = true;
	                // Has keywords for constructor parameter
	                keywordFilters = 3 /* ConstructorParameterKeywords */;
	                return 1 /* Success */;
	            }
	            function tryGetJsxCompletionSymbols() {
	                var jsxContainer = tryGetContainingJsxElement(contextToken);
	                // Cursor is inside a JSX self-closing element or opening element
	                var attrsType = jsxContainer && typeChecker.getAllAttributesTypeFromJsxOpeningLikeElement(jsxContainer);
	                if (!attrsType)
	                    return 0 /* Continue */;
	                symbols = filterJsxAttributes(typeChecker.getPropertiesOfType(attrsType), jsxContainer.attributes.properties);
	                completionKind = 3 /* MemberLike */;
	                isNewIdentifierLocation = false;
	                return 1 /* Success */;
	            }
	            function getGlobalCompletions() {
	                if (tryGetFunctionLikeBodyCompletionContainer(contextToken)) {
	                    keywordFilters = 4 /* FunctionLikeBodyKeywords */;
	                }
	                // Get all entities in the current scope.
	                completionKind = 1 /* Global */;
	                isNewIdentifierLocation = isNewIdentifierDefinitionLocation(contextToken);
	                if (previousToken !== contextToken) {
	                    ts.Debug.assert(!!previousToken, "Expected 'contextToken' to be defined when different from 'previousToken'.");
	                }
	                // We need to find the node that will give us an appropriate scope to begin
	                // aggregating completion candidates. This is achieved in 'getScopeNode'
	                // by finding the first node that encompasses a position, accounting for whether a node
	                // is "complete" to decide whether a position belongs to the node.
	                //
	                // However, at the end of an identifier, we are interested in the scope of the identifier
	                // itself, but fall outside of the identifier. For instance:
	                //
	                //      xyz => x$
	                //
	                // the cursor is outside of both the 'x' and the arrow function 'xyz => x',
	                // so 'xyz' is not returned in our results.
	                //
	                // We define 'adjustedPosition' so that we may appropriately account for
	                // being at the end of an identifier. The intention is that if requesting completion
	                // at the end of an identifier, it should be effectively equivalent to requesting completion
	                // anywhere inside/at the beginning of the identifier. So in the previous case, the
	                // 'adjustedPosition' will work as if requesting completion in the following:
	                //
	                //      xyz => $x
	                //
	                // If previousToken !== contextToken, then
	                //   - 'contextToken' was adjusted to the token prior to 'previousToken'
	                //      because we were at the end of an identifier.
	                //   - 'previousToken' is defined.
	                var adjustedPosition = previousToken !== contextToken ?
	                    previousToken.getStart() :
	                    position;
	                var scopeNode = getScopeNode(contextToken, adjustedPosition, sourceFile) || sourceFile;
	                isInSnippetScope = isSnippetScope(scopeNode);
	                var symbolMeanings = 67901928 /* Type */ | 67216319 /* Value */ | 1920 /* Namespace */ | 2097152 /* Alias */;
	                symbols = ts.Debug.assertEachDefined(typeChecker.getSymbolsInScope(scopeNode, symbolMeanings), "getSymbolsInScope() should all be defined");
	                // Need to insert 'this.' before properties of `this` type, so only do that if `includeInsertTextCompletions`
	                if (preferences.includeCompletionsWithInsertText && scopeNode.kind !== 273 /* SourceFile */) {
	                    var thisType = typeChecker.tryGetThisTypeAt(scopeNode);
	                    if (thisType) {
	                        for (var _i = 0, _a = getPropertiesForCompletion(thisType, typeChecker, /*isForAccess*/ true); _i < _a.length; _i++) {
	                            var symbol = _a[_i];
	                            symbolToOriginInfoMap[ts.getSymbolId(symbol)] = { type: "this-type" };
	                            symbols.push(symbol);
	                        }
	                    }
	                }
	                if (shouldOfferImportCompletions()) {
	                    getSymbolsFromOtherSourceFileExports(symbols, previousToken && ts.isIdentifier(previousToken) ? previousToken.text : "", program.getCompilerOptions().target);
	                }
	                filterGlobalCompletion(symbols);
	            }
	            function shouldOfferImportCompletions() {
	                // If not already a module, must have modules enabled and not currently be in a commonjs module. (TODO: import completions for commonjs)
	                if (!preferences.includeCompletionsForModuleExports)
	                    return false;
	                // If already using ES6 modules, OK to continue using them.
	                if (sourceFile.externalModuleIndicator)
	                    return true;
	                // If already using commonjs, don't introduce ES6.
	                if (sourceFile.commonJsModuleIndicator)
	                    return false;
	                // If some file is using ES6 modules, assume that it's OK to add more.
	                if (ts.programContainsEs6Modules(program))
	                    return true;
	                // For JS, stay on the safe side.
	                if (ts.isSourceFileJavaScript(sourceFile))
	                    return false;
	                // If module transpilation is enabled or we're targeting es6 or above, or not emitting, OK.
	                return ts.compilerOptionsIndicateEs6Modules(program.getCompilerOptions());
	            }
	            function isSnippetScope(scopeNode) {
	                switch (scopeNode.kind) {
	                    case 273 /* SourceFile */:
	                    case 201 /* TemplateExpression */:
	                    case 264 /* JsxExpression */:
	                    case 212 /* Block */:
	                        return true;
	                    default:
	                        return ts.isStatement(scopeNode);
	                }
	            }
	            function filterGlobalCompletion(symbols) {
	                var isTypeOnlyCompletion = insideJsDocTagTypeExpression || !isContextTokenValueLocation(contextToken) && (ts.isPartOfTypeNode(location) || isContextTokenTypeLocation(contextToken));
	                var allowTypes = isTypeOnlyCompletion || !isContextTokenValueLocation(contextToken) && ts.isPossiblyTypeArgumentPosition(contextToken, sourceFile);
	                if (isTypeOnlyCompletion)
	                    keywordFilters = 5 /* TypeKeywords */;
	                ts.filterMutate(symbols, function (symbol) {
	                    if (!ts.isSourceFile(location)) {
	                        // export = /**/ here we want to get all meanings, so any symbol is ok
	                        if (ts.isExportAssignment(location.parent)) {
	                            return true;
	                        }
	                        symbol = ts.skipAlias(symbol, typeChecker);
	                        // import m = /**/ <-- It can only access namespace (if typing import = x. this would get member symbols and not namespace)
	                        if (ts.isInRightSideOfInternalImportEqualsDeclaration(location)) {
	                            return !!(symbol.flags & 1920 /* Namespace */);
	                        }
	                        if (allowTypes) {
	                            // Its a type, but you can reach it by namespace.type as well
	                            var symbolAllowedAsType = symbolCanBeReferencedAtTypeLocation(symbol);
	                            if (symbolAllowedAsType || isTypeOnlyCompletion) {
	                                return symbolAllowedAsType;
	                            }
	                        }
	                    }
	                    // expressions are value space (which includes the value namespaces)
	                    return !!(ts.getCombinedLocalAndExportSymbolFlags(symbol) & 67216319 /* Value */);
	                });
	            }
	            function isContextTokenValueLocation(contextToken) {
	                return contextToken &&
	                    contextToken.kind === 103 /* TypeOfKeyword */ &&
	                    (contextToken.parent.kind === 164 /* TypeQuery */ || ts.isTypeOfExpression(contextToken.parent));
	            }
	            function isContextTokenTypeLocation(contextToken) {
	                if (contextToken) {
	                    var parentKind = contextToken.parent.kind;
	                    switch (contextToken.kind) {
	                        case 56 /* ColonToken */:
	                            return parentKind === 151 /* PropertyDeclaration */ ||
	                                parentKind === 150 /* PropertySignature */ ||
	                                parentKind === 148 /* Parameter */ ||
	                                parentKind === 231 /* VariableDeclaration */ ||
	                                ts.isFunctionLikeKind(parentKind);
	                        case 58 /* EqualsToken */:
	                            return parentKind === 236 /* TypeAliasDeclaration */;
	                        case 118 /* AsKeyword */:
	                            return parentKind === 207 /* AsExpression */;
	                    }
	                }
	                return false;
	            }
	            function symbolCanBeReferencedAtTypeLocation(symbol) {
	                symbol = symbol.exportSymbol || symbol;
	                // This is an alias, follow what it aliases
	                symbol = ts.skipAlias(symbol, typeChecker);
	                if (symbol.flags & 67901928 /* Type */) {
	                    return true;
	                }
	                if (symbol.flags & 1536 /* Module */) {
	                    var exportedSymbols = typeChecker.getExportsOfModule(symbol);
	                    // If the exported symbols contains type,
	                    // symbol can be referenced at locations where type is allowed
	                    return exportedSymbols.some(symbolCanBeReferencedAtTypeLocation);
	                }
	            }
	            function getSymbolsFromOtherSourceFileExports(symbols, tokenText, target) {
	                var tokenTextLowerCase = tokenText.toLowerCase();
	                ts.codefix.forEachExternalModuleToImportFrom(typeChecker, sourceFile, program.getSourceFiles(), function (moduleSymbol) {
	                    // Perf -- ignore other modules if this is a request for details
	                    if (detailsEntryId && detailsEntryId.source && ts.stripQuotes(moduleSymbol.name) !== detailsEntryId.source) {
	                        return;
	                    }
	                    for (var _i = 0, _a = typeChecker.getExportsOfModule(moduleSymbol); _i < _a.length; _i++) {
	                        var symbol = _a[_i];
	                        // Don't add a completion for a re-export, only for the original.
	                        // The actual import fix might end up coming from a re-export -- we don't compute that until getting completion details.
	                        // This is just to avoid adding duplicate completion entries.
	                        //
	                        // If `symbol.parent !== ...`, this comes from an `export * from "foo"` re-export. Those don't create new symbols.
	                        // If `some(...)`, this comes from an `export { foo } from "foo"` re-export, which creates a new symbol (thus isn't caught by the first check).
	                        if (typeChecker.getMergedSymbol(symbol.parent) !== typeChecker.resolveExternalModuleSymbol(moduleSymbol)
	                            || ts.some(symbol.declarations, function (d) { return ts.isExportSpecifier(d) && !!d.parent.parent.moduleSpecifier; })) {
	                            continue;
	                        }
	                        var isDefaultExport = symbol.name === "default" /* Default */;
	                        if (isDefaultExport) {
	                            symbol = ts.getLocalSymbolForExportDefault(symbol) || symbol;
	                        }
	                        var origin = { type: "export", moduleSymbol: moduleSymbol, isDefaultExport: isDefaultExport };
	                        if (detailsEntryId || stringContainsCharactersInOrder(getSymbolName(symbol, origin, target).toLowerCase(), tokenTextLowerCase)) {
	                            symbols.push(symbol);
	                            symbolToOriginInfoMap[ts.getSymbolId(symbol)] = origin;
	                        }
	                    }
	                });
	            }
	            /**
	             * True if you could remove some characters in `a` to get `b`.
	             * E.g., true for "abcdef" and "bdf".
	             * But not true for "abcdef" and "dbf".
	             */
	            function stringContainsCharactersInOrder(str, characters) {
	                if (characters.length === 0) {
	                    return true;
	                }
	                var characterIndex = 0;
	                for (var strIndex = 0; strIndex < str.length; strIndex++) {
	                    if (str.charCodeAt(strIndex) === characters.charCodeAt(characterIndex)) {
	                        characterIndex++;
	                        if (characterIndex === characters.length) {
	                            return true;
	                        }
	                    }
	                }
	                // Did not find all characters
	                return false;
	            }
	            /**
	             * Finds the first node that "embraces" the position, so that one may
	             * accurately aggregate locals from the closest containing scope.
	             */
	            function getScopeNode(initialToken, position, sourceFile) {
	                var scope = initialToken;
	                while (scope && !ts.positionBelongsToNode(scope, position, sourceFile)) {
	                    scope = scope.parent;
	                }
	                return scope;
	            }
	            function isCompletionListBlocker(contextToken) {
	                var start = ts.timestamp();
	                var result = isInStringOrRegularExpressionOrTemplateLiteral(contextToken) ||
	                    isSolelyIdentifierDefinitionLocation(contextToken) ||
	                    isDotOfNumericLiteral(contextToken) ||
	                    isInJsxText(contextToken);
	                log("getCompletionsAtPosition: isCompletionListBlocker: " + (ts.timestamp() - start));
	                return result;
	            }
	            function isInJsxText(contextToken) {
	                if (contextToken.kind === 10 /* JsxText */) {
	                    return true;
	                }
	                if (contextToken.kind === 29 /* GreaterThanToken */ && contextToken.parent) {
	                    if (contextToken.parent.kind === 256 /* JsxOpeningElement */) {
	                        return true;
	                    }
	                    if (contextToken.parent.kind === 257 /* JsxClosingElement */ || contextToken.parent.kind === 255 /* JsxSelfClosingElement */) {
	                        return contextToken.parent.parent && contextToken.parent.parent.kind === 254 /* JsxElement */;
	                    }
	                }
	                return false;
	            }
	            function isNewIdentifierDefinitionLocation(previousToken) {
	                if (previousToken) {
	                    var containingNodeKind = previousToken.parent.kind;
	                    switch (previousToken.kind) {
	                        case 26 /* CommaToken */:
	                            return containingNodeKind === 186 /* CallExpression */ // func( a, |
	                                || containingNodeKind === 154 /* Constructor */ // constructor( a, |   /* public, protected, private keywords are allowed here, so show completion */
	                                || containingNodeKind === 187 /* NewExpression */ // new C(a, |
	                                || containingNodeKind === 182 /* ArrayLiteralExpression */ // [a, |
	                                || containingNodeKind === 199 /* BinaryExpression */ // const x = (a, |
	                                || containingNodeKind === 162 /* FunctionType */; // var x: (s: string, list|
	                        case 19 /* OpenParenToken */:
	                            return containingNodeKind === 186 /* CallExpression */ // func( |
	                                || containingNodeKind === 154 /* Constructor */ // constructor( |
	                                || containingNodeKind === 187 /* NewExpression */ // new C(a|
	                                || containingNodeKind === 190 /* ParenthesizedExpression */ // const x = (a|
	                                || containingNodeKind === 172 /* ParenthesizedType */; // function F(pred: (a| /* this can become an arrow function, where 'a' is the argument */
	                        case 21 /* OpenBracketToken */:
	                            return containingNodeKind === 182 /* ArrayLiteralExpression */ // [ |
	                                || containingNodeKind === 159 /* IndexSignature */ // [ | : string ]
	                                || containingNodeKind === 146 /* ComputedPropertyName */; // [ |    /* this can become an index signature */
	                        case 129 /* ModuleKeyword */: // module |
	                        case 130 /* NamespaceKeyword */: // namespace |
	                            return true;
	                        case 23 /* DotToken */:
	                            return containingNodeKind === 238 /* ModuleDeclaration */; // module A.|
	                        case 17 /* OpenBraceToken */:
	                            return containingNodeKind === 234 /* ClassDeclaration */; // class A{ |
	                        case 58 /* EqualsToken */:
	                            return containingNodeKind === 231 /* VariableDeclaration */ // const x = a|
	                                || containingNodeKind === 199 /* BinaryExpression */; // x = a|
	                        case 14 /* TemplateHead */:
	                            return containingNodeKind === 201 /* TemplateExpression */; // `aa ${|
	                        case 15 /* TemplateMiddle */:
	                            return containingNodeKind === 210 /* TemplateSpan */; // `aa ${10} dd ${|
	                        case 114 /* PublicKeyword */:
	                        case 112 /* PrivateKeyword */:
	                        case 113 /* ProtectedKeyword */:
	                            return containingNodeKind === 151 /* PropertyDeclaration */; // class A{ public |
	                    }
	                    // Previous token may have been a keyword that was converted to an identifier.
	                    switch (keywordForNode(previousToken)) {
	                        case 114 /* PublicKeyword */:
	                        case 113 /* ProtectedKeyword */:
	                        case 112 /* PrivateKeyword */:
	                            return true;
	                    }
	                }
	                return false;
	            }
	            function isInStringOrRegularExpressionOrTemplateLiteral(contextToken) {
	                if (contextToken.kind === 9 /* StringLiteral */
	                    || contextToken.kind === 12 /* RegularExpressionLiteral */
	                    || ts.isTemplateLiteralKind(contextToken.kind)) {
	                    var start_5 = contextToken.getStart();
	                    var end = contextToken.getEnd();
	                    // To be "in" one of these literals, the position has to be:
	                    //   1. entirely within the token text.
	                    //   2. at the end position of an unterminated token.
	                    //   3. at the end of a regular expression (due to trailing flags like '/foo/g').
	                    if (start_5 < position && position < end) {
	                        return true;
	                    }
	                    if (position === end) {
	                        return !!contextToken.isUnterminated
	                            || contextToken.kind === 12 /* RegularExpressionLiteral */;
	                    }
	                }
	                return false;
	            }
	            /**
	             * Aggregates relevant symbols for completion in object literals and object binding patterns.
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             *
	             * @returns true if 'symbols' was successfully populated; false otherwise.
	             */
	            function tryGetObjectLikeCompletionSymbols() {
	                var objectLikeContainer = tryGetObjectLikeCompletionContainer(contextToken);
	                if (!objectLikeContainer)
	                    return 0 /* Continue */;
	                // We're looking up possible property names from contextual/inferred/declared type.
	                completionKind = 0 /* ObjectPropertyDeclaration */;
	                var typeMembers;
	                var existingMembers;
	                if (objectLikeContainer.kind === 183 /* ObjectLiteralExpression */) {
	                    var typeForObject = typeChecker.getContextualType(objectLikeContainer);
	                    if (!typeForObject)
	                        return 2 /* Fail */;
	                    isNewIdentifierLocation = hasIndexSignature(typeForObject);
	                    typeMembers = getPropertiesForCompletion(typeForObject, typeChecker, /*isForAccess*/ false);
	                    existingMembers = objectLikeContainer.properties;
	                }
	                else {
	                    ts.Debug.assert(objectLikeContainer.kind === 179 /* ObjectBindingPattern */);
	                    // We are *only* completing on properties from the type being destructured.
	                    isNewIdentifierLocation = false;
	                    var rootDeclaration = ts.getRootDeclaration(objectLikeContainer.parent);
	                    if (!ts.isVariableLike(rootDeclaration))
	                        return ts.Debug.fail("Root declaration is not variable-like.");
	                    // We don't want to complete using the type acquired by the shape
	                    // of the binding pattern; we are only interested in types acquired
	                    // through type declaration or inference.
	                    // Also proceed if rootDeclaration is a parameter and if its containing function expression/arrow function is contextually typed -
	                    // type of parameter will flow in from the contextual type of the function
	                    var canGetType = ts.hasInitializer(rootDeclaration) || ts.hasType(rootDeclaration) || rootDeclaration.parent.parent.kind === 221 /* ForOfStatement */;
	                    if (!canGetType && rootDeclaration.kind === 148 /* Parameter */) {
	                        if (ts.isExpression(rootDeclaration.parent)) {
	                            canGetType = !!typeChecker.getContextualType(rootDeclaration.parent);
	                        }
	                        else if (rootDeclaration.parent.kind === 153 /* MethodDeclaration */ || rootDeclaration.parent.kind === 156 /* SetAccessor */) {
	                            canGetType = ts.isExpression(rootDeclaration.parent.parent) && !!typeChecker.getContextualType(rootDeclaration.parent.parent);
	                        }
	                    }
	                    if (canGetType) {
	                        var typeForObject = typeChecker.getTypeAtLocation(objectLikeContainer);
	                        if (!typeForObject)
	                            return 2 /* Fail */;
	                        // In a binding pattern, get only known properties. Everywhere else we will get all possible properties.
	                        typeMembers = typeChecker.getPropertiesOfType(typeForObject).filter(function (symbol) { return !(ts.getDeclarationModifierFlagsFromSymbol(symbol) & 24 /* NonPublicAccessibilityModifier */); });
	                        existingMembers = objectLikeContainer.elements;
	                    }
	                }
	                if (typeMembers && typeMembers.length > 0) {
	                    // Add filtered items to the completion list
	                    symbols = filterObjectMembersList(typeMembers, ts.Debug.assertDefined(existingMembers));
	                }
	                return 1 /* Success */;
	            }
	            /**
	             * Aggregates relevant symbols for completion in import clauses and export clauses
	             * whose declarations have a module specifier; for instance, symbols will be aggregated for
	             *
	             *      import { | } from "moduleName";
	             *      export { a as foo, | } from "moduleName";
	             *
	             * but not for
	             *
	             *      export { | };
	             *
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             *
	             * @returns true if 'symbols' was successfully populated; false otherwise.
	             */
	            function tryGetImportOrExportClauseCompletionSymbols() {
	                // `import { |` or `import { a as 0, | }`
	                var namedImportsOrExports = contextToken && (contextToken.kind === 17 /* OpenBraceToken */ || contextToken.kind === 26 /* CommaToken */)
	                    ? ts.tryCast(contextToken.parent, ts.isNamedImportsOrExports) : undefined;
	                if (!namedImportsOrExports)
	                    return 0 /* Continue */;
	                // cursor is in an import clause
	                // try to show exported member for imported module
	                var moduleSpecifier = (namedImportsOrExports.kind === 246 /* NamedImports */ ? namedImportsOrExports.parent.parent : namedImportsOrExports.parent).moduleSpecifier;
	                var moduleSpecifierSymbol = typeChecker.getSymbolAtLocation(moduleSpecifier);
	                if (!moduleSpecifierSymbol)
	                    return 2 /* Fail */;
	                completionKind = 3 /* MemberLike */;
	                isNewIdentifierLocation = false;
	                var exports = typeChecker.getExportsAndPropertiesOfModule(moduleSpecifierSymbol);
	                var existing = ts.arrayToSet(namedImportsOrExports.elements, function (n) { return isCurrentlyEditingNode(n) ? undefined : (n.propertyName || n.name).escapedText; });
	                symbols = exports.filter(function (e) { return e.escapedName !== "default" /* Default */ && !existing.get(e.escapedName); });
	                return 1 /* Success */;
	            }
	            /**
	             * Aggregates relevant symbols for completion in class declaration
	             * Relevant symbols are stored in the captured 'symbols' variable.
	             */
	            function tryGetClassLikeCompletionSymbols() {
	                var decl = tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location);
	                if (!decl)
	                    return 0 /* Continue */;
	                // We're looking up possible property names from parent type.
	                completionKind = 3 /* MemberLike */;
	                // Declaring new property/method/accessor
	                isNewIdentifierLocation = true;
	                keywordFilters = ts.isClassLike(decl) ? 1 /* ClassElementKeywords */ : 2 /* InterfaceElementKeywords */;
	                // If you're in an interface you don't want to repeat things from super-interface. So just stop here.
	                if (!ts.isClassLike(decl))
	                    return 1 /* Success */;
	                var classElement = contextToken.parent;
	                var classElementModifierFlags = ts.isClassElement(classElement) && ts.getModifierFlags(classElement);
	                // If this is context token is not something we are editing now, consider if this would lead to be modifier
	                if (contextToken.kind === 71 /* Identifier */ && !isCurrentlyEditingNode(contextToken)) {
	                    switch (contextToken.getText()) {
	                        case "private":
	                            classElementModifierFlags = classElementModifierFlags | 8 /* Private */;
	                            break;
	                        case "static":
	                            classElementModifierFlags = classElementModifierFlags | 32 /* Static */;
	                            break;
	                    }
	                }
	                // No member list for private methods
	                if (!(classElementModifierFlags & 8 /* Private */)) {
	                    // List of property symbols of base type that are not private and already implemented
	                    var baseSymbols = ts.flatMap(ts.getAllSuperTypeNodes(decl), function (baseTypeNode) {
	                        var type = typeChecker.getTypeAtLocation(baseTypeNode);
	                        return typeChecker.getPropertiesOfType(classElementModifierFlags & 32 /* Static */ ? typeChecker.getTypeOfSymbolAtLocation(type.symbol, decl) : type);
	                    });
	                    symbols = filterClassMembersList(baseSymbols, decl.members, classElementModifierFlags);
	                }
	                return 1 /* Success */;
	            }
	            /**
	             * Returns the immediate owning object literal or binding pattern of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetObjectLikeCompletionContainer(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 17 /* OpenBraceToken */: // const x = { |
	                        case 26 /* CommaToken */: // const x = { a: 0, |
	                            var parent = contextToken.parent;
	                            if (ts.isObjectLiteralExpression(parent) || ts.isObjectBindingPattern(parent)) {
	                                return parent;
	                            }
	                            break;
	                    }
	                }
	                return undefined;
	            }
	            function isConstructorParameterCompletion(node) {
	                return !!node.parent && ts.isParameter(node.parent) && ts.isConstructorDeclaration(node.parent.parent)
	                    && (ts.isParameterPropertyModifier(node.kind) || ts.isDeclarationName(node));
	            }
	            /**
	             * Returns the immediate owning class declaration of a context token,
	             * on the condition that one exists and that the context implies completion should be given.
	             */
	            function tryGetConstructorLikeCompletionContainer(contextToken) {
	                if (contextToken) {
	                    switch (contextToken.kind) {
	                        case 19 /* OpenParenToken */:
	                        case 26 /* CommaToken */:
	                            return ts.isConstructorDeclaration(contextToken.parent) && contextToken.parent;
	                        default:
	                            if (isConstructorParameterCompletion(contextToken)) {
	                                return contextToken.parent.parent;
	                            }
	                    }
	                }
	                return undefined;
	            }
	            function tryGetFunctionLikeBodyCompletionContainer(contextToken) {
	                if (contextToken) {
	                    var prev_1;
	                    var container = ts.findAncestor(contextToken.parent, function (node) {
	                        if (ts.isClassLike(node)) {
	                            return "quit";
	                        }
	                        if (ts.isFunctionLikeDeclaration(node) && prev_1 === node.body) {
	                            return true;
	                        }
	                        prev_1 = node;
	                    });
	                    return container && container;
	                }
	            }
	            function tryGetContainingJsxElement(contextToken) {
	                if (contextToken) {
	                    var parent = contextToken.parent;
	                    switch (contextToken.kind) {
	                        case 28 /* LessThanSlashToken */:
	                        case 41 /* SlashToken */:
	                        case 71 /* Identifier */:
	                        case 184 /* PropertyAccessExpression */:
	                        case 262 /* JsxAttributes */:
	                        case 261 /* JsxAttribute */:
	                        case 263 /* JsxSpreadAttribute */:
	                            if (parent && (parent.kind === 255 /* JsxSelfClosingElement */ || parent.kind === 256 /* JsxOpeningElement */)) {
	                                return parent;
	                            }
	                            else if (parent.kind === 261 /* JsxAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                        // The context token is the closing } or " of an attribute, which means
	                        // its parent is a JsxExpression, whose parent is a JsxAttribute,
	                        // whose parent is a JsxOpeningLikeElement
	                        case 9 /* StringLiteral */:
	                            if (parent && ((parent.kind === 261 /* JsxAttribute */) || (parent.kind === 263 /* JsxSpreadAttribute */))) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                        case 18 /* CloseBraceToken */:
	                            if (parent &&
	                                parent.kind === 264 /* JsxExpression */ &&
	                                parent.parent && parent.parent.kind === 261 /* JsxAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                //                  each JsxAttribute can have initializer as JsxExpression
	                                return parent.parent.parent.parent;
	                            }
	                            if (parent && parent.kind === 263 /* JsxSpreadAttribute */) {
	                                // Currently we parse JsxOpeningLikeElement as:
	                                //      JsxOpeningLikeElement
	                                //          attributes: JsxAttributes
	                                //             properties: NodeArray<JsxAttributeLike>
	                                return parent.parent.parent;
	                            }
	                            break;
	                    }
	                }
	                return undefined;
	            }
	            /**
	             * @returns true if we are certain that the currently edited location must define a new location; false otherwise.
	             */
	            function isSolelyIdentifierDefinitionLocation(contextToken) {
	                var containingNodeKind = contextToken.parent.kind;
	                switch (contextToken.kind) {
	                    case 26 /* CommaToken */:
	                        return containingNodeKind === 231 /* VariableDeclaration */ ||
	                            containingNodeKind === 232 /* VariableDeclarationList */ ||
	                            containingNodeKind === 213 /* VariableStatement */ ||
	                            containingNodeKind === 237 /* EnumDeclaration */ || // enum a { foo, |
	                            isFunctionLikeButNotConstructor(containingNodeKind) ||
	                            containingNodeKind === 235 /* InterfaceDeclaration */ || // interface A<T, |
	                            containingNodeKind === 180 /* ArrayBindingPattern */ || // var [x, y|
	                            containingNodeKind === 236 /* TypeAliasDeclaration */ || // type Map, K, |
	                            // class A<T, |
	                            // var C = class D<T, |
	                            (ts.isClassLike(contextToken.parent) &&
	                                contextToken.parent.typeParameters &&
	                                contextToken.parent.typeParameters.end >= contextToken.pos);
	                    case 23 /* DotToken */:
	                        return containingNodeKind === 180 /* ArrayBindingPattern */; // var [.|
	                    case 56 /* ColonToken */:
	                        return containingNodeKind === 181 /* BindingElement */; // var {x :html|
	                    case 21 /* OpenBracketToken */:
	                        return containingNodeKind === 180 /* ArrayBindingPattern */; // var [x|
	                    case 19 /* OpenParenToken */:
	                        return containingNodeKind === 268 /* CatchClause */ ||
	                            isFunctionLikeButNotConstructor(containingNodeKind);
	                    case 17 /* OpenBraceToken */:
	                        return containingNodeKind === 237 /* EnumDeclaration */; // enum a { |
	                    case 27 /* LessThanToken */:
	                        return containingNodeKind === 234 /* ClassDeclaration */ || // class A< |
	                            containingNodeKind === 204 /* ClassExpression */ || // var C = class D< |
	                            containingNodeKind === 235 /* InterfaceDeclaration */ || // interface A< |
	                            containingNodeKind === 236 /* TypeAliasDeclaration */ || // type List< |
	                            ts.isFunctionLikeKind(containingNodeKind);
	                    case 115 /* StaticKeyword */:
	                        return containingNodeKind === 151 /* PropertyDeclaration */ && !ts.isClassLike(contextToken.parent.parent);
	                    case 24 /* DotDotDotToken */:
	                        return containingNodeKind === 148 /* Parameter */ ||
	                            (contextToken.parent && contextToken.parent.parent &&
	                                contextToken.parent.parent.kind === 180 /* ArrayBindingPattern */); // var [...z|
	                    case 114 /* PublicKeyword */:
	                    case 112 /* PrivateKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                        return containingNodeKind === 148 /* Parameter */ && !ts.isConstructorDeclaration(contextToken.parent.parent);
	                    case 118 /* AsKeyword */:
	                        return containingNodeKind === 247 /* ImportSpecifier */ ||
	                            containingNodeKind === 251 /* ExportSpecifier */ ||
	                            containingNodeKind === 245 /* NamespaceImport */;
	                    case 125 /* GetKeyword */:
	                    case 136 /* SetKeyword */:
	                        if (isFromObjectTypeDeclaration(contextToken)) {
	                            return false;
	                        }
	                    // falls through
	                    case 75 /* ClassKeyword */:
	                    case 83 /* EnumKeyword */:
	                    case 109 /* InterfaceKeyword */:
	                    case 89 /* FunctionKeyword */:
	                    case 104 /* VarKeyword */:
	                    case 91 /* ImportKeyword */:
	                    case 110 /* LetKeyword */:
	                    case 76 /* ConstKeyword */:
	                    case 116 /* YieldKeyword */:
	                    case 139 /* TypeKeyword */: // type htm|
	                        return true;
	                }
	                // If the previous token is keyword correspoding to class member completion keyword
	                // there will be completion available here
	                if (isClassMemberCompletionKeyword(keywordForNode(contextToken)) && isFromObjectTypeDeclaration(contextToken)) {
	                    return false;
	                }
	                if (isConstructorParameterCompletion(contextToken)) {
	                    // constructor parameter completion is available only if
	                    // - its modifier of the constructor parameter or
	                    // - its name of the parameter and not being edited
	                    // eg. constructor(a |<- this shouldnt show completion
	                    if (!ts.isIdentifier(contextToken) ||
	                        ts.isParameterPropertyModifier(keywordForNode(contextToken)) ||
	                        isCurrentlyEditingNode(contextToken)) {
	                        return false;
	                    }
	                }
	                // Previous token may have been a keyword that was converted to an identifier.
	                switch (keywordForNode(contextToken)) {
	                    case 117 /* AbstractKeyword */:
	                    case 120 /* AsyncKeyword */:
	                    case 75 /* ClassKeyword */:
	                    case 76 /* ConstKeyword */:
	                    case 124 /* DeclareKeyword */:
	                    case 83 /* EnumKeyword */:
	                    case 89 /* FunctionKeyword */:
	                    case 109 /* InterfaceKeyword */:
	                    case 110 /* LetKeyword */:
	                    case 112 /* PrivateKeyword */:
	                    case 113 /* ProtectedKeyword */:
	                    case 114 /* PublicKeyword */:
	                    case 115 /* StaticKeyword */:
	                    case 104 /* VarKeyword */:
	                    case 116 /* YieldKeyword */:
	                        return true;
	                }
	                return ts.isDeclarationName(contextToken)
	                    && !ts.isJsxAttribute(contextToken.parent)
	                    // Don't block completions if we're in `class C /**/`, because we're *past* the end of the identifier and might want to complete `extends`.
	                    // If `contextToken !== previousToken`, this is `class C ex/**/`.
	                    && !(ts.isClassLike(contextToken.parent) && (contextToken !== previousToken || position > previousToken.end));
	            }
	            function isFunctionLikeButNotConstructor(kind) {
	                return ts.isFunctionLikeKind(kind) && kind !== 154 /* Constructor */;
	            }
	            function isDotOfNumericLiteral(contextToken) {
	                if (contextToken.kind === 8 /* NumericLiteral */) {
	                    var text = contextToken.getFullText();
	                    return text.charAt(text.length - 1) === ".";
	                }
	                return false;
	            }
	            /**
	             * Filters out completion suggestions for named imports or exports.
	             *
	             * @returns Symbols to be suggested in an object binding pattern or object literal expression, barring those whose declarations
	             *          do not occur at the current position and have not otherwise been typed.
	             */
	            function filterObjectMembersList(contextualMemberSymbols, existingMembers) {
	                if (existingMembers.length === 0) {
	                    return contextualMemberSymbols;
	                }
	                var existingMemberNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, existingMembers_1 = existingMembers; _i < existingMembers_1.length; _i++) {
	                    var m = existingMembers_1[_i];
	                    // Ignore omitted expressions for missing members
	                    if (m.kind !== 269 /* PropertyAssignment */ &&
	                        m.kind !== 270 /* ShorthandPropertyAssignment */ &&
	                        m.kind !== 181 /* BindingElement */ &&
	                        m.kind !== 153 /* MethodDeclaration */ &&
	                        m.kind !== 155 /* GetAccessor */ &&
	                        m.kind !== 156 /* SetAccessor */) {
	                        continue;
	                    }
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(m)) {
	                        continue;
	                    }
	                    var existingName = void 0;
	                    if (m.kind === 181 /* BindingElement */ && m.propertyName) {
	                        // include only identifiers in completion list
	                        if (m.propertyName.kind === 71 /* Identifier */) {
	                            existingName = m.propertyName.escapedText;
	                        }
	                    }
	                    else {
	                        // TODO: Account for computed property name
	                        // NOTE: if one only performs this step when m.name is an identifier,
	                        // things like '__proto__' are not filtered out.
	                        var name = ts.getNameOfDeclaration(m);
	                        existingName = ts.isPropertyNameLiteral(name) ? ts.getEscapedTextOfIdentifierOrLiteral(name) : undefined;
	                    }
	                    existingMemberNames.set(existingName, true);
	                }
	                return contextualMemberSymbols.filter(function (m) { return !existingMemberNames.get(m.escapedName); });
	            }
	            /**
	             * Filters out completion suggestions for class elements.
	             *
	             * @returns Symbols to be suggested in an class element depending on existing memebers and symbol flags
	             */
	            function filterClassMembersList(baseSymbols, existingMembers, currentClassElementModifierFlags) {
	                var existingMemberNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, existingMembers_2 = existingMembers; _i < existingMembers_2.length; _i++) {
	                    var m = existingMembers_2[_i];
	                    // Ignore omitted expressions for missing members
	                    if (m.kind !== 151 /* PropertyDeclaration */ &&
	                        m.kind !== 153 /* MethodDeclaration */ &&
	                        m.kind !== 155 /* GetAccessor */ &&
	                        m.kind !== 156 /* SetAccessor */) {
	                        continue;
	                    }
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(m)) {
	                        continue;
	                    }
	                    // Dont filter member even if the name matches if it is declared private in the list
	                    if (ts.hasModifier(m, 8 /* Private */)) {
	                        continue;
	                    }
	                    // do not filter it out if the static presence doesnt match
	                    if (ts.hasModifier(m, 32 /* Static */) !== !!(currentClassElementModifierFlags & 32 /* Static */)) {
	                        continue;
	                    }
	                    var existingName = ts.getPropertyNameForPropertyNameNode(m.name);
	                    if (existingName) {
	                        existingMemberNames.set(existingName, true);
	                    }
	                }
	                return baseSymbols.filter(function (propertySymbol) {
	                    return !existingMemberNames.has(propertySymbol.escapedName) &&
	                        !!propertySymbol.declarations &&
	                        !(ts.getDeclarationModifierFlagsFromSymbol(propertySymbol) & 8 /* Private */);
	                });
	            }
	            /**
	             * Filters out completion suggestions from 'symbols' according to existing JSX attributes.
	             *
	             * @returns Symbols to be suggested in a JSX element, barring those whose attributes
	             *          do not occur at the current position and have not otherwise been typed.
	             */
	            function filterJsxAttributes(symbols, attributes) {
	                var seenNames = ts.createUnderscoreEscapedMap();
	                for (var _i = 0, attributes_1 = attributes; _i < attributes_1.length; _i++) {
	                    var attr = attributes_1[_i];
	                    // If this is the current item we are editing right now, do not filter it out
	                    if (isCurrentlyEditingNode(attr)) {
	                        continue;
	                    }
	                    if (attr.kind === 261 /* JsxAttribute */) {
	                        seenNames.set(attr.name.escapedText, true);
	                    }
	                }
	                return symbols.filter(function (a) { return !seenNames.get(a.escapedName); });
	            }
	            function isCurrentlyEditingNode(node) {
	                return node.getStart(sourceFile) <= position && position <= node.getEnd();
	            }
	        }
	        function getCompletionEntryDisplayNameForSymbol(symbol, target, origin, kind) {
	            var name = getSymbolName(symbol, origin, target);
	            if (name === undefined
	                // If the symbol is external module, don't show it in the completion list
	                // (i.e declare module "http" { const x; } | // <= request completion here, "http" should not be there)
	                || symbol.flags & 1536 /* Module */ && ts.startsWithQuote(name)
	                // If the symbol is the internal name of an ES symbol, it is not a valid entry. Internal names for ES symbols start with "__@"
	                || ts.isKnownSymbol(symbol)) {
	                return undefined;
	            }
	            var validIdentiferResult = { name: name, needsConvertPropertyAccess: false };
	            if (ts.isIdentifierText(name, target))
	                return validIdentiferResult;
	            switch (kind) {
	                case 3 /* MemberLike */:
	                    return undefined;
	                case 0 /* ObjectPropertyDeclaration */:
	                    // TODO: GH#18169
	                    return { name: JSON.stringify(name), needsConvertPropertyAccess: false };
	                case 2 /* PropertyAccess */:
	                case 1 /* Global */: // For a 'this.' completion it will be in a global context, but may have a non-identifier name.
	                    // Don't add a completion for a name starting with a space. See https://github.com/Microsoft/TypeScript/pull/20547
	                    return name.charCodeAt(0) === 32 /* space */ ? undefined : { name: name, needsConvertPropertyAccess: true };
	                case 5 /* None */:
	                case 4 /* String */:
	                    return validIdentiferResult;
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        // A cache of completion entries for keywords, these do not change between sessions
	        var _keywordCompletions = [];
	        var allKeywordsCompletions = ts.memoize(function () {
	            var res = [];
	            for (var i = 72 /* FirstKeyword */; i <= 144 /* LastKeyword */; i++) {
	                res.push({
	                    name: ts.tokenToString(i),
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "" /* none */,
	                    sortText: "0"
	                });
	            }
	            return res;
	        });
	        function getKeywordCompletions(keywordFilter) {
	            return _keywordCompletions[keywordFilter] || (_keywordCompletions[keywordFilter] = allKeywordsCompletions().filter(function (entry) {
	                var kind = ts.stringToToken(entry.name);
	                switch (keywordFilter) {
	                    case 0 /* None */:
	                        // "undefined" is a global variable, so don't need a keyword completion for it.
	                        return kind !== 140 /* UndefinedKeyword */;
	                    case 1 /* ClassElementKeywords */:
	                        return isClassMemberCompletionKeyword(kind);
	                    case 2 /* InterfaceElementKeywords */:
	                        return isInterfaceOrTypeLiteralCompletionKeyword(kind);
	                    case 3 /* ConstructorParameterKeywords */:
	                        return ts.isParameterPropertyModifier(kind);
	                    case 4 /* FunctionLikeBodyKeywords */:
	                        return !isClassMemberCompletionKeyword(kind);
	                    case 5 /* TypeKeywords */:
	                        return ts.isTypeKeyword(kind);
	                    default:
	                        return ts.Debug.assertNever(keywordFilter);
	                }
	            }));
	        }
	        function isInterfaceOrTypeLiteralCompletionKeyword(kind) {
	            return kind === 132 /* ReadonlyKeyword */;
	        }
	        function isClassMemberCompletionKeyword(kind) {
	            switch (kind) {
	                case 117 /* AbstractKeyword */:
	                case 123 /* ConstructorKeyword */:
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                case 120 /* AsyncKeyword */:
	                    return true;
	                default:
	                    return ts.isClassMemberModifier(kind);
	            }
	        }
	        function keywordForNode(node) {
	            return ts.isIdentifier(node) ? node.originalKeywordKind || 0 /* Unknown */ : node.kind;
	        }
	        function isEqualityOperatorKind(kind) {
	            switch (kind) {
	                case 34 /* EqualsEqualsEqualsToken */:
	                case 32 /* EqualsEqualsToken */:
	                case 35 /* ExclamationEqualsEqualsToken */:
	                case 33 /* ExclamationEqualsToken */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        /** Get the corresponding JSDocTag node if the position is in a jsDoc comment */
	        function getJsDocTagAtPosition(node, position) {
	            var jsDoc = getJsDocHavingNode(node).jsDoc;
	            if (!jsDoc)
	                return undefined;
	            for (var _i = 0, jsDoc_1 = jsDoc; _i < jsDoc_1.length; _i++) {
	                var _a = jsDoc_1[_i], pos = _a.pos, end = _a.end, tags = _a.tags;
	                if (!tags || position < pos || position > end)
	                    continue;
	                for (var i = tags.length - 1; i >= 0; i--) {
	                    var tag = tags[i];
	                    if (position >= tag.pos) {
	                        return tag;
	                    }
	                }
	            }
	        }
	        function getJsDocHavingNode(node) {
	            if (!ts.isToken(node))
	                return node;
	            switch (node.kind) {
	                case 104 /* VarKeyword */:
	                case 110 /* LetKeyword */:
	                case 76 /* ConstKeyword */:
	                    // if the current token is var, let or const, skip the VariableDeclarationList
	                    return node.parent.parent;
	                default:
	                    return node.parent;
	            }
	        }
	        /**
	         * Gets all properties on a type, but if that type is a union of several types,
	         * excludes array-like types or callable/constructable types.
	         */
	        function getPropertiesForCompletion(type, checker, isForAccess) {
	            if (!(type.isUnion())) {
	                return ts.Debug.assertEachDefined(type.getApparentProperties(), "getApparentProperties() should all be defined");
	            }
	            // If we're providing completions for an object literal, skip primitive, array-like, or callable types since those shouldn't be implemented by object literals.
	            var filteredTypes = isForAccess ? type.types : type.types.filter(function (memberType) {
	                return !(memberType.flags & 16382 /* Primitive */ || checker.isArrayLikeType(memberType) || ts.typeHasCallOrConstructSignatures(memberType, checker));
	            });
	            return ts.Debug.assertEachDefined(checker.getAllPossiblePropertiesOfTypes(filteredTypes), "getAllPossiblePropertiesOfTypes() should all be defined");
	        }
	        /**
	         * Returns the immediate owning class declaration of a context token,
	         * on the condition that one exists and that the context implies completion should be given.
	         */
	        function tryGetObjectTypeDeclarationCompletionContainer(sourceFile, contextToken, location) {
	            // class c { method() { } | method2() { } }
	            switch (location.kind) {
	                case 298 /* SyntaxList */:
	                    return ts.tryCast(location.parent, ts.isObjectTypeDeclaration);
	                case 1 /* EndOfFileToken */:
	                    var cls = ts.tryCast(ts.lastOrUndefined(ts.cast(location.parent, ts.isSourceFile).statements), ts.isObjectTypeDeclaration);
	                    if (cls && !ts.findChildOfKind(cls, 18 /* CloseBraceToken */, sourceFile)) {
	                        return cls;
	                    }
	            }
	            if (!contextToken)
	                return undefined;
	            switch (contextToken.kind) {
	                case 25 /* SemicolonToken */: // class c {getValue(): number; | }
	                case 18 /* CloseBraceToken */: // class c { method() { } | }
	                    // class c { method() { } b| }
	                    return isFromObjectTypeDeclaration(location) && location.parent.name === location
	                        ? location.parent.parent
	                        : ts.tryCast(location, ts.isObjectTypeDeclaration);
	                case 17 /* OpenBraceToken */: // class c { |
	                case 26 /* CommaToken */: // class c {getValue(): number, | }
	                    return ts.tryCast(contextToken.parent, ts.isObjectTypeDeclaration);
	                default:
	                    if (!isFromObjectTypeDeclaration(contextToken))
	                        return undefined;
	                    var isValidKeyword = ts.isClassLike(contextToken.parent.parent) ? isClassMemberCompletionKeyword : isInterfaceOrTypeLiteralCompletionKeyword;
	                    return (isValidKeyword(contextToken.kind) || ts.isIdentifier(contextToken) && isValidKeyword(ts.stringToToken(contextToken.text)))
	                        ? contextToken.parent.parent : undefined;
	            }
	        }
	        // TODO: GH#19856 Would like to return `node is Node & { parent: (ClassElement | TypeElement) & { parent: ObjectTypeDeclaration } }` but then compilation takes > 10 minutes
	        function isFromObjectTypeDeclaration(node) {
	            return node.parent && ts.isClassOrTypeElement(node.parent) && ts.isObjectTypeDeclaration(node.parent.parent);
	        }
	        function hasIndexSignature(type) {
	            return !!type.getStringIndexType() || !!type.getNumberIndexType();
	        }
	        function isValidTrigger(sourceFile, triggerCharacter, contextToken, position) {
	            switch (triggerCharacter) {
	                case ".":
	                case "@":
	                    return true;
	                case '"':
	                case "'":
	                case "`":
	                    // Only automatically bring up completions if this is an opening quote.
	                    return isStringLiteralOrTemplate(contextToken) && position === contextToken.getStart(sourceFile) + 1;
	                case "<":
	                    // Opening JSX tag
	                    return contextToken.kind === 27 /* LessThanToken */ && contextToken.parent.kind !== 199 /* BinaryExpression */;
	                case "/":
	                    return ts.isStringLiteralLike(contextToken)
	                        ? !!ts.tryGetImportFromModuleSpecifier(contextToken)
	                        : contextToken.kind === 41 /* SlashToken */ && ts.isJsxClosingElement(contextToken.parent);
	                default:
	                    return ts.Debug.assertNever(triggerCharacter);
	            }
	        }
	        function isStringLiteralOrTemplate(node) {
	            switch (node.kind) {
	                case 9 /* StringLiteral */:
	                case 13 /* NoSubstitutionTemplateLiteral */:
	                case 201 /* TemplateExpression */:
	                case 188 /* TaggedTemplateExpression */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	    })(Completions = ts.Completions || (ts.Completions = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var DocumentHighlights;
	    (function (DocumentHighlights) {
	        function getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node.parent && (ts.isJsxOpeningElement(node.parent) && node.parent.tagName === node || ts.isJsxClosingElement(node.parent))) {
	                // For a JSX element, just highlight the matching tag, not all references.
	                var _a = node.parent.parent, openingElement = _a.openingElement, closingElement = _a.closingElement;
	                var highlightSpans = [openingElement, closingElement].map(function (_a) {
	                    var tagName = _a.tagName;
	                    return getHighlightSpanForNode(tagName, sourceFile);
	                });
	                return [{ fileName: sourceFile.fileName, highlightSpans: highlightSpans }];
	            }
	            return getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) || getSyntacticDocumentHighlights(node, sourceFile);
	        }
	        DocumentHighlights.getDocumentHighlights = getDocumentHighlights;
	        function getHighlightSpanForNode(node, sourceFile) {
	            return {
	                fileName: sourceFile.fileName,
	                textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                kind: "none" /* none */
	            };
	        }
	        function getSemanticDocumentHighlights(position, node, program, cancellationToken, sourceFilesToSearch) {
	            var sourceFilesSet = ts.arrayToSet(sourceFilesToSearch, function (f) { return f.fileName; });
	            var referenceEntries = ts.FindAllReferences.getReferenceEntriesForNode(position, node, program, sourceFilesToSearch, cancellationToken, /*options*/ undefined, sourceFilesSet);
	            if (!referenceEntries)
	                return undefined;
	            var map = ts.arrayToMultiMap(referenceEntries.map(ts.FindAllReferences.toHighlightSpan), function (e) { return e.fileName; }, function (e) { return e.span; });
	            return ts.arrayFrom(map.entries(), function (_a) {
	                var fileName = _a[0], highlightSpans = _a[1];
	                if (!sourceFilesSet.has(fileName)) {
	                    ts.Debug.assert(program.redirectTargetsSet.has(fileName));
	                    var redirectTarget_1 = program.getSourceFile(fileName);
	                    var redirect = ts.find(sourceFilesToSearch, function (f) { return f.redirectInfo && f.redirectInfo.redirectTarget === redirectTarget_1; });
	                    fileName = redirect.fileName;
	                    ts.Debug.assert(sourceFilesSet.has(fileName));
	                }
	                return { fileName: fileName, highlightSpans: highlightSpans };
	            });
	        }
	        function getSyntacticDocumentHighlights(node, sourceFile) {
	            var highlightSpans = getHighlightSpans(node, sourceFile);
	            return highlightSpans && [{ fileName: sourceFile.fileName, highlightSpans: highlightSpans }];
	        }
	        function getHighlightSpans(node, sourceFile) {
	            switch (node.kind) {
	                case 90 /* IfKeyword */:
	                case 82 /* ElseKeyword */:
	                    return ts.isIfStatement(node.parent) ? getIfElseOccurrences(node.parent, sourceFile) : undefined;
	                case 96 /* ReturnKeyword */:
	                    return useParent(node.parent, ts.isReturnStatement, getReturnOccurrences);
	                case 100 /* ThrowKeyword */:
	                    return useParent(node.parent, ts.isThrowStatement, getThrowOccurrences);
	                case 102 /* TryKeyword */:
	                case 74 /* CatchKeyword */:
	                case 87 /* FinallyKeyword */:
	                    var tryStatement = node.kind === 74 /* CatchKeyword */ ? node.parent.parent : node.parent;
	                    return useParent(tryStatement, ts.isTryStatement, getTryCatchFinallyOccurrences);
	                case 98 /* SwitchKeyword */:
	                    return useParent(node.parent, ts.isSwitchStatement, getSwitchCaseDefaultOccurrences);
	                case 73 /* CaseKeyword */:
	                case 79 /* DefaultKeyword */:
	                    return useParent(node.parent.parent.parent, ts.isSwitchStatement, getSwitchCaseDefaultOccurrences);
	                case 72 /* BreakKeyword */:
	                case 77 /* ContinueKeyword */:
	                    return useParent(node.parent, ts.isBreakOrContinueStatement, getBreakOrContinueStatementOccurrences);
	                case 88 /* ForKeyword */:
	                case 106 /* WhileKeyword */:
	                case 81 /* DoKeyword */:
	                    return useParent(node.parent, function (n) { return ts.isIterationStatement(n, /*lookInLabeledStatements*/ true); }, getLoopBreakContinueOccurrences);
	                case 123 /* ConstructorKeyword */:
	                    return getFromAllDeclarations(ts.isConstructorDeclaration, [123 /* ConstructorKeyword */]);
	                case 125 /* GetKeyword */:
	                case 136 /* SetKeyword */:
	                    return getFromAllDeclarations(ts.isAccessor, [125 /* GetKeyword */, 136 /* SetKeyword */]);
	                case 121 /* AwaitKeyword */:
	                    return useParent(node.parent, ts.isAwaitExpression, getAsyncAndAwaitOccurrences);
	                case 120 /* AsyncKeyword */:
	                    return highlightSpans(getAsyncAndAwaitOccurrences(node));
	                default:
	                    return ts.isModifierKind(node.kind) && (ts.isDeclaration(node.parent) || ts.isVariableStatement(node.parent))
	                        ? highlightSpans(getModifierOccurrences(node.kind, node.parent))
	                        : undefined;
	            }
	            function getFromAllDeclarations(nodeTest, keywords) {
	                return useParent(node.parent, nodeTest, function (decl) { return ts.mapDefined(decl.symbol.declarations, function (d) {
	                    return nodeTest(d) ? ts.find(d.getChildren(sourceFile), function (c) { return ts.contains(keywords, c.kind); }) : undefined;
	                }); });
	            }
	            function useParent(node, nodeTest, getNodes) {
	                return nodeTest(node) ? highlightSpans(getNodes(node, sourceFile)) : undefined;
	            }
	            function highlightSpans(nodes) {
	                return nodes && nodes.map(function (node) { return getHighlightSpanForNode(node, sourceFile); });
	            }
	        }
	        /**
	         * Aggregates all throw-statements within this node *without* crossing
	         * into function boundaries and try-blocks with catch-clauses.
	         */
	        function aggregateOwnedThrowStatements(node) {
	            if (ts.isThrowStatement(node)) {
	                return [node];
	            }
	            else if (ts.isTryStatement(node)) {
	                // Exceptions thrown within a try block lacking a catch clause are "owned" in the current context.
	                return ts.concatenate(node.catchClause ? aggregateOwnedThrowStatements(node.catchClause) : node.tryBlock && aggregateOwnedThrowStatements(node.tryBlock), aggregateOwnedThrowStatements(node.finallyBlock));
	            }
	            // Do not cross function boundaries.
	            return ts.isFunctionLike(node) ? undefined : flatMapChildren(node, aggregateOwnedThrowStatements);
	        }
	        /**
	         * For lack of a better name, this function takes a throw statement and returns the
	         * nearest ancestor that is a try-block (whose try statement has a catch clause),
	         * function-block, or source file.
	         */
	        function getThrowStatementOwner(throwStatement) {
	            var child = throwStatement;
	            while (child.parent) {
	                var parent = child.parent;
	                if (ts.isFunctionBlock(parent) || parent.kind === 273 /* SourceFile */) {
	                    return parent;
	                }
	                // A throw-statement is only owned by a try-statement if the try-statement has
	                // a catch clause, and if the throw-statement occurs within the try block.
	                if (ts.isTryStatement(parent) && parent.tryBlock === child && parent.catchClause) {
	                    return child;
	                }
	                child = parent;
	            }
	            return undefined;
	        }
	        function aggregateAllBreakAndContinueStatements(node) {
	            return ts.isBreakOrContinueStatement(node) ? [node] : ts.isFunctionLike(node) ? undefined : flatMapChildren(node, aggregateAllBreakAndContinueStatements);
	        }
	        function flatMapChildren(node, cb) {
	            var result = [];
	            node.forEachChild(function (child) {
	                var value = cb(child);
	                if (value !== undefined) {
	                    result.push.apply(result, ts.toArray(value));
	                }
	            });
	            return result;
	        }
	        function ownsBreakOrContinueStatement(owner, statement) {
	            var actualOwner = getBreakOrContinueOwner(statement);
	            return actualOwner && actualOwner === owner;
	        }
	        function getBreakOrContinueOwner(statement) {
	            return ts.findAncestor(statement, function (node) {
	                switch (node.kind) {
	                    case 226 /* SwitchStatement */:
	                        if (statement.kind === 222 /* ContinueStatement */) {
	                            return false;
	                        }
	                    // falls through
	                    case 219 /* ForStatement */:
	                    case 220 /* ForInStatement */:
	                    case 221 /* ForOfStatement */:
	                    case 218 /* WhileStatement */:
	                    case 217 /* DoStatement */:
	                        return !statement.label || isLabeledBy(node, statement.label.escapedText);
	                    default:
	                        // Don't cross function boundaries.
	                        // TODO: GH#20090
	                        return (ts.isFunctionLike(node) && "quit");
	                }
	            });
	        }
	        function getModifierOccurrences(modifier, declaration) {
	            var modifierFlag = ts.modifierToFlag(modifier);
	            return ts.mapDefined(getNodesToSearchForModifier(declaration, modifierFlag), function (node) {
	                if (ts.getModifierFlags(node) & modifierFlag) {
	                    var mod = ts.find(node.modifiers, function (m) { return m.kind === modifier; });
	                    ts.Debug.assert(!!mod);
	                    return mod;
	                }
	            });
	        }
	        function getNodesToSearchForModifier(declaration, modifierFlag) {
	            // Types of node whose children might have modifiers.
	            var container = declaration.parent;
	            switch (container.kind) {
	                case 239 /* ModuleBlock */:
	                case 273 /* SourceFile */:
	                case 212 /* Block */:
	                case 265 /* CaseClause */:
	                case 266 /* DefaultClause */:
	                    // Container is either a class declaration or the declaration is a classDeclaration
	                    if (modifierFlag & 128 /* Abstract */ && ts.isClassDeclaration(declaration)) {
	                        return declaration.members.concat([declaration]);
	                    }
	                    else {
	                        return container.statements;
	                    }
	                case 154 /* Constructor */:
	                case 153 /* MethodDeclaration */:
	                case 233 /* FunctionDeclaration */: {
	                    return container.parameters.concat((ts.isClassLike(container.parent) ? container.parent.members : []));
	                }
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                    var nodes = container.members;
	                    // If we're an accessibility modifier, we're in an instance member and should search
	                    // the constructor's parameter list for instance members as well.
	                    if (modifierFlag & 28 /* AccessibilityModifier */) {
	                        var constructor = ts.find(container.members, ts.isConstructorDeclaration);
	                        if (constructor) {
	                            return nodes.concat(constructor.parameters);
	                        }
	                    }
	                    else if (modifierFlag & 128 /* Abstract */) {
	                        return nodes.concat([container]);
	                    }
	                    return nodes;
	                default:
	                    ts.Debug.assertNever(container, "Invalid container kind.");
	            }
	        }
	        function pushKeywordIf(keywordList, token) {
	            var expected = [];
	            for (var _i = 2; _i < arguments.length; _i++) {
	                expected[_i - 2] = arguments[_i];
	            }
	            if (token && ts.contains(expected, token.kind)) {
	                keywordList.push(token);
	                return true;
	            }
	            return false;
	        }
	        function getLoopBreakContinueOccurrences(loopNode) {
	            var keywords = [];
	            if (pushKeywordIf(keywords, loopNode.getFirstToken(), 88 /* ForKeyword */, 106 /* WhileKeyword */, 81 /* DoKeyword */)) {
	                // If we succeeded and got a do-while loop, then start looking for a 'while' keyword.
	                if (loopNode.kind === 217 /* DoStatement */) {
	                    var loopTokens = loopNode.getChildren();
	                    for (var i = loopTokens.length - 1; i >= 0; i--) {
	                        if (pushKeywordIf(keywords, loopTokens[i], 106 /* WhileKeyword */)) {
	                            break;
	                        }
	                    }
	                }
	            }
	            ts.forEach(aggregateAllBreakAndContinueStatements(loopNode.statement), function (statement) {
	                if (ownsBreakOrContinueStatement(loopNode, statement)) {
	                    pushKeywordIf(keywords, statement.getFirstToken(), 72 /* BreakKeyword */, 77 /* ContinueKeyword */);
	                }
	            });
	            return keywords;
	        }
	        function getBreakOrContinueStatementOccurrences(breakOrContinueStatement) {
	            var owner = getBreakOrContinueOwner(breakOrContinueStatement);
	            if (owner) {
	                switch (owner.kind) {
	                    case 219 /* ForStatement */:
	                    case 220 /* ForInStatement */:
	                    case 221 /* ForOfStatement */:
	                    case 217 /* DoStatement */:
	                    case 218 /* WhileStatement */:
	                        return getLoopBreakContinueOccurrences(owner);
	                    case 226 /* SwitchStatement */:
	                        return getSwitchCaseDefaultOccurrences(owner);
	                }
	            }
	            return undefined;
	        }
	        function getSwitchCaseDefaultOccurrences(switchStatement) {
	            var keywords = [];
	            pushKeywordIf(keywords, switchStatement.getFirstToken(), 98 /* SwitchKeyword */);
	            // Go through each clause in the switch statement, collecting the 'case'/'default' keywords.
	            ts.forEach(switchStatement.caseBlock.clauses, function (clause) {
	                pushKeywordIf(keywords, clause.getFirstToken(), 73 /* CaseKeyword */, 79 /* DefaultKeyword */);
	                ts.forEach(aggregateAllBreakAndContinueStatements(clause), function (statement) {
	                    if (ownsBreakOrContinueStatement(switchStatement, statement)) {
	                        pushKeywordIf(keywords, statement.getFirstToken(), 72 /* BreakKeyword */);
	                    }
	                });
	            });
	            return keywords;
	        }
	        function getTryCatchFinallyOccurrences(tryStatement, sourceFile) {
	            var keywords = [];
	            pushKeywordIf(keywords, tryStatement.getFirstToken(), 102 /* TryKeyword */);
	            if (tryStatement.catchClause) {
	                pushKeywordIf(keywords, tryStatement.catchClause.getFirstToken(), 74 /* CatchKeyword */);
	            }
	            if (tryStatement.finallyBlock) {
	                var finallyKeyword = ts.findChildOfKind(tryStatement, 87 /* FinallyKeyword */, sourceFile);
	                pushKeywordIf(keywords, finallyKeyword, 87 /* FinallyKeyword */);
	            }
	            return keywords;
	        }
	        function getThrowOccurrences(throwStatement, sourceFile) {
	            var owner = getThrowStatementOwner(throwStatement);
	            if (!owner) {
	                return undefined;
	            }
	            var keywords = [];
	            ts.forEach(aggregateOwnedThrowStatements(owner), function (throwStatement) {
	                keywords.push(ts.findChildOfKind(throwStatement, 100 /* ThrowKeyword */, sourceFile));
	            });
	            // If the "owner" is a function, then we equate 'return' and 'throw' statements in their
	            // ability to "jump out" of the function, and include occurrences for both.
	            if (ts.isFunctionBlock(owner)) {
	                ts.forEachReturnStatement(owner, function (returnStatement) {
	                    keywords.push(ts.findChildOfKind(returnStatement, 96 /* ReturnKeyword */, sourceFile));
	                });
	            }
	            return keywords;
	        }
	        function getReturnOccurrences(returnStatement, sourceFile) {
	            var func = ts.getContainingFunction(returnStatement);
	            if (!func) {
	                return undefined;
	            }
	            var keywords = [];
	            ts.forEachReturnStatement(ts.cast(func.body, ts.isBlock), function (returnStatement) {
	                keywords.push(ts.findChildOfKind(returnStatement, 96 /* ReturnKeyword */, sourceFile));
	            });
	            // Include 'throw' statements that do not occur within a try block.
	            ts.forEach(aggregateOwnedThrowStatements(func.body), function (throwStatement) {
	                keywords.push(ts.findChildOfKind(throwStatement, 100 /* ThrowKeyword */, sourceFile));
	            });
	            return keywords;
	        }
	        function getAsyncAndAwaitOccurrences(node) {
	            var func = ts.getContainingFunction(node);
	            if (!func) {
	                return undefined;
	            }
	            var keywords = [];
	            if (func.modifiers) {
	                func.modifiers.forEach(function (modifier) {
	                    pushKeywordIf(keywords, modifier, 120 /* AsyncKeyword */);
	                });
	            }
	            ts.forEachChild(func, aggregate);
	            return keywords;
	            function aggregate(node) {
	                if (ts.isAwaitExpression(node)) {
	                    pushKeywordIf(keywords, node.getFirstToken(), 121 /* AwaitKeyword */);
	                }
	                // Do not cross function boundaries.
	                if (!ts.isFunctionLike(node) && !ts.isClassLike(node) && !ts.isInterfaceDeclaration(node) && !ts.isModuleDeclaration(node) && !ts.isTypeAliasDeclaration(node) && !ts.isTypeNode(node)) {
	                    ts.forEachChild(node, aggregate);
	                }
	            }
	        }
	        function getIfElseOccurrences(ifStatement, sourceFile) {
	            var keywords = getIfElseKeywords(ifStatement, sourceFile);
	            var result = [];
	            // We'd like to highlight else/ifs together if they are only separated by whitespace
	            // (i.e. the keywords are separated by no comments, no newlines).
	            for (var i = 0; i < keywords.length; i++) {
	                if (keywords[i].kind === 82 /* ElseKeyword */ && i < keywords.length - 1) {
	                    var elseKeyword = keywords[i];
	                    var ifKeyword = keywords[i + 1]; // this *should* always be an 'if' keyword.
	                    var shouldCombineElseAndIf = true;
	                    // Avoid recalculating getStart() by iterating backwards.
	                    for (var j = ifKeyword.getStart(sourceFile) - 1; j >= elseKeyword.end; j--) {
	                        if (!ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(j))) {
	                            shouldCombineElseAndIf = false;
	                            break;
	                        }
	                    }
	                    if (shouldCombineElseAndIf) {
	                        result.push({
	                            fileName: sourceFile.fileName,
	                            textSpan: ts.createTextSpanFromBounds(elseKeyword.getStart(), ifKeyword.end),
	                            kind: "reference" /* reference */
	                        });
	                        i++; // skip the next keyword
	                        continue;
	                    }
	                }
	                // Ordinary case: just highlight the keyword.
	                result.push(getHighlightSpanForNode(keywords[i], sourceFile));
	            }
	            return result;
	        }
	        function getIfElseKeywords(ifStatement, sourceFile) {
	            var keywords = [];
	            // Traverse upwards through all parent if-statements linked by their else-branches.
	            while (ts.isIfStatement(ifStatement.parent) && ifStatement.parent.elseStatement === ifStatement) {
	                ifStatement = ifStatement.parent;
	            }
	            // Now traverse back down through the else branches, aggregating if/else keywords of if-statements.
	            while (true) {
	                var children = ifStatement.getChildren(sourceFile);
	                pushKeywordIf(keywords, children[0], 90 /* IfKeyword */);
	                // Generally the 'else' keyword is second-to-last, so we traverse backwards.
	                for (var i = children.length - 1; i >= 0; i--) {
	                    if (pushKeywordIf(keywords, children[i], 82 /* ElseKeyword */)) {
	                        break;
	                    }
	                }
	                if (!ifStatement.elseStatement || !ts.isIfStatement(ifStatement.elseStatement)) {
	                    break;
	                }
	                ifStatement = ifStatement.elseStatement;
	            }
	            return keywords;
	        }
	        /**
	         * Whether or not a 'node' is preceded by a label of the given string.
	         * Note: 'node' cannot be a SourceFile.
	         */
	        function isLabeledBy(node, labelName) {
	            return !!ts.findAncestor(node.parent, function (owner) { return !ts.isLabeledStatement(owner) ? "quit" : owner.label.escapedText === labelName; });
	        }
	    })(DocumentHighlights = ts.DocumentHighlights || (ts.DocumentHighlights = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function createDocumentRegistry(useCaseSensitiveFileNames, currentDirectory) {
	        return createDocumentRegistryInternal(useCaseSensitiveFileNames, currentDirectory);
	    }
	    ts.createDocumentRegistry = createDocumentRegistry;
	    /*@internal*/
	    function createDocumentRegistryInternal(useCaseSensitiveFileNames, currentDirectory, externalCache) {
	        if (currentDirectory === void 0) { currentDirectory = ""; }
	        // Maps from compiler setting target (ES3, ES5, etc.) to all the cached documents we have
	        // for those settings.
	        var buckets = ts.createMap();
	        var getCanonicalFileName = ts.createGetCanonicalFileName(!!useCaseSensitiveFileNames);
	        function getKeyForCompilationSettings(settings) {
	            return "_" + settings.target + "|" + settings.module + "|" + settings.noResolve + "|" + settings.jsx + "|" + settings.allowJs + "|" + settings.baseUrl + "|" + JSON.stringify(settings.typeRoots) + "|" + JSON.stringify(settings.rootDirs) + "|" + JSON.stringify(settings.paths);
	        }
	        function getBucketForCompilationSettings(key, createIfMissing) {
	            var bucket = buckets.get(key);
	            if (!bucket && createIfMissing) {
	                buckets.set(key, bucket = ts.createMap());
	            }
	            return bucket;
	        }
	        function reportStats() {
	            var bucketInfoArray = ts.arrayFrom(buckets.keys()).filter(function (name) { return name && name.charAt(0) === "_"; }).map(function (name) {
	                var entries = buckets.get(name);
	                var sourceFiles = [];
	                entries.forEach(function (entry, name) {
	                    sourceFiles.push({
	                        name: name,
	                        refCount: entry.languageServiceRefCount
	                    });
	                });
	                sourceFiles.sort(function (x, y) { return y.refCount - x.refCount; });
	                return {
	                    bucket: name,
	                    sourceFiles: sourceFiles
	                };
	            });
	            return JSON.stringify(bucketInfoArray, undefined, 2);
	        }
	        function acquireDocument(fileName, compilationSettings, scriptSnapshot, version, scriptKind) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind);
	        }
	        function acquireDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind) {
	            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, /*acquiring*/ true, scriptKind);
	        }
	        function updateDocument(fileName, compilationSettings, scriptSnapshot, version, scriptKind) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind);
	        }
	        function updateDocumentWithKey(fileName, path, compilationSettings, key, scriptSnapshot, version, scriptKind) {
	            return acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, /*acquiring*/ false, scriptKind);
	        }
	        function acquireOrUpdateDocument(fileName, path, compilationSettings, key, scriptSnapshot, version, acquiring, scriptKind) {
	            var bucket = getBucketForCompilationSettings(key, /*createIfMissing*/ true);
	            var entry = bucket.get(path);
	            var scriptTarget = scriptKind === 6 /* JSON */ ? 100 /* JSON */ : compilationSettings.target;
	            if (!entry && externalCache) {
	                var sourceFile = externalCache.getDocument(key, path);
	                if (sourceFile) {
	                    ts.Debug.assert(acquiring);
	                    entry = {
	                        sourceFile: sourceFile,
	                        languageServiceRefCount: 0
	                    };
	                    bucket.set(path, entry);
	                }
	            }
	            if (!entry) {
	                // Have never seen this file with these settings.  Create a new source file for it.
	                var sourceFile = ts.createLanguageServiceSourceFile(fileName, scriptSnapshot, scriptTarget, version, /*setNodeParents*/ false, scriptKind);
	                if (externalCache) {
	                    externalCache.setDocument(key, path, sourceFile);
	                }
	                entry = {
	                    sourceFile: sourceFile,
	                    languageServiceRefCount: 1,
	                };
	                bucket.set(path, entry);
	            }
	            else {
	                // We have an entry for this file.  However, it may be for a different version of
	                // the script snapshot.  If so, update it appropriately.  Otherwise, we can just
	                // return it as is.
	                if (entry.sourceFile.version !== version) {
	                    entry.sourceFile = ts.updateLanguageServiceSourceFile(entry.sourceFile, scriptSnapshot, version, scriptSnapshot.getChangeRange(entry.sourceFile.scriptSnapshot));
	                    if (externalCache) {
	                        externalCache.setDocument(key, path, entry.sourceFile);
	                    }
	                }
	                // If we're acquiring, then this is the first time this LS is asking for this document.
	                // Increase our ref count so we know there's another LS using the document.  If we're
	                // not acquiring, then that means the LS is 'updating' the file instead, and that means
	                // it has already acquired the document previously.  As such, we do not need to increase
	                // the ref count.
	                if (acquiring) {
	                    entry.languageServiceRefCount++;
	                }
	            }
	            ts.Debug.assert(entry.languageServiceRefCount !== 0);
	            return entry.sourceFile;
	        }
	        function releaseDocument(fileName, compilationSettings) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var key = getKeyForCompilationSettings(compilationSettings);
	            return releaseDocumentWithKey(path, key);
	        }
	        function releaseDocumentWithKey(path, key) {
	            var bucket = getBucketForCompilationSettings(key, /*createIfMissing*/ false);
	            ts.Debug.assert(bucket !== undefined);
	            var entry = bucket.get(path);
	            entry.languageServiceRefCount--;
	            ts.Debug.assert(entry.languageServiceRefCount >= 0);
	            if (entry.languageServiceRefCount === 0) {
	                bucket.delete(path);
	            }
	        }
	        function getLanguageServiceRefCounts(path) {
	            return ts.arrayFrom(buckets.entries(), function (_a) {
	                var key = _a[0], bucket = _a[1];
	                var entry = bucket.get(path);
	                return [key, entry && entry.languageServiceRefCount];
	            });
	        }
	        return {
	            acquireDocument: acquireDocument,
	            acquireDocumentWithKey: acquireDocumentWithKey,
	            updateDocument: updateDocument,
	            updateDocumentWithKey: updateDocumentWithKey,
	            releaseDocument: releaseDocument,
	            releaseDocumentWithKey: releaseDocumentWithKey,
	            getLanguageServiceRefCounts: getLanguageServiceRefCounts,
	            reportStats: reportStats,
	            getKeyForCompilationSettings: getKeyForCompilationSettings
	        };
	    }
	    ts.createDocumentRegistryInternal = createDocumentRegistryInternal;
	})(ts || (ts = {}));
	/* Code for finding imports of an exported symbol. Used only by FindAllReferences. */
	/* @internal */
	var ts;
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        /** Creates the imports map and returns an ImportTracker that uses it. Call this lazily to avoid calling `getDirectImportsMap` unnecessarily.  */
	        function createImportTracker(sourceFiles, sourceFilesSet, checker, cancellationToken) {
	            var allDirectImports = getDirectImportsMap(sourceFiles, checker, cancellationToken);
	            return function (exportSymbol, exportInfo, isForRename) {
	                var _a = getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, exportInfo, checker, cancellationToken), directImports = _a.directImports, indirectUsers = _a.indirectUsers;
	                return __assign({ indirectUsers: indirectUsers }, getSearchesFromDirectImports(directImports, exportSymbol, exportInfo.exportKind, checker, isForRename));
	            };
	        }
	        FindAllReferences.createImportTracker = createImportTracker;
	        var ExportKind;
	        (function (ExportKind) {
	            ExportKind[ExportKind["Named"] = 0] = "Named";
	            ExportKind[ExportKind["Default"] = 1] = "Default";
	            ExportKind[ExportKind["ExportEquals"] = 2] = "ExportEquals";
	        })(ExportKind = FindAllReferences.ExportKind || (FindAllReferences.ExportKind = {}));
	        var ImportExport;
	        (function (ImportExport) {
	            ImportExport[ImportExport["Import"] = 0] = "Import";
	            ImportExport[ImportExport["Export"] = 1] = "Export";
	        })(ImportExport = FindAllReferences.ImportExport || (FindAllReferences.ImportExport = {}));
	        /** Returns import statements that directly reference the exporting module, and a list of files that may access the module through a namespace. */
	        function getImportersForExport(sourceFiles, sourceFilesSet, allDirectImports, _a, checker, cancellationToken) {
	            var exportingModuleSymbol = _a.exportingModuleSymbol, exportKind = _a.exportKind;
	            var markSeenDirectImport = ts.nodeSeenTracker();
	            var markSeenIndirectUser = ts.nodeSeenTracker();
	            var directImports = [];
	            var isAvailableThroughGlobal = !!exportingModuleSymbol.globalExports;
	            var indirectUserDeclarations = isAvailableThroughGlobal ? undefined : [];
	            handleDirectImports(exportingModuleSymbol);
	            return { directImports: directImports, indirectUsers: getIndirectUsers() };
	            function getIndirectUsers() {
	                if (isAvailableThroughGlobal) {
	                    // It has `export as namespace`, so anything could potentially use it.
	                    return sourceFiles;
	                }
	                // Module augmentations may use this module's exports without importing it.
	                for (var _i = 0, _a = exportingModuleSymbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    if (ts.isExternalModuleAugmentation(decl) && sourceFilesSet.has(decl.getSourceFile().fileName)) {
	                        addIndirectUser(decl);
	                    }
	                }
	                // This may return duplicates (if there are multiple module declarations in a single source file, all importing the same thing as a namespace), but `State.markSearchedSymbol` will handle that.
	                return indirectUserDeclarations.map(ts.getSourceFileOfNode);
	            }
	            function handleDirectImports(exportingModuleSymbol) {
	                var theseDirectImports = getDirectImports(exportingModuleSymbol);
	                if (theseDirectImports) {
	                    for (var _i = 0, theseDirectImports_1 = theseDirectImports; _i < theseDirectImports_1.length; _i++) {
	                        var direct = theseDirectImports_1[_i];
	                        if (!markSeenDirectImport(direct)) {
	                            continue;
	                        }
	                        cancellationToken.throwIfCancellationRequested();
	                        switch (direct.kind) {
	                            case 186 /* CallExpression */:
	                                if (!isAvailableThroughGlobal) {
	                                    var parent = direct.parent;
	                                    if (exportKind === 2 /* ExportEquals */ && parent.kind === 231 /* VariableDeclaration */) {
	                                        var name = parent.name;
	                                        if (name.kind === 71 /* Identifier */) {
	                                            directImports.push(name);
	                                            break;
	                                        }
	                                    }
	                                    // Don't support re-exporting 'require()' calls, so just add a single indirect user.
	                                    addIndirectUser(direct.getSourceFile());
	                                }
	                                break;
	                            case 71 /* Identifier */: // for 'const x = require("y");
	                                break; // TODO: GH#23879
	                            case 242 /* ImportEqualsDeclaration */:
	                                handleNamespaceImport(direct, direct.name, ts.hasModifier(direct, 1 /* Export */));
	                                break;
	                            case 243 /* ImportDeclaration */:
	                                var namedBindings = direct.importClause && direct.importClause.namedBindings;
	                                if (namedBindings && namedBindings.kind === 245 /* NamespaceImport */) {
	                                    handleNamespaceImport(direct, namedBindings.name);
	                                }
	                                else if (ts.isDefaultImport(direct)) {
	                                    var sourceFileLike = getSourceFileLikeForImportDeclaration(direct);
	                                    if (!isAvailableThroughGlobal) {
	                                        addIndirectUser(sourceFileLike); // Add a check for indirect uses to handle synthetic default imports
	                                    }
	                                    directImports.push(direct);
	                                }
	                                else {
	                                    directImports.push(direct);
	                                }
	                                break;
	                            case 249 /* ExportDeclaration */:
	                                if (!direct.exportClause) {
	                                    // This is `export * from "foo"`, so imports of this module may import the export too.
	                                    handleDirectImports(getContainingModuleSymbol(direct, checker));
	                                }
	                                else {
	                                    // This is `export { foo } from "foo"` and creates an alias symbol, so recursive search will get handle re-exports.
	                                    directImports.push(direct);
	                                }
	                                break;
	                            case 178 /* ImportType */:
	                                directImports.push(direct);
	                                break;
	                            default:
	                                ts.Debug.assertNever(direct, "Unexpected import kind: " + ts.Debug.showSyntaxKind(direct));
	                        }
	                    }
	                }
	            }
	            function handleNamespaceImport(importDeclaration, name, isReExport) {
	                if (exportKind === 2 /* ExportEquals */) {
	                    // This is a direct import, not import-as-namespace.
	                    directImports.push(importDeclaration);
	                }
	                else if (!isAvailableThroughGlobal) {
	                    var sourceFileLike = getSourceFileLikeForImportDeclaration(importDeclaration);
	                    ts.Debug.assert(sourceFileLike.kind === 273 /* SourceFile */ || sourceFileLike.kind === 238 /* ModuleDeclaration */);
	                    if (isReExport || findNamespaceReExports(sourceFileLike, name, checker)) {
	                        addIndirectUsers(sourceFileLike);
	                    }
	                    else {
	                        addIndirectUser(sourceFileLike);
	                    }
	                }
	            }
	            function addIndirectUser(sourceFileLike) {
	                ts.Debug.assert(!isAvailableThroughGlobal);
	                var isNew = markSeenIndirectUser(sourceFileLike);
	                if (isNew) {
	                    indirectUserDeclarations.push(sourceFileLike);
	                }
	                return isNew;
	            }
	            /** Adds a module and all of its transitive dependencies as possible indirect users. */
	            function addIndirectUsers(sourceFileLike) {
	                if (!addIndirectUser(sourceFileLike)) {
	                    return;
	                }
	                var moduleSymbol = checker.getMergedSymbol(sourceFileLike.symbol);
	                ts.Debug.assert(!!(moduleSymbol.flags & 1536 /* Module */));
	                var directImports = getDirectImports(moduleSymbol);
	                if (directImports) {
	                    for (var _i = 0, directImports_1 = directImports; _i < directImports_1.length; _i++) {
	                        var directImport = directImports_1[_i];
	                        addIndirectUsers(getSourceFileLikeForImportDeclaration(directImport));
	                    }
	                }
	            }
	            function getDirectImports(moduleSymbol) {
	                return allDirectImports.get(ts.getSymbolId(moduleSymbol).toString());
	            }
	        }
	        /**
	         * Given the set of direct imports of a module, we need to find which ones import the particular exported symbol.
	         * The returned `importSearches` will result in the entire source file being searched.
	         * But re-exports will be placed in 'singleReferences' since they cannot be locally referenced.
	         */
	        function getSearchesFromDirectImports(directImports, exportSymbol, exportKind, checker, isForRename) {
	            var importSearches = [];
	            var singleReferences = [];
	            function addSearch(location, symbol) {
	                importSearches.push([location, symbol]);
	            }
	            if (directImports) {
	                for (var _i = 0, directImports_2 = directImports; _i < directImports_2.length; _i++) {
	                    var decl = directImports_2[_i];
	                    handleImport(decl);
	                }
	            }
	            return { importSearches: importSearches, singleReferences: singleReferences };
	            function handleImport(decl) {
	                if (decl.kind === 242 /* ImportEqualsDeclaration */) {
	                    if (isExternalModuleImportEquals(decl)) {
	                        handleNamespaceImportLike(decl.name);
	                    }
	                    return;
	                }
	                if (decl.kind === 71 /* Identifier */) {
	                    handleNamespaceImportLike(decl);
	                    return;
	                }
	                if (decl.kind === 178 /* ImportType */) {
	                    if (decl.qualifier) {
	                        if (ts.isIdentifier(decl.qualifier) && decl.qualifier.escapedText === ts.symbolName(exportSymbol)) {
	                            singleReferences.push(decl.qualifier);
	                        }
	                    }
	                    else if (exportKind === 2 /* ExportEquals */) {
	                        singleReferences.push(decl.argument.literal);
	                    }
	                    return;
	                }
	                // Ignore if there's a grammar error
	                if (decl.moduleSpecifier.kind !== 9 /* StringLiteral */) {
	                    return;
	                }
	                if (decl.kind === 249 /* ExportDeclaration */) {
	                    searchForNamedImport(decl.exportClause);
	                    return;
	                }
	                var importClause = decl.importClause;
	                if (!importClause) {
	                    return;
	                }
	                var namedBindings = importClause.namedBindings;
	                if (namedBindings && namedBindings.kind === 245 /* NamespaceImport */) {
	                    handleNamespaceImportLike(namedBindings.name);
	                    return;
	                }
	                if (exportKind === 0 /* Named */) {
	                    searchForNamedImport(namedBindings);
	                }
	                else {
	                    // `export =` might be imported by a default import if `--allowSyntheticDefaultImports` is on, so this handles both ExportKind.Default and ExportKind.ExportEquals
	                    var name = importClause.name;
	                    // If a default import has the same name as the default export, allow to rename it.
	                    // Given `import f` and `export default function f`, we will rename both, but for `import g` we will rename just that.
	                    if (name && (!isForRename || name.escapedText === ts.symbolEscapedNameNoDefault(exportSymbol))) {
	                        var defaultImportAlias = checker.getSymbolAtLocation(name);
	                        addSearch(name, defaultImportAlias);
	                    }
	                    // 'default' might be accessed as a named import `{ default as foo }`.
	                    if (exportKind === 1 /* Default */) {
	                        searchForNamedImport(namedBindings);
	                    }
	                }
	            }
	            /**
	             * `import x = require("./x") or `import * as x from "./x"`.
	             * An `export =` may be imported by this syntax, so it may be a direct import.
	             * If it's not a direct import, it will be in `indirectUsers`, so we don't have to do anything here.
	             */
	            function handleNamespaceImportLike(importName) {
	                // Don't rename an import that already has a different name than the export.
	                if (exportKind === 2 /* ExportEquals */ && (!isForRename || isNameMatch(importName.escapedText))) {
	                    addSearch(importName, checker.getSymbolAtLocation(importName));
	                }
	            }
	            function searchForNamedImport(namedBindings) {
	                if (!namedBindings) {
	                    return;
	                }
	                for (var _i = 0, _a = namedBindings.elements; _i < _a.length; _i++) {
	                    var element = _a[_i];
	                    var name = element.name, propertyName = element.propertyName;
	                    if (!isNameMatch((propertyName || name).escapedText)) {
	                        continue;
	                    }
	                    if (propertyName) {
	                        // This is `import { foo as bar } from "./a"` or `export { foo as bar } from "./a"`. `foo` isn't a local in the file, so just add it as a single reference.
	                        singleReferences.push(propertyName);
	                        // If renaming `{ foo as bar }`, don't touch `bar`, just `foo`.
	                        // But do rename `foo` in ` { default as foo }` if that's the original export name.
	                        if (!isForRename || name.escapedText === exportSymbol.escapedName) {
	                            // Search locally for `bar`.
	                            addSearch(name, checker.getSymbolAtLocation(name));
	                        }
	                    }
	                    else {
	                        var localSymbol = element.kind === 251 /* ExportSpecifier */ && element.propertyName
	                            ? checker.getExportSpecifierLocalTargetSymbol(element) // For re-exporting under a different name, we want to get the re-exported symbol.
	                            : checker.getSymbolAtLocation(name);
	                        addSearch(name, localSymbol);
	                    }
	                }
	            }
	            function isNameMatch(name) {
	                // Use name of "default" even in `export =` case because we may have allowSyntheticDefaultImports
	                return name === exportSymbol.escapedName || exportKind !== 0 /* Named */ && name === "default" /* Default */;
	            }
	        }
	        /** Returns 'true' is the namespace 'name' is re-exported from this module, and 'false' if it is only used locally. */
	        function findNamespaceReExports(sourceFileLike, name, checker) {
	            var namespaceImportSymbol = checker.getSymbolAtLocation(name);
	            return forEachPossibleImportOrExportStatement(sourceFileLike, function (statement) {
	                if (!ts.isExportDeclaration(statement))
	                    return;
	                var exportClause = statement.exportClause, moduleSpecifier = statement.moduleSpecifier;
	                return !moduleSpecifier && exportClause &&
	                    exportClause.elements.some(function (element) { return checker.getExportSpecifierLocalTargetSymbol(element) === namespaceImportSymbol; });
	            });
	        }
	        function findModuleReferences(program, sourceFiles, searchModuleSymbol) {
	            var refs = [];
	            var checker = program.getTypeChecker();
	            for (var _i = 0, sourceFiles_5 = sourceFiles; _i < sourceFiles_5.length; _i++) {
	                var referencingFile = sourceFiles_5[_i];
	                var searchSourceFile = searchModuleSymbol.valueDeclaration;
	                if (searchSourceFile.kind === 273 /* SourceFile */) {
	                    for (var _a = 0, _b = referencingFile.referencedFiles; _a < _b.length; _a++) {
	                        var ref = _b[_a];
	                        if (program.getSourceFileFromReference(referencingFile, ref) === searchSourceFile) {
	                            refs.push({ kind: "reference", referencingFile: referencingFile, ref: ref });
	                        }
	                    }
	                    for (var _c = 0, _d = referencingFile.typeReferenceDirectives; _c < _d.length; _c++) {
	                        var ref = _d[_c];
	                        var referenced = program.getResolvedTypeReferenceDirectives().get(ref.fileName);
	                        if (referenced !== undefined && referenced.resolvedFileName === searchSourceFile.fileName) {
	                            refs.push({ kind: "reference", referencingFile: referencingFile, ref: ref });
	                        }
	                    }
	                }
	                forEachImport(referencingFile, function (_importDecl, moduleSpecifier) {
	                    var moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
	                    if (moduleSymbol === searchModuleSymbol) {
	                        refs.push({ kind: "import", literal: moduleSpecifier });
	                    }
	                });
	            }
	            return refs;
	        }
	        FindAllReferences.findModuleReferences = findModuleReferences;
	        /** Returns a map from a module symbol Id to all import statements that directly reference the module. */
	        function getDirectImportsMap(sourceFiles, checker, cancellationToken) {
	            var map = ts.createMap();
	            for (var _i = 0, sourceFiles_6 = sourceFiles; _i < sourceFiles_6.length; _i++) {
	                var sourceFile = sourceFiles_6[_i];
	                cancellationToken.throwIfCancellationRequested();
	                forEachImport(sourceFile, function (importDecl, moduleSpecifier) {
	                    var moduleSymbol = checker.getSymbolAtLocation(moduleSpecifier);
	                    if (moduleSymbol) {
	                        var id = ts.getSymbolId(moduleSymbol).toString();
	                        var imports = map.get(id);
	                        if (!imports) {
	                            map.set(id, imports = []);
	                        }
	                        imports.push(importDecl);
	                    }
	                });
	            }
	            return map;
	        }
	        /** Iterates over all statements at the top level or in module declarations. Returns the first truthy result. */
	        function forEachPossibleImportOrExportStatement(sourceFileLike, action) {
	            return ts.forEach(sourceFileLike.kind === 273 /* SourceFile */ ? sourceFileLike.statements : sourceFileLike.body.statements, function (statement) {
	                return action(statement) || (isAmbientModuleDeclaration(statement) && ts.forEach(statement.body && statement.body.statements, action));
	            });
	        }
	        /** Calls `action` for each import, re-export, or require() in a file. */
	        function forEachImport(sourceFile, action) {
	            if (sourceFile.externalModuleIndicator || sourceFile.imports !== undefined) {
	                for (var _i = 0, _a = sourceFile.imports; _i < _a.length; _i++) {
	                    var i = _a[_i];
	                    action(ts.importFromModuleSpecifier(i), i);
	                }
	            }
	            else {
	                forEachPossibleImportOrExportStatement(sourceFile, function (statement) {
	                    switch (statement.kind) {
	                        case 249 /* ExportDeclaration */:
	                        case 243 /* ImportDeclaration */: {
	                            var decl = statement;
	                            if (decl.moduleSpecifier && ts.isStringLiteral(decl.moduleSpecifier)) {
	                                action(decl, decl.moduleSpecifier);
	                            }
	                            break;
	                        }
	                        case 242 /* ImportEqualsDeclaration */: {
	                            var decl = statement;
	                            if (isExternalModuleImportEquals(decl)) {
	                                action(decl, decl.moduleReference.expression);
	                            }
	                            break;
	                        }
	                    }
	                });
	            }
	        }
	        /**
	         * Given a local reference, we might notice that it's an import/export and recursively search for references of that.
	         * If at an import, look locally for the symbol it imports.
	         * If an an export, look for all imports of it.
	         * This doesn't handle export specifiers; that is done in `getReferencesAtExportSpecifier`.
	         * @param comingFromExport If we are doing a search for all exports, don't bother looking backwards for the imported symbol, since that's the reason we're here.
	         */
	        function getImportOrExportSymbol(node, symbol, checker, comingFromExport) {
	            return comingFromExport ? getExport() : getExport() || getImport();
	            function getExport() {
	                var parent = node.parent;
	                if (symbol.exportSymbol) {
	                    if (parent.kind === 184 /* PropertyAccessExpression */) {
	                        // When accessing an export of a JS module, there's no alias. The symbol will still be flagged as an export even though we're at the use.
	                        // So check that we are at the declaration.
	                        return symbol.declarations.some(function (d) { return d === parent; }) && ts.isBinaryExpression(parent.parent)
	                            ? getSpecialPropertyExport(parent.parent, /*useLhsSymbol*/ false)
	                            : undefined;
	                    }
	                    else {
	                        return exportInfo(symbol.exportSymbol, getExportKindForDeclaration(parent));
	                    }
	                }
	                else {
	                    var exportNode = getExportNode(parent, node);
	                    if (exportNode && ts.hasModifier(exportNode, 1 /* Export */)) {
	                        if (ts.isImportEqualsDeclaration(exportNode) && exportNode.moduleReference === node) {
	                            // We're at `Y` in `export import X = Y`. This is not the exported symbol, the left-hand-side is. So treat this as an import statement.
	                            if (comingFromExport) {
	                                return undefined;
	                            }
	                            var lhsSymbol = checker.getSymbolAtLocation(exportNode.name);
	                            return { kind: 0 /* Import */, symbol: lhsSymbol, isNamedImport: false };
	                        }
	                        else {
	                            return exportInfo(symbol, getExportKindForDeclaration(exportNode));
	                        }
	                    }
	                    // If we are in `export = a;` or `export default a;`, `parent` is the export assignment.
	                    else if (ts.isExportAssignment(parent)) {
	                        return getExportAssignmentExport(parent);
	                    }
	                    // If we are in `export = class A {};` (or `export = class A {};`) at `A`, `parent.parent` is the export assignment.
	                    else if (ts.isExportAssignment(parent.parent)) {
	                        return getExportAssignmentExport(parent.parent);
	                    }
	                    // Similar for `module.exports =` and `exports.A =`.
	                    else if (ts.isBinaryExpression(parent)) {
	                        return getSpecialPropertyExport(parent, /*useLhsSymbol*/ true);
	                    }
	                    else if (ts.isBinaryExpression(parent.parent)) {
	                        return getSpecialPropertyExport(parent.parent, /*useLhsSymbol*/ true);
	                    }
	                    else if (ts.isJSDocTypedefTag(parent)) {
	                        return exportInfo(symbol, 0 /* Named */);
	                    }
	                }
	                function getExportAssignmentExport(ex) {
	                    // Get the symbol for the `export =` node; its parent is the module it's the export of.
	                    var exportingModuleSymbol = ts.Debug.assertDefined(ex.symbol.parent, "Expected export symbol to have a parent");
	                    var exportKind = ex.isExportEquals ? 2 /* ExportEquals */ : 1 /* Default */;
	                    return { kind: 1 /* Export */, symbol: symbol, exportInfo: { exportingModuleSymbol: exportingModuleSymbol, exportKind: exportKind } };
	                }
	                function getSpecialPropertyExport(node, useLhsSymbol) {
	                    var kind;
	                    switch (ts.getSpecialPropertyAssignmentKind(node)) {
	                        case 1 /* ExportsProperty */:
	                            kind = 0 /* Named */;
	                            break;
	                        case 2 /* ModuleExports */:
	                            kind = 2 /* ExportEquals */;
	                            break;
	                        default:
	                            return undefined;
	                    }
	                    var sym = useLhsSymbol ? checker.getSymbolAtLocation(ts.cast(node.left, ts.isPropertyAccessExpression).name) : symbol;
	                    // Better detection for GH#20803
	                    if (sym && !(checker.getMergedSymbol(sym.parent).flags & 1536 /* Module */)) {
	                        ts.Debug.fail("Special property assignment kind does not have a module as its parent. Assignment is " + ts.Debug.showSymbol(sym) + ", parent is " + ts.Debug.showSymbol(sym.parent));
	                    }
	                    return sym && exportInfo(sym, kind);
	                }
	            }
	            function getImport() {
	                var isImport = isNodeImport(node);
	                if (!isImport)
	                    return undefined;
	                // A symbol being imported is always an alias. So get what that aliases to find the local symbol.
	                var importedSymbol = checker.getImmediateAliasedSymbol(symbol);
	                if (!importedSymbol)
	                    return undefined;
	                // Search on the local symbol in the exporting module, not the exported symbol.
	                importedSymbol = skipExportSpecifierSymbol(importedSymbol, checker);
	                // Similarly, skip past the symbol for 'export ='
	                if (importedSymbol.escapedName === "export=") {
	                    importedSymbol = getExportEqualsLocalSymbol(importedSymbol, checker);
	                }
	                // If the import has a different name than the export, do not continue searching.
	                // If `importedName` is undefined, do continue searching as the export is anonymous.
	                // (All imports returned from this function will be ignored anyway if we are in rename and this is a not a named export.)
	                var importedName = ts.symbolEscapedNameNoDefault(importedSymbol);
	                if (importedName === undefined || importedName === "default" /* Default */ || importedName === symbol.escapedName) {
	                    return __assign({ kind: 0 /* Import */, symbol: importedSymbol }, isImport);
	                }
	            }
	            function exportInfo(symbol, kind) {
	                var exportInfo = getExportInfo(symbol, kind, checker);
	                return exportInfo && { kind: 1 /* Export */, symbol: symbol, exportInfo: exportInfo };
	            }
	            // Not meant for use with export specifiers or export assignment.
	            function getExportKindForDeclaration(node) {
	                return ts.hasModifier(node, 512 /* Default */) ? 1 /* Default */ : 0 /* Named */;
	            }
	        }
	        FindAllReferences.getImportOrExportSymbol = getImportOrExportSymbol;
	        function getExportEqualsLocalSymbol(importedSymbol, checker) {
	            if (importedSymbol.flags & 2097152 /* Alias */) {
	                return ts.Debug.assertDefined(checker.getImmediateAliasedSymbol(importedSymbol));
	            }
	            var decl = importedSymbol.valueDeclaration;
	            if (ts.isExportAssignment(decl)) { // `export = class {}`
	                return ts.Debug.assertDefined(decl.expression.symbol);
	            }
	            else if (ts.isBinaryExpression(decl)) { // `module.exports = class {}`
	                return ts.Debug.assertDefined(decl.right.symbol);
	            }
	            else if (ts.isSourceFile(decl)) { // json module
	                return ts.Debug.assertDefined(decl.symbol);
	            }
	            return ts.Debug.fail();
	        }
	        // If a reference is a class expression, the exported node would be its parent.
	        // If a reference is a variable declaration, the exported node would be the variable statement.
	        function getExportNode(parent, node) {
	            if (parent.kind === 231 /* VariableDeclaration */) {
	                var p = parent;
	                return p.name !== node ? undefined :
	                    p.parent.kind === 268 /* CatchClause */ ? undefined : p.parent.parent.kind === 213 /* VariableStatement */ ? p.parent.parent : undefined;
	            }
	            else {
	                return parent;
	            }
	        }
	        function isNodeImport(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                    return parent.name === node && isExternalModuleImportEquals(parent)
	                        ? { isNamedImport: false }
	                        : undefined;
	                case 247 /* ImportSpecifier */:
	                    // For a rename import `{ foo as bar }`, don't search for the imported symbol. Just find local uses of `bar`.
	                    return parent.propertyName ? undefined : { isNamedImport: true };
	                case 244 /* ImportClause */:
	                case 245 /* NamespaceImport */:
	                    ts.Debug.assert(parent.name === node);
	                    return { isNamedImport: false };
	                default:
	                    return undefined;
	            }
	        }
	        function getExportInfo(exportSymbol, exportKind, checker) {
	            var moduleSymbol = exportSymbol.parent;
	            if (!moduleSymbol)
	                return undefined; // This can happen if an `export` is not at the top-level (which is a compile error).
	            var exportingModuleSymbol = checker.getMergedSymbol(moduleSymbol); // Need to get merged symbol in case there's an augmentation.
	            // `export` may appear in a namespace. In that case, just rely on global search.
	            return ts.isExternalModuleSymbol(exportingModuleSymbol) ? { exportingModuleSymbol: exportingModuleSymbol, exportKind: exportKind } : undefined;
	        }
	        FindAllReferences.getExportInfo = getExportInfo;
	        /** If at an export specifier, go to the symbol it refers to. */
	        function skipExportSpecifierSymbol(symbol, checker) {
	            // For `export { foo } from './bar", there's nothing to skip, because it does not create a new alias. But `export { foo } does.
	            if (symbol.declarations) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    if (ts.isExportSpecifier(declaration) && !declaration.propertyName && !declaration.parent.parent.moduleSpecifier) {
	                        return checker.getExportSpecifierLocalTargetSymbol(declaration);
	                    }
	                }
	            }
	            return symbol;
	        }
	        function getContainingModuleSymbol(importer, checker) {
	            return checker.getMergedSymbol(getSourceFileLikeForImportDeclaration(importer).symbol);
	        }
	        function getSourceFileLikeForImportDeclaration(node) {
	            if (node.kind === 186 /* CallExpression */) {
	                return node.getSourceFile();
	            }
	            var parent = node.parent;
	            if (parent.kind === 273 /* SourceFile */) {
	                return parent;
	            }
	            ts.Debug.assert(parent.kind === 239 /* ModuleBlock */);
	            return ts.cast(parent.parent, isAmbientModuleDeclaration);
	        }
	        function isAmbientModuleDeclaration(node) {
	            return node.kind === 238 /* ModuleDeclaration */ && node.name.kind === 9 /* StringLiteral */;
	        }
	        function isExternalModuleImportEquals(eq) {
	            return eq.moduleReference.kind === 253 /* ExternalModuleReference */ && eq.moduleReference.expression.kind === 9 /* StringLiteral */;
	        }
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        function nodeEntry(node, isInString) {
	            return { type: "node", node: node, isInString: isInString };
	        }
	        FindAllReferences.nodeEntry = nodeEntry;
	        function findReferencedSymbols(program, cancellationToken, sourceFiles, sourceFile, position) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            var referencedSymbols = FindAllReferences.Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken);
	            var checker = program.getTypeChecker();
	            return !referencedSymbols || !referencedSymbols.length ? undefined : ts.mapDefined(referencedSymbols, function (_a) {
	                var definition = _a.definition, references = _a.references;
	                // Only include referenced symbols that have a valid definition.
	                return definition && {
	                    definition: checker.runWithCancellationToken(cancellationToken, function (checker) { return definitionToReferencedSymbolDefinitionInfo(definition, checker, node); }),
	                    references: references.map(toReferenceEntry)
	                };
	            });
	        }
	        FindAllReferences.findReferencedSymbols = findReferencedSymbols;
	        function getImplementationsAtPosition(program, cancellationToken, sourceFiles, sourceFile, position) {
	            // A node in a JSDoc comment can't have an implementation anyway.
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ false);
	            var referenceEntries = getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position);
	            var checker = program.getTypeChecker();
	            return ts.map(referenceEntries, function (entry) { return toImplementationLocation(entry, checker); });
	        }
	        FindAllReferences.getImplementationsAtPosition = getImplementationsAtPosition;
	        function getImplementationReferenceEntries(program, cancellationToken, sourceFiles, node, position) {
	            if (node.kind === 273 /* SourceFile */) {
	                return undefined;
	            }
	            var checker = program.getTypeChecker();
	            // If invoked directly on a shorthand property assignment, then return
	            // the declaration of the symbol being assigned (not the symbol being assigned to).
	            if (node.parent.kind === 270 /* ShorthandPropertyAssignment */) {
	                var result_5 = [];
	                FindAllReferences.Core.getReferenceEntriesForShorthandPropertyAssignment(node, checker, function (node) { return result_5.push(nodeEntry(node)); });
	                return result_5;
	            }
	            else if (node.kind === 97 /* SuperKeyword */ || ts.isSuperProperty(node.parent)) {
	                // References to and accesses on the super keyword only have one possible implementation, so no
	                // need to "Find all References"
	                var symbol = checker.getSymbolAtLocation(node);
	                return symbol.valueDeclaration && [nodeEntry(symbol.valueDeclaration)];
	            }
	            else {
	                // Perform "Find all References" and retrieve only those that are implementations
	                return getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, { implementations: true });
	            }
	        }
	        function findReferencedEntries(program, cancellationToken, sourceFiles, sourceFile, position, options) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            return ts.map(flattenEntries(FindAllReferences.Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options)), toReferenceEntry);
	        }
	        FindAllReferences.findReferencedEntries = findReferencedEntries;
	        function getReferenceEntriesForNode(position, node, program, sourceFiles, cancellationToken, options, sourceFilesSet) {
	            if (options === void 0) { options = {}; }
	            if (sourceFilesSet === void 0) { sourceFilesSet = ts.arrayToSet(sourceFiles, function (f) { return f.fileName; }); }
	            return flattenEntries(FindAllReferences.Core.getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options, sourceFilesSet));
	        }
	        FindAllReferences.getReferenceEntriesForNode = getReferenceEntriesForNode;
	        function flattenEntries(referenceSymbols) {
	            return referenceSymbols && ts.flatMap(referenceSymbols, function (r) { return r.references; });
	        }
	        function definitionToReferencedSymbolDefinitionInfo(def, checker, originalNode) {
	            var info = (function () {
	                switch (def.type) {
	                    case "symbol": {
	                        var symbol = def.symbol;
	                        var _a = getDefinitionKindAndDisplayParts(symbol, checker, originalNode), displayParts_1 = _a.displayParts, kind_1 = _a.kind;
	                        var name_3 = displayParts_1.map(function (p) { return p.text; }).join("");
	                        return { node: symbol.declarations ? ts.getNameOfDeclaration(ts.first(symbol.declarations)) || ts.first(symbol.declarations) : originalNode, name: name_3, kind: kind_1, displayParts: displayParts_1 };
	                    }
	                    case "label": {
	                        var node_3 = def.node;
	                        return { node: node_3, name: node_3.text, kind: "label" /* label */, displayParts: [ts.displayPart(node_3.text, ts.SymbolDisplayPartKind.text)] };
	                    }
	                    case "keyword": {
	                        var node_4 = def.node;
	                        var name_4 = ts.tokenToString(node_4.kind);
	                        return { node: node_4, name: name_4, kind: "keyword" /* keyword */, displayParts: [{ text: name_4, kind: "keyword" /* keyword */ }] };
	                    }
	                    case "this": {
	                        var node_5 = def.node;
	                        var symbol = checker.getSymbolAtLocation(node_5);
	                        var displayParts_2 = symbol && ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, node_5.getSourceFile(), ts.getContainerNode(node_5), node_5).displayParts || [ts.textPart("this")];
	                        return { node: node_5, name: "this", kind: "var" /* variableElement */, displayParts: displayParts_2 };
	                    }
	                    case "string": {
	                        var node_6 = def.node;
	                        return { node: node_6, name: node_6.text, kind: "var" /* variableElement */, displayParts: [ts.displayPart(ts.getTextOfNode(node_6), ts.SymbolDisplayPartKind.stringLiteral)] };
	                    }
	                    default:
	                        return ts.Debug.assertNever(def);
	                }
	            })();
	            var node = info.node, name = info.name, kind = info.kind, displayParts = info.displayParts;
	            var sourceFile = node.getSourceFile();
	            return { containerKind: "" /* unknown */, containerName: "", fileName: sourceFile.fileName, kind: kind, name: name, textSpan: getTextSpan(ts.isComputedPropertyName(node) ? node.expression : node, sourceFile), displayParts: displayParts };
	        }
	        function getDefinitionKindAndDisplayParts(symbol, checker, node) {
	            var meaning = FindAllReferences.Core.getIntersectingMeaningFromDeclarations(node, symbol);
	            var enclosingDeclaration = ts.firstOrUndefined(symbol.declarations) || node;
	            var _a = ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(checker, symbol, enclosingDeclaration.getSourceFile(), enclosingDeclaration, enclosingDeclaration, meaning), displayParts = _a.displayParts, symbolKind = _a.symbolKind;
	            return { displayParts: displayParts, kind: symbolKind };
	        }
	        function toReferenceEntry(entry) {
	            if (entry.type === "span") {
	                return { textSpan: entry.textSpan, fileName: entry.fileName, isWriteAccess: false, isDefinition: false };
	            }
	            var node = entry.node, isInString = entry.isInString;
	            var sourceFile = node.getSourceFile();
	            return {
	                fileName: sourceFile.fileName,
	                textSpan: getTextSpan(node, sourceFile),
	                isWriteAccess: isWriteAccessForReference(node),
	                isDefinition: node.kind === 79 /* DefaultKeyword */
	                    || ts.isAnyDeclarationName(node)
	                    || ts.isLiteralComputedPropertyDeclarationName(node),
	                isInString: isInString,
	            };
	        }
	        function toImplementationLocation(entry, checker) {
	            if (entry.type === "node") {
	                var node = entry.node;
	                var sourceFile = node.getSourceFile();
	                return __assign({ textSpan: getTextSpan(node, sourceFile), fileName: sourceFile.fileName }, implementationKindDisplayParts(node, checker));
	            }
	            else {
	                var textSpan = entry.textSpan, fileName = entry.fileName;
	                return { textSpan: textSpan, fileName: fileName, kind: "" /* unknown */, displayParts: [] };
	            }
	        }
	        function implementationKindDisplayParts(node, checker) {
	            var symbol = checker.getSymbolAtLocation(ts.isDeclaration(node) && node.name ? node.name : node);
	            if (symbol) {
	                return getDefinitionKindAndDisplayParts(symbol, checker, node);
	            }
	            else if (node.kind === 183 /* ObjectLiteralExpression */) {
	                return {
	                    kind: "interface" /* interfaceElement */,
	                    displayParts: [ts.punctuationPart(19 /* OpenParenToken */), ts.textPart("object literal"), ts.punctuationPart(20 /* CloseParenToken */)]
	                };
	            }
	            else if (node.kind === 204 /* ClassExpression */) {
	                return {
	                    kind: "local class" /* localClassElement */,
	                    displayParts: [ts.punctuationPart(19 /* OpenParenToken */), ts.textPart("anonymous local class"), ts.punctuationPart(20 /* CloseParenToken */)]
	                };
	            }
	            else {
	                return { kind: ts.getNodeKind(node), displayParts: [] };
	            }
	        }
	        function toHighlightSpan(entry) {
	            if (entry.type === "span") {
	                var fileName = entry.fileName, textSpan = entry.textSpan;
	                return { fileName: fileName, span: { textSpan: textSpan, kind: "reference" /* reference */ } };
	            }
	            var node = entry.node, isInString = entry.isInString;
	            var sourceFile = node.getSourceFile();
	            var writeAccess = isWriteAccessForReference(node);
	            var span = {
	                textSpan: getTextSpan(node, sourceFile),
	                kind: writeAccess ? "writtenReference" /* writtenReference */ : "reference" /* reference */,
	                isInString: isInString
	            };
	            return { fileName: sourceFile.fileName, span: span };
	        }
	        FindAllReferences.toHighlightSpan = toHighlightSpan;
	        function getTextSpan(node, sourceFile) {
	            var start = node.getStart(sourceFile);
	            var end = node.getEnd();
	            if (node.kind === 9 /* StringLiteral */) {
	                start += 1;
	                end -= 1;
	            }
	            return ts.createTextSpanFromBounds(start, end);
	        }
	        /** A node is considered a writeAccess iff it is a name of a declaration or a target of an assignment */
	        function isWriteAccessForReference(node) {
	            return node.kind === 79 /* DefaultKeyword */ || ts.isAnyDeclarationName(node) || ts.isWriteAccess(node);
	        }
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/** Encapsulates the core find-all-references algorithm. */
	/* @internal */
	(function (ts) {
	    var FindAllReferences;
	    (function (FindAllReferences) {
	        var Core;
	        (function (Core) {
	            /** Core find-all-references algorithm. Handles special cases before delegating to `getReferencedSymbolsForSymbol`. */
	            function getReferencedSymbolsForNode(position, node, program, sourceFiles, cancellationToken, options, sourceFilesSet) {
	                if (options === void 0) { options = {}; }
	                if (sourceFilesSet === void 0) { sourceFilesSet = ts.arrayToSet(sourceFiles, function (f) { return f.fileName; }); }
	                if (ts.isSourceFile(node)) {
	                    var reference = ts.GoToDefinition.getReferenceAtPosition(node, position, program);
	                    return reference && getReferencedSymbolsForModule(program, program.getTypeChecker().getMergedSymbol(reference.file.symbol), /*excludeImportTypeOfExportEquals*/ false, sourceFiles, sourceFilesSet);
	                }
	                if (!options.implementations) {
	                    var special = getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken);
	                    if (special) {
	                        return special;
	                    }
	                }
	                var checker = program.getTypeChecker();
	                var symbol = checker.getSymbolAtLocation(node);
	                // Could not find a symbol e.g. unknown identifier
	                if (!symbol) {
	                    // String literal might be a property (and thus have a symbol), so do this here rather than in getReferencedSymbolsSpecial.
	                    return !options.implementations && ts.isStringLiteral(node) ? getReferencesForStringLiteral(node, sourceFiles, cancellationToken) : undefined;
	                }
	                var moduleReferences = ts.emptyArray;
	                var moduleSourceFile = isModuleSymbol(symbol);
	                if (moduleSourceFile) {
	                    var exportEquals = symbol.exports.get("export=" /* ExportEquals */);
	                    // If !!exportEquals, we're about to add references to `import("mod")` anyway, so don't double-count them.
	                    moduleReferences = getReferencedSymbolsForModule(program, symbol, !!exportEquals, sourceFiles, sourceFilesSet);
	                    if (!exportEquals || !sourceFilesSet.has(moduleSourceFile.fileName))
	                        return moduleReferences;
	                    // Continue to get references to 'export ='.
	                    symbol = ts.skipAlias(exportEquals, checker);
	                    node = undefined;
	                }
	                return ts.concatenate(moduleReferences, getReferencedSymbolsForSymbol(symbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options));
	            }
	            Core.getReferencedSymbolsForNode = getReferencedSymbolsForNode;
	            function isModuleSymbol(symbol) {
	                return symbol.flags & 1536 /* Module */ && ts.find(symbol.declarations, ts.isSourceFile);
	            }
	            function getReferencedSymbolsForModule(program, symbol, excludeImportTypeOfExportEquals, sourceFiles, sourceFilesSet) {
	                ts.Debug.assert(!!symbol.valueDeclaration);
	                var references = ts.mapDefined(FindAllReferences.findModuleReferences(program, sourceFiles, symbol), function (reference) {
	                    if (reference.kind === "import") {
	                        var parent = reference.literal.parent;
	                        if (ts.isLiteralTypeNode(parent)) {
	                            var importType = ts.cast(parent.parent, ts.isImportTypeNode);
	                            if (excludeImportTypeOfExportEquals && !importType.qualifier) {
	                                return undefined;
	                            }
	                        }
	                        // import("foo") with no qualifier will reference the `export =` of the module, which may be referenced anyway.
	                        return { type: "node", node: reference.literal };
	                    }
	                    else {
	                        return {
	                            type: "span",
	                            fileName: reference.referencingFile.fileName,
	                            textSpan: ts.createTextSpanFromRange(reference.ref),
	                        };
	                    }
	                });
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    switch (decl.kind) {
	                        case 273 /* SourceFile */:
	                            // Don't include the source file itself. (This may not be ideal behavior, but awkward to include an entire file as a reference.)
	                            break;
	                        case 238 /* ModuleDeclaration */:
	                            if (sourceFilesSet.has(decl.getSourceFile().fileName)) {
	                                references.push({ type: "node", node: decl.name });
	                            }
	                            break;
	                        default:
	                            // This may be merged with something.
	                            ts.Debug.fail("Expected a module symbol to be declared by a SourceFile or ModuleDeclaration.");
	                    }
	                }
	                return references.length ? [{ definition: { type: "symbol", symbol: symbol }, references: references }] : ts.emptyArray;
	            }
	            /** getReferencedSymbols for special node kinds. */
	            function getReferencedSymbolsSpecial(node, sourceFiles, cancellationToken) {
	                if (ts.isTypeKeyword(node.kind)) {
	                    return getAllReferencesForKeyword(sourceFiles, node.kind, cancellationToken);
	                }
	                // Labels
	                if (ts.isJumpStatementTarget(node)) {
	                    var labelDefinition = ts.getTargetLabel(node.parent, node.text);
	                    // if we have a label definition, look within its statement for references, if not, then
	                    // the label is undefined and we have no results..
	                    return labelDefinition && getLabelReferencesInNode(labelDefinition.parent, labelDefinition);
	                }
	                else if (ts.isLabelOfLabeledStatement(node)) {
	                    // it is a label definition and not a target, search within the parent labeledStatement
	                    return getLabelReferencesInNode(node.parent, node);
	                }
	                if (ts.isThis(node)) {
	                    return getReferencesForThisKeyword(node, sourceFiles, cancellationToken);
	                }
	                if (node.kind === 97 /* SuperKeyword */) {
	                    return getReferencesForSuperKeyword(node);
	                }
	                return undefined;
	            }
	            /** Core find-all-references algorithm for a normal symbol. */
	            function getReferencedSymbolsForSymbol(symbol, node, sourceFiles, sourceFilesSet, checker, cancellationToken, options) {
	                symbol = node && skipPastExportOrImportSpecifierOrUnion(symbol, node, checker) || symbol;
	                // Compute the meaning from the location and the symbol it references
	                var searchMeaning = node ? getIntersectingMeaningFromDeclarations(node, symbol) : 7 /* All */;
	                var result = [];
	                var state = new State(sourceFiles, sourceFilesSet, node ? getSpecialSearchKind(node) : 0 /* None */, checker, cancellationToken, searchMeaning, options, result);
	                if (node && node.kind === 79 /* DefaultKeyword */) {
	                    addReference(node, symbol, state);
	                    searchForImportsOfExport(node, symbol, { exportingModuleSymbol: ts.Debug.assertDefined(symbol.parent, "Expected export symbol to have a parent"), exportKind: 1 /* Default */ }, state);
	                }
	                else {
	                    var search = state.createSearch(node, symbol, /*comingFrom*/ undefined, { allSearchSymbols: node ? populateSearchSymbolSet(symbol, node, checker, options.implementations) : [symbol] });
	                    // Try to get the smallest valid scope that we can limit our search to;
	                    // otherwise we'll need to search globally (i.e. include each file).
	                    var scope = getSymbolScope(symbol);
	                    if (scope) {
	                        getReferencesInContainer(scope, scope.getSourceFile(), search, state, /*addReferencesHere*/ !(ts.isSourceFile(scope) && !ts.contains(sourceFiles, scope)));
	                    }
	                    else {
	                        // Global search
	                        for (var _i = 0, _a = state.sourceFiles; _i < _a.length; _i++) {
	                            var sourceFile = _a[_i];
	                            state.cancellationToken.throwIfCancellationRequested();
	                            searchForName(sourceFile, search, state);
	                        }
	                    }
	                }
	                return result;
	            }
	            function getSpecialSearchKind(node) {
	                switch (node.kind) {
	                    case 123 /* ConstructorKeyword */:
	                        return 1 /* Constructor */;
	                    case 71 /* Identifier */:
	                        if (ts.isClassLike(node.parent)) {
	                            ts.Debug.assert(node.parent.name === node);
	                            return 2 /* Class */;
	                        }
	                    // falls through
	                    default:
	                        return 0 /* None */;
	                }
	            }
	            /** Handle a few special cases relating to export/import specifiers. */
	            function skipPastExportOrImportSpecifierOrUnion(symbol, node, checker) {
	                var parent = node.parent;
	                if (ts.isExportSpecifier(parent)) {
	                    return getLocalSymbolForExportSpecifier(node, symbol, parent, checker);
	                }
	                if (ts.isImportSpecifier(parent) && parent.propertyName === node) {
	                    // We're at `foo` in `import { foo as bar }`. Probably intended to find all refs on the original, not just on the import.
	                    return checker.getImmediateAliasedSymbol(symbol);
	                }
	                // If the symbol is declared as part of a declaration like `{ type: "a" } | { type: "b" }`, use the property on the union type to get more references.
	                return ts.firstDefined(symbol.declarations, function (decl) {
	                    if (!decl.parent) {
	                        // Assertions for GH#21814. We should be handling SourceFile symbols in `getReferencedSymbolsForModule` instead of getting here.
	                        ts.Debug.fail("Unexpected symbol at " + ts.Debug.showSyntaxKind(node) + ": " + ts.Debug.showSymbol(symbol));
	                    }
	                    return ts.isTypeLiteralNode(decl.parent) && ts.isUnionTypeNode(decl.parent.parent)
	                        ? checker.getPropertyOfType(checker.getTypeFromTypeNode(decl.parent.parent), symbol.name)
	                        : undefined;
	                });
	            }
	            var SpecialSearchKind;
	            (function (SpecialSearchKind) {
	                SpecialSearchKind[SpecialSearchKind["None"] = 0] = "None";
	                SpecialSearchKind[SpecialSearchKind["Constructor"] = 1] = "Constructor";
	                SpecialSearchKind[SpecialSearchKind["Class"] = 2] = "Class";
	            })(SpecialSearchKind || (SpecialSearchKind = {}));
	            /**
	             * Holds all state needed for the finding references.
	             * Unlike `Search`, there is only one `State`.
	             */
	            var State = /** @class */ (function () {
	                function State(sourceFiles, sourceFilesSet, 
	                /** True if we're searching for constructor references. */
	                specialSearchKind, checker, cancellationToken, searchMeaning, options, result) {
	                    this.sourceFiles = sourceFiles;
	                    this.sourceFilesSet = sourceFilesSet;
	                    this.specialSearchKind = specialSearchKind;
	                    this.checker = checker;
	                    this.cancellationToken = cancellationToken;
	                    this.searchMeaning = searchMeaning;
	                    this.options = options;
	                    this.result = result;
	                    /** Cache for `explicitlyinheritsFrom`. */
	                    this.inheritsFromCache = ts.createMap();
	                    /**
	                     * Type nodes can contain multiple references to the same type. For example:
	                     *      let x: Foo & (Foo & Bar) = ...
	                     * Because we are returning the implementation locations and not the identifier locations,
	                     * duplicate entries would be returned here as each of the type references is part of
	                     * the same implementation. For that reason, check before we add a new entry.
	                     */
	                    this.markSeenContainingTypeReference = ts.nodeSeenTracker();
	                    /**
	                     * It's possible that we will encounter the right side of `export { foo as bar } from "x";` more than once.
	                     * For example:
	                     *     // b.ts
	                     *     export { foo as bar } from "./a";
	                     *     import { bar } from "./b";
	                     *
	                     * Normally at `foo as bar` we directly add `foo` and do not locally search for it (since it doesn't declare a local).
	                     * But another reference to it may appear in the same source file.
	                     * See `tests/cases/fourslash/transitiveExportImports3.ts`.
	                     */
	                    this.markSeenReExportRHS = ts.nodeSeenTracker();
	                    this.symbolIdToReferences = [];
	                    // Source file ID → symbol ID → Whether the symbol has been searched for in the source file.
	                    this.sourceFileToSeenSymbols = [];
	                }
	                State.prototype.includesSourceFile = function (sourceFile) {
	                    return this.sourceFilesSet.has(sourceFile.fileName);
	                };
	                /** Gets every place to look for references of an exported symbols. See `ImportsResult` in `importTracker.ts` for more documentation. */
	                State.prototype.getImportSearches = function (exportSymbol, exportInfo) {
	                    if (!this.importTracker)
	                        this.importTracker = FindAllReferences.createImportTracker(this.sourceFiles, this.sourceFilesSet, this.checker, this.cancellationToken);
	                    return this.importTracker(exportSymbol, exportInfo, this.options.isForRename);
	                };
	                /** @param allSearchSymbols set of additinal symbols for use by `includes`. */
	                State.prototype.createSearch = function (location, symbol, comingFrom, searchOptions) {
	                    if (searchOptions === void 0) { searchOptions = {}; }
	                    // Note: if this is an external module symbol, the name doesn't include quotes.
	                    // Note: getLocalSymbolForExportDefault handles `export default class C {}`, but not `export default C` or `export { C as default }`.
	                    // The other two forms seem to be handled downstream (e.g. in `skipPastExportOrImportSpecifier`), so special-casing the first form
	                    // here appears to be intentional).
	                    var _a = searchOptions.text, text = _a === void 0 ? ts.stripQuotes(ts.unescapeLeadingUnderscores((ts.getLocalSymbolForExportDefault(symbol) || symbol).escapedName)) : _a, _b = searchOptions.allSearchSymbols, allSearchSymbols = _b === void 0 ? [symbol] : _b;
	                    var escapedText = ts.escapeLeadingUnderscores(text);
	                    var parents = this.options.implementations && location && getParentSymbolsOfPropertyAccess(location, symbol, this.checker);
	                    return { symbol: symbol, comingFrom: comingFrom, text: text, escapedText: escapedText, parents: parents, allSearchSymbols: allSearchSymbols, includes: function (sym) { return ts.contains(allSearchSymbols, sym); } };
	                };
	                /**
	                 * Callback to add references for a particular searched symbol.
	                 * This initializes a reference group, so only call this if you will add at least one reference.
	                 */
	                State.prototype.referenceAdder = function (searchSymbol) {
	                    var symbolId = ts.getSymbolId(searchSymbol);
	                    var references = this.symbolIdToReferences[symbolId];
	                    if (!references) {
	                        references = this.symbolIdToReferences[symbolId] = [];
	                        this.result.push({ definition: { type: "symbol", symbol: searchSymbol }, references: references });
	                    }
	                    return function (node) { return references.push(FindAllReferences.nodeEntry(node)); };
	                };
	                /** Add a reference with no associated definition. */
	                State.prototype.addStringOrCommentReference = function (fileName, textSpan) {
	                    this.result.push({
	                        definition: undefined,
	                        references: [{ type: "span", fileName: fileName, textSpan: textSpan }]
	                    });
	                };
	                /** Returns `true` the first time we search for a symbol in a file and `false` afterwards. */
	                State.prototype.markSearchedSymbols = function (sourceFile, symbols) {
	                    var sourceId = ts.getNodeId(sourceFile);
	                    var seenSymbols = this.sourceFileToSeenSymbols[sourceId] || (this.sourceFileToSeenSymbols[sourceId] = ts.createMap());
	                    var anyNewSymbols = false;
	                    for (var _i = 0, symbols_5 = symbols; _i < symbols_5.length; _i++) {
	                        var sym = symbols_5[_i];
	                        anyNewSymbols = ts.addToSeen(seenSymbols, ts.getSymbolId(sym)) || anyNewSymbols;
	                    }
	                    return anyNewSymbols;
	                };
	                return State;
	            }());
	            /** Search for all imports of a given exported symbol using `State.getImportSearches`. */
	            function searchForImportsOfExport(exportLocation, exportSymbol, exportInfo, state) {
	                var _a = state.getImportSearches(exportSymbol, exportInfo), importSearches = _a.importSearches, singleReferences = _a.singleReferences, indirectUsers = _a.indirectUsers;
	                // For `import { foo as bar }` just add the reference to `foo`, and don't otherwise search in the file.
	                if (singleReferences.length) {
	                    var addRef = state.referenceAdder(exportSymbol);
	                    for (var _i = 0, singleReferences_1 = singleReferences; _i < singleReferences_1.length; _i++) {
	                        var singleRef = singleReferences_1[_i];
	                        if (shouldAddSingleReference(singleRef, state))
	                            addRef(singleRef);
	                    }
	                }
	                // For each import, find all references to that import in its source file.
	                for (var _b = 0, importSearches_1 = importSearches; _b < importSearches_1.length; _b++) {
	                    var _c = importSearches_1[_b], importLocation = _c[0], importSymbol = _c[1];
	                    getReferencesInSourceFile(importLocation.getSourceFile(), state.createSearch(importLocation, importSymbol, 1 /* Export */), state);
	                }
	                if (indirectUsers.length) {
	                    var indirectSearch = void 0;
	                    switch (exportInfo.exportKind) {
	                        case 0 /* Named */:
	                            indirectSearch = state.createSearch(exportLocation, exportSymbol, 1 /* Export */);
	                            break;
	                        case 1 /* Default */:
	                            // Search for a property access to '.default'. This can't be renamed.
	                            indirectSearch = state.options.isForRename ? undefined : state.createSearch(exportLocation, exportSymbol, 1 /* Export */, { text: "default" });
	                            break;
	                        case 2 /* ExportEquals */:
	                            break;
	                    }
	                    if (indirectSearch) {
	                        for (var _d = 0, indirectUsers_1 = indirectUsers; _d < indirectUsers_1.length; _d++) {
	                            var indirectUser = indirectUsers_1[_d];
	                            searchForName(indirectUser, indirectSearch, state);
	                        }
	                    }
	                }
	            }
	            function shouldAddSingleReference(singleRef, state) {
	                if (!hasMatchingMeaning(singleRef, state))
	                    return false;
	                if (!state.options.isForRename)
	                    return true;
	                // Don't rename an import type `import("./module-name")` when renaming `name` in `export = name;`
	                if (!ts.isIdentifier(singleRef))
	                    return false;
	                // At `default` in `import { default as x }` or `export { default as x }`, do add a reference, but do not rename.
	                return !((ts.isExportSpecifier(singleRef.parent) || ts.isImportSpecifier(singleRef.parent)) && singleRef.escapedText === "default" /* Default */);
	            }
	            // Go to the symbol we imported from and find references for it.
	            function searchForImportedSymbol(symbol, state) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var declaration = _a[_i];
	                    var exportingFile = declaration.getSourceFile();
	                    // Need to search in the file even if it's not in the search-file set, because it might export the symbol.
	                    getReferencesInSourceFile(exportingFile, state.createSearch(declaration, symbol, 0 /* Import */), state, state.includesSourceFile(exportingFile));
	                }
	            }
	            /** Search for all occurences of an identifier in a source file (and filter out the ones that match). */
	            function searchForName(sourceFile, search, state) {
	                if (ts.getNameTable(sourceFile).get(search.escapedText) !== undefined) {
	                    getReferencesInSourceFile(sourceFile, search, state);
	                }
	            }
	            function getPropertySymbolOfDestructuringAssignment(location, checker) {
	                return ts.isArrayLiteralOrObjectLiteralDestructuringPattern(location.parent.parent) &&
	                    checker.getPropertySymbolOfDestructuringAssignment(location);
	            }
	            function getObjectBindingElementWithoutPropertyName(symbol) {
	                var bindingElement = ts.getDeclarationOfKind(symbol, 181 /* BindingElement */);
	                if (bindingElement &&
	                    bindingElement.parent.kind === 179 /* ObjectBindingPattern */ &&
	                    ts.isIdentifier(bindingElement.name) &&
	                    !bindingElement.propertyName) {
	                    return bindingElement;
	                }
	            }
	            function getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker) {
	                var bindingElement = getObjectBindingElementWithoutPropertyName(symbol);
	                return bindingElement && ts.getPropertySymbolFromBindingElement(checker, bindingElement);
	            }
	            /**
	             * Determines the smallest scope in which a symbol may have named references.
	             * Note that not every construct has been accounted for. This function can
	             * probably be improved.
	             *
	             * @returns undefined if the scope cannot be determined, implying that
	             * a reference to a symbol can occur anywhere.
	             */
	            function getSymbolScope(symbol) {
	                // If this is the symbol of a named function expression or named class expression,
	                // then named references are limited to its own scope.
	                var declarations = symbol.declarations, flags = symbol.flags, parent = symbol.parent, valueDeclaration = symbol.valueDeclaration;
	                if (valueDeclaration && (valueDeclaration.kind === 191 /* FunctionExpression */ || valueDeclaration.kind === 204 /* ClassExpression */)) {
	                    return valueDeclaration;
	                }
	                if (!declarations) {
	                    return undefined;
	                }
	                // If this is private property or method, the scope is the containing class
	                if (flags & (4 /* Property */ | 8192 /* Method */)) {
	                    var privateDeclaration = ts.find(declarations, function (d) { return ts.hasModifier(d, 8 /* Private */); });
	                    if (privateDeclaration) {
	                        return ts.getAncestor(privateDeclaration, 234 /* ClassDeclaration */);
	                    }
	                    // Else this is a public property and could be accessed from anywhere.
	                    return undefined;
	                }
	                // If symbol is of object binding pattern element without property name we would want to
	                // look for property too and that could be anywhere
	                if (getObjectBindingElementWithoutPropertyName(symbol)) {
	                    return undefined;
	                }
	                /*
	                If the symbol has a parent, it's globally visible unless:
	                - It's a private property (handled above).
	                - It's a type parameter.
	                - The parent is an external module: then we should only search in the module (and recurse on the export later).
	                  - But if the parent has `export as namespace`, the symbol is globally visible through that namespace.
	                */
	                var exposedByParent = parent && !(symbol.flags & 262144 /* TypeParameter */);
	                if (exposedByParent && !((parent.flags & 1536 /* Module */) && ts.isExternalModuleSymbol(parent) && !parent.globalExports)) {
	                    return undefined;
	                }
	                var scope;
	                for (var _i = 0, declarations_10 = declarations; _i < declarations_10.length; _i++) {
	                    var declaration = declarations_10[_i];
	                    var container = ts.getContainerNode(declaration);
	                    if (scope && scope !== container) {
	                        // Different declarations have different containers, bail out
	                        return undefined;
	                    }
	                    if (!container || container.kind === 273 /* SourceFile */ && !ts.isExternalOrCommonJsModule(container)) {
	                        // This is a global variable and not an external module, any declaration defined
	                        // within this scope is visible outside the file
	                        return undefined;
	                    }
	                    // The search scope is the container node
	                    scope = container;
	                }
	                // If symbol.parent, this means we are in an export of an external module. (Otherwise we would have returned `undefined` above.)
	                // For an export of a module, we may be in a declaration file, and it may be accessed elsewhere. E.g.:
	                //     declare module "a" { export type T = number; }
	                //     declare module "b" { import { T } from "a"; export const x: T; }
	                // So we must search the whole source file. (Because we will mark the source file as seen, we we won't return to it when searching for imports.)
	                return exposedByParent ? scope.getSourceFile() : scope;
	            }
	            /** Used as a quick check for whether a symbol is used at all in a file (besides its definition). */
	            function isSymbolReferencedInFile(definition, checker, sourceFile) {
	                return eachSymbolReferenceInFile(definition, checker, sourceFile, function () { return true; }) || false;
	            }
	            Core.isSymbolReferencedInFile = isSymbolReferencedInFile;
	            function eachSymbolReferenceInFile(definition, checker, sourceFile, cb) {
	                var symbol = checker.getSymbolAtLocation(definition);
	                if (!symbol)
	                    return undefined;
	                for (var _i = 0, _a = getPossibleSymbolReferenceNodes(sourceFile, symbol.name); _i < _a.length; _i++) {
	                    var token = _a[_i];
	                    if (!ts.isIdentifier(token) || token === definition || token.escapedText !== definition.escapedText)
	                        continue;
	                    var referenceSymbol = checker.getSymbolAtLocation(token); // See GH#19955 for why the type annotation is necessary
	                    if (referenceSymbol === symbol
	                        || checker.getShorthandAssignmentValueSymbol(token.parent) === symbol
	                        || ts.isExportSpecifier(token.parent) && getLocalSymbolForExportSpecifier(token, referenceSymbol, token.parent, checker) === symbol) {
	                        var res = cb(token);
	                        if (res)
	                            return res;
	                    }
	                }
	            }
	            Core.eachSymbolReferenceInFile = eachSymbolReferenceInFile;
	            function getPossibleSymbolReferenceNodes(sourceFile, symbolName, container) {
	                if (container === void 0) { container = sourceFile; }
	                return getPossibleSymbolReferencePositions(sourceFile, symbolName, container).map(function (pos) { return ts.getTouchingPropertyName(sourceFile, pos, /*includeJsDocComment*/ true); });
	            }
	            function getPossibleSymbolReferencePositions(sourceFile, symbolName, container) {
	                if (container === void 0) { container = sourceFile; }
	                var positions = [];
	                /// TODO: Cache symbol existence for files to save text search
	                // Also, need to make this work for unicode escapes.
	                // Be resilient in the face of a symbol with no name or zero length name
	                if (!symbolName || !symbolName.length) {
	                    return positions;
	                }
	                var text = sourceFile.text;
	                var sourceLength = text.length;
	                var symbolNameLength = symbolName.length;
	                var position = text.indexOf(symbolName, container.pos);
	                while (position >= 0) {
	                    // If we are past the end, stop looking
	                    if (position > container.end)
	                        break;
	                    // We found a match.  Make sure it's not part of a larger word (i.e. the char
	                    // before and after it have to be a non-identifier char).
	                    var endPosition = position + symbolNameLength;
	                    if ((position === 0 || !ts.isIdentifierPart(text.charCodeAt(position - 1), 6 /* Latest */)) &&
	                        (endPosition === sourceLength || !ts.isIdentifierPart(text.charCodeAt(endPosition), 6 /* Latest */))) {
	                        // Found a real match.  Keep searching.
	                        positions.push(position);
	                    }
	                    position = text.indexOf(symbolName, position + symbolNameLength + 1);
	                }
	                return positions;
	            }
	            function getLabelReferencesInNode(container, targetLabel) {
	                var sourceFile = container.getSourceFile();
	                var labelName = targetLabel.text;
	                var references = ts.mapDefined(getPossibleSymbolReferenceNodes(sourceFile, labelName, container), function (node) {
	                    // Only pick labels that are either the target label, or have a target that is the target label
	                    return node === targetLabel || (ts.isJumpStatementTarget(node) && ts.getTargetLabel(node, labelName) === targetLabel) ? FindAllReferences.nodeEntry(node) : undefined;
	                });
	                return [{ definition: { type: "label", node: targetLabel }, references: references }];
	            }
	            function isValidReferencePosition(node, searchSymbolName) {
	                // Compare the length so we filter out strict superstrings of the symbol we are looking for
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        return node.text.length === searchSymbolName.length;
	                    case 9 /* StringLiteral */: {
	                        var str = node;
	                        return (ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(str) || ts.isNameOfModuleDeclaration(node) || ts.isExpressionOfExternalModuleImportEqualsDeclaration(node)) &&
	                            str.text.length === searchSymbolName.length;
	                    }
	                    case 8 /* NumericLiteral */:
	                        return ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(node) && node.text.length === searchSymbolName.length;
	                    case 79 /* DefaultKeyword */:
	                        return "default".length === searchSymbolName.length;
	                    default:
	                        return false;
	                }
	            }
	            function getAllReferencesForKeyword(sourceFiles, keywordKind, cancellationToken) {
	                var references = ts.flatMap(sourceFiles, function (sourceFile) {
	                    cancellationToken.throwIfCancellationRequested();
	                    return ts.mapDefined(getPossibleSymbolReferenceNodes(sourceFile, ts.tokenToString(keywordKind), sourceFile), function (referenceLocation) {
	                        return referenceLocation.kind === keywordKind ? FindAllReferences.nodeEntry(referenceLocation) : undefined;
	                    });
	                });
	                return references.length ? [{ definition: { type: "keyword", node: references[0].node }, references: references }] : undefined;
	            }
	            function getReferencesInSourceFile(sourceFile, search, state, addReferencesHere) {
	                if (addReferencesHere === void 0) { addReferencesHere = true; }
	                state.cancellationToken.throwIfCancellationRequested();
	                return getReferencesInContainer(sourceFile, sourceFile, search, state, addReferencesHere);
	            }
	            /**
	             * Search within node "container" for references for a search value, where the search value is defined as a
	             * tuple of(searchSymbol, searchText, searchLocation, and searchMeaning).
	             * searchLocation: a node where the search value
	             */
	            function getReferencesInContainer(container, sourceFile, search, state, addReferencesHere) {
	                if (!state.markSearchedSymbols(sourceFile, search.allSearchSymbols)) {
	                    return;
	                }
	                for (var _i = 0, _a = getPossibleSymbolReferencePositions(sourceFile, search.text, container); _i < _a.length; _i++) {
	                    var position = _a[_i];
	                    getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere);
	                }
	            }
	            function hasMatchingMeaning(referenceLocation, state) {
	                return !!(ts.getMeaningFromLocation(referenceLocation) & state.searchMeaning);
	            }
	            function getReferencesAtLocation(sourceFile, position, search, state, addReferencesHere) {
	                var referenceLocation = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	                if (!isValidReferencePosition(referenceLocation, search.text)) {
	                    // This wasn't the start of a token.  Check to see if it might be a
	                    // match in a comment or string if that's what the caller is asking
	                    // for.
	                    if (!state.options.implementations && (state.options.findInStrings && ts.isInString(sourceFile, position) || state.options.findInComments && ts.isInNonReferenceComment(sourceFile, position))) {
	                        // In the case where we're looking inside comments/strings, we don't have
	                        // an actual definition.  So just use 'undefined' here.  Features like
	                        // 'Rename' won't care (as they ignore the definitions), and features like
	                        // 'FindReferences' will just filter out these results.
	                        state.addStringOrCommentReference(sourceFile.fileName, ts.createTextSpan(position, search.text.length));
	                    }
	                    return;
	                }
	                if (!hasMatchingMeaning(referenceLocation, state))
	                    return;
	                var referenceSymbol = state.checker.getSymbolAtLocation(referenceLocation);
	                if (!referenceSymbol) {
	                    return;
	                }
	                var parent = referenceLocation.parent;
	                if (ts.isImportSpecifier(parent) && parent.propertyName === referenceLocation) {
	                    // This is added through `singleReferences` in ImportsResult. If we happen to see it again, don't add it again.
	                    return;
	                }
	                if (ts.isExportSpecifier(parent)) {
	                    ts.Debug.assert(referenceLocation.kind === 71 /* Identifier */);
	                    getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, parent, search, state, addReferencesHere);
	                    return;
	                }
	                var relatedSymbol = getRelatedSymbol(search, referenceSymbol, referenceLocation, state);
	                if (!relatedSymbol) {
	                    getReferenceForShorthandProperty(referenceSymbol, search, state);
	                    return;
	                }
	                switch (state.specialSearchKind) {
	                    case 0 /* None */:
	                        if (addReferencesHere)
	                            addReference(referenceLocation, relatedSymbol, state);
	                        break;
	                    case 1 /* Constructor */:
	                        addConstructorReferences(referenceLocation, sourceFile, search, state);
	                        break;
	                    case 2 /* Class */:
	                        addClassStaticThisReferences(referenceLocation, search, state);
	                        break;
	                    default:
	                        ts.Debug.assertNever(state.specialSearchKind);
	                }
	                getImportOrExportReferences(referenceLocation, referenceSymbol, search, state);
	            }
	            function getReferencesAtExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, search, state, addReferencesHere) {
	                var parent = exportSpecifier.parent, propertyName = exportSpecifier.propertyName, name = exportSpecifier.name;
	                var exportDeclaration = parent.parent;
	                var localSymbol = getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, state.checker);
	                if (!search.includes(localSymbol)) {
	                    return;
	                }
	                if (!propertyName) {
	                    // Don't rename at `export { default } from "m";`. (but do continue to search for imports of the re-export)
	                    if (!(state.options.isForRename && name.escapedText === "default" /* Default */)) {
	                        addRef();
	                    }
	                }
	                else if (referenceLocation === propertyName) {
	                    // For `export { foo as bar } from "baz"`, "`foo`" will be added from the singleReferences for import searches of the original export.
	                    // For `export { foo as bar };`, where `foo` is a local, so add it now.
	                    if (!exportDeclaration.moduleSpecifier) {
	                        addRef();
	                    }
	                    if (addReferencesHere && !state.options.isForRename && state.markSeenReExportRHS(name)) {
	                        addReference(name, referenceSymbol, state);
	                    }
	                }
	                else {
	                    if (state.markSeenReExportRHS(referenceLocation)) {
	                        addRef();
	                    }
	                }
	                // For `export { foo as bar }`, rename `foo`, but not `bar`.
	                if (!(referenceLocation === propertyName && state.options.isForRename)) {
	                    var exportKind = referenceLocation.originalKeywordKind === 79 /* DefaultKeyword */ ? 1 /* Default */ : 0 /* Named */;
	                    var exportInfo = FindAllReferences.getExportInfo(referenceSymbol, exportKind, state.checker);
	                    ts.Debug.assert(!!exportInfo);
	                    searchForImportsOfExport(referenceLocation, referenceSymbol, exportInfo, state);
	                }
	                // At `export { x } from "foo"`, also search for the imported symbol `"foo".x`.
	                if (search.comingFrom !== 1 /* Export */ && exportDeclaration.moduleSpecifier && !propertyName) {
	                    var imported = state.checker.getExportSpecifierLocalTargetSymbol(exportSpecifier);
	                    if (imported)
	                        searchForImportedSymbol(imported, state);
	                }
	                function addRef() {
	                    if (addReferencesHere)
	                        addReference(referenceLocation, localSymbol, state);
	                }
	            }
	            function getLocalSymbolForExportSpecifier(referenceLocation, referenceSymbol, exportSpecifier, checker) {
	                return isExportSpecifierAlias(referenceLocation, exportSpecifier) && checker.getExportSpecifierLocalTargetSymbol(exportSpecifier) || referenceSymbol;
	            }
	            function isExportSpecifierAlias(referenceLocation, exportSpecifier) {
	                var parent = exportSpecifier.parent, propertyName = exportSpecifier.propertyName, name = exportSpecifier.name;
	                ts.Debug.assert(propertyName === referenceLocation || name === referenceLocation);
	                if (propertyName) {
	                    // Given `export { foo as bar } [from "someModule"]`: It's an alias at `foo`, but at `bar` it's a new symbol.
	                    return propertyName === referenceLocation;
	                }
	                else {
	                    // `export { foo } from "foo"` is a re-export.
	                    // `export { foo };` is not a re-export, it creates an alias for the local variable `foo`.
	                    return !parent.parent.moduleSpecifier;
	                }
	            }
	            function getImportOrExportReferences(referenceLocation, referenceSymbol, search, state) {
	                var importOrExport = FindAllReferences.getImportOrExportSymbol(referenceLocation, referenceSymbol, state.checker, search.comingFrom === 1 /* Export */);
	                if (!importOrExport)
	                    return;
	                var symbol = importOrExport.symbol;
	                if (importOrExport.kind === 0 /* Import */) {
	                    if (!state.options.isForRename || importOrExport.isNamedImport) {
	                        searchForImportedSymbol(symbol, state);
	                    }
	                }
	                else {
	                    // We don't check for `state.isForRename`, even for default exports, because importers that previously matched the export name should be updated to continue matching.
	                    searchForImportsOfExport(referenceLocation, symbol, importOrExport.exportInfo, state);
	                }
	            }
	            function getReferenceForShorthandProperty(_a, search, state) {
	                var flags = _a.flags, valueDeclaration = _a.valueDeclaration;
	                var shorthandValueSymbol = state.checker.getShorthandAssignmentValueSymbol(valueDeclaration);
	                /*
	                 * Because in short-hand property assignment, an identifier which stored as name of the short-hand property assignment
	                 * has two meanings: property name and property value. Therefore when we do findAllReference at the position where
	                 * an identifier is declared, the language service should return the position of the variable declaration as well as
	                 * the position in short-hand property assignment excluding property accessing. However, if we do findAllReference at the
	                 * position of property accessing, the referenceEntry of such position will be handled in the first case.
	                 */
	                if (!(flags & 33554432 /* Transient */) && search.includes(shorthandValueSymbol)) {
	                    addReference(ts.getNameOfDeclaration(valueDeclaration), shorthandValueSymbol, state);
	                }
	            }
	            function addReference(referenceLocation, relatedSymbol, state) {
	                var addRef = state.referenceAdder(relatedSymbol);
	                if (state.options.implementations) {
	                    addImplementationReferences(referenceLocation, addRef, state);
	                }
	                else {
	                    addRef(referenceLocation);
	                }
	            }
	            /** Adds references when a constructor is used with `new this()` in its own class and `super()` calls in subclasses.  */
	            function addConstructorReferences(referenceLocation, sourceFile, search, state) {
	                if (ts.isNewExpressionTarget(referenceLocation)) {
	                    addReference(referenceLocation, search.symbol, state);
	                }
	                var pusher = function () { return state.referenceAdder(search.symbol); };
	                if (ts.isClassLike(referenceLocation.parent)) {
	                    ts.Debug.assert(referenceLocation.kind === 79 /* DefaultKeyword */ || referenceLocation.parent.name === referenceLocation);
	                    // This is the class declaration containing the constructor.
	                    findOwnConstructorReferences(search.symbol, sourceFile, pusher());
	                }
	                else {
	                    // If this class appears in `extends C`, then the extending class' "super" calls are references.
	                    var classExtending = tryGetClassByExtendingIdentifier(referenceLocation);
	                    if (classExtending) {
	                        findSuperConstructorAccesses(classExtending, pusher());
	                    }
	                }
	            }
	            function addClassStaticThisReferences(referenceLocation, search, state) {
	                addReference(referenceLocation, search.symbol, state);
	                var classLike = referenceLocation.parent;
	                if (state.options.isForRename || !ts.isClassLike(classLike))
	                    return;
	                ts.Debug.assert(classLike.name === referenceLocation);
	                var addRef = state.referenceAdder(search.symbol);
	                for (var _i = 0, _a = classLike.members; _i < _a.length; _i++) {
	                    var member = _a[_i];
	                    if (!(ts.isMethodOrAccessor(member) && ts.hasModifier(member, 32 /* Static */))) {
	                        continue;
	                    }
	                    member.body.forEachChild(function cb(node) {
	                        if (node.kind === 99 /* ThisKeyword */) {
	                            addRef(node);
	                        }
	                        else if (!ts.isFunctionLike(node)) {
	                            node.forEachChild(cb);
	                        }
	                    });
	                }
	            }
	            /**
	             * `classSymbol` is the class where the constructor was defined.
	             * Reference the constructor and all calls to `new this()`.
	             */
	            function findOwnConstructorReferences(classSymbol, sourceFile, addNode) {
	                for (var _i = 0, _a = classSymbol.members.get("__constructor" /* Constructor */).declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    var ctrKeyword = ts.findChildOfKind(decl, 123 /* ConstructorKeyword */, sourceFile);
	                    ts.Debug.assert(decl.kind === 154 /* Constructor */ && !!ctrKeyword);
	                    addNode(ctrKeyword);
	                }
	                classSymbol.exports.forEach(function (member) {
	                    var decl = member.valueDeclaration;
	                    if (decl && decl.kind === 153 /* MethodDeclaration */) {
	                        var body = decl.body;
	                        if (body) {
	                            forEachDescendantOfKind(body, 99 /* ThisKeyword */, function (thisKeyword) {
	                                if (ts.isNewExpressionTarget(thisKeyword)) {
	                                    addNode(thisKeyword);
	                                }
	                            });
	                        }
	                    }
	                });
	            }
	            /** Find references to `super` in the constructor of an extending class.  */
	            function findSuperConstructorAccesses(cls, addNode) {
	                var symbol = cls.symbol;
	                var ctr = symbol.members.get("__constructor" /* Constructor */);
	                if (!ctr) {
	                    return;
	                }
	                for (var _i = 0, _a = ctr.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    ts.Debug.assert(decl.kind === 154 /* Constructor */);
	                    var body = decl.body;
	                    if (body) {
	                        forEachDescendantOfKind(body, 97 /* SuperKeyword */, function (node) {
	                            if (ts.isCallExpressionTarget(node)) {
	                                addNode(node);
	                            }
	                        });
	                    }
	                }
	            }
	            function addImplementationReferences(refNode, addReference, state) {
	                // Check if we found a function/propertyAssignment/method with an implementation or initializer
	                if (ts.isDeclarationName(refNode) && isImplementation(refNode.parent)) {
	                    addReference(refNode.parent);
	                    return;
	                }
	                if (refNode.kind !== 71 /* Identifier */) {
	                    return;
	                }
	                if (refNode.parent.kind === 270 /* ShorthandPropertyAssignment */) {
	                    // Go ahead and dereference the shorthand assignment by going to its definition
	                    getReferenceEntriesForShorthandPropertyAssignment(refNode, state.checker, addReference);
	                }
	                // Check if the node is within an extends or implements clause
	                var containingClass = getContainingClassIfInHeritageClause(refNode);
	                if (containingClass) {
	                    addReference(containingClass);
	                    return;
	                }
	                // If we got a type reference, try and see if the reference applies to any expressions that can implement an interface
	                // Find the first node whose parent isn't a type node -- i.e., the highest type node.
	                var typeNode = ts.findAncestor(refNode, function (a) { return !ts.isQualifiedName(a.parent) && !ts.isTypeNode(a.parent) && !ts.isTypeElement(a.parent); });
	                var typeHavingNode = typeNode.parent;
	                if (ts.hasType(typeHavingNode) && typeHavingNode.type === typeNode && state.markSeenContainingTypeReference(typeHavingNode)) {
	                    if (ts.hasInitializer(typeHavingNode)) {
	                        addIfImplementation(typeHavingNode.initializer);
	                    }
	                    else if (ts.isFunctionLike(typeHavingNode) && typeHavingNode.body) {
	                        var body = typeHavingNode.body;
	                        if (body.kind === 212 /* Block */) {
	                            ts.forEachReturnStatement(body, function (returnStatement) {
	                                if (returnStatement.expression)
	                                    addIfImplementation(returnStatement.expression);
	                            });
	                        }
	                        else {
	                            addIfImplementation(body);
	                        }
	                    }
	                    else if (ts.isAssertionExpression(typeHavingNode)) {
	                        addIfImplementation(typeHavingNode.expression);
	                    }
	                }
	                function addIfImplementation(e) {
	                    if (isImplementationExpression(e))
	                        addReference(e);
	                }
	            }
	            function getContainingClassIfInHeritageClause(node) {
	                return ts.isIdentifier(node) || ts.isPropertyAccessExpression(node) ? getContainingClassIfInHeritageClause(node.parent)
	                    : ts.isExpressionWithTypeArguments(node) ? ts.tryCast(node.parent.parent, ts.isClassLike) : undefined;
	            }
	            /**
	             * Returns true if this is an expression that can be considered an implementation
	             */
	            function isImplementationExpression(node) {
	                switch (node.kind) {
	                    case 190 /* ParenthesizedExpression */:
	                        return isImplementationExpression(node.expression);
	                    case 192 /* ArrowFunction */:
	                    case 191 /* FunctionExpression */:
	                    case 183 /* ObjectLiteralExpression */:
	                    case 204 /* ClassExpression */:
	                    case 182 /* ArrayLiteralExpression */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	            /**
	             * Determines if the parent symbol occurs somewhere in the child's ancestry. If the parent symbol
	             * is an interface, determines if some ancestor of the child symbol extends or inherits from it.
	             * Also takes in a cache of previous results which makes this slightly more efficient and is
	             * necessary to avoid potential loops like so:
	             *     class A extends B { }
	             *     class B extends A { }
	             *
	             * We traverse the AST rather than using the type checker because users are typically only interested
	             * in explicit implementations of an interface/class when calling "Go to Implementation". Sibling
	             * implementations of types that share a common ancestor with the type whose implementation we are
	             * searching for need to be filtered out of the results. The type checker doesn't let us make the
	             * distinction between structurally compatible implementations and explicit implementations, so we
	             * must use the AST.
	             *
	             * @param symbol         A class or interface Symbol
	             * @param parent        Another class or interface Symbol
	             * @param cachedResults A map of symbol id pairs (i.e. "child,parent") to booleans indicating previous results
	             */
	            function explicitlyInheritsFrom(symbol, parent, cachedResults, checker) {
	                if (symbol === parent) {
	                    return true;
	                }
	                var key = ts.getSymbolId(symbol) + "," + ts.getSymbolId(parent);
	                var cached = cachedResults.get(key);
	                if (cached !== undefined) {
	                    return cached;
	                }
	                // Set the key so that we don't infinitely recurse
	                cachedResults.set(key, false);
	                var inherits = symbol.declarations.some(function (declaration) {
	                    return ts.getAllSuperTypeNodes(declaration).some(function (typeReference) {
	                        var type = checker.getTypeAtLocation(typeReference);
	                        return !!type && !!type.symbol && explicitlyInheritsFrom(type.symbol, parent, cachedResults, checker);
	                    });
	                });
	                cachedResults.set(key, inherits);
	                return inherits;
	            }
	            function getReferencesForSuperKeyword(superKeyword) {
	                var searchSpaceNode = ts.getSuperContainer(superKeyword, /*stopOnFunctions*/ false);
	                if (!searchSpaceNode) {
	                    return undefined;
	                }
	                // Whether 'super' occurs in a static context within a class.
	                var staticFlag = 32 /* Static */;
	                switch (searchSpaceNode.kind) {
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        staticFlag &= ts.getModifierFlags(searchSpaceNode);
	                        searchSpaceNode = searchSpaceNode.parent; // re-assign to be the owning class
	                        break;
	                    default:
	                        return undefined;
	                }
	                var sourceFile = searchSpaceNode.getSourceFile();
	                var references = ts.mapDefined(getPossibleSymbolReferenceNodes(sourceFile, "super", searchSpaceNode), function (node) {
	                    if (node.kind !== 97 /* SuperKeyword */) {
	                        return;
	                    }
	                    var container = ts.getSuperContainer(node, /*stopOnFunctions*/ false);
	                    // If we have a 'super' container, we must have an enclosing class.
	                    // Now make sure the owning class is the same as the search-space
	                    // and has the same static qualifier as the original 'super's owner.
	                    return container && (32 /* Static */ & ts.getModifierFlags(container)) === staticFlag && container.parent.symbol === searchSpaceNode.symbol ? FindAllReferences.nodeEntry(node) : undefined;
	                });
	                return [{ definition: { type: "symbol", symbol: searchSpaceNode.symbol }, references: references }];
	            }
	            function getReferencesForThisKeyword(thisOrSuperKeyword, sourceFiles, cancellationToken) {
	                var searchSpaceNode = ts.getThisContainer(thisOrSuperKeyword, /* includeArrowFunctions */ false);
	                // Whether 'this' occurs in a static context within a class.
	                var staticFlag = 32 /* Static */;
	                switch (searchSpaceNode.kind) {
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        if (ts.isObjectLiteralMethod(searchSpaceNode)) {
	                            break;
	                        }
	                    // falls through
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        staticFlag &= ts.getModifierFlags(searchSpaceNode);
	                        searchSpaceNode = searchSpaceNode.parent; // re-assign to be the owning class
	                        break;
	                    case 273 /* SourceFile */:
	                        if (ts.isExternalModule(searchSpaceNode)) {
	                            return undefined;
	                        }
	                    // falls through
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                        break;
	                    // Computed properties in classes are not handled here because references to this are illegal,
	                    // so there is no point finding references to them.
	                    default:
	                        return undefined;
	                }
	                var references = ts.flatMap(searchSpaceNode.kind === 273 /* SourceFile */ ? sourceFiles : [searchSpaceNode.getSourceFile()], function (sourceFile) {
	                    cancellationToken.throwIfCancellationRequested();
	                    return getPossibleSymbolReferenceNodes(sourceFile, "this", ts.isSourceFile(searchSpaceNode) ? sourceFile : searchSpaceNode).filter(function (node) {
	                        if (!ts.isThis(node)) {
	                            return false;
	                        }
	                        var container = ts.getThisContainer(node, /* includeArrowFunctions */ false);
	                        switch (searchSpaceNode.kind) {
	                            case 191 /* FunctionExpression */:
	                            case 233 /* FunctionDeclaration */:
	                                return searchSpaceNode.symbol === container.symbol;
	                            case 153 /* MethodDeclaration */:
	                            case 152 /* MethodSignature */:
	                                return ts.isObjectLiteralMethod(searchSpaceNode) && searchSpaceNode.symbol === container.symbol;
	                            case 204 /* ClassExpression */:
	                            case 234 /* ClassDeclaration */:
	                                // Make sure the container belongs to the same class
	                                // and has the appropriate static modifier from the original container.
	                                return container.parent && searchSpaceNode.symbol === container.parent.symbol && (ts.getModifierFlags(container) & 32 /* Static */) === staticFlag;
	                            case 273 /* SourceFile */:
	                                return container.kind === 273 /* SourceFile */ && !ts.isExternalModule(container);
	                        }
	                    });
	                }).map(function (n) { return FindAllReferences.nodeEntry(n); });
	                return [{
	                        definition: { type: "this", node: thisOrSuperKeyword },
	                        references: references
	                    }];
	            }
	            function getReferencesForStringLiteral(node, sourceFiles, cancellationToken) {
	                var references = ts.flatMap(sourceFiles, function (sourceFile) {
	                    cancellationToken.throwIfCancellationRequested();
	                    return ts.mapDefined(getPossibleSymbolReferenceNodes(sourceFile, node.text), function (ref) {
	                        return ts.isStringLiteral(ref) && ref.text === node.text ? FindAllReferences.nodeEntry(ref, /*isInString*/ true) : undefined;
	                    });
	                });
	                return [{
	                        definition: { type: "string", node: node },
	                        references: references
	                    }];
	            }
	            // For certain symbol kinds, we need to include other symbols in the search set.
	            // This is not needed when searching for re-exports.
	            function populateSearchSymbolSet(symbol, location, checker, implementations) {
	                var result = [];
	                forEachRelatedSymbol(symbol, location, checker, function (sym, root, base) { result.push(base || root || sym); }, 
	                /*allowBaseTypes*/ function () { return !implementations; });
	                return result;
	            }
	            function forEachRelatedSymbol(symbol, location, checker, cbSymbol, allowBaseTypes) {
	                var containingObjectLiteralElement = ts.getContainingObjectLiteralElement(location);
	                if (containingObjectLiteralElement) {
	                    // If the location is in a context sensitive location (i.e. in an object literal) try
	                    // to get a contextual type for it, and add the property symbol from the contextual
	                    // type to the search set
	                    var res_1 = ts.firstDefined(getPropertySymbolsFromContextualType(containingObjectLiteralElement, checker), fromRoot);
	                    if (res_1)
	                        return res_1;
	                    // If the location is name of property symbol from object literal destructuring pattern
	                    // Search the property symbol
	                    //      for ( { property: p2 } of elems) { }
	                    var propertySymbol = getPropertySymbolOfDestructuringAssignment(location, checker);
	                    var res1 = propertySymbol && cbSymbol(propertySymbol);
	                    if (res1)
	                        return res1;
	                    /* Because in short-hand property assignment, location has two meaning : property name and as value of the property
	                     * When we do findAllReference at the position of the short-hand property assignment, we would want to have references to position of
	                     * property name and variable declaration of the identifier.
	                     * Like in below example, when querying for all references for an identifier 'name', of the property assignment, the language service
	                     * should show both 'name' in 'obj' and 'name' in variable declaration
	                     *      const name = "Foo";
	                     *      const obj = { name };
	                     * In order to do that, we will populate the search set with the value symbol of the identifier as a value of the property assignment
	                     * so that when matching with potential reference symbol, both symbols from property declaration and variable declaration
	                     * will be included correctly.
	                     */
	                    var shorthandValueSymbol = checker.getShorthandAssignmentValueSymbol(location.parent);
	                    var res2 = shorthandValueSymbol && cbSymbol(shorthandValueSymbol);
	                    if (res2)
	                        return res2;
	                }
	                var res = fromRoot(symbol);
	                if (res)
	                    return res;
	                if (symbol.valueDeclaration && ts.isParameterPropertyDeclaration(symbol.valueDeclaration)) {
	                    // For a parameter property, now try on the other symbol (property if this was a parameter, parameter if this was a property).
	                    var paramProps = checker.getSymbolsOfParameterPropertyDeclaration(ts.cast(symbol.valueDeclaration, ts.isParameter), symbol.name);
	                    ts.Debug.assert(paramProps.length === 2 && !!(paramProps[0].flags & 1 /* FunctionScopedVariable */) && !!(paramProps[1].flags & 4 /* Property */)); // is [parameter, property]
	                    return fromRoot(symbol.flags & 1 /* FunctionScopedVariable */ ? paramProps[1] : paramProps[0]);
	                }
	                // If this is symbol of binding element without propertyName declaration in Object binding pattern
	                // Include the property in the search
	                var bindingElementPropertySymbol = getPropertySymbolOfObjectBindingPatternWithoutPropertyName(symbol, checker);
	                return bindingElementPropertySymbol && fromRoot(bindingElementPropertySymbol);
	                function fromRoot(sym) {
	                    // If this is a union property:
	                    //   - In populateSearchSymbolsSet we will add all the symbols from all its source symbols in all unioned types.
	                    //   - In findRelatedSymbol, we will just use the union symbol if any source symbol is included in the search.
	                    // If the symbol is an instantiation from a another symbol (e.g. widened symbol):
	                    //   - In populateSearchSymbolsSet, add the root the list
	                    //   - In findRelatedSymbol, return the source symbol if that is in the search. (Do not return the instantiation symbol.)
	                    return ts.firstDefined(checker.getRootSymbols(sym), function (rootSymbol) {
	                        return cbSymbol(sym, rootSymbol)
	                            // Add symbol of properties/methods of the same name in base classes and implemented interfaces definitions
	                            || (rootSymbol.parent && rootSymbol.parent.flags & (32 /* Class */ | 64 /* Interface */) && allowBaseTypes(rootSymbol)
	                                ? getPropertySymbolsFromBaseTypes(rootSymbol.parent, rootSymbol.name, checker, function (base) { return cbSymbol(sym, rootSymbol, base); })
	                                : undefined);
	                    });
	                }
	            }
	            /**
	             * Find symbol of the given property-name and add the symbol to the given result array
	             * @param symbol a symbol to start searching for the given propertyName
	             * @param propertyName a name of property to search for
	             * @param result an array of symbol of found property symbols
	             * @param previousIterationSymbolsCache a cache of symbol from previous iterations of calling this function to prevent infinite revisiting of the same symbol.
	             *                                The value of previousIterationSymbol is undefined when the function is first called.
	             */
	            function getPropertySymbolsFromBaseTypes(symbol, propertyName, checker, cb) {
	                var seen = ts.createMap();
	                return recur(symbol);
	                function recur(symbol) {
	                    // Use `addToSeen` to ensure we don't infinitely recurse in this situation:
	                    //      interface C extends C {
	                    //          /*findRef*/propName: string;
	                    //      }
	                    if (!(symbol.flags & (32 /* Class */ | 64 /* Interface */)) || !ts.addToSeen(seen, ts.getSymbolId(symbol)))
	                        return;
	                    return ts.firstDefined(symbol.declarations, function (declaration) { return ts.firstDefined(ts.getAllSuperTypeNodes(declaration), function (typeReference) {
	                        var type = checker.getTypeAtLocation(typeReference);
	                        var propertySymbol = type && type.symbol && checker.getPropertyOfType(type, propertyName);
	                        // Visit the typeReference as well to see if it directly or indirectly uses that property
	                        return propertySymbol && (ts.firstDefined(checker.getRootSymbols(propertySymbol), cb) || recur(type.symbol));
	                    }); });
	                }
	            }
	            function getRelatedSymbol(search, referenceSymbol, referenceLocation, state) {
	                var checker = state.checker;
	                return forEachRelatedSymbol(referenceSymbol, referenceLocation, checker, function (sym, rootSymbol, baseSymbol) { return search.includes(baseSymbol || rootSymbol || sym)
	                    // For a base type, use the symbol for the derived type. For a synthetic (e.g. union) property, use the union symbol.
	                    ? rootSymbol && !(ts.getCheckFlags(sym) & 6 /* Synthetic */) ? rootSymbol : sym
	                    : undefined; }, 
	                /*allowBaseTypes*/ function (rootSymbol) {
	                    return !(search.parents && !search.parents.some(function (parent) { return explicitlyInheritsFrom(rootSymbol.parent, parent, state.inheritsFromCache, checker); }));
	                });
	            }
	            /** Gets all symbols for one property. Does not get symbols for every property. */
	            function getPropertySymbolsFromContextualType(node, checker) {
	                var contextualType = checker.getContextualType(node.parent);
	                var name = ts.getNameFromPropertyName(node.name);
	                var symbol = contextualType && name && contextualType.getProperty(name);
	                return symbol ? [symbol] :
	                    contextualType && contextualType.isUnion() ? ts.mapDefined(contextualType.types, function (t) { return t.getProperty(name); }) : ts.emptyArray;
	            }
	            /**
	             * Given an initial searchMeaning, extracted from a location, widen the search scope based on the declarations
	             * of the corresponding symbol. e.g. if we are searching for "Foo" in value position, but "Foo" references a class
	             * then we need to widen the search to include type positions as well.
	             * On the contrary, if we are searching for "Bar" in type position and we trace bar to an interface, and an uninstantiated
	             * module, we want to keep the search limited to only types, as the two declarations (interface and uninstantiated module)
	             * do not intersect in any of the three spaces.
	             */
	            function getIntersectingMeaningFromDeclarations(node, symbol) {
	                var meaning = ts.getMeaningFromLocation(node);
	                var declarations = symbol.declarations;
	                if (declarations) {
	                    var lastIterationMeaning = void 0;
	                    do {
	                        // The result is order-sensitive, for instance if initialMeaning === Namespace, and declarations = [class, instantiated module]
	                        // we need to consider both as they initialMeaning intersects with the module in the namespace space, and the module
	                        // intersects with the class in the value space.
	                        // To achieve that we will keep iterating until the result stabilizes.
	                        // Remember the last meaning
	                        lastIterationMeaning = meaning;
	                        for (var _i = 0, declarations_11 = declarations; _i < declarations_11.length; _i++) {
	                            var declaration = declarations_11[_i];
	                            var declarationMeaning = ts.getMeaningFromDeclaration(declaration);
	                            if (declarationMeaning & meaning) {
	                                meaning |= declarationMeaning;
	                            }
	                        }
	                    } while (meaning !== lastIterationMeaning);
	                }
	                return meaning;
	            }
	            Core.getIntersectingMeaningFromDeclarations = getIntersectingMeaningFromDeclarations;
	            function isImplementation(node) {
	                return !!(node.flags & 4194304 /* Ambient */)
	                    || (ts.isVariableLike(node) ? ts.hasInitializer(node)
	                        : ts.isFunctionLikeDeclaration(node) ? !!node.body
	                            : ts.isClassLike(node) || ts.isModuleOrEnumDeclaration(node));
	            }
	            function getReferenceEntriesForShorthandPropertyAssignment(node, checker, addReference) {
	                var refSymbol = checker.getSymbolAtLocation(node);
	                var shorthandSymbol = checker.getShorthandAssignmentValueSymbol(refSymbol.valueDeclaration);
	                if (shorthandSymbol) {
	                    for (var _i = 0, _a = shorthandSymbol.getDeclarations(); _i < _a.length; _i++) {
	                        var declaration = _a[_i];
	                        if (ts.getMeaningFromDeclaration(declaration) & 1 /* Value */) {
	                            addReference(declaration);
	                        }
	                    }
	                }
	            }
	            Core.getReferenceEntriesForShorthandPropertyAssignment = getReferenceEntriesForShorthandPropertyAssignment;
	            function forEachDescendantOfKind(node, kind, action) {
	                ts.forEachChild(node, function (child) {
	                    if (child.kind === kind) {
	                        action(child);
	                    }
	                    forEachDescendantOfKind(child, kind, action);
	                });
	            }
	            /** Get `C` given `N` if `N` is in the position `class C extends N` or `class C extends foo.N` where `N` is an identifier. */
	            function tryGetClassByExtendingIdentifier(node) {
	                return ts.tryGetClassExtendingExpressionWithTypeArguments(ts.climbPastPropertyAccess(node).parent);
	            }
	            /**
	             * If we are just looking for implementations and this is a property access expression, we need to get the
	             * symbol of the local type of the symbol the property is being accessed on. This is because our search
	             * symbol may have a different parent symbol if the local type's symbol does not declare the property
	             * being accessed (i.e. it is declared in some parent class or interface)
	             */
	            function getParentSymbolsOfPropertyAccess(location, symbol, checker) {
	                var propertyAccessExpression = ts.isRightSideOfPropertyAccess(location) ? location.parent : undefined;
	                var lhsType = propertyAccessExpression && checker.getTypeAtLocation(propertyAccessExpression.expression);
	                var res = ts.mapDefined(lhsType && (lhsType.isUnionOrIntersection() ? lhsType.types : lhsType.symbol === symbol.parent ? undefined : [lhsType]), function (t) {
	                    return t.symbol && t.symbol.flags & (32 /* Class */ | 64 /* Interface */) ? t.symbol : undefined;
	                });
	                return res.length === 0 ? undefined : res;
	            }
	        })(Core = FindAllReferences.Core || (FindAllReferences.Core = {}));
	    })(FindAllReferences = ts.FindAllReferences || (ts.FindAllReferences = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function getEditsForFileRename(program, oldFileOrDirPath, newFileOrDirPath, host, formatContext, preferences) {
	        var useCaseSensitiveFileNames = ts.hostUsesCaseSensitiveFileNames(host);
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        var oldToNew = getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName);
	        var newToOld = getPathUpdater(newFileOrDirPath, oldFileOrDirPath, getCanonicalFileName);
	        return ts.textChanges.ChangeTracker.with({ host: host, formatContext: formatContext }, function (changeTracker) {
	            updateTsconfigFiles(program, changeTracker, oldToNew, newFileOrDirPath, host.getCurrentDirectory(), useCaseSensitiveFileNames);
	            updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName, preferences);
	        });
	    }
	    ts.getEditsForFileRename = getEditsForFileRename;
	    function getPathUpdater(oldFileOrDirPath, newFileOrDirPath, getCanonicalFileName) {
	        var canonicalOldPath = getCanonicalFileName(oldFileOrDirPath);
	        return function (path) {
	            var canonicalPath = getCanonicalFileName(path);
	            if (canonicalPath === canonicalOldPath)
	                return newFileOrDirPath;
	            var suffix = ts.tryRemoveDirectoryPrefix(canonicalPath, canonicalOldPath);
	            return suffix === undefined ? undefined : newFileOrDirPath + "/" + suffix;
	        };
	    }
	    function updateTsconfigFiles(program, changeTracker, oldToNew, newFileOrDirPath, currentDirectory, useCaseSensitiveFileNames) {
	        var configFile = program.getCompilerOptions().configFile;
	        if (!configFile)
	            return;
	        var configDir = ts.getDirectoryPath(configFile.fileName);
	        var jsonObjectLiteral = ts.getTsConfigObjectLiteralExpression(configFile);
	        if (!jsonObjectLiteral)
	            return;
	        forEachProperty(jsonObjectLiteral, function (property, propertyName) {
	            switch (propertyName) {
	                case "files":
	                case "include":
	                case "exclude": {
	                    var foundExactMatch = updatePaths(property);
	                    if (!foundExactMatch && propertyName === "include" && ts.isArrayLiteralExpression(property.initializer)) {
	                        var includes = ts.mapDefined(property.initializer.elements, function (e) { return ts.isStringLiteral(e) ? e.text : undefined; });
	                        var matchers = ts.getFileMatcherPatterns(configDir, /*excludes*/ [], includes, useCaseSensitiveFileNames, currentDirectory);
	                        // If there isn't some include for this, add a new one.
	                        if (!ts.getRegexFromPattern(ts.Debug.assertDefined(matchers.includeFilePattern), useCaseSensitiveFileNames).test(newFileOrDirPath)) {
	                            changeTracker.insertNodeAfter(configFile, ts.last(property.initializer.elements), ts.createStringLiteral(relativePath(newFileOrDirPath)));
	                        }
	                    }
	                    break;
	                }
	                case "compilerOptions":
	                    forEachProperty(property.initializer, function (property, propertyName) {
	                        var option = ts.getOptionFromName(propertyName);
	                        if (option && (option.isFilePath || option.type === "list" && option.element.isFilePath)) {
	                            updatePaths(property);
	                        }
	                        else if (propertyName === "paths") {
	                            forEachProperty(property.initializer, function (pathsProperty) {
	                                if (!ts.isArrayLiteralExpression(pathsProperty.initializer))
	                                    return;
	                                for (var _i = 0, _a = pathsProperty.initializer.elements; _i < _a.length; _i++) {
	                                    var e = _a[_i];
	                                    tryUpdateString(e);
	                                }
	                            });
	                        }
	                    });
	                    break;
	            }
	        });
	        function updatePaths(property) {
	            // Type annotation needed due to #7294
	            var elements = ts.isArrayLiteralExpression(property.initializer) ? property.initializer.elements : [property.initializer];
	            var foundExactMatch = false;
	            for (var _i = 0, elements_5 = elements; _i < elements_5.length; _i++) {
	                var element = elements_5[_i];
	                foundExactMatch = tryUpdateString(element) || foundExactMatch;
	            }
	            return foundExactMatch;
	        }
	        function tryUpdateString(element) {
	            if (!ts.isStringLiteral(element))
	                return false;
	            var elementFileName = combinePathsSafe(configDir, element.text);
	            var updated = oldToNew(elementFileName);
	            if (updated !== undefined) {
	                changeTracker.replaceRangeWithText(configFile, createStringRange(element, configFile), relativePath(updated));
	                return true;
	            }
	            return false;
	        }
	        function relativePath(path) {
	            return ts.getRelativePathFromDirectory(configDir, path, /*ignoreCase*/ !useCaseSensitiveFileNames);
	        }
	    }
	    function updateImports(program, changeTracker, oldToNew, newToOld, host, getCanonicalFileName, preferences) {
	        var _loop_14 = function (sourceFile) {
	            var newImportFromPath = oldToNew(sourceFile.fileName) || sourceFile.fileName;
	            var newImportFromDirectory = ts.getDirectoryPath(newImportFromPath);
	            var oldFromNew = newToOld(sourceFile.fileName);
	            var oldImportFromPath = oldFromNew || sourceFile.fileName;
	            var oldImportFromDirectory = ts.getDirectoryPath(oldImportFromPath);
	            updateImportsWorker(sourceFile, changeTracker, function (referenceText) {
	                if (!ts.pathIsRelative(referenceText))
	                    return undefined;
	                var oldAbsolute = combinePathsSafe(oldImportFromDirectory, referenceText);
	                var newAbsolute = oldToNew(oldAbsolute);
	                return newAbsolute === undefined ? undefined : ts.ensurePathIsNonModuleName(ts.getRelativePathFromDirectory(newImportFromDirectory, newAbsolute, getCanonicalFileName));
	            }, function (importLiteral) {
	                var toImport = oldFromNew !== undefined
	                    // If we're at the new location (file was already renamed), need to redo module resolution starting from the old location.
	                    // TODO:GH#18217
	                    ? getSourceFileToImportFromResolved(ts.resolveModuleName(importLiteral.text, oldImportFromPath, program.getCompilerOptions(), host), oldToNew, program)
	                    : getSourceFileToImport(importLiteral, sourceFile, program, host, oldToNew);
	                return toImport === undefined ? undefined : ts.moduleSpecifiers.getModuleSpecifier(program.getCompilerOptions(), sourceFile, newImportFromPath, toImport, host, preferences);
	            });
	        };
	        for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	            var sourceFile = _a[_i];
	            _loop_14(sourceFile);
	        }
	    }
	    function combineNormal(pathA, pathB) {
	        return ts.normalizePath(ts.combinePaths(pathA, pathB));
	    }
	    function combinePathsSafe(pathA, pathB) {
	        return ts.ensurePathIsNonModuleName(combineNormal(pathA, pathB));
	    }
	    function getSourceFileToImport(importLiteral, importingSourceFile, program, host, oldToNew) {
	        var symbol = program.getTypeChecker().getSymbolAtLocation(importLiteral);
	        if (symbol) {
	            if (symbol.declarations.some(function (d) { return ts.isAmbientModule(d); }))
	                return undefined; // No need to update if it's an ambient module
	            var oldFileName = ts.find(symbol.declarations, ts.isSourceFile).fileName;
	            return oldToNew(oldFileName) || oldFileName;
	        }
	        else {
	            var resolved = host.resolveModuleNames
	                ? host.getResolvedModuleWithFailedLookupLocationsFromCache && host.getResolvedModuleWithFailedLookupLocationsFromCache(importLiteral.text, importingSourceFile.fileName)
	                : program.getResolvedModuleWithFailedLookupLocationsFromCache(importLiteral.text, importingSourceFile.fileName);
	            return getSourceFileToImportFromResolved(resolved, oldToNew, program);
	        }
	    }
	    function getSourceFileToImportFromResolved(resolved, oldToNew, program) {
	        return resolved && ((resolved.resolvedModule && getIfInProgram(resolved.resolvedModule.resolvedFileName)) || ts.firstDefined(resolved.failedLookupLocations, getIfInProgram));
	        function getIfInProgram(oldLocation) {
	            var newLocation = oldToNew(oldLocation);
	            return program.getSourceFile(oldLocation) || newLocation !== undefined && program.getSourceFile(newLocation)
	                ? newLocation || oldLocation
	                : undefined;
	        }
	    }
	    function updateImportsWorker(sourceFile, changeTracker, updateRef, updateImport) {
	        for (var _i = 0, _a = sourceFile.referencedFiles; _i < _a.length; _i++) {
	            var ref = _a[_i];
	            var updated = updateRef(ref.fileName);
	            if (updated !== undefined && updated !== sourceFile.text.slice(ref.pos, ref.end))
	                changeTracker.replaceRangeWithText(sourceFile, ref, updated);
	        }
	        for (var _b = 0, _c = sourceFile.imports; _b < _c.length; _b++) {
	            var importStringLiteral = _c[_b];
	            var updated = updateImport(importStringLiteral);
	            if (updated !== undefined && updated !== importStringLiteral.text)
	                changeTracker.replaceRangeWithText(sourceFile, createStringRange(importStringLiteral, sourceFile), updated);
	        }
	    }
	    function createStringRange(node, sourceFile) {
	        return ts.createTextRange(node.getStart(sourceFile) + 1, node.end - 1);
	    }
	    function forEachProperty(objectLiteral, cb) {
	        if (!ts.isObjectLiteralExpression(objectLiteral))
	            return;
	        for (var _i = 0, _a = objectLiteral.properties; _i < _a.length; _i++) {
	            var property = _a[_i];
	            if (ts.isPropertyAssignment(property) && ts.isStringLiteral(property.name)) {
	                cb(property, property.name.text);
	            }
	        }
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var GoToDefinition;
	    (function (GoToDefinition) {
	        function getDefinitionAtPosition(program, sourceFile, position) {
	            var reference = getReferenceAtPosition(sourceFile, position, program);
	            if (reference) {
	                return [getDefinitionInfoForFileReference(reference.fileName, reference.file.fileName)];
	            }
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                return undefined;
	            }
	            // Labels
	            if (ts.isJumpStatementTarget(node)) {
	                var label = ts.getTargetLabel(node.parent, node.text);
	                return label ? [createDefinitionInfoFromName(label, "label" /* label */, node.text, /*containerName*/ undefined)] : undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            var symbol = getSymbol(node, typeChecker);
	            // Could not find a symbol e.g. node is string or number keyword,
	            // or the symbol was an internal symbol and does not have a declaration e.g. undefined symbol
	            if (!symbol) {
	                return getDefinitionInfoForIndexSignatures(node, typeChecker);
	            }
	            var calledDeclaration = tryGetSignatureDeclaration(typeChecker, node);
	            if (calledDeclaration) {
	                var sigInfo = createDefinitionFromSignatureDeclaration(typeChecker, calledDeclaration);
	                // For a function, if this is the original function definition, return just sigInfo.
	                // If this is the original constructor definition, parent is the class.
	                return typeChecker.getRootSymbols(symbol).some(function (s) { return calledDeclaration.symbol === s || calledDeclaration.symbol.parent === s; }) ||
	                    // TODO: GH#23742 Following check shouldn't be necessary if 'require' is an alias
	                    symbol.declarations.some(function (d) { return ts.isVariableDeclaration(d) && d.initializer && ts.isRequireCall(d.initializer, /*checkArgumentIsStringLiteralLike*/ false); })
	                    ? [sigInfo]
	                    : [sigInfo].concat(getDefinitionFromSymbol(typeChecker, symbol, node));
	            }
	            // Because name in short-hand property assignment has two different meanings: property name and property value,
	            // using go-to-definition at such position should go to the variable declaration of the property value rather than
	            // go to the declaration of the property name (in this case stay at the same position). However, if go-to-definition
	            // is performed at the location of property access, we would like to go to definition of the property in the short-hand
	            // assignment. This case and others are handled by the following code.
	            if (node.parent.kind === 270 /* ShorthandPropertyAssignment */) {
	                var shorthandSymbol_1 = typeChecker.getShorthandAssignmentValueSymbol(symbol.valueDeclaration);
	                return shorthandSymbol_1 ? shorthandSymbol_1.declarations.map(function (decl) { return createDefinitionInfo(decl, typeChecker, shorthandSymbol_1, node); }) : [];
	            }
	            // If the node is the name of a BindingElement within an ObjectBindingPattern instead of just returning the
	            // declaration the symbol (which is itself), we should try to get to the original type of the ObjectBindingPattern
	            // and return the property declaration for the referenced property.
	            // For example:
	            //      import('./foo').then(({ b/*goto*/ar }) => undefined); => should get use to the declaration in file "./foo"
	            //
	            //      function bar<T>(onfulfilled: (value: T) => void) { //....}
	            //      interface Test {
	            //          pr/*destination*/op1: number
	            //      }
	            //      bar<Test>(({pr/*goto*/op1})=>{});
	            if (ts.isPropertyName(node) && ts.isBindingElement(node.parent) && ts.isObjectBindingPattern(node.parent.parent) &&
	                (node === (node.parent.propertyName || node.parent.name))) {
	                var type = typeChecker.getTypeAtLocation(node.parent.parent);
	                if (type) {
	                    var propSymbols = ts.getPropertySymbolsFromType(type, node);
	                    if (propSymbols) {
	                        return ts.flatMap(propSymbols, function (propSymbol) { return getDefinitionFromSymbol(typeChecker, propSymbol, node); });
	                    }
	                }
	            }
	            // If the current location we want to find its definition is in an object literal, try to get the contextual type for the
	            // object literal, lookup the property symbol in the contextual type, and use this for goto-definition.
	            // For example
	            //      interface Props{
	            //          /*first*/prop1: number
	            //          prop2: boolean
	            //      }
	            //      function Foo(arg: Props) {}
	            //      Foo( { pr/*1*/op1: 10, prop2: true })
	            var element = ts.getContainingObjectLiteralElement(node);
	            if (element && typeChecker.getContextualType(element.parent)) {
	                return ts.flatMap(ts.getPropertySymbolsFromContextualType(typeChecker, element), function (propertySymbol) {
	                    return getDefinitionFromSymbol(typeChecker, propertySymbol, node);
	                });
	            }
	            return getDefinitionFromSymbol(typeChecker, symbol, node);
	        }
	        GoToDefinition.getDefinitionAtPosition = getDefinitionAtPosition;
	        function getReferenceAtPosition(sourceFile, position, program) {
	            var referencePath = findReferenceInPosition(sourceFile.referencedFiles, position);
	            if (referencePath) {
	                var file_16 = ts.tryResolveScriptReference(program, sourceFile, referencePath);
	                return file_16 && { fileName: referencePath.fileName, file: file_16 };
	            }
	            var typeReferenceDirective = findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
	            if (typeReferenceDirective) {
	                var reference = program.getResolvedTypeReferenceDirectives().get(typeReferenceDirective.fileName);
	                var file_17 = reference && program.getSourceFile(reference.resolvedFileName);
	                return file_17 && { fileName: typeReferenceDirective.fileName, file: file_17 };
	            }
	            return undefined;
	        }
	        GoToDefinition.getReferenceAtPosition = getReferenceAtPosition;
	        /// Goto type
	        function getTypeDefinitionAtPosition(typeChecker, sourceFile, position) {
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                return undefined;
	            }
	            var symbol = typeChecker.getSymbolAtLocation(node);
	            var type = symbol && typeChecker.getTypeOfSymbolAtLocation(symbol, node);
	            if (!type) {
	                return undefined;
	            }
	            if (type.isUnion() && !(type.flags & 16 /* Enum */)) {
	                return ts.flatMap(type.types, function (t) { return t.symbol && getDefinitionFromSymbol(typeChecker, t.symbol, node); });
	            }
	            return type.symbol && getDefinitionFromSymbol(typeChecker, type.symbol, node);
	        }
	        GoToDefinition.getTypeDefinitionAtPosition = getTypeDefinitionAtPosition;
	        function getDefinitionAndBoundSpan(program, sourceFile, position) {
	            var definitions = getDefinitionAtPosition(program, sourceFile, position);
	            if (!definitions || definitions.length === 0) {
	                return undefined;
	            }
	            // Check if position is on triple slash reference.
	            var comment = findReferenceInPosition(sourceFile.referencedFiles, position) || findReferenceInPosition(sourceFile.typeReferenceDirectives, position);
	            if (comment) {
	                return { definitions: definitions, textSpan: ts.createTextSpanFromRange(comment) };
	            }
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            var textSpan = ts.createTextSpan(node.getStart(), node.getWidth());
	            return { definitions: definitions, textSpan: textSpan };
	        }
	        GoToDefinition.getDefinitionAndBoundSpan = getDefinitionAndBoundSpan;
	        // At 'x.foo', see if the type of 'x' has an index signature, and if so find its declarations.
	        function getDefinitionInfoForIndexSignatures(node, checker) {
	            if (!ts.isPropertyAccessExpression(node.parent) || node.parent.name !== node)
	                return;
	            var type = checker.getTypeAtLocation(node.parent.expression);
	            return ts.mapDefined(type.isUnionOrIntersection() ? type.types : [type], function (nonUnionType) {
	                var info = checker.getIndexInfoOfType(nonUnionType, 0 /* String */);
	                return info && info.declaration && createDefinitionFromSignatureDeclaration(checker, info.declaration);
	            });
	        }
	        function getSymbol(node, checker) {
	            var symbol = checker.getSymbolAtLocation(node);
	            // If this is an alias, and the request came at the declaration location
	            // get the aliased symbol instead. This allows for goto def on an import e.g.
	            //   import {A, B} from "mod";
	            // to jump to the implementation directly.
	            if (symbol && symbol.flags & 2097152 /* Alias */ && shouldSkipAlias(node, symbol.declarations[0])) {
	                var aliased = checker.getAliasedSymbol(symbol);
	                if (aliased.declarations) {
	                    return aliased;
	                }
	            }
	            return symbol;
	        }
	        // Go to the original declaration for cases:
	        //
	        //   (1) when the aliased symbol was declared in the location(parent).
	        //   (2) when the aliased symbol is originating from an import.
	        //
	        function shouldSkipAlias(node, declaration) {
	            if (node.kind !== 71 /* Identifier */) {
	                return false;
	            }
	            if (node.parent === declaration) {
	                return true;
	            }
	            switch (declaration.kind) {
	                case 244 /* ImportClause */:
	                case 242 /* ImportEqualsDeclaration */:
	                    return true;
	                case 247 /* ImportSpecifier */:
	                    return declaration.parent.kind === 246 /* NamedImports */;
	                default:
	                    return false;
	            }
	        }
	        function getDefinitionFromSymbol(typeChecker, symbol, node) {
	            return getConstructSignatureDefinition() || getCallSignatureDefinition() || ts.map(symbol.declarations, function (declaration) { return createDefinitionInfo(declaration, typeChecker, symbol, node); });
	            function getConstructSignatureDefinition() {
	                // Applicable only if we are in a new expression, or we are on a constructor declaration
	                // and in either case the symbol has a construct signature definition, i.e. class
	                if (symbol.flags & 32 /* Class */ && (ts.isNewExpressionTarget(node) || node.kind === 123 /* ConstructorKeyword */)) {
	                    var cls = ts.find(symbol.declarations, ts.isClassLike) || ts.Debug.fail("Expected declaration to have at least one class-like declaration");
	                    return getSignatureDefinition(cls.members, /*selectConstructors*/ true);
	                }
	            }
	            function getCallSignatureDefinition() {
	                return ts.isCallExpressionTarget(node) || ts.isNewExpressionTarget(node) || ts.isNameOfFunctionDeclaration(node)
	                    ? getSignatureDefinition(symbol.declarations, /*selectConstructors*/ false)
	                    : undefined;
	            }
	            function getSignatureDefinition(signatureDeclarations, selectConstructors) {
	                if (!signatureDeclarations) {
	                    return undefined;
	                }
	                var declarations = signatureDeclarations.filter(selectConstructors ? ts.isConstructorDeclaration : ts.isFunctionLike);
	                return declarations.length
	                    ? [createDefinitionInfo(ts.find(declarations, function (d) { return !!d.body; }) || ts.last(declarations), typeChecker, symbol, node)]
	                    : undefined;
	            }
	        }
	        /** Creates a DefinitionInfo from a Declaration, using the declaration's name if possible. */
	        function createDefinitionInfo(declaration, checker, symbol, node) {
	            var symbolName = checker.symbolToString(symbol); // Do not get scoped name, just the name of the symbol
	            var symbolKind = ts.SymbolDisplay.getSymbolKind(checker, symbol, node);
	            var containerName = symbol.parent ? checker.symbolToString(symbol.parent, node) : "";
	            return createDefinitionInfoFromName(declaration, symbolKind, symbolName, containerName);
	        }
	        /** Creates a DefinitionInfo directly from the name of a declaration. */
	        function createDefinitionInfoFromName(declaration, symbolKind, symbolName, containerName) {
	            var name = ts.getNameOfDeclaration(declaration) || declaration;
	            var sourceFile = name.getSourceFile();
	            return {
	                fileName: sourceFile.fileName,
	                textSpan: ts.createTextSpanFromNode(name, sourceFile),
	                kind: symbolKind,
	                name: symbolName,
	                containerKind: undefined,
	                containerName: containerName
	            };
	        }
	        function createDefinitionFromSignatureDeclaration(typeChecker, decl) {
	            return createDefinitionInfo(decl, typeChecker, decl.symbol, decl);
	        }
	        function findReferenceInPosition(refs, pos) {
	            return ts.find(refs, function (ref) { return ref.pos <= pos && pos <= ref.end; });
	        }
	        GoToDefinition.findReferenceInPosition = findReferenceInPosition;
	        function getDefinitionInfoForFileReference(name, targetFileName) {
	            return {
	                fileName: targetFileName,
	                textSpan: ts.createTextSpanFromBounds(0, 0),
	                kind: "script" /* scriptElement */,
	                name: name,
	                containerName: undefined,
	                containerKind: undefined
	            };
	        }
	        /** Returns a CallLikeExpression where `node` is the target being invoked. */
	        function getAncestorCallLikeExpression(node) {
	            var target = climbPastManyPropertyAccesses(node);
	            var callLike = target.parent;
	            return callLike && ts.isCallLikeExpression(callLike) && ts.getInvokedExpression(callLike) === target && callLike;
	        }
	        function climbPastManyPropertyAccesses(node) {
	            return ts.isRightSideOfPropertyAccess(node) ? climbPastManyPropertyAccesses(node.parent) : node;
	        }
	        function tryGetSignatureDeclaration(typeChecker, node) {
	            var callLike = getAncestorCallLikeExpression(node);
	            var signature = callLike && typeChecker.getResolvedSignature(callLike);
	            // Don't go to a function type, go to the value having that type.
	            return ts.tryCast(signature && signature.declaration, function (d) { return ts.isFunctionLike(d) && !ts.isFunctionTypeNode(d); });
	        }
	    })(GoToDefinition = ts.GoToDefinition || (ts.GoToDefinition = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var JsDoc;
	    (function (JsDoc) {
	        var jsDocTagNames = [
	            "augments",
	            "author",
	            "argument",
	            "borrows",
	            "callback",
	            "class",
	            "constant",
	            "constructor",
	            "constructs",
	            "default",
	            "deprecated",
	            "description",
	            "event",
	            "example",
	            "extends",
	            "field",
	            "fileOverview",
	            "function",
	            "ignore",
	            "inheritDoc",
	            "inner",
	            "lends",
	            "link",
	            "memberOf",
	            "method",
	            "name",
	            "namespace",
	            "param",
	            "private",
	            "prop",
	            "property",
	            "public",
	            "requires",
	            "returns",
	            "see",
	            "since",
	            "static",
	            "template",
	            "throws",
	            "type",
	            "typedef",
	            "version"
	        ];
	        var jsDocTagNameCompletionEntries;
	        var jsDocTagCompletionEntries;
	        function getJsDocCommentsFromDeclarations(declarations) {
	            // Only collect doc comments from duplicate declarations once:
	            // In case of a union property there might be same declaration multiple times
	            // which only varies in type parameter
	            // Eg. const a: Array<string> | Array<number>; a.length
	            // The property length will have two declarations of property length coming
	            // from Array<T> - Array<string> and Array<number>
	            var documentationComment = [];
	            forEachUnique(declarations, function (declaration) {
	                for (var _i = 0, _a = getCommentHavingNodes(declaration); _i < _a.length; _i++) {
	                    var comment = _a[_i].comment;
	                    if (comment === undefined)
	                        continue;
	                    if (documentationComment.length) {
	                        documentationComment.push(ts.lineBreakPart());
	                    }
	                    documentationComment.push(ts.textPart(comment));
	                }
	            });
	            return documentationComment;
	        }
	        JsDoc.getJsDocCommentsFromDeclarations = getJsDocCommentsFromDeclarations;
	        function getCommentHavingNodes(declaration) {
	            switch (declaration.kind) {
	                case 292 /* JSDocParameterTag */:
	                case 297 /* JSDocPropertyTag */:
	                    return [declaration];
	                case 291 /* JSDocCallbackTag */:
	                case 296 /* JSDocTypedefTag */:
	                    return [declaration, declaration.parent];
	                default:
	                    return ts.getJSDocCommentsAndTags(declaration);
	            }
	        }
	        function getJsDocTagsFromDeclarations(declarations) {
	            // Only collect doc comments from duplicate declarations once.
	            var tags = [];
	            forEachUnique(declarations, function (declaration) {
	                for (var _i = 0, _a = ts.getJSDocTags(declaration); _i < _a.length; _i++) {
	                    var tag = _a[_i];
	                    tags.push({ name: tag.tagName.text, text: getCommentText(tag) });
	                }
	            });
	            return tags;
	        }
	        JsDoc.getJsDocTagsFromDeclarations = getJsDocTagsFromDeclarations;
	        function getCommentText(tag) {
	            var comment = tag.comment;
	            switch (tag.kind) {
	                case 289 /* JSDocAugmentsTag */:
	                    return withNode(tag.class);
	                case 295 /* JSDocTemplateTag */:
	                    return withList(tag.typeParameters);
	                case 294 /* JSDocTypeTag */:
	                    return withNode(tag.typeExpression);
	                case 296 /* JSDocTypedefTag */:
	                case 291 /* JSDocCallbackTag */:
	                case 297 /* JSDocPropertyTag */:
	                case 292 /* JSDocParameterTag */:
	                    var name = tag.name;
	                    return name ? withNode(name) : comment;
	                default:
	                    return comment;
	            }
	            function withNode(node) {
	                return addComment(node.getText());
	            }
	            function withList(list) {
	                return addComment(list.map(function (x) { return x.getText(); }).join(", "));
	            }
	            function addComment(s) {
	                return comment === undefined ? s : s + " " + comment;
	            }
	        }
	        /**
	         * Iterates through 'array' by index and performs the callback on each element of array until the callback
	         * returns a truthy value, then returns that value.
	         * If no such value is found, the callback is applied to each element of array and undefined is returned.
	         */
	        function forEachUnique(array, callback) {
	            if (array) {
	                for (var i = 0; i < array.length; i++) {
	                    if (array.indexOf(array[i]) === i) {
	                        var result = callback(array[i], i);
	                        if (result) {
	                            return result;
	                        }
	                    }
	                }
	            }
	            return undefined;
	        }
	        function getJSDocTagNameCompletions() {
	            return jsDocTagNameCompletionEntries || (jsDocTagNameCompletionEntries = ts.map(jsDocTagNames, function (tagName) {
	                return {
	                    name: tagName,
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "",
	                    sortText: "0",
	                };
	            }));
	        }
	        JsDoc.getJSDocTagNameCompletions = getJSDocTagNameCompletions;
	        JsDoc.getJSDocTagNameCompletionDetails = getJSDocTagCompletionDetails;
	        function getJSDocTagCompletions() {
	            return jsDocTagCompletionEntries || (jsDocTagCompletionEntries = ts.map(jsDocTagNames, function (tagName) {
	                return {
	                    name: "@" + tagName,
	                    kind: "keyword" /* keyword */,
	                    kindModifiers: "",
	                    sortText: "0"
	                };
	            }));
	        }
	        JsDoc.getJSDocTagCompletions = getJSDocTagCompletions;
	        function getJSDocTagCompletionDetails(name) {
	            return {
	                name: name,
	                kind: "" /* unknown */,
	                kindModifiers: "",
	                displayParts: [ts.textPart(name)],
	                documentation: ts.emptyArray,
	                tags: ts.emptyArray,
	                codeActions: undefined,
	            };
	        }
	        JsDoc.getJSDocTagCompletionDetails = getJSDocTagCompletionDetails;
	        function getJSDocParameterNameCompletions(tag) {
	            if (!ts.isIdentifier(tag.name)) {
	                return ts.emptyArray;
	            }
	            var nameThusFar = tag.name.text;
	            var jsdoc = tag.parent;
	            var fn = jsdoc.parent;
	            if (!ts.isFunctionLike(fn))
	                return [];
	            return ts.mapDefined(fn.parameters, function (param) {
	                if (!ts.isIdentifier(param.name))
	                    return undefined;
	                var name = param.name.text;
	                if (jsdoc.tags.some(function (t) { return t !== tag && ts.isJSDocParameterTag(t) && ts.isIdentifier(t.name) && t.name.escapedText === name; })
	                    || nameThusFar !== undefined && !ts.startsWith(name, nameThusFar)) {
	                    return undefined;
	                }
	                return { name: name, kind: "parameter" /* parameterElement */, kindModifiers: "", sortText: "0" };
	            });
	        }
	        JsDoc.getJSDocParameterNameCompletions = getJSDocParameterNameCompletions;
	        function getJSDocParameterNameCompletionDetails(name) {
	            return {
	                name: name,
	                kind: "parameter" /* parameterElement */,
	                kindModifiers: "",
	                displayParts: [ts.textPart(name)],
	                documentation: ts.emptyArray,
	                tags: ts.emptyArray,
	                codeActions: undefined,
	            };
	        }
	        JsDoc.getJSDocParameterNameCompletionDetails = getJSDocParameterNameCompletionDetails;
	        /**
	         * Checks if position points to a valid position to add JSDoc comments, and if so,
	         * returns the appropriate template. Otherwise returns an empty string.
	         * Valid positions are
	         *      - outside of comments, statements, and expressions, and
	         *      - preceding a:
	         *          - function/constructor/method declaration
	         *          - class declarations
	         *          - variable statements
	         *          - namespace declarations
	         *          - interface declarations
	         *          - method signatures
	         *          - type alias declarations
	         *
	         * Hosts should ideally check that:
	         * - The line is all whitespace up to 'position' before performing the insertion.
	         * - If the keystroke sequence "/\*\*" induced the call, we also check that the next
	         * non-whitespace character is '*', which (approximately) indicates whether we added
	         * the second '*' to complete an existing (JSDoc) comment.
	         * @param fileName The file in which to perform the check.
	         * @param position The (character-indexed) position in the file where the check should
	         * be performed.
	         */
	        function getDocCommentTemplateAtPosition(newLine, sourceFile, position) {
	            // Check if in a context where we don't want to perform any insertion
	            if (ts.isInString(sourceFile, position) || ts.isInComment(sourceFile, position) || ts.hasDocComment(sourceFile, position)) {
	                return undefined;
	            }
	            var tokenAtPos = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	            var tokenStart = tokenAtPos.getStart();
	            if (!tokenAtPos || tokenStart < position) {
	                return undefined;
	            }
	            var commentOwnerInfo = getCommentOwnerInfo(tokenAtPos);
	            if (!commentOwnerInfo) {
	                return undefined;
	            }
	            var commentOwner = commentOwnerInfo.commentOwner, parameters = commentOwnerInfo.parameters;
	            if (commentOwner.getStart() < position) {
	                return undefined;
	            }
	            if (!parameters || parameters.length === 0) {
	                // if there are no parameters, just complete to a single line JSDoc comment
	                var singleLineResult = "/** */";
	                return { newText: singleLineResult, caretOffset: 3 };
	            }
	            var posLineAndChar = sourceFile.getLineAndCharacterOfPosition(position);
	            var lineStart = sourceFile.getLineStarts()[posLineAndChar.line];
	            // replace non-whitespace characters in prefix with spaces.
	            var indentationStr = sourceFile.text.substr(lineStart, posLineAndChar.character).replace(/\S/i, function () { return " "; });
	            var isJavaScriptFile = ts.hasJavaScriptFileExtension(sourceFile.fileName);
	            var docParams = "";
	            for (var i = 0; i < parameters.length; i++) {
	                var currentName = parameters[i].name;
	                var paramName = currentName.kind === 71 /* Identifier */ ? currentName.escapedText : "param" + i;
	                if (isJavaScriptFile) {
	                    docParams += indentationStr + " * @param {any} " + paramName + newLine;
	                }
	                else {
	                    docParams += indentationStr + " * @param " + paramName + newLine;
	                }
	            }
	            // A doc comment consists of the following
	            // * The opening comment line
	            // * the first line (without a param) for the object's untagged info (this is also where the caret ends up)
	            // * the '@param'-tagged lines
	            // * TODO: other tags.
	            // * the closing comment line
	            // * if the caret was directly in front of the object, then we add an extra line and indentation.
	            var preamble = "/**" + newLine +
	                indentationStr + " * ";
	            var result = preamble + newLine +
	                docParams +
	                indentationStr + " */" +
	                (tokenStart === position ? newLine + indentationStr : "");
	            return { newText: result, caretOffset: preamble.length };
	        }
	        JsDoc.getDocCommentTemplateAtPosition = getDocCommentTemplateAtPosition;
	        function getCommentOwnerInfo(tokenAtPos) {
	            for (var commentOwner = tokenAtPos; commentOwner; commentOwner = commentOwner.parent) {
	                switch (commentOwner.kind) {
	                    case 233 /* FunctionDeclaration */:
	                    case 153 /* MethodDeclaration */:
	                    case 154 /* Constructor */:
	                    case 152 /* MethodSignature */:
	                        var parameters = commentOwner.parameters;
	                        return { commentOwner: commentOwner, parameters: parameters };
	                    case 234 /* ClassDeclaration */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 150 /* PropertySignature */:
	                    case 237 /* EnumDeclaration */:
	                    case 272 /* EnumMember */:
	                    case 236 /* TypeAliasDeclaration */:
	                        return { commentOwner: commentOwner };
	                    case 213 /* VariableStatement */: {
	                        var varStatement = commentOwner;
	                        var varDeclarations = varStatement.declarationList.declarations;
	                        var parameters_1 = varDeclarations.length === 1 && varDeclarations[0].initializer
	                            ? getParametersFromRightHandSideOfAssignment(varDeclarations[0].initializer)
	                            : undefined;
	                        return { commentOwner: commentOwner, parameters: parameters_1 };
	                    }
	                    case 273 /* SourceFile */:
	                        return undefined;
	                    case 238 /* ModuleDeclaration */:
	                        // If in walking up the tree, we hit a a nested namespace declaration,
	                        // then we must be somewhere within a dotted namespace name; however we don't
	                        // want to give back a JSDoc template for the 'b' or 'c' in 'namespace a.b.c { }'.
	                        return commentOwner.parent.kind === 238 /* ModuleDeclaration */ ? undefined : { commentOwner: commentOwner };
	                    case 199 /* BinaryExpression */: {
	                        var be = commentOwner;
	                        if (ts.getSpecialPropertyAssignmentKind(be) === 0 /* None */) {
	                            return undefined;
	                        }
	                        var parameters_2 = ts.isFunctionLike(be.right) ? be.right.parameters : ts.emptyArray;
	                        return { commentOwner: commentOwner, parameters: parameters_2 };
	                    }
	                }
	            }
	        }
	        /**
	         * Digs into an an initializer or RHS operand of an assignment operation
	         * to get the parameters of an apt signature corresponding to a
	         * function expression or a class expression.
	         *
	         * @param rightHandSide the expression which may contain an appropriate set of parameters
	         * @returns the parameters of a signature found on the RHS if one exists; otherwise 'emptyArray'.
	         */
	        function getParametersFromRightHandSideOfAssignment(rightHandSide) {
	            while (rightHandSide.kind === 190 /* ParenthesizedExpression */) {
	                rightHandSide = rightHandSide.expression;
	            }
	            switch (rightHandSide.kind) {
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                    return rightHandSide.parameters;
	                case 204 /* ClassExpression */: {
	                    var ctr = ts.find(rightHandSide.members, ts.isConstructorDeclaration);
	                    return ctr && ctr.parameters;
	                }
	            }
	            return ts.emptyArray;
	        }
	    })(JsDoc = ts.JsDoc || (ts.JsDoc = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function stringToInt(str) {
	        var n = parseInt(str, 10);
	        if (isNaN(n)) {
	            throw new Error("Error in parseInt(" + JSON.stringify(str) + ")");
	        }
	        return n;
	    }
	    var isPrereleaseRegex = /^(.*)-next.\d+/;
	    var prereleaseSemverRegex = /^(\d+)\.(\d+)\.0-next.(\d+)$/;
	    var semverRegex = /^(\d+)\.(\d+)\.(\d+)$/;
	    var Semver = /** @class */ (function () {
	        function Semver(major, minor, patch, 
	        /**
	         * If true, this is `major.minor.0-next.patch`.
	         * If false, this is `major.minor.patch`.
	         */
	        isPrerelease) {
	            this.major = major;
	            this.minor = minor;
	            this.patch = patch;
	            this.isPrerelease = isPrerelease;
	        }
	        Semver.parse = function (semver) {
	            var isPrerelease = isPrereleaseRegex.test(semver);
	            var result = Semver.tryParse(semver, isPrerelease);
	            if (!result) {
	                throw new Error("Unexpected semver: " + semver + " (isPrerelease: " + isPrerelease + ")");
	            }
	            return result;
	        };
	        Semver.fromRaw = function (_a) {
	            var major = _a.major, minor = _a.minor, patch = _a.patch, isPrerelease = _a.isPrerelease;
	            return new Semver(major, minor, patch, isPrerelease);
	        };
	        // This must parse the output of `versionString`.
	        Semver.tryParse = function (semver, isPrerelease) {
	            // Per the semver spec <http://semver.org/#spec-item-2>:
	            // "A normal version number MUST take the form X.Y.Z where X, Y, and Z are non-negative integers, and MUST NOT contain leading zeroes."
	            var rgx = isPrerelease ? prereleaseSemverRegex : semverRegex;
	            var match = rgx.exec(semver);
	            return match ? new Semver(stringToInt(match[1]), stringToInt(match[2]), stringToInt(match[3]), isPrerelease) : undefined;
	        };
	        Object.defineProperty(Semver.prototype, "versionString", {
	            get: function () {
	                return this.isPrerelease ? this.major + "." + this.minor + ".0-next." + this.patch : this.major + "." + this.minor + "." + this.patch;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Semver.prototype.equals = function (sem) {
	            return this.major === sem.major && this.minor === sem.minor && this.patch === sem.patch && this.isPrerelease === sem.isPrerelease;
	        };
	        Semver.prototype.greaterThan = function (sem) {
	            return this.major > sem.major || this.major === sem.major
	                && (this.minor > sem.minor || this.minor === sem.minor
	                    && (!this.isPrerelease && sem.isPrerelease || this.isPrerelease === sem.isPrerelease
	                        && this.patch > sem.patch));
	        };
	        return Semver;
	    }());
	    ts.Semver = Semver;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var JsTyping;
	    (function (JsTyping) {
	        /* @internal */
	        function isTypingUpToDate(cachedTyping, availableTypingVersions) {
	            var availableVersion = ts.Semver.parse(ts.getProperty(availableTypingVersions, "ts" + ts.versionMajorMinor) || ts.getProperty(availableTypingVersions, "latest"));
	            return !availableVersion.greaterThan(cachedTyping.version);
	        }
	        JsTyping.isTypingUpToDate = isTypingUpToDate;
	        /* @internal */
	        JsTyping.nodeCoreModuleList = [
	            "assert",
	            "async_hooks",
	            "buffer",
	            "child_process",
	            "cluster",
	            "console",
	            "constants",
	            "crypto",
	            "dgram",
	            "dns",
	            "domain",
	            "events",
	            "fs",
	            "http",
	            "https",
	            "http2",
	            "inspector",
	            "net",
	            "os",
	            "path",
	            "perf_hooks",
	            "process",
	            "punycode",
	            "querystring",
	            "readline",
	            "repl",
	            "stream",
	            "string_decoder",
	            "timers",
	            "tls",
	            "tty",
	            "url",
	            "util",
	            "v8",
	            "vm",
	            "zlib"
	        ];
	        /* @internal */
	        JsTyping.nodeCoreModules = ts.arrayToSet(JsTyping.nodeCoreModuleList);
	        function loadSafeList(host, safeListPath) {
	            var result = ts.readConfigFile(safeListPath, function (path) { return host.readFile(path); });
	            return ts.createMapFromTemplate(result.config);
	        }
	        JsTyping.loadSafeList = loadSafeList;
	        function loadTypesMap(host, typesMapPath) {
	            var result = ts.readConfigFile(typesMapPath, function (path) { return host.readFile(path); });
	            if (result.config) {
	                return ts.createMapFromTemplate(result.config.simpleMap);
	            }
	            return undefined;
	        }
	        JsTyping.loadTypesMap = loadTypesMap;
	        /**
	         * @param host is the object providing I/O related operations.
	         * @param fileNames are the file names that belong to the same project
	         * @param projectRootPath is the path to the project root directory
	         * @param safeListPath is the path used to retrieve the safe list
	         * @param packageNameToTypingLocation is the map of package names to their cached typing locations and installed versions
	         * @param typeAcquisition is used to customize the typing acquisition process
	         * @param compilerOptions are used as a source for typing inference
	         */
	        function discoverTypings(host, log, fileNames, projectRootPath, safeList, packageNameToTypingLocation, typeAcquisition, unresolvedImports, typesRegistry) {
	            if (!typeAcquisition || !typeAcquisition.enable) {
	                return { cachedTypingPaths: [], newTypingNames: [], filesToWatch: [] };
	            }
	            // A typing name to typing file path mapping
	            var inferredTypings = ts.createMap();
	            // Only infer typings for .js and .jsx files
	            fileNames = ts.mapDefined(fileNames, function (fileName) {
	                var path = ts.normalizePath(fileName);
	                if (ts.hasJavaScriptFileExtension(path)) {
	                    return path;
	                }
	            });
	            var filesToWatch = [];
	            if (typeAcquisition.include)
	                addInferredTypings(typeAcquisition.include, "Explicitly included types");
	            var exclude = typeAcquisition.exclude || [];
	            // Directories to search for package.json, bower.json and other typing information
	            var possibleSearchDirs = ts.arrayToSet(fileNames, ts.getDirectoryPath);
	            possibleSearchDirs.set(projectRootPath, true);
	            possibleSearchDirs.forEach(function (_true, searchDir) {
	                var packageJsonPath = ts.combinePaths(searchDir, "package.json");
	                getTypingNamesFromJson(packageJsonPath, filesToWatch);
	                var bowerJsonPath = ts.combinePaths(searchDir, "bower.json");
	                getTypingNamesFromJson(bowerJsonPath, filesToWatch);
	                var bowerComponentsPath = ts.combinePaths(searchDir, "bower_components");
	                getTypingNamesFromPackagesFolder(bowerComponentsPath, filesToWatch);
	                var nodeModulesPath = ts.combinePaths(searchDir, "node_modules");
	                getTypingNamesFromPackagesFolder(nodeModulesPath, filesToWatch);
	            });
	            getTypingNamesFromSourceFileNames(fileNames);
	            // add typings for unresolved imports
	            if (unresolvedImports) {
	                var module_1 = ts.deduplicate(unresolvedImports.map(function (moduleId) { return JsTyping.nodeCoreModules.has(moduleId) ? "node" : moduleId; }), ts.equateStringsCaseSensitive, ts.compareStringsCaseSensitive);
	                addInferredTypings(module_1, "Inferred typings from unresolved imports");
	            }
	            // Add the cached typing locations for inferred typings that are already installed
	            packageNameToTypingLocation.forEach(function (typing, name) {
	                var registryEntry = typesRegistry.get(name);
	                if (inferredTypings.has(name) && inferredTypings.get(name) === undefined && registryEntry !== undefined && isTypingUpToDate(typing, registryEntry)) {
	                    inferredTypings.set(name, typing.typingLocation);
	                }
	            });
	            // Remove typings that the user has added to the exclude list
	            for (var _i = 0, exclude_1 = exclude; _i < exclude_1.length; _i++) {
	                var excludeTypingName = exclude_1[_i];
	                var didDelete = inferredTypings.delete(excludeTypingName);
	                if (didDelete && log)
	                    log("Typing for " + excludeTypingName + " is in exclude list, will be ignored.");
	            }
	            var newTypingNames = [];
	            var cachedTypingPaths = [];
	            inferredTypings.forEach(function (inferred, typing) {
	                if (inferred !== undefined) {
	                    cachedTypingPaths.push(inferred);
	                }
	                else {
	                    newTypingNames.push(typing);
	                }
	            });
	            var result = { cachedTypingPaths: cachedTypingPaths, newTypingNames: newTypingNames, filesToWatch: filesToWatch };
	            if (log)
	                log("Result: " + JSON.stringify(result));
	            return result;
	            function addInferredTyping(typingName) {
	                if (!inferredTypings.has(typingName)) {
	                    inferredTypings.set(typingName, undefined);
	                }
	            }
	            function addInferredTypings(typingNames, message) {
	                if (log)
	                    log(message + ": " + JSON.stringify(typingNames));
	                ts.forEach(typingNames, addInferredTyping);
	            }
	            /**
	             * Get the typing info from common package manager json files like package.json or bower.json
	             */
	            function getTypingNamesFromJson(jsonPath, filesToWatch) {
	                if (!host.fileExists(jsonPath)) {
	                    return;
	                }
	                filesToWatch.push(jsonPath);
	                var jsonConfig = ts.readConfigFile(jsonPath, function (path) { return host.readFile(path); }).config;
	                var jsonTypingNames = ts.flatMap([jsonConfig.dependencies, jsonConfig.devDependencies, jsonConfig.optionalDependencies, jsonConfig.peerDependencies], ts.getOwnKeys);
	                addInferredTypings(jsonTypingNames, "Typing names in '" + jsonPath + "' dependencies");
	            }
	            /**
	             * Infer typing names from given file names. For example, the file name "jquery-min.2.3.4.js"
	             * should be inferred to the 'jquery' typing name; and "angular-route.1.2.3.js" should be inferred
	             * to the 'angular-route' typing name.
	             * @param fileNames are the names for source files in the project
	             */
	            function getTypingNamesFromSourceFileNames(fileNames) {
	                var fromFileNames = ts.mapDefined(fileNames, function (j) {
	                    if (!ts.hasJavaScriptFileExtension(j))
	                        return undefined;
	                    var inferredTypingName = ts.removeFileExtension(ts.getBaseFileName(j.toLowerCase()));
	                    var cleanedTypingName = ts.removeMinAndVersionNumbers(inferredTypingName);
	                    return safeList.get(cleanedTypingName);
	                });
	                if (fromFileNames.length) {
	                    addInferredTypings(fromFileNames, "Inferred typings from file names");
	                }
	                var hasJsxFile = ts.some(fileNames, function (f) { return ts.fileExtensionIs(f, ".jsx" /* Jsx */); });
	                if (hasJsxFile) {
	                    if (log)
	                        log("Inferred 'react' typings due to presence of '.jsx' extension");
	                    addInferredTyping("react");
	                }
	            }
	            /**
	             * Infer typing names from packages folder (ex: node_module, bower_components)
	             * @param packagesFolderPath is the path to the packages folder
	             */
	            function getTypingNamesFromPackagesFolder(packagesFolderPath, filesToWatch) {
	                filesToWatch.push(packagesFolderPath);
	                // Todo: add support for ModuleResolutionHost too
	                if (!host.directoryExists(packagesFolderPath)) {
	                    return;
	                }
	                // depth of 2, so we access `node_modules/foo` but not `node_modules/foo/bar`
	                var fileNames = host.readDirectory(packagesFolderPath, [".json" /* Json */], /*excludes*/ undefined, /*includes*/ undefined, /*depth*/ 2);
	                if (log)
	                    log("Searching for typing names in " + packagesFolderPath + "; all files: " + JSON.stringify(fileNames));
	                var packageNames = [];
	                for (var _i = 0, fileNames_1 = fileNames; _i < fileNames_1.length; _i++) {
	                    var fileName = fileNames_1[_i];
	                    var normalizedFileName = ts.normalizePath(fileName);
	                    var baseFileName = ts.getBaseFileName(normalizedFileName);
	                    if (baseFileName !== "package.json" && baseFileName !== "bower.json") {
	                        continue;
	                    }
	                    var result_6 = ts.readConfigFile(normalizedFileName, function (path) { return host.readFile(path); });
	                    var packageJson = result_6.config;
	                    // npm 3's package.json contains a "_requiredBy" field
	                    // we should include all the top level module names for npm 2, and only module names whose
	                    // "_requiredBy" field starts with "#" or equals "/" for npm 3.
	                    if (baseFileName === "package.json" && packageJson._requiredBy &&
	                        ts.filter(packageJson._requiredBy, function (r) { return r[0] === "#" || r === "/"; }).length === 0) {
	                        continue;
	                    }
	                    // If the package has its own d.ts typings, those will take precedence. Otherwise the package name will be used
	                    // to download d.ts files from DefinitelyTyped
	                    if (!packageJson.name) {
	                        continue;
	                    }
	                    var ownTypes = packageJson.types || packageJson.typings;
	                    if (ownTypes) {
	                        var absolutePath = ts.getNormalizedAbsolutePath(ownTypes, ts.getDirectoryPath(normalizedFileName));
	                        if (log)
	                            log("    Package '" + packageJson.name + "' provides its own types.");
	                        inferredTypings.set(packageJson.name, absolutePath);
	                    }
	                    else {
	                        packageNames.push(packageJson.name);
	                    }
	                }
	                addInferredTypings(packageNames, "    Found package names");
	            }
	        }
	        JsTyping.discoverTypings = discoverTypings;
	        var PackageNameValidationResult;
	        (function (PackageNameValidationResult) {
	            PackageNameValidationResult[PackageNameValidationResult["Ok"] = 0] = "Ok";
	            PackageNameValidationResult[PackageNameValidationResult["ScopedPackagesNotSupported"] = 1] = "ScopedPackagesNotSupported";
	            PackageNameValidationResult[PackageNameValidationResult["EmptyName"] = 2] = "EmptyName";
	            PackageNameValidationResult[PackageNameValidationResult["NameTooLong"] = 3] = "NameTooLong";
	            PackageNameValidationResult[PackageNameValidationResult["NameStartsWithDot"] = 4] = "NameStartsWithDot";
	            PackageNameValidationResult[PackageNameValidationResult["NameStartsWithUnderscore"] = 5] = "NameStartsWithUnderscore";
	            PackageNameValidationResult[PackageNameValidationResult["NameContainsNonURISafeCharacters"] = 6] = "NameContainsNonURISafeCharacters";
	        })(PackageNameValidationResult = JsTyping.PackageNameValidationResult || (JsTyping.PackageNameValidationResult = {}));
	        var maxPackageNameLength = 214;
	        /**
	         * Validates package name using rules defined at https://docs.npmjs.com/files/package.json
	         */
	        function validatePackageName(packageName) {
	            if (!packageName) {
	                return 2 /* EmptyName */;
	            }
	            if (packageName.length > maxPackageNameLength) {
	                return 3 /* NameTooLong */;
	            }
	            if (packageName.charCodeAt(0) === 46 /* dot */) {
	                return 4 /* NameStartsWithDot */;
	            }
	            if (packageName.charCodeAt(0) === 95 /* _ */) {
	                return 5 /* NameStartsWithUnderscore */;
	            }
	            // check if name is scope package like: starts with @ and has one '/' in the middle
	            // scoped packages are not currently supported
	            // TODO: when support will be added we'll need to split and check both scope and package name
	            if (/^@[^/]+\/[^/]+$/.test(packageName)) {
	                return 1 /* ScopedPackagesNotSupported */;
	            }
	            if (encodeURIComponent(packageName) !== packageName) {
	                return 6 /* NameContainsNonURISafeCharacters */;
	            }
	            return 0 /* Ok */;
	        }
	        JsTyping.validatePackageName = validatePackageName;
	        function renderPackageNameValidationFailure(result, typing) {
	            switch (result) {
	                case 2 /* EmptyName */:
	                    return "Package name '" + typing + "' cannot be empty";
	                case 3 /* NameTooLong */:
	                    return "Package name '" + typing + "' should be less than " + maxPackageNameLength + " characters";
	                case 4 /* NameStartsWithDot */:
	                    return "Package name '" + typing + "' cannot start with '.'";
	                case 5 /* NameStartsWithUnderscore */:
	                    return "Package name '" + typing + "' cannot start with '_'";
	                case 1 /* ScopedPackagesNotSupported */:
	                    return "Package '" + typing + "' is scoped and currently is not supported";
	                case 6 /* NameContainsNonURISafeCharacters */:
	                    return "Package name '" + typing + "' contains non URI safe characters";
	                case 0 /* Ok */:
	                    return ts.Debug.fail(); // Shouldn't have called this.
	                default:
	                    ts.Debug.assertNever(result);
	            }
	        }
	        JsTyping.renderPackageNameValidationFailure = renderPackageNameValidationFailure;
	    })(JsTyping = ts.JsTyping || (ts.JsTyping = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var NavigateTo;
	    (function (NavigateTo) {
	        function getNavigateToItems(sourceFiles, checker, cancellationToken, searchValue, maxResultCount, excludeDtsFiles) {
	            var patternMatcher = ts.createPatternMatcher(searchValue);
	            if (!patternMatcher)
	                return ts.emptyArray;
	            var rawItems = [];
	            var _loop_15 = function (sourceFile) {
	                cancellationToken.throwIfCancellationRequested();
	                if (excludeDtsFiles && ts.fileExtensionIs(sourceFile.fileName, ".d.ts" /* Dts */)) {
	                    return "continue";
	                }
	                sourceFile.getNamedDeclarations().forEach(function (declarations, name) {
	                    getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, sourceFile.fileName, rawItems);
	                });
	            };
	            // Search the declarations in all files and output matched NavigateToItem into array of NavigateToItem[]
	            for (var _i = 0, sourceFiles_7 = sourceFiles; _i < sourceFiles_7.length; _i++) {
	                var sourceFile = sourceFiles_7[_i];
	                _loop_15(sourceFile);
	            }
	            rawItems.sort(compareNavigateToItems);
	            if (maxResultCount !== undefined) {
	                rawItems = rawItems.slice(0, maxResultCount);
	            }
	            return rawItems.map(createNavigateToItem);
	        }
	        NavigateTo.getNavigateToItems = getNavigateToItems;
	        function getItemsFromNamedDeclaration(patternMatcher, name, declarations, checker, fileName, rawItems) {
	            // First do a quick check to see if the name of the declaration matches the
	            // last portion of the (possibly) dotted name they're searching for.
	            var match = patternMatcher.getMatchForLastSegmentOfPattern(name);
	            if (!match) {
	                return; // continue to next named declarations
	            }
	            for (var _i = 0, declarations_12 = declarations; _i < declarations_12.length; _i++) {
	                var declaration = declarations_12[_i];
	                if (!shouldKeepItem(declaration, checker))
	                    continue;
	                if (patternMatcher.patternContainsDots) {
	                    var fullMatch = patternMatcher.getFullMatch(getContainers(declaration), name);
	                    if (fullMatch) {
	                        rawItems.push({ name: name, fileName: fileName, matchKind: fullMatch.kind, isCaseSensitive: fullMatch.isCaseSensitive, declaration: declaration });
	                    }
	                }
	                else {
	                    // If the pattern has dots in it, then also see if the declaration container matches as well.
	                    rawItems.push({ name: name, fileName: fileName, matchKind: match.kind, isCaseSensitive: match.isCaseSensitive, declaration: declaration });
	                }
	            }
	        }
	        function shouldKeepItem(declaration, checker) {
	            switch (declaration.kind) {
	                case 244 /* ImportClause */:
	                case 247 /* ImportSpecifier */:
	                case 242 /* ImportEqualsDeclaration */:
	                    var importer = checker.getSymbolAtLocation(declaration.name);
	                    var imported = checker.getAliasedSymbol(importer);
	                    return importer.escapedName !== imported.escapedName;
	                default:
	                    return true;
	            }
	        }
	        function tryAddSingleDeclarationName(declaration, containers) {
	            var name = ts.getNameOfDeclaration(declaration);
	            if (name && ts.isPropertyNameLiteral(name)) {
	                containers.unshift(ts.getTextOfIdentifierOrLiteral(name));
	                return true;
	            }
	            else if (name && name.kind === 146 /* ComputedPropertyName */) {
	                return tryAddComputedPropertyName(name.expression, containers, /*includeLastPortion*/ true);
	            }
	            else {
	                // Don't know how to add this.
	                return false;
	            }
	        }
	        // Only added the names of computed properties if they're simple dotted expressions, like:
	        //
	        //      [X.Y.Z]() { }
	        function tryAddComputedPropertyName(expression, containers, includeLastPortion) {
	            if (ts.isPropertyNameLiteral(expression)) {
	                var text = ts.getTextOfIdentifierOrLiteral(expression);
	                if (includeLastPortion) {
	                    containers.unshift(text);
	                }
	                return true;
	            }
	            if (ts.isPropertyAccessExpression(expression)) {
	                if (includeLastPortion) {
	                    containers.unshift(expression.name.text);
	                }
	                return tryAddComputedPropertyName(expression.expression, containers, /*includeLastPortion*/ true);
	            }
	            return false;
	        }
	        function getContainers(declaration) {
	            var containers = [];
	            // First, if we started with a computed property name, then add all but the last
	            // portion into the container array.
	            var name = ts.getNameOfDeclaration(declaration);
	            if (name.kind === 146 /* ComputedPropertyName */ && !tryAddComputedPropertyName(name.expression, containers, /*includeLastPortion*/ false)) {
	                return undefined;
	            }
	            // Now, walk up our containers, adding all their names to the container array.
	            declaration = ts.getContainerNode(declaration);
	            while (declaration) {
	                if (!tryAddSingleDeclarationName(declaration, containers)) {
	                    return undefined;
	                }
	                declaration = ts.getContainerNode(declaration);
	            }
	            return containers;
	        }
	        function compareNavigateToItems(i1, i2) {
	            // TODO(cyrusn): get the gamut of comparisons that VS already uses here.
	            return ts.compareValues(i1.matchKind, i2.matchKind)
	                || ts.compareStringsCaseSensitiveUI(i1.name, i2.name);
	        }
	        function createNavigateToItem(rawItem) {
	            var declaration = rawItem.declaration;
	            var container = ts.getContainerNode(declaration);
	            var containerName = container && ts.getNameOfDeclaration(container);
	            return {
	                name: rawItem.name,
	                kind: ts.getNodeKind(declaration),
	                kindModifiers: ts.getNodeModifiers(declaration),
	                matchKind: ts.PatternMatchKind[rawItem.matchKind],
	                isCaseSensitive: rawItem.isCaseSensitive,
	                fileName: rawItem.fileName,
	                textSpan: ts.createTextSpanFromNode(declaration),
	                // TODO(jfreeman): What should be the containerName when the container has a computed name?
	                containerName: containerName ? containerName.text : "",
	                containerKind: containerName ? ts.getNodeKind(container) : "" /* unknown */
	            };
	        }
	    })(NavigateTo = ts.NavigateTo || (ts.NavigateTo = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var NavigationBar;
	    (function (NavigationBar) {
	        /**
	         * Matches all whitespace characters in a string. Eg:
	         *
	         * "app.
	         *
	         * onactivated"
	         *
	         * matches because of the newline, whereas
	         *
	         * "app.onactivated"
	         *
	         * does not match.
	         */
	        var whiteSpaceRegex = /\s+/g;
	        // Keep sourceFile handy so we don't have to search for it every time we need to call `getText`.
	        var curCancellationToken;
	        var curSourceFile;
	        /**
	         * For performance, we keep navigation bar parents on a stack rather than passing them through each recursion.
	         * `parent` is the current parent and is *not* stored in parentsStack.
	         * `startNode` sets a new parent and `endNode` returns to the previous parent.
	         */
	        var parentsStack = [];
	        var parent;
	        // NavigationBarItem requires an array, but will not mutate it, so just give it this for performance.
	        var emptyChildItemArray = [];
	        function getNavigationBarItems(sourceFile, cancellationToken) {
	            curCancellationToken = cancellationToken;
	            curSourceFile = sourceFile;
	            try {
	                return ts.map(topLevelItems(rootNavigationBarNode(sourceFile)), convertToTopLevelItem);
	            }
	            finally {
	                reset();
	            }
	        }
	        NavigationBar.getNavigationBarItems = getNavigationBarItems;
	        function getNavigationTree(sourceFile, cancellationToken) {
	            curCancellationToken = cancellationToken;
	            curSourceFile = sourceFile;
	            try {
	                return convertToTree(rootNavigationBarNode(sourceFile));
	            }
	            finally {
	                reset();
	            }
	        }
	        NavigationBar.getNavigationTree = getNavigationTree;
	        function reset() {
	            curSourceFile = undefined;
	            curCancellationToken = undefined;
	            parentsStack = [];
	            parent = undefined;
	            emptyChildItemArray = [];
	        }
	        function nodeText(node) {
	            return node.getText(curSourceFile);
	        }
	        function navigationBarNodeKind(n) {
	            return n.node.kind;
	        }
	        function pushChild(parent, child) {
	            if (parent.children) {
	                parent.children.push(child);
	            }
	            else {
	                parent.children = [child];
	            }
	        }
	        function rootNavigationBarNode(sourceFile) {
	            ts.Debug.assert(!parentsStack.length);
	            var root = { node: sourceFile, additionalNodes: undefined, parent: undefined, children: undefined, indent: 0 };
	            parent = root;
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                addChildrenRecursively(statement);
	            }
	            endNode();
	            ts.Debug.assert(!parent && !parentsStack.length);
	            return root;
	        }
	        function addLeafNode(node) {
	            pushChild(parent, emptyNavigationBarNode(node));
	        }
	        function emptyNavigationBarNode(node) {
	            return {
	                node: node,
	                additionalNodes: undefined,
	                parent: parent,
	                children: undefined,
	                indent: parent.indent + 1
	            };
	        }
	        /**
	         * Add a new level of NavigationBarNodes.
	         * This pushes to the stack, so you must call `endNode` when you are done adding to this node.
	         */
	        function startNode(node) {
	            var navNode = emptyNavigationBarNode(node);
	            pushChild(parent, navNode);
	            // Save the old parent
	            parentsStack.push(parent);
	            parent = navNode;
	        }
	        /** Call after calling `startNode` and adding children to it. */
	        function endNode() {
	            if (parent.children) {
	                mergeChildren(parent.children);
	                sortChildren(parent.children);
	            }
	            parent = parentsStack.pop();
	        }
	        function addNodeWithRecursiveChild(node, child) {
	            startNode(node);
	            addChildrenRecursively(child);
	            endNode();
	        }
	        /** Look for navigation bar items in node's subtree, adding them to the current `parent`. */
	        function addChildrenRecursively(node) {
	            curCancellationToken.throwIfCancellationRequested();
	            if (!node || ts.isToken(node)) {
	                return;
	            }
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                    // Get parameter properties, and treat them as being on the *same* level as the constructor, not under it.
	                    var ctr = node;
	                    addNodeWithRecursiveChild(ctr, ctr.body);
	                    // Parameter properties are children of the class, not the constructor.
	                    for (var _i = 0, _a = ctr.parameters; _i < _a.length; _i++) {
	                        var param = _a[_i];
	                        if (ts.isParameterPropertyDeclaration(param)) {
	                            addLeafNode(param);
	                        }
	                    }
	                    break;
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 152 /* MethodSignature */:
	                    if (!ts.hasDynamicName(node)) {
	                        addNodeWithRecursiveChild(node, node.body);
	                    }
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    if (!ts.hasDynamicName(node)) {
	                        addLeafNode(node);
	                    }
	                    break;
	                case 244 /* ImportClause */:
	                    var importClause = node;
	                    // Handle default import case e.g.:
	                    //    import d from "mod";
	                    if (importClause.name) {
	                        addLeafNode(importClause);
	                    }
	                    // Handle named bindings in imports e.g.:
	                    //    import * as NS from "mod";
	                    //    import {a, b as B} from "mod";
	                    var namedBindings = importClause.namedBindings;
	                    if (namedBindings) {
	                        if (namedBindings.kind === 245 /* NamespaceImport */) {
	                            addLeafNode(namedBindings);
	                        }
	                        else {
	                            for (var _b = 0, _c = namedBindings.elements; _b < _c.length; _b++) {
	                                var element = _c[_b];
	                                addLeafNode(element);
	                            }
	                        }
	                    }
	                    break;
	                case 181 /* BindingElement */:
	                case 231 /* VariableDeclaration */:
	                    var _d = node, name = _d.name, initializer = _d.initializer;
	                    if (ts.isBindingPattern(name)) {
	                        addChildrenRecursively(name);
	                    }
	                    else if (initializer && isFunctionOrClassExpression(initializer)) {
	                        if (initializer.name) {
	                            // Don't add a node for the VariableDeclaration, just for the initializer.
	                            addChildrenRecursively(initializer);
	                        }
	                        else {
	                            // Add a node for the VariableDeclaration, but not for the initializer.
	                            startNode(node);
	                            ts.forEachChild(initializer, addChildrenRecursively);
	                            endNode();
	                        }
	                    }
	                    else {
	                        addNodeWithRecursiveChild(node, initializer);
	                    }
	                    break;
	                case 192 /* ArrowFunction */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                    addNodeWithRecursiveChild(node, node.body);
	                    break;
	                case 237 /* EnumDeclaration */:
	                    startNode(node);
	                    for (var _e = 0, _f = node.members; _e < _f.length; _e++) {
	                        var member = _f[_e];
	                        if (!isComputedProperty(member)) {
	                            addLeafNode(member);
	                        }
	                    }
	                    endNode();
	                    break;
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                case 235 /* InterfaceDeclaration */:
	                    startNode(node);
	                    for (var _g = 0, _h = node.members; _g < _h.length; _g++) {
	                        var member = _h[_g];
	                        addChildrenRecursively(member);
	                    }
	                    endNode();
	                    break;
	                case 238 /* ModuleDeclaration */:
	                    addNodeWithRecursiveChild(node, getInteriorModule(node).body);
	                    break;
	                case 251 /* ExportSpecifier */:
	                case 242 /* ImportEqualsDeclaration */:
	                case 159 /* IndexSignature */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 236 /* TypeAliasDeclaration */:
	                    addLeafNode(node);
	                    break;
	                case 199 /* BinaryExpression */: {
	                    var special = ts.getSpecialPropertyAssignmentKind(node);
	                    switch (special) {
	                        case 1 /* ExportsProperty */:
	                        case 2 /* ModuleExports */:
	                        case 3 /* PrototypeProperty */:
	                        case 6 /* Prototype */:
	                            addNodeWithRecursiveChild(node, node.right);
	                            break;
	                        case 4 /* ThisProperty */:
	                        case 5 /* Property */:
	                        case 0 /* None */:
	                            break;
	                        default:
	                            ts.Debug.assertNever(special);
	                    }
	                }
	                // falls through
	                default:
	                    if (ts.hasJSDocNodes(node)) {
	                        ts.forEach(node.jsDoc, function (jsDoc) {
	                            ts.forEach(jsDoc.tags, function (tag) {
	                                if (ts.isJSDocTypeAlias(tag)) {
	                                    addLeafNode(tag);
	                                }
	                            });
	                        });
	                    }
	                    ts.forEachChild(node, addChildrenRecursively);
	            }
	        }
	        /** Merge declarations of the same kind. */
	        function mergeChildren(children) {
	            var nameToItems = ts.createMap();
	            ts.filterMutate(children, function (child) {
	                var declName = ts.getNameOfDeclaration(child.node);
	                var name = declName && nodeText(declName);
	                if (!name) {
	                    // Anonymous items are never merged.
	                    return true;
	                }
	                var itemsWithSameName = nameToItems.get(name);
	                if (!itemsWithSameName) {
	                    nameToItems.set(name, child);
	                    return true;
	                }
	                if (itemsWithSameName instanceof Array) {
	                    for (var _i = 0, itemsWithSameName_1 = itemsWithSameName; _i < itemsWithSameName_1.length; _i++) {
	                        var itemWithSameName = itemsWithSameName_1[_i];
	                        if (tryMerge(itemWithSameName, child)) {
	                            return false;
	                        }
	                    }
	                    itemsWithSameName.push(child);
	                    return true;
	                }
	                else {
	                    var itemWithSameName = itemsWithSameName;
	                    if (tryMerge(itemWithSameName, child)) {
	                        return false;
	                    }
	                    nameToItems.set(name, [itemWithSameName, child]);
	                    return true;
	                }
	            });
	        }
	        function tryMerge(a, b) {
	            if (shouldReallyMerge(a.node, b.node)) {
	                merge(a, b);
	                return true;
	            }
	            return false;
	        }
	        /** a and b have the same name, but they may not be mergeable. */
	        function shouldReallyMerge(a, b) {
	            if (a.kind !== b.kind) {
	                return false;
	            }
	            switch (a.kind) {
	                case 151 /* PropertyDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                    return ts.hasModifier(a, 32 /* Static */) === ts.hasModifier(b, 32 /* Static */);
	                case 238 /* ModuleDeclaration */:
	                    return areSameModule(a, b);
	                default:
	                    return true;
	            }
	        }
	        // We use 1 NavNode to represent 'A.B.C', but there are multiple source nodes.
	        // Only merge module nodes that have the same chain. Don't merge 'A.B.C' with 'A'!
	        function areSameModule(a, b) {
	            return a.body.kind === b.body.kind && (a.body.kind !== 238 /* ModuleDeclaration */ || areSameModule(a.body, b.body));
	        }
	        /** Merge source into target. Source should be thrown away after this is called. */
	        function merge(target, source) {
	            var _a;
	            target.additionalNodes = target.additionalNodes || [];
	            target.additionalNodes.push(source.node);
	            if (source.additionalNodes) {
	                (_a = target.additionalNodes).push.apply(_a, source.additionalNodes);
	            }
	            target.children = ts.concatenate(target.children, source.children);
	            if (target.children) {
	                mergeChildren(target.children);
	                sortChildren(target.children);
	            }
	        }
	        /** Recursively ensure that each NavNode's children are in sorted order. */
	        function sortChildren(children) {
	            children.sort(compareChildren);
	        }
	        function compareChildren(child1, child2) {
	            return ts.compareStringsCaseSensitiveUI(tryGetName(child1.node), tryGetName(child2.node))
	                || ts.compareValues(navigationBarNodeKind(child1), navigationBarNodeKind(child2));
	        }
	        /**
	         * This differs from getItemName because this is just used for sorting.
	         * We only sort nodes by name that have a more-or-less "direct" name, as opposed to `new()` and the like.
	         * So `new()` can still come before an `aardvark` method.
	         */
	        function tryGetName(node) {
	            if (node.kind === 238 /* ModuleDeclaration */) {
	                return getModuleName(node);
	            }
	            var declName = ts.getNameOfDeclaration(node);
	            if (declName) {
	                return ts.unescapeLeadingUnderscores(ts.getPropertyNameForPropertyNameNode(declName));
	            }
	            switch (node.kind) {
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                case 204 /* ClassExpression */:
	                    return getFunctionOrClassName(node);
	                default:
	                    return undefined;
	            }
	        }
	        function getItemName(node) {
	            if (node.kind === 238 /* ModuleDeclaration */) {
	                return getModuleName(node);
	            }
	            var name = ts.getNameOfDeclaration(node);
	            if (name) {
	                var text = nodeText(name);
	                if (text.length > 0) {
	                    return text;
	                }
	            }
	            switch (node.kind) {
	                case 273 /* SourceFile */:
	                    var sourceFile = node;
	                    return ts.isExternalModule(sourceFile)
	                        ? "\"" + ts.escapeString(ts.getBaseFileName(ts.removeFileExtension(ts.normalizePath(sourceFile.fileName)))) + "\""
	                        : "<global>";
	                case 192 /* ArrowFunction */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                    if (ts.getModifierFlags(node) & 512 /* Default */) {
	                        return "default";
	                    }
	                    // We may get a string with newlines or other whitespace in the case of an object dereference
	                    // (eg: "app\n.onactivated"), so we should remove the whitespace for readabiltiy in the
	                    // navigation bar.
	                    return getFunctionOrClassName(node);
	                case 154 /* Constructor */:
	                    return "constructor";
	                case 158 /* ConstructSignature */:
	                    return "new()";
	                case 157 /* CallSignature */:
	                    return "()";
	                case 159 /* IndexSignature */:
	                    return "[]";
	                default:
	                    return "<unknown>";
	            }
	        }
	        /** Flattens the NavNode tree to a list, keeping only the top-level items. */
	        function topLevelItems(root) {
	            var topLevel = [];
	            function recur(item) {
	                if (isTopLevel(item)) {
	                    topLevel.push(item);
	                    if (item.children) {
	                        for (var _i = 0, _a = item.children; _i < _a.length; _i++) {
	                            var child = _a[_i];
	                            recur(child);
	                        }
	                    }
	                }
	            }
	            recur(root);
	            return topLevel;
	            function isTopLevel(item) {
	                switch (navigationBarNodeKind(item)) {
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                    case 237 /* EnumDeclaration */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 238 /* ModuleDeclaration */:
	                    case 273 /* SourceFile */:
	                    case 236 /* TypeAliasDeclaration */:
	                    case 296 /* JSDocTypedefTag */:
	                    case 291 /* JSDocCallbackTag */:
	                        return true;
	                    case 154 /* Constructor */:
	                    case 153 /* MethodDeclaration */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 231 /* VariableDeclaration */:
	                        return hasSomeImportantChild(item);
	                    case 192 /* ArrowFunction */:
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                        return isTopLevelFunctionDeclaration(item);
	                    default:
	                        return false;
	                }
	                function isTopLevelFunctionDeclaration(item) {
	                    if (!item.node.body) {
	                        return false;
	                    }
	                    switch (navigationBarNodeKind(item.parent)) {
	                        case 239 /* ModuleBlock */:
	                        case 273 /* SourceFile */:
	                        case 153 /* MethodDeclaration */:
	                        case 154 /* Constructor */:
	                            return true;
	                        default:
	                            return hasSomeImportantChild(item);
	                    }
	                }
	                function hasSomeImportantChild(item) {
	                    return ts.forEach(item.children, function (child) {
	                        var childKind = navigationBarNodeKind(child);
	                        return childKind !== 231 /* VariableDeclaration */ && childKind !== 181 /* BindingElement */;
	                    });
	                }
	            }
	        }
	        function convertToTree(n) {
	            return {
	                text: getItemName(n.node),
	                kind: ts.getNodeKind(n.node),
	                kindModifiers: getModifiers(n.node),
	                spans: getSpans(n),
	                childItems: ts.map(n.children, convertToTree)
	            };
	        }
	        function convertToTopLevelItem(n) {
	            return {
	                text: getItemName(n.node),
	                kind: ts.getNodeKind(n.node),
	                kindModifiers: getModifiers(n.node),
	                spans: getSpans(n),
	                childItems: ts.map(n.children, convertToChildItem) || emptyChildItemArray,
	                indent: n.indent,
	                bolded: false,
	                grayed: false
	            };
	            function convertToChildItem(n) {
	                return {
	                    text: getItemName(n.node),
	                    kind: ts.getNodeKind(n.node),
	                    kindModifiers: ts.getNodeModifiers(n.node),
	                    spans: getSpans(n),
	                    childItems: emptyChildItemArray,
	                    indent: 0,
	                    bolded: false,
	                    grayed: false
	                };
	            }
	        }
	        function getSpans(n) {
	            var spans = [getNodeSpan(n.node)];
	            if (n.additionalNodes) {
	                for (var _i = 0, _a = n.additionalNodes; _i < _a.length; _i++) {
	                    var node = _a[_i];
	                    spans.push(getNodeSpan(node));
	                }
	            }
	            return spans;
	        }
	        function getModuleName(moduleDeclaration) {
	            // We want to maintain quotation marks.
	            if (ts.isAmbientModule(moduleDeclaration)) {
	                return ts.getTextOfNode(moduleDeclaration.name);
	            }
	            // Otherwise, we need to aggregate each identifier to build up the qualified name.
	            var result = [];
	            result.push(ts.getTextOfIdentifierOrLiteral(moduleDeclaration.name));
	            while (moduleDeclaration.body && moduleDeclaration.body.kind === 238 /* ModuleDeclaration */) {
	                moduleDeclaration = moduleDeclaration.body;
	                result.push(ts.getTextOfIdentifierOrLiteral(moduleDeclaration.name));
	            }
	            return result.join(".");
	        }
	        /**
	         * For 'module A.B.C', we want to get the node for 'C'.
	         * We store 'A' as associated with a NavNode, and use getModuleName to traverse down again.
	         */
	        function getInteriorModule(decl) {
	            return decl.body.kind === 238 /* ModuleDeclaration */ ? getInteriorModule(decl.body) : decl;
	        }
	        function isComputedProperty(member) {
	            return !member.name || member.name.kind === 146 /* ComputedPropertyName */;
	        }
	        function getNodeSpan(node) {
	            return node.kind === 273 /* SourceFile */ ? ts.createTextSpanFromRange(node) : ts.createTextSpanFromNode(node, curSourceFile);
	        }
	        function getModifiers(node) {
	            if (node.parent && node.parent.kind === 231 /* VariableDeclaration */) {
	                node = node.parent;
	            }
	            return ts.getNodeModifiers(node);
	        }
	        function getFunctionOrClassName(node) {
	            if (node.name && ts.getFullWidth(node.name) > 0) {
	                return ts.declarationNameToString(node.name);
	            }
	            // See if it is a var initializer. If so, use the var name.
	            else if (node.parent.kind === 231 /* VariableDeclaration */) {
	                return ts.declarationNameToString(node.parent.name);
	            }
	            // See if it is of the form "<expr> = function(){...}". If so, use the text from the left-hand side.
	            else if (node.parent.kind === 199 /* BinaryExpression */ &&
	                node.parent.operatorToken.kind === 58 /* EqualsToken */) {
	                return nodeText(node.parent.left).replace(whiteSpaceRegex, "");
	            }
	            // See if it is a property assignment, and if so use the property name
	            else if (node.parent.kind === 269 /* PropertyAssignment */ && node.parent.name) {
	                return nodeText(node.parent.name);
	            }
	            // Default exports are named "default"
	            else if (ts.getModifierFlags(node) & 512 /* Default */) {
	                return "default";
	            }
	            else {
	                return ts.isClassLike(node) ? "<class>" : "<function>";
	            }
	        }
	        function isFunctionOrClassExpression(node) {
	            switch (node.kind) {
	                case 192 /* ArrowFunction */:
	                case 191 /* FunctionExpression */:
	                case 204 /* ClassExpression */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	    })(NavigationBar = ts.NavigationBar || (ts.NavigationBar = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var OrganizeImports;
	    (function (OrganizeImports) {
	        /**
	         * Organize imports by:
	         *   1) Removing unused imports
	         *   2) Coalescing imports from the same module
	         *   3) Sorting imports
	         */
	        function organizeImports(sourceFile, formatContext, host, program, _preferences) {
	            var changeTracker = ts.textChanges.ChangeTracker.fromContext({ host: host, formatContext: formatContext });
	            var coalesceAndOrganizeImports = function (importGroup) { return coalesceImports(removeUnusedImports(importGroup, sourceFile, program)); };
	            // All of the old ImportDeclarations in the file, in syntactic order.
	            var topLevelImportDecls = sourceFile.statements.filter(ts.isImportDeclaration);
	            organizeImportsWorker(topLevelImportDecls, coalesceAndOrganizeImports);
	            // All of the old ExportDeclarations in the file, in syntactic order.
	            var topLevelExportDecls = sourceFile.statements.filter(ts.isExportDeclaration);
	            organizeImportsWorker(topLevelExportDecls, coalesceExports);
	            for (var _i = 0, _a = sourceFile.statements.filter(ts.isAmbientModule); _i < _a.length; _i++) {
	                var ambientModule = _a[_i];
	                var ambientModuleBody = getModuleBlock(ambientModule);
	                var ambientModuleImportDecls = ambientModuleBody.statements.filter(ts.isImportDeclaration);
	                organizeImportsWorker(ambientModuleImportDecls, coalesceAndOrganizeImports);
	                var ambientModuleExportDecls = ambientModuleBody.statements.filter(ts.isExportDeclaration);
	                organizeImportsWorker(ambientModuleExportDecls, coalesceExports);
	            }
	            return changeTracker.getChanges();
	            function organizeImportsWorker(oldImportDecls, coalesce) {
	                if (ts.length(oldImportDecls) === 0) {
	                    return;
	                }
	                // Special case: normally, we'd expect leading and trailing trivia to follow each import
	                // around as it's sorted.  However, we do not want this to happen for leading trivia
	                // on the first import because it is probably the header comment for the file.
	                // Consider: we could do a more careful check that this trivia is actually a header,
	                // but the consequences of being wrong are very minor.
	                ts.suppressLeadingTrivia(oldImportDecls[0]);
	                var oldImportGroups = ts.group(oldImportDecls, function (importDecl) { return getExternalModuleName(importDecl.moduleSpecifier); });
	                var sortedImportGroups = ts.stableSort(oldImportGroups, function (group1, group2) { return compareModuleSpecifiers(group1[0].moduleSpecifier, group2[0].moduleSpecifier); });
	                var newImportDecls = ts.flatMap(sortedImportGroups, function (importGroup) {
	                    return getExternalModuleName(importGroup[0].moduleSpecifier)
	                        ? coalesce(importGroup)
	                        : importGroup;
	                });
	                // Delete or replace the first import.
	                if (newImportDecls.length === 0) {
	                    changeTracker.deleteNode(sourceFile, oldImportDecls[0], {
	                        useNonAdjustedStartPosition: true,
	                        useNonAdjustedEndPosition: false,
	                    });
	                }
	                else {
	                    // Note: Delete the surrounding trivia because it will have been retained in newImportDecls.
	                    changeTracker.replaceNodeWithNodes(sourceFile, oldImportDecls[0], newImportDecls, {
	                        useNonAdjustedStartPosition: true,
	                        useNonAdjustedEndPosition: false,
	                        suffix: ts.getNewLineOrDefaultFromHost(host, formatContext.options),
	                    });
	                }
	                // Delete any subsequent imports.
	                for (var i = 1; i < oldImportDecls.length; i++) {
	                    changeTracker.deleteNode(sourceFile, oldImportDecls[i]);
	                }
	            }
	        }
	        OrganizeImports.organizeImports = organizeImports;
	        function getModuleBlock(moduleDecl) {
	            var body = moduleDecl.body;
	            return body && !ts.isIdentifier(body) && (ts.isModuleBlock(body) ? body : getModuleBlock(body));
	        }
	        function removeUnusedImports(oldImports, sourceFile, program) {
	            var typeChecker = program.getTypeChecker();
	            var jsxNamespace = typeChecker.getJsxNamespace();
	            var jsxElementsPresent = !!(sourceFile.transformFlags & 4 /* ContainsJsx */);
	            var usedImports = [];
	            for (var _i = 0, oldImports_1 = oldImports; _i < oldImports_1.length; _i++) {
	                var importDecl = oldImports_1[_i];
	                var importClause = importDecl.importClause;
	                if (!importClause) {
	                    // Imports without import clauses are assumed to be included for their side effects and are not removed.
	                    usedImports.push(importDecl);
	                    continue;
	                }
	                var name = importClause.name, namedBindings = importClause.namedBindings;
	                // Default import
	                if (name && !isDeclarationUsed(name)) {
	                    name = undefined;
	                }
	                if (namedBindings) {
	                    if (ts.isNamespaceImport(namedBindings)) {
	                        // Namespace import
	                        if (!isDeclarationUsed(namedBindings.name)) {
	                            namedBindings = undefined;
	                        }
	                    }
	                    else {
	                        // List of named imports
	                        var newElements = namedBindings.elements.filter(function (e) { return isDeclarationUsed(e.name); });
	                        if (newElements.length < namedBindings.elements.length) {
	                            namedBindings = newElements.length
	                                ? ts.updateNamedImports(namedBindings, newElements)
	                                : undefined;
	                        }
	                    }
	                }
	                if (name || namedBindings) {
	                    usedImports.push(updateImportDeclarationAndClause(importDecl, name, namedBindings));
	                }
	            }
	            return usedImports;
	            function isDeclarationUsed(identifier) {
	                // The JSX factory symbol is always used if JSX elements are present - even if they are not allowed.
	                return jsxElementsPresent && (identifier.text === jsxNamespace) || ts.FindAllReferences.Core.isSymbolReferencedInFile(identifier, typeChecker, sourceFile);
	            }
	        }
	        function getExternalModuleName(specifier) {
	            return specifier !== undefined && ts.isStringLiteralLike(specifier)
	                ? specifier.text
	                : undefined;
	        }
	        /* @internal */ // Internal for testing
	        /**
	         * @param importGroup a list of ImportDeclarations, all with the same module name.
	         */
	        function coalesceImports(importGroup) {
	            if (importGroup.length === 0) {
	                return importGroup;
	            }
	            var _a = getCategorizedImports(importGroup), importWithoutClause = _a.importWithoutClause, defaultImports = _a.defaultImports, namespaceImports = _a.namespaceImports, namedImports = _a.namedImports;
	            var coalescedImports = [];
	            if (importWithoutClause) {
	                coalescedImports.push(importWithoutClause);
	            }
	            // Normally, we don't combine default and namespace imports, but it would be silly to
	            // produce two import declarations in this special case.
	            if (defaultImports.length === 1 && namespaceImports.length === 1 && namedImports.length === 0) {
	                // Add the namespace import to the existing default ImportDeclaration.
	                var defaultImport = defaultImports[0];
	                coalescedImports.push(updateImportDeclarationAndClause(defaultImport, defaultImport.importClause.name, namespaceImports[0].importClause.namedBindings));
	                return coalescedImports;
	            }
	            var sortedNamespaceImports = ts.stableSort(namespaceImports, function (i1, i2) {
	                return compareIdentifiers(i1.importClause.namedBindings.name, i2.importClause.namedBindings.name);
	            });
	            for (var _i = 0, sortedNamespaceImports_1 = sortedNamespaceImports; _i < sortedNamespaceImports_1.length; _i++) {
	                var namespaceImport = sortedNamespaceImports_1[_i];
	                // Drop the name, if any
	                coalescedImports.push(updateImportDeclarationAndClause(namespaceImport, /*name*/ undefined, namespaceImport.importClause.namedBindings));
	            }
	            if (defaultImports.length === 0 && namedImports.length === 0) {
	                return coalescedImports;
	            }
	            var newDefaultImport;
	            var newImportSpecifiers = [];
	            if (defaultImports.length === 1) {
	                newDefaultImport = defaultImports[0].importClause.name;
	            }
	            else {
	                for (var _b = 0, defaultImports_1 = defaultImports; _b < defaultImports_1.length; _b++) {
	                    var defaultImport = defaultImports_1[_b];
	                    newImportSpecifiers.push(ts.createImportSpecifier(ts.createIdentifier("default"), defaultImport.importClause.name));
	                }
	            }
	            newImportSpecifiers.push.apply(newImportSpecifiers, ts.flatMap(namedImports, function (i) { return i.importClause.namedBindings.elements; }));
	            var sortedImportSpecifiers = sortSpecifiers(newImportSpecifiers);
	            var importDecl = defaultImports.length > 0
	                ? defaultImports[0]
	                : namedImports[0];
	            var newNamedImports = sortedImportSpecifiers.length === 0
	                ? newDefaultImport
	                    ? undefined
	                    : ts.createNamedImports(ts.emptyArray)
	                : namedImports.length === 0
	                    ? ts.createNamedImports(sortedImportSpecifiers)
	                    : ts.updateNamedImports(namedImports[0].importClause.namedBindings, sortedImportSpecifiers);
	            coalescedImports.push(updateImportDeclarationAndClause(importDecl, newDefaultImport, newNamedImports));
	            return coalescedImports;
	            /*
	             * Returns entire import declarations because they may already have been rewritten and
	             * may lack parent pointers.  The desired parts can easily be recovered based on the
	             * categorization.
	             *
	             * NB: There may be overlap between `defaultImports` and `namespaceImports`/`namedImports`.
	             */
	            function getCategorizedImports(importGroup) {
	                var importWithoutClause;
	                var defaultImports = [];
	                var namespaceImports = [];
	                var namedImports = [];
	                for (var _i = 0, importGroup_1 = importGroup; _i < importGroup_1.length; _i++) {
	                    var importDeclaration = importGroup_1[_i];
	                    if (importDeclaration.importClause === undefined) {
	                        // Only the first such import is interesting - the others are redundant.
	                        // Note: Unfortunately, we will lose trivia that was on this node.
	                        importWithoutClause = importWithoutClause || importDeclaration;
	                        continue;
	                    }
	                    var _a = importDeclaration.importClause, name = _a.name, namedBindings = _a.namedBindings;
	                    if (name) {
	                        defaultImports.push(importDeclaration);
	                    }
	                    if (namedBindings) {
	                        if (ts.isNamespaceImport(namedBindings)) {
	                            namespaceImports.push(importDeclaration);
	                        }
	                        else {
	                            namedImports.push(importDeclaration);
	                        }
	                    }
	                }
	                return {
	                    importWithoutClause: importWithoutClause,
	                    defaultImports: defaultImports,
	                    namespaceImports: namespaceImports,
	                    namedImports: namedImports,
	                };
	            }
	        }
	        OrganizeImports.coalesceImports = coalesceImports;
	        /* @internal */ // Internal for testing
	        /**
	         * @param exportGroup a list of ExportDeclarations, all with the same module name.
	         */
	        function coalesceExports(exportGroup) {
	            if (exportGroup.length === 0) {
	                return exportGroup;
	            }
	            var _a = getCategorizedExports(exportGroup), exportWithoutClause = _a.exportWithoutClause, namedExports = _a.namedExports;
	            var coalescedExports = [];
	            if (exportWithoutClause) {
	                coalescedExports.push(exportWithoutClause);
	            }
	            if (namedExports.length === 0) {
	                return coalescedExports;
	            }
	            var newExportSpecifiers = [];
	            newExportSpecifiers.push.apply(newExportSpecifiers, ts.flatMap(namedExports, function (i) { return (i.exportClause).elements; }));
	            var sortedExportSpecifiers = sortSpecifiers(newExportSpecifiers);
	            var exportDecl = namedExports[0];
	            coalescedExports.push(ts.updateExportDeclaration(exportDecl, exportDecl.decorators, exportDecl.modifiers, ts.updateNamedExports(exportDecl.exportClause, sortedExportSpecifiers), exportDecl.moduleSpecifier));
	            return coalescedExports;
	            /*
	             * Returns entire export declarations because they may already have been rewritten and
	             * may lack parent pointers.  The desired parts can easily be recovered based on the
	             * categorization.
	             */
	            function getCategorizedExports(exportGroup) {
	                var exportWithoutClause;
	                var namedExports = [];
	                for (var _i = 0, exportGroup_1 = exportGroup; _i < exportGroup_1.length; _i++) {
	                    var exportDeclaration = exportGroup_1[_i];
	                    if (exportDeclaration.exportClause === undefined) {
	                        // Only the first such export is interesting - the others are redundant.
	                        // Note: Unfortunately, we will lose trivia that was on this node.
	                        exportWithoutClause = exportWithoutClause || exportDeclaration;
	                    }
	                    else {
	                        namedExports.push(exportDeclaration);
	                    }
	                }
	                return {
	                    exportWithoutClause: exportWithoutClause,
	                    namedExports: namedExports,
	                };
	            }
	        }
	        OrganizeImports.coalesceExports = coalesceExports;
	        function updateImportDeclarationAndClause(importDeclaration, name, namedBindings) {
	            return ts.updateImportDeclaration(importDeclaration, importDeclaration.decorators, importDeclaration.modifiers, ts.updateImportClause(importDeclaration.importClause, name, namedBindings), importDeclaration.moduleSpecifier);
	        }
	        function sortSpecifiers(specifiers) {
	            return ts.stableSort(specifiers, function (s1, s2) {
	                return compareIdentifiers(s1.propertyName || s1.name, s2.propertyName || s2.name) ||
	                    compareIdentifiers(s1.name, s2.name);
	            });
	        }
	        /* internal */ // Exported for testing
	        function compareModuleSpecifiers(m1, m2) {
	            var name1 = getExternalModuleName(m1);
	            var name2 = getExternalModuleName(m2);
	            return ts.compareBooleans(name1 === undefined, name2 === undefined) ||
	                ts.compareBooleans(ts.isExternalModuleNameRelative(name1), ts.isExternalModuleNameRelative(name2)) ||
	                ts.compareStringsCaseInsensitive(name1, name2);
	        }
	        OrganizeImports.compareModuleSpecifiers = compareModuleSpecifiers;
	        function compareIdentifiers(s1, s2) {
	            return ts.compareStringsCaseInsensitive(s1.text, s2.text);
	        }
	    })(OrganizeImports = ts.OrganizeImports || (ts.OrganizeImports = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var OutliningElementsCollector;
	    (function (OutliningElementsCollector) {
	        function collectElements(sourceFile, cancellationToken) {
	            var res = [];
	            addNodeOutliningSpans(sourceFile, cancellationToken, res);
	            addRegionOutliningSpans(sourceFile, res);
	            return res.sort(function (span1, span2) { return span1.textSpan.start - span2.textSpan.start; });
	        }
	        OutliningElementsCollector.collectElements = collectElements;
	        function addNodeOutliningSpans(sourceFile, cancellationToken, out) {
	            var depthRemaining = 40;
	            var current = 0;
	            var statements = sourceFile.statements;
	            var n = statements.length;
	            while (current < n) {
	                while (current < n && !ts.isAnyImportSyntax(statements[current])) {
	                    visitNonImportNode(statements[current]);
	                    current++;
	                }
	                if (current === n)
	                    break;
	                var firstImport = current;
	                while (current < n && ts.isAnyImportSyntax(statements[current])) {
	                    addOutliningForLeadingCommentsForNode(statements[current], sourceFile, cancellationToken, out);
	                    current++;
	                }
	                var lastImport = current - 1;
	                if (lastImport !== firstImport) {
	                    out.push(createOutliningSpanFromBounds(ts.findChildOfKind(statements[firstImport], 91 /* ImportKeyword */, sourceFile).getStart(sourceFile), statements[lastImport].getEnd(), "imports" /* Imports */));
	                }
	            }
	            function visitNonImportNode(n) {
	                if (depthRemaining === 0)
	                    return;
	                cancellationToken.throwIfCancellationRequested();
	                if (ts.isDeclaration(n)) {
	                    addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out);
	                }
	                var span = getOutliningSpanForNode(n, sourceFile);
	                if (span)
	                    out.push(span);
	                depthRemaining--;
	                if (ts.isIfStatement(n) && n.elseStatement && ts.isIfStatement(n.elseStatement)) {
	                    // Consider an 'else if' to be on the same depth as the 'if'.
	                    visitNonImportNode(n.expression);
	                    visitNonImportNode(n.thenStatement);
	                    depthRemaining++;
	                    visitNonImportNode(n.elseStatement);
	                    depthRemaining--;
	                }
	                else {
	                    n.forEachChild(visitNonImportNode);
	                }
	                depthRemaining++;
	            }
	        }
	        function addRegionOutliningSpans(sourceFile, out) {
	            var regions = [];
	            var lineStarts = sourceFile.getLineStarts();
	            for (var i = 0; i < lineStarts.length; i++) {
	                var currentLineStart = lineStarts[i];
	                var lineEnd = i + 1 === lineStarts.length ? sourceFile.getEnd() : lineStarts[i + 1] - 1;
	                var lineText = sourceFile.text.substring(currentLineStart, lineEnd);
	                var result = lineText.match(/^\s*\/\/\s*#(end)?region(?:\s+(.*))?(?:\r)?$/);
	                if (!result || ts.isInComment(sourceFile, currentLineStart)) {
	                    continue;
	                }
	                if (!result[1]) {
	                    var span = ts.createTextSpanFromBounds(sourceFile.text.indexOf("//", currentLineStart), lineEnd);
	                    regions.push(createOutliningSpan(span, "region" /* Region */, span, /*autoCollapse*/ false, result[2] || "#region"));
	                }
	                else {
	                    var region = regions.pop();
	                    if (region) {
	                        region.textSpan.length = lineEnd - region.textSpan.start;
	                        region.hintSpan.length = lineEnd - region.textSpan.start;
	                        out.push(region);
	                    }
	                }
	            }
	        }
	        function addOutliningForLeadingCommentsForNode(n, sourceFile, cancellationToken, out) {
	            var comments = ts.getLeadingCommentRangesOfNode(n, sourceFile);
	            if (!comments)
	                return;
	            var firstSingleLineCommentStart = -1;
	            var lastSingleLineCommentEnd = -1;
	            var singleLineCommentCount = 0;
	            for (var _i = 0, comments_3 = comments; _i < comments_3.length; _i++) {
	                var _a = comments_3[_i], kind = _a.kind, pos = _a.pos, end = _a.end;
	                cancellationToken.throwIfCancellationRequested();
	                switch (kind) {
	                    case 2 /* SingleLineCommentTrivia */:
	                        // For single line comments, combine consecutive ones (2 or more) into
	                        // a single span from the start of the first till the end of the last
	                        if (singleLineCommentCount === 0) {
	                            firstSingleLineCommentStart = pos;
	                        }
	                        lastSingleLineCommentEnd = end;
	                        singleLineCommentCount++;
	                        break;
	                    case 3 /* MultiLineCommentTrivia */:
	                        combineAndAddMultipleSingleLineComments();
	                        out.push(createOutliningSpanFromBounds(pos, end, "comment" /* Comment */));
	                        singleLineCommentCount = 0;
	                        break;
	                    default:
	                        ts.Debug.assertNever(kind);
	                }
	            }
	            combineAndAddMultipleSingleLineComments();
	            function combineAndAddMultipleSingleLineComments() {
	                // Only outline spans of two or more consecutive single line comments
	                if (singleLineCommentCount > 1) {
	                    out.push(createOutliningSpanFromBounds(firstSingleLineCommentStart, lastSingleLineCommentEnd, "comment" /* Comment */));
	                }
	            }
	        }
	        function createOutliningSpanFromBounds(pos, end, kind) {
	            return createOutliningSpan(ts.createTextSpanFromBounds(pos, end), kind);
	        }
	        function getOutliningSpanForNode(n, sourceFile) {
	            switch (n.kind) {
	                case 212 /* Block */:
	                    if (ts.isFunctionBlock(n)) {
	                        return spanForNode(n.parent, /*autoCollapse*/ n.parent.kind !== 192 /* ArrowFunction */);
	                    }
	                    // Check if the block is standalone, or 'attached' to some parent statement.
	                    // If the latter, we want to collapse the block, but consider its hint span
	                    // to be the entire span of the parent.
	                    switch (n.parent.kind) {
	                        case 217 /* DoStatement */:
	                        case 220 /* ForInStatement */:
	                        case 221 /* ForOfStatement */:
	                        case 219 /* ForStatement */:
	                        case 216 /* IfStatement */:
	                        case 218 /* WhileStatement */:
	                        case 225 /* WithStatement */:
	                        case 268 /* CatchClause */:
	                            return spanForNode(n.parent);
	                        case 229 /* TryStatement */:
	                            // Could be the try-block, or the finally-block.
	                            var tryStatement = n.parent;
	                            if (tryStatement.tryBlock === n) {
	                                return spanForNode(n.parent);
	                            }
	                            else if (tryStatement.finallyBlock === n) {
	                                return spanForNode(ts.findChildOfKind(tryStatement, 87 /* FinallyKeyword */, sourceFile));
	                            }
	                        // falls through
	                        default:
	                            // Block was a standalone block.  In this case we want to only collapse
	                            // the span of the block, independent of any parent span.
	                            return createOutliningSpan(ts.createTextSpanFromNode(n, sourceFile), "code" /* Code */);
	                    }
	                case 239 /* ModuleBlock */:
	                    return spanForNode(n.parent);
	                case 234 /* ClassDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 240 /* CaseBlock */:
	                    return spanForNode(n);
	                case 183 /* ObjectLiteralExpression */:
	                    return spanForObjectOrArrayLiteral(n);
	                case 182 /* ArrayLiteralExpression */:
	                    return spanForObjectOrArrayLiteral(n, 21 /* OpenBracketToken */);
	            }
	            function spanForObjectOrArrayLiteral(node, open) {
	                if (open === void 0) { open = 17 /* OpenBraceToken */; }
	                // If the block has no leading keywords and is inside an array literal,
	                // we only want to collapse the span of the block.
	                // Otherwise, the collapsed section will include the end of the previous line.
	                return spanForNode(node, /*autoCollapse*/ false, /*useFullStart*/ !ts.isArrayLiteralExpression(node.parent), open);
	            }
	            function spanForNode(hintSpanNode, autoCollapse, useFullStart, open) {
	                if (autoCollapse === void 0) { autoCollapse = false; }
	                if (useFullStart === void 0) { useFullStart = true; }
	                if (open === void 0) { open = 17 /* OpenBraceToken */; }
	                var openToken = ts.findChildOfKind(n, open, sourceFile);
	                var close = open === 17 /* OpenBraceToken */ ? 18 /* CloseBraceToken */ : 22 /* CloseBracketToken */;
	                var closeToken = ts.findChildOfKind(n, close, sourceFile);
	                if (!openToken || !closeToken) {
	                    return undefined;
	                }
	                var textSpan = ts.createTextSpanFromBounds(useFullStart ? openToken.getFullStart() : openToken.getStart(sourceFile), closeToken.getEnd());
	                return createOutliningSpan(textSpan, "code" /* Code */, ts.createTextSpanFromNode(hintSpanNode, sourceFile), autoCollapse);
	            }
	        }
	        function createOutliningSpan(textSpan, kind, hintSpan, autoCollapse, bannerText) {
	            if (hintSpan === void 0) { hintSpan = textSpan; }
	            if (autoCollapse === void 0) { autoCollapse = false; }
	            if (bannerText === void 0) { bannerText = "..."; }
	            return { textSpan: textSpan, kind: kind, hintSpan: hintSpan, bannerText: bannerText, autoCollapse: autoCollapse };
	        }
	    })(OutliningElementsCollector = ts.OutliningElementsCollector || (ts.OutliningElementsCollector = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    // Note(cyrusn): this enum is ordered from strongest match type to weakest match type.
	    var PatternMatchKind;
	    (function (PatternMatchKind) {
	        PatternMatchKind[PatternMatchKind["exact"] = 0] = "exact";
	        PatternMatchKind[PatternMatchKind["prefix"] = 1] = "prefix";
	        PatternMatchKind[PatternMatchKind["substring"] = 2] = "substring";
	        PatternMatchKind[PatternMatchKind["camelCase"] = 3] = "camelCase";
	    })(PatternMatchKind = ts.PatternMatchKind || (ts.PatternMatchKind = {}));
	    function createPatternMatch(kind, isCaseSensitive) {
	        return {
	            kind: kind,
	            isCaseSensitive: isCaseSensitive
	        };
	    }
	    function createPatternMatcher(pattern) {
	        // We'll often see the same candidate string many times when searching (For example, when
	        // we see the name of a module that is used everywhere, or the name of an overload).  As
	        // such, we cache the information we compute about the candidate for the life of this
	        // pattern matcher so we don't have to compute it multiple times.
	        var stringToWordSpans = ts.createMap();
	        var dotSeparatedSegments = pattern.trim().split(".").map(function (p) { return createSegment(p.trim()); });
	        // A segment is considered invalid if we couldn't find any words in it.
	        if (dotSeparatedSegments.some(function (segment) { return !segment.subWordTextChunks.length; }))
	            return undefined;
	        return {
	            getFullMatch: function (containers, candidate) { return getFullMatch(containers, candidate, dotSeparatedSegments, stringToWordSpans); },
	            getMatchForLastSegmentOfPattern: function (candidate) { return matchSegment(candidate, ts.last(dotSeparatedSegments), stringToWordSpans); },
	            patternContainsDots: dotSeparatedSegments.length > 1
	        };
	    }
	    ts.createPatternMatcher = createPatternMatcher;
	    function getFullMatch(candidateContainers, candidate, dotSeparatedSegments, stringToWordSpans) {
	        // First, check that the last part of the dot separated pattern matches the name of the
	        // candidate.  If not, then there's no point in proceeding and doing the more
	        // expensive work.
	        var candidateMatch = matchSegment(candidate, ts.lastOrUndefined(dotSeparatedSegments), stringToWordSpans);
	        if (!candidateMatch) {
	            return undefined;
	        }
	        candidateContainers = candidateContainers || [];
	        // -1 because the last part was checked against the name, and only the rest
	        // of the parts are checked against the container.
	        if (dotSeparatedSegments.length - 1 > candidateContainers.length) {
	            // There weren't enough container parts to match against the pattern parts.
	            // So this definitely doesn't match.
	            return undefined;
	        }
	        var bestMatch;
	        for (var i = dotSeparatedSegments.length - 2, j = candidateContainers.length - 1; i >= 0; i -= 1, j -= 1) {
	            bestMatch = betterMatch(bestMatch, matchSegment(candidateContainers[j], dotSeparatedSegments[i], stringToWordSpans));
	        }
	        return bestMatch;
	    }
	    function getWordSpans(word, stringToWordSpans) {
	        var spans = stringToWordSpans.get(word);
	        if (!spans) {
	            stringToWordSpans.set(word, spans = breakIntoWordSpans(word));
	        }
	        return spans;
	    }
	    function matchTextChunk(candidate, chunk, stringToWordSpans) {
	        var index = indexOfIgnoringCase(candidate, chunk.textLowerCase);
	        if (index === 0) {
	            // a) Check if the word is a prefix of the candidate, in a case insensitive or
	            //    sensitive manner. If it does, return that there was an exact match if the word and candidate are the same length, else a prefix match.
	            return createPatternMatch(chunk.text.length === candidate.length ? PatternMatchKind.exact : PatternMatchKind.prefix, /*isCaseSensitive:*/ ts.startsWith(candidate, chunk.text));
	        }
	        if (chunk.isLowerCase) {
	            if (index === -1)
	                return undefined;
	            // b) If the part is entirely lowercase, then check if it is contained anywhere in the
	            //    candidate in a case insensitive manner.  If so, return that there was a substring
	            //    match.
	            //
	            //    Note: We only have a substring match if the lowercase part is prefix match of some
	            //    word part. That way we don't match something like 'Class' when the user types 'a'.
	            //    But we would match 'FooAttribute' (since 'Attribute' starts with 'a').
	            var wordSpans = getWordSpans(candidate, stringToWordSpans);
	            for (var _i = 0, wordSpans_1 = wordSpans; _i < wordSpans_1.length; _i++) {
	                var span = wordSpans_1[_i];
	                if (partStartsWith(candidate, span, chunk.text, /*ignoreCase:*/ true)) {
	                    return createPatternMatch(PatternMatchKind.substring, /*isCaseSensitive:*/ partStartsWith(candidate, span, chunk.text, /*ignoreCase:*/ false));
	                }
	            }
	            // c) Is the pattern a substring of the candidate starting on one of the candidate's word boundaries?
	            // We could check every character boundary start of the candidate for the pattern. However, that's
	            // an m * n operation in the wost case. Instead, find the first instance of the pattern
	            // substring, and see if it starts on a capital letter. It seems unlikely that the user will try to
	            // filter the list based on a substring that starts on a capital letter and also with a lowercase one.
	            // (Pattern: fogbar, Candidate: quuxfogbarFogBar).
	            if (chunk.text.length < candidate.length && isUpperCaseLetter(candidate.charCodeAt(index))) {
	                return createPatternMatch(PatternMatchKind.substring, /*isCaseSensitive:*/ false);
	            }
	        }
	        else {
	            // d) If the part was not entirely lowercase, then check if it is contained in the
	            //    candidate in a case *sensitive* manner. If so, return that there was a substring
	            //    match.
	            if (candidate.indexOf(chunk.text) > 0) {
	                return createPatternMatch(PatternMatchKind.substring, /*isCaseSensitive:*/ true);
	            }
	            // e) If the part was not entirely lowercase, then attempt a camel cased match as well.
	            if (chunk.characterSpans.length > 0) {
	                var candidateParts = getWordSpans(candidate, stringToWordSpans);
	                var isCaseSensitive = tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase:*/ false) ? true
	                    : tryCamelCaseMatch(candidate, candidateParts, chunk, /*ignoreCase:*/ true) ? false : undefined;
	                if (isCaseSensitive !== undefined) {
	                    return createPatternMatch(PatternMatchKind.camelCase, isCaseSensitive);
	                }
	            }
	        }
	    }
	    function matchSegment(candidate, segment, stringToWordSpans) {
	        // First check if the segment matches as is.  This is also useful if the segment contains
	        // characters we would normally strip when splitting into parts that we also may want to
	        // match in the candidate.  For example if the segment is "@int" and the candidate is
	        // "@int", then that will show up as an exact match here.
	        //
	        // Note: if the segment contains a space or an asterisk then we must assume that it's a
	        // multi-word segment.
	        if (every(segment.totalTextChunk.text, function (ch) { return ch !== 32 /* space */ && ch !== 42 /* asterisk */; })) {
	            var match = matchTextChunk(candidate, segment.totalTextChunk, stringToWordSpans);
	            if (match)
	                return match;
	        }
	        // The logic for pattern matching is now as follows:
	        //
	        // 1) Break the segment passed in into words.  Breaking is rather simple and a
	        //    good way to think about it that if gives you all the individual alphanumeric words
	        //    of the pattern.
	        //
	        // 2) For each word try to match the word against the candidate value.
	        //
	        // 3) Matching is as follows:
	        //
	        //   a) Check if the word is a prefix of the candidate, in a case insensitive or
	        //      sensitive manner. If it does, return that there was an exact match if the word and candidate are the same length, else a prefix match.
	        //
	        //   If the word is entirely lowercase:
	        //      b) Then check if it is contained anywhere in the
	        //          candidate in a case insensitive manner.  If so, return that there was a substring
	        //          match.
	        //
	        //          Note: We only have a substring match if the lowercase part is prefix match of
	        //          some word part. That way we don't match something like 'Class' when the user
	        //          types 'a'. But we would match 'FooAttribute' (since 'Attribute' starts with
	        //          'a').
	        //
	        //       c) The word is all lower case. Is it a case insensitive substring of the candidate starting
	        //          on a part boundary of the candidate?
	        //
	        //   Else:
	        //       d) If the word was not entirely lowercase, then check if it is contained in the
	        //          candidate in a case *sensitive* manner. If so, return that there was a substring
	        //          match.
	        //
	        //       e) If the word was not entirely lowercase, then attempt a camel cased match as
	        //          well.
	        //
	        // Only if all words have some sort of match is the pattern considered matched.
	        var subWordTextChunks = segment.subWordTextChunks;
	        var bestMatch;
	        for (var _i = 0, subWordTextChunks_1 = subWordTextChunks; _i < subWordTextChunks_1.length; _i++) {
	            var subWordTextChunk = subWordTextChunks_1[_i];
	            bestMatch = betterMatch(bestMatch, matchTextChunk(candidate, subWordTextChunk, stringToWordSpans));
	        }
	        return bestMatch;
	    }
	    function betterMatch(a, b) {
	        return ts.min(a, b, compareMatches);
	    }
	    function compareMatches(a, b) {
	        return a === undefined ? 1 /* GreaterThan */ : b === undefined ? -1 /* LessThan */
	            : ts.compareValues(a.kind, b.kind) || ts.compareBooleans(!a.isCaseSensitive, !b.isCaseSensitive);
	    }
	    function partStartsWith(candidate, candidateSpan, pattern, ignoreCase, patternSpan) {
	        if (patternSpan === void 0) { patternSpan = { start: 0, length: pattern.length }; }
	        return patternSpan.length <= candidateSpan.length // If pattern part is longer than the candidate part there can never be a match.
	            && everyInRange(0, patternSpan.length, function (i) { return equalChars(pattern.charCodeAt(patternSpan.start + i), candidate.charCodeAt(candidateSpan.start + i), ignoreCase); });
	    }
	    function equalChars(ch1, ch2, ignoreCase) {
	        return ignoreCase ? toLowerCase(ch1) === toLowerCase(ch2) : ch1 === ch2;
	    }
	    function tryCamelCaseMatch(candidate, candidateParts, chunk, ignoreCase) {
	        var chunkCharacterSpans = chunk.characterSpans;
	        // Note: we may have more pattern parts than candidate parts.  This is because multiple
	        // pattern parts may match a candidate part.  For example "SiUI" against "SimpleUI".
	        // We'll have 3 pattern parts Si/U/I against two candidate parts Simple/UI.  However, U
	        // and I will both match in UI.
	        var currentCandidate = 0;
	        var currentChunkSpan = 0;
	        var firstMatch;
	        var contiguous;
	        while (true) {
	            // Let's consider our termination cases
	            if (currentChunkSpan === chunkCharacterSpans.length) {
	                return true;
	            }
	            else if (currentCandidate === candidateParts.length) {
	                // No match, since we still have more of the pattern to hit
	                return false;
	            }
	            var candidatePart = candidateParts[currentCandidate];
	            var gotOneMatchThisCandidate = false;
	            // Consider the case of matching SiUI against SimpleUIElement. The candidate parts
	            // will be Simple/UI/Element, and the pattern parts will be Si/U/I.  We'll match 'Si'
	            // against 'Simple' first.  Then we'll match 'U' against 'UI'. However, we want to
	            // still keep matching pattern parts against that candidate part.
	            for (; currentChunkSpan < chunkCharacterSpans.length; currentChunkSpan++) {
	                var chunkCharacterSpan = chunkCharacterSpans[currentChunkSpan];
	                if (gotOneMatchThisCandidate) {
	                    // We've already gotten one pattern part match in this candidate.  We will
	                    // only continue trying to consumer pattern parts if the last part and this
	                    // part are both upper case.
	                    if (!isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan - 1].start)) ||
	                        !isUpperCaseLetter(chunk.text.charCodeAt(chunkCharacterSpans[currentChunkSpan].start))) {
	                        break;
	                    }
	                }
	                if (!partStartsWith(candidate, candidatePart, chunk.text, ignoreCase, chunkCharacterSpan)) {
	                    break;
	                }
	                gotOneMatchThisCandidate = true;
	                firstMatch = firstMatch === undefined ? currentCandidate : firstMatch;
	                // If we were contiguous, then keep that value.  If we weren't, then keep that
	                // value.  If we don't know, then set the value to 'true' as an initial match is
	                // obviously contiguous.
	                contiguous = contiguous === undefined ? true : contiguous;
	                candidatePart = ts.createTextSpan(candidatePart.start + chunkCharacterSpan.length, candidatePart.length - chunkCharacterSpan.length);
	            }
	            // Check if we matched anything at all.  If we didn't, then we need to unset the
	            // contiguous bit if we currently had it set.
	            // If we haven't set the bit yet, then that means we haven't matched anything so
	            // far, and we don't want to change that.
	            if (!gotOneMatchThisCandidate && contiguous !== undefined) {
	                contiguous = false;
	            }
	            // Move onto the next candidate.
	            currentCandidate++;
	        }
	    }
	    function createSegment(text) {
	        return {
	            totalTextChunk: createTextChunk(text),
	            subWordTextChunks: breakPatternIntoTextChunks(text)
	        };
	    }
	    function isUpperCaseLetter(ch) {
	        // Fast check for the ascii range.
	        if (ch >= 65 /* A */ && ch <= 90 /* Z */) {
	            return true;
	        }
	        if (ch < 127 /* maxAsciiCharacter */ || !ts.isUnicodeIdentifierStart(ch, 6 /* Latest */)) {
	            return false;
	        }
	        // TODO: find a way to determine this for any unicode characters in a
	        // non-allocating manner.
	        var str = String.fromCharCode(ch);
	        return str === str.toUpperCase();
	    }
	    function isLowerCaseLetter(ch) {
	        // Fast check for the ascii range.
	        if (ch >= 97 /* a */ && ch <= 122 /* z */) {
	            return true;
	        }
	        if (ch < 127 /* maxAsciiCharacter */ || !ts.isUnicodeIdentifierStart(ch, 6 /* Latest */)) {
	            return false;
	        }
	        // TODO: find a way to determine this for any unicode characters in a
	        // non-allocating manner.
	        var str = String.fromCharCode(ch);
	        return str === str.toLowerCase();
	    }
	    // Assumes 'value' is already lowercase.
	    function indexOfIgnoringCase(str, value) {
	        var n = str.length - value.length;
	        var _loop_16 = function (start) {
	            if (every(value, function (valueChar, i) { return toLowerCase(str.charCodeAt(i + start)) === valueChar; })) {
	                return { value: start };
	            }
	        };
	        for (var start = 0; start <= n; start++) {
	            var state_4 = _loop_16(start);
	            if (typeof state_4 === "object")
	                return state_4.value;
	        }
	        return -1;
	    }
	    function toLowerCase(ch) {
	        // Fast convert for the ascii range.
	        if (ch >= 65 /* A */ && ch <= 90 /* Z */) {
	            return 97 /* a */ + (ch - 65 /* A */);
	        }
	        if (ch < 127 /* maxAsciiCharacter */) {
	            return ch;
	        }
	        // TODO: find a way to compute this for any unicode characters in a
	        // non-allocating manner.
	        return String.fromCharCode(ch).toLowerCase().charCodeAt(0);
	    }
	    function isDigit(ch) {
	        // TODO(cyrusn): Find a way to support this for unicode digits.
	        return ch >= 48 /* _0 */ && ch <= 57 /* _9 */;
	    }
	    function isWordChar(ch) {
	        return isUpperCaseLetter(ch) || isLowerCaseLetter(ch) || isDigit(ch) || ch === 95 /* _ */ || ch === 36 /* $ */;
	    }
	    function breakPatternIntoTextChunks(pattern) {
	        var result = [];
	        var wordStart = 0;
	        var wordLength = 0;
	        for (var i = 0; i < pattern.length; i++) {
	            var ch = pattern.charCodeAt(i);
	            if (isWordChar(ch)) {
	                if (wordLength === 0) {
	                    wordStart = i;
	                }
	                wordLength++;
	            }
	            else {
	                if (wordLength > 0) {
	                    result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
	                    wordLength = 0;
	                }
	            }
	        }
	        if (wordLength > 0) {
	            result.push(createTextChunk(pattern.substr(wordStart, wordLength)));
	        }
	        return result;
	    }
	    function createTextChunk(text) {
	        var textLowerCase = text.toLowerCase();
	        return {
	            text: text,
	            textLowerCase: textLowerCase,
	            isLowerCase: text === textLowerCase,
	            characterSpans: breakIntoCharacterSpans(text)
	        };
	    }
	    /* @internal */ function breakIntoCharacterSpans(identifier) {
	        return breakIntoSpans(identifier, /*word:*/ false);
	    }
	    ts.breakIntoCharacterSpans = breakIntoCharacterSpans;
	    /* @internal */ function breakIntoWordSpans(identifier) {
	        return breakIntoSpans(identifier, /*word:*/ true);
	    }
	    ts.breakIntoWordSpans = breakIntoWordSpans;
	    function breakIntoSpans(identifier, word) {
	        var result = [];
	        var wordStart = 0;
	        for (var i = 1; i < identifier.length; i++) {
	            var lastIsDigit = isDigit(identifier.charCodeAt(i - 1));
	            var currentIsDigit = isDigit(identifier.charCodeAt(i));
	            var hasTransitionFromLowerToUpper = transitionFromLowerToUpper(identifier, word, i);
	            var hasTransitionFromUpperToLower = word && transitionFromUpperToLower(identifier, i, wordStart);
	            if (charIsPunctuation(identifier.charCodeAt(i - 1)) ||
	                charIsPunctuation(identifier.charCodeAt(i)) ||
	                lastIsDigit !== currentIsDigit ||
	                hasTransitionFromLowerToUpper ||
	                hasTransitionFromUpperToLower) {
	                if (!isAllPunctuation(identifier, wordStart, i)) {
	                    result.push(ts.createTextSpan(wordStart, i - wordStart));
	                }
	                wordStart = i;
	            }
	        }
	        if (!isAllPunctuation(identifier, wordStart, identifier.length)) {
	            result.push(ts.createTextSpan(wordStart, identifier.length - wordStart));
	        }
	        return result;
	    }
	    function charIsPunctuation(ch) {
	        switch (ch) {
	            case 33 /* exclamation */:
	            case 34 /* doubleQuote */:
	            case 35 /* hash */:
	            case 37 /* percent */:
	            case 38 /* ampersand */:
	            case 39 /* singleQuote */:
	            case 40 /* openParen */:
	            case 41 /* closeParen */:
	            case 42 /* asterisk */:
	            case 44 /* comma */:
	            case 45 /* minus */:
	            case 46 /* dot */:
	            case 47 /* slash */:
	            case 58 /* colon */:
	            case 59 /* semicolon */:
	            case 63 /* question */:
	            case 64 /* at */:
	            case 91 /* openBracket */:
	            case 92 /* backslash */:
	            case 93 /* closeBracket */:
	            case 95 /* _ */:
	            case 123 /* openBrace */:
	            case 125 /* closeBrace */:
	                return true;
	        }
	        return false;
	    }
	    function isAllPunctuation(identifier, start, end) {
	        return every(identifier, function (ch) { return charIsPunctuation(ch) && ch !== 95 /* _ */; }, start, end);
	    }
	    function transitionFromUpperToLower(identifier, index, wordStart) {
	        // Cases this supports:
	        // 1) IDisposable -> I, Disposable
	        // 2) UIElement -> UI, Element
	        // 3) HTMLDocument -> HTML, Document
	        //
	        // etc.
	        // We have a transition from an upper to a lower letter here.  But we only
	        // want to break if all the letters that preceded are uppercase.  i.e. if we
	        // have "Foo" we don't want to break that into "F, oo".  But if we have
	        // "IFoo" or "UIFoo", then we want to break that into "I, Foo" and "UI,
	        // Foo".  i.e. the last uppercase letter belongs to the lowercase letters
	        // that follows.  Note: this will make the following not split properly:
	        // "HELLOthere".  However, these sorts of names do not show up in .Net
	        // programs.
	        return index !== wordStart
	            && index + 1 < identifier.length
	            && isUpperCaseLetter(identifier.charCodeAt(index))
	            && isLowerCaseLetter(identifier.charCodeAt(index + 1))
	            && every(identifier, isUpperCaseLetter, wordStart, index);
	    }
	    function transitionFromLowerToUpper(identifier, word, index) {
	        var lastIsUpper = isUpperCaseLetter(identifier.charCodeAt(index - 1));
	        var currentIsUpper = isUpperCaseLetter(identifier.charCodeAt(index));
	        // See if the casing indicates we're starting a new word. Note: if we're breaking on
	        // words, then just seeing an upper case character isn't enough.  Instead, it has to
	        // be uppercase and the previous character can't be uppercase.
	        //
	        // For example, breaking "AddMetadata" on words would make: Add Metadata
	        //
	        // on characters would be: A dd M etadata
	        //
	        // Break "AM" on words would be: AM
	        //
	        // on characters would be: A M
	        //
	        // We break the search string on characters.  But we break the symbol name on words.
	        return currentIsUpper && (!word || !lastIsUpper);
	    }
	    function everyInRange(start, end, pred) {
	        for (var i = start; i < end; i++) {
	            if (!pred(i)) {
	                return false;
	            }
	        }
	        return true;
	    }
	    function every(s, pred, start, end) {
	        if (start === void 0) { start = 0; }
	        if (end === void 0) { end = s.length; }
	        return everyInRange(start, end, function (i) { return pred(s.charCodeAt(i), i); });
	    }
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    function preProcessFile(sourceText, readImportFiles, detectJavaScriptImports) {
	        if (readImportFiles === void 0) { readImportFiles = true; }
	        if (detectJavaScriptImports === void 0) { detectJavaScriptImports = false; }
	        var pragmaContext = {
	            languageVersion: 1 /* ES5 */,
	            pragmas: undefined,
	            checkJsDirective: undefined,
	            referencedFiles: [],
	            typeReferenceDirectives: [],
	            amdDependencies: [],
	            hasNoDefaultLib: undefined,
	            moduleName: undefined
	        };
	        var importedFiles = [];
	        var ambientExternalModules;
	        var lastToken;
	        var currentToken;
	        var braceNesting = 0;
	        // assume that text represent an external module if it contains at least one top level import/export
	        // ambient modules that are found inside external modules are interpreted as module augmentations
	        var externalModule = false;
	        function nextToken() {
	            lastToken = currentToken;
	            currentToken = ts.scanner.scan();
	            if (currentToken === 17 /* OpenBraceToken */) {
	                braceNesting++;
	            }
	            else if (currentToken === 18 /* CloseBraceToken */) {
	                braceNesting--;
	            }
	            return currentToken;
	        }
	        function getFileReference() {
	            var fileName = ts.scanner.getTokenValue();
	            var pos = ts.scanner.getTokenPos();
	            return { fileName: fileName, pos: pos, end: pos + fileName.length };
	        }
	        function recordAmbientExternalModule() {
	            if (!ambientExternalModules) {
	                ambientExternalModules = [];
	            }
	            ambientExternalModules.push({ ref: getFileReference(), depth: braceNesting });
	        }
	        function recordModuleName() {
	            importedFiles.push(getFileReference());
	            markAsExternalModuleIfTopLevel();
	        }
	        function markAsExternalModuleIfTopLevel() {
	            if (braceNesting === 0) {
	                externalModule = true;
	            }
	        }
	        /**
	         * Returns true if at least one token was consumed from the stream
	         */
	        function tryConsumeDeclare() {
	            var token = ts.scanner.getToken();
	            if (token === 124 /* DeclareKeyword */) {
	                // declare module "mod"
	                token = nextToken();
	                if (token === 129 /* ModuleKeyword */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        recordAmbientExternalModule();
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        /**
	         * Returns true if at least one token was consumed from the stream
	         */
	        function tryConsumeImport() {
	            if (lastToken === 23 /* DotToken */) {
	                return false;
	            }
	            var token = ts.scanner.getToken();
	            if (token === 91 /* ImportKeyword */) {
	                token = nextToken();
	                if (token === 19 /* OpenParenToken */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        // import("mod");
	                        recordModuleName();
	                        return true;
	                    }
	                }
	                else if (token === 9 /* StringLiteral */) {
	                    // import "mod";
	                    recordModuleName();
	                    return true;
	                }
	                else {
	                    if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                        token = nextToken();
	                        if (token === 142 /* FromKeyword */) {
	                            token = nextToken();
	                            if (token === 9 /* StringLiteral */) {
	                                // import d from "mod";
	                                recordModuleName();
	                                return true;
	                            }
	                        }
	                        else if (token === 58 /* EqualsToken */) {
	                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) {
	                                return true;
	                            }
	                        }
	                        else if (token === 26 /* CommaToken */) {
	                            // consume comma and keep going
	                            token = nextToken();
	                        }
	                        else {
	                            // unknown syntax
	                            return true;
	                        }
	                    }
	                    if (token === 17 /* OpenBraceToken */) {
	                        token = nextToken();
	                        // consume "{ a as B, c, d as D}" clauses
	                        // make sure that it stops on EOF
	                        while (token !== 18 /* CloseBraceToken */ && token !== 1 /* EndOfFileToken */) {
	                            token = nextToken();
	                        }
	                        if (token === 18 /* CloseBraceToken */) {
	                            token = nextToken();
	                            if (token === 142 /* FromKeyword */) {
	                                token = nextToken();
	                                if (token === 9 /* StringLiteral */) {
	                                    // import {a as A} from "mod";
	                                    // import d, {a, b as B} from "mod"
	                                    recordModuleName();
	                                }
	                            }
	                        }
	                    }
	                    else if (token === 39 /* AsteriskToken */) {
	                        token = nextToken();
	                        if (token === 118 /* AsKeyword */) {
	                            token = nextToken();
	                            if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                                token = nextToken();
	                                if (token === 142 /* FromKeyword */) {
	                                    token = nextToken();
	                                    if (token === 9 /* StringLiteral */) {
	                                        // import * as NS from "mod"
	                                        // import d, * as NS from "mod"
	                                        recordModuleName();
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeExport() {
	            var token = ts.scanner.getToken();
	            if (token === 84 /* ExportKeyword */) {
	                markAsExternalModuleIfTopLevel();
	                token = nextToken();
	                if (token === 17 /* OpenBraceToken */) {
	                    token = nextToken();
	                    // consume "{ a as B, c, d as D}" clauses
	                    // make sure it stops on EOF
	                    while (token !== 18 /* CloseBraceToken */ && token !== 1 /* EndOfFileToken */) {
	                        token = nextToken();
	                    }
	                    if (token === 18 /* CloseBraceToken */) {
	                        token = nextToken();
	                        if (token === 142 /* FromKeyword */) {
	                            token = nextToken();
	                            if (token === 9 /* StringLiteral */) {
	                                // export {a as A} from "mod";
	                                // export {a, b as B} from "mod"
	                                recordModuleName();
	                            }
	                        }
	                    }
	                }
	                else if (token === 39 /* AsteriskToken */) {
	                    token = nextToken();
	                    if (token === 142 /* FromKeyword */) {
	                        token = nextToken();
	                        if (token === 9 /* StringLiteral */) {
	                            // export * from "mod"
	                            recordModuleName();
	                        }
	                    }
	                }
	                else if (token === 91 /* ImportKeyword */) {
	                    token = nextToken();
	                    if (token === 71 /* Identifier */ || ts.isKeyword(token)) {
	                        token = nextToken();
	                        if (token === 58 /* EqualsToken */) {
	                            if (tryConsumeRequireCall(/*skipCurrentToken*/ true)) {
	                                return true;
	                            }
	                        }
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeRequireCall(skipCurrentToken) {
	            var token = skipCurrentToken ? nextToken() : ts.scanner.getToken();
	            if (token === 133 /* RequireKeyword */) {
	                token = nextToken();
	                if (token === 19 /* OpenParenToken */) {
	                    token = nextToken();
	                    if (token === 9 /* StringLiteral */) {
	                        //  require("mod");
	                        recordModuleName();
	                    }
	                }
	                return true;
	            }
	            return false;
	        }
	        function tryConsumeDefine() {
	            var token = ts.scanner.getToken();
	            if (token === 71 /* Identifier */ && ts.scanner.getTokenValue() === "define") {
	                token = nextToken();
	                if (token !== 19 /* OpenParenToken */) {
	                    return true;
	                }
	                token = nextToken();
	                if (token === 9 /* StringLiteral */) {
	                    // looks like define ("modname", ... - skip string literal and comma
	                    token = nextToken();
	                    if (token === 26 /* CommaToken */) {
	                        token = nextToken();
	                    }
	                    else {
	                        // unexpected token
	                        return true;
	                    }
	                }
	                // should be start of dependency list
	                if (token !== 21 /* OpenBracketToken */) {
	                    return true;
	                }
	                // skip open bracket
	                token = nextToken();
	                // scan until ']' or EOF
	                while (token !== 22 /* CloseBracketToken */ && token !== 1 /* EndOfFileToken */) {
	                    // record string literals as module names
	                    if (token === 9 /* StringLiteral */) {
	                        recordModuleName();
	                    }
	                    token = nextToken();
	                }
	                return true;
	            }
	            return false;
	        }
	        function processImports() {
	            ts.scanner.setText(sourceText);
	            nextToken();
	            // Look for:
	            //    import "mod";
	            //    import d from "mod"
	            //    import {a as A } from "mod";
	            //    import * as NS from "mod"
	            //    import d, {a, b as B} from "mod"
	            //    import i = require("mod");
	            //    import("mod");
	            //    export * from "mod"
	            //    export {a as b} from "mod"
	            //    export import i = require("mod")
	            //    (for JavaScript files) require("mod")
	            // Do not look for:
	            //    AnySymbol.import("mod")
	            //    AnySymbol.nested.import("mod")
	            while (true) {
	                if (ts.scanner.getToken() === 1 /* EndOfFileToken */) {
	                    break;
	                }
	                // check if at least one of alternative have moved scanner forward
	                if (tryConsumeDeclare() ||
	                    tryConsumeImport() ||
	                    tryConsumeExport() ||
	                    (detectJavaScriptImports && (tryConsumeRequireCall(/*skipCurrentToken*/ false) || tryConsumeDefine()))) {
	                    continue;
	                }
	                else {
	                    nextToken();
	                }
	            }
	            ts.scanner.setText(undefined);
	        }
	        if (readImportFiles) {
	            processImports();
	        }
	        ts.processCommentPragmas(pragmaContext, sourceText);
	        ts.processPragmasIntoFields(pragmaContext, ts.noop);
	        if (externalModule) {
	            // for external modules module all nested ambient modules are augmentations
	            if (ambientExternalModules) {
	                // move all detected ambient modules to imported files since they need to be resolved
	                for (var _i = 0, ambientExternalModules_1 = ambientExternalModules; _i < ambientExternalModules_1.length; _i++) {
	                    var decl = ambientExternalModules_1[_i];
	                    importedFiles.push(decl.ref);
	                }
	            }
	            return { referencedFiles: pragmaContext.referencedFiles, typeReferenceDirectives: pragmaContext.typeReferenceDirectives, importedFiles: importedFiles, isLibFile: pragmaContext.hasNoDefaultLib, ambientExternalModules: undefined };
	        }
	        else {
	            // for global scripts ambient modules still can have augmentations - look for ambient modules with depth > 0
	            var ambientModuleNames = void 0;
	            if (ambientExternalModules) {
	                for (var _a = 0, ambientExternalModules_2 = ambientExternalModules; _a < ambientExternalModules_2.length; _a++) {
	                    var decl = ambientExternalModules_2[_a];
	                    if (decl.depth === 0) {
	                        if (!ambientModuleNames) {
	                            ambientModuleNames = [];
	                        }
	                        ambientModuleNames.push(decl.ref.fileName);
	                    }
	                    else {
	                        importedFiles.push(decl.ref);
	                    }
	                }
	            }
	            return { referencedFiles: pragmaContext.referencedFiles, typeReferenceDirectives: pragmaContext.typeReferenceDirectives, importedFiles: importedFiles, isLibFile: pragmaContext.hasNoDefaultLib, ambientExternalModules: ambientModuleNames };
	        }
	    }
	    ts.preProcessFile = preProcessFile;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var Rename;
	    (function (Rename) {
	        function getRenameInfo(typeChecker, defaultLibFileName, getCanonicalFileName, sourceFile, position) {
	            var getCanonicalDefaultLibName = ts.memoize(function () { return getCanonicalFileName(ts.normalizePath(defaultLibFileName)); });
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            var renameInfo = node && nodeIsEligibleForRename(node)
	                ? getRenameInfoForNode(node, typeChecker, sourceFile, isDefinedInLibraryFile)
	                : undefined;
	            return renameInfo || getRenameInfoError(ts.Diagnostics.You_cannot_rename_this_element);
	            function isDefinedInLibraryFile(declaration) {
	                if (!defaultLibFileName) {
	                    return false;
	                }
	                var sourceFile = declaration.getSourceFile();
	                var canonicalName = getCanonicalFileName(ts.normalizePath(sourceFile.fileName));
	                return canonicalName === getCanonicalDefaultLibName();
	            }
	        }
	        Rename.getRenameInfo = getRenameInfo;
	        function getRenameInfoForNode(node, typeChecker, sourceFile, isDefinedInLibraryFile) {
	            var symbol = typeChecker.getSymbolAtLocation(node);
	            // Only allow a symbol to be renamed if it actually has at least one declaration.
	            if (symbol) {
	                var declarations = symbol.declarations;
	                if (declarations && declarations.length > 0) {
	                    // Disallow rename for elements that are defined in the standard TypeScript library.
	                    if (declarations.some(isDefinedInLibraryFile)) {
	                        return getRenameInfoError(ts.Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
	                    }
	                    // Cannot rename `default` as in `import { default as foo } from "./someModule";
	                    if (ts.isIdentifier(node) && node.originalKeywordKind === 79 /* DefaultKeyword */ && symbol.parent.flags & 1536 /* Module */) {
	                        return undefined;
	                    }
	                    // Can't rename a module name.
	                    if (ts.isStringLiteralLike(node) && ts.tryGetImportFromModuleSpecifier(node))
	                        return undefined;
	                    var kind = ts.SymbolDisplay.getSymbolKind(typeChecker, symbol, node);
	                    var specifierName = (ts.isImportOrExportSpecifierName(node) || ts.isStringOrNumericLiteral(node) && node.parent.kind === 146 /* ComputedPropertyName */)
	                        ? ts.stripQuotes(ts.getTextOfIdentifierOrLiteral(node))
	                        : undefined;
	                    var displayName = specifierName || typeChecker.symbolToString(symbol);
	                    var fullDisplayName = specifierName || typeChecker.getFullyQualifiedName(symbol);
	                    return getRenameInfoSuccess(displayName, fullDisplayName, kind, ts.SymbolDisplay.getSymbolModifiers(symbol), node, sourceFile);
	                }
	            }
	            else if (ts.isStringLiteral(node)) {
	                if (isDefinedInLibraryFile(node)) {
	                    return getRenameInfoError(ts.Diagnostics.You_cannot_rename_elements_that_are_defined_in_the_standard_TypeScript_library);
	                }
	                return getRenameInfoSuccess(node.text, node.text, "var" /* variableElement */, "" /* none */, node, sourceFile);
	            }
	        }
	        function getRenameInfoSuccess(displayName, fullDisplayName, kind, kindModifiers, node, sourceFile) {
	            return {
	                canRename: true,
	                kind: kind,
	                displayName: displayName,
	                localizedErrorMessage: undefined,
	                fullDisplayName: fullDisplayName,
	                kindModifiers: kindModifiers,
	                triggerSpan: createTriggerSpanForNode(node, sourceFile)
	            };
	        }
	        function getRenameInfoError(diagnostic) {
	            return {
	                canRename: false,
	                localizedErrorMessage: ts.getLocaleSpecificMessage(diagnostic),
	                displayName: undefined,
	                fullDisplayName: undefined,
	                kind: undefined,
	                kindModifiers: undefined,
	                triggerSpan: undefined
	            };
	        }
	        function createTriggerSpanForNode(node, sourceFile) {
	            var start = node.getStart(sourceFile);
	            var width = node.getWidth(sourceFile);
	            if (node.kind === 9 /* StringLiteral */) {
	                // Exclude the quotes
	                start += 1;
	                width -= 2;
	            }
	            return ts.createTextSpan(start, width);
	        }
	        function nodeIsEligibleForRename(node) {
	            switch (node.kind) {
	                case 71 /* Identifier */:
	                case 9 /* StringLiteral */:
	                case 99 /* ThisKeyword */:
	                    return true;
	                case 8 /* NumericLiteral */:
	                    return ts.isLiteralNameOfPropertyDeclarationOrIndexAccess(node);
	                default:
	                    return false;
	            }
	        }
	    })(Rename = ts.Rename || (ts.Rename = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var SignatureHelp;
	    (function (SignatureHelp) {
	        var ArgumentListKind;
	        (function (ArgumentListKind) {
	            ArgumentListKind[ArgumentListKind["TypeArguments"] = 0] = "TypeArguments";
	            ArgumentListKind[ArgumentListKind["CallArguments"] = 1] = "CallArguments";
	            ArgumentListKind[ArgumentListKind["TaggedTemplateArguments"] = 2] = "TaggedTemplateArguments";
	            ArgumentListKind[ArgumentListKind["JSXAttributesArguments"] = 3] = "JSXAttributesArguments";
	        })(ArgumentListKind = SignatureHelp.ArgumentListKind || (SignatureHelp.ArgumentListKind = {}));
	        function getSignatureHelpItems(program, sourceFile, position, cancellationToken) {
	            var typeChecker = program.getTypeChecker();
	            // Decide whether to show signature help
	            var startingToken = ts.findTokenOnLeftOfPosition(sourceFile, position);
	            if (!startingToken) {
	                // We are at the beginning of the file
	                return undefined;
	            }
	            var argumentInfo = getContainingArgumentInfo(startingToken, position, sourceFile);
	            if (!argumentInfo)
	                return undefined;
	            cancellationToken.throwIfCancellationRequested();
	            // Semantic filtering of signature help
	            var call = argumentInfo.invocation;
	            var candidates = [];
	            var resolvedSignature = typeChecker.getResolvedSignature(call, candidates, argumentInfo.argumentCount);
	            cancellationToken.throwIfCancellationRequested();
	            if (!candidates.length) {
	                // We didn't have any sig help items produced by the TS compiler.  If this is a JS
	                // file, then see if we can figure out anything better.
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    return createJavaScriptSignatureHelpItems(argumentInfo, program, cancellationToken);
	                }
	                return undefined;
	            }
	            return typeChecker.runWithCancellationToken(cancellationToken, function (typeChecker) { return createSignatureHelpItems(candidates, resolvedSignature, argumentInfo, typeChecker); });
	        }
	        SignatureHelp.getSignatureHelpItems = getSignatureHelpItems;
	        function createJavaScriptSignatureHelpItems(argumentInfo, program, cancellationToken) {
	            if (argumentInfo.invocation.kind !== 186 /* CallExpression */) {
	                return undefined;
	            }
	            // See if we can find some symbol with the call expression name that has call signatures.
	            var callExpression = argumentInfo.invocation;
	            var expression = callExpression.expression;
	            var name = ts.isIdentifier(expression) ? expression : ts.isPropertyAccessExpression(expression) ? expression.name : undefined;
	            if (!name || !name.escapedText) {
	                return undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                var nameToDeclarations = sourceFile.getNamedDeclarations();
	                var declarations = nameToDeclarations.get(name.text);
	                if (declarations) {
	                    var _loop_17 = function (declaration) {
	                        var symbol = declaration.symbol;
	                        if (symbol) {
	                            var type = typeChecker.getTypeOfSymbolAtLocation(symbol, declaration);
	                            if (type) {
	                                var callSignatures_1 = type.getCallSignatures();
	                                if (callSignatures_1 && callSignatures_1.length) {
	                                    return { value: typeChecker.runWithCancellationToken(cancellationToken, function (typeChecker) { return createSignatureHelpItems(callSignatures_1, callSignatures_1[0], argumentInfo, typeChecker); }) };
	                                }
	                            }
	                        }
	                    };
	                    for (var _b = 0, declarations_13 = declarations; _b < declarations_13.length; _b++) {
	                        var declaration = declarations_13[_b];
	                        var state_5 = _loop_17(declaration);
	                        if (typeof state_5 === "object")
	                            return state_5.value;
	                    }
	                }
	            }
	        }
	        /**
	         * Returns relevant information for the argument list and the current argument if we are
	         * in the argument of an invocation; returns undefined otherwise.
	         */
	        function getImmediatelyContainingArgumentInfo(node, position, sourceFile) {
	            if (ts.isCallOrNewExpression(node.parent)) {
	                var invocation = node.parent;
	                var list = void 0;
	                var argumentIndex = void 0;
	                // There are 3 cases to handle:
	                //   1. The token introduces a list, and should begin a signature help session
	                //   2. The token is either not associated with a list, or ends a list, so the session should end
	                //   3. The token is buried inside a list, and should give signature help
	                //
	                // The following are examples of each:
	                //
	                //    Case 1:
	                //          foo<#T, U>(#a, b)    -> The token introduces a list, and should begin a signature help session
	                //    Case 2:
	                //          fo#o<T, U>#(a, b)#   -> The token is either not associated with a list, or ends a list, so the session should end
	                //    Case 3:
	                //          foo<T#, U#>(a#, #b#) -> The token is buried inside a list, and should give signature help
	                // Find out if 'node' is an argument, a type argument, or neither
	                if (node.kind === 27 /* LessThanToken */ || node.kind === 19 /* OpenParenToken */) {
	                    // Find the list that starts right *after* the < or ( token.
	                    // If the user has just opened a list, consider this item 0.
	                    list = getChildListThatStartsWithOpenerToken(invocation, node, sourceFile);
	                    ts.Debug.assert(list !== undefined);
	                    argumentIndex = 0;
	                }
	                else {
	                    // findListItemInfo can return undefined if we are not in parent's argument list
	                    // or type argument list. This includes cases where the cursor is:
	                    //   - To the right of the closing parenthesis, non-substitution template, or template tail.
	                    //   - Between the type arguments and the arguments (greater than token)
	                    //   - On the target of the call (parent.func)
	                    //   - On the 'new' keyword in a 'new' expression
	                    list = ts.findContainingList(node);
	                    if (!list)
	                        return undefined;
	                    argumentIndex = getArgumentIndex(list, node);
	                }
	                var kind = invocation.typeArguments && invocation.typeArguments.pos === list.pos ? 0 /* TypeArguments */ : 1 /* CallArguments */;
	                var argumentCount = getArgumentCount(list);
	                if (argumentIndex !== 0) {
	                    ts.Debug.assertLessThan(argumentIndex, argumentCount);
	                }
	                var argumentsSpan = getApplicableSpanForArguments(list, sourceFile);
	                return { kind: kind, invocation: invocation, argumentsSpan: argumentsSpan, argumentIndex: argumentIndex, argumentCount: argumentCount };
	            }
	            else if (node.kind === 13 /* NoSubstitutionTemplateLiteral */ && node.parent.kind === 188 /* TaggedTemplateExpression */) {
	                // Check if we're actually inside the template;
	                // otherwise we'll fall out and return undefined.
	                if (ts.isInsideTemplateLiteral(node, position)) {
	                    return getArgumentListInfoForTemplate(node.parent, /*argumentIndex*/ 0, sourceFile);
	                }
	            }
	            else if (node.kind === 14 /* TemplateHead */ && node.parent.parent.kind === 188 /* TaggedTemplateExpression */) {
	                var templateExpression = node.parent;
	                var tagExpression = templateExpression.parent;
	                ts.Debug.assert(templateExpression.kind === 201 /* TemplateExpression */);
	                var argumentIndex = ts.isInsideTemplateLiteral(node, position) ? 0 : 1;
	                return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
	            }
	            else if (node.parent.kind === 210 /* TemplateSpan */ && node.parent.parent.parent.kind === 188 /* TaggedTemplateExpression */) {
	                var templateSpan = node.parent;
	                var templateExpression = templateSpan.parent;
	                var tagExpression = templateExpression.parent;
	                ts.Debug.assert(templateExpression.kind === 201 /* TemplateExpression */);
	                // If we're just after a template tail, don't show signature help.
	                if (node.kind === 16 /* TemplateTail */ && !ts.isInsideTemplateLiteral(node, position)) {
	                    return undefined;
	                }
	                var spanIndex = templateExpression.templateSpans.indexOf(templateSpan);
	                var argumentIndex = getArgumentIndexForTemplatePiece(spanIndex, node, position);
	                return getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile);
	            }
	            else if (node.parent && ts.isJsxOpeningLikeElement(node.parent)) {
	                // Provide a signature help for JSX opening element or JSX self-closing element.
	                // This is not guarantee that JSX tag-name is resolved into stateless function component. (that is done in "getSignatureHelpItems")
	                // i.e
	                //      export function MainButton(props: ButtonProps, context: any): JSX.Element { ... }
	                //      <MainButton /*signatureHelp*/
	                var attributeSpanStart = node.parent.attributes.getFullStart();
	                var attributeSpanEnd = ts.skipTrivia(sourceFile.text, node.parent.attributes.getEnd(), /*stopAfterLineBreak*/ false);
	                return {
	                    kind: 3 /* JSXAttributesArguments */,
	                    invocation: node.parent,
	                    argumentsSpan: ts.createTextSpan(attributeSpanStart, attributeSpanEnd - attributeSpanStart),
	                    argumentIndex: 0,
	                    argumentCount: 1
	                };
	            }
	            return undefined;
	        }
	        SignatureHelp.getImmediatelyContainingArgumentInfo = getImmediatelyContainingArgumentInfo;
	        function getArgumentIndex(argumentsList, node) {
	            // The list we got back can include commas.  In the presence of errors it may
	            // also just have nodes without commas.  For example "Foo(a b c)" will have 3
	            // args without commas. We want to find what index we're at.  So we count
	            // forward until we hit ourselves, only incrementing the index if it isn't a
	            // comma.
	            //
	            // Note: the subtlety around trailing commas (in getArgumentCount) does not apply
	            // here.  That's because we're only walking forward until we hit the node we're
	            // on.  In that case, even if we're after the trailing comma, we'll still see
	            // that trailing comma in the list, and we'll have generated the appropriate
	            // arg index.
	            var argumentIndex = 0;
	            for (var _i = 0, _a = argumentsList.getChildren(); _i < _a.length; _i++) {
	                var child = _a[_i];
	                if (child === node) {
	                    break;
	                }
	                if (child.kind !== 26 /* CommaToken */) {
	                    argumentIndex++;
	                }
	            }
	            return argumentIndex;
	        }
	        function getArgumentCount(argumentsList) {
	            // The argument count for a list is normally the number of non-comma children it has.
	            // For example, if you have "Foo(a,b)" then there will be three children of the arg
	            // list 'a' '<comma>' 'b'.  So, in this case the arg count will be 2.  However, there
	            // is a small subtlety.  If you have "Foo(a,)", then the child list will just have
	            // 'a' '<comma>'.  So, in the case where the last child is a comma, we increase the
	            // arg count by one to compensate.
	            //
	            // Note: this subtlety only applies to the last comma.  If you had "Foo(a,," then
	            // we'll have: 'a' '<comma>' '<missing>'
	            // That will give us 2 non-commas.  We then add one for the last comma, giving us an
	            // arg count of 3.
	            var listChildren = argumentsList.getChildren();
	            var argumentCount = ts.countWhere(listChildren, function (arg) { return arg.kind !== 26 /* CommaToken */; });
	            if (listChildren.length > 0 && ts.lastOrUndefined(listChildren).kind === 26 /* CommaToken */) {
	                argumentCount++;
	            }
	            return argumentCount;
	        }
	        // spanIndex is either the index for a given template span.
	        // This does not give appropriate results for a NoSubstitutionTemplateLiteral
	        function getArgumentIndexForTemplatePiece(spanIndex, node, position) {
	            // Because the TemplateStringsArray is the first argument, we have to offset each substitution expression by 1.
	            // There are three cases we can encounter:
	            //      1. We are precisely in the template literal (argIndex = 0).
	            //      2. We are in or to the right of the substitution expression (argIndex = spanIndex + 1).
	            //      3. We are directly to the right of the template literal, but because we look for the token on the left,
	            //          not enough to put us in the substitution expression; we should consider ourselves part of
	            //          the *next* span's expression by offsetting the index (argIndex = (spanIndex + 1) + 1).
	            //
	            // tslint:disable no-double-space
	            // Example: f  `# abcd $#{#  1 + 1#  }# efghi ${ #"#hello"#  }  #  `
	            //              ^       ^ ^       ^   ^          ^ ^      ^     ^
	            // Case:        1       1 3       2   1          3 2      2     1
	            // tslint:enable no-double-space
	            ts.Debug.assert(position >= node.getStart(), "Assumed 'position' could not occur before node.");
	            if (ts.isTemplateLiteralKind(node.kind)) {
	                if (ts.isInsideTemplateLiteral(node, position)) {
	                    return 0;
	                }
	                return spanIndex + 2;
	            }
	            return spanIndex + 1;
	        }
	        function getArgumentListInfoForTemplate(tagExpression, argumentIndex, sourceFile) {
	            // argumentCount is either 1 or (numSpans + 1) to account for the template strings array argument.
	            var argumentCount = ts.isNoSubstitutionTemplateLiteral(tagExpression.template) ? 1 : tagExpression.template.templateSpans.length + 1;
	            if (argumentIndex !== 0) {
	                ts.Debug.assertLessThan(argumentIndex, argumentCount);
	            }
	            return {
	                kind: 2 /* TaggedTemplateArguments */,
	                invocation: tagExpression,
	                argumentsSpan: getApplicableSpanForTaggedTemplate(tagExpression, sourceFile),
	                argumentIndex: argumentIndex,
	                argumentCount: argumentCount
	            };
	        }
	        function getApplicableSpanForArguments(argumentsList, sourceFile) {
	            // We use full start and skip trivia on the end because we want to include trivia on
	            // both sides. For example,
	            //
	            //    foo(   /*comment */     a, b, c      /*comment*/     )
	            //        |                                               |
	            //
	            // The applicable span is from the first bar to the second bar (inclusive,
	            // but not including parentheses)
	            var applicableSpanStart = argumentsList.getFullStart();
	            var applicableSpanEnd = ts.skipTrivia(sourceFile.text, argumentsList.getEnd(), /*stopAfterLineBreak*/ false);
	            return ts.createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
	        }
	        function getApplicableSpanForTaggedTemplate(taggedTemplate, sourceFile) {
	            var template = taggedTemplate.template;
	            var applicableSpanStart = template.getStart();
	            var applicableSpanEnd = template.getEnd();
	            // We need to adjust the end position for the case where the template does not have a tail.
	            // Otherwise, we will not show signature help past the expression.
	            // For example,
	            //
	            //      ` ${ 1 + 1 foo(10)
	            //       |       |
	            // This is because a Missing node has no width. However, what we actually want is to include trivia
	            // leading up to the next token in case the user is about to type in a TemplateMiddle or TemplateTail.
	            if (template.kind === 201 /* TemplateExpression */) {
	                var lastSpan = ts.lastOrUndefined(template.templateSpans);
	                if (lastSpan.literal.getFullWidth() === 0) {
	                    applicableSpanEnd = ts.skipTrivia(sourceFile.text, applicableSpanEnd, /*stopAfterLineBreak*/ false);
	                }
	            }
	            return ts.createTextSpan(applicableSpanStart, applicableSpanEnd - applicableSpanStart);
	        }
	        function getContainingArgumentInfo(node, position, sourceFile) {
	            for (var n = node; n.kind !== 273 /* SourceFile */; n = n.parent) {
	                if (ts.isFunctionBlock(n)) {
	                    return undefined;
	                }
	                // If the node is not a subspan of its parent, this is a big problem.
	                // There have been crashes that might be caused by this violation.
	                if (n.pos < n.parent.pos || n.end > n.parent.end) {
	                    ts.Debug.fail("Node of kind " + n.kind + " is not a subspan of its parent of kind " + n.parent.kind);
	                }
	                var argumentInfo = getImmediatelyContainingArgumentInfo(n, position, sourceFile);
	                if (argumentInfo) {
	                    return argumentInfo;
	                }
	                // TODO: Handle generic call with incomplete syntax
	            }
	            return undefined;
	        }
	        SignatureHelp.getContainingArgumentInfo = getContainingArgumentInfo;
	        function getChildListThatStartsWithOpenerToken(parent, openerToken, sourceFile) {
	            var children = parent.getChildren(sourceFile);
	            var indexOfOpenerToken = children.indexOf(openerToken);
	            ts.Debug.assert(indexOfOpenerToken >= 0 && children.length > indexOfOpenerToken + 1);
	            return children[indexOfOpenerToken + 1];
	        }
	        var signatureHelpNodeBuilderFlags = 8192 /* OmitParameterModifiers */ | 3112960 /* IgnoreErrors */ | 16384 /* UseAliasDefinedOutsideCurrentScope */;
	        function createSignatureHelpItems(candidates, resolvedSignature, argumentListInfo, typeChecker) {
	            var argumentCount = argumentListInfo.argumentCount, applicableSpan = argumentListInfo.argumentsSpan, invocation = argumentListInfo.invocation, argumentIndex = argumentListInfo.argumentIndex;
	            var isTypeParameterList = argumentListInfo.kind === 0 /* TypeArguments */;
	            var callTarget = ts.getInvokedExpression(invocation);
	            var callTargetSymbol = typeChecker.getSymbolAtLocation(callTarget);
	            var callTargetDisplayParts = callTargetSymbol && ts.symbolToDisplayParts(typeChecker, callTargetSymbol, /*enclosingDeclaration*/ undefined, /*meaning*/ undefined);
	            var printer = ts.createPrinter({ removeComments: true });
	            var items = ts.map(candidates, function (candidateSignature) {
	                var signatureHelpParameters;
	                var prefixDisplayParts = [];
	                var suffixDisplayParts = [];
	                if (callTargetDisplayParts) {
	                    ts.addRange(prefixDisplayParts, callTargetDisplayParts);
	                }
	                var isVariadic;
	                if (isTypeParameterList) {
	                    isVariadic = false; // type parameter lists are not variadic
	                    prefixDisplayParts.push(ts.punctuationPart(27 /* LessThanToken */));
	                    var typeParameters = (candidateSignature.target || candidateSignature).typeParameters;
	                    signatureHelpParameters = typeParameters && typeParameters.length > 0 ? ts.map(typeParameters, createSignatureHelpParameterForTypeParameter) : ts.emptyArray;
	                    suffixDisplayParts.push(ts.punctuationPart(29 /* GreaterThanToken */));
	                    var parameterParts = ts.mapToDisplayParts(function (writer) {
	                        var thisParameter = candidateSignature.thisParameter ? [typeChecker.symbolToParameterDeclaration(candidateSignature.thisParameter, invocation, signatureHelpNodeBuilderFlags)] : [];
	                        var params = ts.createNodeArray(thisParameter.concat(ts.map(candidateSignature.parameters, function (param) { return typeChecker.symbolToParameterDeclaration(param, invocation, signatureHelpNodeBuilderFlags); })));
	                        printer.writeList(1296 /* CallExpressionArguments */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                    });
	                    ts.addRange(suffixDisplayParts, parameterParts);
	                }
	                else {
	                    isVariadic = candidateSignature.hasRestParameter;
	                    var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                        if (candidateSignature.typeParameters && candidateSignature.typeParameters.length) {
	                            var args = ts.createNodeArray(ts.map(candidateSignature.typeParameters, function (p) { return typeChecker.typeParameterToDeclaration(p, invocation); }));
	                            printer.writeList(26896 /* TypeParameters */, args, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                        }
	                    });
	                    ts.addRange(prefixDisplayParts, typeParameterParts);
	                    prefixDisplayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                    signatureHelpParameters = ts.map(candidateSignature.parameters, createSignatureHelpParameterForParameter);
	                    suffixDisplayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                }
	                var returnTypeParts = ts.mapToDisplayParts(function (writer) {
	                    writer.writePunctuation(":");
	                    writer.writeSpace(" ");
	                    var predicate = typeChecker.getTypePredicateOfSignature(candidateSignature);
	                    if (predicate) {
	                        typeChecker.writeTypePredicate(predicate, invocation, /*flags*/ undefined, writer);
	                    }
	                    else {
	                        typeChecker.writeType(typeChecker.getReturnTypeOfSignature(candidateSignature), invocation, /*flags*/ undefined, writer);
	                    }
	                });
	                ts.addRange(suffixDisplayParts, returnTypeParts);
	                return {
	                    isVariadic: isVariadic,
	                    prefixDisplayParts: prefixDisplayParts,
	                    suffixDisplayParts: suffixDisplayParts,
	                    separatorDisplayParts: [ts.punctuationPart(26 /* CommaToken */), ts.spacePart()],
	                    parameters: signatureHelpParameters,
	                    documentation: candidateSignature.getDocumentationComment(typeChecker),
	                    tags: candidateSignature.getJsDocTags()
	                };
	            });
	            if (argumentIndex !== 0) {
	                ts.Debug.assertLessThan(argumentIndex, argumentCount);
	            }
	            var selectedItemIndex = candidates.indexOf(resolvedSignature);
	            ts.Debug.assert(selectedItemIndex !== -1); // If candidates is non-empty it should always include bestSignature. We check for an empty candidates before calling this function.
	            return { items: items, applicableSpan: applicableSpan, selectedItemIndex: selectedItemIndex, argumentIndex: argumentIndex, argumentCount: argumentCount };
	            function createSignatureHelpParameterForParameter(parameter) {
	                var displayParts = ts.mapToDisplayParts(function (writer) {
	                    var param = typeChecker.symbolToParameterDeclaration(parameter, invocation, signatureHelpNodeBuilderFlags);
	                    printer.writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                });
	                return {
	                    name: parameter.name,
	                    documentation: parameter.getDocumentationComment(typeChecker),
	                    displayParts: displayParts,
	                    isOptional: typeChecker.isOptionalParameter(parameter.valueDeclaration)
	                };
	            }
	            function createSignatureHelpParameterForTypeParameter(typeParameter) {
	                var displayParts = ts.mapToDisplayParts(function (writer) {
	                    var param = typeChecker.typeParameterToDeclaration(typeParameter, invocation);
	                    printer.writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(invocation)), writer);
	                });
	                return {
	                    name: typeParameter.symbol.name,
	                    documentation: ts.emptyArray,
	                    displayParts: displayParts,
	                    isOptional: false
	                };
	            }
	        }
	    })(SignatureHelp = ts.SignatureHelp || (ts.SignatureHelp = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    function computeSuggestionDiagnostics(sourceFile, program) {
	        program.getSemanticDiagnostics(sourceFile);
	        var checker = program.getDiagnosticsProducingTypeChecker();
	        var diags = [];
	        if (sourceFile.commonJsModuleIndicator &&
	            (ts.programContainsEs6Modules(program) || ts.compilerOptionsIndicateEs6Modules(program.getCompilerOptions())) &&
	            containsTopLevelCommonjs(sourceFile)) {
	            diags.push(ts.createDiagnosticForNode(getErrorNodeFromCommonJsIndicator(sourceFile.commonJsModuleIndicator), ts.Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES6_module));
	        }
	        var isJsFile = ts.isSourceFileJavaScript(sourceFile);
	        function check(node) {
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                    if (isJsFile) {
	                        var symbol = node.symbol;
	                        if (symbol.members && (symbol.members.size > 0)) {
	                            diags.push(ts.createDiagnosticForNode(ts.isVariableDeclaration(node.parent) ? node.parent.name : node, ts.Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration));
	                        }
	                    }
	                    break;
	            }
	            if (!isJsFile && ts.codefix.parameterShouldGetTypeFromJSDoc(node)) {
	                diags.push(ts.createDiagnosticForNode(node.name || node, ts.Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types));
	            }
	            node.forEachChild(check);
	        }
	        check(sourceFile);
	        if (!isJsFile) {
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                if (ts.isVariableStatement(statement) &&
	                    statement.declarationList.flags & 2 /* Const */ &&
	                    statement.declarationList.declarations.length === 1) {
	                    var init = statement.declarationList.declarations[0].initializer;
	                    if (init && ts.isRequireCall(init, /*checkArgumentIsStringLiteralLike*/ true)) {
	                        diags.push(ts.createDiagnosticForNode(init, ts.Diagnostics.require_call_may_be_converted_to_an_import));
	                    }
	                }
	            }
	        }
	        if (ts.getAllowSyntheticDefaultImports(program.getCompilerOptions())) {
	            for (var _b = 0, _c = sourceFile.imports; _b < _c.length; _b++) {
	                var moduleSpecifier = _c[_b];
	                var importNode = ts.importFromModuleSpecifier(moduleSpecifier);
	                var name = importNameForConvertToDefaultImport(importNode);
	                if (!name)
	                    continue;
	                var module_2 = ts.getResolvedModule(sourceFile, moduleSpecifier.text);
	                var resolvedFile = module_2 && program.getSourceFile(module_2.resolvedFileName);
	                if (resolvedFile && resolvedFile.externalModuleIndicator && ts.isExportAssignment(resolvedFile.externalModuleIndicator) && resolvedFile.externalModuleIndicator.isExportEquals) {
	                    diags.push(ts.createDiagnosticForNode(name, ts.Diagnostics.Import_may_be_converted_to_a_default_import));
	                }
	            }
	        }
	        ts.addRange(diags, sourceFile.bindSuggestionDiagnostics);
	        return diags.concat(checker.getSuggestionDiagnostics(sourceFile)).sort(function (d1, d2) { return d1.start - d2.start; });
	    }
	    ts.computeSuggestionDiagnostics = computeSuggestionDiagnostics;
	    // convertToEs6Module only works on top-level, so don't trigger it if commonjs code only appears in nested scopes.
	    function containsTopLevelCommonjs(sourceFile) {
	        return sourceFile.statements.some(function (statement) {
	            switch (statement.kind) {
	                case 213 /* VariableStatement */:
	                    return statement.declarationList.declarations.some(function (decl) {
	                        return ts.isRequireCall(propertyAccessLeftHandSide(decl.initializer), /*checkArgumentIsStringLiteralLike*/ true);
	                    });
	                case 215 /* ExpressionStatement */: {
	                    var expression = statement.expression;
	                    if (!ts.isBinaryExpression(expression))
	                        return ts.isRequireCall(expression, /*checkArgumentIsStringLiteralLike*/ true);
	                    var kind = ts.getSpecialPropertyAssignmentKind(expression);
	                    return kind === 1 /* ExportsProperty */ || kind === 2 /* ModuleExports */;
	                }
	                default:
	                    return false;
	            }
	        });
	    }
	    function propertyAccessLeftHandSide(node) {
	        return ts.isPropertyAccessExpression(node) ? propertyAccessLeftHandSide(node.expression) : node;
	    }
	    function importNameForConvertToDefaultImport(node) {
	        switch (node.kind) {
	            case 243 /* ImportDeclaration */:
	                var importClause = node.importClause, moduleSpecifier = node.moduleSpecifier;
	                return importClause && !importClause.name && importClause.namedBindings.kind === 245 /* NamespaceImport */ && ts.isStringLiteral(moduleSpecifier)
	                    ? importClause.namedBindings.name
	                    : undefined;
	            case 242 /* ImportEqualsDeclaration */:
	                return node.name;
	            default:
	                return undefined;
	        }
	    }
	    function getErrorNodeFromCommonJsIndicator(commonJsModuleIndicator) {
	        return ts.isBinaryExpression(commonJsModuleIndicator) ? commonJsModuleIndicator.left : commonJsModuleIndicator;
	    }
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var SymbolDisplay;
	    (function (SymbolDisplay) {
	        // TODO(drosen): use contextual SemanticMeaning.
	        function getSymbolKind(typeChecker, symbol, location) {
	            var result = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
	            if (result !== "" /* unknown */) {
	                return result;
	            }
	            var flags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            if (flags & 32 /* Class */) {
	                return ts.getDeclarationOfKind(symbol, 204 /* ClassExpression */) ?
	                    "local class" /* localClassElement */ : "class" /* classElement */;
	            }
	            if (flags & 384 /* Enum */)
	                return "enum" /* enumElement */;
	            if (flags & 524288 /* TypeAlias */)
	                return "type" /* typeElement */;
	            if (flags & 64 /* Interface */)
	                return "interface" /* interfaceElement */;
	            if (flags & 262144 /* TypeParameter */)
	                return "type parameter" /* typeParameterElement */;
	            if (flags & 262144 /* TypeParameter */)
	                return "type parameter" /* typeParameterElement */;
	            if (flags & 8 /* EnumMember */)
	                return "enum member" /* enumMemberElement */;
	            if (flags & 2097152 /* Alias */)
	                return "alias" /* alias */;
	            if (flags & 1536 /* Module */)
	                return "module" /* moduleElement */;
	            return result;
	        }
	        SymbolDisplay.getSymbolKind = getSymbolKind;
	        function getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location) {
	            var roots = typeChecker.getRootSymbols(symbol);
	            // If this is a method from a mapped type, leave as a method so long as it still has a call signature.
	            if (roots.length === 1
	                && ts.first(roots).flags & 8192 /* Method */
	                // Ensure the mapped version is still a method, as opposed to `{ [K in keyof I]: number }`.
	                && typeChecker.getTypeOfSymbolAtLocation(symbol, location).getNonNullableType().getCallSignatures().length !== 0) {
	                return "method" /* memberFunctionElement */;
	            }
	            if (typeChecker.isUndefinedSymbol(symbol)) {
	                return "var" /* variableElement */;
	            }
	            if (typeChecker.isArgumentsSymbol(symbol)) {
	                return "local var" /* localVariableElement */;
	            }
	            if (location.kind === 99 /* ThisKeyword */ && ts.isExpression(location)) {
	                return "parameter" /* parameterElement */;
	            }
	            var flags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            if (flags & 3 /* Variable */) {
	                if (ts.isFirstDeclarationOfSymbolParameter(symbol)) {
	                    return "parameter" /* parameterElement */;
	                }
	                else if (symbol.valueDeclaration && ts.isConst(symbol.valueDeclaration)) {
	                    return "const" /* constElement */;
	                }
	                else if (ts.forEach(symbol.declarations, ts.isLet)) {
	                    return "let" /* letElement */;
	                }
	                return isLocalVariableOrFunction(symbol) ? "local var" /* localVariableElement */ : "var" /* variableElement */;
	            }
	            if (flags & 16 /* Function */)
	                return isLocalVariableOrFunction(symbol) ? "local function" /* localFunctionElement */ : "function" /* functionElement */;
	            if (flags & 32768 /* GetAccessor */)
	                return "getter" /* memberGetAccessorElement */;
	            if (flags & 65536 /* SetAccessor */)
	                return "setter" /* memberSetAccessorElement */;
	            if (flags & 8192 /* Method */)
	                return "method" /* memberFunctionElement */;
	            if (flags & 16384 /* Constructor */)
	                return "constructor" /* constructorImplementationElement */;
	            if (flags & 4 /* Property */) {
	                if (flags & 33554432 /* Transient */ && symbol.checkFlags & 6 /* Synthetic */) {
	                    // If union property is result of union of non method (property/accessors/variables), it is labeled as property
	                    var unionPropertyKind = ts.forEach(typeChecker.getRootSymbols(symbol), function (rootSymbol) {
	                        var rootSymbolFlags = rootSymbol.getFlags();
	                        if (rootSymbolFlags & (98308 /* PropertyOrAccessor */ | 3 /* Variable */)) {
	                            return "property" /* memberVariableElement */;
	                        }
	                        // May be a Function if this was from `typeof N` with `namespace N { function f();. }`.
	                        ts.Debug.assert(!!(rootSymbolFlags & (8192 /* Method */ | 16 /* Function */)));
	                    });
	                    if (!unionPropertyKind) {
	                        // If this was union of all methods,
	                        // make sure it has call signatures before we can label it as method
	                        var typeOfUnionProperty = typeChecker.getTypeOfSymbolAtLocation(symbol, location);
	                        if (typeOfUnionProperty.getCallSignatures().length) {
	                            return "method" /* memberFunctionElement */;
	                        }
	                        return "property" /* memberVariableElement */;
	                    }
	                    return unionPropertyKind;
	                }
	                // If we requested completions after `x.` at the top-level, we may be at a source file location.
	                switch (location.parent && location.parent.kind) {
	                    // If we've typed a character of the attribute name, will be 'JsxAttribute', else will be 'JsxOpeningElement'.
	                    case 256 /* JsxOpeningElement */:
	                    case 254 /* JsxElement */:
	                    case 255 /* JsxSelfClosingElement */:
	                        return location.kind === 71 /* Identifier */ ? "property" /* memberVariableElement */ : "JSX attribute" /* jsxAttribute */;
	                    case 261 /* JsxAttribute */:
	                        return "JSX attribute" /* jsxAttribute */;
	                    default:
	                        return "property" /* memberVariableElement */;
	                }
	            }
	            return "" /* unknown */;
	        }
	        function getSymbolModifiers(symbol) {
	            var nodeModifiers = symbol && symbol.declarations && symbol.declarations.length > 0
	                ? ts.getNodeModifiers(symbol.declarations[0])
	                : "" /* none */;
	            var symbolModifiers = symbol && symbol.flags & 16777216 /* Optional */ ?
	                "optional" /* optionalModifier */
	                : "" /* none */;
	            return nodeModifiers && symbolModifiers ? nodeModifiers + "," + symbolModifiers : nodeModifiers || symbolModifiers;
	        }
	        SymbolDisplay.getSymbolModifiers = getSymbolModifiers;
	        // TODO(drosen): Currently completion entry details passes the SemanticMeaning.All instead of using semanticMeaning of location
	        function getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, enclosingDeclaration, location, semanticMeaning, alias) {
	            if (semanticMeaning === void 0) { semanticMeaning = ts.getMeaningFromLocation(location); }
	            var displayParts = [];
	            var documentation;
	            var tags;
	            var symbolFlags = ts.getCombinedLocalAndExportSymbolFlags(symbol);
	            var symbolKind = getSymbolKindOfConstructorPropertyMethodAccessorFunctionOrVar(typeChecker, symbol, location);
	            var hasAddedSymbolInfo;
	            var isThisExpression = location.kind === 99 /* ThisKeyword */ && ts.isExpression(location);
	            var type;
	            var printer;
	            var documentationFromAlias;
	            var tagsFromAlias;
	            // Class at constructor site need to be shown as constructor apart from property,method, vars
	            if (symbolKind !== "" /* unknown */ || symbolFlags & 32 /* Class */ || symbolFlags & 2097152 /* Alias */) {
	                // If it is accessor they are allowed only if location is at name of the accessor
	                if (symbolKind === "getter" /* memberGetAccessorElement */ || symbolKind === "setter" /* memberSetAccessorElement */) {
	                    symbolKind = "property" /* memberVariableElement */;
	                }
	                var signature = void 0;
	                type = isThisExpression ? typeChecker.getTypeAtLocation(location) : typeChecker.getTypeOfSymbolAtLocation(symbol.exportSymbol || symbol, location);
	                if (location.parent && location.parent.kind === 184 /* PropertyAccessExpression */) {
	                    var right = location.parent.name;
	                    // Either the location is on the right of a property access, or on the left and the right is missing
	                    if (right === location || (right && right.getFullWidth() === 0)) {
	                        location = location.parent;
	                    }
	                }
	                // try get the call/construct signature from the type if it matches
	                var callExpressionLike = void 0;
	                if (ts.isCallOrNewExpression(location)) {
	                    callExpressionLike = location;
	                }
	                else if (ts.isCallExpressionTarget(location) || ts.isNewExpressionTarget(location)) {
	                    callExpressionLike = location.parent;
	                }
	                else if (location.parent && ts.isJsxOpeningLikeElement(location.parent) && ts.isFunctionLike(symbol.valueDeclaration)) {
	                    callExpressionLike = location.parent;
	                }
	                if (callExpressionLike) {
	                    var candidateSignatures = [];
	                    signature = typeChecker.getResolvedSignature(callExpressionLike, candidateSignatures);
	                    var useConstructSignatures = callExpressionLike.kind === 187 /* NewExpression */ || (ts.isCallExpression(callExpressionLike) && callExpressionLike.expression.kind === 97 /* SuperKeyword */);
	                    var allSignatures = useConstructSignatures ? type.getConstructSignatures() : type.getCallSignatures();
	                    if (!ts.contains(allSignatures, signature.target) && !ts.contains(allSignatures, signature)) {
	                        // Get the first signature if there is one -- allSignatures may contain
	                        // either the original signature or its target, so check for either
	                        signature = allSignatures.length ? allSignatures[0] : undefined;
	                    }
	                    if (signature) {
	                        if (useConstructSignatures && (symbolFlags & 32 /* Class */)) {
	                            // Constructor
	                            symbolKind = "constructor" /* constructorImplementationElement */;
	                            addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
	                        }
	                        else if (symbolFlags & 2097152 /* Alias */) {
	                            symbolKind = "alias" /* alias */;
	                            pushSymbolKind(symbolKind);
	                            displayParts.push(ts.spacePart());
	                            if (useConstructSignatures) {
	                                displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                displayParts.push(ts.spacePart());
	                            }
	                            addFullSymbolName(symbol);
	                        }
	                        else {
	                            addPrefixForAnyFunctionOrVar(symbol, symbolKind);
	                        }
	                        switch (symbolKind) {
	                            case "JSX attribute" /* jsxAttribute */:
	                            case "property" /* memberVariableElement */:
	                            case "var" /* variableElement */:
	                            case "const" /* constElement */:
	                            case "let" /* letElement */:
	                            case "parameter" /* parameterElement */:
	                            case "local var" /* localVariableElement */:
	                                // If it is call or construct signature of lambda's write type name
	                                displayParts.push(ts.punctuationPart(56 /* ColonToken */));
	                                displayParts.push(ts.spacePart());
	                                if (!(ts.getObjectFlags(type) & 16 /* Anonymous */) && type.symbol) {
	                                    ts.addRange(displayParts, ts.symbolToDisplayParts(typeChecker, type.symbol, enclosingDeclaration, /*meaning*/ undefined, 4 /* AllowAnyNodeKind */ | 1 /* WriteTypeParametersOrArguments */));
	                                    displayParts.push(ts.lineBreakPart());
	                                }
	                                if (useConstructSignatures) {
	                                    displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                    displayParts.push(ts.spacePart());
	                                }
	                                addSignatureDisplayParts(signature, allSignatures, 262144 /* WriteArrowStyleSignature */);
	                                break;
	                            default:
	                                // Just signature
	                                addSignatureDisplayParts(signature, allSignatures);
	                        }
	                        hasAddedSymbolInfo = true;
	                    }
	                }
	                else if ((ts.isNameOfFunctionDeclaration(location) && !(symbolFlags & 98304 /* Accessor */)) || // name of function declaration
	                    (location.kind === 123 /* ConstructorKeyword */ && location.parent.kind === 154 /* Constructor */)) { // At constructor keyword of constructor declaration
	                    // get the signature from the declaration and write it
	                    var functionDeclaration_1 = location.parent;
	                    // Use function declaration to write the signatures only if the symbol corresponding to this declaration
	                    var locationIsSymbolDeclaration = ts.find(symbol.declarations, function (declaration) {
	                        return declaration === (location.kind === 123 /* ConstructorKeyword */ ? functionDeclaration_1.parent : functionDeclaration_1);
	                    });
	                    if (locationIsSymbolDeclaration) {
	                        var allSignatures = functionDeclaration_1.kind === 154 /* Constructor */ ? type.getNonNullableType().getConstructSignatures() : type.getNonNullableType().getCallSignatures();
	                        if (!typeChecker.isImplementationOfOverload(functionDeclaration_1)) {
	                            signature = typeChecker.getSignatureFromDeclaration(functionDeclaration_1);
	                        }
	                        else {
	                            signature = allSignatures[0];
	                        }
	                        if (functionDeclaration_1.kind === 154 /* Constructor */) {
	                            // show (constructor) Type(...) signature
	                            symbolKind = "constructor" /* constructorImplementationElement */;
	                            addPrefixForAnyFunctionOrVar(type.symbol, symbolKind);
	                        }
	                        else {
	                            // (function/method) symbol(..signature)
	                            addPrefixForAnyFunctionOrVar(functionDeclaration_1.kind === 157 /* CallSignature */ &&
	                                !(type.symbol.flags & 2048 /* TypeLiteral */ || type.symbol.flags & 4096 /* ObjectLiteral */) ? type.symbol : symbol, symbolKind);
	                        }
	                        addSignatureDisplayParts(signature, allSignatures);
	                        hasAddedSymbolInfo = true;
	                    }
	                }
	            }
	            if (symbolFlags & 32 /* Class */ && !hasAddedSymbolInfo && !isThisExpression) {
	                addAliasPrefixIfNecessary();
	                if (ts.getDeclarationOfKind(symbol, 204 /* ClassExpression */)) {
	                    // Special case for class expressions because we would like to indicate that
	                    // the class name is local to the class body (similar to function expression)
	                    //      (local class) class <className>
	                    pushSymbolKind("local class" /* localClassElement */);
	                }
	                else {
	                    // Class declaration has name which is not local.
	                    displayParts.push(ts.keywordPart(75 /* ClassKeyword */));
	                }
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	            }
	            if ((symbolFlags & 64 /* Interface */) && (semanticMeaning & 2 /* Type */)) {
	                prefixNextMeaning();
	                displayParts.push(ts.keywordPart(109 /* InterfaceKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	            }
	            if (symbolFlags & 524288 /* TypeAlias */) {
	                prefixNextMeaning();
	                displayParts.push(ts.keywordPart(139 /* TypeKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                writeTypeParametersOfSymbol(symbol, sourceFile);
	                displayParts.push(ts.spacePart());
	                displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                displayParts.push(ts.spacePart());
	                ts.addRange(displayParts, ts.typeToDisplayParts(typeChecker, typeChecker.getDeclaredTypeOfSymbol(symbol), enclosingDeclaration, 8388608 /* InTypeAlias */));
	            }
	            if (symbolFlags & 384 /* Enum */) {
	                prefixNextMeaning();
	                if (ts.forEach(symbol.declarations, ts.isConstEnumDeclaration)) {
	                    displayParts.push(ts.keywordPart(76 /* ConstKeyword */));
	                    displayParts.push(ts.spacePart());
	                }
	                displayParts.push(ts.keywordPart(83 /* EnumKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	            }
	            if (symbolFlags & 1536 /* Module */) {
	                prefixNextMeaning();
	                var declaration = ts.getDeclarationOfKind(symbol, 238 /* ModuleDeclaration */);
	                var isNamespace = declaration && declaration.name && declaration.name.kind === 71 /* Identifier */;
	                displayParts.push(ts.keywordPart(isNamespace ? 130 /* NamespaceKeyword */ : 129 /* ModuleKeyword */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	            }
	            if ((symbolFlags & 262144 /* TypeParameter */) && (semanticMeaning & 2 /* Type */)) {
	                prefixNextMeaning();
	                displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                displayParts.push(ts.textPart("type parameter"));
	                displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                if (symbol.parent) {
	                    // Class/Interface type parameter
	                    addInPrefix();
	                    addFullSymbolName(symbol.parent, enclosingDeclaration);
	                    writeTypeParametersOfSymbol(symbol.parent, enclosingDeclaration);
	                }
	                else {
	                    // Method/function type parameter
	                    var decl = ts.getDeclarationOfKind(symbol, 147 /* TypeParameter */);
	                    ts.Debug.assert(decl !== undefined);
	                    var declaration = decl.parent;
	                    if (declaration) {
	                        if (ts.isFunctionLikeKind(declaration.kind)) {
	                            addInPrefix();
	                            var signature = typeChecker.getSignatureFromDeclaration(declaration);
	                            if (declaration.kind === 158 /* ConstructSignature */) {
	                                displayParts.push(ts.keywordPart(94 /* NewKeyword */));
	                                displayParts.push(ts.spacePart());
	                            }
	                            else if (declaration.kind !== 157 /* CallSignature */ && declaration.name) {
	                                addFullSymbolName(declaration.symbol);
	                            }
	                            ts.addRange(displayParts, ts.signatureToDisplayParts(typeChecker, signature, sourceFile, 32 /* WriteTypeArgumentsOfSignature */));
	                        }
	                        else if (declaration.kind === 236 /* TypeAliasDeclaration */) {
	                            // Type alias type parameter
	                            // For example
	                            //      type list<T> = T[]; // Both T will go through same code path
	                            addInPrefix();
	                            displayParts.push(ts.keywordPart(139 /* TypeKeyword */));
	                            displayParts.push(ts.spacePart());
	                            addFullSymbolName(declaration.symbol);
	                            writeTypeParametersOfSymbol(declaration.symbol, sourceFile);
	                        }
	                    }
	                }
	            }
	            if (symbolFlags & 8 /* EnumMember */) {
	                symbolKind = "enum member" /* enumMemberElement */;
	                addPrefixForAnyFunctionOrVar(symbol, "enum member");
	                var declaration = symbol.declarations[0];
	                if (declaration.kind === 272 /* EnumMember */) {
	                    var constantValue = typeChecker.getConstantValue(declaration);
	                    if (constantValue !== undefined) {
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.displayPart(ts.getTextOfConstantValue(constantValue), typeof constantValue === "number" ? ts.SymbolDisplayPartKind.numericLiteral : ts.SymbolDisplayPartKind.stringLiteral));
	                    }
	                }
	            }
	            if (symbolFlags & 2097152 /* Alias */) {
	                prefixNextMeaning();
	                if (!hasAddedSymbolInfo) {
	                    var resolvedSymbol = typeChecker.getAliasedSymbol(symbol);
	                    if (resolvedSymbol !== symbol && resolvedSymbol.declarations && resolvedSymbol.declarations.length > 0) {
	                        var resolvedNode = resolvedSymbol.declarations[0];
	                        var declarationName = ts.getNameOfDeclaration(resolvedNode);
	                        if (declarationName) {
	                            var isExternalModuleDeclaration = ts.isModuleWithStringLiteralName(resolvedNode) &&
	                                ts.hasModifier(resolvedNode, 2 /* Ambient */);
	                            var shouldUseAliasName = symbol.name !== "default" && !isExternalModuleDeclaration;
	                            var resolvedInfo = getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, resolvedSymbol, ts.getSourceFileOfNode(resolvedNode), resolvedNode, declarationName, semanticMeaning, shouldUseAliasName ? symbol : resolvedSymbol);
	                            displayParts.push.apply(displayParts, resolvedInfo.displayParts);
	                            displayParts.push(ts.lineBreakPart());
	                            documentationFromAlias = resolvedInfo.documentation;
	                            tagsFromAlias = resolvedInfo.tags;
	                        }
	                    }
	                }
	                switch (symbol.declarations[0].kind) {
	                    case 241 /* NamespaceExportDeclaration */:
	                        displayParts.push(ts.keywordPart(84 /* ExportKeyword */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.keywordPart(130 /* NamespaceKeyword */));
	                        break;
	                    case 248 /* ExportAssignment */:
	                        displayParts.push(ts.keywordPart(84 /* ExportKeyword */));
	                        displayParts.push(ts.spacePart());
	                        displayParts.push(ts.keywordPart(symbol.declarations[0].isExportEquals ? 58 /* EqualsToken */ : 79 /* DefaultKeyword */));
	                        break;
	                    case 251 /* ExportSpecifier */:
	                        displayParts.push(ts.keywordPart(84 /* ExportKeyword */));
	                        break;
	                    default:
	                        displayParts.push(ts.keywordPart(91 /* ImportKeyword */));
	                }
	                displayParts.push(ts.spacePart());
	                addFullSymbolName(symbol);
	                ts.forEach(symbol.declarations, function (declaration) {
	                    if (declaration.kind === 242 /* ImportEqualsDeclaration */) {
	                        var importEqualsDeclaration = declaration;
	                        if (ts.isExternalModuleImportEqualsDeclaration(importEqualsDeclaration)) {
	                            displayParts.push(ts.spacePart());
	                            displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                            displayParts.push(ts.spacePart());
	                            displayParts.push(ts.keywordPart(133 /* RequireKeyword */));
	                            displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                            displayParts.push(ts.displayPart(ts.getTextOfNode(ts.getExternalModuleImportEqualsDeclarationExpression(importEqualsDeclaration)), ts.SymbolDisplayPartKind.stringLiteral));
	                            displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                        }
	                        else {
	                            var internalAliasSymbol = typeChecker.getSymbolAtLocation(importEqualsDeclaration.moduleReference);
	                            if (internalAliasSymbol) {
	                                displayParts.push(ts.spacePart());
	                                displayParts.push(ts.operatorPart(58 /* EqualsToken */));
	                                displayParts.push(ts.spacePart());
	                                addFullSymbolName(internalAliasSymbol, enclosingDeclaration);
	                            }
	                        }
	                        return true;
	                    }
	                });
	            }
	            if (!hasAddedSymbolInfo) {
	                if (symbolKind !== "" /* unknown */) {
	                    if (type) {
	                        if (isThisExpression) {
	                            prefixNextMeaning();
	                            displayParts.push(ts.keywordPart(99 /* ThisKeyword */));
	                        }
	                        else {
	                            addPrefixForAnyFunctionOrVar(symbol, symbolKind);
	                        }
	                        // For properties, variables and local vars: show the type
	                        if (symbolKind === "property" /* memberVariableElement */ ||
	                            symbolKind === "JSX attribute" /* jsxAttribute */ ||
	                            symbolFlags & 3 /* Variable */ ||
	                            symbolKind === "local var" /* localVariableElement */ ||
	                            isThisExpression) {
	                            displayParts.push(ts.punctuationPart(56 /* ColonToken */));
	                            displayParts.push(ts.spacePart());
	                            // If the type is type parameter, format it specially
	                            if (type.symbol && type.symbol.flags & 262144 /* TypeParameter */) {
	                                var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                                    var param = typeChecker.typeParameterToDeclaration(type, enclosingDeclaration);
	                                    getPrinter().writeNode(4 /* Unspecified */, param, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosingDeclaration)), writer);
	                                });
	                                ts.addRange(displayParts, typeParameterParts);
	                            }
	                            else {
	                                ts.addRange(displayParts, ts.typeToDisplayParts(typeChecker, type, enclosingDeclaration));
	                            }
	                        }
	                        else if (symbolFlags & 16 /* Function */ ||
	                            symbolFlags & 8192 /* Method */ ||
	                            symbolFlags & 16384 /* Constructor */ ||
	                            symbolFlags & 131072 /* Signature */ ||
	                            symbolFlags & 98304 /* Accessor */ ||
	                            symbolKind === "method" /* memberFunctionElement */) {
	                            var allSignatures = type.getNonNullableType().getCallSignatures();
	                            if (allSignatures.length) {
	                                addSignatureDisplayParts(allSignatures[0], allSignatures);
	                            }
	                        }
	                    }
	                }
	                else {
	                    symbolKind = getSymbolKind(typeChecker, symbol, location);
	                }
	            }
	            if (!documentation) {
	                documentation = symbol.getDocumentationComment(typeChecker);
	                tags = symbol.getJsDocTags();
	                if (documentation.length === 0 && symbolFlags & 4 /* Property */) {
	                    // For some special property access expressions like `exports.foo = foo` or `module.exports.foo = foo`
	                    // there documentation comments might be attached to the right hand side symbol of their declarations.
	                    // The pattern of such special property access is that the parent symbol is the symbol of the file.
	                    if (symbol.parent && ts.forEach(symbol.parent.declarations, function (declaration) { return declaration.kind === 273 /* SourceFile */; })) {
	                        for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                            var declaration = _a[_i];
	                            if (!declaration.parent || declaration.parent.kind !== 199 /* BinaryExpression */) {
	                                continue;
	                            }
	                            var rhsSymbol = typeChecker.getSymbolAtLocation(declaration.parent.right);
	                            if (!rhsSymbol) {
	                                continue;
	                            }
	                            documentation = rhsSymbol.getDocumentationComment(typeChecker);
	                            tags = rhsSymbol.getJsDocTags();
	                            if (documentation.length > 0) {
	                                break;
	                            }
	                        }
	                    }
	                }
	            }
	            if (documentation.length === 0 && documentationFromAlias) {
	                documentation = documentationFromAlias;
	            }
	            if (tags.length === 0 && tagsFromAlias) {
	                tags = tagsFromAlias;
	            }
	            return { displayParts: displayParts, documentation: documentation, symbolKind: symbolKind, tags: tags };
	            function getPrinter() {
	                if (!printer) {
	                    printer = ts.createPrinter({ removeComments: true });
	                }
	                return printer;
	            }
	            function prefixNextMeaning() {
	                if (displayParts.length) {
	                    displayParts.push(ts.lineBreakPart());
	                }
	                addAliasPrefixIfNecessary();
	            }
	            function addAliasPrefixIfNecessary() {
	                if (alias) {
	                    pushSymbolKind("alias" /* alias */);
	                    displayParts.push(ts.spacePart());
	                }
	            }
	            function addInPrefix() {
	                displayParts.push(ts.spacePart());
	                displayParts.push(ts.keywordPart(92 /* InKeyword */));
	                displayParts.push(ts.spacePart());
	            }
	            function addFullSymbolName(symbolToDisplay, enclosingDeclaration) {
	                if (alias && symbolToDisplay === symbol) {
	                    symbolToDisplay = alias;
	                }
	                var fullSymbolDisplayParts = ts.symbolToDisplayParts(typeChecker, symbolToDisplay, enclosingDeclaration || sourceFile, /*meaning*/ undefined, 1 /* WriteTypeParametersOrArguments */ | 2 /* UseOnlyExternalAliasing */ | 4 /* AllowAnyNodeKind */);
	                ts.addRange(displayParts, fullSymbolDisplayParts);
	                if (symbol.flags & 16777216 /* Optional */) {
	                    displayParts.push(ts.punctuationPart(55 /* QuestionToken */));
	                }
	            }
	            function addPrefixForAnyFunctionOrVar(symbol, symbolKind) {
	                prefixNextMeaning();
	                if (symbolKind) {
	                    pushSymbolKind(symbolKind);
	                    if (symbol && !ts.some(symbol.declarations, function (d) { return ts.isArrowFunction(d) || (ts.isFunctionExpression(d) || ts.isClassExpression(d)) && !d.name; })) {
	                        displayParts.push(ts.spacePart());
	                        addFullSymbolName(symbol);
	                    }
	                }
	            }
	            function pushSymbolKind(symbolKind) {
	                switch (symbolKind) {
	                    case "var" /* variableElement */:
	                    case "function" /* functionElement */:
	                    case "let" /* letElement */:
	                    case "const" /* constElement */:
	                    case "constructor" /* constructorImplementationElement */:
	                        displayParts.push(ts.textOrKeywordPart(symbolKind));
	                        return;
	                    default:
	                        displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                        displayParts.push(ts.textOrKeywordPart(symbolKind));
	                        displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                        return;
	                }
	            }
	            function addSignatureDisplayParts(signature, allSignatures, flags) {
	                ts.addRange(displayParts, ts.signatureToDisplayParts(typeChecker, signature, enclosingDeclaration, flags | 32 /* WriteTypeArgumentsOfSignature */));
	                if (allSignatures.length > 1) {
	                    displayParts.push(ts.spacePart());
	                    displayParts.push(ts.punctuationPart(19 /* OpenParenToken */));
	                    displayParts.push(ts.operatorPart(37 /* PlusToken */));
	                    displayParts.push(ts.displayPart((allSignatures.length - 1).toString(), ts.SymbolDisplayPartKind.numericLiteral));
	                    displayParts.push(ts.spacePart());
	                    displayParts.push(ts.textPart(allSignatures.length === 2 ? "overload" : "overloads"));
	                    displayParts.push(ts.punctuationPart(20 /* CloseParenToken */));
	                }
	                documentation = signature.getDocumentationComment(typeChecker);
	                tags = signature.getJsDocTags();
	            }
	            function writeTypeParametersOfSymbol(symbol, enclosingDeclaration) {
	                var typeParameterParts = ts.mapToDisplayParts(function (writer) {
	                    var params = typeChecker.symbolToTypeParameterDeclarations(symbol, enclosingDeclaration);
	                    getPrinter().writeList(26896 /* TypeParameters */, params, ts.getSourceFileOfNode(ts.getParseTreeNode(enclosingDeclaration)), writer);
	                });
	                ts.addRange(displayParts, typeParameterParts);
	            }
	        }
	        SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind = getSymbolDisplayPartsDocumentationAndSymbolKind;
	        function isLocalVariableOrFunction(symbol) {
	            if (symbol.parent) {
	                return false; // This is exported symbol
	            }
	            return ts.forEach(symbol.declarations, function (declaration) {
	                // Function expressions are local
	                if (declaration.kind === 191 /* FunctionExpression */) {
	                    return true;
	                }
	                if (declaration.kind !== 231 /* VariableDeclaration */ && declaration.kind !== 233 /* FunctionDeclaration */) {
	                    return false;
	                }
	                // If the parent is not sourceFile or module block it is local variable
	                for (var parent = declaration.parent; !ts.isFunctionBlock(parent); parent = parent.parent) {
	                    // Reached source file or module block
	                    if (parent.kind === 273 /* SourceFile */ || parent.kind === 239 /* ModuleBlock */) {
	                        return false;
	                    }
	                }
	                // parent is in function block
	                return true;
	            });
	        }
	    })(SymbolDisplay = ts.SymbolDisplay || (ts.SymbolDisplay = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /*
	     * This function will compile source text from 'input' argument using specified compiler options.
	     * If not options are provided - it will use a set of default compiler options.
	     * Extra compiler options that will unconditionally be used by this function are:
	     * - isolatedModules = true
	     * - allowNonTsExtensions = true
	     * - noLib = true
	     * - noResolve = true
	     */
	    function transpileModule(input, transpileOptions) {
	        var diagnostics = [];
	        var options = transpileOptions.compilerOptions ? fixupCompilerOptions(transpileOptions.compilerOptions, diagnostics) : ts.getDefaultCompilerOptions();
	        options.isolatedModules = true;
	        // transpileModule does not write anything to disk so there is no need to verify that there are no conflicts between input and output paths.
	        options.suppressOutputPathCheck = true;
	        // Filename can be non-ts file.
	        options.allowNonTsExtensions = true;
	        // We are not returning a sourceFile for lib file when asked by the program,
	        // so pass --noLib to avoid reporting a file not found error.
	        options.noLib = true;
	        // Clear out other settings that would not be used in transpiling this module
	        options.lib = undefined;
	        options.types = undefined;
	        options.noEmit = undefined;
	        options.noEmitOnError = undefined;
	        options.paths = undefined;
	        options.rootDirs = undefined;
	        options.declaration = undefined;
	        options.declarationDir = undefined;
	        options.out = undefined;
	        options.outFile = undefined;
	        // We are not doing a full typecheck, we are not resolving the whole context,
	        // so pass --noResolve to avoid reporting missing file errors.
	        options.noResolve = true;
	        // if jsx is specified then treat file as .tsx
	        var inputFileName = transpileOptions.fileName || (options.jsx ? "module.tsx" : "module.ts");
	        var sourceFile = ts.createSourceFile(inputFileName, input, options.target);
	        if (transpileOptions.moduleName) {
	            sourceFile.moduleName = transpileOptions.moduleName;
	        }
	        if (transpileOptions.renamedDependencies) {
	            sourceFile.renamedDependencies = ts.createMapFromTemplate(transpileOptions.renamedDependencies);
	        }
	        var newLine = ts.getNewLineCharacter(options);
	        // Output
	        var outputText;
	        var sourceMapText;
	        // Create a compilerHost object to allow the compiler to read and write files
	        var compilerHost = {
	            getSourceFile: function (fileName) { return fileName === ts.normalizePath(inputFileName) ? sourceFile : undefined; },
	            writeFile: function (name, text) {
	                if (ts.fileExtensionIs(name, ".map")) {
	                    ts.Debug.assertEqual(sourceMapText, undefined, "Unexpected multiple source map outputs, file:", name);
	                    sourceMapText = text;
	                }
	                else {
	                    ts.Debug.assertEqual(outputText, undefined, "Unexpected multiple outputs, file:", name);
	                    outputText = text;
	                }
	            },
	            getDefaultLibFileName: function () { return "lib.d.ts"; },
	            useCaseSensitiveFileNames: function () { return false; },
	            getCanonicalFileName: function (fileName) { return fileName; },
	            getCurrentDirectory: function () { return ""; },
	            getNewLine: function () { return newLine; },
	            fileExists: function (fileName) { return fileName === inputFileName; },
	            readFile: function () { return ""; },
	            directoryExists: function () { return true; },
	            getDirectories: function () { return []; }
	        };
	        var program = ts.createProgram([inputFileName], options, compilerHost);
	        if (transpileOptions.reportDiagnostics) {
	            ts.addRange(/*to*/ diagnostics, /*from*/ program.getSyntacticDiagnostics(sourceFile));
	            ts.addRange(/*to*/ diagnostics, /*from*/ program.getOptionsDiagnostics());
	        }
	        // Emit
	        program.emit(/*targetSourceFile*/ undefined, /*writeFile*/ undefined, /*cancellationToken*/ undefined, /*emitOnlyDtsFiles*/ undefined, transpileOptions.transformers);
	        ts.Debug.assert(outputText !== undefined, "Output generation failed");
	        return { outputText: outputText, diagnostics: diagnostics, sourceMapText: sourceMapText };
	    }
	    ts.transpileModule = transpileModule;
	    /*
	     * This is a shortcut function for transpileModule - it accepts transpileOptions as parameters and returns only outputText part of the result.
	     */
	    function transpile(input, compilerOptions, fileName, diagnostics, moduleName) {
	        var output = transpileModule(input, { compilerOptions: compilerOptions, fileName: fileName, reportDiagnostics: !!diagnostics, moduleName: moduleName });
	        // addRange correctly handles cases when wither 'from' or 'to' argument is missing
	        ts.addRange(diagnostics, output.diagnostics);
	        return output.outputText;
	    }
	    ts.transpile = transpile;
	    var commandLineOptionsStringToEnum;
	    /** JS users may pass in string values for enum compiler options (such as ModuleKind), so convert. */
	    /*@internal*/
	    function fixupCompilerOptions(options, diagnostics) {
	        // Lazily create this value to fix module loading errors.
	        commandLineOptionsStringToEnum = commandLineOptionsStringToEnum || ts.filter(ts.optionDeclarations, function (o) {
	            return typeof o.type === "object" && !ts.forEachEntry(o.type, function (v) { return typeof v !== "number"; });
	        });
	        options = ts.cloneCompilerOptions(options);
	        var _loop_18 = function (opt) {
	            if (!ts.hasProperty(options, opt.name)) {
	                return "continue";
	            }
	            var value = options[opt.name];
	            // Value should be a key of opt.type
	            if (ts.isString(value)) {
	                // If value is not a string, this will fail
	                options[opt.name] = ts.parseCustomTypeOption(opt, value, diagnostics);
	            }
	            else {
	                if (!ts.forEachEntry(opt.type, function (v) { return v === value; })) {
	                    // Supplied value isn't a valid enum value.
	                    diagnostics.push(ts.createCompilerDiagnosticForInvalidCustomType(opt));
	                }
	            }
	        };
	        for (var _i = 0, commandLineOptionsStringToEnum_1 = commandLineOptionsStringToEnum; _i < commandLineOptionsStringToEnum_1.length; _i++) {
	            var opt = commandLineOptionsStringToEnum_1[_i];
	            _loop_18(opt);
	        }
	        return options;
	    }
	    ts.fixupCompilerOptions = fixupCompilerOptions;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var FormattingRequestKind;
	        (function (FormattingRequestKind) {
	            FormattingRequestKind[FormattingRequestKind["FormatDocument"] = 0] = "FormatDocument";
	            FormattingRequestKind[FormattingRequestKind["FormatSelection"] = 1] = "FormatSelection";
	            FormattingRequestKind[FormattingRequestKind["FormatOnEnter"] = 2] = "FormatOnEnter";
	            FormattingRequestKind[FormattingRequestKind["FormatOnSemicolon"] = 3] = "FormatOnSemicolon";
	            FormattingRequestKind[FormattingRequestKind["FormatOnOpeningCurlyBrace"] = 4] = "FormatOnOpeningCurlyBrace";
	            FormattingRequestKind[FormattingRequestKind["FormatOnClosingCurlyBrace"] = 5] = "FormatOnClosingCurlyBrace";
	        })(FormattingRequestKind = formatting.FormattingRequestKind || (formatting.FormattingRequestKind = {}));
	        var FormattingContext = /** @class */ (function () {
	            function FormattingContext(sourceFile, formattingRequestKind, options) {
	                this.sourceFile = sourceFile;
	                this.formattingRequestKind = formattingRequestKind;
	                this.options = options;
	            }
	            FormattingContext.prototype.updateContext = function (currentRange, currentTokenParent, nextRange, nextTokenParent, commonParent) {
	                ts.Debug.assert(currentRange !== undefined, "currentTokenSpan is null");
	                ts.Debug.assert(currentTokenParent !== undefined, "currentTokenParent is null");
	                ts.Debug.assert(nextRange !== undefined, "nextTokenSpan is null");
	                ts.Debug.assert(nextTokenParent !== undefined, "nextTokenParent is null");
	                ts.Debug.assert(commonParent !== undefined, "commonParent is null");
	                this.currentTokenSpan = currentRange;
	                this.currentTokenParent = currentTokenParent;
	                this.nextTokenSpan = nextRange;
	                this.nextTokenParent = nextTokenParent;
	                this.contextNode = commonParent;
	                // drop cached results
	                this.contextNodeAllOnSameLine = undefined;
	                this.nextNodeAllOnSameLine = undefined;
	                this.tokensAreOnSameLine = undefined;
	                this.contextNodeBlockIsOnOneLine = undefined;
	                this.nextNodeBlockIsOnOneLine = undefined;
	            };
	            FormattingContext.prototype.ContextNodeAllOnSameLine = function () {
	                if (this.contextNodeAllOnSameLine === undefined) {
	                    this.contextNodeAllOnSameLine = this.NodeIsOnOneLine(this.contextNode);
	                }
	                return this.contextNodeAllOnSameLine;
	            };
	            FormattingContext.prototype.NextNodeAllOnSameLine = function () {
	                if (this.nextNodeAllOnSameLine === undefined) {
	                    this.nextNodeAllOnSameLine = this.NodeIsOnOneLine(this.nextTokenParent);
	                }
	                return this.nextNodeAllOnSameLine;
	            };
	            FormattingContext.prototype.TokensAreOnSameLine = function () {
	                if (this.tokensAreOnSameLine === undefined) {
	                    var startLine = this.sourceFile.getLineAndCharacterOfPosition(this.currentTokenSpan.pos).line;
	                    var endLine = this.sourceFile.getLineAndCharacterOfPosition(this.nextTokenSpan.pos).line;
	                    this.tokensAreOnSameLine = (startLine === endLine);
	                }
	                return this.tokensAreOnSameLine;
	            };
	            FormattingContext.prototype.ContextNodeBlockIsOnOneLine = function () {
	                if (this.contextNodeBlockIsOnOneLine === undefined) {
	                    this.contextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.contextNode);
	                }
	                return this.contextNodeBlockIsOnOneLine;
	            };
	            FormattingContext.prototype.NextNodeBlockIsOnOneLine = function () {
	                if (this.nextNodeBlockIsOnOneLine === undefined) {
	                    this.nextNodeBlockIsOnOneLine = this.BlockIsOnOneLine(this.nextTokenParent);
	                }
	                return this.nextNodeBlockIsOnOneLine;
	            };
	            FormattingContext.prototype.NodeIsOnOneLine = function (node) {
	                var startLine = this.sourceFile.getLineAndCharacterOfPosition(node.getStart(this.sourceFile)).line;
	                var endLine = this.sourceFile.getLineAndCharacterOfPosition(node.getEnd()).line;
	                return startLine === endLine;
	            };
	            FormattingContext.prototype.BlockIsOnOneLine = function (node) {
	                var openBrace = ts.findChildOfKind(node, 17 /* OpenBraceToken */, this.sourceFile);
	                var closeBrace = ts.findChildOfKind(node, 18 /* CloseBraceToken */, this.sourceFile);
	                if (openBrace && closeBrace) {
	                    var startLine = this.sourceFile.getLineAndCharacterOfPosition(openBrace.getEnd()).line;
	                    var endLine = this.sourceFile.getLineAndCharacterOfPosition(closeBrace.getStart(this.sourceFile)).line;
	                    return startLine === endLine;
	                }
	                return false;
	            };
	            return FormattingContext;
	        }());
	        formatting.FormattingContext = FormattingContext;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var standardScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, 0 /* Standard */);
	        var jsxScanner = ts.createScanner(6 /* Latest */, /*skipTrivia*/ false, 1 /* JSX */);
	        var ScanAction;
	        (function (ScanAction) {
	            ScanAction[ScanAction["Scan"] = 0] = "Scan";
	            ScanAction[ScanAction["RescanGreaterThanToken"] = 1] = "RescanGreaterThanToken";
	            ScanAction[ScanAction["RescanSlashToken"] = 2] = "RescanSlashToken";
	            ScanAction[ScanAction["RescanTemplateToken"] = 3] = "RescanTemplateToken";
	            ScanAction[ScanAction["RescanJsxIdentifier"] = 4] = "RescanJsxIdentifier";
	            ScanAction[ScanAction["RescanJsxText"] = 5] = "RescanJsxText";
	        })(ScanAction || (ScanAction = {}));
	        function getFormattingScanner(text, languageVariant, startPos, endPos, cb) {
	            var scanner = languageVariant === 1 /* JSX */ ? jsxScanner : standardScanner;
	            scanner.setText(text);
	            scanner.setTextPos(startPos);
	            var wasNewLine = true;
	            var leadingTrivia;
	            var trailingTrivia;
	            var savedPos;
	            var lastScanAction;
	            var lastTokenInfo;
	            var res = cb({
	                advance: advance,
	                readTokenInfo: readTokenInfo,
	                isOnToken: isOnToken,
	                getCurrentLeadingTrivia: function () { return leadingTrivia; },
	                lastTrailingTriviaWasNewLine: function () { return wasNewLine; },
	                skipToEndOf: skipToEndOf,
	            });
	            lastTokenInfo = undefined;
	            scanner.setText(undefined);
	            return res;
	            function advance() {
	                lastTokenInfo = undefined;
	                var isStarted = scanner.getStartPos() !== startPos;
	                if (isStarted) {
	                    wasNewLine = trailingTrivia && ts.lastOrUndefined(trailingTrivia).kind === 4 /* NewLineTrivia */;
	                }
	                else {
	                    scanner.scan();
	                }
	                leadingTrivia = undefined;
	                trailingTrivia = undefined;
	                var pos = scanner.getStartPos();
	                // Read leading trivia and token
	                while (pos < endPos) {
	                    var t = scanner.getToken();
	                    if (!ts.isTrivia(t)) {
	                        break;
	                    }
	                    // consume leading trivia
	                    scanner.scan();
	                    var item = {
	                        pos: pos,
	                        end: scanner.getStartPos(),
	                        kind: t
	                    };
	                    pos = scanner.getStartPos();
	                    leadingTrivia = ts.append(leadingTrivia, item);
	                }
	                savedPos = scanner.getStartPos();
	            }
	            function shouldRescanGreaterThanToken(node) {
	                switch (node.kind) {
	                    case 31 /* GreaterThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    case 46 /* GreaterThanGreaterThanToken */:
	                        return true;
	                }
	                return false;
	            }
	            function shouldRescanJsxIdentifier(node) {
	                if (node.parent) {
	                    switch (node.parent.kind) {
	                        case 261 /* JsxAttribute */:
	                        case 256 /* JsxOpeningElement */:
	                        case 257 /* JsxClosingElement */:
	                        case 255 /* JsxSelfClosingElement */:
	                            // May parse an identifier like `module-layout`; that will be scanned as a keyword at first, but we should parse the whole thing to get an identifier.
	                            return ts.isKeyword(node.kind) || node.kind === 71 /* Identifier */;
	                    }
	                }
	                return false;
	            }
	            function shouldRescanJsxText(node) {
	                return node.kind === 10 /* JsxText */;
	            }
	            function shouldRescanSlashToken(container) {
	                return container.kind === 12 /* RegularExpressionLiteral */;
	            }
	            function shouldRescanTemplateToken(container) {
	                return container.kind === 15 /* TemplateMiddle */ ||
	                    container.kind === 16 /* TemplateTail */;
	            }
	            function startsWithSlashToken(t) {
	                return t === 41 /* SlashToken */ || t === 63 /* SlashEqualsToken */;
	            }
	            function readTokenInfo(n) {
	                ts.Debug.assert(isOnToken());
	                // normally scanner returns the smallest available token
	                // check the kind of context node to determine if scanner should have more greedy behavior and consume more text.
	                var expectedScanAction = shouldRescanGreaterThanToken(n)
	                    ? 1 /* RescanGreaterThanToken */
	                    : shouldRescanSlashToken(n)
	                        ? 2 /* RescanSlashToken */
	                        : shouldRescanTemplateToken(n)
	                            ? 3 /* RescanTemplateToken */
	                            : shouldRescanJsxIdentifier(n)
	                                ? 4 /* RescanJsxIdentifier */
	                                : shouldRescanJsxText(n)
	                                    ? 5 /* RescanJsxText */
	                                    : 0 /* Scan */;
	                if (lastTokenInfo && expectedScanAction === lastScanAction) {
	                    // readTokenInfo was called before with the same expected scan action.
	                    // No need to re-scan text, return existing 'lastTokenInfo'
	                    // it is ok to call fixTokenKind here since it does not affect
	                    // what portion of text is consumed. In contrast rescanning can change it,
	                    // i.e. for '>=' when originally scanner eats just one character
	                    // and rescanning forces it to consume more.
	                    return fixTokenKind(lastTokenInfo, n);
	                }
	                if (scanner.getStartPos() !== savedPos) {
	                    ts.Debug.assert(lastTokenInfo !== undefined);
	                    // readTokenInfo was called before but scan action differs - rescan text
	                    scanner.setTextPos(savedPos);
	                    scanner.scan();
	                }
	                var currentToken = getNextToken(n, expectedScanAction);
	                var token = {
	                    pos: scanner.getStartPos(),
	                    end: scanner.getTextPos(),
	                    kind: currentToken
	                };
	                // consume trailing trivia
	                if (trailingTrivia) {
	                    trailingTrivia = undefined;
	                }
	                while (scanner.getStartPos() < endPos) {
	                    currentToken = scanner.scan();
	                    if (!ts.isTrivia(currentToken)) {
	                        break;
	                    }
	                    var trivia = {
	                        pos: scanner.getStartPos(),
	                        end: scanner.getTextPos(),
	                        kind: currentToken
	                    };
	                    if (!trailingTrivia) {
	                        trailingTrivia = [];
	                    }
	                    trailingTrivia.push(trivia);
	                    if (currentToken === 4 /* NewLineTrivia */) {
	                        // move past new line
	                        scanner.scan();
	                        break;
	                    }
	                }
	                lastTokenInfo = { leadingTrivia: leadingTrivia, trailingTrivia: trailingTrivia, token: token };
	                return fixTokenKind(lastTokenInfo, n);
	            }
	            function getNextToken(n, expectedScanAction) {
	                var token = scanner.getToken();
	                lastScanAction = 0 /* Scan */;
	                switch (expectedScanAction) {
	                    case 1 /* RescanGreaterThanToken */:
	                        if (token === 29 /* GreaterThanToken */) {
	                            lastScanAction = 1 /* RescanGreaterThanToken */;
	                            var newToken = scanner.reScanGreaterToken();
	                            ts.Debug.assert(n.kind === newToken);
	                            return newToken;
	                        }
	                        break;
	                    case 2 /* RescanSlashToken */:
	                        if (startsWithSlashToken(token)) {
	                            lastScanAction = 2 /* RescanSlashToken */;
	                            var newToken = scanner.reScanSlashToken();
	                            ts.Debug.assert(n.kind === newToken);
	                            return newToken;
	                        }
	                        break;
	                    case 3 /* RescanTemplateToken */:
	                        if (token === 18 /* CloseBraceToken */) {
	                            lastScanAction = 3 /* RescanTemplateToken */;
	                            return scanner.reScanTemplateToken();
	                        }
	                        break;
	                    case 4 /* RescanJsxIdentifier */:
	                        lastScanAction = 4 /* RescanJsxIdentifier */;
	                        return scanner.scanJsxIdentifier();
	                    case 5 /* RescanJsxText */:
	                        lastScanAction = 5 /* RescanJsxText */;
	                        return scanner.reScanJsxToken();
	                    case 0 /* Scan */:
	                        break;
	                    default:
	                        ts.Debug.assertNever(expectedScanAction);
	                }
	                return token;
	            }
	            function isOnToken() {
	                var current = lastTokenInfo ? lastTokenInfo.token.kind : scanner.getToken();
	                var startPos = lastTokenInfo ? lastTokenInfo.token.pos : scanner.getStartPos();
	                return startPos < endPos && current !== 1 /* EndOfFileToken */ && !ts.isTrivia(current);
	            }
	            // when containing node in the tree is token
	            // but its kind differs from the kind that was returned by the scanner,
	            // then kind needs to be fixed. This might happen in cases
	            // when parser interprets token differently, i.e keyword treated as identifier
	            function fixTokenKind(tokenInfo, container) {
	                if (ts.isToken(container) && tokenInfo.token.kind !== container.kind) {
	                    tokenInfo.token.kind = container.kind;
	                }
	                return tokenInfo;
	            }
	            function skipToEndOf(node) {
	                scanner.setTextPos(node.end);
	                savedPos = scanner.getStartPos();
	                lastScanAction = undefined;
	                lastTokenInfo = undefined;
	                wasNewLine = false;
	                leadingTrivia = undefined;
	                trailingTrivia = undefined;
	            }
	        }
	        formatting.getFormattingScanner = getFormattingScanner;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        formatting.anyContext = ts.emptyArray;
	        var RuleAction;
	        (function (RuleAction) {
	            RuleAction[RuleAction["Ignore"] = 1] = "Ignore";
	            RuleAction[RuleAction["Space"] = 2] = "Space";
	            RuleAction[RuleAction["NewLine"] = 4] = "NewLine";
	            RuleAction[RuleAction["Delete"] = 8] = "Delete";
	        })(RuleAction = formatting.RuleAction || (formatting.RuleAction = {}));
	        var RuleFlags;
	        (function (RuleFlags) {
	            RuleFlags[RuleFlags["None"] = 0] = "None";
	            RuleFlags[RuleFlags["CanDeleteNewLines"] = 1] = "CanDeleteNewLines";
	        })(RuleFlags = formatting.RuleFlags || (formatting.RuleFlags = {}));
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        function getAllRules() {
	            var allTokens = [];
	            for (var token = 0 /* FirstToken */; token <= 144 /* LastToken */; token++) {
	                allTokens.push(token);
	            }
	            function anyTokenExcept() {
	                var tokens = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    tokens[_i] = arguments[_i];
	                }
	                return { tokens: allTokens.filter(function (t) { return !tokens.some(function (t2) { return t2 === t; }); }), isSpecific: false };
	            }
	            var anyToken = { tokens: allTokens, isSpecific: false };
	            var anyTokenIncludingMultilineComments = tokenRangeFrom(allTokens.concat([3 /* MultiLineCommentTrivia */]));
	            var keywords = tokenRangeFromRange(72 /* FirstKeyword */, 144 /* LastKeyword */);
	            var binaryOperators = tokenRangeFromRange(27 /* FirstBinaryOperator */, 70 /* LastBinaryOperator */);
	            var binaryKeywordOperators = [92 /* InKeyword */, 93 /* InstanceOfKeyword */, 144 /* OfKeyword */, 118 /* AsKeyword */, 127 /* IsKeyword */];
	            var unaryPrefixOperators = [43 /* PlusPlusToken */, 44 /* MinusMinusToken */, 52 /* TildeToken */, 51 /* ExclamationToken */];
	            var unaryPrefixExpressions = [
	                8 /* NumericLiteral */, 71 /* Identifier */, 19 /* OpenParenToken */, 21 /* OpenBracketToken */,
	                17 /* OpenBraceToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */
	            ];
	            var unaryPreincrementExpressions = [71 /* Identifier */, 19 /* OpenParenToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */];
	            var unaryPostincrementExpressions = [71 /* Identifier */, 20 /* CloseParenToken */, 22 /* CloseBracketToken */, 94 /* NewKeyword */];
	            var unaryPredecrementExpressions = [71 /* Identifier */, 19 /* OpenParenToken */, 99 /* ThisKeyword */, 94 /* NewKeyword */];
	            var unaryPostdecrementExpressions = [71 /* Identifier */, 20 /* CloseParenToken */, 22 /* CloseBracketToken */, 94 /* NewKeyword */];
	            var comments = [2 /* SingleLineCommentTrivia */, 3 /* MultiLineCommentTrivia */];
	            var typeNames = [71 /* Identifier */].concat(ts.typeKeywords);
	            // Place a space before open brace in a function declaration
	            // TypeScript: Function can have return types, which can be made of tons of different token kinds
	            var functionOpenBraceLeftTokenRange = anyTokenIncludingMultilineComments;
	            // Place a space before open brace in a TypeScript declaration that has braces as children (class, module, enum, etc)
	            var typeScriptOpenBraceLeftTokenRange = tokenRangeFrom([71 /* Identifier */, 3 /* MultiLineCommentTrivia */, 75 /* ClassKeyword */, 84 /* ExportKeyword */, 91 /* ImportKeyword */]);
	            // Place a space before open brace in a control flow construct
	            var controlOpenBraceLeftTokenRange = tokenRangeFrom([20 /* CloseParenToken */, 3 /* MultiLineCommentTrivia */, 81 /* DoKeyword */, 102 /* TryKeyword */, 87 /* FinallyKeyword */, 82 /* ElseKeyword */]);
	            // These rules are higher in priority than user-configurable
	            var highPriorityCommonRules = [
	                // Leave comments alone
	                rule("IgnoreBeforeComment", anyToken, comments, formatting.anyContext, 1 /* Ignore */),
	                rule("IgnoreAfterLineComment", 2 /* SingleLineCommentTrivia */, anyToken, formatting.anyContext, 1 /* Ignore */),
	                rule("NotSpaceBeforeColon", anyToken, 56 /* ColonToken */, [isNonJsxSameLineTokenContext, isNotBinaryOpContext, isNotTypeAnnotationContext], 8 /* Delete */),
	                rule("SpaceAfterColon", 56 /* ColonToken */, anyToken, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceBeforeQuestionMark", anyToken, 55 /* QuestionToken */, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                // insert space after '?' only when it is used in conditional operator
	                rule("SpaceAfterQuestionMarkInConditionalOperator", 55 /* QuestionToken */, anyToken, [isNonJsxSameLineTokenContext, isConditionalOperatorContext], 2 /* Space */),
	                // in other cases there should be no space between '?' and next token
	                rule("NoSpaceAfterQuestionMark", 55 /* QuestionToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeDot", anyToken, 23 /* DotToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterDot", 23 /* DotToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBetweenImportParenInImportType", 91 /* ImportKeyword */, 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext, isImportTypeContext], 8 /* Delete */),
	                // Special handling of unary operators.
	                // Prefix operators generally shouldn't have a space between
	                // them and their target unary expression.
	                rule("NoSpaceAfterUnaryPrefixOperator", unaryPrefixOperators, unaryPrefixExpressions, [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                rule("NoSpaceAfterUnaryPreincrementOperator", 43 /* PlusPlusToken */, unaryPreincrementExpressions, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterUnaryPredecrementOperator", 44 /* MinusMinusToken */, unaryPredecrementExpressions, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeUnaryPostincrementOperator", unaryPostincrementExpressions, 43 /* PlusPlusToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeUnaryPostdecrementOperator", unaryPostdecrementExpressions, 44 /* MinusMinusToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // More unary operator special-casing.
	                // DevDiv 181814: Be careful when removing leading whitespace
	                // around unary operators.  Examples:
	                //      1 - -2  --X--> 1--2
	                //      a + ++b --X--> a+++b
	                rule("SpaceAfterPostincrementWhenFollowedByAdd", 43 /* PlusPlusToken */, 37 /* PlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterAddWhenFollowedByUnaryPlus", 37 /* PlusToken */, 37 /* PlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterAddWhenFollowedByPreincrement", 37 /* PlusToken */, 43 /* PlusPlusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterPostdecrementWhenFollowedBySubtract", 44 /* MinusMinusToken */, 38 /* MinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterSubtractWhenFollowedByUnaryMinus", 38 /* MinusToken */, 38 /* MinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterSubtractWhenFollowedByPredecrement", 38 /* MinusToken */, 44 /* MinusMinusToken */, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceAfterCloseBrace", 18 /* CloseBraceToken */, [26 /* CommaToken */, 25 /* SemicolonToken */], [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // For functions and control block place } on a new line [multi-line rule]
	                rule("NewLineBeforeCloseBraceInBlockContext", anyTokenIncludingMultilineComments, 18 /* CloseBraceToken */, [isMultilineBlockContext], 4 /* NewLine */),
	                // Space/new line after }.
	                rule("SpaceAfterCloseBrace", 18 /* CloseBraceToken */, anyTokenExcept(20 /* CloseParenToken */), [isNonJsxSameLineTokenContext, isAfterCodeBlockContext], 2 /* Space */),
	                // Special case for (}, else) and (}, while) since else & while tokens are not part of the tree which makes SpaceAfterCloseBrace rule not applied
	                // Also should not apply to })
	                rule("SpaceBetweenCloseBraceAndElse", 18 /* CloseBraceToken */, 82 /* ElseKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenCloseBraceAndWhile", 18 /* CloseBraceToken */, 106 /* WhileKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenEmptyBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectContext], 8 /* Delete */),
	                // Add a space after control dec context if the next character is an open bracket ex: 'if (false)[a, b] = [1, 2];' -> 'if (false) [a, b] = [1, 2];'
	                rule("SpaceAfterConditionalClosingParen", 20 /* CloseParenToken */, 21 /* OpenBracketToken */, [isControlDeclContext], 2 /* Space */),
	                rule("NoSpaceBetweenFunctionKeywordAndStar", 89 /* FunctionKeyword */, 39 /* AsteriskToken */, [isFunctionDeclarationOrFunctionExpressionContext], 8 /* Delete */),
	                rule("SpaceAfterStarInGeneratorDeclaration", 39 /* AsteriskToken */, [71 /* Identifier */, 19 /* OpenParenToken */], [isFunctionDeclarationOrFunctionExpressionContext], 2 /* Space */),
	                rule("SpaceAfterFunctionInFuncDecl", 89 /* FunctionKeyword */, anyToken, [isFunctionDeclContext], 2 /* Space */),
	                // Insert new line after { and before } in multi-line contexts.
	                rule("NewLineAfterOpenBraceInBlockContext", 17 /* OpenBraceToken */, anyToken, [isMultilineBlockContext], 4 /* NewLine */),
	                // For get/set members, we check for (identifier,identifier) since get/set don't have tokens and they are represented as just an identifier token.
	                // Though, we do extra check on the context to make sure we are dealing with get/set node. Example:
	                //      get x() {}
	                //      set x(val) {}
	                rule("SpaceAfterGetSetInMember", [125 /* GetKeyword */, 136 /* SetKeyword */], 71 /* Identifier */, [isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceBetweenYieldKeywordAndStar", 116 /* YieldKeyword */, 39 /* AsteriskToken */, [isNonJsxSameLineTokenContext, isYieldOrYieldStarWithOperand], 8 /* Delete */),
	                rule("SpaceBetweenYieldOrYieldStarAndOperand", [116 /* YieldKeyword */, 39 /* AsteriskToken */], anyToken, [isNonJsxSameLineTokenContext, isYieldOrYieldStarWithOperand], 2 /* Space */),
	                rule("NoSpaceBetweenReturnAndSemicolon", 96 /* ReturnKeyword */, 25 /* SemicolonToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceAfterCertainKeywords", [104 /* VarKeyword */, 100 /* ThrowKeyword */, 94 /* NewKeyword */, 80 /* DeleteKeyword */, 96 /* ReturnKeyword */, 103 /* TypeOfKeyword */, 121 /* AwaitKeyword */], anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceAfterLetConstInVariableDeclaration", [110 /* LetKeyword */, 76 /* ConstKeyword */], anyToken, [isNonJsxSameLineTokenContext, isStartOfVariableDeclarationList], 2 /* Space */),
	                rule("NoSpaceBeforeOpenParenInFuncCall", anyToken, 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext, isFunctionCallOrNewContext, isPreviousTokenNotComma], 8 /* Delete */),
	                // Special case for binary operators (that are keywords). For these we have to add a space and shouldn't follow any user options.
	                rule("SpaceBeforeBinaryKeywordOperator", anyToken, binaryKeywordOperators, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterBinaryKeywordOperator", binaryKeywordOperators, anyToken, [isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterVoidOperator", 105 /* VoidKeyword */, anyToken, [isNonJsxSameLineTokenContext, isVoidOpContext], 2 /* Space */),
	                // Async-await
	                rule("SpaceBetweenAsyncAndOpenParen", 120 /* AsyncKeyword */, 19 /* OpenParenToken */, [isArrowFunctionContext, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenAsyncAndFunctionKeyword", 120 /* AsyncKeyword */, 89 /* FunctionKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Template string
	                rule("NoSpaceBetweenTagAndTemplateString", [71 /* Identifier */, 20 /* CloseParenToken */], [13 /* NoSubstitutionTemplateLiteral */, 14 /* TemplateHead */], [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // JSX opening elements
	                rule("SpaceBeforeJsxAttribute", anyToken, 71 /* Identifier */, [isNextTokenParentJsxAttribute, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeSlashInJsxOpeningElement", anyToken, 41 /* SlashToken */, [isJsxSelfClosingElementContext, isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBeforeGreaterThanTokenInJsxOpeningElement", 41 /* SlashToken */, 29 /* GreaterThanToken */, [isJsxSelfClosingElementContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeEqualInJsxAttribute", anyToken, 58 /* EqualsToken */, [isJsxAttributeContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterEqualInJsxAttribute", 58 /* EqualsToken */, anyToken, [isJsxAttributeContext, isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // TypeScript-specific rules
	                // Use of module as a function call. e.g.: import m2 = module("m2");
	                rule("NoSpaceAfterModuleImport", [129 /* ModuleKeyword */, 133 /* RequireKeyword */], 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Add a space around certain TypeScript keywords
	                rule("SpaceAfterCertainTypeScriptKeywords", [
	                    117 /* AbstractKeyword */,
	                    75 /* ClassKeyword */,
	                    124 /* DeclareKeyword */,
	                    79 /* DefaultKeyword */,
	                    83 /* EnumKeyword */,
	                    84 /* ExportKeyword */,
	                    85 /* ExtendsKeyword */,
	                    125 /* GetKeyword */,
	                    108 /* ImplementsKeyword */,
	                    91 /* ImportKeyword */,
	                    109 /* InterfaceKeyword */,
	                    129 /* ModuleKeyword */,
	                    130 /* NamespaceKeyword */,
	                    112 /* PrivateKeyword */,
	                    114 /* PublicKeyword */,
	                    113 /* ProtectedKeyword */,
	                    132 /* ReadonlyKeyword */,
	                    136 /* SetKeyword */,
	                    115 /* StaticKeyword */,
	                    139 /* TypeKeyword */,
	                    142 /* FromKeyword */,
	                    128 /* KeyOfKeyword */,
	                    126 /* InferKeyword */,
	                ], anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCertainTypeScriptKeywords", anyToken, [85 /* ExtendsKeyword */, 108 /* ImplementsKeyword */, 142 /* FromKeyword */], [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Treat string literals in module names as identifiers, and add a space between the literal and the opening Brace braces, e.g.: module "m2" {
	                rule("SpaceAfterModuleName", 9 /* StringLiteral */, 17 /* OpenBraceToken */, [isModuleDeclContext], 2 /* Space */),
	                // Lambda expressions
	                rule("SpaceBeforeArrow", anyToken, 36 /* EqualsGreaterThanToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceAfterArrow", 36 /* EqualsGreaterThanToken */, anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Optional parameters and let args
	                rule("NoSpaceAfterEllipsis", 24 /* DotDotDotToken */, 71 /* Identifier */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOptionalParameters", 55 /* QuestionToken */, [20 /* CloseParenToken */, 26 /* CommaToken */], [isNonJsxSameLineTokenContext, isNotBinaryOpContext], 8 /* Delete */),
	                // Remove spaces in empty interface literals. e.g.: x: {}
	                rule("NoSpaceBetweenEmptyInterfaceBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectTypeContext], 8 /* Delete */),
	                // generics and type assertions
	                rule("NoSpaceBeforeOpenAngularBracket", typeNames, 27 /* LessThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceBetweenCloseParenAndAngularBracket", 20 /* CloseParenToken */, 27 /* LessThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenAngularBracket", 27 /* LessThanToken */, anyToken, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseAngularBracket", anyToken, 29 /* GreaterThanToken */, [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterCloseAngularBracket", 29 /* GreaterThanToken */, [19 /* OpenParenToken */, 21 /* OpenBracketToken */, 29 /* GreaterThanToken */, 26 /* CommaToken */], [isNonJsxSameLineTokenContext, isTypeArgumentOrParameterOrAssertionContext, isNotFunctionDeclContext /*To prevent an interference with the SpaceBeforeOpenParenInFuncDecl rule*/], 8 /* Delete */),
	                // decorators
	                rule("SpaceBeforeAt", [20 /* CloseParenToken */, 71 /* Identifier */], 57 /* AtToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterAt", 57 /* AtToken */, anyToken, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after @ in decorator
	                rule("SpaceAfterDecorator", anyToken, [
	                    117 /* AbstractKeyword */,
	                    71 /* Identifier */,
	                    84 /* ExportKeyword */,
	                    79 /* DefaultKeyword */,
	                    75 /* ClassKeyword */,
	                    115 /* StaticKeyword */,
	                    114 /* PublicKeyword */,
	                    112 /* PrivateKeyword */,
	                    113 /* ProtectedKeyword */,
	                    125 /* GetKeyword */,
	                    136 /* SetKeyword */,
	                    21 /* OpenBracketToken */,
	                    39 /* AsteriskToken */,
	                ], [isEndOfDecoratorContextOnSameLine], 2 /* Space */),
	                rule("NoSpaceBeforeNonNullAssertionOperator", anyToken, 51 /* ExclamationToken */, [isNonJsxSameLineTokenContext, isNonNullAssertionContext], 8 /* Delete */),
	                rule("NoSpaceAfterNewKeywordOnConstructorSignature", 94 /* NewKeyword */, 19 /* OpenParenToken */, [isNonJsxSameLineTokenContext, isConstructorSignatureContext], 8 /* Delete */),
	            ];
	            // These rules are applied after high priority
	            var userConfigurableRules = [
	                // Treat constructor as an identifier in a function declaration, and remove spaces between constructor and following left parentheses
	                rule("SpaceAfterConstructor", 123 /* ConstructorKeyword */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterConstructor"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterConstructor", 123 /* ConstructorKeyword */, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterConstructor"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceAfterComma", 26 /* CommaToken */, anyToken, [isOptionEnabled("insertSpaceAfterCommaDelimiter"), isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext, isNextTokenNotCloseBracket], 2 /* Space */),
	                rule("NoSpaceAfterComma", 26 /* CommaToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterCommaDelimiter"), isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext], 8 /* Delete */),
	                // Insert space after function keyword for anonymous functions
	                rule("SpaceAfterAnonymousFunctionKeyword", 89 /* FunctionKeyword */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterFunctionKeywordForAnonymousFunctions"), isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceAfterAnonymousFunctionKeyword", 89 /* FunctionKeyword */, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterFunctionKeywordForAnonymousFunctions"), isFunctionDeclContext], 8 /* Delete */),
	                // Insert space after keywords in control flow statements
	                rule("SpaceAfterKeywordInControl", keywords, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterKeywordsInControlFlowStatements"), isControlDeclContext], 2 /* Space */),
	                rule("NoSpaceAfterKeywordInControl", keywords, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterKeywordsInControlFlowStatements"), isControlDeclContext], 8 /* Delete */),
	                // Insert space after opening and before closing nonempty parenthesis
	                rule("SpaceAfterOpenParen", 19 /* OpenParenToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCloseParen", anyToken, 20 /* CloseParenToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBetweenOpenParens", 19 /* OpenParenToken */, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenParens", 19 /* OpenParenToken */, 20 /* CloseParenToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenParen", 19 /* OpenParenToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseParen", anyToken, 20 /* CloseParenToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyParenthesis"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after opening and before closing nonempty brackets
	                rule("SpaceAfterOpenBracket", 21 /* OpenBracketToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBracket", anyToken, 22 /* CloseBracketToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceBetweenBrackets", 21 /* OpenBracketToken */, 22 /* CloseBracketToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenBracket", 21 /* OpenBracketToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBracket", anyToken, 22 /* CloseBracketToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBrackets"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert a space after { and before } in single-line contexts, but remove space from empty object literals {}.
	                rule("SpaceAfterOpenBrace", 17 /* OpenBraceToken */, anyToken, [isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isBraceWrappedContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBrace", anyToken, 18 /* CloseBraceToken */, [isOptionEnabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isBraceWrappedContext], 2 /* Space */),
	                rule("NoSpaceBetweenEmptyBraceBrackets", 17 /* OpenBraceToken */, 18 /* CloseBraceToken */, [isNonJsxSameLineTokenContext, isObjectContext], 8 /* Delete */),
	                rule("NoSpaceAfterOpenBrace", 17 /* OpenBraceToken */, anyToken, [isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBrace", anyToken, 18 /* CloseBraceToken */, [isOptionDisabled("insertSpaceAfterOpeningAndBeforeClosingNonemptyBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // Insert space after opening and before closing template string braces
	                rule("SpaceAfterTemplateHeadAndMiddle", [14 /* TemplateHead */, 15 /* TemplateMiddle */], anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("SpaceBeforeTemplateMiddleAndTail", anyToken, [15 /* TemplateMiddle */, 16 /* TemplateTail */], [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 2 /* Space */),
	                rule("NoSpaceAfterTemplateHeadAndMiddle", [14 /* TemplateHead */, 15 /* TemplateMiddle */], anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceBeforeTemplateMiddleAndTail", anyToken, [15 /* TemplateMiddle */, 16 /* TemplateTail */], [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingTemplateStringBraces"), isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // No space after { and before } in JSX expression
	                rule("SpaceAfterOpenBraceInJsxExpression", 17 /* OpenBraceToken */, anyToken, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 2 /* Space */),
	                rule("SpaceBeforeCloseBraceInJsxExpression", anyToken, 18 /* CloseBraceToken */, [isOptionEnabled("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 2 /* Space */),
	                rule("NoSpaceAfterOpenBraceInJsxExpression", 17 /* OpenBraceToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 8 /* Delete */),
	                rule("NoSpaceBeforeCloseBraceInJsxExpression", anyToken, 18 /* CloseBraceToken */, [isOptionDisabledOrUndefined("insertSpaceAfterOpeningAndBeforeClosingJsxExpressionBraces"), isNonJsxSameLineTokenContext, isJsxExpressionContext], 8 /* Delete */),
	                // Insert space after semicolon in for statement
	                rule("SpaceAfterSemicolonInFor", 25 /* SemicolonToken */, anyToken, [isOptionEnabled("insertSpaceAfterSemicolonInForStatements"), isNonJsxSameLineTokenContext, isForContext], 2 /* Space */),
	                rule("NoSpaceAfterSemicolonInFor", 25 /* SemicolonToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterSemicolonInForStatements"), isNonJsxSameLineTokenContext, isForContext], 8 /* Delete */),
	                // Insert space before and after binary operators
	                rule("SpaceBeforeBinaryOperator", anyToken, binaryOperators, [isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("SpaceAfterBinaryOperator", binaryOperators, anyToken, [isOptionEnabled("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 2 /* Space */),
	                rule("NoSpaceBeforeBinaryOperator", anyToken, binaryOperators, [isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 8 /* Delete */),
	                rule("NoSpaceAfterBinaryOperator", binaryOperators, anyToken, [isOptionDisabledOrUndefined("insertSpaceBeforeAndAfterBinaryOperators"), isNonJsxSameLineTokenContext, isBinaryOpContext], 8 /* Delete */),
	                rule("SpaceBeforeOpenParenInFuncDecl", anyToken, 19 /* OpenParenToken */, [isOptionEnabled("insertSpaceBeforeFunctionParenthesis"), isNonJsxSameLineTokenContext, isFunctionDeclContext], 2 /* Space */),
	                rule("NoSpaceBeforeOpenParenInFuncDecl", anyToken, 19 /* OpenParenToken */, [isOptionDisabledOrUndefined("insertSpaceBeforeFunctionParenthesis"), isNonJsxSameLineTokenContext, isFunctionDeclContext], 8 /* Delete */),
	                // Open Brace braces after control block
	                rule("NewLineBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForControlBlocks"), isControlDeclContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                // Open Brace braces after function
	                // TypeScript: Function can have return types, which can be made of tons of different token kinds
	                rule("NewLineBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForFunctions"), isFunctionDeclContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                // Open Brace braces after TypeScript module/class/interface
	                rule("NewLineBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionEnabled("placeOpenBraceOnNewLineForFunctions"), isTypeScriptDeclWithBlockContext, isBeforeMultilineBlockContext], 4 /* NewLine */, 1 /* CanDeleteNewLines */),
	                rule("SpaceAfterTypeAssertion", 29 /* GreaterThanToken */, anyToken, [isOptionEnabled("insertSpaceAfterTypeAssertion"), isNonJsxSameLineTokenContext, isTypeAssertionContext], 2 /* Space */),
	                rule("NoSpaceAfterTypeAssertion", 29 /* GreaterThanToken */, anyToken, [isOptionDisabledOrUndefined("insertSpaceAfterTypeAssertion"), isNonJsxSameLineTokenContext, isTypeAssertionContext], 8 /* Delete */),
	                rule("SpaceBeforeTypeAnnotation", anyToken, 56 /* ColonToken */, [isOptionEnabled("insertSpaceBeforeTypeAnnotation"), isNonJsxSameLineTokenContext, isTypeAnnotationContext], 2 /* Space */),
	                rule("NoSpaceBeforeTypeAnnotation", anyToken, 56 /* ColonToken */, [isOptionDisabledOrUndefined("insertSpaceBeforeTypeAnnotation"), isNonJsxSameLineTokenContext, isTypeAnnotationContext], 8 /* Delete */),
	            ];
	            // These rules are lower in priority than user-configurable. Rules earlier in this list have priority over rules later in the list.
	            var lowPriorityCommonRules = [
	                // Space after keyword but not before ; or : or ?
	                rule("NoSpaceBeforeSemicolon", anyToken, 25 /* SemicolonToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("SpaceBeforeOpenBraceInControl", controlOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForControlBlocks"), isControlDeclContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("SpaceBeforeOpenBraceInFunction", functionOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"), isFunctionDeclContext, isBeforeBlockContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("SpaceBeforeOpenBraceInTypeScriptDeclWithBlock", typeScriptOpenBraceLeftTokenRange, 17 /* OpenBraceToken */, [isOptionDisabledOrUndefinedOrTokensOnSameLine("placeOpenBraceOnNewLineForFunctions"), isTypeScriptDeclWithBlockContext, isNotFormatOnEnter, isSameLineTokenOrBeforeBlockContext], 2 /* Space */, 1 /* CanDeleteNewLines */),
	                rule("NoSpaceBeforeComma", anyToken, 26 /* CommaToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                // No space before and after indexer `x[]`
	                rule("NoSpaceBeforeOpenBracket", anyTokenExcept(120 /* AsyncKeyword */, 73 /* CaseKeyword */), 21 /* OpenBracketToken */, [isNonJsxSameLineTokenContext], 8 /* Delete */),
	                rule("NoSpaceAfterCloseBracket", 22 /* CloseBracketToken */, anyToken, [isNonJsxSameLineTokenContext, isNotBeforeBlockInFunctionDeclarationContext], 8 /* Delete */),
	                rule("SpaceAfterSemicolon", 25 /* SemicolonToken */, anyToken, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Remove extra space between for and await
	                rule("SpaceBetweenForAndAwaitKeyword", 88 /* ForKeyword */, 121 /* AwaitKeyword */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	                // Add a space between statements. All keywords except (do,else,case) has open/close parens after them.
	                // So, we have a rule to add a space for [),Any], [do,Any], [else,Any], and [case,Any]
	                rule("SpaceBetweenStatements", [20 /* CloseParenToken */, 81 /* DoKeyword */, 82 /* ElseKeyword */, 73 /* CaseKeyword */], anyToken, [isNonJsxSameLineTokenContext, isNonJsxElementOrFragmentContext, isNotForContext], 2 /* Space */),
	                // This low-pri rule takes care of "try {" and "finally {" in case the rule SpaceBeforeOpenBraceInControl didn't execute on FormatOnEnter.
	                rule("SpaceAfterTryFinally", [102 /* TryKeyword */, 87 /* FinallyKeyword */], 17 /* OpenBraceToken */, [isNonJsxSameLineTokenContext], 2 /* Space */),
	            ];
	            return highPriorityCommonRules.concat(userConfigurableRules, lowPriorityCommonRules);
	        }
	        formatting.getAllRules = getAllRules;
	        function rule(debugName, left, right, context, action, flags) {
	            if (flags === void 0) { flags = 0 /* None */; }
	            return { leftTokenRange: toTokenRange(left), rightTokenRange: toTokenRange(right), rule: { debugName: debugName, context: context, action: action, flags: flags } };
	        }
	        function tokenRangeFrom(tokens) {
	            return { tokens: tokens, isSpecific: true };
	        }
	        function toTokenRange(arg) {
	            return typeof arg === "number" ? tokenRangeFrom([arg]) : ts.isArray(arg) ? tokenRangeFrom(arg) : arg;
	        }
	        function tokenRangeFromRange(from, to, except) {
	            if (except === void 0) { except = []; }
	            var tokens = [];
	            for (var token = from; token <= to; token++) {
	                if (!ts.contains(except, token)) {
	                    tokens.push(token);
	                }
	            }
	            return tokenRangeFrom(tokens);
	        }
	        ///
	        /// Contexts
	        ///
	        function isOptionEnabled(optionName) {
	            return function (context) { return context.options && context.options.hasOwnProperty(optionName) && !!context.options[optionName]; };
	        }
	        function isOptionDisabled(optionName) {
	            return function (context) { return context.options && context.options.hasOwnProperty(optionName) && !context.options[optionName]; };
	        }
	        function isOptionDisabledOrUndefined(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !context.options[optionName]; };
	        }
	        function isOptionDisabledOrUndefinedOrTokensOnSameLine(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !context.options[optionName] || context.TokensAreOnSameLine(); };
	        }
	        function isOptionEnabledOrUndefined(optionName) {
	            return function (context) { return !context.options || !context.options.hasOwnProperty(optionName) || !!context.options[optionName]; };
	        }
	        function isForContext(context) {
	            return context.contextNode.kind === 219 /* ForStatement */;
	        }
	        function isNotForContext(context) {
	            return !isForContext(context);
	        }
	        function isBinaryOpContext(context) {
	            switch (context.contextNode.kind) {
	                case 199 /* BinaryExpression */:
	                case 200 /* ConditionalExpression */:
	                case 170 /* ConditionalType */:
	                case 207 /* AsExpression */:
	                case 251 /* ExportSpecifier */:
	                case 247 /* ImportSpecifier */:
	                case 160 /* TypePredicate */:
	                case 168 /* UnionType */:
	                case 169 /* IntersectionType */:
	                    return true;
	                // equals in binding elements: function foo([[x, y] = [1, 2]])
	                case 181 /* BindingElement */:
	                // equals in type X = ...
	                case 236 /* TypeAliasDeclaration */:
	                // equal in import a = module('a');
	                case 242 /* ImportEqualsDeclaration */:
	                // equal in let a = 0;
	                case 231 /* VariableDeclaration */:
	                // equal in p = 0;
	                case 148 /* Parameter */:
	                case 272 /* EnumMember */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                    return context.currentTokenSpan.kind === 58 /* EqualsToken */ || context.nextTokenSpan.kind === 58 /* EqualsToken */;
	                // "in" keyword in for (let x in []) { }
	                case 220 /* ForInStatement */:
	                // "in" keyword in [P in keyof T]: T[P]
	                case 147 /* TypeParameter */:
	                    return context.currentTokenSpan.kind === 92 /* InKeyword */ || context.nextTokenSpan.kind === 92 /* InKeyword */;
	                // Technically, "of" is not a binary operator, but format it the same way as "in"
	                case 221 /* ForOfStatement */:
	                    return context.currentTokenSpan.kind === 144 /* OfKeyword */ || context.nextTokenSpan.kind === 144 /* OfKeyword */;
	            }
	            return false;
	        }
	        function isNotBinaryOpContext(context) {
	            return !isBinaryOpContext(context);
	        }
	        function isNotTypeAnnotationContext(context) {
	            return !isTypeAnnotationContext(context);
	        }
	        function isTypeAnnotationContext(context) {
	            var contextKind = context.contextNode.kind;
	            return contextKind === 151 /* PropertyDeclaration */ ||
	                contextKind === 150 /* PropertySignature */ ||
	                contextKind === 148 /* Parameter */ ||
	                contextKind === 231 /* VariableDeclaration */ ||
	                ts.isFunctionLikeKind(contextKind);
	        }
	        function isConditionalOperatorContext(context) {
	            return context.contextNode.kind === 200 /* ConditionalExpression */ ||
	                context.contextNode.kind === 170 /* ConditionalType */;
	        }
	        function isSameLineTokenOrBeforeBlockContext(context) {
	            return context.TokensAreOnSameLine() || isBeforeBlockContext(context);
	        }
	        function isBraceWrappedContext(context) {
	            return context.contextNode.kind === 179 /* ObjectBindingPattern */ ||
	                context.contextNode.kind === 176 /* MappedType */ ||
	                isSingleLineBlockContext(context);
	        }
	        // This check is done before an open brace in a control construct, a function, or a typescript block declaration
	        function isBeforeMultilineBlockContext(context) {
	            return isBeforeBlockContext(context) && !(context.NextNodeAllOnSameLine() || context.NextNodeBlockIsOnOneLine());
	        }
	        function isMultilineBlockContext(context) {
	            return isBlockContext(context) && !(context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
	        }
	        function isSingleLineBlockContext(context) {
	            return isBlockContext(context) && (context.ContextNodeAllOnSameLine() || context.ContextNodeBlockIsOnOneLine());
	        }
	        function isBlockContext(context) {
	            return nodeIsBlockContext(context.contextNode);
	        }
	        function isBeforeBlockContext(context) {
	            return nodeIsBlockContext(context.nextTokenParent);
	        }
	        // IMPORTANT!!! This method must return true ONLY for nodes with open and close braces as immediate children
	        function nodeIsBlockContext(node) {
	            if (nodeIsTypeScriptDeclWithBlockContext(node)) {
	                // This means we are in a context that looks like a block to the user, but in the grammar is actually not a node (it's a class, module, enum, object type literal, etc).
	                return true;
	            }
	            switch (node.kind) {
	                case 212 /* Block */:
	                case 240 /* CaseBlock */:
	                case 183 /* ObjectLiteralExpression */:
	                case 239 /* ModuleBlock */:
	                    return true;
	            }
	            return false;
	        }
	        function isFunctionDeclContext(context) {
	            switch (context.contextNode.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                // case SyntaxKind.MemberFunctionDeclaration:
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                // case SyntaxKind.MethodSignature:
	                case 157 /* CallSignature */:
	                case 191 /* FunctionExpression */:
	                case 154 /* Constructor */:
	                case 192 /* ArrowFunction */:
	                // case SyntaxKind.ConstructorDeclaration:
	                // case SyntaxKind.SimpleArrowFunctionExpression:
	                // case SyntaxKind.ParenthesizedArrowFunctionExpression:
	                case 235 /* InterfaceDeclaration */: // This one is not truly a function, but for formatting purposes, it acts just like one
	                    return true;
	            }
	            return false;
	        }
	        function isNotFunctionDeclContext(context) {
	            return !isFunctionDeclContext(context);
	        }
	        function isFunctionDeclarationOrFunctionExpressionContext(context) {
	            return context.contextNode.kind === 233 /* FunctionDeclaration */ || context.contextNode.kind === 191 /* FunctionExpression */;
	        }
	        function isTypeScriptDeclWithBlockContext(context) {
	            return nodeIsTypeScriptDeclWithBlockContext(context.contextNode);
	        }
	        function nodeIsTypeScriptDeclWithBlockContext(node) {
	            switch (node.kind) {
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                case 235 /* InterfaceDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 165 /* TypeLiteral */:
	                case 238 /* ModuleDeclaration */:
	                case 249 /* ExportDeclaration */:
	                case 250 /* NamedExports */:
	                case 243 /* ImportDeclaration */:
	                case 246 /* NamedImports */:
	                    return true;
	            }
	            return false;
	        }
	        function isAfterCodeBlockContext(context) {
	            switch (context.currentTokenParent.kind) {
	                case 234 /* ClassDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 268 /* CatchClause */:
	                case 239 /* ModuleBlock */:
	                case 226 /* SwitchStatement */:
	                    return true;
	                case 212 /* Block */: {
	                    var blockParent = context.currentTokenParent.parent;
	                    // In a codefix scenario, we can't rely on parents being set. So just always return true.
	                    if (!blockParent || blockParent.kind !== 192 /* ArrowFunction */ && blockParent.kind !== 191 /* FunctionExpression */) {
	                        return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function isControlDeclContext(context) {
	            switch (context.contextNode.kind) {
	                case 216 /* IfStatement */:
	                case 226 /* SwitchStatement */:
	                case 219 /* ForStatement */:
	                case 220 /* ForInStatement */:
	                case 221 /* ForOfStatement */:
	                case 218 /* WhileStatement */:
	                case 229 /* TryStatement */:
	                case 217 /* DoStatement */:
	                case 225 /* WithStatement */:
	                // TODO
	                // case SyntaxKind.ElseClause:
	                case 268 /* CatchClause */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function isObjectContext(context) {
	            return context.contextNode.kind === 183 /* ObjectLiteralExpression */;
	        }
	        function isFunctionCallContext(context) {
	            return context.contextNode.kind === 186 /* CallExpression */;
	        }
	        function isNewContext(context) {
	            return context.contextNode.kind === 187 /* NewExpression */;
	        }
	        function isFunctionCallOrNewContext(context) {
	            return isFunctionCallContext(context) || isNewContext(context);
	        }
	        function isPreviousTokenNotComma(context) {
	            return context.currentTokenSpan.kind !== 26 /* CommaToken */;
	        }
	        function isNextTokenNotCloseBracket(context) {
	            return context.nextTokenSpan.kind !== 22 /* CloseBracketToken */;
	        }
	        function isArrowFunctionContext(context) {
	            return context.contextNode.kind === 192 /* ArrowFunction */;
	        }
	        function isImportTypeContext(context) {
	            return context.contextNode.kind === 178 /* ImportType */;
	        }
	        function isNonJsxSameLineTokenContext(context) {
	            return context.TokensAreOnSameLine() && context.contextNode.kind !== 10 /* JsxText */;
	        }
	        function isNonJsxElementOrFragmentContext(context) {
	            return context.contextNode.kind !== 254 /* JsxElement */ && context.contextNode.kind !== 258 /* JsxFragment */;
	        }
	        function isJsxExpressionContext(context) {
	            return context.contextNode.kind === 264 /* JsxExpression */ || context.contextNode.kind === 263 /* JsxSpreadAttribute */;
	        }
	        function isNextTokenParentJsxAttribute(context) {
	            return context.nextTokenParent.kind === 261 /* JsxAttribute */;
	        }
	        function isJsxAttributeContext(context) {
	            return context.contextNode.kind === 261 /* JsxAttribute */;
	        }
	        function isJsxSelfClosingElementContext(context) {
	            return context.contextNode.kind === 255 /* JsxSelfClosingElement */;
	        }
	        function isNotBeforeBlockInFunctionDeclarationContext(context) {
	            return !isFunctionDeclContext(context) && !isBeforeBlockContext(context);
	        }
	        function isEndOfDecoratorContextOnSameLine(context) {
	            return context.TokensAreOnSameLine() &&
	                context.contextNode.decorators &&
	                nodeIsInDecoratorContext(context.currentTokenParent) &&
	                !nodeIsInDecoratorContext(context.nextTokenParent);
	        }
	        function nodeIsInDecoratorContext(node) {
	            while (ts.isExpressionNode(node)) {
	                node = node.parent;
	            }
	            return node.kind === 149 /* Decorator */;
	        }
	        function isStartOfVariableDeclarationList(context) {
	            return context.currentTokenParent.kind === 232 /* VariableDeclarationList */ &&
	                context.currentTokenParent.getStart(context.sourceFile) === context.currentTokenSpan.pos;
	        }
	        function isNotFormatOnEnter(context) {
	            return context.formattingRequestKind !== 2 /* FormatOnEnter */;
	        }
	        function isModuleDeclContext(context) {
	            return context.contextNode.kind === 238 /* ModuleDeclaration */;
	        }
	        function isObjectTypeContext(context) {
	            return context.contextNode.kind === 165 /* TypeLiteral */; // && context.contextNode.parent.kind !== SyntaxKind.InterfaceDeclaration;
	        }
	        function isConstructorSignatureContext(context) {
	            return context.contextNode.kind === 158 /* ConstructSignature */;
	        }
	        function isTypeArgumentOrParameterOrAssertion(token, parent) {
	            if (token.kind !== 27 /* LessThanToken */ && token.kind !== 29 /* GreaterThanToken */) {
	                return false;
	            }
	            switch (parent.kind) {
	                case 161 /* TypeReference */:
	                case 189 /* TypeAssertionExpression */:
	                case 236 /* TypeAliasDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 204 /* ClassExpression */:
	                case 235 /* InterfaceDeclaration */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 192 /* ArrowFunction */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 186 /* CallExpression */:
	                case 187 /* NewExpression */:
	                case 206 /* ExpressionWithTypeArguments */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function isTypeArgumentOrParameterOrAssertionContext(context) {
	            return isTypeArgumentOrParameterOrAssertion(context.currentTokenSpan, context.currentTokenParent) ||
	                isTypeArgumentOrParameterOrAssertion(context.nextTokenSpan, context.nextTokenParent);
	        }
	        function isTypeAssertionContext(context) {
	            return context.contextNode.kind === 189 /* TypeAssertionExpression */;
	        }
	        function isVoidOpContext(context) {
	            return context.currentTokenSpan.kind === 105 /* VoidKeyword */ && context.currentTokenParent.kind === 195 /* VoidExpression */;
	        }
	        function isYieldOrYieldStarWithOperand(context) {
	            return context.contextNode.kind === 202 /* YieldExpression */ && context.contextNode.expression !== undefined;
	        }
	        function isNonNullAssertionContext(context) {
	            return context.contextNode.kind === 208 /* NonNullExpression */;
	        }
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        function getFormatContext(options) {
	            return { options: options, getRule: getRulesMap() };
	        }
	        formatting.getFormatContext = getFormatContext;
	        var rulesMapCache;
	        function getRulesMap() {
	            if (rulesMapCache === undefined) {
	                rulesMapCache = createRulesMap(formatting.getAllRules());
	            }
	            return rulesMapCache;
	        }
	        function createRulesMap(rules) {
	            var map = buildMap(rules);
	            return function (context) {
	                var bucket = map[getRuleBucketIndex(context.currentTokenSpan.kind, context.nextTokenSpan.kind)];
	                return bucket && ts.find(bucket, function (rule) { return ts.every(rule.context, function (c) { return c(context); }); });
	            };
	        }
	        function buildMap(rules) {
	            // Map from bucket index to array of rules
	            var map = new Array(mapRowLength * mapRowLength);
	            // This array is used only during construction of the rulesbucket in the map
	            var rulesBucketConstructionStateList = new Array(map.length);
	            for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
	                var rule_1 = rules_1[_i];
	                var specificRule = rule_1.leftTokenRange.isSpecific && rule_1.rightTokenRange.isSpecific;
	                for (var _a = 0, _b = rule_1.leftTokenRange.tokens; _a < _b.length; _a++) {
	                    var left = _b[_a];
	                    for (var _c = 0, _d = rule_1.rightTokenRange.tokens; _c < _d.length; _c++) {
	                        var right = _d[_c];
	                        var index = getRuleBucketIndex(left, right);
	                        var rulesBucket = map[index];
	                        if (rulesBucket === undefined) {
	                            rulesBucket = map[index] = [];
	                        }
	                        addRule(rulesBucket, rule_1.rule, specificRule, rulesBucketConstructionStateList, index);
	                    }
	                }
	            }
	            return map;
	        }
	        function getRuleBucketIndex(row, column) {
	            ts.Debug.assert(row <= 144 /* LastKeyword */ && column <= 144 /* LastKeyword */, "Must compute formatting context from tokens");
	            return (row * mapRowLength) + column;
	        }
	        var maskBitSize = 5;
	        var mask = 31; // MaskBitSize bits
	        var mapRowLength = 144 /* LastToken */ + 1;
	        var RulesPosition;
	        (function (RulesPosition) {
	            RulesPosition[RulesPosition["IgnoreRulesSpecific"] = 0] = "IgnoreRulesSpecific";
	            RulesPosition[RulesPosition["IgnoreRulesAny"] = maskBitSize * 1] = "IgnoreRulesAny";
	            RulesPosition[RulesPosition["ContextRulesSpecific"] = maskBitSize * 2] = "ContextRulesSpecific";
	            RulesPosition[RulesPosition["ContextRulesAny"] = maskBitSize * 3] = "ContextRulesAny";
	            RulesPosition[RulesPosition["NoContextRulesSpecific"] = maskBitSize * 4] = "NoContextRulesSpecific";
	            RulesPosition[RulesPosition["NoContextRulesAny"] = maskBitSize * 5] = "NoContextRulesAny";
	        })(RulesPosition || (RulesPosition = {}));
	        // The Rules list contains all the inserted rules into a rulebucket in the following order:
	        //    1- Ignore rules with specific token combination
	        //    2- Ignore rules with any token combination
	        //    3- Context rules with specific token combination
	        //    4- Context rules with any token combination
	        //    5- Non-context rules with specific token combination
	        //    6- Non-context rules with any token combination
	        //
	        // The member rulesInsertionIndexBitmap is used to describe the number of rules
	        // in each sub-bucket (above) hence can be used to know the index of where to insert
	        // the next rule. It's a bitmap which contains 6 different sections each is given 5 bits.
	        //
	        // Example:
	        // In order to insert a rule to the end of sub-bucket (3), we get the index by adding
	        // the values in the bitmap segments 3rd, 2nd, and 1st.
	        function addRule(rules, rule, specificTokens, constructionState, rulesBucketIndex) {
	            var position = rule.action === 1 /* Ignore */
	                ? specificTokens ? RulesPosition.IgnoreRulesSpecific : RulesPosition.IgnoreRulesAny
	                : rule.context !== formatting.anyContext
	                    ? specificTokens ? RulesPosition.ContextRulesSpecific : RulesPosition.ContextRulesAny
	                    : specificTokens ? RulesPosition.NoContextRulesSpecific : RulesPosition.NoContextRulesAny;
	            var state = constructionState[rulesBucketIndex] || 0;
	            rules.splice(getInsertionIndex(state, position), 0, rule);
	            constructionState[rulesBucketIndex] = increaseInsertionIndex(state, position);
	        }
	        function getInsertionIndex(indexBitmap, maskPosition) {
	            var index = 0;
	            for (var pos = 0; pos <= maskPosition; pos += maskBitSize) {
	                index += indexBitmap & mask;
	                indexBitmap >>= maskBitSize;
	            }
	            return index;
	        }
	        function increaseInsertionIndex(indexBitmap, maskPosition) {
	            var value = ((indexBitmap >> maskPosition) & mask) + 1;
	            ts.Debug.assert((value & mask) === value, "Adding more rules into the sub-bucket than allowed. Maximum allowed is 32 rules.");
	            return (indexBitmap & ~(mask << maskPosition)) | (value << maskPosition);
	        }
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var Constants;
	        (function (Constants) {
	            Constants[Constants["Unknown"] = -1] = "Unknown";
	        })(Constants || (Constants = {}));
	        function formatOnEnter(position, sourceFile, formatContext) {
	            var line = sourceFile.getLineAndCharacterOfPosition(position).line;
	            if (line === 0) {
	                return [];
	            }
	            // After the enter key, the cursor is now at a new line. The new line may or may not contain non-whitespace characters.
	            // If the new line has only whitespaces, we won't want to format this line, because that would remove the indentation as
	            // trailing whitespaces. So the end of the formatting span should be the later one between:
	            //  1. the end of the previous line
	            //  2. the last non-whitespace character in the current line
	            var endOfFormatSpan = ts.getEndLinePosition(line, sourceFile);
	            while (ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(endOfFormatSpan))) {
	                endOfFormatSpan--;
	            }
	            // if the character at the end of the span is a line break, we shouldn't include it, because it indicates we don't want to
	            // touch the current line at all. Also, on some OSes the line break consists of two characters (\r\n), we should test if the
	            // previous character before the end of format span is line break character as well.
	            if (ts.isLineBreak(sourceFile.text.charCodeAt(endOfFormatSpan))) {
	                endOfFormatSpan--;
	            }
	            var span = {
	                // get start position for the previous line
	                pos: ts.getStartPositionOfLine(line - 1, sourceFile),
	                // end value is exclusive so add 1 to the result
	                end: endOfFormatSpan + 1
	            };
	            return formatSpan(span, sourceFile, formatContext, 2 /* FormatOnEnter */);
	        }
	        formatting.formatOnEnter = formatOnEnter;
	        function formatOnSemicolon(position, sourceFile, formatContext) {
	            var semicolon = findImmediatelyPrecedingTokenOfKind(position, 25 /* SemicolonToken */, sourceFile);
	            return formatNodeLines(findOutermostNodeWithinListLevel(semicolon), sourceFile, formatContext, 3 /* FormatOnSemicolon */);
	        }
	        formatting.formatOnSemicolon = formatOnSemicolon;
	        function formatOnOpeningCurly(position, sourceFile, formatContext) {
	            var openingCurly = findImmediatelyPrecedingTokenOfKind(position, 17 /* OpenBraceToken */, sourceFile);
	            if (!openingCurly) {
	                return [];
	            }
	            var curlyBraceRange = openingCurly.parent;
	            var outermostNode = findOutermostNodeWithinListLevel(curlyBraceRange);
	            /**
	             * We limit the span to end at the opening curly to handle the case where
	             * the brace matched to that just typed will be incorrect after further edits.
	             * For example, we could type the opening curly for the following method
	             * body without brace-matching activated:
	             * ```
	             * class C {
	             *     foo()
	             * }
	             * ```
	             * and we wouldn't want to move the closing brace.
	             */
	            var textRange = {
	                pos: ts.getLineStartPositionForPosition(outermostNode.getStart(sourceFile), sourceFile),
	                end: position
	            };
	            return formatSpan(textRange, sourceFile, formatContext, 4 /* FormatOnOpeningCurlyBrace */);
	        }
	        formatting.formatOnOpeningCurly = formatOnOpeningCurly;
	        function formatOnClosingCurly(position, sourceFile, formatContext) {
	            var precedingToken = findImmediatelyPrecedingTokenOfKind(position, 18 /* CloseBraceToken */, sourceFile);
	            return formatNodeLines(findOutermostNodeWithinListLevel(precedingToken), sourceFile, formatContext, 5 /* FormatOnClosingCurlyBrace */);
	        }
	        formatting.formatOnClosingCurly = formatOnClosingCurly;
	        function formatDocument(sourceFile, formatContext) {
	            var span = {
	                pos: 0,
	                end: sourceFile.text.length
	            };
	            return formatSpan(span, sourceFile, formatContext, 0 /* FormatDocument */);
	        }
	        formatting.formatDocument = formatDocument;
	        function formatSelection(start, end, sourceFile, formatContext) {
	            // format from the beginning of the line
	            var span = {
	                pos: ts.getLineStartPositionForPosition(start, sourceFile),
	                end: end,
	            };
	            return formatSpan(span, sourceFile, formatContext, 1 /* FormatSelection */);
	        }
	        formatting.formatSelection = formatSelection;
	        /**
	         * Validating `expectedTokenKind` ensures the token was typed in the context we expect (eg: not a comment).
	         * @param expectedTokenKind The kind of the last token constituting the desired parent node.
	         */
	        function findImmediatelyPrecedingTokenOfKind(end, expectedTokenKind, sourceFile) {
	            var precedingToken = ts.findPrecedingToken(end, sourceFile);
	            return precedingToken && precedingToken.kind === expectedTokenKind && end === precedingToken.getEnd() ?
	                precedingToken :
	                undefined;
	        }
	        /**
	         * Finds the highest node enclosing `node` at the same list level as `node`
	         * and whose end does not exceed `node.end`.
	         *
	         * Consider typing the following
	         * ```
	         * let x = 1;
	         * while (true) {
	         * }
	         * ```
	         * Upon typing the closing curly, we want to format the entire `while`-statement, but not the preceding
	         * variable declaration.
	         */
	        function findOutermostNodeWithinListLevel(node) {
	            var current = node;
	            while (current &&
	                current.parent &&
	                current.parent.end === node.end &&
	                !isListElement(current.parent, current)) {
	                current = current.parent;
	            }
	            return current;
	        }
	        // Returns true if node is a element in some list in parent
	        // i.e. parent is class declaration with the list of members and node is one of members.
	        function isListElement(parent, node) {
	            switch (parent.kind) {
	                case 234 /* ClassDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                    return ts.rangeContainsRange(parent.members, node);
	                case 238 /* ModuleDeclaration */:
	                    var body = parent.body;
	                    return body && body.kind === 239 /* ModuleBlock */ && ts.rangeContainsRange(body.statements, node);
	                case 273 /* SourceFile */:
	                case 212 /* Block */:
	                case 239 /* ModuleBlock */:
	                    return ts.rangeContainsRange(parent.statements, node);
	                case 268 /* CatchClause */:
	                    return ts.rangeContainsRange(parent.block.statements, node);
	            }
	            return false;
	        }
	        /** find node that fully contains given text range */
	        function findEnclosingNode(range, sourceFile) {
	            return find(sourceFile);
	            function find(n) {
	                var candidate = ts.forEachChild(n, function (c) { return ts.startEndContainsRange(c.getStart(sourceFile), c.end, range) && c; });
	                if (candidate) {
	                    var result = find(candidate);
	                    if (result) {
	                        return result;
	                    }
	                }
	                return n;
	            }
	        }
	        /** formatting is not applied to ranges that contain parse errors.
	         * This function will return a predicate that for a given text range will tell
	         * if there are any parse errors that overlap with the range.
	         */
	        function prepareRangeContainsErrorFunction(errors, originalRange) {
	            if (!errors.length) {
	                return rangeHasNoErrors;
	            }
	            // pick only errors that fall in range
	            var sorted = errors
	                .filter(function (d) { return ts.rangeOverlapsWithStartEnd(originalRange, d.start, d.start + d.length); })
	                .sort(function (e1, e2) { return e1.start - e2.start; });
	            if (!sorted.length) {
	                return rangeHasNoErrors;
	            }
	            var index = 0;
	            return function (r) {
	                // in current implementation sequence of arguments [r1, r2...] is monotonically increasing.
	                // 'index' tracks the index of the most recent error that was checked.
	                while (true) {
	                    if (index >= sorted.length) {
	                        // all errors in the range were already checked -> no error in specified range
	                        return false;
	                    }
	                    var error = sorted[index];
	                    if (r.end <= error.start) {
	                        // specified range ends before the error refered by 'index' - no error in range
	                        return false;
	                    }
	                    if (ts.startEndOverlapsWithStartEnd(r.pos, r.end, error.start, error.start + error.length)) {
	                        // specified range overlaps with error range
	                        return true;
	                    }
	                    index++;
	                }
	            };
	            function rangeHasNoErrors() {
	                return false;
	            }
	        }
	        /**
	         * Start of the original range might fall inside the comment - scanner will not yield appropriate results
	         * This function will look for token that is located before the start of target range
	         * and return its end as start position for the scanner.
	         */
	        function getScanStartPosition(enclosingNode, originalRange, sourceFile) {
	            var start = enclosingNode.getStart(sourceFile);
	            if (start === originalRange.pos && enclosingNode.end === originalRange.end) {
	                return start;
	            }
	            var precedingToken = ts.findPrecedingToken(originalRange.pos, sourceFile);
	            if (!precedingToken) {
	                // no preceding token found - start from the beginning of enclosing node
	                return enclosingNode.pos;
	            }
	            // preceding token ends after the start of original range (i.e when originalRange.pos falls in the middle of literal)
	            // start from the beginning of enclosingNode to handle the entire 'originalRange'
	            if (precedingToken.end >= originalRange.pos) {
	                return enclosingNode.pos;
	            }
	            return precedingToken.end;
	        }
	        /*
	         * For cases like
	         * if (a ||
	         *     b ||$
	         *     c) {...}
	         * If we hit Enter at $ we want line '    b ||' to be indented.
	         * Formatting will be applied to the last two lines.
	         * Node that fully encloses these lines is binary expression 'a ||...'.
	         * Initial indentation for this node will be 0.
	         * Binary expressions don't introduce new indentation scopes, however it is possible
	         * that some parent node on the same line does - like if statement in this case.
	         * Note that we are considering parents only from the same line with initial node -
	         * if parent is on the different line - its delta was already contributed
	         * to the initial indentation.
	         */
	        function getOwnOrInheritedDelta(n, options, sourceFile) {
	            var previousLine = -1 /* Unknown */;
	            var child;
	            while (n) {
	                var line = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile)).line;
	                if (previousLine !== -1 /* Unknown */ && line !== previousLine) {
	                    break;
	                }
	                if (formatting.SmartIndenter.shouldIndentChildNode(options, n, child, sourceFile)) {
	                    return options.indentSize;
	                }
	                previousLine = line;
	                child = n;
	                n = n.parent;
	            }
	            return 0;
	        }
	        /* @internal */
	        function formatNodeGivenIndentation(node, sourceFileLike, languageVariant, initialIndentation, delta, formatContext) {
	            var range = { pos: 0, end: sourceFileLike.text.length };
	            return formatting.getFormattingScanner(sourceFileLike.text, languageVariant, range.pos, range.end, function (scanner) { return formatSpanWorker(range, node, initialIndentation, delta, scanner, formatContext, 1 /* FormatSelection */, function (_) { return false; }, // assume that node does not have any errors
	            sourceFileLike); });
	        }
	        formatting.formatNodeGivenIndentation = formatNodeGivenIndentation;
	        function formatNodeLines(node, sourceFile, formatContext, requestKind) {
	            if (!node) {
	                return [];
	            }
	            var span = {
	                pos: ts.getLineStartPositionForPosition(node.getStart(sourceFile), sourceFile),
	                end: node.end
	            };
	            return formatSpan(span, sourceFile, formatContext, requestKind);
	        }
	        function formatSpan(originalRange, sourceFile, formatContext, requestKind) {
	            // find the smallest node that fully wraps the range and compute the initial indentation for the node
	            var enclosingNode = findEnclosingNode(originalRange, sourceFile);
	            return formatting.getFormattingScanner(sourceFile.text, sourceFile.languageVariant, getScanStartPosition(enclosingNode, originalRange, sourceFile), originalRange.end, function (scanner) { return formatSpanWorker(originalRange, enclosingNode, formatting.SmartIndenter.getIndentationForNode(enclosingNode, originalRange, sourceFile, formatContext.options), getOwnOrInheritedDelta(enclosingNode, formatContext.options, sourceFile), scanner, formatContext, requestKind, prepareRangeContainsErrorFunction(sourceFile.parseDiagnostics, originalRange), sourceFile); });
	        }
	        function formatSpanWorker(originalRange, enclosingNode, initialIndentation, delta, formattingScanner, _a, requestKind, rangeContainsError, sourceFile) {
	            var options = _a.options, getRule = _a.getRule;
	            // formatting context is used by rules provider
	            var formattingContext = new formatting.FormattingContext(sourceFile, requestKind, options);
	            var previousRange;
	            var previousParent;
	            var previousRangeStartLine;
	            var lastIndentedLine;
	            var indentationOnLastIndentedLine;
	            var edits = [];
	            formattingScanner.advance();
	            if (formattingScanner.isOnToken()) {
	                var startLine = sourceFile.getLineAndCharacterOfPosition(enclosingNode.getStart(sourceFile)).line;
	                var undecoratedStartLine = startLine;
	                if (enclosingNode.decorators) {
	                    undecoratedStartLine = sourceFile.getLineAndCharacterOfPosition(ts.getNonDecoratorTokenPosOfNode(enclosingNode, sourceFile)).line;
	                }
	                processNode(enclosingNode, enclosingNode, startLine, undecoratedStartLine, initialIndentation, delta);
	            }
	            if (!formattingScanner.isOnToken()) {
	                var leadingTrivia = formattingScanner.getCurrentLeadingTrivia();
	                if (leadingTrivia) {
	                    processTrivia(leadingTrivia, enclosingNode, enclosingNode, /*dynamicIndentation*/ undefined);
	                    trimTrailingWhitespacesForRemainingRange();
	                }
	            }
	            return edits;
	            // local functions
	            /** Tries to compute the indentation for a list element.
	             * If list element is not in range then
	             * function will pick its actual indentation
	             * so it can be pushed downstream as inherited indentation.
	             * If list element is in the range - its indentation will be equal
	             * to inherited indentation from its predecessors.
	             */
	            function tryComputeIndentationForListItem(startPos, endPos, parentStartLine, range, inheritedIndentation) {
	                if (ts.rangeOverlapsWithStartEnd(range, startPos, endPos) ||
	                    ts.rangeContainsStartEnd(range, startPos, endPos) /* Not to miss zero-range nodes e.g. JsxText */) {
	                    if (inheritedIndentation !== -1 /* Unknown */) {
	                        return inheritedIndentation;
	                    }
	                }
	                else {
	                    var startLine = sourceFile.getLineAndCharacterOfPosition(startPos).line;
	                    var startLinePosition = ts.getLineStartPositionForPosition(startPos, sourceFile);
	                    var column = formatting.SmartIndenter.findFirstNonWhitespaceColumn(startLinePosition, startPos, sourceFile, options);
	                    if (startLine !== parentStartLine || startPos === column) {
	                        // Use the base indent size if it is greater than
	                        // the indentation of the inherited predecessor.
	                        var baseIndentSize = formatting.SmartIndenter.getBaseIndentation(options);
	                        return baseIndentSize > column ? baseIndentSize : column;
	                    }
	                }
	                return -1 /* Unknown */;
	            }
	            function computeIndentation(node, startLine, inheritedIndentation, parent, parentDynamicIndentation, effectiveParentStartLine) {
	                var delta = formatting.SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
	                if (effectiveParentStartLine === startLine) {
	                    // if node is located on the same line with the parent
	                    // - inherit indentation from the parent
	                    // - push children if either parent of node itself has non-zero delta
	                    return {
	                        indentation: startLine === lastIndentedLine ? indentationOnLastIndentedLine : parentDynamicIndentation.getIndentation(),
	                        delta: Math.min(options.indentSize, parentDynamicIndentation.getDelta(node) + delta)
	                    };
	                }
	                else if (inheritedIndentation === -1 /* Unknown */) {
	                    if (node.kind === 19 /* OpenParenToken */ && startLine === lastIndentedLine) {
	                        // the is used for chaining methods formatting
	                        // - we need to get the indentation on last line and the delta of parent
	                        return { indentation: indentationOnLastIndentedLine, delta: parentDynamicIndentation.getDelta(node) };
	                    }
	                    else if (formatting.SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement(parent, node, startLine, sourceFile)) {
	                        return { indentation: parentDynamicIndentation.getIndentation(), delta: delta };
	                    }
	                    else {
	                        return { indentation: parentDynamicIndentation.getIndentation() + parentDynamicIndentation.getDelta(node), delta: delta };
	                    }
	                }
	                else {
	                    return { indentation: inheritedIndentation, delta: delta };
	                }
	            }
	            function getFirstNonDecoratorTokenOfNode(node) {
	                if (node.modifiers && node.modifiers.length) {
	                    return node.modifiers[0].kind;
	                }
	                switch (node.kind) {
	                    case 234 /* ClassDeclaration */: return 75 /* ClassKeyword */;
	                    case 235 /* InterfaceDeclaration */: return 109 /* InterfaceKeyword */;
	                    case 233 /* FunctionDeclaration */: return 89 /* FunctionKeyword */;
	                    case 237 /* EnumDeclaration */: return 237 /* EnumDeclaration */;
	                    case 155 /* GetAccessor */: return 125 /* GetKeyword */;
	                    case 156 /* SetAccessor */: return 136 /* SetKeyword */;
	                    case 153 /* MethodDeclaration */:
	                        if (node.asteriskToken) {
	                            return 39 /* AsteriskToken */;
	                        }
	                    // falls through
	                    case 151 /* PropertyDeclaration */:
	                    case 148 /* Parameter */:
	                        return ts.getNameOfDeclaration(node).kind;
	                }
	            }
	            function getDynamicIndentation(node, nodeStartLine, indentation, delta) {
	                return {
	                    getIndentationForComment: function (kind, tokenIndentation, container) {
	                        switch (kind) {
	                            // preceding comment to the token that closes the indentation scope inherits the indentation from the scope
	                            // ..  {
	                            //     // comment
	                            // }
	                            case 18 /* CloseBraceToken */:
	                            case 22 /* CloseBracketToken */:
	                            case 20 /* CloseParenToken */:
	                                return indentation + getDelta(container);
	                        }
	                        return tokenIndentation !== -1 /* Unknown */ ? tokenIndentation : indentation;
	                    },
	                    getIndentationForToken: function (line, kind, container) {
	                        return shouldAddDelta(line, kind, container) ? indentation + getDelta(container) : indentation;
	                    },
	                    getIndentation: function () { return indentation; },
	                    getDelta: getDelta,
	                    recomputeIndentation: function (lineAdded) {
	                        if (node.parent && formatting.SmartIndenter.shouldIndentChildNode(options, node.parent, node, sourceFile)) {
	                            indentation += lineAdded ? options.indentSize : -options.indentSize;
	                            delta = formatting.SmartIndenter.shouldIndentChildNode(options, node) ? options.indentSize : 0;
	                        }
	                    }
	                };
	                function shouldAddDelta(line, kind, container) {
	                    switch (kind) {
	                        // open and close brace, 'else' and 'while' (in do statement) tokens has indentation of the parent
	                        case 17 /* OpenBraceToken */:
	                        case 18 /* CloseBraceToken */:
	                        case 19 /* OpenParenToken */:
	                        case 20 /* CloseParenToken */:
	                        case 82 /* ElseKeyword */:
	                        case 106 /* WhileKeyword */:
	                        case 57 /* AtToken */:
	                            return false;
	                        case 41 /* SlashToken */:
	                        case 29 /* GreaterThanToken */:
	                            switch (container.kind) {
	                                case 256 /* JsxOpeningElement */:
	                                case 257 /* JsxClosingElement */:
	                                case 255 /* JsxSelfClosingElement */:
	                                    return false;
	                            }
	                            break;
	                        case 21 /* OpenBracketToken */:
	                        case 22 /* CloseBracketToken */:
	                            if (container.kind !== 176 /* MappedType */) {
	                                return false;
	                            }
	                            break;
	                    }
	                    // if token line equals to the line of containing node (this is a first token in the node) - use node indentation
	                    return nodeStartLine !== line
	                        // if this token is the first token following the list of decorators, we do not need to indent
	                        && !(node.decorators && kind === getFirstNonDecoratorTokenOfNode(node));
	                }
	                function getDelta(child) {
	                    // Delta value should be zero when the node explicitly prevents indentation of the child node
	                    return formatting.SmartIndenter.nodeWillIndentChild(options, node, child, sourceFile, /*indentByDefault*/ true) ? delta : 0;
	                }
	            }
	            function processNode(node, contextNode, nodeStartLine, undecoratedNodeStartLine, indentation, delta) {
	                if (!ts.rangeOverlapsWithStartEnd(originalRange, node.getStart(sourceFile), node.getEnd())) {
	                    return;
	                }
	                var nodeDynamicIndentation = getDynamicIndentation(node, nodeStartLine, indentation, delta);
	                // a useful observations when tracking context node
	                //        /
	                //      [a]
	                //   /   |   \
	                //  [b] [c] [d]
	                // node 'a' is a context node for nodes 'b', 'c', 'd'
	                // except for the leftmost leaf token in [b] - in this case context node ('e') is located somewhere above 'a'
	                // this rule can be applied recursively to child nodes of 'a'.
	                //
	                // context node is set to parent node value after processing every child node
	                // context node is set to parent of the token after processing every token
	                var childContextNode = contextNode;
	                // if there are any tokens that logically belong to node and interleave child nodes
	                // such tokens will be consumed in processChildNode for the child that follows them
	                ts.forEachChild(node, function (child) {
	                    processChildNode(child, /*inheritedIndentation*/ -1 /* Unknown */, node, nodeDynamicIndentation, nodeStartLine, undecoratedNodeStartLine, /*isListItem*/ false);
	                }, function (nodes) {
	                    processChildNodes(nodes, node, nodeStartLine, nodeDynamicIndentation);
	                });
	                // proceed any tokens in the node that are located after child nodes
	                while (formattingScanner.isOnToken()) {
	                    var tokenInfo = formattingScanner.readTokenInfo(node);
	                    if (tokenInfo.token.end > node.end) {
	                        break;
	                    }
	                    consumeTokenAndAdvanceScanner(tokenInfo, node, nodeDynamicIndentation, node);
	                }
	                function processChildNode(child, inheritedIndentation, parent, parentDynamicIndentation, parentStartLine, undecoratedParentStartLine, isListItem, isFirstListItem) {
	                    var childStartPos = child.getStart(sourceFile);
	                    var childStartLine = sourceFile.getLineAndCharacterOfPosition(childStartPos).line;
	                    var undecoratedChildStartLine = childStartLine;
	                    if (child.decorators) {
	                        undecoratedChildStartLine = sourceFile.getLineAndCharacterOfPosition(ts.getNonDecoratorTokenPosOfNode(child, sourceFile)).line;
	                    }
	                    // if child is a list item - try to get its indentation, only if parent is within the original range.
	                    var childIndentationAmount = -1 /* Unknown */;
	                    if (isListItem && ts.rangeContainsRange(originalRange, parent)) {
	                        childIndentationAmount = tryComputeIndentationForListItem(childStartPos, child.end, parentStartLine, originalRange, inheritedIndentation);
	                        if (childIndentationAmount !== -1 /* Unknown */) {
	                            inheritedIndentation = childIndentationAmount;
	                        }
	                    }
	                    // child node is outside the target range - do not dive inside
	                    if (!ts.rangeOverlapsWithStartEnd(originalRange, child.pos, child.end)) {
	                        if (child.end < originalRange.pos) {
	                            formattingScanner.skipToEndOf(child);
	                        }
	                        return inheritedIndentation;
	                    }
	                    if (child.getFullWidth() === 0) {
	                        return inheritedIndentation;
	                    }
	                    while (formattingScanner.isOnToken()) {
	                        // proceed any parent tokens that are located prior to child.getStart()
	                        var tokenInfo = formattingScanner.readTokenInfo(node);
	                        if (tokenInfo.token.end > childStartPos) {
	                            // stop when formatting scanner advances past the beginning of the child
	                            break;
	                        }
	                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, node);
	                    }
	                    if (!formattingScanner.isOnToken()) {
	                        return inheritedIndentation;
	                    }
	                    // JSX text shouldn't affect indenting
	                    if (ts.isToken(child) && child.kind !== 10 /* JsxText */) {
	                        // if child node is a token, it does not impact indentation, proceed it using parent indentation scope rules
	                        var tokenInfo = formattingScanner.readTokenInfo(child);
	                        ts.Debug.assert(tokenInfo.token.end === child.end, "Token end is child end");
	                        consumeTokenAndAdvanceScanner(tokenInfo, node, parentDynamicIndentation, child);
	                        return inheritedIndentation;
	                    }
	                    var effectiveParentStartLine = child.kind === 149 /* Decorator */ ? childStartLine : undecoratedParentStartLine;
	                    var childIndentation = computeIndentation(child, childStartLine, childIndentationAmount, node, parentDynamicIndentation, effectiveParentStartLine);
	                    processNode(child, childContextNode, childStartLine, undecoratedChildStartLine, childIndentation.indentation, childIndentation.delta);
	                    if (child.kind === 10 /* JsxText */) {
	                        var range = { pos: child.getStart(), end: child.getEnd() };
	                        indentMultilineCommentOrJsxText(range, childIndentation.indentation, /*firstLineIsIndented*/ true, /*indentFinalLine*/ false);
	                    }
	                    childContextNode = node;
	                    if (isFirstListItem && parent.kind === 182 /* ArrayLiteralExpression */ && inheritedIndentation === -1 /* Unknown */) {
	                        inheritedIndentation = childIndentation.indentation;
	                    }
	                    return inheritedIndentation;
	                }
	                function processChildNodes(nodes, parent, parentStartLine, parentDynamicIndentation) {
	                    ts.Debug.assert(ts.isNodeArray(nodes));
	                    var listStartToken = getOpenTokenForList(parent, nodes);
	                    var listEndToken = getCloseTokenForOpenToken(listStartToken);
	                    var listDynamicIndentation = parentDynamicIndentation;
	                    var startLine = parentStartLine;
	                    if (listStartToken !== 0 /* Unknown */) {
	                        // introduce a new indentation scope for lists (including list start and end tokens)
	                        while (formattingScanner.isOnToken()) {
	                            var tokenInfo = formattingScanner.readTokenInfo(parent);
	                            if (tokenInfo.token.end > nodes.pos) {
	                                // stop when formatting scanner moves past the beginning of node list
	                                break;
	                            }
	                            else if (tokenInfo.token.kind === listStartToken) {
	                                // consume list start token
	                                startLine = sourceFile.getLineAndCharacterOfPosition(tokenInfo.token.pos).line;
	                                var indentation_2 = computeIndentation(tokenInfo.token, startLine, -1 /* Unknown */, parent, parentDynamicIndentation, parentStartLine);
	                                listDynamicIndentation = getDynamicIndentation(parent, parentStartLine, indentation_2.indentation, indentation_2.delta);
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, listDynamicIndentation, parent);
	                            }
	                            else {
	                                // consume any tokens that precede the list as child elements of 'node' using its indentation scope
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, parentDynamicIndentation, parent);
	                            }
	                        }
	                    }
	                    var inheritedIndentation = -1 /* Unknown */;
	                    for (var i = 0; i < nodes.length; i++) {
	                        var child = nodes[i];
	                        inheritedIndentation = processChildNode(child, inheritedIndentation, node, listDynamicIndentation, startLine, startLine, /*isListItem*/ true, /*isFirstListItem*/ i === 0);
	                    }
	                    if (listEndToken !== 0 /* Unknown */) {
	                        if (formattingScanner.isOnToken()) {
	                            var tokenInfo = formattingScanner.readTokenInfo(parent);
	                            // consume the list end token only if it is still belong to the parent
	                            // there might be the case when current token matches end token but does not considered as one
	                            // function (x: function) <--
	                            // without this check close paren will be interpreted as list end token for function expression which is wrong
	                            if (tokenInfo.token.kind === listEndToken && ts.rangeContainsRange(parent, tokenInfo.token)) {
	                                // consume list end token
	                                consumeTokenAndAdvanceScanner(tokenInfo, parent, listDynamicIndentation, parent);
	                            }
	                        }
	                    }
	                }
	                function consumeTokenAndAdvanceScanner(currentTokenInfo, parent, dynamicIndentation, container) {
	                    ts.Debug.assert(ts.rangeContainsRange(parent, currentTokenInfo.token));
	                    var lastTriviaWasNewLine = formattingScanner.lastTrailingTriviaWasNewLine();
	                    var indentToken = false;
	                    if (currentTokenInfo.leadingTrivia) {
	                        processTrivia(currentTokenInfo.leadingTrivia, parent, childContextNode, dynamicIndentation);
	                    }
	                    var lineAction = 0 /* None */;
	                    var isTokenInRange = ts.rangeContainsRange(originalRange, currentTokenInfo.token);
	                    var tokenStart = sourceFile.getLineAndCharacterOfPosition(currentTokenInfo.token.pos);
	                    if (isTokenInRange) {
	                        var rangeHasError = rangeContainsError(currentTokenInfo.token);
	                        // save previousRange since processRange will overwrite this value with current one
	                        var savePreviousRange = previousRange;
	                        lineAction = processRange(currentTokenInfo.token, tokenStart, parent, childContextNode, dynamicIndentation);
	                        // do not indent comments\token if token range overlaps with some error
	                        if (!rangeHasError) {
	                            if (lineAction === 0 /* None */) {
	                                // indent token only if end line of previous range does not match start line of the token
	                                var prevEndLine = savePreviousRange && sourceFile.getLineAndCharacterOfPosition(savePreviousRange.end).line;
	                                indentToken = lastTriviaWasNewLine && tokenStart.line !== prevEndLine;
	                            }
	                            else {
	                                indentToken = lineAction === 1 /* LineAdded */;
	                            }
	                        }
	                    }
	                    if (currentTokenInfo.trailingTrivia) {
	                        processTrivia(currentTokenInfo.trailingTrivia, parent, childContextNode, dynamicIndentation);
	                    }
	                    if (indentToken) {
	                        var tokenIndentation = (isTokenInRange && !rangeContainsError(currentTokenInfo.token)) ?
	                            dynamicIndentation.getIndentationForToken(tokenStart.line, currentTokenInfo.token.kind, container) :
	                            -1 /* Unknown */;
	                        var indentNextTokenOrTrivia = true;
	                        if (currentTokenInfo.leadingTrivia) {
	                            var commentIndentation = dynamicIndentation.getIndentationForComment(currentTokenInfo.token.kind, tokenIndentation, container);
	                            for (var _i = 0, _a = currentTokenInfo.leadingTrivia; _i < _a.length; _i++) {
	                                var triviaItem = _a[_i];
	                                var triviaInRange = ts.rangeContainsRange(originalRange, triviaItem);
	                                switch (triviaItem.kind) {
	                                    case 3 /* MultiLineCommentTrivia */:
	                                        if (triviaInRange) {
	                                            indentMultilineCommentOrJsxText(triviaItem, commentIndentation, /*firstLineIsIndented*/ !indentNextTokenOrTrivia);
	                                        }
	                                        indentNextTokenOrTrivia = false;
	                                        break;
	                                    case 2 /* SingleLineCommentTrivia */:
	                                        if (indentNextTokenOrTrivia && triviaInRange) {
	                                            insertIndentation(triviaItem.pos, commentIndentation, /*lineAdded*/ false);
	                                        }
	                                        indentNextTokenOrTrivia = false;
	                                        break;
	                                    case 4 /* NewLineTrivia */:
	                                        indentNextTokenOrTrivia = true;
	                                        break;
	                                }
	                            }
	                        }
	                        // indent token only if is it is in target range and does not overlap with any error ranges
	                        if (tokenIndentation !== -1 /* Unknown */ && indentNextTokenOrTrivia) {
	                            insertIndentation(currentTokenInfo.token.pos, tokenIndentation, lineAction === 1 /* LineAdded */);
	                            lastIndentedLine = tokenStart.line;
	                            indentationOnLastIndentedLine = tokenIndentation;
	                        }
	                    }
	                    formattingScanner.advance();
	                    childContextNode = parent;
	                }
	            }
	            function processTrivia(trivia, parent, contextNode, dynamicIndentation) {
	                for (var _i = 0, trivia_1 = trivia; _i < trivia_1.length; _i++) {
	                    var triviaItem = trivia_1[_i];
	                    if (ts.isComment(triviaItem.kind) && ts.rangeContainsRange(originalRange, triviaItem)) {
	                        var triviaItemStart = sourceFile.getLineAndCharacterOfPosition(triviaItem.pos);
	                        processRange(triviaItem, triviaItemStart, parent, contextNode, dynamicIndentation);
	                    }
	                }
	            }
	            function processRange(range, rangeStart, parent, contextNode, dynamicIndentation) {
	                var rangeHasError = rangeContainsError(range);
	                var lineAction = 0 /* None */;
	                if (!rangeHasError) {
	                    if (!previousRange) {
	                        // trim whitespaces starting from the beginning of the span up to the current line
	                        var originalStart = sourceFile.getLineAndCharacterOfPosition(originalRange.pos);
	                        trimTrailingWhitespacesForLines(originalStart.line, rangeStart.line);
	                    }
	                    else {
	                        lineAction =
	                            processPair(range, rangeStart.line, parent, previousRange, previousRangeStartLine, previousParent, contextNode, dynamicIndentation);
	                    }
	                }
	                previousRange = range;
	                previousParent = parent;
	                previousRangeStartLine = rangeStart.line;
	                return lineAction;
	            }
	            function processPair(currentItem, currentStartLine, currentParent, previousItem, previousStartLine, previousParent, contextNode, dynamicIndentation) {
	                formattingContext.updateContext(previousItem, previousParent, currentItem, currentParent, contextNode);
	                var rule = getRule(formattingContext);
	                var trimTrailingWhitespaces;
	                var lineAction = 0 /* None */;
	                if (rule) {
	                    lineAction = applyRuleEdits(rule, previousItem, previousStartLine, currentItem, currentStartLine);
	                    switch (lineAction) {
	                        case 2 /* LineRemoved */:
	                            // Handle the case where the next line is moved to be the end of this line.
	                            // In this case we don't indent the next line in the next pass.
	                            if (currentParent.getStart(sourceFile) === currentItem.pos) {
	                                dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ false);
	                            }
	                            break;
	                        case 1 /* LineAdded */:
	                            // Handle the case where token2 is moved to the new line.
	                            // In this case we indent token2 in the next pass but we set
	                            // sameLineIndent flag to notify the indenter that the indentation is within the line.
	                            if (currentParent.getStart(sourceFile) === currentItem.pos) {
	                                dynamicIndentation.recomputeIndentation(/*lineAddedByFormatting*/ true);
	                            }
	                            break;
	                        default:
	                            ts.Debug.assert(lineAction === 0 /* None */);
	                    }
	                    // We need to trim trailing whitespace between the tokens if they were on different lines, and no rule was applied to put them on the same line
	                    trimTrailingWhitespaces = !(rule.action & 8 /* Delete */) && rule.flags !== 1 /* CanDeleteNewLines */;
	                }
	                else {
	                    trimTrailingWhitespaces = true;
	                }
	                if (currentStartLine !== previousStartLine && trimTrailingWhitespaces) {
	                    // We need to trim trailing whitespace between the tokens if they were on different lines, and no rule was applied to put them on the same line
	                    trimTrailingWhitespacesForLines(previousStartLine, currentStartLine, previousItem);
	                }
	                return lineAction;
	            }
	            function insertIndentation(pos, indentation, lineAdded) {
	                var indentationString = getIndentationString(indentation, options);
	                if (lineAdded) {
	                    // new line is added before the token by the formatting rules
	                    // insert indentation string at the very beginning of the token
	                    recordReplace(pos, 0, indentationString);
	                }
	                else {
	                    var tokenStart = sourceFile.getLineAndCharacterOfPosition(pos);
	                    var startLinePosition = ts.getStartPositionOfLine(tokenStart.line, sourceFile);
	                    if (indentation !== characterToColumn(startLinePosition, tokenStart.character) || indentationIsDifferent(indentationString, startLinePosition)) {
	                        recordReplace(startLinePosition, tokenStart.character, indentationString);
	                    }
	                }
	            }
	            function characterToColumn(startLinePosition, characterInLine) {
	                var column = 0;
	                for (var i = 0; i < characterInLine; i++) {
	                    if (sourceFile.text.charCodeAt(startLinePosition + i) === 9 /* tab */) {
	                        column += options.tabSize - column % options.tabSize;
	                    }
	                    else {
	                        column++;
	                    }
	                }
	                return column;
	            }
	            function indentationIsDifferent(indentationString, startLinePosition) {
	                return indentationString !== sourceFile.text.substr(startLinePosition, indentationString.length);
	            }
	            function indentMultilineCommentOrJsxText(commentRange, indentation, firstLineIsIndented, indentFinalLine) {
	                if (indentFinalLine === void 0) { indentFinalLine = true; }
	                // split comment in lines
	                var startLine = sourceFile.getLineAndCharacterOfPosition(commentRange.pos).line;
	                var endLine = sourceFile.getLineAndCharacterOfPosition(commentRange.end).line;
	                var parts;
	                if (startLine === endLine) {
	                    if (!firstLineIsIndented) {
	                        // treat as single line comment
	                        insertIndentation(commentRange.pos, indentation, /*lineAdded*/ false);
	                    }
	                    return;
	                }
	                else {
	                    parts = [];
	                    var startPos = commentRange.pos;
	                    for (var line = startLine; line < endLine; line++) {
	                        var endOfLine = ts.getEndLinePosition(line, sourceFile);
	                        parts.push({ pos: startPos, end: endOfLine });
	                        startPos = ts.getStartPositionOfLine(line + 1, sourceFile);
	                    }
	                    if (indentFinalLine) {
	                        parts.push({ pos: startPos, end: commentRange.end });
	                    }
	                }
	                var startLinePos = ts.getStartPositionOfLine(startLine, sourceFile);
	                var nonWhitespaceColumnInFirstPart = formatting.SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(startLinePos, parts[0].pos, sourceFile, options);
	                if (indentation === nonWhitespaceColumnInFirstPart.column) {
	                    return;
	                }
	                var startIndex = 0;
	                if (firstLineIsIndented) {
	                    startIndex = 1;
	                    startLine++;
	                }
	                // shift all parts on the delta size
	                var delta = indentation - nonWhitespaceColumnInFirstPart.column;
	                for (var i = startIndex; i < parts.length; i++, startLine++) {
	                    var startLinePos_1 = ts.getStartPositionOfLine(startLine, sourceFile);
	                    var nonWhitespaceCharacterAndColumn = i === 0
	                        ? nonWhitespaceColumnInFirstPart
	                        : formatting.SmartIndenter.findFirstNonWhitespaceCharacterAndColumn(parts[i].pos, parts[i].end, sourceFile, options);
	                    var newIndentation = nonWhitespaceCharacterAndColumn.column + delta;
	                    if (newIndentation > 0) {
	                        var indentationString = getIndentationString(newIndentation, options);
	                        recordReplace(startLinePos_1, nonWhitespaceCharacterAndColumn.character, indentationString);
	                    }
	                    else {
	                        recordDelete(startLinePos_1, nonWhitespaceCharacterAndColumn.character);
	                    }
	                }
	            }
	            function trimTrailingWhitespacesForLines(line1, line2, range) {
	                for (var line = line1; line < line2; line++) {
	                    var lineStartPosition = ts.getStartPositionOfLine(line, sourceFile);
	                    var lineEndPosition = ts.getEndLinePosition(line, sourceFile);
	                    // do not trim whitespaces in comments or template expression
	                    if (range && (ts.isComment(range.kind) || ts.isStringOrRegularExpressionOrTemplateLiteral(range.kind)) && range.pos <= lineEndPosition && range.end > lineEndPosition) {
	                        continue;
	                    }
	                    var whitespaceStart = getTrailingWhitespaceStartPosition(lineStartPosition, lineEndPosition);
	                    if (whitespaceStart !== -1) {
	                        ts.Debug.assert(whitespaceStart === lineStartPosition || !ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(whitespaceStart - 1)));
	                        recordDelete(whitespaceStart, lineEndPosition + 1 - whitespaceStart);
	                    }
	                }
	            }
	            /**
	             * @param start The position of the first character in range
	             * @param end The position of the last character in range
	             */
	            function getTrailingWhitespaceStartPosition(start, end) {
	                var pos = end;
	                while (pos >= start && ts.isWhiteSpaceSingleLine(sourceFile.text.charCodeAt(pos))) {
	                    pos--;
	                }
	                if (pos !== end) {
	                    return pos + 1;
	                }
	                return -1;
	            }
	            /**
	             * Trimming will be done for lines after the previous range
	             */
	            function trimTrailingWhitespacesForRemainingRange() {
	                var startPosition = previousRange ? previousRange.end : originalRange.pos;
	                var startLine = sourceFile.getLineAndCharacterOfPosition(startPosition).line;
	                var endLine = sourceFile.getLineAndCharacterOfPosition(originalRange.end).line;
	                trimTrailingWhitespacesForLines(startLine, endLine + 1, previousRange);
	            }
	            function recordDelete(start, len) {
	                if (len) {
	                    edits.push(ts.createTextChangeFromStartLength(start, len, ""));
	                }
	            }
	            function recordReplace(start, len, newText) {
	                if (len || newText) {
	                    edits.push(ts.createTextChangeFromStartLength(start, len, newText));
	                }
	            }
	            function applyRuleEdits(rule, previousRange, previousStartLine, currentRange, currentStartLine) {
	                var onLaterLine = currentStartLine !== previousStartLine;
	                switch (rule.action) {
	                    case 1 /* Ignore */:
	                        // no action required
	                        return 0 /* None */;
	                    case 8 /* Delete */:
	                        if (previousRange.end !== currentRange.pos) {
	                            // delete characters starting from t1.end up to t2.pos exclusive
	                            recordDelete(previousRange.end, currentRange.pos - previousRange.end);
	                            return onLaterLine ? 2 /* LineRemoved */ : 0 /* None */;
	                        }
	                        break;
	                    case 4 /* NewLine */:
	                        // exit early if we on different lines and rule cannot change number of newlines
	                        // if line1 and line2 are on subsequent lines then no edits are required - ok to exit
	                        // if line1 and line2 are separated with more than one newline - ok to exit since we cannot delete extra new lines
	                        if (rule.flags !== 1 /* CanDeleteNewLines */ && previousStartLine !== currentStartLine) {
	                            return 0 /* None */;
	                        }
	                        // edit should not be applied if we have one line feed between elements
	                        var lineDelta = currentStartLine - previousStartLine;
	                        if (lineDelta !== 1) {
	                            recordReplace(previousRange.end, currentRange.pos - previousRange.end, options.newLineCharacter);
	                            return onLaterLine ? 0 /* None */ : 1 /* LineAdded */;
	                        }
	                        break;
	                    case 2 /* Space */:
	                        // exit early if we on different lines and rule cannot change number of newlines
	                        if (rule.flags !== 1 /* CanDeleteNewLines */ && previousStartLine !== currentStartLine) {
	                            return 0 /* None */;
	                        }
	                        var posDelta = currentRange.pos - previousRange.end;
	                        if (posDelta !== 1 || sourceFile.text.charCodeAt(previousRange.end) !== 32 /* space */) {
	                            recordReplace(previousRange.end, currentRange.pos - previousRange.end, " ");
	                            return onLaterLine ? 2 /* LineRemoved */ : 0 /* None */;
	                        }
	                }
	                return 0 /* None */;
	            }
	        }
	        var LineAction;
	        (function (LineAction) {
	            LineAction[LineAction["None"] = 0] = "None";
	            LineAction[LineAction["LineAdded"] = 1] = "LineAdded";
	            LineAction[LineAction["LineRemoved"] = 2] = "LineRemoved";
	        })(LineAction || (LineAction = {}));
	        /**
	         * @param precedingToken pass `null` if preceding token was already computed and result was `undefined`.
	         */
	        function getRangeOfEnclosingComment(sourceFile, position, onlyMultiLine, precedingToken, // tslint:disable-line:no-null-keyword
	        tokenAtPosition, predicate) {
	            if (tokenAtPosition === void 0) { tokenAtPosition = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false); }
	            var tokenStart = tokenAtPosition.getStart(sourceFile);
	            if (tokenStart <= position && position < tokenAtPosition.getEnd()) {
	                return undefined;
	            }
	            if (precedingToken === undefined) {
	                precedingToken = ts.findPrecedingToken(position, sourceFile);
	            }
	            // Between two consecutive tokens, all comments are either trailing on the former
	            // or leading on the latter (and none are in both lists).
	            var trailingRangesOfPreviousToken = precedingToken && ts.getTrailingCommentRanges(sourceFile.text, precedingToken.end);
	            var leadingCommentRangesOfNextToken = ts.getLeadingCommentRangesOfNode(tokenAtPosition, sourceFile);
	            var commentRanges = trailingRangesOfPreviousToken && leadingCommentRangesOfNextToken ?
	                trailingRangesOfPreviousToken.concat(leadingCommentRangesOfNextToken) :
	                trailingRangesOfPreviousToken || leadingCommentRangesOfNextToken;
	            if (commentRanges) {
	                for (var _i = 0, commentRanges_1 = commentRanges; _i < commentRanges_1.length; _i++) {
	                    var range = commentRanges_1[_i];
	                    // The end marker of a single-line comment does not include the newline character.
	                    // With caret at `^`, in the following case, we are inside a comment (^ denotes the cursor position):
	                    //
	                    //    // asdf   ^\n
	                    //
	                    // But for closed multi-line comments, we don't want to be inside the comment in the following case:
	                    //
	                    //    /* asdf */^
	                    //
	                    // However, unterminated multi-line comments *do* contain their end.
	                    //
	                    // Internally, we represent the end of the comment at the newline and closing '/', respectively.
	                    //
	                    if ((range.pos < position && position < range.end ||
	                        position === range.end && (range.kind === 2 /* SingleLineCommentTrivia */ || position === sourceFile.getFullWidth()))) {
	                        return (range.kind === 3 /* MultiLineCommentTrivia */ || !onlyMultiLine) && (!predicate || predicate(range)) ? range : undefined;
	                    }
	                }
	            }
	            return undefined;
	        }
	        formatting.getRangeOfEnclosingComment = getRangeOfEnclosingComment;
	        function getOpenTokenForList(node, list) {
	            switch (node.kind) {
	                case 154 /* Constructor */:
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 192 /* ArrowFunction */:
	                    if (node.typeParameters === list) {
	                        return 27 /* LessThanToken */;
	                    }
	                    else if (node.parameters === list) {
	                        return 19 /* OpenParenToken */;
	                    }
	                    break;
	                case 186 /* CallExpression */:
	                case 187 /* NewExpression */:
	                    if (node.typeArguments === list) {
	                        return 27 /* LessThanToken */;
	                    }
	                    else if (node.arguments === list) {
	                        return 19 /* OpenParenToken */;
	                    }
	                    break;
	                case 161 /* TypeReference */:
	                    if (node.typeArguments === list) {
	                        return 27 /* LessThanToken */;
	                    }
	            }
	            return 0 /* Unknown */;
	        }
	        function getCloseTokenForOpenToken(kind) {
	            switch (kind) {
	                case 19 /* OpenParenToken */:
	                    return 20 /* CloseParenToken */;
	                case 27 /* LessThanToken */:
	                    return 29 /* GreaterThanToken */;
	            }
	            return 0 /* Unknown */;
	        }
	        var internedSizes;
	        var internedTabsIndentation;
	        var internedSpacesIndentation;
	        function getIndentationString(indentation, options) {
	            // reset interned strings if FormatCodeOptions were changed
	            var resetInternedStrings = !internedSizes || (internedSizes.tabSize !== options.tabSize || internedSizes.indentSize !== options.indentSize);
	            if (resetInternedStrings) {
	                internedSizes = { tabSize: options.tabSize, indentSize: options.indentSize };
	                internedTabsIndentation = internedSpacesIndentation = undefined;
	            }
	            if (!options.convertTabsToSpaces) {
	                var tabs = Math.floor(indentation / options.tabSize);
	                var spaces = indentation - tabs * options.tabSize;
	                var tabString = void 0;
	                if (!internedTabsIndentation) {
	                    internedTabsIndentation = [];
	                }
	                if (internedTabsIndentation[tabs] === undefined) {
	                    internedTabsIndentation[tabs] = tabString = ts.repeatString("\t", tabs);
	                }
	                else {
	                    tabString = internedTabsIndentation[tabs];
	                }
	                return spaces ? tabString + ts.repeatString(" ", spaces) : tabString;
	            }
	            else {
	                var spacesString = void 0;
	                var quotient = Math.floor(indentation / options.indentSize);
	                var remainder = indentation % options.indentSize;
	                if (!internedSpacesIndentation) {
	                    internedSpacesIndentation = [];
	                }
	                if (internedSpacesIndentation[quotient] === undefined) {
	                    spacesString = ts.repeatString(" ", options.indentSize * quotient);
	                    internedSpacesIndentation[quotient] = spacesString;
	                }
	                else {
	                    spacesString = internedSpacesIndentation[quotient];
	                }
	                return remainder ? spacesString + ts.repeatString(" ", remainder) : spacesString;
	            }
	        }
	        formatting.getIndentationString = getIndentationString;
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var formatting;
	    (function (formatting) {
	        var SmartIndenter;
	        (function (SmartIndenter) {
	            var Value;
	            (function (Value) {
	                Value[Value["Unknown"] = -1] = "Unknown";
	            })(Value || (Value = {}));
	            /**
	             * @param assumeNewLineBeforeCloseBrace
	             * `false` when called on text from a real source file.
	             * `true` when we need to assume `position` is on a newline.
	             *
	             * This is useful for codefixes. Consider
	             * ```
	             * function f() {
	             * |}
	             * ```
	             * with `position` at `|`.
	             *
	             * When inserting some text after an open brace, we would like to get indentation as if a newline was already there.
	             * By default indentation at `position` will be 0 so 'assumeNewLineBeforeCloseBrace' overrides this behavior.
	             */
	            function getIndentation(position, sourceFile, options, assumeNewLineBeforeCloseBrace) {
	                if (assumeNewLineBeforeCloseBrace === void 0) { assumeNewLineBeforeCloseBrace = false; }
	                if (position > sourceFile.text.length) {
	                    return getBaseIndentation(options); // past EOF
	                }
	                // no indentation when the indent style is set to none,
	                // so we can return fast
	                if (options.indentStyle === ts.IndentStyle.None) {
	                    return 0;
	                }
	                var precedingToken = ts.findPrecedingToken(position, sourceFile);
	                var enclosingCommentRange = formatting.getRangeOfEnclosingComment(sourceFile, position, /*onlyMultiLine*/ true, precedingToken || null); // tslint:disable-line:no-null-keyword
	                if (enclosingCommentRange) {
	                    return getCommentIndent(sourceFile, position, options, enclosingCommentRange);
	                }
	                if (!precedingToken) {
	                    return getBaseIndentation(options);
	                }
	                // no indentation in string \regex\template literals
	                var precedingTokenIsLiteral = ts.isStringOrRegularExpressionOrTemplateLiteral(precedingToken.kind);
	                if (precedingTokenIsLiteral && precedingToken.getStart(sourceFile) <= position && position < precedingToken.end) {
	                    return 0;
	                }
	                var lineAtPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
	                // indentation is first non-whitespace character in a previous line
	                // for block indentation, we should look for a line which contains something that's not
	                // whitespace.
	                if (options.indentStyle === ts.IndentStyle.Block) {
	                    return getBlockIndent(sourceFile, position, options);
	                }
	                if (precedingToken.kind === 26 /* CommaToken */ && precedingToken.parent.kind !== 199 /* BinaryExpression */) {
	                    // previous token is comma that separates items in list - find the previous item and try to derive indentation from it
	                    var actualIndentation = getActualIndentationForListItemBeforeComma(precedingToken, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation;
	                    }
	                }
	                return getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options);
	            }
	            SmartIndenter.getIndentation = getIndentation;
	            function getCommentIndent(sourceFile, position, options, enclosingCommentRange) {
	                var previousLine = ts.getLineAndCharacterOfPosition(sourceFile, position).line - 1;
	                var commentStartLine = ts.getLineAndCharacterOfPosition(sourceFile, enclosingCommentRange.pos).line;
	                ts.Debug.assert(commentStartLine >= 0);
	                if (previousLine <= commentStartLine) {
	                    return findFirstNonWhitespaceColumn(ts.getStartPositionOfLine(commentStartLine, sourceFile), position, sourceFile, options);
	                }
	                var startPostionOfLine = ts.getStartPositionOfLine(previousLine, sourceFile);
	                var _a = findFirstNonWhitespaceCharacterAndColumn(startPostionOfLine, position, sourceFile, options), column = _a.column, character = _a.character;
	                if (column === 0) {
	                    return column;
	                }
	                var firstNonWhitespaceCharacterCode = sourceFile.text.charCodeAt(startPostionOfLine + character);
	                return firstNonWhitespaceCharacterCode === 42 /* asterisk */ ? column - 1 : column;
	            }
	            function getBlockIndent(sourceFile, position, options) {
	                // move backwards until we find a line with a non-whitespace character,
	                // then find the first non-whitespace character for that line.
	                var current = position;
	                while (current > 0) {
	                    var char = sourceFile.text.charCodeAt(current);
	                    if (!ts.isWhiteSpaceLike(char)) {
	                        break;
	                    }
	                    current--;
	                }
	                var lineStart = ts.getLineStartPositionForPosition(current, sourceFile);
	                return findFirstNonWhitespaceColumn(lineStart, current, sourceFile, options);
	            }
	            function getSmartIndent(sourceFile, position, precedingToken, lineAtPosition, assumeNewLineBeforeCloseBrace, options) {
	                // try to find node that can contribute to indentation and includes 'position' starting from 'precedingToken'
	                // if such node is found - compute initial indentation for 'position' inside this node
	                var previous;
	                var current = precedingToken;
	                while (current) {
	                    if (ts.positionBelongsToNode(current, position, sourceFile) && shouldIndentChildNode(options, current, previous, sourceFile, /*isNextChild*/ true)) {
	                        var currentStart = getStartLineAndCharacterForNode(current, sourceFile);
	                        var nextTokenKind = nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile);
	                        var indentationDelta = nextTokenKind !== 0 /* Unknown */
	                            // handle cases when codefix is about to be inserted before the close brace
	                            ? assumeNewLineBeforeCloseBrace && nextTokenKind === 2 /* CloseBrace */ ? options.indentSize : 0
	                            : lineAtPosition !== currentStart.line ? options.indentSize : 0;
	                        return getIndentationForNodeWorker(current, currentStart, /*ignoreActualIndentationRange*/ undefined, indentationDelta, sourceFile, /*isNextChild*/ true, options);
	                    }
	                    // check if current node is a list item - if yes, take indentation from it
	                    var actualIndentation = getActualIndentationForListItem(current, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation;
	                    }
	                    actualIndentation = getLineIndentationWhenExpressionIsInMultiLine(current, sourceFile, options);
	                    if (actualIndentation !== -1 /* Unknown */) {
	                        return actualIndentation + options.indentSize;
	                    }
	                    previous = current;
	                    current = current.parent;
	                }
	                // no parent was found - return the base indentation of the SourceFile
	                return getBaseIndentation(options);
	            }
	            function getIndentationForNode(n, ignoreActualIndentationRange, sourceFile, options) {
	                var start = sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
	                return getIndentationForNodeWorker(n, start, ignoreActualIndentationRange, /*indentationDelta*/ 0, sourceFile, /*isNextChild*/ false, options);
	            }
	            SmartIndenter.getIndentationForNode = getIndentationForNode;
	            function getBaseIndentation(options) {
	                return options.baseIndentSize || 0;
	            }
	            SmartIndenter.getBaseIndentation = getBaseIndentation;
	            function getIndentationForNodeWorker(current, currentStart, ignoreActualIndentationRange, indentationDelta, sourceFile, isNextChild, options) {
	                var parent = current.parent;
	                // Walk up the tree and collect indentation for parent-child node pairs. Indentation is not added if
	                // * parent and child nodes start on the same line, or
	                // * parent is an IfStatement and child starts on the same line as an 'else clause'.
	                while (parent) {
	                    var useActualIndentation = true;
	                    if (ignoreActualIndentationRange) {
	                        var start = current.getStart(sourceFile);
	                        useActualIndentation = start < ignoreActualIndentationRange.pos || start > ignoreActualIndentationRange.end;
	                    }
	                    if (useActualIndentation) {
	                        // check if current node is a list item - if yes, take indentation from it
	                        var actualIndentation = getActualIndentationForListItem(current, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                    }
	                    var containingListOrParentStart = getContainingListOrParentStart(parent, current, sourceFile);
	                    var parentAndChildShareLine = containingListOrParentStart.line === currentStart.line ||
	                        childStartsOnTheSameLineWithElseInIfStatement(parent, current, currentStart.line, sourceFile);
	                    if (useActualIndentation) {
	                        // try to fetch actual indentation for current node from source text
	                        var actualIndentation = getActualIndentationForNode(current, parent, currentStart, parentAndChildShareLine, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                        actualIndentation = getLineIndentationWhenExpressionIsInMultiLine(current, sourceFile, options);
	                        if (actualIndentation !== -1 /* Unknown */) {
	                            return actualIndentation + indentationDelta;
	                        }
	                    }
	                    // increase indentation if parent node wants its content to be indented and parent and child nodes don't start on the same line
	                    if (shouldIndentChildNode(options, parent, current, sourceFile, isNextChild) && !parentAndChildShareLine) {
	                        indentationDelta += options.indentSize;
	                    }
	                    // In our AST, a call argument's `parent` is the call-expression, not the argument list.
	                    // We would like to increase indentation based on the relationship between an argument and its argument-list,
	                    // so we spoof the starting position of the (parent) call-expression to match the (non-parent) argument-list.
	                    // But, the spoofed start-value could then cause a problem when comparing the start position of the call-expression
	                    // to *its* parent (in the case of an iife, an expression statement), adding an extra level of indentation.
	                    //
	                    // Instead, when at an argument, we unspoof the starting position of the enclosing call expression
	                    // *after* applying indentation for the argument.
	                    var useTrueStart = isArgumentAndStartLineOverlapsExpressionBeingCalled(parent, current, currentStart.line, sourceFile);
	                    current = parent;
	                    parent = current.parent;
	                    currentStart = useTrueStart ? sourceFile.getLineAndCharacterOfPosition(current.getStart(sourceFile)) : containingListOrParentStart;
	                }
	                return indentationDelta + getBaseIndentation(options);
	            }
	            function getContainingListOrParentStart(parent, child, sourceFile) {
	                var containingList = getContainingList(child, sourceFile);
	                var startPos = containingList ? containingList.pos : parent.getStart(sourceFile);
	                return sourceFile.getLineAndCharacterOfPosition(startPos);
	            }
	            /*
	             * Function returns Value.Unknown if indentation cannot be determined
	             */
	            function getActualIndentationForListItemBeforeComma(commaToken, sourceFile, options) {
	                // previous token is comma that separates items in list - find the previous item and try to derive indentation from it
	                var commaItemInfo = ts.findListItemInfo(commaToken);
	                if (commaItemInfo && commaItemInfo.listItemIndex > 0) {
	                    return deriveActualIndentationFromList(commaItemInfo.list.getChildren(), commaItemInfo.listItemIndex - 1, sourceFile, options);
	                }
	                else {
	                    // handle broken code gracefully
	                    return -1 /* Unknown */;
	                }
	            }
	            /*
	             * Function returns Value.Unknown if actual indentation for node should not be used (i.e because node is nested expression)
	             */
	            function getActualIndentationForNode(current, parent, currentLineAndChar, parentAndChildShareLine, sourceFile, options) {
	                // actual indentation is used for statements\declarations if one of cases below is true:
	                // - parent is SourceFile - by default immediate children of SourceFile are not indented except when user indents them manually
	                // - parent and child are not on the same line
	                var useActualIndentation = (ts.isDeclaration(current) || ts.isStatementButNotDeclaration(current)) &&
	                    (parent.kind === 273 /* SourceFile */ || !parentAndChildShareLine);
	                if (!useActualIndentation) {
	                    return -1 /* Unknown */;
	                }
	                return findColumnForFirstNonWhitespaceCharacterInLine(currentLineAndChar, sourceFile, options);
	            }
	            var NextTokenKind;
	            (function (NextTokenKind) {
	                NextTokenKind[NextTokenKind["Unknown"] = 0] = "Unknown";
	                NextTokenKind[NextTokenKind["OpenBrace"] = 1] = "OpenBrace";
	                NextTokenKind[NextTokenKind["CloseBrace"] = 2] = "CloseBrace";
	            })(NextTokenKind || (NextTokenKind = {}));
	            function nextTokenIsCurlyBraceOnSameLineAsCursor(precedingToken, current, lineAtPosition, sourceFile) {
	                var nextToken = ts.findNextToken(precedingToken, current, sourceFile);
	                if (!nextToken) {
	                    return 0 /* Unknown */;
	                }
	                if (nextToken.kind === 17 /* OpenBraceToken */) {
	                    // open braces are always indented at the parent level
	                    return 1 /* OpenBrace */;
	                }
	                else if (nextToken.kind === 18 /* CloseBraceToken */) {
	                    // close braces are indented at the parent level if they are located on the same line with cursor
	                    // this means that if new line will be added at $ position, this case will be indented
	                    // class A {
	                    //    $
	                    // }
	                    /// and this one - not
	                    // class A {
	                    // $}
	                    var nextTokenStartLine = getStartLineAndCharacterForNode(nextToken, sourceFile).line;
	                    return lineAtPosition === nextTokenStartLine ? 2 /* CloseBrace */ : 0 /* Unknown */;
	                }
	                return 0 /* Unknown */;
	            }
	            function getStartLineAndCharacterForNode(n, sourceFile) {
	                return sourceFile.getLineAndCharacterOfPosition(n.getStart(sourceFile));
	            }
	            function isArgumentAndStartLineOverlapsExpressionBeingCalled(parent, child, childStartLine, sourceFile) {
	                if (!(ts.isCallExpression(parent) && ts.contains(parent.arguments, child))) {
	                    return false;
	                }
	                var expressionOfCallExpressionEnd = parent.expression.getEnd();
	                var expressionOfCallExpressionEndLine = ts.getLineAndCharacterOfPosition(sourceFile, expressionOfCallExpressionEnd).line;
	                return expressionOfCallExpressionEndLine === childStartLine;
	            }
	            SmartIndenter.isArgumentAndStartLineOverlapsExpressionBeingCalled = isArgumentAndStartLineOverlapsExpressionBeingCalled;
	            function childStartsOnTheSameLineWithElseInIfStatement(parent, child, childStartLine, sourceFile) {
	                if (parent.kind === 216 /* IfStatement */ && parent.elseStatement === child) {
	                    var elseKeyword = ts.findChildOfKind(parent, 82 /* ElseKeyword */, sourceFile);
	                    ts.Debug.assert(elseKeyword !== undefined);
	                    var elseKeywordStartLine = getStartLineAndCharacterForNode(elseKeyword, sourceFile).line;
	                    return elseKeywordStartLine === childStartLine;
	                }
	                return false;
	            }
	            SmartIndenter.childStartsOnTheSameLineWithElseInIfStatement = childStartsOnTheSameLineWithElseInIfStatement;
	            function getListIfStartEndIsInListRange(list, start, end) {
	                return list && ts.rangeContainsStartEnd(list, start, end) ? list : undefined;
	            }
	            function getContainingList(node, sourceFile) {
	                if (node.parent) {
	                    var end = node.end;
	                    switch (node.parent.kind) {
	                        case 161 /* TypeReference */:
	                            return getListIfStartEndIsInListRange(node.parent.typeArguments, node.getStart(sourceFile), end);
	                        case 183 /* ObjectLiteralExpression */:
	                            return node.parent.properties;
	                        case 182 /* ArrayLiteralExpression */:
	                            return node.parent.elements;
	                        case 233 /* FunctionDeclaration */:
	                        case 191 /* FunctionExpression */:
	                        case 192 /* ArrowFunction */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 157 /* CallSignature */:
	                        case 154 /* Constructor */:
	                        case 163 /* ConstructorType */:
	                        case 158 /* ConstructSignature */: {
	                            var start = node.getStart(sourceFile);
	                            return getListIfStartEndIsInListRange(node.parent.typeParameters, start, end) ||
	                                getListIfStartEndIsInListRange(node.parent.parameters, start, end);
	                        }
	                        case 234 /* ClassDeclaration */:
	                            return getListIfStartEndIsInListRange(node.parent.typeParameters, node.getStart(sourceFile), end);
	                        case 187 /* NewExpression */:
	                        case 186 /* CallExpression */: {
	                            var start = node.getStart(sourceFile);
	                            return getListIfStartEndIsInListRange(node.parent.typeArguments, start, end) ||
	                                getListIfStartEndIsInListRange(node.parent.arguments, start, end);
	                        }
	                        case 232 /* VariableDeclarationList */:
	                            return getListIfStartEndIsInListRange(node.parent.declarations, node.getStart(sourceFile), end);
	                        case 246 /* NamedImports */:
	                        case 250 /* NamedExports */:
	                            return getListIfStartEndIsInListRange(node.parent.elements, node.getStart(sourceFile), end);
	                        case 179 /* ObjectBindingPattern */:
	                        case 180 /* ArrayBindingPattern */:
	                            return getListIfStartEndIsInListRange(node.parent.elements, node.getStart(sourceFile), end);
	                    }
	                }
	                return undefined;
	            }
	            SmartIndenter.getContainingList = getContainingList;
	            function getActualIndentationForListItem(node, sourceFile, options) {
	                var containingList = getContainingList(node, sourceFile);
	                if (containingList) {
	                    var index = containingList.indexOf(node);
	                    if (index !== -1) {
	                        return deriveActualIndentationFromList(containingList, index, sourceFile, options);
	                    }
	                }
	                return -1 /* Unknown */;
	            }
	            function getLineIndentationWhenExpressionIsInMultiLine(node, sourceFile, options) {
	                // actual indentation should not be used when:
	                // - node is close parenthesis - this is the end of the expression
	                if (node.kind === 20 /* CloseParenToken */) {
	                    return -1 /* Unknown */;
	                }
	                if (node.parent && ts.isCallOrNewExpression(node.parent) && node.parent.expression !== node) {
	                    var fullCallOrNewExpression = node.parent.expression;
	                    var startingExpression = getStartingExpression(fullCallOrNewExpression);
	                    if (fullCallOrNewExpression === startingExpression) {
	                        return -1 /* Unknown */;
	                    }
	                    var fullCallOrNewExpressionEnd = sourceFile.getLineAndCharacterOfPosition(fullCallOrNewExpression.end);
	                    var startingExpressionEnd = sourceFile.getLineAndCharacterOfPosition(startingExpression.end);
	                    if (fullCallOrNewExpressionEnd.line === startingExpressionEnd.line) {
	                        return -1 /* Unknown */;
	                    }
	                    return findColumnForFirstNonWhitespaceCharacterInLine(fullCallOrNewExpressionEnd, sourceFile, options);
	                }
	                return -1 /* Unknown */;
	                function getStartingExpression(node) {
	                    while (true) {
	                        switch (node.kind) {
	                            case 186 /* CallExpression */:
	                            case 187 /* NewExpression */:
	                            case 184 /* PropertyAccessExpression */:
	                            case 185 /* ElementAccessExpression */:
	                                node = node.expression;
	                                break;
	                            default:
	                                return node;
	                        }
	                    }
	                }
	            }
	            function deriveActualIndentationFromList(list, index, sourceFile, options) {
	                ts.Debug.assert(index >= 0 && index < list.length);
	                var node = list[index];
	                // walk toward the start of the list starting from current node and check if the line is the same for all items.
	                // if end line for item [i - 1] differs from the start line for item [i] - find column of the first non-whitespace character on the line of item [i]
	                var lineAndCharacter = getStartLineAndCharacterForNode(node, sourceFile);
	                for (var i = index - 1; i >= 0; i--) {
	                    if (list[i].kind === 26 /* CommaToken */) {
	                        continue;
	                    }
	                    // skip list items that ends on the same line with the current list element
	                    var prevEndLine = sourceFile.getLineAndCharacterOfPosition(list[i].end).line;
	                    if (prevEndLine !== lineAndCharacter.line) {
	                        return findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options);
	                    }
	                    lineAndCharacter = getStartLineAndCharacterForNode(list[i], sourceFile);
	                }
	                return -1 /* Unknown */;
	            }
	            function findColumnForFirstNonWhitespaceCharacterInLine(lineAndCharacter, sourceFile, options) {
	                var lineStart = sourceFile.getPositionOfLineAndCharacter(lineAndCharacter.line, 0);
	                return findFirstNonWhitespaceColumn(lineStart, lineStart + lineAndCharacter.character, sourceFile, options);
	            }
	            /**
	             * Character is the actual index of the character since the beginning of the line.
	             * Column - position of the character after expanding tabs to spaces.
	             * "0\t2$"
	             * value of 'character' for '$' is 3
	             * value of 'column' for '$' is 6 (assuming that tab size is 4)
	             */
	            function findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options) {
	                var character = 0;
	                var column = 0;
	                for (var pos = startPos; pos < endPos; pos++) {
	                    var ch = sourceFile.text.charCodeAt(pos);
	                    if (!ts.isWhiteSpaceSingleLine(ch)) {
	                        break;
	                    }
	                    if (ch === 9 /* tab */) {
	                        column += options.tabSize + (column % options.tabSize);
	                    }
	                    else {
	                        column++;
	                    }
	                    character++;
	                }
	                return { column: column, character: character };
	            }
	            SmartIndenter.findFirstNonWhitespaceCharacterAndColumn = findFirstNonWhitespaceCharacterAndColumn;
	            function findFirstNonWhitespaceColumn(startPos, endPos, sourceFile, options) {
	                return findFirstNonWhitespaceCharacterAndColumn(startPos, endPos, sourceFile, options).column;
	            }
	            SmartIndenter.findFirstNonWhitespaceColumn = findFirstNonWhitespaceColumn;
	            function nodeWillIndentChild(settings, parent, child, sourceFile, indentByDefault) {
	                var childKind = child ? child.kind : 0 /* Unknown */;
	                switch (parent.kind) {
	                    case 215 /* ExpressionStatement */:
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 237 /* EnumDeclaration */:
	                    case 236 /* TypeAliasDeclaration */:
	                    case 182 /* ArrayLiteralExpression */:
	                    case 212 /* Block */:
	                    case 239 /* ModuleBlock */:
	                    case 183 /* ObjectLiteralExpression */:
	                    case 165 /* TypeLiteral */:
	                    case 176 /* MappedType */:
	                    case 167 /* TupleType */:
	                    case 240 /* CaseBlock */:
	                    case 266 /* DefaultClause */:
	                    case 265 /* CaseClause */:
	                    case 190 /* ParenthesizedExpression */:
	                    case 184 /* PropertyAccessExpression */:
	                    case 186 /* CallExpression */:
	                    case 187 /* NewExpression */:
	                    case 213 /* VariableStatement */:
	                    case 248 /* ExportAssignment */:
	                    case 224 /* ReturnStatement */:
	                    case 200 /* ConditionalExpression */:
	                    case 180 /* ArrayBindingPattern */:
	                    case 179 /* ObjectBindingPattern */:
	                    case 256 /* JsxOpeningElement */:
	                    case 259 /* JsxOpeningFragment */:
	                    case 255 /* JsxSelfClosingElement */:
	                    case 264 /* JsxExpression */:
	                    case 152 /* MethodSignature */:
	                    case 157 /* CallSignature */:
	                    case 158 /* ConstructSignature */:
	                    case 148 /* Parameter */:
	                    case 162 /* FunctionType */:
	                    case 163 /* ConstructorType */:
	                    case 172 /* ParenthesizedType */:
	                    case 188 /* TaggedTemplateExpression */:
	                    case 196 /* AwaitExpression */:
	                    case 250 /* NamedExports */:
	                    case 246 /* NamedImports */:
	                    case 251 /* ExportSpecifier */:
	                    case 247 /* ImportSpecifier */:
	                    case 151 /* PropertyDeclaration */:
	                        return true;
	                    case 231 /* VariableDeclaration */:
	                    case 269 /* PropertyAssignment */:
	                        if (!settings.indentMultiLineObjectLiteralBeginningOnBlankLine && sourceFile && childKind === 183 /* ObjectLiteralExpression */) {
	                            return rangeIsOnOneLine(sourceFile, child);
	                        }
	                        return true;
	                    case 217 /* DoStatement */:
	                    case 218 /* WhileStatement */:
	                    case 220 /* ForInStatement */:
	                    case 221 /* ForOfStatement */:
	                    case 219 /* ForStatement */:
	                    case 216 /* IfStatement */:
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                    case 153 /* MethodDeclaration */:
	                    case 192 /* ArrowFunction */:
	                    case 154 /* Constructor */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                        return childKind !== 212 /* Block */;
	                    case 249 /* ExportDeclaration */:
	                        return childKind !== 250 /* NamedExports */;
	                    case 243 /* ImportDeclaration */:
	                        return childKind !== 244 /* ImportClause */ ||
	                            (!!child.namedBindings && child.namedBindings.kind !== 246 /* NamedImports */);
	                    case 254 /* JsxElement */:
	                        return childKind !== 257 /* JsxClosingElement */;
	                    case 258 /* JsxFragment */:
	                        return childKind !== 260 /* JsxClosingFragment */;
	                    case 169 /* IntersectionType */:
	                    case 168 /* UnionType */:
	                        if (childKind === 165 /* TypeLiteral */) {
	                            return false;
	                        }
	                    // falls through
	                }
	                // No explicit rule for given nodes so the result will follow the default value argument
	                return indentByDefault;
	            }
	            SmartIndenter.nodeWillIndentChild = nodeWillIndentChild;
	            function isControlFlowEndingStatement(kind, parent) {
	                switch (kind) {
	                    case 224 /* ReturnStatement */:
	                    case 228 /* ThrowStatement */: {
	                        if (parent.kind !== 212 /* Block */) {
	                            return true;
	                        }
	                        var grandParent = parent.parent;
	                        // In a function, we may want to write inner functions after this.
	                        return !(grandParent && grandParent.kind === 191 /* FunctionExpression */ || grandParent.kind === 233 /* FunctionDeclaration */);
	                    }
	                    case 222 /* ContinueStatement */:
	                    case 223 /* BreakStatement */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	            /**
	             * True when the parent node should indent the given child by an explicit rule.
	             * @param isNextChild If true, we are judging indent of a hypothetical child *after* this one, not the current child.
	             */
	            function shouldIndentChildNode(settings, parent, child, sourceFile, isNextChild) {
	                if (isNextChild === void 0) { isNextChild = false; }
	                return nodeWillIndentChild(settings, parent, child, sourceFile, /*indentByDefault*/ false)
	                    && !(isNextChild && child && isControlFlowEndingStatement(child.kind, parent));
	            }
	            SmartIndenter.shouldIndentChildNode = shouldIndentChildNode;
	            function rangeIsOnOneLine(sourceFile, range) {
	                var rangeStart = ts.skipTrivia(sourceFile.text, range.pos);
	                var startLine = sourceFile.getLineAndCharacterOfPosition(rangeStart).line;
	                var endLine = sourceFile.getLineAndCharacterOfPosition(range.end).line;
	                return startLine === endLine;
	            }
	        })(SmartIndenter = formatting.SmartIndenter || (formatting.SmartIndenter = {}));
	    })(formatting = ts.formatting || (ts.formatting = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var textChanges;
	    (function (textChanges_3) {
	        /**
	         * Currently for simplicity we store recovered positions on the node itself.
	         * It can be changed to side-table later if we decide that current design is too invasive.
	         */
	        function getPos(n) {
	            var result = n.__pos;
	            ts.Debug.assert(typeof result === "number");
	            return result;
	        }
	        function setPos(n, pos) {
	            ts.Debug.assert(typeof pos === "number");
	            n.__pos = pos;
	        }
	        function getEnd(n) {
	            var result = n.__end;
	            ts.Debug.assert(typeof result === "number");
	            return result;
	        }
	        function setEnd(n, end) {
	            ts.Debug.assert(typeof end === "number");
	            n.__end = end;
	        }
	        var Position;
	        (function (Position) {
	            Position[Position["FullStart"] = 0] = "FullStart";
	            Position[Position["Start"] = 1] = "Start";
	        })(Position = textChanges_3.Position || (textChanges_3.Position = {}));
	        function skipWhitespacesAndLineBreaks(text, start) {
	            return ts.skipTrivia(text, start, /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	        }
	        function hasCommentsBeforeLineBreak(text, start) {
	            var i = start;
	            while (i < text.length) {
	                var ch = text.charCodeAt(i);
	                if (ts.isWhiteSpaceSingleLine(ch)) {
	                    i++;
	                    continue;
	                }
	                return ch === 47 /* slash */;
	            }
	            return false;
	        }
	        textChanges_3.useNonAdjustedPositions = {
	            useNonAdjustedStartPosition: true,
	            useNonAdjustedEndPosition: true,
	        };
	        var ChangeKind;
	        (function (ChangeKind) {
	            ChangeKind[ChangeKind["Remove"] = 0] = "Remove";
	            ChangeKind[ChangeKind["ReplaceWithSingleNode"] = 1] = "ReplaceWithSingleNode";
	            ChangeKind[ChangeKind["ReplaceWithMultipleNodes"] = 2] = "ReplaceWithMultipleNodes";
	            ChangeKind[ChangeKind["Text"] = 3] = "Text";
	        })(ChangeKind || (ChangeKind = {}));
	        function getAdjustedRange(sourceFile, startNode, endNode, options) {
	            return { pos: getAdjustedStartPosition(sourceFile, startNode, options, Position.Start), end: getAdjustedEndPosition(sourceFile, endNode, options) };
	        }
	        function getAdjustedStartPosition(sourceFile, node, options, position) {
	            if (options.useNonAdjustedStartPosition) {
	                return node.getStart(sourceFile);
	            }
	            var fullStart = node.getFullStart();
	            var start = node.getStart(sourceFile);
	            if (fullStart === start) {
	                return start;
	            }
	            var fullStartLine = ts.getLineStartPositionForPosition(fullStart, sourceFile);
	            var startLine = ts.getLineStartPositionForPosition(start, sourceFile);
	            if (startLine === fullStartLine) {
	                // full start and start of the node are on the same line
	                //   a,     b;
	                //    ^     ^
	                //    |   start
	                // fullstart
	                // when b is replaced - we usually want to keep the leading trvia
	                // when b is deleted - we delete it
	                return position === Position.Start ? start : fullStart;
	            }
	            // get start position of the line following the line that contains fullstart position
	            // (but only if the fullstart isn't the very beginning of the file)
	            var nextLineStart = fullStart > 0 ? 1 : 0;
	            var adjustedStartPosition = ts.getStartPositionOfLine(ts.getLineOfLocalPosition(sourceFile, fullStartLine) + nextLineStart, sourceFile);
	            // skip whitespaces/newlines
	            adjustedStartPosition = skipWhitespacesAndLineBreaks(sourceFile.text, adjustedStartPosition);
	            return ts.getStartPositionOfLine(ts.getLineOfLocalPosition(sourceFile, adjustedStartPosition), sourceFile);
	        }
	        function getAdjustedEndPosition(sourceFile, node, options) {
	            var end = node.end;
	            if (options.useNonAdjustedEndPosition || ts.isExpression(node)) {
	                return end;
	            }
	            var newEnd = ts.skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true);
	            return newEnd !== end && ts.isLineBreak(sourceFile.text.charCodeAt(newEnd - 1))
	                ? newEnd
	                : end;
	        }
	        /**
	         * Checks if 'candidate' argument is a legal separator in the list that contains 'node' as an element
	         */
	        function isSeparator(node, candidate) {
	            return candidate && node.parent && (candidate.kind === 26 /* CommaToken */ || (candidate.kind === 25 /* SemicolonToken */ && node.parent.kind === 183 /* ObjectLiteralExpression */));
	        }
	        function spaces(count) {
	            var s = "";
	            for (var i = 0; i < count; i++) {
	                s += " ";
	            }
	            return s;
	        }
	        var ChangeTracker = /** @class */ (function () {
	            /** Public for tests only. Other callers should use `ChangeTracker.with`. */
	            function ChangeTracker(newLineCharacter, formatContext) {
	                this.newLineCharacter = newLineCharacter;
	                this.formatContext = formatContext;
	                this.changes = [];
	                this.newFiles = [];
	                this.deletedNodesInLists = new ts.NodeSet(); // Stores ids of nodes in lists that we already deleted. Used to avoid deleting `, ` twice in `a, b`.
	                this.classesWithNodesInsertedAtStart = ts.createMap(); // Set<ClassDeclaration> implemented as Map<node id, ClassDeclaration>
	            }
	            ChangeTracker.fromContext = function (context) {
	                return new ChangeTracker(ts.getNewLineOrDefaultFromHost(context.host, context.formatContext.options), context.formatContext);
	            };
	            ChangeTracker.with = function (context, cb) {
	                var tracker = ChangeTracker.fromContext(context);
	                cb(tracker);
	                return tracker.getChanges();
	            };
	            ChangeTracker.prototype.deleteRange = function (sourceFile, range) {
	                this.changes.push({ kind: ChangeKind.Remove, sourceFile: sourceFile, range: range });
	                return this;
	            };
	            /** Warning: This deletes comments too. See `copyComments` in `convertFunctionToEs6Class`. */
	            ChangeTracker.prototype.deleteNode = function (sourceFile, node, options) {
	                if (options === void 0) { options = {}; }
	                var startPosition = getAdjustedStartPosition(sourceFile, node, options, Position.FullStart);
	                var endPosition = getAdjustedEndPosition(sourceFile, node, options);
	                this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	                return this;
	            };
	            ChangeTracker.prototype.deleteNodeRange = function (sourceFile, startNode, endNode, options) {
	                if (options === void 0) { options = {}; }
	                var startPosition = getAdjustedStartPosition(sourceFile, startNode, options, Position.FullStart);
	                var endPosition = getAdjustedEndPosition(sourceFile, endNode, options);
	                this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	                return this;
	            };
	            ChangeTracker.prototype.deleteNodeRangeExcludingEnd = function (sourceFile, startNode, afterEndNode, options) {
	                if (options === void 0) { options = {}; }
	                var startPosition = getAdjustedStartPosition(sourceFile, startNode, options, Position.FullStart);
	                var endPosition = afterEndNode === undefined ? sourceFile.text.length : getAdjustedStartPosition(sourceFile, afterEndNode, options, Position.FullStart);
	                this.deleteRange(sourceFile, { pos: startPosition, end: endPosition });
	            };
	            ChangeTracker.prototype.deleteNodeInList = function (sourceFile, node) {
	                var containingList = ts.formatting.SmartIndenter.getContainingList(node, sourceFile);
	                if (!containingList) {
	                    ts.Debug.fail("node is not a list element");
	                    return this;
	                }
	                var index = ts.indexOfNode(containingList, node);
	                if (index < 0) {
	                    return this;
	                }
	                if (containingList.length === 1) {
	                    this.deleteNode(sourceFile, node);
	                    return this;
	                }
	                // Note: We will only delete a comma *after* a node. This will leave a trailing comma if we delete the last node.
	                // That's handled in the end by `finishTrailingCommaAfterDeletingNodesInList`.
	                ts.Debug.assert(!this.deletedNodesInLists.has(node), "Deleting a node twice");
	                this.deletedNodesInLists.add(node);
	                this.deleteRange(sourceFile, {
	                    pos: startPositionToDeleteNodeInList(sourceFile, node),
	                    end: index === containingList.length - 1 ? getAdjustedEndPosition(sourceFile, node, {}) : startPositionToDeleteNodeInList(sourceFile, containingList[index + 1]),
	                });
	                return this;
	            };
	            ChangeTracker.prototype.replaceRange = function (sourceFile, range, newNode, options) {
	                if (options === void 0) { options = {}; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithSingleNode, sourceFile: sourceFile, range: range, options: options, node: newNode });
	                return this;
	            };
	            ChangeTracker.prototype.replaceNode = function (sourceFile, oldNode, newNode, options) {
	                if (options === void 0) { options = textChanges_3.useNonAdjustedPositions; }
	                return this.replaceRange(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNode, options);
	            };
	            ChangeTracker.prototype.replaceNodeRange = function (sourceFile, startNode, endNode, newNode, options) {
	                if (options === void 0) { options = textChanges_3.useNonAdjustedPositions; }
	                this.replaceRange(sourceFile, getAdjustedRange(sourceFile, startNode, endNode, options), newNode, options);
	            };
	            ChangeTracker.prototype.replaceRangeWithNodes = function (sourceFile, range, newNodes, options) {
	                if (options === void 0) { options = {}; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithMultipleNodes, sourceFile: sourceFile, range: range, options: options, nodes: newNodes });
	                return this;
	            };
	            ChangeTracker.prototype.replaceNodeWithNodes = function (sourceFile, oldNode, newNodes, options) {
	                if (options === void 0) { options = textChanges_3.useNonAdjustedPositions; }
	                return this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, oldNode, oldNode, options), newNodes, options);
	            };
	            ChangeTracker.prototype.replaceNodeRangeWithNodes = function (sourceFile, startNode, endNode, newNodes, options) {
	                if (options === void 0) { options = textChanges_3.useNonAdjustedPositions; }
	                return this.replaceRangeWithNodes(sourceFile, getAdjustedRange(sourceFile, startNode, endNode, options), newNodes, options);
	            };
	            ChangeTracker.prototype.nextCommaToken = function (sourceFile, node) {
	                var next = ts.findNextToken(node, node.parent, sourceFile);
	                return next && next.kind === 26 /* CommaToken */ ? next : undefined;
	            };
	            ChangeTracker.prototype.replacePropertyAssignment = function (sourceFile, oldNode, newNode) {
	                var suffix = this.nextCommaToken(sourceFile, oldNode) ? "" : ("," + this.newLineCharacter);
	                return this.replaceNode(sourceFile, oldNode, newNode, { suffix: suffix });
	            };
	            ChangeTracker.prototype.insertNodeAt = function (sourceFile, pos, newNode, options) {
	                if (options === void 0) { options = {}; }
	                this.replaceRange(sourceFile, ts.createTextRange(pos), newNode, options);
	            };
	            ChangeTracker.prototype.insertNodesAt = function (sourceFile, pos, newNodes, options) {
	                if (options === void 0) { options = {}; }
	                this.changes.push({ kind: ChangeKind.ReplaceWithMultipleNodes, sourceFile: sourceFile, options: options, nodes: newNodes, range: { pos: pos, end: pos } });
	            };
	            ChangeTracker.prototype.insertNodeAtTopOfFile = function (sourceFile, newNode, blankLineBetween) {
	                var pos = getInsertionPositionAtSourceFileTop(sourceFile);
	                this.insertNodeAt(sourceFile, pos, newNode, {
	                    prefix: pos === 0 ? undefined : this.newLineCharacter,
	                    suffix: (ts.isLineBreak(sourceFile.text.charCodeAt(pos)) ? "" : this.newLineCharacter) + (blankLineBetween ? this.newLineCharacter : ""),
	                });
	            };
	            ChangeTracker.prototype.insertNodeBefore = function (sourceFile, before, newNode, blankLineBetween) {
	                if (blankLineBetween === void 0) { blankLineBetween = false; }
	                this.insertNodeAt(sourceFile, getAdjustedStartPosition(sourceFile, before, {}, Position.Start), newNode, this.getOptionsForInsertNodeBefore(before, blankLineBetween));
	            };
	            ChangeTracker.prototype.insertModifierBefore = function (sourceFile, modifier, before) {
	                var pos = before.getStart(sourceFile);
	                this.replaceRange(sourceFile, { pos: pos, end: pos }, ts.createToken(modifier), { suffix: " " });
	            };
	            ChangeTracker.prototype.insertCommentBeforeLine = function (sourceFile, lineNumber, position, commentText) {
	                var lineStartPosition = ts.getStartPositionOfLine(lineNumber, sourceFile);
	                var startPosition = ts.getFirstNonSpaceCharacterPosition(sourceFile.text, lineStartPosition);
	                // First try to see if we can put the comment on the previous line.
	                // We need to make sure that we are not in the middle of a string literal or a comment.
	                // If so, we do not want to separate the node from its comment if we can.
	                // Otherwise, add an extra new line immediately before the error span.
	                var insertAtLineStart = isValidLocationToAddComment(sourceFile, startPosition);
	                var token = ts.getTouchingToken(sourceFile, insertAtLineStart ? startPosition : position, /*includeJsDocComment*/ false);
	                var indent = sourceFile.text.slice(lineStartPosition, startPosition);
	                var text = (insertAtLineStart ? "" : this.newLineCharacter) + "//" + commentText + this.newLineCharacter + indent;
	                this.insertText(sourceFile, token.getStart(sourceFile), text);
	            };
	            ChangeTracker.prototype.replaceRangeWithText = function (sourceFile, range, text) {
	                this.changes.push({ kind: ChangeKind.Text, sourceFile: sourceFile, range: range, text: text });
	            };
	            ChangeTracker.prototype.insertText = function (sourceFile, pos, text) {
	                this.replaceRangeWithText(sourceFile, ts.createTextRange(pos), text);
	            };
	            /** Prefer this over replacing a node with another that has a type annotation, as it avoids reformatting the other parts of the node. */
	            ChangeTracker.prototype.tryInsertTypeAnnotation = function (sourceFile, node, type) {
	                var endNode;
	                if (ts.isFunctionLike(node)) {
	                    endNode = ts.findChildOfKind(node, 20 /* CloseParenToken */, sourceFile);
	                    if (!endNode) {
	                        if (!ts.isArrowFunction(node))
	                            return; // Function missing parentheses, give up
	                        // If no `)`, is an arrow function `x => x`, so use the end of the first parameter
	                        endNode = ts.first(node.parameters);
	                    }
	                }
	                else {
	                    endNode = node.kind !== 231 /* VariableDeclaration */ && node.questionToken ? node.questionToken : node.name;
	                }
	                this.insertNodeAt(sourceFile, endNode.end, type, { prefix: ": " });
	            };
	            ChangeTracker.prototype.insertTypeParameters = function (sourceFile, node, typeParameters) {
	                // If no `(`, is an arrow function `x => x`, so use the pos of the first parameter
	                var start = (ts.findChildOfKind(node, 19 /* OpenParenToken */, sourceFile) || ts.first(node.parameters)).getStart(sourceFile);
	                this.insertNodesAt(sourceFile, start, typeParameters, { prefix: "<", suffix: ">" });
	            };
	            ChangeTracker.prototype.getOptionsForInsertNodeBefore = function (before, doubleNewlines) {
	                if (ts.isStatement(before) || ts.isClassElement(before)) {
	                    return { suffix: doubleNewlines ? this.newLineCharacter + this.newLineCharacter : this.newLineCharacter };
	                }
	                else if (ts.isVariableDeclaration(before)) { // insert `x = 1, ` into `const x = 1, y = 2;
	                    return { suffix: ", " };
	                }
	                else if (ts.isParameter(before)) {
	                    return {};
	                }
	                return ts.Debug.failBadSyntaxKind(before); // We haven't handled this kind of node yet -- add it
	            };
	            ChangeTracker.prototype.insertNodeAtConstructorStart = function (sourceFile, ctr, newStatement) {
	                var firstStatement = ts.firstOrUndefined(ctr.body.statements);
	                if (!firstStatement || !ctr.body.multiLine) {
	                    this.replaceConstructorBody(sourceFile, ctr, [newStatement].concat(ctr.body.statements));
	                }
	                else {
	                    this.insertNodeBefore(sourceFile, firstStatement, newStatement);
	                }
	            };
	            ChangeTracker.prototype.insertNodeAtConstructorEnd = function (sourceFile, ctr, newStatement) {
	                var lastStatement = ts.lastOrUndefined(ctr.body.statements);
	                if (!lastStatement || !ctr.body.multiLine) {
	                    this.replaceConstructorBody(sourceFile, ctr, ctr.body.statements.concat([newStatement]));
	                }
	                else {
	                    this.insertNodeAfter(sourceFile, lastStatement, newStatement);
	                }
	            };
	            ChangeTracker.prototype.replaceConstructorBody = function (sourceFile, ctr, statements) {
	                this.replaceNode(sourceFile, ctr.body, ts.createBlock(statements, /*multiLine*/ true));
	            };
	            ChangeTracker.prototype.insertNodeAtEndOfScope = function (sourceFile, scope, newNode) {
	                var pos = getAdjustedStartPosition(sourceFile, scope.getLastToken(), {}, Position.Start);
	                this.replaceRange(sourceFile, { pos: pos, end: pos }, newNode, {
	                    prefix: ts.isLineBreak(sourceFile.text.charCodeAt(scope.getLastToken().pos)) ? this.newLineCharacter : this.newLineCharacter + this.newLineCharacter,
	                    suffix: this.newLineCharacter
	                });
	            };
	            ChangeTracker.prototype.insertNodeAtClassStart = function (sourceFile, cls, newElement) {
	                var clsStart = cls.getStart(sourceFile);
	                var indentation = ts.formatting.SmartIndenter.findFirstNonWhitespaceColumn(ts.getLineStartPositionForPosition(clsStart, sourceFile), clsStart, sourceFile, this.formatContext.options)
	                    + this.formatContext.options.indentSize;
	                this.insertNodeAt(sourceFile, cls.members.pos, newElement, __assign({ indentation: indentation }, this.getInsertNodeAtClassStartPrefixSuffix(sourceFile, cls)));
	            };
	            ChangeTracker.prototype.getInsertNodeAtClassStartPrefixSuffix = function (sourceFile, cls) {
	                if (cls.members.length === 0) {
	                    if (ts.addToSeen(this.classesWithNodesInsertedAtStart, ts.getNodeId(cls), cls)) {
	                        // For `class C {\n}`, don't add the trailing "\n"
	                        var shouldSuffix = ts.positionsAreOnSameLine.apply(void 0, getClassBraceEnds(cls, sourceFile).concat([sourceFile])); // TODO: GH#4130 remove 'as any'
	                        return { prefix: this.newLineCharacter, suffix: shouldSuffix ? this.newLineCharacter : "" };
	                    }
	                    else {
	                        return { prefix: "", suffix: this.newLineCharacter };
	                    }
	                }
	                else {
	                    return { prefix: this.newLineCharacter, suffix: "" };
	                }
	            };
	            ChangeTracker.prototype.insertNodeAfterComma = function (sourceFile, after, newNode) {
	                var endPosition = this.insertNodeAfterWorker(sourceFile, this.nextCommaToken(sourceFile, after) || after, newNode);
	                this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
	            };
	            ChangeTracker.prototype.insertNodeAfter = function (sourceFile, after, newNode) {
	                var endPosition = this.insertNodeAfterWorker(sourceFile, after, newNode);
	                this.insertNodeAt(sourceFile, endPosition, newNode, this.getInsertNodeAfterOptions(sourceFile, after));
	            };
	            ChangeTracker.prototype.insertNodesAfter = function (sourceFile, after, newNodes) {
	                var endPosition = this.insertNodeAfterWorker(sourceFile, after, ts.first(newNodes));
	                this.insertNodesAt(sourceFile, endPosition, newNodes, this.getInsertNodeAfterOptions(sourceFile, after));
	            };
	            ChangeTracker.prototype.insertNodeAfterWorker = function (sourceFile, after, newNode) {
	                if (needSemicolonBetween(after, newNode)) {
	                    // check if previous statement ends with semicolon
	                    // if not - insert semicolon to preserve the code from changing the meaning due to ASI
	                    if (sourceFile.text.charCodeAt(after.end - 1) !== 59 /* semicolon */) {
	                        this.replaceRange(sourceFile, ts.createTextRange(after.end), ts.createToken(25 /* SemicolonToken */));
	                    }
	                }
	                var endPosition = getAdjustedEndPosition(sourceFile, after, {});
	                return endPosition;
	            };
	            ChangeTracker.prototype.getInsertNodeAfterOptions = function (sourceFile, after) {
	                var options = this.getInsertNodeAfterOptionsWorker(after);
	                return __assign({}, options, { prefix: after.end === sourceFile.end && ts.isStatement(after) ? (options.prefix ? "\n" + options.prefix : "\n") : options.prefix });
	            };
	            ChangeTracker.prototype.getInsertNodeAfterOptionsWorker = function (node) {
	                if (ts.isClassDeclaration(node) || ts.isModuleDeclaration(node)) {
	                    return { prefix: this.newLineCharacter, suffix: this.newLineCharacter };
	                }
	                else if (ts.isStatement(node) || ts.isClassOrTypeElement(node)) {
	                    return { suffix: this.newLineCharacter };
	                }
	                else if (ts.isVariableDeclaration(node) || ts.isStringLiteral(node)) {
	                    return { prefix: ", " };
	                }
	                else if (ts.isPropertyAssignment(node)) {
	                    return { suffix: "," + this.newLineCharacter };
	                }
	                else if (ts.isParameter(node)) {
	                    return {};
	                }
	                return ts.Debug.failBadSyntaxKind(node); // We haven't handled this kind of node yet -- add it
	            };
	            ChangeTracker.prototype.insertName = function (sourceFile, node, name) {
	                ts.Debug.assert(!node.name);
	                if (node.kind === 192 /* ArrowFunction */) {
	                    var arrow = ts.findChildOfKind(node, 36 /* EqualsGreaterThanToken */, sourceFile);
	                    var lparen = ts.findChildOfKind(node, 19 /* OpenParenToken */, sourceFile);
	                    if (lparen) {
	                        // `() => {}` --> `function f() {}`
	                        this.insertNodesAt(sourceFile, lparen.getStart(sourceFile), [ts.createToken(89 /* FunctionKeyword */), ts.createIdentifier(name)], { joiner: " " });
	                        this.deleteNode(sourceFile, arrow);
	                    }
	                    else {
	                        // `x => {}` -> `function f(x) {}`
	                        this.insertText(sourceFile, ts.first(node.parameters).getStart(sourceFile), "function " + name + "(");
	                        // Replacing full range of arrow to get rid of the leading space -- replace ` =>` with `)`
	                        this.replaceRange(sourceFile, arrow, ts.createToken(20 /* CloseParenToken */));
	                    }
	                    if (node.body.kind !== 212 /* Block */) {
	                        // `() => 0` => `function f() { return 0; }`
	                        this.insertNodesAt(sourceFile, node.body.getStart(sourceFile), [ts.createToken(17 /* OpenBraceToken */), ts.createToken(96 /* ReturnKeyword */)], { joiner: " ", suffix: " " });
	                        this.insertNodesAt(sourceFile, node.body.end, [ts.createToken(25 /* SemicolonToken */), ts.createToken(18 /* CloseBraceToken */)], { joiner: " " });
	                    }
	                }
	                else {
	                    var pos = ts.findChildOfKind(node, node.kind === 191 /* FunctionExpression */ ? 89 /* FunctionKeyword */ : 75 /* ClassKeyword */, sourceFile).end;
	                    this.insertNodeAt(sourceFile, pos, ts.createIdentifier(name), { prefix: " " });
	                }
	            };
	            ChangeTracker.prototype.insertExportModifier = function (sourceFile, node) {
	                this.insertText(sourceFile, node.getStart(sourceFile), "export ");
	            };
	            /**
	             * This function should be used to insert nodes in lists when nodes don't carry separators as the part of the node range,
	             * i.e. arguments in arguments lists, parameters in parameter lists etc.
	             * Note that separators are part of the node in statements and class elements.
	             */
	            ChangeTracker.prototype.insertNodeInListAfter = function (sourceFile, after, newNode, containingList) {
	                if (containingList === void 0) { containingList = ts.formatting.SmartIndenter.getContainingList(after, sourceFile); }
	                if (!containingList) {
	                    ts.Debug.fail("node is not a list element");
	                    return this;
	                }
	                var index = ts.indexOfNode(containingList, after);
	                if (index < 0) {
	                    return this;
	                }
	                var end = after.getEnd();
	                if (index !== containingList.length - 1) {
	                    // any element except the last one
	                    // use next sibling as an anchor
	                    var nextToken = ts.getTokenAtPosition(sourceFile, after.end, /*includeJsDocComment*/ false);
	                    if (nextToken && isSeparator(after, nextToken)) {
	                        // for list
	                        // a, b, c
	                        // create change for adding 'e' after 'a' as
	                        // - find start of next element after a (it is b)
	                        // - use this start as start and end position in final change
	                        // - build text of change by formatting the text of node + separator + whitespace trivia of b
	                        // in multiline case it will work as
	                        //   a,
	                        //   b,
	                        //   c,
	                        // result - '*' denotes leading trivia that will be inserted after new text (displayed as '#')
	                        //   a,*
	                        // ***insertedtext<separator>#
	                        // ###b,
	                        //   c,
	                        // find line and character of the next element
	                        var lineAndCharOfNextElement = ts.getLineAndCharacterOfPosition(sourceFile, skipWhitespacesAndLineBreaks(sourceFile.text, containingList[index + 1].getFullStart()));
	                        // find line and character of the token that precedes next element (usually it is separator)
	                        var lineAndCharOfNextToken = ts.getLineAndCharacterOfPosition(sourceFile, nextToken.end);
	                        var prefix = void 0;
	                        var startPos = void 0;
	                        if (lineAndCharOfNextToken.line === lineAndCharOfNextElement.line) {
	                            // next element is located on the same line with separator:
	                            // a,$$$$b
	                            //  ^    ^
	                            //  |    |-next element
	                            //  |-separator
	                            // where $$$ is some leading trivia
	                            // for a newly inserted node we'll maintain the same relative position comparing to separator and replace leading trivia with spaces
	                            // a,    x,$$$$b
	                            //  ^    ^     ^
	                            //  |    |     |-next element
	                            //  |    |-new inserted node padded with spaces
	                            //  |-separator
	                            startPos = nextToken.end;
	                            prefix = spaces(lineAndCharOfNextElement.character - lineAndCharOfNextToken.character);
	                        }
	                        else {
	                            // next element is located on different line that separator
	                            // let insert position be the beginning of the line that contains next element
	                            startPos = ts.getStartPositionOfLine(lineAndCharOfNextElement.line, sourceFile);
	                        }
	                        // write separator and leading trivia of the next element as suffix
	                        var suffix = "" + ts.tokenToString(nextToken.kind) + sourceFile.text.substring(nextToken.end, containingList[index + 1].getStart(sourceFile));
	                        this.replaceRange(sourceFile, ts.createTextRange(startPos, containingList[index + 1].getStart(sourceFile)), newNode, { prefix: prefix, suffix: suffix });
	                    }
	                }
	                else {
	                    var afterStart = after.getStart(sourceFile);
	                    var afterStartLinePosition = ts.getLineStartPositionForPosition(afterStart, sourceFile);
	                    var separator = void 0;
	                    var multilineList = false;
	                    // insert element after the last element in the list that has more than one item
	                    // pick the element preceding the after element to:
	                    // - pick the separator
	                    // - determine if list is a multiline
	                    if (containingList.length === 1) {
	                        // if list has only one element then we'll format is as multiline if node has comment in trailing trivia, or as singleline otherwise
	                        // i.e. var x = 1 // this is x
	                        //     | new element will be inserted at this position
	                        separator = 26 /* CommaToken */;
	                    }
	                    else {
	                        // element has more than one element, pick separator from the list
	                        var tokenBeforeInsertPosition = ts.findPrecedingToken(after.pos, sourceFile);
	                        separator = isSeparator(after, tokenBeforeInsertPosition) ? tokenBeforeInsertPosition.kind : 26 /* CommaToken */;
	                        // determine if list is multiline by checking lines of after element and element that precedes it.
	                        var afterMinusOneStartLinePosition = ts.getLineStartPositionForPosition(containingList[index - 1].getStart(sourceFile), sourceFile);
	                        multilineList = afterMinusOneStartLinePosition !== afterStartLinePosition;
	                    }
	                    if (hasCommentsBeforeLineBreak(sourceFile.text, after.end)) {
	                        // in this case we'll always treat containing list as multiline
	                        multilineList = true;
	                    }
	                    if (multilineList) {
	                        // insert separator immediately following the 'after' node to preserve comments in trailing trivia
	                        this.replaceRange(sourceFile, ts.createTextRange(end), ts.createToken(separator));
	                        // use the same indentation as 'after' item
	                        var indentation = ts.formatting.SmartIndenter.findFirstNonWhitespaceColumn(afterStartLinePosition, afterStart, sourceFile, this.formatContext.options);
	                        // insert element before the line break on the line that contains 'after' element
	                        var insertPos = ts.skipTrivia(sourceFile.text, end, /*stopAfterLineBreak*/ true, /*stopAtComments*/ false);
	                        if (insertPos !== end && ts.isLineBreak(sourceFile.text.charCodeAt(insertPos - 1))) {
	                            insertPos--;
	                        }
	                        this.replaceRange(sourceFile, ts.createTextRange(insertPos), newNode, { indentation: indentation, prefix: this.newLineCharacter });
	                    }
	                    else {
	                        this.replaceRange(sourceFile, ts.createTextRange(end), newNode, { prefix: ts.tokenToString(separator) + " " });
	                    }
	                }
	                return this;
	            };
	            ChangeTracker.prototype.finishClassesWithNodesInsertedAtStart = function () {
	                var _this = this;
	                this.classesWithNodesInsertedAtStart.forEach(function (cls) {
	                    var sourceFile = cls.getSourceFile();
	                    var _a = getClassBraceEnds(cls, sourceFile), openBraceEnd = _a[0], closeBraceEnd = _a[1];
	                    // For `class C { }` remove the whitespace inside the braces.
	                    if (ts.positionsAreOnSameLine(openBraceEnd, closeBraceEnd, sourceFile) && openBraceEnd !== closeBraceEnd - 1) {
	                        _this.deleteRange(sourceFile, ts.createTextRange(openBraceEnd, closeBraceEnd - 1));
	                    }
	                });
	            };
	            ChangeTracker.prototype.finishTrailingCommaAfterDeletingNodesInList = function () {
	                var _this = this;
	                this.deletedNodesInLists.forEach(function (node) {
	                    var sourceFile = node.getSourceFile();
	                    var list = ts.formatting.SmartIndenter.getContainingList(node, sourceFile);
	                    if (node !== ts.last(list))
	                        return;
	                    var lastNonDeletedIndex = ts.findLastIndex(list, function (n) { return !_this.deletedNodesInLists.has(n); }, list.length - 2);
	                    if (lastNonDeletedIndex !== -1) {
	                        _this.deleteRange(sourceFile, { pos: list[lastNonDeletedIndex].end, end: startPositionToDeleteNodeInList(sourceFile, list[lastNonDeletedIndex + 1]) });
	                    }
	                });
	            };
	            /**
	             * Note: after calling this, the TextChanges object must be discarded!
	             * @param validate only for tests
	             *    The reason we must validate as part of this method is that `getNonFormattedText` changes the node's positions,
	             *    so we can only call this once and can't get the non-formatted text separately.
	             */
	            ChangeTracker.prototype.getChanges = function (validate) {
	                this.finishClassesWithNodesInsertedAtStart();
	                this.finishTrailingCommaAfterDeletingNodesInList();
	                var changes = changesToText.getTextChangesFromChanges(this.changes, this.newLineCharacter, this.formatContext, validate);
	                for (var _i = 0, _a = this.newFiles; _i < _a.length; _i++) {
	                    var _b = _a[_i], oldFile = _b.oldFile, fileName = _b.fileName, statements = _b.statements;
	                    changes.push(changesToText.newFileChanges(oldFile, fileName, statements, this.newLineCharacter, this.formatContext));
	                }
	                return changes;
	            };
	            ChangeTracker.prototype.createNewFile = function (oldFile, fileName, statements) {
	                this.newFiles.push({ oldFile: oldFile, fileName: fileName, statements: statements });
	            };
	            return ChangeTracker;
	        }());
	        textChanges_3.ChangeTracker = ChangeTracker;
	        // find first non-whitespace position in the leading trivia of the node
	        function startPositionToDeleteNodeInList(sourceFile, node) {
	            return ts.skipTrivia(sourceFile.text, getAdjustedStartPosition(sourceFile, node, {}, Position.FullStart), /*stopAfterLineBreak*/ false, /*stopAtComments*/ true);
	        }
	        function getClassBraceEnds(cls, sourceFile) {
	            return [ts.findChildOfKind(cls, 17 /* OpenBraceToken */, sourceFile).end, ts.findChildOfKind(cls, 18 /* CloseBraceToken */, sourceFile).end];
	        }
	        var changesToText;
	        (function (changesToText) {
	            function getTextChangesFromChanges(changes, newLineCharacter, formatContext, validate) {
	                return ts.group(changes, function (c) { return c.sourceFile.path; }).map(function (changesInFile) {
	                    var sourceFile = changesInFile[0].sourceFile;
	                    // order changes by start position
	                    // If the start position is the same, put the shorter range first, since an empty range (x, x) may precede (x, y) but not vice-versa.
	                    var normalized = ts.stableSort(changesInFile, function (a, b) { return (a.range.pos - b.range.pos) || (a.range.end - b.range.end); });
	                    var _loop_19 = function (i) {
	                        ts.Debug.assert(normalized[i].range.end <= normalized[i + 1].range.pos, "Changes overlap", function () {
	                            return JSON.stringify(normalized[i].range) + " and " + JSON.stringify(normalized[i + 1].range);
	                        });
	                    };
	                    // verify that change intervals do not overlap, except possibly at end points.
	                    for (var i = 0; i < normalized.length - 1; i++) {
	                        _loop_19(i);
	                    }
	                    var textChanges = normalized.map(function (c) {
	                        return ts.createTextChange(ts.createTextSpanFromRange(c.range), computeNewText(c, sourceFile, newLineCharacter, formatContext, validate));
	                    });
	                    return { fileName: sourceFile.fileName, textChanges: textChanges };
	                });
	            }
	            changesToText.getTextChangesFromChanges = getTextChangesFromChanges;
	            function newFileChanges(oldFile, fileName, statements, newLineCharacter, formatContext) {
	                // TODO: this emits the file, parses it back, then formats it that -- may be a less roundabout way to do this
	                var nonFormattedText = statements.map(function (s) { return getNonformattedText(s, oldFile, newLineCharacter).text; }).join(newLineCharacter);
	                var sourceFile = ts.createSourceFile(fileName, nonFormattedText, 6 /* ESNext */, /*setParentNodes*/ true);
	                var changes = ts.formatting.formatDocument(sourceFile, formatContext);
	                var text = applyChanges(nonFormattedText, changes);
	                return { fileName: fileName, textChanges: [ts.createTextChange(ts.createTextSpan(0, 0), text)], isNewFile: true };
	            }
	            changesToText.newFileChanges = newFileChanges;
	            function computeNewText(change, sourceFile, newLineCharacter, formatContext, validate) {
	                if (change.kind === ChangeKind.Remove) {
	                    return "";
	                }
	                if (change.kind === ChangeKind.Text) {
	                    return change.text;
	                }
	                var _a = change.options, options = _a === void 0 ? {} : _a, pos = change.range.pos;
	                var format = function (n) { return getFormattedTextOfNode(n, sourceFile, pos, options, newLineCharacter, formatContext, validate); };
	                var text = change.kind === ChangeKind.ReplaceWithMultipleNodes
	                    ? change.nodes.map(function (n) { return ts.removeSuffix(format(n), newLineCharacter); }).join(change.options.joiner || newLineCharacter)
	                    : format(change.node);
	                // strip initial indentation (spaces or tabs) if text will be inserted in the middle of the line
	                var noIndent = (options.preserveLeadingWhitespace || options.indentation !== undefined || ts.getLineStartPositionForPosition(pos, sourceFile) === pos) ? text : text.replace(/^\s+/, "");
	                return (options.prefix || "") + noIndent + (options.suffix || "");
	            }
	            /** Note: this may mutate `nodeIn`. */
	            function getFormattedTextOfNode(nodeIn, sourceFile, pos, _a, newLineCharacter, formatContext, validate) {
	                var indentation = _a.indentation, prefix = _a.prefix, delta = _a.delta;
	                var _b = getNonformattedText(nodeIn, sourceFile, newLineCharacter), node = _b.node, text = _b.text;
	                if (validate)
	                    validate(node, text);
	                var formatOptions = formatContext.options;
	                var initialIndentation = indentation !== undefined
	                    ? indentation
	                    : ts.formatting.SmartIndenter.getIndentation(pos, sourceFile, formatOptions, prefix === newLineCharacter || ts.getLineStartPositionForPosition(pos, sourceFile) === pos);
	                if (delta === undefined) {
	                    delta = ts.formatting.SmartIndenter.shouldIndentChildNode(formatContext.options, nodeIn) ? (formatOptions.indentSize || 0) : 0;
	                }
	                var file = { text: text, getLineAndCharacterOfPosition: function (pos) { return ts.getLineAndCharacterOfPosition(this, pos); } };
	                var changes = ts.formatting.formatNodeGivenIndentation(node, file, sourceFile.languageVariant, initialIndentation, delta, formatContext);
	                return applyChanges(text, changes);
	            }
	            /** Note: output node may be mutated input node. */
	            function getNonformattedText(node, sourceFile, newLineCharacter) {
	                var writer = new Writer(newLineCharacter);
	                var newLine = newLineCharacter === "\n" ? 1 /* LineFeed */ : 0 /* CarriageReturnLineFeed */;
	                ts.createPrinter({ newLine: newLine }, writer).writeNode(4 /* Unspecified */, node, sourceFile, writer);
	                return { text: writer.getText(), node: assignPositionsToNode(node) };
	            }
	        })(changesToText || (changesToText = {}));
	        function applyChanges(text, changes) {
	            for (var i = changes.length - 1; i >= 0; i--) {
	                var change = changes[i];
	                text = "" + text.substring(0, change.span.start) + change.newText + text.substring(ts.textSpanEnd(change.span));
	            }
	            return text;
	        }
	        textChanges_3.applyChanges = applyChanges;
	        function isTrivia(s) {
	            return ts.skipTrivia(s, 0) === s.length;
	        }
	        function assignPositionsToNode(node) {
	            var visited = ts.visitEachChild(node, assignPositionsToNode, ts.nullTransformationContext, assignPositionsToNodeArray, assignPositionsToNode);
	            // create proxy node for non synthesized nodes
	            var newNode = ts.nodeIsSynthesized(visited) ? visited : Object.create(visited);
	            newNode.pos = getPos(node);
	            newNode.end = getEnd(node);
	            return newNode;
	        }
	        function assignPositionsToNodeArray(nodes, visitor, test, start, count) {
	            var visited = ts.visitNodes(nodes, visitor, test, start, count);
	            if (!visited) {
	                return visited;
	            }
	            // clone nodearray if necessary
	            var nodeArray = visited === nodes ? ts.createNodeArray(visited.slice(0)) : visited;
	            nodeArray.pos = getPos(nodes);
	            nodeArray.end = getEnd(nodes);
	            return nodeArray;
	        }
	        var Writer = /** @class */ (function () {
	            function Writer(newLine) {
	                var _this = this;
	                this.lastNonTriviaPosition = 0;
	                this.writer = ts.createTextWriter(newLine);
	                this.onEmitNode = function (hint, node, printCallback) {
	                    if (node) {
	                        setPos(node, _this.lastNonTriviaPosition);
	                    }
	                    printCallback(hint, node);
	                    if (node) {
	                        setEnd(node, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onBeforeEmitNodeArray = function (nodes) {
	                    if (nodes) {
	                        setPos(nodes, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onAfterEmitNodeArray = function (nodes) {
	                    if (nodes) {
	                        setEnd(nodes, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onBeforeEmitToken = function (node) {
	                    if (node) {
	                        setPos(node, _this.lastNonTriviaPosition);
	                    }
	                };
	                this.onAfterEmitToken = function (node) {
	                    if (node) {
	                        setEnd(node, _this.lastNonTriviaPosition);
	                    }
	                };
	            }
	            Writer.prototype.setLastNonTriviaPosition = function (s, force) {
	                if (force || !isTrivia(s)) {
	                    this.lastNonTriviaPosition = this.writer.getTextPos();
	                    var i = 0;
	                    while (ts.isWhiteSpaceLike(s.charCodeAt(s.length - i - 1))) {
	                        i++;
	                    }
	                    // trim trailing whitespaces
	                    this.lastNonTriviaPosition -= i;
	                }
	            };
	            Writer.prototype.write = function (s) {
	                this.writer.write(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeKeyword = function (s) {
	                this.writer.writeKeyword(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeOperator = function (s) {
	                this.writer.writeOperator(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writePunctuation = function (s) {
	                this.writer.writePunctuation(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeParameter = function (s) {
	                this.writer.writeParameter(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeProperty = function (s) {
	                this.writer.writeProperty(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeSpace = function (s) {
	                this.writer.writeSpace(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeStringLiteral = function (s) {
	                this.writer.writeStringLiteral(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeSymbol = function (s, sym) {
	                this.writer.writeSymbol(s, sym);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeTextOfNode = function (text, node) {
	                this.writer.writeTextOfNode(text, node);
	            };
	            Writer.prototype.writeLine = function () {
	                this.writer.writeLine();
	            };
	            Writer.prototype.increaseIndent = function () {
	                this.writer.increaseIndent();
	            };
	            Writer.prototype.decreaseIndent = function () {
	                this.writer.decreaseIndent();
	            };
	            Writer.prototype.getText = function () {
	                return this.writer.getText();
	            };
	            Writer.prototype.rawWrite = function (s) {
	                this.writer.rawWrite(s);
	                this.setLastNonTriviaPosition(s, /*force*/ false);
	            };
	            Writer.prototype.writeLiteral = function (s) {
	                this.writer.writeLiteral(s);
	                this.setLastNonTriviaPosition(s, /*force*/ true);
	            };
	            Writer.prototype.getTextPos = function () {
	                return this.writer.getTextPos();
	            };
	            Writer.prototype.getLine = function () {
	                return this.writer.getLine();
	            };
	            Writer.prototype.getColumn = function () {
	                return this.writer.getColumn();
	            };
	            Writer.prototype.getIndent = function () {
	                return this.writer.getIndent();
	            };
	            Writer.prototype.isAtStartOfLine = function () {
	                return this.writer.isAtStartOfLine();
	            };
	            Writer.prototype.clear = function () {
	                this.writer.clear();
	                this.lastNonTriviaPosition = 0;
	            };
	            return Writer;
	        }());
	        function getInsertionPositionAtSourceFileTop(_a) {
	            var text = _a.text;
	            var shebang = ts.getShebang(text);
	            var position = 0;
	            if (shebang !== undefined) {
	                position = shebang.length;
	                advancePastLineBreak();
	            }
	            // For a source file, it is possible there are detached comments we should not skip
	            var ranges = ts.getLeadingCommentRanges(text, position);
	            if (!ranges)
	                return position;
	            // However we should still skip a pinned comment at the top
	            if (ranges.length && ranges[0].kind === 3 /* MultiLineCommentTrivia */ && ts.isPinnedComment(text, ranges[0].pos)) {
	                position = ranges[0].end;
	                advancePastLineBreak();
	                ranges = ranges.slice(1);
	            }
	            // As well as any triple slash references
	            for (var _i = 0, ranges_1 = ranges; _i < ranges_1.length; _i++) {
	                var range = ranges_1[_i];
	                if (range.kind === 2 /* SingleLineCommentTrivia */ && ts.isRecognizedTripleSlashComment(text, range.pos, range.end)) {
	                    position = range.end;
	                    advancePastLineBreak();
	                    continue;
	                }
	                break;
	            }
	            return position;
	            function advancePastLineBreak() {
	                if (position < text.length) {
	                    var charCode = text.charCodeAt(position);
	                    if (ts.isLineBreak(charCode)) {
	                        position++;
	                        if (position < text.length && charCode === 13 /* carriageReturn */ && text.charCodeAt(position) === 10 /* lineFeed */) {
	                            position++;
	                        }
	                    }
	                }
	            }
	        }
	        function isValidLocationToAddComment(sourceFile, position) {
	            return !ts.isInComment(sourceFile, position) && !ts.isInString(sourceFile, position) && !ts.isInTemplateString(sourceFile, position);
	        }
	        textChanges_3.isValidLocationToAddComment = isValidLocationToAddComment;
	        function needSemicolonBetween(a, b) {
	            return (ts.isPropertySignature(a) || ts.isPropertyDeclaration(a)) && ts.isClassOrTypeElement(b) && b.name.kind === 146 /* ComputedPropertyName */
	                || ts.isStatementButNotDeclaration(a) && ts.isStatementButNotDeclaration(b); // TODO: only if b would start with a `(` or `[`
	        }
	    })(textChanges = ts.textChanges || (ts.textChanges = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodeToFixes = ts.createMultiMap();
	        var fixIdToRegistration = ts.createMap();
	        function diagnosticToString(diag) {
	            return ts.isArray(diag)
	                ? ts.formatStringFromArgs(ts.getLocaleSpecificMessage(diag[0]), diag.slice(1))
	                : ts.getLocaleSpecificMessage(diag);
	        }
	        function createCodeFixActionNoFixId(fixName, changes, description) {
	            return createCodeFixActionWorker(fixName, diagnosticToString(description), changes, /*fixId*/ undefined, /*fixAllDescription*/ undefined);
	        }
	        codefix.createCodeFixActionNoFixId = createCodeFixActionNoFixId;
	        function createCodeFixAction(fixName, changes, description, fixId, fixAllDescription, command) {
	            return createCodeFixActionWorker(fixName, diagnosticToString(description), changes, fixId, diagnosticToString(fixAllDescription), command);
	        }
	        codefix.createCodeFixAction = createCodeFixAction;
	        function createCodeFixActionWorker(fixName, description, changes, fixId, fixAllDescription, command) {
	            return { fixName: fixName, description: description, changes: changes, fixId: fixId, fixAllDescription: fixAllDescription, commands: command ? [command] : undefined };
	        }
	        function registerCodeFix(reg) {
	            for (var _i = 0, _a = reg.errorCodes; _i < _a.length; _i++) {
	                var error = _a[_i];
	                errorCodeToFixes.add(String(error), reg);
	            }
	            if (reg.fixIds) {
	                for (var _b = 0, _c = reg.fixIds; _b < _c.length; _b++) {
	                    var fixId = _c[_b];
	                    ts.Debug.assert(!fixIdToRegistration.has(fixId));
	                    fixIdToRegistration.set(fixId, reg);
	                }
	            }
	        }
	        codefix.registerCodeFix = registerCodeFix;
	        function getSupportedErrorCodes() {
	            return ts.arrayFrom(errorCodeToFixes.keys());
	        }
	        codefix.getSupportedErrorCodes = getSupportedErrorCodes;
	        function getFixes(context) {
	            return ts.flatMap(errorCodeToFixes.get(String(context.errorCode)) || ts.emptyArray, function (f) { return f.getCodeActions(context); });
	        }
	        codefix.getFixes = getFixes;
	        function getAllFixes(context) {
	            // Currently fixId is always a string.
	            return fixIdToRegistration.get(ts.cast(context.fixId, ts.isString)).getAllCodeActions(context);
	        }
	        codefix.getAllFixes = getAllFixes;
	        function createCombinedCodeActions(changes, commands) {
	            return { changes: changes, commands: commands };
	        }
	        function createFileTextChanges(fileName, textChanges) {
	            return { fileName: fileName, textChanges: textChanges };
	        }
	        codefix.createFileTextChanges = createFileTextChanges;
	        function codeFixAll(context, errorCodes, use) {
	            var commands = [];
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) {
	                return eachDiagnostic(context, errorCodes, function (diag) { return use(t, diag, commands); });
	            });
	            return createCombinedCodeActions(changes, commands.length === 0 ? undefined : commands);
	        }
	        codefix.codeFixAll = codeFixAll;
	        function eachDiagnostic(_a, errorCodes, cb) {
	            var program = _a.program, sourceFile = _a.sourceFile;
	            for (var _i = 0, _b = program.getSemanticDiagnostics(sourceFile).concat(ts.computeSuggestionDiagnostics(sourceFile, program)); _i < _b.length; _i++) {
	                var diag = _b[_i];
	                if (ts.contains(errorCodes, diag.code)) {
	                    cb(diag);
	                }
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor_1) {
	        // A map with the refactor code as key, the refactor itself as value
	        // e.g.  nonSuggestableRefactors[refactorCode] -> the refactor you want
	        var refactors = ts.createMap();
	        /** @param name An unique code associated with each refactor. Does not have to be human-readable. */
	        function registerRefactor(name, refactor) {
	            refactors.set(name, refactor);
	        }
	        refactor_1.registerRefactor = registerRefactor;
	        function getApplicableRefactors(context) {
	            return ts.arrayFrom(ts.flatMapIterator(refactors.values(), function (refactor) {
	                return context.cancellationToken && context.cancellationToken.isCancellationRequested() ? undefined : refactor.getAvailableActions(context);
	            }));
	        }
	        refactor_1.getApplicableRefactors = getApplicableRefactors;
	        function getEditsForRefactor(context, refactorName, actionName) {
	            var refactor = refactors.get(refactorName);
	            return refactor && refactor.getEditsForAction(context, actionName);
	        }
	        refactor_1.getEditsForRefactor = getEditsForRefactor;
	    })(refactor = ts.refactor || (ts.refactor = {}));
	    function getRefactorContextSpan(_a) {
	        var startPosition = _a.startPosition, endPosition = _a.endPosition;
	        return ts.createTextSpanFromBounds(startPosition, endPosition === undefined ? startPosition : endPosition);
	    }
	    ts.getRefactorContextSpan = getRefactorContextSpan;
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "addMissingInvocationForDecorator";
	        var errorCodes = [ts.Diagnostics._0_accepts_too_few_arguments_to_be_used_as_a_decorator_here_Did_you_mean_to_call_it_first_and_write_0.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return makeChange(t, context.sourceFile, context.span.start); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Call_decorator_expression, fixId, ts.Diagnostics.Add_to_all_uncalled_decorators)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) { return makeChange(changes, diag.file, diag.start); }); },
	        });
	        function makeChange(changeTracker, sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            var decorator = ts.findAncestor(token, ts.isDecorator);
	            ts.Debug.assert(!!decorator, "Expected position to be owned by a decorator.");
	            var replacement = ts.createCall(decorator.expression, /*typeArguments*/ undefined, /*argumentsArray*/ undefined);
	            changeTracker.replaceNode(sourceFile, decorator.expression, replacement);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "annotateWithTypeFromJSDoc";
	        var errorCodes = [ts.Diagnostics.JSDoc_types_may_be_moved_to_TypeScript_types.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var decl = getDeclaration(context.sourceFile, context.span.start);
	                if (!decl)
	                    return;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, decl); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Annotate_with_type_from_JSDoc, fixId, ts.Diagnostics.Annotate_everything_with_types_from_JSDoc)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var decl = getDeclaration(diag.file, diag.start);
	                if (decl)
	                    doChange(changes, diag.file, decl);
	            }); },
	        });
	        function getDeclaration(file, pos) {
	            var name = ts.getTokenAtPosition(file, pos, /*includeJsDocComment*/ false);
	            // For an arrow function with no name, 'name' lands on the first parameter.
	            return ts.tryCast(ts.isParameter(name.parent) ? name.parent.parent : name.parent, parameterShouldGetTypeFromJSDoc);
	        }
	        function parameterShouldGetTypeFromJSDoc(node) {
	            return isDeclarationWithType(node) && hasUsableJSDoc(node);
	        }
	        codefix.parameterShouldGetTypeFromJSDoc = parameterShouldGetTypeFromJSDoc;
	        function hasUsableJSDoc(decl) {
	            return ts.isFunctionLikeDeclaration(decl)
	                ? decl.parameters.some(hasUsableJSDoc) || (!decl.type && !!ts.getJSDocReturnType(decl))
	                : !decl.type && !!ts.getJSDocType(decl);
	        }
	        function doChange(changes, sourceFile, decl) {
	            if (ts.isFunctionLikeDeclaration(decl) && (ts.getJSDocReturnType(decl) || decl.parameters.some(function (p) { return !!ts.getJSDocType(p); }))) {
	                if (!decl.typeParameters) {
	                    var typeParameters = ts.getJSDocTypeParameterDeclarations(decl);
	                    if (typeParameters.length)
	                        changes.insertTypeParameters(sourceFile, decl, typeParameters);
	                }
	                var needParens = ts.isArrowFunction(decl) && !ts.findChildOfKind(decl, 19 /* OpenParenToken */, sourceFile);
	                if (needParens)
	                    changes.insertNodeBefore(sourceFile, ts.first(decl.parameters), ts.createToken(19 /* OpenParenToken */));
	                for (var _i = 0, _a = decl.parameters; _i < _a.length; _i++) {
	                    var param = _a[_i];
	                    if (!param.type) {
	                        var paramType = ts.getJSDocType(param);
	                        if (paramType)
	                            changes.tryInsertTypeAnnotation(sourceFile, param, transformJSDocType(paramType));
	                    }
	                }
	                if (needParens)
	                    changes.insertNodeAfter(sourceFile, ts.last(decl.parameters), ts.createToken(20 /* CloseParenToken */));
	                if (!decl.type) {
	                    var returnType = ts.getJSDocReturnType(decl);
	                    if (returnType)
	                        changes.tryInsertTypeAnnotation(sourceFile, decl, transformJSDocType(returnType));
	                }
	            }
	            else {
	                var jsdocType = ts.Debug.assertDefined(ts.getJSDocType(decl)); // If not defined, shouldn't have been an error to fix
	                ts.Debug.assert(!decl.type); // If defined, shouldn't have been an error to fix.
	                changes.tryInsertTypeAnnotation(sourceFile, decl, transformJSDocType(jsdocType));
	            }
	        }
	        function isDeclarationWithType(node) {
	            return ts.isFunctionLikeDeclaration(node) ||
	                node.kind === 231 /* VariableDeclaration */ ||
	                node.kind === 150 /* PropertySignature */ ||
	                node.kind === 151 /* PropertyDeclaration */;
	        }
	        function transformJSDocType(node) {
	            switch (node.kind) {
	                case 278 /* JSDocAllType */:
	                case 279 /* JSDocUnknownType */:
	                    return ts.createTypeReferenceNode("any", ts.emptyArray);
	                case 282 /* JSDocOptionalType */:
	                    return transformJSDocOptionalType(node);
	                case 281 /* JSDocNonNullableType */:
	                    return transformJSDocType(node.type);
	                case 280 /* JSDocNullableType */:
	                    return transformJSDocNullableType(node);
	                case 284 /* JSDocVariadicType */:
	                    return transformJSDocVariadicType(node);
	                case 283 /* JSDocFunctionType */:
	                    return transformJSDocFunctionType(node);
	                case 161 /* TypeReference */:
	                    return transformJSDocTypeReference(node);
	                default:
	                    var visited = ts.visitEachChild(node, transformJSDocType, /*context*/ undefined);
	                    ts.setEmitFlags(visited, 1 /* SingleLine */);
	                    return visited;
	            }
	        }
	        function transformJSDocOptionalType(node) {
	            return ts.createUnionTypeNode([ts.visitNode(node.type, transformJSDocType), ts.createTypeReferenceNode("undefined", ts.emptyArray)]);
	        }
	        function transformJSDocNullableType(node) {
	            return ts.createUnionTypeNode([ts.visitNode(node.type, transformJSDocType), ts.createTypeReferenceNode("null", ts.emptyArray)]);
	        }
	        function transformJSDocVariadicType(node) {
	            return ts.createArrayTypeNode(ts.visitNode(node.type, transformJSDocType));
	        }
	        function transformJSDocFunctionType(node) {
	            return ts.createFunctionTypeNode(ts.emptyArray, node.parameters.map(transformJSDocParameter), node.type);
	        }
	        function transformJSDocParameter(node) {
	            var index = node.parent.parameters.indexOf(node);
	            var isRest = node.type.kind === 284 /* JSDocVariadicType */ && index === node.parent.parameters.length - 1;
	            var name = node.name || (isRest ? "rest" : "arg" + index);
	            var dotdotdot = isRest ? ts.createToken(24 /* DotDotDotToken */) : node.dotDotDotToken;
	            return ts.createParameter(node.decorators, node.modifiers, dotdotdot, name, node.questionToken, ts.visitNode(node.type, transformJSDocType), node.initializer);
	        }
	        function transformJSDocTypeReference(node) {
	            var name = node.typeName;
	            var args = node.typeArguments;
	            if (ts.isIdentifier(node.typeName)) {
	                if (ts.isJSDocIndexSignature(node)) {
	                    return transformJSDocIndexSignature(node);
	                }
	                var text = node.typeName.text;
	                switch (node.typeName.text) {
	                    case "String":
	                    case "Boolean":
	                    case "Object":
	                    case "Number":
	                        text = text.toLowerCase();
	                        break;
	                    case "array":
	                    case "date":
	                    case "promise":
	                        text = text[0].toUpperCase() + text.slice(1);
	                        break;
	                }
	                name = ts.createIdentifier(text);
	                if ((text === "Array" || text === "Promise") && !node.typeArguments) {
	                    args = ts.createNodeArray([ts.createTypeReferenceNode("any", ts.emptyArray)]);
	                }
	                else {
	                    args = ts.visitNodes(node.typeArguments, transformJSDocType);
	                }
	            }
	            return ts.createTypeReferenceNode(name, args);
	        }
	        function transformJSDocIndexSignature(node) {
	            var index = ts.createParameter(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*dotDotDotToken*/ undefined, node.typeArguments[0].kind === 134 /* NumberKeyword */ ? "n" : "s", 
	            /*questionToken*/ undefined, ts.createTypeReferenceNode(node.typeArguments[0].kind === 134 /* NumberKeyword */ ? "number" : "string", []), 
	            /*initializer*/ undefined);
	            var indexSignature = ts.createTypeLiteralNode([ts.createIndexSignature(/*decorators*/ undefined, /*modifiers*/ undefined, [index], node.typeArguments[1])]);
	            ts.setEmitFlags(indexSignature, 1 /* SingleLine */);
	            return indexSignature;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "convertFunctionToEs6Class";
	        var errorCodes = [ts.Diagnostics.This_constructor_function_may_be_converted_to_a_class_declaration.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, context.span.start, context.program.getTypeChecker()); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Convert_function_to_an_ES2015_class, fixId, ts.Diagnostics.Convert_all_constructor_functions_to_classes)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, err) { return doChange(changes, err.file, err.start, context.program.getTypeChecker()); }); },
	        });
	        function doChange(changes, sourceFile, position, checker) {
	            var deletedNodes = [];
	            var ctorSymbol = checker.getSymbolAtLocation(ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false));
	            if (!ctorSymbol || !(ctorSymbol.flags & (16 /* Function */ | 3 /* Variable */))) {
	                // Bad input
	                return undefined;
	            }
	            var ctorDeclaration = ctorSymbol.valueDeclaration;
	            var precedingNode;
	            var newClassDeclaration;
	            switch (ctorDeclaration.kind) {
	                case 233 /* FunctionDeclaration */:
	                    precedingNode = ctorDeclaration;
	                    deleteNode(ctorDeclaration);
	                    newClassDeclaration = createClassFromFunctionDeclaration(ctorDeclaration);
	                    break;
	                case 231 /* VariableDeclaration */:
	                    precedingNode = ctorDeclaration.parent.parent;
	                    newClassDeclaration = createClassFromVariableDeclaration(ctorDeclaration);
	                    if (ctorDeclaration.parent.declarations.length === 1) {
	                        copyComments(precedingNode, newClassDeclaration, sourceFile);
	                        deleteNode(precedingNode);
	                    }
	                    else {
	                        deleteNode(ctorDeclaration, /*inList*/ true);
	                    }
	                    break;
	            }
	            if (!newClassDeclaration) {
	                return undefined;
	            }
	            copyComments(ctorDeclaration, newClassDeclaration, sourceFile);
	            // Because the preceding node could be touched, we need to insert nodes before delete nodes.
	            changes.insertNodeAfter(sourceFile, precedingNode, newClassDeclaration);
	            for (var _i = 0, deletedNodes_1 = deletedNodes; _i < deletedNodes_1.length; _i++) {
	                var _a = deletedNodes_1[_i], node = _a.node, inList = _a.inList;
	                if (inList) {
	                    changes.deleteNodeInList(sourceFile, node);
	                }
	                else {
	                    changes.deleteNode(sourceFile, node);
	                }
	            }
	            function deleteNode(node, inList) {
	                if (inList === void 0) { inList = false; }
	                // If parent node has already been deleted, do nothing
	                if (!deletedNodes.some(function (n) { return ts.isNodeDescendantOf(node, n.node); })) {
	                    deletedNodes.push({ node: node, inList: inList });
	                }
	            }
	            function createClassElementsFromSymbol(symbol) {
	                var memberElements = [];
	                // all instance members are stored in the "member" array of symbol
	                if (symbol.members) {
	                    symbol.members.forEach(function (member) {
	                        var memberElement = createClassElement(member, /*modifiers*/ undefined);
	                        if (memberElement) {
	                            memberElements.push(memberElement);
	                        }
	                    });
	                }
	                // all static members are stored in the "exports" array of symbol
	                if (symbol.exports) {
	                    symbol.exports.forEach(function (member) {
	                        var memberElement = createClassElement(member, [ts.createToken(115 /* StaticKeyword */)]);
	                        if (memberElement) {
	                            memberElements.push(memberElement);
	                        }
	                    });
	                }
	                return memberElements;
	                function shouldConvertDeclaration(_target, source) {
	                    // Right now the only thing we can convert are function expressions - other values shouldn't get
	                    // transformed. We can update this once ES public class properties are available.
	                    return ts.isFunctionLike(source);
	                }
	                function createClassElement(symbol, modifiers) {
	                    // Right now the only thing we can convert are function expressions, which are marked as methods
	                    if (!(symbol.flags & 8192 /* Method */)) {
	                        return;
	                    }
	                    var memberDeclaration = symbol.valueDeclaration;
	                    var assignmentBinaryExpression = memberDeclaration.parent;
	                    if (!shouldConvertDeclaration(memberDeclaration, assignmentBinaryExpression.right)) {
	                        return;
	                    }
	                    // delete the entire statement if this expression is the sole expression to take care of the semicolon at the end
	                    var nodeToDelete = assignmentBinaryExpression.parent && assignmentBinaryExpression.parent.kind === 215 /* ExpressionStatement */
	                        ? assignmentBinaryExpression.parent : assignmentBinaryExpression;
	                    deleteNode(nodeToDelete);
	                    if (!assignmentBinaryExpression.right) {
	                        return ts.createProperty([], modifiers, symbol.name, /*questionToken*/ undefined, 
	                        /*type*/ undefined, /*initializer*/ undefined);
	                    }
	                    switch (assignmentBinaryExpression.right.kind) {
	                        case 191 /* FunctionExpression */: {
	                            var functionExpression = assignmentBinaryExpression.right;
	                            var fullModifiers = ts.concatenate(modifiers, getModifierKindFromSource(functionExpression, 120 /* AsyncKeyword */));
	                            var method = ts.createMethod(/*decorators*/ undefined, fullModifiers, /*asteriskToken*/ undefined, memberDeclaration.name, /*questionToken*/ undefined, 
	                            /*typeParameters*/ undefined, functionExpression.parameters, /*type*/ undefined, functionExpression.body);
	                            copyComments(assignmentBinaryExpression, method, sourceFile);
	                            return method;
	                        }
	                        case 192 /* ArrowFunction */: {
	                            var arrowFunction = assignmentBinaryExpression.right;
	                            var arrowFunctionBody = arrowFunction.body;
	                            var bodyBlock = void 0;
	                            // case 1: () => { return [1,2,3] }
	                            if (arrowFunctionBody.kind === 212 /* Block */) {
	                                bodyBlock = arrowFunctionBody;
	                            }
	                            // case 2: () => [1,2,3]
	                            else {
	                                bodyBlock = ts.createBlock([ts.createReturn(arrowFunctionBody)]);
	                            }
	                            var fullModifiers = ts.concatenate(modifiers, getModifierKindFromSource(arrowFunction, 120 /* AsyncKeyword */));
	                            var method = ts.createMethod(/*decorators*/ undefined, fullModifiers, /*asteriskToken*/ undefined, memberDeclaration.name, /*questionToken*/ undefined, 
	                            /*typeParameters*/ undefined, arrowFunction.parameters, /*type*/ undefined, bodyBlock);
	                            copyComments(assignmentBinaryExpression, method, sourceFile);
	                            return method;
	                        }
	                        default: {
	                            // Don't try to declare members in JavaScript files
	                            if (ts.isSourceFileJavaScript(sourceFile)) {
	                                return;
	                            }
	                            var prop = ts.createProperty(/*decorators*/ undefined, modifiers, memberDeclaration.name, /*questionToken*/ undefined, 
	                            /*type*/ undefined, assignmentBinaryExpression.right);
	                            copyComments(assignmentBinaryExpression.parent, prop, sourceFile);
	                            return prop;
	                        }
	                    }
	                }
	            }
	            function createClassFromVariableDeclaration(node) {
	                var initializer = node.initializer;
	                if (!initializer || initializer.kind !== 191 /* FunctionExpression */) {
	                    return undefined;
	                }
	                if (node.name.kind !== 71 /* Identifier */) {
	                    return undefined;
	                }
	                var memberElements = createClassElementsFromSymbol(initializer.symbol);
	                if (initializer.body) {
	                    memberElements.unshift(ts.createConstructor(/*decorators*/ undefined, /*modifiers*/ undefined, initializer.parameters, initializer.body));
	                }
	                var modifiers = getModifierKindFromSource(precedingNode, 84 /* ExportKeyword */);
	                var cls = ts.createClassDeclaration(/*decorators*/ undefined, modifiers, node.name, 
	                /*typeParameters*/ undefined, /*heritageClauses*/ undefined, memberElements);
	                // Don't call copyComments here because we'll already leave them in place
	                return cls;
	            }
	            function createClassFromFunctionDeclaration(node) {
	                var memberElements = createClassElementsFromSymbol(ctorSymbol);
	                if (node.body) {
	                    memberElements.unshift(ts.createConstructor(/*decorators*/ undefined, /*modifiers*/ undefined, node.parameters, node.body));
	                }
	                var modifiers = getModifierKindFromSource(node, 84 /* ExportKeyword */);
	                var cls = ts.createClassDeclaration(/*decorators*/ undefined, modifiers, node.name, 
	                /*typeParameters*/ undefined, /*heritageClauses*/ undefined, memberElements);
	                // Don't call copyComments here because we'll already leave them in place
	                return cls;
	            }
	        }
	        function copyComments(sourceNode, targetNode, sourceFile) {
	            ts.forEachLeadingCommentRange(sourceFile.text, sourceNode.pos, function (pos, end, kind, htnl) {
	                if (kind === 3 /* MultiLineCommentTrivia */) {
	                    // Remove leading /*
	                    pos += 2;
	                    // Remove trailing */
	                    end -= 2;
	                }
	                else {
	                    // Remove leading //
	                    pos += 2;
	                }
	                ts.addSyntheticLeadingComment(targetNode, kind, sourceFile.text.slice(pos, end), htnl);
	            });
	        }
	        function getModifierKindFromSource(source, kind) {
	            return ts.filter(source.modifiers, function (modifier) { return modifier.kind === kind; });
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        codefix.registerCodeFix({
	            errorCodes: [ts.Diagnostics.File_is_a_CommonJS_module_it_may_be_converted_to_an_ES6_module.code],
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, preferences = context.preferences;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (changes) {
	                    var moduleExportsChangedToDefault = convertFileToEs6Module(sourceFile, program.getTypeChecker(), changes, program.getCompilerOptions().target, ts.getQuotePreference(sourceFile, preferences));
	                    if (moduleExportsChangedToDefault) {
	                        for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                            var importingFile = _a[_i];
	                            fixImportOfModuleExports(importingFile, sourceFile, changes, ts.getQuotePreference(importingFile, preferences));
	                        }
	                    }
	                });
	                // No support for fix-all since this applies to the whole file at once anyway.
	                return [codefix.createCodeFixActionNoFixId("convertToEs6Module", changes, ts.Diagnostics.Convert_to_ES6_module)];
	            },
	        });
	        function fixImportOfModuleExports(importingFile, exportingFile, changes, quotePreference) {
	            for (var _i = 0, _a = importingFile.imports; _i < _a.length; _i++) {
	                var moduleSpecifier = _a[_i];
	                var imported = ts.getResolvedModule(importingFile, moduleSpecifier.text);
	                if (!imported || imported.resolvedFileName !== exportingFile.fileName) {
	                    continue;
	                }
	                var importNode = ts.importFromModuleSpecifier(moduleSpecifier);
	                switch (importNode.kind) {
	                    case 242 /* ImportEqualsDeclaration */:
	                        changes.replaceNode(importingFile, importNode, ts.makeImport(importNode.name, /*namedImports*/ undefined, moduleSpecifier, quotePreference));
	                        break;
	                    case 186 /* CallExpression */:
	                        if (ts.isRequireCall(importNode, /*checkArgumentIsStringLiteralLike*/ false)) {
	                            changes.replaceNode(importingFile, importNode, ts.createPropertyAccess(ts.getSynthesizedDeepClone(importNode), "default"));
	                        }
	                        break;
	                }
	            }
	        }
	        /** @returns Whether we converted a `module.exports =` to a default export. */
	        function convertFileToEs6Module(sourceFile, checker, changes, target, quotePreference) {
	            var identifiers = { original: collectFreeIdentifiers(sourceFile), additional: ts.createMap() };
	            var exports = collectExportRenames(sourceFile, checker, identifiers);
	            convertExportsAccesses(sourceFile, exports, changes);
	            var moduleExportsChangedToDefault = false;
	            for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                var moduleExportsChanged = convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports, quotePreference);
	                moduleExportsChangedToDefault = moduleExportsChangedToDefault || moduleExportsChanged;
	            }
	            return moduleExportsChangedToDefault;
	        }
	        function collectExportRenames(sourceFile, checker, identifiers) {
	            var res = ts.createMap();
	            forEachExportReference(sourceFile, function (node) {
	                var _a = node.name, text = _a.text, originalKeywordKind = _a.originalKeywordKind;
	                if (!res.has(text) && (originalKeywordKind !== undefined && ts.isNonContextualKeyword(originalKeywordKind)
	                    || checker.resolveName(node.name.text, node, 67216319 /* Value */, /*excludeGlobals*/ true))) {
	                    // Unconditionally add an underscore in case `text` is a keyword.
	                    res.set(text, makeUniqueName("_" + text, identifiers));
	                }
	            });
	            return res;
	        }
	        function convertExportsAccesses(sourceFile, exports, changes) {
	            forEachExportReference(sourceFile, function (node, isAssignmentLhs) {
	                if (isAssignmentLhs) {
	                    return;
	                }
	                var text = node.name.text;
	                changes.replaceNode(sourceFile, node, ts.createIdentifier(exports.get(text) || text));
	            });
	        }
	        function forEachExportReference(sourceFile, cb) {
	            sourceFile.forEachChild(function recur(node) {
	                if (ts.isPropertyAccessExpression(node) && ts.isExportsOrModuleExportsOrAlias(sourceFile, node.expression)) {
	                    var parent = node.parent;
	                    cb(node, ts.isBinaryExpression(parent) && parent.left === node && parent.operatorToken.kind === 58 /* EqualsToken */);
	                }
	                node.forEachChild(recur);
	            });
	        }
	        function convertStatement(sourceFile, statement, checker, changes, identifiers, target, exports, quotePreference) {
	            switch (statement.kind) {
	                case 213 /* VariableStatement */:
	                    convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference);
	                    return false;
	                case 215 /* ExpressionStatement */: {
	                    var expression = statement.expression;
	                    switch (expression.kind) {
	                        case 186 /* CallExpression */: {
	                            if (ts.isRequireCall(expression, /*checkArgumentIsStringLiteralLike*/ true)) {
	                                // For side-effecting require() call, just make a side-effecting import.
	                                changes.replaceNode(sourceFile, statement, ts.makeImport(/*name*/ undefined, /*namedImports*/ undefined, expression.arguments[0], quotePreference));
	                            }
	                            return false;
	                        }
	                        case 199 /* BinaryExpression */: {
	                            var operatorToken = expression.operatorToken;
	                            return operatorToken.kind === 58 /* EqualsToken */ && convertAssignment(sourceFile, checker, expression, changes, exports);
	                        }
	                    }
	                }
	                // falls through
	                default:
	                    return false;
	            }
	        }
	        function convertVariableStatement(sourceFile, statement, changes, checker, identifiers, target, quotePreference) {
	            var declarationList = statement.declarationList;
	            var foundImport = false;
	            var newNodes = ts.flatMap(declarationList.declarations, function (decl) {
	                var name = decl.name, initializer = decl.initializer;
	                if (initializer) {
	                    if (ts.isExportsOrModuleExportsOrAlias(sourceFile, initializer)) {
	                        // `const alias = module.exports;` can be removed.
	                        foundImport = true;
	                        return [];
	                    }
	                    else if (ts.isRequireCall(initializer, /*checkArgumentIsStringLiteralLike*/ true)) {
	                        foundImport = true;
	                        return convertSingleImport(sourceFile, name, initializer.arguments[0], changes, checker, identifiers, target, quotePreference);
	                    }
	                    else if (ts.isPropertyAccessExpression(initializer) && ts.isRequireCall(initializer.expression, /*checkArgumentIsStringLiteralLike*/ true)) {
	                        foundImport = true;
	                        return convertPropertyAccessImport(name, initializer.name.text, initializer.expression.arguments[0], identifiers, quotePreference);
	                    }
	                }
	                // Move it out to its own variable statement. (This will not be used if `!foundImport`)
	                return ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList([decl], declarationList.flags));
	            });
	            if (foundImport) {
	                // useNonAdjustedEndPosition to ensure we don't eat the newline after the statement.
	                changes.replaceNodeWithNodes(sourceFile, statement, newNodes);
	            }
	        }
	        /** Converts `const name = require("moduleSpecifier").propertyName` */
	        function convertPropertyAccessImport(name, propertyName, moduleSpecifier, identifiers, quotePreference) {
	            switch (name.kind) {
	                case 179 /* ObjectBindingPattern */:
	                case 180 /* ArrayBindingPattern */: {
	                    // `const [a, b] = require("c").d` --> `import { d } from "c"; const [a, b] = d;`
	                    var tmp = makeUniqueName(propertyName, identifiers);
	                    return [
	                        makeSingleImport(tmp, propertyName, moduleSpecifier, quotePreference),
	                        makeConst(/*modifiers*/ undefined, name, ts.createIdentifier(tmp)),
	                    ];
	                }
	                case 71 /* Identifier */:
	                    // `const a = require("b").c` --> `import { c as a } from "./b";
	                    return [makeSingleImport(name.text, propertyName, moduleSpecifier, quotePreference)];
	                default:
	                    ts.Debug.assertNever(name);
	            }
	        }
	        function convertAssignment(sourceFile, checker, assignment, changes, exports) {
	            var left = assignment.left, right = assignment.right;
	            if (!ts.isPropertyAccessExpression(left)) {
	                return false;
	            }
	            if (ts.isExportsOrModuleExportsOrAlias(sourceFile, left)) {
	                if (ts.isExportsOrModuleExportsOrAlias(sourceFile, right)) {
	                    // `const alias = module.exports;` or `module.exports = alias;` can be removed.
	                    changes.deleteNode(sourceFile, assignment.parent);
	                }
	                else {
	                    var replacement = ts.isObjectLiteralExpression(right) ? tryChangeModuleExportsObject(right)
	                        : ts.isRequireCall(right, /*checkArgumentIsStringLiteralLike*/ true) ? convertReExportAll(right.arguments[0], checker)
	                            : undefined;
	                    if (replacement) {
	                        changes.replaceNodeWithNodes(sourceFile, assignment.parent, replacement[0]);
	                        return replacement[1];
	                    }
	                    else {
	                        changes.replaceRangeWithText(sourceFile, ts.createTextRange(left.getStart(sourceFile), right.pos), "export default");
	                        return true;
	                    }
	                }
	            }
	            else if (ts.isExportsOrModuleExportsOrAlias(sourceFile, left.expression)) {
	                convertNamedExport(sourceFile, assignment, changes, exports);
	            }
	            return false;
	        }
	        /**
	         * Convert `module.exports = { ... }` to individual exports..
	         * We can't always do this if the module has interesting members -- then it will be a default export instead.
	         */
	        function tryChangeModuleExportsObject(object) {
	            var statements = ts.mapAllOrFail(object.properties, function (prop) {
	                switch (prop.kind) {
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    // TODO: Maybe we should handle this? See fourslash test `refactorConvertToEs6Module_export_object_shorthand.ts`.
	                    case 270 /* ShorthandPropertyAssignment */:
	                    case 271 /* SpreadAssignment */:
	                        return undefined;
	                    case 269 /* PropertyAssignment */:
	                        return !ts.isIdentifier(prop.name) ? undefined : convertExportsDotXEquals_replaceNode(prop.name.text, prop.initializer);
	                    case 153 /* MethodDeclaration */:
	                        return !ts.isIdentifier(prop.name) ? undefined : functionExpressionToDeclaration(prop.name.text, [ts.createToken(84 /* ExportKeyword */)], prop);
	                    default:
	                        ts.Debug.assertNever(prop);
	                }
	            });
	            return statements && [statements, false];
	        }
	        function convertNamedExport(sourceFile, assignment, changes, exports) {
	            // If "originalKeywordKind" was set, this is e.g. `exports.
	            var text = assignment.left.name.text;
	            var rename = exports.get(text);
	            if (rename !== undefined) {
	                /*
	                const _class = 0;
	                export { _class as class };
	                */
	                var newNodes = [
	                    makeConst(/*modifiers*/ undefined, rename, assignment.right),
	                    makeExportDeclaration([ts.createExportSpecifier(rename, text)]),
	                ];
	                changes.replaceNodeWithNodes(sourceFile, assignment.parent, newNodes);
	            }
	            else {
	                convertExportsPropertyAssignment(assignment, sourceFile, changes);
	            }
	        }
	        function convertReExportAll(reExported, checker) {
	            // `module.exports = require("x");` ==> `export * from "x"; export { default } from "x";`
	            var moduleSpecifier = reExported.text;
	            var moduleSymbol = checker.getSymbolAtLocation(reExported);
	            var exports = moduleSymbol ? moduleSymbol.exports : ts.emptyUnderscoreEscapedMap;
	            return exports.has("export=")
	                ? [[reExportDefault(moduleSpecifier)], true]
	                : !exports.has("default")
	                    ? [[reExportStar(moduleSpecifier)], false]
	                    // If there's some non-default export, must include both `export *` and `export default`.
	                    : exports.size > 1 ? [[reExportStar(moduleSpecifier), reExportDefault(moduleSpecifier)], true] : [[reExportDefault(moduleSpecifier)], true];
	        }
	        function reExportStar(moduleSpecifier) {
	            return makeExportDeclaration(/*exportClause*/ undefined, moduleSpecifier);
	        }
	        function reExportDefault(moduleSpecifier) {
	            return makeExportDeclaration([ts.createExportSpecifier(/*propertyName*/ undefined, "default")], moduleSpecifier);
	        }
	        function convertExportsPropertyAssignment(_a, sourceFile, changes) {
	            var left = _a.left, right = _a.right, parent = _a.parent;
	            var name = left.name.text;
	            if ((ts.isFunctionExpression(right) || ts.isArrowFunction(right) || ts.isClassExpression(right)) && (!right.name || right.name.text === name)) {
	                // `exports.f = function() {}` -> `export function f() {}` -- Replace `exports.f = ` with `export `, and insert the name after `function`.
	                changes.replaceRange(sourceFile, { pos: left.getStart(sourceFile), end: right.getStart(sourceFile) }, ts.createToken(84 /* ExportKeyword */), { suffix: " " });
	                if (!right.name)
	                    changes.insertName(sourceFile, right, name);
	                var semi = ts.findChildOfKind(parent, 25 /* SemicolonToken */, sourceFile);
	                if (semi)
	                    changes.deleteNode(sourceFile, semi, { useNonAdjustedEndPosition: true });
	            }
	            else {
	                // `exports.f = function g() {}` -> `export const f = function g() {}` -- just replace `exports.` with `export const `
	                changes.replaceNodeRangeWithNodes(sourceFile, left.expression, ts.findChildOfKind(left, 23 /* DotToken */, sourceFile), [ts.createToken(84 /* ExportKeyword */), ts.createToken(76 /* ConstKeyword */)], { joiner: " ", suffix: " " });
	            }
	        }
	        // TODO: GH#22492 this will cause an error if a change has been made inside the body of the node.
	        function convertExportsDotXEquals_replaceNode(name, exported) {
	            var modifiers = [ts.createToken(84 /* ExportKeyword */)];
	            switch (exported.kind) {
	                case 191 /* FunctionExpression */: {
	                    var expressionName = exported.name;
	                    if (expressionName && expressionName.text !== name) {
	                        // `exports.f = function g() {}` -> `export const f = function g() {}`
	                        return exportConst();
	                    }
	                }
	                // falls through
	                case 192 /* ArrowFunction */:
	                    // `exports.f = function() {}` --> `export function f() {}`
	                    return functionExpressionToDeclaration(name, modifiers, exported);
	                case 204 /* ClassExpression */:
	                    // `exports.C = class {}` --> `export class C {}`
	                    return classExpressionToDeclaration(name, modifiers, exported);
	                default:
	                    return exportConst();
	            }
	            function exportConst() {
	                // `exports.x = 0;` --> `export const x = 0;`
	                return makeConst(modifiers, ts.createIdentifier(name), exported);
	            }
	        }
	        /**
	         * Converts `const <<name>> = require("x");`.
	         * Returns nodes that will replace the variable declaration for the commonjs import.
	         * May also make use `changes` to remove qualifiers at the use sites of imports, to change `mod.x` to `x`.
	         */
	        function convertSingleImport(file, name, moduleSpecifier, changes, checker, identifiers, target, quotePreference) {
	            switch (name.kind) {
	                case 179 /* ObjectBindingPattern */: {
	                    var importSpecifiers = ts.mapAllOrFail(name.elements, function (e) {
	                        return e.dotDotDotToken || e.initializer || e.propertyName && !ts.isIdentifier(e.propertyName) || !ts.isIdentifier(e.name)
	                            ? undefined
	                            : makeImportSpecifier(e.propertyName && e.propertyName.text, e.name.text);
	                    });
	                    if (importSpecifiers) {
	                        return [ts.makeImport(/*name*/ undefined, importSpecifiers, moduleSpecifier, quotePreference)];
	                    }
	                }
	                // falls through -- object destructuring has an interesting pattern and must be a variable declaration
	                case 180 /* ArrayBindingPattern */: {
	                    /*
	                    import x from "x";
	                    const [a, b, c] = x;
	                    */
	                    var tmp = makeUniqueName(codefix.moduleSpecifierToValidIdentifier(moduleSpecifier.text, target), identifiers);
	                    return [
	                        ts.makeImport(ts.createIdentifier(tmp), /*namedImports*/ undefined, moduleSpecifier, quotePreference),
	                        makeConst(/*modifiers*/ undefined, ts.getSynthesizedDeepClone(name), ts.createIdentifier(tmp)),
	                    ];
	                }
	                case 71 /* Identifier */:
	                    return convertSingleIdentifierImport(file, name, moduleSpecifier, changes, checker, identifiers, quotePreference);
	                default:
	                    ts.Debug.assertNever(name);
	            }
	        }
	        /**
	         * Convert `import x = require("x").`
	         * Also converts uses like `x.y()` to `y()` and uses a named import.
	         */
	        function convertSingleIdentifierImport(file, name, moduleSpecifier, changes, checker, identifiers, quotePreference) {
	            var nameSymbol = checker.getSymbolAtLocation(name);
	            // Maps from module property name to name actually used. (The same if there isn't shadowing.)
	            var namedBindingsNames = ts.createMap();
	            // True if there is some non-property use like `x()` or `f(x)`.
	            var needDefaultImport = false;
	            for (var _i = 0, _a = identifiers.original.get(name.text); _i < _a.length; _i++) {
	                var use = _a[_i];
	                if (checker.getSymbolAtLocation(use) !== nameSymbol || use === name) {
	                    // This was a use of a different symbol with the same name, due to shadowing. Ignore.
	                    continue;
	                }
	                var parent = use.parent;
	                if (ts.isPropertyAccessExpression(parent)) {
	                    var expression = parent.expression, propertyName = parent.name.text;
	                    ts.Debug.assert(expression === use); // Else shouldn't have been in `collectIdentifiers`
	                    var idName = namedBindingsNames.get(propertyName);
	                    if (idName === undefined) {
	                        idName = makeUniqueName(propertyName, identifiers);
	                        namedBindingsNames.set(propertyName, idName);
	                    }
	                    changes.replaceNode(file, parent, ts.createIdentifier(idName));
	                }
	                else {
	                    needDefaultImport = true;
	                }
	            }
	            var namedBindings = namedBindingsNames.size === 0 ? undefined : ts.arrayFrom(ts.mapIterator(namedBindingsNames.entries(), function (_a) {
	                var propertyName = _a[0], idName = _a[1];
	                return ts.createImportSpecifier(propertyName === idName ? undefined : ts.createIdentifier(propertyName), ts.createIdentifier(idName));
	            }));
	            if (!namedBindings) {
	                // If it was unused, ensure that we at least import *something*.
	                needDefaultImport = true;
	            }
	            return [ts.makeImport(needDefaultImport ? ts.getSynthesizedDeepClone(name) : undefined, namedBindings, moduleSpecifier, quotePreference)];
	        }
	        // Identifiers helpers
	        function makeUniqueName(name, identifiers) {
	            while (identifiers.original.has(name) || identifiers.additional.has(name)) {
	                name = "_" + name;
	            }
	            identifiers.additional.set(name, true);
	            return name;
	        }
	        function collectFreeIdentifiers(file) {
	            var map = ts.createMultiMap();
	            file.forEachChild(function recur(node) {
	                if (ts.isIdentifier(node) && isFreeIdentifier(node)) {
	                    map.add(node.text, node);
	                }
	                node.forEachChild(recur);
	            });
	            return map;
	        }
	        function isFreeIdentifier(node) {
	            var parent = node.parent;
	            switch (parent.kind) {
	                case 184 /* PropertyAccessExpression */:
	                    return parent.name !== node;
	                case 181 /* BindingElement */:
	                    return parent.propertyName !== node;
	                default:
	                    return true;
	            }
	        }
	        // Node helpers
	        function functionExpressionToDeclaration(name, additionalModifiers, fn) {
	            return ts.createFunctionDeclaration(ts.getSynthesizedDeepClones(fn.decorators), // TODO: GH#19915 Don't think this is even legal.
	            ts.concatenate(additionalModifiers, ts.getSynthesizedDeepClones(fn.modifiers)), ts.getSynthesizedDeepClone(fn.asteriskToken), name, ts.getSynthesizedDeepClones(fn.typeParameters), ts.getSynthesizedDeepClones(fn.parameters), ts.getSynthesizedDeepClone(fn.type), ts.convertToFunctionBody(ts.getSynthesizedDeepClone(fn.body)));
	        }
	        function classExpressionToDeclaration(name, additionalModifiers, cls) {
	            return ts.createClassDeclaration(ts.getSynthesizedDeepClones(cls.decorators), // TODO: GH#19915 Don't think this is even legal.
	            ts.concatenate(additionalModifiers, ts.getSynthesizedDeepClones(cls.modifiers)), name, ts.getSynthesizedDeepClones(cls.typeParameters), ts.getSynthesizedDeepClones(cls.heritageClauses), ts.getSynthesizedDeepClones(cls.members));
	        }
	        function makeSingleImport(localName, propertyName, moduleSpecifier, quotePreference) {
	            return propertyName === "default"
	                ? ts.makeImport(ts.createIdentifier(localName), /*namedImports*/ undefined, moduleSpecifier, quotePreference)
	                : ts.makeImport(/*name*/ undefined, [makeImportSpecifier(propertyName, localName)], moduleSpecifier, quotePreference);
	        }
	        function makeImportSpecifier(propertyName, name) {
	            return ts.createImportSpecifier(propertyName !== undefined && propertyName !== name ? ts.createIdentifier(propertyName) : undefined, ts.createIdentifier(name));
	        }
	        function makeConst(modifiers, name, init) {
	            return ts.createVariableStatement(modifiers, ts.createVariableDeclarationList([ts.createVariableDeclaration(name, /*type*/ undefined, init)], 2 /* Const */));
	        }
	        function makeExportDeclaration(exportSpecifiers, moduleSpecifier) {
	            return ts.createExportDeclaration(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, exportSpecifiers && ts.createNamedExports(exportSpecifiers), moduleSpecifier === undefined ? undefined : ts.createLiteral(moduleSpecifier));
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "correctQualifiedNameToIndexedAccessType";
	        var errorCodes = [ts.Diagnostics.Cannot_access_0_1_because_0_is_a_type_but_not_a_namespace_Did_you_mean_to_retrieve_the_type_of_the_property_1_in_0_with_0_1.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var qualifiedName = getQualifiedName(context.sourceFile, context.span.start);
	                if (!qualifiedName)
	                    return undefined;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, qualifiedName); });
	                var newText = qualifiedName.left.text + "[\"" + qualifiedName.right.text + "\"]";
	                return [codefix.createCodeFixAction(fixId, changes, [ts.Diagnostics.Rewrite_as_the_indexed_access_type_0, newText], fixId, ts.Diagnostics.Rewrite_all_as_indexed_access_types)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var q = getQualifiedName(diag.file, diag.start);
	                if (q) {
	                    doChange(changes, diag.file, q);
	                }
	            }); },
	        });
	        function getQualifiedName(sourceFile, pos) {
	            var qualifiedName = ts.findAncestor(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ true), ts.isQualifiedName);
	            ts.Debug.assert(!!qualifiedName, "Expected position to be owned by a qualified name.");
	            return ts.isIdentifier(qualifiedName.left) ? qualifiedName : undefined;
	        }
	        function doChange(changeTracker, sourceFile, qualifiedName) {
	            var rightText = qualifiedName.right.text;
	            var replacement = ts.createIndexedAccessTypeNode(ts.createTypeReferenceNode(qualifiedName.left, /*typeArguments*/ undefined), ts.createLiteralTypeNode(ts.createLiteral(rightText)));
	            changeTracker.replaceNode(sourceFile, qualifiedName, replacement);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodes = [ts.Diagnostics.Class_0_incorrectly_implements_interface_1.code,
	            ts.Diagnostics.Class_0_incorrectly_implements_class_1_Did_you_mean_to_extend_1_and_inherit_its_members_as_a_subclass.code];
	        var fixId = "fixClassIncorrectlyImplementsInterface"; // TODO: share a group with fixClassDoesntImplementInheritedAbstractMember?
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var program = context.program, sourceFile = context.sourceFile, span = context.span;
	                var classDeclaration = getClass(sourceFile, span.start);
	                var checker = program.getTypeChecker();
	                return ts.mapDefined(ts.getClassImplementsHeritageClauseElements(classDeclaration), function (implementedTypeNode) {
	                    var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMissingDeclarations(checker, implementedTypeNode, sourceFile, classDeclaration, t, context.preferences); });
	                    return changes.length === 0 ? undefined : codefix.createCodeFixAction(fixId, changes, [ts.Diagnostics.Implement_interface_0, implementedTypeNode.getText(sourceFile)], fixId, ts.Diagnostics.Implement_all_unimplemented_interfaces);
	                });
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenClassDeclarations = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var classDeclaration = getClass(diag.file, diag.start);
	                    if (ts.addToSeen(seenClassDeclarations, ts.getNodeId(classDeclaration))) {
	                        for (var _i = 0, _a = ts.getClassImplementsHeritageClauseElements(classDeclaration); _i < _a.length; _i++) {
	                            var implementedTypeNode = _a[_i];
	                            addMissingDeclarations(context.program.getTypeChecker(), implementedTypeNode, diag.file, classDeclaration, changes, context.preferences);
	                        }
	                    }
	                });
	            },
	        });
	        function getClass(sourceFile, pos) {
	            return ts.Debug.assertDefined(ts.getContainingClass(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false)));
	        }
	        function addMissingDeclarations(checker, implementedTypeNode, sourceFile, classDeclaration, changeTracker, preferences) {
	            // Note that this is ultimately derived from a map indexed by symbol names,
	            // so duplicates cannot occur.
	            var implementedType = checker.getTypeAtLocation(implementedTypeNode);
	            var implementedTypeSymbols = checker.getPropertiesOfType(implementedType);
	            var nonPrivateMembers = implementedTypeSymbols.filter(function (symbol) { return !(ts.getModifierFlags(symbol.valueDeclaration) & 8 /* Private */); });
	            var classType = checker.getTypeAtLocation(classDeclaration);
	            if (!classType.getNumberIndexType()) {
	                createMissingIndexSignatureDeclaration(implementedType, 1 /* Number */);
	            }
	            if (!classType.getStringIndexType()) {
	                createMissingIndexSignatureDeclaration(implementedType, 0 /* String */);
	            }
	            codefix.createMissingMemberNodes(classDeclaration, nonPrivateMembers, checker, preferences, function (member) { return changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, member); });
	            function createMissingIndexSignatureDeclaration(type, kind) {
	                var indexInfoOfKind = checker.getIndexInfoOfType(type, kind);
	                if (indexInfoOfKind) {
	                    changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, checker.indexInfoToIndexSignatureDeclaration(indexInfoOfKind, kind, classDeclaration));
	                }
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var ChangeTracker = ts.textChanges.ChangeTracker;
	        codefix.registerCodeFix({
	            errorCodes: [
	                ts.Diagnostics.Cannot_find_name_0.code,
	                ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
	                ts.Diagnostics.Cannot_find_namespace_0.code,
	                ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code,
	                ts.Diagnostics._0_only_refers_to_a_type_but_is_being_used_as_a_value_here.code,
	            ],
	            getCodeActions: getImportCodeActions,
	            // TODO: GH#20315
	            fixIds: [],
	            getAllCodeActions: ts.notImplemented,
	        });
	        function createCodeAction(descriptionDiagnostic, diagnosticArgs, changes) {
	            // TODO: GH#20315
	            return codefix.createCodeFixActionNoFixId("import", changes, [descriptionDiagnostic].concat(diagnosticArgs));
	        }
	        function convertToImportCodeFixContext(context, symbolToken, symbolName) {
	            var program = context.program;
	            var checker = program.getTypeChecker();
	            return {
	                host: context.host,
	                formatContext: context.formatContext,
	                sourceFile: context.sourceFile,
	                program: program,
	                checker: checker,
	                compilerOptions: program.getCompilerOptions(),
	                cachedImportDeclarations: [],
	                getCanonicalFileName: ts.createGetCanonicalFileName(ts.hostUsesCaseSensitiveFileNames(context.host)),
	                symbolName: symbolName,
	                symbolToken: symbolToken,
	                preferences: context.preferences,
	            };
	        }
	        var ImportKind;
	        (function (ImportKind) {
	            ImportKind[ImportKind["Named"] = 0] = "Named";
	            ImportKind[ImportKind["Default"] = 1] = "Default";
	            ImportKind[ImportKind["Namespace"] = 2] = "Namespace";
	            ImportKind[ImportKind["Equals"] = 3] = "Equals";
	        })(ImportKind || (ImportKind = {}));
	        function getImportCompletionAction(exportedSymbol, moduleSymbol, sourceFile, symbolName, host, program, checker, compilerOptions, allSourceFiles, formatContext, getCanonicalFileName, symbolToken, preferences) {
	            var exportInfos = getAllReExportingModules(exportedSymbol, moduleSymbol, symbolName, sourceFile, checker, allSourceFiles);
	            ts.Debug.assert(exportInfos.some(function (info) { return info.moduleSymbol === moduleSymbol; }));
	            // We sort the best codefixes first, so taking `first` is best for completions.
	            var moduleSpecifier = ts.first(getNewImportInfos(program, sourceFile, exportInfos, host, preferences)).moduleSpecifier;
	            var ctx = { host: host, program: program, checker: checker, compilerOptions: compilerOptions, sourceFile: sourceFile, formatContext: formatContext, symbolName: symbolName, getCanonicalFileName: getCanonicalFileName, symbolToken: symbolToken, preferences: preferences };
	            return { moduleSpecifier: moduleSpecifier, codeAction: ts.first(getCodeActionsForImport(exportInfos, ctx)) };
	        }
	        codefix.getImportCompletionAction = getImportCompletionAction;
	        function getAllReExportingModules(exportedSymbol, exportingModuleSymbol, symbolName, sourceFile, checker, allSourceFiles) {
	            var result = [];
	            forEachExternalModule(checker, allSourceFiles, function (moduleSymbol, moduleFile) {
	                // Don't import from a re-export when looking "up" like to `./index` or `../index`.
	                if (moduleFile && moduleSymbol !== exportingModuleSymbol && ts.startsWith(sourceFile.fileName, ts.getDirectoryPath(moduleFile.fileName))) {
	                    return;
	                }
	                for (var _i = 0, _a = checker.getExportsOfModule(moduleSymbol); _i < _a.length; _i++) {
	                    var exported = _a[_i];
	                    if ((exported.escapedName === "default" /* Default */ || exported.name === symbolName) && ts.skipAlias(exported, checker) === exportedSymbol) {
	                        var isDefaultExport = checker.tryGetMemberInModuleExports("default" /* Default */, moduleSymbol) === exported;
	                        result.push({ moduleSymbol: moduleSymbol, importKind: isDefaultExport ? 1 /* Default */ : 0 /* Named */ });
	                    }
	                }
	            });
	            return result;
	        }
	        function getCodeActionsForImport(exportInfos, context) {
	            var result = [];
	            getCodeActionsForImport_separateExistingAndNew(exportInfos, context, result, result);
	            return result;
	        }
	        function getCodeActionsForImport_separateExistingAndNew(exportInfos, context, useExisting, addNew) {
	            var existingImports = ts.flatMap(exportInfos, function (info) {
	                return getImportDeclarations(info, context.checker, context.sourceFile, context.cachedImportDeclarations);
	            });
	            // It is possible that multiple import statements with the same specifier exist in the file.
	            // e.g.
	            //
	            //     import * as ns from "foo";
	            //     import { member1, member2 } from "foo";
	            //
	            //     member3/**/ <-- cusor here
	            //
	            // in this case we should provie 2 actions:
	            //     1. change "member3" to "ns.member3"
	            //     2. add "member3" to the second import statement's import list
	            // and it is up to the user to decide which one fits best.
	            if (context.symbolToken && ts.isIdentifier(context.symbolToken)) {
	                for (var _i = 0, existingImports_1 = existingImports; _i < existingImports_1.length; _i++) {
	                    var declaration = existingImports_1[_i].declaration;
	                    var namespace_2 = getNamespaceImportName(declaration);
	                    if (namespace_2) {
	                        var moduleSymbol = context.checker.getAliasedSymbol(context.checker.getSymbolAtLocation(namespace_2));
	                        if (moduleSymbol && moduleSymbol.exports.has(ts.escapeLeadingUnderscores(context.symbolName))) {
	                            useExisting.push(getCodeActionForUseExistingNamespaceImport(namespace_2.text, context, context.symbolToken));
	                        }
	                    }
	                }
	            }
	            getCodeActionsForAddImport(exportInfos, context, existingImports, useExisting, addNew);
	        }
	        function getNamespaceImportName(declaration) {
	            if (declaration.kind === 243 /* ImportDeclaration */) {
	                var namedBindings = declaration.importClause && ts.isImportClause(declaration.importClause) && declaration.importClause.namedBindings;
	                return namedBindings && namedBindings.kind === 245 /* NamespaceImport */ ? namedBindings.name : undefined;
	            }
	            else {
	                return declaration.name;
	            }
	        }
	        // TODO(anhans): This doesn't seem important to cache... just use an iterator instead of creating a new array?
	        function getImportDeclarations(_a, checker, _b, cachedImportDeclarations) {
	            var moduleSymbol = _a.moduleSymbol, importKind = _a.importKind;
	            var imports = _b.imports;
	            if (cachedImportDeclarations === void 0) { cachedImportDeclarations = []; }
	            var moduleSymbolId = ts.getUniqueSymbolId(moduleSymbol, checker);
	            var cached = cachedImportDeclarations[moduleSymbolId];
	            if (!cached) {
	                cached = cachedImportDeclarations[moduleSymbolId] = ts.mapDefined(imports, function (moduleSpecifier) {
	                    var i = ts.importFromModuleSpecifier(moduleSpecifier);
	                    return (i.kind === 243 /* ImportDeclaration */ || i.kind === 242 /* ImportEqualsDeclaration */)
	                        && checker.getSymbolAtLocation(moduleSpecifier) === moduleSymbol ? { declaration: i, importKind: importKind } : undefined;
	                });
	            }
	            return cached;
	        }
	        function getCodeActionForNewImport(context, _a) {
	            var moduleSpecifier = _a.moduleSpecifier, importKind = _a.importKind;
	            var sourceFile = context.sourceFile, symbolName = context.symbolName, preferences = context.preferences;
	            var lastImportDeclaration = ts.findLast(sourceFile.statements, ts.isAnyImportSyntax);
	            var moduleSpecifierWithoutQuotes = ts.stripQuotes(moduleSpecifier);
	            var quotedModuleSpecifier = ts.makeStringLiteral(moduleSpecifierWithoutQuotes, ts.getQuotePreference(sourceFile, preferences));
	            var importDecl = importKind !== 3 /* Equals */
	                ? ts.createImportDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, createImportClauseOfKind(importKind, symbolName), quotedModuleSpecifier)
	                : ts.createImportEqualsDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, ts.createIdentifier(symbolName), ts.createExternalModuleReference(quotedModuleSpecifier));
	            var changes = ChangeTracker.with(context, function (changeTracker) {
	                if (lastImportDeclaration) {
	                    changeTracker.insertNodeAfter(sourceFile, lastImportDeclaration, importDecl);
	                }
	                else {
	                    changeTracker.insertNodeAtTopOfFile(sourceFile, importDecl, /*blankLineBetween*/ true);
	                }
	            });
	            // if this file doesn't have any import statements, insert an import statement and then insert a new line
	            // between the only import statement and user code. Otherwise just insert the statement because chances
	            // are there are already a new line seperating code and import statements.
	            return createCodeAction(ts.Diagnostics.Import_0_from_module_1, [symbolName, moduleSpecifierWithoutQuotes], changes);
	        }
	        function createImportClauseOfKind(kind, symbolName) {
	            var id = ts.createIdentifier(symbolName);
	            switch (kind) {
	                case 1 /* Default */:
	                    return ts.createImportClause(id, /*namedBindings*/ undefined);
	                case 2 /* Namespace */:
	                    return ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(id));
	                case 0 /* Named */:
	                    return ts.createImportClause(/*name*/ undefined, ts.createNamedImports([ts.createImportSpecifier(/*propertyName*/ undefined, id)]));
	                default:
	                    ts.Debug.assertNever(kind);
	            }
	        }
	        function getNewImportInfos(program, sourceFile, moduleSymbols, host, preferences) {
	            var choicesForEachExportingModule = ts.flatMap(moduleSymbols, function (_a) {
	                var moduleSymbol = _a.moduleSymbol, importKind = _a.importKind;
	                var modulePathsGroups = ts.moduleSpecifiers.getModuleSpecifiers(moduleSymbol, program.getCompilerOptions(), sourceFile, host, program.getSourceFiles(), preferences);
	                return modulePathsGroups.map(function (group) { return group.map(function (moduleSpecifier) { return ({ moduleSpecifier: moduleSpecifier, importKind: importKind }); }); });
	            });
	            // Sort to keep the shortest paths first, but keep [relativePath, importRelativeToBaseUrl] groups together
	            return ts.flatten(choicesForEachExportingModule.sort(function (a, b) { return ts.first(a).moduleSpecifier.length - ts.first(b).moduleSpecifier.length; }));
	        }
	        function getCodeActionsForAddImport(exportInfos, ctx, existingImports, useExisting, addNew) {
	            var fromExistingImport = ts.firstDefined(existingImports, function (_a) {
	                var declaration = _a.declaration, importKind = _a.importKind;
	                if (declaration.kind === 243 /* ImportDeclaration */ && declaration.importClause) {
	                    var changes = tryUpdateExistingImport(ctx, ts.isImportClause(declaration.importClause) && declaration.importClause || undefined, importKind);
	                    if (changes) {
	                        var moduleSpecifierWithoutQuotes = ts.stripQuotes(declaration.moduleSpecifier.getText());
	                        return createCodeAction(ts.Diagnostics.Add_0_to_existing_import_declaration_from_1, [ctx.symbolName, moduleSpecifierWithoutQuotes], changes);
	                    }
	                }
	            });
	            if (fromExistingImport) {
	                useExisting.push(fromExistingImport);
	                return;
	            }
	            var existingDeclaration = ts.firstDefined(existingImports, newImportInfoFromExistingSpecifier);
	            var newImportInfos = existingDeclaration
	                ? [existingDeclaration]
	                : getNewImportInfos(ctx.program, ctx.sourceFile, exportInfos, ctx.host, ctx.preferences);
	            for (var _i = 0, newImportInfos_1 = newImportInfos; _i < newImportInfos_1.length; _i++) {
	                var info = newImportInfos_1[_i];
	                addNew.push(getCodeActionForNewImport(ctx, info));
	            }
	        }
	        function newImportInfoFromExistingSpecifier(_a) {
	            var declaration = _a.declaration, importKind = _a.importKind;
	            var expression = declaration.kind === 243 /* ImportDeclaration */
	                ? declaration.moduleSpecifier
	                : declaration.moduleReference.kind === 253 /* ExternalModuleReference */
	                    ? declaration.moduleReference.expression
	                    : undefined;
	            return expression && ts.isStringLiteral(expression) ? { moduleSpecifier: expression.text, importKind: importKind } : undefined;
	        }
	        function tryUpdateExistingImport(context, importClause, importKind) {
	            var symbolName = context.symbolName, sourceFile = context.sourceFile;
	            var name = importClause.name;
	            var namedBindings = (importClause.kind !== 242 /* ImportEqualsDeclaration */ && importClause).namedBindings;
	            switch (importKind) {
	                case 1 /* Default */:
	                    return name ? undefined : ChangeTracker.with(context, function (t) {
	                        return t.replaceNode(sourceFile, importClause, ts.createImportClause(ts.createIdentifier(symbolName), namedBindings));
	                    });
	                case 0 /* Named */: {
	                    var newImportSpecifier_1 = ts.createImportSpecifier(/*propertyName*/ undefined, ts.createIdentifier(symbolName));
	                    if (namedBindings && namedBindings.kind === 246 /* NamedImports */ && namedBindings.elements.length !== 0) {
	                        // There are already named imports; add another.
	                        return ChangeTracker.with(context, function (t) { return t.insertNodeInListAfter(sourceFile, namedBindings.elements[namedBindings.elements.length - 1], newImportSpecifier_1); });
	                    }
	                    if (!namedBindings || namedBindings.kind === 246 /* NamedImports */ && namedBindings.elements.length === 0) {
	                        return ChangeTracker.with(context, function (t) {
	                            return t.replaceNode(sourceFile, importClause, ts.createImportClause(name, ts.createNamedImports([newImportSpecifier_1])));
	                        });
	                    }
	                    return undefined;
	                }
	                case 2 /* Namespace */:
	                    return namedBindings ? undefined : ChangeTracker.with(context, function (t) {
	                        return t.replaceNode(sourceFile, importClause, ts.createImportClause(name, ts.createNamespaceImport(ts.createIdentifier(symbolName))));
	                    });
	                case 3 /* Equals */:
	                    return undefined;
	                default:
	                    ts.Debug.assertNever(importKind);
	            }
	        }
	        function getCodeActionForUseExistingNamespaceImport(namespacePrefix, context, symbolToken) {
	            var symbolName = context.symbolName, sourceFile = context.sourceFile;
	            /**
	             * Cases:
	             *     import * as ns from "mod"
	             *     import default, * as ns from "mod"
	             *     import ns = require("mod")
	             *
	             * Because there is no import list, we alter the reference to include the
	             * namespace instead of altering the import declaration. For example, "foo" would
	             * become "ns.foo"
	             */
	            var changes = ChangeTracker.with(context, function (tracker) {
	                return tracker.replaceNode(sourceFile, symbolToken, ts.createPropertyAccess(ts.createIdentifier(namespacePrefix), symbolToken));
	            });
	            return createCodeAction(ts.Diagnostics.Change_0_to_1, [symbolName, namespacePrefix + "." + symbolName], changes);
	        }
	        function getImportCodeActions(context) {
	            return context.errorCode === ts.Diagnostics._0_refers_to_a_UMD_global_but_the_current_file_is_a_module_Consider_adding_an_import_instead.code
	                ? getActionsForUMDImport(context)
	                : getActionsForNonUMDImport(context);
	        }
	        function getActionsForUMDImport(context) {
	            var token = ts.getTokenAtPosition(context.sourceFile, context.span.start, /*includeJsDocComment*/ false);
	            var checker = context.program.getTypeChecker();
	            var umdSymbol;
	            if (ts.isIdentifier(token)) {
	                // try the identifier to see if it is the umd symbol
	                umdSymbol = checker.getSymbolAtLocation(token);
	            }
	            if (!ts.isUMDExportSymbol(umdSymbol)) {
	                // The error wasn't for the symbolAtLocation, it was for the JSX tag itself, which needs access to e.g. `React`.
	                var parent = token.parent;
	                var isNodeOpeningLikeElement = ts.isJsxOpeningLikeElement(parent);
	                if ((ts.isJsxOpeningLikeElement && parent.tagName === token) || parent.kind === 259 /* JsxOpeningFragment */) {
	                    umdSymbol = checker.resolveName(checker.getJsxNamespace(parent), isNodeOpeningLikeElement ? parent.tagName : parent, 67216319 /* Value */, /*excludeGlobals*/ false);
	                }
	            }
	            if (ts.isUMDExportSymbol(umdSymbol)) {
	                var symbol = checker.getAliasedSymbol(umdSymbol);
	                if (symbol) {
	                    return getCodeActionsForImport([{ moduleSymbol: symbol, importKind: getUmdImportKind(context.program.getCompilerOptions()) }], convertToImportCodeFixContext(context, token, umdSymbol.name));
	                }
	            }
	            return undefined;
	        }
	        function getUmdImportKind(compilerOptions) {
	            // Import a synthetic `default` if enabled.
	            if (ts.getAllowSyntheticDefaultImports(compilerOptions)) {
	                return 1 /* Default */;
	            }
	            // When a synthetic `default` is unavailable, use `import..require` if the module kind supports it.
	            var moduleKind = ts.getEmitModuleKind(compilerOptions);
	            switch (moduleKind) {
	                case ts.ModuleKind.AMD:
	                case ts.ModuleKind.CommonJS:
	                case ts.ModuleKind.UMD:
	                    return 3 /* Equals */;
	                case ts.ModuleKind.System:
	                case ts.ModuleKind.ES2015:
	                case ts.ModuleKind.ESNext:
	                case ts.ModuleKind.None:
	                    // Fall back to the `import * as ns` style import.
	                    return 2 /* Namespace */;
	                default:
	                    return ts.Debug.assertNever(moduleKind);
	            }
	        }
	        function getActionsForNonUMDImport(context) {
	            // This will always be an Identifier, since the diagnostics we fix only fail on identifiers.
	            var sourceFile = context.sourceFile, span = context.span, program = context.program, cancellationToken = context.cancellationToken;
	            var checker = program.getTypeChecker();
	            var symbolToken = ts.getTokenAtPosition(sourceFile, span.start, /*includeJsDocComment*/ false);
	            // If we're at `<Foo/>`, we must check if `Foo` is already in scope, and if so, get an import for `React` instead.
	            var symbolName = ts.isJsxOpeningLikeElement(symbolToken.parent)
	                && symbolToken.parent.tagName === symbolToken
	                && (!ts.isIdentifier(symbolToken) || ts.isIntrinsicJsxName(symbolToken.text) || checker.resolveName(symbolToken.text, symbolToken, 67108863 /* All */, /*excludeGlobals*/ false))
	                ? checker.getJsxNamespace()
	                : ts.isIdentifier(symbolToken) ? symbolToken.text : undefined;
	            if (!symbolName)
	                return undefined;
	            // "default" is a keyword and not a legal identifier for the import, so we don't expect it here
	            ts.Debug.assert(symbolName !== "default");
	            var currentTokenMeaning = ts.getMeaningFromLocation(symbolToken);
	            // For each original symbol, keep all re-exports of that symbol together so we can call `getCodeActionsForImport` on the whole group at once.
	            // Maps symbol id to info for modules providing that symbol (original export + re-exports).
	            var originalSymbolToExportInfos = ts.createMultiMap();
	            function addSymbol(moduleSymbol, exportedSymbol, importKind) {
	                originalSymbolToExportInfos.add(ts.getUniqueSymbolId(exportedSymbol, checker).toString(), { moduleSymbol: moduleSymbol, importKind: importKind });
	            }
	            forEachExternalModuleToImportFrom(checker, sourceFile, program.getSourceFiles(), function (moduleSymbol) {
	                cancellationToken.throwIfCancellationRequested();
	                // check the default export
	                var defaultExport = checker.tryGetMemberInModuleExports("default" /* Default */, moduleSymbol);
	                if (defaultExport) {
	                    var localSymbol = ts.getLocalSymbolForExportDefault(defaultExport);
	                    if ((localSymbol && localSymbol.escapedName === symbolName ||
	                        getEscapedNameForExportDefault(defaultExport) === symbolName ||
	                        moduleSymbolToValidIdentifier(moduleSymbol, program.getCompilerOptions().target) === symbolName) && checkSymbolHasMeaning(localSymbol || defaultExport, currentTokenMeaning)) {
	                        addSymbol(moduleSymbol, localSymbol || defaultExport, 1 /* Default */);
	                    }
	                }
	                // check exports with the same name
	                var exportSymbolWithIdenticalName = checker.tryGetMemberInModuleExportsAndProperties(symbolName, moduleSymbol);
	                if (exportSymbolWithIdenticalName && checkSymbolHasMeaning(exportSymbolWithIdenticalName, currentTokenMeaning)) {
	                    addSymbol(moduleSymbol, exportSymbolWithIdenticalName, 0 /* Named */);
	                }
	                function getEscapedNameForExportDefault(symbol) {
	                    return ts.firstDefined(symbol.declarations, function (declaration) {
	                        if (ts.isExportAssignment(declaration)) {
	                            if (ts.isIdentifier(declaration.expression)) {
	                                return declaration.expression.escapedText;
	                            }
	                        }
	                        else if (ts.isExportSpecifier(declaration)) {
	                            ts.Debug.assert(declaration.name.escapedText === "default" /* Default */);
	                            if (declaration.propertyName) {
	                                return declaration.propertyName.escapedText;
	                            }
	                        }
	                    });
	                }
	            });
	            var addToExistingDeclaration = [];
	            var addNewDeclaration = [];
	            originalSymbolToExportInfos.forEach(function (exportInfos) {
	                getCodeActionsForImport_separateExistingAndNew(exportInfos, convertToImportCodeFixContext(context, symbolToken, symbolName), addToExistingDeclaration, addNewDeclaration);
	            });
	            return addToExistingDeclaration.concat(addNewDeclaration);
	        }
	        function checkSymbolHasMeaning(_a, meaning) {
	            var declarations = _a.declarations;
	            return ts.some(declarations, function (decl) { return !!(ts.getMeaningFromDeclaration(decl) & meaning); });
	        }
	        function forEachExternalModuleToImportFrom(checker, from, allSourceFiles, cb) {
	            forEachExternalModule(checker, allSourceFiles, function (module, sourceFile) {
	                if (sourceFile === undefined || sourceFile !== from && isImportablePath(from.fileName, sourceFile.fileName)) {
	                    cb(module);
	                }
	            });
	        }
	        codefix.forEachExternalModuleToImportFrom = forEachExternalModuleToImportFrom;
	        function forEachExternalModule(checker, allSourceFiles, cb) {
	            for (var _i = 0, _a = checker.getAmbientModules(); _i < _a.length; _i++) {
	                var ambient = _a[_i];
	                cb(ambient, /*sourceFile*/ undefined);
	            }
	            for (var _b = 0, allSourceFiles_1 = allSourceFiles; _b < allSourceFiles_1.length; _b++) {
	                var sourceFile = allSourceFiles_1[_b];
	                if (ts.isExternalOrCommonJsModule(sourceFile)) {
	                    cb(checker.getMergedSymbol(sourceFile.symbol), sourceFile);
	                }
	            }
	        }
	        /**
	         * Don't include something from a `node_modules` that isn't actually reachable by a global import.
	         * A relative import to node_modules is usually a bad idea.
	         */
	        function isImportablePath(fromPath, toPath) {
	            // If it's in a `node_modules` but is not reachable from here via a global import, don't bother.
	            var toNodeModules = ts.forEachAncestorDirectory(toPath, function (ancestor) { return ts.getBaseFileName(ancestor) === "node_modules" ? ancestor : undefined; });
	            return toNodeModules === undefined || ts.startsWith(fromPath, ts.getDirectoryPath(toNodeModules));
	        }
	        function moduleSymbolToValidIdentifier(moduleSymbol, target) {
	            return moduleSpecifierToValidIdentifier(ts.removeFileExtension(ts.stripQuotes(moduleSymbol.name)), target);
	        }
	        codefix.moduleSymbolToValidIdentifier = moduleSymbolToValidIdentifier;
	        function moduleSpecifierToValidIdentifier(moduleSpecifier, target) {
	            var baseName = ts.getBaseFileName(ts.removeSuffix(moduleSpecifier, "/index"));
	            var res = "";
	            var lastCharWasValid = true;
	            var firstCharCode = baseName.charCodeAt(0);
	            if (ts.isIdentifierStart(firstCharCode, target)) {
	                res += String.fromCharCode(firstCharCode);
	            }
	            else {
	                lastCharWasValid = false;
	            }
	            for (var i = 1; i < baseName.length; i++) {
	                var ch = baseName.charCodeAt(i);
	                var isValid = ts.isIdentifierPart(ch, target);
	                if (isValid) {
	                    var char = String.fromCharCode(ch);
	                    if (!lastCharWasValid) {
	                        char = char.toUpperCase();
	                    }
	                    res += char;
	                }
	                lastCharWasValid = isValid;
	            }
	            // Need `|| "_"` to ensure result isn't empty.
	            return !ts.isStringANonContextualKeyword(res) ? res || "_" : "_" + res;
	        }
	        codefix.moduleSpecifierToValidIdentifier = moduleSpecifierToValidIdentifier;
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixSpelling";
	        var errorCodes = [
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
	            ts.Diagnostics.Cannot_find_name_0_Did_you_mean_1.code,
	            ts.Diagnostics.Module_0_has_no_exported_member_1_Did_you_mean_2.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var info = getInfo(sourceFile, context.span.start, context);
	                if (!info)
	                    return undefined;
	                var node = info.node, suggestion = info.suggestion;
	                var target = context.host.getCompilationSettings().target;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, node, suggestion, target); });
	                return [codefix.createCodeFixAction("spelling", changes, [ts.Diagnostics.Change_spelling_to_0, suggestion], fixId, ts.Diagnostics.Fix_all_detected_spelling_errors)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var info = getInfo(diag.file, diag.start, context);
	                var target = context.host.getCompilationSettings().target;
	                if (info)
	                    doChange(changes, context.sourceFile, info.node, info.suggestion, target);
	            }); },
	        });
	        function getInfo(sourceFile, pos, context) {
	            // This is the identifier of the misspelled word. eg:
	            // this.speling = 1;
	            //      ^^^^^^^
	            var node = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false); // TODO: GH#15852
	            var checker = context.program.getTypeChecker();
	            var suggestion;
	            if (ts.isPropertyAccessExpression(node.parent) && node.parent.name === node) {
	                ts.Debug.assert(node.kind === 71 /* Identifier */);
	                var containingType = checker.getTypeAtLocation(node.parent.expression);
	                suggestion = checker.getSuggestionForNonexistentProperty(node, containingType);
	            }
	            else if (ts.isImportSpecifier(node.parent) && node.parent.name === node) {
	                ts.Debug.assert(node.kind === 71 /* Identifier */);
	                var importDeclaration = ts.findAncestor(node, ts.isImportDeclaration);
	                var resolvedSourceFile = getResolvedSourceFileFromImportDeclaration(sourceFile, context, importDeclaration);
	                if (resolvedSourceFile && resolvedSourceFile.symbol) {
	                    suggestion = checker.getSuggestionForNonexistentModule(node, resolvedSourceFile.symbol);
	                }
	            }
	            else {
	                var meaning = ts.getMeaningFromLocation(node);
	                var name = ts.getTextOfNode(node);
	                ts.Debug.assert(name !== undefined, "name should be defined");
	                suggestion = checker.getSuggestionForNonexistentSymbol(node, name, convertSemanticMeaningToSymbolFlags(meaning));
	            }
	            return suggestion === undefined ? undefined : { node: node, suggestion: suggestion };
	        }
	        function doChange(changes, sourceFile, node, suggestion, target) {
	            if (!ts.isIdentifierText(suggestion, target) && ts.isPropertyAccessExpression(node.parent)) {
	                changes.replaceNode(sourceFile, node.parent, ts.createElementAccess(node.parent.expression, ts.createLiteral(suggestion)));
	            }
	            else {
	                changes.replaceNode(sourceFile, node, ts.createIdentifier(suggestion));
	            }
	        }
	        function convertSemanticMeaningToSymbolFlags(meaning) {
	            var flags = 0;
	            if (meaning & 4 /* Namespace */) {
	                flags |= 1920 /* Namespace */;
	            }
	            if (meaning & 2 /* Type */) {
	                flags |= 67901928 /* Type */;
	            }
	            if (meaning & 1 /* Value */) {
	                flags |= 67216319 /* Value */;
	            }
	            return flags;
	        }
	        function getResolvedSourceFileFromImportDeclaration(sourceFile, context, importDeclaration) {
	            if (!importDeclaration || !ts.isStringLiteralLike(importDeclaration.moduleSpecifier))
	                return undefined;
	            var resolvedModule = ts.getResolvedModule(sourceFile, importDeclaration.moduleSpecifier.text);
	            if (!resolvedModule)
	                return undefined;
	            return context.program.getSourceFile(resolvedModule.resolvedFileName);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixName = "addMissingMember";
	        var errorCodes = [
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1.code,
	            ts.Diagnostics.Property_0_does_not_exist_on_type_1_Did_you_mean_2.code,
	        ];
	        var fixId = "addMissingMember";
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var info = getInfo(context.sourceFile, context.span.start, context.program.getTypeChecker());
	                if (!info)
	                    return undefined;
	                var classDeclaration = info.classDeclaration, classDeclarationSourceFile = info.classDeclarationSourceFile, inJs = info.inJs, makeStatic = info.makeStatic, token = info.token, call = info.call;
	                var methodCodeAction = call && getActionForMethodDeclaration(context, classDeclarationSourceFile, classDeclaration, token, call, makeStatic, inJs, context.preferences);
	                var addMember = inJs ?
	                    ts.singleElementArray(getActionsForAddMissingMemberInJavaScriptFile(context, classDeclarationSourceFile, classDeclaration, token.text, makeStatic)) :
	                    getActionsForAddMissingMemberInTypeScriptFile(context, classDeclarationSourceFile, classDeclaration, token, makeStatic);
	                return ts.concatenate(ts.singleElementArray(methodCodeAction), addMember);
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenNames = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var program = context.program, preferences = context.preferences;
	                    var info = getInfo(diag.file, diag.start, program.getTypeChecker());
	                    if (!info)
	                        return;
	                    var classDeclaration = info.classDeclaration, classDeclarationSourceFile = info.classDeclarationSourceFile, inJs = info.inJs, makeStatic = info.makeStatic, token = info.token, call = info.call;
	                    if (!ts.addToSeen(seenNames, token.text)) {
	                        return;
	                    }
	                    // Always prefer to add a method declaration if possible.
	                    if (call) {
	                        addMethodDeclaration(changes, classDeclarationSourceFile, classDeclaration, token, call, makeStatic, inJs, preferences);
	                    }
	                    else {
	                        if (inJs) {
	                            addMissingMemberInJs(changes, classDeclarationSourceFile, classDeclaration, token.text, makeStatic);
	                        }
	                        else {
	                            var typeNode = getTypeNode(program.getTypeChecker(), classDeclaration, token);
	                            addPropertyDeclaration(changes, classDeclarationSourceFile, classDeclaration, token.text, typeNode, makeStatic);
	                        }
	                    }
	                });
	            },
	        });
	        function getInfo(tokenSourceFile, tokenPos, checker) {
	            // The identifier of the missing property. eg:
	            // this.missing = 1;
	            //      ^^^^^^^
	            var token = ts.getTokenAtPosition(tokenSourceFile, tokenPos, /*includeJsDocComment*/ false);
	            if (!ts.isIdentifier(token)) {
	                return undefined;
	            }
	            var parent = token.parent;
	            if (!ts.isPropertyAccessExpression(parent))
	                return undefined;
	            var leftExpressionType = ts.skipConstraint(checker.getTypeAtLocation(parent.expression));
	            var symbol = leftExpressionType.symbol;
	            var classDeclaration = symbol && symbol.declarations && ts.find(symbol.declarations, ts.isClassLike);
	            if (!classDeclaration)
	                return undefined;
	            var makeStatic = leftExpressionType.target !== checker.getDeclaredTypeOfSymbol(symbol);
	            var classDeclarationSourceFile = classDeclaration.getSourceFile();
	            var inJs = ts.isSourceFileJavaScript(classDeclarationSourceFile);
	            var call = ts.tryCast(parent.parent, ts.isCallExpression);
	            return { token: token, classDeclaration: classDeclaration, makeStatic: makeStatic, classDeclarationSourceFile: classDeclarationSourceFile, inJs: inJs, call: call };
	        }
	        function getActionsForAddMissingMemberInJavaScriptFile(context, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMissingMemberInJs(t, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic); });
	            return changes.length === 0 ? undefined
	                : codefix.createCodeFixAction(fixName, changes, [makeStatic ? ts.Diagnostics.Initialize_static_property_0 : ts.Diagnostics.Initialize_property_0_in_the_constructor, tokenName], fixId, ts.Diagnostics.Add_all_missing_members);
	        }
	        function addMissingMemberInJs(changeTracker, classDeclarationSourceFile, classDeclaration, tokenName, makeStatic) {
	            if (makeStatic) {
	                if (classDeclaration.kind === 204 /* ClassExpression */) {
	                    return;
	                }
	                var className = classDeclaration.name.getText();
	                var staticInitialization = initializePropertyToUndefined(ts.createIdentifier(className), tokenName);
	                changeTracker.insertNodeAfter(classDeclarationSourceFile, classDeclaration, staticInitialization);
	            }
	            else {
	                var classConstructor = ts.getFirstConstructorWithBody(classDeclaration);
	                if (!classConstructor) {
	                    return;
	                }
	                var propertyInitialization = initializePropertyToUndefined(ts.createThis(), tokenName);
	                changeTracker.insertNodeAtConstructorEnd(classDeclarationSourceFile, classConstructor, propertyInitialization);
	            }
	        }
	        function initializePropertyToUndefined(obj, propertyName) {
	            return ts.createStatement(ts.createAssignment(ts.createPropertyAccess(obj, propertyName), ts.createIdentifier("undefined")));
	        }
	        function getActionsForAddMissingMemberInTypeScriptFile(context, classDeclarationSourceFile, classDeclaration, token, makeStatic) {
	            var typeNode = getTypeNode(context.program.getTypeChecker(), classDeclaration, token);
	            var addProp = createAddPropertyDeclarationAction(context, classDeclarationSourceFile, classDeclaration, makeStatic, token.text, typeNode);
	            return makeStatic ? [addProp] : [addProp, createAddIndexSignatureAction(context, classDeclarationSourceFile, classDeclaration, token.text, typeNode)];
	        }
	        function getTypeNode(checker, classDeclaration, token) {
	            var typeNode;
	            if (token.parent.parent.kind === 199 /* BinaryExpression */) {
	                var binaryExpression = token.parent.parent;
	                var otherExpression = token.parent === binaryExpression.left ? binaryExpression.right : binaryExpression.left;
	                var widenedType = checker.getWidenedType(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(otherExpression)));
	                typeNode = checker.typeToTypeNode(widenedType, classDeclaration);
	            }
	            return typeNode || ts.createKeywordTypeNode(119 /* AnyKeyword */);
	        }
	        function createAddPropertyDeclarationAction(context, classDeclarationSourceFile, classDeclaration, makeStatic, tokenName, typeNode) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addPropertyDeclaration(t, classDeclarationSourceFile, classDeclaration, tokenName, typeNode, makeStatic); });
	            return codefix.createCodeFixAction(fixName, changes, [makeStatic ? ts.Diagnostics.Declare_static_property_0 : ts.Diagnostics.Declare_property_0, tokenName], fixId, ts.Diagnostics.Add_all_missing_members);
	        }
	        function addPropertyDeclaration(changeTracker, classDeclarationSourceFile, classDeclaration, tokenName, typeNode, makeStatic) {
	            var property = ts.createProperty(
	            /*decorators*/ undefined, 
	            /*modifiers*/ makeStatic ? [ts.createToken(115 /* StaticKeyword */)] : undefined, tokenName, 
	            /*questionToken*/ undefined, typeNode, 
	            /*initializer*/ undefined);
	            var lastProp = getNodeToInsertPropertyAfter(classDeclaration);
	            if (lastProp) {
	                changeTracker.insertNodeAfter(classDeclarationSourceFile, lastProp, property);
	            }
	            else {
	                changeTracker.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, property);
	            }
	        }
	        // Gets the last of the first run of PropertyDeclarations, or undefined if the class does not start with a PropertyDeclaration.
	        function getNodeToInsertPropertyAfter(cls) {
	            var res;
	            for (var _i = 0, _a = cls.members; _i < _a.length; _i++) {
	                var member = _a[_i];
	                if (!ts.isPropertyDeclaration(member))
	                    break;
	                res = member;
	            }
	            return res;
	        }
	        function createAddIndexSignatureAction(context, classDeclarationSourceFile, classDeclaration, tokenName, typeNode) {
	            // Index signatures cannot have the static modifier.
	            var stringTypeNode = ts.createKeywordTypeNode(137 /* StringKeyword */);
	            var indexingParameter = ts.createParameter(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, 
	            /*dotDotDotToken*/ undefined, "x", 
	            /*questionToken*/ undefined, stringTypeNode, 
	            /*initializer*/ undefined);
	            var indexSignature = ts.createIndexSignature(
	            /*decorators*/ undefined, 
	            /*modifiers*/ undefined, [indexingParameter], typeNode);
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, indexSignature); });
	            // No fixId here because code-fix-all currently only works on adding individual named properties.
	            return codefix.createCodeFixActionNoFixId(fixName, changes, [ts.Diagnostics.Add_index_signature_for_property_0, tokenName]);
	        }
	        function getActionForMethodDeclaration(context, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs, preferences) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addMethodDeclaration(t, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs, preferences); });
	            return codefix.createCodeFixAction(fixName, changes, [makeStatic ? ts.Diagnostics.Declare_static_method_0 : ts.Diagnostics.Declare_method_0, token.text], fixId, ts.Diagnostics.Add_all_missing_members);
	        }
	        function addMethodDeclaration(changeTracker, classDeclarationSourceFile, classDeclaration, token, callExpression, makeStatic, inJs, preferences) {
	            var methodDeclaration = codefix.createMethodFromCallExpression(callExpression, token.text, inJs, makeStatic, preferences);
	            changeTracker.insertNodeAtClassStart(classDeclarationSourceFile, classDeclaration, methodDeclaration);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixCannotFindModule";
	        var errorCodeCannotFindModule = ts.Diagnostics.Cannot_find_module_0.code;
	        var errorCodes = [
	            errorCodeCannotFindModule,
	            ts.Diagnostics.Could_not_find_a_declaration_file_for_module_0_1_implicitly_has_an_any_type.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var host = context.host, sourceFile = context.sourceFile, start = context.span.start;
	                var packageName = getTypesPackageNameToInstall(host, sourceFile, start, context.errorCode);
	                return packageName === undefined ? []
	                    : [codefix.createCodeFixAction(fixId, /*changes*/ [], [ts.Diagnostics.Install_0, packageName], fixId, ts.Diagnostics.Install_all_missing_types_packages, getCommand(sourceFile.fileName, packageName))];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (_, diag, commands) {
	                var pkg = getTypesPackageNameToInstall(context.host, diag.file, diag.start, diag.code);
	                if (pkg) {
	                    commands.push(getCommand(diag.file.fileName, pkg));
	                }
	            }); },
	        });
	        function getCommand(fileName, packageName) {
	            return { type: "install package", file: fileName, packageName: packageName };
	        }
	        function getTypesPackageNameToInstall(host, sourceFile, pos, diagCode) {
	            var moduleName = ts.cast(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false), ts.isStringLiteral).text;
	            var packageName = ts.getPackageName(moduleName).packageName;
	            return diagCode === errorCodeCannotFindModule
	                ? (ts.JsTyping.nodeCoreModules.has(packageName) ? "@types/node" : undefined)
	                : (host.isKnownTypesPackageName(packageName) ? ts.getTypesPackageName(packageName) : undefined);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var errorCodes = [
	            ts.Diagnostics.Non_abstract_class_0_does_not_implement_inherited_abstract_member_1_from_class_2.code,
	            ts.Diagnostics.Non_abstract_class_expression_does_not_implement_inherited_abstract_member_0_from_class_1.code,
	        ];
	        var fixId = "fixClassDoesntImplementInheritedAbstractMember";
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var program = context.program, sourceFile = context.sourceFile, span = context.span;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) {
	                    return addMissingMembers(getClass(sourceFile, span.start), sourceFile, program.getTypeChecker(), t, context.preferences);
	                });
	                return changes.length === 0 ? undefined : [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Implement_inherited_abstract_class, fixId, ts.Diagnostics.Implement_all_inherited_abstract_classes)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenClassDeclarations = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var classDeclaration = getClass(diag.file, diag.start);
	                    if (ts.addToSeen(seenClassDeclarations, ts.getNodeId(classDeclaration))) {
	                        addMissingMembers(classDeclaration, context.sourceFile, context.program.getTypeChecker(), changes, context.preferences);
	                    }
	                });
	            },
	        });
	        function getClass(sourceFile, pos) {
	            // Token is the identifier in the case of a class declaration
	            // or the class keyword token in the case of a class expression.
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            return ts.cast(token.parent, ts.isClassLike);
	        }
	        function addMissingMembers(classDeclaration, sourceFile, checker, changeTracker, preferences) {
	            var extendsNode = ts.getClassExtendsHeritageClauseElement(classDeclaration);
	            var instantiatedExtendsType = checker.getTypeAtLocation(extendsNode);
	            // Note that this is ultimately derived from a map indexed by symbol names,
	            // so duplicates cannot occur.
	            var abstractAndNonPrivateExtendsSymbols = checker.getPropertiesOfType(instantiatedExtendsType).filter(symbolPointsToNonPrivateAndAbstractMember);
	            codefix.createMissingMemberNodes(classDeclaration, abstractAndNonPrivateExtendsSymbols, checker, preferences, function (member) { return changeTracker.insertNodeAtClassStart(sourceFile, classDeclaration, member); });
	        }
	        function symbolPointsToNonPrivateAndAbstractMember(symbol) {
	            // See `codeFixClassExtendAbstractProtectedProperty.ts` in https://github.com/Microsoft/TypeScript/pull/11547/files
	            // (now named `codeFixClassExtendAbstractPrivateProperty.ts`)
	            var flags = ts.getModifierFlags(ts.first(symbol.getDeclarations()));
	            return !(flags & 8 /* Private */) && !!(flags & 128 /* Abstract */);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "classSuperMustPrecedeThisAccess";
	        var errorCodes = [ts.Diagnostics.super_must_be_called_before_accessing_this_in_the_constructor_of_a_derived_class.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var nodes = getNodes(sourceFile, span.start);
	                if (!nodes)
	                    return undefined;
	                var constructor = nodes.constructor, superCall = nodes.superCall;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, constructor, superCall); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Make_super_call_the_first_statement_in_the_constructor, fixId, ts.Diagnostics.Make_all_super_calls_the_first_statement_in_their_constructor)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var seenClasses = ts.createMap(); // Ensure we only do this once per class.
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var nodes = getNodes(diag.file, diag.start);
	                    if (!nodes)
	                        return;
	                    var constructor = nodes.constructor, superCall = nodes.superCall;
	                    if (ts.addToSeen(seenClasses, ts.getNodeId(constructor.parent))) {
	                        doChange(changes, sourceFile, constructor, superCall);
	                    }
	                });
	            },
	        });
	        function doChange(changes, sourceFile, constructor, superCall) {
	            changes.insertNodeAtConstructorStart(sourceFile, constructor, superCall);
	            changes.deleteNode(sourceFile, superCall);
	        }
	        function getNodes(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            if (token.kind !== 99 /* ThisKeyword */)
	                return undefined;
	            var constructor = ts.getContainingFunction(token);
	            var superCall = findSuperCall(constructor.body);
	            // figure out if the `this` access is actually inside the supercall
	            // i.e. super(this.a), since in that case we won't suggest a fix
	            return superCall && !superCall.expression.arguments.some(function (arg) { return ts.isPropertyAccessExpression(arg) && arg.expression === token; }) ? { constructor: constructor, superCall: superCall } : undefined;
	        }
	        function findSuperCall(n) {
	            return ts.isExpressionStatement(n) && ts.isSuperCall(n.expression)
	                ? n
	                : ts.isFunctionLike(n)
	                    ? undefined
	                    : ts.forEachChild(n, findSuperCall);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "constructorForDerivedNeedSuperCall";
	        var errorCodes = [ts.Diagnostics.Constructors_for_derived_classes_must_contain_a_super_call.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var ctr = getNode(sourceFile, span.start);
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, ctr); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Add_missing_super_call, fixId, ts.Diagnostics.Add_all_missing_super_calls)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                return doChange(changes, context.sourceFile, getNode(diag.file, diag.start));
	            }); },
	        });
	        function getNode(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            ts.Debug.assert(token.kind === 123 /* ConstructorKeyword */);
	            return token.parent;
	        }
	        function doChange(changes, sourceFile, ctr) {
	            var superCall = ts.createStatement(ts.createCall(ts.createSuper(), /*typeArguments*/ undefined, /*argumentsArray*/ ts.emptyArray));
	            changes.insertNodeAtConstructorStart(sourceFile, ctr, superCall);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "extendsInterfaceBecomesImplements";
	        var errorCodes = [ts.Diagnostics.Cannot_extend_an_interface_0_Did_you_mean_implements.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var nodes = getNodes(sourceFile, context.span.start);
	                if (!nodes)
	                    return undefined;
	                var extendsToken = nodes.extendsToken, heritageClauses = nodes.heritageClauses;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChanges(t, sourceFile, extendsToken, heritageClauses); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Change_extends_to_implements, fixId, ts.Diagnostics.Change_all_extended_interfaces_to_implements)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var nodes = getNodes(diag.file, diag.start);
	                if (nodes)
	                    doChanges(changes, diag.file, nodes.extendsToken, nodes.heritageClauses);
	            }); },
	        });
	        function getNodes(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            var heritageClauses = ts.getContainingClass(token).heritageClauses;
	            var extendsToken = heritageClauses[0].getFirstToken();
	            return extendsToken.kind === 85 /* ExtendsKeyword */ ? { extendsToken: extendsToken, heritageClauses: heritageClauses } : undefined;
	        }
	        function doChanges(changes, sourceFile, extendsToken, heritageClauses) {
	            changes.replaceNode(sourceFile, extendsToken, ts.createToken(108 /* ImplementsKeyword */));
	            // If there is already an implements clause, replace the implements keyword with a comma.
	            if (heritageClauses.length === 2 &&
	                heritageClauses[0].token === 85 /* ExtendsKeyword */ &&
	                heritageClauses[1].token === 108 /* ImplementsKeyword */) {
	                var implementsToken = heritageClauses[1].getFirstToken();
	                var implementsFullStart = implementsToken.getFullStart();
	                changes.replaceRange(sourceFile, { pos: implementsFullStart, end: implementsFullStart }, ts.createToken(26 /* CommaToken */));
	                // Rough heuristic: delete trailing whitespace after keyword so that it's not excessive.
	                // (Trailing because leading might be indentation, which is more sensitive.)
	                var text = sourceFile.text;
	                var end = implementsToken.end;
	                while (end < text.length && ts.isWhiteSpaceSingleLine(text.charCodeAt(end))) {
	                    end++;
	                }
	                changes.deleteRange(sourceFile, { pos: implementsToken.getStart(), end: end });
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "forgottenThisPropertyAccess";
	        var didYouMeanStaticMemberCode = ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_static_member_1_0.code;
	        var errorCodes = [
	            ts.Diagnostics.Cannot_find_name_0_Did_you_mean_the_instance_member_this_0.code,
	            didYouMeanStaticMemberCode,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var info = getInfo(sourceFile, context.span.start, context.errorCode);
	                if (!info) {
	                    return undefined;
	                }
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, info); });
	                return [codefix.createCodeFixAction(fixId, changes, [ts.Diagnostics.Add_0_to_unresolved_variable, info.className || "this"], fixId, ts.Diagnostics.Add_qualifier_to_all_unresolved_variables_matching_a_member_name)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                doChange(changes, context.sourceFile, getInfo(diag.file, diag.start, diag.code));
	            }); },
	        });
	        function getInfo(sourceFile, pos, diagCode) {
	            var node = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            if (!ts.isIdentifier(node))
	                return undefined;
	            return { node: node, className: diagCode === didYouMeanStaticMemberCode ? ts.getContainingClass(node).name.text : undefined };
	        }
	        function doChange(changes, sourceFile, _a) {
	            var node = _a.node, className = _a.className;
	            // TODO (https://github.com/Microsoft/TypeScript/issues/21246): use shared helper
	            ts.suppressLeadingAndTrailingTrivia(node);
	            changes.replaceNode(sourceFile, node, ts.createPropertyAccess(className ? ts.createIdentifier(className) : ts.createThis(), node));
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixName = "unusedIdentifier";
	        var fixIdPrefix = "unusedIdentifier_prefix";
	        var fixIdDelete = "unusedIdentifier_delete";
	        var errorCodes = [
	            ts.Diagnostics._0_is_declared_but_its_value_is_never_read.code,
	            ts.Diagnostics._0_is_declared_but_never_used.code,
	            ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code,
	            ts.Diagnostics.All_imports_in_import_declaration_are_unused.code,
	            ts.Diagnostics.All_destructured_elements_are_unused.code,
	            ts.Diagnostics.All_variables_are_unused.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var errorCode = context.errorCode, sourceFile = context.sourceFile;
	                var startToken = ts.getTokenAtPosition(sourceFile, context.span.start, /*includeJsDocComment*/ false);
	                var importDecl = tryGetFullImport(startToken);
	                if (importDecl) {
	                    var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.deleteNode(sourceFile, importDecl); });
	                    return [codefix.createCodeFixAction(fixName, changes, [ts.Diagnostics.Remove_import_from_0, ts.showModuleSpecifier(importDecl)], fixIdDelete, ts.Diagnostics.Delete_all_unused_declarations)];
	                }
	                var delDestructure = ts.textChanges.ChangeTracker.with(context, function (t) { return tryDeleteFullDestructure(t, sourceFile, startToken, /*deleted*/ undefined); });
	                if (delDestructure.length) {
	                    return [codefix.createCodeFixAction(fixName, delDestructure, ts.Diagnostics.Remove_destructuring, fixIdDelete, ts.Diagnostics.Delete_all_unused_declarations)];
	                }
	                var delVar = ts.textChanges.ChangeTracker.with(context, function (t) { return tryDeleteFullVariableStatement(t, sourceFile, startToken, /*deleted*/ undefined); });
	                if (delVar.length) {
	                    return [codefix.createCodeFixAction(fixName, delDestructure, ts.Diagnostics.Remove_variable_statement, fixIdDelete, ts.Diagnostics.Delete_all_unused_declarations)];
	                }
	                var token = getToken(sourceFile, ts.textSpanEnd(context.span));
	                var result = [];
	                var deletion = ts.textChanges.ChangeTracker.with(context, function (t) { return tryDeleteDeclaration(t, sourceFile, token, /*deleted*/ undefined); });
	                if (deletion.length) {
	                    result.push(codefix.createCodeFixAction(fixName, deletion, [ts.Diagnostics.Remove_declaration_for_Colon_0, token.getText(sourceFile)], fixIdDelete, ts.Diagnostics.Delete_all_unused_declarations));
	                }
	                var prefix = ts.textChanges.ChangeTracker.with(context, function (t) { return tryPrefixDeclaration(t, errorCode, sourceFile, token); });
	                if (prefix.length) {
	                    result.push(codefix.createCodeFixAction(fixName, prefix, [ts.Diagnostics.Prefix_0_with_an_underscore, token.getText(sourceFile)], fixIdPrefix, ts.Diagnostics.Prefix_all_unused_declarations_with_where_possible));
	                }
	                return result;
	            },
	            fixIds: [fixIdPrefix, fixIdDelete],
	            getAllCodeActions: function (context) {
	                // Track a set of deleted nodes that may be ancestors of other marked for deletion -- only delete the ancestors.
	                var deleted = new NodeSet();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var sourceFile = context.sourceFile;
	                    var startToken = ts.getTokenAtPosition(sourceFile, diag.start, /*includeJsDocComment*/ false);
	                    var token = ts.findPrecedingToken(ts.textSpanEnd(diag), diag.file);
	                    switch (context.fixId) {
	                        case fixIdPrefix:
	                            if (ts.isIdentifier(token) && canPrefix(token)) {
	                                tryPrefixDeclaration(changes, diag.code, sourceFile, token);
	                            }
	                            break;
	                        case fixIdDelete:
	                            // Ignore if this range was already deleted.
	                            if (deleted.some(function (d) { return ts.rangeContainsPosition(d, diag.start); }))
	                                break;
	                            var importDecl = tryGetFullImport(startToken);
	                            if (importDecl) {
	                                changes.deleteNode(sourceFile, importDecl);
	                            }
	                            else if (!tryDeleteFullDestructure(changes, sourceFile, startToken, deleted) && !tryDeleteFullVariableStatement(changes, sourceFile, startToken, deleted)) {
	                                tryDeleteDeclaration(changes, sourceFile, token, deleted);
	                            }
	                            break;
	                        default:
	                            ts.Debug.fail(JSON.stringify(context.fixId));
	                    }
	                });
	            },
	        });
	        // Sometimes the diagnostic span is an entire ImportDeclaration, so we should remove the whole thing.
	        function tryGetFullImport(startToken) {
	            return startToken.kind === 91 /* ImportKeyword */ ? ts.tryCast(startToken.parent, ts.isImportDeclaration) : undefined;
	        }
	        function tryDeleteFullDestructure(changes, sourceFile, startToken, deletedAncestors) {
	            if (startToken.kind !== 17 /* OpenBraceToken */ || !ts.isObjectBindingPattern(startToken.parent))
	                return false;
	            var decl = ts.cast(startToken.parent, ts.isObjectBindingPattern).parent;
	            switch (decl.kind) {
	                case 231 /* VariableDeclaration */:
	                    tryDeleteVariableDeclaration(changes, sourceFile, decl, deletedAncestors);
	                    break;
	                case 148 /* Parameter */:
	                    if (deletedAncestors)
	                        deletedAncestors.add(decl);
	                    changes.deleteNodeInList(sourceFile, decl);
	                    break;
	                case 181 /* BindingElement */:
	                    if (deletedAncestors)
	                        deletedAncestors.add(decl);
	                    changes.deleteNode(sourceFile, decl);
	                    break;
	                default:
	                    return ts.Debug.assertNever(decl);
	            }
	            return true;
	        }
	        function tryDeleteFullVariableStatement(changes, sourceFile, startToken, deletedAncestors) {
	            var declarationList = ts.tryCast(startToken.parent, ts.isVariableDeclarationList);
	            if (declarationList && declarationList.getChildren(sourceFile)[0] === startToken) {
	                if (deletedAncestors)
	                    deletedAncestors.add(declarationList);
	                changes.deleteNode(sourceFile, declarationList.parent.kind === 213 /* VariableStatement */ ? declarationList.parent : declarationList);
	                return true;
	            }
	            return false;
	        }
	        function getToken(sourceFile, pos) {
	            var token = ts.findPrecedingToken(pos, sourceFile, /*startNode*/ undefined, /*includeJsDoc*/ true);
	            // this handles var ["computed"] = 12;
	            return token.kind === 22 /* CloseBracketToken */ ? ts.findPrecedingToken(pos - 1, sourceFile) : token;
	        }
	        function tryPrefixDeclaration(changes, errorCode, sourceFile, token) {
	            // Don't offer to prefix a property.
	            if (errorCode !== ts.Diagnostics.Property_0_is_declared_but_its_value_is_never_read.code && ts.isIdentifier(token) && canPrefix(token)) {
	                changes.replaceNode(sourceFile, token, ts.createIdentifier("_" + token.text));
	            }
	        }
	        function canPrefix(token) {
	            switch (token.parent.kind) {
	                case 148 /* Parameter */:
	                    return true;
	                case 231 /* VariableDeclaration */: {
	                    var varDecl = token.parent;
	                    switch (varDecl.parent.parent.kind) {
	                        case 221 /* ForOfStatement */:
	                        case 220 /* ForInStatement */:
	                            return true;
	                    }
	                }
	            }
	            return false;
	        }
	        function tryDeleteDeclaration(changes, sourceFile, token, deletedAncestors) {
	            switch (token.kind) {
	                case 71 /* Identifier */:
	                    tryDeleteIdentifier(changes, sourceFile, token, deletedAncestors);
	                    break;
	                case 151 /* PropertyDeclaration */:
	                case 245 /* NamespaceImport */:
	                    if (deletedAncestors)
	                        deletedAncestors.add(token.parent);
	                    changes.deleteNode(sourceFile, token.parent);
	                    break;
	                default:
	                    tryDeleteDefault(changes, sourceFile, token, deletedAncestors);
	            }
	        }
	        function tryDeleteDefault(changes, sourceFile, token, deletedAncestors) {
	            if (ts.isDeclarationName(token)) {
	                if (deletedAncestors)
	                    deletedAncestors.add(token.parent);
	                changes.deleteNode(sourceFile, token.parent);
	            }
	            else if (ts.isLiteralComputedPropertyDeclarationName(token)) {
	                if (deletedAncestors)
	                    deletedAncestors.add(token.parent.parent);
	                changes.deleteNode(sourceFile, token.parent.parent);
	            }
	        }
	        function tryDeleteIdentifier(changes, sourceFile, identifier, deletedAncestors) {
	            var parent = identifier.parent;
	            switch (parent.kind) {
	                case 231 /* VariableDeclaration */:
	                    tryDeleteVariableDeclaration(changes, sourceFile, parent, deletedAncestors);
	                    break;
	                case 147 /* TypeParameter */:
	                    var typeParameters = ts.getEffectiveTypeParameterDeclarations(parent.parent);
	                    if (typeParameters.length === 1) {
	                        var _a = ts.cast(typeParameters, ts.isNodeArray), pos = _a.pos, end = _a.end;
	                        var previousToken = ts.getTokenAtPosition(sourceFile, pos - 1, /*includeJsDocComment*/ false);
	                        var nextToken = ts.getTokenAtPosition(sourceFile, end, /*includeJsDocComment*/ false);
	                        ts.Debug.assert(previousToken.kind === 27 /* LessThanToken */);
	                        ts.Debug.assert(nextToken.kind === 29 /* GreaterThanToken */);
	                        changes.deleteNodeRange(sourceFile, previousToken, nextToken);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                case 148 /* Parameter */:
	                    var oldFunction = parent.parent;
	                    if (ts.isSetAccessor(oldFunction)) {
	                        // Setter must have a parameter
	                        break;
	                    }
	                    if (ts.isArrowFunction(oldFunction) && oldFunction.parameters.length === 1) {
	                        // Lambdas with exactly one parameter are special because, after removal, there
	                        // must be an empty parameter list (i.e. `()`) and this won't necessarily be the
	                        // case if the parameter is simply removed (e.g. in `x => 1`).
	                        var newFunction = ts.updateArrowFunction(oldFunction, oldFunction.modifiers, oldFunction.typeParameters, 
	                        /*parameters*/ undefined, oldFunction.type, oldFunction.equalsGreaterThanToken, oldFunction.body);
	                        // Drop leading and trailing trivia of the new function because we're only going
	                        // to replace the span (vs the full span) of the old function - the old leading
	                        // and trailing trivia will remain.
	                        ts.suppressLeadingAndTrailingTrivia(newFunction);
	                        changes.replaceNode(sourceFile, oldFunction, newFunction);
	                    }
	                    else {
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                case 181 /* BindingElement */: {
	                    var pattern = parent.parent;
	                    switch (pattern.kind) {
	                        case 180 /* ArrayBindingPattern */:
	                            changes.deleteNode(sourceFile, parent); // Don't delete ','
	                            break;
	                        case 179 /* ObjectBindingPattern */:
	                            changes.deleteNodeInList(sourceFile, parent);
	                            break;
	                        default:
	                            return ts.Debug.assertNever(pattern);
	                    }
	                    break;
	                }
	                // handle case where 'import a = A;'
	                case 242 /* ImportEqualsDeclaration */:
	                    var importEquals = ts.getAncestor(identifier, 242 /* ImportEqualsDeclaration */);
	                    changes.deleteNode(sourceFile, importEquals);
	                    break;
	                case 247 /* ImportSpecifier */:
	                    var namedImports = parent.parent;
	                    if (namedImports.elements.length === 1) {
	                        tryDeleteNamedImportBinding(changes, sourceFile, namedImports);
	                    }
	                    else {
	                        // delete import specifier
	                        changes.deleteNodeInList(sourceFile, parent);
	                    }
	                    break;
	                case 244 /* ImportClause */: // this covers both 'import |d|' and 'import |d,| *'
	                    var importClause = parent;
	                    if (!importClause.namedBindings) { // |import d from './file'|
	                        changes.deleteNode(sourceFile, ts.getAncestor(importClause, 243 /* ImportDeclaration */));
	                    }
	                    else {
	                        // import |d,| * as ns from './file'
	                        var start = importClause.name.getStart(sourceFile);
	                        var nextToken = ts.getTokenAtPosition(sourceFile, importClause.name.end, /*includeJsDocComment*/ false);
	                        if (nextToken && nextToken.kind === 26 /* CommaToken */) {
	                            // shift first non-whitespace position after comma to the start position of the node
	                            var end = ts.skipTrivia(sourceFile.text, nextToken.end, /*stopAfterLineBreaks*/ false, /*stopAtComments*/ true);
	                            changes.deleteRange(sourceFile, { pos: start, end: end });
	                        }
	                        else {
	                            changes.deleteNode(sourceFile, importClause.name);
	                        }
	                    }
	                    break;
	                case 245 /* NamespaceImport */:
	                    tryDeleteNamedImportBinding(changes, sourceFile, parent);
	                    break;
	                default:
	                    tryDeleteDefault(changes, sourceFile, identifier, deletedAncestors);
	                    break;
	            }
	        }
	        function tryDeleteNamedImportBinding(changes, sourceFile, namedBindings) {
	            if (namedBindings.parent.name) {
	                // Delete named imports while preserving the default import
	                // import d|, * as ns| from './file'
	                // import d|, { a }| from './file'
	                var previousToken = ts.getTokenAtPosition(sourceFile, namedBindings.pos - 1, /*includeJsDocComment*/ false);
	                if (previousToken && previousToken.kind === 26 /* CommaToken */) {
	                    changes.deleteRange(sourceFile, { pos: previousToken.getStart(), end: namedBindings.end });
	                }
	            }
	            else {
	                // Delete the entire import declaration
	                // |import * as ns from './file'|
	                // |import { a } from './file'|
	                var importDecl = ts.getAncestor(namedBindings, 243 /* ImportDeclaration */);
	                changes.deleteNode(sourceFile, importDecl);
	            }
	        }
	        // token.parent is a variableDeclaration
	        function tryDeleteVariableDeclaration(changes, sourceFile, varDecl, deletedAncestors) {
	            switch (varDecl.parent.parent.kind) {
	                case 219 /* ForStatement */: {
	                    var forStatement = varDecl.parent.parent;
	                    var forInitializer = forStatement.initializer;
	                    if (forInitializer.declarations.length === 1) {
	                        if (deletedAncestors)
	                            deletedAncestors.add(forInitializer);
	                        changes.deleteNode(sourceFile, forInitializer);
	                    }
	                    else {
	                        if (deletedAncestors)
	                            deletedAncestors.add(varDecl);
	                        changes.deleteNodeInList(sourceFile, varDecl);
	                    }
	                    break;
	                }
	                case 221 /* ForOfStatement */:
	                    var forOfStatement = varDecl.parent.parent;
	                    ts.Debug.assert(forOfStatement.initializer.kind === 232 /* VariableDeclarationList */);
	                    var forOfInitializer = forOfStatement.initializer;
	                    if (deletedAncestors)
	                        deletedAncestors.add(forOfInitializer.declarations[0]);
	                    changes.replaceNode(sourceFile, forOfInitializer.declarations[0], ts.createObjectLiteral());
	                    break;
	                case 220 /* ForInStatement */:
	                case 229 /* TryStatement */:
	                    break;
	                default:
	                    var variableStatement = varDecl.parent.parent;
	                    if (variableStatement.declarationList.declarations.length === 1) {
	                        if (deletedAncestors)
	                            deletedAncestors.add(variableStatement);
	                        changes.deleteNode(sourceFile, variableStatement);
	                    }
	                    else {
	                        if (deletedAncestors)
	                            deletedAncestors.add(varDecl);
	                        changes.deleteNodeInList(sourceFile, varDecl);
	                    }
	            }
	        }
	        var NodeSet = /** @class */ (function () {
	            function NodeSet() {
	                this.map = ts.createMap();
	            }
	            NodeSet.prototype.add = function (node) {
	                this.map.set(String(ts.getNodeId(node)), node);
	            };
	            NodeSet.prototype.some = function (pred) {
	                return ts.forEachEntry(this.map, pred) || false;
	            };
	            return NodeSet;
	        }());
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixUnreachableCode";
	        var errorCodes = [ts.Diagnostics.Unreachable_code_detected.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, context.span.start); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Remove_unreachable_code, fixId, ts.Diagnostics.Remove_all_unreachable_code)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) { return doChange(changes, diag.file, diag.start); }); },
	        });
	        function doChange(changes, sourceFile, start) {
	            var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	            var statement = ts.findAncestor(token, ts.isStatement);
	            ts.Debug.assert(statement.getStart(sourceFile) === token.getStart(sourceFile));
	            var container = (ts.isBlock(statement.parent) ? statement.parent : statement).parent;
	            switch (container.kind) {
	                case 216 /* IfStatement */:
	                    if (container.elseStatement) {
	                        if (ts.isBlock(statement.parent)) {
	                            changes.deleteNodeRange(sourceFile, ts.first(statement.parent.statements), ts.last(statement.parent.statements));
	                        }
	                        else {
	                            changes.replaceNode(sourceFile, statement, ts.createBlock(ts.emptyArray));
	                        }
	                        break;
	                    }
	                // falls through
	                case 218 /* WhileStatement */:
	                case 219 /* ForStatement */:
	                    changes.deleteNode(sourceFile, container);
	                    break;
	                default:
	                    if (ts.isBlock(statement.parent)) {
	                        split(sliceAfter(statement.parent.statements, statement), shouldRemove, function (start, end) { return changes.deleteNodeRange(sourceFile, start, end); });
	                    }
	                    else {
	                        changes.deleteNode(sourceFile, statement);
	                    }
	            }
	        }
	        function shouldRemove(s) {
	            // Don't remove statements that can validly be used before they appear.
	            return !ts.isFunctionDeclaration(s) && !isPurelyTypeDeclaration(s) &&
	                // `var x;` may declare a variable used above
	                !(ts.isVariableStatement(s) && !(ts.getCombinedNodeFlags(s) & (1 /* Let */ | 2 /* Const */)) && s.declarationList.declarations.some(function (d) { return !d.initializer; }));
	        }
	        function isPurelyTypeDeclaration(s) {
	            switch (s.kind) {
	                case 235 /* InterfaceDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                    return true;
	                case 238 /* ModuleDeclaration */:
	                    return ts.getModuleInstanceState(s) !== 1 /* Instantiated */;
	                case 237 /* EnumDeclaration */:
	                    return ts.hasModifier(s, 2048 /* Const */);
	            }
	        }
	        function sliceAfter(arr, value) {
	            var index = arr.indexOf(value);
	            ts.Debug.assert(index !== -1);
	            return arr.slice(index);
	        }
	        // Calls 'cb' with the start and end of each range where 'pred' is true.
	        function split(arr, pred, cb) {
	            ts.getRangesWhere(arr, pred, function (start, afterEnd) { return cb(arr[start], arr[afterEnd - 1]); });
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixUnusedLabel";
	        var errorCodes = [ts.Diagnostics.Unused_label.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, context.span.start); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Remove_unused_label, fixId, ts.Diagnostics.Remove_all_unused_labels)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) { return doChange(changes, diag.file, diag.start); }); },
	        });
	        function doChange(changes, sourceFile, start) {
	            var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	            var labeledStatement = ts.cast(token.parent, ts.isLabeledStatement);
	            var pos = token.getStart(sourceFile);
	            var statementPos = labeledStatement.statement.getStart(sourceFile);
	            // If label is on a separate line, just delete the rest of that line, but not the indentation of the labeled statement.
	            var end = ts.positionsAreOnSameLine(pos, statementPos, sourceFile) ? statementPos
	                : ts.skipTrivia(sourceFile.text, ts.findChildOfKind(labeledStatement, 56 /* ColonToken */, sourceFile).end, /*stopAfterLineBreak*/ true);
	            changes.deleteRange(sourceFile, { pos: pos, end: end });
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixIdPlain = "fixJSDocTypes_plain";
	        var fixIdNullable = "fixJSDocTypes_nullable";
	        var errorCodes = [ts.Diagnostics.JSDoc_types_can_only_be_used_inside_documentation_comments.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile;
	                var checker = context.program.getTypeChecker();
	                var info = getInfo(sourceFile, context.span.start, checker);
	                if (!info)
	                    return undefined;
	                var typeNode = info.typeNode, type = info.type;
	                var original = typeNode.getText(sourceFile);
	                var actions = [fix(type, fixIdPlain, ts.Diagnostics.Change_all_jsdoc_style_types_to_TypeScript)];
	                if (typeNode.kind === 280 /* JSDocNullableType */) {
	                    // for nullable types, suggest the flow-compatible `T | null | undefined`
	                    // in addition to the jsdoc/closure-compatible `T | null`
	                    actions.push(fix(checker.getNullableType(type, 4096 /* Undefined */), fixIdNullable, ts.Diagnostics.Change_all_jsdoc_style_types_to_TypeScript_and_add_undefined_to_nullable_types));
	                }
	                return actions;
	                function fix(type, fixId, fixAllDescription) {
	                    var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, typeNode, type, checker); });
	                    return codefix.createCodeFixAction("jdocTypes", changes, [ts.Diagnostics.Change_0_to_1, original, checker.typeToString(type)], fixId, fixAllDescription);
	                }
	            },
	            fixIds: [fixIdPlain, fixIdNullable],
	            getAllCodeActions: function (context) {
	                var fixId = context.fixId, program = context.program, sourceFile = context.sourceFile;
	                var checker = program.getTypeChecker();
	                return codefix.codeFixAll(context, errorCodes, function (changes, err) {
	                    var info = getInfo(err.file, err.start, checker);
	                    if (!info)
	                        return;
	                    var typeNode = info.typeNode, type = info.type;
	                    var fixedType = typeNode.kind === 280 /* JSDocNullableType */ && fixId === fixIdNullable ? checker.getNullableType(type, 4096 /* Undefined */) : type;
	                    doChange(changes, sourceFile, typeNode, fixedType, checker);
	                });
	            }
	        });
	        function doChange(changes, sourceFile, oldTypeNode, newType, checker) {
	            changes.replaceNode(sourceFile, oldTypeNode, checker.typeToTypeNode(newType, /*enclosingDeclaration*/ oldTypeNode));
	        }
	        function getInfo(sourceFile, pos, checker) {
	            var decl = ts.findAncestor(ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false), isTypeContainer);
	            var typeNode = decl && decl.type;
	            return typeNode && { typeNode: typeNode, type: checker.getTypeFromTypeNode(typeNode) };
	        }
	        function isTypeContainer(node) {
	            // NOTE: Some locations are not handled yet:
	            // MappedTypeNode.typeParameters and SignatureDeclaration.typeParameters, as well as CallExpression.typeArguments
	            switch (node.kind) {
	                case 207 /* AsExpression */:
	                case 157 /* CallSignature */:
	                case 158 /* ConstructSignature */:
	                case 233 /* FunctionDeclaration */:
	                case 155 /* GetAccessor */:
	                case 159 /* IndexSignature */:
	                case 176 /* MappedType */:
	                case 153 /* MethodDeclaration */:
	                case 152 /* MethodSignature */:
	                case 148 /* Parameter */:
	                case 151 /* PropertyDeclaration */:
	                case 150 /* PropertySignature */:
	                case 156 /* SetAccessor */:
	                case 236 /* TypeAliasDeclaration */:
	                case 189 /* TypeAssertionExpression */:
	                case 231 /* VariableDeclaration */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "fixAwaitInSyncFunction";
	        var errorCodes = [
	            ts.Diagnostics.await_expression_is_only_allowed_within_an_async_function.code,
	            ts.Diagnostics.A_for_await_of_statement_is_only_allowed_within_an_async_function_or_async_generator.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var nodes = getNodes(sourceFile, span.start);
	                if (!nodes)
	                    return undefined;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, nodes); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Add_async_modifier_to_containing_function, fixId, ts.Diagnostics.Add_all_missing_async_modifiers)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var nodes = getNodes(diag.file, diag.start);
	                if (!nodes)
	                    return;
	                doChange(changes, context.sourceFile, nodes);
	            }); },
	        });
	        function getReturnType(expr) {
	            if (expr.type) {
	                return expr.type;
	            }
	            if (ts.isVariableDeclaration(expr.parent) &&
	                expr.parent.type &&
	                ts.isFunctionTypeNode(expr.parent.type)) {
	                return expr.parent.type.type;
	            }
	        }
	        function getNodes(sourceFile, start) {
	            var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	            var containingFunction = ts.getContainingFunction(token);
	            if (!containingFunction) {
	                return;
	            }
	            var insertBefore;
	            switch (containingFunction.kind) {
	                case 153 /* MethodDeclaration */:
	                    insertBefore = containingFunction.name;
	                    break;
	                case 233 /* FunctionDeclaration */:
	                case 191 /* FunctionExpression */:
	                    insertBefore = ts.findChildOfKind(containingFunction, 89 /* FunctionKeyword */, sourceFile);
	                    break;
	                case 192 /* ArrowFunction */:
	                    insertBefore = ts.findChildOfKind(containingFunction, 19 /* OpenParenToken */, sourceFile) || ts.first(containingFunction.parameters);
	                    break;
	                default:
	                    return;
	            }
	            return {
	                insertBefore: insertBefore,
	                returnType: getReturnType(containingFunction)
	            };
	        }
	        function doChange(changes, sourceFile, _a) {
	            var insertBefore = _a.insertBefore, returnType = _a.returnType;
	            if (returnType) {
	                var entityName = ts.getEntityNameFromTypeNode(returnType);
	                if (!entityName || entityName.kind !== 71 /* Identifier */ || entityName.text !== "Promise") {
	                    changes.replaceNode(sourceFile, returnType, ts.createTypeReferenceNode("Promise", ts.createNodeArray([returnType])));
	                }
	            }
	            changes.insertModifierBefore(sourceFile, 120 /* AsyncKeyword */, insertBefore);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixName = "disableJsDiagnostics";
	        var fixId = "disableJsDiagnostics";
	        var errorCodes = ts.mapDefined(Object.keys(ts.Diagnostics), function (key) {
	            var diag = ts.Diagnostics[key];
	            return diag.category === ts.DiagnosticCategory.Error ? diag.code : undefined;
	        });
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, span = context.span, host = context.host, formatContext = context.formatContext;
	                if (!ts.isInJavaScriptFile(sourceFile) || !ts.isCheckJsEnabledForFile(sourceFile, program.getCompilerOptions())) {
	                    return undefined;
	                }
	                var fixes = [
	                    // fixId unnecessary because adding `// @ts-nocheck` even once will ignore every error in the file.
	                    codefix.createCodeFixActionNoFixId(fixName, [codefix.createFileTextChanges(sourceFile.fileName, [
	                            ts.createTextChange(sourceFile.checkJsDirective
	                                ? ts.createTextSpanFromBounds(sourceFile.checkJsDirective.pos, sourceFile.checkJsDirective.end)
	                                : ts.createTextSpan(0, 0), "// @ts-nocheck" + ts.getNewLineOrDefaultFromHost(host, formatContext.options)),
	                        ])], ts.Diagnostics.Disable_checking_for_this_file),
	                ];
	                if (ts.textChanges.isValidLocationToAddComment(sourceFile, span.start)) {
	                    fixes.unshift(codefix.createCodeFixAction(fixName, ts.textChanges.ChangeTracker.with(context, function (t) { return makeChange(t, sourceFile, span.start); }), ts.Diagnostics.Ignore_this_error_message, fixId, ts.Diagnostics.Add_ts_ignore_to_all_error_messages));
	                }
	                return fixes;
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var seenLines = ts.createMap();
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    if (ts.textChanges.isValidLocationToAddComment(diag.file, diag.start)) {
	                        makeChange(changes, diag.file, diag.start, seenLines);
	                    }
	                });
	            },
	        });
	        function makeChange(changes, sourceFile, position, seenLines) {
	            var lineNumber = ts.getLineAndCharacterOfPosition(sourceFile, position).line;
	            // Only need to add `// @ts-ignore` for a line once.
	            if (!seenLines || ts.addToSeen(seenLines, lineNumber)) {
	                changes.insertCommentBeforeLine(sourceFile, lineNumber, position, " @ts-ignore");
	            }
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        /**
	         * Finds members of the resolved type that are missing in the class pointed to by class decl
	         * and generates source code for the missing members.
	         * @param possiblyMissingSymbols The collection of symbols to filter and then get insertions for.
	         * @returns Empty string iff there are no member insertions.
	         */
	        function createMissingMemberNodes(classDeclaration, possiblyMissingSymbols, checker, preferences, out) {
	            var classMembers = classDeclaration.symbol.members;
	            for (var _i = 0, possiblyMissingSymbols_1 = possiblyMissingSymbols; _i < possiblyMissingSymbols_1.length; _i++) {
	                var symbol = possiblyMissingSymbols_1[_i];
	                if (!classMembers.has(symbol.escapedName)) {
	                    addNewNodeForMemberSymbol(symbol, classDeclaration, checker, preferences, out);
	                }
	            }
	        }
	        codefix.createMissingMemberNodes = createMissingMemberNodes;
	        /**
	         * @returns Empty string iff there we can't figure out a representation for `symbol` in `enclosingDeclaration`.
	         */
	        function addNewNodeForMemberSymbol(symbol, enclosingDeclaration, checker, preferences, out) {
	            var declarations = symbol.getDeclarations();
	            if (!(declarations && declarations.length)) {
	                return undefined;
	            }
	            var declaration = declarations[0];
	            var name = ts.getSynthesizedDeepClone(ts.getNameOfDeclaration(declaration), /*includeTrivia*/ false);
	            var visibilityModifier = createVisibilityModifier(ts.getModifierFlags(declaration));
	            var modifiers = visibilityModifier ? ts.createNodeArray([visibilityModifier]) : undefined;
	            var type = checker.getWidenedType(checker.getTypeOfSymbolAtLocation(symbol, enclosingDeclaration));
	            var optional = !!(symbol.flags & 16777216 /* Optional */);
	            switch (declaration.kind) {
	                case 155 /* GetAccessor */:
	                case 156 /* SetAccessor */:
	                case 150 /* PropertySignature */:
	                case 151 /* PropertyDeclaration */:
	                    var typeNode = checker.typeToTypeNode(type, enclosingDeclaration);
	                    out(ts.createProperty(
	                    /*decorators*/ undefined, modifiers, name, optional ? ts.createToken(55 /* QuestionToken */) : undefined, typeNode, 
	                    /*initializer*/ undefined));
	                    break;
	                case 152 /* MethodSignature */:
	                case 153 /* MethodDeclaration */:
	                    // The signature for the implementation appears as an entry in `signatures` iff
	                    // there is only one signature.
	                    // If there are overloads and an implementation signature, it appears as an
	                    // extra declaration that isn't a signature for `type`.
	                    // If there is more than one overload but no implementation signature
	                    // (eg: an abstract method or interface declaration), there is a 1-1
	                    // correspondence of declarations and signatures.
	                    var signatures = checker.getSignaturesOfType(type, 0 /* Call */);
	                    if (!ts.some(signatures)) {
	                        break;
	                    }
	                    if (declarations.length === 1) {
	                        ts.Debug.assert(signatures.length === 1);
	                        var signature = signatures[0];
	                        outputMethod(signature, modifiers, name, createStubbedMethodBody(preferences));
	                        break;
	                    }
	                    for (var _i = 0, signatures_8 = signatures; _i < signatures_8.length; _i++) {
	                        var signature = signatures_8[_i];
	                        // Need to ensure nodes are fresh each time so they can have different positions.
	                        outputMethod(signature, ts.getSynthesizedDeepClones(modifiers, /*includeTrivia*/ false), ts.getSynthesizedDeepClone(name, /*includeTrivia*/ false));
	                    }
	                    if (declarations.length > signatures.length) {
	                        var signature = checker.getSignatureFromDeclaration(declarations[declarations.length - 1]);
	                        outputMethod(signature, modifiers, name, createStubbedMethodBody(preferences));
	                    }
	                    else {
	                        ts.Debug.assert(declarations.length === signatures.length);
	                        out(createMethodImplementingSignatures(signatures, name, optional, modifiers, preferences));
	                    }
	                    break;
	            }
	            function outputMethod(signature, modifiers, name, body) {
	                var method = signatureToMethodDeclaration(checker, signature, enclosingDeclaration, modifiers, name, optional, body);
	                if (method)
	                    out(method);
	            }
	        }
	        function signatureToMethodDeclaration(checker, signature, enclosingDeclaration, modifiers, name, optional, body) {
	            var signatureDeclaration = checker.signatureToSignatureDeclaration(signature, 153 /* MethodDeclaration */, enclosingDeclaration, 256 /* SuppressAnyReturnType */);
	            if (!signatureDeclaration) {
	                return undefined;
	            }
	            signatureDeclaration.decorators = undefined;
	            signatureDeclaration.modifiers = modifiers;
	            signatureDeclaration.name = name;
	            signatureDeclaration.questionToken = optional ? ts.createToken(55 /* QuestionToken */) : undefined;
	            signatureDeclaration.body = body;
	            return signatureDeclaration;
	        }
	        function createMethodFromCallExpression(_a, methodName, inJs, makeStatic, preferences) {
	            var typeArguments = _a.typeArguments, args = _a.arguments;
	            return ts.createMethod(
	            /*decorators*/ undefined, 
	            /*modifiers*/ makeStatic ? [ts.createToken(115 /* StaticKeyword */)] : undefined, 
	            /*asteriskToken*/ undefined, methodName, 
	            /*questionToken*/ undefined, 
	            /*typeParameters*/ inJs ? undefined : ts.map(typeArguments, function (_, i) {
	                return ts.createTypeParameterDeclaration(84 /* T */ + typeArguments.length - 1 <= 90 /* Z */ ? String.fromCharCode(84 /* T */ + i) : "T" + i);
	            }), 
	            /*parameters*/ createDummyParameters(args.length, /*names*/ undefined, /*minArgumentCount*/ undefined, inJs), 
	            /*type*/ inJs ? undefined : ts.createKeywordTypeNode(119 /* AnyKeyword */), createStubbedMethodBody(preferences));
	        }
	        codefix.createMethodFromCallExpression = createMethodFromCallExpression;
	        function createDummyParameters(argCount, names, minArgumentCount, inJs) {
	            var parameters = [];
	            for (var i = 0; i < argCount; i++) {
	                var newParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, 
	                /*dotDotDotToken*/ undefined, 
	                /*name*/ names && names[i] || "arg" + i, 
	                /*questionToken*/ minArgumentCount !== undefined && i >= minArgumentCount ? ts.createToken(55 /* QuestionToken */) : undefined, 
	                /*type*/ inJs ? undefined : ts.createKeywordTypeNode(119 /* AnyKeyword */), 
	                /*initializer*/ undefined);
	                parameters.push(newParameter);
	            }
	            return parameters;
	        }
	        function createMethodImplementingSignatures(signatures, name, optional, modifiers, preferences) {
	            /** This is *a* signature with the maximal number of arguments,
	             * such that if there is a "maximal" signature without rest arguments,
	             * this is one of them.
	             */
	            var maxArgsSignature = signatures[0];
	            var minArgumentCount = signatures[0].minArgumentCount;
	            var someSigHasRestParameter = false;
	            for (var _i = 0, signatures_9 = signatures; _i < signatures_9.length; _i++) {
	                var sig = signatures_9[_i];
	                minArgumentCount = Math.min(sig.minArgumentCount, minArgumentCount);
	                if (sig.hasRestParameter) {
	                    someSigHasRestParameter = true;
	                }
	                if (sig.parameters.length >= maxArgsSignature.parameters.length && (!sig.hasRestParameter || maxArgsSignature.hasRestParameter)) {
	                    maxArgsSignature = sig;
	                }
	            }
	            var maxNonRestArgs = maxArgsSignature.parameters.length - (maxArgsSignature.hasRestParameter ? 1 : 0);
	            var maxArgsParameterSymbolNames = maxArgsSignature.parameters.map(function (symbol) { return symbol.name; });
	            var parameters = createDummyParameters(maxNonRestArgs, maxArgsParameterSymbolNames, minArgumentCount, /*inJs*/ false);
	            if (someSigHasRestParameter) {
	                var anyArrayType = ts.createArrayTypeNode(ts.createKeywordTypeNode(119 /* AnyKeyword */));
	                var restParameter = ts.createParameter(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, ts.createToken(24 /* DotDotDotToken */), maxArgsParameterSymbolNames[maxNonRestArgs] || "rest", 
	                /*questionToken*/ maxNonRestArgs >= minArgumentCount ? ts.createToken(55 /* QuestionToken */) : undefined, anyArrayType, 
	                /*initializer*/ undefined);
	                parameters.push(restParameter);
	            }
	            return createStubbedMethod(modifiers, name, optional, 
	            /*typeParameters*/ undefined, parameters, 
	            /*returnType*/ undefined, preferences);
	        }
	        function createStubbedMethod(modifiers, name, optional, typeParameters, parameters, returnType, preferences) {
	            return ts.createMethod(
	            /*decorators*/ undefined, modifiers, 
	            /*asteriskToken*/ undefined, name, optional ? ts.createToken(55 /* QuestionToken */) : undefined, typeParameters, parameters, returnType, createStubbedMethodBody(preferences));
	        }
	        function createStubbedMethodBody(preferences) {
	            return ts.createBlock([ts.createThrow(ts.createNew(ts.createIdentifier("Error"), 
	                /*typeArguments*/ undefined, [ts.createLiteral("Method not implemented.", /*isSingleQuote*/ preferences.quotePreference === "single")]))], 
	            /*multiline*/ true);
	        }
	        function createVisibilityModifier(flags) {
	            if (flags & 4 /* Public */) {
	                return ts.createToken(114 /* PublicKeyword */);
	            }
	            else if (flags & 16 /* Protected */) {
	                return ts.createToken(113 /* ProtectedKeyword */);
	            }
	            return undefined;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "inferFromUsage";
	        var errorCodes = [
	            // Variable declarations
	            ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code,
	            // Variable uses
	            ts.Diagnostics.Variable_0_implicitly_has_an_1_type.code,
	            // Parameter declarations
	            ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code,
	            ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code,
	            // Get Accessor declarations
	            ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code,
	            ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code,
	            // Set Accessor declarations
	            ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code,
	            // Property declarations
	            ts.Diagnostics.Member_0_implicitly_has_an_1_type.code,
	        ];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, start = context.span.start, errorCode = context.errorCode, cancellationToken = context.cancellationToken;
	                if (ts.isSourceFileJavaScript(sourceFile)) {
	                    return undefined; // TODO: GH#20113
	                }
	                var token = ts.getTokenAtPosition(sourceFile, start, /*includeJsDocComment*/ false);
	                var declaration;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (changes) { declaration = doChange(changes, sourceFile, token, errorCode, program, cancellationToken, /*markSeenseen*/ ts.returnTrue); });
	                return changes.length === 0 ? undefined
	                    : [codefix.createCodeFixAction(fixId, changes, [getDiagnostic(errorCode, token), ts.getNameOfDeclaration(declaration).getText(sourceFile)], fixId, ts.Diagnostics.Infer_all_types_from_usage)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) {
	                var sourceFile = context.sourceFile, program = context.program, cancellationToken = context.cancellationToken;
	                var markSeen = ts.nodeSeenTracker();
	                return codefix.codeFixAll(context, errorCodes, function (changes, err) {
	                    doChange(changes, sourceFile, ts.getTokenAtPosition(err.file, err.start, /*includeJsDocComment*/ false), err.code, program, cancellationToken, markSeen);
	                });
	            },
	        });
	        function getDiagnostic(errorCode, token) {
	            switch (errorCode) {
	                case ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
	                    return ts.isSetAccessor(ts.getContainingFunction(token)) ? ts.Diagnostics.Infer_type_of_0_from_usage : ts.Diagnostics.Infer_parameter_types_from_usage;
	                case ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
	                    return ts.Diagnostics.Infer_parameter_types_from_usage;
	                default:
	                    return ts.Diagnostics.Infer_type_of_0_from_usage;
	            }
	        }
	        function doChange(changes, sourceFile, token, errorCode, program, cancellationToken, markSeen) {
	            if (!ts.isParameterPropertyModifier(token.kind) && token.kind !== 71 /* Identifier */ && token.kind !== 24 /* DotDotDotToken */) {
	                return undefined;
	            }
	            var parent = token.parent;
	            switch (errorCode) {
	                // Variable and Property declarations
	                case ts.Diagnostics.Member_0_implicitly_has_an_1_type.code:
	                case ts.Diagnostics.Variable_0_implicitly_has_type_1_in_some_locations_where_its_type_cannot_be_determined.code:
	                    if ((ts.isVariableDeclaration(parent) && markSeen(parent)) || ts.isPropertyDeclaration(parent) || ts.isPropertySignature(parent)) { // handle bad location
	                        annotateVariableDeclaration(changes, sourceFile, parent, program, cancellationToken);
	                        return parent;
	                    }
	                    return undefined;
	                case ts.Diagnostics.Variable_0_implicitly_has_an_1_type.code: {
	                    var symbol = program.getTypeChecker().getSymbolAtLocation(token);
	                    if (symbol && symbol.valueDeclaration && ts.isVariableDeclaration(symbol.valueDeclaration) && markSeen(symbol.valueDeclaration)) {
	                        annotateVariableDeclaration(changes, sourceFile, symbol.valueDeclaration, program, cancellationToken);
	                        return symbol.valueDeclaration;
	                    }
	                    return undefined;
	                }
	            }
	            var containingFunction = ts.getContainingFunction(token);
	            if (containingFunction === undefined) {
	                return undefined;
	            }
	            switch (errorCode) {
	                // Parameter declarations
	                case ts.Diagnostics.Parameter_0_implicitly_has_an_1_type.code:
	                    if (ts.isSetAccessor(containingFunction)) {
	                        annotateSetAccessor(changes, sourceFile, containingFunction, program, cancellationToken);
	                        return containingFunction;
	                    }
	                // falls through
	                case ts.Diagnostics.Rest_parameter_0_implicitly_has_an_any_type.code:
	                    if (markSeen(containingFunction)) {
	                        var param = ts.cast(parent, ts.isParameter);
	                        annotateParameters(changes, param, containingFunction, sourceFile, program, cancellationToken);
	                        return param;
	                    }
	                    return undefined;
	                // Get Accessor declarations
	                case ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_get_accessor_lacks_a_return_type_annotation.code:
	                case ts.Diagnostics._0_which_lacks_return_type_annotation_implicitly_has_an_1_return_type.code:
	                    if (ts.isGetAccessor(containingFunction) && ts.isIdentifier(containingFunction.name)) {
	                        annotate(changes, sourceFile, containingFunction, inferTypeForVariableFromUsage(containingFunction.name, program, cancellationToken), program);
	                        return containingFunction;
	                    }
	                    return undefined;
	                // Set Accessor declarations
	                case ts.Diagnostics.Property_0_implicitly_has_type_any_because_its_set_accessor_lacks_a_parameter_type_annotation.code:
	                    if (ts.isSetAccessor(containingFunction)) {
	                        annotateSetAccessor(changes, sourceFile, containingFunction, program, cancellationToken);
	                        return containingFunction;
	                    }
	                    return undefined;
	                default:
	                    return ts.Debug.fail(String(errorCode));
	            }
	        }
	        function annotateVariableDeclaration(changes, sourceFile, declaration, program, cancellationToken) {
	            if (ts.isIdentifier(declaration.name)) {
	                annotate(changes, sourceFile, declaration, inferTypeForVariableFromUsage(declaration.name, program, cancellationToken), program);
	            }
	        }
	        function isApplicableFunctionForInference(declaration) {
	            switch (declaration.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                case 154 /* Constructor */:
	                    return true;
	                case 191 /* FunctionExpression */:
	                    return !!declaration.name;
	            }
	            return false;
	        }
	        function annotateParameters(changes, parameterDeclaration, containingFunction, sourceFile, program, cancellationToken) {
	            if (!ts.isIdentifier(parameterDeclaration.name) || !isApplicableFunctionForInference(containingFunction)) {
	                return;
	            }
	            var types = inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken) ||
	                containingFunction.parameters.map(function (p) { return ts.isIdentifier(p.name) ? inferTypeForVariableFromUsage(p.name, program, cancellationToken) : undefined; });
	            // We didn't actually find a set of type inference positions matching each parameter position
	            if (!types || containingFunction.parameters.length !== types.length) {
	                return;
	            }
	            ts.zipWith(containingFunction.parameters, types, function (parameter, type) {
	                if (!parameter.type && !parameter.initializer) {
	                    annotate(changes, sourceFile, parameter, type, program);
	                }
	            });
	        }
	        function annotateSetAccessor(changes, sourceFile, setAccessorDeclaration, program, cancellationToken) {
	            var param = ts.firstOrUndefined(setAccessorDeclaration.parameters);
	            if (param && ts.isIdentifier(setAccessorDeclaration.name) && ts.isIdentifier(param.name)) {
	                var type = inferTypeForVariableFromUsage(setAccessorDeclaration.name, program, cancellationToken) ||
	                    inferTypeForVariableFromUsage(param.name, program, cancellationToken);
	                annotate(changes, sourceFile, param, type, program);
	            }
	        }
	        function annotate(changes, sourceFile, declaration, type, program) {
	            var typeNode = type && getTypeNodeIfAccessible(type, declaration, program.getTypeChecker());
	            if (typeNode)
	                changes.tryInsertTypeAnnotation(sourceFile, declaration, typeNode);
	        }
	        function getTypeNodeIfAccessible(type, enclosingScope, checker) {
	            var typeIsAccessible = true;
	            var notAccessible = function () { typeIsAccessible = false; };
	            var res = checker.typeToTypeNode(type, enclosingScope, /*flags*/ undefined, {
	                trackSymbol: function (symbol, declaration, meaning) {
	                    typeIsAccessible = typeIsAccessible && checker.isSymbolAccessible(symbol, declaration, meaning, /*shouldComputeAliasToMarkVisible*/ false).accessibility === 0 /* Accessible */;
	                },
	                reportInaccessibleThisError: notAccessible,
	                reportPrivateInBaseOfClassExpression: notAccessible,
	                reportInaccessibleUniqueSymbolError: notAccessible,
	            });
	            return typeIsAccessible ? res : undefined;
	        }
	        function getReferences(token, program, cancellationToken) {
	            // Position shouldn't matter since token is not a SourceFile.
	            return ts.mapDefined(ts.FindAllReferences.getReferenceEntriesForNode(-1, token, program, program.getSourceFiles(), cancellationToken), function (entry) {
	                return entry.type === "node" ? ts.tryCast(entry.node, ts.isIdentifier) : undefined;
	            });
	        }
	        function inferTypeForVariableFromUsage(token, program, cancellationToken) {
	            return InferFromReference.inferTypeFromReferences(getReferences(token, program, cancellationToken), program.getTypeChecker(), cancellationToken);
	        }
	        function inferTypeForParametersFromUsage(containingFunction, sourceFile, program, cancellationToken) {
	            switch (containingFunction.kind) {
	                case 154 /* Constructor */:
	                case 191 /* FunctionExpression */:
	                case 233 /* FunctionDeclaration */:
	                case 153 /* MethodDeclaration */:
	                    var isConstructor = containingFunction.kind === 154 /* Constructor */;
	                    var searchToken = isConstructor ?
	                        ts.findChildOfKind(containingFunction, 123 /* ConstructorKeyword */, sourceFile) :
	                        containingFunction.name;
	                    if (searchToken) {
	                        return InferFromReference.inferTypeForParametersFromReferences(getReferences(searchToken, program, cancellationToken), containingFunction, program.getTypeChecker(), cancellationToken);
	                    }
	            }
	        }
	        var InferFromReference;
	        (function (InferFromReference) {
	            function inferTypeFromReferences(references, checker, cancellationToken) {
	                var usageContext = {};
	                for (var _i = 0, references_1 = references; _i < references_1.length; _i++) {
	                    var reference = references_1[_i];
	                    cancellationToken.throwIfCancellationRequested();
	                    inferTypeFromContext(reference, checker, usageContext);
	                }
	                return getTypeFromUsageContext(usageContext, checker);
	            }
	            InferFromReference.inferTypeFromReferences = inferTypeFromReferences;
	            function inferTypeForParametersFromReferences(references, declaration, checker, cancellationToken) {
	                if (references.length === 0) {
	                    return undefined;
	                }
	                if (!declaration.parameters) {
	                    return undefined;
	                }
	                var usageContext = {};
	                for (var _i = 0, references_2 = references; _i < references_2.length; _i++) {
	                    var reference = references_2[_i];
	                    cancellationToken.throwIfCancellationRequested();
	                    inferTypeFromContext(reference, checker, usageContext);
	                }
	                var isConstructor = declaration.kind === 154 /* Constructor */;
	                var callContexts = isConstructor ? usageContext.constructContexts : usageContext.callContexts;
	                return callContexts && declaration.parameters.map(function (parameter, parameterIndex) {
	                    var types = [];
	                    var isRest = ts.isRestParameter(parameter);
	                    for (var _i = 0, callContexts_1 = callContexts; _i < callContexts_1.length; _i++) {
	                        var callContext = callContexts_1[_i];
	                        if (callContext.argumentTypes.length <= parameterIndex) {
	                            continue;
	                        }
	                        if (isRest) {
	                            for (var i = parameterIndex; i < callContext.argumentTypes.length; i++) {
	                                types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[i]));
	                            }
	                        }
	                        else {
	                            types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[parameterIndex]));
	                        }
	                    }
	                    if (!types.length) {
	                        return undefined;
	                    }
	                    var type = checker.getWidenedType(checker.getUnionType(types, 2 /* Subtype */));
	                    return isRest ? checker.createArrayType(type) : type;
	                });
	            }
	            InferFromReference.inferTypeForParametersFromReferences = inferTypeForParametersFromReferences;
	            function inferTypeFromContext(node, checker, usageContext) {
	                while (ts.isRightSideOfQualifiedNameOrPropertyAccess(node)) {
	                    node = node.parent;
	                }
	                switch (node.parent.kind) {
	                    case 198 /* PostfixUnaryExpression */:
	                        usageContext.isNumber = true;
	                        break;
	                    case 197 /* PrefixUnaryExpression */:
	                        inferTypeFromPrefixUnaryExpressionContext(node.parent, usageContext);
	                        break;
	                    case 199 /* BinaryExpression */:
	                        inferTypeFromBinaryExpressionContext(node, node.parent, checker, usageContext);
	                        break;
	                    case 265 /* CaseClause */:
	                    case 266 /* DefaultClause */:
	                        inferTypeFromSwitchStatementLabelContext(node.parent, checker, usageContext);
	                        break;
	                    case 186 /* CallExpression */:
	                    case 187 /* NewExpression */:
	                        if (node.parent.expression === node) {
	                            inferTypeFromCallExpressionContext(node.parent, checker, usageContext);
	                        }
	                        else {
	                            inferTypeFromContextualType(node, checker, usageContext);
	                        }
	                        break;
	                    case 184 /* PropertyAccessExpression */:
	                        inferTypeFromPropertyAccessExpressionContext(node.parent, checker, usageContext);
	                        break;
	                    case 185 /* ElementAccessExpression */:
	                        inferTypeFromPropertyElementExpressionContext(node.parent, node, checker, usageContext);
	                        break;
	                    case 231 /* VariableDeclaration */: {
	                        var _a = node.parent, name = _a.name, initializer = _a.initializer;
	                        if (node === name) {
	                            if (initializer) { // This can happen for `let x = null;` which still has an implicit-any error.
	                                addCandidateType(usageContext, checker.getTypeAtLocation(initializer));
	                            }
	                            break;
	                        }
	                    }
	                    // falls through
	                    default:
	                        return inferTypeFromContextualType(node, checker, usageContext);
	                }
	            }
	            function inferTypeFromContextualType(node, checker, usageContext) {
	                if (ts.isExpressionNode(node)) {
	                    addCandidateType(usageContext, checker.getContextualType(node));
	                }
	            }
	            function inferTypeFromPrefixUnaryExpressionContext(node, usageContext) {
	                switch (node.operator) {
	                    case 43 /* PlusPlusToken */:
	                    case 44 /* MinusMinusToken */:
	                    case 38 /* MinusToken */:
	                    case 52 /* TildeToken */:
	                        usageContext.isNumber = true;
	                        break;
	                    case 37 /* PlusToken */:
	                        usageContext.isNumberOrString = true;
	                        break;
	                    // case SyntaxKind.ExclamationToken:
	                    // no inferences here;
	                }
	            }
	            function inferTypeFromBinaryExpressionContext(node, parent, checker, usageContext) {
	                switch (parent.operatorToken.kind) {
	                    // ExponentiationOperator
	                    case 40 /* AsteriskAsteriskToken */:
	                    // MultiplicativeOperator
	                    case 39 /* AsteriskToken */:
	                    case 41 /* SlashToken */:
	                    case 42 /* PercentToken */:
	                    // ShiftOperator
	                    case 45 /* LessThanLessThanToken */:
	                    case 46 /* GreaterThanGreaterThanToken */:
	                    case 47 /* GreaterThanGreaterThanGreaterThanToken */:
	                    // BitwiseOperator
	                    case 48 /* AmpersandToken */:
	                    case 49 /* BarToken */:
	                    case 50 /* CaretToken */:
	                    // CompoundAssignmentOperator
	                    case 60 /* MinusEqualsToken */:
	                    case 62 /* AsteriskAsteriskEqualsToken */:
	                    case 61 /* AsteriskEqualsToken */:
	                    case 63 /* SlashEqualsToken */:
	                    case 64 /* PercentEqualsToken */:
	                    case 68 /* AmpersandEqualsToken */:
	                    case 69 /* BarEqualsToken */:
	                    case 70 /* CaretEqualsToken */:
	                    case 65 /* LessThanLessThanEqualsToken */:
	                    case 67 /* GreaterThanGreaterThanGreaterThanEqualsToken */:
	                    case 66 /* GreaterThanGreaterThanEqualsToken */:
	                    // AdditiveOperator
	                    case 38 /* MinusToken */:
	                    // RelationalOperator
	                    case 27 /* LessThanToken */:
	                    case 30 /* LessThanEqualsToken */:
	                    case 29 /* GreaterThanToken */:
	                    case 31 /* GreaterThanEqualsToken */:
	                        var operandType = checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left);
	                        if (operandType.flags & 272 /* EnumLike */) {
	                            addCandidateType(usageContext, operandType);
	                        }
	                        else {
	                            usageContext.isNumber = true;
	                        }
	                        break;
	                    case 59 /* PlusEqualsToken */:
	                    case 37 /* PlusToken */:
	                        var otherOperandType = checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left);
	                        if (otherOperandType.flags & 272 /* EnumLike */) {
	                            addCandidateType(usageContext, otherOperandType);
	                        }
	                        else if (otherOperandType.flags & 84 /* NumberLike */) {
	                            usageContext.isNumber = true;
	                        }
	                        else if (otherOperandType.flags & 34 /* StringLike */) {
	                            usageContext.isString = true;
	                        }
	                        else {
	                            usageContext.isNumberOrString = true;
	                        }
	                        break;
	                    //  AssignmentOperators
	                    case 58 /* EqualsToken */:
	                    case 32 /* EqualsEqualsToken */:
	                    case 34 /* EqualsEqualsEqualsToken */:
	                    case 35 /* ExclamationEqualsEqualsToken */:
	                    case 33 /* ExclamationEqualsToken */:
	                        addCandidateType(usageContext, checker.getTypeAtLocation(parent.left === node ? parent.right : parent.left));
	                        break;
	                    case 92 /* InKeyword */:
	                        if (node === parent.left) {
	                            usageContext.isString = true;
	                        }
	                        break;
	                    // LogicalOperator
	                    case 54 /* BarBarToken */:
	                        if (node === parent.left &&
	                            (node.parent.parent.kind === 231 /* VariableDeclaration */ || ts.isAssignmentExpression(node.parent.parent, /*excludeCompoundAssignment*/ true))) {
	                            // var x = x || {};
	                            // TODO: use getFalsyflagsOfType
	                            addCandidateType(usageContext, checker.getTypeAtLocation(parent.right));
	                        }
	                        break;
	                    case 53 /* AmpersandAmpersandToken */:
	                    case 26 /* CommaToken */:
	                    case 93 /* InstanceOfKeyword */:
	                        // nothing to infer here
	                        break;
	                }
	            }
	            function inferTypeFromSwitchStatementLabelContext(parent, checker, usageContext) {
	                addCandidateType(usageContext, checker.getTypeAtLocation(parent.parent.parent.expression));
	            }
	            function inferTypeFromCallExpressionContext(parent, checker, usageContext) {
	                var callContext = {
	                    argumentTypes: [],
	                    returnType: {}
	                };
	                if (parent.arguments) {
	                    for (var _i = 0, _a = parent.arguments; _i < _a.length; _i++) {
	                        var argument = _a[_i];
	                        callContext.argumentTypes.push(checker.getTypeAtLocation(argument));
	                    }
	                }
	                inferTypeFromContext(parent, checker, callContext.returnType);
	                if (parent.kind === 186 /* CallExpression */) {
	                    (usageContext.callContexts || (usageContext.callContexts = [])).push(callContext);
	                }
	                else {
	                    (usageContext.constructContexts || (usageContext.constructContexts = [])).push(callContext);
	                }
	            }
	            function inferTypeFromPropertyAccessExpressionContext(parent, checker, usageContext) {
	                var name = ts.escapeLeadingUnderscores(parent.name.text);
	                if (!usageContext.properties) {
	                    usageContext.properties = ts.createUnderscoreEscapedMap();
	                }
	                var propertyUsageContext = usageContext.properties.get(name) || {};
	                inferTypeFromContext(parent, checker, propertyUsageContext);
	                usageContext.properties.set(name, propertyUsageContext);
	            }
	            function inferTypeFromPropertyElementExpressionContext(parent, node, checker, usageContext) {
	                if (node === parent.argumentExpression) {
	                    usageContext.isNumberOrString = true;
	                    return;
	                }
	                else {
	                    var indexType = checker.getTypeAtLocation(parent);
	                    var indexUsageContext = {};
	                    inferTypeFromContext(parent, checker, indexUsageContext);
	                    if (indexType.flags & 84 /* NumberLike */) {
	                        usageContext.numberIndexContext = indexUsageContext;
	                    }
	                    else {
	                        usageContext.stringIndexContext = indexUsageContext;
	                    }
	                }
	            }
	            function getTypeFromUsageContext(usageContext, checker) {
	                if (usageContext.isNumberOrString && !usageContext.isNumber && !usageContext.isString) {
	                    return checker.getUnionType([checker.getNumberType(), checker.getStringType()]);
	                }
	                else if (usageContext.isNumber) {
	                    return checker.getNumberType();
	                }
	                else if (usageContext.isString) {
	                    return checker.getStringType();
	                }
	                else if (usageContext.candidateTypes) {
	                    return checker.getWidenedType(checker.getUnionType(usageContext.candidateTypes.map(function (t) { return checker.getBaseTypeOfLiteralType(t); }), 2 /* Subtype */));
	                }
	                else if (usageContext.properties && hasCallContext(usageContext.properties.get("then"))) {
	                    var paramType = getParameterTypeFromCallContexts(0, usageContext.properties.get("then").callContexts, /*isRestParameter*/ false, checker);
	                    var types = paramType.getCallSignatures().map(function (c) { return c.getReturnType(); });
	                    return checker.createPromiseType(types.length ? checker.getUnionType(types, 2 /* Subtype */) : checker.getAnyType());
	                }
	                else if (usageContext.properties && hasCallContext(usageContext.properties.get("push"))) {
	                    return checker.createArrayType(getParameterTypeFromCallContexts(0, usageContext.properties.get("push").callContexts, /*isRestParameter*/ false, checker));
	                }
	                else if (usageContext.properties || usageContext.callContexts || usageContext.constructContexts || usageContext.numberIndexContext || usageContext.stringIndexContext) {
	                    var members_6 = ts.createUnderscoreEscapedMap();
	                    var callSignatures = [];
	                    var constructSignatures = [];
	                    var stringIndexInfo = void 0;
	                    var numberIndexInfo = void 0;
	                    if (usageContext.properties) {
	                        usageContext.properties.forEach(function (context, name) {
	                            var symbol = checker.createSymbol(4 /* Property */, name);
	                            symbol.type = getTypeFromUsageContext(context, checker) || checker.getAnyType();
	                            members_6.set(name, symbol);
	                        });
	                    }
	                    if (usageContext.callContexts) {
	                        for (var _i = 0, _a = usageContext.callContexts; _i < _a.length; _i++) {
	                            var callContext = _a[_i];
	                            callSignatures.push(getSignatureFromCallContext(callContext, checker));
	                        }
	                    }
	                    if (usageContext.constructContexts) {
	                        for (var _b = 0, _c = usageContext.constructContexts; _b < _c.length; _b++) {
	                            var constructContext = _c[_b];
	                            constructSignatures.push(getSignatureFromCallContext(constructContext, checker));
	                        }
	                    }
	                    if (usageContext.numberIndexContext) {
	                        numberIndexInfo = checker.createIndexInfo(getTypeFromUsageContext(usageContext.numberIndexContext, checker), /*isReadonly*/ false);
	                    }
	                    if (usageContext.stringIndexContext) {
	                        stringIndexInfo = checker.createIndexInfo(getTypeFromUsageContext(usageContext.stringIndexContext, checker), /*isReadonly*/ false);
	                    }
	                    return checker.createAnonymousType(/*symbol*/ undefined, members_6, callSignatures, constructSignatures, stringIndexInfo, numberIndexInfo);
	                }
	                else {
	                    return undefined;
	                }
	            }
	            function getParameterTypeFromCallContexts(parameterIndex, callContexts, isRestParameter, checker) {
	                var types = [];
	                if (callContexts) {
	                    for (var _i = 0, callContexts_2 = callContexts; _i < callContexts_2.length; _i++) {
	                        var callContext = callContexts_2[_i];
	                        if (callContext.argumentTypes.length > parameterIndex) {
	                            if (isRestParameter) {
	                                types = ts.concatenate(types, ts.map(callContext.argumentTypes.slice(parameterIndex), function (a) { return checker.getBaseTypeOfLiteralType(a); }));
	                            }
	                            else {
	                                types.push(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[parameterIndex]));
	                            }
	                        }
	                    }
	                }
	                if (types.length) {
	                    var type = checker.getWidenedType(checker.getUnionType(types, 2 /* Subtype */));
	                    return isRestParameter ? checker.createArrayType(type) : type;
	                }
	                return undefined;
	            }
	            function getSignatureFromCallContext(callContext, checker) {
	                var parameters = [];
	                for (var i = 0; i < callContext.argumentTypes.length; i++) {
	                    var symbol = checker.createSymbol(1 /* FunctionScopedVariable */, ts.escapeLeadingUnderscores("arg" + i));
	                    symbol.type = checker.getWidenedType(checker.getBaseTypeOfLiteralType(callContext.argumentTypes[i]));
	                    parameters.push(symbol);
	                }
	                var returnType = getTypeFromUsageContext(callContext.returnType, checker) || checker.getVoidType();
	                return checker.createSignature(/*declaration*/ undefined, /*typeParameters*/ undefined, /*thisParameter*/ undefined, parameters, returnType, /*typePredicate*/ undefined, callContext.argumentTypes.length, /*hasRestParameter*/ false, /*hasLiteralTypes*/ false);
	            }
	            function addCandidateType(context, type) {
	                if (type && !(type.flags & 1 /* Any */) && !(type.flags & 16384 /* Never */)) {
	                    (context.candidateTypes || (context.candidateTypes = [])).push(type);
	                }
	            }
	            function hasCallContext(usageContext) {
	                return usageContext && usageContext.callContexts;
	            }
	        })(InferFromReference || (InferFromReference = {}));
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixName = "invalidImportSyntax";
	        codefix.registerCodeFix({
	            errorCodes: [ts.Diagnostics.A_namespace_style_import_cannot_be_called_or_constructed_and_will_cause_a_failure_at_runtime.code],
	            getCodeActions: getActionsForInvalidImport
	        });
	        function getActionsForInvalidImport(context) {
	            var sourceFile = context.sourceFile;
	            // This is the whole import statement, eg:
	            // import * as Bluebird from 'bluebird';
	            // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
	            var node = ts.getTokenAtPosition(sourceFile, context.span.start, /*includeJsDocComment*/ false).parent;
	            if (!ts.isImportDeclaration(node)) {
	                // No import quick fix for import calls
	                return [];
	            }
	            return getCodeFixesForImportDeclaration(context, node);
	        }
	        function getCodeFixesForImportDeclaration(context, node) {
	            var sourceFile = ts.getSourceFileOfNode(node);
	            var namespace = ts.getNamespaceDeclarationNode(node);
	            var opts = context.program.getCompilerOptions();
	            var variations = [];
	            // import Bluebird from "bluebird";
	            variations.push(createAction(context, sourceFile, node, ts.makeImport(namespace.name, /*namedImports*/ undefined, node.moduleSpecifier, ts.getQuotePreference(sourceFile, context.preferences))));
	            if (ts.getEmitModuleKind(opts) === ts.ModuleKind.CommonJS) {
	                // import Bluebird = require("bluebird");
	                variations.push(createAction(context, sourceFile, node, ts.createImportEqualsDeclaration(
	                /*decorators*/ undefined, 
	                /*modifiers*/ undefined, namespace.name, ts.createExternalModuleReference(node.moduleSpecifier))));
	            }
	            return variations;
	        }
	        function createAction(context, sourceFile, node, replacement) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.replaceNode(sourceFile, node, replacement); });
	            return codefix.createCodeFixActionNoFixId("invalidImportSyntax", changes, [ts.Diagnostics.Replace_import_with_0, changes[0].textChanges[0].newText]);
	        }
	        codefix.registerCodeFix({
	            errorCodes: [
	                ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures.code,
	                ts.Diagnostics.Cannot_use_new_with_an_expression_whose_type_lacks_a_call_or_construct_signature.code,
	            ],
	            getCodeActions: getActionsForUsageOfInvalidImport
	        });
	        function getActionsForUsageOfInvalidImport(context) {
	            var sourceFile = context.sourceFile;
	            var targetKind = ts.Diagnostics.Cannot_invoke_an_expression_whose_type_lacks_a_call_signature_Type_0_has_no_compatible_call_signatures.code === context.errorCode ? 186 /* CallExpression */ : 187 /* NewExpression */;
	            var node = ts.findAncestor(ts.getTokenAtPosition(sourceFile, context.span.start, /*includeJsDocComment*/ false), function (a) { return a.kind === targetKind && a.getStart() === context.span.start && a.getEnd() === (context.span.start + context.span.length); });
	            if (!node) {
	                return [];
	            }
	            var expr = node.expression;
	            var type = context.program.getTypeChecker().getTypeAtLocation(expr);
	            if (!(type.symbol && type.symbol.originatingImport)) {
	                return [];
	            }
	            var fixes = [];
	            var relatedImport = type.symbol.originatingImport;
	            if (!ts.isImportCall(relatedImport)) {
	                ts.addRange(fixes, getCodeFixesForImportDeclaration(context, relatedImport));
	            }
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return t.replaceNode(sourceFile, expr, ts.createPropertyAccess(expr, "default"), {}); });
	            fixes.push(codefix.createCodeFixActionNoFixId(fixName, changes, ts.Diagnostics.Use_synthetic_default_member));
	            return fixes;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixName = "strictClassInitialization";
	        var fixIdAddDefiniteAssignmentAssertions = "addMissingPropertyDefiniteAssignmentAssertions";
	        var fixIdAddUndefinedType = "addMissingPropertyUndefinedType";
	        var fixIdAddInitializer = "addMissingPropertyInitializer";
	        var errorCodes = [ts.Diagnostics.Property_0_has_no_initializer_and_is_not_definitely_assigned_in_the_constructor.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var propertyDeclaration = getPropertyDeclaration(context.sourceFile, context.span.start);
	                if (!propertyDeclaration)
	                    return;
	                var result = [
	                    getActionForAddMissingUndefinedType(context, propertyDeclaration),
	                    getActionForAddMissingDefiniteAssignmentAssertion(context, propertyDeclaration)
	                ];
	                ts.append(result, getActionForAddMissingInitializer(context, propertyDeclaration));
	                return result;
	            },
	            fixIds: [fixIdAddDefiniteAssignmentAssertions, fixIdAddUndefinedType, fixIdAddInitializer],
	            getAllCodeActions: function (context) {
	                return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                    var propertyDeclaration = getPropertyDeclaration(diag.file, diag.start);
	                    if (!propertyDeclaration)
	                        return;
	                    switch (context.fixId) {
	                        case fixIdAddDefiniteAssignmentAssertions:
	                            addDefiniteAssignmentAssertion(changes, diag.file, propertyDeclaration);
	                            break;
	                        case fixIdAddUndefinedType:
	                            addUndefinedType(changes, diag.file, propertyDeclaration);
	                            break;
	                        case fixIdAddInitializer:
	                            var checker = context.program.getTypeChecker();
	                            var initializer = getInitializer(checker, propertyDeclaration);
	                            if (!initializer)
	                                return;
	                            addInitializer(changes, diag.file, propertyDeclaration, initializer);
	                            break;
	                        default:
	                            ts.Debug.fail(JSON.stringify(context.fixId));
	                    }
	                });
	            },
	        });
	        function getPropertyDeclaration(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            return ts.isIdentifier(token) ? ts.cast(token.parent, ts.isPropertyDeclaration) : undefined;
	        }
	        function getActionForAddMissingDefiniteAssignmentAssertion(context, propertyDeclaration) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addDefiniteAssignmentAssertion(t, context.sourceFile, propertyDeclaration); });
	            return codefix.createCodeFixAction(fixName, changes, [ts.Diagnostics.Add_definite_assignment_assertion_to_property_0, propertyDeclaration.getText()], fixIdAddDefiniteAssignmentAssertions, ts.Diagnostics.Add_definite_assignment_assertions_to_all_uninitialized_properties);
	        }
	        function addDefiniteAssignmentAssertion(changeTracker, propertyDeclarationSourceFile, propertyDeclaration) {
	            var property = ts.updateProperty(propertyDeclaration, propertyDeclaration.decorators, propertyDeclaration.modifiers, propertyDeclaration.name, ts.createToken(51 /* ExclamationToken */), propertyDeclaration.type, propertyDeclaration.initializer);
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
	        }
	        function getActionForAddMissingUndefinedType(context, propertyDeclaration) {
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addUndefinedType(t, context.sourceFile, propertyDeclaration); });
	            return codefix.createCodeFixAction(fixName, changes, [ts.Diagnostics.Add_undefined_type_to_property_0, propertyDeclaration.name.getText()], fixIdAddUndefinedType, ts.Diagnostics.Add_undefined_type_to_all_uninitialized_properties);
	        }
	        function addUndefinedType(changeTracker, propertyDeclarationSourceFile, propertyDeclaration) {
	            var undefinedTypeNode = ts.createKeywordTypeNode(140 /* UndefinedKeyword */);
	            var types = ts.isUnionTypeNode(propertyDeclaration.type) ? propertyDeclaration.type.types.concat(undefinedTypeNode) : [propertyDeclaration.type, undefinedTypeNode];
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration.type, ts.createUnionTypeNode(types));
	        }
	        function getActionForAddMissingInitializer(context, propertyDeclaration) {
	            var checker = context.program.getTypeChecker();
	            var initializer = getInitializer(checker, propertyDeclaration);
	            if (!initializer)
	                return undefined;
	            var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return addInitializer(t, context.sourceFile, propertyDeclaration, initializer); });
	            return codefix.createCodeFixAction(fixName, changes, [ts.Diagnostics.Add_initializer_to_property_0, propertyDeclaration.name.getText()], fixIdAddInitializer, ts.Diagnostics.Add_initializers_to_all_uninitialized_properties);
	        }
	        function addInitializer(changeTracker, propertyDeclarationSourceFile, propertyDeclaration, initializer) {
	            var property = ts.updateProperty(propertyDeclaration, propertyDeclaration.decorators, propertyDeclaration.modifiers, propertyDeclaration.name, propertyDeclaration.questionToken, propertyDeclaration.type, initializer);
	            changeTracker.replaceNode(propertyDeclarationSourceFile, propertyDeclaration, property);
	        }
	        function getInitializer(checker, propertyDeclaration) {
	            return getDefaultValueFromType(checker, checker.getTypeFromTypeNode(propertyDeclaration.type));
	        }
	        function getDefaultValueFromType(checker, type) {
	            if (type.flags & 2 /* String */) {
	                return ts.createLiteral("");
	            }
	            else if (type.flags & 4 /* Number */) {
	                return ts.createNumericLiteral("0");
	            }
	            else if (type.flags & 8 /* Boolean */) {
	                return ts.createFalse();
	            }
	            else if (type.isLiteral()) {
	                return ts.createLiteral(type.value);
	            }
	            else if (type.isUnion()) {
	                return ts.firstDefined(type.types, function (t) { return getDefaultValueFromType(checker, t); });
	            }
	            else if (type.isClass()) {
	                var classDeclaration = ts.getClassLikeDeclarationOfSymbol(type.symbol);
	                if (!classDeclaration || ts.hasModifier(classDeclaration, 128 /* Abstract */))
	                    return undefined;
	                var constructorDeclaration = ts.getFirstConstructorWithBody(classDeclaration);
	                if (constructorDeclaration && constructorDeclaration.parameters.length)
	                    return undefined;
	                return ts.createNew(ts.createIdentifier(type.symbol.name), /*typeArguments*/ undefined, /*argumentsArray*/ undefined);
	            }
	            return undefined;
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "requireInTs";
	        var errorCodes = [ts.Diagnostics.require_call_may_be_converted_to_an_import.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, context.sourceFile, context.span.start, context.program); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Convert_require_to_import, fixId, ts.Diagnostics.Convert_all_require_to_import)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) { return doChange(changes, diag.file, diag.start, context.program); }); },
	        });
	        function doChange(changes, sourceFile, pos, program) {
	            var _a = getInfo(sourceFile, pos), statement = _a.statement, name = _a.name, required = _a.required;
	            changes.replaceNode(sourceFile, statement, ts.getAllowSyntheticDefaultImports(program.getCompilerOptions())
	                ? ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, ts.createImportClause(name, /*namedBindings*/ undefined), required)
	                : ts.createImportEqualsDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, name, ts.createExternalModuleReference(required)));
	        }
	        function getInfo(sourceFile, pos) {
	            var parent = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false).parent;
	            if (!ts.isRequireCall(parent, /*checkArgumentIsStringLiteralLike*/ true))
	                throw ts.Debug.failBadSyntaxKind(parent);
	            var decl = ts.cast(parent.parent, ts.isVariableDeclaration);
	            return { statement: ts.cast(decl.parent.parent, ts.isVariableStatement), name: ts.cast(decl.name, ts.isIdentifier), required: parent.arguments[0] };
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixId = "useDefaultImport";
	        var errorCodes = [ts.Diagnostics.Import_may_be_converted_to_a_default_import.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, start = context.span.start;
	                var info = getInfo(sourceFile, start);
	                if (!info)
	                    return undefined;
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, info, context.preferences); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Convert_to_default_import, fixId, ts.Diagnostics.Convert_all_to_default_imports)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                var info = getInfo(diag.file, diag.start);
	                if (info)
	                    doChange(changes, diag.file, info, context.preferences);
	            }); },
	        });
	        function getInfo(sourceFile, pos) {
	            var name = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            if (!ts.isIdentifier(name))
	                return undefined; // bad input
	            var parent = name.parent;
	            if (ts.isImportEqualsDeclaration(parent) && ts.isExternalModuleReference(parent.moduleReference)) {
	                return { importNode: parent, name: name, moduleSpecifier: parent.moduleReference.expression };
	            }
	            else if (ts.isNamespaceImport(parent)) {
	                var importNode = parent.parent.parent;
	                return { importNode: importNode, name: name, moduleSpecifier: importNode.moduleSpecifier };
	            }
	        }
	        function doChange(changes, sourceFile, info, preferences) {
	            changes.replaceNode(sourceFile, info.importNode, ts.makeImport(info.name, /*namedImports*/ undefined, info.moduleSpecifier, ts.getQuotePreference(sourceFile, preferences)));
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var codefix;
	    (function (codefix) {
	        var fixIdAddMissingTypeof = "fixAddModuleReferTypeMissingTypeof";
	        var fixId = fixIdAddMissingTypeof;
	        var errorCodes = [ts.Diagnostics.Module_0_does_not_refer_to_a_type_but_is_used_as_a_type_here.code];
	        codefix.registerCodeFix({
	            errorCodes: errorCodes,
	            getCodeActions: function (context) {
	                var sourceFile = context.sourceFile, span = context.span;
	                var importType = getImportTypeNode(sourceFile, span.start);
	                var changes = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(t, sourceFile, importType); });
	                return [codefix.createCodeFixAction(fixId, changes, ts.Diagnostics.Add_missing_typeof, fixId, ts.Diagnostics.Add_missing_typeof)];
	            },
	            fixIds: [fixId],
	            getAllCodeActions: function (context) { return codefix.codeFixAll(context, errorCodes, function (changes, diag) {
	                return doChange(changes, context.sourceFile, getImportTypeNode(diag.file, diag.start));
	            }); },
	        });
	        function getImportTypeNode(sourceFile, pos) {
	            var token = ts.getTokenAtPosition(sourceFile, pos, /*includeJsDocComment*/ false);
	            ts.Debug.assert(token.kind === 91 /* ImportKeyword */);
	            ts.Debug.assert(token.parent.kind === 178 /* ImportType */);
	            return token.parent;
	        }
	        function doChange(changes, sourceFile, importType) {
	            var newTypeNode = ts.updateImportTypeNode(importType, importType.argument, importType.qualifier, importType.typeArguments, /* isTypeOf */ true);
	            changes.replaceNode(sourceFile, importType, newTypeNode);
	        }
	    })(codefix = ts.codefix || (ts.codefix = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var extractSymbol;
	        (function (extractSymbol) {
	            var refactorName = "Extract Symbol";
	            refactor.registerRefactor(refactorName, { getAvailableActions: getAvailableActions, getEditsForAction: getEditsForAction });
	            /**
	             * Compute the associated code actions
	             * Exported for tests.
	             */
	            function getAvailableActions(context) {
	                var rangeToExtract = getRangeToExtract(context.file, ts.getRefactorContextSpan(context));
	                var targetRange = rangeToExtract.targetRange;
	                if (targetRange === undefined) {
	                    return undefined;
	                }
	                var extractions = getPossibleExtractions(targetRange, context);
	                if (extractions === undefined) {
	                    // No extractions possible
	                    return undefined;
	                }
	                var functionActions = [];
	                var usedFunctionNames = ts.createMap();
	                var constantActions = [];
	                var usedConstantNames = ts.createMap();
	                var i = 0;
	                for (var _i = 0, extractions_1 = extractions; _i < extractions_1.length; _i++) {
	                    var _a = extractions_1[_i], functionExtraction = _a.functionExtraction, constantExtraction = _a.constantExtraction;
	                    // Skip these since we don't have a way to report errors yet
	                    if (functionExtraction.errors.length === 0) {
	                        // Don't issue refactorings with duplicated names.
	                        // Scopes come back in "innermost first" order, so extractions will
	                        // preferentially go into nearer scopes
	                        var description = functionExtraction.description;
	                        if (!usedFunctionNames.has(description)) {
	                            usedFunctionNames.set(description, true);
	                            functionActions.push({
	                                description: description,
	                                name: "function_scope_" + i
	                            });
	                        }
	                    }
	                    // Skip these since we don't have a way to report errors yet
	                    if (constantExtraction.errors.length === 0) {
	                        // Don't issue refactorings with duplicated names.
	                        // Scopes come back in "innermost first" order, so extractions will
	                        // preferentially go into nearer scopes
	                        var description = constantExtraction.description;
	                        if (!usedConstantNames.has(description)) {
	                            usedConstantNames.set(description, true);
	                            constantActions.push({
	                                description: description,
	                                name: "constant_scope_" + i
	                            });
	                        }
	                    }
	                    // *do* increment i anyway because we'll look for the i-th scope
	                    // later when actually doing the refactoring if the user requests it
	                    i++;
	                }
	                var infos = [];
	                if (functionActions.length) {
	                    infos.push({
	                        name: refactorName,
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_function),
	                        actions: functionActions
	                    });
	                }
	                if (constantActions.length) {
	                    infos.push({
	                        name: refactorName,
	                        description: ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_constant),
	                        actions: constantActions
	                    });
	                }
	                return infos.length ? infos : undefined;
	            }
	            extractSymbol.getAvailableActions = getAvailableActions;
	            /* Exported for tests */
	            function getEditsForAction(context, actionName) {
	                var rangeToExtract = getRangeToExtract(context.file, ts.getRefactorContextSpan(context));
	                var targetRange = rangeToExtract.targetRange;
	                var parsedFunctionIndexMatch = /^function_scope_(\d+)$/.exec(actionName);
	                if (parsedFunctionIndexMatch) {
	                    var index = +parsedFunctionIndexMatch[1];
	                    ts.Debug.assert(isFinite(index), "Expected to parse a finite number from the function scope index");
	                    return getFunctionExtractionAtIndex(targetRange, context, index);
	                }
	                var parsedConstantIndexMatch = /^constant_scope_(\d+)$/.exec(actionName);
	                if (parsedConstantIndexMatch) {
	                    var index = +parsedConstantIndexMatch[1];
	                    ts.Debug.assert(isFinite(index), "Expected to parse a finite number from the constant scope index");
	                    return getConstantExtractionAtIndex(targetRange, context, index);
	                }
	                ts.Debug.fail("Unrecognized action name");
	            }
	            extractSymbol.getEditsForAction = getEditsForAction;
	            // Move these into diagnostic messages if they become user-facing
	            var Messages;
	            (function (Messages) {
	                function createMessage(message) {
	                    return { message: message, code: 0, category: ts.DiagnosticCategory.Message, key: message };
	                }
	                Messages.cannotExtractRange = createMessage("Cannot extract range.");
	                Messages.cannotExtractImport = createMessage("Cannot extract import statement.");
	                Messages.cannotExtractSuper = createMessage("Cannot extract super call.");
	                Messages.cannotExtractEmpty = createMessage("Cannot extract empty range.");
	                Messages.expressionExpected = createMessage("expression expected.");
	                Messages.uselessConstantType = createMessage("No reason to extract constant of type.");
	                Messages.statementOrExpressionExpected = createMessage("Statement or expression expected.");
	                Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements = createMessage("Cannot extract range containing conditional break or continue statements.");
	                Messages.cannotExtractRangeContainingConditionalReturnStatement = createMessage("Cannot extract range containing conditional return statement.");
	                Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange = createMessage("Cannot extract range containing labeled break or continue with target outside of the range.");
	                Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators = createMessage("Cannot extract range containing writes to references located outside of the target range in generators.");
	                Messages.typeWillNotBeVisibleInTheNewScope = createMessage("Type will not visible in the new scope.");
	                Messages.functionWillNotBeVisibleInTheNewScope = createMessage("Function will not visible in the new scope.");
	                Messages.cannotExtractIdentifier = createMessage("Select more than a single identifier.");
	                Messages.cannotExtractExportedEntity = createMessage("Cannot extract exported declaration");
	                Messages.cannotWriteInExpression = createMessage("Cannot write back side-effects when extracting an expression");
	                Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor = createMessage("Cannot move initialization of read-only class property outside of the constructor");
	                Messages.cannotExtractAmbientBlock = createMessage("Cannot extract code from ambient contexts");
	                Messages.cannotAccessVariablesFromNestedScopes = createMessage("Cannot access variables from nested scopes");
	                Messages.cannotExtractToOtherFunctionLike = createMessage("Cannot extract method to a function-like scope that is not a function");
	                Messages.cannotExtractToJSClass = createMessage("Cannot extract constant to a class scope in JS");
	                Messages.cannotExtractToExpressionArrowFunction = createMessage("Cannot extract constant to an arrow function without a block");
	            })(Messages = extractSymbol.Messages || (extractSymbol.Messages = {}));
	            var RangeFacts;
	            (function (RangeFacts) {
	                RangeFacts[RangeFacts["None"] = 0] = "None";
	                RangeFacts[RangeFacts["HasReturn"] = 1] = "HasReturn";
	                RangeFacts[RangeFacts["IsGenerator"] = 2] = "IsGenerator";
	                RangeFacts[RangeFacts["IsAsyncFunction"] = 4] = "IsAsyncFunction";
	                RangeFacts[RangeFacts["UsesThis"] = 8] = "UsesThis";
	                /**
	                 * The range is in a function which needs the 'static' modifier in a class
	                 */
	                RangeFacts[RangeFacts["InStaticRegion"] = 16] = "InStaticRegion";
	            })(RangeFacts || (RangeFacts = {}));
	            /**
	             * getRangeToExtract takes a span inside a text file and returns either an expression or an array
	             * of statements representing the minimum set of nodes needed to extract the entire span. This
	             * process may fail, in which case a set of errors is returned instead (these are currently
	             * not shown to the user, but can be used by us diagnostically)
	             */
	            // exported only for tests
	            function getRangeToExtract(sourceFile, span) {
	                var length = span.length;
	                if (length === 0) {
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractEmpty)] };
	                }
	                // Walk up starting from the the start position until we find a non-SourceFile node that subsumes the selected span.
	                // This may fail (e.g. you select two statements in the root of a source file)
	                var start = getParentNodeInSpan(ts.getTokenAtPosition(sourceFile, span.start, /*includeJsDocComment*/ false), sourceFile, span);
	                // Do the same for the ending position
	                var end = getParentNodeInSpan(ts.findTokenOnLeftOfPosition(sourceFile, ts.textSpanEnd(span)), sourceFile, span);
	                var declarations = [];
	                // We'll modify these flags as we walk the tree to collect data
	                // about what things need to be done as part of the extraction.
	                var rangeFacts = RangeFacts.None;
	                if (!start || !end) {
	                    // cannot find either start or end node
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                if (start.parent !== end.parent) {
	                    // start and end nodes belong to different subtrees
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                if (start !== end) {
	                    // start and end should be statements and parent should be either block or a source file
	                    if (!isBlockLike(start.parent)) {
	                        return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                    }
	                    var statements = [];
	                    for (var _i = 0, _a = start.parent.statements; _i < _a.length; _i++) {
	                        var statement = _a[_i];
	                        if (statement === start || statements.length) {
	                            var errors_1 = checkNode(statement);
	                            if (errors_1) {
	                                return { errors: errors_1 };
	                            }
	                            statements.push(statement);
	                        }
	                        if (statement === end) {
	                            break;
	                        }
	                    }
	                    if (!statements.length) {
	                        // https://github.com/Microsoft/TypeScript/issues/20559
	                        // Ranges like [|case 1: break;|] will fail to populate `statements` because
	                        // they will never find `start` in `start.parent.statements`.
	                        // Consider: We could support ranges like [|case 1:|] by refining them to just
	                        // the expression.
	                        return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                    }
	                    return { targetRange: { range: statements, facts: rangeFacts, declarations: declarations } };
	                }
	                if (ts.isReturnStatement(start) && !start.expression) {
	                    // Makes no sense to extract an expression-less return statement.
	                    return { errors: [ts.createFileDiagnostic(sourceFile, span.start, length, Messages.cannotExtractRange)] };
	                }
	                // We have a single node (start)
	                var node = refineNode(start);
	                var errors = checkRootNode(node) || checkNode(node);
	                if (errors) {
	                    return { errors: errors };
	                }
	                return { targetRange: { range: getStatementOrExpressionRange(node), facts: rangeFacts, declarations: declarations } };
	                /**
	                 * Attempt to refine the extraction node (generally, by shrinking it) to produce better results.
	                 * @param node The unrefined extraction node.
	                 */
	                function refineNode(node) {
	                    if (ts.isReturnStatement(node)) {
	                        if (node.expression) {
	                            return node.expression;
	                        }
	                    }
	                    else if (ts.isVariableStatement(node)) {
	                        var numInitializers = 0;
	                        var lastInitializer = void 0;
	                        for (var _i = 0, _a = node.declarationList.declarations; _i < _a.length; _i++) {
	                            var declaration = _a[_i];
	                            if (declaration.initializer) {
	                                numInitializers++;
	                                lastInitializer = declaration.initializer;
	                            }
	                        }
	                        if (numInitializers === 1) {
	                            return lastInitializer;
	                        }
	                        // No special handling if there are multiple initializers.
	                    }
	                    else if (ts.isVariableDeclaration(node)) {
	                        if (node.initializer) {
	                            return node.initializer;
	                        }
	                    }
	                    return node;
	                }
	                function checkRootNode(node) {
	                    if (ts.isIdentifier(ts.isExpressionStatement(node) ? node.expression : node)) {
	                        return [ts.createDiagnosticForNode(node, Messages.cannotExtractIdentifier)];
	                    }
	                    return undefined;
	                }
	                function checkForStaticContext(nodeToCheck, containingClass) {
	                    var current = nodeToCheck;
	                    while (current !== containingClass) {
	                        if (current.kind === 151 /* PropertyDeclaration */) {
	                            if (ts.hasModifier(current, 32 /* Static */)) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                            break;
	                        }
	                        else if (current.kind === 148 /* Parameter */) {
	                            var ctorOrMethod = ts.getContainingFunction(current);
	                            if (ctorOrMethod.kind === 154 /* Constructor */) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                            break;
	                        }
	                        else if (current.kind === 153 /* MethodDeclaration */) {
	                            if (ts.hasModifier(current, 32 /* Static */)) {
	                                rangeFacts |= RangeFacts.InStaticRegion;
	                            }
	                        }
	                        current = current.parent;
	                    }
	                }
	                // Verifies whether we can actually extract this node or not.
	                function checkNode(nodeToCheck) {
	                    var PermittedJumps;
	                    (function (PermittedJumps) {
	                        PermittedJumps[PermittedJumps["None"] = 0] = "None";
	                        PermittedJumps[PermittedJumps["Break"] = 1] = "Break";
	                        PermittedJumps[PermittedJumps["Continue"] = 2] = "Continue";
	                        PermittedJumps[PermittedJumps["Return"] = 4] = "Return";
	                    })(PermittedJumps || (PermittedJumps = {}));
	                    // We believe it's true because the node is from the (unmodified) tree.
	                    ts.Debug.assert(nodeToCheck.pos <= nodeToCheck.end, "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	                    // For understanding how skipTrivia functioned:
	                    ts.Debug.assert(!ts.positionIsSynthesized(nodeToCheck.pos), "This failure could trigger https://github.com/Microsoft/TypeScript/issues/20809");
	                    if (!ts.isStatement(nodeToCheck) && !(ts.isExpressionNode(nodeToCheck) && isExtractableExpression(nodeToCheck))) {
	                        return [ts.createDiagnosticForNode(nodeToCheck, Messages.statementOrExpressionExpected)];
	                    }
	                    if (nodeToCheck.flags & 4194304 /* Ambient */) {
	                        return [ts.createDiagnosticForNode(nodeToCheck, Messages.cannotExtractAmbientBlock)];
	                    }
	                    // If we're in a class, see whether we're in a static region (static property initializer, static method, class constructor parameter default)
	                    var containingClass = ts.getContainingClass(nodeToCheck);
	                    if (containingClass) {
	                        checkForStaticContext(nodeToCheck, containingClass);
	                    }
	                    var errors;
	                    var permittedJumps = 4 /* Return */;
	                    var seenLabels;
	                    visit(nodeToCheck);
	                    return errors;
	                    function visit(node) {
	                        if (errors) {
	                            // already found an error - can stop now
	                            return true;
	                        }
	                        if (ts.isDeclaration(node)) {
	                            var declaringNode = (node.kind === 231 /* VariableDeclaration */) ? node.parent.parent : node;
	                            if (ts.hasModifier(declaringNode, 1 /* Export */)) {
	                                (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractExportedEntity));
	                                return true;
	                            }
	                            declarations.push(node.symbol);
	                        }
	                        // Some things can't be extracted in certain situations
	                        switch (node.kind) {
	                            case 243 /* ImportDeclaration */:
	                                (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractImport));
	                                return true;
	                            case 97 /* SuperKeyword */:
	                                // For a super *constructor call*, we have to be extracting the entire class,
	                                // but a super *method call* simply implies a 'this' reference
	                                if (node.parent.kind === 186 /* CallExpression */) {
	                                    // Super constructor call
	                                    var containingClass_1 = ts.getContainingClass(node);
	                                    if (containingClass_1.pos < span.start || containingClass_1.end >= (span.start + span.length)) {
	                                        (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractSuper));
	                                        return true;
	                                    }
	                                }
	                                else {
	                                    rangeFacts |= RangeFacts.UsesThis;
	                                }
	                                break;
	                        }
	                        if (!node || ts.isFunctionLikeDeclaration(node) || ts.isClassLike(node)) {
	                            switch (node.kind) {
	                                case 233 /* FunctionDeclaration */:
	                                case 234 /* ClassDeclaration */:
	                                    if (ts.isSourceFile(node.parent) && node.parent.externalModuleIndicator === undefined) {
	                                        // You cannot extract global declarations
	                                        (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.functionWillNotBeVisibleInTheNewScope));
	                                    }
	                                    break;
	                            }
	                            // do not dive into functions or classes
	                            return false;
	                        }
	                        var savedPermittedJumps = permittedJumps;
	                        switch (node.kind) {
	                            case 216 /* IfStatement */:
	                                permittedJumps = 0 /* None */;
	                                break;
	                            case 229 /* TryStatement */:
	                                // forbid all jumps inside try blocks
	                                permittedJumps = 0 /* None */;
	                                break;
	                            case 212 /* Block */:
	                                if (node.parent && node.parent.kind === 229 /* TryStatement */ && node.parent.finallyBlock === node) {
	                                    // allow unconditional returns from finally blocks
	                                    permittedJumps = 4 /* Return */;
	                                }
	                                break;
	                            case 265 /* CaseClause */:
	                                // allow unlabeled break inside case clauses
	                                permittedJumps |= 1 /* Break */;
	                                break;
	                            default:
	                                if (ts.isIterationStatement(node, /*lookInLabeledStatements*/ false)) {
	                                    // allow unlabeled break/continue inside loops
	                                    permittedJumps |= 1 /* Break */ | 2 /* Continue */;
	                                }
	                                break;
	                        }
	                        switch (node.kind) {
	                            case 173 /* ThisType */:
	                            case 99 /* ThisKeyword */:
	                                rangeFacts |= RangeFacts.UsesThis;
	                                break;
	                            case 227 /* LabeledStatement */:
	                                {
	                                    var label = node.label;
	                                    (seenLabels || (seenLabels = [])).push(label.escapedText);
	                                    ts.forEachChild(node, visit);
	                                    seenLabels.pop();
	                                    break;
	                                }
	                            case 223 /* BreakStatement */:
	                            case 222 /* ContinueStatement */:
	                                {
	                                    var label = node.label;
	                                    if (label) {
	                                        if (!ts.contains(seenLabels, label.escapedText)) {
	                                            // attempts to jump to label that is not in range to be extracted
	                                            (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingLabeledBreakOrContinueStatementWithTargetOutsideOfTheRange));
	                                        }
	                                    }
	                                    else {
	                                        if (!(permittedJumps & (node.kind === 223 /* BreakStatement */ ? 1 /* Break */ : 2 /* Continue */))) {
	                                            // attempt to break or continue in a forbidden context
	                                            (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingConditionalBreakOrContinueStatements));
	                                        }
	                                    }
	                                    break;
	                                }
	                            case 196 /* AwaitExpression */:
	                                rangeFacts |= RangeFacts.IsAsyncFunction;
	                                break;
	                            case 202 /* YieldExpression */:
	                                rangeFacts |= RangeFacts.IsGenerator;
	                                break;
	                            case 224 /* ReturnStatement */:
	                                if (permittedJumps & 4 /* Return */) {
	                                    rangeFacts |= RangeFacts.HasReturn;
	                                }
	                                else {
	                                    (errors || (errors = [])).push(ts.createDiagnosticForNode(node, Messages.cannotExtractRangeContainingConditionalReturnStatement));
	                                }
	                                break;
	                            default:
	                                ts.forEachChild(node, visit);
	                                break;
	                        }
	                        permittedJumps = savedPermittedJumps;
	                    }
	                }
	            }
	            extractSymbol.getRangeToExtract = getRangeToExtract;
	            function getStatementOrExpressionRange(node) {
	                if (ts.isStatement(node)) {
	                    return [node];
	                }
	                else if (ts.isExpressionNode(node)) {
	                    // If our selection is the expression in an ExpressionStatement, expand
	                    // the selection to include the enclosing Statement (this stops us
	                    // from trying to care about the return value of the extracted function
	                    // and eliminates double semicolon insertion in certain scenarios)
	                    return ts.isExpressionStatement(node.parent) ? [node.parent] : node;
	                }
	                return undefined;
	            }
	            function isScope(node) {
	                return ts.isFunctionLikeDeclaration(node) || ts.isSourceFile(node) || ts.isModuleBlock(node) || ts.isClassLike(node);
	            }
	            /**
	             * Computes possible places we could extract the function into. For example,
	             * you may be able to extract into a class method *or* local closure *or* namespace function,
	             * depending on what's in the extracted body.
	             */
	            function collectEnclosingScopes(range) {
	                var current = isReadonlyArray(range.range) ? ts.first(range.range) : range.range;
	                if (range.facts & RangeFacts.UsesThis) {
	                    // if range uses this as keyword or as type inside the class then it can only be extracted to a method of the containing class
	                    var containingClass = ts.getContainingClass(current);
	                    if (containingClass) {
	                        var containingFunction = ts.findAncestor(current, ts.isFunctionLikeDeclaration);
	                        return containingFunction
	                            ? [containingFunction, containingClass]
	                            : [containingClass];
	                    }
	                }
	                var scopes = [];
	                while (true) {
	                    current = current.parent;
	                    // A function parameter's initializer is actually in the outer scope, not the function declaration
	                    if (current.kind === 148 /* Parameter */) {
	                        // Skip all the way to the outer scope of the function that declared this parameter
	                        current = ts.findAncestor(current, function (parent) { return ts.isFunctionLikeDeclaration(parent); }).parent;
	                    }
	                    // We want to find the nearest parent where we can place an "equivalent" sibling to the node we're extracting out of.
	                    // Walk up to the closest parent of a place where we can logically put a sibling:
	                    //  * Function declaration
	                    //  * Class declaration or expression
	                    //  * Module/namespace or source file
	                    if (isScope(current)) {
	                        scopes.push(current);
	                        if (current.kind === 273 /* SourceFile */) {
	                            return scopes;
	                        }
	                    }
	                }
	            }
	            function getFunctionExtractionAtIndex(targetRange, context, requestedChangesIndex) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, target = _b.target, usagesPerScope = _b.usagesPerScope, functionErrorsPerScope = _b.functionErrorsPerScope, exposedVariableDeclarations = _b.exposedVariableDeclarations;
	                ts.Debug.assert(!functionErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
	                context.cancellationToken.throwIfCancellationRequested();
	                return extractFunctionInScope(target, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], exposedVariableDeclarations, targetRange, context);
	            }
	            function getConstantExtractionAtIndex(targetRange, context, requestedChangesIndex) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, target = _b.target, usagesPerScope = _b.usagesPerScope, constantErrorsPerScope = _b.constantErrorsPerScope, exposedVariableDeclarations = _b.exposedVariableDeclarations;
	                ts.Debug.assert(!constantErrorsPerScope[requestedChangesIndex].length, "The extraction went missing? How?");
	                ts.Debug.assert(exposedVariableDeclarations.length === 0, "Extract constant accepted a range containing a variable declaration?");
	                context.cancellationToken.throwIfCancellationRequested();
	                var expression = ts.isExpression(target)
	                    ? target
	                    : target.statements[0].expression;
	                return extractConstantInScope(expression, scopes[requestedChangesIndex], usagesPerScope[requestedChangesIndex], targetRange.facts, context);
	            }
	            /**
	             * Given a piece of text to extract ('targetRange'), computes a list of possible extractions.
	             * Each returned ExtractResultForScope corresponds to a possible target scope and is either a set of changes
	             * or an error explaining why we can't extract into that scope.
	             */
	            function getPossibleExtractions(targetRange, context) {
	                var _a = getPossibleExtractionsWorker(targetRange, context), scopes = _a.scopes, _b = _a.readsAndWrites, functionErrorsPerScope = _b.functionErrorsPerScope, constantErrorsPerScope = _b.constantErrorsPerScope;
	                // Need the inner type annotation to avoid https://github.com/Microsoft/TypeScript/issues/7547
	                var extractions = scopes.map(function (scope, i) {
	                    var functionDescriptionPart = getDescriptionForFunctionInScope(scope);
	                    var constantDescriptionPart = getDescriptionForConstantInScope(scope);
	                    var scopeDescription = ts.isFunctionLikeDeclaration(scope)
	                        ? getDescriptionForFunctionLikeDeclaration(scope)
	                        : ts.isClassLike(scope)
	                            ? getDescriptionForClassLikeDeclaration(scope)
	                            : getDescriptionForModuleLikeDeclaration(scope);
	                    var functionDescription;
	                    var constantDescription;
	                    if (scopeDescription === 1 /* Global */) {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [functionDescriptionPart, "global"]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [constantDescriptionPart, "global"]);
	                    }
	                    else if (scopeDescription === 0 /* Module */) {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [functionDescriptionPart, "module"]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1_scope), [constantDescriptionPart, "module"]);
	                    }
	                    else {
	                        functionDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1), [functionDescriptionPart, scopeDescription]);
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_1), [constantDescriptionPart, scopeDescription]);
	                    }
	                    // Customize the phrasing for the innermost scope to increase clarity.
	                    if (i === 0 && !ts.isClassLike(scope)) {
	                        constantDescription = ts.formatStringFromArgs(ts.getLocaleSpecificMessage(ts.Diagnostics.Extract_to_0_in_enclosing_scope), [constantDescriptionPart]);
	                    }
	                    return {
	                        functionExtraction: {
	                            description: functionDescription,
	                            errors: functionErrorsPerScope[i],
	                        },
	                        constantExtraction: {
	                            description: constantDescription,
	                            errors: constantErrorsPerScope[i],
	                        },
	                    };
	                });
	                return extractions;
	            }
	            function getPossibleExtractionsWorker(targetRange, context) {
	                var sourceFile = context.file;
	                var scopes = collectEnclosingScopes(targetRange);
	                var enclosingTextRange = getEnclosingTextRange(targetRange, sourceFile);
	                var readsAndWrites = collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, context.program.getTypeChecker(), context.cancellationToken);
	                return { scopes: scopes, readsAndWrites: readsAndWrites };
	            }
	            function getDescriptionForFunctionInScope(scope) {
	                return ts.isFunctionLikeDeclaration(scope)
	                    ? "inner function"
	                    : ts.isClassLike(scope)
	                        ? "method"
	                        : "function";
	            }
	            function getDescriptionForConstantInScope(scope) {
	                return ts.isClassLike(scope)
	                    ? "readonly field"
	                    : "constant";
	            }
	            function getDescriptionForFunctionLikeDeclaration(scope) {
	                switch (scope.kind) {
	                    case 154 /* Constructor */:
	                        return "constructor";
	                    case 191 /* FunctionExpression */:
	                    case 233 /* FunctionDeclaration */:
	                        return scope.name
	                            ? "function '" + scope.name.text + "'"
	                            : "anonymous function";
	                    case 192 /* ArrowFunction */:
	                        return "arrow function";
	                    case 153 /* MethodDeclaration */:
	                        return "method '" + scope.name.getText();
	                    case 155 /* GetAccessor */:
	                        return "'get " + scope.name.getText() + "'";
	                    case 156 /* SetAccessor */:
	                        return "'set " + scope.name.getText() + "'";
	                    default:
	                        ts.Debug.assertNever(scope);
	                }
	            }
	            function getDescriptionForClassLikeDeclaration(scope) {
	                return scope.kind === 234 /* ClassDeclaration */
	                    ? scope.name ? "class '" + scope.name.text + "'" : "anonymous class declaration"
	                    : scope.name ? "class expression '" + scope.name.text + "'" : "anonymous class expression";
	            }
	            function getDescriptionForModuleLikeDeclaration(scope) {
	                return scope.kind === 239 /* ModuleBlock */
	                    ? "namespace '" + scope.parent.name.getText() + "'"
	                    : scope.externalModuleIndicator ? 0 /* Module */ : 1 /* Global */;
	            }
	            var SpecialScope;
	            (function (SpecialScope) {
	                SpecialScope[SpecialScope["Module"] = 0] = "Module";
	                SpecialScope[SpecialScope["Global"] = 1] = "Global";
	            })(SpecialScope || (SpecialScope = {}));
	            /**
	             * Result of 'extractRange' operation for a specific scope.
	             * Stores either a list of changes that should be applied to extract a range or a list of errors
	             */
	            function extractFunctionInScope(node, scope, _a, exposedVariableDeclarations, range, context) {
	                var usagesInScope = _a.usages, typeParameterUsages = _a.typeParameterUsages, substitutions = _a.substitutions;
	                var checker = context.program.getTypeChecker();
	                // Make a unique name for the extracted function
	                var file = scope.getSourceFile();
	                var functionNameText = ts.getUniqueName(ts.isClassLike(scope) ? "newMethod" : "newFunction", file);
	                var isJS = ts.isInJavaScriptFile(scope);
	                var functionName = ts.createIdentifier(functionNameText);
	                var returnType;
	                var parameters = [];
	                var callArguments = [];
	                var writes;
	                usagesInScope.forEach(function (usage, name) {
	                    var typeNode;
	                    if (!isJS) {
	                        var type = checker.getTypeOfSymbolAtLocation(usage.symbol, usage.node);
	                        // Widen the type so we don't emit nonsense annotations like "function fn(x: 3) {"
	                        type = checker.getBaseTypeOfLiteralType(type);
	                        typeNode = checker.typeToTypeNode(type, scope, 1 /* NoTruncation */);
	                    }
	                    var paramDecl = ts.createParameter(
	                    /*decorators*/ undefined, 
	                    /*modifiers*/ undefined, 
	                    /*dotDotDotToken*/ undefined, 
	                    /*name*/ name, 
	                    /*questionToken*/ undefined, typeNode);
	                    parameters.push(paramDecl);
	                    if (usage.usage === 2 /* Write */) {
	                        (writes || (writes = [])).push(usage);
	                    }
	                    callArguments.push(ts.createIdentifier(name));
	                });
	                var typeParametersAndDeclarations = ts.arrayFrom(typeParameterUsages.values()).map(function (type) { return ({ type: type, declaration: getFirstDeclaration(type) }); });
	                var sortedTypeParametersAndDeclarations = typeParametersAndDeclarations.sort(compareTypesByDeclarationOrder);
	                var typeParameters = sortedTypeParametersAndDeclarations.length === 0
	                    ? undefined
	                    : sortedTypeParametersAndDeclarations.map(function (t) { return t.declaration; });
	                // Strictly speaking, we should check whether each name actually binds to the appropriate type
	                // parameter.  In cases of shadowing, they may not.
	                var callTypeArguments = typeParameters !== undefined
	                    ? typeParameters.map(function (decl) { return ts.createTypeReferenceNode(decl.name, /*typeArguments*/ undefined); })
	                    : undefined;
	                // Provide explicit return types for contextually-typed functions
	                // to avoid problems when there are literal types present
	                if (ts.isExpression(node) && !isJS) {
	                    var contextualType = checker.getContextualType(node);
	                    returnType = checker.typeToTypeNode(contextualType, scope, 1 /* NoTruncation */);
	                }
	                var _b = transformFunctionBody(node, exposedVariableDeclarations, writes, substitutions, !!(range.facts & RangeFacts.HasReturn)), body = _b.body, returnValueProperty = _b.returnValueProperty;
	                ts.suppressLeadingAndTrailingTrivia(body);
	                var newFunction;
	                if (ts.isClassLike(scope)) {
	                    // always create private method in TypeScript files
	                    var modifiers = isJS ? [] : [ts.createToken(112 /* PrivateKeyword */)];
	                    if (range.facts & RangeFacts.InStaticRegion) {
	                        modifiers.push(ts.createToken(115 /* StaticKeyword */));
	                    }
	                    if (range.facts & RangeFacts.IsAsyncFunction) {
	                        modifiers.push(ts.createToken(120 /* AsyncKeyword */));
	                    }
	                    newFunction = ts.createMethod(
	                    /*decorators*/ undefined, modifiers.length ? modifiers : undefined, range.facts & RangeFacts.IsGenerator ? ts.createToken(39 /* AsteriskToken */) : undefined, functionName, 
	                    /*questionToken*/ undefined, typeParameters, parameters, returnType, body);
	                }
	                else {
	                    newFunction = ts.createFunctionDeclaration(
	                    /*decorators*/ undefined, range.facts & RangeFacts.IsAsyncFunction ? [ts.createToken(120 /* AsyncKeyword */)] : undefined, range.facts & RangeFacts.IsGenerator ? ts.createToken(39 /* AsteriskToken */) : undefined, functionName, typeParameters, parameters, returnType, body);
	                }
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var minInsertionPos = (isReadonlyArray(range.range) ? ts.last(range.range) : range.range).end;
	                var nodeToInsertBefore = getNodeToInsertFunctionBefore(minInsertionPos, scope);
	                if (nodeToInsertBefore) {
	                    changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newFunction, /*blankLineBetween*/ true);
	                }
	                else {
	                    changeTracker.insertNodeAtEndOfScope(context.file, scope, newFunction);
	                }
	                var newNodes = [];
	                // replace range with function call
	                var called = getCalledExpression(scope, range, functionNameText);
	                var call = ts.createCall(called, callTypeArguments, // Note that no attempt is made to take advantage of type argument inference
	                callArguments);
	                if (range.facts & RangeFacts.IsGenerator) {
	                    call = ts.createYield(ts.createToken(39 /* AsteriskToken */), call);
	                }
	                if (range.facts & RangeFacts.IsAsyncFunction) {
	                    call = ts.createAwait(call);
	                }
	                if (exposedVariableDeclarations.length && !writes) {
	                    // No need to mix declarations and writes.
	                    // How could any variables be exposed if there's a return statement?
	                    ts.Debug.assert(!returnValueProperty);
	                    ts.Debug.assert(!(range.facts & RangeFacts.HasReturn));
	                    if (exposedVariableDeclarations.length === 1) {
	                        // Declaring exactly one variable: let x = newFunction();
	                        var variableDeclaration = exposedVariableDeclarations[0];
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(ts.getSynthesizedDeepClone(variableDeclaration.name), /*type*/ ts.getSynthesizedDeepClone(variableDeclaration.type), /*initializer*/ call)], // TODO (acasey): test binding patterns
	                        variableDeclaration.parent.flags)));
	                    }
	                    else {
	                        // Declaring multiple variables / return properties:
	                        //   let {x, y} = newFunction();
	                        var bindingElements = [];
	                        var typeElements = [];
	                        var commonNodeFlags = exposedVariableDeclarations[0].parent.flags;
	                        var sawExplicitType = false;
	                        for (var _i = 0, exposedVariableDeclarations_1 = exposedVariableDeclarations; _i < exposedVariableDeclarations_1.length; _i++) {
	                            var variableDeclaration = exposedVariableDeclarations_1[_i];
	                            bindingElements.push(ts.createBindingElement(
	                            /*dotDotDotToken*/ undefined, 
	                            /*propertyName*/ undefined, 
	                            /*name*/ ts.getSynthesizedDeepClone(variableDeclaration.name)));
	                            // Being returned through an object literal will have widened the type.
	                            var variableType = checker.typeToTypeNode(checker.getBaseTypeOfLiteralType(checker.getTypeAtLocation(variableDeclaration)), scope, 1 /* NoTruncation */);
	                            typeElements.push(ts.createPropertySignature(
	                            /*modifiers*/ undefined, 
	                            /*name*/ variableDeclaration.symbol.name, 
	                            /*questionToken*/ undefined, 
	                            /*type*/ variableType, 
	                            /*initializer*/ undefined));
	                            sawExplicitType = sawExplicitType || variableDeclaration.type !== undefined;
	                            commonNodeFlags = commonNodeFlags & variableDeclaration.parent.flags;
	                        }
	                        var typeLiteral = sawExplicitType ? ts.createTypeLiteralNode(typeElements) : undefined;
	                        if (typeLiteral) {
	                            ts.setEmitFlags(typeLiteral, 1 /* SingleLine */);
	                        }
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(ts.createObjectBindingPattern(bindingElements), 
	                            /*type*/ typeLiteral, 
	                            /*initializer*/ call)], commonNodeFlags)));
	                    }
	                }
	                else if (exposedVariableDeclarations.length || writes) {
	                    if (exposedVariableDeclarations.length) {
	                        // CONSIDER: we're going to create one statement per variable, but we could actually preserve their original grouping.
	                        for (var _c = 0, exposedVariableDeclarations_2 = exposedVariableDeclarations; _c < exposedVariableDeclarations_2.length; _c++) {
	                            var variableDeclaration = exposedVariableDeclarations_2[_c];
	                            var flags = variableDeclaration.parent.flags;
	                            if (flags & 2 /* Const */) {
	                                flags = (flags & ~2 /* Const */) | 1 /* Let */;
	                            }
	                            newNodes.push(ts.createVariableStatement(
	                            /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(variableDeclaration.symbol.name, getTypeDeepCloneUnionUndefined(variableDeclaration.type))], flags)));
	                        }
	                    }
	                    if (returnValueProperty) {
	                        // has both writes and return, need to create variable declaration to hold return value;
	                        newNodes.push(ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(returnValueProperty, getTypeDeepCloneUnionUndefined(returnType))], 1 /* Let */)));
	                    }
	                    var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                    if (returnValueProperty) {
	                        assignments.unshift(ts.createShorthandPropertyAssignment(returnValueProperty));
	                    }
	                    // propagate writes back
	                    if (assignments.length === 1) {
	                        // We would only have introduced a return value property if there had been
	                        // other assignments to make.
	                        ts.Debug.assert(!returnValueProperty);
	                        newNodes.push(ts.createStatement(ts.createAssignment(assignments[0].name, call)));
	                        if (range.facts & RangeFacts.HasReturn) {
	                            newNodes.push(ts.createReturn());
	                        }
	                    }
	                    else {
	                        // emit e.g.
	                        //   { a, b, __return } = newFunction(a, b);
	                        //   return __return;
	                        newNodes.push(ts.createStatement(ts.createAssignment(ts.createObjectLiteral(assignments), call)));
	                        if (returnValueProperty) {
	                            newNodes.push(ts.createReturn(ts.createIdentifier(returnValueProperty)));
	                        }
	                    }
	                }
	                else {
	                    if (range.facts & RangeFacts.HasReturn) {
	                        newNodes.push(ts.createReturn(call));
	                    }
	                    else if (isReadonlyArray(range.range)) {
	                        newNodes.push(ts.createStatement(call));
	                    }
	                    else {
	                        newNodes.push(call);
	                    }
	                }
	                if (isReadonlyArray(range.range)) {
	                    changeTracker.replaceNodeRangeWithNodes(context.file, ts.first(range.range), ts.last(range.range), newNodes);
	                }
	                else {
	                    changeTracker.replaceNodeWithNodes(context.file, range.range, newNodes);
	                }
	                var edits = changeTracker.getChanges();
	                var renameRange = isReadonlyArray(range.range) ? ts.first(range.range) : range.range;
	                var renameFilename = renameRange.getSourceFile().fileName;
	                var renameLocation = ts.getRenameLocation(edits, renameFilename, functionNameText, /*isDeclaredBeforeUse*/ false);
	                return { renameFilename: renameFilename, renameLocation: renameLocation, edits: edits };
	                function getTypeDeepCloneUnionUndefined(typeNode) {
	                    if (typeNode === undefined) {
	                        return undefined;
	                    }
	                    var clone = ts.getSynthesizedDeepClone(typeNode);
	                    var withoutParens = clone;
	                    while (ts.isParenthesizedTypeNode(withoutParens)) {
	                        withoutParens = withoutParens.type;
	                    }
	                    return ts.isUnionTypeNode(withoutParens) && ts.find(withoutParens.types, function (t) { return t.kind === 140 /* UndefinedKeyword */; })
	                        ? clone
	                        : ts.createUnionTypeNode([clone, ts.createKeywordTypeNode(140 /* UndefinedKeyword */)]);
	                }
	            }
	            /**
	             * Result of 'extractRange' operation for a specific scope.
	             * Stores either a list of changes that should be applied to extract a range or a list of errors
	             */
	            function extractConstantInScope(node, scope, _a, rangeFacts, context) {
	                var substitutions = _a.substitutions;
	                var checker = context.program.getTypeChecker();
	                // Make a unique name for the extracted variable
	                var file = scope.getSourceFile();
	                var localNameText = ts.getUniqueName(ts.isClassLike(scope) ? "newProperty" : "newLocal", file);
	                var isJS = ts.isInJavaScriptFile(scope);
	                var variableType = isJS || !checker.isContextSensitive(node)
	                    ? undefined
	                    : checker.typeToTypeNode(checker.getContextualType(node), scope, 1 /* NoTruncation */);
	                var initializer = transformConstantInitializer(node, substitutions);
	                ts.suppressLeadingAndTrailingTrivia(initializer);
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                if (ts.isClassLike(scope)) {
	                    ts.Debug.assert(!isJS); // See CannotExtractToJSClass
	                    var modifiers = [];
	                    modifiers.push(ts.createToken(112 /* PrivateKeyword */));
	                    if (rangeFacts & RangeFacts.InStaticRegion) {
	                        modifiers.push(ts.createToken(115 /* StaticKeyword */));
	                    }
	                    modifiers.push(ts.createToken(132 /* ReadonlyKeyword */));
	                    var newVariable = ts.createProperty(
	                    /*decorators*/ undefined, modifiers, localNameText, 
	                    /*questionToken*/ undefined, variableType, initializer);
	                    var localReference = ts.createPropertyAccess(rangeFacts & RangeFacts.InStaticRegion
	                        ? ts.createIdentifier(scope.name.getText())
	                        : ts.createThis(), ts.createIdentifier(localNameText));
	                    // Declare
	                    var maxInsertionPos = node.pos;
	                    var nodeToInsertBefore = getNodeToInsertPropertyBefore(maxInsertionPos, scope);
	                    changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariable, /*blankLineBetween*/ true);
	                    // Consume
	                    changeTracker.replaceNode(context.file, node, localReference);
	                }
	                else {
	                    var newVariableDeclaration = ts.createVariableDeclaration(localNameText, variableType, initializer);
	                    // If the node is part of an initializer in a list of variable declarations, insert a new
	                    // variable declaration into the list (in case it depends on earlier ones).
	                    // CONSIDER: If the declaration list isn't const, we might want to split it into multiple
	                    // lists so that the newly extracted one can be const.
	                    var oldVariableDeclaration = getContainingVariableDeclarationIfInList(node, scope);
	                    if (oldVariableDeclaration) {
	                        // Declare
	                        // CONSIDER: could detect that each is on a separate line (See `extractConstant_VariableList_MultipleLines` in `extractConstants.ts`)
	                        changeTracker.insertNodeBefore(context.file, oldVariableDeclaration, newVariableDeclaration);
	                        // Consume
	                        var localReference = ts.createIdentifier(localNameText);
	                        changeTracker.replaceNode(context.file, node, localReference);
	                    }
	                    else if (node.parent.kind === 215 /* ExpressionStatement */ && scope === ts.findAncestor(node, isScope)) {
	                        // If the parent is an expression statement and the target scope is the immediately enclosing one,
	                        // replace the statement with the declaration.
	                        var newVariableStatement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([newVariableDeclaration], 2 /* Const */));
	                        changeTracker.replaceNode(context.file, node.parent, newVariableStatement);
	                    }
	                    else {
	                        var newVariableStatement = ts.createVariableStatement(
	                        /*modifiers*/ undefined, ts.createVariableDeclarationList([newVariableDeclaration], 2 /* Const */));
	                        // Declare
	                        var nodeToInsertBefore = getNodeToInsertConstantBefore(node, scope);
	                        if (nodeToInsertBefore.pos === 0) {
	                            changeTracker.insertNodeAtTopOfFile(context.file, newVariableStatement, /*blankLineBetween*/ false);
	                        }
	                        else {
	                            changeTracker.insertNodeBefore(context.file, nodeToInsertBefore, newVariableStatement, /*blankLineBetween*/ false);
	                        }
	                        // Consume
	                        if (node.parent.kind === 215 /* ExpressionStatement */) {
	                            // If the parent is an expression statement, delete it.
	                            changeTracker.deleteNode(context.file, node.parent, ts.textChanges.useNonAdjustedPositions);
	                        }
	                        else {
	                            var localReference = ts.createIdentifier(localNameText);
	                            changeTracker.replaceNode(context.file, node, localReference);
	                        }
	                    }
	                }
	                var edits = changeTracker.getChanges();
	                var renameFilename = node.getSourceFile().fileName;
	                var renameLocation = ts.getRenameLocation(edits, renameFilename, localNameText, /*isDeclaredBeforeUse*/ true);
	                return { renameFilename: renameFilename, renameLocation: renameLocation, edits: edits };
	            }
	            function getContainingVariableDeclarationIfInList(node, scope) {
	                var prevNode;
	                while (node !== undefined && node !== scope) {
	                    if (ts.isVariableDeclaration(node) &&
	                        node.initializer === prevNode &&
	                        ts.isVariableDeclarationList(node.parent) &&
	                        node.parent.declarations.length > 1) {
	                        return node;
	                    }
	                    prevNode = node;
	                    node = node.parent;
	                }
	            }
	            function getFirstDeclaration(type) {
	                var firstDeclaration;
	                var symbol = type.symbol;
	                if (symbol && symbol.declarations) {
	                    for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                        var declaration = _a[_i];
	                        if (firstDeclaration === undefined || declaration.pos < firstDeclaration.pos) {
	                            firstDeclaration = declaration;
	                        }
	                    }
	                }
	                return firstDeclaration;
	            }
	            function compareTypesByDeclarationOrder(_a, _b) {
	                var type1 = _a.type, declaration1 = _a.declaration;
	                var type2 = _b.type, declaration2 = _b.declaration;
	                return ts.compareProperties(declaration1, declaration2, "pos", ts.compareValues)
	                    || ts.compareStringsCaseSensitive(type1.symbol ? type1.symbol.getName() : "", type2.symbol ? type2.symbol.getName() : "")
	                    || ts.compareValues(type1.id, type2.id);
	            }
	            function getCalledExpression(scope, range, functionNameText) {
	                var functionReference = ts.createIdentifier(functionNameText);
	                if (ts.isClassLike(scope)) {
	                    var lhs = range.facts & RangeFacts.InStaticRegion ? ts.createIdentifier(scope.name.text) : ts.createThis();
	                    return ts.createPropertyAccess(lhs, functionReference);
	                }
	                else {
	                    return functionReference;
	                }
	            }
	            function transformFunctionBody(body, exposedVariableDeclarations, writes, substitutions, hasReturn) {
	                var hasWritesOrVariableDeclarations = writes !== undefined || exposedVariableDeclarations.length > 0;
	                if (ts.isBlock(body) && !hasWritesOrVariableDeclarations && substitutions.size === 0) {
	                    // already block, no declarations or writes to propagate back, no substitutions - can use node as is
	                    return { body: ts.createBlock(body.statements, /*multLine*/ true), returnValueProperty: undefined };
	                }
	                var returnValueProperty;
	                var ignoreReturns = false;
	                var statements = ts.createNodeArray(ts.isBlock(body) ? body.statements.slice(0) : [ts.isStatement(body) ? body : ts.createReturn(body)]);
	                // rewrite body if either there are writes that should be propagated back via return statements or there are substitutions
	                if (hasWritesOrVariableDeclarations || substitutions.size) {
	                    var rewrittenStatements = ts.visitNodes(statements, visitor).slice();
	                    if (hasWritesOrVariableDeclarations && !hasReturn && ts.isStatement(body)) {
	                        // add return at the end to propagate writes back in case if control flow falls out of the function body
	                        // it is ok to know that range has at least one return since it we only allow unconditional returns
	                        var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                        if (assignments.length === 1) {
	                            rewrittenStatements.push(ts.createReturn(assignments[0].name));
	                        }
	                        else {
	                            rewrittenStatements.push(ts.createReturn(ts.createObjectLiteral(assignments)));
	                        }
	                    }
	                    return { body: ts.createBlock(rewrittenStatements, /*multiLine*/ true), returnValueProperty: returnValueProperty };
	                }
	                else {
	                    return { body: ts.createBlock(statements, /*multiLine*/ true), returnValueProperty: undefined };
	                }
	                function visitor(node) {
	                    if (!ignoreReturns && node.kind === 224 /* ReturnStatement */ && hasWritesOrVariableDeclarations) {
	                        var assignments = getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes);
	                        if (node.expression) {
	                            if (!returnValueProperty) {
	                                returnValueProperty = "__return";
	                            }
	                            assignments.unshift(ts.createPropertyAssignment(returnValueProperty, ts.visitNode(node.expression, visitor)));
	                        }
	                        if (assignments.length === 1) {
	                            return ts.createReturn(assignments[0].name);
	                        }
	                        else {
	                            return ts.createReturn(ts.createObjectLiteral(assignments));
	                        }
	                    }
	                    else {
	                        var oldIgnoreReturns = ignoreReturns;
	                        ignoreReturns = ignoreReturns || ts.isFunctionLikeDeclaration(node) || ts.isClassLike(node);
	                        var substitution = substitutions.get(ts.getNodeId(node).toString());
	                        var result = substitution ? ts.getSynthesizedDeepClone(substitution) : ts.visitEachChild(node, visitor, ts.nullTransformationContext);
	                        ignoreReturns = oldIgnoreReturns;
	                        return result;
	                    }
	                }
	            }
	            function transformConstantInitializer(initializer, substitutions) {
	                return substitutions.size
	                    ? visitor(initializer)
	                    : initializer;
	                function visitor(node) {
	                    var substitution = substitutions.get(ts.getNodeId(node).toString());
	                    return substitution ? ts.getSynthesizedDeepClone(substitution) : ts.visitEachChild(node, visitor, ts.nullTransformationContext);
	                }
	            }
	            function getStatementsOrClassElements(scope) {
	                if (ts.isFunctionLikeDeclaration(scope)) {
	                    var body = scope.body;
	                    if (ts.isBlock(body)) {
	                        return body.statements;
	                    }
	                }
	                else if (ts.isModuleBlock(scope) || ts.isSourceFile(scope)) {
	                    return scope.statements;
	                }
	                else if (ts.isClassLike(scope)) {
	                    return scope.members;
	                }
	                else {
	                    ts.assertTypeIsNever(scope);
	                }
	                return ts.emptyArray;
	            }
	            /**
	             * If `scope` contains a function after `minPos`, then return the first such function.
	             * Otherwise, return `undefined`.
	             */
	            function getNodeToInsertFunctionBefore(minPos, scope) {
	                return ts.find(getStatementsOrClassElements(scope), function (child) {
	                    return child.pos >= minPos && ts.isFunctionLikeDeclaration(child) && !ts.isConstructorDeclaration(child);
	                });
	            }
	            function getNodeToInsertPropertyBefore(maxPos, scope) {
	                var members = scope.members;
	                ts.Debug.assert(members.length > 0); // There must be at least one child, since we extracted from one.
	                var prevMember;
	                var allProperties = true;
	                for (var _i = 0, members_7 = members; _i < members_7.length; _i++) {
	                    var member = members_7[_i];
	                    if (member.pos > maxPos) {
	                        return prevMember || members[0];
	                    }
	                    if (allProperties && !ts.isPropertyDeclaration(member)) {
	                        // If it is non-vacuously true that all preceding members are properties,
	                        // insert before the current member (i.e. at the end of the list of properties).
	                        if (prevMember !== undefined) {
	                            return member;
	                        }
	                        allProperties = false;
	                    }
	                    prevMember = member;
	                }
	                ts.Debug.assert(prevMember !== undefined); // If the loop didn't return, then it did set prevMember.
	                return prevMember;
	            }
	            function getNodeToInsertConstantBefore(node, scope) {
	                ts.Debug.assert(!ts.isClassLike(scope));
	                var prevScope;
	                for (var curr = node; curr !== scope; curr = curr.parent) {
	                    if (isScope(curr)) {
	                        prevScope = curr;
	                    }
	                }
	                for (var curr = (prevScope || node).parent;; curr = curr.parent) {
	                    if (isBlockLike(curr)) {
	                        var prevStatement = void 0;
	                        for (var _i = 0, _a = curr.statements; _i < _a.length; _i++) {
	                            var statement = _a[_i];
	                            if (statement.pos > node.pos) {
	                                break;
	                            }
	                            prevStatement = statement;
	                        }
	                        if (!prevStatement && ts.isCaseClause(curr)) {
	                            // We must have been in the expression of the case clause.
	                            ts.Debug.assert(ts.isSwitchStatement(curr.parent.parent));
	                            return curr.parent.parent;
	                        }
	                        // There must be at least one statement since we started in one.
	                        ts.Debug.assert(prevStatement !== undefined);
	                        return prevStatement;
	                    }
	                    if (curr === scope) {
	                        ts.Debug.fail("Didn't encounter a block-like before encountering scope");
	                        break;
	                    }
	                }
	            }
	            function getPropertyAssignmentsForWritesAndVariableDeclarations(exposedVariableDeclarations, writes) {
	                var variableAssignments = ts.map(exposedVariableDeclarations, function (v) { return ts.createShorthandPropertyAssignment(v.symbol.name); });
	                var writeAssignments = ts.map(writes, function (w) { return ts.createShorthandPropertyAssignment(w.symbol.name); });
	                return variableAssignments === undefined
	                    ? writeAssignments
	                    : writeAssignments === undefined
	                        ? variableAssignments
	                        : variableAssignments.concat(writeAssignments);
	            }
	            function isReadonlyArray(v) {
	                return ts.isArray(v);
	            }
	            /**
	             * Produces a range that spans the entirety of nodes, given a selection
	             * that might start/end in the middle of nodes.
	             *
	             * For example, when the user makes a selection like this
	             *                     v---v
	             *   var someThing = foo + bar;
	             *  this returns     ^-------^
	             */
	            function getEnclosingTextRange(targetRange, sourceFile) {
	                return isReadonlyArray(targetRange.range)
	                    ? { pos: ts.first(targetRange.range).getStart(sourceFile), end: ts.last(targetRange.range).getEnd() }
	                    : targetRange.range;
	            }
	            var Usage;
	            (function (Usage) {
	                // value should be passed to extracted method
	                Usage[Usage["Read"] = 1] = "Read";
	                // value should be passed to extracted method and propagated back
	                Usage[Usage["Write"] = 2] = "Write";
	            })(Usage || (Usage = {}));
	            function collectReadsAndWrites(targetRange, scopes, enclosingTextRange, sourceFile, checker, cancellationToken) {
	                var allTypeParameterUsages = ts.createMap(); // Key is type ID
	                var usagesPerScope = [];
	                var substitutionsPerScope = [];
	                var functionErrorsPerScope = [];
	                var constantErrorsPerScope = [];
	                var visibleDeclarationsInExtractedRange = [];
	                var exposedVariableSymbolSet = ts.createMap(); // Key is symbol ID
	                var exposedVariableDeclarations = [];
	                var firstExposedNonVariableDeclaration;
	                var expression = !isReadonlyArray(targetRange.range)
	                    ? targetRange.range
	                    : targetRange.range.length === 1 && ts.isExpressionStatement(targetRange.range[0])
	                        ? targetRange.range[0].expression
	                        : undefined;
	                var expressionDiagnostic;
	                if (expression === undefined) {
	                    var statements = targetRange.range;
	                    var start = ts.first(statements).getStart();
	                    var end = ts.last(statements).end;
	                    expressionDiagnostic = ts.createFileDiagnostic(sourceFile, start, end - start, Messages.expressionExpected);
	                }
	                else if (checker.getTypeAtLocation(expression).flags & (2048 /* Void */ | 16384 /* Never */)) {
	                    expressionDiagnostic = ts.createDiagnosticForNode(expression, Messages.uselessConstantType);
	                }
	                // initialize results
	                for (var _i = 0, scopes_1 = scopes; _i < scopes_1.length; _i++) {
	                    var scope = scopes_1[_i];
	                    usagesPerScope.push({ usages: ts.createMap(), typeParameterUsages: ts.createMap(), substitutions: ts.createMap() });
	                    substitutionsPerScope.push(ts.createMap());
	                    functionErrorsPerScope.push(ts.isFunctionLikeDeclaration(scope) && scope.kind !== 233 /* FunctionDeclaration */
	                        ? [ts.createDiagnosticForNode(scope, Messages.cannotExtractToOtherFunctionLike)]
	                        : []);
	                    var constantErrors = [];
	                    if (expressionDiagnostic) {
	                        constantErrors.push(expressionDiagnostic);
	                    }
	                    if (ts.isClassLike(scope) && ts.isInJavaScriptFile(scope)) {
	                        constantErrors.push(ts.createDiagnosticForNode(scope, Messages.cannotExtractToJSClass));
	                    }
	                    if (ts.isArrowFunction(scope) && !ts.isBlock(scope.body)) {
	                        // TODO (https://github.com/Microsoft/TypeScript/issues/18924): allow this
	                        constantErrors.push(ts.createDiagnosticForNode(scope, Messages.cannotExtractToExpressionArrowFunction));
	                    }
	                    constantErrorsPerScope.push(constantErrors);
	                }
	                var seenUsages = ts.createMap();
	                var target = isReadonlyArray(targetRange.range) ? ts.createBlock(targetRange.range) : targetRange.range;
	                var unmodifiedNode = isReadonlyArray(targetRange.range) ? ts.first(targetRange.range) : targetRange.range;
	                var inGenericContext = isInGenericContext(unmodifiedNode);
	                collectUsages(target);
	                // Unfortunately, this code takes advantage of the knowledge that the generated method
	                // will use the contextual type of an expression as the return type of the extracted
	                // method (and will therefore "use" all the types involved).
	                if (inGenericContext && !isReadonlyArray(targetRange.range)) {
	                    var contextualType = checker.getContextualType(targetRange.range);
	                    recordTypeParameterUsages(contextualType);
	                }
	                if (allTypeParameterUsages.size > 0) {
	                    var seenTypeParameterUsages = ts.createMap(); // Key is type ID
	                    var i_1 = 0;
	                    for (var curr = unmodifiedNode; curr !== undefined && i_1 < scopes.length; curr = curr.parent) {
	                        if (curr === scopes[i_1]) {
	                            // Copy current contents of seenTypeParameterUsages into scope.
	                            seenTypeParameterUsages.forEach(function (typeParameter, id) {
	                                usagesPerScope[i_1].typeParameterUsages.set(id, typeParameter);
	                            });
	                            i_1++;
	                        }
	                        // Note that we add the current node's type parameters *after* updating the corresponding scope.
	                        if (ts.isDeclarationWithTypeParameters(curr)) {
	                            for (var _a = 0, _b = ts.getEffectiveTypeParameterDeclarations(curr); _a < _b.length; _a++) {
	                                var typeParameterDecl = _b[_a];
	                                var typeParameter = checker.getTypeAtLocation(typeParameterDecl);
	                                if (allTypeParameterUsages.has(typeParameter.id.toString())) {
	                                    seenTypeParameterUsages.set(typeParameter.id.toString(), typeParameter);
	                                }
	                            }
	                        }
	                    }
	                    // If we didn't get through all the scopes, then there were some that weren't in our
	                    // parent chain (impossible at time of writing).  A conservative solution would be to
	                    // copy allTypeParameterUsages into all remaining scopes.
	                    ts.Debug.assert(i_1 === scopes.length);
	                }
	                // If there are any declarations in the extracted block that are used in the same enclosing
	                // lexical scope, we can't move the extraction "up" as those declarations will become unreachable
	                if (visibleDeclarationsInExtractedRange.length) {
	                    var containingLexicalScopeOfExtraction = ts.isBlockScope(scopes[0], scopes[0].parent)
	                        ? scopes[0]
	                        : ts.getEnclosingBlockScopeContainer(scopes[0]);
	                    ts.forEachChild(containingLexicalScopeOfExtraction, checkForUsedDeclarations);
	                }
	                var _loop_20 = function (i) {
	                    var scopeUsages = usagesPerScope[i];
	                    // Special case: in the innermost scope, all usages are available.
	                    // (The computed value reflects the value at the top-level of the scope, but the
	                    // local will actually be declared at the same level as the extracted expression).
	                    if (i > 0 && (scopeUsages.usages.size > 0 || scopeUsages.typeParameterUsages.size > 0)) {
	                        var errorNode = isReadonlyArray(targetRange.range) ? targetRange.range[0] : targetRange.range;
	                        constantErrorsPerScope[i].push(ts.createDiagnosticForNode(errorNode, Messages.cannotAccessVariablesFromNestedScopes));
	                    }
	                    var hasWrite = false;
	                    var readonlyClassPropertyWrite;
	                    usagesPerScope[i].usages.forEach(function (value) {
	                        if (value.usage === 2 /* Write */) {
	                            hasWrite = true;
	                            if (value.symbol.flags & 106500 /* ClassMember */ &&
	                                value.symbol.valueDeclaration &&
	                                ts.hasModifier(value.symbol.valueDeclaration, 64 /* Readonly */)) {
	                                readonlyClassPropertyWrite = value.symbol.valueDeclaration;
	                            }
	                        }
	                    });
	                    // If an expression was extracted, then there shouldn't have been any variable declarations.
	                    ts.Debug.assert(isReadonlyArray(targetRange.range) || exposedVariableDeclarations.length === 0);
	                    if (hasWrite && !isReadonlyArray(targetRange.range)) {
	                        var diag = ts.createDiagnosticForNode(targetRange.range, Messages.cannotWriteInExpression);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                    else if (readonlyClassPropertyWrite && i > 0) {
	                        var diag = ts.createDiagnosticForNode(readonlyClassPropertyWrite, Messages.cannotExtractReadonlyPropertyInitializerOutsideConstructor);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                    else if (firstExposedNonVariableDeclaration) {
	                        var diag = ts.createDiagnosticForNode(firstExposedNonVariableDeclaration, Messages.cannotExtractExportedEntity);
	                        functionErrorsPerScope[i].push(diag);
	                        constantErrorsPerScope[i].push(diag);
	                    }
	                };
	                for (var i = 0; i < scopes.length; i++) {
	                    _loop_20(i);
	                }
	                return { target: target, usagesPerScope: usagesPerScope, functionErrorsPerScope: functionErrorsPerScope, constantErrorsPerScope: constantErrorsPerScope, exposedVariableDeclarations: exposedVariableDeclarations };
	                function isInGenericContext(node) {
	                    return !!ts.findAncestor(node, function (n) { return ts.isDeclarationWithTypeParameters(n) && ts.getEffectiveTypeParameterDeclarations(n).length !== 0; });
	                }
	                function recordTypeParameterUsages(type) {
	                    // PERF: This is potentially very expensive.  `type` could be a library type with
	                    // a lot of properties, each of which the walker will visit.  Unfortunately, the
	                    // solution isn't as trivial as filtering to user types because of (e.g.) Array.
	                    var symbolWalker = checker.getSymbolWalker(function () { return (cancellationToken.throwIfCancellationRequested(), true); });
	                    var visitedTypes = symbolWalker.walkType(type).visitedTypes;
	                    for (var _i = 0, visitedTypes_1 = visitedTypes; _i < visitedTypes_1.length; _i++) {
	                        var visitedType = visitedTypes_1[_i];
	                        if (visitedType.isTypeParameter()) {
	                            allTypeParameterUsages.set(visitedType.id.toString(), visitedType);
	                        }
	                    }
	                }
	                function collectUsages(node, valueUsage) {
	                    if (valueUsage === void 0) { valueUsage = 1 /* Read */; }
	                    if (inGenericContext) {
	                        var type = checker.getTypeAtLocation(node);
	                        recordTypeParameterUsages(type);
	                    }
	                    if (ts.isDeclaration(node) && node.symbol) {
	                        visibleDeclarationsInExtractedRange.push(node);
	                    }
	                    if (ts.isAssignmentExpression(node)) {
	                        // use 'write' as default usage for values
	                        collectUsages(node.left, 2 /* Write */);
	                        collectUsages(node.right);
	                    }
	                    else if (ts.isUnaryExpressionWithWrite(node)) {
	                        collectUsages(node.operand, 2 /* Write */);
	                    }
	                    else if (ts.isPropertyAccessExpression(node) || ts.isElementAccessExpression(node)) {
	                        // use 'write' as default usage for values
	                        ts.forEachChild(node, collectUsages);
	                    }
	                    else if (ts.isIdentifier(node)) {
	                        if (!node.parent) {
	                            return;
	                        }
	                        if (ts.isQualifiedName(node.parent) && node !== node.parent.left) {
	                            return;
	                        }
	                        if (ts.isPropertyAccessExpression(node.parent) && node !== node.parent.expression) {
	                            return;
	                        }
	                        recordUsage(node, valueUsage, /*isTypeNode*/ ts.isPartOfTypeNode(node));
	                    }
	                    else {
	                        ts.forEachChild(node, collectUsages);
	                    }
	                }
	                function recordUsage(n, usage, isTypeNode) {
	                    var symbolId = recordUsagebySymbol(n, usage, isTypeNode);
	                    if (symbolId) {
	                        for (var i = 0; i < scopes.length; i++) {
	                            // push substitution from map<symbolId, subst> to map<nodeId, subst> to simplify rewriting
	                            var substitution = substitutionsPerScope[i].get(symbolId);
	                            if (substitution) {
	                                usagesPerScope[i].substitutions.set(ts.getNodeId(n).toString(), substitution);
	                            }
	                        }
	                    }
	                }
	                function recordUsagebySymbol(identifier, usage, isTypeName) {
	                    var symbol = getSymbolReferencedByIdentifier(identifier);
	                    if (!symbol) {
	                        // cannot find symbol - do nothing
	                        return undefined;
	                    }
	                    var symbolId = ts.getSymbolId(symbol).toString();
	                    var lastUsage = seenUsages.get(symbolId);
	                    // there are two kinds of value usages
	                    // - reads - if range contains a read from the value located outside of the range then value should be passed as a parameter
	                    // - writes - if range contains a write to a value located outside the range the value should be passed as a parameter and
	                    //   returned as a return value
	                    // 'write' case is a superset of 'read' so if we already have processed 'write' of some symbol there is not need to handle 'read'
	                    // since all information is already recorded
	                    if (lastUsage && lastUsage >= usage) {
	                        return symbolId;
	                    }
	                    seenUsages.set(symbolId, usage);
	                    if (lastUsage) {
	                        // if we get here this means that we are trying to handle 'write' and 'read' was already processed
	                        // walk scopes and update existing records.
	                        for (var _i = 0, usagesPerScope_1 = usagesPerScope; _i < usagesPerScope_1.length; _i++) {
	                            var perScope = usagesPerScope_1[_i];
	                            var prevEntry = perScope.usages.get(identifier.text);
	                            if (prevEntry) {
	                                perScope.usages.set(identifier.text, { usage: usage, symbol: symbol, node: identifier });
	                            }
	                        }
	                        return symbolId;
	                    }
	                    // find first declaration in this file
	                    var decls = symbol.getDeclarations();
	                    var declInFile = decls && ts.find(decls, function (d) { return d.getSourceFile() === sourceFile; });
	                    if (!declInFile) {
	                        return undefined;
	                    }
	                    if (ts.rangeContainsStartEnd(enclosingTextRange, declInFile.getStart(), declInFile.end)) {
	                        // declaration is located in range to be extracted - do nothing
	                        return undefined;
	                    }
	                    if (targetRange.facts & RangeFacts.IsGenerator && usage === 2 /* Write */) {
	                        // this is write to a reference located outside of the target scope and range is extracted into generator
	                        // currently this is unsupported scenario
	                        var diag = ts.createDiagnosticForNode(identifier, Messages.cannotExtractRangeThatContainsWritesToReferencesLocatedOutsideOfTheTargetRangeInGenerators);
	                        for (var _a = 0, functionErrorsPerScope_1 = functionErrorsPerScope; _a < functionErrorsPerScope_1.length; _a++) {
	                            var errors = functionErrorsPerScope_1[_a];
	                            errors.push(diag);
	                        }
	                        for (var _b = 0, constantErrorsPerScope_1 = constantErrorsPerScope; _b < constantErrorsPerScope_1.length; _b++) {
	                            var errors = constantErrorsPerScope_1[_b];
	                            errors.push(diag);
	                        }
	                    }
	                    for (var i = 0; i < scopes.length; i++) {
	                        var scope = scopes[i];
	                        var resolvedSymbol = checker.resolveName(symbol.name, scope, symbol.flags, /*excludeGlobals*/ false);
	                        if (resolvedSymbol === symbol) {
	                            continue;
	                        }
	                        if (!substitutionsPerScope[i].has(symbolId)) {
	                            var substitution = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.exportSymbol || symbol, scope, isTypeName);
	                            if (substitution) {
	                                substitutionsPerScope[i].set(symbolId, substitution);
	                            }
	                            else if (isTypeName) {
	                                // If the symbol is a type parameter that won't be in scope, we'll pass it as a type argument
	                                // so there's no problem.
	                                if (!(symbol.flags & 262144 /* TypeParameter */)) {
	                                    var diag = ts.createDiagnosticForNode(identifier, Messages.typeWillNotBeVisibleInTheNewScope);
	                                    functionErrorsPerScope[i].push(diag);
	                                    constantErrorsPerScope[i].push(diag);
	                                }
	                            }
	                            else {
	                                usagesPerScope[i].usages.set(identifier.text, { usage: usage, symbol: symbol, node: identifier });
	                            }
	                        }
	                    }
	                    return symbolId;
	                }
	                function checkForUsedDeclarations(node) {
	                    // If this node is entirely within the original extraction range, we don't need to do anything.
	                    if (node === targetRange.range || (isReadonlyArray(targetRange.range) && targetRange.range.indexOf(node) >= 0)) {
	                        return;
	                    }
	                    // Otherwise check and recurse.
	                    var sym = ts.isIdentifier(node)
	                        ? getSymbolReferencedByIdentifier(node)
	                        : checker.getSymbolAtLocation(node);
	                    if (sym) {
	                        var decl = ts.find(visibleDeclarationsInExtractedRange, function (d) { return d.symbol === sym; });
	                        if (decl) {
	                            if (ts.isVariableDeclaration(decl)) {
	                                var idString = decl.symbol.id.toString();
	                                if (!exposedVariableSymbolSet.has(idString)) {
	                                    exposedVariableDeclarations.push(decl);
	                                    exposedVariableSymbolSet.set(idString, true);
	                                }
	                            }
	                            else {
	                                // CONSIDER: this includes binding elements, which we could
	                                // expose in the same way as variables.
	                                firstExposedNonVariableDeclaration = firstExposedNonVariableDeclaration || decl;
	                            }
	                        }
	                    }
	                    ts.forEachChild(node, checkForUsedDeclarations);
	                }
	                /**
	                 * Return the symbol referenced by an identifier (even if it declares a different symbol).
	                 */
	                function getSymbolReferencedByIdentifier(identifier) {
	                    // If the identifier is both a property name and its value, we're only interested in its value
	                    // (since the name is a declaration and will be included in the extracted range).
	                    return identifier.parent && ts.isShorthandPropertyAssignment(identifier.parent) && identifier.parent.name === identifier
	                        ? checker.getShorthandAssignmentValueSymbol(identifier.parent)
	                        : checker.getSymbolAtLocation(identifier);
	                }
	                function tryReplaceWithQualifiedNameOrPropertyAccess(symbol, scopeDecl, isTypeNode) {
	                    if (!symbol) {
	                        return undefined;
	                    }
	                    var decls = symbol.getDeclarations();
	                    if (decls && decls.some(function (d) { return d.parent === scopeDecl; })) {
	                        return ts.createIdentifier(symbol.name);
	                    }
	                    var prefix = tryReplaceWithQualifiedNameOrPropertyAccess(symbol.parent, scopeDecl, isTypeNode);
	                    if (prefix === undefined) {
	                        return undefined;
	                    }
	                    return isTypeNode
	                        ? ts.createQualifiedName(prefix, ts.createIdentifier(symbol.name))
	                        : ts.createPropertyAccess(prefix, symbol.name);
	                }
	            }
	            function getParentNodeInSpan(node, file, span) {
	                if (!node)
	                    return undefined;
	                while (node.parent) {
	                    if (ts.isSourceFile(node.parent) || !spanContainsNode(span, node.parent, file)) {
	                        return node;
	                    }
	                    node = node.parent;
	                }
	            }
	            function spanContainsNode(span, node, file) {
	                return ts.textSpanContainsPosition(span, node.getStart(file)) &&
	                    node.getEnd() <= ts.textSpanEnd(span);
	            }
	            /**
	             * Computes whether or not a node represents an expression in a position where it could
	             * be extracted.
	             * The isExpression() in utilities.ts returns some false positives we need to handle,
	             * such as `import x from 'y'` -- the 'y' is a StringLiteral but is *not* an expression
	             * in the sense of something that you could extract on
	             */
	            function isExtractableExpression(node) {
	                switch (node.parent.kind) {
	                    case 272 /* EnumMember */:
	                        return false;
	                }
	                switch (node.kind) {
	                    case 9 /* StringLiteral */:
	                        return node.parent.kind !== 243 /* ImportDeclaration */ &&
	                            node.parent.kind !== 247 /* ImportSpecifier */;
	                    case 203 /* SpreadElement */:
	                    case 179 /* ObjectBindingPattern */:
	                    case 181 /* BindingElement */:
	                        return false;
	                    case 71 /* Identifier */:
	                        return node.parent.kind !== 181 /* BindingElement */ &&
	                            node.parent.kind !== 247 /* ImportSpecifier */ &&
	                            node.parent.kind !== 251 /* ExportSpecifier */;
	                }
	                return true;
	            }
	            function isBlockLike(node) {
	                switch (node.kind) {
	                    case 212 /* Block */:
	                    case 273 /* SourceFile */:
	                    case 239 /* ModuleBlock */:
	                    case 265 /* CaseClause */:
	                        return true;
	                    default:
	                        return false;
	                }
	            }
	        })(extractSymbol = refactor.extractSymbol || (refactor.extractSymbol = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var generateGetAccessorAndSetAccessor;
	        (function (generateGetAccessorAndSetAccessor) {
	            var actionName = "Generate 'get' and 'set' accessors";
	            var actionDescription = ts.Diagnostics.Generate_get_and_set_accessors.message;
	            refactor.registerRefactor(actionName, { getEditsForAction: getEditsForAction, getAvailableActions: getAvailableActions });
	            function getAvailableActions(context) {
	                var file = context.file;
	                if (!getConvertibleFieldAtPosition(context, file))
	                    return undefined;
	                return [{
	                        name: actionName,
	                        description: actionDescription,
	                        actions: [
	                            {
	                                name: actionName,
	                                description: actionDescription
	                            }
	                        ]
	                    }];
	            }
	            function getEditsForAction(context, _actionName) {
	                var file = context.file;
	                var fieldInfo = getConvertibleFieldAtPosition(context, file);
	                if (!fieldInfo)
	                    return undefined;
	                var isJS = ts.isSourceFileJavaScript(file);
	                var changeTracker = ts.textChanges.ChangeTracker.fromContext(context);
	                var isStatic = fieldInfo.isStatic, isReadonly = fieldInfo.isReadonly, fieldName = fieldInfo.fieldName, accessorName = fieldInfo.accessorName, originalName = fieldInfo.originalName, type = fieldInfo.type, container = fieldInfo.container, declaration = fieldInfo.declaration, renameAccessor = fieldInfo.renameAccessor;
	                ts.suppressLeadingAndTrailingTrivia(fieldName);
	                ts.suppressLeadingAndTrailingTrivia(declaration);
	                ts.suppressLeadingAndTrailingTrivia(container);
	                var isInClassLike = ts.isClassLike(container);
	                // avoid Readonly modifier because it will convert to get accessor
	                var modifierFlags = ts.getModifierFlags(declaration) & ~64 /* Readonly */;
	                var accessorModifiers = isInClassLike
	                    ? !modifierFlags || modifierFlags & 8 /* Private */
	                        ? getModifiers(isJS, isStatic, 114 /* PublicKeyword */)
	                        : ts.createNodeArray(ts.createModifiersFromModifierFlags(modifierFlags))
	                    : undefined;
	                var fieldModifiers = isInClassLike ? getModifiers(isJS, isStatic, 112 /* PrivateKeyword */) : undefined;
	                updateFieldDeclaration(changeTracker, file, declaration, fieldName, fieldModifiers);
	                var getAccessor = generateGetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic, container);
	                ts.suppressLeadingAndTrailingTrivia(getAccessor);
	                insertAccessor(changeTracker, file, getAccessor, declaration, container);
	                if (isReadonly) {
	                    // readonly modifier only existed in classLikeDeclaration
	                    var constructor = ts.getFirstConstructorWithBody(container);
	                    if (constructor) {
	                        updateReadonlyPropertyInitializerStatementConstructor(changeTracker, context, constructor, fieldName, originalName);
	                    }
	                }
	                else {
	                    var setAccessor = generateSetAccessor(fieldName, accessorName, type, accessorModifiers, isStatic, container);
	                    ts.suppressLeadingAndTrailingTrivia(setAccessor);
	                    insertAccessor(changeTracker, file, setAccessor, declaration, container);
	                }
	                var edits = changeTracker.getChanges();
	                var renameFilename = file.fileName;
	                var nameNeedRename = renameAccessor ? accessorName : fieldName;
	                var renameLocationOffset = ts.isIdentifier(nameNeedRename) ? 0 : -1;
	                var renameLocation = renameLocationOffset + ts.getRenameLocation(edits, renameFilename, nameNeedRename.text, /*preferLastLocation*/ ts.isParameter(declaration));
	                return { renameFilename: renameFilename, renameLocation: renameLocation, edits: edits };
	            }
	            function isConvertableName(name) {
	                return ts.isIdentifier(name) || ts.isStringLiteral(name);
	            }
	            function isAcceptedDeclaration(node) {
	                return ts.isParameterPropertyDeclaration(node) || ts.isPropertyDeclaration(node) || ts.isPropertyAssignment(node);
	            }
	            function createPropertyName(name, originalName) {
	                return ts.isIdentifier(originalName) ? ts.createIdentifier(name) : ts.createLiteral(name);
	            }
	            function createAccessorAccessExpression(fieldName, isStatic, container) {
	                var leftHead = isStatic ? container.name : ts.createThis();
	                return ts.isIdentifier(fieldName) ? ts.createPropertyAccess(leftHead, fieldName) : ts.createElementAccess(leftHead, ts.createLiteral(fieldName));
	            }
	            function getModifiers(isJS, isStatic, accessModifier) {
	                var modifiers = ts.append(!isJS ? [ts.createToken(accessModifier)] : undefined, isStatic ? ts.createToken(115 /* StaticKeyword */) : undefined);
	                return modifiers && ts.createNodeArray(modifiers);
	            }
	            function startsWithUnderscore(name) {
	                return name.charCodeAt(0) === 95 /* _ */;
	            }
	            function getConvertibleFieldAtPosition(context, file) {
	                var startPosition = context.startPosition, endPosition = context.endPosition;
	                var node = ts.getTokenAtPosition(file, startPosition, /*includeJsDocComment*/ false);
	                var declaration = ts.findAncestor(node.parent, isAcceptedDeclaration);
	                // make sure declaration have AccessibilityModifier or Static Modifier or Readonly Modifier
	                var meaning = 28 /* AccessibilityModifier */ | 32 /* Static */ | 64 /* Readonly */;
	                if (!declaration || !ts.rangeOverlapsWithStartEnd(declaration.name, startPosition, endPosition)
	                    || !isConvertableName(declaration.name) || (ts.getModifierFlags(declaration) | meaning) !== meaning)
	                    return undefined;
	                var name = declaration.name.text;
	                var startWithUnderscore = startsWithUnderscore(name);
	                var fieldName = createPropertyName(startWithUnderscore ? name : ts.getUniqueName("_" + name, file), declaration.name);
	                var accessorName = createPropertyName(startWithUnderscore ? ts.getUniqueName(name.substring(1), file) : name, declaration.name);
	                return {
	                    isStatic: ts.hasStaticModifier(declaration),
	                    isReadonly: ts.hasReadonlyModifier(declaration),
	                    type: ts.getTypeAnnotationNode(declaration),
	                    container: declaration.kind === 148 /* Parameter */ ? declaration.parent.parent : declaration.parent,
	                    originalName: declaration.name,
	                    declaration: declaration,
	                    fieldName: fieldName,
	                    accessorName: accessorName,
	                    renameAccessor: startWithUnderscore
	                };
	            }
	            function generateGetAccessor(fieldName, accessorName, type, modifiers, isStatic, container) {
	                return ts.createGetAccessor(
	                /*decorators*/ undefined, modifiers, accessorName, 
	                /*parameters*/ undefined, type, ts.createBlock([
	                    ts.createReturn(createAccessorAccessExpression(fieldName, isStatic, container))
	                ], /*multiLine*/ true));
	            }
	            function generateSetAccessor(fieldName, accessorName, type, modifiers, isStatic, container) {
	                return ts.createSetAccessor(
	                /*decorators*/ undefined, modifiers, accessorName, [ts.createParameter(
	                    /*decorators*/ undefined, 
	                    /*modifiers*/ undefined, 
	                    /*dotDotDotToken*/ undefined, ts.createIdentifier("value"), 
	                    /*questionToken*/ undefined, type)], ts.createBlock([
	                    ts.createStatement(ts.createAssignment(createAccessorAccessExpression(fieldName, isStatic, container), ts.createIdentifier("value")))
	                ], /*multiLine*/ true));
	            }
	            function updatePropertyDeclaration(changeTracker, file, declaration, fieldName, modifiers) {
	                var property = ts.updateProperty(declaration, declaration.decorators, modifiers, fieldName, declaration.questionToken || declaration.exclamationToken, declaration.type, declaration.initializer);
	                changeTracker.replaceNode(file, declaration, property);
	            }
	            function updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName) {
	                var assignment = ts.updatePropertyAssignment(declaration, fieldName, declaration.initializer);
	                changeTracker.replacePropertyAssignment(file, declaration, assignment);
	            }
	            function updateFieldDeclaration(changeTracker, file, declaration, fieldName, modifiers) {
	                if (ts.isPropertyDeclaration(declaration)) {
	                    updatePropertyDeclaration(changeTracker, file, declaration, fieldName, modifiers);
	                }
	                else if (ts.isPropertyAssignment(declaration)) {
	                    updatePropertyAssignmentDeclaration(changeTracker, file, declaration, fieldName);
	                }
	                else {
	                    changeTracker.replaceNode(file, declaration, ts.updateParameter(declaration, declaration.decorators, modifiers, declaration.dotDotDotToken, ts.cast(fieldName, ts.isIdentifier), declaration.questionToken, declaration.type, declaration.initializer));
	                }
	            }
	            function insertAccessor(changeTracker, file, accessor, declaration, container) {
	                ts.isParameterPropertyDeclaration(declaration)
	                    ? changeTracker.insertNodeAtClassStart(file, container, accessor)
	                    : ts.isPropertyAssignment(declaration)
	                        ? changeTracker.insertNodeAfterComma(file, declaration, accessor)
	                        : changeTracker.insertNodeAfter(file, declaration, accessor);
	            }
	            function updateReadonlyPropertyInitializerStatementConstructor(changeTracker, context, constructor, fieldName, originalName) {
	                if (!constructor.body)
	                    return;
	                var file = context.file, program = context.program, cancellationToken = context.cancellationToken;
	                var referenceEntries = ts.mapDefined(ts.FindAllReferences.getReferenceEntriesForNode(originalName.parent.pos, originalName, program, [file], cancellationToken), function (entry) { return ((entry.type === "node" && ts.rangeContainsRange(constructor, entry.node) && ts.isIdentifier(entry.node) && ts.isWriteAccess(entry.node)) ? entry.node : undefined); });
	                ts.forEach(referenceEntries, function (entry) {
	                    var parent = entry.parent;
	                    var accessorName = ts.createIdentifier(fieldName.text);
	                    var node = ts.isBinaryExpression(parent)
	                        ? ts.updateBinary(parent, accessorName, parent.right, parent.operatorToken)
	                        : ts.isPropertyAccessExpression(parent)
	                            ? ts.updatePropertyAccess(parent, parent.expression, accessorName)
	                            : ts.Debug.fail("Unexpected write access token");
	                    changeTracker.replaceNode(file, parent, node);
	                });
	            }
	        })(generateGetAccessorAndSetAccessor = refactor.generateGetAccessorAndSetAccessor || (refactor.generateGetAccessorAndSetAccessor = {}));
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var refactor;
	    (function (refactor) {
	        var refactorName = "Move to a new file";
	        refactor.registerRefactor(refactorName, {
	            getAvailableActions: function (context) {
	                if (!context.preferences.allowTextChangesInNewFiles || getStatementsToMove(context) === undefined)
	                    return undefined;
	                var description = ts.getLocaleSpecificMessage(ts.Diagnostics.Move_to_a_new_file);
	                return [{ name: refactorName, description: description, actions: [{ name: refactorName, description: description }] }];
	            },
	            getEditsForAction: function (context, actionName) {
	                ts.Debug.assert(actionName === refactorName);
	                var statements = ts.Debug.assertDefined(getStatementsToMove(context));
	                var edits = ts.textChanges.ChangeTracker.with(context, function (t) { return doChange(context.file, context.program, statements, t, context.host, context.preferences); });
	                return { edits: edits, renameFilename: undefined, renameLocation: undefined };
	            }
	        });
	        function getRangeToMove(context) {
	            var file = context.file;
	            var range = ts.createTextRangeFromSpan(ts.getRefactorContextSpan(context));
	            var statements = file.statements;
	            var startNodeIndex = ts.findIndex(statements, function (s) { return s.end > range.pos; });
	            if (startNodeIndex === -1)
	                return undefined;
	            var startStatement = statements[startNodeIndex];
	            if (ts.isNamedDeclaration(startStatement) && startStatement.name && ts.rangeContainsRange(startStatement.name, range)) {
	                return { toMove: [statements[startNodeIndex]], afterLast: statements[startNodeIndex + 1] };
	            }
	            // Can't only partially include the start node or be partially into the next node
	            if (range.pos > startStatement.getStart(file))
	                return undefined;
	            var afterEndNodeIndex = ts.findIndex(statements, function (s) { return s.end > range.end; }, startNodeIndex);
	            // Can't be partially into the next node
	            if (afterEndNodeIndex !== -1 && (afterEndNodeIndex === 0 || statements[afterEndNodeIndex].getStart(file) < range.end))
	                return undefined;
	            return {
	                toMove: statements.slice(startNodeIndex, afterEndNodeIndex === -1 ? statements.length : afterEndNodeIndex),
	                afterLast: afterEndNodeIndex === -1 ? undefined : statements[afterEndNodeIndex],
	            };
	        }
	        function doChange(oldFile, program, toMove, changes, host, preferences) {
	            var checker = program.getTypeChecker();
	            var usage = getUsageInfo(oldFile, toMove.all, checker);
	            var currentDirectory = ts.getDirectoryPath(oldFile.fileName);
	            var extension = ts.extensionFromPath(oldFile.fileName);
	            var newModuleName = makeUniqueModuleName(getNewModuleName(usage.movedSymbols), extension, currentDirectory, host);
	            var newFileNameWithExtension = newModuleName + extension;
	            // If previous file was global, this is easy.
	            changes.createNewFile(oldFile, ts.combinePaths(currentDirectory, newFileNameWithExtension), getNewStatementsAndRemoveFromOldFile(oldFile, usage, changes, toMove, program, newModuleName, preferences));
	            addNewFileToTsconfig(program, changes, oldFile.fileName, newFileNameWithExtension, ts.hostGetCanonicalFileName(host));
	        }
	        // Filters imports out of the range of statements to move. Imports will be copied to the new file anyway, and may still be needed in the old file.
	        function getStatementsToMove(context) {
	            var rangeToMove = getRangeToMove(context);
	            if (rangeToMove === undefined)
	                return undefined;
	            var all = [];
	            var ranges = [];
	            var toMove = rangeToMove.toMove, afterLast = rangeToMove.afterLast;
	            ts.getRangesWhere(toMove, function (s) { return !isPureImport(s); }, function (start, afterEndIndex) {
	                for (var i = start; i < afterEndIndex; i++)
	                    all.push(toMove[i]);
	                ranges.push({ first: toMove[start], afterLast: afterLast });
	            });
	            return all.length === 0 ? undefined : { all: all, ranges: ranges };
	        }
	        function isPureImport(node) {
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return true;
	                case 242 /* ImportEqualsDeclaration */:
	                    return !ts.hasModifier(node, 1 /* Export */);
	                case 213 /* VariableStatement */:
	                    return node.declarationList.declarations.every(function (d) { return d.initializer && ts.isRequireCall(d.initializer, /*checkArgumentIsStringLiteralLike*/ true); });
	                default:
	                    return false;
	            }
	        }
	        function addNewFileToTsconfig(program, changes, oldFileName, newFileNameWithExtension, getCanonicalFileName) {
	            var cfg = program.getCompilerOptions().configFile;
	            if (!cfg)
	                return;
	            var newFileAbsolutePath = ts.normalizePath(ts.combinePaths(oldFileName, "..", newFileNameWithExtension));
	            var newFilePath = ts.getRelativePathFromFile(cfg.fileName, newFileAbsolutePath, getCanonicalFileName);
	            var cfgObject = cfg.statements[0] && ts.tryCast(cfg.statements[0].expression, ts.isObjectLiteralExpression);
	            var filesProp = cfgObject && ts.find(cfgObject.properties, function (prop) {
	                return ts.isPropertyAssignment(prop) && ts.isStringLiteral(prop.name) && prop.name.text === "files";
	            });
	            if (filesProp && ts.isArrayLiteralExpression(filesProp.initializer)) {
	                changes.insertNodeInListAfter(cfg, ts.last(filesProp.initializer.elements), ts.createLiteral(newFilePath), filesProp.initializer.elements);
	            }
	        }
	        function getNewStatementsAndRemoveFromOldFile(oldFile, usage, changes, toMove, program, newModuleName, preferences) {
	            var checker = program.getTypeChecker();
	            if (!oldFile.externalModuleIndicator && !oldFile.commonJsModuleIndicator) {
	                deleteMovedStatements(oldFile, toMove.ranges, changes);
	                return toMove.all;
	            }
	            var useEs6ModuleSyntax = !!oldFile.externalModuleIndicator;
	            var quotePreference = ts.getQuotePreference(oldFile, preferences);
	            var importsFromNewFile = createOldFileImportsFromNewFile(usage.oldFileImportsFromNewFile, newModuleName, useEs6ModuleSyntax, quotePreference);
	            if (importsFromNewFile) {
	                changes.insertNodeBefore(oldFile, oldFile.statements[0], importsFromNewFile, /*blankLineBetween*/ true);
	            }
	            deleteUnusedOldImports(oldFile, toMove.all, changes, usage.unusedImportsFromOldFile, checker);
	            deleteMovedStatements(oldFile, toMove.ranges, changes);
	            updateImportsInOtherFiles(changes, program, oldFile, usage.movedSymbols, newModuleName);
	            return getNewFileImportsAndAddExportInOldFile(oldFile, usage.oldImportsNeededByNewFile, usage.newFileImportsFromOldFile, changes, checker, useEs6ModuleSyntax, quotePreference).concat(addExports(oldFile, toMove.all, usage.oldFileImportsFromNewFile, useEs6ModuleSyntax));
	        }
	        function deleteMovedStatements(sourceFile, moved, changes) {
	            for (var _i = 0, moved_1 = moved; _i < moved_1.length; _i++) {
	                var _a = moved_1[_i], first_1 = _a.first, afterLast = _a.afterLast;
	                changes.deleteNodeRangeExcludingEnd(sourceFile, first_1, afterLast);
	            }
	        }
	        function deleteUnusedOldImports(oldFile, toMove, changes, toDelete, checker) {
	            for (var _i = 0, _a = oldFile.statements; _i < _a.length; _i++) {
	                var statement = _a[_i];
	                if (ts.contains(toMove, statement))
	                    continue;
	                forEachImportInStatement(statement, function (i) { return deleteUnusedImports(oldFile, i, changes, function (name) { return toDelete.has(checker.getSymbolAtLocation(name)); }); });
	            }
	        }
	        function updateImportsInOtherFiles(changes, program, oldFile, movedSymbols, newModuleName) {
	            var checker = program.getTypeChecker();
	            var _loop_21 = function (sourceFile) {
	                if (sourceFile === oldFile)
	                    return "continue";
	                var _loop_22 = function (statement) {
	                    forEachImportInStatement(statement, function (importNode) {
	                        if (checker.getSymbolAtLocation(moduleSpecifierFromImport(importNode)) !== oldFile.symbol)
	                            return;
	                        var shouldMove = function (name) {
	                            var symbol = ts.isBindingElement(name.parent)
	                                ? ts.getPropertySymbolFromBindingElement(checker, name.parent)
	                                : ts.skipAlias(checker.getSymbolAtLocation(name), checker);
	                            return !!symbol && movedSymbols.has(symbol);
	                        };
	                        deleteUnusedImports(sourceFile, importNode, changes, shouldMove); // These will be changed to imports from the new file
	                        var newModuleSpecifier = ts.combinePaths(ts.getDirectoryPath(moduleSpecifierFromImport(importNode).text), newModuleName);
	                        var newImportDeclaration = filterImport(importNode, ts.createLiteral(newModuleSpecifier), shouldMove);
	                        if (newImportDeclaration)
	                            changes.insertNodeAfter(sourceFile, statement, newImportDeclaration);
	                        var ns = getNamespaceLikeImport(importNode);
	                        if (ns)
	                            updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleName, newModuleSpecifier, ns, importNode);
	                    });
	                };
	                for (var _i = 0, _a = sourceFile.statements; _i < _a.length; _i++) {
	                    var statement = _a[_i];
	                    _loop_22(statement);
	                }
	            };
	            for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                var sourceFile = _a[_i];
	                _loop_21(sourceFile);
	            }
	        }
	        function getNamespaceLikeImport(node) {
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return node.importClause && node.importClause.namedBindings && node.importClause.namedBindings.kind === 245 /* NamespaceImport */ ?
	                        node.importClause.namedBindings.name : undefined;
	                case 242 /* ImportEqualsDeclaration */:
	                    return node.name;
	                case 231 /* VariableDeclaration */:
	                    return ts.tryCast(node.name, ts.isIdentifier);
	                default:
	                    return ts.Debug.assertNever(node);
	            }
	        }
	        function updateNamespaceLikeImport(changes, sourceFile, checker, movedSymbols, newModuleName, newModuleSpecifier, oldImportId, oldImportNode) {
	            var preferredNewNamespaceName = ts.codefix.moduleSpecifierToValidIdentifier(newModuleName, 6 /* ESNext */);
	            var needUniqueName = false;
	            var toChange = [];
	            ts.FindAllReferences.Core.eachSymbolReferenceInFile(oldImportId, checker, sourceFile, function (ref) {
	                if (!ts.isPropertyAccessExpression(ref.parent))
	                    return;
	                needUniqueName = needUniqueName || !!checker.resolveName(preferredNewNamespaceName, ref, 67108863 /* All */, /*excludeGlobals*/ true);
	                if (movedSymbols.has(checker.getSymbolAtLocation(ref.parent.name))) {
	                    toChange.push(ref);
	                }
	            });
	            if (toChange.length) {
	                var newNamespaceName = needUniqueName ? ts.getUniqueName(preferredNewNamespaceName, sourceFile) : preferredNewNamespaceName;
	                for (var _i = 0, toChange_1 = toChange; _i < toChange_1.length; _i++) {
	                    var ref = toChange_1[_i];
	                    changes.replaceNode(sourceFile, ref, ts.createIdentifier(newNamespaceName));
	                }
	                changes.insertNodeAfter(sourceFile, oldImportNode, updateNamespaceLikeImportNode(oldImportNode, newModuleName, newModuleSpecifier));
	            }
	        }
	        function updateNamespaceLikeImportNode(node, newNamespaceName, newModuleSpecifier) {
	            var newNamespaceId = ts.createIdentifier(newNamespaceName);
	            var newModuleString = ts.createLiteral(newModuleSpecifier);
	            switch (node.kind) {
	                case 243 /* ImportDeclaration */:
	                    return ts.createImportDeclaration(
	                    /*decorators*/ undefined, /*modifiers*/ undefined, ts.createImportClause(/*name*/ undefined, ts.createNamespaceImport(newNamespaceId)), newModuleString);
	                case 242 /* ImportEqualsDeclaration */:
	                    return ts.createImportEqualsDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, newNamespaceId, ts.createExternalModuleReference(newModuleString));
	                case 231 /* VariableDeclaration */:
	                    return ts.createVariableDeclaration(newNamespaceId, /*type*/ undefined, createRequireCall(newModuleString));
	                default:
	                    return ts.Debug.assertNever(node);
	            }
	        }
	        function moduleSpecifierFromImport(i) {
	            return (i.kind === 243 /* ImportDeclaration */ ? i.moduleSpecifier
	                : i.kind === 242 /* ImportEqualsDeclaration */ ? i.moduleReference.expression
	                    : i.initializer.arguments[0]);
	        }
	        function forEachImportInStatement(statement, cb) {
	            if (ts.isImportDeclaration(statement)) {
	                if (ts.isStringLiteral(statement.moduleSpecifier))
	                    cb(statement);
	            }
	            else if (ts.isImportEqualsDeclaration(statement)) {
	                if (ts.isExternalModuleReference(statement.moduleReference) && ts.isStringLiteralLike(statement.moduleReference.expression)) {
	                    cb(statement);
	                }
	            }
	            else if (ts.isVariableStatement(statement)) {
	                for (var _i = 0, _a = statement.declarationList.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    if (decl.initializer && ts.isRequireCall(decl.initializer, /*checkArgumentIsStringLiteralLike*/ true)) {
	                        cb(decl);
	                    }
	                }
	            }
	        }
	        function createOldFileImportsFromNewFile(newFileNeedExport, newFileNameWithExtension, useEs6Imports, quotePreference) {
	            var defaultImport;
	            var imports = [];
	            newFileNeedExport.forEach(function (symbol) {
	                if (symbol.escapedName === "default" /* Default */) {
	                    defaultImport = ts.createIdentifier(ts.symbolNameNoDefault(symbol));
	                }
	                else {
	                    imports.push(symbol.name);
	                }
	            });
	            return makeImportOrRequire(defaultImport, imports, newFileNameWithExtension, useEs6Imports, quotePreference);
	        }
	        function makeImportOrRequire(defaultImport, imports, path, useEs6Imports, quotePreference) {
	            path = ts.ensurePathIsNonModuleName(path);
	            if (useEs6Imports) {
	                var specifiers = imports.map(function (i) { return ts.createImportSpecifier(/*propertyName*/ undefined, ts.createIdentifier(i)); });
	                return ts.makeImportIfNecessary(defaultImport, specifiers, path, quotePreference);
	            }
	            else {
	                ts.Debug.assert(!defaultImport); // If there's a default export, it should have been an es6 module.
	                var bindingElements = imports.map(function (i) { return ts.createBindingElement(/*dotDotDotToken*/ undefined, /*propertyName*/ undefined, i); });
	                return bindingElements.length
	                    ? makeVariableStatement(ts.createObjectBindingPattern(bindingElements), /*type*/ undefined, createRequireCall(ts.createLiteral(path)))
	                    : undefined;
	            }
	        }
	        function makeVariableStatement(name, type, initializer, flags) {
	            if (flags === void 0) { flags = 2 /* Const */; }
	            return ts.createVariableStatement(/*modifiers*/ undefined, ts.createVariableDeclarationList([ts.createVariableDeclaration(name, type, initializer)], flags));
	        }
	        function createRequireCall(moduleSpecifier) {
	            return ts.createCall(ts.createIdentifier("require"), /*typeArguments*/ undefined, [moduleSpecifier]);
	        }
	        function addExports(sourceFile, toMove, needExport, useEs6Exports) {
	            return ts.flatMap(toMove, function (statement) {
	                if (isTopLevelDeclarationStatement(statement) &&
	                    !isExported(sourceFile, statement, useEs6Exports) &&
	                    forEachTopLevelDeclaration(statement, function (d) { return needExport.has(ts.Debug.assertDefined(d.symbol)); })) {
	                    var exports_2 = addExport(statement, useEs6Exports);
	                    if (exports_2)
	                        return exports_2;
	                }
	                return statement;
	            });
	        }
	        function deleteUnusedImports(sourceFile, importDecl, changes, isUnused) {
	            switch (importDecl.kind) {
	                case 243 /* ImportDeclaration */:
	                    deleteUnusedImportsInDeclaration(sourceFile, importDecl, changes, isUnused);
	                    break;
	                case 242 /* ImportEqualsDeclaration */:
	                    if (isUnused(importDecl.name)) {
	                        changes.deleteNode(sourceFile, importDecl);
	                    }
	                    break;
	                case 231 /* VariableDeclaration */:
	                    deleteUnusedImportsInVariableDeclaration(sourceFile, importDecl, changes, isUnused);
	                    break;
	                default:
	                    ts.Debug.assertNever(importDecl);
	            }
	        }
	        function deleteUnusedImportsInDeclaration(sourceFile, importDecl, changes, isUnused) {
	            if (!importDecl.importClause)
	                return;
	            var _a = importDecl.importClause, name = _a.name, namedBindings = _a.namedBindings;
	            var defaultUnused = !name || isUnused(name);
	            var namedBindingsUnused = !namedBindings ||
	                (namedBindings.kind === 245 /* NamespaceImport */ ? isUnused(namedBindings.name) : namedBindings.elements.every(function (e) { return isUnused(e.name); }));
	            if (defaultUnused && namedBindingsUnused) {
	                changes.deleteNode(sourceFile, importDecl);
	            }
	            else {
	                if (name && defaultUnused) {
	                    changes.deleteNode(sourceFile, name);
	                }
	                if (namedBindings) {
	                    if (namedBindingsUnused) {
	                        changes.deleteNode(sourceFile, namedBindings);
	                    }
	                    else if (namedBindings.kind === 246 /* NamedImports */) {
	                        for (var _i = 0, _b = namedBindings.elements; _i < _b.length; _i++) {
	                            var element = _b[_i];
	                            if (isUnused(element.name))
	                                changes.deleteNodeInList(sourceFile, element);
	                        }
	                    }
	                }
	            }
	        }
	        function deleteUnusedImportsInVariableDeclaration(sourceFile, varDecl, changes, isUnused) {
	            var name = varDecl.name;
	            switch (name.kind) {
	                case 71 /* Identifier */:
	                    if (isUnused(name)) {
	                        changes.deleteNode(sourceFile, name);
	                    }
	                    break;
	                case 180 /* ArrayBindingPattern */:
	                    break;
	                case 179 /* ObjectBindingPattern */:
	                    if (name.elements.every(function (e) { return ts.isIdentifier(e.name) && isUnused(e.name); })) {
	                        changes.deleteNode(sourceFile, ts.isVariableDeclarationList(varDecl.parent) && varDecl.parent.declarations.length === 1 ? varDecl.parent.parent : varDecl);
	                    }
	                    else {
	                        for (var _i = 0, _a = name.elements; _i < _a.length; _i++) {
	                            var element = _a[_i];
	                            if (ts.isIdentifier(element.name) && isUnused(element.name)) {
	                                changes.deleteNode(sourceFile, element.name);
	                            }
	                        }
	                    }
	                    break;
	            }
	        }
	        function getNewFileImportsAndAddExportInOldFile(oldFile, importsToCopy, newFileImportsFromOldFile, changes, checker, useEs6ModuleSyntax, quotePreference) {
	            var copiedOldImports = [];
	            for (var _i = 0, _a = oldFile.statements; _i < _a.length; _i++) {
	                var oldStatement = _a[_i];
	                forEachImportInStatement(oldStatement, function (i) {
	                    ts.append(copiedOldImports, filterImport(i, moduleSpecifierFromImport(i), function (name) { return importsToCopy.has(checker.getSymbolAtLocation(name)); }));
	                });
	            }
	            // Also, import things used from the old file, and insert 'export' modifiers as necessary in the old file.
	            var oldFileDefault;
	            var oldFileNamedImports = [];
	            var markSeenTop = ts.nodeSeenTracker(); // Needed because multiple declarations may appear in `const x = 0, y = 1;`.
	            newFileImportsFromOldFile.forEach(function (symbol) {
	                for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                    var decl = _a[_i];
	                    if (!isTopLevelDeclaration(decl))
	                        continue;
	                    var name = nameOfTopLevelDeclaration(decl);
	                    if (!name)
	                        continue;
	                    var top = getTopLevelDeclarationStatement(decl);
	                    if (markSeenTop(top)) {
	                        addExportToChanges(oldFile, top, changes, useEs6ModuleSyntax);
	                    }
	                    if (ts.hasModifier(decl, 512 /* Default */)) {
	                        oldFileDefault = name;
	                    }
	                    else {
	                        oldFileNamedImports.push(name.text);
	                    }
	                }
	            });
	            ts.append(copiedOldImports, makeImportOrRequire(oldFileDefault, oldFileNamedImports, ts.removeFileExtension(ts.getBaseFileName(oldFile.fileName)), useEs6ModuleSyntax, quotePreference));
	            return copiedOldImports;
	        }
	        function makeUniqueModuleName(moduleName, extension, inDirectory, host) {
	            var newModuleName = moduleName;
	            for (var i = 1;; i++) {
	                var name = ts.combinePaths(inDirectory, newModuleName + extension);
	                if (!host.fileExists(name))
	                    return newModuleName;
	                newModuleName = moduleName + "." + i;
	            }
	        }
	        function getNewModuleName(movedSymbols) {
	            return movedSymbols.forEachEntry(ts.symbolNameNoDefault) || "newFile";
	        }
	        function getUsageInfo(oldFile, toMove, checker) {
	            var movedSymbols = new SymbolSet();
	            var oldImportsNeededByNewFile = new SymbolSet();
	            var newFileImportsFromOldFile = new SymbolSet();
	            for (var _i = 0, toMove_1 = toMove; _i < toMove_1.length; _i++) {
	                var statement = toMove_1[_i];
	                forEachTopLevelDeclaration(statement, function (decl) {
	                    movedSymbols.add(ts.Debug.assertDefined(ts.isExpressionStatement(decl) ? checker.getSymbolAtLocation(decl.expression.left) : decl.symbol));
	                });
	            }
	            for (var _a = 0, toMove_2 = toMove; _a < toMove_2.length; _a++) {
	                var statement = toMove_2[_a];
	                forEachReference(statement, checker, function (symbol) {
	                    if (!symbol.declarations)
	                        return;
	                    for (var _i = 0, _a = symbol.declarations; _i < _a.length; _i++) {
	                        var decl = _a[_i];
	                        if (isInImport(decl)) {
	                            oldImportsNeededByNewFile.add(symbol);
	                        }
	                        else if (isTopLevelDeclaration(decl) && !movedSymbols.has(symbol)) {
	                            newFileImportsFromOldFile.add(symbol);
	                        }
	                    }
	                });
	            }
	            var unusedImportsFromOldFile = oldImportsNeededByNewFile.clone();
	            var oldFileImportsFromNewFile = new SymbolSet();
	            for (var _b = 0, _c = oldFile.statements; _b < _c.length; _b++) {
	                var statement = _c[_b];
	                if (ts.contains(toMove, statement))
	                    continue;
	                forEachReference(statement, checker, function (symbol) {
	                    if (movedSymbols.has(symbol))
	                        oldFileImportsFromNewFile.add(symbol);
	                    unusedImportsFromOldFile.delete(symbol);
	                });
	            }
	            return { movedSymbols: movedSymbols, newFileImportsFromOldFile: newFileImportsFromOldFile, oldFileImportsFromNewFile: oldFileImportsFromNewFile, oldImportsNeededByNewFile: oldImportsNeededByNewFile, unusedImportsFromOldFile: unusedImportsFromOldFile };
	        }
	        // Below should all be utilities
	        function isInImport(decl) {
	            switch (decl.kind) {
	                case 242 /* ImportEqualsDeclaration */:
	                case 247 /* ImportSpecifier */:
	                case 244 /* ImportClause */:
	                    return true;
	                case 231 /* VariableDeclaration */:
	                    return isVariableDeclarationInImport(decl);
	                case 181 /* BindingElement */:
	                    return ts.isVariableDeclaration(decl.parent.parent) && isVariableDeclarationInImport(decl.parent.parent);
	                default:
	                    return false;
	            }
	        }
	        function isVariableDeclarationInImport(decl) {
	            return ts.isSourceFile(decl.parent.parent.parent) &&
	                decl.initializer && ts.isRequireCall(decl.initializer, /*checkArgumentIsStringLiteralLike*/ true);
	        }
	        function filterImport(i, moduleSpecifier, keep) {
	            switch (i.kind) {
	                case 243 /* ImportDeclaration */: {
	                    var clause = i.importClause;
	                    if (!clause)
	                        return undefined;
	                    var defaultImport = clause.name && keep(clause.name) ? clause.name : undefined;
	                    var namedBindings = clause.namedBindings && filterNamedBindings(clause.namedBindings, keep);
	                    return defaultImport || namedBindings
	                        ? ts.createImportDeclaration(/*decorators*/ undefined, /*modifiers*/ undefined, ts.createImportClause(defaultImport, namedBindings), moduleSpecifier)
	                        : undefined;
	                }
	                case 242 /* ImportEqualsDeclaration */:
	                    return keep(i.name) ? i : undefined;
	                case 231 /* VariableDeclaration */: {
	                    var name = filterBindingName(i.name, keep);
	                    return name ? makeVariableStatement(name, i.type, createRequireCall(moduleSpecifier), i.parent.flags) : undefined;
	                }
	                default:
	                    return ts.Debug.assertNever(i);
	            }
	        }
	        function filterNamedBindings(namedBindings, keep) {
	            if (namedBindings.kind === 245 /* NamespaceImport */) {
	                return keep(namedBindings.name) ? namedBindings : undefined;
	            }
	            else {
	                var newElements = namedBindings.elements.filter(function (e) { return keep(e.name); });
	                return newElements.length ? ts.createNamedImports(newElements) : undefined;
	            }
	        }
	        function filterBindingName(name, keep) {
	            switch (name.kind) {
	                case 71 /* Identifier */:
	                    return keep(name) ? name : undefined;
	                case 180 /* ArrayBindingPattern */:
	                    return name;
	                case 179 /* ObjectBindingPattern */: {
	                    // We can't handle nested destructurings or property names well here, so just copy them all.
	                    var newElements = name.elements.filter(function (prop) { return prop.propertyName || !ts.isIdentifier(prop.name) || keep(prop.name); });
	                    return newElements.length ? ts.createObjectBindingPattern(newElements) : undefined;
	                }
	            }
	        }
	        function forEachReference(node, checker, onReference) {
	            node.forEachChild(function cb(node) {
	                if (ts.isIdentifier(node) && !ts.isDeclarationName(node)) {
	                    var sym = checker.getSymbolAtLocation(node);
	                    if (sym)
	                        onReference(sym);
	                }
	                else {
	                    node.forEachChild(cb);
	                }
	            });
	        }
	        var SymbolSet = /** @class */ (function () {
	            function SymbolSet() {
	                this.map = ts.createMap();
	            }
	            SymbolSet.prototype.add = function (symbol) {
	                this.map.set(String(ts.getSymbolId(symbol)), symbol);
	            };
	            SymbolSet.prototype.has = function (symbol) {
	                return this.map.has(String(ts.getSymbolId(symbol)));
	            };
	            SymbolSet.prototype.delete = function (symbol) {
	                this.map.delete(String(ts.getSymbolId(symbol)));
	            };
	            SymbolSet.prototype.forEach = function (cb) {
	                this.map.forEach(cb);
	            };
	            SymbolSet.prototype.forEachEntry = function (cb) {
	                return ts.forEachEntry(this.map, cb);
	            };
	            SymbolSet.prototype.clone = function () {
	                var clone = new SymbolSet();
	                ts.copyEntries(this.map, clone.map);
	                return clone;
	            };
	            return SymbolSet;
	        }());
	        function isTopLevelDeclaration(node) {
	            return isNonVariableTopLevelDeclaration(node) || ts.isVariableDeclaration(node) && ts.isSourceFile(node.parent.parent.parent);
	        }
	        function isTopLevelDeclarationStatement(node) {
	            ts.Debug.assert(ts.isSourceFile(node.parent));
	            return isNonVariableTopLevelDeclaration(node) || ts.isVariableStatement(node);
	        }
	        function isNonVariableTopLevelDeclaration(node) {
	            switch (node.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 242 /* ImportEqualsDeclaration */:
	                    return true;
	                default:
	                    return false;
	            }
	        }
	        function forEachTopLevelDeclaration(statement, cb) {
	            switch (statement.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 234 /* ClassDeclaration */:
	                case 238 /* ModuleDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 242 /* ImportEqualsDeclaration */:
	                    return cb(statement);
	                case 213 /* VariableStatement */:
	                    return ts.forEach(statement.declarationList.declarations, cb);
	                case 215 /* ExpressionStatement */: {
	                    var expression = statement.expression;
	                    return ts.isBinaryExpression(expression) && ts.getSpecialPropertyAssignmentKind(expression) === 1 /* ExportsProperty */
	                        ? cb(statement)
	                        : undefined;
	                }
	            }
	        }
	        function nameOfTopLevelDeclaration(d) {
	            return d.kind === 215 /* ExpressionStatement */ ? d.expression.left.name : ts.tryCast(d.name, ts.isIdentifier);
	        }
	        function getTopLevelDeclarationStatement(d) {
	            return ts.isVariableDeclaration(d) ? d.parent.parent : d;
	        }
	        function addExportToChanges(sourceFile, decl, changes, useEs6Exports) {
	            if (isExported(sourceFile, decl, useEs6Exports))
	                return;
	            if (useEs6Exports) {
	                if (!ts.isExpressionStatement(decl))
	                    changes.insertExportModifier(sourceFile, decl);
	            }
	            else {
	                var names = getNamesToExportInCommonJS(decl);
	                if (names.length !== 0)
	                    changes.insertNodesAfter(sourceFile, decl, names.map(createExportAssignment));
	            }
	        }
	        function isExported(sourceFile, decl, useEs6Exports) {
	            if (useEs6Exports) {
	                return !ts.isExpressionStatement(decl) && ts.hasModifier(decl, 1 /* Export */);
	            }
	            else {
	                return getNamesToExportInCommonJS(decl).some(function (name) { return sourceFile.symbol.exports.has(ts.escapeLeadingUnderscores(name)); });
	            }
	        }
	        function addExport(decl, useEs6Exports) {
	            return useEs6Exports ? [addEs6Export(decl)] : addCommonjsExport(decl);
	        }
	        function addEs6Export(d) {
	            var modifiers = ts.concatenate([ts.createModifier(84 /* ExportKeyword */)], d.modifiers);
	            switch (d.kind) {
	                case 233 /* FunctionDeclaration */:
	                    return ts.updateFunctionDeclaration(d, d.decorators, modifiers, d.asteriskToken, d.name, d.typeParameters, d.parameters, d.type, d.body);
	                case 234 /* ClassDeclaration */:
	                    return ts.updateClassDeclaration(d, d.decorators, modifiers, d.name, d.typeParameters, d.heritageClauses, d.members);
	                case 213 /* VariableStatement */:
	                    return ts.updateVariableStatement(d, modifiers, d.declarationList);
	                case 238 /* ModuleDeclaration */:
	                    return ts.updateModuleDeclaration(d, d.decorators, modifiers, d.name, d.body);
	                case 237 /* EnumDeclaration */:
	                    return ts.updateEnumDeclaration(d, d.decorators, modifiers, d.name, d.members);
	                case 236 /* TypeAliasDeclaration */:
	                    return ts.updateTypeAliasDeclaration(d, d.decorators, modifiers, d.name, d.typeParameters, d.type);
	                case 235 /* InterfaceDeclaration */:
	                    return ts.updateInterfaceDeclaration(d, d.decorators, modifiers, d.name, d.typeParameters, d.heritageClauses, d.members);
	                case 242 /* ImportEqualsDeclaration */:
	                    return ts.updateImportEqualsDeclaration(d, d.decorators, modifiers, d.name, d.moduleReference);
	                case 215 /* ExpressionStatement */:
	                    return ts.Debug.fail(); // Shouldn't try to add 'export' keyword to `exports.x = ...`
	                default:
	                    return ts.Debug.assertNever(d);
	            }
	        }
	        function addCommonjsExport(decl) {
	            return [decl].concat(getNamesToExportInCommonJS(decl).map(createExportAssignment));
	        }
	        function getNamesToExportInCommonJS(decl) {
	            switch (decl.kind) {
	                case 233 /* FunctionDeclaration */:
	                case 234 /* ClassDeclaration */:
	                    return [decl.name.text];
	                case 213 /* VariableStatement */:
	                    return ts.mapDefined(decl.declarationList.declarations, function (d) { return ts.isIdentifier(d.name) ? d.name.text : undefined; });
	                case 238 /* ModuleDeclaration */:
	                case 237 /* EnumDeclaration */:
	                case 236 /* TypeAliasDeclaration */:
	                case 235 /* InterfaceDeclaration */:
	                case 242 /* ImportEqualsDeclaration */:
	                    return undefined;
	                case 215 /* ExpressionStatement */:
	                    return ts.Debug.fail(); // Shouldn't try to add 'export' keyword to `exports.x = ...`
	                default:
	                    ts.Debug.assertNever(decl);
	            }
	        }
	        /** Creates `exports.x = x;` */
	        function createExportAssignment(name) {
	            return ts.createExpressionStatement(ts.createBinary(ts.createPropertyAccess(ts.createIdentifier("exports"), ts.createIdentifier(name)), 58 /* EqualsToken */, ts.createIdentifier(name)));
	        }
	    })(refactor = ts.refactor || (ts.refactor = {}));
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var sourcemaps;
	    (function (sourcemaps) {
	        sourcemaps.identitySourceMapper = { getOriginalPosition: ts.identity, getGeneratedPosition: ts.identity };
	        function decode(host, mapPath, map, program, fallbackCache) {
	            if (fallbackCache === void 0) { fallbackCache = ts.createSourceFileLikeCache(host); }
	            var currentDirectory = ts.getDirectoryPath(mapPath);
	            var sourceRoot = map.sourceRoot || currentDirectory;
	            var decodedMappings;
	            var generatedOrderedMappings;
	            var sourceOrderedMappings;
	            return {
	                getOriginalPosition: getOriginalPosition,
	                getGeneratedPosition: getGeneratedPosition
	            };
	            function getGeneratedPosition(loc) {
	                var maps = getSourceOrderedMappings();
	                if (!ts.length(maps))
	                    return loc;
	                var targetIndex = ts.binarySearch(maps, { sourcePath: loc.fileName, sourcePosition: loc.position }, ts.identity, compareProcessedPositionSourcePositions);
	                if (targetIndex < 0 && maps.length > 0) {
	                    // if no exact match, closest is 2's compliment of result
	                    targetIndex = ~targetIndex;
	                }
	                if (!maps[targetIndex] || ts.comparePaths(loc.fileName, maps[targetIndex].sourcePath, sourceRoot) !== 0) {
	                    return loc;
	                }
	                return { fileName: ts.toPath(map.file, sourceRoot, host.getCanonicalFileName), position: maps[targetIndex].emittedPosition }; // Closest pos
	            }
	            function getOriginalPosition(loc) {
	                var maps = getGeneratedOrderedMappings();
	                if (!ts.length(maps))
	                    return loc;
	                var targetIndex = ts.binarySearch(maps, { emittedPosition: loc.position }, ts.identity, compareProcessedPositionEmittedPositions);
	                if (targetIndex < 0 && maps.length > 0) {
	                    // if no exact match, closest is 2's compliment of result
	                    targetIndex = ~targetIndex;
	                }
	                return { fileName: ts.toPath(maps[targetIndex].sourcePath, sourceRoot, host.getCanonicalFileName), position: maps[targetIndex].sourcePosition }; // Closest pos
	            }
	            function getSourceFileLike(fileName, location) {
	                // Lookup file in program, if provided
	                var file = program && program.getSourceFile(fileName);
	                if (!file) {
	                    // Otherwise check the cache (which may hit disk)
	                    var path = ts.toPath(fileName, location, host.getCanonicalFileName);
	                    return fallbackCache.get(path);
	                }
	                return file;
	            }
	            function getPositionOfLineAndCharacterUsingName(fileName, directory, line, character) {
	                var file = getSourceFileLike(fileName, directory);
	                if (!file) {
	                    return -1;
	                }
	                return ts.getPositionOfLineAndCharacter(file, line, character);
	            }
	            function getDecodedMappings() {
	                return decodedMappings || (decodedMappings = calculateDecodedMappings());
	            }
	            function getSourceOrderedMappings() {
	                return sourceOrderedMappings || (sourceOrderedMappings = getDecodedMappings().slice().sort(compareProcessedPositionSourcePositions));
	            }
	            function getGeneratedOrderedMappings() {
	                return generatedOrderedMappings || (generatedOrderedMappings = getDecodedMappings().slice().sort(compareProcessedPositionEmittedPositions));
	            }
	            function calculateDecodedMappings() {
	                var state = {
	                    encodedText: map.mappings,
	                    currentNameIndex: undefined,
	                    sourceMapNamesLength: map.names ? map.names.length : undefined,
	                    currentEmittedColumn: 0,
	                    currentEmittedLine: 0,
	                    currentSourceColumn: 0,
	                    currentSourceLine: 0,
	                    currentSourceIndex: 0,
	                    positions: [],
	                    decodingIndex: 0,
	                    processPosition: processPosition,
	                };
	                while (!hasCompletedDecoding(state)) {
	                    decodeSinglePosition(state);
	                    if (state.error) {
	                        host.log("Encountered error while decoding sourcemap found at " + mapPath + ": " + state.error);
	                        return [];
	                    }
	                }
	                return state.positions;
	            }
	            function compareProcessedPositionSourcePositions(a, b) {
	                return ts.comparePaths(a.sourcePath, b.sourcePath, sourceRoot) ||
	                    ts.compareValues(a.sourcePosition, b.sourcePosition);
	            }
	            function compareProcessedPositionEmittedPositions(a, b) {
	                return ts.compareValues(a.emittedPosition, b.emittedPosition);
	            }
	            function processPosition(position) {
	                var sourcePath = map.sources[position.sourceIndex];
	                return {
	                    emittedPosition: getPositionOfLineAndCharacterUsingName(map.file, currentDirectory, position.emittedLine, position.emittedColumn),
	                    sourcePosition: getPositionOfLineAndCharacterUsingName(sourcePath, sourceRoot, position.sourceLine, position.sourceColumn),
	                    sourcePath: sourcePath,
	                };
	            }
	        }
	        sourcemaps.decode = decode;
	        function hasCompletedDecoding(state) {
	            return state.decodingIndex === state.encodedText.length;
	        }
	        function decodeSinglePosition(state) {
	            while (state.decodingIndex < state.encodedText.length) {
	                var char = state.encodedText.charCodeAt(state.decodingIndex);
	                if (char === 59 /* semicolon */) {
	                    // New line
	                    state.currentEmittedLine++;
	                    state.currentEmittedColumn = 0;
	                    state.decodingIndex++;
	                    continue;
	                }
	                if (char === 44 /* comma */) {
	                    // Next entry is on same line - no action needed
	                    state.decodingIndex++;
	                    continue;
	                }
	                // Read the current position
	                // 1. Column offset from prev read jsColumn
	                state.currentEmittedColumn += base64VLQFormatDecode();
	                // Incorrect emittedColumn dont support this map
	                if (createErrorIfCondition(state.currentEmittedColumn < 0, "Invalid emittedColumn found")) {
	                    return;
	                }
	                // Dont support reading mappings that dont have information about original source and its line numbers
	                if (createErrorIfCondition(isSourceMappingSegmentEnd(state.encodedText, state.decodingIndex), "Unsupported Error Format: No entries after emitted column")) {
	                    return;
	                }
	                // 2. Relative sourceIndex
	                state.currentSourceIndex += base64VLQFormatDecode();
	                // Incorrect sourceIndex dont support this map
	                if (createErrorIfCondition(state.currentSourceIndex < 0, "Invalid sourceIndex found")) {
	                    return;
	                }
	                // Dont support reading mappings that dont have information about original source position
	                if (createErrorIfCondition(isSourceMappingSegmentEnd(state.encodedText, state.decodingIndex), "Unsupported Error Format: No entries after sourceIndex")) {
	                    return;
	                }
	                // 3. Relative sourceLine 0 based
	                state.currentSourceLine += base64VLQFormatDecode();
	                // Incorrect sourceLine dont support this map
	                if (createErrorIfCondition(state.currentSourceLine < 0, "Invalid sourceLine found")) {
	                    return;
	                }
	                // Dont support reading mappings that dont have information about original source and its line numbers
	                if (createErrorIfCondition(isSourceMappingSegmentEnd(state.encodedText, state.decodingIndex), "Unsupported Error Format: No entries after emitted Line")) {
	                    return;
	                }
	                // 4. Relative sourceColumn 0 based
	                state.currentSourceColumn += base64VLQFormatDecode();
	                // Incorrect sourceColumn dont support this map
	                if (createErrorIfCondition(state.currentSourceColumn < 0, "Invalid sourceLine found")) {
	                    return;
	                }
	                // 5. Check if there is name:
	                if (!isSourceMappingSegmentEnd(state.encodedText, state.decodingIndex)) {
	                    if (state.currentNameIndex === undefined) {
	                        state.currentNameIndex = 0;
	                    }
	                    state.currentNameIndex += base64VLQFormatDecode();
	                    // Incorrect nameIndex dont support this map
	                    // TODO: If we start using `name`s, issue errors when they aren't correct in the sourcemap
	                    // if (createErrorIfCondition(state.currentNameIndex < 0 || state.currentNameIndex >= state.sourceMapNamesLength, "Invalid name index for the source map entry")) {
	                    //    return;
	                    // }
	                }
	                // Dont support reading mappings that dont have information about original source and its line numbers
	                if (createErrorIfCondition(!isSourceMappingSegmentEnd(state.encodedText, state.decodingIndex), "Unsupported Error Format: There are more entries after " + (state.currentNameIndex === undefined ? "sourceColumn" : "nameIndex"))) {
	                    return;
	                }
	                // Entry should be complete
	                capturePosition();
	                return;
	            }
	            createErrorIfCondition(/*condition*/ true, "No encoded entry found");
	            return;
	            function capturePosition() {
	                state.positions.push(state.processPosition({
	                    emittedColumn: state.currentEmittedColumn,
	                    emittedLine: state.currentEmittedLine,
	                    sourceColumn: state.currentSourceColumn,
	                    sourceIndex: state.currentSourceIndex,
	                    sourceLine: state.currentSourceLine,
	                    nameIndex: state.currentNameIndex
	                }));
	            }
	            function createErrorIfCondition(condition, errormsg) {
	                if (state.error) {
	                    // An error was already reported
	                    return true;
	                }
	                if (condition) {
	                    state.error = errormsg;
	                }
	                return condition;
	            }
	            function base64VLQFormatDecode() {
	                var moreDigits = true;
	                var shiftCount = 0;
	                var value = 0;
	                for (; moreDigits; state.decodingIndex++) {
	                    if (createErrorIfCondition(state.decodingIndex >= state.encodedText.length, "Error in decoding base64VLQFormatDecode, past the mapping string")) {
	                        return;
	                    }
	                    // 6 digit number
	                    var currentByte = base64FormatDecode(state.encodedText.charAt(state.decodingIndex));
	                    // If msb is set, we still have more bits to continue
	                    moreDigits = (currentByte & 32) !== 0;
	                    // least significant 5 bits are the next msbs in the final value.
	                    value = value | ((currentByte & 31) << shiftCount);
	                    shiftCount += 5;
	                }
	                // Least significant bit if 1 represents negative and rest of the msb is actual absolute value
	                if ((value & 1) === 0) {
	                    // + number
	                    value = value >> 1;
	                }
	                else {
	                    // - number
	                    value = value >> 1;
	                    value = -value;
	                }
	                return value;
	            }
	        }
	        function base64FormatDecode(char) {
	            return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(char);
	        }
	        function isSourceMappingSegmentEnd(encodedText, pos) {
	            return (pos === encodedText.length ||
	                encodedText.charCodeAt(pos) === 44 /* comma */ ||
	                encodedText.charCodeAt(pos) === 59 /* semicolon */);
	        }
	    })(sourcemaps = ts.sourcemaps || (ts.sourcemaps = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /** The version of the language service API */
	    ts.servicesVersion = "0.8";
	    function createNode(kind, pos, end, parent) {
	        var node = ts.isNodeKind(kind) ? new NodeObject(kind, pos, end) :
	            kind === 71 /* Identifier */ ? new IdentifierObject(71 /* Identifier */, pos, end) :
	                new TokenObject(kind, pos, end);
	        node.parent = parent;
	        node.flags = parent.flags & 12679168 /* ContextFlags */;
	        return node;
	    }
	    var NodeObject = /** @class */ (function () {
	        function NodeObject(kind, pos, end) {
	            this.pos = pos;
	            this.end = end;
	            this.flags = 0 /* None */;
	            this.transformFlags = undefined;
	            this.parent = undefined;
	            this.kind = kind;
	        }
	        NodeObject.prototype.assertHasRealPosition = function (message) {
	            // tslint:disable-next-line:debug-assert
	            ts.Debug.assert(!ts.positionIsSynthesized(this.pos) && !ts.positionIsSynthesized(this.end), message || "Node must have a real position for this operation");
	        };
	        NodeObject.prototype.getSourceFile = function () {
	            return ts.getSourceFileOfNode(this);
	        };
	        NodeObject.prototype.getStart = function (sourceFile, includeJsDocComment) {
	            this.assertHasRealPosition();
	            return ts.getTokenPosOfNode(this, sourceFile, includeJsDocComment);
	        };
	        NodeObject.prototype.getFullStart = function () {
	            this.assertHasRealPosition();
	            return this.pos;
	        };
	        NodeObject.prototype.getEnd = function () {
	            this.assertHasRealPosition();
	            return this.end;
	        };
	        NodeObject.prototype.getWidth = function (sourceFile) {
	            this.assertHasRealPosition();
	            return this.getEnd() - this.getStart(sourceFile);
	        };
	        NodeObject.prototype.getFullWidth = function () {
	            this.assertHasRealPosition();
	            return this.end - this.pos;
	        };
	        NodeObject.prototype.getLeadingTriviaWidth = function (sourceFile) {
	            this.assertHasRealPosition();
	            return this.getStart(sourceFile) - this.pos;
	        };
	        NodeObject.prototype.getFullText = function (sourceFile) {
	            this.assertHasRealPosition();
	            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
	        };
	        NodeObject.prototype.getText = function (sourceFile) {
	            this.assertHasRealPosition();
	            if (!sourceFile) {
	                sourceFile = this.getSourceFile();
	            }
	            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
	        };
	        NodeObject.prototype.getChildCount = function (sourceFile) {
	            return this.getChildren(sourceFile).length;
	        };
	        NodeObject.prototype.getChildAt = function (index, sourceFile) {
	            return this.getChildren(sourceFile)[index];
	        };
	        NodeObject.prototype.getChildren = function (sourceFile) {
	            this.assertHasRealPosition("Node without a real position cannot be scanned and thus has no token nodes - use forEachChild and collect the result if that's fine");
	            return this._children || (this._children = createChildren(this, sourceFile));
	        };
	        NodeObject.prototype.getFirstToken = function (sourceFile) {
	            this.assertHasRealPosition();
	            var children = this.getChildren(sourceFile);
	            if (!children.length) {
	                return undefined;
	            }
	            var child = ts.find(children, function (kid) { return kid.kind < 277 /* FirstJSDocNode */ || kid.kind > 297 /* LastJSDocNode */; });
	            return child.kind < 145 /* FirstNode */ ?
	                child :
	                child.getFirstToken(sourceFile);
	        };
	        NodeObject.prototype.getLastToken = function (sourceFile) {
	            this.assertHasRealPosition();
	            var children = this.getChildren(sourceFile);
	            var child = ts.lastOrUndefined(children);
	            if (!child) {
	                return undefined;
	            }
	            return child.kind < 145 /* FirstNode */ ? child : child.getLastToken(sourceFile);
	        };
	        NodeObject.prototype.forEachChild = function (cbNode, cbNodeArray) {
	            return ts.forEachChild(this, cbNode, cbNodeArray);
	        };
	        return NodeObject;
	    }());
	    function createChildren(node, sourceFile) {
	        if (!ts.isNodeKind(node.kind)) {
	            return ts.emptyArray;
	        }
	        var children = [];
	        if (ts.isJSDocCommentContainingNode(node)) {
	            /** Don't add trivia for "tokens" since this is in a comment. */
	            node.forEachChild(function (child) { children.push(child); });
	            return children;
	        }
	        ts.scanner.setText((sourceFile || node.getSourceFile()).text);
	        var pos = node.pos;
	        var processNode = function (child) {
	            addSyntheticNodes(children, pos, child.pos, node);
	            children.push(child);
	            pos = child.end;
	        };
	        var processNodes = function (nodes) {
	            addSyntheticNodes(children, pos, nodes.pos, node);
	            children.push(createSyntaxList(nodes, node));
	            pos = nodes.end;
	        };
	        // jsDocComments need to be the first children
	        ts.forEach(node.jsDoc, processNode);
	        // For syntactic classifications, all trivia are classified together, including jsdoc comments.
	        // For that to work, the jsdoc comments should still be the leading trivia of the first child.
	        // Restoring the scanner position ensures that.
	        pos = node.pos;
	        node.forEachChild(processNode, processNodes);
	        addSyntheticNodes(children, pos, node.end, node);
	        ts.scanner.setText(undefined);
	        return children;
	    }
	    function addSyntheticNodes(nodes, pos, end, parent) {
	        ts.scanner.setTextPos(pos);
	        while (pos < end) {
	            var token = ts.scanner.scan();
	            var textPos = ts.scanner.getTextPos();
	            if (textPos <= end) {
	                if (token === 71 /* Identifier */) {
	                    ts.Debug.fail("Did not expect " + ts.Debug.showSyntaxKind(parent) + " to have an Identifier in its trivia");
	                }
	                nodes.push(createNode(token, pos, textPos, parent));
	            }
	            pos = textPos;
	            if (token === 1 /* EndOfFileToken */) {
	                break;
	            }
	        }
	    }
	    function createSyntaxList(nodes, parent) {
	        var list = createNode(298 /* SyntaxList */, nodes.pos, nodes.end, parent);
	        list._children = [];
	        var pos = nodes.pos;
	        for (var _i = 0, nodes_7 = nodes; _i < nodes_7.length; _i++) {
	            var node = nodes_7[_i];
	            addSyntheticNodes(list._children, pos, node.pos, parent);
	            list._children.push(node);
	            pos = node.end;
	        }
	        addSyntheticNodes(list._children, pos, nodes.end, parent);
	        return list;
	    }
	    var TokenOrIdentifierObject = /** @class */ (function () {
	        function TokenOrIdentifierObject(pos, end) {
	            // Set properties in same order as NodeObject
	            this.pos = pos;
	            this.end = end;
	            this.flags = 0 /* None */;
	            this.parent = undefined;
	        }
	        TokenOrIdentifierObject.prototype.getSourceFile = function () {
	            return ts.getSourceFileOfNode(this);
	        };
	        TokenOrIdentifierObject.prototype.getStart = function (sourceFile, includeJsDocComment) {
	            return ts.getTokenPosOfNode(this, sourceFile, includeJsDocComment);
	        };
	        TokenOrIdentifierObject.prototype.getFullStart = function () {
	            return this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getEnd = function () {
	            return this.end;
	        };
	        TokenOrIdentifierObject.prototype.getWidth = function (sourceFile) {
	            return this.getEnd() - this.getStart(sourceFile);
	        };
	        TokenOrIdentifierObject.prototype.getFullWidth = function () {
	            return this.end - this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getLeadingTriviaWidth = function (sourceFile) {
	            return this.getStart(sourceFile) - this.pos;
	        };
	        TokenOrIdentifierObject.prototype.getFullText = function (sourceFile) {
	            return (sourceFile || this.getSourceFile()).text.substring(this.pos, this.end);
	        };
	        TokenOrIdentifierObject.prototype.getText = function (sourceFile) {
	            if (!sourceFile) {
	                sourceFile = this.getSourceFile();
	            }
	            return sourceFile.text.substring(this.getStart(sourceFile), this.getEnd());
	        };
	        TokenOrIdentifierObject.prototype.getChildCount = function () {
	            return 0;
	        };
	        TokenOrIdentifierObject.prototype.getChildAt = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.getChildren = function () {
	            return ts.emptyArray;
	        };
	        TokenOrIdentifierObject.prototype.getFirstToken = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.getLastToken = function () {
	            return undefined;
	        };
	        TokenOrIdentifierObject.prototype.forEachChild = function () {
	            return undefined;
	        };
	        return TokenOrIdentifierObject;
	    }());
	    var SymbolObject = /** @class */ (function () {
	        function SymbolObject(flags, name) {
	            this.flags = flags;
	            this.escapedName = name;
	        }
	        SymbolObject.prototype.getFlags = function () {
	            return this.flags;
	        };
	        Object.defineProperty(SymbolObject.prototype, "name", {
	            get: function () {
	                return ts.symbolName(this);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        SymbolObject.prototype.getEscapedName = function () {
	            return this.escapedName;
	        };
	        SymbolObject.prototype.getName = function () {
	            return this.name;
	        };
	        SymbolObject.prototype.getDeclarations = function () {
	            return this.declarations;
	        };
	        SymbolObject.prototype.getDocumentationComment = function (checker) {
	            if (!this.documentationComment) {
	                this.documentationComment = ts.emptyArray; // Set temporarily to avoid an infinite loop finding inherited docs
	                this.documentationComment = getDocumentationComment(this.declarations, checker);
	            }
	            return this.documentationComment;
	        };
	        SymbolObject.prototype.getJsDocTags = function () {
	            if (this.tags === undefined) {
	                this.tags = ts.JsDoc.getJsDocTagsFromDeclarations(this.declarations);
	            }
	            return this.tags;
	        };
	        return SymbolObject;
	    }());
	    var TokenObject = /** @class */ (function (_super) {
	        __extends(TokenObject, _super);
	        function TokenObject(kind, pos, end) {
	            var _this = _super.call(this, pos, end) || this;
	            _this.kind = kind;
	            return _this;
	        }
	        return TokenObject;
	    }(TokenOrIdentifierObject));
	    var IdentifierObject = /** @class */ (function (_super) {
	        __extends(IdentifierObject, _super);
	        function IdentifierObject(_kind, pos, end) {
	            return _super.call(this, pos, end) || this;
	        }
	        Object.defineProperty(IdentifierObject.prototype, "text", {
	            get: function () {
	                return ts.idText(this);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return IdentifierObject;
	    }(TokenOrIdentifierObject));
	    IdentifierObject.prototype.kind = 71 /* Identifier */;
	    var TypeObject = /** @class */ (function () {
	        function TypeObject(checker, flags) {
	            this.checker = checker;
	            this.flags = flags;
	        }
	        TypeObject.prototype.getFlags = function () {
	            return this.flags;
	        };
	        TypeObject.prototype.getSymbol = function () {
	            return this.symbol;
	        };
	        TypeObject.prototype.getProperties = function () {
	            return this.checker.getPropertiesOfType(this);
	        };
	        TypeObject.prototype.getProperty = function (propertyName) {
	            return this.checker.getPropertyOfType(this, propertyName);
	        };
	        TypeObject.prototype.getApparentProperties = function () {
	            return this.checker.getAugmentedPropertiesOfType(this);
	        };
	        TypeObject.prototype.getCallSignatures = function () {
	            return this.checker.getSignaturesOfType(this, 0 /* Call */);
	        };
	        TypeObject.prototype.getConstructSignatures = function () {
	            return this.checker.getSignaturesOfType(this, 1 /* Construct */);
	        };
	        TypeObject.prototype.getStringIndexType = function () {
	            return this.checker.getIndexTypeOfType(this, 0 /* String */);
	        };
	        TypeObject.prototype.getNumberIndexType = function () {
	            return this.checker.getIndexTypeOfType(this, 1 /* Number */);
	        };
	        TypeObject.prototype.getBaseTypes = function () {
	            return this.isClassOrInterface() ? this.checker.getBaseTypes(this) : undefined;
	        };
	        TypeObject.prototype.getNonNullableType = function () {
	            return this.checker.getNonNullableType(this);
	        };
	        TypeObject.prototype.getConstraint = function () {
	            return this.checker.getBaseConstraintOfType(this);
	        };
	        TypeObject.prototype.getDefault = function () {
	            return this.checker.getDefaultFromTypeParameter(this);
	        };
	        TypeObject.prototype.isUnion = function () {
	            return !!(this.flags & 131072 /* Union */);
	        };
	        TypeObject.prototype.isIntersection = function () {
	            return !!(this.flags & 262144 /* Intersection */);
	        };
	        TypeObject.prototype.isUnionOrIntersection = function () {
	            return !!(this.flags & 393216 /* UnionOrIntersection */);
	        };
	        TypeObject.prototype.isLiteral = function () {
	            return !!(this.flags & 224 /* Literal */);
	        };
	        TypeObject.prototype.isStringLiteral = function () {
	            return !!(this.flags & 32 /* StringLiteral */);
	        };
	        TypeObject.prototype.isNumberLiteral = function () {
	            return !!(this.flags & 64 /* NumberLiteral */);
	        };
	        TypeObject.prototype.isTypeParameter = function () {
	            return !!(this.flags & 32768 /* TypeParameter */);
	        };
	        TypeObject.prototype.isClassOrInterface = function () {
	            return !!(ts.getObjectFlags(this) & 3 /* ClassOrInterface */);
	        };
	        TypeObject.prototype.isClass = function () {
	            return !!(ts.getObjectFlags(this) & 1 /* Class */);
	        };
	        return TypeObject;
	    }());
	    var SignatureObject = /** @class */ (function () {
	        function SignatureObject(checker) {
	            this.checker = checker;
	        }
	        SignatureObject.prototype.getDeclaration = function () {
	            return this.declaration;
	        };
	        SignatureObject.prototype.getTypeParameters = function () {
	            return this.typeParameters;
	        };
	        SignatureObject.prototype.getParameters = function () {
	            return this.parameters;
	        };
	        SignatureObject.prototype.getReturnType = function () {
	            return this.checker.getReturnTypeOfSignature(this);
	        };
	        SignatureObject.prototype.getDocumentationComment = function () {
	            return this.documentationComment || (this.documentationComment = getDocumentationComment(ts.singleElementArray(this.declaration), this.checker));
	        };
	        SignatureObject.prototype.getJsDocTags = function () {
	            if (this.jsDocTags === undefined) {
	                this.jsDocTags = this.declaration ? ts.JsDoc.getJsDocTagsFromDeclarations([this.declaration]) : [];
	            }
	            return this.jsDocTags;
	        };
	        return SignatureObject;
	    }());
	    /**
	     * Returns whether or not the given node has a JSDoc "inheritDoc" tag on it.
	     * @param node the Node in question.
	     * @returns `true` if `node` has a JSDoc "inheritDoc" tag on it, otherwise `false`.
	     */
	    function hasJSDocInheritDocTag(node) {
	        return ts.getJSDocTags(node).some(function (tag) { return tag.tagName.text === "inheritDoc"; });
	    }
	    function getDocumentationComment(declarations, checker) {
	        if (!declarations)
	            return ts.emptyArray;
	        var doc = ts.JsDoc.getJsDocCommentsFromDeclarations(declarations);
	        if (doc.length === 0 || declarations.some(hasJSDocInheritDocTag)) {
	            for (var _i = 0, declarations_14 = declarations; _i < declarations_14.length; _i++) {
	                var declaration = declarations_14[_i];
	                var inheritedDocs = findInheritedJSDocComments(declaration, declaration.symbol.name, checker);
	                // TODO: GH#16312 Return a ReadonlyArray, avoid copying inheritedDocs
	                if (inheritedDocs)
	                    doc = doc.length === 0 ? inheritedDocs.slice() : inheritedDocs.concat(ts.lineBreakPart(), doc);
	            }
	        }
	        return doc;
	    }
	    /**
	     * Attempts to find JSDoc comments for possibly-inherited properties.  Checks superclasses then traverses
	     * implemented interfaces until a symbol is found with the same name and with documentation.
	     * @param declaration The possibly-inherited declaration to find comments for.
	     * @param propertyName The name of the possibly-inherited property.
	     * @param typeChecker A TypeChecker, used to find inherited properties.
	     * @returns A filled array of documentation comments if any were found, otherwise an empty array.
	     */
	    function findInheritedJSDocComments(declaration, propertyName, typeChecker) {
	        return ts.firstDefined(declaration.parent ? ts.getAllSuperTypeNodes(declaration.parent) : ts.emptyArray, function (superTypeNode) {
	            var superType = typeChecker.getTypeAtLocation(superTypeNode);
	            var baseProperty = superType && typeChecker.getPropertyOfType(superType, propertyName);
	            var inheritedDocs = baseProperty && baseProperty.getDocumentationComment(typeChecker);
	            return inheritedDocs && inheritedDocs.length ? inheritedDocs : undefined;
	        });
	    }
	    var SourceFileObject = /** @class */ (function (_super) {
	        __extends(SourceFileObject, _super);
	        function SourceFileObject(kind, pos, end) {
	            return _super.call(this, kind, pos, end) || this;
	        }
	        SourceFileObject.prototype.update = function (newText, textChangeRange) {
	            return ts.updateSourceFile(this, newText, textChangeRange);
	        };
	        SourceFileObject.prototype.getLineAndCharacterOfPosition = function (position) {
	            return ts.getLineAndCharacterOfPosition(this, position);
	        };
	        SourceFileObject.prototype.getLineStarts = function () {
	            return ts.getLineStarts(this);
	        };
	        SourceFileObject.prototype.getPositionOfLineAndCharacter = function (line, character) {
	            return ts.getPositionOfLineAndCharacter(this, line, character);
	        };
	        SourceFileObject.prototype.getLineEndOfPosition = function (pos) {
	            var line = this.getLineAndCharacterOfPosition(pos).line;
	            var lineStarts = this.getLineStarts();
	            var lastCharPos;
	            if (line + 1 >= lineStarts.length) {
	                lastCharPos = this.getEnd();
	            }
	            if (!lastCharPos) {
	                lastCharPos = lineStarts[line + 1] - 1;
	            }
	            var fullText = this.getFullText();
	            // if the new line is "\r\n", we should return the last non-new-line-character position
	            return fullText[lastCharPos] === "\n" && fullText[lastCharPos - 1] === "\r" ? lastCharPos - 1 : lastCharPos;
	        };
	        SourceFileObject.prototype.getNamedDeclarations = function () {
	            if (!this.namedDeclarations) {
	                this.namedDeclarations = this.computeNamedDeclarations();
	            }
	            return this.namedDeclarations;
	        };
	        SourceFileObject.prototype.computeNamedDeclarations = function () {
	            var result = ts.createMultiMap();
	            ts.forEachChild(this, visit);
	            return result;
	            function addDeclaration(declaration) {
	                var name = getDeclarationName(declaration);
	                if (name) {
	                    result.add(name, declaration);
	                }
	            }
	            function getDeclarations(name) {
	                var declarations = result.get(name);
	                if (!declarations) {
	                    result.set(name, declarations = []);
	                }
	                return declarations;
	            }
	            function getDeclarationName(declaration) {
	                var name = ts.getNameOfDeclaration(declaration);
	                return name && (ts.isComputedPropertyName(name) && ts.isPropertyAccessExpression(name.expression) ? name.expression.name.text
	                    : ts.isPropertyName(name) ? ts.getNameFromPropertyName(name) : undefined);
	            }
	            function visit(node) {
	                switch (node.kind) {
	                    case 233 /* FunctionDeclaration */:
	                    case 191 /* FunctionExpression */:
	                    case 153 /* MethodDeclaration */:
	                    case 152 /* MethodSignature */:
	                        var functionDeclaration = node;
	                        var declarationName = getDeclarationName(functionDeclaration);
	                        if (declarationName) {
	                            var declarations = getDeclarations(declarationName);
	                            var lastDeclaration = ts.lastOrUndefined(declarations);
	                            // Check whether this declaration belongs to an "overload group".
	                            if (lastDeclaration && functionDeclaration.parent === lastDeclaration.parent && functionDeclaration.symbol === lastDeclaration.symbol) {
	                                // Overwrite the last declaration if it was an overload
	                                // and this one is an implementation.
	                                if (functionDeclaration.body && !lastDeclaration.body) {
	                                    declarations[declarations.length - 1] = functionDeclaration;
	                                }
	                            }
	                            else {
	                                declarations.push(functionDeclaration);
	                            }
	                        }
	                        ts.forEachChild(node, visit);
	                        break;
	                    case 234 /* ClassDeclaration */:
	                    case 204 /* ClassExpression */:
	                    case 235 /* InterfaceDeclaration */:
	                    case 236 /* TypeAliasDeclaration */:
	                    case 237 /* EnumDeclaration */:
	                    case 238 /* ModuleDeclaration */:
	                    case 242 /* ImportEqualsDeclaration */:
	                    case 251 /* ExportSpecifier */:
	                    case 247 /* ImportSpecifier */:
	                    case 244 /* ImportClause */:
	                    case 245 /* NamespaceImport */:
	                    case 155 /* GetAccessor */:
	                    case 156 /* SetAccessor */:
	                    case 165 /* TypeLiteral */:
	                        addDeclaration(node);
	                        ts.forEachChild(node, visit);
	                        break;
	                    case 148 /* Parameter */:
	                        // Only consider parameter properties
	                        if (!ts.hasModifier(node, 92 /* ParameterPropertyModifier */)) {
	                            break;
	                        }
	                    // falls through
	                    case 231 /* VariableDeclaration */:
	                    case 181 /* BindingElement */: {
	                        var decl = node;
	                        if (ts.isBindingPattern(decl.name)) {
	                            ts.forEachChild(decl.name, visit);
	                            break;
	                        }
	                        if (decl.initializer) {
	                            visit(decl.initializer);
	                        }
	                    }
	                    // falls through
	                    case 272 /* EnumMember */:
	                    case 151 /* PropertyDeclaration */:
	                    case 150 /* PropertySignature */:
	                        addDeclaration(node);
	                        break;
	                    case 249 /* ExportDeclaration */:
	                        // Handle named exports case e.g.:
	                        //    export {a, b as B} from "mod";
	                        if (node.exportClause) {
	                            ts.forEach(node.exportClause.elements, visit);
	                        }
	                        break;
	                    case 243 /* ImportDeclaration */:
	                        var importClause = node.importClause;
	                        if (importClause) {
	                            // Handle default import case e.g.:
	                            //    import d from "mod";
	                            if (importClause.name) {
	                                addDeclaration(importClause);
	                            }
	                            // Handle named bindings in imports e.g.:
	                            //    import * as NS from "mod";
	                            //    import {a, b as B} from "mod";
	                            if (importClause.namedBindings) {
	                                if (importClause.namedBindings.kind === 245 /* NamespaceImport */) {
	                                    addDeclaration(importClause.namedBindings);
	                                }
	                                else {
	                                    ts.forEach(importClause.namedBindings.elements, visit);
	                                }
	                            }
	                        }
	                        break;
	                    case 199 /* BinaryExpression */:
	                        if (ts.getSpecialPropertyAssignmentKind(node) !== 0 /* None */) {
	                            addDeclaration(node);
	                        }
	                    // falls through
	                    default:
	                        ts.forEachChild(node, visit);
	                }
	            }
	        };
	        return SourceFileObject;
	    }(NodeObject));
	    var SourceMapSourceObject = /** @class */ (function () {
	        function SourceMapSourceObject(fileName, text, skipTrivia) {
	            this.fileName = fileName;
	            this.text = text;
	            this.skipTrivia = skipTrivia;
	        }
	        SourceMapSourceObject.prototype.getLineAndCharacterOfPosition = function (pos) {
	            return ts.getLineAndCharacterOfPosition(this, pos);
	        };
	        return SourceMapSourceObject;
	    }());
	    function getServicesObjectAllocator() {
	        return {
	            getNodeConstructor: function () { return NodeObject; },
	            getTokenConstructor: function () { return TokenObject; },
	            getIdentifierConstructor: function () { return IdentifierObject; },
	            getSourceFileConstructor: function () { return SourceFileObject; },
	            getSymbolConstructor: function () { return SymbolObject; },
	            getTypeConstructor: function () { return TypeObject; },
	            getSignatureConstructor: function () { return SignatureObject; },
	            getSourceMapSourceConstructor: function () { return SourceMapSourceObject; },
	        };
	    }
	    function toEditorSettings(optionsAsMap) {
	        var allPropertiesAreCamelCased = true;
	        for (var key in optionsAsMap) {
	            if (ts.hasProperty(optionsAsMap, key) && !isCamelCase(key)) {
	                allPropertiesAreCamelCased = false;
	                break;
	            }
	        }
	        if (allPropertiesAreCamelCased) {
	            return optionsAsMap;
	        }
	        var settings = {};
	        for (var key in optionsAsMap) {
	            if (ts.hasProperty(optionsAsMap, key)) {
	                var newKey = isCamelCase(key) ? key : key.charAt(0).toLowerCase() + key.substr(1);
	                settings[newKey] = optionsAsMap[key];
	            }
	        }
	        return settings;
	    }
	    ts.toEditorSettings = toEditorSettings;
	    function isCamelCase(s) {
	        return !s.length || s.charAt(0) === s.charAt(0).toLowerCase();
	    }
	    function displayPartsToString(displayParts) {
	        if (displayParts) {
	            return ts.map(displayParts, function (displayPart) { return displayPart.text; }).join("");
	        }
	        return "";
	    }
	    ts.displayPartsToString = displayPartsToString;
	    function getDefaultCompilerOptions() {
	        // Always default to "ScriptTarget.ES5" for the language service
	        return {
	            target: 1 /* ES5 */,
	            jsx: 1 /* Preserve */
	        };
	    }
	    ts.getDefaultCompilerOptions = getDefaultCompilerOptions;
	    function getSupportedCodeFixes() {
	        return ts.codefix.getSupportedErrorCodes();
	    }
	    ts.getSupportedCodeFixes = getSupportedCodeFixes;
	    // Cache host information about script Should be refreshed
	    // at each language service public entry point, since we don't know when
	    // the set of scripts handled by the host changes.
	    var HostCache = /** @class */ (function () {
	        function HostCache(host, getCanonicalFileName) {
	            this.host = host;
	            // script id => script index
	            this.currentDirectory = host.getCurrentDirectory();
	            this.fileNameToEntry = ts.createMap();
	            // Initialize the list with the root file names
	            var rootFileNames = host.getScriptFileNames();
	            for (var _i = 0, rootFileNames_1 = rootFileNames; _i < rootFileNames_1.length; _i++) {
	                var fileName = rootFileNames_1[_i];
	                this.createEntry(fileName, ts.toPath(fileName, this.currentDirectory, getCanonicalFileName));
	            }
	            // store the compilation settings
	            this._compilationSettings = host.getCompilationSettings() || getDefaultCompilerOptions();
	        }
	        HostCache.prototype.compilationSettings = function () {
	            return this._compilationSettings;
	        };
	        HostCache.prototype.getProjectReferences = function () {
	            return this.host.getProjectReferences && this.host.getProjectReferences();
	        };
	        HostCache.prototype.createEntry = function (fileName, path) {
	            var entry;
	            var scriptSnapshot = this.host.getScriptSnapshot(fileName);
	            if (scriptSnapshot) {
	                entry = {
	                    hostFileName: fileName,
	                    version: this.host.getScriptVersion(fileName),
	                    scriptSnapshot: scriptSnapshot,
	                    scriptKind: ts.getScriptKind(fileName, this.host)
	                };
	            }
	            else {
	                entry = fileName;
	            }
	            this.fileNameToEntry.set(path, entry);
	            return entry;
	        };
	        HostCache.prototype.getEntryByPath = function (path) {
	            return this.fileNameToEntry.get(path);
	        };
	        HostCache.prototype.getHostFileInformation = function (path) {
	            var entry = this.fileNameToEntry.get(path);
	            return !ts.isString(entry) ? entry : undefined;
	        };
	        HostCache.prototype.getOrCreateEntryByPath = function (fileName, path) {
	            var info = this.getEntryByPath(path) || this.createEntry(fileName, path);
	            return ts.isString(info) ? undefined : info;
	        };
	        HostCache.prototype.getRootFileNames = function () {
	            var names = [];
	            this.fileNameToEntry.forEach(function (entry) {
	                if (ts.isString(entry)) {
	                    names.push(entry);
	                }
	                else {
	                    if (entry.scriptKind !== 6 /* JSON */) {
	                        names.push(entry.hostFileName);
	                    }
	                }
	            });
	            return names;
	        };
	        HostCache.prototype.getVersion = function (path) {
	            var file = this.getHostFileInformation(path);
	            return file && file.version;
	        };
	        HostCache.prototype.getScriptSnapshot = function (path) {
	            var file = this.getHostFileInformation(path);
	            return file && file.scriptSnapshot;
	        };
	        return HostCache;
	    }());
	    var SyntaxTreeCache = /** @class */ (function () {
	        function SyntaxTreeCache(host) {
	            this.host = host;
	        }
	        SyntaxTreeCache.prototype.getCurrentSourceFile = function (fileName) {
	            var scriptSnapshot = this.host.getScriptSnapshot(fileName);
	            if (!scriptSnapshot) {
	                // The host does not know about this file.
	                throw new Error("Could not find file: '" + fileName + "'.");
	            }
	            var scriptKind = ts.getScriptKind(fileName, this.host);
	            var version = this.host.getScriptVersion(fileName);
	            var sourceFile;
	            if (this.currentFileName !== fileName) {
	                // This is a new file, just parse it
	                sourceFile = createLanguageServiceSourceFile(fileName, scriptSnapshot, 6 /* Latest */, version, /*setNodeParents*/ true, scriptKind);
	            }
	            else if (this.currentFileVersion !== version) {
	                // This is the same file, just a newer version. Incrementally parse the file.
	                var editRange = scriptSnapshot.getChangeRange(this.currentFileScriptSnapshot);
	                sourceFile = updateLanguageServiceSourceFile(this.currentSourceFile, scriptSnapshot, version, editRange);
	            }
	            if (sourceFile) {
	                // All done, ensure state is up to date
	                this.currentFileVersion = version;
	                this.currentFileName = fileName;
	                this.currentFileScriptSnapshot = scriptSnapshot;
	                this.currentSourceFile = sourceFile;
	            }
	            return this.currentSourceFile;
	        };
	        return SyntaxTreeCache;
	    }());
	    function setSourceFileFields(sourceFile, scriptSnapshot, version) {
	        sourceFile.version = version;
	        sourceFile.scriptSnapshot = scriptSnapshot;
	    }
	    function createLanguageServiceSourceFile(fileName, scriptSnapshot, scriptTarget, version, setNodeParents, scriptKind) {
	        var sourceFile = ts.createSourceFile(fileName, ts.getSnapshotText(scriptSnapshot), scriptTarget, setNodeParents, scriptKind);
	        setSourceFileFields(sourceFile, scriptSnapshot, version);
	        return sourceFile;
	    }
	    ts.createLanguageServiceSourceFile = createLanguageServiceSourceFile;
	    ts.disableIncrementalParsing = false;
	    function updateLanguageServiceSourceFile(sourceFile, scriptSnapshot, version, textChangeRange, aggressiveChecks) {
	        // If we were given a text change range, and our version or open-ness changed, then
	        // incrementally parse this file.
	        if (textChangeRange) {
	            if (version !== sourceFile.version) {
	                // Once incremental parsing is ready, then just call into this function.
	                if (!ts.disableIncrementalParsing) {
	                    var newText = void 0;
	                    // grab the fragment from the beginning of the original text to the beginning of the span
	                    var prefix = textChangeRange.span.start !== 0
	                        ? sourceFile.text.substr(0, textChangeRange.span.start)
	                        : "";
	                    // grab the fragment from the end of the span till the end of the original text
	                    var suffix = ts.textSpanEnd(textChangeRange.span) !== sourceFile.text.length
	                        ? sourceFile.text.substr(ts.textSpanEnd(textChangeRange.span))
	                        : "";
	                    if (textChangeRange.newLength === 0) {
	                        // edit was a deletion - just combine prefix and suffix
	                        newText = prefix && suffix ? prefix + suffix : prefix || suffix;
	                    }
	                    else {
	                        // it was actual edit, fetch the fragment of new text that correspond to new span
	                        var changedText = scriptSnapshot.getText(textChangeRange.span.start, textChangeRange.span.start + textChangeRange.newLength);
	                        // combine prefix, changed text and suffix
	                        newText = prefix && suffix
	                            ? prefix + changedText + suffix
	                            : prefix
	                                ? (prefix + changedText)
	                                : (changedText + suffix);
	                    }
	                    var newSourceFile = ts.updateSourceFile(sourceFile, newText, textChangeRange, aggressiveChecks);
	                    setSourceFileFields(newSourceFile, scriptSnapshot, version);
	                    // after incremental parsing nameTable might not be up-to-date
	                    // drop it so it can be lazily recreated later
	                    newSourceFile.nameTable = undefined;
	                    // dispose all resources held by old script snapshot
	                    if (sourceFile !== newSourceFile && sourceFile.scriptSnapshot) {
	                        if (sourceFile.scriptSnapshot.dispose) {
	                            sourceFile.scriptSnapshot.dispose();
	                        }
	                        sourceFile.scriptSnapshot = undefined;
	                    }
	                    return newSourceFile;
	                }
	            }
	        }
	        // Otherwise, just create a new source file.
	        return createLanguageServiceSourceFile(sourceFile.fileName, scriptSnapshot, sourceFile.languageVersion, version, /*setNodeParents*/ true, sourceFile.scriptKind);
	    }
	    ts.updateLanguageServiceSourceFile = updateLanguageServiceSourceFile;
	    var CancellationTokenObject = /** @class */ (function () {
	        function CancellationTokenObject(cancellationToken) {
	            this.cancellationToken = cancellationToken;
	        }
	        CancellationTokenObject.prototype.isCancellationRequested = function () {
	            return this.cancellationToken && this.cancellationToken.isCancellationRequested();
	        };
	        CancellationTokenObject.prototype.throwIfCancellationRequested = function () {
	            if (this.isCancellationRequested()) {
	                throw new ts.OperationCanceledException();
	            }
	        };
	        return CancellationTokenObject;
	    }());
	    /* @internal */
	    /** A cancellation that throttles calls to the host */
	    var ThrottledCancellationToken = /** @class */ (function () {
	        function ThrottledCancellationToken(hostCancellationToken, throttleWaitMilliseconds) {
	            if (throttleWaitMilliseconds === void 0) { throttleWaitMilliseconds = 20; }
	            this.hostCancellationToken = hostCancellationToken;
	            this.throttleWaitMilliseconds = throttleWaitMilliseconds;
	            // Store when we last tried to cancel.  Checking cancellation can be expensive (as we have
	            // to marshall over to the host layer).  So we only bother actually checking once enough
	            // time has passed.
	            this.lastCancellationCheckTime = 0;
	        }
	        ThrottledCancellationToken.prototype.isCancellationRequested = function () {
	            var time = ts.timestamp();
	            var duration = Math.abs(time - this.lastCancellationCheckTime);
	            if (duration >= this.throttleWaitMilliseconds) {
	                // Check no more than once every throttle wait milliseconds
	                this.lastCancellationCheckTime = time;
	                return this.hostCancellationToken.isCancellationRequested();
	            }
	            return false;
	        };
	        ThrottledCancellationToken.prototype.throwIfCancellationRequested = function () {
	            if (this.isCancellationRequested()) {
	                throw new ts.OperationCanceledException();
	            }
	        };
	        return ThrottledCancellationToken;
	    }());
	    ts.ThrottledCancellationToken = ThrottledCancellationToken;
	    /* @internal */
	    function createSourceFileLikeCache(host) {
	        var cached = ts.createMap();
	        return {
	            get: function (path) {
	                if (cached.has(path)) {
	                    return cached.get(path);
	                }
	                if (!host.fileExists || !host.readFile || !host.fileExists(path))
	                    return;
	                // And failing that, check the disk
	                var text = host.readFile(path);
	                var file = {
	                    text: text,
	                    lineMap: undefined,
	                    getLineAndCharacterOfPosition: function (pos) {
	                        return ts.computeLineAndCharacterOfPosition(ts.getLineStarts(this), pos);
	                    }
	                };
	                cached.set(path, file);
	                return file;
	            }
	        };
	    }
	    ts.createSourceFileLikeCache = createSourceFileLikeCache;
	    function createLanguageService(host, documentRegistry, syntaxOnly) {
	        if (documentRegistry === void 0) { documentRegistry = ts.createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory()); }
	        if (syntaxOnly === void 0) { syntaxOnly = false; }
	        var _a;
	        var syntaxTreeCache = new SyntaxTreeCache(host);
	        var program;
	        var lastProjectVersion;
	        var lastTypesRootVersion = 0;
	        var cancellationToken = new CancellationTokenObject(host.getCancellationToken && host.getCancellationToken());
	        var currentDirectory = host.getCurrentDirectory();
	        // Check if the localized messages json is set, otherwise query the host for it
	        if (!ts.localizedDiagnosticMessages && host.getLocalizedDiagnosticMessages) {
	            ts.localizedDiagnosticMessages = host.getLocalizedDiagnosticMessages();
	        }
	        var sourcemappedFileCache;
	        function log(message) {
	            if (host.log) {
	                host.log(message);
	            }
	        }
	        var useCaseSensitiveFileNames = ts.hostUsesCaseSensitiveFileNames(host);
	        var getCanonicalFileName = ts.createGetCanonicalFileName(useCaseSensitiveFileNames);
	        function getValidSourceFile(fileName) {
	            var sourceFile = program.getSourceFile(fileName);
	            if (!sourceFile) {
	                throw new Error("Could not find file: '" + fileName + "'.");
	            }
	            return sourceFile;
	        }
	        function synchronizeHostData() {
	            ts.Debug.assert(!syntaxOnly);
	            // perform fast check if host supports it
	            if (host.getProjectVersion) {
	                var hostProjectVersion = host.getProjectVersion();
	                if (hostProjectVersion) {
	                    if (lastProjectVersion === hostProjectVersion && !host.hasChangedAutomaticTypeDirectiveNames) {
	                        return;
	                    }
	                    lastProjectVersion = hostProjectVersion;
	                }
	            }
	            var typeRootsVersion = host.getTypeRootsVersion ? host.getTypeRootsVersion() : 0;
	            if (lastTypesRootVersion !== typeRootsVersion) {
	                log("TypeRoots version has changed; provide new program");
	                program = undefined;
	                lastTypesRootVersion = typeRootsVersion;
	            }
	            // Get a fresh cache of the host information
	            var hostCache = new HostCache(host, getCanonicalFileName);
	            var rootFileNames = hostCache.getRootFileNames();
	            var hasInvalidatedResolution = host.hasInvalidatedResolution || ts.returnFalse;
	            // If the program is already up-to-date, we can reuse it
	            if (ts.isProgramUptoDate(program, rootFileNames, hostCache.compilationSettings(), function (path) { return hostCache.getVersion(path); }, fileExists, hasInvalidatedResolution, host.hasChangedAutomaticTypeDirectiveNames)) {
	                return;
	            }
	            // IMPORTANT - It is critical from this moment onward that we do not check
	            // cancellation tokens.  We are about to mutate source files from a previous program
	            // instance.  If we cancel midway through, we may end up in an inconsistent state where
	            // the program points to old source files that have been invalidated because of
	            // incremental parsing.
	            var newSettings = hostCache.compilationSettings();
	            // Now create a new compiler
	            var compilerHost = {
	                getSourceFile: getOrCreateSourceFile,
	                getSourceFileByPath: getOrCreateSourceFileByPath,
	                getCancellationToken: function () { return cancellationToken; },
	                getCanonicalFileName: getCanonicalFileName,
	                useCaseSensitiveFileNames: function () { return useCaseSensitiveFileNames; },
	                getNewLine: function () { return ts.getNewLineCharacter(newSettings, function () { return ts.getNewLineOrDefaultFromHost(host); }); },
	                getDefaultLibFileName: function (options) { return host.getDefaultLibFileName(options); },
	                writeFile: ts.noop,
	                getCurrentDirectory: function () { return currentDirectory; },
	                fileExists: fileExists,
	                readFile: function (fileName) {
	                    // stub missing host functionality
	                    var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	                    var entry = hostCache.getEntryByPath(path);
	                    if (entry) {
	                        return ts.isString(entry) ? undefined : ts.getSnapshotText(entry.scriptSnapshot);
	                    }
	                    return host.readFile && host.readFile(fileName);
	                },
	                realpath: host.realpath && (function (path) { return host.realpath(path); }),
	                directoryExists: function (directoryName) {
	                    return ts.directoryProbablyExists(directoryName, host);
	                },
	                getDirectories: function (path) {
	                    return host.getDirectories ? host.getDirectories(path) : [];
	                },
	                onReleaseOldSourceFile: onReleaseOldSourceFile,
	                hasInvalidatedResolution: hasInvalidatedResolution,
	                hasChangedAutomaticTypeDirectiveNames: host.hasChangedAutomaticTypeDirectiveNames
	            };
	            if (host.trace) {
	                compilerHost.trace = function (message) { return host.trace(message); };
	            }
	            if (host.resolveModuleNames) {
	                compilerHost.resolveModuleNames = function (moduleNames, containingFile, reusedNames) { return host.resolveModuleNames(moduleNames, containingFile, reusedNames); };
	            }
	            if (host.resolveTypeReferenceDirectives) {
	                compilerHost.resolveTypeReferenceDirectives = function (typeReferenceDirectiveNames, containingFile) {
	                    return host.resolveTypeReferenceDirectives(typeReferenceDirectiveNames, containingFile);
	                };
	            }
	            var documentRegistryBucketKey = documentRegistry.getKeyForCompilationSettings(newSettings);
	            var options = {
	                rootNames: rootFileNames,
	                options: newSettings,
	                host: compilerHost,
	                oldProgram: program,
	                projectReferences: hostCache.getProjectReferences()
	            };
	            program = ts.createProgram(options);
	            // hostCache is captured in the closure for 'getOrCreateSourceFile' but it should not be used past this point.
	            // It needs to be cleared to allow all collected snapshots to be released
	            hostCache = undefined;
	            // We reset this cache on structure invalidation so we don't hold on to outdated files for long; however we can't use the `compilerHost` above,
	            // Because it only functions until `hostCache` is cleared, while we'll potentially need the functionality to lazily read sourcemap files during
	            // the course of whatever called `synchronizeHostData`
	            sourcemappedFileCache = createSourceFileLikeCache(host);
	            // Make sure all the nodes in the program are both bound, and have their parent
	            // pointers set property.
	            program.getTypeChecker();
	            return;
	            function fileExists(fileName) {
	                var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	                var entry = hostCache.getEntryByPath(path);
	                return entry ?
	                    !ts.isString(entry) :
	                    (host.fileExists && host.fileExists(fileName));
	            }
	            // Release any files we have acquired in the old program but are
	            // not part of the new program.
	            function onReleaseOldSourceFile(oldSourceFile, oldOptions) {
	                var oldSettingsKey = documentRegistry.getKeyForCompilationSettings(oldOptions);
	                documentRegistry.releaseDocumentWithKey(oldSourceFile.path, oldSettingsKey);
	            }
	            function getOrCreateSourceFile(fileName, languageVersion, onError, shouldCreateNewSourceFile) {
	                return getOrCreateSourceFileByPath(fileName, ts.toPath(fileName, currentDirectory, getCanonicalFileName), languageVersion, onError, shouldCreateNewSourceFile);
	            }
	            function getOrCreateSourceFileByPath(fileName, path, _languageVersion, _onError, shouldCreateNewSourceFile) {
	                ts.Debug.assert(hostCache !== undefined);
	                // The program is asking for this file, check first if the host can locate it.
	                // If the host can not locate the file, then it does not exist. return undefined
	                // to the program to allow reporting of errors for missing files.
	                var hostFileInformation = hostCache.getOrCreateEntryByPath(fileName, path);
	                if (!hostFileInformation) {
	                    return undefined;
	                }
	                // Check if the language version has changed since we last created a program; if they are the same,
	                // it is safe to reuse the sourceFiles; if not, then the shape of the AST can change, and the oldSourceFile
	                // can not be reused. we have to dump all syntax trees and create new ones.
	                if (!shouldCreateNewSourceFile) {
	                    // Check if the old program had this file already
	                    var oldSourceFile = program && program.getSourceFileByPath(path);
	                    if (oldSourceFile) {
	                        // We already had a source file for this file name.  Go to the registry to
	                        // ensure that we get the right up to date version of it.  We need this to
	                        // address the following race-condition.  Specifically, say we have the following:
	                        //
	                        //      LS1
	                        //          \
	                        //           DocumentRegistry
	                        //          /
	                        //      LS2
	                        //
	                        // Each LS has a reference to file 'foo.ts' at version 1.  LS2 then updates
	                        // it's version of 'foo.ts' to version 2.  This will cause LS2 and the
	                        // DocumentRegistry to have version 2 of the document.  HOwever, LS1 will
	                        // have version 1.  And *importantly* this source file will be *corrupt*.
	                        // The act of creating version 2 of the file irrevocably damages the version
	                        // 1 file.
	                        //
	                        // So, later when we call into LS1, we need to make sure that it doesn't use
	                        // it's source file any more, and instead defers to DocumentRegistry to get
	                        // either version 1, version 2 (or some other version) depending on what the
	                        // host says should be used.
	                        // We do not support the scenario where a host can modify a registered
	                        // file's script kind, i.e. in one project some file is treated as ".ts"
	                        // and in another as ".js"
	                        ts.Debug.assertEqual(hostFileInformation.scriptKind, oldSourceFile.scriptKind, "Registered script kind should match new script kind.", path);
	                        return documentRegistry.updateDocumentWithKey(fileName, path, newSettings, documentRegistryBucketKey, hostFileInformation.scriptSnapshot, hostFileInformation.version, hostFileInformation.scriptKind);
	                    }
	                    // We didn't already have the file.  Fall through and acquire it from the registry.
	                }
	                // Could not find this file in the old program, create a new SourceFile for it.
	                return documentRegistry.acquireDocumentWithKey(fileName, path, newSettings, documentRegistryBucketKey, hostFileInformation.scriptSnapshot, hostFileInformation.version, hostFileInformation.scriptKind);
	            }
	        }
	        function getProgram() {
	            if (syntaxOnly) {
	                ts.Debug.assert(program === undefined);
	                return undefined;
	            }
	            synchronizeHostData();
	            return program;
	        }
	        function cleanupSemanticCache() {
	            program = undefined;
	        }
	        function dispose() {
	            if (program) {
	                ts.forEach(program.getSourceFiles(), function (f) {
	                    return documentRegistry.releaseDocument(f.fileName, program.getCompilerOptions());
	                });
	                program = undefined;
	            }
	            host = undefined;
	        }
	        /// Diagnostics
	        function getSyntacticDiagnostics(fileName) {
	            synchronizeHostData();
	            return program.getSyntacticDiagnostics(getValidSourceFile(fileName), cancellationToken).slice();
	        }
	        /**
	         * getSemanticDiagnostics return array of Diagnostics. If '-d' is not enabled, only report semantic errors
	         * If '-d' enabled, report both semantic and emitter errors
	         */
	        function getSemanticDiagnostics(fileName) {
	            synchronizeHostData();
	            var targetSourceFile = getValidSourceFile(fileName);
	            // Only perform the action per file regardless of '-out' flag as LanguageServiceHost is expected to call this function per file.
	            // Therefore only get diagnostics for given file.
	            var semanticDiagnostics = program.getSemanticDiagnostics(targetSourceFile, cancellationToken);
	            if (!program.getCompilerOptions().declaration) {
	                return semanticDiagnostics.slice();
	            }
	            // If '-d' is enabled, check for emitter error. One example of emitter error is export class implements non-export interface
	            var declarationDiagnostics = program.getDeclarationDiagnostics(targetSourceFile, cancellationToken);
	            return semanticDiagnostics.concat(declarationDiagnostics);
	        }
	        function getSuggestionDiagnostics(fileName) {
	            synchronizeHostData();
	            return ts.computeSuggestionDiagnostics(getValidSourceFile(fileName), program);
	        }
	        function getCompilerOptionsDiagnostics() {
	            synchronizeHostData();
	            return program.getOptionsDiagnostics(cancellationToken).concat(program.getGlobalDiagnostics(cancellationToken));
	        }
	        function getCompletionsAtPosition(fileName, position, options) {
	            if (options === void 0) { options = ts.defaultPreferences; }
	            // Convert from deprecated options names to new names
	            var fullPreferences = __assign({}, ts.identity(options), { includeCompletionsForModuleExports: options.includeCompletionsForModuleExports || options.includeExternalModuleExports, includeCompletionsWithInsertText: options.includeCompletionsWithInsertText || options.includeInsertTextCompletions });
	            synchronizeHostData();
	            return ts.Completions.getCompletionsAtPosition(host, program, log, getValidSourceFile(fileName), position, fullPreferences, options.triggerCharacter);
	        }
	        function getCompletionEntryDetails(fileName, position, name, formattingOptions, source, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            return ts.Completions.getCompletionEntryDetails(program, log, getValidSourceFile(fileName), position, { name: name, source: source }, host, formattingOptions && ts.formatting.getFormatContext(formattingOptions), getCanonicalFileName, preferences, cancellationToken);
	        }
	        function getCompletionEntrySymbol(fileName, position, name, source) {
	            synchronizeHostData();
	            return ts.Completions.getCompletionEntrySymbol(program, log, getValidSourceFile(fileName), position, { name: name, source: source });
	        }
	        function getQuickInfoAtPosition(fileName, position) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var node = ts.getTouchingPropertyName(sourceFile, position, /*includeJsDocComment*/ true);
	            if (node === sourceFile) {
	                // Avoid giving quickInfo for the sourceFile as a whole.
	                return undefined;
	            }
	            var typeChecker = program.getTypeChecker();
	            var symbol = getSymbolAtLocationForQuickInfo(node, typeChecker);
	            if (!symbol || typeChecker.isUnknownSymbol(symbol)) {
	                // Try getting just type at this position and show
	                switch (node.kind) {
	                    case 71 /* Identifier */:
	                        if (ts.isLabelName(node)) {
	                            // Type here will be 'any', avoid displaying this.
	                            return undefined;
	                        }
	                    // falls through
	                    case 184 /* PropertyAccessExpression */:
	                    case 145 /* QualifiedName */:
	                    case 99 /* ThisKeyword */:
	                    case 173 /* ThisType */:
	                    case 97 /* SuperKeyword */:
	                        // For the identifiers/this/super etc get the type at position
	                        var type_4 = typeChecker.getTypeAtLocation(node);
	                        return type_4 && {
	                            kind: "" /* unknown */,
	                            kindModifiers: "" /* none */,
	                            textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                            displayParts: typeChecker.runWithCancellationToken(cancellationToken, function (typeChecker) { return ts.typeToDisplayParts(typeChecker, type_4, ts.getContainerNode(node)); }),
	                            documentation: type_4.symbol ? type_4.symbol.getDocumentationComment(typeChecker) : undefined,
	                            tags: type_4.symbol ? type_4.symbol.getJsDocTags() : undefined
	                        };
	                }
	                return undefined;
	            }
	            var _a = typeChecker.runWithCancellationToken(cancellationToken, function (typeChecker) {
	                return ts.SymbolDisplay.getSymbolDisplayPartsDocumentationAndSymbolKind(typeChecker, symbol, sourceFile, ts.getContainerNode(node), node);
	            }), symbolKind = _a.symbolKind, displayParts = _a.displayParts, documentation = _a.documentation, tags = _a.tags;
	            return {
	                kind: symbolKind,
	                kindModifiers: ts.SymbolDisplay.getSymbolModifiers(symbol),
	                textSpan: ts.createTextSpanFromNode(node, sourceFile),
	                displayParts: displayParts,
	                documentation: documentation,
	                tags: tags,
	            };
	        }
	        function getSymbolAtLocationForQuickInfo(node, checker) {
	            if ((ts.isIdentifier(node) || ts.isStringLiteral(node))
	                && ts.isPropertyAssignment(node.parent)
	                && node.parent.name === node) {
	                var type = checker.getContextualType(node.parent.parent);
	                var property = type && checker.getPropertyOfType(type, ts.getTextOfIdentifierOrLiteral(node));
	                if (property) {
	                    return property;
	                }
	            }
	            return checker.getSymbolAtLocation(node);
	        }
	        function toLineColumnOffset(fileName, position) {
	            var path = ts.toPath(fileName, currentDirectory, getCanonicalFileName);
	            var file = program.getSourceFile(path) || sourcemappedFileCache.get(path);
	            return file.getLineAndCharacterOfPosition(position);
	        }
	        // Sometimes tools can sometimes see the following line as a source mapping url comment, so we mangle it a bit (the [M])
	        var sourceMapCommentRegExp = /^\/\/[@#] source[M]appingURL=(.+)$/gm;
	        var base64UrlRegExp = /^data:(?:application\/json(?:;charset=[uU][tT][fF]-8);base64,([A-Za-z0-9+\/=]+)$)?/;
	        function scanForSourcemapURL(fileName) {
	            var mappedFile = sourcemappedFileCache.get(ts.toPath(fileName, currentDirectory, getCanonicalFileName));
	            if (!mappedFile) {
	                return;
	            }
	            var starts = ts.getLineStarts(mappedFile);
	            for (var index = starts.length - 1; index >= 0; index--) {
	                sourceMapCommentRegExp.lastIndex = starts[index];
	                var comment = sourceMapCommentRegExp.exec(mappedFile.text);
	                if (comment) {
	                    return comment[1];
	                }
	            }
	        }
	        function convertDocumentToSourceMapper(file, contents, mapFileName) {
	            var maps;
	            try {
	                maps = JSON.parse(contents);
	            }
	            catch (_a) {
	                // swallow error
	            }
	            if (!maps || !maps.sources || !maps.file || !maps.mappings) {
	                // obviously invalid map
	                return file.sourceMapper = ts.sourcemaps.identitySourceMapper;
	            }
	            return file.sourceMapper = ts.sourcemaps.decode({
	                readFile: function (s) { return host.readFile(s); },
	                fileExists: function (s) { return host.fileExists(s); },
	                getCanonicalFileName: getCanonicalFileName,
	                log: log,
	            }, mapFileName, maps, program, sourcemappedFileCache);
	        }
	        function getSourceMapper(fileName, file) {
	            if (!host.readFile || !host.fileExists) {
	                return file.sourceMapper = ts.sourcemaps.identitySourceMapper;
	            }
	            if (file.sourceMapper) {
	                return file.sourceMapper;
	            }
	            var mapFileName = scanForSourcemapURL(fileName);
	            if (mapFileName) {
	                var match = base64UrlRegExp.exec(mapFileName);
	                if (match) {
	                    if (match[1]) {
	                        var base64Object = match[1];
	                        return convertDocumentToSourceMapper(file, ts.base64decode(ts.sys, base64Object), fileName);
	                    }
	                    // Not a data URL we can parse, skip it
	                    mapFileName = undefined;
	                }
	            }
	            var possibleMapLocations = [];
	            if (mapFileName) {
	                possibleMapLocations.push(mapFileName);
	            }
	            possibleMapLocations.push(fileName + ".map");
	            for (var _i = 0, possibleMapLocations_1 = possibleMapLocations; _i < possibleMapLocations_1.length; _i++) {
	                var location = possibleMapLocations_1[_i];
	                var mapPath = ts.toPath(location, ts.getDirectoryPath(fileName), getCanonicalFileName);
	                if (host.fileExists(mapPath)) {
	                    return convertDocumentToSourceMapper(file, host.readFile(mapPath), mapPath);
	                }
	            }
	            return file.sourceMapper = ts.sourcemaps.identitySourceMapper;
	        }
	        function makeGetTargetOfMappedPosition(extract, create) {
	            return getTargetOfMappedPosition;
	            function getTargetOfMappedPosition(input, original) {
	                if (original === void 0) { original = input; }
	                var info = extract(input);
	                if (ts.endsWith(info.fileName, ".d.ts" /* Dts */)) {
	                    var file_18 = program.getSourceFile(info.fileName);
	                    if (!file_18) {
	                        var path = ts.toPath(info.fileName, currentDirectory, getCanonicalFileName);
	                        file_18 = sourcemappedFileCache.get(path);
	                    }
	                    if (!file_18) {
	                        return input;
	                    }
	                    var mapper = getSourceMapper(info.fileName, file_18);
	                    var newLoc = mapper.getOriginalPosition(info);
	                    if (newLoc === info)
	                        return input;
	                    return getTargetOfMappedPosition(create(newLoc, input, original), original);
	                }
	                return input;
	            }
	        }
	        var getTargetOfMappedDeclarationInfo = makeGetTargetOfMappedPosition(function (info) { return ({ fileName: info.fileName, position: info.textSpan.start }); }, function (newLoc, info, original) { return ({
	            containerKind: info.containerKind,
	            containerName: info.containerName,
	            fileName: newLoc.fileName,
	            kind: info.kind,
	            name: info.name,
	            textSpan: {
	                start: newLoc.position,
	                length: info.textSpan.length
	            },
	            originalFileName: original.fileName,
	            originalTextSpan: original.textSpan
	        }); });
	        function getTargetOfMappedDeclarationFiles(infos) {
	            return ts.map(infos, function (d) { return getTargetOfMappedDeclarationInfo(d); });
	        }
	        /// Goto definition
	        function getDefinitionAtPosition(fileName, position) {
	            synchronizeHostData();
	            return getTargetOfMappedDeclarationFiles(ts.GoToDefinition.getDefinitionAtPosition(program, getValidSourceFile(fileName), position));
	        }
	        function getDefinitionAndBoundSpan(fileName, position) {
	            synchronizeHostData();
	            var result = ts.GoToDefinition.getDefinitionAndBoundSpan(program, getValidSourceFile(fileName), position);
	            if (!result)
	                return result;
	            var mappedDefs = getTargetOfMappedDeclarationFiles(result.definitions);
	            if (mappedDefs === result.definitions) {
	                return result;
	            }
	            return {
	                definitions: mappedDefs,
	                textSpan: result.textSpan
	            };
	        }
	        function getTypeDefinitionAtPosition(fileName, position) {
	            synchronizeHostData();
	            return getTargetOfMappedDeclarationFiles(ts.GoToDefinition.getTypeDefinitionAtPosition(program.getTypeChecker(), getValidSourceFile(fileName), position));
	        }
	        /// Goto implementation
	        var getTargetOfMappedImplementationLocation = makeGetTargetOfMappedPosition(function (info) { return ({ fileName: info.fileName, position: info.textSpan.start }); }, function (newLoc, info) { return ({
	            fileName: newLoc.fileName,
	            kind: info.kind,
	            displayParts: info.displayParts,
	            textSpan: {
	                start: newLoc.position,
	                length: info.textSpan.length
	            },
	            originalFileName: info.fileName,
	            originalTextSpan: info.textSpan
	        }); });
	        function getTargetOfMappedImplementationLocations(infos) {
	            return ts.map(infos, function (d) { return getTargetOfMappedImplementationLocation(d); });
	        }
	        function getImplementationAtPosition(fileName, position) {
	            synchronizeHostData();
	            return getTargetOfMappedImplementationLocations(ts.FindAllReferences.getImplementationsAtPosition(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position));
	        }
	        /// References and Occurrences
	        function getOccurrencesAtPosition(fileName, position) {
	            return ts.flatMap(getDocumentHighlights(fileName, position, [fileName]), function (entry) { return entry.highlightSpans.map(function (highlightSpan) { return ({
	                fileName: entry.fileName,
	                textSpan: highlightSpan.textSpan,
	                isWriteAccess: highlightSpan.kind === "writtenReference" /* writtenReference */,
	                isDefinition: false,
	                isInString: highlightSpan.isInString,
	            }); }); });
	        }
	        function getDocumentHighlights(fileName, position, filesToSearch) {
	            ts.Debug.assert(filesToSearch.some(function (f) { return ts.normalizePath(f) === fileName; }));
	            synchronizeHostData();
	            var sourceFilesToSearch = ts.map(filesToSearch, function (f) { return ts.Debug.assertDefined(program.getSourceFile(f)); });
	            var sourceFile = getValidSourceFile(fileName);
	            return ts.DocumentHighlights.getDocumentHighlights(program, cancellationToken, sourceFile, position, sourceFilesToSearch);
	        }
	        function findRenameLocations(fileName, position, findInStrings, findInComments) {
	            return getReferences(fileName, position, { findInStrings: findInStrings, findInComments: findInComments, isForRename: true });
	        }
	        function getReferencesAtPosition(fileName, position) {
	            return getReferences(fileName, position);
	        }
	        function getReferences(fileName, position, options) {
	            synchronizeHostData();
	            // Exclude default library when renaming as commonly user don't want to change that file.
	            var sourceFiles = [];
	            if (options && options.isForRename) {
	                for (var _i = 0, _a = program.getSourceFiles(); _i < _a.length; _i++) {
	                    var sourceFile = _a[_i];
	                    if (!program.isSourceFileDefaultLibrary(sourceFile)) {
	                        sourceFiles.push(sourceFile);
	                    }
	                }
	            }
	            else {
	                sourceFiles = program.getSourceFiles().slice();
	            }
	            return ts.FindAllReferences.findReferencedEntries(program, cancellationToken, sourceFiles, getValidSourceFile(fileName), position, options);
	        }
	        function findReferences(fileName, position) {
	            synchronizeHostData();
	            return ts.FindAllReferences.findReferencedSymbols(program, cancellationToken, program.getSourceFiles(), getValidSourceFile(fileName), position);
	        }
	        /// NavigateTo
	        function getNavigateToItems(searchValue, maxResultCount, fileName, excludeDtsFiles) {
	            synchronizeHostData();
	            var sourceFiles = fileName ? [getValidSourceFile(fileName)] : program.getSourceFiles();
	            return ts.NavigateTo.getNavigateToItems(sourceFiles, program.getTypeChecker(), cancellationToken, searchValue, maxResultCount, excludeDtsFiles);
	        }
	        function getEmitOutput(fileName, emitOnlyDtsFiles) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var customTransformers = host.getCustomTransformers && host.getCustomTransformers();
	            return ts.getFileEmitOutput(program, sourceFile, emitOnlyDtsFiles, cancellationToken, customTransformers);
	        }
	        // Signature help
	        /**
	         * This is a semantic operation.
	         */
	        function getSignatureHelpItems(fileName, position) {
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            return ts.SignatureHelp.getSignatureHelpItems(program, sourceFile, position, cancellationToken);
	        }
	        /// Syntactic features
	        function getNonBoundSourceFile(fileName) {
	            return syntaxTreeCache.getCurrentSourceFile(fileName);
	        }
	        function getSourceFile(fileName) {
	            return getNonBoundSourceFile(fileName);
	        }
	        function getNameOrDottedNameSpan(fileName, startPos, _endPos) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            // Get node at the location
	            var node = ts.getTouchingPropertyName(sourceFile, startPos, /*includeJsDocComment*/ false);
	            if (node === sourceFile) {
	                return;
	            }
	            switch (node.kind) {
	                case 184 /* PropertyAccessExpression */:
	                case 145 /* QualifiedName */:
	                case 9 /* StringLiteral */:
	                case 86 /* FalseKeyword */:
	                case 101 /* TrueKeyword */:
	                case 95 /* NullKeyword */:
	                case 97 /* SuperKeyword */:
	                case 99 /* ThisKeyword */:
	                case 173 /* ThisType */:
	                case 71 /* Identifier */:
	                    break;
	                // Cant create the text span
	                default:
	                    return;
	            }
	            var nodeForStartPos = node;
	            while (true) {
	                if (ts.isRightSideOfPropertyAccess(nodeForStartPos) || ts.isRightSideOfQualifiedName(nodeForStartPos)) {
	                    // If on the span is in right side of the the property or qualified name, return the span from the qualified name pos to end of this node
	                    nodeForStartPos = nodeForStartPos.parent;
	                }
	                else if (ts.isNameOfModuleDeclaration(nodeForStartPos)) {
	                    // If this is name of a module declarations, check if this is right side of dotted module name
	                    // If parent of the module declaration which is parent of this node is module declaration and its body is the module declaration that this node is name of
	                    // Then this name is name from dotted module
	                    if (nodeForStartPos.parent.parent.kind === 238 /* ModuleDeclaration */ &&
	                        nodeForStartPos.parent.parent.body === nodeForStartPos.parent) {
	                        // Use parent module declarations name for start pos
	                        nodeForStartPos = nodeForStartPos.parent.parent.name;
	                    }
	                    else {
	                        // We have to use this name for start pos
	                        break;
	                    }
	                }
	                else {
	                    // Is not a member expression so we have found the node for start pos
	                    break;
	                }
	            }
	            return ts.createTextSpanFromBounds(nodeForStartPos.getStart(), node.getEnd());
	        }
	        function getBreakpointStatementAtPosition(fileName, position) {
	            // doesn't use compiler - no need to synchronize with host
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.BreakpointResolver.spanInSourceFileAtLocation(sourceFile, position);
	        }
	        function getNavigationBarItems(fileName) {
	            return ts.NavigationBar.getNavigationBarItems(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
	        }
	        function getNavigationTree(fileName) {
	            return ts.NavigationBar.getNavigationTree(syntaxTreeCache.getCurrentSourceFile(fileName), cancellationToken);
	        }
	        function isTsOrTsxFile(fileName) {
	            var kind = ts.getScriptKind(fileName, host);
	            return kind === 3 /* TS */ || kind === 4 /* TSX */;
	        }
	        function getSemanticClassifications(fileName, span) {
	            if (!isTsOrTsxFile(fileName)) {
	                // do not run semantic classification on non-ts-or-tsx files
	                return [];
	            }
	            synchronizeHostData();
	            return ts.getSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
	        }
	        function getEncodedSemanticClassifications(fileName, span) {
	            if (!isTsOrTsxFile(fileName)) {
	                // do not run semantic classification on non-ts-or-tsx files
	                return { spans: [], endOfLineState: 0 /* None */ };
	            }
	            synchronizeHostData();
	            return ts.getEncodedSemanticClassifications(program.getTypeChecker(), cancellationToken, getValidSourceFile(fileName), program.getClassifiableNames(), span);
	        }
	        function getSyntacticClassifications(fileName, span) {
	            // doesn't use compiler - no need to synchronize with host
	            return ts.getSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
	        }
	        function getEncodedSyntacticClassifications(fileName, span) {
	            // doesn't use compiler - no need to synchronize with host
	            return ts.getEncodedSyntacticClassifications(cancellationToken, syntaxTreeCache.getCurrentSourceFile(fileName), span);
	        }
	        function getOutliningSpans(fileName) {
	            // doesn't use compiler - no need to synchronize with host
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.OutliningElementsCollector.collectElements(sourceFile, cancellationToken);
	        }
	        var braceMatching = ts.createMapFromTemplate((_a = {},
	            _a[17 /* OpenBraceToken */] = 18 /* CloseBraceToken */,
	            _a[19 /* OpenParenToken */] = 20 /* CloseParenToken */,
	            _a[21 /* OpenBracketToken */] = 22 /* CloseBracketToken */,
	            _a[29 /* GreaterThanToken */] = 27 /* LessThanToken */,
	            _a));
	        braceMatching.forEach(function (value, key) { return braceMatching.set(value.toString(), Number(key)); });
	        function getBraceMatchingAtPosition(fileName, position) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var token = ts.getTouchingToken(sourceFile, position, /*includeJsDocComment*/ false);
	            var matchKind = token.getStart(sourceFile) === position ? braceMatching.get(token.kind.toString()) : undefined;
	            var match = matchKind && ts.findChildOfKind(token.parent, matchKind, sourceFile);
	            // We want to order the braces when we return the result.
	            return match ? [ts.createTextSpanFromNode(token, sourceFile), ts.createTextSpanFromNode(match, sourceFile)].sort(function (a, b) { return a.start - b.start; }) : ts.emptyArray;
	        }
	        function getIndentationAtPosition(fileName, position, editorOptions) {
	            var start = ts.timestamp();
	            var settings = toEditorSettings(editorOptions);
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            log("getIndentationAtPosition: getCurrentSourceFile: " + (ts.timestamp() - start));
	            start = ts.timestamp();
	            var result = ts.formatting.SmartIndenter.getIndentation(position, sourceFile, settings);
	            log("getIndentationAtPosition: computeIndentation  : " + (ts.timestamp() - start));
	            return result;
	        }
	        function getFormattingEditsForRange(fileName, start, end, options) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            return ts.formatting.formatSelection(start, end, sourceFile, ts.formatting.getFormatContext(toEditorSettings(options)));
	        }
	        function getFormattingEditsForDocument(fileName, options) {
	            return ts.formatting.formatDocument(syntaxTreeCache.getCurrentSourceFile(fileName), ts.formatting.getFormatContext(toEditorSettings(options)));
	        }
	        function getFormattingEditsAfterKeystroke(fileName, position, key, options) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var formatContext = ts.formatting.getFormatContext(toEditorSettings(options));
	            if (!ts.isInComment(sourceFile, position)) {
	                switch (key) {
	                    case "{":
	                        return ts.formatting.formatOnOpeningCurly(position, sourceFile, formatContext);
	                    case "}":
	                        return ts.formatting.formatOnClosingCurly(position, sourceFile, formatContext);
	                    case ";":
	                        return ts.formatting.formatOnSemicolon(position, sourceFile, formatContext);
	                    case "\n":
	                        return ts.formatting.formatOnEnter(position, sourceFile, formatContext);
	                }
	            }
	            return [];
	        }
	        function getCodeFixesAtPosition(fileName, start, end, errorCodes, formatOptions, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            var span = ts.createTextSpanFromBounds(start, end);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.flatMap(ts.deduplicate(errorCodes, ts.equateValues, ts.compareValues), function (errorCode) {
	                cancellationToken.throwIfCancellationRequested();
	                return ts.codefix.getFixes({ errorCode: errorCode, sourceFile: sourceFile, span: span, program: program, host: host, cancellationToken: cancellationToken, formatContext: formatContext, preferences: preferences });
	            });
	        }
	        function getCombinedCodeFix(scope, fixId, formatOptions, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            ts.Debug.assert(scope.type === "file");
	            var sourceFile = getValidSourceFile(scope.fileName);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.codefix.getAllFixes({ fixId: fixId, sourceFile: sourceFile, program: program, host: host, cancellationToken: cancellationToken, formatContext: formatContext, preferences: preferences });
	        }
	        function organizeImports(scope, formatOptions, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            ts.Debug.assert(scope.type === "file");
	            var sourceFile = getValidSourceFile(scope.fileName);
	            var formatContext = ts.formatting.getFormatContext(formatOptions);
	            return ts.OrganizeImports.organizeImports(sourceFile, formatContext, host, program, preferences);
	        }
	        function getEditsForFileRename(oldFilePath, newFilePath, formatOptions, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            return ts.getEditsForFileRename(getProgram(), oldFilePath, newFilePath, host, ts.formatting.getFormatContext(formatOptions), preferences);
	        }
	        function applyCodeActionCommand(fileName, actionOrUndefined) {
	            var action = typeof fileName === "string" ? actionOrUndefined : fileName;
	            return ts.isArray(action) ? Promise.all(action.map(applySingleCodeActionCommand)) : applySingleCodeActionCommand(action);
	        }
	        function applySingleCodeActionCommand(action) {
	            switch (action.type) {
	                case "install package":
	                    return host.installPackage
	                        ? host.installPackage({ fileName: ts.toPath(action.file, currentDirectory, getCanonicalFileName), packageName: action.packageName })
	                        : Promise.reject("Host does not implement `installPackage`");
	                default:
	                    ts.Debug.fail();
	                // TODO: Debug.assertNever(action); will only work if there is more than one type.
	            }
	        }
	        function getDocCommentTemplateAtPosition(fileName, position) {
	            return ts.JsDoc.getDocCommentTemplateAtPosition(ts.getNewLineOrDefaultFromHost(host), syntaxTreeCache.getCurrentSourceFile(fileName), position);
	        }
	        function isValidBraceCompletionAtPosition(fileName, position, openingBrace) {
	            // '<' is currently not supported, figuring out if we're in a Generic Type vs. a comparison is too
	            // expensive to do during typing scenarios
	            // i.e. whether we're dealing with:
	            //      var x = new foo<| ( with class foo<T>{} )
	            // or
	            //      var y = 3 <|
	            if (openingBrace === 60 /* lessThan */) {
	                return false;
	            }
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            // Check if in a context where we don't want to perform any insertion
	            if (ts.isInString(sourceFile, position)) {
	                return false;
	            }
	            if (ts.isInsideJsxElementOrAttribute(sourceFile, position)) {
	                return openingBrace === 123 /* openBrace */;
	            }
	            if (ts.isInTemplateString(sourceFile, position)) {
	                return false;
	            }
	            switch (openingBrace) {
	                case 39 /* singleQuote */:
	                case 34 /* doubleQuote */:
	                case 96 /* backtick */:
	                    return !ts.isInComment(sourceFile, position);
	            }
	            return true;
	        }
	        function getSpanOfEnclosingComment(fileName, position, onlyMultiLine) {
	            var sourceFile = syntaxTreeCache.getCurrentSourceFile(fileName);
	            var range = ts.formatting.getRangeOfEnclosingComment(sourceFile, position, onlyMultiLine);
	            return range && ts.createTextSpanFromRange(range);
	        }
	        function getTodoComments(fileName, descriptors) {
	            // Note: while getting todo comments seems like a syntactic operation, we actually
	            // treat it as a semantic operation here.  This is because we expect our host to call
	            // this on every single file.  If we treat this syntactically, then that will cause
	            // us to populate and throw away the tree in our syntax tree cache for each file.  By
	            // treating this as a semantic operation, we can access any tree without throwing
	            // anything away.
	            synchronizeHostData();
	            var sourceFile = getValidSourceFile(fileName);
	            cancellationToken.throwIfCancellationRequested();
	            var fileContents = sourceFile.text;
	            var result = [];
	            // Exclude node_modules files as we don't want to show the todos of external libraries.
	            if (descriptors.length > 0 && !isNodeModulesFile(sourceFile.fileName)) {
	                var regExp = getTodoCommentsRegExp();
	                var matchArray = void 0;
	                while (matchArray = regExp.exec(fileContents)) {
	                    cancellationToken.throwIfCancellationRequested();
	                    // If we got a match, here is what the match array will look like.  Say the source text is:
	                    //
	                    //      "    // hack   1"
	                    //
	                    // The result array with the regexp:    will be:
	                    //
	                    //      ["// hack   1", "// ", "hack   1", undefined, "hack"]
	                    //
	                    // Here are the relevant capture groups:
	                    //  0) The full match for the entire regexp.
	                    //  1) The preamble to the message portion.
	                    //  2) The message portion.
	                    //  3...N) The descriptor that was matched - by index.  'undefined' for each
	                    //         descriptor that didn't match.  an actual value if it did match.
	                    //
	                    //  i.e. 'undefined' in position 3 above means TODO(jason) didn't match.
	                    //       "hack"      in position 4 means HACK did match.
	                    var firstDescriptorCaptureIndex = 3;
	                    ts.Debug.assert(matchArray.length === descriptors.length + firstDescriptorCaptureIndex);
	                    var preamble = matchArray[1];
	                    var matchPosition = matchArray.index + preamble.length;
	                    // OK, we have found a match in the file.  This is only an acceptable match if
	                    // it is contained within a comment.
	                    if (!ts.isInComment(sourceFile, matchPosition)) {
	                        continue;
	                    }
	                    var descriptor = void 0;
	                    for (var i = 0; i < descriptors.length; i++) {
	                        if (matchArray[i + firstDescriptorCaptureIndex]) {
	                            descriptor = descriptors[i];
	                        }
	                    }
	                    ts.Debug.assert(descriptor !== undefined);
	                    // We don't want to match something like 'TODOBY', so we make sure a non
	                    // letter/digit follows the match.
	                    if (isLetterOrDigit(fileContents.charCodeAt(matchPosition + descriptor.text.length))) {
	                        continue;
	                    }
	                    var message = matchArray[2];
	                    result.push({ descriptor: descriptor, message: message, position: matchPosition });
	                }
	            }
	            return result;
	            function escapeRegExp(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            }
	            function getTodoCommentsRegExp() {
	                // NOTE: `?:` means 'non-capture group'.  It allows us to have groups without having to
	                // filter them out later in the final result array.
	                // TODO comments can appear in one of the following forms:
	                //
	                //  1)      // TODO     or  /////////// TODO
	                //
	                //  2)      /* TODO     or  /********** TODO
	                //
	                //  3)      /*
	                //           *   TODO
	                //           */
	                //
	                // The following three regexps are used to match the start of the text up to the TODO
	                // comment portion.
	                var singleLineCommentStart = /(?:\/\/+\s*)/.source;
	                var multiLineCommentStart = /(?:\/\*+\s*)/.source;
	                var anyNumberOfSpacesAndAsterisksAtStartOfLine = /(?:^(?:\s|\*)*)/.source;
	                // Match any of the above three TODO comment start regexps.
	                // Note that the outermost group *is* a capture group.  We want to capture the preamble
	                // so that we can determine the starting position of the TODO comment match.
	                var preamble = "(" + anyNumberOfSpacesAndAsterisksAtStartOfLine + "|" + singleLineCommentStart + "|" + multiLineCommentStart + ")";
	                // Takes the descriptors and forms a regexp that matches them as if they were literals.
	                // For example, if the descriptors are "TODO(jason)" and "HACK", then this will be:
	                //
	                //      (?:(TODO\(jason\))|(HACK))
	                //
	                // Note that the outermost group is *not* a capture group, but the innermost groups
	                // *are* capture groups.  By capturing the inner literals we can determine after
	                // matching which descriptor we are dealing with.
	                var literals = "(?:" + ts.map(descriptors, function (d) { return "(" + escapeRegExp(d.text) + ")"; }).join("|") + ")";
	                // After matching a descriptor literal, the following regexp matches the rest of the
	                // text up to the end of the line (or */).
	                var endOfLineOrEndOfComment = /(?:$|\*\/)/.source;
	                var messageRemainder = /(?:.*?)/.source;
	                // This is the portion of the match we'll return as part of the TODO comment result. We
	                // match the literal portion up to the end of the line or end of comment.
	                var messagePortion = "(" + literals + messageRemainder + ")";
	                var regExpString = preamble + messagePortion + endOfLineOrEndOfComment;
	                // The final regexp will look like this:
	                // /((?:\/\/+\s*)|(?:\/\*+\s*)|(?:^(?:\s|\*)*))((?:(TODO\(jason\))|(HACK))(?:.*?))(?:$|\*\/)/gim
	                // The flags of the regexp are important here.
	                //  'g' is so that we are doing a global search and can find matches several times
	                //  in the input.
	                //
	                //  'i' is for case insensitivity (We do this to match C# TODO comment code).
	                //
	                //  'm' is so we can find matches in a multi-line input.
	                return new RegExp(regExpString, "gim");
	            }
	            function isLetterOrDigit(char) {
	                return (char >= 97 /* a */ && char <= 122 /* z */) ||
	                    (char >= 65 /* A */ && char <= 90 /* Z */) ||
	                    (char >= 48 /* _0 */ && char <= 57 /* _9 */);
	            }
	            function isNodeModulesFile(path) {
	                return ts.stringContains(path, "/node_modules/");
	            }
	        }
	        function getRenameInfo(fileName, position) {
	            synchronizeHostData();
	            var defaultLibFileName = host.getDefaultLibFileName(host.getCompilationSettings());
	            return ts.Rename.getRenameInfo(program.getTypeChecker(), defaultLibFileName, getCanonicalFileName, getValidSourceFile(fileName), position);
	        }
	        function getRefactorContext(file, positionOrRange, preferences, formatOptions) {
	            var _a = typeof positionOrRange === "number" ? [positionOrRange, undefined] : [positionOrRange.pos, positionOrRange.end], startPosition = _a[0], endPosition = _a[1];
	            return {
	                file: file,
	                startPosition: startPosition,
	                endPosition: endPosition,
	                program: getProgram(),
	                host: host,
	                formatContext: ts.formatting.getFormatContext(formatOptions),
	                cancellationToken: cancellationToken,
	                preferences: preferences,
	            };
	        }
	        function getApplicableRefactors(fileName, positionOrRange, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            var file = getValidSourceFile(fileName);
	            return ts.refactor.getApplicableRefactors(getRefactorContext(file, positionOrRange, preferences));
	        }
	        function getEditsForRefactor(fileName, formatOptions, positionOrRange, refactorName, actionName, preferences) {
	            if (preferences === void 0) { preferences = ts.defaultPreferences; }
	            synchronizeHostData();
	            var file = getValidSourceFile(fileName);
	            return ts.refactor.getEditsForRefactor(getRefactorContext(file, positionOrRange, preferences, formatOptions), refactorName, actionName);
	        }
	        return {
	            dispose: dispose,
	            cleanupSemanticCache: cleanupSemanticCache,
	            getSyntacticDiagnostics: getSyntacticDiagnostics,
	            getSemanticDiagnostics: getSemanticDiagnostics,
	            getSuggestionDiagnostics: getSuggestionDiagnostics,
	            getCompilerOptionsDiagnostics: getCompilerOptionsDiagnostics,
	            getSyntacticClassifications: getSyntacticClassifications,
	            getSemanticClassifications: getSemanticClassifications,
	            getEncodedSyntacticClassifications: getEncodedSyntacticClassifications,
	            getEncodedSemanticClassifications: getEncodedSemanticClassifications,
	            getCompletionsAtPosition: getCompletionsAtPosition,
	            getCompletionEntryDetails: getCompletionEntryDetails,
	            getCompletionEntrySymbol: getCompletionEntrySymbol,
	            getSignatureHelpItems: getSignatureHelpItems,
	            getQuickInfoAtPosition: getQuickInfoAtPosition,
	            getDefinitionAtPosition: getDefinitionAtPosition,
	            getDefinitionAndBoundSpan: getDefinitionAndBoundSpan,
	            getImplementationAtPosition: getImplementationAtPosition,
	            getTypeDefinitionAtPosition: getTypeDefinitionAtPosition,
	            getReferencesAtPosition: getReferencesAtPosition,
	            findReferences: findReferences,
	            getOccurrencesAtPosition: getOccurrencesAtPosition,
	            getDocumentHighlights: getDocumentHighlights,
	            getNameOrDottedNameSpan: getNameOrDottedNameSpan,
	            getBreakpointStatementAtPosition: getBreakpointStatementAtPosition,
	            getNavigateToItems: getNavigateToItems,
	            getRenameInfo: getRenameInfo,
	            findRenameLocations: findRenameLocations,
	            getNavigationBarItems: getNavigationBarItems,
	            getNavigationTree: getNavigationTree,
	            getOutliningSpans: getOutliningSpans,
	            getTodoComments: getTodoComments,
	            getBraceMatchingAtPosition: getBraceMatchingAtPosition,
	            getIndentationAtPosition: getIndentationAtPosition,
	            getFormattingEditsForRange: getFormattingEditsForRange,
	            getFormattingEditsForDocument: getFormattingEditsForDocument,
	            getFormattingEditsAfterKeystroke: getFormattingEditsAfterKeystroke,
	            getDocCommentTemplateAtPosition: getDocCommentTemplateAtPosition,
	            isValidBraceCompletionAtPosition: isValidBraceCompletionAtPosition,
	            getSpanOfEnclosingComment: getSpanOfEnclosingComment,
	            getCodeFixesAtPosition: getCodeFixesAtPosition,
	            getCombinedCodeFix: getCombinedCodeFix,
	            applyCodeActionCommand: applyCodeActionCommand,
	            organizeImports: organizeImports,
	            getEditsForFileRename: getEditsForFileRename,
	            getEmitOutput: getEmitOutput,
	            getNonBoundSourceFile: getNonBoundSourceFile,
	            getSourceFile: getSourceFile,
	            getProgram: getProgram,
	            getApplicableRefactors: getApplicableRefactors,
	            getEditsForRefactor: getEditsForRefactor,
	            toLineColumnOffset: toLineColumnOffset
	        };
	    }
	    ts.createLanguageService = createLanguageService;
	    /* @internal */
	    /** Names in the name table are escaped, so an identifier `__foo` will have a name table entry `___foo`. */
	    function getNameTable(sourceFile) {
	        if (!sourceFile.nameTable) {
	            initializeNameTable(sourceFile);
	        }
	        return sourceFile.nameTable;
	    }
	    ts.getNameTable = getNameTable;
	    function initializeNameTable(sourceFile) {
	        var nameTable = sourceFile.nameTable = ts.createUnderscoreEscapedMap();
	        sourceFile.forEachChild(function walk(node) {
	            if (ts.isIdentifier(node) && node.escapedText || ts.isStringOrNumericLiteral(node) && literalIsName(node)) {
	                var text = ts.getEscapedTextOfIdentifierOrLiteral(node);
	                nameTable.set(text, nameTable.get(text) === undefined ? node.pos : -1);
	            }
	            ts.forEachChild(node, walk);
	            if (ts.hasJSDocNodes(node)) {
	                for (var _i = 0, _a = node.jsDoc; _i < _a.length; _i++) {
	                    var jsDoc = _a[_i];
	                    ts.forEachChild(jsDoc, walk);
	                }
	            }
	        });
	    }
	    /**
	     * We want to store any numbers/strings if they were a name that could be
	     * related to a declaration.  So, if we have 'import x = require("something")'
	     * then we want 'something' to be in the name table.  Similarly, if we have
	     * "a['propname']" then we want to store "propname" in the name table.
	     */
	    function literalIsName(node) {
	        return ts.isDeclarationName(node) ||
	            node.parent.kind === 253 /* ExternalModuleReference */ ||
	            isArgumentOfElementAccessExpression(node) ||
	            ts.isLiteralComputedPropertyDeclarationName(node);
	    }
	    /**
	     * Returns the containing object literal property declaration given a possible name node, e.g. "a" in x = { "a": 1 }
	     */
	    /* @internal */
	    function getContainingObjectLiteralElement(node) {
	        switch (node.kind) {
	            case 9 /* StringLiteral */:
	            case 8 /* NumericLiteral */:
	                if (node.parent.kind === 146 /* ComputedPropertyName */) {
	                    return ts.isObjectLiteralElement(node.parent.parent) ? node.parent.parent : undefined;
	                }
	            // falls through
	            case 71 /* Identifier */:
	                return ts.isObjectLiteralElement(node.parent) &&
	                    (node.parent.parent.kind === 183 /* ObjectLiteralExpression */ || node.parent.parent.kind === 262 /* JsxAttributes */) &&
	                    node.parent.name === node ? node.parent : undefined;
	        }
	        return undefined;
	    }
	    ts.getContainingObjectLiteralElement = getContainingObjectLiteralElement;
	    /* @internal */
	    function getPropertySymbolsFromContextualType(typeChecker, node) {
	        var objectLiteral = node.parent;
	        var contextualType = typeChecker.getContextualType(objectLiteral);
	        return getPropertySymbolsFromType(contextualType, node.name);
	    }
	    ts.getPropertySymbolsFromContextualType = getPropertySymbolsFromContextualType;
	    /* @internal */
	    function getPropertySymbolsFromType(type, propName) {
	        var name = ts.unescapeLeadingUnderscores(ts.getTextOfPropertyName(propName));
	        if (name && type) {
	            var result_7 = [];
	            var symbol = type.getProperty(name);
	            if (type.flags & 131072 /* Union */) {
	                ts.forEach(type.types, function (t) {
	                    var symbol = t.getProperty(name);
	                    if (symbol) {
	                        result_7.push(symbol);
	                    }
	                });
	                return result_7;
	            }
	            if (symbol) {
	                result_7.push(symbol);
	                return result_7;
	            }
	        }
	        return undefined;
	    }
	    ts.getPropertySymbolsFromType = getPropertySymbolsFromType;
	    function isArgumentOfElementAccessExpression(node) {
	        return node &&
	            node.parent &&
	            node.parent.kind === 185 /* ElementAccessExpression */ &&
	            node.parent.argumentExpression === node;
	    }
	    /**
	     * Get the path of the default library files (lib.d.ts) as distributed with the typescript
	     * node package.
	     * The functionality is not supported if the ts module is consumed outside of a node module.
	     */
	    function getDefaultLibFilePath(options) {
	        // Check __dirname is defined and that we are on a node.js system.
	        if (true) {
	            return __dirname + ts.directorySeparator + ts.getDefaultLibFileName(options);
	        }
	        throw new Error("getDefaultLibFilePath is only supported when consumed as a node module. ");
	    }
	    ts.getDefaultLibFilePath = getDefaultLibFilePath;
	    ts.objectAllocator = getServicesObjectAllocator();
	})(ts || (ts = {}));
	/* @internal */
	var ts;
	(function (ts) {
	    var BreakpointResolver;
	    (function (BreakpointResolver) {
	        /**
	         * Get the breakpoint span in given sourceFile
	         */
	        function spanInSourceFileAtLocation(sourceFile, position) {
	            // Cannot set breakpoint in dts file
	            if (sourceFile.isDeclarationFile) {
	                return undefined;
	            }
	            var tokenAtLocation = ts.getTokenAtPosition(sourceFile, position, /*includeJsDocComment*/ false);
	            var lineOfPosition = sourceFile.getLineAndCharacterOfPosition(position).line;
	            if (sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getStart(sourceFile)).line > lineOfPosition) {
	                // Get previous token if the token is returned starts on new line
	                // eg: let x =10; |--- cursor is here
	                //     let y = 10;
	                // token at position will return let keyword on second line as the token but we would like to use
	                // token on same line if trailing trivia (comments or white spaces on same line) part of the last token on that line
	                tokenAtLocation = ts.findPrecedingToken(tokenAtLocation.pos, sourceFile);
	                // It's a blank line
	                if (!tokenAtLocation || sourceFile.getLineAndCharacterOfPosition(tokenAtLocation.getEnd()).line !== lineOfPosition) {
	                    return undefined;
	                }
	            }
	            // Cannot set breakpoint in ambient declarations
	            if (tokenAtLocation.flags & 4194304 /* Ambient */) {
	                return undefined;
	            }
	            // Get the span in the node based on its syntax
	            return spanInNode(tokenAtLocation);
	            function textSpan(startNode, endNode) {
	                var start = startNode.decorators ?
	                    ts.skipTrivia(sourceFile.text, startNode.decorators.end) :
	                    startNode.getStart(sourceFile);
	                return ts.createTextSpanFromBounds(start, (endNode || startNode).getEnd());
	            }
	            function textSpanEndingAtNextToken(startNode, previousTokenToFindNextEndToken) {
	                return textSpan(startNode, ts.findNextToken(previousTokenToFindNextEndToken, previousTokenToFindNextEndToken.parent, sourceFile));
	            }
	            function spanInNodeIfStartsOnSameLine(node, otherwiseOnNode) {
	                if (node && lineOfPosition === sourceFile.getLineAndCharacterOfPosition(node.getStart(sourceFile)).line) {
	                    return spanInNode(node);
	                }
	                return spanInNode(otherwiseOnNode);
	            }
	            function spanInNodeArray(nodeArray) {
	                return ts.createTextSpanFromBounds(ts.skipTrivia(sourceFile.text, nodeArray.pos), nodeArray.end);
	            }
	            function spanInPreviousNode(node) {
	                return spanInNode(ts.findPrecedingToken(node.pos, sourceFile));
	            }
	            function spanInNextNode(node) {
	                return spanInNode(ts.findNextToken(node, node.parent, sourceFile));
	            }
	            function spanInNode(node) {
	                if (node) {
	                    switch (node.kind) {
	                        case 213 /* VariableStatement */:
	                            // Span on first variable declaration
	                            return spanInVariableDeclaration(node.declarationList.declarations[0]);
	                        case 231 /* VariableDeclaration */:
	                        case 151 /* PropertyDeclaration */:
	                        case 150 /* PropertySignature */:
	                            return spanInVariableDeclaration(node);
	                        case 148 /* Parameter */:
	                            return spanInParameterDeclaration(node);
	                        case 233 /* FunctionDeclaration */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 154 /* Constructor */:
	                        case 191 /* FunctionExpression */:
	                        case 192 /* ArrowFunction */:
	                            return spanInFunctionDeclaration(node);
	                        case 212 /* Block */:
	                            if (ts.isFunctionBlock(node)) {
	                                return spanInFunctionBlock(node);
	                            }
	                        // falls through
	                        case 239 /* ModuleBlock */:
	                            return spanInBlock(node);
	                        case 268 /* CatchClause */:
	                            return spanInBlock(node.block);
	                        case 215 /* ExpressionStatement */:
	                            // span on the expression
	                            return textSpan(node.expression);
	                        case 224 /* ReturnStatement */:
	                            // span on return keyword and expression if present
	                            return textSpan(node.getChildAt(0), node.expression);
	                        case 218 /* WhileStatement */:
	                            // Span on while(...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 217 /* DoStatement */:
	                            // span in statement of the do statement
	                            return spanInNode(node.statement);
	                        case 230 /* DebuggerStatement */:
	                            // span on debugger keyword
	                            return textSpan(node.getChildAt(0));
	                        case 216 /* IfStatement */:
	                            // set on if(..) span
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 227 /* LabeledStatement */:
	                            // span in statement
	                            return spanInNode(node.statement);
	                        case 223 /* BreakStatement */:
	                        case 222 /* ContinueStatement */:
	                            // On break or continue keyword and label if present
	                            return textSpan(node.getChildAt(0), node.label);
	                        case 219 /* ForStatement */:
	                            return spanInForStatement(node);
	                        case 220 /* ForInStatement */:
	                            // span of for (a in ...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 221 /* ForOfStatement */:
	                            // span in initializer
	                            return spanInInitializerOfForLike(node);
	                        case 226 /* SwitchStatement */:
	                            // span on switch(...)
	                            return textSpanEndingAtNextToken(node, node.expression);
	                        case 265 /* CaseClause */:
	                        case 266 /* DefaultClause */:
	                            // span in first statement of the clause
	                            return spanInNode(node.statements[0]);
	                        case 229 /* TryStatement */:
	                            // span in try block
	                            return spanInBlock(node.tryBlock);
	                        case 228 /* ThrowStatement */:
	                            // span in throw ...
	                            return textSpan(node, node.expression);
	                        case 248 /* ExportAssignment */:
	                            // span on export = id
	                            return textSpan(node, node.expression);
	                        case 242 /* ImportEqualsDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleReference);
	                        case 243 /* ImportDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleSpecifier);
	                        case 249 /* ExportDeclaration */:
	                            // import statement without including semicolon
	                            return textSpan(node, node.moduleSpecifier);
	                        case 238 /* ModuleDeclaration */:
	                            // span on complete module if it is instantiated
	                            if (ts.getModuleInstanceState(node) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        case 234 /* ClassDeclaration */:
	                        case 237 /* EnumDeclaration */:
	                        case 272 /* EnumMember */:
	                        case 181 /* BindingElement */:
	                            // span on complete node
	                            return textSpan(node);
	                        case 225 /* WithStatement */:
	                            // span in statement
	                            return spanInNode(node.statement);
	                        case 149 /* Decorator */:
	                            return spanInNodeArray(node.parent.decorators);
	                        case 179 /* ObjectBindingPattern */:
	                        case 180 /* ArrayBindingPattern */:
	                            return spanInBindingPattern(node);
	                        // No breakpoint in interface, type alias
	                        case 235 /* InterfaceDeclaration */:
	                        case 236 /* TypeAliasDeclaration */:
	                            return undefined;
	                        // Tokens:
	                        case 25 /* SemicolonToken */:
	                        case 1 /* EndOfFileToken */:
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile));
	                        case 26 /* CommaToken */:
	                            return spanInPreviousNode(node);
	                        case 17 /* OpenBraceToken */:
	                            return spanInOpenBraceToken(node);
	                        case 18 /* CloseBraceToken */:
	                            return spanInCloseBraceToken(node);
	                        case 22 /* CloseBracketToken */:
	                            return spanInCloseBracketToken(node);
	                        case 19 /* OpenParenToken */:
	                            return spanInOpenParenToken(node);
	                        case 20 /* CloseParenToken */:
	                            return spanInCloseParenToken(node);
	                        case 56 /* ColonToken */:
	                            return spanInColonToken(node);
	                        case 29 /* GreaterThanToken */:
	                        case 27 /* LessThanToken */:
	                            return spanInGreaterThanOrLessThanToken(node);
	                        // Keywords:
	                        case 106 /* WhileKeyword */:
	                            return spanInWhileKeyword(node);
	                        case 82 /* ElseKeyword */:
	                        case 74 /* CatchKeyword */:
	                        case 87 /* FinallyKeyword */:
	                            return spanInNextNode(node);
	                        case 144 /* OfKeyword */:
	                            return spanInOfKeyword(node);
	                        default:
	                            // Destructuring pattern in destructuring assignment
	                            // [a, b, c] of
	                            // [a, b, c] = expression
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node)) {
	                                return spanInArrayLiteralOrObjectLiteralDestructuringPattern(node);
	                            }
	                            // Set breakpoint on identifier element of destructuring pattern
	                            // `a` or `...c` or `d: x` from
	                            // `[a, b, ...c]` or `{ a, b }` or `{ d: x }` from destructuring pattern
	                            if ((node.kind === 71 /* Identifier */ ||
	                                node.kind === 203 /* SpreadElement */ ||
	                                node.kind === 269 /* PropertyAssignment */ ||
	                                node.kind === 270 /* ShorthandPropertyAssignment */) &&
	                                ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                return textSpan(node);
	                            }
	                            if (node.kind === 199 /* BinaryExpression */) {
	                                var _a = node, left = _a.left, operatorToken = _a.operatorToken;
	                                // Set breakpoint in destructuring pattern if its destructuring assignment
	                                // [a, b, c] or {a, b, c} of
	                                // [a, b, c] = expression or
	                                // {a, b, c} = expression
	                                if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(left)) {
	                                    return spanInArrayLiteralOrObjectLiteralDestructuringPattern(left);
	                                }
	                                if (operatorToken.kind === 58 /* EqualsToken */ && ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                    // Set breakpoint on assignment expression element of destructuring pattern
	                                    // a = expression of
	                                    // [a = expression, b, c] = someExpression or
	                                    // { a = expression, b, c } = someExpression
	                                    return textSpan(node);
	                                }
	                                if (operatorToken.kind === 26 /* CommaToken */) {
	                                    return spanInNode(left);
	                                }
	                            }
	                            if (ts.isExpressionNode(node)) {
	                                switch (node.parent.kind) {
	                                    case 217 /* DoStatement */:
	                                        // Set span as if on while keyword
	                                        return spanInPreviousNode(node);
	                                    case 149 /* Decorator */:
	                                        // Set breakpoint on the decorator emit
	                                        return spanInNode(node.parent);
	                                    case 219 /* ForStatement */:
	                                    case 221 /* ForOfStatement */:
	                                        return textSpan(node);
	                                    case 199 /* BinaryExpression */:
	                                        if (node.parent.operatorToken.kind === 26 /* CommaToken */) {
	                                            // If this is a comma expression, the breakpoint is possible in this expression
	                                            return textSpan(node);
	                                        }
	                                        break;
	                                    case 192 /* ArrowFunction */:
	                                        if (node.parent.body === node) {
	                                            // If this is body of arrow function, it is allowed to have the breakpoint
	                                            return textSpan(node);
	                                        }
	                                        break;
	                                }
	                            }
	                            switch (node.parent.kind) {
	                                case 269 /* PropertyAssignment */:
	                                    // If this is name of property assignment, set breakpoint in the initializer
	                                    if (node.parent.name === node &&
	                                        !ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent.parent)) {
	                                        return spanInNode(node.parent.initializer);
	                                    }
	                                    break;
	                                case 189 /* TypeAssertionExpression */:
	                                    // Breakpoint in type assertion goes to its operand
	                                    if (node.parent.type === node) {
	                                        return spanInNextNode(node.parent.type);
	                                    }
	                                    break;
	                                case 231 /* VariableDeclaration */:
	                                case 148 /* Parameter */: {
	                                    // initializer of variable/parameter declaration go to previous node
	                                    var _b = node.parent, initializer = _b.initializer, type = _b.type;
	                                    if (initializer === node || type === node || ts.isAssignmentOperator(node.kind)) {
	                                        return spanInPreviousNode(node);
	                                    }
	                                    break;
	                                }
	                                case 199 /* BinaryExpression */: {
	                                    var left = node.parent.left;
	                                    if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(left) && node !== left) {
	                                        // If initializer of destructuring assignment move to previous token
	                                        return spanInPreviousNode(node);
	                                    }
	                                    break;
	                                }
	                                default:
	                                    // return type of function go to previous token
	                                    if (ts.isFunctionLike(node.parent) && node.parent.type === node) {
	                                        return spanInPreviousNode(node);
	                                    }
	                            }
	                            // Default go to parent to set the breakpoint
	                            return spanInNode(node.parent);
	                    }
	                }
	                function textSpanFromVariableDeclaration(variableDeclaration) {
	                    if (ts.isVariableDeclarationList(variableDeclaration.parent) && variableDeclaration.parent.declarations[0] === variableDeclaration) {
	                        // First declaration - include let keyword
	                        return textSpan(ts.findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent), variableDeclaration);
	                    }
	                    else {
	                        // Span only on this declaration
	                        return textSpan(variableDeclaration);
	                    }
	                }
	                function spanInVariableDeclaration(variableDeclaration) {
	                    // If declaration of for in statement, just set the span in parent
	                    if (variableDeclaration.parent.parent.kind === 220 /* ForInStatement */) {
	                        return spanInNode(variableDeclaration.parent.parent);
	                    }
	                    // If this is a destructuring pattern, set breakpoint in binding pattern
	                    if (ts.isBindingPattern(variableDeclaration.name)) {
	                        return spanInBindingPattern(variableDeclaration.name);
	                    }
	                    // Breakpoint is possible in variableDeclaration only if there is initialization
	                    // or its declaration from 'for of'
	                    if (variableDeclaration.initializer ||
	                        ts.hasModifier(variableDeclaration, 1 /* Export */) ||
	                        variableDeclaration.parent.parent.kind === 221 /* ForOfStatement */) {
	                        return textSpanFromVariableDeclaration(variableDeclaration);
	                    }
	                    if (ts.isVariableDeclarationList(variableDeclaration.parent) &&
	                        variableDeclaration.parent.declarations[0] !== variableDeclaration) {
	                        // If we cannot set breakpoint on this declaration, set it on previous one
	                        // Because the variable declaration may be binding pattern and
	                        // we would like to set breakpoint in last binding element if that's the case,
	                        // use preceding token instead
	                        return spanInNode(ts.findPrecedingToken(variableDeclaration.pos, sourceFile, variableDeclaration.parent));
	                    }
	                }
	                function canHaveSpanInParameterDeclaration(parameter) {
	                    // Breakpoint is possible on parameter only if it has initializer, is a rest parameter, or has public or private modifier
	                    return !!parameter.initializer || parameter.dotDotDotToken !== undefined ||
	                        ts.hasModifier(parameter, 4 /* Public */ | 8 /* Private */);
	                }
	                function spanInParameterDeclaration(parameter) {
	                    if (ts.isBindingPattern(parameter.name)) {
	                        // Set breakpoint in binding pattern
	                        return spanInBindingPattern(parameter.name);
	                    }
	                    else if (canHaveSpanInParameterDeclaration(parameter)) {
	                        return textSpan(parameter);
	                    }
	                    else {
	                        var functionDeclaration = parameter.parent;
	                        var indexOfParameter = functionDeclaration.parameters.indexOf(parameter);
	                        ts.Debug.assert(indexOfParameter !== -1);
	                        if (indexOfParameter !== 0) {
	                            // Not a first parameter, go to previous parameter
	                            return spanInParameterDeclaration(functionDeclaration.parameters[indexOfParameter - 1]);
	                        }
	                        else {
	                            // Set breakpoint in the function declaration body
	                            return spanInNode(functionDeclaration.body);
	                        }
	                    }
	                }
	                function canFunctionHaveSpanInWholeDeclaration(functionDeclaration) {
	                    return ts.hasModifier(functionDeclaration, 1 /* Export */) ||
	                        (functionDeclaration.parent.kind === 234 /* ClassDeclaration */ && functionDeclaration.kind !== 154 /* Constructor */);
	                }
	                function spanInFunctionDeclaration(functionDeclaration) {
	                    // No breakpoints in the function signature
	                    if (!functionDeclaration.body) {
	                        return undefined;
	                    }
	                    if (canFunctionHaveSpanInWholeDeclaration(functionDeclaration)) {
	                        // Set the span on whole function declaration
	                        return textSpan(functionDeclaration);
	                    }
	                    // Set span in function body
	                    return spanInNode(functionDeclaration.body);
	                }
	                function spanInFunctionBlock(block) {
	                    var nodeForSpanInBlock = block.statements.length ? block.statements[0] : block.getLastToken();
	                    if (canFunctionHaveSpanInWholeDeclaration(block.parent)) {
	                        return spanInNodeIfStartsOnSameLine(block.parent, nodeForSpanInBlock);
	                    }
	                    return spanInNode(nodeForSpanInBlock);
	                }
	                function spanInBlock(block) {
	                    switch (block.parent.kind) {
	                        case 238 /* ModuleDeclaration */:
	                            if (ts.getModuleInstanceState(block.parent) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        // Set on parent if on same line otherwise on first statement
	                        case 218 /* WhileStatement */:
	                        case 216 /* IfStatement */:
	                        case 220 /* ForInStatement */:
	                            return spanInNodeIfStartsOnSameLine(block.parent, block.statements[0]);
	                        // Set span on previous token if it starts on same line otherwise on the first statement of the block
	                        case 219 /* ForStatement */:
	                        case 221 /* ForOfStatement */:
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(block.pos, sourceFile, block.parent), block.statements[0]);
	                    }
	                    // Default action is to set on first statement
	                    return spanInNode(block.statements[0]);
	                }
	                function spanInInitializerOfForLike(forLikeStatement) {
	                    if (forLikeStatement.initializer.kind === 232 /* VariableDeclarationList */) {
	                        // Declaration list - set breakpoint in first declaration
	                        var variableDeclarationList = forLikeStatement.initializer;
	                        if (variableDeclarationList.declarations.length > 0) {
	                            return spanInNode(variableDeclarationList.declarations[0]);
	                        }
	                    }
	                    else {
	                        // Expression - set breakpoint in it
	                        return spanInNode(forLikeStatement.initializer);
	                    }
	                }
	                function spanInForStatement(forStatement) {
	                    if (forStatement.initializer) {
	                        return spanInInitializerOfForLike(forStatement);
	                    }
	                    if (forStatement.condition) {
	                        return textSpan(forStatement.condition);
	                    }
	                    if (forStatement.incrementor) {
	                        return textSpan(forStatement.incrementor);
	                    }
	                }
	                function spanInBindingPattern(bindingPattern) {
	                    // Set breakpoint in first binding element
	                    var firstBindingElement = ts.forEach(bindingPattern.elements, function (element) { return element.kind !== 205 /* OmittedExpression */ ? element : undefined; });
	                    if (firstBindingElement) {
	                        return spanInNode(firstBindingElement);
	                    }
	                    // Empty binding pattern of binding element, set breakpoint on binding element
	                    if (bindingPattern.parent.kind === 181 /* BindingElement */) {
	                        return textSpan(bindingPattern.parent);
	                    }
	                    // Variable declaration is used as the span
	                    return textSpanFromVariableDeclaration(bindingPattern.parent);
	                }
	                function spanInArrayLiteralOrObjectLiteralDestructuringPattern(node) {
	                    ts.Debug.assert(node.kind !== 180 /* ArrayBindingPattern */ && node.kind !== 179 /* ObjectBindingPattern */);
	                    var elements = node.kind === 182 /* ArrayLiteralExpression */ ? node.elements : node.properties;
	                    var firstBindingElement = ts.forEach(elements, function (element) { return element.kind !== 205 /* OmittedExpression */ ? element : undefined; });
	                    if (firstBindingElement) {
	                        return spanInNode(firstBindingElement);
	                    }
	                    // Could be ArrayLiteral from destructuring assignment or
	                    // just nested element in another destructuring assignment
	                    // set breakpoint on assignment when parent is destructuring assignment
	                    // Otherwise set breakpoint for this element
	                    return textSpan(node.parent.kind === 199 /* BinaryExpression */ ? node.parent : node);
	                }
	                // Tokens:
	                function spanInOpenBraceToken(node) {
	                    switch (node.parent.kind) {
	                        case 237 /* EnumDeclaration */:
	                            var enumDeclaration = node.parent;
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile, node.parent), enumDeclaration.members.length ? enumDeclaration.members[0] : enumDeclaration.getLastToken(sourceFile));
	                        case 234 /* ClassDeclaration */:
	                            var classDeclaration = node.parent;
	                            return spanInNodeIfStartsOnSameLine(ts.findPrecedingToken(node.pos, sourceFile, node.parent), classDeclaration.members.length ? classDeclaration.members[0] : classDeclaration.getLastToken(sourceFile));
	                        case 240 /* CaseBlock */:
	                            return spanInNodeIfStartsOnSameLine(node.parent.parent, node.parent.clauses[0]);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInCloseBraceToken(node) {
	                    switch (node.parent.kind) {
	                        case 239 /* ModuleBlock */:
	                            // If this is not an instantiated module block, no bp span
	                            if (ts.getModuleInstanceState(node.parent.parent) !== 1 /* Instantiated */) {
	                                return undefined;
	                            }
	                        // falls through
	                        case 237 /* EnumDeclaration */:
	                        case 234 /* ClassDeclaration */:
	                            // Span on close brace token
	                            return textSpan(node);
	                        case 212 /* Block */:
	                            if (ts.isFunctionBlock(node.parent)) {
	                                // Span on close brace token
	                                return textSpan(node);
	                            }
	                        // falls through
	                        case 268 /* CatchClause */:
	                            return spanInNode(ts.lastOrUndefined(node.parent.statements));
	                        case 240 /* CaseBlock */:
	                            // breakpoint in last statement of the last clause
	                            var caseBlock = node.parent;
	                            var lastClause = ts.lastOrUndefined(caseBlock.clauses);
	                            if (lastClause) {
	                                return spanInNode(ts.lastOrUndefined(lastClause.statements));
	                            }
	                            return undefined;
	                        case 179 /* ObjectBindingPattern */:
	                            // Breakpoint in last binding element or binding pattern if it contains no elements
	                            var bindingPattern = node.parent;
	                            return spanInNode(ts.lastOrUndefined(bindingPattern.elements) || bindingPattern);
	                        // Default to parent node
	                        default:
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                // Breakpoint in last binding element or binding pattern if it contains no elements
	                                var objectLiteral = node.parent;
	                                return textSpan(ts.lastOrUndefined(objectLiteral.properties) || objectLiteral);
	                            }
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInCloseBracketToken(node) {
	                    switch (node.parent.kind) {
	                        case 180 /* ArrayBindingPattern */:
	                            // Breakpoint in last binding element or binding pattern if it contains no elements
	                            var bindingPattern = node.parent;
	                            return textSpan(ts.lastOrUndefined(bindingPattern.elements) || bindingPattern);
	                        default:
	                            if (ts.isArrayLiteralOrObjectLiteralDestructuringPattern(node.parent)) {
	                                // Breakpoint in last binding element or binding pattern if it contains no elements
	                                var arrayLiteral = node.parent;
	                                return textSpan(ts.lastOrUndefined(arrayLiteral.elements) || arrayLiteral);
	                            }
	                            // Default to parent node
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInOpenParenToken(node) {
	                    if (node.parent.kind === 217 /* DoStatement */ || // Go to while keyword and do action instead
	                        node.parent.kind === 186 /* CallExpression */ ||
	                        node.parent.kind === 187 /* NewExpression */) {
	                        return spanInPreviousNode(node);
	                    }
	                    if (node.parent.kind === 190 /* ParenthesizedExpression */) {
	                        return spanInNextNode(node);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInCloseParenToken(node) {
	                    // Is this close paren token of parameter list, set span in previous token
	                    switch (node.parent.kind) {
	                        case 191 /* FunctionExpression */:
	                        case 233 /* FunctionDeclaration */:
	                        case 192 /* ArrowFunction */:
	                        case 153 /* MethodDeclaration */:
	                        case 152 /* MethodSignature */:
	                        case 155 /* GetAccessor */:
	                        case 156 /* SetAccessor */:
	                        case 154 /* Constructor */:
	                        case 218 /* WhileStatement */:
	                        case 217 /* DoStatement */:
	                        case 219 /* ForStatement */:
	                        case 221 /* ForOfStatement */:
	                        case 186 /* CallExpression */:
	                        case 187 /* NewExpression */:
	                        case 190 /* ParenthesizedExpression */:
	                            return spanInPreviousNode(node);
	                        // Default to parent node
	                        default:
	                            return spanInNode(node.parent);
	                    }
	                }
	                function spanInColonToken(node) {
	                    // Is this : specifying return annotation of the function declaration
	                    if (ts.isFunctionLike(node.parent) ||
	                        node.parent.kind === 269 /* PropertyAssignment */ ||
	                        node.parent.kind === 148 /* Parameter */) {
	                        return spanInPreviousNode(node);
	                    }
	                    return spanInNode(node.parent);
	                }
	                function spanInGreaterThanOrLessThanToken(node) {
	                    if (node.parent.kind === 189 /* TypeAssertionExpression */) {
	                        return spanInNextNode(node);
	                    }
	                    return spanInNode(node.parent);
	                }
	                function spanInWhileKeyword(node) {
	                    if (node.parent.kind === 217 /* DoStatement */) {
	                        // Set span on while expression
	                        return textSpanEndingAtNextToken(node, node.parent.expression);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	                function spanInOfKeyword(node) {
	                    if (node.parent.kind === 221 /* ForOfStatement */) {
	                        // Set using next token
	                        return spanInNextNode(node);
	                    }
	                    // Default to parent node
	                    return spanInNode(node.parent);
	                }
	            }
	        }
	        BreakpointResolver.spanInSourceFileAtLocation = spanInSourceFileAtLocation;
	    })(BreakpointResolver = ts.BreakpointResolver || (ts.BreakpointResolver = {}));
	})(ts || (ts = {}));
	var ts;
	(function (ts) {
	    /**
	     * Transform one or more nodes using the supplied transformers.
	     * @param source A single `Node` or an array of `Node` objects.
	     * @param transformers An array of `TransformerFactory` callbacks used to process the transformation.
	     * @param compilerOptions Optional compiler options.
	     */
	    function transform(source, transformers, compilerOptions) {
	        var diagnostics = [];
	        compilerOptions = ts.fixupCompilerOptions(compilerOptions, diagnostics);
	        var nodes = ts.isArray(source) ? source : [source];
	        var result = ts.transformNodes(/*resolver*/ undefined, /*emitHost*/ undefined, compilerOptions, nodes, transformers, /*allowDtsFiles*/ true);
	        result.diagnostics = ts.concatenate(result.diagnostics, diagnostics);
	        return result;
	    }
	    ts.transform = transform;
	})(ts || (ts = {}));
	//
	// Copyright (c) Microsoft Corporation.  All rights reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//   http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	//
	/* @internal */
	var debugObjectHost = (function () { return this; })();
	// We need to use 'null' to interface with the managed side.
	/* tslint:disable:no-null-keyword */
	/* tslint:disable:no-in-operator */
	/* @internal */
	var ts;
	(function (ts) {
	    function logInternalError(logger, err) {
	        if (logger) {
	            logger.log("*INTERNAL ERROR* - Exception in typescript services: " + err.message);
	        }
	    }
	    var ScriptSnapshotShimAdapter = /** @class */ (function () {
	        function ScriptSnapshotShimAdapter(scriptSnapshotShim) {
	            this.scriptSnapshotShim = scriptSnapshotShim;
	        }
	        ScriptSnapshotShimAdapter.prototype.getText = function (start, end) {
	            return this.scriptSnapshotShim.getText(start, end);
	        };
	        ScriptSnapshotShimAdapter.prototype.getLength = function () {
	            return this.scriptSnapshotShim.getLength();
	        };
	        ScriptSnapshotShimAdapter.prototype.getChangeRange = function (oldSnapshot) {
	            var oldSnapshotShim = oldSnapshot;
	            var encoded = this.scriptSnapshotShim.getChangeRange(oldSnapshotShim.scriptSnapshotShim);
	            if (encoded === null) {
	                return null;
	            }
	            var decoded = JSON.parse(encoded);
	            return ts.createTextChangeRange(ts.createTextSpan(decoded.span.start, decoded.span.length), decoded.newLength);
	        };
	        ScriptSnapshotShimAdapter.prototype.dispose = function () {
	            // if scriptSnapshotShim is a COM object then property check becomes method call with no arguments
	            // 'in' does not have this effect
	            if ("dispose" in this.scriptSnapshotShim) {
	                this.scriptSnapshotShim.dispose();
	            }
	        };
	        return ScriptSnapshotShimAdapter;
	    }());
	    var LanguageServiceShimHostAdapter = /** @class */ (function () {
	        function LanguageServiceShimHostAdapter(shimHost) {
	            var _this = this;
	            this.shimHost = shimHost;
	            this.loggingEnabled = false;
	            this.tracingEnabled = false;
	            // if shimHost is a COM object then property check will become method call with no arguments.
	            // 'in' does not have this effect.
	            if ("getModuleResolutionsForFile" in this.shimHost) {
	                this.resolveModuleNames = function (moduleNames, containingFile) {
	                    var resolutionsInFile = JSON.parse(_this.shimHost.getModuleResolutionsForFile(containingFile));
	                    return ts.map(moduleNames, function (name) {
	                        var result = ts.getProperty(resolutionsInFile, name);
	                        return result ? { resolvedFileName: result, extension: ts.extensionFromPath(result), isExternalLibraryImport: false } : undefined;
	                    });
	                };
	            }
	            if ("directoryExists" in this.shimHost) {
	                this.directoryExists = function (directoryName) { return _this.shimHost.directoryExists(directoryName); };
	            }
	            if ("getTypeReferenceDirectiveResolutionsForFile" in this.shimHost) {
	                this.resolveTypeReferenceDirectives = function (typeDirectiveNames, containingFile) {
	                    var typeDirectivesForFile = JSON.parse(_this.shimHost.getTypeReferenceDirectiveResolutionsForFile(containingFile));
	                    return ts.map(typeDirectiveNames, function (name) { return ts.getProperty(typeDirectivesForFile, name); });
	                };
	            }
	        }
	        LanguageServiceShimHostAdapter.prototype.log = function (s) {
	            if (this.loggingEnabled) {
	                this.shimHost.log(s);
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.trace = function (s) {
	            if (this.tracingEnabled) {
	                this.shimHost.trace(s);
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.error = function (s) {
	            this.shimHost.error(s);
	        };
	        LanguageServiceShimHostAdapter.prototype.getProjectVersion = function () {
	            if (!this.shimHost.getProjectVersion) {
	                // shimmed host does not support getProjectVersion
	                return undefined;
	            }
	            return this.shimHost.getProjectVersion();
	        };
	        LanguageServiceShimHostAdapter.prototype.getTypeRootsVersion = function () {
	            if (!this.shimHost.getTypeRootsVersion) {
	                return 0;
	            }
	            return this.shimHost.getTypeRootsVersion();
	        };
	        LanguageServiceShimHostAdapter.prototype.useCaseSensitiveFileNames = function () {
	            return this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
	        };
	        LanguageServiceShimHostAdapter.prototype.getCompilationSettings = function () {
	            var settingsJson = this.shimHost.getCompilationSettings();
	            if (settingsJson === null || settingsJson === "") {
	                throw Error("LanguageServiceShimHostAdapter.getCompilationSettings: empty compilationSettings");
	            }
	            var compilerOptions = JSON.parse(settingsJson);
	            // permit language service to handle all files (filtering should be performed on the host side)
	            compilerOptions.allowNonTsExtensions = true;
	            return compilerOptions;
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptFileNames = function () {
	            var encoded = this.shimHost.getScriptFileNames();
	            return this.files = JSON.parse(encoded);
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptSnapshot = function (fileName) {
	            var scriptSnapshot = this.shimHost.getScriptSnapshot(fileName);
	            return scriptSnapshot && new ScriptSnapshotShimAdapter(scriptSnapshot);
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptKind = function (fileName) {
	            if ("getScriptKind" in this.shimHost) {
	                return this.shimHost.getScriptKind(fileName);
	            }
	            else {
	                return 0 /* Unknown */;
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.getScriptVersion = function (fileName) {
	            return this.shimHost.getScriptVersion(fileName);
	        };
	        LanguageServiceShimHostAdapter.prototype.getLocalizedDiagnosticMessages = function () {
	            var diagnosticMessagesJson = this.shimHost.getLocalizedDiagnosticMessages();
	            if (diagnosticMessagesJson === null || diagnosticMessagesJson === "") {
	                return null;
	            }
	            try {
	                return JSON.parse(diagnosticMessagesJson);
	            }
	            catch (e) {
	                this.log(e.description || "diagnosticMessages.generated.json has invalid JSON format");
	                return null;
	            }
	        };
	        LanguageServiceShimHostAdapter.prototype.getCancellationToken = function () {
	            var hostCancellationToken = this.shimHost.getCancellationToken();
	            return new ts.ThrottledCancellationToken(hostCancellationToken);
	        };
	        LanguageServiceShimHostAdapter.prototype.getCurrentDirectory = function () {
	            return this.shimHost.getCurrentDirectory();
	        };
	        LanguageServiceShimHostAdapter.prototype.getDirectories = function (path) {
	            return JSON.parse(this.shimHost.getDirectories(path));
	        };
	        LanguageServiceShimHostAdapter.prototype.getDefaultLibFileName = function (options) {
	            return this.shimHost.getDefaultLibFileName(JSON.stringify(options));
	        };
	        LanguageServiceShimHostAdapter.prototype.readDirectory = function (path, extensions, exclude, include, depth) {
	            var pattern = ts.getFileMatcherPatterns(path, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
	            return JSON.parse(this.shimHost.readDirectory(path, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
	        };
	        LanguageServiceShimHostAdapter.prototype.readFile = function (path, encoding) {
	            return this.shimHost.readFile(path, encoding);
	        };
	        LanguageServiceShimHostAdapter.prototype.fileExists = function (path) {
	            return this.shimHost.fileExists(path);
	        };
	        return LanguageServiceShimHostAdapter;
	    }());
	    ts.LanguageServiceShimHostAdapter = LanguageServiceShimHostAdapter;
	    var CoreServicesShimHostAdapter = /** @class */ (function () {
	        function CoreServicesShimHostAdapter(shimHost) {
	            var _this = this;
	            this.shimHost = shimHost;
	            this.useCaseSensitiveFileNames = this.shimHost.useCaseSensitiveFileNames ? this.shimHost.useCaseSensitiveFileNames() : false;
	            if ("directoryExists" in this.shimHost) {
	                this.directoryExists = function (directoryName) { return _this.shimHost.directoryExists(directoryName); };
	            }
	            if ("realpath" in this.shimHost) {
	                this.realpath = function (path) { return _this.shimHost.realpath(path); };
	            }
	        }
	        CoreServicesShimHostAdapter.prototype.readDirectory = function (rootDir, extensions, exclude, include, depth) {
	            var pattern = ts.getFileMatcherPatterns(rootDir, exclude, include, this.shimHost.useCaseSensitiveFileNames(), this.shimHost.getCurrentDirectory());
	            return JSON.parse(this.shimHost.readDirectory(rootDir, JSON.stringify(extensions), JSON.stringify(pattern.basePaths), pattern.excludePattern, pattern.includeFilePattern, pattern.includeDirectoryPattern, depth));
	        };
	        CoreServicesShimHostAdapter.prototype.fileExists = function (fileName) {
	            return this.shimHost.fileExists(fileName);
	        };
	        CoreServicesShimHostAdapter.prototype.readFile = function (fileName) {
	            return this.shimHost.readFile(fileName);
	        };
	        CoreServicesShimHostAdapter.prototype.getDirectories = function (path) {
	            return JSON.parse(this.shimHost.getDirectories(path));
	        };
	        return CoreServicesShimHostAdapter;
	    }());
	    ts.CoreServicesShimHostAdapter = CoreServicesShimHostAdapter;
	    function simpleForwardCall(logger, actionDescription, action, logPerformance) {
	        var start;
	        if (logPerformance) {
	            logger.log(actionDescription);
	            start = ts.timestamp();
	        }
	        var result = action();
	        if (logPerformance) {
	            var end = ts.timestamp();
	            logger.log(actionDescription + " completed in " + (end - start) + " msec");
	            if (ts.isString(result)) {
	                var str = result;
	                if (str.length > 128) {
	                    str = str.substring(0, 128) + "...";
	                }
	                logger.log("  result.length=" + str.length + ", result='" + JSON.stringify(str) + "'");
	            }
	        }
	        return result;
	    }
	    function forwardJSONCall(logger, actionDescription, action, logPerformance) {
	        return forwardCall(logger, actionDescription, /*returnJson*/ true, action, logPerformance);
	    }
	    function forwardCall(logger, actionDescription, returnJson, action, logPerformance) {
	        try {
	            var result = simpleForwardCall(logger, actionDescription, action, logPerformance);
	            return returnJson ? JSON.stringify({ result: result }) : result;
	        }
	        catch (err) {
	            if (err instanceof ts.OperationCanceledException) {
	                return JSON.stringify({ canceled: true });
	            }
	            logInternalError(logger, err);
	            err.description = actionDescription;
	            return JSON.stringify({ error: err });
	        }
	    }
	    var ShimBase = /** @class */ (function () {
	        function ShimBase(factory) {
	            this.factory = factory;
	            factory.registerShim(this);
	        }
	        ShimBase.prototype.dispose = function (_dummy) {
	            this.factory.unregisterShim(this);
	        };
	        return ShimBase;
	    }());
	    function realizeDiagnostics(diagnostics, newLine) {
	        return diagnostics.map(function (d) { return realizeDiagnostic(d, newLine); });
	    }
	    ts.realizeDiagnostics = realizeDiagnostics;
	    function realizeDiagnostic(diagnostic, newLine) {
	        return {
	            message: ts.flattenDiagnosticMessageText(diagnostic.messageText, newLine),
	            start: diagnostic.start,
	            length: diagnostic.length,
	            category: ts.diagnosticCategoryName(diagnostic),
	            code: diagnostic.code,
	            reportsUnnecessary: diagnostic.reportsUnnecessary,
	        };
	    }
	    var LanguageServiceShimObject = /** @class */ (function (_super) {
	        __extends(LanguageServiceShimObject, _super);
	        function LanguageServiceShimObject(factory, host, languageService) {
	            var _this = _super.call(this, factory) || this;
	            _this.host = host;
	            _this.languageService = languageService;
	            _this.logPerformance = false;
	            _this.logger = _this.host;
	            return _this;
	        }
	        LanguageServiceShimObject.prototype.forwardJSONCall = function (actionDescription, action) {
	            return forwardJSONCall(this.logger, actionDescription, action, this.logPerformance);
	        };
	        /// DISPOSE
	        /**
	         * Ensure (almost) deterministic release of internal Javascript resources when
	         * some external native objects holds onto us (e.g. Com/Interop).
	         */
	        LanguageServiceShimObject.prototype.dispose = function (dummy) {
	            this.logger.log("dispose()");
	            this.languageService.dispose();
	            this.languageService = null;
	            // force a GC
	            if (debugObjectHost && debugObjectHost.CollectGarbage) {
	                debugObjectHost.CollectGarbage();
	                this.logger.log("CollectGarbage()");
	            }
	            this.logger = null;
	            _super.prototype.dispose.call(this, dummy);
	        };
	        /// REFRESH
	        /**
	         * Update the list of scripts known to the compiler
	         */
	        LanguageServiceShimObject.prototype.refresh = function (throwOnError) {
	            this.forwardJSONCall("refresh(" + throwOnError + ")", function () { return null; });
	        };
	        LanguageServiceShimObject.prototype.cleanupSemanticCache = function () {
	            var _this = this;
	            this.forwardJSONCall("cleanupSemanticCache()", function () {
	                _this.languageService.cleanupSemanticCache();
	                return null;
	            });
	        };
	        LanguageServiceShimObject.prototype.realizeDiagnostics = function (diagnostics) {
	            var newLine = ts.getNewLineOrDefaultFromHost(this.host);
	            return realizeDiagnostics(diagnostics, newLine);
	        };
	        LanguageServiceShimObject.prototype.getSyntacticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getSyntacticClassifications('" + fileName + "', " + start + ", " + length + ")", function () { return _this.languageService.getSyntacticClassifications(fileName, ts.createTextSpan(start, length)); });
	        };
	        LanguageServiceShimObject.prototype.getSemanticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getSemanticClassifications('" + fileName + "', " + start + ", " + length + ")", function () { return _this.languageService.getSemanticClassifications(fileName, ts.createTextSpan(start, length)); });
	        };
	        LanguageServiceShimObject.prototype.getEncodedSyntacticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getEncodedSyntacticClassifications('" + fileName + "', " + start + ", " + length + ")", 
	            // directly serialize the spans out to a string.  This is much faster to decode
	            // on the managed side versus a full JSON array.
	            function () { return convertClassifications(_this.languageService.getEncodedSyntacticClassifications(fileName, ts.createTextSpan(start, length))); });
	        };
	        LanguageServiceShimObject.prototype.getEncodedSemanticClassifications = function (fileName, start, length) {
	            var _this = this;
	            return this.forwardJSONCall("getEncodedSemanticClassifications('" + fileName + "', " + start + ", " + length + ")", 
	            // directly serialize the spans out to a string.  This is much faster to decode
	            // on the managed side versus a full JSON array.
	            function () { return convertClassifications(_this.languageService.getEncodedSemanticClassifications(fileName, ts.createTextSpan(start, length))); });
	        };
	        LanguageServiceShimObject.prototype.getSyntacticDiagnostics = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getSyntacticDiagnostics('" + fileName + "')", function () {
	                var diagnostics = _this.languageService.getSyntacticDiagnostics(fileName);
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        LanguageServiceShimObject.prototype.getSemanticDiagnostics = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getSemanticDiagnostics('" + fileName + "')", function () {
	                var diagnostics = _this.languageService.getSemanticDiagnostics(fileName);
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        LanguageServiceShimObject.prototype.getSuggestionDiagnostics = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getSuggestionDiagnostics('" + fileName + "')", function () { return _this.realizeDiagnostics(_this.languageService.getSuggestionDiagnostics(fileName)); });
	        };
	        LanguageServiceShimObject.prototype.getCompilerOptionsDiagnostics = function () {
	            var _this = this;
	            return this.forwardJSONCall("getCompilerOptionsDiagnostics()", function () {
	                var diagnostics = _this.languageService.getCompilerOptionsDiagnostics();
	                return _this.realizeDiagnostics(diagnostics);
	            });
	        };
	        /// QUICKINFO
	        /**
	         * Computes a string representation of the type at the requested position
	         * in the active file.
	         */
	        LanguageServiceShimObject.prototype.getQuickInfoAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getQuickInfoAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getQuickInfoAtPosition(fileName, position); });
	        };
	        /// NAMEORDOTTEDNAMESPAN
	        /**
	         * Computes span information of the name or dotted name at the requested position
	         * in the active file.
	         */
	        LanguageServiceShimObject.prototype.getNameOrDottedNameSpan = function (fileName, startPos, endPos) {
	            var _this = this;
	            return this.forwardJSONCall("getNameOrDottedNameSpan('" + fileName + "', " + startPos + ", " + endPos + ")", function () { return _this.languageService.getNameOrDottedNameSpan(fileName, startPos, endPos); });
	        };
	        /**
	         * STATEMENTSPAN
	         * Computes span information of statement at the requested position in the active file.
	         */
	        LanguageServiceShimObject.prototype.getBreakpointStatementAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getBreakpointStatementAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getBreakpointStatementAtPosition(fileName, position); });
	        };
	        /// SIGNATUREHELP
	        LanguageServiceShimObject.prototype.getSignatureHelpItems = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getSignatureHelpItems('" + fileName + "', " + position + ")", function () { return _this.languageService.getSignatureHelpItems(fileName, position); });
	        };
	        /// GOTO DEFINITION
	        /**
	         * Computes the definition location and file for the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getDefinitionAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDefinitionAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getDefinitionAtPosition(fileName, position); });
	        };
	        /**
	         * Computes the definition location and file for the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getDefinitionAndBoundSpan = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDefinitionAndBoundSpan('" + fileName + "', " + position + ")", function () { return _this.languageService.getDefinitionAndBoundSpan(fileName, position); });
	        };
	        /// GOTO Type
	        /**
	         * Computes the definition location of the type of the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getTypeDefinitionAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getTypeDefinitionAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getTypeDefinitionAtPosition(fileName, position); });
	        };
	        /// GOTO Implementation
	        /**
	         * Computes the implementation location of the symbol
	         * at the requested position.
	         */
	        LanguageServiceShimObject.prototype.getImplementationAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getImplementationAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getImplementationAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getRenameInfo = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getRenameInfo('" + fileName + "', " + position + ")", function () { return _this.languageService.getRenameInfo(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.findRenameLocations = function (fileName, position, findInStrings, findInComments) {
	            var _this = this;
	            return this.forwardJSONCall("findRenameLocations('" + fileName + "', " + position + ", " + findInStrings + ", " + findInComments + ")", function () { return _this.languageService.findRenameLocations(fileName, position, findInStrings, findInComments); });
	        };
	        /// GET BRACE MATCHING
	        LanguageServiceShimObject.prototype.getBraceMatchingAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getBraceMatchingAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getBraceMatchingAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.isValidBraceCompletionAtPosition = function (fileName, position, openingBrace) {
	            var _this = this;
	            return this.forwardJSONCall("isValidBraceCompletionAtPosition('" + fileName + "', " + position + ", " + openingBrace + ")", function () { return _this.languageService.isValidBraceCompletionAtPosition(fileName, position, openingBrace); });
	        };
	        LanguageServiceShimObject.prototype.getSpanOfEnclosingComment = function (fileName, position, onlyMultiLine) {
	            var _this = this;
	            return this.forwardJSONCall("getSpanOfEnclosingComment('" + fileName + "', " + position + ")", function () { return _this.languageService.getSpanOfEnclosingComment(fileName, position, onlyMultiLine); });
	        };
	        /// GET SMART INDENT
	        LanguageServiceShimObject.prototype.getIndentationAtPosition = function (fileName, position, options /*Services.EditorOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getIndentationAtPosition('" + fileName + "', " + position + ")", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getIndentationAtPosition(fileName, position, localOptions);
	            });
	        };
	        /// GET REFERENCES
	        LanguageServiceShimObject.prototype.getReferencesAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getReferencesAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getReferencesAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.findReferences = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("findReferences('" + fileName + "', " + position + ")", function () { return _this.languageService.findReferences(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getOccurrencesAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getOccurrencesAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getOccurrencesAtPosition(fileName, position); });
	        };
	        LanguageServiceShimObject.prototype.getDocumentHighlights = function (fileName, position, filesToSearch) {
	            var _this = this;
	            return this.forwardJSONCall("getDocumentHighlights('" + fileName + "', " + position + ")", function () {
	                var results = _this.languageService.getDocumentHighlights(fileName, position, JSON.parse(filesToSearch));
	                // workaround for VS document highlighting issue - keep only items from the initial file
	                var normalizedName = ts.normalizeSlashes(fileName).toLowerCase();
	                return ts.filter(results, function (r) { return ts.normalizeSlashes(r.fileName).toLowerCase() === normalizedName; });
	            });
	        };
	        /// COMPLETION LISTS
	        /**
	         * Get a string based representation of the completions
	         * to provide at the given source position and providing a member completion
	         * list if requested.
	         */
	        LanguageServiceShimObject.prototype.getCompletionsAtPosition = function (fileName, position, preferences) {
	            var _this = this;
	            return this.forwardJSONCall("getCompletionsAtPosition('" + fileName + "', " + position + ", " + preferences + ")", function () { return _this.languageService.getCompletionsAtPosition(fileName, position, preferences); });
	        };
	        /** Get a string based representation of a completion list entry details */
	        LanguageServiceShimObject.prototype.getCompletionEntryDetails = function (fileName, position, entryName, formatOptions, source, preferences) {
	            var _this = this;
	            return this.forwardJSONCall("getCompletionEntryDetails('" + fileName + "', " + position + ", '" + entryName + "')", function () {
	                var localOptions = formatOptions === undefined ? undefined : JSON.parse(formatOptions);
	                return _this.languageService.getCompletionEntryDetails(fileName, position, entryName, localOptions, source, preferences);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsForRange = function (fileName, start, end, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsForRange('" + fileName + "', " + start + ", " + end + ")", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsForRange(fileName, start, end, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsForDocument = function (fileName, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsForDocument('" + fileName + "')", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsForDocument(fileName, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getFormattingEditsAfterKeystroke = function (fileName, position, key, options /*Services.FormatCodeOptions*/) {
	            var _this = this;
	            return this.forwardJSONCall("getFormattingEditsAfterKeystroke('" + fileName + "', " + position + ", '" + key + "')", function () {
	                var localOptions = JSON.parse(options);
	                return _this.languageService.getFormattingEditsAfterKeystroke(fileName, position, key, localOptions);
	            });
	        };
	        LanguageServiceShimObject.prototype.getDocCommentTemplateAtPosition = function (fileName, position) {
	            var _this = this;
	            return this.forwardJSONCall("getDocCommentTemplateAtPosition('" + fileName + "', " + position + ")", function () { return _this.languageService.getDocCommentTemplateAtPosition(fileName, position); });
	        };
	        /// NAVIGATE TO
	        /** Return a list of symbols that are interesting to navigate to */
	        LanguageServiceShimObject.prototype.getNavigateToItems = function (searchValue, maxResultCount, fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigateToItems('" + searchValue + "', " + maxResultCount + ", " + fileName + ")", function () { return _this.languageService.getNavigateToItems(searchValue, maxResultCount, fileName); });
	        };
	        LanguageServiceShimObject.prototype.getNavigationBarItems = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigationBarItems('" + fileName + "')", function () { return _this.languageService.getNavigationBarItems(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getNavigationTree = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getNavigationTree('" + fileName + "')", function () { return _this.languageService.getNavigationTree(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getOutliningSpans = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getOutliningSpans('" + fileName + "')", function () { return _this.languageService.getOutliningSpans(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getTodoComments = function (fileName, descriptors) {
	            var _this = this;
	            return this.forwardJSONCall("getTodoComments('" + fileName + "')", function () { return _this.languageService.getTodoComments(fileName, JSON.parse(descriptors)); });
	        };
	        /// Emit
	        LanguageServiceShimObject.prototype.getEmitOutput = function (fileName) {
	            var _this = this;
	            return this.forwardJSONCall("getEmitOutput('" + fileName + "')", function () { return _this.languageService.getEmitOutput(fileName); });
	        };
	        LanguageServiceShimObject.prototype.getEmitOutputObject = function (fileName) {
	            var _this = this;
	            return forwardCall(this.logger, "getEmitOutput('" + fileName + "')", 
	            /*returnJson*/ false, function () { return _this.languageService.getEmitOutput(fileName); }, this.logPerformance);
	        };
	        return LanguageServiceShimObject;
	    }(ShimBase));
	    function convertClassifications(classifications) {
	        return { spans: classifications.spans.join(","), endOfLineState: classifications.endOfLineState };
	    }
	    var ClassifierShimObject = /** @class */ (function (_super) {
	        __extends(ClassifierShimObject, _super);
	        function ClassifierShimObject(factory, logger) {
	            var _this = _super.call(this, factory) || this;
	            _this.logger = logger;
	            _this.logPerformance = false;
	            _this.classifier = ts.createClassifier();
	            return _this;
	        }
	        ClassifierShimObject.prototype.getEncodedLexicalClassifications = function (text, lexState, syntacticClassifierAbsent) {
	            var _this = this;
	            return forwardJSONCall(this.logger, "getEncodedLexicalClassifications", function () { return convertClassifications(_this.classifier.getEncodedLexicalClassifications(text, lexState, syntacticClassifierAbsent)); }, this.logPerformance);
	        };
	        /// COLORIZATION
	        ClassifierShimObject.prototype.getClassificationsForLine = function (text, lexState, classifyKeywordsInGenerics) {
	            var classification = this.classifier.getClassificationsForLine(text, lexState, classifyKeywordsInGenerics);
	            var result = "";
	            for (var _i = 0, _a = classification.entries; _i < _a.length; _i++) {
	                var item = _a[_i];
	                result += item.length + "\n";
	                result += item.classification + "\n";
	            }
	            result += classification.finalLexState;
	            return result;
	        };
	        return ClassifierShimObject;
	    }(ShimBase));
	    var CoreServicesShimObject = /** @class */ (function (_super) {
	        __extends(CoreServicesShimObject, _super);
	        function CoreServicesShimObject(factory, logger, host) {
	            var _this = _super.call(this, factory) || this;
	            _this.logger = logger;
	            _this.host = host;
	            _this.logPerformance = false;
	            return _this;
	        }
	        CoreServicesShimObject.prototype.forwardJSONCall = function (actionDescription, action) {
	            return forwardJSONCall(this.logger, actionDescription, action, this.logPerformance);
	        };
	        CoreServicesShimObject.prototype.resolveModuleName = function (fileName, moduleName, compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("resolveModuleName('" + fileName + "')", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                var result = ts.resolveModuleName(moduleName, ts.normalizeSlashes(fileName), compilerOptions, _this.host);
	                var resolvedFileName = result.resolvedModule ? result.resolvedModule.resolvedFileName : undefined;
	                if (result.resolvedModule && result.resolvedModule.extension !== ".ts" /* Ts */ && result.resolvedModule.extension !== ".tsx" /* Tsx */ && result.resolvedModule.extension !== ".d.ts" /* Dts */) {
	                    resolvedFileName = undefined;
	                }
	                return {
	                    resolvedFileName: resolvedFileName,
	                    failedLookupLocations: result.failedLookupLocations
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.resolveTypeReferenceDirective = function (fileName, typeReferenceDirective, compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("resolveTypeReferenceDirective(" + fileName + ")", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                var result = ts.resolveTypeReferenceDirective(typeReferenceDirective, ts.normalizeSlashes(fileName), compilerOptions, _this.host);
	                return {
	                    resolvedFileName: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.resolvedFileName : undefined,
	                    primary: result.resolvedTypeReferenceDirective ? result.resolvedTypeReferenceDirective.primary : true,
	                    failedLookupLocations: result.failedLookupLocations
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getPreProcessedFileInfo = function (fileName, sourceTextSnapshot) {
	            var _this = this;
	            return this.forwardJSONCall("getPreProcessedFileInfo('" + fileName + "')", function () {
	                // for now treat files as JavaScript
	                var result = ts.preProcessFile(ts.getSnapshotText(sourceTextSnapshot), /* readImportFiles */ true, /* detectJavaScriptImports */ true);
	                return {
	                    referencedFiles: _this.convertFileReferences(result.referencedFiles),
	                    importedFiles: _this.convertFileReferences(result.importedFiles),
	                    ambientExternalModules: result.ambientExternalModules,
	                    isLibFile: result.isLibFile,
	                    typeReferenceDirectives: _this.convertFileReferences(result.typeReferenceDirectives)
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getAutomaticTypeDirectiveNames = function (compilerOptionsJson) {
	            var _this = this;
	            return this.forwardJSONCall("getAutomaticTypeDirectiveNames('" + compilerOptionsJson + "')", function () {
	                var compilerOptions = JSON.parse(compilerOptionsJson);
	                return ts.getAutomaticTypeDirectiveNames(compilerOptions, _this.host);
	            });
	        };
	        CoreServicesShimObject.prototype.convertFileReferences = function (refs) {
	            if (!refs) {
	                return undefined;
	            }
	            var result = [];
	            for (var _i = 0, refs_2 = refs; _i < refs_2.length; _i++) {
	                var ref = refs_2[_i];
	                result.push({
	                    path: ts.normalizeSlashes(ref.fileName),
	                    position: ref.pos,
	                    length: ref.end - ref.pos
	                });
	            }
	            return result;
	        };
	        CoreServicesShimObject.prototype.getTSConfigFileInfo = function (fileName, sourceTextSnapshot) {
	            var _this = this;
	            return this.forwardJSONCall("getTSConfigFileInfo('" + fileName + "')", function () {
	                var result = ts.parseJsonText(fileName, ts.getSnapshotText(sourceTextSnapshot));
	                var normalizedFileName = ts.normalizeSlashes(fileName);
	                var configFile = ts.parseJsonSourceFileConfigFileContent(result, _this.host, ts.getDirectoryPath(normalizedFileName), /*existingOptions*/ {}, normalizedFileName);
	                return {
	                    options: configFile.options,
	                    typeAcquisition: configFile.typeAcquisition,
	                    files: configFile.fileNames,
	                    raw: configFile.raw,
	                    errors: realizeDiagnostics(result.parseDiagnostics.concat(configFile.errors), "\r\n")
	                };
	            });
	        };
	        CoreServicesShimObject.prototype.getDefaultCompilationSettings = function () {
	            return this.forwardJSONCall("getDefaultCompilationSettings()", function () { return ts.getDefaultCompilerOptions(); });
	        };
	        CoreServicesShimObject.prototype.discoverTypings = function (discoverTypingsJson) {
	            var _this = this;
	            var getCanonicalFileName = ts.createGetCanonicalFileName(/*useCaseSensitivefileNames:*/ false);
	            return this.forwardJSONCall("discoverTypings()", function () {
	                var info = JSON.parse(discoverTypingsJson);
	                if (_this.safeList === undefined) {
	                    _this.safeList = ts.JsTyping.loadSafeList(_this.host, ts.toPath(info.safeListPath, info.safeListPath, getCanonicalFileName));
	                }
	                return ts.JsTyping.discoverTypings(_this.host, function (msg) { return _this.logger.log(msg); }, info.fileNames, ts.toPath(info.projectRootPath, info.projectRootPath, getCanonicalFileName), _this.safeList, info.packageNameToTypingLocation, info.typeAcquisition, info.unresolvedImports, info.typesRegistry);
	            });
	        };
	        return CoreServicesShimObject;
	    }(ShimBase));
	    var TypeScriptServicesFactory = /** @class */ (function () {
	        function TypeScriptServicesFactory() {
	            this._shims = [];
	        }
	        /*
	         * Returns script API version.
	         */
	        TypeScriptServicesFactory.prototype.getServicesVersion = function () {
	            return ts.servicesVersion;
	        };
	        TypeScriptServicesFactory.prototype.createLanguageServiceShim = function (host) {
	            try {
	                if (this.documentRegistry === undefined) {
	                    this.documentRegistry = ts.createDocumentRegistry(host.useCaseSensitiveFileNames && host.useCaseSensitiveFileNames(), host.getCurrentDirectory());
	                }
	                var hostAdapter = new LanguageServiceShimHostAdapter(host);
	                var languageService = ts.createLanguageService(hostAdapter, this.documentRegistry, /*syntaxOnly*/ false);
	                return new LanguageServiceShimObject(this, host, languageService);
	            }
	            catch (err) {
	                logInternalError(host, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.createClassifierShim = function (logger) {
	            try {
	                return new ClassifierShimObject(this, logger);
	            }
	            catch (err) {
	                logInternalError(logger, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.createCoreServicesShim = function (host) {
	            try {
	                var adapter = new CoreServicesShimHostAdapter(host);
	                return new CoreServicesShimObject(this, host, adapter);
	            }
	            catch (err) {
	                logInternalError(host, err);
	                throw err;
	            }
	        };
	        TypeScriptServicesFactory.prototype.close = function () {
	            // Forget all the registered shims
	            ts.clear(this._shims);
	            this.documentRegistry = undefined;
	        };
	        TypeScriptServicesFactory.prototype.registerShim = function (shim) {
	            this._shims.push(shim);
	        };
	        TypeScriptServicesFactory.prototype.unregisterShim = function (shim) {
	            for (var i = 0; i < this._shims.length; i++) {
	                if (this._shims[i] === shim) {
	                    delete this._shims[i];
	                    return;
	                }
	            }
	            throw new Error("Invalid operation");
	        };
	        return TypeScriptServicesFactory;
	    }());
	    ts.TypeScriptServicesFactory = TypeScriptServicesFactory;
	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = ts;
	    }
	})(ts || (ts = {}));
	/* tslint:enable:no-in-operator */
	/* tslint:enable:no-null */
	/// TODO: this is used by VS, clean this up on both sides of the interface
	/* @internal */
	var TypeScript;
	(function (TypeScript) {
	    var Services;
	    (function (Services) {
	        Services.TypeScriptServicesFactory = ts.TypeScriptServicesFactory;
	    })(Services = TypeScript.Services || (TypeScript.Services = {}));
	})(TypeScript || (TypeScript = {}));
	// 'toolsVersion' gets consumed by the managed side, so it's not unused.
	// TODO: it should be moved into a namespace though.
	/* @internal */
	var toolsVersion = ts.versionMajorMinor;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(871), "/index.js", (function() { return this; }()), "/"))

/***/ }),
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var SourceMapConsumer = __webpack_require__(1314).SourceMapConsumer;
	var path = __webpack_require__(1325);
	
	var fs;
	try {
	  fs = __webpack_require__(1326);
	  if (!fs.existsSync || !fs.readFileSync) {
	    // fs doesn't have all methods we need
	    fs = null;
	  }
	} catch (err) {
	  /* nop */
	}
	
	// Only install once if called multiple times
	var errorFormatterInstalled = false;
	var uncaughtShimInstalled = false;
	
	// If true, the caches are reset before a stack trace formatting operation
	var emptyCacheBetweenOperations = false;
	
	// Supports {browser, node, auto}
	var environment = "auto";
	
	// Maps a file path to a string containing the file contents
	var fileContentsCache = {};
	
	// Maps a file path to a source map for that file
	var sourceMapCache = {};
	
	// Regex for detecting source maps
	var reSourceMap = /^data:application\/json[^,]+base64,/;
	
	// Priority list of retrieve handlers
	var retrieveFileHandlers = [];
	var retrieveMapHandlers = [];
	
	function isInBrowser() {
	  if (environment === "browser")
	    return true;
	  if (environment === "node")
	    return false;
	  return ((typeof window !== 'undefined') && (typeof XMLHttpRequest === 'function') && !(window.require && window.module && window.process && window.process.type === "renderer"));
	}
	
	function hasGlobalProcessEventEmitter() {
	  return ((typeof process === 'object') && (process !== null) && (typeof process.on === 'function'));
	}
	
	function handlerExec(list) {
	  return function(arg) {
	    for (var i = 0; i < list.length; i++) {
	      var ret = list[i](arg);
	      if (ret) {
	        return ret;
	      }
	    }
	    return null;
	  };
	}
	
	var retrieveFile = handlerExec(retrieveFileHandlers);
	
	retrieveFileHandlers.push(function(path) {
	  // Trim the path to make sure there is no extra whitespace.
	  path = path.trim();
	  if (path in fileContentsCache) {
	    return fileContentsCache[path];
	  }
	
	  var contents = null;
	  if (!fs) {
	    // Use SJAX if we are in the browser
	    var xhr = new XMLHttpRequest();
	    xhr.open('GET', path, false);
	    xhr.send(null);
	    var contents = null
	    if (xhr.readyState === 4 && xhr.status === 200) {
	      contents = xhr.responseText
	    }
	  } else if (fs.existsSync(path)) {
	    // Otherwise, use the filesystem
	    try {
	      contents = fs.readFileSync(path, 'utf8');
	    } catch (er) {
	      contents = '';
	    }
	  }
	
	  return fileContentsCache[path] = contents;
	});
	
	// Support URLs relative to a directory, but be careful about a protocol prefix
	// in case we are in the browser (i.e. directories may start with "http://")
	function supportRelativeURL(file, url) {
	  if (!file) return url;
	  var dir = path.dirname(file);
	  var match = /^\w+:\/\/[^\/]*/.exec(dir);
	  var protocol = match ? match[0] : '';
	  return protocol + path.resolve(dir.slice(protocol.length), url);
	}
	
	function retrieveSourceMapURL(source) {
	  var fileData;
	
	  if (isInBrowser()) {
	     try {
	       var xhr = new XMLHttpRequest();
	       xhr.open('GET', source, false);
	       xhr.send(null);
	       fileData = xhr.readyState === 4 ? xhr.responseText : null;
	
	       // Support providing a sourceMappingURL via the SourceMap header
	       var sourceMapHeader = xhr.getResponseHeader("SourceMap") ||
	                             xhr.getResponseHeader("X-SourceMap");
	       if (sourceMapHeader) {
	         return sourceMapHeader;
	       }
	     } catch (e) {
	     }
	  }
	
	  // Get the URL of the source map
	  fileData = retrieveFile(source);
	  var re = /(?:\/\/[@#][ \t]+sourceMappingURL=([^\s'"]+?)[ \t]*$)|(?:\/\*[@#][ \t]+sourceMappingURL=([^\*]+?)[ \t]*(?:\*\/)[ \t]*$)/mg;
	  // Keep executing the search to find the *last* sourceMappingURL to avoid
	  // picking up sourceMappingURLs from comments, strings, etc.
	  var lastMatch, match;
	  while (match = re.exec(fileData)) lastMatch = match;
	  if (!lastMatch) return null;
	  return lastMatch[1];
	};
	
	// Can be overridden by the retrieveSourceMap option to install. Takes a
	// generated source filename; returns a {map, optional url} object, or null if
	// there is no source map.  The map field may be either a string or the parsed
	// JSON object (ie, it must be a valid argument to the SourceMapConsumer
	// constructor).
	var retrieveSourceMap = handlerExec(retrieveMapHandlers);
	retrieveMapHandlers.push(function(source) {
	  var sourceMappingURL = retrieveSourceMapURL(source);
	  if (!sourceMappingURL) return null;
	
	  // Read the contents of the source map
	  var sourceMapData;
	  if (reSourceMap.test(sourceMappingURL)) {
	    // Support source map URL as a data url
	    var rawData = sourceMappingURL.slice(sourceMappingURL.indexOf(',') + 1);
	    sourceMapData = new Buffer(rawData, "base64").toString();
	    sourceMappingURL = source;
	  } else {
	    // Support source map URLs relative to the source URL
	    sourceMappingURL = supportRelativeURL(source, sourceMappingURL);
	    sourceMapData = retrieveFile(sourceMappingURL);
	  }
	
	  if (!sourceMapData) {
	    return null;
	  }
	
	  return {
	    url: sourceMappingURL,
	    map: sourceMapData
	  };
	});
	
	function mapSourcePosition(position) {
	  var sourceMap = sourceMapCache[position.source];
	  if (!sourceMap) {
	    // Call the (overrideable) retrieveSourceMap function to get the source map.
	    var urlAndMap = retrieveSourceMap(position.source);
	    if (urlAndMap) {
	      sourceMap = sourceMapCache[position.source] = {
	        url: urlAndMap.url,
	        map: new SourceMapConsumer(urlAndMap.map)
	      };
	
	      // Load all sources stored inline with the source map into the file cache
	      // to pretend like they are already loaded. They may not exist on disk.
	      if (sourceMap.map.sourcesContent) {
	        sourceMap.map.sources.forEach(function(source, i) {
	          var contents = sourceMap.map.sourcesContent[i];
	          if (contents) {
	            var url = supportRelativeURL(sourceMap.url, source);
	            fileContentsCache[url] = contents;
	          }
	        });
	      }
	    } else {
	      sourceMap = sourceMapCache[position.source] = {
	        url: null,
	        map: null
	      };
	    }
	  }
	
	  // Resolve the source URL relative to the URL of the source map
	  if (sourceMap && sourceMap.map) {
	    var originalPosition = sourceMap.map.originalPositionFor(position);
	
	    // Only return the original position if a matching line was found. If no
	    // matching line is found then we return position instead, which will cause
	    // the stack trace to print the path and line for the compiled file. It is
	    // better to give a precise location in the compiled file than a vague
	    // location in the original file.
	    if (originalPosition.source !== null) {
	      originalPosition.source = supportRelativeURL(
	        sourceMap.url, originalPosition.source);
	      return originalPosition;
	    }
	  }
	
	  return position;
	}
	
	// Parses code generated by FormatEvalOrigin(), a function inside V8:
	// https://code.google.com/p/v8/source/browse/trunk/src/messages.js
	function mapEvalOrigin(origin) {
	  // Most eval() calls are in this format
	  var match = /^eval at ([^(]+) \((.+):(\d+):(\d+)\)$/.exec(origin);
	  if (match) {
	    var position = mapSourcePosition({
	      source: match[2],
	      line: +match[3],
	      column: match[4] - 1
	    });
	    return 'eval at ' + match[1] + ' (' + position.source + ':' +
	      position.line + ':' + (position.column + 1) + ')';
	  }
	
	  // Parse nested eval() calls using recursion
	  match = /^eval at ([^(]+) \((.+)\)$/.exec(origin);
	  if (match) {
	    return 'eval at ' + match[1] + ' (' + mapEvalOrigin(match[2]) + ')';
	  }
	
	  // Make sure we still return useful information if we didn't find anything
	  return origin;
	}
	
	// This is copied almost verbatim from the V8 source code at
	// https://code.google.com/p/v8/source/browse/trunk/src/messages.js. The
	// implementation of wrapCallSite() used to just forward to the actual source
	// code of CallSite.prototype.toString but unfortunately a new release of V8
	// did something to the prototype chain and broke the shim. The only fix I
	// could find was copy/paste.
	function CallSiteToString() {
	  var fileName;
	  var fileLocation = "";
	  if (this.isNative()) {
	    fileLocation = "native";
	  } else {
	    fileName = this.getScriptNameOrSourceURL();
	    if (!fileName && this.isEval()) {
	      fileLocation = this.getEvalOrigin();
	      fileLocation += ", ";  // Expecting source position to follow.
	    }
	
	    if (fileName) {
	      fileLocation += fileName;
	    } else {
	      // Source code does not originate from a file and is not native, but we
	      // can still get the source position inside the source string, e.g. in
	      // an eval string.
	      fileLocation += "<anonymous>";
	    }
	    var lineNumber = this.getLineNumber();
	    if (lineNumber != null) {
	      fileLocation += ":" + lineNumber;
	      var columnNumber = this.getColumnNumber();
	      if (columnNumber) {
	        fileLocation += ":" + columnNumber;
	      }
	    }
	  }
	
	  var line = "";
	  var functionName = this.getFunctionName();
	  var addSuffix = true;
	  var isConstructor = this.isConstructor();
	  var isMethodCall = !(this.isToplevel() || isConstructor);
	  if (isMethodCall) {
	    var typeName = this.getTypeName();
	    // Fixes shim to be backward compatable with Node v0 to v4
	    if (typeName === "[object Object]") {
	      typeName = "null";
	    }
	    var methodName = this.getMethodName();
	    if (functionName) {
	      if (typeName && functionName.indexOf(typeName) != 0) {
	        line += typeName + ".";
	      }
	      line += functionName;
	      if (methodName && functionName.indexOf("." + methodName) != functionName.length - methodName.length - 1) {
	        line += " [as " + methodName + "]";
	      }
	    } else {
	      line += typeName + "." + (methodName || "<anonymous>");
	    }
	  } else if (isConstructor) {
	    line += "new " + (functionName || "<anonymous>");
	  } else if (functionName) {
	    line += functionName;
	  } else {
	    line += fileLocation;
	    addSuffix = false;
	  }
	  if (addSuffix) {
	    line += " (" + fileLocation + ")";
	  }
	  return line;
	}
	
	function cloneCallSite(frame) {
	  var object = {};
	  Object.getOwnPropertyNames(Object.getPrototypeOf(frame)).forEach(function(name) {
	    object[name] = /^(?:is|get)/.test(name) ? function() { return frame[name].call(frame); } : frame[name];
	  });
	  object.toString = CallSiteToString;
	  return object;
	}
	
	function wrapCallSite(frame) {
	  if(frame.isNative()) {
	    return frame;
	  }
	
	  // Most call sites will return the source file from getFileName(), but code
	  // passed to eval() ending in "//# sourceURL=..." will return the source file
	  // from getScriptNameOrSourceURL() instead
	  var source = frame.getFileName() || frame.getScriptNameOrSourceURL();
	  if (source) {
	    var line = frame.getLineNumber();
	    var column = frame.getColumnNumber() - 1;
	
	    // Fix position in Node where some (internal) code is prepended.
	    // See https://github.com/evanw/node-source-map-support/issues/36
	    var headerLength = 62;
	    if (line === 1 && column > headerLength && !isInBrowser() && !frame.isEval()) {
	      column -= headerLength;
	    }
	
	    var position = mapSourcePosition({
	      source: source,
	      line: line,
	      column: column
	    });
	    frame = cloneCallSite(frame);
	    frame.getFileName = function() { return position.source; };
	    frame.getLineNumber = function() { return position.line; };
	    frame.getColumnNumber = function() { return position.column + 1; };
	    frame.getScriptNameOrSourceURL = function() { return position.source; };
	    return frame;
	  }
	
	  // Code called using eval() needs special handling
	  var origin = frame.isEval() && frame.getEvalOrigin();
	  if (origin) {
	    origin = mapEvalOrigin(origin);
	    frame = cloneCallSite(frame);
	    frame.getEvalOrigin = function() { return origin; };
	    return frame;
	  }
	
	  // If we get here then we were unable to change the source position
	  return frame;
	}
	
	// This function is part of the V8 stack trace API, for more info see:
	// http://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
	function prepareStackTrace(error, stack) {
	  if (emptyCacheBetweenOperations) {
	    fileContentsCache = {};
	    sourceMapCache = {};
	  }
	
	  return error + stack.map(function(frame) {
	    return '\n    at ' + wrapCallSite(frame);
	  }).join('');
	}
	
	// Generate position and snippet of original source with pointer
	function getErrorSource(error) {
	  var match = /\n    at [^(]+ \((.*):(\d+):(\d+)\)/.exec(error.stack);
	  if (match) {
	    var source = match[1];
	    var line = +match[2];
	    var column = +match[3];
	
	    // Support the inline sourceContents inside the source map
	    var contents = fileContentsCache[source];
	
	    // Support files on disk
	    if (!contents && fs && fs.existsSync(source)) {
	      try {
	        contents = fs.readFileSync(source, 'utf8');
	      } catch (er) {
	        contents = '';
	      }
	    }
	
	    // Format the line from the original source code like node does
	    if (contents) {
	      var code = contents.split(/(?:\r\n|\r|\n)/)[line - 1];
	      if (code) {
	        return source + ':' + line + '\n' + code + '\n' +
	          new Array(column).join(' ') + '^';
	      }
	    }
	  }
	  return null;
	}
	
	function printErrorAndExit (error) {
	  var source = getErrorSource(error);
	
	  if (source) {
	    console.error();
	    console.error(source);
	  }
	
	  console.error(error.stack);
	  process.exit(1);
	}
	
	function shimEmitUncaughtException () {
	  var origEmit = process.emit;
	
	  process.emit = function (type) {
	    if (type === 'uncaughtException') {
	      var hasStack = (arguments[1] && arguments[1].stack);
	      var hasListeners = (this.listeners(type).length > 0);
	
	      if (hasStack && !hasListeners) {
	        return printErrorAndExit(arguments[1]);
	      }
	    }
	
	    return origEmit.apply(this, arguments);
	  };
	}
	
	exports.wrapCallSite = wrapCallSite;
	exports.getErrorSource = getErrorSource;
	exports.mapSourcePosition = mapSourcePosition;
	exports.retrieveSourceMap = retrieveSourceMap;
	
	exports.install = function(options) {
	  options = options || {};
	
	  if (options.environment) {
	    environment = options.environment;
	    if (["node", "browser", "auto"].indexOf(environment) === -1) {
	      throw new Error("environment " + environment + " was unknown. Available options are {auto, browser, node}")
	    }
	  }
	
	  // Allow sources to be found by methods other than reading the files
	  // directly from disk.
	  if (options.retrieveFile) {
	    if (options.overrideRetrieveFile) {
	      retrieveFileHandlers.length = 0;
	    }
	
	    retrieveFileHandlers.unshift(options.retrieveFile);
	  }
	
	  // Allow source maps to be found by methods other than reading the files
	  // directly from disk.
	  if (options.retrieveSourceMap) {
	    if (options.overrideRetrieveSourceMap) {
	      retrieveMapHandlers.length = 0;
	    }
	
	    retrieveMapHandlers.unshift(options.retrieveSourceMap);
	  }
	
	  // Support runtime transpilers that include inline source maps
	  if (options.hookRequire && !isInBrowser()) {
	    var Module;
	    try {
	      Module = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"module\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    } catch (err) {
	      // NOP: Loading in catch block to convert webpack error to warning.
	    }
	    var $compile = Module.prototype._compile;
	
	    if (!$compile.__sourceMapSupport) {
	      Module.prototype._compile = function(content, filename) {
	        fileContentsCache[filename] = content;
	        sourceMapCache[filename] = undefined;
	        return $compile.call(this, content, filename);
	      };
	
	      Module.prototype._compile.__sourceMapSupport = true;
	    }
	  }
	
	  // Configure options
	  if (!emptyCacheBetweenOperations) {
	    emptyCacheBetweenOperations = 'emptyCacheBetweenOperations' in options ?
	      options.emptyCacheBetweenOperations : false;
	  }
	
	  // Install the error reformatter
	  if (!errorFormatterInstalled) {
	    errorFormatterInstalled = true;
	    Error.prepareStackTrace = prepareStackTrace;
	  }
	
	  if (!uncaughtShimInstalled) {
	    var installHandler = 'handleUncaughtExceptions' in options ?
	      options.handleUncaughtExceptions : true;
	
	    // Provide the option to not install the uncaught exception handler. This is
	    // to support other uncaught exception handlers (in test frameworks, for
	    // example). If this handler is not installed and there are no other uncaught
	    // exception handlers, uncaught exceptions will be caught by node's built-in
	    // exception handler and the process will still be terminated. However, the
	    // generated JavaScript code will be shown above the stack trace instead of
	    // the original source code.
	    if (installHandler && hasGlobalProcessEventEmitter()) {
	      uncaughtShimInstalled = true;
	      shimEmitUncaughtException();
	    }
	  }
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(871), __webpack_require__(966).Buffer))

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2009-2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE.txt or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	exports.SourceMapGenerator = __webpack_require__(1315).SourceMapGenerator;
	exports.SourceMapConsumer = __webpack_require__(1321).SourceMapConsumer;
	exports.SourceNode = __webpack_require__(1324).SourceNode;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var base64VLQ = __webpack_require__(1316);
	var util = __webpack_require__(1318);
	var ArraySet = __webpack_require__(1319).ArraySet;
	var MappingList = __webpack_require__(1320).MappingList;
	
	/**
	 * An instance of the SourceMapGenerator represents a source map which is
	 * being built incrementally. You may pass an object with the following
	 * properties:
	 *
	 *   - file: The filename of the generated source.
	 *   - sourceRoot: A root for all relative URLs in this source map.
	 */
	function SourceMapGenerator(aArgs) {
	  if (!aArgs) {
	    aArgs = {};
	  }
	  this._file = util.getArg(aArgs, 'file', null);
	  this._sourceRoot = util.getArg(aArgs, 'sourceRoot', null);
	  this._skipValidation = util.getArg(aArgs, 'skipValidation', false);
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	  this._mappings = new MappingList();
	  this._sourcesContents = null;
	}
	
	SourceMapGenerator.prototype._version = 3;
	
	/**
	 * Creates a new SourceMapGenerator based on a SourceMapConsumer
	 *
	 * @param aSourceMapConsumer The SourceMap.
	 */
	SourceMapGenerator.fromSourceMap =
	  function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
	    var sourceRoot = aSourceMapConsumer.sourceRoot;
	    var generator = new SourceMapGenerator({
	      file: aSourceMapConsumer.file,
	      sourceRoot: sourceRoot
	    });
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      var newMapping = {
	        generated: {
	          line: mapping.generatedLine,
	          column: mapping.generatedColumn
	        }
	      };
	
	      if (mapping.source != null) {
	        newMapping.source = mapping.source;
	        if (sourceRoot != null) {
	          newMapping.source = util.relative(sourceRoot, newMapping.source);
	        }
	
	        newMapping.original = {
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        };
	
	        if (mapping.name != null) {
	          newMapping.name = mapping.name;
	        }
	      }
	
	      generator.addMapping(newMapping);
	    });
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        generator.setSourceContent(sourceFile, content);
	      }
	    });
	    return generator;
	  };
	
	/**
	 * Add a single mapping from original source line and column to the generated
	 * source's line and column for this source map being created. The mapping
	 * object should have the following properties:
	 *
	 *   - generated: An object with the generated line and column positions.
	 *   - original: An object with the original line and column positions.
	 *   - source: The original source file (relative to the sourceRoot).
	 *   - name: An optional original token name for this mapping.
	 */
	SourceMapGenerator.prototype.addMapping =
	  function SourceMapGenerator_addMapping(aArgs) {
	    var generated = util.getArg(aArgs, 'generated');
	    var original = util.getArg(aArgs, 'original', null);
	    var source = util.getArg(aArgs, 'source', null);
	    var name = util.getArg(aArgs, 'name', null);
	
	    if (!this._skipValidation) {
	      this._validateMapping(generated, original, source, name);
	    }
	
	    if (source != null) {
	      source = String(source);
	      if (!this._sources.has(source)) {
	        this._sources.add(source);
	      }
	    }
	
	    if (name != null) {
	      name = String(name);
	      if (!this._names.has(name)) {
	        this._names.add(name);
	      }
	    }
	
	    this._mappings.add({
	      generatedLine: generated.line,
	      generatedColumn: generated.column,
	      originalLine: original != null && original.line,
	      originalColumn: original != null && original.column,
	      source: source,
	      name: name
	    });
	  };
	
	/**
	 * Set the source content for a source file.
	 */
	SourceMapGenerator.prototype.setSourceContent =
	  function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
	    var source = aSourceFile;
	    if (this._sourceRoot != null) {
	      source = util.relative(this._sourceRoot, source);
	    }
	
	    if (aSourceContent != null) {
	      // Add the source content to the _sourcesContents map.
	      // Create a new _sourcesContents map if the property is null.
	      if (!this._sourcesContents) {
	        this._sourcesContents = Object.create(null);
	      }
	      this._sourcesContents[util.toSetString(source)] = aSourceContent;
	    } else if (this._sourcesContents) {
	      // Remove the source file from the _sourcesContents map.
	      // If the _sourcesContents map is empty, set the property to null.
	      delete this._sourcesContents[util.toSetString(source)];
	      if (Object.keys(this._sourcesContents).length === 0) {
	        this._sourcesContents = null;
	      }
	    }
	  };
	
	/**
	 * Applies the mappings of a sub-source-map for a specific source file to the
	 * source map being generated. Each mapping to the supplied source file is
	 * rewritten using the supplied source map. Note: The resolution for the
	 * resulting mappings is the minimium of this map and the supplied map.
	 *
	 * @param aSourceMapConsumer The source map to be applied.
	 * @param aSourceFile Optional. The filename of the source file.
	 *        If omitted, SourceMapConsumer's file property will be used.
	 * @param aSourceMapPath Optional. The dirname of the path to the source map
	 *        to be applied. If relative, it is relative to the SourceMapConsumer.
	 *        This parameter is needed when the two source maps aren't in the same
	 *        directory, and the source map to be applied contains relative source
	 *        paths. If so, those relative source paths need to be rewritten
	 *        relative to the SourceMapGenerator.
	 */
	SourceMapGenerator.prototype.applySourceMap =
	  function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
	    var sourceFile = aSourceFile;
	    // If aSourceFile is omitted, we will use the file property of the SourceMap
	    if (aSourceFile == null) {
	      if (aSourceMapConsumer.file == null) {
	        throw new Error(
	          'SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, ' +
	          'or the source map\'s "file" property. Both were omitted.'
	        );
	      }
	      sourceFile = aSourceMapConsumer.file;
	    }
	    var sourceRoot = this._sourceRoot;
	    // Make "sourceFile" relative if an absolute Url is passed.
	    if (sourceRoot != null) {
	      sourceFile = util.relative(sourceRoot, sourceFile);
	    }
	    // Applying the SourceMap can add and remove items from the sources and
	    // the names array.
	    var newSources = new ArraySet();
	    var newNames = new ArraySet();
	
	    // Find mappings for the "sourceFile"
	    this._mappings.unsortedForEach(function (mapping) {
	      if (mapping.source === sourceFile && mapping.originalLine != null) {
	        // Check if it can be mapped by the source map, then update the mapping.
	        var original = aSourceMapConsumer.originalPositionFor({
	          line: mapping.originalLine,
	          column: mapping.originalColumn
	        });
	        if (original.source != null) {
	          // Copy mapping
	          mapping.source = original.source;
	          if (aSourceMapPath != null) {
	            mapping.source = util.join(aSourceMapPath, mapping.source)
	          }
	          if (sourceRoot != null) {
	            mapping.source = util.relative(sourceRoot, mapping.source);
	          }
	          mapping.originalLine = original.line;
	          mapping.originalColumn = original.column;
	          if (original.name != null) {
	            mapping.name = original.name;
	          }
	        }
	      }
	
	      var source = mapping.source;
	      if (source != null && !newSources.has(source)) {
	        newSources.add(source);
	      }
	
	      var name = mapping.name;
	      if (name != null && !newNames.has(name)) {
	        newNames.add(name);
	      }
	
	    }, this);
	    this._sources = newSources;
	    this._names = newNames;
	
	    // Copy sourcesContents of applied map.
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aSourceMapPath != null) {
	          sourceFile = util.join(aSourceMapPath, sourceFile);
	        }
	        if (sourceRoot != null) {
	          sourceFile = util.relative(sourceRoot, sourceFile);
	        }
	        this.setSourceContent(sourceFile, content);
	      }
	    }, this);
	  };
	
	/**
	 * A mapping can have one of the three levels of data:
	 *
	 *   1. Just the generated position.
	 *   2. The Generated position, original position, and original source.
	 *   3. Generated and original position, original source, as well as a name
	 *      token.
	 *
	 * To maintain consistency, we validate that any new mapping being added falls
	 * in to one of these categories.
	 */
	SourceMapGenerator.prototype._validateMapping =
	  function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource,
	                                              aName) {
	    // When aOriginal is truthy but has empty values for .line and .column,
	    // it is most likely a programmer error. In this case we throw a very
	    // specific error message to try to guide them the right way.
	    // For example: https://github.com/Polymer/polymer-bundler/pull/519
	    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') {
	        throw new Error(
	            'original.line and original.column are not numbers -- you probably meant to omit ' +
	            'the original mapping entirely and only map the generated position. If so, pass ' +
	            'null for the original mapping instead of an object with empty or null values.'
	        );
	    }
	
	    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	        && aGenerated.line > 0 && aGenerated.column >= 0
	        && !aOriginal && !aSource && !aName) {
	      // Case 1.
	      return;
	    }
	    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated
	             && aOriginal && 'line' in aOriginal && 'column' in aOriginal
	             && aGenerated.line > 0 && aGenerated.column >= 0
	             && aOriginal.line > 0 && aOriginal.column >= 0
	             && aSource) {
	      // Cases 2 and 3.
	      return;
	    }
	    else {
	      throw new Error('Invalid mapping: ' + JSON.stringify({
	        generated: aGenerated,
	        source: aSource,
	        original: aOriginal,
	        name: aName
	      }));
	    }
	  };
	
	/**
	 * Serialize the accumulated mappings in to the stream of base 64 VLQs
	 * specified by the source map format.
	 */
	SourceMapGenerator.prototype._serializeMappings =
	  function SourceMapGenerator_serializeMappings() {
	    var previousGeneratedColumn = 0;
	    var previousGeneratedLine = 1;
	    var previousOriginalColumn = 0;
	    var previousOriginalLine = 0;
	    var previousName = 0;
	    var previousSource = 0;
	    var result = '';
	    var next;
	    var mapping;
	    var nameIdx;
	    var sourceIdx;
	
	    var mappings = this._mappings.toArray();
	    for (var i = 0, len = mappings.length; i < len; i++) {
	      mapping = mappings[i];
	      next = ''
	
	      if (mapping.generatedLine !== previousGeneratedLine) {
	        previousGeneratedColumn = 0;
	        while (mapping.generatedLine !== previousGeneratedLine) {
	          next += ';';
	          previousGeneratedLine++;
	        }
	      }
	      else {
	        if (i > 0) {
	          if (!util.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) {
	            continue;
	          }
	          next += ',';
	        }
	      }
	
	      next += base64VLQ.encode(mapping.generatedColumn
	                                 - previousGeneratedColumn);
	      previousGeneratedColumn = mapping.generatedColumn;
	
	      if (mapping.source != null) {
	        sourceIdx = this._sources.indexOf(mapping.source);
	        next += base64VLQ.encode(sourceIdx - previousSource);
	        previousSource = sourceIdx;
	
	        // lines are stored 0-based in SourceMap spec version 3
	        next += base64VLQ.encode(mapping.originalLine - 1
	                                   - previousOriginalLine);
	        previousOriginalLine = mapping.originalLine - 1;
	
	        next += base64VLQ.encode(mapping.originalColumn
	                                   - previousOriginalColumn);
	        previousOriginalColumn = mapping.originalColumn;
	
	        if (mapping.name != null) {
	          nameIdx = this._names.indexOf(mapping.name);
	          next += base64VLQ.encode(nameIdx - previousName);
	          previousName = nameIdx;
	        }
	      }
	
	      result += next;
	    }
	
	    return result;
	  };
	
	SourceMapGenerator.prototype._generateSourcesContent =
	  function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
	    return aSources.map(function (source) {
	      if (!this._sourcesContents) {
	        return null;
	      }
	      if (aSourceRoot != null) {
	        source = util.relative(aSourceRoot, source);
	      }
	      var key = util.toSetString(source);
	      return Object.prototype.hasOwnProperty.call(this._sourcesContents, key)
	        ? this._sourcesContents[key]
	        : null;
	    }, this);
	  };
	
	/**
	 * Externalize the source map.
	 */
	SourceMapGenerator.prototype.toJSON =
	  function SourceMapGenerator_toJSON() {
	    var map = {
	      version: this._version,
	      sources: this._sources.toArray(),
	      names: this._names.toArray(),
	      mappings: this._serializeMappings()
	    };
	    if (this._file != null) {
	      map.file = this._file;
	    }
	    if (this._sourceRoot != null) {
	      map.sourceRoot = this._sourceRoot;
	    }
	    if (this._sourcesContents) {
	      map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
	    }
	
	    return map;
	  };
	
	/**
	 * Render the source map being generated to a string.
	 */
	SourceMapGenerator.prototype.toString =
	  function SourceMapGenerator_toString() {
	    return JSON.stringify(this.toJSON());
	  };
	
	exports.SourceMapGenerator = SourceMapGenerator;


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 *
	 * Based on the Base 64 VLQ implementation in Closure Compiler:
	 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
	 *
	 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
	 * Redistribution and use in source and binary forms, with or without
	 * modification, are permitted provided that the following conditions are
	 * met:
	 *
	 *  * Redistributions of source code must retain the above copyright
	 *    notice, this list of conditions and the following disclaimer.
	 *  * Redistributions in binary form must reproduce the above
	 *    copyright notice, this list of conditions and the following
	 *    disclaimer in the documentation and/or other materials provided
	 *    with the distribution.
	 *  * Neither the name of Google Inc. nor the names of its
	 *    contributors may be used to endorse or promote products derived
	 *    from this software without specific prior written permission.
	 *
	 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
	 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
	 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
	 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
	 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
	 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
	 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
	 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
	 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
	 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	 */
	
	var base64 = __webpack_require__(1317);
	
	// A single base 64 digit can contain 6 bits of data. For the base 64 variable
	// length quantities we use in the source map spec, the first bit is the sign,
	// the next four bits are the actual value, and the 6th bit is the
	// continuation bit. The continuation bit tells us whether there are more
	// digits in this value following this digit.
	//
	//   Continuation
	//   |    Sign
	//   |    |
	//   V    V
	//   101011
	
	var VLQ_BASE_SHIFT = 5;
	
	// binary: 100000
	var VLQ_BASE = 1 << VLQ_BASE_SHIFT;
	
	// binary: 011111
	var VLQ_BASE_MASK = VLQ_BASE - 1;
	
	// binary: 100000
	var VLQ_CONTINUATION_BIT = VLQ_BASE;
	
	/**
	 * Converts from a two-complement value to a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
	 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
	 */
	function toVLQSigned(aValue) {
	  return aValue < 0
	    ? ((-aValue) << 1) + 1
	    : (aValue << 1) + 0;
	}
	
	/**
	 * Converts to a two-complement value from a value where the sign bit is
	 * placed in the least significant bit.  For example, as decimals:
	 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
	 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
	 */
	function fromVLQSigned(aValue) {
	  var isNegative = (aValue & 1) === 1;
	  var shifted = aValue >> 1;
	  return isNegative
	    ? -shifted
	    : shifted;
	}
	
	/**
	 * Returns the base 64 VLQ encoded value.
	 */
	exports.encode = function base64VLQ_encode(aValue) {
	  var encoded = "";
	  var digit;
	
	  var vlq = toVLQSigned(aValue);
	
	  do {
	    digit = vlq & VLQ_BASE_MASK;
	    vlq >>>= VLQ_BASE_SHIFT;
	    if (vlq > 0) {
	      // There are still more digits in this value, so we must make sure the
	      // continuation bit is marked.
	      digit |= VLQ_CONTINUATION_BIT;
	    }
	    encoded += base64.encode(digit);
	  } while (vlq > 0);
	
	  return encoded;
	};
	
	/**
	 * Decodes the next base 64 VLQ value from the given string and returns the
	 * value and the rest of the string via the out parameter.
	 */
	exports.decode = function base64VLQ_decode(aStr, aIndex, aOutParam) {
	  var strLen = aStr.length;
	  var result = 0;
	  var shift = 0;
	  var continuation, digit;
	
	  do {
	    if (aIndex >= strLen) {
	      throw new Error("Expected more digits in base 64 VLQ value.");
	    }
	
	    digit = base64.decode(aStr.charCodeAt(aIndex++));
	    if (digit === -1) {
	      throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
	    }
	
	    continuation = !!(digit & VLQ_CONTINUATION_BIT);
	    digit &= VLQ_BASE_MASK;
	    result = result + (digit << shift);
	    shift += VLQ_BASE_SHIFT;
	  } while (continuation);
	
	  aOutParam.value = fromVLQSigned(result);
	  aOutParam.rest = aIndex;
	};


/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
	
	/**
	 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
	 */
	exports.encode = function (number) {
	  if (0 <= number && number < intToCharMap.length) {
	    return intToCharMap[number];
	  }
	  throw new TypeError("Must be between 0 and 63: " + number);
	};
	
	/**
	 * Decode a single base 64 character code digit to an integer. Returns -1 on
	 * failure.
	 */
	exports.decode = function (charCode) {
	  var bigA = 65;     // 'A'
	  var bigZ = 90;     // 'Z'
	
	  var littleA = 97;  // 'a'
	  var littleZ = 122; // 'z'
	
	  var zero = 48;     // '0'
	  var nine = 57;     // '9'
	
	  var plus = 43;     // '+'
	  var slash = 47;    // '/'
	
	  var littleOffset = 26;
	  var numberOffset = 52;
	
	  // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
	  if (bigA <= charCode && charCode <= bigZ) {
	    return (charCode - bigA);
	  }
	
	  // 26 - 51: abcdefghijklmnopqrstuvwxyz
	  if (littleA <= charCode && charCode <= littleZ) {
	    return (charCode - littleA + littleOffset);
	  }
	
	  // 52 - 61: 0123456789
	  if (zero <= charCode && charCode <= nine) {
	    return (charCode - zero + numberOffset);
	  }
	
	  // 62: +
	  if (charCode == plus) {
	    return 62;
	  }
	
	  // 63: /
	  if (charCode == slash) {
	    return 63;
	  }
	
	  // Invalid base64 digit.
	  return -1;
	};


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	/**
	 * This is a helper function for getting values from parameter/options
	 * objects.
	 *
	 * @param args The object we are extracting values from
	 * @param name The name of the property we are getting.
	 * @param defaultValue An optional value to return if the property is missing
	 * from the object. If this is not specified and the property is missing, an
	 * error will be thrown.
	 */
	function getArg(aArgs, aName, aDefaultValue) {
	  if (aName in aArgs) {
	    return aArgs[aName];
	  } else if (arguments.length === 3) {
	    return aDefaultValue;
	  } else {
	    throw new Error('"' + aName + '" is a required argument.');
	  }
	}
	exports.getArg = getArg;
	
	var urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.]*)(?::(\d+))?(\S*)$/;
	var dataUrlRegexp = /^data:.+\,.+$/;
	
	function urlParse(aUrl) {
	  var match = aUrl.match(urlRegexp);
	  if (!match) {
	    return null;
	  }
	  return {
	    scheme: match[1],
	    auth: match[2],
	    host: match[3],
	    port: match[4],
	    path: match[5]
	  };
	}
	exports.urlParse = urlParse;
	
	function urlGenerate(aParsedUrl) {
	  var url = '';
	  if (aParsedUrl.scheme) {
	    url += aParsedUrl.scheme + ':';
	  }
	  url += '//';
	  if (aParsedUrl.auth) {
	    url += aParsedUrl.auth + '@';
	  }
	  if (aParsedUrl.host) {
	    url += aParsedUrl.host;
	  }
	  if (aParsedUrl.port) {
	    url += ":" + aParsedUrl.port
	  }
	  if (aParsedUrl.path) {
	    url += aParsedUrl.path;
	  }
	  return url;
	}
	exports.urlGenerate = urlGenerate;
	
	/**
	 * Normalizes a path, or the path portion of a URL:
	 *
	 * - Replaces consecutive slashes with one slash.
	 * - Removes unnecessary '.' parts.
	 * - Removes unnecessary '<dir>/..' parts.
	 *
	 * Based on code in the Node.js 'path' core module.
	 *
	 * @param aPath The path or url to normalize.
	 */
	function normalize(aPath) {
	  var path = aPath;
	  var url = urlParse(aPath);
	  if (url) {
	    if (!url.path) {
	      return aPath;
	    }
	    path = url.path;
	  }
	  var isAbsolute = exports.isAbsolute(path);
	
	  var parts = path.split(/\/+/);
	  for (var part, up = 0, i = parts.length - 1; i >= 0; i--) {
	    part = parts[i];
	    if (part === '.') {
	      parts.splice(i, 1);
	    } else if (part === '..') {
	      up++;
	    } else if (up > 0) {
	      if (part === '') {
	        // The first part is blank if the path is absolute. Trying to go
	        // above the root is a no-op. Therefore we can remove all '..' parts
	        // directly after the root.
	        parts.splice(i + 1, up);
	        up = 0;
	      } else {
	        parts.splice(i, 2);
	        up--;
	      }
	    }
	  }
	  path = parts.join('/');
	
	  if (path === '') {
	    path = isAbsolute ? '/' : '.';
	  }
	
	  if (url) {
	    url.path = path;
	    return urlGenerate(url);
	  }
	  return path;
	}
	exports.normalize = normalize;
	
	/**
	 * Joins two paths/URLs.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be joined with the root.
	 *
	 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
	 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
	 *   first.
	 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
	 *   is updated with the result and aRoot is returned. Otherwise the result
	 *   is returned.
	 *   - If aPath is absolute, the result is aPath.
	 *   - Otherwise the two paths are joined with a slash.
	 * - Joining for example 'http://' and 'www.example.com' is also supported.
	 */
	function join(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	  if (aPath === "") {
	    aPath = ".";
	  }
	  var aPathUrl = urlParse(aPath);
	  var aRootUrl = urlParse(aRoot);
	  if (aRootUrl) {
	    aRoot = aRootUrl.path || '/';
	  }
	
	  // `join(foo, '//www.example.org')`
	  if (aPathUrl && !aPathUrl.scheme) {
	    if (aRootUrl) {
	      aPathUrl.scheme = aRootUrl.scheme;
	    }
	    return urlGenerate(aPathUrl);
	  }
	
	  if (aPathUrl || aPath.match(dataUrlRegexp)) {
	    return aPath;
	  }
	
	  // `join('http://', 'www.example.com')`
	  if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
	    aRootUrl.host = aPath;
	    return urlGenerate(aRootUrl);
	  }
	
	  var joined = aPath.charAt(0) === '/'
	    ? aPath
	    : normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
	
	  if (aRootUrl) {
	    aRootUrl.path = joined;
	    return urlGenerate(aRootUrl);
	  }
	  return joined;
	}
	exports.join = join;
	
	exports.isAbsolute = function (aPath) {
	  return aPath.charAt(0) === '/' || !!aPath.match(urlRegexp);
	};
	
	/**
	 * Make a path relative to a URL or another path.
	 *
	 * @param aRoot The root path or URL.
	 * @param aPath The path or URL to be made relative to aRoot.
	 */
	function relative(aRoot, aPath) {
	  if (aRoot === "") {
	    aRoot = ".";
	  }
	
	  aRoot = aRoot.replace(/\/$/, '');
	
	  // It is possible for the path to be above the root. In this case, simply
	  // checking whether the root is a prefix of the path won't work. Instead, we
	  // need to remove components from the root one by one, until either we find
	  // a prefix that fits, or we run out of components to remove.
	  var level = 0;
	  while (aPath.indexOf(aRoot + '/') !== 0) {
	    var index = aRoot.lastIndexOf("/");
	    if (index < 0) {
	      return aPath;
	    }
	
	    // If the only part of the root that is left is the scheme (i.e. http://,
	    // file:///, etc.), one or more slashes (/), or simply nothing at all, we
	    // have exhausted all components, so the path is not relative to the root.
	    aRoot = aRoot.slice(0, index);
	    if (aRoot.match(/^([^\/]+:\/)?\/*$/)) {
	      return aPath;
	    }
	
	    ++level;
	  }
	
	  // Make sure we add a "../" for each component we removed from the root.
	  return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
	}
	exports.relative = relative;
	
	var supportsNullProto = (function () {
	  var obj = Object.create(null);
	  return !('__proto__' in obj);
	}());
	
	function identity (s) {
	  return s;
	}
	
	/**
	 * Because behavior goes wacky when you set `__proto__` on objects, we
	 * have to prefix all the strings in our set with an arbitrary character.
	 *
	 * See https://github.com/mozilla/source-map/pull/31 and
	 * https://github.com/mozilla/source-map/issues/30
	 *
	 * @param String aStr
	 */
	function toSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return '$' + aStr;
	  }
	
	  return aStr;
	}
	exports.toSetString = supportsNullProto ? identity : toSetString;
	
	function fromSetString(aStr) {
	  if (isProtoString(aStr)) {
	    return aStr.slice(1);
	  }
	
	  return aStr;
	}
	exports.fromSetString = supportsNullProto ? identity : fromSetString;
	
	function isProtoString(s) {
	  if (!s) {
	    return false;
	  }
	
	  var length = s.length;
	
	  if (length < 9 /* "__proto__".length */) {
	    return false;
	  }
	
	  if (s.charCodeAt(length - 1) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 2) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 3) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 4) !== 116 /* 't' */ ||
	      s.charCodeAt(length - 5) !== 111 /* 'o' */ ||
	      s.charCodeAt(length - 6) !== 114 /* 'r' */ ||
	      s.charCodeAt(length - 7) !== 112 /* 'p' */ ||
	      s.charCodeAt(length - 8) !== 95  /* '_' */ ||
	      s.charCodeAt(length - 9) !== 95  /* '_' */) {
	    return false;
	  }
	
	  for (var i = length - 10; i >= 0; i--) {
	    if (s.charCodeAt(i) !== 36 /* '$' */) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	/**
	 * Comparator between two mappings where the original positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same original source/line/column, but different generated
	 * line and column the same. Useful when searching for a mapping with a
	 * stubbed out mapping.
	 */
	function compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
	  var cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0 || onlyCompareOriginal) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByOriginalPositions = compareByOriginalPositions;
	
	/**
	 * Comparator between two mappings with deflated source and name indices where
	 * the generated positions are compared.
	 *
	 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
	 * mappings with the same generated line and column, but different
	 * source/name/original line and column the same. Useful when searching for a
	 * mapping with a stubbed out mapping.
	 */
	function compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0 || onlyCompareGenerated) {
	    return cmp;
	  }
	
	  cmp = mappingA.source - mappingB.source;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return mappingA.name - mappingB.name;
	}
	exports.compareByGeneratedPositionsDeflated = compareByGeneratedPositionsDeflated;
	
	function strcmp(aStr1, aStr2) {
	  if (aStr1 === aStr2) {
	    return 0;
	  }
	
	  if (aStr1 > aStr2) {
	    return 1;
	  }
	
	  return -1;
	}
	
	/**
	 * Comparator between two mappings with inflated source and name strings where
	 * the generated positions are compared.
	 */
	function compareByGeneratedPositionsInflated(mappingA, mappingB) {
	  var cmp = mappingA.generatedLine - mappingB.generatedLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.generatedColumn - mappingB.generatedColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = strcmp(mappingA.source, mappingB.source);
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalLine - mappingB.originalLine;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  cmp = mappingA.originalColumn - mappingB.originalColumn;
	  if (cmp !== 0) {
	    return cmp;
	  }
	
	  return strcmp(mappingA.name, mappingB.name);
	}
	exports.compareByGeneratedPositionsInflated = compareByGeneratedPositionsInflated;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1318);
	var has = Object.prototype.hasOwnProperty;
	var hasNativeMap = typeof Map !== "undefined";
	
	/**
	 * A data structure which is a combination of an array and a set. Adding a new
	 * member is O(1), testing for membership is O(1), and finding the index of an
	 * element is O(1). Removing elements from the set is not supported. Only
	 * strings are supported for membership.
	 */
	function ArraySet() {
	  this._array = [];
	  this._set = hasNativeMap ? new Map() : Object.create(null);
	}
	
	/**
	 * Static method for creating ArraySet instances from an existing array.
	 */
	ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
	  var set = new ArraySet();
	  for (var i = 0, len = aArray.length; i < len; i++) {
	    set.add(aArray[i], aAllowDuplicates);
	  }
	  return set;
	};
	
	/**
	 * Return how many unique items are in this ArraySet. If duplicates have been
	 * added, than those do not count towards the size.
	 *
	 * @returns Number
	 */
	ArraySet.prototype.size = function ArraySet_size() {
	  return hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
	};
	
	/**
	 * Add the given string to this set.
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
	  var sStr = hasNativeMap ? aStr : util.toSetString(aStr);
	  var isDuplicate = hasNativeMap ? this.has(aStr) : has.call(this._set, sStr);
	  var idx = this._array.length;
	  if (!isDuplicate || aAllowDuplicates) {
	    this._array.push(aStr);
	  }
	  if (!isDuplicate) {
	    if (hasNativeMap) {
	      this._set.set(aStr, idx);
	    } else {
	      this._set[sStr] = idx;
	    }
	  }
	};
	
	/**
	 * Is the given string a member of this set?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.has = function ArraySet_has(aStr) {
	  if (hasNativeMap) {
	    return this._set.has(aStr);
	  } else {
	    var sStr = util.toSetString(aStr);
	    return has.call(this._set, sStr);
	  }
	};
	
	/**
	 * What is the index of the given string in the array?
	 *
	 * @param String aStr
	 */
	ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
	  if (hasNativeMap) {
	    var idx = this._set.get(aStr);
	    if (idx >= 0) {
	        return idx;
	    }
	  } else {
	    var sStr = util.toSetString(aStr);
	    if (has.call(this._set, sStr)) {
	      return this._set[sStr];
	    }
	  }
	
	  throw new Error('"' + aStr + '" is not in the set.');
	};
	
	/**
	 * What is the element at the given index?
	 *
	 * @param Number aIdx
	 */
	ArraySet.prototype.at = function ArraySet_at(aIdx) {
	  if (aIdx >= 0 && aIdx < this._array.length) {
	    return this._array[aIdx];
	  }
	  throw new Error('No element indexed by ' + aIdx);
	};
	
	/**
	 * Returns the array representation of this set (which has the proper indices
	 * indicated by indexOf). Note that this is a copy of the internal array used
	 * for storing the members so that no one can mess with internal state.
	 */
	ArraySet.prototype.toArray = function ArraySet_toArray() {
	  return this._array.slice();
	};
	
	exports.ArraySet = ArraySet;


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2014 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1318);
	
	/**
	 * Determine whether mappingB is after mappingA with respect to generated
	 * position.
	 */
	function generatedPositionAfter(mappingA, mappingB) {
	  // Optimized for most common case
	  var lineA = mappingA.generatedLine;
	  var lineB = mappingB.generatedLine;
	  var columnA = mappingA.generatedColumn;
	  var columnB = mappingB.generatedColumn;
	  return lineB > lineA || lineB == lineA && columnB >= columnA ||
	         util.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
	}
	
	/**
	 * A data structure to provide a sorted view of accumulated mappings in a
	 * performance conscious manner. It trades a neglibable overhead in general
	 * case for a large speedup in case of mappings being added in order.
	 */
	function MappingList() {
	  this._array = [];
	  this._sorted = true;
	  // Serves as infimum
	  this._last = {generatedLine: -1, generatedColumn: 0};
	}
	
	/**
	 * Iterate through internal items. This method takes the same arguments that
	 * `Array.prototype.forEach` takes.
	 *
	 * NOTE: The order of the mappings is NOT guaranteed.
	 */
	MappingList.prototype.unsortedForEach =
	  function MappingList_forEach(aCallback, aThisArg) {
	    this._array.forEach(aCallback, aThisArg);
	  };
	
	/**
	 * Add the given source mapping.
	 *
	 * @param Object aMapping
	 */
	MappingList.prototype.add = function MappingList_add(aMapping) {
	  if (generatedPositionAfter(this._last, aMapping)) {
	    this._last = aMapping;
	    this._array.push(aMapping);
	  } else {
	    this._sorted = false;
	    this._array.push(aMapping);
	  }
	};
	
	/**
	 * Returns the flat, sorted array of mappings. The mappings are sorted by
	 * generated position.
	 *
	 * WARNING: This method returns internal data without copying, for
	 * performance. The return value must NOT be mutated, and should be treated as
	 * an immutable borrow. If you want to take ownership, you must make your own
	 * copy.
	 */
	MappingList.prototype.toArray = function MappingList_toArray() {
	  if (!this._sorted) {
	    this._array.sort(util.compareByGeneratedPositionsInflated);
	    this._sorted = true;
	  }
	  return this._array;
	};
	
	exports.MappingList = MappingList;


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var util = __webpack_require__(1318);
	var binarySearch = __webpack_require__(1322);
	var ArraySet = __webpack_require__(1319).ArraySet;
	var base64VLQ = __webpack_require__(1316);
	var quickSort = __webpack_require__(1323).quickSort;
	
	function SourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  return sourceMap.sections != null
	    ? new IndexedSourceMapConsumer(sourceMap)
	    : new BasicSourceMapConsumer(sourceMap);
	}
	
	SourceMapConsumer.fromSourceMap = function(aSourceMap) {
	  return BasicSourceMapConsumer.fromSourceMap(aSourceMap);
	}
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	SourceMapConsumer.prototype._version = 3;
	
	// `__generatedMappings` and `__originalMappings` are arrays that hold the
	// parsed mapping coordinates from the source map's "mappings" attribute. They
	// are lazily instantiated, accessed via the `_generatedMappings` and
	// `_originalMappings` getters respectively, and we only parse the mappings
	// and create these arrays once queried for a source location. We jump through
	// these hoops because there can be many thousands of mappings, and parsing
	// them is expensive, so we only want to do it if we must.
	//
	// Each object in the arrays is of the form:
	//
	//     {
	//       generatedLine: The line number in the generated code,
	//       generatedColumn: The column number in the generated code,
	//       source: The path to the original source file that generated this
	//               chunk of code,
	//       originalLine: The line number in the original source that
	//                     corresponds to this chunk of generated code,
	//       originalColumn: The column number in the original source that
	//                       corresponds to this chunk of generated code,
	//       name: The name of the original symbol which generated this chunk of
	//             code.
	//     }
	//
	// All properties except for `generatedLine` and `generatedColumn` can be
	// `null`.
	//
	// `_generatedMappings` is ordered by the generated positions.
	//
	// `_originalMappings` is ordered by the original positions.
	
	SourceMapConsumer.prototype.__generatedMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_generatedMappings', {
	  get: function () {
	    if (!this.__generatedMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__generatedMappings;
	  }
	});
	
	SourceMapConsumer.prototype.__originalMappings = null;
	Object.defineProperty(SourceMapConsumer.prototype, '_originalMappings', {
	  get: function () {
	    if (!this.__originalMappings) {
	      this._parseMappings(this._mappings, this.sourceRoot);
	    }
	
	    return this.__originalMappings;
	  }
	});
	
	SourceMapConsumer.prototype._charIsMappingSeparator =
	  function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
	    var c = aStr.charAt(index);
	    return c === ";" || c === ",";
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	SourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    throw new Error("Subclasses must implement _parseMappings");
	  };
	
	SourceMapConsumer.GENERATED_ORDER = 1;
	SourceMapConsumer.ORIGINAL_ORDER = 2;
	
	SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
	SourceMapConsumer.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Iterate over each mapping between an original source/line/column and a
	 * generated line/column in this source map.
	 *
	 * @param Function aCallback
	 *        The function that is called with each mapping.
	 * @param Object aContext
	 *        Optional. If specified, this object will be the value of `this` every
	 *        time that `aCallback` is called.
	 * @param aOrder
	 *        Either `SourceMapConsumer.GENERATED_ORDER` or
	 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
	 *        iterate over the mappings sorted by the generated file's line/column
	 *        order or the original's source/line/column order, respectively. Defaults to
	 *        `SourceMapConsumer.GENERATED_ORDER`.
	 */
	SourceMapConsumer.prototype.eachMapping =
	  function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
	    var context = aContext || null;
	    var order = aOrder || SourceMapConsumer.GENERATED_ORDER;
	
	    var mappings;
	    switch (order) {
	    case SourceMapConsumer.GENERATED_ORDER:
	      mappings = this._generatedMappings;
	      break;
	    case SourceMapConsumer.ORIGINAL_ORDER:
	      mappings = this._originalMappings;
	      break;
	    default:
	      throw new Error("Unknown order of iteration.");
	    }
	
	    var sourceRoot = this.sourceRoot;
	    mappings.map(function (mapping) {
	      var source = mapping.source === null ? null : this._sources.at(mapping.source);
	      if (source != null && sourceRoot != null) {
	        source = util.join(sourceRoot, source);
	      }
	      return {
	        source: source,
	        generatedLine: mapping.generatedLine,
	        generatedColumn: mapping.generatedColumn,
	        originalLine: mapping.originalLine,
	        originalColumn: mapping.originalColumn,
	        name: mapping.name === null ? null : this._names.at(mapping.name)
	      };
	    }, this).forEach(aCallback, context);
	  };
	
	/**
	 * Returns all generated line and column information for the original source,
	 * line, and column provided. If no column is provided, returns all mappings
	 * corresponding to a either the line we are searching for or the next
	 * closest line that has any mappings. Otherwise, returns all mappings
	 * corresponding to the given line and either the column we are searching for
	 * or the next closest column that has any offsets.
	 *
	 * The only argument is an object with the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: Optional. the column number in the original source.
	 *
	 * and an array of objects is returned, each with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	SourceMapConsumer.prototype.allGeneratedPositionsFor =
	  function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
	    var line = util.getArg(aArgs, 'line');
	
	    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
	    // returns the index of the closest mapping less than the needle. By
	    // setting needle.originalColumn to 0, we thus find the last mapping for
	    // the given line, provided such a mapping exists.
	    var needle = {
	      source: util.getArg(aArgs, 'source'),
	      originalLine: line,
	      originalColumn: util.getArg(aArgs, 'column', 0)
	    };
	
	    if (this.sourceRoot != null) {
	      needle.source = util.relative(this.sourceRoot, needle.source);
	    }
	    if (!this._sources.has(needle.source)) {
	      return [];
	    }
	    needle.source = this._sources.indexOf(needle.source);
	
	    var mappings = [];
	
	    var index = this._findMapping(needle,
	                                  this._originalMappings,
	                                  "originalLine",
	                                  "originalColumn",
	                                  util.compareByOriginalPositions,
	                                  binarySearch.LEAST_UPPER_BOUND);
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (aArgs.column === undefined) {
	        var originalLine = mapping.originalLine;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we found. Since
	        // mappings are sorted, this is guaranteed to find all mappings for
	        // the line we found.
	        while (mapping && mapping.originalLine === originalLine) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      } else {
	        var originalColumn = mapping.originalColumn;
	
	        // Iterate until either we run out of mappings, or we run into
	        // a mapping for a different line than the one we were searching for.
	        // Since mappings are sorted, this is guaranteed to find all mappings for
	        // the line we are searching for.
	        while (mapping &&
	               mapping.originalLine === line &&
	               mapping.originalColumn == originalColumn) {
	          mappings.push({
	            line: util.getArg(mapping, 'generatedLine', null),
	            column: util.getArg(mapping, 'generatedColumn', null),
	            lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	          });
	
	          mapping = this._originalMappings[++index];
	        }
	      }
	    }
	
	    return mappings;
	  };
	
	exports.SourceMapConsumer = SourceMapConsumer;
	
	/**
	 * A BasicSourceMapConsumer instance represents a parsed source map which we can
	 * query for information about the original file positions by giving it a file
	 * position in the generated source.
	 *
	 * The only parameter is the raw source map (either as a JSON string, or
	 * already parsed to an object). According to the spec, source maps have the
	 * following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - sources: An array of URLs to the original source files.
	 *   - names: An array of identifiers which can be referrenced by individual mappings.
	 *   - sourceRoot: Optional. The URL root from which all sources are relative.
	 *   - sourcesContent: Optional. An array of contents of the original source files.
	 *   - mappings: A string of base64 VLQs which contain the actual mappings.
	 *   - file: Optional. The generated file this source map is associated with.
	 *
	 * Here is an example source map, taken from the source map spec[0]:
	 *
	 *     {
	 *       version : 3,
	 *       file: "out.js",
	 *       sourceRoot : "",
	 *       sources: ["foo.js", "bar.js"],
	 *       names: ["src", "maps", "are", "fun"],
	 *       mappings: "AA,AB;;ABCDE;"
	 *     }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
	 */
	function BasicSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sources = util.getArg(sourceMap, 'sources');
	  // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
	  // requires the array) to play nice here.
	  var names = util.getArg(sourceMap, 'names', []);
	  var sourceRoot = util.getArg(sourceMap, 'sourceRoot', null);
	  var sourcesContent = util.getArg(sourceMap, 'sourcesContent', null);
	  var mappings = util.getArg(sourceMap, 'mappings');
	  var file = util.getArg(sourceMap, 'file', null);
	
	  // Once again, Sass deviates from the spec and supplies the version as a
	  // string rather than a number, so we use loose equality checking here.
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  sources = sources
	    .map(String)
	    // Some source maps produce relative source paths like "./foo.js" instead of
	    // "foo.js".  Normalize these first so that future comparisons will succeed.
	    // See bugzil.la/1090768.
	    .map(util.normalize)
	    // Always ensure that absolute sources are internally stored relative to
	    // the source root, if the source root is absolute. Not doing this would
	    // be particularly problematic when the source root is a prefix of the
	    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
	    .map(function (source) {
	      return sourceRoot && util.isAbsolute(sourceRoot) && util.isAbsolute(source)
	        ? util.relative(sourceRoot, source)
	        : source;
	    });
	
	  // Pass `true` below to allow duplicate names and sources. While source maps
	  // are intended to be compressed and deduplicated, the TypeScript compiler
	  // sometimes generates source maps with duplicates in them. See Github issue
	  // #72 and bugzil.la/889492.
	  this._names = ArraySet.fromArray(names.map(String), true);
	  this._sources = ArraySet.fromArray(sources, true);
	
	  this.sourceRoot = sourceRoot;
	  this.sourcesContent = sourcesContent;
	  this._mappings = mappings;
	  this.file = file;
	}
	
	BasicSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	BasicSourceMapConsumer.prototype.consumer = SourceMapConsumer;
	
	/**
	 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
	 *
	 * @param SourceMapGenerator aSourceMap
	 *        The source map that will be consumed.
	 * @returns BasicSourceMapConsumer
	 */
	BasicSourceMapConsumer.fromSourceMap =
	  function SourceMapConsumer_fromSourceMap(aSourceMap) {
	    var smc = Object.create(BasicSourceMapConsumer.prototype);
	
	    var names = smc._names = ArraySet.fromArray(aSourceMap._names.toArray(), true);
	    var sources = smc._sources = ArraySet.fromArray(aSourceMap._sources.toArray(), true);
	    smc.sourceRoot = aSourceMap._sourceRoot;
	    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(),
	                                                            smc.sourceRoot);
	    smc.file = aSourceMap._file;
	
	    // Because we are modifying the entries (by converting string sources and
	    // names to indices into the sources and names ArraySets), we have to make
	    // a copy of the entry or else bad things happen. Shared mutable state
	    // strikes again! See github issue #191.
	
	    var generatedMappings = aSourceMap._mappings.toArray().slice();
	    var destGeneratedMappings = smc.__generatedMappings = [];
	    var destOriginalMappings = smc.__originalMappings = [];
	
	    for (var i = 0, length = generatedMappings.length; i < length; i++) {
	      var srcMapping = generatedMappings[i];
	      var destMapping = new Mapping;
	      destMapping.generatedLine = srcMapping.generatedLine;
	      destMapping.generatedColumn = srcMapping.generatedColumn;
	
	      if (srcMapping.source) {
	        destMapping.source = sources.indexOf(srcMapping.source);
	        destMapping.originalLine = srcMapping.originalLine;
	        destMapping.originalColumn = srcMapping.originalColumn;
	
	        if (srcMapping.name) {
	          destMapping.name = names.indexOf(srcMapping.name);
	        }
	
	        destOriginalMappings.push(destMapping);
	      }
	
	      destGeneratedMappings.push(destMapping);
	    }
	
	    quickSort(smc.__originalMappings, util.compareByOriginalPositions);
	
	    return smc;
	  };
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	BasicSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(BasicSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    return this._sources.toArray().map(function (s) {
	      return this.sourceRoot != null ? util.join(this.sourceRoot, s) : s;
	    }, this);
	  }
	});
	
	/**
	 * Provide the JIT with a nice shape / hidden class.
	 */
	function Mapping() {
	  this.generatedLine = 0;
	  this.generatedColumn = 0;
	  this.source = null;
	  this.originalLine = null;
	  this.originalColumn = null;
	  this.name = null;
	}
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	BasicSourceMapConsumer.prototype._parseMappings =
	  function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    var generatedLine = 1;
	    var previousGeneratedColumn = 0;
	    var previousOriginalLine = 0;
	    var previousOriginalColumn = 0;
	    var previousSource = 0;
	    var previousName = 0;
	    var length = aStr.length;
	    var index = 0;
	    var cachedSegments = {};
	    var temp = {};
	    var originalMappings = [];
	    var generatedMappings = [];
	    var mapping, str, segment, end, value;
	
	    while (index < length) {
	      if (aStr.charAt(index) === ';') {
	        generatedLine++;
	        index++;
	        previousGeneratedColumn = 0;
	      }
	      else if (aStr.charAt(index) === ',') {
	        index++;
	      }
	      else {
	        mapping = new Mapping();
	        mapping.generatedLine = generatedLine;
	
	        // Because each offset is encoded relative to the previous one,
	        // many segments often have the same encoding. We can exploit this
	        // fact by caching the parsed variable length fields of each segment,
	        // allowing us to avoid a second parse if we encounter the same
	        // segment again.
	        for (end = index; end < length; end++) {
	          if (this._charIsMappingSeparator(aStr, end)) {
	            break;
	          }
	        }
	        str = aStr.slice(index, end);
	
	        segment = cachedSegments[str];
	        if (segment) {
	          index += str.length;
	        } else {
	          segment = [];
	          while (index < end) {
	            base64VLQ.decode(aStr, index, temp);
	            value = temp.value;
	            index = temp.rest;
	            segment.push(value);
	          }
	
	          if (segment.length === 2) {
	            throw new Error('Found a source, but no line and column');
	          }
	
	          if (segment.length === 3) {
	            throw new Error('Found a source and line, but no column');
	          }
	
	          cachedSegments[str] = segment;
	        }
	
	        // Generated column.
	        mapping.generatedColumn = previousGeneratedColumn + segment[0];
	        previousGeneratedColumn = mapping.generatedColumn;
	
	        if (segment.length > 1) {
	          // Original source.
	          mapping.source = previousSource + segment[1];
	          previousSource += segment[1];
	
	          // Original line.
	          mapping.originalLine = previousOriginalLine + segment[2];
	          previousOriginalLine = mapping.originalLine;
	          // Lines are stored 0-based
	          mapping.originalLine += 1;
	
	          // Original column.
	          mapping.originalColumn = previousOriginalColumn + segment[3];
	          previousOriginalColumn = mapping.originalColumn;
	
	          if (segment.length > 4) {
	            // Original name.
	            mapping.name = previousName + segment[4];
	            previousName += segment[4];
	          }
	        }
	
	        generatedMappings.push(mapping);
	        if (typeof mapping.originalLine === 'number') {
	          originalMappings.push(mapping);
	        }
	      }
	    }
	
	    quickSort(generatedMappings, util.compareByGeneratedPositionsDeflated);
	    this.__generatedMappings = generatedMappings;
	
	    quickSort(originalMappings, util.compareByOriginalPositions);
	    this.__originalMappings = originalMappings;
	  };
	
	/**
	 * Find the mapping that best matches the hypothetical "needle" mapping that
	 * we are searching for in the given "haystack" of mappings.
	 */
	BasicSourceMapConsumer.prototype._findMapping =
	  function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName,
	                                         aColumnName, aComparator, aBias) {
	    // To return the position we are searching for, we must first find the
	    // mapping for the given position and then return the opposite position it
	    // points to. Because the mappings are sorted, we can use binary search to
	    // find the best mapping.
	
	    if (aNeedle[aLineName] <= 0) {
	      throw new TypeError('Line must be greater than or equal to 1, got '
	                          + aNeedle[aLineName]);
	    }
	    if (aNeedle[aColumnName] < 0) {
	      throw new TypeError('Column must be greater than or equal to 0, got '
	                          + aNeedle[aColumnName]);
	    }
	
	    return binarySearch.search(aNeedle, aMappings, aComparator, aBias);
	  };
	
	/**
	 * Compute the last column for each generated mapping. The last column is
	 * inclusive.
	 */
	BasicSourceMapConsumer.prototype.computeColumnSpans =
	  function SourceMapConsumer_computeColumnSpans() {
	    for (var index = 0; index < this._generatedMappings.length; ++index) {
	      var mapping = this._generatedMappings[index];
	
	      // Mappings do not contain a field for the last generated columnt. We
	      // can come up with an optimistic estimate, however, by assuming that
	      // mappings are contiguous (i.e. given two consecutive mappings, the
	      // first mapping ends where the second one starts).
	      if (index + 1 < this._generatedMappings.length) {
	        var nextMapping = this._generatedMappings[index + 1];
	
	        if (mapping.generatedLine === nextMapping.generatedLine) {
	          mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
	          continue;
	        }
	      }
	
	      // The last mapping for each line spans the entire line.
	      mapping.lastGeneratedColumn = Infinity;
	    }
	  };
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	BasicSourceMapConsumer.prototype.originalPositionFor =
	  function SourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._generatedMappings,
	      "generatedLine",
	      "generatedColumn",
	      util.compareByGeneratedPositionsDeflated,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._generatedMappings[index];
	
	      if (mapping.generatedLine === needle.generatedLine) {
	        var source = util.getArg(mapping, 'source', null);
	        if (source !== null) {
	          source = this._sources.at(source);
	          if (this.sourceRoot != null) {
	            source = util.join(this.sourceRoot, source);
	          }
	        }
	        var name = util.getArg(mapping, 'name', null);
	        if (name !== null) {
	          name = this._names.at(name);
	        }
	        return {
	          source: source,
	          line: util.getArg(mapping, 'originalLine', null),
	          column: util.getArg(mapping, 'originalColumn', null),
	          name: name
	        };
	      }
	    }
	
	    return {
	      source: null,
	      line: null,
	      column: null,
	      name: null
	    };
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	BasicSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function BasicSourceMapConsumer_hasContentsOfAllSources() {
	    if (!this.sourcesContent) {
	      return false;
	    }
	    return this.sourcesContent.length >= this._sources.size() &&
	      !this.sourcesContent.some(function (sc) { return sc == null; });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	BasicSourceMapConsumer.prototype.sourceContentFor =
	  function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    if (!this.sourcesContent) {
	      return null;
	    }
	
	    if (this.sourceRoot != null) {
	      aSource = util.relative(this.sourceRoot, aSource);
	    }
	
	    if (this._sources.has(aSource)) {
	      return this.sourcesContent[this._sources.indexOf(aSource)];
	    }
	
	    var url;
	    if (this.sourceRoot != null
	        && (url = util.urlParse(this.sourceRoot))) {
	      // XXX: file:// URIs and absolute paths lead to unexpected behavior for
	      // many users. We can help them out when they expect file:// URIs to
	      // behave like it would if they were running a local HTTP server. See
	      // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
	      var fileUriAbsPath = aSource.replace(/^file:\/\//, "");
	      if (url.scheme == "file"
	          && this._sources.has(fileUriAbsPath)) {
	        return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)]
	      }
	
	      if ((!url.path || url.path == "/")
	          && this._sources.has("/" + aSource)) {
	        return this.sourcesContent[this._sources.indexOf("/" + aSource)];
	      }
	    }
	
	    // This function is used recursively from
	    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
	    // don't want to throw if we can't find the source - we just want to
	    // return null, so we provide a flag to exit gracefully.
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
	 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	BasicSourceMapConsumer.prototype.generatedPositionFor =
	  function SourceMapConsumer_generatedPositionFor(aArgs) {
	    var source = util.getArg(aArgs, 'source');
	    if (this.sourceRoot != null) {
	      source = util.relative(this.sourceRoot, source);
	    }
	    if (!this._sources.has(source)) {
	      return {
	        line: null,
	        column: null,
	        lastColumn: null
	      };
	    }
	    source = this._sources.indexOf(source);
	
	    var needle = {
	      source: source,
	      originalLine: util.getArg(aArgs, 'line'),
	      originalColumn: util.getArg(aArgs, 'column')
	    };
	
	    var index = this._findMapping(
	      needle,
	      this._originalMappings,
	      "originalLine",
	      "originalColumn",
	      util.compareByOriginalPositions,
	      util.getArg(aArgs, 'bias', SourceMapConsumer.GREATEST_LOWER_BOUND)
	    );
	
	    if (index >= 0) {
	      var mapping = this._originalMappings[index];
	
	      if (mapping.source === needle.source) {
	        return {
	          line: util.getArg(mapping, 'generatedLine', null),
	          column: util.getArg(mapping, 'generatedColumn', null),
	          lastColumn: util.getArg(mapping, 'lastGeneratedColumn', null)
	        };
	      }
	    }
	
	    return {
	      line: null,
	      column: null,
	      lastColumn: null
	    };
	  };
	
	exports.BasicSourceMapConsumer = BasicSourceMapConsumer;
	
	/**
	 * An IndexedSourceMapConsumer instance represents a parsed source map which
	 * we can query for information. It differs from BasicSourceMapConsumer in
	 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
	 * input.
	 *
	 * The only parameter is a raw source map (either as a JSON string, or already
	 * parsed to an object). According to the spec for indexed source maps, they
	 * have the following attributes:
	 *
	 *   - version: Which version of the source map spec this map is following.
	 *   - file: Optional. The generated file this source map is associated with.
	 *   - sections: A list of section definitions.
	 *
	 * Each value under the "sections" field has two fields:
	 *   - offset: The offset into the original specified at which this section
	 *       begins to apply, defined as an object with a "line" and "column"
	 *       field.
	 *   - map: A source map definition. This source map could also be indexed,
	 *       but doesn't have to be.
	 *
	 * Instead of the "map" field, it's also possible to have a "url" field
	 * specifying a URL to retrieve a source map from, but that's currently
	 * unsupported.
	 *
	 * Here's an example source map, taken from the source map spec[0], but
	 * modified to omit a section which uses the "url" field.
	 *
	 *  {
	 *    version : 3,
	 *    file: "app.js",
	 *    sections: [{
	 *      offset: {line:100, column:10},
	 *      map: {
	 *        version : 3,
	 *        file: "section.js",
	 *        sources: ["foo.js", "bar.js"],
	 *        names: ["src", "maps", "are", "fun"],
	 *        mappings: "AAAA,E;;ABCDE;"
	 *      }
	 *    }],
	 *  }
	 *
	 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
	 */
	function IndexedSourceMapConsumer(aSourceMap) {
	  var sourceMap = aSourceMap;
	  if (typeof aSourceMap === 'string') {
	    sourceMap = JSON.parse(aSourceMap.replace(/^\)\]\}'/, ''));
	  }
	
	  var version = util.getArg(sourceMap, 'version');
	  var sections = util.getArg(sourceMap, 'sections');
	
	  if (version != this._version) {
	    throw new Error('Unsupported version: ' + version);
	  }
	
	  this._sources = new ArraySet();
	  this._names = new ArraySet();
	
	  var lastOffset = {
	    line: -1,
	    column: 0
	  };
	  this._sections = sections.map(function (s) {
	    if (s.url) {
	      // The url field will require support for asynchronicity.
	      // See https://github.com/mozilla/source-map/issues/16
	      throw new Error('Support for url field in sections not implemented.');
	    }
	    var offset = util.getArg(s, 'offset');
	    var offsetLine = util.getArg(offset, 'line');
	    var offsetColumn = util.getArg(offset, 'column');
	
	    if (offsetLine < lastOffset.line ||
	        (offsetLine === lastOffset.line && offsetColumn < lastOffset.column)) {
	      throw new Error('Section offsets must be ordered and non-overlapping.');
	    }
	    lastOffset = offset;
	
	    return {
	      generatedOffset: {
	        // The offset fields are 0-based, but we use 1-based indices when
	        // encoding/decoding from VLQ.
	        generatedLine: offsetLine + 1,
	        generatedColumn: offsetColumn + 1
	      },
	      consumer: new SourceMapConsumer(util.getArg(s, 'map'))
	    }
	  });
	}
	
	IndexedSourceMapConsumer.prototype = Object.create(SourceMapConsumer.prototype);
	IndexedSourceMapConsumer.prototype.constructor = SourceMapConsumer;
	
	/**
	 * The version of the source mapping spec that we are consuming.
	 */
	IndexedSourceMapConsumer.prototype._version = 3;
	
	/**
	 * The list of original sources.
	 */
	Object.defineProperty(IndexedSourceMapConsumer.prototype, 'sources', {
	  get: function () {
	    var sources = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      for (var j = 0; j < this._sections[i].consumer.sources.length; j++) {
	        sources.push(this._sections[i].consumer.sources[j]);
	      }
	    }
	    return sources;
	  }
	});
	
	/**
	 * Returns the original source, line, and column information for the generated
	 * source's line and column positions provided. The only argument is an object
	 * with the following properties:
	 *
	 *   - line: The line number in the generated source.
	 *   - column: The column number in the generated source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - source: The original source file, or null.
	 *   - line: The line number in the original source, or null.
	 *   - column: The column number in the original source, or null.
	 *   - name: The original identifier, or null.
	 */
	IndexedSourceMapConsumer.prototype.originalPositionFor =
	  function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
	    var needle = {
	      generatedLine: util.getArg(aArgs, 'line'),
	      generatedColumn: util.getArg(aArgs, 'column')
	    };
	
	    // Find the section containing the generated position we're trying to map
	    // to an original position.
	    var sectionIndex = binarySearch.search(needle, this._sections,
	      function(needle, section) {
	        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
	        if (cmp) {
	          return cmp;
	        }
	
	        return (needle.generatedColumn -
	                section.generatedOffset.generatedColumn);
	      });
	    var section = this._sections[sectionIndex];
	
	    if (!section) {
	      return {
	        source: null,
	        line: null,
	        column: null,
	        name: null
	      };
	    }
	
	    return section.consumer.originalPositionFor({
	      line: needle.generatedLine -
	        (section.generatedOffset.generatedLine - 1),
	      column: needle.generatedColumn -
	        (section.generatedOffset.generatedLine === needle.generatedLine
	         ? section.generatedOffset.generatedColumn - 1
	         : 0),
	      bias: aArgs.bias
	    });
	  };
	
	/**
	 * Return true if we have the source content for every source in the source
	 * map, false otherwise.
	 */
	IndexedSourceMapConsumer.prototype.hasContentsOfAllSources =
	  function IndexedSourceMapConsumer_hasContentsOfAllSources() {
	    return this._sections.every(function (s) {
	      return s.consumer.hasContentsOfAllSources();
	    });
	  };
	
	/**
	 * Returns the original source content. The only argument is the url of the
	 * original source file. Returns null if no original source content is
	 * available.
	 */
	IndexedSourceMapConsumer.prototype.sourceContentFor =
	  function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      var content = section.consumer.sourceContentFor(aSource, true);
	      if (content) {
	        return content;
	      }
	    }
	    if (nullOnMissing) {
	      return null;
	    }
	    else {
	      throw new Error('"' + aSource + '" is not in the SourceMap.');
	    }
	  };
	
	/**
	 * Returns the generated line and column information for the original source,
	 * line, and column positions provided. The only argument is an object with
	 * the following properties:
	 *
	 *   - source: The filename of the original source.
	 *   - line: The line number in the original source.
	 *   - column: The column number in the original source.
	 *
	 * and an object is returned with the following properties:
	 *
	 *   - line: The line number in the generated source, or null.
	 *   - column: The column number in the generated source, or null.
	 */
	IndexedSourceMapConsumer.prototype.generatedPositionFor =
	  function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	
	      // Only consider this section if the requested source is in the list of
	      // sources of the consumer.
	      if (section.consumer.sources.indexOf(util.getArg(aArgs, 'source')) === -1) {
	        continue;
	      }
	      var generatedPosition = section.consumer.generatedPositionFor(aArgs);
	      if (generatedPosition) {
	        var ret = {
	          line: generatedPosition.line +
	            (section.generatedOffset.generatedLine - 1),
	          column: generatedPosition.column +
	            (section.generatedOffset.generatedLine === generatedPosition.line
	             ? section.generatedOffset.generatedColumn - 1
	             : 0)
	        };
	        return ret;
	      }
	    }
	
	    return {
	      line: null,
	      column: null
	    };
	  };
	
	/**
	 * Parse the mappings in a string in to a data structure which we can easily
	 * query (the ordered arrays in the `this.__generatedMappings` and
	 * `this.__originalMappings` properties).
	 */
	IndexedSourceMapConsumer.prototype._parseMappings =
	  function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
	    this.__generatedMappings = [];
	    this.__originalMappings = [];
	    for (var i = 0; i < this._sections.length; i++) {
	      var section = this._sections[i];
	      var sectionMappings = section.consumer._generatedMappings;
	      for (var j = 0; j < sectionMappings.length; j++) {
	        var mapping = sectionMappings[j];
	
	        var source = section.consumer._sources.at(mapping.source);
	        if (section.consumer.sourceRoot !== null) {
	          source = util.join(section.consumer.sourceRoot, source);
	        }
	        this._sources.add(source);
	        source = this._sources.indexOf(source);
	
	        var name = section.consumer._names.at(mapping.name);
	        this._names.add(name);
	        name = this._names.indexOf(name);
	
	        // The mappings coming from the consumer for the section have
	        // generated positions relative to the start of the section, so we
	        // need to offset them to be relative to the start of the concatenated
	        // generated file.
	        var adjustedMapping = {
	          source: source,
	          generatedLine: mapping.generatedLine +
	            (section.generatedOffset.generatedLine - 1),
	          generatedColumn: mapping.generatedColumn +
	            (section.generatedOffset.generatedLine === mapping.generatedLine
	            ? section.generatedOffset.generatedColumn - 1
	            : 0),
	          originalLine: mapping.originalLine,
	          originalColumn: mapping.originalColumn,
	          name: name
	        };
	
	        this.__generatedMappings.push(adjustedMapping);
	        if (typeof adjustedMapping.originalLine === 'number') {
	          this.__originalMappings.push(adjustedMapping);
	        }
	      }
	    }
	
	    quickSort(this.__generatedMappings, util.compareByGeneratedPositionsDeflated);
	    quickSort(this.__originalMappings, util.compareByOriginalPositions);
	  };
	
	exports.IndexedSourceMapConsumer = IndexedSourceMapConsumer;


/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	exports.GREATEST_LOWER_BOUND = 1;
	exports.LEAST_UPPER_BOUND = 2;
	
	/**
	 * Recursive implementation of binary search.
	 *
	 * @param aLow Indices here and lower do not contain the needle.
	 * @param aHigh Indices here and higher do not contain the needle.
	 * @param aNeedle The element being searched for.
	 * @param aHaystack The non-empty array being searched.
	 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 */
	function recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
	  // This function terminates when one of the following is true:
	  //
	  //   1. We find the exact element we are looking for.
	  //
	  //   2. We did not find the exact element, but we can return the index of
	  //      the next-closest element.
	  //
	  //   3. We did not find the exact element, and there is no next-closest
	  //      element than the one we are searching for, so we return -1.
	  var mid = Math.floor((aHigh - aLow) / 2) + aLow;
	  var cmp = aCompare(aNeedle, aHaystack[mid], true);
	  if (cmp === 0) {
	    // Found the element we are looking for.
	    return mid;
	  }
	  else if (cmp > 0) {
	    // Our needle is greater than aHaystack[mid].
	    if (aHigh - mid > 1) {
	      // The element is in the upper half.
	      return recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // The exact needle element was not found in this haystack. Determine if
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return aHigh < aHaystack.length ? aHigh : -1;
	    } else {
	      return mid;
	    }
	  }
	  else {
	    // Our needle is less than aHaystack[mid].
	    if (mid - aLow > 1) {
	      // The element is in the lower half.
	      return recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
	    }
	
	    // we are in termination case (3) or (2) and return the appropriate thing.
	    if (aBias == exports.LEAST_UPPER_BOUND) {
	      return mid;
	    } else {
	      return aLow < 0 ? -1 : aLow;
	    }
	  }
	}
	
	/**
	 * This is an implementation of binary search which will always try and return
	 * the index of the closest element if there is no exact hit. This is because
	 * mappings between original and generated line/col pairs are single points,
	 * and there is an implicit region between each of them, so a miss just means
	 * that you aren't on the very start of a region.
	 *
	 * @param aNeedle The element you are looking for.
	 * @param aHaystack The array that is being searched.
	 * @param aCompare A function which takes the needle and an element in the
	 *     array and returns -1, 0, or 1 depending on whether the needle is less
	 *     than, equal to, or greater than the element, respectively.
	 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
	 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
	 *     closest element that is smaller than or greater than the one we are
	 *     searching for, respectively, if the exact element cannot be found.
	 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
	 */
	exports.search = function search(aNeedle, aHaystack, aCompare, aBias) {
	  if (aHaystack.length === 0) {
	    return -1;
	  }
	
	  var index = recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack,
	                              aCompare, aBias || exports.GREATEST_LOWER_BOUND);
	  if (index < 0) {
	    return -1;
	  }
	
	  // We have found either the exact element, or the next-closest element than
	  // the one we are searching for. However, there may be more than one such
	  // element. Make sure we always return the smallest of these.
	  while (index - 1 >= 0) {
	    if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) {
	      break;
	    }
	    --index;
	  }
	
	  return index;
	};


/***/ }),
/* 1323 */
/***/ (function(module, exports) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	// It turns out that some (most?) JavaScript engines don't self-host
	// `Array.prototype.sort`. This makes sense because C++ will likely remain
	// faster than JS when doing raw CPU-intensive sorting. However, when using a
	// custom comparator function, calling back and forth between the VM's C++ and
	// JIT'd JS is rather slow *and* loses JIT type information, resulting in
	// worse generated code for the comparator function than would be optimal. In
	// fact, when sorting with a comparator, these costs outweigh the benefits of
	// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
	// a ~3500ms mean speed-up in `bench/bench.html`.
	
	/**
	 * Swap the elements indexed by `x` and `y` in the array `ary`.
	 *
	 * @param {Array} ary
	 *        The array.
	 * @param {Number} x
	 *        The index of the first item.
	 * @param {Number} y
	 *        The index of the second item.
	 */
	function swap(ary, x, y) {
	  var temp = ary[x];
	  ary[x] = ary[y];
	  ary[y] = temp;
	}
	
	/**
	 * Returns a random integer within the range `low .. high` inclusive.
	 *
	 * @param {Number} low
	 *        The lower bound on the range.
	 * @param {Number} high
	 *        The upper bound on the range.
	 */
	function randomIntInRange(low, high) {
	  return Math.round(low + (Math.random() * (high - low)));
	}
	
	/**
	 * The Quick Sort algorithm.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 * @param {Number} p
	 *        Start index of the array
	 * @param {Number} r
	 *        End index of the array
	 */
	function doQuickSort(ary, comparator, p, r) {
	  // If our lower bound is less than our upper bound, we (1) partition the
	  // array into two pieces and (2) recurse on each half. If it is not, this is
	  // the empty array and our base case.
	
	  if (p < r) {
	    // (1) Partitioning.
	    //
	    // The partitioning chooses a pivot between `p` and `r` and moves all
	    // elements that are less than or equal to the pivot to the before it, and
	    // all the elements that are greater than it after it. The effect is that
	    // once partition is done, the pivot is in the exact place it will be when
	    // the array is put in sorted order, and it will not need to be moved
	    // again. This runs in O(n) time.
	
	    // Always choose a random pivot so that an input array which is reverse
	    // sorted does not cause O(n^2) running time.
	    var pivotIndex = randomIntInRange(p, r);
	    var i = p - 1;
	
	    swap(ary, pivotIndex, r);
	    var pivot = ary[r];
	
	    // Immediately after `j` is incremented in this loop, the following hold
	    // true:
	    //
	    //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
	    //
	    //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
	    for (var j = p; j < r; j++) {
	      if (comparator(ary[j], pivot) <= 0) {
	        i += 1;
	        swap(ary, i, j);
	      }
	    }
	
	    swap(ary, i + 1, j);
	    var q = i + 1;
	
	    // (2) Recurse on each half.
	
	    doQuickSort(ary, comparator, p, q - 1);
	    doQuickSort(ary, comparator, q + 1, r);
	  }
	}
	
	/**
	 * Sort the given array in-place with the given comparator function.
	 *
	 * @param {Array} ary
	 *        An array to sort.
	 * @param {function} comparator
	 *        Function to use to compare two items.
	 */
	exports.quickSort = function (ary, comparator) {
	  doQuickSort(ary, comparator, 0, ary.length - 1);
	};


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

	/* -*- Mode: js; js-indent-level: 2; -*- */
	/*
	 * Copyright 2011 Mozilla Foundation and contributors
	 * Licensed under the New BSD license. See LICENSE or:
	 * http://opensource.org/licenses/BSD-3-Clause
	 */
	
	var SourceMapGenerator = __webpack_require__(1315).SourceMapGenerator;
	var util = __webpack_require__(1318);
	
	// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
	// operating systems these days (capturing the result).
	var REGEX_NEWLINE = /(\r?\n)/;
	
	// Newline character code for charCodeAt() comparisons
	var NEWLINE_CODE = 10;
	
	// Private symbol for identifying `SourceNode`s when multiple versions of
	// the source-map library are loaded. This MUST NOT CHANGE across
	// versions!
	var isSourceNode = "$$$isSourceNode$$$";
	
	/**
	 * SourceNodes provide a way to abstract over interpolating/concatenating
	 * snippets of generated JavaScript source code while maintaining the line and
	 * column information associated with the original source code.
	 *
	 * @param aLine The original line number.
	 * @param aColumn The original column number.
	 * @param aSource The original source's filename.
	 * @param aChunks Optional. An array of strings which are snippets of
	 *        generated JS, or other SourceNodes.
	 * @param aName The original identifier.
	 */
	function SourceNode(aLine, aColumn, aSource, aChunks, aName) {
	  this.children = [];
	  this.sourceContents = {};
	  this.line = aLine == null ? null : aLine;
	  this.column = aColumn == null ? null : aColumn;
	  this.source = aSource == null ? null : aSource;
	  this.name = aName == null ? null : aName;
	  this[isSourceNode] = true;
	  if (aChunks != null) this.add(aChunks);
	}
	
	/**
	 * Creates a SourceNode from generated code and a SourceMapConsumer.
	 *
	 * @param aGeneratedCode The generated code
	 * @param aSourceMapConsumer The SourceMap for the generated code
	 * @param aRelativePath Optional. The path that relative sources in the
	 *        SourceMapConsumer should be relative to.
	 */
	SourceNode.fromStringWithSourceMap =
	  function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
	    // The SourceNode we want to fill with the generated code
	    // and the SourceMap
	    var node = new SourceNode();
	
	    // All even indices of this array are one line of the generated code,
	    // while all odd indices are the newlines between two adjacent lines
	    // (since `REGEX_NEWLINE` captures its match).
	    // Processed fragments are accessed by calling `shiftNextLine`.
	    var remainingLines = aGeneratedCode.split(REGEX_NEWLINE);
	    var remainingLinesIndex = 0;
	    var shiftNextLine = function() {
	      var lineContents = getNextLine();
	      // The last line of a file might not have a newline.
	      var newLine = getNextLine() || "";
	      return lineContents + newLine;
	
	      function getNextLine() {
	        return remainingLinesIndex < remainingLines.length ?
	            remainingLines[remainingLinesIndex++] : undefined;
	      }
	    };
	
	    // We need to remember the position of "remainingLines"
	    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
	
	    // The generate SourceNodes we need a code range.
	    // To extract it current and last mapping is used.
	    // Here we store the last mapping.
	    var lastMapping = null;
	
	    aSourceMapConsumer.eachMapping(function (mapping) {
	      if (lastMapping !== null) {
	        // We add the code from "lastMapping" to "mapping":
	        // First check if there is a new line in between.
	        if (lastGeneratedLine < mapping.generatedLine) {
	          // Associate first line with "lastMapping"
	          addMappingWithCode(lastMapping, shiftNextLine());
	          lastGeneratedLine++;
	          lastGeneratedColumn = 0;
	          // The remaining code is added without mapping
	        } else {
	          // There is no new line in between.
	          // Associate the code between "lastGeneratedColumn" and
	          // "mapping.generatedColumn" with "lastMapping"
	          var nextLine = remainingLines[remainingLinesIndex];
	          var code = nextLine.substr(0, mapping.generatedColumn -
	                                        lastGeneratedColumn);
	          remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn -
	                                              lastGeneratedColumn);
	          lastGeneratedColumn = mapping.generatedColumn;
	          addMappingWithCode(lastMapping, code);
	          // No more remaining code, continue
	          lastMapping = mapping;
	          return;
	        }
	      }
	      // We add the generated code until the first mapping
	      // to the SourceNode without any mapping.
	      // Each line is added as separate string.
	      while (lastGeneratedLine < mapping.generatedLine) {
	        node.add(shiftNextLine());
	        lastGeneratedLine++;
	      }
	      if (lastGeneratedColumn < mapping.generatedColumn) {
	        var nextLine = remainingLines[remainingLinesIndex];
	        node.add(nextLine.substr(0, mapping.generatedColumn));
	        remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
	        lastGeneratedColumn = mapping.generatedColumn;
	      }
	      lastMapping = mapping;
	    }, this);
	    // We have processed all mappings.
	    if (remainingLinesIndex < remainingLines.length) {
	      if (lastMapping) {
	        // Associate the remaining code in the current line with "lastMapping"
	        addMappingWithCode(lastMapping, shiftNextLine());
	      }
	      // and add the remaining lines without any mapping
	      node.add(remainingLines.splice(remainingLinesIndex).join(""));
	    }
	
	    // Copy sourcesContent into SourceNode
	    aSourceMapConsumer.sources.forEach(function (sourceFile) {
	      var content = aSourceMapConsumer.sourceContentFor(sourceFile);
	      if (content != null) {
	        if (aRelativePath != null) {
	          sourceFile = util.join(aRelativePath, sourceFile);
	        }
	        node.setSourceContent(sourceFile, content);
	      }
	    });
	
	    return node;
	
	    function addMappingWithCode(mapping, code) {
	      if (mapping === null || mapping.source === undefined) {
	        node.add(code);
	      } else {
	        var source = aRelativePath
	          ? util.join(aRelativePath, mapping.source)
	          : mapping.source;
	        node.add(new SourceNode(mapping.originalLine,
	                                mapping.originalColumn,
	                                source,
	                                code,
	                                mapping.name));
	      }
	    }
	  };
	
	/**
	 * Add a chunk of generated JS to this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.add = function SourceNode_add(aChunk) {
	  if (Array.isArray(aChunk)) {
	    aChunk.forEach(function (chunk) {
	      this.add(chunk);
	    }, this);
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    if (aChunk) {
	      this.children.push(aChunk);
	    }
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Add a chunk of generated JS to the beginning of this source node.
	 *
	 * @param aChunk A string snippet of generated JS code, another instance of
	 *        SourceNode, or an array where each member is one of those things.
	 */
	SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
	  if (Array.isArray(aChunk)) {
	    for (var i = aChunk.length-1; i >= 0; i--) {
	      this.prepend(aChunk[i]);
	    }
	  }
	  else if (aChunk[isSourceNode] || typeof aChunk === "string") {
	    this.children.unshift(aChunk);
	  }
	  else {
	    throw new TypeError(
	      "Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk
	    );
	  }
	  return this;
	};
	
	/**
	 * Walk over the tree of JS snippets in this node and its children. The
	 * walking function is called once for each snippet of JS and is passed that
	 * snippet and the its original associated source's line/column location.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walk = function SourceNode_walk(aFn) {
	  var chunk;
	  for (var i = 0, len = this.children.length; i < len; i++) {
	    chunk = this.children[i];
	    if (chunk[isSourceNode]) {
	      chunk.walk(aFn);
	    }
	    else {
	      if (chunk !== '') {
	        aFn(chunk, { source: this.source,
	                     line: this.line,
	                     column: this.column,
	                     name: this.name });
	      }
	    }
	  }
	};
	
	/**
	 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
	 * each of `this.children`.
	 *
	 * @param aSep The separator.
	 */
	SourceNode.prototype.join = function SourceNode_join(aSep) {
	  var newChildren;
	  var i;
	  var len = this.children.length;
	  if (len > 0) {
	    newChildren = [];
	    for (i = 0; i < len-1; i++) {
	      newChildren.push(this.children[i]);
	      newChildren.push(aSep);
	    }
	    newChildren.push(this.children[i]);
	    this.children = newChildren;
	  }
	  return this;
	};
	
	/**
	 * Call String.prototype.replace on the very right-most source snippet. Useful
	 * for trimming whitespace from the end of a source node, etc.
	 *
	 * @param aPattern The pattern to replace.
	 * @param aReplacement The thing to replace the pattern with.
	 */
	SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
	  var lastChild = this.children[this.children.length - 1];
	  if (lastChild[isSourceNode]) {
	    lastChild.replaceRight(aPattern, aReplacement);
	  }
	  else if (typeof lastChild === 'string') {
	    this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
	  }
	  else {
	    this.children.push(''.replace(aPattern, aReplacement));
	  }
	  return this;
	};
	
	/**
	 * Set the source content for a source file. This will be added to the SourceMapGenerator
	 * in the sourcesContent field.
	 *
	 * @param aSourceFile The filename of the source file
	 * @param aSourceContent The content of the source file
	 */
	SourceNode.prototype.setSourceContent =
	  function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
	    this.sourceContents[util.toSetString(aSourceFile)] = aSourceContent;
	  };
	
	/**
	 * Walk over the tree of SourceNodes. The walking function is called for each
	 * source file content and is passed the filename and source content.
	 *
	 * @param aFn The traversal function.
	 */
	SourceNode.prototype.walkSourceContents =
	  function SourceNode_walkSourceContents(aFn) {
	    for (var i = 0, len = this.children.length; i < len; i++) {
	      if (this.children[i][isSourceNode]) {
	        this.children[i].walkSourceContents(aFn);
	      }
	    }
	
	    var sources = Object.keys(this.sourceContents);
	    for (var i = 0, len = sources.length; i < len; i++) {
	      aFn(util.fromSetString(sources[i]), this.sourceContents[sources[i]]);
	    }
	  };
	
	/**
	 * Return the string representation of this source node. Walks over the tree
	 * and concatenates all the various snippets together to one string.
	 */
	SourceNode.prototype.toString = function SourceNode_toString() {
	  var str = "";
	  this.walk(function (chunk) {
	    str += chunk;
	  });
	  return str;
	};
	
	/**
	 * Returns the string representation of this source node along with a source
	 * map.
	 */
	SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
	  var generated = {
	    code: "",
	    line: 1,
	    column: 0
	  };
	  var map = new SourceMapGenerator(aArgs);
	  var sourceMappingActive = false;
	  var lastOriginalSource = null;
	  var lastOriginalLine = null;
	  var lastOriginalColumn = null;
	  var lastOriginalName = null;
	  this.walk(function (chunk, original) {
	    generated.code += chunk;
	    if (original.source !== null
	        && original.line !== null
	        && original.column !== null) {
	      if(lastOriginalSource !== original.source
	         || lastOriginalLine !== original.line
	         || lastOriginalColumn !== original.column
	         || lastOriginalName !== original.name) {
	        map.addMapping({
	          source: original.source,
	          original: {
	            line: original.line,
	            column: original.column
	          },
	          generated: {
	            line: generated.line,
	            column: generated.column
	          },
	          name: original.name
	        });
	      }
	      lastOriginalSource = original.source;
	      lastOriginalLine = original.line;
	      lastOriginalColumn = original.column;
	      lastOriginalName = original.name;
	      sourceMappingActive = true;
	    } else if (sourceMappingActive) {
	      map.addMapping({
	        generated: {
	          line: generated.line,
	          column: generated.column
	        }
	      });
	      lastOriginalSource = null;
	      sourceMappingActive = false;
	    }
	    for (var idx = 0, length = chunk.length; idx < length; idx++) {
	      if (chunk.charCodeAt(idx) === NEWLINE_CODE) {
	        generated.line++;
	        generated.column = 0;
	        // Mappings end at eol
	        if (idx + 1 === length) {
	          lastOriginalSource = null;
	          sourceMappingActive = false;
	        } else if (sourceMappingActive) {
	          map.addMapping({
	            source: original.source,
	            original: {
	              line: original.line,
	              column: original.column
	            },
	            generated: {
	              line: generated.line,
	              column: generated.column
	            },
	            name: original.name
	          });
	        }
	      } else {
	        generated.column++;
	      }
	    }
	  });
	  this.walkSourceContents(function (sourceFile, sourceContent) {
	    map.setSourceContent(sourceFile, sourceContent);
	  });
	
	  return { code: generated.code, map: map };
	};
	
	exports.SourceNode = SourceNode;


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(871)))

/***/ }),
/* 1326 */
/***/ (function(module, exports) {



/***/ }),
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by alex_crack on 20.11.15.
	 */
	__webpack_require__(1352);
	module.exports = 'ui-notification';

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	/**
	 * angular-ui-notification - Angular.js service providing simple notifications using Bootstrap 3 styles with css transitions for animating
	 * @author Alex_Crack
	 * @version v0.3.6
	 * @link https://github.com/alexcrack/angular-ui-notification
	 * @license MIT
	 */
	angular.module('ui-notification',[]);
	
	angular.module('ui-notification').provider('Notification', function() {
	
	    this.options = {
	        delay: 5000,
	        startTop: 10,
	        startRight: 10,
	        verticalSpacing: 10,
	        horizontalSpacing: 10,
	        positionX: 'right',
	        positionY: 'top',
	        replaceMessage: false,
	        templateUrl: 'angular-ui-notification.html',
	        onClose: undefined,
	        closeOnClick: true,
	        maxCount: 0, // 0 - Infinite
	        container: 'body',
	        priority: 10
	    };
	
	    this.setOptions = function(options) {
	        if (!angular.isObject(options)) throw new Error("Options should be an object!");
	        this.options = angular.extend({}, this.options, options);
	    };
	
	    this.$get = ["$timeout", "$http", "$compile", "$templateCache", "$rootScope", "$injector", "$sce", "$q", "$window", function($timeout, $http, $compile, $templateCache, $rootScope, $injector, $sce, $q, $window) {
	        var options = this.options;
	
	        var startTop = options.startTop;
	        var startRight = options.startRight;
	        var verticalSpacing = options.verticalSpacing;
	        var horizontalSpacing = options.horizontalSpacing;
	        var delay = options.delay;
	
	        var messageElements = [];
	        var isResizeBound = false;
	
	        var notify = function(args, t){
	            var deferred = $q.defer();
	
	            if (typeof args !== 'object' || args === null) {
	                args = {message:args};
	            }
	
	            args.scope = args.scope ? args.scope : $rootScope;
	            args.template = args.templateUrl ? args.templateUrl : options.templateUrl;
	            args.delay = !angular.isUndefined(args.delay) ? args.delay : delay;
	            args.type = t || args.type || options.type ||  '';
	            args.positionY = args.positionY ? args.positionY : options.positionY;
	            args.positionX = args.positionX ? args.positionX : options.positionX;
	            args.replaceMessage = args.replaceMessage ? args.replaceMessage : options.replaceMessage;
	            args.onClose = args.onClose ? args.onClose : options.onClose;
	            args.closeOnClick = (args.closeOnClick !== null && args.closeOnClick !== undefined) ? args.closeOnClick : options.closeOnClick;
	            args.container = args.container ? args.container : options.container;
	            args.priority = args.priority ? args.priority : options.priority;
	            
	            var template=$templateCache.get(args.template);
	
	            if(template){
	                processNotificationTemplate(template);
	            }else{
	                // load it via $http only if it isn't default template and template isn't exist in template cache
	                // cache:true means cache it for later access.
	                $http.get(args.template,{cache: true})
	                  .then(function(response){
	                    processNotificationTemplate(response.data);
	                  })
	                  .catch(function(data){
	                    throw new Error('Template ('+args.template+') could not be loaded. ' + data);
	                  });                
	            }    
	            
	            
	             function processNotificationTemplate(template) {
	
	                var scope = args.scope.$new();
	                scope.message = $sce.trustAsHtml(args.message);
	                scope.title = $sce.trustAsHtml(args.title);
	                scope.t = args.type.substr(0,1);
	                scope.delay = args.delay;
	                scope.onClose = args.onClose;
	
	                var priorityCompareTop = function(a, b) {
	                    return a._priority - b._priority;
	                };
	
	                var priorityCompareBtm = function(a, b) {
	                    return b._priority - a._priority;
	                };
	
	                var reposite = function() {
	                    var j = 0;
	                    var k = 0;
	                    var lastTop = startTop;
	                    var lastRight = startRight;
	                    var lastPosition = [];
	
	                    if( args.positionY === 'top' ) {
	                        messageElements.sort( priorityCompareTop );
	                    } else if( args.positionY === 'bottom' ) {
	                        messageElements.sort( priorityCompareBtm );
	                    }
	
	                    for(var i = messageElements.length - 1; i >= 0; i --) {
	                        var element  = messageElements[i];
	                        if (args.replaceMessage && i < messageElements.length - 1) {
	                            element.addClass('killed');
	                            continue;
	                        }
	                        var elHeight = parseInt(element[0].offsetHeight);
	                        var elWidth  = parseInt(element[0].offsetWidth);
	                        var position = lastPosition[element._positionY+element._positionX];
	
	                        if ((top + elHeight) > window.innerHeight) {
	                            position = startTop;
	                            k ++;
	                            j = 0;
	                        }
	
	                        var top = (lastTop = position ? (j === 0 ? position : position + verticalSpacing) : startTop);
	                        var right = lastRight + (k * (horizontalSpacing + elWidth));
	
	                        element.css(element._positionY, top + 'px');
	                        if (element._positionX == 'center') {
	                            element.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');
	                        } else {
	                            element.css(element._positionX, right + 'px');
	                        }
	
	                        lastPosition[element._positionY+element._positionX] = top + elHeight;
	
	                        if (options.maxCount > 0 && messageElements.length > options.maxCount && i === 0) {
	                            element.scope().kill(true);
	                        }
	
	                        j ++;
	                    }
	                };
	
	                var templateElement = $compile(template)(scope);
	                templateElement._positionY = args.positionY;
	                templateElement._positionX = args.positionX;
	                templateElement._priority = args.priority;
	                templateElement.addClass(args.type);
	
	                var closeEvent = function(e) {
	                    e = e.originalEvent || e;
	                    if (e.type === 'click' || (e.propertyName === 'opacity' && e.elapsedTime >= 1)){
	                        if (scope.onClose) {
	                            scope.$apply(scope.onClose(templateElement));
	                        }
	
	                        templateElement.remove();
	                        messageElements.splice(messageElements.indexOf(templateElement), 1);
	                        scope.$destroy();
	                        reposite();
	                    }
	                };
	
	                if (args.closeOnClick) {
	                    templateElement.addClass('clickable');
	                    templateElement.bind('click', closeEvent);
	                }
	
	                templateElement.bind('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', closeEvent);
	
	                if (angular.isNumber(args.delay)) {
	                    $timeout(function() {
	                        templateElement.addClass('killed');
	                    }, args.delay);
	                }
	
	                setCssTransitions('none');
	
	                angular.element(document.querySelector(args.container)).append(templateElement);
	                var offset = -(parseInt(templateElement[0].offsetHeight) + 50);
	                templateElement.css(templateElement._positionY, offset + "px");
	                messageElements.push(templateElement);
	
	                if(args.positionX == 'center'){
	                    var elWidth = parseInt(templateElement[0].offsetWidth);
	                    templateElement.css('left', parseInt(window.innerWidth / 2 - elWidth / 2) + 'px');
	                }
	
	                $timeout(function(){
	                    setCssTransitions('');
	                });
	
	                function setCssTransitions(value){
	                    ['-webkit-transition', '-o-transition', 'transition'].forEach(function(prefix){
	                        templateElement.css(prefix, value);
	                    });
	                }
	
	                scope._templateElement = templateElement;
	
	                scope.kill = function(isHard) {
	                    if (isHard) {
	                        if (scope.onClose) {
	                            scope.$apply(scope.onClose(scope._templateElement));
	                        }
	
	                        messageElements.splice(messageElements.indexOf(scope._templateElement), 1);
	                        scope._templateElement.remove();
	                        scope.$destroy();
	                        $timeout(reposite);
	                    } else {
	                        scope._templateElement.addClass('killed');
	                    }
	                };
	
	                $timeout(reposite);
	
	                if (!isResizeBound) {
	                    angular.element($window).bind('resize', function(e) {
	                        $timeout(reposite);
	                    });
	                    isResizeBound = true;
	                }
	
	                deferred.resolve(scope);
	
	            }
	
	            return deferred.promise;
	        };
	
	        notify.primary = function(args) {
	            return this(args, 'primary');
	        };
	        notify.error = function(args) {
	            return this(args, 'error');
	        };
	        notify.success = function(args) {
	            return this(args, 'success');
	        };
	        notify.info = function(args) {
	            return this(args, 'info');
	        };
	        notify.warning = function(args) {
	            return this(args, 'warning');
	        };
	
	        notify.clearAll = function() {
	            angular.forEach(messageElements, function(element) {
	                element.addClass('killed');
	            });
	        };
	
	        return notify;
	    }];
	});
	
	angular.module("ui-notification").run(["$templateCache", function($templateCache) {$templateCache.put("angular-ui-notification.html","<div class=\"ui-notification\"><h3 ng-show=\"title\" ng-bind-html=\"title\"></h3><div class=\"message\" ng-bind-html=\"message\"></div></div>");}]);

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1354);
	module.exports = 'ngSanitize';


/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.7.8
	 * (c) 2010-2018 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window, angular) {'use strict';
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $sanitizeMinErr = angular.$$minErr('$sanitize');
	var bind;
	var extend;
	var forEach;
	var isArray;
	var isDefined;
	var lowercase;
	var noop;
	var nodeContains;
	var htmlParser;
	var htmlSanitizeWriter;
	
	/**
	 * @ngdoc module
	 * @name ngSanitize
	 * @description
	 *
	 * The `ngSanitize` module provides functionality to sanitize HTML.
	 *
	 * See {@link ngSanitize.$sanitize `$sanitize`} for usage.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sanitize
	 * @kind function
	 *
	 * @description
	 *   Sanitizes an html string by stripping all potentially dangerous tokens.
	 *
	 *   The input is sanitized by parsing the HTML into tokens. All safe tokens (from a whitelist) are
	 *   then serialized back to a properly escaped HTML string. This means that no unsafe input can make
	 *   it into the returned string.
	 *
	 *   The whitelist for URL sanitization of attribute values is configured using the functions
	 *   `aHrefSanitizationWhitelist` and `imgSrcSanitizationWhitelist` of {@link $compileProvider}.
	 *
	 *   The input may also contain SVG markup if this is enabled via {@link $sanitizeProvider}.
	 *
	 * @param {string} html HTML input.
	 * @returns {string} Sanitized HTML.
	 *
	 * @example
	   <example module="sanitizeExample" deps="angular-sanitize.js" name="sanitize-service">
	   <file name="index.html">
	     <script>
	         angular.module('sanitizeExample', ['ngSanitize'])
	           .controller('ExampleController', ['$scope', '$sce', function($scope, $sce) {
	             $scope.snippet =
	               '<p style="color:blue">an html\n' +
	               '<em onmouseover="this.textContent=\'PWN3D!\'">click here</em>\n' +
	               'snippet</p>';
	             $scope.deliberatelyTrustDangerousSnippet = function() {
	               return $sce.trustAsHtml($scope.snippet);
	             };
	           }]);
	     </script>
	     <div ng-controller="ExampleController">
	        Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <td>Directive</td>
	           <td>How</td>
	           <td>Source</td>
	           <td>Rendered</td>
	         </tr>
	         <tr id="bind-html-with-sanitize">
	           <td>ng-bind-html</td>
	           <td>Automatically uses $sanitize</td>
	           <td><pre>&lt;div ng-bind-html="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind-html="snippet"></div></td>
	         </tr>
	         <tr id="bind-html-with-trust">
	           <td>ng-bind-html</td>
	           <td>Bypass $sanitize by explicitly trusting the dangerous value</td>
	           <td>
	           <pre>&lt;div ng-bind-html="deliberatelyTrustDangerousSnippet()"&gt;
	&lt;/div&gt;</pre>
	           </td>
	           <td><div ng-bind-html="deliberatelyTrustDangerousSnippet()"></div></td>
	         </tr>
	         <tr id="bind-default">
	           <td>ng-bind</td>
	           <td>Automatically escapes</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br/>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	       </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should sanitize the html snippet by default', function() {
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('<p>an html\n<em>click here</em>\nsnippet</p>');
	     });
	
	     it('should inline raw snippet if bound to a trusted value', function() {
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).
	         toBe("<p style=\"color:blue\">an html\n" +
	              "<em onmouseover=\"this.textContent='PWN3D!'\">click here</em>\n" +
	              "snippet</p>");
	     });
	
	     it('should escape snippet without any filter', function() {
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).
	         toBe("&lt;p style=\"color:blue\"&gt;an html\n" +
	              "&lt;em onmouseover=\"this.textContent='PWN3D!'\"&gt;click here&lt;/em&gt;\n" +
	              "snippet&lt;/p&gt;");
	     });
	
	     it('should update', function() {
	       element(by.model('snippet')).clear();
	       element(by.model('snippet')).sendKeys('new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-html-with-sanitize div')).getAttribute('innerHTML')).
	         toBe('new <b>text</b>');
	       expect(element(by.css('#bind-html-with-trust div')).getAttribute('innerHTML')).toBe(
	         'new <b onclick="alert(1)">text</b>');
	       expect(element(by.css('#bind-default div')).getAttribute('innerHTML')).toBe(
	         "new &lt;b onclick=\"alert(1)\"&gt;text&lt;/b&gt;");
	     });
	   </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $sanitizeProvider
	 * @this
	 *
	 * @description
	 * Creates and configures {@link $sanitize} instance.
	 */
	function $SanitizeProvider() {
	  var hasBeenInstantiated = false;
	  var svgEnabled = false;
	
	  this.$get = ['$$sanitizeUri', function($$sanitizeUri) {
	    hasBeenInstantiated = true;
	    if (svgEnabled) {
	      extend(validElements, svgElements);
	    }
	    return function(html) {
	      var buf = [];
	      htmlParser(html, htmlSanitizeWriter(buf, function(uri, isImage) {
	        return !/^unsafe:/.test($$sanitizeUri(uri, isImage));
	      }));
	      return buf.join('');
	    };
	  }];
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#enableSvg
	   * @kind function
	   *
	   * @description
	   * Enables a subset of svg to be supported by the sanitizer.
	   *
	   * <div class="alert alert-warning">
	   *   <p>By enabling this setting without taking other precautions, you might expose your
	   *   application to click-hijacking attacks. In these attacks, sanitized svg elements could be positioned
	   *   outside of the containing element and be rendered over other elements on the page (e.g. a login
	   *   link). Such behavior can then result in phishing incidents.</p>
	   *
	   *   <p>To protect against these, explicitly setup `overflow: hidden` css rule for all potential svg
	   *   tags within the sanitized content:</p>
	   *
	   *   <br>
	   *
	   *   <pre><code>
	   *   .rootOfTheIncludedContent svg {
	   *     overflow: hidden !important;
	   *   }
	   *   </code></pre>
	   * </div>
	   *
	   * @param {boolean=} flag Enable or disable SVG support in the sanitizer.
	   * @returns {boolean|$sanitizeProvider} Returns the currently configured value if called
	   *    without an argument or self for chaining otherwise.
	   */
	  this.enableSvg = function(enableSvg) {
	    if (isDefined(enableSvg)) {
	      svgEnabled = enableSvg;
	      return this;
	    } else {
	      return svgEnabled;
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidElements
	   * @kind function
	   *
	   * @description
	   * Extends the built-in lists of valid HTML/SVG elements, i.e. elements that are considered safe
	   * and are not stripped off during sanitization. You can extend the following lists of elements:
	   *
	   * - `htmlElements`: A list of elements (tag names) to extend the current list of safe HTML
	   *   elements. HTML elements considered safe will not be removed during sanitization. All other
	   *   elements will be stripped off.
	   *
	   * - `htmlVoidElements`: This is similar to `htmlElements`, but marks the elements as
	   *   "void elements" (similar to HTML
	   *   [void elements](https://rawgit.com/w3c/html/html5.1-2/single-page.html#void-elements)). These
	   *   elements have no end tag and cannot have content.
	   *
	   * - `svgElements`: This is similar to `htmlElements`, but for SVG elements. This list is only
	   *   taken into account if SVG is {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for
	   *   `$sanitize`.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in lists of elements may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the elements you add.
	   * </div>
	   *
	   * @param {Array<String>|Object} elements - A list of valid HTML elements or an object with one or
	   *   more of the following properties:
	   *   - **htmlElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     HTML elements.
	   *   - **htmlVoidElements** - `{Array<String>}` - A list of elements to extend the current list of
	   *     void HTML elements; i.e. elements that do not have an end tag.
	   *   - **svgElements** - `{Array<String>}` - A list of elements to extend the current list of SVG
	   *     elements. The list of SVG elements is only taken into account if SVG is
	   *     {@link ngSanitize.$sanitizeProvider#enableSvg enabled} for `$sanitize`.
	   *
	   * Passing an array (`[...]`) is equivalent to passing `{htmlElements: [...]}`.
	   *
	   * @return {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidElements = function(elements) {
	    if (!hasBeenInstantiated) {
	      if (isArray(elements)) {
	        elements = {htmlElements: elements};
	      }
	
	      addElementsTo(svgElements, elements.svgElements);
	      addElementsTo(voidElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlVoidElements);
	      addElementsTo(validElements, elements.htmlElements);
	    }
	
	    return this;
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $sanitizeProvider#addValidAttrs
	   * @kind function
	   *
	   * @description
	   * Extends the built-in list of valid attributes, i.e. attributes that are considered safe and are
	   * not stripped off during sanitization.
	   *
	   * **Note**:
	   * The new attributes will not be treated as URI attributes, which means their values will not be
	   * sanitized as URIs using `$compileProvider`'s
	   * {@link ng.$compileProvider#aHrefSanitizationWhitelist aHrefSanitizationWhitelist} and
	   * {@link ng.$compileProvider#imgSrcSanitizationWhitelist imgSrcSanitizationWhitelist}.
	   *
	   * <div class="alert alert-info">
	   *   This method must be called during the {@link angular.Module#config config} phase. Once the
	   *   `$sanitize` service has been instantiated, this method has no effect.
	   * </div>
	   *
	   * <div class="alert alert-warning">
	   *   Keep in mind that extending the built-in list of attributes may expose your app to XSS or
	   *   other vulnerabilities. Be very mindful of the attributes you add.
	   * </div>
	   *
	   * @param {Array<String>} attrs - A list of valid attributes.
	   *
	   * @returns {$sanitizeProvider} Returns self for chaining.
	   */
	  this.addValidAttrs = function(attrs) {
	    if (!hasBeenInstantiated) {
	      extend(validAttrs, arrayToMap(attrs, true));
	    }
	    return this;
	  };
	
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	  // Private stuff
	  //////////////////////////////////////////////////////////////////////////////////////////////////
	
	  bind = angular.bind;
	  extend = angular.extend;
	  forEach = angular.forEach;
	  isArray = angular.isArray;
	  isDefined = angular.isDefined;
	  lowercase = angular.$$lowercase;
	  noop = angular.noop;
	
	  htmlParser = htmlParserImpl;
	  htmlSanitizeWriter = htmlSanitizeWriterImpl;
	
	  nodeContains = window.Node.prototype.contains || /** @this */ function(arg) {
	    // eslint-disable-next-line no-bitwise
	    return !!(this.compareDocumentPosition(arg) & 16);
	  };
	
	  // Regular Expressions for parsing tags and attributes
	  var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	    // Match everything outside of normal chars and " (quote character)
	    NON_ALPHANUMERIC_REGEXP = /([^#-~ |!])/g;
	
	
	  // Good source of info about elements and attributes
	  // http://dev.w3.org/html5/spec/Overview.html#semantics
	  // http://simon.html5.org/html-elements
	
	  // Safe Void Elements - HTML5
	  // http://dev.w3.org/html5/spec/Overview.html#void-elements
	  var voidElements = stringToMap('area,br,col,hr,img,wbr');
	
	  // Elements that you can, intentionally, leave open (and which close themselves)
	  // http://dev.w3.org/html5/spec/Overview.html#optional-tags
	  var optionalEndTagBlockElements = stringToMap('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr'),
	      optionalEndTagInlineElements = stringToMap('rp,rt'),
	      optionalEndTagElements = extend({},
	                                              optionalEndTagInlineElements,
	                                              optionalEndTagBlockElements);
	
	  // Safe Block Elements - HTML5
	  var blockElements = extend({}, optionalEndTagBlockElements, stringToMap('address,article,' +
	          'aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
	          'h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul'));
	
	  // Inline Elements - HTML5
	  var inlineElements = extend({}, optionalEndTagInlineElements, stringToMap('a,abbr,acronym,b,' +
	          'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,' +
	          'samp,small,span,strike,strong,sub,sup,time,tt,u,var'));
	
	  // SVG Elements
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Elements
	  // Note: the elements animate,animateColor,animateMotion,animateTransform,set are intentionally omitted.
	  // They can potentially allow for arbitrary javascript to be executed. See #11290
	  var svgElements = stringToMap('circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,' +
	          'hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,' +
	          'radialGradient,rect,stop,svg,switch,text,title,tspan');
	
	  // Blocked Elements (will be stripped)
	  var blockedElements = stringToMap('script,style');
	
	  var validElements = extend({},
	                                     voidElements,
	                                     blockElements,
	                                     inlineElements,
	                                     optionalEndTagElements);
	
	  //Attributes that have href and hence need to be sanitized
	  var uriAttrs = stringToMap('background,cite,href,longdesc,src,xlink:href,xml:base');
	
	  var htmlAttrs = stringToMap('abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,' +
	      'color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,' +
	      'ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,' +
	      'scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,' +
	      'valign,value,vspace,width');
	
	  // SVG attributes (without "id" and "name" attributes)
	  // https://wiki.whatwg.org/wiki/Sanitization_rules#svg_Attributes
	  var svgAttrs = stringToMap('accent-height,accumulate,additive,alphabetic,arabic-form,ascent,' +
	      'baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,' +
	      'cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,' +
	      'font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,' +
	      'height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,' +
	      'marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,' +
	      'max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,' +
	      'path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,' +
	      'requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,' +
	      'stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,' +
	      'stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,' +
	      'stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,' +
	      'underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,' +
	      'width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,' +
	      'xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan', true);
	
	  var validAttrs = extend({},
	                                  uriAttrs,
	                                  svgAttrs,
	                                  htmlAttrs);
	
	  function stringToMap(str, lowercaseKeys) {
	    return arrayToMap(str.split(','), lowercaseKeys);
	  }
	
	  function arrayToMap(items, lowercaseKeys) {
	    var obj = {}, i;
	    for (i = 0; i < items.length; i++) {
	      obj[lowercaseKeys ? lowercase(items[i]) : items[i]] = true;
	    }
	    return obj;
	  }
	
	  function addElementsTo(elementsMap, newElements) {
	    if (newElements && newElements.length) {
	      extend(elementsMap, arrayToMap(newElements));
	    }
	  }
	
	  /**
	   * Create an inert document that contains the dirty HTML that needs sanitizing
	   * Depending upon browser support we use one of three strategies for doing this.
	   * Support: Safari 10.x -> XHR strategy
	   * Support: Firefox -> DomParser strategy
	   */
	  var getInertBodyElement /* function(html: string): HTMLBodyElement */ = (function(window, document) {
	    var inertDocument;
	    if (document && document.implementation) {
	      inertDocument = document.implementation.createHTMLDocument('inert');
	    } else {
	      throw $sanitizeMinErr('noinert', 'Can\'t create an inert html document');
	    }
	    var inertBodyElement = (inertDocument.documentElement || inertDocument.getDocumentElement()).querySelector('body');
	
	    // Check for the Safari 10.1 bug - which allows JS to run inside the SVG G element
	    inertBodyElement.innerHTML = '<svg><g onload="this.parentNode.remove()"></g></svg>';
	    if (!inertBodyElement.querySelector('svg')) {
	      return getInertBodyElement_XHR;
	    } else {
	      // Check for the Firefox bug - which prevents the inner img JS from being sanitized
	      inertBodyElement.innerHTML = '<svg><p><style><img src="</style><img src=x onerror=alert(1)//">';
	      if (inertBodyElement.querySelector('svg img')) {
	        return getInertBodyElement_DOMParser;
	      } else {
	        return getInertBodyElement_InertDocument;
	      }
	    }
	
	    function getInertBodyElement_XHR(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        html = encodeURI(html);
	      } catch (e) {
	        return undefined;
	      }
	      var xhr = new window.XMLHttpRequest();
	      xhr.responseType = 'document';
	      xhr.open('GET', 'data:text/html;charset=utf-8,' + html, false);
	      xhr.send(null);
	      var body = xhr.response.body;
	      body.firstChild.remove();
	      return body;
	    }
	
	    function getInertBodyElement_DOMParser(html) {
	      // We add this dummy element to ensure that the rest of the content is parsed as expected
	      // e.g. leading whitespace is maintained and tags like `<meta>` do not get hoisted to the `<head>` tag.
	      html = '<remove></remove>' + html;
	      try {
	        var body = new window.DOMParser().parseFromString(html, 'text/html').body;
	        body.firstChild.remove();
	        return body;
	      } catch (e) {
	        return undefined;
	      }
	    }
	
	    function getInertBodyElement_InertDocument(html) {
	      inertBodyElement.innerHTML = html;
	
	      // Support: IE 9-11 only
	      // strip custom-namespaced attributes on IE<=11
	      if (document.documentMode) {
	        stripCustomNsAttrs(inertBodyElement);
	      }
	
	      return inertBodyElement;
	    }
	  })(window, window.document);
	
	  /**
	   * @example
	   * htmlParser(htmlString, {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * });
	   *
	   * @param {string} html string
	   * @param {object} handler
	   */
	  function htmlParserImpl(html, handler) {
	    if (html === null || html === undefined) {
	      html = '';
	    } else if (typeof html !== 'string') {
	      html = '' + html;
	    }
	
	    var inertBodyElement = getInertBodyElement(html);
	    if (!inertBodyElement) return '';
	
	    //mXSS protection
	    var mXSSAttempts = 5;
	    do {
	      if (mXSSAttempts === 0) {
	        throw $sanitizeMinErr('uinput', 'Failed to sanitize html because the input is unstable');
	      }
	      mXSSAttempts--;
	
	      // trigger mXSS if it is going to happen by reading and writing the innerHTML
	      html = inertBodyElement.innerHTML;
	      inertBodyElement = getInertBodyElement(html);
	    } while (html !== inertBodyElement.innerHTML);
	
	    var node = inertBodyElement.firstChild;
	    while (node) {
	      switch (node.nodeType) {
	        case 1: // ELEMENT_NODE
	          handler.start(node.nodeName.toLowerCase(), attrToMap(node.attributes));
	          break;
	        case 3: // TEXT NODE
	          handler.chars(node.textContent);
	          break;
	      }
	
	      var nextNode;
	      if (!(nextNode = node.firstChild)) {
	        if (node.nodeType === 1) {
	          handler.end(node.nodeName.toLowerCase());
	        }
	        nextNode = getNonDescendant('nextSibling', node);
	        if (!nextNode) {
	          while (nextNode == null) {
	            node = getNonDescendant('parentNode', node);
	            if (node === inertBodyElement) break;
	            nextNode = getNonDescendant('nextSibling', node);
	            if (node.nodeType === 1) {
	              handler.end(node.nodeName.toLowerCase());
	            }
	          }
	        }
	      }
	      node = nextNode;
	    }
	
	    while ((node = inertBodyElement.firstChild)) {
	      inertBodyElement.removeChild(node);
	    }
	  }
	
	  function attrToMap(attrs) {
	    var map = {};
	    for (var i = 0, ii = attrs.length; i < ii; i++) {
	      var attr = attrs[i];
	      map[attr.name] = attr.value;
	    }
	    return map;
	  }
	
	
	  /**
	   * Escapes all potentially dangerous characters, so that the
	   * resulting string can be safely inserted into attribute or
	   * element text.
	   * @param value
	   * @returns {string} escaped text
	   */
	  function encodeEntities(value) {
	    return value.
	      replace(/&/g, '&amp;').
	      replace(SURROGATE_PAIR_REGEXP, function(value) {
	        var hi = value.charCodeAt(0);
	        var low = value.charCodeAt(1);
	        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
	      }).
	      replace(NON_ALPHANUMERIC_REGEXP, function(value) {
	        return '&#' + value.charCodeAt(0) + ';';
	      }).
	      replace(/</g, '&lt;').
	      replace(/>/g, '&gt;');
	  }
	
	  /**
	   * create an HTML/XML writer which writes to buffer
	   * @param {Array} buf use buf.join('') to get out sanitized html string
	   * @returns {object} in the form of {
	   *     start: function(tag, attrs) {},
	   *     end: function(tag) {},
	   *     chars: function(text) {},
	   *     comment: function(text) {}
	   * }
	   */
	  function htmlSanitizeWriterImpl(buf, uriValidator) {
	    var ignoreCurrentElement = false;
	    var out = bind(buf, buf.push);
	    return {
	      start: function(tag, attrs) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && blockedElements[tag]) {
	          ignoreCurrentElement = tag;
	        }
	        if (!ignoreCurrentElement && validElements[tag] === true) {
	          out('<');
	          out(tag);
	          forEach(attrs, function(value, key) {
	            var lkey = lowercase(key);
	            var isImage = (tag === 'img' && lkey === 'src') || (lkey === 'background');
	            if (validAttrs[lkey] === true &&
	              (uriAttrs[lkey] !== true || uriValidator(value, isImage))) {
	              out(' ');
	              out(key);
	              out('="');
	              out(encodeEntities(value));
	              out('"');
	            }
	          });
	          out('>');
	        }
	      },
	      end: function(tag) {
	        tag = lowercase(tag);
	        if (!ignoreCurrentElement && validElements[tag] === true && voidElements[tag] !== true) {
	          out('</');
	          out(tag);
	          out('>');
	        }
	        // eslint-disable-next-line eqeqeq
	        if (tag == ignoreCurrentElement) {
	          ignoreCurrentElement = false;
	        }
	      },
	      chars: function(chars) {
	        if (!ignoreCurrentElement) {
	          out(encodeEntities(chars));
	        }
	      }
	    };
	  }
	
	
	  /**
	   * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1' attribute to declare
	   * ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo'). This is undesirable since we don't want
	   * to allow any of these custom attributes. This method strips them all.
	   *
	   * @param node Root element to process
	   */
	  function stripCustomNsAttrs(node) {
	    while (node) {
	      if (node.nodeType === window.Node.ELEMENT_NODE) {
	        var attrs = node.attributes;
	        for (var i = 0, l = attrs.length; i < l; i++) {
	          var attrNode = attrs[i];
	          var attrName = attrNode.name.toLowerCase();
	          if (attrName === 'xmlns:ns1' || attrName.lastIndexOf('ns1:', 0) === 0) {
	            node.removeAttributeNode(attrNode);
	            i--;
	            l--;
	          }
	        }
	      }
	
	      var nextNode = node.firstChild;
	      if (nextNode) {
	        stripCustomNsAttrs(nextNode);
	      }
	
	      node = getNonDescendant('nextSibling', node);
	    }
	  }
	
	  function getNonDescendant(propName, node) {
	    // An element is clobbered if its `propName` property points to one of its descendants
	    var nextNode = node[propName];
	    if (nextNode && nodeContains.call(node, nextNode)) {
	      throw $sanitizeMinErr('elclob', 'Failed to sanitize html because the element is clobbered: {0}', node.outerHTML || node.outerText);
	    }
	    return nextNode;
	  }
	}
	
	function sanitizeText(chars) {
	  var buf = [];
	  var writer = htmlSanitizeWriter(buf, noop);
	  writer.chars(chars);
	  return buf.join('');
	}
	
	
	// define ngSanitize module and register $sanitize service
	angular.module('ngSanitize', [])
	  .provider('$sanitize', $SanitizeProvider)
	  .info({ angularVersion: '1.7.8' });
	
	/**
	 * @ngdoc filter
	 * @name linky
	 * @kind function
	 *
	 * @description
	 * Finds links in text input and turns them into html links. Supports `http/https/ftp/sftp/mailto` and
	 * plain email address links.
	 *
	 * Requires the {@link ngSanitize `ngSanitize`} module to be installed.
	 *
	 * @param {string} text Input text.
	 * @param {string} [target] Window (`_blank|_self|_parent|_top`) or named frame to open links in.
	 * @param {object|function(url)} [attributes] Add custom attributes to the link element.
	 *
	 *    Can be one of:
	 *
	 *    - `object`: A map of attributes
	 *    - `function`: Takes the url as a parameter and returns a map of attributes
	 *
	 *    If the map of attributes contains a value for `target`, it overrides the value of
	 *    the target parameter.
	 *
	 *
	 * @returns {string} Html-linkified and {@link $sanitize sanitized} text.
	 *
	 * @usage
	   <span ng-bind-html="linky_expression | linky"></span>
	 *
	 * @example
	   <example module="linkyExample" deps="angular-sanitize.js" name="linky-filter">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	       Snippet: <textarea ng-model="snippet" cols="60" rows="3"></textarea>
	       <table>
	         <tr>
	           <th>Filter</th>
	           <th>Source</th>
	           <th>Rendered</th>
	         </tr>
	         <tr id="linky-filter">
	           <td>linky filter</td>
	           <td>
	             <pre>&lt;div ng-bind-html="snippet | linky"&gt;<br>&lt;/div&gt;</pre>
	           </td>
	           <td>
	             <div ng-bind-html="snippet | linky"></div>
	           </td>
	         </tr>
	         <tr id="linky-target">
	          <td>linky target</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_blank'"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_blank'"></div>
	          </td>
	         </tr>
	         <tr id="linky-custom-attributes">
	          <td>linky custom attributes</td>
	          <td>
	            <pre>&lt;div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"&gt;<br>&lt;/div&gt;</pre>
	          </td>
	          <td>
	            <div ng-bind-html="snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}"></div>
	          </td>
	         </tr>
	         <tr id="escaped-html">
	           <td>no filter</td>
	           <td><pre>&lt;div ng-bind="snippet"&gt;<br>&lt;/div&gt;</pre></td>
	           <td><div ng-bind="snippet"></div></td>
	         </tr>
	       </table>
	     </file>
	     <file name="script.js">
	       angular.module('linkyExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.snippet =
	             'Pretty text with some links:\n' +
	             'http://angularjs.org/,\n' +
	             'mailto:us@somewhere.org,\n' +
	             'another@somewhere.org,\n' +
	             'and one more: ftp://127.0.0.1/.';
	           $scope.snippetWithSingleURL = 'http://angularjs.org/';
	         }]);
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should linkify the snippet with urls', function() {
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(4);
	       });
	
	       it('should not linkify snippet without the linky filter', function() {
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText()).
	             toBe('Pretty text with some links: http://angularjs.org/, mailto:us@somewhere.org, ' +
	                  'another@somewhere.org, and one more: ftp://127.0.0.1/.');
	         expect(element.all(by.css('#escaped-html a')).count()).toEqual(0);
	       });
	
	       it('should update', function() {
	         element(by.model('snippet')).clear();
	         element(by.model('snippet')).sendKeys('new http://link.');
	         expect(element(by.id('linky-filter')).element(by.binding('snippet | linky')).getText()).
	             toBe('new http://link.');
	         expect(element.all(by.css('#linky-filter a')).count()).toEqual(1);
	         expect(element(by.id('escaped-html')).element(by.binding('snippet')).getText())
	             .toBe('new http://link.');
	       });
	
	       it('should work with the target property', function() {
	        expect(element(by.id('linky-target')).
	            element(by.binding("snippetWithSingleURL | linky:'_blank'")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-target a')).getAttribute('target')).toEqual('_blank');
	       });
	
	       it('should optionally add custom attributes', function() {
	        expect(element(by.id('linky-custom-attributes')).
	            element(by.binding("snippetWithSingleURL | linky:'_self':{rel: 'nofollow'}")).getText()).
	            toBe('http://angularjs.org/');
	        expect(element(by.css('#linky-custom-attributes a')).getAttribute('rel')).toEqual('nofollow');
	       });
	     </file>
	   </example>
	 */
	angular.module('ngSanitize').filter('linky', ['$sanitize', function($sanitize) {
	  var LINKY_URL_REGEXP =
	        /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i,
	      MAILTO_REGEXP = /^mailto:/i;
	
	  var linkyMinErr = angular.$$minErr('linky');
	  var isDefined = angular.isDefined;
	  var isFunction = angular.isFunction;
	  var isObject = angular.isObject;
	  var isString = angular.isString;
	
	  return function(text, target, attributes) {
	    if (text == null || text === '') return text;
	    if (!isString(text)) throw linkyMinErr('notstring', 'Expected string but received: {0}', text);
	
	    var attributesFn =
	      isFunction(attributes) ? attributes :
	      isObject(attributes) ? function getAttributesObject() {return attributes;} :
	      function getEmptyAttributesObject() {return {};};
	
	    var match;
	    var raw = text;
	    var html = [];
	    var url;
	    var i;
	    while ((match = raw.match(LINKY_URL_REGEXP))) {
	      // We can not end in these as they are sometimes found at the end of the sentence
	      url = match[0];
	      // if we did not match ftp/http/www/mailto then assume mailto
	      if (!match[2] && !match[4]) {
	        url = (match[3] ? 'http://' : 'mailto:') + url;
	      }
	      i = match.index;
	      addText(raw.substr(0, i));
	      addLink(url, match[0].replace(MAILTO_REGEXP, ''));
	      raw = raw.substring(i + match[0].length);
	    }
	    addText(raw);
	    return $sanitize(html.join(''));
	
	    function addText(text) {
	      if (!text) {
	        return;
	      }
	      html.push(sanitizeText(text));
	    }
	
	    function addLink(url, text) {
	      var key, linkAttributes = attributesFn(url);
	      html.push('<a ');
	
	      for (key in linkAttributes) {
	        html.push(key + '="' + linkAttributes[key] + '" ');
	      }
	
	      if (isDefined(target) && !('target' in linkAttributes)) {
	        html.push('target="',
	                  target,
	                  '" ');
	      }
	      html.push('href="',
	                url.replace(/"/g, '&quot;'),
	                '">');
	      addText(text);
	      html.push('</a>');
	    }
	  };
	}]);
	
	
	})(window, window.angular);


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	/*! ng-csv 10-10-2015 */
	!function(a){angular.module("ngCsv.config",[]).value("ngCsv.config",{debug:!0}).config(["$compileProvider",function(a){angular.isDefined(a.urlSanitizationWhitelist)?a.urlSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/):a.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|file|data):/)}]),angular.module("ngCsv.directives",["ngCsv.services"]),angular.module("ngCsv.services",[]),angular.module("ngCsv",["ngCsv.config","ngCsv.services","ngCsv.directives","ngSanitize"]),"undefined"!=typeof module&&"undefined"!=typeof exports&&module.exports===exports&&(module.exports="ngCsv"),angular.module("ngCsv.services").service("CSV",["$q",function(a){var b="\r\n",c="﻿",d={"\\t":"	","\\b":"\b","\\v":"","\\f":"\f","\\r":"\r"};this.stringifyField=function(a,b){return"locale"===b.decimalSep&&this.isFloat(a)?a.toLocaleString():"."!==b.decimalSep&&this.isFloat(a)?a.toString().replace(".",b.decimalSep):"string"==typeof a?(a=a.replace(/"/g,'""'),(b.quoteStrings||a.indexOf(",")>-1||a.indexOf("\n")>-1||a.indexOf("\r")>-1)&&(a=b.txtDelim+a+b.txtDelim),a):"boolean"==typeof a?a?"TRUE":"FALSE":a},this.isFloat=function(a){return+a===a&&(!isFinite(a)||Boolean(a%1))},this.stringify=function(d,e){var f=a.defer(),g=this,h="",i="",j=a.when(d).then(function(a){if(angular.isDefined(e.header)&&e.header){var d,j;d=[],angular.forEach(e.header,function(a){this.push(g.stringifyField(a,e))},d),j=d.join(e.fieldSep?e.fieldSep:","),i+=j+b}var k=[];if(angular.isArray(a)?k=a:angular.isFunction(a)&&(k=a()),angular.isDefined(e.label)&&e.label&&"boolean"==typeof e.label){var l,m;l=[],angular.forEach(k[0],function(a,b){this.push(g.stringifyField(b,e))},l),m=l.join(e.fieldSep?e.fieldSep:","),i+=m+b}angular.forEach(k,function(a,c){var d,f,h=angular.copy(k[c]);f=[];var j=e.columnOrder?e.columnOrder:h;angular.forEach(j,function(a){var b=e.columnOrder?h[a]:a;this.push(g.stringifyField(b,e))},f),d=f.join(e.fieldSep?e.fieldSep:","),i+=c<k.length?d+b:d}),e.addByteOrderMarker&&(h+=c),h+=i,f.resolve(h)});return"function"==typeof j["catch"]&&j["catch"](function(a){f.reject(a)}),f.promise},this.isSpecialChar=function(a){return void 0!==d[a]},this.getSpecialChar=function(a){return d[a]}}]),angular.module("ngCsv.directives").directive("ngCsv",["$parse","$q","CSV","$document","$timeout",function(b,c,d,e,f){return{restrict:"AC",scope:{data:"&ngCsv",filename:"@filename",header:"&csvHeader",columnOrder:"&csvColumnOrder",txtDelim:"@textDelimiter",decimalSep:"@decimalSeparator",quoteStrings:"@quoteStrings",fieldSep:"@fieldSeparator",lazyLoad:"@lazyLoad",addByteOrderMarker:"@addBom",ngClick:"&",charset:"@charset",label:"&csvLabel"},controller:["$scope","$element","$attrs","$transclude",function(a,b,e){function f(){var b={txtDelim:a.txtDelim?a.txtDelim:'"',decimalSep:a.decimalSep?a.decimalSep:".",quoteStrings:a.quoteStrings,addByteOrderMarker:a.addByteOrderMarker};return angular.isDefined(e.csvHeader)&&(b.header=a.$eval(a.header)),angular.isDefined(e.csvColumnOrder)&&(b.columnOrder=a.$eval(a.columnOrder)),angular.isDefined(e.csvLabel)&&(b.label=a.$eval(a.label)),b.fieldSep=a.fieldSep?a.fieldSep:",",b.fieldSep=d.isSpecialChar(b.fieldSep)?d.getSpecialChar(b.fieldSep):b.fieldSep,b}a.csv="",angular.isDefined(a.lazyLoad)&&"true"==a.lazyLoad||angular.isArray(a.data)&&a.$watch("data",function(){a.buildCSV()},!0),a.getFilename=function(){return a.filename||"download.csv"},a.buildCSV=function(){var g=c.defer();return b.addClass(e.ngCsvLoadingClass||"ng-csv-loading"),d.stringify(a.data(),f()).then(function(c){a.csv=c,b.removeClass(e.ngCsvLoadingClass||"ng-csv-loading"),g.resolve(c)}),a.$apply(),g.promise}}],link:function(b,c){function d(){var c=b.charset||"utf-8",d=new Blob([b.csv],{type:"text/csv;charset="+c+";"});if(a.navigator.msSaveOrOpenBlob)navigator.msSaveBlob(d,b.getFilename());else{var g=angular.element('<div data-tap-disabled="true"><a></a></div>'),h=angular.element(g.children()[0]);h.attr("href",a.URL.createObjectURL(d)),h.attr("download",b.getFilename()),h.attr("target","_blank"),e.find("body").append(g),f(function(){h[0].click(),h.remove()},null)}}c.bind("click",function(){b.buildCSV().then(function(){d()}),b.$apply()})}}}])}(window,document);

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	angular.module('validation', ['validation.provider', 'validation.directive']);
	angular.module('validation.provider', []);
	angular.module('validation.directive', ['validation.provider']);
	
	(function() {
	  angular
	    .module('validation.provider')
	    .provider('$validation', Provider);
	
	  function Provider() {
	    var $injector;
	    var $scope;
	    var $http;
	    var $q;
	    var $timeout;
	    var _this = this;
	
	    /**
	     * Setup the provider
	     * @param injector
	     */
	    var setup = function(injector) {
	      $injector = injector;
	      $scope = $injector.get('$rootScope');
	      $http = $injector.get('$http');
	      $q = $injector.get('$q');
	      $timeout = $injector.get('$timeout');
	    };
	
	    /**
	     * Define validation type RegExp
	     * @type {{}}
	     */
	    var expression = {};
	
	    /**
	     * default valid method
	     * @type {{}}
	     */
	    var validMethod = null;
	
	    /**
	     * default error, success message
	     * @type {{}}
	     */
	    var defaultMsg = {};
	
	    /**
	     * Allow user to set a custom Expression, do remember set the default message using setDefaultMsg
	     * @param obj
	     * @returns {*}
	     */
	    this.setExpression = function(obj) {
	      angular.extend(expression, obj);
	      return _this;
	    };
	
	    /**
	     * Get the Expression
	     * @param exprs
	     * @returns {*}
	     */
	    this.getExpression = function(exprs) {
	      return expression[exprs];
	    };
	
	    /**
	     * Allow user to set default message
	     * @param obj
	     * @returns {*}
	     */
	    this.setDefaultMsg = function(obj) {
	      angular.extend(defaultMsg, obj);
	      return _this;
	    };
	
	    /**
	     * Get the Default Message
	     * @param msg
	     * @returns {*}
	     */
	    this.getDefaultMsg = function(msg) {
	      return defaultMsg[msg];
	    };
	
	    /**
	     * allow user to set the global valid method
	     * @param v
	     * @returns {*}
	     */
	    this.setValidMethod = function(v) {
	      validMethod = v;
	    };
	
	    /**
	     * Get the valid method     
	     * @returns {*}
	     */
	    this.getValidMethod = function() {
	      return validMethod;
	    };
	
	    /**
	     * Override the errorHTML function
	     * @param func
	     * @returns {*}
	     */
	    this.setErrorHTML = function(func) {
	      if (func.constructor !== Function) {
	        return;
	      }
	      _this.getErrorHTML = func;
	      return _this;
	    };
	
	    /**
	     * Invalid message HTML, here's the default
	     * @param message
	     * @returns {string}
	     */
	    this.getErrorHTML = function(message) {
	      return '<p class="validation-invalid">' + message + '</p>';
	    };
	
	    /**
	     * Override the successHTML function
	     * @param func
	     * @returns {*}
	     */
	    this.setSuccessHTML = function(func) {
	      if (func.constructor !== Function) {
	        return;
	      }
	      _this.getSuccessHTML = func;
	      return _this;
	    };
	
	    /**
	     * Valid message HTML, here's the default
	     * @param message
	     * @returns {string}
	     */
	    this.getSuccessHTML = function(message) {
	      return '<p class="validation-valid">' + message + '</p>';
	    };
	
	    /**
	     * Whether show the validation success message
	     * You can easily change this to false in your config
	     * example: $validationProvider.showSuccessMessage = false;
	     * @type {boolean}
	     */
	    this.showSuccessMessage = true;
	
	    /**
	     * Whether show the validation error message
	     * You can easily change this to false in your config
	     * example: $validationProvider.showErrorMessage = false;
	     * @type {boolean}
	     */
	    this.showErrorMessage = true;
	
	    /**
	     * Check form valid, return true
	     * checkValid(Form): Check the specific form(Form) valid from angular `$valid`
	     * @param form
	     * @returns {boolean}
	     */
	    this.checkValid = function(form) {
	      return !!(form && form.$valid);
	    };
	
	    /**
	     * Validate the form when click submit, when `validMethod = submit`
	     * @param form
	     * @returns {promise|*}
	     */
	    this.validate = function(form) {
	      var deferred = $q.defer();
	      var idx = 0;
	
	      if (form === undefined) {
	        console.error('This is not a regular Form name scope');
	        deferred.reject('This is not a regular Form name scope');
	        return deferred.promise;
	      }
	
	      if (form.validationId) { // single
	        $scope.$broadcast(form.$name + 'submit-' + form.validationId, idx++);
	      } else if (form.constructor === Array) { // multiple
	        for (var k in form) {
	          $scope.$broadcast(form[k].$name + 'submit-' + form[k].validationId, idx++);
	        }
	      } else {
	        for (var i in form) { // whole scope
	          if (i[0] !== '$' && form[i].hasOwnProperty('$dirty')) {
	            $scope.$broadcast(i + 'submit-' + form[i].validationId, idx++);
	          }
	        }
	      }
	
	      deferred.promise.success = function(fn) {
	        deferred.promise.then(function(value) {
	          fn(value);
	        });
	        return deferred.promise;
	      };
	
	      deferred.promise.error = function(fn) {
	        deferred.promise.then(null, function(value) {
	          fn(value);
	        });
	        return deferred.promise;
	      };
	
	      $timeout(function() {
	        if (_this.checkValid(form)) {
	          deferred.resolve('success');
	        } else {
	          deferred.reject('error');
	        }
	      });
	
	      return deferred.promise;
	    };
	
	    /**
	     * Do this function if validation valid
	     * @param element
	     */
	    this.validCallback = null;
	
	    /**
	     * Do this function if validation invalid
	     * @param element
	     */
	    this.invalidCallback = null;
	
	    /**
	     * Do this function when reset is performed
	     * @param element
	     */
	    this.resetCallback = null;
	
	    /**
	     * reset the specific form
	     * @param form
	     */
	    this.reset = function(form) {
	      if (form === undefined) {
	        console.error('This is not a regular Form name scope');
	        return;
	      }
	
	      if (form.validationId) {
	        $scope.$broadcast(form.$name + 'reset-' + form.validationId);
	      } else if (form.constructor === Array) {
	        for (var k in form) {
	          $scope.$broadcast(form[k].$name + 'reset-' + form[k].validationId);
	        }
	      } else {
	        for (var i in form) {
	          if (i[0] !== '$' && form[i].hasOwnProperty('$dirty')) {
	            $scope.$broadcast(i + 'reset-' + form[i].validationId);
	          }
	        }
	      }
	    };
	
	    /**
	     * Add Message Element in config phase
	     * When you need custom your messageElement 
	     * NODE: this funtion & and `message-id` attribute, have similar purpose.
	     * This function will help you add your `messageElement` automatically instead of pre-defined.
	     * @param element
	     */
	    this.addMsgElement = function(element) {
	      return element.after('<span></span>');
	    };
	
	    /**
	     * Add Message Element in config phase
	     * When you need custom your messageElement 
	     * NODE: this funtion & and `message-id` attribute, have similar purpose.
	     * This function will help you add your `messageElement` automatically instead of pre-defined.
	     * @param element
	     */
	    this.getMsgElement = function(element) {
	      return element.next();
	    };
	
	    /**
	     * $get
	     * @returns {{setErrorHTML: *, getErrorHTML: Function, setSuccessHTML: *, getSuccessHTML: Function, setExpression: *, getExpression: Function, setDefaultMsg: *, getDefaultMsg: Function, checkValid: Function, validate: Function, reset: Function}}
	     */
	    this.$get = ['$injector', function($injector) {
	      setup($injector);
	      return {
	        setValidMethod: this.setValidMethod,
	        getValidMethod: this.getValidMethod,
	        setErrorHTML: this.setErrorHTML,
	        getErrorHTML: this.getErrorHTML,
	        setSuccessHTML: this.setSuccessHTML,
	        getSuccessHTML: this.getSuccessHTML,
	        setExpression: this.setExpression,
	        getExpression: this.getExpression,
	        setDefaultMsg: this.setDefaultMsg,
	        getDefaultMsg: this.getDefaultMsg,
	        showSuccessMessage: this.showSuccessMessage,
	        showErrorMessage: this.showErrorMessage,
	        checkValid: this.checkValid,
	        validate: this.validate,
	        validCallback: this.validCallback,
	        invalidCallback: this.invalidCallback,
	        resetCallback: this.resetCallback,
	        reset: this.reset,
	        addMsgElement: this.addMsgElement,
	        getMsgElement: this.getMsgElement
	      };
	    }];
	  }
	}).call(this);
	
	(function() {
	  angular
	    .module('validation.directive')
	    .directive('validationReset', Reset);
	
	  function Reset($injector) {
	    var $validationProvider = $injector.get('$validation');
	    var $timeout = $injector.get('$timeout');
	    var $parse = $injector.get('$parse');
	    return {
	      link: function postLink(scope, element, attrs) {
	        var form = $parse(attrs.validationReset)(scope);
	        $timeout(function() {
	          element.on('click', function(e) {
	            e.preventDefault();
	            $validationProvider.reset(form);
	          });
	        });
	      }
	    };
	  }
	  Reset.$inject = ['$injector'];
	}).call(this);
	
	(function() {
	  angular
	    .module('validation.directive')
	    .directive('validationSubmit', Submit);
	
	  function Submit($injector) {
	    var $validationProvider = $injector.get('$validation');
	    var $timeout = $injector.get('$timeout');
	    var $parse = $injector.get('$parse');
	    return {
	      priority: 1, // execute before ng-click (0)
	      require: '?ngClick',
	      link: function postLink(scope, element, attrs) {
	        var form = $parse(attrs.validationSubmit)(scope);
	        $timeout(function() {
	          // Disable ng-click event propagation
	          element.off('click');
	          element.on('click', function(e) {
	            e.preventDefault();
	            $validationProvider.validate(form)
	              .success(function() {
	                $parse(attrs.ngClick)(scope);
	              });
	          });
	        });
	      }
	    };
	  }
	  Submit.$inject = ['$injector'];
	}).call(this);
	
	(function() {
	  angular
	    .module('validation.directive')
	    .directive('validator', Validator);
	
	  function Validator($injector) {
	    var $validationProvider = $injector.get('$validation');
	    var $q = $injector.get('$q');
	    var $timeout = $injector.get('$timeout');
	    var $compile = $injector.get('$compile');
	    var $parse = $injector.get('$parse');
	    var groups = {};
	
	    /**
	     * Do this function if validation valid
	     * @param element
	     * @param validMessage
	     * @param validation
	     * @param callback
	     * @param ctrl
	     * @returns {}
	     */
	    var validFunc = function(element, validMessage, validation, scope, ctrl, attrs, param) {
	      var messageToShow = validMessage || $validationProvider.getDefaultMsg(validation).success;
	      var validCallback = $parse(attrs.validCallback);
	      var messageId = attrs.messageId;
	      var validationGroup = attrs.validationGroup;
	      var messageElem;
	
	      if (messageId || validationGroup) messageElem = angular.element(document.querySelector('#' + (messageId || validationGroup)));
	      else messageElem = $validationProvider.getMsgElement(element);
	
	      if (element.attr('no-validation-message')) {
	        messageElem.css('display', 'none');
	      } else if ($validationProvider.showSuccessMessage && messageToShow) {
	        messageToShow = angular.isFunction(messageToShow) ? messageToShow(element, attrs, param) : messageToShow;
	
	        messageElem.html('').append($compile($validationProvider.getSuccessHTML(messageToShow, element, attrs))(scope));
	        messageElem.css('display', '');
	      } else {
	        messageElem.css('display', 'none');
	      }
	
	      ctrl.$setValidity(ctrl.$name, true);
	      validCallback(scope, {
	        message: messageToShow
	      });
	      if ($validationProvider.validCallback) $validationProvider.validCallback(element);
	
	      return true;
	    };
	
	
	    /**
	     * Do this function if validation invalid
	     * @param element
	     * @param validMessage
	     * @param validation
	     * @param callback
	     * @param ctrl
	     * @returns {}
	     */
	    var invalidFunc = function(element, validMessage, validation, scope, ctrl, attrs, param) {
	      var messageToShow = validMessage || $validationProvider.getDefaultMsg(validation).error;
	      var invalidCallback = $parse(attrs.invalidCallback);
	      var messageId = attrs.messageId;
	      var validationGroup = attrs.validationGroup;
	      var messageElem;
	
	      if (messageId || validationGroup) messageElem = angular.element(document.querySelector('#' + (messageId || validationGroup)));
	      else messageElem = $validationProvider.getMsgElement(element);
	
	      if (element.attr('no-validation-message')) {
	        messageElem.css('display', 'none');
	      } else if ($validationProvider.showErrorMessage && messageToShow) {
	        messageToShow = angular.isFunction(messageToShow) ? messageToShow(element, attrs, param) : messageToShow;
	
	        messageElem.html('').append($compile($validationProvider.getErrorHTML(messageToShow, element, attrs))(scope));
	        messageElem.css('display', '');
	      } else {
	        messageElem.css('display', 'none');
	      }
	
	      ctrl.$setValidity(ctrl.$name, false);
	      invalidCallback(scope, {
	        message: messageToShow
	      });
	      if ($validationProvider.invalidCallback) $validationProvider.invalidCallback(element);
	
	      return false;
	    };
	
	    /**
	     * Verify whether there is one of the elements inside the group valid.
	     * If so, it returns true, otherwise, it returns false
	     *
	     * @param validationGroup
	     * @return {boolean}
	     */
	    var checkValidationGroup = function(validationGroup) {
	      var group = groups[validationGroup];
	
	      return Object.keys(group).some(function(key) {
	        return group[key];
	      });
	    };
	
	    /**
	     * Set validity to all elements inside the given group
	     *
	     * @param scope
	     * @param groupName
	     * @param validity
	     */
	    function setValidationGroup(scope, validationGroup, validity) {
	      var validationGroupElems = document.querySelectorAll('*[validation-group=' + validationGroup + ']');
	
	      // Loop through all elements inside the group
	      for (var i = 0, len = validationGroupElems.length; i < len; i++) {
	        var elem = validationGroupElems[i];
	        var formName = elem.form.name;
	        var elemName = elem.name;
	        scope[formName][elemName].$setValidity(elemName, validity);
	      }
	    }
	
	    /**
	     * collect elements for focus
	     * @type {Object}
	     ***private variable
	     */
	    var focusElements = {};
	
	    /**
	     * Get Validation Result Object
	     * @param data
	     * @returns {
	     *    result: Boolean, // is success or error
	     *    message: String  // tips
	     * }
	     */
	    function getResultObj(data) {
	      var res = {};
	      if (data && data.length > 0) {
	        res = data[0];
	        if (!angular.isObject(res)) {
	          res = {
	            result: res,
	            message: ''
	          };
	        }
	      } else {
	        res = {
	          result: false,
	          message: ''
	        };
	      }
	      return res;
	    }
	
	    /**
	     * Check Validation with Function or RegExp
	     * @param scope
	     * @param element
	     * @param attrs
	     * @param ctrl
	     * @param validation
	     * @param value
	     * @returns {}
	     */
	    var checkValidation = function(scope, element, attrs, ctrl, validation, value) {
	      var validators = validation.slice(0);
	      var validatorExpr = validators[0].trim();
	      var paramIndex = validatorExpr.indexOf('=');
	      var validator = paramIndex === -1 ? validatorExpr : validatorExpr.substr(0, paramIndex);
	      var validatorParam = paramIndex === -1 ? null : validatorExpr.substr(paramIndex + 1);
	      var leftValidation = validators.slice(1);
	      var successMessage = validator + 'SuccessMessage';
	      var errorMessage = validator + 'ErrorMessage';
	      var expression = $validationProvider.getExpression(validator);
	      var validationGroup = attrs.validationGroup;
	      var valid = {
	        success: function(message) {
	          validFunc(element, message || attrs[successMessage], validator, scope, ctrl, attrs, validatorParam);
	          if (leftValidation.length) {
	            return checkValidation(scope, element, attrs, ctrl, leftValidation, value);
	          } else {
	            return true;
	          }
	        },
	        error: function(message) {
	          return invalidFunc(element, message || attrs[errorMessage], validator, scope, ctrl, attrs, validatorParam);
	        }
	      };
	
	      if (expression === undefined) {
	        console.error('You are using undefined validator "%s"', validator);
	        if (leftValidation.length) return checkValidation(scope, element, attrs, ctrl, leftValidation, value);
	        else return;
	      }
	      // Check with Function
	      if (expression.constructor === Function) {
	        return $q.all([$validationProvider.getExpression(validator)(value, scope, element, attrs, validatorParam)])
	          .then(function(data) {
	            var resultObj = getResultObj(data);
	            var message = resultObj.message;
	            if (resultObj.result) {
	              if (validationGroup) {
	                groups[validationGroup][ctrl.$name] = true;
	                setValidationGroup(scope, validationGroup, true);
	              }
	              return valid.success(message);
	            } else if (validationGroup) {
	              groups[validationGroup][ctrl.$name] = false;
	
	              // Whenever the element is invalid, we'll check whether one of the elements inside the its group valid or not.
	              // If there is a valid element, its invalid message won't be shown, Otherwise, shows its invalid message.
	              if (checkValidationGroup(validationGroup)) {
	                setValidationGroup(scope, validationGroup, true);
	              } else {
	                setValidationGroup(scope, validationGroup, false);
	                return valid.error(message);
	              }
	            } else return valid.error(message);
	          }, function() {
	            return valid.error();
	          });
	      }
	
	      // Check with RegExp
	      else if (expression.constructor === RegExp) {
	        // Only apply the test if the value is neither undefined or null
	        if (value !== undefined && value !== null) {
	          if ($validationProvider.getExpression(validator).test(value)) {
	            if (validationGroup) {
	              groups[validationGroup][ctrl.$name] = true;
	              setValidationGroup(scope, validationGroup, true);
	            }
	            return valid.success();
	          } else if (validationGroup) {
	            groups[validationGroup][ctrl.$name] = false;
	
	            // Whenever the element is invalid, we'll check whether one of the elements inside the its group valid or not.
	            // If there is a valid element, its invalid message won't be shown, Otherwise, shows its invalid message.
	            if (checkValidationGroup(validationGroup)) {
	              setValidationGroup(scope, validationGroup, true);
	            } else {
	              setValidationGroup(scope, validationGroup, false);
	              return valid.error();
	            }
	          } else return valid.error();
	        }
	      } else return valid.error();
	    };
	
	    /**
	     * generate unique guid
	     */
	    var s4 = function() {
	      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	    };
	    var guid = function() {
	      return (s4() + s4() + s4() + s4());
	    };
	
	
	    return {
	      restrict: 'A',
	      require: 'ngModel',
	      link: function(scope, element, attrs, ctrl) {
	        /**
	         * All attributes
	         */
	        var useViewValue = attrs.useViewValue !== 'false';
	        var validator = attrs.validator;
	        var messageId = attrs.messageId;
	        var validationGroup = attrs.validationGroup;
	        var validMethod = attrs.validMethod;
	        var ngModel = attrs.ngModel;
	
	        /**
	         * watch
	         * @type {watch}
	         *
	         * Use to collect scope.$watch method
	         *
	         * use watch() to destroy the $watch method
	         */
	        var watch = function() {};
	
	        /**
	         * validator
	         * @type {Array}
	         *
	         * Convert user input String to Array
	         */
	        var validation = validator.split(',');
	
	        /**
	         * guid use
	         */
	        var uid = ctrl.validationId = guid();
	
	        /**
	         * to have a value to rollback to
	         */
	        var originalViewValue = null;
	
	        /**
	         * Set initial validity to undefined if no boolean value is transmitted
	         */
	        var initialValidity = void 0;
	        if (typeof attrs.initialValidity === 'boolean') {
	          initialValidity = attrs.initialValidity;
	        }
	
	        /**
	         * Observe validator changes in order to allow dynamically change it
	         */
	        attrs.$observe('validator', function(value) {
	          validation = value.split(',');
	        });
	
	        /**
	         * Set up groups object in order to keep track validation of elements
	         */
	        if (validationGroup) {
	          if (!groups[validationGroup]) groups[validationGroup] = {};
	          groups[validationGroup][ctrl.$name] = false;
	        }
	
	        /**
	         * Default Valid/Invalid Message
	         */
	        if (!(messageId || validationGroup)) $validationProvider.addMsgElement(element);
	
	        /**
	         * Set custom initial validity
	         * Usage: <input initial-validity="true" ... >
	         */
	        ctrl.$setValidity(ctrl.$name, initialValidity);
	
	        /**
	         * Reset the validation for specific form
	         */
	        scope.$on(ctrl.$name + 'reset-' + uid, function() {
	          /**
	           * clear scope.$watch here
	           * when reset status
	           * clear the $watch method to prevent
	           * $watch again while reset the form
	           */
	          watch();
	
	          $timeout(function() {
	            ctrl.$setViewValue(originalViewValue);
	            ctrl.$setPristine();
	            ctrl.$setValidity(ctrl.$name, undefined);
	            ctrl.$render();
	            if (messageId || validationGroup) angular.element(document.querySelector('#' + (messageId || validationGroup))).html('');
	            else $validationProvider.getMsgElement(element).html('');
	
	            if ($validationProvider.resetCallback) $validationProvider.resetCallback(element);
	          });
	        });
	
	        /**
	         * Check validator
	         */
	        validMethod = (angular.isUndefined(validMethod)) ? $validationProvider.getValidMethod() : validMethod;
	
	        /**
	         * Click submit form, check the validity when submit
	         */
	        scope.$on(ctrl.$name + 'submit-' + uid, function(event, index) {
	          var value = useViewValue ? ctrl.$viewValue : ctrl.$modelValue;
	          var isValid = false;
	
	          isValid = checkValidation(scope, element, attrs, ctrl, validation, value);
	
	          if (validMethod === 'submit') {
	            // clear previous scope.$watch
	            watch();
	            watch = scope.$watch(function() {
	              return scope.$eval(ngModel);
	            }, function(value, oldValue) {
	              // don't watch when init
	              if (value === oldValue) {
	                return;
	              }
	
	              // scope.$watch will translate '' to undefined
	              // undefined/null will pass the required submit /^.+/
	              // cause some error in this validation
	              if (value === undefined || value === null) {
	                value = '';
	              }
	
	              isValid = checkValidation(scope, element, attrs, ctrl, validation, value);
	            });
	          }
	
	          var setFocus = function(isValid) {
	            if (isValid) {
	              delete focusElements[index];
	            } else {
	              focusElements[index] = element[0];
	
	              $timeout(function() {
	                focusElements[Math.min.apply(null, Object.keys(focusElements))].focus();
	              }, 0);
	            }
	          };
	
	          if (isValid.constructor === Object) isValid.then(setFocus);
	          else setFocus(isValid);
	        });
	
	        /**
	         * Validate blur method
	         */
	        if (validMethod === 'blur') {
	          element.bind('blur', function() {
	            var value = scope.$eval(ngModel);
	
	            if (scope.$root.$$phase !== '$apply') {
	              scope.$apply(function() {
	                checkValidation(scope, element, attrs, ctrl, validation, value);
	              });
	            } else {
	              checkValidation(scope, element, attrs, ctrl, validation, value);
	            }
	          });
	
	          return;
	        }
	
	        /**
	         * Validate submit & submit-only method
	         */
	        if (validMethod === 'submit' || validMethod === 'submit-only') {
	          return;
	        }
	
	        /**
	         * Validate watch method
	         * This is the default method
	         */
	        scope.$watch(function() {
	          return scope.$eval(ngModel);
	        }, function(value) {
	          /**
	           * dirty, pristine, viewValue control here
	           */
	          if (ctrl.$pristine && ctrl.$viewValue) {
	            // has value when initial
	            originalViewValue = ctrl.$viewValue || '';
	            ctrl.$setViewValue(ctrl.$viewValue);
	          } else if (ctrl.$pristine) {
	            // Don't validate form when the input is clean(pristine)
	            if (messageId || validationGroup) angular.element(document.querySelector('#' + (messageId || validationGroup))).html('');
	            else $validationProvider.getMsgElement(element).html('');
	            return;
	          }
	          checkValidation(scope, element, attrs, ctrl, validation, value);
	        });
	
	        $timeout(function() {
	          /**
	           * Don't showup the validation Message
	           */
	          attrs.$observe('noValidationMessage', function(value) {
	            var el;
	            if (messageId || validationGroup) el = angular.element(document.querySelector('#' + (messageId || validationGroup)));
	            else el = $validationProvider.getMsgElement(element);
	            if (value === 'true' || value === true) el.css('display', 'none');
	            else if (value === 'false' || value === false) el.css('display', 'block');
	          });
	        });
	      }
	    };
	  }
	  Validator.$inject = ['$injector'];
	}).call(this);


/***/ }),
/* 1357 */
/***/ (function(module, exports) {

	(function() {
	  angular
	    .module('validation.rule', ['validation'])
	    .config(['$validationProvider', function($validationProvider) {
	      var expression = {
	        required: function(value) {
	          return !!value;
	        },
	        url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
	        email: /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
	        number: /^\d+$/,
	        minlength: function(value, scope, element, attrs, param) {
	          return value && value.length >= param;
	        },
	        maxlength: function(value, scope, element, attrs, param) {
	          return !value || value.length <= param;
	        }
	      };
	
	      var defaultMsg = {
	        required: {
	          error: 'This should be Required!!',
	          success: 'It\'s Required'
	        },
	        url: {
	          error: 'This should be Url',
	          success: 'It\'s Url'
	        },
	        email: {
	          error: 'This should be Email',
	          success: 'It\'s Email'
	        },
	        number: {
	          error: 'This should be Number',
	          success: 'It\'s Number'
	        },
	        minlength: {
	          error: 'This should be longer',
	          success: 'Long enough!'
	        },
	        maxlength: {
	          error: 'This should be shorter',
	          success: 'Short enough!'
	        }
	      };
	      $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
	    }]);
	}).call(this);


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(moment) {/*! Angular Moment Picker - v0.10.2 - http://indrimuska.github.io/angular-moment-picker - (c) 2015 Indri Muska - MIT */
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 17);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var moment = __webpack_require__(2);
	exports.KEYS = { up: 38, down: 40, left: 37, right: 39, escape: 27, enter: 13 };
	exports.isValidMoment = function (value) {
	    return moment.isMoment(value) && value.isValid();
	};
	exports.toValue = function (date, format, locale) {
	    var momentDate = date;
	    if (!exports.isValidMoment(date))
	        momentDate = exports.toMoment(date, format, locale);
	    return exports.momentToValue(momentDate, format);
	};
	exports.toMoment = function (date, format, locale) {
	    var momentDate = moment(date, format, locale);
	    if (!exports.isValidMoment(momentDate))
	        momentDate = undefined;
	    return momentDate;
	};
	exports.momentToValue = function (momentObject, format) {
	    if (!exports.isValidMoment(momentObject))
	        return undefined;
	    return !format ? momentObject.valueOf() : momentObject.format(format);
	};
	exports.valueToMoment = function (formattedValue, $scope) {
	    var momentValue;
	    if (!formattedValue)
	        return momentValue;
	    if (!$scope.format)
	        momentValue = moment(formattedValue);
	    else
	        momentValue = moment(formattedValue, $scope.format, $scope.locale);
	    if ($scope.model) {
	        // set value for each view precision (from Decade View to minView)
	        var views = $scope.views.all.slice(0, $scope.views.all.indexOf($scope.detectedMinView));
	        angular.forEach(views, function (view) {
	            var precision = $scope.views.precisions[view];
	            momentValue[precision]($scope.model[precision]());
	        });
	    }
	    return momentValue;
	};
	exports.setValue = function (value, $scope, $ctrl, $attrs) {
	    var modelValue = exports.isValidMoment(value) ? value.clone() : exports.valueToMoment(value, $scope), viewValue = exports.momentToValue(modelValue, $scope.format);
	    $scope.model = exports.updateMoment($scope.model, modelValue, $scope);
	    $ctrl.$modelValue = exports.updateMoment($ctrl.$modelValue, modelValue, $scope);
	    if ($attrs['ngModel'] != $attrs['momentPicker'])
	        $scope.value = viewValue;
	    if ($attrs['ngModel']) {
	        $ctrl.$setViewValue(viewValue);
	        $ctrl.$render(); // render input value
	    }
	};
	exports.updateMoment = function (model, value, $scope) {
	    if (!exports.isValidMoment(model) || !value)
	        model = value;
	    else {
	        if (!model.isSame(value)) {
	            // set value for each view precision (from Decade View to maxView)
	            var views = $scope.views.all.slice(0, $scope.views.all.indexOf($scope.detectedMaxView) + 1);
	            angular.forEach(views, function (view) {
	                var precision = $scope.views.precisions[view];
	                model[precision](value[precision]());
	            });
	        }
	    }
	    return model;
	};
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
	module.exports = angular;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
	module.exports = moment;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	// removed by extract-text-webpack-plugin
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var provider_1 = __webpack_require__(9);
	exports.Provider = provider_1["default"];
	var directive_1 = __webpack_require__(7);
	exports.Directive = directive_1["default"];
	angular
	    .module('moment-picker', [])
	    .provider('momentPicker', [function () { return new provider_1["default"](); }])
	    .directive('momentPicker', [
	    '$timeout', '$sce', '$log', '$window', 'momentPicker', '$compile', '$templateCache',
	    function ($timeout, $sce, $log, $window, momentPicker, $compile, $templateCache) {
	        return new directive_1["default"]($timeout, $sce, $log, $window, momentPicker, $compile, $templateCache);
	    }
	]);
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	module.exports = "<div class=moment-picker> <div class=\"moment-picker-container {{view.selected}}-view\" ng-class=\"{'moment-picker-disabled': disabled, open: view.isOpen}\"> <div ng-if=additions.top class=\"moment-picker-addition top\"></div> <table class=header-view ng-if=showHeader> <thead> <tr> <th ng-class=\"{disabled: !view.previous.selectable}\" ng-bind-html=view.previous.label ng-click=view.previous.set()></th> <th ng-bind=view.title ng-click=view.setParentView()></th> <th ng-class=\"{disabled: !view.next.selectable}\" ng-bind-html=view.next.label ng-click=view.next.set()></th> </tr> </thead> </table> <div class=moment-picker-specific-views> <table> <thead ng-if=views[view.selected].headers> <tr> <th ng-repeat=\"header in views[view.selected].headers\" ng-bind=header></th> </tr> </thead> <tbody> <tr ng-repeat=\"row in views[view.selected].rows\"> <td ng-repeat=\"item in row track by item.index\" ng-class=item.class ng-bind=item.label ng-click=\"!disabled && views[view.selected].set(item)\"></td> </tr> </tbody> </table> </div> <div ng-if=additions.bottom class=\"moment-picker-addition bottom\"></div> </div> </div>";
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var moment = __webpack_require__(2);
	var helpers_1 = __webpack_require__(8);
	var views_1 = __webpack_require__(13);
	var utility_1 = __webpack_require__(0);
	var templateHtml = __webpack_require__(6);
	var Directive = (function () {
	    function Directive($timeout, $sce, $log, $window, provider, $compile, $templateCache) {
	        var _this = this;
	        this.$timeout = $timeout;
	        this.$sce = $sce;
	        this.$log = $log;
	        this.$window = $window;
	        this.provider = provider;
	        this.$compile = $compile;
	        this.$templateCache = $templateCache;
	        this.restrict = 'A';
	        this.require = '?ngModel';
	        this.transclude = true;
	        this.template = templateHtml;
	        this.scope = {
	            value: '=?momentPicker',
	            model: '=?ngModel',
	            locale: '@?',
	            format: '@?',
	            minView: '@?',
	            maxView: '@?',
	            startView: '@?',
	            minDate: '=?',
	            maxDate: '=?',
	            startDate: '=?',
	            disabled: '=?disable',
	            position: '@?',
	            inline: '@?',
	            validate: '=?',
	            autoclose: '=?',
	            setOnSelect: '=?',
	            isOpen: '=?',
	            today: '=?',
	            keyboard: '=?',
	            showHeader: '=?',
	            additions: '=?',
	            change: '&?',
	            selectable: '&?'
	        };
	        this.link = function ($scope, $element, $attrs, $ctrl, $transclude) {
	            $transclude(function ($transElement) {
	                // one-way binding attributes
	                angular.forEach([
	                    'locale', 'format', 'minView', 'maxView', 'startView', 'position', 'inline', 'validate', 'autoclose', 'setOnSelect', 'today',
	                    'keyboard', 'showHeader', 'leftArrow', 'rightArrow', 'additions'
	                ], function (attr) {
	                    if (!angular.isDefined($scope[attr]))
	                        $scope[attr] = _this.provider[attr];
	                    if (!angular.isDefined($attrs[attr]))
	                        $attrs[attr] = $scope[attr];
	                });
	                // check if ngModel has been set
	                if (!$attrs['ngModel'])
	                    $ctrl = {};
	                // limits
	                $scope.limits = {
	                    minDate: utility_1.toMoment($scope.minDate, $scope.format, $scope.locale),
	                    maxDate: utility_1.toMoment($scope.maxDate, $scope.format, $scope.locale),
	                    isAfterOrEqualMin: function (value, precision) {
	                        return !angular.isDefined($scope.limits.minDate) || value.isAfter($scope.limits.minDate, precision) || value.isSame($scope.limits.minDate, precision);
	                    },
	                    isBeforeOrEqualMax: function (value, precision) {
	                        return !angular.isDefined($scope.limits.maxDate) || value.isBefore($scope.limits.maxDate, precision) || value.isSame($scope.limits.maxDate, precision);
	                    },
	                    isSelectable: function (value, precision) {
	                        var selectable = true;
	                        try {
	                            if (angular.isFunction($scope.selectable) && $attrs['selectable'])
	                                selectable = $scope.selectable({ date: value, type: precision });
	                        }
	                        catch (e) {
	                            _this.$log.error(e);
	                        }
	                        return $scope.limits.isAfterOrEqualMin(value, precision) && $scope.limits.isBeforeOrEqualMax(value, precision) && selectable;
	                    },
	                    checkValue: function () {
	                        if (!utility_1.isValidMoment($ctrl.$modelValue) || !$scope.validate)
	                            return;
	                        if (!$scope.limits.isAfterOrEqualMin($ctrl.$modelValue))
	                            utility_1.setValue($scope.limits.minDate, $scope, $ctrl, $attrs);
	                        if (!$scope.limits.isBeforeOrEqualMax($ctrl.$modelValue))
	                            utility_1.setValue($scope.limits.maxDate, $scope, $ctrl, $attrs);
	                    },
	                    checkView: function () {
	                        if (!angular.isDefined($scope.view.moment))
	                            $scope.view.moment = moment().locale($scope.locale);
	                        if (!$scope.limits.isAfterOrEqualMin($scope.view.moment))
	                            $scope.view.moment = $scope.limits.minDate.clone();
	                        if (!$scope.limits.isBeforeOrEqualMax($scope.view.moment))
	                            $scope.view.moment = $scope.limits.maxDate.clone();
	                        $scope.view.update();
	                        $scope.view.render();
	                    }
	                };
	                $scope.views = {
	                    all: ['decade', 'year', 'month', 'day', 'hour', 'minute'],
	                    precisions: { decade: 'year', year: 'month', month: 'date', day: 'hour', hour: 'minute', minute: 'second' },
	                    // for each view, `$scope.views.formats` object contains the available moment formats
	                    // formats present in more views are used to perform min/max view detection (i.e. 'LTS', 'LT', ...)
	                    formats: {
	                        decade: 'Y{1,2}(?!Y)|YYYY|[Ll]{1,4}(?!T)',
	                        /* formats: Y,YY,YYYY,L,LL,LLL,LLLL,l,ll,lll,llll */
	                        year: 'M{1,4}(?![Mo])|Mo|Q',
	                        /* formats: M,MM,MMM,MMM,Mo,Q */
	                        month: '[Dd]{1,4}(?![Ddo])|DDDo|[Dd]o|[Ww]{1,2}(?![Wwo])|[Ww]o|[Ee]|L{1,2}(?!T)|l{1,2}',
	                        /* formats: D,DD,DDD,DDDD,d,dd,ddd,dddd,DDDo,Do,do,W,WW,w,ww,Wo,wo,E,e,L,LL,l,ll */
	                        day: '[Hh]{1,2}|LTS?',
	                        /* formats: H,HH,h,hh,LT,LTS */
	                        hour: 'm{1,2}|[Ll]{3,4}|LT(?!S)',
	                        /* formats: m,mm,LLL,LLLL,lll,llll,LT */
	                        minute: 's{1,2}|S{1,}|X|LTS'
	                        /* formats: s,ss,S,SS,SSS..,X,LTS */
	                    },
	                    detectMinMax: function () {
	                        $scope.detectedMinView = $scope.detectedMaxView = undefined;
	                        if (!$scope.format)
	                            return;
	                        var minView, maxView;
	                        angular.forEach($scope.views.formats, function (formats, view) {
	                            var regexp = new RegExp('(' + formats + ')(?![^\[]*\])', 'g');
	                            if (!$scope.format.match(regexp))
	                                return;
	                            if (!angular.isDefined(minView))
	                                minView = view;
	                            maxView = view;
	                        });
	                        if (!angular.isDefined(minView))
	                            minView = 0;
	                        else
	                            minView = Math.max(0, $scope.views.all.indexOf(minView));
	                        if (!angular.isDefined(maxView))
	                            maxView = $scope.views.all.length - 1;
	                        else
	                            maxView = Math.min($scope.views.all.length - 1, $scope.views.all.indexOf(maxView));
	                        if (minView > $scope.views.all.indexOf($scope.minView))
	                            $scope.minView = $scope.views.all[minView];
	                        if (maxView < $scope.views.all.indexOf($scope.maxView))
	                            $scope.maxView = $scope.views.all[maxView];
	                        // save detected min/max view to use them to update the model value properly
	                        $scope.detectedMinView = $scope.views.all[minView];
	                        $scope.detectedMaxView = $scope.views.all[maxView];
	                    },
	                    // specific views
	                    decade: new views_1.DecadeView($scope, $ctrl, _this.provider),
	                    year: new views_1.YearView($scope, $ctrl, _this.provider),
	                    month: new views_1.MonthView($scope, $ctrl, _this.provider),
	                    day: new views_1.DayView($scope, $ctrl, _this.provider),
	                    hour: new views_1.HourView($scope, $ctrl, _this.provider),
	                    minute: new views_1.MinuteView($scope, $ctrl, _this.provider)
	                };
	                $scope.view = {
	                    moment: undefined,
	                    value: undefined,
	                    isOpen: false,
	                    selected: $scope.startView,
	                    update: function () { $scope.view.value = utility_1.momentToValue($scope.view.moment, $scope.format); },
	                    toggle: function () { $scope.view.isOpen ? $scope.view.close() : $scope.view.open(); },
	                    open: function () {
	                        if ($scope.disabled || $scope.view.isOpen || $scope.inline)
	                            return;
	                        $scope.isOpen = true;
	                        $scope.view.isOpen = true;
	                        document.body.appendChild($scope.picker[0]);
	                        $scope.view.position();
	                    },
	                    close: function () {
	                        if (!$scope.view.isOpen || $scope.inline)
	                            return;
	                        $scope.isOpen = false;
	                        $scope.view.isOpen = false;
	                        $scope.view.selected = $scope.startView;
	                        $scope.picker[0].parentNode.removeChild($scope.picker[0]);
	                    },
	                    position: function () {
	                        if (!$scope.view.isOpen || $scope.position || $scope.inline)
	                            return;
	                        var element = $element[0], picker = $scope.picker.children()[0], hasClassTop = $scope.picker.hasClass('top'), hasClassRight = $scope.picker.hasClass('right'), offset = helpers_1.getOffset($element[0]), top = offset.top - _this.$window.pageYOffset, left = offset.left - _this.$window.pageXOffset, winWidth = _this.$window.innerWidth, winHeight = _this.$window.innerHeight, shouldHaveClassTop = top + _this.$window.pageYOffset - picker.offsetHeight > 0 && top > winHeight / 2, shouldHaveClassRight = left + picker.offsetWidth > winWidth, pickerTop = offset.top + (shouldHaveClassTop ? 0 : element.offsetHeight) + 'px', pickerLeft = offset.left + 'px', pickerWidth = element.offsetWidth + 'px';
	                        if (!hasClassTop && shouldHaveClassTop)
	                            $scope.picker.addClass('top');
	                        if (hasClassTop && !shouldHaveClassTop)
	                            $scope.picker.removeClass('top');
	                        if (!hasClassRight && shouldHaveClassRight)
	                            $scope.picker.addClass('right');
	                        if (hasClassRight && !shouldHaveClassRight)
	                            $scope.picker.removeClass('right');
	                        if ($scope.picker.css('top') !== pickerTop)
	                            $scope.picker.css('top', pickerTop);
	                        if ($scope.picker.css('left') !== pickerLeft)
	                            $scope.picker.css('left', pickerLeft);
	                        if ($scope.picker.css('width') !== pickerWidth)
	                            $scope.picker.css('width', pickerWidth);
	                    },
	                    keydown: function (e) {
	                        var view = $scope.views[$scope.view.selected], precision = $scope.views.precisions[$scope.view.selected].replace('date', 'day'), singleUnit = _this.provider[precision + 'sStep'] || 1, operation = [utility_1.KEYS.up, utility_1.KEYS.left].indexOf(e.keyCode) >= 0 ? 'subtract' : 'add', highlight = function (vertical) {
	                            var unitMultiplier = vertical ? view.perLine : 1, nextDate = $scope.view.moment.clone()[operation](singleUnit * unitMultiplier, precision);
	                            if ($scope.limits.isSelectable(nextDate, precision)) {
	                                $scope.view.moment = nextDate;
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        };
	                        switch (e.keyCode) {
	                            case utility_1.KEYS.up:
	                            case utility_1.KEYS.down:
	                                e.preventDefault();
	                                if (!$scope.view.isOpen)
	                                    $scope.view.open();
	                                else
	                                    highlight(true);
	                                break;
	                            case utility_1.KEYS.left:
	                            case utility_1.KEYS.right:
	                                if (!$scope.view.isOpen)
	                                    break;
	                                e.preventDefault();
	                                highlight();
	                                break;
	                            case utility_1.KEYS.enter:
	                                if (!$scope.view.isOpen)
	                                    break;
	                                $scope.view.change(precision);
	                                e.preventDefault();
	                                break;
	                            case utility_1.KEYS.escape:
	                                $scope.view.toggle();
	                                break;
	                        }
	                        $scope.$evalAsync();
	                    },
	                    // utility
	                    unit: function () { return $scope.view.selected == 'decade' ? 10 : 1; },
	                    precision: function () { return $scope.view.selected.replace('decade', 'year'); },
	                    // header
	                    title: '',
	                    previous: {
	                        label: _this.$sce.trustAsHtml($scope.leftArrow),
	                        selectable: true,
	                        set: function () {
	                            if ($scope.view.previous.selectable) {
	                                $scope.view.moment.subtract($scope.view.unit(), $scope.view.precision());
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        }
	                    },
	                    next: {
	                        selectable: true,
	                        label: _this.$sce.trustAsHtml($scope.rightArrow),
	                        set: function () {
	                            if ($scope.view.next.selectable) {
	                                $scope.view.moment.add($scope.view.unit(), $scope.view.precision());
	                                $scope.view.update();
	                                $scope.view.render();
	                            }
	                        }
	                    },
	                    setParentView: function () { $scope.view.change($scope.views.all[Math.max(0, $scope.views.all.indexOf($scope.view.selected) - 1)]); },
	                    // body
	                    render: function () {
	                        var momentPrevious = $scope.view.moment.clone().startOf($scope.view.precision()).subtract($scope.view.unit(), $scope.view.precision()), momentNext = $scope.view.moment.clone().endOf($scope.view.precision()).add($scope.view.unit(), $scope.view.precision());
	                        $scope.view.previous.selectable = $scope.limits.isAfterOrEqualMin(momentPrevious, $scope.view.precision());
	                        $scope.view.previous.label = _this.$sce.trustAsHtml($scope.view.previous.selectable ? $scope.leftArrow : '&nbsp;');
	                        $scope.view.next.selectable = $scope.limits.isBeforeOrEqualMax(momentNext, $scope.view.precision());
	                        $scope.view.next.label = _this.$sce.trustAsHtml($scope.view.next.selectable ? $scope.rightArrow : '&nbsp;');
	                        $scope.view.title = $scope.views[$scope.view.selected].render();
	                    },
	                    change: function (view) {
	                        var nextView = $scope.views.all.indexOf(view), minView = $scope.views.all.indexOf($scope.minView), maxView = $scope.views.all.indexOf($scope.maxView);
	                        var update = function () {
	                            utility_1.setValue($scope.view.moment, $scope, $ctrl, $attrs);
	                            $scope.view.update();
	                            if ($attrs['ngModel'])
	                                $ctrl.$commitViewValue();
	                        };
	                        if ($scope.setOnSelect)
	                            update();
	                        if (nextView < 0 || nextView > maxView) {
	                            if (!$scope.setOnSelect)
	                                update();
	                            if ($scope.autoclose)
	                                _this.$timeout($scope.view.close);
	                        }
	                        else if (nextView >= minView)
	                            $scope.view.selected = view;
	                    }
	                };
	                // creation
	                $element.prepend($transElement);
	                $scope.picker = angular.element($element[0].querySelectorAll('.moment-picker'));
	                $scope.container = angular.element($scope.picker[0].querySelectorAll('.moment-picker-container'));
	                $scope.input = $element[0].tagName.toLowerCase() != 'input' && $element[0].querySelectorAll('input').length > 0
	                    ? angular.element($element[0].querySelectorAll('input'))
	                    : angular.element($element[0]);
	                $scope.input.addClass('moment-picker-input').attr('tabindex', 0);
	                ($scope.position || '').split(' ').forEach(function (className) { return $scope.picker.addClass(className); });
	                if (!$scope.inline)
	                    $scope.picker[0].parentNode.removeChild($scope.picker[0]);
	                else {
	                    $element.after($scope.picker);
	                    $scope.picker.addClass('inline');
	                }
	                // transclude scope to template additions
	                _this.$timeout(function () {
	                    angular.forEach($scope.additions || {}, function (tempalteUrl, key) {
	                        var placeholder = angular.element($scope.container[0].querySelector('.moment-picker-addition.' + key));
	                        var template = _this.$templateCache.get(tempalteUrl);
	                        var compiled = _this.$compile(template)($scope.$parent);
	                        placeholder.append(compiled);
	                    });
	                });
	                // initialization
	                $scope.views.detectMinMax();
	                $scope.limits.checkView();
	                // model controller is initialized after linking function
	                _this.$timeout(function () {
	                    if ($attrs['ngModel']) {
	                        if (!$ctrl.$modelValue && $scope.value)
	                            $ctrl.$setViewValue($scope.value);
	                        $ctrl.$commitViewValue();
	                        $ctrl.$render();
	                    }
	                    else {
	                        if ($scope.value)
	                            $ctrl.$modelValue = utility_1.valueToMoment($scope.value, $scope);
	                    }
	                    // view initialization
	                    if ($scope.startDate)
	                        $scope.view.moment = utility_1.toMoment($scope.startDate, $scope.format, $scope.locale);
	                    else if (utility_1.isValidMoment($ctrl.$modelValue))
	                        $scope.view.moment = $ctrl.$modelValue.clone();
	                    $scope.view.update();
	                    $scope.view.render();
	                });
	                // model <-> view conversion
	                if ($attrs['ngModel']) {
	                    $ctrl.$parsers.push(function (viewValue) { return utility_1.updateMoment($ctrl.$modelValue, utility_1.valueToMoment(viewValue, $scope), $scope) || true; });
	                    $ctrl.$formatters.push(function (modelValue) { return utility_1.momentToValue(modelValue, $scope.format) || ''; });
	                    $ctrl.$viewChangeListeners.push(function () { if ($attrs['ngModel'] != $attrs['momentPicker'])
	                        $scope.value = $ctrl.$viewValue; });
	                    $ctrl.$validators.minDate = function (value) { return $scope.validate || !utility_1.isValidMoment(value) || $scope.limits.isAfterOrEqualMin(value); };
	                    $ctrl.$validators.maxDate = function (value) { return $scope.validate || !utility_1.isValidMoment(value) || $scope.limits.isBeforeOrEqualMax(value); };
	                }
	                // properties listeners
	                if ($attrs['ngModel'] != $attrs['momentPicker'])
	                    $scope.$watch('value', function (newValue, oldValue) {
	                        if (newValue !== oldValue)
	                            utility_1.setValue(newValue, $scope, $ctrl, $attrs);
	                    });
	                $scope.$watch(function () { return utility_1.momentToValue($ctrl.$modelValue, $scope.format); }, function (newViewValue, oldViewValue) {
	                    if (newViewValue == oldViewValue)
	                        return;
	                    var newModelValue = utility_1.valueToMoment(newViewValue, $scope);
	                    utility_1.setValue(newModelValue, $scope, $ctrl, $attrs);
	                    $scope.limits.checkValue();
	                    $scope.view.moment = (newModelValue || moment().locale($scope.locale)).clone();
	                    $scope.view.update();
	                    $scope.view.render();
	                    if (angular.isFunction($scope.change) && $attrs['change']) {
	                        var oldModelValue_1 = utility_1.valueToMoment(oldViewValue, $scope);
	                        $scope.$evalAsync(function () { return $scope.change({ newValue: newModelValue, oldValue: oldModelValue_1 }); });
	                    }
	                });
	                $scope.$watch(function () { return $ctrl.$modelValue && $ctrl.$modelValue.valueOf(); }, function () {
	                    var viewMoment = (utility_1.isValidMoment($ctrl.$modelValue) ? $ctrl.$modelValue : moment().locale($scope.locale)).clone();
	                    if (!viewMoment.isSame($scope.view.moment)) {
	                        $scope.view.moment = viewMoment;
	                        $scope.view.update();
	                        $scope.view.render();
	                    }
	                });
	                $scope.$watch('view.selected', function () { return $scope.view.render(); });
	                $scope.$watchGroup(['minView', 'maxView'], function () {
	                    // auto-detect minView/maxView
	                    $scope.views.detectMinMax();
	                    // limit startView
	                    $scope.startView = $scope.views.all[Math.max(Math.min($scope.views.all.indexOf($scope.startView), $scope.views.all.indexOf($scope.maxView)), $scope.views.all.indexOf($scope.minView))];
	                    $scope.view.selected = $scope.startView;
	                });
	                $scope.$watchGroup([
	                    function () { return utility_1.toValue($scope.minDate, $scope.format, $scope.locale); },
	                    function () { return utility_1.toValue($scope.maxDate, $scope.format, $scope.locale); }
	                ], function () {
	                    angular.forEach(['minDate', 'maxDate'], function (field) {
	                        $scope.limits[field] = utility_1.toMoment($scope[field], $scope.format, $scope.locale);
	                    });
	                    $scope.limits.checkValue();
	                    $scope.limits.checkView();
	                    $scope.view.render();
	                });
	                $scope.$watch(function () { return utility_1.toValue($scope.startDate, $scope.format, $scope.locale); }, function (newViewValue, oldViewValue) {
	                    if (newViewValue == oldViewValue)
	                        return;
	                    $scope.view.moment = utility_1.valueToMoment(newViewValue, $scope);
	                    $scope.view.update();
	                    $scope.view.render();
	                });
	                $attrs.$observe('locale', function (locale) { return $scope.locale = locale; });
	                $scope.$watch('locale', function (locale, previous) {
	                    if (!angular.isDefined(previous) || locale == previous)
	                        return;
	                    if (utility_1.isValidMoment($ctrl.$modelValue))
	                        utility_1.setValue($ctrl.$modelValue.locale(locale), $scope, $ctrl, $attrs);
	                    if (utility_1.isValidMoment($scope.view.moment))
	                        $scope.view.moment = $scope.view.moment.locale(locale);
	                    if (utility_1.isValidMoment($scope.limits.minDate))
	                        $scope.limits.minDate = $scope.limits.minDate.locale(locale);
	                    if (utility_1.isValidMoment($scope.limits.maxDate))
	                        $scope.limits.maxDate = $scope.limits.maxDate.locale(locale);
	                    $scope.view.render();
	                });
	                $scope.$watch('validate', $scope.limits.checkValue);
	                $scope.$watch('isOpen', function (isOpen) {
	                    if ($scope.inline)
	                        $scope.view.isOpen = true;
	                    else if (angular.isDefined(isOpen) && isOpen != $scope.view.isOpen)
	                        $scope.view.toggle();
	                });
	                // event listeners
	                var focusInput = function (e) {
	                    if (e)
	                        e.preventDefault();
	                    $scope.input[0].focus();
	                };
	                // use `touchstart` for iOS Safari, where click events aren't propogated under most circumstances.
	                $scope.input
	                    .on('focus click touchstart', function () { return $scope.$evalAsync($scope.view.open); })
	                    .on('blur', function () { return $scope.$evalAsync($scope.view.close); })
	                    .on('keydown', function (e) { if ($scope.keyboard)
	                    $scope.view.keydown(e); });
	                $element.on('click touchstart', function () { return focusInput(); });
	                $scope.container.on('mousedown', function (e) { return focusInput(e); });
	                angular.element(_this.$window).on('resize scroll', $scope.view.position);
	                // unbind events on destroy
	                $scope.$on('$destroy', function () {
	                    $scope.input.off('focus click touchstart blur keydown');
	                    $element.off('click touchstart');
	                    $scope.container.off('mousedown');
	                    $scope.picker.remove();
	                    angular.element(_this.$window).off('resize scroll', $scope.view.position);
	                });
	            });
	        };
	    }
	    return Directive;
	}());
	exports["default"] = Directive;
	
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	/**
	 * Offset getter method from jQuery: https://github.com/jquery/jquery/blob/3.1.1/src/offset.js#L78
	 */
	exports.getOffset = function (element) {
	    if (!element)
	        return;
	    if (!element.getClientRects().length)
	        return { top: 0, left: 0 };
	    // https://github.com/jquery/jquery/blob/3.1.1/src/core.js#L220
	    var isWindow = function (obj) { return obj != null && obj === obj.window; };
	    var getWindow = function (elem) { return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView; }; // tslint:disable-line:no-any
	    var rect = element.getBoundingClientRect();
	    if (!rect.width && !rect.height)
	        return rect;
	    var doc = element.ownerDocument;
	    var win = getWindow(doc);
	    var docElem = doc.documentElement;
	    return {
	        top: rect.top + win.pageYOffset - docElem.clientTop,
	        left: rect.left + win.pageXOffset - docElem.clientLeft
	    };
	};
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var Provider = (function () {
	    function Provider() {
	        this.settings = {
	            locale: 'en',
	            format: 'L LTS',
	            minView: 'decade',
	            maxView: 'minute',
	            startView: 'year',
	            inline: false,
	            validate: true,
	            autoclose: true,
	            setOnSelect: false,
	            today: false,
	            keyboard: false,
	            showHeader: true,
	            leftArrow: '&larr;',
	            rightArrow: '&rarr;',
	            // Decade View
	            yearsFormat: 'YYYY',
	            // Year View
	            monthsFormat: 'MMM',
	            // Month View
	            daysFormat: 'D',
	            // Day View
	            hoursFormat: 'HH:[00]',
	            hoursStart: 0,
	            hoursEnd: 23,
	            // Hour View
	            minutesStep: 5,
	            minutesStart: 0,
	            minutesEnd: 59,
	            // Minute View
	            secondsFormat: 'ss',
	            secondsStep: 1,
	            secondsStart: 0,
	            secondsEnd: 59
	        };
	    }
	    Provider.prototype.options = function (options) {
	        angular.extend(this.settings, options);
	        return angular.copy(this.settings);
	    };
	    Provider.prototype.$get = function () {
	        return this.settings;
	    };
	    return Provider;
	}());
	exports["default"] = Provider;
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var utility_1 = __webpack_require__(0);
	var DayView = (function () {
	    function DayView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    DayView.prototype.render = function () {
	        var hour = this.$scope.view.moment.clone().startOf('day').hour(this.provider.hoursStart);
	        this.rows = {};
	        for (var h = 0; h <= this.provider.hoursEnd - this.provider.hoursStart; h++) {
	            var index = Math.floor(h / this.perLine), selectable = this.$scope.limits.isSelectable(hour, 'hour');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: h,
	                label: hour.format(this.provider.hoursFormat),
	                year: hour.year(),
	                month: hour.month(),
	                date: hour.date(),
	                hour: hour.hour(),
	                "class": [
	                    this.$scope.keyboard && hour.isSame(this.$scope.view.moment, 'hour') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && hour.isSame(this.$ctrl.$modelValue, 'hour') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            hour.add(1, 'hours');
	        }
	        // return title
	        return this.$scope.view.moment.format('LL');
	    };
	    DayView.prototype.set = function (hour) {
	        if (!hour.selectable)
	            return;
	        this.$scope.view.moment.year(hour.year).month(hour.month).date(hour.date).hour(hour.hour);
	        this.$scope.view.update();
	        this.$scope.view.change('hour');
	    };
	    return DayView;
	}());
	exports["default"] = DayView;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var utility_1 = __webpack_require__(0);
	var DecadeView = (function () {
	    function DecadeView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    DecadeView.prototype.render = function () {
	        var year = this.$scope.view.moment.clone(), firstYear = Math.floor(year.year() / 10) * 10 - 1;
	        this.rows = {};
	        year.year(firstYear);
	        for (var y = 0; y < 12; y++) {
	            var index = Math.floor(y / this.perLine), selectable = this.$scope.limits.isSelectable(year, 'year');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: year.year(),
	                label: year.format(this.provider.yearsFormat),
	                year: year.year(),
	                "class": [
	                    this.$scope.keyboard && year.isSame(this.$scope.view.moment, 'year') ? 'highlighted' : '',
	                    !selectable || [0, 11].indexOf(y) >= 0 ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && year.isSame(this.$ctrl.$modelValue, 'year') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            year.add(1, 'years');
	        }
	        // return title
	        return [year.subtract(2, 'years').format('YYYY'), year.subtract(9, 'years').format('YYYY')].reverse().join(' - ');
	    };
	    DecadeView.prototype.set = function (year) {
	        if (!year.selectable)
	            return;
	        this.$scope.view.moment.year(year.year);
	        this.$scope.view.update();
	        this.$scope.view.change('year');
	    };
	    return DecadeView;
	}());
	exports["default"] = DecadeView;
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var moment = __webpack_require__(2);
	var utility_1 = __webpack_require__(0);
	var HourView = (function () {
	    function HourView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    HourView.prototype.render = function () {
	        var i = 0, minute = this.$scope.view.moment.clone().startOf('hour').minute(this.provider.minutesStart), minutesFormat = this.provider.minutesFormat || moment.localeData(this.$scope.locale).longDateFormat('LT').replace(/[aA]/, '').trim();
	        this.rows = {};
	        for (var m = 0; m <= this.provider.minutesEnd - this.provider.minutesStart; m += this.provider.minutesStep) {
	            var index = Math.floor(i / this.perLine), selectable = this.$scope.limits.isSelectable(minute, 'minute');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: minute.minute(),
	                label: minute.format(minutesFormat),
	                year: minute.year(),
	                month: minute.month(),
	                date: minute.date(),
	                hour: minute.hour(),
	                minute: minute.minute(),
	                "class": [
	                    this.$scope.keyboard && minute.isSame(this.$scope.view.moment, 'minute') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && minute.isSame(this.$ctrl.$modelValue, 'minute') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            i++;
	            minute.add(this.provider.minutesStep, 'minutes');
	        }
	        if (this.$scope.keyboard)
	            this.highlightClosest();
	        // return title
	        return this.$scope.view.moment.clone().startOf('hour').format('lll');
	    };
	    HourView.prototype.set = function (minute) {
	        if (!minute.selectable)
	            return;
	        this.$scope.view.moment.year(minute.year).month(minute.month).date(minute.date).hour(minute.hour).minute(minute.minute);
	        this.$scope.view.update();
	        this.$scope.view.change('minute');
	    };
	    HourView.prototype.highlightClosest = function () {
	        var _this = this;
	        var minutes = [], minute;
	        angular.forEach(this.rows, function (row) {
	            angular.forEach(row, function (value) {
	                if (Math.abs(value.minute - _this.$scope.view.moment.minute()) < _this.provider.minutesStep)
	                    minutes.push(value);
	            });
	        });
	        minute = minutes.sort(function (value1, value2) {
	            return Math.abs(value1.minute - _this.$scope.view.moment.minute()) > Math.abs(value2.minute - _this.$scope.view.moment.minute()) ? 1 : 0;
	        })[0];
	        if (!minute || minute.minute - this.$scope.view.moment.minute() == 0)
	            return;
	        this.$scope.view.moment.year(minute.year).month(minute.month).date(minute.date).hour(minute.hour).minute(minute.minute);
	        this.$scope.view.update();
	        if (minute.selectable)
	            minute["class"] = (minute["class"] + ' highlighted').trim();
	    };
	    return HourView;
	}());
	exports["default"] = HourView;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var decadeView_1 = __webpack_require__(11);
	exports.DecadeView = decadeView_1["default"];
	var yearView_1 = __webpack_require__(16);
	exports.YearView = yearView_1["default"];
	var monthView_1 = __webpack_require__(15);
	exports.MonthView = monthView_1["default"];
	var dayView_1 = __webpack_require__(10);
	exports.DayView = dayView_1["default"];
	var hourView_1 = __webpack_require__(12);
	exports.HourView = hourView_1["default"];
	var minuteView_1 = __webpack_require__(14);
	exports.MinuteView = minuteView_1["default"];
	
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var utility_1 = __webpack_require__(0);
	var MinuteView = (function () {
	    function MinuteView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 6;
	        this.rows = {};
	    }
	    MinuteView.prototype.render = function () {
	        var i = 0, second = this.$scope.view.moment.clone().startOf('minute').second(this.provider.secondsStart);
	        this.rows = {};
	        for (var s = 0; s <= this.provider.secondsEnd - this.provider.secondsStart; s += this.provider.secondsStep) {
	            var index = Math.floor(i / this.perLine), selectable = this.$scope.limits.isSelectable(second, 'second');
	            if (!this.rows[index])
	                this.rows[index] = [];
	            this.rows[index].push({
	                index: second.second(),
	                label: second.format(this.provider.secondsFormat),
	                year: second.year(),
	                month: second.month(),
	                date: second.date(),
	                hour: second.hour(),
	                minute: second.minute(),
	                second: second.second(),
	                "class": [
	                    this.$scope.keyboard && second.isSame(this.$scope.view.moment, 'second') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(this.$ctrl.$modelValue) && second.isSame(this.$ctrl.$modelValue, 'second') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            i++;
	            second.add(this.provider.secondsStep, 'seconds');
	        }
	        if (this.$scope.keyboard)
	            this.highlightClosest();
	        // return title
	        return this.$scope.view.moment.clone().startOf('minute').format('lll');
	    };
	    MinuteView.prototype.set = function (second) {
	        if (!second.selectable)
	            return;
	        this.$scope.view.moment.year(second.year).month(second.month).date(second.date).hour(second.hour).minute(second.minute).second(second.second);
	        this.$scope.view.update();
	        this.$scope.view.change();
	    };
	    MinuteView.prototype.highlightClosest = function () {
	        var _this = this;
	        var seconds = [], second;
	        angular.forEach(this.rows, function (row) {
	            angular.forEach(row, function (value) {
	                if (Math.abs(value.second - _this.$scope.view.moment.second()) < _this.provider.secondsStep)
	                    seconds.push(value);
	            });
	        });
	        second = seconds.sort(function (value1, value2) {
	            return Math.abs(value1.second - _this.$scope.view.moment.second()) > Math.abs(value2.second - _this.$scope.view.moment.second()) ? 1 : 0;
	        })[0];
	        if (!second || second.second - this.$scope.view.moment.second() == 0)
	            return;
	        this.$scope.view.moment.year(second.year).month(second.month).date(second.date).hour(second.hour).minute(second.minute).second(second.second);
	        this.$scope.view.update();
	        if (second.selectable)
	            second["class"] = (second["class"] + ' highlighted').trim();
	    };
	    return MinuteView;
	}());
	exports["default"] = MinuteView;
	
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var angular = __webpack_require__(1);
	var moment = __webpack_require__(2);
	var utility_1 = __webpack_require__(0);
	var MonthView = (function () {
	    function MonthView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = moment.weekdays().length;
	        this.rows = [];
	    }
	    MonthView.prototype.render = function () {
	        var _this = this;
	        var month = this.$scope.view.moment.month(), day = this.$scope.view.moment.clone().startOf('month').startOf('week').hour(12), rows = {}, firstWeek = day.week(), lastWeek = firstWeek + 5;
	        this.rows = [];
	        for (var week = firstWeek; week <= lastWeek; week++)
	            rows[week] = Array.apply(null, Array(this.perLine)).map(function () {
	                var selectable = _this.$scope.limits.isSelectable(day, 'day');
	                var date = {
	                    index: day.date(),
	                    label: day.format(_this.provider.daysFormat),
	                    year: day.year(),
	                    month: day.month(),
	                    date: day.date(),
	                    "class": [
	                        _this.$scope.keyboard && day.isSame(_this.$scope.view.moment, 'day') ? 'highlighted' : '',
	                        !!_this.$scope.today && day.isSame(new Date(), 'day') ? 'today' : '',
	                        !selectable || day.month() != month ? 'disabled' : utility_1.isValidMoment(_this.$ctrl.$modelValue) && day.isSame(_this.$ctrl.$modelValue, 'day') ? 'selected' : ''
	                    ].join(' ').trim(),
	                    selectable: selectable
	                };
	                day.add(1, 'days');
	                return date;
	            });
	        // object to array - see https://github.com/indrimuska/angular-moment-picker/issues/9
	        angular.forEach(rows, function (row) { return _this.rows.push(row); });
	        // render headers
	        this.headers = moment.weekdays().map(function (d, i) { return moment().locale(_this.$scope.locale).startOf('week').add(i, 'day').format('dd'); });
	        // return title
	        return this.$scope.view.moment.format('MMMM YYYY');
	    };
	    MonthView.prototype.set = function (day) {
	        if (!day.selectable)
	            return;
	        this.$scope.view.moment.year(day.year).month(day.month).date(day.date);
	        this.$scope.view.update();
	        this.$scope.view.change('day');
	    };
	    return MonthView;
	}());
	exports["default"] = MonthView;
	
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	exports.__esModule = true;
	var moment = __webpack_require__(2);
	var utility_1 = __webpack_require__(0);
	var YearView = (function () {
	    function YearView($scope, $ctrl, provider) {
	        this.$scope = $scope;
	        this.$ctrl = $ctrl;
	        this.provider = provider;
	        this.perLine = 4;
	        this.rows = {};
	    }
	    YearView.prototype.render = function () {
	        var _this = this;
	        var month = this.$scope.view.moment.clone().startOf('year'), months = moment.monthsShort();
	        this.rows = {};
	        months.forEach(function (label, i) {
	            var index = Math.floor(i / _this.perLine), selectable = _this.$scope.limits.isSelectable(month, 'month');
	            if (!_this.rows[index])
	                _this.rows[index] = [];
	            _this.rows[index].push({
	                index: month.month(),
	                label: month.format(_this.provider.monthsFormat),
	                year: month.year(),
	                month: month.month(),
	                "class": [
	                    _this.$scope.keyboard && month.isSame(_this.$scope.view.moment, 'month') ? 'highlighted' : '',
	                    !selectable ? 'disabled' : utility_1.isValidMoment(_this.$ctrl.$modelValue) && month.isSame(_this.$ctrl.$modelValue, 'month') ? 'selected' : ''
	                ].join(' ').trim(),
	                selectable: selectable
	            });
	            month.add(1, 'months');
	        });
	        // return title
	        return this.$scope.view.moment.format('YYYY');
	    };
	    YearView.prototype.set = function (month) {
	        if (!month.selectable)
	            return;
	        this.$scope.view.moment.year(month.year).month(month.month);
	        this.$scope.view.update();
	        this.$scope.view.change('month');
	    };
	    return YearView;
	}());
	exports["default"] = YearView;
	
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	__webpack_require__(5);
	__webpack_require__(3);
	module.exports = __webpack_require__(4);
	
	
	/***/ })
	/******/ ]);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1359)))

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1361)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1360)(module)))

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 1361 */,
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1359)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1490);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./angular-moment-picker.min.css", function() {
				var newContent = require("!!../../css-loader/index.js!./angular-moment-picker.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! Angular Moment Picker - v0.10.2 - http://indrimuska.github.io/angular-moment-picker - (c) 2015 Indri Muska - MIT */.moment-picker-input{cursor:pointer}.moment-picker{position:absolute;z-index:1060}.moment-picker .moment-picker-container{color:#404040;min-width:15em;background:#fff;padding:4px;border:1px solid #f0f3f4;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;position:absolute;margin-top:4px;margin-left:-.5em;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.075);-moz-box-shadow:0 2px 4px rgba(0,0,0,.075);box-shadow:0 2px 4px rgba(0,0,0,.075)}.moment-picker .moment-picker-container:after,.moment-picker .moment-picker-container:before{content:\"\";display:block;width:0;height:0;border:8px solid transparent;border-top:none;position:absolute;top:-9px;left:15px}.moment-picker .moment-picker-container:before{border-bottom-color:#f0f3f4;border-width:9px}.moment-picker .moment-picker-container:after{border-bottom-color:#fff;margin-top:1px;margin-left:1px}.moment-picker.inline{display:block;position:relative}.moment-picker.inline .moment-picker-container{position:relative;margin:0}.moment-picker.inline .moment-picker-container:after,.moment-picker.inline .moment-picker-container:before{content:none}.moment-picker.top .moment-picker-container{bottom:100%;margin-top:auto;margin-bottom:4px}.moment-picker.top .moment-picker-container:after,.moment-picker.top .moment-picker-container:before{border:8px solid transparent;border-bottom:none;top:auto;bottom:-9px}.moment-picker.top .moment-picker-container:before{border-top-color:#f0f3f4;border-width:9px}.moment-picker.top .moment-picker-container:after{border-top-color:#fff;margin-top:auto;margin-bottom:1px}.moment-picker.right .moment-picker-container{right:0;margin-left:auto;margin-right:-.5em}.moment-picker.right .moment-picker-container:after,.moment-picker.right .moment-picker-container:before{left:auto;right:15px}.moment-picker.right .moment-picker-container:after{margin-left:auto;margin-right:1px}.moment-picker table{border-collapse:collapse;border-spacing:0;min-width:100%;table-layout:fixed}.moment-picker th{font-weight:700}.moment-picker th:first-child,.moment-picker th:last-child{width:2em}.moment-picker td,.moment-picker th{padding:0;text-align:center;min-width:2em;height:2em;text-shadow:0 1px 0 hsla(0,0%,100%,.9);cursor:pointer;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px}.moment-picker td:hover,.moment-picker th:hover{background-color:#fafbfb;background-image:-webkit-gradient(linear,left top,left bottom,from(#f0f3f4),to(#fafbfb));background-image:-webkit-linear-gradient(#f0f3f4,#fafbfb);background-image:-moz-linear-gradient(#f0f3f4,#fafbfb);background-image:-o-linear-gradient(#f0f3f4,#fafbfb);background-image:linear-gradient(#f0f3f4,#fafbfb)}.moment-picker td.disabled,.moment-picker td.disabled:hover,.moment-picker th.disabled,.moment-picker th.disabled:hover{color:#abbbc7;background:none;cursor:default}.moment-picker td.today{background:#e4eef5;color:#404040;text-shadow:0 1px 0 hsla(0,0%,100%,.9)}.moment-picker td.selected{color:#fff;text-shadow:0 -1px 0 rgba(0,0,0,.3);border-color:#3ca0dd;background-color:#45b1e8;background-image:-webkit-gradient(linear,left top,left bottom,from(#45b1e8),to(#3097de));background-image:-webkit-linear-gradient(#45b1e8,#3097de);background-image:-moz-linear-gradient(#45b1e8,#3097de);background-image:-o-linear-gradient(#45b1e8,#3097de);background-image:linear-gradient(#45b1e8,#3097de)}.moment-picker td.highlighted{background-image:-webkit-radial-gradient(transparent,rgba(0,0,0,.15));background-image:-moz-radial-gradient(transparent,rgba(0,0,0,.15));background-image:-o-radial-gradient(transparent,rgba(0,0,0,.15));background-image:radial-gradient(transparent,rgba(0,0,0,.15))}.moment-picker .decade-view td,.moment-picker .year-view td{height:3.4em}.moment-picker .month-view .moment-picker-specific-views th{background:none;cursor:default}.moment-picker .month-view td{width:1.42857143em}.moment-picker .day-view td,.moment-picker .hour-view td{height:2.33333333em}.moment-picker .minute-view td{height:1.8em}", ""]);
	
	// exports


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* angular-moment.js / v1.3.0 / (c) 2013, 2014, 2015, 2016, 2017, 2018 Uri Shaked / MIT Licence */
	
	'format amd';
	/* global define */
	
	(function () {
		'use strict';
	
		function isUndefinedOrNull(val) {
			return angular.isUndefined(val) || val === null;
		}
	
		function requireMoment() {
			try {
				return __webpack_require__(1359); // Using nw.js or browserify?
			} catch (e) {
				throw new Error('Please install moment via npm. Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
			}
		}
	
		function angularMoment(angular, moment) {
	
			if(typeof moment === 'undefined') {
				if(true) {
					moment = requireMoment();
				}else{
					throw new Error('Moment cannot be found by angular-moment! Please reference to: https://github.com/urish/angular-moment'); // Add wiki/troubleshooting section?
				}
			}
	
			/**
			 * @ngdoc overview
			 * @name angularMoment
			 *
			 * @description
			 * angularMoment module provides moment.js functionality for angular.js apps.
			 */
			angular.module('angularMoment', [])
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:angularMomentConfig
			 *
			 * @description
			 * Common configuration of the angularMoment module
			 */
				.constant('angularMomentConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#preprocess
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {function} A preprocessor function that will be applied on all incoming dates
					 *
					 * @description
					 * Defines a preprocessor function to apply on all input dates (e.g. the input of `am-time-ago`,
					 * `amCalendar`, etc.). The function must return a `moment` object.
					 *
					 * @example
					 *   // Causes angular-moment to always treat the input values as unix timestamps
					 *   angularMomentConfig.preprocess = function(value) {
					 * 	   return moment.unix(value);
					 *   }
					 */
					preprocess: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#timezone
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The default timezone
					 *
					 * @description
					 * The default timezone (e.g. 'Europe/London'). Empty string by default (does not apply
					 * any timezone shift).
					 *
					 * NOTE: This option requires moment-timezone >= 0.3.0.
					 */
					timezone: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#format
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {string} The pre-conversion format of the date
					 *
					 * @description
					 * Specify the format of the input date. Essentially it's a
					 * default and saves you from specifying a format in every
					 * element. Overridden by element attr. Null by default.
					 */
					format: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.angularMomentConfig#statefulFilters
					 * @propertyOf angularMoment.config:angularMomentConfig
					 * @returns {boolean} Whether angular-moment filters should be stateless (or not)
					 *
					 * @description
					 * Specifies whether the filters included with angular-moment are stateful.
					 * Stateful filters will automatically re-evaluate whenever you change the timezone
					 * or locale settings, but may negatively impact performance. true by default.
					 */
					statefulFilters: true
				})
	
			/**
			 * @ngdoc object
			 * @name angularMoment.object:moment
			 *
			 * @description
			 * moment global (as provided by the moment.js library)
			 */
				.constant('moment', moment)
	
			/**
			 * @ngdoc object
			 * @name angularMoment.config:amTimeAgoConfig
			 * @module angularMoment
			 *
			 * @description
			 * configuration specific to the amTimeAgo directive
			 */
				.constant('amTimeAgoConfig', {
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#withoutSuffix
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {boolean} Whether to include a suffix in am-time-ago directive
					 *
					 * @description
					 * Defaults to false.
					 */
					withoutSuffix: false,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#serverTime
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} Server time in milliseconds since the epoch
					 *
					 * @description
					 * If set, time ago will be calculated relative to the given value.
					 * If null, local time will be used. Defaults to null.
					 */
					serverTime: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#titleFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format of the date to be displayed in the title of the element. If null,
					 *        the directive set the title of the element.
					 *
					 * @description
					 * The format of the date used for the title of the element. null by default.
					 */
					titleFormat: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateThreshold
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {number} The minimum number of days for showing a full date instead of relative time
					 *
					 * @description
					 * The threshold for displaying a full date. The default is null, which means the date will always
					 * be relative, and full date will never be displayed.
					 */
					fullDateThreshold: null,
	
					/**
					 * @ngdoc property
					 * @name angularMoment.config.amTimeAgoConfig#fullDateFormat
					 * @propertyOf angularMoment.config:amTimeAgoConfig
					 * @returns {string} The format to use when displaying a full date.
					 *
					 * @description
					 * Specify the format of the date when displayed as full date. null by default.
					 */
					fullDateFormat: null,
	
					fullDateThresholdUnit: 'day'
				})
	
			/**
			 * @ngdoc directive
			 * @name angularMoment.directive:amTimeAgo
			 * @module angularMoment
			 *
			 * @restrict A
			 */
				.directive('amTimeAgo', ['$window', 'moment', 'amMoment', 'amTimeAgoConfig', function ($window, moment, amMoment, amTimeAgoConfig) {
	
					return function (scope, element, attr) {
						var activeTimeout = null;
						var currentValue;
						var withoutSuffix = amTimeAgoConfig.withoutSuffix;
						var titleFormat = amTimeAgoConfig.titleFormat;
						var fullDateThreshold = amTimeAgoConfig.fullDateThreshold;
						var fullDateFormat = amTimeAgoConfig.fullDateFormat;
						var fullDateThresholdUnit = amTimeAgoConfig.fullDateThresholdUnit;
	
						var localDate = new Date().getTime();
						var modelName = attr.amTimeAgo;
						var currentFrom;
						var isTimeElement = ('TIME' === element[0].nodeName.toUpperCase());
						var setTitleTime = !element.attr('title');
	
						function getNow() {
							var now;
							if (currentFrom) {
								now = currentFrom;
							} else if (amTimeAgoConfig.serverTime) {
								var localNow = new Date().getTime();
								var nowMillis = localNow - localDate + amTimeAgoConfig.serverTime;
								now = moment(nowMillis);
							}
							else {
								now = moment();
							}
							return now;
						}
	
						function cancelTimer() {
							if (activeTimeout) {
								$window.clearTimeout(activeTimeout);
								activeTimeout = null;
							}
						}
	
						function updateTime(momentInstance) {
							var timeAgo = getNow().diff(momentInstance, fullDateThresholdUnit);
							var showFullDate = fullDateThreshold && timeAgo >= fullDateThreshold;
	
							if (showFullDate) {
								element.text(momentInstance.format(fullDateFormat));
							} else {
								element.text(momentInstance.from(getNow(), withoutSuffix));
							}
	
							if (titleFormat && setTitleTime) {
								element.attr('title', momentInstance.format(titleFormat));
							}
	
							if (!showFullDate) {
								var howOld = Math.abs(getNow().diff(momentInstance, 'minute'));
								var secondsUntilUpdate = 3600;
								if (howOld < 1) {
									secondsUntilUpdate = 1;
								} else if (howOld < 60) {
									secondsUntilUpdate = 30;
								} else if (howOld < 180) {
									secondsUntilUpdate = 300;
								}
	
								activeTimeout = $window.setTimeout(function () {
									updateTime(momentInstance);
								}, secondsUntilUpdate * 1000);
							}
						}
	
						function updateDateTimeAttr(value) {
							if (isTimeElement) {
								element.attr('datetime', value);
							}
						}
	
						function updateMoment() {
							cancelTimer();
							if (currentValue) {
								var momentValue = amMoment.preprocessDate(currentValue);
								updateTime(momentValue);
								updateDateTimeAttr(momentValue.toISOString());
							}
						}
	
						scope.$watch(modelName, function (value) {
							if (isUndefinedOrNull(value) || (value === '')) {
								cancelTimer();
								if (currentValue) {
									element.text('');
									updateDateTimeAttr('');
									currentValue = null;
								}
								return;
							}
	
							currentValue = value;
							updateMoment();
						});
	
						if (angular.isDefined(attr.amFrom)) {
							scope.$watch(attr.amFrom, function (value) {
								if (isUndefinedOrNull(value) || (value === '')) {
									currentFrom = null;
								} else {
									currentFrom = moment(value);
								}
								updateMoment();
							});
						}
	
						if (angular.isDefined(attr.amWithoutSuffix)) {
							scope.$watch(attr.amWithoutSuffix, function (value) {
								if (typeof value === 'boolean') {
									withoutSuffix = value;
									updateMoment();
								} else {
									withoutSuffix = amTimeAgoConfig.withoutSuffix;
								}
							});
						}
	
						attr.$observe('amFullDateThreshold', function (newValue) {
							fullDateThreshold = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateFormat', function (newValue) {
							fullDateFormat = newValue;
							updateMoment();
						});
	
						attr.$observe('amFullDateThresholdUnit', function (newValue) {
							fullDateThresholdUnit = newValue;
							updateMoment();
						});
	
						scope.$on('$destroy', function () {
							cancelTimer();
						});
	
						scope.$on('amMoment:localeChanged', function () {
							updateMoment();
						});
					};
				}])
	
			/**
			 * @ngdoc service
			 * @name angularMoment.service.amMoment
			 * @module angularMoment
			 */
				.service('amMoment', ['moment', '$rootScope', '$log', 'angularMomentConfig', function (moment, $rootScope, $log, angularMomentConfig) {
					var defaultTimezone = null;
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeLocale
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the locale for moment.js and updates all the am-time-ago directive instances
					 * with the new locale. Also broadcasts an `amMoment:localeChanged` event on $rootScope.
					 *
					 * @param {string} locale Locale code (e.g. en, es, ru, pt-br, etc.)
					 * @param {object} customization object of locale strings to override
					 */
					this.changeLocale = function (locale, customization) {
						var result = moment.locale(locale, customization);
						if (angular.isDefined(locale)) {
							$rootScope.$broadcast('amMoment:localeChanged');
	
						}
						return result;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#changeTimezone
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Changes the default timezone for amCalendar, amDateFormat and amTimeAgo. Also broadcasts an
					 * `amMoment:timezoneChanged` event on $rootScope.
					 *
					 * Note: this method works only if moment-timezone > 0.3.0 is loaded
					 *
					 * @param {string} timezone Timezone name (e.g. UTC)
					 */
					this.changeTimezone = function (timezone) {
						if (moment.tz && moment.tz.setDefault) {
							moment.tz.setDefault(timezone);
							$rootScope.$broadcast('amMoment:timezoneChanged');
						} else {
							$log.warn('angular-moment: changeTimezone() works only with moment-timezone.js v0.3.0 or greater.');
						}
						angularMomentConfig.timezone = timezone;
						defaultTimezone = timezone;
					};
	
					/**
					 * @ngdoc function
					 * @name angularMoment.service.amMoment#preprocessDate
					 * @methodOf angularMoment.service.amMoment
					 *
					 * @description
					 * Preprocess a given value and convert it into a Moment instance appropriate for use in the
					 * am-time-ago directive and the filters. The behavior of this function can be overriden by
					 * setting `angularMomentConfig.preprocess`.
					 *
					 * @param {*} value The value to be preprocessed
					 * @return {Moment} A `moment` object
					 */
					this.preprocessDate = function (value) {
						// Configure the default timezone if needed
						if (defaultTimezone !== angularMomentConfig.timezone) {
							this.changeTimezone(angularMomentConfig.timezone);
						}
	
						if (angularMomentConfig.preprocess) {
							return angularMomentConfig.preprocess(value);
						}
	
						if (!isNaN(parseFloat(value)) && isFinite(value)) {
							// Milliseconds since the epoch
							return moment(parseInt(value, 10));
						}
	
						// else just returns the value as-is.
						return moment(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amParse
			 * @module angularMoment
			 */
				.filter('amParse', ['moment', function (moment) {
					return function (value, format) {
						return moment(value, format);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amFromUnix
			 * @module angularMoment
			 */
				.filter('amFromUnix', ['moment', function (moment) {
					return function (value) {
						return moment.unix(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtc
			 * @module angularMoment
			 */
				.filter('amUtc', ['moment', function (moment) {
					return function (value) {
						return moment.utc(value);
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amUtcOffset
			 * @module angularMoment
			 *
			 * @description
			 * Adds a UTC offset to the given timezone object. The offset can be a number of minutes, or a string such as
			 * '+0300', '-0300' or 'Z'.
			 */
				.filter('amUtcOffset', ['amMoment', function (amMoment) {
					function amUtcOffset(value, offset) {
						return amMoment.preprocessDate(value).utcOffset(offset);
					}
	
					return amUtcOffset;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amLocal
			 * @module angularMoment
			 */
				.filter('amLocal', ['moment', function (moment) {
					return function (value) {
						return moment.isMoment(value) ? value.local() : null;
					};
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimezone
			 * @module angularMoment
			 *
			 * @description
			 * Apply a timezone onto a given moment object, e.g. 'America/Phoenix').
			 *
			 * You need to include moment-timezone.js for timezone support.
			 */
				.filter('amTimezone', ['amMoment', 'angularMomentConfig', '$log', function (amMoment, angularMomentConfig, $log) {
					function amTimezone(value, timezone) {
						var aMoment = amMoment.preprocessDate(value);
	
						if (!timezone) {
							return aMoment;
						}
	
						if (aMoment.tz) {
							return aMoment.tz(timezone);
						} else {
							$log.warn('angular-moment: named timezone specified but moment.tz() is undefined. Did you forget to include moment-timezone.js ?');
							return aMoment;
						}
					}
	
					return amTimezone;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amCalendar
			 * @module angularMoment
			 */
				.filter('amCalendar', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amCalendarFilter(value, referenceTime, formats) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						return date.isValid() ? date.calendar(referenceTime, formats) : '';
					}
	
					// Since AngularJS 1.3, filters have to explicitly define being stateful
					// (this is no longer the default).
					amCalendarFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amCalendarFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDifference
			 * @module angularMoment
			 */
				.filter('amDifference', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDifferenceFilter(value, otherValue, unit, usePrecision) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						var date2 = !isUndefinedOrNull(otherValue) ? amMoment.preprocessDate(otherValue) : moment();
	
						if (!date.isValid() || !date2.isValid()) {
							return '';
						}
	
						return date.diff(date2, unit, usePrecision);
					}
	
					amDifferenceFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDifferenceFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDateFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDateFormat', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amDateFormatFilter(value, format) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						var date = amMoment.preprocessDate(value);
						if (!date.isValid()) {
							return '';
						}
	
						return date.format(format);
					}
	
					amDateFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDateFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amDurationFormat
			 * @module angularMoment
			 * @function
			 */
				.filter('amDurationFormat', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amDurationFormatFilter(value, format, suffix) {
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment.duration(value, format).humanize(suffix);
					}
	
					amDurationFormatFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amDurationFormatFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amTimeAgo
			 * @module angularMoment
			 * @function
			 */
				.filter('amTimeAgo', ['moment', 'amMoment', 'angularMomentConfig', function (moment, amMoment, angularMomentConfig) {
					function amTimeAgoFilter(value, suffix, from) {
						var date, dateFrom;
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						value = amMoment.preprocessDate(value);
						date = moment(value);
						if (!date.isValid()) {
							return '';
						}
	
						dateFrom = moment(from);
						if (!isUndefinedOrNull(from) && dateFrom.isValid()) {
							return date.from(dateFrom, suffix);
						}
	
						return date.fromNow(suffix);
					}
	
					amTimeAgoFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amTimeAgoFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amSubtract
			 * @module angularMoment
			 * @function
			 */
				.filter('amSubtract', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amSubtractFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).subtract(parseInt(amount, 10), type);
					}
	
					amSubtractFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amSubtractFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amAdd
			 * @module angularMoment
			 * @function
			 */
				.filter('amAdd', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amAddFilter(value, amount, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).add(parseInt(amount, 10), type);
					}
	
					amAddFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amAddFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amStartOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amStartOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amStartOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).startOf(type);
					}
	
					amStartOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amStartOfFilter;
				}])
	
			/**
			 * @ngdoc filter
			 * @name angularMoment.filter:amEndOf
			 * @module angularMoment
			 * @function
			 */
				.filter('amEndOf', ['moment', 'angularMomentConfig', function (moment, angularMomentConfig) {
					function amEndOfFilter(value, type) {
	
						if (isUndefinedOrNull(value)) {
							return '';
						}
	
						return moment(value).endOf(type);
					}
	
					amEndOfFilter.$stateful = angularMomentConfig.statefulFilters;
	
					return amEndOfFilter;
	 			}]);
	
			return 'angularMoment';
		}
	
		var isElectron = window && window.process && window.process.type;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(369), __webpack_require__(1359)], __WEBPACK_AMD_DEFINE_FACTORY__ = (angularMoment), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module && module.exports && (typeof require === 'function') && !isElectron) {
			module.exports = angularMoment(require('angular'), require('moment'));
		} else {
			angularMoment(angular, (typeof global !== 'undefined' && typeof global.moment !== 'undefined' ? global : window).moment);
		}
	})();


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1493);
	moment.tz.load(__webpack_require__(1494));


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.25
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(1359)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1359)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.25",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
			
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
		
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	module.exports = {"version":"2019a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQob.c ME01.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 gj9y0|32e5","Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4","Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|LMT CST CDT CWT CPT EST|66.s 60 50 50 50 50|01212345|-32B5R.w UFdR.w 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|LMT AST ADT AWT APT|3M.s 40 30 30 30|0121341|-3tokb.w 1nsqb.w 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 2en0|90e5","America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5","America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|LMT MST PST|7K.4 70 80|0121|-3togd.U 1jInd.U 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT|9h.E 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|012323232323232323232323232323232323232323232323232323232323232323232323232343232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121212121565652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5","America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|LMT EST EDT EWT EPT|5R.4 50 40 40 40|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B66.U UFd6.U 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5","America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.K 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.6 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|LMT CST CDT CWT CPT|6i.g 60 50 50 50|0121234121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B5F.I UFdF.I 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|LMT SMT -05 -04 -03|4G.K 4G.K 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.e MJc0 fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452","America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|LMT CST EST EWT EPT EDT|5V 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-32B63 Avc3 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT|90.c 90 80 80 80 70 80 70|01212134151676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|-00 AEST AEDT +11|0 -a0 -b0 -b0|01210121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-2OPc0 Fb40 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|LMT CET CEST|-H -10 -20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32BcH Q4oH Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|LMT CST CDT|-85.H -80 -90|0121212121212121212121212121|-2M0U5.H 1zWo5.H Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azch.Q 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azck.n 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taOu Hbu xUu 94nu 1qsu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1nX0 11B0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|LMT IMT EET EEST +04 +03|-1T.Q -1U.U -20 -30 -40 -30|0123232323232323232323232323232323232323232323232323232345454545453232323232323232323232323232323232323232323232323232323232323235|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|0123232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6K.K -6T.p -70 -7k -7u -90 -80|01234546|-2M0SK.K aILP.l 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Singapore|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so1u|56e5","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30","Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlA5.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry0d.8 xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|LMT AEST AEDT|-9z.s -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109z.s Pk1z.s 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1zv xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PknP.s xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U RxXU.U xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlzE.Q xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PknI.o xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","Europe/Dublin|LMT DMT IST GMT BST IST|p p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHbz 1ra20.l Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Etc/GMT-10|+10|-a0|0|","Etc/GMT-11|+11|-b0|0|","Etc/GMT-12|+12|-c0|0|","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Etc/GMT-7|+07|-70|0|","Etc/GMT-8|+08|-80|0|","Etc/GMT-9|+09|-90|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+2|-02|20|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|LMT AMT NST +0120 +0020 CEST CET|-j.w -j.w -1j.w -1k -k -20 -10|0121212121212121212121212121212121212121212123434345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-5sHcj.w 3i200 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5","Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5","Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1M0 SNMh.u 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cWpg.k 12hbg.k 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|LMT CMT CET CEST|-O.k -O.k -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLAO.k 9Io0 SryO.k Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|LMT CET CEST CET CEST MSK MSD EEST EET +03|-1m -10 -20 -20 -30 -30 -40 -30 -20 -30|01212121212121343565656565656565657878787878787878787878787878787878787878787898|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5","Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|LMT PMT WET WEST WEMT CET CEST|-t.w -9.l 0 -10 -20 -10 -20|012323232323232323232323232323232323232323232323232343434343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3bQot.w ME0k.b cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQo8.l ME00 cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6","Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4","Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4bsoN.U 160LN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|LMT SET CET CEST|-1c.c -10.e -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3FyNc.c P80b.W DPb0.e TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|LMT CET CEST MSK MSD EET EEST|-1t.c -10 -20 -30 -40 -20 -30|0121212134343434343434343431565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3cWpt.c 20vCt.c 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5","Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|LMT +0220 EET MSK CEST CET MSD EEST|-2k.E -2k -20 -30 -20 -10 -40 -30|012345453636363636363636363637272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8Ok.E 1LUM0.E eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Christmas|LMT +07|-72.Q -70|01|-32oT2.Q|21e2","Indian/Cocos|LMT +0630|-6r.E -6u|01|-2OqSr.E|596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4","Pacific/Chuuk|LMT LMT +10 +09|dQ.Q -a7.8 -a0 -90|0123232|-54ma7.8 2glc0 xso7.8 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|LMT -12 -11 +13|bo.k c0 b0 -d0|0123|-2M0Az.E 3bIMz.E B7X0|1","Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0|88e4","Pacific/Funafuti|LMT +12|-bU.Q -c0|01|-2M0XU.Q|45e2","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2","Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|LMT +11 +09 +10 +12|-bo.M -b0 -90 -a0 -c0|01213214|-2M0Xo.M xsoo.M axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -1130 -11|bj.E bk bu b0|0123|-2M0AE.k 21IM0.k 17y0a|12e2","Pacific/Norfolk|LMT +1112 +1130 +1230 +11|-bb.Q -bc -bu -cu -b0|012324|-2M0Xb.Q 21ILX.Q W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3","Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56","Pacific/Pohnpei|LMT LMT +11 +09 +10|dr.8 -aw.Q -b0 -90 -a0|01232432|-54maw.Q 2glc0 xsnw.Q axC0 HBy0 akp0 axd0|34e3","Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-2M0Bk.U 39zzO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.k -ck -d0 -e0|01232323232|-2M10j.k 1BnXX.k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","Pacific/Wake|LMT +12|-b6.s -c0|01|-2M0X6.s|16e3","Pacific/Wallis|LMT +12|-cf.k -c0|01|-2M10f.k|94","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Singapore|Singapore","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 angular-file-upload v2.5.0
	 https://github.com/nervgh/angular-file-upload
	*/
	
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["angular-file-upload"] = factory();
		else
			root["angular-file-upload"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		var _options = __webpack_require__(2);
		
		var _options2 = _interopRequireDefault(_options);
		
		var _FileUploader = __webpack_require__(3);
		
		var _FileUploader2 = _interopRequireDefault(_FileUploader);
		
		var _FileLikeObject = __webpack_require__(4);
		
		var _FileLikeObject2 = _interopRequireDefault(_FileLikeObject);
		
		var _FileItem = __webpack_require__(5);
		
		var _FileItem2 = _interopRequireDefault(_FileItem);
		
		var _FileDirective = __webpack_require__(6);
		
		var _FileDirective2 = _interopRequireDefault(_FileDirective);
		
		var _FileSelect = __webpack_require__(7);
		
		var _FileSelect2 = _interopRequireDefault(_FileSelect);
		
		var _Pipeline = __webpack_require__(8);
		
		var _Pipeline2 = _interopRequireDefault(_Pipeline);
		
		var _FileDrop = __webpack_require__(9);
		
		var _FileDrop2 = _interopRequireDefault(_FileDrop);
		
		var _FileOver = __webpack_require__(10);
		
		var _FileOver2 = _interopRequireDefault(_FileOver);
		
		var _FileSelect3 = __webpack_require__(11);
		
		var _FileSelect4 = _interopRequireDefault(_FileSelect3);
		
		var _FileDrop3 = __webpack_require__(12);
		
		var _FileDrop4 = _interopRequireDefault(_FileDrop3);
		
		var _FileOver3 = __webpack_require__(13);
		
		var _FileOver4 = _interopRequireDefault(_FileOver3);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		angular.module(_config2.default.name, []).value('fileUploaderOptions', _options2.default).factory('FileUploader', _FileUploader2.default).factory('FileLikeObject', _FileLikeObject2.default).factory('FileItem', _FileItem2.default).factory('FileDirective', _FileDirective2.default).factory('FileSelect', _FileSelect2.default).factory('FileDrop', _FileDrop2.default).factory('FileOver', _FileOver2.default).factory('Pipeline', _Pipeline2.default).directive('nvFileSelect', _FileSelect4.default).directive('nvFileDrop', _FileDrop4.default).directive('nvFileOver', _FileOver4.default).run(['FileUploader', 'FileLikeObject', 'FileItem', 'FileDirective', 'FileSelect', 'FileDrop', 'FileOver', 'Pipeline', function (FileUploader, FileLikeObject, FileItem, FileDirective, FileSelect, FileDrop, FileOver, Pipeline) {
		    // only for compatibility
		    FileUploader.FileLikeObject = FileLikeObject;
		    FileUploader.FileItem = FileItem;
		    FileUploader.FileDirective = FileDirective;
		    FileUploader.FileSelect = FileSelect;
		    FileUploader.FileDrop = FileDrop;
		    FileUploader.FileOver = FileOver;
		    FileUploader.Pipeline = Pipeline;
		}]);
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = {
			"name": "angularFileUpload"
		};
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = {
		    url: '/',
		    alias: 'file',
		    headers: {},
		    queue: [],
		    progress: 0,
		    autoUpload: false,
		    removeAfterUpload: false,
		    method: 'POST',
		    filters: [],
		    formData: [],
		    queueLimit: Number.MAX_VALUE,
		    withCredentials: false,
		    disableMultipart: false
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		
		var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
		
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var bind = _angular.bind;
		var copy = _angular.copy;
		var extend = _angular.extend;
		var forEach = _angular.forEach;
		var isObject = _angular.isObject;
		var isNumber = _angular.isNumber;
		var isDefined = _angular.isDefined;
		var isArray = _angular.isArray;
		var isUndefined = _angular.isUndefined;
		var element = _angular.element;
		function __identity(fileUploaderOptions, $rootScope, $http, $window, $timeout, FileLikeObject, FileItem, Pipeline) {
		    var File = $window.File;
		    var FormData = $window.FormData;
		
		    var FileUploader = function () {
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Creates an instance of FileUploader
		         * @param {Object} [options]
		         * @constructor
		         */
		
		        function FileUploader(options) {
		            _classCallCheck(this, FileUploader);
		
		            var settings = copy(fileUploaderOptions);
		
		            extend(this, settings, options, {
		                isUploading: false,
		                _nextIndex: 0,
		                _directives: { select: [], drop: [], over: [] }
		            });
		
		            // add default filters
		            this.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
		            this.filters.unshift({ name: 'folder', fn: this._folderFilter });
		        }
		        /**
		         * Adds items to the queue
		         * @param {File|HTMLInputElement|Object|FileList|Array<Object>} files
		         * @param {Object} [options]
		         * @param {Array<Function>|String} filters
		         */
		
		
		        FileUploader.prototype.addToQueue = function addToQueue(files, options, filters) {
		            var _this = this;
		
		            var incomingQueue = this.isArrayLikeObject(files) ? Array.prototype.slice.call(files) : [files];
		            var arrayOfFilters = this._getFilters(filters);
		            var count = this.queue.length;
		            var addedFileItems = [];
		
		            var next = function next() {
		                var something = incomingQueue.shift();
		
		                if (isUndefined(something)) {
		                    return done();
		                }
		
		                var fileLikeObject = _this.isFile(something) ? something : new FileLikeObject(something);
		                var pipes = _this._convertFiltersToPipes(arrayOfFilters);
		                var pipeline = new Pipeline(pipes);
		                var onThrown = function onThrown(err) {
		                    var originalFilter = err.pipe.originalFilter;
		
		                    var _err$args = _slicedToArray(err.args, 2);
		
		                    var fileLikeObject = _err$args[0];
		                    var options = _err$args[1];
		
		                    _this._onWhenAddingFileFailed(fileLikeObject, originalFilter, options);
		                    next();
		                };
		                var onSuccessful = function onSuccessful(fileLikeObject, options) {
		                    var fileItem = new FileItem(_this, fileLikeObject, options);
		                    addedFileItems.push(fileItem);
		                    _this.queue.push(fileItem);
		                    _this._onAfterAddingFile(fileItem);
		                    next();
		                };
		                pipeline.onThrown = onThrown;
		                pipeline.onSuccessful = onSuccessful;
		                pipeline.exec(fileLikeObject, options);
		            };
		
		            var done = function done() {
		                if (_this.queue.length !== count) {
		                    _this._onAfterAddingAll(addedFileItems);
		                    _this.progress = _this._getTotalProgress();
		                }
		
		                _this._render();
		                if (_this.autoUpload) _this.uploadAll();
		            };
		
		            next();
		        };
		        /**
		         * Remove items from the queue. Remove last: index = -1
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.removeFromQueue = function removeFromQueue(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            if (item.isUploading) item.cancel();
		            this.queue.splice(index, 1);
		            item._destroy();
		            this.progress = this._getTotalProgress();
		        };
		        /**
		         * Clears the queue
		         */
		
		
		        FileUploader.prototype.clearQueue = function clearQueue() {
		            while (this.queue.length) {
		                this.queue[0].remove();
		            }
		            this.progress = 0;
		        };
		        /**
		         * Uploads a item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.uploadItem = function uploadItem(value) {
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var transport = this.isHTML5 ? '_xhrTransport' : '_iframeTransport';
		
		            item._prepareToUploading();
		            if (this.isUploading) return;
		
		            this._onBeforeUploadItem(item);
		            if (item.isCancel) return;
		
		            item.isUploading = true;
		            this.isUploading = true;
		            this[transport](item);
		            this._render();
		        };
		        /**
		         * Cancels uploading of item from the queue
		         * @param {FileItem|Number} value
		         */
		
		
		        FileUploader.prototype.cancelItem = function cancelItem(value) {
		            var _this2 = this;
		
		            var index = this.getIndexOfItem(value);
		            var item = this.queue[index];
		            var prop = this.isHTML5 ? '_xhr' : '_form';
		            if (!item) return;
		            item.isCancel = true;
		            if (item.isUploading) {
		                // It will call this._onCancelItem() & this._onCompleteItem() asynchronously
		                item[prop].abort();
		            } else {
		                (function () {
		                    var dummy = [undefined, 0, {}];
		                    var onNextTick = function onNextTick() {
		                        _this2._onCancelItem.apply(_this2, [item].concat(dummy));
		                        _this2._onCompleteItem.apply(_this2, [item].concat(dummy));
		                    };
		                    $timeout(onNextTick); // Trigger callbacks asynchronously (setImmediate emulation)
		                })();
		            }
		        };
		        /**
		         * Uploads all not uploaded items of queue
		         */
		
		
		        FileUploader.prototype.uploadAll = function uploadAll() {
		            var items = this.getNotUploadedItems().filter(function (item) {
		                return !item.isUploading;
		            });
		            if (!items.length) return;
		
		            forEach(items, function (item) {
		                return item._prepareToUploading();
		            });
		            items[0].upload();
		        };
		        /**
		         * Cancels all uploads
		         */
		
		
		        FileUploader.prototype.cancelAll = function cancelAll() {
		            var items = this.getNotUploadedItems();
		            forEach(items, function (item) {
		                return item.cancel();
		            });
		        };
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFile = function isFile(value) {
		            return this.constructor.isFile(value);
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype.isFileLikeObject = function isFileLikeObject(value) {
		            return this.constructor.isFileLikeObject(value);
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.prototype.isArrayLikeObject = function isArrayLikeObject(value) {
		            return this.constructor.isArrayLikeObject(value);
		        };
		        /**
		         * Returns a index of item from the queue
		         * @param {Item|Number} value
		         * @returns {Number}
		         */
		
		
		        FileUploader.prototype.getIndexOfItem = function getIndexOfItem(value) {
		            return isNumber(value) ? value : this.queue.indexOf(value);
		        };
		        /**
		         * Returns not uploaded items
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getNotUploadedItems = function getNotUploadedItems() {
		            return this.queue.filter(function (item) {
		                return !item.isUploaded;
		            });
		        };
		        /**
		         * Returns items ready for upload
		         * @returns {Array}
		         */
		
		
		        FileUploader.prototype.getReadyItems = function getReadyItems() {
		            return this.queue.filter(function (item) {
		                return item.isReady && !item.isUploading;
		            }).sort(function (item1, item2) {
		                return item1.index - item2.index;
		            });
		        };
		        /**
		         * Destroys instance of FileUploader
		         */
		
		
		        FileUploader.prototype.destroy = function destroy() {
		            var _this3 = this;
		
		            forEach(this._directives, function (key) {
		                forEach(_this3._directives[key], function (object) {
		                    object.destroy();
		                });
		            });
		        };
		        /**
		         * Callback
		         * @param {Array} fileItems
		         */
		
		
		        FileUploader.prototype.onAfterAddingAll = function onAfterAddingAll(fileItems) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onAfterAddingFile = function onAfterAddingFile(fileItem) {};
		        /**
		         * Callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         */
		
		
		        FileUploader.prototype.onWhenAddingFileFailed = function onWhenAddingFileFailed(item, filter, options) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         */
		
		
		        FileUploader.prototype.onBeforeUploadItem = function onBeforeUploadItem(fileItem) {};
		        /**
		         * Callback
		         * @param {FileItem} fileItem
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressItem = function onProgressItem(fileItem, progress) {};
		        /**
		         * Callback
		         * @param {Number} progress
		         */
		
		
		        FileUploader.prototype.onProgressAll = function onProgressAll(progress) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onSuccessItem = function onSuccessItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onErrorItem = function onErrorItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCancelItem = function onCancelItem(item, response, status, headers) {};
		        /**
		         * Callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileUploader.prototype.onCompleteItem = function onCompleteItem(item, response, status, headers) {};
		        /**
		         * Callback
		         */
		
		
		        FileUploader.prototype.onCompleteAll = function onCompleteAll() {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Returns the total progress
		         * @param {Number} [value]
		         * @returns {Number}
		         * @private
		         */
		
		
		        FileUploader.prototype._getTotalProgress = function _getTotalProgress(value) {
		            if (this.removeAfterUpload) return value || 0;
		
		            var notUploaded = this.getNotUploadedItems().length;
		            var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
		            var ratio = 100 / this.queue.length;
		            var current = (value || 0) * ratio / 100;
		
		            return Math.round(uploaded * ratio + current);
		        };
		        /**
		         * Returns array of filters
		         * @param {Array<Function>|String} filters
		         * @returns {Array<Function>}
		         * @private
		         */
		
		
		        FileUploader.prototype._getFilters = function _getFilters(filters) {
		            if (!filters) return this.filters;
		            if (isArray(filters)) return filters;
		            var names = filters.match(/[^\s,]+/g);
		            return this.filters.filter(function (filter) {
		                return names.indexOf(filter.name) !== -1;
		            });
		        };
		        /**
		        * @param {Array<Function>} filters
		        * @returns {Array<Function>}
		        * @private
		        */
		
		
		        FileUploader.prototype._convertFiltersToPipes = function _convertFiltersToPipes(filters) {
		            var _this4 = this;
		
		            return filters.map(function (filter) {
		                var fn = bind(_this4, filter.fn);
		                fn.isAsync = filter.fn.length === 3;
		                fn.originalFilter = filter;
		                return fn;
		            });
		        };
		        /**
		         * Updates html
		         * @private
		         */
		
		
		        FileUploader.prototype._render = function _render() {
		            if (!$rootScope.$$phase) $rootScope.$apply();
		        };
		        /**
		         * Returns "true" if item is a file (not folder)
		         * @param {File|FileLikeObject} item
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._folderFilter = function _folderFilter(item) {
		            return !!(item.size || item.type);
		        };
		        /**
		         * Returns "true" if the limit has not been reached
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._queueLimitFilter = function _queueLimitFilter() {
		            return this.queue.length < this.queueLimit;
		        };
		        /**
		         * Checks whether upload successful
		         * @param {Number} status
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.prototype._isSuccessCode = function _isSuccessCode(status) {
		            return status >= 200 && status < 300 || status === 304;
		        };
		        /**
		         * Transforms the server response
		         * @param {*} response
		         * @param {Object} headers
		         * @returns {*}
		         * @private
		         */
		
		
		        FileUploader.prototype._transformResponse = function _transformResponse(response, headers) {
		            var headersGetter = this._headersGetter(headers);
		            forEach($http.defaults.transformResponse, function (transformFn) {
		                response = transformFn(response, headersGetter);
		            });
		            return response;
		        };
		        /**
		         * Parsed response headers
		         * @param headers
		         * @returns {Object}
		         * @see https://github.com/angular/angular.js/blob/master/src/ng/http.js
		         * @private
		         */
		
		
		        FileUploader.prototype._parseHeaders = function _parseHeaders(headers) {
		            var parsed = {},
		                key,
		                val,
		                i;
		
		            if (!headers) return parsed;
		
		            forEach(headers.split('\n'), function (line) {
		                i = line.indexOf(':');
		                key = line.slice(0, i).trim().toLowerCase();
		                val = line.slice(i + 1).trim();
		
		                if (key) {
		                    parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		                }
		            });
		
		            return parsed;
		        };
		        /**
		         * Returns function that returns headers
		         * @param {Object} parsedHeaders
		         * @returns {Function}
		         * @private
		         */
		
		
		        FileUploader.prototype._headersGetter = function _headersGetter(parsedHeaders) {
		            return function (name) {
		                if (name) {
		                    return parsedHeaders[name.toLowerCase()] || null;
		                }
		                return parsedHeaders;
		            };
		        };
		        /**
		         * The XMLHttpRequest transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._xhrTransport = function _xhrTransport(item) {
		            var _this5 = this;
		
		            var xhr = item._xhr = new XMLHttpRequest();
		            var sendable;
		
		            if (!item.disableMultipart) {
		                sendable = new FormData();
		                forEach(item.formData, function (obj) {
		                    forEach(obj, function (value, key) {
		                        sendable.append(key, value);
		                    });
		                });
		
		                sendable.append(item.alias, item._file, item.file.name);
		            } else {
		                sendable = item._file;
		            }
		
		            if (typeof item._file.size != 'number') {
		                throw new TypeError('The file specified is no longer valid');
		            }
		
		            xhr.upload.onprogress = function (event) {
		                var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
		                _this5._onProgressItem(item, progress);
		            };
		
		            xhr.onload = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                var gist = _this5._isSuccessCode(xhr.status) ? 'Success' : 'Error';
		                var method = '_on' + gist + 'Item';
		                _this5[method](item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onerror = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onErrorItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.onabort = function () {
		                var headers = _this5._parseHeaders(xhr.getAllResponseHeaders());
		                var response = _this5._transformResponse(xhr.response, headers);
		                _this5._onCancelItem(item, response, xhr.status, headers);
		                _this5._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            xhr.open(item.method, item.url, true);
		
		            xhr.withCredentials = item.withCredentials;
		
		            forEach(item.headers, function (value, name) {
		                xhr.setRequestHeader(name, value);
		            });
		
		            xhr.send(sendable);
		        };
		        /**
		         * The IFrame transport
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._iframeTransport = function _iframeTransport(item) {
		            var _this6 = this;
		
		            var form = element('<form style="display: none;" />');
		            var iframe = element('<iframe name="iframeTransport' + Date.now() + '">');
		            var input = item._input;
		
		            if (item._form) item._form.replaceWith(input); // remove old form
		            item._form = form; // save link to new form
		
		            input.prop('name', item.alias);
		
		            forEach(item.formData, function (obj) {
		                forEach(obj, function (value, key) {
		                    var element_ = element('<input type="hidden" name="' + key + '" />');
		                    element_.val(value);
		                    form.append(element_);
		                });
		            });
		
		            form.prop({
		                action: item.url,
		                method: 'POST',
		                target: iframe.prop('name'),
		                enctype: 'multipart/form-data',
		                encoding: 'multipart/form-data' // old IE
		            });
		
		            iframe.bind('load', function () {
		                var html = '';
		                var status = 200;
		
		                try {
		                    // Fix for legacy IE browsers that loads internal error page
		                    // when failed WS response received. In consequence iframe
		                    // content access denied error is thrown becouse trying to
		                    // access cross domain page. When such thing occurs notifying
		                    // with empty response object. See more info at:
		                    // http://stackoverflow.com/questions/151362/access-is-denied-error-on-accessing-iframe-document-object
		                    // Note that if non standard 4xx or 5xx error code returned
		                    // from WS then response content can be accessed without error
		                    // but 'XHR' status becomes 200. In order to avoid confusion
		                    // returning response via same 'success' event handler.
		
		                    // fixed angular.contents() for iframes
		                    html = iframe[0].contentDocument.body.innerHTML;
		                } catch (e) {
		                    // in case we run into the access-is-denied error or we have another error on the server side
		                    // (intentional 500,40... errors), we at least say 'something went wrong' -> 500
		                    status = 500;
		                }
		
		                var xhr = { response: html, status: status, dummy: true };
		                var headers = {};
		                var response = _this6._transformResponse(xhr.response, headers);
		
		                _this6._onSuccessItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            });
		
		            form.abort = function () {
		                var xhr = { status: 0, dummy: true };
		                var headers = {};
		                var response;
		
		                iframe.unbind('load').prop('src', 'javascript:false;');
		                form.replaceWith(input);
		
		                _this6._onCancelItem(item, response, xhr.status, headers);
		                _this6._onCompleteItem(item, response, xhr.status, headers);
		            };
		
		            input.after(form);
		            form.append(input).append(iframe);
		
		            form[0].submit();
		        };
		        /**
		         * Inner callback
		         * @param {File|Object} item
		         * @param {Object} filter
		         * @param {Object} options
		         * @private
		         */
		
		
		        FileUploader.prototype._onWhenAddingFileFailed = function _onWhenAddingFileFailed(item, filter, options) {
		            this.onWhenAddingFileFailed(item, filter, options);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         */
		
		
		        FileUploader.prototype._onAfterAddingFile = function _onAfterAddingFile(item) {
		            this.onAfterAddingFile(item);
		        };
		        /**
		         * Inner callback
		         * @param {Array<FileItem>} items
		         */
		
		
		        FileUploader.prototype._onAfterAddingAll = function _onAfterAddingAll(items) {
		            this.onAfterAddingAll(items);
		        };
		        /**
		         *  Inner callback
		         * @param {FileItem} item
		         * @private
		         */
		
		
		        FileUploader.prototype._onBeforeUploadItem = function _onBeforeUploadItem(item) {
		            item._onBeforeUpload();
		            this.onBeforeUploadItem(item);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileUploader.prototype._onProgressItem = function _onProgressItem(item, progress) {
		            var total = this._getTotalProgress(progress);
		            this.progress = total;
		            item._onProgress(progress);
		            this.onProgressItem(item, progress);
		            this.onProgressAll(total);
		            this._render();
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onSuccessItem = function _onSuccessItem(item, response, status, headers) {
		            item._onSuccess(response, status, headers);
		            this.onSuccessItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onErrorItem = function _onErrorItem(item, response, status, headers) {
		            item._onError(response, status, headers);
		            this.onErrorItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCancelItem = function _onCancelItem(item, response, status, headers) {
		            item._onCancel(response, status, headers);
		            this.onCancelItem(item, response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {FileItem} item
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileUploader.prototype._onCompleteItem = function _onCompleteItem(item, response, status, headers) {
		            item._onComplete(response, status, headers);
		            this.onCompleteItem(item, response, status, headers);
		
		            var nextItem = this.getReadyItems()[0];
		            this.isUploading = false;
		
		            if (isDefined(nextItem)) {
		                nextItem.upload();
		                return;
		            }
		
		            this.onCompleteAll();
		            this.progress = this._getTotalProgress();
		            this._render();
		        };
		        /**********************
		         * STATIC
		         **********************/
		        /**
		         * Returns "true" if value an instance of File
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFile = function isFile(value) {
		            return File && value instanceof File;
		        };
		        /**
		         * Returns "true" if value an instance of FileLikeObject
		         * @param {*} value
		         * @returns {Boolean}
		         * @private
		         */
		
		
		        FileUploader.isFileLikeObject = function isFileLikeObject(value) {
		            return value instanceof FileLikeObject;
		        };
		        /**
		         * Returns "true" if value is array like object
		         * @param {*} value
		         * @returns {Boolean}
		         */
		
		
		        FileUploader.isArrayLikeObject = function isArrayLikeObject(value) {
		            return isObject(value) && 'length' in value;
		        };
		        /**
		         * Inherits a target (Class_1) by a source (Class_2)
		         * @param {Function} target
		         * @param {Function} source
		         */
		
		
		        FileUploader.inherit = function inherit(target, source) {
		            target.prototype = Object.create(source.prototype);
		            target.prototype.constructor = target;
		            target.super_ = source;
		        };
		
		        return FileUploader;
		    }();
		
		    /**********************
		     * PUBLIC
		     **********************/
		    /**
		     * Checks a support the html5 uploader
		     * @returns {Boolean}
		     * @readonly
		     */
		
		
		    FileUploader.prototype.isHTML5 = !!(File && FormData);
		    /**********************
		     * STATIC
		     **********************/
		    /**
		     * @borrows FileUploader.prototype.isHTML5
		     */
		    FileUploader.isHTML5 = FileUploader.prototype.isHTML5;
		
		    return FileUploader;
		}
		
		__identity.$inject = ['fileUploaderOptions', '$rootScope', '$http', '$window', '$timeout', 'FileLikeObject', 'FileItem', 'Pipeline'];
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var copy = _angular.copy;
		var isElement = _angular.isElement;
		var isString = _angular.isString;
		function __identity() {
		
		    return function () {
		        /**
		         * Creates an instance of FileLikeObject
		         * @param {File|HTMLInputElement|Object} fileOrInput
		         * @constructor
		         */
		
		        function FileLikeObject(fileOrInput) {
		            _classCallCheck(this, FileLikeObject);
		
		            var isInput = isElement(fileOrInput);
		            var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
		            var postfix = isString(fakePathOrObject) ? 'FakePath' : 'Object';
		            var method = '_createFrom' + postfix;
		            this[method](fakePathOrObject);
		        }
		        /**
		         * Creates file like object from fake path string
		         * @param {String} path
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromFakePath = function _createFromFakePath(path) {
		            this.lastModifiedDate = null;
		            this.size = null;
		            this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
		            this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
		        };
		        /**
		         * Creates file like object from object
		         * @param {File|FileLikeObject} object
		         * @private
		         */
		
		
		        FileLikeObject.prototype._createFromObject = function _createFromObject(object) {
		            this.lastModifiedDate = copy(object.lastModifiedDate);
		            this.size = object.size;
		            this.type = object.type;
		            this.name = object.name;
		        };
		
		        return FileLikeObject;
		    }();
		}
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var copy = _angular.copy;
		var extend = _angular.extend;
		var element = _angular.element;
		var isElement = _angular.isElement;
		function __identity($compile, FileLikeObject) {
		
		    return function () {
		        /**
		         * Creates an instance of FileItem
		         * @param {FileUploader} uploader
		         * @param {File|HTMLInputElement|Object} some
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileItem(uploader, some, options) {
		            _classCallCheck(this, FileItem);
		
		            var isInput = isElement(some);
		            var input = isInput ? element(some) : null;
		            var file = !isInput ? some : null;
		
		            extend(this, {
		                url: uploader.url,
		                alias: uploader.alias,
		                headers: copy(uploader.headers),
		                formData: copy(uploader.formData),
		                removeAfterUpload: uploader.removeAfterUpload,
		                withCredentials: uploader.withCredentials,
		                disableMultipart: uploader.disableMultipart,
		                method: uploader.method
		            }, options, {
		                uploader: uploader,
		                file: new FileLikeObject(some),
		                isReady: false,
		                isUploading: false,
		                isUploaded: false,
		                isSuccess: false,
		                isCancel: false,
		                isError: false,
		                progress: 0,
		                index: null,
		                _file: file,
		                _input: input
		            });
		
		            if (input) this._replaceNode(input);
		        }
		        /**********************
		         * PUBLIC
		         **********************/
		        /**
		         * Uploads a FileItem
		         */
		
		
		        FileItem.prototype.upload = function upload() {
		            try {
		                this.uploader.uploadItem(this);
		            } catch (e) {
		                var message = e.name + ':' + e.message;
		                this.uploader._onCompleteItem(this, message, e.code, []);
		                this.uploader._onErrorItem(this, message, e.code, []);
		            }
		        };
		        /**
		         * Cancels uploading of FileItem
		         */
		
		
		        FileItem.prototype.cancel = function cancel() {
		            this.uploader.cancelItem(this);
		        };
		        /**
		         * Removes a FileItem
		         */
		
		
		        FileItem.prototype.remove = function remove() {
		            this.uploader.removeFromQueue(this);
		        };
		        /**
		         * Callback
		         * @private
		         */
		
		
		        FileItem.prototype.onBeforeUpload = function onBeforeUpload() {};
		        /**
		         * Callback
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileItem.prototype.onProgress = function onProgress(progress) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onSuccess = function onSuccess(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onError = function onError(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onCancel = function onCancel(response, status, headers) {};
		        /**
		         * Callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         */
		
		
		        FileItem.prototype.onComplete = function onComplete(response, status, headers) {};
		        /**********************
		         * PRIVATE
		         **********************/
		        /**
		         * Inner callback
		         */
		
		
		        FileItem.prototype._onBeforeUpload = function _onBeforeUpload() {
		            this.isReady = true;
		            this.isUploading = false;
		            this.isUploaded = false;
		            this.isSuccess = false;
		            this.isCancel = false;
		            this.isError = false;
		            this.progress = 0;
		            this.onBeforeUpload();
		        };
		        /**
		         * Inner callback
		         * @param {Number} progress
		         * @private
		         */
		
		
		        FileItem.prototype._onProgress = function _onProgress(progress) {
		            this.progress = progress;
		            this.onProgress(progress);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onSuccess = function _onSuccess(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = true;
		            this.isSuccess = true;
		            this.isCancel = false;
		            this.isError = false;
		            this.progress = 100;
		            this.index = null;
		            this.onSuccess(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onError = function _onError(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = true;
		            this.isSuccess = false;
		            this.isCancel = false;
		            this.isError = true;
		            this.progress = 0;
		            this.index = null;
		            this.onError(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onCancel = function _onCancel(response, status, headers) {
		            this.isReady = false;
		            this.isUploading = false;
		            this.isUploaded = false;
		            this.isSuccess = false;
		            this.isCancel = true;
		            this.isError = false;
		            this.progress = 0;
		            this.index = null;
		            this.onCancel(response, status, headers);
		        };
		        /**
		         * Inner callback
		         * @param {*} response
		         * @param {Number} status
		         * @param {Object} headers
		         * @private
		         */
		
		
		        FileItem.prototype._onComplete = function _onComplete(response, status, headers) {
		            this.onComplete(response, status, headers);
		            if (this.removeAfterUpload) this.remove();
		        };
		        /**
		         * Destroys a FileItem
		         */
		
		
		        FileItem.prototype._destroy = function _destroy() {
		            if (this._input) this._input.remove();
		            if (this._form) this._form.remove();
		            delete this._form;
		            delete this._input;
		        };
		        /**
		         * Prepares to uploading
		         * @private
		         */
		
		
		        FileItem.prototype._prepareToUploading = function _prepareToUploading() {
		            this.index = this.index || ++this.uploader._nextIndex;
		            this.isReady = true;
		        };
		        /**
		         * Replaces input element on his clone
		         * @param {JQLite|jQuery} input
		         * @private
		         */
		
		
		        FileItem.prototype._replaceNode = function _replaceNode(input) {
		            var clone = $compile(input.clone())(input.scope());
		            clone.prop('value', null); // FF fix
		            input.css('display', 'none');
		            input.after(clone); // remove jquery dependency
		        };
		
		        return FileItem;
		    }();
		}
		
		__identity.$inject = ['$compile', 'FileLikeObject'];
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity() {
		    var FileDirective = function () {
		        /**
		         * Creates instance of {FileDirective} object
		         * @param {Object} options
		         * @param {Object} options.uploader
		         * @param {HTMLElement} options.element
		         * @param {Object} options.events
		         * @param {String} options.prop
		         * @constructor
		         */
		
		        function FileDirective(options) {
		            _classCallCheck(this, FileDirective);
		
		            extend(this, options);
		            this.uploader._directives[this.prop].push(this);
		            this._saveLinks();
		            this.bind();
		        }
		        /**
		         * Binds events handles
		         */
		
		
		        FileDirective.prototype.bind = function bind() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this.element.bind(key, this[prop]);
		            }
		        };
		        /**
		         * Unbinds events handles
		         */
		
		
		        FileDirective.prototype.unbind = function unbind() {
		            for (var key in this.events) {
		                this.element.unbind(key, this.events[key]);
		            }
		        };
		        /**
		         * Destroys directive
		         */
		
		
		        FileDirective.prototype.destroy = function destroy() {
		            var index = this.uploader._directives[this.prop].indexOf(this);
		            this.uploader._directives[this.prop].splice(index, 1);
		            this.unbind();
		            // this.element = null;
		        };
		        /**
		         * Saves links to functions
		         * @private
		         */
		
		
		        FileDirective.prototype._saveLinks = function _saveLinks() {
		            for (var key in this.events) {
		                var prop = this.events[key];
		                this[prop] = this[prop].bind(this);
		            }
		        };
		
		        return FileDirective;
		    }();
		
		    /**
		     * Map of events
		     * @type {Object}
		     */
		
		
		    FileDirective.prototype.events = {};
		
		    return FileDirective;
		}
	
	/***/ },
	/* 7 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity($compile, FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileSelect, _FileDirective);
		
		        /**
		         * Creates instance of {FileSelect} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileSelect(options) {
		            _classCallCheck(this, FileSelect);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    change: 'onChange'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'select'
		            });
		
		            var _this = _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		
		            if (!_this.uploader.isHTML5) {
		                _this.element.removeAttr('multiple');
		            }
		            _this.element.prop('value', null); // FF fix
		            return _this;
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileSelect.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileSelect.prototype.getFilters = function getFilters() {};
		        /**
		         * If returns "true" then HTMLInputElement will be cleared
		         * @returns {Boolean}
		         */
		
		
		        FileSelect.prototype.isEmptyAfterSelection = function isEmptyAfterSelection() {
		            return !!this.element.attr('multiple');
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileSelect.prototype.onChange = function onChange() {
		            var files = this.uploader.isHTML5 ? this.element[0].files : this.element[0];
		            var options = this.getOptions();
		            var filters = this.getFilters();
		
		            if (!this.uploader.isHTML5) this.destroy();
		            this.uploader.addToQueue(files, options, filters);
		            if (this.isEmptyAfterSelection()) {
		                this.element.prop('value', null);
		                this.element.replaceWith($compile(this.element.clone())(this.scope)); // IE fix
		            }
		        };
		
		        return FileSelect;
		    }(FileDirective);
		}
		
		__identity.$inject = ['$compile', 'FileDirective'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = __identity;
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		var _angular = angular;
		var bind = _angular.bind;
		var isUndefined = _angular.isUndefined;
		function __identity($q) {
		
		  return function () {
		    /**
		     * @param {Array<Function>} pipes
		     */
		
		    function Pipeline() {
		      var pipes = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
		
		      _classCallCheck(this, Pipeline);
		
		      this.pipes = pipes;
		    }
		
		    Pipeline.prototype.next = function next(args) {
		      var pipe = this.pipes.shift();
		      if (isUndefined(pipe)) {
		        this.onSuccessful.apply(this, _toConsumableArray(args));
		        return;
		      }
		      var err = new Error('The filter has not passed');
		      err.pipe = pipe;
		      err.args = args;
		      if (pipe.isAsync) {
		        var deferred = $q.defer();
		        var onFulfilled = bind(this, this.next, args);
		        var onRejected = bind(this, this.onThrown, err);
		        deferred.promise.then(onFulfilled, onRejected);
		        pipe.apply(undefined, _toConsumableArray(args).concat([deferred]));
		      } else {
		        var isDone = Boolean(pipe.apply(undefined, _toConsumableArray(args)));
		        if (isDone) {
		          this.next(args);
		        } else {
		          this.onThrown(err);
		        }
		      }
		    };
		
		    Pipeline.prototype.exec = function exec() {
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
		
		      this.next(args);
		    };
		
		    Pipeline.prototype.onThrown = function onThrown(err) {};
		
		    Pipeline.prototype.onSuccessful = function onSuccessful() {};
		
		    return Pipeline;
		  }();
		}
		
		__identity.$inject = ['$q'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		var forEach = _angular.forEach;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileDrop, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileDrop(options) {
		            _classCallCheck(this, FileDrop);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy',
		                    drop: 'onDrop',
		                    dragover: 'onDragOver',
		                    dragleave: 'onDragLeave'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'drop'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Returns options
		         * @return {Object|undefined}
		         */
		
		
		        FileDrop.prototype.getOptions = function getOptions() {};
		        /**
		         * Returns filters
		         * @return {Array<Function>|String|undefined}
		         */
		
		
		        FileDrop.prototype.getFilters = function getFilters() {};
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDrop = function onDrop(event) {
		            var transfer = this._getTransfer(event);
		            if (!transfer) return;
		            var options = this.getOptions();
		            var filters = this.getFilters();
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		            this.uploader.addToQueue(transfer.files, options, filters);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragOver = function onDragOver(event) {
		            var transfer = this._getTransfer(event);
		            if (!this._haveFiles(transfer.types)) return;
		            transfer.dropEffect = 'copy';
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._addOverClass, this);
		        };
		        /**
		         * Event handler
		         */
		
		
		        FileDrop.prototype.onDragLeave = function onDragLeave(event) {
		            if (event.currentTarget === this.element[0]) return;
		            this._preventAndStop(event);
		            forEach(this.uploader._directives.over, this._removeOverClass, this);
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._getTransfer = function _getTransfer(event) {
		            return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
		        };
		        /**
		         * Helper
		         */
		
		
		        FileDrop.prototype._preventAndStop = function _preventAndStop(event) {
		            event.preventDefault();
		            event.stopPropagation();
		        };
		        /**
		         * Returns "true" if types contains files
		         * @param {Object} types
		         */
		
		
		        FileDrop.prototype._haveFiles = function _haveFiles(types) {
		            if (!types) return false;
		            if (types.indexOf) {
		                return types.indexOf('Files') !== -1;
		            } else if (types.contains) {
		                return types.contains('Files');
		            } else {
		                return false;
		            }
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._addOverClass = function _addOverClass(item) {
		            item.addOverClass();
		        };
		        /**
		         * Callback
		         */
		
		
		        FileDrop.prototype._removeOverClass = function _removeOverClass(item) {
		            item.removeOverClass();
		        };
		
		        return FileDrop;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
		
		var _angular = angular;
		var extend = _angular.extend;
		function __identity(FileDirective) {
		
		    return function (_FileDirective) {
		        _inherits(FileOver, _FileDirective);
		
		        /**
		         * Creates instance of {FileDrop} object
		         * @param {Object} options
		         * @constructor
		         */
		
		        function FileOver(options) {
		            _classCallCheck(this, FileOver);
		
		            var extendedOptions = extend(options, {
		                // Map of events
		                events: {
		                    $destroy: 'destroy'
		                },
		                // Name of property inside uploader._directive object
		                prop: 'over',
		                // Over class
		                overClass: 'nv-file-over'
		            });
		
		            return _possibleConstructorReturn(this, _FileDirective.call(this, extendedOptions));
		        }
		        /**
		         * Adds over class
		         */
		
		
		        FileOver.prototype.addOverClass = function addOverClass() {
		            this.element.addClass(this.getOverClass());
		        };
		        /**
		         * Removes over class
		         */
		
		
		        FileOver.prototype.removeOverClass = function removeOverClass() {
		            this.element.removeClass(this.getOverClass());
		        };
		        /**
		         * Returns over class
		         * @returns {String}
		         */
		
		
		        FileOver.prototype.getOverClass = function getOverClass() {
		            return this.overClass;
		        };
		
		        return FileOver;
		    }(FileDirective);
		}
		
		__identity.$inject = ['FileDirective'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileSelect) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileSelect({
		                uploader: uploader,
		                element: element,
		                scope: scope
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileSelect'];
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity($parse, FileUploader, FileDrop) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            if (!uploader.isHTML5) return;
		
		            var object = new FileDrop({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOptions = $parse(attributes.options).bind(object, scope);
		            object.getFilters = function () {
		                return attributes.filters;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['$parse', 'FileUploader', 'FileDrop'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		    value: true
		});
		exports.default = __identity;
		
		var _config = __webpack_require__(1);
		
		var _config2 = _interopRequireDefault(_config);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function __identity(FileUploader, FileOver) {
		
		    return {
		        link: function link(scope, element, attributes) {
		            var uploader = scope.$eval(attributes.uploader);
		
		            if (!(uploader instanceof FileUploader)) {
		                throw new TypeError('"Uploader" must be an instance of FileUploader');
		            }
		
		            var object = new FileOver({
		                uploader: uploader,
		                element: element
		            });
		
		            object.getOverClass = function () {
		                return attributes.overClass || object.overClass;
		            };
		        }
		    };
		}
		
		__identity.$inject = ['FileUploader', 'FileOver'];
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=angular-file-upload.js.map

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	   * angular-bootstrap-confirm - Displays a bootstrap confirmation popover when clicking the given element.
	   * @version v2.5.1
	   * @link https://github.com/mattlewis92/angular-bootstrap-confirm
	   * @license MIT
	   */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(369), __webpack_require__(1353));
		else if(typeof define === 'function' && define.amd)
			define(["angular", "angular-sanitize"], factory);
		else if(typeof exports === 'object')
			exports["angularBootstrapConfirmModuleName"] = factory(require("angular"), require("angular-sanitize"));
		else
			root["angularBootstrapConfirmModuleName"] = factory(root["angular"], root["angular-sanitize"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var angular = __webpack_require__(1);
		var defaultPopoverTemplate = __webpack_require__(2);
		__webpack_require__(3);
		__webpack_require__(1);
		var DEFAULT_POPOVER_URL = 'angular-bootstrap-confirm.html';
	
		module.exports = angular
	
		  .module('mwl.confirm', [
		    'ngSanitize',
		    'ui.bootstrap.position'
		  ])
	
		  .run(["$templateCache", function($templateCache) {
		    $templateCache.put(DEFAULT_POPOVER_URL, defaultPopoverTemplate);
		  }])
	
		  .controller('PopoverConfirmCtrl', ["$scope", "$rootScope", "$element", "$attrs", "$compile", "$document", "$window", "$timeout", "$injector", "$templateRequest", "$parse", "$log", "$animate", "confirmationPopoverDefaults", function($scope, $rootScope, $element, $attrs, $compile, $document, $window, $timeout,
		                                             $injector, $templateRequest, $parse, $log, $animate, confirmationPopoverDefaults) {
		    var vm = this;
		    vm.defaults = confirmationPopoverDefaults;
		    vm.$attrs = $attrs;
		    var positionServiceName = $injector.has('$uibPosition') ? '$uibPosition' : '$position';
		    var positionService = $injector.get(positionServiceName);
		    var templateUrl = $attrs.templateUrl || confirmationPopoverDefaults.templateUrl;
		    var popoverScope = $rootScope.$new(true);
		    var animation = vm.animation = $attrs.animation === 'true' || confirmationPopoverDefaults.animation;
		    popoverScope.vm = vm;
	
		    function assignOuterScopeValue(attributeName, value) {
		      var scopeName = $attrs[attributeName];
		      if (angular.isDefined(scopeName)) {
		        if ($parse(scopeName).assign) {
		          $parse(scopeName).assign($scope, value);
		        } else {
		          $log.warn('Could not set value of ' + attributeName + ' to ' + value + '. This is normally because the value is not a variable.');
		        }
		      }
		    }
	
		    function evaluateOuterScopeValue(scopeName, defaultValue, locals) {
		      if (angular.isDefined(scopeName)) {
		        return $parse(scopeName)($scope, locals);
		      } else {
		        return defaultValue;
		      }
		    }
	
		    var popoverLoaded = $templateRequest(templateUrl).then(function(template) {
		      var popover = angular.element(template);
		      popover.css('display', 'none');
		      $compile(popover)(popoverScope);
		      $document.find('body').append(popover);
		      return popover;
		    });
	
		    vm.isVisible = false;
	
		    function positionPopover() {
		      popoverLoaded.then(function(popover) {
		        var position = positionService.positionElements($element, popover, $attrs.placement || vm.defaults.placement, true);
		        position.top += 'px';
		        position.left += 'px';
		        popover.css(position);
		      });
		    }
	
		    function applyFocus() {
		      var buttonToFocus = $attrs.focusButton || vm.defaults.focusButton;
		      if (buttonToFocus) {
		        popoverLoaded.then(function(popover) {
		          var targetButtonClass = buttonToFocus + '-button';
		          popover[0].getElementsByClassName(targetButtonClass)[0].focus();
		        });
		      }
		    }
	
		    function showPopover() {
		      if (!vm.isVisible && !evaluateOuterScopeValue($attrs.isDisabled, false)) {
		        popoverLoaded.then(function(popover) {
		          popover.css({display: 'block'});
		          if (animation) {
		            $animate.addClass(popover, 'in');
		          }
		          positionPopover();
		          applyFocus();
		          vm.isVisible = true;
		          assignOuterScopeValue('isOpen', true);
		        });
		      }
		    }
	
		    function hidePopover() {
		      if (vm.isVisible) {
		        popoverLoaded.then(function(popover) {
		          if (animation) {
		            $animate.removeClass(popover, 'in');
		          }
		          popover.css({display: 'none'});
		          vm.isVisible = false;
		          assignOuterScopeValue('isOpen', false);
		        });
		      }
		    }
	
		    function togglePopover() {
		      if (!vm.isVisible) {
		        showPopover();
		      } else {
		        hidePopover();
		      }
		    }
	
		    function documentClick(event) {
		      popoverLoaded.then(function(popover) {
		        if (vm.isVisible && !popover[0].contains(event.target) && !$element[0].contains(event.target)) {
		          hidePopover();
		        }
		      });
		    }
	
		    vm.showPopover = showPopover;
		    vm.hidePopover = hidePopover;
		    vm.togglePopover = togglePopover;
	
		    vm.onConfirm = function(callbackLocals) {
		      evaluateOuterScopeValue($attrs.onConfirm, null, callbackLocals);
		    };
	
		    vm.onCancel = function(callbackLocals) {
		      evaluateOuterScopeValue($attrs.onCancel, null, callbackLocals);
		    };
	
		    $scope.$watch($attrs.isOpen, function(newIsOpenValue) {
		      $timeout(function() { //timeout required so that documentClick() event doesn't fire and close it
		        if (newIsOpenValue) {
		          showPopover();
		        } else {
		          hidePopover();
		        }
		      });
		    });
	
		    $element.bind('click', togglePopover);
	
		    $window.addEventListener('resize', positionPopover);
	
		    $document.bind('click', documentClick);
		    $document.bind('touchend', documentClick);
	
		    $scope.$on('$destroy', function() {
		      popoverLoaded.then(function(popover) {
		        popover.remove();
		        $element.unbind('click', togglePopover);
		        $window.removeEventListener('resize', positionPopover);
		        $document.unbind('click', documentClick);
		        $document.unbind('touchend', documentClick);
		        popoverScope.$destroy();
		      });
		    });
	
		  }])
	
		  .directive('mwlConfirm', function() {
	
		    return {
		      restrict: 'A',
		      controller: 'PopoverConfirmCtrl'
		    };
	
		  })
	
		  .value('confirmationPopoverDefaults', {
		    confirmText: 'Confirm',
		    cancelText: 'Cancel',
		    confirmButtonType: 'success',
		    cancelButtonType: 'default',
		    placement: 'top',
		    focusButton: null,
		    templateUrl: DEFAULT_POPOVER_URL,
		    hideConfirmButton: false,
		    hideCancelButton: false,
		    animation: false
		  })
	
		  .name;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		module.exports = "<div\n  class=\"popover\"\n  ng-class=\"[vm.$attrs.placement || vm.defaults.placement, 'popover-' + (vm.$attrs.placement || vm.defaults.placement), vm.$attrs.popoverClass || vm.defaults.popoverClass, {fade: vm.animation}]\">\n  <div class=\"popover-arrow arrow\"></div>\n  <h3 class=\"popover-title\" ng-bind-html=\"vm.$attrs.title\"></h3>\n  <div class=\"popover-content\">\n    <p ng-bind-html=\"vm.$attrs.message\"></p>\n    <div class=\"row\">\n      <div\n        class=\"col-xs-6\"\n        ng-if=\"!vm.$attrs.hideConfirmButton && !vm.defaults.hideConfirmButton\"\n        ng-class=\"{'col-xs-offset-3': vm.$attrs.hideCancelButton || vm.defaults.hideCancelButton}\">\n        <button\n          class=\"btn btn-block confirm-button\"\n          ng-class=\"'btn-' + (vm.$attrs.confirmButtonType || vm.defaults.confirmButtonType)\"\n          ng-click=\"vm.onConfirm(); vm.hidePopover()\"\n          ng-bind-html=\"vm.$attrs.confirmText || vm.defaults.confirmText\">\n        </button>\n      </div>\n      <div\n        class=\"col-xs-6\"\n        ng-if=\"!vm.$attrs.hideCancelButton && !vm.defaults.hideCancelButton\"\n        ng-class=\"{'col-xs-offset-3': vm.$attrs.hideConfirmButton || vm.defaults.hideConfirmButton}\">\n        <button\n          class=\"btn btn-block cancel-button\"\n          ng-class=\"'btn-' + (vm.$attrs.cancelButtonType || vm.defaults.cancelButtonType)\"\n          ng-click=\"vm.onCancel(); vm.hidePopover()\"\n          ng-bind-html=\"vm.$attrs.cancelText || vm.defaults.cancelText\">\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1498);
	module.exports = 'angular.filter';


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

	/**
	 * Bunch of useful filters for angularJS(with no external dependencies!)
	 * @version v0.5.17 - 2017-09-22 * @link https://github.com/a8m/angular-filter
	 * @author Ariel Mashraki <ariel@mashraki.co.il>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function ( window, angular, undefined ) {
	/*jshint globalstrict:true*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isUndefined = angular.isUndefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isNumber = angular.isNumber,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    equals = angular.equals;
	
	
	/**
	 * @description
	 * get an object and return array of values
	 * @param object
	 * @returns {Array}
	 */
	function toArray(object) {
	  return isArray(object) 
	    ? object 
	    : Object.keys(object).map(function(key) {
	      return object[key];
	    });
	}
	
	/**
	 * @param value
	 * @returns {boolean}
	 */
	function isNull(value) {
	    return value === null;
	}
	
	/**
	 * @description
	 * return if object contains partial object
	 * @param partial{object}
	 * @param object{object}
	 * @returns {boolean}
	 */
	function objectContains(partial, object) {
	  var keys = Object.keys(partial);
	
	  return keys.map(function(el) {
	    return (object[el] !== undefined) && (object[el] == partial[el]);
	  }).indexOf(false) == -1;
	
	}
	
	/**
	 * @description
	 * search for approximate pattern in string
	 * @param word
	 * @param pattern
	 * @returns {*}
	 */
	function hasApproxPattern(word, pattern) {
	  // cheaper version of indexOf; instead of creating each
	  // iteration new str.
	  function indexOf(word, p, c) {
	    var j = 0;
	    while ((p + j) <= word.length) {
	      if (word.charAt(p + j) == c) return j;
	      j++;
	    }
	    return -1;
	  }
	  var p = 0;
	  for (var i = 0; i <= pattern.length; i++) {
	    var index = indexOf(word, p, pattern.charAt(i));
	    if (index == -1) return false;
	    p += index + 1;
	  }
	  return true
	}
	
	/**
	 * @description
	 * return the first n element of an array,
	 * if expression provided, is returns as long the expression return truthy
	 * @param array
	 * @param n {number}
	 * @param expression {$parse}
	 * @return array or single object
	 */
	function getFirstMatches(array, n, expression) {
	  var count = 0;
	
	  return array.filter(function(elm) {
	    var rest = isDefined(expression) ? (count < n && expression(elm)) : count < n;
	    count = rest ? count+1 : count;
	
	    return rest;
	  });
	}
	/**
	 * Polyfill to ECMA6 String.prototype.contains
	 */
	if (!String.prototype.contains) {
	  String.prototype.contains = function() {
	    return String.prototype.indexOf.apply(this, arguments) !== -1;
	  };
	}
	
	/**
	 * @param num {Number}
	 * @param decimal {Number}
	 * @returns {Number}
	 */
	function convertToDecimal(num, decimal){
	  return Math.round(num * Math.pow(10,decimal)) / (Math.pow(10, decimal));
	}
	
	/**
	 * @description
	 * Get an object, and return an array composed of it's properties names(nested too).
	 * @param obj {Object}
	 * @param stack {Array}
	 * @param parent {String}
	 * @returns {Array}
	 * @example
	 * parseKeys({ a:1, b: { c:2, d: { e: 3 } } }) ==> ["a", "b.c", "b.d.e"]
	 */
	function deepKeys(obj, stack, parent) {
	  stack = stack || [];
	  var keys = Object.keys(obj);
	
	  keys.forEach(function(el) {
	    //if it's a nested object
	    if(isObject(obj[el]) && !isArray(obj[el])) {
	      //concatenate the new parent if exist
	      var p = parent ? parent + '.' + el : parent;
	      deepKeys(obj[el], stack, p || el);
	    } else {
	      //create and save the key
	      var key = parent ? parent + '.' + el : el;
	      stack.push(key)
	    }
	  });
	  return stack
	}
	
	/**
	 * @description
	 * Test if given object is a Scope instance
	 * @param obj
	 * @returns {Boolean}
	 */
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	/**
	 * @ngdoc filter
	 * @name a8m.angular
	 * @kind function
	 *
	 * @description
	 * reference to angular function
	 */
	
	angular.module('a8m.angular', [])
	
	    .filter('isUndefined', function () {
	      return function (input) {
	        return angular.isUndefined(input);
	      }
	    })
	    .filter('isDefined', function() {
	      return function (input) {
	        return angular.isDefined(input);
	      }
	    })
	    .filter('isFunction', function() {
	      return function (input) {
	        return angular.isFunction(input);
	      }
	    })
	    .filter('isString', function() {
	      return function (input) {
	        return angular.isString(input)
	      }
	    })
	    .filter('isNumber', function() {
	      return function (input) {
	        return angular.isNumber(input);
	      }
	    })
	    .filter('isArray', function() {
	      return function (input) {
	        return angular.isArray(input);
	      }
	    })
	    .filter('isObject', function() {
	      return function (input) {
	        return angular.isObject(input);
	      }
	    })
	    .filter('isEqual', function() {
	      return function (o1, o2) {
	        return angular.equals(o1, o2);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name a8m.conditions
	 * @kind function
	 *
	 * @description
	 * reference to math conditions
	 */
	 angular.module('a8m.conditions', [])
	
	  .filter({
	    isGreaterThan  : isGreaterThanFilter,
	    '>'            : isGreaterThanFilter,
	
	    isGreaterThanOrEqualTo  : isGreaterThanOrEqualToFilter,
	    '>='                    : isGreaterThanOrEqualToFilter,
	
	    isLessThan  : isLessThanFilter,
	    '<'         : isLessThanFilter,
	
	    isLessThanOrEqualTo  : isLessThanOrEqualToFilter,
	    '<='                 : isLessThanOrEqualToFilter,
	
	    isEqualTo  : isEqualToFilter,
	    '=='       : isEqualToFilter,
	
	    isNotEqualTo  : isNotEqualToFilter,
	    '!='          : isNotEqualToFilter,
	
	    isIdenticalTo  : isIdenticalToFilter,
	    '==='          : isIdenticalToFilter,
	
	    isNotIdenticalTo  : isNotIdenticalToFilter,
	    '!=='             : isNotIdenticalToFilter
	  });
	
	  function isGreaterThanFilter() {
	    return function (input, check) {
	      return input > check;
	    };
	  }
	
	  function isGreaterThanOrEqualToFilter() {
	    return function (input, check) {
	      return input >= check;
	    };
	  }
	
	  function isLessThanFilter() {
	    return function (input, check) {
	      return input < check;
	    };
	  }
	
	  function isLessThanOrEqualToFilter() {
	    return function (input, check) {
	      return input <= check;
	    };
	  }
	
	  function isEqualToFilter() {
	    return function (input, check) {
	      return input == check;
	    };
	  }
	
	  function isNotEqualToFilter() {
	    return function (input, check) {
	      return input != check;
	    };
	  }
	
	  function isIdenticalToFilter() {
	    return function (input, check) {
	      return input === check;
	    };
	  }
	
	  function isNotIdenticalToFilter() {
	    return function (input, check) {
	      return input !== check;
	    };
	  }
	/**
	 * @ngdoc filter
	 * @name isNull
	 * @kind function
	 *
	 * @description
	 * checks if value is null or not
	 * @return Boolean
	 */
	angular.module('a8m.is-null', [])
	    .filter('isNull', function () {
	      return function(input) {
	        return isNull(input);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection after the first that found with the given properties.
	 *
	 */
	angular.module('a8m.after-where', [])
	    .filter('afterWhere', function() {
	      return function (collection, object) {
	
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        if(!isArray(collection) || isUndefined(object)) return collection;
	
	        var index = collection.map( function( elm ) {
	          return objectContains(object, elm);
	        }).indexOf( true );
	
	        return collection.slice((index === -1) ? 0 : index);
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name after
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection after the specified count.
	 *
	 */
	
	angular.module('a8m.after', [])
	    .filter('after', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name before-where
	 * @kind function
	 *
	 * @description
	 * get a collection and properties object, and returns all of the items
	 * in the collection before the first that found with the given properties.
	 */
	angular.module('a8m.before-where', [])
	  .filter('beforeWhere', function() {
	    return function (collection, object) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(object)) return collection;
	
	      var index = collection.map( function( elm ) {
	        return objectContains(object, elm);
	      }).indexOf( true );
	
	      return collection.slice(0, (index === -1) ? collection.length : ++index);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name before
	 * @kind function
	 *
	 * @description
	 * get a collection and specified count, and returns all of the items
	 * in the collection before the specified count.
	 */
	angular.module('a8m.before', [])
	    .filter('before', function() {
	      return function (collection, count) {
	        collection = isObject(collection)
	          ? toArray(collection)
	          : collection;
	
	        return (isArray(collection))
	          ? collection.slice(0, (!count) ? count : --count)
	          : collection;
	      }
	    });
	
	/**
	 * @ngdoc filter
	 * @name chunkBy
	 * @kind function
	 *
	 * @description
	 * Collect data into fixed-length chunks or blocks
	 */
	
	angular.module('a8m.chunk-by', ['a8m.filter-watcher'])
	    .filter('chunkBy', ['filterWatcher', function (filterWatcher) {
	      return function (array, n, fillVal) {
	
	        return filterWatcher.isMemoized('chunkBy', arguments) ||
	            filterWatcher.memoize('chunkBy', arguments, this,
	                _chunkBy(array, n, fillVal));
	        /**
	         * @description
	         * Get array with size `n` in `val` inside it.
	         * @param n
	         * @param val
	         * @returns {Array}
	         */
	        function fill(n, val) {
	          var ret = [];
	          while (n--) ret[n] = val;
	          return ret;
	        }
	
	        function _chunkBy(array, n, fillVal) {
	          if (!isArray(array)) return array;
	          return array.map(function (el, i, self) {
	            i = i * n;
	            el = self.slice(i, i + n);
	            return !isUndefined(fillVal) && el.length < n
	                ? el.concat(fill(n - el.length, fillVal))
	                : el;
	          }).slice(0, Math.ceil(array.length / n));
	        }
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name concat
	 * @kind function
	 *
	 * @description
	 * get (array/object, object/array) and return merged collection
	 */
	angular.module('a8m.concat', [])
	  .filter('concat', [function () {
	    return function (collection, joined) {
	
	      if (isUndefined(joined)) return collection;
	
	      if (isArray(collection)) {
	        return isObject(joined)
	          ? collection.concat(toArray(joined))
	          : collection.concat(joined);
	      }
	
	      if (isObject(collection)) {
	        var array = toArray(collection);
	        return (isObject(joined))
	          ? array.concat(toArray(joined))
	          : array.concat(joined);
	      }
	      return collection;
	    };
	  }
	]);
	
	/**
	 * @ngdoc filter
	 * @name contains
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in one or more object in the collection
	 */
	angular.module('a8m.contains', [])
	  .filter({
	    contains: ['$parse', containsFilter],
	    some: ['$parse', containsFilter]
	  });
	
	function containsFilter($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return false;
	      }
	
	      return collection.some(function(elm) {
	        return ((isString(expression) && isObject(elm)) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	
	    }
	 }
	
	/**
	 * @ngdoc filter
	 * @name countBy
	 * @kind function
	 *
	 * @description
	 * Sorts a list into groups and returns a count for the number of objects in each group.
	 */
	
	angular.module('a8m.count-by', [])
	
	  .filter('countBy', [ '$parse', function ( $parse ) {
	    return function (collection, property) {
	
	      var result = {},
	        get = $parse(property),
	        prop;
	
	      collection = (isObject(collection)) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      collection.forEach( function( elm ) {
	        prop = get(elm);
	
	        if(!result[prop]) {
	          result[prop] = 0;
	        }
	
	        result[prop]++;
	      });
	
	      return result;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name defaults
	 * @kind function
	 *
	 * @description
	 * defaultsFilter allows to specify a default fallback value for properties that resolve to undefined.
	 */
	angular.module('a8m.defaults', [])
	  .filter('defaults', ['$parse', function( $parse ) {
	    return function(collection, defaults) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || !isObject(defaults)) {
	        return collection;
	      }
	
	      var keys = deepKeys(defaults);
	
	      collection.forEach(function(elm) {
	        //loop through all the keys
	        keys.forEach(function(key) {
	          var getter = $parse(key);
	          var setter = getter.assign;
	          //if it's not exist
	          if(isUndefined(getter(elm))) {
	            //get from defaults, and set to the returned object
	            setter(elm, getter(defaults))
	          }
	        });
	      });
	
	      return collection;
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name every
	 * @kind function
	 *
	 * @description
	 * Checks if given expression is present in all members in the collection
	 *
	 */
	angular.module('a8m.every', [])
	  .filter('every', ['$parse', function($parse) {
	    return function (collection, expression) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return true;
	      }
	
	      return collection.every( function(elm) {
	        return (isObject(elm) || isFunction(expression))
	          ? $parse(expression)(elm)
	          : elm === expression;
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name filterBy
	 * @kind function
	 *
	 * @description
	 * filter by specific properties, avoid the rest
	 */
	angular.module('a8m.filter-by', [])
	  .filter('filterBy', ['$parse', function( $parse ) {
	    return function(collection, properties, search, strict) {
	      var comparator;
	
	      search = (isString(search) || isNumber(search)) ?
	        String(search).toLowerCase() : undefined;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      return collection.filter(function(elm) {
	        return properties.some(function(prop) {
	
	          /**
	           * check if there is concatenate properties
	           * example:
	           * object: { first: 'foo', last:'bar' }
	           * filterBy: ['first + last'] => search by full name(i.e 'foo bar')
	           */
	          if(!~prop.indexOf('+')) {
	            comparator = $parse(prop)(elm)
	          } else {
	            var propList = prop.replace(/\s+/g, '').split('+');
	            comparator = propList
	              .map(function(prop) { return $parse(prop)(elm); })
	              .join(' ');
	          }
	
	          if (!isString(comparator) && !isNumber(comparator)) {
	            return false;
	          }
	
	          comparator = String(comparator).toLowerCase();
	
	          return strict ? comparator === search : comparator.contains(search);
	        });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name first
	 * @kind function
	 *
	 * @description
	 * Gets the first element or first n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.first', [])
	  .filter('first', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args;
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length) ? getFirstMatches(collection, n,(getter) ? $parse(getter) : getter) :
	        collection[0];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name flatten
	 * @kind function
	 *
	 * @description
	 * Flattens a nested array (the nesting can be to any depth).
	 * If you pass shallow, the array will only be flattened a single level
	 */
	angular.module('a8m.flatten', [])
	  .filter('flatten', function () {
	    return function(collection, shallow) {
	
	      shallow = shallow || false;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return !shallow
	        ? flatten(collection, 0)
	        : [].concat.apply([], collection);
	    }
	  });
	
	/**
	 * flatten nested array (the nesting can be to any depth).
	 * @param array {Array}
	 * @param i {int}
	 * @returns {Array}
	 * @private
	 */
	function flatten(array, i) {
	  i = i || 0;
	
	  if(i >= array.length)
	    return array;
	
	  if(isArray(array[i])) {
	    return flatten(array.slice(0,i)
	      .concat(array[i], array.slice(i+1)), i);
	  }
	  return flatten(array, i+1);
	}
	
	/**
	 * @ngdoc filter
	 * @name fuzzyByKey
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching by key
	 */
	angular.module('a8m.fuzzy-by', [])
	  .filter('fuzzyBy', ['$parse', function ( $parse ) {
	    return function (collection, property, search, csensitive) {
	
	      var sensitive = csensitive || false,
	        prop, getter;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(property)
	        || isUndefined(search)) {
	        return collection;
	      }
	
	      getter = $parse(property);
	
	      return collection.filter(function(elm) {
	
	        prop = getter(elm);
	        if(!isString(prop)) {
	          return false;
	        }
	
	        prop = (sensitive) ? prop : prop.toLowerCase();
	        search = (sensitive) ? search : search.toLowerCase();
	
	        return hasApproxPattern(prop, search) !== false
	      })
	    }
	
	 }]);
	/**
	 * @ngdoc filter
	 * @name fuzzy
	 * @kind function
	 *
	 * @description
	 * fuzzy string searching for array of strings, objects
	 */
	angular.module('a8m.fuzzy', [])
	  .filter('fuzzy', function () {
	    return function (collection, search, csensitive) {
	      var sensitive = csensitive || false;
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if(!isArray(collection) || isUndefined(search)) {
	        return collection;
	      }
	
	      search = (sensitive) ? search : search.toLowerCase();
	
	      return collection.filter(function(elm) {
	        if(isString(elm)) {
	          elm = (sensitive) ? elm : elm.toLowerCase();
	          return hasApproxPattern(elm, search) !== false
	        }
	        return (isObject(elm)) ? _hasApproximateKey(elm, search) : false;
	      });
	
	      /**
	       * checks if object has key{string} that match
	       * to fuzzy search pattern
	       * @param object
	       * @param search
	       * @returns {boolean}
	       * @private
	       */
	      function _hasApproximateKey(object, search) {
	        var properties = Object.keys(object),
	          prop, flag;
	        return 0 < properties.filter(function (elm) {
	          prop = object[elm];
	
	          //avoid iteration if we found some key that equal[performance]
	          if(flag) return true;
	
	          if (isString(prop)) {
	            prop = (sensitive) ? prop : prop.toLowerCase();
	            return flag = (hasApproxPattern(prop, search) !== false);
	          }
	
	          return false;
	
	        }).length;
	      }
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name groupBy
	 * @kind function
	 *
	 * @description
	 * Create an object composed of keys generated from the result of running each element of a collection,
	 * each key is an array of the elements.
	 */
	
	angular.module('a8m.group-by', [ 'a8m.filter-watcher' ])
	  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
	    return function (collection, property) {
	
	      if(!isObject(collection) || isUndefined(property)) {
	        return collection;
	      }
	
	      return filterWatcher.isMemoized('groupBy', arguments) ||
	        filterWatcher.memoize('groupBy', arguments, this,
	          _groupBy(collection, $parse(property)));
	
	      /**
	       * groupBy function
	       * @param collection
	       * @param getter
	       * @returns {{}}
	       */
	      function _groupBy(collection, getter) {
	        var result = {};
	        var prop;
	
	        forEach( collection, function( elm ) {
	          prop = getter(elm);
	
	          if(!result[prop]) {
	            result[prop] = [];
	          }
	          result[prop].push(elm);
	        });
	        return result;
	      }
	    }
	 }]);
	
	/**
	 * @ngdoc filter
	 * @name isEmpty
	 * @kind function
	 *
	 * @description
	 * get collection or string and return if it empty
	 */
	angular.module('a8m.is-empty', [])
	  .filter('isEmpty', function () {
	    return function(collection) {
	      return isObject(collection)
	        ? !toArray(collection).length
	        : !collection.length;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name join
	 * @kind function
	 *
	 * @description
	 * join a collection by a provided delimiter (space by default)
	 */
	angular.module('a8m.join', [])
	  .filter('join', function () {
	    return function (input, delimiter) {
	      if (isUndefined(input) || !isArray(input)) {
	        return input;
	      }
	      if (isUndefined(delimiter)) delimiter = ' ';
	
	      return input.join(delimiter);
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name last
	 * @kind function
	 *
	 * @description
	 * Gets the last element or last n elements of an array
	 * if callback is provided, is returns as long the callback return truthy
	 */
	angular.module('a8m.last', [])
	  .filter('last', ['$parse', function( $parse ) {
	    return function(collection) {
	      var n
	        , getter
	        , args
	        //cuz reverse change our src collection
	        //and we don't want side effects
	        , reversed = copy(collection);
	
	      reversed = isObject(reversed)
	        ? toArray(reversed)
	        : reversed;
	
	      if(!isArray(reversed)) {
	        return reversed;
	      }
	
	      args = Array.prototype.slice.call(arguments, 1);
	      n = (isNumber(args[0])) ? args[0] : 1;
	      getter = (!isNumber(args[0]))  ? args[0] : (!isNumber(args[1])) ? args[1] : undefined;
	
	      return (args.length)
	        //send reversed collection as arguments, and reverse it back as result
	        ? getFirstMatches(reversed.reverse(), n,(getter) ? $parse(getter) : getter).reverse()
	        //get the last element
	        : reversed[reversed.length-1];
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name map
	 * @kind function
	 *
	 * @description
	 * Returns a new collection of the results of each expression execution.
	 */
	angular.module('a8m.map', [])
	  .filter('map', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.map(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name omit
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.omit', [])
	
	  .filter('omit', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return !($parse(expression)(elm));
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name pick
	 * @kind function
	 *
	 * @description
	 * filter collection by expression
	 */
	
	angular.module('a8m.pick', [])
	
	  .filter('pick', ['$parse', function($parse) {
	    return function (collection, expression) {
	
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      if(!isArray(collection) || isUndefined(expression)) {
	        return collection;
	      }
	
	      return collection.filter(function (elm) {
	        return $parse(expression)(elm);
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name range
	 * @kind function
	 *
	 * @description
	 * rangeFilter provides some support for a for loop using numbers
	 */
	angular.module('a8m.range', [])
	  .filter('range', function () {
	    return function (input, total, start, increment, cb) {
	      start = start || 0;
	      increment = increment || 1;
	      for (var i = 0; i < parseInt(total); i++) {
	        var j = start + i * increment;
	        input.push(isFunction(cb) ? cb(j) : j);
	      }
	      return input;
	    };
	  });
	/**
	 * @ngdoc filter
	 * @name removeWith
	 * @kind function
	 *
	 * @description
	 * get collection and properties object, and removed elements
	 * with this properties
	 */
	
	angular.module('a8m.remove-with', [])
	  .filter('removeWith', function() {
	    return function (collection, object) {
	
	      if(isUndefined(object)) {
	        return collection;
	      }
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return !objectContains(object, elm);
	      });
	    }
	  });
	
	
	/**
	 * @ngdoc filter
	 * @name remove
	 * @kind function
	 *
	 * @description
	 * remove specific members from collection
	 */
	
	angular.module('a8m.remove', [])
	
	  .filter('remove', function () {
	    return function (collection) {
	      collection = isObject(collection) ? toArray(collection) : collection;
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection)) {
	        return collection;
	      }
	
	      return collection.filter( function( member ) {
	        return !args.some(function(nest) {
	          return equals(nest, member);
	        })
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name reverse
	 * @kind function
	 *
	 * @description
	 * Reverses a string or collection
	 */
	angular.module('a8m.reverse', [])
	    .filter('reverse',[ function () {
	      return function (input) {
	        input = isObject(input) ? toArray(input) : input;
	
	        if(isString(input)) {
	          return input.split('').reverse().join('');
	        }
	
	        return isArray(input)
	          ? input.slice().reverse()
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name searchField
	 * @kind function
	 *
	 * @description
	 * for each member, join several strings field and add them to
	 * new field called 'searchField' (use for search filtering)
	 */
	angular.module('a8m.search-field', [])
	  .filter('searchField', ['$parse', function ($parse) {
	    return function (collection) {
	
	      var get, field;
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      if(!isArray(collection) || !args.length) {
	        return collection;
	      }
	
	      return collection.map(function(member) {
	
	        field = args.map(function(field) {
	          get = $parse(field);
	          return get(member);
	        }).join(' ');
	
	        return extend(member, { searchField: field });
	      });
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name toArray
	 * @kind function
	 *
	 * @description
	 * Convert objects into stable arrays.
	 * if addKey set to true,the filter also attaches a new property
	 * $key to the value containing the original key that was used in
	 * the object we are iterating over to reference the property
	 */
	angular.module('a8m.to-array', [])
	  .filter('toArray', function() {
	    return function (collection, addKey) {
	
	      if(!isObject(collection)) {
	        return collection;
	      }
	
	      return !addKey
	        ? toArray(collection)
	        : Object.keys(collection).map(function (key) {
	            return extend(collection[key], { $key: key });
	          });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name unique/uniq
	 * @kind function
	 *
	 * @description
	 * get collection and filter duplicate members
	 * if uniqueFilter get a property(nested to) as argument it's
	 * filter by this property as unique identifier
	 */
	
	angular.module('a8m.unique', [])
	  .filter({
	      unique: ['$parse', uniqFilter],
	      uniq: ['$parse', uniqFilter]
	    });
	
	function uniqFilter($parse) {
	    return function (collection, property) {
	
	      collection = isObject(collection) ? toArray(collection) : collection;
	
	      if (!isArray(collection)) {
	        return collection;
	      }
	
	      //store all unique identifiers
	      var uniqueItems = [],
	          get = $parse(property);
	
	      return (isUndefined(property))
	        //if it's kind of primitive array
	        ? collection.filter(function (elm, pos, self) {
	          return self.indexOf(elm) === pos;
	        })
	        //else compare with equals
	        : collection.filter(function (elm) {
	          var prop = get(elm);
	          if(some(uniqueItems, prop)) {
	            return false;
	          }
	          uniqueItems.push(prop);
	          return true;
	      });
	
	      //checked if the unique identifier is already exist
	      function some(array, member) {
	        if(isUndefined(member)) {
	          return false;
	        }
	        return array.some(function(el) {
	          return equals(el, member);
	        });
	      }
	    }
	}
	
	/**
	 * @ngdoc filter
	 * @name where
	 * @kind function
	 *
	 * @description
	 * of each element in a collection to the given properties object,
	 * returning an array of all elements that have equivalent property values.
	 *
	 */
	angular.module('a8m.where', [])
	  .filter('where', function() {
	    return function (collection, object) {
	      if(isUndefined(object)) return collection;
	      collection = isObject(collection)
	        ? toArray(collection)
	        : collection;
	
	      return collection.filter(function (elm) {
	        return objectContains(object, elm);
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name xor
	 * @kind function
	 *
	 * @description
	 * Exclusive or filter by expression
	 */
	
	angular.module('a8m.xor', [])
	
	  .filter('xor', ['$parse', function($parse) {
	    return function (col1, col2, expression) {
	
	      expression = expression || false;
	
	      col1 = isObject(col1) ? toArray(col1) : col1;
	      col2 = isObject(col2) ? toArray(col2) : col2;
	
	      if(!isArray(col1) || !isArray(col2)) return col1;
	
	      return col1.concat(col2)
	        .filter(function(elm) {
	          return !(some(elm, col1) && some(elm, col2));
	        });
	
	      function some(el, col) {
	        var getter = $parse(expression);
	        return col.some(function(dElm) {
	          return expression
	            ? equals(getter(dElm), getter(el))
	            : equals(dElm, el);
	        });
	      }
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name abs
	 * @kind function
	 *
	 * @description
	 * Will return the absolute value of a number
	 */
	angular.module('a8m.math.abs', [])
	  .filter('abs', function () {
	    return function (input) {
	      return Math.abs(input);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 bytes => 1 KB
	 */
	angular.module('a8m.math.byteFmt', [])
	  .filter('byteFmt', function () {
	    var compared = [{str: 'B', val: 1024}];
	    ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name degrees
	 * @kind function
	 *
	 * @description
	 * Convert angle from radians to degrees
	 */
	angular.module('a8m.math.degrees', [])
	  .filter('degrees', function () {
	    return function (radians, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(radians) && isFinite(radians)) {
	        var degrees = (radians * 180) / Math.PI;
	        return Math.round(degrees * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      } else {
	        return 'NaN';
	      }
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert bytes into appropriate display 
	 * 1024 kilobytes => 1 MB
	 */
	angular.module('a8m.math.kbFmt', [])
	  .filter('kbFmt', function () {
	    var compared = [{str: 'KB', val: 1024}];
	    ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'].forEach(function(el, i) {
	      compared.push({str: el, val: compared[i].val * 1024 });
	    });
	    return function (bytes, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(bytes) && isFinite(bytes)) {
	        var i = 0;
	        while (i < compared.length-1 && bytes >= compared[i].val) i++;
	        bytes /= i > 0 ? compared[i-1].val : 1;
	        return convertToDecimal(bytes, decimal) + ' ' + compared[i].str;
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name max
	 * @kind function
	 *
	 * @description
	 * Math.max will get an array and return the max value. if an expression
	 * is provided, will return max value by expression.
	 */
	angular.module('a8m.math.max', [])
	  .filter('max', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.max.apply(Math, input)
	        : input[indexByMax(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMax(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.max.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name min
	 * @kind function
	 *
	 * @description
	 * Math.min will get an array and return the min value. if an expression
	 * is provided, will return min value by expression.
	 */
	angular.module('a8m.math.min', [])
	  .filter('min', ['$parse', function ($parse) {
	    return function (input, expression) {
	
	      if(!isArray(input)) {
	        return input;
	      }
	      return isUndefined(expression)
	        ? Math.min.apply(Math, input)
	        : input[indexByMin(input, expression)];
	    };
	
	    /**
	     * @private
	     * @param array
	     * @param exp
	     * @returns {number|*|Number}
	     */
	    function indexByMin(array, exp) {
	      var mappedArray = array.map(function(elm){
	        return $parse(exp)(elm);
	      });
	      return mappedArray.indexOf(Math.min.apply(Math, mappedArray));
	    }
	  }]);
	/**
	 * @ngdoc filter
	 * @name Percent
	 * @kind function
	 *
	 * @description
	 * percentage between two numbers
	 */
	angular.module('a8m.math.percent', [])
	  .filter('percent', function () {
	    return function (input, divided, round) {
	
	      var divider = isString(input) ? Number(input) : input;
	      divided = divided || 100;
	      round = round || false;
	
	      if (!isNumber(divider) || isNaN(divider)) return input;
	
	      return round
	        ? Math.round((divider / divided) * 100)
	        : (divider / divided) * 100;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name toRadians
	 * @kind function
	 *
	 * @description
	 * Convert angle from degrees to radians
	 */
	angular.module('a8m.math.radians', [])
	  .filter('radians', function() {
	    return function (degrees, decimal) {
	      // if decimal is not an integer greater than -1, we cannot do. quit with error "NaN"
	      // if degrees is not a real number, we cannot do also. quit with error "NaN"
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(degrees) && isFinite(degrees)) {
	        var radians = (degrees * 3.14159265359) / 180;
	        return Math.round(radians * Math.pow(10,decimal)) / (Math.pow(10,decimal));
	      }
	      return 'NaN';
	    }
	  });
	
	 
	 
	/**
	 * @ngdoc filter
	 * @name Radix
	 * @kind function
	 *
	 * @description
	 * converting decimal numbers to different bases(radix)
	 */
	angular.module('a8m.math.radix', [])
	  .filter('radix', function () {
	    return function (input, radix) {
	      var RANGE = /^[2-9]$|^[1-2]\d$|^3[0-6]$/;
	
	      if(!isNumber(input) || !RANGE.test(radix)) {
	        return input;
	      }
	
	      return input.toString(radix).toUpperCase();
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name formatBytes
	 * @kind function
	 *
	 * @description
	 * Convert number into abbreviations.
	 * i.e: K for one thousand, M for Million, B for billion
	 * e.g: number of users:235,221, decimal:1 => 235.2 K
	 */
	angular.module('a8m.math.shortFmt', [])
	  .filter('shortFmt', function () {
	    return function (number, decimal) {
	      if(isNumber(decimal) && isFinite(decimal) && decimal%1===0 && decimal >= 0 &&
	        isNumber(number) && isFinite(number)){
	        if(number < 1e3) {
	          return '' + number;  // Coerce to string
	        } else if(number < 1e6) {
	          return convertToDecimal((number / 1e3), decimal) + ' K';
	        } else if(number < 1e9){
	          return convertToDecimal((number / 1e6), decimal) + ' M';
	        } else {
	          return convertToDecimal((number / 1e9), decimal) + ' B';
	        }
	
	      }
	      return 'NaN';
	    }
	  });
	/**
	 * @ngdoc filter
	 * @name sum
	 * @kind function
	 *
	 * @description
	 * Sum up all values within an array
	 */
	angular.module('a8m.math.sum', [])
	  .filter('sum', function () {
	    return function (input, initial) {
	      return !isArray(input)
	        ? input
	        : input.reduce(function(prev, curr) {
	          return prev + curr;
	        }, initial || 0);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name endsWith
	 * @kind function
	 *
	 * @description
	 * checks whether string ends with the ends parameter.
	 */
	angular.module('a8m.ends-with', [])
	
	  .filter('endsWith', function () {
	    return function (input, ends, csensitive) {
	
	      var sensitive = csensitive || false,
	        position;
	
	      if(!isString(input) || isUndefined(ends)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	      position = input.length - ends.length;
	
	      return input.indexOf((sensitive) ? ends : ends.toLowerCase(), position) !== -1;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name latinize
	 * @kind function
	 *
	 * @description
	 * remove accents/diacritics from a string
	 */
	angular.module('a8m.latinize', [])
	  .filter('latinize',[ function () {
	    var defaultDiacriticsRemovalap = [
	      {'base':'A', 'letters':'\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'},
	      {'base':'AA','letters':'\uA732'},
	      {'base':'AE','letters':'\u00C6\u01FC\u01E2'},
	      {'base':'AO','letters':'\uA734'},
	      {'base':'AU','letters':'\uA736'},
	      {'base':'AV','letters':'\uA738\uA73A'},
	      {'base':'AY','letters':'\uA73C'},
	      {'base':'B', 'letters':'\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'},
	      {'base':'C', 'letters':'\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'},
	      {'base':'D', 'letters':'\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'},
	      {'base':'DZ','letters':'\u01F1\u01C4'},
	      {'base':'Dz','letters':'\u01F2\u01C5'},
	      {'base':'E', 'letters':'\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'},
	      {'base':'F', 'letters':'\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'},
	      {'base':'G', 'letters':'\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'},
	      {'base':'H', 'letters':'\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'},
	      {'base':'I', 'letters':'\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'},
	      {'base':'J', 'letters':'\u004A\u24BF\uFF2A\u0134\u0248'},
	      {'base':'K', 'letters':'\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'},
	      {'base':'L', 'letters':'\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'},
	      {'base':'LJ','letters':'\u01C7'},
	      {'base':'Lj','letters':'\u01C8'},
	      {'base':'M', 'letters':'\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'},
	      {'base':'N', 'letters':'\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'},
	      {'base':'NJ','letters':'\u01CA'},
	      {'base':'Nj','letters':'\u01CB'},
	      {'base':'O', 'letters':'\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'},
	      {'base':'OI','letters':'\u01A2'},
	      {'base':'OO','letters':'\uA74E'},
	      {'base':'OU','letters':'\u0222'},
	      {'base':'OE','letters':'\u008C\u0152'},
	      {'base':'oe','letters':'\u009C\u0153'},
	      {'base':'P', 'letters':'\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'},
	      {'base':'Q', 'letters':'\u0051\u24C6\uFF31\uA756\uA758\u024A'},
	      {'base':'R', 'letters':'\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'},
	      {'base':'S', 'letters':'\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'},
	      {'base':'T', 'letters':'\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'},
	      {'base':'TZ','letters':'\uA728'},
	      {'base':'U', 'letters':'\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'},
	      {'base':'V', 'letters':'\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'},
	      {'base':'VY','letters':'\uA760'},
	      {'base':'W', 'letters':'\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'},
	      {'base':'X', 'letters':'\u0058\u24CD\uFF38\u1E8A\u1E8C'},
	      {'base':'Y', 'letters':'\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'},
	      {'base':'Z', 'letters':'\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'},
	      {'base':'a', 'letters':'\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'},
	      {'base':'aa','letters':'\uA733'},
	      {'base':'ae','letters':'\u00E6\u01FD\u01E3'},
	      {'base':'ao','letters':'\uA735'},
	      {'base':'au','letters':'\uA737'},
	      {'base':'av','letters':'\uA739\uA73B'},
	      {'base':'ay','letters':'\uA73D'},
	      {'base':'b', 'letters':'\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'},
	      {'base':'c', 'letters':'\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'},
	      {'base':'d', 'letters':'\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'},
	      {'base':'dz','letters':'\u01F3\u01C6'},
	      {'base':'e', 'letters':'\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'},
	      {'base':'f', 'letters':'\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'},
	      {'base':'g', 'letters':'\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'},
	      {'base':'h', 'letters':'\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'},
	      {'base':'hv','letters':'\u0195'},
	      {'base':'i', 'letters':'\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'},
	      {'base':'j', 'letters':'\u006A\u24D9\uFF4A\u0135\u01F0\u0249'},
	      {'base':'k', 'letters':'\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'},
	      {'base':'l', 'letters':'\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'},
	      {'base':'lj','letters':'\u01C9'},
	      {'base':'m', 'letters':'\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'},
	      {'base':'n', 'letters':'\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'},
	      {'base':'nj','letters':'\u01CC'},
	      {'base':'o', 'letters':'\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'},
	      {'base':'oi','letters':'\u01A3'},
	      {'base':'ou','letters':'\u0223'},
	      {'base':'oo','letters':'\uA74F'},
	      {'base':'p','letters':'\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'},
	      {'base':'q','letters':'\u0071\u24E0\uFF51\u024B\uA757\uA759'},
	      {'base':'r','letters':'\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'},
	      {'base':'s','letters':'\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'},
	      {'base':'t','letters':'\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'},
	      {'base':'tz','letters':'\uA729'},
	      {'base':'u','letters': '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'},
	      {'base':'v','letters':'\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'},
	      {'base':'vy','letters':'\uA761'},
	      {'base':'w','letters':'\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'},
	      {'base':'x','letters':'\u0078\u24E7\uFF58\u1E8B\u1E8D'},
	      {'base':'y','letters':'\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'},
	      {'base':'z','letters':'\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'}
	    ];
	
	    var diacriticsMap = {};
	    for (var i = 0; i < defaultDiacriticsRemovalap.length; i++) {
	      var letters = defaultDiacriticsRemovalap[i].letters.split("");
	      for (var j = 0; j < letters.length ; j++){
	        diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	      }
	    }
	
	    // "what?" version ... http://jsperf.com/diacritics/12
	    function removeDiacritics (str) {
	      return str.replace(/[^\u0000-\u007E]/g, function(a){
	        return diacriticsMap[a] || a;
	      });
	    }
	
	    return function (input) {
	
	      return isString(input)
	        ? removeDiacritics(input)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name ltrim
	 * @kind function
	 *
	 * @description
	 * Left trim. Similar to trimFilter, but only for left side.
	 */
	angular.module('a8m.ltrim', [])
	  .filter('ltrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name match
	 * @kind function
	 *
	 * @description
	 * Return the matched pattern in a string.
	 */
	angular.module('a8m.match', [])
	  .filter('match', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? input.match(reg)
	        : null;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name phone-us
	 * @kind function
	 *
	 * @description
	 * format a string or a number into a us-style
	 * phone number in the form (***) ***-****
	 */
	angular.module('a8m.phoneUS', [])
	  .filter('phoneUS', function () {
	    return function(num) {
	      num += '';
	      return '(' + num.slice(0, 3) + ') ' + num.slice(3, 6) + '-' + num.slice(6);
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name repeat
	 * @kind function
	 *
	 * @description
	 * Repeats a string n times
	 */
	angular.module('a8m.repeat', [])
	  .filter('repeat',[ function () {
	    return function (input, n, separator) {
	
	      var times = ~~n;
	
	      if(!isString(input)) {
	        return input;
	      }
	
	      return !times
	        ? input
	        : strRepeat(input, --n, separator || '');
	    }
	  }]);
	
	/**
	 * Repeats a string n times with given separator
	 * @param str string to repeat
	 * @param n number of times
	 * @param sep separator
	 * @returns {*}
	 */
	function strRepeat(str, n, sep) {
	  if(!n) {
	    return str;
	  }
	  return str + sep + strRepeat(str, --n, sep);
	}
	/**
	* @ngdoc filter
	* @name rtrim
	* @kind function
	*
	* @description
	* Right trim. Similar to trimFilter, but only for right side.
	*/
	angular.module('a8m.rtrim', [])
	  .filter('rtrim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp(trim + '+$'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name slugify
	 * @kind function
	 *
	 * @description
	 * remove spaces from string, replace with "-" or given argument
	 */
	angular.module('a8m.slugify', [])
	  .filter('slugify',[ function () {
	    return function (input, sub) {
	
	      var replace = (isUndefined(sub)) ? '-' : sub;
	
	      return isString(input)
	        ? input.toLowerCase().replace(/\s+/g, replace)
	        : input;
	    }
	  }]);
	
	/**
	 * @ngdoc filter
	 * @name split
	 * @kind function
	 *
	 * @description
	 * split a string by a provided delimiter (none '' by default) and skip first n-delimiters
	 */
	angular.module('a8m.split', [])
	  .filter('split', function () {
	    function escapeRegExp(str) {
	      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	    }
	
	    return function (input, delimiter, skip) {
	      var _regexp, _matches, _splitted, _temp;
	
	      if (isUndefined(input) || !isString(input)) {
	        return null;
	      }
	      if (isUndefined(delimiter)) delimiter = '';
	      if (isNaN(skip)) skip = 0;
	
	      _regexp = new RegExp(escapeRegExp(delimiter), 'g');
	      _matches = input.match(_regexp);
	      
	      if (isNull(_matches) || skip >= _matches.length) {
	        return [input];
	      }
	
	      if (skip === 0) return input.split(delimiter);
	      
	      _splitted = input.split(delimiter);
	      _temp = _splitted.splice(0, skip + 1);
	      _splitted.unshift(_temp.join(delimiter));
	    
	      return _splitted;
	    };
	  })
	;
	
	/**
	 * @ngdoc filter
	 * @name startWith
	 * @kind function
	 *
	 * @description
	 * checks whether string starts with the starts parameter.
	 */
	angular.module('a8m.starts-with', [])
	  .filter('startsWith', function () {
	    return function (input, start, csensitive) {
	
	      var sensitive = csensitive || false;
	
	      if(!isString(input) || isUndefined(start)) {
	        return input;
	      }
	
	      input = (sensitive) ? input : input.toLowerCase();
	
	      return !input.indexOf((sensitive) ? start : start.toLowerCase());
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stringular
	 * @kind function
	 *
	 * @description
	 * get string with {n} and replace match with enumeration values
	 */
	angular.module('a8m.stringular', [])
	  .filter('stringular', function () {
	    return function(input) {
	
	      var args = Array.prototype.slice.call(arguments, 1);
	
	      return input.replace(/{(\d+)}/g, function (match, number) {
	        return isUndefined(args[number]) ? match : args[number];
	      });
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name stripTags
	 * @kind function
	 *
	 * @description
	 * strip html tags from string
	 */
	angular.module('a8m.strip-tags', [])
	  .filter('stripTags', function () {
	    return function(input) {
	      return isString(input)
	        ? input.replace(/<\S[^><]*>/g, '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name test
	 * @kind function
	 *
	 * @description
	 * test if a string match a pattern.
	 */
	angular.module('a8m.test', [])
	  .filter('test', function () {
	    return function (input, pattern, flag) {
	
	      var reg = new RegExp(pattern, flag);
	
	      return isString(input)
	        ? reg.test(input)
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name trim
	 * @kind function
	 *
	 * @description
	 *  Strip whitespace (or other characters) from the beginning and end of a string
	 */
	angular.module('a8m.trim', [])
	  .filter('trim', function () {
	    return function(input, chars) {
	
	      var trim = chars || '\\s';
	
	      return isString(input)
	        ? input.replace(new RegExp('^' + trim + '+|' + trim + '+$', 'g'), '')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc filter
	 * @name truncate
	 * @kind function
	 *
	 * @description
	 * truncates a string given a specified length, providing a custom string to denote an omission.
	 */
	angular.module('a8m.truncate', [])
	  .filter('truncate', function () {
	    return function(input, length, suffix, preserve) {
	
	      length = isUndefined(length) ? input.length : length;
	      preserve = preserve || false;
	      suffix = suffix || '';
	
	      if(!isString(input) || (input.length <= length)) return input;
	
	      return input.substring(0, (preserve)
	        ? ((input.indexOf(' ', length) === -1) ? input.length : input.indexOf(' ', length))
	        : length) + suffix;
	    };
	  });
	
	/**
	 * @ngdoc filter
	 * @name ucfirst
	 * @kind function
	 *
	 * @description
	 * ucfirst
	 */
	angular.module('a8m.ucfirst', [])
	  .filter({
	    ucfirst: ucfirstFilter,
	    titleize: ucfirstFilter
	  });
	
	function ucfirstFilter() {
	  return function (input) {
	    return isString(input)
	      ? input
	      .split(' ')
	      .map(function (ch) {
	        return ch.charAt(0).toUpperCase() + ch.substring(1);
	      })
	      .join(' ')
	      : input;
	  }
	}
	
	/**
	 * @ngdoc filter
	 * @name uriComponentEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-component-encode', [])
	  .filter('uriComponentEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURIComponent(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name uriEncode
	 * @kind function
	 *
	 * @description
	 * get string as parameter and return encoded string
	 */
	angular.module('a8m.uri-encode', [])
	  .filter('uriEncode',['$window', function ($window) {
	      return function (input) {
	        return isString(input)
	          ? $window.encodeURI(input)
	          : input;
	      }
	    }]);
	
	/**
	 * @ngdoc filter
	 * @name wrap
	 * @kind function
	 *
	 * @description
	 * Wrap a string with another string
	 */
	angular.module('a8m.wrap', [])
	  .filter('wrap', function () {
	    return function(input, wrap, ends) {
	      return isString(input) && isDefined(wrap)
	        ? [wrap, input, ends || wrap].join('')
	        : input;
	    }
	  });
	
	/**
	 * @ngdoc provider
	 * @name filterWatcher
	 * @kind function
	 *
	 * @description
	 * store specific filters result in $$cache, based on scope life time(avoid memory leak).
	 * on scope.$destroy remove it's cache from $$cache container
	 */
	
	angular.module('a8m.filter-watcher', [])
	  .provider('filterWatcher', function() {
	
	    this.$get = ['$window', '$rootScope', function($window, $rootScope) {
	
	      /**
	       * Cache storing
	       * @type {Object}
	       */
	      var $$cache = {};
	
	      /**
	       * Scope listeners container
	       * scope.$destroy => remove all cache keys
	       * bind to current scope.
	       * @type {Object}
	       */
	      var $$listeners = {};
	
	      /**
	       * $timeout without triggering the digest cycle
	       * @type {function}
	       */
	      var $$timeout = $window.setTimeout;
	
	      /**
	       * @description
	       * get `HashKey` string based on the given arguments.
	       * @param fName
	       * @param args
	       * @returns {string}
	       */
	      function getHashKey(fName, args) {
	        function replacerFactory() {
	          var cache = [];
	          return function(key, val) {
	            if(isObject(val) && !isNull(val)) {
	              if (~cache.indexOf(val)) return '[Circular]';
	              cache.push(val)
	            }
	            if($window == val) return '$WINDOW';
	            if($window.document == val) return '$DOCUMENT';
	            if(isScope(val)) return '$SCOPE';
	            return val;
	          }
	        }
	        return [fName, JSON.stringify(args, replacerFactory())]
	          .join('#')
	          .replace(/"/g,'');
	      }
	
	      /**
	       * @description
	       * fir on $scope.$destroy,
	       * remove cache based scope from `$$cache`,
	       * and remove itself from `$$listeners`
	       * @param event
	       */
	      function removeCache(event) {
	        var id = event.targetScope.$id;
	        forEach($$listeners[id], function(key) {
	          delete $$cache[key];
	        });
	        delete $$listeners[id];
	      }
	
	      /**
	       * @description
	       * for angular version that greater than v.1.3.0
	       * it clear cache when the digest cycle is end.
	       */
	      function cleanStateless() {
	        $$timeout(function() {
	          if(!$rootScope.$$phase)
	            $$cache = {};
	        }, 2000);
	      }
	
	      /**
	       * @description
	       * Store hashKeys in $$listeners container
	       * on scope.$destroy, remove them all(bind an event).
	       * @param scope
	       * @param hashKey
	       * @returns {*}
	       */
	      function addListener(scope, hashKey) {
	        var id = scope.$id;
	        if(isUndefined($$listeners[id])) {
	          scope.$on('$destroy', removeCache);
	          $$listeners[id] = [];
	        }
	        return $$listeners[id].push(hashKey);
	      }
	
	      /**
	       * @description
	       * return the `cacheKey` or undefined.
	       * @param filterName
	       * @param args
	       * @returns {*}
	       */
	      function $$isMemoized(filterName, args) {
	        var hashKey = getHashKey(filterName, args);
	        return $$cache[hashKey];
	      }
	
	      /**
	       * @description
	       * store `result` in `$$cache` container, based on the hashKey.
	       * add $destroy listener and return result
	       * @param filterName
	       * @param args
	       * @param scope
	       * @param result
	       * @returns {*}
	       */
	      function $$memoize(filterName, args, scope, result) {
	        var hashKey = getHashKey(filterName, args);
	        //store result in `$$cache` container
	        $$cache[hashKey] = result;
	        // for angular versions that less than 1.3
	        // add to `$destroy` listener, a cleaner callback
	        if(isScope(scope)) {
	          addListener(scope, hashKey);
	        } else {
	          cleanStateless();
	        }
	        return result;
	      }
	
	      return {
	        isMemoized: $$isMemoized,
	        memoize: $$memoize
	      }
	    }];
	  });
	  
	
	/**
	 * @ngdoc module
	 * @name angular.filters
	 * @description
	 * Bunch of useful filters for angularJS
	 */
	
	angular.module('angular.filter', [
	
	  'a8m.ucfirst',
	  'a8m.uri-encode',
	  'a8m.uri-component-encode',
	  'a8m.slugify',
	  'a8m.latinize',
	  'a8m.strip-tags',
	  'a8m.stringular',
	  'a8m.truncate',
	  'a8m.starts-with',
	  'a8m.ends-with',
	  'a8m.wrap',
	  'a8m.trim',
	  'a8m.ltrim',
	  'a8m.rtrim',
	  'a8m.repeat',
	  'a8m.test',
	  'a8m.match',
	  'a8m.split',
	  'a8m.phoneUS',
	
	  'a8m.to-array',
	  'a8m.concat',
	  'a8m.contains',
	  'a8m.unique',
	  'a8m.is-empty',
	  'a8m.after',
	  'a8m.after-where',
	  'a8m.before',
	  'a8m.before-where',
	  'a8m.defaults',
	  'a8m.where',
	  'a8m.reverse',
	  'a8m.remove',
	  'a8m.remove-with',
	  'a8m.group-by',
	  'a8m.count-by',
	  'a8m.chunk-by',
	  'a8m.search-field',
	  'a8m.fuzzy-by',
	  'a8m.fuzzy',
	  'a8m.omit',
	  'a8m.pick',
	  'a8m.every',
	  'a8m.filter-by',
	  'a8m.xor',
	  'a8m.map',
	  'a8m.first',
	  'a8m.last',
	  'a8m.flatten',
	  'a8m.join',
	  'a8m.range',
	
	  'a8m.math.max',
	  'a8m.math.min',
	  'a8m.math.abs',
	  'a8m.math.percent',
	  'a8m.math.radix',
	  'a8m.math.sum',
	  'a8m.math.degrees',
	  'a8m.math.radians',
	  'a8m.math.byteFmt',
	  'a8m.math.kbFmt',
	  'a8m.math.shortFmt',
	
	  'a8m.angular',
	  'a8m.conditions',
	  'a8m.is-null',
	
	  'a8m.filter-watcher'
	]);
	})( window, window.angular );

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1500);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./animate.css", function() {
				var newContent = require("!!../css-loader/index.js!./animate.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * animate.css -http://daneden.me/animate\n * Version - 3.7.0\n * Licensed under the MIT license - http://opensource.org/licenses/MIT\n *\n * Copyright (c) 2018 Daniel Eden\n */@-webkit-keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06);-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:headShake;animation-name:headShake}@-webkit-keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{0%,11.1%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes jello{0%,11.1%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{-webkit-animation-name:jello;animation-name:jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes heartBeat{0%{-webkit-transform:scale(1);transform:scale(1)}14%{-webkit-transform:scale(1.3);transform:scale(1.3)}28%{-webkit-transform:scale(1);transform:scale(1)}42%{-webkit-transform:scale(1.3);transform:scale(1.3)}70%{-webkit-transform:scale(1);transform:scale(1)}}@keyframes heartBeat{0%{-webkit-transform:scale(1);transform:scale(1)}14%{-webkit-transform:scale(1.3);transform:scale(1.3)}28%{-webkit-transform:scale(1);transform:scale(1)}42%{-webkit-transform:scale(1.3);transform:scale(1.3)}70%{-webkit-transform:scale(1);transform:scale(1)}}.heartBeat{-webkit-animation-name:heartBeat;animation-name:heartBeat;-webkit-animation-duration:1.3s;animation-duration:1.3s;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}.bounceIn{-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-name:bounceOut;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{0%{-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);transform:perspective(400px) scaleX(1) translateZ(0) rotateY(-1turn);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-190deg);-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}50%{-webkit-transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);transform:perspective(400px) scaleX(1) translateZ(150px) rotateY(-170deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);transform:perspective(400px) scale3d(.95,.95,.95) translateZ(0) rotateY(0deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}to{-webkit-transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);transform:perspective(400px) scaleX(1) translateZ(0) rotateY(0deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in;opacity:0}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipOutY;animation-name:flipOutY}@-webkit-keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg);opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes rotateIn{0%{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes rotateInDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes rotateInDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes rotateInUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes rotateInUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}@keyframes rotateOut{0%{-webkit-transform-origin:center;transform-origin:center;opacity:1}to{-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}@keyframes rotateOutDownLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutDownRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutUpLeft{0%{-webkit-transform-origin:left bottom;transform-origin:left bottom;opacity:1}to{-webkit-transform-origin:left bottom;transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}@keyframes rotateOutUpRight{0%{-webkit-transform-origin:right bottom;transform-origin:right bottom;opacity:1}to{-webkit-transform-origin:right bottom;transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes jackInTheBox{0%{opacity:0;-webkit-transform:scale(.1) rotate(30deg);transform:scale(.1) rotate(30deg);-webkit-transform-origin:center bottom;transform-origin:center bottom}50%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}70%{-webkit-transform:rotate(3deg);transform:rotate(3deg)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes jackInTheBox{0%{opacity:0;-webkit-transform:scale(.1) rotate(30deg);transform:scale(.1) rotate(30deg);-webkit-transform-origin:center bottom;transform-origin:center bottom}50%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}70%{-webkit-transform:rotate(3deg);transform:rotate(3deg)}to{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}.jackInTheBox{-webkit-animation-name:jackInTheBox;animation-name:jackInTheBox}@-webkit-keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.delay-1s{-webkit-animation-delay:1s;animation-delay:1s}.animated.delay-2s{-webkit-animation-delay:2s;animation-delay:2s}.animated.delay-3s{-webkit-animation-delay:3s;animation-delay:3s}.animated.delay-4s{-webkit-animation-delay:4s;animation-delay:4s}.animated.delay-5s{-webkit-animation-delay:5s;animation-delay:5s}.animated.fast{-webkit-animation-duration:.8s;animation-duration:.8s}.animated.faster{-webkit-animation-duration:.5s;animation-duration:.5s}.animated.slow{-webkit-animation-duration:2s;animation-duration:2s}.animated.slower{-webkit-animation-duration:3s;animation-duration:3s}@media (prefers-reduced-motion){.animated{-webkit-animation:unset!important;animation:unset!important;-webkit-transition:none!important;transition:none!important}}", ""]);
	
	// exports


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1502);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../sass-loader/index.js!./font-awesome.scss", function() {
				var newContent = require("!!../../css-loader/index.js!../../sass-loader/index.js!./font-awesome.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(1503) + ");src:url(" + __webpack_require__(1504) + "?#iefix&v=4.7.0) format(\"embedded-opentype\"),url(" + __webpack_require__(1505) + ") format(\"woff2\"),url(" + __webpack_require__(1506) + ") format(\"woff\"),url(" + __webpack_require__(1507) + ") format(\"truetype\"),url(" + __webpack_require__(1508) + "#fontawesomeregular) format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14286em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14286em;width:2.14286em;top:.14286em;text-align:center}.fa-li.fa-lg{left:-1.85714em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "674f50d287a8c48dc19ba404d20fe713.eot";

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "af7ae505a9eed503f8b8e6982036873e.woff2";

/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fee66e712a8a08eef5805a46892932ad.woff";

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "b06871f281fee6b241d60582ae9369b9.ttf";

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "912ec66d7572ff821749319396470bde.svg";

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1510);
	module.exports = 'angular-loading-bar';


/***/ }),
/* 1510 */
/***/ (function(module, exports) {

	/*! 
	 * angular-loading-bar v0.9.0
	 * https://chieffancypants.github.io/angular-loading-bar
	 * Copyright (c) 2016 Wes Cruver
	 * License: MIT
	 */
	/*
	 * angular-loading-bar
	 *
	 * intercepts XHR requests and creates a loading bar.
	 * Based on the excellent nprogress work by rstacruz (more info in readme)
	 *
	 * (c) 2013 Wes Cruver
	 * License: MIT
	 */
	
	
	(function() {
	
	'use strict';
	
	// Alias the loading bar for various backwards compatibilities since the project has matured:
	angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
	angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);
	
	
	/**
	 * loadingBarInterceptor service
	 *
	 * Registers itself as an Angular interceptor and listens for XHR requests.
	 */
	angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
	  .config(['$httpProvider', function ($httpProvider) {
	
	    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {
	
	      /**
	       * The total number of requests made
	       */
	      var reqsTotal = 0;
	
	      /**
	       * The number of requests completed (either successfully or not)
	       */
	      var reqsCompleted = 0;
	
	      /**
	       * The amount of time spent fetching before showing the loading bar
	       */
	      var latencyThreshold = cfpLoadingBar.latencyThreshold;
	
	      /**
	       * $timeout handle for latencyThreshold
	       */
	      var startTimeout;
	
	
	      /**
	       * calls cfpLoadingBar.complete() which removes the
	       * loading bar from the DOM.
	       */
	      function setComplete() {
	        $timeout.cancel(startTimeout);
	        cfpLoadingBar.complete();
	        reqsCompleted = 0;
	        reqsTotal = 0;
	      }
	
	      /**
	       * Determine if the response has already been cached
	       * @param  {Object}  config the config option from the request
	       * @return {Boolean} retrns true if cached, otherwise false
	       */
	      function isCached(config) {
	        var cache;
	        var defaultCache = $cacheFactory.get('$http');
	        var defaults = $httpProvider.defaults;
	
	        // Choose the proper cache source. Borrowed from angular: $http service
	        if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	            cache = angular.isObject(config.cache) ? config.cache
	              : angular.isObject(defaults.cache) ? defaults.cache
	              : defaultCache;
	        }
	
	        var cached = cache !== undefined ?
	          cache.get(config.url) !== undefined : false;
	
	        if (config.cached !== undefined && cached !== config.cached) {
	          return config.cached;
	        }
	        config.cached = cached;
	        return cached;
	      }
	
	
	      return {
	        'request': function(config) {
	          // Check to make sure this request hasn't already been cached and that
	          // the requester didn't explicitly ask us to ignore this request:
	          if (!config.ignoreLoadingBar && !isCached(config)) {
	            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
	            if (reqsTotal === 0) {
	              startTimeout = $timeout(function() {
	                cfpLoadingBar.start();
	              }, latencyThreshold);
	            }
	            reqsTotal++;
	            cfpLoadingBar.set(reqsCompleted / reqsTotal);
	          }
	          return config;
	        },
	
	        'response': function(response) {
	          if (!response || !response.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return response;
	          }
	
	          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return response;
	        },
	
	        'responseError': function(rejection) {
	          if (!rejection || !rejection.config) {
	            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
	            return $q.reject(rejection);
	          }
	
	          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
	            reqsCompleted++;
	            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
	            if (reqsCompleted >= reqsTotal) {
	              setComplete();
	            } else {
	              cfpLoadingBar.set(reqsCompleted / reqsTotal);
	            }
	          }
	          return $q.reject(rejection);
	        }
	      };
	    }];
	
	    $httpProvider.interceptors.push(interceptor);
	  }]);
	
	
	/**
	 * Loading Bar
	 *
	 * This service handles adding and removing the actual element in the DOM.
	 * Generally, best practices for DOM manipulation is to take place in a
	 * directive, but because the element itself is injected in the DOM only upon
	 * XHR requests, and it's likely needed on every view, the best option is to
	 * use a service.
	 */
	angular.module('cfp.loadingBar', [])
	  .provider('cfpLoadingBar', function() {
	
	    this.autoIncrement = true;
	    this.includeSpinner = true;
	    this.includeBar = true;
	    this.latencyThreshold = 100;
	    this.startSize = 0.02;
	    this.parentSelector = 'body';
	    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
	    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';
	
	    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
	      var $animate;
	      var $parentSelector = this.parentSelector,
	        loadingBarContainer = angular.element(this.loadingBarTemplate),
	        loadingBar = loadingBarContainer.find('div').eq(0),
	        spinner = angular.element(this.spinnerTemplate);
	
	      var incTimeout,
	        completeTimeout,
	        started = false,
	        status = 0;
	
	      var autoIncrement = this.autoIncrement;
	      var includeSpinner = this.includeSpinner;
	      var includeBar = this.includeBar;
	      var startSize = this.startSize;
	
	      /**
	       * Inserts the loading bar element into the dom, and sets it to 2%
	       */
	      function _start() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $timeout.cancel(completeTimeout);
	
	        // do not continually broadcast the started event:
	        if (started) {
	          return;
	        }
	
	        var document = $document[0];
	        var parent = document.querySelector ?
	          document.querySelector($parentSelector)
	          : $document.find($parentSelector)[0]
	        ;
	
	        if (! parent) {
	          parent = document.getElementsByTagName('body')[0];
	        }
	
	        var $parent = angular.element(parent);
	        var $after = parent.lastChild && angular.element(parent.lastChild);
	
	        $rootScope.$broadcast('cfpLoadingBar:started');
	        started = true;
	
	        if (includeBar) {
	          $animate.enter(loadingBarContainer, $parent, $after);
	        }
	
	        if (includeSpinner) {
	          $animate.enter(spinner, $parent, loadingBarContainer);
	        }
	
	        _set(startSize);
	      }
	
	      /**
	       * Set the loading bar's width to a certain percent.
	       *
	       * @param n any value between 0 and 1
	       */
	      function _set(n) {
	        if (!started) {
	          return;
	        }
	        var pct = (n * 100) + '%';
	        loadingBar.css('width', pct);
	        status = n;
	
	        // increment loadingbar to give the illusion that there is always
	        // progress but make sure to cancel the previous timeouts so we don't
	        // have multiple incs running at the same time.
	        if (autoIncrement) {
	          $timeout.cancel(incTimeout);
	          incTimeout = $timeout(function() {
	            _inc();
	          }, 250);
	        }
	      }
	
	      /**
	       * Increments the loading bar by a random amount
	       * but slows down as it progresses
	       */
	      function _inc() {
	        if (_status() >= 1) {
	          return;
	        }
	
	        var rnd = 0;
	
	        // TODO: do this mathmatically instead of through conditions
	
	        var stat = _status();
	        if (stat >= 0 && stat < 0.25) {
	          // Start out between 3 - 6% increments
	          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
	        } else if (stat >= 0.25 && stat < 0.65) {
	          // increment between 0 - 3%
	          rnd = (Math.random() * 3) / 100;
	        } else if (stat >= 0.65 && stat < 0.9) {
	          // increment between 0 - 2%
	          rnd = (Math.random() * 2) / 100;
	        } else if (stat >= 0.9 && stat < 0.99) {
	          // finally, increment it .5 %
	          rnd = 0.005;
	        } else {
	          // after 99%, don't increment:
	          rnd = 0;
	        }
	
	        var pct = _status() + rnd;
	        _set(pct);
	      }
	
	      function _status() {
	        return status;
	      }
	
	      function _completeAnimation() {
	        status = 0;
	        started = false;
	      }
	
	      function _complete() {
	        if (!$animate) {
	          $animate = $injector.get('$animate');
	        }
	
	        $rootScope.$broadcast('cfpLoadingBar:completed');
	        _set(1);
	
	        $timeout.cancel(completeTimeout);
	
	        // Attempt to aggregate any start/complete calls within 500ms:
	        completeTimeout = $timeout(function() {
	          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
	          if (promise && promise.then) {
	            promise.then(_completeAnimation);
	          }
	          $animate.leave(spinner);
	        }, 500);
	      }
	
	      return {
	        start            : _start,
	        set              : _set,
	        status           : _status,
	        inc              : _inc,
	        complete         : _complete,
	        autoIncrement    : this.autoIncrement,
	        includeSpinner   : this.includeSpinner,
	        latencyThreshold : this.latencyThreshold,
	        parentSelector   : this.parentSelector,
	        startSize        : this.startSize
	      };
	
	
	    }];     //
	  });       // wtf javascript. srsly
	})();       //


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1512);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./loading-bar.min.css", function() {
				var newContent = require("!!../../css-loader/index.js!./loading-bar.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "#loading-bar,#loading-bar-spinner{pointer-events:none;-webkit-pointer-events:none;-webkit-transition:all .35s linear;-moz-transition:.35s linear all;-o-transition:.35s linear all;transition:all .35s linear}#loading-bar-spinner.ng-enter,#loading-bar-spinner.ng-leave.ng-leave-active,#loading-bar.ng-enter,#loading-bar.ng-leave.ng-leave-active{opacity:0}#loading-bar-spinner.ng-enter.ng-enter-active,#loading-bar-spinner.ng-leave,#loading-bar.ng-enter.ng-enter-active,#loading-bar.ng-leave{opacity:1}#loading-bar .bar{-webkit-transition:width .35s;-moz-transition:width .35s;-o-transition:width .35s;transition:width .35s;background:#29d;position:fixed;z-index:10002;top:0;left:0;width:100%;height:2px;border-bottom-right-radius:1px;border-top-right-radius:1px}#loading-bar .peg{position:absolute;width:70px;right:0;top:0;height:2px;opacity:.45;-moz-box-shadow:#29d 1px 0 6px 1px;-ms-box-shadow:#29d 1px 0 6px 1px;-webkit-box-shadow:#29d 1px 0 6px 1px;box-shadow:1px 0 6px 1px #29d;-moz-border-radius:100%;-webkit-border-radius:100%;border-radius:100%}#loading-bar-spinner{display:block;position:fixed;z-index:10002;top:10px;left:10px}#loading-bar-spinner .spinner-icon{width:14px;height:14px;border:2px solid transparent;border-top-color:#29d;border-left-color:#29d;border-radius:50%;-webkit-animation:loading-bar-spinner .4s linear infinite;-moz-animation:loading-bar-spinner .4s linear infinite;-ms-animation:loading-bar-spinner .4s linear infinite;-o-animation:loading-bar-spinner .4s linear infinite;animation:loading-bar-spinner .4s linear infinite}@-webkit-keyframes loading-bar-spinner{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-moz-keyframes loading-bar-spinner{0%{-moz-transform:rotate(0);transform:rotate(0)}to{-moz-transform:rotate(1turn);transform:rotate(1turn)}}@-o-keyframes loading-bar-spinner{0%{-o-transform:rotate(0);transform:rotate(0)}to{-o-transform:rotate(1turn);transform:rotate(1turn)}}@-ms-keyframes loading-bar-spinner{0%{-ms-transform:rotate(0);transform:rotate(0)}to{-ms-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-bar-spinner{0%{transform:rotate(0)}to{transform:rotate(1turn)}}", ""]);
	
	// exports


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1514);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./angular-ui-notification.css", function() {
				var newContent = require("!!../../css-loader/index.js!./angular-ui-notification.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".ui-notification{position:fixed;z-index:9999;width:300px;-webkit-transition:all .5s ease;-o-transition:all ease .5s;transition:all .5s ease;color:#fff;border-radius:0;background:#337ab7;box-shadow:5px 5px 10px rgba(0,0,0,.3)}.ui-notification.clickable{cursor:pointer}.ui-notification.clickable:hover{opacity:.7}.ui-notification.killed{-webkit-transition:opacity 1s ease;-o-transition:opacity ease 1s;transition:opacity 1s ease;opacity:0}.ui-notification>h3{font-size:14px;font-weight:700;display:block;margin:10px 10px 0;padding:0 0 5px;text-align:left;border-bottom:1px solid hsla(0,0%,100%,.3)}.ui-notification a{color:#fff}.ui-notification a:hover{text-decoration:underline}.ui-notification>.message{margin:10px}.ui-notification.warning{color:#fff;background:#f0ad4e}.ui-notification.error{color:#fff;background:#d9534f}.ui-notification.success{color:#fff;background:#5cb85c}.ui-notification.info{color:#fff;background:#5bc0de}", ""]);
	
	// exports


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Satellizer 0.15.5
	 * (c) 2016 Sahat Yalkabov 
	 * License: MIT 
	 */
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.satellizer = factory());
	}(this, function () { 'use strict';
	
	    var Config = (function () {
	        function Config() {
	            this.baseUrl = '/';
	            this.loginUrl = '/auth/login';
	            this.signupUrl = '/auth/signup';
	            this.unlinkUrl = '/auth/unlink/';
	            this.tokenName = 'token';
	            this.tokenPrefix = 'satellizer';
	            this.tokenHeader = 'Authorization';
	            this.tokenType = 'Bearer';
	            this.storageType = 'localStorage';
	            this.tokenRoot = null;
	            this.withCredentials = false;
	            this.providers = {
	                facebook: {
	                    name: 'facebook',
	                    url: '/auth/facebook',
	                    authorizationEndpoint: 'https://www.facebook.com/v2.5/dialog/oauth',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ',',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 580, height: 400 }
	                },
	                google: {
	                    name: 'google',
	                    url: '/auth/google',
	                    authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    optionalUrlParams: ['display', 'state'],
	                    scope: ['profile', 'email'],
	                    scopePrefix: 'openid',
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 452, height: 633 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                },
	                github: {
	                    name: 'github',
	                    url: '/auth/github',
	                    authorizationEndpoint: 'https://github.com/login/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['scope'],
	                    scope: ['user:email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1020, height: 618 }
	                },
	                instagram: {
	                    name: 'instagram',
	                    url: '/auth/instagram',
	                    authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['basic'],
	                    scopeDelimiter: '+',
	                    oauthType: '2.0'
	                },
	                linkedin: {
	                    name: 'linkedin',
	                    url: '/auth/linkedin',
	                    authorizationEndpoint: 'https://www.linkedin.com/uas/oauth2/authorization',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['state'],
	                    scope: ['r_emailaddress'],
	                    scopeDelimiter: ' ',
	                    state: 'STATE',
	                    oauthType: '2.0',
	                    popupOptions: { width: 527, height: 582 }
	                },
	                twitter: {
	                    name: 'twitter',
	                    url: '/auth/twitter',
	                    authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
	                    redirectUri: window.location.origin,
	                    oauthType: '1.0',
	                    popupOptions: { width: 495, height: 645 }
	                },
	                twitch: {
	                    name: 'twitch',
	                    url: '/auth/twitch',
	                    authorizationEndpoint: 'https://api.twitch.tv/kraken/oauth2/authorize',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['scope'],
	                    scope: ['user_read'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                live: {
	                    name: 'live',
	                    url: '/auth/live',
	                    authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
	                    redirectUri: window.location.origin,
	                    requiredUrlParams: ['display', 'scope'],
	                    scope: ['wl.emails'],
	                    scopeDelimiter: ' ',
	                    display: 'popup',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 560 }
	                },
	                yahoo: {
	                    name: 'yahoo',
	                    url: '/auth/yahoo',
	                    authorizationEndpoint: 'https://api.login.yahoo.com/oauth2/request_auth',
	                    redirectUri: window.location.origin,
	                    scope: [],
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 559, height: 519 }
	                },
	                bitbucket: {
	                    name: 'bitbucket',
	                    url: '/auth/bitbucket',
	                    authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
	                    redirectUri: window.location.origin + '/',
	                    requiredUrlParams: ['scope'],
	                    scope: ['email'],
	                    scopeDelimiter: ' ',
	                    oauthType: '2.0',
	                    popupOptions: { width: 1028, height: 529 }
	                },
	                spotify: {
	                    name: 'spotify',
	                    url: '/auth/spotify',
	                    authorizationEndpoint: 'https://accounts.spotify.com/authorize',
	                    redirectUri: window.location.origin,
	                    optionalUrlParams: ['state'],
	                    requiredUrlParams: ['scope'],
	                    scope: ['user-read-email'],
	                    scopePrefix: '',
	                    scopeDelimiter: ',',
	                    oauthType: '2.0',
	                    popupOptions: { width: 500, height: 530 },
	                    state: function () { return encodeURIComponent(Math.random().toString(36).substr(2)); }
	                }
	            };
	            this.httpInterceptor = function () { return true; };
	        }
	        Object.defineProperty(Config, "getConstant", {
	            get: function () {
	                return new Config();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        return Config;
	    }());
	    ;
	
	    var AuthProvider = (function () {
	        function AuthProvider(SatellizerConfig) {
	            this.SatellizerConfig = SatellizerConfig;
	        }
	        Object.defineProperty(AuthProvider.prototype, "baseUrl", {
	            get: function () { return this.SatellizerConfig.baseUrl; },
	            set: function (value) { this.SatellizerConfig.baseUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "loginUrl", {
	            get: function () { return this.SatellizerConfig.loginUrl; },
	            set: function (value) { this.SatellizerConfig.loginUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "signupUrl", {
	            get: function () { return this.SatellizerConfig.signupUrl; },
	            set: function (value) { this.SatellizerConfig.signupUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "unlinkUrl", {
	            get: function () { return this.SatellizerConfig.unlinkUrl; },
	            set: function (value) { this.SatellizerConfig.unlinkUrl = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenRoot", {
	            get: function () { return this.SatellizerConfig.tokenRoot; },
	            set: function (value) { this.SatellizerConfig.tokenRoot = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenName", {
	            get: function () { return this.SatellizerConfig.tokenName; },
	            set: function (value) { this.SatellizerConfig.tokenName = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenPrefix", {
	            get: function () { return this.SatellizerConfig.tokenPrefix; },
	            set: function (value) { this.SatellizerConfig.tokenPrefix = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenHeader", {
	            get: function () { return this.SatellizerConfig.tokenHeader; },
	            set: function (value) { this.SatellizerConfig.tokenHeader = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "tokenType", {
	            get: function () { return this.SatellizerConfig.tokenType; },
	            set: function (value) { this.SatellizerConfig.tokenType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "withCredentials", {
	            get: function () { return this.SatellizerConfig.withCredentials; },
	            set: function (value) { this.SatellizerConfig.withCredentials = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "storageType", {
	            get: function () { return this.SatellizerConfig.storageType; },
	            set: function (value) { this.SatellizerConfig.storageType = value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AuthProvider.prototype, "httpInterceptor", {
	            get: function () { return this.SatellizerConfig.httpInterceptor; },
	            set: function (value) {
	                if (typeof value === 'function') {
	                    this.SatellizerConfig.httpInterceptor = value;
	                }
	                else {
	                    this.SatellizerConfig.httpInterceptor = function () { return value; };
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AuthProvider.prototype.facebook = function (options) {
	            angular.extend(this.SatellizerConfig.providers.facebook, options);
	        };
	        AuthProvider.prototype.google = function (options) {
	            angular.extend(this.SatellizerConfig.providers.google, options);
	        };
	        AuthProvider.prototype.github = function (options) {
	            angular.extend(this.SatellizerConfig.providers.github, options);
	        };
	        AuthProvider.prototype.instagram = function (options) {
	            angular.extend(this.SatellizerConfig.providers.instagram, options);
	        };
	        AuthProvider.prototype.linkedin = function (options) {
	            angular.extend(this.SatellizerConfig.providers.linkedin, options);
	        };
	        AuthProvider.prototype.twitter = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitter, options);
	        };
	        AuthProvider.prototype.twitch = function (options) {
	            angular.extend(this.SatellizerConfig.providers.twitch, options);
	        };
	        AuthProvider.prototype.live = function (options) {
	            angular.extend(this.SatellizerConfig.providers.live, options);
	        };
	        AuthProvider.prototype.yahoo = function (options) {
	            angular.extend(this.SatellizerConfig.providers.yahoo, options);
	        };
	        AuthProvider.prototype.bitbucket = function (options) {
	            angular.extend(this.SatellizerConfig.providers.bitbucket, options);
	        };
	        AuthProvider.prototype.spotify = function (options) {
	            angular.extend(this.SatellizerConfig.providers.spotify, options);
	        };
	        AuthProvider.prototype.oauth1 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '1.0'
	            });
	        };
	        AuthProvider.prototype.oauth2 = function (options) {
	            this.SatellizerConfig.providers[options.name] = angular.extend(options, {
	                oauthType: '2.0'
	            });
	        };
	        AuthProvider.prototype.$get = function (SatellizerShared, SatellizerLocal, SatellizerOAuth) {
	            return {
	                login: function (user, options) { return SatellizerLocal.login(user, options); },
	                signup: function (user, options) { return SatellizerLocal.signup(user, options); },
	                logout: function () { return SatellizerShared.logout(); },
	                authenticate: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                link: function (name, data) { return SatellizerOAuth.authenticate(name, data); },
	                unlink: function (name, options) { return SatellizerOAuth.unlink(name, options); },
	                isAuthenticated: function () { return SatellizerShared.isAuthenticated(); },
	                getPayload: function () { return SatellizerShared.getPayload(); },
	                getToken: function () { return SatellizerShared.getToken(); },
	                setToken: function (token) { return SatellizerShared.setToken({ access_token: token }); },
	                removeToken: function () { return SatellizerShared.removeToken(); },
	                setStorageType: function (type) { return SatellizerShared.setStorageType(type); }
	            };
	        };
	        AuthProvider.$inject = ['SatellizerConfig'];
	        return AuthProvider;
	    }());
	    AuthProvider.prototype.$get.$inject = ['SatellizerShared', 'SatellizerLocal', 'SatellizerOAuth'];
	
	    function joinUrl(baseUrl, url) {
	        if (/^(?:[a-z]+:)?\/\//i.test(url)) {
	            return url;
	        }
	        var joined = [baseUrl, url].join('/');
	        var normalize = function (str) {
	            return str
	                .replace(/[\/]+/g, '/')
	                .replace(/\/\?/g, '?')
	                .replace(/\/\#/g, '#')
	                .replace(/\:\//g, '://');
	        };
	        return normalize(joined);
	    }
	    function getFullUrlPath(location) {
	        var isHttps = location.protocol === 'https:';
	        return location.protocol + '//' + location.hostname +
	            ':' + (location.port || (isHttps ? '443' : '80')) +
	            (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname);
	    }
	    function parseQueryString(str) {
	        var obj = {};
	        var key;
	        var value;
	        angular.forEach((str || '').split('&'), function (keyValue) {
	            if (keyValue) {
	                value = keyValue.split('=');
	                key = decodeURIComponent(value[0]);
	                obj[key] = angular.isDefined(value[1]) ? decodeURIComponent(value[1]) : true;
	            }
	        });
	        return obj;
	    }
	    function decodeBase64(str) {
	        var buffer;
	        if (typeof module !== 'undefined' && module.exports) {
	            try {
	                buffer = __webpack_require__(966).Buffer;
	            }
	            catch (err) {
	            }
	        }
	        var fromCharCode = String.fromCharCode;
	        var re_btou = new RegExp([
	            '[\xC0-\xDF][\x80-\xBF]',
	            '[\xE0-\xEF][\x80-\xBF]{2}',
	            '[\xF0-\xF7][\x80-\xBF]{3}'
	        ].join('|'), 'g');
	        var cb_btou = function (cccc) {
	            switch (cccc.length) {
	                case 4:
	                    var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
	                        | ((0x3f & cccc.charCodeAt(1)) << 12)
	                        | ((0x3f & cccc.charCodeAt(2)) << 6)
	                        | (0x3f & cccc.charCodeAt(3));
	                    var offset = cp - 0x10000;
	                    return (fromCharCode((offset >>> 10) + 0xD800)
	                        + fromCharCode((offset & 0x3FF) + 0xDC00));
	                case 3:
	                    return fromCharCode(((0x0f & cccc.charCodeAt(0)) << 12)
	                        | ((0x3f & cccc.charCodeAt(1)) << 6)
	                        | (0x3f & cccc.charCodeAt(2)));
	                default:
	                    return fromCharCode(((0x1f & cccc.charCodeAt(0)) << 6)
	                        | (0x3f & cccc.charCodeAt(1)));
	            }
	        };
	        var btou = function (b) {
	            return b.replace(re_btou, cb_btou);
	        };
	        var _decode = buffer ? function (a) {
	            return (a.constructor === buffer.constructor
	                ? a : new buffer(a, 'base64')).toString();
	        }
	            : function (a) {
	                return btou(atob(a));
	            };
	        return _decode(String(str).replace(/[-_]/g, function (m0) {
	            return m0 === '-' ? '+' : '/';
	        })
	            .replace(/[^A-Za-z0-9\+\/]/g, ''));
	    }
	
	    var Shared = (function () {
	        function Shared($q, $window, SatellizerConfig, SatellizerStorage) {
	            this.$q = $q;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerStorage = SatellizerStorage;
	            var _a = this.SatellizerConfig, tokenName = _a.tokenName, tokenPrefix = _a.tokenPrefix;
	            this.prefixedTokenName = tokenPrefix ? [tokenPrefix, tokenName].join('_') : tokenName;
	        }
	        Shared.prototype.getToken = function () {
	            return this.SatellizerStorage.get(this.prefixedTokenName);
	        };
	        Shared.prototype.getPayload = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token && token.split('.').length === 3) {
	                try {
	                    var base64Url = token.split('.')[1];
	                    var base64 = base64Url.replace('-', '+').replace('_', '/');
	                    return JSON.parse(decodeBase64(base64));
	                }
	                catch (e) {
	                }
	            }
	        };
	        Shared.prototype.setToken = function (response) {
	            var tokenRoot = this.SatellizerConfig.tokenRoot;
	            var tokenName = this.SatellizerConfig.tokenName;
	            var accessToken = response && response.access_token;
	            var token;
	            if (accessToken) {
	                if (angular.isObject(accessToken) && angular.isObject(accessToken.data)) {
	                    response = accessToken;
	                }
	                else if (angular.isString(accessToken)) {
	                    token = accessToken;
	                }
	            }
	            if (!token && response) {
	                var tokenRootData = tokenRoot && tokenRoot.split('.').reduce(function (o, x) { return o[x]; }, response.data);
	                token = tokenRootData ? tokenRootData[tokenName] : response.data && response.data[tokenName];
	            }
	            if (token) {
	                this.SatellizerStorage.set(this.prefixedTokenName, token);
	            }
	        };
	        Shared.prototype.removeToken = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	        };
	        Shared.prototype.isAuthenticated = function () {
	            var token = this.SatellizerStorage.get(this.prefixedTokenName);
	            if (token) {
	                if (token.split('.').length === 3) {
	                    try {
	                        var base64Url = token.split('.')[1];
	                        var base64 = base64Url.replace('-', '+').replace('_', '/');
	                        var exp = JSON.parse(this.$window.atob(base64)).exp;
	                        if (typeof exp === 'number') {
	                            return Math.round(new Date().getTime() / 1000) < exp;
	                        }
	                    }
	                    catch (e) {
	                        return true; // Pass: Non-JWT token that looks like JWT
	                    }
	                }
	                return true; // Pass: All other tokens
	            }
	            return false; // Fail: No token at all
	        };
	        Shared.prototype.logout = function () {
	            this.SatellizerStorage.remove(this.prefixedTokenName);
	            return this.$q.when();
	        };
	        Shared.prototype.setStorageType = function (type) {
	            this.SatellizerConfig.storageType = type;
	        };
	        Shared.$inject = ['$q', '$window', 'SatellizerConfig', 'SatellizerStorage'];
	        return Shared;
	    }());
	
	    var Local = (function () {
	        function Local($http, SatellizerConfig, SatellizerShared) {
	            this.$http = $http;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	        }
	        Local.prototype.login = function (user, options) {
	            var _this = this;
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.loginUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options).then(function (response) {
	                _this.SatellizerShared.setToken(response);
	                return response;
	            });
	        };
	        Local.prototype.signup = function (user, options) {
	            if (options === void 0) { options = {}; }
	            options.url = options.url ? options.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.signupUrl);
	            options.data = user || options.data;
	            options.method = options.method || 'POST';
	            options.withCredentials = options.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(options);
	        };
	        Local.$inject = ['$http', 'SatellizerConfig', 'SatellizerShared'];
	        return Local;
	    }());
	
	    var Popup = (function () {
	        function Popup($interval, $window, $q) {
	            this.$interval = $interval;
	            this.$window = $window;
	            this.$q = $q;
	            this.popup = null;
	            this.defaults = {
	                redirectUri: null
	            };
	        }
	        Popup.prototype.stringifyOptions = function (options) {
	            var parts = [];
	            angular.forEach(options, function (value, key) {
	                parts.push(key + '=' + value);
	            });
	            return parts.join(',');
	        };
	        Popup.prototype.open = function (url, name, popupOptions, redirectUri, dontPoll) {
	            var width = popupOptions.width || 500;
	            var height = popupOptions.height || 500;
	            var options = this.stringifyOptions({
	                width: width,
	                height: height,
	                top: this.$window.screenY + ((this.$window.outerHeight - height) / 2.5),
	                left: this.$window.screenX + ((this.$window.outerWidth - width) / 2)
	            });
	            var popupName = this.$window['cordova'] || this.$window.navigator.userAgent.indexOf('CriOS') > -1 ? '_blank' : name;
	            this.popup = this.$window.open(url, popupName, options);
	            if (this.popup && this.popup.focus) {
	                this.popup.focus();
	            }
	            if (dontPoll) {
	                return;
	            }
	            if (this.$window['cordova']) {
	                return this.eventListener(redirectUri);
	            }
	            else {
	                if (url === 'about:blank') {
	                    this.popup.location = url;
	                }
	                return this.polling(redirectUri);
	            }
	        };
	        Popup.prototype.polling = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var redirectUriParser = document.createElement('a');
	                redirectUriParser.href = redirectUri;
	                var redirectUriPath = getFullUrlPath(redirectUriParser);
	                var polling = _this.$interval(function () {
	                    if (!_this.popup || _this.popup.closed || _this.popup.closed === undefined) {
	                        _this.$interval.cancel(polling);
	                        reject(new Error('The popup window was closed'));
	                    }
	                    try {
	                        var popupWindowPath = getFullUrlPath(_this.popup.location);
	                        if (popupWindowPath === redirectUriPath) {
	                            if (_this.popup.location.search || _this.popup.location.hash) {
	                                var query = parseQueryString(_this.popup.location.search.substring(1).replace(/\/$/, ''));
	                                var hash = parseQueryString(_this.popup.location.hash.substring(1).replace(/[\/$]/, ''));
	                                var params = angular.extend({}, query, hash);
	                                if (params.error) {
	                                    reject(new Error(params.error));
	                                }
	                                else {
	                                    resolve(params);
	                                }
	                            }
	                            else {
	                                reject(new Error('OAuth redirect has occurred but no query or hash parameters were found. ' +
	                                    'They were either not set during the redirect, or were removed—typically by a ' +
	                                    'routing library—before Satellizer could read it.'));
	                            }
	                            _this.$interval.cancel(polling);
	                            _this.popup.close();
	                        }
	                    }
	                    catch (error) {
	                    }
	                }, 500);
	            });
	        };
	        Popup.prototype.eventListener = function (redirectUri) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                _this.popup.addEventListener('loadstart', function (event) {
	                    if (event.url.indexOf(redirectUri) !== 0) {
	                        return;
	                    }
	                    var parser = document.createElement('a');
	                    parser.href = event.url;
	                    if (parser.search || parser.hash) {
	                        var query = parseQueryString(parser.search.substring(1).replace(/\/$/, ''));
	                        var hash = parseQueryString(parser.hash.substring(1).replace(/[\/$]/, ''));
	                        var params = angular.extend({}, query, hash);
	                        if (params.error) {
	                            reject(new Error(params.error));
	                        }
	                        else {
	                            resolve(params);
	                        }
	                        _this.popup.close();
	                    }
	                });
	                _this.popup.addEventListener('loaderror', function () {
	                    reject(new Error('Authorization failed'));
	                });
	                _this.popup.addEventListener('exit', function () {
	                    reject(new Error('The popup window was closed'));
	                });
	            });
	        };
	        Popup.$inject = ['$interval', '$window', '$q'];
	        return Popup;
	    }());
	
	    var OAuth1 = (function () {
	        function OAuth1($http, $window, SatellizerConfig, SatellizerPopup) {
	            this.$http = $http;
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.defaults = {
	                name: null,
	                url: null,
	                authorizationEndpoint: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                redirectUri: null,
	                requiredUrlParams: null,
	                defaultUrlParams: null,
	                oauthType: '1.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        ;
	        OAuth1.prototype.init = function (options, userData) {
	            var _this = this;
	            angular.extend(this.defaults, options);
	            var name = options.name, popupOptions = options.popupOptions;
	            var redirectUri = this.defaults.redirectUri;
	            // Should open an empty popup and wait until request token is received
	            if (!this.$window['cordova']) {
	                this.SatellizerPopup.open('about:blank', name, popupOptions, redirectUri, true);
	            }
	            return this.getRequestToken().then(function (response) {
	                return _this.openPopup(options, response).then(function (popupResponse) {
	                    return _this.exchangeForToken(popupResponse, userData);
	                });
	            });
	        };
	        OAuth1.prototype.openPopup = function (options, response) {
	            var url = [options.authorizationEndpoint, this.buildQueryString(response.data)].join('?');
	            var redirectUri = this.defaults.redirectUri;
	            if (this.$window['cordova']) {
	                return this.SatellizerPopup.open(url, options.name, options.popupOptions, redirectUri);
	            }
	            else {
	                this.SatellizerPopup.popup.location = url;
	                return this.SatellizerPopup.polling(redirectUri);
	            }
	        };
	        OAuth1.prototype.getRequestToken = function () {
	            var url = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(url, this.defaults);
	        };
	        OAuth1.prototype.exchangeForToken = function (oauthData, userData) {
	            var payload = angular.extend({}, userData, oauthData);
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ? joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) : this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth1.prototype.buildQueryString = function (obj) {
	            var str = [];
	            angular.forEach(obj, function (value, key) {
	                str.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	            });
	            return str.join('&');
	        };
	        OAuth1.$inject = ['$http', '$window', 'SatellizerConfig', 'SatellizerPopup'];
	        return OAuth1;
	    }());
	
	    var OAuth2 = (function () {
	        function OAuth2($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.defaults = {
	                name: null,
	                url: null,
	                clientId: null,
	                authorizationEndpoint: null,
	                redirectUri: null,
	                scope: null,
	                scopePrefix: null,
	                scopeDelimiter: null,
	                state: null,
	                requiredUrlParams: null,
	                defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
	                responseType: 'code',
	                responseParams: {
	                    code: 'code',
	                    clientId: 'clientId',
	                    redirectUri: 'redirectUri'
	                },
	                oauthType: '2.0',
	                popupOptions: { width: null, height: null }
	            };
	        }
	        OAuth2.camelCase = function (name) {
	            return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
	                return offset ? letter.toUpperCase() : letter;
	            });
	        };
	        OAuth2.prototype.init = function (options, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                angular.extend(_this.defaults, options);
	                var stateName = _this.defaults.name + '_state';
	                var _a = _this.defaults, name = _a.name, state = _a.state, popupOptions = _a.popupOptions, redirectUri = _a.redirectUri, responseType = _a.responseType;
	                if (typeof state === 'function') {
	                    _this.SatellizerStorage.set(stateName, state());
	                }
	                else if (typeof state === 'string') {
	                    _this.SatellizerStorage.set(stateName, state);
	                }
	                var url = [_this.defaults.authorizationEndpoint, _this.buildQueryString()].join('?');
	                _this.SatellizerPopup.open(url, name, popupOptions, redirectUri).then(function (oauth) {
	                    if (responseType === 'token' || !url) {
	                        return resolve(oauth);
	                    }
	                    if (oauth.state && oauth.state !== _this.SatellizerStorage.get(stateName)) {
	                        return reject(new Error('The value returned in the state parameter does not match the state value from your original ' +
	                            'authorization code request.'));
	                    }
	                    resolve(_this.exchangeForToken(oauth, userData));
	                }).catch(function (error) { return reject(error); });
	            });
	        };
	        OAuth2.prototype.exchangeForToken = function (oauthData, userData) {
	            var _this = this;
	            var payload = angular.extend({}, userData);
	            angular.forEach(this.defaults.responseParams, function (value, key) {
	                switch (key) {
	                    case 'code':
	                        payload[value] = oauthData.code;
	                        break;
	                    case 'clientId':
	                        payload[value] = _this.defaults.clientId;
	                        break;
	                    case 'redirectUri':
	                        payload[value] = _this.defaults.redirectUri;
	                        break;
	                    default:
	                        payload[value] = oauthData[key];
	                }
	            });
	            if (oauthData.state) {
	                payload.state = oauthData.state;
	            }
	            var exchangeForTokenUrl = this.SatellizerConfig.baseUrl ?
	                joinUrl(this.SatellizerConfig.baseUrl, this.defaults.url) :
	                this.defaults.url;
	            return this.$http.post(exchangeForTokenUrl, payload, { withCredentials: this.SatellizerConfig.withCredentials });
	        };
	        OAuth2.prototype.buildQueryString = function () {
	            var _this = this;
	            var keyValuePairs = [];
	            var urlParamsCategories = ['defaultUrlParams', 'requiredUrlParams', 'optionalUrlParams'];
	            angular.forEach(urlParamsCategories, function (paramsCategory) {
	                angular.forEach(_this.defaults[paramsCategory], function (paramName) {
	                    var camelizedName = OAuth2.camelCase(paramName);
	                    var paramValue = angular.isFunction(_this.defaults[paramName]) ? _this.defaults[paramName]() : _this.defaults[camelizedName];
	                    if (paramName === 'redirect_uri' && !paramValue) {
	                        return;
	                    }
	                    if (paramName === 'state') {
	                        var stateName = _this.defaults.name + '_state';
	                        paramValue = encodeURIComponent(_this.SatellizerStorage.get(stateName));
	                    }
	                    if (paramName === 'scope' && Array.isArray(paramValue)) {
	                        paramValue = paramValue.join(_this.defaults.scopeDelimiter);
	                        if (_this.defaults.scopePrefix) {
	                            paramValue = [_this.defaults.scopePrefix, paramValue].join(_this.defaults.scopeDelimiter);
	                        }
	                    }
	                    keyValuePairs.push([paramName, paramValue]);
	                });
	            });
	            return keyValuePairs.map(function (pair) { return pair.join('='); }).join('&');
	        };
	        OAuth2.$inject = ['$http', '$window', '$timeout', '$q', 'SatellizerConfig', 'SatellizerPopup', 'SatellizerStorage'];
	        return OAuth2;
	    }());
	
	    var OAuth = (function () {
	        function OAuth($http, $window, $timeout, $q, SatellizerConfig, SatellizerPopup, SatellizerStorage, SatellizerShared, SatellizerOAuth1, SatellizerOAuth2) {
	            this.$http = $http;
	            this.$window = $window;
	            this.$timeout = $timeout;
	            this.$q = $q;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerPopup = SatellizerPopup;
	            this.SatellizerStorage = SatellizerStorage;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerOAuth1 = SatellizerOAuth1;
	            this.SatellizerOAuth2 = SatellizerOAuth2;
	        }
	        OAuth.prototype.authenticate = function (name, userData) {
	            var _this = this;
	            return this.$q(function (resolve, reject) {
	                var provider = _this.SatellizerConfig.providers[name];
	                var oauth = null;
	                switch (provider.oauthType) {
	                    case '1.0':
	                        oauth = new OAuth1(_this.$http, _this.$window, _this.SatellizerConfig, _this.SatellizerPopup);
	                        break;
	                    case '2.0':
	                        oauth = new OAuth2(_this.$http, _this.$window, _this.$timeout, _this.$q, _this.SatellizerConfig, _this.SatellizerPopup, _this.SatellizerStorage);
	                        break;
	                    default:
	                        return reject(new Error('Invalid OAuth Type'));
	                }
	                return oauth.init(provider, userData).then(function (response) {
	                    if (provider.url) {
	                        _this.SatellizerShared.setToken(response);
	                    }
	                    resolve(response);
	                }).catch(function (error) {
	                    reject(error);
	                });
	            });
	        };
	        OAuth.prototype.unlink = function (provider, httpOptions) {
	            if (httpOptions === void 0) { httpOptions = {}; }
	            httpOptions.url = httpOptions.url ? httpOptions.url : joinUrl(this.SatellizerConfig.baseUrl, this.SatellizerConfig.unlinkUrl);
	            httpOptions.data = { provider: provider } || httpOptions.data;
	            httpOptions.method = httpOptions.method || 'POST';
	            httpOptions.withCredentials = httpOptions.withCredentials || this.SatellizerConfig.withCredentials;
	            return this.$http(httpOptions);
	        };
	        OAuth.$inject = [
	            '$http',
	            '$window',
	            '$timeout',
	            '$q',
	            'SatellizerConfig',
	            'SatellizerPopup',
	            'SatellizerStorage',
	            'SatellizerShared',
	            'SatellizerOAuth1',
	            'SatellizerOAuth2'
	        ];
	        return OAuth;
	    }());
	
	    var Storage = (function () {
	        function Storage($window, SatellizerConfig) {
	            this.$window = $window;
	            this.SatellizerConfig = SatellizerConfig;
	            this.memoryStore = {};
	        }
	        Storage.prototype.get = function (key) {
	            try {
	                return this.$window[this.SatellizerConfig.storageType].getItem(key);
	            }
	            catch (e) {
	                return this.memoryStore[key];
	            }
	        };
	        Storage.prototype.set = function (key, value) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].setItem(key, value);
	            }
	            catch (e) {
	                this.memoryStore[key] = value;
	            }
	        };
	        Storage.prototype.remove = function (key) {
	            try {
	                this.$window[this.SatellizerConfig.storageType].removeItem(key);
	            }
	            catch (e) {
	                delete this.memoryStore[key];
	            }
	        };
	        Storage.$inject = ['$window', 'SatellizerConfig'];
	        return Storage;
	    }());
	
	    var Interceptor = (function () {
	        function Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            var _this = this;
	            this.SatellizerConfig = SatellizerConfig;
	            this.SatellizerShared = SatellizerShared;
	            this.SatellizerStorage = SatellizerStorage;
	            this.request = function (config) {
	                if (config['skipAuthorization']) {
	                    return config;
	                }
	                if (_this.SatellizerShared.isAuthenticated() && _this.SatellizerConfig.httpInterceptor()) {
	                    var tokenName = _this.SatellizerConfig.tokenPrefix ?
	                        [_this.SatellizerConfig.tokenPrefix, _this.SatellizerConfig.tokenName].join('_') : _this.SatellizerConfig.tokenName;
	                    var token = _this.SatellizerStorage.get(tokenName);
	                    if (_this.SatellizerConfig.tokenHeader && _this.SatellizerConfig.tokenType) {
	                        token = _this.SatellizerConfig.tokenType + ' ' + token;
	                    }
	                    config.headers[_this.SatellizerConfig.tokenHeader] = token;
	                }
	                return config;
	            };
	        }
	        Interceptor.Factory = function (SatellizerConfig, SatellizerShared, SatellizerStorage) {
	            return new Interceptor(SatellizerConfig, SatellizerShared, SatellizerStorage);
	        };
	        Interceptor.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	        return Interceptor;
	    }());
	    Interceptor.Factory.$inject = ['SatellizerConfig', 'SatellizerShared', 'SatellizerStorage'];
	
	    var HttpProviderConfig = (function () {
	        function HttpProviderConfig($httpProvider) {
	            this.$httpProvider = $httpProvider;
	            $httpProvider.interceptors.push(Interceptor.Factory);
	        }
	        HttpProviderConfig.$inject = ['$httpProvider'];
	        return HttpProviderConfig;
	    }());
	
	    angular.module('satellizer', [])
	        .provider('$auth', ['SatellizerConfig', function (SatellizerConfig) { return new AuthProvider(SatellizerConfig); }])
	        .constant('SatellizerConfig', Config.getConstant)
	        .service('SatellizerShared', Shared)
	        .service('SatellizerLocal', Local)
	        .service('SatellizerPopup', Popup)
	        .service('SatellizerOAuth', OAuth)
	        .service('SatellizerOAuth2', OAuth2)
	        .service('SatellizerOAuth1', OAuth1)
	        .service('SatellizerStorage', Storage)
	        .service('SatellizerInterceptor', Interceptor)
	        .config(['$httpProvider', function ($httpProvider) { return new HttpProviderConfig($httpProvider); }]);
	    var ng1 = 'satellizer';
	
	    return ng1;
	
	}));
	//# sourceMappingURL=satellizer.js.map


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(1517)();
	
	__webpack_require__(1518)(Chart);
	__webpack_require__(1524)(Chart);
	__webpack_require__(1525)(Chart);
	__webpack_require__(1526)(Chart);
	__webpack_require__(1527)(Chart);
	__webpack_require__(1528)(Chart);
	__webpack_require__(1529)(Chart);
	__webpack_require__(1530)(Chart);
	__webpack_require__(1531)(Chart);
	__webpack_require__(1532)(Chart);
	__webpack_require__(1533)(Chart);
	__webpack_require__(1534)(Chart);
	__webpack_require__(1535)(Chart);
	
	__webpack_require__(1536)(Chart);
	__webpack_require__(1537)(Chart);
	__webpack_require__(1538)(Chart);
	__webpack_require__(1539)(Chart);
	
	__webpack_require__(1540)(Chart);
	__webpack_require__(1541)(Chart);
	__webpack_require__(1542)(Chart);
	__webpack_require__(1543)(Chart);
	__webpack_require__(1544)(Chart);
	__webpack_require__(1545)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(1546)(Chart);
	__webpack_require__(1547)(Chart);
	__webpack_require__(1548)(Chart);
	__webpack_require__(1549)(Chart);
	__webpack_require__(1550)(Chart);
	__webpack_require__(1551)(Chart);
	
	__webpack_require__(1552)(Chart);
	__webpack_require__(1553)(Chart);
	__webpack_require__(1554)(Chart);
	__webpack_require__(1555)(Chart);
	__webpack_require__(1556)(Chart);
	__webpack_require__(1557)(Chart);
	__webpack_require__(1558)(Chart);
	
	window.Chart = module.exports = Chart;


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(context, config) {
			var me = this;
			var helpers = Chart.helpers;
			me.config = config || {
				data: {
					datasets: []
				}
			};
	
			// Support a jQuery'd canvas element
			if (context.length && context[0].getContext) {
				context = context[0];
			}
	
			// Support a canvas domnode
			if (context.getContext) {
				context = context.getContext('2d');
			}
	
			me.ctx = context;
			me.canvas = context.canvas;
	
			context.canvas.style.display = context.canvas.style.display || 'block';
	
			// Figure out what the size of the chart will be.
			// If the canvas has a specified width and height, we use those else
			// we look to see if the canvas node has a CSS width and height.
			// If there is still no height, fill the parent container
			me.width = context.canvas.width || parseInt(helpers.getStyle(context.canvas, 'width'), 10) || helpers.getMaximumWidth(context.canvas);
			me.height = context.canvas.height || parseInt(helpers.getStyle(context.canvas, 'height'), 10) || helpers.getMaximumHeight(context.canvas);
	
			me.aspectRatio = me.width / me.height;
	
			if (isNaN(me.aspectRatio) || isFinite(me.aspectRatio) === false) {
				// If the canvas has no size, try and figure out what the aspect ratio will be.
				// Some charts prefer square canvases (pie, radar, etc). If that is specified, use that
				// else use the canvas default ratio of 2
				me.aspectRatio = config.aspectRatio !== undefined ? config.aspectRatio : 2;
			}
	
			// Store the original style of the element so we can set it back
			me.originalCanvasStyleWidth = context.canvas.style.width;
			me.originalCanvasStyleHeight = context.canvas.style.height;
	
			// High pixel density displays - multiply the size of the canvas height/width by the device pixel ratio, then scale.
			helpers.retinaScale(me);
			me.controller = new Chart.Controller(me);
	
			// Always bind this so that if the responsive state changes we still work
			helpers.addResizeListener(context.canvas.parentNode, function() {
				if (me.controller && me.controller.config.options.responsive) {
					me.controller.resize();
				}
			});
	
			return me.controller ? me.controller : me;
	
		};
	
		// Globally expose the defaults to allow for user updating/changing
		Chart.defaults = {
			global: {
				responsive: true,
				responsiveAnimationDuration: 0,
				maintainAspectRatio: true,
				events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
				hover: {
					onHover: null,
					mode: 'single',
					animationDuration: 400
				},
				onClick: null,
				defaultColor: 'rgba(0,0,0,0.1)',
				defaultFontColor: '#666',
				defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
				defaultFontSize: 12,
				defaultFontStyle: 'normal',
				showLines: true,
	
				// Element defaults defined in element extensions
				elements: {},
	
				// Legend callback string
				legendCallback: function(chart) {
					var text = [];
					text.push('<ul class="' + chart.id + '-legend">');
					for (var i = 0; i < chart.data.datasets.length; i++) {
						text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
						if (chart.data.datasets[i].label) {
							text.push(chart.data.datasets[i].label);
						}
						text.push('</li>');
					}
					text.push('</ul>');
	
					return text.join('');
				}
			}
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	
	};


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(1519);
	
	module.exports = function(Chart) {
		// Global Chart helpers object for utility methods and classes
		var helpers = Chart.helpers = {};
	
		// -- Basic js utility methods
		helpers.each = function(loopable, callback, self, reverse) {
			// Check to see if null or undefined firstly.
			var i, len;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						callback.call(self, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						callback.call(self, loopable[i], i);
					}
				}
			} else if (typeof loopable === 'object') {
				var keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					callback.call(self, loopable[keys[i]], keys[i]);
				}
			}
		};
		helpers.clone = function(obj) {
			var objClone = {};
			helpers.each(obj, function(value, key) {
				if (helpers.isArray(value)) {
					objClone[key] = value.slice(0);
				} else if (typeof value === 'object' && value !== null) {
					objClone[key] = helpers.clone(value);
				} else {
					objClone[key] = value;
				}
			});
			return objClone;
		};
		helpers.extend = function(base) {
			var setFn = function(value, key) {
				base[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; i++) {
				helpers.each(arguments[i], setFn);
			}
			return base;
		};
		// Need a special merge function to chart configs since they are now grouped
		helpers.configMerge = function(_base) {
			var base = helpers.clone(_base);
			helpers.each(Array.prototype.slice.call(arguments, 1), function(extension) {
				helpers.each(extension, function(value, key) {
					if (key === 'scales') {
						// Scale config merging is complex. Add out own function here for that
						base[key] = helpers.scaleMerge(base.hasOwnProperty(key) ? base[key] : {}, value);
	
					} else if (key === 'scale') {
						// Used in polar area & radar charts since there is only one scale
						base[key] = helpers.configMerge(base.hasOwnProperty(key) ? base[key] : {}, Chart.scaleService.getScaleDefaults(value.type), value);
					} else if (base.hasOwnProperty(key) && helpers.isArray(base[key]) && helpers.isArray(value)) {
						// In this case we have an array of objects replacing another array. Rather than doing a strict replace,
						// merge. This allows easy scale option merging
						var baseArray = base[key];
	
						helpers.each(value, function(valueObj, index) {
	
							if (index < baseArray.length) {
								if (typeof baseArray[index] === 'object' && baseArray[index] !== null && typeof valueObj === 'object' && valueObj !== null) {
									// Two objects are coming together. Do a merge of them.
									baseArray[index] = helpers.configMerge(baseArray[index], valueObj);
								} else {
									// Just overwrite in this case since there is nothing to merge
									baseArray[index] = valueObj;
								}
							} else {
								baseArray.push(valueObj); // nothing to merge
							}
						});
	
					} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
						// If we are overwriting an object with an object, do a merge of the properties.
						base[key] = helpers.configMerge(base[key], value);
	
					} else {
						// can just overwrite the value in this case
						base[key] = value;
					}
				});
			});
	
			return base;
		};
		helpers.scaleMerge = function(_base, extension) {
			var base = helpers.clone(_base);
	
			helpers.each(extension, function(value, key) {
				if (key === 'xAxes' || key === 'yAxes') {
					// These properties are arrays of items
					if (base.hasOwnProperty(key)) {
						helpers.each(value, function(valueObj, index) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							var axisDefaults = Chart.scaleService.getScaleDefaults(axisType);
							if (index >= base[key].length || !base[key][index].type) {
								base[key].push(helpers.configMerge(axisDefaults, valueObj));
							} else if (valueObj.type && valueObj.type !== base[key][index].type) {
								// Type changed. Bring in the new defaults before we bring in valueObj so that valueObj can override the correct scale defaults
								base[key][index] = helpers.configMerge(base[key][index], axisDefaults, valueObj);
							} else {
								// Type is the same
								base[key][index] = helpers.configMerge(base[key][index], valueObj);
							}
						});
					} else {
						base[key] = [];
						helpers.each(value, function(valueObj) {
							var axisType = helpers.getValueOrDefault(valueObj.type, key === 'xAxes' ? 'category' : 'linear');
							base[key].push(helpers.configMerge(Chart.scaleService.getScaleDefaults(axisType), valueObj));
						});
					}
				} else if (base.hasOwnProperty(key) && typeof base[key] === 'object' && base[key] !== null && typeof value === 'object') {
					// If we are overwriting an object with an object, do a merge of the properties.
					base[key] = helpers.configMerge(base[key], value);
	
				} else {
					// can just overwrite the value in this case
					base[key] = value;
				}
			});
	
			return base;
		};
		helpers.getValueAtIndexOrDefault = function(value, index, defaultValue) {
			if (value === undefined || value === null) {
				return defaultValue;
			}
	
			if (helpers.isArray(value)) {
				return index < value.length ? value[index] : defaultValue;
			}
	
			return value;
		};
		helpers.getValueOrDefault = function(value, defaultValue) {
			return value === undefined ? defaultValue : value;
		};
		helpers.indexOf = Array.prototype.indexOf?
			function(array, item) {
				return array.indexOf(item);
			}:
			function(array, item) {
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (array[i] === item) {
						return i;
					}
				}
				return -1;
			};
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (startIndex === undefined || startIndex === null) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.inherits = function(extensions) {
			// Basic javascript inheritance based on the model created in Backbone.js
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
	
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
	
			return ChartElement;
		};
		helpers.noop = function() {};
		helpers.uid = (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}());
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x,
				distanceFromYCenter = anglePoint.y - centrePoint.y,
				radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint,
				current = middlePoint,
				next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					pointCurrent.deltaK = (pointAfter.model.y - pointCurrent.model.y) / (pointAfter.model.x - pointCurrent.model.x);
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Easing functions adapted from Robert Penner's easing equations
		// http://www.robertpenner.com/easing/
		var easingEffects = helpers.easingEffects = {
			linear: function(t) {
				return t;
			},
			easeInQuad: function(t) {
				return t * t;
			},
			easeOutQuad: function(t) {
				return -1 * t * (t - 2);
			},
			easeInOutQuad: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t;
				}
				return -1 / 2 * ((--t) * (t - 2) - 1);
			},
			easeInCubic: function(t) {
				return t * t * t;
			},
			easeOutCubic: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t + 1);
			},
			easeInOutCubic: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t + 2);
			},
			easeInQuart: function(t) {
				return t * t * t * t;
			},
			easeOutQuart: function(t) {
				return -1 * ((t = t / 1 - 1) * t * t * t - 1);
			},
			easeInOutQuart: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t;
				}
				return -1 / 2 * ((t -= 2) * t * t * t - 2);
			},
			easeInQuint: function(t) {
				return 1 * (t /= 1) * t * t * t * t;
			},
			easeOutQuint: function(t) {
				return 1 * ((t = t / 1 - 1) * t * t * t * t + 1);
			},
			easeInOutQuint: function(t) {
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * t * t * t * t * t;
				}
				return 1 / 2 * ((t -= 2) * t * t * t * t + 2);
			},
			easeInSine: function(t) {
				return -1 * Math.cos(t / 1 * (Math.PI / 2)) + 1;
			},
			easeOutSine: function(t) {
				return 1 * Math.sin(t / 1 * (Math.PI / 2));
			},
			easeInOutSine: function(t) {
				return -1 / 2 * (Math.cos(Math.PI * t / 1) - 1);
			},
			easeInExpo: function(t) {
				return (t === 0) ? 1 : 1 * Math.pow(2, 10 * (t / 1 - 1));
			},
			easeOutExpo: function(t) {
				return (t === 1) ? 1 : 1 * (-Math.pow(2, -10 * t / 1) + 1);
			},
			easeInOutExpo: function(t) {
				if (t === 0) {
					return 0;
				}
				if (t === 1) {
					return 1;
				}
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * Math.pow(2, 10 * (t - 1));
				}
				return 1 / 2 * (-Math.pow(2, -10 * --t) + 2);
			},
			easeInCirc: function(t) {
				if (t >= 1) {
					return t;
				}
				return -1 * (Math.sqrt(1 - (t /= 1) * t) - 1);
			},
			easeOutCirc: function(t) {
				return 1 * Math.sqrt(1 - (t = t / 1 - 1) * t);
			},
			easeInOutCirc: function(t) {
				if ((t /= 1 / 2) < 1) {
					return -1 / 2 * (Math.sqrt(1 - t * t) - 1);
				}
				return 1 / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1);
			},
			easeInElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
			},
			easeOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1) === 1) {
					return 1;
				}
				if (!p) {
					p = 1 * 0.3;
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				return a * Math.pow(2, -10 * t) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) + 1;
			},
			easeInOutElastic: function(t) {
				var s = 1.70158;
				var p = 0;
				var a = 1;
				if (t === 0) {
					return 0;
				}
				if ((t /= 1 / 2) === 2) {
					return 1;
				}
				if (!p) {
					p = 1 * (0.3 * 1.5);
				}
				if (a < Math.abs(1)) {
					a = 1;
					s = p / 4;
				} else {
					s = p / (2 * Math.PI) * Math.asin(1 / a);
				}
				if (t < 1) {
					return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p));
				}
				return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * 1 - s) * (2 * Math.PI) / p) * 0.5 + 1;
			},
			easeInBack: function(t) {
				var s = 1.70158;
				return 1 * (t /= 1) * t * ((s + 1) * t - s);
			},
			easeOutBack: function(t) {
				var s = 1.70158;
				return 1 * ((t = t / 1 - 1) * t * ((s + 1) * t + s) + 1);
			},
			easeInOutBack: function(t) {
				var s = 1.70158;
				if ((t /= 1 / 2) < 1) {
					return 1 / 2 * (t * t * (((s *= (1.525)) + 1) * t - s));
				}
				return 1 / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
			},
			easeInBounce: function(t) {
				return 1 - easingEffects.easeOutBounce(1 - t);
			},
			easeOutBounce: function(t) {
				if ((t /= 1) < (1 / 2.75)) {
					return 1 * (7.5625 * t * t);
				} else if (t < (2 / 2.75)) {
					return 1 * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75);
				} else if (t < (2.5 / 2.75)) {
					return 1 * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375);
				}
				return 1 * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375);
			},
			easeInOutBounce: function(t) {
				if (t < 1 / 2) {
					return easingEffects.easeInBounce(t * 2) * 0.5;
				}
				return easingEffects.easeOutBounce(t * 2 - 1) * 0.5 + 1 * 0.5;
			}
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		helpers.cancelAnimFrame = (function() {
			return window.cancelAnimationFrame ||
				window.webkitCancelAnimationFrame ||
				window.mozCancelAnimationFrame ||
				window.oCancelAnimationFrame ||
				window.msCancelAnimationFrame ||
				function(callback) {
					return window.clearTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt,
				canvas = evt.currentTarget || evt.srcElement,
				boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
		helpers.addEvent = function(node, eventType, method) {
			if (node.addEventListener) {
				node.addEventListener(eventType, method);
			} else if (node.attachEvent) {
				node.attachEvent('on' + eventType, method);
			} else {
				node['on' + eventType] = method;
			}
		};
		helpers.removeEvent = function(node, eventType, handler) {
			if (node.removeEventListener) {
				node.removeEventListener(eventType, handler, false);
			} else if (node.detachEvent) {
				node.detachEvent('on' + eventType, handler);
			} else {
				node['on' + eventType] = helpers.noop;
			}
		};
		helpers.bindEvents = function(chartInstance, arrayOfEvents, handler) {
			// Create the events object if it's not already present
			var events = chartInstance.events = chartInstance.events || {};
	
			helpers.each(arrayOfEvents, function(eventName) {
				events[eventName] = function() {
					handler.apply(chartInstance, arguments);
				};
				helpers.addEvent(chartInstance.chart.canvas, eventName, events[eventName]);
			});
		};
		helpers.unbindEvents = function(chartInstance, arrayOfEvents) {
			var canvas = chartInstance.chart.canvas;
			helpers.each(arrayOfEvents, function(handler, eventName) {
				helpers.removeEvent(canvas, eventName, handler);
			});
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof(styleValue) === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw)? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch)? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart) {
			var ctx = chart.ctx;
			var canvas = chart.canvas;
			var width = canvas.width;
			var height = canvas.height;
			var pixelRatio = chart.currentDevicePixelRatio = window.devicePixelRatio || 1;
	
			if (pixelRatio !== 1) {
				canvas.height = height * pixelRatio;
				canvas.width = width * pixelRatio;
				ctx.scale(pixelRatio, pixelRatio);
	
				// Store the device pixel ratio so that we can go backwards in `destroy`.
				// The devicePixelRatio changes with zoom, so there are no guarantees that it is the same
				// when destroy is called
				chart.originalDevicePixelRatio = chart.originalDevicePixelRatio || pixelRatio;
			}
	
			canvas.style.width = width + 'px';
			canvas.style.height = height + 'px';
		};
		// -- Canvas methods
		helpers.clear = function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		};
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
		helpers.drawRoundedRectangle = function(ctx, x, y, width, height, radius) {
			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();
		};
		helpers.color = function(c) {
			if (!color) {
				console.error('Color.js not found!');
				return c;
			}
	
			/* global CanvasGradient */
			if (c instanceof CanvasGradient) {
				return color(Chart.defaults.global.defaultColor);
			}
	
			return color(c);
		};
		helpers.addResizeListener = function(node, callback) {
			// Hide an iframe before the node
			var hiddenIframe = document.createElement('iframe');
			var hiddenIframeClass = 'chartjs-hidden-iframe';
	
			if (hiddenIframe.classlist) {
				// can use classlist
				hiddenIframe.classlist.add(hiddenIframeClass);
			} else {
				hiddenIframe.setAttribute('class', hiddenIframeClass);
			}
	
			// Set the style
			hiddenIframe.tabIndex = -1;
			var style = hiddenIframe.style;
			style.width = '100%';
			style.display = 'block';
			style.border = 0;
			style.height = 0;
			style.margin = 0;
			style.position = 'absolute';
			style.left = 0;
			style.right = 0;
			style.top = 0;
			style.bottom = 0;
	
			// Insert the iframe so that contentWindow is available
			node.insertBefore(hiddenIframe, node.firstChild);
	
			(hiddenIframe.contentWindow || hiddenIframe).onresize = function() {
				if (callback) {
					return callback();
				}
			};
		};
		helpers.removeResizeListener = function(node) {
			var hiddenIframe = node.querySelector('.chartjs-hidden-iframe');
	
			// Remove the resize detect iframe
			if (hiddenIframe) {
				hiddenIframe.parentNode.removeChild(hiddenIframe);
			}
		};
		helpers.isArray = Array.isArray?
			function(obj) {
				return Array.isArray(obj);
			} :
			function(obj) {
				return Object.prototype.toString.call(obj) === '[object Array]';
			};
		// ! @see http://stackoverflow.com/a/14853974
		helpers.arrayEquals = function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen=a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		};
		helpers.callCallback = function(fn, args, _tArg) {
			if (fn && typeof fn.call === 'function') {
				fn.apply(_tArg, args);
			}
		};
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(1520);
	var string = __webpack_require__(1522);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(1521);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ }),
/* 1521 */
/***/ (function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(1523);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
	       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr),
	       hexAlpha = "";
	   if (match) {
	      match = match[1];
	      hexAlpha = match[3];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(hex)) {
	      hexAlpha = match[2];
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	      if (hexAlpha) {
	         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgba, a) {
	   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
	   return "#" + hexDouble(rgba[0]) 
	              + hexDouble(rgba[1])
	              + hexDouble(rgba[2])
	              + (
	                 (a >= 0 && a < 1)
	                 ? hexDouble(Math.round(a * 255))
	                 : ""
	              );
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		// Global Chart canvas helpers object for drawing items to canvas
		var helpers = Chart.canvasHelpers = {};
	
		helpers.drawPoint = function(ctx, pointStyle, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (typeof pointStyle === 'object') {
				type = pointStyle.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(pointStyle, x - pointStyle.width / 2, y - pointStyle.height / 2);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (pointStyle) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		};
	};


/***/ }),
/* 1525 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.elements = {};
	
		Chart.Element = function(configuration) {
			helpers.extend(this, configuration);
			this.initialize.apply(this, arguments);
		};
	
		helpers.extend(Chart.Element.prototype, {
	
			initialize: function() {
				this.hidden = false;
			},
	
			pivot: function() {
				var me = this;
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
				me._start = helpers.clone(me._view);
				return me;
			},
	
			transition: function(ease) {
				var me = this;
	
				if (!me._view) {
					me._view = helpers.clone(me._model);
				}
	
				// No animation -> No Transition
				if (ease === 1) {
					me._view = me._model;
					me._start = null;
					return me;
				}
	
				if (!me._start) {
					me.pivot();
				}
	
				helpers.each(me._model, function(value, key) {
	
					if (key[0] === '_') {
						// Only non-underscored properties
					// Init if doesn't exist
					} else if (!me._view.hasOwnProperty(key)) {
						if (typeof value === 'number' && !isNaN(me._view[key])) {
							me._view[key] = value * ease;
						} else {
							me._view[key] = value;
						}
					// No unnecessary computations
					} else if (value === me._view[key]) {
						// It's the same! Woohoo!
					// Color transitions if possible
					} else if (typeof value === 'string') {
						try {
							var color = helpers.color(me._model[key]).mix(helpers.color(me._start[key]), ease);
							me._view[key] = color.rgbString();
						} catch (err) {
							me._view[key] = value;
						}
					// Number transitions
					} else if (typeof value === 'number') {
						var startVal = me._start[key] !== undefined && isNaN(me._start[key]) === false ? me._start[key] : 0;
						me._view[key] = ((me._model[key] - startVal) * ease) + startVal;
					// Everything else
					} else {
						me._view[key] = value;
					}
				}, me);
	
				return me;
			},
	
			tooltipPosition: function() {
				return {
					x: this._model.x,
					y: this._model.y
				};
			},
	
			hasValue: function() {
				return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
			}
		});
	
		Chart.Element.extend = helpers.inherits;
	
	};


/***/ }),
/* 1526 */
/***/ (function(module, exports) {

	/* global window: false */
	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.animation = {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		};
	
		Chart.Animation = Chart.Element.extend({
			currentStep: null, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
			addAnimation: function(chartInstance, animationObject, duration, lazy) {
				var me = this;
	
				if (!lazy) {
					chartInstance.animating = true;
				}
	
				for (var index = 0; index < me.animations.length; ++index) {
					if (me.animations[index].chartInstance === chartInstance) {
						// replacing an in progress animation
						me.animations[index].animationObject = animationObject;
						return;
					}
				}
	
				me.animations.push({
					chartInstance: chartInstance,
					animationObject: animationObject
				});
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (me.animations.length === 1) {
					me.requestAnimationFrame();
				}
			},
			// Cancel the animation for a given chart instance
			cancelAnimation: function(chartInstance) {
				var index = helpers.findIndex(this.animations, function(animationWrapper) {
					return animationWrapper.chartInstance === chartInstance;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chartInstance.animating = false;
				}
			},
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
			startDigest: function() {
				var me = this;
	
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				var i = 0;
				while (i < me.animations.length) {
					if (me.animations[i].animationObject.currentStep === null) {
						me.animations[i].animationObject.currentStep = 0;
					}
	
					me.animations[i].animationObject.currentStep += 1 + framesToDrop;
	
					if (me.animations[i].animationObject.currentStep > me.animations[i].animationObject.numSteps) {
						me.animations[i].animationObject.currentStep = me.animations[i].animationObject.numSteps;
					}
	
					me.animations[i].animationObject.render(me.animations[i].chartInstance, me.animations[i].animationObject);
					if (me.animations[i].animationObject.onAnimationProgress && me.animations[i].animationObject.onAnimationProgress.call) {
						me.animations[i].animationObject.onAnimationProgress.call(me.animations[i].chartInstance, me.animations[i]);
					}
	
					if (me.animations[i].animationObject.currentStep === me.animations[i].animationObject.numSteps) {
						if (me.animations[i].animationObject.onAnimationComplete && me.animations[i].animationObject.onAnimationComplete.call) {
							me.animations[i].animationObject.onAnimationComplete.call(me.animations[i].chartInstance, me.animations[i]);
						}
	
						// executed the last frame. Remove the animation.
						me.animations[i].chartInstance.animating = false;
	
						me.animations.splice(i, 1);
					} else {
						++i;
					}
				}
	
				var endTime = Date.now();
				var dropFrames = (endTime - startTime) / me.frameDuration;
	
				me.dropFrames += dropFrames;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			}
		};
	};


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * @class Chart.Controller
		 * The main controller of a chart.
		 */
		Chart.Controller = function(instance) {
	
			this.chart = instance;
			this.config = instance.config;
			this.options = this.config.options = helpers.configMerge(Chart.defaults.global, Chart.defaults[this.config.type], this.config.options || {});
			this.id = helpers.uid();
	
			Object.defineProperty(this, 'data', {
				get: function() {
					return this.config.data;
				}
			});
	
			// Add the chart instance to the global namespace
			Chart.instances[this.id] = this;
	
			if (this.options.responsive) {
				// Silent resize before chart draws
				this.resize(true);
			}
	
			this.initialize();
	
			return this;
		};
	
		helpers.extend(Chart.Controller.prototype, /** @lends Chart.Controller */ {
	
			initialize: function() {
				var me = this;
				// Before init plugin notification
				Chart.plugins.notify('beforeInit', [me]);
	
				me.bindEvents();
	
				// Make sure controllers are built first so that each dataset is bound to an axis before the scales
				// are built
				me.ensureScalesHaveIDs();
				me.buildOrUpdateControllers();
				me.buildScales();
				me.updateLayout();
				me.resetElements();
				me.initToolTip();
				me.update();
	
				// After init plugin notification
				Chart.plugins.notify('afterInit', [me]);
	
				return me;
			},
	
			clear: function() {
				helpers.clear(this.chart);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occuring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var chart = me.chart;
				var canvas = chart.canvas;
				var newWidth = helpers.getMaximumWidth(canvas);
				var aspectRatio = chart.aspectRatio;
				var newHeight = (me.options.maintainAspectRatio && isNaN(aspectRatio) === false && isFinite(aspectRatio) && aspectRatio !== 0) ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas);
	
				var sizeChanged = chart.width !== newWidth || chart.height !== newHeight;
	
				if (!sizeChanged) {
					return me;
				}
	
				canvas.width = chart.width = newWidth;
				canvas.height = chart.height = newHeight;
	
				helpers.retinaScale(chart);
	
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				Chart.plugins.notify('resize', [me, newSize]);
	
				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}
	
				if (!silent) {
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
	
				return me;
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear'};
						})
					);
				}
	
				if (options.scale) {
					items.push({options: options.scale, dtype: 'radialLinear', isDefault: true});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.getValueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.chart.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			updateLayout: function() {
				Chart.layoutService.update(this, this.chart.width, this.chart.height);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					if (!meta.type) {
						meta.type = dataset.type || me.config.type;
					}
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						meta.controller = new Chart.controllers[meta.type](me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				if (types.length > 1) {
					for (var i = 1; i < types.length; i++) {
						if (types[i] !== types[i - 1]) {
							me.isCombo = true;
							break;
						}
					}
				}
	
				return newControllers;
			},
	
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			update: function(animationDuration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeUpdate', [me]);
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				Chart.layoutService.update(me, me.chart.width, me.chart.height);
	
				// Apply changes to the dataets that require the scales to have been calculated i.e BorderColor chages
				Chart.plugins.notify('afterScaleUpdate', [me]);
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Do this before render so that any plugins that need final scale updates can use it
				Chart.plugins.notify('afterUpdate', [me]);
	
				me.render(animationDuration, lazy);
			},
	
			/**
			 * @method beforeDatasetsUpdate
			 * @description Called before all datasets are updated. If a plugin returns false,
			 * the datasets update will be cancelled until another chart update is triggered.
			 * @param {Object} instance the chart instance being updated.
			 * @returns {Boolean} false to cancel the datasets update.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * @method afterDatasetsUpdate
			 * @description Called after all datasets have been updated. Note that this
			 * extension will not be called if the datasets update has been cancelled.
			 * @param {Object} instance the chart instance being updated.
			 * @memberof Chart.PluginBase
			 * @since version 2.1.5
			 * @instance
			 */
	
			/**
			 * Updates all datasets unless a plugin returns false to the beforeDatasetsUpdate
			 * extension, in which case no datasets will be updated and the afterDatasetsUpdate
			 * notification will be skipped.
			 * @protected
			 * @instance
			 */
			updateDatasets: function() {
				var me = this;
				var i, ilen;
	
				if (Chart.plugins.notify('beforeDatasetsUpdate', [me])) {
					for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
						me.getDatasetMeta(i).controller.update();
					}
	
					Chart.plugins.notify('afterDatasetsUpdate', [me]);
				}
			},
	
			render: function(duration, lazy) {
				var me = this;
				Chart.plugins.notify('beforeRender', [me]);
	
				var animationOptions = me.options.animation;
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation();
					animation.numSteps = (duration || animationOptions.duration) / 16.66; // 60 fps
					animation.easing = animationOptions.easing;
	
					// render function
					animation.render = function(chartInstance, animationObject) {
						var easingFunction = helpers.easingEffects[animationObject.easing];
						var stepDecimal = animationObject.currentStep / animationObject.numSteps;
						var easeDecimal = easingFunction(stepDecimal);
	
						chartInstance.draw(easeDecimal, stepDecimal, animationObject.currentStep);
					};
	
					// user events
					animation.onAnimationProgress = animationOptions.onProgress;
					animation.onAnimationComplete = animationOptions.onComplete;
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
					if (animationOptions && animationOptions.onComplete && animationOptions.onComplete.call) {
						animationOptions.onComplete.call(me);
					}
				}
				return me;
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				me.clear();
	
				Chart.plugins.notify('beforeDraw', [me, easingDecimal]);
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
				if (me.scale) {
					me.scale.draw();
				}
	
				Chart.plugins.notify('beforeDatasetsDraw', [me, easingDecimal]);
	
				// Draw each dataset via its respective controller (reversed to support proper line stacking)
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						me.getDatasetMeta(datasetIndex).controller.draw(ease);
					}
				}, me, true);
	
				Chart.plugins.notify('afterDatasetsDraw', [me, easingDecimal]);
	
				// Finally draw the tooltip
				me.tooltip.transition(easingDecimal).draw();
	
				Chart.plugins.notify('afterDraw', [me, easingDecimal]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						helpers.each(meta.data, function(element) {
							if (element.inRange(eventPosition.x, eventPosition.y)) {
								elementsArray.push(element);
								return elementsArray;
							}
						});
					}
				});
	
				return elementsArray.slice(0, 1);
			},
	
			getElementsAtEvent: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex),
							element = meta.data[found._index];
						if (element && !element._view.skip) {
							elementsArray.push(element);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtXAxis: function(e) {
				var me = this;
				var eventPosition = helpers.getRelativePosition(e, me.chart);
				var elementsArray = [];
	
				var found = function() {
					if (me.data.datasets) {
						for (var i = 0; i < me.data.datasets.length; i++) {
							var meta = me.getDatasetMeta(i);
							if (me.isDatasetVisible(i)) {
								for (var j = 0; j < meta.data.length; j++) {
									if (meta.data[j].inLabelRange(eventPosition.x, eventPosition.y)) {
										return meta.data[j];
									}
								}
							}
						}
					}
				}.call(me);
	
				if (!found) {
					return elementsArray;
				}
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					if (me.isDatasetVisible(datasetIndex)) {
						var meta = me.getDatasetMeta(datasetIndex);
						var index = helpers.findIndex(meta.data, function(it) {
							return found._model.x === it._model.x;
						});
						if (index !== -1 && !meta.data[index]._view.skip) {
							elementsArray.push(meta.data[index]);
						}
					}
				}, me);
	
				return elementsArray;
			},
	
			getElementsAtEventForMode: function(e, mode) {
				var me = this;
				switch (mode) {
				case 'single':
					return me.getElementAtEvent(e);
				case 'label':
					return me.getElementsAtEvent(e);
				case 'dataset':
					return me.getDatasetAtEvent(e);
				case 'x-axis':
					return me.getElementsAtXAxis(e);
				default:
					return e;
				}
			},
	
			getDatasetAtEvent: function(e) {
				var elementsArray = this.getElementAtEvent(e);
	
				if (elementsArray.length > 0) {
					elementsArray = this.getDatasetMeta(elementsArray[0]._datasetIndex).data;
				}
	
				return elementsArray;
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i<ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean'? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			destroy: function() {
				var me = this;
				me.stop();
				me.clear();
				helpers.unbindEvents(me, me.events);
				helpers.removeResizeListener(me.chart.canvas.parentNode);
	
				// Reset canvas height/width attributes
				var canvas = me.chart.canvas;
				canvas.width = me.chart.width;
				canvas.height = me.chart.height;
	
				// if we scaled the canvas in response to a devicePixelRatio !== 1, we need to undo that transform here
				if (me.chart.originalDevicePixelRatio !== undefined) {
					me.chart.ctx.scale(1 / me.chart.originalDevicePixelRatio, 1 / me.chart.originalDevicePixelRatio);
				}
	
				// Reset to the old style since it may have been changed by the device pixel ratio changes
				canvas.style.width = me.chart.originalCanvasStyleWidth;
				canvas.style.height = me.chart.originalCanvasStyleHeight;
	
				Chart.plugins.notify('destroy', [me]);
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.chart.canvas.toDataURL.apply(this.chart.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me.chart,
					_chartInstance: me,
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			bindEvents: function() {
				var me = this;
				helpers.bindEvents(me, me.options.events, function(evt) {
					me.eventHandler(evt);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				switch (mode) {
				case 'single':
					elements = [elements[0]];
					break;
				case 'label':
				case 'dataset':
				case 'x-axis':
					// elements = elements;
					break;
				default:
					// unsupported mode
					return;
				}
	
				for (i=0, ilen=elements.length; i<ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var tooltipsOptions = options.tooltips;
	
				me.lastActive = me.lastActive || [];
				me.lastTooltipActive = me.lastTooltipActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
					me.tooltipActive = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode);
					me.tooltipActive = me.getElementsAtEventForMode(e, tooltipsOptions.mode);
				}
	
				// On Hover hook
				if (hoverOptions.onHover) {
					hoverOptions.onHover.call(me, me.active);
				}
	
				if (me.legend && me.legend.handleEvent) {
					me.legend.handleEvent(e);
				}
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						options.onClick.call(me, e, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				// Built in Tooltips
				if (tooltipsOptions.enabled || tooltipsOptions.custom) {
					tooltip.initialize();
					tooltip._active = me.tooltipActive;
					tooltip.update(true);
				}
	
				// Hover animations
				tooltip.pivot();
	
				if (!me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					if (!helpers.arrayEquals(me.active, me.lastActive) ||
						!helpers.arrayEquals(me.tooltipActive, me.lastTooltipActive)) {
	
						me.stop();
	
						if (tooltipsOptions.enabled || tooltipsOptions.custom) {
							tooltip.update(true);
						}
	
						// We only need to render at this point. Updating will cause scales to be
						// recomputed generating flicker & using more memory than necessary.
						me.render(hoverOptions.animationDuration, true);
					}
				}
	
				// Remember Last Actives
				me.lastActive = me.active;
				me.lastTooltipActive = me.tooltipActive;
				return me;
			}
		});
	};


/***/ }),
/* 1528 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i=0, ilen=data.length; i<ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(meta, i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var me = this;
				var element = me.createMetaData(index);
				me.getMeta().data.splice(index, 0, element);
				me.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				// Handle the number of data points changing
				var meta = this.getMeta(),
					md = meta.data,
					numData = this.getDataset().data.length,
					numMetaData = md.length;
	
				// Make sure that we handle number of datapoints changing
				if (numData < numMetaData) {
					// Remove excess bars for data points that have been removed
					md.splice(numData, numMetaData - numData);
				} else if (numData > numMetaData) {
					// Add new elements
					for (var index = numMetaData; index < numData; ++index) {
						this.addElementAndReset(index);
					}
				}
			},
	
			update: noop,
	
			draw: function(ease) {
				var easingDecimal = ease || 1;
				helpers.each(this.getMeta().data, function(element) {
					element.transition(easingDecimal).draw();
				});
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex],
					index = element._index,
					custom = element.custom || {},
					valueOrDefault = helpers.getValueAtIndexOrDefault,
					getHoverColor = helpers.getHoverColor,
					model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			}
	
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ }),
/* 1529 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			// Register a box to a chartInstance. A box is simply a reference to an object that requires layout. eg. Scales, Legend, Plugins.
			addBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					chartInstance.boxes = [];
				}
				chartInstance.boxes.push(box);
			},
	
			removeBox: function(chartInstance, box) {
				if (!chartInstance.boxes) {
					return;
				}
				chartInstance.boxes.splice(chartInstance.boxes.indexOf(box), 1);
			},
	
			// The most important function
			update: function(chartInstance, width, height) {
	
				if (!chartInstance) {
					return;
				}
	
				var xPadding = 0;
				var yPadding = 0;
	
				var leftBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'left';
				});
				var rightBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'right';
				});
				var topBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'top';
				});
				var bottomBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'bottom';
				});
	
				// Boxes that overlay the chartarea such as the radialLinear scale
				var chartAreaBoxes = helpers.where(chartInstance.boxes, function(box) {
					return box.options.position === 'chartArea';
				});
	
				// Ensure that full width boxes are at the very top / bottom
				topBoxes.sort(function(a, b) {
					return (b.options.fullWidth ? 1 : 0) - (a.options.fullWidth ? 1 : 0);
				});
				bottomBoxes.sort(function(a, b) {
					return (a.options.fullWidth ? 1 : 0) - (b.options.fullWidth ? 1 : 0);
				});
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - (2 * xPadding);
				var chartHeight = height - (2 * yPadding);
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
	
				// Steps 5 & 6
				var totalLeftBoxesWidth = xPadding;
				var totalRightBoxesWidth = xPadding;
				var totalTopBoxesHeight = yPadding;
				var totalBottomBoxesHeight = yPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: totalLeftBoxesWidth,
								right: totalRightBoxesWidth,
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.options.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = xPadding;
				totalRightBoxesWidth = xPadding;
				totalTopBoxesHeight = yPadding;
				totalBottomBoxesHeight = yPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.options.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = xPadding;
				var top = yPadding;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.options.fullWidth ? xPadding : totalLeftBoxesWidth;
						box.right = box.options.fullWidth ? width - xPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chartInstance.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chartInstance.chartArea.left;
					box.top = chartInstance.chartArea.top;
					box.right = chartInstance.chartArea.right;
					box.bottom = chartInstance.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, defaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(defaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.scaleMerge(Chart.defaults.scale, this.defaults[type]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var defaults = this.defaults;
				if (defaults.hasOwnProperty(type)) {
					defaults[type] = helpers.extend(defaults[type], additions);
				}
			},
			addScalesToLayout: function(chartInstance) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chartInstance.scales, function(scale) {
					Chart.layoutService.addBox(chartInstance, scale);
				});
			}
		};
	};


/***/ }),
/* 1531 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var noop = Chart.helpers.noop;
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			_plugins: [],
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
			},
	
			/**
			 * Remove all registered p^lugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin intances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls registered plugins on the specified extension, with the given args. This
			 * method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {String} extension the name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] extra arguments to apply to the extension call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(extension, args) {
				var plugins = this._plugins;
				var ilen = plugins.length;
				var i, plugin;
	
				for (i=0; i<ilen; ++i) {
					plugin = plugins[i];
					if (typeof plugin[extension] === 'function') {
						if (plugin[extension].apply(plugin, args || []) === false) {
							return false;
						}
					}
				}
	
				return true;
			}
		};
	
		/**
		 * Plugin extension methods.
		 * @interface Chart.PluginBase
		 * @since 2.1.0
		 */
		Chart.PluginBase = Chart.Element.extend({
			// Called at start of chart init
			beforeInit: noop,
	
			// Called at end of chart init
			afterInit: noop,
	
			// Called at start of update
			beforeUpdate: noop,
	
			// Called at end of update
			afterUpdate: noop,
	
			// Called at start of draw
			beforeDraw: noop,
	
			// Called at end of draw
			afterDraw: noop,
	
			// Called during destroy
			destroy: noop
		});
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove me at version 3
		 */
		Chart.pluginService = Chart.plugins;
	};


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.scale = {
			display: true,
			position: 'left',
	
			// grid line settings
			gridLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1,
				drawBorder: true,
				drawOnChartArea: true,
				drawTicks: true,
				tickMarkLength: 10,
				zeroLineWidth: 1,
				zeroLineColor: 'rgba(0,0,0,0.25)',
				offsetGridLines: false,
				borderDash: [],
				borderDashOffset: 0.0
			},
	
			// scale label
			scaleLabel: {
				// actual label
				labelString: '',
	
				// display property
				display: false
			},
	
			// label settings
			ticks: {
				beginAtZero: false,
				minRotation: 0,
				maxRotation: 50,
				mirror: false,
				padding: 10,
				reverse: false,
				display: true,
				autoSkip: true,
				autoSkipPadding: 0,
				labelOffset: 0,
				// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
				callback: function(value) {
					return helpers.isArray(value) ? value : '' + value;
				}
			}
		};
	
		Chart.Scale = Chart.Element.extend({
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			beforeUpdate: function() {
				helpers.callCallback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks
				me.beforeBuildTicks();
				me.buildTicks();
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
				me.convertTicksToLabels();
				me.afterTickToLabelConversion();
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callCallback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callCallback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callCallback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callCallback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callCallback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callCallback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callCallback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callCallback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				me.ticks = me.ticks.map(function(numericalTick, index, ticks) {
					if (me.options.ticks.userCallback) {
						return me.options.ticks.userCallback(numericalTick, index, ticks);
					}
					return me.options.ticks.callback(numericalTick, index, ticks);
				},
				me);
			},
			afterTickToLabelConversion: function() {
				helpers.callCallback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callCallback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = me.options.ticks;
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				context.font = tickLabelFont;
	
				var firstWidth = context.measureText(me.ticks[0]).width;
				var lastWidth = context.measureText(me.ticks[me.ticks.length - 1]).width;
				var firstRotated;
	
				me.labelRotation = optionTicks.minRotation || 0;
				me.paddingRight = 0;
				me.paddingLeft = 0;
	
				if (me.options.display) {
					if (me.isHorizontal()) {
						me.paddingRight = lastWidth / 2 + 3;
						me.paddingLeft = firstWidth / 2 + 3;
	
						if (!me.longestTextCache) {
							me.longestTextCache = {};
						}
						var originalLabelWidth = helpers.longestText(context, tickLabelFont, me.ticks, me.longestTextCache);
						var labelWidth = originalLabelWidth;
						var cosRotation;
						var sinRotation;
	
						// Allow 3 pixels x2 padding either side for label readability
						// only the index matters for a dataset scale, but we want a consistent interface between scales
						var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
						// Max label rotation can be set or default to 90 - also act as a loop counter
						while (labelWidth > tickWidth && me.labelRotation < optionTicks.maxRotation) {
							cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
							sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
	
							firstRotated = cosRotation * firstWidth;
	
							// We're right aligning the text now.
							if (firstRotated + tickFontSize / 2 > me.yLabelWidth) {
								me.paddingLeft = firstRotated + tickFontSize / 2;
							}
	
							me.paddingRight = tickFontSize / 2;
	
							if (sinRotation * originalLabelWidth > me.maxHeight) {
								// go back one step
								me.labelRotation--;
								break;
							}
	
							me.labelRotation++;
							labelWidth = cosRotation * originalLabelWidth;
						}
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				}
			},
			afterCalculateTickRotation: function() {
				helpers.callCallback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callCallback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var opts = me.options;
				var globalDefaults = Chart.defaults.global;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabelOpts.fontSize, globalDefaults.defaultFontSize);
	
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					if (isHorizontal) {
						minSize.height += (scaleLabelFontSize * 1.5);
					} else {
						minSize.width += (scaleLabelFontSize * 1.5);
					}
				}
	
				if (tickOpts.display && display) {
					// Don't bother fitting the ticks if we are not showing them
					if (!me.longestTextCache) {
						me.longestTextCache = {};
					}
	
					var largestTextWidth = helpers.longestText(me.ctx, tickLabelFont, me.ticks, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(me.ticks);
					var lineSpace = tickFontSize * 0.5;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						// TODO - improve this calculation
						var labelHeight = (Math.sin(helpers.toRadians(me.labelRotation)) * me.longestLabelWidth) + (tickFontSize * tallestLabelHeightInLines) + (lineSpace * tallestLabelHeightInLines);
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight);
						me.ctx.font = tickLabelFont;
	
						var firstLabelWidth = me.ctx.measureText(me.ticks[0]).width;
						var lastLabelWidth = me.ctx.measureText(me.ticks[me.ticks.length - 1]).width;
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned which means that the right padding is dominated
						// by the font height
						var cosRotation = Math.cos(helpers.toRadians(me.labelRotation));
						var sinRotation = Math.sin(helpers.toRadians(me.labelRotation));
						me.paddingLeft = me.labelRotation !== 0 ? (cosRotation * firstLabelWidth) + 3 : firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = me.labelRotation !== 0 ? (sinRotation * (tickFontSize / 2)) + 3 : lastLabelWidth / 2 + 3; // when rotated
					} else {
						// A vertical axis is more constrained by the width. Labels are the dominant factor here, so get that length first
						var maxLabelWidth = me.maxWidth - minSize.width;
	
						// Account for padding
						var mirror = tickOpts.mirror;
						if (!mirror) {
							largestTextWidth += me.options.ticks.padding;
						} else {
							// If mirrored text is on the inside so don't expand
							largestTextWidth = 0;
						}
	
						if (largestTextWidth < maxLabelWidth) {
							// We don't need all the room
							minSize.width += largestTextWidth;
						} else {
							// Expand to max size
							minSize.width = me.maxWidth;
						}
	
						me.paddingTop = tickFontSize / 2;
						me.paddingBottom = tickFontSize / 2;
					}
				}
	
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: function() {
				helpers.callCallback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (rawValue === null || typeof(rawValue) === 'undefined') {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number
				if (typeof(rawValue) === 'number' && isNaN(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (typeof(rawValue) === 'object') {
					if ((rawValue instanceof Date) || (rawValue.isValid)) {
						return rawValue;
					}
					return this.getRightValue(this.isHorizontal() ? rawValue.x : rawValue.y);
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			// Used to get the value to display in the tooltip for the data at the given index
			// function getLabelForIndex(index, datasetIndex)
			getLabelForIndex: helpers.noop,
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: helpers.noop,
	
			// Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			getValueForPixel: helpers.noop,
	
			// Used for tick location, should
			getPixelForTick: function(index, includeOffset) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (includeOffset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me.ticks.length - 1)));
			},
	
			// Utility for getting the pixel location of a percentage of scale
			getPixelForDecimal: function(decimal /* , includeOffset*/) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			getBasePixel: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPixelForValue(
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			// Actualy draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = Chart.defaults.global;
				var optionTicks = options.ticks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var skipRatio;
				var useAutoskipper = optionTicks.autoSkip;
				var isHorizontal = me.isHorizontal();
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				var tickFontColor = helpers.getValueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFontSize = helpers.getValueOrDefault(optionTicks.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(optionTicks.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(optionTicks.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				var tl = gridLines.tickMarkLength;
				var borderDash = helpers.getValueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
				var borderDashOffset = helpers.getValueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
	
				var scaleLabelFontColor = helpers.getValueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFontSize = helpers.getValueOrDefault(scaleLabel.fontSize, globalDefaults.defaultFontSize);
				var scaleLabelFontStyle = helpers.getValueOrDefault(scaleLabel.fontStyle, globalDefaults.defaultFontStyle);
				var scaleLabelFontFamily = helpers.getValueOrDefault(scaleLabel.fontFamily, globalDefaults.defaultFontFamily);
				var scaleLabelFont = helpers.fontString(scaleLabelFontSize, scaleLabelFontStyle, scaleLabelFontFamily);
	
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
	
				// Make sure we draw text in the correct color and font
				context.fillStyle = tickFontColor;
	
				var itemsToDraw = [];
	
				if (isHorizontal) {
					skipRatio = false;
	
					// Only calculate the skip ratio with the half width of longestRotateLabel if we got an actual rotation
					// See #2584
					if (isRotated) {
						longestRotatedLabel /= 2;
					}
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * me.ticks.length) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && me.ticks.length > maxTicks) {
						while (!skipRatio || me.ticks.length / (skipRatio || 1) > maxTicks) {
							if (!skipRatio) {
								skipRatio = 1;
							}
							skipRatio += 1;
						}
					}
	
					if (!useAutoskipper) {
						skipRatio = false;
					}
				}
	
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(me.ticks, function(label, index) {
					// If the callback returned a null or undefined value, do not draw this line
					if (label === undefined || label === null) {
						return;
					}
	
					var isLastTick = me.ticks.length === index + 1;
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					var shouldSkip = (skipRatio > 1 && index % skipRatio > 0) || (index % skipRatio === 0 && index + skipRatio >= me.ticks.length);
					if (shouldSkip && !isLastTick || (label === undefined || label === null)) {
						return;
					}
	
					var lineWidth, lineColor;
					if (index === (typeof me.zeroLineIndex !== 'undefined' ? me.zeroLineIndex : 0)) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
					} else {
						lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.getValueAtIndexOrDefault(gridLines.color, index);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
	
					if (isHorizontal) {
						if (!isRotated) {
							textBaseline = options.position === 'top' ? 'bottom' : 'top';
						}
	
						textAlign = isRotated ? 'right' : 'center';
	
						var xLineValue = me.getPixelForTick(index) + helpers.aliasPixel(lineWidth); // xvalues for grid lines
						labelX = me.getPixelForTick(index, gridLines.offsetGridLines) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
						labelY = (isRotated) ? me.top + 12 : options.position === 'top' ? me.bottom - tl : me.top + tl;
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						if (options.position === 'left') {
							if (optionTicks.mirror) {
								labelX = me.right + optionTicks.padding;
								textAlign = 'left';
							} else {
								labelX = me.right - optionTicks.padding;
								textAlign = 'right';
							}
						// right side
						} else if (optionTicks.mirror) {
							labelX = me.left - optionTicks.padding;
							textAlign = 'right';
						} else {
							labelX = me.left + optionTicks.padding;
							textAlign = 'left';
						}
	
						var yLineValue = me.getPixelForTick(index); // xvalues for grid lines
						yLineValue += helpers.aliasPixel(lineWidth);
						labelY = me.getPixelForTick(index, gridLines.offsetGridLines);
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = tickLabelFont;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = -(label.length - 1)*tickFontSize*0.75; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFontSize * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom' ? me.bottom - (scaleLabelFontSize / 2) : me.top + (scaleLabelFontSize / 2);
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft ? me.left + (scaleLabelFontSize / 2) : me.right - (scaleLabelFontSize / 2);
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.getValueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.getValueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left,
						x2 = me.right,
						y1 = me.top,
						y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ }),
/* 1533 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.title = {
			display: false,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
	
			fontStyle: 'bold',
			padding: 10,
	
			// actual title
			text: ''
		};
	
		var noop = helpers.noop;
		Chart.Title = Chart.Element.extend({
	
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
				me.options = helpers.configMerge(Chart.defaults.global.title, config.options);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
	
			beforeUpdate: function() {
				var chartOpts = this.chart.options;
				if (chartOpts && chartOpts.title) {
					this.options = helpers.configMerge(Chart.defaults.global.title, chartOpts.title);
				}
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global,
					display = opts.display,
					fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
					minSize = me.minSize;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? fontSize + (opts.padding * 2) : 0;
				} else {
					minSize.width = display ? fontSize + (opts.padding * 2) : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actualy draw the title block on the canvas
			draw: function() {
				var me = this,
					ctx = me.ctx,
					valueOrDefault = helpers.getValueOrDefault,
					opts = me.options,
					globalDefaults = Chart.defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize),
						fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle),
						fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily),
						titleFont = helpers.fontString(fontSize, fontStyle, fontFamily),
						rotation = 0,
						titleX,
						titleY,
						top = me.top,
						left = me.left,
						bottom = me.bottom,
						right = me.right;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + ((bottom - top) / 2); // midpoint of the height
					} else {
						titleX = opts.position === 'left' ? left + (fontSize / 2) : right - (fontSize / 2);
						titleY = top + ((bottom - top) / 2);
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					ctx.fillText(opts.text, 0, 0);
					ctx.restore();
				}
			}
		});
	
		// Register the title plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var titleOpts = opts.title;
	
				if (titleOpts) {
					chartInstance.titleBlock = new Chart.Title({
						ctx: chartInstance.chart.ctx,
						options: titleOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.titleBlock);
				}
			}
		});
	};


/***/ }),
/* 1534 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var noop = helpers.noop;
	
		Chart.defaults.global.legend = {
	
			display: true,
			position: 'top',
			fullWidth: true, // marks that this box should take the full width of the canvas (pushing down other boxes)
			reverse: false,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		};
	
		Chart.Legend = Chart.Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				me.legendItems = me.options.labels.generateLabels.call(me, me.chart);
				if (me.options.reverse) {
					me.legendItems.reverse();
				}
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = Chart.defaults.global,
					itemOrDefault = helpers.getValueOrDefault,
					fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
					fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
					fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
					labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = labelOpts.usePointStyle ?
								fontSize * Math.sqrt(2) :
								labelOpts.boxWidth;
	
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							// If usePointStyle is set, multiple boxWidth by 2 since it represents
							// the radius and not truly the width
							var boxWidth = labelOpts.usePointStyle ? 2 * labelOpts.boxWidth : labelOpts.boxWidth;
	
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actualy draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = Chart.defaults.global,
					lineDefault = globalDefault.elements.line,
					legendWidth = me.width,
					lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx,
						cursor,
						itemOrDefault = helpers.getValueOrDefault,
						fontColor = itemOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor),
						fontSize = itemOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize),
						fontStyle = itemOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle),
						fontFamily = itemOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily),
						labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = labelOpts.boxWidth,
						hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = itemOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = itemOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = itemOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = itemOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = itemOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (itemOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(itemOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalulate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							Chart.canvasHelpers.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						ctx.fillText(legendItem.text, boxWidth + (fontSize / 2) + x, y);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(boxWidth + (fontSize / 2) + x, y + (fontSize / 2));
							ctx.lineTo(boxWidth + (fontSize / 2) + x + textWidth, y + (fontSize / 2));
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width,
							width = labelOpts.usePointStyle ?
								fontSize + (fontSize / 2) + textWidth :
								boxWidth + (fontSize / 2) + textWidth,
							x = cursor.x,
							y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			// Handle an event
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				var position = helpers.getRelativePosition(e, me.chart.chart),
					x = position.x,
					y = position.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								opts.onClick.call(me, e, me.legendItems[i]);
								break;
							} else if (type === 'mousemove') {
								opts.onHover.call(me, e, me.legendItems[i]);
								break;
							}
						}
					}
				}
			}
		});
	
		// Register the legend plugin
		Chart.plugins.register({
			beforeInit: function(chartInstance) {
				var opts = chartInstance.options;
				var legendOpts = opts.legend;
	
				if (legendOpts) {
					chartInstance.legend = new Chart.Legend({
						ctx: chartInstance.chart.ctx,
						options: legendOpts,
						chart: chartInstance
					});
	
					Chart.layoutService.addBox(chartInstance, chartInstance.legend);
				}
			}
		});
	};


/***/ }),
/* 1535 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.global.tooltips = {
			enabled: true,
			custom: null,
			mode: 'single',
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			yAlign: 'center',
			xAlign: 'center',
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
					return datasetLabel + ': ' + tooltipItem.yLabel;
				},
				labelColor: function(tooltipItem, chartInstance) {
					var meta = chartInstance.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		};
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		function getAveragePosition(elements) {
			if (!elements.length) {
				return false;
			}
	
			var i, len;
			var xPositions = [];
			var yPositions = [];
	
			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					xPositions.push(pos.x);
					yPositions.push(pos.y);
				}
			}
	
			var x = 0,
				y = 0;
			for (i = 0; i < xPositions.length; ++i) {
				if (xPositions[i]) {
					x += xPositions[i];
					y += yPositions[i];
				}
			}
	
			return {
				x: Math.round(x / xPositions.length),
				y: Math.round(y / xPositions.length)
			};
		}
	
		// Private helper to create a tooltip iteam model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index,
				datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex
			};
		}
	
		Chart.Tooltip = Chart.Element.extend({
			initialize: function() {
				var me = this;
				var globalDefaults = Chart.defaults.global;
				var tooltipOpts = me._options;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				helpers.extend(me, {
					_model: {
						// Positioning
						xPadding: tooltipOpts.xPadding,
						yPadding: tooltipOpts.yPadding,
						xAlign: tooltipOpts.xAlign,
						yAlign: tooltipOpts.yAlign,
	
						// Body
						bodyFontColor: tooltipOpts.bodyFontColor,
						_bodyFontFamily: getValueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
						_bodyFontStyle: getValueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
						_bodyAlign: tooltipOpts.bodyAlign,
						bodyFontSize: getValueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
						bodySpacing: tooltipOpts.bodySpacing,
	
						// Title
						titleFontColor: tooltipOpts.titleFontColor,
						_titleFontFamily: getValueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
						_titleFontStyle: getValueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
						titleFontSize: getValueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
						_titleAlign: tooltipOpts.titleAlign,
						titleSpacing: tooltipOpts.titleSpacing,
						titleMarginBottom: tooltipOpts.titleMarginBottom,
	
						// Footer
						footerFontColor: tooltipOpts.footerFontColor,
						_footerFontFamily: getValueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
						_footerFontStyle: getValueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
						footerFontSize: getValueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
						_footerAlign: tooltipOpts.footerAlign,
						footerSpacing: tooltipOpts.footerSpacing,
						footerMarginTop: tooltipOpts.footerMarginTop,
	
						// Appearance
						caretSize: tooltipOpts.caretSize,
						cornerRadius: tooltipOpts.cornerRadius,
						backgroundColor: tooltipOpts.backgroundColor,
						opacity: 0,
						legendColorBackground: tooltipOpts.multiKeyBackground
					}
				});
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments),
					title = callbacks.title.apply(me, arguments),
					afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
				var model = me._model;
				var active = me._active;
	
				var data = me._data;
				var chartInstance = me._chartInstance;
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [],
						tooltipPosition = getAveragePosition(active);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// If there is more than one item, show color items
					if (active.length > 1) {
						helpers.each(tooltipItems, function(tooltipItem) {
							labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, chartInstance));
						});
					}
	
					// Build the Text Lines
					helpers.extend(model, {
						title: me.getTitle(tooltipItems, data),
						beforeBody: me.getBeforeBody(tooltipItems, data),
						body: me.getBody(tooltipItems, data),
						afterBody: me.getAfterBody(tooltipItems, data),
						footer: me.getFooter(tooltipItems, data),
						x: Math.round(tooltipPosition.x),
						y: Math.round(tooltipPosition.y),
						caretPadding: helpers.getValueOrDefault(tooltipPosition.padding, 2),
						labelColors: labelColors
					});
	
					// We need to determine alignment of
					var tooltipSize = me.getTooltipSize(model);
					me.determineAlignment(tooltipSize); // Smart Tooltip placement to stay on the canvas
	
					helpers.extend(model, me.getBackgroundPoint(model, tooltipSize));
				} else {
					me._model.opacity = 0;
				}
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			getTooltipSize: function(vm) {
				var ctx = this._chart.ctx;
	
				var size = {
					height: vm.yPadding * 2, // Tooltip Padding
					width: 0
				};
	
				// Count of all lines in the body
				var body = vm.body;
				var combinedBodyLength = body.reduce(function(count, bodyItem) {
					return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
				}, 0);
				combinedBodyLength += vm.beforeBody.length + vm.afterBody.length;
	
				var titleLineCount = vm.title.length;
				var footerLineCount = vm.footer.length;
				var titleFontSize = vm.titleFontSize,
					bodyFontSize = vm.bodyFontSize,
					footerFontSize = vm.footerFontSize;
	
				size.height += titleLineCount * titleFontSize; // Title Lines
				size.height += (titleLineCount - 1) * vm.titleSpacing; // Title Line Spacing
				size.height += titleLineCount ? vm.titleMarginBottom : 0; // Title's bottom Margin
				size.height += combinedBodyLength * bodyFontSize; // Body Lines
				size.height += combinedBodyLength ? (combinedBodyLength - 1) * vm.bodySpacing : 0; // Body Line Spacing
				size.height += footerLineCount ? vm.footerMarginTop : 0; // Footer Margin
				size.height += footerLineCount * (footerFontSize); // Footer Lines
				size.height += footerLineCount ? (footerLineCount - 1) * vm.footerSpacing : 0; // Footer Line Spacing
	
				// Title width
				var widthPadding = 0;
				var maxLineWidth = function(line) {
					size.width = Math.max(size.width, ctx.measureText(line).width + widthPadding);
				};
	
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
				helpers.each(vm.title, maxLineWidth);
	
				// Body width
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
				helpers.each(vm.beforeBody.concat(vm.afterBody), maxLineWidth);
	
				// Body lines may include some extra width due to the color box
				widthPadding = body.length > 1 ? (bodyFontSize + 2) : 0;
				helpers.each(body, function(bodyItem) {
					helpers.each(bodyItem.before, maxLineWidth);
					helpers.each(bodyItem.lines, maxLineWidth);
					helpers.each(bodyItem.after, maxLineWidth);
				});
	
				// Reset back to 0
				widthPadding = 0;
	
				// Footer width
				ctx.font = helpers.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
				helpers.each(vm.footer, maxLineWidth);
	
				// Add padding
				size.width += 2 * vm.xPadding;
	
				return size;
			},
			determineAlignment: function(size) {
				var me = this;
				var model = me._model;
				var chart = me._chart;
				var chartArea = me._chartInstance.chartArea;
	
				if (model.y < size.height) {
					model.yAlign = 'top';
				} else if (model.y > (chart.height - size.height)) {
					model.yAlign = 'bottom';
				}
	
				var lf, rf; // functions to determine left, right alignment
				var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
				var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
				var midX = (chartArea.left + chartArea.right) / 2;
				var midY = (chartArea.top + chartArea.bottom) / 2;
	
				if (model.yAlign === 'center') {
					lf = function(x) {
						return x <= midX;
					};
					rf = function(x) {
						return x > midX;
					};
				} else {
					lf = function(x) {
						return x <= (size.width / 2);
					};
					rf = function(x) {
						return x >= (chart.width - (size.width / 2));
					};
				}
	
				olf = function(x) {
					return x + size.width > chart.width;
				};
				orf = function(x) {
					return x - size.width < 0;
				};
				yf = function(y) {
					return y <= midY ? 'top' : 'bottom';
				};
	
				if (lf(model.x)) {
					model.xAlign = 'left';
	
					// Is tooltip too wide and goes over the right side of the chart.?
					if (olf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				} else if (rf(model.x)) {
					model.xAlign = 'right';
	
					// Is tooltip too wide and goes outside left edge of canvas?
					if (orf(model.x)) {
						model.xAlign = 'center';
						model.yAlign = yf(model.y);
					}
				}
			},
			getBackgroundPoint: function(vm, size) {
				// Background Position
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				var caretSize = vm.caretSize,
					caretPadding = vm.caretPadding,
					cornerRadius = vm.cornerRadius,
					xAlign = vm.xAlign,
					yAlign = vm.yAlign,
					paddingAndSize = caretSize + caretPadding,
					radiusAndPadding = cornerRadius + caretPadding;
	
				if (xAlign === 'right') {
					pt.x -= size.width;
				} else if (xAlign === 'center') {
					pt.x -= (size.width / 2);
				}
	
				if (yAlign === 'top') {
					pt.y += paddingAndSize;
				} else if (yAlign === 'bottom') {
					pt.y -= size.height + paddingAndSize;
				} else {
					pt.y -= (size.height / 2);
				}
	
				if (yAlign === 'center') {
					if (xAlign === 'left') {
						pt.x += paddingAndSize;
					} else if (xAlign === 'right') {
						pt.x -= paddingAndSize;
					}
				} else if (xAlign === 'left') {
					pt.x -= radiusAndPadding;
				} else if (xAlign === 'right') {
					pt.x += radiusAndPadding;
				}
	
				return pt;
			},
			drawCaret: function(tooltipPoint, size, opacity) {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var x1, x2, x3;
				var y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign,
					yAlign = vm.yAlign;
				var ptX = tooltipPoint.x,
					ptY = tooltipPoint.y;
				var width = size.width,
					height = size.height;
	
				if (yAlign === 'center') {
					// Left or right side
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
					}
	
					y2 = ptY + (height / 2);
					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				} else {
					if (xAlign === 'left') {
						x1 = ptX + cornerRadius;
						x2 = x1 + caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x1 = ptX + width - cornerRadius;
						x2 = x1 - caretSize;
						x3 = x2 - caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
	
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
					}
				}
	
				var bgColor = helpers.color(vm.backgroundColor);
				ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.lineTo(x3, y3);
				ctx.closePath();
				ctx.fill();
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize,
						titleSpacing = vm.titleSpacing;
	
					var titleFontColor = helpers.color(vm.titleFontColor);
					ctx.fillStyle = titleFontColor.alpha(opacity * titleFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
	
				var bodyFontColor = helpers.color(vm.bodyFontColor);
				var textColor = bodyFontColor.alpha(opacity * bodyFontColor.alpha()).rgbString();
				ctx.fillStyle = textColor;
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = body.length > 1;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = helpers.color(vm.legendColorBackground).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.strokeStyle = helpers.color(vm.labelColors[i].borderColor).alpha(opacity).rgbaString();
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = helpers.color(vm.labelColors[i].backgroundColor).alpha(opacity).rgbaString();
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
	
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					var footerFontColor = helpers.color(vm.footerFontColor);
					ctx.fillStyle = footerFontColor.alpha(opacity * footerFontColor.alpha()).rgbString();
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = this.getTooltipSize(vm);
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				if (this._options.enabled) {
					// Draw Background
					var bgColor = helpers.color(vm.backgroundColor);
					ctx.fillStyle = bgColor.alpha(opacity * bgColor.alpha()).rgbString();
					helpers.drawRoundedRectangle(ctx, pt.x, pt.y, tooltipSize.width, tooltipSize.height, vm.cornerRadius);
					ctx.fill();
	
					// Draw Caret
					this.drawCaret(pt, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			}
		});
	};


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global;
	
		globalOpts.elements.arc = {
			backgroundColor: globalOpts.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		};
	
		Chart.elements.Arc = Chart.Element.extend({
			inLabelRange: function(mouseX) {
				var vm = this._view;
	
				if (vm) {
					return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
				}
				return false;
			},
			inRange: function(chartX, chartY) {
				var vm = this._view;
	
				if (vm) {
					var pointRelativePosition = helpers.getAngleFromPoint(vm, {
							x: chartX,
							y: chartY
						}),
						angle = pointRelativePosition.angle,
						distance = pointRelativePosition.distance;
	
					// Sanitise angle range
					var startAngle = vm.startAngle;
					var endAngle = vm.endAngle;
					while (endAngle < startAngle) {
						endAngle += 2.0 * Math.PI;
					}
					while (angle > endAngle) {
						angle -= 2.0 * Math.PI;
					}
					while (angle < startAngle) {
						angle += 2.0 * Math.PI;
					}
	
					// Check if within the range of the open/close angle
					var betweenAngles = (angle >= startAngle && angle <= endAngle),
						withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
					return (betweenAngles && withinRadius);
				}
				return false;
			},
			tooltipPosition: function() {
				var vm = this._view;
	
				var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2),
					rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
				return {
					x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
					y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
				};
			},
			draw: function() {
	
				var ctx = this._chart.ctx,
					vm = this._view,
					sA = vm.startAngle,
					eA = vm.endAngle;
	
				ctx.beginPath();
	
				ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
				ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
				ctx.closePath();
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				ctx.fillStyle = vm.backgroundColor;
	
				ctx.fill();
				ctx.lineJoin = 'bevel';
	
				if (vm.borderWidth) {
					ctx.stroke();
				}
			}
		});
	};


/***/ }),
/* 1537 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		Chart.defaults.global.elements.line = {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true // do we fill in the area between the line and its base axis
		};
	
		Chart.elements.Line = Chart.Element.extend({
			draw: function() {
				var me = this;
				var vm = me._view;
				var spanGaps = vm.spanGaps;
				var scaleZero = vm.scaleZero;
				var loop = me._loop;
	
				var ctx = me._chart.ctx;
				ctx.save();
	
				// Helper function to draw a line to a point
				function lineToPoint(previousPoint, point) {
					var pointVM = point._view;
					if (point._view.steppedLine === true) {
						ctx.lineTo(pointVM.x, previousPoint._view.y);
						ctx.lineTo(pointVM.x, pointVM.y);
					} else if (point._view.tension === 0) {
						ctx.lineTo(pointVM.x, pointVM.y);
					} else {
						ctx.bezierCurveTo(
							previousPoint._view.controlPointNextX,
							previousPoint._view.controlPointNextY,
							pointVM.controlPointPreviousX,
							pointVM.controlPointPreviousY,
							pointVM.x,
							pointVM.y
						);
					}
				}
	
				var points = me._children.slice(); // clone array
				var lastDrawnIndex = -1;
	
				// If we are looping, adding the first point again
				if (loop && points.length) {
					points.push(points[0]);
				}
	
				var index, current, previous, currentVM;
	
				// Fill Line
				if (points.length && vm.fill) {
					ctx.beginPath();
	
					for (index = 0; index < points.length; ++index) {
						current = points[index];
						previous = helpers.previousItem(points, index);
						currentVM = current._view;
	
						// First point moves to it's starting position no matter what
						if (index === 0) {
							if (loop) {
								ctx.moveTo(scaleZero.x, scaleZero.y);
							} else {
								ctx.moveTo(currentVM.x, scaleZero);
							}
	
							if (!currentVM.skip) {
								lastDrawnIndex = index;
								ctx.lineTo(currentVM.x, currentVM.y);
							}
						} else {
							previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
							if (currentVM.skip) {
								// Only do this if this is the first point that is skipped
								if (!spanGaps && lastDrawnIndex === (index - 1)) {
									if (loop) {
										ctx.lineTo(scaleZero.x, scaleZero.y);
									} else {
										ctx.lineTo(previous._view.x, scaleZero);
									}
								}
							} else {
								if (lastDrawnIndex !== (index - 1)) {
									// There was a gap and this is the first point after the gap. If we've never drawn a point, this is a special case.
									// If the first data point is NaN, then there is no real gap to skip
									if (spanGaps && lastDrawnIndex !== -1) {
										// We are spanning the gap, so simple draw a line to this point
										lineToPoint(previous, current);
									} else if (loop) {
										ctx.lineTo(currentVM.x, currentVM.y);
									} else {
										ctx.lineTo(currentVM.x, scaleZero);
										ctx.lineTo(currentVM.x, currentVM.y);
									}
								} else {
									// Line to next point
									lineToPoint(previous, current);
								}
								lastDrawnIndex = index;
							}
						}
					}
	
					if (!loop && lastDrawnIndex !== -1) {
						ctx.lineTo(points[lastDrawnIndex]._view.x, scaleZero);
					}
	
					ctx.fillStyle = vm.backgroundColor || globalDefaults.defaultColor;
					ctx.closePath();
					ctx.fill();
				}
	
				// Stroke Line Options
				var globalOptionLineElements = globalDefaults.elements.line;
				ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
				// IE 9 and 10 do not support line dash
				if (ctx.setLineDash) {
					ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
				}
	
				ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
				ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
				ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
				ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
				// Stroke Line
				ctx.beginPath();
				lastDrawnIndex = -1;
	
				for (index = 0; index < points.length; ++index) {
					current = points[index];
					previous = helpers.previousItem(points, index);
					currentVM = current._view;
	
					// First point moves to it's starting position no matter what
					if (index === 0) {
						if (!currentVM.skip) {
							ctx.moveTo(currentVM.x, currentVM.y);
							lastDrawnIndex = index;
						}
					} else {
						previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
						if (!currentVM.skip) {
							if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
								// There was a gap and this is the first point after the gap
								ctx.moveTo(currentVM.x, currentVM.y);
							} else {
								// Line to next point
								lineToPoint(previous, current);
							}
							lastDrawnIndex = index;
						}
					}
				}
	
				ctx.stroke();
				ctx.restore();
			}
		});
	};


/***/ }),
/* 1538 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			globalOpts = Chart.defaults.global,
			defaultColor = globalOpts.defaultColor;
	
		globalOpts.elements.point = {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderWidth: 1,
			borderColor: defaultColor,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		};
	
		Chart.elements.Point = Chart.Element.extend({
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y,
					padding: vm.radius + vm.borderWidth
				};
			},
			draw: function() {
				var vm = this._view;
				var ctx = this._chart.ctx;
				var pointStyle = vm.pointStyle;
				var radius = vm.radius;
				var x = vm.x;
				var y = vm.y;
	
				if (vm.skip) {
					return;
				}
	
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = helpers.getValueOrDefault(vm.borderWidth, globalOpts.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
	
				Chart.canvasHelpers.drawPoint(ctx, pointStyle, radius, x, y);
			}
		});
	};


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var globalOpts = Chart.defaults.global;
	
		globalOpts.elements.rectangle = {
			backgroundColor: globalOpts.defaultColor,
			borderWidth: 0,
			borderColor: globalOpts.defaultColor,
			borderSkipped: 'bottom'
		};
	
		Chart.elements.Rectangle = Chart.Element.extend({
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				var halfWidth = vm.width / 2,
					leftX = vm.x - halfWidth,
					rightX = vm.x + halfWidth,
					top = vm.base - (vm.base - vm.y),
					halfStroke = vm.borderWidth / 2;
	
				// Canvas doesn't allow us to stroke inside the width so we can
				// adjust the sizes to fit if we're setting a stroke on the line
				if (vm.borderWidth) {
					leftX += halfStroke;
					rightX -= halfStroke;
					top += halfStroke;
				}
	
				ctx.beginPath();
				ctx.fillStyle = vm.backgroundColor;
				ctx.strokeStyle = vm.borderColor;
				ctx.lineWidth = vm.borderWidth;
	
				// Corner points, from bottom-left to bottom-right clockwise
				// | 1 2 |
				// | 0 3 |
				var corners = [
					[leftX, vm.base],
					[leftX, top],
					[rightX, top],
					[rightX, vm.base]
				];
	
				// Find first (starting) corner with fallback to 'bottom'
				var borders = ['bottom', 'left', 'top', 'right'];
				var startCorner = borders.indexOf(vm.borderSkipped, 0);
				if (startCorner === -1) {
					startCorner = 0;
				}
	
				function cornerAt(index) {
					return corners[(startCorner + index) % 4];
				}
	
				// Draw rectangle from 'startCorner'
				ctx.moveTo.apply(ctx, cornerAt(0));
				for (var i = 1; i < 4; i++) {
					ctx.lineTo.apply(ctx, cornerAt(i));
				}
	
				ctx.fill();
				if (vm.borderWidth) {
					ctx.stroke();
				}
			},
			height: function() {
				var vm = this._view;
				return vm.base - vm.y;
			},
			inRange: function(mouseX, mouseY) {
				var vm = this._view;
				return vm ?
						(vm.y < vm.base ?
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.y && mouseY <= vm.base) :
							(mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) && (mouseY >= vm.base && mouseY <= vm.y)) :
						false;
			},
			inLabelRange: function(mouseX) {
				var vm = this._view;
				return vm ? (mouseX >= vm.x - vm.width / 2 && mouseX <= vm.x + vm.width / 2) : false;
			},
			tooltipPosition: function() {
				var vm = this._view;
				return {
					x: vm.x,
					y: vm.y
				};
			}
		});
	
	};


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the botttom down to 0
						me.min = 0;
					}
				}
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var ticks = me.ticks = [];
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var maxTicks = me.getTickLimit();
	
				// Make sure we always have at least 2 ticks
				maxTicks = Math.max(2, maxTicks);
	
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				var fixedStepSizeSet = (tickOpts.fixedStepSize && tickOpts.fixedStepSize > 0) || (tickOpts.stepSize && tickOpts.stepSize > 0);
				if (fixedStepSizeSet) {
					spacing = getValueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize);
				} else {
					var niceRange = helpers.niceNum(me.max - me.min, false);
					spacing = helpers.niceNum(niceRange / (maxTicks - 1), true);
				}
				var niceMin = Math.floor(me.min / spacing) * spacing;
				var niceMax = Math.ceil(me.max / spacing) * spacing;
				var numSpaces = (niceMax - niceMin) / spacing;
	
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(tickOpts.min !== undefined ? tickOpts.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(tickOpts.max !== undefined ? tickOpts.max : niceMax);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ }),
/* 1541 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use tose
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
			// Implement this so that
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = helpers.indexOf(labels, me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = helpers.indexOf(labels, me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if ((data.xLabels && isHorizontal) || (data.yLabels && !isHorizontal)) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index, datasetIndex, includeOffset) {
				var me = this;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
	
				if (value !== undefined && isNaN(index)) {
					var labels = me.getLabels();
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueWidth = innerWidth / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex)) + me.paddingLeft;
	
					if (me.options.gridLines.offsetGridLines && includeOffset || me.maxIndex === me.minIndex && includeOffset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				var valueHeight = innerHeight / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex)) + me.paddingTop;
	
				if (me.options.gridLines.offsetGridLines && includeOffset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index, includeOffset) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null, includeOffset);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var value;
				var offsetAmt = Math.max((me.ticks.length - ((me.options.gridLines.offsetGridLines) ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var innerDimension = horz ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var valueDimension = innerDimension / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (me.options.gridLines.offsetGridLines) {
					pixel -= (valueDimension / 2);
				}
				pixel -= horz ? me.paddingLeft : me.paddingTop;
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ }),
/* 1542 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: function(tickValue, index, ticks) {
					// If we have lots of ticks, don't use the ones
					var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
					// If we have a number like 2.5 as the delta, figure out how many decimal places we need
					if (Math.abs(delta) > 1) {
						if (tickValue !== Math.floor(tickValue)) {
							// not an integer
							delta = tickValue - Math.floor(tickValue);
						}
					}
	
					var logDelta = helpers.log10(Math.abs(delta));
					var tickString = '';
	
					if (tickValue !== 0) {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					} else {
						tickString = '0'; // never show decimal places for 0
					}
	
					return tickString;
				}
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (valuesPerType[meta.type] === undefined) {
							valuesPerType[meta.type] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerType[meta.type].positiveValues;
						var negativeValues = valuesPerType[meta.type].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, Chart.defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var innerDimension;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (paddingLeft + me.paddingRight);
					pixel = me.left + (innerDimension / range * (rightValue - start));
					return Math.round(pixel + paddingLeft);
				}
				innerDimension = me.height - (me.paddingTop + paddingBottom);
				pixel = (me.bottom - paddingBottom) - (innerDimension / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var paddingLeft = me.paddingLeft;
				var paddingBottom = me.paddingBottom;
				var innerDimension = isHorizontal ? me.width - (paddingLeft + me.paddingRight) : me.height - (me.paddingTop + paddingBottom);
				var offset = (isHorizontal ? pixel - me.left - paddingLeft : me.bottom - paddingBottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: function(value, index, arr) {
					var remain = value / (Math.pow(10, Math.floor(helpers.log10(value))));
	
					if (value === 0) {
						return '0';
					} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === arr.length - 1) {
						return value.toExponential();
					}
					return '';
				}
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var getValueOrDefault = helpers.getValueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				if (opts.stacked) {
					var valuesPerType = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerType[meta.type] === undefined) {
								valuesPerType[meta.type] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerType[meta.type];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerType, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = getValueOrDefault(tickOpts.min, me.min);
				me.max = getValueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				// Reset the ticks array. Later on, we will draw a grid line at these positions
				// The array simply contains the numerical value of the spots where ticks will be
				var ticks = me.ticks = [];
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
	
				var tickVal = getValueOrDefault(tickOpts.min, Math.pow(10, Math.floor(helpers.log10(me.min))));
	
				while (tickVal < me.max) {
					ticks.push(tickVal);
	
					var exp;
					var significand;
	
					if (tickVal === 0) {
						exp = Math.floor(helpers.log10(me.minNotZero));
						significand = Math.round(me.minNotZero / Math.pow(10, exp));
					} else {
						exp = Math.floor(helpers.log10(tickVal));
						significand = Math.floor(tickVal / Math.pow(10, exp)) + 1;
					}
	
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				}
	
				var lastTick = getValueOrDefault(tickOpts.max, tickVal);
				ticks.push(lastTick);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var innerDimension;
				var pixel;
	
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var range;
				var paddingTop = me.paddingTop;
				var paddingBottom = me.paddingBottom;
				var paddingLeft = me.paddingLeft;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left + paddingLeft;
					} else {
						innerDimension = me.width - (paddingLeft + me.paddingRight);
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
						pixel += paddingLeft;
					}
				} else {
					// Bottom - top since pixels increase downard on a screen
					innerDimension = me.height - (paddingTop + paddingBottom);
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom - paddingBottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - paddingBottom - innerDimension * 0.02 - (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top + paddingTop;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + paddingTop + innerDimension * 0.02;
						} else {
							pixel = me.top + paddingTop + innerDimension * 0.02 + (innerDimension * 0.98/ range * (helpers.log10(newVal)-helpers.log10(me.minNotZero)));
						}
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height - (paddingTop + paddingBottom);
						pixel = (me.bottom - paddingBottom) - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width - (me.paddingLeft + me.paddingRight);
					value = me.start * Math.pow(10, (pixel - me.left - me.paddingLeft) * range / innerDimension);
				} else {  // todo: if start === 0
					innerDimension = me.height - (me.paddingTop + me.paddingBottom);
					value = Math.pow(10, (me.bottom - me.paddingBottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var globalDefaults = Chart.defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			lineArc: false,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2
			},
	
			pointLabels: {
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			getValueCount: function() {
				return this.chart.data.labels.length;
			},
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				me.min = null;
				me.max = null;
	
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}
	
							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				/*
				 * Right, this is really confusing and there is a lot of maths going on here
				 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
				 *
				 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
				 *
				 * Solution:
				 *
				 * We assume the radius of the polygon is half the size of the canvas at first
				 * at each index we check if the text overlaps.
				 *
				 * Where it does, we store that angle and that index.
				 *
				 * After finding the largest index and angle we calculate how much we need to remove
				 * from the shape radius to move the point inwards by that x.
				 *
				 * We average the left and right distances to get the maximum shape radius that can fit in the box
				 * along with labels.
				 *
				 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
				 * on each side, removing that from the size, halving it and adding the left x protrusion width.
				 *
				 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
				 * and position it in the most space efficient manner
				 *
				 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
				 */
	
				var pointLabels = this.options.pointLabels;
				var pointLabelFontSize = helpers.getValueOrDefault(pointLabels.fontSize, globalDefaults.defaultFontSize);
				var pointLabeFontStyle = helpers.getValueOrDefault(pointLabels.fontStyle, globalDefaults.defaultFontStyle);
				var pointLabeFontFamily = helpers.getValueOrDefault(pointLabels.fontFamily, globalDefaults.defaultFontFamily);
				var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
				// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
				// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
				var largestPossibleRadius = helpers.min([(this.height / 2 - pointLabelFontSize - 5), this.width / 2]),
					pointPosition,
					i,
					textWidth,
					halfTextWidth,
					furthestRight = this.width,
					furthestRightIndex,
					furthestRightAngle,
					furthestLeft = 0,
					furthestLeftIndex,
					furthestLeftAngle,
					xProtrusionLeft,
					xProtrusionRight,
					radiusReductionRight,
					radiusReductionLeft;
				this.ctx.font = pointLabeFont;
	
				for (i = 0; i < this.getValueCount(); i++) {
					// 5px to space the text slightly out - similar to what we do in the draw function.
					pointPosition = this.getPointPosition(i, largestPossibleRadius);
					textWidth = this.ctx.measureText(this.pointLabels[i] ? this.pointLabels[i] : '').width + 5;
	
					// Add quarter circle to make degree 0 mean top of circle
					var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
					var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
					if (angle === 0 || angle === 180) {
						// At angle 0 and 180, we're at exactly the top/bottom
						// of the radar chart, so text will be aligned centrally, so we'll half it and compare
						// w/left and right text sizes
						halfTextWidth = textWidth / 2;
						if (pointPosition.x + halfTextWidth > furthestRight) {
							furthestRight = pointPosition.x + halfTextWidth;
							furthestRightIndex = i;
						}
						if (pointPosition.x - halfTextWidth < furthestLeft) {
							furthestLeft = pointPosition.x - halfTextWidth;
							furthestLeftIndex = i;
						}
					} else if (angle < 180) {
						// Less than half the values means we'll left align the text
						if (pointPosition.x + textWidth > furthestRight) {
							furthestRight = pointPosition.x + textWidth;
							furthestRightIndex = i;
						}
					// More than half the values means we'll right align the text
					} else if (pointPosition.x - textWidth < furthestLeft) {
						furthestLeft = pointPosition.x - textWidth;
						furthestLeftIndex = i;
					}
				}
	
				xProtrusionLeft = furthestLeft;
				xProtrusionRight = Math.ceil(furthestRight - this.width);
	
				furthestRightAngle = this.getIndexAngle(furthestRightIndex);
				furthestLeftAngle = this.getIndexAngle(furthestLeftIndex);
	
				radiusReductionRight = xProtrusionRight / Math.sin(furthestRightAngle + Math.PI / 2);
				radiusReductionLeft = xProtrusionLeft / Math.sin(furthestLeftAngle + Math.PI / 2);
	
				// Ensure we actually need to reduce the size of the chart
				radiusReductionRight = (helpers.isNumber(radiusReductionRight)) ? radiusReductionRight : 0;
				radiusReductionLeft = (helpers.isNumber(radiusReductionLeft)) ? radiusReductionLeft : 0;
	
				this.drawingArea = Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2);
				this.setCenterPoint(radiusReductionLeft, radiusReductionRight);
			},
			setCenterPoint: function(leftMovement, rightMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea,
					maxLeft = leftMovement + me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				// Always vertically in the centre as the text height doesn't change
				me.yCenter = Math.round((me.height / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / this.getValueCount();
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier - (Math.PI / 2) + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero? 0:
					min < 0 && max < 0? max :
					min > 0 && max > 0? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var angleLineOpts = opts.angleLines;
				var pointLabelOpts = opts.pointLabels;
				var getValueOrDefault = helpers.getValueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
	
					// Tick Font
					var tickFontSize = getValueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = getValueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = getValueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || opts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
							var yHeight = me.yCenter - yCenterOffset;
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								ctx.strokeStyle = helpers.getValueAtIndexOrDefault(gridLineOpts.color, index - 1);
								ctx.lineWidth = helpers.getValueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
								if (opts.lineArc) {
									// Draw circular arcs between the points
									ctx.beginPath();
									ctx.arc(me.xCenter, me.yCenter, yCenterOffset, 0, Math.PI * 2);
									ctx.closePath();
									ctx.stroke();
								} else {
									// Draw straight lines connecting each index
									ctx.beginPath();
									for (var i = 0; i < me.getValueCount(); i++) {
										var pointPosition = me.getPointPosition(i, yCenterOffset);
										if (i === 0) {
											ctx.moveTo(pointPosition.x, pointPosition.y);
										} else {
											ctx.lineTo(pointPosition.x, pointPosition.y);
										}
									}
									ctx.closePath();
									ctx.stroke();
								}
							}
	
							if (tickOpts.display) {
								var tickFontColor = getValueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										me.xCenter - labelWidth / 2 - tickOpts.backdropPaddingX,
										yHeight - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, me.xCenter, yHeight);
							}
						}
					});
	
					if (!opts.lineArc) {
						ctx.lineWidth = angleLineOpts.lineWidth;
						ctx.strokeStyle = angleLineOpts.color;
	
						var outerDistance = me.getDistanceFromCenterForValue(opts.reverse ? me.min : me.max);
	
						// Point Label Font
						var pointLabelFontSize = getValueOrDefault(pointLabelOpts.fontSize, globalDefaults.defaultFontSize);
						var pointLabeFontStyle = getValueOrDefault(pointLabelOpts.fontStyle, globalDefaults.defaultFontStyle);
						var pointLabeFontFamily = getValueOrDefault(pointLabelOpts.fontFamily, globalDefaults.defaultFontFamily);
						var pointLabeFont = helpers.fontString(pointLabelFontSize, pointLabeFontStyle, pointLabeFontFamily);
	
						for (var i = me.getValueCount() - 1; i >= 0; i--) {
							if (angleLineOpts.display) {
								var outerPosition = me.getPointPosition(i, outerDistance);
								ctx.beginPath();
								ctx.moveTo(me.xCenter, me.yCenter);
								ctx.lineTo(outerPosition.x, outerPosition.y);
								ctx.stroke();
								ctx.closePath();
							}
							// Extra 3px out for some label spacing
							var pointLabelPosition = me.getPointPosition(i, outerDistance + 5);
	
							// Keep this in loop since we may support array properties here
							var pointLabelFontColor = getValueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = pointLabeFont;
							ctx.fillStyle = pointLabelFontColor;
	
							var pointLabels = me.pointLabels;
	
							// Add quarter circle to make degree 0 mean top of circle
							var angleRadians = this.getIndexAngle(i) + (Math.PI / 2);
							var angle = (angleRadians * 360 / (2 * Math.PI)) % 360;
	
							if (angle === 0 || angle === 180) {
								ctx.textAlign = 'center';
							} else if (angle < 180) {
								ctx.textAlign = 'left';
							} else {
								ctx.textAlign = 'right';
							}
	
							// Set the correct text baseline based on outer positioning
							if (angle === 90 || angle === 270) {
								ctx.textBaseline = 'middle';
							} else if (angle > 270 || angle < 90) {
								ctx.textBaseline = 'bottom';
							} else {
								ctx.textBaseline = 'top';
							}
	
							ctx.fillText(pointLabels[i] ? pointLabels[i] : '', pointLabelPosition.x, pointLabelPosition.y);
						}
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(1359);
	moment = typeof(moment) === 'function' ? moment : window.moment;
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
		var time = {
			units: [{
				name: 'millisecond',
				steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
			}, {
				name: 'second',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'minute',
				steps: [1, 2, 5, 10, 30]
			}, {
				name: 'hour',
				steps: [1, 2, 3, 6, 12]
			}, {
				name: 'day',
				steps: [1, 2, 5]
			}, {
				name: 'week',
				maxStep: 4
			}, {
				name: 'month',
				maxStep: 3
			}, {
				name: 'quarter',
				maxStep: 4
			}, {
				name: 'year',
				maxStep: false
			}]
		};
	
		var defaultConfig = {
			position: 'bottom',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm:ss a', // 11:20:01 AM
					hour: 'MMM D, hA', // Sept 4, 5PM
					day: 'll', // Sep 4 2015
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				}
			},
			ticks: {
				autoSkip: false
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				Chart.Scale.prototype.initialize.call(this);
			},
			getLabelMoment: function(datasetIndex, index) {
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (typeof this.labelMoments[datasetIndex] !== 'undefined') {
					return this.labelMoments[datasetIndex][index];
				}
	
				return null;
			},
			getLabelDiff: function(datasetIndex, index) {
				var me = this;
				if (datasetIndex === null || index === null) {
					return null;
				}
	
				if (me.labelDiffs === undefined) {
					me.buildLabelDiffs();
				}
	
				if (typeof me.labelDiffs[datasetIndex] !== 'undefined') {
					return me.labelDiffs[datasetIndex][index];
				}
	
				return null;
			},
			getMomentStartOf: function(tick) {
				var me = this;
				if (me.options.time.unit === 'week' && me.options.time.isoWeekday !== false) {
					return tick.clone().startOf('isoWeek').isoWeekday(me.options.time.isoWeekday);
				}
				return tick.clone().startOf(me.tickUnit);
			},
			determineDataLimits: function() {
				var me = this;
				me.labelMoments = [];
	
				// Only parse these once. If the dataset does not have data as x,y pairs, we will use
				// these
				var scaleLabelMoments = [];
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelMoments.push(labelMoment);
						}
					}, me);
	
					me.firstTick = moment.min.call(me, scaleLabelMoments);
					me.lastTick = moment.max.call(me, scaleLabelMoments);
				} else {
					me.firstTick = null;
					me.lastTick = null;
				}
	
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var momentsForDataset = [];
					var datasetVisible = me.chart.isDatasetVisible(datasetIndex);
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								momentsForDataset.push(labelMoment);
	
								if (datasetVisible) {
									// May have gone outside the scale ranges, make sure we keep the first and last ticks updated
									me.firstTick = me.firstTick !== null ? moment.min(me.firstTick, labelMoment) : labelMoment;
									me.lastTick = me.lastTick !== null ? moment.max(me.lastTick, labelMoment) : labelMoment;
								}
							}
						}, me);
					} else {
						// We have no labels. Use the ones from the scale
						momentsForDataset = scaleLabelMoments;
					}
	
					me.labelMoments.push(momentsForDataset);
				}, me);
	
				// Set these after we've done all the data
				if (me.options.time.min) {
					me.firstTick = me.parseTime(me.options.time.min);
				}
	
				if (me.options.time.max) {
					me.lastTick = me.parseTime(me.options.time.max);
				}
	
				// We will modify these, so clone for later
				me.firstTick = (me.firstTick || moment()).clone();
				me.lastTick = (me.lastTick || moment()).clone();
			},
			buildLabelDiffs: function() {
				var me = this;
				me.labelDiffs = [];
				var scaleLabelDiffs = [];
				// Parse common labels once
				if (me.chart.data.labels && me.chart.data.labels.length > 0) {
					helpers.each(me.chart.data.labels, function(label) {
						var labelMoment = me.parseTime(label);
	
						if (labelMoment.isValid()) {
							if (me.options.time.round) {
								labelMoment.startOf(me.options.time.round);
							}
							scaleLabelDiffs.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
						}
					}, me);
				}
	
				helpers.each(me.chart.data.datasets, function(dataset) {
					var diffsForDataset = [];
	
					if (typeof dataset.data[0] === 'object' && dataset.data[0] !== null) {
						helpers.each(dataset.data, function(value) {
							var labelMoment = me.parseTime(me.getRightValue(value));
	
							if (labelMoment.isValid()) {
								if (me.options.time.round) {
									labelMoment.startOf(me.options.time.round);
								}
								diffsForDataset.push(labelMoment.diff(me.firstTick, me.tickUnit, true));
							}
						}, me);
					} else {
						// We have no labels. Use common ones
						diffsForDataset = scaleLabelDiffs;
					}
	
					me.labelDiffs.push(diffsForDataset);
				}, me);
			},
			buildTicks: function() {
				var me = this;
	
				me.ctx.save();
				var tickFontSize = helpers.getValueOrDefault(me.options.ticks.fontSize, Chart.defaults.global.defaultFontSize);
				var tickFontStyle = helpers.getValueOrDefault(me.options.ticks.fontStyle, Chart.defaults.global.defaultFontStyle);
				var tickFontFamily = helpers.getValueOrDefault(me.options.ticks.fontFamily, Chart.defaults.global.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
				me.ctx.font = tickLabelFont;
	
				me.ticks = [];
				me.unitScale = 1; // How much we scale the unit by, ie 2 means 2x unit per step
				me.scaleSizeInUnits = 0; // How large the scale is in the base unit (seconds, minutes, etc)
	
				// Set unit override if applicable
				if (me.options.time.unit) {
					me.tickUnit = me.options.time.unit || 'day';
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, 1);
				} else {
					// Determine the smallest needed unit of the time
					var innerWidth = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
	
					// Crude approximation of what the label length might be
					var tempFirstLabel = me.tickFormatFunction(me.firstTick, 0, []);
					var tickLabelWidth = me.ctx.measureText(tempFirstLabel).width;
					var cosRotation = Math.cos(helpers.toRadians(me.options.ticks.maxRotation));
					var sinRotation = Math.sin(helpers.toRadians(me.options.ticks.maxRotation));
					tickLabelWidth = (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
					var labelCapacity = innerWidth / (tickLabelWidth);
	
					// Start as small as possible
					me.tickUnit = me.options.time.minUnit;
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					me.displayFormat = me.options.time.displayFormats[me.tickUnit];
	
					var unitDefinitionIndex = 0;
					var unitDefinition = time.units[unitDefinitionIndex];
	
					// While we aren't ideal and we don't have units left
					while (unitDefinitionIndex < time.units.length) {
						// Can we scale this unit. If `false` we can scale infinitely
						me.unitScale = 1;
	
						if (helpers.isArray(unitDefinition.steps) && Math.ceil(me.scaleSizeInUnits / labelCapacity) < helpers.max(unitDefinition.steps)) {
							// Use one of the prefedined steps
							for (var idx = 0; idx < unitDefinition.steps.length; ++idx) {
								if (unitDefinition.steps[idx] >= Math.ceil(me.scaleSizeInUnits / labelCapacity)) {
									me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, unitDefinition.steps[idx]);
									break;
								}
							}
	
							break;
						} else if ((unitDefinition.maxStep === false) || (Math.ceil(me.scaleSizeInUnits / labelCapacity) < unitDefinition.maxStep)) {
							// We have a max step. Scale this unit
							me.unitScale = helpers.getValueOrDefault(me.options.time.unitStepSize, Math.ceil(me.scaleSizeInUnits / labelCapacity));
							break;
						} else {
							// Move to the next unit up
							++unitDefinitionIndex;
							unitDefinition = time.units[unitDefinitionIndex];
	
							me.tickUnit = unitDefinition.name;
							var leadingUnitBuffer = me.firstTick.diff(me.getMomentStartOf(me.firstTick), me.tickUnit, true);
							var trailingUnitBuffer = me.getMomentStartOf(me.lastTick.clone().add(1, me.tickUnit)).diff(me.lastTick, me.tickUnit, true);
							me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true) + leadingUnitBuffer + trailingUnitBuffer;
							me.displayFormat = me.options.time.displayFormats[unitDefinition.name];
						}
					}
				}
	
				var roundedStart;
	
				// Only round the first tick if we have no hard minimum
				if (!me.options.time.min) {
					me.firstTick = me.getMomentStartOf(me.firstTick);
					roundedStart = me.firstTick;
				} else {
					roundedStart = me.getMomentStartOf(me.firstTick);
				}
	
				// Only round the last tick if we have no hard maximum
				if (!me.options.time.max) {
					var roundedEnd = me.getMomentStartOf(me.lastTick);
					var delta = roundedEnd.diff(me.lastTick, me.tickUnit, true);
					if (delta < 0) {
						// Do not use end of because we need me to be in the next time unit
						me.lastTick = me.getMomentStartOf(me.lastTick.add(1, me.tickUnit));
					} else if (delta >= 0) {
						me.lastTick = roundedEnd;
					}
	
					me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
				}
	
				// Tick displayFormat override
				if (me.options.time.displayFormat) {
					me.displayFormat = me.options.time.displayFormat;
				}
	
				// first tick. will have been rounded correctly if options.time.min is not specified
				me.ticks.push(me.firstTick.clone());
	
				// For every unit in between the first and last moment, create a moment and add it to the ticks tick
				for (var i = 1; i <= me.scaleSizeInUnits; ++i) {
					var newTick = roundedStart.clone().add(i, me.tickUnit);
	
					// Are we greater than the max time
					if (me.options.time.max && newTick.diff(me.lastTick, me.tickUnit, true) >= 0) {
						break;
					}
	
					if (i % me.unitScale === 0) {
						me.ticks.push(newTick);
					}
				}
	
				// Always show the right tick
				var diff = me.ticks[me.ticks.length - 1].diff(me.lastTick, me.tickUnit);
				if (diff !== 0 || me.scaleSizeInUnits === 0) {
					// this is a weird case. If the <max> option is the same as the end option, we can't just diff the times because the tick was created from the roundedStart
					// but the last tick was not rounded.
					if (me.options.time.max) {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.ticks[0], me.tickUnit, true);
					} else {
						me.ticks.push(me.lastTick.clone());
						me.scaleSizeInUnits = me.lastTick.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				me.ctx.restore();
	
				// Invalidate label diffs cache
				me.labelDiffs = undefined;
			},
			// Get tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var label = me.chart.data.labels && index < me.chart.data.labels.length ? me.chart.data.labels[index] : '';
	
				if (typeof me.chart.data.datasets[datasetIndex].data[0] === 'object') {
					label = me.getRightValue(me.chart.data.datasets[datasetIndex].data[index]);
				}
	
				// Format nicely
				if (me.options.time.tooltipFormat) {
					label = me.parseTime(label).format(me.options.time.tooltipFormat);
				}
	
				return label;
			},
			// Function to format an individual tick mark
			tickFormatFunction: function(tick, index, ticks) {
				var formattedTick = tick.format(this.displayFormat);
				var tickOpts = this.options.ticks;
				var callback = helpers.getValueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				if (callback) {
					return callback(formattedTick, index, ticks);
				}
				return formattedTick;
			},
			convertTicksToLabels: function() {
				var me = this;
				me.tickMoments = me.ticks;
				me.ticks = me.ticks.map(me.tickFormatFunction, me);
			},
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var offset = null;
				if (index !== undefined && datasetIndex !== undefined) {
					offset = me.getLabelDiff(datasetIndex, index);
				}
	
				if (offset === null) {
					if (!value || !value.isValid) {
						// not already a moment object
						value = me.parseTime(me.getRightValue(value));
					}
					if (value && value.isValid && value.isValid()) {
						offset = value.diff(me.firstTick, me.tickUnit, true);
					}
				}
	
				if (offset !== null) {
					var decimal = offset !== 0 ? offset / me.scaleSizeInUnits : offset;
	
					if (me.isHorizontal()) {
						var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
						var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
						return me.left + Math.round(valueOffset);
					}
					var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
					var heightOffset = (innerHeight * decimal) + me.paddingTop;
	
					return me.top + Math.round(heightOffset);
				}
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickMoments[index], null, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var innerDimension = me.isHorizontal() ? me.width - (me.paddingLeft + me.paddingRight) : me.height - (me.paddingTop + me.paddingBottom);
				var offset = (pixel - (me.isHorizontal() ? me.left + me.paddingLeft : me.top + me.paddingTop)) / innerDimension;
				offset *= me.scaleSizeInUnits;
				return me.firstTick.clone().add(moment.duration(offset, me.tickUnit).asSeconds(), 'seconds');
			},
			parseTime: function(label) {
				var me = this;
				if (typeof me.options.time.parser === 'string') {
					return moment(label, me.options.time.parser);
				}
				if (typeof me.options.time.parser === 'function') {
					return me.options.time.parser(label);
				}
				// Date objects
				if (typeof label.getMonth === 'function' || typeof label === 'number') {
					return moment(label);
				}
				// Moment support
				if (label.isValid && label.isValid()) {
					return label;
				}
				// Custom parsing (return an instance of moment)
				if (typeof me.options.time.format !== 'string' && me.options.time.format.call) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser. See http://nnnick.github.io/Chart.js/docs-v2/#scales-time-scale');
					return me.options.time.format(label);
				}
				// Moment format parsing
				return moment(label, me.options.time.format);
			}
		});
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	
	};


/***/ }),
/* 1546 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
	
					// Specific to Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}],
				yAxes: [{
					type: 'linear'
				}]
			}
		};
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Rectangle,
	
			initialize: function(chart, datasetIndex) {
				Chart.DatasetController.prototype.initialize.call(this, chart, datasetIndex);
	
				// Use this to indicate that this is a bar dataset.
				this.getMeta().bar = true;
			},
	
			// Get the number of datasets that display bars. We use this to correctly calculate the bar width
			getBarCount: function() {
				var me = this;
				var barCount = 0;
				helpers.each(me.chart.data.datasets, function(dataset, datasetIndex) {
					var meta = me.chart.getDatasetMeta(datasetIndex);
					if (meta.bar && me.chart.isDatasetVisible(datasetIndex)) {
						++barCount;
					}
				}, me);
				return barCount;
			},
	
			update: function(reset) {
				var me = this;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					me.updateElement(rectangle, index, reset);
				}, me);
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = yScale.getBasePixel();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: me.calculateBarX(index, me.index),
						y: reset ? scaleBase : me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						width: me.calculateBarWidth(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					}
				});
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var base = 0;
	
				if (yScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return yScale.getPixelForValue(base);
				}
	
				return yScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var datasetCount = me.getBarCount();
	
				var tickWidth;
	
				if (xScale.options.type === 'category') {
					tickWidth = xScale.getPixelForTick(index + 1) - xScale.getPixelForTick(index);
				} else {
					// Average width
					tickWidth = xScale.width / xScale.ticks.length;
				}
				var categoryWidth = tickWidth * xScale.options.categoryPercentage;
				var categorySpacing = (tickWidth - (tickWidth * xScale.options.categoryPercentage)) / 2;
				var fullBarWidth = categoryWidth / datasetCount;
	
				if (xScale.ticks.length !== me.chart.data.labels.length) {
					var perc = xScale.ticks.length / me.chart.data.labels.length;
					fullBarWidth = fullBarWidth * perc;
				}
	
				var barWidth = fullBarWidth * xScale.options.barPercentage;
				var barSpacing = fullBarWidth - (fullBarWidth * xScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickWidth: tickWidth,
					categoryWidth: categoryWidth,
					categorySpacing: categorySpacing,
					fullBarWidth: fullBarWidth,
					barWidth: barWidth,
					barSpacing: barSpacing
				};
			},
	
			calculateBarWidth: function(index) {
				var xScale = this.getScaleForId(this.getMeta().xAxisID);
				if (xScale.options.barThickness) {
					return xScale.options.barThickness;
				}
				var ruler = this.getRuler(index);
				return xScale.options.stacked ? ruler.categoryWidth : ruler.barWidth;
			},
	
			// Get bar index from the given dataset index accounting for the fact that not all bars are visible
			getBarIndex: function(datasetIndex) {
				var barIndex = 0;
				var meta, j;
	
				for (j = 0; j < datasetIndex; ++j) {
					meta = this.chart.getDatasetMeta(j);
					if (meta.bar && this.chart.isDatasetVisible(j)) {
						++barIndex;
					}
				}
	
				return barIndex;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var leftTick = xScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				leftTick -= me.chart.isCombo ? (ruler.tickWidth / 2) : 0;
	
				if (xScale.options.stacked) {
					return leftTick + (ruler.categoryWidth / 2) + ruler.categorySpacing;
				}
	
				return leftTick +
					(ruler.barWidth / 2) +
					ruler.categorySpacing +
					(ruler.barWidth * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (yScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.yAxisID === yScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return yScale.getPixelForValue(sumNeg + value);
					}
					return yScale.getPixelForValue(sumPos + value);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			draw: function(ease) {
				var me = this;
				var easingDecimal = ease || 1;
				helpers.each(me.getMeta().data, function(rectangle, index) {
					var d = me.getDataset().data[index];
					if (d !== null && d !== undefined && !isNaN(d)) {
						rectangle.transition(easingDecimal).draw();
					}
				}, me);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
	
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
	
		});
	
	
		// including horizontalBar in the bar file, instead of a file of its own
		// it extends bar (like pie extends doughnut)
		Chart.defaults.horizontalBar = {
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'linear',
					position: 'bottom'
				}],
				yAxes: [{
					position: 'left',
					type: 'category',
	
					// Specific to Horizontal Bar Controller
					categoryPercentage: 0.8,
					barPercentage: 0.9,
	
					// grid line settings
					gridLines: {
						offsetGridLines: true
					}
				}]
			},
			elements: {
				rectangle: {
					borderSkipped: 'left'
				}
			},
			tooltips: {
				callbacks: {
					title: function(tooltipItems, data) {
						// Pick first xLabel for now
						var title = '';
	
						if (tooltipItems.length > 0) {
							if (tooltipItems[0].yLabel) {
								title = tooltipItems[0].yLabel;
							} else if (data.labels.length > 0 && tooltipItems[0].index < data.labels.length) {
								title = data.labels[tooltipItems[0].index];
							}
						}
	
						return title;
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						return datasetLabel + ': ' + tooltipItem.xLabel;
					}
				}
			}
		};
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var scaleBase = xScale.getBasePixel();
				var custom = rectangle.custom || {};
				var dataset = me.getDataset();
				var rectangleElementOptions = me.chart.options.elements.rectangle;
	
				helpers.extend(rectangle, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? scaleBase : me.calculateBarX(index, me.index),
						y: me.calculateBarY(index, me.index),
	
						// Tooltip
						label: me.chart.data.labels[index],
						datasetLabel: dataset.label,
	
						// Appearance
						base: reset ? scaleBase : me.calculateBarBase(me.index, index),
						height: me.calculateBarHeight(index),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor),
						borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleElementOptions.borderSkipped,
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth)
					},
	
					draw: function() {
						var ctx = this._chart.ctx;
						var vm = this._view;
	
						var halfHeight = vm.height / 2,
							topY = vm.y - halfHeight,
							bottomY = vm.y + halfHeight,
							right = vm.base - (vm.base - vm.x),
							halfStroke = vm.borderWidth / 2;
	
						// Canvas doesn't allow us to stroke inside the width so we can
						// adjust the sizes to fit if we're setting a stroke on the line
						if (vm.borderWidth) {
							topY += halfStroke;
							bottomY -= halfStroke;
							right += halfStroke;
						}
	
						ctx.beginPath();
	
						ctx.fillStyle = vm.backgroundColor;
						ctx.strokeStyle = vm.borderColor;
						ctx.lineWidth = vm.borderWidth;
	
						// Corner points, from bottom-left to bottom-right clockwise
						// | 1 2 |
						// | 0 3 |
						var corners = [
							[vm.base, bottomY],
							[vm.base, topY],
							[right, topY],
							[right, bottomY]
						];
	
						// Find first (starting) corner with fallback to 'bottom'
						var borders = ['bottom', 'left', 'top', 'right'];
						var startCorner = borders.indexOf(vm.borderSkipped, 0);
						if (startCorner === -1) {
							startCorner = 0;
						}
	
						function cornerAt(cornerIndex) {
							return corners[(startCorner + cornerIndex) % 4];
						}
	
						// Draw rectangle from 'startCorner'
						ctx.moveTo.apply(ctx, cornerAt(0));
						for (var i = 1; i < 4; i++) {
							ctx.lineTo.apply(ctx, cornerAt(i));
						}
	
						ctx.fill();
						if (vm.borderWidth) {
							ctx.stroke();
						}
					},
	
					inRange: function(mouseX, mouseY) {
						var vm = this._view;
						var inRange = false;
	
						if (vm) {
							if (vm.x < vm.base) {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.x && mouseX <= vm.base);
							} else {
								inRange = (mouseY >= vm.y - vm.height / 2 && mouseY <= vm.y + vm.height / 2) && (mouseX >= vm.base && mouseX <= vm.x);
							}
						}
	
						return inRange;
					}
				});
	
				rectangle.pivot();
			},
	
			calculateBarBase: function(datasetIndex, index) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var base = 0;
	
				if (xScale.options.stacked) {
					var chart = me.chart;
					var datasets = chart.data.datasets;
					var value = Number(datasets[datasetIndex].data[index]);
	
					for (var i = 0; i < datasetIndex; i++) {
						var currentDs = datasets[i];
						var currentDsMeta = chart.getDatasetMeta(i);
						if (currentDsMeta.bar && currentDsMeta.xAxisID === xScale.id && chart.isDatasetVisible(i)) {
							var currentVal = Number(currentDs.data[index]);
							base += value < 0 ? Math.min(currentVal, 0) : Math.max(currentVal, 0);
						}
					}
	
					return xScale.getPixelForValue(base);
				}
	
				return xScale.getBasePixel();
			},
	
			getRuler: function(index) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var datasetCount = me.getBarCount();
	
				var tickHeight;
				if (yScale.options.type === 'category') {
					tickHeight = yScale.getPixelForTick(index + 1) - yScale.getPixelForTick(index);
				} else {
					// Average width
					tickHeight = yScale.width / yScale.ticks.length;
				}
				var categoryHeight = tickHeight * yScale.options.categoryPercentage;
				var categorySpacing = (tickHeight - (tickHeight * yScale.options.categoryPercentage)) / 2;
				var fullBarHeight = categoryHeight / datasetCount;
	
				if (yScale.ticks.length !== me.chart.data.labels.length) {
					var perc = yScale.ticks.length / me.chart.data.labels.length;
					fullBarHeight = fullBarHeight * perc;
				}
	
				var barHeight = fullBarHeight * yScale.options.barPercentage;
				var barSpacing = fullBarHeight - (fullBarHeight * yScale.options.barPercentage);
	
				return {
					datasetCount: datasetCount,
					tickHeight: tickHeight,
					categoryHeight: categoryHeight,
					categorySpacing: categorySpacing,
					fullBarHeight: fullBarHeight,
					barHeight: barHeight,
					barSpacing: barSpacing
				};
			},
	
			calculateBarHeight: function(index) {
				var me = this;
				var yScale = me.getScaleForId(me.getMeta().yAxisID);
				if (yScale.options.barThickness) {
					return yScale.options.barThickness;
				}
				var ruler = me.getRuler(index);
				return yScale.options.stacked ? ruler.categoryHeight : ruler.barHeight;
			},
	
			calculateBarX: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var value = Number(me.getDataset().data[index]);
	
				if (xScale.options.stacked) {
	
					var sumPos = 0,
						sumNeg = 0;
	
					for (var i = 0; i < datasetIndex; i++) {
						var ds = me.chart.data.datasets[i];
						var dsMeta = me.chart.getDatasetMeta(i);
						if (dsMeta.bar && dsMeta.xAxisID === xScale.id && me.chart.isDatasetVisible(i)) {
							var stackedVal = Number(ds.data[index]);
							if (stackedVal < 0) {
								sumNeg += stackedVal || 0;
							} else {
								sumPos += stackedVal || 0;
							}
						}
					}
	
					if (value < 0) {
						return xScale.getPixelForValue(sumNeg + value);
					}
					return xScale.getPixelForValue(sumPos + value);
				}
	
				return xScale.getPixelForValue(value);
			},
	
			calculateBarY: function(index, datasetIndex) {
				var me = this;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var barIndex = me.getBarIndex(datasetIndex);
	
				var ruler = me.getRuler(index);
				var topTick = yScale.getPixelForValue(null, index, datasetIndex, me.chart.isCombo);
				topTick -= me.chart.isCombo ? (ruler.tickHeight / 2) : 0;
	
				if (yScale.options.stacked) {
					return topTick + (ruler.categoryHeight / 2) + ruler.categorySpacing;
				}
	
				return topTick +
					(ruler.barHeight / 2) +
					ruler.categorySpacing +
					(ruler.barHeight * barIndex) +
					(ruler.barSpacing / 2) +
					(ruler.barSpacing * barIndex);
			}
		});
	};


/***/ }),
/* 1547 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.bubble = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // bubble should probably use a linear scale by default
					position: 'bottom',
					id: 'x-axis-0' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-0'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem, data) {
						var datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
						var dataPoint = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return datasetLabel + ': (' + dataPoint.x + ', ' + dataPoint.y + ', ' + dataPoint.r + ')';
					}
				}
			}
		};
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
	
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var data = dataset.data[index];
				var pointElementOptions = me.chart.options.elements.point;
				var dsIndex = me.index;
	
				helpers.extend(point, {
					// Utility
					_xScale: xScale,
					_yScale: yScale,
					_datasetIndex: dsIndex,
					_index: index,
	
					// Desired view properties
					_model: {
						x: reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex, me.chart.isCombo),
						y: reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex),
						// Appearance
						radius: reset ? 0 : custom.radius ? custom.radius : me.getRadius(data),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				// Trick to reset the styles of the point
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, pointElementOptions);
	
				var model = point._model;
				model.skip = custom.skip ? custom.skip : (isNaN(model.x) || isNaN(model.y));
	
				point.pivot();
			},
	
			getRadius: function(value) {
				return value.r || this.chart.options.elements.point.radius;
			},
	
			setHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.setHoverStyle.call(me, point);
	
				// Radius
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
				model.radius = custom.hoverRadius ? custom.hoverRadius : (helpers.getValueAtIndexOrDefault(dataset.hoverRadius, index, me.chart.options.elements.point.hoverRadius)) + me.getRadius(dataset.data[index]);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				Chart.DatasetController.prototype.removeHoverStyle.call(me, point, me.chart.options.elements.point);
	
				var dataVal = me.chart.data.datasets[point._datasetIndex].data[point._index];
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.radius ? custom.radius : me.getRadius(dataVal);
			}
		});
	};


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers,
			defaults = Chart.defaults;
	
		defaults.doughnut = {
			animation: {
				// Boolean - Whether we animate the rotation of the Doughnut
				animateRotate: true,
				// Boolean - Whether we animate scaling the Doughnut from the centre
				animateScale: false
			},
			aspectRatio: 1,
			hover: {
				mode: 'single'
			},
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc && arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						// toggle visibility of index if exists
						if (meta.data[index]) {
							meta.data[index].hidden = !meta.data[index].hidden;
						}
					}
	
					chart.update();
				}
			},
	
			// The percentage of the chart that we cut out of the middle.
			cutoutPercentage: 50,
	
			// The rotation of the chart, where the first data arc begins.
			rotation: Math.PI * -0.5,
	
			// The total circumference of the chart.
			circumference: Math.PI * 2.0,
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
					}
				}
			}
		};
	
		defaults.pie = helpers.clone(defaults.doughnut);
		helpers.extend(defaults.pie, {
			cutoutPercentage: 0
		});
	
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					arcOpts = opts.elements.arc,
					availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth,
					availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth,
					minSize = Math.min(availableWidth, availableHeight),
					offset = {
						x: 0,
						y: 0
					},
					meta = me.getMeta(),
					cutoutPercentage = opts.cutoutPercentage,
					circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && 0 <= endAngle) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart,
					chartArea = chart.chartArea,
					opts = chart.options,
					animationOpts = opts.animation,
					centerX = (chartArea.left + chartArea.right) / 2,
					centerY = (chartArea.top + chartArea.bottom) / 2,
					startAngle = opts.rotation, // non reset case handled later
					endAngle = opts.rotation, // non reset case handled later
					dataset = me.getDataset(),
					circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI)),
					innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius,
					outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius,
					valueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(elements) {
				var max = 0,
					index = this.index,
					length = elements.length,
					borderWidth,
					hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = elements[i]._model ? elements[i]._model.borderWidth : 0;
					hoverWidth = elements[i]._chart ? elements[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ }),
/* 1549 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.line = {
			showLines: true,
			spanGaps: false,
	
			hover: {
				mode: 'label'
			},
	
			scales: {
				xAxes: [{
					type: 'category',
					id: 'x-axis-0'
				}],
				yAxes: [{
					type: 'linear',
					id: 'y-axis-0'
				}]
			}
		};
	
		function lineEnabled(dataset, options) {
			return helpers.getValueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			addElementAndReset: function(index) {
				var me = this;
				var options = me.chart.options;
				var meta = me.getMeta();
	
				Chart.DatasetController.prototype.addElementAndReset.call(me, index);
	
				// Make sure bezier control points are updated
				if (lineEnabled(me.getDataset(), options) && meta.dataset._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives linse the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.getValueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.getValueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePixel()
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderWidth) {
					borderWidth = custom.borderWidth;
				} else if (dataset.pointBorderWidth) {
					borderWidth = helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (dataset.borderWidth) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
				var labels = me.chart.data.labels || [];
				var includeOffset = (labels.length === 1 || dataset.data.length === 1) || me.chart.isCombo;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex, includeOffset);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.getValueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function(ease) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data || [];
				var easingDecimal = ease || 1;
				var i, ilen;
	
				// Transition Point Locations
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].transition(easingDecimal);
				}
	
				// Transition and Draw the line
				if (lineEnabled(me.getDataset(), me.chart.options)) {
					meta.dataset.transition(easingDecimal).draw();
				}
	
				// Draw the points
				for (i=0, ilen=points.length; i<ilen; ++i) {
					points[i].draw();
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.polarArea = {
	
			scale: {
				type: 'radialLinear',
				lineArc: true, // so that lines are circular
				ticks: {
					beginAtZero: true
				}
			},
	
			// Boolean - Whether to animate the rotation of the chart
			animation: {
				animateRotate: true,
				animateScale: true
			},
	
			startAngle: -0.5 * Math.PI,
			aspectRatio: 1,
			legendCallback: function(chart) {
				var text = [];
				text.push('<ul class="' + chart.id + '-legend">');
	
				var data = chart.data;
				var datasets = data.datasets;
				var labels = data.labels;
	
				if (datasets.length) {
					for (var i = 0; i < datasets[0].data.length; ++i) {
						text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '">');
						if (labels[i]) {
							text.push(labels[i]);
						}
						text.push('</span></li>');
					}
				}
	
				text.push('</ul>');
				return text.join('');
			},
			legend: {
				labels: {
					generateLabels: function(chart) {
						var data = chart.data;
						if (data.labels.length && data.datasets.length) {
							return data.labels.map(function(label, i) {
								var meta = chart.getDatasetMeta(0);
								var ds = data.datasets[0];
								var arc = meta.data[i];
								var custom = arc.custom || {};
								var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
								var arcOpts = chart.options.elements.arc;
								var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
								var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
								var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
								return {
									text: label,
									fillStyle: fill,
									strokeStyle: stroke,
									lineWidth: bw,
									hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
									// Extra data used for toggling the correct item
									index: i
								};
							});
						}
						return [];
					}
				},
	
				onClick: function(e, legendItem) {
					var index = legendItem.index;
					var chart = this.chart;
					var i, ilen, meta;
	
					for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
						meta = chart.getDatasetMeta(i);
						meta.data[index].hidden = !meta.data[index].hidden;
					}
	
					chart.update();
				}
			},
	
			// Need to override these to give a nice default
			tooltips: {
				callbacks: {
					title: function() {
						return '';
					},
					label: function(tooltipItem, data) {
						return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel;
					}
				}
			}
		};
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: Chart.elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var getValueAtIndexOrDefault = helpers.getValueAtIndexOrDefault;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: getValueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ }),
/* 1551 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var helpers = Chart.helpers;
	
		Chart.defaults.radar = {
			scale: {
				type: 'radialLinear'
			},
			elements: {
				line: {
					tension: 0 // no bezier in radar
				}
			}
		};
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: Chart.elements.Line,
	
			dataElementType: Chart.elements.Point,
	
			linkScales: helpers.noop,
	
			addElementAndReset: function(index) {
				Chart.DatasetController.prototype.addElementAndReset.call(this, index);
	
				// Make sure bezier control points are updated
				this.updateBezierControlPoints();
			},
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
	
						// Scale
						scaleTop: scale.top,
						scaleBottom: scale.bottom,
						scaleZero: scale.getBasePosition()
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.getValueOrDefault(dataset.tension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.getValueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.getValueAtIndexOrDefault(dataset.hitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			draw: function(ease) {
				var meta = this.getMeta();
				var easingDecimal = ease || 1;
	
				// Transition Point Locations
				helpers.each(meta.data, function(point) {
					point.transition(easingDecimal);
				});
	
				// Transition and Draw the line
				meta.dataset.transition(easingDecimal).draw();
	
				// Draw the points
				helpers.each(meta.data, function(point) {
					point.draw();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.getValueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.getValueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.getValueAtIndexOrDefault(dataset.radius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.getValueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.getValueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.getValueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ }),
/* 1552 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1553 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1555 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1557 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.options = Chart.helpers.configMerge({aspectRatio: 1}, config.options);
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1558 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			hover: {
				mode: 'single'
			},
	
			scales: {
				xAxes: [{
					type: 'linear', // scatter should not use a category axis
					position: 'bottom',
					id: 'x-axis-1' // need an ID so datasets can reference the scale
				}],
				yAxes: [{
					type: 'linear',
					position: 'left',
					id: 'y-axis-1'
				}]
			},
	
			tooltips: {
				callbacks: {
					title: function() {
						// Title doesn't make sense for scatter since we format the data as a point
						return '';
					},
					label: function(tooltipItem) {
						return '(' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
					}
				}
			}
		};
	
		// Register the default config for this type
		Chart.defaults.scatter = defaultConfig;
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	
	};


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * angular-chart.js - An angular.js wrapper for Chart.js
	 * http://jtblin.github.io/angular-chart.js/
	 * Version: 1.1.1
	 *
	 * Copyright 2016 Jerome Touffe-Blin
	 * Released under the BSD-2-Clause license
	 * https://github.com/jtblin/angular-chart.js/blob/master/LICENSE
	 */
	(function (factory) {
	  'use strict';
	  if (true) {
	    // Node/CommonJS
	    module.exports = factory(
	      typeof angular !== 'undefined' ? angular : __webpack_require__(369),
	      typeof Chart !== 'undefined' ? Chart : __webpack_require__(1516));
	  }  else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(['angular', 'chart'], factory);
	  } else {
	    // Browser globals
	    if (typeof angular === 'undefined') {
	        throw new Error('AngularJS framework needs to be included, see https://angularjs.org/');
	    } else if (typeof Chart === 'undefined') {
	      throw new Error('Chart.js library needs to be included, see http://jtblin.github.io/angular-chart.js/');
	    }
	    factory(angular, Chart);
	  }
	}(function (angular, Chart) {
	  'use strict';
	
	  Chart.defaults.global.multiTooltipTemplate = '<%if (datasetLabel){%><%=datasetLabel%>: <%}%><%= value %>';
	  Chart.defaults.global.tooltips.mode = 'label';
	  Chart.defaults.global.elements.line.borderWidth = 2;
	  Chart.defaults.global.elements.rectangle.borderWidth = 2;
	  Chart.defaults.global.legend.display = false;
	  Chart.defaults.global.colors = [
	    '#97BBCD', // blue
	    '#DCDCDC', // light grey
	    '#F7464A', // red
	    '#46BFBD', // green
	    '#FDB45C', // yellow
	    '#949FB1', // grey
	    '#4D5360'  // dark grey
	  ];
	
	  var useExcanvas = typeof window.G_vmlCanvasManager === 'object' &&
	    window.G_vmlCanvasManager !== null &&
	    typeof window.G_vmlCanvasManager.initElement === 'function';
	
	  if (useExcanvas) Chart.defaults.global.animation = false;
	
	  return angular.module('chart.js', [])
	    .provider('ChartJs', ChartJsProvider)
	    .factory('ChartJsFactory', ['ChartJs', '$timeout', ChartJsFactory])
	    .directive('chartBase', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory(); }])
	    .directive('chartLine', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('line'); }])
	    .directive('chartBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bar'); }])
	    .directive('chartHorizontalBar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('horizontalBar'); }])
	    .directive('chartRadar', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('radar'); }])
	    .directive('chartDoughnut', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('doughnut'); }])
	    .directive('chartPie', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('pie'); }])
	    .directive('chartPolarArea', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('polarArea'); }])
	    .directive('chartBubble', ['ChartJsFactory', function (ChartJsFactory) { return new ChartJsFactory('bubble'); }])
	    .name;
	
	  /**
	   * Wrapper for chart.js
	   * Allows configuring chart js using the provider
	   *
	   * angular.module('myModule', ['chart.js']).config(function(ChartJsProvider) {
	   *   ChartJsProvider.setOptions({ responsive: false });
	   *   ChartJsProvider.setOptions('Line', { responsive: true });
	   * })))
	   */
	  function ChartJsProvider () {
	    var options = { responsive: true };
	    var ChartJs = {
	      Chart: Chart,
	      getOptions: function (type) {
	        var typeOptions = type && options[type] || {};
	        return angular.extend({}, options, typeOptions);
	      }
	    };
	
	    /**
	     * Allow to set global options during configuration
	     */
	    this.setOptions = function (type, customOptions) {
	      // If no type was specified set option for the global object
	      if (! customOptions) {
	        customOptions = type;
	        options = angular.merge(options, customOptions);
	      } else {
	        // Set options for the specific chart
	        options[type] = angular.merge(options[type] || {}, customOptions);
	      }
	
	      angular.merge(ChartJs.Chart.defaults, options);
	    };
	
	    this.$get = function () {
	      return ChartJs;
	    };
	  }
	
	  function ChartJsFactory (ChartJs, $timeout) {
	    return function chart (type) {
	      return {
	        restrict: 'CA',
	        scope: {
	          chartGetColor: '=?',
	          chartType: '=',
	          chartData: '=?',
	          chartLabels: '=?',
	          chartOptions: '=?',
	          chartSeries: '=?',
	          chartColors: '=?',
	          chartClick: '=?',
	          chartHover: '=?',
	          chartDatasetOverride: '=?'
	        },
	        link: function (scope, elem/*, attrs */) {
	          if (useExcanvas) window.G_vmlCanvasManager.initElement(elem[0]);
	
	          // Order of setting "watch" matter
	          scope.$watch('chartData', watchData, true);
	          scope.$watch('chartSeries', watchOther, true);
	          scope.$watch('chartLabels', watchOther, true);
	          scope.$watch('chartOptions', watchOther, true);
	          scope.$watch('chartColors', watchOther, true);
	          scope.$watch('chartDatasetOverride', watchOther, true);
	          scope.$watch('chartType', watchType, false);
	
	          scope.$on('$destroy', function () {
	            destroyChart(scope);
	          });
	
	          scope.$on('$resize', function () {
	            if (scope.chart) scope.chart.resize();
	          });
	
	          function watchData (newVal, oldVal) {
	            if (! newVal || ! newVal.length || (Array.isArray(newVal[0]) && ! newVal[0].length)) {
	              destroyChart(scope);
	              return;
	            }
	            var chartType = type || scope.chartType;
	            if (! chartType) return;
	
	            if (scope.chart && canUpdateChart(newVal, oldVal))
	              return updateChart(newVal, scope);
	
	            createChart(chartType, scope, elem);
	          }
	
	          function watchOther (newVal, oldVal) {
	            if (isEmpty(newVal)) return;
	            if (angular.equals(newVal, oldVal)) return;
	            var chartType = type || scope.chartType;
	            if (! chartType) return;
	
	            // chart.update() doesn't work for series and labels
	            // so we have to re-create the chart entirely
	            createChart(chartType, scope, elem);
	          }
	
	          function watchType (newVal, oldVal) {
	            if (isEmpty(newVal)) return;
	            if (angular.equals(newVal, oldVal)) return;
	            createChart(newVal, scope, elem);
	          }
	        }
	      };
	    };
	
	    function createChart (type, scope, elem) {
	      var options = getChartOptions(type, scope);
	      if (! hasData(scope) || ! canDisplay(type, scope, elem, options)) return;
	
	      var cvs = elem[0];
	      var ctx = cvs.getContext('2d');
	
	      scope.chartGetColor = getChartColorFn(scope);
	      var data = getChartData(type, scope);
	      // Destroy old chart if it exists to avoid ghost charts issue
	      // https://github.com/jtblin/angular-chart.js/issues/187
	      destroyChart(scope);
	
	      scope.chart = new ChartJs.Chart(ctx, {
	        type: type,
	        data: data,
	        options: options
	      });
	      scope.$emit('chart-create', scope.chart);
	      bindEvents(cvs, scope);
	    }
	
	    function canUpdateChart (newVal, oldVal) {
	      if (newVal && oldVal && newVal.length && oldVal.length) {
	        return Array.isArray(newVal[0]) ?
	        newVal.length === oldVal.length && newVal.every(function (element, index) {
	          return element.length === oldVal[index].length; }) :
	          oldVal.reduce(sum, 0) > 0 ? newVal.length === oldVal.length : false;
	      }
	      return false;
	    }
	
	    function sum (carry, val) {
	      return carry + val;
	    }
	
	    function getEventHandler (scope, action, triggerOnlyOnChange) {
	      var lastState = {
	        point: void 0,
	        points: void 0
	      };
	      return function (evt) {
	        var atEvent = scope.chart.getElementAtEvent || scope.chart.getPointAtEvent;
	        var atEvents = scope.chart.getElementsAtEvent || scope.chart.getPointsAtEvent;
	        if (atEvents) {
	          var points = atEvents.call(scope.chart, evt);
	          var point = atEvent ? atEvent.call(scope.chart, evt)[0] : void 0;
	
	          if (triggerOnlyOnChange === false ||
	            (! angular.equals(lastState.points, points) && ! angular.equals(lastState.point, point))
	          ) {
	            lastState.point = point;
	            lastState.points = points;
	            scope[action](points, evt, point);
	          }
	        }
	      };
	    }
	
	    function getColors (type, scope) {
	      var colors = angular.copy(scope.chartColors ||
	        ChartJs.getOptions(type).chartColors ||
	        Chart.defaults.global.colors
	      );
	      var notEnoughColors = colors.length < scope.chartData.length;
	      while (colors.length < scope.chartData.length) {
	        colors.push(scope.chartGetColor());
	      }
	      // mutate colors in this case as we don't want
	      // the colors to change on each refresh
	      if (notEnoughColors) scope.chartColors = colors;
	      return colors.map(convertColor);
	    }
	
	    function convertColor (color) {
	      // Allows RGB and RGBA colors to be input as a string: e.g.: "rgb(159,204,0)", "rgba(159,204,0, 0.5)"
	      if (typeof color === 'string' && color[0] === 'r') return getColor(rgbStringToRgb(color));
	      // Allows hex colors to be input as a string.
	      if (typeof color === 'string' && color[0] === '#') return getColor(hexToRgb(color.substr(1)));
	      // Allows colors to be input as an object, bypassing getColor() entirely
	      if (typeof color === 'object' && color !== null) return color;
	      return getRandomColor();
	    }
	
	    function getRandomColor () {
	      var color = [getRandomInt(0, 255), getRandomInt(0, 255), getRandomInt(0, 255)];
	      return getColor(color);
	    }
	
	    function getColor (color) {
	      var alpha = color[3] || 1;
	      color = color.slice(0, 3);
	      return {
	        backgroundColor: rgba(color, 0.2),
	        pointBackgroundColor: rgba(color, alpha),
	        pointHoverBackgroundColor: rgba(color, 0.8),
	        borderColor: rgba(color, alpha),
	        pointBorderColor: '#fff',
	        pointHoverBorderColor: rgba(color, alpha)
	      };
	    }
	
	    function getRandomInt (min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    }
	
	    function rgba (color, alpha) {
	      // rgba not supported by IE8
	      return useExcanvas ? 'rgb(' + color.join(',') + ')' : 'rgba(' + color.concat(alpha).join(',') + ')';
	    }
	
	    // Credit: http://stackoverflow.com/a/11508164/1190235
	    function hexToRgb (hex) {
	      var bigint = parseInt(hex, 16),
	        r = (bigint >> 16) & 255,
	        g = (bigint >> 8) & 255,
	        b = bigint & 255;
	
	      return [r, g, b];
	    }
	
	    function rgbStringToRgb (color) {
	      var match = color.match(/^rgba?\(([\d,.]+)\)$/);
	      if (! match) throw new Error('Cannot parse rgb value');
	      color = match[1].split(',');
	      return color.map(Number);
	    }
	
	    function hasData (scope) {
	      return scope.chartData && scope.chartData.length;
	    }
	
	    function getChartColorFn (scope) {
	      return typeof scope.chartGetColor === 'function' ? scope.chartGetColor : getRandomColor;
	    }
	
	    function getChartData (type, scope) {
	      var colors = getColors(type, scope);
	      return Array.isArray(scope.chartData[0]) ?
	        getDataSets(scope.chartLabels, scope.chartData, scope.chartSeries || [], colors, scope.chartDatasetOverride) :
	        getData(scope.chartLabels, scope.chartData, colors, scope.chartDatasetOverride);
	    }
	
	    function getDataSets (labels, data, series, colors, datasetOverride) {
	      return {
	        labels: labels,
	        datasets: data.map(function (item, i) {
	          var dataset = angular.extend({}, colors[i], {
	            label: series[i],
	            data: item
	          });
	          if (datasetOverride && datasetOverride.length >= i) {
	            angular.merge(dataset, datasetOverride[i]);
	          }
	          return dataset;
	        })
	      };
	    }
	
	    function getData (labels, data, colors, datasetOverride) {
	      var dataset = {
	        labels: labels,
	        datasets: [{
	          data: data,
	          backgroundColor: colors.map(function (color) {
	            return color.pointBackgroundColor;
	          }),
	          hoverBackgroundColor: colors.map(function (color) {
	            return color.backgroundColor;
	          })
	        }]
	      };
	      if (datasetOverride) {
	        angular.merge(dataset.datasets[0], datasetOverride);
	      }
	      return dataset;
	    }
	
	    function getChartOptions (type, scope) {
	      return angular.extend({}, ChartJs.getOptions(type), scope.chartOptions);
	    }
	
	    function bindEvents (cvs, scope) {
	      cvs.onclick = scope.chartClick ? getEventHandler(scope, 'chartClick', false) : angular.noop;
	      cvs.onmousemove = scope.chartHover ? getEventHandler(scope, 'chartHover', true) : angular.noop;
	    }
	
	    function updateChart (values, scope) {
	      if (Array.isArray(scope.chartData[0])) {
	        scope.chart.data.datasets.forEach(function (dataset, i) {
	          dataset.data = values[i];
	        });
	      } else {
	        scope.chart.data.datasets[0].data = values;
	      }
	
	      scope.chart.update();
	      scope.$emit('chart-update', scope.chart);
	    }
	
	    function isEmpty (value) {
	      return ! value ||
	        (Array.isArray(value) && ! value.length) ||
	        (typeof value === 'object' && ! Object.keys(value).length);
	    }
	
	    function canDisplay (type, scope, elem, options) {
	      // TODO: check parent?
	      if (options.responsive && elem[0].clientHeight === 0) {
	        $timeout(function () {
	          createChart(type, scope, elem);
	        }, 50, false);
	        return false;
	      }
	      return true;
	    }
	
	    function destroyChart(scope) {
	      if(! scope.chart) return;
	      scope.chart.destroy();
	      scope.$emit('chart-destroy', scope.chart);
	    }
	  }
	}));


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	// Browserify
	
	__webpack_require__(369);
	__webpack_require__(1561);
	
	module.exports = 'fixed.table.header';


/***/ }),
/* 1561 */
/***/ (function(module, exports) {

	/*
	 * Angular Fixed Table Header
	 * https://github.com/daniel-nagy/fixed-table-header
	 * @license MIT
	 * v0.2.1
	 */
	(function (window, angular, undefined) {
	'use strict';
	
	angular.module('fixed.table.header', []).directive('fixHead', fixHead);
	
	function fixHead($compile, $window) {
	  
	  function compile(tElement) {
	    var table = {
	      clone: tElement.parent().clone().empty(),
	      original: tElement.parent()
	    };
	    
	    var header = {
	      clone: tElement.clone(),
	      original: tElement
	    };
	    
	    // prevent recursive compilation
	    header.clone.removeAttr('fix-head').removeAttr('ng-if');
	    
	    table.clone.css({display: 'block', overflow: 'hidden'}).addClass('clone');
	    header.clone.css('display', 'block');
	    header.original.css('visibility', 'hidden');
	    
	    return function postLink(scope) {
	      var scrollContainer = table.original.parent();
	      
	      // insert the element so when it is compiled it will link
	      // with the correct scope and controllers
	      header.original.after(header.clone);
	      
	      $compile(table.clone)(scope);
	      $compile(header.clone)(scope);
	      
	      scrollContainer.parent()[0].insertBefore(table.clone.append(header.clone)[0], scrollContainer[0]);
	      
	      scrollContainer.on('scroll', function () {
	        // use CSS transforms to move the cloned header when the table is scrolled horizontally
	        header.clone.css('transform', 'translate3d(' + -(scrollContainer.prop('scrollLeft')) + 'px, 0, 0)');
	      });
	      
	      function cells() {
	        return header.clone.find('th').length;
	      }
	      
	      function getCells(node) {
	        return Array.prototype.map.call(node.find('th'), function (cell) {
	          return jQLite(cell);
	        });
	      }
	      
	      function height() {
	        return header.original.prop('clientHeight');
	      }
	      
	      function jQLite(node) {
	        return angular.element(node);
	      }
	      
	      function marginTop(height) {
	        table.original.css('marginTop', '-' + height + 'px');
	      }
	      
	      function updateCells() {
	        var cells = {
	          clone: getCells(header.clone),
	          original: getCells(header.original)
	        };
	        
	        cells.clone.forEach(function (clone, index) {
	          if(clone.data('isClone')) {
	            return;
	          }
	          
	          // prevent duplicating watch listeners
	          clone.data('isClone', true);
	          
	          var cell = cells.original[index];
	          var style = $window.getComputedStyle(cell[0]);
	          
	          var getWidth = function () {
	            return style.width;
	          };
	          
	          var setWidth = function () {
	            marginTop(height());
	            clone.css({minWidth: style.width, maxWidth: style.width});
	          };
	          
	          var listener = scope.$watch(getWidth, setWidth);
	          
	          $window.addEventListener('resize', setWidth);
	          
	          clone.on('$destroy', function () {
	            listener();
	            $window.removeEventListener('resize', setWidth);
	          });
	          
	          cell.on('$destroy', function () {
	            clone.remove();
	          });
	        });
	      }
	      
	      scope.$watch(cells, updateCells);
	      
	      header.original.on('$destroy', function () {
	        header.clone.remove();
	      });
	    };
	  }
	  
	  return {
	    compile: compile
	  };
	}
	
	fixHead.$inject = ['$compile', '$window'];
	
	})(window, angular);

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.4.1
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {
	
	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /Windows Phone/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group
	
	            'Nexus 7' +     // Nexus 7
	
	            '|' +           // OR
	
	            'BNTV250' +     // B&N Nook Tablet 7 inch
	
	            '|' +           // OR
	
	            'Kindle Fire' + // Kindle Fire
	
	            '|' +           // OR
	
	            'Silk' +        // Kindle Fire, Silk Accelerated
	
	            '|' +           // OR
	
	            'GT-P1000' +    // Galaxy Tab 7 inch
	
	            ')',            // End non-capturing group
	
	            'i');           // Case-insensitive matching
	
	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };
	
	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;
	
	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	        // iPhone" string. Same probable happens on other tablet platforms.
	        // This will confuse detection so strip it out if it exists.
	        tmp = ua.split('Twitter');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
	
	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;
	
	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
	
	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };
	
	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };
	
	    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }
	
	})(this);


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1564);
	module.exports = 'ismobile';

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * isMobile.js v0.3.9
	 *
	 * A simple library to detect Apple phones and tablets,
	 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
	 * and any kind of seven inch device, via user agent sniffing.
	 *
	 * @author: Kai Mallea (kmallea@gmail.com)
	 *
	 * @license: http://creativecommons.org/publicdomain/zero/1.0/
	 */
	(function (global) {
	
	    var apple_phone         = /iPhone/i,
	        apple_ipod          = /iPod/i,
	        apple_tablet        = /iPad/i,
	        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
	        android_tablet      = /Android/i,
	        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
	        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
	        windows_phone       = /IEMobile/i,
	        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
	        other_blackberry    = /BlackBerry/i,
	        other_blackberry_10 = /BB10/i,
	        other_opera         = /Opera Mini/i,
	        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
	        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
	        seven_inch = new RegExp(
	            '(?:' +         // Non-capturing group
	
	            'Nexus 7' +     // Nexus 7
	
	            '|' +           // OR
	
	            'BNTV250' +     // B&N Nook Tablet 7 inch
	
	            '|' +           // OR
	
	            'Kindle Fire' + // Kindle Fire
	
	            '|' +           // OR
	
	            'Silk' +        // Kindle Fire, Silk Accelerated
	
	            '|' +           // OR
	
	            'GT-P1000' +    // Galaxy Tab 7 inch
	
	            ')',            // End non-capturing group
	
	            'i');           // Case-insensitive matching
	
	    var match = function(regex, userAgent) {
	        return regex.test(userAgent);
	    };
	
	    var IsMobileClass = function(userAgent) {
	        var ua = userAgent || navigator.userAgent;
	        // Facebook mobile app's integrated browser adds a bunch of strings that
	        // match everything. Strip it out if it exists.
	        var tmp = ua.split('[FBAN');
	        if (typeof tmp[1] !== 'undefined') {
	            ua = tmp[0];
	        }
	
	        this.apple = {
	            phone:  match(apple_phone, ua),
	            ipod:   match(apple_ipod, ua),
	            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
	            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
	        };
	        this.amazon = {
	            phone:  match(amazon_phone, ua),
	            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
	        };
	        this.android = {
	            phone:  match(amazon_phone, ua) || match(android_phone, ua),
	            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
	            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
	        };
	        this.windows = {
	            phone:  match(windows_phone, ua),
	            tablet: match(windows_tablet, ua),
	            device: match(windows_phone, ua) || match(windows_tablet, ua)
	        };
	        this.other = {
	            blackberry:   match(other_blackberry, ua),
	            blackberry10: match(other_blackberry_10, ua),
	            opera:        match(other_opera, ua),
	            firefox:      match(other_firefox, ua),
	            chrome:       match(other_chrome, ua),
	            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
	        };
	        this.seven_inch = match(seven_inch, ua);
	        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
	        // excludes 'other' devices and ipods, targeting touchscreen phones
	        this.phone = this.apple.phone || this.android.phone || this.windows.phone;
	        // excludes 7 inch devices, classifying as phone or tablet is left to the user
	        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
	
	        if (typeof window === 'undefined') {
	            return this;
	        }
	    };
	
	    var instantiate = function() {
	        var IM = new IsMobileClass();
	        IM.Class = IsMobileClass;
	        return IM;
	    };
	
	    if (typeof module != 'undefined' && module.exports && typeof window === 'undefined') {
	        //node
	        module.exports = IsMobileClass;
	    } else if (typeof module != 'undefined' && module.exports && typeof window !== 'undefined') {
	        //browserify
	        module.exports = instantiate();
	    } else if (true) {
	        //AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	        global.isMobile = instantiate();
	    }
	
	})(this);
	
	
	/**
	 * angular-ismobile by Ronny Haase <ronhaase@gmail.com>
	 *
	 * Licensed under CC0 1.0 Universal (CC0 1.0)
	 *
	 * https://github.com/ronnyhaase/angular-ismobile
	 */
	(function () {
		'use strict';
	
		angular.module('ismobile', []);
	
		angular.module('ismobile').provider('isMobile', ['$windowProvider', function IsMobileProvider($windowProvider) {
			var _window = $windowProvider.$get();
	
			angular.merge(this, _window.isMobile);
	
			this.$get = [function isMobileFactory() {
				return angular.copy(_window.isMobile);
			}];
		}]);
	})();


/***/ }),
/* 1565 */
/***/ (function(module, exports) {

	(function (angular) {
	    'use strict';
	
	    var mod = angular.module('ngPrint', []);
	
	    function printDirective() {
	        var printSection = document.getElementById('printSection');
	
	        // if there is no printing section, create one
	        if (!printSection) {
	            printSection = document.createElement('div');
	            printSection.id = 'printSection';
	            document.body.appendChild(printSection);
	        }
	
	        function link(scope, element, attrs) {
	            element.on('click', function () {
	                var elemToPrint = document.getElementById(attrs.printElementId);
	                if (elemToPrint) {
	                    printElement(elemToPrint);
	                }
	            });
	
	            if (window.matchMedia) {
	                var mediaQueryList = window.matchMedia('print');
	                mediaQueryList.addListener(function(mql) {
	                    if (!mql.matches) {
	                        afterPrint();
	                    } else {
	                        // before print (currently does nothing)
	                    }
	                });
	            }
	
	            window.onafterprint = afterPrint;
	        }
	
	        function afterPrint() {
	            // clean the print section before adding new content
	            printSection.innerHTML = '';
	        }
	
	        function printElement(elem) {
	            // clones the element you want to print
	            var domClone = elem.cloneNode(true);
	            printSection.innerHTML = '';
	            printSection.appendChild(domClone);
	            window.print();
	        }
	
	        return {
	            link: link,
	            restrict: 'A'
	        };
	    }
	
	    mod.directive('ngPrint', [printDirective]);
	}(window.angular));


/***/ }),
/* 1566 */
/***/ (function(module, exports) {

	/**
	 * @ngDoc directive
	 * @name ng.directive:paging
	 *
	 * @description
	 * A directive to aid in paging large datasets
	 * while requiring a small amount of page
	 * information.
	 *
	 * @element EA
	 *
	 */
	angular.module('bw.paging', []).directive('paging', function () {
	
	
	    /**
	     * The regex expression to use for any replace methods
	     * Feel free to tweak / fork values for your application
	     */
	    var regex = /\{page\}/g;
	    
	
	    /**
	     * The angular return value required for the directive
	     * Feel free to tweak / fork values for your application
	     */
	    return {
	
	        // Restrict to elements and attributes
	        restrict: 'EA',
	
	        // Assign the angular link function
	        link: fieldLink,
	        
	        // Assign the angular directive template HTML
	        template: fieldTemplate,
	
	        // Assign the angular scope attribute formatting
	        scope: {
	            page: '=',
	            pageSize: '=',
	            total: '=',
	            disabled: '@',
	            dots: '@',
	            ulClass: '@',
	            activeClass: '@',
	            disabledClass: '@',
	            adjacent: '@',
	            pagingAction: '&',
	            pgHref: '@',
	            textFirst: '@',
	            textLast: '@',
	            textNext: '@',
	            textPrev: '@',
	            textFirstClass: '@',
	            textLastClass: '@',
	            textNextClass: '@',
	            textPrevClass: '@',
	            textTitlePage: '@',
	            textTitleFirst: '@',
	            textTitleLast: '@',
	            textTitleNext: '@',
	            textTitlePrev: '@'
	        }
	                    
	    };
	
	
	    /**
	     * Link the directive to enable our scope watch values
	     *
	     * @param {object} scope - Angular link scope
	     * @param {object} el - Angular link element
	     * @param {object} attrs - Angular link attribute
	     */
	    function fieldLink(scope, el, attrs) {
	
	        // Hook in our watched items
	        scope.$watchCollection('[page,pageSize,total,disabled]', function () {
	            build(scope, attrs);
	        });
	    }
	    
	    
	    /**
	     * Create our template html 
	     * We use a function to figure out how to handle href correctly
	     * 
	     * @param {object} el - Angular link element
	     * @param {object} attrs - Angular link attribute
	     */
	    function fieldTemplate(el, attrs){
	            return '<ul data-ng-hide="Hide" data-ng-class="ulClass"> ' +
	                '<li ' +
	                    'title="{{Item.title}}" ' +
	                    'data-ng-class="Item.liClass" ' +
	                    'data-ng-repeat="Item in List"> ' +
	                        '<a ' + 
	                            (attrs.pgHref ? 'data-ng-href="{{Item.pgHref}}" ' : 'href ') +
	                            'data-ng-class="Item.aClass" ' +
	                            'data-ng-click="Item.action()" ' +
	                            'data-ng-bind="Item.value">'+ 
	                        '</a> ' +
	                '</li>' +
	            '</ul>' 
	    }
	
	
	    /**
	     * Assign default scope values from settings
	     * Feel free to tweak / fork these for your application
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {Object} attrs - The local directive attribute object
	     */
	    function setScopeValues(scope, attrs) {
	
	        scope.List = [];
	        scope.Hide = false;
	        
	        scope.page = parseInt(scope.page) || 1;
	        scope.total = parseInt(scope.total) || 0;
	        scope.adjacent = parseInt(scope.adjacent) || 2;
	
	        scope.pgHref = scope.pgHref || '';
	        scope.dots = scope.dots || '...';
	        
	        scope.ulClass = scope.ulClass || 'pagination';
	        scope.activeClass = scope.activeClass || 'active';
	        scope.disabledClass = scope.disabledClass || 'disabled';
	
	        scope.textFirst = scope.textFirst || '<<';
	        scope.textLast = scope.textLast || '>>';
	        scope.textNext = scope.textNext || '>';
	        scope.textPrev = scope.textPrev || '<';
	        
	        scope.textFirstClass = scope.textFirstClass || '';
	        scope.textLastClass= scope.textLastClass || '';
	        scope.textNextClass = scope.textNextClass || '';
	        scope.textPrevClass = scope.textPrevClass || '';
	
	        scope.textTitlePage = scope.textTitlePage || 'Page {page}';
	        scope.textTitleFirst = scope.textTitleFirst || 'First Page'; 
	        scope.textTitleLast = scope.textTitleLast || 'Last Page'; 
	        scope.textTitleNext = scope.textTitleNext || 'Next Page'; 
	        scope.textTitlePrev = scope.textTitlePrev || 'Previous Page'; 
	
	        scope.hideIfEmpty = evalBoolAttribute(scope, attrs.hideIfEmpty);
	        scope.showPrevNext = evalBoolAttribute(scope, attrs.showPrevNext);
	        scope.showFirstLast = evalBoolAttribute(scope, attrs.showFirstLast);
	        scope.scrollTop = evalBoolAttribute(scope, attrs.scrollTop);
	        scope.isDisabled = evalBoolAttribute(scope, attrs.disabled);
	    }
	
	
	    /**
	     * A helper to perform our boolean eval on attributes
	     * This allows flexibility in the attribute for strings and variables in scope
	     * 
	     * @param {Object} scope - The local directive scope object
	     * @param {Object} value - The attribute value of interest
	     */
	    function evalBoolAttribute(scope, value){
	        return angular.isDefined(value)
	            ? !!scope.$parent.$eval(value)
	            : false;
	    }
	
	
	    /**
	     * Validate and clean up any scope values
	     * This happens after we have set the scope values
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {int} pageCount - The last page number or total page count
	     */
	    function validateScopeValues(scope, pageCount) {
	
	        // Block where the page is larger than the pageCount
	        if (scope.page > pageCount) {
	            scope.page = pageCount;
	        }
	
	        // Block where the page is less than 0
	        if (scope.page <= 0) {
	            scope.page = 1;
	        }
	
	        // Block where adjacent value is 0 or below
	        if (scope.adjacent <= 0) {
	            scope.adjacent = 2;
	        }
	
	        // Hide from page if we have 1 or less pages
	        // if directed to hide empty
	        if (pageCount <= 1) {
	            scope.Hide = scope.hideIfEmpty;
	        }
	    }
	
	
	    /**
	     * Assign the method action to take when a page is clicked
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {int} page - The current page of interest
	     */
	    function internalAction(scope, page) {
	
	        // Block clicks we try to load the active page
	        if (scope.page == page) {
	            return;
	        }
	
	        // Block if we are forcing disabled 
	        if(scope.isDisabled)
	        {
	            return;
	        }
	
	        // Update the page in scope
	        scope.page = page;
	
	        // Pass our parameters to the paging action
	        scope.pagingAction({
	            page: scope.page,
	            pageSize: scope.pageSize,
	            total: scope.total
	        });
	
	        // If allowed scroll up to the top of the page
	        if (scope.scrollTop) {
	            scrollTo(0, 0);
	        }
	    }
	
	
	    /**
	     * Add the first, previous, next, and last buttons if desired
	     * The logic is defined by the mode of interest
	     * This method will simply return if the scope.showPrevNext is false
	     * This method will simply return if there are no pages to display
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {int} pageCount - The last page number or total page count
	     * @param {string} mode - The mode of interest either prev or last
	     */
	    function addPrevNext(scope, pageCount, mode) {
	
	        // Ignore if we are not showing
	        // or there are no pages to display
	        if ((!scope.showPrevNext && !scope.showFirstLast) || pageCount < 1) {
	            return;
	        }
	
	        // Local variables to help determine logic
	        var disabled, alpha, beta;
	
	        // Determine logic based on the mode of interest
	        // Calculate the previous / next page and if the click actions are allowed
	        if (mode === 'prev') {
	
	            disabled = scope.page - 1 <= 0;
	            var prevPage = scope.page - 1 <= 0 ? 1 : scope.page - 1;
	
	            if(scope.showFirstLast){
	                alpha = {
	                    value: scope.textFirst,
	                    title: scope.textTitleFirst, 
	                    aClass: scope.textFirstClass,
	                    page: 1
	                };                
	            }
	
	            if(scope.showPrevNext){
	                beta = {
	                    value: scope.textPrev,
	                    title: scope.textTitlePrev, 
	                    aClass: scope.textPrevClass,
	                    page: prevPage
	                };    
	            }
	
	        } else {
	
	            disabled = scope.page + 1 > pageCount;
	            var nextPage = scope.page + 1 >= pageCount ? pageCount : scope.page + 1;
	
	            if(scope.showPrevNext){
	                alpha = {
	                    value: scope.textNext,
	                    title: scope.textTitleNext, 
	                    aClass: scope.textNextClass,
	                    page: nextPage
	                };    
	            }
	            
	            if(scope.showFirstLast){
	                beta = {
	                    value: scope.textLast,
	                    title: scope.textTitleLast, 
	                    aClass: scope.textLastClass,
	                    page: pageCount
	                };    
	            }
	            
	        }
	
	        // Create the Add Item Function
	        var buildItem = function (item, disabled) {
	            return {
	                title: item.title,
	                aClass: item.aClass,
	                value: item.aClass ? '' : item.value,
	                liClass: disabled ? scope.disabledClass : '',
	                pgHref: disabled ? '' : scope.pgHref.replace(regex, item.page),
	                action: function () {
	                    if (!disabled) {
	                        internalAction(scope, item.page);
	                    }
	                }
	            };    
	        };
	
	        // Force disabled if specified
	        if(scope.isDisabled){
	            disabled = true;
	        }
	
	        // Add alpha items
	        if(alpha){
	            var alphaItem = buildItem(alpha, disabled);
	            scope.List.push(alphaItem);    
	        }
	        
	        // Add beta items
	        if(beta){
	            var betaItem = buildItem(beta, disabled);
	            scope.List.push(betaItem);    
	        }
	    }
	
	
	    /**
	     * Adds a range of numbers to our list
	     * The range is dependent on the start and finish parameters
	     *
	     * @param {int} start - The start of the range to add to the paging list
	     * @param {int} finish - The end of the range to add to the paging list
	     * @param {Object} scope - The local directive scope object
	     */
	    function addRange(start, finish, scope) {
	    
	        // Add our items where i is the page number
	        var i = 0;
	        for (i = start; i <= finish; i++) {
	
	            var pgHref = scope.pgHref.replace(regex, i);
	            var liClass = scope.page == i ? scope.activeClass : ''; 
	
	            // Handle items that are affected by disabled
	            if(scope.isDisabled){
	                pgHref = '';
	                liClass = scope.disabledClass;
	            }
	
	
	            scope.List.push({
	                value: i,
	                title: scope.textTitlePage.replace(regex, i),
	                liClass: liClass,
	                pgHref: pgHref,
	                action: function () {
	                    internalAction(scope, this.value);
	                }
	            });
	        }
	    }
	
	
	    /**
	     * Add Dots ie: 1 2 [...] 10 11 12 [...] 56 57
	     * This is my favorite function not going to lie
	     *
	     * @param {Object} scope - The local directive scope object
	     */
	    function addDots(scope) {
	        scope.List.push({
	            value: scope.dots,
	            liClass: scope.disabledClass
	        });
	    }
	
	
	    /**
	     * Add the first or beginning items in our paging list
	     * We leverage the 'next' parameter to determine if the dots are required
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {int} next - the next page number in the paging sequence
	     */
	    function addFirst(scope, next) {
	
	        addRange(1, 2, scope);
	
	        // We ignore dots if the next value is 3
	        // ie: 1 2 [...] 3 4 5 becomes just 1 2 3 4 5
	        if (next != 3) {
	            addDots(scope);
	        }
	    }
	
	
	    /**
	     * Add the last or end items in our paging list
	     * We leverage the 'prev' parameter to determine if the dots are required
	     *
	     * @param {int} pageCount - The last page number or total page count
	     * @param {Object} scope - The local directive scope object
	     * @param {int} prev - the previous page number in the paging sequence
	     */
	    // Add Last Pages
	    function addLast(pageCount, scope, prev) {
	
	        // We ignore dots if the previous value is one less that our start range
	        // ie: 1 2 3 4 [...] 5 6  becomes just 1 2 3 4 5 6
	        if (prev != pageCount - 2) {
	            addDots(scope);
	        }
	
	        addRange(pageCount - 1, pageCount, scope);
	    }
	
	
	
	    /**
	     * The main build function used to determine the paging logic
	     * Feel free to tweak / fork values for your application
	     *
	     * @param {Object} scope - The local directive scope object
	     * @param {Object} attrs - The local directive attribute object
	     */
	    function build(scope, attrs) {
	
	        // Block divide by 0 and empty page size
	        if (!scope.pageSize || scope.pageSize <= 0) {
	            scope.pageSize = 1;
	        }
	
	        // Determine the last page or total page count
	        var pageCount = Math.ceil(scope.total / scope.pageSize);
	
	        // Set the default scope values where needed
	        setScopeValues(scope, attrs);
	
	        // Validate the scope values to protect against strange states
	        validateScopeValues(scope, pageCount);
	
	        // Create the beginning and end page values
	        var start, finish;
	
	        // Calculate the full adjacency value
	        var fullAdjacentSize = (scope.adjacent * 2) + 2;
	
	
	        // Add the Next and Previous buttons to our list
	        addPrevNext(scope, pageCount, 'prev');
	
	        // If the page count is less than the full adjacnet size
	        // Then we simply display all the pages, Otherwise we calculate the proper paging display
	        if (pageCount <= (fullAdjacentSize + 2)) {
	
	            start = 1;
	            addRange(start, pageCount, scope);
	
	        } else {
	
	            // Determine if we are showing the beginning of the paging list
	            // We know it is the beginning if the page - adjacent is <= 2
	            if (scope.page - scope.adjacent <= 2) {
	
	                start = 1;
	                finish = 1 + fullAdjacentSize;
	
	                addRange(start, finish, scope);
	                addLast(pageCount, scope, finish);
	            }
	
	            // Determine if we are showing the middle of the paging list
	            // We know we are either in the middle or at the end since the beginning is ruled out above
	            // So we simply check if we are not at the end
	            // Again 2 is hard coded as we always display two pages after the dots
	            else if (scope.page < pageCount - (scope.adjacent + 2)) {
	
	                start = scope.page - scope.adjacent;
	                finish = scope.page + scope.adjacent;
	
	                addFirst(scope, start);
	                addRange(start, finish, scope);
	                addLast(pageCount, scope, finish);
	            }
	
	            // If nothing else we conclude we are at the end of the paging list
	            // We know this since we have already ruled out the beginning and middle above
	            else {
	
	                start = pageCount - fullAdjacentSize;
	                finish = pageCount;
	
	                addFirst(scope, start);
	                addRange(start, finish, scope);
	            }
	        }
	
	        // Add the next and last buttons to our paging list
	        addPrevNext(scope, pageCount, 'next');
	    }
	
	});


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	/*! ngclipboard - v1.1.1 - 2016-02-26
	* https://github.com/sachinchoolur/ngclipboard
	* Copyright (c) 2016 Sachin; Licensed MIT */
	(function() {
	    'use strict';
	    var MODULE_NAME = 'ngclipboard';
	    var angular, Clipboard;
	    
	    // Check for CommonJS support
	    if (typeof module === 'object' && module.exports) {
	      angular = __webpack_require__(369);
	      Clipboard = __webpack_require__(1568);
	      module.exports = MODULE_NAME;
	    } else {
	      angular = window.angular;
	      Clipboard = window.Clipboard;
	    }
	
	    angular.module(MODULE_NAME, []).directive('ngclipboard', function() {
	        return {
	            restrict: 'A',
	            scope: {
	                ngclipboardSuccess: '&',
	                ngclipboardError: '&'
	            },
	            link: function(scope, element) {
	                var clipboard = new Clipboard(element[0]);
	
	                clipboard.on('success', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardSuccess({
	                      e: e
	                    });
	                  });
	                });
	
	                clipboard.on('error', function(e) {
	                  scope.$apply(function () {
	                    scope.ngclipboardError({
	                      e: e
	                    });
	                  });
	                });
	
	            }
	        };
	    });
	}());


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1569), __webpack_require__(1571), __webpack_require__(1572)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
	        global.clipboard = mod.exports;
	    }
	})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
	    'use strict';
	
	    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);
	
	    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);
	
	    var _goodListener2 = _interopRequireDefault(_goodListener);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    function _possibleConstructorReturn(self, call) {
	        if (!self) {
	            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	        }
	
	        return call && (typeof call === "object" || typeof call === "function") ? call : self;
	    }
	
	    function _inherits(subClass, superClass) {
	        if (typeof superClass !== "function" && superClass !== null) {
	            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	        }
	
	        subClass.prototype = Object.create(superClass && superClass.prototype, {
	            constructor: {
	                value: subClass,
	                enumerable: false,
	                writable: true,
	                configurable: true
	            }
	        });
	        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	    }
	
	    var Clipboard = function (_Emitter) {
	        _inherits(Clipboard, _Emitter);
	
	        /**
	         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
	         * @param {Object} options
	         */
	        function Clipboard(trigger, options) {
	            _classCallCheck(this, Clipboard);
	
	            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));
	
	            _this.resolveOptions(options);
	            _this.listenClick(trigger);
	            return _this;
	        }
	
	        /**
	         * Defines if attributes would be resolved using internal setter functions
	         * or custom functions that were passed in the constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(Clipboard, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
	                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
	                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
	            }
	        }, {
	            key: 'listenClick',
	            value: function listenClick(trigger) {
	                var _this2 = this;
	
	                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
	                    return _this2.onClick(e);
	                });
	            }
	        }, {
	            key: 'onClick',
	            value: function onClick(e) {
	                var trigger = e.delegateTarget || e.currentTarget;
	
	                if (this.clipboardAction) {
	                    this.clipboardAction = null;
	                }
	
	                this.clipboardAction = new _clipboardAction2.default({
	                    action: this.action(trigger),
	                    target: this.target(trigger),
	                    text: this.text(trigger),
	                    trigger: trigger,
	                    emitter: this
	                });
	            }
	        }, {
	            key: 'defaultAction',
	            value: function defaultAction(trigger) {
	                return getAttributeValue('action', trigger);
	            }
	        }, {
	            key: 'defaultTarget',
	            value: function defaultTarget(trigger) {
	                var selector = getAttributeValue('target', trigger);
	
	                if (selector) {
	                    return document.querySelector(selector);
	                }
	            }
	        }, {
	            key: 'defaultText',
	            value: function defaultText(trigger) {
	                return getAttributeValue('text', trigger);
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.listener.destroy();
	
	                if (this.clipboardAction) {
	                    this.clipboardAction.destroy();
	                    this.clipboardAction = null;
	                }
	            }
	        }]);
	
	        return Clipboard;
	    }(_tinyEmitter2.default);
	
	    /**
	     * Helper function to retrieve attribute value.
	     * @param {String} suffix
	     * @param {Element} element
	     */
	    function getAttributeValue(suffix, element) {
	        var attribute = 'data-clipboard-' + suffix;
	
	        if (!element.hasAttribute(attribute)) {
	            return;
	        }
	
	        return element.getAttribute(attribute);
	    }
	
	    module.exports = Clipboard;
	});

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1570)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== "undefined") {
	        factory(module, require('select'));
	    } else {
	        var mod = {
	            exports: {}
	        };
	        factory(mod, global.select);
	        global.clipboardAction = mod.exports;
	    }
	})(this, function (module, _select) {
	    'use strict';
	
	    var _select2 = _interopRequireDefault(_select);
	
	    function _interopRequireDefault(obj) {
	        return obj && obj.__esModule ? obj : {
	            default: obj
	        };
	    }
	
	    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	        return typeof obj;
	    } : function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    function _classCallCheck(instance, Constructor) {
	        if (!(instance instanceof Constructor)) {
	            throw new TypeError("Cannot call a class as a function");
	        }
	    }
	
	    var _createClass = function () {
	        function defineProperties(target, props) {
	            for (var i = 0; i < props.length; i++) {
	                var descriptor = props[i];
	                descriptor.enumerable = descriptor.enumerable || false;
	                descriptor.configurable = true;
	                if ("value" in descriptor) descriptor.writable = true;
	                Object.defineProperty(target, descriptor.key, descriptor);
	            }
	        }
	
	        return function (Constructor, protoProps, staticProps) {
	            if (protoProps) defineProperties(Constructor.prototype, protoProps);
	            if (staticProps) defineProperties(Constructor, staticProps);
	            return Constructor;
	        };
	    }();
	
	    var ClipboardAction = function () {
	        /**
	         * @param {Object} options
	         */
	        function ClipboardAction(options) {
	            _classCallCheck(this, ClipboardAction);
	
	            this.resolveOptions(options);
	            this.initSelection();
	        }
	
	        /**
	         * Defines base properties passed from constructor.
	         * @param {Object} options
	         */
	
	
	        _createClass(ClipboardAction, [{
	            key: 'resolveOptions',
	            value: function resolveOptions() {
	                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	                this.action = options.action;
	                this.emitter = options.emitter;
	                this.target = options.target;
	                this.text = options.text;
	                this.trigger = options.trigger;
	
	                this.selectedText = '';
	            }
	        }, {
	            key: 'initSelection',
	            value: function initSelection() {
	                if (this.text) {
	                    this.selectFake();
	                } else if (this.target) {
	                    this.selectTarget();
	                }
	            }
	        }, {
	            key: 'selectFake',
	            value: function selectFake() {
	                var _this = this;
	
	                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';
	
	                this.removeFake();
	
	                this.fakeHandlerCallback = function () {
	                    return _this.removeFake();
	                };
	                this.fakeHandler = document.body.addEventListener('click', this.fakeHandlerCallback) || true;
	
	                this.fakeElem = document.createElement('textarea');
	                // Prevent zooming on iOS
	                this.fakeElem.style.fontSize = '12pt';
	                // Reset box model
	                this.fakeElem.style.border = '0';
	                this.fakeElem.style.padding = '0';
	                this.fakeElem.style.margin = '0';
	                // Move element out of screen horizontally
	                this.fakeElem.style.position = 'absolute';
	                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
	                // Move element to the same position vertically
	                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
	                this.fakeElem.addEventListener('focus', window.scrollTo(0, yPosition));
	                this.fakeElem.style.top = yPosition + 'px';
	
	                this.fakeElem.setAttribute('readonly', '');
	                this.fakeElem.value = this.text;
	
	                document.body.appendChild(this.fakeElem);
	
	                this.selectedText = (0, _select2.default)(this.fakeElem);
	                this.copyText();
	            }
	        }, {
	            key: 'removeFake',
	            value: function removeFake() {
	                if (this.fakeHandler) {
	                    document.body.removeEventListener('click', this.fakeHandlerCallback);
	                    this.fakeHandler = null;
	                    this.fakeHandlerCallback = null;
	                }
	
	                if (this.fakeElem) {
	                    document.body.removeChild(this.fakeElem);
	                    this.fakeElem = null;
	                }
	            }
	        }, {
	            key: 'selectTarget',
	            value: function selectTarget() {
	                this.selectedText = (0, _select2.default)(this.target);
	                this.copyText();
	            }
	        }, {
	            key: 'copyText',
	            value: function copyText() {
	                var succeeded = void 0;
	
	                try {
	                    succeeded = document.execCommand(this.action);
	                } catch (err) {
	                    succeeded = false;
	                }
	
	                this.handleResult(succeeded);
	            }
	        }, {
	            key: 'handleResult',
	            value: function handleResult(succeeded) {
	                this.emitter.emit(succeeded ? 'success' : 'error', {
	                    action: this.action,
	                    text: this.selectedText,
	                    trigger: this.trigger,
	                    clearSelection: this.clearSelection.bind(this)
	                });
	            }
	        }, {
	            key: 'clearSelection',
	            value: function clearSelection() {
	                if (this.target) {
	                    this.target.blur();
	                }
	
	                window.getSelection().removeAllRanges();
	            }
	        }, {
	            key: 'destroy',
	            value: function destroy() {
	                this.removeFake();
	            }
	        }, {
	            key: 'action',
	            set: function set() {
	                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
	
	                this._action = action;
	
	                if (this._action !== 'copy' && this._action !== 'cut') {
	                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
	                }
	            },
	            get: function get() {
	                return this._action;
	            }
	        }, {
	            key: 'target',
	            set: function set(target) {
	                if (target !== undefined) {
	                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
	                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
	                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
	                        }
	
	                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
	                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
	                        }
	
	                        this._target = target;
	                    } else {
	                        throw new Error('Invalid "target" value, use a valid Element');
	                    }
	                }
	            },
	            get: function get() {
	                return this._target;
	            }
	        }]);
	
	        return ClipboardAction;
	    }();
	
	    module.exports = ClipboardAction;
	});

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

	function select(element) {
	    var selectedText;
	
	    if (element.nodeName === 'SELECT') {
	        element.focus();
	
	        selectedText = element.value;
	    }
	    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
	        var isReadOnly = element.hasAttribute('readonly');
	
	        if (!isReadOnly) {
	            element.setAttribute('readonly', '');
	        }
	
	        element.select();
	        element.setSelectionRange(0, element.value.length);
	
	        if (!isReadOnly) {
	            element.removeAttribute('readonly');
	        }
	
	        selectedText = element.value;
	    }
	    else {
	        if (element.hasAttribute('contenteditable')) {
	            element.focus();
	        }
	
	        var selection = window.getSelection();
	        var range = document.createRange();
	
	        range.selectNodeContents(element);
	        selection.removeAllRanges();
	        selection.addRange(range);
	
	        selectedText = selection.toString();
	    }
	
	    return selectedText;
	}
	
	module.exports = select;


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

	function E () {
	  // Keep this empty so it's easier to inherit from
	  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
	}
	
	E.prototype = {
	  on: function (name, callback, ctx) {
	    var e = this.e || (this.e = {});
	
	    (e[name] || (e[name] = [])).push({
	      fn: callback,
	      ctx: ctx
	    });
	
	    return this;
	  },
	
	  once: function (name, callback, ctx) {
	    var self = this;
	    function listener () {
	      self.off(name, listener);
	      callback.apply(ctx, arguments);
	    };
	
	    listener._ = callback
	    return this.on(name, listener, ctx);
	  },
	
	  emit: function (name) {
	    var data = [].slice.call(arguments, 1);
	    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
	    var i = 0;
	    var len = evtArr.length;
	
	    for (i; i < len; i++) {
	      evtArr[i].fn.apply(evtArr[i].ctx, data);
	    }
	
	    return this;
	  },
	
	  off: function (name, callback) {
	    var e = this.e || (this.e = {});
	    var evts = e[name];
	    var liveEvents = [];
	
	    if (evts && callback) {
	      for (var i = 0, len = evts.length; i < len; i++) {
	        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
	          liveEvents.push(evts[i]);
	      }
	    }
	
	    // Remove event from queue to prevent memory leak
	    // Suggested by https://github.com/lazd
	    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
	
	    (liveEvents.length)
	      ? e[name] = liveEvents
	      : delete e[name];
	
	    return this;
	  }
	};
	
	module.exports = E;


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	var is = __webpack_require__(1573);
	var delegate = __webpack_require__(1574);
	
	/**
	 * Validates all params and calls the right
	 * listener function based on its target type.
	 *
	 * @param {String|HTMLElement|HTMLCollection|NodeList} target
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listen(target, type, callback) {
	    if (!target && !type && !callback) {
	        throw new Error('Missing required arguments');
	    }
	
	    if (!is.string(type)) {
	        throw new TypeError('Second argument must be a String');
	    }
	
	    if (!is.fn(callback)) {
	        throw new TypeError('Third argument must be a Function');
	    }
	
	    if (is.node(target)) {
	        return listenNode(target, type, callback);
	    }
	    else if (is.nodeList(target)) {
	        return listenNodeList(target, type, callback);
	    }
	    else if (is.string(target)) {
	        return listenSelector(target, type, callback);
	    }
	    else {
	        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
	    }
	}
	
	/**
	 * Adds an event listener to a HTML element
	 * and returns a remove listener function.
	 *
	 * @param {HTMLElement} node
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNode(node, type, callback) {
	    node.addEventListener(type, callback);
	
	    return {
	        destroy: function() {
	            node.removeEventListener(type, callback);
	        }
	    }
	}
	
	/**
	 * Add an event listener to a list of HTML elements
	 * and returns a remove listener function.
	 *
	 * @param {NodeList|HTMLCollection} nodeList
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenNodeList(nodeList, type, callback) {
	    Array.prototype.forEach.call(nodeList, function(node) {
	        node.addEventListener(type, callback);
	    });
	
	    return {
	        destroy: function() {
	            Array.prototype.forEach.call(nodeList, function(node) {
	                node.removeEventListener(type, callback);
	            });
	        }
	    }
	}
	
	/**
	 * Add an event listener to a selector
	 * and returns a remove listener function.
	 *
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Object}
	 */
	function listenSelector(selector, type, callback) {
	    return delegate(document.body, selector, type, callback);
	}
	
	module.exports = listen;


/***/ }),
/* 1573 */
/***/ (function(module, exports) {

	/**
	 * Check if argument is a HTML element.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.node = function(value) {
	    return value !== undefined
	        && value instanceof HTMLElement
	        && value.nodeType === 1;
	};
	
	/**
	 * Check if argument is a list of HTML elements.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.nodeList = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return value !== undefined
	        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
	        && ('length' in value)
	        && (value.length === 0 || exports.node(value[0]));
	};
	
	/**
	 * Check if argument is a string.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.string = function(value) {
	    return typeof value === 'string'
	        || value instanceof String;
	};
	
	/**
	 * Check if argument is a function.
	 *
	 * @param {Object} value
	 * @return {Boolean}
	 */
	exports.fn = function(value) {
	    var type = Object.prototype.toString.call(value);
	
	    return type === '[object Function]';
	};


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	var closest = __webpack_require__(1575);
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function _delegate(element, selector, type, callback, useCapture) {
	    var listenerFn = listener.apply(this, arguments);
	
	    element.addEventListener(type, listenerFn, useCapture);
	
	    return {
	        destroy: function() {
	            element.removeEventListener(type, listenerFn, useCapture);
	        }
	    }
	}
	
	/**
	 * Delegates event to a selector.
	 *
	 * @param {Element|String|Array} [elements]
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @param {Boolean} useCapture
	 * @return {Object}
	 */
	function delegate(elements, selector, type, callback, useCapture) {
	    // Handle the regular Element usage
	    if (typeof elements.addEventListener === 'function') {
	        return _delegate.apply(null, arguments);
	    }
	
	    // Handle Element-less usage, it defaults to global delegation
	    if (typeof type === 'function') {
	        // Use `document` as the first parameter, then apply arguments
	        // This is a short way to .unshift `arguments` without running into deoptimizations
	        return _delegate.bind(null, document).apply(null, arguments);
	    }
	
	    // Handle Selector-based usage
	    if (typeof elements === 'string') {
	        elements = document.querySelectorAll(elements);
	    }
	
	    // Handle Array-like based usage
	    return Array.prototype.map.call(elements, function (element) {
	        return _delegate(element, selector, type, callback, useCapture);
	    });
	}
	
	/**
	 * Finds closest match and invokes callback.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @param {String} type
	 * @param {Function} callback
	 * @return {Function}
	 */
	function listener(element, selector, type, callback) {
	    return function(e) {
	        e.delegateTarget = closest(e.target, selector);
	
	        if (e.delegateTarget) {
	            callback.call(element, e);
	        }
	    }
	}
	
	module.exports = delegate;


/***/ }),
/* 1575 */
/***/ (function(module, exports) {

	var DOCUMENT_NODE_TYPE = 9;
	
	/**
	 * A polyfill for Element.matches()
	 */
	if (typeof Element !== 'undefined' && !Element.prototype.matches) {
	    var proto = Element.prototype;
	
	    proto.matches = proto.matchesSelector ||
	                    proto.mozMatchesSelector ||
	                    proto.msMatchesSelector ||
	                    proto.oMatchesSelector ||
	                    proto.webkitMatchesSelector;
	}
	
	/**
	 * Finds the closest parent that matches a selector.
	 *
	 * @param {Element} element
	 * @param {String} selector
	 * @return {Function}
	 */
	function closest (element, selector) {
	    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
	        if (typeof element.matches === 'function' &&
	            element.matches(selector)) {
	          return element;
	        }
	        element = element.parentNode;
	    }
	}
	
	module.exports = closest;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1577);
	module.exports = 'vAccordion';


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

	/**
	 * vAccordion - AngularJS multi-level accordion component
	 * @version v1.6.0
	 * @link http://lukaszwatroba.github.io/v-accordion
	 * @author Łukasz Wątroba <l@lukaszwatroba.com>
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	(function (angular) {
	'use strict';
	
	// Config
	angular.module('vAccordion.config', [])
	  .constant('accordionConfig', {
	    states: {
	      expanded: 'is-expanded'
	    },
	    expandAnimationDuration: 0.5
	  })
	  .animation('.is-expanded', [ '$animateCss', 'accordionConfig', function ($animateCss, accordionConfig) {
	    return {
	      addClass: function (element, className, done) {
	        var paneContent = angular.element(element[0].querySelector('v-pane-content')),
	            paneInner = angular.element(paneContent[0].querySelector('div'));
	
	        var height = paneInner[0].offsetHeight;
	
	        var expandAnimation = $animateCss(paneContent, {
	          easing: 'ease',
	          from: { maxHeight: '0px' },
	          to: { maxHeight: height + 'px' },
	          duration: accordionConfig.expandAnimationDuration
	        });
	
	        expandAnimation.start().done(function () {
	          paneContent.css('max-height', 'none');
	          done();
	        });
	
	        return function (isCancelled) {
	          if (isCancelled) {
	            paneContent.css('max-height', 'none');
	          }
	        };
	      },
	      removeClass: function (element, className, done) {
	        var paneContent = angular.element(element[0].querySelector('v-pane-content')),
	            paneInner = angular.element(paneContent[0].querySelector('div'));
	
	        var height = paneInner[0].offsetHeight;
	
	        var collapseAnimation = $animateCss(paneContent, {
	          easing: 'ease',
	          from: { maxHeight: height + 'px' },
	          to: { maxHeight: '0px' },
	          duration: accordionConfig.expandAnimationDuration
	        });
	
	        collapseAnimation.start().done(done);
	
	        return function (isCancelled) {
	          if (isCancelled) {
	            paneContent.css('max-height', '0px');
	          }
	        };
	      }
	    };
	  } ]);
	
	
	// Modules
	angular.module('vAccordion.directives', []);
	angular.module('vAccordion',
	  [
	    'vAccordion.config',
	    'vAccordion.directives'
	  ]);
	
	
	
	// vAccordion directive
	angular.module('vAccordion.directives')
	  .directive('vAccordion', vAccordionDirective);
	
	
	function vAccordionDirective ($timeout) {
	  return {
	    restrict: 'E',
	    transclude: true,
	    controller: vAccordionController,
	    scope: {
	      control: '=?',
	      expandCb: '&?onexpand',
	      collapseCb: '&?oncollapse',
	      id: '@?'
	    },
	    link: {
	      pre: function (scope, iElement, iAttrs) {
	        scope.allowMultiple = (angular.isDefined(iAttrs.multiple) && (iAttrs.multiple === '' || iAttrs.multiple === 'true'));
	      },
	      post: function (scope, iElement, iAttrs, ctrl, transclude) {
	        transclude(scope.$parent.$new(), function (clone, transclusionScope) {
	          transclusionScope.$accordion = scope.internalControl;
	          if (scope.id) { transclusionScope.$accordion.id = scope.id; }
	          iElement.append(clone);
	        });
	
	        iAttrs.$set('role', 'tablist');
	
	        if (scope.allowMultiple) {
	          iAttrs.$set('aria-multiselectable', 'true');
	        }
	
	        if (angular.isDefined(scope.control)) {
	          checkCustomControlAPIMethods();
	
	          var mergedControl = angular.extend({}, scope.internalControl, scope.control);
	          scope.control = scope.internalControl = mergedControl;
	        }
	        else {
	          scope.control = scope.internalControl;
	        }
	
	        function checkCustomControlAPIMethods () {
	          var protectedApiMethods = ['toggle', 'expand', 'collapse', 'expandAll', 'collapseAll', 'hasExpandedPane'];
	
	          angular.forEach(protectedApiMethods, function (iteratedMethodName) {
	            if (scope.control[iteratedMethodName]) {
	              throw new Error('The `' + iteratedMethodName + '` method can not be overwritten');
	            }
	          });
	        }
	
	        $timeout(function () {
	          var eventName = (angular.isDefined(ctrl.getAccordionId())) ? ctrl.getAccordionId() + ':onReady' : 'vAccordion:onReady';
	          scope.$emit(eventName);
	        }, 0);
	      }
	    }
	  };
	}
	vAccordionDirective.$inject = ['$timeout'];
	
	
	// vAccordion directive controller
	function vAccordionController ($scope) {
	  var ctrl = this;
	  var isDisabled = false;
	
	  $scope.panes = [];
	
		$scope.expandCb = (angular.isFunction($scope.expandCb)) ? $scope.expandCb : angular.noop;
		$scope.collapseCb = (angular.isFunction($scope.collapseCb)) ? $scope.collapseCb : angular.noop;
	
	  ctrl.hasExpandedPane = function hasExpandedPane () {
	    var bool = false;
	
	    for (var i = 0, length = $scope.panes.length; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isExpanded) {
	        bool = true;
	        break;
	      }
	    }
	
	    return bool;
	  };
	
	  ctrl.getPaneByIndex = function getPaneByIndex (index) {
	    var thePane;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.$parent && angular.isDefined(iteratedPane.$parent.$index) && iteratedPane.$parent.$index === index) {
	        thePane = iteratedPane;
	      }
	    });
	
	    return (thePane) ? thePane : $scope.panes[index];
	  };
	
	  ctrl.getPaneIndex = function getPaneIndex (pane) {
	    var theIndex;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.$parent && angular.isDefined(iteratedPane.$parent.$index) && iteratedPane === pane) {
	        theIndex = iteratedPane.$parent.$index;
	      }
	    });
	
	    return (angular.isDefined(theIndex)) ? theIndex : $scope.panes.indexOf(pane);
	  };
	
	  ctrl.getPaneById = function getPaneById (id) {
	    var thePane;
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane.id && iteratedPane.id === id) {
	        thePane = iteratedPane;
	      }
	    });
	
	    return thePane;
	  };
	
	  ctrl.getPaneId = function getPaneId (pane) {
	    return pane.id;
	  };
	
	  ctrl.getAccordionId = function getAccordionId () {
	    return $scope.id;
	  };
	
	
	  ctrl.disable = function disable () {
	    isDisabled = true;
	  };
	
	  ctrl.enable = function enable () {
	    isDisabled = false;
	  };
	
	  ctrl.addPane = function addPane (paneToAdd) {
	    if (!$scope.allowMultiple) {
	      if (ctrl.hasExpandedPane() && paneToAdd.isExpanded) {
	        throw new Error('The `multiple` attribute can\'t be found');
	      }
	    }
	
	    $scope.panes.push(paneToAdd);
	
	    if (paneToAdd.isExpanded) {
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToAdd), id: paneToAdd.id, pane: paneToAdd });
	    }
	  };
	
	  ctrl.focusNext = function focusNext () {
	    var length = $scope.panes.length;
	
	    for (var i = 0; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isFocused) {
	        var paneToFocusIndex = i + 1;
	
	        if (paneToFocusIndex > $scope.panes.length - 1) {
	          paneToFocusIndex = 0;
	        }
	
	        var paneToFocus = $scope.panes[paneToFocusIndex];
	            paneToFocus.paneElement.find('v-pane-header')[0].focus();
	
	        break;
	      }
	    }
	  };
	
	  ctrl.focusPrevious = function focusPrevious () {
	    var length = $scope.panes.length;
	
	    for (var i = 0; i < length; i++) {
	      var iteratedPane = $scope.panes[i];
	
	      if (iteratedPane.isFocused) {
	        var paneToFocusIndex = i - 1;
	
	        if (paneToFocusIndex < 0) {
	          paneToFocusIndex = $scope.panes.length - 1;
	        }
	
	        var paneToFocus = $scope.panes[paneToFocusIndex];
	            paneToFocus.paneElement.find('v-pane-header')[0].focus();
	
	        break;
	      }
	    }
	  };
	
	  ctrl.toggle = function toggle (paneToToggle) {
	    if (isDisabled || !paneToToggle) { return; }
	
	    if (!$scope.allowMultiple) {
	      ctrl.collapseAll(paneToToggle);
	    }
	
	    paneToToggle.isExpanded = !paneToToggle.isExpanded;
	
	    if (paneToToggle.isExpanded) {
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToToggle), id: paneToToggle.id, pane: paneToToggle });
	    } else {
	      $scope.collapseCb({ index: ctrl.getPaneIndex(paneToToggle), id: paneToToggle.id, pane: paneToToggle });
	    }
	  };
	
	  ctrl.expand = function expand (paneToExpand) {
	    if (isDisabled || !paneToExpand) { return; }
	
	    if (!$scope.allowMultiple) {
	      ctrl.collapseAll(paneToExpand);
	    }
	
	    if (!paneToExpand.isExpanded) {
	      paneToExpand.isExpanded = true;
	      $scope.expandCb({ index: ctrl.getPaneIndex(paneToExpand), id: paneToExpand.id, pane: paneToExpand });
	    }
	  };
	
	  ctrl.collapse = function collapse (paneToCollapse) {
	    if (isDisabled || !paneToCollapse) { return; }
	
	    if (paneToCollapse.isExpanded) {
	      paneToCollapse.isExpanded = false;
	      $scope.collapseCb({ index: ctrl.getPaneIndex(paneToCollapse), id: paneToCollapse.id, pane: paneToCollapse });
	    }
	  };
	
	  ctrl.expandAll = function expandAll () {
	    if (isDisabled) { return; }
	
	    if ($scope.allowMultiple) {
	      angular.forEach($scope.panes, function (iteratedPane) {
	        ctrl.expand(iteratedPane);
	      });
	    } else {
	      throw new Error('The `multiple` attribute can\'t be found');
	    }
	  };
	
	  ctrl.collapseAll = function collapseAll (exceptionalPane) {
	    if (isDisabled) { return; }
	
	    angular.forEach($scope.panes, function (iteratedPane) {
	      if (iteratedPane !== exceptionalPane) {
	        ctrl.collapse(iteratedPane);
	      }
	    });
	  };
	
	  // API
	  $scope.internalControl = {
	    toggle: function toggle (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.toggle( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.toggle( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    expand: function expand (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.expand( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.expand( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    collapse: function collapse (indexOrId) {
	      if (angular.isString(indexOrId)) {
	        ctrl.collapse( ctrl.getPaneById(indexOrId) );
	      } else {
	        ctrl.collapse( ctrl.getPaneByIndex(indexOrId) );
	      }
	    },
	    expandAll: ctrl.expandAll,
	    collapseAll: ctrl.collapseAll,
	    hasExpandedPane: ctrl.hasExpandedPane
	  };
	}
	vAccordionController.$inject = ['$scope'];
	
	
	
	// vPane directive
	angular.module('vAccordion.directives')
	  .directive('vPane', vPaneDirective);
	
	
	function vPaneDirective ($timeout, $animate, accordionConfig) {
	  return {
	    restrict: 'E',
	    require: '^vAccordion',
	    transclude: true,
	    controller: vPaneController,
	    scope: {
	      isExpanded: '=?expanded',
	      isDisabled: '=?ngDisabled',
	      id: '@?'
	    },
	    link: function (scope, iElement, iAttrs, accordionCtrl, transclude) {
	      transclude(scope.$parent.$new(), function (clone, transclusionScope) {
	        transclusionScope.$pane = scope.internalControl;
	        if (scope.id) { transclusionScope.$pane.id = scope.id; }
	        iElement.append(clone);
	      });
	
	      if (!angular.isDefined(scope.isExpanded)) {
	        scope.isExpanded = (angular.isDefined(iAttrs.expanded) && (iAttrs.expanded === ''));
	      }
	
	      if (angular.isDefined(iAttrs.disabled)) {
	        scope.isDisabled = true;
	      }
	
	      var states = accordionConfig.states;
	
	      var paneHeader = iElement.find('v-pane-header'),
	          paneContent = iElement.find('v-pane-content'),
	          paneInner = paneContent.find('div');
	
	      var accordionId = accordionCtrl.getAccordionId();
	
	      if (!paneHeader[0]) {
	        throw new Error('The `v-pane-header` directive can\'t be found');
	      }
	
	      if (!paneContent[0]) {
	        throw new Error('The `v-pane-content` directive can\'t be found');
	      }
	
	      scope.paneElement = iElement;
	      scope.paneContentElement = paneContent;
	      scope.paneInnerElement = paneInner;
	
	      scope.accordionCtrl = accordionCtrl;
	
	      accordionCtrl.addPane(scope);
	
	      function emitEvent (eventName) {
	        eventName = (angular.isDefined(accordionId)) ? accordionId + ':' + eventName : 'vAccordion:' + eventName;
	        scope.$emit(eventName);
	      }
	
	      function expand () {
	        accordionCtrl.disable();
	
	        paneContent.attr('aria-hidden', 'false');
	
	        paneHeader.attr({
	          'aria-selected': 'true',
	          'aria-expanded': 'true'
	        });
	
	        emitEvent('onExpand');
	
	        $animate
	          .addClass(iElement, states.expanded)
	          .then(function () {
	            accordionCtrl.enable();
	            emitEvent('onExpandAnimationEnd');
	          });
	      }
	
	      function collapse () {
	        accordionCtrl.disable();
	
	        paneContent.attr('aria-hidden', 'true');
	
	        paneHeader.attr({
	          'aria-selected': 'false',
	          'aria-expanded': 'false'
	        });
	
	        emitEvent('onCollapse');
	
	        $animate
	          .removeClass(iElement, states.expanded)
	          .then(function () {
	            accordionCtrl.enable();
	            emitEvent('onCollapseAnimationEnd');
	          });
	      }
	
	      scope.$evalAsync(function () {
	        if (scope.isExpanded) {
	          iElement.addClass(states.expanded);
	          paneContent
	            .css('max-height', 'none')
	            .attr('aria-hidden', 'false');
	
	          paneHeader.attr({
	            'aria-selected': 'true',
	            'aria-expanded': 'true'
	          });
	        } else {
	          paneContent
	            .css('max-height', '0px')
	            .attr('aria-hidden', 'true');
	
	          paneHeader.attr({
	            'aria-selected': 'false',
	            'aria-expanded': 'false'
	          });
	        }
	      });
	
	      scope.$watch('isExpanded', function (newValue, oldValue) {
	        if (newValue === oldValue) { return true; }
	        if (newValue) { expand(); }
	        else { collapse(); }
	      });
	    }
	  };
	}
	vPaneDirective.$inject = ['$timeout', '$animate', 'accordionConfig'];
	
	
	// vPane directive controller
	function vPaneController ($scope) {
	  var ctrl = this;
	
	  ctrl.isExpanded = function isExpanded () {
	    return $scope.isExpanded;
	  };
	
	  ctrl.toggle = function toggle () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.toggle($scope);
	    }
	  };
	
	  ctrl.expand = function expand () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.expand($scope);
	    }
	  };
	
	  ctrl.collapse = function collapse () {
	    if (!$scope.isAnimating && !$scope.isDisabled) {
	      $scope.accordionCtrl.collapse($scope);
	    }
	  };
	
	  ctrl.focusPane = function focusPane () {
	    $scope.isFocused = true;
	  };
	
	  ctrl.blurPane = function blurPane () {
	    $scope.isFocused = false;
	  };
	
	  $scope.internalControl = {
	    toggle: ctrl.toggle,
	    expand: ctrl.expand,
	    collapse: ctrl.collapse,
	    isExpanded: ctrl.isExpanded
	  };
	}
	vPaneController.$inject = ['$scope'];
	
	
	
	// vPaneContent directive
	angular.module('vAccordion.directives')
	  .directive('vPaneContent', vPaneContentDirective);
	
	
	function vPaneContentDirective () {
	  return {
	    restrict: 'E',
	    require: '^vPane',
	    transclude: true,
	    template: '<div ng-transclude></div>',
	    scope: {},
	    link: function (scope, iElement, iAttrs) {
	      iAttrs.$set('role', 'tabpanel');
	      iAttrs.$set('aria-hidden', 'true');
	    }
	  };
	}
	
	
	
	// vPaneHeader directive
	angular.module('vAccordion.directives')
	  .directive('vPaneHeader', vPaneHeaderDirective);
	
	
	function vPaneHeaderDirective () {
	  return {
	    restrict: 'E',
	    require: ['^vPane', '^vAccordion'],
	    transclude: true,
	    template: '<div ng-transclude></div>',
	    scope: {},
	    link: function (scope, iElement, iAttrs, ctrls) {
	      iAttrs.$set('role', 'tab');
	      iAttrs.$set('tabindex', '0');
	
	      var paneCtrl = ctrls[0],
	          accordionCtrl = ctrls[1];
	
	      var isInactive = angular.isDefined(iAttrs.inactive);
	
	      function onClick () {
	        if (isInactive) { return false; }
	        scope.$apply(function () { paneCtrl.toggle(); });
	      }
	
	      function onKeydown (event) {
	        if (event.keyCode === 32  || event.keyCode === 13) {
	          scope.$apply(function () { paneCtrl.toggle(); });
	          event.preventDefault();
	        } else if (event.keyCode === 39 || event.keyCode === 40) {
	          scope.$apply(function () { accordionCtrl.focusNext(); });
	          event.preventDefault();
	        } else if (event.keyCode === 37 || event.keyCode === 38) {
	          scope.$apply(function () { accordionCtrl.focusPrevious(); });
	          event.preventDefault();
	        }
	      }
	
	      function onFocus () {
	        paneCtrl.focusPane();
	      }
	
	      function onBlur () {
	        paneCtrl.blurPane();
	      }
	
	      iElement[0].onfocus = onFocus;
	      iElement[0].onblur = onBlur;
	      iElement.bind('click', onClick);
	      iElement.bind('keydown', onKeydown);
	
	      scope.$on('$destroy', function () {
	        iElement.unbind('click', onClick);
	        iElement.unbind('keydown', onKeydown);
	        iElement[0].onfocus = null;
	        iElement[0].onblur = null;
	      });
	    }
	  };
	}
	
	})(angular);

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1579);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!./v-accordion.min.css", function() {
				var newContent = require("!!../../css-loader/index.js!./v-accordion.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, "v-accordion,v-pane{display:block}v-pane.is-expanded>v-pane-content>div{display:visible}v-pane[disabled]>v-pane-header{opacity:.6;pointer-events:none}v-pane-header{display:block;position:relative;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}v-pane-header:focus{outline:0}v-pane-header>div{display:block}v-pane-content{display:block;position:relative;overflow:hidden;max-height:0}v-pane-content>div{visibility:none}.vAccordion--default v-accordion{margin-top:20px;padding-left:20px}.vAccordion--default v-pane-content>div{padding-bottom:20px;opacity:0;-webkit-transform:translate3d(0,30px,0);transform:translate3d(0,30px,0);-webkit-transition:all .5s;transition:all .5s}.vAccordion--default v-pane{overflow:hidden}.vAccordion--default v-pane.is-expanded>v-pane-header{border-bottom-color:#2196f3}.vAccordion--default v-pane.is-expanded>v-pane-header:after{-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}.vAccordion--default v-pane.is-expanded>v-pane-header:before{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.vAccordion--default v-pane.is-expanded>v-pane-content>div{opacity:1;-webkit-transform:translateZ(0);transform:translateZ(0)}.vAccordion--default v-pane[disabled] v-pane-header:after,.vAccordion--default v-pane[disabled] v-pane-header:before{display:none}.vAccordion--default v-pane-header{padding:5px 0;margin-bottom:20px;border-bottom:2px solid #d8d8d8;-webkit-transition:all .25s;transition:all .25s}.vAccordion--default v-pane-header:after,.vAccordion--default v-pane-header:before{content:\"\";display:block;position:absolute;top:50%;right:0;width:10px;height:1px;background-color:#2196f3;-webkit-transform-origin:50% 50%;transform-origin:50% 50%;will-change:transform;-webkit-transition:all .25s;transition:all .25s}.vAccordion--default v-pane-header:before{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.vAccordion--default v-pane-header:focus,.vAccordion--default v-pane-header:hover{color:#2196f3}", ""]);
	
	// exports


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
		/*
		*
		* A AngularJS module that implements the HTML5 W3C saveAs() in browsers that
		* do not natively support it
		*
		* (c) 2015 Philipp Alferov
		* License: MIT
		*
		*/
	
		module.exports = 'ngFileSaver';
	
		angular.module('ngFileSaver', [])
		  .factory('FileSaver', ['Blob', 'SaveAs', 'FileSaverUtils', __webpack_require__(1)])
		  .factory('FileSaverUtils', [__webpack_require__(2)])
		  .factory('Blob', ['$window', __webpack_require__(3)])
		  .factory('SaveAs', [__webpack_require__(5)]);
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function FileSaver(Blob, SaveAs, FileSaverUtils) {
	
		  function save(blob, filename, disableAutoBOM) {
		    try {
		      SaveAs(blob, filename, disableAutoBOM);
		    } catch(err) {
		      FileSaverUtils.handleErrors(err.message);
		    }
		  }
	
		  return {
	
		    /**
		    * saveAs
		    * Immediately starts saving a file, returns undefined.
		    *
		    * @name saveAs
		    * @function
		    * @param {Blob} data A Blob instance
		    * @param {Object} filename Custom filename (extension is optional)
		    * @param {Boolean} disableAutoBOM Disable automatically provided Unicode
		    * text encoding hints
		    *
		    * @return {Undefined}
		    */
	
		    saveAs: function(data, filename, disableAutoBOM) {
	
		      if (!FileSaverUtils.isBlobInstance(data)) {
		        FileSaverUtils.handleErrors('Data argument should be a blob instance');
		      }
	
		      if (!FileSaverUtils.isString(filename)) {
		        FileSaverUtils.handleErrors('Filename argument should be a string');
		      }
	
		      return save(data, filename, disableAutoBOM);
		    }
		  };
		};
	
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		module.exports = function FileSaverUtils() {
		  return {
		    handleErrors: function(msg) {
		      throw new Error(msg);
		    },
		    isString: function(obj) {
		      return typeof obj === 'string' || obj instanceof String;
		    },
		    isUndefined: function(obj) {
		      return typeof obj === 'undefined';
		    },
		    isBlobInstance: function(obj) {
		      return obj instanceof Blob;
		    }
		  };
		};
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		__webpack_require__(4);
	
		module.exports = function Blob($window) {
		  return $window.Blob;
		};
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		/* Blob.js
		 * A Blob implementation.
		 * 2014-07-24
		 *
		 * By Eli Grey, http://eligrey.com
		 * By Devin Samarin, https://github.com/dsamarin
		 * License: MIT
		 *   See https://github.com/eligrey/Blob.js/blob/master/LICENSE.md
		 */
	
		/*global self, unescape */
		/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
		  plusplus: true */
	
		/*! @source http://purl.eligrey.com/github/Blob.js/blob/master/Blob.js */
	
		(function (view) {
			"use strict";
	
			view.URL = view.URL || view.webkitURL;
	
			if (view.Blob && view.URL) {
				try {
					new Blob;
					return;
				} catch (e) {}
			}
	
			// Internally we use a BlobBuilder implementation to base Blob off of
			// in order to support older browsers that only have BlobBuilder
			var BlobBuilder = view.BlobBuilder || view.WebKitBlobBuilder || view.MozBlobBuilder || (function(view) {
				var
					  get_class = function(object) {
						return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
					}
					, FakeBlobBuilder = function BlobBuilder() {
						this.data = [];
					}
					, FakeBlob = function Blob(data, type, encoding) {
						this.data = data;
						this.size = data.length;
						this.type = type;
						this.encoding = encoding;
					}
					, FBB_proto = FakeBlobBuilder.prototype
					, FB_proto = FakeBlob.prototype
					, FileReaderSync = view.FileReaderSync
					, FileException = function(type) {
						this.code = this[this.name = type];
					}
					, file_ex_codes = (
						  "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR "
						+ "NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR"
					).split(" ")
					, file_ex_code = file_ex_codes.length
					, real_URL = view.URL || view.webkitURL || view
					, real_create_object_URL = real_URL.createObjectURL
					, real_revoke_object_URL = real_URL.revokeObjectURL
					, URL = real_URL
					, btoa = view.btoa
					, atob = view.atob
	
					, ArrayBuffer = view.ArrayBuffer
					, Uint8Array = view.Uint8Array
	
					, origin = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/
				;
				FakeBlob.fake = FB_proto.fake = true;
				while (file_ex_code--) {
					FileException.prototype[file_ex_codes[file_ex_code]] = file_ex_code + 1;
				}
				// Polyfill URL
				if (!real_URL.createObjectURL) {
					URL = view.URL = function(uri) {
						var
							  uri_info = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
							, uri_origin
						;
						uri_info.href = uri;
						if (!("origin" in uri_info)) {
							if (uri_info.protocol.toLowerCase() === "data:") {
								uri_info.origin = null;
							} else {
								uri_origin = uri.match(origin);
								uri_info.origin = uri_origin && uri_origin[1];
							}
						}
						return uri_info;
					};
				}
				URL.createObjectURL = function(blob) {
					var
						  type = blob.type
						, data_URI_header
					;
					if (type === null) {
						type = "application/octet-stream";
					}
					if (blob instanceof FakeBlob) {
						data_URI_header = "data:" + type;
						if (blob.encoding === "base64") {
							return data_URI_header + ";base64," + blob.data;
						} else if (blob.encoding === "URI") {
							return data_URI_header + "," + decodeURIComponent(blob.data);
						} if (btoa) {
							return data_URI_header + ";base64," + btoa(blob.data);
						} else {
							return data_URI_header + "," + encodeURIComponent(blob.data);
						}
					} else if (real_create_object_URL) {
						return real_create_object_URL.call(real_URL, blob);
					}
				};
				URL.revokeObjectURL = function(object_URL) {
					if (object_URL.substring(0, 5) !== "data:" && real_revoke_object_URL) {
						real_revoke_object_URL.call(real_URL, object_URL);
					}
				};
				FBB_proto.append = function(data/*, endings*/) {
					var bb = this.data;
					// decode data to a binary string
					if (Uint8Array && (data instanceof ArrayBuffer || data instanceof Uint8Array)) {
						var
							  str = ""
							, buf = new Uint8Array(data)
							, i = 0
							, buf_len = buf.length
						;
						for (; i < buf_len; i++) {
							str += String.fromCharCode(buf[i]);
						}
						bb.push(str);
					} else if (get_class(data) === "Blob" || get_class(data) === "File") {
						if (FileReaderSync) {
							var fr = new FileReaderSync;
							bb.push(fr.readAsBinaryString(data));
						} else {
							// async FileReader won't work as BlobBuilder is sync
							throw new FileException("NOT_READABLE_ERR");
						}
					} else if (data instanceof FakeBlob) {
						if (data.encoding === "base64" && atob) {
							bb.push(atob(data.data));
						} else if (data.encoding === "URI") {
							bb.push(decodeURIComponent(data.data));
						} else if (data.encoding === "raw") {
							bb.push(data.data);
						}
					} else {
						if (typeof data !== "string") {
							data += ""; // convert unsupported types to strings
						}
						// decode UTF-16 to binary string
						bb.push(unescape(encodeURIComponent(data)));
					}
				};
				FBB_proto.getBlob = function(type) {
					if (!arguments.length) {
						type = null;
					}
					return new FakeBlob(this.data.join(""), type, "raw");
				};
				FBB_proto.toString = function() {
					return "[object BlobBuilder]";
				};
				FB_proto.slice = function(start, end, type) {
					var args = arguments.length;
					if (args < 3) {
						type = null;
					}
					return new FakeBlob(
						  this.data.slice(start, args > 1 ? end : this.data.length)
						, type
						, this.encoding
					);
				};
				FB_proto.toString = function() {
					return "[object Blob]";
				};
				FB_proto.close = function() {
					this.size = 0;
					delete this.data;
				};
				return FakeBlobBuilder;
			}(view));
	
			view.Blob = function(blobParts, options) {
				var type = options ? (options.type || "") : "";
				var builder = new BlobBuilder();
				if (blobParts) {
					for (var i = 0, len = blobParts.length; i < len; i++) {
						if (Uint8Array && blobParts[i] instanceof Uint8Array) {
							builder.append(blobParts[i].buffer);
						}
						else {
							builder.append(blobParts[i]);
						}
					}
				}
				var blob = builder.getBlob(type);
				if (!blob.slice && blob.webkitSlice) {
					blob.slice = blob.webkitSlice;
				}
				return blob;
			};
	
			var getPrototypeOf = Object.getPrototypeOf || function(object) {
				return object.__proto__;
			};
			view.Blob.prototype = getPrototypeOf(new view.Blob());
		}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || this.content || this));
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		module.exports = function SaveAs() {
		  return __webpack_require__(6).saveAs || function() {};
		};
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
		 * A saveAs() FileSaver implementation.
		 * 1.3.2
		 * 2016-06-16 18:25:19
		 *
		 * By Eli Grey, http://eligrey.com
		 * License: MIT
		 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
		 */
	
		/*global self */
		/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
		/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
		var saveAs = saveAs || (function(view) {
			"use strict";
			// IE <10 is explicitly unsupported
			if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
				return;
			}
			var
				  doc = view.document
				  // only get URL when necessary in case Blob.js hasn't overridden it yet
				, get_URL = function() {
					return view.URL || view.webkitURL || view;
				}
				, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
				, can_use_save_link = "download" in save_link
				, click = function(node) {
					var event = new MouseEvent("click");
					node.dispatchEvent(event);
				}
				, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
				, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
				, throw_outside = function(ex) {
					(view.setImmediate || view.setTimeout)(function() {
						throw ex;
					}, 0);
				}
				, force_saveable_type = "application/octet-stream"
				// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
				, arbitrary_revoke_timeout = 1000 * 40 // in ms
				, revoke = function(file) {
					var revoker = function() {
						if (typeof file === "string") { // file is an object URL
							get_URL().revokeObjectURL(file);
						} else { // file is a File
							file.remove();
						}
					};
					setTimeout(revoker, arbitrary_revoke_timeout);
				}
				, dispatch = function(filesaver, event_types, event) {
					event_types = [].concat(event_types);
					var i = event_types.length;
					while (i--) {
						var listener = filesaver["on" + event_types[i]];
						if (typeof listener === "function") {
							try {
								listener.call(filesaver, event || filesaver);
							} catch (ex) {
								throw_outside(ex);
							}
						}
					}
				}
				, auto_bom = function(blob) {
					// prepend BOM for UTF-8 XML and text/* types (including HTML)
					// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
					if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
						return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
					}
					return blob;
				}
				, FileSaver = function(blob, name, no_auto_bom) {
					if (!no_auto_bom) {
						blob = auto_bom(blob);
					}
					// First try a.download, then web filesystem, then object URLs
					var
						  filesaver = this
						, type = blob.type
						, force = type === force_saveable_type
						, object_url
						, dispatch_all = function() {
							dispatch(filesaver, "writestart progress write writeend".split(" "));
						}
						// on any filesys errors revert to saving with object URLs
						, fs_error = function() {
							if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
								// Safari doesn't allow downloading of blob urls
								var reader = new FileReader();
								reader.onloadend = function() {
									var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
									var popup = view.open(url, '_blank');
									if(!popup) view.location.href = url;
									url=undefined; // release reference before dispatching
									filesaver.readyState = filesaver.DONE;
									dispatch_all();
								};
								reader.readAsDataURL(blob);
								filesaver.readyState = filesaver.INIT;
								return;
							}
							// don't create more object URLs than needed
							if (!object_url) {
								object_url = get_URL().createObjectURL(blob);
							}
							if (force) {
								view.location.href = object_url;
							} else {
								var opened = view.open(object_url, "_blank");
								if (!opened) {
									// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
									view.location.href = object_url;
								}
							}
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
							revoke(object_url);
						}
					;
					filesaver.readyState = filesaver.INIT;
	
					if (can_use_save_link) {
						object_url = get_URL().createObjectURL(blob);
						setTimeout(function() {
							save_link.href = object_url;
							save_link.download = name;
							click(save_link);
							dispatch_all();
							revoke(object_url);
							filesaver.readyState = filesaver.DONE;
						});
						return;
					}
	
					fs_error();
				}
				, FS_proto = FileSaver.prototype
				, saveAs = function(blob, name, no_auto_bom) {
					return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
				}
			;
			// IE 10+ (native saveAs)
			if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
				return function(blob, name, no_auto_bom) {
					name = name || blob.name || "download";
	
					if (!no_auto_bom) {
						blob = auto_bom(blob);
					}
					return navigator.msSaveOrOpenBlob(blob, name);
				};
			}
	
			FS_proto.abort = function(){};
			FS_proto.readyState = FS_proto.INIT = 0;
			FS_proto.WRITING = 1;
			FS_proto.DONE = 2;
	
			FS_proto.error =
			FS_proto.onwritestart =
			FS_proto.onprogress =
			FS_proto.onwrite =
			FS_proto.onabort =
			FS_proto.onerror =
			FS_proto.onwriteend =
				null;
	
			return saveAs;
		}(
			   typeof self !== "undefined" && self
			|| typeof window !== "undefined" && window
			|| this.content
		));
		// `self` is undefined in Firefox for Android content script context
		// while `this` is nsIContentFrameMessageManager
		// with an attribute `content` that corresponds to the window
	
		if (typeof module !== "undefined" && module.exports) {
		  module.exports.saveAs = saveAs;
		} else if (("function" !== "undefined" && __webpack_require__(7) !== null) && (__webpack_require__(8) !== null)) {
		  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		    return saveAs;
		  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		module.exports = function() { throw new Error("define cannot be used indirect"); };
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
		/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ }
	/******/ ])
	});
	;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * angular-translate - v2.18.1 - 2018-05-19
	 * 
	 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof module === 'object' && module.exports) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    factory();
	  }
	}(this, function () {
	
	/**
	 * @ngdoc overview
	 * @name pascalprecht.translate
	 *
	 * @description
	 * The main module which holds everything together.
	 */
	runTranslate.$inject = ['$translate'];
	$translate.$inject = ['$STORAGE_KEY', '$windowProvider', '$translateSanitizationProvider', 'pascalprechtTranslateOverrider'];
	$translateDefaultInterpolation.$inject = ['$interpolate', '$translateSanitization'];
	translateDirective.$inject = ['$translate', '$interpolate', '$compile', '$parse', '$rootScope'];
	translateAttrDirective.$inject = ['$translate', '$rootScope'];
	translateCloakDirective.$inject = ['$translate', '$rootScope'];
	translateFilterFactory.$inject = ['$parse', '$translate'];
	$translationCache.$inject = ['$cacheFactory'];
	angular.module('pascalprecht.translate', ['ng'])
	  .run(runTranslate);
	
	function runTranslate($translate) {
	
	  'use strict';
	
	  var key = $translate.storageKey(),
	    storage = $translate.storage();
	
	  var fallbackFromIncorrectStorageValue = function () {
	    var preferred = $translate.preferredLanguage();
	    if (angular.isString(preferred)) {
	      $translate.use(preferred);
	      // $translate.use() will also remember the language.
	      // So, we don't need to call storage.put() here.
	    } else {
	      storage.put(key, $translate.use());
	    }
	  };
	
	  fallbackFromIncorrectStorageValue.displayName = 'fallbackFromIncorrectStorageValue';
	
	  if (storage) {
	    if (!storage.get(key)) {
	      fallbackFromIncorrectStorageValue();
	    } else {
	      $translate.use(storage.get(key))['catch'](fallbackFromIncorrectStorageValue);
	    }
	  } else if (angular.isString($translate.preferredLanguage())) {
	    $translate.use($translate.preferredLanguage());
	  }
	}
	
	runTranslate.displayName = 'runTranslate';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateSanitizationProvider
	 *
	 * @description
	 *
	 * Configurations for $translateSanitization
	 */
	angular.module('pascalprecht.translate').provider('$translateSanitization', $translateSanitizationProvider);
	
	function $translateSanitizationProvider () {
	
	  'use strict';
	
	  var $sanitize,
	      $sce,
	      currentStrategy = null, // TODO change to either 'sanitize', 'escape' or ['sanitize', 'escapeParameters'] in 3.0.
	      hasConfiguredStrategy = false,
	      hasShownNoStrategyConfiguredWarning = false,
	      strategies;
	
	  /**
	   * Definition of a sanitization strategy function
	   * @callback StrategyFunction
	   * @param {string|object} value - value to be sanitized (either a string or an interpolated value map)
	   * @param {string} mode - either 'text' for a string (translation) or 'params' for the interpolated params
	   * @return {string|object}
	   */
	
	  /**
	   * @ngdoc property
	   * @name strategies
	   * @propertyOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Following strategies are built-in:
	   * <dl>
	   *   <dt>sanitize</dt>
	   *   <dd>Sanitizes HTML in the translation text using $sanitize</dd>
	   *   <dt>escape</dt>
	   *   <dd>Escapes HTML in the translation</dd>
	   *   <dt>sanitizeParameters</dt>
	   *   <dd>Sanitizes HTML in the values of the interpolation parameters using $sanitize</dd>
	   *   <dt>escapeParameters</dt>
	   *   <dd>Escapes HTML in the values of the interpolation parameters</dd>
	   *   <dt>escaped</dt>
	   *   <dd>Support legacy strategy name 'escaped' for backwards compatibility (will be removed in 3.0)</dd>
	   * </dl>
	   *
	   */
	
	  strategies = {
	    sanitize: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlSanitizeValue(value);
	      }
	      return value;
	    },
	    escape: function (value, mode/*, context*/) {
	      if (mode === 'text') {
	        value = htmlEscapeValue(value);
	      }
	      return value;
	    },
	    sanitizeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlSanitizeValue);
	      }
	      return value;
	    },
	    escapeParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlEscapeValue);
	      }
	      return value;
	    },
	    sce: function (value, mode, context) {
	      if (mode === 'text') {
	        value = htmlTrustValue(value);
	      } else if (mode === 'params') {
	        if (context !== 'filter') {
	          // do html escape in filter context #1101
	          value = mapInterpolationParameters(value, htmlEscapeValue);
	        }
	      }
	      return value;
	    },
	    sceParameters: function (value, mode/*, context*/) {
	      if (mode === 'params') {
	        value = mapInterpolationParameters(value, htmlTrustValue);
	      }
	      return value;
	    }
	  };
	  // Support legacy strategy name 'escaped' for backwards compatibility.
	  // TODO should be removed in 3.0
	  strategies.escaped = strategies.escapeParameters;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#addStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Adds a sanitization strategy to the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @param {StrategyFunction} strategyFunction - strategy function
	   * @returns {object} this
	   */
	  this.addStrategy = function (strategyName, strategyFunction) {
	    strategies[strategyName] = strategyFunction;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#removeStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Removes a sanitization strategy from the list of known strategies.
	   *
	   * @param {string} strategyName - unique key for a strategy
	   * @returns {object} this
	   */
	  this.removeStrategy = function (strategyName) {
	    delete strategies[strategyName];
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateSanitizationProvider#useStrategy
	   * @methodOf pascalprecht.translate.$translateSanitizationProvider
	   *
	   * @description
	   * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	   *
	   * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	   * @returns {object} this
	   */
	  this.useStrategy = function (strategy) {
	    hasConfiguredStrategy = true;
	    currentStrategy = strategy;
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translateSanitization
	   * @requires $injector
	   * @requires $log
	   *
	   * @description
	   * Sanitizes interpolation parameters and translated texts.
	   *
	   */
	  this.$get = ['$injector', '$log', function ($injector, $log) {
	
	    var cachedStrategyMap = {};
	
	    var applyStrategies = function (value, mode, context, selectedStrategies) {
	      angular.forEach(selectedStrategies, function (selectedStrategy) {
	        if (angular.isFunction(selectedStrategy)) {
	          value = selectedStrategy(value, mode, context);
	        } else if (angular.isFunction(strategies[selectedStrategy])) {
	          value = strategies[selectedStrategy](value, mode, context);
	        } else if (angular.isString(strategies[selectedStrategy])) {
	          if (!cachedStrategyMap[strategies[selectedStrategy]]) {
	            try {
	              cachedStrategyMap[strategies[selectedStrategy]] = $injector.get(strategies[selectedStrategy]);
	            } catch (e) {
	              cachedStrategyMap[strategies[selectedStrategy]] = function() {};
	              throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	            }
	          }
	          value = cachedStrategyMap[strategies[selectedStrategy]](value, mode, context);
	        } else {
	          throw new Error('pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: \'' + selectedStrategy + '\'');
	        }
	      });
	      return value;
	    };
	
	    // TODO: should be removed in 3.0
	    var showNoStrategyConfiguredWarning = function () {
	      if (!hasConfiguredStrategy && !hasShownNoStrategyConfiguredWarning) {
	        $log.warn('pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details.');
	        hasShownNoStrategyConfiguredWarning = true;
	      }
	    };
	
	    if ($injector.has('$sanitize')) {
	      $sanitize = $injector.get('$sanitize');
	    }
	    if ($injector.has('$sce')) {
	      $sce = $injector.get('$sce');
	    }
	
	    return {
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#useStrategy
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
	       *
	       * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
	       */
	      useStrategy: (function (self) {
	        return function (strategy) {
	          self.useStrategy(strategy);
	        };
	      })(this),
	
	      /**
	       * @ngdoc function
	       * @name pascalprecht.translate.$translateSanitization#sanitize
	       * @methodOf pascalprecht.translate.$translateSanitization
	       *
	       * @description
	       * Sanitizes a value.
	       *
	       * @param {string|object} value The value which should be sanitized.
	       * @param {string} mode The current sanitization mode, either 'params' or 'text'.
	       * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
	       * @param {string} [context] The context of this call: filter, service. Default is service
	       * @returns {string|object} sanitized value
	       */
	      sanitize: function (value, mode, strategy, context) {
	        if (!currentStrategy) {
	          showNoStrategyConfiguredWarning();
	        }
	
	        if (!strategy && strategy !== null) {
	          strategy = currentStrategy;
	        }
	
	        if (!strategy) {
	          return value;
	        }
	
	        if (!context) {
	          context = 'service';
	        }
	
	        var selectedStrategies = angular.isArray(strategy) ? strategy : [strategy];
	        return applyStrategies(value, mode, context, selectedStrategies);
	      }
	    };
	  }];
	
	  var htmlEscapeValue = function (value) {
	    var element = angular.element('<div></div>');
	    element.text(value); // not chainable, see #1044
	    return element.html();
	  };
	
	  var htmlSanitizeValue = function (value) {
	    if (!$sanitize) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as \'escape\'.');
	    }
	    return $sanitize(value);
	  };
	
	  var htmlTrustValue = function (value) {
	    if (!$sce) {
	      throw new Error('pascalprecht.translate.$translateSanitization: Error cannot find $sce service.');
	    }
	    return $sce.trustAsHtml(value);
	  };
	
	  var mapInterpolationParameters = function (value, iteratee, stack) {
	    if (angular.isDate(value)) {
	      return value;
	    } else if (angular.isObject(value)) {
	      var result = angular.isArray(value) ? [] : {};
	
	      if (!stack) {
	        stack = [];
	      } else {
	        if (stack.indexOf(value) > -1) {
	          throw new Error('pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object');
	        }
	      }
	
	      stack.push(value);
	      angular.forEach(value, function (propertyValue, propertyKey) {
	
	        /* Skipping function properties. */
	        if (angular.isFunction(propertyValue)) {
	          return;
	        }
	
	        result[propertyKey] = mapInterpolationParameters(propertyValue, iteratee, stack);
	      });
	      stack.splice(-1, 1); // remove last
	
	      return result;
	    } else if (angular.isNumber(value)) {
	      return value;
	    } else if (value === true || value === false) {
	      return value;
	    } else if (!angular.isUndefined(value) && value !== null) {
	      return iteratee(value);
	    } else {
	      return value;
	    }
	  };
	}
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateProvider
	 * @description
	 *
	 * $translateProvider allows developers to register translation-tables, asynchronous loaders
	 * and similar to configure translation behavior directly inside of a module.
	 *
	 */
	angular.module('pascalprecht.translate')
	  .constant('pascalprechtTranslateOverrider', {})
	  .provider('$translate', $translate);
	
	function $translate($STORAGE_KEY, $windowProvider, $translateSanitizationProvider, pascalprechtTranslateOverrider) {
	
	  'use strict';
	
	  var $translationTable = {},
	    $preferredLanguage,
	    $availableLanguageKeys = [],
	    $languageKeyAliases,
	    $fallbackLanguage,
	    $fallbackWasString,
	    $uses,
	    $nextLang,
	    $storageFactory,
	    $storageKey = $STORAGE_KEY,
	    $storagePrefix,
	    $missingTranslationHandlerFactory,
	    $interpolationFactory,
	    $interpolatorFactories = [],
	    $loaderFactory,
	    $cloakClassName = 'translate-cloak',
	    $loaderOptions,
	    $notFoundIndicatorLeft,
	    $notFoundIndicatorRight,
	    $postCompilingEnabled = false,
	    $forceAsyncReloadEnabled = false,
	    $nestedObjectDelimeter = '.',
	    $isReady = false,
	    $keepContent = false,
	    loaderCache,
	    directivePriority = 0,
	    statefulFilter = true,
	    postProcessFn,
	    uniformLanguageTagResolver = 'default',
	    languageTagResolver = {
	      'default' : function (tag) {
	        return (tag || '').split('-').join('_');
	      },
	      java : function (tag) {
	        var temp = (tag || '').split('-').join('_');
	        var parts = temp.split('_');
	        return parts.length > 1 ? (parts[0].toLowerCase() + '_' + parts[1].toUpperCase()) : temp;
	      },
	      bcp47 : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	
	        switch (parts.length) {
	          case 1: // language only
	            parts[0] = parts[0].toLowerCase();
	            break;
	          case 2: // language-script or language-region
	            parts[0] = parts[0].toLowerCase();
	            if (parts[1].length === 4) { // parts[1] is script
	              parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            } else { // parts[1] is region
	              parts[1] = parts[1].toUpperCase();
	            }
	            break;
	          case 3: // language-script-region
	            parts[0] = parts[0].toLowerCase();
	            parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
	            parts[2] = parts[2].toUpperCase();
	            break;
	          default:
	            return temp;
	        }
	
	        return parts.join('-');
	      },
	      'iso639-1' : function (tag) {
	        var temp = (tag || '').split('_').join('-');
	        var parts = temp.split('-');
	        return parts[0].toLowerCase();
	      }
	    };
	
	  var version = '2.18.1';
	
	  // tries to determine the browsers language
	  var getFirstBrowserLanguage = function () {
	
	    // internal purpose only
	    if (angular.isFunction(pascalprechtTranslateOverrider.getLocale)) {
	      return pascalprechtTranslateOverrider.getLocale();
	    }
	
	    var nav = $windowProvider.$get().navigator,
	      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
	      i,
	      language;
	
	    // support for HTML 5.1 "navigator.languages"
	    if (angular.isArray(nav.languages)) {
	      for (i = 0; i < nav.languages.length; i++) {
	        language = nav.languages[i];
	        if (language && language.length) {
	          return language;
	        }
	      }
	    }
	
	    // support for other well known properties in browsers
	    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
	      language = nav[browserLanguagePropertyKeys[i]];
	      if (language && language.length) {
	        return language;
	      }
	    }
	
	    return null;
	  };
	  getFirstBrowserLanguage.displayName = 'angular-translate/service: getFirstBrowserLanguage';
	
	  // tries to determine the browsers locale
	  var getLocale = function () {
	    var locale = getFirstBrowserLanguage() || '';
	    if (languageTagResolver[uniformLanguageTagResolver]) {
	      locale = languageTagResolver[uniformLanguageTagResolver](locale);
	    }
	    return locale;
	  };
	  getLocale.displayName = 'angular-translate/service: getLocale';
	
	  /**
	   * @name indexOf
	   * @private
	   *
	   * @description
	   * indexOf polyfill. Kinda sorta.
	   *
	   * @param {array} array Array to search in.
	   * @param {string} searchElement Element to search for.
	   *
	   * @returns {int} Index of search element.
	   */
	  var indexOf = function (array, searchElement) {
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === searchElement) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function () {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  var negotiateLocale = function (preferred) {
	    if (!preferred) {
	      return;
	    }
	
	    var avail = [],
	      locale = lowercase(preferred),
	      i = 0,
	      n = $availableLanguageKeys.length;
	
	    for (; i < n; i++) {
	      avail.push(lowercase($availableLanguageKeys[i]));
	    }
	
	    // Check for an exact match in our list of available keys
	    i = indexOf(avail, locale);
	    if (i > -1) {
	      return $availableLanguageKeys[i];
	    }
	
	    if ($languageKeyAliases) {
	      var alias;
	      for (var langKeyAlias in $languageKeyAliases) {
	        if ($languageKeyAliases.hasOwnProperty(langKeyAlias)) {
	          var hasWildcardKey = false;
	          var hasExactKey = Object.prototype.hasOwnProperty.call($languageKeyAliases, langKeyAlias) &&
	            lowercase(langKeyAlias) === lowercase(preferred);
	
	          if (langKeyAlias.slice(-1) === '*') {
	            hasWildcardKey = lowercase(langKeyAlias.slice(0, -1)) === lowercase(preferred.slice(0, langKeyAlias.length - 1));
	          }
	          if (hasExactKey || hasWildcardKey) {
	            alias = $languageKeyAliases[langKeyAlias];
	            if (indexOf(avail, lowercase(alias)) > -1) {
	              return alias;
	            }
	          }
	        }
	      }
	    }
	
	    // Check for a language code without region
	    var parts = preferred.split('_');
	
	    if (parts.length > 1 && indexOf(avail, lowercase(parts[0])) > -1) {
	      return parts[0];
	    }
	
	    // If everything fails, return undefined.
	    return;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translations
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a new translation table for specific language key.
	   *
	   * To register a translation table for specific language, pass a defined language
	   * key as first parameter.
	   *
	   * <pre>
	   *  // register translation table for language: 'de_DE'
	   *  $translateProvider.translations('de_DE', {
	   *    'GREETING': 'Hallo Welt!'
	   *  });
	   *
	   *  // register another one
	   *  $translateProvider.translations('en_US', {
	   *    'GREETING': 'Hello world!'
	   *  });
	   * </pre>
	   *
	   * When registering multiple translation tables for for the same language key,
	   * the actual translation table gets extended. This allows you to define module
	   * specific translation which only get added, once a specific module is loaded in
	   * your app.
	   *
	   * Invoking this method with no arguments returns the translation table which was
	   * registered with no language key. Invoking it with a language key returns the
	   * related translation table.
	   *
	   * @param {string} langKey A language key.
	   * @param {object} translationTable A plain old JavaScript object that represents a translation table.
	   *
	   */
	  var translations = function (langKey, translationTable) {
	
	    if (!langKey && !translationTable) {
	      return $translationTable;
	    }
	
	    if (langKey && !translationTable) {
	      if (angular.isString(langKey)) {
	        return $translationTable[langKey];
	      }
	    } else {
	      if (!angular.isObject($translationTable[langKey])) {
	        $translationTable[langKey] = {};
	      }
	      angular.extend($translationTable[langKey], flatObject(translationTable));
	    }
	    return this;
	  };
	
	  this.translations = translations;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#cloakClassName
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the class name for `translate-cloak` directive.
	   * Default class name is `translate-cloak`.
	   *
	   * @param {string} name translate-cloak class name
	   */
	  this.cloakClassName = function (name) {
	    if (!name) {
	      return $cloakClassName;
	    }
	    $cloakClassName = name;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#nestedObjectDelimeter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   *
	   * Let's you change the delimiter for namespaced translations.
	   * Default delimiter is `.`.
	   *
	   * @param {string} delimiter namespace separator
	   */
	  this.nestedObjectDelimeter = function (delimiter) {
	    if (!delimiter) {
	      return $nestedObjectDelimeter;
	    }
	    $nestedObjectDelimeter = delimiter;
	    return this;
	  };
	
	  /**
	   * @name flatObject
	   * @private
	   *
	   * @description
	   * Flats an object. This function is used to flatten given translation data with
	   * namespaces, so they are later accessible via dot notation.
	   */
	  var flatObject = function (data, path, result, prevKey) {
	    var key, keyWithPath, keyWithShortPath, val;
	
	    if (!path) {
	      path = [];
	    }
	    if (!result) {
	      result = {};
	    }
	    for (key in data) {
	      if (!Object.prototype.hasOwnProperty.call(data, key)) {
	        continue;
	      }
	      val = data[key];
	      if (angular.isObject(val)) {
	        flatObject(val, path.concat(key), result, key);
	      } else {
	        keyWithPath = path.length ? ('' + path.join($nestedObjectDelimeter) + $nestedObjectDelimeter + key) : key;
	        if (path.length && key === prevKey) {
	          // Create shortcut path (foo.bar == foo.bar.bar)
	          keyWithShortPath = '' + path.join($nestedObjectDelimeter);
	          // Link it to original path
	          result[keyWithShortPath] = '@:' + keyWithPath;
	        }
	        result[keyWithPath] = val;
	      }
	    }
	    return result;
	  };
	  flatObject.displayName = 'flatObject';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#addInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Adds interpolation services to angular-translate, so it can manage them.
	   *
	   * @param {object} factory Interpolation service factory
	   */
	  this.addInterpolation = function (factory) {
	    $interpolatorFactories.push(factory);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMessageFormatInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use interpolation functionality of messageformat.js.
	   * This is useful when having high level pluralization and gender selection.
	   */
	  this.useMessageFormatInterpolation = function () {
	    return this.useInterpolation('$translateMessageFormatInterpolation');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useInterpolation
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which interpolation style to use as default, application-wide.
	   * Simply pass a factory/service name. The interpolation service has to implement
	   * the correct interface.
	   *
	   * @param {string} factory Interpolation service name.
	   */
	  this.useInterpolation = function (factory) {
	    $interpolationFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useSanitizeStrategy
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Simply sets a sanitation strategy type.
	   *
	   * @param {string} value Strategy type.
	   */
	  this.useSanitizeValueStrategy = function (value) {
	    $translateSanitizationProvider.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#preferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use for translation
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **prefer**.
	   * It is recommended to call this after {@link pascalprecht.translate.$translate#fallbackLanguage fallbackLanguage()}.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.preferredLanguage = function (langKey) {
	    if (langKey) {
	      setupPreferredLanguage(langKey);
	      return this;
	    }
	    return $preferredLanguage;
	  };
	  var setupPreferredLanguage = function (langKey) {
	    if (langKey) {
	      $preferredLanguage = langKey;
	    }
	    return $preferredLanguage;
	  };
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicator
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found. E.g. when
	   * setting the indicator as 'X' and one tries to translate a translation id
	   * called `NOT_FOUND`, this will result in `X NOT_FOUND X`.
	   *
	   * Internally this methods sets a left indicator and a right indicator using
	   * `$translateProvider.translationNotFoundIndicatorLeft()` and
	   * `$translateProvider.translationNotFoundIndicatorRight()`.
	   *
	   * **Note**: These methods automatically add a whitespace between the indicators
	   * and the translation id.
	   *
	   * @param {string} indicator An indicator, could be any string.
	   */
	  this.translationNotFoundIndicator = function (indicator) {
	    this.translationNotFoundIndicatorLeft(indicator);
	    this.translationNotFoundIndicatorRight(indicator);
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found left to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorLeft = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorLeft;
	    }
	    $notFoundIndicatorLeft = indicator;
	    return this;
	  };
	
	  /**
	   * ngdoc function
	   * @name pascalprecht.translate.$translateProvider#translationNotFoundIndicatorLeft
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets an indicator which is used when a translation isn't found right to the
	   * translation id.
	   *
	   * @param {string} indicator An indicator.
	   */
	  this.translationNotFoundIndicatorRight = function (indicator) {
	    if (!indicator) {
	      return $notFoundIndicatorRight;
	    }
	    $notFoundIndicatorRight = indicator;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#fallbackLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which of the registered translation tables to use when missing translations
	   * at initial startup by passing a language key. Similar to `$translateProvider#use`
	   * only that it says which language to **fallback**.
	   *
	   * @param {string||array} langKey A language key.
	   *
	   */
	  this.fallbackLanguage = function (langKey) {
	    fallbackStack(langKey);
	    return this;
	  };
	
	  var fallbackStack = function (langKey) {
	    if (langKey) {
	      if (angular.isString(langKey)) {
	        $fallbackWasString = true;
	        $fallbackLanguage = [langKey];
	      } else if (angular.isArray(langKey)) {
	        $fallbackWasString = false;
	        $fallbackLanguage = langKey;
	      }
	      if (angular.isString($preferredLanguage) && indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	        $fallbackLanguage.push($preferredLanguage);
	      }
	
	      return this;
	    } else {
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#use
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Set which translation table to use for translation by given language key. When
	   * trying to 'use' a language which isn't provided, it'll throw an error.
	   *
	   * You actually don't have to use this method since `$translateProvider#preferredLanguage`
	   * does the job too.
	   *
	   * @param {string} langKey A language key.
	   */
	  this.use = function (langKey) {
	    if (langKey) {
	      if (!$translationTable[langKey] && (!$loaderFactory)) {
	        // only throw an error, when not loading translation data asynchronously
	        throw new Error('$translateProvider couldn\'t find translationTable for langKey: \'' + langKey + '\'');
	      }
	      $uses = langKey;
	      return this;
	    }
	    return $uses;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#resolveClientLocale
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	   *
	   * @returns {string} the current client/browser language key
	   */
	  this.resolveClientLocale = function () {
	    return getLocale();
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storageKey
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells the module which key must represent the choosed language by a user in the storage.
	   *
	   * @param {string} key A key for the storage.
	   */
	  var storageKey = function (key) {
	    if (!key) {
	      if ($storagePrefix) {
	        return $storagePrefix + $storageKey;
	      }
	      return $storageKey;
	    }
	    $storageKey = key;
	    return this;
	  };
	
	  this.storageKey = storageKey;
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useUrlLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateUrlLoader` extension service as loader.
	   *
	   * @param {string} url Url
	   * @param {Object=} options Optional configuration object
	   */
	  this.useUrlLoader = function (url, options) {
	    return this.useLoader('$translateUrlLoader', angular.extend({url : url}, options));
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStaticFilesLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateStaticFilesLoader` extension service as loader.
	   *
	   * @param {Object=} options Optional configuration object
	   */
	  this.useStaticFilesLoader = function (options) {
	    return this.useLoader('$translateStaticFilesLoader', options);
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoader
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use any other service as loader.
	   *
	   * @param {string} loaderFactory Factory name to use
	   * @param {Object=} options Optional configuration object
	   */
	  this.useLoader = function (loaderFactory, options) {
	    $loaderFactory = loaderFactory;
	    $loaderOptions = options || {};
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLocalStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateLocalStorage` service as storage layer.
	   *
	   */
	  this.useLocalStorage = function () {
	    return this.useStorage('$translateLocalStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useCookieStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use `$translateCookieStorage` service as storage layer.
	   */
	  this.useCookieStorage = function () {
	    return this.useStorage('$translateCookieStorage');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useStorage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use custom service as storage layer.
	   */
	  this.useStorage = function (storageFactory) {
	    $storageFactory = storageFactory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#storagePrefix
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets prefix for storage key.
	   *
	   * @param {string} prefix Storage key prefix
	   */
	  this.storagePrefix = function (prefix) {
	    if (!prefix) {
	      return prefix;
	    }
	    $storagePrefix = prefix;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandlerLog
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to use built-in log handler when trying to translate
	   * a translation Id which doesn't exist.
	   *
	   * This is actually a shortcut method for `useMissingTranslationHandler()`.
	   *
	   */
	  this.useMissingTranslationHandlerLog = function () {
	    return this.useMissingTranslationHandler('$translateMissingTranslationHandlerLog');
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useMissingTranslationHandler
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Expects a factory name which later gets instantiated with `$injector`.
	   * This method can be used to tell angular-translate to use a custom
	   * missingTranslationHandler. Just build a factory which returns a function
	   * and expects a translation id as argument.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.useMissingTranslationHandler('customHandler');
	   *  });
	   *
	   *  app.factory('customHandler', function (dep1, dep2) {
	   *    return function (translationId) {
	   *      // something with translationId and dep1 and dep2
	   *    };
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.useMissingTranslationHandler = function (factory) {
	    $missingTranslationHandlerFactory = factory;
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#usePostCompiling
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If post compiling is enabled, all translated values will be processed
	   * again with AngularJS' $compile.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.usePostCompiling(true);
	   *  });
	   * </pre>
	   *
	   * @param {string} factory Factory name
	   */
	  this.usePostCompiling = function (value) {
	    $postCompilingEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#forceAsyncReload
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If force async reload is enabled, async loader will always be called
	   * even if $translationTable already contains the language key, adding
	   * possible new entries to the $translationTable.
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.forceAsyncReload(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.forceAsyncReload = function (value) {
	    $forceAsyncReloadEnabled = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#uniformLanguageTag
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate which language tag should be used as a result when determining
	   * the current browser language.
	   *
	   * This setting must be set before invoking {@link pascalprecht.translate.$translateProvider#methods_determinePreferredLanguage determinePreferredLanguage()}.
	   *
	   * <pre>
	   * $translateProvider
	   *   .uniformLanguageTag('bcp47')
	   *   .determinePreferredLanguage()
	   * </pre>
	   *
	   * The resolver currently supports:
	   * * default
	   *     (traditionally: hyphens will be converted into underscores, i.e. en-US => en_US)
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_us
	   * * java
	   *     like default, but the second part will be always in uppercase
	   *     en-US => en_US
	   *     en_US => en_US
	   *     en-us => en_US
	   * * BCP 47 (RFC 4646 & 4647)
	   *     EN => en
	   *     en-US => en-US
	   *     en_US => en-US
	   *     en-us => en-US
	   *     sr-latn => sr-Latn
	   *     sr-latn-rs => sr-Latn-RS
	   *
	   * See also:
	   * * http://en.wikipedia.org/wiki/IETF_language_tag
	   * * http://www.w3.org/International/core/langtags/
	   * * http://tools.ietf.org/html/bcp47
	   *
	   * @param {string|object} options - options (or standard)
	   * @param {string} options.standard - valid values are 'default', 'bcp47', 'java'
	   */
	  this.uniformLanguageTag = function (options) {
	
	    if (!options) {
	      options = {};
	    } else if (angular.isString(options)) {
	      options = {
	        standard : options
	      };
	    }
	
	    uniformLanguageTagResolver = options.standard;
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#determinePreferredLanguage
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Tells angular-translate to try to determine on its own which language key
	   * to set as preferred language. When `fn` is given, angular-translate uses it
	   * to determine a language key, otherwise it uses the built-in `getLocale()`
	   * method.
	   *
	   * The `getLocale()` returns a language key in the format `[lang]_[country]` or
	   * `[lang]` depending on what the browser provides.
	   *
	   * Use this method at your own risk, since not all browsers return a valid
	   * locale (see {@link pascalprecht.translate.$translateProvider#methods_uniformLanguageTag uniformLanguageTag()}).
	   *
	   * @param {Function=} fn Function to determine a browser's locale
	   */
	  this.determinePreferredLanguage = function (fn) {
	
	    var locale = (fn && angular.isFunction(fn)) ? fn() : getLocale();
	
	    if (!$availableLanguageKeys.length) {
	      $preferredLanguage = locale;
	    } else {
	      $preferredLanguage = negotiateLocale(locale) || locale;
	    }
	
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#registerAvailableLanguageKeys
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a set of language keys the app will work with. Use this method in
	   * combination with
	   * {@link pascalprecht.translate.$translateProvider#determinePreferredLanguage determinePreferredLanguage}.
	   * When available languages keys are registered, angular-translate
	   * tries to find the best fitting language key depending on the browsers locale,
	   * considering your language key convention.
	   *
	   * @param {object} languageKeys Array of language keys the your app will use
	   * @param {object=} aliases Alias map.
	   */
	  this.registerAvailableLanguageKeys = function (languageKeys, aliases) {
	    if (languageKeys) {
	      $availableLanguageKeys = languageKeys;
	      if (aliases) {
	        $languageKeyAliases = aliases;
	      }
	      return this;
	    }
	    return $availableLanguageKeys;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#useLoaderCache
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Registers a cache for internal $http based loaders.
	   * {@link pascalprecht.translate.$translationCache $translationCache}.
	   * When false the cache will be disabled (default). When true or undefined
	   * the cache will be a default (see $cacheFactory). When an object it will
	   * be treat as a cache object itself: the usage is $http({cache: cache})
	   *
	   * @param {object} cache boolean, string or cache-object
	   */
	  this.useLoaderCache = function (cache) {
	    if (cache === false) {
	      // disable cache
	      loaderCache = undefined;
	    } else if (cache === true) {
	      // enable cache using AJS defaults
	      loaderCache = true;
	    } else if (typeof(cache) === 'undefined') {
	      // enable cache using default
	      loaderCache = '$translationCache';
	    } else if (cache) {
	      // enable cache using given one (see $cacheFactory)
	      loaderCache = cache;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#directivePriority
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Sets the default priority of the translate directive. The standard value is `0`.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {number} priority for the translate-directive
	   */
	  this.directivePriority = function (priority) {
	    if (priority === undefined) {
	      // getter
	      return directivePriority;
	    } else {
	      // setter with chaining
	      directivePriority = priority;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#statefulFilter
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * Since AngularJS 1.3, filters which are not stateless (depending at the scope)
	   * have to explicit define this behavior.
	   * Sets whether the translate filter should be stateful or stateless. The standard value is `true`
	   * meaning being stateful.
	   * Calling this function without an argument will return the current value.
	   *
	   * @param {boolean} state - defines the state of the filter
	   */
	  this.statefulFilter = function (state) {
	    if (state === undefined) {
	      // getter
	      return statefulFilter;
	    } else {
	      // setter with chaining
	      statefulFilter = state;
	      return this;
	    }
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#postProcess
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * The post processor will be intercept right after the translation result. It can modify the result.
	   *
	   * @param {object} fn Function or service name (string) to be called after the translation value has been set / resolved. The function itself will enrich every value being processed and then continue the normal resolver process
	   */
	  this.postProcess = function (fn) {
	    if (fn) {
	      postProcessFn = fn;
	    } else {
	      postProcessFn = undefined;
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateProvider#keepContent
	   * @methodOf pascalprecht.translate.$translateProvider
	   *
	   * @description
	   * If keepContent is set to true than translate directive will always use innerHTML
	   * as a default translation
	   *
	   * Example:
	   * <pre>
	   *  app.config(function ($translateProvider) {
	   *    $translateProvider.keepContent(true);
	   *  });
	   * </pre>
	   *
	   * @param {boolean} value - valid values are true or false
	   */
	  this.keepContent = function (value) {
	    $keepContent = !(!value);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name pascalprecht.translate.$translate
	   * @requires $interpolate
	   * @requires $log
	   * @requires $rootScope
	   * @requires $q
	   *
	   * @description
	   * The `$translate` service is the actual core of angular-translate. It expects a translation id
	   * and optional interpolate parameters to translate contents.
	   *
	   * <pre>
	   *  $translate('HEADLINE_TEXT').then(function (translation) {
	   *    $scope.translatedText = translation;
	   *  });
	   * </pre>
	   *
	   * @param {string|array} translationId A token which represents a translation id
	   *                                     This can be optionally an array of translation ids which
	   *                                     results that the function returns an object where each key
	   *                                     is the translation id and the value the translation.
	   * @param {object=} [interpolateParams={}] An object hash for dynamic values
	   * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	   * @param {string=} [defaultTranslationText=undefined] the optional default translation text that is written as
	   *                                        as default text in case it is not found in any configured language
	   * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	   * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	   * @returns {object} promise
	   */
	  this.$get = ['$log', '$injector', '$rootScope', '$q', function ($log, $injector, $rootScope, $q) {
	
	    var Storage,
	      defaultInterpolator = $injector.get($interpolationFactory || '$translateDefaultInterpolation'),
	      pendingLoader = false,
	      interpolatorHashMap = {},
	      langPromises = {},
	      fallbackIndex,
	      startFallbackIteration;
	
	    var $translate = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy) {
	      if (!$uses && $preferredLanguage) {
	        $uses = $preferredLanguage;
	      }
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        // Inspired by Q.allSettled by Kris Kowal
	        // https://github.com/kriskowal/q/blob/b0fa72980717dc202ffc3cbf03b936e10ebbb9d7/q.js#L1553-1563
	        // This transforms all promises regardless resolved or rejected
	        var translateAll = function (translationIds) {
	          var results = {}; // storing the actual results
	          var promises = []; // promises to wait for
	          // Wraps the promise a) being always resolved and b) storing the link id->value
	          var translate = function (translationId) {
	            var deferred = $q.defer();
	            var regardless = function (value) {
	              results[translationId] = value;
	              deferred.resolve([translationId, value]);
	            };
	            // we don't care whether the promise was resolved or rejected; just store the values
	            $translate(translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage, sanitizeStrategy).then(regardless, regardless);
	            return deferred.promise;
	          };
	          for (var i = 0, c = translationIds.length; i < c; i++) {
	            promises.push(translate(translationIds[i]));
	          }
	          // wait for all (including storing to results)
	          return $q.all(promises).then(function () {
	            // return the results
	            return results;
	          });
	        };
	        return translateAll(translationId);
	      }
	
	      var deferred = $q.defer();
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var promiseToWaitFor = (function () {
	        var promise = langPromises[uses] || langPromises[$preferredLanguage];
	
	        fallbackIndex = 0;
	
	        if ($storageFactory && !promise) {
	          // looks like there's no pending promise for $preferredLanguage or
	          // $uses. Maybe there's one pending for a language that comes from
	          // storage.
	          var langKey = Storage.get($storageKey);
	          promise = langPromises[langKey];
	
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            var index = indexOf($fallbackLanguage, langKey);
	            // maybe the language from storage is also defined as fallback language
	            // we increase the fallback language index to not search in that language
	            // as fallback, since it's probably the first used language
	            // in that case the index starts after the first element
	            fallbackIndex = (index === 0) ? 1 : 0;
	
	            // but we can make sure to ALWAYS fallback to preferred language at least
	            if (indexOf($fallbackLanguage, $preferredLanguage) < 0) {
	              $fallbackLanguage.push($preferredLanguage);
	            }
	          }
	        }
	        return promise;
	      }());
	
	      if (!promiseToWaitFor) {
	        // no promise to wait for? okay. Then there's no loader registered
	        // nor is a one pending for language that comes from storage.
	        // We can just translate.
	        determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	      } else {
	        var promiseResolved = function () {
	          // $uses may have changed while waiting
	          if (!forceLanguage) {
	            uses = $uses;
	          }
	          determineTranslation(translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	        };
	        promiseResolved.displayName = 'promiseResolved';
	
	        promiseToWaitFor['finally'](promiseResolved)['catch'](angular.noop); // we don't care about errors here, already handled
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name applyNotFoundIndicators
	     * @private
	     *
	     * @description
	     * Applies not fount indicators to given translation id, if needed.
	     * This function gets only executed, if a translation id doesn't exist,
	     * which is why a translation id is expected as argument.
	     *
	     * @param {string} translationId Translation id.
	     * @returns {string} Same as given translation id but applied with not found
	     * indicators.
	     */
	    var applyNotFoundIndicators = function (translationId) {
	      // applying notFoundIndicators
	      if ($notFoundIndicatorLeft) {
	        translationId = [$notFoundIndicatorLeft, translationId].join(' ');
	      }
	      if ($notFoundIndicatorRight) {
	        translationId = [translationId, $notFoundIndicatorRight].join(' ');
	      }
	      return translationId;
	    };
	
	    /**
	     * @name useLanguage
	     * @private
	     *
	     * @description
	     * Makes actual use of a language by setting a given language key as used
	     * language and informs registered interpolators to also use the given
	     * key as locale.
	     *
	     * @param {string} key Locale key.
	     */
	    var useLanguage = function (key) {
	      $uses = key;
	
	      // make sure to store new language key before triggering success event
	      if ($storageFactory) {
	        Storage.put($translate.storageKey(), $uses);
	      }
	
	      $rootScope.$emit('$translateChangeSuccess', {language : key});
	
	      // inform default interpolator
	      defaultInterpolator.setLocale($uses);
	
	      var eachInterpolator = function (interpolator, id) {
	        interpolatorHashMap[id].setLocale($uses);
	      };
	      eachInterpolator.displayName = 'eachInterpolatorLocaleSetter';
	
	      // inform all others too!
	      angular.forEach(interpolatorHashMap, eachInterpolator);
	      $rootScope.$emit('$translateChangeEnd', {language : key});
	    };
	
	    /**
	     * @name loadAsync
	     * @private
	     *
	     * @description
	     * Kicks off registered async loader using `$injector` and applies existing
	     * loader options. When resolved, it updates translation tables accordingly
	     * or rejects with given language key.
	     *
	     * @param {string} key Language key.
	     * @return {Promise} A promise.
	     */
	    var loadAsync = function (key) {
	      if (!key) {
	        throw 'No language key specified for loading.';
	      }
	
	      var deferred = $q.defer();
	
	      $rootScope.$emit('$translateLoadingStart', {language : key});
	      pendingLoader = true;
	
	      var cache = loaderCache;
	      if (typeof(cache) === 'string') {
	        // getting on-demand instance of loader
	        cache = $injector.get(cache);
	      }
	
	      var loaderOptions = angular.extend({}, $loaderOptions, {
	        key : key,
	        $http : angular.extend({}, {
	          cache : cache
	        }, $loaderOptions.$http)
	      });
	
	      var onLoaderSuccess = function (data) {
	        var translationTable = {};
	        $rootScope.$emit('$translateLoadingSuccess', {language : key});
	
	        if (angular.isArray(data)) {
	          angular.forEach(data, function (table) {
	            angular.extend(translationTable, flatObject(table));
	          });
	        } else {
	          angular.extend(translationTable, flatObject(data));
	        }
	        pendingLoader = false;
	        deferred.resolve({
	          key : key,
	          table : translationTable
	        });
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderSuccess.displayName = 'onLoaderSuccess';
	
	      var onLoaderError = function (key) {
	        $rootScope.$emit('$translateLoadingError', {language : key});
	        deferred.reject(key);
	        $rootScope.$emit('$translateLoadingEnd', {language : key});
	      };
	      onLoaderError.displayName = 'onLoaderError';
	
	      $injector.get($loaderFactory)(loaderOptions)
	        .then(onLoaderSuccess, onLoaderError);
	
	      return deferred.promise;
	    };
	
	    if ($storageFactory) {
	      Storage = $injector.get($storageFactory);
	
	      if (!Storage.get || !Storage.put) {
	        throw new Error('Couldn\'t use storage \'' + $storageFactory + '\', missing get() or put() method!');
	      }
	    }
	
	    // if we have additional interpolations that were added via
	    // $translateProvider.addInterpolation(), we have to map'em
	    if ($interpolatorFactories.length) {
	      var eachInterpolationFactory = function (interpolatorFactory) {
	        var interpolator = $injector.get(interpolatorFactory);
	        // setting initial locale for each interpolation service
	        interpolator.setLocale($preferredLanguage || $uses);
	        // make'em recognizable through id
	        interpolatorHashMap[interpolator.getInterpolationIdentifier()] = interpolator;
	      };
	      eachInterpolationFactory.displayName = 'interpolationFactoryAdder';
	
	      angular.forEach($interpolatorFactories, eachInterpolationFactory);
	    }
	
	    /**
	     * @name getTranslationTable
	     * @private
	     *
	     * @description
	     * Returns a promise that resolves to the translation table
	     * or is rejected if an error occurred.
	     *
	     * @param langKey
	     * @returns {Q.promise}
	     */
	    var getTranslationTable = function (langKey) {
	      var deferred = $q.defer();
	      if (Object.prototype.hasOwnProperty.call($translationTable, langKey)) {
	        deferred.resolve($translationTable[langKey]);
	      } else if (langPromises[langKey]) {
	        var onResolve = function (data) {
	          translations(data.key, data.table);
	          deferred.resolve(data.table);
	        };
	        onResolve.displayName = 'translationTableResolver';
	        langPromises[langKey].then(onResolve, deferred.reject);
	      } else {
	        deferred.reject();
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslation
	     * @private
	     *
	     * @description
	     * Returns a promise that will resolve to the translation
	     * or be rejected if no translation was found for the language.
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {Q.promise}
	     */
	    var getFallbackTranslation = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      var onResolve = function (translationTable) {
	        if (Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	          Interpolator.setLocale(langKey);
	          var translation = translationTable[translationId];
	          if (translation.substr(0, 2) === '@:') {
	            getFallbackTranslation(langKey, translation.substr(2), interpolateParams, Interpolator, sanitizeStrategy)
	              .then(deferred.resolve, deferred.reject);
	          } else {
	            var interpolatedValue = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'service', sanitizeStrategy, translationId);
	            interpolatedValue = applyPostProcessing(translationId, translationTable[translationId], interpolatedValue, interpolateParams, langKey);
	
	            deferred.resolve(interpolatedValue);
	
	          }
	          Interpolator.setLocale($uses);
	        } else {
	          deferred.reject();
	        }
	      };
	      onResolve.displayName = 'fallbackTranslationResolver';
	
	      getTranslationTable(langKey).then(onResolve, deferred.reject);
	
	      return deferred.promise;
	    };
	
	    /**
	     * @name getFallbackTranslationInstant
	     * @private
	     *
	     * @description
	     * Returns a translation
	     * This function is currently only used for fallback language translation.
	     *
	     * @param langKey The language to translate to.
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns {string} translation
	     */
	    var getFallbackTranslationInstant = function (langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result, translationTable = $translationTable[langKey];
	
	      if (translationTable && Object.prototype.hasOwnProperty.call(translationTable, translationId) && translationTable[translationId] !== null) {
	        Interpolator.setLocale(langKey);
	        result = Interpolator.interpolate(translationTable[translationId], interpolateParams, 'filter', sanitizeStrategy, translationId);
	        result = applyPostProcessing(translationId, translationTable[translationId], result, interpolateParams, langKey, sanitizeStrategy);
	        // workaround for TrustedValueHolderType
	        if (!angular.isString(result) && angular.isFunction(result.$$unwrapTrustedValue)) {
	          var result2 = result.$$unwrapTrustedValue();
	          if (result2.substr(0, 2) === '@:') {
	            return getFallbackTranslationInstant(langKey, result2.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	          }
	        } else if (result.substr(0, 2) === '@:') {
	          return getFallbackTranslationInstant(langKey, result.substr(2), interpolateParams, Interpolator, sanitizeStrategy);
	        }
	        Interpolator.setLocale($uses);
	      }
	
	      return result;
	    };
	
	
	    /**
	     * @name translateByHandler
	     * @private
	     *
	     * Translate by missing translation handler.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param defaultTranslationText
	     * @param sanitizeStrategy sanitize strategy override
	     *
	     * @returns translation created by $missingTranslationHandler or translationId is $missingTranslationHandler is
	     * absent
	     */
	    var translateByHandler = function (translationId, interpolateParams, defaultTranslationText, sanitizeStrategy) {
	      // If we have a handler factory - we might also call it here to determine if it provides
	      // a default text for a translationid that can't be found anywhere in our tables
	      if ($missingTranslationHandlerFactory) {
	        return $injector.get($missingTranslationHandlerFactory)(translationId, $uses, interpolateParams, defaultTranslationText, sanitizeStrategy);
	      } else {
	        return translationId;
	      }
	    };
	
	    /**
	     * @name resolveForFallbackLanguage
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise that will resolve to the translation.
	     */
	    var resolveForFallbackLanguage = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      var deferred = $q.defer();
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        getFallbackTranslation(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy).then(
	          function (data) {
	            deferred.resolve(data);
	          },
	          function () {
	            // Look in the next fallback language for a translation.
	            // It delays the resolving by passing another promise to resolve.
	            return resolveForFallbackLanguage(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy).then(deferred.resolve, deferred.reject);
	          }
	        );
	      } else {
	        // No translation found in any fallback language
	        // if a default translation text is set in the directive, then return this as a result
	        if (defaultTranslationText) {
	          deferred.resolve(defaultTranslationText);
	        } else {
	          var missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	
	          // if no default translation is set and an error handler is defined, send it to the handler
	          // and then return the result if it isn't undefined
	          if ($missingTranslationHandlerFactory && missingTranslationHandlerTranslation) {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @name resolveForFallbackLanguageInstant
	     * @private
	     *
	     * Recursive helper function for fallbackTranslation that will sequentially look
	     * for a translation in the fallbackLanguages starting with fallbackLanguageIndex.
	     *
	     * @param fallbackLanguageIndex
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {string} translation
	     */
	    var resolveForFallbackLanguageInstant = function (fallbackLanguageIndex, translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      var result;
	
	      if (fallbackLanguageIndex < $fallbackLanguage.length) {
	        var langKey = $fallbackLanguage[fallbackLanguageIndex];
	        result = getFallbackTranslationInstant(langKey, translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        if (!result && result !== '') {
	          result = resolveForFallbackLanguageInstant(fallbackLanguageIndex + 1, translationId, interpolateParams, Interpolator);
	        }
	      }
	      return result;
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param defaultTranslationText
	     * @param sanitizeStrategy
	     * @returns {Q.promise} Promise, that resolves to the translation.
	     */
	    var fallbackTranslation = function (translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguage((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy);
	    };
	
	    /**
	     * Translates with the usage of the fallback languages.
	     *
	     * @param translationId
	     * @param interpolateParams
	     * @param Interpolator
	     * @param sanitizeStrategy
	     * @returns {String} translation
	     */
	    var fallbackTranslationInstant = function (translationId, interpolateParams, Interpolator, sanitizeStrategy) {
	      // Start with the fallbackLanguage with index 0
	      return resolveForFallbackLanguageInstant((startFallbackIteration > 0 ? startFallbackIteration : fallbackIndex), translationId, interpolateParams, Interpolator, sanitizeStrategy);
	    };
	
	    var determineTranslation = function (translationId, interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy) {
	
	      var deferred = $q.defer();
	
	      var table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = (interpolationId) ? interpolatorHashMap[interpolationId] : defaultInterpolator;
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	
	          $translate(translation.substr(2), interpolateParams, interpolationId, defaultTranslationText, uses, sanitizeStrategy)
	            .then(deferred.resolve, deferred.reject);
	        } else {
	          //
	          var resolvedTranslation = Interpolator.interpolate(translation, interpolateParams, 'service', sanitizeStrategy, translationId);
	          resolvedTranslation = applyPostProcessing(translationId, translation, resolvedTranslation, interpolateParams, uses);
	          deferred.resolve(resolvedTranslation);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, defaultTranslationText);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackTranslation(translationId, interpolateParams, Interpolator, defaultTranslationText, sanitizeStrategy)
	            .then(function (translation) {
	              deferred.resolve(translation);
	            }, function (_translationId) {
	              deferred.reject(applyNotFoundIndicators(_translationId));
	            });
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.resolve(missingTranslationHandlerTranslation);
	          }
	        } else {
	          if (defaultTranslationText) {
	            deferred.resolve(defaultTranslationText);
	          } else {
	            deferred.reject(applyNotFoundIndicators(translationId));
	          }
	        }
	      }
	      return deferred.promise;
	    };
	
	    var determineTranslationInstant = function (translationId, interpolateParams, interpolationId, uses, sanitizeStrategy) {
	
	      var result, table = uses ? $translationTable[uses] : $translationTable,
	        Interpolator = defaultInterpolator;
	
	      // if the interpolation id exists use custom interpolator
	      if (interpolatorHashMap && Object.prototype.hasOwnProperty.call(interpolatorHashMap, interpolationId)) {
	        Interpolator = interpolatorHashMap[interpolationId];
	      }
	
	      // if the translation id exists, we can just interpolate it
	      if (table && Object.prototype.hasOwnProperty.call(table, translationId) && table[translationId] !== null) {
	        var translation = table[translationId];
	
	        // If using link, rerun $translate with linked translationId and return it
	        if (translation.substr(0, 2) === '@:') {
	          result = determineTranslationInstant(translation.substr(2), interpolateParams, interpolationId, uses, sanitizeStrategy);
	        } else {
	          result = Interpolator.interpolate(translation, interpolateParams, 'filter', sanitizeStrategy, translationId);
	          result = applyPostProcessing(translationId, translation, result, interpolateParams, uses, sanitizeStrategy);
	        }
	      } else {
	        var missingTranslationHandlerTranslation;
	        // for logging purposes only (as in $translateMissingTranslationHandlerLog), value is not returned to promise
	        if ($missingTranslationHandlerFactory && !pendingLoader) {
	          missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	        }
	
	        // since we couldn't translate the inital requested translation id,
	        // we try it now with one or more fallback languages, if fallback language(s) is
	        // configured.
	        if (uses && $fallbackLanguage && $fallbackLanguage.length) {
	          fallbackIndex = 0;
	          result = fallbackTranslationInstant(translationId, interpolateParams, Interpolator, sanitizeStrategy);
	        } else if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          result = missingTranslationHandlerTranslation;
	        } else {
	          result = applyNotFoundIndicators(translationId);
	        }
	      }
	
	      return result;
	    };
	
	    var clearNextLangAndPromise = function (key) {
	      if ($nextLang === key) {
	        $nextLang = undefined;
	      }
	      langPromises[key] = undefined;
	    };
	
	    var applyPostProcessing = function (translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy) {
	      var fn = postProcessFn;
	
	      if (fn) {
	
	        if (typeof(fn) === 'string') {
	          // getting on-demand instance
	          fn = $injector.get(fn);
	        }
	        if (fn) {
	          return fn(translationId, translation, resolvedTranslation, interpolateParams, uses, sanitizeStrategy);
	        }
	      }
	
	      return resolvedTranslation;
	    };
	
	    var loadTranslationsIfMissing = function (key) {
	      if (!$translationTable[key] && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          return translation;
	        });
	      }
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#preferredLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the preferred language.
	     *
	     * @param {string} langKey language String or Array to be used as preferredLanguage (changing at runtime)
	     *
	     * @return {string} preferred language key
	     */
	    $translate.preferredLanguage = function (langKey) {
	      if (langKey) {
	        setupPreferredLanguage(langKey);
	      }
	      return $preferredLanguage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#cloakClassName
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured class name for `translate-cloak` directive.
	     *
	     * @return {string} cloakClassName
	     */
	    $translate.cloakClassName = function () {
	      return $cloakClassName;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#nestedObjectDelimeter
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the configured delimiter for nested namespaces.
	     *
	     * @return {string} nestedObjectDelimeter
	     */
	    $translate.nestedObjectDelimeter = function () {
	      return $nestedObjectDelimeter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#fallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key for the fallback languages or sets a new fallback stack.
	     * It is recommended to call this before {@link pascalprecht.translate.$translateProvider#preferredLanguage preferredLanguage()}.
	     *
	     * @param {string=} langKey language String or Array of fallback languages to be used (to change stack at runtime)
	     *
	     * @return {string||array} fallback language key
	     */
	    $translate.fallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        fallbackStack(langKey);
	
	        // as we might have an async loader initiated and a new translation language might have been defined
	        // we need to add the promise to the stack also. So - iterate.
	        if ($loaderFactory) {
	          if ($fallbackLanguage && $fallbackLanguage.length) {
	            for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	              if (!langPromises[$fallbackLanguage[i]]) {
	                langPromises[$fallbackLanguage[i]] = loadAsync($fallbackLanguage[i]);
	              }
	            }
	          }
	        }
	        $translate.use($translate.use());
	      }
	      if ($fallbackWasString) {
	        return $fallbackLanguage[0];
	      } else {
	        return $fallbackLanguage;
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#useFallbackLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Sets the first key of the fallback language stack to be used for translation.
	     * Therefore all languages in the fallback array BEFORE this key will be skipped!
	     *
	     * @param {string=} langKey Contains the langKey the iteration shall start with. Set to false if you want to
	     * get back to the whole stack
	     */
	    $translate.useFallbackLanguage = function (langKey) {
	      if (langKey !== undefined && langKey !== null) {
	        if (!langKey) {
	          startFallbackIteration = 0;
	        } else {
	          var langKeyPosition = indexOf($fallbackLanguage, langKey);
	          if (langKeyPosition > -1) {
	            startFallbackIteration = langKeyPosition;
	          }
	        }
	
	      }
	
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#proposedLanguage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the language key of language that is currently loaded asynchronously.
	     *
	     * @return {string} language key
	     */
	    $translate.proposedLanguage = function () {
	      return $nextLang;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storage
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns registered storage.
	     *
	     * @return {object} Storage
	     */
	    $translate.storage = function () {
	      return Storage;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#negotiateLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a language key based on available languages and language aliases. If a
	     * language key cannot be resolved, returns undefined.
	     *
	     * If no or a falsy key is given, returns undefined.
	     *
	     * @param {string} [key] Language key
	     * @return {string|undefined} Language key or undefined if no language key is found.
	     */
	    $translate.negotiateLocale = negotiateLocale;
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#use
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Tells angular-translate which language to use by given language key. This method is
	     * used to change language at runtime. It also takes care of storing the language
	     * key in a configured store to let your app remember the choosed language.
	     *
	     * When trying to 'use' a language which isn't available it tries to load it
	     * asynchronously with registered loaders.
	     *
	     * Returns promise object with loaded language file data or string of the currently used language.
	     *
	     * If no or a falsy key is given it returns the currently used language key.
	     * The returned string will be ```undefined``` if setting up $translate hasn't finished.
	     * @example
	     * $translate.use("en_US").then(function(data){
	       *   $scope.text = $translate("HELLO");
	       * });
	     *
	     * @param {string=} key Language key
	     * @return {object|string} Promise with loaded language data or the language key if a falsy param was given.
	     */
	    $translate.use = function (key) {
	      if (!key) {
	        return $uses;
	      }
	
	      var deferred = $q.defer();
	      deferred.promise.then(null, angular.noop); // AJS "Possibly unhandled rejection"
	
	      $rootScope.$emit('$translateChangeStart', {language : key});
	
	      // Try to get the aliased language key
	      var aliasedKey = negotiateLocale(key);
	      // Ensure only registered language keys will be loaded
	      if ($availableLanguageKeys.length > 0 && !aliasedKey) {
	        return $q.reject(key);
	      }
	
	      if (aliasedKey) {
	        key = aliasedKey;
	      }
	
	      // if there isn't a translation table for the language we've requested,
	      // we load it asynchronously
	      $nextLang = key;
	      if (($forceAsyncReloadEnabled || !$translationTable[key]) && $loaderFactory && !langPromises[key]) {
	        langPromises[key] = loadAsync(key).then(function (translation) {
	          translations(translation.key, translation.table);
	          deferred.resolve(translation.key);
	          if ($nextLang === key) {
	            useLanguage(translation.key);
	          }
	          return translation;
	        }, function (key) {
	          $rootScope.$emit('$translateChangeError', {language : key});
	          deferred.reject(key);
	          $rootScope.$emit('$translateChangeEnd', {language : key});
	          return $q.reject(key);
	        });
	        langPromises[key]['finally'](function () {
	          clearNextLangAndPromise(key);
	        })['catch'](angular.noop); // we don't care about errors (clearing)
	      } else if (langPromises[key]) {
	        // we are already loading this asynchronously
	        // resolve our new deferred when the old langPromise is resolved
	        langPromises[key].then(function (translation) {
	          if ($nextLang === translation.key) {
	            useLanguage(translation.key);
	          }
	          deferred.resolve(translation.key);
	          return translation;
	        }, function (key) {
	          // find first available fallback language if that request has failed
	          if (!$uses && $fallbackLanguage && $fallbackLanguage.length > 0 && $fallbackLanguage[0] !== key) {
	            return $translate.use($fallbackLanguage[0]).then(deferred.resolve, deferred.reject);
	          } else {
	            return deferred.reject(key);
	          }
	        });
	      } else {
	        deferred.resolve(key);
	        useLanguage(key);
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#resolveClientLocale
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This returns the current browser/client's language key. The result is processed with the configured uniform tag resolver.
	     *
	     * @returns {string} the current client/browser language key
	     */
	    $translate.resolveClientLocale = function () {
	      return getLocale();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#storageKey
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the key for the storage.
	     *
	     * @return {string} storage key
	     */
	    $translate.storageKey = function () {
	      return storageKey();
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isPostCompilingEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether post compiling is enabled or not
	     *
	     * @return {bool} storage key
	     */
	    $translate.isPostCompilingEnabled = function () {
	      return $postCompilingEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isForceAsyncReloadEnabled
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether force async reload is enabled or not
	     *
	     * @return {boolean} forceAsyncReload value
	     */
	    $translate.isForceAsyncReloadEnabled = function () {
	      return $forceAsyncReloadEnabled;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isKeepContent
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether keepContent or not
	     *
	     * @return {boolean} keepContent value
	     */
	    $translate.isKeepContent = function () {
	      return $keepContent;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#refresh
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Refreshes a translation table pointed by the given langKey. If langKey is not specified,
	     * the module will drop all existent translation tables and load new version of those which
	     * are currently in use.
	     *
	     * Refresh means that the module will drop target translation table and try to load it again.
	     *
	     * In case there are no loaders registered the refresh() method will throw an Error.
	     *
	     * If the module is able to refresh translation tables refresh() method will broadcast
	     * $translateRefreshStart and $translateRefreshEnd events.
	     *
	     * @example
	     * // this will drop all currently existent translation tables and reload those which are
	     * // currently in use
	     * $translate.refresh();
	     * // this will refresh a translation table for the en_US language
	     * $translate.refresh('en_US');
	     *
	     * @param {string} langKey A language key of the table, which has to be refreshed
	     *
	     * @return {promise} Promise, which will be resolved in case a translation tables refreshing
	     * process is finished successfully, and reject if not.
	     */
	    $translate.refresh = function (langKey) {
	      if (!$loaderFactory) {
	        throw new Error('Couldn\'t refresh translation table, no loader registered!');
	      }
	
	      $rootScope.$emit('$translateRefreshStart', {language : langKey});
	
	      var deferred = $q.defer(), updatedLanguages = {};
	
	      //private helper
	      function loadNewData(languageKey) {
	        var promise = loadAsync(languageKey);
	        //update the load promise cache for this language
	        langPromises[languageKey] = promise;
	        //register a data handler for the promise
	        promise.then(function (data) {
	            //clear the cache for this language
	            $translationTable[languageKey] = {};
	            //add the new data for this language
	            translations(languageKey, data.table);
	            //track that we updated this language
	            updatedLanguages[languageKey] = true;
	          },
	          //handle rejection to appease the $q validation
	          angular.noop);
	        return promise;
	      }
	
	      //set up post-processing
	      deferred.promise.then(
	        function () {
	          for (var key in $translationTable) {
	            if ($translationTable.hasOwnProperty(key)) {
	              //delete cache entries that were not updated
	              if (!(key in updatedLanguages)) {
	                delete $translationTable[key];
	              }
	            }
	          }
	          if ($uses) {
	            useLanguage($uses);
	          }
	        },
	        //handle rejection to appease the $q validation
	        angular.noop
	      )['finally'](
	        function () {
	          $rootScope.$emit('$translateRefreshEnd', {language : langKey});
	        }
	      );
	
	      if (!langKey) {
	        // if there's no language key specified we refresh ALL THE THINGS!
	        var languagesToReload = $fallbackLanguage && $fallbackLanguage.slice() || [];
	        if ($uses && languagesToReload.indexOf($uses) === -1) {
	          languagesToReload.push($uses);
	        }
	        $q.all(languagesToReload.map(loadNewData)).then(deferred.resolve, deferred.reject);
	
	      } else if ($translationTable[langKey]) {
	        //just refresh the specified language cache
	        loadNewData(langKey).then(deferred.resolve, deferred.reject);
	
	      } else {
	        deferred.reject();
	      }
	
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#instant
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns a translation instantly from the internal state of loaded translation. All rules
	     * regarding the current language, the preferred language of even fallback languages will be
	     * used except any promise handling. If a language was not found, an asynchronous loading
	     * will be invoked in the background.
	     *
	     * @param {string|array} translationId A token which represents a translation id
	     *                                     This can be optionally an array of translation ids which
	     *                                     results that the function's promise returns an object where
	     *                                     each key is the translation id and the value the translation.
	     * @param {object=} [interpolateParams={}] Params
	     * @param {string=} [interpolationId=undefined] The id of the interpolation to use (use default unless set via useInterpolation())
	     * @param {string=} [forceLanguage=false] A language to be used instead of the current language
	     * @param {string=} [sanitizeStrategy=undefined] force sanitize strategy for this call instead of using the configured one (use default unless set)
	     *
	     * @return {string|object} translation
	     */
	    $translate.instant = function (translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
	
	      // we don't want to re-negotiate $uses
	      var uses = (forceLanguage && forceLanguage !== $uses) ? // we don't want to re-negotiate $uses
	        (negotiateLocale(forceLanguage) || forceLanguage) : $uses;
	
	      // Detect undefined and null values to shorten the execution and prevent exceptions
	      if (translationId === null || angular.isUndefined(translationId)) {
	        return translationId;
	      }
	
	      // Check forceLanguage is present
	      if (forceLanguage) {
	        loadTranslationsIfMissing(forceLanguage);
	      }
	
	      // Duck detection: If the first argument is an array, a bunch of translations was requested.
	      // The result is an object.
	      if (angular.isArray(translationId)) {
	        var results = {};
	        for (var i = 0, c = translationId.length; i < c; i++) {
	          results[translationId[i]] = $translate.instant(translationId[i], interpolateParams, interpolationId, forceLanguage, sanitizeStrategy);
	        }
	        return results;
	      }
	
	      // We discarded unacceptable values. So we just need to verify if translationId is empty String
	      if (angular.isString(translationId) && translationId.length < 1) {
	        return translationId;
	      }
	
	      // trim off any whitespace
	      if (translationId) {
	        translationId = trim.apply(translationId);
	      }
	
	      var result, possibleLangKeys = [];
	      if ($preferredLanguage) {
	        possibleLangKeys.push($preferredLanguage);
	      }
	      if (uses) {
	        possibleLangKeys.push(uses);
	      }
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        possibleLangKeys = possibleLangKeys.concat($fallbackLanguage);
	      }
	      for (var j = 0, d = possibleLangKeys.length; j < d; j++) {
	        var possibleLangKey = possibleLangKeys[j];
	        if ($translationTable[possibleLangKey]) {
	          if (typeof $translationTable[possibleLangKey][translationId] !== 'undefined') {
	            result = determineTranslationInstant(translationId, interpolateParams, interpolationId, uses, sanitizeStrategy);
	          }
	        }
	        if (typeof result !== 'undefined') {
	          break;
	        }
	      }
	
	      if (!result && result !== '') {
	        if ($notFoundIndicatorLeft || $notFoundIndicatorRight) {
	          result = applyNotFoundIndicators(translationId);
	        } else {
	          // Return translation of default interpolator if not found anything.
	          result = defaultInterpolator.interpolate(translationId, interpolateParams, 'filter', sanitizeStrategy);
	
	          // looks like the requested translation id doesn't exists.
	          // Now, if there is a registered handler for missing translations and no
	          // asyncLoader is pending, we execute the handler
	          var missingTranslationHandlerTranslation;
	          if ($missingTranslationHandlerFactory && !pendingLoader) {
	            missingTranslationHandlerTranslation = translateByHandler(translationId, interpolateParams, sanitizeStrategy);
	          }
	
	          if ($missingTranslationHandlerFactory && !pendingLoader && missingTranslationHandlerTranslation) {
	            result = missingTranslationHandlerTranslation;
	          }
	        }
	      }
	
	      return result;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#versionInfo
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the current version information for the angular-translate library
	     *
	     * @return {string} angular-translate version
	     */
	    $translate.versionInfo = function () {
	      return version;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#loaderCache
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns the defined loaderCache.
	     *
	     * @return {boolean|string|object} current value of loaderCache
	     */
	    $translate.loaderCache = function () {
	      return loaderCache;
	    };
	
	    // internal purpose only
	    $translate.directivePriority = function () {
	      return directivePriority;
	    };
	
	    // internal purpose only
	    $translate.statefulFilter = function () {
	      return statefulFilter;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#isReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns whether the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_onReady onReady()}.
	     *
	     * @return {boolean} current value of ready
	     */
	    $translate.isReady = function () {
	      return $isReady;
	    };
	
	    var $onReadyDeferred = $q.defer();
	    $onReadyDeferred.promise.then(function () {
	      $isReady = true;
	    });
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#onReady
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Calls the function provided or resolved the returned promise after the service is "ready" to translate (i.e. loading 1st language).
	     *
	     * See also {@link pascalprecht.translate.$translate#methods_isReady isReady()}.
	     *
	     * @param {Function=} fn Function to invoke when service is ready
	     * @return {object} Promise resolved when service is ready
	     */
	    $translate.onReady = function (fn) {
	      var deferred = $q.defer();
	      if (angular.isFunction(fn)) {
	        deferred.promise.then(fn);
	      }
	      if ($isReady) {
	        deferred.resolve();
	      } else {
	        $onReadyDeferred.promise.then(deferred.resolve);
	      }
	      return deferred.promise;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getAvailableLanguageKeys
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * This function simply returns the registered language keys being defined before in the config phase
	     * With this, an application can use the array to provide a language selection dropdown or similar
	     * without any additional effort
	     *
	     * @returns {object} returns the list of possibly registered language keys and mapping or null if not defined
	     */
	    $translate.getAvailableLanguageKeys = function () {
	      if ($availableLanguageKeys.length > 0) {
	        return $availableLanguageKeys;
	      }
	      return null;
	    };
	
	    /**
	     * @ngdoc function
	     * @name pascalprecht.translate.$translate#getTranslationTable
	     * @methodOf pascalprecht.translate.$translate
	     *
	     * @description
	     * Returns translation table by the given language key.
	     *
	     * Unless a language is provided it returns a translation table of the current one.
	     * Note: If translation dictionary is currently downloading or in progress
	     * it will return null.
	     *
	     * @param {string} langKey A token which represents a translation id
	     *
	     * @return {object} a copy of angular-translate $translationTable
	     */
	    $translate.getTranslationTable = function (langKey) {
	      langKey = langKey || $translate.use();
	      if (langKey && $translationTable[langKey]) {
	        return angular.copy($translationTable[langKey]);
	      }
	      return null;
	    };
	
	    // Whenever $translateReady is being fired, this will ensure the state of $isReady
	    var globalOnReadyListener = $rootScope.$on('$translateReady', function () {
	      $onReadyDeferred.resolve();
	      globalOnReadyListener(); // one time only
	      globalOnReadyListener = null;
	    });
	    var globalOnChangeListener = $rootScope.$on('$translateChangeEnd', function () {
	      $onReadyDeferred.resolve();
	      globalOnChangeListener(); // one time only
	      globalOnChangeListener = null;
	    });
	
	    if ($loaderFactory) {
	
	      // If at least one async loader is defined and there are no
	      // (default) translations available we should try to load them.
	      if (angular.equals($translationTable, {})) {
	        if ($translate.use()) {
	          $translate.use($translate.use());
	        }
	      }
	
	      // Also, if there are any fallback language registered, we start
	      // loading them asynchronously as soon as we can.
	      if ($fallbackLanguage && $fallbackLanguage.length) {
	        var processAsyncResult = function (translation) {
	          translations(translation.key, translation.table);
	          $rootScope.$emit('$translateChangeEnd', {language : translation.key});
	          return translation;
	        };
	        for (var i = 0, len = $fallbackLanguage.length; i < len; i++) {
	          var fallbackLanguageId = $fallbackLanguage[i];
	          if ($forceAsyncReloadEnabled || !$translationTable[fallbackLanguageId]) {
	            langPromises[fallbackLanguageId] = loadAsync(fallbackLanguageId).then(processAsyncResult);
	          }
	        }
	      }
	    } else {
	      $rootScope.$emit('$translateReady', {language : $translate.use()});
	    }
	
	    return $translate;
	  }];
	}
	
	$translate.displayName = 'displayName';
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translateDefaultInterpolation
	 * @requires $interpolate
	 *
	 * @description
	 * Uses angular's `$interpolate` services to interpolate strings against some values.
	 *
	 * Be aware to configure a proper sanitization strategy.
	 *
	 * See also:
	 * * {@link pascalprecht.translate.$translateSanitization}
	 *
	 * @return {object} $translateDefaultInterpolation Interpolator service
	 */
	angular.module('pascalprecht.translate').factory('$translateDefaultInterpolation', $translateDefaultInterpolation);
	
	function $translateDefaultInterpolation ($interpolate, $translateSanitization) {
	
	  'use strict';
	
	  var $translateInterpolator = {},
	      $locale,
	      $identifier = 'default';
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#setLocale
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Sets current locale (this is currently not use in this interpolation).
	   *
	   * @param {string} locale Language key or locale.
	   */
	  $translateInterpolator.setLocale = function (locale) {
	    $locale = locale;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#getInterpolationIdentifier
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Returns an identifier for this interpolation service.
	   *
	   * @returns {string} $identifier
	   */
	  $translateInterpolator.getInterpolationIdentifier = function () {
	    return $identifier;
	  };
	
	  /**
	   * @deprecated will be removed in 3.0
	   * @see {@link pascalprecht.translate.$translateSanitization}
	   */
	  $translateInterpolator.useSanitizeValueStrategy = function (value) {
	    $translateSanitization.useStrategy(value);
	    return this;
	  };
	
	  /**
	   * @ngdoc function
	   * @name pascalprecht.translate.$translateDefaultInterpolation#interpolate
	   * @methodOf pascalprecht.translate.$translateDefaultInterpolation
	   *
	   * @description
	   * Interpolates given value agains given interpolate params using angulars
	   * `$interpolate` service.
	   *
	   * Since AngularJS 1.5, `value` must not be a string but can be anything input.
	   *
	   * @param {string} value translation
	   * @param {object} [interpolationParams={}] interpolation params
	   * @param {string} [context=undefined] current context (filter, directive, service)
	   * @param {string} [sanitizeStrategy=undefined] sanitize strategy (use default unless set)
	   * @param {string} translationId current translationId
	   *
	   * @returns {string} interpolated string
	   */
	  $translateInterpolator.interpolate = function (value, interpolationParams, context, sanitizeStrategy, translationId) { // jshint ignore:line
	    interpolationParams = interpolationParams || {};
	    interpolationParams = $translateSanitization.sanitize(interpolationParams, 'params', sanitizeStrategy, context);
	
	    var interpolatedText;
	    if (angular.isNumber(value)) {
	      // numbers are safe
	      interpolatedText = '' + value;
	    } else if (angular.isString(value)) {
	      // strings must be interpolated (that's the job here)
	      interpolatedText = $interpolate(value)(interpolationParams);
	      interpolatedText = $translateSanitization.sanitize(interpolatedText, 'text', sanitizeStrategy, context);
	    } else {
	      // neither a number or a string, cant interpolate => empty string
	      interpolatedText = '';
	    }
	
	    return interpolatedText;
	  };
	
	  return $translateInterpolator;
	}
	
	$translateDefaultInterpolation.displayName = '$translateDefaultInterpolation';
	
	angular.module('pascalprecht.translate').constant('$STORAGE_KEY', 'NG_TRANSLATE_LANG_KEY');
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate
	 * @requires $interpolate,
	 * @requires $compile,
	 * @requires $parse,
	 * @requires $rootScope
	 * @restrict AE
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses $translate service to translate the translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate Translation id which could be either string or interpolated string.
	 * @param {string=} translate-values Values to pass into translation id. Can be passed as object literal string or interpolated object.
	 * @param {string=} translate-attr-ATTR translate Translation id and put it into ATTR attribute.
	 * @param {string=} translate-default will be used unless translation was successful
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 * @param {boolean=} translate-compile (default true if present) defines locally activation of {@link pascalprecht.translate.$translateProvider#methods_usePostCompiling}
	 * @param {boolean=} translate-keep-content (default true if present) defines that in case a KEY could not be translated, that the existing content is left in the innerHTML}
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre translate="TRANSLATION_ID"></pre>
	        <pre translate>TRANSLATION_ID</pre>
	        <pre translate translate-attr-title="TRANSLATION_ID"></pre>
	        <pre translate="{{translationId}}"></pre>
	        <pre translate>{{translationId}}</pre>
	        <pre translate="WITH_VALUES" translate-values="{value: 5}"></pre>
	        <pre translate translate-values="{value: 5}">WITH_VALUES</pre>
	        <pre translate="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate translate-values="{{values}}">WITH_VALUES</pre>
	        <pre translate translate-attr-title="WITH_VALUES" translate-values="{{values}}"></pre>
	        <pre translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hi"></pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	          'WITH_CAMEL_CASE_KEY': 'The interpolation key is camel cased: {{camelCaseKey}}'
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<p translate="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate="{{translationId}}"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>TRANSLATION_ID</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate>{{translationId}}</p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('Hello there!');
	
	          element = $compile('<p translate translate-attr-title="TRANSLATION_ID"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('title')).toBe('Hello there!');
	
	          element = $compile('<p translate="WITH_CAMEL_CASE_KEY" translate-value-camel-case-key="Hello"></p>')($rootScope);
	          $rootScope.$digest();
	          expect(element.text()).toBe('The interpolation key is camel cased: Hello');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translate', translateDirective);
	function translateDirective($translate, $interpolate, $compile, $parse, $rootScope) {
	
	  'use strict';
	
	  /**
	   * @name trim
	   * @private
	   *
	   * @description
	   * trim polyfill
	   *
	   * @returns {string} The string stripped of whitespace from both ends
	   */
	  var trim = function() {
	    return this.toString().replace(/^\s+|\s+$/g, '');
	  };
	
	  /**
	   * @name lowercase
	   * @private
	   *
	   * @description
	   * Return the lowercase string only if the type is string
	   *
	   * @returns {string} The string all in lowercase
	   */
	  var lowercase = function (string) {
	    return angular.isString(string) ? string.toLowerCase() : string;
	  };
	
	  return {
	    restrict: 'AE',
	    scope: true,
	    priority: $translate.directivePriority(),
	    compile: function (tElement, tAttr) {
	
	      var translateValuesExist = (tAttr.translateValues) ?
	        tAttr.translateValues : undefined;
	
	      var translateInterpolation = (tAttr.translateInterpolation) ?
	        tAttr.translateInterpolation : undefined;
	
	      var translateSanitizeStrategyExist = (tAttr.translateSanitizeStrategy) ?
	        tAttr.translateSanitizeStrategy : undefined;
	
	      var translateValueExist = tElement[0].outerHTML.match(/translate-value-+/i);
	
	      var interpolateRegExp = '^(.*)(' + $interpolate.startSymbol() + '.*' + $interpolate.endSymbol() + ')(.*)',
	          watcherRegExp = '^(.*)' + $interpolate.startSymbol() + '(.*)' + $interpolate.endSymbol() + '(.*)';
	
	      return function linkFn(scope, iElement, iAttr) {
	
	        scope.interpolateParams = {};
	        scope.preText = '';
	        scope.postText = '';
	        scope.translateNamespace = getTranslateNamespace(scope);
	        var translationIds = {};
	
	        var initInterpolationParams = function (interpolateParams, iAttr, tAttr) {
	          // initial setup
	          if (iAttr.translateValues) {
	            angular.extend(interpolateParams, $parse(iAttr.translateValues)(scope.$parent));
	          }
	          // initially fetch all attributes if existing and fill the params
	          if (translateValueExist) {
	            for (var attr in tAttr) {
	              if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	                var attributeName = lowercase(attr.substr(14, 1)) + attr.substr(15);
	                interpolateParams[attributeName] = tAttr[attr];
	              }
	            }
	          }
	        };
	
	        // Ensures any change of the attribute "translate" containing the id will
	        // be re-stored to the scope's "translationId".
	        // If the attribute has no content, the element's text value (white spaces trimmed off) will be used.
	        var observeElementTranslation = function (translationId) {
	
	          // Remove any old watcher
	          if (angular.isFunction(observeElementTranslation._unwatchOld)) {
	            observeElementTranslation._unwatchOld();
	            observeElementTranslation._unwatchOld = undefined;
	          }
	
	          if (angular.equals(translationId , '') || !angular.isDefined(translationId)) {
	            var iElementText = trim.apply(iElement.text());
	
	            // Resolve translation id by inner html if required
	            var interpolateMatches = iElementText.match(interpolateRegExp);
	            // Interpolate translation id if required
	            if (angular.isArray(interpolateMatches)) {
	              scope.preText = interpolateMatches[1];
	              scope.postText = interpolateMatches[3];
	              translationIds.translate = $interpolate(interpolateMatches[2])(scope.$parent);
	              var watcherMatches = iElementText.match(watcherRegExp);
	              if (angular.isArray(watcherMatches) && watcherMatches[2] && watcherMatches[2].length) {
	                observeElementTranslation._unwatchOld = scope.$watch(watcherMatches[2], function (newValue) {
	                  translationIds.translate = newValue;
	                  updateTranslations();
	                });
	              }
	            } else {
	              // do not assigne the translation id if it is empty.
	              translationIds.translate = !iElementText ? undefined : iElementText;
	            }
	          } else {
	            translationIds.translate = translationId;
	          }
	          updateTranslations();
	        };
	
	        var observeAttributeTranslation = function (translateAttr) {
	          iAttr.$observe(translateAttr, function (translationId) {
	            translationIds[translateAttr] = translationId;
	            updateTranslations();
	          });
	        };
	
	        // initial setup with values
	        initInterpolationParams(scope.interpolateParams, iAttr, tAttr);
	
	        var firstAttributeChangedEvent = true;
	        iAttr.$observe('translate', function (translationId) {
	          if (typeof translationId === 'undefined') {
	            // case of element "<translate>xyz</translate>"
	            observeElementTranslation('');
	          } else {
	            // case of regular attribute
	            if (translationId !== '' || !firstAttributeChangedEvent) {
	              translationIds.translate = translationId;
	              updateTranslations();
	            }
	          }
	          firstAttributeChangedEvent = false;
	        });
	
	        for (var translateAttr in iAttr) {
	          if (iAttr.hasOwnProperty(translateAttr) && translateAttr.substr(0, 13) === 'translateAttr' && translateAttr.length > 13) {
	            observeAttributeTranslation(translateAttr);
	          }
	        }
	
	        iAttr.$observe('translateDefault', function (value) {
	          scope.defaultText = value;
	          updateTranslations();
	        });
	
	        if (translateSanitizeStrategyExist) {
	          iAttr.$observe('translateSanitizeStrategy', function (value) {
	            scope.sanitizeStrategy = $parse(value)(scope.$parent);
	            updateTranslations();
	          });
	        }
	
	        if (translateValuesExist) {
	          iAttr.$observe('translateValues', function (interpolateParams) {
	            if (interpolateParams) {
	              scope.$parent.$watch(function () {
	                angular.extend(scope.interpolateParams, $parse(interpolateParams)(scope.$parent));
	              });
	            }
	          });
	        }
	
	        if (translateValueExist) {
	          var observeValueAttribute = function (attrName) {
	            iAttr.$observe(attrName, function (value) {
	              var attributeName = lowercase(attrName.substr(14, 1)) + attrName.substr(15);
	              scope.interpolateParams[attributeName] = value;
	            });
	          };
	          for (var attr in iAttr) {
	            if (Object.prototype.hasOwnProperty.call(iAttr, attr) && attr.substr(0, 14) === 'translateValue' && attr !== 'translateValues') {
	              observeValueAttribute(attr);
	            }
	          }
	        }
	
	        // Master update function
	        var updateTranslations = function () {
	          for (var key in translationIds) {
	            if (translationIds.hasOwnProperty(key) && translationIds[key] !== undefined) {
	              updateTranslation(key, translationIds[key], scope, scope.interpolateParams, scope.defaultText, scope.translateNamespace);
	            }
	          }
	        };
	
	        // Put translation processing function outside loop
	        var updateTranslation = function(translateAttr, translationId, scope, interpolateParams, defaultTranslationText, translateNamespace) {
	          if (translationId) {
	            // if translation id starts with '.' and translateNamespace given, prepend namespace
	            if (translateNamespace && translationId.charAt(0) === '.') {
	              translationId = translateNamespace + translationId;
	            }
	
	            $translate(translationId, interpolateParams, translateInterpolation, defaultTranslationText, scope.translateLanguage, scope.sanitizeStrategy)
	              .then(function (translation) {
	                applyTranslation(translation, scope, true, translateAttr);
	              }, function (translationId) {
	                applyTranslation(translationId, scope, false, translateAttr);
	              });
	          } else {
	            // as an empty string cannot be translated, we can solve this using successful=false
	            applyTranslation(translationId, scope, false, translateAttr);
	          }
	        };
	
	        var applyTranslation = function (value, scope, successful, translateAttr) {
	          if (!successful) {
	            if (typeof scope.defaultText !== 'undefined') {
	              value = scope.defaultText;
	            }
	          }
	          if (translateAttr === 'translate') {
	            // default translate into innerHTML
	            if (successful || (!successful && !$translate.isKeepContent() && typeof iAttr.translateKeepContent === 'undefined')) {
	              iElement.empty().append(scope.preText + value + scope.postText);
	            }
	            var globallyEnabled = $translate.isPostCompilingEnabled();
	            var locallyDefined = typeof tAttr.translateCompile !== 'undefined';
	            var locallyEnabled = locallyDefined && tAttr.translateCompile !== 'false';
	            if ((globallyEnabled && !locallyDefined) || locallyEnabled) {
	              $compile(iElement.contents())(scope);
	            }
	          } else {
	            // translate attribute
	            var attributeName = iAttr.$attr[translateAttr];
	            if (attributeName.substr(0, 5) === 'data-') {
	              // ensure html5 data prefix is stripped
	              attributeName = attributeName.substr(5);
	            }
	            attributeName = attributeName.substr(15);
	            iElement.attr(attributeName, value);
	          }
	        };
	
	        if (translateValuesExist || translateValueExist || iAttr.translateDefault) {
	          scope.$watch('interpolateParams', updateTranslations, true);
	        }
	
	        // Replaced watcher on translateLanguage with event listener
	        scope.$on('translateLanguageChanged', updateTranslations);
	
	        // Ensures the text will be refreshed after the current language was changed
	        // w/ $translate.use(...)
	        var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	        // ensure translation will be looked up at least one
	        if (iElement.text().length) {
	          if (iAttr.translate) {
	            observeElementTranslation(iAttr.translate);
	          } else {
	            observeElementTranslation('');
	          }
	        } else if (iAttr.translate) {
	          // ensure attribute will be not skipped
	          observeElementTranslation(iAttr.translate);
	        }
	        updateTranslations();
	        scope.$on('$destroy', unbind);
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateDirective.displayName = 'translateDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translate-attr
	 * @restrict A
	 *
	 * @description
	 * Translates attributes like translate-attr-ATTR, but with an object like ng-class.
	 * Internally it uses `translate` service to translate translation id. It possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate-attr Object literal mapping attributes to translation ids.
	 * @param {string=} translate-values Values to pass into the translation ids. Can be passed as object literal string.
	 * @param {string=} translate-sanitize-strategy defines locally sanitize strategy
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{value: 5}" />
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}',
	        }).preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	    <file name="scenario.js">
	      it('should translate', function () {
	        inject(function ($rootScope, $compile) {
	          $rootScope.translationId = 'TRANSLATION_ID';
	
	          element = $compile('<input translate-attr="{ placeholder: translationId, title: 'WITH_VALUES' }" translate-values="{ value: 5 }" />')($rootScope);
	          $rootScope.$digest();
	          expect(element.attr('placeholder)).toBe('Hello there!');
	          expect(element.attr('title)).toBe('The following value is dynamic: 5');
	        });
	      });
	    </file>
	   </example>
	 */
	.directive('translateAttr', translateAttrDirective);
	function translateAttrDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    priority: $translate.directivePriority(),
	    link: function linkFn(scope, element, attr) {
	
	      var translateAttr,
	          translateValues,
	          translateSanitizeStrategy,
	          previousAttributes = {};
	
	      // Main update translations function
	      var updateTranslations = function () {
	        angular.forEach(translateAttr, function (translationId, attributeName) {
	          if (!translationId) {
	            return;
	          }
	          previousAttributes[attributeName] = true;
	
	          // if translation id starts with '.' and translateNamespace given, prepend namespace
	          if (scope.translateNamespace && translationId.charAt(0) === '.') {
	            translationId = scope.translateNamespace + translationId;
	          }
	          $translate(translationId, translateValues, attr.translateInterpolation, undefined, scope.translateLanguage, translateSanitizeStrategy)
	            .then(function (translation) {
	              element.attr(attributeName, translation);
	            }, function (translationId) {
	              element.attr(attributeName, translationId);
	            });
	        });
	
	        // Removing unused attributes that were previously used
	        angular.forEach(previousAttributes, function (flag, attributeName) {
	          if (!translateAttr[attributeName]) {
	            element.removeAttr(attributeName);
	            delete previousAttributes[attributeName];
	          }
	        });
	      };
	
	      // Watch for attribute changes
	      watchAttribute(
	        scope,
	        attr.translateAttr,
	        function (newValue) { translateAttr = newValue; },
	        updateTranslations
	      );
	      // Watch for value changes
	      watchAttribute(
	        scope,
	        attr.translateValues,
	        function (newValue) { translateValues = newValue; },
	        updateTranslations
	      );
	      // Watch for sanitize strategy changes
	      watchAttribute(
	        scope,
	        attr.translateSanitizeStrategy,
	        function (newValue) { translateSanitizeStrategy = newValue; },
	        updateTranslations
	      );
	
	      if (attr.translateValues) {
	        scope.$watch(attr.translateValues, updateTranslations, true);
	      }
	
	      // Replaced watcher on translateLanguage with event listener
	      scope.$on('translateLanguageChanged', updateTranslations);
	
	      // Ensures the text will be refreshed after the current language was changed
	      // w/ $translate.use(...)
	      var unbind = $rootScope.$on('$translateChangeSuccess', updateTranslations);
	
	      updateTranslations();
	      scope.$on('$destroy', unbind);
	    }
	  };
	}
	
	function watchAttribute(scope, attribute, valueCallback, changeCallback) {
	  'use strict';
	  if (!attribute) {
	    return;
	  }
	  if (attribute.substr(0, 2) === '::') {
	    attribute = attribute.substr(2);
	  } else {
	    scope.$watch(attribute, function(newValue) {
	      valueCallback(newValue);
	      changeCallback();
	    }, true);
	  }
	  valueCallback(scope.$eval(attribute));
	}
	
	translateAttrDirective.displayName = 'translateAttrDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateCloak
	 * @requires $translate
	 * @restrict A
	 *
	 * $description
	 * Adds a `translate-cloak` class name to the given element where this directive
	 * is applied initially and removes it, once a loader has finished loading.
	 *
	 * This directive can be used to prevent initial flickering when loading translation
	 * data asynchronously.
	 *
	 * The class name is defined in
	 * {@link pascalprecht.translate.$translateProvider#cloakClassName $translate.cloakClassName()}.
	 *
	 * @param {string=} translate-cloak If a translationId is provided, it will be used for showing
	 *                                  or hiding the cloak. Basically it relies on the translation
	 *                                  resolve.
	 */
	.directive('translateCloak', translateCloakDirective);
	
	function translateCloakDirective($translate, $rootScope) {
	
	  'use strict';
	
	  return {
	    compile : function (tElement) {
	      var applyCloak = function (element) {
	          element.addClass($translate.cloakClassName());
	        },
	        removeCloak = function (element) {
	          element.removeClass($translate.cloakClassName());
	        };
	      applyCloak(tElement);
	
	      return function linkFn(scope, iElement, iAttr) {
	        //Create bound functions that incorporate the active DOM element.
	        var iRemoveCloak = removeCloak.bind(this, iElement), iApplyCloak = applyCloak.bind(this, iElement);
	        if (iAttr.translateCloak && iAttr.translateCloak.length) {
	          // Register a watcher for the defined translation allowing a fine tuned cloak
	          iAttr.$observe('translateCloak', function (translationId) {
	            $translate(translationId).then(iRemoveCloak, iApplyCloak);
	          });
	          $rootScope.$on('$translateChangeSuccess', function () {
	            $translate(iAttr.translateCloak).then(iRemoveCloak, iApplyCloak);
	          });
	        } else {
	          $translate.onReady(iRemoveCloak);
	        }
	      };
	    }
	  };
	}
	
	translateCloakDirective.displayName = 'translateCloakDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateNamespace
	 * @restrict A
	 *
	 * @description
	 * Translates given translation id either through attribute or DOM content.
	 * Internally it uses `translate` filter to translate translation id. It is possible to
	 * pass an optional `translate-values` object literal as string into translation id.
	 *
	 * @param {string=} translate namespace name which could be either string or interpolated string.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div translate-namespace="CONTENT">
	
	        <div>
	            <h1 translate>.HEADERS.TITLE</h1>
	            <h1 translate>.HEADERS.WELCOME</h1>
	        </div>
	
	        <div translate-namespace=".HEADERS">
	            <h1 translate>.TITLE</h1>
	            <h1 translate>.WELCOME</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en',{
	          'TRANSLATION_ID': 'Hello there!',
	          'CONTENT': {
	            'HEADERS': {
	                TITLE: 'Title'
	            }
	          },
	          'CONTENT.HEADERS.WELCOME': 'Welcome'
	        }).preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateNamespace', translateNamespaceDirective);
	
	function translateNamespaceDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return {
	        pre: function (scope, iElement, iAttrs) {
	          scope.translateNamespace = _getTranslateNamespace(scope);
	
	          if (scope.translateNamespace && iAttrs.translateNamespace.charAt(0) === '.') {
	            scope.translateNamespace += iAttrs.translateNamespace;
	          } else {
	            scope.translateNamespace = iAttrs.translateNamespace;
	          }
	        }
	      };
	    }
	  };
	}
	
	/**
	 * Returns the scope's namespace.
	 * @private
	 * @param scope
	 * @returns {string}
	 */
	function _getTranslateNamespace(scope) {
	  'use strict';
	  if (scope.translateNamespace) {
	    return scope.translateNamespace;
	  }
	  if (scope.$parent) {
	    return _getTranslateNamespace(scope.$parent);
	  }
	}
	
	translateNamespaceDirective.displayName = 'translateNamespaceDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc directive
	 * @name pascalprecht.translate.directive:translateLanguage
	 * @restrict A
	 *
	 * @description
	 * Forces the language to the directives in the underlying scope.
	 *
	 * @param {string=} translate language that will be negotiated.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div>
	
	        <div>
	            <h1 translate>HELLO</h1>
	        </div>
	
	        <div translate-language="de">
	            <h1 translate>HELLO</h1>
	        </div>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider
	          .translations('en',{
	            'HELLO': 'Hello world!'
	          })
	          .translations('de',{
	            'HELLO': 'Hallo Welt!'
	          })
	          .preferredLanguage('en');
	
	      });
	
	    </file>
	   </example>
	 */
	.directive('translateLanguage', translateLanguageDirective);
	
	function translateLanguageDirective() {
	
	  'use strict';
	
	  return {
	    restrict: 'A',
	    scope: true,
	    compile: function () {
	      return function linkFn(scope, iElement, iAttrs) {
	
	        iAttrs.$observe('translateLanguage', function (newTranslateLanguage) {
	          scope.translateLanguage = newTranslateLanguage;
	        });
	
	        scope.$watch('translateLanguage', function(){
	          scope.$broadcast('translateLanguageChanged');
	        });
	      };
	    }
	  };
	}
	
	translateLanguageDirective.displayName = 'translateLanguageDirective';
	
	angular.module('pascalprecht.translate')
	/**
	 * @ngdoc filter
	 * @name pascalprecht.translate.filter:translate
	 * @requires $parse
	 * @requires pascalprecht.translate.$translate
	 * @function
	 *
	 * @description
	 * Uses `$translate` service to translate contents. Accepts interpolate parameters
	 * to pass dynamized values though translation.
	 *
	 * @param {string} translationId A translation id to be translated.
	 * @param {*=} interpolateParams Optional object literal (as hash or string) to pass values into translation.
	 *
	 * @returns {string} Translated text.
	 *
	 * @example
	   <example module="ngView">
	    <file name="index.html">
	      <div ng-controller="TranslateCtrl">
	
	        <pre>{{ 'TRANSLATION_ID' | translate }}</pre>
	        <pre>{{ translationId | translate }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:'{value: 5}' }}</pre>
	        <pre>{{ 'WITH_VALUES' | translate:values }}</pre>
	
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngView', ['pascalprecht.translate'])
	
	      .config(function ($translateProvider) {
	
	        $translateProvider.translations('en', {
	          'TRANSLATION_ID': 'Hello there!',
	          'WITH_VALUES': 'The following value is dynamic: {{value}}'
	        });
	        $translateProvider.preferredLanguage('en');
	
	      });
	
	      angular.module('ngView').controller('TranslateCtrl', function ($scope) {
	        $scope.translationId = 'TRANSLATION_ID';
	
	        $scope.values = {
	          value: 78
	        };
	      });
	    </file>
	   </example>
	 */
	.filter('translate', translateFilterFactory);
	
	function translateFilterFactory($parse, $translate) {
	
	  'use strict';
	
	  var translateFilter = function (translationId, interpolateParams, interpolation, forceLanguage) {
	    if (!angular.isObject(interpolateParams)) {
	      var ctx = this || {
	        '__SCOPE_IS_NOT_AVAILABLE': 'More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f'
	        };
	      interpolateParams = $parse(interpolateParams)(ctx);
	    }
	
	    return $translate.instant(translationId, interpolateParams, interpolation, forceLanguage);
	  };
	
	  if ($translate.statefulFilter()) {
	    translateFilter.$stateful = true;
	  }
	
	  return translateFilter;
	}
	
	translateFilterFactory.displayName = 'translateFilterFactory';
	
	angular.module('pascalprecht.translate')
	
	/**
	 * @ngdoc object
	 * @name pascalprecht.translate.$translationCache
	 * @requires $cacheFactory
	 *
	 * @description
	 * The first time a translation table is used, it is loaded in the translation cache for quick retrieval. You
	 * can load translation tables directly into the cache by consuming the
	 * `$translationCache` service directly.
	 *
	 * @return {object} $cacheFactory object.
	 */
	  .factory('$translationCache', $translationCache);
	
	function $translationCache($cacheFactory) {
	
	  'use strict';
	
	  return $cacheFactory('translations');
	}
	
	$translationCache.displayName = '$translationCache';
	return 'pascalprecht.translate';
	
	}));


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * angucomplete-alt
	 * Autocomplete directive for AngularJS
	 * This is a fork of Daryl Rowland's angucomplete with some extra features.
	 * By Hidenari Nozaki
	 */
	
	/*! Copyright (c) 2014 Hidenari Nozaki and contributors | Licensed under the MIT license */
	
	(function (root, factory) {
	  'use strict';
	  if (typeof module !== 'undefined' && module.exports) {
	    // CommonJS
	    module.exports = factory(__webpack_require__(369));
	  } else if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(369)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    // Global Variables
	    factory(root.angular);
	  }
	}(window, function (angular) {
	  'use strict';
	
	  angular.module('angucomplete-alt', []).directive('angucompleteAlt', ['$q', '$parse', '$http', '$sce', '$timeout', '$templateCache', '$interpolate', function ($q, $parse, $http, $sce, $timeout, $templateCache, $interpolate) {
	    // keyboard events
	    var KEY_DW  = 40;
	    var KEY_RT  = 39;
	    var KEY_UP  = 38;
	    var KEY_LF  = 37;
	    var KEY_ES  = 27;
	    var KEY_EN  = 13;
	    var KEY_TAB =  9;
	
	    var MIN_LENGTH = 3;
	    var MAX_LENGTH = 524288;  // the default max length per the html maxlength attribute
	    var PAUSE = 500;
	    var BLUR_TIMEOUT = 200;
	
	    // string constants
	    var REQUIRED_CLASS = 'autocomplete-required';
	    var TEXT_SEARCHING = 'Searching...';
	    var TEXT_NORESULTS = 'No results found';
	    var TEMPLATE_URL = '/angucomplete-alt/index.html';
	
	    // Set the default template for this directive
	    $templateCache.put(TEMPLATE_URL,
	        '<div class="angucomplete-holder" ng-class="{\'angucomplete-dropdown-visible\': showDropdown}">' +
	        '  <input id="{{id}}_value" name="{{inputName}}" tabindex="{{fieldTabindex}}" ng-class="{\'angucomplete-input-not-empty\': notEmpty}" ng-model="searchStr" ng-disabled="disableInput" type="{{inputType}}" placeholder="{{placeholder}}" maxlength="{{maxlength}}" ng-focus="onFocusHandler()" class="{{inputClass}}" ng-focus="resetHideResults()" ng-blur="hideResults($event)" autocapitalize="off" autocorrect="off" autocomplete="off" ng-change="inputChangeHandler(searchStr)"/>' +
	        '  <div id="{{id}}_dropdown" class="angucomplete-dropdown" ng-show="showDropdown">' +
	        '    <div class="angucomplete-searching" ng-show="searching" ng-bind="textSearching"></div>' +
	        '    <div class="angucomplete-searching" ng-show="!searching && (!results || results.length == 0)" ng-bind="textNoResults"></div>' +
	        '    <div class="angucomplete-row" ng-repeat="result in results" ng-click="selectResult(result)" ng-mouseenter="hoverRow($index)" ng-class="{\'angucomplete-selected-row\': $index == currentIndex}">' +
	        '      <div ng-if="imageField" class="angucomplete-image-holder">' +
	        '        <img ng-if="result.image && result.image != \'\'" ng-src="{{result.image}}" class="angucomplete-image"/>' +
	        '        <div ng-if="!result.image && result.image != \'\'" class="angucomplete-image-default"></div>' +
	        '      </div>' +
	        '      <div class="angucomplete-title" ng-if="matchClass" ng-bind-html="result.title"></div>' +
	        '      <div class="angucomplete-title" ng-if="!matchClass">{{ result.title }}</div>' +
	        '      <div ng-if="matchClass && result.description && result.description != \'\'" class="angucomplete-description" ng-bind-html="result.description"></div>' +
	        '      <div ng-if="!matchClass && result.description && result.description != \'\'" class="angucomplete-description">{{result.description}}</div>' +
	        '    </div>' +
	        '  </div>' +
	        '</div>'
	    );
	
	    function link(scope, elem, attrs, ctrl) {
	      var inputField = elem.find('input');
	      var minlength = MIN_LENGTH;
	      var searchTimer = null;
	      var hideTimer;
	      var requiredClassName = REQUIRED_CLASS;
	      var responseFormatter;
	      var validState = null;
	      var httpCanceller = null;
	      var httpCallInProgress = false;
	      var dd = elem[0].querySelector('.angucomplete-dropdown');
	      var isScrollOn = false;
	      var mousedownOn = null;
	      var unbindInitialValue;
	      var displaySearching;
	      var displayNoResults;
	
	      elem.on('mousedown', function(event) {
	        if (event.target.id) {
	          mousedownOn = event.target.id;
	          if (mousedownOn === scope.id + '_dropdown') {
	            document.body.addEventListener('click', clickoutHandlerForDropdown);
	          }
	        }
	        else {
	          mousedownOn = event.target.className;
	        }
	      });
	
	      scope.currentIndex = scope.focusFirst ? 0 : null;
	      scope.searching = false;
	      unbindInitialValue = scope.$watch('initialValue', function(newval) {
	        if (newval) {
	          // remove scope listener
	          unbindInitialValue();
	          // change input
	          handleInputChange(newval, true);
	        }
	      });
	
	      scope.$watch('fieldRequired', function(newval, oldval) {
	        if (newval !== oldval) {
	          if (!newval) {
	            ctrl[scope.inputName].$setValidity(requiredClassName, true);
	          }
	          else if (!validState || scope.currentIndex === -1) {
	            handleRequired(false);
	          }
	          else {
	            handleRequired(true);
	          }
	        }
	      });
	
	      scope.$on('angucomplete-alt:clearInput', function (event, elementId) {
	        if (!elementId || elementId === scope.id) {
	          scope.searchStr = null;
	          callOrAssign();
	          handleRequired(false);
	          clearResults();
	        }
	      });
	
	      scope.$on('angucomplete-alt:changeInput', function (event, elementId, newval) {
	        if (!!elementId && elementId === scope.id) {
	          handleInputChange(newval);
	        }
	      });
	
	      function handleInputChange(newval, initial) {
	        if (newval) {
	          if (typeof newval === 'object') {
	            scope.searchStr = extractTitle(newval);
	            callOrAssign({originalObject: newval});
	          } else if (typeof newval === 'string' && newval.length > 0) {
	            scope.searchStr = newval;
	          } else {
	            if (console && console.error) {
	              console.error('Tried to set ' + (!!initial ? 'initial' : '') + ' value of angucomplete to', newval, 'which is an invalid value');
	            }
	          }
	
	          handleRequired(true);
	        }
	      }
	
	      // #194 dropdown list not consistent in collapsing (bug).
	      function clickoutHandlerForDropdown(event) {
	        mousedownOn = null;
	        scope.hideResults(event);
	        document.body.removeEventListener('click', clickoutHandlerForDropdown);
	      }
	
	      // for IE8 quirkiness about event.which
	      function ie8EventNormalizer(event) {
	        return event.which ? event.which : event.keyCode;
	      }
	
	      function callOrAssign(value) {
	        if (typeof scope.selectedObject === 'function') {
	          scope.selectedObject(value, scope.selectedObjectData);
	        }
	        else {
	          scope.selectedObject = value;
	        }
	
	        if (value) {
	          handleRequired(true);
	        }
	        else {
	          handleRequired(false);
	        }
	      }
	
	      function callFunctionOrIdentity(fn) {
	        return function(data) {
	          return scope[fn] ? scope[fn](data) : data;
	        };
	      }
	
	      function setInputString(str) {
	        callOrAssign({originalObject: str});
	
	        if (scope.clearSelected) {
	          scope.searchStr = null;
	        }
	        clearResults();
	      }
	
	      function extractTitle(data) {
	        // split title fields and run extractValue for each and join with ' '
	        return scope.titleField.split(',')
	          .map(function(field) {
	            return extractValue(data, field);
	          })
	          .join(' ');
	      }
	
	      function extractValue(obj, key) {
	        var keys, result;
	        if (key) {
	          keys= key.split('.');
	          result = obj;
	          for (var i = 0; i < keys.length; i++) {
	            result = result[keys[i]];
	          }
	        }
	        else {
	          result = obj;
	        }
	        return result;
	      }
	
	      function findMatchString(target, str) {
	        var result, matches, re;
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	        // Escape user input to be treated as a literal string within a regular expression
	        re = new RegExp(str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
	        if (!target) { return; }
	        if (!target.match || !target.replace) { target = target.toString(); }
	        matches = target.match(re);
	        if (matches) {
	          result = target.replace(re,
	              '<span class="'+ scope.matchClass +'">'+ matches[0] +'</span>');
	        }
	        else {
	          result = target;
	        }
	        return $sce.trustAsHtml(result);
	      }
	
	      function handleRequired(valid) {
	        scope.notEmpty = valid;
	        validState = scope.searchStr;
	        if (scope.fieldRequired && ctrl && scope.inputName) {
	          ctrl[scope.inputName].$setValidity(requiredClassName, valid);
	        }
	      }
	
	      function keyupHandler(event) {
	        var which = ie8EventNormalizer(event);
	        if (which === KEY_LF || which === KEY_RT) {
	          // do nothing
	          return;
	        }
	
	        if (which === KEY_UP || which === KEY_EN) {
	          event.preventDefault();
	        }
	        else if (which === KEY_DW) {
	          event.preventDefault();
	          if (!scope.showDropdown && scope.searchStr && scope.searchStr.length >= minlength) {
	            initResults();
	            scope.searching = true;
	            searchTimerComplete(scope.searchStr);
	          }
	        }
	        else if (which === KEY_ES) {
	          clearResults();
	          scope.$apply(function() {
	            inputField.val(scope.searchStr);
	          });
	        }
	        else {
	          if (minlength === 0 && !scope.searchStr) {
	            return;
	          }
	
	          if (!scope.searchStr || scope.searchStr === '') {
	            scope.showDropdown = false;
	          } else if (scope.searchStr.length >= minlength) {
	            initResults();
	
	            if (searchTimer) {
	              $timeout.cancel(searchTimer);
	            }
	
	            scope.searching = true;
	
	            searchTimer = $timeout(function() {
	              searchTimerComplete(scope.searchStr);
	            }, scope.pause);
	          }
	
	          if (validState && validState !== scope.searchStr && !scope.clearSelected) {
	            scope.$apply(function() {
	              callOrAssign();
	            });
	          }
	        }
	      }
	
	      function handleOverrideSuggestions(event) {
	        if (scope.overrideSuggestions &&
	            !(scope.selectedObject && scope.selectedObject.originalObject === scope.searchStr)) {
	          if (event) {
	            event.preventDefault();
	          }
	
	          // cancel search timer
	          $timeout.cancel(searchTimer);
	          // cancel http request
	          cancelHttpRequest();
	
	          setInputString(scope.searchStr);
	        }
	      }
	
	      function dropdownRowOffsetHeight(row) {
	        var css = getComputedStyle(row);
	        return row.offsetHeight +
	          parseInt(css.marginTop, 10) + parseInt(css.marginBottom, 10);
	      }
	
	      function dropdownHeight() {
	        return dd.getBoundingClientRect().top +
	          parseInt(getComputedStyle(dd).maxHeight, 10);
	      }
	
	      function dropdownRow() {
	        return elem[0].querySelectorAll('.angucomplete-row')[scope.currentIndex];
	      }
	
	      function dropdownRowTop() {
	        return dropdownRow().getBoundingClientRect().top -
	          (dd.getBoundingClientRect().top +
	           parseInt(getComputedStyle(dd).paddingTop, 10));
	      }
	
	      function dropdownScrollTopTo(offset) {
	        dd.scrollTop = dd.scrollTop + offset;
	      }
	
	      function updateInputField(){
	        var current = scope.results[scope.currentIndex];
	        if (scope.matchClass) {
	          inputField.val(extractTitle(current.originalObject));
	        }
	        else {
	          inputField.val(current.title);
	        }
	      }
	
	      function keydownHandler(event) {
	        var which = ie8EventNormalizer(event);
	        var row = null;
	        var rowTop = null;
	
	        if (which === KEY_EN && scope.results) {
	          if (scope.currentIndex >= 0 && scope.currentIndex < scope.results.length) {
	            event.preventDefault();
	            scope.selectResult(scope.results[scope.currentIndex]);
	          } else {
	            handleOverrideSuggestions(event);
	            clearResults();
	          }
	          scope.$apply();
	        } else if (which === KEY_DW && scope.results) {
	          event.preventDefault();
	          if ((scope.currentIndex + 1) < scope.results.length && scope.showDropdown) {
	            scope.$apply(function() {
	              scope.currentIndex ++;
	              updateInputField();
	            });
	
	            if (isScrollOn) {
	              row = dropdownRow();
	              if (dropdownHeight() < row.getBoundingClientRect().bottom) {
	                dropdownScrollTopTo(dropdownRowOffsetHeight(row));
	              }
	            }
	          }
	        } else if (which === KEY_UP && scope.results) {
	          event.preventDefault();
	          if (scope.currentIndex >= 1) {
	            scope.$apply(function() {
	              scope.currentIndex --;
	              updateInputField();
	            });
	
	            if (isScrollOn) {
	              rowTop = dropdownRowTop();
	              if (rowTop < 0) {
	                dropdownScrollTopTo(rowTop - 1);
	              }
	            }
	          }
	          else if (scope.currentIndex === 0) {
	            scope.$apply(function() {
	              scope.currentIndex = -1;
	              inputField.val(scope.searchStr);
	            });
	          }
	        } else if (which === KEY_TAB) {
	          if (scope.results && scope.results.length > 0 && scope.showDropdown) {
	            if (scope.currentIndex === -1 && scope.overrideSuggestions) {
	              // intentionally not sending event so that it does not
	              // prevent default tab behavior
	              handleOverrideSuggestions();
	            }
	            else {
	              if (scope.currentIndex === -1) {
	                scope.currentIndex = 0;
	              }
	              scope.selectResult(scope.results[scope.currentIndex]);
	              scope.$digest();
	            }
	          }
	          else {
	            // no results
	            // intentionally not sending event so that it does not
	            // prevent default tab behavior
	            if (scope.searchStr && scope.searchStr.length > 0) {
	              handleOverrideSuggestions();
	            }
	          }
	        } else if (which === KEY_ES) {
	          // This is very specific to IE10/11 #272
	          // without this, IE clears the input text
	          event.preventDefault();
	        }
	      }
	
	      function httpSuccessCallbackGen(str) {
	        return function(responseData, status, headers, config) {
	          // normalize return obejct from promise
	          if (!status && !headers && !config && responseData.data) {
	            responseData = responseData.data;
	          }
	          scope.searching = false;
	          processResults(
	            extractValue(responseFormatter(responseData), scope.remoteUrlDataField),
	            str);
	        };
	      }
	
	      function httpErrorCallback(errorRes, status, headers, config) {
	        scope.searching = httpCallInProgress;
	
	        // normalize return obejct from promise
	        if (!status && !headers && !config) {
	          status = errorRes.status;
	        }
	
	        // cancelled/aborted
	        if (status === 0 || status === -1) { return; }
	        if (scope.remoteUrlErrorCallback) {
	          scope.remoteUrlErrorCallback(errorRes, status, headers, config);
	        }
	        else {
	          if (console && console.error) {
	            console.error('http error');
	          }
	        }
	      }
	
	      function cancelHttpRequest() {
	        if (httpCanceller) {
	          httpCanceller.resolve();
	        }
	      }
	
	      function getRemoteResults(str) {
	        var params = {},
	            url = scope.remoteUrl + encodeURIComponent(str);
	        if (scope.remoteUrlRequestFormatter) {
	          params = {params: scope.remoteUrlRequestFormatter(str)};
	          url = scope.remoteUrl;
	        }
	        if (!!scope.remoteUrlRequestWithCredentials) {
	          params.withCredentials = true;
	        }
	        cancelHttpRequest();
	        httpCanceller = $q.defer();
	        params.timeout = httpCanceller.promise;
	        httpCallInProgress = true;
	        $http.get(url, params)
	          .then(httpSuccessCallbackGen(str))
	          .catch(httpErrorCallback)
	          .finally(function(){httpCallInProgress=false;});
	      }
	
	      function getRemoteResultsWithCustomHandler(str) {
	        cancelHttpRequest();
	
	        httpCanceller = $q.defer();
	
	        scope.remoteApiHandler(str, httpCanceller.promise)
	          .then(httpSuccessCallbackGen(str))
	          .catch(httpErrorCallback);
	
	        /* IE8 compatible
	        scope.remoteApiHandler(str, httpCanceller.promise)
	          ['then'](httpSuccessCallbackGen(str))
	          ['catch'](httpErrorCallback);
	        */
	      }
	
	      function clearResults() {
	        scope.showDropdown = false;
	        scope.results = [];
	        if (dd) {
	          dd.scrollTop = 0;
	        }
	      }
	
	      function initResults() {
	        scope.showDropdown = displaySearching;
	        scope.currentIndex = scope.focusFirst ? 0 : -1;
	        scope.results = [];
	      }
	
	      function getLocalResults(str) {
	        var i, match, s, value,
	            searchFields = scope.searchFields.split(','),
	            matches = [];
	        if (typeof scope.parseInput() !== 'undefined') {
	          str = scope.parseInput()(str);
	        }
	        for (i = 0; i < scope.localData.length; i++) {
	          match = false;
	
	          for (s = 0; s < searchFields.length; s++) {
	            value = extractValue(scope.localData[i], searchFields[s]) || '';
	            match = match || (value.toString().toLowerCase().indexOf(str.toString().toLowerCase()) >= 0);
	          }
	
	          if (match) {
	            matches[matches.length] = scope.localData[i];
	          }
	        }
	        return matches;
	      }
	
	      function checkExactMatch(result, obj, str){
	        if (!str) { return false; }
	        for(var key in obj){
	          if(obj[key].toLowerCase() === str.toLowerCase()){
	            scope.selectResult(result);
	            return true;
	          }
	        }
	        return false;
	      }
	
	      function searchTimerComplete(str) {
	        // Begin the search
	        if (!str || str.length < minlength) {
	          return;
	        }
	        if (scope.localData) {
	          scope.$apply(function() {
	            var matches;
	            if (typeof scope.localSearch() !== 'undefined') {
	              matches = scope.localSearch()(str, scope.localData);
	            } else {
	              matches = getLocalResults(str);
	            }
	            scope.searching = false;
	            processResults(matches, str);
	          });
	        }
	        else if (scope.remoteApiHandler) {
	          getRemoteResultsWithCustomHandler(str);
	        } else {
	          getRemoteResults(str);
	        }
	      }
	
	      function processResults(responseData, str) {
	        var i, description, image, text, formattedText, formattedDesc;
	
	        if (responseData && responseData.length > 0) {
	          scope.results = [];
	
	          for (i = 0; i < responseData.length; i++) {
	            if (scope.titleField && scope.titleField !== '') {
	              text = formattedText = extractTitle(responseData[i]);
	            }
	
	            description = '';
	            if (scope.descriptionField) {
	              description = formattedDesc = extractValue(responseData[i], scope.descriptionField);
	            }
	
	            image = '';
	            if (scope.imageField) {
	              image = extractValue(responseData[i], scope.imageField);
	            }
	
	            if (scope.matchClass) {
	              formattedText = findMatchString(text, str);
	              formattedDesc = findMatchString(description, str);
	            }
	
	            scope.results[scope.results.length] = {
	              title: formattedText,
	              description: formattedDesc,
	              image: image,
	              originalObject: responseData[i]
	            };
	          }
	
	        } else {
	          scope.results = [];
	        }
	
	        if (scope.autoMatch && scope.results.length === 1 &&
	            checkExactMatch(scope.results[0],
	              {title: text, desc: description || ''}, scope.searchStr)) {
	          scope.showDropdown = false;
	        } else if (scope.results.length === 0 && !displayNoResults) {
	          scope.showDropdown = false;
	        } else {
	          scope.showDropdown = true;
	        }
	      }
	
	      function showAll() {
	        if (scope.localData) {
	          scope.searching = false;
	          processResults(scope.localData, '');
	        }
	        else if (scope.remoteApiHandler) {
	          scope.searching = true;
	          getRemoteResultsWithCustomHandler('');
	        }
	        else {
	          scope.searching = true;
	          getRemoteResults('');
	        }
	      }
	
	      scope.onFocusHandler = function() {
	        if (scope.focusIn) {
	          scope.focusIn();
	        }
	        if (minlength === 0 && (!scope.searchStr || scope.searchStr.length === 0)) {
	          scope.currentIndex = scope.focusFirst ? 0 : scope.currentIndex;
	          scope.showDropdown = true;
	          showAll();
	        }
	      };
	
	      scope.hideResults = function() {
	        if (mousedownOn &&
	            (mousedownOn === scope.id + '_dropdown' ||
	             mousedownOn.indexOf('angucomplete') >= 0)) {
	          mousedownOn = null;
	        }
	        else {
	          hideTimer = $timeout(function() {
	            clearResults();
	            scope.$apply(function() {
	              if (scope.searchStr && scope.searchStr.length > 0) {
	                inputField.val(scope.searchStr);
	              }
	            });
	          }, BLUR_TIMEOUT);
	          cancelHttpRequest();
	
	          if (scope.focusOut) {
	            scope.focusOut();
	          }
	
	          if (scope.overrideSuggestions) {
	            if (scope.searchStr && scope.searchStr.length > 0 && scope.currentIndex === -1) {
	              handleOverrideSuggestions();
	            }
	          }
	        }
	      };
	
	      scope.resetHideResults = function() {
	        if (hideTimer) {
	          $timeout.cancel(hideTimer);
	        }
	      };
	
	      scope.hoverRow = function(index) {
	        scope.currentIndex = index;
	      };
	
	      scope.selectResult = function(result) {
	        // Restore original values
	        if (scope.matchClass) {
	          result.title = extractTitle(result.originalObject);
	          result.description = extractValue(result.originalObject, scope.descriptionField);
	        }
	
	        if (scope.clearSelected) {
	          scope.searchStr = null;
	        }
	        else {
	          scope.searchStr = result.title;
	        }
	        callOrAssign(result);
	        clearResults();
	      };
	
	      scope.inputChangeHandler = function(str) {
	        if (str.length < minlength) {
	          cancelHttpRequest();
	          clearResults();
	        }
	        else if (str.length === 0 && minlength === 0) {
	          showAll();
	        }
	
	        if (scope.inputChanged) {
	          str = scope.inputChanged(str);
	        }
	        return str;
	      };
	
	      // check required
	      if (scope.fieldRequiredClass && scope.fieldRequiredClass !== '') {
	        requiredClassName = scope.fieldRequiredClass;
	      }
	
	      // check min length
	      if (scope.minlength && scope.minlength !== '') {
	        minlength = parseInt(scope.minlength, 10);
	      }
	
	      // check pause time
	      if (!scope.pause) {
	        scope.pause = PAUSE;
	      }
	
	      // check clearSelected
	      if (!scope.clearSelected) {
	        scope.clearSelected = false;
	      }
	
	      // check override suggestions
	      if (!scope.overrideSuggestions) {
	        scope.overrideSuggestions = false;
	      }
	
	      // check required field
	      if (scope.fieldRequired && ctrl) {
	        // check initial value, if given, set validitity to true
	        if (scope.initialValue) {
	          handleRequired(true);
	        }
	        else {
	          handleRequired(false);
	        }
	      }
	
	      scope.inputType = attrs.type ? attrs.type : 'text';
	
	      // set strings for "Searching..." and "No results"
	      scope.textSearching = attrs.textSearching ? attrs.textSearching : TEXT_SEARCHING;
	      scope.textNoResults = attrs.textNoResults ? attrs.textNoResults : TEXT_NORESULTS;
	      displaySearching = scope.textSearching === 'false' ? false : true;
	      displayNoResults = scope.textNoResults === 'false' ? false : true;
	
	      // set max length (default to maxlength deault from html
	      scope.maxlength = attrs.maxlength ? attrs.maxlength : MAX_LENGTH;
	
	      // register events
	      inputField.on('keydown', keydownHandler);
	      inputField.on('keyup compositionend', keyupHandler);
	
	      // set response formatter
	      responseFormatter = callFunctionOrIdentity('remoteUrlResponseFormatter');
	
	      // set isScrollOn
	      $timeout(function() {
	        var css = getComputedStyle(dd);
	        isScrollOn = css.maxHeight && css.overflowY === 'auto';
	      });
	    }
	
	    return {
	      restrict: 'EA',
	      require: '^?form',
	      scope: {
	        selectedObject: '=',
	        selectedObjectData: '=',
	        disableInput: '=',
	        initialValue: '=',
	        localData: '=',
	        localSearch: '&',
	        remoteUrlRequestFormatter: '=',
	        remoteUrlRequestWithCredentials: '@',
	        remoteUrlResponseFormatter: '=',
	        remoteUrlErrorCallback: '=',
	        remoteApiHandler: '=',
	        id: '@',
	        type: '@',
	        placeholder: '@',
	        textSearching: '@',
	        textNoResults: '@',
	        remoteUrl: '@',
	        remoteUrlDataField: '@',
	        titleField: '@',
	        descriptionField: '@',
	        imageField: '@',
	        inputClass: '@',
	        pause: '@',
	        searchFields: '@',
	        minlength: '@',
	        matchClass: '@',
	        clearSelected: '@',
	        overrideSuggestions: '@',
	        fieldRequired: '=',
	        fieldRequiredClass: '@',
	        inputChanged: '=',
	        autoMatch: '@',
	        focusOut: '&',
	        focusIn: '&',
	        fieldTabindex: '@',
	        inputName: '@',
	        focusFirst: '@',
	        parseInput: '&'
	      },
	      templateUrl: function(element, attrs) {
	        return attrs.templateUrl || TEMPLATE_URL;
	      },
	      compile: function(tElement) {
	        var startSym = $interpolate.startSymbol();
	        var endSym = $interpolate.endSymbol();
	        if (!(startSym === '{{' && endSym === '}}')) {
	          var interpolatedHtml = tElement.html()
	            .replace(/\{\{/g, startSym)
	            .replace(/\}\}/g, endSym);
	          tElement.html(interpolatedHtml);
	        }
	        return link;
	      }
	    };
	  }]);
	
	}));


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1584);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(458)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!./angucomplete-alt.css", function() {
				var newContent = require("!!../css-loader/index.js!./angucomplete-alt.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(452)();
	// imports
	
	
	// module
	exports.push([module.id, ".angucomplete-holder{position:relative}.angucomplete-dropdown{border:1px solid #ececec;border-radius:2px;width:250px;padding:6px;cursor:pointer;z-index:9999;position:absolute;margin-top:-6px;background-color:#fff}.angucomplete-searching{color:#acacac;font-size:14px}.angucomplete-description{font-size:14px}.angucomplete-row{padding:5px;color:#000;margin-bottom:4px;clear:both}.angucomplete-selected-row{background-color:#add8e6;color:#fff}.angucomplete-image-holder{padding-top:2px;float:left;margin-right:10px;margin-left:5px}.angucomplete-image{height:34px;width:34px;border-radius:50%;border:1px solid #ececec}.angucomplete-image-default{background-position:50%;background-size:contain;height:34px;width:34px}", ""]);
	
	// exports


/***/ }),
/* 1585 */
/***/ (function(module, exports) {

	!function(a){"use strict";var b=a.module("ngLoadingOverlay",[]);b.provider("$loadingOverlayConfig",function(){var a={bg:"rgba(0, 0, 0, 0.5)",textColor:"#fff",template:"<b>Please wait</b>",zIndex:9999};this.defaultConfig=function(b,c,d,e){a.bg=c||a.bg,a.template=b||a.template,a.textColor=d||a.textColor,a.zIndex=e||a.zIndex},this.$get=function(){return{get:function(){return a}}}}),b.service("$loadingOverlay",["$compile","$rootScope","$sce","$loadingOverlayConfig",function(b,c,d,e){var f='<div id="ng-loading-overlay" ng-show="show" style="display: -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex; align-items: center; justify-content: center; position:absolute; left:0; height: 100%; width: 100%;" ng-style="{\'background\': bg, \'color\': textColor, \'top\': positionTop, \'z-index\': zIndex}"><div style="position:relative;opacity: 1;" ng-bind-html="template"></div></div>',g=0,h=e.get(),i=a.element(f),j=c.$new();j.show=!1,a.element(document).ready(function(){i=b(i)(j),a.element(document.body).append(i)}),this.show=function(b,c,e,f){var i=a.element(document.body);g+=1,b?j.template=d.trustAsHtml(b):j.template=d.trustAsHtml(h.template),c?j.bg=c:j.bg=h.bg,e?j.textColor=e:j.textColor=h.textColor,j.zIndex=f||h.zIndex,j.positionTop=window.pageYOffset,console.log(j.positionTop),i.css("overflow","hidden"),j.show=!0},this.hide=function(){g&&(g-=1),g||(a.element(document.body).css("overflow","auto"),j.show=!1)}}])}(window.angular);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vendor.bundle.js